/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 168);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(29);


/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core__ = __webpack_require__(17);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_0__core__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "G", function() { return __WEBPACK_IMPORTED_MODULE_0__core__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return __WEBPACK_IMPORTED_MODULE_0__core__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__layout__ = __webpack_require__(344);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__layout__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__typo__ = __webpack_require__(46);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_2__typo__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_2__typo__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_2__typo__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "V", function() { return __WEBPACK_IMPORTED_MODULE_2__typo__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return __WEBPACK_IMPORTED_MODULE_2__typo__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return __WEBPACK_IMPORTED_MODULE_2__typo__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return __WEBPACK_IMPORTED_MODULE_2__typo__["g"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return __WEBPACK_IMPORTED_MODULE_2__typo__["h"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_22", function() { return __WEBPACK_IMPORTED_MODULE_2__typo__["i"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_27", function() { return __WEBPACK_IMPORTED_MODULE_2__typo__["j"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_37", function() { return __WEBPACK_IMPORTED_MODULE_2__typo__["k"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_43", function() { return __WEBPACK_IMPORTED_MODULE_2__typo__["l"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_44", function() { return __WEBPACK_IMPORTED_MODULE_2__typo__["m"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_45", function() { return __WEBPACK_IMPORTED_MODULE_2__typo__["n"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_47", function() { return __WEBPACK_IMPORTED_MODULE_2__typo__["o"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_49", function() { return __WEBPACK_IMPORTED_MODULE_2__typo__["p"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_55", function() { return __WEBPACK_IMPORTED_MODULE_2__typo__["q"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_56", function() { return __WEBPACK_IMPORTED_MODULE_2__typo__["r"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_74", function() { return __WEBPACK_IMPORTED_MODULE_2__typo__["s"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__app__ = __webpack_require__(345);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_75", function() { return __WEBPACK_IMPORTED_MODULE_3__app__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_76", function() { return __WEBPACK_IMPORTED_MODULE_3__app__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_77", function() { return __WEBPACK_IMPORTED_MODULE_3__app__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_78", function() { return __WEBPACK_IMPORTED_MODULE_3__app__["d"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__form__ = __webpack_require__(381);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "R", function() { return __WEBPACK_IMPORTED_MODULE_4__form__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__partials__ = __webpack_require__(382);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_5__partials__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_5__partials__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "H", function() { return __WEBPACK_IMPORTED_MODULE_5__partials__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "W", function() { return __WEBPACK_IMPORTED_MODULE_5__partials__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return __WEBPACK_IMPORTED_MODULE_5__partials__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return __WEBPACK_IMPORTED_MODULE_5__partials__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return __WEBPACK_IMPORTED_MODULE_5__partials__["g"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return __WEBPACK_IMPORTED_MODULE_5__partials__["h"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_18", function() { return __WEBPACK_IMPORTED_MODULE_5__partials__["i"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_39", function() { return __WEBPACK_IMPORTED_MODULE_5__partials__["j"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_57", function() { return __WEBPACK_IMPORTED_MODULE_5__partials__["k"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_58", function() { return __WEBPACK_IMPORTED_MODULE_5__partials__["l"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__auth__ = __webpack_require__(388);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_6__auth__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return __WEBPACK_IMPORTED_MODULE_6__auth__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components__ = __webpack_require__(158);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_7__components__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_7__components__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_7__components__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_7__components__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_7__components__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_7__components__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_7__components__["g"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_7__components__["h"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_7__components__["i"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_7__components__["j"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_7__components__["k"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_7__components__["l"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_7__components__["m"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_7__components__["n"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "E", function() { return __WEBPACK_IMPORTED_MODULE_7__components__["o"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "I", function() { return __WEBPACK_IMPORTED_MODULE_7__components__["p"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "L", function() { return __WEBPACK_IMPORTED_MODULE_7__components__["q"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "M", function() { return __WEBPACK_IMPORTED_MODULE_7__components__["r"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "N", function() { return __WEBPACK_IMPORTED_MODULE_7__components__["s"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "O", function() { return __WEBPACK_IMPORTED_MODULE_7__components__["t"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "P", function() { return __WEBPACK_IMPORTED_MODULE_7__components__["u"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "S", function() { return __WEBPACK_IMPORTED_MODULE_7__components__["v"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "T", function() { return __WEBPACK_IMPORTED_MODULE_7__components__["w"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return __WEBPACK_IMPORTED_MODULE_7__components__["x"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return __WEBPACK_IMPORTED_MODULE_7__components__["y"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return __WEBPACK_IMPORTED_MODULE_7__components__["z"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return __WEBPACK_IMPORTED_MODULE_7__components__["A"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return __WEBPACK_IMPORTED_MODULE_7__components__["B"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_14", function() { return __WEBPACK_IMPORTED_MODULE_7__components__["C"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_16", function() { return __WEBPACK_IMPORTED_MODULE_7__components__["D"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_17", function() { return __WEBPACK_IMPORTED_MODULE_7__components__["E"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_20", function() { return __WEBPACK_IMPORTED_MODULE_7__components__["F"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_23", function() { return __WEBPACK_IMPORTED_MODULE_7__components__["G"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_24", function() { return __WEBPACK_IMPORTED_MODULE_7__components__["H"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_25", function() { return __WEBPACK_IMPORTED_MODULE_7__components__["I"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_26", function() { return __WEBPACK_IMPORTED_MODULE_7__components__["J"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_28", function() { return __WEBPACK_IMPORTED_MODULE_7__components__["K"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_31", function() { return __WEBPACK_IMPORTED_MODULE_7__components__["L"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_34", function() { return __WEBPACK_IMPORTED_MODULE_7__components__["M"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_36", function() { return __WEBPACK_IMPORTED_MODULE_7__components__["N"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_40", function() { return __WEBPACK_IMPORTED_MODULE_7__components__["O"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_41", function() { return __WEBPACK_IMPORTED_MODULE_7__components__["P"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_46", function() { return __WEBPACK_IMPORTED_MODULE_7__components__["Q"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_48", function() { return __WEBPACK_IMPORTED_MODULE_7__components__["R"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_50", function() { return __WEBPACK_IMPORTED_MODULE_7__components__["S"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_52", function() { return __WEBPACK_IMPORTED_MODULE_7__components__["T"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_59", function() { return __WEBPACK_IMPORTED_MODULE_7__components__["U"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_62", function() { return __WEBPACK_IMPORTED_MODULE_7__components__["V"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_63", function() { return __WEBPACK_IMPORTED_MODULE_7__components__["W"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_67", function() { return __WEBPACK_IMPORTED_MODULE_7__components__["X"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_70", function() { return __WEBPACK_IMPORTED_MODULE_7__components__["Y"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_71", function() { return __WEBPACK_IMPORTED_MODULE_7__components__["Z"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_72", function() { return __WEBPACK_IMPORTED_MODULE_7__components__["_0"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_73", function() { return __WEBPACK_IMPORTED_MODULE_7__components__["_1"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_79", function() { return __WEBPACK_IMPORTED_MODULE_7__components__["_2"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__containers__ = __webpack_require__(392);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_8__containers__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_8__containers__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_8__containers__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_8__containers__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_8__containers__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "B", function() { return __WEBPACK_IMPORTED_MODULE_8__containers__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "C", function() { return __WEBPACK_IMPORTED_MODULE_8__containers__["g"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "D", function() { return __WEBPACK_IMPORTED_MODULE_8__containers__["h"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "F", function() { return __WEBPACK_IMPORTED_MODULE_8__containers__["i"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "J", function() { return __WEBPACK_IMPORTED_MODULE_8__containers__["j"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "K", function() { return __WEBPACK_IMPORTED_MODULE_8__containers__["k"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "U", function() { return __WEBPACK_IMPORTED_MODULE_8__containers__["l"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "X", function() { return __WEBPACK_IMPORTED_MODULE_8__containers__["m"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_12", function() { return __WEBPACK_IMPORTED_MODULE_8__containers__["n"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_13", function() { return __WEBPACK_IMPORTED_MODULE_8__containers__["o"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_15", function() { return __WEBPACK_IMPORTED_MODULE_8__containers__["p"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_19", function() { return __WEBPACK_IMPORTED_MODULE_8__containers__["q"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_21", function() { return __WEBPACK_IMPORTED_MODULE_8__containers__["r"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_29", function() { return __WEBPACK_IMPORTED_MODULE_8__containers__["s"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_30", function() { return __WEBPACK_IMPORTED_MODULE_8__containers__["t"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_32", function() { return __WEBPACK_IMPORTED_MODULE_8__containers__["u"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_33", function() { return __WEBPACK_IMPORTED_MODULE_8__containers__["v"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_35", function() { return __WEBPACK_IMPORTED_MODULE_8__containers__["w"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_38", function() { return __WEBPACK_IMPORTED_MODULE_8__containers__["x"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_42", function() { return __WEBPACK_IMPORTED_MODULE_8__containers__["y"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_51", function() { return __WEBPACK_IMPORTED_MODULE_8__containers__["z"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_53", function() { return __WEBPACK_IMPORTED_MODULE_8__containers__["A"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_54", function() { return __WEBPACK_IMPORTED_MODULE_8__containers__["B"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_60", function() { return __WEBPACK_IMPORTED_MODULE_8__containers__["C"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_61", function() { return __WEBPACK_IMPORTED_MODULE_8__containers__["D"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_64", function() { return __WEBPACK_IMPORTED_MODULE_8__containers__["E"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_65", function() { return __WEBPACK_IMPORTED_MODULE_8__containers__["F"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_66", function() { return __WEBPACK_IMPORTED_MODULE_8__containers__["G"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_68", function() { return __WEBPACK_IMPORTED_MODULE_8__containers__["H"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_69", function() { return __WEBPACK_IMPORTED_MODULE_8__containers__["I"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_80", function() { return __WEBPACK_IMPORTED_MODULE_8__containers__["J"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_81", function() { return __WEBPACK_IMPORTED_MODULE_8__containers__["K"]; });
// Config --


/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Video__ = __webpack_require__(414);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_21", function() { return __WEBPACK_IMPORTED_MODULE_0__Video__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Loader__ = __webpack_require__(415);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return __WEBPACK_IMPORTED_MODULE_1__Loader__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Button__ = __webpack_require__(444);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_2__Button__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Error__ = __webpack_require__(445);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_3__Error__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Success__ = __webpack_require__(446);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return __WEBPACK_IMPORTED_MODULE_4__Success__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ProgressBar__ = __webpack_require__(447);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return __WEBPACK_IMPORTED_MODULE_5__ProgressBar__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Account__ = __webpack_require__(448);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_6__Account__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Notifications__ = __webpack_require__(512);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return __WEBPACK_IMPORTED_MODULE_7__Notifications__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Bookmarks__ = __webpack_require__(513);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_8__Bookmarks__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__PushContent__ = __webpack_require__(514);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return __WEBPACK_IMPORTED_MODULE_9__PushContent__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Picture__ = __webpack_require__(515);
/* unused harmony reexport Picture */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__SearchBar__ = __webpack_require__(516);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return __WEBPACK_IMPORTED_MODULE_11__SearchBar__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__BookmarkButton__ = __webpack_require__(517);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_12__BookmarkButton__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__PDFButton__ = __webpack_require__(519);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return __WEBPACK_IMPORTED_MODULE_13__PDFButton__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Card__ = __webpack_require__(520);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_14__Card__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Featured__ = __webpack_require__(521);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_15__Featured__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ReturnButton__ = __webpack_require__(522);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return __WEBPACK_IMPORTED_MODULE_16__ReturnButton__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Slider__ = __webpack_require__(523);
/* unused harmony reexport Slider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Prodibi__ = __webpack_require__(524);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return __WEBPACK_IMPORTED_MODULE_18__Prodibi__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Videos___ = __webpack_require__(527);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_22", function() { return __WEBPACK_IMPORTED_MODULE_19__Videos___["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__Nav__ = __webpack_require__(528);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return __WEBPACK_IMPORTED_MODULE_20__Nav__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__Filter__ = __webpack_require__(529);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_21__Filter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__FilterDropdown__ = __webpack_require__(530);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_22__FilterDropdown__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__SelectDropdown__ = __webpack_require__(531);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return __WEBPACK_IMPORTED_MODULE_23__SelectDropdown__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__SelectCountries__ = __webpack_require__(532);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return __WEBPACK_IMPORTED_MODULE_24__SelectCountries__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__SelectPhone__ = __webpack_require__(533);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return __WEBPACK_IMPORTED_MODULE_25__SelectPhone__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__SlideshowMobile__ = __webpack_require__(536);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return __WEBPACK_IMPORTED_MODULE_26__SlideshowMobile__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__UserNav__ = __webpack_require__(537);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_19", function() { return __WEBPACK_IMPORTED_MODULE_27__UserNav__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__ProductList__ = __webpack_require__(538);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return __WEBPACK_IMPORTED_MODULE_28__ProductList__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__SearchList__ = __webpack_require__(539);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return __WEBPACK_IMPORTED_MODULE_29__SearchList__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__SimpleFilter__ = __webpack_require__(540);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return __WEBPACK_IMPORTED_MODULE_30__SimpleFilter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__TeamCard__ = __webpack_require__(541);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_12", function() { return __WEBPACK_IMPORTED_MODULE_31__TeamCard__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__Quantity__ = __webpack_require__(542);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return __WEBPACK_IMPORTED_MODULE_32__Quantity__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__DefaultPicture__ = __webpack_require__(543);
/* unused harmony reexport DefaultPicture */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__AlertCard__ = __webpack_require__(544);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_34__AlertCard__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__Event__ = __webpack_require__(545);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_35__Event__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__FlickitySlider__ = __webpack_require__(546);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_36__FlickitySlider__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__ArticleNav__ = __webpack_require__(547);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_37__ArticleNav__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__Pan__ = __webpack_require__(548);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return __WEBPACK_IMPORTED_MODULE_38__Pan__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__SimpleSlider__ = __webpack_require__(551);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return __WEBPACK_IMPORTED_MODULE_39__SimpleSlider__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__Gallery__ = __webpack_require__(552);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return __WEBPACK_IMPORTED_MODULE_40__Gallery__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__Poll__ = __webpack_require__(553);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return __WEBPACK_IMPORTED_MODULE_41__Poll__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__Shapes___ = __webpack_require__(47);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_42__Shapes___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_42__Shapes___["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_42__Shapes___["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_42__Shapes___["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_42__Shapes___["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_42__Shapes___["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_42__Shapes___["g"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_42__Shapes___["h"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_42__Shapes___["i"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "C", function() { return __WEBPACK_IMPORTED_MODULE_42__Shapes___["j"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "D", function() { return __WEBPACK_IMPORTED_MODULE_42__Shapes___["k"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "E", function() { return __WEBPACK_IMPORTED_MODULE_42__Shapes___["l"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "F", function() { return __WEBPACK_IMPORTED_MODULE_42__Shapes___["m"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "H", function() { return __WEBPACK_IMPORTED_MODULE_42__Shapes___["n"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "I", function() { return __WEBPACK_IMPORTED_MODULE_42__Shapes___["o"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "K", function() { return __WEBPACK_IMPORTED_MODULE_42__Shapes___["p"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "O", function() { return __WEBPACK_IMPORTED_MODULE_42__Shapes___["q"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return __WEBPACK_IMPORTED_MODULE_42__Shapes___["r"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return __WEBPACK_IMPORTED_MODULE_42__Shapes___["s"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return __WEBPACK_IMPORTED_MODULE_42__Shapes___["t"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return __WEBPACK_IMPORTED_MODULE_42__Shapes___["u"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_14", function() { return __WEBPACK_IMPORTED_MODULE_42__Shapes___["v"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_15", function() { return __WEBPACK_IMPORTED_MODULE_42__Shapes___["w"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_16", function() { return __WEBPACK_IMPORTED_MODULE_42__Shapes___["x"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_18", function() { return __WEBPACK_IMPORTED_MODULE_42__Shapes___["y"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_20", function() { return __WEBPACK_IMPORTED_MODULE_42__Shapes___["z"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_23", function() { return __WEBPACK_IMPORTED_MODULE_42__Shapes___["A"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__Form___ = __webpack_require__(554);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_43__Form___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_43__Form___["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_13", function() { return __WEBPACK_IMPORTED_MODULE_43__Form___["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_17", function() { return __WEBPACK_IMPORTED_MODULE_43__Form___["d"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__SliderTemplates___ = __webpack_require__(559);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__Challenge___ = __webpack_require__(567);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_45__Challenge___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_45__Challenge___["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_45__Challenge___["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "V", function() { return __WEBPACK_IMPORTED_MODULE_45__Challenge___["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "X", function() { return __WEBPACK_IMPORTED_MODULE_45__Challenge___["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return __WEBPACK_IMPORTED_MODULE_45__Challenge___["f"]; });


/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* unused harmony export flush */
/* unused harmony export hydrate */
/* unused harmony export cx */
/* unused harmony export merge */
/* unused harmony export getRegisteredStyles */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return injectGlobal; });
/* unused harmony export keyframes */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return css; });
/* unused harmony export sheet */
/* unused harmony export caches */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_emotion__ = __webpack_require__(346);


var context = typeof global !== 'undefined' ? global : {};

var _createEmotion = Object(__WEBPACK_IMPORTED_MODULE_0_create_emotion__["a" /* default */])(context),
    flush = _createEmotion.flush,
    hydrate = _createEmotion.hydrate,
    cx = _createEmotion.cx,
    merge = _createEmotion.merge,
    getRegisteredStyles = _createEmotion.getRegisteredStyles,
    injectGlobal = _createEmotion.injectGlobal,
    keyframes = _createEmotion.keyframes,
    css = _createEmotion.css,
    sheet = _createEmotion.sheet,
    caches = _createEmotion.caches;



/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(40)))

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__ = __webpack_require__(296);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HashRouter__ = __webpack_require__(301);
/* unused harmony reexport HashRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Link__ = __webpack_require__(140);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__Link__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MemoryRouter__ = __webpack_require__(302);
/* unused harmony reexport MemoryRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NavLink__ = __webpack_require__(303);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_4__NavLink__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Prompt__ = __webpack_require__(305);
/* unused harmony reexport Prompt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Redirect__ = __webpack_require__(306);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_6__Redirect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Route__ = __webpack_require__(142);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_7__Route__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Router__ = __webpack_require__(86);
/* unused harmony reexport Router */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__StaticRouter__ = __webpack_require__(307);
/* unused harmony reexport StaticRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Switch__ = __webpack_require__(308);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_10__Switch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__generatePath__ = __webpack_require__(309);
/* unused harmony reexport generatePath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__matchPath__ = __webpack_require__(310);
/* unused harmony reexport matchPath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__withRouter__ = __webpack_require__(311);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_13__withRouter__["a"]; });





























/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */


/**
 * WARNING: DO NOT manually require this module.
 * This is a replacement for `invariant(...)` used by the error code system
 * and will _only_ be required by the corresponding babel pass.
 * It always throws.
 */

function reactProdInvariant(code) {
  var argCount = arguments.length - 1;

  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;

  for (var argIdx = 0; argIdx < argCount; argIdx++) {
    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
  }

  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';

  var error = new Error(message);
  error.name = 'Invariant Violation';
  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame

  throw error;
}

module.exports = reactProdInvariant;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyFunction = __webpack_require__(19);

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = emptyFunction;

if (false) {
  var printWarning = function printWarning(format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.indexOf('Failed Composite propType: ') === 0) {
      return; // Ignore CompositeComponent proptype check.
    }

    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = warning;

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Provider__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__connect_connect__ = __webpack_require__(275);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["a"]; });
/* unused harmony reexport createProvider */
/* unused harmony reexport connectAdvanced */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__connect_connect__["a"]; });





/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "postFile", function() { return postFile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchUser", function() { return fetchUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "logIn", function() { return logIn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "forgotPassword", function() { return forgotPassword; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "uploadFile", function() { return uploadFile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "changePassword", function() { return changePassword; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addReport", function() { return addReport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addQuiz", function() { return addQuiz; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addContact", function() { return addContact; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addFaqQuestion", function() { return addFaqQuestion; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "logOut", function() { return logOut; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchMenu", function() { return fetchMenu; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchReset", function() { return fetchReset; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchFeatured", function() { return fetchFeatured; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchFaq", function() { return fetchFaq; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchPoll", function() { return fetchPoll; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchCounter", function() { return fetchCounter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchDonator", function() { return fetchDonator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "submitDonator", function() { return submitDonator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "searchTerm", function() { return searchTerm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchPage", function() { return fetchPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchAgenda", function() { return fetchAgenda; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchThefts", function() { return fetchThefts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addBookmark", function() { return addBookmark; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addStock", function() { return addStock; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeBookmark", function() { return removeBookmark; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateProfile", function() { return updateProfile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchCharity", function() { return fetchCharity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchChallenge", function() { return fetchChallenge; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchQuestion", function() { return fetchQuestion; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "initGA", function() { return initGA; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_qs__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recompose__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_ga__ = __webpack_require__(36);
var stringify=function stringify(data){return{credentials:'include',headers:{'Content-Type':'application/x-www-form-urlencoded'},body:__WEBPACK_IMPORTED_MODULE_0_qs___default.a.stringify(data)};};var errorHandler=function errorHandler(err){throw err;};var jsonify=function jsonify(request){return request.then(function(res){try{return res.json();}catch(e){errorHandler(e);}});};var handleErrors=function handleErrors(request){return request.catch(errorHandler);};var enhanceRequest=Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["a" /* compose */])(jsonify,handleErrors);var createRequestWithData=function createRequestWithData(method){return function(url){var data=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};return enhanceRequest(fetch(url,Object.assign({method:method},stringify(data))));};};var post=createRequestWithData('POST');var deleteRq=createRequestWithData('DELETE');var postFile=function postFile(url,data){return enhanceRequest(fetch(url,{method:'POST',contentType:false,processData:false,credentials:'include',body:data}));};var get=function get(url){return enhanceRequest(fetch(url,{credentials:'include'}));};var dumbPost=function dumbPost(action,options){return post(action,options);};var fetchUser=function fetchUser(){return get('/user.json');};var logIn=dumbPost;var forgotPassword=dumbPost;var uploadFile=dumbPost;var changePassword=dumbPost;var addReport=dumbPost;var addQuiz=dumbPost;var addContact=dumbPost;var addFaqQuestion=dumbPost;var logOut=function logOut(){return fetch('/logout',{credentials:'include'});};var fetchMenu=function fetchMenu(url){return get(url);};var fetchReset=function fetchReset(url){return get(url);};var fetchFeatured=function fetchFeatured(){return get('/featured.json');};var fetchFaq=function fetchFaq(){return get('/faq.json');};var fetchPoll=function fetchPoll(){return get('/survey.json');};var fetchCounter=function fetchCounter(){return get('/counter.json');};var fetchDonator=function fetchDonator(){return get('/donator/form/render.json');};var submitDonator=function submitDonator(data){return post('/donator/form/submit.json',data);};var searchTerm=function searchTerm(term){return get('/search/'+term+'.json');};var fetchPage=function fetchPage(page,preview){return get(page+'.json'+(preview?'?preview=true':''));};var fetchAgenda=function fetchAgenda(year,month,pathname){return get(pathname+'/'+year+'/'+month+'.json');};var fetchThefts=function fetchThefts(models,ref){return get('/alerts/thefts.json?model='+models+'&serialNb='+encodeURIComponent(ref));};var addBookmark=function addBookmark(item){return post('/bookmarks.json',item);};var addStock=function addStock(item){return post('/stock/update-quantity.json',item);};var removeBookmark=function removeBookmark(item){return deleteRq('/bookmarks.json',item);};var updateProfile=function updateProfile(url,item){return post(url,item);};var fetchCharity=function fetchCharity(){return get('/brand/charity.json');};// CHALLENGE
var fetchChallenge=function fetchChallenge(){return get('/challenge/quiz/self-ranking.json');};// QUIZZ
var fetchQuestion=function fetchQuestion(id){return get(id==='current'?'/challenge/quiz/question.json':'/challenge/quiz/'+id+'/question.json');};// GA
var initGA=function initGA(){var username=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'no-name';return __WEBPACK_IMPORTED_MODULE_2_react_ga__["a" /* default */].initialize('UA-166262585-1',{gaOptions:{userId:username}});};

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(452);


/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__scenes_Pages_container__ = __webpack_require__(62);
var _home$InterviewsList$;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/* harmony default export */ __webpack_exports__["a"] = (_home$InterviewsList$={home:{path:'/',component:__WEBPACK_IMPORTED_MODULE_0__scenes_Pages_container__["y" /* Search */],exact:true},InterviewsList:{path:'/brand/essentials/interviews',exact:true,component:__WEBPACK_IMPORTED_MODULE_0__scenes_Pages_container__["p" /* Interviews */]},bookmarks:{path:'/bookmarks',exact:true,component:__WEBPACK_IMPORTED_MODULE_0__scenes_Pages_container__["c" /* Bookmarks */]}},_defineProperty(_home$InterviewsList$,'bookmarks',{path:'/bookmarks/:slug',exactPath:'/bookmarks',viewed:'/bookmarks/viewed',saved:'/bookmarks/saved',component:__WEBPACK_IMPORTED_MODULE_0__scenes_Pages_container__["c" /* Bookmarks */]}),_defineProperty(_home$InterviewsList$,'catalog',{path:'/catalog/watches',exact:true,component:__WEBPACK_IMPORTED_MODULE_0__scenes_Pages_container__["d" /* Catalog */]}),_defineProperty(_home$InterviewsList$,'product',{path:'/catalog/models/:slug',component:__WEBPACK_IMPORTED_MODULE_0__scenes_Pages_container__["t" /* Product */]}),_defineProperty(_home$InterviewsList$,'charity',{path:'/brand/charity',component:__WEBPACK_IMPORTED_MODULE_0__scenes_Pages_container__["g" /* CharityCatalog */],exact:true}),_defineProperty(_home$InterviewsList$,'charityContact',{path:'/brand/charity/contact',component:__WEBPACK_IMPORTED_MODULE_0__scenes_Pages_container__["h" /* CharityForm */],exact:true}),_defineProperty(_home$InterviewsList$,'charityPage',{path:'/brand/charity/:slug',component:__WEBPACK_IMPORTED_MODULE_0__scenes_Pages_container__["t" /* Product */]}),_defineProperty(_home$InterviewsList$,'brand',{path:'/brand',component:__WEBPACK_IMPORTED_MODULE_0__scenes_Pages_container__["d" /* Catalog */],exact:true}),_defineProperty(_home$InterviewsList$,'brandPages',{path:'/brand/:slug',component:__WEBPACK_IMPORTED_MODULE_0__scenes_Pages_container__["t" /* Product */]}),_defineProperty(_home$InterviewsList$,'social',{path:'/social-media/:filter?',exactPath:'/social-media',component:__WEBPACK_IMPORTED_MODULE_0__scenes_Pages_container__["A" /* SocialMedia */],exact:true}),_defineProperty(_home$InterviewsList$,'publications',{path:'/news',component:__WEBPACK_IMPORTED_MODULE_0__scenes_Pages_container__["u" /* Publication */],exact:true}),_defineProperty(_home$InterviewsList$,'article',{path:'/news/:slug',component:__WEBPACK_IMPORTED_MODULE_0__scenes_Pages_container__["b" /* Article */]}),_defineProperty(_home$InterviewsList$,'gifts',{path:'/challenge/gifts',component:__WEBPACK_IMPORTED_MODULE_0__scenes_Pages_container__["m" /* Gift */],exact:true}),_defineProperty(_home$InterviewsList$,'hubQuizz',{path:'/challenge/quizz',component:__WEBPACK_IMPORTED_MODULE_0__scenes_Pages_container__["n" /* HubQuizz */],exact:true}),_defineProperty(_home$InterviewsList$,'quizz',{path:'/challenge/quizz/:slug?',exactPath:'/challenge/quizz',component:__WEBPACK_IMPORTED_MODULE_0__scenes_Pages_container__["v" /* Quizz */]}),_defineProperty(_home$InterviewsList$,'currentQuizz',{path:'/challenge/quizz/current',component:__WEBPACK_IMPORTED_MODULE_0__scenes_Pages_container__["v" /* Quizz */]}),_defineProperty(_home$InterviewsList$,'ranking',{path:'/challenge/ranking/:filter?',exactPath:'/challenge/ranking',component:__WEBPACK_IMPORTED_MODULE_0__scenes_Pages_container__["w" /* Ranking */]}),_defineProperty(_home$InterviewsList$,'information',{path:'/user/information',component:__WEBPACK_IMPORTED_MODULE_0__scenes_Pages_container__["G" /* User */],exact:true}),_defineProperty(_home$InterviewsList$,'stock',{path:'/user/stocks',component:__WEBPACK_IMPORTED_MODULE_0__scenes_Pages_container__["B" /* Stock */],exact:true}),_defineProperty(_home$InterviewsList$,'team',{path:'/user/team/:filter?',exactPath:'/user/team',component:__WEBPACK_IMPORTED_MODULE_0__scenes_Pages_container__["C" /* Team */]}),_defineProperty(_home$InterviewsList$,'event',{path:'/user/agenda/event',component:__WEBPACK_IMPORTED_MODULE_0__scenes_Pages_container__["a" /* Agenda */],exact:true}),_defineProperty(_home$InterviewsList$,'counterfeits',{path:'/user/alerts',component:__WEBPACK_IMPORTED_MODULE_0__scenes_Pages_container__["k" /* Counterfeits */],exact:true}),_defineProperty(_home$InterviewsList$,'counterfeit',{path:'/user/alerts/counterfeits/:slug',component:__WEBPACK_IMPORTED_MODULE_0__scenes_Pages_container__["j" /* Counterfeit */]}),_defineProperty(_home$InterviewsList$,'thefts',{path:'/user/alerts/thefts',component:__WEBPACK_IMPORTED_MODULE_0__scenes_Pages_container__["E" /* Thefts */],exact:true}),_defineProperty(_home$InterviewsList$,'theft',{path:'/user/alerts/thefts/:slug',component:__WEBPACK_IMPORTED_MODULE_0__scenes_Pages_container__["D" /* Theft */]}),_defineProperty(_home$InterviewsList$,'faqs',{path:'/q-and-a',component:__WEBPACK_IMPORTED_MODULE_0__scenes_Pages_container__["l" /* Faq */],exact:true}),_defineProperty(_home$InterviewsList$,'report',{path:'/user/alerts/thefts/report',component:__WEBPACK_IMPORTED_MODULE_0__scenes_Pages_container__["x" /* Report */],exact:true}),_defineProperty(_home$InterviewsList$,'challenge',{path:'/user/challenge',component:__WEBPACK_IMPORTED_MODULE_0__scenes_Pages_container__["f" /* Challenge */],exact:true}),_defineProperty(_home$InterviewsList$,'sitemap',{path:'/sitemap',component:__WEBPACK_IMPORTED_MODULE_0__scenes_Pages_container__["z" /* Sitemap */],exact:true}),_defineProperty(_home$InterviewsList$,'contact',{path:'/contact',component:__WEBPACK_IMPORTED_MODULE_0__scenes_Pages_container__["i" /* Contact */],exact:true}),_defineProperty(_home$InterviewsList$,'privacy',{path:'/privacy',component:__WEBPACK_IMPORTED_MODULE_0__scenes_Pages_container__["s" /* Privacy */],exact:true}),_defineProperty(_home$InterviewsList$,'legals',{path:'/legal-info',component:__WEBPACK_IMPORTED_MODULE_0__scenes_Pages_container__["q" /* Legals */],exact:true}),_defineProperty(_home$InterviewsList$,'models',{path:'/catalog/models',component:__WEBPACK_IMPORTED_MODULE_0__scenes_Pages_container__["d" /* Catalog */],exact:true}),_defineProperty(_home$InterviewsList$,'friends',{path:'/catalog/friends-and-partners',exact:true,component:__WEBPACK_IMPORTED_MODULE_0__scenes_Pages_container__["d" /* Catalog */]}),_defineProperty(_home$InterviewsList$,'materials',{path:'/catalog/materials',exact:true,component:__WEBPACK_IMPORTED_MODULE_0__scenes_Pages_container__["d" /* Catalog */]}),_defineProperty(_home$InterviewsList$,'complications',{path:'/catalog/complications',exact:true,component:__WEBPACK_IMPORTED_MODULE_0__scenes_Pages_container__["d" /* Catalog */]}),_defineProperty(_home$InterviewsList$,'friendsProduct',{path:'/catalog/friends-and-partners/:slug',component:__WEBPACK_IMPORTED_MODULE_0__scenes_Pages_container__["t" /* Product */]}),_defineProperty(_home$InterviewsList$,'materialsProduct',{path:'/catalog/materials/:slug',component:__WEBPACK_IMPORTED_MODULE_0__scenes_Pages_container__["t" /* Product */]}),_defineProperty(_home$InterviewsList$,'complicationsProduct',{path:'/catalog/complications/:slug',component:__WEBPACK_IMPORTED_MODULE_0__scenes_Pages_container__["t" /* Product */]}),_defineProperty(_home$InterviewsList$,'videos',{path:'/training/videos/:slug',component:__WEBPACK_IMPORTED_MODULE_0__scenes_Pages_container__["F" /* Training */]}),_defineProperty(_home$InterviewsList$,'inDepth',{path:'/catalog/in-depth',exact:true,component:__WEBPACK_IMPORTED_MODULE_0__scenes_Pages_container__["o" /* InDepth */]}),_defineProperty(_home$InterviewsList$,'inDepthChild',{path:'/catalog/in-depth/:slug',component:__WEBPACK_IMPORTED_MODULE_0__scenes_Pages_container__["t" /* Product */]}),_defineProperty(_home$InterviewsList$,'catalogEventsList',{path:'/catalog/events',exact:true,component:__WEBPACK_IMPORTED_MODULE_0__scenes_Pages_container__["e" /* CatalogEvent */]}),_defineProperty(_home$InterviewsList$,'catalogEvent',{path:'/catalog/events/:slug',component:__WEBPACK_IMPORTED_MODULE_0__scenes_Pages_container__["t" /* Product */]}),_home$InterviewsList$);

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(6);

var DOMProperty = __webpack_require__(31);
var ReactDOMComponentFlags = __webpack_require__(103);

var invariant = __webpack_require__(4);

var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
var Flags = ReactDOMComponentFlags;

var internalInstanceKey = '__reactInternalInstance$' + Math.random().toString(36).slice(2);

/**
 * Check if a given node should be cached.
 */
function shouldPrecacheNode(node, nodeID) {
  return node.nodeType === 1 && node.getAttribute(ATTR_NAME) === String(nodeID) || node.nodeType === 8 && node.nodeValue === ' react-text: ' + nodeID + ' ' || node.nodeType === 8 && node.nodeValue === ' react-empty: ' + nodeID + ' ';
}

/**
 * Drill down (through composites and empty components) until we get a host or
 * host text component.
 *
 * This is pretty polymorphic but unavoidable with the current structure we have
 * for `_renderedChildren`.
 */
function getRenderedHostOrTextFromComponent(component) {
  var rendered;
  while (rendered = component._renderedComponent) {
    component = rendered;
  }
  return component;
}

/**
 * Populate `_hostNode` on the rendered host/text component with the given
 * DOM node. The passed `inst` can be a composite.
 */
function precacheNode(inst, node) {
  var hostInst = getRenderedHostOrTextFromComponent(inst);
  hostInst._hostNode = node;
  node[internalInstanceKey] = hostInst;
}

function uncacheNode(inst) {
  var node = inst._hostNode;
  if (node) {
    delete node[internalInstanceKey];
    inst._hostNode = null;
  }
}

/**
 * Populate `_hostNode` on each child of `inst`, assuming that the children
 * match up with the DOM (element) children of `node`.
 *
 * We cache entire levels at once to avoid an n^2 problem where we access the
 * children of a node sequentially and have to walk from the start to our target
 * node every time.
 *
 * Since we update `_renderedChildren` and the actual DOM at (slightly)
 * different times, we could race here and see a newer `_renderedChildren` than
 * the DOM nodes we see. To avoid this, ReactMultiChild calls
 * `prepareToManageChildren` before we change `_renderedChildren`, at which
 * time the container's child nodes are always cached (until it unmounts).
 */
function precacheChildNodes(inst, node) {
  if (inst._flags & Flags.hasCachedChildNodes) {
    return;
  }
  var children = inst._renderedChildren;
  var childNode = node.firstChild;
  outer: for (var name in children) {
    if (!children.hasOwnProperty(name)) {
      continue;
    }
    var childInst = children[name];
    var childID = getRenderedHostOrTextFromComponent(childInst)._domID;
    if (childID === 0) {
      // We're currently unmounting this child in ReactMultiChild; skip it.
      continue;
    }
    // We assume the child nodes are in the same order as the child instances.
    for (; childNode !== null; childNode = childNode.nextSibling) {
      if (shouldPrecacheNode(childNode, childID)) {
        precacheNode(childInst, childNode);
        continue outer;
      }
    }
    // We reached the end of the DOM children without finding an ID match.
     true ?  false ? invariant(false, 'Unable to find element with ID %s.', childID) : _prodInvariant('32', childID) : void 0;
  }
  inst._flags |= Flags.hasCachedChildNodes;
}

/**
 * Given a DOM node, return the closest ReactDOMComponent or
 * ReactDOMTextComponent instance ancestor.
 */
function getClosestInstanceFromNode(node) {
  if (node[internalInstanceKey]) {
    return node[internalInstanceKey];
  }

  // Walk up the tree until we find an ancestor whose instance we have cached.
  var parents = [];
  while (!node[internalInstanceKey]) {
    parents.push(node);
    if (node.parentNode) {
      node = node.parentNode;
    } else {
      // Top of the tree. This node must not be part of a React tree (or is
      // unmounted, potentially).
      return null;
    }
  }

  var closest;
  var inst;
  for (; node && (inst = node[internalInstanceKey]); node = parents.pop()) {
    closest = inst;
    if (parents.length) {
      precacheChildNodes(inst, node);
    }
  }

  return closest;
}

/**
 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
 * instance, or null if the node was not rendered by this React.
 */
function getInstanceFromNode(node) {
  var inst = getClosestInstanceFromNode(node);
  if (inst != null && inst._hostNode === node) {
    return inst;
  } else {
    return null;
  }
}

/**
 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
 * DOM node.
 */
function getNodeFromInstance(inst) {
  // Without this first invariant, passing a non-DOM-component triggers the next
  // invariant for a missing parent, which is super confusing.
  !(inst._hostNode !== undefined) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;

  if (inst._hostNode) {
    return inst._hostNode;
  }

  // Walk up the tree until we find an ancestor whose DOM node we have cached.
  var parents = [];
  while (!inst._hostNode) {
    parents.push(inst);
    !inst._hostParent ?  false ? invariant(false, 'React DOM tree root should always have a node reference.') : _prodInvariant('34') : void 0;
    inst = inst._hostParent;
  }

  // Now parents contains each ancestor that does *not* have a cached native
  // node, and `inst` is the deepest ancestor that does.
  for (; parents.length; inst = parents.pop()) {
    precacheChildNodes(inst, inst._hostNode);
  }

  return inst._hostNode;
}

var ReactDOMComponentTree = {
  getClosestInstanceFromNode: getClosestInstanceFromNode,
  getInstanceFromNode: getInstanceFromNode,
  getNodeFromInstance: getNodeFromInstance,
  precacheChildNodes: precacheChildNodes,
  precacheNode: precacheNode,
  uncacheNode: uncacheNode
};

module.exports = ReactDOMComponentTree;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(271)();
}


/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return withLoader; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_ga__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_ApiController__ = __webpack_require__(10);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var withLoader=function withLoader(WrappedComponent){var path=arguments.length>1&&arguments[1]!==undefined?arguments[1]:null;var slug=arguments.length>2&&arguments[2]!==undefined?arguments[2]:false;var isReload=arguments.length>3&&arguments[3]!==undefined?arguments[3]:true;return function(_Component){_inherits(_class2,_Component);function _class2(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,_class2);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=_class2.__proto__||Object.getPrototypeOf(_class2)).call.apply(_ref,[this].concat(args))),_this),_this.state={isReady:false},_this.getData=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(location,match){var fetchURL;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:fetchURL=!path?location.pathname:path;if(slug)fetchURL=path+'/'+match.params.slug;_context.next=4;return Object(__WEBPACK_IMPORTED_MODULE_5__services_ApiController__["fetchPage"])(fetchURL,location?location.search==='?preview=true':false).then(function(data){_this.setState({isReady:true,data:data});__WEBPACK_IMPORTED_MODULE_2_react_ga__["a" /* default */].pageview(fetchURL);}).catch(function(e){console.log('Something wrong with fetching data',e);});case 4:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x4,_x5){return _ref2.apply(this,arguments);};}(),_temp),_possibleConstructorReturn(_this,_ret);}_createClass(_class2,[{key:'componentDidMount',value:function componentDidMount(){this.getData(this.props.location,this.props.match);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(_ref3){var match=_ref3.match,location=_ref3.location;if(window.location.pathname!=='/q-and-a'){if(this.props.location.pathname!==location.pathname&&(match.path===this.props.match.path||match.path.search('/catalog/models')!==-1&&this.props.match.path.search('/class/')!==-1)&&isReload){this.setState({isReady:false});this.getData(location,match);}}}},{key:'render',value:function render(){var isReady=this.state.isReady;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:Object(__WEBPACK_IMPORTED_MODULE_3__styles__["z" /* ContentLoaderStyle */])(isReady)},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'content-loader'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["F" /* Load */],{width:24,height:24})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(WrappedComponent,Object.assign({},this.props,this.state,{getData:this.getData})));}}]);return _class2;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);};

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/**
 * Simple, lightweight module assisting with the detection and context of
 * Worker. Helps avoid circular dependencies and allows code to reason about
 * whether or not they are in a Worker, even if they never include the main
 * `ReactWorker` dependency.
 */
var ExecutionEnvironment = {

  canUseDOM: canUseDOM,

  canUseWorkers: typeof Worker !== 'undefined',

  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),

  canUseViewport: canUseDOM && !!window.screen,

  isInWorker: !canUseDOM // For now, this is true - might change in the future.

};

module.exports = ExecutionEnvironment;

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Colors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Easings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Font; });
// COLORS 
var Colors={black:'#000000',dark:'#0B0B0B',lightGrey:'#D8D8D8',mediumGrey:'#ADADAD',grey:'#727272',darkGrey:'#3C3C3C',extraLightGrey:'#EBEBEB',white:'#FFFFFF',red:'#D0021B',green:'#7ec82c',blue:'#453FE3',shadow:'rgba(0, 0, 0, 0.15)'// EASINGS
};var Easings={linear:'cubic-bezier(0.250, 0.250, 0.750, 0.750)',quadIn:'cubic-bezier(0.550, 0.085, 0.680, 0.530)',quadOut:'cubic-bezier(0.250, 0.460, 0.450, 0.940)',quadInOut:'cubic-bezier(0.455, 0.030, 0.515, 0.955)',cubicIn:'cubic-bezier(0.550, 0.055, 0.675, 0.190)',cubicOut:'cubic-bezier(0.215, 0.610, 0.355, 1.000)',cubicInOut:'cubic-bezier(0.645, 0.045, 0.355, 1.000)',quartIn:'cubic-bezier(0.895, 0.030, 0.685, 0.220)',quartOut:'cubic-bezier(0.165, 0.840, 0.440, 1.000)',quartInOut:'cubic-bezier(0.770, 0.000, 0.175, 1.000)',quintIn:'cubic-bezier(0.755, 0.050, 0.855, 0.060)',quintOut:'cubic-bezier(0.230, 1.000, 0.320, 1.000)',quintInOut:'cubic-bezier(0.860, 0.000, 0.070, 1.000)',sineIn:'cubic-bezier(0.470, 0.000, 0.745, 0.715)',sineOut:'cubic-bezier(0.390, 0.575, 0.565, 1.000)',sineInOut:'cubic-bezier(0.445, 0.050, 0.550, 0.950)',expoIn:'cubic-bezier(0.950, 0.050, 0.795, 0.035)',expoOut:'cubic-bezier(0.190, 1.000, 0.220, 1.000)',expoInOut:'cubic-bezier(1.000, 0.000, 0.000, 1.000)',circIn:'cubic-bezier(0.600, 0.040, 0.980, 0.335)',circOut:'cubic-bezier(0.075, 0.820, 0.165, 1.000)',circInOut:'cubic-bezier(0.785, 0.135, 0.150, 0.860)',backIn:'cubic-bezier(0.600, 0, 0.735, 0.045)',backOut:'cubic-bezier(0.175, 0.885, 0.320, 1.275)',backInOut:'cubic-bezier(0.680, 0, 0.265, 1)',customEase:'cubic-bezier(0.000, 0.660, 0.445, 1.000)'// FONTS
};var Font={base:'Overpass',title_font:'Interstate-ExtraLight',title_font_bold:'Interstate-bold'};

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2016-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



// Trust the developer to only use ReactInstrumentation with a __DEV__ check

var debugTool = null;

if (false) {
  var ReactDebugTool = require('./ReactDebugTool');
  debugTool = ReactDebugTool;
}

module.exports = { debugTool: debugTool };

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(6),
    _assign = __webpack_require__(9);

var CallbackQueue = __webpack_require__(107);
var PooledClass = __webpack_require__(27);
var ReactFeatureFlags = __webpack_require__(108);
var ReactReconciler = __webpack_require__(32);
var Transaction = __webpack_require__(50);

var invariant = __webpack_require__(4);

var dirtyComponents = [];
var updateBatchNumber = 0;
var asapCallbackQueue = CallbackQueue.getPooled();
var asapEnqueued = false;

var batchingStrategy = null;

function ensureInjected() {
  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching strategy') : _prodInvariant('123') : void 0;
}

var NESTED_UPDATES = {
  initialize: function () {
    this.dirtyComponentsLength = dirtyComponents.length;
  },
  close: function () {
    if (this.dirtyComponentsLength !== dirtyComponents.length) {
      // Additional updates were enqueued by componentDidUpdate handlers or
      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
      // these new updates so that if A's componentDidUpdate calls setState on
      // B, B will update before the callback A's updater provided when calling
      // setState.
      dirtyComponents.splice(0, this.dirtyComponentsLength);
      flushBatchedUpdates();
    } else {
      dirtyComponents.length = 0;
    }
  }
};

var UPDATE_QUEUEING = {
  initialize: function () {
    this.callbackQueue.reset();
  },
  close: function () {
    this.callbackQueue.notifyAll();
  }
};

var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];

function ReactUpdatesFlushTransaction() {
  this.reinitializeTransaction();
  this.dirtyComponentsLength = null;
  this.callbackQueue = CallbackQueue.getPooled();
  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled(
  /* useCreateElement */true);
}

_assign(ReactUpdatesFlushTransaction.prototype, Transaction, {
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  },

  destructor: function () {
    this.dirtyComponentsLength = null;
    CallbackQueue.release(this.callbackQueue);
    this.callbackQueue = null;
    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
    this.reconcileTransaction = null;
  },

  perform: function (method, scope, a) {
    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
    // with this transaction's wrappers around it.
    return Transaction.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
  }
});

PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);

function batchedUpdates(callback, a, b, c, d, e) {
  ensureInjected();
  return batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
}

/**
 * Array comparator for ReactComponents by mount ordering.
 *
 * @param {ReactComponent} c1 first component you're comparing
 * @param {ReactComponent} c2 second component you're comparing
 * @return {number} Return value usable by Array.prototype.sort().
 */
function mountOrderComparator(c1, c2) {
  return c1._mountOrder - c2._mountOrder;
}

function runBatchedUpdates(transaction) {
  var len = transaction.dirtyComponentsLength;
  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to match dirty-components array length (%s).', len, dirtyComponents.length) : _prodInvariant('124', len, dirtyComponents.length) : void 0;

  // Since reconciling a component higher in the owner hierarchy usually (not
  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
  // them before their children by sorting the array.
  dirtyComponents.sort(mountOrderComparator);

  // Any updates enqueued while reconciling must be performed after this entire
  // batch. Otherwise, if dirtyComponents is [A, B] where A has children B and
  // C, B could update twice in a single batch if C's render enqueues an update
  // to B (since B would have already updated, we should skip it, and the only
  // way we can know to do so is by checking the batch counter).
  updateBatchNumber++;

  for (var i = 0; i < len; i++) {
    // If a component is unmounted before pending changes apply, it will still
    // be here, but we assume that it has cleared its _pendingCallbacks and
    // that performUpdateIfNecessary is a noop.
    var component = dirtyComponents[i];

    // If performUpdateIfNecessary happens to enqueue any new updates, we
    // shouldn't execute the callbacks until the next render happens, so
    // stash the callbacks first
    var callbacks = component._pendingCallbacks;
    component._pendingCallbacks = null;

    var markerName;
    if (ReactFeatureFlags.logTopLevelRenders) {
      var namedComponent = component;
      // Duck type TopLevelWrapper. This is probably always true.
      if (component._currentElement.type.isReactTopLevelWrapper) {
        namedComponent = component._renderedComponent;
      }
      markerName = 'React update: ' + namedComponent.getName();
      console.time(markerName);
    }

    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction, updateBatchNumber);

    if (markerName) {
      console.timeEnd(markerName);
    }

    if (callbacks) {
      for (var j = 0; j < callbacks.length; j++) {
        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
      }
    }
  }
}

var flushBatchedUpdates = function () {
  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
  // array and perform any updates enqueued by mount-ready handlers (i.e.,
  // componentDidUpdate) but we need to check here too in order to catch
  // updates enqueued by setState callbacks and asap calls.
  while (dirtyComponents.length || asapEnqueued) {
    if (dirtyComponents.length) {
      var transaction = ReactUpdatesFlushTransaction.getPooled();
      transaction.perform(runBatchedUpdates, null, transaction);
      ReactUpdatesFlushTransaction.release(transaction);
    }

    if (asapEnqueued) {
      asapEnqueued = false;
      var queue = asapCallbackQueue;
      asapCallbackQueue = CallbackQueue.getPooled();
      queue.notifyAll();
      CallbackQueue.release(queue);
    }
  }
};

/**
 * Mark a component as needing a rerender, adding an optional callback to a
 * list of functions which will be executed once the rerender occurs.
 */
function enqueueUpdate(component) {
  ensureInjected();

  // Various parts of our code (such as ReactCompositeComponent's
  // _renderValidatedComponent) assume that calls to render aren't nested;
  // verify that that's the case. (This is called by each top-level update
  // function, like setState, forceUpdate, etc.; creation and
  // destruction of top-level components is guarded in ReactMount.)

  if (!batchingStrategy.isBatchingUpdates) {
    batchingStrategy.batchedUpdates(enqueueUpdate, component);
    return;
  }

  dirtyComponents.push(component);
  if (component._updateBatchNumber == null) {
    component._updateBatchNumber = updateBatchNumber + 1;
  }
}

/**
 * Enqueue a callback to be run at the end of the current batching cycle. Throws
 * if no updates are currently being performed.
 */
function asap(callback, context) {
  invariant(batchingStrategy.isBatchingUpdates, "ReactUpdates.asap: Can't enqueue an asap callback in a context where" + 'updates are not being batched.');
  asapCallbackQueue.enqueue(callback, context);
  asapEnqueued = true;
}

var ReactUpdatesInjection = {
  injectReconcileTransaction: function (ReconcileTransaction) {
    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : _prodInvariant('126') : void 0;
    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
  },

  injectBatchingStrategy: function (_batchingStrategy) {
    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : _prodInvariant('127') : void 0;
    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : _prodInvariant('128') : void 0;
    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : _prodInvariant('129') : void 0;
    batchingStrategy = _batchingStrategy;
  }
};

var ReactUpdates = {
  /**
   * React references `ReactReconcileTransaction` using this property in order
   * to allow dependency injection.
   *
   * @internal
   */
  ReactReconcileTransaction: null,

  batchedUpdates: batchedUpdates,
  enqueueUpdate: enqueueUpdate,
  flushBatchedUpdates: flushBatchedUpdates,
  injection: ReactUpdatesInjection,
  asap: asap
};

module.exports = ReactUpdates;

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.21';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function',
      INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading whitespace. */
  var reTrimStart = /^\s+/;

  /** Used to match a single whitespace character. */
  var reWhitespace = /\s/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */
  var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */
  function baseTrim(string) {
    return string
      ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
      : string;
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */
  function trimmedEndIndex(string) {
    var index = string.length;

    while (index-- && reWhitespace.test(string.charAt(index))) {}
    return index;
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });
      } else if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) {
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      if (iteratees.length) {
        iteratees = arrayMap(iteratees, function(iteratee) {
          if (isArray(iteratee)) {
            return function(value) {
              return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
            }
          }
          return iteratee;
        });
      } else {
        iteratees = [identity];
      }

      var index = -1;
      iteratees = arrayMap(iteratees, baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
          return object;
        }

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      var low = 0,
          high = array == null ? 0 : array.length;
      if (high === 0) {
        return 0;
      }

      value = iteratee(value);
      var valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision && nativeIsFinite(number)) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Check that cyclic values are equal.
      var arrStacked = stack.get(array);
      var othStacked = stack.get(other);
      if (arrStacked && othStacked) {
        return arrStacked == other && othStacked == array;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Check that cyclic values are equal.
      var objStacked = stack.get(object);
      var othStacked = stack.get(other);
      if (objStacked && othStacked) {
        return objStacked == other && othStacked == object;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function safeGet(object, key) {
      if (key === 'constructor' && typeof object[key] === 'function') {
        return;
      }

      if (key == '__proto__') {
        return;
      }

      return object[key];
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            clearTimeout(timerId);
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = baseTrim(value);
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      // The sourceURL gets injected into the source that's eval-ed, so be careful
      // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
      // and escape the comment, thus injecting code that gets evaled.
      var sourceURL = '//# sourceURL=' +
        (hasOwnProperty.call(options, 'sourceURL')
          ? (options.sourceURL + '').replace(/\s/g, ' ')
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Throw an error if a forbidden character was found in `variable`, to prevent
      // potential command injection attacks.
      else if (reForbiddenIdentifierChars.test(variable)) {
        throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
      }

      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return baseTrim(string);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.slice(0, trimmedEndIndex(string) + 1);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = lodashFunc.name + '';
        if (!hasOwnProperty.call(realNames, key)) {
          realNames[key] = [];
        }
        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (true) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
      return _;
    }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else if (freeModule) {
    // Export for Node.js.
    (freeModule.exports = _)._ = _;
    // Export for CommonJS support.
    freeExports._ = _;
  }
  else {
    // Export to the global object.
    root._ = _;
  }
}.call(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(40), __webpack_require__(153)(module)))

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/**
 * Keeps track of the current owner.
 *
 * The current owner is the component who should own any components that are
 * currently being constructed.
 */
var ReactCurrentOwner = {
  /**
   * @internal
   * @type {ReactComponent}
   */
  current: null
};

module.exports = ReactCurrentOwner;

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(9);

var PooledClass = __webpack_require__(27);

var emptyFunction = __webpack_require__(19);
var warning = __webpack_require__(7);

var didWarnForAddedNewProperty = false;
var isProxySupported = typeof Proxy === 'function';

var shouldBeReleasedProperties = ['dispatchConfig', '_targetInst', 'nativeEvent', 'isDefaultPrevented', 'isPropagationStopped', '_dispatchListeners', '_dispatchInstances'];

/**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var EventInterface = {
  type: null,
  target: null,
  // currentTarget is set when dispatching; no use in copying it here
  currentTarget: emptyFunction.thatReturnsNull,
  eventPhase: null,
  bubbles: null,
  cancelable: null,
  timeStamp: function (event) {
    return event.timeStamp || Date.now();
  },
  defaultPrevented: null,
  isTrusted: null
};

/**
 * Synthetic events are dispatched by event plugins, typically in response to a
 * top-level event delegation handler.
 *
 * These systems should generally use pooling to reduce the frequency of garbage
 * collection. The system should check `isPersistent` to determine whether the
 * event should be released into the pool after being dispatched. Users that
 * need a persisted event should invoke `persist`.
 *
 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
 * normalizing browser quirks. Subclasses do not necessarily have to implement a
 * DOM interface; custom application-specific events can also subclass this.
 *
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {*} targetInst Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @param {DOMEventTarget} nativeEventTarget Target node.
 */
function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
  if (false) {
    // these have a getter/setter for warnings
    delete this.nativeEvent;
    delete this.preventDefault;
    delete this.stopPropagation;
  }

  this.dispatchConfig = dispatchConfig;
  this._targetInst = targetInst;
  this.nativeEvent = nativeEvent;

  var Interface = this.constructor.Interface;
  for (var propName in Interface) {
    if (!Interface.hasOwnProperty(propName)) {
      continue;
    }
    if (false) {
      delete this[propName]; // this has a getter/setter for warnings
    }
    var normalize = Interface[propName];
    if (normalize) {
      this[propName] = normalize(nativeEvent);
    } else {
      if (propName === 'target') {
        this.target = nativeEventTarget;
      } else {
        this[propName] = nativeEvent[propName];
      }
    }
  }

  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
  if (defaultPrevented) {
    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
  } else {
    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
  }
  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
  return this;
}

_assign(SyntheticEvent.prototype, {
  preventDefault: function () {
    this.defaultPrevented = true;
    var event = this.nativeEvent;
    if (!event) {
      return;
    }

    if (event.preventDefault) {
      event.preventDefault();
      // eslint-disable-next-line valid-typeof
    } else if (typeof event.returnValue !== 'unknown') {
      event.returnValue = false;
    }
    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
  },

  stopPropagation: function () {
    var event = this.nativeEvent;
    if (!event) {
      return;
    }

    if (event.stopPropagation) {
      event.stopPropagation();
      // eslint-disable-next-line valid-typeof
    } else if (typeof event.cancelBubble !== 'unknown') {
      // The ChangeEventPlugin registers a "propertychange" event for
      // IE. This event does not support bubbling or cancelling, and
      // any references to cancelBubble throw "Member not found".  A
      // typeof check of "unknown" circumvents this issue (and is also
      // IE specific).
      event.cancelBubble = true;
    }

    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
  },

  /**
   * We release all dispatched `SyntheticEvent`s after each event loop, adding
   * them back into the pool. This allows a way to hold onto a reference that
   * won't be added back into the pool.
   */
  persist: function () {
    this.isPersistent = emptyFunction.thatReturnsTrue;
  },

  /**
   * Checks if this event should be released back into the pool.
   *
   * @return {boolean} True if this should not be released, false otherwise.
   */
  isPersistent: emptyFunction.thatReturnsFalse,

  /**
   * `PooledClass` looks for `destructor` on each instance it releases.
   */
  destructor: function () {
    var Interface = this.constructor.Interface;
    for (var propName in Interface) {
      if (false) {
        Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
      } else {
        this[propName] = null;
      }
    }
    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
      this[shouldBeReleasedProperties[i]] = null;
    }
    if (false) {
      Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
      Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', emptyFunction));
      Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', emptyFunction));
    }
  }
});

SyntheticEvent.Interface = EventInterface;

/**
 * Helper to reduce boilerplate when creating subclasses.
 *
 * @param {function} Class
 * @param {?object} Interface
 */
SyntheticEvent.augmentClass = function (Class, Interface) {
  var Super = this;

  var E = function () {};
  E.prototype = Super.prototype;
  var prototype = new E();

  _assign(prototype, Class.prototype);
  Class.prototype = prototype;
  Class.prototype.constructor = Class;

  Class.Interface = _assign({}, Super.Interface, Interface);
  Class.augmentClass = Super.augmentClass;

  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
};

/** Proxying after everything set on SyntheticEvent
  * to resolve Proxy issue on some WebKit browsers
  * in which some Event properties are set to undefined (GH#10010)
  */
if (false) {
  if (isProxySupported) {
    /*eslint-disable no-func-assign */
    SyntheticEvent = new Proxy(SyntheticEvent, {
      construct: function (target, args) {
        return this.apply(target, Object.create(target.prototype), args);
      },
      apply: function (constructor, that, args) {
        return new Proxy(constructor.apply(that, args), {
          set: function (target, prop, value) {
            if (prop !== 'isPersistent' && !target.constructor.Interface.hasOwnProperty(prop) && shouldBeReleasedProperties.indexOf(prop) === -1) {
              process.env.NODE_ENV !== 'production' ? warning(didWarnForAddedNewProperty || target.isPersistent(), "This synthetic event is reused for performance reasons. If you're " + "seeing this, you're adding a new property in the synthetic event object. " + 'The property is never released. See ' + 'https://fb.me/react-event-pooling for more information.') : void 0;
              didWarnForAddedNewProperty = true;
            }
            target[prop] = value;
            return true;
          }
        });
      }
    });
    /*eslint-enable no-func-assign */
  }
}

PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);

module.exports = SyntheticEvent;

/**
  * Helper to nullify syntheticEvent instance properties when destructing
  *
  * @param {object} SyntheticEvent
  * @param {String} propName
  * @return {object} defineProperty object
  */
function getPooledWarningPropertyDefinition(propName, getVal) {
  var isFunction = typeof getVal === 'function';
  return {
    configurable: true,
    set: set,
    get: get
  };

  function set(val) {
    var action = isFunction ? 'setting the method' : 'setting the property';
    warn(action, 'This is effectively a no-op');
    return val;
  }

  function get() {
    var action = isFunction ? 'accessing the method' : 'accessing the property';
    var result = isFunction ? 'This is a no-op function' : 'This is set to null';
    warn(action, result);
    return getVal;
  }

  function warn(action, result) {
    var warningCondition = false;
     false ? warning(warningCondition, "This synthetic event is reused for performance reasons. If you're seeing this, " + "you're %s `%s` on a released/nullified synthetic event. %s. " + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result) : void 0;
  }
}

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * Fizzy UI utils v2.0.7
 * MIT license
 */

/*jshint browser: true, undef: true, unused: true, strict: true */

( function( window, factory ) {
  // universal module definition
  /*jshint strict: false */ /*globals define, module, require */

  if ( true ) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
      __webpack_require__(456)
    ], __WEBPACK_AMD_DEFINE_RESULT__ = function( matchesSelector ) {
      return factory( window, matchesSelector );
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
      window,
      require('desandro-matches-selector')
    );
  } else {
    // browser global
    window.fizzyUIUtils = factory(
      window,
      window.matchesSelector
    );
  }

}( window, function factory( window, matchesSelector ) {

'use strict';

var utils = {};

// ----- extend ----- //

// extends objects
utils.extend = function( a, b ) {
  for ( var prop in b ) {
    a[ prop ] = b[ prop ];
  }
  return a;
};

// ----- modulo ----- //

utils.modulo = function( num, div ) {
  return ( ( num % div ) + div ) % div;
};

// ----- makeArray ----- //

var arraySlice = Array.prototype.slice;

// turn element or nodeList into an array
utils.makeArray = function( obj ) {
  if ( Array.isArray( obj ) ) {
    // use object if already an array
    return obj;
  }
  // return empty array if undefined or null. #6
  if ( obj === null || obj === undefined ) {
    return [];
  }

  var isArrayLike = typeof obj == 'object' && typeof obj.length == 'number';
  if ( isArrayLike ) {
    // convert nodeList to array
    return arraySlice.call( obj );
  }

  // array of single index
  return [ obj ];
};

// ----- removeFrom ----- //

utils.removeFrom = function( ary, obj ) {
  var index = ary.indexOf( obj );
  if ( index != -1 ) {
    ary.splice( index, 1 );
  }
};

// ----- getParent ----- //

utils.getParent = function( elem, selector ) {
  while ( elem.parentNode && elem != document.body ) {
    elem = elem.parentNode;
    if ( matchesSelector( elem, selector ) ) {
      return elem;
    }
  }
};

// ----- getQueryElement ----- //

// use element as selector string
utils.getQueryElement = function( elem ) {
  if ( typeof elem == 'string' ) {
    return document.querySelector( elem );
  }
  return elem;
};

// ----- handleEvent ----- //

// enable .ontype to trigger from .addEventListener( elem, 'type' )
utils.handleEvent = function( event ) {
  var method = 'on' + event.type;
  if ( this[ method ] ) {
    this[ method ]( event );
  }
};

// ----- filterFindElements ----- //

utils.filterFindElements = function( elems, selector ) {
  // make array of elems
  elems = utils.makeArray( elems );
  var ffElems = [];

  elems.forEach( function( elem ) {
    // check that elem is an actual element
    if ( !( elem instanceof HTMLElement ) ) {
      return;
    }
    // add elem if no selector
    if ( !selector ) {
      ffElems.push( elem );
      return;
    }
    // filter & find items if we have a selector
    // filter
    if ( matchesSelector( elem, selector ) ) {
      ffElems.push( elem );
    }
    // find children
    var childElems = elem.querySelectorAll( selector );
    // concat childElems to filterFound array
    for ( var i=0; i < childElems.length; i++ ) {
      ffElems.push( childElems[i] );
    }
  });

  return ffElems;
};

// ----- debounceMethod ----- //

utils.debounceMethod = function( _class, methodName, threshold ) {
  threshold = threshold || 100;
  // original method
  var method = _class.prototype[ methodName ];
  var timeoutName = methodName + 'Timeout';

  _class.prototype[ methodName ] = function() {
    var timeout = this[ timeoutName ];
    clearTimeout( timeout );

    var args = arguments;
    var _this = this;
    this[ timeoutName ] = setTimeout( function() {
      method.apply( _this, args );
      delete _this[ timeoutName ];
    }, threshold );
  };
};

// ----- docReady ----- //

utils.docReady = function( callback ) {
  var readyState = document.readyState;
  if ( readyState == 'complete' || readyState == 'interactive' ) {
    // do async to allow for other scripts to run. metafizzy/flickity#441
    setTimeout( callback );
  } else {
    document.addEventListener( 'DOMContentLoaded', callback );
  }
};

// ----- htmlInit ----- //

// http://jamesroberts.name/blog/2010/02/22/string-functions-for-javascript-trim-to-camel-case-to-dashed-and-to-underscore/
utils.toDashed = function( str ) {
  return str.replace( /(.)([A-Z])/g, function( match, $1, $2 ) {
    return $1 + '-' + $2;
  }).toLowerCase();
};

var console = window.console;
/**
 * allow user to initialize classes via [data-namespace] or .js-namespace class
 * htmlInit( Widget, 'widgetName' )
 * options are parsed from data-namespace-options
 */
utils.htmlInit = function( WidgetClass, namespace ) {
  utils.docReady( function() {
    var dashedNamespace = utils.toDashed( namespace );
    var dataAttr = 'data-' + dashedNamespace;
    var dataAttrElems = document.querySelectorAll( '[' + dataAttr + ']' );
    var jsDashElems = document.querySelectorAll( '.js-' + dashedNamespace );
    var elems = utils.makeArray( dataAttrElems )
      .concat( utils.makeArray( jsDashElems ) );
    var dataOptionsAttr = dataAttr + '-options';
    var jQuery = window.jQuery;

    elems.forEach( function( elem ) {
      var attr = elem.getAttribute( dataAttr ) ||
        elem.getAttribute( dataOptionsAttr );
      var options;
      try {
        options = attr && JSON.parse( attr );
      } catch ( error ) {
        // log error, do not initialize
        if ( console ) {
          console.error( 'Error parsing ' + dataAttr + ' on ' + elem.className +
          ': ' + error );
        }
        return;
      }
      // initialize
      var instance = new WidgetClass( elem, options );
      // make available via $().data('namespace')
      if ( jQuery ) {
        jQuery.data( elem, namespace, instance );
      }
    });

  });
};

// -----  ----- //

return utils;

}));


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(6);

var invariant = __webpack_require__(4);

/**
 * Static poolers. Several custom versions for each potential number of
 * arguments. A completely generic pooler is easy to implement, but would
 * require accessing the `arguments` object. In each of these, `this` refers to
 * the Class itself, not an instance. If any others are needed, simply add them
 * here, or in their own files.
 */
var oneArgumentPooler = function (copyFieldsFrom) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, copyFieldsFrom);
    return instance;
  } else {
    return new Klass(copyFieldsFrom);
  }
};

var twoArgumentPooler = function (a1, a2) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2);
    return instance;
  } else {
    return new Klass(a1, a2);
  }
};

var threeArgumentPooler = function (a1, a2, a3) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3);
    return instance;
  } else {
    return new Klass(a1, a2, a3);
  }
};

var fourArgumentPooler = function (a1, a2, a3, a4) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3, a4);
    return instance;
  } else {
    return new Klass(a1, a2, a3, a4);
  }
};

var standardReleaser = function (instance) {
  var Klass = this;
  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
  instance.destructor();
  if (Klass.instancePool.length < Klass.poolSize) {
    Klass.instancePool.push(instance);
  }
};

var DEFAULT_POOL_SIZE = 10;
var DEFAULT_POOLER = oneArgumentPooler;

/**
 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
 * itself (statically) not adding any prototypical fields. Any CopyConstructor
 * you give this may have a `poolSize` property, and will look for a
 * prototypical `destructor` on instances.
 *
 * @param {Function} CopyConstructor Constructor that can be used to reset.
 * @param {Function} pooler Customizable pooler.
 */
var addPoolingTo = function (CopyConstructor, pooler) {
  // Casting as any so that flow ignores the actual implementation and trusts
  // it to match the type we declared
  var NewKlass = CopyConstructor;
  NewKlass.instancePool = [];
  NewKlass.getPooled = pooler || DEFAULT_POOLER;
  if (!NewKlass.poolSize) {
    NewKlass.poolSize = DEFAULT_POOL_SIZE;
  }
  NewKlass.release = standardReleaser;
  return NewKlass;
};

var PooledClass = {
  addPoolingTo: addPoolingTo,
  oneArgumentPooler: oneArgumentPooler,
  twoArgumentPooler: twoArgumentPooler,
  threeArgumentPooler: threeArgumentPooler,
  fourArgumentPooler: fourArgumentPooler
};

module.exports = PooledClass;

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// Flickity main
/* eslint-disable max-params */
( function( window, factory ) {
  // universal module definition
  if ( true ) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
      __webpack_require__(94),
      __webpack_require__(161),
      __webpack_require__(26),
      __webpack_require__(457),
      __webpack_require__(458),
      __webpack_require__(459),
    ], __WEBPACK_AMD_DEFINE_RESULT__ = function( EvEmitter, getSize, utils, Cell, Slide, animatePrototype ) {
      return factory( window, EvEmitter, getSize, utils, Cell, Slide, animatePrototype );
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
        window,
        require('ev-emitter'),
        require('get-size'),
        require('fizzy-ui-utils'),
        require('./cell'),
        require('./slide'),
        require('./animate')
    );
  } else {
    // browser global
    var _Flickity = window.Flickity;

    window.Flickity = factory(
        window,
        window.EvEmitter,
        window.getSize,
        window.fizzyUIUtils,
        _Flickity.Cell,
        _Flickity.Slide,
        _Flickity.animatePrototype
    );
  }

}( window, function factory( window, EvEmitter, getSize,
    utils, Cell, Slide, animatePrototype ) {

/* eslint-enable max-params */
'use strict';

// vars
var jQuery = window.jQuery;
var getComputedStyle = window.getComputedStyle;
var console = window.console;

function moveElements( elems, toElem ) {
  elems = utils.makeArray( elems );
  while ( elems.length ) {
    toElem.appendChild( elems.shift() );
  }
}

// -------------------------- Flickity -------------------------- //

// globally unique identifiers
var GUID = 0;
// internal store of all Flickity intances
var instances = {};

function Flickity( element, options ) {
  var queryElement = utils.getQueryElement( element );
  if ( !queryElement ) {
    if ( console ) {
      console.error( 'Bad element for Flickity: ' + ( queryElement || element ) );
    }
    return;
  }
  this.element = queryElement;
  // do not initialize twice on same element
  if ( this.element.flickityGUID ) {
    var instance = instances[ this.element.flickityGUID ];
    if ( instance ) instance.option( options );
    return instance;
  }

  // add jQuery
  if ( jQuery ) {
    this.$element = jQuery( this.element );
  }
  // options
  this.options = utils.extend( {}, this.constructor.defaults );
  this.option( options );

  // kick things off
  this._create();
}

Flickity.defaults = {
  accessibility: true,
  // adaptiveHeight: false,
  cellAlign: 'center',
  // cellSelector: undefined,
  // contain: false,
  freeScrollFriction: 0.075, // friction when free-scrolling
  friction: 0.28, // friction when selecting
  namespaceJQueryEvents: true,
  // initialIndex: 0,
  percentPosition: true,
  resize: true,
  selectedAttraction: 0.025,
  setGallerySize: true,
  // watchCSS: false,
  // wrapAround: false
};

// hash of methods triggered on _create()
Flickity.createMethods = [];

var proto = Flickity.prototype;
// inherit EventEmitter
utils.extend( proto, EvEmitter.prototype );

proto._create = function() {
  // add id for Flickity.data
  var id = this.guid = ++GUID;
  this.element.flickityGUID = id; // expando
  instances[ id ] = this; // associate via id
  // initial properties
  this.selectedIndex = 0;
  // how many frames slider has been in same position
  this.restingFrames = 0;
  // initial physics properties
  this.x = 0;
  this.velocity = 0;
  this.originSide = this.options.rightToLeft ? 'right' : 'left';
  // create viewport & slider
  this.viewport = document.createElement('div');
  this.viewport.className = 'flickity-viewport';
  this._createSlider();

  if ( this.options.resize || this.options.watchCSS ) {
    window.addEventListener( 'resize', this );
  }

  // add listeners from on option
  for ( var eventName in this.options.on ) {
    var listener = this.options.on[ eventName ];
    this.on( eventName, listener );
  }

  Flickity.createMethods.forEach( function( method ) {
    this[ method ]();
  }, this );

  if ( this.options.watchCSS ) {
    this.watchCSS();
  } else {
    this.activate();
  }

};

/**
 * set options
 * @param {Object} opts - options to extend
 */
proto.option = function( opts ) {
  utils.extend( this.options, opts );
};

proto.activate = function() {
  if ( this.isActive ) {
    return;
  }
  this.isActive = true;
  this.element.classList.add('flickity-enabled');
  if ( this.options.rightToLeft ) {
    this.element.classList.add('flickity-rtl');
  }

  this.getSize();
  // move initial cell elements so they can be loaded as cells
  var cellElems = this._filterFindCellElements( this.element.children );
  moveElements( cellElems, this.slider );
  this.viewport.appendChild( this.slider );
  this.element.appendChild( this.viewport );
  // get cells from children
  this.reloadCells();

  if ( this.options.accessibility ) {
    // allow element to focusable
    this.element.tabIndex = 0;
    // listen for key presses
    this.element.addEventListener( 'keydown', this );
  }

  this.emitEvent('activate');
  this.selectInitialIndex();
  // flag for initial activation, for using initialIndex
  this.isInitActivated = true;
  // ready event. #493
  this.dispatchEvent('ready');
};

// slider positions the cells
proto._createSlider = function() {
  // slider element does all the positioning
  var slider = document.createElement('div');
  slider.className = 'flickity-slider';
  slider.style[ this.originSide ] = 0;
  this.slider = slider;
};

proto._filterFindCellElements = function( elems ) {
  return utils.filterFindElements( elems, this.options.cellSelector );
};

// goes through all children
proto.reloadCells = function() {
  // collection of item elements
  this.cells = this._makeCells( this.slider.children );
  this.positionCells();
  this._getWrapShiftCells();
  this.setGallerySize();
};

/**
 * turn elements into Flickity.Cells
 * @param {[Array, NodeList, HTMLElement]} elems - elements to make into cells
 * @returns {Array} items - collection of new Flickity Cells
 */
proto._makeCells = function( elems ) {
  var cellElems = this._filterFindCellElements( elems );

  // create new Flickity for collection
  var cells = cellElems.map( function( cellElem ) {
    return new Cell( cellElem, this );
  }, this );

  return cells;
};

proto.getLastCell = function() {
  return this.cells[ this.cells.length - 1 ];
};

proto.getLastSlide = function() {
  return this.slides[ this.slides.length - 1 ];
};

// positions all cells
proto.positionCells = function() {
  // size all cells
  this._sizeCells( this.cells );
  // position all cells
  this._positionCells( 0 );
};

/**
 * position certain cells
 * @param {Integer} index - which cell to start with
 */
proto._positionCells = function( index ) {
  index = index || 0;
  // also measure maxCellHeight
  // start 0 if positioning all cells
  this.maxCellHeight = index ? this.maxCellHeight || 0 : 0;
  var cellX = 0;
  // get cellX
  if ( index > 0 ) {
    var startCell = this.cells[ index - 1 ];
    cellX = startCell.x + startCell.size.outerWidth;
  }
  var len = this.cells.length;
  for ( var i = index; i < len; i++ ) {
    var cell = this.cells[i];
    cell.setPosition( cellX );
    cellX += cell.size.outerWidth;
    this.maxCellHeight = Math.max( cell.size.outerHeight, this.maxCellHeight );
  }
  // keep track of cellX for wrap-around
  this.slideableWidth = cellX;
  // slides
  this.updateSlides();
  // contain slides target
  this._containSlides();
  // update slidesWidth
  this.slidesWidth = len ? this.getLastSlide().target - this.slides[0].target : 0;
};

/**
 * cell.getSize() on multiple cells
 * @param {Array} cells - cells to size
 */
proto._sizeCells = function( cells ) {
  cells.forEach( function( cell ) {
    cell.getSize();
  } );
};

// --------------------------  -------------------------- //

proto.updateSlides = function() {
  this.slides = [];
  if ( !this.cells.length ) {
    return;
  }

  var slide = new Slide( this );
  this.slides.push( slide );
  var isOriginLeft = this.originSide == 'left';
  var nextMargin = isOriginLeft ? 'marginRight' : 'marginLeft';

  var canCellFit = this._getCanCellFit();

  this.cells.forEach( function( cell, i ) {
    // just add cell if first cell in slide
    if ( !slide.cells.length ) {
      slide.addCell( cell );
      return;
    }

    var slideWidth = ( slide.outerWidth - slide.firstMargin ) +
      ( cell.size.outerWidth - cell.size[ nextMargin ] );

    if ( canCellFit.call( this, i, slideWidth ) ) {
      slide.addCell( cell );
    } else {
      // doesn't fit, new slide
      slide.updateTarget();

      slide = new Slide( this );
      this.slides.push( slide );
      slide.addCell( cell );
    }
  }, this );
  // last slide
  slide.updateTarget();
  // update .selectedSlide
  this.updateSelectedSlide();
};

proto._getCanCellFit = function() {
  var groupCells = this.options.groupCells;
  if ( !groupCells ) {
    return function() {
      return false;
    };
  } else if ( typeof groupCells == 'number' ) {
    // group by number. 3 -> [0,1,2], [3,4,5], ...
    var number = parseInt( groupCells, 10 );
    return function( i ) {
      return ( i % number ) !== 0;
    };
  }
  // default, group by width of slide
  // parse '75%
  var percentMatch = typeof groupCells == 'string' &&
    groupCells.match( /^(\d+)%$/ );
  var percent = percentMatch ? parseInt( percentMatch[1], 10 ) / 100 : 1;
  return function( i, slideWidth ) {
    /* eslint-disable-next-line no-invalid-this */
    return slideWidth <= ( this.size.innerWidth + 1 ) * percent;
  };
};

// alias _init for jQuery plugin .flickity()
proto._init =
proto.reposition = function() {
  this.positionCells();
  this.positionSliderAtSelected();
};

proto.getSize = function() {
  this.size = getSize( this.element );
  this.setCellAlign();
  this.cursorPosition = this.size.innerWidth * this.cellAlign;
};

var cellAlignShorthands = {
  // cell align, then based on origin side
  center: {
    left: 0.5,
    right: 0.5,
  },
  left: {
    left: 0,
    right: 1,
  },
  right: {
    right: 0,
    left: 1,
  },
};

proto.setCellAlign = function() {
  var shorthand = cellAlignShorthands[ this.options.cellAlign ];
  this.cellAlign = shorthand ? shorthand[ this.originSide ] : this.options.cellAlign;
};

proto.setGallerySize = function() {
  if ( this.options.setGallerySize ) {
    var height = this.options.adaptiveHeight && this.selectedSlide ?
      this.selectedSlide.height : this.maxCellHeight;
    this.viewport.style.height = height + 'px';
  }
};

proto._getWrapShiftCells = function() {
  // only for wrap-around
  if ( !this.options.wrapAround ) {
    return;
  }
  // unshift previous cells
  this._unshiftCells( this.beforeShiftCells );
  this._unshiftCells( this.afterShiftCells );
  // get before cells
  // initial gap
  var gapX = this.cursorPosition;
  var cellIndex = this.cells.length - 1;
  this.beforeShiftCells = this._getGapCells( gapX, cellIndex, -1 );
  // get after cells
  // ending gap between last cell and end of gallery viewport
  gapX = this.size.innerWidth - this.cursorPosition;
  // start cloning at first cell, working forwards
  this.afterShiftCells = this._getGapCells( gapX, 0, 1 );
};

proto._getGapCells = function( gapX, cellIndex, increment ) {
  // keep adding cells until the cover the initial gap
  var cells = [];
  while ( gapX > 0 ) {
    var cell = this.cells[ cellIndex ];
    if ( !cell ) {
      break;
    }
    cells.push( cell );
    cellIndex += increment;
    gapX -= cell.size.outerWidth;
  }
  return cells;
};

// ----- contain ----- //

// contain cell targets so no excess sliding
proto._containSlides = function() {
  if ( !this.options.contain || this.options.wrapAround || !this.cells.length ) {
    return;
  }
  var isRightToLeft = this.options.rightToLeft;
  var beginMargin = isRightToLeft ? 'marginRight' : 'marginLeft';
  var endMargin = isRightToLeft ? 'marginLeft' : 'marginRight';
  var contentWidth = this.slideableWidth - this.getLastCell().size[ endMargin ];
  // content is less than gallery size
  var isContentSmaller = contentWidth < this.size.innerWidth;
  // bounds
  var beginBound = this.cursorPosition + this.cells[0].size[ beginMargin ];
  var endBound = contentWidth - this.size.innerWidth * ( 1 - this.cellAlign );
  // contain each cell target
  this.slides.forEach( function( slide ) {
    if ( isContentSmaller ) {
      // all cells fit inside gallery
      slide.target = contentWidth * this.cellAlign;
    } else {
      // contain to bounds
      slide.target = Math.max( slide.target, beginBound );
      slide.target = Math.min( slide.target, endBound );
    }
  }, this );
};

// -----  ----- //

/**
 * emits events via eventEmitter and jQuery events
 * @param {String} type - name of event
 * @param {Event} event - original event
 * @param {Array} args - extra arguments
 */
proto.dispatchEvent = function( type, event, args ) {
  var emitArgs = event ? [ event ].concat( args ) : args;
  this.emitEvent( type, emitArgs );

  if ( jQuery && this.$element ) {
    // default trigger with type if no event
    type += this.options.namespaceJQueryEvents ? '.flickity' : '';
    var $event = type;
    if ( event ) {
      // create jQuery event
      var jQEvent = new jQuery.Event( event );
      jQEvent.type = type;
      $event = jQEvent;
    }
    this.$element.trigger( $event, args );
  }
};

// -------------------------- select -------------------------- //

/**
 * @param {Integer} index - index of the slide
 * @param {Boolean} isWrap - will wrap-around to last/first if at the end
 * @param {Boolean} isInstant - will immediately set position at selected cell
 */
proto.select = function( index, isWrap, isInstant ) {
  if ( !this.isActive ) {
    return;
  }
  index = parseInt( index, 10 );
  this._wrapSelect( index );

  if ( this.options.wrapAround || isWrap ) {
    index = utils.modulo( index, this.slides.length );
  }
  // bail if invalid index
  if ( !this.slides[ index ] ) {
    return;
  }
  var prevIndex = this.selectedIndex;
  this.selectedIndex = index;
  this.updateSelectedSlide();
  if ( isInstant ) {
    this.positionSliderAtSelected();
  } else {
    this.startAnimation();
  }
  if ( this.options.adaptiveHeight ) {
    this.setGallerySize();
  }
  // events
  this.dispatchEvent( 'select', null, [ index ] );
  // change event if new index
  if ( index != prevIndex ) {
    this.dispatchEvent( 'change', null, [ index ] );
  }
  // old v1 event name, remove in v3
  this.dispatchEvent('cellSelect');
};

// wraps position for wrapAround, to move to closest slide. #113
proto._wrapSelect = function( index ) {
  var len = this.slides.length;
  var isWrapping = this.options.wrapAround && len > 1;
  if ( !isWrapping ) {
    return index;
  }
  var wrapIndex = utils.modulo( index, len );
  // go to shortest
  var delta = Math.abs( wrapIndex - this.selectedIndex );
  var backWrapDelta = Math.abs( ( wrapIndex + len ) - this.selectedIndex );
  var forewardWrapDelta = Math.abs( ( wrapIndex - len ) - this.selectedIndex );
  if ( !this.isDragSelect && backWrapDelta < delta ) {
    index += len;
  } else if ( !this.isDragSelect && forewardWrapDelta < delta ) {
    index -= len;
  }
  // wrap position so slider is within normal area
  if ( index < 0 ) {
    this.x -= this.slideableWidth;
  } else if ( index >= len ) {
    this.x += this.slideableWidth;
  }
};

proto.previous = function( isWrap, isInstant ) {
  this.select( this.selectedIndex - 1, isWrap, isInstant );
};

proto.next = function( isWrap, isInstant ) {
  this.select( this.selectedIndex + 1, isWrap, isInstant );
};

proto.updateSelectedSlide = function() {
  var slide = this.slides[ this.selectedIndex ];
  // selectedIndex could be outside of slides, if triggered before resize()
  if ( !slide ) {
    return;
  }
  // unselect previous selected slide
  this.unselectSelectedSlide();
  // update new selected slide
  this.selectedSlide = slide;
  slide.select();
  this.selectedCells = slide.cells;
  this.selectedElements = slide.getCellElements();
  // HACK: selectedCell & selectedElement is first cell in slide, backwards compatibility
  // Remove in v3?
  this.selectedCell = slide.cells[0];
  this.selectedElement = this.selectedElements[0];
};

proto.unselectSelectedSlide = function() {
  if ( this.selectedSlide ) {
    this.selectedSlide.unselect();
  }
};

proto.selectInitialIndex = function() {
  var initialIndex = this.options.initialIndex;
  // already activated, select previous selectedIndex
  if ( this.isInitActivated ) {
    this.select( this.selectedIndex, false, true );
    return;
  }
  // select with selector string
  if ( initialIndex && typeof initialIndex == 'string' ) {
    var cell = this.queryCell( initialIndex );
    if ( cell ) {
      this.selectCell( initialIndex, false, true );
      return;
    }
  }

  var index = 0;
  // select with number
  if ( initialIndex && this.slides[ initialIndex ] ) {
    index = initialIndex;
  }
  // select instantly
  this.select( index, false, true );
};

/**
 * select slide from number or cell element
 * @param {[Element, Number]} value - zero-based index or element to select
 * @param {Boolean} isWrap - enables wrapping around for extra index
 * @param {Boolean} isInstant - disables slide animation
 */
proto.selectCell = function( value, isWrap, isInstant ) {
  // get cell
  var cell = this.queryCell( value );
  if ( !cell ) {
    return;
  }

  var index = this.getCellSlideIndex( cell );
  this.select( index, isWrap, isInstant );
};

proto.getCellSlideIndex = function( cell ) {
  // get index of slides that has cell
  for ( var i = 0; i < this.slides.length; i++ ) {
    var slide = this.slides[i];
    var index = slide.cells.indexOf( cell );
    if ( index != -1 ) {
      return i;
    }
  }
};

// -------------------------- get cells -------------------------- //

/**
 * get Flickity.Cell, given an Element
 * @param {Element} elem - matching cell element
 * @returns {Flickity.Cell} cell - matching cell
 */
proto.getCell = function( elem ) {
  // loop through cells to get the one that matches
  for ( var i = 0; i < this.cells.length; i++ ) {
    var cell = this.cells[i];
    if ( cell.element == elem ) {
      return cell;
    }
  }
};

/**
 * get collection of Flickity.Cells, given Elements
 * @param {[Element, Array, NodeList]} elems - multiple elements
 * @returns {Array} cells - Flickity.Cells
 */
proto.getCells = function( elems ) {
  elems = utils.makeArray( elems );
  var cells = [];
  elems.forEach( function( elem ) {
    var cell = this.getCell( elem );
    if ( cell ) {
      cells.push( cell );
    }
  }, this );
  return cells;
};

/**
 * get cell elements
 * @returns {Array} cellElems
 */
proto.getCellElements = function() {
  return this.cells.map( function( cell ) {
    return cell.element;
  } );
};

/**
 * get parent cell from an element
 * @param {Element} elem - child element
 * @returns {Flickit.Cell} cell - parent cell
 */
proto.getParentCell = function( elem ) {
  // first check if elem is cell
  var cell = this.getCell( elem );
  if ( cell ) {
    return cell;
  }
  // try to get parent cell elem
  elem = utils.getParent( elem, '.flickity-slider > *' );
  return this.getCell( elem );
};

/**
 * get cells adjacent to a slide
 * @param {Integer} adjCount - number of adjacent slides
 * @param {Integer} index - index of slide to start
 * @returns {Array} cells - array of Flickity.Cells
 */
proto.getAdjacentCellElements = function( adjCount, index ) {
  if ( !adjCount ) {
    return this.selectedSlide.getCellElements();
  }
  index = index === undefined ? this.selectedIndex : index;

  var len = this.slides.length;
  if ( 1 + ( adjCount * 2 ) >= len ) {
    return this.getCellElements();
  }

  var cellElems = [];
  for ( var i = index - adjCount; i <= index + adjCount; i++ ) {
    var slideIndex = this.options.wrapAround ? utils.modulo( i, len ) : i;
    var slide = this.slides[ slideIndex ];
    if ( slide ) {
      cellElems = cellElems.concat( slide.getCellElements() );
    }
  }
  return cellElems;
};

/**
 * select slide from number or cell element
 * @param {[Element, String, Number]} selector - element, selector string, or index
 * @returns {Flickity.Cell} - matching cell
 */
proto.queryCell = function( selector ) {
  if ( typeof selector == 'number' ) {
    // use number as index
    return this.cells[ selector ];
  }
  if ( typeof selector == 'string' ) {
    // do not select invalid selectors from hash: #123, #/. #791
    if ( selector.match( /^[#.]?[\d/]/ ) ) {
      return;
    }
    // use string as selector, get element
    selector = this.element.querySelector( selector );
  }
  // get cell from element
  return this.getCell( selector );
};

// -------------------------- events -------------------------- //

proto.uiChange = function() {
  this.emitEvent('uiChange');
};

// keep focus on element when child UI elements are clicked
proto.childUIPointerDown = function( event ) {
  // HACK iOS does not allow touch events to bubble up?!
  if ( event.type != 'touchstart' ) {
    event.preventDefault();
  }
  this.focus();
};

// ----- resize ----- //

proto.onresize = function() {
  this.watchCSS();
  this.resize();
};

utils.debounceMethod( Flickity, 'onresize', 150 );

proto.resize = function() {
  if ( !this.isActive ) {
    return;
  }
  this.getSize();
  // wrap values
  if ( this.options.wrapAround ) {
    this.x = utils.modulo( this.x, this.slideableWidth );
  }
  this.positionCells();
  this._getWrapShiftCells();
  this.setGallerySize();
  this.emitEvent('resize');
  // update selected index for group slides, instant
  // TODO: position can be lost between groups of various numbers
  var selectedElement = this.selectedElements && this.selectedElements[0];
  this.selectCell( selectedElement, false, true );
};

// watches the :after property, activates/deactivates
proto.watchCSS = function() {
  var watchOption = this.options.watchCSS;
  if ( !watchOption ) {
    return;
  }

  var afterContent = getComputedStyle( this.element, ':after' ).content;
  // activate if :after { content: 'flickity' }
  if ( afterContent.indexOf('flickity') != -1 ) {
    this.activate();
  } else {
    this.deactivate();
  }
};

// ----- keydown ----- //

// go previous/next if left/right keys pressed
proto.onkeydown = function( event ) {
  // only work if element is in focus
  var isNotFocused = document.activeElement && document.activeElement != this.element;
  if ( !this.options.accessibility || isNotFocused ) {
    return;
  }

  var handler = Flickity.keyboardHandlers[ event.keyCode ];
  if ( handler ) {
    handler.call( this );
  }
};

Flickity.keyboardHandlers = {
  // left arrow
  37: function() {
    var leftMethod = this.options.rightToLeft ? 'next' : 'previous';
    this.uiChange();
    this[ leftMethod ]();
  },
  // right arrow
  39: function() {
    var rightMethod = this.options.rightToLeft ? 'previous' : 'next';
    this.uiChange();
    this[ rightMethod ]();
  },
};

// ----- focus ----- //

proto.focus = function() {
  // TODO remove scrollTo once focus options gets more support
  // https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/focus ...
  //    #Browser_compatibility
  var prevScrollY = window.pageYOffset;
  this.element.focus({ preventScroll: true });
  // hack to fix scroll jump after focus, #76
  if ( window.pageYOffset != prevScrollY ) {
    window.scrollTo( window.pageXOffset, prevScrollY );
  }
};

// -------------------------- destroy -------------------------- //

// deactivate all Flickity functionality, but keep stuff available
proto.deactivate = function() {
  if ( !this.isActive ) {
    return;
  }
  this.element.classList.remove('flickity-enabled');
  this.element.classList.remove('flickity-rtl');
  this.unselectSelectedSlide();
  // destroy cells
  this.cells.forEach( function( cell ) {
    cell.destroy();
  } );
  this.element.removeChild( this.viewport );
  // move child elements back into element
  moveElements( this.slider.children, this.element );
  if ( this.options.accessibility ) {
    this.element.removeAttribute('tabIndex');
    this.element.removeEventListener( 'keydown', this );
  }
  // set flags
  this.isActive = false;
  this.emitEvent('deactivate');
};

proto.destroy = function() {
  this.deactivate();
  window.removeEventListener( 'resize', this );
  this.allOff();
  this.emitEvent('destroy');
  if ( jQuery && this.$element ) {
    jQuery.removeData( this.element, 'flickity' );
  }
  delete this.element.flickityGUID;
  delete instances[ this.guid ];
};

// -------------------------- prototype -------------------------- //

utils.extend( proto, animatePrototype );

// -------------------------- extras -------------------------- //

/**
 * get Flickity instance from element
 * @param {[Element, String]} elem - element or selector string
 * @returns {Flickity} - Flickity instance
 */
Flickity.data = function( elem ) {
  elem = utils.getQueryElement( elem );
  var id = elem && elem.flickityGUID;
  return id && instances[ id ];
};

utils.htmlInit( Flickity, 'flickity' );

if ( jQuery && jQuery.bridget ) {
  jQuery.bridget( 'flickity', Flickity );
}

// set internal jQuery, for Webpack + jQuery v3, #478
Flickity.setJQuery = function( jq ) {
  jQuery = jq;
};

Flickity.Cell = Cell;
Flickity.Slide = Slide;

return Flickity;

} ) );


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(9);

var ReactBaseClasses = __webpack_require__(97);
var ReactChildren = __webpack_require__(177);
var ReactDOMFactories = __webpack_require__(182);
var ReactElement = __webpack_require__(30);
var ReactPropTypes = __webpack_require__(183);
var ReactVersion = __webpack_require__(187);

var createReactClass = __webpack_require__(188);
var onlyChild = __webpack_require__(190);

var createElement = ReactElement.createElement;
var createFactory = ReactElement.createFactory;
var cloneElement = ReactElement.cloneElement;

if (false) {
  var lowPriorityWarning = require('./lowPriorityWarning');
  var canDefineProperty = require('./canDefineProperty');
  var ReactElementValidator = require('./ReactElementValidator');
  var didWarnPropTypesDeprecated = false;
  createElement = ReactElementValidator.createElement;
  createFactory = ReactElementValidator.createFactory;
  cloneElement = ReactElementValidator.cloneElement;
}

var __spread = _assign;
var createMixin = function (mixin) {
  return mixin;
};

if (false) {
  var warnedForSpread = false;
  var warnedForCreateMixin = false;
  __spread = function () {
    lowPriorityWarning(warnedForSpread, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.');
    warnedForSpread = true;
    return _assign.apply(null, arguments);
  };

  createMixin = function (mixin) {
    lowPriorityWarning(warnedForCreateMixin, 'React.createMixin is deprecated and should not be used. ' + 'In React v16.0, it will be removed. ' + 'You can use this mixin directly instead. ' + 'See https://fb.me/createmixin-was-never-implemented for more info.');
    warnedForCreateMixin = true;
    return mixin;
  };
}

var React = {
  // Modern

  Children: {
    map: ReactChildren.map,
    forEach: ReactChildren.forEach,
    count: ReactChildren.count,
    toArray: ReactChildren.toArray,
    only: onlyChild
  },

  Component: ReactBaseClasses.Component,
  PureComponent: ReactBaseClasses.PureComponent,

  createElement: createElement,
  cloneElement: cloneElement,
  isValidElement: ReactElement.isValidElement,

  // Classic

  PropTypes: ReactPropTypes,
  createClass: createReactClass,
  createFactory: createFactory,
  createMixin: createMixin,

  // This looks DOM specific but these are actually isomorphic helpers
  // since they are just generating DOM strings.
  DOM: ReactDOMFactories,

  version: ReactVersion,

  // Deprecated hook for JSX spread, don't use this for anything.
  __spread: __spread
};

if (false) {
  var warnedForCreateClass = false;
  if (canDefineProperty) {
    Object.defineProperty(React, 'PropTypes', {
      get: function () {
        lowPriorityWarning(didWarnPropTypesDeprecated, 'Accessing PropTypes via the main React package is deprecated,' + ' and will be removed in  React v16.0.' + ' Use the latest available v15.* prop-types package from npm instead.' + ' For info on usage, compatibility, migration and more, see ' + 'https://fb.me/prop-types-docs');
        didWarnPropTypesDeprecated = true;
        return ReactPropTypes;
      }
    });

    Object.defineProperty(React, 'createClass', {
      get: function () {
        lowPriorityWarning(warnedForCreateClass, 'Accessing createClass via the main React package is deprecated,' + ' and will be removed in React v16.0.' + " Use a plain JavaScript class instead. If you're not yet " + 'ready to migrate, create-react-class v15.* is available ' + 'on npm as a temporary, drop-in replacement. ' + 'For more info see https://fb.me/react-create-class');
        warnedForCreateClass = true;
        return createReactClass;
      }
    });
  }

  // React.DOM factories are deprecated. Wrap these methods so that
  // invocations of the React.DOM namespace and alert users to switch
  // to the `react-dom-factories` package.
  React.DOM = {};
  var warnedForFactories = false;
  Object.keys(ReactDOMFactories).forEach(function (factory) {
    React.DOM[factory] = function () {
      if (!warnedForFactories) {
        lowPriorityWarning(false, 'Accessing factories like React.DOM.%s has been deprecated ' + 'and will be removed in v16.0+. Use the ' + 'react-dom-factories package instead. ' + ' Version 1.0 provides a drop-in replacement.' + ' For more info, see https://fb.me/react-dom-factories', factory);
        warnedForFactories = true;
      }
      return ReactDOMFactories[factory].apply(ReactDOMFactories, arguments);
    };
  });
}

module.exports = React;

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(9);

var ReactCurrentOwner = __webpack_require__(22);

var warning = __webpack_require__(7);
var canDefineProperty = __webpack_require__(99);
var hasOwnProperty = Object.prototype.hasOwnProperty;

var REACT_ELEMENT_TYPE = __webpack_require__(100);

var RESERVED_PROPS = {
  key: true,
  ref: true,
  __self: true,
  __source: true
};

var specialPropKeyWarningShown, specialPropRefWarningShown;

function hasValidRef(config) {
  if (false) {
    if (hasOwnProperty.call(config, 'ref')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }
  return config.ref !== undefined;
}

function hasValidKey(config) {
  if (false) {
    if (hasOwnProperty.call(config, 'key')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }
  return config.key !== undefined;
}

function defineKeyPropWarningGetter(props, displayName) {
  var warnAboutAccessingKey = function () {
    if (!specialPropKeyWarningShown) {
      specialPropKeyWarningShown = true;
       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
    }
  };
  warnAboutAccessingKey.isReactWarning = true;
  Object.defineProperty(props, 'key', {
    get: warnAboutAccessingKey,
    configurable: true
  });
}

function defineRefPropWarningGetter(props, displayName) {
  var warnAboutAccessingRef = function () {
    if (!specialPropRefWarningShown) {
      specialPropRefWarningShown = true;
       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
    }
  };
  warnAboutAccessingRef.isReactWarning = true;
  Object.defineProperty(props, 'ref', {
    get: warnAboutAccessingRef,
    configurable: true
  });
}

/**
 * Factory method to create a new React element. This no longer adheres to
 * the class pattern, so do not use new to call it. Also, no instanceof check
 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
 * if something is a React Element.
 *
 * @param {*} type
 * @param {*} key
 * @param {string|object} ref
 * @param {*} self A *temporary* helper to detect places where `this` is
 * different from the `owner` when React.createElement is called, so that we
 * can warn. We want to get rid of owner and replace string `ref`s with arrow
 * functions, and as long as `this` and owner are the same, there will be no
 * change in behavior.
 * @param {*} source An annotation object (added by a transpiler or otherwise)
 * indicating filename, line number, and/or other information.
 * @param {*} owner
 * @param {*} props
 * @internal
 */
var ReactElement = function (type, key, ref, self, source, owner, props) {
  var element = {
    // This tag allow us to uniquely identify this as a React Element
    $$typeof: REACT_ELEMENT_TYPE,

    // Built-in properties that belong on the element
    type: type,
    key: key,
    ref: ref,
    props: props,

    // Record the component responsible for creating this element.
    _owner: owner
  };

  if (false) {
    // The validation flag is currently mutative. We put it on
    // an external backing store so that we can freeze the whole object.
    // This can be replaced with a WeakMap once they are implemented in
    // commonly used development environments.
    element._store = {};

    // To make comparing ReactElements easier for testing purposes, we make
    // the validation flag non-enumerable (where possible, which should
    // include every environment we run tests in), so the test framework
    // ignores it.
    if (canDefineProperty) {
      Object.defineProperty(element._store, 'validated', {
        configurable: false,
        enumerable: false,
        writable: true,
        value: false
      });
      // self and source are DEV only properties.
      Object.defineProperty(element, '_self', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: self
      });
      // Two elements created in two different places should be considered
      // equal for testing purposes and therefore we hide it from enumeration.
      Object.defineProperty(element, '_source', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: source
      });
    } else {
      element._store.validated = false;
      element._self = self;
      element._source = source;
    }
    if (Object.freeze) {
      Object.freeze(element.props);
      Object.freeze(element);
    }
  }

  return element;
};

/**
 * Create and return a new ReactElement of the given type.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
 */
ReactElement.createElement = function (type, config, children) {
  var propName;

  // Reserved names are extracted
  var props = {};

  var key = null;
  var ref = null;
  var self = null;
  var source = null;

  if (config != null) {
    if (hasValidRef(config)) {
      ref = config.ref;
    }
    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    self = config.__self === undefined ? null : config.__self;
    source = config.__source === undefined ? null : config.__source;
    // Remaining properties are added to a new props object
    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        props[propName] = config[propName];
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    if (false) {
      if (Object.freeze) {
        Object.freeze(childArray);
      }
    }
    props.children = childArray;
  }

  // Resolve default props
  if (type && type.defaultProps) {
    var defaultProps = type.defaultProps;
    for (propName in defaultProps) {
      if (props[propName] === undefined) {
        props[propName] = defaultProps[propName];
      }
    }
  }
  if (false) {
    if (key || ref) {
      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
        if (key) {
          defineKeyPropWarningGetter(props, displayName);
        }
        if (ref) {
          defineRefPropWarningGetter(props, displayName);
        }
      }
    }
  }
  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
};

/**
 * Return a function that produces ReactElements of a given type.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
 */
ReactElement.createFactory = function (type) {
  var factory = ReactElement.createElement.bind(null, type);
  // Expose the type on the factory and the prototype so that it can be
  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
  // This should not be named `constructor` since this may not be the function
  // that created the element, and it may not even be a constructor.
  // Legacy hook TODO: Warn if this is accessed
  factory.type = type;
  return factory;
};

ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);

  return newElement;
};

/**
 * Clone and return a new ReactElement using element as the starting point.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
 */
ReactElement.cloneElement = function (element, config, children) {
  var propName;

  // Original props are copied
  var props = _assign({}, element.props);

  // Reserved names are extracted
  var key = element.key;
  var ref = element.ref;
  // Self is preserved since the owner is preserved.
  var self = element._self;
  // Source is preserved since cloneElement is unlikely to be targeted by a
  // transpiler, and the original source is probably a better indicator of the
  // true owner.
  var source = element._source;

  // Owner will be preserved, unless ref is overridden
  var owner = element._owner;

  if (config != null) {
    if (hasValidRef(config)) {
      // Silently steal the ref from the parent.
      ref = config.ref;
      owner = ReactCurrentOwner.current;
    }
    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    // Remaining properties override existing props
    var defaultProps;
    if (element.type && element.type.defaultProps) {
      defaultProps = element.type.defaultProps;
    }
    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        if (config[propName] === undefined && defaultProps !== undefined) {
          // Resolve default props
          props[propName] = defaultProps[propName];
        } else {
          props[propName] = config[propName];
        }
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    props.children = childArray;
  }

  return ReactElement(element.type, key, ref, self, source, owner, props);
};

/**
 * Verifies the object is a ReactElement.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
 * @param {?object} object
 * @return {boolean} True if `object` is a valid component.
 * @final
 */
ReactElement.isValidElement = function (object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
};

module.exports = ReactElement;

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(6);

var invariant = __webpack_require__(4);

function checkMask(value, bitmask) {
  return (value & bitmask) === bitmask;
}

var DOMPropertyInjection = {
  /**
   * Mapping from normalized, camelcased property names to a configuration that
   * specifies how the associated DOM property should be accessed or rendered.
   */
  MUST_USE_PROPERTY: 0x1,
  HAS_BOOLEAN_VALUE: 0x4,
  HAS_NUMERIC_VALUE: 0x8,
  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,

  /**
   * Inject some specialized knowledge about the DOM. This takes a config object
   * with the following properties:
   *
   * isCustomAttribute: function that given an attribute name will return true
   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
   * attributes where it's impossible to enumerate all of the possible
   * attribute names,
   *
   * Properties: object mapping DOM property name to one of the
   * DOMPropertyInjection constants or null. If your attribute isn't in here,
   * it won't get written to the DOM.
   *
   * DOMAttributeNames: object mapping React attribute name to the DOM
   * attribute name. Attribute names not specified use the **lowercase**
   * normalized name.
   *
   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
   * attribute namespace URL. (Attribute names not specified use no namespace.)
   *
   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
   * Property names not specified use the normalized name.
   *
   * DOMMutationMethods: Properties that require special mutation methods. If
   * `value` is undefined, the mutation method should unset the property.
   *
   * @param {object} domPropertyConfig the config as described above.
   */
  injectDOMPropertyConfig: function (domPropertyConfig) {
    var Injection = DOMPropertyInjection;
    var Properties = domPropertyConfig.Properties || {};
    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};

    if (domPropertyConfig.isCustomAttribute) {
      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
    }

    for (var propName in Properties) {
      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property \'%s\' which has already been injected. You may be accidentally injecting the same DOM property config twice, or you may be injecting two configs that have conflicting property names.', propName) : _prodInvariant('48', propName) : void 0;

      var lowerCased = propName.toLowerCase();
      var propConfig = Properties[propName];

      var propertyInfo = {
        attributeName: lowerCased,
        attributeNamespace: null,
        propertyName: propName,
        mutationMethod: null,

        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
      };
      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or numeric value, but not a combination: %s', propName) : _prodInvariant('50', propName) : void 0;

      if (false) {
        DOMProperty.getPossibleStandardName[lowerCased] = propName;
      }

      if (DOMAttributeNames.hasOwnProperty(propName)) {
        var attributeName = DOMAttributeNames[propName];
        propertyInfo.attributeName = attributeName;
        if (false) {
          DOMProperty.getPossibleStandardName[attributeName] = propName;
        }
      }

      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
      }

      if (DOMPropertyNames.hasOwnProperty(propName)) {
        propertyInfo.propertyName = DOMPropertyNames[propName];
      }

      if (DOMMutationMethods.hasOwnProperty(propName)) {
        propertyInfo.mutationMethod = DOMMutationMethods[propName];
      }

      DOMProperty.properties[propName] = propertyInfo;
    }
  }
};

/* eslint-disable max-len */
var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
/* eslint-enable max-len */

/**
 * DOMProperty exports lookup objects that can be used like functions:
 *
 *   > DOMProperty.isValid['id']
 *   true
 *   > DOMProperty.isValid['foobar']
 *   undefined
 *
 * Although this may be confusing, it performs better in general.
 *
 * @see http://jsperf.com/key-exists
 * @see http://jsperf.com/key-missing
 */
var DOMProperty = {
  ID_ATTRIBUTE_NAME: 'data-reactid',
  ROOT_ATTRIBUTE_NAME: 'data-reactroot',

  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040',

  /**
   * Map from property "standard name" to an object with info about how to set
   * the property in the DOM. Each object contains:
   *
   * attributeName:
   *   Used when rendering markup or with `*Attribute()`.
   * attributeNamespace
   * propertyName:
   *   Used on DOM node instances. (This includes properties that mutate due to
   *   external factors.)
   * mutationMethod:
   *   If non-null, used instead of the property or `setAttribute()` after
   *   initial render.
   * mustUseProperty:
   *   Whether the property must be accessed and mutated as an object property.
   * hasBooleanValue:
   *   Whether the property should be removed when set to a falsey value.
   * hasNumericValue:
   *   Whether the property must be numeric or parse as a numeric and should be
   *   removed when set to a falsey value.
   * hasPositiveNumericValue:
   *   Whether the property must be positive numeric or parse as a positive
   *   numeric and should be removed when set to a falsey value.
   * hasOverloadedBooleanValue:
   *   Whether the property can be used as a flag as well as with a value.
   *   Removed when strictly equal to false; present without a value when
   *   strictly equal to true; present with a value otherwise.
   */
  properties: {},

  /**
   * Mapping from lowercase property names to the properly cased version, used
   * to warn in the case of missing properties. Available only in __DEV__.
   *
   * autofocus is predefined, because adding it to the property whitelist
   * causes unintended side effects.
   *
   * @type {Object}
   */
  getPossibleStandardName:  false ? { autofocus: 'autoFocus' } : null,

  /**
   * All of the isCustomAttribute() functions that have been injected.
   */
  _isCustomAttributeFunctions: [],

  /**
   * Checks whether a property name is a custom attribute.
   * @method
   */
  isCustomAttribute: function (attributeName) {
    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
      if (isCustomAttributeFn(attributeName)) {
        return true;
      }
    }
    return false;
  },

  injection: DOMPropertyInjection
};

module.exports = DOMProperty;

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactRef = __webpack_require__(199);
var ReactInstrumentation = __webpack_require__(18);

var warning = __webpack_require__(7);

/**
 * Helper to call ReactRef.attachRefs with this composite component, split out
 * to avoid allocations in the transaction mount-ready queue.
 */
function attachRefs() {
  ReactRef.attachRefs(this, this._currentElement);
}

var ReactReconciler = {
  /**
   * Initializes the component, renders markup, and registers event listeners.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {?object} the containing host component instance
   * @param {?object} info about the host container
   * @return {?string} Rendered markup to be inserted into the DOM.
   * @final
   * @internal
   */
  mountComponent: function (internalInstance, transaction, hostParent, hostContainerInfo, context, parentDebugID) // 0 in production and for roots
  {
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeMountComponent(internalInstance._debugID, internalInstance._currentElement, parentDebugID);
      }
    }
    var markup = internalInstance.mountComponent(transaction, hostParent, hostContainerInfo, context, parentDebugID);
    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
    }
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onMountComponent(internalInstance._debugID);
      }
    }
    return markup;
  },

  /**
   * Returns a value that can be passed to
   * ReactComponentEnvironment.replaceNodeWithMarkup.
   */
  getHostNode: function (internalInstance) {
    return internalInstance.getHostNode();
  },

  /**
   * Releases any resources allocated by `mountComponent`.
   *
   * @final
   * @internal
   */
  unmountComponent: function (internalInstance, safely) {
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeUnmountComponent(internalInstance._debugID);
      }
    }
    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
    internalInstance.unmountComponent(safely);
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onUnmountComponent(internalInstance._debugID);
      }
    }
  },

  /**
   * Update a component using a new element.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactElement} nextElement
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   * @internal
   */
  receiveComponent: function (internalInstance, nextElement, transaction, context) {
    var prevElement = internalInstance._currentElement;

    if (nextElement === prevElement && context === internalInstance._context) {
      // Since elements are immutable after the owner is rendered,
      // we can do a cheap identity compare here to determine if this is a
      // superfluous reconcile. It's possible for state to be mutable but such
      // change should trigger an update of the owner which would recreate
      // the element. We explicitly check for the existence of an owner since
      // it's possible for an element created outside a composite to be
      // deeply mutated and reused.

      // TODO: Bailing out early is just a perf optimization right?
      // TODO: Removing the return statement should affect correctness?
      return;
    }

    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, nextElement);
      }
    }

    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);

    if (refsChanged) {
      ReactRef.detachRefs(internalInstance, prevElement);
    }

    internalInstance.receiveComponent(nextElement, transaction, context);

    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
    }

    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
      }
    }
  },

  /**
   * Flush any dirty changes in a component.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  performUpdateIfNecessary: function (internalInstance, transaction, updateBatchNumber) {
    if (internalInstance._updateBatchNumber !== updateBatchNumber) {
      // The component's enqueued batch number should always be the current
      // batch or the following one.
       false ? warning(internalInstance._updateBatchNumber == null || internalInstance._updateBatchNumber === updateBatchNumber + 1, 'performUpdateIfNecessary: Unexpected batch number (current %s, ' + 'pending %s)', updateBatchNumber, internalInstance._updateBatchNumber) : void 0;
      return;
    }
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, internalInstance._currentElement);
      }
    }
    internalInstance.performUpdateIfNecessary(transaction);
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
      }
    }
  }
};

module.exports = ReactReconciler;

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var DOMNamespaces = __webpack_require__(74);
var setInnerHTML = __webpack_require__(52);

var createMicrosoftUnsafeLocalFunction = __webpack_require__(75);
var setTextContent = __webpack_require__(112);

var ELEMENT_NODE_TYPE = 1;
var DOCUMENT_FRAGMENT_NODE_TYPE = 11;

/**
 * In IE (8-11) and Edge, appending nodes with no children is dramatically
 * faster than appending a full subtree, so we essentially queue up the
 * .appendChild calls here and apply them so each node is added to its parent
 * before any children are added.
 *
 * In other browsers, doing so is slower or neutral compared to the other order
 * (in Firefox, twice as slow) so we only do this inversion in IE.
 *
 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
 */
var enableLazy = typeof document !== 'undefined' && typeof document.documentMode === 'number' || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && /\bEdge\/\d/.test(navigator.userAgent);

function insertTreeChildren(tree) {
  if (!enableLazy) {
    return;
  }
  var node = tree.node;
  var children = tree.children;
  if (children.length) {
    for (var i = 0; i < children.length; i++) {
      insertTreeBefore(node, children[i], null);
    }
  } else if (tree.html != null) {
    setInnerHTML(node, tree.html);
  } else if (tree.text != null) {
    setTextContent(node, tree.text);
  }
}

var insertTreeBefore = createMicrosoftUnsafeLocalFunction(function (parentNode, tree, referenceNode) {
  // DocumentFragments aren't actually part of the DOM after insertion so
  // appending children won't update the DOM. We need to ensure the fragment
  // is properly populated first, breaking out of our lazy approach for just
  // this level. Also, some <object> plugins (like Flash Player) will read
  // <param> nodes immediately upon insertion into the DOM, so <object>
  // must also be populated prior to insertion into the DOM.
  if (tree.node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE || tree.node.nodeType === ELEMENT_NODE_TYPE && tree.node.nodeName.toLowerCase() === 'object' && (tree.node.namespaceURI == null || tree.node.namespaceURI === DOMNamespaces.html)) {
    insertTreeChildren(tree);
    parentNode.insertBefore(tree.node, referenceNode);
  } else {
    parentNode.insertBefore(tree.node, referenceNode);
    insertTreeChildren(tree);
  }
});

function replaceChildWithTree(oldNode, newTree) {
  oldNode.parentNode.replaceChild(newTree.node, oldNode);
  insertTreeChildren(newTree);
}

function queueChild(parentTree, childTree) {
  if (enableLazy) {
    parentTree.children.push(childTree);
  } else {
    parentTree.node.appendChild(childTree.node);
  }
}

function queueHTML(tree, html) {
  if (enableLazy) {
    tree.html = html;
  } else {
    setInnerHTML(tree.node, html);
  }
}

function queueText(tree, text) {
  if (enableLazy) {
    tree.text = text;
  } else {
    setTextContent(tree.node, text);
  }
}

function toString() {
  return this.node.nodeName;
}

function DOMLazyTree(node) {
  return {
    node: node,
    children: [],
    html: null,
    text: null,
    toString: toString
  };
}

DOMLazyTree.insertTreeBefore = insertTreeBefore;
DOMLazyTree.replaceChildWithTree = replaceChildWithTree;
DOMLazyTree.queueChild = queueChild;
DOMLazyTree.queueHTML = queueHTML;
DOMLazyTree.queueText = queueText;

module.exports = DOMLazyTree;

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createBrowserHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createHashHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return createMemoryHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return createLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return locationsAreEqual; });
/* unused harmony export parsePath */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return createPath; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_resolve_pathname__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_value_equal__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_tiny_warning__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_tiny_invariant__ = __webpack_require__(300);






function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
}
function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
}
function hasBasename(path, prefix) {
  return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && '/?#'.indexOf(path.charAt(prefix.length)) !== -1;
}
function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
}
function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';
  var hashIndex = pathname.indexOf('#');

  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');

  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
}
function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;
  var path = pathname || '/';
  if (search && search !== '?') path += search.charAt(0) === '?' ? search : "?" + search;
  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : "#" + hash;
  return path;
}

function createLocation(path, state, key, currentLocation) {
  var location;

  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = parsePath(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, path);
    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = Object(__WEBPACK_IMPORTED_MODULE_1_resolve_pathname__["a" /* default */])(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
}
function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && Object(__WEBPACK_IMPORTED_MODULE_2_value_equal__["a" /* default */])(a.state, b.state);
}

function createTransitionManager() {
  var prompt = null;

  function setPrompt(nextPrompt) {
     false ? warning(prompt == null, 'A history supports only one prompt at a time') : void 0;
    prompt = nextPrompt;
    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  }

  function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
           false ? warning(false, 'A history needs a getUserConfirmation function in order to use a prompt message') : void 0;
          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  }

  var listeners = [];

  function appendListener(fn) {
    var isActive = true;

    function listener() {
      if (isActive) fn.apply(void 0, arguments);
    }

    listeners.push(listener);
    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  }

  function notifyListeners() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(void 0, args);
    });
  }

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
}

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function getConfirmation(message, callback) {
  callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */

function supportsHistory() {
  var ua = window.navigator.userAgent;
  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
  return window.history && 'pushState' in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */

function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */

function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */

function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
}

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */


function createBrowserHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Browser history needs a DOM') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  var globalHistory = window.history;
  var canUseHistory = supportsHistory();
  var needsHashChangeListener = !supportsPopStateOnHashChange();
  var _props = props,
      _props$forceRefresh = _props.forceRefresh,
      forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';

  function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;
    var path = pathname + search + hash;
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path, state, key);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if (isExtraneousPopstateEvent(event)) return;
    handlePop(getDOMLocation(event.state));
  }

  function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  }

  var forceNextPop = false;

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allKeys.indexOf(fromLocation.key);
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  }

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key]; // Public interface

  function createHref(location) {
    return basename + createPath(location);
  }

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.pushState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex + 1);
          nextKeys.push(location.key);
          allKeys = nextKeys;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history') : void 0;
        window.location.href = href;
      }
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.replaceState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          if (prevIndex !== -1) allKeys[prevIndex] = location.key;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history') : void 0;
        window.location.replace(href);
      }
    });
  }

  function go(n) {
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.addEventListener(HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.removeEventListener(HashChangeEvent, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

var HashChangeEvent$1 = 'hashchange';
var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + stripLeadingSlash(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: stripLeadingSlash,
    decodePath: addLeadingSlash
  },
  slash: {
    encodePath: addLeadingSlash,
    decodePath: addLeadingSlash
  }
};

function stripHash(url) {
  var hashIndex = url.indexOf('#');
  return hashIndex === -1 ? url : url.slice(0, hashIndex);
}

function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
}

function pushHashPath(path) {
  window.location.hash = path;
}

function replaceHashPath(path) {
  window.location.replace(stripHash(window.location.href) + '#' + path);
}

function createHashHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Hash history needs a DOM') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  var globalHistory = window.history;
  var canGoWithoutReload = supportsGoWithoutReloadUsingHash();
  var _props = props,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$hashType = _props.hashType,
      hashType = _props$hashType === void 0 ? 'slash' : _props$hashType;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';
  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;

  function getDOMLocation() {
    var path = decodePath(getHashPath());
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  var forceNextPop = false;
  var ignorePath = null;

  function locationsAreEqual$$1(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
  }

  function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;
      if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === createPath(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;
      handlePop(location);
    }
  }

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf(createPath(toLocation));
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allPaths.lastIndexOf(createPath(fromLocation));
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  } // Ensure the hash is encoded properly before doing anything else.


  var path = getHashPath();
  var encodedPath = encodePath(path);
  if (path !== encodedPath) replaceHashPath(encodedPath);
  var initialLocation = getDOMLocation();
  var allPaths = [createPath(initialLocation)]; // Public interface

  function createHref(location) {
    var baseTag = document.querySelector('base');
    var href = '';

    if (baseTag && baseTag.getAttribute('href')) {
      href = stripHash(window.location.href);
    }

    return href + '#' + encodePath(basename + createPath(location));
  }

  function push(path, state) {
     false ? warning(state === undefined, 'Hash history cannot push state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);
        var prevIndex = allPaths.lastIndexOf(createPath(history.location));
        var nextPaths = allPaths.slice(0, prevIndex + 1);
        nextPaths.push(path);
        allPaths = nextPaths;
        setState({
          action: action,
          location: location
        });
      } else {
         false ? warning(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack') : void 0;
        setState();
      }
    });
  }

  function replace(path, state) {
     false ? warning(state === undefined, 'Hash history cannot replace state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf(createPath(history.location));
      if (prevIndex !== -1) allPaths[prevIndex] = path;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
     false ? warning(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : void 0;
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(HashChangeEvent$1, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(HashChangeEvent$1, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */


function createMemoryHistory(props) {
  if (props === void 0) {
    props = {};
  }

  var _props = props,
      getUserConfirmation = _props.getUserConfirmation,
      _props$initialEntries = _props.initialEntries,
      initialEntries = _props$initialEntries === void 0 ? ['/'] : _props$initialEntries,
      _props$initialIndex = _props.initialIndex,
      initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = history.entries.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? createLocation(entry, undefined, createKey()) : createLocation(entry, undefined, entry.key || createKey());
  }); // Public interface

  var createHref = createPath;

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;
      var nextEntries = history.entries.slice(0);

      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      history.entries[history.index] = location;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);
    var action = 'POP';
    var location = history.entries[nextIndex];
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  }

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    return transitionManager.setPrompt(prompt);
  }

  function listen(listener) {
    return transitionManager.appendListener(listener);
  }

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };
  return history;
}




/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export mapProps */
/* unused harmony export withProps */
/* unused harmony export withPropsOnChange */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return withHandlers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return defaultProps; });
/* unused harmony export renameProp */
/* unused harmony export renameProps */
/* unused harmony export flattenProp */
/* unused harmony export withState */
/* unused harmony export withStateHandlers */
/* unused harmony export withReducer */
/* unused harmony export branch */
/* unused harmony export renderComponent */
/* unused harmony export renderNothing */
/* unused harmony export shouldUpdate */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return pure; });
/* unused harmony export onlyUpdateForKeys */
/* unused harmony export onlyUpdateForPropTypes */
/* unused harmony export withContext */
/* unused harmony export getContext */
/* unused harmony export lifecycle */
/* unused harmony export toClass */
/* unused harmony export setStatic */
/* unused harmony export setPropTypes */
/* unused harmony export setDisplayName */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return compose; });
/* unused harmony export getDisplayName */
/* unused harmony export wrapDisplayName */
/* unused harmony export isClassComponent */
/* unused harmony export createEagerElement */
/* unused harmony export createEagerFactory */
/* unused harmony export createSink */
/* unused harmony export componentFromProp */
/* unused harmony export nest */
/* unused harmony export hoistStatics */
/* unused harmony export componentFromStream */
/* unused harmony export componentFromStreamWithConfig */
/* unused harmony export mapPropsStream */
/* unused harmony export mapPropsStreamWithConfig */
/* unused harmony export createEventHandler */
/* unused harmony export createEventHandlerWithConfig */
/* unused harmony export setObservableConfig */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_change_emitter__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_change_emitter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_change_emitter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_symbol_observable__ = __webpack_require__(135);
/* unused harmony reexport shallowEqual */






var setStatic = function setStatic(key, value) {
  return function (BaseComponent) {
    /* eslint-disable no-param-reassign */
    BaseComponent[key] = value;
    /* eslint-enable no-param-reassign */
    return BaseComponent;
  };
};

var setDisplayName = function setDisplayName(displayName) {
  return setStatic('displayName', displayName);
};

var getDisplayName = function getDisplayName(Component$$1) {
  if (typeof Component$$1 === 'string') {
    return Component$$1;
  }

  if (!Component$$1) {
    return undefined;
  }

  return Component$$1.displayName || Component$$1.name || 'Component';
};

var wrapDisplayName = function wrapDisplayName(BaseComponent, hocName) {
  return hocName + '(' + getDisplayName(BaseComponent) + ')';
};

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};









var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};



var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};









var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var createEagerElementUtil = function createEagerElementUtil(hasKey, isReferentiallyTransparent, type, props, children) {
  if ("production" === 'production' && !hasKey && isReferentiallyTransparent) {
    if (children) {
      return type(_extends({}, props, { children: children }));
    }
    return type(props);
  }

  var Component$$1 = type;

  if (children) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      Component$$1,
      props,
      children
    );
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component$$1, props);
};

var isClassComponent = function isClassComponent(Component$$1) {
  return Boolean(Component$$1 && Component$$1.prototype && typeof Component$$1.prototype.render === 'function');
};

var isReferentiallyTransparentFunctionComponent = function isReferentiallyTransparentFunctionComponent(Component$$1) {
  return Boolean(typeof Component$$1 === 'function' && !isClassComponent(Component$$1) && !Component$$1.defaultProps && !Component$$1.contextTypes);
};

var createFactory = function createFactory(type) {
  var isReferentiallyTransparent = isReferentiallyTransparentFunctionComponent(type);
  return function (p, c) {
    return createEagerElementUtil(false, isReferentiallyTransparent, type, p, c);
  };
};

var mapProps = function mapProps(propsMapper) {
  return function (BaseComponent) {
    var factory = createFactory(BaseComponent);
    var MapProps = function MapProps(props) {
      return factory(propsMapper(props));
    };
    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'mapProps'))(MapProps);
    }
    return MapProps;
  };
};

var withProps = function withProps(input) {
  var hoc = mapProps(function (props) {
    return _extends({}, props, typeof input === 'function' ? input(props) : input);
  });
  if (false) {
    return function (BaseComponent) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withProps'))(hoc(BaseComponent));
    };
  }
  return hoc;
};

var pick = function pick(obj, keys) {
  var result = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (obj.hasOwnProperty(key)) {
      result[key] = obj[key];
    }
  }
  return result;
};

var withPropsOnChange = function withPropsOnChange(shouldMapOrKeys, propsMapper) {
  return function (BaseComponent) {
    var factory = createFactory(BaseComponent);
    var shouldMap = typeof shouldMapOrKeys === 'function' ? shouldMapOrKeys : function (props, nextProps) {
      return !__WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual___default()(pick(props, shouldMapOrKeys), pick(nextProps, shouldMapOrKeys));
    };

    var WithPropsOnChange = function (_Component) {
      inherits(WithPropsOnChange, _Component);

      function WithPropsOnChange() {
        var _temp, _this, _ret;

        classCallCheck(this, WithPropsOnChange);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.computedProps = propsMapper(_this.props), _temp), possibleConstructorReturn(_this, _ret);
      }

      WithPropsOnChange.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        if (shouldMap(this.props, nextProps)) {
          this.computedProps = propsMapper(nextProps);
        }
      };

      WithPropsOnChange.prototype.render = function render() {
        return factory(_extends({}, this.props, this.computedProps));
      };

      return WithPropsOnChange;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withPropsOnChange'))(WithPropsOnChange);
    }
    return WithPropsOnChange;
  };
};

var mapValues = function mapValues(obj, func) {
  var result = {};
  /* eslint-disable no-restricted-syntax */
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) {
      result[key] = func(obj[key], key);
    }
  }
  /* eslint-enable no-restricted-syntax */
  return result;
};

/* eslint-disable no-console */
var withHandlers = function withHandlers(handlers) {
  return function (BaseComponent) {
    var factory = createFactory(BaseComponent);

    var WithHandlers = function (_Component) {
      inherits(WithHandlers, _Component);

      function WithHandlers() {
        var _temp, _this, _ret;

        classCallCheck(this, WithHandlers);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), possibleConstructorReturn(_this, _ret);
      }

      WithHandlers.prototype.componentWillReceiveProps = function componentWillReceiveProps() {
        this.cachedHandlers = {};
      };

      WithHandlers.prototype.render = function render() {
        return factory(_extends({}, this.props, this.handlers));
      };

      return WithHandlers;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    var _initialiseProps = function _initialiseProps() {
      var _this2 = this;

      this.cachedHandlers = {};
      this.handlers = mapValues(typeof handlers === 'function' ? handlers(this.props) : handlers, function (createHandler, handlerName) {
        return function () {
          var cachedHandler = _this2.cachedHandlers[handlerName];
          if (cachedHandler) {
            return cachedHandler.apply(undefined, arguments);
          }

          var handler = createHandler(_this2.props);
          _this2.cachedHandlers[handlerName] = handler;

          if (false) {
            console.error(
            // eslint-disable-line no-console
            'withHandlers(): Expected a map of higher-order functions. ' + 'Refer to the docs for more info.');
          }

          return handler.apply(undefined, arguments);
        };
      });
    };

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withHandlers'))(WithHandlers);
    }
    return WithHandlers;
  };
};

var defaultProps = function defaultProps(props) {
  return function (BaseComponent) {
    var factory = createFactory(BaseComponent);
    var DefaultProps = function DefaultProps(ownerProps) {
      return factory(ownerProps);
    };
    DefaultProps.defaultProps = props;
    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'defaultProps'))(DefaultProps);
    }
    return DefaultProps;
  };
};

var omit = function omit(obj, keys) {
  var rest = objectWithoutProperties(obj, []);

  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (rest.hasOwnProperty(key)) {
      delete rest[key];
    }
  }
  return rest;
};

var renameProp = function renameProp(oldName, newName) {
  var hoc = mapProps(function (props) {
    var _babelHelpers$extends;

    return _extends({}, omit(props, [oldName]), (_babelHelpers$extends = {}, _babelHelpers$extends[newName] = props[oldName], _babelHelpers$extends));
  });
  if (false) {
    return function (BaseComponent) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'renameProp'))(hoc(BaseComponent));
    };
  }
  return hoc;
};

var keys = Object.keys;


var mapKeys = function mapKeys(obj, func) {
  return keys(obj).reduce(function (result, key) {
    var val = obj[key];
    /* eslint-disable no-param-reassign */
    result[func(val, key)] = val;
    /* eslint-enable no-param-reassign */
    return result;
  }, {});
};

var renameProps = function renameProps(nameMap) {
  var hoc = mapProps(function (props) {
    return _extends({}, omit(props, keys(nameMap)), mapKeys(pick(props, keys(nameMap)), function (_, oldName) {
      return nameMap[oldName];
    }));
  });
  if (false) {
    return function (BaseComponent) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'renameProps'))(hoc(BaseComponent));
    };
  }
  return hoc;
};

var flattenProp = function flattenProp(propName) {
  return function (BaseComponent) {
    var factory = createFactory(BaseComponent);
    var FlattenProp = function FlattenProp(props) {
      return factory(_extends({}, props, props[propName]));
    };

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'flattenProp'))(FlattenProp);
    }
    return FlattenProp;
  };
};

var withState = function withState(stateName, stateUpdaterName, initialState) {
  return function (BaseComponent) {
    var factory = createFactory(BaseComponent);

    var WithState = function (_Component) {
      inherits(WithState, _Component);

      function WithState() {
        var _temp, _this, _ret;

        classCallCheck(this, WithState);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
          stateValue: typeof initialState === 'function' ? initialState(_this.props) : initialState
        }, _this.updateStateValue = function (updateFn, callback) {
          return _this.setState(function (_ref) {
            var stateValue = _ref.stateValue;
            return {
              stateValue: typeof updateFn === 'function' ? updateFn(stateValue) : updateFn
            };
          }, callback);
        }, _temp), possibleConstructorReturn(_this, _ret);
      }

      WithState.prototype.render = function render() {
        var _babelHelpers$extends;

        return factory(_extends({}, this.props, (_babelHelpers$extends = {}, _babelHelpers$extends[stateName] = this.state.stateValue, _babelHelpers$extends[stateUpdaterName] = this.updateStateValue, _babelHelpers$extends)));
      };

      return WithState;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withState'))(WithState);
    }
    return WithState;
  };
};

var withStateHandlers = function withStateHandlers(initialState, stateUpdaters) {
  return function (BaseComponent) {
    var factory = createFactory(BaseComponent);

    var WithStateHandlers = function (_Component) {
      inherits(WithStateHandlers, _Component);

      function WithStateHandlers() {
        var _temp, _this, _ret;

        classCallCheck(this, WithStateHandlers);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), possibleConstructorReturn(_this, _ret);
      }

      WithStateHandlers.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
        var propsChanged = nextProps !== this.props;
        // the idea is to skip render if stateUpdater handler return undefined
        // this allows to create no state update handlers with access to state and props
        var stateChanged = !__WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual___default()(nextState, this.state);
        return propsChanged || stateChanged;
      };

      WithStateHandlers.prototype.render = function render() {
        return factory(_extends({}, this.props, this.state, this.stateUpdaters));
      };

      return WithStateHandlers;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    var _initialiseProps = function _initialiseProps() {
      var _this2 = this;

      this.state = typeof initialState === 'function' ? initialState(this.props) : initialState;
      this.stateUpdaters = mapValues(stateUpdaters, function (handler) {
        return function (mayBeEvent) {
          for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
            args[_key2 - 1] = arguments[_key2];
          }

          // Having that functional form of setState can be called async
          // we need to persist SyntheticEvent
          if (mayBeEvent && typeof mayBeEvent.persist === 'function') {
            mayBeEvent.persist();
          }

          _this2.setState(function (state, props) {
            return handler(state, props).apply(undefined, [mayBeEvent].concat(args));
          });
        };
      });
    };

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withStateHandlers'))(WithStateHandlers);
    }
    return WithStateHandlers;
  };
};

var withReducer = function withReducer(stateName, dispatchName, reducer, initialState) {
  return function (BaseComponent) {
    var factory = createFactory(BaseComponent);

    var WithReducer = function (_Component) {
      inherits(WithReducer, _Component);

      function WithReducer() {
        var _temp, _this, _ret;

        classCallCheck(this, WithReducer);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
          stateValue: _this.initializeStateValue()
        }, _this.dispatch = function (action) {
          return _this.setState(function (_ref) {
            var stateValue = _ref.stateValue;
            return {
              stateValue: reducer(stateValue, action)
            };
          });
        }, _temp), possibleConstructorReturn(_this, _ret);
      }

      WithReducer.prototype.initializeStateValue = function initializeStateValue() {
        if (initialState !== undefined) {
          return typeof initialState === 'function' ? initialState(this.props) : initialState;
        }
        return reducer(undefined, { type: '@@recompose/INIT' });
      };

      WithReducer.prototype.render = function render() {
        var _babelHelpers$extends;

        return factory(_extends({}, this.props, (_babelHelpers$extends = {}, _babelHelpers$extends[stateName] = this.state.stateValue, _babelHelpers$extends[dispatchName] = this.dispatch, _babelHelpers$extends)));
      };

      return WithReducer;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withReducer'))(WithReducer);
    }
    return WithReducer;
  };
};

var identity = function identity(Component$$1) {
  return Component$$1;
};

var branch = function branch(test, left) {
  var right = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : identity;
  return function (BaseComponent) {
    var leftFactory = void 0;
    var rightFactory = void 0;
    var Branch = function Branch(props) {
      if (test(props)) {
        leftFactory = leftFactory || createFactory(left(BaseComponent));
        return leftFactory(props);
      }
      rightFactory = rightFactory || createFactory(right(BaseComponent));
      return rightFactory(props);
    };

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'branch'))(Branch);
    }
    return Branch;
  };
};

var renderComponent = function renderComponent(Component$$1) {
  return function (_) {
    var factory = createFactory(Component$$1);
    var RenderComponent = function RenderComponent(props) {
      return factory(props);
    };
    if (false) {
      RenderComponent.displayName = wrapDisplayName(Component$$1, 'renderComponent');
    }
    return RenderComponent;
  };
};

var Nothing = function (_Component) {
  inherits(Nothing, _Component);

  function Nothing() {
    classCallCheck(this, Nothing);
    return possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  Nothing.prototype.render = function render() {
    return null;
  };

  return Nothing;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var renderNothing = function renderNothing(_) {
  return Nothing;
};

var shouldUpdate = function shouldUpdate(test) {
  return function (BaseComponent) {
    var factory = createFactory(BaseComponent);

    var ShouldUpdate = function (_Component) {
      inherits(ShouldUpdate, _Component);

      function ShouldUpdate() {
        classCallCheck(this, ShouldUpdate);
        return possibleConstructorReturn(this, _Component.apply(this, arguments));
      }

      ShouldUpdate.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
        return test(this.props, nextProps);
      };

      ShouldUpdate.prototype.render = function render() {
        return factory(this.props);
      };

      return ShouldUpdate;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'shouldUpdate'))(ShouldUpdate);
    }
    return ShouldUpdate;
  };
};

var pure = function pure(BaseComponent) {
  var hoc = shouldUpdate(function (props, nextProps) {
    return !__WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual___default()(props, nextProps);
  });

  if (false) {
    return setDisplayName(wrapDisplayName(BaseComponent, 'pure'))(hoc(BaseComponent));
  }

  return hoc(BaseComponent);
};

var onlyUpdateForKeys = function onlyUpdateForKeys(propKeys) {
  var hoc = shouldUpdate(function (props, nextProps) {
    return !__WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual___default()(pick(nextProps, propKeys), pick(props, propKeys));
  });

  if (false) {
    return function (BaseComponent) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'onlyUpdateForKeys'))(hoc(BaseComponent));
    };
  }
  return hoc;
};

var onlyUpdateForPropTypes = function onlyUpdateForPropTypes(BaseComponent) {
  var propTypes = BaseComponent.propTypes;

  if (false) {
    if (!propTypes) {
      /* eslint-disable */
      console.error('A component without any `propTypes` was passed to ' + '`onlyUpdateForPropTypes()`. Check the implementation of the ' + ('component with display name "' + getDisplayName(BaseComponent) + '".'));
      /* eslint-enable */
    }
  }

  var propKeys = Object.keys(propTypes || {});
  var OnlyUpdateForPropTypes = onlyUpdateForKeys(propKeys)(BaseComponent);

  if (false) {
    return setDisplayName(wrapDisplayName(BaseComponent, 'onlyUpdateForPropTypes'))(OnlyUpdateForPropTypes);
  }
  return OnlyUpdateForPropTypes;
};

var withContext = function withContext(childContextTypes, getChildContext) {
  return function (BaseComponent) {
    var factory = createFactory(BaseComponent);

    var WithContext = function (_Component) {
      inherits(WithContext, _Component);

      function WithContext() {
        var _temp, _this, _ret;

        classCallCheck(this, WithContext);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.getChildContext = function () {
          return getChildContext(_this.props);
        }, _temp), possibleConstructorReturn(_this, _ret);
      }

      WithContext.prototype.render = function render() {
        return factory(this.props);
      };

      return WithContext;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    WithContext.childContextTypes = childContextTypes;

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withContext'))(WithContext);
    }
    return WithContext;
  };
};

var getContext = function getContext(contextTypes) {
  return function (BaseComponent) {
    var factory = createFactory(BaseComponent);
    var GetContext = function GetContext(ownerProps, context) {
      return factory(_extends({}, ownerProps, context));
    };

    GetContext.contextTypes = contextTypes;

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'getContext'))(GetContext);
    }
    return GetContext;
  };
};

/* eslint-disable no-console */
var lifecycle = function lifecycle(spec) {
  return function (BaseComponent) {
    var factory = createFactory(BaseComponent);

    if (false) {
      console.error('lifecycle() does not support the render method; its behavior is to ' + 'pass all props and state to the base component.');
    }

    var Lifecycle = function (_Component) {
      inherits(Lifecycle, _Component);

      function Lifecycle() {
        classCallCheck(this, Lifecycle);
        return possibleConstructorReturn(this, _Component.apply(this, arguments));
      }

      Lifecycle.prototype.render = function render() {
        return factory(_extends({}, this.props, this.state));
      };

      return Lifecycle;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    Object.keys(spec).forEach(function (hook) {
      return Lifecycle.prototype[hook] = spec[hook];
    });

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'lifecycle'))(Lifecycle);
    }
    return Lifecycle;
  };
};

var toClass = function toClass(baseComponent) {
  if (isClassComponent(baseComponent)) {
    return baseComponent;
  }

  var ToClass = function (_Component) {
    inherits(ToClass, _Component);

    function ToClass() {
      classCallCheck(this, ToClass);
      return possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    ToClass.prototype.render = function render() {
      if (typeof baseComponent === 'string') {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(baseComponent, this.props);
      }
      return baseComponent(this.props, this.context);
    };

    return ToClass;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  ToClass.displayName = getDisplayName(baseComponent);
  ToClass.propTypes = baseComponent.propTypes;
  ToClass.contextTypes = baseComponent.contextTypes;
  ToClass.defaultProps = baseComponent.defaultProps;

  return ToClass;
};

var setPropTypes = function setPropTypes(propTypes) {
  return setStatic('propTypes', propTypes);
};

function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(undefined, arguments));
    };
  });
}

var createEagerElement = function createEagerElement(type, props, children) {
  var isReferentiallyTransparent = isReferentiallyTransparentFunctionComponent(type);
  /* eslint-disable */
  var hasKey = props && props.hasOwnProperty('key');
  /* eslint-enable */
  return createEagerElementUtil(hasKey, isReferentiallyTransparent, type, props, children);
};

var createSink = function createSink(callback) {
  return function (_Component) {
    inherits(Sink, _Component);

    function Sink() {
      classCallCheck(this, Sink);
      return possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    Sink.prototype.componentWillMount = function componentWillMount() {
      callback(this.props);
    };

    Sink.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      callback(nextProps);
    };

    Sink.prototype.render = function render() {
      return null;
    };

    return Sink;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
};

var componentFromProp = function componentFromProp(propName) {
  var Component$$1 = function Component$$1(props) {
    return createEagerElement(props[propName], omit(props, [propName]));
  };
  Component$$1.displayName = 'componentFromProp(' + propName + ')';
  return Component$$1;
};

var nest = function nest() {
  for (var _len = arguments.length, Components = Array(_len), _key = 0; _key < _len; _key++) {
    Components[_key] = arguments[_key];
  }

  var factories = Components.map(createFactory);
  var Nest = function Nest(_ref) {
    var props = objectWithoutProperties(_ref, []),
        children = _ref.children;
    return factories.reduceRight(function (child, factory) {
      return factory(props, child);
    }, children);
  };

  if (false) {
    var displayNames = Components.map(getDisplayName);
    Nest.displayName = 'nest(' + displayNames.join(', ') + ')';
  }

  return Nest;
};

var hoistStatics = function hoistStatics(higherOrderComponent) {
  return function (BaseComponent) {
    var NewComponent = higherOrderComponent(BaseComponent);
    __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(NewComponent, BaseComponent);
    return NewComponent;
  };
};

var _config = {
  fromESObservable: null,
  toESObservable: null
};

var configureObservable = function configureObservable(c) {
  _config = c;
};

var config = {
  fromESObservable: function fromESObservable(observable) {
    return typeof _config.fromESObservable === 'function' ? _config.fromESObservable(observable) : observable;
  },
  toESObservable: function toESObservable(stream) {
    return typeof _config.toESObservable === 'function' ? _config.toESObservable(stream) : stream;
  }
};

var componentFromStreamWithConfig = function componentFromStreamWithConfig(config$$1) {
  return function (propsToVdom) {
    return function (_Component) {
      inherits(ComponentFromStream, _Component);

      function ComponentFromStream() {
        var _config$fromESObserva;

        var _temp, _this, _ret;

        classCallCheck(this, ComponentFromStream);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = { vdom: null }, _this.propsEmitter = Object(__WEBPACK_IMPORTED_MODULE_3_change_emitter__["createChangeEmitter"])(), _this.props$ = config$$1.fromESObservable((_config$fromESObserva = {
          subscribe: function subscribe(observer) {
            var unsubscribe = _this.propsEmitter.listen(function (props) {
              if (props) {
                observer.next(props);
              } else {
                observer.complete();
              }
            });
            return { unsubscribe: unsubscribe };
          }
        }, _config$fromESObserva[__WEBPACK_IMPORTED_MODULE_4_symbol_observable__["a" /* default */]] = function () {
          return this;
        }, _config$fromESObserva)), _this.vdom$ = config$$1.toESObservable(propsToVdom(_this.props$)), _temp), possibleConstructorReturn(_this, _ret);
      }

      // Stream of props


      // Stream of vdom


      ComponentFromStream.prototype.componentWillMount = function componentWillMount() {
        var _this2 = this;

        // Subscribe to child prop changes so we know when to re-render
        this.subscription = this.vdom$.subscribe({
          next: function next(vdom) {
            _this2.setState({ vdom: vdom });
          }
        });
        this.propsEmitter.emit(this.props);
      };

      ComponentFromStream.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        // Receive new props from the owner
        this.propsEmitter.emit(nextProps);
      };

      ComponentFromStream.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
        return nextState.vdom !== this.state.vdom;
      };

      ComponentFromStream.prototype.componentWillUnmount = function componentWillUnmount() {
        // Call without arguments to complete stream
        this.propsEmitter.emit();

        // Clean-up subscription before un-mounting
        this.subscription.unsubscribe();
      };

      ComponentFromStream.prototype.render = function render() {
        return this.state.vdom;
      };

      return ComponentFromStream;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
  };
};

var componentFromStream = function componentFromStream(propsToVdom) {
  return componentFromStreamWithConfig(config)(propsToVdom);
};

var identity$1 = function identity(t) {
  return t;
};

var mapPropsStreamWithConfig = function mapPropsStreamWithConfig(config$$1) {
  var componentFromStream = componentFromStreamWithConfig({
    fromESObservable: identity$1,
    toESObservable: identity$1
  });
  return function (transform) {
    return function (BaseComponent) {
      var factory = createFactory(BaseComponent);
      var fromESObservable = config$$1.fromESObservable,
          toESObservable = config$$1.toESObservable;

      return componentFromStream(function (props$) {
        var _ref;

        return _ref = {
          subscribe: function subscribe(observer) {
            var subscription = toESObservable(transform(fromESObservable(props$))).subscribe({
              next: function next(childProps) {
                return observer.next(factory(childProps));
              }
            });
            return {
              unsubscribe: function unsubscribe() {
                return subscription.unsubscribe();
              }
            };
          }
        }, _ref[__WEBPACK_IMPORTED_MODULE_4_symbol_observable__["a" /* default */]] = function () {
          return this;
        }, _ref;
      });
    };
  };
};

var mapPropsStream = function mapPropsStream(transform) {
  var hoc = mapPropsStreamWithConfig(config)(transform);

  if (false) {
    return function (BaseComponent) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'mapPropsStream'))(hoc(BaseComponent));
    };
  }
  return hoc;
};

var createEventHandlerWithConfig = function createEventHandlerWithConfig(config$$1) {
  return function () {
    var _config$fromESObserva;

    var emitter = Object(__WEBPACK_IMPORTED_MODULE_3_change_emitter__["createChangeEmitter"])();
    var stream = config$$1.fromESObservable((_config$fromESObserva = {
      subscribe: function subscribe(observer) {
        var unsubscribe = emitter.listen(function (value) {
          return observer.next(value);
        });
        return { unsubscribe: unsubscribe };
      }
    }, _config$fromESObserva[__WEBPACK_IMPORTED_MODULE_4_symbol_observable__["a" /* default */]] = function () {
      return this;
    }, _config$fromESObserva));
    return {
      handler: emitter.emit,
      stream: stream
    };
  };
};

var createEventHandler = createEventHandlerWithConfig(config);

// Higher-order component helpers




/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export initialize */
/* unused harmony export addTrackers */
/* unused harmony export ga */
/* unused harmony export set */
/* unused harmony export send */
/* unused harmony export pageview */
/* unused harmony export modalview */
/* unused harmony export timing */
/* unused harmony export event */
/* unused harmony export exception */
/* unused harmony export plugin */
/* unused harmony export outboundLink */
/* unused harmony export testModeAPI */
/* unused harmony export OutboundLink */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_OutboundLink__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core__ = __webpack_require__(327);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var initialize = __WEBPACK_IMPORTED_MODULE_1__core__["initialize"];

var addTrackers = __WEBPACK_IMPORTED_MODULE_1__core__["addTrackers"];

var ga = __WEBPACK_IMPORTED_MODULE_1__core__["ga"];

var set = __WEBPACK_IMPORTED_MODULE_1__core__["set"];

var send = __WEBPACK_IMPORTED_MODULE_1__core__["send"];

var pageview = __WEBPACK_IMPORTED_MODULE_1__core__["pageview"];

var modalview = __WEBPACK_IMPORTED_MODULE_1__core__["modalview"];

var timing = __WEBPACK_IMPORTED_MODULE_1__core__["timing"];

var event = __WEBPACK_IMPORTED_MODULE_1__core__["event"];

var exception = __WEBPACK_IMPORTED_MODULE_1__core__["exception"];

var plugin = __WEBPACK_IMPORTED_MODULE_1__core__["plugin"];

var outboundLink = __WEBPACK_IMPORTED_MODULE_1__core__["outboundLink"];

var testModeAPI = __WEBPACK_IMPORTED_MODULE_1__core__["testModeAPI"];

__WEBPACK_IMPORTED_MODULE_0__components_OutboundLink__["a" /* default */].origTrackLink = __WEBPACK_IMPORTED_MODULE_0__components_OutboundLink__["a" /* default */].trackLink;
__WEBPACK_IMPORTED_MODULE_0__components_OutboundLink__["a" /* default */].trackLink = __WEBPACK_IMPORTED_MODULE_1__core__["outboundLink"];
var OutboundLink = __WEBPACK_IMPORTED_MODULE_0__components_OutboundLink__["a" /* default */];
/* harmony default export */ __webpack_exports__["a"] = (_objectSpread(_objectSpread({}, __WEBPACK_IMPORTED_MODULE_1__core__), {}, {
  OutboundLink: OutboundLink
}));

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getAverageColor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
var _this=this;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var getAverageColor=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(picture){var data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:if(picture){_context.next=2;break;}return _context.abrupt('return',false);case 2:_context.next=4;return average(picture);case 4:data=_context.sent;return _context.abrupt('return',data);case 6:case'end':return _context.stop();}}},_callee,_this);}));return function getAverageColor(_x){return _ref.apply(this,arguments);};}();var average=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(picture){var defaultRGB,canvas,context,count,averageData;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:defaultRGB={r:0,g:0,b:0};canvas=document.createElement('canvas');context=canvas.getContext('2d');count=0;_context2.next=6;return getImage(picture).then(function(image){var height=canvas.height=image.naturalHeight||image.offsetHeight||image.height;context.drawImage(image,0,0);var data=context.getImageData(0,0,3,height);var pix=data.data;for(var i=0;i<pix.length;i=i+4){count++;defaultRGB.r+=pix[i];defaultRGB.g+=pix[i+1];defaultRGB.b+=pix[i+2];}defaultRGB.r=~~(defaultRGB.r/count);defaultRGB.g=~~(defaultRGB.g/count);defaultRGB.b=~~(defaultRGB.b/count);var acc=(defaultRGB.r+defaultRGB.g+defaultRGB.b)/3;return acc>250||acc<5?'rgb('+defaultRGB.r+', '+defaultRGB.g+', '+defaultRGB.b+')':false;}).catch(function(e){console.log(e);});case 6:averageData=_context2.sent;return _context2.abrupt('return',averageData);case 8:case'end':return _context2.stop();}}},_callee2,_this);}));return function average(_x2){return _ref2.apply(this,arguments);};}();var getImage=function getImage(picture){return new Promise(function(resolve,reject){var image=new Image();image.onload=function(){return resolve(image);};image.onerror=reject;image.src=picture;});};

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Flickity v2.2.2
 * Touch, responsive, flickable carousels
 *
 * Licensed GPLv3 for open source use
 * or Flickity Commercial License for commercial use
 *
 * https://flickity.metafizzy.co
 * Copyright 2015-2021 Metafizzy
 */

( function( window, factory ) {
  // universal module definition
  if ( true ) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
      __webpack_require__(28),
      __webpack_require__(460),
      __webpack_require__(462),
      __webpack_require__(463),
      __webpack_require__(464),
      __webpack_require__(465),
      __webpack_require__(466),
    ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
        require('./flickity'),
        require('./drag'),
        require('./prev-next-button'),
        require('./page-dots'),
        require('./player'),
        require('./add-remove-cell'),
        require('./lazyload')
    );
  }

} )( window, function factory( Flickity ) {
  return Flickity;
} );


/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return fetchUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return logIn; });
/* unused harmony export changePassword */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return editPassword; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return editChallenge; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return logOut; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return updateProfilePicture; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return forgotPassword; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return checkConnect; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers_Session__ = __webpack_require__(154);
var _this=this;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}// import { debounce } from 'lodash'
var fetchUser=function fetchUser(){return(// debounce(
function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(dispatch,getState,api){var response,challenge;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.prev=0;_context.next=3;return api.fetchUser();case 3:response=_context.sent;if(response.connected){_context.next=8;break;}dispatch(Object.assign({type:__WEBPACK_IMPORTED_MODULE_1__reducers_Session__["a" /* ActionTypes */].CREATE_FORM},response));_context.next=12;break;case 8:_context.next=10;return api.fetchChallenge();case 10:challenge=_context.sent;if(challenge){dispatch(Object.assign({type:__WEBPACK_IMPORTED_MODULE_1__reducers_Session__["a" /* ActionTypes */].INIT_SESSION,initAt:performance.now()},response,{challenge:{current:challenge.rank,total:challenge.count,best:challenge.bestRanking,quizz:challenge.quizTaken,quizzTotal:challenge.totalQuiz,results:challenge.results,rankingIQ:challenge.score}}));}case 12:_context.next=17;break;case 14:_context.prev=14;_context.t0=_context['catch'](0);console.log(_context.t0);case 17:case'end':return _context.stop();}}},_callee,_this,[[0,14]]);}));return function(_x,_x2,_x3){return _ref.apply(this,arguments);};}());};var logIn=function logIn(fields){return function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(dispatch,getState,api){var response,challenge;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return api.logIn(getState().Session.action,fields);case 2:response=_context2.sent;if(response.connected){_context2.next=7;break;}dispatch(Object.assign({type:__WEBPACK_IMPORTED_MODULE_1__reducers_Session__["a" /* ActionTypes */].HANDLE_ERRORS},response));_context2.next=11;break;case 7:_context2.next=9;return api.fetchChallenge();case 9:challenge=_context2.sent;dispatch(Object.assign({type:__WEBPACK_IMPORTED_MODULE_1__reducers_Session__["a" /* ActionTypes */].INIT_SESSION,initAt:performance.now()},response,{challenge:{current:challenge.rank,total:challenge.count,best:challenge.bestRanking,quizz:challenge.quizTaken,quizzTotal:challenge.totalQuiz,results:challenge.results,rankingIQ:challenge.score}}));case 11:case'end':return _context2.stop();}}},_callee2,_this);}));return function(_x4,_x5,_x6){return _ref2.apply(this,arguments);};}();};var changePassword=function changePassword(fields){return function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(dispatch,getState,api){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return api.changePassword(getState().Session.forgotForm.action,fields);case 2:response=_context3.sent;if(!response.success){dispatch({type:__WEBPACK_IMPORTED_MODULE_1__reducers_Session__["a" /* ActionTypes */].HANDLE_ERRORS,error:{changePassword:response.error}});}else{dispatch({type:__WEBPACK_IMPORTED_MODULE_1__reducers_Session__["a" /* ActionTypes */].PASSWORD_CHANGED});}case 4:case'end':return _context3.stop();}}},_callee3,_this);}));return function(_x7,_x8,_x9){return _ref3.apply(this,arguments);};}();};var editPassword=function editPassword(fields,action){return function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(dispatch,getState,api){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.next=2;return api.changePassword(action,fields);case 2:response=_context4.sent;if(!response.success){dispatch({type:__WEBPACK_IMPORTED_MODULE_1__reducers_Session__["a" /* ActionTypes */].HANDLE_ERRORS,error:{changePassword:response.error}});}else{dispatch({type:__WEBPACK_IMPORTED_MODULE_1__reducers_Session__["a" /* ActionTypes */].PASSWORD_CHANGED});}case 4:case'end':return _context4.stop();}}},_callee4,_this);}));return function(_x10,_x11,_x12){return _ref4.apply(this,arguments);};}();};var editChallenge=function editChallenge(){return function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(dispatch,getState,api){var challenge;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:_context5.next=2;return api.fetchChallenge();case 2:challenge=_context5.sent;dispatch({type:__WEBPACK_IMPORTED_MODULE_1__reducers_Session__["a" /* ActionTypes */].EDIT_CHALLENGE,challenge:{current:challenge.rank,total:challenge.count,best:challenge.bestRanking,quizz:challenge.quizTaken,quizzTotal:challenge.totalQuiz,results:challenge.results,rankingIQ:challenge.score}});case 4:case'end':return _context5.stop();}}},_callee5,_this);}));return function(_x13,_x14,_x15){return _ref5.apply(this,arguments);};}();};var logOut=function logOut(){return function(){var _ref6=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(dispatch,getState,api){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:_context6.next=2;return api.logOut();case 2:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__reducers_Session__["a" /* ActionTypes */].CLEAR_SESSION});window.location='/';case 4:case'end':return _context6.stop();}}},_callee6,_this);}));return function(_x16,_x17,_x18){return _ref6.apply(this,arguments);};}();};var updateProfilePicture=function updateProfilePicture(file){return function(){var _ref7=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(dispatch,getState,api){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__reducers_Session__["a" /* ActionTypes */].EDIT_PICTURE,picture:file});case 1:case'end':return _context7.stop();}}},_callee7,_this);}));return function(_x19,_x20,_x21){return _ref7.apply(this,arguments);};}();};var forgotPassword=function forgotPassword(fields){return function(){var _ref8=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(dispatch,getState,api){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:_context8.next=2;return api.forgotPassword(getState().Session.forgot_password.action,fields);case 2:response=_context8.sent;if(!response.success){dispatch({type:__WEBPACK_IMPORTED_MODULE_1__reducers_Session__["a" /* ActionTypes */].HANDLE_ERRORS,error:{message:response.error}});}else{dispatch({type:__WEBPACK_IMPORTED_MODULE_1__reducers_Session__["a" /* ActionTypes */].HANDLE_ERRORS,error:{success:"You will receive an email with a link to reset your password"}});}case 4:case'end':return _context8.stop();}}},_callee8,_this);}));return function(_x22,_x23,_x24){return _ref8.apply(this,arguments);};}();};var checkConnect=function checkConnect(){return function(){var _ref9=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9(dispatch,getState,api){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9){while(1){switch(_context9.prev=_context9.next){case 0:_context9.next=2;return api.fetchUser();case 2:response=_context9.sent;if(!(!response.connected&&getState().Session.initAt!==-1)){_context9.next=8;break;}_context9.next=6;return api.logOut();case 6:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__reducers_Session__["a" /* ActionTypes */].CLEAR_SESSION});window.location='/';case 8:case'end':return _context9.stop();}}},_callee9,_this);}));return function(_x25,_x26,_x27){return _ref9.apply(this,arguments);};}();};

/***/ }),
/* 40 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */


/**
 * WARNING: DO NOT manually require this module.
 * This is a replacement for `invariant(...)` used by the error code system
 * and will _only_ be required by the corresponding babel pass.
 * It always throws.
 */

function reactProdInvariant(code) {
  var argCount = arguments.length - 1;

  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;

  for (var argIdx = 0; argIdx < argCount; argIdx++) {
    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
  }

  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';

  var error = new Error(message);
  error.name = 'Invariant Violation';
  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame

  throw error;
}

module.exports = reactProdInvariant;

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var EventPluginHub = __webpack_require__(43);
var EventPluginUtils = __webpack_require__(68);

var accumulateInto = __webpack_require__(104);
var forEachAccumulated = __webpack_require__(105);
var warning = __webpack_require__(7);

var getListener = EventPluginHub.getListener;

/**
 * Some event types have a notion of different registration names for different
 * "phases" of propagation. This finds listeners by a given phase.
 */
function listenerAtPhase(inst, event, propagationPhase) {
  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
  return getListener(inst, registrationName);
}

/**
 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
 * here, allows us to not have to bind or create functions for each event.
 * Mutating the event's members allows us to not have to create a wrapping
 * "dispatch" object that pairs the event with the listener.
 */
function accumulateDirectionalDispatches(inst, phase, event) {
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(inst, 'Dispatching inst must not be null') : void 0;
  }
  var listener = listenerAtPhase(inst, event, phase);
  if (listener) {
    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
    event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
  }
}

/**
 * Collect dispatches (must be entirely collected before dispatching - see unit
 * tests). Lazily allocate the array to conserve memory.  We must loop through
 * each event and perform the traversal for each one. We cannot perform a
 * single traversal for the entire collection of events because each event may
 * have a different target.
 */
function accumulateTwoPhaseDispatchesSingle(event) {
  if (event && event.dispatchConfig.phasedRegistrationNames) {
    EventPluginUtils.traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
  }
}

/**
 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
 */
function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
  if (event && event.dispatchConfig.phasedRegistrationNames) {
    var targetInst = event._targetInst;
    var parentInst = targetInst ? EventPluginUtils.getParentInstance(targetInst) : null;
    EventPluginUtils.traverseTwoPhase(parentInst, accumulateDirectionalDispatches, event);
  }
}

/**
 * Accumulates without regard to direction, does not look for phased
 * registration names. Same as `accumulateDirectDispatchesSingle` but without
 * requiring that the `dispatchMarker` be the same as the dispatched ID.
 */
function accumulateDispatches(inst, ignoredDirection, event) {
  if (event && event.dispatchConfig.registrationName) {
    var registrationName = event.dispatchConfig.registrationName;
    var listener = getListener(inst, registrationName);
    if (listener) {
      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
      event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
    }
  }
}

/**
 * Accumulates dispatches on an `SyntheticEvent`, but only for the
 * `dispatchMarker`.
 * @param {SyntheticEvent} event
 */
function accumulateDirectDispatchesSingle(event) {
  if (event && event.dispatchConfig.registrationName) {
    accumulateDispatches(event._targetInst, null, event);
  }
}

function accumulateTwoPhaseDispatches(events) {
  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
}

function accumulateTwoPhaseDispatchesSkipTarget(events) {
  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
}

function accumulateEnterLeaveDispatches(leave, enter, from, to) {
  EventPluginUtils.traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
}

function accumulateDirectDispatches(events) {
  forEachAccumulated(events, accumulateDirectDispatchesSingle);
}

/**
 * A small set of propagation patterns, each of which will accept a small amount
 * of information, and generate a set of "dispatch ready event objects" - which
 * are sets of events that have already been annotated with a set of dispatched
 * listener functions/ids. The API is designed this way to discourage these
 * propagation strategies from actually executing the dispatches, since we
 * always want to collect the entire set of dispatches before executing event a
 * single one.
 *
 * @constructor EventPropagators
 */
var EventPropagators = {
  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
  accumulateDirectDispatches: accumulateDirectDispatches,
  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
};

module.exports = EventPropagators;

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(6);

var EventPluginRegistry = __webpack_require__(67);
var EventPluginUtils = __webpack_require__(68);
var ReactErrorUtils = __webpack_require__(69);

var accumulateInto = __webpack_require__(104);
var forEachAccumulated = __webpack_require__(105);
var invariant = __webpack_require__(4);

/**
 * Internal store for event listeners
 */
var listenerBank = {};

/**
 * Internal queue of events that have accumulated their dispatches and are
 * waiting to have their dispatches executed.
 */
var eventQueue = null;

/**
 * Dispatches an event and releases it back into the pool, unless persistent.
 *
 * @param {?object} event Synthetic event to be dispatched.
 * @param {boolean} simulated If the event is simulated (changes exn behavior)
 * @private
 */
var executeDispatchesAndRelease = function (event, simulated) {
  if (event) {
    EventPluginUtils.executeDispatchesInOrder(event, simulated);

    if (!event.isPersistent()) {
      event.constructor.release(event);
    }
  }
};
var executeDispatchesAndReleaseSimulated = function (e) {
  return executeDispatchesAndRelease(e, true);
};
var executeDispatchesAndReleaseTopLevel = function (e) {
  return executeDispatchesAndRelease(e, false);
};

var getDictionaryKey = function (inst) {
  // Prevents V8 performance issue:
  // https://github.com/facebook/react/pull/7232
  return '.' + inst._rootNodeID;
};

function isInteractive(tag) {
  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
}

function shouldPreventMouseEvent(name, type, props) {
  switch (name) {
    case 'onClick':
    case 'onClickCapture':
    case 'onDoubleClick':
    case 'onDoubleClickCapture':
    case 'onMouseDown':
    case 'onMouseDownCapture':
    case 'onMouseMove':
    case 'onMouseMoveCapture':
    case 'onMouseUp':
    case 'onMouseUpCapture':
      return !!(props.disabled && isInteractive(type));
    default:
      return false;
  }
}

/**
 * This is a unified interface for event plugins to be installed and configured.
 *
 * Event plugins can implement the following properties:
 *
 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
 *     Required. When a top-level event is fired, this method is expected to
 *     extract synthetic events that will in turn be queued and dispatched.
 *
 *   `eventTypes` {object}
 *     Optional, plugins that fire events must publish a mapping of registration
 *     names that are used to register listeners. Values of this mapping must
 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
 *
 *   `executeDispatch` {function(object, function, string)}
 *     Optional, allows plugins to override how an event gets dispatched. By
 *     default, the listener is simply invoked.
 *
 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
 *
 * @public
 */
var EventPluginHub = {
  /**
   * Methods for injecting dependencies.
   */
  injection: {
    /**
     * @param {array} InjectedEventPluginOrder
     * @public
     */
    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,

    /**
     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
     */
    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
  },

  /**
   * Stores `listener` at `listenerBank[registrationName][key]`. Is idempotent.
   *
   * @param {object} inst The instance, which is the source of events.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @param {function} listener The callback to store.
   */
  putListener: function (inst, registrationName, listener) {
    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : _prodInvariant('94', registrationName, typeof listener) : void 0;

    var key = getDictionaryKey(inst);
    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
    bankForRegistrationName[key] = listener;

    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
    if (PluginModule && PluginModule.didPutListener) {
      PluginModule.didPutListener(inst, registrationName, listener);
    }
  },

  /**
   * @param {object} inst The instance, which is the source of events.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @return {?function} The stored callback.
   */
  getListener: function (inst, registrationName) {
    // TODO: shouldPreventMouseEvent is DOM-specific and definitely should not
    // live here; needs to be moved to a better place soon
    var bankForRegistrationName = listenerBank[registrationName];
    if (shouldPreventMouseEvent(registrationName, inst._currentElement.type, inst._currentElement.props)) {
      return null;
    }
    var key = getDictionaryKey(inst);
    return bankForRegistrationName && bankForRegistrationName[key];
  },

  /**
   * Deletes a listener from the registration bank.
   *
   * @param {object} inst The instance, which is the source of events.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   */
  deleteListener: function (inst, registrationName) {
    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
    if (PluginModule && PluginModule.willDeleteListener) {
      PluginModule.willDeleteListener(inst, registrationName);
    }

    var bankForRegistrationName = listenerBank[registrationName];
    // TODO: This should never be null -- when is it?
    if (bankForRegistrationName) {
      var key = getDictionaryKey(inst);
      delete bankForRegistrationName[key];
    }
  },

  /**
   * Deletes all listeners for the DOM element with the supplied ID.
   *
   * @param {object} inst The instance, which is the source of events.
   */
  deleteAllListeners: function (inst) {
    var key = getDictionaryKey(inst);
    for (var registrationName in listenerBank) {
      if (!listenerBank.hasOwnProperty(registrationName)) {
        continue;
      }

      if (!listenerBank[registrationName][key]) {
        continue;
      }

      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
      if (PluginModule && PluginModule.willDeleteListener) {
        PluginModule.willDeleteListener(inst, registrationName);
      }

      delete listenerBank[registrationName][key];
    }
  },

  /**
   * Allows registered plugins an opportunity to extract events from top-level
   * native browser events.
   *
   * @return {*} An accumulation of synthetic events.
   * @internal
   */
  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var events;
    var plugins = EventPluginRegistry.plugins;
    for (var i = 0; i < plugins.length; i++) {
      // Not every plugin in the ordering may be loaded at runtime.
      var possiblePlugin = plugins[i];
      if (possiblePlugin) {
        var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
        if (extractedEvents) {
          events = accumulateInto(events, extractedEvents);
        }
      }
    }
    return events;
  },

  /**
   * Enqueues a synthetic event that should be dispatched when
   * `processEventQueue` is invoked.
   *
   * @param {*} events An accumulation of synthetic events.
   * @internal
   */
  enqueueEvents: function (events) {
    if (events) {
      eventQueue = accumulateInto(eventQueue, events);
    }
  },

  /**
   * Dispatches all synthetic events on the event queue.
   *
   * @internal
   */
  processEventQueue: function (simulated) {
    // Set `eventQueue` to null before processing it so that we can tell if more
    // events get enqueued while processing.
    var processingEventQueue = eventQueue;
    eventQueue = null;
    if (simulated) {
      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
    } else {
      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
    }
    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.') : _prodInvariant('95') : void 0;
    // This would be a good time to rethrow if any of the event handlers threw.
    ReactErrorUtils.rethrowCaughtError();
  },

  /**
   * These are needed for tests only. Do not use!
   */
  __purge: function () {
    listenerBank = {};
  },

  __getListenerBank: function () {
    return listenerBank;
  }
};

module.exports = EventPluginHub;

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticEvent = __webpack_require__(23);

var getEventTarget = __webpack_require__(70);

/**
 * @interface UIEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var UIEventInterface = {
  view: function (event) {
    if (event.view) {
      return event.view;
    }

    var target = getEventTarget(event);
    if (target.window === target) {
      // target is a window object
      return target;
    }

    var doc = target.ownerDocument;
    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
    if (doc) {
      return doc.defaultView || doc.parentWindow;
    } else {
      return window;
    }
  },
  detail: function (event) {
    return event.detail || 0;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticEvent}
 */
function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);

module.exports = SyntheticUIEvent;

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * `ReactInstanceMap` maintains a mapping from a public facing stateful
 * instance (key) and the internal representation (value). This allows public
 * methods to accept the user facing instance as an argument and map them back
 * to internal methods.
 */

// TODO: Replace this with ES6: var ReactInstanceMap = new Map();

var ReactInstanceMap = {
  /**
   * This API should be called `delete` but we'd have to make sure to always
   * transform these to strings for IE support. When this transform is fully
   * supported we can rename it.
   */
  remove: function (key) {
    key._reactInternalInstance = undefined;
  },

  get: function (key) {
    return key._reactInternalInstance;
  },

  has: function (key) {
    return key._reactInternalInstance !== undefined;
  },

  set: function (key, value) {
    key._reactInternalInstance = value;
  }
};

module.exports = ReactInstanceMap;

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Brand; });
/* unused harmony export H1 */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return H2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return Subtitle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return Link; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return Label; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return MenuLink; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CardTitle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return MenuH2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return XSmall; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return ProfileName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return PushTitle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return SearchLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return SliderLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return SliderTitle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return SliderContent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return SliderSubtitle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return SliderDescription; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CardSmall; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return SubtitlePage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0____ = __webpack_require__(1);
var Brand={fontSize:'2.475rem',lineHeight:'1.2em',fontWeight:100,fontFamily:__WEBPACK_IMPORTED_MODULE_0____["Q" /* Font */].base,'@media (min-width: 1024px)':{fontSize:'8.25rem'}// Title H1
};var H1={fontSize:'2.4rem',lineHeight:'1em',textTransform:'uppercase',fontFamily:__WEBPACK_IMPORTED_MODULE_0____["Q" /* Font */].title+', sans-serif','@media (min-width: 1024px)':{fontSize:'4.8125rem'}// Title H1
};var H2={fontSize:'2rem',lineHeight:'1em',textTransform:'uppercase',fontFamily:__WEBPACK_IMPORTED_MODULE_0____["Q" /* Font */].title+', sans-serif',fontWeight:'bold','@media (min-width: 1024px)':{fontSize:'3.3rem'}};var Subtitle={fontWeight:100,fontSize:'2rem',fontFamily:__WEBPACK_IMPORTED_MODULE_0____["Q" /* Font */].base+', sans-serif','@media (min-width: 1024px)':{fontSize:'2.5rem'}};var Link={fontSize:'0.825rem',lineHeight:'1.2em',textTransform:'uppercase',textDecoration:'none',fontFamily:__WEBPACK_IMPORTED_MODULE_0____["Q" /* Font */].base,fontWeight:800,letterSpacing:'0.125rem',textIndent:'0.125rem'};var Label={fontSize:'1.325rem',fontFamily:__WEBPACK_IMPORTED_MODULE_0____["Q" /* Font */].base,fontWeight:200,'@media (min-width: 1024px)':{fontSize:'1.65rem'}//Menu 
};var MenuLink=Object.assign({},Link,{fontSize:'1rem',letterSpacing:0//Menu 
});var CardTitle=Object.assign({},Link,{fontSize:'1.125rem',letterSpacing:'0rem',textIndent:'0rem','@media (min-width: 1024px)':{letterSpacing:'0.125rem',textIndent:'0.125rem'}});var MenuH2={fontSize:'2.5rem',fontFamily:__WEBPACK_IMPORTED_MODULE_0____["Q" /* Font */].title_font,fontWeight:200,'@media (min-width: 1024px)':{fontSize:'3rem'}};var XSmall=Object.assign({},Link,{fontSize:'0.6rem',letterSpacing:0});var ProfileName={fontSize:'1.25rem',fontFamily:__WEBPACK_IMPORTED_MODULE_0____["Q" /* Font */].base,fontWeight:800,'@media (min-width: 1224px)':{fontSize:'0.9375rem'}};var PushTitle={fontSize:'2rem',fontFamily:__WEBPACK_IMPORTED_MODULE_0____["Q" /* Font */].base,fontWeight:800,lineHeight:1.2,letterSpacing:'0.125rem','@media (min-width: 1224px)':{fontSize:'2.5rem'}};var SearchLabel={fontSize:'1.25rem',fontFamily:__WEBPACK_IMPORTED_MODULE_0____["Q" /* Font */].base,fontWeight:200,lineHeight:1.2,'@media (min-width: 1024px)':{fontSize:'3.3rem',letterSpacing:'0.125rem'}// 13px
};var SliderLabel={fontSize:'0.8125rem',fontFamily:__WEBPACK_IMPORTED_MODULE_0____["Q" /* Font */].base,lineHeight:1.2,fontWeight:800,textTransform:'uppercase'// SLIDER
};var SliderTitle={fontSize:'2.8125rem',fontFamily:__WEBPACK_IMPORTED_MODULE_0____["Q" /* Font */].title,lineHeight:1.2,fontWeight:'bold',textTransform:'uppercase',marginBottom:'2rem','@media (min-width: 1024px)':{fontSize:'4.375rem',marginBottom:'4rem'}};var SliderContent={fontSize:'1.125rem',fontFamily:__WEBPACK_IMPORTED_MODULE_0____["Q" /* Font */].base,lineHeight:1.4};var SliderSubtitle={fontSize:'1.625rem',fontFamily:__WEBPACK_IMPORTED_MODULE_0____["Q" /* Font */].base,lineHeight:1.2,fontWeight:'bold','@media (min-width: 1024px)':{fontSize:'2.5rem'}};var SliderDescription={fontSize:'1rem',fontFamily:__WEBPACK_IMPORTED_MODULE_0____["Q" /* Font */].base,lineHeight:1.2,fontWeight:400};var CardSmall={fontSize:'0.8125rem',fontFamily:__WEBPACK_IMPORTED_MODULE_0____["Q" /* Font */].base,lineHeight:1.2};var SubtitlePage={fontSize:'1.875rem',fontFamily:__WEBPACK_IMPORTED_MODULE_0____["Q" /* Font */].base,lineHeight:1.2,textTransform:'uppercase',fontWeight:'bold'};

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Logo__ = __webpack_require__(416);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_0__Logo__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Load__ = __webpack_require__(417);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_1__Load__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__User__ = __webpack_require__(418);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_2__User__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RM__ = __webpack_require__(419);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_3__RM__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Search__ = __webpack_require__(420);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_4__Search__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Bookmark__ = __webpack_require__(421);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_5__Bookmark__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__BookmarkPlain__ = __webpack_require__(422);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_6__BookmarkPlain__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Notification__ = __webpack_require__(423);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_7__Notification__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Pdf__ = __webpack_require__(424);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_8__Pdf__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ArrowBack__ = __webpack_require__(425);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_9__ArrowBack__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Triangle__ = __webpack_require__(426);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_10__Triangle__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Upload__ = __webpack_require__(427);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_11__Upload__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Alert__ = __webpack_require__(428);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_12__Alert__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Arrow__ = __webpack_require__(429);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_13__Arrow__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__ArrowDrop__ = __webpack_require__(430);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_14__ArrowDrop__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Generate__ = __webpack_require__(431);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_15__Generate__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Store__ = __webpack_require__(432);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_16__Store__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Localisation__ = __webpack_require__(433);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_17__Localisation__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Print__ = __webpack_require__(434);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_18__Print__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Edit__ = __webpack_require__(435);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_19__Edit__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__Valid__ = __webpack_require__(436);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_20__Valid__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__Social__ = __webpack_require__(437);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_21__Social__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_21__Social__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_21__Social__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_21__Social__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_21__Social__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_21__Social__["f"]; });


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var require;//! moment.js
//! version : 2.29.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

    var hookCallback;

    function hooks() {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return (
            input instanceof Array ||
            Object.prototype.toString.call(input) === '[object Array]'
        );
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return (
            input != null &&
            Object.prototype.toString.call(input) === '[object Object]'
        );
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return Object.getOwnPropertyNames(obj).length === 0;
        } else {
            var k;
            for (k in obj) {
                if (hasOwnProp(obj, k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return (
            typeof input === 'number' ||
            Object.prototype.toString.call(input) === '[object Number]'
        );
    }

    function isDate(input) {
        return (
            input instanceof Date ||
            Object.prototype.toString.call(input) === '[object Date]'
        );
    }

    function map(arr, fn) {
        var res = [],
            i;
        for (i = 0; i < arr.length; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false,
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this),
                len = t.length >>> 0,
                i;

            for (i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m),
                parsedParts = some.call(flags.parsedDateParts, function (i) {
                    return i != null;
                }),
                isNowValid =
                    !isNaN(m._d.getTime()) &&
                    flags.overflow < 0 &&
                    !flags.empty &&
                    !flags.invalidEra &&
                    !flags.invalidMonth &&
                    !flags.invalidWeekday &&
                    !flags.weekdayMismatch &&
                    !flags.nullInput &&
                    !flags.invalidFormat &&
                    !flags.userInvalidated &&
                    (!flags.meridiem || (flags.meridiem && parsedParts));

            if (m._strict) {
                isNowValid =
                    isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }

            if (Object.isFrozen == null || !Object.isFrozen(m)) {
                m._isValid = isNowValid;
            } else {
                return isNowValid;
            }
        }
        return m._isValid;
    }

    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        } else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = (hooks.momentProperties = []),
        updateInProgress = false;

    function copyConfig(to, from) {
        var i, prop, val;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentProperties.length > 0) {
            for (i = 0; i < momentProperties.length; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment(obj) {
        return (
            obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
        );
    }

    function warn(msg) {
        if (
            hooks.suppressDeprecationWarnings === false &&
            typeof console !== 'undefined' &&
            console.warn
        ) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [],
                    arg,
                    i,
                    key;
                for (i = 0; i < arguments.length; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (key in arguments[0]) {
                            if (hasOwnProp(arguments[0], key)) {
                                arg += key + ': ' + arguments[0][key] + ', ';
                            }
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(
                    msg +
                        '\nArguments: ' +
                        Array.prototype.slice.call(args).join('') +
                        '\n' +
                        new Error().stack
                );
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return (
            (typeof Function !== 'undefined' && input instanceof Function) ||
            Object.prototype.toString.call(input) === '[object Function]'
        );
    }

    function set(config) {
        var prop, i;
        for (i in config) {
            if (hasOwnProp(config, i)) {
                prop = config[i];
                if (isFunction(prop)) {
                    this[i] = prop;
                } else {
                    this['_' + i] = prop;
                }
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' +
                /\d{1,2}/.source
        );
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig),
            prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (
                hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])
            ) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i,
                res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L',
    };

    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (
            (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
            absNumber
        );
    }

    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
        formatFunctions = {},
        formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(
                    func.apply(this, arguments),
                    token
                );
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens),
            i,
            length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '',
                i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i])
                    ? array[i].call(mom, format)
                    : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] =
            formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(
                localFormattingTokens,
                replaceLongDateFormatTokens
            );
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A',
    };

    function longDateFormat(key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper
            .match(formattingTokens)
            .map(function (tok) {
                if (
                    tok === 'MMMM' ||
                    tok === 'MM' ||
                    tok === 'DD' ||
                    tok === 'dddd'
                ) {
                    return tok.slice(1);
                }
                return tok;
            })
            .join('');

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate() {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d',
        defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years',
    };

    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output)
            ? output(number, withoutSuffix, string, isFuture)
            : output.replace(/%d/i, number);
    }

    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {};

    function addUnitAlias(unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string'
            ? aliases[units] || aliases[units.toLowerCase()]
            : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {};

    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }

    function getPrioritizedUnits(unitsObj) {
        var units = [],
            u;
        for (u in unitsObj) {
            if (hasOwnProp(unitsObj, u)) {
                units.push({ unit: u, priority: priorities[u] });
            }
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    function absFloor(number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    function makeGetSet(unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get(mom, unit) {
        return mom.isValid()
            ? mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]()
            : NaN;
    }

    function set$1(mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (
                unit === 'FullYear' &&
                isLeapYear(mom.year()) &&
                mom.month() === 1 &&
                mom.date() === 29
            ) {
                value = toInt(value);
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](
                    value,
                    mom.month(),
                    daysInMonth(value, mom.month())
                );
            } else {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
            }
        }
    }

    // MOMENTS

    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }

    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units),
                i;
            for (i = 0; i < prioritized.length; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    var match1 = /\d/, //       0 - 9
        match2 = /\d\d/, //      00 - 99
        match3 = /\d{3}/, //     000 - 999
        match4 = /\d{4}/, //    0000 - 9999
        match6 = /[+-]?\d{6}/, // -999999 - 999999
        match1to2 = /\d\d?/, //       0 - 99
        match3to4 = /\d\d\d\d?/, //     999 - 9999
        match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
        match1to3 = /\d{1,3}/, //       0 - 999
        match1to4 = /\d{1,4}/, //       0 - 9999
        match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
        matchUnsigned = /\d+/, //       0 - inf
        matchSigned = /[+-]?\d+/, //    -inf - inf
        matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
        matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
        matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
        // any word (or two) characters or numbers including two/three word month in arabic.
        // includes scottish gaelic two word and hyphenated months
        matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
        regexes;

    regexes = {};

    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex)
            ? regex
            : function (isStrict, localeData) {
                  return isStrict && strictRegex ? strictRegex : regex;
              };
    }

    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(
            s
                .replace('\\', '')
                .replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (
                    matched,
                    p1,
                    p2,
                    p3,
                    p4
                ) {
                    return p1 || p2 || p3 || p4;
                })
        );
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken(token, callback) {
        var i,
            func = callback;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        for (i = 0; i < token.length; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken(token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0,
        MONTH = 1,
        DATE = 2,
        HOUR = 3,
        MINUTE = 4,
        SECOND = 5,
        MILLISECOND = 6,
        WEEK = 7,
        WEEKDAY = 8;

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1
            ? isLeapYear(year)
                ? 29
                : 28
            : 31 - ((modMonth % 7) % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias('month', 'M');

    // PRIORITY

    addUnitPriority('month', 8);

    // PARSING

    addRegexToken('M', match1to2);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split(
            '_'
        ),
        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
        defaultMonthsShortRegex = matchWord,
        defaultMonthsRegex = matchWord;

    function localeMonths(m, format) {
        if (!m) {
            return isArray(this._months)
                ? this._months
                : this._months['standalone'];
        }
        return isArray(this._months)
            ? this._months[m.month()]
            : this._months[
                  (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
                      ? 'format'
                      : 'standalone'
              ][m.month()];
    }

    function localeMonthsShort(m, format) {
        if (!m) {
            return isArray(this._monthsShort)
                ? this._monthsShort
                : this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort)
            ? this._monthsShort[m.month()]
            : this._monthsShort[
                  MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
              ][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i,
            ii,
            mom,
            llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp(
                    '^' + this.months(mom, '').replace('.', '') + '$',
                    'i'
                );
                this._shortMonthsParse[i] = new RegExp(
                    '^' + this.monthsShort(mom, '').replace('.', '') + '$',
                    'i'
                );
            }
            if (!strict && !this._monthsParse[i]) {
                regex =
                    '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'MMMM' &&
                this._longMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'MMM' &&
                this._shortMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth(mom, value) {
        var dayOfMonth;

        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }

    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict
                ? this._monthsShortStrictRegex
                : this._monthsShortRegex;
        }
    }

    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict
                ? this._monthsStrictRegex
                : this._monthsRegex;
        }
    }

    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 12; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for (i = 0; i < 24; i++) {
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._monthsShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY', 4], 0, 'year');
    addFormatToken(0, ['YYYYY', 5], 0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // ALIASES

    addUnitAlias('year', 'y');

    // PRIORITIES

    addUnitPriority('year', 1);

    // PARSING

    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] =
            input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear() {
        return isLeapYear(this.year());
    }

    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) {
                date.setFullYear(y);
            }
        } else {
            date = new Date(y, m, d, h, M, s, ms);
        }

        return date;
    }

    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) {
                date.setUTCFullYear(y);
            }
        } else {
            date = new Date(Date.UTC.apply(null, arguments));
        }

        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear,
            resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear,
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek,
            resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear,
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    // PRIORITIES

    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);

    // PARSING

    addRegexToken('w', match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (
        input,
        week,
        config,
        token
    ) {
        week[token.substr(0, 1)] = toInt(input);
    });

    // HELPERS

    // LOCALES

    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow: 0, // Sunday is the first day of the week.
        doy: 6, // The week that contains Jan 6th is the first week of the year.
    };

    function localeFirstDayOfWeek() {
        return this._week.dow;
    }

    function localeFirstDayOfYear() {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    // PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);

    // PARSING

    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }

    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        defaultWeekdaysRegex = matchWord,
        defaultWeekdaysShortRegex = matchWord,
        defaultWeekdaysMinRegex = matchWord;

    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays)
            ? this._weekdays
            : this._weekdays[
                  m && m !== true && this._weekdays.isFormat.test(format)
                      ? 'format'
                      : 'standalone'
              ];
        return m === true
            ? shiftWeekdays(weekdays, this._week.dow)
            : m
            ? weekdays[m.day()]
            : weekdays;
    }

    function localeWeekdaysShort(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysShort, this._week.dow)
            : m
            ? this._weekdaysShort[m.day()]
            : this._weekdaysShort;
    }

    function localeWeekdaysMin(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysMin, this._week.dow)
            : m
            ? this._weekdaysMin[m.day()]
            : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i,
            ii,
            mom,
            llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._shortWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._minWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
            }
            if (!this._weekdaysParse[i]) {
                regex =
                    '^' +
                    this.weekdays(mom, '') +
                    '|^' +
                    this.weekdaysShort(mom, '') +
                    '|^' +
                    this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'dddd' &&
                this._fullWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'ddd' &&
                this._shortWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'dd' &&
                this._minWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict
                ? this._weekdaysStrictRegex
                : this._weekdaysRegex;
        }
    }

    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict
                ? this._weekdaysShortStrictRegex
                : this._weekdaysShortRegex;
        }
    }

    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict
                ? this._weekdaysMinStrictRegex
                : this._weekdaysMinRegex;
        }
    }

    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [],
            shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom,
            minp,
            shortp,
            longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._weekdaysShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
        this._weekdaysMinStrictRegex = new RegExp(
            '^(' + minPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return (
            '' +
            hFormat.apply(this) +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return (
            '' +
            this.hours() +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(
                this.hours(),
                this.minutes(),
                lowercase
            );
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // ALIASES

    addUnitAlias('hour', 'h');

    // PRIORITY
    addUnitPriority('hour', 13);

    // PARSING

    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2);
    addRegexToken('h', match1to2);
    addRegexToken('k', match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
        // Setting the hour should keep the time, because the user explicitly
        // specified which hour they want. So trying to maintain the same hour (in
        // a new timezone) makes sense. Adding/subtracting hours does not follow
        // this rule.
        getSetHour = makeGetSet('Hours', true);

    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse,
    };

    // internal storage for locale config files
    var locales = {},
        localeFamilies = {},
        globalLocale;

    function commonPrefix(arr1, arr2) {
        var i,
            minl = Math.min(arr1.length, arr2.length);
        for (i = 0; i < minl; i += 1) {
            if (arr1[i] !== arr2[i]) {
                return i;
            }
        }
        return minl;
    }

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0,
            j,
            next,
            locale,
            split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (
                    next &&
                    next.length >= j &&
                    commonPrefix(split, next) >= j - 1
                ) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function loadLocale(name) {
        var oldLocale = null,
            aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (
            locales[name] === undefined &&
            typeof module !== 'undefined' &&
            module &&
            module.exports
        ) {
            try {
                oldLocale = globalLocale._abbr;
                aliasedRequire = require;
                !(function webpackMissingModule() { var e = new Error("Cannot find module \"./locale\""); e.code = 'MODULE_NOT_FOUND'; throw e; }());
                getSetGlobalLocale(oldLocale);
            } catch (e) {
                // mark as not found to avoid repeating expensive file require call causing high CPU
                // when trying to find en-US, en_US, en-us for every format call
                locales[name] = null; // null means not found
            }
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            } else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            } else {
                if (typeof console !== 'undefined' && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn(
                        'Locale ' + key + ' not found. Did you forget to load it?'
                    );
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale(name, config) {
        if (config !== null) {
            var locale,
                parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple(
                    'defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
                );
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config,
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);

            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale,
                tmpLocale,
                parentConfig = baseConfig;

            if (locales[name] != null && locales[name].parentLocale != null) {
                // Update existing child locale in-place to avoid memory-leaks
                locales[name].set(mergeConfigs(locales[name]._config, config));
            } else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) {
                    parentConfig = tmpLocale._config;
                }
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) {
                    // updateLocale is called for creating a new locale
                    // Set abbr so it will have a name (getters return
                    // undefined otherwise).
                    config.abbr = name;
                }
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                    if (name === getSetGlobalLocale()) {
                        getSetGlobalLocale(name);
                    }
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale(key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow(m) {
        var overflow,
            a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH] < 0 || a[MONTH] > 11
                    ? MONTH
                    : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
                    ? DATE
                    : a[HOUR] < 0 ||
                      a[HOUR] > 24 ||
                      (a[HOUR] === 24 &&
                          (a[MINUTE] !== 0 ||
                              a[SECOND] !== 0 ||
                              a[MILLISECOND] !== 0))
                    ? HOUR
                    : a[MINUTE] < 0 || a[MINUTE] > 59
                    ? MINUTE
                    : a[SECOND] < 0 || a[SECOND] > 59
                    ? SECOND
                    : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
                    ? MILLISECOND
                    : -1;

            if (
                getParsingFlags(m)._overflowDayOfYear &&
                (overflow < YEAR || overflow > DATE)
            ) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
        isoDates = [
            ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
            ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
            ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
            ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
            ['YYYY-DDD', /\d{4}-\d{3}/],
            ['YYYY-MM', /\d{4}-\d\d/, false],
            ['YYYYYYMMDD', /[+-]\d{10}/],
            ['YYYYMMDD', /\d{8}/],
            ['GGGG[W]WWE', /\d{4}W\d{3}/],
            ['GGGG[W]WW', /\d{4}W\d{2}/, false],
            ['YYYYDDD', /\d{7}/],
            ['YYYYMM', /\d{6}/, false],
            ['YYYY', /\d{4}/, false],
        ],
        // iso time formats and regexes
        isoTimes = [
            ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
            ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
            ['HH:mm:ss', /\d\d:\d\d:\d\d/],
            ['HH:mm', /\d\d:\d\d/],
            ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
            ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
            ['HHmmss', /\d\d\d\d\d\d/],
            ['HHmm', /\d\d\d\d/],
            ['HH', /\d\d/],
        ],
        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
        // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
        rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
        obsOffsets = {
            UT: 0,
            GMT: 0,
            EDT: -4 * 60,
            EST: -5 * 60,
            CDT: -5 * 60,
            CST: -6 * 60,
            MDT: -6 * 60,
            MST: -7 * 60,
            PDT: -7 * 60,
            PST: -8 * 60,
        };

    // date from iso format
    function configFromISO(config) {
        var i,
            l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime,
            dateFormat,
            timeFormat,
            tzFormat;

        if (match) {
            getParsingFlags(config).iso = true;

            for (i = 0, l = isoDates.length; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimes.length; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    function extractFromRFC2822Strings(
        yearStr,
        monthStr,
        dayStr,
        hourStr,
        minuteStr,
        secondStr
    ) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10),
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s
            .replace(/\([^)]*\)|[\n\t]/g, ' ')
            .replace(/(\s\s+)/g, ' ')
            .replace(/^\s\s*/, '')
            .replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(
                    parsedInput[0],
                    parsedInput[1],
                    parsedInput[2]
                ).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10),
                m = hm % 100,
                h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)),
            parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(
                match[4],
                match[3],
                match[2],
                match[5],
                match[6],
                match[7]
            );
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        if (config._strict) {
            config._isValid = false;
        } else {
            // Final attempt, use Input Fallback
            hooks.createFromInputFallback(config);
        }
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
            'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
            'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [
                nowValue.getUTCFullYear(),
                nowValue.getUTCMonth(),
                nowValue.getUTCDate(),
            ];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i,
            date,
            input = [],
            currentDate,
            expectedWeekday,
            yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (
                config._dayOfYear > daysInYear(yearToUse) ||
                config._dayOfYear === 0
            ) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] =
                config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (
            config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0
        ) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(
            null,
            input
        );
        expectedWeekday = config._useUTC
            ? config._d.getUTCDay()
            : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (
            config._w &&
            typeof config._w.d !== 'undefined' &&
            config._w.d !== expectedWeekday
        ) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(
                w.GG,
                config._a[YEAR],
                weekOfYear(createLocal(), 1, 4).year
            );
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to beginning of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i,
            parsedInput,
            tokens,
            token,
            skipped,
            stringLength = string.length,
            totalParsedInputLength = 0,
            era;

        tokens =
            expandFormat(config._f, config._locale).match(formattingTokens) || [];

        for (i = 0; i < tokens.length; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) ||
                [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(
                    string.indexOf(parsedInput) + parsedInput.length
                );
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                } else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver =
            stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (
            config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0
        ) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(
            config._locale,
            config._a[HOUR],
            config._meridiem
        );

        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) {
            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        }

        configFromArray(config);
        checkOverflow(config);
    }

    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,
            scoreToBeat,
            i,
            currentScore,
            validFormatFound,
            bestFormatIsValid = false;

        if (config._f.length === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < config._f.length; i++) {
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (isValid(tempConfig)) {
                validFormatFound = true;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (!bestFormatIsValid) {
                if (
                    scoreToBeat == null ||
                    currentScore < scoreToBeat ||
                    validFormatFound
                ) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) {
                        bestFormatIsValid = true;
                    }
                }
            } else {
                if (currentScore < scoreToBeat) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                }
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i),
            dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map(
            [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
            function (obj) {
                return obj && parseInt(obj, 10);
            }
        );

        configFromArray(config);
    }

    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig(config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({ nullInput: true });
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        } else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};

        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if (
            (isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)
        ) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
            'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other < this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        ),
        prototypeMax = deprecate(
            'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other > this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +new Date();
    };

    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond',
    ];

    function isDurationValid(m) {
        var key,
            unitHasDecimal = false,
            i;
        for (key in m) {
            if (
                hasOwnProp(m, key) &&
                !(
                    indexOf.call(ordering, key) !== -1 &&
                    (m[key] == null || !isNaN(m[key]))
                )
            ) {
                return false;
            }
        }

        for (i = 0; i < ordering.length; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds =
            +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration(obj) {
        return obj instanceof Duration;
    }

    function absRound(number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if (
                (dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
            ) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    // FORMATTING

    function offset(token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset(),
                sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return (
                sign +
                zeroFill(~~(offset / 60), 2) +
                separator +
                zeroFill(~~offset % 60, 2)
            );
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher),
            chunk,
            parts,
            minutes;

        if (matches === null) {
            return null;
        }

        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff =
                (isMoment(input) || isDate(input)
                    ? input.valueOf()
                    : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(
                        this,
                        createDuration(input - offset, 'm'),
                        1,
                        false
                    );
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset() {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            } else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset(input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime() {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {},
            other;

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted =
                this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
        // and further modified to allow for strings containing both week and day
        isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration(input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms: input._milliseconds,
                d: input._days,
                M: input._months,
            };
        } else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) {
                duration[key] = +input;
            } else {
                duration.milliseconds = +input;
            }
        } else if ((match = aspNetRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
            };
        } else if ((match = isoRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign),
            };
        } else if (duration == null) {
            // checks for null or undefined
            duration = {};
        } else if (
            typeof duration === 'object' &&
            ('from' in duration || 'to' in duration)
        ) {
            diffRes = momentsDifference(
                createLocal(duration.from),
                createLocal(duration.to)
            );

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
            ret._isValid = input._isValid;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {};

        res.months =
            other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +base.clone().add(res.months, 'M');

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return { milliseconds: 0, months: 0 };
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(
                    name,
                    'moment().' +
                        name +
                        '(period, number) is deprecated. Please use moment().' +
                        name +
                        '(number, period). ' +
                        'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
                );
                tmp = val;
                val = period;
                period = tmp;
            }

            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add = createAdder(1, 'add'),
        subtract = createAdder(-1, 'subtract');

    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }

    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return (
            isMoment(input) ||
            isDate(input) ||
            isString(input) ||
            isNumber(input) ||
            isNumberOrStringArray(input) ||
            isMomentInputObject(input) ||
            input === null ||
            input === undefined
        );
    }

    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'years',
                'year',
                'y',
                'months',
                'month',
                'M',
                'days',
                'day',
                'd',
                'dates',
                'date',
                'D',
                'hours',
                'hour',
                'h',
                'minutes',
                'minute',
                'm',
                'seconds',
                'second',
                's',
                'milliseconds',
                'millisecond',
                'ms',
            ],
            i,
            property;

        for (i = 0; i < properties.length; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input),
            dataTypeTest = false;
        if (arrayTest) {
            dataTypeTest =
                input.filter(function (item) {
                    return !isNumber(item) && isString(input);
                }).length === 0;
        }
        return arrayTest && dataTypeTest;
    }

    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'sameDay',
                'nextDay',
                'lastDay',
                'nextWeek',
                'lastWeek',
                'sameElse',
            ],
            i,
            property;

        for (i = 0; i < properties.length; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6
            ? 'sameElse'
            : diff < -1
            ? 'lastWeek'
            : diff < 0
            ? 'lastDay'
            : diff < 1
            ? 'sameDay'
            : diff < 2
            ? 'nextDay'
            : diff < 7
            ? 'nextWeek'
            : 'sameElse';
    }

    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse',
            output =
                formats &&
                (isFunction(formats[format])
                    ? formats[format].call(this, now)
                    : formats[format]);

        return this.format(
            output || this.localeData().calendar(format, this, createLocal(now))
        );
    }

    function clone() {
        return new Moment(this);
    }

    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from),
            localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
            return false;
        }
        inclusivity = inclusivity || '()';
        return (
            (inclusivity[0] === '('
                ? this.isAfter(localFrom, units)
                : !this.isBefore(localFrom, units)) &&
            (inclusivity[1] === ')'
                ? this.isBefore(localTo, units)
                : !this.isAfter(localTo, units))
        );
    }

    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return (
                this.clone().startOf(units).valueOf() <= inputMs &&
                inputMs <= this.clone().endOf(units).valueOf()
            );
        }
    }

    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }

    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }

    function diff(input, units, asFloat) {
        var that, zoneDelta, output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff(a, b) {
        if (a.date() < b.date()) {
            // end-of-month calculations work correct when the start month has more
            // days than the end month.
            return -monthDiff(b, a);
        }
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2,
            adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true,
            m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(
                m,
                utc
                    ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
                    : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
            );
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
                    .toISOString()
                    .replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(
            m,
            utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
        );
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect() {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment',
            zone = '',
            prefix,
            year,
            datetime,
            suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format(inputString) {
        if (!inputString) {
            inputString = this.isUtc()
                ? hooks.defaultFormatUtc
                : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ to: this, from: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ from: this, to: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData() {
        return this._locale;
    }

    var MS_PER_SECOND = 1000,
        MS_PER_MINUTE = 60 * MS_PER_SECOND,
        MS_PER_HOUR = 60 * MS_PER_MINUTE,
        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;

    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return ((dividend % divisor) + divisor) % divisor;
    }

    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return new Date(y, m, d).valueOf();
        }
    }

    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return Date.UTC(y, m, d);
        }
    }

    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(
                    this.year(),
                    this.month() - (this.month() % 3),
                    1
                );
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - this.weekday()
                );
                break;
            case 'isoWeek':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - (this.isoWeekday() - 1)
                );
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(
                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                    MS_PER_HOUR
                );
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time =
                    startOfDate(
                        this.year(),
                        this.month() - (this.month() % 3) + 3,
                        1
                    ) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - this.weekday() + 7
                    ) - 1;
                break;
            case 'isoWeek':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - (this.isoWeekday() - 1) + 7
                    ) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time +=
                    MS_PER_HOUR -
                    mod$1(
                        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                        MS_PER_HOUR
                    ) -
                    1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }

    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate() {
        return new Date(this.valueOf());
    }

    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond(),
        ];
    }

    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds(),
        };
    }

    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2() {
        return isValid(this);
    }

    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt() {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict,
        };
    }

    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');

    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
    addFormatToken('y', ['yy', 2], 0, 'eraYear');
    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');

    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);

    addParseToken(['N', 'NN', 'NNN', 'NNNN', 'NNNNN'], function (
        input,
        array,
        config,
        token
    ) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) {
            getParsingFlags(config).era = era;
        } else {
            getParsingFlags(config).invalidEra = input;
        }
    });

    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);

    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
    addParseToken(['yo'], function (input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) {
            match = input.match(config._locale._eraYearOrdinalRegex);
        }

        if (config._locale.eraYearOrdinalParse) {
            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        } else {
            array[YEAR] = parseInt(input, 10);
        }
    });

    function localeEras(m, format) {
        var i,
            l,
            date,
            eras = this._eras || getLocale('en')._eras;
        for (i = 0, l = eras.length; i < l; ++i) {
            switch (typeof eras[i].since) {
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }

            switch (typeof eras[i].until) {
                case 'undefined':
                    eras[i].until = +Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }

    function localeErasParse(eraName, format, strict) {
        var i,
            l,
            eras = this.eras(),
            name,
            abbr,
            narrow;
        eraName = eraName.toUpperCase();

        for (i = 0, l = eras.length; i < l; ++i) {
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();

            if (strict) {
                switch (format) {
                    case 'N':
                    case 'NN':
                    case 'NNN':
                        if (abbr === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNN':
                        if (name === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNNN':
                        if (narrow === eraName) {
                            return eras[i];
                        }
                        break;
                }
            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
                return eras[i];
            }
        }
    }

    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? +1 : -1;
        if (year === undefined) {
            return hooks(era.since).year();
        } else {
            return hooks(era.since).year() + (year - era.offset) * dir;
        }
    }

    function getEraName() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].name;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].name;
            }
        }

        return '';
    }

    function getEraNarrow() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].narrow;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].narrow;
            }
        }

        return '';
    }

    function getEraAbbr() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].abbr;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].abbr;
            }
        }

        return '';
    }

    function getEraYear() {
        var i,
            l,
            dir,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            dir = eras[i].since <= eras[i].until ? +1 : -1;

            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (
                (eras[i].since <= val && val <= eras[i].until) ||
                (eras[i].until <= val && val <= eras[i].since)
            ) {
                return (
                    (this.year() - hooks(eras[i].since).year()) * dir +
                    eras[i].offset
                );
            }
        }

        return this.year();
    }

    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }

    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }

    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }

    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }

    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }

    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }

    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }

    function computeErasParse() {
        var abbrPieces = [],
            namePieces = [],
            narrowPieces = [],
            mixedPieces = [],
            i,
            l,
            eras = this.eras();

        for (i = 0, l = eras.length; i < l; ++i) {
            namePieces.push(regexEscape(eras[i].name));
            abbrPieces.push(regexEscape(eras[i].abbr));
            narrowPieces.push(regexEscape(eras[i].narrow));

            mixedPieces.push(regexEscape(eras[i].name));
            mixedPieces.push(regexEscape(eras[i].abbr));
            mixedPieces.push(regexEscape(eras[i].narrow));
        }

        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp(
            '^(' + narrowPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    // PRIORITY

    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);

    // PARSING

    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);

    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (
        input,
        week,
        config,
        token
    ) {
        week[token.substr(0, 2)] = toInt(input);
    });

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.week(),
            this.weekday(),
            this.localeData()._week.dow,
            this.localeData()._week.doy
        );
    }

    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.isoWeek(),
            this.isoWeekday(),
            1,
            4
        );
    }

    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }

    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }

    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // ALIASES

    addUnitAlias('quarter', 'Q');

    // PRIORITY

    addUnitPriority('quarter', 7);

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter(input) {
        return input == null
            ? Math.ceil((this.month() + 1) / 3)
            : this.month((input - 1) * 3 + (this.month() % 3));
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // ALIASES

    addUnitAlias('date', 'D');

    // PRIORITY
    addUnitPriority('date', 9);

    // PARSING

    addRegexToken('D', match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict
            ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
            : locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // ALIASES

    addUnitAlias('dayOfYear', 'DDD');

    // PRIORITY
    addUnitPriority('dayOfYear', 4);

    // PARSING

    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear(input) {
        var dayOfYear =
            Math.round(
                (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
            ) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // ALIASES

    addUnitAlias('minute', 'm');

    // PRIORITY

    addUnitPriority('minute', 14);

    // PARSING

    addRegexToken('m', match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // ALIASES

    addUnitAlias('second', 's');

    // PRIORITY

    addUnitPriority('second', 15);

    // PARSING

    addRegexToken('s', match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });

    // ALIASES

    addUnitAlias('millisecond', 'ms');

    // PRIORITY

    addUnitPriority('millisecond', 16);

    // PARSING

    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);

    var token, getSetMillisecond;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }

    getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
            return 'Moment<' + this.format() + '>';
        };
    }
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate(
        'dates accessor is deprecated. Use date instead.',
        getSetDayOfMonth
    );
    proto.months = deprecate(
        'months accessor is deprecated. Use month instead',
        getSetMonth
    );
    proto.years = deprecate(
        'years accessor is deprecated. Use year instead',
        getSetYear
    );
    proto.zone = deprecate(
        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
        getSetZone
    );
    proto.isDSTShifted = deprecate(
        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
        isDaylightSavingTimeShifted
    );

    function createUnix(input) {
        return createLocal(input * 1000);
    }

    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat(string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;

    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;

    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1(format, index, field, setter) {
        var locale = getLocale(),
            utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i,
            out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0,
            i,
            out = [];

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: +Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD',
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC',
            },
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    toInt((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
    });

    // Side effect imports

    hooks.lang = deprecate(
        'moment.lang is deprecated. Use moment.locale instead.',
        getSetGlobalLocale
    );
    hooks.langData = deprecate(
        'moment.langData is deprecated. Use moment.localeData instead.',
        getLocale
    );

    var mathAbs = Math.abs;

    function abs() {
        var data = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);

        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);

        return this;
    }

    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil(number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble() {
        var milliseconds = this._milliseconds,
            days = this._days,
            months = this._months,
            data = this._data,
            seconds,
            minutes,
            hours,
            years,
            monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (
            !(
                (milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0)
            )
        ) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;

        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;

        hours = absFloor(minutes / 60);
        data.hours = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days = days;
        data.months = months;
        data.years = years;

        return this;
    }

    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return (days * 4800) / 146097;
    }

    function monthsToDays(months) {
        // the reverse of daysToMonths
        return (months * 146097) / 4800;
    }

    function as(units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days,
            months,
            milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch (units) {
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }

    // TODO: Use this.as('ms')?
    function valueOf$1() {
        if (!this.isValid()) {
            return NaN;
        }
        return (
            this._milliseconds +
            this._days * 864e5 +
            (this._months % 12) * 2592e6 +
            toInt(this._months / 12) * 31536e6
        );
    }

    function makeAs(alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms'),
        asSeconds = makeAs('s'),
        asMinutes = makeAs('m'),
        asHours = makeAs('h'),
        asDays = makeAs('d'),
        asWeeks = makeAs('w'),
        asMonths = makeAs('M'),
        asQuarters = makeAs('Q'),
        asYears = makeAs('y');

    function clone$1() {
        return createDuration(this);
    }

    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds'),
        seconds = makeGetter('seconds'),
        minutes = makeGetter('minutes'),
        hours = makeGetter('hours'),
        days = makeGetter('days'),
        months = makeGetter('months'),
        years = makeGetter('years');

    function weeks() {
        return absFloor(this.days() / 7);
    }

    var round = Math.round,
        thresholds = {
            ss: 44, // a few seconds to seconds
            s: 45, // seconds to minute
            m: 45, // minutes to hour
            h: 22, // hours to day
            d: 26, // days to month/week
            w: null, // weeks to month
            M: 11, // months to year
        };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(),
            seconds = round(duration.as('s')),
            minutes = round(duration.as('m')),
            hours = round(duration.as('h')),
            days = round(duration.as('d')),
            months = round(duration.as('M')),
            weeks = round(duration.as('w')),
            years = round(duration.as('y')),
            a =
                (seconds <= thresholds.ss && ['s', seconds]) ||
                (seconds < thresholds.s && ['ss', seconds]) ||
                (minutes <= 1 && ['m']) ||
                (minutes < thresholds.m && ['mm', minutes]) ||
                (hours <= 1 && ['h']) ||
                (hours < thresholds.h && ['hh', hours]) ||
                (days <= 1 && ['d']) ||
                (days < thresholds.d && ['dd', days]);

        if (thresholds.w != null) {
            a =
                a ||
                (weeks <= 1 && ['w']) ||
                (weeks < thresholds.w && ['ww', weeks]);
        }
        a = a ||
            (months <= 1 && ['M']) ||
            (months < thresholds.M && ['MM', months]) ||
            (years <= 1 && ['y']) || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var withSuffix = false,
            th = thresholds,
            locale,
            output;

        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') {
            withSuffix = argWithSuffix;
        }
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) {
                th.ss = argThresholds.s - 1;
            }
        }

        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000,
            days = abs$1(this._days),
            months = abs$1(this._months),
            minutes,
            hours,
            years,
            s,
            total = this.asSeconds(),
            totalSign,
            ymSign,
            daysSign,
            hmsSign;

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';

        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return (
            totalSign +
            'P' +
            (years ? ymSign + years + 'Y' : '') +
            (months ? ymSign + months + 'M' : '') +
            (days ? daysSign + days + 'D' : '') +
            (hours || minutes || seconds ? 'T' : '') +
            (hours ? hmsSign + hours + 'H' : '') +
            (minutes ? hmsSign + minutes + 'M' : '') +
            (seconds ? hmsSign + s + 'S' : '')
        );
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;

    proto$2.toIsoString = deprecate(
        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
        toISOString$1
    );
    proto$2.lang = lang;

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    //! moment.js

    hooks.version = '2.29.1';

    setHookCallback(createLocal);

    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD', // <input type="date" />
        TIME: 'HH:mm', // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
        WEEK: 'GGGG-[W]WW', // <input type="week" />
        MONTH: 'YYYY-MM', // <input type="month" />
    };

    return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(153)(module)))

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(191);


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(6);

var invariant = __webpack_require__(4);

var OBSERVED_ERROR = {};

/**
 * `Transaction` creates a black box that is able to wrap any method such that
 * certain invariants are maintained before and after the method is invoked
 * (Even if an exception is thrown while invoking the wrapped method). Whoever
 * instantiates a transaction can provide enforcers of the invariants at
 * creation time. The `Transaction` class itself will supply one additional
 * automatic invariant for you - the invariant that any transaction instance
 * should not be run while it is already being run. You would typically create a
 * single instance of a `Transaction` for reuse multiple times, that potentially
 * is used to wrap several different methods. Wrappers are extremely simple -
 * they only require implementing two methods.
 *
 * <pre>
 *                       wrappers (injected at creation time)
 *                                      +        +
 *                                      |        |
 *                    +-----------------|--------|--------------+
 *                    |                 v        |              |
 *                    |      +---------------+   |              |
 *                    |   +--|    wrapper1   |---|----+         |
 *                    |   |  +---------------+   v    |         |
 *                    |   |          +-------------+  |         |
 *                    |   |     +----|   wrapper2  |--------+   |
 *                    |   |     |    +-------------+  |     |   |
 *                    |   |     |                     |     |   |
 *                    |   v     v                     v     v   | wrapper
 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | +---+ +---+   +---------+   +---+ +---+ |
 *                    |  initialize                    close    |
 *                    +-----------------------------------------+
 * </pre>
 *
 * Use cases:
 * - Preserving the input selection ranges before/after reconciliation.
 *   Restoring selection even in the event of an unexpected error.
 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
 *   while guaranteeing that afterwards, the event system is reactivated.
 * - Flushing a queue of collected DOM mutations to the main UI thread after a
 *   reconciliation takes place in a worker thread.
 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
 *   content.
 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
 * - (Future use case): Layout calculations before and after DOM updates.
 *
 * Transactional plugin API:
 * - A module that has an `initialize` method that returns any precomputation.
 * - and a `close` method that accepts the precomputation. `close` is invoked
 *   when the wrapped process is completed, or has failed.
 *
 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
 * that implement `initialize` and `close`.
 * @return {Transaction} Single transaction for reuse in thread.
 *
 * @class Transaction
 */
var TransactionImpl = {
  /**
   * Sets up this instance so that it is prepared for collecting metrics. Does
   * so such that this setup method may be used on an instance that is already
   * initialized, in a way that does not consume additional memory upon reuse.
   * That can be useful if you decide to make your subclass of this mixin a
   * "PooledClass".
   */
  reinitializeTransaction: function () {
    this.transactionWrappers = this.getTransactionWrappers();
    if (this.wrapperInitData) {
      this.wrapperInitData.length = 0;
    } else {
      this.wrapperInitData = [];
    }
    this._isInTransaction = false;
  },

  _isInTransaction: false,

  /**
   * @abstract
   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
   */
  getTransactionWrappers: null,

  isInTransaction: function () {
    return !!this._isInTransaction;
  },

  /* eslint-disable space-before-function-paren */

  /**
   * Executes the function within a safety window. Use this for the top level
   * methods that result in large amounts of computation/mutations that would
   * need to be safety checked. The optional arguments helps prevent the need
   * to bind in many cases.
   *
   * @param {function} method Member of scope to call.
   * @param {Object} scope Scope to invoke from.
   * @param {Object?=} a Argument to pass to the method.
   * @param {Object?=} b Argument to pass to the method.
   * @param {Object?=} c Argument to pass to the method.
   * @param {Object?=} d Argument to pass to the method.
   * @param {Object?=} e Argument to pass to the method.
   * @param {Object?=} f Argument to pass to the method.
   *
   * @return {*} Return value from `method`.
   */
  perform: function (method, scope, a, b, c, d, e, f) {
    /* eslint-enable space-before-function-paren */
    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there is already an outstanding transaction.') : _prodInvariant('27') : void 0;
    var errorThrown;
    var ret;
    try {
      this._isInTransaction = true;
      // Catching errors makes debugging more difficult, so we start with
      // errorThrown set to true before setting it to false after calling
      // close -- if it's still set to true in the finally block, it means
      // one of these calls threw.
      errorThrown = true;
      this.initializeAll(0);
      ret = method.call(scope, a, b, c, d, e, f);
      errorThrown = false;
    } finally {
      try {
        if (errorThrown) {
          // If `method` throws, prefer to show that stack trace over any thrown
          // by invoking `closeAll`.
          try {
            this.closeAll(0);
          } catch (err) {}
        } else {
          // Since `method` didn't throw, we don't want to silence the exception
          // here.
          this.closeAll(0);
        }
      } finally {
        this._isInTransaction = false;
      }
    }
    return ret;
  },

  initializeAll: function (startIndex) {
    var transactionWrappers = this.transactionWrappers;
    for (var i = startIndex; i < transactionWrappers.length; i++) {
      var wrapper = transactionWrappers[i];
      try {
        // Catching errors makes debugging more difficult, so we start with the
        // OBSERVED_ERROR state before overwriting it with the real return value
        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
        // block, it means wrapper.initialize threw.
        this.wrapperInitData[i] = OBSERVED_ERROR;
        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
      } finally {
        if (this.wrapperInitData[i] === OBSERVED_ERROR) {
          // The initializer for wrapper i threw an error; initialize the
          // remaining wrappers but silence any exceptions from them to ensure
          // that the first error is the one to bubble up.
          try {
            this.initializeAll(i + 1);
          } catch (err) {}
        }
      }
    }
  },

  /**
   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
   * them the respective return values of `this.transactionWrappers.init[i]`
   * (`close`rs that correspond to initializers that failed will not be
   * invoked).
   */
  closeAll: function (startIndex) {
    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : _prodInvariant('28') : void 0;
    var transactionWrappers = this.transactionWrappers;
    for (var i = startIndex; i < transactionWrappers.length; i++) {
      var wrapper = transactionWrappers[i];
      var initData = this.wrapperInitData[i];
      var errorThrown;
      try {
        // Catching errors makes debugging more difficult, so we start with
        // errorThrown set to true before setting it to false after calling
        // close -- if it's still set to true in the finally block, it means
        // wrapper.close threw.
        errorThrown = true;
        if (initData !== OBSERVED_ERROR && wrapper.close) {
          wrapper.close.call(this, initData);
        }
        errorThrown = false;
      } finally {
        if (errorThrown) {
          // The closer for wrapper i threw an error; close the remaining
          // wrappers but silence any exceptions from them to ensure that the
          // first error is the one to bubble up.
          try {
            this.closeAll(i + 1);
          } catch (e) {}
        }
      }
    }
    this.wrapperInitData.length = 0;
  }
};

module.exports = TransactionImpl;

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticUIEvent = __webpack_require__(44);
var ViewportMetrics = __webpack_require__(111);

var getEventModifierState = __webpack_require__(72);

/**
 * @interface MouseEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var MouseEventInterface = {
  screenX: null,
  screenY: null,
  clientX: null,
  clientY: null,
  ctrlKey: null,
  shiftKey: null,
  altKey: null,
  metaKey: null,
  getModifierState: getEventModifierState,
  button: function (event) {
    // Webkit, Firefox, IE9+
    // which:  1 2 3
    // button: 0 1 2 (standard)
    var button = event.button;
    if ('which' in event) {
      return button;
    }
    // IE<9
    // which:  undefined
    // button: 0 0 0
    // button: 1 4 2 (onmouseup)
    return button === 2 ? 2 : button === 4 ? 1 : 0;
  },
  buttons: null,
  relatedTarget: function (event) {
    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
  },
  // "Proprietary" Interface.
  pageX: function (event) {
    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
  },
  pageY: function (event) {
    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);

module.exports = SyntheticMouseEvent;

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ExecutionEnvironment = __webpack_require__(16);
var DOMNamespaces = __webpack_require__(74);

var WHITESPACE_TEST = /^[ \r\n\t\f]/;
var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;

var createMicrosoftUnsafeLocalFunction = __webpack_require__(75);

// SVG temp container for IE lacking innerHTML
var reusableSVGContainer;

/**
 * Set the innerHTML property of a node, ensuring that whitespace is preserved
 * even in IE8.
 *
 * @param {DOMElement} node
 * @param {string} html
 * @internal
 */
var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
  // IE does not have innerHTML for SVG nodes, so instead we inject the
  // new markup in a temp node and then move the child nodes across into
  // the target node
  if (node.namespaceURI === DOMNamespaces.svg && !('innerHTML' in node)) {
    reusableSVGContainer = reusableSVGContainer || document.createElement('div');
    reusableSVGContainer.innerHTML = '<svg>' + html + '</svg>';
    var svgNode = reusableSVGContainer.firstChild;
    while (svgNode.firstChild) {
      node.appendChild(svgNode.firstChild);
    }
  } else {
    node.innerHTML = html;
  }
});

if (ExecutionEnvironment.canUseDOM) {
  // IE8: When updating a just created node with innerHTML only leading
  // whitespace is removed. When updating an existing node with innerHTML
  // whitespace in root TextNodes is also collapsed.
  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html

  // Feature detection; only IE8 is known to behave improperly like this.
  var testElement = document.createElement('div');
  testElement.innerHTML = ' ';
  if (testElement.innerHTML === '') {
    setInnerHTML = function (node, html) {
      // Magic theory: IE8 supposedly differentiates between added and updated
      // nodes when processing innerHTML, innerHTML on updated nodes suffers
      // from worse whitespace behavior. Re-adding a node like this triggers
      // the initial and more favorable whitespace behavior.
      // TODO: What to do on a detached node?
      if (node.parentNode) {
        node.parentNode.replaceChild(node, node);
      }

      // We also implement a workaround for non-visible tags disappearing into
      // thin air on IE8, this only happens if there is no visible text
      // in-front of the non-visible tags. Piggyback on the whitespace fix
      // and simply check if any non-visible tags appear in the source.
      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
        // Recover leading whitespace by temporarily prepending any character.
        // \uFEFF has the potential advantage of being zero-width/invisible.
        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
        // in hopes that this is preserved even if "\uFEFF" is transformed to
        // the actual Unicode character (by Babel, for example).
        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
        node.innerHTML = String.fromCharCode(0xfeff) + html;

        // deleteData leaves an empty `TextNode` which offsets the index of all
        // children. Definitely want to avoid this.
        var textNode = node.firstChild;
        if (textNode.data.length === 1) {
          node.removeChild(textNode);
        } else {
          textNode.deleteData(0, 1);
        }
      } else {
        node.innerHTML = html;
      }
    };
  }
  testElement = null;
}

module.exports = setInnerHTML;

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2016-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * Based on the escape-html library, which is used under the MIT License below:
 *
 * Copyright (c) 2012-2013 TJ Holowaychuk
 * Copyright (c) 2015 Andreas Lubbe
 * Copyright (c) 2015 Tiancheng "Timothy" Gu
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * 'Software'), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 *
 */



// code copied and modified from escape-html
/**
 * Module variables.
 * @private
 */

var matchHtmlRegExp = /["'&<>]/;

/**
 * Escape special characters in the given string of html.
 *
 * @param  {string} string The string to escape for inserting into HTML
 * @return {string}
 * @public
 */

function escapeHtml(string) {
  var str = '' + string;
  var match = matchHtmlRegExp.exec(str);

  if (!match) {
    return str;
  }

  var escape;
  var html = '';
  var index = 0;
  var lastIndex = 0;

  for (index = match.index; index < str.length; index++) {
    switch (str.charCodeAt(index)) {
      case 34:
        // "
        escape = '&quot;';
        break;
      case 38:
        // &
        escape = '&amp;';
        break;
      case 39:
        // '
        escape = '&#x27;'; // modified from escape-html; used to be '&#39'
        break;
      case 60:
        // <
        escape = '&lt;';
        break;
      case 62:
        // >
        escape = '&gt;';
        break;
      default:
        continue;
    }

    if (lastIndex !== index) {
      html += str.substring(lastIndex, index);
    }

    lastIndex = index + 1;
    html += escape;
  }

  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
}
// end code copied and modified from escape-html

/**
 * Escapes text to prevent scripting attacks.
 *
 * @param {*} text Text value to escape.
 * @return {string} An escaped string.
 */
function escapeTextContentForBrowser(text) {
  if (typeof text === 'boolean' || typeof text === 'number') {
    // this shortcircuit helps perf for types that we know will never have
    // special characters, especially given that this function is used often
    // for numeric dom ids.
    return '' + text;
  }
  return escapeHtml(text);
}

module.exports = escapeTextContentForBrowser;

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(9);

var EventPluginRegistry = __webpack_require__(67);
var ReactEventEmitterMixin = __webpack_require__(220);
var ViewportMetrics = __webpack_require__(111);

var getVendorPrefixedEventName = __webpack_require__(221);
var isEventSupported = __webpack_require__(71);

/**
 * Summary of `ReactBrowserEventEmitter` event handling:
 *
 *  - Top-level delegation is used to trap most native browser events. This
 *    may only occur in the main thread and is the responsibility of
 *    ReactEventListener, which is injected and can therefore support pluggable
 *    event sources. This is the only work that occurs in the main thread.
 *
 *  - We normalize and de-duplicate events to account for browser quirks. This
 *    may be done in the worker thread.
 *
 *  - Forward these native events (with the associated top-level type used to
 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
 *    to extract any synthetic events.
 *
 *  - The `EventPluginHub` will then process each event by annotating them with
 *    "dispatches", a sequence of listeners and IDs that care about that event.
 *
 *  - The `EventPluginHub` then dispatches the events.
 *
 * Overview of React and the event system:
 *
 * +------------+    .
 * |    DOM     |    .
 * +------------+    .
 *       |           .
 *       v           .
 * +------------+    .
 * | ReactEvent |    .
 * |  Listener  |    .
 * +------------+    .                         +-----------+
 *       |           .               +--------+|SimpleEvent|
 *       |           .               |         |Plugin     |
 * +-----|------+    .               v         +-----------+
 * |     |      |    .    +--------------+                    +------------+
 * |     +-----------.--->|EventPluginHub|                    |    Event   |
 * |            |    .    |              |     +-----------+  | Propagators|
 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
 * |            |    .    |              |     +-----------+  |  utilities |
 * |     +-----------.--->|              |                    +------------+
 * |     |      |    .    +--------------+
 * +-----|------+    .                ^        +-----------+
 *       |           .                |        |Enter/Leave|
 *       +           .                +-------+|Plugin     |
 * +-------------+   .                         +-----------+
 * | application |   .
 * |-------------|   .
 * |             |   .
 * |             |   .
 * +-------------+   .
 *                   .
 *    React Core     .  General Purpose Event Plugin System
 */

var hasEventPageXY;
var alreadyListeningTo = {};
var isMonitoringScrollValue = false;
var reactTopListenersCounter = 0;

// For events like 'submit' which don't consistently bubble (which we trap at a
// lower node than `document`), binding at `document` would cause duplicate
// events so we don't include them here
var topEventMapping = {
  topAbort: 'abort',
  topAnimationEnd: getVendorPrefixedEventName('animationend') || 'animationend',
  topAnimationIteration: getVendorPrefixedEventName('animationiteration') || 'animationiteration',
  topAnimationStart: getVendorPrefixedEventName('animationstart') || 'animationstart',
  topBlur: 'blur',
  topCanPlay: 'canplay',
  topCanPlayThrough: 'canplaythrough',
  topChange: 'change',
  topClick: 'click',
  topCompositionEnd: 'compositionend',
  topCompositionStart: 'compositionstart',
  topCompositionUpdate: 'compositionupdate',
  topContextMenu: 'contextmenu',
  topCopy: 'copy',
  topCut: 'cut',
  topDoubleClick: 'dblclick',
  topDrag: 'drag',
  topDragEnd: 'dragend',
  topDragEnter: 'dragenter',
  topDragExit: 'dragexit',
  topDragLeave: 'dragleave',
  topDragOver: 'dragover',
  topDragStart: 'dragstart',
  topDrop: 'drop',
  topDurationChange: 'durationchange',
  topEmptied: 'emptied',
  topEncrypted: 'encrypted',
  topEnded: 'ended',
  topError: 'error',
  topFocus: 'focus',
  topInput: 'input',
  topKeyDown: 'keydown',
  topKeyPress: 'keypress',
  topKeyUp: 'keyup',
  topLoadedData: 'loadeddata',
  topLoadedMetadata: 'loadedmetadata',
  topLoadStart: 'loadstart',
  topMouseDown: 'mousedown',
  topMouseMove: 'mousemove',
  topMouseOut: 'mouseout',
  topMouseOver: 'mouseover',
  topMouseUp: 'mouseup',
  topPaste: 'paste',
  topPause: 'pause',
  topPlay: 'play',
  topPlaying: 'playing',
  topProgress: 'progress',
  topRateChange: 'ratechange',
  topScroll: 'scroll',
  topSeeked: 'seeked',
  topSeeking: 'seeking',
  topSelectionChange: 'selectionchange',
  topStalled: 'stalled',
  topSuspend: 'suspend',
  topTextInput: 'textInput',
  topTimeUpdate: 'timeupdate',
  topTouchCancel: 'touchcancel',
  topTouchEnd: 'touchend',
  topTouchMove: 'touchmove',
  topTouchStart: 'touchstart',
  topTransitionEnd: getVendorPrefixedEventName('transitionend') || 'transitionend',
  topVolumeChange: 'volumechange',
  topWaiting: 'waiting',
  topWheel: 'wheel'
};

/**
 * To ensure no conflicts with other potential React instances on the page
 */
var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);

function getListeningForDocument(mountAt) {
  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
  // directly.
  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
    mountAt[topListenersIDKey] = reactTopListenersCounter++;
    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
  }
  return alreadyListeningTo[mountAt[topListenersIDKey]];
}

/**
 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
 * example:
 *
 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
 *
 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
 *
 * @internal
 */
var ReactBrowserEventEmitter = _assign({}, ReactEventEmitterMixin, {
  /**
   * Injectable event backend
   */
  ReactEventListener: null,

  injection: {
    /**
     * @param {object} ReactEventListener
     */
    injectReactEventListener: function (ReactEventListener) {
      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
    }
  },

  /**
   * Sets whether or not any created callbacks should be enabled.
   *
   * @param {boolean} enabled True if callbacks should be enabled.
   */
  setEnabled: function (enabled) {
    if (ReactBrowserEventEmitter.ReactEventListener) {
      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
    }
  },

  /**
   * @return {boolean} True if callbacks are enabled.
   */
  isEnabled: function () {
    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
  },

  /**
   * We listen for bubbled touch events on the document object.
   *
   * Firefox v8.01 (and possibly others) exhibited strange behavior when
   * mounting `onmousemove` events at some node that was not the document
   * element. The symptoms were that if your mouse is not moving over something
   * contained within that mount point (for example on the background) the
   * top-level listeners for `onmousemove` won't be called. However, if you
   * register the `mousemove` on the document object, then it will of course
   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
   * top-level listeners to the document object only, at least for these
   * movement types of events and possibly all events.
   *
   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
   *
   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
   * they bubble to document.
   *
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @param {object} contentDocumentHandle Document which owns the container
   */
  listenTo: function (registrationName, contentDocumentHandle) {
    var mountAt = contentDocumentHandle;
    var isListening = getListeningForDocument(mountAt);
    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];

    for (var i = 0; i < dependencies.length; i++) {
      var dependency = dependencies[i];
      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
        if (dependency === 'topWheel') {
          if (isEventSupported('wheel')) {
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'wheel', mountAt);
          } else if (isEventSupported('mousewheel')) {
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'mousewheel', mountAt);
          } else {
            // Firefox needs to capture a different mouse scroll event.
            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'DOMMouseScroll', mountAt);
          }
        } else if (dependency === 'topScroll') {
          if (isEventSupported('scroll', true)) {
            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topScroll', 'scroll', mountAt);
          } else {
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topScroll', 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
          }
        } else if (dependency === 'topFocus' || dependency === 'topBlur') {
          if (isEventSupported('focus', true)) {
            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topFocus', 'focus', mountAt);
            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topBlur', 'blur', mountAt);
          } else if (isEventSupported('focusin')) {
            // IE has `focusin` and `focusout` events which bubble.
            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topFocus', 'focusin', mountAt);
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topBlur', 'focusout', mountAt);
          }

          // to make sure blur and focus event listeners are only attached once
          isListening.topBlur = true;
          isListening.topFocus = true;
        } else if (topEventMapping.hasOwnProperty(dependency)) {
          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
        }

        isListening[dependency] = true;
      }
    }
  },

  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
  },

  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
  },

  /**
   * Protect against document.createEvent() returning null
   * Some popup blocker extensions appear to do this:
   * https://github.com/facebook/react/issues/6887
   */
  supportsEventPageXY: function () {
    if (!document.createEvent) {
      return false;
    }
    var ev = document.createEvent('MouseEvent');
    return ev != null && 'pageX' in ev;
  },

  /**
   * Listens to window scroll and resize events. We cache scroll values so that
   * application code can access them without triggering reflows.
   *
   * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
   * pageX/pageY isn't supported (legacy browsers).
   *
   * NOTE: Scroll events do not bubble.
   *
   * @see http://www.quirksmode.org/dom/events/scroll.html
   */
  ensureScrollValueMonitoring: function () {
    if (hasEventPageXY === undefined) {
      hasEventPageXY = ReactBrowserEventEmitter.supportsEventPageXY();
    }
    if (!hasEventPageXY && !isMonitoringScrollValue) {
      var refresh = ViewportMetrics.refreshScrollValues;
      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
      isMonitoringScrollValue = true;
    }
  }
});

module.exports = ReactBrowserEventEmitter;

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

/*eslint-disable no-self-compare */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _extends;
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * The public API for putting history on context.
 */

var Router = function (_React$Component) {
  _inherits(Router, _React$Component);

  function Router() {
    var _temp, _this, _ret;

    _classCallCheck(this, Router);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props.history.location.pathname)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Router.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        history: this.props.history,
        route: {
          location: this.props.history.location,
          match: this.state.match
        }
      })
    };
  };

  Router.prototype.computeMatch = function computeMatch(pathname) {
    return {
      path: "/",
      url: "/",
      params: {},
      isExact: pathname === "/"
    };
  };

  Router.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    var _props = this.props,
        children = _props.children,
        history = _props.history;


    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(children == null || __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 1, "A <Router> may have only one child element");

    // Do this here so we can setState when a <Redirect> changes the
    // location in componentWillMount. This happens e.g. when doing
    // server rendering using a <StaticRouter>.
    this.unlisten = history.listen(function () {
      _this2.setState({
        match: _this2.computeMatch(history.location.pathname)
      });
    });
  };

  Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(this.props.history === nextProps.history, "You cannot change <Router history>");
  };

  Router.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unlisten();
  };

  Router.prototype.render = function render() {
    var children = this.props.children;

    return children ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children) : null;
  };

  return Router;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Router.propTypes = {
  history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node
};
Router.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Router.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Router);

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compilePath = function compilePath(pattern, options) {
  var cacheKey = "" + options.end + options.strict + options.sensitive;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var keys = [];
  var re = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default()(pattern, keys, options);
  var compiledPattern = { re: re, keys: keys };

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledPattern;
    cacheCount++;
  }

  return compiledPattern;
};

/**
 * Public API for matching a URL pathname to a path pattern.
 */
var matchPath = function matchPath(pathname) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var parent = arguments[2];

  if (typeof options === "string") options = { path: options };

  var _options = options,
      path = _options.path,
      _options$exact = _options.exact,
      exact = _options$exact === undefined ? false : _options$exact,
      _options$strict = _options.strict,
      strict = _options$strict === undefined ? false : _options$strict,
      _options$sensitive = _options.sensitive,
      sensitive = _options$sensitive === undefined ? false : _options$sensitive;


  if (path == null) return parent;

  var _compilePath = compilePath(path, { end: exact, strict: strict, sensitive: sensitive }),
      re = _compilePath.re,
      keys = _compilePath.keys;

  var match = re.exec(pathname);

  if (!match) return null;

  var url = match[0],
      values = match.slice(1);

  var isExact = pathname === url;

  if (exact && !isExact) return null;

  return {
    path: path, // the path pattern used to match
    url: path === "/" && url === "" ? "/" : url, // the matched portion of the URL
    isExact: isExact, // whether or not we matched exactly
    params: keys.reduce(function (memo, key, index) {
      memo[key.name] = values[index];
      return memo;
    }, {})
  };
};

/* harmony default export */ __webpack_exports__["a"] = (matchPath);

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BodyMovin */
/* unused harmony export Icon */
/* unused harmony export IconsSprite */
/* unused harmony export SvgFromFile */
/* unused harmony export ScrollBlocker */
/* unused harmony export Transition */
/* unused harmony export withBehavior */
/* unused harmony export withComputed */
/* unused harmony export withResize */
/* unused harmony export withVisibility */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createReducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bodymovin__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bodymovin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_bodymovin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_chirashi__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_dom__);
/**
 * by-react-utils v0.0.18
 * (c) 2017 Alex Toudic
 * Released under MIT License.
 **/







var asyncToGenerator = function (fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
};

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();







var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var get = function get(object, property, receiver) {
  if (object === null) object = Function.prototype;
  var desc = Object.getOwnPropertyDescriptor(object, property);

  if (desc === undefined) {
    var parent = Object.getPrototypeOf(object);

    if (parent === null) {
      return undefined;
    } else {
      return get(parent, property, receiver);
    }
  } else if ("value" in desc) {
    return desc.value;
  } else {
    var getter = desc.get;

    if (getter === undefined) {
      return undefined;
    }

    return getter.call(receiver);
  }
};

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};











var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};



















var toConsumableArray = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  } else {
    return Array.from(arr);
  }
};

var BodyMovin = function (_Component) {
  inherits(BodyMovin, _Component);

  function BodyMovin() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, BodyMovin);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = BodyMovin.__proto__ || Object.getPrototypeOf(BodyMovin)).call.apply(_ref, [this].concat(args))), _this), _this.handleMouseEnter = function () {
      _this.tryToPlay();
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(BodyMovin, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      this.anim = __WEBPACK_IMPORTED_MODULE_1_bodymovin___default.a.loadAnimation(_extends({}, this.props, {
        container: this.node
      }));

      this.anim.addEventListener('complete', function () {
        return _this2.isPlaying = false;
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(_ref2) {
      var play = _ref2.play;

      if (play && !this.props.play) this.tryToPlay();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.anim.destroy();
    }
  }, {
    key: 'tryToPlay',
    value: function tryToPlay() {
      if (!this.isPlaying) {
        this.isPlaying = true;
        this.anim.goToAndPlay(0);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', {
        className: this.props.className,
        onMouseEnter: this.handleMouseEnter,
        ref: function ref(node) {
          return _this3.node = node;
        }
      });
    }
  }]);
  return BodyMovin;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

BodyMovin.defaultProps = {
  loop: false,
  autoplay: false,
  playOnOver: true,
  play: false
};

var Icon = (function (_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className,
      name = _ref.name;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'svg',
    { className: name + '-icon ' + className },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('use', { xlinkHref: '#' + name })
  );
});

var IconsSprite = (function (_ref) {
  var children$$1 = _ref.children;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'svg',
    { style: { display: 'none' } },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'defs',
      null,
      __WEBPACK_IMPORTED_MODULE_0_react__["Children"].map(children$$1, function (icon) {
        var name = icon.props.name;


        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'g',
          {
            key: name,
            id: name
          },
          icon
        );
      })
    )
  );
});

var SvgFromFile = function (_Component) {
  inherits(SvgFromFile, _Component);
  createClass(SvgFromFile, null, [{
    key: 'fetchElement',
    value: function fetchElement(path) {
      return fetch(path).then(function (data) {
        return data.text();
      }).then(function (text) {
        return text.slice(text.indexOf('<svg'));
      });
    }
  }]);

  function SvgFromFile(props) {
    var _ref,
        _this2 = this;

    classCallCheck(this, SvgFromFile);

    for (var _len = arguments.length, rest = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      rest[_key - 1] = arguments[_key];
    }

    var _this = possibleConstructorReturn(this, (_ref = SvgFromFile.__proto__ || Object.getPrototypeOf(SvgFromFile)).call.apply(_ref, [this, props].concat(rest)));

    _this.state = {
      svgElement: ''
    };


    if (props.path) {
      asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.t0 = _this;
                _context.next = 3;
                return SvgFromFile.fetchElement(props.path);

              case 3:
                _context.t1 = _context.sent;

                _context.t0.applySvg.call(_context.t0, _context.t1);

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    } else {
      _this.applySvg(props.file);
    }
    return _this;
  }

  createClass(SvgFromFile, [{
    key: 'applySvg',
    value: function applySvg(content) {
      var svgElement = Object(__WEBPACK_IMPORTED_MODULE_2_chirashi__["d" /* createElement */])();
      this.setState({ svgElement: svgElement });
      Object(__WEBPACK_IMPORTED_MODULE_2_chirashi__["a" /* append */])(this.node, Object(__WEBPACK_IMPORTED_MODULE_2_chirashi__["b" /* children */])(svgElement));
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      if (!this.state.svgElement) return null;

      var _getAttr = Object(__WEBPACK_IMPORTED_MODULE_2_chirashi__["g" /* getAttr */])(this.state.svgElement, 'viewBox', 'width', 'height'),
          viewBox = _getAttr.viewBox,
          width = _getAttr.width,
          height = _getAttr.height;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg', {
        id: this.props.name,
        viewBox: viewBox || '0 0 ' + width + ' ' + height,
        ref: function ref(node) {
          return _this3.node = node;
        }
      });
    }
  }]);
  return SvgFromFile;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var ScrollBlocker = function (_Component) {
  inherits(ScrollBlocker, _Component);

  function ScrollBlocker() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, ScrollBlocker);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = ScrollBlocker.__proto__ || Object.getPrototypeOf(ScrollBlocker)).call.apply(_ref, [this].concat(args))), _this), _this.scrollId = Object(__WEBPACK_IMPORTED_MODULE_3_lodash__["uniqueId"])('scroll-'), _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(ScrollBlocker, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      ScrollBlocker.toggleEnabled(this.scrollId, this.props.enabled);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(_ref2) {
      var enabled = _ref2.enabled;

      if (enabled === this.props.enabled) return;

      ScrollBlocker.toggleEnabled(this.scrollId, enabled);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      ScrollBlocker.toggleEnabled(this.scrollId, true);
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.children;
    }
  }], [{
    key: 'toggleEnabled',
    value: function toggleEnabled(scrollId, enabled) {
      if (enabled) {
        ScrollBlocker.retainers.splice(ScrollBlocker.retainers.indexOf(scrollId), 1);
      } else {
        ScrollBlocker.retainers.push(scrollId);
      }

      var previous = ScrollBlocker.blocked;
      ScrollBlocker.blocked = Boolean(ScrollBlocker.retainers.length);

      if (previous !== ScrollBlocker.blocked) {
        if (ScrollBlocker.blocked) {
          Object(__WEBPACK_IMPORTED_MODULE_2_chirashi__["i" /* setStyleProp */])(document.documentElement, { overflow: 'hidden' });
        } else {
          Object(__WEBPACK_IMPORTED_MODULE_2_chirashi__["c" /* clearStyle */])(document.documentElement, 'overflow');
        }
      }
    }
  }]);
  return ScrollBlocker;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

ScrollBlocker.blocked = false;
ScrollBlocker.retainers = [];
ScrollBlocker.defaultProps = {
  enabled: false
};

var Transition = function (_Component) {
  inherits(Transition, _Component);

  function Transition() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, Transition);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = Transition.__proto__ || Object.getPrototypeOf(Transition)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      show: true,
      enter: false,
      leave: false
    }, _this.toggleState = function () {
      _this.setState({
        show: _this.props.show,
        active: false
      });
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(Transition, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.toggleAnim(this.props);

      this.unbind = Object(__WEBPACK_IMPORTED_MODULE_2_chirashi__["h" /* on */])(Object(__WEBPACK_IMPORTED_MODULE_4_react_dom__["findDOMNode"])(this.node), {
        transitionend: this.toggleState
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.show !== nextProps.show) {
        this.toggleAnim(nextProps);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.unbind();
    }
  }, {
    key: 'toggleAnim',
    value: function toggleAnim(_ref2) {
      var _this2 = this;

      var show = _ref2.show,
          delay = _ref2.delay;

      this.setState({
        enter: show,
        leave: !show
      });

      setTimeout(function () {
        _this2.setState({
          active: true
        });
      }, delay);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var anim = this.props.anim;
      var _state = this.state,
          enter = _state.enter,
          leave = _state.leave,
          active = _state.active;


      var className = '' + anim + (enter ? '--enter' : leave ? '--leave' : '');

      return this.state.show ? Object(__WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"])(__WEBPACK_IMPORTED_MODULE_0_react__["Children"].only(this.props.children), {
        ref: function ref(node) {
          return _this3.node = node;
        },
        className: anim + ' ' + className + ' ' + (active ? className + '-active' : '')
      }) : null;
    }
  }]);
  return Transition;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Transition.defaultProps = {
  show: true,
  delay: 0
};

/* eslint-disable */

var BreakpointListener = function () {
    function BreakpointListener(breakpoints) {
        var _this = this;

        classCallCheck(this, BreakpointListener);

        this.resize = function () {
            var width = window.innerWidth,
                i = _this._breakpoints.length;

            while (i-- && width >= _this._breakpoints[i].size) {}

            _this.current = _this._breakpoints[Math.min(_this._breakpoints.length - 1, i + 1)].label;
        };

        this._current = '';
        this._listeners = [];
        this._breakpoints = [];

        Object(__WEBPACK_IMPORTED_MODULE_2_chirashi__["f" /* forIn */])(breakpoints, function (key, value) {
            _this._breakpoints.push({
                size: parseInt(value),
                label: key
            });
        });

        this._breakpoints.sort(function (a, b) {
            return b.size - a.size;
        });

        this.offResize = Object(__WEBPACK_IMPORTED_MODULE_2_chirashi__["h" /* on */])(window, { resize: this.resize });

        this.resize({
            width: window.innerWidth
        });
    }

    createClass(BreakpointListener, [{
        key: 'trigger',
        value: function trigger() {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = this._listeners[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var listener = _step.value;

                    listener(this._current);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    }, {
        key: 'on',
        value: function on$$1(callback) {
            this._listeners.push(callback);
        }
    }, {
        key: 'off',
        value: function off(callback) {
            this._listeners.splice(this._listeners.indexOf(callback), 1);
        }
    }, {
        key: 'kill',
        value: function kill() {
            this.offResize();
        }
    }, {
        key: 'current',
        set: function set$$1(value) {
            if (this._current == value) return;

            this._current = value;

            this.trigger();
        },
        get: function get$$1() {
            return this._current;
        }
    }]);
    return BreakpointListener;
}();

/* eslint-disable */

var BreakpointManager = function (_BreakpointListener) {
    inherits(BreakpointManager, _BreakpointListener);

    function BreakpointManager(breakpoints) {
        classCallCheck(this, BreakpointManager);

        var _this = possibleConstructorReturn(this, (BreakpointManager.__proto__ || Object.getPrototypeOf(BreakpointManager)).call(this, breakpoints));

        _this.bindGroupBehaviors = function (group) {
            var behaviors = void 0;
            if (!(behaviors = _this._groups[group])) return;

            var disabled = [],
                enabled = [];

            var i = behaviors.enabled.length;
            while (i--) {
                var behavior = behaviors.enabled[i];

                if (behavior.sizes.indexOf(_this.current) == -1) {
                    behavior.disable(_this.current);
                    disabled.push(behavior);
                } else enabled.push(behavior);
            }

            var j = behaviors.disabled.length;
            while (j--) {
                var _behavior = behaviors.disabled[j];

                if (_behavior.sizes.indexOf(_this.current) != -1 && _behavior.and()) {
                    _behavior.enable(_this.current);
                    enabled.push(_behavior);
                } else disabled.push(_behavior);
            }

            behaviors.disabled = disabled;
            behaviors.enabled = enabled;

            _this._groups[group] = behaviors;
        };

        _this._groups = {};
        return _this;
    }

    createClass(BreakpointManager, [{
        key: 'trigger',
        value: function trigger() {
            this.bindBehaviors();
            get(BreakpointManager.prototype.__proto__ || Object.getPrototypeOf(BreakpointManager.prototype), 'trigger', this).call(this);
        }
    }, {
        key: 'bindBehaviors',
        value: function bindBehaviors() {
            if (this._groups) {
                Object(__WEBPACK_IMPORTED_MODULE_2_chirashi__["f" /* forIn */])(this._groups, this.bindGroupBehaviors);
            }
        }
    }, {
        key: 'refreshGroupBehaviors',
        value: function refreshGroupBehaviors(group) {
            this.disableGroupBehaviors(group);
            this.bindGroupBehaviors(group);
        }
    }, {
        key: 'addToGroup',
        value: function addToGroup(group, behaviors) {
            var bind = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

            var behaviorsGroup = this._groups[group];

            if (!behaviorsGroup) {
                behaviorsGroup = {
                    disabled: [],
                    enabled: []
                };
            }

            var i = behaviors.length;
            while (i--) {
                var behavior = behaviors[i];

                if (!behavior.disable) behavior.disable = function () {};
                if (!behavior.enable) behavior.enable = function () {};
                if (!behavior.and) behavior.and = function () {
                    return true;
                };

                if (bind && behavior.sizes.indexOf(this.current) != -1 && behavior.and()) {
                    behavior.enable(this.current);
                    behaviorsGroup.enabled.push(behavior);
                } else {
                    behaviorsGroup.disabled.push(behavior);
                }
            }

            this._groups[group] = behaviorsGroup;
        }
    }, {
        key: 'removeGroup',
        value: function removeGroup(group) {
            var _this2 = this;

            if (!this._groups[group]) return;

            Object(__WEBPACK_IMPORTED_MODULE_2_chirashi__["e" /* forEach */])(this._groups[group].enabled, function (behavior) {
                return behavior.disable(_this2.current);
            });

            delete this._groups[group];
        }
    }, {
        key: 'disableGroupBehaviors',
        value: function disableGroupBehaviors(group) {
            if (!this._groups[group]) return;

            var behaviors = this._groups[group];

            var i = behaviors.enabled.length;
            while (i--) {
                var behavior = behaviors.enabled[i];

                behavior.disable(this.current);
            }

            behaviors.disabled = behaviors.disabled.concat(behaviors.enabled);
            behaviors.enabled = [];
        }
    }, {
        key: 'kill',
        value: function kill() {
            var _this3 = this;

            Object(__WEBPACK_IMPORTED_MODULE_2_chirashi__["f" /* forIn */])(this._groups, function (group, behaviors) {
                Object(__WEBPACK_IMPORTED_MODULE_2_chirashi__["e" /* forEach */])(behaviors.enabled, function (behavior) {
                    return behavior.disable(_this3.current);
                });
            });

            get(BreakpointManager.prototype.__proto__ || Object.getPrototypeOf(BreakpointManager.prototype), 'kill', this).call(this);
        }
    }]);
    return BreakpointManager;
}(BreakpointListener);

var defaultBreakpoints = {
  huge: '1440px',
  large: '1170px',
  medium: '768px',
  small: '450px'
};

var _manager = { value: null };
var _breakpoints = { value: defaultBreakpoints };

var configBreakpoints = function configBreakpoints(breakpoints) {
  _breakpoints.value = breakpoints;
};

var withBehavior = function withBehavior(options) {
  return function (ComposedComponent) {
    return function (_Component) {
      inherits(EnhancedComponent, _Component);

      function EnhancedComponent() {
        var _ref;

        classCallCheck(this, EnhancedComponent);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        var _this = possibleConstructorReturn(this, (_ref = EnhancedComponent.__proto__ || Object.getPrototypeOf(EnhancedComponent)).call.apply(_ref, [this].concat(toConsumableArray(args))));

        _this.state = {};


        if (!_manager.value) {
          _manager.value = new BreakpointManager(_breakpoints.value);
        }

        _this.behaviorId = Object(__WEBPACK_IMPORTED_MODULE_3_lodash__["uniqueId"])('behavior_');

        Object(__WEBPACK_IMPORTED_MODULE_2_chirashi__["e" /* forEach */])(options, function (behavior) {
          _manager.value.addToGroup(_this.behaviorId, [{
            sizes: behavior.sizes,
            enable: function enable() {
              if (behavior.enable) _this.setState(behavior.enable());
            },
            disable: function disable() {
              if (behavior.disable) _this.setState(behavior.disable());
            }
          }], false);
        });
        return _this;
      }

      createClass(EnhancedComponent, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
          _manager.value.bindGroupBehaviors(this.behaviorId);
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          _manager.value.removeGroup(this.behaviorId);
        }
      }, {
        key: 'render',
        value: function render() {
          var _this2 = this;

          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ComposedComponent, _extends({
            ref: function ref(context) {
              return _this2.context = context;
            }
          }, this.state, this.props));
        }
      }]);
      return EnhancedComponent;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
  };
};

var index = Object.assign(withBehavior, { configBreakpoints: configBreakpoints });

var withComputed = (function (mapPropsToHandler) {
  return function (WrappedComponent) {
    return function (_Component) {
      inherits(WithPropsWatch, _Component);

      function WithPropsWatch() {
        classCallCheck(this, WithPropsWatch);
        return possibleConstructorReturn(this, (WithPropsWatch.__proto__ || Object.getPrototypeOf(WithPropsWatch)).apply(this, arguments));
      }

      createClass(WithPropsWatch, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
          var _this2 = this;

          this.computeState(function (state, handler, propName) {
            return _extends({}, state, handler(_this2.props, null));
          });
        }
      }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
          var _this3 = this;

          this.computeState(function (state, handler, propName) {
            return nextProps[propName] === _this3.props[propName] ? state : _extends({}, state, handler(nextProps, _this3.props));
          });
        }
      }, {
        key: 'computeState',
        value: function computeState(iteratee) {
          this.setState(Object(__WEBPACK_IMPORTED_MODULE_3_lodash__["reduce"])(mapPropsToHandler, iteratee, {}));
        }
      }, {
        key: 'render',
        value: function render() {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedComponent, _extends({}, this.props, this.state));
        }
      }]);
      return WithPropsWatch;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
  };
});

var withResize = (function (callback) {
  return function (WrappedComponent) {
    return function (_Component) {
      inherits(WithResize, _Component);

      function WithResize() {
        var _ref;

        var _temp, _this, _ret;

        classCallCheck(this, WithResize);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = WithResize.__proto__ || Object.getPrototypeOf(WithResize)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _this.resize = function () {
          _this.setState(callback(Object(__WEBPACK_IMPORTED_MODULE_4_react_dom__["findDOMNode"])(_this.el)));
        }, _temp), possibleConstructorReturn(_this, _ret);
      }

      createClass(WithResize, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
          this.unbind = Object(__WEBPACK_IMPORTED_MODULE_2_chirashi__["h" /* on */])(window, { resize: this.resize });
          this.resizeTimeout = setTimeout(this.resize, 100);
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          this.unbind();
          clearTimeout(this.resizeTimeout);
        }
      }, {
        key: 'render',
        value: function render() {
          var _this2 = this;

          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedComponent, _extends({
            ref: function ref(el) {
              return _this2.el = el;
            }
          }, this.props, this.state));
        }
      }]);
      return WithResize;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
  };
});

var withVisibility = (function (WrappedComponent) {
  return function (_Component) {
    inherits(WithVisibility, _Component);

    function WithVisibility() {
      var _ref;

      var _temp, _this, _ret;

      classCallCheck(this, WithVisibility);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = WithVisibility.__proto__ || Object.getPrototypeOf(WithVisibility)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
        visibility: document.visibilityState
      }, _temp), possibleConstructorReturn(_this, _ret);
    }

    createClass(WithVisibility, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        var _this2 = this;

        this.unbind = Object(__WEBPACK_IMPORTED_MODULE_2_chirashi__["h" /* on */])(document, {
          visibilitychange: function visibilitychange() {
            _this2.setState({ visibility: document.visibilityState });
          }
        });
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        this.unbind();
      }
    }, {
      key: 'render',
      value: function render() {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedComponent, _extends({}, this.props, this.state));
      }
    }]);
    return WithVisibility;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
});

var createReducer = (function (initialState, handlers) {
  return function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];
    return action.type in handlers ? handlers[action.type](state, action) : state;
  };
});




/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return forEach; });
/* unused harmony export forElements */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return forIn; });
/* unused harmony export getElement */
/* unused harmony export getElements */
/* unused harmony export isDomElement */
/* unused harmony export addClass */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return append; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return children; });
/* unused harmony export clone */
/* unused harmony export closest */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return createElement; });
/* unused harmony export empty */
/* unused harmony export filter */
/* unused harmony export find */
/* unused harmony export findOne */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getAttr; });
/* unused harmony export getData */
/* unused harmony export getHtml */
/* unused harmony export getProp */
/* unused harmony export hasClass */
/* unused harmony export indexInParent */
/* unused harmony export insertAfter */
/* unused harmony export insertBefore */
/* unused harmony export next */
/* unused harmony export parent */
/* unused harmony export parents */
/* unused harmony export prev */
/* unused harmony export remove */
/* unused harmony export removeAttr */
/* unused harmony export removeClass */
/* unused harmony export removeData */
/* unused harmony export setAttr */
/* unused harmony export setData */
/* unused harmony export setHtml */
/* unused harmony export setProp */
/* unused harmony export toggleClass */
/* unused harmony export delegate */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return on; });
/* unused harmony export once */
/* unused harmony export ready */
/* unused harmony export trigger */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return clearStyle; });
/* unused harmony export clientRect */
/* unused harmony export getComputedStyle */
/* unused harmony export getHeight */
/* unused harmony export getSize */
/* unused harmony export getStyleProp */
/* unused harmony export getWidth */
/* unused harmony export hide */
/* unused harmony export offset */
/* unused harmony export position */
/* unused harmony export screenPosition */
/* unused harmony export setCssVariable */
/* unused harmony export setHeight */
/* unused harmony export setSize */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return setStyleProp; });
/* unused harmony export setWidth */
/* unused harmony export show */
/* unused harmony export transform */
/**
 * Chirashi.js v6.5.0
 * (c) 2017 Alex Toudic
 * Released under MIT License.
 **/

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};



















var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/**
 * Iterates over items and apply callback on each one.
 * @param {*} items - The iterable.
 * @param {forEachCallback} callback - The callback to call for each iteratee.
 * @return {*} iterable - items if it's an array-like or an array containing items.
 * @example //esnext
 * import { forEach } from 'chirashi'
 *
 * const items = forEach([0, 1, 2], (item, i) => console.log(`${i}: ${item + 1}`)) //returns: [0, 1, 2]
 * // logs:
 * //   0: 1
 * //   1: 2
 * //   2: 3
 * forEach(0, (item, i) => console.log(`${i}: ${item + 1}`)) //returns: [0]
 * //   0: 1
 * @example //es5
 * var items = Chirashi.forEach([0, 1, 2], function (item, i) { console.log(i+': '+(item + 1)) }) //returns: [0, 1, 2]
 * // logs:
 * //   0: 1
 * //   1: 2
 * //   2: 3
 * Chirashi.forEach(0, function (item, i) { console.log(i+': '+(item + 1)) }) //returns: [0]
 * // logs:
 * //   0: 1
 */
function forEach(items, callback) {
  if (!items) return [];

  if ((typeof items === 'undefined' ? 'undefined' : _typeof(items)) !== 'object' || !('length' in items)) {
    items = [items];
  }

  var n = items.length;
  for (var i = 0; i < n; ++i) {
    callback(items[i], i);
  }return items;
}

/**
* Callback to apply on item.
* @callback forEachCallback
* @param {*} item
* @param {number} index - Index of item in items.
*/

var _breakingMethods = ['push', 'splice', 'unshift'];

function _overloadMethod(array, method) {
  array[method] = function () {
    this['_chrsh-valid'] = false;

    return Array.prototype[method].apply(this, arguments);
  };
}

function _chirasizeArray(array) {
  forEach(_breakingMethods, _overloadMethod.bind(null, array));

  array['_chrsh-valid'] = true;

  return array;
}

function _nodelistToArray(collection) {
  var arr = [];

  var i = -1;
  while (arr[++i] = collection[i]) {}

  arr.length--;

  return _chirasizeArray(arr);
}

var reg = /^[.#]?[\w-_]+$/;

function _getElements(from, selector) {
  if (selector.search(reg) === 0) {
    switch (selector[0]) {
      case '.':
        return _nodelistToArray(from.getElementsByClassName(selector.slice(1)));
      case '#':
        var element = from === document ? from.getElementById(selector.slice(1)) : from.querySelector(selector);
        return _chirasizeArray(element ? [element] : []);
      default:
        return _nodelistToArray(from.getElementsByTagName(selector));
    }
  }

  return _nodelistToArray(from.querySelectorAll(selector));
}

/**
 * Test if element is a dom element. Doesn't resolve selectors.
 * @param {*} element - The element to test.
 * @return {boolean} isDomElement - true if element is an instance of Node or Window.
 * @example //esnext
 * import { createElement, append, isDomElement } from 'chirashi'
 * const sushi = createElement('.sushi')
 * append(document.body, sushi)
 * isDomElement(window) //returns: true
 * isDomElement(sushi) //returns: true
 * isDomElement('.sushi') //returns: false
 * @example //es5
 * var sushi = Chirashi.createElement('.sushi')
 * Chirashi.append(document.body, sushi)
 * Chirashi.isDomElement(window) //returns: true
 * Chirashi.isDomElement(sushi) //returns: true
 * Chirashi.isDomElement('.sushi') //returns: false
 */
function isDomElement(element) {
  return !!element && (!!element.nodeType || element === window);
}

/**
 * Get dom element recursively from iterable or selector.
 * @param {(string|Array|NodeList|HTMLCollection|Window|Node)} input - The iterable, selector or elements.
 * @return {Array} domElements - The array of dom elements from input.
 * @example //esnext
 * import { createElement, append, getElements } from 'chirashi'
 * const sushi = createElement('.sushi')
 * const unagi = createElement('.unagi')
 * const yakitori = createElement('.yakitori')
 * const sashimi = createElement('.sashimi')
 * append(document.body, [sushi, unagi, yakitori, sashimi])
 * getElements('div') //returns: [<div class="sushi"></div>, <div class="unagi"></div>, <div class="yakitori"></div>, <div class="sashimi"></div>]
 * getElements('.yakitori, .sashimi') //returns: [<div class="yakitori"></div>, <div class="sashimi"></div>]
 * getElements([sushi, unagi, '.sashimi', '.wasabi']) //returns: [<div class="sushi"></div>, <div class="unagi"></div>, <div class="sashimi"></div>]
 * getElements('.wasabi') //returns: []
 * @example //es5
 * var sushi = Chirashi.createElement('.sushi')
 * var unagi = Chirashi.createElement('.unagi')
 * var yakitori = Chirashi.createElement('.yakitori')
 * var sashimi = Chirashi.createElement('.sashimi')
 * Chirashi.append(document.body, [sushi, unagi, yakitori, sashimi])
 * Chirashi.getElements('div') //returns: [<div class="sushi"></div>, <div class="unagi"></div>, <div class="yakitori"></div>, <div class="sashimi"></div>]
 * Chirashi.getElements('.yakitori, .sashimi') //returns: [<div class="yakitori"></div>, <div class="sashimi"></div>]
 * Chirashi.getElements([sushi, unagi, '.sashimi', '.wasabi']) //returns: [<div class="sushi"></div>, <div class="unagi"></div>, <div class="sashimi"></div>]
 * Chirashi.getElements('.wasabi') //returns: []
 */
function getElements(input) {
  if (typeof input === 'string') {
    return _getElements(document, input);
  }

  if (input instanceof window.NodeList || input instanceof window.HTMLCollection) {
    return _nodelistToArray(input);
  }

  if (input instanceof Array) {
    if (input['_chrsh-valid']) {
      return input;
    }

    var output = [];
    forEach(input, _pushRecursive.bind(null, output));

    return _chirasizeArray(output);
  }

  return _chirasizeArray(isDomElement(input) ? [input] : []);
}

function _pushRecursive(output, element) {
  output.push.apply(output, getElements(element));
}

/**
 * Iterates over dom elements and apply callback on each one.
 * @param {(string|Array|NodeList|HTMLCollection|Window|Node)} elements - The iterable, selector or elements. Note that it'll be passed to getElements.
 * @param {forElementsCallback} callback - The function to call for each element.
 * @return {Array} iterable - The getElements' result for chaining.
 * @example //esnext
 * import { createElement, append, forElements } from 'chirashi'
 * const sushi = createElement('.sushi')
 * const unagi = createElement('.unagi')
 * const yakitori = createElement('.yakitori')
 * const sashimi = createElement('.sashimi')
 * append(document.body, [sushi, unagi, yakitori, sashimi])
 * forElements('div', console.log) //returns: [<div class="sushi"></div>, <div class="unagi"></div>, <div class="yakitori"></div>, <div class="sashimi"></div>]
 * // logs:
 * // <div class="sushi"></div> 0
 * // <div class="unagi"></div> 1
 * // <div class="yakitori"></div> 2
 * // <div class="sashimi"></div> 3
 * forElements([yakitori, sashimi], console.log) //returns: [<div class="yakitori"></div>, <div class="sashimi"></div>]
 * // logs:
 * // <div class="yakitori"></div> 0
 * // <div class="sashimi"></div> 1
 * @example //es5
 * var sushi = Chirashi.createElement('.sushi')
 * var unagi = Chirashi.createElement('.unagi')
 * var yakitori = Chirashi.createElement('.yakitori')
 * var sashimi = Chirashi.createElement('.sashimi')
 * Chirashi.append(document.body, [sushi, unagi, yakitori, sashimi])
 * Chirashi.forElements('div', console.log) //returns: [<div class="sushi"></div>, <div class="unagi"></div>, <div class="yakitori"></div>, <div class="sashimi"></div>]
 * // logs:
 * // <div class="sushi"></div> 0
 * // <div class="unagi"></div> 1
 * // <div class="yakitori"></div> 2
 * // <div class="sashimi"></div> 3
 * Chirashi.forElements([yakitori, sashimi], console.log) //returns: [<div class="yakitori"></div>, <div class="sashimi"></div>]
 * // logs:
 * // <div class="yakitori"></div> 0
 * // <div class="sashimi"></div> 1
 */
function forElements(elements, callback) {
  return forEach(getElements(elements), callback);
}

/**
 * Callback to apply on element.
 * @callback forElementsCallback
 * @param {Window | document | HTMLElement | SVGElement | Text} element
 * @param {number} index - Index of element in elements.
 */

/**
 * Iterates over object's keys and apply callback on each one.
 * @param {Object} object - The iterable.
 * @param {forInCallback} callback - The function to call for each key-value pair.
 * @return {Object} object - The iterable for chaining.
 * @example //esnext
 * import { forIn } from 'chirashi'
 * const californiaRoll = { name: 'California Roll', price: 4.25, recipe: ['avocado', 'cucumber', 'crab', 'mayonnaise', 'sushi rice', 'seaweed'] }
 * forIn(californiaRoll, (key, value) => {
 *   console.log(`${key} -> ${value}`)
 * }) //returns: { name: 'California Roll', price: 4.25, recipe: ['avocado', 'cucumber', 'crab', 'mayonnaise', 'sushi rice', 'seaweed'] }
 * // LOGS:
 * // name -> California Roll
 * // price -> 4.25
 * // recipe -> ['avocado', 'cucumber', 'crab', 'mayonnaise', 'sushi rice', 'seaweed']
 * @example //es5
 * var californiaRoll = { name: 'California Roll', price: 4.25, recipe: ['avocado', 'cucumber', 'crab', 'mayonnaise', 'sushi rice', 'seaweed'] }
 * Chirashi.forIn(californiaRoll, (key, value) => {
 *   console.log(key + ' -> ' + value)
 * }) //returns: { name: 'California Roll', price: 4.25, recipe: ['avocado', 'cucumber', 'crab', 'mayonnaise', 'sushi rice', 'seaweed'] }
 * // LOGS:
 * // name -> California Roll
 * // price -> 4.25
 * // recipe -> ['avocado', 'cucumber', 'crab', 'mayonnaise', 'sushi rice', 'seaweed']
 */
function forIn(object, callback) {
  if ((typeof object === 'undefined' ? 'undefined' : _typeof(object)) !== 'object') return;

  forEach(Object.keys(object), _forKey.bind(null, object, callback));

  return object;
}

function _forKey(object, callback, key) {
  callback(key, object[key]);
}

/**
 * Callback to apply on each key-value pair.
 * @callback forInCallback
 * @param {string} key
 * @param {*} value
 */

var reg$1 = /^[.#]?[\w-_]+$/;

function _getElement(from, selector) {
  if (selector.search(reg$1) === 0) {
    switch (selector[0]) {
      case '.':
        return from.getElementsByClassName(selector.slice(1))[0];
      case '#':
        return from === document ? from.getElementById(selector.slice(1)) : from.querySelector(selector);
      default:
        return from.getElementsByTagName(selector)[0];
    }
  }

  return from.querySelector(selector);
}

/**
 * Get first dom element from iterable or selector.
 * @param {(string|Array|NodeList|HTMLCollection|Window|Node)} input - The iterable, selector or elements.
 * @return {(Window|Node|boolean)} element - The dom element from input.
 * @example //esnext
 * import { createElement, append, getElement } from 'chirashi'
 * const sushi = createElement('.sushi')
 * const unagi = createElement('.unagi')
 * const yakitori = createElement('.yakitori')
 * const sashimi = createElement('.sashimi')
 * append(document.body, [sushi, unagi, yakitori, sashimi])
 * getElement('div') //returns: <div class="sushi"></div>
 * getElement('.yakitori, .sashimi') //returns: <div class="yakitori"></div>
 * getElement([sushi, unagi, '.sashimi', '.unknown']) //returns: <div class="sushi"></div>
 * getElement('.wasabi') //returns: undefined
 * @example //es5
 * var sushi = Chirashi.createElement('.sushi')
 * var unagi = Chirashi.createElement('.unagi')
 * var yakitori = Chirashi.createElement('.yakitori')
 * var sashimi = Chirashi.createElement('.sashimi')
 * Chirashi.append(document.body, [sushi, unagi, yakitori, sashimi])
 * Chirashi.getElement('div') //returns: <div class="sushi"></div>
 * Chirashi.getElement('.yakitori, .sashimi') //returns: <div class="yakitori"></div>
 * Chirashi.getElement([sushi, unagi, '.sashimi', '.unknown']) //returns: <div class="sushi"></div>
 * Chirashi.getElement('.wasabi') //returns: undefined
 */
function getElement(input) {
  if (typeof input === 'string') {
    return _getElement(document, input);
  }

  if (input instanceof window.NodeList || input instanceof window.HTMLCollection) {
    return input[0];
  }

  if (input instanceof Array) {
    return getElement(input[0]);
  }

  return isDomElement(input) && input;
}

function _updateOne(method, classes, element) {
  element.classList[method].apply(element.classList, classes);
}

function _updateClassList(elements, method, classes) {
  return forElements(elements, _updateOne.bind(null, method, classes));
}

/**
 * Iterates over classes and add it on each element of elements or ignore it if already set.
 * @param {(string|Array|NodeList|HTMLCollection|Element)} elements - The iterable, selector or elements.
 * @param {...string} classes - Classes to add.
 * @return {Array} iterable - The getElements' result for chaining.
 * @example //esnext
 * import { createElement, addClass } from 'chirashi'
 * const maki = createElement('.maki')
 * addClass(maki, 'wasabi') //returns: <div class="wasabi"></div>
 * addClass(maki, 'seaweed', 'cheese') //returns: <div class="wasabi seaweed cheese"></div>
 * addClass('.maki', 'avocado', 'salmon') //returns: <div class="wasabi seaweed cheese avocado salmon"></div>
 * @example //es5
 * var maki = Chirashi.createElement('.maki')
 * Chirashi.addClass(maki, 'wasabi') //returns: <div class="wasabi"></div>
 * Chirashi.addClass(maki, 'seaweed', 'cheese') //returns: <div class="wasabi seaweed cheese"></div>
 * Chirashi.addClass('.maki', 'avocado', 'salmon') //returns: <div class="wasabi seaweed cheese avocado salmon"></div>
 */
function addClass(elements) {
  for (var _len = arguments.length, classes = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    classes[_key - 1] = arguments[_key];
  }

  return _updateClassList(elements, 'add', classes);
}

var regex = /[#.]?([\w-_]+)|\[([\w-_]+)(="([\w.,;:{}'/\\#!@_&?%=<>-\s]+)?")?]|{([\w.,;:{}/\\'"#!@_&?%=<>-\s]+)}/g;

/**
 * Creates a dom element from an HTML string, tag or css like selector with text between {} if needed.
 * @param {string} string - The html string, tag or css like selector.
 * @return {Element} element - The dom element created from the string.
 * @example //esnext
 * import { createElement } from 'chirashi'
 * const maki = createElement('a#sushi.link[data-href="chirashijs.org"][data-link]{click me!}') //returns: <a class="link" id="sushi" data-href="chirashijs.org" data-link>click me!</a>
 * const greetings = createElement('<h1>Hello <strong>World</strong>!</h1>') //returns: <h1>Hello <strong>World</strong>!</h1>
 * @example //es5
 * var maki = Chirashi.createElement('a#sushi.link[data-href="chirashijs.org"][data-link]{click me!}') //returns: <a class="link" id="sushi" data-href="chirashijs.org" data-link>click me!</a>
 * var greetings = Chirashi.createElement('<h1>Hello <strong>World</strong>!</h1>') //returns: <h1>Hello <strong>World</strong>!</h1>
 */
function createElement(string) {
  regex.lastIndex = 0;

  if (string.indexOf('<') !== 0) {
    var core = null;

    var attributes = '';
    var className = '';
    var text = '';

    var segment = void 0;
    while (segment = regex.exec(string)) {
      if (segment[1]) {
        switch (segment[0][0]) {
          case '#':
            attributes += ' id="' + segment[1] + '"';
            break;

          case '.':
            className += ' ' + segment[1];
            break;

          default:
            core = segment[1];
        }
      } else if (segment[2]) {
        attributes += ' ' + segment[2] + (segment[4] ? '="' + segment[4] + '"' : '');
      } else {
        text = segment[5];
      }
    }

    if (core === null) core = 'div';

    string = '<' + core + (className ? ' class="' + className.slice(1) + '"' : '') + attributes + '>' + text + '</' + core + '>';
  }

  var temp = document.createElement('div');
  temp.innerHTML = string;

  var element = temp.firstChild;

  return element;
}

/**
 * Appends each node to a parent node.
 * @param {(string|Array|NodeList|HTMLCollection|Node)} element - The parent node. Note that it'll be passed to getElement to ensure there's only one.
 * @param {(string|Array.<(string|Node)>|Node)} nodes - String, node or array of nodes and/or strings. Each string will be passed to createElement then append.
 * @return {(Node|boolean)} node - The node for chaining or false if nodes can't be appended.
 * @example //esnext
 * import { createElement, append } from 'chirashi'
 * const maki = createElement('.maki')
 * append(maki, '.salmon[data-fish="salmon"]') //returns: <div class="maki"><div class="salmon" data-fish="salmon"></div></div>
 * const avocado = createElement('.avocado')
 * append(maki, [avocado, '.cheese[data-cheese="cream"]']) //returns: <div class="maki"><div class="salmon" data-fish="salmon"></div><div class="avocado"></div><div class="cheese" data-cheese="cream"></div></div>
 * @example //es5
 * var maki = Chirashi.createElement('.maki')
 * Chirashi.append(maki, '.salmon[data-fish="salmon"]') //returns: <div class="maki"><div class="salmon" data-fish="salmon"></div></div>
 * var avocado = Chirashi.createElement('.avocado')
 * Chirashi.append(maki, [avocado, '.cheese[data-cheese="cream"]']) //returns: <div class="maki"><div class="salmon" data-fish="salmon"></div><div class="avocado"></div><div class="cheese" data-cheese="cream"></div></div>
 */
function append(element, nodes) {
  element = getElement(element);

  if (!element || !element.appendChild) return false;

  forEach(nodes, _appendOne.bind(null, element));

  return element;
}

function _appendOne(element, node) {
  element.appendChild(typeof node === 'string' ? createElement(node) : node);
}

function _getOneOrMore(args, execute) {
  if (args.length === 1) {
    return execute(args[0]);
  } else {
    var ret = {};
    forEach(args, _injectIntoObject.bind(null, ret, execute));

    return ret;
  }
}

function _injectIntoObject(ret, execute, arg) {
  ret[arg] = execute(arg);
}

function _getOneOrMoreFromElement(execute, element) {
  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  return !!(element = getElement(element)) && _getOneOrMore(args, execute.bind(null, element));
}

/**
 * Get the value for the property name on the element.
 * @param {(string|Array|NodeList|HTMLCollection|Window|Node)} element - The element. Note that it'll be passed to getElement to ensure there's only one.
 * @param {string} ...properties - The properties' names.
 * @return {*} value - The value for property on element if only one property, object of property-value pairs or false if no element found.
 * @example //esnext
 * import { createElement, append, getProp } from 'chirashi'
 * const maki = createElement('.maki')
 * append(maki, '.salmon')
 * getProp(maki, 'firstChild') //returns: <div class="salmon"></div>
 * @example //es5
 * var maki = Chirashi.createElement('.maki')
 * Chirashi.append(maki, '.salmon')
 * Chirashi.getProp(maki, 'firstChild') //returns: <div class="salmon"></div>
 */
var getProp = _getOneOrMoreFromElement.bind(null, _getProperty);
function _getProperty(element, property) {
  return element[property];
}

/**
 * Returns an element's children as Array.
 * @param {(string|Array|NodeList|HTMLCollection|Node)} element - The parent node. Note that it'll be passed to getElement to ensure there's only one.
 * @return {Array.<Element>} children - Element's children as array.
 * @example //esnext
 * import { createElement, append, children } from 'chirashi'
 * const maki = createElement('.maki')
 * append(maki, ['.salmon', '.avocado'])
 * children(maki) //returns: [<div class="salmon"></div>, <div class="avocado"></div>]
 * @example //es5
 * const maki = Chirashi.createElement('.maki')
 * Chirashi.append(maki, ['.salmon', '.avocado'])
 * Chirashi.children(maki) //returns: [<div class="salmon"></div>, <div class="avocado"></div>]
 */
function children(element) {
  return _nodelistToArray(getProp(element, 'children'));
}

/**
 * Clones element.
 * @param {(string|Array|NodeList|HTMLCollection|Node)} element - The node to clone. Note that it'll be passed to getElement to ensure there's only one.
 * @return {(Node|boolean)} clone - element's clone or false if element isn't a node.
 * @example //esnext
 * import { createElement, append, clone } from 'chirashi'
 * const maki = createElement('.maki')
 * clone(maki) //returns: <div class="maki"></div>
 * const sushi = createElement('.sushi')
 * append(document.body, sushi)
 * clone('.sushi') //returns: <div class="sushi"></div>
 * @example //es5
 * var maki = Chirashi.createElement('.maki')
 * Chirashi.clone(maki) //returns: <div class="maki"></div>
 * var sushi = Chirashi.createElement('.sushi')
 * Chirashi.append(document.body, sushi)
 * Chirashi.clone('.sushi') //returns: <div class="sushi"></div>
 */
function clone(element) {
  return !!(element = getElement(element)) && 'cloneNode' in element && element.cloneNode(true);
}

/**
 * Get closest element matching the tested selector or tested element traveling up the DOM tree from element to limit.
 * @param {(string|Array|NodeList|HTMLCollection|Element)} element - First tested element. Note that it'll be passed to getElement to ensure there's only one.
 * @param {(string|Element)} tested - The selector or dom element to match.
 * @param {(string|Node)} [limit=document] - Returns false when this selector or element is reached.
 * @return {(Element|boolean)} matchedElement - The matched element or false.
 * @example //esnext
 * import { createElement, append, closest } from 'chirashi'
 * const maki = createElement('.maki')
 * const cheese = createElement('.cheese')
 * append(maki, cheese)
 * append(cheese, '.avocado')
 * append(document.body, maki)
 * closest('.avocado', '.maki') //returns: <div class="maki"></div>
 * closest('.avocado', '.maki', '.cheese') //returns: false
 * @example //es5
 * var maki = Chirashi.createElement('.maki')
 * var cheese = Chirashi.createElement('.cheese')
 * Chirashi.append(maki, cheese)
 * Chirashi.append(cheese, '.avocado')
 * Chirashi.append(document.body, maki)
 * Chirashi.closest('.avocado', '.maki') //returns: <div class="maki"></div>
 * Chirashi.closest('.avocado', '.maki', '.cheese') //returns: false
 */
function closest(element, tested) {
  var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : document;

  element = getElement(element);

  if (!element || (typeof limit === 'string' ? element.matches(limit) : element === limit)) {
    return false;
  }

  if (typeof tested === 'string' ? element.matches(tested) : element === tested) {
    return element;
  }

  return !!element.parentNode && closest(element.parentNode, tested, limit);
}

/**
 * Remove every child of elements.
 * @param {(string|Array|NodeList|HTMLCollection|Node)} elements - The iterable, selector or elements. Note that it'll be passed to getElements.
 * @return {Array} iterable - The getElements' result for chaining.
 * @example //esnext
 * import { createElement, append, empty } from 'chirashi'
 * const maki = createElement('.maki') //returns: <div class="maki"></div>
 * append(maki, '.cheese') //returns: <div class="maki"><div class="cheese"></div></div>
 * empty(maki) //returns: [<div class="maki"></div>]
 * @example //es5
 * const maki = Chirashi.createElement('.maki') //returns: <div class="maki"></div>
 * Chirashi.append(maki, '.cheese') //returns: <div class="maki"><div class="cheese"></div></div>
 * Chirashi.empty(maki) //returns: [<div class="maki"></div>]
 */
function empty(elements) {
  return forElements(elements, _removeChildren);
}

function _removeChildren(element) {
  var child = void 0;
  while (child = element.firstChild) {
    element.removeChild(child);
  }
}

function _applyOnElements(method, elements, selector) {
  var found = [];

  forElements(elements, method.bind(null, found, selector));

  return _chirasizeArray(found);
}

/**
 * Iterates over elements, returning an array of all elements matching tested selector.
 * @param {(string|Array|NodeList|HTMLCollection|Element)} elements - The iterable, selector or elements. Note that it'll be passed to getElements.
 * @param {(string|Element)} tested - The selector or dom element to match.
 * @return {Array.<Element>} matching - The array of filtered elements.
 * @example //esnext
 * import { createElement, append, filter } from 'chirashi'
 * const salmonMaki = createElement('.salmon.maki')
 * const tunaMaki = createElement('.tuna.maki')
 * const salmonSushi = createElement('.salmon.sushi')
 * const tunaSushi = createElement('.tuna.sushi')
 * append(document.body, [salmonMaki, tunaMaki, salmonSushi, tunaSushi])
 * filter('div', '.salmon') //returns: [<div class="salmon sushi"></div>, <div class="salmon maki"></div>]
 * filter([salmonMaki, tunaMaki, salmonSushi, tunaSushi], '.maki') //returns: [<div class="salmon maki"></div>, <div class="tuna maki"></div>]
 * filter('div', '.salmon') //returns: [<div class="salmon sushi"></div>, <div class="salmon maki"></div>]
 * @example //es5
 * var salmonMaki = Chirashi.createElement('.salmon.maki')
 * var tunaMaki = Chirashi.createElement('.tuna.maki')
 * var salmonSushi = Chirashi.createElement('.salmon.sushi')
 * var tunaSushi = Chirashi.createElement('.tuna.sushi')
 * Chirashi.append(document.body, [salmonMaki, tunaMaki, salmonSushi, tunaSushi])
 * Chirashi.filter('div', '.salmon') //returns: [<div class="salmon sushi"></div>, <div class="salmon maki"></div>]
 * Chirashi.filter([salmonMaki, tunaMaki, salmonSushi, tunaSushi], '.maki') //returns: [<div class="salmon maki"></div>, <div class="tuna maki"></div>]
 * Chirashi.filter('div', '.salmon') //returns: [<div class="salmon sushi"></div>, <div class="salmon maki"></div>]
 */
var filter = _applyOnElements.bind(null, _checkOne);
function _checkOne(matching, tested, element) {
  if (typeof tested === 'string' && 'matches' in element && element.matches(tested) || element === tested) {
    matching.push(element);
  }
}

/**
 * Iterates over each element of elements and returns an array containing all elements' children matching a selector.
 * @param {(string|Array|NodeList|HTMLCollection|Element|Document|ParentNode)} elements - The iterable, selector or parent elements. Note that it'll be passed to getElements.
 * @param {string} selector - The selector.
 * @return {Array.<Element>} found - The array of elements' descendants matching the selector.
 * @example //esnext
 * import { createElement, append, find } from 'chirashi'
 * const maki = createElement('.maki')
 * append(maki, ['.salmon[data-fish][data-inside]', '.avocado[data-inside]'])
 * const roll = createElement('.roll')
 * append(roll, '.tuna[data-fish][data-inside]')
 * append(document.body, [maki, roll])
 * find('div', '[data-fish]') //returns: [<div class="salmon" data-fish data-inside></div>, <div class="tuna" data-fish data-inside></div>]
 * find(maki, '[data-inside]') //returns: [<div class="salmon" data-fish data-inside></div>, <div class="avocado" data-inside></div>]
 * @example //es5
 * var maki = Chirashi.createElement('.maki')
 * Chirashi.append(maki, ['.salmon[data-fish][data-inside]', '.avocado[data-inside]'])
 * var roll = Chirashi.createElement('.roll')
 * Chirashi.append(roll, '.tuna[data-fish][data-inside]')
 * Chirashi.append(document.body, [maki, roll])
 * Chirashi.find('div', '[data-fish]') //returns: [<div class="salmon" data-fish data-inside></div>, <div class="tuna" data-fish data-inside></div>]
 * Chirashi.find(maki, '[data-inside]') //returns: [<div class="salmon" data-fish data-inside></div>, <div class="avocado" data-inside></div>]
 */
var find = _applyOnElements.bind(null, _findFromOne);
function _findFromOne(found, selector, element) {
  found.push.apply(found, _getElements(element, selector));
}

/**
 * Find the first element's child matching the selector.
 * @param {(string|Array|NodeList|HTMLCollection|Element|Document|ParentNode)} element - The parent node. Note that it'll be passed to getElement to ensure there's only one.
 * @param {string} selector - The selector to match.
 * @return {(Element|null)} element - The first child of elements matching the selector or null.
 * @example //esnext
 * import { createElement, append, find } from 'chirashi'
 * const maki = createElement('.maki')
 * append(maki, ['.salmon[data-fish][data-inside]', '.avocado[data-inside]'])
 * const roll = createElement('.roll')
 * append(roll, '.tuna[data-fish][data-inside]')
 * append(document.body, [maki, roll])
 * findOne('div', '[data-fish]') //returns: <div class="salmon" data-fish data-inside></div>
 * findOne(maki, '[data-inside]') //returns: <div class="salmon" data-fish data-inside></div>
 * @example //es5
 * var maki = Chirashi.createElement('.maki')
 * Chirashi.append(maki, ['.salmon[data-fish][data-inside]', '.avocado[data-inside]'])
 * var roll = Chirashi.createElement('.roll')
 * Chirashi.append(roll, '.tuna[data-fish][data-inside]')
 * Chirashi.append(document.body, [maki, roll])
 * Chirashi.findOne('div', '[data-fish]') //returns: <div class="salmon" data-fish data-inside></div>
 * Chirashi.findOne(maki, '[data-inside]') //returns: <div class="salmon" data-fish data-inside></div>
 */
function findOne(element, selector) {
  return (element = getElement(element)) ? _getElement(element, selector) : null;
}

/**
 * Get value for named attribute of element.
 * @param {(string|Array|NodeList|HTMLCollection|Element)} element - The element. Note that it'll be passed to getElement to ensure there's only one.
 * @param {...string} names - The attributes' names.
 * @return {(Object<string, (string|boolean)>|string|boolean)} value - The value for the attribute if only one name, object of attributes' name-value pairs or false if no element found.
 * @example //esnext
 * import { createElement, getAttr } from 'chirashi'
 * const maki = createElement('.maki[data-fish="salmon"]')
 * getAttr(maki, 'data-fish') //returns: "salmon"
 * @example //es5
 * const maki = Chirashi.createElement('.maki[data-fish="salmon"]')
 * Chirashi.getAttr(maki, 'data-fish') //returns: "salmon"
 */
var getAttr = _getOneOrMoreFromElement.bind(null, _getAttribute);
function _getAttribute(element, name) {
  return element.getAttribute(name);
}

/**
 * Alias on getAttr prefixing name with 'data-'.
 * @param {(string|Array|NodeList|HTMLCollection|Element)} element - The element. Note that it'll be passed to getElement to ensure there's only one.
 * @param {...string} names - The data-attributes' names.
 * @return {(Object<string, (string|boolean)>|string|boolean)} value - The value for the data-attribute if only one name, object of data-attributes' name-value pairs or false if no element found.
 * @example //esnext
 * import { createElement, getData } from 'chirashi'
 * const maki = createElement('.maki[data-fish="salmon"]')
 * getData(maki, 'fish') //returns: "salmon"
 * @example //es5
 * const maki = Chirashi.createElement('.maki[data-fish="salmon"]')
 * Chirashi.getData(maki, 'fish') //returns: "salmon"
 */
var getData = _getOneOrMoreFromElement.bind(null, _getDataAttribute);
function _getDataAttribute(element, name) {
  return element.getAttribute('data-' + name);
}

/**
 * Get the inner html of an element.
 * @param {(string|Array|NodeList|HTMLCollection|Element)} element - The element. Note that it'll be passed to getElement to ensure there's only one.
 * @return {(string|null)} innerHTML - The inner html of the element or null if no element found.
 * @example //esnext
 * import { createElement, setHtml, getHtml } from 'chirashi'
 * const maki = createElement('p.maki')
 * setHtml(maki, 'salmon')
 * getHtml(maki) //returns: "salmon"
 * @example //es5
 * var maki = createElement('p.maki')
 * setHtml(maki, 'salmon')
 * getHtml(maki) //returns: "salmon"
 */
function getHtml(element) {
  return getProp(element, 'innerHTML');
}

/**
 * Iterates over classes and test if element has each.
 * @param {(string|Array|NodeList|HTMLCollection|Element)} elements - The iterable, selector or elements.
 * @param {...string} classes - Classes to test.
 * @return {boolean} hasClass - Is true if element has all classes.
 * @example //esnext
 * import { createElement, hasClass } from 'chirashi'
 * const maki = createElement('.salmon.cheese.maki')
 * hasClass(maki, 'salmon', 'cheese') //returns: true
 * hasClass(maki, 'salmon', 'avocado') //returns: false
 * @example //es5
 * var maki = Chirashi.createElement('.salmon.cheese.maki')
 * Chirashi.hasClass(maki, 'salmon', 'cheese') //returns: true
 * Chirashi.hasClass(maki, 'salmon', 'avocado') //returns: false
 */
function hasClass(element) {
  element = getElement(element);
  if (!element) return;

  var n = arguments.length <= 1 ? 0 : arguments.length - 1;
  var found = void 0;
  var i = 0;
  while (i < n && (found = element.classList.contains((_ref = i++ + 1, arguments.length <= _ref ? undefined : arguments[_ref])))) {
    var _ref;
  }

  return found;
}

/**
 * Returns index of element in parent's children.
 * * @param {(string|Array|NodeList|HTMLCollection|NonDocumentTypeChildNode)} element - The element. Note that it'll be passed to getElement to ensure there's only one.
 * @return {(number|null)} index - The position of element in his parent's children or null if no element found.
 * @example //esnext
 * import { createElement, append, indexInParent } from 'chirashi'
 * const maki = createElement('.maki')
 * append(document.body, maki)
 * append(maki, ['.salmon[data-fish="salmon"]', '.cheese[data-cheese="cream"]']) //returns: <div class="maki"><div class="salmon" data-fish="salmon"></div><div class="cheese" data-cheese="cream"></div></div>
 * indexInParent('.cheese') //returns: 1
 * @example //es5
 * var maki = Chirashi.createElement('.maki')
 * Chirashi.append(document.body, maki)
 * Chirashi.append(maki, ['.salmon[data-fish="salmon"]', '.cheese[data-cheese="cream"]']) //returns: <div class="maki"><div class="salmon" data-fish="salmon"></div><div class="cheese" data-cheese="cream"></div></div>
 * Chirashi.indexInParent('.cheese') //returns: 1
 */
function indexInParent(element) {
  element = getElement(element);

  if (!element) return null;

  var i = void 0,
      current = void 0;
  for (i = 0, current = element; current = current.previousElementSibling; ++i) {}

  return i;
}

function _nodeInsertion(method, element, nodes) {
  element = getElement(element);

  if (!element || !('parentNode' in element)) return;

  var parent = element.parentNode;

  forEach(nodes, method.bind(null, parent, element));

  return element;
}

/**
 * Insert nodes after element in his parent.
 * @param {(string|Array|NodeList|HTMLCollection|NonDocumentTypeChildNode)} element - The element. Note that it'll be passed to getElement to ensure there's only one.
 * @param {(Array<(string|Node)>|string|Node)} nodes - Array of dom elements or string to create it using createElement.
 * @return {(Node|undefined)} element - The element for chaining or undefined if no element found or element has no parent.
 * @example //esnext
 * import { createElement, append, insertAfter } from 'chirashi'
 * const maki = createElement('.maki')
 * append(document.body, maki)
 * append(maki, ['.salmon[data-fish="salmon"]', '.cheese[data-cheese="cream"]'])
 * insertAfter('.salmon', ['.avocado', '.wasabi']) //returns: <div class="maki"><div class="salmon" data-fish="salmon"></div><div class="avocado"></div><div class="wasabi"></div><div class="cheese" data-cheese="cream"></div></div>
 * @example //es5
 * var maki = Chirashi.createElement('.maki')
 * Chirashi.append(document.body, maki)
 * Chirashi.append(maki, ['.salmon[data-fish="salmon"]', '.cheese[data-cheese="cream"]'])
 * Chirashi.insertAfter('.salmon', ['.avocado', '.wasabi']) //returns: <div class="maki"><div class="salmon" data-fish="salmon"></div><div class="avocado"></div><div class="wasabi"></div><div class="cheese" data-cheese="cream"></div></div>
 */
var insertAfter = _nodeInsertion.bind(null, _insertAfter);
function _insertAfter(parent, element, node) {
  parent.insertBefore(typeof node === 'string' ? createElement(node) : node, element.nextElementSibling);
}

/**
 * Insert nodes before element in his parent.
 * @param {(string|Array|NodeList|HTMLCollection|NonDocumentTypeChildNode)} element - The element. Note that it'll be passed to getElement to ensure there's only one.
 * @param {(Array<(string|Node)>|string|Node)} nodes - Array of dom elements or string to create it using createElement.
 * @return {(Node|undefined)} element - The element for chaining or undefined if no element found or element has no parent.
 * @example //esnext
 * import { createElement, append, insertBefore } from 'chirashi'
 * const maki = createElement('.maki')
 * append(document.body, maki)
 * append(maki, ['.salmon[data-fish="salmon"]', '.cheese[data-cheese="cream"]'])
 * insertBefore('.cheese', ['.avocado', '.wasabi']) //returns: <div class="maki"><div class="salmon" data-fish="salmon"></div><div class="avocado"></div><div class="wasabi"></div><div class="cheese" data-cheese="cream"></div></div>
 * @example //es5
 * var maki = Chirashi.createElement('.maki')
 * Chirashi.append(document.body, maki)
 * Chirashi.append(maki, ['.salmon[data-fish="salmon"]', '.cheese[data-cheese="cream"]'])
 * Chirashi.insertBefore('.cheese', ['.avocado', '.wasabi']) //returns: <div class="maki"><div class="salmon" data-fish="salmon"></div><div class="avocado"></div><div class="wasabi"></div><div class="cheese" data-cheese="cream"></div></div>
 */
var insertBefore = _nodeInsertion.bind(null, _insertBefore);
function _insertBefore(parent, element, node) {
  parent.insertBefore(typeof node === 'string' ? createElement(node) : node, element);
}

/**
 * Get the next sibling of element.
 * @param {(string|Array|NodeList|HTMLCollection|NonDocumentTypeChildNode)} element - The element. Note that it'll be passed to getElement to ensure there's only one.
 * @return {(Node|null)} nextElement - The element's next sibling or null if no element found.
 * @example //esnext
 * import { createElement, append, next } from 'chirashi'
 * const maki = createElement('.maki')
 * append(maki, '.salmon[data-fish="salmon"]') //returns: <div class="maki"><div class="salmon" data-fish="salmon"></div></div>
 * const avocado = createElement('.avocado')
 * append(maki, [avocado, '.cheese[data-cheese="cream"]']) //returns: <div class="maki"><div class="salmon" data-fish="salmon"></div><div class="avocado"></div><div class="cheese" data-cheese="cream"></div></div>
 * next(avocado) //returns: <div class="cheese" data-cheese="cream"></div>
 * @example //es5
 * var maki = Chirashi.createElement('.maki')
 * Chirashi.append(maki, '.salmon[data-fish="salmon"]') //returns: <div class="maki"><div class="salmon" data-fish="salmon"></div></div>
 * var avocado = Chirashi.createElement('.avocado')
 * Chirashi.append(maki, [avocado, '.cheese[data-cheese="cream"]']) //returns: <div class="maki"><div class="salmon" data-fish="salmon"></div><div class="avocado"></div><div class="cheese" data-cheese="cream"></div></div>
 * Chirashi.next(avocado) //returns: <div class="cheese" data-cheese="cream"></div>
 */
function next(element) {
  return getProp(element, 'nextElementSibling');
}

/**
 * Returns the parent node of the element.
 * @param {(string|Array|NodeList|HTMLCollection|Node)} element - The element. Note that it'll be passed to getElement to ensure there's only one.
 * @return {(document|Element|null)} parentElement - The parent node or null if no element found.
 * @example //esnext
 * import { createElement, append, parent } from 'chirashi'
 * const maki = createElement('.maki')
 * append(document.body, maki)
 * append(maki, '.salmon[data-fish="salmon"]') //returns: <div class="maki"><div class="salmon" data-fish="salmon"></div></div>
 * parent('.salmon') //returns: <div class="maki"><div class="salmon" data-fish="salmon"></div></div>
 * @example //es5
 * var maki = Chirashi.createElement('.maki')
 * append(maki
 * Chirashi.append(document.body, maki)
 * Chirashi.append(maki, '.salmon[data-fish="salmon"]') //returns: <div class="maki"><div class="salmon" data-fish="salmon"></div></div>
 * Chirashi.parent('.salmon') //returns: <div class="maki"><div class="salmon" data-fish="salmon"></div></div>
 */
function parent(element) {
  return getProp(element, 'parentNode');
}

/**
 * Returns an array of every element's ancestors.
 * @param {(string|Array|NodeList|HTMLCollection|Node)} element - The element. Note that it'll be passed to getElement to ensure there's only one.
 * @return {Array.<Node>} parents - Array of element's ancestors.
 * @example //esnext
 * import { createElement, append, parents } from 'chirashi'
 * const maki = createElement('.maki')
 * append(document.body, maki)
 * append(maki, '.salmon[data-fish="salmon"]') //returns: <div class="maki"><div class="salmon" data-fish="salmon"></div></div>
 * parents('.salmon') //returns: [<div class="maki">...</div>, <body>...</body>, <html>...</html>, document]
 * @example //es5
 * var maki = Chirashi.createElement('.maki')
 * append(maki
 * Chirashi.append(document.body, maki)
 * Chirashi.append(maki, '.salmon[data-fish="salmon"]') //returns: <div class="maki"><div class="salmon" data-fish="salmon"></div></div>
 * Chirashi.parents('.salmon') //returns: [<div class="maki">...</div>, <body>...</body>, <html>...</html>, document]
 */
function parents(element) {
  return _chirasizeArray(_getParents(getElement(element)));
}

function _getParents(element) {
  var arr = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  var parent = void 0;
  if (element && (parent = element.parentNode)) {
    arr.push(parent);

    return _getParents(parent, arr);
  }

  return arr;
}

/**
 * Get the previous sibling of element.
 * @param {(string|Array|NodeList|HTMLCollection|NonDocumentTypeChildNode)} element - The element. Note that it'll be passed to getElement to ensure there's only one.
 * @return {(Node|null)} previousElement - The element's previous sibling or null if no element found.
 * @example //esnext
 * import { createElement, append, prev } from 'chirashi'
 * const maki = createElement('.maki')
 * append(maki, '.salmon[data-fish="salmon"]') //returns: <div class="maki"><div class="salmon" data-fish="salmon"></div></div>
 * const avocado = createElement('.avocado')
 * append(maki, [avocado, '.cheese[data-cheese="cream"]']) //returns: <div class="maki"><div class="salmon" data-fish="salmon"></div><div class="avocado"></div><div class="cheese" data-cheese="cream"></div></div>
 * prev(avocado) //returns: <div class="salmon" data-fish="salmon"></div>
 * @example //es5
 * var maki = Chirashi.createElement('.maki')
 * Chirashi.append(maki, '.salmon[data-fish="salmon"]') //returns: <div class="maki"><div class="salmon" data-fish="salmon"></div></div>
 * var avocado = Chirashi.createElement('.avocado')
 * Chirashi.append(maki, [avocado, '.cheese[data-cheese="cream"]']) //returns: <div class="maki"><div class="salmon" data-fish="salmon"></div><div class="avocado"></div><div class="cheese" data-cheese="cream"></div></div>
 * Chirashi.prev(avocado) //returns: <div class="salmon" data-fish="salmon"></div>
 */
function prev(element) {
  return getProp(element, 'previousElementSibling');
}

/**
 * Iterates over elements and removes it from DOM.
 * @param {(string|Array|NodeList|HTMLCollection|Element)} elements - The iterable, selector or elements.
 * @return {(Array|NodeList|HTMLCollection)} removedElements - The array or nodelist of removed dom elements.
 * @example //esnext
 * import { createElement, append, remove } from 'chirashi'
 * const maki = createElement('.maki')
 * append(document.body, maki)
 * append(maki, '.salmon[data-fish="salmon"]') //returns: <div class="maki"><div class="salmon" data-fish="salmon"></div></div>
 * const avocado = createElement('.avocado')
 * append(maki, [avocado, '.cheese[data-cheese="cream"]']) //returns: <div class="maki"><div class="salmon" data-fish="salmon"></div><div class="avocado"></div><div class="cheese" data-cheese="cream"></div></div>
 * remove('.cheese') //returns: [<div class="cheese" data-cheese="cream"></div>]
 * @example //es5
 * var maki = Chirashi.createElement('.maki')
 * Chirashi.append(document.body, maki)
 * Chirashi.append(maki, '.salmon[data-fish="salmon"]') //returns: <div class="maki"><div class="salmon" data-fish="salmon"></div></div>
 * var avocado = Chirashi.createElement('.avocado')
 * Chirashi.append(maki, [avocado, '.cheese[data-cheese="cream"]']) //returns: <div class="maki"><div class="salmon" data-fish="salmon"></div><div class="avocado"></div><div class="cheese" data-cheese="cream"></div></div>
 * Chirashi.remove('.cheese') //returns: [<div class="cheese" data-cheese="cream"></div>]
 */
function remove(elements) {
  return forElements(elements, _removeOne);
}

function _removeOne(element) {
  if (!element.parentNode) return;

  element.parentNode.removeChild(element);
}

function _applyArg(element, method, arg) {
  element[method](arg);
}

function _applyElement(method, args, element) {
  if (!element[method]) return;

  forEach(args, _applyArg.bind(null, element, method));
}

function _applyForEach(elements, method, args) {
  return forElements(elements, _applyElement.bind(null, method, args));
}

/**
 * Iterates over attributes and removes it from each element of elements.
 * @param {(string|Array|NodeList|HTMLCollection|Element)} elements - The iterable, selector or elements.
 * @param {...string} attributes - Names of attributes to remove.
 * @return {Array} iterable - The getElements' result for chaining.
 * @example //esnext
 * import { createElement, append, removeAttr } from 'chirashi'
 * const maki = createElement('.maki')
 * append(document.body, maki)
 * append(maki, ['.salmon[data-fish="salmon"]', '.cheese[data-cheese="cream"]']) //returns: <div class="maki"><div class="salmon" data-fish="salmon"></div><div class="cheese" data-cheese="cream"></div></div>
 * removeAttr('.salmon', 'data-fish') //returns: [<div class="salmon"></div>]
 * @example //es5
 * var maki = Chirashi.createElement('.maki')
 * Chirashi.append(document.body, maki)
 * Chirashi.append(maki, ['.salmon[data-fish="salmon"]', '.cheese[data-cheese="cream"]']) //returns: <div class="maki"><div class="salmon" data-fish="salmon"></div><div class="cheese" data-cheese="cream"></div></div>
 * Chirashi.removeAttr('.salmon', 'data-fish') //returns: [<div class="salmon"></div>]
 */
function removeAttr(elements) {
  for (var _len = arguments.length, attributes = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    attributes[_key - 1] = arguments[_key];
  }

  return _applyForEach(elements, 'removeAttribute', attributes);
}

/**
 * Iterates over classes and remove it from each element of elements.
 * @param {(string|Array|NodeList|HTMLCollection|Element)} elements - The iterable, selector or elements.
 * @param {...string} classes - Classes to remove.
 * @return {Array} iterable - The getElements' result for chaining.
 * @example //esnext
 * import { createElement, removeClass } from 'chirashi'
 * const maki = createElement('.maki.salmon.cheese.wasabi') //returns: <div class="maki salmon cheese wasabi"></div>
 * removeClass(maki, 'cheese', 'wasabi') //returns: [<div class="maki salmon"></div>]
 * @example //es5
 * var maki = Chirashi.createElement('.maki.salmon.cheese.wasabi') //returns: <div class="maki salmon cheese wasabi"></div>
 * Chirashi.removeClass(maki, 'cheese', 'wasabi') //returns: [<div class="maki salmon"></div>]
 */
function removeClass(elements) {
  for (var _len = arguments.length, classes = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    classes[_key - 1] = arguments[_key];
  }

  return _updateClassList(elements, 'remove', classes);
}

/**
 * Iterates over attributes and removes it from each element of elements.
 * @param {(string|Array|NodeList|HTMLCollection|Element)} elements - The iterable, selector or elements.
 * @param {...string} attributes - Names of data attributes to remove.
 * @return {Array} iterable - The getElements' result for chaining.
 * @example //esnext
 * import { createElement, append, removeData } from 'chirashi'
 * const maki = createElement('.maki')
 * append(document.body, maki)
 * append(maki, ['.salmon[data-fish="salmon"]', '.cheese[data-cheese="cream"]']) //returns: <div class="maki"><div class="salmon" data-fish="salmon"></div><div class="cheese" data-cheese="cream"></div></div>
 * removeData('.salmon', 'fish') //returns: [<div class="salmon"></div>]
 * @example //es5
 * var maki = Chirashi.createElement('.maki')
 * Chirashi.append(document.body, maki)
 * Chirashi.append(maki, ['.salmon[data-fish="salmon"]', '.cheese[data-cheese="cream"]']) //returns: <div class="maki"><div class="salmon" data-fish="salmon"></div><div class="cheese" data-cheese="cream"></div></div>
 * Chirashi.removeData('.salmon', 'fish') //returns: [<div class="salmon"></div>]
 */
function removeData(elements) {
  for (var _len = arguments.length, attributes = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    attributes[_key - 1] = arguments[_key];
  }

  forEach(attributes, _prefixAttr.bind(null, attributes));

  return _applyForEach(elements, 'removeAttribute', attributes);
}

function _prefixAttr(attributes, attr, index) {
  attributes[index] = 'data-' + attr;
}

function _parseAndApply(parse, apply, elements, options) {
  forIn(options, parse.bind(null, options));

  return forElements(elements, apply.bind(null, options));
}

/**
 * Iterates over attributes as key value pairs and apply on each element of elements.
 * @param {(string|Array|NodeList|HTMLCollection|Element)} elements - The iterable, selector or elements.
 * @param {Object.<string, (number|string)>} attributes - The attributes key value pairs.
 * @return {Array} iterable - The getElements' result for chaining.
 * @example //esnext
 * import { createElement, setAttr } from 'chirashi'
 * const maki = createElement('.maki')
 * setAttr(maki, {
 *   dataFish: 'salmon'
 * }) //returns: [<div class="maki" data-fish="salmon">]
 * @example //es5
 * var maki = Chirashi.createElement('.maki')
 * Chirashi.setAttr(maki, {
 *   dataFish: 'salmon'
 * }) //returns: [<div class="maki" data-fish="salmon">]
 */
var setAttr = _parseAndApply.bind(null, _stringifyValue, _setAttributes);
function _setAttributes(attributes, element) {
  forIn(attributes, element.setAttribute.bind(element));
}

function _stringifyValue(attributes, name, value) {
  if (typeof value !== 'string' && !(value instanceof Array)) {
    attributes[name] = JSON.stringify(value);
  }
}

/**
 * Iterates over data-attributes as key value pairs and apply on each element of elements.
 * @param {(string|Array|NodeList|HTMLCollection|Element)} elements - The iterable, selector or elements.
 * @param {Object.<string, (number|string)>} dataAttributes - The data-attributes key value pairs
 * @return {Array} iterable - The getElements' result for chaining.
 * @example //esnext
 * import { createElement, setData } from 'chirashi'
 * const maki = createElement('.maki')
 * setData(maki, {
 *   fish: 'salmon'
 * }) //returns: [<div class="maki" data-fish="salmon">]
 * @example //es5
 * var maki = Chirashi.createElement('.maki')
 * Chirashi.setData(maki, {
 *   fish: 'salmon'
 * }) //returns: [<div class="maki" data-fish="salmon">]
 */
function setData(elements, dataAttributes) {
  var attributes = {};

  forIn(dataAttributes, _prefixAttribute.bind(null, attributes));

  return setAttr(elements, attributes);
}

function _prefixAttribute(attributes, name, value) {
  attributes['data-' + name] = value;
}

/**
 * Apply props as key value pairs on each element of elements.
 * @param {(string|Array|NodeList|HTMLCollection|Window|Node)} elements - The iterable, selector or elements.
 * @param {Object} props - The props key value pairs.
 * @return {Array} iterable - The getElements' result for chaining.
 * @example //esnext
 * import { createElement, setProp, getProp } from 'chirashi'
 * const maki = createElement('input.maki')
 * setProp(maki, { value: 'こんにちは世界' })
 * getProp(maki, 'value') //returns: こんにちは世界
 * @example //es5
 * var maki = Chirashi.createElement('input.maki')
 * Chirashi.setProp(maki, { value: 'こんにちは世界' })
 * Chirashi.getProp(maki, 'value') //returns: こんにちは世界
 */
function setProp(elements, props) {
  return forElements(elements, _apply.bind(null, props));
}

function _apply(props, element) {
  Object.assign(element, props);
}

/**
 * Set the inner html of elements.
 * @param {(string|Array|NodeList|HTMLCollection|Element)} elements - The iterable, selector or elements.
 * @param {string} html - The html to insert.
 * @return {Array} iterable - The getElements' result for chaining.
 * @example //esnext
* import { createElement, setHtml, getHtml } from 'chirashi'
* const maki = createElement('p.maki')
* setHtml(maki, 'salmon') //returns: [<p class="maki">salmon</p>]
* getHtml(maki) //returns: "salmon"
* @example //es5
* var maki = createElement('p.maki')
* setHtml(maki, 'salmon') //returns: [<p class="maki">salmon</p>]
* getHtml(maki) //returns: "salmon"
 */
function setHtml(elements, html) {
  return setProp(elements, { 'innerHTML': html });
}

var reg$2 = /[,\s]+/g;
function _stringToArray(input) {
  reg$2.lastIndex = 0;

  if (typeof input === 'string') {
    return input.search(reg$2) !== -1 ? input.split(reg$2) : [input];
  }

  return input;
}

/**
 * Iterates over classes and toggle it on each element of elements.
 * @param {(string|Array|NodeList|HTMLCollection|Element)} elements - The iterable, selector or elements.
 * @param {(string|Array|Object)} classes - Array of classes or string of classes seperated with comma and/or spaces. Or object with keys being the string of classes seperated with comma and/or spaces and values function returning a booleanean.
 * @return {Array} iterable - The getElements' result for chaining.
 * @example //esnext
 * import { createElement, toggleClass, clone, setData, getData } from 'chirashi'
 * const maki = createElement('.wasabi.salmon.maki') //returns: <div class="maki salmon wasabi"></div>
 * const sushi = createElement('.salmon.sushi') //returns: <div class="sushi salmon"></div>
 * toggleClass([maki, sushi], 'wasabi') //returns: [<div class="maki salmon"></div>, <div class="sushi salmon wasabi"></div>]
 * const scdMaki = clone(maki)
 * setData(maki, { for: 'leonard' })
 * setData(scdMaki, { for: 'sheldon' })
 * toggleClass([maki, scdMaki], {
 *   cheese: element => {
 *     return getData(element, 'for') !== 'leonard'
 *   }
 * }) //returns: [<div class="maki salmon cheese" data-for="sheldon"></div>, <div class="maki salmon" data-for="leonard"></div>]
 * @example //es5
 * var maki = Chirashi.createElement('.wasabi.salmon.maki') //returns: <div class="wasabi salmon maki"></div>
 * var sushi = Chirashi.createElement('.salmon.sushi') //returns: <div class="salmon sushi"></div>
 * Chirashi.toggleClass([maki, sushi], 'wasabi') //returns: [<div class="maki salmon"></div>, <div class="sushi salmon wasabi"></div>]
 * var scdMaki = Chirashi.clone(maki)
 * Chirashi.setData(maki, { for: 'leonard' })
 * Chirashi.setData(scdMaki, { for: 'sheldon' })
 * Chirashi.toggleClass([maki, scdMaki], {
 *   cheese: function (element) {
 *     return Chirashi.getData(element, 'for') !== 'leonard'
 *   }
 * }) //returns: [<div class="maki salmon cheese" data-for="sheldon"></div>, <div class="maki salmon" data-for="leonard"></div>]
 */
function toggleClass(elements) {
  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  if (_typeof(args[0]) === 'object') {
    forIn(args[0], _toggleClassesWithForce.bind(null, elements));
  } else {
    forEach(args, _toggleClassName.bind(null, elements));
  }
}

function _toggleOne(className, element) {
  element.classList.toggle(className);
}

function _toggleClassName(elements, className) {
  forElements(elements, _toggleOne.bind(null, className));
}

function _toggleOneWithForce(className, force, element) {
  element.classList.toggle(className, force(element));
}

function _toggleClassNameWithForce(elements, force, className) {
  forElements(elements, _toggleOneWithForce.bind(null, className, force));
}

function _toggleClassesWithForce(elements, classNames, force) {
  forEach(_stringToArray(classNames), _toggleClassNameWithForce.bind(null, elements, force));
}

function _setEvent(method, callback, options, event, element) {
  element[method](event, callback, options);
}

function _setEventOnEach(elements, method, callback, options, event) {
  forEach(elements, _setEvent.bind(null, method, callback, options, event));
}

function _setInput(elements, method, events, options) {
  var callback = void 0;
  var passedOptions = void 0;
  if (typeof options === 'function') {
    callback = options;
    passedOptions = false;
  } else {
    callback = options.handler;
    passedOptions = _extends({}, options);
  }

  forEach(_stringToArray(events), _setEventOnEach.bind(null, elements, method, callback, passedOptions));
}

function _setEvents(elements, method, input) {
  method += 'EventListener';

  elements = getElements(elements);
  forIn(input, _setInput.bind(null, elements, method));

  return elements;
}

/**
 * Bind events listener on each element of elements.
 * @param {(string|Array|NodeList|HTMLCollection|EventTarget)} elements - The iterable, selector or elements.
 * @param {Object.<string, (eventCallback|EventObject)>} input - An object in which keys are events to bind seperated with coma and/or spaces and values are eventCallbacks or EventObjects.
 * @return {offCallback} off - The unbinding function.
 * @example //esnext
 * import { createElement, append, on, trigger } from 'chirashi'
 * const maki = createElement('a.cheese.maki')
 * const sushi = createElement('a.wasabi.sushi')
 * append(document.body, [maki, sushi])
 * const off = on('.cheese, .wasabi', {
 *   click(e, target) {
 *     console.log('clicked', target)
 *   },
 *   'mouseenter mousemove': {
 *     handler: (e, target) => {
 *       console.log('mouse in', target)
 *     },
 *     passive: true
 *   }
 * })
 * trigger(maki, 'click') //simulate user's click
 * // LOGS: "clicked" <a class="maki cheese"></a>
 * trigger(sushi, 'click') //simulate user's click
 * // LOGS: "clicked" <a class="sushi wasabi"></a>
 * off(maki, 'click') //remove click event listener on maki
 * off() //remove all listeners from all elements
 * @example //es5
 * var off = Chirashi.bind('.cheese, .wasabi', {
 *   'click': function (e, target) {
 *     console.log('clicked', target)
 *   },
 *   'mouseenter mousemove': {
 *     handler: (e, target) => {
 *       console.log('mouse in', target)
 *     },
 *     passive: true
 *   }
 * })
 * var maki = Chirashi.createElement('a.cheese.maki')
 * var sushi = Chirashi.createElement('a.wasabi.sushi')
 * Chirashi.append(document.body, [maki, sushi])
 * Chirashi.trigger(maki, 'click') //simulate user's click
 * // LOGS: "clicked" <a class="maki cheese"></a>
 * Chirashi.trigger(sushi, 'click') //simulate user's click
 * // LOGS: "clicked" <a class="sushi wasabi"></a>
 * off(maki, 'click') //remove click event listener on maki
 * off() //remove all listeners from all elements
 */
function on(elements, input) {
  elements = _setEvents(elements, 'add', input);

  return function (offElements, events) {
    _setEvents(offElements || elements, 'remove', events ? defineProperty({}, events, input[events]) : input);
  };
}

/**
 * Options to bind event.
 * @typedef {Object} EventObject
 * @property {eventCallback} handler - The callback to execute on event.
 * @property {boolean} [capture=false] - Indicates that events of this type will be dispatched to the registered listener before being dispatched to any EventTarget beneath it in the DOM tree.
 * @property {boolean} [once=false] - Indicates that the listener should be invoked at most once after being added. If it is true, the listener would be removed automatically when it is invoked.
 * @property {boolean} [passive=false] - Indicates that the listener will never call preventDefault(). If it does, the user agent should ignore it and generate a console warning.
 */

/**
 * Callback to execute on event.
 * @callback eventCallback
 * @param {Event} event - Triggered event.
 */

/**
 * Called to remove one or all events listeners of one or all elements.
 * @callback offCallback
 * @param {(string|Array|NodeList|HTMLCollection|EventTarget)} [offElements] - The iterable, selector or elements to unbind.
 * @param {string} [events] - The events to unbind. Must be provided in the same syntax as in input.
 */

/**
 * Delegate events listener on delegate and execute callback when target matches selector (targets doesn't have to be in the DOM).
 * @param {string} selector - The selector to match.
 * @param {Object.<string, delegateCallback>} input - An object in which keys are events to delegate seperated with coma and/or spaces and values are delegateCallbacks.
 * @param {(string|Array|NodeList|HTMLCollection|EventTarget)} [target=document.body] - The event target. Note that it'll be passed to getElement to ensure there's only one.
 * @return {offCallback} off - The unbind function.
 * @example //esnext
 * import { createElement, append, delegate, trigger } from 'chirashi'
 * const off = delegate('.cheese, .wasabi', {
 *   click(e, target) => {
 *     console.log('clicked', target)
 *   },
 *   'mouseenter mousemove': (e, target) => {
 *     console.log('mouse in', target)
 *   }
 * })
 * const maki = createElement('a.cheese.maki')
 * const sushi = createElement('a.wasabi.sushi')
 * append(document.body, [maki, sushi])
 * trigger(maki, 'click') //simulate user's click
 * // LOGS: "clicked" <a class="maki cheese"></a>
 * trigger(sushi, 'click') //simulate user's click
 * // LOGS: "clicked" <a class="sushi wasabi"></a>
 * off('mouseenter mousemove') //remove mouseenter and mousemove listeners
 * off() //remove all listeners
 * @example //es5
 * var off = Chirashi.delegate('.cheese, .wasabi', {
 *   'click': function (e, target) {
 *     console.log('clicked', target)
 *   },
 *   'mouseenter mousemove': function(e, target) {
 *     console.log('mouse in', target)
 *   }
 * })
 * var maki = Chirashi.createElement('a.cheese.maki')
 * var sushi = Chirashi.createElement('a.wasabi.sushi')
 * Chirashi.append(document.body, [maki, sushi])
 * Chirashi.trigger(maki, 'click') //simulate user's click
 * // LOGS: "clicked" <a class="maki cheese"></a>
 * Chirashi.trigger(sushi, 'click') //simulate user's click
 * // LOGS: "clicked" <a class="sushi wasabi"></a>
 * off('mouseenter mousemove') //remove mouseenter and mousemove listeners
 * off() //remove all listeners
 */
function delegate(selector, input) {
  var target = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : document.body;

  target = getElement(target);

  var eventsObj = {};
  forIn(input, _wrapOptions.bind(null, selector, target, eventsObj));

  var off = on(target, eventsObj);

  return function (events) {
    off(target, events);
  };
}

function _wrapOptions(selector, target, eventsObj, events, options) {
  if (typeof options === 'function') {
    eventsObj[events] = _wrapCallback(selector, target, options);
  } else {
    eventsObj[events] = _extends({}, options, {
      handler: _wrapCallback(selector, target, options.handler)
    });
  }
}

function _wrapCallback(selector, target, callback) {
  return function (event) {
    var currentTarget = closest(event.target, selector, target);
    if (currentTarget) callback(event, currentTarget);
  };
}

/**
* Callback to execute on event using delegate.
* @callback delegateCallback
* @param {Event} event - Triggered event.
* @param {HTMLElement | SVGElement} target - Target of the event.
*/

/**
* Called to off one or all events.
* @callback offCallback
* @param {string} [events] - The events to off. Must be provided in the same syntax as in input.
*/

/**
 * Bind events listener on each element of elements and unbind after first triggered.
 * @param {(string|Array|NodeList|HTMLCollection|EventTarget)} elements - The iterable, selector or elements.
 * @param {Object.<string, eventCallback>} input - An object in which keys are events to bind seperated with coma and/or spaces and values are eventCallbacks.
 * @param {boolean} [eachElement=false] - If true only current target's events listeners will be removed after trigger.
 * @param {boolean} [eachEvent=false] - If true only triggered event group of events listeners will be removed.
 * @return {offCallback} cancel - cancel function for unbinding.
 * @example //esnext
 * import { createElement, append, once, trigger } from 'chirashi'
 * const maki = createElement('a.cheese.maki')
 * const sushi = createElement('a.wasabi.sushi')
 * append(document.body, [maki, sushi])
 * const cancel = once('.cheese, .wasabi', {
 *   click(e, target) => {
 *     console.log('clicked', target)
 *   },
 *   'mouseenter mousemove': (e, target) => {
 *     console.log('mouse in', target)
 *   }
 * }, true, true)
 * trigger(maki, 'click') //simulate user's click
 * // LOGS: "clicked" <a class="maki cheese"></a>
 * // click event listener was auto-removed from maki
 * trigger(sushi, 'click') //simulate user's click
 * // LOGS: "clicked" <a class="sushi wasabi"></a>
 * // click event listener was auto-removed from sushi
 * cancel() //remove all listeners from all elements
 * once('.cheese, .wasabi', {
 *   click(e, target) => {
 *     console.log('clicked', target)
 *   }
 * })
 * trigger(maki, 'click') //simulate user's click
 * // LOGS: "clicked" <a class="maki cheese"></a>
 * // all events listeners were auto-removed from all elements
 * trigger(sushi, 'click') //simulate user's click
 * // won't log anything
 * @example //es5
 * var maki = Chirashi.createElement('a.cheese.maki')
 * var sushi = Chirashi.createElement('a.wasabi.sushi')
 * Chirashi.append(document.body, [maki, sushi])
 * var cancel = Chirashi.once('.cheese, .wasabi', {
 *   click: function (e, target) {
 *     console.log('clicked', target)
 *   },
 *   'mouseenter mousemove': function (e, target) {
 *     console.log('mouse in', target)
 *   }
 * }, true, true)
 * Chirashi.trigger(maki, 'click') //simulate user's click
 * // LOGS: "clicked" <a class="maki cheese"></a>
 * // click event listener was auto-removed from maki
 * Chirashi.trigger(sushi, 'click') //simulate user's click
 * // LOGS: "clicked" <a class="sushi wasabi"></a>
 * // click event listener was auto-removed from sushi
 * cancel() //remove all listeners from all elements
 * Chirashi.once('.cheese, .wasabi', {
 *   click: function (e, target) {
 *     console.log('clicked', target)
 *   }
 * })
 * Chirashi.trigger(maki, 'click') //simulate user's click
 * // LOGS: "clicked" <a class="maki cheese"></a>
 * // all events listeners were auto-removed from all elements
 * Chirashi.trigger(sushi, 'click') //simulate user's click
 * // won't log anything
 */
function once(elements, input) {
  var eachElement = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var eachEvent = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  var off = void 0;
  var eventsObj = {};

  forIn(input, function (events, callback) {
    eventsObj[events] = function (event) {
      callback(event);

      off(eachElement && event.currentTarget, eachEvent && events);
    };
  });

  return off = on(elements, eventsObj);
}

/**
 * Execute callback when dom is ready.
 * @param {eventCallback} callback - The callback.
 * @example //esnext
 * import { ready } from 'chirashi'
 * ready(() => {
 *   console.log('Hello World!')
 * })
 * // Dom already complete or event fired.
 * // LOGS: "Hello World!"
 * @example //es5
 * Chirashi.ready(function () {
 *   console.log('Hello World!')
 * })
 * // Dom already complete or event fired.
 * // LOGS: "Hello World!"
 */
function ready(callback) {
  // arguments[1] is used for test purpose only
  if ((arguments[1] || document.readyState) === 'complete') {
    callback();
  } else {
    once(document, {
      'DOMContentLoaded': callback
    });
  }
}

var defaults$1 = {
  bubbles: true,
  cancelable: true
};

/**
 * Trigger events on elements with data
 * @param {(string|Array|NodeList|HTMLCollection|EventTarget)} elements - The iterable, selector or elements.
 * @param {string} events - The events that should be tiggered seperated with spaces
 * @param {Object} data - The events' data
 * @return {Array} iterable - The getElements' result for chaining.
 * @example //esnext
 * import { createElement, append, on, trigger } from 'chirashi'
 * const maki = createElement('a.cheese.maki')
 * const sushi = createElement('a.wasabi.sushi')
 * append(document.body, [maki, sushi])
 * const listener = on('.cheese, .wasabi', {
 *   click(e, target) => {
 *     console.log('clicked', target)
 *   }
 * })
 * trigger(maki, 'click') //simulate user's click
 * // LOGS: "clicked" <a class="maki cheese"></a>
 * trigger(sushi, 'click') //simulate user's click
 * // LOGS: "clicked" <a class="sushi wasabi"></a>
 * @example //es5
 * var listener = Chirashi.bind('.cheese, .wasabi', {
 *   'click': function (e, target) {
 *     console.log('clicked', target)
 *   }
 * })
 * var maki = Chirashi.createElement('a.cheese.maki')
 * var sushi = Chirashi.createElement('a.wasabi.sushi')
 * Chirashi.append(document.body, [maki, sushi])
 * Chirashi.trigger(maki, 'click') //simulate user's click
 * // LOGS: "clicked" <a class="maki cheese"></a>
 * Chirashi.trigger(sushi, 'click') //simulate user's click
 * // LOGS: "clicked" <a class="sushi wasabi"></a>
 */
function trigger(elements, events) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  elements = getElements(elements);

  if (!elements.length) return;

  options = _extends({}, options, defaults$1);

  forEach(_stringToArray(events), _createEvent.bind(null, elements, options));

  return elements;
}

function _createEvent(elements, options, event) {
  event = new window.CustomEvent(event, options);

  forEach(elements, _dispatchEvent.bind(null, event));
}

function _dispatchEvent(event, element) {
  element.dispatchEvent(event);
}

var caps = /[A-Z]/g;

function _kebabCase(input) {
  var output = '' + input;

  var next = void 0;
  while (next = caps.exec(input)) {
    output = output.replace(new RegExp(next, 'g'), '-' + next[0].toLowerCase());
  }

  return output;
}

var unitless = ['z-index', 'zoom', 'font-weight', 'line-height', 'counter-reset', 'counter-increment', 'volume', 'stress', 'pitch-range', 'richness', 'opacity'];

/**
 * Set the provided style to elements.
 * @param {(string|Array|NodeList|HTMLCollection)} elements - The iterable, selector or elements.
 * @param {Object.<string, (number|string)>} style - The style options as object with keys the css property and values, string values or number. If the value is a number and property doesn't support unitless values, pixels will be used.
 * @return {Array} iterable - The getElements' result for chaining.
 * @example //esnext
 * import { append, setStyleProp } from 'chirashi'
 *
 * append(document.body, '.maki')
 * append('.maki', '.salmon')
 *
 * setStyleProp('.maki', {
 *   display: 'block',
 *   position: 'absolute',
 *   top: 200,
 *   left: 240,
 *   width: 100,
 *   height: 100,
 *   borderRadius: '50%',
 *   background: 'black'
 * }) // returns: [<div class="maki" style="display: block; position: absolute; top: 200px; left: 240px; width: 100px; height: 100px; border-radius: 50%; background: black;"><div class="salmon"></div></div>]
 *
 * const salmon = setStyleProp('.salmon', {
 *   display: 'block',
 *   position: 'absolute',
 *   top: 20,
 *   left: 10,
 *   width: 10,
 *   height: 10,
 *   borderRadius: '50%',
 *   background: 'pink'
 * }) // returns: [<div class="salmon" style="display: block; position: absolute; top: 20px; left: 10px; width: 10px; height: 10px; border-radius: 50%; background: pink;"></div>]
 * @example //es5
 * Chirashi.append(document.body, '.maki')
 * Chirashi.append('.maki', '.salmon')
 *
 * Chirashi.setStyleProp('.maki', {
 *   display: 'block',
 *   position: 'absolute',
 *   top: 200,
 *   left: 240,
 *   width: 100,
 *   height: 100,
 *   borderRadius: '50%',
 *   background: 'black'
 * }) // returns: [<div class="maki" style="display: block; position: absolute; top: 200px; left: 240px; width: 100px; height: 100px; border-radius: 50%; background: black;"><div class="salmon"></div></div>]
 *
 * const salmon = Chirashi.setStyleProp('.salmon', {
 *   display: 'block',
 *   position: 'absolute',
 *   top: 20,
 *   left: 10,
 *   width: 10,
 *   height: 10,
 *   borderRadius: '50%',
 *   background: 'pink'
 * }) // returns: [<div class="salmon" style="display: block; position: absolute; top: 20px; left: 10px; width: 10px; height: 10px; border-radius: 50%; background: pink;"></div>]
 */
var setStyleProp = _parseAndApply.bind(null, _applyUnit, _applyStyle);
function _applyUnit(style, prop, value) {
  if (unitless.indexOf(_kebabCase(prop)) === -1 && typeof value === 'number') {
    style[prop] += 'px';
  }
}

function _applyStyle(style, element) {
  if (!element.style) return;

  Object.assign(element.style, style);
}

/**
 * Clear inline style properties from elements.
 * @param {(string|Array|NodeList|HTMLCollection|HTMLElement)} elements - The iterable, selector or elements.
 * @param {...string} props - The style properties to clear.
 * @return {Array} iterable - The getElements' result for chaining.
 * @example //esnext
 * import { createElement, setStyle, clearStyle } from 'chirashi'
 * const maki = createElement('a.cheese.maki')
 * setStyleProp(maki, {
 *   position: 'absolute',
 *   top: 10,
 *   width: 200,
 *   height: 200,
 *   background: 'red'
 * }) // returns: [<a class="cheese maki" style="position: 'absolute'; top: '10px'; width: '200px'; height: '200px'; background: 'red';"></a>]
 * clearStyle(maki, 'width', 'height', 'background') // returns: [<a class="cheese maki" style="position: 'absolute'; top: '10px';"></a>]
 * @example //es5
 * var maki = Chirashi.createElement('a.cheese.maki')
 * Chirashi.setStyleProp(maki, {
 *   position: 'absolute',
 *   top: 10,
 *   width: 200,
 *   height: 200,
 *   background: 'red'
 * }) // returns: [<a class="cheese maki" style="position: 'absolute'; top: '10px'; width: '200px'; height: '200px'; background: 'red';"></a>]
 * Chirashi.clearStyle(maki, 'width', 'height', 'background') // returns: [<a class="cheese maki" style="position: 'absolute'; top: '10px';"></a>]
 */
function clearStyle(elements) {
  var style = {};

  for (var _len = arguments.length, props = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    props[_key - 1] = arguments[_key];
  }

  forEach(props, _resetProp.bind(null, style));

  return setStyleProp(elements, style);
}

function _resetProp(style, prop) {
  style[prop] = '';
}

/**
 * Return the screen relative position of an element.
 * @param {(string|Array|NodeList|HTMLCollection|Element)} element - The element. Note that it'll be passed to getElement to ensure there's only one.
 * @return {(Object|boolean)} clientRect - Element's screen position or false if no element found.
 * @return {number} clientRect.bottom - Y-coordinate, relative to the viewport origin, of the bottom of the rectangle box.
 * @return {number} clientRect.height - Height of the rectangle box (This is identical to bottom minus top).
 * @return {number} clientRect.left - X-coordinate, relative to the viewport origin, of the left of the rectangle box.
 * @return {number} clientRect.right - X-coordinate, relative to the viewport origin, of the right of the rectangle box.
 * @return {number} clientRect.top - Y-coordinate, relative to the viewport origin, of the top of the rectangle box.
 * @return {number} clientRect.width - Width of the rectangle box (This is identical to right minus left).
 * @example esnext
 * import { setStyleProp, append, clientRect } from 'chirashi'
 *
 * setStyleProp([document.documentElement, document.body], {
 *   position: 'relative',
 *   margin: 0,
 *   padding: 0
 * })
 *
 * append(document.body, '.poulp')
 *
 * const poulp = setStyleProp('.poulp', {
 *   display: 'block',
 *   position: 'absolute',
 *   top: 200,
 *   left: 240,
 *   width: 100,
 *   height: 100,
 *   background: 'red'
 * })
 *
 * clientRect(poulp) // returns: { bottom: 300, height: 100, left: 240, right: 0, top: 200, width: 100 }
 * @example es5
 * Chirashi.setStyleProp([document.documentElement, document.body], {
 *   position: 'relative',
 *   margin: 0,
 *   padding: 0
 * })
 *
 * Chirashi.append(document.body, '.poulp')
 *
 * var poulp = Chirashi.setStyleProp('.poulp', {
 *   display: 'block',
 *   position: 'absolute',
 *   top: 200,
 *   left: 240,
 *   width: 100,
 *   height: 100,
 *   background: 'red'
 * })
 *
 * Chirashi.clientRect(poulp) // returns: { bottom: 300, height: 100, left: 240, right: 0, top: 200, width: 100 }
 */
function clientRect(element) {
  element = getElement(element);

  if (!element) return false;

  var rect = element.getBoundingClientRect();

  // exhaustive because ClientRect use only getters breaking simple copies
  return {
    bottom: rect.bottom,
    height: rect.height,
    left: rect.left,
    right: rect.right,
    top: rect.top,
    width: rect.width
  };
}

/**
 * Get computed style of an element.
 * @param {(string|Array|NodeList|HTMLCollection|Element)} element - The element. Note that it'll be passed to getElement to ensure there's only one.
 * @return {Object<string, string>} computedStyle - the computed style of the element.
 * @example //esnext
 * import { append, setStyleProp, getComputedStyle } from 'chirashi'
 * append(document.body, '.maki')
 * const maki = setStyleProp('.maki', {
 *   display: 'block',
 *   position: 'relative',
 *   top: 10
 * })
 * getComputedStyle(maki) //returns: { display: 'block', position: 'relative', top: '10px', [... other properties according to the browser] }
 * @example //es5
 * Chirashi.append(document.body, '.maki')
 * var maki = Chirashi.setStyleProp('.maki', {
 *   display: 'block',
 *   position: 'relative',
 *   top: 10
 * })
 * Chirashi.getComputedStyle(maki) //returns: { display: 'block', position: 'relative', top: '10px', [... other properties according to the browser] }
 */
function getComputedStyle(element) {
  return !!(element = getElement(element)) && window.getComputedStyle(element);
}

function _getLength(element, direction, offset) {
  return getProp(element, (offset ? 'offset' : 'client') + direction);
}

/**
 * Get element's height in pixels.
 * @param {(string|Array|NodeList|HTMLCollection|Element|HTMLElement)} element - The element. Note that it'll be passed to getElement to ensure there's only one.
 * @param {boolean} [offset=false] - If true height will include scrollbar and borders to size.
 * @return {number} height - The height in pixels.
 * @example //esnext
 * import { append, setStyleProp, getHeight } from 'chirashi'
 * append(document.body, '.maki')
 * const maki = setStyleProp('.maki', {
 *   display: 'block',
 *   border: '20px solid red',
 *   padding: 10,
 *   height: 200,
 *   width: 200
 * })
 * getHeight(maki, true) //returns: 260
 * getHeight(maki) //returns: 220
 * @example //es5
 * Chirashi.append(document.body, '.maki')
 * var maki = Chirashi.setStyleProp('.maki', {
 *   display: 'block',
 *   border: '20px solid red',
 *   padding: 10,
 *   height: 200,
 *   width: 200
 * })
 * Chirashi.getHeight(maki, true) //returns: 260
 * Chirashi.getHeight(maki) //returns: 220
 */
function getHeight(element) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  return _getLength(element, 'Height', offset);
}

/**
 * Get element's width in pixels.
 * @param {(string|Array|NodeList|HTMLCollection|Element|HTMLElement)} element - The element. Note that it'll be passed to getElement to ensure there's only one.
 * @param {boolean} [offset=false] - If true width will include scrollbar and borders to size.
 * @return {number} width - The width in pixels.
 * @example //esnext
 * import { append, setStyleProp, getWidth } from 'chirashi'
 * append(document.body, '.maki')
 * const maki = setStyleProp('.maki', {
 *   display: 'block',
 *   border: '20px solid red',
 *   padding: 10,
 *   height: 200,
 *   width: 200
 * })
 * getWidth(maki, true) //returns: 260
 * getWidth(maki) //returns: 220
 * @example //es5
 * Chirashi.append(document.body, '.maki')
 * var maki = Chirashi.setStyleProp('.maki', {
 *   display: 'block',
 *   border: '20px solid red',
 *   padding: 10,
 *   height: 200,
 *   width: 200
 * })
 * Chirashi.getWidth(maki, true) //returns: 260
 * Chirashi.getWidth(maki) //returns: 220
 */
function getWidth(element) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  return _getLength(element, 'Width', offset);
}

/**
 * Get element's size in pixels.
 * @param {(string|Array|NodeList|HTMLCollection|Element|HTMLElement)} element - The element. Note that it'll be passed to getElement to ensure there's only one.
 * @param {boolean} [offset=false] - If true size will include scrollbar and borders.
 * @return {number} size - The size in pixels.
 * @example //esnext
 * import { append, setStyleProp, getSize } from 'chirashi'
 * append(document.body, '.maki')
 * const maki = setStyleProp('.maki', {
 *   display: 'block',
 *   border: '20px solid red',
 *   padding: 10,
 *   height: 200,
 *   width: 200
 * })
 * getSize(maki, true) //returns: { width: 260, height: 260 }
 * getSize(maki) //returns: { width: 220, height: 220 }
 * @example //es5
 * Chirashi.append(document.body, '.maki')
 * var maki = Chirashi.setStyleProp('.maki', {
 *   display: 'block',
 *   border: '20px solid red',
 *   padding: 10,
 *   height: 200,
 *   width: 200
 * })
 * Chirashi.getSize(maki, true) //returns: { width: 260, height: 260 }
 * Chirashi.getSize(maki) //returns: { width: 220, height: 220 }
 */
function getSize(element) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  return {
    width: getWidth(element, offset),
    height: getHeight(element, offset)
  };
}

/**
 * Get computed style props of an element. While getComputedStyle returns all properties, getStyleProp returns only needed and convert unitless numeric values or pixels values into numbers.
 * @param {(string|Array|NodeList|HTMLCollection|Element)} element - The element. Note that it'll be passed to getElement to ensure there's only one.
 * @return {(string|number|Object<string, (string|number)>)} computedStyle - Value of computed for provided prop if only one or parsed copy of element's computed style if several.
 * @example //esnext
 * import { append, setStyleProp, getStyleProp } from 'chirashi'
 * append(document.body, '.maki')
 * const maki = setStyleProp('.maki', {
 *   display: 'block',
 *   position: 'relative',
 *   top: 10
 * })
 * getStyleProp(maki, 'display', 'top') //returns: { display: "block", top: 10 }
 * @example //es5
 * Chirashi.append(document.body, '.maki')
 * var maki = Chirashi.setStyleProp('.maki', {
 *   display: 'block',
 *   position: 'relative',
 *   top: 10
 * })
 * Chirashi.getStyleProp(maki, 'display', 'top') //returns: { display: "block", top: 10 }
 */
function getStyleProp(element) {
  var computedStyle = getComputedStyle(element);

  if (!computedStyle) return false;

  for (var _len = arguments.length, props = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    props[_key - 1] = arguments[_key];
  }

  return _getOneOrMore(props, _parseProp.bind(null, computedStyle));
}

function _parseProp(input, prop) {
  var value = input[prop];
  return value && (!isNaN(+value) || value.indexOf('px') !== -1) ? parseFloat(value) : value;
}

/**
 * Hide each element of elements using visibility.
 * @param {(string|Array|NodeList|HTMLCollection|HTMLElement)} elements - The iterable, selector or elements.
 * @return {Array} iterable - The getElements' result for chaining.
 * @example //esnext
 * import { append, hide, getStyleProp }
 * append(document.body, '.maki')
 * const maki = hide('.maki')
 * getStyleProp(maki, 'visibility') // returns: "hidden"
 * @example //es5
 * Chirashi.append(document.body, '.maki')
 * var maki = Chirashi.hide('.maki')
 * Chirashi.getStyleProp(maki, 'visibility') // returns: "hidden"
 */
function hide(elements) {
  return setStyleProp(elements, { visibility: 'hidden' });
}

/**
 * Return the screen relative position of an element.
 * @param {(string|Array|NodeList|HTMLCollection|Element)} element - The element. Note that it'll be passed to getElement to ensure there's only one.
 * @return {(Object|boolean)} screenPosition - Element's screen position or false if no element found.
 * @return {Object.top} top - Y-coordinate, relative to the viewport origin, of the top of the rectangle box.
 * @return {Object.left} left - X-coordinate, relative to the viewport origin, of the left of the rectangle box.
 * @example esnext
 * import { setStyleProp, append, screenPosition } from 'chirashi'
 *
 * setStyleProp([document.documentElement, document.body], {
 *   position: 'relative',
 *   margin: 0,
 *   padding: 0
 * })
 *
 * append(document.body, '.poulp')
 *
 * const poulp = setStyleProp('.poulp', {
 *   display: 'block',
 *   position: 'absolute',
 *   top: 200,
 *   left: 240,
 *   width: 100,
 *   height: 100,
 *   background: 'red'
 * })
 *
 * screenPosition(poulp) // returns: { top: 200, left: 240 }
 * @example es5
 * Chirashi.setStyleProp([document.documentElement, document.body], {
 *   position: 'relative',
 *   margin: 0,
 *   padding: 0
 * })
 *
 * Chirashi.append(document.body, '.poulp')
 *
 * var poulp = Chirashi.setStyleProp('.poulp', {
 *   display: 'block',
 *   position: 'absolute',
 *   top: 200,
 *   left: 240,
 *   width: 100,
 *   height: 100,
 *   background: 'red'
 * })
 *
 * Chirashi.screenPosition(poulp) // returns: { top: 200, left: 240 }
 */
function screenPosition(element) {
  var rect = clientRect(element);

  return rect && {
    top: rect.top,
    left: rect.left
  };
}

/**
 * Returns the top and left offset of an element. Offset is relative to web page.
 * @param {(string|Array|NodeList|HTMLCollection|Element)} element - The element. Note that it'll be passed to getElement to ensure there's only one.
 * @return {(Object|boolean)} offset - Offset object or false if no element found.
 * @return {Object.top} top - Top offset in pixels.
 * @return {Object.left} left - Left offset in pixels.
 * @example //esnext
 * import { setStyleProp, append, offset }
 * setStyleProp([document.documentElement, document.body], {
 *   position: 'relative',
 *   margin: 0,
 *   padding: 0
 * })
 * append(document.body, '.sushi')
 * const sushi = setStyleProp('.sushi', {
 *   display: 'block',
 *   width: 100,
 *   height: 100,
 *   position: 'absolute',
 *   top: 200,
 *   left: 240,
 *   background: 'red'
 * })
 * offset(sushi) // returns: { top: 200, left: 240 }
 * @example //es5
 * Chirashi.setStyleProp([document.documentElement, document.body], {
 *   position: 'relative',
 *   margin: 0,
 *   padding: 0
 * })
 * Chirashi.append(document.body, '.sushi')
 * var sushi = Chirashi.setStyleProp('.sushi', {
 *   display: 'block',
 *   width: 100,
 *   height: 100,
 *   position: 'absolute',
 *   top: 200,
 *   left: 240,
 *   background: 'red'
 * })
 * Chirashi.offset(sushi) // returns: { top: 200, left: 240 }
 */
function offset(element) {
  var screenPos = screenPosition(element);

  return screenPos && {
    top: screenPos.top + window.scrollY,
    left: screenPos.left + window.scrollX
  };
}

/**
 * Return the top and left position of an element. Position is relative to parent.
 * @param {(string|Array|NodeList|HTMLCollection|document|Element)} element - The selector or dom element.
 * @return {(Object|boolean)} offset - Offset object or false if no element found.
 * @return {Object.top} top - Top position in pixels.
 * @return {Object.left} left - Left position in pixels.
 * @example //esnext
 * import { append, setStyleProp, position } from 'chirashi'
 *
 * setStyleProp([document.documentElement, document.body], {
 *   position: 'relative',
 *   margin: 0,
 *   padding: 0
 * })
 *
 * append(document.body, '.maki')
 * append('.maki', '.salmon')
 *
 * setStyleProp('.maki', {
 *   display: 'block',
 *   position: 'absolute',
 *   top: 200,
 *   left: 240,
 *   width: 100,
 *   height: 100,
 *   borderRadius: '50%',
 *   background: 'black'
 * })
 *
 * const salmon = setStyleProp('.salmon', {
 *   display: 'block',
 *   position: 'absolute',
 *   top: 20,
 *   left: 10,
 *   width: 10,
 *   height: 10,
 *   borderRadius: '50%',
 *   background: 'pink'
 * })
 *
 * position(salmon) // returns: { top: 20, left: 10 }
 * @example //es5
 * Chirashi.setStyleProp([document.documentElement, document.body], {
 *   position: 'relative',
 *   margin: 0,
 *   padding: 0
 * })
 *
 * Chirashi.append(document.body, '.maki')
 * Chirashi.append('.maki', '.salmon')
 *
 * Chirashi.setStyleProp('.maki', {
 *   display: 'block',
 *   position: 'absolute',
 *   top: 200,
 *   left: 240,
 *   width: 100,
 *   height: 100,
 *   borderRadius: '50%',
 *   background: 'black'
 * })
 *
 * var salmon = Chirashi.setStyleProp('.salmon', {
 *   display: 'block',
 *   position: 'absolute',
 *   top: 20,
 *   left: 10,
 *   width: 10,
 *   height: 10,
 *   borderRadius: '50%',
 *   background: 'pink'
 * })
 *
 * Chirashi.position(salmon) // returns: { top: 20, left: 10 }
 */
function position(element) {
  return !!(element = getElement(element)) && {
    top: element.offsetTop,
    left: element.offsetLeft
  };
}

/**
 * Set the provided css variables to elements.
 * @param {(string|Array|NodeList|HTMLCollection)} elements - The iterable, selector or elements.
 * @param {Object.<string, (number|string)>} variables - The key-value pairs of variables to set, the variable name shouldn't be prefixed with -- and can be in camelCase.
 * @return {Array} iterable - The getElements' result for chaining.
 * @example //esnext
 * import { append, setCssVariable } from 'chirashi'
 *
 * append(document.body, '.maki')
 *
 * setCssVariable('.maki', {
 *   opacity: 0.5,
 *   textColor: 'blue'
 * }) // returns: [<div class="maki" style="--opacity: 0.5; --text-color: 'rgb(0,0,255)'"></div>]
 * @example //es5
 * Chirashi.append(document.body, '.maki')
 *
 * Chirashi.setCssVariable('.maki', {
 *   opacity: 0.5,
 *   textColor: 'blue'
 * }) // returns: [<div class="maki" style="--opacity: 0.5; --text-color: 'rgb(0,0,255)'"></div>]
 */
var setCssVariable = _parseAndApply.bind(null, _applyPrefix, _applyVariables);
function _applyPrefix(variables, prop, value) {
  variables['--' + _kebabCase(prop)] = value;
}

function _applyVariables(variables, element) {
  if (!element.style) return;

  forIn(variables, _applyVariable.bind(null, element));
}

function _applyVariable(element, key, value) {
  element.style.setProperty(key, value);
}

/**
 * Set the provided height to elements.
 * @param {(string|Array|NodeList|HTMLCollection|HTMLElement)} elements - The iterable, selector or elements.
 * @param {(number|string)} height - The height as number or string. For number, unit used will be pixels.
 * @return {Array} iterable - The getElements' result for chaining.
 * @example //esnext
 * import { append, setHeight } from 'chirashi'
 *
 * append(document.body, '.maki')
 *
 * setHeight('.maki', 20) // returns: [<div class="maki" style="height: 20px;"></div>]
 * setHeight('.maki', '100%') // returns: [<div class="maki" style="height: 100%;"></div>]
 * @example //es5
 * Chirashi.append(document.body, '.maki')
 *
 * Chirashi.setHeight('.maki', 20) // returns: [<div class="maki" style="height: 20px;"></div>]
 * Chirashi.setHeight('.maki', '100%') // returns: [<div class="maki" style="height: 100%;"></div>]
 */
function setHeight(elements, height) {
  return setStyleProp(elements, { height: height });
}

/**
 * Set the provided size to elements.
 * @param {(string|Array|NodeList|HTMLCollection)} elements - The iterable, selector or elements.
 * @param {(number|string)} width - The width as number or string. For number, unit used will be pixels.
 * @param {(number|string)} height - The height as number or string. For number, unit used will be pixels.
 * @return {Array} iterable - The getElements' result for chaining.
 * @example //esnext
 * import { append, setSize } from 'chirashi'
 *
 * append(document.body, '.maki')
 *
 * setSize('.maki', 20, '100%') // returns: [<div class="maki" style="width: 20px; height: 100%;"></div>]
 * @example //es5
 * Chirashi.append(document.body, '.maki')
 *
 * Chirashi.setSize('.maki', 20, '100%') // returns: [<div class="maki" style="width: 20px; height: 100%;"></div>]
 */
function setSize(elements, width, height) {
  return setStyleProp(elements, { width: width, height: height });
}

/**
 * Set the provided width to elements.
 * @param {(string|Array|NodeList|HTMLCollection|HTMLElement)} elements - The iterable, selector or elements.
 * @param {(number|string)} width - The width as number or string. For number, unit used will be pixels.
 * @return {Array} iterable - The getElements' result for chaining.
 * @example //esnext
 * import { append, setWidth } from 'chirashi'
 *
 * append(document.body, '.maki')
 *
 * setWidth('.maki', 20) // returns: [<div class="maki" style="width: 20px;"></div>]
 * setWidth('.maki', '100%') // returns: [<div class="maki" style="width: 100%;"></div>]
 * @example //es5
 * Chirashi.append(document.body, '.maki')
 *
 * Chirashi.setWidth('.maki', 20) // returns: [<div class="maki" style="width: 20px;"></div>]
 * Chirashi.setWidth('.maki', '100%') // returns: [<div class="maki" style="width: 100%;"></div>]
 */
function setWidth(elements, width) {
  return setStyleProp(elements, { width: width });
}

/**
 * Show each element of elements using visibility.
 * @param {(string|Array|NodeList|HTMLCollection|HTMLElement)} elements - The iterable, selector or elements.
 * @return {Array} iterable - The getElements' result for chaining.
 * @example //esnext
 * import { append, show, getStyleProp }
 * append(document.body, '.maki')
 * const maki = show('.maki')
 * getStyleProp(maki, 'visibility') // returns: "visible"
 * @example //es5
 * Chirashi.append(document.body, '.maki')
 * var maki = Chirashi.show('.maki')
 * Chirashi.getStyleProp(maki, 'visibility') // returns: "visible"
 */
function show(elements) {
  return setStyleProp(elements, { visibility: 'visible' });
}

/**
 * Compute and apply 3d transform matrix from provided transformation to each element of elements.
 * @param {(string|Array|NodeList|HTMLCollection)} elements - The iterable or selector.
 * @param {Transformation} transformation - The transformation as an object
 * @return {Array} iterable - The getElements' result for chaining.
 * @return {function} domElements.chrshPush - Methods to push dom elements into the array. Accepts same input as getElements.
 * @example //esnext
 * import { createElement, setHtml, transform } from 'chirashi'
 * const wasabiPea = createElement('p')
 * setHtml(wasabiPea, 'Wasabi')
 * transform(wasabiPea, {}) // returns: [<p style="transform: "matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)">Wasabi</p>]
 * transform(wasabiPea, {x: 5, y: 6, z: 7}) // returns: [<p style="transform: "matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,5,6,7,1)">Wasabi</p>]
 * transform(wasabiPea, {scale: 2}) // returns: [<p style="transform: "matrix3d(2,0,0,0,0,2,0,0,0,0,1,0,0,0,0,1)">Wasabi</p>]
 * transform(wasabiPea, {scale: {x: 2, y: 3, z: 4}}) // returns: [<p style="transform: "matrix3d(2,0,0,0,0,3,0,0,0,0,4,0,0,0,0,1)">Wasabi</p>]
 * transform(wasabiPea, {rotate: 45}) // returns: [<p style="transform: "matrix3d(0.53,0.85,0,0,-0.85,0.53,0,0,0,0,1,0,0,0,0,1)">Wasabi</p>]
 * transform(wasabiPea, {rotate: {x: 45, y: 20, z: 15}}) // returns: [<p style="transform: "matrix3d(-0.31,0.65,-0.91,0,-0.65,-0.4,0.85,0,0.91,-0.85,0.21,0,0,0,0,1)">Wasabi</p>]
 * transform(wasabiPea, {skew: 45}) // returns: [<p style="transform: "matrix3d(1,1.62,0,0,1.62,1,0,0,0,0,1,0,0,0,0,1)">Wasabi</p>]
 * transform(wasabiPea, {skew: {x: 25, y: 45}}) // returns: [<p style="transform: "matrix3d(1,1.62,0,0,-0.13,1,0,0,0,0,1,0,0,0,0,1)">Wasabi</p>]
 * transform(wasabiPea, {x: 5, y: 6, z: 7, scale: {x: 2, y: 3}, rotate: {x: 45, y: 20, z: 15}, skew: {x: 25, y: 45}}) // returns: [<p style="transform: "matrix3d(-0.62,2.27,-0.91,0,-0.78,-1.2,0.85,0,0.91,-0.85,0.21,0,5,6,7,1)">Wasabi</p>]
 * @example //es5
 * var wasabiPea = Chirashi.createElement('p')
 * Chirashi.setHtml(wasabiPea, 'Wasabi')
 * Chirashi.transform(wasabiPea, {}) // returns: [<p style="transform: "matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)">Wasabi</p>]
 * Chirashi.transform(wasabiPea, {x: 5, y: 6, z: 7}) // returns: [<p style="transform: "matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,5,6,7,1)">Wasabi</p>]
 * Chirashi.transform(wasabiPea, {scale: 2}) // returns: [<p style="transform: "matrix3d(2,0,0,0,0,2,0,0,0,0,1,0,0,0,0,1)">Wasabi</p>]
 * Chirashi.transform(wasabiPea, {scale: {x: 2, y: 3, z: 4}}) // returns: [<p style="transform: "matrix3d(2,0,0,0,0,3,0,0,0,0,4,0,0,0,0,1)">Wasabi</p>]
 * Chirashi.transform(wasabiPea, {rotate: 45}) // returns: [<p style="transform: "matrix3d(0.53,0.85,0,0,-0.85,0.53,0,0,0,0,1,0,0,0,0,1)">Wasabi</p>]
 * Chirashi.transform(wasabiPea, {rotate: {x: 45, y: 20, z: 15}}) // returns: [<p style="transform: "matrix3d(-0.31,0.65,-0.91,0,-0.65,-0.4,0.85,0,0.91,-0.85,0.21,0,0,0,0,1)">Wasabi</p>]
 * Chirashi.transform(wasabiPea, {skew: 45}) // returns: [<p style="transform: "matrix3d(1,1.62,0,0,1.62,1,0,0,0,0,1,0,0,0,0,1)">Wasabi</p>]
 * Chirashi.transform(wasabiPea, {skew: {x: 25, y: 45}}) // returns: [<p style="transform: "matrix3d(1,1.62,0,0,-0.13,1,0,0,0,0,1,0,0,0,0,1)">Wasabi</p>]
 * Chirashi.transform(wasabiPea, {x: 5, y: 6, z: 7, scale: {x: 2, y: 3}, rotate: {x: 45, y: 20, z: 15}, skew: {x: 25, y: 45}}) // returns: [<p style="transform: "matrix3d(-0.62,2.27,-0.91,0,-0.78,-1.2,0.85,0,0.91,-0.85,0.21,0,5,6,7,1)">Wasabi</p>]
 */
function transform(elements, transformation) {
  return setStyleProp(elements, { transform: 'matrix3d(' + _transformMatrix(transformation).join(',') + ')' });
}

function _transformFromObj(values, transformation, name, defaultVal, axe) {
  values[name + axe.toUpperCase()] = axe in transformation[name] ? transformation[name][axe] : defaultVal;
}

function _transformFromGlobal(values, name, defaultAxes, axe) {
  values[name + axe.toUpperCase()] = defaultAxes[axe];
}

function _transformFromDefault(values, name, defaultVal, axe) {
  values[name + axe.toUpperCase()] = defaultVal;
}

function _getValues(transformation, axes, name, defaultVal, defaultAxes) {
  var values = {};

  if (name in transformation) {
    if (_typeof(transformation[name]) === 'object') {
      // set transformation on axes from object
      forEach(axes, _transformFromObj.bind(null, values, transformation, name, defaultVal));
    } else {
      // set transformation on each axes from global value
      forEach(axes, _transformFromGlobal.bind(null, values, name, defaultAxes));
    }
  } else {
    // set default transformation
    forEach(axes, _transformFromDefault.bind(null, values, name, defaultVal));
  }

  return values;
}

function _roundMatrix(matrix, item, index) {
  matrix[index] = +item.toFixed(2);
}

function _transformMatrix(transformation) {
  var x = 'x' in transformation ? transformation.x : 0;
  var y = 'y' in transformation ? transformation.y : 0;
  var z = 'z' in transformation ? transformation.z : 0;

  var _getValues2 = _getValues(transformation, ['x', 'y', 'z'], 'scale', 1, { x: transformation.scale, y: transformation.scale, z: 1 }),
      scaleX = _getValues2.scaleX,
      scaleY = _getValues2.scaleY,
      scaleZ = _getValues2.scaleZ;

  var _getValues3 = _getValues(transformation, ['x', 'y', 'z'], 'rotate', 0, { x: 0, y: 0, z: transformation.rotate }),
      rotateX = _getValues3.rotateX,
      rotateY = _getValues3.rotateY,
      rotateZ = _getValues3.rotateZ;

  var _getValues4 = _getValues(transformation, ['x', 'y'], 'skew', 0, { x: transformation.skew, y: transformation.skew }),
      skewX = _getValues4.skewX,
      skewY = _getValues4.skewY;

  var cosRotateX = Math.cos(rotateX);
  var sinRotateX = Math.sin(rotateX);
  var cosRotateY = Math.cos(rotateY);
  var sinRotateY = Math.sin(rotateY);
  var cosRotateZ = Math.cos(rotateZ);
  var sinRotateZ = Math.sin(rotateZ);
  var tanSkewX = Math.tan(skewX);
  var tanSkewY = Math.tan(skewY);

  var matrix = [scaleX * cosRotateY * cosRotateZ, sinRotateZ + tanSkewY, -sinRotateY, 0, -sinRotateZ + tanSkewX, scaleY * cosRotateX * cosRotateZ, sinRotateX, 0, sinRotateY, -sinRotateX, scaleZ * cosRotateX * cosRotateY, 0, x, y, z, 1];

  forEach(matrix, _roundMatrix.bind(null, matrix));

  return matrix;
}

/**
 * @typedef {Object} Transformation
 * @property {number} [x=0] - Translation value on x axis in pixels.
 * @property {number} [y=0] - Translation value on y axis in pixels.
 * @property {number} [z=0] - Translation value on z axis in pixels.
 * @property {(number|object)} [scale=1] - Scale value for x and y axes or object of values for axes.
 * @property {number} [scale.x=1] - Scale value on x axis.
 * @property {number} [scale.y=1] - Scale value on y axis.
 * @property {number} [scale.z=1] - Scale value on z axis.
 * @property {(number|object)} [rotate=0] - Rotation value for z axis in radians or object of values for axes.
 * @property {number} [rotate.x=0] - Rotation value on x axis in radians.
 * @property {number} [rotate.y=0] - Rotation value on y axis in radians.
 * @property {number} [rotate.z=0] - Rotation value on z axis in radians.
 * @property {(number|object)} [skew=0] - Skew value for x and y axes in radians or object of values for axes.
 * @property {number} [skew.x=0] - Skew value on x axis in radians.
 * @property {number} [skew.y=0] - Skew value on y axis in radians.
 */




/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return withResize; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var withResize=function withResize(WrappedComponent){var breakpoints=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var BREAKPOINTS_CONFIG=Object.assign({mobile:1024,large:1440},breakpoints);return function(_Component){_inherits(_class2,_Component);function _class2(){var _ref;var _temp,_this,_ret;_classCallCheck(this,_class2);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=_class2.__proto__||Object.getPrototypeOf(_class2)).call.apply(_ref,[this].concat(args))),_this),_this.state={isMobile:window.innerWidth<BREAKPOINTS_CONFIG.mobile,isDesktop:window.innerWidth>BREAKPOINTS_CONFIG.mobile&&window.innerWidth<BREAKPOINTS_CONFIG.large,isLarge:window.innerWidth>BREAKPOINTS_CONFIG.large},_this.onResize=Object(__WEBPACK_IMPORTED_MODULE_1_lodash__["throttle"])(function(){_this.setState({isMobile:window.innerWidth<BREAKPOINTS_CONFIG.mobile,isDesktop:window.innerWidth>BREAKPOINTS_CONFIG.mobile&&window.innerWidth<BREAKPOINTS_CONFIG.large,isLarge:window.innerWidth>BREAKPOINTS_CONFIG.large});},400),_temp),_possibleConstructorReturn(_this,_ret);}_createClass(_class2,[{key:'componentDidMount',value:function componentDidMount(){this.resize=window.addEventListener('resize',this.onResize.bind(this));}},{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener('resize',this.onResize.bind(this));}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedComponent,Object.assign({viewport:this.state},this.props));}}]);return _class2;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);};

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Search__ = __webpack_require__(449);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_0__Search__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Product___ = __webpack_require__(450);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_1__Product___["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Catalog__ = __webpack_require__(473);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_2__Catalog__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Bookmarks__ = __webpack_require__(474);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__Bookmarks__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Publication__ = __webpack_require__(475);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_4__Publication__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Agenda__ = __webpack_require__(476);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_5__Agenda__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Article__ = __webpack_require__(479);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_6__Article__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Challenge__ = __webpack_require__(480);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_7__Challenge__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Contact__ = __webpack_require__(481);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_8__Contact__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Counterfeits__ = __webpack_require__(482);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_9__Counterfeits__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Counterfeit__ = __webpack_require__(483);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_10__Counterfeit__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Faq__ = __webpack_require__(484);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_11__Faq__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Gift__ = __webpack_require__(487);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_12__Gift__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__HubQuizz__ = __webpack_require__(488);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_13__HubQuizz__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Page__ = __webpack_require__(489);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_14__Page__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Quizz___ = __webpack_require__(490);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_15__Quizz___["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Ranking__ = __webpack_require__(495);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_16__Ranking__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Report__ = __webpack_require__(496);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_17__Report__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Sitemap__ = __webpack_require__(497);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_18__Sitemap__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__SocialMedia__ = __webpack_require__(498);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_19__SocialMedia__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__Stock__ = __webpack_require__(499);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return __WEBPACK_IMPORTED_MODULE_20__Stock__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__Team__ = __webpack_require__(500);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return __WEBPACK_IMPORTED_MODULE_21__Team__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__Thefts__ = __webpack_require__(501);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return __WEBPACK_IMPORTED_MODULE_22__Thefts__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__User__ = __webpack_require__(502);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return __WEBPACK_IMPORTED_MODULE_23__User__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__Theft__ = __webpack_require__(503);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return __WEBPACK_IMPORTED_MODULE_24__Theft__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__Legals__ = __webpack_require__(504);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_25__Legals__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__Privacy__ = __webpack_require__(505);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_26__Privacy__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__Training__ = __webpack_require__(506);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return __WEBPACK_IMPORTED_MODULE_27__Training__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__CatalogEvent__ = __webpack_require__(507);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_28__CatalogEvent__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__Interviews__ = __webpack_require__(508);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_29__Interviews__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__InDepth__ = __webpack_require__(509);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_30__InDepth__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__CharityForm__ = __webpack_require__(510);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_31__CharityForm__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__CharityCatalog__ = __webpack_require__(511);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_32__CharityCatalog__["a"]; });


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/default_picture_RM.0abb47bb.jpg";

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return GetMonth; });
/* unused harmony export DateDiff */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DayDiff; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Date_FR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DateFormat; });
/* unused harmony export deployCF */
var GetMonth=function GetMonth(m){var months=['January','February','March','April','May','June','July','August','September','October','November','December'];return months[parseInt(m)-1];};var DateDiff=function DateDiff(dateold,datenew){var mnew=datenew.getMonth();var dnew=datenew.getDate();var mold=dateold.getMonth();var dold=dateold.getDate();var diff=datenew-dateold;if(mold>mnew)diff--;else{if(mold==mnew){if(dold>dnew)diff--;}}return diff;};var DayDiff=function DayDiff(d1,d2){d1=d1.getTime()/86400000;d2=d2.getTime()/86400000;return new Number(d2-d1).toFixed(0);};var Date_FR=function Date_FR(date){var month=date.slice(5,7);var year=date.slice(0,4);var day=date.slice(8,10);return day+'/'+month+'/'+year;};var DateFormat=function DateFormat(date){switch(date){case 1:case 31:return date+'<sup>st</sup>';case 2:return date+'<sup>nd</sup>';case 3:return date+'<sup>rd</sup>';default:return date+'<sup>th</sup>';}};var deployCF=function deployCF(test){return true;};

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(185);
} else {
  module.exports = require('./cjs/react-is.development.js');
}


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(6);

var invariant = __webpack_require__(4);

/**
 * Injectable ordering of event plugins.
 */
var eventPluginOrder = null;

/**
 * Injectable mapping from names to event plugin modules.
 */
var namesToPlugins = {};

/**
 * Recomputes the plugin list using the injected plugins and plugin ordering.
 *
 * @private
 */
function recomputePluginOrdering() {
  if (!eventPluginOrder) {
    // Wait until an `eventPluginOrder` is injected.
    return;
  }
  for (var pluginName in namesToPlugins) {
    var pluginModule = namesToPlugins[pluginName];
    var pluginIndex = eventPluginOrder.indexOf(pluginName);
    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `%s`.', pluginName) : _prodInvariant('96', pluginName) : void 0;
    if (EventPluginRegistry.plugins[pluginIndex]) {
      continue;
    }
    !pluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `%s` does not.', pluginName) : _prodInvariant('97', pluginName) : void 0;
    EventPluginRegistry.plugins[pluginIndex] = pluginModule;
    var publishedEvents = pluginModule.eventTypes;
    for (var eventName in publishedEvents) {
      !publishEventForPlugin(publishedEvents[eventName], pluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : _prodInvariant('98', eventName, pluginName) : void 0;
    }
  }
}

/**
 * Publishes an event so that it can be dispatched by the supplied plugin.
 *
 * @param {object} dispatchConfig Dispatch configuration for the event.
 * @param {object} PluginModule Plugin publishing the event.
 * @return {boolean} True if the event was successfully published.
 * @private
 */
function publishEventForPlugin(dispatchConfig, pluginModule, eventName) {
  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same event name, `%s`.', eventName) : _prodInvariant('99', eventName) : void 0;
  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;

  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
  if (phasedRegistrationNames) {
    for (var phaseName in phasedRegistrationNames) {
      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
        var phasedRegistrationName = phasedRegistrationNames[phaseName];
        publishRegistrationName(phasedRegistrationName, pluginModule, eventName);
      }
    }
    return true;
  } else if (dispatchConfig.registrationName) {
    publishRegistrationName(dispatchConfig.registrationName, pluginModule, eventName);
    return true;
  }
  return false;
}

/**
 * Publishes a registration name that is used to identify dispatched events and
 * can be used with `EventPluginHub.putListener` to register listeners.
 *
 * @param {string} registrationName Registration name to add.
 * @param {object} PluginModule Plugin publishing the event.
 * @private
 */
function publishRegistrationName(registrationName, pluginModule, eventName) {
  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same registration name, `%s`.', registrationName) : _prodInvariant('100', registrationName) : void 0;
  EventPluginRegistry.registrationNameModules[registrationName] = pluginModule;
  EventPluginRegistry.registrationNameDependencies[registrationName] = pluginModule.eventTypes[eventName].dependencies;

  if (false) {
    var lowerCasedName = registrationName.toLowerCase();
    EventPluginRegistry.possibleRegistrationNames[lowerCasedName] = registrationName;

    if (registrationName === 'onDoubleClick') {
      EventPluginRegistry.possibleRegistrationNames.ondblclick = registrationName;
    }
  }
}

/**
 * Registers plugins so that they can extract and dispatch events.
 *
 * @see {EventPluginHub}
 */
var EventPluginRegistry = {
  /**
   * Ordered list of injected plugins.
   */
  plugins: [],

  /**
   * Mapping from event name to dispatch config
   */
  eventNameDispatchConfigs: {},

  /**
   * Mapping from registration name to plugin module
   */
  registrationNameModules: {},

  /**
   * Mapping from registration name to event name
   */
  registrationNameDependencies: {},

  /**
   * Mapping from lowercase registration names to the properly cased version,
   * used to warn in the case of missing event handlers. Available
   * only in __DEV__.
   * @type {Object}
   */
  possibleRegistrationNames:  false ? {} : null,
  // Trust the developer to only use possibleRegistrationNames in __DEV__

  /**
   * Injects an ordering of plugins (by plugin name). This allows the ordering
   * to be decoupled from injection of the actual plugins so that ordering is
   * always deterministic regardless of packaging, on-the-fly injection, etc.
   *
   * @param {array} InjectedEventPluginOrder
   * @internal
   * @see {EventPluginHub.injection.injectEventPluginOrder}
   */
  injectEventPluginOrder: function (injectedEventPluginOrder) {
    !!eventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.') : _prodInvariant('101') : void 0;
    // Clone the ordering so it cannot be dynamically mutated.
    eventPluginOrder = Array.prototype.slice.call(injectedEventPluginOrder);
    recomputePluginOrdering();
  },

  /**
   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
   * in the ordering injected by `injectEventPluginOrder`.
   *
   * Plugins can be injected as part of page initialization or on-the-fly.
   *
   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
   * @internal
   * @see {EventPluginHub.injection.injectEventPluginsByName}
   */
  injectEventPluginsByName: function (injectedNamesToPlugins) {
    var isOrderingDirty = false;
    for (var pluginName in injectedNamesToPlugins) {
      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
        continue;
      }
      var pluginModule = injectedNamesToPlugins[pluginName];
      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== pluginModule) {
        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins using the same name, `%s`.', pluginName) : _prodInvariant('102', pluginName) : void 0;
        namesToPlugins[pluginName] = pluginModule;
        isOrderingDirty = true;
      }
    }
    if (isOrderingDirty) {
      recomputePluginOrdering();
    }
  },

  /**
   * Looks up the plugin for the supplied event.
   *
   * @param {object} event A synthetic event.
   * @return {?object} The plugin that created the supplied event.
   * @internal
   */
  getPluginModuleForEvent: function (event) {
    var dispatchConfig = event.dispatchConfig;
    if (dispatchConfig.registrationName) {
      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
    }
    if (dispatchConfig.phasedRegistrationNames !== undefined) {
      // pulling phasedRegistrationNames out of dispatchConfig helps Flow see
      // that it is not undefined.
      var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;

      for (var phase in phasedRegistrationNames) {
        if (!phasedRegistrationNames.hasOwnProperty(phase)) {
          continue;
        }
        var pluginModule = EventPluginRegistry.registrationNameModules[phasedRegistrationNames[phase]];
        if (pluginModule) {
          return pluginModule;
        }
      }
    }
    return null;
  },

  /**
   * Exposed for unit testing.
   * @private
   */
  _resetEventPlugins: function () {
    eventPluginOrder = null;
    for (var pluginName in namesToPlugins) {
      if (namesToPlugins.hasOwnProperty(pluginName)) {
        delete namesToPlugins[pluginName];
      }
    }
    EventPluginRegistry.plugins.length = 0;

    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
    for (var eventName in eventNameDispatchConfigs) {
      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
        delete eventNameDispatchConfigs[eventName];
      }
    }

    var registrationNameModules = EventPluginRegistry.registrationNameModules;
    for (var registrationName in registrationNameModules) {
      if (registrationNameModules.hasOwnProperty(registrationName)) {
        delete registrationNameModules[registrationName];
      }
    }

    if (false) {
      var possibleRegistrationNames = EventPluginRegistry.possibleRegistrationNames;
      for (var lowerCasedName in possibleRegistrationNames) {
        if (possibleRegistrationNames.hasOwnProperty(lowerCasedName)) {
          delete possibleRegistrationNames[lowerCasedName];
        }
      }
    }
  }
};

module.exports = EventPluginRegistry;

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(6);

var ReactErrorUtils = __webpack_require__(69);

var invariant = __webpack_require__(4);
var warning = __webpack_require__(7);

/**
 * Injected dependencies:
 */

/**
 * - `ComponentTree`: [required] Module that can convert between React instances
 *   and actual node references.
 */
var ComponentTree;
var TreeTraversal;
var injection = {
  injectComponentTree: function (Injected) {
    ComponentTree = Injected;
    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.getNodeFromInstance && Injected.getInstanceFromNode, 'EventPluginUtils.injection.injectComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.') : void 0;
    }
  },
  injectTreeTraversal: function (Injected) {
    TreeTraversal = Injected;
    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.isAncestor && Injected.getLowestCommonAncestor, 'EventPluginUtils.injection.injectTreeTraversal(...): Injected ' + 'module is missing isAncestor or getLowestCommonAncestor.') : void 0;
    }
  }
};

function isEndish(topLevelType) {
  return topLevelType === 'topMouseUp' || topLevelType === 'topTouchEnd' || topLevelType === 'topTouchCancel';
}

function isMoveish(topLevelType) {
  return topLevelType === 'topMouseMove' || topLevelType === 'topTouchMove';
}
function isStartish(topLevelType) {
  return topLevelType === 'topMouseDown' || topLevelType === 'topTouchStart';
}

var validateEventDispatches;
if (false) {
  validateEventDispatches = function (event) {
    var dispatchListeners = event._dispatchListeners;
    var dispatchInstances = event._dispatchInstances;

    var listenersIsArr = Array.isArray(dispatchListeners);
    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;

    var instancesIsArr = Array.isArray(dispatchInstances);
    var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;

    process.env.NODE_ENV !== 'production' ? warning(instancesIsArr === listenersIsArr && instancesLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : void 0;
  };
}

/**
 * Dispatch the event to the listener.
 * @param {SyntheticEvent} event SyntheticEvent to handle
 * @param {boolean} simulated If the event is simulated (changes exn behavior)
 * @param {function} listener Application-level callback
 * @param {*} inst Internal component instance
 */
function executeDispatch(event, simulated, listener, inst) {
  var type = event.type || 'unknown-event';
  event.currentTarget = EventPluginUtils.getNodeFromInstance(inst);
  if (simulated) {
    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event);
  } else {
    ReactErrorUtils.invokeGuardedCallback(type, listener, event);
  }
  event.currentTarget = null;
}

/**
 * Standard/simple iteration through an event's collected dispatches.
 */
function executeDispatchesInOrder(event, simulated) {
  var dispatchListeners = event._dispatchListeners;
  var dispatchInstances = event._dispatchInstances;
  if (false) {
    validateEventDispatches(event);
  }
  if (Array.isArray(dispatchListeners)) {
    for (var i = 0; i < dispatchListeners.length; i++) {
      if (event.isPropagationStopped()) {
        break;
      }
      // Listeners and Instances are two parallel arrays that are always in sync.
      executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
    }
  } else if (dispatchListeners) {
    executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
  }
  event._dispatchListeners = null;
  event._dispatchInstances = null;
}

/**
 * Standard/simple iteration through an event's collected dispatches, but stops
 * at the first dispatch execution returning true, and returns that id.
 *
 * @return {?string} id of the first dispatch execution who's listener returns
 * true, or null if no listener returned true.
 */
function executeDispatchesInOrderStopAtTrueImpl(event) {
  var dispatchListeners = event._dispatchListeners;
  var dispatchInstances = event._dispatchInstances;
  if (false) {
    validateEventDispatches(event);
  }
  if (Array.isArray(dispatchListeners)) {
    for (var i = 0; i < dispatchListeners.length; i++) {
      if (event.isPropagationStopped()) {
        break;
      }
      // Listeners and Instances are two parallel arrays that are always in sync.
      if (dispatchListeners[i](event, dispatchInstances[i])) {
        return dispatchInstances[i];
      }
    }
  } else if (dispatchListeners) {
    if (dispatchListeners(event, dispatchInstances)) {
      return dispatchInstances;
    }
  }
  return null;
}

/**
 * @see executeDispatchesInOrderStopAtTrueImpl
 */
function executeDispatchesInOrderStopAtTrue(event) {
  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
  event._dispatchInstances = null;
  event._dispatchListeners = null;
  return ret;
}

/**
 * Execution of a "direct" dispatch - there must be at most one dispatch
 * accumulated on the event or it is considered an error. It doesn't really make
 * sense for an event with multiple dispatches (bubbled) to keep track of the
 * return values at each dispatch execution, but it does tend to make sense when
 * dealing with "direct" dispatches.
 *
 * @return {*} The return value of executing the single dispatch.
 */
function executeDirectDispatch(event) {
  if (false) {
    validateEventDispatches(event);
  }
  var dispatchListener = event._dispatchListeners;
  var dispatchInstance = event._dispatchInstances;
  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : _prodInvariant('103') : void 0;
  event.currentTarget = dispatchListener ? EventPluginUtils.getNodeFromInstance(dispatchInstance) : null;
  var res = dispatchListener ? dispatchListener(event) : null;
  event.currentTarget = null;
  event._dispatchListeners = null;
  event._dispatchInstances = null;
  return res;
}

/**
 * @param {SyntheticEvent} event
 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
 */
function hasDispatches(event) {
  return !!event._dispatchListeners;
}

/**
 * General utilities that are useful in creating custom Event Plugins.
 */
var EventPluginUtils = {
  isEndish: isEndish,
  isMoveish: isMoveish,
  isStartish: isStartish,

  executeDirectDispatch: executeDirectDispatch,
  executeDispatchesInOrder: executeDispatchesInOrder,
  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
  hasDispatches: hasDispatches,

  getInstanceFromNode: function (node) {
    return ComponentTree.getInstanceFromNode(node);
  },
  getNodeFromInstance: function (node) {
    return ComponentTree.getNodeFromInstance(node);
  },
  isAncestor: function (a, b) {
    return TreeTraversal.isAncestor(a, b);
  },
  getLowestCommonAncestor: function (a, b) {
    return TreeTraversal.getLowestCommonAncestor(a, b);
  },
  getParentInstance: function (inst) {
    return TreeTraversal.getParentInstance(inst);
  },
  traverseTwoPhase: function (target, fn, arg) {
    return TreeTraversal.traverseTwoPhase(target, fn, arg);
  },
  traverseEnterLeave: function (from, to, fn, argFrom, argTo) {
    return TreeTraversal.traverseEnterLeave(from, to, fn, argFrom, argTo);
  },

  injection: injection
};

module.exports = EventPluginUtils;

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var caughtError = null;

/**
 * Call a function while guarding against errors that happens within it.
 *
 * @param {String} name of the guard to use for logging or debugging
 * @param {Function} func The function to invoke
 * @param {*} a First argument
 * @param {*} b Second argument
 */
function invokeGuardedCallback(name, func, a) {
  try {
    func(a);
  } catch (x) {
    if (caughtError === null) {
      caughtError = x;
    }
  }
}

var ReactErrorUtils = {
  invokeGuardedCallback: invokeGuardedCallback,

  /**
   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
   * handler are sure to be rethrown by rethrowCaughtError.
   */
  invokeGuardedCallbackWithCatch: invokeGuardedCallback,

  /**
   * During execution of guarded functions we will capture the first error which
   * we will rethrow to be handled by the top level error handler.
   */
  rethrowCaughtError: function () {
    if (caughtError) {
      var error = caughtError;
      caughtError = null;
      throw error;
    }
  }
};

if (false) {
  /**
   * To help development we can get better devtools integration by simulating a
   * real browser event.
   */
  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
    var fakeNode = document.createElement('react');
    ReactErrorUtils.invokeGuardedCallback = function (name, func, a) {
      var boundFunc = function () {
        func(a);
      };
      var evtType = 'react-' + name;
      fakeNode.addEventListener(evtType, boundFunc, false);
      var evt = document.createEvent('Event');
      evt.initEvent(evtType, false, false);
      fakeNode.dispatchEvent(evt);
      fakeNode.removeEventListener(evtType, boundFunc, false);
    };
  }
}

module.exports = ReactErrorUtils;

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Gets the target node from a native browser event by accounting for
 * inconsistencies in browser DOM APIs.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {DOMEventTarget} Target node.
 */

function getEventTarget(nativeEvent) {
  var target = nativeEvent.target || nativeEvent.srcElement || window;

  // Normalize SVG <use> element events #4963
  if (target.correspondingUseElement) {
    target = target.correspondingUseElement;
  }

  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
  // @see http://www.quirksmode.org/js/events_properties.html
  return target.nodeType === 3 ? target.parentNode : target;
}

module.exports = getEventTarget;

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ExecutionEnvironment = __webpack_require__(16);

var useHasFeature;
if (ExecutionEnvironment.canUseDOM) {
  useHasFeature = document.implementation && document.implementation.hasFeature &&
  // always returns true in newer browsers as per the standard.
  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
  document.implementation.hasFeature('', '') !== true;
}

/**
 * Checks if an event is supported in the current execution environment.
 *
 * NOTE: This will not work correctly for non-generic events such as `change`,
 * `reset`, `load`, `error`, and `select`.
 *
 * Borrows from Modernizr.
 *
 * @param {string} eventNameSuffix Event name, e.g. "click".
 * @param {?boolean} capture Check if the capture phase is supported.
 * @return {boolean} True if the event is supported.
 * @internal
 * @license Modernizr 3.0.0pre (Custom Build) | MIT
 */
function isEventSupported(eventNameSuffix, capture) {
  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
    return false;
  }

  var eventName = 'on' + eventNameSuffix;
  var isSupported = eventName in document;

  if (!isSupported) {
    var element = document.createElement('div');
    element.setAttribute(eventName, 'return;');
    isSupported = typeof element[eventName] === 'function';
  }

  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
    // This is the only way to test support for the `wheel` event in IE9+.
    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
  }

  return isSupported;
}

module.exports = isEventSupported;

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Translation from modifier key to the associated property in the event.
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
 */

var modifierKeyToProp = {
  Alt: 'altKey',
  Control: 'ctrlKey',
  Meta: 'metaKey',
  Shift: 'shiftKey'
};

// IE8 does not implement getModifierState so we simply map it to the only
// modifier keys exposed by the event itself, does not support Lock-keys.
// Currently, all major browsers except Chrome seems to support Lock-keys.
function modifierStateGetter(keyArg) {
  var syntheticEvent = this;
  var nativeEvent = syntheticEvent.nativeEvent;
  if (nativeEvent.getModifierState) {
    return nativeEvent.getModifierState(keyArg);
  }
  var keyProp = modifierKeyToProp[keyArg];
  return keyProp ? !!nativeEvent[keyProp] : false;
}

function getEventModifierState(nativeEvent) {
  return modifierStateGetter;
}

module.exports = getEventModifierState;

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var DOMLazyTree = __webpack_require__(33);
var Danger = __webpack_require__(205);
var ReactDOMComponentTree = __webpack_require__(13);
var ReactInstrumentation = __webpack_require__(18);

var createMicrosoftUnsafeLocalFunction = __webpack_require__(75);
var setInnerHTML = __webpack_require__(52);
var setTextContent = __webpack_require__(112);

function getNodeAfter(parentNode, node) {
  // Special case for text components, which return [open, close] comments
  // from getHostNode.
  if (Array.isArray(node)) {
    node = node[1];
  }
  return node ? node.nextSibling : parentNode.firstChild;
}

/**
 * Inserts `childNode` as a child of `parentNode` at the `index`.
 *
 * @param {DOMElement} parentNode Parent node in which to insert.
 * @param {DOMElement} childNode Child node to insert.
 * @param {number} index Index at which to insert the child.
 * @internal
 */
var insertChildAt = createMicrosoftUnsafeLocalFunction(function (parentNode, childNode, referenceNode) {
  // We rely exclusively on `insertBefore(node, null)` instead of also using
  // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
  // we are careful to use `null`.)
  parentNode.insertBefore(childNode, referenceNode);
});

function insertLazyTreeChildAt(parentNode, childTree, referenceNode) {
  DOMLazyTree.insertTreeBefore(parentNode, childTree, referenceNode);
}

function moveChild(parentNode, childNode, referenceNode) {
  if (Array.isArray(childNode)) {
    moveDelimitedText(parentNode, childNode[0], childNode[1], referenceNode);
  } else {
    insertChildAt(parentNode, childNode, referenceNode);
  }
}

function removeChild(parentNode, childNode) {
  if (Array.isArray(childNode)) {
    var closingComment = childNode[1];
    childNode = childNode[0];
    removeDelimitedText(parentNode, childNode, closingComment);
    parentNode.removeChild(closingComment);
  }
  parentNode.removeChild(childNode);
}

function moveDelimitedText(parentNode, openingComment, closingComment, referenceNode) {
  var node = openingComment;
  while (true) {
    var nextNode = node.nextSibling;
    insertChildAt(parentNode, node, referenceNode);
    if (node === closingComment) {
      break;
    }
    node = nextNode;
  }
}

function removeDelimitedText(parentNode, startNode, closingComment) {
  while (true) {
    var node = startNode.nextSibling;
    if (node === closingComment) {
      // The closing comment is removed by ReactMultiChild.
      break;
    } else {
      parentNode.removeChild(node);
    }
  }
}

function replaceDelimitedText(openingComment, closingComment, stringText) {
  var parentNode = openingComment.parentNode;
  var nodeAfterComment = openingComment.nextSibling;
  if (nodeAfterComment === closingComment) {
    // There are no text nodes between the opening and closing comments; insert
    // a new one if stringText isn't empty.
    if (stringText) {
      insertChildAt(parentNode, document.createTextNode(stringText), nodeAfterComment);
    }
  } else {
    if (stringText) {
      // Set the text content of the first node after the opening comment, and
      // remove all following nodes up until the closing comment.
      setTextContent(nodeAfterComment, stringText);
      removeDelimitedText(parentNode, nodeAfterComment, closingComment);
    } else {
      removeDelimitedText(parentNode, openingComment, closingComment);
    }
  }

  if (false) {
    ReactInstrumentation.debugTool.onHostOperation({
      instanceID: ReactDOMComponentTree.getInstanceFromNode(openingComment)._debugID,
      type: 'replace text',
      payload: stringText
    });
  }
}

var dangerouslyReplaceNodeWithMarkup = Danger.dangerouslyReplaceNodeWithMarkup;
if (false) {
  dangerouslyReplaceNodeWithMarkup = function (oldChild, markup, prevInstance) {
    Danger.dangerouslyReplaceNodeWithMarkup(oldChild, markup);
    if (prevInstance._debugID !== 0) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: prevInstance._debugID,
        type: 'replace with',
        payload: markup.toString()
      });
    } else {
      var nextInstance = ReactDOMComponentTree.getInstanceFromNode(markup.node);
      if (nextInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onHostOperation({
          instanceID: nextInstance._debugID,
          type: 'mount',
          payload: markup.toString()
        });
      }
    }
  };
}

/**
 * Operations for updating with DOM children.
 */
var DOMChildrenOperations = {
  dangerouslyReplaceNodeWithMarkup: dangerouslyReplaceNodeWithMarkup,

  replaceDelimitedText: replaceDelimitedText,

  /**
   * Updates a component's children by processing a series of updates. The
   * update configurations are each expected to have a `parentNode` property.
   *
   * @param {array<object>} updates List of update configurations.
   * @internal
   */
  processUpdates: function (parentNode, updates) {
    if (false) {
      var parentNodeDebugID = ReactDOMComponentTree.getInstanceFromNode(parentNode)._debugID;
    }

    for (var k = 0; k < updates.length; k++) {
      var update = updates[k];
      switch (update.type) {
        case 'INSERT_MARKUP':
          insertLazyTreeChildAt(parentNode, update.content, getNodeAfter(parentNode, update.afterNode));
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'insert child',
              payload: {
                toIndex: update.toIndex,
                content: update.content.toString()
              }
            });
          }
          break;
        case 'MOVE_EXISTING':
          moveChild(parentNode, update.fromNode, getNodeAfter(parentNode, update.afterNode));
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'move child',
              payload: { fromIndex: update.fromIndex, toIndex: update.toIndex }
            });
          }
          break;
        case 'SET_MARKUP':
          setInnerHTML(parentNode, update.content);
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'replace children',
              payload: update.content.toString()
            });
          }
          break;
        case 'TEXT_CONTENT':
          setTextContent(parentNode, update.content);
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'replace text',
              payload: update.content.toString()
            });
          }
          break;
        case 'REMOVE_NODE':
          removeChild(parentNode, update.fromNode);
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'remove child',
              payload: { fromIndex: update.fromIndex }
            });
          }
          break;
      }
    }
  }
};

module.exports = DOMChildrenOperations;

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var DOMNamespaces = {
  html: 'http://www.w3.org/1999/xhtml',
  mathml: 'http://www.w3.org/1998/Math/MathML',
  svg: 'http://www.w3.org/2000/svg'
};

module.exports = DOMNamespaces;

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/* globals MSApp */



/**
 * Create a function which has 'unsafe' privileges (required by windows8 apps)
 */

var createMicrosoftUnsafeLocalFunction = function (func) {
  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
    return function (arg0, arg1, arg2, arg3) {
      MSApp.execUnsafeLocalFunction(function () {
        return func(arg0, arg1, arg2, arg3);
      });
    };
  } else {
    return func;
  }
};

module.exports = createMicrosoftUnsafeLocalFunction;

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(6);

var ReactPropTypesSecret = __webpack_require__(223);
var propTypesFactory = __webpack_require__(101);

var React = __webpack_require__(29);
var PropTypes = propTypesFactory(React.isValidElement);

var invariant = __webpack_require__(4);
var warning = __webpack_require__(7);

var hasReadOnlyValue = {
  button: true,
  checkbox: true,
  image: true,
  hidden: true,
  radio: true,
  reset: true,
  submit: true
};

function _assertSingleLink(inputProps) {
  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use checkedLink, you probably don\'t want to use valueLink and vice versa.') : _prodInvariant('87') : void 0;
}
function _assertValueLink(inputProps) {
  _assertSingleLink(inputProps);
  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want to use value or onChange, you probably don\'t want to use valueLink.') : _prodInvariant('88') : void 0;
}

function _assertCheckedLink(inputProps) {
  _assertSingleLink(inputProps);
  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. If you want to use checked or onChange, you probably don\'t want to use checkedLink') : _prodInvariant('89') : void 0;
}

var propTypes = {
  value: function (props, propName, componentName) {
    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
      return null;
    }
    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
  },
  checked: function (props, propName, componentName) {
    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
      return null;
    }
    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
  },
  onChange: PropTypes.func
};

var loggedTypeFailures = {};
function getDeclarationErrorAddendum(owner) {
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

/**
 * Provide a linked `value` attribute for controlled forms. You should not use
 * this outside of the ReactDOM controlled form components.
 */
var LinkedValueUtils = {
  checkPropTypes: function (tagName, props, owner) {
    for (var propName in propTypes) {
      if (propTypes.hasOwnProperty(propName)) {
        var error = propTypes[propName](props, propName, tagName, 'prop', null, ReactPropTypesSecret);
      }
      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
        // Only monitor this failure once because there tends to be a lot of the
        // same error.
        loggedTypeFailures[error.message] = true;

        var addendum = getDeclarationErrorAddendum(owner);
         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : void 0;
      }
    }
  },

  /**
   * @param {object} inputProps Props for form component
   * @return {*} current value of the input either from value prop or link.
   */
  getValue: function (inputProps) {
    if (inputProps.valueLink) {
      _assertValueLink(inputProps);
      return inputProps.valueLink.value;
    }
    return inputProps.value;
  },

  /**
   * @param {object} inputProps Props for form component
   * @return {*} current checked status of the input either from checked prop
   *             or link.
   */
  getChecked: function (inputProps) {
    if (inputProps.checkedLink) {
      _assertCheckedLink(inputProps);
      return inputProps.checkedLink.value;
    }
    return inputProps.checked;
  },

  /**
   * @param {object} inputProps Props for form component
   * @param {SyntheticEvent} event change event to handle
   */
  executeOnChange: function (inputProps, event) {
    if (inputProps.valueLink) {
      _assertValueLink(inputProps);
      return inputProps.valueLink.requestChange(event.target.value);
    } else if (inputProps.checkedLink) {
      _assertCheckedLink(inputProps);
      return inputProps.checkedLink.requestChange(event.target.checked);
    } else if (inputProps.onChange) {
      return inputProps.onChange.call(undefined, event);
    }
  }
};

module.exports = LinkedValueUtils;

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(6);

var invariant = __webpack_require__(4);

var injected = false;

var ReactComponentEnvironment = {
  /**
   * Optionally injectable hook for swapping out mount images in the middle of
   * the tree.
   */
  replaceNodeWithMarkup: null,

  /**
   * Optionally injectable hook for processing a queue of child updates. Will
   * later move into MultiChildComponents.
   */
  processChildrenUpdates: null,

  injection: {
    injectEnvironment: function (environment) {
      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : _prodInvariant('104') : void 0;
      ReactComponentEnvironment.replaceNodeWithMarkup = environment.replaceNodeWithMarkup;
      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
      injected = true;
    }
  }
};

module.exports = ReactComponentEnvironment;

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Given a `prevElement` and `nextElement`, determines if the existing
 * instance should be updated as opposed to being destroyed or replaced by a new
 * instance. Both arguments are elements. This ensures that this logic can
 * operate on stateless trees without any backing instance.
 *
 * @param {?object} prevElement
 * @param {?object} nextElement
 * @return {boolean} True if the existing instance should be updated.
 * @protected
 */

function shouldUpdateReactComponent(prevElement, nextElement) {
  var prevEmpty = prevElement === null || prevElement === false;
  var nextEmpty = nextElement === null || nextElement === false;
  if (prevEmpty || nextEmpty) {
    return prevEmpty === nextEmpty;
  }

  var prevType = typeof prevElement;
  var nextType = typeof nextElement;
  if (prevType === 'string' || prevType === 'number') {
    return nextType === 'string' || nextType === 'number';
  } else {
    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
  }
}

module.exports = shouldUpdateReactComponent;

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */

function escape(key) {
  var escapeRegex = /[=:]/g;
  var escaperLookup = {
    '=': '=0',
    ':': '=2'
  };
  var escapedString = ('' + key).replace(escapeRegex, function (match) {
    return escaperLookup[match];
  });

  return '$' + escapedString;
}

/**
 * Unescape and unwrap key for human-readable display
 *
 * @param {string} key to unescape.
 * @return {string} the unescaped key.
 */
function unescape(key) {
  var unescapeRegex = /(=0|=2)/g;
  var unescaperLookup = {
    '=0': '=',
    '=2': ':'
  };
  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);

  return ('' + keySubstring).replace(unescapeRegex, function (match) {
    return unescaperLookup[match];
  });
}

var KeyEscapeUtils = {
  escape: escape,
  unescape: unescape
};

module.exports = KeyEscapeUtils;

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(6);

var ReactCurrentOwner = __webpack_require__(22);
var ReactInstanceMap = __webpack_require__(45);
var ReactInstrumentation = __webpack_require__(18);
var ReactUpdates = __webpack_require__(20);

var invariant = __webpack_require__(4);
var warning = __webpack_require__(7);

function enqueueUpdate(internalInstance) {
  ReactUpdates.enqueueUpdate(internalInstance);
}

function formatUnexpectedArgument(arg) {
  var type = typeof arg;
  if (type !== 'object') {
    return type;
  }
  var displayName = arg.constructor && arg.constructor.name || type;
  var keys = Object.keys(arg);
  if (keys.length > 0 && keys.length < 20) {
    return displayName + ' (keys: ' + keys.join(', ') + ')';
  }
  return displayName;
}

function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
  var internalInstance = ReactInstanceMap.get(publicInstance);
  if (!internalInstance) {
    if (false) {
      var ctor = publicInstance.constructor;
      // Only warn when we have a callerName. Otherwise we should be silent.
      // We're probably calling from enqueueCallback. We don't want to warn
      // there because we already warned for the corresponding lifecycle method.
      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, ctor && (ctor.displayName || ctor.name) || 'ReactClass') : void 0;
    }
    return null;
  }

  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition (such as ' + "within `render` or another component's constructor). Render methods " + 'should be a pure function of props and state; constructor ' + 'side-effects are an anti-pattern, but can be moved to ' + '`componentWillMount`.', callerName) : void 0;
  }

  return internalInstance;
}

/**
 * ReactUpdateQueue allows for state updates to be scheduled into a later
 * reconciliation step.
 */
var ReactUpdateQueue = {
  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */
  isMounted: function (publicInstance) {
    if (false) {
      var owner = ReactCurrentOwner.current;
      if (owner !== null) {
        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
        owner._warnedAboutRefsInRender = true;
      }
    }
    var internalInstance = ReactInstanceMap.get(publicInstance);
    if (internalInstance) {
      // During componentWillMount and render this will still be null but after
      // that will always render to something. At least for now. So we can use
      // this hack.
      return !!internalInstance._renderedComponent;
    } else {
      return false;
    }
  },

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @param {string} callerName Name of the calling function in the public API.
   * @internal
   */
  enqueueCallback: function (publicInstance, callback, callerName) {
    ReactUpdateQueue.validateCallback(callback, callerName);
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);

    // Previously we would throw an error if we didn't have an internal
    // instance. Since we want to make it a no-op instead, we mirror the same
    // behavior we have in other enqueue* methods.
    // We also need to ignore callbacks in componentWillMount. See
    // enqueueUpdates.
    if (!internalInstance) {
      return null;
    }

    if (internalInstance._pendingCallbacks) {
      internalInstance._pendingCallbacks.push(callback);
    } else {
      internalInstance._pendingCallbacks = [callback];
    }
    // TODO: The callback here is ignored when setState is called from
    // componentWillMount. Either fix it or disallow doing so completely in
    // favor of getInitialState. Alternatively, we can disallow
    // componentWillMount during server-side rendering.
    enqueueUpdate(internalInstance);
  },

  enqueueCallbackInternal: function (internalInstance, callback) {
    if (internalInstance._pendingCallbacks) {
      internalInstance._pendingCallbacks.push(callback);
    } else {
      internalInstance._pendingCallbacks = [callback];
    }
    enqueueUpdate(internalInstance);
  },

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */
  enqueueForceUpdate: function (publicInstance) {
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');

    if (!internalInstance) {
      return;
    }

    internalInstance._pendingForceUpdate = true;

    enqueueUpdate(internalInstance);
  },

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @internal
   */
  enqueueReplaceState: function (publicInstance, completeState, callback) {
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');

    if (!internalInstance) {
      return;
    }

    internalInstance._pendingStateQueue = [completeState];
    internalInstance._pendingReplaceState = true;

    // Future-proof 15.5
    if (callback !== undefined && callback !== null) {
      ReactUpdateQueue.validateCallback(callback, 'replaceState');
      if (internalInstance._pendingCallbacks) {
        internalInstance._pendingCallbacks.push(callback);
      } else {
        internalInstance._pendingCallbacks = [callback];
      }
    }

    enqueueUpdate(internalInstance);
  },

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @internal
   */
  enqueueSetState: function (publicInstance, partialState) {
    if (false) {
      ReactInstrumentation.debugTool.onSetState();
      process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : void 0;
    }

    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');

    if (!internalInstance) {
      return;
    }

    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
    queue.push(partialState);

    enqueueUpdate(internalInstance);
  },

  enqueueElementInternal: function (internalInstance, nextElement, nextContext) {
    internalInstance._pendingElement = nextElement;
    // TODO: introduce _pendingContext instead of setting it directly.
    internalInstance._context = nextContext;
    enqueueUpdate(internalInstance);
  },

  validateCallback: function (callback, callerName) {
    !(!callback || typeof callback === 'function') ?  false ? invariant(false, '%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.', callerName, formatUnexpectedArgument(callback)) : _prodInvariant('122', callerName, formatUnexpectedArgument(callback)) : void 0;
  }
};

module.exports = ReactUpdateQueue;

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(9);

var emptyFunction = __webpack_require__(19);
var warning = __webpack_require__(7);

var validateDOMNesting = emptyFunction;

if (false) {
  // This validation code was written based on the HTML5 parsing spec:
  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
  //
  // Note: this does not catch all invalid nesting, nor does it try to (as it's
  // not clear what practical benefit doing so provides); instead, we warn only
  // for cases where the parser will give a parse tree differing from what React
  // intended. For example, <b><div></div></b> is invalid but we don't warn
  // because it still parses correctly; we do warn for other cases like nested
  // <p> tags where the beginning of the second element implicitly closes the
  // first, causing a confusing mess.

  // https://html.spec.whatwg.org/multipage/syntax.html#special
  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];

  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',

  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
  // TODO: Distinguish by namespace here -- for <title>, including it here
  // errs on the side of fewer warnings
  'foreignObject', 'desc', 'title'];

  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
  var buttonScopeTags = inScopeTags.concat(['button']);

  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];

  var emptyAncestorInfo = {
    current: null,

    formTag: null,
    aTagInScope: null,
    buttonTagInScope: null,
    nobrTagInScope: null,
    pTagInButtonScope: null,

    listItemTagAutoclosing: null,
    dlItemTagAutoclosing: null
  };

  var updatedAncestorInfo = function (oldInfo, tag, instance) {
    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
    var info = { tag: tag, instance: instance };

    if (inScopeTags.indexOf(tag) !== -1) {
      ancestorInfo.aTagInScope = null;
      ancestorInfo.buttonTagInScope = null;
      ancestorInfo.nobrTagInScope = null;
    }
    if (buttonScopeTags.indexOf(tag) !== -1) {
      ancestorInfo.pTagInButtonScope = null;
    }

    // See rules for 'li', 'dd', 'dt' start tags in
    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
      ancestorInfo.listItemTagAutoclosing = null;
      ancestorInfo.dlItemTagAutoclosing = null;
    }

    ancestorInfo.current = info;

    if (tag === 'form') {
      ancestorInfo.formTag = info;
    }
    if (tag === 'a') {
      ancestorInfo.aTagInScope = info;
    }
    if (tag === 'button') {
      ancestorInfo.buttonTagInScope = info;
    }
    if (tag === 'nobr') {
      ancestorInfo.nobrTagInScope = info;
    }
    if (tag === 'p') {
      ancestorInfo.pTagInButtonScope = info;
    }
    if (tag === 'li') {
      ancestorInfo.listItemTagAutoclosing = info;
    }
    if (tag === 'dd' || tag === 'dt') {
      ancestorInfo.dlItemTagAutoclosing = info;
    }

    return ancestorInfo;
  };

  /**
   * Returns whether
   */
  var isTagValidWithParent = function (tag, parentTag) {
    // First, let's check if we're in an unusual parsing mode...
    switch (parentTag) {
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
      case 'select':
        return tag === 'option' || tag === 'optgroup' || tag === '#text';
      case 'optgroup':
        return tag === 'option' || tag === '#text';
      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
      // but
      case 'option':
        return tag === '#text';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
      // No special behavior since these rules fall back to "in body" mode for
      // all except special table nodes which cause bad parsing behavior anyway.

      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
      case 'tr':
        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
      case 'tbody':
      case 'thead':
      case 'tfoot':
        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
      case 'colgroup':
        return tag === 'col' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
      case 'table':
        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
      case 'head':
        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
      case 'html':
        return tag === 'head' || tag === 'body';
      case '#document':
        return tag === 'html';
    }

    // Probably in the "in body" parsing mode, so we outlaw only tag combos
    // where the parsing rules cause implicit opens or closes to be added.
    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
    switch (tag) {
      case 'h1':
      case 'h2':
      case 'h3':
      case 'h4':
      case 'h5':
      case 'h6':
        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';

      case 'rp':
      case 'rt':
        return impliedEndTags.indexOf(parentTag) === -1;

      case 'body':
      case 'caption':
      case 'col':
      case 'colgroup':
      case 'frame':
      case 'head':
      case 'html':
      case 'tbody':
      case 'td':
      case 'tfoot':
      case 'th':
      case 'thead':
      case 'tr':
        // These tags are only valid with a few parents that have special child
        // parsing rules -- if we're down here, then none of those matched and
        // so we allow it only if we don't know what the parent is, as all other
        // cases are invalid.
        return parentTag == null;
    }

    return true;
  };

  /**
   * Returns whether
   */
  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
    switch (tag) {
      case 'address':
      case 'article':
      case 'aside':
      case 'blockquote':
      case 'center':
      case 'details':
      case 'dialog':
      case 'dir':
      case 'div':
      case 'dl':
      case 'fieldset':
      case 'figcaption':
      case 'figure':
      case 'footer':
      case 'header':
      case 'hgroup':
      case 'main':
      case 'menu':
      case 'nav':
      case 'ol':
      case 'p':
      case 'section':
      case 'summary':
      case 'ul':
      case 'pre':
      case 'listing':
      case 'table':
      case 'hr':
      case 'xmp':
      case 'h1':
      case 'h2':
      case 'h3':
      case 'h4':
      case 'h5':
      case 'h6':
        return ancestorInfo.pTagInButtonScope;

      case 'form':
        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;

      case 'li':
        return ancestorInfo.listItemTagAutoclosing;

      case 'dd':
      case 'dt':
        return ancestorInfo.dlItemTagAutoclosing;

      case 'button':
        return ancestorInfo.buttonTagInScope;

      case 'a':
        // Spec says something about storing a list of markers, but it sounds
        // equivalent to this check.
        return ancestorInfo.aTagInScope;

      case 'nobr':
        return ancestorInfo.nobrTagInScope;
    }

    return null;
  };

  /**
   * Given a ReactCompositeComponent instance, return a list of its recursive
   * owners, starting at the root and ending with the instance itself.
   */
  var findOwnerStack = function (instance) {
    if (!instance) {
      return [];
    }

    var stack = [];
    do {
      stack.push(instance);
    } while (instance = instance._currentElement._owner);
    stack.reverse();
    return stack;
  };

  var didWarn = {};

  validateDOMNesting = function (childTag, childText, childInstance, ancestorInfo) {
    ancestorInfo = ancestorInfo || emptyAncestorInfo;
    var parentInfo = ancestorInfo.current;
    var parentTag = parentInfo && parentInfo.tag;

    if (childText != null) {
      process.env.NODE_ENV !== 'production' ? warning(childTag == null, 'validateDOMNesting: when childText is passed, childTag should be null') : void 0;
      childTag = '#text';
    }

    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
    var problematic = invalidParent || invalidAncestor;

    if (problematic) {
      var ancestorTag = problematic.tag;
      var ancestorInstance = problematic.instance;

      var childOwner = childInstance && childInstance._currentElement._owner;
      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;

      var childOwners = findOwnerStack(childOwner);
      var ancestorOwners = findOwnerStack(ancestorOwner);

      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
      var i;

      var deepestCommon = -1;
      for (i = 0; i < minStackLen; i++) {
        if (childOwners[i] === ancestorOwners[i]) {
          deepestCommon = i;
        } else {
          break;
        }
      }

      var UNKNOWN = '(unknown)';
      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
        return inst.getName() || UNKNOWN;
      });
      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
        return inst.getName() || UNKNOWN;
      });
      var ownerInfo = [].concat(
      // If the parent and child instances have a common owner ancestor, start
      // with that -- otherwise we just start with the parent's owners.
      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
      // If we're warning about an invalid (non-parent) ancestry, add '...'
      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');

      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
      if (didWarn[warnKey]) {
        return;
      }
      didWarn[warnKey] = true;

      var tagDisplayName = childTag;
      var whitespaceInfo = '';
      if (childTag === '#text') {
        if (/\S/.test(childText)) {
          tagDisplayName = 'Text nodes';
        } else {
          tagDisplayName = 'Whitespace text nodes';
          whitespaceInfo = " Make sure you don't have any extra whitespace between tags on " + 'each line of your source code.';
        }
      } else {
        tagDisplayName = '<' + childTag + '>';
      }

      if (invalidParent) {
        var info = '';
        if (ancestorTag === 'table' && childTag === 'tr') {
          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
        }
        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a child of <%s>.%s ' + 'See %s.%s', tagDisplayName, ancestorTag, whitespaceInfo, ownerInfo, info) : void 0;
      } else {
        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>. See %s.', tagDisplayName, ancestorTag, ownerInfo) : void 0;
      }
    }
  };

  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;

  // For testing
  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
    ancestorInfo = ancestorInfo || emptyAncestorInfo;
    var parentInfo = ancestorInfo.current;
    var parentTag = parentInfo && parentInfo.tag;
    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
  };
}

module.exports = validateDOMNesting;

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * `charCode` represents the actual "character code" and is safe to use with
 * `String.fromCharCode`. As such, only keys that correspond to printable
 * characters produce a valid `charCode`, the only exception to this is Enter.
 * The Tab-key is considered non-printable and does not have a `charCode`,
 * presumably because it does not produce a tab-character in browsers.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {number} Normalized `charCode` property.
 */

function getEventCharCode(nativeEvent) {
  var charCode;
  var keyCode = nativeEvent.keyCode;

  if ('charCode' in nativeEvent) {
    charCode = nativeEvent.charCode;

    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
    if (charCode === 0 && keyCode === 13) {
      charCode = 13;
    }
  } else {
    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
    charCode = keyCode;
  }

  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
  // Must not discard the (non-)printable Enter-key.
  if (charCode >= 32 || charCode === 13) {
    return charCode;
  }

  return 0;
}

module.exports = getEventCharCode;

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = warning;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */

}

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutPropertiesLoose;
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__combineReducers__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__compose__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_warning__ = __webpack_require__(136);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createStore", function() { return __WEBPACK_IMPORTED_MODULE_0__createStore__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "combineReducers", function() { return __WEBPACK_IMPORTED_MODULE_1__combineReducers__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "bindActionCreators", function() { return __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "applyMiddleware", function() { return __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "compose", function() { return __WEBPACK_IMPORTED_MODULE_4__compose__["a"]; });







/*
* This is a dummy function to check if the function name has been altered by minification.
* If the function has been minified and NODE_ENV !== 'production', warn the user.
*/
function isCrushed() {}

if (false) {
  warning('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
}



/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__ = __webpack_require__(57);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__["a" /* default */]);

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(58);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var isEmptyChildren = function isEmptyChildren(children) {
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 0;
};

/**
 * The public API for matching a single path and rendering.
 */

var Route = function (_React$Component) {
  _inherits(Route, _React$Component);

  function Route() {
    var _temp, _this, _ret;

    _classCallCheck(this, Route);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props, _this.context.router)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Route.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        route: {
          location: this.props.location || this.context.router.route.location,
          match: this.state.match
        }
      })
    };
  };

  Route.prototype.computeMatch = function computeMatch(_ref, router) {
    var computedMatch = _ref.computedMatch,
        location = _ref.location,
        path = _ref.path,
        strict = _ref.strict,
        exact = _ref.exact,
        sensitive = _ref.sensitive;

    if (computedMatch) return computedMatch; // <Switch> already computed the match for us

    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(router, "You should not use <Route> or withRouter() outside a <Router>");

    var route = router.route;

    var pathname = (location || route.location).pathname;

    return Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(pathname, { path: path, strict: strict, exact: exact, sensitive: sensitive }, route.match);
  };

  Route.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.render), "You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored");

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored");

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.render && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored");
  };

  Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');

    this.setState({
      match: this.computeMatch(nextProps, nextContext.router)
    });
  };

  Route.prototype.render = function render() {
    var match = this.state.match;
    var _props = this.props,
        children = _props.children,
        component = _props.component,
        render = _props.render;
    var _context$router = this.context.router,
        history = _context$router.history,
        route = _context$router.route,
        staticContext = _context$router.staticContext;

    var location = this.props.location || route.location;
    var props = { match: match, location: location, history: history, staticContext: staticContext };

    if (component) return match ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(component, props) : null;

    if (render) return match ? render(props) : null;

    if (typeof children === "function") return children(props);

    if (children && !isEmptyChildren(children)) return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children);

    return null;
  };

  return Route;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Route.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object, // private, from <Switch>
  path: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  exact: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  sensitive: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  component: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  render: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node]),
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Route.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    route: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
  })
};
Route.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Route);

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compileGenerator = function compileGenerator(pattern) {
  var cacheKey = pattern;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var compiledGenerator = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default.a.compile(pattern);

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledGenerator;
    cacheCount++;
  }

  return compiledGenerator;
};

/**
 * Public API for generating a URL pathname from a pattern and parameters.
 */
var generatePath = function generatePath() {
  var pattern = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/";
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (pattern === "/") {
    return pattern;
  }
  var generator = compileGenerator(pattern);
  return generator(params, { pretty: true });
};

/* harmony default export */ __webpack_exports__["a"] = (generatePath);

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var undefined;

var $SyntaxError = SyntaxError;
var $Function = Function;
var $TypeError = TypeError;

// eslint-disable-next-line consistent-return
var getEvalledConstructor = function (expressionSyntax) {
	try {
		return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
	} catch (e) {}
};

var $gOPD = Object.getOwnPropertyDescriptor;
if ($gOPD) {
	try {
		$gOPD({}, '');
	} catch (e) {
		$gOPD = null; // this is IE 8, which has a broken gOPD
	}
}

var throwTypeError = function () {
	throw new $TypeError();
};
var ThrowTypeError = $gOPD
	? (function () {
		try {
			// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
			arguments.callee; // IE 8 does not throw here
			return throwTypeError;
		} catch (calleeThrows) {
			try {
				// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
				return $gOPD(arguments, 'callee').get;
			} catch (gOPDthrows) {
				return throwTypeError;
			}
		}
	}())
	: throwTypeError;

var hasSymbols = __webpack_require__(316)();

var getProto = Object.getPrototypeOf || function (x) { return x.__proto__; }; // eslint-disable-line no-proto

var needsEval = {};

var TypedArray = typeof Uint8Array === 'undefined' ? undefined : getProto(Uint8Array);

var INTRINSICS = {
	'%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
	'%Array%': Array,
	'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
	'%ArrayIteratorPrototype%': hasSymbols ? getProto([][Symbol.iterator]()) : undefined,
	'%AsyncFromSyncIteratorPrototype%': undefined,
	'%AsyncFunction%': needsEval,
	'%AsyncGenerator%': needsEval,
	'%AsyncGeneratorFunction%': needsEval,
	'%AsyncIteratorPrototype%': needsEval,
	'%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
	'%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
	'%Boolean%': Boolean,
	'%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
	'%Date%': Date,
	'%decodeURI%': decodeURI,
	'%decodeURIComponent%': decodeURIComponent,
	'%encodeURI%': encodeURI,
	'%encodeURIComponent%': encodeURIComponent,
	'%Error%': Error,
	'%eval%': eval, // eslint-disable-line no-eval
	'%EvalError%': EvalError,
	'%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
	'%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
	'%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
	'%Function%': $Function,
	'%GeneratorFunction%': needsEval,
	'%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
	'%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
	'%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
	'%isFinite%': isFinite,
	'%isNaN%': isNaN,
	'%IteratorPrototype%': hasSymbols ? getProto(getProto([][Symbol.iterator]())) : undefined,
	'%JSON%': typeof JSON === 'object' ? JSON : undefined,
	'%Map%': typeof Map === 'undefined' ? undefined : Map,
	'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols ? undefined : getProto(new Map()[Symbol.iterator]()),
	'%Math%': Math,
	'%Number%': Number,
	'%Object%': Object,
	'%parseFloat%': parseFloat,
	'%parseInt%': parseInt,
	'%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
	'%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
	'%RangeError%': RangeError,
	'%ReferenceError%': ReferenceError,
	'%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
	'%RegExp%': RegExp,
	'%Set%': typeof Set === 'undefined' ? undefined : Set,
	'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols ? undefined : getProto(new Set()[Symbol.iterator]()),
	'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
	'%String%': String,
	'%StringIteratorPrototype%': hasSymbols ? getProto(''[Symbol.iterator]()) : undefined,
	'%Symbol%': hasSymbols ? Symbol : undefined,
	'%SyntaxError%': $SyntaxError,
	'%ThrowTypeError%': ThrowTypeError,
	'%TypedArray%': TypedArray,
	'%TypeError%': $TypeError,
	'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
	'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
	'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
	'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
	'%URIError%': URIError,
	'%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
	'%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
	'%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet
};

var doEval = function doEval(name) {
	var value;
	if (name === '%AsyncFunction%') {
		value = getEvalledConstructor('async function () {}');
	} else if (name === '%GeneratorFunction%') {
		value = getEvalledConstructor('function* () {}');
	} else if (name === '%AsyncGeneratorFunction%') {
		value = getEvalledConstructor('async function* () {}');
	} else if (name === '%AsyncGenerator%') {
		var fn = doEval('%AsyncGeneratorFunction%');
		if (fn) {
			value = fn.prototype;
		}
	} else if (name === '%AsyncIteratorPrototype%') {
		var gen = doEval('%AsyncGenerator%');
		if (gen) {
			value = getProto(gen.prototype);
		}
	}

	INTRINSICS[name] = value;

	return value;
};

var LEGACY_ALIASES = {
	'%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
	'%ArrayPrototype%': ['Array', 'prototype'],
	'%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
	'%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
	'%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
	'%ArrayProto_values%': ['Array', 'prototype', 'values'],
	'%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
	'%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
	'%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
	'%BooleanPrototype%': ['Boolean', 'prototype'],
	'%DataViewPrototype%': ['DataView', 'prototype'],
	'%DatePrototype%': ['Date', 'prototype'],
	'%ErrorPrototype%': ['Error', 'prototype'],
	'%EvalErrorPrototype%': ['EvalError', 'prototype'],
	'%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
	'%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
	'%FunctionPrototype%': ['Function', 'prototype'],
	'%Generator%': ['GeneratorFunction', 'prototype'],
	'%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
	'%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
	'%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
	'%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
	'%JSONParse%': ['JSON', 'parse'],
	'%JSONStringify%': ['JSON', 'stringify'],
	'%MapPrototype%': ['Map', 'prototype'],
	'%NumberPrototype%': ['Number', 'prototype'],
	'%ObjectPrototype%': ['Object', 'prototype'],
	'%ObjProto_toString%': ['Object', 'prototype', 'toString'],
	'%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
	'%PromisePrototype%': ['Promise', 'prototype'],
	'%PromiseProto_then%': ['Promise', 'prototype', 'then'],
	'%Promise_all%': ['Promise', 'all'],
	'%Promise_reject%': ['Promise', 'reject'],
	'%Promise_resolve%': ['Promise', 'resolve'],
	'%RangeErrorPrototype%': ['RangeError', 'prototype'],
	'%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
	'%RegExpPrototype%': ['RegExp', 'prototype'],
	'%SetPrototype%': ['Set', 'prototype'],
	'%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
	'%StringPrototype%': ['String', 'prototype'],
	'%SymbolPrototype%': ['Symbol', 'prototype'],
	'%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
	'%TypedArrayPrototype%': ['TypedArray', 'prototype'],
	'%TypeErrorPrototype%': ['TypeError', 'prototype'],
	'%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
	'%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
	'%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
	'%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
	'%URIErrorPrototype%': ['URIError', 'prototype'],
	'%WeakMapPrototype%': ['WeakMap', 'prototype'],
	'%WeakSetPrototype%': ['WeakSet', 'prototype']
};

var bind = __webpack_require__(90);
var hasOwn = __webpack_require__(319);
var $concat = bind.call(Function.call, Array.prototype.concat);
var $spliceApply = bind.call(Function.apply, Array.prototype.splice);
var $replace = bind.call(Function.call, String.prototype.replace);
var $strSlice = bind.call(Function.call, String.prototype.slice);

/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
var stringToPath = function stringToPath(string) {
	var first = $strSlice(string, 0, 1);
	var last = $strSlice(string, -1);
	if (first === '%' && last !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
	} else if (last === '%' && first !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
	}
	var result = [];
	$replace(string, rePropName, function (match, number, quote, subString) {
		result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : number || match;
	});
	return result;
};
/* end adaptation */

var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
	var intrinsicName = name;
	var alias;
	if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
		alias = LEGACY_ALIASES[intrinsicName];
		intrinsicName = '%' + alias[0] + '%';
	}

	if (hasOwn(INTRINSICS, intrinsicName)) {
		var value = INTRINSICS[intrinsicName];
		if (value === needsEval) {
			value = doEval(intrinsicName);
		}
		if (typeof value === 'undefined' && !allowMissing) {
			throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
		}

		return {
			alias: alias,
			name: intrinsicName,
			value: value
		};
	}

	throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
};

module.exports = function GetIntrinsic(name, allowMissing) {
	if (typeof name !== 'string' || name.length === 0) {
		throw new $TypeError('intrinsic name must be a non-empty string');
	}
	if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
		throw new $TypeError('"allowMissing" argument must be a boolean');
	}

	var parts = stringToPath(name);
	var intrinsicBaseName = parts.length > 0 ? parts[0] : '';

	var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
	var intrinsicRealName = intrinsic.name;
	var value = intrinsic.value;
	var skipFurtherCaching = false;

	var alias = intrinsic.alias;
	if (alias) {
		intrinsicBaseName = alias[0];
		$spliceApply(parts, $concat([0, 1], alias));
	}

	for (var i = 1, isOwn = true; i < parts.length; i += 1) {
		var part = parts[i];
		var first = $strSlice(part, 0, 1);
		var last = $strSlice(part, -1);
		if (
			(
				(first === '"' || first === "'" || first === '`')
				|| (last === '"' || last === "'" || last === '`')
			)
			&& first !== last
		) {
			throw new $SyntaxError('property names with quotes must have matching quotes');
		}
		if (part === 'constructor' || !isOwn) {
			skipFurtherCaching = true;
		}

		intrinsicBaseName += '.' + part;
		intrinsicRealName = '%' + intrinsicBaseName + '%';

		if (hasOwn(INTRINSICS, intrinsicRealName)) {
			value = INTRINSICS[intrinsicRealName];
		} else if (value != null) {
			if (!(part in value)) {
				if (!allowMissing) {
					throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
				}
				return void undefined;
			}
			if ($gOPD && (i + 1) >= parts.length) {
				var desc = $gOPD(value, part);
				isOwn = !!desc;

				// By convention, when a data property is converted to an accessor
				// property to emulate a data property that does not suffer from
				// the override mistake, that accessor's getter is marked with
				// an `originalValue` property. Here, when we detect this, we
				// uphold the illusion by pretending to see that original data
				// property, i.e., returning the value rather than the getter
				// itself.
				if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
					value = desc.get;
				} else {
					value = value[part];
				}
			} else {
				isOwn = hasOwn(value, part);
				value = value[part];
			}

			if (isOwn && !skipFurtherCaching) {
				INTRINSICS[intrinsicRealName] = value;
			}
		}
	}
	return value;
};


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(318);

module.exports = Function.prototype.bind || implementation;


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var replace = String.prototype.replace;
var percentTwenties = /%20/g;

var Format = {
    RFC1738: 'RFC1738',
    RFC3986: 'RFC3986'
};

module.exports = {
    'default': Format.RFC3986,
    formatters: {
        RFC1738: function (value) {
            return replace.call(value, percentTwenties, '+');
        },
        RFC3986: function (value) {
            return String(value);
        }
    },
    RFC1738: Format.RFC1738,
    RFC3986: Format.RFC3986
};


/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = warn;
function warn(s) {
  console.warn('[react-ga]', s);
}

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MemoryRouter__ = __webpack_require__(141);
/* unused harmony reexport MemoryRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Prompt__ = __webpack_require__(144);
/* unused harmony reexport Prompt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redirect__ = __webpack_require__(145);
/* unused harmony reexport Redirect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__(87);
/* unused harmony reexport Route */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(57);
/* unused harmony reexport Router */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__StaticRouter__ = __webpack_require__(146);
/* unused harmony reexport StaticRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Switch__ = __webpack_require__(147);
/* unused harmony reexport Switch */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__generatePath__ = __webpack_require__(88);
/* unused harmony reexport generatePath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__matchPath__ = __webpack_require__(58);
/* unused harmony reexport matchPath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__withRouter__ = __webpack_require__(148);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_9__withRouter__["a"]; });





















/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * EvEmitter v1.1.0
 * Lil' event emitter
 * MIT License
 */

/* jshint unused: true, undef: true, strict: true */

( function( global, factory ) {
  // universal module definition
  /* jshint strict: false */ /* globals define, module, window */
  if ( true ) {
    // AMD - RequireJS
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS - Browserify, Webpack
    module.exports = factory();
  } else {
    // Browser globals
    global.EvEmitter = factory();
  }

}( typeof window != 'undefined' ? window : this, function() {

"use strict";

function EvEmitter() {}

var proto = EvEmitter.prototype;

proto.on = function( eventName, listener ) {
  if ( !eventName || !listener ) {
    return;
  }
  // set events hash
  var events = this._events = this._events || {};
  // set listeners array
  var listeners = events[ eventName ] = events[ eventName ] || [];
  // only add once
  if ( listeners.indexOf( listener ) == -1 ) {
    listeners.push( listener );
  }

  return this;
};

proto.once = function( eventName, listener ) {
  if ( !eventName || !listener ) {
    return;
  }
  // add event
  this.on( eventName, listener );
  // set once flag
  // set onceEvents hash
  var onceEvents = this._onceEvents = this._onceEvents || {};
  // set onceListeners object
  var onceListeners = onceEvents[ eventName ] = onceEvents[ eventName ] || {};
  // set flag
  onceListeners[ listener ] = true;

  return this;
};

proto.off = function( eventName, listener ) {
  var listeners = this._events && this._events[ eventName ];
  if ( !listeners || !listeners.length ) {
    return;
  }
  var index = listeners.indexOf( listener );
  if ( index != -1 ) {
    listeners.splice( index, 1 );
  }

  return this;
};

proto.emitEvent = function( eventName, args ) {
  var listeners = this._events && this._events[ eventName ];
  if ( !listeners || !listeners.length ) {
    return;
  }
  // copy over to avoid interference if .off() in listener
  listeners = listeners.slice(0);
  args = args || [];
  // once stuff
  var onceListeners = this._onceEvents && this._onceEvents[ eventName ];

  for ( var i=0; i < listeners.length; i++ ) {
    var listener = listeners[i]
    var isOnce = onceListeners && onceListeners[ listener ];
    if ( isOnce ) {
      // remove listener
      // remove before trigger to prevent recursion
      this.off( eventName, listener );
      // unset once flag
      delete onceListeners[ listener ];
    }
    // trigger listener
    listener.apply( this, args );
  }

  return this;
};

proto.allOff = function() {
  delete this._events;
  delete this._onceEvents;
};

return EvEmitter;

}));


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Unipointer v2.3.0
 * base class for doing one thing with pointer event
 * MIT license
 */

/*jshint browser: true, undef: true, unused: true, strict: true */

( function( window, factory ) {
  // universal module definition
  /* jshint strict: false */ /*global define, module, require */
  if ( true ) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
      __webpack_require__(94)
    ], __WEBPACK_AMD_DEFINE_RESULT__ = function( EvEmitter ) {
      return factory( window, EvEmitter );
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
      window,
      require('ev-emitter')
    );
  } else {
    // browser global
    window.Unipointer = factory(
      window,
      window.EvEmitter
    );
  }

}( window, function factory( window, EvEmitter ) {

'use strict';

function noop() {}

function Unipointer() {}

// inherit EvEmitter
var proto = Unipointer.prototype = Object.create( EvEmitter.prototype );

proto.bindStartEvent = function( elem ) {
  this._bindStartEvent( elem, true );
};

proto.unbindStartEvent = function( elem ) {
  this._bindStartEvent( elem, false );
};

/**
 * Add or remove start event
 * @param {Boolean} isAdd - remove if falsey
 */
proto._bindStartEvent = function( elem, isAdd ) {
  // munge isAdd, default to true
  isAdd = isAdd === undefined ? true : isAdd;
  var bindMethod = isAdd ? 'addEventListener' : 'removeEventListener';

  // default to mouse events
  var startEvent = 'mousedown';
  if ( window.PointerEvent ) {
    // Pointer Events
    startEvent = 'pointerdown';
  } else if ( 'ontouchstart' in window ) {
    // Touch Events. iOS Safari
    startEvent = 'touchstart';
  }
  elem[ bindMethod ]( startEvent, this );
};

// trigger handler methods for events
proto.handleEvent = function( event ) {
  var method = 'on' + event.type;
  if ( this[ method ] ) {
    this[ method ]( event );
  }
};

// returns the touch that we're keeping track of
proto.getTouch = function( touches ) {
  for ( var i=0; i < touches.length; i++ ) {
    var touch = touches[i];
    if ( touch.identifier == this.pointerIdentifier ) {
      return touch;
    }
  }
};

// ----- start event ----- //

proto.onmousedown = function( event ) {
  // dismiss clicks from right or middle buttons
  var button = event.button;
  if ( button && ( button !== 0 && button !== 1 ) ) {
    return;
  }
  this._pointerDown( event, event );
};

proto.ontouchstart = function( event ) {
  this._pointerDown( event, event.changedTouches[0] );
};

proto.onpointerdown = function( event ) {
  this._pointerDown( event, event );
};

/**
 * pointer start
 * @param {Event} event
 * @param {Event or Touch} pointer
 */
proto._pointerDown = function( event, pointer ) {
  // dismiss right click and other pointers
  // button = 0 is okay, 1-4 not
  if ( event.button || this.isPointerDown ) {
    return;
  }

  this.isPointerDown = true;
  // save pointer identifier to match up touch events
  this.pointerIdentifier = pointer.pointerId !== undefined ?
    // pointerId for pointer events, touch.indentifier for touch events
    pointer.pointerId : pointer.identifier;

  this.pointerDown( event, pointer );
};

proto.pointerDown = function( event, pointer ) {
  this._bindPostStartEvents( event );
  this.emitEvent( 'pointerDown', [ event, pointer ] );
};

// hash of events to be bound after start event
var postStartEvents = {
  mousedown: [ 'mousemove', 'mouseup' ],
  touchstart: [ 'touchmove', 'touchend', 'touchcancel' ],
  pointerdown: [ 'pointermove', 'pointerup', 'pointercancel' ],
};

proto._bindPostStartEvents = function( event ) {
  if ( !event ) {
    return;
  }
  // get proper events to match start event
  var events = postStartEvents[ event.type ];
  // bind events to node
  events.forEach( function( eventName ) {
    window.addEventListener( eventName, this );
  }, this );
  // save these arguments
  this._boundPointerEvents = events;
};

proto._unbindPostStartEvents = function() {
  // check for _boundEvents, in case dragEnd triggered twice (old IE8 bug)
  if ( !this._boundPointerEvents ) {
    return;
  }
  this._boundPointerEvents.forEach( function( eventName ) {
    window.removeEventListener( eventName, this );
  }, this );

  delete this._boundPointerEvents;
};

// ----- move event ----- //

proto.onmousemove = function( event ) {
  this._pointerMove( event, event );
};

proto.onpointermove = function( event ) {
  if ( event.pointerId == this.pointerIdentifier ) {
    this._pointerMove( event, event );
  }
};

proto.ontouchmove = function( event ) {
  var touch = this.getTouch( event.changedTouches );
  if ( touch ) {
    this._pointerMove( event, touch );
  }
};

/**
 * pointer move
 * @param {Event} event
 * @param {Event or Touch} pointer
 * @private
 */
proto._pointerMove = function( event, pointer ) {
  this.pointerMove( event, pointer );
};

// public
proto.pointerMove = function( event, pointer ) {
  this.emitEvent( 'pointerMove', [ event, pointer ] );
};

// ----- end event ----- //


proto.onmouseup = function( event ) {
  this._pointerUp( event, event );
};

proto.onpointerup = function( event ) {
  if ( event.pointerId == this.pointerIdentifier ) {
    this._pointerUp( event, event );
  }
};

proto.ontouchend = function( event ) {
  var touch = this.getTouch( event.changedTouches );
  if ( touch ) {
    this._pointerUp( event, touch );
  }
};

/**
 * pointer up
 * @param {Event} event
 * @param {Event or Touch} pointer
 * @private
 */
proto._pointerUp = function( event, pointer ) {
  this._pointerDone();
  this.pointerUp( event, pointer );
};

// public
proto.pointerUp = function( event, pointer ) {
  this.emitEvent( 'pointerUp', [ event, pointer ] );
};

// ----- pointer done ----- //

// triggered on pointer up & pointer cancel
proto._pointerDone = function() {
  this._pointerReset();
  this._unbindPostStartEvents();
  this.pointerDone();
};

proto._pointerReset = function() {
  // reset properties
  this.isPointerDown = false;
  delete this.pointerIdentifier;
};

proto.pointerDone = noop;

// ----- pointer cancel ----- //

proto.onpointercancel = function( event ) {
  if ( event.pointerId == this.pointerIdentifier ) {
    this._pointerCancel( event, event );
  }
};

proto.ontouchcancel = function( event ) {
  var touch = this.getTouch( event.changedTouches );
  if ( touch ) {
    this._pointerCancel( event, touch );
  }
};

/**
 * pointer cancel
 * @param {Event} event
 * @param {Event or Touch} pointer
 * @private
 */
proto._pointerCancel = function( event, pointer ) {
  this._pointerDone();
  this.pointerCancel( event, pointer );
};

// public
proto.pointerCancel = function( event, pointer ) {
  this.emitEvent( 'pointerCancel', [ event, pointer ] );
};

// -----  ----- //

// utility function for getting x/y coords from event
Unipointer.getPointerPoint = function( pointer ) {
  return {
    x: pointer.pageX,
    y: pointer.pageY
  };
};

// -----  ----- //

return Unipointer;

}));


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(171);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(41),
    _assign = __webpack_require__(9);

var ReactNoopUpdateQueue = __webpack_require__(98);

var canDefineProperty = __webpack_require__(99);
var emptyObject = __webpack_require__(65);
var invariant = __webpack_require__(4);
var lowPriorityWarning = __webpack_require__(176);

/**
 * Base class helpers for the updating state of a component.
 */
function ReactComponent(props, context, updater) {
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  // We initialize the default updater but the real one gets injected by the
  // renderer.
  this.updater = updater || ReactNoopUpdateQueue;
}

ReactComponent.prototype.isReactComponent = {};

/**
 * Sets a subset of the state. Always use this to mutate
 * state. You should treat `this.state` as immutable.
 *
 * There is no guarantee that `this.state` will be immediately updated, so
 * accessing `this.state` after calling this method may return the old value.
 *
 * There is no guarantee that calls to `setState` will run synchronously,
 * as they may eventually be batched together.  You can provide an optional
 * callback that will be executed when the call to setState is actually
 * completed.
 *
 * When a function is provided to setState, it will be called at some point in
 * the future (not synchronously). It will be called with the up to date
 * component arguments (state, props, context). These values can be different
 * from this.* because your function may be called after receiveProps but before
 * shouldComponentUpdate, and this new state, props, and context will not yet be
 * assigned to this.
 *
 * @param {object|function} partialState Next partial state or function to
 *        produce next partial state to be merged with current state.
 * @param {?function} callback Called after state is updated.
 * @final
 * @protected
 */
ReactComponent.prototype.setState = function (partialState, callback) {
  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
  this.updater.enqueueSetState(this, partialState);
  if (callback) {
    this.updater.enqueueCallback(this, callback, 'setState');
  }
};

/**
 * Forces an update. This should only be invoked when it is known with
 * certainty that we are **not** in a DOM transaction.
 *
 * You may want to call this when you know that some deeper aspect of the
 * component's state has changed but `setState` was not called.
 *
 * This will not invoke `shouldComponentUpdate`, but it will invoke
 * `componentWillUpdate` and `componentDidUpdate`.
 *
 * @param {?function} callback Called after update is complete.
 * @final
 * @protected
 */
ReactComponent.prototype.forceUpdate = function (callback) {
  this.updater.enqueueForceUpdate(this);
  if (callback) {
    this.updater.enqueueCallback(this, callback, 'forceUpdate');
  }
};

/**
 * Deprecated APIs. These APIs used to exist on classic React classes but since
 * we would like to deprecate them, we're not going to move them over to this
 * modern base class. Instead, we define a getter that warns if it's accessed.
 */
if (false) {
  var deprecatedAPIs = {
    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
  };
  var defineDeprecationWarning = function (methodName, info) {
    if (canDefineProperty) {
      Object.defineProperty(ReactComponent.prototype, methodName, {
        get: function () {
          lowPriorityWarning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);
          return undefined;
        }
      });
    }
  };
  for (var fnName in deprecatedAPIs) {
    if (deprecatedAPIs.hasOwnProperty(fnName)) {
      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
    }
  }
}

/**
 * Base class helpers for the updating state of a component.
 */
function ReactPureComponent(props, context, updater) {
  // Duplicated from ReactComponent.
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  // We initialize the default updater but the real one gets injected by the
  // renderer.
  this.updater = updater || ReactNoopUpdateQueue;
}

function ComponentDummy() {}
ComponentDummy.prototype = ReactComponent.prototype;
ReactPureComponent.prototype = new ComponentDummy();
ReactPureComponent.prototype.constructor = ReactPureComponent;
// Avoid an extra prototype jump for these methods.
_assign(ReactPureComponent.prototype, ReactComponent.prototype);
ReactPureComponent.prototype.isPureReactComponent = true;

module.exports = {
  Component: ReactComponent,
  PureComponent: ReactPureComponent
};

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var warning = __webpack_require__(7);

function warnNoop(publicInstance, callerName) {
  if (false) {
    var constructor = publicInstance.constructor;
    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
  }
}

/**
 * This is the abstract API for an update queue.
 */
var ReactNoopUpdateQueue = {
  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */
  isMounted: function (publicInstance) {
    return false;
  },

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @internal
   */
  enqueueCallback: function (publicInstance, callback) {},

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */
  enqueueForceUpdate: function (publicInstance) {
    warnNoop(publicInstance, 'forceUpdate');
  },

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @internal
   */
  enqueueReplaceState: function (publicInstance, completeState) {
    warnNoop(publicInstance, 'replaceState');
  },

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @internal
   */
  enqueueSetState: function (publicInstance, partialState) {
    warnNoop(publicInstance, 'setState');
  }
};

module.exports = ReactNoopUpdateQueue;

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var canDefineProperty = false;
if (false) {
  try {
    // $FlowFixMe https://github.com/facebook/flow/issues/285
    Object.defineProperty({}, 'x', { get: function () {} });
    canDefineProperty = true;
  } catch (x) {
    // IE will fail on defineProperty
  }
}

module.exports = canDefineProperty;

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



// The Symbol used to tag the ReactElement type. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.

var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;

module.exports = REACT_ELEMENT_TYPE;

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



// React 15.5 references this module, and assumes PropTypes are still callable in production.
// Therefore we re-export development-only version with all the PropTypes checks here.
// However if one is migrating to the `prop-types` npm library, they will go through the
// `index.js` entry point, and it will branch depending on the environment.
var factory = __webpack_require__(184);
module.exports = function(isValidElement) {
  // It is still allowed in 15.5.
  var throwOnDirectAccess = false;
  return factory(isValidElement, throwOnDirectAccess);
};


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactDOMComponentFlags = {
  hasCachedChildNodes: 1 << 0
};

module.exports = ReactDOMComponentFlags;

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(6);

var invariant = __webpack_require__(4);

/**
 * Accumulates items that must not be null or undefined into the first one. This
 * is used to conserve memory by avoiding array allocations, and thus sacrifices
 * API cleanness. Since `current` can be null before being passed in and not
 * null after this function, make sure to assign it back to `current`:
 *
 * `a = accumulateInto(a, b);`
 *
 * This API should be sparingly used. Try `accumulate` for something cleaner.
 *
 * @return {*|array<*>} An accumulation of items.
 */

function accumulateInto(current, next) {
  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : _prodInvariant('30') : void 0;

  if (current == null) {
    return next;
  }

  // Both are not empty. Warning: Never call x.concat(y) when you are not
  // certain that x is an Array (x could be a string with concat method).
  if (Array.isArray(current)) {
    if (Array.isArray(next)) {
      current.push.apply(current, next);
      return current;
    }
    current.push(next);
    return current;
  }

  if (Array.isArray(next)) {
    // A bit too dangerous to mutate `next`.
    return [current].concat(next);
  }

  return [current, next];
}

module.exports = accumulateInto;

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/**
 * @param {array} arr an "accumulation" of items which is either an Array or
 * a single item. Useful when paired with the `accumulate` module. This is a
 * simple utility that allows us to reason about a collection of items, but
 * handling the case when there is exactly one item (and we do not need to
 * allocate an array).
 */

function forEachAccumulated(arr, cb, scope) {
  if (Array.isArray(arr)) {
    arr.forEach(cb, scope);
  } else if (arr) {
    cb.call(scope, arr);
  }
}

module.exports = forEachAccumulated;

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ExecutionEnvironment = __webpack_require__(16);

var contentKey = null;

/**
 * Gets the key used to access text content on a DOM node.
 *
 * @return {?string} Key used to access text content.
 * @internal
 */
function getTextContentAccessor() {
  if (!contentKey && ExecutionEnvironment.canUseDOM) {
    // Prefer textContent to innerText because many browsers support both but
    // SVG <text> elements don't support innerText even when <div> does.
    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
  }
  return contentKey;
}

module.exports = getTextContentAccessor;

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(6);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PooledClass = __webpack_require__(27);

var invariant = __webpack_require__(4);

/**
 * A specialized pseudo-event module to help keep track of components waiting to
 * be notified when their DOM representations are available for use.
 *
 * This implements `PooledClass`, so you should never need to instantiate this.
 * Instead, use `CallbackQueue.getPooled()`.
 *
 * @class ReactMountReady
 * @implements PooledClass
 * @internal
 */

var CallbackQueue = function () {
  function CallbackQueue(arg) {
    _classCallCheck(this, CallbackQueue);

    this._callbacks = null;
    this._contexts = null;
    this._arg = arg;
  }

  /**
   * Enqueues a callback to be invoked when `notifyAll` is invoked.
   *
   * @param {function} callback Invoked when `notifyAll` is invoked.
   * @param {?object} context Context to call `callback` with.
   * @internal
   */


  CallbackQueue.prototype.enqueue = function enqueue(callback, context) {
    this._callbacks = this._callbacks || [];
    this._callbacks.push(callback);
    this._contexts = this._contexts || [];
    this._contexts.push(context);
  };

  /**
   * Invokes all enqueued callbacks and clears the queue. This is invoked after
   * the DOM representation of a component has been created or updated.
   *
   * @internal
   */


  CallbackQueue.prototype.notifyAll = function notifyAll() {
    var callbacks = this._callbacks;
    var contexts = this._contexts;
    var arg = this._arg;
    if (callbacks && contexts) {
      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : _prodInvariant('24') : void 0;
      this._callbacks = null;
      this._contexts = null;
      for (var i = 0; i < callbacks.length; i++) {
        callbacks[i].call(contexts[i], arg);
      }
      callbacks.length = 0;
      contexts.length = 0;
    }
  };

  CallbackQueue.prototype.checkpoint = function checkpoint() {
    return this._callbacks ? this._callbacks.length : 0;
  };

  CallbackQueue.prototype.rollback = function rollback(len) {
    if (this._callbacks && this._contexts) {
      this._callbacks.length = len;
      this._contexts.length = len;
    }
  };

  /**
   * Resets the internal queue.
   *
   * @internal
   */


  CallbackQueue.prototype.reset = function reset() {
    this._callbacks = null;
    this._contexts = null;
  };

  /**
   * `PooledClass` looks for this.
   */


  CallbackQueue.prototype.destructor = function destructor() {
    this.reset();
  };

  return CallbackQueue;
}();

module.exports = PooledClass.addPoolingTo(CallbackQueue);

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var ReactFeatureFlags = {
  // When true, call console.time() before and .timeEnd() after each top-level
  // render (both initial renders and updates). Useful when looking at prod-mode
  // timeline profiles in Chrome, for example.
  logTopLevelRenders: false
};

module.exports = ReactFeatureFlags;

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactDOMComponentTree = __webpack_require__(13);

function isCheckable(elem) {
  var type = elem.type;
  var nodeName = elem.nodeName;
  return nodeName && nodeName.toLowerCase() === 'input' && (type === 'checkbox' || type === 'radio');
}

function getTracker(inst) {
  return inst._wrapperState.valueTracker;
}

function attachTracker(inst, tracker) {
  inst._wrapperState.valueTracker = tracker;
}

function detachTracker(inst) {
  inst._wrapperState.valueTracker = null;
}

function getValueFromNode(node) {
  var value;
  if (node) {
    value = isCheckable(node) ? '' + node.checked : node.value;
  }
  return value;
}

var inputValueTracking = {
  // exposed for testing
  _getTrackerFromNode: function (node) {
    return getTracker(ReactDOMComponentTree.getInstanceFromNode(node));
  },


  track: function (inst) {
    if (getTracker(inst)) {
      return;
    }

    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var valueField = isCheckable(node) ? 'checked' : 'value';
    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);

    var currentValue = '' + node[valueField];

    // if someone has already defined a value or Safari, then bail
    // and don't track value will cause over reporting of changes,
    // but it's better then a hard failure
    // (needed for certain tests that spyOn input values and Safari)
    if (node.hasOwnProperty(valueField) || typeof descriptor.get !== 'function' || typeof descriptor.set !== 'function') {
      return;
    }

    Object.defineProperty(node, valueField, {
      enumerable: descriptor.enumerable,
      configurable: true,
      get: function () {
        return descriptor.get.call(this);
      },
      set: function (value) {
        currentValue = '' + value;
        descriptor.set.call(this, value);
      }
    });

    attachTracker(inst, {
      getValue: function () {
        return currentValue;
      },
      setValue: function (value) {
        currentValue = '' + value;
      },
      stopTracking: function () {
        detachTracker(inst);
        delete node[valueField];
      }
    });
  },

  updateValueIfChanged: function (inst) {
    if (!inst) {
      return false;
    }
    var tracker = getTracker(inst);

    if (!tracker) {
      inputValueTracking.track(inst);
      return true;
    }

    var lastValue = tracker.getValue();
    var nextValue = getValueFromNode(ReactDOMComponentTree.getNodeFromInstance(inst));

    if (nextValue !== lastValue) {
      tracker.setValue(nextValue);
      return true;
    }

    return false;
  },
  stopTracking: function (inst) {
    var tracker = getTracker(inst);
    if (tracker) {
      tracker.stopTracking();
    }
  }
};

module.exports = inputValueTracking;

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/**
 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
 */

var supportedInputTypes = {
  color: true,
  date: true,
  datetime: true,
  'datetime-local': true,
  email: true,
  month: true,
  number: true,
  password: true,
  range: true,
  search: true,
  tel: true,
  text: true,
  time: true,
  url: true,
  week: true
};

function isTextInputElement(elem) {
  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();

  if (nodeName === 'input') {
    return !!supportedInputTypes[elem.type];
  }

  if (nodeName === 'textarea') {
    return true;
  }

  return false;
}

module.exports = isTextInputElement;

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ViewportMetrics = {
  currentScrollLeft: 0,

  currentScrollTop: 0,

  refreshScrollValues: function (scrollPosition) {
    ViewportMetrics.currentScrollLeft = scrollPosition.x;
    ViewportMetrics.currentScrollTop = scrollPosition.y;
  }
};

module.exports = ViewportMetrics;

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ExecutionEnvironment = __webpack_require__(16);
var escapeTextContentForBrowser = __webpack_require__(53);
var setInnerHTML = __webpack_require__(52);

/**
 * Set the textContent property of a node, ensuring that whitespace is preserved
 * even in IE8. innerText is a poor substitute for textContent and, among many
 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
 * as it should.
 *
 * @param {DOMElement} node
 * @param {string} text
 * @internal
 */
var setTextContent = function (node, text) {
  if (text) {
    var firstChild = node.firstChild;

    if (firstChild && firstChild === node.lastChild && firstChild.nodeType === 3) {
      firstChild.nodeValue = text;
      return;
    }
  }
  node.textContent = text;
};

if (ExecutionEnvironment.canUseDOM) {
  if (!('textContent' in document.documentElement)) {
    setTextContent = function (node, text) {
      if (node.nodeType === 3) {
        node.nodeValue = text;
        return;
      }
      setInnerHTML(node, escapeTextContentForBrowser(text));
    };
  }
}

module.exports = setTextContent;

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * @param {DOMElement} node input/textarea to focus
 */

function focusNode(node) {
  // IE8 can throw "Can't move focus to the control because it is invisible,
  // not enabled, or of a type that does not accept the focus." for all kinds of
  // reasons that are too expensive and fragile to test.
  try {
    node.focus();
  } catch (e) {}
}

module.exports = focusNode;

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * CSS properties which accept numbers but are not in units of "px".
 */

var isUnitlessNumber = {
  animationIterationCount: true,
  borderImageOutset: true,
  borderImageSlice: true,
  borderImageWidth: true,
  boxFlex: true,
  boxFlexGroup: true,
  boxOrdinalGroup: true,
  columnCount: true,
  columns: true,
  flex: true,
  flexGrow: true,
  flexPositive: true,
  flexShrink: true,
  flexNegative: true,
  flexOrder: true,
  gridRow: true,
  gridRowEnd: true,
  gridRowSpan: true,
  gridRowStart: true,
  gridColumn: true,
  gridColumnEnd: true,
  gridColumnSpan: true,
  gridColumnStart: true,
  fontWeight: true,
  lineClamp: true,
  lineHeight: true,
  opacity: true,
  order: true,
  orphans: true,
  tabSize: true,
  widows: true,
  zIndex: true,
  zoom: true,

  // SVG-related properties
  fillOpacity: true,
  floodOpacity: true,
  stopOpacity: true,
  strokeDasharray: true,
  strokeDashoffset: true,
  strokeMiterlimit: true,
  strokeOpacity: true,
  strokeWidth: true
};

/**
 * @param {string} prefix vendor-specific prefix, eg: Webkit
 * @param {string} key style name, eg: transitionDuration
 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
 * WebkitTransitionDuration
 */
function prefixKey(prefix, key) {
  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
}

/**
 * Support style names that may come passed in prefixed by adding permutations
 * of vendor prefixes.
 */
var prefixes = ['Webkit', 'ms', 'Moz', 'O'];

// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
// infinite loop, because it iterates over the newly added props too.
Object.keys(isUnitlessNumber).forEach(function (prop) {
  prefixes.forEach(function (prefix) {
    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
  });
});

/**
 * Most style properties can be unset by doing .style[prop] = '' but IE8
 * doesn't like doing that with shorthand properties so for the properties that
 * IE8 breaks on, which are listed here, we instead unset each of the
 * individual properties. See http://bugs.jquery.com/ticket/12385.
 * The 4-value 'clock' properties like margin, padding, border-width seem to
 * behave without any problems. Curiously, list-style works too without any
 * special prodding.
 */
var shorthandPropertyExpansions = {
  background: {
    backgroundAttachment: true,
    backgroundColor: true,
    backgroundImage: true,
    backgroundPositionX: true,
    backgroundPositionY: true,
    backgroundRepeat: true
  },
  backgroundPosition: {
    backgroundPositionX: true,
    backgroundPositionY: true
  },
  border: {
    borderWidth: true,
    borderStyle: true,
    borderColor: true
  },
  borderBottom: {
    borderBottomWidth: true,
    borderBottomStyle: true,
    borderBottomColor: true
  },
  borderLeft: {
    borderLeftWidth: true,
    borderLeftStyle: true,
    borderLeftColor: true
  },
  borderRight: {
    borderRightWidth: true,
    borderRightStyle: true,
    borderRightColor: true
  },
  borderTop: {
    borderTopWidth: true,
    borderTopStyle: true,
    borderTopColor: true
  },
  font: {
    fontStyle: true,
    fontVariant: true,
    fontWeight: true,
    fontSize: true,
    lineHeight: true,
    fontFamily: true
  },
  outline: {
    outlineWidth: true,
    outlineStyle: true,
    outlineColor: true
  }
};

var CSSProperty = {
  isUnitlessNumber: isUnitlessNumber,
  shorthandPropertyExpansions: shorthandPropertyExpansions
};

module.exports = CSSProperty;

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var DOMProperty = __webpack_require__(31);
var ReactDOMComponentTree = __webpack_require__(13);
var ReactInstrumentation = __webpack_require__(18);

var quoteAttributeValueForBrowser = __webpack_require__(219);
var warning = __webpack_require__(7);

var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + DOMProperty.ATTRIBUTE_NAME_START_CHAR + '][' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
var illegalAttributeNameCache = {};
var validatedAttributeNameCache = {};

function isAttributeNameSafe(attributeName) {
  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
    return true;
  }
  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
    return false;
  }
  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
    validatedAttributeNameCache[attributeName] = true;
    return true;
  }
  illegalAttributeNameCache[attributeName] = true;
   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : void 0;
  return false;
}

function shouldIgnoreValue(propertyInfo, value) {
  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
}

/**
 * Operations for dealing with DOM properties.
 */
var DOMPropertyOperations = {
  /**
   * Creates markup for the ID property.
   *
   * @param {string} id Unescaped ID.
   * @return {string} Markup string.
   */
  createMarkupForID: function (id) {
    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
  },

  setAttributeForID: function (node, id) {
    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
  },

  createMarkupForRoot: function () {
    return DOMProperty.ROOT_ATTRIBUTE_NAME + '=""';
  },

  setAttributeForRoot: function (node) {
    node.setAttribute(DOMProperty.ROOT_ATTRIBUTE_NAME, '');
  },

  /**
   * Creates markup for a property.
   *
   * @param {string} name
   * @param {*} value
   * @return {?string} Markup string, or null if the property was invalid.
   */
  createMarkupForProperty: function (name, value) {
    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
    if (propertyInfo) {
      if (shouldIgnoreValue(propertyInfo, value)) {
        return '';
      }
      var attributeName = propertyInfo.attributeName;
      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
        return attributeName + '=""';
      }
      return attributeName + '=' + quoteAttributeValueForBrowser(value);
    } else if (DOMProperty.isCustomAttribute(name)) {
      if (value == null) {
        return '';
      }
      return name + '=' + quoteAttributeValueForBrowser(value);
    }
    return null;
  },

  /**
   * Creates markup for a custom property.
   *
   * @param {string} name
   * @param {*} value
   * @return {string} Markup string, or empty string if the property was invalid.
   */
  createMarkupForCustomAttribute: function (name, value) {
    if (!isAttributeNameSafe(name) || value == null) {
      return '';
    }
    return name + '=' + quoteAttributeValueForBrowser(value);
  },

  /**
   * Sets the value for a property on a node.
   *
   * @param {DOMElement} node
   * @param {string} name
   * @param {*} value
   */
  setValueForProperty: function (node, name, value) {
    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
    if (propertyInfo) {
      var mutationMethod = propertyInfo.mutationMethod;
      if (mutationMethod) {
        mutationMethod(node, value);
      } else if (shouldIgnoreValue(propertyInfo, value)) {
        this.deleteValueForProperty(node, name);
        return;
      } else if (propertyInfo.mustUseProperty) {
        // Contrary to `setAttribute`, object properties are properly
        // `toString`ed by IE8/9.
        node[propertyInfo.propertyName] = value;
      } else {
        var attributeName = propertyInfo.attributeName;
        var namespace = propertyInfo.attributeNamespace;
        // `setAttribute` with objects becomes only `[object]` in IE8/9,
        // ('' + value) makes it output the correct toString()-value.
        if (namespace) {
          node.setAttributeNS(namespace, attributeName, '' + value);
        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
          node.setAttribute(attributeName, '');
        } else {
          node.setAttribute(attributeName, '' + value);
        }
      }
    } else if (DOMProperty.isCustomAttribute(name)) {
      DOMPropertyOperations.setValueForAttribute(node, name, value);
      return;
    }

    if (false) {
      var payload = {};
      payload[name] = value;
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'update attribute',
        payload: payload
      });
    }
  },

  setValueForAttribute: function (node, name, value) {
    if (!isAttributeNameSafe(name)) {
      return;
    }
    if (value == null) {
      node.removeAttribute(name);
    } else {
      node.setAttribute(name, '' + value);
    }

    if (false) {
      var payload = {};
      payload[name] = value;
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'update attribute',
        payload: payload
      });
    }
  },

  /**
   * Deletes an attributes from a node.
   *
   * @param {DOMElement} node
   * @param {string} name
   */
  deleteValueForAttribute: function (node, name) {
    node.removeAttribute(name);
    if (false) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'remove attribute',
        payload: name
      });
    }
  },

  /**
   * Deletes the value for a property on a node.
   *
   * @param {DOMElement} node
   * @param {string} name
   */
  deleteValueForProperty: function (node, name) {
    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
    if (propertyInfo) {
      var mutationMethod = propertyInfo.mutationMethod;
      if (mutationMethod) {
        mutationMethod(node, undefined);
      } else if (propertyInfo.mustUseProperty) {
        var propName = propertyInfo.propertyName;
        if (propertyInfo.hasBooleanValue) {
          node[propName] = false;
        } else {
          node[propName] = '';
        }
      } else {
        node.removeAttribute(propertyInfo.attributeName);
      }
    } else if (DOMProperty.isCustomAttribute(name)) {
      node.removeAttribute(name);
    }

    if (false) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'remove attribute',
        payload: name
      });
    }
  }
};

module.exports = DOMPropertyOperations;

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(9);

var LinkedValueUtils = __webpack_require__(76);
var ReactDOMComponentTree = __webpack_require__(13);
var ReactUpdates = __webpack_require__(20);

var warning = __webpack_require__(7);

var didWarnValueLink = false;
var didWarnValueDefaultValue = false;

function updateOptionsIfPendingUpdateAndMounted() {
  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
    this._wrapperState.pendingUpdate = false;

    var props = this._currentElement.props;
    var value = LinkedValueUtils.getValue(props);

    if (value != null) {
      updateOptions(this, Boolean(props.multiple), value);
    }
  }
}

function getDeclarationErrorAddendum(owner) {
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

var valuePropNames = ['value', 'defaultValue'];

/**
 * Validation function for `value` and `defaultValue`.
 * @private
 */
function checkSelectPropTypes(inst, props) {
  var owner = inst._currentElement._owner;
  LinkedValueUtils.checkPropTypes('select', props, owner);

  if (props.valueLink !== undefined && !didWarnValueLink) {
     false ? warning(false, '`valueLink` prop on `select` is deprecated; set `value` and `onChange` instead.') : void 0;
    didWarnValueLink = true;
  }

  for (var i = 0; i < valuePropNames.length; i++) {
    var propName = valuePropNames[i];
    if (props[propName] == null) {
      continue;
    }
    var isArray = Array.isArray(props[propName]);
    if (props.multiple && !isArray) {
       false ? warning(false, 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
    } else if (!props.multiple && isArray) {
       false ? warning(false, 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
    }
  }
}

/**
 * @param {ReactDOMComponent} inst
 * @param {boolean} multiple
 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
 * @private
 */
function updateOptions(inst, multiple, propValue) {
  var selectedValue, i;
  var options = ReactDOMComponentTree.getNodeFromInstance(inst).options;

  if (multiple) {
    selectedValue = {};
    for (i = 0; i < propValue.length; i++) {
      selectedValue['' + propValue[i]] = true;
    }
    for (i = 0; i < options.length; i++) {
      var selected = selectedValue.hasOwnProperty(options[i].value);
      if (options[i].selected !== selected) {
        options[i].selected = selected;
      }
    }
  } else {
    // Do not set `select.value` as exact behavior isn't consistent across all
    // browsers for all cases.
    selectedValue = '' + propValue;
    for (i = 0; i < options.length; i++) {
      if (options[i].value === selectedValue) {
        options[i].selected = true;
        return;
      }
    }
    if (options.length) {
      options[0].selected = true;
    }
  }
}

/**
 * Implements a <select> host component that allows optionally setting the
 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
 * stringable. If `multiple` is true, the prop must be an array of stringables.
 *
 * If `value` is not supplied (or null/undefined), user actions that change the
 * selected option will trigger updates to the rendered options.
 *
 * If it is supplied (and not null/undefined), the rendered options will not
 * update in response to user actions. Instead, the `value` prop must change in
 * order for the rendered options to update.
 *
 * If `defaultValue` is provided, any options with the supplied values will be
 * selected.
 */
var ReactDOMSelect = {
  getHostProps: function (inst, props) {
    return _assign({}, props, {
      onChange: inst._wrapperState.onChange,
      value: undefined
    });
  },

  mountWrapper: function (inst, props) {
    if (false) {
      checkSelectPropTypes(inst, props);
    }

    var value = LinkedValueUtils.getValue(props);
    inst._wrapperState = {
      pendingUpdate: false,
      initialValue: value != null ? value : props.defaultValue,
      listeners: null,
      onChange: _handleChange.bind(inst),
      wasMultiple: Boolean(props.multiple)
    };

    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
       false ? warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
      didWarnValueDefaultValue = true;
    }
  },

  getSelectValueContext: function (inst) {
    // ReactDOMOption looks at this initial value so the initial generated
    // markup has correct `selected` attributes
    return inst._wrapperState.initialValue;
  },

  postUpdateWrapper: function (inst) {
    var props = inst._currentElement.props;

    // After the initial mount, we control selected-ness manually so don't pass
    // this value down
    inst._wrapperState.initialValue = undefined;

    var wasMultiple = inst._wrapperState.wasMultiple;
    inst._wrapperState.wasMultiple = Boolean(props.multiple);

    var value = LinkedValueUtils.getValue(props);
    if (value != null) {
      inst._wrapperState.pendingUpdate = false;
      updateOptions(inst, Boolean(props.multiple), value);
    } else if (wasMultiple !== Boolean(props.multiple)) {
      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
      if (props.defaultValue != null) {
        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
      } else {
        // Revert the select back to its default unselected state.
        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
      }
    }
  }
};

function _handleChange(event) {
  var props = this._currentElement.props;
  var returnValue = LinkedValueUtils.executeOnChange(props, event);

  if (this._rootNodeID) {
    this._wrapperState.pendingUpdate = true;
  }
  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
  return returnValue;
}

module.exports = ReactDOMSelect;

/***/ }),
/* 117 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(6),
    _assign = __webpack_require__(9);

var ReactCompositeComponent = __webpack_require__(228);
var ReactEmptyComponent = __webpack_require__(120);
var ReactHostComponent = __webpack_require__(121);

var getNextDebugID = __webpack_require__(229);
var invariant = __webpack_require__(4);
var warning = __webpack_require__(7);

// To avoid a cyclic dependency, we create the final class in this module
var ReactCompositeComponentWrapper = function (element) {
  this.construct(element);
};

function getDeclarationErrorAddendum(owner) {
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

/**
 * Check if the type reference is a known internal type. I.e. not a user
 * provided composite type.
 *
 * @param {function} type
 * @return {boolean} Returns true if this is a valid internal type.
 */
function isInternalComponentType(type) {
  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
}

/**
 * Given a ReactNode, create an instance that will actually be mounted.
 *
 * @param {ReactNode} node
 * @param {boolean} shouldHaveDebugID
 * @return {object} A new instance of the element's constructor.
 * @protected
 */
function instantiateReactComponent(node, shouldHaveDebugID) {
  var instance;

  if (node === null || node === false) {
    instance = ReactEmptyComponent.create(instantiateReactComponent);
  } else if (typeof node === 'object') {
    var element = node;
    var type = element.type;
    if (typeof type !== 'function' && typeof type !== 'string') {
      var info = '';
      if (false) {
        if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
          info += ' You likely forgot to export your component from the file ' + "it's defined in.";
        }
      }
      info += getDeclarationErrorAddendum(element._owner);
       true ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s', type == null ? type : typeof type, info) : _prodInvariant('130', type == null ? type : typeof type, info) : void 0;
    }

    // Special case string values
    if (typeof element.type === 'string') {
      instance = ReactHostComponent.createInternalComponent(element);
    } else if (isInternalComponentType(element.type)) {
      // This is temporarily available for custom components that are not string
      // representations. I.e. ART. Once those are updated to use the string
      // representation, we can drop this code path.
      instance = new element.type(element);

      // We renamed this. Allow the old name for compat. :(
      if (!instance.getHostNode) {
        instance.getHostNode = instance.getNativeNode;
      }
    } else {
      instance = new ReactCompositeComponentWrapper(element);
    }
  } else if (typeof node === 'string' || typeof node === 'number') {
    instance = ReactHostComponent.createInstanceForText(node);
  } else {
     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : _prodInvariant('131', typeof node) : void 0;
  }

  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.getHostNode === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : void 0;
  }

  // These two fields are used by the DOM and ART diffing algorithms
  // respectively. Instead of using expandos on components, we should be
  // storing the state needed by the diffing algorithms elsewhere.
  instance._mountIndex = 0;
  instance._mountImage = null;

  if (false) {
    instance._debugID = shouldHaveDebugID ? getNextDebugID() : 0;
  }

  // Internal instances should fully constructed at this point, so they should
  // not get any new fields added to them at this point.
  if (false) {
    if (Object.preventExtensions) {
      Object.preventExtensions(instance);
    }
  }

  return instance;
}

_assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent, {
  _instantiateReactComponent: instantiateReactComponent
});

module.exports = instantiateReactComponent;

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(6);

var React = __webpack_require__(29);

var invariant = __webpack_require__(4);

var ReactNodeTypes = {
  HOST: 0,
  COMPOSITE: 1,
  EMPTY: 2,

  getType: function (node) {
    if (node === null || node === false) {
      return ReactNodeTypes.EMPTY;
    } else if (React.isValidElement(node)) {
      if (typeof node.type === 'function') {
        return ReactNodeTypes.COMPOSITE;
      } else {
        return ReactNodeTypes.HOST;
      }
    }
     true ?  false ? invariant(false, 'Unexpected node: %s', node) : _prodInvariant('26', node) : void 0;
  }
};

module.exports = ReactNodeTypes;

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyComponentFactory;

var ReactEmptyComponentInjection = {
  injectEmptyComponentFactory: function (factory) {
    emptyComponentFactory = factory;
  }
};

var ReactEmptyComponent = {
  create: function (instantiate) {
    return emptyComponentFactory(instantiate);
  }
};

ReactEmptyComponent.injection = ReactEmptyComponentInjection;

module.exports = ReactEmptyComponent;

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(6);

var invariant = __webpack_require__(4);

var genericComponentClass = null;
var textComponentClass = null;

var ReactHostComponentInjection = {
  // This accepts a class that receives the tag string. This is a catch all
  // that can render any kind of tag.
  injectGenericComponentClass: function (componentClass) {
    genericComponentClass = componentClass;
  },
  // This accepts a text component class that takes the text string to be
  // rendered as props.
  injectTextComponentClass: function (componentClass) {
    textComponentClass = componentClass;
  }
};

/**
 * Get a host internal component class for a specific tag.
 *
 * @param {ReactElement} element The element to create.
 * @return {function} The internal class constructor function.
 */
function createInternalComponent(element) {
  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : _prodInvariant('111', element.type) : void 0;
  return new genericComponentClass(element);
}

/**
 * @param {ReactText} text
 * @return {ReactComponent}
 */
function createInstanceForText(text) {
  return new textComponentClass(text);
}

/**
 * @param {ReactComponent} component
 * @return {boolean}
 */
function isTextComponent(component) {
  return component instanceof textComponentClass;
}

var ReactHostComponent = {
  createInternalComponent: createInternalComponent,
  createInstanceForText: createInstanceForText,
  isTextComponent: isTextComponent,
  injection: ReactHostComponentInjection
};

module.exports = ReactHostComponent;

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(6);

var ReactCurrentOwner = __webpack_require__(22);
var REACT_ELEMENT_TYPE = __webpack_require__(230);

var getIteratorFn = __webpack_require__(231);
var invariant = __webpack_require__(4);
var KeyEscapeUtils = __webpack_require__(79);
var warning = __webpack_require__(7);

var SEPARATOR = '.';
var SUBSEPARATOR = ':';

/**
 * This is inlined from ReactElement since this file is shared between
 * isomorphic and renderers. We could extract this to a
 *
 */

/**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */

var didWarnAboutMaps = false;

/**
 * Generate a key string that identifies a component within a set.
 *
 * @param {*} component A component that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */
function getComponentKey(component, index) {
  // Do some typechecking here since we call this blindly. We want to ensure
  // that we don't block potential future ES APIs.
  if (component && typeof component === 'object' && component.key != null) {
    // Explicit key
    return KeyEscapeUtils.escape(component.key);
  }
  // Implicit key determined by the index in the set
  return index.toString(36);
}

/**
 * @param {?*} children Children tree container.
 * @param {!string} nameSoFar Name of the key path so far.
 * @param {!function} callback Callback to invoke with each child found.
 * @param {?*} traverseContext Used to pass information throughout the traversal
 * process.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
  var type = typeof children;

  if (type === 'undefined' || type === 'boolean') {
    // All of the above are perceived as null.
    children = null;
  }

  if (children === null || type === 'string' || type === 'number' ||
  // The following is inlined from ReactElement. This means we can optimize
  // some checks. React Fiber also inlines this logic for similar purposes.
  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
    callback(traverseContext, children,
    // If it's the only child, treat the name as if it was wrapped in an array
    // so that it's consistent if the number of children grows.
    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
    return 1;
  }

  var child;
  var nextName;
  var subtreeCount = 0; // Count of children found in the current subtree.
  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;

  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      nextName = nextNamePrefix + getComponentKey(child, i);
      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
    }
  } else {
    var iteratorFn = getIteratorFn(children);
    if (iteratorFn) {
      var iterator = iteratorFn.call(children);
      var step;
      if (iteratorFn !== children.entries) {
        var ii = 0;
        while (!(step = iterator.next()).done) {
          child = step.value;
          nextName = nextNamePrefix + getComponentKey(child, ii++);
          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
        }
      } else {
        if (false) {
          var mapsAsChildrenAddendum = '';
          if (ReactCurrentOwner.current) {
            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
            if (mapsAsChildrenOwnerName) {
              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
            }
          }
          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
          didWarnAboutMaps = true;
        }
        // Iterator will provide entry [k,v] tuples rather than values.
        while (!(step = iterator.next()).done) {
          var entry = step.value;
          if (entry) {
            child = entry[1];
            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
          }
        }
      }
    } else if (type === 'object') {
      var addendum = '';
      if (false) {
        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
        if (children._isReactElement) {
          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
        }
        if (ReactCurrentOwner.current) {
          var name = ReactCurrentOwner.current.getName();
          if (name) {
            addendum += ' Check the render method of `' + name + '`.';
          }
        }
      }
      var childrenString = String(children);
       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
    }
  }

  return subtreeCount;
}

/**
 * Traverses children that are typically specified as `props.children`, but
 * might also be specified through attributes:
 *
 * - `traverseAllChildren(this.props.children, ...)`
 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
 *
 * The `traverseContext` is an optional argument that is passed through the
 * entire traversal. It can be used to store accumulations or anything else that
 * the callback might find relevant.
 *
 * @param {?*} children Children tree object.
 * @param {!function} callback To invoke upon traversing each child.
 * @param {?*} traverseContext Context for traversal.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildren(children, callback, traverseContext) {
  if (children == null) {
    return 0;
  }

  return traverseAllChildrenImpl(children, '', callback, traverseContext);
}

module.exports = traverseAllChildren;

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2016-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(41);

var ReactCurrentOwner = __webpack_require__(22);

var invariant = __webpack_require__(4);
var warning = __webpack_require__(7);

function isNative(fn) {
  // Based on isNative() from Lodash
  var funcToString = Function.prototype.toString;
  var hasOwnProperty = Object.prototype.hasOwnProperty;
  var reIsNative = RegExp('^' + funcToString
  // Take an example native function source for comparison
  .call(hasOwnProperty
  // Strip regex characters so we can use it for regex
  ).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&'
  // Remove hasOwnProperty from the template to make it generic
  ).replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
  try {
    var source = funcToString.call(fn);
    return reIsNative.test(source);
  } catch (err) {
    return false;
  }
}

var canUseCollections =
// Array.from
typeof Array.from === 'function' &&
// Map
typeof Map === 'function' && isNative(Map) &&
// Map.prototype.keys
Map.prototype != null && typeof Map.prototype.keys === 'function' && isNative(Map.prototype.keys) &&
// Set
typeof Set === 'function' && isNative(Set) &&
// Set.prototype.keys
Set.prototype != null && typeof Set.prototype.keys === 'function' && isNative(Set.prototype.keys);

var setItem;
var getItem;
var removeItem;
var getItemIDs;
var addRoot;
var removeRoot;
var getRootIDs;

if (canUseCollections) {
  var itemMap = new Map();
  var rootIDSet = new Set();

  setItem = function (id, item) {
    itemMap.set(id, item);
  };
  getItem = function (id) {
    return itemMap.get(id);
  };
  removeItem = function (id) {
    itemMap['delete'](id);
  };
  getItemIDs = function () {
    return Array.from(itemMap.keys());
  };

  addRoot = function (id) {
    rootIDSet.add(id);
  };
  removeRoot = function (id) {
    rootIDSet['delete'](id);
  };
  getRootIDs = function () {
    return Array.from(rootIDSet.keys());
  };
} else {
  var itemByKey = {};
  var rootByKey = {};

  // Use non-numeric keys to prevent V8 performance issues:
  // https://github.com/facebook/react/pull/7232
  var getKeyFromID = function (id) {
    return '.' + id;
  };
  var getIDFromKey = function (key) {
    return parseInt(key.substr(1), 10);
  };

  setItem = function (id, item) {
    var key = getKeyFromID(id);
    itemByKey[key] = item;
  };
  getItem = function (id) {
    var key = getKeyFromID(id);
    return itemByKey[key];
  };
  removeItem = function (id) {
    var key = getKeyFromID(id);
    delete itemByKey[key];
  };
  getItemIDs = function () {
    return Object.keys(itemByKey).map(getIDFromKey);
  };

  addRoot = function (id) {
    var key = getKeyFromID(id);
    rootByKey[key] = true;
  };
  removeRoot = function (id) {
    var key = getKeyFromID(id);
    delete rootByKey[key];
  };
  getRootIDs = function () {
    return Object.keys(rootByKey).map(getIDFromKey);
  };
}

var unmountedIDs = [];

function purgeDeep(id) {
  var item = getItem(id);
  if (item) {
    var childIDs = item.childIDs;

    removeItem(id);
    childIDs.forEach(purgeDeep);
  }
}

function describeComponentFrame(name, source, ownerName) {
  return '\n    in ' + (name || 'Unknown') + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
}

function getDisplayName(element) {
  if (element == null) {
    return '#empty';
  } else if (typeof element === 'string' || typeof element === 'number') {
    return '#text';
  } else if (typeof element.type === 'string') {
    return element.type;
  } else {
    return element.type.displayName || element.type.name || 'Unknown';
  }
}

function describeID(id) {
  var name = ReactComponentTreeHook.getDisplayName(id);
  var element = ReactComponentTreeHook.getElement(id);
  var ownerID = ReactComponentTreeHook.getOwnerID(id);
  var ownerName;
  if (ownerID) {
    ownerName = ReactComponentTreeHook.getDisplayName(ownerID);
  }
   false ? warning(element, 'ReactComponentTreeHook: Missing React element for debugID %s when ' + 'building stack', id) : void 0;
  return describeComponentFrame(name, element && element._source, ownerName);
}

var ReactComponentTreeHook = {
  onSetChildren: function (id, nextChildIDs) {
    var item = getItem(id);
    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
    item.childIDs = nextChildIDs;

    for (var i = 0; i < nextChildIDs.length; i++) {
      var nextChildID = nextChildIDs[i];
      var nextChild = getItem(nextChildID);
      !nextChild ?  false ? invariant(false, 'Expected hook events to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('140') : void 0;
      !(nextChild.childIDs != null || typeof nextChild.element !== 'object' || nextChild.element == null) ?  false ? invariant(false, 'Expected onSetChildren() to fire for a container child before its parent includes it in onSetChildren().') : _prodInvariant('141') : void 0;
      !nextChild.isMounted ?  false ? invariant(false, 'Expected onMountComponent() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('71') : void 0;
      if (nextChild.parentID == null) {
        nextChild.parentID = id;
        // TODO: This shouldn't be necessary but mounting a new root during in
        // componentWillMount currently causes not-yet-mounted components to
        // be purged from our tree data so their parent id is missing.
      }
      !(nextChild.parentID === id) ?  false ? invariant(false, 'Expected onBeforeMountComponent() parent and onSetChildren() to be consistent (%s has parents %s and %s).', nextChildID, nextChild.parentID, id) : _prodInvariant('142', nextChildID, nextChild.parentID, id) : void 0;
    }
  },
  onBeforeMountComponent: function (id, element, parentID) {
    var item = {
      element: element,
      parentID: parentID,
      text: null,
      childIDs: [],
      isMounted: false,
      updateCount: 0
    };
    setItem(id, item);
  },
  onBeforeUpdateComponent: function (id, element) {
    var item = getItem(id);
    if (!item || !item.isMounted) {
      // We may end up here as a result of setState() in componentWillUnmount().
      // In this case, ignore the element.
      return;
    }
    item.element = element;
  },
  onMountComponent: function (id) {
    var item = getItem(id);
    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
    item.isMounted = true;
    var isRoot = item.parentID === 0;
    if (isRoot) {
      addRoot(id);
    }
  },
  onUpdateComponent: function (id) {
    var item = getItem(id);
    if (!item || !item.isMounted) {
      // We may end up here as a result of setState() in componentWillUnmount().
      // In this case, ignore the element.
      return;
    }
    item.updateCount++;
  },
  onUnmountComponent: function (id) {
    var item = getItem(id);
    if (item) {
      // We need to check if it exists.
      // `item` might not exist if it is inside an error boundary, and a sibling
      // error boundary child threw while mounting. Then this instance never
      // got a chance to mount, but it still gets an unmounting event during
      // the error boundary cleanup.
      item.isMounted = false;
      var isRoot = item.parentID === 0;
      if (isRoot) {
        removeRoot(id);
      }
    }
    unmountedIDs.push(id);
  },
  purgeUnmountedComponents: function () {
    if (ReactComponentTreeHook._preventPurging) {
      // Should only be used for testing.
      return;
    }

    for (var i = 0; i < unmountedIDs.length; i++) {
      var id = unmountedIDs[i];
      purgeDeep(id);
    }
    unmountedIDs.length = 0;
  },
  isMounted: function (id) {
    var item = getItem(id);
    return item ? item.isMounted : false;
  },
  getCurrentStackAddendum: function (topElement) {
    var info = '';
    if (topElement) {
      var name = getDisplayName(topElement);
      var owner = topElement._owner;
      info += describeComponentFrame(name, topElement._source, owner && owner.getName());
    }

    var currentOwner = ReactCurrentOwner.current;
    var id = currentOwner && currentOwner._debugID;

    info += ReactComponentTreeHook.getStackAddendumByID(id);
    return info;
  },
  getStackAddendumByID: function (id) {
    var info = '';
    while (id) {
      info += describeID(id);
      id = ReactComponentTreeHook.getParentID(id);
    }
    return info;
  },
  getChildIDs: function (id) {
    var item = getItem(id);
    return item ? item.childIDs : [];
  },
  getDisplayName: function (id) {
    var element = ReactComponentTreeHook.getElement(id);
    if (!element) {
      return null;
    }
    return getDisplayName(element);
  },
  getElement: function (id) {
    var item = getItem(id);
    return item ? item.element : null;
  },
  getOwnerID: function (id) {
    var element = ReactComponentTreeHook.getElement(id);
    if (!element || !element._owner) {
      return null;
    }
    return element._owner._debugID;
  },
  getParentID: function (id) {
    var item = getItem(id);
    return item ? item.parentID : null;
  },
  getSource: function (id) {
    var item = getItem(id);
    var element = item ? item.element : null;
    var source = element != null ? element._source : null;
    return source;
  },
  getText: function (id) {
    var element = ReactComponentTreeHook.getElement(id);
    if (typeof element === 'string') {
      return element;
    } else if (typeof element === 'number') {
      return '' + element;
    } else {
      return null;
    }
  },
  getUpdateCount: function (id) {
    var item = getItem(id);
    return item ? item.updateCount : 0;
  },


  getRootIDs: getRootIDs,
  getRegisteredIDs: getItemIDs,

  pushNonStandardWarningStack: function (isCreatingElement, currentSource) {
    if (typeof console.reactStack !== 'function') {
      return;
    }

    var stack = [];
    var currentOwner = ReactCurrentOwner.current;
    var id = currentOwner && currentOwner._debugID;

    try {
      if (isCreatingElement) {
        stack.push({
          name: id ? ReactComponentTreeHook.getDisplayName(id) : null,
          fileName: currentSource ? currentSource.fileName : null,
          lineNumber: currentSource ? currentSource.lineNumber : null
        });
      }

      while (id) {
        var element = ReactComponentTreeHook.getElement(id);
        var parentID = ReactComponentTreeHook.getParentID(id);
        var ownerID = ReactComponentTreeHook.getOwnerID(id);
        var ownerName = ownerID ? ReactComponentTreeHook.getDisplayName(ownerID) : null;
        var source = element && element._source;
        stack.push({
          name: ownerName,
          fileName: source ? source.fileName : null,
          lineNumber: source ? source.lineNumber : null
        });
        id = parentID;
      }
    } catch (err) {
      // Internal state is messed up.
      // Stop building the stack (it's just a nice to have).
    }

    console.reactStack(stack);
  },
  popNonStandardWarningStack: function () {
    if (typeof console.reactStackEnd !== 'function') {
      return;
    }
    console.reactStackEnd();
  }
};

module.exports = ReactComponentTreeHook;

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var emptyFunction = __webpack_require__(19);

/**
 * Upstream version of event listener. Does not take into account specific
 * nature of platform.
 */
var EventListener = {
  /**
   * Listen to DOM events during the bubble phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  listen: function listen(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, false);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, false);
        }
      };
    } else if (target.attachEvent) {
      target.attachEvent('on' + eventType, callback);
      return {
        remove: function remove() {
          target.detachEvent('on' + eventType, callback);
        }
      };
    }
  },

  /**
   * Listen to DOM events during the capture phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  capture: function capture(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, true);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, true);
        }
      };
    } else {
      if (false) {
        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
      }
      return {
        remove: emptyFunction
      };
    }
  },

  registerDefault: function registerDefault() {}
};

module.exports = EventListener;

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactDOMSelection = __webpack_require__(243);

var containsNode = __webpack_require__(245);
var focusNode = __webpack_require__(113);
var getActiveElement = __webpack_require__(126);

function isInDocument(node) {
  return containsNode(document.documentElement, node);
}

/**
 * @ReactInputSelection: React input selection module. Based on Selection.js,
 * but modified to be suitable for react and has a couple of bug fixes (doesn't
 * assume buttons have range selections allowed).
 * Input selection module for React.
 */
var ReactInputSelection = {
  hasSelectionCapabilities: function (elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
  },

  getSelectionInformation: function () {
    var focusedElem = getActiveElement();
    return {
      focusedElem: focusedElem,
      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
    };
  },

  /**
   * @restoreSelection: If any selection information was potentially lost,
   * restore it. This is useful when performing operations that could remove dom
   * nodes and place them back in, resulting in focus being lost.
   */
  restoreSelection: function (priorSelectionInformation) {
    var curFocusedElem = getActiveElement();
    var priorFocusedElem = priorSelectionInformation.focusedElem;
    var priorSelectionRange = priorSelectionInformation.selectionRange;
    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
      }
      focusNode(priorFocusedElem);
    }
  },

  /**
   * @getSelection: Gets the selection bounds of a focused textarea, input or
   * contentEditable node.
   * -@input: Look up selection bounds of this input
   * -@return {start: selectionStart, end: selectionEnd}
   */
  getSelection: function (input) {
    var selection;

    if ('selectionStart' in input) {
      // Modern browser with input or textarea.
      selection = {
        start: input.selectionStart,
        end: input.selectionEnd
      };
    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
      // IE8 input.
      var range = document.selection.createRange();
      // There can only be one selection per document in IE, so it must
      // be in our element.
      if (range.parentElement() === input) {
        selection = {
          start: -range.moveStart('character', -input.value.length),
          end: -range.moveEnd('character', -input.value.length)
        };
      }
    } else {
      // Content editable or old IE textarea.
      selection = ReactDOMSelection.getOffsets(input);
    }

    return selection || { start: 0, end: 0 };
  },

  /**
   * @setSelection: Sets the selection bounds of a textarea or input and focuses
   * the input.
   * -@input     Set selection bounds of this input or textarea
   * -@offsets   Object of same form that is returned from get*
   */
  setSelection: function (input, offsets) {
    var start = offsets.start;
    var end = offsets.end;
    if (end === undefined) {
      end = start;
    }

    if ('selectionStart' in input) {
      input.selectionStart = start;
      input.selectionEnd = Math.min(end, input.value.length);
    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
      var range = input.createTextRange();
      range.collapse(true);
      range.moveStart('character', start);
      range.moveEnd('character', end - start);
      range.select();
    } else {
      ReactDOMSelection.setOffsets(input, offsets);
    }
  }
};

module.exports = ReactInputSelection;

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/* eslint-disable fb-www/typeof-undefined */

/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?DOMDocument} doc Defaults to current document.
 * @return {?DOMElement}
 */
function getActiveElement(doc) /*?DOMElement*/{
  doc = doc || (typeof document !== 'undefined' ? document : undefined);
  if (typeof doc === 'undefined') {
    return null;
  }
  try {
    return doc.activeElement || doc.body;
  } catch (e) {
    return doc.body;
  }
}

module.exports = getActiveElement;

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(6);

var DOMLazyTree = __webpack_require__(33);
var DOMProperty = __webpack_require__(31);
var React = __webpack_require__(29);
var ReactBrowserEventEmitter = __webpack_require__(54);
var ReactCurrentOwner = __webpack_require__(22);
var ReactDOMComponentTree = __webpack_require__(13);
var ReactDOMContainerInfo = __webpack_require__(260);
var ReactDOMFeatureFlags = __webpack_require__(261);
var ReactFeatureFlags = __webpack_require__(108);
var ReactInstanceMap = __webpack_require__(45);
var ReactInstrumentation = __webpack_require__(18);
var ReactMarkupChecksum = __webpack_require__(262);
var ReactReconciler = __webpack_require__(32);
var ReactUpdateQueue = __webpack_require__(80);
var ReactUpdates = __webpack_require__(20);

var emptyObject = __webpack_require__(65);
var instantiateReactComponent = __webpack_require__(118);
var invariant = __webpack_require__(4);
var setInnerHTML = __webpack_require__(52);
var shouldUpdateReactComponent = __webpack_require__(78);
var warning = __webpack_require__(7);

var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
var ROOT_ATTR_NAME = DOMProperty.ROOT_ATTRIBUTE_NAME;

var ELEMENT_NODE_TYPE = 1;
var DOC_NODE_TYPE = 9;
var DOCUMENT_FRAGMENT_NODE_TYPE = 11;

var instancesByReactRootID = {};

/**
 * Finds the index of the first character
 * that's not common between the two given strings.
 *
 * @return {number} the index of the character where the strings diverge
 */
function firstDifferenceIndex(string1, string2) {
  var minLen = Math.min(string1.length, string2.length);
  for (var i = 0; i < minLen; i++) {
    if (string1.charAt(i) !== string2.charAt(i)) {
      return i;
    }
  }
  return string1.length === string2.length ? -1 : minLen;
}

/**
 * @param {DOMElement|DOMDocument} container DOM element that may contain
 * a React component
 * @return {?*} DOM element that may have the reactRoot ID, or null.
 */
function getReactRootElementInContainer(container) {
  if (!container) {
    return null;
  }

  if (container.nodeType === DOC_NODE_TYPE) {
    return container.documentElement;
  } else {
    return container.firstChild;
  }
}

function internalGetID(node) {
  // If node is something like a window, document, or text node, none of
  // which support attributes or a .getAttribute method, gracefully return
  // the empty string, as if the attribute were missing.
  return node.getAttribute && node.getAttribute(ATTR_NAME) || '';
}

/**
 * Mounts this component and inserts it into the DOM.
 *
 * @param {ReactComponent} componentInstance The instance to mount.
 * @param {DOMElement} container DOM element to mount into.
 * @param {ReactReconcileTransaction} transaction
 * @param {boolean} shouldReuseMarkup If true, do not insert markup
 */
function mountComponentIntoNode(wrapperInstance, container, transaction, shouldReuseMarkup, context) {
  var markerName;
  if (ReactFeatureFlags.logTopLevelRenders) {
    var wrappedElement = wrapperInstance._currentElement.props.child;
    var type = wrappedElement.type;
    markerName = 'React mount: ' + (typeof type === 'string' ? type : type.displayName || type.name);
    console.time(markerName);
  }

  var markup = ReactReconciler.mountComponent(wrapperInstance, transaction, null, ReactDOMContainerInfo(wrapperInstance, container), context, 0 /* parentDebugID */
  );

  if (markerName) {
    console.timeEnd(markerName);
  }

  wrapperInstance._renderedComponent._topLevelWrapper = wrapperInstance;
  ReactMount._mountImageIntoNode(markup, container, wrapperInstance, shouldReuseMarkup, transaction);
}

/**
 * Batched mount.
 *
 * @param {ReactComponent} componentInstance The instance to mount.
 * @param {DOMElement} container DOM element to mount into.
 * @param {boolean} shouldReuseMarkup If true, do not insert markup
 */
function batchedMountComponentIntoNode(componentInstance, container, shouldReuseMarkup, context) {
  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
  /* useCreateElement */
  !shouldReuseMarkup && ReactDOMFeatureFlags.useCreateElement);
  transaction.perform(mountComponentIntoNode, null, componentInstance, container, transaction, shouldReuseMarkup, context);
  ReactUpdates.ReactReconcileTransaction.release(transaction);
}

/**
 * Unmounts a component and removes it from the DOM.
 *
 * @param {ReactComponent} instance React component instance.
 * @param {DOMElement} container DOM element to unmount from.
 * @final
 * @internal
 * @see {ReactMount.unmountComponentAtNode}
 */
function unmountComponentFromNode(instance, container, safely) {
  if (false) {
    ReactInstrumentation.debugTool.onBeginFlush();
  }
  ReactReconciler.unmountComponent(instance, safely);
  if (false) {
    ReactInstrumentation.debugTool.onEndFlush();
  }

  if (container.nodeType === DOC_NODE_TYPE) {
    container = container.documentElement;
  }

  // http://jsperf.com/emptying-a-node
  while (container.lastChild) {
    container.removeChild(container.lastChild);
  }
}

/**
 * True if the supplied DOM node has a direct React-rendered child that is
 * not a React root element. Useful for warning in `render`,
 * `unmountComponentAtNode`, etc.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM element contains a direct child that was
 * rendered by React but is not a root element.
 * @internal
 */
function hasNonRootReactChild(container) {
  var rootEl = getReactRootElementInContainer(container);
  if (rootEl) {
    var inst = ReactDOMComponentTree.getInstanceFromNode(rootEl);
    return !!(inst && inst._hostParent);
  }
}

/**
 * True if the supplied DOM node is a React DOM element and
 * it has been rendered by another copy of React.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM has been rendered by another copy of React
 * @internal
 */
function nodeIsRenderedByOtherInstance(container) {
  var rootEl = getReactRootElementInContainer(container);
  return !!(rootEl && isReactNode(rootEl) && !ReactDOMComponentTree.getInstanceFromNode(rootEl));
}

/**
 * True if the supplied DOM node is a valid node element.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM is a valid DOM node.
 * @internal
 */
function isValidContainer(node) {
  return !!(node && (node.nodeType === ELEMENT_NODE_TYPE || node.nodeType === DOC_NODE_TYPE || node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE));
}

/**
 * True if the supplied DOM node is a valid React node element.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM is a valid React DOM node.
 * @internal
 */
function isReactNode(node) {
  return isValidContainer(node) && (node.hasAttribute(ROOT_ATTR_NAME) || node.hasAttribute(ATTR_NAME));
}

function getHostRootInstanceInContainer(container) {
  var rootEl = getReactRootElementInContainer(container);
  var prevHostInstance = rootEl && ReactDOMComponentTree.getInstanceFromNode(rootEl);
  return prevHostInstance && !prevHostInstance._hostParent ? prevHostInstance : null;
}

function getTopLevelWrapperInContainer(container) {
  var root = getHostRootInstanceInContainer(container);
  return root ? root._hostContainerInfo._topLevelWrapper : null;
}

/**
 * Temporary (?) hack so that we can store all top-level pending updates on
 * composites instead of having to worry about different types of components
 * here.
 */
var topLevelRootCounter = 1;
var TopLevelWrapper = function () {
  this.rootID = topLevelRootCounter++;
};
TopLevelWrapper.prototype.isReactComponent = {};
if (false) {
  TopLevelWrapper.displayName = 'TopLevelWrapper';
}
TopLevelWrapper.prototype.render = function () {
  return this.props.child;
};
TopLevelWrapper.isReactTopLevelWrapper = true;

/**
 * Mounting is the process of initializing a React component by creating its
 * representative DOM elements and inserting them into a supplied `container`.
 * Any prior content inside `container` is destroyed in the process.
 *
 *   ReactMount.render(
 *     component,
 *     document.getElementById('container')
 *   );
 *
 *   <div id="container">                   <-- Supplied `container`.
 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
 *       // ...                                 component.
 *     </div>
 *   </div>
 *
 * Inside of `container`, the first element rendered is the "reactRoot".
 */
var ReactMount = {
  TopLevelWrapper: TopLevelWrapper,

  /**
   * Used by devtools. The keys are not important.
   */
  _instancesByReactRootID: instancesByReactRootID,

  /**
   * This is a hook provided to support rendering React components while
   * ensuring that the apparent scroll position of its `container` does not
   * change.
   *
   * @param {DOMElement} container The `container` being rendered into.
   * @param {function} renderCallback This must be called once to do the render.
   */
  scrollMonitor: function (container, renderCallback) {
    renderCallback();
  },

  /**
   * Take a component that's already mounted into the DOM and replace its props
   * @param {ReactComponent} prevComponent component instance already in the DOM
   * @param {ReactElement} nextElement component instance to render
   * @param {DOMElement} container container to render into
   * @param {?function} callback function triggered on completion
   */
  _updateRootComponent: function (prevComponent, nextElement, nextContext, container, callback) {
    ReactMount.scrollMonitor(container, function () {
      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement, nextContext);
      if (callback) {
        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
      }
    });

    return prevComponent;
  },

  /**
   * Render a new component into the DOM. Hooked by hooks!
   *
   * @param {ReactElement} nextElement element to render
   * @param {DOMElement} container container to render into
   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
   * @return {ReactComponent} nextComponent
   */
  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
    // Various parts of our code (such as ReactCompositeComponent's
    // _renderValidatedComponent) assume that calls to render aren't nested;
    // verify that that's the case.
     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;

    !isValidContainer(container) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : _prodInvariant('37') : void 0;

    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
    var componentInstance = instantiateReactComponent(nextElement, false);

    // The initial render is synchronous but any updates that happen during
    // rendering, in componentWillMount or componentDidMount, will be batched
    // according to the current batching strategy.

    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, container, shouldReuseMarkup, context);

    var wrapperID = componentInstance._instance.rootID;
    instancesByReactRootID[wrapperID] = componentInstance;

    return componentInstance;
  },

  /**
   * Renders a React component into the DOM in the supplied `container`.
   *
   * If the React component was previously rendered into `container`, this will
   * perform an update on it and only mutate the DOM as necessary to reflect the
   * latest React component.
   *
   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
   * @param {ReactElement} nextElement Component element to render.
   * @param {DOMElement} container DOM element to render into.
   * @param {?function} callback function triggered on completion
   * @return {ReactComponent} Component instance rendered in `container`.
   */
  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
    !(parentComponent != null && ReactInstanceMap.has(parentComponent)) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : _prodInvariant('38') : void 0;
    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
  },

  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
    ReactUpdateQueue.validateCallback(callback, 'ReactDOM.render');
    !React.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : // Check if it quacks like an element
    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : _prodInvariant('39', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : void 0;

     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : void 0;

    var nextWrappedElement = React.createElement(TopLevelWrapper, {
      child: nextElement
    });

    var nextContext;
    if (parentComponent) {
      var parentInst = ReactInstanceMap.get(parentComponent);
      nextContext = parentInst._processChildContext(parentInst._context);
    } else {
      nextContext = emptyObject;
    }

    var prevComponent = getTopLevelWrapperInContainer(container);

    if (prevComponent) {
      var prevWrappedElement = prevComponent._currentElement;
      var prevElement = prevWrappedElement.props.child;
      if (shouldUpdateReactComponent(prevElement, nextElement)) {
        var publicInst = prevComponent._renderedComponent.getPublicInstance();
        var updatedCallback = callback && function () {
          callback.call(publicInst);
        };
        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, nextContext, container, updatedCallback);
        return publicInst;
      } else {
        ReactMount.unmountComponentAtNode(container);
      }
    }

    var reactRootElement = getReactRootElementInContainer(container);
    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
    var containerHasNonRootReactChild = hasNonRootReactChild(container);

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : void 0;

      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
        var rootElementSibling = reactRootElement;
        while (rootElementSibling) {
          if (internalGetID(rootElementSibling)) {
            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : void 0;
            break;
          }
          rootElementSibling = rootElementSibling.nextSibling;
        }
      }
    }

    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, nextContext)._renderedComponent.getPublicInstance();
    if (callback) {
      callback.call(component);
    }
    return component;
  },

  /**
   * Renders a React component into the DOM in the supplied `container`.
   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.render
   *
   * If the React component was previously rendered into `container`, this will
   * perform an update on it and only mutate the DOM as necessary to reflect the
   * latest React component.
   *
   * @param {ReactElement} nextElement Component element to render.
   * @param {DOMElement} container DOM element to render into.
   * @param {?function} callback function triggered on completion
   * @return {ReactComponent} Component instance rendered in `container`.
   */
  render: function (nextElement, container, callback) {
    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
  },

  /**
   * Unmounts and destroys the React component rendered in the `container`.
   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.unmountcomponentatnode
   *
   * @param {DOMElement} container DOM element containing a React component.
   * @return {boolean} True if a component was found in and unmounted from
   *                   `container`
   */
  unmountComponentAtNode: function (container) {
    // Various parts of our code (such as ReactCompositeComponent's
    // _renderValidatedComponent) assume that calls to render aren't nested;
    // verify that that's the case. (Strictly speaking, unmounting won't cause a
    // render but we still don't expect to be in a render call here.)
     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;

    !isValidContainer(container) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : _prodInvariant('40') : void 0;

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(!nodeIsRenderedByOtherInstance(container), "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by another copy of React.') : void 0;
    }

    var prevComponent = getTopLevelWrapperInContainer(container);
    if (!prevComponent) {
      // Check if the node being unmounted was rendered by React, but isn't a
      // root node.
      var containerHasNonRootReactChild = hasNonRootReactChild(container);

      // Check if the container itself is a React root node.
      var isContainerReactRoot = container.nodeType === 1 && container.hasAttribute(ROOT_ATTR_NAME);

      if (false) {
        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : void 0;
      }

      return false;
    }
    delete instancesByReactRootID[prevComponent._instance.rootID];
    ReactUpdates.batchedUpdates(unmountComponentFromNode, prevComponent, container, false);
    return true;
  },

  _mountImageIntoNode: function (markup, container, instance, shouldReuseMarkup, transaction) {
    !isValidContainer(container) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : _prodInvariant('41') : void 0;

    if (shouldReuseMarkup) {
      var rootElement = getReactRootElementInContainer(container);
      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
        ReactDOMComponentTree.precacheNode(instance, rootElement);
        return;
      } else {
        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);

        var rootMarkup = rootElement.outerHTML;
        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);

        var normalizedMarkup = markup;
        if (false) {
          // because rootMarkup is retrieved from the DOM, various normalizations
          // will have occurred which will not be present in `markup`. Here,
          // insert markup into a <div> or <iframe> depending on the container
          // type to perform the same normalizations before comparing.
          var normalizer;
          if (container.nodeType === ELEMENT_NODE_TYPE) {
            normalizer = document.createElement('div');
            normalizer.innerHTML = markup;
            normalizedMarkup = normalizer.innerHTML;
          } else {
            normalizer = document.createElement('iframe');
            document.body.appendChild(normalizer);
            normalizer.contentDocument.write(markup);
            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
            document.body.removeChild(normalizer);
          }
        }

        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);

        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using server rendering but the checksum was invalid. This usually means you rendered a different component type or props on the client from the one on the server, or your render() methods are impure. React cannot handle this case due to cross-browser quirks by rendering at the document root. You should look for environment dependent code in your components and ensure the props are the same client and server side:\n%s', difference) : _prodInvariant('42', difference) : void 0;

        if (false) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : void 0;
        }
      }
    }

    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but you didn\'t use server rendering. We can\'t do this without using server rendering due to cross-browser quirks. See ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('43') : void 0;

    if (transaction.useCreateElement) {
      while (container.lastChild) {
        container.removeChild(container.lastChild);
      }
      DOMLazyTree.insertTreeBefore(container, markup, null);
    } else {
      setInnerHTML(container, markup);
      ReactDOMComponentTree.precacheNode(instance, container.firstChild);
    }

    if (false) {
      var hostNode = ReactDOMComponentTree.getInstanceFromNode(container.firstChild);
      if (hostNode._debugID !== 0) {
        ReactInstrumentation.debugTool.onHostOperation({
          instanceID: hostNode._debugID,
          type: 'mount',
          payload: markup.toString()
        });
      }
    }
  }
};

module.exports = ReactMount;

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactNodeTypes = __webpack_require__(119);

function getHostComponentFromComposite(inst) {
  var type;

  while ((type = inst._renderedNodeType) === ReactNodeTypes.COMPOSITE) {
    inst = inst._renderedComponent;
  }

  if (type === ReactNodeTypes.HOST) {
    return inst._renderedComponent;
  } else if (type === ReactNodeTypes.EMPTY) {
    return null;
  }
}

module.exports = getHostComponentFromComposite;

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _inheritsLoose;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setPrototypeOf_js__ = __webpack_require__(270);

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  Object(__WEBPACK_IMPORTED_MODULE_0__setPrototypeOf_js__["a" /* default */])(subClass, superClass);
}

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return subscriptionShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return storeShape; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);

var subscriptionShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  trySubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  tryUnsubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  notifyNestedSubs: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  isSubscribed: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});
var storeShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  subscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  dispatch: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  getState: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = connectAdvanced;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_is__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_Subscription__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__ = __webpack_require__(130);










var prefixUnsafeLifecycleMethods = typeof __WEBPACK_IMPORTED_MODULE_6_react___default.a.forwardRef !== "undefined";
var hotReloadingVersion = 0;
var dummyState = {};

function noop() {}

function makeSelectorStateful(sourceSelector, store) {
  // wrap the selector in an object that tracks its results between runs.
  var selector = {
    run: function runComponentSelector(props) {
      try {
        var nextProps = sourceSelector(store.getState(), props);

        if (nextProps !== selector.props || selector.error) {
          selector.shouldComponentUpdate = true;
          selector.props = nextProps;
          selector.error = null;
        }
      } catch (error) {
        selector.shouldComponentUpdate = true;
        selector.error = error;
      }
    }
  };
  return selector;
}

function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
     export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory, // options object:
_ref) {
  var _contextTypes, _childContextTypes;

  if (_ref === void 0) {
    _ref = {};
  }

  var _ref2 = _ref,
      _ref2$getDisplayName = _ref2.getDisplayName,
      getDisplayName = _ref2$getDisplayName === void 0 ? function (name) {
    return "ConnectAdvanced(" + name + ")";
  } : _ref2$getDisplayName,
      _ref2$methodName = _ref2.methodName,
      methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName,
      _ref2$renderCountProp = _ref2.renderCountProp,
      renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp,
      _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta,
      _ref2$storeKey = _ref2.storeKey,
      storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey,
      _ref2$withRef = _ref2.withRef,
      withRef = _ref2$withRef === void 0 ? false : _ref2$withRef,
      connectOptions = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref2, ["getDisplayName", "methodName", "renderCountProp", "shouldHandleStateChanges", "storeKey", "withRef"]);

  var subscriptionKey = storeKey + 'Subscription';
  var version = hotReloadingVersion++;
  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["a" /* storeShape */], _contextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["b" /* subscriptionShape */], _contextTypes);
  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["b" /* subscriptionShape */], _childContextTypes);
  return function wrapWithConnect(WrappedComponent) {
    __WEBPACK_IMPORTED_MODULE_5_invariant___default()(Object(__WEBPACK_IMPORTED_MODULE_7_react_is__["isValidElementType"])(WrappedComponent), "You must pass a component to the function returned by " + (methodName + ". Instead received " + JSON.stringify(WrappedComponent)));
    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      withRef: withRef,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent // TODO Actually fix our use of componentWillReceiveProps

      /* eslint-disable react/no-deprecated */

    });

    var Connect =
    /*#__PURE__*/
    function (_Component) {
      Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Connect, _Component);

      function Connect(props, context) {
        var _this;

        _this = _Component.call(this, props, context) || this;
        _this.version = version;
        _this.state = {};
        _this.renderCount = 0;
        _this.store = props[storeKey] || context[storeKey];
        _this.propsMode = Boolean(props[storeKey]);
        _this.setWrappedInstance = _this.setWrappedInstance.bind(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
        __WEBPACK_IMPORTED_MODULE_5_invariant___default()(_this.store, "Could not find \"" + storeKey + "\" in either the context or props of " + ("\"" + displayName + "\". Either wrap the root component in a <Provider>, ") + ("or explicitly pass \"" + storeKey + "\" as a prop to \"" + displayName + "\"."));

        _this.initSelector();

        _this.initSubscription();

        return _this;
      }

      var _proto = Connect.prototype;

      _proto.getChildContext = function getChildContext() {
        var _ref3;

        // If this component received store from props, its subscription should be transparent
        // to any descendants receiving store+subscription from context; it passes along
        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
        // Connect to control ordering of notifications to flow top-down.
        var subscription = this.propsMode ? null : this.subscription;
        return _ref3 = {}, _ref3[subscriptionKey] = subscription || this.context[subscriptionKey], _ref3;
      };

      _proto.componentDidMount = function componentDidMount() {
        if (!shouldHandleStateChanges) return; // componentWillMount fires during server side rendering, but componentDidMount and
        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
        // To handle the case where a child component may have triggered a state change by
        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
        // re-render.

        this.subscription.trySubscribe();
        this.selector.run(this.props);
        if (this.selector.shouldComponentUpdate) this.forceUpdate();
      }; // Note: this is renamed below to the UNSAFE_ version in React >=16.3.0


      _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        this.selector.run(nextProps);
      };

      _proto.shouldComponentUpdate = function shouldComponentUpdate() {
        return this.selector.shouldComponentUpdate;
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.subscription) this.subscription.tryUnsubscribe();
        this.subscription = null;
        this.notifyNestedSubs = noop;
        this.store = null;
        this.selector.run = noop;
        this.selector.shouldComponentUpdate = false;
      };

      _proto.getWrappedInstance = function getWrappedInstance() {
        __WEBPACK_IMPORTED_MODULE_5_invariant___default()(withRef, "To access the wrapped instance, you need to specify " + ("{ withRef: true } in the options argument of the " + methodName + "() call."));
        return this.wrappedInstance;
      };

      _proto.setWrappedInstance = function setWrappedInstance(ref) {
        this.wrappedInstance = ref;
      };

      _proto.initSelector = function initSelector() {
        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
        this.selector = makeSelectorStateful(sourceSelector, this.store);
        this.selector.run(this.props);
      };

      _proto.initSubscription = function initSubscription() {
        if (!shouldHandleStateChanges) return; // parentSub's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.

        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
        this.subscription = new __WEBPACK_IMPORTED_MODULE_8__utils_Subscription__["a" /* default */](this.store, parentSub, this.onStateChange.bind(this)); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
        // the middle of the notification loop, where `this.subscription` will then be null. An
        // extra null check every change can be avoided by copying the method onto `this` and then
        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
        // listeners logic is changed to not call listeners that have been unsubscribed in the
        // middle of the notification loop.

        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
      };

      _proto.onStateChange = function onStateChange() {
        this.selector.run(this.props);

        if (!this.selector.shouldComponentUpdate) {
          this.notifyNestedSubs();
        } else {
          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
          this.setState(dummyState);
        }
      };

      _proto.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
        // needs to notify nested subs. Once called, it unimplements itself until further state
        // changes occur. Doing it this way vs having a permanent `componentDidUpdate` that does
        // a boolean check every time avoids an extra method call most of the time, resulting
        // in some perf boost.
        this.componentDidUpdate = undefined;
        this.notifyNestedSubs();
      };

      _proto.isSubscribed = function isSubscribed() {
        return Boolean(this.subscription) && this.subscription.isSubscribed();
      };

      _proto.addExtraProps = function addExtraProps(props) {
        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props; // make a shallow copy so that fields added don't leak to the original selector.
        // this is especially important for 'ref' since that's a reference back to the component
        // instance. a singleton memoized selector would then be holding a reference to the
        // instance, preventing the instance from being garbage collected, and that would be bad

        var withExtras = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props);

        if (withRef) withExtras.ref = this.setWrappedInstance;
        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
        return withExtras;
      };

      _proto.render = function render() {
        var selector = this.selector;
        selector.shouldComponentUpdate = false;

        if (selector.error) {
          throw selector.error;
        } else {
          return Object(__WEBPACK_IMPORTED_MODULE_6_react__["createElement"])(WrappedComponent, this.addExtraProps(selector.props));
        }
      };

      return Connect;
    }(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

    if (prefixUnsafeLifecycleMethods) {
      // Use UNSAFE_ event name where supported
      Connect.prototype.UNSAFE_componentWillReceiveProps = Connect.prototype.componentWillReceiveProps;
      delete Connect.prototype.componentWillReceiveProps;
    }
    /* eslint-enable react/no-deprecated */


    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = displayName;
    Connect.childContextTypes = childContextTypes;
    Connect.contextTypes = contextTypes;
    Connect.propTypes = contextTypes;

    if (false) {
      // Use UNSAFE_ event name where supported
      var eventName = prefixUnsafeLifecycleMethods ? 'UNSAFE_componentWillUpdate' : 'componentWillUpdate';

      Connect.prototype[eventName] = function componentWillUpdate() {
        var _this2 = this;

        // We are hot reloading!
        if (this.version !== version) {
          this.version = version;
          this.initSelector(); // If any connected descendants don't hot reload (and resubscribe in the process), their
          // listeners will be lost when we unsubscribe. Unfortunately, by copying over all
          // listeners, this does mean that the old versions of connected descendants will still be
          // notified of state changes; however, their onStateChange function is a no-op so this
          // isn't a huge deal.

          var oldListeners = [];

          if (this.subscription) {
            oldListeners = this.subscription.listeners.get();
            this.subscription.tryUnsubscribe();
          }

          this.initSubscription();

          if (shouldHandleStateChanges) {
            this.subscription.trySubscribe();
            oldListeners.forEach(function (listener) {
              return _this2.subscription.listeners.subscribe(listener);
            });
          }
        }
      };
    }

    return __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default()(Connect, WrappedComponent);
  };
}

/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActionTypes; });
/* harmony export (immutable) */ __webpack_exports__["b"] = createStore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_symbol_observable__ = __webpack_require__(135);



/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var ActionTypes = {
  INIT: '@@redux/INIT'

  /**
   * Creates a Redux store that holds the state tree.
   * The only way to change the data in the store is to call `dispatch()` on it.
   *
   * There should only be a single store in your app. To specify how different
   * parts of the state tree respond to actions, you may combine several reducers
   * into a single reducer function by using `combineReducers`.
   *
   * @param {Function} reducer A function that returns the next state tree, given
   * the current state tree and the action to handle.
   *
   * @param {any} [preloadedState] The initial state. You may optionally specify it
   * to hydrate the state from the server in universal apps, or to restore a
   * previously serialized user session.
   * If you use `combineReducers` to produce the root reducer function, this must be
   * an object with the same shape as `combineReducers` keys.
   *
   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
   * to enhance the store with third-party capabilities such as middleware,
   * time travel, persistence, etc. The only store enhancer that ships with Redux
   * is `applyMiddleware()`.
   *
   * @returns {Store} A Redux store that lets you read the state, dispatch actions
   * and subscribe to changes.
   */
};function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */
  function getState() {
    return currentState;
  }

  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */
  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected listener to be a function.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */
  function dispatch(action) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;
    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }

  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */
  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer;
    dispatch({ type: ActionTypes.INIT });
  }

  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */
  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object') {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return { unsubscribe: unsubscribe };
      }
    }, _ref[__WEBPACK_IMPORTED_MODULE_1_symbol_observable__["a" /* default */]] = function () {
      return this;
    }, _ref;
  }

  // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.
  dispatch({ type: ActionTypes.INIT });

  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[__WEBPACK_IMPORTED_MODULE_1_symbol_observable__["a" /* default */]] = observable, _ref2;
}

/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getPrototype_js__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__(285);




/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a" /* default */])(value) || Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) != objectTag) {
    return false;
  }
  var proto = Object(__WEBPACK_IMPORTED_MODULE_1__getPrototype_js__["a" /* default */])(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

/* harmony default export */ __webpack_exports__["a"] = (isPlainObject);


/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(279);


/** Built-in value references. */
var Symbol = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Symbol;

/* harmony default export */ __webpack_exports__["a"] = (Symbol);


/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ponyfill_js__ = __webpack_require__(287);
/* global window */


var root;

if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = Object(__WEBPACK_IMPORTED_MODULE_0__ponyfill_js__["a" /* default */])(root);
/* harmony default export */ __webpack_exports__["a"] = (result);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(40), __webpack_require__(286)(module)))

/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = compose;
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */

function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(undefined, arguments));
    };
  });
}

/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = wrapMapToPropsConstant;
/* unused harmony export getDependsOnOwnProps */
/* harmony export (immutable) */ __webpack_exports__["b"] = wrapMapToPropsFunc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(139);

function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }

    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
// 
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..

function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
// 
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//    
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//    
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//    

function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    }; // allow detectFactoryAndVerify to get ownProps


    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) verifyPlainObject(props, displayName, methodName);
      return props;
    };

    return proxy;
  };
}

/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isPlainObject__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__warning__ = __webpack_require__(83);


function verifyPlainObject(value, displayName, methodName) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0__isPlainObject__["a" /* default */])(value)) {
    Object(__WEBPACK_IMPORTED_MODULE_1__warning__["a" /* default */])(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
  }
}

/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(34);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var isModifiedEvent = function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};

/**
 * The public API for rendering a history-aware <a>.
 */

var Link = function (_React$Component) {
  _inherits(Link, _React$Component);

  function Link() {
    var _temp, _this, _ret;

    _classCallCheck(this, Link);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
      if (_this.props.onClick) _this.props.onClick(event);

      if (!event.defaultPrevented && // onClick prevented default
      event.button === 0 && // ignore everything but left clicks
      !_this.props.target && // let browser handle "target=_blank" etc.
      !isModifiedEvent(event) // ignore clicks with modifier keys
      ) {
          event.preventDefault();

          var history = _this.context.router.history;
          var _this$props = _this.props,
              replace = _this$props.replace,
              to = _this$props.to;


          if (replace) {
            history.replace(to);
          } else {
            history.push(to);
          }
        }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Link.prototype.render = function render() {
    var _props = this.props,
        replace = _props.replace,
        to = _props.to,
        innerRef = _props.innerRef,
        props = _objectWithoutProperties(_props, ["replace", "to", "innerRef"]); // eslint-disable-line no-unused-vars

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, "You should not use <Link> outside a <Router>");

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(to !== undefined, 'You must specify the "to" property');

    var history = this.context.router.history;

    var location = typeof to === "string" ? Object(__WEBPACK_IMPORTED_MODULE_3_history__["c" /* createLocation */])(to, null, null, history.location) : to;

    var href = history.createHref(location);
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", _extends({}, props, { onClick: this.handleClick, href: href, ref: innerRef }));
  };

  return Link;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Link.propTypes = {
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired,
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};
Link.defaultProps = {
  replace: false
};
Link.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      createHref: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Link);

/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(57);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that stores location in memory.
 */

var MemoryRouter = function (_React$Component) {
  _inherits(MemoryRouter, _React$Component);

  function MemoryRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, MemoryRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["d" /* createMemoryHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  MemoryRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<MemoryRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { MemoryRouter as Router }`.");
  };

  MemoryRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return MemoryRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

MemoryRouter.propTypes = {
  initialEntries: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
  initialIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (MemoryRouter);

/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__ = __webpack_require__(87);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__["a" /* default */]);

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

var isarray = __webpack_require__(304)

/**
 * Expose `pathToRegexp`.
 */
module.exports = pathToRegexp
module.exports.parse = parse
module.exports.compile = compile
module.exports.tokensToFunction = tokensToFunction
module.exports.tokensToRegExp = tokensToRegExp

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g')

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = []
  var key = 0
  var index = 0
  var path = ''
  var defaultDelimiter = options && options.delimiter || '/'
  var res

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0]
    var escaped = res[1]
    var offset = res.index
    path += str.slice(index, offset)
    index = offset + m.length

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1]
      continue
    }

    var next = str[index]
    var prefix = res[2]
    var name = res[3]
    var capture = res[4]
    var group = res[5]
    var modifier = res[6]
    var asterisk = res[7]

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path)
      path = ''
    }

    var partial = prefix != null && next != null && next !== prefix
    var repeat = modifier === '+' || modifier === '*'
    var optional = modifier === '?' || modifier === '*'
    var delimiter = res[2] || defaultDelimiter
    var pattern = capture || group

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    })
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index)
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path)
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options), options)
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens, options) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length)

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', flags(options))
    }
  }

  return function (obj, opts) {
    var path = ''
    var data = obj || {}
    var options = opts || {}
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i]

      if (typeof token === 'string') {
        path += token

        continue
      }

      var value = data[token.name]
      var segment

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j])

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value)

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options && options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g)

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      })
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = []

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source)
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  var strict = options.strict
  var end = options.end !== false
  var route = ''

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i]

    if (typeof token === 'string') {
      route += escapeString(token)
    } else {
      var prefix = escapeString(token.prefix)
      var capture = '(?:' + token.pattern + ')'

      keys.push(token)

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*'
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?'
        } else {
          capture = prefix + '(' + capture + ')?'
        }
      } else {
        capture = prefix + '(' + capture + ')'
      }

      route += capture
    }
  }

  var delimiter = escapeString(options.delimiter || '/')
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
  }

  if (end) {
    route += '$'
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}


/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





/**
 * The public API for prompting the user before navigating away
 * from a screen with a component.
 */

var Prompt = function (_React$Component) {
  _inherits(Prompt, _React$Component);

  function Prompt() {
    _classCallCheck(this, Prompt);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Prompt.prototype.enable = function enable(message) {
    if (this.unblock) this.unblock();

    this.unblock = this.context.router.history.block(message);
  };

  Prompt.prototype.disable = function disable() {
    if (this.unblock) {
      this.unblock();
      this.unblock = null;
    }
  };

  Prompt.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, "You should not use <Prompt> outside a <Router>");

    if (this.props.when) this.enable(this.props.message);
  };

  Prompt.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.when) {
      if (!this.props.when || this.props.message !== nextProps.message) this.enable(nextProps.message);
    } else {
      this.disable();
    }
  };

  Prompt.prototype.componentWillUnmount = function componentWillUnmount() {
    this.disable();
  };

  Prompt.prototype.render = function render() {
    return null;
  };

  return Prompt;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Prompt.propTypes = {
  when: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  message: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]).isRequired
};
Prompt.defaultProps = {
  when: true
};
Prompt.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      block: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Prompt);

/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__generatePath__ = __webpack_require__(88);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








/**
 * The public API for updating the location programmatically
 * with a component.
 */

var Redirect = function (_React$Component) {
  _inherits(Redirect, _React$Component);

  function Redirect() {
    _classCallCheck(this, Redirect);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Redirect.prototype.isStatic = function isStatic() {
    return this.context.router && this.context.router.staticContext;
  };

  Redirect.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, "You should not use <Redirect> outside a <Router>");

    if (this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidMount = function componentDidMount() {
    if (!this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var prevTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(prevProps.to);
    var nextTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(this.props.to);

    if (Object(__WEBPACK_IMPORTED_MODULE_4_history__["f" /* locationsAreEqual */])(prevTo, nextTo)) {
      __WEBPACK_IMPORTED_MODULE_2_warning___default()(false, "You tried to redirect to the same route you're currently on: " + ("\"" + nextTo.pathname + nextTo.search + "\""));
      return;
    }

    this.perform();
  };

  Redirect.prototype.computeTo = function computeTo(_ref) {
    var computedMatch = _ref.computedMatch,
        to = _ref.to;

    if (computedMatch) {
      if (typeof to === "string") {
        return Object(__WEBPACK_IMPORTED_MODULE_5__generatePath__["a" /* default */])(to, computedMatch.params);
      } else {
        return _extends({}, to, {
          pathname: Object(__WEBPACK_IMPORTED_MODULE_5__generatePath__["a" /* default */])(to.pathname, computedMatch.params)
        });
      }
    }

    return to;
  };

  Redirect.prototype.perform = function perform() {
    var history = this.context.router.history;
    var push = this.props.push;

    var to = this.computeTo(this.props);

    if (push) {
      history.push(to);
    } else {
      history.replace(to);
    }
  };

  Redirect.prototype.render = function render() {
    return null;
  };

  return Redirect;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Redirect.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, // private, from <Switch>
  push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  from: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired
};
Redirect.defaultProps = {
  push: false
};
Redirect.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Redirect);

/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Router__ = __webpack_require__(57);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === "/" ? path : "/" + path;
};

var addBasename = function addBasename(basename, location) {
  if (!basename) return location;

  return _extends({}, location, {
    pathname: addLeadingSlash(basename) + location.pathname
  });
};

var stripBasename = function stripBasename(basename, location) {
  if (!basename) return location;

  var base = addLeadingSlash(basename);

  if (location.pathname.indexOf(base) !== 0) return location;

  return _extends({}, location, {
    pathname: location.pathname.substr(base.length)
  });
};

var createURL = function createURL(location) {
  return typeof location === "string" ? location : Object(__WEBPACK_IMPORTED_MODULE_4_history__["e" /* createPath */])(location);
};

var staticHandler = function staticHandler(methodName) {
  return function () {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(false, "You cannot %s with <StaticRouter>", methodName);
  };
};

var noop = function noop() {};

/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */

var StaticRouter = function (_React$Component) {
  _inherits(StaticRouter, _React$Component);

  function StaticRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, StaticRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.createHref = function (path) {
      return addLeadingSlash(_this.props.basename + createURL(path));
    }, _this.handlePush = function (location) {
      var _this$props = _this.props,
          basename = _this$props.basename,
          context = _this$props.context;

      context.action = "PUSH";
      context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location));
      context.url = createURL(context.location);
    }, _this.handleReplace = function (location) {
      var _this$props2 = _this.props,
          basename = _this$props2.basename,
          context = _this$props2.context;

      context.action = "REPLACE";
      context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location));
      context.url = createURL(context.location);
    }, _this.handleListen = function () {
      return noop;
    }, _this.handleBlock = function () {
      return noop;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  StaticRouter.prototype.getChildContext = function getChildContext() {
    return {
      router: {
        staticContext: this.props.context
      }
    };
  };

  StaticRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<StaticRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { StaticRouter as Router }`.");
  };

  StaticRouter.prototype.render = function render() {
    var _props = this.props,
        basename = _props.basename,
        context = _props.context,
        location = _props.location,
        props = _objectWithoutProperties(_props, ["basename", "context", "location"]);

    var history = {
      createHref: this.createHref,
      action: "POP",
      location: stripBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location)),
      push: this.handlePush,
      replace: this.handleReplace,
      go: staticHandler("go"),
      goBack: staticHandler("goBack"),
      goForward: staticHandler("goForward"),
      listen: this.handleListen,
      block: this.handleBlock
    };

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Router__["a" /* default */], _extends({}, props, { history: history }));
  };

  return StaticRouter;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

StaticRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  context: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object])
};
StaticRouter.defaultProps = {
  basename: "",
  location: "/"
};
StaticRouter.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (StaticRouter);

/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(58);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for rendering the first <Route> that matches.
 */

var Switch = function (_React$Component) {
  _inherits(Switch, _React$Component);

  function Switch() {
    _classCallCheck(this, Switch);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Switch.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, "You should not use <Switch> outside a <Router>");
  };

  Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
  };

  Switch.prototype.render = function render() {
    var route = this.context.router.route;
    var children = this.props.children;

    var location = this.props.location || route.location;

    var match = void 0,
        child = void 0;
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (element) {
      if (match == null && __WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(element)) {
        var _element$props = element.props,
            pathProp = _element$props.path,
            exact = _element$props.exact,
            strict = _element$props.strict,
            sensitive = _element$props.sensitive,
            from = _element$props.from;

        var path = pathProp || from;

        child = element;
        match = Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(location.pathname, { path: path, exact: exact, strict: strict, sensitive: sensitive }, route.match);
      }
    });

    return match ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, { location: location, computedMatch: match }) : null;
  };

  return Switch;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Switch.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    route: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
  }).isRequired
};
Switch.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};


/* harmony default export */ __webpack_exports__["a"] = (Switch);

/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__(87);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A public higher-order component to access the imperative API
 */
var withRouter = function withRouter(Component) {
  var C = function C(props) {
    var wrappedComponentRef = props.wrappedComponentRef,
        remainingProps = _objectWithoutProperties(props, ["wrappedComponentRef"]);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Route__["a" /* default */], {
      children: function children(routeComponentProps) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, _extends({}, remainingProps, routeComponentProps, {
          ref: wrappedComponentRef
        }));
      }
    });
  };

  C.displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
  C.WrappedComponent = Component;
  C.propTypes = {
    wrappedComponentRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
  };

  return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(C, Component);
};

/* harmony default export */ __webpack_exports__["a"] = (withRouter);

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var formats = __webpack_require__(91);

var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;

var hexTable = (function () {
    var array = [];
    for (var i = 0; i < 256; ++i) {
        array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
    }

    return array;
}());

var compactQueue = function compactQueue(queue) {
    while (queue.length > 1) {
        var item = queue.pop();
        var obj = item.obj[item.prop];

        if (isArray(obj)) {
            var compacted = [];

            for (var j = 0; j < obj.length; ++j) {
                if (typeof obj[j] !== 'undefined') {
                    compacted.push(obj[j]);
                }
            }

            item.obj[item.prop] = compacted;
        }
    }
};

var arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? Object.create(null) : {};
    for (var i = 0; i < source.length; ++i) {
        if (typeof source[i] !== 'undefined') {
            obj[i] = source[i];
        }
    }

    return obj;
};

var merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */
    if (!source) {
        return target;
    }

    if (typeof source !== 'object') {
        if (isArray(target)) {
            target.push(source);
        } else if (target && typeof target === 'object') {
            if ((options && (options.plainObjects || options.allowPrototypes)) || !has.call(Object.prototype, source)) {
                target[source] = true;
            }
        } else {
            return [target, source];
        }

        return target;
    }

    if (!target || typeof target !== 'object') {
        return [target].concat(source);
    }

    var mergeTarget = target;
    if (isArray(target) && !isArray(source)) {
        mergeTarget = arrayToObject(target, options);
    }

    if (isArray(target) && isArray(source)) {
        source.forEach(function (item, i) {
            if (has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === 'object' && item && typeof item === 'object') {
                    target[i] = merge(targetItem, item, options);
                } else {
                    target.push(item);
                }
            } else {
                target[i] = item;
            }
        });
        return target;
    }

    return Object.keys(source).reduce(function (acc, key) {
        var value = source[key];

        if (has.call(acc, key)) {
            acc[key] = merge(acc[key], value, options);
        } else {
            acc[key] = value;
        }
        return acc;
    }, mergeTarget);
};

var assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function (acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};

var decode = function (str, decoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, ' ');
    if (charset === 'iso-8859-1') {
        // unescape never throws, no try...catch needed:
        return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    }
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};

var encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) {
        return str;
    }

    var string = str;
    if (typeof str === 'symbol') {
        string = Symbol.prototype.toString.call(str);
    } else if (typeof str !== 'string') {
        string = String(str);
    }

    if (charset === 'iso-8859-1') {
        return escape(string).replace(/%u[0-9a-f]{4}/gi, function ($0) {
            return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
        });
    }

    var out = '';
    for (var i = 0; i < string.length; ++i) {
        var c = string.charCodeAt(i);

        if (
            c === 0x2D // -
            || c === 0x2E // .
            || c === 0x5F // _
            || c === 0x7E // ~
            || (c >= 0x30 && c <= 0x39) // 0-9
            || (c >= 0x41 && c <= 0x5A) // a-z
            || (c >= 0x61 && c <= 0x7A) // A-Z
            || (format === formats.RFC1738 && (c === 0x28 || c === 0x29)) // ( )
        ) {
            out += string.charAt(i);
            continue;
        }

        if (c < 0x80) {
            out = out + hexTable[c];
            continue;
        }

        if (c < 0x800) {
            out = out + (hexTable[0xC0 | (c >> 6)] + hexTable[0x80 | (c & 0x3F)]);
            continue;
        }

        if (c < 0xD800 || c >= 0xE000) {
            out = out + (hexTable[0xE0 | (c >> 12)] + hexTable[0x80 | ((c >> 6) & 0x3F)] + hexTable[0x80 | (c & 0x3F)]);
            continue;
        }

        i += 1;
        c = 0x10000 + (((c & 0x3FF) << 10) | (string.charCodeAt(i) & 0x3FF));
        out += hexTable[0xF0 | (c >> 18)]
            + hexTable[0x80 | ((c >> 12) & 0x3F)]
            + hexTable[0x80 | ((c >> 6) & 0x3F)]
            + hexTable[0x80 | (c & 0x3F)];
    }

    return out;
};

var compact = function compact(value) {
    var queue = [{ obj: { o: value }, prop: 'o' }];
    var refs = [];

    for (var i = 0; i < queue.length; ++i) {
        var item = queue[i];
        var obj = item.obj[item.prop];

        var keys = Object.keys(obj);
        for (var j = 0; j < keys.length; ++j) {
            var key = keys[j];
            var val = obj[key];
            if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
                queue.push({ obj: obj, prop: key });
                refs.push(val);
            }
        }
    }

    compactQueue(queue);

    return value;
};

var isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
};

var isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== 'object') {
        return false;
    }

    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};

var combine = function combine(a, b) {
    return [].concat(a, b);
};

var maybeMap = function maybeMap(val, fn) {
    if (isArray(val)) {
        var mapped = [];
        for (var i = 0; i < val.length; i += 1) {
            mapped.push(fn(val[i]));
        }
        return mapped;
    }
    return fn(val);
};

module.exports = {
    arrayToObject: arrayToObject,
    assign: assign,
    combine: combine,
    compact: compact,
    decode: decode,
    encode: encode,
    isBuffer: isBuffer,
    isRegExp: isRegExp,
    maybeMap: maybeMap,
    merge: merge
};


/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = trim;
// GA strings need to have leading/trailing whitespace trimmed, and not all
// browsers have String.prototoype.trim().
function trim(s) {
  return s && s.toString().replace(/^\s+|\s+$/g, '');
}

/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export initialState */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActionTypes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_by_react_utils__ = __webpack_require__(59);
var _createReducer;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var initialState={featured:[],contents:{}};var ActionTypes={SET_FEATURED:'SET_FEATURED',SET_PAGE_CONTENT:'SET_PAGE_CONTENT'};/* harmony default export */ __webpack_exports__["b"] = (Object(__WEBPACK_IMPORTED_MODULE_0_by_react_utils__["a" /* createReducer */])(initialState,(_createReducer={},_defineProperty(_createReducer,ActionTypes.SET_FEATURED,function(state,_ref){var featured=_ref.featured;return Object.assign({},state,{featured:[].concat(_toConsumableArray(featured))});}),_defineProperty(_createReducer,ActionTypes.SET_PAGE_CONTENT,function(state,_ref2){var page=_ref2.page,contents=_ref2.contents;return Object.assign({},state,{contents:Object.assign({},state.contents,_defineProperty({},page,'length'in contents?[].concat(_toConsumableArray(contents)):Object.assign({},contents)))});}),_createReducer)));

/***/ }),
/* 153 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export initialState */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActionTypes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_by_react_utils__ = __webpack_require__(59);
var _createReducer;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var initialState={username:'',role:'',notifications:[],initAt:-1,action:'',fields:[],forgot_password:[],forgotForm:[],passwordChanged:false,menu:[],urls:[],store:null,picture:'',challenge:{}};var ActionTypes={CREATE_FORM:'CREATE_FORM',INIT_SESSION:'INIT_SESSION',CLEAR_SESSION:'CLEAR_SESSION',HANDLE_ERRORS:'HANDLE_ERRORS',PASSWORD_CHANGED:'PASSWORD_CHANGED',INIT_CHALLENGE:'INIT_CHALLENGE',EDIT_CHALLENGE:'EDIT_CHALLENGE',EDIT_PICTURE:'EDIT_PICTURE'};/* harmony default export */ __webpack_exports__["b"] = (Object(__WEBPACK_IMPORTED_MODULE_0_by_react_utils__["a" /* createReducer */])(initialState,(_createReducer={},_defineProperty(_createReducer,ActionTypes.CREATE_FORM,function(state,_ref){var action=_ref.action,fields=_ref.fields,forgot_password=_ref.forgot_password,form=_ref.form;return Object.assign({},state,{username:'',role:'',picture:'',initAt:-1,action:action,fields:[].concat(_toConsumableArray(fields)),urls:[],forgot_password:Object.assign({},forgot_password),forgotForm:form,passwordChanged:false,store:null,challenge:{}});}),_defineProperty(_createReducer,ActionTypes.INIT_SESSION,function(state,_ref2){var initAt=_ref2.initAt,username=_ref2.username,notifications=_ref2.notifications,form=_ref2.form,menu=_ref2.menu,preview=_ref2.preview,role=_ref2.role,urls=_ref2.urls,store=_ref2.store,picture=_ref2.picture,challenge=_ref2.challenge;return Object.assign({},state,{error:null,initAt:initAt,username:username,role:role,store:store,picture:picture,forgotForm:form,notifications:[].concat(_toConsumableArray(notifications)),menu:menu,passwordChanged:false,preview:preview,urls:urls,challenge:challenge});}),_defineProperty(_createReducer,ActionTypes.EDIT_CHALLENGE,function(state,_ref3){var challenge=_ref3.challenge;return Object.assign({},state,{challenge:challenge});}),_defineProperty(_createReducer,ActionTypes.EDIT_PICTURE,function(state,_ref4){var picture=_ref4.picture;return Object.assign({},state,{picture:picture});}),_defineProperty(_createReducer,ActionTypes.CLEAR_SESSION,function(state,_ref5){var initAt=_ref5.initAt,username=_ref5.username,notifications=_ref5.notifications,menu=_ref5.menu,preview=_ref5.preview;return Object.assign({},state,{error:null,username:'',role:'',picture:'',store:null,notifications:[],menu:[],initAt:-1,action:'',fields:[],urls:[],forgot_password:[],forgotForm:[],passwordChanged:false,preview:preview,challenge:{}});}),_defineProperty(_createReducer,ActionTypes.HANDLE_ERRORS,function(state,_ref6){var error=_ref6.error;return Object.assign({},state,{error:Object.assign({},error)});}),_defineProperty(_createReducer,ActionTypes.PASSWORD_CHANGED,function(state){return Object.assign({},state,{error:null,passwordChanged:true});}),_createReducer)));

/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export initialState */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActionTypes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_by_react_utils__ = __webpack_require__(59);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var initialState={isOpen:false};var ActionTypes={TOGGLE_MODAL:'TOGGLE_MODAL'};/* harmony default export */ __webpack_exports__["b"] = (Object(__WEBPACK_IMPORTED_MODULE_0_by_react_utils__["a" /* createReducer */])(initialState,_defineProperty({},ActionTypes.TOGGLE_MODAL,function(state,_ref){var isOpen=_ref.isOpen;return Object.assign({},state,{isOpen:isOpen});})));

/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Auth___ = __webpack_require__(341);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__Auth___["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Pages___ = __webpack_require__(588);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__Pages___["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AuthGate__ = __webpack_require__(589);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__AuthGate__["a"]; });


/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BaseLayout___ = __webpack_require__(342);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__BaseLayout___["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AuthLayout__ = __webpack_require__(583);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__AuthLayout__["a"]; });


/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__button__ = __webpack_require__(352);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__button__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_0__button__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_0__button__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_0__button__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_0__button__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_0__button__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_0__button__["g"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_0__button__["h"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_0__button__["i"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fields__ = __webpack_require__(353);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_1__fields__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "W", function() { return __WEBPACK_IMPORTED_MODULE_1__fields__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__account__ = __webpack_require__(354);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__account__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__progressBar__ = __webpack_require__(355);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "G", function() { return __WEBPACK_IMPORTED_MODULE_3__progressBar__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__notification__ = __webpack_require__(356);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "C", function() { return __WEBPACK_IMPORTED_MODULE_4__notification__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pushContent__ = __webpack_require__(357);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "H", function() { return __WEBPACK_IMPORTED_MODULE_5__pushContent__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__searchBar__ = __webpack_require__(358);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "N", function() { return __WEBPACK_IMPORTED_MODULE_6__searchBar__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__card__ = __webpack_require__(359);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_7__card__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_7__card__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__featured__ = __webpack_require__(360);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_8__featured__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__slider__ = __webpack_require__(361);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_9__slider__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_9__slider__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return __WEBPACK_IMPORTED_MODULE_9__slider__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "R", function() { return __WEBPACK_IMPORTED_MODULE_9__slider__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "T", function() { return __WEBPACK_IMPORTED_MODULE_9__slider__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "U", function() { return __WEBPACK_IMPORTED_MODULE_9__slider__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "V", function() { return __WEBPACK_IMPORTED_MODULE_9__slider__["g"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return __WEBPACK_IMPORTED_MODULE_9__slider__["h"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__video__ = __webpack_require__(362);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_10__video__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return __WEBPACK_IMPORTED_MODULE_10__video__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return __WEBPACK_IMPORTED_MODULE_10__video__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return __WEBPACK_IMPORTED_MODULE_10__video__["d"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__panelPDF__ = __webpack_require__(363);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "E", function() { return __WEBPACK_IMPORTED_MODULE_11__panelPDF__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__challenge__ = __webpack_require__(364);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_12__challenge__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_12__challenge__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "I", function() { return __WEBPACK_IMPORTED_MODULE_12__challenge__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "J", function() { return __WEBPACK_IMPORTED_MODULE_12__challenge__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "L", function() { return __WEBPACK_IMPORTED_MODULE_12__challenge__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "M", function() { return __WEBPACK_IMPORTED_MODULE_12__challenge__["f"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__nav__ = __webpack_require__(366);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_13__nav__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "B", function() { return __WEBPACK_IMPORTED_MODULE_13__nav__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__userNav__ = __webpack_require__(367);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return __WEBPACK_IMPORTED_MODULE_14__userNav__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__simpleFilter__ = __webpack_require__(368);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "P", function() { return __WEBPACK_IMPORTED_MODULE_15__simpleFilter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__prodibi__ = __webpack_require__(369);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "F", function() { return __WEBPACK_IMPORTED_MODULE_16__prodibi__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__quantity__ = __webpack_require__(370);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "K", function() { return __WEBPACK_IMPORTED_MODULE_17__quantity__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__checkbox__ = __webpack_require__(371);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_18__checkbox__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__dropdown__ = __webpack_require__(372);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_19__dropdown__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "O", function() { return __WEBPACK_IMPORTED_MODULE_19__dropdown__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__slideshow__ = __webpack_require__(373);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "S", function() { return __WEBPACK_IMPORTED_MODULE_20__slideshow__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__filter__ = __webpack_require__(374);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_21__filter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__uploadFile__ = __webpack_require__(375);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "X", function() { return __WEBPACK_IMPORTED_MODULE_22__uploadFile__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__event__ = __webpack_require__(376);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_23__event__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__contentLoader__ = __webpack_require__(377);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_24__contentLoader__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__pan__ = __webpack_require__(378);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "D", function() { return __WEBPACK_IMPORTED_MODULE_25__pan__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__gallery__ = __webpack_require__(379);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_26__gallery__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__faqPopin__ = __webpack_require__(380);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_27__faqPopin__["a"]; });


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/quizz.511885af.jpg";

/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BaseTemplate__ = __webpack_require__(454);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__BaseTemplate__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FullTextTemplate__ = __webpack_require__(455);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__FullTextTemplate__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__IntroTemplate__ = __webpack_require__(467);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__IntroTemplate__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SingleVideoTemplate__ = __webpack_require__(468);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__SingleVideoTemplate__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SliderTemplate__ = __webpack_require__(469);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_4__SliderTemplate__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SocialTemplate__ = __webpack_require__(470);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_5__SocialTemplate__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SuggestTemplate__ = __webpack_require__(471);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_6__SuggestTemplate__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__VideoTemplate__ = __webpack_require__(472);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_7__VideoTemplate__["a"]; });


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * getSize v2.0.3
 * measure size of elements
 * MIT license
 */

/* jshint browser: true, strict: true, undef: true, unused: true */
/* globals console: false */

( function( window, factory ) {
  /* jshint strict: false */ /* globals define, module */
  if ( true ) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory();
  } else {
    // browser global
    window.getSize = factory();
  }

})( window, function factory() {
'use strict';

// -------------------------- helpers -------------------------- //

// get a number from a string, not a percentage
function getStyleSize( value ) {
  var num = parseFloat( value );
  // not a percent like '100%', and a number
  var isValid = value.indexOf('%') == -1 && !isNaN( num );
  return isValid && num;
}

function noop() {}

var logError = typeof console == 'undefined' ? noop :
  function( message ) {
    console.error( message );
  };

// -------------------------- measurements -------------------------- //

var measurements = [
  'paddingLeft',
  'paddingRight',
  'paddingTop',
  'paddingBottom',
  'marginLeft',
  'marginRight',
  'marginTop',
  'marginBottom',
  'borderLeftWidth',
  'borderRightWidth',
  'borderTopWidth',
  'borderBottomWidth'
];

var measurementsLength = measurements.length;

function getZeroSize() {
  var size = {
    width: 0,
    height: 0,
    innerWidth: 0,
    innerHeight: 0,
    outerWidth: 0,
    outerHeight: 0
  };
  for ( var i=0; i < measurementsLength; i++ ) {
    var measurement = measurements[i];
    size[ measurement ] = 0;
  }
  return size;
}

// -------------------------- getStyle -------------------------- //

/**
 * getStyle, get style of element, check for Firefox bug
 * https://bugzilla.mozilla.org/show_bug.cgi?id=548397
 */
function getStyle( elem ) {
  var style = getComputedStyle( elem );
  if ( !style ) {
    logError( 'Style returned ' + style +
      '. Are you running this code in a hidden iframe on Firefox? ' +
      'See https://bit.ly/getsizebug1' );
  }
  return style;
}

// -------------------------- setup -------------------------- //

var isSetup = false;

var isBoxSizeOuter;

/**
 * setup
 * check isBoxSizerOuter
 * do on first getSize() rather than on page load for Firefox bug
 */
function setup() {
  // setup once
  if ( isSetup ) {
    return;
  }
  isSetup = true;

  // -------------------------- box sizing -------------------------- //

  /**
   * Chrome & Safari measure the outer-width on style.width on border-box elems
   * IE11 & Firefox<29 measures the inner-width
   */
  var div = document.createElement('div');
  div.style.width = '200px';
  div.style.padding = '1px 2px 3px 4px';
  div.style.borderStyle = 'solid';
  div.style.borderWidth = '1px 2px 3px 4px';
  div.style.boxSizing = 'border-box';

  var body = document.body || document.documentElement;
  body.appendChild( div );
  var style = getStyle( div );
  // round value for browser zoom. desandro/masonry#928
  isBoxSizeOuter = Math.round( getStyleSize( style.width ) ) == 200;
  getSize.isBoxSizeOuter = isBoxSizeOuter;

  body.removeChild( div );
}

// -------------------------- getSize -------------------------- //

function getSize( elem ) {
  setup();

  // use querySeletor if elem is string
  if ( typeof elem == 'string' ) {
    elem = document.querySelector( elem );
  }

  // do not proceed on non-objects
  if ( !elem || typeof elem != 'object' || !elem.nodeType ) {
    return;
  }

  var style = getStyle( elem );

  // if hidden, everything is 0
  if ( style.display == 'none' ) {
    return getZeroSize();
  }

  var size = {};
  size.width = elem.offsetWidth;
  size.height = elem.offsetHeight;

  var isBorderBox = size.isBorderBox = style.boxSizing == 'border-box';

  // get all measurements
  for ( var i=0; i < measurementsLength; i++ ) {
    var measurement = measurements[i];
    var value = style[ measurement ];
    var num = parseFloat( value );
    // any 'auto', 'medium' value will be 0
    size[ measurement ] = !isNaN( num ) ? num : 0;
  }

  var paddingWidth = size.paddingLeft + size.paddingRight;
  var paddingHeight = size.paddingTop + size.paddingBottom;
  var marginWidth = size.marginLeft + size.marginRight;
  var marginHeight = size.marginTop + size.marginBottom;
  var borderWidth = size.borderLeftWidth + size.borderRightWidth;
  var borderHeight = size.borderTopWidth + size.borderBottomWidth;

  var isBorderBoxSizeOuter = isBorderBox && isBoxSizeOuter;

  // overwrite width and height if we can get it from style
  var styleWidth = getStyleSize( style.width );
  if ( styleWidth !== false ) {
    size.width = styleWidth +
      // add padding and border unless it's already including it
      ( isBorderBoxSizeOuter ? 0 : paddingWidth + borderWidth );
  }

  var styleHeight = getStyleSize( style.height );
  if ( styleHeight !== false ) {
    size.height = styleHeight +
      // add padding and border unless it's already including it
      ( isBorderBoxSizeOuter ? 0 : paddingHeight + borderHeight );
  }

  size.innerWidth = size.width - ( paddingWidth + borderWidth );
  size.innerHeight = size.height - ( paddingHeight + borderHeight );

  size.outerWidth = size.width + marginWidth;
  size.outerHeight = size.height + marginHeight;

  return size;
}

return getSize;

});


/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Video=function(_Component){_inherits(Video,_Component);function Video(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Video);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Video.__proto__||Object.getPrototypeOf(Video)).call.apply(_ref,[this].concat(args))),_this),_this.state={active:false},_this.handlerClick=function(e){e.preventDefault();if(!e.target.classList.contains('video-close')&&!e.target.closest('.video-close')){_this.setState({url:_this.props.type==='vimeo'?'https://player.vimeo.com/video/'+_this.props.link+'?autoplay=1':'https://www.youtube.com/embed/'+_this.props.link+'?autoplay=1'},function(){_this.setState({active:true});});}},_this.handlerClose=function(e){e.preventDefault();_this.setState({active:false},function(){_this.setState({url:''});});},_this.scaleVideo=function(){var windowHeight=window.innerHeight;var videoHeight=_this.video;var scale=windowHeight/videoHeight;if(videoHeight<=windowHeight){_this.video.style.transform='scale('+scale+') translateY(-50%)';}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Video,[{key:'componentDidMount',value:function componentDidMount(){this.scaleVideo();}},{key:'render',value:function render(){var _this2=this;var _props=this.props,title=_props.title,poster=_props.poster;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card flex '+Object(__WEBPACK_IMPORTED_MODULE_1__styles__["s" /* CardStyle */])(true,poster,true)+' '+Object(__WEBPACK_IMPORTED_MODULE_1__styles__["_71" /* VideoCardStyle */])(this.state.active)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-inner',onClick:this.handlerClick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-picture'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'video-label'},title)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-bottom'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'card-link'},'Discover')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'video-container-full'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'video-close',onClick:this.handlerClose},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'video-iframe',ref:function ref(video){return _this2.video=video;}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'video-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('iframe',{src:this.state.url,frameBorder:'0',allowFullScreen:true,title:title}))))));}}]);return Video;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Video);

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t(__webpack_require__(48),__webpack_require__(0),__webpack_require__(477)):"function"==typeof define&&define.amd?define(["moment","react","react-onclickoutside"],t):"object"==typeof exports?exports.DatePicker=t(require("moment"),require("react"),require("react-onclickoutside")):e.DatePicker=t(e.moment,e.React,e.onClickOutside)}(this,function(e,t,n){return function(e){function t(r){if(n[r])return n[r].exports;var o=n[r]={exports:{},id:r,loaded:!1};return e[r].call(o.exports,o,o.exports,t),o.loaded=!0,o.exports}var n={};return t.m=e,t.c=n,t.p="",t(0)}([function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t,n){return t in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function s(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var p=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),c=n(1),u=r(c),l=n(4),f=r(l),d=n(5),h=(r(d),n(20)),m=r(h),y=n(11),v=r(y),b=n(18),g=n(2),w=r(g),_=n(12),D=r(_),O="react-datepicker-ignore-onclickoutside",k=(0,D.default)(u.default),E=function(e){function t(e){a(this,t);var n=i(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e));return n.calcInitialState=function(){var e=n.props.openToDate?(0,w.default)(n.props.openToDate):n.props.selectsEnd&&n.props.startDate?(0,w.default)(n.props.startDate):n.props.selectsStart&&n.props.endDate?(0,w.default)(n.props.endDate):"undefined"!=typeof n.props.utcOffset?w.default.utc().utcOffset(n.props.utcOffset):(0,w.default)(),t=(0,b.getEffectiveMinDate)(n.props),r=(0,b.getEffectiveMaxDate)(n.props),o=t&&e.isBefore(t)?t:r&&e.isAfter(r)?r:e;return{open:!1,preventFocus:!1,preSelection:n.props.selected?(0,w.default)(n.props.selected):o}},n.clearPreventFocusTimeout=function(){n.preventFocusTimeout&&clearTimeout(n.preventFocusTimeout)},n.setFocus=function(){n.input.focus()},n.setOpen=function(e){n.setState({open:e,preSelection:e&&n.state.open?n.state.preSelection:n.calcInitialState().preSelection})},n.handleFocus=function(e){n.state.preventFocus||(n.props.onFocus(e),n.setOpen(!0))},n.cancelFocusInput=function(){clearTimeout(n.inputFocusTimeout),n.inputFocusTimeout=null},n.deferFocusInput=function(){n.cancelFocusInput(),n.inputFocusTimeout=setTimeout(function(){return n.setFocus()},1)},n.handleDropdownFocus=function(){n.cancelFocusInput()},n.handleBlur=function(e){n.state.open?n.deferFocusInput():n.props.onBlur(e)},n.handleCalendarClickOutside=function(e){n.props.inline||n.setOpen(!1),n.props.onClickOutside(e),n.props.withPortal&&e.preventDefault()},n.handleChange=function(e){if(!n.props.onChangeRaw||(n.props.onChangeRaw(e),!e.isDefaultPrevented())){n.setState({inputValue:e.target.value});var t=(0,b.parseDate)(e.target.value,n.props);!t&&e.target.value||n.setSelected(t,e,!0)}},n.handleSelect=function(e,t){n.setState({preventFocus:!0},function(){return n.preventFocusTimeout=setTimeout(function(){return n.setState({preventFocus:!1})},50),n.preventFocusTimeout}),n.setSelected(e,t),n.props.shouldCloseOnSelect?n.props.inline||n.setOpen(!1):n.setPreSelection(e)},n.setSelected=function(e,t,r){var o=e;null!==o&&(0,b.isDayDisabled)(o,n.props)||((0,b.isSameDay)(n.props.selected,o)&&!n.props.allowSameDay||(null!==o&&(n.props.selected&&(o=(0,w.default)(o).set({hour:n.props.selected.hour(),minute:n.props.selected.minute(),second:n.props.selected.second()})),n.setState({preSelection:o})),n.props.onChange(o,t)),n.props.onSelect(o,t),r||n.setState({inputValue:null}))},n.setPreSelection=function(e){var t="undefined"!=typeof n.props.minDate&&"undefined"!=typeof n.props.maxDate,r=!t||!e||(0,b.isDayInRange)(e,n.props.minDate,n.props.maxDate);r&&n.setState({preSelection:e})},n.onInputClick=function(){n.props.disabled||n.setOpen(!0)},n.onInputKeyDown=function(e){n.props.onKeyDown(e);var t=e.key;if(!n.state.open&&!n.props.inline)return void("Enter"!==t&&"Escape"!==t&&"Tab"!==t&&n.onInputClick());var r=(0,w.default)(n.state.preSelection);if("Enter"===t)e.preventDefault(),w.default.isMoment(n.state.preSelection)||w.default.isDate(n.state.preSelection)?(n.handleSelect(r,e),!n.props.shouldCloseOnSelect&&n.setPreSelection(r)):n.setOpen(!1);else if("Escape"===t)e.preventDefault(),n.setOpen(!1);else if("Tab"===t)n.setOpen(!1);else if(!n.props.disabledKeyboardNavigation){var o=void 0;switch(t){case"ArrowLeft":e.preventDefault(),o=r.subtract(1,"days");break;case"ArrowRight":e.preventDefault(),o=r.add(1,"days");break;case"ArrowUp":e.preventDefault(),o=r.subtract(1,"weeks");break;case"ArrowDown":e.preventDefault(),o=r.add(1,"weeks");break;case"PageUp":e.preventDefault(),o=r.subtract(1,"months");break;case"PageDown":e.preventDefault(),o=r.add(1,"months");break;case"Home":e.preventDefault(),o=r.subtract(1,"years");break;case"End":e.preventDefault(),o=r.add(1,"years")}n.setPreSelection(o)}},n.onClearClick=function(e){e.preventDefault(),n.props.onChange(null,e)},n.renderCalendar=function(){return n.props.inline||n.state.open&&!n.props.disabled?f.default.createElement(k,{ref:function(e){n.calendar=e},locale:n.props.locale,dateFormat:n.props.dateFormatCalendar,useWeekdaysShort:n.props.useWeekdaysShort,dropdownMode:n.props.dropdownMode,selected:n.props.selected,preSelection:n.state.preSelection,onSelect:n.handleSelect,onWeekSelect:n.props.onWeekSelect,openToDate:n.props.openToDate,minDate:n.props.minDate,maxDate:n.props.maxDate,selectsStart:n.props.selectsStart,selectsEnd:n.props.selectsEnd,startDate:n.props.startDate,endDate:n.props.endDate,excludeDates:n.props.excludeDates,filterDate:n.props.filterDate,onClickOutside:n.handleCalendarClickOutside,formatWeekNumber:n.props.formatWeekNumber,highlightDates:n.props.highlightDates,includeDates:n.props.includeDates,inline:n.props.inline,peekNextMonth:n.props.peekNextMonth,showMonthDropdown:n.props.showMonthDropdown,showWeekNumbers:n.props.showWeekNumbers,showYearDropdown:n.props.showYearDropdown,forceShowMonthNavigation:n.props.forceShowMonthNavigation,scrollableYearDropdown:n.props.scrollableYearDropdown,todayButton:n.props.todayButton,weekLabel:n.props.weekLabel,utcOffset:n.props.utcOffset,outsideClickIgnoreClass:O,fixedHeight:n.props.fixedHeight,monthsShown:n.props.monthsShown,onDropdownFocus:n.handleDropdownFocus,onMonthChange:n.props.onMonthChange,dayClassName:n.props.dayClassName,className:n.props.calendarClassName,yearDropdownItemNumber:n.props.yearDropdownItemNumber},n.props.children):null},n.renderDateInput=function(){var e=(0,v.default)(n.props.className,o({},O,n.state.open)),t=n.props.customInput||f.default.createElement("input",{type:"text"}),r="string"==typeof n.props.value?n.props.value:"string"==typeof n.state.inputValue?n.state.inputValue:(0,b.safeDateFormat)(n.props.selected,n.props);return f.default.cloneElement(t,{ref:function(e){n.input=e},value:r,onBlur:n.handleBlur,onChange:n.handleChange,onClick:n.onInputClick,onFocus:n.handleFocus,onKeyDown:n.onInputKeyDown,id:n.props.id,name:n.props.name,autoFocus:n.props.autoFocus,placeholder:n.props.placeholderText,disabled:n.props.disabled,autoComplete:n.props.autoComplete,className:e,title:n.props.title,readOnly:n.props.readOnly,required:n.props.required,tabIndex:n.props.tabIndex})},n.renderClearButton=function(){return n.props.isClearable&&null!=n.props.selected?f.default.createElement("a",{className:"react-datepicker__close-icon",href:"#",onClick:n.onClearClick}):null},n.state=n.calcInitialState(),n}return s(t,e),p(t,null,[{key:"defaultProps",get:function(){return{allowSameDay:!1,dateFormat:"L",dateFormatCalendar:"MMMM YYYY",onChange:function(){},disabled:!1,disabledKeyboardNavigation:!1,dropdownMode:"scroll",onFocus:function(){},onBlur:function(){},onKeyDown:function(){},onSelect:function(){},onClickOutside:function(){},onMonthChange:function(){},utcOffset:(0,w.default)().utcOffset(),monthsShown:1,withPortal:!1,shouldCloseOnSelect:!0}}}]),p(t,[{key:"componentWillReceiveProps",value:function(e){var t=this.props.selected&&this.props.selected.month(),n=e.selected&&e.selected.month();this.props.inline&&t!==n&&this.setPreSelection(e.selected)}},{key:"componentWillUnmount",value:function(){this.clearPreventFocusTimeout()}},{key:"render",value:function(){var e=this.renderCalendar();return this.props.inline&&!this.props.withPortal?e:this.props.withPortal?f.default.createElement("div",null,this.props.inline?null:f.default.createElement("div",{className:"react-datepicker__input-container"},this.renderDateInput(),this.renderClearButton()),this.state.open||this.props.inline?f.default.createElement("div",{className:"react-datepicker__portal"},e):null):f.default.createElement(m.default,{className:this.props.popperClassName,hidePopper:!this.state.open||this.props.disabled,popperModifiers:this.props.popperModifiers,targetComponent:f.default.createElement("div",{className:"react-datepicker__input-container"},this.renderDateInput(),this.renderClearButton()),popperComponent:e,popperPlacement:this.props.popperPlacement})}}]),t}(f.default.Component);t.default=E},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var s=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),p=n(2),c=r(p),u=n(3),l=r(u),f=n(13),d=r(f),h=n(15),m=r(h),y=n(4),v=r(y),b=n(5),g=(r(b),n(11)),w=r(g),_=n(18),D=["react-datepicker__year-select","react-datepicker__month-select"],O=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=(e.className||"").split(/\s+/);return D.some(function(e){return t.indexOf(e)>=0})},k=function(e){function t(e){o(this,t);var n=a(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e));return n.handleClickOutside=function(e){n.props.onClickOutside(e)},n.handleDropdownFocus=function(e){O(e.target)&&n.props.onDropdownFocus()},n.getDateInView=function(){var e=n.props,t=e.preSelection,r=e.selected,o=e.openToDate,a=e.utcOffset,i=(0,_.getEffectiveMinDate)(n.props),s=(0,_.getEffectiveMaxDate)(n.props),p=c.default.utc().utcOffset(a),u=o||r||t;return u?u:i&&p.isBefore(i)?i:s&&p.isAfter(s)?s:p},n.localizeMoment=function(e){return e.clone().locale(n.props.locale||c.default.locale())},n.increaseMonth=function(){n.setState({date:n.state.date.clone().add(1,"month")},function(){return n.handleMonthChange(n.state.date)})},n.decreaseMonth=function(){n.setState({date:n.state.date.clone().subtract(1,"month")},function(){return n.handleMonthChange(n.state.date)})},n.handleDayClick=function(e,t){return n.props.onSelect(e,t)},n.handleDayMouseEnter=function(e){return n.setState({selectingDate:e})},n.handleMonthMouseLeave=function(){return n.setState({selectingDate:null})},n.handleMonthChange=function(e){n.props.onMonthChange&&n.props.onMonthChange(e)},n.changeYear=function(e){n.setState({date:n.state.date.clone().set("year",e)})},n.changeMonth=function(e){n.setState({date:n.state.date.clone().set("month",e)},function(){return n.handleMonthChange(n.state.date)})},n.header=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:n.state.date,t=e.clone().startOf("week"),r=[];return n.props.showWeekNumbers&&r.push(v.default.createElement("div",{key:"W",className:"react-datepicker__day-name"},n.props.weekLabel||"#")),r.concat([0,1,2,3,4,5,6].map(function(e){var r=t.clone().add(e,"days"),o=n.props.useWeekdaysShort?r.localeData().weekdaysShort(r):r.localeData().weekdaysMin(r);return v.default.createElement("div",{key:e,className:"react-datepicker__day-name"},o)}))},n.renderPreviousMonthButton=function(){if(n.props.forceShowMonthNavigation||!(0,_.allDaysDisabledBefore)(n.state.date,"month",n.props))return v.default.createElement("a",{className:"react-datepicker__navigation react-datepicker__navigation--previous",onClick:n.decreaseMonth})},n.renderNextMonthButton=function(){if(n.props.forceShowMonthNavigation||!(0,_.allDaysDisabledAfter)(n.state.date,"month",n.props))return v.default.createElement("a",{className:"react-datepicker__navigation react-datepicker__navigation--next",onClick:n.increaseMonth})},n.renderCurrentMonth=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:n.state.date,t=["react-datepicker__current-month"];return n.props.showYearDropdown&&t.push("react-datepicker__current-month--hasYearDropdown"),n.props.showMonthDropdown&&t.push("react-datepicker__current-month--hasMonthDropdown"),v.default.createElement("div",{className:t.join(" ")},e.format(n.props.dateFormat))},n.renderYearDropdown=function(){var e=arguments.length>0&&void 0!==arguments[0]&&arguments[0];if(n.props.showYearDropdown&&!e)return v.default.createElement(l.default,{dropdownMode:n.props.dropdownMode,onChange:n.changeYear,minDate:n.props.minDate,maxDate:n.props.maxDate,year:n.state.date.year(),scrollableYearDropdown:n.props.scrollableYearDropdown,yearDropdownItemNumber:n.props.yearDropdownItemNumber})},n.renderMonthDropdown=function(){arguments.length>0&&void 0!==arguments[0]&&arguments[0];if(n.props.showMonthDropdown)return v.default.createElement(d.default,{dropdownMode:n.props.dropdownMode,locale:n.props.locale,dateFormat:n.props.dateFormat,onChange:n.changeMonth,month:n.state.date.month()})},n.renderTodayButton=function(){if(n.props.todayButton)return v.default.createElement("div",{className:"react-datepicker__today-button",onClick:function(e){return n.props.onSelect(c.default.utc().utcOffset(n.props.utcOffset).startOf("date"),e)}},n.props.todayButton)},n.renderMonths=function(){for(var e=[],t=0;t<n.props.monthsShown;++t){var r=n.state.date.clone().add(t,"M"),o="month-"+t;e.push(v.default.createElement("div",{key:o,className:"react-datepicker__month-container"},v.default.createElement("div",{className:"react-datepicker__header"},n.renderCurrentMonth(r),v.default.createElement("div",{className:"react-datepicker__header__dropdown react-datepicker__header__dropdown--"+n.props.dropdownMode,onFocus:n.handleDropdownFocus},n.renderMonthDropdown(0!==t),n.renderYearDropdown(0!==t)),v.default.createElement("div",{className:"react-datepicker__day-names"},n.header(r))),v.default.createElement(m.default,{day:r,dayClassName:n.props.dayClassName,onDayClick:n.handleDayClick,onDayMouseEnter:n.handleDayMouseEnter,onMouseLeave:n.handleMonthMouseLeave,onWeekSelect:n.props.onWeekSelect,formatWeekNumber:n.props.formatWeekNumber,minDate:n.props.minDate,maxDate:n.props.maxDate,excludeDates:n.props.excludeDates,highlightDates:n.props.highlightDates,selectingDate:n.state.selectingDate,includeDates:n.props.includeDates,inline:n.props.inline,fixedHeight:n.props.fixedHeight,filterDate:n.props.filterDate,preSelection:n.props.preSelection,selected:n.props.selected,selectsStart:n.props.selectsStart,selectsEnd:n.props.selectsEnd,showWeekNumbers:n.props.showWeekNumbers,startDate:n.props.startDate,endDate:n.props.endDate,peekNextMonth:n.props.peekNextMonth,utcOffset:n.props.utcOffset})))}return e},n.state={date:n.localizeMoment(n.getDateInView()),selectingDate:null},n}return i(t,e),s(t,null,[{key:"defaultProps",get:function(){return{onDropdownFocus:function(){},utcOffset:c.default.utc().utcOffset(),monthsShown:1,forceShowMonthNavigation:!1}}}]),s(t,[{key:"componentWillReceiveProps",value:function(e){e.preSelection&&!(0,_.isSameDay)(e.preSelection,this.props.preSelection)?this.setState({date:this.localizeMoment(e.preSelection)}):e.openToDate&&!(0,_.isSameDay)(e.openToDate,this.props.openToDate)&&this.setState({date:this.localizeMoment(e.openToDate)})}},{key:"render",value:function(){return v.default.createElement("div",{className:(0,w.default)("react-datepicker",this.props.className)},v.default.createElement("div",{className:"react-datepicker__triangle"}),this.renderPreviousMonthButton(),this.renderNextMonthButton(),this.renderMonths(),this.renderTodayButton(),this.props.children)}}]),t}(v.default.Component);t.default=k},function(t,n){t.exports=e},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var s=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),p=n(4),c=r(p),u=n(5),l=(r(u),n(10)),f=r(l),d=n(12),h=r(d),m=(0,h.default)(f.default),y=function(e){function t(){var e,n,r,i;o(this,t);for(var s=arguments.length,p=Array(s),u=0;u<s;u++)p[u]=arguments[u];return n=r=a(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(p))),r.state={dropdownVisible:!1},r.renderSelectOptions=function(){for(var e=r.props.minDate?r.props.minDate.year():1900,t=r.props.maxDate?r.props.maxDate.year():2100,n=[],o=e;o<=t;o++)n.push(c.default.createElement("option",{key:o,value:o},o));return n},r.onSelectChange=function(e){r.onChange(e.target.value)},r.renderSelectMode=function(){return c.default.createElement("select",{value:r.props.year,className:"react-datepicker__year-select",onChange:r.onSelectChange},r.renderSelectOptions())},r.renderReadView=function(e){return c.default.createElement("div",{key:"read",style:{visibility:e?"visible":"hidden"},className:"react-datepicker__year-read-view",onClick:r.toggleDropdown},c.default.createElement("span",{className:"react-datepicker__year-read-view--down-arrow"}),c.default.createElement("span",{className:"react-datepicker__year-read-view--selected-year"},r.props.year))},r.renderDropdown=function(){return c.default.createElement(m,{key:"dropdown",ref:"options",year:r.props.year,onChange:r.onChange,onCancel:r.toggleDropdown,scrollableYearDropdown:r.props.scrollableYearDropdown,yearDropdownItemNumber:r.props.yearDropdownItemNumber})},r.renderScrollMode=function(){var e=r.state.dropdownVisible,t=[r.renderReadView(!e)];return e&&t.unshift(r.renderDropdown()),t},r.onChange=function(e){r.toggleDropdown(),e!==r.props.year&&r.props.onChange(e)},r.toggleDropdown=function(){r.setState({dropdownVisible:!r.state.dropdownVisible})},i=n,a(r,i)}return i(t,e),s(t,[{key:"render",value:function(){var e=void 0;switch(this.props.dropdownMode){case"scroll":e=this.renderScrollMode();break;case"select":e=this.renderSelectMode()}return c.default.createElement("div",{className:"react-datepicker__year-dropdown-container react-datepicker__year-dropdown-container--"+this.props.dropdownMode},e)}}]),t}(c.default.Component);t.default=y},function(e,n){e.exports=t},function(e,t,n){e.exports=n(6)()},function(e,t,n){"use strict";var r=n(7),o=n(8),a=n(9);e.exports=function(){function e(e,t,n,r,i,s){s!==a&&o(!1,"Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types")}function t(){return e}e.isRequired=e;var n={array:e,bool:e,func:e,number:e,object:e,string:e,symbol:e,any:e,arrayOf:t,element:e,instanceOf:t,node:e,objectOf:t,oneOf:t,oneOfType:t,shape:t};return n.checkPropTypes=r,n.PropTypes=n,n}},function(e,t){"use strict";function n(e){return function(){return e}}var r=function(){};r.thatReturns=n,r.thatReturnsFalse=n(!1),r.thatReturnsTrue=n(!0),r.thatReturnsNull=n(null),r.thatReturnsThis=function(){return this},r.thatReturnsArgument=function(e){return e},e.exports=r},function(e,t,n){"use strict";function r(e,t,n,r,a,i,s,p){if(o(t),!e){var c;if(void 0===t)c=new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var u=[n,r,a,i,s,p],l=0;c=new Error(t.replace(/%s/g,function(){return u[l++]})),c.name="Invariant Violation"}throw c.framesToPop=1,c}}var o=function(e){};e.exports=r},function(e,t){"use strict";var n="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";e.exports=n},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}function s(e,t){for(var n=[],r=0;r<2*t+1;r++)n.push(e+t-r);return n}Object.defineProperty(t,"__esModule",{value:!0});var p=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),c=n(4),u=r(c),l=n(5),f=(r(l),n(11)),d=r(f),h=function(e){function t(e){o(this,t);var n=a(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e));n.renderOptions=function(){var e=n.props.year,t=n.state.yearsList.map(function(t){return u.default.createElement("div",{className:"react-datepicker__year-option",key:t,ref:t,onClick:n.onChange.bind(n,t)},e===t?u.default.createElement("span",{className:"react-datepicker__year-option--selected"},"✓"):"",t)});return t.unshift(u.default.createElement("div",{className:"react-datepicker__year-option",ref:"upcoming",key:"upcoming",onClick:n.incrementYears},u.default.createElement("a",{className:"react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-upcoming"}))),t.push(u.default.createElement("div",{className:"react-datepicker__year-option",ref:"previous",key:"previous",onClick:n.decrementYears},u.default.createElement("a",{className:"react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-previous"}))),t},n.onChange=function(e){n.props.onChange(e)},n.handleClickOutside=function(){n.props.onCancel()},n.shiftYears=function(e){var t=n.state.yearsList.map(function(t){return t+e});n.setState({yearsList:t})},n.incrementYears=function(){return n.shiftYears(1)},n.decrementYears=function(){return n.shiftYears(-1)};var r=e.yearDropdownItemNumber,i=e.scrollableYearDropdown,p=r||(i?10:5);return n.state={yearsList:s(n.props.year,p)},n}return i(t,e),p(t,[{key:"render",value:function(){var e=(0,d.default)({"react-datepicker__year-dropdown":!0,"react-datepicker__year-dropdown--scrollable":this.props.scrollableYearDropdown});return u.default.createElement("div",{className:e},this.renderOptions())}}]),t}(u.default.Component);t.default=h},function(e,t,n){var r,o;/*!
	  Copyright (c) 2016 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
!function(){"use strict";function n(){for(var e=[],t=0;t<arguments.length;t++){var r=arguments[t];if(r){var o=typeof r;if("string"===o||"number"===o)e.push(r);else if(Array.isArray(r))e.push(n.apply(null,r));else if("object"===o)for(var i in r)a.call(r,i)&&r[i]&&e.push(i)}}return e.join(" ")}var a={}.hasOwnProperty;"undefined"!=typeof e&&e.exports?e.exports=n:(r=[],o=function(){return n}.apply(t,r),!(void 0!==o&&(e.exports=o)))}()},function(e,t){e.exports=n},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var s=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),p=n(4),c=r(p),u=n(5),l=(r(u),n(14)),f=r(l),d=n(12),h=r(d),m=n(2),y=r(m),v=(0,h.default)(f.default),b=function(e){function t(){var e,n,r,i;o(this,t);for(var s=arguments.length,p=Array(s),u=0;u<s;u++)p[u]=arguments[u];return n=r=a(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(p))),r.state={dropdownVisible:!1},r.renderSelectOptions=function(e){return e.map(function(e,t){return c.default.createElement("option",{key:t,value:t},e)})},r.renderSelectMode=function(e){return c.default.createElement("select",{value:r.props.month,className:"react-datepicker__month-select",onChange:function(e){return r.onChange(e.target.value)}},r.renderSelectOptions(e))},r.renderReadView=function(e,t){return c.default.createElement("div",{key:"read",style:{visibility:e?"visible":"hidden"},className:"react-datepicker__month-read-view",onClick:r.toggleDropdown},c.default.createElement("span",{className:"react-datepicker__month-read-view--selected-month"},t[r.props.month]),c.default.createElement("span",{className:"react-datepicker__month-read-view--down-arrow"}))},r.renderDropdown=function(e){return c.default.createElement(v,{key:"dropdown",ref:"options",month:r.props.month,monthNames:e,onChange:r.onChange,onCancel:r.toggleDropdown})},r.renderScrollMode=function(e){var t=r.state.dropdownVisible,n=[r.renderReadView(!t,e)];return t&&n.unshift(r.renderDropdown(e)),n},r.onChange=function(e){r.toggleDropdown(),e!==r.props.month&&r.props.onChange(e)},r.toggleDropdown=function(){return r.setState({dropdownVisible:!r.state.dropdownVisible})},i=n,a(r,i)}return i(t,e),s(t,[{key:"render",value:function(){var e=this,t=y.default.localeData(this.props.locale),n=[0,1,2,3,4,5,6,7,8,9,10,11].map(function(n){return t.months((0,y.default)({M:n}),e.props.dateFormat)}),r=void 0;switch(this.props.dropdownMode){case"scroll":r=this.renderScrollMode(n);break;case"select":r=this.renderSelectMode(n)}return c.default.createElement("div",{className:"react-datepicker__month-dropdown-container react-datepicker__month-dropdown-container--"+this.props.dropdownMode},r)}}]),t}(c.default.Component);t.default=b},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var s=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),p=n(4),c=r(p),u=n(5),l=(r(u),function(e){function t(){var e,n,r,i;o(this,t);for(var s=arguments.length,p=Array(s),u=0;u<s;u++)p[u]=arguments[u];return n=r=a(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(p))),r.renderOptions=function(){return r.props.monthNames.map(function(e,t){return c.default.createElement("div",{className:"react-datepicker__month-option",key:e,ref:e,onClick:r.onChange.bind(r,t)},r.props.month===t?c.default.createElement("span",{className:"react-datepicker__month-option--selected"},"✓"):"",e)})},r.onChange=function(e){return r.props.onChange(e)},r.handleClickOutside=function(){return r.props.onCancel()},i=n,a(r,i)}return i(t,e),s(t,[{key:"render",value:function(){return c.default.createElement("div",{className:"react-datepicker__month-dropdown"},this.renderOptions())}}]),t}(c.default.Component));t.default=l},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var s=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),p=n(4),c=r(p),u=n(5),l=(r(u),n(11)),f=r(l),d=n(16),h=r(d),m=6,y=function(e){function t(){var e,n,r,i;o(this,t);for(var s=arguments.length,p=Array(s),u=0;u<s;u++)p[u]=arguments[u];return n=r=a(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(p))),r.handleDayClick=function(e,t){r.props.onDayClick&&r.props.onDayClick(e,t)},r.handleDayMouseEnter=function(e){r.props.onDayMouseEnter&&r.props.onDayMouseEnter(e)},r.handleMouseLeave=function(){r.props.onMouseLeave&&r.props.onMouseLeave()},r.isWeekInMonth=function(e){var t=r.props.day,n=e.clone().add(6,"days");return e.isSame(t,"month")||n.isSame(t,"month")},r.renderWeeks=function(){for(var e=[],t=r.props.fixedHeight,n=r.props.day.clone().startOf("month").startOf("week"),o=0,a=!1;;){if(e.push(c.default.createElement(h.default,{key:o,day:n,month:r.props.day.month(),onDayClick:r.handleDayClick,onDayMouseEnter:r.handleDayMouseEnter,onWeekSelect:r.props.onWeekSelect,formatWeekNumber:r.props.formatWeekNumber,minDate:r.props.minDate,maxDate:r.props.maxDate,excludeDates:r.props.excludeDates,includeDates:r.props.includeDates,inline:r.props.inline,highlightDates:r.props.highlightDates,selectingDate:r.props.selectingDate,filterDate:r.props.filterDate,preSelection:r.props.preSelection,selected:r.props.selected,selectsStart:r.props.selectsStart,selectsEnd:r.props.selectsEnd,showWeekNumber:r.props.showWeekNumbers,startDate:r.props.startDate,endDate:r.props.endDate,dayClassName:r.props.dayClassName,utcOffset:r.props.utcOffset})),a)break;o++,n=n.clone().add(1,"weeks");var i=t&&o>=m,s=!t&&!r.isWeekInMonth(n);if(i||s){if(!r.props.peekNextMonth)break;a=!0}}return e},r.getClassNames=function(){var e=r.props,t=e.selectingDate,n=e.selectsStart,o=e.selectsEnd;return(0,f.default)("react-datepicker__month",{"react-datepicker__month--selecting-range":t&&(n||o)})},i=n,a(r,i)}return i(t,e),s(t,[{key:"render",value:function(){return c.default.createElement("div",{className:this.getClassNames(),onMouseLeave:this.handleMouseLeave,role:"listbox"},this.renderWeeks())}}]),t}(c.default.Component);t.default=y},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var s=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),p=n(4),c=r(p),u=n(5),l=(r(u),n(17)),f=r(l),d=n(19),h=r(d),m=function(e){function t(){var e,n,r,i;o(this,t);for(var s=arguments.length,p=Array(s),u=0;u<s;u++)p[u]=arguments[u];return n=r=a(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(p))),r.handleDayClick=function(e,t){r.props.onDayClick&&r.props.onDayClick(e,t)},r.handleDayMouseEnter=function(e){r.props.onDayMouseEnter&&r.props.onDayMouseEnter(e)},r.handleWeekClick=function(e,t,n){"function"==typeof r.props.onWeekSelect&&r.props.onWeekSelect(e,t,n)},r.formatWeekNumber=function(e){return r.props.formatWeekNumber?r.props.formatWeekNumber(e):parseInt(e.format("w"),10)},r.renderDays=function(){var e=r.props.day.clone().startOf("week"),t=[],n=r.formatWeekNumber(e);if(r.props.showWeekNumber){var o=r.props.onWeekSelect?r.handleWeekClick.bind(r,e,n):void 0;t.push(c.default.createElement(h.default,{key:"W",weekNumber:n,onClick:o}))}return t.concat([0,1,2,3,4,5,6].map(function(t){var n=e.clone().add(t,"days");return c.default.createElement(f.default,{key:t,day:n,month:r.props.month,onClick:r.handleDayClick.bind(r,n),onMouseEnter:r.handleDayMouseEnter.bind(r,n),minDate:r.props.minDate,maxDate:r.props.maxDate,excludeDates:r.props.excludeDates,includeDates:r.props.includeDates,inline:r.props.inline,highlightDates:r.props.highlightDates,selectingDate:r.props.selectingDate,filterDate:r.props.filterDate,preSelection:r.props.preSelection,selected:r.props.selected,selectsStart:r.props.selectsStart,selectsEnd:r.props.selectsEnd,startDate:r.props.startDate,endDate:r.props.endDate,dayClassName:r.props.dayClassName,utcOffset:r.props.utcOffset})}))},i=n,a(r,i)}return i(t,e),s(t,[{key:"render",value:function(){return c.default.createElement("div",{className:"react-datepicker__week"},this.renderDays())}}]),t}(c.default.Component);t.default=m},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t,n){return t in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function s(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var p="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},c=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),u=n(2),l=r(u),f=n(4),d=r(f),h=n(5),m=(r(h),n(11)),y=r(m),v=n(18),b=function(e){function t(){var e,n,r,s;a(this,t);for(var c=arguments.length,u=Array(c),f=0;f<c;f++)u[f]=arguments[f];return n=r=i(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(u))),r.handleClick=function(e){!r.isDisabled()&&r.props.onClick&&r.props.onClick(e)},r.handleMouseEnter=function(e){!r.isDisabled()&&r.props.onMouseEnter&&r.props.onMouseEnter(e)},r.isSameDay=function(e){return(0,v.isSameDay)(r.props.day,e)},r.isKeyboardSelected=function(){return!r.props.inline&&!r.isSameDay(r.props.selected)&&r.isSameDay(r.props.preSelection)},r.isDisabled=function(){return(0,v.isDayDisabled)(r.props.day,r.props)},r.getHighLightedClass=function(e){var t=r.props,n=t.day,a=t.highlightDates;if(!a)return o({},e,!1);for(var i={},s=0,c=a.length;s<c;s++){var u=a[s];if(u instanceof l.default)(0,v.isSameDay)(n,u)&&(i[e]=!0);else if("object"===("undefined"==typeof u?"undefined":p(u))){var f=Object.keys(u),d=u[f[0]];if("string"==typeof f[0]&&d.constructor===Array)for(var h=0,m=d.length;h<m;h++)(0,v.isSameDay)(n,d[h])&&(i[f[0]]=!0)}}return i},r.isInRange=function(){var e=r.props,t=e.day,n=e.startDate,o=e.endDate;return!(!n||!o)&&(0,v.isDayInRange)(t,n,o)},r.isInSelectingRange=function(){var e=r.props,t=e.day,n=e.selectsStart,o=e.selectsEnd,a=e.selectingDate,i=e.startDate,s=e.endDate;return!(!n&&!o||!a||r.isDisabled())&&(n&&s&&a.isSameOrBefore(s)?(0,v.isDayInRange)(t,a,s):!!(o&&i&&a.isSameOrAfter(i))&&(0,v.isDayInRange)(t,i,a))},r.isSelectingRangeStart=function(){if(!r.isInSelectingRange())return!1;var e=r.props,t=e.day,n=e.selectingDate,o=e.startDate,a=e.selectsStart;return a?(0,v.isSameDay)(t,n):(0,v.isSameDay)(t,o)},r.isSelectingRangeEnd=function(){if(!r.isInSelectingRange())return!1;var e=r.props,t=e.day,n=e.selectingDate,o=e.endDate,a=e.selectsEnd;return a?(0,v.isSameDay)(t,n):(0,v.isSameDay)(t,o)},r.isRangeStart=function(){var e=r.props,t=e.day,n=e.startDate,o=e.endDate;return!(!n||!o)&&(0,v.isSameDay)(n,t)},r.isRangeEnd=function(){var e=r.props,t=e.day,n=e.startDate,o=e.endDate;return!(!n||!o)&&(0,v.isSameDay)(o,t)},r.isWeekend=function(){var e=r.props.day.day();return 0===e||6===e},r.isOutsideMonth=function(){return void 0!==r.props.month&&r.props.month!==r.props.day.month()},r.getClassNames=function(e){var t=r.props.dayClassName?r.props.dayClassName(e):void 0;return(0,y.default)("react-datepicker__day",t,"react-datepicker__day--"+(0,v.getDayOfWeekCode)(r.props.day),{"react-datepicker__day--disabled":r.isDisabled(),"react-datepicker__day--selected":r.isSameDay(r.props.selected),"react-datepicker__day--keyboard-selected":r.isKeyboardSelected(),"react-datepicker__day--range-start":r.isRangeStart(),"react-datepicker__day--range-end":r.isRangeEnd(),"react-datepicker__day--in-range":r.isInRange(),"react-datepicker__day--in-selecting-range":r.isInSelectingRange(),"react-datepicker__day--selecting-range-start":r.isSelectingRangeStart(),"react-datepicker__day--selecting-range-end":r.isSelectingRangeEnd(),"react-datepicker__day--today":r.isSameDay(l.default.utc().utcOffset(r.props.utcOffset)),"react-datepicker__day--weekend":r.isWeekend(),"react-datepicker__day--outside-month":r.isOutsideMonth()},r.getHighLightedClass("react-datepicker__day--highlighted"))},s=n,i(r,s)}return s(t,e),c(t,[{key:"render",value:function(){return d.default.createElement("div",{className:this.getClassNames(this.props.day),onClick:this.handleClick,onMouseEnter:this.handleMouseEnter,"aria-label":"day-"+this.props.day.date(),role:"option"},this.props.day.date())}}]),t}(d.default.Component);b.defaultProps={utcOffset:l.default.utc().utcOffset()},t.default=b},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){return e&&t?e.isSame(t,"day"):!e&&!t}function a(e,t){return e&&t?e.utcOffset()===t.utcOffset():!e&&!t}function i(e,t,n){var r=t.clone().startOf("day").subtract(1,"seconds"),o=n.clone().startOf("day").add(1,"seconds");return e.clone().startOf("day").isBetween(r,o)}function s(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=t.minDate,r=t.maxDate,a=t.excludeDates,i=t.includeDates,s=t.filterDate;return n&&e.isBefore(n,"day")||r&&e.isAfter(r,"day")||a&&a.some(function(t){return o(e,t)})||i&&!i.some(function(t){return o(e,t)})||s&&!s(e.clone())||!1}function p(e,t){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{},r=n.minDate,o=n.includeDates,a=e.clone().subtract(1,t);return r&&a.isBefore(r,t)||o&&o.every(function(e){return a.isBefore(e,t)})||!1}function c(e,t){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{},r=n.maxDate,o=n.includeDates,a=e.clone().add(1,t);return r&&a.isAfter(r,t)||o&&o.every(function(e){return a.isAfter(e,t)})||!1}function u(e){var t=e.minDate,n=e.includeDates;return n&&t?y.default.min(n.filter(function(e){return t.isSameOrBefore(e,"day")})):n?y.default.min(n):t}function l(e){var t=e.maxDate,n=e.includeDates;return n&&t?y.default.max(n.filter(function(e){return t.isSameOrAfter(e,"day")})):n?y.default.max(n):t}function f(e,t){var n=t.dateFormat,r=t.locale,o=(0,y.default)(e,n,r||y.default.locale(),!0);return o.isValid()?o:null}function d(e,t){var n=t.dateFormat,r=t.locale;return e&&e.clone().locale(r||y.default.locale()).format(Array.isArray(n)?n[0]:n)||""}function h(e){return v[e.isoWeekday()]}Object.defineProperty(t,"__esModule",{value:!0}),t.isSameDay=o,t.isSameUtcOffset=a,t.isDayInRange=i,t.isDayDisabled=s,t.allDaysDisabledBefore=p,t.allDaysDisabledAfter=c,t.getEffectiveMinDate=u,t.getEffectiveMaxDate=l,t.parseDate=f,t.safeDateFormat=d,t.getDayOfWeekCode=h;var m=n(2),y=r(m),v={1:"mon",2:"tue",3:"wed",4:"thu",5:"fri",6:"sat",7:"sun"}},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var s=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),p=n(4),c=r(p),u=n(5),l=(r(u),n(11)),f=r(l),d=function(e){function t(){var e,n,r,i;o(this,t);for(var s=arguments.length,p=Array(s),c=0;c<s;c++)p[c]=arguments[c];return n=r=a(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(p))),r.handleClick=function(e){r.props.onClick&&r.props.onClick(e)},i=n,a(r,i)}return i(t,e),s(t,[{key:"render",value:function(){var e={"react-datepicker__week-number":!0,"react-datepicker__week-number--clickable":!!this.props.onClick};return c.default.createElement("div",{className:(0,f.default)(e),"aria-label":"week-"+this.props.weekNumber,onClick:this.handleClick},this.props.weekNumber)}}]),t}(c.default.Component);t.default=d},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0}),t.popperPlacementPositions=void 0;var s=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),p=n(4),c=r(p),u=n(5),l=(r(u),n(21)),f=(t.popperPlacementPositions=["auto","auto-left","auto-right","bottom","bottom-end","bottom-start","left","left-end","left-start","right","right-end","right-start","top","top-end","top-start"],function(e){function t(){return o(this,t),a(this,(t.__proto__||Object.getPrototypeOf(t)).apply(this,arguments))}return i(t,e),s(t,[{key:"render",value:function(){var e=this.props,t=e.hidePopper,n=e.popperComponent,r=e.popperModifiers,o=e.popperPlacement,a=e.targetComponent;return c.default.createElement(l.Manager,null,c.default.createElement(l.Target,{className:"react-datepicker-wrapper"},a),!t&&c.default.createElement(l.Popper,{className:"react-datepicker-popper",modifiers:r,placement:o},n))}}],[{key:"defaultProps",get:function(){return{hidePopper:!0,popperModifiers:{preventOverflow:{enabled:!0,escapeWithReference:!0,boundariesElement:"viewport"}},popperPlacement:"bottom-start"}}}]),t}(c.default.Component));t.default=f},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0}),t.Arrow=t.Popper=t.Target=t.Manager=void 0;var o=n(22),a=r(o),i=n(23),s=r(i),p=n(24),c=r(p),u=n(28),l=r(u);t.Manager=a.default,t.Target=s.default,t.Popper=c.default,t.Arrow=l.default},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){var n={};for(var r in e)t.indexOf(r)>=0||Object.prototype.hasOwnProperty.call(e,r)&&(n[r]=e[r]);return n}function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function s(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var p=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),c=n(4),u=(r(c),n(5)),l=r(u),f=function(e){function t(){var e,n,r,o;a(this,t);for(var s=arguments.length,p=Array(s),c=0;c<s;c++)p[c]=arguments[c];return n=r=i(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(p))),r._setTargetNode=function(e){r._targetNode=e},r._getTargetNode=function(){return r._targetNode},o=n,i(r,o)}return s(t,e),p(t,[{key:"getChildContext",value:function(){return{popperManager:{setTargetNode:this._setTargetNode,getTargetNode:this._getTargetNode}}}},{key:"render",value:function(){var e=this.props,t=e.tag,n=e.children,r=o(e,["tag","children"]);return t!==!1?(0,c.createElement)(t,r,n):n}}]),t}(c.Component);f.childContextTypes={popperManager:l.default.object.isRequired},f.propTypes={tag:l.default.oneOfType([l.default.string,l.default.bool])},f.defaultProps={tag:"div"},t.default=f},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){var n={};for(var r in e)t.indexOf(r)>=0||Object.prototype.hasOwnProperty.call(e,r)&&(n[r]=e[r]);return n}Object.defineProperty(t,"__esModule",{value:!0});var a=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},i=n(4),s=(r(i),n(5)),p=r(s),c=function(e,t){var n=e.component,r=void 0===n?"div":n,s=e.innerRef,p=e.children,c=o(e,["component","innerRef","children"]),u=t.popperManager,l=function(e){u.setTargetNode(e),"function"==typeof s&&s(e)};if("function"==typeof p){var f={ref:l};return p({targetProps:f,restProps:c})}var d=a({},c);return"string"==typeof r?d.ref=l:d.innerRef=l,(0,i.createElement)(r,d,p)};c.contextTypes={popperManager:p.default.object.isRequired},c.propTypes={component:p.default.oneOfType([p.default.node,p.default.func]),innerRef:p.default.func,children:p.default.oneOfType([p.default.node,p.default.func])},t.default=c},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t,n){return t in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}function a(e,t){var n={};for(var r in e)t.indexOf(r)>=0||Object.prototype.hasOwnProperty.call(e,r)&&(n[r]=e[r]);return n}function i(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function s(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function p(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var c=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},u=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),l=n(4),f=(r(l),n(5)),d=r(f),h=n(25),m=r(h),y=n(26),v=r(y),b=function(e){function t(){var e,n,r,o;i(this,t);for(var a=arguments.length,p=Array(a),u=0;u<a;u++)p[u]=arguments[u];return n=r=s(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(p))),r.state={},r._setArrowNode=function(e){r._arrowNode=e},r._getTargetNode=function(){return r.context.popperManager.getTargetNode()},r._updateStateModifier={enabled:!0,order:900,fn:function(e){return(r.state.data&&!(0,v.default)(e.offsets,r.state.data.offsets)||!r.state.data)&&r.setState({data:e}),e}},r._getPopperStyle=function(){var e=r.state.data;if(!r._popper||!e)return{position:"absolute",pointerEvents:"none",opacity:0};var t=e.offsets.popper,n=(t.top,t.left,t.position);return c({position:n},e.styles)},r._getPopperPlacement=function(){return r.state.data?r.state.data.placement:void 0},r._getArrowStyle=function(){if(r.state.data&&r.state.data.offsets.arrow){var e=r.state.data.offsets.arrow,t=e.top,n=e.left;return{top:t,left:n}}return{}},o=n,s(r,o)}return p(t,e),u(t,[{key:"getChildContext",value:function(){return{popper:{setArrowNode:this._setArrowNode,getArrowStyle:this._getArrowStyle}}}},{key:"componentDidMount",value:function(){this._updatePopper()}},{key:"componentDidUpdate",value:function(e){e.placement===this.props.placement&&e.eventsEnabled===this.props.eventsEnabled||this._updatePopper(),this._popper&&e.children!==this.props.children&&this._popper.scheduleUpdate()}},{key:"componentWillUnmount",value:function(){this._destroyPopper()}},{key:"_updatePopper",value:function(){this._destroyPopper(),this._node&&this._createPopper()}},{key:"_createPopper",value:function(){var e=this.props,t=e.placement,n=e.eventsEnabled,r=c({},this.props.modifiers,{applyStyle:{enabled:!1},updateState:this._updateStateModifier});this._arrowNode&&(r.arrow={element:this._arrowNode}),this._popper=new m.default(this._getTargetNode(),this._node,{placement:t,eventsEnabled:n,modifiers:r}),this._popper.scheduleUpdate()}},{key:"_destroyPopper",value:function(){this._popper&&this._popper.destroy()}},{key:"render",value:function(){var e=this,t=this.props,n=t.component,r=t.innerRef,i=(t.placement,t.eventsEnabled,t.modifiers,t.children),s=a(t,["component","innerRef","placement","eventsEnabled","modifiers","children"]),p=function(t){e._node=t,"function"==typeof r&&r(t)},u=this._getPopperStyle(),f=this._getPopperPlacement();if("function"==typeof i){var d=o({ref:p,style:u},"data-placement",f);return i({popperProps:d,restProps:s,scheduleUpdate:this._popper&&this._popper.scheduleUpdate})}var h=c({},s,{style:c({},s.style,u),"data-placement":f});return"string"==typeof n?h.ref=p:h.innerRef=p,(0,l.createElement)(n,h,i)}}]),t}(l.Component);b.contextTypes={popperManager:d.default.object.isRequired},b.childContextTypes={popper:d.default.object.isRequired},b.propTypes={component:d.default.oneOfType([d.default.node,d.default.func]),innerRef:d.default.func,placement:d.default.oneOf(m.default.placements),eventsEnabled:d.default.bool,modifiers:d.default.object,children:d.default.oneOfType([d.default.node,d.default.func])},b.defaultProps={component:"div",placement:"bottom",eventsEnabled:!0,modifiers:{}},t.default=b},function(e,t,n){(function(t){/**!
	 * @fileOverview Kickass library to create and place poppers near their reference elements.
	 * @version 1.12.3
	 * @license
	 * Copyright (c) 2016 Federico Zivolo and contributors
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy
	 * of this software and associated documentation files (the "Software"), to deal
	 * in the Software without restriction, including without limitation the rights
	 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	 * copies of the Software, and to permit persons to whom the Software is
	 * furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all
	 * copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
	 * SOFTWARE.
	 */
!function(t,n){e.exports=n()}(this,function(){"use strict";function e(e){var t=!1,n=0,r=document.createElement("span"),o=new MutationObserver(function(){e(),t=!1});return o.observe(r,{attributes:!0}),function(){t||(t=!0,r.setAttribute("x-index",n),n+=1)}}function n(e){var t=!1;return function(){t||(t=!0,setTimeout(function(){t=!1,e()},ce))}}function r(e){var t={};return e&&"[object Function]"===t.toString.call(e)}function o(e,t){if(1!==e.nodeType)return[];var n=window.getComputedStyle(e,null);return t?n[t]:n}function a(e){return"HTML"===e.nodeName?e:e.parentNode||e.host}function i(e){if(!e||["HTML","BODY","#document"].indexOf(e.nodeName)!==-1)return window.document.body;var t=o(e),n=t.overflow,r=t.overflowX,s=t.overflowY;return/(auto|scroll)/.test(n+s+r)?e:i(a(e))}function s(e){var t=e&&e.offsetParent,n=t&&t.nodeName;return n&&"BODY"!==n&&"HTML"!==n?["TD","TABLE"].indexOf(t.nodeName)!==-1&&"static"===o(t,"position")?s(t):t:window.document.documentElement}function p(e){var t=e.nodeName;return"BODY"!==t&&("HTML"===t||s(e.firstElementChild)===e)}function c(e){return null!==e.parentNode?c(e.parentNode):e}function u(e,t){if(!(e&&e.nodeType&&t&&t.nodeType))return window.document.documentElement;var n=e.compareDocumentPosition(t)&Node.DOCUMENT_POSITION_FOLLOWING,r=n?e:t,o=n?t:e,a=document.createRange();a.setStart(r,0),a.setEnd(o,0);var i=a.commonAncestorContainer;if(e!==i&&t!==i||r.contains(o))return p(i)?i:s(i);var l=c(e);return l.host?u(l.host,t):u(e,c(t).host)}function l(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"top",n="top"===t?"scrollTop":"scrollLeft",r=e.nodeName;if("BODY"===r||"HTML"===r){var o=window.document.documentElement,a=window.document.scrollingElement||o;return a[n]}return e[n]}function f(e,t){var n=arguments.length>2&&void 0!==arguments[2]&&arguments[2],r=l(t,"top"),o=l(t,"left"),a=n?-1:1;return e.top+=r*a,e.bottom+=r*a,e.left+=o*a,e.right+=o*a,e}function d(e,t){var n="x"===t?"Left":"Top",r="Left"===n?"Right":"Bottom";return+e["border"+n+"Width"].split("px")[0]+ +e["border"+r+"Width"].split("px")[0]}function h(e,t,n,r){return Math.max(t["offset"+e],t["scroll"+e],n["client"+e],n["offset"+e],n["scroll"+e],he()?n["offset"+e]+r["margin"+("Height"===e?"Top":"Left")]+r["margin"+("Height"===e?"Bottom":"Right")]:0)}function m(){var e=window.document.body,t=window.document.documentElement,n=he()&&window.getComputedStyle(t);return{height:h("Height",e,t,n),width:h("Width",e,t,n)}}function y(e){return be({},e,{right:e.left+e.width,bottom:e.top+e.height})}function v(e){var t={};if(he())try{t=e.getBoundingClientRect();var n=l(e,"top"),r=l(e,"left");t.top+=n,t.left+=r,t.bottom+=n,t.right+=r}catch(e){}else t=e.getBoundingClientRect();var a={left:t.left,top:t.top,width:t.right-t.left,height:t.bottom-t.top},i="HTML"===e.nodeName?m():{},s=i.width||e.clientWidth||a.right-a.left,p=i.height||e.clientHeight||a.bottom-a.top,c=e.offsetWidth-s,u=e.offsetHeight-p;if(c||u){var f=o(e);c-=d(f,"x"),u-=d(f,"y"),a.width-=c,a.height-=u}return y(a)}function b(e,t){var n=he(),r="HTML"===t.nodeName,a=v(e),s=v(t),p=i(e),c=o(t),u=+c.borderTopWidth.split("px")[0],l=+c.borderLeftWidth.split("px")[0],d=y({top:a.top-s.top-u,left:a.left-s.left-l,width:a.width,height:a.height});if(d.marginTop=0,d.marginLeft=0,!n&&r){var h=+c.marginTop.split("px")[0],m=+c.marginLeft.split("px")[0];d.top-=u-h,d.bottom-=u-h,d.left-=l-m,d.right-=l-m,d.marginTop=h,d.marginLeft=m}return(n?t.contains(p):t===p&&"BODY"!==p.nodeName)&&(d=f(d,t)),d}function g(e){var t=window.document.documentElement,n=b(e,t),r=Math.max(t.clientWidth,window.innerWidth||0),o=Math.max(t.clientHeight,window.innerHeight||0),a=l(t),i=l(t,"left"),s={top:a-n.top+n.marginTop,left:i-n.left+n.marginLeft,width:r,height:o};return y(s)}function w(e){var t=e.nodeName;return"BODY"!==t&&"HTML"!==t&&("fixed"===o(e,"position")||w(a(e)))}function _(e,t,n,r){var o={top:0,left:0},s=u(e,t);if("viewport"===r)o=g(s);else{var p=void 0;"scrollParent"===r?(p=i(a(e)),"BODY"===p.nodeName&&(p=window.document.documentElement)):p="window"===r?window.document.documentElement:r;var c=b(p,s);if("HTML"!==p.nodeName||w(s))o=c;else{var l=m(),f=l.height,d=l.width;o.top+=c.top-c.marginTop,o.bottom=f+c.top,o.left+=c.left-c.marginLeft,o.right=d+c.left}}return o.left+=n,o.top+=n,o.right-=n,o.bottom-=n,o}function D(e){var t=e.width,n=e.height;return t*n}function O(e,t,n,r,o){var a=arguments.length>5&&void 0!==arguments[5]?arguments[5]:0;if(e.indexOf("auto")===-1)return e;var i=_(n,r,a,o),s={top:{width:i.width,height:t.top-i.top},right:{width:i.right-t.right,height:i.height},bottom:{width:i.width,height:i.bottom-t.bottom},left:{width:t.left-i.left,height:i.height}},p=Object.keys(s).map(function(e){return be({key:e},s[e],{area:D(s[e])})}).sort(function(e,t){return t.area-e.area}),c=p.filter(function(e){var t=e.width,r=e.height;return t>=n.clientWidth&&r>=n.clientHeight}),u=c.length>0?c[0].key:p[0].key,l=e.split("-")[1];return u+(l?"-"+l:"")}function k(e,t,n){var r=u(t,n);return b(n,r)}function E(e){var t=window.getComputedStyle(e),n=parseFloat(t.marginTop)+parseFloat(t.marginBottom),r=parseFloat(t.marginLeft)+parseFloat(t.marginRight),o={width:e.offsetWidth+r,height:e.offsetHeight+n};return o}function S(e){var t={left:"right",right:"left",bottom:"top",top:"bottom"};return e.replace(/left|right|bottom|top/g,function(e){return t[e]})}function C(e,t,n){n=n.split("-")[0];var r=E(e),o={width:r.width,height:r.height},a=["right","left"].indexOf(n)!==-1,i=a?"top":"left",s=a?"left":"top",p=a?"height":"width",c=a?"width":"height";return o[i]=t[i]+t[p]/2-r[p]/2,n===s?o[s]=t[s]-r[c]:o[s]=t[S(s)],o}function M(e,t){return Array.prototype.find?e.find(t):e.filter(t)[0]}function P(e,t,n){if(Array.prototype.findIndex)return e.findIndex(function(e){return e[t]===n});var r=M(e,function(e){return e[t]===n});return e.indexOf(r)}function N(e,t,n){var o=void 0===n?e:e.slice(0,P(e,"name",n));return o.forEach(function(e){e.function&&console.warn("`modifier.function` is deprecated, use `modifier.fn`!");var n=e.function||e.fn;e.enabled&&r(n)&&(t.offsets.popper=y(t.offsets.popper),t.offsets.reference=y(t.offsets.reference),t=n(t,e))}),t}function x(){if(!this.state.isDestroyed){var e={instance:this,styles:{},arrowStyles:{},attributes:{},flipped:!1,offsets:{}};e.offsets.reference=k(this.state,this.popper,this.reference),e.placement=O(this.options.placement,e.offsets.reference,this.popper,this.reference,this.options.modifiers.flip.boundariesElement,this.options.modifiers.flip.padding),e.originalPlacement=e.placement,e.offsets.popper=C(this.popper,e.offsets.reference,e.placement),e.offsets.popper.position="absolute",e=N(this.modifiers,e),this.state.isCreated?this.options.onUpdate(e):(this.state.isCreated=!0,this.options.onCreate(e))}}function j(e,t){return e.some(function(e){var n=e.name,r=e.enabled;return r&&n===t})}function T(e){for(var t=[!1,"ms","Webkit","Moz","O"],n=e.charAt(0).toUpperCase()+e.slice(1),r=0;r<t.length-1;r++){var o=t[r],a=o?""+o+n:e;if("undefined"!=typeof window.document.body.style[a])return a}return null}function R(){return this.state.isDestroyed=!0,j(this.modifiers,"applyStyle")&&(this.popper.removeAttribute("x-placement"),this.popper.style.left="",this.popper.style.position="",this.popper.style.top="",this.popper.style[T("transform")]=""),this.disableEventListeners(),this.options.removeOnDestroy&&this.popper.parentNode.removeChild(this.popper),this}function W(e,t,n,r){var o="BODY"===e.nodeName,a=o?window:e;a.addEventListener(t,n,{passive:!0}),o||W(i(a.parentNode),t,n,r),r.push(a)}function L(e,t,n,r){n.updateBound=r,window.addEventListener("resize",n.updateBound,{passive:!0});var o=i(e);return W(o,"scroll",n.updateBound,n.scrollParents),n.scrollElement=o,n.eventsEnabled=!0,n}function F(){this.state.eventsEnabled||(this.state=L(this.reference,this.options,this.state,this.scheduleUpdate))}function I(e,t){return window.removeEventListener("resize",t.updateBound),t.scrollParents.forEach(function(e){e.removeEventListener("scroll",t.updateBound)}),t.updateBound=null,t.scrollParents=[],t.scrollElement=null,t.eventsEnabled=!1,t}function A(){this.state.eventsEnabled&&(window.cancelAnimationFrame(this.scheduleUpdate),this.state=I(this.reference,this.state))}function B(e){return""!==e&&!isNaN(parseFloat(e))&&isFinite(e)}function Y(e,t){Object.keys(t).forEach(function(n){var r="";["width","height","top","right","bottom","left"].indexOf(n)!==-1&&B(t[n])&&(r="px"),e.style[n]=t[n]+r})}function H(e,t){Object.keys(t).forEach(function(n){var r=t[n];r!==!1?e.setAttribute(n,t[n]):e.removeAttribute(n)})}function U(e){return Y(e.instance.popper,e.styles),H(e.instance.popper,e.attributes),e.arrowElement&&Object.keys(e.arrowStyles).length&&Y(e.arrowElement,e.arrowStyles),e}function V(e,t,n,r,o){var a=k(o,t,e),i=O(n.placement,a,t,e,n.modifiers.flip.boundariesElement,n.modifiers.flip.padding);return t.setAttribute("x-placement",i),Y(t,{position:"absolute"}),n}function q(e,t){var n=t.x,r=t.y,o=e.offsets.popper,a=M(e.instance.modifiers,function(e){return"applyStyle"===e.name}).gpuAcceleration;void 0!==a&&console.warn("WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!");var i=void 0!==a?a:t.gpuAcceleration,p=s(e.instance.popper),c=v(p),u={position:o.position},l={left:Math.floor(o.left),top:Math.floor(o.top),bottom:Math.floor(o.bottom),right:Math.floor(o.right)},f="bottom"===n?"top":"bottom",d="right"===r?"left":"right",h=T("transform"),m=void 0,y=void 0;if(y="bottom"===f?-c.height+l.bottom:l.top,m="right"===d?-c.width+l.right:l.left,i&&h)u[h]="translate3d("+m+"px, "+y+"px, 0)",u[f]=0,u[d]=0,u.willChange="transform";else{var b="bottom"===f?-1:1,g="right"===d?-1:1;u[f]=y*b,u[d]=m*g,u.willChange=f+", "+d}var w={"x-placement":e.placement};return e.attributes=be({},w,e.attributes),e.styles=be({},u,e.styles),e.arrowStyles=be({},e.offsets.arrow,e.arrowStyles),e}function K(e,t,n){var r=M(e,function(e){var n=e.name;return n===t}),o=!!r&&e.some(function(e){return e.name===n&&e.enabled&&e.order<r.order});if(!o){var a="`"+t+"`",i="`"+n+"`";console.warn(i+" modifier is required by "+a+" modifier in order to work, be sure to include it before "+a+"!")}return o}function z(e,t){if(!K(e.instance.modifiers,"arrow","keepTogether"))return e;var n=t.element;if("string"==typeof n){if(n=e.instance.popper.querySelector(n),!n)return e}else if(!e.instance.popper.contains(n))return console.warn("WARNING: `arrow.element` must be child of its popper element!"),e;var r=e.placement.split("-")[0],a=e.offsets,i=a.popper,s=a.reference,p=["left","right"].indexOf(r)!==-1,c=p?"height":"width",u=p?"Top":"Left",l=u.toLowerCase(),f=p?"left":"top",d=p?"bottom":"right",h=E(n)[c];s[d]-h<i[l]&&(e.offsets.popper[l]-=i[l]-(s[d]-h)),s[l]+h>i[d]&&(e.offsets.popper[l]+=s[l]+h-i[d]);var m=s[l]+s[c]/2-h/2,v=o(e.instance.popper,"margin"+u).replace("px",""),b=m-y(e.offsets.popper)[l]-v;return b=Math.max(Math.min(i[c]-h,b),0),e.arrowElement=n,e.offsets.arrow={},e.offsets.arrow[l]=Math.round(b),e.offsets.arrow[f]="",e}function G(e){return"end"===e?"start":"start"===e?"end":e}function X(e){var t=arguments.length>1&&void 0!==arguments[1]&&arguments[1],n=we.indexOf(e),r=we.slice(n+1).concat(we.slice(0,n));return t?r.reverse():r}function J(e,t){if(j(e.instance.modifiers,"inner"))return e;if(e.flipped&&e.placement===e.originalPlacement)return e;var n=_(e.instance.popper,e.instance.reference,t.padding,t.boundariesElement),r=e.placement.split("-")[0],o=S(r),a=e.placement.split("-")[1]||"",i=[];switch(t.behavior){case _e.FLIP:i=[r,o];break;case _e.CLOCKWISE:i=X(r);break;case _e.COUNTERCLOCKWISE:i=X(r,!0);break;default:i=t.behavior}return i.forEach(function(s,p){if(r!==s||i.length===p+1)return e;r=e.placement.split("-")[0],o=S(r);var c=e.offsets.popper,u=e.offsets.reference,l=Math.floor,f="left"===r&&l(c.right)>l(u.left)||"right"===r&&l(c.left)<l(u.right)||"top"===r&&l(c.bottom)>l(u.top)||"bottom"===r&&l(c.top)<l(u.bottom),d=l(c.left)<l(n.left),h=l(c.right)>l(n.right),m=l(c.top)<l(n.top),y=l(c.bottom)>l(n.bottom),v="left"===r&&d||"right"===r&&h||"top"===r&&m||"bottom"===r&&y,b=["top","bottom"].indexOf(r)!==-1,g=!!t.flipVariations&&(b&&"start"===a&&d||b&&"end"===a&&h||!b&&"start"===a&&m||!b&&"end"===a&&y);(f||v||g)&&(e.flipped=!0,(f||v)&&(r=i[p+1]),g&&(a=G(a)),e.placement=r+(a?"-"+a:""),e.offsets.popper=be({},e.offsets.popper,C(e.instance.popper,e.offsets.reference,e.placement)),e=N(e.instance.modifiers,e,"flip"))}),e}function Q(e){var t=e.offsets,n=t.popper,r=t.reference,o=e.placement.split("-")[0],a=Math.floor,i=["top","bottom"].indexOf(o)!==-1,s=i?"right":"bottom",p=i?"left":"top",c=i?"width":"height";return n[s]<a(r[p])&&(e.offsets.popper[p]=a(r[p])-n[c]),n[p]>a(r[s])&&(e.offsets.popper[p]=a(r[s])),e}function Z(e,t,n,r){var o=e.match(/((?:\-|\+)?\d*\.?\d*)(.*)/),a=+o[1],i=o[2];if(!a)return e;if(0===i.indexOf("%")){var s=void 0;switch(i){case"%p":s=n;break;case"%":case"%r":default:s=r}var p=y(s);return p[t]/100*a}if("vh"===i||"vw"===i){var c=void 0;return c="vh"===i?Math.max(document.documentElement.clientHeight,window.innerHeight||0):Math.max(document.documentElement.clientWidth,window.innerWidth||0),c/100*a}return a}function $(e,t,n,r){var o=[0,0],a=["right","left"].indexOf(r)!==-1,i=e.split(/(\+|\-)/).map(function(e){return e.trim()}),s=i.indexOf(M(i,function(e){return e.search(/,|\s/)!==-1}));i[s]&&i[s].indexOf(",")===-1&&console.warn("Offsets separated by white space(s) are deprecated, use a comma (,) instead.");var p=/\s*,\s*|\s+/,c=s!==-1?[i.slice(0,s).concat([i[s].split(p)[0]]),[i[s].split(p)[1]].concat(i.slice(s+1))]:[i];return c=c.map(function(e,r){var o=(1===r?!a:a)?"height":"width",i=!1;return e.reduce(function(e,t){return""===e[e.length-1]&&["+","-"].indexOf(t)!==-1?(e[e.length-1]=t,i=!0,e):i?(e[e.length-1]+=t,i=!1,e):e.concat(t)},[]).map(function(e){return Z(e,o,t,n)})}),c.forEach(function(e,t){e.forEach(function(n,r){B(n)&&(o[t]+=n*("-"===e[r-1]?-1:1))})}),o}function ee(e,t){var n=t.offset,r=e.placement,o=e.offsets,a=o.popper,i=o.reference,s=r.split("-")[0],p=void 0;return p=B(+n)?[+n,0]:$(n,a,i,s),"left"===s?(a.top+=p[0],a.left-=p[1]):"right"===s?(a.top+=p[0],a.left+=p[1]):"top"===s?(a.left+=p[0],a.top-=p[1]):"bottom"===s&&(a.left+=p[0],a.top+=p[1]),e.popper=a,e}function te(e,t){var n=t.boundariesElement||s(e.instance.popper);e.instance.reference===n&&(n=s(n));var r=_(e.instance.popper,e.instance.reference,t.padding,n);t.boundaries=r;var o=t.priority,a=e.offsets.popper,i={primary:function(e){var n=a[e];return a[e]<r[e]&&!t.escapeWithReference&&(n=Math.max(a[e],r[e])),ve({},e,n)},secondary:function(e){var n="right"===e?"left":"top",o=a[n];return a[e]>r[e]&&!t.escapeWithReference&&(o=Math.min(a[n],r[e]-("right"===e?a.width:a.height))),ve({},n,o)}};return o.forEach(function(e){var t=["left","top"].indexOf(e)!==-1?"primary":"secondary";a=be({},a,i[t](e))}),e.offsets.popper=a,e}function ne(e){var t=e.placement,n=t.split("-")[0],r=t.split("-")[1];if(r){var o=e.offsets,a=o.reference,i=o.popper,s=["bottom","top"].indexOf(n)!==-1,p=s?"left":"top",c=s?"width":"height",u={start:ve({},p,a[p]),end:ve({},p,a[p]+a[c]-i[c])};e.offsets.popper=be({},i,u[r])}return e}function re(e){if(!K(e.instance.modifiers,"hide","preventOverflow"))return e;var t=e.offsets.reference,n=M(e.instance.modifiers,function(e){return"preventOverflow"===e.name}).boundaries;if(t.bottom<n.top||t.left>n.right||t.top>n.bottom||t.right<n.left){if(e.hide===!0)return e;e.hide=!0,e.attributes["x-out-of-boundaries"]=""}else{if(e.hide===!1)return e;e.hide=!1,e.attributes["x-out-of-boundaries"]=!1}return e}function oe(e){var t=e.placement,n=t.split("-")[0],r=e.offsets,o=r.popper,a=r.reference,i=["left","right"].indexOf(n)!==-1,s=["top","left"].indexOf(n)===-1;return o[i?"left":"top"]=a[n]-(s?o[i?"width":"height"]:0),e.placement=S(t),e.offsets.popper=y(o),e}for(var ae=["native code","[object MutationObserverConstructor]"],ie=function(e){return ae.some(function(t){return(e||"").toString().indexOf(t)>-1})},se="undefined"!=typeof window,pe=["Edge","Trident","Firefox"],ce=0,ue=0;ue<pe.length;ue+=1)if(se&&navigator.userAgent.indexOf(pe[ue])>=0){ce=1;break}var le=se&&ie(window.MutationObserver),fe=le?e:n,de=void 0,he=function(){return void 0===de&&(de=navigator.appVersion.indexOf("MSIE 10")!==-1),de},me=function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")},ye=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),ve=function(e,t,n){return t in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e},be=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},ge=["auto-start","auto","auto-end","top-start","top","top-end","right-start","right","right-end","bottom-end","bottom","bottom-start","left-end","left","left-start"],we=ge.slice(3),_e={FLIP:"flip",CLOCKWISE:"clockwise",COUNTERCLOCKWISE:"counterclockwise"},De={shift:{order:100,enabled:!0,fn:ne},offset:{order:200,enabled:!0,fn:ee,offset:0},preventOverflow:{order:300,enabled:!0,fn:te,priority:["left","right","top","bottom"],padding:5,boundariesElement:"scrollParent"},keepTogether:{order:400,enabled:!0,fn:Q},arrow:{order:500,enabled:!0,fn:z,element:"[x-arrow]"},flip:{order:600,enabled:!0,fn:J,behavior:"flip",padding:5,boundariesElement:"viewport"},inner:{order:700,enabled:!1,fn:oe},hide:{order:800,enabled:!0,fn:re},computeStyle:{order:850,enabled:!0,fn:q,gpuAcceleration:!0,x:"bottom",y:"right"},applyStyle:{order:900,enabled:!0,fn:U,onLoad:V,gpuAcceleration:void 0}},Oe={placement:"bottom",eventsEnabled:!0,removeOnDestroy:!1,onCreate:function(){},onUpdate:function(){},modifiers:De},ke=function(){function e(t,n){var o=this,a=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};me(this,e),this.scheduleUpdate=function(){return requestAnimationFrame(o.update)},this.update=fe(this.update.bind(this)),this.options=be({},e.Defaults,a),this.state={isDestroyed:!1,isCreated:!1,scrollParents:[]},this.reference=t.jquery?t[0]:t,this.popper=n.jquery?n[0]:n,this.options.modifiers={},Object.keys(be({},e.Defaults.modifiers,a.modifiers)).forEach(function(t){o.options.modifiers[t]=be({},e.Defaults.modifiers[t]||{},a.modifiers?a.modifiers[t]:{})}),this.modifiers=Object.keys(this.options.modifiers).map(function(e){return be({name:e},o.options.modifiers[e])}).sort(function(e,t){return e.order-t.order}),this.modifiers.forEach(function(e){e.enabled&&r(e.onLoad)&&e.onLoad(o.reference,o.popper,o.options,e,o.state)}),this.update();var i=this.options.eventsEnabled;i&&this.enableEventListeners(),this.state.eventsEnabled=i}return ye(e,[{key:"update",value:function(){return x.call(this)}},{key:"destroy",value:function(){return R.call(this)}},{key:"enableEventListeners",value:function(){return F.call(this)}},{key:"disableEventListeners",value:function(){return A.call(this)}}]),e}();return ke.Utils=("undefined"!=typeof window?window:t).PopperUtils,ke.placements=ge,ke.Defaults=Oe,ke})}).call(t,function(){return this}())},function(e,t,n){/*!
	 * is-equal-shallow <https://github.com/jonschlinkert/is-equal-shallow>
	 *
	 * Copyright (c) 2015, Jon Schlinkert.
	 * Licensed under the MIT License.
	 */
"use strict";var r=n(27);e.exports=function(e,t){if(!e&&!t)return!0;if(!e&&t||e&&!t)return!1;var n,o=0,a=0;for(n in t)if(a++,!r(t[n])||!e.hasOwnProperty(n)||e[n]!==t[n])return!1;for(n in e)o++;return o===a}},function(e,t){/*!
	 * is-primitive <https://github.com/jonschlinkert/is-primitive>
	 *
	 * Copyright (c) 2014-2015, Jon Schlinkert.
	 * Licensed under the MIT License.
	 */
"use strict";e.exports=function(e){return null==e||"function"!=typeof e&&"object"!=typeof e}},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){var n={};for(var r in e)t.indexOf(r)>=0||Object.prototype.hasOwnProperty.call(e,r)&&(n[r]=e[r]);return n}Object.defineProperty(t,"__esModule",{value:!0});var a=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},i=n(4),s=(r(i),n(5)),p=r(s),c=function(e,t){var n=e.component,r=void 0===n?"span":n,s=e.innerRef,p=e.children,c=o(e,["component","innerRef","children"]),u=t.popper,l=function(e){u.setArrowNode(e),"function"==typeof s&&s(e)},f=u.getArrowStyle();if("function"==typeof p){var d={ref:l,style:f};return p({arrowProps:d,restProps:c})}var h=a({},c,{style:a({},f,c.style)});return"string"==typeof r?h.ref=l:h.innerRef=l,(0,i.createElement)(r,h,p)};c.contextTypes={popper:p.default.object.isRequired},c.propTypes={component:p.default.oneOfType([p.default.node,p.default.func]),innerRef:p.default.func,children:p.default.oneOfType([p.default.node,p.default.func])},t.default=c}])});

/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return openModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return closeModal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers_FaqModal__ = __webpack_require__(155);
var _this=this;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var openModal=function openModal(flag){return function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(dispatch,getState){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__reducers_FaqModal__["a" /* ActionTypes */].TOGGLE_MODAL,isOpen:true});case 1:case'end':return _context.stop();}}},_callee,_this);}));return function(_x,_x2){return _ref.apply(this,arguments);};}();};var closeModal=function closeModal(flag){return function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(dispatch,getState){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__reducers_FaqModal__["a" /* ActionTypes */].TOGGLE_MODAL,isOpen:false});case 1:case'end':return _context2.stop();}}},_callee2,_this);}));return function(_x3,_x4){return _ref2.apply(this,arguments);};}();};

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/rm-charity-org.54a16e7e.jpg";

/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Base__ = __webpack_require__(577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Challenge__ = __webpack_require__(578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Pages_container__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Panel=function(_Component){_inherits(Panel,_Component);function Panel(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Panel);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Panel.__proto__||Object.getPrototypeOf(Panel)).call.apply(_ref,[this].concat(args))),_this),_this.state={lastColor:'',panelContent:{},load:false},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Panel,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(_ref2){var _this2=this;var content=_ref2.content;if(content!==''){var nArr=['','challenge','search'];this.setState({lastColor:content,load:false});this.timeout=setTimeout(function(){_this2.setState({load:true,panelContent:{id:content,push:nArr.indexOf(content)===-1?_this2.props.menu[content].push:'',categories:nArr.indexOf(content)===-1?_this2.props.menu[content].categories:''}});},300);}}},{key:'render',value:function render(){var _props=this.props,content=_props.content,open=_props.open,isMobile=_props.isMobile,isLoad=_props.isLoad;var _state=this.state,lastColor=_state.lastColor,panelContent=_state.panelContent,load=_state.load;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'panel '+Object(__WEBPACK_IMPORTED_MODULE_3__styles__["_18" /* PanelStyle */])(lastColor!=='challenge'?'black':'white',open,isMobile,isLoad)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'panel-transition'},content==='challenge'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Challenge__["a" /* default */],{load:load}),content==='search'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Pages_container__["y" /* Search */],{load:load,isPanel:true,home:false}),content!=='challenge'&&content!=='search'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Base__["a" /* default */],{type:content,push:panelContent.push,categories:panelContent.categories,load:load})));}}]);return Panel;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Panel.propTypes={content:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,open:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function(_ref3){var Session=_ref3.Session;return{menu:Session.menu};})(Panel));

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/Interstate-ExtraLight.ada9854b.eot";

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(169);
module.exports = __webpack_require__(174);


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// @remove-on-eject-begin
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
// @remove-on-eject-end


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(170).enable();
  window.Promise = __webpack_require__(172);
}

// fetch() polyfill for making API calls.
__webpack_require__(173);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(9);

// In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
// We don't polyfill it in the browser--this is user's responsibility.
if (false) {
  require('raf').polyfill(global);
}


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(96);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._47 = null;
  Promise._71 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._47 = function (promise) {
    if (
      promise._83 === 2 && // IS REJECTED
      rejections[promise._56]
    ) {
      if (rejections[promise._56].logged) {
        onHandled(promise._56);
      } else {
        clearTimeout(rejections[promise._56].timeout);
      }
      delete rejections[promise._56];
    }
  };
  Promise._71 = function (promise, err) {
    if (promise._75 === 0) { // not yet handled
      promise._56 = id++;
      rejections[promise._56] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._56),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(40)))

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(96);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 173 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_whatwg_fetch__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_whatwg_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_whatwg_fetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_polyfill_array_includes__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_polyfill_array_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_polyfill_array_includes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_fonts__ = __webpack_require__(590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_global__ = __webpack_require__(602);
// POLYFILL
// import registerServiceWorker from './registerServiceWorker'
__WEBPACK_IMPORTED_MODULE_2_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__App__["a" /* default */],null),document.getElementById('app'));// registerServiceWorker()

/***/ }),
/* 175 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ')
    preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = options.status === undefined ? 200 : options.status
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      } else if (request.credentials === 'omit') {
        xhr.withCredentials = false
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Forked from fbjs/warning:
 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
 *
 * Only change is we use console.warn instead of console.error,
 * and do nothing when 'console' is not supported.
 * This really simplifies the code.
 * ---
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var lowPriorityWarning = function () {};

if (false) {
  var printWarning = function (format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.warn(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  lowPriorityWarning = function (condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }
    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = lowPriorityWarning;

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var PooledClass = __webpack_require__(178);
var ReactElement = __webpack_require__(30);

var emptyFunction = __webpack_require__(19);
var traverseAllChildren = __webpack_require__(179);

var twoArgumentPooler = PooledClass.twoArgumentPooler;
var fourArgumentPooler = PooledClass.fourArgumentPooler;

var userProvidedKeyEscapeRegex = /\/+/g;
function escapeUserProvidedKey(text) {
  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
}

/**
 * PooledClass representing the bookkeeping associated with performing a child
 * traversal. Allows avoiding binding callbacks.
 *
 * @constructor ForEachBookKeeping
 * @param {!function} forEachFunction Function to perform traversal with.
 * @param {?*} forEachContext Context to perform context with.
 */
function ForEachBookKeeping(forEachFunction, forEachContext) {
  this.func = forEachFunction;
  this.context = forEachContext;
  this.count = 0;
}
ForEachBookKeeping.prototype.destructor = function () {
  this.func = null;
  this.context = null;
  this.count = 0;
};
PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);

function forEachSingleChild(bookKeeping, child, name) {
  var func = bookKeeping.func,
      context = bookKeeping.context;

  func.call(context, child, bookKeeping.count++);
}

/**
 * Iterates through children that are typically specified as `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} forEachFunc
 * @param {*} forEachContext Context for forEachContext.
 */
function forEachChildren(children, forEachFunc, forEachContext) {
  if (children == null) {
    return children;
  }
  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
  traverseAllChildren(children, forEachSingleChild, traverseContext);
  ForEachBookKeeping.release(traverseContext);
}

/**
 * PooledClass representing the bookkeeping associated with performing a child
 * mapping. Allows avoiding binding callbacks.
 *
 * @constructor MapBookKeeping
 * @param {!*} mapResult Object containing the ordered map of results.
 * @param {!function} mapFunction Function to perform mapping with.
 * @param {?*} mapContext Context to perform mapping with.
 */
function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
  this.result = mapResult;
  this.keyPrefix = keyPrefix;
  this.func = mapFunction;
  this.context = mapContext;
  this.count = 0;
}
MapBookKeeping.prototype.destructor = function () {
  this.result = null;
  this.keyPrefix = null;
  this.func = null;
  this.context = null;
  this.count = 0;
};
PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);

function mapSingleChildIntoContext(bookKeeping, child, childKey) {
  var result = bookKeeping.result,
      keyPrefix = bookKeeping.keyPrefix,
      func = bookKeeping.func,
      context = bookKeeping.context;


  var mappedChild = func.call(context, child, bookKeeping.count++);
  if (Array.isArray(mappedChild)) {
    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
  } else if (mappedChild != null) {
    if (ReactElement.isValidElement(mappedChild)) {
      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
      // Keep both the (mapped) and old keys if they differ, just as
      // traverseAllChildren used to do for objects as children
      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
    }
    result.push(mappedChild);
  }
}

function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
  var escapedPrefix = '';
  if (prefix != null) {
    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
  }
  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
  MapBookKeeping.release(traverseContext);
}

/**
 * Maps children that are typically specified as `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
 *
 * The provided mapFunction(child, key, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func The map function.
 * @param {*} context Context for mapFunction.
 * @return {object} Object containing the ordered map of results.
 */
function mapChildren(children, func, context) {
  if (children == null) {
    return children;
  }
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
  return result;
}

function forEachSingleChildDummy(traverseContext, child, name) {
  return null;
}

/**
 * Count the number of children that are typically specified as
 * `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
 *
 * @param {?*} children Children tree container.
 * @return {number} The number of children.
 */
function countChildren(children, context) {
  return traverseAllChildren(children, forEachSingleChildDummy, null);
}

/**
 * Flatten a children object (typically specified as `props.children`) and
 * return an array with appropriately re-keyed children.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
 */
function toArray(children) {
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
  return result;
}

var ReactChildren = {
  forEach: forEachChildren,
  map: mapChildren,
  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
  count: countChildren,
  toArray: toArray
};

module.exports = ReactChildren;

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(41);

var invariant = __webpack_require__(4);

/**
 * Static poolers. Several custom versions for each potential number of
 * arguments. A completely generic pooler is easy to implement, but would
 * require accessing the `arguments` object. In each of these, `this` refers to
 * the Class itself, not an instance. If any others are needed, simply add them
 * here, or in their own files.
 */
var oneArgumentPooler = function (copyFieldsFrom) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, copyFieldsFrom);
    return instance;
  } else {
    return new Klass(copyFieldsFrom);
  }
};

var twoArgumentPooler = function (a1, a2) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2);
    return instance;
  } else {
    return new Klass(a1, a2);
  }
};

var threeArgumentPooler = function (a1, a2, a3) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3);
    return instance;
  } else {
    return new Klass(a1, a2, a3);
  }
};

var fourArgumentPooler = function (a1, a2, a3, a4) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3, a4);
    return instance;
  } else {
    return new Klass(a1, a2, a3, a4);
  }
};

var standardReleaser = function (instance) {
  var Klass = this;
  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
  instance.destructor();
  if (Klass.instancePool.length < Klass.poolSize) {
    Klass.instancePool.push(instance);
  }
};

var DEFAULT_POOL_SIZE = 10;
var DEFAULT_POOLER = oneArgumentPooler;

/**
 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
 * itself (statically) not adding any prototypical fields. Any CopyConstructor
 * you give this may have a `poolSize` property, and will look for a
 * prototypical `destructor` on instances.
 *
 * @param {Function} CopyConstructor Constructor that can be used to reset.
 * @param {Function} pooler Customizable pooler.
 */
var addPoolingTo = function (CopyConstructor, pooler) {
  // Casting as any so that flow ignores the actual implementation and trusts
  // it to match the type we declared
  var NewKlass = CopyConstructor;
  NewKlass.instancePool = [];
  NewKlass.getPooled = pooler || DEFAULT_POOLER;
  if (!NewKlass.poolSize) {
    NewKlass.poolSize = DEFAULT_POOL_SIZE;
  }
  NewKlass.release = standardReleaser;
  return NewKlass;
};

var PooledClass = {
  addPoolingTo: addPoolingTo,
  oneArgumentPooler: oneArgumentPooler,
  twoArgumentPooler: twoArgumentPooler,
  threeArgumentPooler: threeArgumentPooler,
  fourArgumentPooler: fourArgumentPooler
};

module.exports = PooledClass;

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(41);

var ReactCurrentOwner = __webpack_require__(22);
var REACT_ELEMENT_TYPE = __webpack_require__(100);

var getIteratorFn = __webpack_require__(180);
var invariant = __webpack_require__(4);
var KeyEscapeUtils = __webpack_require__(181);
var warning = __webpack_require__(7);

var SEPARATOR = '.';
var SUBSEPARATOR = ':';

/**
 * This is inlined from ReactElement since this file is shared between
 * isomorphic and renderers. We could extract this to a
 *
 */

/**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */

var didWarnAboutMaps = false;

/**
 * Generate a key string that identifies a component within a set.
 *
 * @param {*} component A component that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */
function getComponentKey(component, index) {
  // Do some typechecking here since we call this blindly. We want to ensure
  // that we don't block potential future ES APIs.
  if (component && typeof component === 'object' && component.key != null) {
    // Explicit key
    return KeyEscapeUtils.escape(component.key);
  }
  // Implicit key determined by the index in the set
  return index.toString(36);
}

/**
 * @param {?*} children Children tree container.
 * @param {!string} nameSoFar Name of the key path so far.
 * @param {!function} callback Callback to invoke with each child found.
 * @param {?*} traverseContext Used to pass information throughout the traversal
 * process.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
  var type = typeof children;

  if (type === 'undefined' || type === 'boolean') {
    // All of the above are perceived as null.
    children = null;
  }

  if (children === null || type === 'string' || type === 'number' ||
  // The following is inlined from ReactElement. This means we can optimize
  // some checks. React Fiber also inlines this logic for similar purposes.
  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
    callback(traverseContext, children,
    // If it's the only child, treat the name as if it was wrapped in an array
    // so that it's consistent if the number of children grows.
    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
    return 1;
  }

  var child;
  var nextName;
  var subtreeCount = 0; // Count of children found in the current subtree.
  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;

  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      nextName = nextNamePrefix + getComponentKey(child, i);
      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
    }
  } else {
    var iteratorFn = getIteratorFn(children);
    if (iteratorFn) {
      var iterator = iteratorFn.call(children);
      var step;
      if (iteratorFn !== children.entries) {
        var ii = 0;
        while (!(step = iterator.next()).done) {
          child = step.value;
          nextName = nextNamePrefix + getComponentKey(child, ii++);
          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
        }
      } else {
        if (false) {
          var mapsAsChildrenAddendum = '';
          if (ReactCurrentOwner.current) {
            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
            if (mapsAsChildrenOwnerName) {
              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
            }
          }
          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
          didWarnAboutMaps = true;
        }
        // Iterator will provide entry [k,v] tuples rather than values.
        while (!(step = iterator.next()).done) {
          var entry = step.value;
          if (entry) {
            child = entry[1];
            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
          }
        }
      }
    } else if (type === 'object') {
      var addendum = '';
      if (false) {
        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
        if (children._isReactElement) {
          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
        }
        if (ReactCurrentOwner.current) {
          var name = ReactCurrentOwner.current.getName();
          if (name) {
            addendum += ' Check the render method of `' + name + '`.';
          }
        }
      }
      var childrenString = String(children);
       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
    }
  }

  return subtreeCount;
}

/**
 * Traverses children that are typically specified as `props.children`, but
 * might also be specified through attributes:
 *
 * - `traverseAllChildren(this.props.children, ...)`
 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
 *
 * The `traverseContext` is an optional argument that is passed through the
 * entire traversal. It can be used to store accumulations or anything else that
 * the callback might find relevant.
 *
 * @param {?*} children Children tree object.
 * @param {!function} callback To invoke upon traversing each child.
 * @param {?*} traverseContext Context for traversal.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildren(children, callback, traverseContext) {
  if (children == null) {
    return 0;
  }

  return traverseAllChildrenImpl(children, '', callback, traverseContext);
}

module.exports = traverseAllChildren;

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/* global Symbol */

var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

/**
 * Returns the iterator method function contained on the iterable object.
 *
 * Be sure to invoke the function with the iterable as context:
 *
 *     var iteratorFn = getIteratorFn(myIterable);
 *     if (iteratorFn) {
 *       var iterator = iteratorFn.call(myIterable);
 *       ...
 *     }
 *
 * @param {?object} maybeIterable
 * @return {?function}
 */
function getIteratorFn(maybeIterable) {
  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
  if (typeof iteratorFn === 'function') {
    return iteratorFn;
  }
}

module.exports = getIteratorFn;

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */

function escape(key) {
  var escapeRegex = /[=:]/g;
  var escaperLookup = {
    '=': '=0',
    ':': '=2'
  };
  var escapedString = ('' + key).replace(escapeRegex, function (match) {
    return escaperLookup[match];
  });

  return '$' + escapedString;
}

/**
 * Unescape and unwrap key for human-readable display
 *
 * @param {string} key to unescape.
 * @return {string} the unescaped key.
 */
function unescape(key) {
  var unescapeRegex = /(=0|=2)/g;
  var unescaperLookup = {
    '=0': '=',
    '=2': ':'
  };
  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);

  return ('' + keySubstring).replace(unescapeRegex, function (match) {
    return unescaperLookup[match];
  });
}

var KeyEscapeUtils = {
  escape: escape,
  unescape: unescape
};

module.exports = KeyEscapeUtils;

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactElement = __webpack_require__(30);

/**
 * Create a factory that creates HTML tag elements.
 *
 * @private
 */
var createDOMFactory = ReactElement.createFactory;
if (false) {
  var ReactElementValidator = require('./ReactElementValidator');
  createDOMFactory = ReactElementValidator.createFactory;
}

/**
 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
 *
 * @public
 */
var ReactDOMFactories = {
  a: createDOMFactory('a'),
  abbr: createDOMFactory('abbr'),
  address: createDOMFactory('address'),
  area: createDOMFactory('area'),
  article: createDOMFactory('article'),
  aside: createDOMFactory('aside'),
  audio: createDOMFactory('audio'),
  b: createDOMFactory('b'),
  base: createDOMFactory('base'),
  bdi: createDOMFactory('bdi'),
  bdo: createDOMFactory('bdo'),
  big: createDOMFactory('big'),
  blockquote: createDOMFactory('blockquote'),
  body: createDOMFactory('body'),
  br: createDOMFactory('br'),
  button: createDOMFactory('button'),
  canvas: createDOMFactory('canvas'),
  caption: createDOMFactory('caption'),
  cite: createDOMFactory('cite'),
  code: createDOMFactory('code'),
  col: createDOMFactory('col'),
  colgroup: createDOMFactory('colgroup'),
  data: createDOMFactory('data'),
  datalist: createDOMFactory('datalist'),
  dd: createDOMFactory('dd'),
  del: createDOMFactory('del'),
  details: createDOMFactory('details'),
  dfn: createDOMFactory('dfn'),
  dialog: createDOMFactory('dialog'),
  div: createDOMFactory('div'),
  dl: createDOMFactory('dl'),
  dt: createDOMFactory('dt'),
  em: createDOMFactory('em'),
  embed: createDOMFactory('embed'),
  fieldset: createDOMFactory('fieldset'),
  figcaption: createDOMFactory('figcaption'),
  figure: createDOMFactory('figure'),
  footer: createDOMFactory('footer'),
  form: createDOMFactory('form'),
  h1: createDOMFactory('h1'),
  h2: createDOMFactory('h2'),
  h3: createDOMFactory('h3'),
  h4: createDOMFactory('h4'),
  h5: createDOMFactory('h5'),
  h6: createDOMFactory('h6'),
  head: createDOMFactory('head'),
  header: createDOMFactory('header'),
  hgroup: createDOMFactory('hgroup'),
  hr: createDOMFactory('hr'),
  html: createDOMFactory('html'),
  i: createDOMFactory('i'),
  iframe: createDOMFactory('iframe'),
  img: createDOMFactory('img'),
  input: createDOMFactory('input'),
  ins: createDOMFactory('ins'),
  kbd: createDOMFactory('kbd'),
  keygen: createDOMFactory('keygen'),
  label: createDOMFactory('label'),
  legend: createDOMFactory('legend'),
  li: createDOMFactory('li'),
  link: createDOMFactory('link'),
  main: createDOMFactory('main'),
  map: createDOMFactory('map'),
  mark: createDOMFactory('mark'),
  menu: createDOMFactory('menu'),
  menuitem: createDOMFactory('menuitem'),
  meta: createDOMFactory('meta'),
  meter: createDOMFactory('meter'),
  nav: createDOMFactory('nav'),
  noscript: createDOMFactory('noscript'),
  object: createDOMFactory('object'),
  ol: createDOMFactory('ol'),
  optgroup: createDOMFactory('optgroup'),
  option: createDOMFactory('option'),
  output: createDOMFactory('output'),
  p: createDOMFactory('p'),
  param: createDOMFactory('param'),
  picture: createDOMFactory('picture'),
  pre: createDOMFactory('pre'),
  progress: createDOMFactory('progress'),
  q: createDOMFactory('q'),
  rp: createDOMFactory('rp'),
  rt: createDOMFactory('rt'),
  ruby: createDOMFactory('ruby'),
  s: createDOMFactory('s'),
  samp: createDOMFactory('samp'),
  script: createDOMFactory('script'),
  section: createDOMFactory('section'),
  select: createDOMFactory('select'),
  small: createDOMFactory('small'),
  source: createDOMFactory('source'),
  span: createDOMFactory('span'),
  strong: createDOMFactory('strong'),
  style: createDOMFactory('style'),
  sub: createDOMFactory('sub'),
  summary: createDOMFactory('summary'),
  sup: createDOMFactory('sup'),
  table: createDOMFactory('table'),
  tbody: createDOMFactory('tbody'),
  td: createDOMFactory('td'),
  textarea: createDOMFactory('textarea'),
  tfoot: createDOMFactory('tfoot'),
  th: createDOMFactory('th'),
  thead: createDOMFactory('thead'),
  time: createDOMFactory('time'),
  title: createDOMFactory('title'),
  tr: createDOMFactory('tr'),
  track: createDOMFactory('track'),
  u: createDOMFactory('u'),
  ul: createDOMFactory('ul'),
  'var': createDOMFactory('var'),
  video: createDOMFactory('video'),
  wbr: createDOMFactory('wbr'),

  // SVG
  circle: createDOMFactory('circle'),
  clipPath: createDOMFactory('clipPath'),
  defs: createDOMFactory('defs'),
  ellipse: createDOMFactory('ellipse'),
  g: createDOMFactory('g'),
  image: createDOMFactory('image'),
  line: createDOMFactory('line'),
  linearGradient: createDOMFactory('linearGradient'),
  mask: createDOMFactory('mask'),
  path: createDOMFactory('path'),
  pattern: createDOMFactory('pattern'),
  polygon: createDOMFactory('polygon'),
  polyline: createDOMFactory('polyline'),
  radialGradient: createDOMFactory('radialGradient'),
  rect: createDOMFactory('rect'),
  stop: createDOMFactory('stop'),
  svg: createDOMFactory('svg'),
  text: createDOMFactory('text'),
  tspan: createDOMFactory('tspan')
};

module.exports = ReactDOMFactories;

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _require = __webpack_require__(30),
    isValidElement = _require.isValidElement;

var factory = __webpack_require__(101);

module.exports = factory(isValidElement);

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactIs = __webpack_require__(66);
var assign = __webpack_require__(9);

var ReactPropTypesSecret = __webpack_require__(102);
var checkPropTypes = __webpack_require__(186);

var has = Function.call.bind(Object.prototype.hasOwnProperty);
var printWarning = function() {};

if (false) {
  printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

function emptyFunctionThatReturnsNull() {
  return null;
}

module.exports = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker,
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message) {
    this.message = message;
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (false) {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          var err = new Error(
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
          err.name = 'Invariant Violation';
          throw err;
        } else if (false) {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            printWarning(
              'You are manually calling a React.PropTypes validation ' +
              'function for the `' + propFullName + '` prop on `' + componentName  + '`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!ReactIs.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (false) {
        if (arguments.length > 1) {
          printWarning(
            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
          );
        } else {
          printWarning('Invalid argument supplied to oneOf, expected an array.');
        }
      }
      return emptyFunctionThatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);
        if (type === 'symbol') {
          return String(value);
        }
        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (has(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
       false ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        printWarning(
          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
        );
        return emptyFunctionThatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
          return null;
        }
      }

      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (!checker) {
          continue;
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from
      // props.
      var allKeys = assign({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (!checker) {
          return new PropTypeError(
            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
          );
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // falsy value can't be a Symbol
    if (!propValue) {
      return false;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var printWarning = function() {};

if (false) {
  var ReactPropTypesSecret = require('./lib/ReactPropTypesSecret');
  var loggedTypeFailures = {};
  var has = Function.call.bind(Object.prototype.hasOwnProperty);

  printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (false) {
    for (var typeSpecName in typeSpecs) {
      if (has(typeSpecs, typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error(
              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.'
            );
            err.name = 'Invariant Violation';
            throw err;
          }
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
        } catch (ex) {
          error = ex;
        }
        if (error && !(error instanceof Error)) {
          printWarning(
            (componentName || 'React class') + ': type specification of ' +
            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
            'You may have forgotten to pass an argument to the type checker ' +
            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
            'shape all require an argument).'
          );
        }
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          printWarning(
            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
          );
        }
      }
    }
  }
}

/**
 * Resets warning cache when testing.
 *
 * @private
 */
checkPropTypes.resetWarningCache = function() {
  if (false) {
    loggedTypeFailures = {};
  }
}

module.exports = checkPropTypes;


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



module.exports = '15.7.0';


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _require = __webpack_require__(97),
    Component = _require.Component;

var _require2 = __webpack_require__(30),
    isValidElement = _require2.isValidElement;

var ReactNoopUpdateQueue = __webpack_require__(98);
var factory = __webpack_require__(189);

module.exports = factory(Component, isValidElement, ReactNoopUpdateQueue);

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(9);

// -- Inlined from fbjs --

var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function _invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

var warning = function(){};

if (false) {
  var printWarning = function printWarning(format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.indexOf('Failed Composite propType: ') === 0) {
      return; // Ignore CompositeComponent proptype check.
    }

    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

// /-- Inlined from fbjs --

var MIXINS_KEY = 'mixins';

// Helper function to allow the creation of anonymous functions which do not
// have .name set to the name of the variable being assigned to.
function identity(fn) {
  return fn;
}

var ReactPropTypeLocationNames;
if (false) {
  ReactPropTypeLocationNames = {
    prop: 'prop',
    context: 'context',
    childContext: 'child context'
  };
} else {
  ReactPropTypeLocationNames = {};
}

function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
  /**
   * Policies that describe methods in `ReactClassInterface`.
   */

  var injectedMixins = [];

  /**
   * Composite components are higher-level components that compose other composite
   * or host components.
   *
   * To create a new type of `ReactClass`, pass a specification of
   * your new class to `React.createClass`. The only requirement of your class
   * specification is that you implement a `render` method.
   *
   *   var MyComponent = React.createClass({
   *     render: function() {
   *       return <div>Hello World</div>;
   *     }
   *   });
   *
   * The class specification supports a specific protocol of methods that have
   * special meaning (e.g. `render`). See `ReactClassInterface` for
   * more the comprehensive protocol. Any other properties and methods in the
   * class specification will be available on the prototype.
   *
   * @interface ReactClassInterface
   * @internal
   */
  var ReactClassInterface = {
    /**
     * An array of Mixin objects to include when defining your component.
     *
     * @type {array}
     * @optional
     */
    mixins: 'DEFINE_MANY',

    /**
     * An object containing properties and methods that should be defined on
     * the component's constructor instead of its prototype (static methods).
     *
     * @type {object}
     * @optional
     */
    statics: 'DEFINE_MANY',

    /**
     * Definition of prop types for this component.
     *
     * @type {object}
     * @optional
     */
    propTypes: 'DEFINE_MANY',

    /**
     * Definition of context types for this component.
     *
     * @type {object}
     * @optional
     */
    contextTypes: 'DEFINE_MANY',

    /**
     * Definition of context types this component sets for its children.
     *
     * @type {object}
     * @optional
     */
    childContextTypes: 'DEFINE_MANY',

    // ==== Definition methods ====

    /**
     * Invoked when the component is mounted. Values in the mapping will be set on
     * `this.props` if that prop is not specified (i.e. using an `in` check).
     *
     * This method is invoked before `getInitialState` and therefore cannot rely
     * on `this.state` or use `this.setState`.
     *
     * @return {object}
     * @optional
     */
    getDefaultProps: 'DEFINE_MANY_MERGED',

    /**
     * Invoked once before the component is mounted. The return value will be used
     * as the initial value of `this.state`.
     *
     *   getInitialState: function() {
     *     return {
     *       isOn: false,
     *       fooBaz: new BazFoo()
     *     }
     *   }
     *
     * @return {object}
     * @optional
     */
    getInitialState: 'DEFINE_MANY_MERGED',

    /**
     * @return {object}
     * @optional
     */
    getChildContext: 'DEFINE_MANY_MERGED',

    /**
     * Uses props from `this.props` and state from `this.state` to render the
     * structure of the component.
     *
     * No guarantees are made about when or how often this method is invoked, so
     * it must not have side effects.
     *
     *   render: function() {
     *     var name = this.props.name;
     *     return <div>Hello, {name}!</div>;
     *   }
     *
     * @return {ReactComponent}
     * @required
     */
    render: 'DEFINE_ONCE',

    // ==== Delegate methods ====

    /**
     * Invoked when the component is initially created and about to be mounted.
     * This may have side effects, but any external subscriptions or data created
     * by this method must be cleaned up in `componentWillUnmount`.
     *
     * @optional
     */
    componentWillMount: 'DEFINE_MANY',

    /**
     * Invoked when the component has been mounted and has a DOM representation.
     * However, there is no guarantee that the DOM node is in the document.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been mounted (initialized and rendered) for the first time.
     *
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidMount: 'DEFINE_MANY',

    /**
     * Invoked before the component receives new props.
     *
     * Use this as an opportunity to react to a prop transition by updating the
     * state using `this.setState`. Current props are accessed via `this.props`.
     *
     *   componentWillReceiveProps: function(nextProps, nextContext) {
     *     this.setState({
     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
     *     });
     *   }
     *
     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
     * transition may cause a state change, but the opposite is not true. If you
     * need it, you are probably looking for `componentWillUpdate`.
     *
     * @param {object} nextProps
     * @optional
     */
    componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Invoked while deciding if the component should be updated as a result of
     * receiving new props, state and/or context.
     *
     * Use this as an opportunity to `return false` when you're certain that the
     * transition to the new props/state/context will not require a component
     * update.
     *
     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
     *     return !equal(nextProps, this.props) ||
     *       !equal(nextState, this.state) ||
     *       !equal(nextContext, this.context);
     *   }
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @return {boolean} True if the component should update.
     * @optional
     */
    shouldComponentUpdate: 'DEFINE_ONCE',

    /**
     * Invoked when the component is about to update due to a transition from
     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
     * and `nextContext`.
     *
     * Use this as an opportunity to perform preparation before an update occurs.
     *
     * NOTE: You **cannot** use `this.setState()` in this method.
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @param {ReactReconcileTransaction} transaction
     * @optional
     */
    componentWillUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component's DOM representation has been updated.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been updated.
     *
     * @param {object} prevProps
     * @param {?object} prevState
     * @param {?object} prevContext
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component is about to be removed from its parent and have
     * its DOM representation destroyed.
     *
     * Use this as an opportunity to deallocate any external resources.
     *
     * NOTE: There is no `componentDidUnmount` since your component will have been
     * destroyed by that point.
     *
     * @optional
     */
    componentWillUnmount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillMount`.
     *
     * @optional
     */
    UNSAFE_componentWillMount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillReceiveProps`.
     *
     * @optional
     */
    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillUpdate`.
     *
     * @optional
     */
    UNSAFE_componentWillUpdate: 'DEFINE_MANY',

    // ==== Advanced methods ====

    /**
     * Updates the component's currently mounted DOM representation.
     *
     * By default, this implements React's rendering and reconciliation algorithm.
     * Sophisticated clients may wish to override this.
     *
     * @param {ReactReconcileTransaction} transaction
     * @internal
     * @overridable
     */
    updateComponent: 'OVERRIDE_BASE'
  };

  /**
   * Similar to ReactClassInterface but for static methods.
   */
  var ReactClassStaticInterface = {
    /**
     * This method is invoked after a component is instantiated and when it
     * receives new props. Return an object to update state in response to
     * prop changes. Return null to indicate no change to state.
     *
     * If an object is returned, its keys will be merged into the existing state.
     *
     * @return {object || null}
     * @optional
     */
    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
  };

  /**
   * Mapping from class specification keys to special processing functions.
   *
   * Although these are declared like instance properties in the specification
   * when defining classes using `React.createClass`, they are actually static
   * and are accessible on the constructor instead of the prototype. Despite
   * being static, they must be defined outside of the "statics" key under
   * which all other static methods are defined.
   */
  var RESERVED_SPEC_KEYS = {
    displayName: function(Constructor, displayName) {
      Constructor.displayName = displayName;
    },
    mixins: function(Constructor, mixins) {
      if (mixins) {
        for (var i = 0; i < mixins.length; i++) {
          mixSpecIntoComponent(Constructor, mixins[i]);
        }
      }
    },
    childContextTypes: function(Constructor, childContextTypes) {
      if (false) {
        validateTypeDef(Constructor, childContextTypes, 'childContext');
      }
      Constructor.childContextTypes = _assign(
        {},
        Constructor.childContextTypes,
        childContextTypes
      );
    },
    contextTypes: function(Constructor, contextTypes) {
      if (false) {
        validateTypeDef(Constructor, contextTypes, 'context');
      }
      Constructor.contextTypes = _assign(
        {},
        Constructor.contextTypes,
        contextTypes
      );
    },
    /**
     * Special case getDefaultProps which should move into statics but requires
     * automatic merging.
     */
    getDefaultProps: function(Constructor, getDefaultProps) {
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps = createMergedResultFunction(
          Constructor.getDefaultProps,
          getDefaultProps
        );
      } else {
        Constructor.getDefaultProps = getDefaultProps;
      }
    },
    propTypes: function(Constructor, propTypes) {
      if (false) {
        validateTypeDef(Constructor, propTypes, 'prop');
      }
      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
    },
    statics: function(Constructor, statics) {
      mixStaticSpecIntoComponent(Constructor, statics);
    },
    autobind: function() {}
  };

  function validateTypeDef(Constructor, typeDef, location) {
    for (var propName in typeDef) {
      if (typeDef.hasOwnProperty(propName)) {
        // use a warning instead of an _invariant so components
        // don't show up in prod but only in __DEV__
        if (false) {
          warning(
            typeof typeDef[propName] === 'function',
            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
              'React.PropTypes.',
            Constructor.displayName || 'ReactClass',
            ReactPropTypeLocationNames[location],
            propName
          );
        }
      }
    }
  }

  function validateMethodOverride(isAlreadyDefined, name) {
    var specPolicy = ReactClassInterface.hasOwnProperty(name)
      ? ReactClassInterface[name]
      : null;

    // Disallow overriding of base class methods unless explicitly allowed.
    if (ReactClassMixin.hasOwnProperty(name)) {
      _invariant(
        specPolicy === 'OVERRIDE_BASE',
        'ReactClassInterface: You are attempting to override ' +
          '`%s` from your class specification. Ensure that your method names ' +
          'do not overlap with React methods.',
        name
      );
    }

    // Disallow defining methods more than once unless explicitly allowed.
    if (isAlreadyDefined) {
      _invariant(
        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
        'ReactClassInterface: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be due ' +
          'to a mixin.',
        name
      );
    }
  }

  /**
   * Mixin helper which handles policy validation and reserved
   * specification keys when building React classes.
   */
  function mixSpecIntoComponent(Constructor, spec) {
    if (!spec) {
      if (false) {
        var typeofSpec = typeof spec;
        var isMixinValid = typeofSpec === 'object' && spec !== null;

        if (process.env.NODE_ENV !== 'production') {
          warning(
            isMixinValid,
            "%s: You're attempting to include a mixin that is either null " +
              'or not an object. Check the mixins included by the component, ' +
              'as well as any mixins they include themselves. ' +
              'Expected object but got %s.',
            Constructor.displayName || 'ReactClass',
            spec === null ? null : typeofSpec
          );
        }
      }

      return;
    }

    _invariant(
      typeof spec !== 'function',
      "ReactClass: You're attempting to " +
        'use a component class or function as a mixin. Instead, just use a ' +
        'regular object.'
    );
    _invariant(
      !isValidElement(spec),
      "ReactClass: You're attempting to " +
        'use a component as a mixin. Instead, just use a regular object.'
    );

    var proto = Constructor.prototype;
    var autoBindPairs = proto.__reactAutoBindPairs;

    // By handling mixins before any other properties, we ensure the same
    // chaining order is applied to methods with DEFINE_MANY policy, whether
    // mixins are listed before or after these methods in the spec.
    if (spec.hasOwnProperty(MIXINS_KEY)) {
      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
    }

    for (var name in spec) {
      if (!spec.hasOwnProperty(name)) {
        continue;
      }

      if (name === MIXINS_KEY) {
        // We have already handled mixins in a special case above.
        continue;
      }

      var property = spec[name];
      var isAlreadyDefined = proto.hasOwnProperty(name);
      validateMethodOverride(isAlreadyDefined, name);

      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
        RESERVED_SPEC_KEYS[name](Constructor, property);
      } else {
        // Setup methods on prototype:
        // The following member methods should not be automatically bound:
        // 1. Expected ReactClass methods (in the "interface").
        // 2. Overridden methods (that were mixed in).
        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
        var isFunction = typeof property === 'function';
        var shouldAutoBind =
          isFunction &&
          !isReactClassMethod &&
          !isAlreadyDefined &&
          spec.autobind !== false;

        if (shouldAutoBind) {
          autoBindPairs.push(name, property);
          proto[name] = property;
        } else {
          if (isAlreadyDefined) {
            var specPolicy = ReactClassInterface[name];

            // These cases should already be caught by validateMethodOverride.
            _invariant(
              isReactClassMethod &&
                (specPolicy === 'DEFINE_MANY_MERGED' ||
                  specPolicy === 'DEFINE_MANY'),
              'ReactClass: Unexpected spec policy %s for key %s ' +
                'when mixing in component specs.',
              specPolicy,
              name
            );

            // For methods which are defined more than once, call the existing
            // methods before calling the new property, merging if appropriate.
            if (specPolicy === 'DEFINE_MANY_MERGED') {
              proto[name] = createMergedResultFunction(proto[name], property);
            } else if (specPolicy === 'DEFINE_MANY') {
              proto[name] = createChainedFunction(proto[name], property);
            }
          } else {
            proto[name] = property;
            if (false) {
              // Add verbose displayName to the function, which helps when looking
              // at profiling tools.
              if (typeof property === 'function' && spec.displayName) {
                proto[name].displayName = spec.displayName + '_' + name;
              }
            }
          }
        }
      }
    }
  }

  function mixStaticSpecIntoComponent(Constructor, statics) {
    if (!statics) {
      return;
    }

    for (var name in statics) {
      var property = statics[name];
      if (!statics.hasOwnProperty(name)) {
        continue;
      }

      var isReserved = name in RESERVED_SPEC_KEYS;
      _invariant(
        !isReserved,
        'ReactClass: You are attempting to define a reserved ' +
          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
          'as an instance property instead; it will still be accessible on the ' +
          'constructor.',
        name
      );

      var isAlreadyDefined = name in Constructor;
      if (isAlreadyDefined) {
        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
          ? ReactClassStaticInterface[name]
          : null;

        _invariant(
          specPolicy === 'DEFINE_MANY_MERGED',
          'ReactClass: You are attempting to define ' +
            '`%s` on your component more than once. This conflict may be ' +
            'due to a mixin.',
          name
        );

        Constructor[name] = createMergedResultFunction(Constructor[name], property);

        return;
      }

      Constructor[name] = property;
    }
  }

  /**
   * Merge two objects, but throw if both contain the same key.
   *
   * @param {object} one The first object, which is mutated.
   * @param {object} two The second object
   * @return {object} one after it has been mutated to contain everything in two.
   */
  function mergeIntoWithNoDuplicateKeys(one, two) {
    _invariant(
      one && two && typeof one === 'object' && typeof two === 'object',
      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
    );

    for (var key in two) {
      if (two.hasOwnProperty(key)) {
        _invariant(
          one[key] === undefined,
          'mergeIntoWithNoDuplicateKeys(): ' +
            'Tried to merge two objects with the same key: `%s`. This conflict ' +
            'may be due to a mixin; in particular, this may be caused by two ' +
            'getInitialState() or getDefaultProps() methods returning objects ' +
            'with clashing keys.',
          key
        );
        one[key] = two[key];
      }
    }
    return one;
  }

  /**
   * Creates a function that invokes two functions and merges their return values.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createMergedResultFunction(one, two) {
    return function mergedResult() {
      var a = one.apply(this, arguments);
      var b = two.apply(this, arguments);
      if (a == null) {
        return b;
      } else if (b == null) {
        return a;
      }
      var c = {};
      mergeIntoWithNoDuplicateKeys(c, a);
      mergeIntoWithNoDuplicateKeys(c, b);
      return c;
    };
  }

  /**
   * Creates a function that invokes two functions and ignores their return vales.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createChainedFunction(one, two) {
    return function chainedFunction() {
      one.apply(this, arguments);
      two.apply(this, arguments);
    };
  }

  /**
   * Binds a method to the component.
   *
   * @param {object} component Component whose method is going to be bound.
   * @param {function} method Method to be bound.
   * @return {function} The bound method.
   */
  function bindAutoBindMethod(component, method) {
    var boundMethod = method.bind(component);
    if (false) {
      boundMethod.__reactBoundContext = component;
      boundMethod.__reactBoundMethod = method;
      boundMethod.__reactBoundArguments = null;
      var componentName = component.constructor.displayName;
      var _bind = boundMethod.bind;
      boundMethod.bind = function(newThis) {
        for (
          var _len = arguments.length,
            args = Array(_len > 1 ? _len - 1 : 0),
            _key = 1;
          _key < _len;
          _key++
        ) {
          args[_key - 1] = arguments[_key];
        }

        // User is trying to bind() an autobound method; we effectively will
        // ignore the value of "this" that the user is trying to use, so
        // let's warn.
        if (newThis !== component && newThis !== null) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): React component methods may only be bound to the ' +
                'component instance. See %s',
              componentName
            );
          }
        } else if (!args.length) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): You are binding a component method to the component. ' +
                'React does this for you automatically in a high-performance ' +
                'way, so you can safely remove this call. See %s',
              componentName
            );
          }
          return boundMethod;
        }
        var reboundMethod = _bind.apply(boundMethod, arguments);
        reboundMethod.__reactBoundContext = component;
        reboundMethod.__reactBoundMethod = method;
        reboundMethod.__reactBoundArguments = args;
        return reboundMethod;
      };
    }
    return boundMethod;
  }

  /**
   * Binds all auto-bound methods in a component.
   *
   * @param {object} component Component whose method is going to be bound.
   */
  function bindAutoBindMethods(component) {
    var pairs = component.__reactAutoBindPairs;
    for (var i = 0; i < pairs.length; i += 2) {
      var autoBindKey = pairs[i];
      var method = pairs[i + 1];
      component[autoBindKey] = bindAutoBindMethod(component, method);
    }
  }

  var IsMountedPreMixin = {
    componentDidMount: function() {
      this.__isMounted = true;
    }
  };

  var IsMountedPostMixin = {
    componentWillUnmount: function() {
      this.__isMounted = false;
    }
  };

  /**
   * Add more to the ReactClass base class. These are all legacy features and
   * therefore not already part of the modern ReactComponent.
   */
  var ReactClassMixin = {
    /**
     * TODO: This will be deprecated because state should always keep a consistent
     * type signature and the only use case for this, is to avoid that.
     */
    replaceState: function(newState, callback) {
      this.updater.enqueueReplaceState(this, newState, callback);
    },

    /**
     * Checks whether or not this composite component is mounted.
     * @return {boolean} True if mounted, false otherwise.
     * @protected
     * @final
     */
    isMounted: function() {
      if (false) {
        warning(
          this.__didWarnIsMounted,
          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
            'subscriptions and pending requests in componentWillUnmount to ' +
            'prevent memory leaks.',
          (this.constructor && this.constructor.displayName) ||
            this.name ||
            'Component'
        );
        this.__didWarnIsMounted = true;
      }
      return !!this.__isMounted;
    }
  };

  var ReactClassComponent = function() {};
  _assign(
    ReactClassComponent.prototype,
    ReactComponent.prototype,
    ReactClassMixin
  );

  /**
   * Creates a composite component class given a class specification.
   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
   *
   * @param {object} spec Class specification (which must define `render`).
   * @return {function} Component constructor function.
   * @public
   */
  function createClass(spec) {
    // To keep our warnings more understandable, we'll use a little hack here to
    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
    // unnecessarily identify a class without displayName as 'Constructor'.
    var Constructor = identity(function(props, context, updater) {
      // This constructor gets overridden by mocks. The argument is used
      // by mocks to assert on what gets mounted.

      if (false) {
        warning(
          this instanceof Constructor,
          'Something is calling a React component directly. Use a factory or ' +
            'JSX instead. See: https://fb.me/react-legacyfactory'
        );
      }

      // Wire up auto-binding
      if (this.__reactAutoBindPairs.length) {
        bindAutoBindMethods(this);
      }

      this.props = props;
      this.context = context;
      this.refs = emptyObject;
      this.updater = updater || ReactNoopUpdateQueue;

      this.state = null;

      // ReactClasses doesn't have constructors. Instead, they use the
      // getInitialState and componentWillMount methods for initialization.

      var initialState = this.getInitialState ? this.getInitialState() : null;
      if (false) {
        // We allow auto-mocks to proceed as if they're returning null.
        if (
          initialState === undefined &&
          this.getInitialState._isMockFunction
        ) {
          // This is probably bad practice. Consider warning here and
          // deprecating this convenience.
          initialState = null;
        }
      }
      _invariant(
        typeof initialState === 'object' && !Array.isArray(initialState),
        '%s.getInitialState(): must return an object or null',
        Constructor.displayName || 'ReactCompositeComponent'
      );

      this.state = initialState;
    });
    Constructor.prototype = new ReactClassComponent();
    Constructor.prototype.constructor = Constructor;
    Constructor.prototype.__reactAutoBindPairs = [];

    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));

    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
    mixSpecIntoComponent(Constructor, spec);
    mixSpecIntoComponent(Constructor, IsMountedPostMixin);

    // Initialize the defaultProps property after all mixins have been merged.
    if (Constructor.getDefaultProps) {
      Constructor.defaultProps = Constructor.getDefaultProps();
    }

    if (false) {
      // This is a tag to indicate that the use of these method names is ok,
      // since it's used with createClass. If it's not, then it's likely a
      // mistake so we'll warn you to use the static property, property
      // initializer or constructor respectively.
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps.isReactClassApproved = {};
      }
      if (Constructor.prototype.getInitialState) {
        Constructor.prototype.getInitialState.isReactClassApproved = {};
      }
    }

    _invariant(
      Constructor.prototype.render,
      'createClass(...): Class specification must implement a `render` method.'
    );

    if (false) {
      warning(
        !Constructor.prototype.componentShouldUpdate,
        '%s has a method called ' +
          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
          'The name is phrased as a question because the function is ' +
          'expected to return a value.',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.componentWillRecieveProps,
        '%s has a method called ' +
          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
          'Did you mean UNSAFE_componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
    }

    // Reduce time spent doing lookups by setting these on the prototype.
    for (var methodName in ReactClassInterface) {
      if (!Constructor.prototype[methodName]) {
        Constructor.prototype[methodName] = null;
      }
    }

    return Constructor;
  }

  return createClass;
}

module.exports = factory;


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */


var _prodInvariant = __webpack_require__(41);

var ReactElement = __webpack_require__(30);

var invariant = __webpack_require__(4);

/**
 * Returns the first child in a collection of children and verifies that there
 * is only one child in the collection.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
 *
 * The current implementation of this function assumes that a single child gets
 * passed without a wrapper, but the purpose of this helper function is to
 * abstract away the particular structure of children.
 *
 * @param {?object} children Child collection structure.
 * @return {ReactElement} The first and only `ReactElement` contained in the
 * structure.
 */
function onlyChild(children) {
  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
  return children;
}

module.exports = onlyChild;

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/



var ReactDOMComponentTree = __webpack_require__(13);
var ReactDefaultInjection = __webpack_require__(192);
var ReactMount = __webpack_require__(127);
var ReactReconciler = __webpack_require__(32);
var ReactUpdates = __webpack_require__(20);
var ReactVersion = __webpack_require__(264);

var findDOMNode = __webpack_require__(265);
var getHostComponentFromComposite = __webpack_require__(128);
var renderSubtreeIntoContainer = __webpack_require__(266);
var warning = __webpack_require__(7);

ReactDefaultInjection.inject();

var ReactDOM = {
  findDOMNode: findDOMNode,
  render: ReactMount.render,
  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
  version: ReactVersion,

  /* eslint-disable camelcase */
  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
  /* eslint-enable camelcase */
};

// Inject the runtime into a devtools global hook regardless of browser.
// Allows for debugging when the hook is injected on the page.
if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
    ComponentTree: {
      getClosestInstanceFromNode: ReactDOMComponentTree.getClosestInstanceFromNode,
      getNodeFromInstance: function (inst) {
        // inst is an internal instance (but could be a composite)
        if (inst._renderedComponent) {
          inst = getHostComponentFromComposite(inst);
        }
        if (inst) {
          return ReactDOMComponentTree.getNodeFromInstance(inst);
        } else {
          return null;
        }
      }
    },
    Mount: ReactMount,
    Reconciler: ReactReconciler
  });
}

if (false) {
  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
    // First check if devtools is not installed
    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
      // If we're in Chrome or Firefox, provide a download link if not installed.
      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
        // Firefox does not have the issue with devtools loaded over file://
        var showFileUrlMessage = window.location.protocol.indexOf('http') === -1 && navigator.userAgent.indexOf('Firefox') === -1;
        console.debug('Download the React DevTools ' + (showFileUrlMessage ? 'and use an HTTP server (instead of a file: URL) ' : '') + 'for a better development experience: ' + 'https://fb.me/react-devtools');
      }
    }

    var testFunc = function testFn() {};
    process.env.NODE_ENV !== 'production' ? warning((testFunc.name || testFunc.toString()).indexOf('testFn') !== -1, "It looks like you're using a minified copy of the development build " + 'of React. When deploying React apps to production, make sure to use ' + 'the production build which skips development warnings and is faster. ' + 'See https://fb.me/react-minification for more details.') : void 0;

    // If we're in IE8, check to see if we are in compatibility mode and provide
    // information on preventing compatibility mode
    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;

    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : void 0;

    var expectedFeatures = [
    // shims
    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.trim];

    for (var i = 0; i < expectedFeatures.length; i++) {
      if (!expectedFeatures[i]) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'One or more ES5 shims expected by React are not available: ' + 'https://fb.me/react-warning-polyfills') : void 0;
        break;
      }
    }
  }
}

if (false) {
  var ReactInstrumentation = require('./ReactInstrumentation');
  var ReactDOMUnknownPropertyHook = require('./ReactDOMUnknownPropertyHook');
  var ReactDOMNullInputValuePropHook = require('./ReactDOMNullInputValuePropHook');
  var ReactDOMInvalidARIAHook = require('./ReactDOMInvalidARIAHook');

  ReactInstrumentation.debugTool.addHook(ReactDOMUnknownPropertyHook);
  ReactInstrumentation.debugTool.addHook(ReactDOMNullInputValuePropHook);
  ReactInstrumentation.debugTool.addHook(ReactDOMInvalidARIAHook);
}

module.exports = ReactDOM;

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ARIADOMPropertyConfig = __webpack_require__(193);
var BeforeInputEventPlugin = __webpack_require__(194);
var ChangeEventPlugin = __webpack_require__(198);
var DefaultEventPluginOrder = __webpack_require__(201);
var EnterLeaveEventPlugin = __webpack_require__(202);
var HTMLDOMPropertyConfig = __webpack_require__(203);
var ReactComponentBrowserEnvironment = __webpack_require__(204);
var ReactDOMComponent = __webpack_require__(210);
var ReactDOMComponentTree = __webpack_require__(13);
var ReactDOMEmptyComponent = __webpack_require__(235);
var ReactDOMTreeTraversal = __webpack_require__(236);
var ReactDOMTextComponent = __webpack_require__(237);
var ReactDefaultBatchingStrategy = __webpack_require__(238);
var ReactEventListener = __webpack_require__(239);
var ReactInjection = __webpack_require__(241);
var ReactReconcileTransaction = __webpack_require__(242);
var SVGDOMPropertyConfig = __webpack_require__(248);
var SelectEventPlugin = __webpack_require__(249);
var SimpleEventPlugin = __webpack_require__(250);

var alreadyInjected = false;

function inject() {
  if (alreadyInjected) {
    // TODO: This is currently true because these injections are shared between
    // the client and the server package. They should be built independently
    // and not share any injection state. Then this problem will be solved.
    return;
  }
  alreadyInjected = true;

  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);

  /**
   * Inject modules for resolving DOM hierarchy and plugin ordering.
   */
  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
  ReactInjection.EventPluginUtils.injectComponentTree(ReactDOMComponentTree);
  ReactInjection.EventPluginUtils.injectTreeTraversal(ReactDOMTreeTraversal);

  /**
   * Some important event plugins included by default (without having to require
   * them).
   */
  ReactInjection.EventPluginHub.injectEventPluginsByName({
    SimpleEventPlugin: SimpleEventPlugin,
    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
    ChangeEventPlugin: ChangeEventPlugin,
    SelectEventPlugin: SelectEventPlugin,
    BeforeInputEventPlugin: BeforeInputEventPlugin
  });

  ReactInjection.HostComponent.injectGenericComponentClass(ReactDOMComponent);

  ReactInjection.HostComponent.injectTextComponentClass(ReactDOMTextComponent);

  ReactInjection.DOMProperty.injectDOMPropertyConfig(ARIADOMPropertyConfig);
  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);

  ReactInjection.EmptyComponent.injectEmptyComponentFactory(function (instantiate) {
    return new ReactDOMEmptyComponent(instantiate);
  });

  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);

  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
}

module.exports = {
  inject: inject
};

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ARIADOMPropertyConfig = {
  Properties: {
    // Global States and Properties
    'aria-current': 0, // state
    'aria-details': 0,
    'aria-disabled': 0, // state
    'aria-hidden': 0, // state
    'aria-invalid': 0, // state
    'aria-keyshortcuts': 0,
    'aria-label': 0,
    'aria-roledescription': 0,
    // Widget Attributes
    'aria-autocomplete': 0,
    'aria-checked': 0,
    'aria-expanded': 0,
    'aria-haspopup': 0,
    'aria-level': 0,
    'aria-modal': 0,
    'aria-multiline': 0,
    'aria-multiselectable': 0,
    'aria-orientation': 0,
    'aria-placeholder': 0,
    'aria-pressed': 0,
    'aria-readonly': 0,
    'aria-required': 0,
    'aria-selected': 0,
    'aria-sort': 0,
    'aria-valuemax': 0,
    'aria-valuemin': 0,
    'aria-valuenow': 0,
    'aria-valuetext': 0,
    // Live Region Attributes
    'aria-atomic': 0,
    'aria-busy': 0,
    'aria-live': 0,
    'aria-relevant': 0,
    // Drag-and-Drop Attributes
    'aria-dropeffect': 0,
    'aria-grabbed': 0,
    // Relationship Attributes
    'aria-activedescendant': 0,
    'aria-colcount': 0,
    'aria-colindex': 0,
    'aria-colspan': 0,
    'aria-controls': 0,
    'aria-describedby': 0,
    'aria-errormessage': 0,
    'aria-flowto': 0,
    'aria-labelledby': 0,
    'aria-owns': 0,
    'aria-posinset': 0,
    'aria-rowcount': 0,
    'aria-rowindex': 0,
    'aria-rowspan': 0,
    'aria-setsize': 0
  },
  DOMAttributeNames: {},
  DOMPropertyNames: {}
};

module.exports = ARIADOMPropertyConfig;

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var EventPropagators = __webpack_require__(42);
var ExecutionEnvironment = __webpack_require__(16);
var FallbackCompositionState = __webpack_require__(195);
var SyntheticCompositionEvent = __webpack_require__(196);
var SyntheticInputEvent = __webpack_require__(197);

var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
var START_KEYCODE = 229;

var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;

var documentMode = null;
if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
  documentMode = document.documentMode;
}

// Webkit offers a very useful `textInput` event that can be used to
// directly represent `beforeInput`. The IE `textinput` event is not as
// useful, so we don't use it.
var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();

// In IE9+, we have access to composition events, but the data supplied
// by the native compositionend event may be incorrect. Japanese ideographic
// spaces, for instance (\u3000) are not recorded correctly.
var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);

/**
 * Opera <= 12 includes TextEvent in window, but does not fire
 * text input events. Rely on keypress instead.
 */
function isPresto() {
  var opera = window.opera;
  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
}

var SPACEBAR_CODE = 32;
var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);

// Events and their corresponding property names.
var eventTypes = {
  beforeInput: {
    phasedRegistrationNames: {
      bubbled: 'onBeforeInput',
      captured: 'onBeforeInputCapture'
    },
    dependencies: ['topCompositionEnd', 'topKeyPress', 'topTextInput', 'topPaste']
  },
  compositionEnd: {
    phasedRegistrationNames: {
      bubbled: 'onCompositionEnd',
      captured: 'onCompositionEndCapture'
    },
    dependencies: ['topBlur', 'topCompositionEnd', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
  },
  compositionStart: {
    phasedRegistrationNames: {
      bubbled: 'onCompositionStart',
      captured: 'onCompositionStartCapture'
    },
    dependencies: ['topBlur', 'topCompositionStart', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
  },
  compositionUpdate: {
    phasedRegistrationNames: {
      bubbled: 'onCompositionUpdate',
      captured: 'onCompositionUpdateCapture'
    },
    dependencies: ['topBlur', 'topCompositionUpdate', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
  }
};

// Track whether we've ever handled a keypress on the space key.
var hasSpaceKeypress = false;

/**
 * Return whether a native keypress event is assumed to be a command.
 * This is required because Firefox fires `keypress` events for key commands
 * (cut, copy, select-all, etc.) even though no character is inserted.
 */
function isKeypressCommand(nativeEvent) {
  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
  !(nativeEvent.ctrlKey && nativeEvent.altKey);
}

/**
 * Translate native top level events into event types.
 *
 * @param {string} topLevelType
 * @return {object}
 */
function getCompositionEventType(topLevelType) {
  switch (topLevelType) {
    case 'topCompositionStart':
      return eventTypes.compositionStart;
    case 'topCompositionEnd':
      return eventTypes.compositionEnd;
    case 'topCompositionUpdate':
      return eventTypes.compositionUpdate;
  }
}

/**
 * Does our fallback best-guess model think this event signifies that
 * composition has begun?
 *
 * @param {string} topLevelType
 * @param {object} nativeEvent
 * @return {boolean}
 */
function isFallbackCompositionStart(topLevelType, nativeEvent) {
  return topLevelType === 'topKeyDown' && nativeEvent.keyCode === START_KEYCODE;
}

/**
 * Does our fallback mode think that this event is the end of composition?
 *
 * @param {string} topLevelType
 * @param {object} nativeEvent
 * @return {boolean}
 */
function isFallbackCompositionEnd(topLevelType, nativeEvent) {
  switch (topLevelType) {
    case 'topKeyUp':
      // Command keys insert or clear IME input.
      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
    case 'topKeyDown':
      // Expect IME keyCode on each keydown. If we get any other
      // code we must have exited earlier.
      return nativeEvent.keyCode !== START_KEYCODE;
    case 'topKeyPress':
    case 'topMouseDown':
    case 'topBlur':
      // Events are not possible without cancelling IME.
      return true;
    default:
      return false;
  }
}

/**
 * Google Input Tools provides composition data via a CustomEvent,
 * with the `data` property populated in the `detail` object. If this
 * is available on the event object, use it. If not, this is a plain
 * composition event and we have nothing special to extract.
 *
 * @param {object} nativeEvent
 * @return {?string}
 */
function getDataFromCustomEvent(nativeEvent) {
  var detail = nativeEvent.detail;
  if (typeof detail === 'object' && 'data' in detail) {
    return detail.data;
  }
  return null;
}

// Track the current IME composition fallback object, if any.
var currentComposition = null;

/**
 * @return {?object} A SyntheticCompositionEvent.
 */
function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
  var eventType;
  var fallbackData;

  if (canUseCompositionEvent) {
    eventType = getCompositionEventType(topLevelType);
  } else if (!currentComposition) {
    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
      eventType = eventTypes.compositionStart;
    }
  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
    eventType = eventTypes.compositionEnd;
  }

  if (!eventType) {
    return null;
  }

  if (useFallbackCompositionData) {
    // The current composition is stored statically and must not be
    // overwritten while composition continues.
    if (!currentComposition && eventType === eventTypes.compositionStart) {
      currentComposition = FallbackCompositionState.getPooled(nativeEventTarget);
    } else if (eventType === eventTypes.compositionEnd) {
      if (currentComposition) {
        fallbackData = currentComposition.getData();
      }
    }
  }

  var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);

  if (fallbackData) {
    // Inject data generated from fallback path into the synthetic event.
    // This matches the property of native CompositionEventInterface.
    event.data = fallbackData;
  } else {
    var customData = getDataFromCustomEvent(nativeEvent);
    if (customData !== null) {
      event.data = customData;
    }
  }

  EventPropagators.accumulateTwoPhaseDispatches(event);
  return event;
}

/**
 * @param {string} topLevelType Record from `EventConstants`.
 * @param {object} nativeEvent Native browser event.
 * @return {?string} The string corresponding to this `beforeInput` event.
 */
function getNativeBeforeInputChars(topLevelType, nativeEvent) {
  switch (topLevelType) {
    case 'topCompositionEnd':
      return getDataFromCustomEvent(nativeEvent);
    case 'topKeyPress':
      /**
       * If native `textInput` events are available, our goal is to make
       * use of them. However, there is a special case: the spacebar key.
       * In Webkit, preventing default on a spacebar `textInput` event
       * cancels character insertion, but it *also* causes the browser
       * to fall back to its default spacebar behavior of scrolling the
       * page.
       *
       * Tracking at:
       * https://code.google.com/p/chromium/issues/detail?id=355103
       *
       * To avoid this issue, use the keypress event as if no `textInput`
       * event is available.
       */
      var which = nativeEvent.which;
      if (which !== SPACEBAR_CODE) {
        return null;
      }

      hasSpaceKeypress = true;
      return SPACEBAR_CHAR;

    case 'topTextInput':
      // Record the characters to be added to the DOM.
      var chars = nativeEvent.data;

      // If it's a spacebar character, assume that we have already handled
      // it at the keypress level and bail immediately. Android Chrome
      // doesn't give us keycodes, so we need to blacklist it.
      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
        return null;
      }

      return chars;

    default:
      // For other native event types, do nothing.
      return null;
  }
}

/**
 * For browsers that do not provide the `textInput` event, extract the
 * appropriate string to use for SyntheticInputEvent.
 *
 * @param {string} topLevelType Record from `EventConstants`.
 * @param {object} nativeEvent Native browser event.
 * @return {?string} The fallback string for this `beforeInput` event.
 */
function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
  // If we are currently composing (IME) and using a fallback to do so,
  // try to extract the composed characters from the fallback object.
  // If composition event is available, we extract a string only at
  // compositionevent, otherwise extract it at fallback events.
  if (currentComposition) {
    if (topLevelType === 'topCompositionEnd' || !canUseCompositionEvent && isFallbackCompositionEnd(topLevelType, nativeEvent)) {
      var chars = currentComposition.getData();
      FallbackCompositionState.release(currentComposition);
      currentComposition = null;
      return chars;
    }
    return null;
  }

  switch (topLevelType) {
    case 'topPaste':
      // If a paste event occurs after a keypress, throw out the input
      // chars. Paste events should not lead to BeforeInput events.
      return null;
    case 'topKeyPress':
      /**
       * As of v27, Firefox may fire keypress events even when no character
       * will be inserted. A few possibilities:
       *
       * - `which` is `0`. Arrow keys, Esc key, etc.
       *
       * - `which` is the pressed key code, but no char is available.
       *   Ex: 'AltGr + d` in Polish. There is no modified character for
       *   this key combination and no character is inserted into the
       *   document, but FF fires the keypress for char code `100` anyway.
       *   No `input` event will occur.
       *
       * - `which` is the pressed key code, but a command combination is
       *   being used. Ex: `Cmd+C`. No character is inserted, and no
       *   `input` event will occur.
       */
      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
        return String.fromCharCode(nativeEvent.which);
      }
      return null;
    case 'topCompositionEnd':
      return useFallbackCompositionData ? null : nativeEvent.data;
    default:
      return null;
  }
}

/**
 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
 * `textInput` or fallback behavior.
 *
 * @return {?object} A SyntheticInputEvent.
 */
function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
  var chars;

  if (canUseTextInputEvent) {
    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
  } else {
    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
  }

  // If no characters are being inserted, no BeforeInput event should
  // be fired.
  if (!chars) {
    return null;
  }

  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);

  event.data = chars;
  EventPropagators.accumulateTwoPhaseDispatches(event);
  return event;
}

/**
 * Create an `onBeforeInput` event to match
 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
 *
 * This event plugin is based on the native `textInput` event
 * available in Chrome, Safari, Opera, and IE. This event fires after
 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
 *
 * `beforeInput` is spec'd but not implemented in any browsers, and
 * the `input` event does not provide any useful information about what has
 * actually been added, contrary to the spec. Thus, `textInput` is the best
 * available event to identify the characters that have actually been inserted
 * into the target node.
 *
 * This plugin is also responsible for emitting `composition` events, thus
 * allowing us to share composition fallback code for both `beforeInput` and
 * `composition` event types.
 */
var BeforeInputEventPlugin = {
  eventTypes: eventTypes,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    return [extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget)];
  }
};

module.exports = BeforeInputEventPlugin;

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(9);

var PooledClass = __webpack_require__(27);

var getTextContentAccessor = __webpack_require__(106);

/**
 * This helper class stores information about text content of a target node,
 * allowing comparison of content before and after a given event.
 *
 * Identify the node where selection currently begins, then observe
 * both its text content and its current position in the DOM. Since the
 * browser may natively replace the target node during composition, we can
 * use its position to find its replacement.
 *
 * @param {DOMEventTarget} root
 */
function FallbackCompositionState(root) {
  this._root = root;
  this._startText = this.getText();
  this._fallbackText = null;
}

_assign(FallbackCompositionState.prototype, {
  destructor: function () {
    this._root = null;
    this._startText = null;
    this._fallbackText = null;
  },

  /**
   * Get current text of input.
   *
   * @return {string}
   */
  getText: function () {
    if ('value' in this._root) {
      return this._root.value;
    }
    return this._root[getTextContentAccessor()];
  },

  /**
   * Determine the differing substring between the initially stored
   * text content and the current content.
   *
   * @return {string}
   */
  getData: function () {
    if (this._fallbackText) {
      return this._fallbackText;
    }

    var start;
    var startValue = this._startText;
    var startLength = startValue.length;
    var end;
    var endValue = this.getText();
    var endLength = endValue.length;

    for (start = 0; start < startLength; start++) {
      if (startValue[start] !== endValue[start]) {
        break;
      }
    }

    var minEnd = startLength - start;
    for (end = 1; end <= minEnd; end++) {
      if (startValue[startLength - end] !== endValue[endLength - end]) {
        break;
      }
    }

    var sliceTail = end > 1 ? 1 - end : undefined;
    this._fallbackText = endValue.slice(start, sliceTail);
    return this._fallbackText;
  }
});

PooledClass.addPoolingTo(FallbackCompositionState);

module.exports = FallbackCompositionState;

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticEvent = __webpack_require__(23);

/**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
 */
var CompositionEventInterface = {
  data: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);

module.exports = SyntheticCompositionEvent;

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticEvent = __webpack_require__(23);

/**
 * @interface Event
 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
 *      /#events-inputevents
 */
var InputEventInterface = {
  data: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);

module.exports = SyntheticInputEvent;

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var EventPluginHub = __webpack_require__(43);
var EventPropagators = __webpack_require__(42);
var ExecutionEnvironment = __webpack_require__(16);
var ReactDOMComponentTree = __webpack_require__(13);
var ReactUpdates = __webpack_require__(20);
var SyntheticEvent = __webpack_require__(23);

var inputValueTracking = __webpack_require__(109);
var getEventTarget = __webpack_require__(70);
var isEventSupported = __webpack_require__(71);
var isTextInputElement = __webpack_require__(110);

var eventTypes = {
  change: {
    phasedRegistrationNames: {
      bubbled: 'onChange',
      captured: 'onChangeCapture'
    },
    dependencies: ['topBlur', 'topChange', 'topClick', 'topFocus', 'topInput', 'topKeyDown', 'topKeyUp', 'topSelectionChange']
  }
};

function createAndAccumulateChangeEvent(inst, nativeEvent, target) {
  var event = SyntheticEvent.getPooled(eventTypes.change, inst, nativeEvent, target);
  event.type = 'change';
  EventPropagators.accumulateTwoPhaseDispatches(event);
  return event;
}
/**
 * For IE shims
 */
var activeElement = null;
var activeElementInst = null;

/**
 * SECTION: handle `change` event
 */
function shouldUseChangeEvent(elem) {
  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
}

var doesChangeEventBubble = false;
if (ExecutionEnvironment.canUseDOM) {
  // See `handleChange` comment below
  doesChangeEventBubble = isEventSupported('change') && (!document.documentMode || document.documentMode > 8);
}

function manualDispatchChangeEvent(nativeEvent) {
  var event = createAndAccumulateChangeEvent(activeElementInst, nativeEvent, getEventTarget(nativeEvent));

  // If change and propertychange bubbled, we'd just bind to it like all the
  // other events and have it go through ReactBrowserEventEmitter. Since it
  // doesn't, we manually listen for the events and so we have to enqueue and
  // process the abstract event manually.
  //
  // Batching is necessary here in order to ensure that all event handlers run
  // before the next rerender (including event handlers attached to ancestor
  // elements instead of directly on the input). Without this, controlled
  // components don't work properly in conjunction with event bubbling because
  // the component is rerendered and the value reverted before all the event
  // handlers can run. See https://github.com/facebook/react/issues/708.
  ReactUpdates.batchedUpdates(runEventInBatch, event);
}

function runEventInBatch(event) {
  EventPluginHub.enqueueEvents(event);
  EventPluginHub.processEventQueue(false);
}

function startWatchingForChangeEventIE8(target, targetInst) {
  activeElement = target;
  activeElementInst = targetInst;
  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
}

function stopWatchingForChangeEventIE8() {
  if (!activeElement) {
    return;
  }
  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
  activeElement = null;
  activeElementInst = null;
}

function getInstIfValueChanged(targetInst, nativeEvent) {
  var updated = inputValueTracking.updateValueIfChanged(targetInst);
  var simulated = nativeEvent.simulated === true && ChangeEventPlugin._allowSimulatedPassThrough;

  if (updated || simulated) {
    return targetInst;
  }
}

function getTargetInstForChangeEvent(topLevelType, targetInst) {
  if (topLevelType === 'topChange') {
    return targetInst;
  }
}

function handleEventsForChangeEventIE8(topLevelType, target, targetInst) {
  if (topLevelType === 'topFocus') {
    // stopWatching() should be a noop here but we call it just in case we
    // missed a blur event somehow.
    stopWatchingForChangeEventIE8();
    startWatchingForChangeEventIE8(target, targetInst);
  } else if (topLevelType === 'topBlur') {
    stopWatchingForChangeEventIE8();
  }
}

/**
 * SECTION: handle `input` event
 */
var isInputEventSupported = false;
if (ExecutionEnvironment.canUseDOM) {
  // IE9 claims to support the input event but fails to trigger it when
  // deleting text, so we ignore its input events.

  isInputEventSupported = isEventSupported('input') && (!document.documentMode || document.documentMode > 9);
}

/**
 * (For IE <=9) Starts tracking propertychange events on the passed-in element
 * and override the value property so that we can distinguish user events from
 * value changes in JS.
 */
function startWatchingForValueChange(target, targetInst) {
  activeElement = target;
  activeElementInst = targetInst;
  activeElement.attachEvent('onpropertychange', handlePropertyChange);
}

/**
 * (For IE <=9) Removes the event listeners from the currently-tracked element,
 * if any exists.
 */
function stopWatchingForValueChange() {
  if (!activeElement) {
    return;
  }
  activeElement.detachEvent('onpropertychange', handlePropertyChange);

  activeElement = null;
  activeElementInst = null;
}

/**
 * (For IE <=9) Handles a propertychange event, sending a `change` event if
 * the value of the active element has changed.
 */
function handlePropertyChange(nativeEvent) {
  if (nativeEvent.propertyName !== 'value') {
    return;
  }
  if (getInstIfValueChanged(activeElementInst, nativeEvent)) {
    manualDispatchChangeEvent(nativeEvent);
  }
}

function handleEventsForInputEventPolyfill(topLevelType, target, targetInst) {
  if (topLevelType === 'topFocus') {
    // In IE8, we can capture almost all .value changes by adding a
    // propertychange handler and looking for events with propertyName
    // equal to 'value'
    // In IE9, propertychange fires for most input events but is buggy and
    // doesn't fire when text is deleted, but conveniently, selectionchange
    // appears to fire in all of the remaining cases so we catch those and
    // forward the event if the value has changed
    // In either case, we don't want to call the event handler if the value
    // is changed from JS so we redefine a setter for `.value` that updates
    // our activeElementValue variable, allowing us to ignore those changes
    //
    // stopWatching() should be a noop here but we call it just in case we
    // missed a blur event somehow.
    stopWatchingForValueChange();
    startWatchingForValueChange(target, targetInst);
  } else if (topLevelType === 'topBlur') {
    stopWatchingForValueChange();
  }
}

// For IE8 and IE9.
function getTargetInstForInputEventPolyfill(topLevelType, targetInst, nativeEvent) {
  if (topLevelType === 'topSelectionChange' || topLevelType === 'topKeyUp' || topLevelType === 'topKeyDown') {
    // On the selectionchange event, the target is just document which isn't
    // helpful for us so just check activeElement instead.
    //
    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
    // propertychange on the first input event after setting `value` from a
    // script and fires only keydown, keypress, keyup. Catching keyup usually
    // gets it and catching keydown lets us fire an event for the first
    // keystroke if user does a key repeat (it'll be a little delayed: right
    // before the second keystroke). Other input methods (e.g., paste) seem to
    // fire selectionchange normally.
    return getInstIfValueChanged(activeElementInst, nativeEvent);
  }
}

/**
 * SECTION: handle `click` event
 */
function shouldUseClickEvent(elem) {
  // Use the `click` event to detect changes to checkbox and radio inputs.
  // This approach works across all browsers, whereas `change` does not fire
  // until `blur` in IE8.
  var nodeName = elem.nodeName;
  return nodeName && nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
}

function getTargetInstForClickEvent(topLevelType, targetInst, nativeEvent) {
  if (topLevelType === 'topClick') {
    return getInstIfValueChanged(targetInst, nativeEvent);
  }
}

function getTargetInstForInputOrChangeEvent(topLevelType, targetInst, nativeEvent) {
  if (topLevelType === 'topInput' || topLevelType === 'topChange') {
    return getInstIfValueChanged(targetInst, nativeEvent);
  }
}

function handleControlledInputBlur(inst, node) {
  // TODO: In IE, inst is occasionally null. Why?
  if (inst == null) {
    return;
  }

  // Fiber and ReactDOM keep wrapper state in separate places
  var state = inst._wrapperState || node._wrapperState;

  if (!state || !state.controlled || node.type !== 'number') {
    return;
  }

  // If controlled, assign the value attribute to the current value on blur
  var value = '' + node.value;
  if (node.getAttribute('value') !== value) {
    node.setAttribute('value', value);
  }
}

/**
 * This plugin creates an `onChange` event that normalizes change events
 * across form elements. This event fires at a time when it's possible to
 * change the element's value without seeing a flicker.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - select
 */
var ChangeEventPlugin = {
  eventTypes: eventTypes,

  _allowSimulatedPassThrough: true,
  _isInputEventSupported: isInputEventSupported,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;

    var getTargetInstFunc, handleEventFunc;
    if (shouldUseChangeEvent(targetNode)) {
      if (doesChangeEventBubble) {
        getTargetInstFunc = getTargetInstForChangeEvent;
      } else {
        handleEventFunc = handleEventsForChangeEventIE8;
      }
    } else if (isTextInputElement(targetNode)) {
      if (isInputEventSupported) {
        getTargetInstFunc = getTargetInstForInputOrChangeEvent;
      } else {
        getTargetInstFunc = getTargetInstForInputEventPolyfill;
        handleEventFunc = handleEventsForInputEventPolyfill;
      }
    } else if (shouldUseClickEvent(targetNode)) {
      getTargetInstFunc = getTargetInstForClickEvent;
    }

    if (getTargetInstFunc) {
      var inst = getTargetInstFunc(topLevelType, targetInst, nativeEvent);
      if (inst) {
        var event = createAndAccumulateChangeEvent(inst, nativeEvent, nativeEventTarget);
        return event;
      }
    }

    if (handleEventFunc) {
      handleEventFunc(topLevelType, targetNode, targetInst);
    }

    // When blurring, set the value attribute for number inputs
    if (topLevelType === 'topBlur') {
      handleControlledInputBlur(targetInst, targetNode);
    }
  }
};

module.exports = ChangeEventPlugin;

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var ReactOwner = __webpack_require__(200);

var ReactRef = {};

function attachRef(ref, component, owner) {
  if (typeof ref === 'function') {
    ref(component.getPublicInstance());
  } else {
    // Legacy ref
    ReactOwner.addComponentAsRefTo(component, ref, owner);
  }
}

function detachRef(ref, component, owner) {
  if (typeof ref === 'function') {
    ref(null);
  } else {
    // Legacy ref
    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
  }
}

ReactRef.attachRefs = function (instance, element) {
  if (element === null || typeof element !== 'object') {
    return;
  }
  var ref = element.ref;
  if (ref != null) {
    attachRef(ref, instance, element._owner);
  }
};

ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
  // If either the owner or a `ref` has changed, make sure the newest owner
  // has stored a reference to `this`, and the previous owner (if different)
  // has forgotten the reference to `this`. We use the element instead
  // of the public this.props because the post processing cannot determine
  // a ref. The ref conceptually lives on the element.

  // TODO: Should this even be possible? The owner cannot change because
  // it's forbidden by shouldUpdateReactComponent. The ref can change
  // if you swap the keys of but not the refs. Reconsider where this check
  // is made. It probably belongs where the key checking and
  // instantiateReactComponent is done.

  var prevRef = null;
  var prevOwner = null;
  if (prevElement !== null && typeof prevElement === 'object') {
    prevRef = prevElement.ref;
    prevOwner = prevElement._owner;
  }

  var nextRef = null;
  var nextOwner = null;
  if (nextElement !== null && typeof nextElement === 'object') {
    nextRef = nextElement.ref;
    nextOwner = nextElement._owner;
  }

  return prevRef !== nextRef ||
  // If owner changes but we have an unchanged function ref, don't update refs
  typeof nextRef === 'string' && nextOwner !== prevOwner;
};

ReactRef.detachRefs = function (instance, element) {
  if (element === null || typeof element !== 'object') {
    return;
  }
  var ref = element.ref;
  if (ref != null) {
    detachRef(ref, instance, element._owner);
  }
};

module.exports = ReactRef;

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(6);

var invariant = __webpack_require__(4);

/**
 * @param {?object} object
 * @return {boolean} True if `object` is a valid owner.
 * @final
 */
function isValidOwner(object) {
  return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
}

/**
 * ReactOwners are capable of storing references to owned components.
 *
 * All components are capable of //being// referenced by owner components, but
 * only ReactOwner components are capable of //referencing// owned components.
 * The named reference is known as a "ref".
 *
 * Refs are available when mounted and updated during reconciliation.
 *
 *   var MyComponent = React.createClass({
 *     render: function() {
 *       return (
 *         <div onClick={this.handleClick}>
 *           <CustomComponent ref="custom" />
 *         </div>
 *       );
 *     },
 *     handleClick: function() {
 *       this.refs.custom.handleClick();
 *     },
 *     componentDidMount: function() {
 *       this.refs.custom.initialize();
 *     }
 *   });
 *
 * Refs should rarely be used. When refs are used, they should only be done to
 * control data that is not handled by React's data flow.
 *
 * @class ReactOwner
 */
var ReactOwner = {
  /**
   * Adds a component by ref to an owner component.
   *
   * @param {ReactComponent} component Component to reference.
   * @param {string} ref Name by which to refer to the component.
   * @param {ReactOwner} owner Component on which to record the ref.
   * @final
   * @internal
   */
  addComponentAsRefTo: function (component, ref, owner) {
    !isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might be adding a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('119') : void 0;
    owner.attachRef(ref, component);
  },

  /**
   * Removes a component by ref from an owner component.
   *
   * @param {ReactComponent} component Component to dereference.
   * @param {string} ref Name of the ref to remove.
   * @param {ReactOwner} owner Component on which the ref is recorded.
   * @final
   * @internal
   */
  removeComponentAsRefFrom: function (component, ref, owner) {
    !isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might be removing a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('120') : void 0;
    var ownerPublicInstance = owner.getPublicInstance();
    // Check that `component`'s owner is still alive and that `component` is still the current ref
    // because we do not want to detach the ref if another component stole it.
    if (ownerPublicInstance && ownerPublicInstance.refs[ref] === component.getPublicInstance()) {
      owner.detachRef(ref);
    }
  }
};

module.exports = ReactOwner;

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Module that is injectable into `EventPluginHub`, that specifies a
 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
 * plugins, without having to package every one of them. This is better than
 * having plugins be ordered in the same order that they are injected because
 * that ordering would be influenced by the packaging order.
 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
 */

var DefaultEventPluginOrder = ['ResponderEventPlugin', 'SimpleEventPlugin', 'TapEventPlugin', 'EnterLeaveEventPlugin', 'ChangeEventPlugin', 'SelectEventPlugin', 'BeforeInputEventPlugin'];

module.exports = DefaultEventPluginOrder;

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var EventPropagators = __webpack_require__(42);
var ReactDOMComponentTree = __webpack_require__(13);
var SyntheticMouseEvent = __webpack_require__(51);

var eventTypes = {
  mouseEnter: {
    registrationName: 'onMouseEnter',
    dependencies: ['topMouseOut', 'topMouseOver']
  },
  mouseLeave: {
    registrationName: 'onMouseLeave',
    dependencies: ['topMouseOut', 'topMouseOver']
  }
};

var EnterLeaveEventPlugin = {
  eventTypes: eventTypes,

  /**
   * For almost every interaction we care about, there will be both a top-level
   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
   * we do not extract duplicate events. However, moving the mouse into the
   * browser from outside will not fire a `mouseout` event. In this case, we use
   * the `mouseover` top-level event.
   */
  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    if (topLevelType === 'topMouseOver' && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
      return null;
    }
    if (topLevelType !== 'topMouseOut' && topLevelType !== 'topMouseOver') {
      // Must not be a mouse in or mouse out - ignoring.
      return null;
    }

    var win;
    if (nativeEventTarget.window === nativeEventTarget) {
      // `nativeEventTarget` is probably a window object.
      win = nativeEventTarget;
    } else {
      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
      var doc = nativeEventTarget.ownerDocument;
      if (doc) {
        win = doc.defaultView || doc.parentWindow;
      } else {
        win = window;
      }
    }

    var from;
    var to;
    if (topLevelType === 'topMouseOut') {
      from = targetInst;
      var related = nativeEvent.relatedTarget || nativeEvent.toElement;
      to = related ? ReactDOMComponentTree.getClosestInstanceFromNode(related) : null;
    } else {
      // Moving to a node from outside the window.
      from = null;
      to = targetInst;
    }

    if (from === to) {
      // Nothing pertains to our managed components.
      return null;
    }

    var fromNode = from == null ? win : ReactDOMComponentTree.getNodeFromInstance(from);
    var toNode = to == null ? win : ReactDOMComponentTree.getNodeFromInstance(to);

    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, from, nativeEvent, nativeEventTarget);
    leave.type = 'mouseleave';
    leave.target = fromNode;
    leave.relatedTarget = toNode;

    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, to, nativeEvent, nativeEventTarget);
    enter.type = 'mouseenter';
    enter.target = toNode;
    enter.relatedTarget = fromNode;

    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, from, to);

    return [leave, enter];
  }
};

module.exports = EnterLeaveEventPlugin;

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var DOMProperty = __webpack_require__(31);

var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;

var HTMLDOMPropertyConfig = {
  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
  Properties: {
    /**
     * Standard Properties
     */
    accept: 0,
    acceptCharset: 0,
    accessKey: 0,
    action: 0,
    allowFullScreen: HAS_BOOLEAN_VALUE,
    allowTransparency: 0,
    alt: 0,
    // specifies target context for links with `preload` type
    as: 0,
    async: HAS_BOOLEAN_VALUE,
    autoComplete: 0,
    // autoFocus is polyfilled/normalized by AutoFocusUtils
    // autoFocus: HAS_BOOLEAN_VALUE,
    autoPlay: HAS_BOOLEAN_VALUE,
    capture: HAS_BOOLEAN_VALUE,
    cellPadding: 0,
    cellSpacing: 0,
    charSet: 0,
    challenge: 0,
    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    cite: 0,
    classID: 0,
    className: 0,
    cols: HAS_POSITIVE_NUMERIC_VALUE,
    colSpan: 0,
    content: 0,
    contentEditable: 0,
    contextMenu: 0,
    controls: HAS_BOOLEAN_VALUE,
    controlsList: 0,
    coords: 0,
    crossOrigin: 0,
    data: 0, // For `<object />` acts as `src`.
    dateTime: 0,
    'default': HAS_BOOLEAN_VALUE,
    defer: HAS_BOOLEAN_VALUE,
    dir: 0,
    disabled: HAS_BOOLEAN_VALUE,
    download: HAS_OVERLOADED_BOOLEAN_VALUE,
    draggable: 0,
    encType: 0,
    form: 0,
    formAction: 0,
    formEncType: 0,
    formMethod: 0,
    formNoValidate: HAS_BOOLEAN_VALUE,
    formTarget: 0,
    frameBorder: 0,
    headers: 0,
    height: 0,
    hidden: HAS_BOOLEAN_VALUE,
    high: 0,
    href: 0,
    hrefLang: 0,
    htmlFor: 0,
    httpEquiv: 0,
    icon: 0,
    id: 0,
    inputMode: 0,
    integrity: 0,
    is: 0,
    keyParams: 0,
    keyType: 0,
    kind: 0,
    label: 0,
    lang: 0,
    list: 0,
    loop: HAS_BOOLEAN_VALUE,
    low: 0,
    manifest: 0,
    marginHeight: 0,
    marginWidth: 0,
    max: 0,
    maxLength: 0,
    media: 0,
    mediaGroup: 0,
    method: 0,
    min: 0,
    minLength: 0,
    // Caution; `option.selected` is not updated if `select.multiple` is
    // disabled with `removeAttribute`.
    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    name: 0,
    nonce: 0,
    noValidate: HAS_BOOLEAN_VALUE,
    open: HAS_BOOLEAN_VALUE,
    optimum: 0,
    pattern: 0,
    placeholder: 0,
    playsInline: HAS_BOOLEAN_VALUE,
    poster: 0,
    preload: 0,
    profile: 0,
    radioGroup: 0,
    readOnly: HAS_BOOLEAN_VALUE,
    referrerPolicy: 0,
    rel: 0,
    required: HAS_BOOLEAN_VALUE,
    reversed: HAS_BOOLEAN_VALUE,
    role: 0,
    rows: HAS_POSITIVE_NUMERIC_VALUE,
    rowSpan: HAS_NUMERIC_VALUE,
    sandbox: 0,
    scope: 0,
    scoped: HAS_BOOLEAN_VALUE,
    scrolling: 0,
    seamless: HAS_BOOLEAN_VALUE,
    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    shape: 0,
    size: HAS_POSITIVE_NUMERIC_VALUE,
    sizes: 0,
    span: HAS_POSITIVE_NUMERIC_VALUE,
    spellCheck: 0,
    src: 0,
    srcDoc: 0,
    srcLang: 0,
    srcSet: 0,
    start: HAS_NUMERIC_VALUE,
    step: 0,
    style: 0,
    summary: 0,
    tabIndex: 0,
    target: 0,
    title: 0,
    // Setting .type throws on non-<input> tags
    type: 0,
    useMap: 0,
    value: 0,
    width: 0,
    wmode: 0,
    wrap: 0,

    /**
     * RDFa Properties
     */
    about: 0,
    datatype: 0,
    inlist: 0,
    prefix: 0,
    // property is also supported for OpenGraph in meta tags.
    property: 0,
    resource: 0,
    'typeof': 0,
    vocab: 0,

    /**
     * Non-standard Properties
     */
    // autoCapitalize and autoCorrect are supported in Mobile Safari for
    // keyboard hints.
    autoCapitalize: 0,
    autoCorrect: 0,
    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
    autoSave: 0,
    // color is for Safari mask-icon link
    color: 0,
    // itemProp, itemScope, itemType are for
    // Microdata support. See http://schema.org/docs/gs.html
    itemProp: 0,
    itemScope: HAS_BOOLEAN_VALUE,
    itemType: 0,
    // itemID and itemRef are for Microdata support as well but
    // only specified in the WHATWG spec document. See
    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
    itemID: 0,
    itemRef: 0,
    // results show looking glass icon and recent searches on input
    // search fields in WebKit/Blink
    results: 0,
    // IE-only attribute that specifies security restrictions on an iframe
    // as an alternative to the sandbox attribute on IE<10
    security: 0,
    // IE-only attribute that controls focus behavior
    unselectable: 0
  },
  DOMAttributeNames: {
    acceptCharset: 'accept-charset',
    className: 'class',
    htmlFor: 'for',
    httpEquiv: 'http-equiv'
  },
  DOMPropertyNames: {},
  DOMMutationMethods: {
    value: function (node, value) {
      if (value == null) {
        return node.removeAttribute('value');
      }

      // Number inputs get special treatment due to some edge cases in
      // Chrome. Let everything else assign the value attribute as normal.
      // https://github.com/facebook/react/issues/7253#issuecomment-236074326
      if (node.type !== 'number' || node.hasAttribute('value') === false) {
        node.setAttribute('value', '' + value);
      } else if (node.validity && !node.validity.badInput && node.ownerDocument.activeElement !== node) {
        // Don't assign an attribute if validation reports bad
        // input. Chrome will clear the value. Additionally, don't
        // operate on inputs that have focus, otherwise Chrome might
        // strip off trailing decimal places and cause the user's
        // cursor position to jump to the beginning of the input.
        //
        // In ReactDOMInput, we have an onBlur event that will trigger
        // this function again when focus is lost.
        node.setAttribute('value', '' + value);
      }
    }
  }
};

module.exports = HTMLDOMPropertyConfig;

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var DOMChildrenOperations = __webpack_require__(73);
var ReactDOMIDOperations = __webpack_require__(209);

/**
 * Abstracts away all functionality of the reconciler that requires knowledge of
 * the browser context. TODO: These callers should be refactored to avoid the
 * need for this injection.
 */
var ReactComponentBrowserEnvironment = {
  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,

  replaceNodeWithMarkup: DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup
};

module.exports = ReactComponentBrowserEnvironment;

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(6);

var DOMLazyTree = __webpack_require__(33);
var ExecutionEnvironment = __webpack_require__(16);

var createNodesFromMarkup = __webpack_require__(206);
var emptyFunction = __webpack_require__(19);
var invariant = __webpack_require__(4);

var Danger = {
  /**
   * Replaces a node with a string of markup at its current position within its
   * parent. The markup must render into a single root node.
   *
   * @param {DOMElement} oldChild Child node to replace.
   * @param {string} markup Markup to render in place of the child node.
   * @internal
   */
  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a worker thread. Make sure `window` and `document` are available globally before requiring React when unit testing or use ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('56') : void 0;
    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : _prodInvariant('57') : void 0;
    !(oldChild.nodeName !== 'HTML') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the <html> node. This is because browser quirks make this unreliable and/or slow. If you want to render to the root you must use server rendering. See ReactDOMServer.renderToString().') : _prodInvariant('58') : void 0;

    if (typeof markup === 'string') {
      var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
      oldChild.parentNode.replaceChild(newChild, oldChild);
    } else {
      DOMLazyTree.replaceChildWithTree(oldChild, markup);
    }
  }
};

module.exports = Danger;

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/*eslint-disable fb-www/unsafe-html*/

var ExecutionEnvironment = __webpack_require__(16);

var createArrayFromMixed = __webpack_require__(207);
var getMarkupWrap = __webpack_require__(208);
var invariant = __webpack_require__(4);

/**
 * Dummy container used to render all markup.
 */
var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;

/**
 * Pattern used by `getNodeName`.
 */
var nodeNamePattern = /^\s*<(\w+)/;

/**
 * Extracts the `nodeName` of the first element in a string of markup.
 *
 * @param {string} markup String of markup.
 * @return {?string} Node name of the supplied markup.
 */
function getNodeName(markup) {
  var nodeNameMatch = markup.match(nodeNamePattern);
  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
}

/**
 * Creates an array containing the nodes rendered from the supplied markup. The
 * optionally supplied `handleScript` function will be invoked once for each
 * <script> element that is rendered. If no `handleScript` function is supplied,
 * an exception is thrown if any <script> elements are rendered.
 *
 * @param {string} markup A string of valid HTML markup.
 * @param {?function} handleScript Invoked once for each rendered <script>.
 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
 */
function createNodesFromMarkup(markup, handleScript) {
  var node = dummyNode;
  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : void 0;
  var nodeName = getNodeName(markup);

  var wrap = nodeName && getMarkupWrap(nodeName);
  if (wrap) {
    node.innerHTML = wrap[1] + markup + wrap[2];

    var wrapDepth = wrap[0];
    while (wrapDepth--) {
      node = node.lastChild;
    }
  } else {
    node.innerHTML = markup;
  }

  var scripts = node.getElementsByTagName('script');
  if (scripts.length) {
    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : void 0;
    createArrayFromMixed(scripts).forEach(handleScript);
  }

  var nodes = Array.from(node.childNodes);
  while (node.lastChild) {
    node.removeChild(node.lastChild);
  }
  return nodes;
}

module.exports = createNodesFromMarkup;

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var invariant = __webpack_require__(4);

/**
 * Convert array-like objects to arrays.
 *
 * This API assumes the caller knows the contents of the data type. For less
 * well defined inputs use createArrayFromMixed.
 *
 * @param {object|function|filelist} obj
 * @return {array}
 */
function toArray(obj) {
  var length = obj.length;

  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
  // in old versions of Safari).
  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;

  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;

  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;

  !(typeof obj.callee !== 'function') ?  false ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;

  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
  // without method will throw during the slice call and skip straight to the
  // fallback.
  if (obj.hasOwnProperty) {
    try {
      return Array.prototype.slice.call(obj);
    } catch (e) {
      // IE < 9 does not support Array#slice on collections objects
    }
  }

  // Fall back to copying key by key. This assumes all keys have a value,
  // so will not preserve sparsely populated inputs.
  var ret = Array(length);
  for (var ii = 0; ii < length; ii++) {
    ret[ii] = obj[ii];
  }
  return ret;
}

/**
 * Perform a heuristic test to determine if an object is "array-like".
 *
 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
 *   Joshu replied: "Mu."
 *
 * This function determines if its argument has "array nature": it returns
 * true if the argument is an actual array, an `arguments' object, or an
 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
 *
 * It will return false for other array-like objects like Filelist.
 *
 * @param {*} obj
 * @return {boolean}
 */
function hasArrayNature(obj) {
  return (
    // not null/false
    !!obj && (
    // arrays are objects, NodeLists are functions in Safari
    typeof obj == 'object' || typeof obj == 'function') &&
    // quacks like an array
    'length' in obj &&
    // not window
    !('setInterval' in obj) &&
    // no DOM node should be considered an array-like
    // a 'select' element has 'length' and 'item' properties on IE8
    typeof obj.nodeType != 'number' && (
    // a real array
    Array.isArray(obj) ||
    // arguments
    'callee' in obj ||
    // HTMLCollection/NodeList
    'item' in obj)
  );
}

/**
 * Ensure that the argument is an array by wrapping it in an array if it is not.
 * Creates a copy of the argument if it is already an array.
 *
 * This is mostly useful idiomatically:
 *
 *   var createArrayFromMixed = require('createArrayFromMixed');
 *
 *   function takesOneOrMoreThings(things) {
 *     things = createArrayFromMixed(things);
 *     ...
 *   }
 *
 * This allows you to treat `things' as an array, but accept scalars in the API.
 *
 * If you need to convert an array-like object, like `arguments`, into an array
 * use toArray instead.
 *
 * @param {*} obj
 * @return {array}
 */
function createArrayFromMixed(obj) {
  if (!hasArrayNature(obj)) {
    return [obj];
  } else if (Array.isArray(obj)) {
    return obj.slice();
  } else {
    return toArray(obj);
  }
}

module.exports = createArrayFromMixed;

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/*eslint-disable fb-www/unsafe-html */

var ExecutionEnvironment = __webpack_require__(16);

var invariant = __webpack_require__(4);

/**
 * Dummy container used to detect which wraps are necessary.
 */
var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;

/**
 * Some browsers cannot use `innerHTML` to render certain elements standalone,
 * so we wrap them, render the wrapped nodes, then extract the desired node.
 *
 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
 */

var shouldWrap = {};

var selectWrap = [1, '<select multiple="true">', '</select>'];
var tableWrap = [1, '<table>', '</table>'];
var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];

var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];

var markupWrap = {
  '*': [1, '?<div>', '</div>'],

  'area': [1, '<map>', '</map>'],
  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
  'legend': [1, '<fieldset>', '</fieldset>'],
  'param': [1, '<object>', '</object>'],
  'tr': [2, '<table><tbody>', '</tbody></table>'],

  'optgroup': selectWrap,
  'option': selectWrap,

  'caption': tableWrap,
  'colgroup': tableWrap,
  'tbody': tableWrap,
  'tfoot': tableWrap,
  'thead': tableWrap,

  'td': trWrap,
  'th': trWrap
};

// Initialize the SVG elements since we know they'll always need to be wrapped
// consistently. If they are created inside a <div> they will be initialized in
// the wrong namespace (and will not display).
var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
svgElements.forEach(function (nodeName) {
  markupWrap[nodeName] = svgWrap;
  shouldWrap[nodeName] = true;
});

/**
 * Gets the markup wrap configuration for the supplied `nodeName`.
 *
 * NOTE: This lazily detects which wraps are necessary for the current browser.
 *
 * @param {string} nodeName Lowercase `nodeName`.
 * @return {?array} Markup wrap configuration, if applicable.
 */
function getMarkupWrap(nodeName) {
  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : void 0;
  if (!markupWrap.hasOwnProperty(nodeName)) {
    nodeName = '*';
  }
  if (!shouldWrap.hasOwnProperty(nodeName)) {
    if (nodeName === '*') {
      dummyNode.innerHTML = '<link />';
    } else {
      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
    }
    shouldWrap[nodeName] = !dummyNode.firstChild;
  }
  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
}

module.exports = getMarkupWrap;

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var DOMChildrenOperations = __webpack_require__(73);
var ReactDOMComponentTree = __webpack_require__(13);

/**
 * Operations used to process updates to DOM nodes.
 */
var ReactDOMIDOperations = {
  /**
   * Updates a component's children by processing a series of updates.
   *
   * @param {array<object>} updates List of update configurations.
   * @internal
   */
  dangerouslyProcessChildrenUpdates: function (parentInst, updates) {
    var node = ReactDOMComponentTree.getNodeFromInstance(parentInst);
    DOMChildrenOperations.processUpdates(node, updates);
  }
};

module.exports = ReactDOMIDOperations;

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/* global hasOwnProperty:true */



var _prodInvariant = __webpack_require__(6),
    _assign = __webpack_require__(9);

var AutoFocusUtils = __webpack_require__(211);
var CSSPropertyOperations = __webpack_require__(212);
var DOMLazyTree = __webpack_require__(33);
var DOMNamespaces = __webpack_require__(74);
var DOMProperty = __webpack_require__(31);
var DOMPropertyOperations = __webpack_require__(115);
var EventPluginHub = __webpack_require__(43);
var EventPluginRegistry = __webpack_require__(67);
var ReactBrowserEventEmitter = __webpack_require__(54);
var ReactDOMComponentFlags = __webpack_require__(103);
var ReactDOMComponentTree = __webpack_require__(13);
var ReactDOMInput = __webpack_require__(222);
var ReactDOMOption = __webpack_require__(224);
var ReactDOMSelect = __webpack_require__(116);
var ReactDOMTextarea = __webpack_require__(225);
var ReactInstrumentation = __webpack_require__(18);
var ReactMultiChild = __webpack_require__(226);
var ReactServerRenderingTransaction = __webpack_require__(233);

var emptyFunction = __webpack_require__(19);
var escapeTextContentForBrowser = __webpack_require__(53);
var invariant = __webpack_require__(4);
var isEventSupported = __webpack_require__(71);
var shallowEqual = __webpack_require__(55);
var inputValueTracking = __webpack_require__(109);
var validateDOMNesting = __webpack_require__(81);
var warning = __webpack_require__(7);

var Flags = ReactDOMComponentFlags;
var deleteListener = EventPluginHub.deleteListener;
var getNode = ReactDOMComponentTree.getNodeFromInstance;
var listenTo = ReactBrowserEventEmitter.listenTo;
var registrationNameModules = EventPluginRegistry.registrationNameModules;

// For quickly matching children type, to test if can be treated as content.
var CONTENT_TYPES = { string: true, number: true };

var STYLE = 'style';
var HTML = '__html';
var RESERVED_PROPS = {
  children: null,
  dangerouslySetInnerHTML: null,
  suppressContentEditableWarning: null
};

// Node type for document fragments (Node.DOCUMENT_FRAGMENT_NODE).
var DOC_FRAGMENT_TYPE = 11;

function getDeclarationErrorAddendum(internalInstance) {
  if (internalInstance) {
    var owner = internalInstance._currentElement._owner || null;
    if (owner) {
      var name = owner.getName();
      if (name) {
        return ' This DOM node was rendered by `' + name + '`.';
      }
    }
  }
  return '';
}

function friendlyStringify(obj) {
  if (typeof obj === 'object') {
    if (Array.isArray(obj)) {
      return '[' + obj.map(friendlyStringify).join(', ') + ']';
    } else {
      var pairs = [];
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
        }
      }
      return '{' + pairs.join(', ') + '}';
    }
  } else if (typeof obj === 'string') {
    return JSON.stringify(obj);
  } else if (typeof obj === 'function') {
    return '[function object]';
  }
  // Differs from JSON.stringify in that undefined because undefined and that
  // inf and nan don't become null
  return String(obj);
}

var styleMutationWarning = {};

function checkAndWarnForMutatedStyle(style1, style2, component) {
  if (style1 == null || style2 == null) {
    return;
  }
  if (shallowEqual(style1, style2)) {
    return;
  }

  var componentName = component._tag;
  var owner = component._currentElement._owner;
  var ownerName;
  if (owner) {
    ownerName = owner.getName();
  }

  var hash = ownerName + '|' + componentName;

  if (styleMutationWarning.hasOwnProperty(hash)) {
    return;
  }

  styleMutationWarning[hash] = true;

   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : void 0;
}

/**
 * @param {object} component
 * @param {?object} props
 */
function assertValidProps(component, props) {
  if (!props) {
    return;
  }
  // Note the use of `==` which checks for null or undefined.
  if (voidElementTags[component._tag]) {
    !(props.children == null && props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '%s is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : _prodInvariant('137', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : void 0;
  }
  if (props.dangerouslySetInnerHTML != null) {
    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : _prodInvariant('60') : void 0;
    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.') : _prodInvariant('61') : void 0;
  }
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : void 0;
    process.env.NODE_ENV !== 'production' ? warning(props.suppressContentEditableWarning || !props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : void 0;
    process.env.NODE_ENV !== 'production' ? warning(props.onFocusIn == null && props.onFocusOut == null, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.') : void 0;
  }
  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + \'em\'}} when using JSX.%s', getDeclarationErrorAddendum(component)) : _prodInvariant('62', getDeclarationErrorAddendum(component)) : void 0;
}

function enqueuePutListener(inst, registrationName, listener, transaction) {
  if (transaction instanceof ReactServerRenderingTransaction) {
    return;
  }
  if (false) {
    // IE8 has no API for event capturing and the `onScroll` event doesn't
    // bubble.
    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), "This browser doesn't support the `onScroll` event") : void 0;
  }
  var containerInfo = inst._hostContainerInfo;
  var isDocumentFragment = containerInfo._node && containerInfo._node.nodeType === DOC_FRAGMENT_TYPE;
  var doc = isDocumentFragment ? containerInfo._node : containerInfo._ownerDocument;
  listenTo(registrationName, doc);
  transaction.getReactMountReady().enqueue(putListener, {
    inst: inst,
    registrationName: registrationName,
    listener: listener
  });
}

function putListener() {
  var listenerToPut = this;
  EventPluginHub.putListener(listenerToPut.inst, listenerToPut.registrationName, listenerToPut.listener);
}

function inputPostMount() {
  var inst = this;
  ReactDOMInput.postMountWrapper(inst);
}

function textareaPostMount() {
  var inst = this;
  ReactDOMTextarea.postMountWrapper(inst);
}

function optionPostMount() {
  var inst = this;
  ReactDOMOption.postMountWrapper(inst);
}

var setAndValidateContentChildDev = emptyFunction;
if (false) {
  setAndValidateContentChildDev = function (content) {
    var hasExistingContent = this._contentDebugID != null;
    var debugID = this._debugID;
    // This ID represents the inlined child that has no backing instance:
    var contentDebugID = -debugID;

    if (content == null) {
      if (hasExistingContent) {
        ReactInstrumentation.debugTool.onUnmountComponent(this._contentDebugID);
      }
      this._contentDebugID = null;
      return;
    }

    validateDOMNesting(null, String(content), this, this._ancestorInfo);
    this._contentDebugID = contentDebugID;
    if (hasExistingContent) {
      ReactInstrumentation.debugTool.onBeforeUpdateComponent(contentDebugID, content);
      ReactInstrumentation.debugTool.onUpdateComponent(contentDebugID);
    } else {
      ReactInstrumentation.debugTool.onBeforeMountComponent(contentDebugID, content, debugID);
      ReactInstrumentation.debugTool.onMountComponent(contentDebugID);
      ReactInstrumentation.debugTool.onSetChildren(debugID, [contentDebugID]);
    }
  };
}

// There are so many media events, it makes sense to just
// maintain a list rather than create a `trapBubbledEvent` for each
var mediaEvents = {
  topAbort: 'abort',
  topCanPlay: 'canplay',
  topCanPlayThrough: 'canplaythrough',
  topDurationChange: 'durationchange',
  topEmptied: 'emptied',
  topEncrypted: 'encrypted',
  topEnded: 'ended',
  topError: 'error',
  topLoadedData: 'loadeddata',
  topLoadedMetadata: 'loadedmetadata',
  topLoadStart: 'loadstart',
  topPause: 'pause',
  topPlay: 'play',
  topPlaying: 'playing',
  topProgress: 'progress',
  topRateChange: 'ratechange',
  topSeeked: 'seeked',
  topSeeking: 'seeking',
  topStalled: 'stalled',
  topSuspend: 'suspend',
  topTimeUpdate: 'timeupdate',
  topVolumeChange: 'volumechange',
  topWaiting: 'waiting'
};

function trackInputValue() {
  inputValueTracking.track(this);
}

function trapBubbledEventsLocal() {
  var inst = this;
  // If a component renders to null or if another component fatals and causes
  // the state of the tree to be corrupted, `node` here can be null.
  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : _prodInvariant('63') : void 0;
  var node = getNode(inst);
  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : _prodInvariant('64') : void 0;

  switch (inst._tag) {
    case 'iframe':
    case 'object':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
      break;
    case 'video':
    case 'audio':
      inst._wrapperState.listeners = [];
      // Create listener for each media event
      for (var event in mediaEvents) {
        if (mediaEvents.hasOwnProperty(event)) {
          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(event, mediaEvents[event], node));
        }
      }
      break;
    case 'source':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node)];
      break;
    case 'img':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node), ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
      break;
    case 'form':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topReset', 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent('topSubmit', 'submit', node)];
      break;
    case 'input':
    case 'select':
    case 'textarea':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topInvalid', 'invalid', node)];
      break;
  }
}

function postUpdateSelectWrapper() {
  ReactDOMSelect.postUpdateWrapper(this);
}

// For HTML, certain tags should omit their close tag. We keep a whitelist for
// those special-case tags.

var omittedCloseTags = {
  area: true,
  base: true,
  br: true,
  col: true,
  embed: true,
  hr: true,
  img: true,
  input: true,
  keygen: true,
  link: true,
  meta: true,
  param: true,
  source: true,
  track: true,
  wbr: true
  // NOTE: menuitem's close tag should be omitted, but that causes problems.
};

var newlineEatingTags = {
  listing: true,
  pre: true,
  textarea: true
};

// For HTML, certain tags cannot have children. This has the same purpose as
// `omittedCloseTags` except that `menuitem` should still have its closing tag.

var voidElementTags = _assign({
  menuitem: true
}, omittedCloseTags);

// We accept any tag to be rendered but since this gets injected into arbitrary
// HTML, we want to make sure that it's a safe tag.
// http://www.w3.org/TR/REC-xml/#NT-Name

var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
var validatedTagCache = {};
var hasOwnProperty = {}.hasOwnProperty;

function validateDangerousTag(tag) {
  if (!hasOwnProperty.call(validatedTagCache, tag)) {
    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : _prodInvariant('65', tag) : void 0;
    validatedTagCache[tag] = true;
  }
}

function isCustomComponent(tagName, props) {
  return tagName.indexOf('-') >= 0 || props.is != null;
}

var globalIdCounter = 1;

/**
 * Creates a new React class that is idempotent and capable of containing other
 * React components. It accepts event listeners and DOM properties that are
 * valid according to `DOMProperty`.
 *
 *  - Event listeners: `onClick`, `onMouseDown`, etc.
 *  - DOM properties: `className`, `name`, `title`, etc.
 *
 * The `style` property functions differently from the DOM API. It accepts an
 * object mapping of style properties to values.
 *
 * @constructor ReactDOMComponent
 * @extends ReactMultiChild
 */
function ReactDOMComponent(element) {
  var tag = element.type;
  validateDangerousTag(tag);
  this._currentElement = element;
  this._tag = tag.toLowerCase();
  this._namespaceURI = null;
  this._renderedChildren = null;
  this._previousStyle = null;
  this._previousStyleCopy = null;
  this._hostNode = null;
  this._hostParent = null;
  this._rootNodeID = 0;
  this._domID = 0;
  this._hostContainerInfo = null;
  this._wrapperState = null;
  this._topLevelWrapper = null;
  this._flags = 0;
  if (false) {
    this._ancestorInfo = null;
    setAndValidateContentChildDev.call(this, null);
  }
}

ReactDOMComponent.displayName = 'ReactDOMComponent';

ReactDOMComponent.Mixin = {
  /**
   * Generates root tag markup then recurses. This method has side effects and
   * is not idempotent.
   *
   * @internal
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {?ReactDOMComponent} the parent component instance
   * @param {?object} info about the host container
   * @param {object} context
   * @return {string} The computed markup.
   */
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    this._rootNodeID = globalIdCounter++;
    this._domID = hostContainerInfo._idCounter++;
    this._hostParent = hostParent;
    this._hostContainerInfo = hostContainerInfo;

    var props = this._currentElement.props;

    switch (this._tag) {
      case 'audio':
      case 'form':
      case 'iframe':
      case 'img':
      case 'link':
      case 'object':
      case 'source':
      case 'video':
        this._wrapperState = {
          listeners: null
        };
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
      case 'input':
        ReactDOMInput.mountWrapper(this, props, hostParent);
        props = ReactDOMInput.getHostProps(this, props);
        transaction.getReactMountReady().enqueue(trackInputValue, this);
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
      case 'option':
        ReactDOMOption.mountWrapper(this, props, hostParent);
        props = ReactDOMOption.getHostProps(this, props);
        break;
      case 'select':
        ReactDOMSelect.mountWrapper(this, props, hostParent);
        props = ReactDOMSelect.getHostProps(this, props);
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
      case 'textarea':
        ReactDOMTextarea.mountWrapper(this, props, hostParent);
        props = ReactDOMTextarea.getHostProps(this, props);
        transaction.getReactMountReady().enqueue(trackInputValue, this);
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
    }

    assertValidProps(this, props);

    // We create tags in the namespace of their parent container, except HTML
    // tags get no namespace.
    var namespaceURI;
    var parentTag;
    if (hostParent != null) {
      namespaceURI = hostParent._namespaceURI;
      parentTag = hostParent._tag;
    } else if (hostContainerInfo._tag) {
      namespaceURI = hostContainerInfo._namespaceURI;
      parentTag = hostContainerInfo._tag;
    }
    if (namespaceURI == null || namespaceURI === DOMNamespaces.svg && parentTag === 'foreignobject') {
      namespaceURI = DOMNamespaces.html;
    }
    if (namespaceURI === DOMNamespaces.html) {
      if (this._tag === 'svg') {
        namespaceURI = DOMNamespaces.svg;
      } else if (this._tag === 'math') {
        namespaceURI = DOMNamespaces.mathml;
      }
    }
    this._namespaceURI = namespaceURI;

    if (false) {
      var parentInfo;
      if (hostParent != null) {
        parentInfo = hostParent._ancestorInfo;
      } else if (hostContainerInfo._tag) {
        parentInfo = hostContainerInfo._ancestorInfo;
      }
      if (parentInfo) {
        // parentInfo should always be present except for the top-level
        // component when server rendering
        validateDOMNesting(this._tag, null, this, parentInfo);
      }
      this._ancestorInfo = validateDOMNesting.updatedAncestorInfo(parentInfo, this._tag, this);
    }

    var mountImage;
    if (transaction.useCreateElement) {
      var ownerDocument = hostContainerInfo._ownerDocument;
      var el;
      if (namespaceURI === DOMNamespaces.html) {
        if (this._tag === 'script') {
          // Create the script via .innerHTML so its "parser-inserted" flag is
          // set to true and it does not execute
          var div = ownerDocument.createElement('div');
          var type = this._currentElement.type;
          div.innerHTML = '<' + type + '></' + type + '>';
          el = div.removeChild(div.firstChild);
        } else if (props.is) {
          el = ownerDocument.createElement(this._currentElement.type, props.is);
        } else {
          // Separate else branch instead of using `props.is || undefined` above becuase of a Firefox bug.
          // See discussion in https://github.com/facebook/react/pull/6896
          // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
          el = ownerDocument.createElement(this._currentElement.type);
        }
      } else {
        el = ownerDocument.createElementNS(namespaceURI, this._currentElement.type);
      }
      ReactDOMComponentTree.precacheNode(this, el);
      this._flags |= Flags.hasCachedChildNodes;
      if (!this._hostParent) {
        DOMPropertyOperations.setAttributeForRoot(el);
      }
      this._updateDOMProperties(null, props, transaction);
      var lazyTree = DOMLazyTree(el);
      this._createInitialChildren(transaction, props, context, lazyTree);
      mountImage = lazyTree;
    } else {
      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
      var tagContent = this._createContentMarkup(transaction, props, context);
      if (!tagContent && omittedCloseTags[this._tag]) {
        mountImage = tagOpen + '/>';
      } else {
        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
      }
    }

    switch (this._tag) {
      case 'input':
        transaction.getReactMountReady().enqueue(inputPostMount, this);
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'textarea':
        transaction.getReactMountReady().enqueue(textareaPostMount, this);
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'select':
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'button':
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'option':
        transaction.getReactMountReady().enqueue(optionPostMount, this);
        break;
    }

    return mountImage;
  },

  /**
   * Creates markup for the open tag and all attributes.
   *
   * This method has side effects because events get registered.
   *
   * Iterating over object properties is faster than iterating over arrays.
   * @see http://jsperf.com/obj-vs-arr-iteration
   *
   * @private
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} props
   * @return {string} Markup of opening tag.
   */
  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
    var ret = '<' + this._currentElement.type;

    for (var propKey in props) {
      if (!props.hasOwnProperty(propKey)) {
        continue;
      }
      var propValue = props[propKey];
      if (propValue == null) {
        continue;
      }
      if (registrationNameModules.hasOwnProperty(propKey)) {
        if (propValue) {
          enqueuePutListener(this, propKey, propValue, transaction);
        }
      } else {
        if (propKey === STYLE) {
          if (propValue) {
            if (false) {
              // See `_updateDOMProperties`. style block
              this._previousStyle = propValue;
            }
            propValue = this._previousStyleCopy = _assign({}, props.style);
          }
          propValue = CSSPropertyOperations.createMarkupForStyles(propValue, this);
        }
        var markup = null;
        if (this._tag != null && isCustomComponent(this._tag, props)) {
          if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
          }
        } else {
          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
        }
        if (markup) {
          ret += ' ' + markup;
        }
      }
    }

    // For static pages, no need to put React ID and checksum. Saves lots of
    // bytes.
    if (transaction.renderToStaticMarkup) {
      return ret;
    }

    if (!this._hostParent) {
      ret += ' ' + DOMPropertyOperations.createMarkupForRoot();
    }
    ret += ' ' + DOMPropertyOperations.createMarkupForID(this._domID);
    return ret;
  },

  /**
   * Creates markup for the content between the tags.
   *
   * @private
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} props
   * @param {object} context
   * @return {string} Content markup.
   */
  _createContentMarkup: function (transaction, props, context) {
    var ret = '';

    // Intentional use of != to avoid catching zero/false.
    var innerHTML = props.dangerouslySetInnerHTML;
    if (innerHTML != null) {
      if (innerHTML.__html != null) {
        ret = innerHTML.__html;
      }
    } else {
      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
      var childrenToUse = contentToUse != null ? null : props.children;
      if (contentToUse != null) {
        // TODO: Validate that text is allowed as a child of this node
        ret = escapeTextContentForBrowser(contentToUse);
        if (false) {
          setAndValidateContentChildDev.call(this, contentToUse);
        }
      } else if (childrenToUse != null) {
        var mountImages = this.mountChildren(childrenToUse, transaction, context);
        ret = mountImages.join('');
      }
    }
    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
      // text/html ignores the first character in these tags if it's a newline
      // Prefer to break application/xml over text/html (for now) by adding
      // a newline specifically to get eaten by the parser. (Alternately for
      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
      // \r is normalized out by HTMLTextAreaElement#value.)
      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
      // See: Parsing of "textarea" "listing" and "pre" elements
      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
      return '\n' + ret;
    } else {
      return ret;
    }
  },

  _createInitialChildren: function (transaction, props, context, lazyTree) {
    // Intentional use of != to avoid catching zero/false.
    var innerHTML = props.dangerouslySetInnerHTML;
    if (innerHTML != null) {
      if (innerHTML.__html != null) {
        DOMLazyTree.queueHTML(lazyTree, innerHTML.__html);
      }
    } else {
      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
      var childrenToUse = contentToUse != null ? null : props.children;
      // TODO: Validate that text is allowed as a child of this node
      if (contentToUse != null) {
        // Avoid setting textContent when the text is empty. In IE11 setting
        // textContent on a text area will cause the placeholder to not
        // show within the textarea until it has been focused and blurred again.
        // https://github.com/facebook/react/issues/6731#issuecomment-254874553
        if (contentToUse !== '') {
          if (false) {
            setAndValidateContentChildDev.call(this, contentToUse);
          }
          DOMLazyTree.queueText(lazyTree, contentToUse);
        }
      } else if (childrenToUse != null) {
        var mountImages = this.mountChildren(childrenToUse, transaction, context);
        for (var i = 0; i < mountImages.length; i++) {
          DOMLazyTree.queueChild(lazyTree, mountImages[i]);
        }
      }
    }
  },

  /**
   * Receives a next element and updates the component.
   *
   * @internal
   * @param {ReactElement} nextElement
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} context
   */
  receiveComponent: function (nextElement, transaction, context) {
    var prevElement = this._currentElement;
    this._currentElement = nextElement;
    this.updateComponent(transaction, prevElement, nextElement, context);
  },

  /**
   * Updates a DOM component after it has already been allocated and
   * attached to the DOM. Reconciles the root DOM node, then recurses.
   *
   * @param {ReactReconcileTransaction} transaction
   * @param {ReactElement} prevElement
   * @param {ReactElement} nextElement
   * @internal
   * @overridable
   */
  updateComponent: function (transaction, prevElement, nextElement, context) {
    var lastProps = prevElement.props;
    var nextProps = this._currentElement.props;

    switch (this._tag) {
      case 'input':
        lastProps = ReactDOMInput.getHostProps(this, lastProps);
        nextProps = ReactDOMInput.getHostProps(this, nextProps);
        break;
      case 'option':
        lastProps = ReactDOMOption.getHostProps(this, lastProps);
        nextProps = ReactDOMOption.getHostProps(this, nextProps);
        break;
      case 'select':
        lastProps = ReactDOMSelect.getHostProps(this, lastProps);
        nextProps = ReactDOMSelect.getHostProps(this, nextProps);
        break;
      case 'textarea':
        lastProps = ReactDOMTextarea.getHostProps(this, lastProps);
        nextProps = ReactDOMTextarea.getHostProps(this, nextProps);
        break;
    }

    assertValidProps(this, nextProps);
    this._updateDOMProperties(lastProps, nextProps, transaction);
    this._updateDOMChildren(lastProps, nextProps, transaction, context);

    switch (this._tag) {
      case 'input':
        // Update the wrapper around inputs *after* updating props. This has to
        // happen after `_updateDOMProperties`. Otherwise HTML5 input validations
        // raise warnings and prevent the new value from being assigned.
        ReactDOMInput.updateWrapper(this);

        // We also check that we haven't missed a value update, such as a
        // Radio group shifting the checked value to another named radio input.
        inputValueTracking.updateValueIfChanged(this);
        break;
      case 'textarea':
        ReactDOMTextarea.updateWrapper(this);
        break;
      case 'select':
        // <select> value update needs to occur after <option> children
        // reconciliation
        transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
        break;
    }
  },

  /**
   * Reconciles the properties by detecting differences in property values and
   * updating the DOM as necessary. This function is probably the single most
   * critical path for performance optimization.
   *
   * TODO: Benchmark whether checking for changed values in memory actually
   *       improves performance (especially statically positioned elements).
   * TODO: Benchmark the effects of putting this at the top since 99% of props
   *       do not change for a given reconciliation.
   * TODO: Benchmark areas that can be improved with caching.
   *
   * @private
   * @param {object} lastProps
   * @param {object} nextProps
   * @param {?DOMElement} node
   */
  _updateDOMProperties: function (lastProps, nextProps, transaction) {
    var propKey;
    var styleName;
    var styleUpdates;
    for (propKey in lastProps) {
      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
        continue;
      }
      if (propKey === STYLE) {
        var lastStyle = this._previousStyleCopy;
        for (styleName in lastStyle) {
          if (lastStyle.hasOwnProperty(styleName)) {
            styleUpdates = styleUpdates || {};
            styleUpdates[styleName] = '';
          }
        }
        this._previousStyleCopy = null;
      } else if (registrationNameModules.hasOwnProperty(propKey)) {
        if (lastProps[propKey]) {
          // Only call deleteListener if there was a listener previously or
          // else willDeleteListener gets called when there wasn't actually a
          // listener (e.g., onClick={null})
          deleteListener(this, propKey);
        }
      } else if (isCustomComponent(this._tag, lastProps)) {
        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
          DOMPropertyOperations.deleteValueForAttribute(getNode(this), propKey);
        }
      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
        DOMPropertyOperations.deleteValueForProperty(getNode(this), propKey);
      }
    }
    for (propKey in nextProps) {
      var nextProp = nextProps[propKey];
      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps != null ? lastProps[propKey] : undefined;
      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
        continue;
      }
      if (propKey === STYLE) {
        if (nextProp) {
          if (false) {
            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
            this._previousStyle = nextProp;
          }
          nextProp = this._previousStyleCopy = _assign({}, nextProp);
        } else {
          this._previousStyleCopy = null;
        }
        if (lastProp) {
          // Unset styles on `lastProp` but not on `nextProp`.
          for (styleName in lastProp) {
            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
              styleUpdates = styleUpdates || {};
              styleUpdates[styleName] = '';
            }
          }
          // Update styles that changed since `lastProp`.
          for (styleName in nextProp) {
            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
              styleUpdates = styleUpdates || {};
              styleUpdates[styleName] = nextProp[styleName];
            }
          }
        } else {
          // Relies on `updateStylesByID` not mutating `styleUpdates`.
          styleUpdates = nextProp;
        }
      } else if (registrationNameModules.hasOwnProperty(propKey)) {
        if (nextProp) {
          enqueuePutListener(this, propKey, nextProp, transaction);
        } else if (lastProp) {
          deleteListener(this, propKey);
        }
      } else if (isCustomComponent(this._tag, nextProps)) {
        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
          DOMPropertyOperations.setValueForAttribute(getNode(this), propKey, nextProp);
        }
      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
        var node = getNode(this);
        // If we're updating to null or undefined, we should remove the property
        // from the DOM node instead of inadvertently setting to a string. This
        // brings us in line with the same behavior we have on initial render.
        if (nextProp != null) {
          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
        } else {
          DOMPropertyOperations.deleteValueForProperty(node, propKey);
        }
      }
    }
    if (styleUpdates) {
      CSSPropertyOperations.setValueForStyles(getNode(this), styleUpdates, this);
    }
  },

  /**
   * Reconciles the children with the various properties that affect the
   * children content.
   *
   * @param {object} lastProps
   * @param {object} nextProps
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   */
  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;

    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;

    // Note the use of `!=` which checks for null or undefined.
    var lastChildren = lastContent != null ? null : lastProps.children;
    var nextChildren = nextContent != null ? null : nextProps.children;

    // If we're switching from children to content/html or vice versa, remove
    // the old content
    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
    if (lastChildren != null && nextChildren == null) {
      this.updateChildren(null, transaction, context);
    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
      this.updateTextContent('');
      if (false) {
        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
      }
    }

    if (nextContent != null) {
      if (lastContent !== nextContent) {
        this.updateTextContent('' + nextContent);
        if (false) {
          setAndValidateContentChildDev.call(this, nextContent);
        }
      }
    } else if (nextHtml != null) {
      if (lastHtml !== nextHtml) {
        this.updateMarkup('' + nextHtml);
      }
      if (false) {
        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
      }
    } else if (nextChildren != null) {
      if (false) {
        setAndValidateContentChildDev.call(this, null);
      }

      this.updateChildren(nextChildren, transaction, context);
    }
  },

  getHostNode: function () {
    return getNode(this);
  },

  /**
   * Destroys all event registrations for this instance. Does not remove from
   * the DOM. That must be done by the parent.
   *
   * @internal
   */
  unmountComponent: function (safely) {
    switch (this._tag) {
      case 'audio':
      case 'form':
      case 'iframe':
      case 'img':
      case 'link':
      case 'object':
      case 'source':
      case 'video':
        var listeners = this._wrapperState.listeners;
        if (listeners) {
          for (var i = 0; i < listeners.length; i++) {
            listeners[i].remove();
          }
        }
        break;
      case 'input':
      case 'textarea':
        inputValueTracking.stopTracking(this);
        break;
      case 'html':
      case 'head':
      case 'body':
        /**
         * Components like <html> <head> and <body> can't be removed or added
         * easily in a cross-browser way, however it's valuable to be able to
         * take advantage of React's reconciliation for styling and <title>
         * management. So we just document it and throw in dangerous cases.
         */
         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is impossible to unmount some top-level components (eg <html>, <head>, and <body>) reliably and efficiently. To fix this, have a single top-level component that never unmounts render these elements.', this._tag) : _prodInvariant('66', this._tag) : void 0;
        break;
    }

    this.unmountChildren(safely);
    ReactDOMComponentTree.uncacheNode(this);
    EventPluginHub.deleteAllListeners(this);
    this._rootNodeID = 0;
    this._domID = 0;
    this._wrapperState = null;

    if (false) {
      setAndValidateContentChildDev.call(this, null);
    }
  },

  getPublicInstance: function () {
    return getNode(this);
  }
};

_assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);

module.exports = ReactDOMComponent;

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactDOMComponentTree = __webpack_require__(13);

var focusNode = __webpack_require__(113);

var AutoFocusUtils = {
  focusDOMComponent: function () {
    focusNode(ReactDOMComponentTree.getNodeFromInstance(this));
  }
};

module.exports = AutoFocusUtils;

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var CSSProperty = __webpack_require__(114);
var ExecutionEnvironment = __webpack_require__(16);
var ReactInstrumentation = __webpack_require__(18);

var camelizeStyleName = __webpack_require__(213);
var dangerousStyleValue = __webpack_require__(215);
var hyphenateStyleName = __webpack_require__(216);
var memoizeStringOnly = __webpack_require__(218);
var warning = __webpack_require__(7);

var processStyleName = memoizeStringOnly(function (styleName) {
  return hyphenateStyleName(styleName);
});

var hasShorthandPropertyBug = false;
var styleFloatAccessor = 'cssFloat';
if (ExecutionEnvironment.canUseDOM) {
  var tempStyle = document.createElement('div').style;
  try {
    // IE8 throws "Invalid argument." if resetting shorthand style properties.
    tempStyle.font = '';
  } catch (e) {
    hasShorthandPropertyBug = true;
  }
  // IE8 only supports accessing cssFloat (standard) as styleFloat
  if (document.documentElement.style.cssFloat === undefined) {
    styleFloatAccessor = 'styleFloat';
  }
}

if (false) {
  // 'msTransform' is correct, but the other prefixes should be capitalized
  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;

  // style values shouldn't contain a semicolon
  var badStyleValueWithSemicolonPattern = /;\s*$/;

  var warnedStyleNames = {};
  var warnedStyleValues = {};
  var warnedForNaNValue = false;

  var warnHyphenatedStyleName = function (name, owner) {
    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
      return;
    }

    warnedStyleNames[name] = true;
    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner)) : void 0;
  };

  var warnBadVendoredStyleName = function (name, owner) {
    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
      return;
    }

    warnedStyleNames[name] = true;
    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
  };

  var warnStyleValueWithSemicolon = function (name, value, owner) {
    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
      return;
    }

    warnedStyleValues[value] = true;
    process.env.NODE_ENV !== 'production' ? warning(false, "Style property values shouldn't contain a semicolon.%s " + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
  };

  var warnStyleValueIsNaN = function (name, value, owner) {
    if (warnedForNaNValue) {
      return;
    }

    warnedForNaNValue = true;
    process.env.NODE_ENV !== 'production' ? warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
  };

  var checkRenderMessage = function (owner) {
    if (owner) {
      var name = owner.getName();
      if (name) {
        return ' Check the render method of `' + name + '`.';
      }
    }
    return '';
  };

  /**
   * @param {string} name
   * @param {*} value
   * @param {ReactDOMComponent} component
   */
  var warnValidStyle = function (name, value, component) {
    var owner;
    if (component) {
      owner = component._currentElement._owner;
    }
    if (name.indexOf('-') > -1) {
      warnHyphenatedStyleName(name, owner);
    } else if (badVendoredStyleNamePattern.test(name)) {
      warnBadVendoredStyleName(name, owner);
    } else if (badStyleValueWithSemicolonPattern.test(value)) {
      warnStyleValueWithSemicolon(name, value, owner);
    }

    if (typeof value === 'number' && isNaN(value)) {
      warnStyleValueIsNaN(name, value, owner);
    }
  };
}

/**
 * Operations for dealing with CSS properties.
 */
var CSSPropertyOperations = {
  /**
   * Serializes a mapping of style properties for use as inline styles:
   *
   *   > createMarkupForStyles({width: '200px', height: 0})
   *   "width:200px;height:0;"
   *
   * Undefined values are ignored so that declarative programming is easier.
   * The result should be HTML-escaped before insertion into the DOM.
   *
   * @param {object} styles
   * @param {ReactDOMComponent} component
   * @return {?string}
   */
  createMarkupForStyles: function (styles, component) {
    var serialized = '';
    for (var styleName in styles) {
      if (!styles.hasOwnProperty(styleName)) {
        continue;
      }
      var isCustomProperty = styleName.indexOf('--') === 0;
      var styleValue = styles[styleName];
      if (false) {
        if (!isCustomProperty) {
          warnValidStyle(styleName, styleValue, component);
        }
      }
      if (styleValue != null) {
        serialized += processStyleName(styleName) + ':';
        serialized += dangerousStyleValue(styleName, styleValue, component, isCustomProperty) + ';';
      }
    }
    return serialized || null;
  },

  /**
   * Sets the value for multiple styles on a node.  If a value is specified as
   * '' (empty string), the corresponding style property will be unset.
   *
   * @param {DOMElement} node
   * @param {object} styles
   * @param {ReactDOMComponent} component
   */
  setValueForStyles: function (node, styles, component) {
    if (false) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: component._debugID,
        type: 'update styles',
        payload: styles
      });
    }

    var style = node.style;
    for (var styleName in styles) {
      if (!styles.hasOwnProperty(styleName)) {
        continue;
      }
      var isCustomProperty = styleName.indexOf('--') === 0;
      if (false) {
        if (!isCustomProperty) {
          warnValidStyle(styleName, styles[styleName], component);
        }
      }
      var styleValue = dangerousStyleValue(styleName, styles[styleName], component, isCustomProperty);
      if (styleName === 'float' || styleName === 'cssFloat') {
        styleName = styleFloatAccessor;
      }
      if (isCustomProperty) {
        style.setProperty(styleName, styleValue);
      } else if (styleValue) {
        style[styleName] = styleValue;
      } else {
        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
        if (expansion) {
          // Shorthand property that IE8 won't like unsetting, so unset each
          // component to placate it
          for (var individualStyleName in expansion) {
            style[individualStyleName] = '';
          }
        } else {
          style[styleName] = '';
        }
      }
    }
  }
};

module.exports = CSSPropertyOperations;

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */



var camelize = __webpack_require__(214);

var msPattern = /^-ms-/;

/**
 * Camelcases a hyphenated CSS property name, for example:
 *
 *   > camelizeStyleName('background-color')
 *   < "backgroundColor"
 *   > camelizeStyleName('-moz-transition')
 *   < "MozTransition"
 *   > camelizeStyleName('-ms-transition')
 *   < "msTransition"
 *
 * As Andi Smith suggests
 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
 * is converted to lowercase `ms`.
 *
 * @param {string} string
 * @return {string}
 */
function camelizeStyleName(string) {
  return camelize(string.replace(msPattern, 'ms-'));
}

module.exports = camelizeStyleName;

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var _hyphenPattern = /-(.)/g;

/**
 * Camelcases a hyphenated string, for example:
 *
 *   > camelize('background-color')
 *   < "backgroundColor"
 *
 * @param {string} string
 * @return {string}
 */
function camelize(string) {
  return string.replace(_hyphenPattern, function (_, character) {
    return character.toUpperCase();
  });
}

module.exports = camelize;

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var CSSProperty = __webpack_require__(114);
var warning = __webpack_require__(7);

var isUnitlessNumber = CSSProperty.isUnitlessNumber;
var styleWarnings = {};

/**
 * Convert a value into the proper css writable value. The style name `name`
 * should be logical (no hyphens), as specified
 * in `CSSProperty.isUnitlessNumber`.
 *
 * @param {string} name CSS property name such as `topMargin`.
 * @param {*} value CSS property value such as `10px`.
 * @param {ReactDOMComponent} component
 * @return {string} Normalized style value with dimensions applied.
 */
function dangerousStyleValue(name, value, component, isCustomProperty) {
  // Note that we've removed escapeTextForBrowser() calls here since the
  // whole string will be escaped when the attribute is injected into
  // the markup. If you provide unsafe user data here they can inject
  // arbitrary CSS which may be problematic (I couldn't repro this):
  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
  // This is not an XSS hole but instead a potential CSS injection issue
  // which has lead to a greater discussion about how we're going to
  // trust URLs moving forward. See #2115901

  var isEmpty = value == null || typeof value === 'boolean' || value === '';
  if (isEmpty) {
    return '';
  }

  var isNonNumeric = isNaN(value);
  if (isCustomProperty || isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
    return '' + value; // cast to string
  }

  if (typeof value === 'string') {
    if (false) {
      // Allow '0' to pass through without warning. 0 is already special and
      // doesn't require units, so we don't need to warn about it.
      if (component && value !== '0') {
        var owner = component._currentElement._owner;
        var ownerName = owner ? owner.getName() : null;
        if (ownerName && !styleWarnings[ownerName]) {
          styleWarnings[ownerName] = {};
        }
        var warned = false;
        if (ownerName) {
          var warnings = styleWarnings[ownerName];
          warned = warnings[name];
          if (!warned) {
            warnings[name] = true;
          }
        }
        if (!warned) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
        }
      }
    }
    value = value.trim();
  }
  return value + 'px';
}

module.exports = dangerousStyleValue;

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */



var hyphenate = __webpack_require__(217);

var msPattern = /^ms-/;

/**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenateStyleName(string) {
  return hyphenate(string).replace(msPattern, '-ms-');
}

module.exports = hyphenateStyleName;

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var _uppercasePattern = /([A-Z])/g;

/**
 * Hyphenates a camelcased string, for example:
 *
 *   > hyphenate('backgroundColor')
 *   < "background-color"
 *
 * For CSS style names, use `hyphenateStyleName` instead which works properly
 * with all vendor prefixes, including `ms`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenate(string) {
  return string.replace(_uppercasePattern, '-$1').toLowerCase();
}

module.exports = hyphenate;

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @typechecks static-only
 */



/**
 * Memoizes the return value of a function that accepts one string argument.
 */

function memoizeStringOnly(callback) {
  var cache = {};
  return function (string) {
    if (!cache.hasOwnProperty(string)) {
      cache[string] = callback.call(this, string);
    }
    return cache[string];
  };
}

module.exports = memoizeStringOnly;

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var escapeTextContentForBrowser = __webpack_require__(53);

/**
 * Escapes attribute value to prevent scripting attacks.
 *
 * @param {*} value Value to escape.
 * @return {string} An escaped string.
 */
function quoteAttributeValueForBrowser(value) {
  return '"' + escapeTextContentForBrowser(value) + '"';
}

module.exports = quoteAttributeValueForBrowser;

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var EventPluginHub = __webpack_require__(43);

function runEventQueueInBatch(events) {
  EventPluginHub.enqueueEvents(events);
  EventPluginHub.processEventQueue(false);
}

var ReactEventEmitterMixin = {
  /**
   * Streams a fired top-level event to `EventPluginHub` where plugins have the
   * opportunity to create `ReactEvent`s to be dispatched.
   */
  handleTopLevel: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var events = EventPluginHub.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
    runEventQueueInBatch(events);
  }
};

module.exports = ReactEventEmitterMixin;

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ExecutionEnvironment = __webpack_require__(16);

/**
 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
 *
 * @param {string} styleProp
 * @param {string} eventName
 * @returns {object}
 */
function makePrefixMap(styleProp, eventName) {
  var prefixes = {};

  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
  prefixes['Moz' + styleProp] = 'moz' + eventName;
  prefixes['ms' + styleProp] = 'MS' + eventName;
  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();

  return prefixes;
}

/**
 * A list of event names to a configurable list of vendor prefixes.
 */
var vendorPrefixes = {
  animationend: makePrefixMap('Animation', 'AnimationEnd'),
  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
  animationstart: makePrefixMap('Animation', 'AnimationStart'),
  transitionend: makePrefixMap('Transition', 'TransitionEnd')
};

/**
 * Event names that have already been detected and prefixed (if applicable).
 */
var prefixedEventNames = {};

/**
 * Element to check for prefixes on.
 */
var style = {};

/**
 * Bootstrap if a DOM exists.
 */
if (ExecutionEnvironment.canUseDOM) {
  style = document.createElement('div').style;

  // On some platforms, in particular some releases of Android 4.x,
  // the un-prefixed "animation" and "transition" properties are defined on the
  // style object but the events that fire will still be prefixed, so we need
  // to check if the un-prefixed events are usable, and if not remove them from the map.
  if (!('AnimationEvent' in window)) {
    delete vendorPrefixes.animationend.animation;
    delete vendorPrefixes.animationiteration.animation;
    delete vendorPrefixes.animationstart.animation;
  }

  // Same as above
  if (!('TransitionEvent' in window)) {
    delete vendorPrefixes.transitionend.transition;
  }
}

/**
 * Attempts to determine the correct vendor prefixed event name.
 *
 * @param {string} eventName
 * @returns {string}
 */
function getVendorPrefixedEventName(eventName) {
  if (prefixedEventNames[eventName]) {
    return prefixedEventNames[eventName];
  } else if (!vendorPrefixes[eventName]) {
    return eventName;
  }

  var prefixMap = vendorPrefixes[eventName];

  for (var styleProp in prefixMap) {
    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
      return prefixedEventNames[eventName] = prefixMap[styleProp];
    }
  }

  return '';
}

module.exports = getVendorPrefixedEventName;

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(6),
    _assign = __webpack_require__(9);

var DOMPropertyOperations = __webpack_require__(115);
var LinkedValueUtils = __webpack_require__(76);
var ReactDOMComponentTree = __webpack_require__(13);
var ReactUpdates = __webpack_require__(20);

var invariant = __webpack_require__(4);
var warning = __webpack_require__(7);

var didWarnValueLink = false;
var didWarnCheckedLink = false;
var didWarnValueDefaultValue = false;
var didWarnCheckedDefaultChecked = false;
var didWarnControlledToUncontrolled = false;
var didWarnUncontrolledToControlled = false;

function forceUpdateIfMounted() {
  if (this._rootNodeID) {
    // DOM component is still mounted; update
    ReactDOMInput.updateWrapper(this);
  }
}

function isControlled(props) {
  var usesChecked = props.type === 'checkbox' || props.type === 'radio';
  return usesChecked ? props.checked != null : props.value != null;
}

/**
 * Implements an <input> host component that allows setting these optional
 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
 *
 * If `checked` or `value` are not supplied (or null/undefined), user actions
 * that affect the checked state or value will trigger updates to the element.
 *
 * If they are supplied (and not null/undefined), the rendered element will not
 * trigger updates to the element. Instead, the props must change in order for
 * the rendered element to be updated.
 *
 * The rendered element will be initialized as unchecked (or `defaultChecked`)
 * with an empty value (or `defaultValue`).
 *
 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
 */
var ReactDOMInput = {
  getHostProps: function (inst, props) {
    var value = LinkedValueUtils.getValue(props);
    var checked = LinkedValueUtils.getChecked(props);

    var hostProps = _assign({
      // Make sure we set .type before any other properties (setting .value
      // before .type means .value is lost in IE11 and below)
      type: undefined,
      // Make sure we set .step before .value (setting .value before .step
      // means .value is rounded on mount, based upon step precision)
      step: undefined,
      // Make sure we set .min & .max before .value (to ensure proper order
      // in corner cases such as min or max deriving from value, e.g. Issue #7170)
      min: undefined,
      max: undefined
    }, props, {
      defaultChecked: undefined,
      defaultValue: undefined,
      value: value != null ? value : inst._wrapperState.initialValue,
      checked: checked != null ? checked : inst._wrapperState.initialChecked,
      onChange: inst._wrapperState.onChange
    });

    return hostProps;
  },

  mountWrapper: function (inst, props) {
    if (false) {
      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);

      var owner = inst._currentElement._owner;

      if (props.valueLink !== undefined && !didWarnValueLink) {
        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
        didWarnValueLink = true;
      }
      if (props.checkedLink !== undefined && !didWarnCheckedLink) {
        process.env.NODE_ENV !== 'production' ? warning(false, '`checkedLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
        didWarnCheckedLink = true;
      }
      if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnCheckedDefaultChecked = true;
      }
      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnValueDefaultValue = true;
      }
    }

    var defaultValue = props.defaultValue;
    inst._wrapperState = {
      initialChecked: props.checked != null ? props.checked : props.defaultChecked,
      initialValue: props.value != null ? props.value : defaultValue,
      listeners: null,
      onChange: _handleChange.bind(inst),
      controlled: isControlled(props)
    };
  },

  updateWrapper: function (inst) {
    var props = inst._currentElement.props;

    if (false) {
      var controlled = isControlled(props);
      var owner = inst._currentElement._owner;

      if (!inst._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing an uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnUncontrolledToControlled = true;
      }
      if (inst._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnControlledToUncontrolled = true;
      }
    }

    // TODO: Shouldn't this be getChecked(props)?
    var checked = props.checked;
    if (checked != null) {
      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'checked', checked || false);
    }

    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var value = LinkedValueUtils.getValue(props);
    if (value != null) {
      if (value === 0 && node.value === '') {
        node.value = '0';
        // Note: IE9 reports a number inputs as 'text', so check props instead.
      } else if (props.type === 'number') {
        // Simulate `input.valueAsNumber`. IE9 does not support it
        var valueAsNumber = parseFloat(node.value, 10) || 0;

        if (
        // eslint-disable-next-line
        value != valueAsNumber ||
        // eslint-disable-next-line
        value == valueAsNumber && node.value != value) {
          // Cast `value` to a string to ensure the value is set correctly. While
          // browsers typically do this as necessary, jsdom doesn't.
          node.value = '' + value;
        }
      } else if (node.value !== '' + value) {
        // Cast `value` to a string to ensure the value is set correctly. While
        // browsers typically do this as necessary, jsdom doesn't.
        node.value = '' + value;
      }
    } else {
      if (props.value == null && props.defaultValue != null) {
        // In Chrome, assigning defaultValue to certain input types triggers input validation.
        // For number inputs, the display value loses trailing decimal points. For email inputs,
        // Chrome raises "The specified value <x> is not a valid email address".
        //
        // Here we check to see if the defaultValue has actually changed, avoiding these problems
        // when the user is inputting text
        //
        // https://github.com/facebook/react/issues/7253
        if (node.defaultValue !== '' + props.defaultValue) {
          node.defaultValue = '' + props.defaultValue;
        }
      }
      if (props.checked == null && props.defaultChecked != null) {
        node.defaultChecked = !!props.defaultChecked;
      }
    }
  },

  postMountWrapper: function (inst) {
    var props = inst._currentElement.props;

    // This is in postMount because we need access to the DOM node, which is not
    // available until after the component has mounted.
    var node = ReactDOMComponentTree.getNodeFromInstance(inst);

    // Detach value from defaultValue. We won't do anything if we're working on
    // submit or reset inputs as those values & defaultValues are linked. They
    // are not resetable nodes so this operation doesn't matter and actually
    // removes browser-default values (eg "Submit Query") when no value is
    // provided.

    switch (props.type) {
      case 'submit':
      case 'reset':
        break;
      case 'color':
      case 'date':
      case 'datetime':
      case 'datetime-local':
      case 'month':
      case 'time':
      case 'week':
        // This fixes the no-show issue on iOS Safari and Android Chrome:
        // https://github.com/facebook/react/issues/7233
        node.value = '';
        node.value = node.defaultValue;
        break;
      default:
        node.value = node.value;
        break;
    }

    // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
    // this is needed to work around a chrome bug where setting defaultChecked
    // will sometimes influence the value of checked (even after detachment).
    // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
    // We need to temporarily unset name to avoid disrupting radio button groups.
    var name = node.name;
    if (name !== '') {
      node.name = '';
    }
    node.defaultChecked = !node.defaultChecked;
    node.defaultChecked = !node.defaultChecked;
    if (name !== '') {
      node.name = name;
    }
  }
};

function _handleChange(event) {
  var props = this._currentElement.props;

  var returnValue = LinkedValueUtils.executeOnChange(props, event);

  // Here we use asap to wait until all updates have propagated, which
  // is important when using controlled components within layers:
  // https://github.com/facebook/react/issues/1698
  ReactUpdates.asap(forceUpdateIfMounted, this);

  var name = props.name;
  if (props.type === 'radio' && name != null) {
    var rootNode = ReactDOMComponentTree.getNodeFromInstance(this);
    var queryRoot = rootNode;

    while (queryRoot.parentNode) {
      queryRoot = queryRoot.parentNode;
    }

    // If `rootNode.form` was non-null, then we could try `form.elements`,
    // but that sometimes behaves strangely in IE8. We could also try using
    // `form.getElementsByName`, but that will only return direct children
    // and won't include inputs that use the HTML5 `form=` attribute. Since
    // the input might not even be in a form, let's just use the global
    // `querySelectorAll` to ensure we don't miss anything.
    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');

    for (var i = 0; i < group.length; i++) {
      var otherNode = group[i];
      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
        continue;
      }
      // This will throw if radio buttons rendered by different copies of React
      // and the same name are rendered into the same form (same as #1939).
      // That's probably okay; we don't support it just as we don't support
      // mixing React radio buttons with non-React ones.
      var otherInstance = ReactDOMComponentTree.getInstanceFromNode(otherNode);
      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.') : _prodInvariant('90') : void 0;
      // If this is a controlled radio button group, forcing the input that
      // was previously checked to update will cause it to be come re-checked
      // as appropriate.
      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
    }
  }

  return returnValue;
}

module.exports = ReactDOMInput;

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(9);

var React = __webpack_require__(29);
var ReactDOMComponentTree = __webpack_require__(13);
var ReactDOMSelect = __webpack_require__(116);

var warning = __webpack_require__(7);
var didWarnInvalidOptionChildren = false;

function flattenChildren(children) {
  var content = '';

  // Flatten children and warn if they aren't strings or numbers;
  // invalid types are ignored.
  React.Children.forEach(children, function (child) {
    if (child == null) {
      return;
    }
    if (typeof child === 'string' || typeof child === 'number') {
      content += child;
    } else if (!didWarnInvalidOptionChildren) {
      didWarnInvalidOptionChildren = true;
       false ? warning(false, 'Only strings and numbers are supported as <option> children.') : void 0;
    }
  });

  return content;
}

/**
 * Implements an <option> host component that warns when `selected` is set.
 */
var ReactDOMOption = {
  mountWrapper: function (inst, props, hostParent) {
    // TODO (yungsters): Remove support for `selected` in <option>.
    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : void 0;
    }

    // Look up whether this option is 'selected'
    var selectValue = null;
    if (hostParent != null) {
      var selectParent = hostParent;

      if (selectParent._tag === 'optgroup') {
        selectParent = selectParent._hostParent;
      }

      if (selectParent != null && selectParent._tag === 'select') {
        selectValue = ReactDOMSelect.getSelectValueContext(selectParent);
      }
    }

    // If the value is null (e.g., no specified value or after initial mount)
    // or missing (e.g., for <datalist>), we don't change props.selected
    var selected = null;
    if (selectValue != null) {
      var value;
      if (props.value != null) {
        value = props.value + '';
      } else {
        value = flattenChildren(props.children);
      }
      selected = false;
      if (Array.isArray(selectValue)) {
        // multiple
        for (var i = 0; i < selectValue.length; i++) {
          if ('' + selectValue[i] === value) {
            selected = true;
            break;
          }
        }
      } else {
        selected = '' + selectValue === value;
      }
    }

    inst._wrapperState = { selected: selected };
  },

  postMountWrapper: function (inst) {
    // value="" should make a value attribute (#6219)
    var props = inst._currentElement.props;
    if (props.value != null) {
      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
      node.setAttribute('value', props.value);
    }
  },

  getHostProps: function (inst, props) {
    var hostProps = _assign({ selected: undefined, children: undefined }, props);

    // Read state only from initial mount because <select> updates value
    // manually; we need the initial state only for server rendering
    if (inst._wrapperState.selected != null) {
      hostProps.selected = inst._wrapperState.selected;
    }

    var content = flattenChildren(props.children);

    if (content) {
      hostProps.children = content;
    }

    return hostProps;
  }
};

module.exports = ReactDOMOption;

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(6),
    _assign = __webpack_require__(9);

var LinkedValueUtils = __webpack_require__(76);
var ReactDOMComponentTree = __webpack_require__(13);
var ReactUpdates = __webpack_require__(20);

var invariant = __webpack_require__(4);
var warning = __webpack_require__(7);

var didWarnValueLink = false;
var didWarnValDefaultVal = false;

function forceUpdateIfMounted() {
  if (this._rootNodeID) {
    // DOM component is still mounted; update
    ReactDOMTextarea.updateWrapper(this);
  }
}

/**
 * Implements a <textarea> host component that allows setting `value`, and
 * `defaultValue`. This differs from the traditional DOM API because value is
 * usually set as PCDATA children.
 *
 * If `value` is not supplied (or null/undefined), user actions that affect the
 * value will trigger updates to the element.
 *
 * If `value` is supplied (and not null/undefined), the rendered element will
 * not trigger updates to the element. Instead, the `value` prop must change in
 * order for the rendered element to be updated.
 *
 * The rendered element will be initialized with an empty value, the prop
 * `defaultValue` if specified, or the children content (deprecated).
 */
var ReactDOMTextarea = {
  getHostProps: function (inst, props) {
    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : _prodInvariant('91') : void 0;

    // Always set children to the same thing. In IE9, the selection range will
    // get reset if `textContent` is mutated.  We could add a check in setTextContent
    // to only set the value if/when the value differs from the node value (which would
    // completely solve this IE9 bug), but Sebastian+Ben seemed to like this solution.
    // The value can be a boolean or object so that's why it's forced to be a string.
    var hostProps = _assign({}, props, {
      value: undefined,
      defaultValue: undefined,
      children: '' + inst._wrapperState.initialValue,
      onChange: inst._wrapperState.onChange
    });

    return hostProps;
  },

  mountWrapper: function (inst, props) {
    if (false) {
      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
      if (props.valueLink !== undefined && !didWarnValueLink) {
        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `textarea` is deprecated; set `value` and `onChange` instead.') : void 0;
        didWarnValueLink = true;
      }
      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
        didWarnValDefaultVal = true;
      }
    }

    var value = LinkedValueUtils.getValue(props);
    var initialValue = value;

    // Only bother fetching default value if we're going to use it
    if (value == null) {
      var defaultValue = props.defaultValue;
      // TODO (yungsters): Remove support for children content in <textarea>.
      var children = props.children;
      if (children != null) {
        if (false) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : void 0;
        }
        !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : _prodInvariant('92') : void 0;
        if (Array.isArray(children)) {
          !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : _prodInvariant('93') : void 0;
          children = children[0];
        }

        defaultValue = '' + children;
      }
      if (defaultValue == null) {
        defaultValue = '';
      }
      initialValue = defaultValue;
    }

    inst._wrapperState = {
      initialValue: '' + initialValue,
      listeners: null,
      onChange: _handleChange.bind(inst)
    };
  },

  updateWrapper: function (inst) {
    var props = inst._currentElement.props;

    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var value = LinkedValueUtils.getValue(props);
    if (value != null) {
      // Cast `value` to a string to ensure the value is set correctly. While
      // browsers typically do this as necessary, jsdom doesn't.
      var newValue = '' + value;

      // To avoid side effects (such as losing text selection), only set value if changed
      if (newValue !== node.value) {
        node.value = newValue;
      }
      if (props.defaultValue == null) {
        node.defaultValue = newValue;
      }
    }
    if (props.defaultValue != null) {
      node.defaultValue = props.defaultValue;
    }
  },

  postMountWrapper: function (inst) {
    // This is in postMount because we need access to the DOM node, which is not
    // available until after the component has mounted.
    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var textContent = node.textContent;

    // Only set node.value if textContent is equal to the expected
    // initial value. In IE10/IE11 there is a bug where the placeholder attribute
    // will populate textContent as well.
    // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
    if (textContent === inst._wrapperState.initialValue) {
      node.value = textContent;
    }
  }
};

function _handleChange(event) {
  var props = this._currentElement.props;
  var returnValue = LinkedValueUtils.executeOnChange(props, event);
  ReactUpdates.asap(forceUpdateIfMounted, this);
  return returnValue;
}

module.exports = ReactDOMTextarea;

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(6);

var ReactComponentEnvironment = __webpack_require__(77);
var ReactInstanceMap = __webpack_require__(45);
var ReactInstrumentation = __webpack_require__(18);

var ReactCurrentOwner = __webpack_require__(22);
var ReactReconciler = __webpack_require__(32);
var ReactChildReconciler = __webpack_require__(227);

var emptyFunction = __webpack_require__(19);
var flattenChildren = __webpack_require__(232);
var invariant = __webpack_require__(4);

/**
 * Make an update for markup to be rendered and inserted at a supplied index.
 *
 * @param {string} markup Markup that renders into an element.
 * @param {number} toIndex Destination index.
 * @private
 */
function makeInsertMarkup(markup, afterNode, toIndex) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'INSERT_MARKUP',
    content: markup,
    fromIndex: null,
    fromNode: null,
    toIndex: toIndex,
    afterNode: afterNode
  };
}

/**
 * Make an update for moving an existing element to another index.
 *
 * @param {number} fromIndex Source index of the existing element.
 * @param {number} toIndex Destination index of the element.
 * @private
 */
function makeMove(child, afterNode, toIndex) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'MOVE_EXISTING',
    content: null,
    fromIndex: child._mountIndex,
    fromNode: ReactReconciler.getHostNode(child),
    toIndex: toIndex,
    afterNode: afterNode
  };
}

/**
 * Make an update for removing an element at an index.
 *
 * @param {number} fromIndex Index of the element to remove.
 * @private
 */
function makeRemove(child, node) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'REMOVE_NODE',
    content: null,
    fromIndex: child._mountIndex,
    fromNode: node,
    toIndex: null,
    afterNode: null
  };
}

/**
 * Make an update for setting the markup of a node.
 *
 * @param {string} markup Markup that renders into an element.
 * @private
 */
function makeSetMarkup(markup) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'SET_MARKUP',
    content: markup,
    fromIndex: null,
    fromNode: null,
    toIndex: null,
    afterNode: null
  };
}

/**
 * Make an update for setting the text content.
 *
 * @param {string} textContent Text content to set.
 * @private
 */
function makeTextContent(textContent) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'TEXT_CONTENT',
    content: textContent,
    fromIndex: null,
    fromNode: null,
    toIndex: null,
    afterNode: null
  };
}

/**
 * Push an update, if any, onto the queue. Creates a new queue if none is
 * passed and always returns the queue. Mutative.
 */
function enqueue(queue, update) {
  if (update) {
    queue = queue || [];
    queue.push(update);
  }
  return queue;
}

/**
 * Processes any enqueued updates.
 *
 * @private
 */
function processQueue(inst, updateQueue) {
  ReactComponentEnvironment.processChildrenUpdates(inst, updateQueue);
}

var setChildrenForInstrumentation = emptyFunction;
if (false) {
  var getDebugID = function (inst) {
    if (!inst._debugID) {
      // Check for ART-like instances. TODO: This is silly/gross.
      var internal;
      if (internal = ReactInstanceMap.get(inst)) {
        inst = internal;
      }
    }
    return inst._debugID;
  };
  setChildrenForInstrumentation = function (children) {
    var debugID = getDebugID(this);
    // TODO: React Native empty components are also multichild.
    // This means they still get into this method but don't have _debugID.
    if (debugID !== 0) {
      ReactInstrumentation.debugTool.onSetChildren(debugID, children ? Object.keys(children).map(function (key) {
        return children[key]._debugID;
      }) : []);
    }
  };
}

/**
 * ReactMultiChild are capable of reconciling multiple children.
 *
 * @class ReactMultiChild
 * @internal
 */
var ReactMultiChild = {
  /**
   * Provides common functionality for components that must reconcile multiple
   * children. This is used by `ReactDOMComponent` to mount, update, and
   * unmount child components.
   *
   * @lends {ReactMultiChild.prototype}
   */
  Mixin: {
    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
      if (false) {
        var selfDebugID = getDebugID(this);
        if (this._currentElement) {
          try {
            ReactCurrentOwner.current = this._currentElement._owner;
            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context, selfDebugID);
          } finally {
            ReactCurrentOwner.current = null;
          }
        }
      }
      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
    },

    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context) {
      var nextChildren;
      var selfDebugID = 0;
      if (false) {
        selfDebugID = getDebugID(this);
        if (this._currentElement) {
          try {
            ReactCurrentOwner.current = this._currentElement._owner;
            nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
          } finally {
            ReactCurrentOwner.current = null;
          }
          ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
          return nextChildren;
        }
      }
      nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
      ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
      return nextChildren;
    },

    /**
     * Generates a "mount image" for each of the supplied children. In the case
     * of `ReactDOMComponent`, a mount image is a string of markup.
     *
     * @param {?object} nestedChildren Nested child maps.
     * @return {array} An array of mounted representations.
     * @internal
     */
    mountChildren: function (nestedChildren, transaction, context) {
      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
      this._renderedChildren = children;

      var mountImages = [];
      var index = 0;
      for (var name in children) {
        if (children.hasOwnProperty(name)) {
          var child = children[name];
          var selfDebugID = 0;
          if (false) {
            selfDebugID = getDebugID(this);
          }
          var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._hostContainerInfo, context, selfDebugID);
          child._mountIndex = index++;
          mountImages.push(mountImage);
        }
      }

      if (false) {
        setChildrenForInstrumentation.call(this, children);
      }

      return mountImages;
    },

    /**
     * Replaces any rendered children with a text content string.
     *
     * @param {string} nextContent String of content.
     * @internal
     */
    updateTextContent: function (nextContent) {
      var prevChildren = this._renderedChildren;
      // Remove any rendered children.
      ReactChildReconciler.unmountChildren(prevChildren, false);
      for (var name in prevChildren) {
        if (prevChildren.hasOwnProperty(name)) {
           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
        }
      }
      // Set new text content.
      var updates = [makeTextContent(nextContent)];
      processQueue(this, updates);
    },

    /**
     * Replaces any rendered children with a markup string.
     *
     * @param {string} nextMarkup String of markup.
     * @internal
     */
    updateMarkup: function (nextMarkup) {
      var prevChildren = this._renderedChildren;
      // Remove any rendered children.
      ReactChildReconciler.unmountChildren(prevChildren, false);
      for (var name in prevChildren) {
        if (prevChildren.hasOwnProperty(name)) {
           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
        }
      }
      var updates = [makeSetMarkup(nextMarkup)];
      processQueue(this, updates);
    },

    /**
     * Updates the rendered children with new children.
     *
     * @param {?object} nextNestedChildrenElements Nested child element maps.
     * @param {ReactReconcileTransaction} transaction
     * @internal
     */
    updateChildren: function (nextNestedChildrenElements, transaction, context) {
      // Hook used by React ART
      this._updateChildren(nextNestedChildrenElements, transaction, context);
    },

    /**
     * @param {?object} nextNestedChildrenElements Nested child element maps.
     * @param {ReactReconcileTransaction} transaction
     * @final
     * @protected
     */
    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
      var prevChildren = this._renderedChildren;
      var removedNodes = {};
      var mountImages = [];
      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context);
      if (!nextChildren && !prevChildren) {
        return;
      }
      var updates = null;
      var name;
      // `nextIndex` will increment for each child in `nextChildren`, but
      // `lastIndex` will be the last index visited in `prevChildren`.
      var nextIndex = 0;
      var lastIndex = 0;
      // `nextMountIndex` will increment for each newly mounted child.
      var nextMountIndex = 0;
      var lastPlacedNode = null;
      for (name in nextChildren) {
        if (!nextChildren.hasOwnProperty(name)) {
          continue;
        }
        var prevChild = prevChildren && prevChildren[name];
        var nextChild = nextChildren[name];
        if (prevChild === nextChild) {
          updates = enqueue(updates, this.moveChild(prevChild, lastPlacedNode, nextIndex, lastIndex));
          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
          prevChild._mountIndex = nextIndex;
        } else {
          if (prevChild) {
            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
            // The `removedNodes` loop below will actually remove the child.
          }
          // The child must be instantiated before it's mounted.
          updates = enqueue(updates, this._mountChildAtIndex(nextChild, mountImages[nextMountIndex], lastPlacedNode, nextIndex, transaction, context));
          nextMountIndex++;
        }
        nextIndex++;
        lastPlacedNode = ReactReconciler.getHostNode(nextChild);
      }
      // Remove children that are no longer present.
      for (name in removedNodes) {
        if (removedNodes.hasOwnProperty(name)) {
          updates = enqueue(updates, this._unmountChild(prevChildren[name], removedNodes[name]));
        }
      }
      if (updates) {
        processQueue(this, updates);
      }
      this._renderedChildren = nextChildren;

      if (false) {
        setChildrenForInstrumentation.call(this, nextChildren);
      }
    },

    /**
     * Unmounts all rendered children. This should be used to clean up children
     * when this component is unmounted. It does not actually perform any
     * backend operations.
     *
     * @internal
     */
    unmountChildren: function (safely) {
      var renderedChildren = this._renderedChildren;
      ReactChildReconciler.unmountChildren(renderedChildren, safely);
      this._renderedChildren = null;
    },

    /**
     * Moves a child component to the supplied index.
     *
     * @param {ReactComponent} child Component to move.
     * @param {number} toIndex Destination index of the element.
     * @param {number} lastIndex Last index visited of the siblings of `child`.
     * @protected
     */
    moveChild: function (child, afterNode, toIndex, lastIndex) {
      // If the index of `child` is less than `lastIndex`, then it needs to
      // be moved. Otherwise, we do not need to move it because a child will be
      // inserted or moved before `child`.
      if (child._mountIndex < lastIndex) {
        return makeMove(child, afterNode, toIndex);
      }
    },

    /**
     * Creates a child component.
     *
     * @param {ReactComponent} child Component to create.
     * @param {string} mountImage Markup to insert.
     * @protected
     */
    createChild: function (child, afterNode, mountImage) {
      return makeInsertMarkup(mountImage, afterNode, child._mountIndex);
    },

    /**
     * Removes a child component.
     *
     * @param {ReactComponent} child Child to remove.
     * @protected
     */
    removeChild: function (child, node) {
      return makeRemove(child, node);
    },

    /**
     * Mounts a child with the supplied name.
     *
     * NOTE: This is part of `updateChildren` and is here for readability.
     *
     * @param {ReactComponent} child Component to mount.
     * @param {string} name Name of the child.
     * @param {number} index Index at which to insert the child.
     * @param {ReactReconcileTransaction} transaction
     * @private
     */
    _mountChildAtIndex: function (child, mountImage, afterNode, index, transaction, context) {
      child._mountIndex = index;
      return this.createChild(child, afterNode, mountImage);
    },

    /**
     * Unmounts a rendered child.
     *
     * NOTE: This is part of `updateChildren` and is here for readability.
     *
     * @param {ReactComponent} child Component to unmount.
     * @private
     */
    _unmountChild: function (child, node) {
      var update = this.removeChild(child, node);
      child._mountIndex = null;
      return update;
    }
  }
};

module.exports = ReactMultiChild;

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactReconciler = __webpack_require__(32);

var instantiateReactComponent = __webpack_require__(118);
var KeyEscapeUtils = __webpack_require__(79);
var shouldUpdateReactComponent = __webpack_require__(78);
var traverseAllChildren = __webpack_require__(122);
var warning = __webpack_require__(7);

var ReactComponentTreeHook;

if (typeof process !== 'undefined' && Object({"NODE_ENV":"production","PUBLIC_URL":""}) && "production" === 'test') {
  // Temporary hack.
  // Inline requires don't work well with Jest:
  // https://github.com/facebook/react/issues/7240
  // Remove the inline requires when we don't need them anymore:
  // https://github.com/facebook/react/pull/7178
  ReactComponentTreeHook = __webpack_require__(123);
}

function instantiateChild(childInstances, child, name, selfDebugID) {
  // We found a component instance.
  var keyUnique = childInstances[name] === undefined;
  if (false) {
    if (!ReactComponentTreeHook) {
      ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
    }
    if (!keyUnique) {
      process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
    }
  }
  if (child != null && keyUnique) {
    childInstances[name] = instantiateReactComponent(child, true);
  }
}

/**
 * ReactChildReconciler provides helpers for initializing or updating a set of
 * children. Its output is suitable for passing it onto ReactMultiChild which
 * does diffed reordering and insertion.
 */
var ReactChildReconciler = {
  /**
   * Generates a "mount image" for each of the supplied children. In the case
   * of `ReactDOMComponent`, a mount image is a string of markup.
   *
   * @param {?object} nestedChildNodes Nested child maps.
   * @return {?object} A set of child instances.
   * @internal
   */
  instantiateChildren: function (nestedChildNodes, transaction, context, selfDebugID) // 0 in production and for roots
  {
    if (nestedChildNodes == null) {
      return null;
    }
    var childInstances = {};

    if (false) {
      traverseAllChildren(nestedChildNodes, function (childInsts, child, name) {
        return instantiateChild(childInsts, child, name, selfDebugID);
      }, childInstances);
    } else {
      traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
    }
    return childInstances;
  },

  /**
   * Updates the rendered children and returns a new set of children.
   *
   * @param {?object} prevChildren Previously initialized set of children.
   * @param {?object} nextChildren Flat child element maps.
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   * @return {?object} A new set of child instances.
   * @internal
   */
  updateChildren: function (prevChildren, nextChildren, mountImages, removedNodes, transaction, hostParent, hostContainerInfo, context, selfDebugID) // 0 in production and for roots
  {
    // We currently don't have a way to track moves here but if we use iterators
    // instead of for..in we can zip the iterators and check if an item has
    // moved.
    // TODO: If nothing has changed, return the prevChildren object so that we
    // can quickly bailout if nothing has changed.
    if (!nextChildren && !prevChildren) {
      return;
    }
    var name;
    var prevChild;
    for (name in nextChildren) {
      if (!nextChildren.hasOwnProperty(name)) {
        continue;
      }
      prevChild = prevChildren && prevChildren[name];
      var prevElement = prevChild && prevChild._currentElement;
      var nextElement = nextChildren[name];
      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
        nextChildren[name] = prevChild;
      } else {
        if (prevChild) {
          removedNodes[name] = ReactReconciler.getHostNode(prevChild);
          ReactReconciler.unmountComponent(prevChild, false);
        }
        // The child must be instantiated before it's mounted.
        var nextChildInstance = instantiateReactComponent(nextElement, true);
        nextChildren[name] = nextChildInstance;
        // Creating mount image now ensures refs are resolved in right order
        // (see https://github.com/facebook/react/pull/7101 for explanation).
        var nextChildMountImage = ReactReconciler.mountComponent(nextChildInstance, transaction, hostParent, hostContainerInfo, context, selfDebugID);
        mountImages.push(nextChildMountImage);
      }
    }
    // Unmount children that are no longer present.
    for (name in prevChildren) {
      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
        prevChild = prevChildren[name];
        removedNodes[name] = ReactReconciler.getHostNode(prevChild);
        ReactReconciler.unmountComponent(prevChild, false);
      }
    }
  },

  /**
   * Unmounts all rendered children. This should be used to clean up children
   * when this component is unmounted.
   *
   * @param {?object} renderedChildren Previously initialized set of children.
   * @internal
   */
  unmountChildren: function (renderedChildren, safely) {
    for (var name in renderedChildren) {
      if (renderedChildren.hasOwnProperty(name)) {
        var renderedChild = renderedChildren[name];
        ReactReconciler.unmountComponent(renderedChild, safely);
      }
    }
  }
};

module.exports = ReactChildReconciler;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(117)))

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(6),
    _assign = __webpack_require__(9);

var React = __webpack_require__(29);
var ReactComponentEnvironment = __webpack_require__(77);
var ReactCurrentOwner = __webpack_require__(22);
var ReactErrorUtils = __webpack_require__(69);
var ReactInstanceMap = __webpack_require__(45);
var ReactInstrumentation = __webpack_require__(18);
var ReactNodeTypes = __webpack_require__(119);
var ReactReconciler = __webpack_require__(32);

if (false) {
  var checkReactTypeSpec = require('./checkReactTypeSpec');
}

var emptyObject = __webpack_require__(65);
var invariant = __webpack_require__(4);
var shallowEqual = __webpack_require__(55);
var shouldUpdateReactComponent = __webpack_require__(78);
var warning = __webpack_require__(7);

var CompositeTypes = {
  ImpureClass: 0,
  PureClass: 1,
  StatelessFunctional: 2
};

function StatelessComponent(Component) {}
StatelessComponent.prototype.render = function () {
  var Component = ReactInstanceMap.get(this)._currentElement.type;
  var element = Component(this.props, this.context, this.updater);
  warnIfInvalidElement(Component, element);
  return element;
};

function warnIfInvalidElement(Component, element) {
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(element === null || element === false || React.isValidElement(element), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : void 0;
    process.env.NODE_ENV !== 'production' ? warning(!Component.childContextTypes, '%s(...): childContextTypes cannot be defined on a functional component.', Component.displayName || Component.name || 'Component') : void 0;
  }
}

function shouldConstruct(Component) {
  return !!(Component.prototype && Component.prototype.isReactComponent);
}

function isPureComponent(Component) {
  return !!(Component.prototype && Component.prototype.isPureReactComponent);
}

// Separated into a function to contain deoptimizations caused by try/finally.
function measureLifeCyclePerf(fn, debugID, timerType) {
  if (debugID === 0) {
    // Top-level wrappers (see ReactMount) and empty components (see
    // ReactDOMEmptyComponent) are invisible to hooks and devtools.
    // Both are implementation details that should go away in the future.
    return fn();
  }

  ReactInstrumentation.debugTool.onBeginLifeCycleTimer(debugID, timerType);
  try {
    return fn();
  } finally {
    ReactInstrumentation.debugTool.onEndLifeCycleTimer(debugID, timerType);
  }
}

/**
 * ------------------ The Life-Cycle of a Composite Component ------------------
 *
 * - constructor: Initialization of state. The instance is now retained.
 *   - componentWillMount
 *   - render
 *   - [children's constructors]
 *     - [children's componentWillMount and render]
 *     - [children's componentDidMount]
 *     - componentDidMount
 *
 *       Update Phases:
 *       - componentWillReceiveProps (only called if parent updated)
 *       - shouldComponentUpdate
 *         - componentWillUpdate
 *           - render
 *           - [children's constructors or receive props phases]
 *         - componentDidUpdate
 *
 *     - componentWillUnmount
 *     - [children's componentWillUnmount]
 *   - [children destroyed]
 * - (destroyed): The instance is now blank, released by React and ready for GC.
 *
 * -----------------------------------------------------------------------------
 */

/**
 * An incrementing ID assigned to each component when it is mounted. This is
 * used to enforce the order in which `ReactUpdates` updates dirty components.
 *
 * @private
 */
var nextMountID = 1;

/**
 * @lends {ReactCompositeComponent.prototype}
 */
var ReactCompositeComponent = {
  /**
   * Base constructor for all composite component.
   *
   * @param {ReactElement} element
   * @final
   * @internal
   */
  construct: function (element) {
    this._currentElement = element;
    this._rootNodeID = 0;
    this._compositeType = null;
    this._instance = null;
    this._hostParent = null;
    this._hostContainerInfo = null;

    // See ReactUpdateQueue
    this._updateBatchNumber = null;
    this._pendingElement = null;
    this._pendingStateQueue = null;
    this._pendingReplaceState = false;
    this._pendingForceUpdate = false;

    this._renderedNodeType = null;
    this._renderedComponent = null;
    this._context = null;
    this._mountOrder = 0;
    this._topLevelWrapper = null;

    // See ReactUpdates and ReactUpdateQueue.
    this._pendingCallbacks = null;

    // ComponentWillUnmount shall only be called once
    this._calledComponentWillUnmount = false;

    if (false) {
      this._warnedAboutRefsInRender = false;
    }
  },

  /**
   * Initializes the component, renders markup, and registers event listeners.
   *
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {?object} hostParent
   * @param {?object} hostContainerInfo
   * @param {?object} context
   * @return {?string} Rendered markup to be inserted into the DOM.
   * @final
   * @internal
   */
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    var _this = this;

    this._context = context;
    this._mountOrder = nextMountID++;
    this._hostParent = hostParent;
    this._hostContainerInfo = hostContainerInfo;

    var publicProps = this._currentElement.props;
    var publicContext = this._processContext(context);

    var Component = this._currentElement.type;

    var updateQueue = transaction.getUpdateQueue();

    // Initialize the public class
    var doConstruct = shouldConstruct(Component);
    var inst = this._constructComponent(doConstruct, publicProps, publicContext, updateQueue);
    var renderedElement;

    // Support functional components
    if (!doConstruct && (inst == null || inst.render == null)) {
      renderedElement = inst;
      warnIfInvalidElement(Component, renderedElement);
      !(inst === null || inst === false || React.isValidElement(inst)) ?  false ? invariant(false, '%s(...): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : _prodInvariant('105', Component.displayName || Component.name || 'Component') : void 0;
      inst = new StatelessComponent(Component);
      this._compositeType = CompositeTypes.StatelessFunctional;
    } else {
      if (isPureComponent(Component)) {
        this._compositeType = CompositeTypes.PureClass;
      } else {
        this._compositeType = CompositeTypes.ImpureClass;
      }
    }

    if (false) {
      // This will throw later in _renderValidatedComponent, but add an early
      // warning now to help debugging
      if (inst.render == null) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', Component.displayName || Component.name || 'Component') : void 0;
      }

      var propsMutated = inst.props !== publicProps;
      var componentName = Component.displayName || Component.name || 'Component';

      process.env.NODE_ENV !== 'production' ? warning(inst.props === undefined || !propsMutated, '%s(...): When calling super() in `%s`, make sure to pass ' + "up the same props that your component's constructor was passed.", componentName, componentName) : void 0;
    }

    // These should be set up in the constructor, but as a convenience for
    // simpler class abstractions, we set them up after the fact.
    inst.props = publicProps;
    inst.context = publicContext;
    inst.refs = emptyObject;
    inst.updater = updateQueue;

    this._instance = inst;

    // Store a reference from the instance back to the internal representation
    ReactInstanceMap.set(inst, this);

    if (false) {
      // Since plain JS classes are defined without any special initialization
      // logic, we can not catch common errors early. Therefore, we have to
      // catch them here, at initialization time, instead.
      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved || inst.state, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : void 0;
    }

    var initialState = inst.state;
    if (initialState === undefined) {
      inst.state = initialState = null;
    }
    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : _prodInvariant('106', this.getName() || 'ReactCompositeComponent') : void 0;

    this._pendingStateQueue = null;
    this._pendingReplaceState = false;
    this._pendingForceUpdate = false;

    var markup;
    if (inst.unstable_handleError) {
      markup = this.performInitialMountWithErrorHandling(renderedElement, hostParent, hostContainerInfo, transaction, context);
    } else {
      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
    }

    if (inst.componentDidMount) {
      if (false) {
        transaction.getReactMountReady().enqueue(function () {
          measureLifeCyclePerf(function () {
            return inst.componentDidMount();
          }, _this._debugID, 'componentDidMount');
        });
      } else {
        transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
      }
    }

    return markup;
  },

  _constructComponent: function (doConstruct, publicProps, publicContext, updateQueue) {
    if (false) {
      ReactCurrentOwner.current = this;
      try {
        return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
      } finally {
        ReactCurrentOwner.current = null;
      }
    } else {
      return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
    }
  },

  _constructComponentWithoutOwner: function (doConstruct, publicProps, publicContext, updateQueue) {
    var Component = this._currentElement.type;

    if (doConstruct) {
      if (false) {
        return measureLifeCyclePerf(function () {
          return new Component(publicProps, publicContext, updateQueue);
        }, this._debugID, 'ctor');
      } else {
        return new Component(publicProps, publicContext, updateQueue);
      }
    }

    // This can still be an instance in case of factory components
    // but we'll count this as time spent rendering as the more common case.
    if (false) {
      return measureLifeCyclePerf(function () {
        return Component(publicProps, publicContext, updateQueue);
      }, this._debugID, 'render');
    } else {
      return Component(publicProps, publicContext, updateQueue);
    }
  },

  performInitialMountWithErrorHandling: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
    var markup;
    var checkpoint = transaction.checkpoint();
    try {
      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
    } catch (e) {
      // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
      transaction.rollback(checkpoint);
      this._instance.unstable_handleError(e);
      if (this._pendingStateQueue) {
        this._instance.state = this._processPendingState(this._instance.props, this._instance.context);
      }
      checkpoint = transaction.checkpoint();

      this._renderedComponent.unmountComponent(true);
      transaction.rollback(checkpoint);

      // Try again - we've informed the component about the error, so they can render an error message this time.
      // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
    }
    return markup;
  },

  performInitialMount: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
    var inst = this._instance;

    var debugID = 0;
    if (false) {
      debugID = this._debugID;
    }

    if (inst.componentWillMount) {
      if (false) {
        measureLifeCyclePerf(function () {
          return inst.componentWillMount();
        }, debugID, 'componentWillMount');
      } else {
        inst.componentWillMount();
      }
      // When mounting, calls to `setState` by `componentWillMount` will set
      // `this._pendingStateQueue` without triggering a re-render.
      if (this._pendingStateQueue) {
        inst.state = this._processPendingState(inst.props, inst.context);
      }
    }

    // If not a stateless component, we now render
    if (renderedElement === undefined) {
      renderedElement = this._renderValidatedComponent();
    }

    var nodeType = ReactNodeTypes.getType(renderedElement);
    this._renderedNodeType = nodeType;
    var child = this._instantiateReactComponent(renderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
    );
    this._renderedComponent = child;

    var markup = ReactReconciler.mountComponent(child, transaction, hostParent, hostContainerInfo, this._processChildContext(context), debugID);

    if (false) {
      if (debugID !== 0) {
        var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
        ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
      }
    }

    return markup;
  },

  getHostNode: function () {
    return ReactReconciler.getHostNode(this._renderedComponent);
  },

  /**
   * Releases any resources allocated by `mountComponent`.
   *
   * @final
   * @internal
   */
  unmountComponent: function (safely) {
    if (!this._renderedComponent) {
      return;
    }

    var inst = this._instance;

    if (inst.componentWillUnmount && !inst._calledComponentWillUnmount) {
      inst._calledComponentWillUnmount = true;

      if (safely) {
        var name = this.getName() + '.componentWillUnmount()';
        ReactErrorUtils.invokeGuardedCallback(name, inst.componentWillUnmount.bind(inst));
      } else {
        if (false) {
          measureLifeCyclePerf(function () {
            return inst.componentWillUnmount();
          }, this._debugID, 'componentWillUnmount');
        } else {
          inst.componentWillUnmount();
        }
      }
    }

    if (this._renderedComponent) {
      ReactReconciler.unmountComponent(this._renderedComponent, safely);
      this._renderedNodeType = null;
      this._renderedComponent = null;
      this._instance = null;
    }

    // Reset pending fields
    // Even if this component is scheduled for another update in ReactUpdates,
    // it would still be ignored because these fields are reset.
    this._pendingStateQueue = null;
    this._pendingReplaceState = false;
    this._pendingForceUpdate = false;
    this._pendingCallbacks = null;
    this._pendingElement = null;

    // These fields do not really need to be reset since this object is no
    // longer accessible.
    this._context = null;
    this._rootNodeID = 0;
    this._topLevelWrapper = null;

    // Delete the reference from the instance to this internal representation
    // which allow the internals to be properly cleaned up even if the user
    // leaks a reference to the public instance.
    ReactInstanceMap.remove(inst);

    // Some existing components rely on inst.props even after they've been
    // destroyed (in event handlers).
    // TODO: inst.props = null;
    // TODO: inst.state = null;
    // TODO: inst.context = null;
  },

  /**
   * Filters the context object to only contain keys specified in
   * `contextTypes`
   *
   * @param {object} context
   * @return {?object}
   * @private
   */
  _maskContext: function (context) {
    var Component = this._currentElement.type;
    var contextTypes = Component.contextTypes;
    if (!contextTypes) {
      return emptyObject;
    }
    var maskedContext = {};
    for (var contextName in contextTypes) {
      maskedContext[contextName] = context[contextName];
    }
    return maskedContext;
  },

  /**
   * Filters the context object to only contain keys specified in
   * `contextTypes`, and asserts that they are valid.
   *
   * @param {object} context
   * @return {?object}
   * @private
   */
  _processContext: function (context) {
    var maskedContext = this._maskContext(context);
    if (false) {
      var Component = this._currentElement.type;
      if (Component.contextTypes) {
        this._checkContextTypes(Component.contextTypes, maskedContext, 'context');
      }
    }
    return maskedContext;
  },

  /**
   * @param {object} currentContext
   * @return {object}
   * @private
   */
  _processChildContext: function (currentContext) {
    var Component = this._currentElement.type;
    var inst = this._instance;
    var childContext;

    if (inst.getChildContext) {
      if (false) {
        ReactInstrumentation.debugTool.onBeginProcessingChildContext();
        try {
          childContext = inst.getChildContext();
        } finally {
          ReactInstrumentation.debugTool.onEndProcessingChildContext();
        }
      } else {
        childContext = inst.getChildContext();
      }
    }

    if (childContext) {
      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().', this.getName() || 'ReactCompositeComponent') : _prodInvariant('107', this.getName() || 'ReactCompositeComponent') : void 0;
      if (false) {
        this._checkContextTypes(Component.childContextTypes, childContext, 'child context');
      }
      for (var name in childContext) {
        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : _prodInvariant('108', this.getName() || 'ReactCompositeComponent', name) : void 0;
      }
      return _assign({}, currentContext, childContext);
    }
    return currentContext;
  },

  /**
   * Assert that the context types are valid
   *
   * @param {object} typeSpecs Map of context field to a ReactPropType
   * @param {object} values Runtime values that need to be type-checked
   * @param {string} location e.g. "prop", "context", "child context"
   * @private
   */
  _checkContextTypes: function (typeSpecs, values, location) {
    if (false) {
      checkReactTypeSpec(typeSpecs, values, location, this.getName(), null, this._debugID);
    }
  },

  receiveComponent: function (nextElement, transaction, nextContext) {
    var prevElement = this._currentElement;
    var prevContext = this._context;

    this._pendingElement = null;

    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
  },

  /**
   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
   * is set, update the component.
   *
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  performUpdateIfNecessary: function (transaction) {
    if (this._pendingElement != null) {
      ReactReconciler.receiveComponent(this, this._pendingElement, transaction, this._context);
    } else if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
    } else {
      this._updateBatchNumber = null;
    }
  },

  /**
   * Perform an update to a mounted component. The componentWillReceiveProps and
   * shouldComponentUpdate methods are called, then (assuming the update isn't
   * skipped) the remaining update lifecycle methods are called and the DOM
   * representation is updated.
   *
   * By default, this implements React's rendering and reconciliation algorithm.
   * Sophisticated clients may wish to override this.
   *
   * @param {ReactReconcileTransaction} transaction
   * @param {ReactElement} prevParentElement
   * @param {ReactElement} nextParentElement
   * @internal
   * @overridable
   */
  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
    var inst = this._instance;
    !(inst != null) ?  false ? invariant(false, 'Attempted to update component `%s` that has already been unmounted (or failed to mount).', this.getName() || 'ReactCompositeComponent') : _prodInvariant('136', this.getName() || 'ReactCompositeComponent') : void 0;

    var willReceive = false;
    var nextContext;

    // Determine if the context has changed or not
    if (this._context === nextUnmaskedContext) {
      nextContext = inst.context;
    } else {
      nextContext = this._processContext(nextUnmaskedContext);
      willReceive = true;
    }

    var prevProps = prevParentElement.props;
    var nextProps = nextParentElement.props;

    // Not a simple state update but a props update
    if (prevParentElement !== nextParentElement) {
      willReceive = true;
    }

    // An update here will schedule an update but immediately set
    // _pendingStateQueue which will ensure that any state updates gets
    // immediately reconciled instead of waiting for the next batch.
    if (willReceive && inst.componentWillReceiveProps) {
      if (false) {
        measureLifeCyclePerf(function () {
          return inst.componentWillReceiveProps(nextProps, nextContext);
        }, this._debugID, 'componentWillReceiveProps');
      } else {
        inst.componentWillReceiveProps(nextProps, nextContext);
      }
    }

    var nextState = this._processPendingState(nextProps, nextContext);
    var shouldUpdate = true;

    if (!this._pendingForceUpdate) {
      if (inst.shouldComponentUpdate) {
        if (false) {
          shouldUpdate = measureLifeCyclePerf(function () {
            return inst.shouldComponentUpdate(nextProps, nextState, nextContext);
          }, this._debugID, 'shouldComponentUpdate');
        } else {
          shouldUpdate = inst.shouldComponentUpdate(nextProps, nextState, nextContext);
        }
      } else {
        if (this._compositeType === CompositeTypes.PureClass) {
          shouldUpdate = !shallowEqual(prevProps, nextProps) || !shallowEqual(inst.state, nextState);
        }
      }
    }

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(shouldUpdate !== undefined, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : void 0;
    }

    this._updateBatchNumber = null;
    if (shouldUpdate) {
      this._pendingForceUpdate = false;
      // Will set `this.props`, `this.state` and `this.context`.
      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
    } else {
      // If it's determined that a component should not update, we still want
      // to set props and state but we shortcut the rest of the update.
      this._currentElement = nextParentElement;
      this._context = nextUnmaskedContext;
      inst.props = nextProps;
      inst.state = nextState;
      inst.context = nextContext;
    }
  },

  _processPendingState: function (props, context) {
    var inst = this._instance;
    var queue = this._pendingStateQueue;
    var replace = this._pendingReplaceState;
    this._pendingReplaceState = false;
    this._pendingStateQueue = null;

    if (!queue) {
      return inst.state;
    }

    if (replace && queue.length === 1) {
      return queue[0];
    }

    var nextState = _assign({}, replace ? queue[0] : inst.state);
    for (var i = replace ? 1 : 0; i < queue.length; i++) {
      var partial = queue[i];
      _assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
    }

    return nextState;
  },

  /**
   * Merges new props and state, notifies delegate methods of update and
   * performs update.
   *
   * @param {ReactElement} nextElement Next element
   * @param {object} nextProps Next public object to set as properties.
   * @param {?object} nextState Next object to set as state.
   * @param {?object} nextContext Next public object to set as context.
   * @param {ReactReconcileTransaction} transaction
   * @param {?object} unmaskedContext
   * @private
   */
  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
    var _this2 = this;

    var inst = this._instance;

    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
    var prevProps;
    var prevState;
    var prevContext;
    if (hasComponentDidUpdate) {
      prevProps = inst.props;
      prevState = inst.state;
      prevContext = inst.context;
    }

    if (inst.componentWillUpdate) {
      if (false) {
        measureLifeCyclePerf(function () {
          return inst.componentWillUpdate(nextProps, nextState, nextContext);
        }, this._debugID, 'componentWillUpdate');
      } else {
        inst.componentWillUpdate(nextProps, nextState, nextContext);
      }
    }

    this._currentElement = nextElement;
    this._context = unmaskedContext;
    inst.props = nextProps;
    inst.state = nextState;
    inst.context = nextContext;

    this._updateRenderedComponent(transaction, unmaskedContext);

    if (hasComponentDidUpdate) {
      if (false) {
        transaction.getReactMountReady().enqueue(function () {
          measureLifeCyclePerf(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), _this2._debugID, 'componentDidUpdate');
        });
      } else {
        transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
      }
    }
  },

  /**
   * Call the component's `render` method and update the DOM accordingly.
   *
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  _updateRenderedComponent: function (transaction, context) {
    var prevComponentInstance = this._renderedComponent;
    var prevRenderedElement = prevComponentInstance._currentElement;
    var nextRenderedElement = this._renderValidatedComponent();

    var debugID = 0;
    if (false) {
      debugID = this._debugID;
    }

    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
    } else {
      var oldHostNode = ReactReconciler.getHostNode(prevComponentInstance);
      ReactReconciler.unmountComponent(prevComponentInstance, false);

      var nodeType = ReactNodeTypes.getType(nextRenderedElement);
      this._renderedNodeType = nodeType;
      var child = this._instantiateReactComponent(nextRenderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
      );
      this._renderedComponent = child;

      var nextMarkup = ReactReconciler.mountComponent(child, transaction, this._hostParent, this._hostContainerInfo, this._processChildContext(context), debugID);

      if (false) {
        if (debugID !== 0) {
          var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
          ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
        }
      }

      this._replaceNodeWithMarkup(oldHostNode, nextMarkup, prevComponentInstance);
    }
  },

  /**
   * Overridden in shallow rendering.
   *
   * @protected
   */
  _replaceNodeWithMarkup: function (oldHostNode, nextMarkup, prevInstance) {
    ReactComponentEnvironment.replaceNodeWithMarkup(oldHostNode, nextMarkup, prevInstance);
  },

  /**
   * @protected
   */
  _renderValidatedComponentWithoutOwnerOrContext: function () {
    var inst = this._instance;
    var renderedElement;

    if (false) {
      renderedElement = measureLifeCyclePerf(function () {
        return inst.render();
      }, this._debugID, 'render');
    } else {
      renderedElement = inst.render();
    }

    if (false) {
      // We allow auto-mocks to proceed as if they're returning null.
      if (renderedElement === undefined && inst.render._isMockFunction) {
        // This is probably bad practice. Consider warning here and
        // deprecating this convenience.
        renderedElement = null;
      }
    }

    return renderedElement;
  },

  /**
   * @private
   */
  _renderValidatedComponent: function () {
    var renderedElement;
    if ("production" !== 'production' || this._compositeType !== CompositeTypes.StatelessFunctional) {
      ReactCurrentOwner.current = this;
      try {
        renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
      } finally {
        ReactCurrentOwner.current = null;
      }
    } else {
      renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
    }
    !(
    // TODO: An `isValidNode` function would probably be more appropriate
    renderedElement === null || renderedElement === false || React.isValidElement(renderedElement)) ?  false ? invariant(false, '%s.render(): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : _prodInvariant('109', this.getName() || 'ReactCompositeComponent') : void 0;

    return renderedElement;
  },

  /**
   * Lazily allocates the refs object and stores `component` as `ref`.
   *
   * @param {string} ref Reference name.
   * @param {component} component Component to store as `ref`.
   * @final
   * @private
   */
  attachRef: function (ref, component) {
    var inst = this.getPublicInstance();
    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : _prodInvariant('110') : void 0;
    var publicComponentInstance = component.getPublicInstance();
    if (false) {
      var componentName = component && component.getName ? component.getName() : 'a component';
      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null || component._compositeType !== CompositeTypes.StatelessFunctional, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : void 0;
    }
    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
    refs[ref] = publicComponentInstance;
  },

  /**
   * Detaches a reference name.
   *
   * @param {string} ref Name to dereference.
   * @final
   * @private
   */
  detachRef: function (ref) {
    var refs = this.getPublicInstance().refs;
    delete refs[ref];
  },

  /**
   * Get a text description of the component that can be used to identify it
   * in error messages.
   * @return {string} The name or null.
   * @internal
   */
  getName: function () {
    var type = this._currentElement.type;
    var constructor = this._instance && this._instance.constructor;
    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
  },

  /**
   * Get the publicly accessible representation of this component - i.e. what
   * is exposed by refs and returned by render. Can be null for stateless
   * components.
   *
   * @return {ReactComponent} the public component instance.
   * @internal
   */
  getPublicInstance: function () {
    var inst = this._instance;
    if (this._compositeType === CompositeTypes.StatelessFunctional) {
      return null;
    }
    return inst;
  },

  // Stub
  _instantiateReactComponent: null
};

module.exports = ReactCompositeComponent;

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var nextDebugID = 1;

function getNextDebugID() {
  return nextDebugID++;
}

module.exports = getNextDebugID;

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



// The Symbol used to tag the ReactElement type. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.

var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;

module.exports = REACT_ELEMENT_TYPE;

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/* global Symbol */

var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

/**
 * Returns the iterator method function contained on the iterable object.
 *
 * Be sure to invoke the function with the iterable as context:
 *
 *     var iteratorFn = getIteratorFn(myIterable);
 *     if (iteratorFn) {
 *       var iterator = iteratorFn.call(myIterable);
 *       ...
 *     }
 *
 * @param {?object} maybeIterable
 * @return {?function}
 */
function getIteratorFn(maybeIterable) {
  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
  if (typeof iteratorFn === 'function') {
    return iteratorFn;
  }
}

module.exports = getIteratorFn;

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var KeyEscapeUtils = __webpack_require__(79);
var traverseAllChildren = __webpack_require__(122);
var warning = __webpack_require__(7);

var ReactComponentTreeHook;

if (typeof process !== 'undefined' && Object({"NODE_ENV":"production","PUBLIC_URL":""}) && "production" === 'test') {
  // Temporary hack.
  // Inline requires don't work well with Jest:
  // https://github.com/facebook/react/issues/7240
  // Remove the inline requires when we don't need them anymore:
  // https://github.com/facebook/react/pull/7178
  ReactComponentTreeHook = __webpack_require__(123);
}

/**
 * @param {function} traverseContext Context passed through traversal.
 * @param {?ReactComponent} child React child component.
 * @param {!string} name String name of key path to child.
 * @param {number=} selfDebugID Optional debugID of the current internal instance.
 */
function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
  // We found a component instance.
  if (traverseContext && typeof traverseContext === 'object') {
    var result = traverseContext;
    var keyUnique = result[name] === undefined;
    if (false) {
      if (!ReactComponentTreeHook) {
        ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
      }
      if (!keyUnique) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
      }
    }
    if (keyUnique && child != null) {
      result[name] = child;
    }
  }
}

/**
 * Flattens children that are typically specified as `props.children`. Any null
 * children will not be included in the resulting object.
 * @return {!object} flattened children keyed by name.
 */
function flattenChildren(children, selfDebugID) {
  if (children == null) {
    return children;
  }
  var result = {};

  if (false) {
    traverseAllChildren(children, function (traverseContext, child, name) {
      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
    }, result);
  } else {
    traverseAllChildren(children, flattenSingleChildIntoContext, result);
  }
  return result;
}

module.exports = flattenChildren;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(117)))

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(9);

var PooledClass = __webpack_require__(27);
var Transaction = __webpack_require__(50);
var ReactInstrumentation = __webpack_require__(18);
var ReactServerUpdateQueue = __webpack_require__(234);

/**
 * Executed within the scope of the `Transaction` instance. Consider these as
 * being member methods, but with an implied ordering while being isolated from
 * each other.
 */
var TRANSACTION_WRAPPERS = [];

if (false) {
  TRANSACTION_WRAPPERS.push({
    initialize: ReactInstrumentation.debugTool.onBeginFlush,
    close: ReactInstrumentation.debugTool.onEndFlush
  });
}

var noopCallbackQueue = {
  enqueue: function () {}
};

/**
 * @class ReactServerRenderingTransaction
 * @param {boolean} renderToStaticMarkup
 */
function ReactServerRenderingTransaction(renderToStaticMarkup) {
  this.reinitializeTransaction();
  this.renderToStaticMarkup = renderToStaticMarkup;
  this.useCreateElement = false;
  this.updateQueue = new ReactServerUpdateQueue(this);
}

var Mixin = {
  /**
   * @see Transaction
   * @abstract
   * @final
   * @return {array} Empty list of operation wrap procedures.
   */
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  },

  /**
   * @return {object} The queue to collect `onDOMReady` callbacks with.
   */
  getReactMountReady: function () {
    return noopCallbackQueue;
  },

  /**
   * @return {object} The queue to collect React async events.
   */
  getUpdateQueue: function () {
    return this.updateQueue;
  },

  /**
   * `PooledClass` looks for this, and will invoke this before allowing this
   * instance to be reused.
   */
  destructor: function () {},

  checkpoint: function () {},

  rollback: function () {}
};

_assign(ReactServerRenderingTransaction.prototype, Transaction, Mixin);

PooledClass.addPoolingTo(ReactServerRenderingTransaction);

module.exports = ReactServerRenderingTransaction;

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ReactUpdateQueue = __webpack_require__(80);

var warning = __webpack_require__(7);

function warnNoop(publicInstance, callerName) {
  if (false) {
    var constructor = publicInstance.constructor;
    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
  }
}

/**
 * This is the update queue used for server rendering.
 * It delegates to ReactUpdateQueue while server rendering is in progress and
 * switches to ReactNoopUpdateQueue after the transaction has completed.
 * @class ReactServerUpdateQueue
 * @param {Transaction} transaction
 */

var ReactServerUpdateQueue = function () {
  function ReactServerUpdateQueue(transaction) {
    _classCallCheck(this, ReactServerUpdateQueue);

    this.transaction = transaction;
  }

  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */


  ReactServerUpdateQueue.prototype.isMounted = function isMounted(publicInstance) {
    return false;
  };

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueCallback = function enqueueCallback(publicInstance, callback, callerName) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueCallback(publicInstance, callback, callerName);
    }
  };

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueForceUpdate = function enqueueForceUpdate(publicInstance) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueForceUpdate(publicInstance);
    } else {
      warnNoop(publicInstance, 'forceUpdate');
    }
  };

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object|function} completeState Next state.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueReplaceState = function enqueueReplaceState(publicInstance, completeState) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueReplaceState(publicInstance, completeState);
    } else {
      warnNoop(publicInstance, 'replaceState');
    }
  };

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object|function} partialState Next partial state to be merged with state.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueSetState = function enqueueSetState(publicInstance, partialState) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueSetState(publicInstance, partialState);
    } else {
      warnNoop(publicInstance, 'setState');
    }
  };

  return ReactServerUpdateQueue;
}();

module.exports = ReactServerUpdateQueue;

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(9);

var DOMLazyTree = __webpack_require__(33);
var ReactDOMComponentTree = __webpack_require__(13);

var ReactDOMEmptyComponent = function (instantiate) {
  // ReactCompositeComponent uses this:
  this._currentElement = null;
  // ReactDOMComponentTree uses these:
  this._hostNode = null;
  this._hostParent = null;
  this._hostContainerInfo = null;
  this._domID = 0;
};
_assign(ReactDOMEmptyComponent.prototype, {
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    var domID = hostContainerInfo._idCounter++;
    this._domID = domID;
    this._hostParent = hostParent;
    this._hostContainerInfo = hostContainerInfo;

    var nodeValue = ' react-empty: ' + this._domID + ' ';
    if (transaction.useCreateElement) {
      var ownerDocument = hostContainerInfo._ownerDocument;
      var node = ownerDocument.createComment(nodeValue);
      ReactDOMComponentTree.precacheNode(this, node);
      return DOMLazyTree(node);
    } else {
      if (transaction.renderToStaticMarkup) {
        // Normally we'd insert a comment node, but since this is a situation
        // where React won't take over (static pages), we can simply return
        // nothing.
        return '';
      }
      return '<!--' + nodeValue + '-->';
    }
  },
  receiveComponent: function () {},
  getHostNode: function () {
    return ReactDOMComponentTree.getNodeFromInstance(this);
  },
  unmountComponent: function () {
    ReactDOMComponentTree.uncacheNode(this);
  }
});

module.exports = ReactDOMEmptyComponent;

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(6);

var invariant = __webpack_require__(4);

/**
 * Return the lowest common ancestor of A and B, or null if they are in
 * different trees.
 */
function getLowestCommonAncestor(instA, instB) {
  !('_hostNode' in instA) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
  !('_hostNode' in instB) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;

  var depthA = 0;
  for (var tempA = instA; tempA; tempA = tempA._hostParent) {
    depthA++;
  }
  var depthB = 0;
  for (var tempB = instB; tempB; tempB = tempB._hostParent) {
    depthB++;
  }

  // If A is deeper, crawl up.
  while (depthA - depthB > 0) {
    instA = instA._hostParent;
    depthA--;
  }

  // If B is deeper, crawl up.
  while (depthB - depthA > 0) {
    instB = instB._hostParent;
    depthB--;
  }

  // Walk in lockstep until we find a match.
  var depth = depthA;
  while (depth--) {
    if (instA === instB) {
      return instA;
    }
    instA = instA._hostParent;
    instB = instB._hostParent;
  }
  return null;
}

/**
 * Return if A is an ancestor of B.
 */
function isAncestor(instA, instB) {
  !('_hostNode' in instA) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
  !('_hostNode' in instB) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;

  while (instB) {
    if (instB === instA) {
      return true;
    }
    instB = instB._hostParent;
  }
  return false;
}

/**
 * Return the parent instance of the passed-in instance.
 */
function getParentInstance(inst) {
  !('_hostNode' in inst) ?  false ? invariant(false, 'getParentInstance: Invalid argument.') : _prodInvariant('36') : void 0;

  return inst._hostParent;
}

/**
 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
 */
function traverseTwoPhase(inst, fn, arg) {
  var path = [];
  while (inst) {
    path.push(inst);
    inst = inst._hostParent;
  }
  var i;
  for (i = path.length; i-- > 0;) {
    fn(path[i], 'captured', arg);
  }
  for (i = 0; i < path.length; i++) {
    fn(path[i], 'bubbled', arg);
  }
}

/**
 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
 * should would receive a `mouseEnter` or `mouseLeave` event.
 *
 * Does not invoke the callback on the nearest common ancestor because nothing
 * "entered" or "left" that element.
 */
function traverseEnterLeave(from, to, fn, argFrom, argTo) {
  var common = from && to ? getLowestCommonAncestor(from, to) : null;
  var pathFrom = [];
  while (from && from !== common) {
    pathFrom.push(from);
    from = from._hostParent;
  }
  var pathTo = [];
  while (to && to !== common) {
    pathTo.push(to);
    to = to._hostParent;
  }
  var i;
  for (i = 0; i < pathFrom.length; i++) {
    fn(pathFrom[i], 'bubbled', argFrom);
  }
  for (i = pathTo.length; i-- > 0;) {
    fn(pathTo[i], 'captured', argTo);
  }
}

module.exports = {
  isAncestor: isAncestor,
  getLowestCommonAncestor: getLowestCommonAncestor,
  getParentInstance: getParentInstance,
  traverseTwoPhase: traverseTwoPhase,
  traverseEnterLeave: traverseEnterLeave
};

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(6),
    _assign = __webpack_require__(9);

var DOMChildrenOperations = __webpack_require__(73);
var DOMLazyTree = __webpack_require__(33);
var ReactDOMComponentTree = __webpack_require__(13);

var escapeTextContentForBrowser = __webpack_require__(53);
var invariant = __webpack_require__(4);
var validateDOMNesting = __webpack_require__(81);

/**
 * Text nodes violate a couple assumptions that React makes about components:
 *
 *  - When mounting text into the DOM, adjacent text nodes are merged.
 *  - Text nodes cannot be assigned a React root ID.
 *
 * This component is used to wrap strings between comment nodes so that they
 * can undergo the same reconciliation that is applied to elements.
 *
 * TODO: Investigate representing React components in the DOM with text nodes.
 *
 * @class ReactDOMTextComponent
 * @extends ReactComponent
 * @internal
 */
var ReactDOMTextComponent = function (text) {
  // TODO: This is really a ReactText (ReactNode), not a ReactElement
  this._currentElement = text;
  this._stringText = '' + text;
  // ReactDOMComponentTree uses these:
  this._hostNode = null;
  this._hostParent = null;

  // Properties
  this._domID = 0;
  this._mountIndex = 0;
  this._closingComment = null;
  this._commentNodes = null;
};

_assign(ReactDOMTextComponent.prototype, {
  /**
   * Creates the markup for this text node. This node is not intended to have
   * any features besides containing text content.
   *
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @return {string} Markup for this text node.
   * @internal
   */
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    if (false) {
      var parentInfo;
      if (hostParent != null) {
        parentInfo = hostParent._ancestorInfo;
      } else if (hostContainerInfo != null) {
        parentInfo = hostContainerInfo._ancestorInfo;
      }
      if (parentInfo) {
        // parentInfo should always be present except for the top-level
        // component when server rendering
        validateDOMNesting(null, this._stringText, this, parentInfo);
      }
    }

    var domID = hostContainerInfo._idCounter++;
    var openingValue = ' react-text: ' + domID + ' ';
    var closingValue = ' /react-text ';
    this._domID = domID;
    this._hostParent = hostParent;
    if (transaction.useCreateElement) {
      var ownerDocument = hostContainerInfo._ownerDocument;
      var openingComment = ownerDocument.createComment(openingValue);
      var closingComment = ownerDocument.createComment(closingValue);
      var lazyTree = DOMLazyTree(ownerDocument.createDocumentFragment());
      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(openingComment));
      if (this._stringText) {
        DOMLazyTree.queueChild(lazyTree, DOMLazyTree(ownerDocument.createTextNode(this._stringText)));
      }
      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(closingComment));
      ReactDOMComponentTree.precacheNode(this, openingComment);
      this._closingComment = closingComment;
      return lazyTree;
    } else {
      var escapedText = escapeTextContentForBrowser(this._stringText);

      if (transaction.renderToStaticMarkup) {
        // Normally we'd wrap this between comment nodes for the reasons stated
        // above, but since this is a situation where React won't take over
        // (static pages), we can simply return the text as it is.
        return escapedText;
      }

      return '<!--' + openingValue + '-->' + escapedText + '<!--' + closingValue + '-->';
    }
  },

  /**
   * Updates this component by updating the text content.
   *
   * @param {ReactText} nextText The next text content
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  receiveComponent: function (nextText, transaction) {
    if (nextText !== this._currentElement) {
      this._currentElement = nextText;
      var nextStringText = '' + nextText;
      if (nextStringText !== this._stringText) {
        // TODO: Save this as pending props and use performUpdateIfNecessary
        // and/or updateComponent to do the actual update for consistency with
        // other component types?
        this._stringText = nextStringText;
        var commentNodes = this.getHostNode();
        DOMChildrenOperations.replaceDelimitedText(commentNodes[0], commentNodes[1], nextStringText);
      }
    }
  },

  getHostNode: function () {
    var hostNode = this._commentNodes;
    if (hostNode) {
      return hostNode;
    }
    if (!this._closingComment) {
      var openingComment = ReactDOMComponentTree.getNodeFromInstance(this);
      var node = openingComment.nextSibling;
      while (true) {
        !(node != null) ?  false ? invariant(false, 'Missing closing comment for text component %s', this._domID) : _prodInvariant('67', this._domID) : void 0;
        if (node.nodeType === 8 && node.nodeValue === ' /react-text ') {
          this._closingComment = node;
          break;
        }
        node = node.nextSibling;
      }
    }
    hostNode = [this._hostNode, this._closingComment];
    this._commentNodes = hostNode;
    return hostNode;
  },

  unmountComponent: function () {
    this._closingComment = null;
    this._commentNodes = null;
    ReactDOMComponentTree.uncacheNode(this);
  }
});

module.exports = ReactDOMTextComponent;

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(9);

var ReactUpdates = __webpack_require__(20);
var Transaction = __webpack_require__(50);

var emptyFunction = __webpack_require__(19);

var RESET_BATCHED_UPDATES = {
  initialize: emptyFunction,
  close: function () {
    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
  }
};

var FLUSH_BATCHED_UPDATES = {
  initialize: emptyFunction,
  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
};

var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];

function ReactDefaultBatchingStrategyTransaction() {
  this.reinitializeTransaction();
}

_assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction, {
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  }
});

var transaction = new ReactDefaultBatchingStrategyTransaction();

var ReactDefaultBatchingStrategy = {
  isBatchingUpdates: false,

  /**
   * Call the provided function in a context within which calls to `setState`
   * and friends are batched such that components aren't updated unnecessarily.
   */
  batchedUpdates: function (callback, a, b, c, d, e) {
    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;

    ReactDefaultBatchingStrategy.isBatchingUpdates = true;

    // The code is written this way to avoid extra allocations
    if (alreadyBatchingUpdates) {
      return callback(a, b, c, d, e);
    } else {
      return transaction.perform(callback, null, a, b, c, d, e);
    }
  }
};

module.exports = ReactDefaultBatchingStrategy;

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(9);

var EventListener = __webpack_require__(124);
var ExecutionEnvironment = __webpack_require__(16);
var PooledClass = __webpack_require__(27);
var ReactDOMComponentTree = __webpack_require__(13);
var ReactUpdates = __webpack_require__(20);

var getEventTarget = __webpack_require__(70);
var getUnboundedScrollPosition = __webpack_require__(240);

/**
 * Find the deepest React component completely containing the root of the
 * passed-in instance (for use when entire React trees are nested within each
 * other). If React trees are not nested, returns null.
 */
function findParent(inst) {
  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
  // traversal, but caching is difficult to do correctly without using a
  // mutation observer to listen for all DOM changes.
  while (inst._hostParent) {
    inst = inst._hostParent;
  }
  var rootNode = ReactDOMComponentTree.getNodeFromInstance(inst);
  var container = rootNode.parentNode;
  return ReactDOMComponentTree.getClosestInstanceFromNode(container);
}

// Used to store ancestor hierarchy in top level callback
function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
  this.topLevelType = topLevelType;
  this.nativeEvent = nativeEvent;
  this.ancestors = [];
}
_assign(TopLevelCallbackBookKeeping.prototype, {
  destructor: function () {
    this.topLevelType = null;
    this.nativeEvent = null;
    this.ancestors.length = 0;
  }
});
PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);

function handleTopLevelImpl(bookKeeping) {
  var nativeEventTarget = getEventTarget(bookKeeping.nativeEvent);
  var targetInst = ReactDOMComponentTree.getClosestInstanceFromNode(nativeEventTarget);

  // Loop through the hierarchy, in case there's any nested components.
  // It's important that we build the array of ancestors before calling any
  // event handlers, because event handlers can modify the DOM, leading to
  // inconsistencies with ReactMount's node cache. See #1105.
  var ancestor = targetInst;
  do {
    bookKeeping.ancestors.push(ancestor);
    ancestor = ancestor && findParent(ancestor);
  } while (ancestor);

  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
    targetInst = bookKeeping.ancestors[i];
    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
  }
}

function scrollValueMonitor(cb) {
  var scrollPosition = getUnboundedScrollPosition(window);
  cb(scrollPosition);
}

var ReactEventListener = {
  _enabled: true,
  _handleTopLevel: null,

  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,

  setHandleTopLevel: function (handleTopLevel) {
    ReactEventListener._handleTopLevel = handleTopLevel;
  },

  setEnabled: function (enabled) {
    ReactEventListener._enabled = !!enabled;
  },

  isEnabled: function () {
    return ReactEventListener._enabled;
  },

  /**
   * Traps top-level events by using event bubbling.
   *
   * @param {string} topLevelType Record from `EventConstants`.
   * @param {string} handlerBaseName Event name (e.g. "click").
   * @param {object} element Element on which to attach listener.
   * @return {?object} An object with a remove function which will forcefully
   *                  remove the listener.
   * @internal
   */
  trapBubbledEvent: function (topLevelType, handlerBaseName, element) {
    if (!element) {
      return null;
    }
    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
  },

  /**
   * Traps a top-level event by using event capturing.
   *
   * @param {string} topLevelType Record from `EventConstants`.
   * @param {string} handlerBaseName Event name (e.g. "click").
   * @param {object} element Element on which to attach listener.
   * @return {?object} An object with a remove function which will forcefully
   *                  remove the listener.
   * @internal
   */
  trapCapturedEvent: function (topLevelType, handlerBaseName, element) {
    if (!element) {
      return null;
    }
    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
  },

  monitorScrollValue: function (refresh) {
    var callback = scrollValueMonitor.bind(null, refresh);
    EventListener.listen(window, 'scroll', callback);
  },

  dispatchEvent: function (topLevelType, nativeEvent) {
    if (!ReactEventListener._enabled) {
      return;
    }

    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
    try {
      // Event queue being processed in the same cycle allows
      // `preventDefault`.
      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
    } finally {
      TopLevelCallbackBookKeeping.release(bookKeeping);
    }
  }
};

module.exports = ReactEventListener;

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */



/**
 * Gets the scroll position of the supplied element or window.
 *
 * The return values are unbounded, unlike `getScrollPosition`. This means they
 * may be negative or exceed the element boundaries (which is possible using
 * inertial scrolling).
 *
 * @param {DOMWindow|DOMElement} scrollable
 * @return {object} Map with `x` and `y` keys.
 */

function getUnboundedScrollPosition(scrollable) {
  if (scrollable.Window && scrollable instanceof scrollable.Window) {
    return {
      x: scrollable.pageXOffset || scrollable.document.documentElement.scrollLeft,
      y: scrollable.pageYOffset || scrollable.document.documentElement.scrollTop
    };
  }
  return {
    x: scrollable.scrollLeft,
    y: scrollable.scrollTop
  };
}

module.exports = getUnboundedScrollPosition;

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var DOMProperty = __webpack_require__(31);
var EventPluginHub = __webpack_require__(43);
var EventPluginUtils = __webpack_require__(68);
var ReactComponentEnvironment = __webpack_require__(77);
var ReactEmptyComponent = __webpack_require__(120);
var ReactBrowserEventEmitter = __webpack_require__(54);
var ReactHostComponent = __webpack_require__(121);
var ReactUpdates = __webpack_require__(20);

var ReactInjection = {
  Component: ReactComponentEnvironment.injection,
  DOMProperty: DOMProperty.injection,
  EmptyComponent: ReactEmptyComponent.injection,
  EventPluginHub: EventPluginHub.injection,
  EventPluginUtils: EventPluginUtils.injection,
  EventEmitter: ReactBrowserEventEmitter.injection,
  HostComponent: ReactHostComponent.injection,
  Updates: ReactUpdates.injection
};

module.exports = ReactInjection;

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(9);

var CallbackQueue = __webpack_require__(107);
var PooledClass = __webpack_require__(27);
var ReactBrowserEventEmitter = __webpack_require__(54);
var ReactInputSelection = __webpack_require__(125);
var ReactInstrumentation = __webpack_require__(18);
var Transaction = __webpack_require__(50);
var ReactUpdateQueue = __webpack_require__(80);

/**
 * Ensures that, when possible, the selection range (currently selected text
 * input) is not disturbed by performing the transaction.
 */
var SELECTION_RESTORATION = {
  /**
   * @return {Selection} Selection information.
   */
  initialize: ReactInputSelection.getSelectionInformation,
  /**
   * @param {Selection} sel Selection information returned from `initialize`.
   */
  close: ReactInputSelection.restoreSelection
};

/**
 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
 * high level DOM manipulations (like temporarily removing a text input from the
 * DOM).
 */
var EVENT_SUPPRESSION = {
  /**
   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
   * the reconciliation.
   */
  initialize: function () {
    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
    ReactBrowserEventEmitter.setEnabled(false);
    return currentlyEnabled;
  },

  /**
   * @param {boolean} previouslyEnabled Enabled status of
   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
   *   restores the previous value.
   */
  close: function (previouslyEnabled) {
    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
  }
};

/**
 * Provides a queue for collecting `componentDidMount` and
 * `componentDidUpdate` callbacks during the transaction.
 */
var ON_DOM_READY_QUEUEING = {
  /**
   * Initializes the internal `onDOMReady` queue.
   */
  initialize: function () {
    this.reactMountReady.reset();
  },

  /**
   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
   */
  close: function () {
    this.reactMountReady.notifyAll();
  }
};

/**
 * Executed within the scope of the `Transaction` instance. Consider these as
 * being member methods, but with an implied ordering while being isolated from
 * each other.
 */
var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];

if (false) {
  TRANSACTION_WRAPPERS.push({
    initialize: ReactInstrumentation.debugTool.onBeginFlush,
    close: ReactInstrumentation.debugTool.onEndFlush
  });
}

/**
 * Currently:
 * - The order that these are listed in the transaction is critical:
 * - Suppresses events.
 * - Restores selection range.
 *
 * Future:
 * - Restore document/overflow scroll positions that were unintentionally
 *   modified via DOM insertions above the top viewport boundary.
 * - Implement/integrate with customized constraint based layout system and keep
 *   track of which dimensions must be remeasured.
 *
 * @class ReactReconcileTransaction
 */
function ReactReconcileTransaction(useCreateElement) {
  this.reinitializeTransaction();
  // Only server-side rendering really needs this option (see
  // `ReactServerRendering`), but server-side uses
  // `ReactServerRenderingTransaction` instead. This option is here so that it's
  // accessible and defaults to false when `ReactDOMComponent` and
  // `ReactDOMTextComponent` checks it in `mountComponent`.`
  this.renderToStaticMarkup = false;
  this.reactMountReady = CallbackQueue.getPooled(null);
  this.useCreateElement = useCreateElement;
}

var Mixin = {
  /**
   * @see Transaction
   * @abstract
   * @final
   * @return {array<object>} List of operation wrap procedures.
   *   TODO: convert to array<TransactionWrapper>
   */
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  },

  /**
   * @return {object} The queue to collect `onDOMReady` callbacks with.
   */
  getReactMountReady: function () {
    return this.reactMountReady;
  },

  /**
   * @return {object} The queue to collect React async events.
   */
  getUpdateQueue: function () {
    return ReactUpdateQueue;
  },

  /**
   * Save current transaction state -- if the return value from this method is
   * passed to `rollback`, the transaction will be reset to that state.
   */
  checkpoint: function () {
    // reactMountReady is the our only stateful wrapper
    return this.reactMountReady.checkpoint();
  },

  rollback: function (checkpoint) {
    this.reactMountReady.rollback(checkpoint);
  },

  /**
   * `PooledClass` looks for this, and will invoke this before allowing this
   * instance to be reused.
   */
  destructor: function () {
    CallbackQueue.release(this.reactMountReady);
    this.reactMountReady = null;
  }
};

_assign(ReactReconcileTransaction.prototype, Transaction, Mixin);

PooledClass.addPoolingTo(ReactReconcileTransaction);

module.exports = ReactReconcileTransaction;

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ExecutionEnvironment = __webpack_require__(16);

var getNodeForCharacterOffset = __webpack_require__(244);
var getTextContentAccessor = __webpack_require__(106);

/**
 * While `isCollapsed` is available on the Selection object and `collapsed`
 * is available on the Range object, IE11 sometimes gets them wrong.
 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
 */
function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
  return anchorNode === focusNode && anchorOffset === focusOffset;
}

/**
 * Get the appropriate anchor and focus node/offset pairs for IE.
 *
 * The catch here is that IE's selection API doesn't provide information
 * about whether the selection is forward or backward, so we have to
 * behave as though it's always forward.
 *
 * IE text differs from modern selection in that it behaves as though
 * block elements end with a new line. This means character offsets will
 * differ between the two APIs.
 *
 * @param {DOMElement} node
 * @return {object}
 */
function getIEOffsets(node) {
  var selection = document.selection;
  var selectedRange = selection.createRange();
  var selectedLength = selectedRange.text.length;

  // Duplicate selection so we can move range without breaking user selection.
  var fromStart = selectedRange.duplicate();
  fromStart.moveToElementText(node);
  fromStart.setEndPoint('EndToStart', selectedRange);

  var startOffset = fromStart.text.length;
  var endOffset = startOffset + selectedLength;

  return {
    start: startOffset,
    end: endOffset
  };
}

/**
 * @param {DOMElement} node
 * @return {?object}
 */
function getModernOffsets(node) {
  var selection = window.getSelection && window.getSelection();

  if (!selection || selection.rangeCount === 0) {
    return null;
  }

  var anchorNode = selection.anchorNode;
  var anchorOffset = selection.anchorOffset;
  var focusNode = selection.focusNode;
  var focusOffset = selection.focusOffset;

  var currentRange = selection.getRangeAt(0);

  // In Firefox, range.startContainer and range.endContainer can be "anonymous
  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
  // divs do not seem to expose properties, triggering a "Permission denied
  // error" if any of its properties are accessed. The only seemingly possible
  // way to avoid erroring is to access a property that typically works for
  // non-anonymous divs and catch any error that may otherwise arise. See
  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
  try {
    /* eslint-disable no-unused-expressions */
    currentRange.startContainer.nodeType;
    currentRange.endContainer.nodeType;
    /* eslint-enable no-unused-expressions */
  } catch (e) {
    return null;
  }

  // If the node and offset values are the same, the selection is collapsed.
  // `Selection.isCollapsed` is available natively, but IE sometimes gets
  // this value wrong.
  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);

  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;

  var tempRange = currentRange.cloneRange();
  tempRange.selectNodeContents(node);
  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);

  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);

  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
  var end = start + rangeLength;

  // Detect whether the selection is backward.
  var detectionRange = document.createRange();
  detectionRange.setStart(anchorNode, anchorOffset);
  detectionRange.setEnd(focusNode, focusOffset);
  var isBackward = detectionRange.collapsed;

  return {
    start: isBackward ? end : start,
    end: isBackward ? start : end
  };
}

/**
 * @param {DOMElement|DOMTextNode} node
 * @param {object} offsets
 */
function setIEOffsets(node, offsets) {
  var range = document.selection.createRange().duplicate();
  var start, end;

  if (offsets.end === undefined) {
    start = offsets.start;
    end = start;
  } else if (offsets.start > offsets.end) {
    start = offsets.end;
    end = offsets.start;
  } else {
    start = offsets.start;
    end = offsets.end;
  }

  range.moveToElementText(node);
  range.moveStart('character', start);
  range.setEndPoint('EndToStart', range);
  range.moveEnd('character', end - start);
  range.select();
}

/**
 * In modern non-IE browsers, we can support both forward and backward
 * selections.
 *
 * Note: IE10+ supports the Selection object, but it does not support
 * the `extend` method, which means that even in modern IE, it's not possible
 * to programmatically create a backward selection. Thus, for all IE
 * versions, we use the old IE API to create our selections.
 *
 * @param {DOMElement|DOMTextNode} node
 * @param {object} offsets
 */
function setModernOffsets(node, offsets) {
  if (!window.getSelection) {
    return;
  }

  var selection = window.getSelection();
  var length = node[getTextContentAccessor()].length;
  var start = Math.min(offsets.start, length);
  var end = offsets.end === undefined ? start : Math.min(offsets.end, length);

  // IE 11 uses modern selection, but doesn't support the extend method.
  // Flip backward selections, so we can set with a single range.
  if (!selection.extend && start > end) {
    var temp = end;
    end = start;
    start = temp;
  }

  var startMarker = getNodeForCharacterOffset(node, start);
  var endMarker = getNodeForCharacterOffset(node, end);

  if (startMarker && endMarker) {
    var range = document.createRange();
    range.setStart(startMarker.node, startMarker.offset);
    selection.removeAllRanges();

    if (start > end) {
      selection.addRange(range);
      selection.extend(endMarker.node, endMarker.offset);
    } else {
      range.setEnd(endMarker.node, endMarker.offset);
      selection.addRange(range);
    }
  }
}

var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);

var ReactDOMSelection = {
  /**
   * @param {DOMElement} node
   */
  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,

  /**
   * @param {DOMElement|DOMTextNode} node
   * @param {object} offsets
   */
  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
};

module.exports = ReactDOMSelection;

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Given any node return the first leaf node without children.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {DOMElement|DOMTextNode}
 */

function getLeafNode(node) {
  while (node && node.firstChild) {
    node = node.firstChild;
  }
  return node;
}

/**
 * Get the next sibling within a container. This will walk up the
 * DOM if a node's siblings have been exhausted.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {?DOMElement|DOMTextNode}
 */
function getSiblingNode(node) {
  while (node) {
    if (node.nextSibling) {
      return node.nextSibling;
    }
    node = node.parentNode;
  }
}

/**
 * Get object describing the nodes which contain characters at offset.
 *
 * @param {DOMElement|DOMTextNode} root
 * @param {number} offset
 * @return {?object}
 */
function getNodeForCharacterOffset(root, offset) {
  var node = getLeafNode(root);
  var nodeStart = 0;
  var nodeEnd = 0;

  while (node) {
    if (node.nodeType === 3) {
      nodeEnd = nodeStart + node.textContent.length;

      if (nodeStart <= offset && nodeEnd >= offset) {
        return {
          node: node,
          offset: offset - nodeStart
        };
      }

      nodeStart = nodeEnd;
    }

    node = getLeafNode(getSiblingNode(node));
  }
}

module.exports = getNodeForCharacterOffset;

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

var isTextNode = __webpack_require__(246);

/*eslint-disable no-bitwise */

/**
 * Checks if a given DOM node contains or is another DOM node.
 */
function containsNode(outerNode, innerNode) {
  if (!outerNode || !innerNode) {
    return false;
  } else if (outerNode === innerNode) {
    return true;
  } else if (isTextNode(outerNode)) {
    return false;
  } else if (isTextNode(innerNode)) {
    return containsNode(outerNode, innerNode.parentNode);
  } else if ('contains' in outerNode) {
    return outerNode.contains(innerNode);
  } else if (outerNode.compareDocumentPosition) {
    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
  } else {
    return false;
  }
}

module.exports = containsNode;

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var isNode = __webpack_require__(247);

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM text node.
 */
function isTextNode(object) {
  return isNode(object) && object.nodeType == 3;
}

module.exports = isTextNode;

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM node.
 */
function isNode(object) {
  var doc = object ? object.ownerDocument || object : document;
  var defaultView = doc.defaultView || window;
  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
}

module.exports = isNode;

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var NS = {
  xlink: 'http://www.w3.org/1999/xlink',
  xml: 'http://www.w3.org/XML/1998/namespace'
};

// We use attributes for everything SVG so let's avoid some duplication and run
// code instead.
// The following are all specified in the HTML config already so we exclude here.
// - class (as className)
// - color
// - height
// - id
// - lang
// - max
// - media
// - method
// - min
// - name
// - style
// - target
// - type
// - width
var ATTRS = {
  accentHeight: 'accent-height',
  accumulate: 0,
  additive: 0,
  alignmentBaseline: 'alignment-baseline',
  allowReorder: 'allowReorder',
  alphabetic: 0,
  amplitude: 0,
  arabicForm: 'arabic-form',
  ascent: 0,
  attributeName: 'attributeName',
  attributeType: 'attributeType',
  autoReverse: 'autoReverse',
  azimuth: 0,
  baseFrequency: 'baseFrequency',
  baseProfile: 'baseProfile',
  baselineShift: 'baseline-shift',
  bbox: 0,
  begin: 0,
  bias: 0,
  by: 0,
  calcMode: 'calcMode',
  capHeight: 'cap-height',
  clip: 0,
  clipPath: 'clip-path',
  clipRule: 'clip-rule',
  clipPathUnits: 'clipPathUnits',
  colorInterpolation: 'color-interpolation',
  colorInterpolationFilters: 'color-interpolation-filters',
  colorProfile: 'color-profile',
  colorRendering: 'color-rendering',
  contentScriptType: 'contentScriptType',
  contentStyleType: 'contentStyleType',
  cursor: 0,
  cx: 0,
  cy: 0,
  d: 0,
  decelerate: 0,
  descent: 0,
  diffuseConstant: 'diffuseConstant',
  direction: 0,
  display: 0,
  divisor: 0,
  dominantBaseline: 'dominant-baseline',
  dur: 0,
  dx: 0,
  dy: 0,
  edgeMode: 'edgeMode',
  elevation: 0,
  enableBackground: 'enable-background',
  end: 0,
  exponent: 0,
  externalResourcesRequired: 'externalResourcesRequired',
  fill: 0,
  fillOpacity: 'fill-opacity',
  fillRule: 'fill-rule',
  filter: 0,
  filterRes: 'filterRes',
  filterUnits: 'filterUnits',
  floodColor: 'flood-color',
  floodOpacity: 'flood-opacity',
  focusable: 0,
  fontFamily: 'font-family',
  fontSize: 'font-size',
  fontSizeAdjust: 'font-size-adjust',
  fontStretch: 'font-stretch',
  fontStyle: 'font-style',
  fontVariant: 'font-variant',
  fontWeight: 'font-weight',
  format: 0,
  from: 0,
  fx: 0,
  fy: 0,
  g1: 0,
  g2: 0,
  glyphName: 'glyph-name',
  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
  glyphOrientationVertical: 'glyph-orientation-vertical',
  glyphRef: 'glyphRef',
  gradientTransform: 'gradientTransform',
  gradientUnits: 'gradientUnits',
  hanging: 0,
  horizAdvX: 'horiz-adv-x',
  horizOriginX: 'horiz-origin-x',
  ideographic: 0,
  imageRendering: 'image-rendering',
  'in': 0,
  in2: 0,
  intercept: 0,
  k: 0,
  k1: 0,
  k2: 0,
  k3: 0,
  k4: 0,
  kernelMatrix: 'kernelMatrix',
  kernelUnitLength: 'kernelUnitLength',
  kerning: 0,
  keyPoints: 'keyPoints',
  keySplines: 'keySplines',
  keyTimes: 'keyTimes',
  lengthAdjust: 'lengthAdjust',
  letterSpacing: 'letter-spacing',
  lightingColor: 'lighting-color',
  limitingConeAngle: 'limitingConeAngle',
  local: 0,
  markerEnd: 'marker-end',
  markerMid: 'marker-mid',
  markerStart: 'marker-start',
  markerHeight: 'markerHeight',
  markerUnits: 'markerUnits',
  markerWidth: 'markerWidth',
  mask: 0,
  maskContentUnits: 'maskContentUnits',
  maskUnits: 'maskUnits',
  mathematical: 0,
  mode: 0,
  numOctaves: 'numOctaves',
  offset: 0,
  opacity: 0,
  operator: 0,
  order: 0,
  orient: 0,
  orientation: 0,
  origin: 0,
  overflow: 0,
  overlinePosition: 'overline-position',
  overlineThickness: 'overline-thickness',
  paintOrder: 'paint-order',
  panose1: 'panose-1',
  pathLength: 'pathLength',
  patternContentUnits: 'patternContentUnits',
  patternTransform: 'patternTransform',
  patternUnits: 'patternUnits',
  pointerEvents: 'pointer-events',
  points: 0,
  pointsAtX: 'pointsAtX',
  pointsAtY: 'pointsAtY',
  pointsAtZ: 'pointsAtZ',
  preserveAlpha: 'preserveAlpha',
  preserveAspectRatio: 'preserveAspectRatio',
  primitiveUnits: 'primitiveUnits',
  r: 0,
  radius: 0,
  refX: 'refX',
  refY: 'refY',
  renderingIntent: 'rendering-intent',
  repeatCount: 'repeatCount',
  repeatDur: 'repeatDur',
  requiredExtensions: 'requiredExtensions',
  requiredFeatures: 'requiredFeatures',
  restart: 0,
  result: 0,
  rotate: 0,
  rx: 0,
  ry: 0,
  scale: 0,
  seed: 0,
  shapeRendering: 'shape-rendering',
  slope: 0,
  spacing: 0,
  specularConstant: 'specularConstant',
  specularExponent: 'specularExponent',
  speed: 0,
  spreadMethod: 'spreadMethod',
  startOffset: 'startOffset',
  stdDeviation: 'stdDeviation',
  stemh: 0,
  stemv: 0,
  stitchTiles: 'stitchTiles',
  stopColor: 'stop-color',
  stopOpacity: 'stop-opacity',
  strikethroughPosition: 'strikethrough-position',
  strikethroughThickness: 'strikethrough-thickness',
  string: 0,
  stroke: 0,
  strokeDasharray: 'stroke-dasharray',
  strokeDashoffset: 'stroke-dashoffset',
  strokeLinecap: 'stroke-linecap',
  strokeLinejoin: 'stroke-linejoin',
  strokeMiterlimit: 'stroke-miterlimit',
  strokeOpacity: 'stroke-opacity',
  strokeWidth: 'stroke-width',
  surfaceScale: 'surfaceScale',
  systemLanguage: 'systemLanguage',
  tableValues: 'tableValues',
  targetX: 'targetX',
  targetY: 'targetY',
  textAnchor: 'text-anchor',
  textDecoration: 'text-decoration',
  textRendering: 'text-rendering',
  textLength: 'textLength',
  to: 0,
  transform: 0,
  u1: 0,
  u2: 0,
  underlinePosition: 'underline-position',
  underlineThickness: 'underline-thickness',
  unicode: 0,
  unicodeBidi: 'unicode-bidi',
  unicodeRange: 'unicode-range',
  unitsPerEm: 'units-per-em',
  vAlphabetic: 'v-alphabetic',
  vHanging: 'v-hanging',
  vIdeographic: 'v-ideographic',
  vMathematical: 'v-mathematical',
  values: 0,
  vectorEffect: 'vector-effect',
  version: 0,
  vertAdvY: 'vert-adv-y',
  vertOriginX: 'vert-origin-x',
  vertOriginY: 'vert-origin-y',
  viewBox: 'viewBox',
  viewTarget: 'viewTarget',
  visibility: 0,
  widths: 0,
  wordSpacing: 'word-spacing',
  writingMode: 'writing-mode',
  x: 0,
  xHeight: 'x-height',
  x1: 0,
  x2: 0,
  xChannelSelector: 'xChannelSelector',
  xlinkActuate: 'xlink:actuate',
  xlinkArcrole: 'xlink:arcrole',
  xlinkHref: 'xlink:href',
  xlinkRole: 'xlink:role',
  xlinkShow: 'xlink:show',
  xlinkTitle: 'xlink:title',
  xlinkType: 'xlink:type',
  xmlBase: 'xml:base',
  xmlns: 0,
  xmlnsXlink: 'xmlns:xlink',
  xmlLang: 'xml:lang',
  xmlSpace: 'xml:space',
  y: 0,
  y1: 0,
  y2: 0,
  yChannelSelector: 'yChannelSelector',
  z: 0,
  zoomAndPan: 'zoomAndPan'
};

var SVGDOMPropertyConfig = {
  Properties: {},
  DOMAttributeNamespaces: {
    xlinkActuate: NS.xlink,
    xlinkArcrole: NS.xlink,
    xlinkHref: NS.xlink,
    xlinkRole: NS.xlink,
    xlinkShow: NS.xlink,
    xlinkTitle: NS.xlink,
    xlinkType: NS.xlink,
    xmlBase: NS.xml,
    xmlLang: NS.xml,
    xmlSpace: NS.xml
  },
  DOMAttributeNames: {}
};

Object.keys(ATTRS).forEach(function (key) {
  SVGDOMPropertyConfig.Properties[key] = 0;
  if (ATTRS[key]) {
    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
  }
});

module.exports = SVGDOMPropertyConfig;

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var EventPropagators = __webpack_require__(42);
var ExecutionEnvironment = __webpack_require__(16);
var ReactDOMComponentTree = __webpack_require__(13);
var ReactInputSelection = __webpack_require__(125);
var SyntheticEvent = __webpack_require__(23);

var getActiveElement = __webpack_require__(126);
var isTextInputElement = __webpack_require__(110);
var shallowEqual = __webpack_require__(55);

var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;

var eventTypes = {
  select: {
    phasedRegistrationNames: {
      bubbled: 'onSelect',
      captured: 'onSelectCapture'
    },
    dependencies: ['topBlur', 'topContextMenu', 'topFocus', 'topKeyDown', 'topKeyUp', 'topMouseDown', 'topMouseUp', 'topSelectionChange']
  }
};

var activeElement = null;
var activeElementInst = null;
var lastSelection = null;
var mouseDown = false;

// Track whether a listener exists for this plugin. If none exist, we do
// not extract events. See #3639.
var hasListener = false;

/**
 * Get an object which is a unique representation of the current selection.
 *
 * The return value will not be consistent across nodes or browsers, but
 * two identical selections on the same node will return identical objects.
 *
 * @param {DOMElement} node
 * @return {object}
 */
function getSelection(node) {
  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
    return {
      start: node.selectionStart,
      end: node.selectionEnd
    };
  } else if (window.getSelection) {
    var selection = window.getSelection();
    return {
      anchorNode: selection.anchorNode,
      anchorOffset: selection.anchorOffset,
      focusNode: selection.focusNode,
      focusOffset: selection.focusOffset
    };
  } else if (document.selection) {
    var range = document.selection.createRange();
    return {
      parentElement: range.parentElement(),
      text: range.text,
      top: range.boundingTop,
      left: range.boundingLeft
    };
  }
}

/**
 * Poll selection to see whether it's changed.
 *
 * @param {object} nativeEvent
 * @return {?SyntheticEvent}
 */
function constructSelectEvent(nativeEvent, nativeEventTarget) {
  // Ensure we have the right element, and that the user is not dragging a
  // selection (this matches native `select` event behavior). In HTML5, select
  // fires only on input and textarea thus if there's no focused element we
  // won't dispatch.
  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
    return null;
  }

  // Only fire when selection has actually changed.
  var currentSelection = getSelection(activeElement);
  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
    lastSelection = currentSelection;

    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementInst, nativeEvent, nativeEventTarget);

    syntheticEvent.type = 'select';
    syntheticEvent.target = activeElement;

    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);

    return syntheticEvent;
  }

  return null;
}

/**
 * This plugin creates an `onSelect` event that normalizes select events
 * across form elements.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - contentEditable
 *
 * This differs from native browser implementations in the following ways:
 * - Fires on contentEditable fields as well as inputs.
 * - Fires for collapsed selection.
 * - Fires after user input.
 */
var SelectEventPlugin = {
  eventTypes: eventTypes,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    if (!hasListener) {
      return null;
    }

    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;

    switch (topLevelType) {
      // Track the input node that has focus.
      case 'topFocus':
        if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
          activeElement = targetNode;
          activeElementInst = targetInst;
          lastSelection = null;
        }
        break;
      case 'topBlur':
        activeElement = null;
        activeElementInst = null;
        lastSelection = null;
        break;
      // Don't fire the event while the user is dragging. This matches the
      // semantics of the native select event.
      case 'topMouseDown':
        mouseDown = true;
        break;
      case 'topContextMenu':
      case 'topMouseUp':
        mouseDown = false;
        return constructSelectEvent(nativeEvent, nativeEventTarget);
      // Chrome and IE fire non-standard event when selection is changed (and
      // sometimes when it hasn't). IE's event fires out of order with respect
      // to key and input events on deletion, so we discard it.
      //
      // Firefox doesn't support selectionchange, so check selection status
      // after each key entry. The selection changes after keydown and before
      // keyup, but we check on keydown as well in the case of holding down a
      // key, when multiple keydown events are fired but only one keyup is.
      // This is also our approach for IE handling, for the reason above.
      case 'topSelectionChange':
        if (skipSelectionChangeEvent) {
          break;
        }
      // falls through
      case 'topKeyDown':
      case 'topKeyUp':
        return constructSelectEvent(nativeEvent, nativeEventTarget);
    }

    return null;
  },

  didPutListener: function (inst, registrationName, listener) {
    if (registrationName === 'onSelect') {
      hasListener = true;
    }
  }
};

module.exports = SelectEventPlugin;

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(6);

var EventListener = __webpack_require__(124);
var EventPropagators = __webpack_require__(42);
var ReactDOMComponentTree = __webpack_require__(13);
var SyntheticAnimationEvent = __webpack_require__(251);
var SyntheticClipboardEvent = __webpack_require__(252);
var SyntheticEvent = __webpack_require__(23);
var SyntheticFocusEvent = __webpack_require__(253);
var SyntheticKeyboardEvent = __webpack_require__(254);
var SyntheticMouseEvent = __webpack_require__(51);
var SyntheticDragEvent = __webpack_require__(256);
var SyntheticTouchEvent = __webpack_require__(257);
var SyntheticTransitionEvent = __webpack_require__(258);
var SyntheticUIEvent = __webpack_require__(44);
var SyntheticWheelEvent = __webpack_require__(259);

var emptyFunction = __webpack_require__(19);
var getEventCharCode = __webpack_require__(82);
var invariant = __webpack_require__(4);

/**
 * Turns
 * ['abort', ...]
 * into
 * eventTypes = {
 *   'abort': {
 *     phasedRegistrationNames: {
 *       bubbled: 'onAbort',
 *       captured: 'onAbortCapture',
 *     },
 *     dependencies: ['topAbort'],
 *   },
 *   ...
 * };
 * topLevelEventsToDispatchConfig = {
 *   'topAbort': { sameConfig }
 * };
 */
var eventTypes = {};
var topLevelEventsToDispatchConfig = {};
['abort', 'animationEnd', 'animationIteration', 'animationStart', 'blur', 'canPlay', 'canPlayThrough', 'click', 'contextMenu', 'copy', 'cut', 'doubleClick', 'drag', 'dragEnd', 'dragEnter', 'dragExit', 'dragLeave', 'dragOver', 'dragStart', 'drop', 'durationChange', 'emptied', 'encrypted', 'ended', 'error', 'focus', 'input', 'invalid', 'keyDown', 'keyPress', 'keyUp', 'load', 'loadedData', 'loadedMetadata', 'loadStart', 'mouseDown', 'mouseMove', 'mouseOut', 'mouseOver', 'mouseUp', 'paste', 'pause', 'play', 'playing', 'progress', 'rateChange', 'reset', 'scroll', 'seeked', 'seeking', 'stalled', 'submit', 'suspend', 'timeUpdate', 'touchCancel', 'touchEnd', 'touchMove', 'touchStart', 'transitionEnd', 'volumeChange', 'waiting', 'wheel'].forEach(function (event) {
  var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
  var onEvent = 'on' + capitalizedEvent;
  var topEvent = 'top' + capitalizedEvent;

  var type = {
    phasedRegistrationNames: {
      bubbled: onEvent,
      captured: onEvent + 'Capture'
    },
    dependencies: [topEvent]
  };
  eventTypes[event] = type;
  topLevelEventsToDispatchConfig[topEvent] = type;
});

var onClickListeners = {};

function getDictionaryKey(inst) {
  // Prevents V8 performance issue:
  // https://github.com/facebook/react/pull/7232
  return '.' + inst._rootNodeID;
}

function isInteractive(tag) {
  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
}

var SimpleEventPlugin = {
  eventTypes: eventTypes,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
    if (!dispatchConfig) {
      return null;
    }
    var EventConstructor;
    switch (topLevelType) {
      case 'topAbort':
      case 'topCanPlay':
      case 'topCanPlayThrough':
      case 'topDurationChange':
      case 'topEmptied':
      case 'topEncrypted':
      case 'topEnded':
      case 'topError':
      case 'topInput':
      case 'topInvalid':
      case 'topLoad':
      case 'topLoadedData':
      case 'topLoadedMetadata':
      case 'topLoadStart':
      case 'topPause':
      case 'topPlay':
      case 'topPlaying':
      case 'topProgress':
      case 'topRateChange':
      case 'topReset':
      case 'topSeeked':
      case 'topSeeking':
      case 'topStalled':
      case 'topSubmit':
      case 'topSuspend':
      case 'topTimeUpdate':
      case 'topVolumeChange':
      case 'topWaiting':
        // HTML Events
        // @see http://www.w3.org/TR/html5/index.html#events-0
        EventConstructor = SyntheticEvent;
        break;
      case 'topKeyPress':
        // Firefox creates a keypress event for function keys too. This removes
        // the unwanted keypress events. Enter is however both printable and
        // non-printable. One would expect Tab to be as well (but it isn't).
        if (getEventCharCode(nativeEvent) === 0) {
          return null;
        }
      /* falls through */
      case 'topKeyDown':
      case 'topKeyUp':
        EventConstructor = SyntheticKeyboardEvent;
        break;
      case 'topBlur':
      case 'topFocus':
        EventConstructor = SyntheticFocusEvent;
        break;
      case 'topClick':
        // Firefox creates a click event on right mouse clicks. This removes the
        // unwanted click events.
        if (nativeEvent.button === 2) {
          return null;
        }
      /* falls through */
      case 'topDoubleClick':
      case 'topMouseDown':
      case 'topMouseMove':
      case 'topMouseUp':
      // TODO: Disabled elements should not respond to mouse events
      /* falls through */
      case 'topMouseOut':
      case 'topMouseOver':
      case 'topContextMenu':
        EventConstructor = SyntheticMouseEvent;
        break;
      case 'topDrag':
      case 'topDragEnd':
      case 'topDragEnter':
      case 'topDragExit':
      case 'topDragLeave':
      case 'topDragOver':
      case 'topDragStart':
      case 'topDrop':
        EventConstructor = SyntheticDragEvent;
        break;
      case 'topTouchCancel':
      case 'topTouchEnd':
      case 'topTouchMove':
      case 'topTouchStart':
        EventConstructor = SyntheticTouchEvent;
        break;
      case 'topAnimationEnd':
      case 'topAnimationIteration':
      case 'topAnimationStart':
        EventConstructor = SyntheticAnimationEvent;
        break;
      case 'topTransitionEnd':
        EventConstructor = SyntheticTransitionEvent;
        break;
      case 'topScroll':
        EventConstructor = SyntheticUIEvent;
        break;
      case 'topWheel':
        EventConstructor = SyntheticWheelEvent;
        break;
      case 'topCopy':
      case 'topCut':
      case 'topPaste':
        EventConstructor = SyntheticClipboardEvent;
        break;
    }
    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : _prodInvariant('86', topLevelType) : void 0;
    var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
    EventPropagators.accumulateTwoPhaseDispatches(event);
    return event;
  },

  didPutListener: function (inst, registrationName, listener) {
    // Mobile Safari does not fire properly bubble click events on
    // non-interactive elements, which means delegated click listeners do not
    // fire. The workaround for this bug involves attaching an empty click
    // listener on the target node.
    // http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
      var key = getDictionaryKey(inst);
      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
      if (!onClickListeners[key]) {
        onClickListeners[key] = EventListener.listen(node, 'click', emptyFunction);
      }
    }
  },

  willDeleteListener: function (inst, registrationName) {
    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
      var key = getDictionaryKey(inst);
      onClickListeners[key].remove();
      delete onClickListeners[key];
    }
  }
};

module.exports = SimpleEventPlugin;

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticEvent = __webpack_require__(23);

/**
 * @interface Event
 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
 */
var AnimationEventInterface = {
  animationName: null,
  elapsedTime: null,
  pseudoElement: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticEvent}
 */
function SyntheticAnimationEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticAnimationEvent, AnimationEventInterface);

module.exports = SyntheticAnimationEvent;

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticEvent = __webpack_require__(23);

/**
 * @interface Event
 * @see http://www.w3.org/TR/clipboard-apis/
 */
var ClipboardEventInterface = {
  clipboardData: function (event) {
    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);

module.exports = SyntheticClipboardEvent;

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticUIEvent = __webpack_require__(44);

/**
 * @interface FocusEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var FocusEventInterface = {
  relatedTarget: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);

module.exports = SyntheticFocusEvent;

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticUIEvent = __webpack_require__(44);

var getEventCharCode = __webpack_require__(82);
var getEventKey = __webpack_require__(255);
var getEventModifierState = __webpack_require__(72);

/**
 * @interface KeyboardEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var KeyboardEventInterface = {
  key: getEventKey,
  location: null,
  ctrlKey: null,
  shiftKey: null,
  altKey: null,
  metaKey: null,
  repeat: null,
  locale: null,
  getModifierState: getEventModifierState,
  // Legacy Interface
  charCode: function (event) {
    // `charCode` is the result of a KeyPress event and represents the value of
    // the actual printable character.

    // KeyPress is deprecated, but its replacement is not yet final and not
    // implemented in any major browser. Only KeyPress has charCode.
    if (event.type === 'keypress') {
      return getEventCharCode(event);
    }
    return 0;
  },
  keyCode: function (event) {
    // `keyCode` is the result of a KeyDown/Up event and represents the value of
    // physical keyboard key.

    // The actual meaning of the value depends on the users' keyboard layout
    // which cannot be detected. Assuming that it is a US keyboard layout
    // provides a surprisingly accurate mapping for US and European users.
    // Due to this, it is left to the user to implement at this time.
    if (event.type === 'keydown' || event.type === 'keyup') {
      return event.keyCode;
    }
    return 0;
  },
  which: function (event) {
    // `which` is an alias for either `keyCode` or `charCode` depending on the
    // type of the event.
    if (event.type === 'keypress') {
      return getEventCharCode(event);
    }
    if (event.type === 'keydown' || event.type === 'keyup') {
      return event.keyCode;
    }
    return 0;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);

module.exports = SyntheticKeyboardEvent;

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var getEventCharCode = __webpack_require__(82);

/**
 * Normalization of deprecated HTML5 `key` values
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */
var normalizeKey = {
  Esc: 'Escape',
  Spacebar: ' ',
  Left: 'ArrowLeft',
  Up: 'ArrowUp',
  Right: 'ArrowRight',
  Down: 'ArrowDown',
  Del: 'Delete',
  Win: 'OS',
  Menu: 'ContextMenu',
  Apps: 'ContextMenu',
  Scroll: 'ScrollLock',
  MozPrintableKey: 'Unidentified'
};

/**
 * Translation from legacy `keyCode` to HTML5 `key`
 * Only special keys supported, all others depend on keyboard layout or browser
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */
var translateToKey = {
  8: 'Backspace',
  9: 'Tab',
  12: 'Clear',
  13: 'Enter',
  16: 'Shift',
  17: 'Control',
  18: 'Alt',
  19: 'Pause',
  20: 'CapsLock',
  27: 'Escape',
  32: ' ',
  33: 'PageUp',
  34: 'PageDown',
  35: 'End',
  36: 'Home',
  37: 'ArrowLeft',
  38: 'ArrowUp',
  39: 'ArrowRight',
  40: 'ArrowDown',
  45: 'Insert',
  46: 'Delete',
  112: 'F1',
  113: 'F2',
  114: 'F3',
  115: 'F4',
  116: 'F5',
  117: 'F6',
  118: 'F7',
  119: 'F8',
  120: 'F9',
  121: 'F10',
  122: 'F11',
  123: 'F12',
  144: 'NumLock',
  145: 'ScrollLock',
  224: 'Meta'
};

/**
 * @param {object} nativeEvent Native browser event.
 * @return {string} Normalized `key` property.
 */
function getEventKey(nativeEvent) {
  if (nativeEvent.key) {
    // Normalize inconsistent values reported by browsers due to
    // implementations of a working draft specification.

    // FireFox implements `key` but returns `MozPrintableKey` for all
    // printable characters (normalized to `Unidentified`), ignore it.
    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
    if (key !== 'Unidentified') {
      return key;
    }
  }

  // Browser does not implement `key`, polyfill as much of it as we can.
  if (nativeEvent.type === 'keypress') {
    var charCode = getEventCharCode(nativeEvent);

    // The enter-key is technically both printable and non-printable and can
    // thus be captured by `keypress`, no other non-printable key should.
    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
  }
  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
    // While user keyboard layout determines the actual meaning of each
    // `keyCode` value, almost all function keys have a universal value.
    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
  }
  return '';
}

module.exports = getEventKey;

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticMouseEvent = __webpack_require__(51);

/**
 * @interface DragEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var DragEventInterface = {
  dataTransfer: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);

module.exports = SyntheticDragEvent;

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticUIEvent = __webpack_require__(44);

var getEventModifierState = __webpack_require__(72);

/**
 * @interface TouchEvent
 * @see http://www.w3.org/TR/touch-events/
 */
var TouchEventInterface = {
  touches: null,
  targetTouches: null,
  changedTouches: null,
  altKey: null,
  metaKey: null,
  ctrlKey: null,
  shiftKey: null,
  getModifierState: getEventModifierState
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);

module.exports = SyntheticTouchEvent;

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticEvent = __webpack_require__(23);

/**
 * @interface Event
 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
 */
var TransitionEventInterface = {
  propertyName: null,
  elapsedTime: null,
  pseudoElement: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticEvent}
 */
function SyntheticTransitionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticTransitionEvent, TransitionEventInterface);

module.exports = SyntheticTransitionEvent;

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticMouseEvent = __webpack_require__(51);

/**
 * @interface WheelEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var WheelEventInterface = {
  deltaX: function (event) {
    return 'deltaX' in event ? event.deltaX : // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
  },
  deltaY: function (event) {
    return 'deltaY' in event ? event.deltaY : // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
    'wheelDeltaY' in event ? -event.wheelDeltaY : // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
    'wheelDelta' in event ? -event.wheelDelta : 0;
  },
  deltaZ: null,

  // Browsers without "deltaMode" is reporting in raw wheel delta where one
  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
  deltaMode: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticMouseEvent}
 */
function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);

module.exports = SyntheticWheelEvent;

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var validateDOMNesting = __webpack_require__(81);

var DOC_NODE_TYPE = 9;

function ReactDOMContainerInfo(topLevelWrapper, node) {
  var info = {
    _topLevelWrapper: topLevelWrapper,
    _idCounter: 1,
    _ownerDocument: node ? node.nodeType === DOC_NODE_TYPE ? node : node.ownerDocument : null,
    _node: node,
    _tag: node ? node.nodeName.toLowerCase() : null,
    _namespaceURI: node ? node.namespaceURI : null
  };
  if (false) {
    info._ancestorInfo = node ? validateDOMNesting.updatedAncestorInfo(null, info._tag, null) : null;
  }
  return info;
}

module.exports = ReactDOMContainerInfo;

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactDOMFeatureFlags = {
  useCreateElement: true,
  useFiber: false
};

module.exports = ReactDOMFeatureFlags;

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var adler32 = __webpack_require__(263);

var TAG_END = /\/?>/;
var COMMENT_START = /^<\!\-\-/;

var ReactMarkupChecksum = {
  CHECKSUM_ATTR_NAME: 'data-react-checksum',

  /**
   * @param {string} markup Markup string
   * @return {string} Markup string with checksum attribute attached
   */
  addChecksumToMarkup: function (markup) {
    var checksum = adler32(markup);

    // Add checksum (handle both parent tags, comments and self-closing tags)
    if (COMMENT_START.test(markup)) {
      return markup;
    } else {
      return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
    }
  },

  /**
   * @param {string} markup to use
   * @param {DOMElement} element root React element
   * @returns {boolean} whether or not the markup is the same
   */
  canReuseMarkup: function (markup, element) {
    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
    var markupChecksum = adler32(markup);
    return markupChecksum === existingChecksum;
  }
};

module.exports = ReactMarkupChecksum;

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var MOD = 65521;

// adler32 is not cryptographically strong, and is only used to sanity check that
// markup generated on the server matches the markup generated on the client.
// This implementation (a modified version of the SheetJS version) has been optimized
// for our use case, at the expense of conforming to the adler32 specification
// for non-ascii inputs.
function adler32(data) {
  var a = 1;
  var b = 0;
  var i = 0;
  var l = data.length;
  var m = l & ~0x3;
  while (i < m) {
    var n = Math.min(i + 4096, m);
    for (; i < n; i += 4) {
      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
    }
    a %= MOD;
    b %= MOD;
  }
  for (; i < l; i++) {
    b += a += data.charCodeAt(i);
  }
  a %= MOD;
  b %= MOD;
  return a | b << 16;
}

module.exports = adler32;

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



module.exports = '15.6.2';

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(6);

var ReactCurrentOwner = __webpack_require__(22);
var ReactDOMComponentTree = __webpack_require__(13);
var ReactInstanceMap = __webpack_require__(45);

var getHostComponentFromComposite = __webpack_require__(128);
var invariant = __webpack_require__(4);
var warning = __webpack_require__(7);

/**
 * Returns the DOM node rendered by this element.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.finddomnode
 *
 * @param {ReactComponent|DOMElement} componentOrElement
 * @return {?DOMElement} The root node of this element.
 */
function findDOMNode(componentOrElement) {
  if (false) {
    var owner = ReactCurrentOwner.current;
    if (owner !== null) {
      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
      owner._warnedAboutRefsInRender = true;
    }
  }
  if (componentOrElement == null) {
    return null;
  }
  if (componentOrElement.nodeType === 1) {
    return componentOrElement;
  }

  var inst = ReactInstanceMap.get(componentOrElement);
  if (inst) {
    inst = getHostComponentFromComposite(inst);
    return inst ? ReactDOMComponentTree.getNodeFromInstance(inst) : null;
  }

  if (typeof componentOrElement.render === 'function') {
     true ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : _prodInvariant('44') : void 0;
  } else {
     true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : _prodInvariant('45', Object.keys(componentOrElement)) : void 0;
  }
}

module.exports = findDOMNode;

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactMount = __webpack_require__(127);

module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ }),
/* 267 */
/***/ (function(module, exports) {

Array.prototype.includes||Object.defineProperty(Array.prototype,"includes",{value:function(r,e){if(null==this)throw new TypeError('"this" is null or not defined');var t=Object(this),n=t.length>>>0;if(0===n)return!1;for(var i=0|e,o=Math.max(i>=0?i:n-Math.abs(i),0);o<n;){if(function(r,e){return r===e||"number"==typeof r&&"number"==typeof e&&isNaN(r)&&isNaN(e)}(t[o],r))return!0;o++}return!1}});

/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__scenes__ = __webpack_require__(156);
/* harmony default export */ __webpack_exports__["a"] = (function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux__["a" /* Provider */],{store:__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* BrowserRouter */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__scenes__["c" /* AuthGate */],null))));});

/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createProvider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_warning__ = __webpack_require__(83);





var prefixUnsafeLifecycleMethods = typeof __WEBPACK_IMPORTED_MODULE_1_react___default.a.forwardRef !== "undefined";
var didWarnAboutReceivingStore = false;

function warnAboutReceivingStore() {
  if (didWarnAboutReceivingStore) {
    return;
  }

  didWarnAboutReceivingStore = true;
  Object(__WEBPACK_IMPORTED_MODULE_4__utils_warning__["a" /* default */])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reduxjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
}

function createProvider(storeKey) {
  var _Provider$childContex;

  if (storeKey === void 0) {
    storeKey = 'store';
  }

  var subscriptionKey = storeKey + "Subscription";

  var Provider =
  /*#__PURE__*/
  function (_Component) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Provider, _Component);

    var _proto = Provider.prototype;

    _proto.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
    };

    function Provider(props, context) {
      var _this;

      _this = _Component.call(this, props, context) || this;
      _this[storeKey] = props.store;
      return _this;
    }

    _proto.render = function render() {
      return __WEBPACK_IMPORTED_MODULE_1_react__["Children"].only(this.props.children);
    };

    return Provider;
  }(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

  if (false) {
    // Use UNSAFE_ event name where supported
    var eventName = prefixUnsafeLifecycleMethods ? 'UNSAFE_componentWillReceiveProps' : 'componentWillReceiveProps';

    Provider.prototype[eventName] = function (nextProps) {
      if (this[storeKey] !== nextProps.store) {
        warnAboutReceivingStore();
      }
    };
  }

  Provider.propTypes = {
    store: __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__["a" /* storeShape */].isRequired,
    children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.element.isRequired
  };
  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__["a" /* storeShape */].isRequired, _Provider$childContex[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__["b" /* subscriptionShape */], _Provider$childContex);
  return Provider;
}
/* harmony default export */ __webpack_exports__["a"] = (createProvider());

/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _setPrototypeOf;
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(102);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _assertThisInitialized;
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(66);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Subscription; });
// encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
var CLEARED = null;
var nullListeners = {
  notify: function notify() {}
};

function createListenerCollection() {
  // the current/next pattern is copied from redux's createStore code.
  // TODO: refactor+expose that code to be reusable here?
  var current = [];
  var next = [];
  return {
    clear: function clear() {
      next = CLEARED;
      current = CLEARED;
    },
    notify: function notify() {
      var listeners = current = next;

      for (var i = 0; i < listeners.length; i++) {
        listeners[i]();
      }
    },
    get: function get() {
      return next;
    },
    subscribe: function subscribe(listener) {
      var isSubscribed = true;
      if (next === current) next = current.slice();
      next.push(listener);
      return function unsubscribe() {
        if (!isSubscribed || current === CLEARED) return;
        isSubscribed = false;
        if (next === current) next = current.slice();
        next.splice(next.indexOf(listener), 1);
      };
    }
  };
}

var Subscription =
/*#__PURE__*/
function () {
  function Subscription(store, parentSub, onStateChange) {
    this.store = store;
    this.parentSub = parentSub;
    this.onStateChange = onStateChange;
    this.unsubscribe = null;
    this.listeners = nullListeners;
  }

  var _proto = Subscription.prototype;

  _proto.addNestedSub = function addNestedSub(listener) {
    this.trySubscribe();
    return this.listeners.subscribe(listener);
  };

  _proto.notifyNestedSubs = function notifyNestedSubs() {
    this.listeners.notify();
  };

  _proto.isSubscribed = function isSubscribed() {
    return Boolean(this.unsubscribe);
  };

  _proto.trySubscribe = function trySubscribe() {
    if (!this.unsubscribe) {
      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);
      this.listeners = createListenerCollection();
    }
  };

  _proto.tryUnsubscribe = function tryUnsubscribe() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
      this.listeners.clear();
      this.listeners = nullListeners;
    }
  };

  return Subscription;
}();



/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createConnect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_connectAdvanced__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mapDispatchToProps__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mapStateToProps__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mergeProps__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__selectorFactory__ = __webpack_require__(294);








/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
  };
}

function strictEqual(a, b) {
  return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios


function createConnect(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === void 0 ? __WEBPACK_IMPORTED_MODULE_2__components_connectAdvanced__["a" /* default */] : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? __WEBPACK_IMPORTED_MODULE_5__mapStateToProps__["a" /* default */] : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? __WEBPACK_IMPORTED_MODULE_4__mapDispatchToProps__["a" /* default */] : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === void 0 ? __WEBPACK_IMPORTED_MODULE_6__mergeProps__["a" /* default */] : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === void 0 ? __WEBPACK_IMPORTED_MODULE_7__selectorFactory__["a" /* default */] : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
    if (_ref2 === void 0) {
      _ref2 = {};
    }

    var _ref3 = _ref2,
        _ref3$pure = _ref3.pure,
        pure = _ref3$pure === void 0 ? true : _ref3$pure,
        _ref3$areStatesEqual = _ref3.areStatesEqual,
        areStatesEqual = _ref3$areStatesEqual === void 0 ? strictEqual : _ref3$areStatesEqual,
        _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual,
        areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areOwnPropsEqua,
        _ref3$areStatePropsEq = _ref3.areStatePropsEqual,
        areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areStatePropsEq,
        _ref3$areMergedPropsE = _ref3.areMergedPropsEqual,
        areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areMergedPropsE,
        extraOptions = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref3, ["pure", "areStatesEqual", "areOwnPropsEqual", "areStatePropsEqual", "areMergedPropsEqual"]);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
    return connectHOC(selectorFactory, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      // used in error messages
      methodName: 'connect',
      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return "Connect(" + name + ")";
      },
      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),
      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual
    }, extraOptions));
  };
}
/* harmony default export */ __webpack_exports__["a"] = (createConnect());

/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shallowEqual;
var hasOwn = Object.prototype.hasOwnProperty;

function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);
  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

/***/ }),
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapDispatchToPropsIsFunction */
/* unused harmony export whenMapDispatchToPropsIsMissing */
/* unused harmony export whenMapDispatchToPropsIsObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__ = __webpack_require__(138);


function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}
function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return {
      dispatch: dispatch
    };
  }) : undefined;
}
function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_redux__["bindActionCreators"])(mapDispatchToProps, dispatch);
  }) : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject]);

/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getRawTag_js__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objectToString_js__ = __webpack_require__(282);




/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? Object(__WEBPACK_IMPORTED_MODULE_1__getRawTag_js__["a" /* default */])(value)
    : Object(__WEBPACK_IMPORTED_MODULE_2__objectToString_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (baseGetTag);


/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__(280);


/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */] || freeSelf || Function('return this')();

/* harmony default export */ __webpack_exports__["a"] = (root);


/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/* harmony default export */ __webpack_exports__["a"] = (freeGlobal);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(40)))

/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(134);


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (getRawTag);


/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/* harmony default export */ __webpack_exports__["a"] = (objectToString);


/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overArg_js__ = __webpack_require__(284);


/** Built-in value references. */
var getPrototype = Object(__WEBPACK_IMPORTED_MODULE_0__overArg_js__["a" /* default */])(Object.getPrototypeOf, Object);

/* harmony default export */ __webpack_exports__["a"] = (getPrototype);


/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (overArg);


/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* harmony default export */ __webpack_exports__["a"] = (isObjectLike);


/***/ }),
/* 286 */
/***/ (function(module, exports) {

module.exports = function(originalModule) {
	if(!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true,
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var Symbol = root.Symbol;

	if (typeof Symbol === 'function') {
		if (Symbol.observable) {
			result = Symbol.observable;
		} else {
			result = Symbol('observable');
			Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};


/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = combineReducers;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_warning__ = __webpack_require__(136);




function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';

  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__["a" /* default */])(inputState)) {
    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });

  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });

  if (unexpectedKeys.length > 0) {
    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, { type: __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT });

    if (typeof initialState === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
    }

    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
    if (typeof reducer(undefined, { type: type }) === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
    }
  });
}

/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */
function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};
  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning('No reducer provided for key "' + key + '"');
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }
  var finalReducerKeys = Object.keys(finalReducers);

  var unexpectedKeyCache = void 0;
  if (false) {
    unexpectedKeyCache = {};
  }

  var shapeAssertionError = void 0;
  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};
    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);
      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(_key, action);
        throw new Error(errorMessage);
      }
      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }
    return hasChanged ? nextState : state;
  };
}

/***/ }),
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = bindActionCreators;
function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(undefined, arguments));
  };
}

/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass a single function as the first argument,
 * and get a function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */
function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
  }

  var keys = Object.keys(actionCreators);
  var boundActionCreators = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var actionCreator = actionCreators[key];
    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }
  return boundActionCreators;
}

/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = applyMiddleware;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__compose__ = __webpack_require__(137);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */
function applyMiddleware() {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function (reducer, preloadedState, enhancer) {
      var store = createStore(reducer, preloadedState, enhancer);
      var _dispatch = store.dispatch;
      var chain = [];

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch(action) {
          return _dispatch(action);
        }
      };
      chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = __WEBPACK_IMPORTED_MODULE_0__compose__["a" /* default */].apply(undefined, chain)(store.dispatch);

      return _extends({}, store, {
        dispatch: _dispatch
      });
    };
  };
}

/***/ }),
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isPlainObject;
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = Object.getPrototypeOf(obj);
  if (proto === null) return true;
  var baseProto = proto;

  while (Object.getPrototypeOf(baseProto) !== null) {
    baseProto = Object.getPrototypeOf(baseProto);
  }

  return proto === baseProto;
}

/***/ }),
/* 292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapStateToPropsIsFunction */
/* unused harmony export whenMapStateToPropsIsMissing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__ = __webpack_require__(138);

function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapStateToProps, 'mapStateToProps') : undefined;
}
function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function () {
    return {};
  }) : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing]);

/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultMergeProps */
/* unused harmony export wrapMergePropsFunc */
/* unused harmony export whenMergePropsIsFunction */
/* unused harmony export whenMergePropsIsOmitted */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_verifyPlainObject__ = __webpack_require__(139);


function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, ownProps, stateProps, dispatchProps);
}
function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;
    var hasRunOnce = false;
    var mergedProps;
    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;
        if (false) verifyPlainObject(mergedProps, displayName, 'mergeProps');
      }

      return mergedProps;
    };
  };
}
function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}
function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMergePropsIsFunction, whenMergePropsIsOmitted]);

/***/ }),
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export impureFinalPropsSelectorFactory */
/* unused harmony export pureFinalPropsSelectorFactory */
/* harmony export (immutable) */ __webpack_exports__["a"] = finalPropsSelectorFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__verifySubselectors__ = __webpack_require__(295);


function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}
function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;
  var hasRunAtLeastOnce = false;
  var state;
  var ownProps;
  var stateProps;
  var dispatchProps;
  var mergedProps;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;
    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;
    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
} // TODO: Add more comments
// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref2, ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"]);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (false) {
    verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
  }

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

/***/ }),
/* 295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_warning__ = __webpack_require__(83);


function verify(selector, methodName, displayName) {
  if (!selector) {
    throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
      Object(__WEBPACK_IMPORTED_MODULE_0__utils_warning__["a" /* default */])("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
    }
  }
}

function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
  verify(mapStateToProps, 'mapStateToProps', displayName);
  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
  verify(mergeProps, 'mergeProps', displayName);
}

/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(86);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses HTML5 history.
 */

var BrowserRouter = function (_React$Component) {
  _inherits(BrowserRouter, _React$Component);

  function BrowserRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, BrowserRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["a" /* createBrowserHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  BrowserRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<BrowserRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { BrowserRouter as Router }`.");
  };

  BrowserRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return BrowserRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

BrowserRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  forceRefresh: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (BrowserRouter);

/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
}

// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }

  list.pop();
}

// This implementation is based heavily on node's url.parse
function resolvePathname(to, from) {
  if (from === undefined) from = '';

  var toParts = (to && to.split('/')) || [];
  var fromParts = (from && from.split('/')) || [];

  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';

  var hasTrailingSlash;
  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  var up = 0;
  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) fromParts.unshift('..');

  if (
    mustEndAbs &&
    fromParts[0] !== '' &&
    (!fromParts[0] || !isAbsolute(fromParts[0]))
  )
    fromParts.unshift('');

  var result = fromParts.join('/');

  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';

  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (resolvePathname);


/***/ }),
/* 298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function valueOf(obj) {
  return obj.valueOf ? obj.valueOf() : Object.prototype.valueOf.call(obj);
}

function valueEqual(a, b) {
  // Test for strict equality first.
  if (a === b) return true;

  // Otherwise, if either of them == null they are not equal.
  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return (
      Array.isArray(b) &&
      a.length === b.length &&
      a.every(function(item, index) {
        return valueEqual(item, b[index]);
      })
    );
  }

  if (typeof a === 'object' || typeof b === 'object') {
    var aValue = valueOf(a);
    var bValue = valueOf(b);

    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);

    return Object.keys(Object.assign({}, a, b)).every(function(key) {
      return valueEqual(a[key], b[key]);
    });
  }

  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (valueEqual);


/***/ }),
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isProduction = "production" === 'production';
function warning(condition, message) {
  if (!isProduction) {
    if (condition) {
      return;
    }

    var text = "Warning: " + message;

    if (typeof console !== 'undefined') {
      console.warn(text);
    }

    try {
      throw Error(text);
    } catch (x) {}
  }
}

/* unused harmony default export */ var _unused_webpack_default_export = (warning);


/***/ }),
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isProduction = "production" === 'production';
var prefix = 'Invariant failed';
function invariant(condition, message) {
    if (condition) {
        return;
    }
    if (isProduction) {
        throw new Error(prefix);
    }
    throw new Error(prefix + ": " + (message || ''));
}

/* harmony default export */ __webpack_exports__["a"] = (invariant);


/***/ }),
/* 301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(86);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses window.location.hash.
 */

var HashRouter = function (_React$Component) {
  _inherits(HashRouter, _React$Component);

  function HashRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, HashRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["b" /* createHashHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  HashRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<HashRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { HashRouter as Router }`.");
  };

  HashRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return HashRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

HashRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  hashType: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(["hashbang", "noslash", "slash"]),
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* unused harmony default export */ var _unused_webpack_default_export = (HashRouter);

/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__ = __webpack_require__(141);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__["a" /* default */]);

/***/ }),
/* 303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Route__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Link__ = __webpack_require__(140);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A <Link> wrapper that knows if it's "active" or not.
 */
var NavLink = function NavLink(_ref) {
  var to = _ref.to,
      exact = _ref.exact,
      strict = _ref.strict,
      location = _ref.location,
      activeClassName = _ref.activeClassName,
      className = _ref.className,
      activeStyle = _ref.activeStyle,
      style = _ref.style,
      getIsActive = _ref.isActive,
      ariaCurrent = _ref["aria-current"],
      rest = _objectWithoutProperties(_ref, ["to", "exact", "strict", "location", "activeClassName", "className", "activeStyle", "style", "isActive", "aria-current"]);

  var path = (typeof to === "undefined" ? "undefined" : _typeof(to)) === "object" ? to.pathname : to;

  // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
  var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Route__["a" /* default */], {
    path: escapedPath,
    exact: exact,
    strict: strict,
    location: location,
    children: function children(_ref2) {
      var location = _ref2.location,
          match = _ref2.match;

      var isActive = !!(getIsActive ? getIsActive(match, location) : match);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */], _extends({
        to: to,
        className: isActive ? [className, activeClassName].filter(function (i) {
          return i;
        }).join(" ") : className,
        style: isActive ? _extends({}, style, activeStyle) : style,
        "aria-current": isActive && ariaCurrent || null
      }, rest));
    }
  });
};

NavLink.propTypes = {
  to: __WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */].propTypes.to,
  exact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  activeClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  activeStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  isActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  "aria-current": __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["page", "step", "location", "date", "time", "true"])
};

NavLink.defaultProps = {
  activeClassName: "active",
  "aria-current": "page"
};

/* harmony default export */ __webpack_exports__["a"] = (NavLink);

/***/ }),
/* 304 */
/***/ (function(module, exports) {

module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};


/***/ }),
/* 305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__ = __webpack_require__(144);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__["a" /* default */]);

/***/ }),
/* 306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__ = __webpack_require__(145);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__["a" /* default */]);

/***/ }),
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__ = __webpack_require__(146);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__["a" /* default */]);

/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__ = __webpack_require__(147);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__["a" /* default */]);

/***/ }),
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_generatePath__ = __webpack_require__(88);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_generatePath__["a" /* default */]);

/***/ }),
/* 310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__ = __webpack_require__(58);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__["a" /* default */]);

/***/ }),
/* 311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__ = __webpack_require__(148);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__["a" /* default */]);

/***/ }),
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_ApiController__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_devtools_extension__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_devtools_extension___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_redux_devtools_extension__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_thunk__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers__ = __webpack_require__(338);
// import logger from 'redux-logger'
var composeEnhancers=Object(__WEBPACK_IMPORTED_MODULE_2_redux_devtools_extension__["composeWithDevTools"])({});/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_redux__["createStore"])(Object(__WEBPACK_IMPORTED_MODULE_1_redux__["combineReducers"])(__WEBPACK_IMPORTED_MODULE_4__reducers__),composeEnhancers(Object(__WEBPACK_IMPORTED_MODULE_1_redux__["applyMiddleware"])(__WEBPACK_IMPORTED_MODULE_3_redux_thunk__["a" /* default */].withExtraArgument(__WEBPACK_IMPORTED_MODULE_0__services_ApiController__)))));

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var stringify = __webpack_require__(314);
var parse = __webpack_require__(324);
var formats = __webpack_require__(91);

module.exports = {
    formats: formats,
    parse: parse,
    stringify: stringify
};


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var getSideChannel = __webpack_require__(315);
var utils = __webpack_require__(150);
var formats = __webpack_require__(91);
var has = Object.prototype.hasOwnProperty;

var arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + '[]';
    },
    comma: 'comma',
    indices: function indices(prefix, key) {
        return prefix + '[' + key + ']';
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};

var isArray = Array.isArray;
var push = Array.prototype.push;
var pushToArray = function (arr, valueOrArray) {
    push.apply(arr, isArray(valueOrArray) ? valueOrArray : [valueOrArray]);
};

var toISO = Date.prototype.toISOString;

var defaultFormat = formats['default'];
var defaults = {
    addQueryPrefix: false,
    allowDots: false,
    charset: 'utf-8',
    charsetSentinel: false,
    delimiter: '&',
    encode: true,
    encoder: utils.encode,
    encodeValuesOnly: false,
    format: defaultFormat,
    formatter: formats.formatters[defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};

var isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === 'string'
        || typeof v === 'number'
        || typeof v === 'boolean'
        || typeof v === 'symbol'
        || typeof v === 'bigint';
};

var stringify = function stringify(
    object,
    prefix,
    generateArrayPrefix,
    strictNullHandling,
    skipNulls,
    encoder,
    filter,
    sort,
    allowDots,
    serializeDate,
    format,
    formatter,
    encodeValuesOnly,
    charset,
    sideChannel
) {
    var obj = object;

    if (sideChannel.has(object)) {
        throw new RangeError('Cyclic object value');
    }

    if (typeof filter === 'function') {
        obj = filter(prefix, obj);
    } else if (obj instanceof Date) {
        obj = serializeDate(obj);
    } else if (generateArrayPrefix === 'comma' && isArray(obj)) {
        obj = utils.maybeMap(obj, function (value) {
            if (value instanceof Date) {
                return serializeDate(value);
            }
            return value;
        });
    }

    if (obj === null) {
        if (strictNullHandling) {
            return encoder && !encodeValuesOnly ? encoder(prefix, defaults.encoder, charset, 'key', format) : prefix;
        }

        obj = '';
    }

    if (isNonNullishPrimitive(obj) || utils.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults.encoder, charset, 'key', format);
            return [formatter(keyValue) + '=' + formatter(encoder(obj, defaults.encoder, charset, 'value', format))];
        }
        return [formatter(prefix) + '=' + formatter(String(obj))];
    }

    var values = [];

    if (typeof obj === 'undefined') {
        return values;
    }

    var objKeys;
    if (generateArrayPrefix === 'comma' && isArray(obj)) {
        // we need to join elements in
        objKeys = [{ value: obj.length > 0 ? obj.join(',') || null : undefined }];
    } else if (isArray(filter)) {
        objKeys = filter;
    } else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }

    for (var i = 0; i < objKeys.length; ++i) {
        var key = objKeys[i];
        var value = typeof key === 'object' && key.value !== undefined ? key.value : obj[key];

        if (skipNulls && value === null) {
            continue;
        }

        var keyPrefix = isArray(obj)
            ? typeof generateArrayPrefix === 'function' ? generateArrayPrefix(prefix, key) : prefix
            : prefix + (allowDots ? '.' + key : '[' + key + ']');

        sideChannel.set(object, true);
        var valueSideChannel = getSideChannel();
        pushToArray(values, stringify(
            value,
            keyPrefix,
            generateArrayPrefix,
            strictNullHandling,
            skipNulls,
            encoder,
            filter,
            sort,
            allowDots,
            serializeDate,
            format,
            formatter,
            encodeValuesOnly,
            charset,
            valueSideChannel
        ));
    }

    return values;
};

var normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) {
        return defaults;
    }

    if (opts.encoder !== null && opts.encoder !== undefined && typeof opts.encoder !== 'function') {
        throw new TypeError('Encoder has to be a function.');
    }

    var charset = opts.charset || defaults.charset;
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    }

    var format = formats['default'];
    if (typeof opts.format !== 'undefined') {
        if (!has.call(formats.formatters, opts.format)) {
            throw new TypeError('Unknown format option provided.');
        }
        format = opts.format;
    }
    var formatter = formats.formatters[format];

    var filter = defaults.filter;
    if (typeof opts.filter === 'function' || isArray(opts.filter)) {
        filter = opts.filter;
    }

    return {
        addQueryPrefix: typeof opts.addQueryPrefix === 'boolean' ? opts.addQueryPrefix : defaults.addQueryPrefix,
        allowDots: typeof opts.allowDots === 'undefined' ? defaults.allowDots : !!opts.allowDots,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
        delimiter: typeof opts.delimiter === 'undefined' ? defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === 'boolean' ? opts.encode : defaults.encode,
        encoder: typeof opts.encoder === 'function' ? opts.encoder : defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === 'boolean' ? opts.encodeValuesOnly : defaults.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === 'function' ? opts.serializeDate : defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === 'boolean' ? opts.skipNulls : defaults.skipNulls,
        sort: typeof opts.sort === 'function' ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
    };
};

module.exports = function (object, opts) {
    var obj = object;
    var options = normalizeStringifyOptions(opts);

    var objKeys;
    var filter;

    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    } else if (isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }

    var keys = [];

    if (typeof obj !== 'object' || obj === null) {
        return '';
    }

    var arrayFormat;
    if (opts && opts.arrayFormat in arrayPrefixGenerators) {
        arrayFormat = opts.arrayFormat;
    } else if (opts && 'indices' in opts) {
        arrayFormat = opts.indices ? 'indices' : 'repeat';
    } else {
        arrayFormat = 'indices';
    }

    var generateArrayPrefix = arrayPrefixGenerators[arrayFormat];

    if (!objKeys) {
        objKeys = Object.keys(obj);
    }

    if (options.sort) {
        objKeys.sort(options.sort);
    }

    var sideChannel = getSideChannel();
    for (var i = 0; i < objKeys.length; ++i) {
        var key = objKeys[i];

        if (options.skipNulls && obj[key] === null) {
            continue;
        }
        pushToArray(keys, stringify(
            obj[key],
            key,
            generateArrayPrefix,
            options.strictNullHandling,
            options.skipNulls,
            options.encode ? options.encoder : null,
            options.filter,
            options.sort,
            options.allowDots,
            options.serializeDate,
            options.format,
            options.formatter,
            options.encodeValuesOnly,
            options.charset,
            sideChannel
        ));
    }

    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? '?' : '';

    if (options.charsetSentinel) {
        if (options.charset === 'iso-8859-1') {
            // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
            prefix += 'utf8=%26%2310003%3B&';
        } else {
            // encodeURIComponent('✓')
            prefix += 'utf8=%E2%9C%93&';
        }
    }

    return joined.length > 0 ? prefix + joined : '';
};


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(89);
var callBound = __webpack_require__(320);
var inspect = __webpack_require__(322);

var $TypeError = GetIntrinsic('%TypeError%');
var $WeakMap = GetIntrinsic('%WeakMap%', true);
var $Map = GetIntrinsic('%Map%', true);

var $weakMapGet = callBound('WeakMap.prototype.get', true);
var $weakMapSet = callBound('WeakMap.prototype.set', true);
var $weakMapHas = callBound('WeakMap.prototype.has', true);
var $mapGet = callBound('Map.prototype.get', true);
var $mapSet = callBound('Map.prototype.set', true);
var $mapHas = callBound('Map.prototype.has', true);

/*
 * This function traverses the list returning the node corresponding to the
 * given key.
 *
 * That node is also moved to the head of the list, so that if it's accessed
 * again we don't need to traverse the whole list. By doing so, all the recently
 * used nodes can be accessed relatively quickly.
 */
var listGetNode = function (list, key) { // eslint-disable-line consistent-return
	for (var prev = list, curr; (curr = prev.next) !== null; prev = curr) {
		if (curr.key === key) {
			prev.next = curr.next;
			curr.next = list.next;
			list.next = curr; // eslint-disable-line no-param-reassign
			return curr;
		}
	}
};

var listGet = function (objects, key) {
	var node = listGetNode(objects, key);
	return node && node.value;
};
var listSet = function (objects, key, value) {
	var node = listGetNode(objects, key);
	if (node) {
		node.value = value;
	} else {
		// Prepend the new node to the beginning of the list
		objects.next = { // eslint-disable-line no-param-reassign
			key: key,
			next: objects.next,
			value: value
		};
	}
};
var listHas = function (objects, key) {
	return !!listGetNode(objects, key);
};

module.exports = function getSideChannel() {
	var $wm;
	var $m;
	var $o;
	var channel = {
		assert: function (key) {
			if (!channel.has(key)) {
				throw new $TypeError('Side channel does not contain ' + inspect(key));
			}
		},
		get: function (key) { // eslint-disable-line consistent-return
			if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
				if ($wm) {
					return $weakMapGet($wm, key);
				}
			} else if ($Map) {
				if ($m) {
					return $mapGet($m, key);
				}
			} else {
				if ($o) { // eslint-disable-line no-lonely-if
					return listGet($o, key);
				}
			}
		},
		has: function (key) {
			if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
				if ($wm) {
					return $weakMapHas($wm, key);
				}
			} else if ($Map) {
				if ($m) {
					return $mapHas($m, key);
				}
			} else {
				if ($o) { // eslint-disable-line no-lonely-if
					return listHas($o, key);
				}
			}
			return false;
		},
		set: function (key, value) {
			if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
				if (!$wm) {
					$wm = new $WeakMap();
				}
				$weakMapSet($wm, key, value);
			} else if ($Map) {
				if (!$m) {
					$m = new $Map();
				}
				$mapSet($m, key, value);
			} else {
				if (!$o) {
					/*
					 * Initialize the linked list as an empty node, so that we don't have
					 * to special-case handling of the first node: we can always refer to
					 * it as (previous node).next, instead of something like (list).head
					 */
					$o = { key: {}, next: null };
				}
				listSet($o, key, value);
			}
		}
	};
	return channel;
};


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var origSymbol = typeof Symbol !== 'undefined' && Symbol;
var hasSymbolSham = __webpack_require__(317);

module.exports = function hasNativeSymbols() {
	if (typeof origSymbol !== 'function') { return false; }
	if (typeof Symbol !== 'function') { return false; }
	if (typeof origSymbol('foo') !== 'symbol') { return false; }
	if (typeof Symbol('bar') !== 'symbol') { return false; }

	return hasSymbolSham();
};


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint complexity: [2, 18], max-statements: [2, 33] */
module.exports = function hasSymbols() {
	if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
	if (typeof Symbol.iterator === 'symbol') { return true; }

	var obj = {};
	var sym = Symbol('test');
	var symObj = Object(sym);
	if (typeof sym === 'string') { return false; }

	if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
	if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }

	// temp disabled per https://github.com/ljharb/object.assign/issues/17
	// if (sym instanceof Symbol) { return false; }
	// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
	// if (!(symObj instanceof Symbol)) { return false; }

	// if (typeof Symbol.prototype.toString !== 'function') { return false; }
	// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }

	var symVal = 42;
	obj[sym] = symVal;
	for (sym in obj) { return false; } // eslint-disable-line no-restricted-syntax, no-unreachable-loop
	if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }

	if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }

	var syms = Object.getOwnPropertySymbols(obj);
	if (syms.length !== 1 || syms[0] !== sym) { return false; }

	if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }

	if (typeof Object.getOwnPropertyDescriptor === 'function') {
		var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
		if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
	}

	return true;
};


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint no-invalid-this: 1 */

var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var slice = Array.prototype.slice;
var toStr = Object.prototype.toString;
var funcType = '[object Function]';

module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || toStr.call(target) !== funcType) {
        throw new TypeError(ERROR_MESSAGE + target);
    }
    var args = slice.call(arguments, 1);

    var bound;
    var binder = function () {
        if (this instanceof bound) {
            var result = target.apply(
                this,
                args.concat(slice.call(arguments))
            );
            if (Object(result) === result) {
                return result;
            }
            return this;
        } else {
            return target.apply(
                that,
                args.concat(slice.call(arguments))
            );
        }
    };

    var boundLength = Math.max(0, target.length - args.length);
    var boundArgs = [];
    for (var i = 0; i < boundLength; i++) {
        boundArgs.push('$' + i);
    }

    bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this,arguments); }')(binder);

    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }

    return bound;
};


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(90);

module.exports = bind.call(Function.call, Object.prototype.hasOwnProperty);


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(89);

var callBind = __webpack_require__(321);

var $indexOf = callBind(GetIntrinsic('String.prototype.indexOf'));

module.exports = function callBoundIntrinsic(name, allowMissing) {
	var intrinsic = GetIntrinsic(name, !!allowMissing);
	if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) {
		return callBind(intrinsic);
	}
	return intrinsic;
};


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(90);
var GetIntrinsic = __webpack_require__(89);

var $apply = GetIntrinsic('%Function.prototype.apply%');
var $call = GetIntrinsic('%Function.prototype.call%');
var $reflectApply = GetIntrinsic('%Reflect.apply%', true) || bind.call($call, $apply);

var $gOPD = GetIntrinsic('%Object.getOwnPropertyDescriptor%', true);
var $defineProperty = GetIntrinsic('%Object.defineProperty%', true);
var $max = GetIntrinsic('%Math.max%');

if ($defineProperty) {
	try {
		$defineProperty({}, 'a', { value: 1 });
	} catch (e) {
		// IE 8 has a broken defineProperty
		$defineProperty = null;
	}
}

module.exports = function callBind(originalFunction) {
	var func = $reflectApply(bind, $call, arguments);
	if ($gOPD && $defineProperty) {
		var desc = $gOPD(func, 'length');
		if (desc.configurable) {
			// original length, plus the receiver, minus any additional arguments (after the receiver)
			$defineProperty(
				func,
				'length',
				{ value: 1 + $max(0, originalFunction.length - (arguments.length - 1)) }
			);
		}
	}
	return func;
};

var applyBind = function applyBind() {
	return $reflectApply(bind, $apply, arguments);
};

if ($defineProperty) {
	$defineProperty(module.exports, 'apply', { value: applyBind });
} else {
	module.exports.apply = applyBind;
}


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

var hasMap = typeof Map === 'function' && Map.prototype;
var mapSizeDescriptor = Object.getOwnPropertyDescriptor && hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, 'size') : null;
var mapSize = hasMap && mapSizeDescriptor && typeof mapSizeDescriptor.get === 'function' ? mapSizeDescriptor.get : null;
var mapForEach = hasMap && Map.prototype.forEach;
var hasSet = typeof Set === 'function' && Set.prototype;
var setSizeDescriptor = Object.getOwnPropertyDescriptor && hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, 'size') : null;
var setSize = hasSet && setSizeDescriptor && typeof setSizeDescriptor.get === 'function' ? setSizeDescriptor.get : null;
var setForEach = hasSet && Set.prototype.forEach;
var hasWeakMap = typeof WeakMap === 'function' && WeakMap.prototype;
var weakMapHas = hasWeakMap ? WeakMap.prototype.has : null;
var hasWeakSet = typeof WeakSet === 'function' && WeakSet.prototype;
var weakSetHas = hasWeakSet ? WeakSet.prototype.has : null;
var hasWeakRef = typeof WeakRef === 'function' && WeakRef.prototype;
var weakRefDeref = hasWeakRef ? WeakRef.prototype.deref : null;
var booleanValueOf = Boolean.prototype.valueOf;
var objectToString = Object.prototype.toString;
var functionToString = Function.prototype.toString;
var match = String.prototype.match;
var bigIntValueOf = typeof BigInt === 'function' ? BigInt.prototype.valueOf : null;
var gOPS = Object.getOwnPropertySymbols;
var symToString = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? Symbol.prototype.toString : null;
var hasShammedSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'object';
var isEnumerable = Object.prototype.propertyIsEnumerable;

var gPO = (typeof Reflect === 'function' ? Reflect.getPrototypeOf : Object.getPrototypeOf) || (
    [].__proto__ === Array.prototype // eslint-disable-line no-proto
        ? function (O) {
            return O.__proto__; // eslint-disable-line no-proto
        }
        : null
);

var inspectCustom = __webpack_require__(323).custom;
var inspectSymbol = inspectCustom && isSymbol(inspectCustom) ? inspectCustom : null;
var toStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag !== 'undefined' ? Symbol.toStringTag : null;

module.exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};

    if (has(opts, 'quoteStyle') && (opts.quoteStyle !== 'single' && opts.quoteStyle !== 'double')) {
        throw new TypeError('option "quoteStyle" must be "single" or "double"');
    }
    if (
        has(opts, 'maxStringLength') && (typeof opts.maxStringLength === 'number'
            ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity
            : opts.maxStringLength !== null
        )
    ) {
        throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    }
    var customInspect = has(opts, 'customInspect') ? opts.customInspect : true;
    if (typeof customInspect !== 'boolean' && customInspect !== 'symbol') {
        throw new TypeError('option "customInspect", if provided, must be `true`, `false`, or `\'symbol\'`');
    }

    if (
        has(opts, 'indent')
        && opts.indent !== null
        && opts.indent !== '\t'
        && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)
    ) {
        throw new TypeError('options "indent" must be "\\t", an integer > 0, or `null`');
    }

    if (typeof obj === 'undefined') {
        return 'undefined';
    }
    if (obj === null) {
        return 'null';
    }
    if (typeof obj === 'boolean') {
        return obj ? 'true' : 'false';
    }

    if (typeof obj === 'string') {
        return inspectString(obj, opts);
    }
    if (typeof obj === 'number') {
        if (obj === 0) {
            return Infinity / obj > 0 ? '0' : '-0';
        }
        return String(obj);
    }
    if (typeof obj === 'bigint') {
        return String(obj) + 'n';
    }

    var maxDepth = typeof opts.depth === 'undefined' ? 5 : opts.depth;
    if (typeof depth === 'undefined') { depth = 0; }
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === 'object') {
        return isArray(obj) ? '[Array]' : '[Object]';
    }

    var indent = getIndent(opts, depth);

    if (typeof seen === 'undefined') {
        seen = [];
    } else if (indexOf(seen, obj) >= 0) {
        return '[Circular]';
    }

    function inspect(value, from, noIndent) {
        if (from) {
            seen = seen.slice();
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if (has(opts, 'quoteStyle')) {
                newOpts.quoteStyle = opts.quoteStyle;
            }
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }

    if (typeof obj === 'function') {
        var name = nameOf(obj);
        var keys = arrObjKeys(obj, inspect);
        return '[Function' + (name ? ': ' + name : ' (anonymous)') + ']' + (keys.length > 0 ? ' { ' + keys.join(', ') + ' }' : '');
    }
    if (isSymbol(obj)) {
        var symString = hasShammedSymbols ? String(obj).replace(/^(Symbol\(.*\))_[^)]*$/, '$1') : symToString.call(obj);
        return typeof obj === 'object' && !hasShammedSymbols ? markBoxed(symString) : symString;
    }
    if (isElement(obj)) {
        var s = '<' + String(obj.nodeName).toLowerCase();
        var attrs = obj.attributes || [];
        for (var i = 0; i < attrs.length; i++) {
            s += ' ' + attrs[i].name + '=' + wrapQuotes(quote(attrs[i].value), 'double', opts);
        }
        s += '>';
        if (obj.childNodes && obj.childNodes.length) { s += '...'; }
        s += '</' + String(obj.nodeName).toLowerCase() + '>';
        return s;
    }
    if (isArray(obj)) {
        if (obj.length === 0) { return '[]'; }
        var xs = arrObjKeys(obj, inspect);
        if (indent && !singleLineValues(xs)) {
            return '[' + indentedJoin(xs, indent) + ']';
        }
        return '[ ' + xs.join(', ') + ' ]';
    }
    if (isError(obj)) {
        var parts = arrObjKeys(obj, inspect);
        if (parts.length === 0) { return '[' + String(obj) + ']'; }
        return '{ [' + String(obj) + '] ' + parts.join(', ') + ' }';
    }
    if (typeof obj === 'object' && customInspect) {
        if (inspectSymbol && typeof obj[inspectSymbol] === 'function') {
            return obj[inspectSymbol]();
        } else if (customInspect !== 'symbol' && typeof obj.inspect === 'function') {
            return obj.inspect();
        }
    }
    if (isMap(obj)) {
        var mapParts = [];
        mapForEach.call(obj, function (value, key) {
            mapParts.push(inspect(key, obj, true) + ' => ' + inspect(value, obj));
        });
        return collectionOf('Map', mapSize.call(obj), mapParts, indent);
    }
    if (isSet(obj)) {
        var setParts = [];
        setForEach.call(obj, function (value) {
            setParts.push(inspect(value, obj));
        });
        return collectionOf('Set', setSize.call(obj), setParts, indent);
    }
    if (isWeakMap(obj)) {
        return weakCollectionOf('WeakMap');
    }
    if (isWeakSet(obj)) {
        return weakCollectionOf('WeakSet');
    }
    if (isWeakRef(obj)) {
        return weakCollectionOf('WeakRef');
    }
    if (isNumber(obj)) {
        return markBoxed(inspect(Number(obj)));
    }
    if (isBigInt(obj)) {
        return markBoxed(inspect(bigIntValueOf.call(obj)));
    }
    if (isBoolean(obj)) {
        return markBoxed(booleanValueOf.call(obj));
    }
    if (isString(obj)) {
        return markBoxed(inspect(String(obj)));
    }
    if (!isDate(obj) && !isRegExp(obj)) {
        var ys = arrObjKeys(obj, inspect);
        var isPlainObject = gPO ? gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? '' : 'null prototype';
        var stringTag = !isPlainObject && toStringTag && Object(obj) === obj && toStringTag in obj ? toStr(obj).slice(8, -1) : protoTag ? 'Object' : '';
        var constructorTag = isPlainObject || typeof obj.constructor !== 'function' ? '' : obj.constructor.name ? obj.constructor.name + ' ' : '';
        var tag = constructorTag + (stringTag || protoTag ? '[' + [].concat(stringTag || [], protoTag || []).join(': ') + '] ' : '');
        if (ys.length === 0) { return tag + '{}'; }
        if (indent) {
            return tag + '{' + indentedJoin(ys, indent) + '}';
        }
        return tag + '{ ' + ys.join(', ') + ' }';
    }
    return String(obj);
};

function wrapQuotes(s, defaultStyle, opts) {
    var quoteChar = (opts.quoteStyle || defaultStyle) === 'double' ? '"' : "'";
    return quoteChar + s + quoteChar;
}

function quote(s) {
    return String(s).replace(/"/g, '&quot;');
}

function isArray(obj) { return toStr(obj) === '[object Array]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isDate(obj) { return toStr(obj) === '[object Date]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isRegExp(obj) { return toStr(obj) === '[object RegExp]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isError(obj) { return toStr(obj) === '[object Error]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isString(obj) { return toStr(obj) === '[object String]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isNumber(obj) { return toStr(obj) === '[object Number]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isBoolean(obj) { return toStr(obj) === '[object Boolean]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }

// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function isSymbol(obj) {
    if (hasShammedSymbols) {
        return obj && typeof obj === 'object' && obj instanceof Symbol;
    }
    if (typeof obj === 'symbol') {
        return true;
    }
    if (!obj || typeof obj !== 'object' || !symToString) {
        return false;
    }
    try {
        symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}

function isBigInt(obj) {
    if (!obj || typeof obj !== 'object' || !bigIntValueOf) {
        return false;
    }
    try {
        bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}

var hasOwn = Object.prototype.hasOwnProperty || function (key) { return key in this; };
function has(obj, key) {
    return hasOwn.call(obj, key);
}

function toStr(obj) {
    return objectToString.call(obj);
}

function nameOf(f) {
    if (f.name) { return f.name; }
    var m = match.call(functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) { return m[1]; }
    return null;
}

function indexOf(xs, x) {
    if (xs.indexOf) { return xs.indexOf(x); }
    for (var i = 0, l = xs.length; i < l; i++) {
        if (xs[i] === x) { return i; }
    }
    return -1;
}

function isMap(x) {
    if (!mapSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        mapSize.call(x);
        try {
            setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakMap(x) {
    if (!weakMapHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakMapHas.call(x, weakMapHas);
        try {
            weakSetHas.call(x, weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakRef(x) {
    if (!weakRefDeref || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}

function isSet(x) {
    if (!setSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        setSize.call(x);
        try {
            mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakSet(x) {
    if (!weakSetHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakSetHas.call(x, weakSetHas);
        try {
            weakMapHas.call(x, weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isElement(x) {
    if (!x || typeof x !== 'object') { return false; }
    if (typeof HTMLElement !== 'undefined' && x instanceof HTMLElement) {
        return true;
    }
    return typeof x.nodeName === 'string' && typeof x.getAttribute === 'function';
}

function inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = '... ' + remaining + ' more character' + (remaining > 1 ? 's' : '');
        return inspectString(str.slice(0, opts.maxStringLength), opts) + trailer;
    }
    // eslint-disable-next-line no-control-regex
    var s = str.replace(/(['\\])/g, '\\$1').replace(/[\x00-\x1f]/g, lowbyte);
    return wrapQuotes(s, 'single', opts);
}

function lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: 'b',
        9: 't',
        10: 'n',
        12: 'f',
        13: 'r'
    }[n];
    if (x) { return '\\' + x; }
    return '\\x' + (n < 0x10 ? '0' : '') + n.toString(16).toUpperCase();
}

function markBoxed(str) {
    return 'Object(' + str + ')';
}

function weakCollectionOf(type) {
    return type + ' { ? }';
}

function collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? indentedJoin(entries, indent) : entries.join(', ');
    return type + ' (' + size + ') {' + joinedEntries + '}';
}

function singleLineValues(xs) {
    for (var i = 0; i < xs.length; i++) {
        if (indexOf(xs[i], '\n') >= 0) {
            return false;
        }
    }
    return true;
}

function getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === '\t') {
        baseIndent = '\t';
    } else if (typeof opts.indent === 'number' && opts.indent > 0) {
        baseIndent = Array(opts.indent + 1).join(' ');
    } else {
        return null;
    }
    return {
        base: baseIndent,
        prev: Array(depth + 1).join(baseIndent)
    };
}

function indentedJoin(xs, indent) {
    if (xs.length === 0) { return ''; }
    var lineJoiner = '\n' + indent.prev + indent.base;
    return lineJoiner + xs.join(',' + lineJoiner) + '\n' + indent.prev;
}

function arrObjKeys(obj, inspect) {
    var isArr = isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for (var i = 0; i < obj.length; i++) {
            xs[i] = has(obj, i) ? inspect(obj[i], obj) : '';
        }
    }
    var syms = typeof gOPS === 'function' ? gOPS(obj) : [];
    var symMap;
    if (hasShammedSymbols) {
        symMap = {};
        for (var k = 0; k < syms.length; k++) {
            symMap['$' + syms[k]] = syms[k];
        }
    }

    for (var key in obj) { // eslint-disable-line no-restricted-syntax
        if (!has(obj, key)) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (hasShammedSymbols && symMap['$' + key] instanceof Symbol) {
            // this is to prevent shammed Symbols, which are stored as strings, from being included in the string key section
            continue; // eslint-disable-line no-restricted-syntax, no-continue
        } else if ((/[^\w$]/).test(key)) {
            xs.push(inspect(key, obj) + ': ' + inspect(obj[key], obj));
        } else {
            xs.push(key + ': ' + inspect(obj[key], obj));
        }
    }
    if (typeof gOPS === 'function') {
        for (var j = 0; j < syms.length; j++) {
            if (isEnumerable.call(obj, syms[j])) {
                xs.push('[' + inspect(syms[j]) + ']: ' + inspect(obj[syms[j]], obj));
            }
        }
    }
    return xs;
}


/***/ }),
/* 323 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(150);

var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;

var defaults = {
    allowDots: false,
    allowPrototypes: false,
    allowSparse: false,
    arrayLimit: 20,
    charset: 'utf-8',
    charsetSentinel: false,
    comma: false,
    decoder: utils.decode,
    delimiter: '&',
    depth: 5,
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictNullHandling: false
};

var interpretNumericEntities = function (str) {
    return str.replace(/&#(\d+);/g, function ($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};

var parseArrayValue = function (val, options) {
    if (val && typeof val === 'string' && options.comma && val.indexOf(',') > -1) {
        return val.split(',');
    }

    return val;
};

// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')

// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')

var parseValues = function parseQueryStringValues(str, options) {
    var obj = {};
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, limit);
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;

    var charset = options.charset;
    if (options.charsetSentinel) {
        for (i = 0; i < parts.length; ++i) {
            if (parts[i].indexOf('utf8=') === 0) {
                if (parts[i] === charsetSentinel) {
                    charset = 'utf-8';
                } else if (parts[i] === isoSentinel) {
                    charset = 'iso-8859-1';
                }
                skipIndex = i;
                i = parts.length; // The eslint settings do not allow break;
            }
        }
    }

    for (i = 0; i < parts.length; ++i) {
        if (i === skipIndex) {
            continue;
        }
        var part = parts[i];

        var bracketEqualsPos = part.indexOf(']=');
        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;

        var key, val;
        if (pos === -1) {
            key = options.decoder(part, defaults.decoder, charset, 'key');
            val = options.strictNullHandling ? null : '';
        } else {
            key = options.decoder(part.slice(0, pos), defaults.decoder, charset, 'key');
            val = utils.maybeMap(
                parseArrayValue(part.slice(pos + 1), options),
                function (encodedVal) {
                    return options.decoder(encodedVal, defaults.decoder, charset, 'value');
                }
            );
        }

        if (val && options.interpretNumericEntities && charset === 'iso-8859-1') {
            val = interpretNumericEntities(val);
        }

        if (part.indexOf('[]=') > -1) {
            val = isArray(val) ? [val] : val;
        }

        if (has.call(obj, key)) {
            obj[key] = utils.combine(obj[key], val);
        } else {
            obj[key] = val;
        }
    }

    return obj;
};

var parseObject = function (chain, val, options, valuesParsed) {
    var leaf = valuesParsed ? val : parseArrayValue(val, options);

    for (var i = chain.length - 1; i >= 0; --i) {
        var obj;
        var root = chain[i];

        if (root === '[]' && options.parseArrays) {
            obj = [].concat(leaf);
        } else {
            obj = options.plainObjects ? Object.create(null) : {};
            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
            var index = parseInt(cleanRoot, 10);
            if (!options.parseArrays && cleanRoot === '') {
                obj = { 0: leaf };
            } else if (
                !isNaN(index)
                && root !== cleanRoot
                && String(index) === cleanRoot
                && index >= 0
                && (options.parseArrays && index <= options.arrayLimit)
            ) {
                obj = [];
                obj[index] = leaf;
            } else {
                obj[cleanRoot] = leaf;
            }
        }

        leaf = obj;
    }

    return leaf;
};

var parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) {
        return;
    }

    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;

    // The regex chunks

    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;

    // Get the parent

    var segment = options.depth > 0 && brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;

    // Stash the parent if it exists

    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
        if (!options.plainObjects && has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) {
                return;
            }
        }

        keys.push(parent);
    }

    // Loop through children appending to the array until we hit depth

    var i = 0;
    while (options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth) {
        i += 1;
        if (!options.plainObjects && has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) {
                return;
            }
        }
        keys.push(segment[1]);
    }

    // If there's a remainder, just add whatever is left

    if (segment) {
        keys.push('[' + key.slice(segment.index) + ']');
    }

    return parseObject(keys, val, options, valuesParsed);
};

var normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) {
        return defaults;
    }

    if (opts.decoder !== null && opts.decoder !== undefined && typeof opts.decoder !== 'function') {
        throw new TypeError('Decoder has to be a function.');
    }

    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    }
    var charset = typeof opts.charset === 'undefined' ? defaults.charset : opts.charset;

    return {
        allowDots: typeof opts.allowDots === 'undefined' ? defaults.allowDots : !!opts.allowDots,
        allowPrototypes: typeof opts.allowPrototypes === 'boolean' ? opts.allowPrototypes : defaults.allowPrototypes,
        allowSparse: typeof opts.allowSparse === 'boolean' ? opts.allowSparse : defaults.allowSparse,
        arrayLimit: typeof opts.arrayLimit === 'number' ? opts.arrayLimit : defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
        comma: typeof opts.comma === 'boolean' ? opts.comma : defaults.comma,
        decoder: typeof opts.decoder === 'function' ? opts.decoder : defaults.decoder,
        delimiter: typeof opts.delimiter === 'string' || utils.isRegExp(opts.delimiter) ? opts.delimiter : defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: (typeof opts.depth === 'number' || opts.depth === false) ? +opts.depth : defaults.depth,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === 'boolean' ? opts.interpretNumericEntities : defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === 'number' ? opts.parameterLimit : defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === 'boolean' ? opts.plainObjects : defaults.plainObjects,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
    };
};

module.exports = function (str, opts) {
    var options = normalizeParseOptions(opts);

    if (str === '' || str === null || typeof str === 'undefined') {
        return options.plainObjects ? Object.create(null) : {};
    }

    var tempObj = typeof str === 'string' ? parseValues(str, options) : str;
    var obj = options.plainObjects ? Object.create(null) : {};

    // Iterate over the keys and setup the new object

    var keys = Object.keys(tempObj);
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        var newObj = parseKeys(key, tempObj[key], options, typeof str === 'string');
        obj = utils.merge(obj, newObj, options);
    }

    if (options.allowSparse === true) {
        return obj;
    }

    return utils.compact(obj);
};


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var createChangeEmitter = exports.createChangeEmitter = function createChangeEmitter() {
  var currentListeners = [];
  var nextListeners = currentListeners;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  function listen(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected listener to be a function.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function () {
      if (!isSubscribed) {
        return;
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  function emit() {
    currentListeners = nextListeners;
    var listeners = currentListeners;
    for (var i = 0; i < listeners.length; i++) {
      listeners[i].apply(listeners, arguments);
    }
  }

  return {
    listen: listen,
    emit: emit
  };
};

/***/ }),
/* 326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OutboundLink; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_console_warn__ = __webpack_require__(92);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




var NEWTAB = '_blank';
var MIDDLECLICK = 1;

var OutboundLink = /*#__PURE__*/function (_Component) {
  _inherits(OutboundLink, _Component);

  var _super = _createSuper(OutboundLink);

  function OutboundLink() {
    var _this;

    _classCallCheck(this, OutboundLink);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "handleClick", function (event) {
      var _this$props = _this.props,
          target = _this$props.target,
          eventLabel = _this$props.eventLabel,
          to = _this$props.to,
          onClick = _this$props.onClick,
          trackerNames = _this$props.trackerNames;
      var eventMeta = {
        label: eventLabel
      };
      var sameTarget = target !== NEWTAB;
      var normalClick = !(event.ctrlKey || event.shiftKey || event.metaKey || event.button === MIDDLECLICK);

      if (sameTarget && normalClick) {
        event.preventDefault();
        OutboundLink.trackLink(eventMeta, function () {
          window.location.href = to;
        }, trackerNames);
      } else {
        OutboundLink.trackLink(eventMeta, function () {}, trackerNames);
      }

      if (onClick) {
        onClick(event);
      }
    });

    return _this;
  }

  _createClass(OutboundLink, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          href = _this$props2.to,
          target = _this$props2.target,
          oldProps = _objectWithoutProperties(_this$props2, ["to", "target"]);

      var props = _objectSpread(_objectSpread({}, oldProps), {}, {
        target: target,
        href: href,
        onClick: this.handleClick
      });

      if (target === NEWTAB) {
        props.rel = "".concat(props.rel ? props.rel : '', " noopener noreferrer").trim();
      }

      delete props.eventLabel;
      delete props.trackerNames;
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', props);
    }
  }]);

  return OutboundLink;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

_defineProperty(OutboundLink, "trackLink", function () {
  Object(__WEBPACK_IMPORTED_MODULE_2__utils_console_warn__["a" /* default */])('ga tracking not enabled');
});


OutboundLink.propTypes = {
  eventLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  trackerNames: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string)
};
OutboundLink.defaultProps = {
  target: null,
  to: null,
  onClick: null,
  trackerNames: null
};

/***/ }),
/* 327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["addTrackers"] = addTrackers;
/* harmony export (immutable) */ __webpack_exports__["initialize"] = initialize;
/* harmony export (immutable) */ __webpack_exports__["ga"] = ga;
/* harmony export (immutable) */ __webpack_exports__["set"] = set;
/* harmony export (immutable) */ __webpack_exports__["send"] = send;
/* harmony export (immutable) */ __webpack_exports__["pageview"] = pageview;
/* harmony export (immutable) */ __webpack_exports__["modalview"] = modalview;
/* harmony export (immutable) */ __webpack_exports__["timing"] = timing;
/* harmony export (immutable) */ __webpack_exports__["event"] = event;
/* harmony export (immutable) */ __webpack_exports__["exception"] = exception;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "plugin", function() { return plugin; });
/* harmony export (immutable) */ __webpack_exports__["outboundLink"] = outboundLink;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "testModeAPI", function() { return testModeAPI; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_format__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_removeLeadingSlash__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_trim__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_loadGA__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_console_warn__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_console_log__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_testModeAPI__ = __webpack_require__(335);
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/**
 * React Google Analytics Module
 *
 * @package react-ga
 * @author  Adam Lofting <adam@mozillafoundation.org>
 *          Atul Varma <atul@mozillafoundation.org>
 */

/**
 * Utilities
 */








var _isNotBrowser = typeof window === 'undefined' || typeof document === 'undefined';

var _debug = false;
var _titleCase = true;
var _testMode = false;
var _alwaysSendToDefaultTracker = true;
var _redactEmail = true;

var internalGa = function internalGa() {
  var _window;

  if (_testMode) return __WEBPACK_IMPORTED_MODULE_6__utils_testModeAPI__["a" /* default */].ga.apply(__WEBPACK_IMPORTED_MODULE_6__utils_testModeAPI__["a" /* default */], arguments);
  if (_isNotBrowser) return false;
  if (!window.ga) return Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('ReactGA.initialize must be called first or GoogleAnalytics should be loaded manually');
  return (_window = window).ga.apply(_window, arguments);
};

function _format(s) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_format__["a" /* default */])(s, _titleCase, _redactEmail);
}

function _gaCommand(trackerNames) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  var command = args[0];

  if (typeof internalGa === 'function') {
    if (typeof command !== 'string') {
      Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('ga command must be a string');
      return;
    }

    if (_alwaysSendToDefaultTracker || !Array.isArray(trackerNames)) internalGa.apply(void 0, args);

    if (Array.isArray(trackerNames)) {
      trackerNames.forEach(function (name) {
        internalGa.apply(void 0, _toConsumableArray(["".concat(name, ".").concat(command)].concat(args.slice(1))));
      });
    }
  }
}

function _initialize(gaTrackingID, options) {
  if (!gaTrackingID) {
    Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('gaTrackingID is required in initialize()');
    return;
  }

  if (options) {
    if (options.debug && options.debug === true) {
      _debug = true;
    }

    if (options.titleCase === false) {
      _titleCase = false;
    }

    if (options.redactEmail === false) {
      _redactEmail = false;
    }

    if (options.useExistingGa) {
      return;
    }
  }

  if (options && options.gaOptions) {
    internalGa('create', gaTrackingID, options.gaOptions);
  } else {
    internalGa('create', gaTrackingID, 'auto');
  }
}

function addTrackers(configsOrTrackingId, options) {
  if (Array.isArray(configsOrTrackingId)) {
    configsOrTrackingId.forEach(function (config) {
      if (_typeof(config) !== 'object') {
        Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('All configs must be an object');
        return;
      }

      _initialize(config.trackingId, config);
    });
  } else {
    _initialize(configsOrTrackingId, options);
  }

  return true;
}
function initialize(configsOrTrackingId, options) {
  if (options && options.testMode === true) {
    _testMode = true;
  } else {
    if (_isNotBrowser) {
      return;
    }

    if (!options || options.standardImplementation !== true) Object(__WEBPACK_IMPORTED_MODULE_3__utils_loadGA__["a" /* default */])(options);
  }

  _alwaysSendToDefaultTracker = options && typeof options.alwaysSendToDefaultTracker === 'boolean' ? options.alwaysSendToDefaultTracker : true;
  addTrackers(configsOrTrackingId, options);
}
/**
 * ga:
 * Returns the original GA object.
 */

function ga() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  if (args.length > 0) {
    internalGa.apply(void 0, args);

    if (_debug) {
      Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("called ga('arguments');");
      Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("with arguments: ".concat(JSON.stringify(args)));
    }
  }

  return window.ga;
}
/**
 * set:
 * GA tracker set method
 * @param {Object} fieldsObject - a field/value pair or a group of field/value pairs on the tracker
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */

function set(fieldsObject, trackerNames) {
  if (!fieldsObject) {
    Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('`fieldsObject` is required in .set()');
    return;
  }

  if (_typeof(fieldsObject) !== 'object') {
    Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('Expected `fieldsObject` arg to be an Object');
    return;
  }

  if (Object.keys(fieldsObject).length === 0) {
    Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('empty `fieldsObject` given to .set()');
  }

  _gaCommand(trackerNames, 'set', fieldsObject);

  if (_debug) {
    Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("called ga('set', fieldsObject);");
    Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("with fieldsObject: ".concat(JSON.stringify(fieldsObject)));
  }
}
/**
 * send:
 * Clone of the low level `ga.send` method
 * WARNING: No validations will be applied to this
 * @param  {Object} fieldObject - field object for tracking different analytics
 * @param  {Array} trackerNames - trackers to send the command to
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */

function send(fieldObject, trackerNames) {
  _gaCommand(trackerNames, 'send', fieldObject);

  if (_debug) {
    Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("called ga('send', fieldObject);");
    Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("with fieldObject: ".concat(JSON.stringify(fieldObject)));
    Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("with trackers: ".concat(JSON.stringify(trackerNames)));
  }
}
/**
 * pageview:
 * Basic GA pageview tracking
 * @param  {String} path - the current page page e.g. '/about'
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 * @param {String} title - (optional) the page title e. g. 'My Website'
 */

function pageview(rawPath, trackerNames, title) {
  if (!rawPath) {
    Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('path is required in .pageview()');
    return;
  }

  var path = Object(__WEBPACK_IMPORTED_MODULE_2__utils_trim__["a" /* default */])(rawPath);

  if (path === '') {
    Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('path cannot be an empty string in .pageview()');
    return;
  }

  var extraFields = {};

  if (title) {
    extraFields.title = title;
  }

  if (typeof ga === 'function') {
    _gaCommand(trackerNames, 'send', _objectSpread({
      hitType: 'pageview',
      page: path
    }, extraFields));

    if (_debug) {
      Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("called ga('send', 'pageview', path);");
      var extraLog = '';

      if (title) {
        extraLog = " and title: ".concat(title);
      }

      Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("with path: ".concat(path).concat(extraLog));
    }
  }
}
/**
 * modalview:
 * a proxy to basic GA pageview tracking to consistently track
 * modal views that are an equivalent UX to a traditional pageview
 * @param  {String} modalName e.g. 'add-or-edit-club'
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */

function modalview(rawModalName, trackerNames) {
  if (!rawModalName) {
    Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('modalName is required in .modalview(modalName)');
    return;
  }

  var modalName = Object(__WEBPACK_IMPORTED_MODULE_1__utils_removeLeadingSlash__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__utils_trim__["a" /* default */])(rawModalName));

  if (modalName === '') {
    Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('modalName cannot be an empty string or a single / in .modalview()');
    return;
  }

  if (typeof ga === 'function') {
    var path = "/modal/".concat(modalName);

    _gaCommand(trackerNames, 'send', 'pageview', path);

    if (_debug) {
      Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("called ga('send', 'pageview', path);");
      Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("with path: ".concat(path));
    }
  }
}
/**
 * timing:
 * GA timing
 * @param args.category {String} required
 * @param args.variable {String} required
 * @param args.value  {Int}  required
 * @param args.label  {String} required
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */

function timing() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      category = _ref.category,
      variable = _ref.variable,
      value = _ref.value,
      label = _ref.label;

  var trackerNames = arguments.length > 1 ? arguments[1] : undefined;

  if (typeof ga === 'function') {
    if (!category || !variable || typeof value !== 'number') {
      Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('args.category, args.variable ' + 'AND args.value are required in timing() ' + 'AND args.value has to be a number');
      return;
    } // Required Fields


    var fieldObject = {
      hitType: 'timing',
      timingCategory: _format(category),
      timingVar: _format(variable),
      timingValue: value
    };

    if (label) {
      fieldObject.timingLabel = _format(label);
    }

    send(fieldObject, trackerNames);
  }
}
/**
 * event:
 * GA event tracking
 * @param args.category {String} required
 * @param args.action {String} required
 * @param args.label {String} optional
 * @param args.value {Int} optional
 * @param args.nonInteraction {boolean} optional
 * @param args.transport {string} optional
 * @param {{action: string, category: string}} trackerNames - (optional) a list of extra trackers to run the command on
 */

function event() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      category = _ref2.category,
      action = _ref2.action,
      label = _ref2.label,
      value = _ref2.value,
      nonInteraction = _ref2.nonInteraction,
      transport = _ref2.transport,
      args = _objectWithoutProperties(_ref2, ["category", "action", "label", "value", "nonInteraction", "transport"]);

  var trackerNames = arguments.length > 1 ? arguments[1] : undefined;

  if (typeof ga === 'function') {
    // Simple Validation
    if (!category || !action) {
      Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('args.category AND args.action are required in event()');
      return;
    } // Required Fields


    var fieldObject = {
      hitType: 'event',
      eventCategory: _format(category),
      eventAction: _format(action)
    }; // Optional Fields

    if (label) {
      fieldObject.eventLabel = _format(label);
    }

    if (typeof value !== 'undefined') {
      if (typeof value !== 'number') {
        Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('Expected `args.value` arg to be a Number.');
      } else {
        fieldObject.eventValue = value;
      }
    }

    if (typeof nonInteraction !== 'undefined') {
      if (typeof nonInteraction !== 'boolean') {
        Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('`args.nonInteraction` must be a boolean.');
      } else {
        fieldObject.nonInteraction = nonInteraction;
      }
    }

    if (typeof transport !== 'undefined') {
      if (typeof transport !== 'string') {
        Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('`args.transport` must be a string.');
      } else {
        if (['beacon', 'xhr', 'image'].indexOf(transport) === -1) {
          Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('`args.transport` must be either one of these values: `beacon`, `xhr` or `image`');
        }

        fieldObject.transport = transport;
      }
    }

    Object.keys(args).filter(function (key) {
      return key.substr(0, 'dimension'.length) === 'dimension';
    }).forEach(function (key) {
      fieldObject[key] = args[key];
    });
    Object.keys(args).filter(function (key) {
      return key.substr(0, 'metric'.length) === 'metric';
    }).forEach(function (key) {
      fieldObject[key] = args[key];
    }); // Send to GA

    send(fieldObject, trackerNames);
  }
}
/**
 * exception:
 * GA exception tracking
 * @param args.description {String} optional
 * @param args.fatal {boolean} optional
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */

function exception(_ref3, trackerNames) {
  var description = _ref3.description,
      fatal = _ref3.fatal;

  if (typeof ga === 'function') {
    // Required Fields
    var fieldObject = {
      hitType: 'exception'
    }; // Optional Fields

    if (description) {
      fieldObject.exDescription = _format(description);
    }

    if (typeof fatal !== 'undefined') {
      if (typeof fatal !== 'boolean') {
        Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('`args.fatal` must be a boolean.');
      } else {
        fieldObject.exFatal = fatal;
      }
    } // Send to GA


    send(fieldObject, trackerNames);
  }
}
var plugin = {
  /**
   * require:
   * GA requires a plugin
   * @param name {String} e.g. 'ecommerce' or 'myplugin'
   * @param options {Object} optional e.g {path: '/log', debug: true}
   * @param trackerName {String} optional e.g 'trackerName'
   */
  require: function require(rawName, options, trackerName) {
    if (typeof ga === 'function') {
      // Required Fields
      if (!rawName) {
        Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('`name` is required in .require()');
        return;
      }

      var name = Object(__WEBPACK_IMPORTED_MODULE_2__utils_trim__["a" /* default */])(rawName);

      if (name === '') {
        Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('`name` cannot be an empty string in .require()');
        return;
      }

      var requireString = trackerName ? "".concat(trackerName, ".require") : 'require'; // Optional Fields

      if (options) {
        if (_typeof(options) !== 'object') {
          Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('Expected `options` arg to be an Object');
          return;
        }

        if (Object.keys(options).length === 0) {
          Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('Empty `options` given to .require()');
        }

        ga(requireString, name, options);

        if (_debug) {
          Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("called ga('require', '".concat(name, "', ").concat(JSON.stringify(options)));
        }
      } else {
        ga(requireString, name);

        if (_debug) {
          Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("called ga('require', '".concat(name, "');"));
        }
      }
    }
  },

  /**
   * execute:
   * GA execute action for plugin
   * Takes variable number of arguments
   * @param pluginName {String} e.g. 'ecommerce' or 'myplugin'
   * @param action {String} e.g. 'addItem' or 'myCustomAction'
   * @param actionType {String} optional e.g. 'detail'
   * @param payload {Object} optional e.g { id: '1x5e', name : 'My product to track' }
   */
  execute: function execute(pluginName, action) {
    var payload;
    var actionType;

    for (var _len3 = arguments.length, args = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
      args[_key3 - 2] = arguments[_key3];
    }

    if (args.length === 1) {
      payload = args[0];
    } else {
      actionType = args[0];
      payload = args[1];
    }

    if (typeof ga === 'function') {
      if (typeof pluginName !== 'string') {
        Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('Expected `pluginName` arg to be a String.');
      } else if (typeof action !== 'string') {
        Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('Expected `action` arg to be a String.');
      } else {
        var command = "".concat(pluginName, ":").concat(action);
        payload = payload || null;

        if (actionType && payload) {
          ga(command, actionType, payload);

          if (_debug) {
            Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("called ga('".concat(command, "');"));
            Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("actionType: \"".concat(actionType, "\" with payload: ").concat(JSON.stringify(payload)));
          }
        } else if (payload) {
          ga(command, payload);

          if (_debug) {
            Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("called ga('".concat(command, "');"));
            Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("with payload: ".concat(JSON.stringify(payload)));
          }
        } else {
          ga(command);

          if (_debug) {
            Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("called ga('".concat(command, "');"));
          }
        }
      }
    }
  }
};
/**
 * outboundLink:
 * GA outboundLink tracking
 * @param args.label {String} e.g. url, or 'Create an Account'
 * @param {function} hitCallback - Called after processing a hit.
 */

function outboundLink(args, hitCallback, trackerNames) {
  if (typeof hitCallback !== 'function') {
    Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('hitCallback function is required');
    return;
  }

  if (typeof ga === 'function') {
    // Simple Validation
    if (!args || !args.label) {
      Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('args.label is required in outboundLink()');
      return;
    } // Required Fields


    var fieldObject = {
      hitType: 'event',
      eventCategory: 'Outbound',
      eventAction: 'Click',
      eventLabel: _format(args.label)
    };
    var safetyCallbackCalled = false;

    var safetyCallback = function safetyCallback() {
      // This prevents a delayed response from GA
      // causing hitCallback from being fired twice
      safetyCallbackCalled = true;
      hitCallback();
    }; // Using a timeout to ensure the execution of critical application code
    // in the case when the GA server might be down
    // or an ad blocker prevents sending the data
    // register safety net timeout:


    var t = setTimeout(safetyCallback, 250);

    var clearableCallbackForGA = function clearableCallbackForGA() {
      clearTimeout(t);

      if (!safetyCallbackCalled) {
        hitCallback();
      }
    };

    fieldObject.hitCallback = clearableCallbackForGA; // Send to GA

    send(fieldObject, trackerNames);
  } else {
    // if ga is not defined, return the callback so the application
    // continues to work as expected
    setTimeout(hitCallback, 0);
  }
}
var testModeAPI = __WEBPACK_IMPORTED_MODULE_6__utils_testModeAPI__["a" /* default */];
/* harmony default export */ __webpack_exports__["default"] = ({
  initialize: initialize,
  ga: ga,
  set: set,
  send: send,
  pageview: pageview,
  modalview: modalview,
  timing: timing,
  event: event,
  exception: exception,
  plugin: plugin,
  outboundLink: outboundLink,
  testModeAPI: __WEBPACK_IMPORTED_MODULE_6__utils_testModeAPI__["a" /* default */]
});

/***/ }),
/* 328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = format;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__redactEmail__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toTitleCase__ = __webpack_require__(331);


function format() {
  var s = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var titleCase = arguments.length > 1 ? arguments[1] : undefined;
  var redactingEmail = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  var _str = s || '';

  if (titleCase) {
    _str = Object(__WEBPACK_IMPORTED_MODULE_1__toTitleCase__["a" /* default */])(s);
  }

  if (redactingEmail) {
    _str = Object(__WEBPACK_IMPORTED_MODULE_0__redactEmail__["a" /* default */])(_str);
  }

  return _str;
}

/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = redactEmail;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__console_warn__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mightBeEmail__ = __webpack_require__(330);


var redacted = 'REDACTED (Potential Email Address)';
function redactEmail(string) {
  if (Object(__WEBPACK_IMPORTED_MODULE_1__mightBeEmail__["a" /* default */])(string)) {
    Object(__WEBPACK_IMPORTED_MODULE_0__console_warn__["a" /* default */])('This arg looks like an email address, redacting.');
    return redacted;
  }

  return string;
}

/***/ }),
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = mightBeEmail;
// See if s could be an email address. We don't want to send personal data like email.
// https://support.google.com/analytics/answer/2795983?hl=en
function mightBeEmail(s) {
  // There's no point trying to validate rfc822 fully, just look for ...@...
  return typeof s === 'string' && s.indexOf('@') !== -1;
}

/***/ }),
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = toTitleCase;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__trim__ = __webpack_require__(151);
/**
 * To Title Case 2.1 - http://individed.com/code/to-title-case/
 * Copyright 2008-2013 David Gouch. Licensed under the MIT License.
 * https://github.com/gouch/to-title-case
 */

var smallWords = /^(a|an|and|as|at|but|by|en|for|if|in|nor|of|on|or|per|the|to|vs?\.?|via)$/i; // test

function toTitleCase(string) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__trim__["a" /* default */])(string).replace(/[A-Za-z0-9\u00C0-\u00FF]+[^\s-]*/g, function (match, index, title) {
    if (index > 0 && index + match.length !== title.length && match.search(smallWords) > -1 && title.charAt(index - 2) !== ':' && (title.charAt(index + match.length) !== '-' || title.charAt(index - 1) === '-') && title.charAt(index - 1).search(/[^\s-]/) < 0) {
      return match.toLowerCase();
    }

    if (match.substr(1).search(/[A-Z]|\../) > -1) {
      return match;
    }

    return match.charAt(0).toUpperCase() + match.substr(1);
  });
}

/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = removeLeadingSlash;
function removeLeadingSlash(string) {
  if (string.substring(0, 1) === '/') {
    return string.substring(1);
  }

  return string;
}

/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isLoaded = false;
/* harmony default export */ __webpack_exports__["a"] = (function (options) {
  if (isLoaded) return;
  isLoaded = true;
  var gaAddress = 'https://www.google-analytics.com/analytics.js';

  if (options && options.gaAddress) {
    gaAddress = options.gaAddress;
  } else if (options && options.debug) {
    gaAddress = 'https://www.google-analytics.com/analytics_debug.js';
  }

  var onerror = options && options.onerror; // https://developers.google.com/analytics/devguides/collection/analyticsjs/

  /* eslint-disable */

  (function (i, s, o, g, r, a, m) {
    i['GoogleAnalyticsObject'] = r;
    i[r] = i[r] || function () {
      (i[r].q = i[r].q || []).push(arguments);
    }, i[r].l = 1 * new Date();
    a = s.createElement(o), m = s.getElementsByTagName(o)[0];
    a.async = 1;
    a.src = g;
    a.onerror = onerror;
    m.parentNode.insertBefore(a, m);
  })(window, document, 'script', gaAddress, 'ga');
  /* eslint-enable */

});

/***/ }),
/* 334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = log;
function log(s) {
  console.info('[react-ga]', s);
}

/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export gaCalls */
var gaCalls = [];
/* harmony default export */ __webpack_exports__["a"] = ({
  calls: gaCalls,
  ga: function ga() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    gaCalls.push([].concat(args));
  },
  resetCalls: function resetCalls() {
    gaCalls.length = 0;
  }
});

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var compose = __webpack_require__(85).compose;

exports.__esModule = true;
exports.composeWithDevTools =
  typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    : function () {
        if (arguments.length === 0) return undefined;
        if (typeof arguments[0] === 'object') return compose;
        return compose.apply(null, arguments);
      };

exports.devToolsEnhancer =
  typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION__
    ? window.__REDUX_DEVTOOLS_EXTENSION__
    : function () {
        return function (noop) {
          return noop;
        };
      };


/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function createThunkMiddleware(extraArgument) {
  return function (_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;
    return function (next) {
      return function (action) {
        if (typeof action === 'function') {
          return action(dispatch, getState, extraArgument);
        }

        return next(action);
      };
    };
  };
}

var thunk = createThunkMiddleware();
thunk.withExtraArgument = createThunkMiddleware;

/* harmony default export */ __webpack_exports__["a"] = (thunk);

/***/ }),
/* 338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Content__ = __webpack_require__(152);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Content", function() { return __WEBPACK_IMPORTED_MODULE_0__Content__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Session__ = __webpack_require__(154);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Session", function() { return __WEBPACK_IMPORTED_MODULE_1__Session__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Global__ = __webpack_require__(340);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Global", function() { return __WEBPACK_IMPORTED_MODULE_2__Global__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FaqModal__ = __webpack_require__(155);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "FaqModal", function() { return __WEBPACK_IMPORTED_MODULE_3__FaqModal__["b"]; });
// export { default as Menu } from './Menu'


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;(function(root, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
            return factory(root);
        }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof module === "object" && module.exports) {
        module.exports = factory(root);
    } else {
        root.bodymovin = factory(root);
    }
}((window || {}), function(window) {
    var svgNS = "http://www.w3.org/2000/svg";

var locationHref = '';

var subframeEnabled = true;
var expressionsPlugin;
var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
var cachedColors = {};
var bm_rounder = Math.round;
var bm_rnd;
var bm_pow = Math.pow;
var bm_sqrt = Math.sqrt;
var bm_abs = Math.abs;
var bm_floor = Math.floor;
var bm_max = Math.max;
var bm_min = Math.min;
var blitter = 10;

var BMMath = {};
(function(){
    var propertyNames = Object.getOwnPropertyNames(Math);
    var i, len = propertyNames.length;
    for(i=0;i<len;i+=1){
        BMMath[propertyNames[i]] = Math[propertyNames[i]];
    }
}());

function ProjectInterface(){return {}};

BMMath.random = Math.random;
BMMath.abs = function(val){
    var tOfVal = typeof val;
    if(tOfVal === 'object' && val.length){
        var absArr = Array.apply(null,{length:val.length});
        var i, len = val.length;
        for(i=0;i<len;i+=1){
            absArr[i] = Math.abs(val[i]);
        }
        return absArr;
    }
    return Math.abs(val);

}
var defaultCurveSegments = 150;
var degToRads = Math.PI/180;
var roundCorner = 0.5519;

function roundValues(flag){
    if(flag){
        bm_rnd = Math.round;
    }else{
        bm_rnd = function(val){
            return val;
        };
    }
}
roundValues(false);

function roundTo2Decimals(val){
    return Math.round(val*10000)/10000;
}

function roundTo3Decimals(val){
    return Math.round(val*100)/100;
}

function styleDiv(element){
    element.style.position = 'absolute';
    element.style.top = 0;
    element.style.left = 0;
    element.style.display = 'block';
    element.style.transformOrigin = element.style.webkitTransformOrigin = '0 0';
    element.style.backfaceVisibility  = element.style.webkitBackfaceVisibility = 'visible';
    element.style.transformStyle = element.style.webkitTransformStyle = element.style.mozTransformStyle = "preserve-3d";
}

function styleUnselectableDiv(element){
    element.style.userSelect = 'none';
    element.style.MozUserSelect = 'none';
    element.style.webkitUserSelect = 'none';
    element.style.oUserSelect = 'none';

}

function BMEnterFrameEvent(n,c,t,d){
    this.type = n;
    this.currentTime = c;
    this.totalTime = t;
    this.direction = d < 0 ? -1:1;
}

function BMCompleteEvent(n,d){
    this.type = n;
    this.direction = d < 0 ? -1:1;
}

function BMCompleteLoopEvent(n,c,t,d){
    this.type = n;
    this.currentLoop = c;
    this.totalLoops = t;
    this.direction = d < 0 ? -1:1;
}

function BMSegmentStartEvent(n,f,t){
    this.type = n;
    this.firstFrame = f;
    this.totalFrames = t;
}

function BMDestroyEvent(n,t){
    this.type = n;
    this.target = t;
}

function _addEventListener(eventName, callback){

    if (!this._cbs[eventName]){
        this._cbs[eventName] = [];
    }
    this._cbs[eventName].push(callback);

	return function() {
		this.removeEventListener(eventName, callback);
	}.bind(this);
}

function _removeEventListener(eventName,callback){

    if (!callback){
        this._cbs[eventName] = null;
    }else if(this._cbs[eventName]){
        var i = 0, len = this._cbs[eventName].length;
        while(i<len){
            if(this._cbs[eventName][i] === callback){
                this._cbs[eventName].splice(i,1);
                i -=1;
                len -= 1;
            }
            i += 1;
        }
        if(!this._cbs[eventName].length){
            this._cbs[eventName] = null;
        }
    }

}

function _triggerEvent(eventName, args){
    if (this._cbs[eventName]) {
        var len = this._cbs[eventName].length;
        for (var i = 0; i < len; i++){
            this._cbs[eventName][i](args);
        }
    }
}

function randomString(length, chars){
    if(chars === undefined){
        chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890';
    }
    var i;
    var result = '';
    for (i = length; i > 0; --i) result += chars[Math.round(Math.random() * (chars.length - 1))];
    return result;
}

function HSVtoRGB(h, s, v) {
    var r, g, b, i, f, p, q, t;
    if (arguments.length === 1) {
        s = h.s, v = h.v, h = h.h;
    }
    i = Math.floor(h * 6);
    f = h * 6 - i;
    p = v * (1 - s);
    q = v * (1 - f * s);
    t = v * (1 - (1 - f) * s);
    switch (i % 6) {
        case 0: r = v, g = t, b = p; break;
        case 1: r = q, g = v, b = p; break;
        case 2: r = p, g = v, b = t; break;
        case 3: r = p, g = q, b = v; break;
        case 4: r = t, g = p, b = v; break;
        case 5: r = v, g = p, b = q; break;
    }
    return [ r,
        g,
         b ];
}

function RGBtoHSV(r, g, b) {
    if (arguments.length === 1) {
        g = r.g, b = r.b, r = r.r;
    }
    var max = Math.max(r, g, b), min = Math.min(r, g, b),
        d = max - min,
        h,
        s = (max === 0 ? 0 : d / max),
        v = max / 255;

    switch (max) {
        case min: h = 0; break;
        case r: h = (g - b) + d * (g < b ? 6: 0); h /= 6 * d; break;
        case g: h = (b - r) + d * 2; h /= 6 * d; break;
        case b: h = (r - g) + d * 4; h /= 6 * d; break;
    }

    return [
         h,
         s,
         v
    ];
}

function addSaturationToRGB(color,offset){
    var hsv = RGBtoHSV(color[0]*255,color[1]*255,color[2]*255);
    hsv[1] += offset;
    if (hsv[1] > 1) {
        hsv[1] = 1;
    }
    else if (hsv[1] <= 0) {
        hsv[1] = 0;
    }
    return HSVtoRGB(hsv[0],hsv[1],hsv[2]);
}

function addBrightnessToRGB(color,offset){
    var hsv = RGBtoHSV(color[0]*255,color[1]*255,color[2]*255);
    hsv[2] += offset;
    if (hsv[2] > 1) {
        hsv[2] = 1;
    }
    else if (hsv[2] < 0) {
        hsv[2] = 0;
    }
    return HSVtoRGB(hsv[0],hsv[1],hsv[2]);
}

function addHueToRGB(color,offset) {
    var hsv = RGBtoHSV(color[0]*255,color[1]*255,color[2]*255);
    hsv[0] += offset/360;
    if (hsv[0] > 1) {
        hsv[0] -= 1;
    }
    else if (hsv[0] < 0) {
        hsv[0] += 1;
    }
    return HSVtoRGB(hsv[0],hsv[1],hsv[2]);
}

function componentToHex(c) {
    var hex = c.toString(16);
    return hex.length == 1 ? '0' + hex : hex;
}

var rgbToHex = (function(){
    var colorMap = [];
    var i;
    var hex;
    for(i=0;i<256;i+=1){
        hex = i.toString(16);
        colorMap[i] = hex.length == 1 ? '0' + hex : hex;
    }

    return function(r, g, b) {
        if(r<0){
            r = 0;
        }
        if(g<0){
            g = 0;
        }
        if(b<0){
            b = 0;
        }
        return '#' + colorMap[r] + colorMap[g] + colorMap[b];
    };
}());

function fillToRgba(hex,alpha){
    if(!cachedColors[hex]){
        var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        cachedColors[hex] = parseInt(result[1], 16)+','+parseInt(result[2], 16)+','+parseInt(result[3], 16);
    }
    return 'rgba('+cachedColors[hex]+','+alpha+')';
}

var fillColorToString = (function(){

    var colorMap = [];
    return function(colorArr,alpha){
        if(alpha !== undefined){
            colorArr[3] = alpha;
        }
        if(!colorMap[colorArr[0]]){
            colorMap[colorArr[0]] = {};
        }
        if(!colorMap[colorArr[0]][colorArr[1]]){
            colorMap[colorArr[0]][colorArr[1]] = {};
        }
        if(!colorMap[colorArr[0]][colorArr[1]][colorArr[2]]){
            colorMap[colorArr[0]][colorArr[1]][colorArr[2]] = {};
        }
        if(!colorMap[colorArr[0]][colorArr[1]][colorArr[2]][colorArr[3]]){
            colorMap[colorArr[0]][colorArr[1]][colorArr[2]][colorArr[3]] = 'rgba(' + colorArr.join(',')+')';
        }
        return colorMap[colorArr[0]][colorArr[1]][colorArr[2]][colorArr[3]];
    };
}());

function RenderedFrame(tr,o) {
    this.tr = tr;
    this.o = o;
}

function iterateDynamicProperties(num){
    var i, len = this.dynamicProperties;
    for(i=0;i<len;i+=1){
        this.dynamicProperties[i].getValue(num);
    }
}

function reversePath(paths){
    var newI = [], newO = [], newV = [];
    var i, len, newPaths = {};
    var init = 0;
    if (paths.c) {
        newI[0] = paths.o[0];
        newO[0] = paths.i[0];
        newV[0] = paths.v[0];
        init = 1;
    }
    len = paths.i.length;
    var cnt = len - 1;

    for (i = init; i < len; i += 1) {
        newI.push(paths.o[cnt]);
        newO.push(paths.i[cnt]);
        newV.push(paths.v[cnt]);
        cnt -= 1;
    }

    newPaths.i = newI;
    newPaths.o = newO;
    newPaths.v = newV;

    return newPaths;
}
/*!
 Transformation Matrix v2.0
 (c) Epistemex 2014-2015
 www.epistemex.com
 By Ken Fyrstenberg
 Contributions by leeoniya.
 License: MIT, header required.
 */

/**
 * 2D transformation matrix object initialized with identity matrix.
 *
 * The matrix can synchronize a canvas context by supplying the context
 * as an argument, or later apply current absolute transform to an
 * existing context.
 *
 * All values are handled as floating point values.
 *
 * @param {CanvasRenderingContext2D} [context] - Optional context to sync with Matrix
 * @prop {number} a - scale x
 * @prop {number} b - shear y
 * @prop {number} c - shear x
 * @prop {number} d - scale y
 * @prop {number} e - translate x
 * @prop {number} f - translate y
 * @prop {CanvasRenderingContext2D|null} [context=null] - set or get current canvas context
 * @constructor
 */

var Matrix = (function(){

    function reset(){
        this.props[0] = 1;
        this.props[1] = 0;
        this.props[2] = 0;
        this.props[3] = 0;
        this.props[4] = 0;
        this.props[5] = 1;
        this.props[6] = 0;
        this.props[7] = 0;
        this.props[8] = 0;
        this.props[9] = 0;
        this.props[10] = 1;
        this.props[11] = 0;
        this.props[12] = 0;
        this.props[13] = 0;
        this.props[14] = 0;
        this.props[15] = 1;
        return this;
    }

    function rotate(angle) {
        if(angle === 0){
            return this;
        }
        var mCos = Math.cos(angle);
        var mSin = Math.sin(angle);
        return this._t(mCos, -mSin,  0, 0
            , mSin,  mCos, 0, 0
            , 0,  0,  1, 0
            , 0, 0, 0, 1);
    }

    function rotateX(angle){
        if(angle === 0){
            return this;
        }
        var mCos = Math.cos(angle);
        var mSin = Math.sin(angle);
        return this._t(1, 0, 0, 0
            , 0, mCos, -mSin, 0
            , 0, mSin,  mCos, 0
            , 0, 0, 0, 1);
    }

    function rotateY(angle){
        if(angle === 0){
            return this;
        }
        var mCos = Math.cos(angle);
        var mSin = Math.sin(angle);
        return this._t(mCos,  0,  mSin, 0
            , 0, 1, 0, 0
            , -mSin,  0,  mCos, 0
            , 0, 0, 0, 1);
    }

    function rotateZ(angle){
        if(angle === 0){
            return this;
        }
        var mCos = Math.cos(angle);
        var mSin = Math.sin(angle);
        return this._t(mCos, -mSin,  0, 0
            , mSin,  mCos, 0, 0
            , 0,  0,  1, 0
            , 0, 0, 0, 1);
    }

    function shear(sx,sy){
        return this._t(1, sy, sx, 1, 0, 0);
    }

    function skew(ax, ay){
        return this.shear(Math.tan(ax), Math.tan(ay));
    }

    function skewFromAxis(ax, angle){
        var mCos = Math.cos(angle);
        var mSin = Math.sin(angle);
        return this._t(mCos, mSin,  0, 0
            , -mSin,  mCos, 0, 0
            , 0,  0,  1, 0
            , 0, 0, 0, 1)
            ._t(1, 0,  0, 0
            , Math.tan(ax),  1, 0, 0
            , 0,  0,  1, 0
            , 0, 0, 0, 1)
            ._t(mCos, -mSin,  0, 0
            , mSin,  mCos, 0, 0
            , 0,  0,  1, 0
            , 0, 0, 0, 1);
        //return this._t(mCos, mSin, -mSin, mCos, 0, 0)._t(1, 0, Math.tan(ax), 1, 0, 0)._t(mCos, -mSin, mSin, mCos, 0, 0);
    }

    function scale(sx, sy, sz) {
        sz = isNaN(sz) ? 1 : sz;
        if(sx == 1 && sy == 1 && sz == 1){
            return this;
        }
        return this._t(sx, 0, 0, 0, 0, sy, 0, 0, 0, 0, sz, 0, 0, 0, 0, 1);
    }

    function setTransform(a, b, c, d, e, f, g, h, i, j, k, l, m, n, o, p) {
        this.props[0] = a;
        this.props[1] = b;
        this.props[2] = c;
        this.props[3] = d;
        this.props[4] = e;
        this.props[5] = f;
        this.props[6] = g;
        this.props[7] = h;
        this.props[8] = i;
        this.props[9] = j;
        this.props[10] = k;
        this.props[11] = l;
        this.props[12] = m;
        this.props[13] = n;
        this.props[14] = o;
        this.props[15] = p;
        return this;
    }

    function translate(tx, ty, tz) {
        tz = tz || 0;
        if(tx !== 0 || ty !== 0 || tz !== 0){
            return this._t(1,0,0,0,0,1,0,0,0,0,1,0,tx,ty,tz,1);
        }
        return this;
    }

    function transform(a2, b2, c2, d2, e2, f2, g2, h2, i2, j2, k2, l2, m2, n2, o2, p2) {

        if(a2 === 1 && b2 === 0 && c2 === 0 && d2 === 0 && e2 === 0 && f2 === 1 && g2 === 0 && h2 === 0 && i2 === 0 && j2 === 0 && k2 === 1 && l2 === 0){
            if(m2 !== 0 || n2 !== 0 || o2 !== 0){

                this.props[12] = this.props[12] * a2 + this.props[13] * e2 + this.props[14] * i2 + this.props[15] * m2 ;
                this.props[13] = this.props[12] * b2 + this.props[13] * f2 + this.props[14] * j2 + this.props[15] * n2 ;
                this.props[14] = this.props[12] * c2 + this.props[13] * g2 + this.props[14] * k2 + this.props[15] * o2 ;
                this.props[15] = this.props[12] * d2 + this.props[13] * h2 + this.props[14] * l2 + this.props[15] * p2 ;
            }
            this._identityCalculated = false;
            return this;
        }

        var a1 = this.props[0];
        var b1 = this.props[1];
        var c1 = this.props[2];
        var d1 = this.props[3];
        var e1 = this.props[4];
        var f1 = this.props[5];
        var g1 = this.props[6];
        var h1 = this.props[7];
        var i1 = this.props[8];
        var j1 = this.props[9];
        var k1 = this.props[10];
        var l1 = this.props[11];
        var m1 = this.props[12];
        var n1 = this.props[13];
        var o1 = this.props[14];
        var p1 = this.props[15];

        /* matrix order (canvas compatible):
         * ace
         * bdf
         * 001
         */
        this.props[0] = a1 * a2 + b1 * e2 + c1 * i2 + d1 * m2;
        this.props[1] = a1 * b2 + b1 * f2 + c1 * j2 + d1 * n2 ;
        this.props[2] = a1 * c2 + b1 * g2 + c1 * k2 + d1 * o2 ;
        this.props[3] = a1 * d2 + b1 * h2 + c1 * l2 + d1 * p2 ;

        this.props[4] = e1 * a2 + f1 * e2 + g1 * i2 + h1 * m2 ;
        this.props[5] = e1 * b2 + f1 * f2 + g1 * j2 + h1 * n2 ;
        this.props[6] = e1 * c2 + f1 * g2 + g1 * k2 + h1 * o2 ;
        this.props[7] = e1 * d2 + f1 * h2 + g1 * l2 + h1 * p2 ;

        this.props[8] = i1 * a2 + j1 * e2 + k1 * i2 + l1 * m2 ;
        this.props[9] = i1 * b2 + j1 * f2 + k1 * j2 + l1 * n2 ;
        this.props[10] = i1 * c2 + j1 * g2 + k1 * k2 + l1 * o2 ;
        this.props[11] = i1 * d2 + j1 * h2 + k1 * l2 + l1 * p2 ;

        this.props[12] = m1 * a2 + n1 * e2 + o1 * i2 + p1 * m2 ;
        this.props[13] = m1 * b2 + n1 * f2 + o1 * j2 + p1 * n2 ;
        this.props[14] = m1 * c2 + n1 * g2 + o1 * k2 + p1 * o2 ;
        this.props[15] = m1 * d2 + n1 * h2 + o1 * l2 + p1 * p2 ;

        this._identityCalculated = false;
        return this;
    }

    function isIdentity() {
        if(!this._identityCalculated){
            this._identity = !(this.props[0] !== 1 || this.props[1] !== 0 || this.props[2] !== 0 || this.props[3] !== 0
                || this.props[4] !== 0 || this.props[5] !== 1 || this.props[6] !== 0 || this.props[7] !== 0
                || this.props[8] !== 0 || this.props[9] !== 0 || this.props[10] !== 1 || this.props[11] !== 0
                || this.props[12] !== 0 || this.props[13] !== 0 || this.props[14] !== 0 || this.props[15] !== 1);
            this._identityCalculated = true;
        }
        return this._identity;
    }

    function clone(matr){
        var i;
        for(i=0;i<16;i+=1){
            matr.props[i] = this.props[i];
        }
    }

    function cloneFromProps(props){
        var i;
        for(i=0;i<16;i+=1){
            this.props[i] = props[i];
        }
    }

    function applyToPoint(x, y, z) {

        return {
            x: x * this.props[0] + y * this.props[4] + z * this.props[8] + this.props[12],
            y: x * this.props[1] + y * this.props[5] + z * this.props[9] + this.props[13],
            z: x * this.props[2] + y * this.props[6] + z * this.props[10] + this.props[14]
        };
        /*return {
         x: x * me.a + y * me.c + me.e,
         y: x * me.b + y * me.d + me.f
         };*/
    }
    function applyToX(x, y, z) {
        return x * this.props[0] + y * this.props[4] + z * this.props[8] + this.props[12];
    }
    function applyToY(x, y, z) {
        return x * this.props[1] + y * this.props[5] + z * this.props[9] + this.props[13];
    }
    function applyToZ(x, y, z) {
        return x * this.props[2] + y * this.props[6] + z * this.props[10] + this.props[14];
    }

    function inversePoint(pt) {
        var determinant = this.props[0] * this.props[5] - this.props[1] * this.props[4];
        var a = this.props[5]/determinant;
        var b = - this.props[1]/determinant;
        var c = - this.props[4]/determinant;
        var d = this.props[0]/determinant;
        var e = (this.props[4] * this.props[13] - this.props[5] * this.props[12])/determinant;
        var f = - (this.props[0] * this.props[13] - this.props[1] * this.props[12])/determinant;
        return [pt[0] * a + pt[1] * c + e, pt[0] * b + pt[1] * d + f, 0];
    }

    function inversePoints(pts){
        var i, len = pts.length, retPts = [];
        for(i=0;i<len;i+=1){
            retPts[i] = inversePoint(pts[i]);
        }
        return retPts;
    }

    function applyToPointArray(x,y,z,dimensions){
        if(dimensions && dimensions === 2) {
            var arr = point_pool.newPoint();
            arr[0] = x * this.props[0] + y * this.props[4] + z * this.props[8] + this.props[12]; 
            arr[1] = x * this.props[1] + y * this.props[5] + z * this.props[9] + this.props[13]; 
            return arr;    
        }
        return [x * this.props[0] + y * this.props[4] + z * this.props[8] + this.props[12],x * this.props[1] + y * this.props[5] + z * this.props[9] + this.props[13],x * this.props[2] + y * this.props[6] + z * this.props[10] + this.props[14]];
    }
    function applyToPointStringified(x, y) {
        if(this.isIdentity()) {
            return x + ',' + y;
        }
        return (bm_rnd(x * this.props[0] + y * this.props[4] + this.props[12]))+','+(bm_rnd(x * this.props[1] + y * this.props[5] + this.props[13]));
    }

    function toArray() {
        return [this.props[0],this.props[1],this.props[2],this.props[3],this.props[4],this.props[5],this.props[6],this.props[7],this.props[8],this.props[9],this.props[10],this.props[11],this.props[12],this.props[13],this.props[14],this.props[15]];
    }

    function toCSS() {
        if(isSafari){
            return "matrix3d(" + roundTo2Decimals(this.props[0]) + ',' + roundTo2Decimals(this.props[1]) + ',' + roundTo2Decimals(this.props[2]) + ',' + roundTo2Decimals(this.props[3]) + ',' + roundTo2Decimals(this.props[4]) + ',' + roundTo2Decimals(this.props[5]) + ',' + roundTo2Decimals(this.props[6]) + ',' + roundTo2Decimals(this.props[7]) + ',' + roundTo2Decimals(this.props[8]) + ',' + roundTo2Decimals(this.props[9]) + ',' + roundTo2Decimals(this.props[10]) + ',' + roundTo2Decimals(this.props[11]) + ',' + roundTo2Decimals(this.props[12]) + ',' + roundTo2Decimals(this.props[13]) + ',' + roundTo2Decimals(this.props[14]) + ',' + roundTo2Decimals(this.props[15]) + ')';
        } else {
            this.cssParts[1] = this.props.join(',');
            return this.cssParts.join('');
        }
    }

    function to2dCSS() {
        return "matrix(" + roundTo2Decimals(this.props[0]) + ',' + roundTo2Decimals(this.props[1]) + ',' + roundTo2Decimals(this.props[4]) + ',' + roundTo2Decimals(this.props[5]) + ',' + roundTo2Decimals(this.props[12]) + ',' + roundTo2Decimals(this.props[13]) + ")";
    }

    function toString() {
        return "" + this.toArray();
    }

    return function(){
        this.reset = reset;
        this.rotate = rotate;
        this.rotateX = rotateX;
        this.rotateY = rotateY;
        this.rotateZ = rotateZ;
        this.skew = skew;
        this.skewFromAxis = skewFromAxis;
        this.shear = shear;
        this.scale = scale;
        this.setTransform = setTransform;
        this.translate = translate;
        this.transform = transform;
        this.applyToPoint = applyToPoint;
        this.applyToX = applyToX;
        this.applyToY = applyToY;
        this.applyToZ = applyToZ;
        this.applyToPointArray = applyToPointArray;
        this.applyToPointStringified = applyToPointStringified;
        this.toArray = toArray;
        this.toCSS = toCSS;
        this.to2dCSS = to2dCSS;
        this.toString = toString;
        this.clone = clone;
        this.cloneFromProps = cloneFromProps;
        this.inversePoints = inversePoints;
        this.inversePoint = inversePoint;
        this._t = this.transform;
        this.isIdentity = isIdentity;
        this._identity = true;
        this._identityCalculated = false;

        this.props = [1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1];

        this.cssParts = ['matrix3d(','',')'];
    }
}());

function Matrix() {


}

/*
 Copyright 2014 David Bau.

 Permission is hereby granted, free of charge, to any person obtaining
 a copy of this software and associated documentation files (the
 "Software"), to deal in the Software without restriction, including
 without limitation the rights to use, copy, modify, merge, publish,
 distribute, sublicense, and/or sell copies of the Software, and to
 permit persons to whom the Software is furnished to do so, subject to
 the following conditions:

 The above copyright notice and this permission notice shall be
 included in all copies or substantial portions of the Software.

 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
 IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
 CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
 TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
 SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

 */

(function (pool, math) {
//
// The following constants are related to IEEE 754 limits.
//
    var global = this,
        width = 256,        // each RC4 output is 0 <= x < 256
        chunks = 6,         // at least six RC4 outputs for each double
        digits = 52,        // there are 52 significant digits in a double
        rngname = 'random', // rngname: name for Math.random and Math.seedrandom
        startdenom = math.pow(width, chunks),
        significance = math.pow(2, digits),
        overflow = significance * 2,
        mask = width - 1,
        nodecrypto;         // node.js crypto module, initialized at the bottom.

//
// seedrandom()
// This is the seedrandom function described above.
//
    function seedrandom(seed, options, callback) {
        var key = [];
        options = (options == true) ? { entropy: true } : (options || {});

        // Flatten the seed string or build one from local entropy if needed.
        var shortseed = mixkey(flatten(
            options.entropy ? [seed, tostring(pool)] :
                (seed == null) ? autoseed() : seed, 3), key);

        // Use the seed to initialize an ARC4 generator.
        var arc4 = new ARC4(key);

        // This function returns a random double in [0, 1) that contains
        // randomness in every bit of the mantissa of the IEEE 754 value.
        var prng = function() {
            var n = arc4.g(chunks),             // Start with a numerator n < 2 ^ 48
                d = startdenom,                 //   and denominator d = 2 ^ 48.
                x = 0;                          //   and no 'extra last byte'.
            while (n < significance) {          // Fill up all significant digits by
                n = (n + x) * width;              //   shifting numerator and
                d *= width;                       //   denominator and generating a
                x = arc4.g(1);                    //   new least-significant-byte.
            }
            while (n >= overflow) {             // To avoid rounding up, before adding
                n /= 2;                           //   last byte, shift everything
                d /= 2;                           //   right using integer math until
                x >>>= 1;                         //   we have exactly the desired bits.
            }
            return (n + x) / d;                 // Form the number within [0, 1).
        };

        prng.int32 = function() { return arc4.g(4) | 0; }
        prng.quick = function() { return arc4.g(4) / 0x100000000; }
        prng.double = prng;

        // Mix the randomness into accumulated entropy.
        mixkey(tostring(arc4.S), pool);

        // Calling convention: what to return as a function of prng, seed, is_math.
        return (options.pass || callback ||
        function(prng, seed, is_math_call, state) {
            if (state) {
                // Load the arc4 state from the given state if it has an S array.
                if (state.S) { copy(state, arc4); }
                // Only provide the .state method if requested via options.state.
                prng.state = function() { return copy(arc4, {}); }
            }

            // If called as a method of Math (Math.seedrandom()), mutate
            // Math.random because that is how seedrandom.js has worked since v1.0.
            if (is_math_call) { math[rngname] = prng; return seed; }

            // Otherwise, it is a newer calling convention, so return the
            // prng directly.
            else return prng;
        })(
            prng,
            shortseed,
            'global' in options ? options.global : (this == math),
            options.state);
    }
    math['seed' + rngname] = seedrandom;

//
// ARC4
//
// An ARC4 implementation.  The constructor takes a key in the form of
// an array of at most (width) integers that should be 0 <= x < (width).
//
// The g(count) method returns a pseudorandom integer that concatenates
// the next (count) outputs from ARC4.  Its return value is a number x
// that is in the range 0 <= x < (width ^ count).
//
    function ARC4(key) {
        var t, keylen = key.length,
            me = this, i = 0, j = me.i = me.j = 0, s = me.S = [];

        // The empty key [] is treated as [0].
        if (!keylen) { key = [keylen++]; }

        // Set up S using the standard key scheduling algorithm.
        while (i < width) {
            s[i] = i++;
        }
        for (i = 0; i < width; i++) {
            s[i] = s[j = mask & (j + key[i % keylen] + (t = s[i]))];
            s[j] = t;
        }

        // The "g" method returns the next (count) outputs as one number.
        (me.g = function(count) {
            // Using instance members instead of closure state nearly doubles speed.
            var t, r = 0,
                i = me.i, j = me.j, s = me.S;
            while (count--) {
                t = s[i = mask & (i + 1)];
                r = r * width + s[mask & ((s[i] = s[j = mask & (j + t)]) + (s[j] = t))];
            }
            me.i = i; me.j = j;
            return r;
            // For robust unpredictability, the function call below automatically
            // discards an initial batch of values.  This is called RC4-drop[256].
            // See http://google.com/search?q=rsa+fluhrer+response&btnI
        })(width);
    }

//
// copy()
// Copies internal state of ARC4 to or from a plain object.
//
    function copy(f, t) {
        t.i = f.i;
        t.j = f.j;
        t.S = f.S.slice();
        return t;
    };

//
// flatten()
// Converts an object tree to nested arrays of strings.
//
    function flatten(obj, depth) {
        var result = [], typ = (typeof obj), prop;
        if (depth && typ == 'object') {
            for (prop in obj) {
                try { result.push(flatten(obj[prop], depth - 1)); } catch (e) {}
            }
        }
        return (result.length ? result : typ == 'string' ? obj : obj + '\0');
    }

//
// mixkey()
// Mixes a string seed into a key that is an array of integers, and
// returns a shortened string seed that is equivalent to the result key.
//
    function mixkey(seed, key) {
        var stringseed = seed + '', smear, j = 0;
        while (j < stringseed.length) {
            key[mask & j] =
                mask & ((smear ^= key[mask & j] * 19) + stringseed.charCodeAt(j++));
        }
        return tostring(key);
    }

//
// autoseed()
// Returns an object for autoseeding, using window.crypto and Node crypto
// module if available.
//
    function autoseed() {
        try {
            if (nodecrypto) { return tostring(nodecrypto.randomBytes(width)); }
            var out = new Uint8Array(width);
            (global.crypto || global.msCrypto).getRandomValues(out);
            return tostring(out);
        } catch (e) {
            var browser = global.navigator,
                plugins = browser && browser.plugins;
            return [+new Date, global, plugins, global.screen, tostring(pool)];
        }
    }

//
// tostring()
// Converts an array of charcodes to a string
//
    function tostring(a) {
        return String.fromCharCode.apply(0, a);
    }

//
// When seedrandom.js is loaded, we immediately mix a few bits
// from the built-in RNG into the entropy pool.  Because we do
// not want to interfere with deterministic PRNG state later,
// seedrandom will not call math.random on its own again after
// initialization.
//
    mixkey(math.random(), pool);

//
// Nodejs and AMD support: export the implementation as a module using
// either convention.
//

// End anonymous scope, and pass initial values.
})(
    [],     // pool: entropy pool starts empty
    BMMath    // math: package containing random, pow, and seedrandom
);
var BezierFactory = (function(){
    /**
     * BezierEasing - use bezier curve for transition easing function
     * by Gaëtan Renaudeau 2014 - 2015 – MIT License
     *
     * Credits: is based on Firefox's nsSMILKeySpline.cpp
     * Usage:
     * var spline = BezierEasing([ 0.25, 0.1, 0.25, 1.0 ])
     * spline.get(x) => returns the easing value | x must be in [0, 1] range
     *
     */

        var ob = {};
    ob.getBezierEasing = getBezierEasing;
    var beziers = {};

    function getBezierEasing(a,b,c,d,nm){
        var str = nm || ('bez_' + a+'_'+b+'_'+c+'_'+d).replace(/\./g, 'p');
        if(beziers[str]){
            return beziers[str];
        }
        var bezEasing = new BezierEasing([a,b,c,d]);
        beziers[str] = bezEasing;
        return bezEasing;
    }

// These values are established by empiricism with tests (tradeoff: performance VS precision)
    var NEWTON_ITERATIONS = 4;
    var NEWTON_MIN_SLOPE = 0.001;
    var SUBDIVISION_PRECISION = 0.0000001;
    var SUBDIVISION_MAX_ITERATIONS = 10;

    var kSplineTableSize = 11;
    var kSampleStepSize = 1.0 / (kSplineTableSize - 1.0);

    var float32ArraySupported = typeof Float32Array === "function";

    function A (aA1, aA2) { return 1.0 - 3.0 * aA2 + 3.0 * aA1; }
    function B (aA1, aA2) { return 3.0 * aA2 - 6.0 * aA1; }
    function C (aA1)      { return 3.0 * aA1; }

// Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
    function calcBezier (aT, aA1, aA2) {
        return ((A(aA1, aA2)*aT + B(aA1, aA2))*aT + C(aA1))*aT;
    }

// Returns dx/dt given t, x1, and x2, or dy/dt given t, y1, and y2.
    function getSlope (aT, aA1, aA2) {
        return 3.0 * A(aA1, aA2)*aT*aT + 2.0 * B(aA1, aA2) * aT + C(aA1);
    }

    function binarySubdivide (aX, aA, aB, mX1, mX2) {
        var currentX, currentT, i = 0;
        do {
            currentT = aA + (aB - aA) / 2.0;
            currentX = calcBezier(currentT, mX1, mX2) - aX;
            if (currentX > 0.0) {
                aB = currentT;
            } else {
                aA = currentT;
            }
        } while (Math.abs(currentX) > SUBDIVISION_PRECISION && ++i < SUBDIVISION_MAX_ITERATIONS);
        return currentT;
    }

    function newtonRaphsonIterate (aX, aGuessT, mX1, mX2) {
        for (var i = 0; i < NEWTON_ITERATIONS; ++i) {
            var currentSlope = getSlope(aGuessT, mX1, mX2);
            if (currentSlope === 0.0) return aGuessT;
            var currentX = calcBezier(aGuessT, mX1, mX2) - aX;
            aGuessT -= currentX / currentSlope;
        }
        return aGuessT;
    }

    /**
     * points is an array of [ mX1, mY1, mX2, mY2 ]
     */
    function BezierEasing (points) {
        this._p = points;
        this._mSampleValues = float32ArraySupported ? new Float32Array(kSplineTableSize) : new Array(kSplineTableSize);
        this._precomputed = false;

        this.get = this.get.bind(this);
    }

    BezierEasing.prototype = {

        get: function (x) {
            var mX1 = this._p[0],
                mY1 = this._p[1],
                mX2 = this._p[2],
                mY2 = this._p[3];
            if (!this._precomputed) this._precompute();
            if (mX1 === mY1 && mX2 === mY2) return x; // linear
            // Because JavaScript number are imprecise, we should guarantee the extremes are right.
            if (x === 0) return 0;
            if (x === 1) return 1;
            return calcBezier(this._getTForX(x), mY1, mY2);
        },

        // Private part

        _precompute: function () {
            var mX1 = this._p[0],
                mY1 = this._p[1],
                mX2 = this._p[2],
                mY2 = this._p[3];
            this._precomputed = true;
            if (mX1 !== mY1 || mX2 !== mY2)
                this._calcSampleValues();
        },

        _calcSampleValues: function () {
            var mX1 = this._p[0],
                mX2 = this._p[2];
            for (var i = 0; i < kSplineTableSize; ++i) {
                this._mSampleValues[i] = calcBezier(i * kSampleStepSize, mX1, mX2);
            }
        },

        /**
         * getTForX chose the fastest heuristic to determine the percentage value precisely from a given X projection.
         */
        _getTForX: function (aX) {
            var mX1 = this._p[0],
                mX2 = this._p[2],
                mSampleValues = this._mSampleValues;

            var intervalStart = 0.0;
            var currentSample = 1;
            var lastSample = kSplineTableSize - 1;

            for (; currentSample !== lastSample && mSampleValues[currentSample] <= aX; ++currentSample) {
                intervalStart += kSampleStepSize;
            }
            --currentSample;

            // Interpolate to provide an initial guess for t
            var dist = (aX - mSampleValues[currentSample]) / (mSampleValues[currentSample+1] - mSampleValues[currentSample]);
            var guessForT = intervalStart + dist * kSampleStepSize;

            var initialSlope = getSlope(guessForT, mX1, mX2);
            if (initialSlope >= NEWTON_MIN_SLOPE) {
                return newtonRaphsonIterate(aX, guessForT, mX1, mX2);
            } else if (initialSlope === 0.0) {
                return guessForT;
            } else {
                return binarySubdivide(aX, intervalStart, intervalStart + kSampleStepSize, mX1, mX2);
            }
        }
    };

    return ob;

}());
(function () {
    var lastTime = 0;
    var vendors = ['ms', 'moz', 'webkit', 'o'];
    for(var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
        window.requestAnimationFrame = window[vendors[x] + 'RequestAnimationFrame'];
        window.cancelAnimationFrame = window[vendors[x] + 'CancelAnimationFrame'] || window[vendors[x] + 'CancelRequestAnimationFrame'];
    }
    if(!window.requestAnimationFrame)
        window.requestAnimationFrame = function (callback, element) {
            var currTime = new Date().getTime();
            var timeToCall = Math.max(0, 16 - (currTime - lastTime));
            var id = setTimeout(function () {
                    callback(currTime + timeToCall);
                },
                timeToCall);
            lastTime = currTime + timeToCall;
            return id;
        };
    if(!window.cancelAnimationFrame)
        window.cancelAnimationFrame = function (id) {
            clearTimeout(id);
        };
}());

function createElement(parent,child,params){
    if(child){
        child.prototype = Object.create(parent.prototype);
        child.prototype.constructor = child;
        child.prototype._parent = parent.prototype;
    }else{
        var instance = Object.create(parent.prototype,params);
        var getType = {};
        if(instance && getType.toString.call(instance.init) === '[object Function]'){
            instance.init();
        }
        return instance;
    }
}

function extendPrototype(source,destination){
    for (var attr in source.prototype) {
        if (source.prototype.hasOwnProperty(attr)) destination.prototype[attr] = source.prototype[attr];
    }
}
function bezFunction(){

    var easingFunctions = [];
    var math = Math;

    function pointOnLine2D(x1,y1, x2,y2, x3,y3){
        var det1 = (x1*y2) + (y1*x3) + (x2*y3) - (x3*y2) - (y3*x1) - (x2*y1);
        return det1 > -0.0001 && det1 < 0.0001;
    }

    function pointOnLine3D(x1,y1,z1, x2,y2,z2, x3,y3,z3){
        if(z1 === 0 && z2 === 0 && z3 === 0) {
            return pointOnLine2D(x1,y1, x2,y2, x3,y3);
        }
        var dist1 = Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2) + Math.pow(z2 - z1, 2));
        var dist2 = Math.sqrt(Math.pow(x3 - x1, 2) + Math.pow(y3 - y1, 2) + Math.pow(z3 - z1, 2));
        var dist3 = Math.sqrt(Math.pow(x3 - x2, 2) + Math.pow(y3 - y2, 2) + Math.pow(z3 - z2, 2));
        var diffDist;
        if(dist1 > dist2){
            if(dist1 > dist3){
                diffDist = dist1 - dist2 - dist3;
            } else {
                diffDist = dist3 - dist2 - dist1;
            }
        } else if(dist3 > dist2){
            diffDist = dist3 - dist2 - dist1;
        } else {
            diffDist = dist2 - dist1 - dist3;
        }
        return diffDist > -0.0001 && diffDist < 0.0001;
    }

    /*function getEasingCurve(aa,bb,cc,dd,encodedFuncName) {
        if(!encodedFuncName){
            encodedFuncName = ('bez_' + aa+'_'+bb+'_'+cc+'_'+dd).replace(/\./g, 'p');
        }
        if(easingFunctions[encodedFuncName]){
            return easingFunctions[encodedFuncName];
        }
        var A0, B0, C0;
        var A1, B1, C1;
        easingFunctions[encodedFuncName] = function(tt) {
            var x = tt;
            var i = 0, z;
            while (++i < 20) {
                C0 = 3 * aa;
                B0 = 3 * (cc - aa) - C0;
                A0 = 1 - C0 - B0;
                z = (x * (C0 + x * (B0 + x * A0))) - tt;
                if (bm_abs(z) < 1e-3) break;
                x -= z / (C0 + x * (2 * B0 + 3 * A0 * x));
            }
            C1 = 3 * bb;
            B1 = 3 * (dd - bb) - C1;
            A1 = 1 - C1 - B1;
            var polyB = x * (C1 + x * (B1 + x * A1));
            //return c * polyB + b;
            return polyB;
        };
        return easingFunctions[encodedFuncName];
    }*/
    var getBezierLength = (function(){

        function Segment(l,p){
            this.l = l;
            this.p = p;
        }

        return function(pt1,pt2,pt3,pt4){
            var curveSegments = defaultCurveSegments;
            var k;
            var i, len;
            var ptCoord,perc,addedLength = 0;
            var ptDistance;
            var point = [],lastPoint = [];
            var lengthData = {
                addedLength: 0,
                segments: []
            };
            len = pt3.length;
            for(k=0;k<curveSegments;k+=1){
                perc = k/(curveSegments-1);
                ptDistance = 0;
                for(i=0;i<len;i+=1){
                    ptCoord = bm_pow(1-perc,3)*pt1[i]+3*bm_pow(1-perc,2)*perc*pt3[i]+3*(1-perc)*bm_pow(perc,2)*pt4[i]+bm_pow(perc,3)*pt2[i];
                    point[i] = ptCoord;
                    if(lastPoint[i] !== null){
                        ptDistance += bm_pow(point[i] - lastPoint[i],2);
                    }
                    lastPoint[i] = point[i];
                }
                if(ptDistance){
                    ptDistance = bm_sqrt(ptDistance);
                    addedLength += ptDistance;
                }
                lengthData.segments.push(new Segment(addedLength,perc));
            }
            lengthData.addedLength = addedLength;
            return lengthData;
        };
    }());

    function getSegmentsLength(shapeData) {
        var closed = shapeData.c;
        var pathV = shapeData.v;
        var pathO = shapeData.o;
        var pathI = shapeData.i;
        var i, len = shapeData._length;
        var lengths = [];
        var totalLength = 0;
        for(i=0;i<len-1;i+=1){
            lengths[i] = getBezierLength(pathV[i],pathV[i+1],pathO[i],pathI[i+1]);
            totalLength += lengths[i].addedLength;
        }
        if(closed){
            lengths[i] = getBezierLength(pathV[i],pathV[0],pathO[i],pathI[0]);
            totalLength += lengths[i].addedLength;
        }
        return {lengths:lengths,totalLength:totalLength};
    }

    function BezierData(length){
        this.segmentLength = 0;
        this.points = new Array(length);
    }

    function PointData(partial,point){
        this.partialLength = partial;
        this.point = point;
    }

    var buildBezierData = (function(){

        var storedData = {};

        return function (keyData){
            var pt1 = keyData.s;
            var pt2 = keyData.e;
            var pt3 = keyData.to;
            var pt4 = keyData.ti;
            var bezierName = (pt1.join('_')+'_'+pt2.join('_')+'_'+pt3.join('_')+'_'+pt4.join('_')).replace(/\./g, 'p');
            if(storedData[bezierName]){
                keyData.bezierData = storedData[bezierName];
                return;
            }
        var curveSegments = defaultCurveSegments;
        var k, i, len;
            var ptCoord,perc,addedLength = 0;
            var ptDistance;
            var point,lastPoint = null;
            if(pt1.length === 2 && (pt1[0] != pt2[0] || pt1[1] != pt2[1]) && pointOnLine2D(pt1[0],pt1[1],pt2[0],pt2[1],pt1[0]+pt3[0],pt1[1]+pt3[1]) && pointOnLine2D(pt1[0],pt1[1],pt2[0],pt2[1],pt2[0]+pt4[0],pt2[1]+pt4[1])){
                curveSegments = 2;
            }
            var bezierData = new BezierData(curveSegments);
            len = pt3.length;
            for(k=0;k<curveSegments;k+=1){
            point = new Array(len);
                perc = k/(curveSegments-1);
                ptDistance = 0;
                for(i=0;i<len;i+=1){
                ptCoord = bm_pow(1-perc,3)*pt1[i]+3*bm_pow(1-perc,2)*perc*(pt1[i] + pt3[i])+3*(1-perc)*bm_pow(perc,2)*(pt2[i] + pt4[i])+bm_pow(perc,3)*pt2[i];
                point[i] = ptCoord;
                    if(lastPoint !== null){
                    ptDistance += bm_pow(point[i] - lastPoint[i],2);
                    }
                }
            ptDistance = bm_sqrt(ptDistance);
                addedLength += ptDistance;
                bezierData.points[k] = new PointData(ptDistance,point);
                lastPoint = point;
            }
            bezierData.segmentLength = addedLength;
            keyData.bezierData = bezierData;
            storedData[bezierName] = bezierData;

        }
    }());

    function getDistancePerc(perc,bezierData){
        var segments = bezierData.segments;
        var len = segments.length;
        var initPos = bm_floor((len-1)*perc);
        var lengthPos = perc*bezierData.addedLength;
        var lPerc = 0;
        if(lengthPos == segments[initPos].l){
            return segments[initPos].p;
        }else{
            var dir = segments[initPos].l > lengthPos ? -1 : 1;
            var flag = true;
            while(flag){
                if(segments[initPos].l <= lengthPos && segments[initPos+1].l > lengthPos){
                    lPerc = (lengthPos - segments[initPos].l)/(segments[initPos+1].l-segments[initPos].l);
                    flag = false;
                }else{
                    initPos += dir;
                }
                if(initPos < 0 || initPos >= len - 1){
                    flag = false;
                }
            }
            return segments[initPos].p + (segments[initPos+1].p - segments[initPos].p)*lPerc;
        }
    }

    function SegmentPoints(){
        this.pt1 = new Array(2);
        this.pt2 = new Array(2);
        this.pt3 = new Array(2);
        this.pt4 = new Array(2);
    }

    function getPointInSegment(pt1, pt2, pt3, pt4, percent, bezierData) {
        var t1 = getDistancePerc(percent,bezierData);
        var u0 = 1;
        var u1 = 1 - t1;
        var ptX = Math.round((u1*u1*u1* pt1[0] + (t1*u1*u1 + u1*t1*u1 + u1*u1*t1)* pt3[0] + (t1*t1*u1 + u1*t1*t1 + t1*u1*t1)*pt4[0] + t1*t1*t1* pt2[0])* 1000) / 1000;
        var ptY = Math.round((u1*u1*u1* pt1[1] + (t1*u1*u1 + u1*t1*u1 + u1*u1*t1)* pt3[1] + (t1*t1*u1 + u1*t1*t1 + t1*u1*t1)*pt4[1] + t1*t1*t1* pt2[1])* 1000) / 1000;
        return [ptX, ptY];
    }

    function getNewSegment(pt1,pt2,pt3,pt4,startPerc,endPerc, bezierData){

        var pts = new SegmentPoints();
        startPerc = startPerc < 0 ? 0 : startPerc > 1 ? 1 : startPerc;
        var t0 = getDistancePerc(startPerc,bezierData);
        endPerc = endPerc > 1 ? 1 : endPerc;
        var t1 = getDistancePerc(endPerc,bezierData);
        var i, len = pt1.length;
        var u0 = 1 - t0;
        var u1 = 1 - t1;
        //Math.round(num * 100) / 100
        for(i=0;i<len;i+=1){
            pts.pt1[i] =  Math.round((u0*u0*u0* pt1[i] + (t0*u0*u0 + u0*t0*u0 + u0*u0*t0) * pt3[i] + (t0*t0*u0 + u0*t0*t0 + t0*u0*t0)* pt4[i] + t0*t0*t0* pt2[i])* 1000) / 1000;
            pts.pt3[i] = Math.round((u0*u0*u1*pt1[i] + (t0*u0*u1 + u0*t0*u1 + u0*u0*t1)* pt3[i] + (t0*t0*u1 + u0*t0*t1 + t0*u0*t1)* pt4[i] + t0*t0*t1* pt2[i])* 1000) / 1000;
            pts.pt4[i] = Math.round((u0*u1*u1* pt1[i] + (t0*u1*u1 + u0*t1*u1 + u0*u1*t1)* pt3[i] + (t0*t1*u1 + u0*t1*t1 + t0*u1*t1)* pt4[i] + t0*t1*t1* pt2[i])* 1000) / 1000;
            pts.pt2[i] = Math.round((u1*u1*u1* pt1[i] + (t1*u1*u1 + u1*t1*u1 + u1*u1*t1)* pt3[i] + (t1*t1*u1 + u1*t1*t1 + t1*u1*t1)*pt4[i] + t1*t1*t1* pt2[i])* 1000) / 1000;
        }
        return pts;
    }

    return {
        //getEasingCurve : getEasingCurve,
        getBezierLength : getBezierLength,
        getSegmentsLength : getSegmentsLength,
        getNewSegment : getNewSegment,
        getPointInSegment : getPointInSegment,
        buildBezierData : buildBezierData,
        pointOnLine2D : pointOnLine2D,
        pointOnLine3D : pointOnLine3D
    };
}

var bez = bezFunction();
function dataFunctionManager(){

    //var tCanvasHelper = document.createElement('canvas').getContext('2d');

    function completeLayers(layers, comps, fontManager){
        var layerData;
        var animArray, lastFrame;
        var i, len = layers.length;
        var j, jLen, k, kLen;
        for(i=0;i<len;i+=1){
            layerData = layers[i];
            if(!('ks' in layerData) || layerData.completed){
                continue;
            }
            layerData.completed = true;
            if(layerData.tt){
                layers[i-1].td = layerData.tt;
            }
            animArray = [];
            lastFrame = -1;
            if(layerData.hasMask){
                var maskProps = layerData.masksProperties;
                jLen = maskProps.length;
                for(j=0;j<jLen;j+=1){
                    if(maskProps[j].pt.k.i){
                        convertPathsToAbsoluteValues(maskProps[j].pt.k);
                    }else{
                        kLen = maskProps[j].pt.k.length;
                        for(k=0;k<kLen;k+=1){
                            if(maskProps[j].pt.k[k].s){
                                convertPathsToAbsoluteValues(maskProps[j].pt.k[k].s[0]);
                            }
                            if(maskProps[j].pt.k[k].e){
                                convertPathsToAbsoluteValues(maskProps[j].pt.k[k].e[0]);
                            }
                        }
                    }
                }
            }
            if(layerData.ty===0){
                layerData.layers = findCompLayers(layerData.refId, comps);
                completeLayers(layerData.layers,comps, fontManager);
            }else if(layerData.ty === 4){
                completeShapes(layerData.shapes);
            }else if(layerData.ty == 5){
                completeText(layerData, fontManager);
            }
        }
    }

    function findCompLayers(id,comps){
        var i = 0, len = comps.length;
        while(i<len){
            if(comps[i].id === id){
                if(!comps[i].layers.__used) {
                    comps[i].layers.__used = true;
                    return comps[i].layers;
                }
                return JSON.parse(JSON.stringify(comps[i].layers));
            }
            i += 1;
        }
    }

    function completeShapes(arr){
        var i, len = arr.length;
        var j, jLen;
        var hasPaths = false;
        for(i=len-1;i>=0;i-=1){
            if(arr[i].ty == 'sh'){
                if(arr[i].ks.k.i){
                    convertPathsToAbsoluteValues(arr[i].ks.k);
                }else{
                    jLen = arr[i].ks.k.length;
                    for(j=0;j<jLen;j+=1){
                        if(arr[i].ks.k[j].s){
                            convertPathsToAbsoluteValues(arr[i].ks.k[j].s[0]);
                        }
                        if(arr[i].ks.k[j].e){
                            convertPathsToAbsoluteValues(arr[i].ks.k[j].e[0]);
                        }
                    }
                }
                hasPaths = true;
            }else if(arr[i].ty == 'gr'){
                completeShapes(arr[i].it);
            }
        }
        /*if(hasPaths){
            //mx: distance
            //ss: sensitivity
            //dc: decay
            arr.splice(arr.length-1,0,{
                "ty": "ms",
                "mx":20,
                "ss":10,
                 "dc":0.001,
                "maxDist":200
            });
        }*/
    }

    function convertPathsToAbsoluteValues(path){
        var i, len = path.i.length;
        for(i=0;i<len;i+=1){
            path.i[i][0] += path.v[i][0];
            path.i[i][1] += path.v[i][1];
            path.o[i][0] += path.v[i][0];
            path.o[i][1] += path.v[i][1];
        }
    }

    function checkVersion(minimum,animVersionString){
        var animVersion = animVersionString ? animVersionString.split('.') : [100,100,100];
        if(minimum[0]>animVersion[0]){
            return true;
        } else if(animVersion[0] > minimum[0]){
            return false;
        }
        if(minimum[1]>animVersion[1]){
            return true;
        } else if(animVersion[1] > minimum[1]){
            return false;
        }
        if(minimum[2]>animVersion[2]){
            return true;
        } else if(animVersion[2] > minimum[2]){
            return false;
        }
    }

    var checkText = (function(){
        var minimumVersion = [4,4,14];

        function updateTextLayer(textLayer){
            var documentData = textLayer.t.d;
            textLayer.t.d = {
                k: [
                    {
                        s:documentData,
                        t:0
                    }
                ]
            }
        }

        function iterateLayers(layers){
            var i, len = layers.length;
            for(i=0;i<len;i+=1){
                if(layers[i].ty === 5){
                    updateTextLayer(layers[i]);
                }
            }
        }

        return function (animationData){
            if(checkVersion(minimumVersion,animationData.v)){
                iterateLayers(animationData.layers);
                if(animationData.assets){
                    var i, len = animationData.assets.length;
                    for(i=0;i<len;i+=1){
                        if(animationData.assets[i].layers){
                            iterateLayers(animationData.assets[i].layers);

                        }
                    }
                }
            }
        }
    }())

    var checkChars = (function() {
        var minimumVersion = [4,7,99];
        return function (animationData){
            if(animationData.chars && !checkVersion(minimumVersion,animationData.v)){
                var i, len = animationData.chars.length, j, jLen, k, kLen;
                var pathData, paths;
                for(i = 0; i < len; i += 1) {
                    if(animationData.chars[i].data && animationData.chars[i].data.shapes) {
                        paths = animationData.chars[i].data.shapes[0].it;
                        jLen = paths.length;

                        for(j = 0; j < jLen; j += 1) {
                            pathData = paths[j].ks.k;
                            if(!pathData.__converted) {
                                convertPathsToAbsoluteValues(paths[j].ks.k);
                                pathData.__converted = true;
                            }
                        }
                    }
                }
            }
        }

    }())

    var checkColors = (function(){
        var minimumVersion = [4,1,9];

        function iterateShapes(shapes){
            var i, len = shapes.length;
            var j, jLen;
            for(i=0;i<len;i+=1){
                if(shapes[i].ty === 'gr'){
                    iterateShapes(shapes[i].it);
                }else if(shapes[i].ty === 'fl' || shapes[i].ty === 'st'){
                    if(shapes[i].c.k && shapes[i].c.k[0].i){
                        jLen = shapes[i].c.k.length;
                        for(j=0;j<jLen;j+=1){
                            if(shapes[i].c.k[j].s){
                                shapes[i].c.k[j].s[0] /= 255;
                                shapes[i].c.k[j].s[1] /= 255;
                                shapes[i].c.k[j].s[2] /= 255;
                                shapes[i].c.k[j].s[3] /= 255;
                            }
                            if(shapes[i].c.k[j].e){
                                shapes[i].c.k[j].e[0] /= 255;
                                shapes[i].c.k[j].e[1] /= 255;
                                shapes[i].c.k[j].e[2] /= 255;
                                shapes[i].c.k[j].e[3] /= 255;
                            }
                        }
                    } else {
                        shapes[i].c.k[0] /= 255;
                        shapes[i].c.k[1] /= 255;
                        shapes[i].c.k[2] /= 255;
                        shapes[i].c.k[3] /= 255;
                    }
                }
            }
        }

        function iterateLayers(layers){
            var i, len = layers.length;
            for(i=0;i<len;i+=1){
                if(layers[i].ty === 4){
                    iterateShapes(layers[i].shapes);
                }
            }
        }

        return function (animationData){
            if(checkVersion(minimumVersion,animationData.v)){
                iterateLayers(animationData.layers);
                if(animationData.assets){
                    var i, len = animationData.assets.length;
                    for(i=0;i<len;i+=1){
                        if(animationData.assets[i].layers){
                            iterateLayers(animationData.assets[i].layers);

                        }
                    }
                }
            }
        }
    }());

    var checkShapes = (function(){
        var minimumVersion = [4,4,18];



        function completeShapes(arr){
            var i, len = arr.length;
            var j, jLen;
            var hasPaths = false;
            for(i=len-1;i>=0;i-=1){
                if(arr[i].ty == 'sh'){
                    if(arr[i].ks.k.i){
                        arr[i].ks.k.c = arr[i].closed;
                    }else{
                        jLen = arr[i].ks.k.length;
                        for(j=0;j<jLen;j+=1){
                            if(arr[i].ks.k[j].s){
                                arr[i].ks.k[j].s[0].c = arr[i].closed;
                            }
                            if(arr[i].ks.k[j].e){
                                arr[i].ks.k[j].e[0].c = arr[i].closed;
                            }
                        }
                    }
                    hasPaths = true;
                }else if(arr[i].ty == 'gr'){
                    completeShapes(arr[i].it);
                }
            }
        }

        function iterateLayers(layers){
            var layerData;
            var i, len = layers.length;
            var j, jLen, k, kLen;
            for(i=0;i<len;i+=1){
                layerData = layers[i];
                if(layerData.hasMask){
                    var maskProps = layerData.masksProperties;
                    jLen = maskProps.length;
                    for(j=0;j<jLen;j+=1){
                        if(maskProps[j].pt.k.i){
                            maskProps[j].pt.k.c = maskProps[j].cl;
                        }else{
                            kLen = maskProps[j].pt.k.length;
                            for(k=0;k<kLen;k+=1){
                                if(maskProps[j].pt.k[k].s){
                                    maskProps[j].pt.k[k].s[0].c = maskProps[j].cl;
                                }
                                if(maskProps[j].pt.k[k].e){
                                    maskProps[j].pt.k[k].e[0].c = maskProps[j].cl;
                                }
                            }
                        }
                    }
                }
                if(layerData.ty === 4){
                    completeShapes(layerData.shapes);
                }
            }
        }

        return function (animationData){
            if(checkVersion(minimumVersion,animationData.v)){
                iterateLayers(animationData.layers);
                if(animationData.assets){
                    var i, len = animationData.assets.length;
                    for(i=0;i<len;i+=1){
                        if(animationData.assets[i].layers){
                            iterateLayers(animationData.assets[i].layers);

                        }
                    }
                }
            }
        }
    }());

    /*function blitPaths(path){
        var i, len = path.i.length;
        for(i=0;i<len;i+=1){
            path.i[i][0] /= blitter;
            path.i[i][1] /= blitter;
            path.o[i][0] /= blitter;
            path.o[i][1] /= blitter;
            path.v[i][0] /= blitter;
            path.v[i][1] /= blitter;
        }
    }

    function blitShapes(arr){
        var i, len = arr.length;
        var j, jLen;
        var hasPaths = false;
        for(i=len-1;i>=0;i-=1){
            if(arr[i].ty == 'sh'){
                if(arr[i].ks.k.i){
                    blitPaths(arr[i].ks.k);
                }else{
                    jLen = arr[i].ks.k.length;
                    for(j=0;j<jLen;j+=1){
                        if(arr[i].ks.k[j].s){
                            blitPaths(arr[i].ks.k[j].s[0]);
                        }
                        if(arr[i].ks.k[j].e){
                            blitPaths(arr[i].ks.k[j].e[0]);
                        }
                    }
                }
                hasPaths = true;
            }else if(arr[i].ty == 'gr'){
                blitShapes(arr[i].it);
            }else if(arr[i].ty == 'rc'){
                blitProperty(arr[i].p);
                blitProperty(arr[i].s);
            }else if(arr[i].ty == 'st'){
                blitProperty(arr[i].w);
            }else if(arr[i].ty == 'tr'){
                blitProperty(arr[i].p);
                blitProperty(arr[i].sk);
                blitProperty(arr[i].a);
            }else if(arr[i].ty == 'el'){
                blitProperty(arr[i].p);
                blitProperty(arr[i].s);
            }else if(arr[i].ty == 'rd'){
                blitProperty(arr[i].r);
            }else{

                //console.log(arr[i].ty );
            }
        }
    }

    function blitText(data, fontManager){

    }

    function blitValue(val){
        if(typeof(val) === 'number'){
            val /= blitter;
        } else {
            var i = val.length-1;
            while(i>=0){
                val[i] /= blitter;
                i-=1;
            }
        }
        return val;
    }

    function blitProperty(data){
        if(!data.k.length){
            data.k = blitValue(data.k);
        }else if(typeof(data.k[0]) === 'number'){
            data.k = blitValue(data.k);
        } else {
            var i, len = data.k.length;
            for(i=0;i<len;i+=1){
                if(data.k[i].s){
                    //console.log('pre S: ', data.k[i].s);
                    data.k[i].s = blitValue(data.k[i].s);
                    //console.log('post S: ', data.k[i].s);
                }
                if(data.k[i].e){
                    //console.log('pre E: ', data.k[i].e);
                    data.k[i].e = blitValue(data.k[i].e);
                    //console.log('post E: ', data.k[i].e);
                }
            }
        }
    }

    function blitLayers(layers,comps, fontManager){
        var layerData;
        var animArray, lastFrame;
        var i, len = layers.length;
        var j, jLen, k, kLen;
        for(i=0;i<len;i+=1){
            layerData = layers[i];
            if(!('ks' in layerData)){
                continue;
            }
            blitProperty(layerData.ks.a);
            blitProperty(layerData.ks.p);
            layerData.completed = true;
            if(layerData.tt){
                layers[i-1].td = layerData.tt;
            }
            animArray = [];
            lastFrame = -1;
            if(layerData.hasMask){
                var maskProps = layerData.masksProperties;
                jLen = maskProps.length;
                for(j=0;j<jLen;j+=1){
                    if(maskProps[j].pt.k.i){
                        blitPaths(maskProps[j].pt.k);
                    }else{
                        kLen = maskProps[j].pt.k.length;
                        for(k=0;k<kLen;k+=1){
                            if(maskProps[j].pt.k[k].s){
                                blitPaths(maskProps[j].pt.k[k].s[0]);
                            }
                            if(maskProps[j].pt.k[k].e){
                                blitPaths(maskProps[j].pt.k[k].e[0]);
                            }
                        }
                    }
                }
            }
            if(layerData.ty===0){
                layerData.w = Math.round(layerData.w/blitter);
                layerData.h = Math.round(layerData.h/blitter);
                blitLayers(layerData.layers,comps, fontManager);
            }else if(layerData.ty === 4){
                blitShapes(layerData.shapes);
            }else if(layerData.ty == 5){
                blitText(layerData, fontManager);
            }else if(layerData.ty == 1){
                layerData.sh /= blitter;
                layerData.sw /= blitter;
            } else {
            }
        }
    }

    function blitAnimation(animationData,comps, fontManager){
        blitLayers(animationData.layers,comps, fontManager);
    }*/

    function completeData(animationData, fontManager){
        if(animationData.__complete){
            return;
        }
        checkColors(animationData);
        checkText(animationData);
        checkChars(animationData);
        checkShapes(animationData);
        completeLayers(animationData.layers, animationData.assets, fontManager);
        animationData.__complete = true;
        //blitAnimation(animationData, animationData.assets, fontManager);
    }

    function completeText(data, fontManager){
        if(data.t.a.length === 0 && !('m' in data.t.p)){
            data.singleShape = true;
        }
    }

    var moduleOb = {};
    moduleOb.completeData = completeData;

    return moduleOb;
}

var dataManager = dataFunctionManager();
var FontManager = (function(){

    var maxWaitingTime = 5000;

    function setUpNode(font, family){
        var parentNode = document.createElement('span');
        parentNode.style.fontFamily    = family;
        var node = document.createElement('span');
        // Characters that vary significantly among different fonts
        node.innerHTML = 'giItT1WQy@!-/#';
        // Visible - so we can measure it - but not on the screen
        parentNode.style.position      = 'absolute';
        parentNode.style.left          = '-10000px';
        parentNode.style.top           = '-10000px';
        // Large font size makes even subtle changes obvious
        parentNode.style.fontSize      = '300px';
        // Reset any font properties
        parentNode.style.fontVariant   = 'normal';
        parentNode.style.fontStyle     = 'normal';
        parentNode.style.fontWeight    = 'normal';
        parentNode.style.letterSpacing = '0';
        parentNode.appendChild(node);
        document.body.appendChild(parentNode);

        // Remember width with no applied web font
        var width = node.offsetWidth;
        node.style.fontFamily = font + ', '+family;
        return {node:node, w:width, parent:parentNode};
    }

    function checkLoadedFonts() {
        var i, len = this.fonts.length;
        var node, w;
        var loadedCount = len;
        for(i=0;i<len; i+= 1){
            if(this.fonts[i].loaded){
                loadedCount -= 1;
                continue;
            }
            if(this.fonts[i].fOrigin === 't' || this.fonts[i].origin === 2){
                if(window.Typekit && window.Typekit.load && this.typekitLoaded === 0){
                    this.typekitLoaded = 1;
                    try{window.Typekit.load({
                        async: true,
                        active: function() {
                            this.typekitLoaded = 2;
                        }.bind(this)
                    });}catch(e){}
                }
                if(this.typekitLoaded === 2) {
                    this.fonts[i].loaded = true;
                }
            } else if(this.fonts[i].fOrigin === 'n' || this.fonts[i].origin === 0){
                this.fonts[i].loaded = true;
            } else{
                node = this.fonts[i].monoCase.node;
                w = this.fonts[i].monoCase.w;
                if(node.offsetWidth !== w){
                    loadedCount -= 1;
                    this.fonts[i].loaded = true;
                }else{
                    node = this.fonts[i].sansCase.node;
                    w = this.fonts[i].sansCase.w;
                    if(node.offsetWidth !== w){
                        loadedCount -= 1;
                        this.fonts[i].loaded = true;
                    }
                }
                if(this.fonts[i].loaded){
                    this.fonts[i].sansCase.parent.parentNode.removeChild(this.fonts[i].sansCase.parent);
                    this.fonts[i].monoCase.parent.parentNode.removeChild(this.fonts[i].monoCase.parent);
                }
            }
        }

        if(loadedCount !== 0 && Date.now() - this.initTime < maxWaitingTime){
            setTimeout(checkLoadedFonts.bind(this),20);
        }else{
            setTimeout(function(){this.loaded = true;}.bind(this),0);

        }
    };

    function createHelper(def, fontData){
        var tHelper = document.createElementNS(svgNS,'text');
        tHelper.style.fontSize = '100px';
        tHelper.style.fontFamily = fontData.fFamily;
        tHelper.textContent = '1';
        if(fontData.fClass){
            tHelper.style.fontFamily = 'inherit';
            tHelper.className = fontData.fClass;
        } else {
            tHelper.style.fontFamily = fontData.fFamily;
        }
        def.appendChild(tHelper);
        var tCanvasHelper = document.createElement('canvas').getContext('2d');
        tCanvasHelper.font = '100px '+ fontData.fFamily;
        return tCanvasHelper;
    }

    function addFonts(fontData, defs){
        if(!fontData){
            this.loaded = true;
            return;
        }
        if(this.chars){
            this.loaded = true;
            this.fonts = fontData.list;
            return;
        }

        var fontArr = fontData.list;
        var i, len = fontArr.length;
        for(i=0; i<len; i+= 1){
            fontArr[i].loaded = false;
            fontArr[i].monoCase = setUpNode(fontArr[i].fFamily,'monospace');
            fontArr[i].sansCase = setUpNode(fontArr[i].fFamily,'sans-serif');
            if(!fontArr[i].fPath) {
                fontArr[i].loaded = true;
            }else if(fontArr[i].fOrigin === 'p' || fontArr[i].origin === 3){
                var s = document.createElement('style');
                s.type = "text/css";
                s.innerHTML = "@font-face {" + "font-family: "+fontArr[i].fFamily+"; font-style: normal; src: url('"+fontArr[i].fPath+"');}";
                defs.appendChild(s);
            } else if(fontArr[i].fOrigin === 'g' || fontArr[i].origin === 1){
                //<link href='https://fonts.googleapis.com/css?family=Montserrat' rel='stylesheet' type='text/css'>
                var l = document.createElement('link');
                l.type = "text/css";
                l.rel = "stylesheet";
                l.href = fontArr[i].fPath;
                defs.appendChild(l);
            } else if(fontArr[i].fOrigin === 't' || fontArr[i].origin === 2){
                //<link href='https://fonts.googleapis.com/css?family=Montserrat' rel='stylesheet' type='text/css'>
                var sc = document.createElement('script');
                sc.setAttribute('src',fontArr[i].fPath);
                defs.appendChild(sc);
            }
            fontArr[i].helper = createHelper(defs,fontArr[i]);
            this.fonts.push(fontArr[i]);
        }
        checkLoadedFonts.bind(this)();
    }

    function addChars(chars){
        if(!chars){
            return;
        }
        if(!this.chars){
            this.chars = [];
        }
        var i, len = chars.length;
        var j, jLen = this.chars.length, found;
        for(i=0;i<len;i+=1){
            j = 0;
            found = false;
            while(j<jLen){
                if(this.chars[j].style === chars[i].style && this.chars[j].fFamily === chars[i].fFamily && this.chars[j].ch === chars[i].ch){
                    found = true;
                }
                j += 1;
            }
            if(!found){
                this.chars.push(chars[i]);
                jLen += 1;
            }
        }
    }

    function getCharData(char, style, font){
        var i = 0, len = this.chars.length;
        while( i < len) {
            if(this.chars[i].ch === char && this.chars[i].style === style && this.chars[i].fFamily === font){
                return this.chars[i];
            }
            i+= 1;
        }
    }

    function measureText(char, fontName, size){
        var fontData = this.getFontByName(fontName);
        var tHelper = fontData.helper;
        //tHelper.textContent = char;
        return tHelper.measureText(char).width*size/100;
        //return tHelper.getComputedTextLength()*size/100;
    }

    function getFontByName(name){
        var i = 0, len = this.fonts.length;
        while(i<len){
            if(this.fonts[i].fName === name) {
                return this.fonts[i];
            }
            i += 1;
        }
        return 'sans-serif';
    }

    var Font = function(){
        this.fonts = [];
        this.chars = null;
        this.typekitLoaded = 0;
        this.loaded = false;
        this.initTime = Date.now();
    };
    Font.prototype.addChars = addChars;
    Font.prototype.addFonts = addFonts;
    Font.prototype.getCharData = getCharData;
    Font.prototype.getFontByName = getFontByName;
    Font.prototype.measureText = measureText;

    return Font;

}());
var PropertyFactory = (function(){

    var initFrame = -999999;

    function interpolateValue(frameNum, iterationIndex, previousValue, caching){
        var offsetTime = this.offsetTime;
        var newValue;
        if(previousValue.constructor === Array) {
            newValue = Array.apply(null,{length:previousValue.length})
        }
        var i = iterationIndex;
        var len = this.keyframes.length- 1,flag = true;
        var keyData, nextKeyData;

        while(flag){
            keyData = this.keyframes[i];
            nextKeyData = this.keyframes[i+1];
            if(i == len-1 && frameNum >= nextKeyData.t - offsetTime){
                if(keyData.h){
                    keyData = nextKeyData;
                }
                iterationIndex = 0;
                break;
            }
            if((nextKeyData.t - offsetTime) > frameNum){
                iterationIndex = i;
                break;
            }
            if(i < len - 1){
                i += 1;
            }else{
                iterationIndex = 0;
                flag = false;
            }
        }

        var k, kLen,perc,jLen, j, fnc;
        if(keyData.to){

            if(!keyData.bezierData){
                bez.buildBezierData(keyData);
            }
            var bezierData = keyData.bezierData;
            if(frameNum >= nextKeyData.t-offsetTime || frameNum < keyData.t-offsetTime){
                var ind = frameNum >= nextKeyData.t-offsetTime ? bezierData.points.length - 1 : 0;
                kLen = bezierData.points[ind].point.length;
                for(k = 0; k < kLen; k += 1){
                    newValue[k] = bezierData.points[ind].point[k];
                }
                caching._lastBezierData = null;
            }else{
                if(keyData.__fnct){
                    fnc = keyData.__fnct;
                }else{
                    fnc = BezierFactory.getBezierEasing(keyData.o.x,keyData.o.y,keyData.i.x,keyData.i.y,keyData.n).get;
                    keyData.__fnct = fnc;
                }
                perc = fnc((frameNum-(keyData.t-offsetTime))/((nextKeyData.t-offsetTime)-(keyData.t-offsetTime)));
                var distanceInLine = bezierData.segmentLength*perc;

                var segmentPerc;
                var addedLength =  (caching.lastFrame < frameNum && caching._lastBezierData === bezierData) ? caching._lastAddedLength : 0;
                j =  (caching.lastFrame < frameNum && caching._lastBezierData === bezierData) ? caching._lastPoint : 0;
                flag = true;
                jLen = bezierData.points.length;
                while(flag){
                    addedLength +=bezierData.points[j].partialLength;
                    if(distanceInLine === 0 || perc === 0 || j == bezierData.points.length - 1){
                        kLen = bezierData.points[j].point.length;
                        for(k=0;k<kLen;k+=1){
                            newValue[k] = bezierData.points[j].point[k];
                        }
                        break;
                    }else if(distanceInLine >= addedLength && distanceInLine < addedLength + bezierData.points[j+1].partialLength){
                        segmentPerc = (distanceInLine-addedLength)/(bezierData.points[j+1].partialLength);
                        kLen = bezierData.points[j].point.length;
                        for(k=0;k<kLen;k+=1){
                            newValue[k] = bezierData.points[j].point[k] + (bezierData.points[j+1].point[k] - bezierData.points[j].point[k])*segmentPerc;
                        }
                        break;
                    }
                    if(j < jLen - 1){
                        j += 1;
                    }else{
                        flag = false;
                    }
                }
                caching._lastPoint = j;
                caching._lastAddedLength = addedLength - bezierData.points[j].partialLength;
                caching._lastBezierData = bezierData;
            }
        }else{
            var outX,outY,inX,inY, keyValue;
            len = keyData.s.length;
            for(i=0;i<len;i+=1){
                if(keyData.h !== 1){
                    if(frameNum >= nextKeyData.t-offsetTime){
                        perc = 1;
                    }else if(frameNum < keyData.t-offsetTime){
                        perc = 0;
                    }else{
                        if(keyData.o.x.constructor === Array){
                            if(!keyData.__fnct){
                                keyData.__fnct = [];
                            }
                            if (!keyData.__fnct[i]) {
                                outX = keyData.o.x[i] || keyData.o.x[0];
                                outY = keyData.o.y[i] || keyData.o.y[0];
                                inX = keyData.i.x[i] || keyData.i.x[0];
                                inY = keyData.i.y[i] || keyData.i.y[0];
                                fnc = BezierFactory.getBezierEasing(outX,outY,inX,inY).get;
                                keyData.__fnct[i] = fnc;
                            } else {
                                fnc = keyData.__fnct[i];
                            }
                        } else {
                            if (!keyData.__fnct) {
                                outX = keyData.o.x;
                                outY = keyData.o.y;
                                inX = keyData.i.x;
                                inY = keyData.i.y;
                                fnc = BezierFactory.getBezierEasing(outX,outY,inX,inY).get;
                                keyData.__fnct = fnc;
                            } else{
                                fnc = keyData.__fnct;
                            }
                        }
                        perc = fnc((frameNum-(keyData.t-offsetTime))/((nextKeyData.t-offsetTime)-(keyData.t-offsetTime)));
                    }
                }
                if(this.sh && keyData.h !== 1){
                    var initP = keyData.s[i];
                    var endP = keyData.e[i];
                    if(initP-endP < -180){
                        initP += 360;
                    } else if(initP-endP > 180){
                        initP -= 360;
                    }
                    keyValue = initP+(endP-initP)*perc;
                } else {
                    keyValue = keyData.h === 1 ? keyData.s[i] : keyData.s[i]+(keyData.e[i]-keyData.s[i])*perc;
                }
                if(len === 1){
                    newValue = keyValue;
                }else{
                    newValue[i] = keyValue;
                }
            }
        }
        return {
            value: newValue,
            iterationIndex: iterationIndex
        }
    }

    function getValueAtCurrentTime(){
        if(this.elem.globalData.frameId === this.frameId){
            return;
        }
        this.mdf = false;
        var frameNum = this.comp.renderedFrame - this.offsetTime;
        var initTime = this.keyframes[0].t-this.offsetTime;
        var endTime = this.keyframes[this.keyframes.length- 1].t-this.offsetTime;
        if(!(frameNum === this._caching.lastFrame || (this._caching.lastFrame !== initFrame && ((this._caching.lastFrame >= endTime && frameNum >= endTime) || (this._caching.lastFrame < initTime && frameNum < initTime))))){
            var i = this._caching.lastFrame < frameNum ? this._caching.lastIndex : 0;
            var renderResult = this.interpolateValue(frameNum, i, this.pv, this._caching);
            this._caching.lastIndex = renderResult.iterationIndex;
            if(this.pv.constructor === Array){
                i = 0;
                while(i<this.v.length){
                    this.pv[i] = renderResult.value[i];
                    this.v[i] = this.mult ? this.pv[i] * this.mult : this.pv[i];
                    if(this.lastPValue[i] !== this.pv[i]) {
                        this.mdf = true;
                        this.lastPValue[i] = this.pv[i];
                    }
                    i += 1;
                }
            } else {
                this.pv = renderResult.value;
                this.v = this.mult ? this.pv*this.mult : this.pv;
                if(this.lastPValue != this.pv){
                    this.mdf = true;
                    this.lastPValue = this.pv;
                }
            }
            
        }
        this._caching.lastFrame = frameNum;
        this.frameId = this.elem.globalData.frameId;
    }

    function getNoValue(){}

    function ValueProperty(elem,data, mult){
        this.mult = mult;
        this.v = mult ? data.k * mult : data.k;
        this.pv = data.k;
        this.mdf = false;
        this.comp = elem.comp;
        this.k = false;
        this.kf = false;
        this.vel = 0;
        this.getValue = getNoValue;
    }

    function MultiDimensionalProperty(elem,data, mult){
        this.mult = mult;
        this.data = data;
        this.mdf = false;
        this.comp = elem.comp;
        this.k = false;
        this.kf = false;
        this.frameId = -1;
        this.v = Array.apply(null, {length:data.k.length});
        this.pv = Array.apply(null, {length:data.k.length});
        this.lastValue = Array.apply(null, {length:data.k.length});
        var arr = Array.apply(null, {length:data.k.length});
        this.vel = arr.map(function () { return 0 });
        var i, len = data.k.length;
        for(i = 0;i<len;i+=1){
            this.v[i] = mult ? data.k[i] * mult : data.k[i];
            this.pv[i] = data.k[i];
        }
        this.getValue = getNoValue;
    }

    function KeyframedValueProperty(elem, data, mult){
        this.keyframes = data.k;
        this.offsetTime = elem.data.st;
        this.lastValue = -99999;
        this.lastPValue = -99999;
        this.frameId = -1;
        this._caching={lastFrame:initFrame,lastIndex:0};
        this.k = true;
        this.kf = true;
        this.data = data;
        this.mult = mult;
        this.elem = elem;
        this.comp = elem.comp;
        this.v = mult ? data.k[0].s[0]*mult : data.k[0].s[0];
        this.pv = data.k[0].s[0];
        this.getValue = getValueAtCurrentTime;
        this.interpolateValue = interpolateValue;
    }

    function KeyframedMultidimensionalProperty(elem, data, mult){
        var i, len = data.k.length;
        var s, e,to,ti;
        for(i=0;i<len-1;i+=1){
            if(data.k[i].to && data.k[i].s && data.k[i].e){
                s = data.k[i].s;
                e = data.k[i].e;
                to = data.k[i].to;
                ti = data.k[i].ti;
                if((s.length === 2 && !(s[0] === e[0] && s[1] === e[1]) && bez.pointOnLine2D(s[0],s[1],e[0],e[1],s[0] + to[0],s[1] + to[1]) && bez.pointOnLine2D(s[0],s[1],e[0],e[1],e[0] + ti[0],e[1] + ti[1])) || (s.length === 3 && !(s[0] === e[0] && s[1] === e[1] && s[2] === e[2]) && bez.pointOnLine3D(s[0],s[1],s[2],e[0],e[1],e[2],s[0] + to[0],s[1] + to[1],s[2] + to[2]) && bez.pointOnLine3D(s[0],s[1],s[2],e[0],e[1],e[2],e[0] + ti[0],e[1] + ti[1],e[2] + ti[2]))){
                    data.k[i].to = null;
                    data.k[i].ti = null;
                }
            }
        }
        this.keyframes = data.k;
        this.offsetTime = elem.data.st;
        this.k = true;
        this.kf = true;
        this.mult = mult;
        this.elem = elem;
        this.comp = elem.comp;
        this._caching={lastFrame:initFrame,lastIndex:0};
        this.getValue = getValueAtCurrentTime;
        this.interpolateValue = interpolateValue;
        this.frameId = -1;
        this.v = Array.apply(null, {length:data.k[0].s.length});
        this.pv = Array.apply(null, {length:data.k[0].s.length});
        this.lastValue = Array.apply(null, {length:data.k[0].s.length});
        this.lastPValue = Array.apply(null, {length:data.k[0].s.length});
    }

    var TransformProperty = (function() {
        function positionGetter() {
            if(this.p) {
                return ExpressionValue(this.p);
            } else {
                return [this.px.v, this.py.v, this.pz ? this.pz.v : 0];
            }
        }
        function xPositionGetter() {
            return ExpressionValue(this.px);
        }
        function yPositionGetter() {
            return ExpressionValue(this.py);
        }
        function zPositionGetter() {
            return ExpressionValue(this.pz);
        }
        function anchorGetter() {
            return ExpressionValue(this.a);
        }
        function orientationGetter() {
            return ExpressionValue(this.or);
        }
        function rotationGetter() {
            if(this.r) {
                return ExpressionValue(this.r, 1/degToRads);
            } else {
                return ExpressionValue(this.rz, 1/degToRads);
            }
        }
        function scaleGetter() {
            return ExpressionValue(this.s, 100);
        }
        function opacityGetter() {
            return ExpressionValue(this.o, 100);
        }
        function skewGetter() {
            return ExpressionValue(this.sk);
        }
        function skewAxisGetter() {
            return ExpressionValue(this.sa);
        }
        function applyToMatrix(mat) {
            var i, len = this.dynamicProperties.length;
            for(i = 0; i < len; i += 1) {
                this.dynamicProperties[i].getValue();
                if (this.dynamicProperties[i].mdf) {
                    this.mdf = true;
                }
            }
            if (this.a) {
                mat.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]);
            }
            if (this.s) {
                mat.scale(this.s.v[0], this.s.v[1], this.s.v[2]);
            }
            if (this.r) {
                mat.rotate(-this.r.v);
            } else {
                mat.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]);
            }
            if (this.data.p.s) {
                if (this.data.p.z) {
                    mat.translate(this.px.v, this.py.v, -this.pz.v);
                } else {
                    mat.translate(this.px.v, this.py.v, 0);
                }
            } else {
                mat.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
            }
        }
        function processKeys(){
            if (this.elem.globalData.frameId === this.frameId) {
                return;
            }

            this.mdf = false;
            var i, len = this.dynamicProperties.length;

            for(i = 0; i < len; i += 1) {
                this.dynamicProperties[i].getValue();
                if (this.dynamicProperties[i].mdf) {
                    this.mdf = true;
                }
            }
            if (this.mdf) {
                this.v.reset();
                if (this.a) {
                    this.v.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]);
                }
                if(this.s) {
                    this.v.scale(this.s.v[0], this.s.v[1], this.s.v[2]);
                }
                if (this.sk) {
                    this.v.skewFromAxis(-this.sk.v, this.sa.v);
                }
                if (this.r) {
                    this.v.rotate(-this.r.v);
                } else {
                    this.v.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]);
                }
                if (this.autoOriented && this.p.keyframes && this.p.getValueAtTime) {
                    var v1,v2;
                    if (this.p._caching.lastFrame+this.p.offsetTime <= this.p.keyframes[0].t) {
                        v1 = this.p.getValueAtTime((this.p.keyframes[0].t + 0.01) / this.elem.globalData.frameRate,0);
                        v2 = this.p.getValueAtTime(this.p.keyframes[0].t / this.elem.globalData.frameRate, 0);
                    } else if(this.p._caching.lastFrame+this.p.offsetTime >= this.p.keyframes[this.p.keyframes.length - 1].t) {
                        v1 = this.p.getValueAtTime((this.p.keyframes[this.p.keyframes.length - 1].t / this.elem.globalData.frameRate), 0);
                        v2 = this.p.getValueAtTime((this.p.keyframes[this.p.keyframes.length - 1].t - 0.01) / this.elem.globalData.frameRate, 0);
                    } else {
                        v1 = this.p.pv;
                        v2 = this.p.getValueAtTime((this.p._caching.lastFrame+this.p.offsetTime - 0.01) / this.elem.globalData.frameRate, this.p.offsetTime);
                    }
                    this.v.rotate(-Math.atan2(v1[1] - v2[1], v1[0] - v2[0]));
                }
                if(this.data.p.s){
                    if(this.data.p.z) {
                        this.v.translate(this.px.v, this.py.v, -this.pz.v);
                    } else {
                        this.v.translate(this.px.v, this.py.v, 0);
                    }
                }else{
                    this.v.translate(this.p.v[0],this.p.v[1],-this.p.v[2]);
                }
            }
            this.frameId = this.elem.globalData.frameId;
        }

        function setInverted(){
            this.inverted = true;
            this.iv = new Matrix();
            if(!this.k){
                if(this.data.p.s){
                    this.iv.translate(this.px.v,this.py.v,-this.pz.v);
                }else{
                    this.iv.translate(this.p.v[0],this.p.v[1],-this.p.v[2]);
                }
                if(this.r){
                    this.iv.rotate(-this.r.v);
                }else{
                    this.iv.rotateX(-this.rx.v).rotateY(-this.ry.v).rotateZ(this.rz.v);
                }
                if(this.s){
                    this.iv.scale(this.s.v[0],this.s.v[1],1);
                }
                if(this.a){
                    this.iv.translate(-this.a.v[0],-this.a.v[1],this.a.v[2]);
                }
            }
        }

        function autoOrient(){
            //
            //var prevP = this.getValueAtTime();
        }

        return function TransformProperty(elem,data,arr){
            this.elem = elem;
            this.frameId = -1;
            this.type = 'transform';
            this.dynamicProperties = [];
            this.mdf = false;
            this.data = data;
            this.getValue = processKeys;
            this.applyToMatrix = applyToMatrix;
            this.setInverted = setInverted;
            this.autoOrient = autoOrient;
            this.v = new Matrix();
            if(data.p.s){
                this.px = PropertyFactory.getProp(elem,data.p.x,0,0,this.dynamicProperties);
                this.py = PropertyFactory.getProp(elem,data.p.y,0,0,this.dynamicProperties);
                if(data.p.z){
                    this.pz = PropertyFactory.getProp(elem,data.p.z,0,0,this.dynamicProperties);
                }
            }else{
                this.p = PropertyFactory.getProp(elem,data.p,1,0,this.dynamicProperties);
            }
            if(data.r) {
                this.r = PropertyFactory.getProp(elem, data.r, 0, degToRads, this.dynamicProperties);
            } else if(data.rx) {
                this.rx = PropertyFactory.getProp(elem, data.rx, 0, degToRads, this.dynamicProperties);
                this.ry = PropertyFactory.getProp(elem, data.ry, 0, degToRads, this.dynamicProperties);
                this.rz = PropertyFactory.getProp(elem, data.rz, 0, degToRads, this.dynamicProperties);
                this.or = PropertyFactory.getProp(elem, data.or, 1, degToRads, this.dynamicProperties);
                //sh Indicates it needs to be capped between -180 and 180
                this.or.sh = true;
            }
            if(data.sk){
                this.sk = PropertyFactory.getProp(elem, data.sk, 0, degToRads, this.dynamicProperties);
                this.sa = PropertyFactory.getProp(elem, data.sa, 0, degToRads, this.dynamicProperties);
            }
            if(data.a) {
                this.a = PropertyFactory.getProp(elem,data.a,1,0,this.dynamicProperties);
            }
            if(data.s) {
                this.s = PropertyFactory.getProp(elem,data.s,1,0.01,this.dynamicProperties);
            }
            if(data.o){
                this.o = PropertyFactory.getProp(elem,data.o,0,0.01,this.dynamicProperties);
            } else {
                this.o = {mdf:false,v:1};
            }
            if(this.dynamicProperties.length){
                arr.push(this);
            }else{
                if(this.a){
                    this.v.translate(-this.a.v[0],-this.a.v[1],this.a.v[2]);
                }
                if(this.s){
                    this.v.scale(this.s.v[0],this.s.v[1],this.s.v[2]);
                }
                if(this.sk){
                    this.v.skewFromAxis(-this.sk.v,this.sa.v);
                }
                if(this.r){
                    this.v.rotate(-this.r.v);
                }else{
                    this.v.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]);
                }
                if(this.data.p.s){
                    if(data.p.z) {
                        this.v.translate(this.px.v, this.py.v, -this.pz.v);
                    } else {
                        this.v.translate(this.px.v, this.py.v, 0);
                    }
                }else{
                    this.v.translate(this.p.v[0],this.p.v[1],-this.p.v[2]);
                }
            }
            Object.defineProperty(this, "position", { get: positionGetter});
            Object.defineProperty(this, "xPosition", { get: xPositionGetter});
            Object.defineProperty(this, "yPosition", { get: yPositionGetter});
            Object.defineProperty(this, "orientation", { get: orientationGetter});
            Object.defineProperty(this, "anchorPoint", { get: anchorGetter});
            Object.defineProperty(this, "rotation", { get: rotationGetter});
            Object.defineProperty(this, "scale", { get: scaleGetter});
            Object.defineProperty(this, "opacity", { get: opacityGetter});
            Object.defineProperty(this, "skew", { get: skewGetter});
            Object.defineProperty(this, "skewAxis", { get: skewAxisGetter});
        }
    }());

    function getProp(elem,data,type, mult, arr) {
        var p;
        if(type === 2){
            p = new TransformProperty(elem, data, arr);
        } else if(data.a === 0){
            if(type === 0) {
                p = new ValueProperty(elem,data,mult);
            } else {
                p = new MultiDimensionalProperty(elem,data, mult);
            }
        } else if(data.a === 1){
            if(type === 0) {
                p = new KeyframedValueProperty(elem,data,mult);
            } else {
                p = new KeyframedMultidimensionalProperty(elem,data, mult);
            }
        } else if(!data.k.length){
            p = new ValueProperty(elem,data, mult);
        }else if(typeof(data.k[0]) === 'number'){
            p = new MultiDimensionalProperty(elem,data, mult);
        }else{
            switch(type){
                case 0:
                    p = new KeyframedValueProperty(elem,data,mult);
                    break;
                case 1:
                    p = new KeyframedMultidimensionalProperty(elem,data,mult);
                    break;
            }
        }
        if(p.k){
            arr.push(p);
        }
        return p;
    }

    var getGradientProp = (function(){

        function getValue(forceRender){
            this.prop.getValue();
            this.cmdf = false;
            this.omdf = false;
            if(this.prop.mdf || forceRender){
                var i, len = this.data.p*4;
                var mult, val;
                for(i=0;i<len;i+=1){
                    mult = i%4 === 0 ? 100 : 255;
                    val = Math.round(this.prop.v[i]*mult);
                    if(this.c[i] !== val){
                        this.c[i] = val;
                        this.cmdf = true;
                    }
                }
                if(this.o.length){
                    len = this.prop.v.length;
                    for(i=this.data.p*4;i<len;i+=1){
                        mult = i%2 === 0 ? 100 : 1;
                        val = i%2 === 0 ?  Math.round(this.prop.v[i]*100):this.prop.v[i];
                        if(this.o[i-this.data.p*4] !== val){
                            this.o[i-this.data.p*4] = val;
                            this.omdf = true;
                        }
                    }
                }
            }

        }

        function gradientProp(elem,data,arr){
            this.prop = getProp(elem,data.k,1,null,[]);
            this.data = data;
            this.k = this.prop.k;
            this.c = Array.apply(null,{length:data.p*4});
            var cLength = data.k.k[0].s ? (data.k.k[0].s.length - data.p*4) : data.k.k.length - data.p*4;
            this.o = Array.apply(null,{length:cLength});
            this.cmdf = false;
            this.omdf = false;
            this.getValue = getValue;
            if(this.prop.k){
                arr.push(this);
            }
            this.getValue(true);
        }

        return function getGradientProp(elem,data,arr){
            return new gradientProp(elem,data,arr);
        }
    }());




    var DashProperty = (function(){

        function processKeys(forceRender){
            var i = 0, len = this.dataProps.length;

            if(this.elem.globalData.frameId === this.frameId && !forceRender){
                return;
            }
            this.mdf = false;
            this.frameId = this.elem.globalData.frameId;
            while(i<len){
                if(this.dataProps[i].p.mdf){
                    this.mdf = true;
                    break;
                }
                i+=1;
            }
            if(this.mdf || forceRender){
                if(this.renderer === 'svg') {
                    this.dasharray = '';
                }
                for(i=0;i<len;i+=1){
                    if(this.dataProps[i].n != 'o'){
                        if(this.renderer === 'svg') {
                            this.dasharray += ' ' + this.dataProps[i].p.v;
                        }else{
                            this.dasharray[i] = this.dataProps[i].p.v;
                        }
                    }else{
                        this.dashoffset = this.dataProps[i].p.v;
                    }
                }
            }
        }

        return function(elem, data,renderer, dynamicProperties){
            this.elem = elem;
            this.frameId = -1;
            this.dataProps = new Array(data.length);
            this.renderer = renderer;
            this.mdf = false;
            this.k = false;
            if(this.renderer === 'svg'){
                this.dasharray = '';
            }else{

                this.dasharray = new Array(data.length - 1);
            }
            this.dashoffset = 0;
            var i, len = data.length, prop;
            for(i=0;i<len;i+=1){
                prop = PropertyFactory.getProp(elem,data[i].v,0, 0, dynamicProperties);
                this.k = prop.k ? true : this.k;
                this.dataProps[i] = {n:data[i].n,p:prop};
            }
            this.getValue = processKeys;
            if(this.k){
                dynamicProperties.push(this);
            }else{
                this.getValue(true);
            }

        }
    }());

    function getDashProp(elem, data,renderer, dynamicProperties) {
        return new DashProperty(elem, data,renderer, dynamicProperties);
    };

    var TextSelectorProp = (function(){
        var max = Math.max;
        var min = Math.min;
        var floor = Math.floor;
        function updateRange(newCharsFlag){
            this.mdf = newCharsFlag || false;
            if(this.dynamicProperties.length){
                var i, len = this.dynamicProperties.length;
                for(i=0;i<len;i+=1){
                    this.dynamicProperties[i].getValue();
                    if(this.dynamicProperties[i].mdf){
                        this.mdf = true;
                    }
                }
            }
            var totalChars = this.elem.textProperty.currentData ? this.elem.textProperty.currentData.l.length : 0;
            if(newCharsFlag && this.data.r === 2) {
                this.e.v = totalChars;
            }
            var divisor = this.data.r === 2 ? 1 : 100 / totalChars;
            var o = this.o.v/divisor;
            var s = this.s.v/divisor + o;
            var e = (this.e.v/divisor) + o;
            if(s>e){
                var _s = s;
                s = e;
                e = _s;
            }
            this.finalS = s;
            this.finalE = e;
        }

        function getMult(ind){
            //var easer = bez.getEasingCurve(this.ne.v/100,0,1-this.xe.v/100,1);
            var easer = BezierFactory.getBezierEasing(this.ne.v/100,0,1-this.xe.v/100,1).get;
            var mult = 0;
            var s = this.finalS;
            var e = this.finalE;
            var type = this.data.sh;
            if(type == 2){
                if(e === s){
                    mult = ind >= e ? 1 : 0;
                }else{
                    mult = max(0,min(0.5/(e-s) + (ind-s)/(e-s),1));
                }
                mult = easer(mult);
            }else if(type == 3){
                if(e === s){
                    mult = ind >= e ? 0 : 1;
                }else{
                    mult = 1 - max(0,min(0.5/(e-s) + (ind-s)/(e-s),1));
                }

                mult = easer(mult);
            }else if(type == 4){
                if(e === s){
                    mult = 0;
                }else{
                    mult = max(0,min(0.5/(e-s) + (ind-s)/(e-s),1));
                    if(mult<.5){
                        mult *= 2;
                    }else{
                        mult = 1 - 2*(mult-0.5);
                    }
                }
                mult = easer(mult);
            }else if(type == 5){
                if(e === s){
                    mult = 0;
                }else{
                    var tot = e - s;
                    /*ind += 0.5;
                    mult = -4/(tot*tot)*(ind*ind)+(4/tot)*ind;*/
                    ind = min(max(0,ind+0.5-s),e-s);
                    var x = -tot/2+ind;
                    var a = tot/2;
                    mult = Math.sqrt(1 - (x*x)/(a*a));
                }
                mult = easer(mult);
            }else if(type == 6){
                if(e === s){
                    mult = 0;
                }else{
                    ind = min(max(0,ind+0.5-s),e-s);
                    mult = (1+(Math.cos((Math.PI+Math.PI*2*(ind)/(e-s)))))/2;
                    /*
                     ind = Math.min(Math.max(s,ind),e-1);
                     mult = (1+(Math.cos((Math.PI+Math.PI*2*(ind-s)/(e-1-s)))))/2;
                     mult = Math.max(mult,(1/(e-1-s))/(e-1-s));*/
                }
                mult = easer(mult);
            }else {
                if(ind >= floor(s)){
                    if(ind-s < 0){
                        mult = 1 - (s - ind);
                    }else{
                        mult = max(0,min(e-ind,1));
                    }
                }
                mult = easer(mult);
            }
            return mult*this.a.v;
        }

        return function TextSelectorProp(elem,data, arr){
            this.mdf = false;
            this.k = false;
            this.data = data;
            this.dynamicProperties = [];
            this.getValue = updateRange;
            this.getMult = getMult;
            this.elem = elem;
            this.comp = elem.comp;
            this.finalS = 0;
            this.finalE = 0;
            this.s = PropertyFactory.getProp(elem,data.s || {k:0},0,0,this.dynamicProperties);
            if('e' in data){
                this.e = PropertyFactory.getProp(elem,data.e,0,0,this.dynamicProperties);
            }else{
                this.e = {v:100};
            }
            this.o = PropertyFactory.getProp(elem,data.o || {k:0},0,0,this.dynamicProperties);
            this.xe = PropertyFactory.getProp(elem,data.xe || {k:0},0,0,this.dynamicProperties);
            this.ne = PropertyFactory.getProp(elem,data.ne || {k:0},0,0,this.dynamicProperties);
            this.a = PropertyFactory.getProp(elem,data.a,0,0.01,this.dynamicProperties);
            if(this.dynamicProperties.length){
                arr.push(this);
            }else{
                this.getValue();
            }
        }
    }());

    function getTextSelectorProp(elem, data,arr) {
        return new TextSelectorProp(elem, data, arr);
    };

    var ob = {
        getProp: getProp,
        getDashProp: getDashProp,
        getTextSelectorProp: getTextSelectorProp,
        getGradientProp: getGradientProp
    };
    return ob;
}());
function ShapePath(){
	this.c = false;
	this._length = 0;
	this._maxLength = 8;
	this.v = Array.apply(null,{length:this._maxLength});
	this.o = Array.apply(null,{length:this._maxLength});
	this.i = Array.apply(null,{length:this._maxLength});
};

ShapePath.prototype.setPathData = function(closed, len) {
	this.c = closed;
	this.setLength(len);
	var i = 0;
	while(i < len){
		this.v[i] = point_pool.newPoint();
		this.o[i] = point_pool.newPoint();
		this.i[i] = point_pool.newPoint();
		i += 1;
	}
};

ShapePath.prototype.setLength = function(len) {
	while(this._maxLength < len) {
		this.doubleArrayLength();
	}
	this._length = len;
}

ShapePath.prototype.doubleArrayLength = function() {
	this.v = this.v.concat(Array.apply(null,{length:this._maxLength}))
	this.i = this.i.concat(Array.apply(null,{length:this._maxLength}))
	this.o = this.o.concat(Array.apply(null,{length:this._maxLength}))
	this._maxLength *= 2;
};

ShapePath.prototype.setXYAt = function(x, y, type, pos, replace) {
	var arr;
	this._length = Math.max(this._length, pos + 1);
	if(this._length >= this._maxLength) {
		this.doubleArrayLength();
	}
	switch(type){
		case 'v':
			arr = this.v;
			break;
		case 'i':
			arr = this.i;
			break;
		case 'o':
			arr = this.o;
			break;
	}
	if(!arr[pos] || (arr[pos] && !replace)){
		arr[pos] = point_pool.newPoint();
	}
	arr[pos][0] = x;
	arr[pos][1] = y;
};

ShapePath.prototype.setTripleAt = function(vX,vY,oX,oY,iX,iY,pos, replace) {
	this.setXYAt(vX,vY,'v',pos, replace);
	this.setXYAt(oX,oY,'o',pos, replace);
	this.setXYAt(iX,iY,'i',pos, replace);
};
var ShapePropertyFactory = (function(){

    var initFrame = -999999;

    function interpolateShape(frameNum, iterationIndex, previousValue, isCurrentRender) {
        var keyPropS,keyPropE,isHold;
        if(frameNum < this.keyframes[0].t-this.offsetTime){
            keyPropS = this.keyframes[0].s[0];
            isHold = true;
            iterationIndex = 0;
        }else if(frameNum >= this.keyframes[this.keyframes.length - 1].t-this.offsetTime){
            if(this.keyframes[this.keyframes.length - 2].h === 1){
                keyPropS = this.keyframes[this.keyframes.length - 1].s[0];
            }else{
                keyPropS = this.keyframes[this.keyframes.length - 2].e[0];
            }
            isHold = true;
        }else{
            var i = iterationIndex;
            var len = this.keyframes.length- 1,flag = true,keyData,nextKeyData, j, jLen, k, kLen;
            while(flag){
                keyData = this.keyframes[i];
                nextKeyData = this.keyframes[i+1];
                if((nextKeyData.t - this.offsetTime) > frameNum){
                    break;
                }
                if(i < len - 1){
                    i += 1;
                }else{
                    flag = false;
                }
            }
            isHold = keyData.h === 1;
            iterationIndex = i;

            var perc;
            if(!isHold){
                if(frameNum >= nextKeyData.t-this.offsetTime){
                    perc = 1;
                }else if(frameNum < keyData.t-this.offsetTime){
                    perc = 0;
                }else{
                    var fnc;
                    if(keyData.__fnct){
                        fnc = keyData.__fnct;
                    }else{
                        fnc = BezierFactory.getBezierEasing(keyData.o.x,keyData.o.y,keyData.i.x,keyData.i.y).get;
                        keyData.__fnct = fnc;
                    }
                    perc = fnc((frameNum-(keyData.t-this.offsetTime))/((nextKeyData.t-this.offsetTime)-(keyData.t-this.offsetTime)));
                }
                keyPropE = keyData.e[0];
            }
            keyPropS = keyData.s[0];
        }
        jLen = previousValue._length;
        kLen = keyPropS.i[0].length;
        var hasModified = false;
        var vertexValue;
        for(j=0;j<jLen;j+=1){
            for(k=0;k<kLen;k+=1){
                if(isHold){
                    vertexValue = keyPropS.i[j][k];
                    if(previousValue.i[j][k] !== vertexValue){
                        previousValue.i[j][k] = vertexValue;
                        if(isCurrentRender) {
                            this.pv.i[j][k] = vertexValue;
                        }
                        hasModified = true;
                    }
                    vertexValue = keyPropS.o[j][k];
                    if(previousValue.o[j][k] !== vertexValue){
                        previousValue.o[j][k] = vertexValue;
                        if(isCurrentRender) {
                            this.pv.o[j][k] = vertexValue;
                        }
                        hasModified = true;
                    }
                    vertexValue = keyPropS.v[j][k];
                    if(previousValue.v[j][k] !== vertexValue){
                        previousValue.v[j][k] = vertexValue;
                        if(isCurrentRender) {
                            this.pv.v[j][k] = vertexValue;
                        }
                        hasModified = true;
                    }
                }else{
                    vertexValue = keyPropS.i[j][k]+(keyPropE.i[j][k]-keyPropS.i[j][k])*perc;
                    if(previousValue.i[j][k] !== vertexValue){
                        previousValue.i[j][k] = vertexValue;
                        if(isCurrentRender) {
                            this.pv.i[j][k] = vertexValue;
                        }
                        hasModified = true;
                    }
                    vertexValue = keyPropS.o[j][k]+(keyPropE.o[j][k]-keyPropS.o[j][k])*perc;
                    if(previousValue.o[j][k] !== vertexValue){
                        previousValue.o[j][k] = vertexValue;
                        if(isCurrentRender) {
                            this.pv.o[j][k] = vertexValue;
                        }
                        hasModified = true;
                    }
                    vertexValue = keyPropS.v[j][k]+(keyPropE.v[j][k]-keyPropS.v[j][k])*perc;
                    if(previousValue.v[j][k] !== vertexValue){
                        previousValue.v[j][k] = vertexValue;
                        if(isCurrentRender) {
                            this.pv.v[j][k] = vertexValue;
                        }
                        hasModified = true;
                    }
                }
            }
        }
        if(hasModified) {
            previousValue.c = keyPropS.c;
        }
        return {
            iterationIndex: iterationIndex,
            hasModified: hasModified
        }
    }

    function interpolateShapeCurrentTime(){
        if(this.elem.globalData.frameId === this.frameId){
            return;
        }
        this.mdf = false;
        var frameNum = this.comp.renderedFrame - this.offsetTime;
        var initTime = this.keyframes[0].t - this.offsetTime;
        var endTime = this.keyframes[this.keyframes.length - 1].t - this.offsetTime;
        if(!(this.lastFrame !== initFrame && ((this.lastFrame < initTime && frameNum < initTime) || (this.lastFrame > endTime && frameNum > endTime)))){
            ////
            var i = this.lastFrame < frameNum ? this._lastIndex : 0;
            var renderResult = this.interpolateShape(frameNum, i, this.v, true);
            ////
            this._lastIndex = renderResult.iterationIndex;
            this.mdf = renderResult.hasModified;
            if(renderResult.hasModified) {
                this.paths = this.localShapeCollection;
            }
        }
        this.lastFrame = frameNum;
        this.frameId = this.elem.globalData.frameId;
    }

    function getShapeValue(){
        return this.v;
    }

    function resetShape(){
        this.paths = this.localShapeCollection;
        if(!this.k){
            this.mdf = false;
        }
    }

    function ShapeProperty(elem, data, type){
        this.__shapeObject = 1;
        this.comp = elem.comp;
        this.k = false;
        this.mdf = false;
        var pathData = type === 3 ? data.pt.k : data.ks.k;
        this.v = shape_pool.clone(pathData);
        this.pv = shape_pool.clone(this.v);
        this.localShapeCollection = shapeCollection_pool.newShapeCollection();
        this.paths = this.localShapeCollection;
        this.paths.addShape(this.v);
        this.reset = resetShape;
    }
    ShapeProperty.prototype.interpolateShape = interpolateShape;
    ShapeProperty.prototype.getValue = getShapeValue;

    function KeyframedShapeProperty(elem,data,type){
        this.__shapeObject = 1;
        this.comp = elem.comp;
        this.elem = elem;
        this.offsetTime = elem.data.st;
        this._lastIndex = 0;
        this.keyframes = type === 3 ? data.pt.k : data.ks.k;
        this.k = true;
        this.kf = true;
        var i, len = this.keyframes[0].s[0].i.length;
        var jLen = this.keyframes[0].s[0].i[0].length;
        this.v = shape_pool.newShape();
        this.v.setPathData(this.keyframes[0].s[0].c, len);
        this.pv = shape_pool.clone(this.v);
        this.localShapeCollection = shapeCollection_pool.newShapeCollection();
        this.paths = this.localShapeCollection;
        this.paths.addShape(this.v);
        this.lastFrame = initFrame;
        this.reset = resetShape;
    }
    KeyframedShapeProperty.prototype.getValue = interpolateShapeCurrentTime;
    KeyframedShapeProperty.prototype.interpolateShape = interpolateShape;

    var EllShapeProperty = (function(){

        var cPoint = roundCorner;

        function convertEllToPath(){
            var p0 = this.p.v[0], p1 = this.p.v[1], s0 = this.s.v[0]/2, s1 = this.s.v[1]/2;
            if(this.d !== 3){
                this.v.v[0][0] = p0;
                this.v.v[0][1] = p1-s1;
                this.v.v[1][0] = p0 + s0;
                this.v.v[1][1] = p1;
                this.v.v[2][0] = p0;
                this.v.v[2][1] = p1+s1;
                this.v.v[3][0] = p0 - s0;
                this.v.v[3][1] = p1;
                this.v.i[0][0] = p0 - s0*cPoint;
                this.v.i[0][1] = p1 - s1;
                this.v.i[1][0] = p0 + s0;
                this.v.i[1][1] = p1 - s1*cPoint;
                this.v.i[2][0] = p0 + s0*cPoint;
                this.v.i[2][1] = p1 + s1;
                this.v.i[3][0] = p0 - s0;
                this.v.i[3][1] = p1 + s1*cPoint;
                this.v.o[0][0] = p0 + s0*cPoint;
                this.v.o[0][1] = p1 - s1;
                this.v.o[1][0] = p0 + s0;
                this.v.o[1][1] = p1 + s1*cPoint;
                this.v.o[2][0] = p0 - s0*cPoint;
                this.v.o[2][1] = p1 + s1;
                this.v.o[3][0] = p0 - s0;
                this.v.o[3][1] = p1 - s1*cPoint;
            }else{
                this.v.v[0][0] = p0;
                this.v.v[0][1] = p1-s1;
                this.v.v[1][0] = p0 - s0;
                this.v.v[1][1] = p1;
                this.v.v[2][0] = p0;
                this.v.v[2][1] = p1+s1;
                this.v.v[3][0] = p0 + s0;
                this.v.v[3][1] = p1;
                this.v.i[0][0] = p0 + s0*cPoint;
                this.v.i[0][1] = p1 - s1;
                this.v.i[1][0] = p0 - s0;
                this.v.i[1][1] = p1 - s1*cPoint;
                this.v.i[2][0] = p0 - s0*cPoint;
                this.v.i[2][1] = p1 + s1;
                this.v.i[3][0] = p0 + s0;
                this.v.i[3][1] = p1 + s1*cPoint;
                this.v.o[0][0] = p0 - s0*cPoint;
                this.v.o[0][1] = p1 - s1;
                this.v.o[1][0] = p0 - s0;
                this.v.o[1][1] = p1 + s1*cPoint;
                this.v.o[2][0] = p0 + s0*cPoint;
                this.v.o[2][1] = p1 + s1;
                this.v.o[3][0] = p0 + s0;
                this.v.o[3][1] = p1 - s1*cPoint;
            }
        }

        function processKeys(frameNum){
            var i, len = this.dynamicProperties.length;
            if(this.elem.globalData.frameId === this.frameId){
                return;
            }
            this.mdf = false;
            this.frameId = this.elem.globalData.frameId;

            for(i=0;i<len;i+=1){
                this.dynamicProperties[i].getValue(frameNum);
                if(this.dynamicProperties[i].mdf){
                    this.mdf = true;
                }
            }
            if(this.mdf){
                this.convertEllToPath();
            }
        }

        return function EllShapeProperty(elem,data) {
            /*this.v = {
                v: Array.apply(null,{length:4}),
                i: Array.apply(null,{length:4}),
                o: Array.apply(null,{length:4}),
                c: true
            };*/
            this.v = shape_pool.newShape();
            this.v.setPathData(true, 4);
            this.localShapeCollection = shapeCollection_pool.newShapeCollection();
            this.paths = this.localShapeCollection;
            this.localShapeCollection.addShape(this.v);
            this.d = data.d;
            this.dynamicProperties = [];
            this.elem = elem;
            this.comp = elem.comp;
            this.frameId = -1;
            this.mdf = false;
            this.getValue = processKeys;
            this.convertEllToPath = convertEllToPath;
            this.reset = resetShape;
            this.p = PropertyFactory.getProp(elem,data.p,1,0,this.dynamicProperties);
            this.s = PropertyFactory.getProp(elem,data.s,1,0,this.dynamicProperties);
            if(this.dynamicProperties.length){
                this.k = true;
            }else{
                this.convertEllToPath();
            }
        }
    }());

    var StarShapeProperty = (function() {

        function convertPolygonToPath(){
            var numPts = Math.floor(this.pt.v);
            var angle = Math.PI*2/numPts;
            /*this.v.v.length = numPts;
            this.v.i.length = numPts;
            this.v.o.length = numPts;*/
            var rad = this.or.v;
            var roundness = this.os.v;
            var perimSegment = 2*Math.PI*rad/(numPts*4);
            var i, currentAng = -Math.PI/ 2;
            var dir = this.data.d === 3 ? -1 : 1;
            currentAng += this.r.v;
            this.v._length = 0;
            for(i=0;i<numPts;i+=1){
                var x = rad * Math.cos(currentAng);
                var y = rad * Math.sin(currentAng);
                var ox = x === 0 && y === 0 ? 0 : y/Math.sqrt(x*x + y*y);
                var oy = x === 0 && y === 0 ? 0 : -x/Math.sqrt(x*x + y*y);
                x +=  + this.p.v[0];
                y +=  + this.p.v[1];
                this.v.setTripleAt(x,y,x-ox*perimSegment*roundness*dir,y-oy*perimSegment*roundness*dir,x+ox*perimSegment*roundness*dir,y+oy*perimSegment*roundness*dir, i, true);
                /*this.v.v[i] = [x,y];
                this.v.i[i] = [x+ox*perimSegment*roundness*dir,y+oy*perimSegment*roundness*dir];
                this.v.o[i] = [x-ox*perimSegment*roundness*dir,y-oy*perimSegment*roundness*dir];*/
                currentAng += angle*dir;
            }
            this.paths.length = 0;
            this.paths[0] = this.v;
        }

        function convertStarToPath() {
            var numPts = Math.floor(this.pt.v)*2;
            var angle = Math.PI*2/numPts;
            /*this.v.v.length = numPts;
            this.v.i.length = numPts;
            this.v.o.length = numPts;*/
            var longFlag = true;
            var longRad = this.or.v;
            var shortRad = this.ir.v;
            var longRound = this.os.v;
            var shortRound = this.is.v;
            var longPerimSegment = 2*Math.PI*longRad/(numPts*2);
            var shortPerimSegment = 2*Math.PI*shortRad/(numPts*2);
            var i, rad,roundness,perimSegment, currentAng = -Math.PI/ 2;
            currentAng += this.r.v;
            var dir = this.data.d === 3 ? -1 : 1;
            this.v._length = 0;
            for(i=0;i<numPts;i+=1){
                rad = longFlag ? longRad : shortRad;
                roundness = longFlag ? longRound : shortRound;
                perimSegment = longFlag ? longPerimSegment : shortPerimSegment;
                var x = rad * Math.cos(currentAng);
                var y = rad * Math.sin(currentAng);
                var ox = x === 0 && y === 0 ? 0 : y/Math.sqrt(x*x + y*y);
                var oy = x === 0 && y === 0 ? 0 : -x/Math.sqrt(x*x + y*y);
                x +=  + this.p.v[0];
                y +=  + this.p.v[1];
                this.v.setTripleAt(x,y,x-ox*perimSegment*roundness*dir,y-oy*perimSegment*roundness*dir,x+ox*perimSegment*roundness*dir,y+oy*perimSegment*roundness*dir, i, true);

                /*this.v.v[i] = [x,y];
                this.v.i[i] = [x+ox*perimSegment*roundness*dir,y+oy*perimSegment*roundness*dir];
                this.v.o[i] = [x-ox*perimSegment*roundness*dir,y-oy*perimSegment*roundness*dir];
                this.v._length = numPts;*/
                longFlag = !longFlag;
                currentAng += angle*dir;
            }
        }

        function processKeys() {
            if(this.elem.globalData.frameId === this.frameId){
                return;
            }
            this.mdf = false;
            this.frameId = this.elem.globalData.frameId;
            var i, len = this.dynamicProperties.length;

            for(i=0;i<len;i+=1){
                this.dynamicProperties[i].getValue();
                if(this.dynamicProperties[i].mdf){
                    this.mdf = true;
                }
            }
            if(this.mdf){
                this.convertToPath();
            }
        }

        return function StarShapeProperty(elem,data) {
            /*this.v = {
                v: [],
                i: [],
                o: [],
                c: true
            };*/
            this.v = shape_pool.newShape();
            this.v.setPathData(true, 0);
            this.elem = elem;
            this.comp = elem.comp;
            this.data = data;
            this.frameId = -1;
            this.d = data.d;
            this.dynamicProperties = [];
            this.mdf = false;
            this.getValue = processKeys;
            this.reset = resetShape;
            if(data.sy === 1){
                this.ir = PropertyFactory.getProp(elem,data.ir,0,0,this.dynamicProperties);
                this.is = PropertyFactory.getProp(elem,data.is,0,0.01,this.dynamicProperties);
                this.convertToPath = convertStarToPath;
            } else {
                this.convertToPath = convertPolygonToPath;
            }
            this.pt = PropertyFactory.getProp(elem,data.pt,0,0,this.dynamicProperties);
            this.p = PropertyFactory.getProp(elem,data.p,1,0,this.dynamicProperties);
            this.r = PropertyFactory.getProp(elem,data.r,0,degToRads,this.dynamicProperties);
            this.or = PropertyFactory.getProp(elem,data.or,0,0,this.dynamicProperties);
            this.os = PropertyFactory.getProp(elem,data.os,0,0.01,this.dynamicProperties);
            this.localShapeCollection = shapeCollection_pool.newShapeCollection();
            this.localShapeCollection.addShape(this.v);
            this.paths = this.localShapeCollection;
            if(this.dynamicProperties.length){
                this.k = true;
            }else{
                this.convertToPath();
            }
        }
    }());

    var RectShapeProperty = (function() {
        function processKeys(frameNum){
            if(this.elem.globalData.frameId === this.frameId){
                return;
            }
            this.mdf = false;
            this.frameId = this.elem.globalData.frameId;
            var i, len = this.dynamicProperties.length;

            for(i=0;i<len;i+=1){
                this.dynamicProperties[i].getValue(frameNum);
                if(this.dynamicProperties[i].mdf){
                    this.mdf = true;
                }
            }
            if(this.mdf){
                this.convertRectToPath();
            }

        }

        function convertRectToPath(){
            var p0 = this.p.v[0], p1 = this.p.v[1], v0 = this.s.v[0]/2, v1 = this.s.v[1]/2;
            var round = bm_min(v0,v1,this.r.v);
            var cPoint = round*(1-roundCorner);
            this.v._length = 0;

            if(this.d === 2 || this.d === 1) {
                this.v.setTripleAt(p0+v0, p1-v1+round,p0+v0, p1-v1+round,p0+v0,p1-v1+cPoint,0, true);
                this.v.setTripleAt(p0+v0, p1+v1-round,p0+v0, p1+v1-cPoint,p0+v0, p1+v1-round,1, true);
                if(round!== 0){
                    this.v.setTripleAt(p0+v0-round, p1+v1,p0+v0-round,p1+v1,p0+v0-cPoint,p1+v1,2, true);
                    this.v.setTripleAt(p0-v0+round,p1+v1,p0-v0+cPoint,p1+v1,p0-v0+round,p1+v1,3, true);
                    this.v.setTripleAt(p0-v0,p1+v1-round,p0-v0,p1+v1-round,p0-v0,p1+v1-cPoint,4, true);
                    this.v.setTripleAt(p0-v0,p1-v1+round,p0-v0,p1-v1+cPoint,p0-v0,p1-v1+round,5, true);
                    this.v.setTripleAt(p0-v0+round,p1-v1,p0-v0+round,p1-v1,p0-v0+cPoint,p1-v1,6, true);
                    this.v.setTripleAt(p0+v0-round,p1-v1,p0+v0-cPoint,p1-v1,p0+v0-round,p1-v1,7, true);
                } else {
                    this.v.setTripleAt(p0-v0,p1+v1,p0-v0+cPoint,p1+v1,p0-v0,p1+v1,2);
                    this.v.setTripleAt(p0-v0,p1-v1,p0-v0,p1-v1+cPoint,p0-v0,p1-v1,3);
                }
            }else{
                this.v.setTripleAt(p0+v0,p1-v1+round,p0+v0,p1-v1+cPoint,p0+v0,p1-v1+round,0, true);
                if(round!== 0){
                    this.v.setTripleAt(p0+v0-round,p1-v1,p0+v0-round,p1-v1,p0+v0-cPoint,p1-v1,1, true);
                    this.v.setTripleAt(p0-v0+round,p1-v1,p0-v0+cPoint,p1-v1,p0-v0+round,p1-v1,2, true);
                    this.v.setTripleAt(p0-v0,p1-v1+round,p0-v0,p1-v1+round,p0-v0,p1-v1+cPoint,3, true);
                    this.v.setTripleAt(p0-v0,p1+v1-round,p0-v0,p1+v1-cPoint,p0-v0,p1+v1-round,4, true);
                    this.v.setTripleAt(p0-v0+round,p1+v1,p0-v0+round,p1+v1,p0-v0+cPoint,p1+v1,5, true);
                    this.v.setTripleAt(p0+v0-round,p1+v1,p0+v0-cPoint,p1+v1,p0+v0-round,p1+v1,6, true);
                    this.v.setTripleAt(p0+v0,p1+v1-round,p0+v0,p1+v1-round,p0+v0,p1+v1-cPoint,7, true);
                } else {
                    this.v.setTripleAt(p0-v0,p1-v1,p0-v0+cPoint,p1-v1,p0-v0,p1-v1,1, true);
                    this.v.setTripleAt(p0-v0,p1+v1,p0-v0,p1+v1-cPoint,p0-v0,p1+v1,2, true);
                    this.v.setTripleAt(p0+v0,p1+v1,p0+v0-cPoint,p1+v1,p0+v0,p1+v1,3, true);

                }
            }
        }

        return function RectShapeProperty(elem,data) {
            this.v = shape_pool.newShape();
            this.v.c = true;
            this.localShapeCollection = shapeCollection_pool.newShapeCollection();
            this.localShapeCollection.addShape(this.v);
            this.paths = this.localShapeCollection;
            this.elem = elem;
            this.comp = elem.comp;
            this.frameId = -1;
            this.d = data.d;
            this.dynamicProperties = [];
            this.mdf = false;
            this.getValue = processKeys;
            this.convertRectToPath = convertRectToPath;
            this.reset = resetShape;
            this.p = PropertyFactory.getProp(elem,data.p,1,0,this.dynamicProperties);
            this.s = PropertyFactory.getProp(elem,data.s,1,0,this.dynamicProperties);
            this.r = PropertyFactory.getProp(elem,data.r,0,0,this.dynamicProperties);
            if(this.dynamicProperties.length){
                this.k = true;
            }else{
                this.convertRectToPath();
            }
        }
    }());

    function getShapeProp(elem,data,type, arr){
        var prop;
        if(type === 3 || type === 4){
            var dataProp = type === 3 ? data.pt : data.ks;
            var keys = dataProp.k;
            if(dataProp.a === 1 || keys.length){
                prop = new KeyframedShapeProperty(elem, data, type);
            }else{
                prop = new ShapeProperty(elem, data, type);
            }
        }else if(type === 5){
            prop = new RectShapeProperty(elem, data);
        }else if(type === 6){
            prop = new EllShapeProperty(elem, data);
        }else if(type === 7){
            prop = new StarShapeProperty(elem, data);
        }
        if(prop.k){
            arr.push(prop);
        }
        return prop;
    }

    function getConstructorFunction() {
        return ShapeProperty;
    }

    function getKeyframedConstructorFunction() {
        return KeyframedShapeProperty;
    }

    var ob = {};
    ob.getShapeProp = getShapeProp;
    ob.getConstructorFunction = getConstructorFunction;
    ob.getKeyframedConstructorFunction = getKeyframedConstructorFunction;
    return ob;
}());
var ShapeModifiers = (function(){
    var ob = {};
    var modifiers = {};
    ob.registerModifier = registerModifier;
    ob.getModifier = getModifier;

    function registerModifier(nm,factory){
        if(!modifiers[nm]){
            modifiers[nm] = factory;
        }
    }

    function getModifier(nm,elem, data, dynamicProperties){
        return new modifiers[nm](elem, data, dynamicProperties);
    }

    return ob;
}());

function ShapeModifier(){}
ShapeModifier.prototype.initModifierProperties = function(){};
ShapeModifier.prototype.addShapeToModifier = function(){};
ShapeModifier.prototype.addShape = function(data){
    if(!this.closed){
        this.shapes.push({shape:data.sh, data: data, localShapeCollection:shapeCollection_pool.newShapeCollection()});
        this.addShapeToModifier(data.sh);
    }
}
ShapeModifier.prototype.init = function(elem,data,dynamicProperties){
    this.elem = elem;
    this.frameId = -1;
    this.shapes = [];
    this.dynamicProperties = [];
    this.mdf = false;
    this.closed = false;
    this.k = false;
    this.comp = elem.comp;
    this.initModifierProperties(elem,data);
    if(this.dynamicProperties.length){
        this.k = true;
        dynamicProperties.push(this);
    }else{
        this.getValue(true);
    }
}
function TrimModifier(){};
extendPrototype(ShapeModifier,TrimModifier);
TrimModifier.prototype.processKeys = function(forceRender){
    if(this.elem.globalData.frameId === this.frameId && !forceRender){
        return;
    }
    this.mdf = forceRender ? true : false;
    this.frameId = this.elem.globalData.frameId;
    var i, len = this.dynamicProperties.length;

    for(i=0;i<len;i+=1){
        this.dynamicProperties[i].getValue();
        if(this.dynamicProperties[i].mdf){
            this.mdf = true;
        }
    }
    if(this.mdf || forceRender){
        var o = (this.o.v%360)/360;
        if(o < 0){
            o += 1;
        }
        var s = this.s.v + o;
        var e = this.e.v + o;
        if(s == e){

        }
        if(s>e){
            var _s = s;
            s = e;
            e = _s;
        }
        this.sValue = s;
        this.eValue = e;
        this.oValue = o;
    }
}
TrimModifier.prototype.initModifierProperties = function(elem,data){
    this.sValue = 0;
    this.eValue = 0;
    this.oValue = 0;
    this.getValue = this.processKeys;
    this.s = PropertyFactory.getProp(elem,data.s,0,0.01,this.dynamicProperties);
    this.e = PropertyFactory.getProp(elem,data.e,0,0.01,this.dynamicProperties);
    this.o = PropertyFactory.getProp(elem,data.o,0,0,this.dynamicProperties);
    this.m = data.m;
    if(!this.dynamicProperties.length){
        this.getValue(true);
    }
};

TrimModifier.prototype.calculateShapeEdges = function(s, e, shapeLength, addedLength, totalModifierLength) {
    var segments = []
    if(e <= 1){
        segments.push({
            s: s,
            e: e
        })
    }else if(s >= 1){
        segments.push({
            s: s - 1,
            e: e - 1
        })
    }else{
        segments.push({
            s: s,
            e: 1
        })
        segments.push({
            s: 0,
            e: e - 1
        })
    }
    var shapeSegments = [];
    var i, len = segments.length, segmentOb;
    for(i = 0; i < len; i += 1) {
        segmentOb = segments[i];
        if (segmentOb.e * totalModifierLength < addedLength || segmentOb.s * totalModifierLength > addedLength + shapeLength) {
            
        } else {
            var shapeS, shapeE;
            if(segmentOb.s * totalModifierLength <= addedLength) {
                shapeS = 0;
            } else {
                shapeS = (segmentOb.s * totalModifierLength - addedLength) / shapeLength;
            }
            if(segmentOb.e * totalModifierLength >= addedLength + shapeLength) {
                shapeE = 1;
            } else {
                shapeE = ((segmentOb.e * totalModifierLength - addedLength) / shapeLength);
            }
            shapeSegments.push([shapeS, shapeE]);
        }
    }
    if(!shapeSegments.length){
        shapeSegments.push([0,0]);
    }
    return shapeSegments;
}

TrimModifier.prototype.processShapes = function(firstFrame){
    var shapePaths;
    var i, len = this.shapes.length;
    var j, jLen;
    var s = this.sValue;
    var e = this.eValue;
    var pathsData,pathData, totalShapeLength, totalModifierLength = 0;

    if(e === s){
        for(i=0;i<len;i+=1){
            this.shapes[i].localShapeCollection.releaseShapes();
            this.shapes[i].shape.mdf = true;
            this.shapes[i].shape.paths = this.shapes[i].localShapeCollection;
        }
    } else if(!((e === 1 && s === 0) || (e===0 && s === 1))){
        var segments = [], shapeData, localShapeCollection;
        for(i=0;i<len;i+=1){
            shapeData = this.shapes[i];
            if(!shapeData.shape.mdf && !this.mdf && !firstFrame && this.m !== 2){
                shapeData.shape.paths = shapeData.localShapeCollection;
            } else {
                shapePaths = shapeData.shape.paths;
                jLen = shapePaths._length;
                totalShapeLength = 0;
                if(!shapeData.shape.mdf && shapeData.pathsData){
                    totalShapeLength = shapeData.totalShapeLength;
                } else {
                    pathsData = [];
                    for(j=0;j<jLen;j+=1){
                        pathData = bez.getSegmentsLength(shapePaths.shapes[j]);
                        pathsData.push(pathData);
                        totalShapeLength += pathData.totalLength;
                    }
                    shapeData.totalShapeLength = totalShapeLength;
                    shapeData.pathsData = pathsData;
                }

                totalModifierLength += totalShapeLength;
                shapeData.shape.mdf = true;
            }
        }
        var shapeS = s, shapeE = e, addedLength = 0;
        var j, jLen;
        for(i = len - 1; i >= 0; i -= 1){
            shapeData = this.shapes[i];
            if (shapeData.shape.mdf) {
                localShapeCollection = shapeData.localShapeCollection;
                localShapeCollection.releaseShapes();
                if(this.m === 2 && len > 1) {
                    var edges = this.calculateShapeEdges(s, e, shapeData.totalShapeLength, addedLength, totalModifierLength);
                    addedLength += shapeData.totalShapeLength;
                } else {
                    edges = [[shapeS, shapeE]]
                }
                jLen = edges.length;
                for (j = 0; j < jLen; j += 1) {
                    shapeS = edges[j][0];
                    shapeE = edges[j][1];
                    segments.length = 0;
                    if(shapeE <= 1){
                        segments.push({
                            s:shapeData.totalShapeLength * shapeS,
                            e:shapeData.totalShapeLength * shapeE
                        })
                    }else if(shapeS >= 1){
                        segments.push({
                            s:shapeData.totalShapeLength * (shapeS - 1),
                            e:shapeData.totalShapeLength * (shapeE - 1)
                        })
                    }else{
                        segments.push({
                            s:shapeData.totalShapeLength * shapeS,
                            e:shapeData.totalShapeLength
                        })
                        segments.push({
                            s:0,
                            e:shapeData.totalShapeLength*(shapeE - 1)
                        })
                    }
                    var newShapesData = this.addShapes(shapeData,segments[0]);
                    if (segments[0].s !== segments[0].e) {
                        var lastPos;
                        if(segments.length > 1){
                            if(shapeData.shape.v.c){
                                var lastShape = newShapesData.pop();
                                this.addPaths(newShapesData, localShapeCollection);
                                newShapesData = this.addShapes(shapeData,segments[1], lastShape);
                            } else {
                                this.addPaths(newShapesData, localShapeCollection);
                                newShapesData = this.addShapes(shapeData,segments[1]);
                            }
                        } 
                        this.addPaths(newShapesData, localShapeCollection);
                    }
                    
                }
                shapeData.shape.paths = localShapeCollection;
            }
        }
    } else if(this.mdf){
        for(i=0;i<len;i+=1){
            this.shapes[i].shape.mdf = true;
        }
    }
    if(!this.dynamicProperties.length){
        this.mdf = false;
    }
}

TrimModifier.prototype.addPaths = function(newPaths, localShapeCollection) {
    var i, len = newPaths.length;
    for(i = 0; i < len; i += 1) {
        localShapeCollection.addShape(newPaths[i])
    }
}

TrimModifier.prototype.addSegment = function(pt1,pt2,pt3,pt4,shapePath,pos, newShape) {
    /*console.log(pt1, 'vertex: v, at: ', pos);
    console.log(pt2, 'vertex: o, at: ', pos);
    console.log(pt3, 'vertex: i, at: ', pos + 1);
    console.log(pt4, 'vertex: v, at: ', pos + 1);
    console.log('newShape: ', newShape);*/
    shapePath.setXYAt(pt2[0],pt2[1],'o',pos);
    shapePath.setXYAt(pt3[0],pt3[1],'i',pos + 1);
    if(newShape){
        shapePath.setXYAt(pt1[0],pt1[1],'v',pos);
    }
    shapePath.setXYAt(pt4[0],pt4[1],'v',pos + 1);
}

TrimModifier.prototype.addShapes = function(shapeData, shapeSegment, shapePath){
    var pathsData = shapeData.pathsData;
    var shapePaths = shapeData.shape.paths.shapes;
    var i, len = shapeData.shape.paths._length, j, jLen;
    var addedLength = 0;
    var currentLengthData,segmentCount;
    var lengths;
    var segment;
    var shapes = [];
    var initPos;
    var newShape = true;
    if(!shapePath){
        shapePath = shape_pool.newShape();
        segmentCount = 0;
        initPos = 0;
    } else {
        segmentCount = shapePath._length;
        initPos = shapePath._length;
    }
    shapes.push(shapePath);
    for(i=0;i<len;i+=1){
        lengths = pathsData[i].lengths;
        shapePath.c = shapePaths[i].c;
        jLen = shapePaths[i].c ? lengths.length : lengths.length + 1;
        for(j=1;j<jLen;j+=1){
            currentLengthData = lengths[j-1];
            if(addedLength + currentLengthData.addedLength < shapeSegment.s){
                addedLength += currentLengthData.addedLength;
                shapePath.c = false;
            } else if(addedLength > shapeSegment.e){
                shapePath.c = false;
                break;
            } else {
                if(shapeSegment.s <= addedLength && shapeSegment.e >= addedLength + currentLengthData.addedLength){
                    this.addSegment(shapePaths[i].v[j-1],shapePaths[i].o[j-1],shapePaths[i].i[j],shapePaths[i].v[j],shapePath,segmentCount,newShape);
                    newShape = false;
                } else {
                    segment = bez.getNewSegment(shapePaths[i].v[j-1],shapePaths[i].v[j],shapePaths[i].o[j-1],shapePaths[i].i[j], (shapeSegment.s - addedLength)/currentLengthData.addedLength,(shapeSegment.e - addedLength)/currentLengthData.addedLength, lengths[j-1]);
                    this.addSegment(segment.pt1,segment.pt3,segment.pt4,segment.pt2,shapePath,segmentCount,newShape);
                    newShape = false;
                    shapePath.c = false;
                }
                addedLength += currentLengthData.addedLength;
                segmentCount += 1;
            }
        }
        if(shapePaths[i].c){
            currentLengthData = lengths[j-1];
            if(addedLength <= shapeSegment.e){
                var segmentLength = lengths[j-1].addedLength;
                if(shapeSegment.s <= addedLength && shapeSegment.e >= addedLength + segmentLength){
                    this.addSegment(shapePaths[i].v[j-1],shapePaths[i].o[j-1],shapePaths[i].i[0],shapePaths[i].v[0],shapePath,segmentCount,newShape);
                    newShape = false;
                }else{
                    segment = bez.getNewSegment(shapePaths[i].v[j-1],shapePaths[i].v[0],shapePaths[i].o[j-1],shapePaths[i].i[0], (shapeSegment.s - addedLength)/segmentLength,(shapeSegment.e - addedLength)/segmentLength, lengths[j-1]);
                    this.addSegment(segment.pt1,segment.pt3,segment.pt4,segment.pt2,shapePath,segmentCount,newShape);
                    newShape = false;
                    shapePath.c = false;
                }
            } else {
                shapePath.c = false;
            }
            addedLength += currentLengthData.addedLength;
            segmentCount += 1;
        }
        if(shapePath._length){
            shapePath.setXYAt(shapePath.v[initPos][0],shapePath.v[initPos][1],'i',initPos);
            shapePath.setXYAt(shapePath.v[shapePath._length - 1][0],shapePath.v[shapePath._length - 1][1],'o',shapePath._length - 1);
        }
        if(addedLength > shapeSegment.e){
            break;
        }
        if(i<len-1){
            shapePath = shape_pool.newShape();
            newShape = true;
            shapes.push(shapePath);
            segmentCount = 0;
        }
    }
    return shapes;

}


ShapeModifiers.registerModifier('tm',TrimModifier);
function RoundCornersModifier(){};
extendPrototype(ShapeModifier,RoundCornersModifier);
RoundCornersModifier.prototype.processKeys = function(forceRender){
    if(this.elem.globalData.frameId === this.frameId && !forceRender){
        return;
    }
    this.mdf = forceRender ? true : false;
    this.frameId = this.elem.globalData.frameId;
    var i, len = this.dynamicProperties.length;

    for(i=0;i<len;i+=1){
        this.dynamicProperties[i].getValue();
        if(this.dynamicProperties[i].mdf){
            this.mdf = true;
        }
    }
}
RoundCornersModifier.prototype.initModifierProperties = function(elem,data){
    this.getValue = this.processKeys;
    this.rd = PropertyFactory.getProp(elem,data.r,0,null,this.dynamicProperties);
    if(!this.dynamicProperties.length){
        this.getValue(true);
    }
};

RoundCornersModifier.prototype.processPath = function(path, round){
    var cloned_path = shape_pool.newShape();
    cloned_path.c = path.c;
    var i, len = path._length;
    var currentV,currentI,currentO,closerV, newV,newO,newI,distance,newPosPerc,index = 0;
    var vX,vY,oX,oY,iX,iY;
    for(i=0;i<len;i+=1){
        currentV = path.v[i];
        currentO = path.o[i];
        currentI = path.i[i];
        if(currentV[0]===currentO[0] && currentV[1]===currentO[1] && currentV[0]===currentI[0] && currentV[1]===currentI[1]){
            if((i===0 || i === len - 1) && !path.c){
                cloned_path.setTripleAt(currentV[0],currentV[1],currentO[0],currentO[1],currentI[0],currentI[1],index);
                /*cloned_path.v[index] = currentV;
                cloned_path.o[index] = currentO;
                cloned_path.i[index] = currentI;*/
                index += 1;
            } else {
                if(i===0){
                    closerV = path.v[len-1];
                } else {
                    closerV = path.v[i-1];
                }
                distance = Math.sqrt(Math.pow(currentV[0]-closerV[0],2)+Math.pow(currentV[1]-closerV[1],2));
                newPosPerc = distance ? Math.min(distance/2,round)/distance : 0;
                vX = iX = currentV[0]+(closerV[0]-currentV[0])*newPosPerc;
                vY = iY = currentV[1]-(currentV[1]-closerV[1])*newPosPerc;
                oX = vX-(vX-currentV[0])*roundCorner;
                oY = vY-(vY-currentV[1])*roundCorner;
                cloned_path.setTripleAt(vX,vY,oX,oY,iX,iY,index);
                index += 1;

                if(i === len - 1){
                    closerV = path.v[0];
                } else {
                    closerV = path.v[i+1];
                }
                distance = Math.sqrt(Math.pow(currentV[0]-closerV[0],2)+Math.pow(currentV[1]-closerV[1],2));
                newPosPerc = distance ? Math.min(distance/2,round)/distance : 0;
                vX = oX = currentV[0]+(closerV[0]-currentV[0])*newPosPerc;
                vY = oY = currentV[1]+(closerV[1]-currentV[1])*newPosPerc;
                iX = vX-(vX-currentV[0])*roundCorner;
                iY = vY-(vY-currentV[1])*roundCorner;
                cloned_path.setTripleAt(vX,vY,oX,oY,iX,iY,index);
                index += 1;
            }
        } else {
            cloned_path.setTripleAt(path.v[i][0],path.v[i][1],path.o[i][0],path.o[i][1],path.i[i][0],path.i[i][1],index);
            index += 1;
        }
    }
    return cloned_path;
}

RoundCornersModifier.prototype.processShapes = function(firstFrame){
    var shapePaths;
    var i, len = this.shapes.length;
    var j, jLen;
    var rd = this.rd.v;

    if(rd !== 0){
        var shapeData, newPaths, localShapeCollection;
        for(i=0;i<len;i+=1){
            shapeData = this.shapes[i];
            newPaths = shapeData.shape.paths;
            localShapeCollection = shapeData.localShapeCollection;
            if(!(!shapeData.shape.mdf && !this.mdf && !firstFrame)){
                localShapeCollection.releaseShapes();
                shapeData.shape.mdf = true;
                shapePaths = shapeData.shape.paths.shapes;
                jLen = shapeData.shape.paths._length;
                for(j=0;j<jLen;j+=1){
                    localShapeCollection.addShape(this.processPath(shapePaths[j],rd));
                }
            }
            shapeData.shape.paths = shapeData.localShapeCollection;
        }

    }
    if(!this.dynamicProperties.length){
        this.mdf = false;
    }
}


ShapeModifiers.registerModifier('rd',RoundCornersModifier);
function RepeaterModifier(){};
RepeaterModifier.prototype.processKeys = function(forceRender){
    if(this.elem.globalData.frameId === this.frameId && !forceRender){
        return;
    }
    this.mdf = forceRender ? true : false;
    var i, len = this.dynamicProperties.length;

    for(i=0;i<len;i+=1){
        this.dynamicProperties[i].getValue();
        if(this.dynamicProperties[i].mdf){
            this.mdf = true;
        }
    }
};

RepeaterModifier.prototype.initModifierProperties = function(elem,data){
    this.getValue = this.processKeys;
    this.c = PropertyFactory.getProp(elem,data.c,0,null,this.dynamicProperties);
    this.o = PropertyFactory.getProp(elem,data.o,0,null,this.dynamicProperties);
    this.tr = PropertyFactory.getProp(elem,data.tr,2,null,this.dynamicProperties);
    this.data = data;
    if(!this.dynamicProperties.length){
        this.getValue(true);
    }
    this.pMatrix = new Matrix();
    this.rMatrix = new Matrix();
    this.sMatrix = new Matrix();
    this.tMatrix = new Matrix();
    this.matrix = new Matrix();
};

RepeaterModifier.prototype.applyTransforms = function(pMatrix, rMatrix, sMatrix, transform, perc, inv){
    var dir = inv ? -1 : 1;
    var scaleX = transform.s.v[0] + (1 - transform.s.v[0]) * (1 - perc);
    var scaleY = transform.s.v[1] + (1 - transform.s.v[1]) * (1 - perc);
    pMatrix.translate(transform.p.v[0] * dir * perc, transform.p.v[1] * dir * perc, transform.p.v[2]);
    rMatrix.translate(-transform.a.v[0], -transform.a.v[1], transform.a.v[2]);
    rMatrix.rotate(-transform.r.v * dir * perc);
    rMatrix.translate(transform.a.v[0], transform.a.v[1], transform.a.v[2]);
    sMatrix.translate(-transform.a.v[0], -transform.a.v[1], transform.a.v[2]);
    sMatrix.scale(inv ? 1/scaleX : scaleX, inv ? 1/scaleY : scaleY);
    sMatrix.translate(transform.a.v[0], transform.a.v[1], transform.a.v[2]);
}

RepeaterModifier.prototype.init = function(elem, arr, pos, elemsData, dynamicProperties) {
    this.elem = elem;
    this.arr = arr;
    this.pos = pos;
    this.elemsData = elemsData;
    this._currentCopies = 0;
    this._elements = [];
    this._groups = [];
    this.dynamicProperties = [];
    this.frameId = -1;
    this.initModifierProperties(elem,arr[pos]);
    var cont = 0;
    while(pos>0){
        pos -= 1;
        //this._elements.unshift(arr.splice(pos,1)[0]);
        this._elements.unshift(arr[pos]);
        cont += 1;
    }
    if(this.dynamicProperties.length){
        this.k = true;
        dynamicProperties.push(this);
    }else{
        this.getValue(true);
    }
}

RepeaterModifier.prototype.resetElements = function(elements){
    var i, len = elements.length;
    for(i = 0; i < len; i += 1) {
        elements[i]._processed = false;
        if(elements[i].ty === 'gr'){
            this.resetElements(elements[i].it);
        }
    }
}

RepeaterModifier.prototype.cloneElements = function(elements){
    var i, len = elements.length;
    var newElements = JSON.parse(JSON.stringify(elements));
    this.resetElements(newElements);
    return newElements;
}

RepeaterModifier.prototype.changeGroupRender = function(elements, renderFlag) {
    var i, len = elements.length;
    for(i = 0; i < len ; i += 1) {
        elements[i]._render = renderFlag;
        if(elements[i].ty === 'gr') {
            this.changeGroupRender(elements[i].it, renderFlag);
        }
    }
}

RepeaterModifier.prototype.processShapes = function(firstFrame){

    if(this.elem.globalData.frameId === this.frameId){
        return;
    }
    this.frameId = this.elem.globalData.frameId;
    if(!this.dynamicProperties.length && !firstFrame){
        this.mdf = false;
    }
    if(this.mdf){
        var copies = Math.ceil(this.c.v);
        if(this._groups.length < copies){
            while(this._groups.length < copies){
                var group = {
                    it:this.cloneElements(this._elements),
                    ty:'gr'
                }
                group.it.push({"a":{"a":0,"ix":1,"k":[0,0]},"nm":"Transform","o":{"a":0,"ix":7,"k":100},"p":{"a":0,"ix":2,"k":[0,0]},"r":{"a":0,"ix":6,"k":0},"s":{"a":0,"ix":3,"k":[100,100]},"sa":{"a":0,"ix":5,"k":0},"sk":{"a":0,"ix":4,"k":0},"ty":"tr"});
                
                this.arr.splice(0,0,group);
                this._groups.splice(0,0,group);
                this._currentCopies += 1;
            }
            this.elem.reloadShapes();
        }
        var i, cont = 0, renderFlag;
        for(i = 0; i  <= this._groups.length - 1; i += 1){
            renderFlag = cont < copies;
            this._groups[i]._render = renderFlag;
            this.changeGroupRender(this._groups[i].it, renderFlag);
            cont += 1;
        }
        
        this._currentCopies = copies;
        this.elem.firstFrame = true;
        ////

        var offset = this.o.v;
        var offsetModulo = offset%1;
        var roundOffset = offset > 0 ? Math.floor(offset) : Math.ceil(offset);
        var k;
        var tMat = this.tr.v.props;
        var pProps = this.pMatrix.props;
        var rProps = this.rMatrix.props;
        var sProps = this.sMatrix.props;
        this.pMatrix.reset();
        this.rMatrix.reset();
        this.sMatrix.reset();
        this.tMatrix.reset();
        this.matrix.reset();
        var iteration = 0;

        if(offset > 0) {
            while(iteration<roundOffset){
                this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, false);
                iteration += 1;
            }
            if(offsetModulo){
                this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, offsetModulo, false);
                iteration += offsetModulo;
            }
        } else if(offset < 0) {
            while(iteration>roundOffset){
                this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, true);
                iteration -= 1;
            }
            if(offsetModulo){
                this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, - offsetModulo, true);
                iteration -= offsetModulo;
            }
        }
        i = this.data.m === 1 ? 0 : this._currentCopies - 1;
        var dir = this.data.m === 1 ? 1 : -1;
        cont = this._currentCopies;
        while(cont){
            if(iteration !== 0){
                if((i !== 0 && dir === 1) || (i !== this._currentCopies - 1 && dir === -1)){
                    this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, false);
                }
                this.matrix.transform(rProps[0],rProps[1],rProps[2],rProps[3],rProps[4],rProps[5],rProps[6],rProps[7],rProps[8],rProps[9],rProps[10],rProps[11],rProps[12],rProps[13],rProps[14],rProps[15]);
                this.matrix.transform(sProps[0],sProps[1],sProps[2],sProps[3],sProps[4],sProps[5],sProps[6],sProps[7],sProps[8],sProps[9],sProps[10],sProps[11],sProps[12],sProps[13],sProps[14],sProps[15]);
                this.matrix.transform(pProps[0],pProps[1],pProps[2],pProps[3],pProps[4],pProps[5],pProps[6],pProps[7],pProps[8],pProps[9],pProps[10],pProps[11],pProps[12],pProps[13],pProps[14],pProps[15]);
                var items = this.elemsData[i].it;
                var itemsTransform = items[items.length - 1].transform.mProps.v.props;
                var j, jLen = itemsTransform.length;
                for(j=0;j<jLen;j+=1) {
                    itemsTransform[j] = this.matrix.props[j];
                }
                this.matrix.reset();
            } else {
                this.matrix.reset();
                var items = this.elemsData[i].it;
                var itemsTransform = items[items.length - 1].transform.mProps.v.props;
                var j, jLen = itemsTransform.length;
                for(j=0;j<jLen;j+=1) {
                    itemsTransform[j] = this.matrix.props[j];
                }
            }
            iteration += 1;
            cont -= 1;
            i += dir;
        }
    }
}

RepeaterModifier.prototype.addShape = function(){}

ShapeModifiers.registerModifier('rp',RepeaterModifier);
function ShapeCollection(){
	this._length = 0;
	this._maxLength = 4;
	this.shapes = Array.apply(null,{length:this._maxLength});
};

ShapeCollection.prototype.addShape = function(shapeData){
	if(this._length === this._maxLength){
		this.shapes = this.shapes.concat(Array.apply(null,{length:this._maxLength}));
		this._maxLength *= 2;
	}
	this.shapes[this._length] = shapeData;
	this._length += 1;
};

ShapeCollection.prototype.releaseShapes = function(){
	var i;
	for(i = 0; i < this._length; i += 1) {
		shape_pool.release(this.shapes[i]);
	}
	this._length = 0;
};
var ImagePreloader = (function(){

    var imagesLoadedCb;

    function imageLoaded(){
        this.loadedAssets += 1;
        if(this.loadedAssets === this.totalImages){
            if(imagesLoadedCb) {
                imagesLoadedCb(null);
            }
        }
    }

    function getAssetsPath(assetData){
        var path = '';
        if(this.assetsPath){
            var imagePath = assetData.p;
            if(imagePath.indexOf('images/') !== -1){
                imagePath = imagePath.split('/')[1];
            }
            path = this.assetsPath + imagePath;
        } else {
            path = this.path;
            path += assetData.u ? assetData.u : '';
            path += assetData.p;
        }
        return path;
    }

    function loadImage(path){
        var img = document.createElement('img');
        img.addEventListener('load', imageLoaded.bind(this), false);
        img.addEventListener('error', imageLoaded.bind(this), false);
        img.src = path;
    }
    function loadAssets(assets, cb){
        imagesLoadedCb = cb;
        this.totalAssets = assets.length;
        var i;
        for(i=0;i<this.totalAssets;i+=1){
            if(!assets[i].layers){
                loadImage.bind(this)(getAssetsPath.bind(this)(assets[i]));
                this.totalImages += 1;
            }
        }
    }

    function setPath(path){
        this.path = path || '';
    }

    function setAssetsPath(path){
        this.assetsPath = path || '';
    }

    return function ImagePreloader(){
        this.loadAssets = loadAssets;
        this.setAssetsPath = setAssetsPath;
        this.setPath = setPath;
        this.assetsPath = '';
        this.path = '';
        this.totalAssets = 0;
        this.totalImages = 0;
        this.loadedAssets = 0;
    }
}());
var featureSupport = (function(){
	var ob = {
		maskType: true
	}
	if (/MSIE 10/i.test(navigator.userAgent) || /MSIE 9/i.test(navigator.userAgent) || /rv:11.0/i.test(navigator.userAgent) || /Edge\/\d./i.test(navigator.userAgent)) {
	   ob.maskType = false;
	}
	return ob;
}());
var filtersFactory = (function(){
	var ob = {};
	ob.createFilter = createFilter;
	ob.createAlphaToLuminanceFilter = createAlphaToLuminanceFilter;

	function createFilter(filId){
        	var fil = document.createElementNS(svgNS,'filter');
        	fil.setAttribute('id',filId);
                fil.setAttribute('filterUnits','objectBoundingBox');
                fil.setAttribute('x','0%');
                fil.setAttribute('y','0%');
                fil.setAttribute('width','100%');
                fil.setAttribute('height','100%');
                return fil;
	}

	function createAlphaToLuminanceFilter(){
                var feColorMatrix = document.createElementNS(svgNS,'feColorMatrix');
                feColorMatrix.setAttribute('type','matrix');
                feColorMatrix.setAttribute('color-interpolation-filters','sRGB');
                feColorMatrix.setAttribute('values','0 0 0 1 0  0 0 0 1 0  0 0 0 1 0  0 0 0 1 1');
                return feColorMatrix;
	}

	return ob;
}())
function TextAnimatorProperty(textData, renderType, elem){
    this.mdf = false;
    this._firstFrame = true;
	this._hasMaskedPath = false;
	this._frameId = -1;
	this._dynamicProperties = [];
	this._textData = textData;
	this._renderType = renderType;
	this._elem = elem;
	this._animatorsData = Array.apply(null,{length:this._textData.a.length});
	this._pathData = {}
	this._moreOptions = {
		alignment: {}
	};
	this.renderedLetters = [];
    this.lettersChangedFlag = false;

}

TextAnimatorProperty.prototype.searchProperties = function(dynamicProperties){
    var i, len = this._textData.a.length, animatorData, animatorProps;
    var getProp = PropertyFactory.getProp;
    for(i=0;i<len;i+=1){
        animatorProps = this._textData.a[i];
        animatorData = {
            a: {},
            s: {}
        };
        if('r' in animatorProps.a) {
            animatorData.a.r = getProp(this._elem,animatorProps.a.r,0,degToRads,this._dynamicProperties);
        }
        if('rx' in animatorProps.a) {
            animatorData.a.rx = getProp(this._elem,animatorProps.a.rx,0,degToRads,this._dynamicProperties);
        }
        if('ry' in animatorProps.a) {
            animatorData.a.ry = getProp(this._elem,animatorProps.a.ry,0,degToRads,this._dynamicProperties);
        }
        if('sk' in animatorProps.a) {
            animatorData.a.sk = getProp(this._elem,animatorProps.a.sk,0,degToRads,this._dynamicProperties);
        }
        if('sa' in animatorProps.a) {
            animatorData.a.sa = getProp(this._elem,animatorProps.a.sa,0,degToRads,this._dynamicProperties);
        }
        if('s' in animatorProps.a) {
            animatorData.a.s = getProp(this._elem,animatorProps.a.s,1,0.01,this._dynamicProperties);
        }
        if('a' in animatorProps.a) {
            animatorData.a.a = getProp(this._elem,animatorProps.a.a,1,0,this._dynamicProperties);
        }
        if('o' in animatorProps.a) {
            animatorData.a.o = getProp(this._elem,animatorProps.a.o,0,0.01,this._dynamicProperties);
        }
        if('p' in animatorProps.a) {
            animatorData.a.p = getProp(this._elem,animatorProps.a.p,1,0,this._dynamicProperties);
        }
        if('sw' in animatorProps.a) {
            animatorData.a.sw = getProp(this._elem,animatorProps.a.sw,0,0,this._dynamicProperties);
        }
        if('sc' in animatorProps.a) {
            animatorData.a.sc = getProp(this._elem,animatorProps.a.sc,1,0,this._dynamicProperties);
        }
        if('fc' in animatorProps.a) {
            animatorData.a.fc = getProp(this._elem,animatorProps.a.fc,1,0,this._dynamicProperties);
        }
        if('fh' in animatorProps.a) {
            animatorData.a.fh = getProp(this._elem,animatorProps.a.fh,0,0,this._dynamicProperties);
        }
        if('fs' in animatorProps.a) {
            animatorData.a.fs = getProp(this._elem,animatorProps.a.fs,0,0.01,this._dynamicProperties);
        }
        if('fb' in animatorProps.a) {
            animatorData.a.fb = getProp(this._elem,animatorProps.a.fb,0,0.01,this._dynamicProperties);
        }
        if('t' in animatorProps.a) {
            animatorData.a.t = getProp(this._elem,animatorProps.a.t,0,0,this._dynamicProperties);
        }
        animatorData.s = PropertyFactory.getTextSelectorProp(this._elem,animatorProps.s,this._dynamicProperties);
        animatorData.s.t = animatorProps.s.t;
        this._animatorsData[i] = animatorData;
    }
    if(this._textData.p && 'm' in this._textData.p){
        this._pathData = {
            f: getProp(this._elem,this._textData.p.f,0,0,this._dynamicProperties),
            l: getProp(this._elem,this._textData.p.l,0,0,this._dynamicProperties),
            r: this._textData.p.r,
            m: this._elem.maskManager.getMaskProperty(this._textData.p.m)
        };
        this._hasMaskedPath = true;
    } else {
        this._hasMaskedPath = false;
    }
    this._moreOptions.alignment = getProp(this._elem,this._textData.m.a,1,0,this._dynamicProperties);
    if(this._dynamicProperties.length) {
    	dynamicProperties.push(this);
    }
}

TextAnimatorProperty.prototype.getMeasures = function(documentData, lettersChangedFlag){
    this.lettersChangedFlag = lettersChangedFlag;
    if(!this.mdf && !this._firstFrame && !lettersChangedFlag && (!this._hasMaskedPath || !this._pathData.m.mdf)) {
        return;
    }
    this._firstFrame = false;
    var alignment = this._moreOptions.alignment.v;
    var animators = this._animatorsData;
    var textData = this._textData;
    var matrixHelper = this.mHelper;
    var renderType = this._renderType;
    var renderedLettersCount = this.renderedLetters.length;
    var data = this.data;
    var xPos,yPos;
    var i, len;
    var letters = documentData.l;
    if(this._hasMaskedPath) {
        var mask = this._pathData.m;
        if(!this._pathData.n || this._pathData.mdf){
            var paths = mask.v;
            if(this._pathData.r){
                paths = reversePath(paths);
            }
            var pathInfo = {
                tLength: 0,
                segments: []
            };
            len = paths._length - 1;
            var pathData;
            var totalLength = 0;
            for (i = 0; i < len; i += 1) {
                pathData = {
                    s: paths.v[i],
                    e: paths.v[i + 1],
                    to: [paths.o[i][0] - paths.v[i][0], paths.o[i][1] - paths.v[i][1]],
                    ti: [paths.i[i + 1][0] - paths.v[i + 1][0], paths.i[i + 1][1] - paths.v[i + 1][1]]
                };
                bez.buildBezierData(pathData);
                pathInfo.tLength += pathData.bezierData.segmentLength;
                pathInfo.segments.push(pathData);
                totalLength += pathData.bezierData.segmentLength;
            }
            i = len;
            if (mask.v.c) {
                pathData = {
                    s: paths.v[i],
                    e: paths.v[0],
                    to: [paths.o[i][0] - paths.v[i][0], paths.o[i][1] - paths.v[i][1]],
                    ti: [paths.i[0][0] - paths.v[0][0], paths.i[0][1] - paths.v[0][1]]
                };
                bez.buildBezierData(pathData);
                pathInfo.tLength += pathData.bezierData.segmentLength;
                pathInfo.segments.push(pathData);
                totalLength += pathData.bezierData.segmentLength;
            }
            this._pathData.pi = pathInfo;
        }
        var pathInfo = this._pathData.pi;

        var currentLength = this._pathData.f.v, segmentInd = 0, pointInd = 1, currentPoint, prevPoint, points;
        var segmentLength = 0, flag = true;
        var segments = pathInfo.segments;
        if (currentLength < 0 && mask.v.c) {
            if (pathInfo.tLength < Math.abs(currentLength)) {
                currentLength = -Math.abs(currentLength) % pathInfo.tLength;
            }
            segmentInd = segments.length - 1;
            points = segments[segmentInd].bezierData.points;
            pointInd = points.length - 1;
            while (currentLength < 0) {
                currentLength += points[pointInd].partialLength;
                pointInd -= 1;
                if (pointInd < 0) {
                    segmentInd -= 1;
                    points = segments[segmentInd].bezierData.points;
                    pointInd = points.length - 1;
                }
            }

        }
        points = segments[segmentInd].bezierData.points;
        prevPoint = points[pointInd - 1];
        currentPoint = points[pointInd];
        var partialLength = currentPoint.partialLength;
        var perc, tanAngle;
    }


    len = letters.length;
    xPos = 0;
    yPos = 0;
    var yOff = documentData.s*1.2*.714;
    var firstLine = true;
    var animatorProps, animatorSelector;
    var j, jLen;
    var letterValue;

    jLen = animators.length;
    if (lettersChangedFlag) {
        for (j = 0; j < jLen; j += 1) {
            animatorSelector = animators[j].s;
            animatorSelector.getValue(true);
        }
    }
    var lastLetter;

    var mult, ind = -1, offf, xPathPos, yPathPos;
    var initPathPos = currentLength,initSegmentInd = segmentInd, initPointInd = pointInd, currentLine = -1;
    var elemOpacity;
    var sc,sw,fc,k;
    var lineLength = 0;
    var letterSw,letterSc,letterFc,letterM = '',letterP = this.defaultPropsArray,letterO;
    for( i = 0; i < len; i += 1) {
        matrixHelper.reset();
        elemOpacity = 1;
        if(letters[i].n) {
            xPos = 0;
            yPos += documentData.yOffset;
            yPos += firstLine ? 1 : 0;
            currentLength = initPathPos ;
            firstLine = false;
            lineLength = 0;
            if(this._hasMaskedPath) {
                segmentInd = initSegmentInd;
                pointInd = initPointInd;
                points = segments[segmentInd].bezierData.points;
                prevPoint = points[pointInd - 1];
                currentPoint = points[pointInd];
                partialLength = currentPoint.partialLength;
                segmentLength = 0;
            }
            letterO = letterSw = letterFc = letterM = '';
            letterP = this.defaultPropsArray;
        }else{
            if(this._hasMaskedPath) {
                if(currentLine !== letters[i].line){
                    switch(documentData.j){
                        case 1:
                            currentLength += totalLength - documentData.lineWidths[letters[i].line];
                            break;
                        case 2:
                            currentLength += (totalLength - documentData.lineWidths[letters[i].line])/2;
                            break;
                    }
                    currentLine = letters[i].line;
                }
                if (ind !== letters[i].ind) {
                    if (letters[ind]) {
                        currentLength += letters[ind].extra;
                    }
                    currentLength += letters[i].an / 2;
                    ind = letters[i].ind;
                }
                currentLength += alignment[0] * letters[i].an / 200;
                var animatorOffset = 0;
                for (j = 0; j < jLen; j += 1) {
                    animatorProps = animators[j].a;
                    if ('p' in animatorProps) {
                        animatorSelector = animators[j].s;
                        mult = animatorSelector.getMult(letters[i].anIndexes[j],textData.a[j].s.totalChars);
                        if(mult.length){
                            animatorOffset += animatorProps.p.v[0] * mult[0];
                        } else{
                            animatorOffset += animatorProps.p.v[0] * mult;
                        }

                    }
                    if ('a' in animatorProps) {
                        animatorSelector = animators[j].s;
                        mult = animatorSelector.getMult(letters[i].anIndexes[j],textData.a[j].s.totalChars);
                        if(mult.length){
                            animatorOffset += animatorProps.a.v[0] * mult[0];
                        } else{
                            animatorOffset += animatorProps.a.v[0] * mult;
                        }

                    }
                }
                flag = true;
                while (flag) {
                    if (segmentLength + partialLength >= currentLength + animatorOffset || !points) {
                        perc = (currentLength + animatorOffset - segmentLength) / currentPoint.partialLength;
                        xPathPos = prevPoint.point[0] + (currentPoint.point[0] - prevPoint.point[0]) * perc;
                        yPathPos = prevPoint.point[1] + (currentPoint.point[1] - prevPoint.point[1]) * perc;
                        matrixHelper.translate(-alignment[0]*letters[i].an/200, -(alignment[1] * yOff / 100));
                        flag = false;
                    } else if (points) {
                        segmentLength += currentPoint.partialLength;
                        pointInd += 1;
                        if (pointInd >= points.length) {
                            pointInd = 0;
                            segmentInd += 1;
                            if (!segments[segmentInd]) {
                                if (mask.v.c) {
                                    pointInd = 0;
                                    segmentInd = 0;
                                    points = segments[segmentInd].bezierData.points;
                                } else {
                                    segmentLength -= currentPoint.partialLength;
                                    points = null;
                                }
                            } else {
                                points = segments[segmentInd].bezierData.points;
                            }
                        }
                        if (points) {
                            prevPoint = currentPoint;
                            currentPoint = points[pointInd];
                            partialLength = currentPoint.partialLength;
                        }
                    }
                }
                offf = letters[i].an / 2 - letters[i].add;
                matrixHelper.translate(-offf, 0, 0);
            } else {
                offf = letters[i].an/2 - letters[i].add;
                matrixHelper.translate(-offf,0,0);

                // Grouping alignment
                matrixHelper.translate(-alignment[0]*letters[i].an/200, -alignment[1]*yOff/100, 0);
            }

            lineLength += letters[i].l/2;
            for(j=0;j<jLen;j+=1){
                animatorProps = animators[j].a;
                if ('t' in animatorProps) {
                    animatorSelector = animators[j].s;
                    mult = animatorSelector.getMult(letters[i].anIndexes[j],textData.a[j].s.totalChars);
                    if(this._hasMaskedPath) {
                        if(mult.length) {
                            currentLength += animatorProps.t*mult[0];
                        } else {
                            currentLength += animatorProps.t*mult;
                        }
                    }else{
                        if(mult.length) {
                            xPos += animatorProps.t.v*mult[0];
                        } else {
                            xPos += animatorProps.t.v*mult;
                        }
                    }
                }
            }
            lineLength += letters[i].l/2;
            if(documentData.strokeWidthAnim) {
                sw = documentData.sw || 0;
            }
            if(documentData.strokeColorAnim) {
                if(documentData.sc){
                    sc = [documentData.sc[0], documentData.sc[1], documentData.sc[2]];
                }else{
                    sc = [0,0,0];
                }
            }
            if(documentData.fillColorAnim && documentData.fc) {
                fc = [documentData.fc[0], documentData.fc[1], documentData.fc[2]];
            }
            for(j=0;j<jLen;j+=1){
                animatorProps = animators[j].a;
                if ('a' in animatorProps) {
                    animatorSelector = animators[j].s;
                    mult = animatorSelector.getMult(letters[i].anIndexes[j],textData.a[j].s.totalChars);

                    if(mult.length){
                        matrixHelper.translate(-animatorProps.a.v[0]*mult[0], -animatorProps.a.v[1]*mult[1], animatorProps.a.v[2]*mult[2]);
                    } else {
                        matrixHelper.translate(-animatorProps.a.v[0]*mult, -animatorProps.a.v[1]*mult, animatorProps.a.v[2]*mult);
                    }
                }
            }
            for(j=0;j<jLen;j+=1){
                animatorProps = animators[j].a;
                if ('s' in animatorProps) {
                    animatorSelector = animators[j].s;
                    mult = animatorSelector.getMult(letters[i].anIndexes[j],textData.a[j].s.totalChars);
                    if(mult.length){
                        matrixHelper.scale(1+((animatorProps.s.v[0]-1)*mult[0]),1+((animatorProps.s.v[1]-1)*mult[1]),1);
                    } else {
                        matrixHelper.scale(1+((animatorProps.s.v[0]-1)*mult),1+((animatorProps.s.v[1]-1)*mult),1);
                    }
                }
            }
            for(j=0;j<jLen;j+=1) {
                animatorProps = animators[j].a;
                animatorSelector = animators[j].s;
                mult = animatorSelector.getMult(letters[i].anIndexes[j],textData.a[j].s.totalChars);
                if ('sk' in animatorProps) {
                    if(mult.length) {
                        matrixHelper.skewFromAxis(-animatorProps.sk.v * mult[0], animatorProps.sa.v * mult[1]);
                    } else {
                        matrixHelper.skewFromAxis(-animatorProps.sk.v * mult, animatorProps.sa.v * mult);
                    }
                }
                if ('r' in animatorProps) {
                    if(mult.length) {
                        matrixHelper.rotateZ(-animatorProps.r.v * mult[2]);
                    } else {
                        matrixHelper.rotateZ(-animatorProps.r.v * mult);
                    }
                }
                if ('ry' in animatorProps) {

                    if(mult.length) {
                        matrixHelper.rotateY(animatorProps.ry.v*mult[1]);
                    }else{
                        matrixHelper.rotateY(animatorProps.ry.v*mult);
                    }
                }
                if ('rx' in animatorProps) {
                    if(mult.length) {
                        matrixHelper.rotateX(animatorProps.rx.v*mult[0]);
                    } else {
                        matrixHelper.rotateX(animatorProps.rx.v*mult);
                    }
                }
                if ('o' in animatorProps) {
                    if(mult.length) {
                        elemOpacity += ((animatorProps.o.v)*mult[0] - elemOpacity)*mult[0];
                    } else {
                        elemOpacity += ((animatorProps.o.v)*mult - elemOpacity)*mult;
                    }
                }
                if (documentData.strokeWidthAnim && 'sw' in animatorProps) {
                    if(mult.length) {
                        sw += animatorProps.sw.v*mult[0];
                    } else {
                        sw += animatorProps.sw.v*mult;
                    }
                }
                if (documentData.strokeColorAnim && 'sc' in animatorProps) {
                    for(k=0;k<3;k+=1){
                        if(mult.length) {
                            sc[k] = sc[k] + (animatorProps.sc.v[k] - sc[k])*mult[0]
                        } else {
                            sc[k] = sc[k] + (animatorProps.sc.v[k] - sc[k])*mult;
                        }
                    }
                }
                if (documentData.fillColorAnim && documentData.fc) {
                    if('fc' in animatorProps){
                        for(k=0;k<3;k+=1){
                            if(mult.length) {
                                fc[k] = fc[k] + (animatorProps.fc.v[k] - fc[k])*mult[0];
                            } else {
                                fc[k] = fc[k] + (animatorProps.fc.v[k] - fc[k])*mult;
                            }
                        }
                    }
                    if('fh' in animatorProps){
                        if(mult.length) {
                            fc = addHueToRGB(fc,animatorProps.fh.v*mult[0]);
                        } else {
                            fc = addHueToRGB(fc,animatorProps.fh.v*mult);
                        }
                    }
                    if('fs' in animatorProps){
                        if(mult.length) {
                            fc = addSaturationToRGB(fc,animatorProps.fs.v*mult[0]);
                        } else {
                            fc = addSaturationToRGB(fc,animatorProps.fs.v*mult);
                        }
                    }
                    if('fb' in animatorProps){
                        if(mult.length) {
                            fc = addBrightnessToRGB(fc,animatorProps.fb.v*mult[0]);
                        } else {
                            fc = addBrightnessToRGB(fc,animatorProps.fb.v*mult);
                        }
                    }
                }
            }

            for(j=0;j<jLen;j+=1){
                animatorProps = animators[j].a;

                if ('p' in animatorProps) {
                    animatorSelector = animators[j].s;
                    mult = animatorSelector.getMult(letters[i].anIndexes[j],textData.a[j].s.totalChars);
                    if(this._hasMaskedPath) {
                        if(mult.length) {
                            matrixHelper.translate(0, animatorProps.p.v[1] * mult[0], -animatorProps.p.v[2] * mult[1]);
                        } else {
                            matrixHelper.translate(0, animatorProps.p.v[1] * mult, -animatorProps.p.v[2] * mult);
                        }
                    }else{
                        if(mult.length) {
                            matrixHelper.translate(animatorProps.p.v[0] * mult[0], animatorProps.p.v[1] * mult[1], -animatorProps.p.v[2] * mult[2]);
                        } else {
                            matrixHelper.translate(animatorProps.p.v[0] * mult, animatorProps.p.v[1] * mult, -animatorProps.p.v[2] * mult);
                        }
                    }
                }
            }
            if(documentData.strokeWidthAnim){
                letterSw = sw < 0 ? 0 : sw;
            }
            if(documentData.strokeColorAnim){
                letterSc = 'rgb('+Math.round(sc[0]*255)+','+Math.round(sc[1]*255)+','+Math.round(sc[2]*255)+')';
            }
            if(documentData.fillColorAnim && documentData.fc){
                letterFc = 'rgb('+Math.round(fc[0]*255)+','+Math.round(fc[1]*255)+','+Math.round(fc[2]*255)+')';
            }

            if(this._hasMaskedPath) {
                matrixHelper.translate(0,-documentData.ls);

                matrixHelper.translate(0, alignment[1]*yOff/100 + yPos,0);
                if (textData.p.p) {
                    tanAngle = (currentPoint.point[1] - prevPoint.point[1]) / (currentPoint.point[0] - prevPoint.point[0]);
                    var rot = Math.atan(tanAngle) * 180 / Math.PI;
                    if (currentPoint.point[0] < prevPoint.point[0]) {
                        rot += 180;
                    }
                    matrixHelper.rotate(-rot * Math.PI / 180);
                }
                matrixHelper.translate(xPathPos, yPathPos, 0);
                currentLength -= alignment[0]*letters[i].an/200;
                if(letters[i+1] && ind !== letters[i+1].ind){
                    currentLength += letters[i].an / 2;
                    currentLength += documentData.tr/1000*documentData.s;
                }
            }else{

                matrixHelper.translate(xPos,yPos,0);

                if(documentData.ps){
                    //matrixHelper.translate(documentData.ps[0],documentData.ps[1],0);
                    matrixHelper.translate(documentData.ps[0],documentData.ps[1] + documentData.ascent,0);
                }
                switch(documentData.j){
                    case 1:
                        matrixHelper.translate(documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[letters[i].line]),0,0);
                        break;
                    case 2:
                        matrixHelper.translate(documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[letters[i].line])/2,0,0);
                        break;
                }
                matrixHelper.translate(0,-documentData.ls);
                matrixHelper.translate(offf,0,0);
                matrixHelper.translate(alignment[0]*letters[i].an/200,alignment[1]*yOff/100,0);
                xPos += letters[i].l + documentData.tr/1000*documentData.s;
            }
            if(renderType === 'html'){
                letterM = matrixHelper.toCSS();
            }else if(renderType === 'svg'){
                letterM = matrixHelper.to2dCSS();
            }else{
                letterP = [matrixHelper.props[0],matrixHelper.props[1],matrixHelper.props[2],matrixHelper.props[3],matrixHelper.props[4],matrixHelper.props[5],matrixHelper.props[6],matrixHelper.props[7],matrixHelper.props[8],matrixHelper.props[9],matrixHelper.props[10],matrixHelper.props[11],matrixHelper.props[12],matrixHelper.props[13],matrixHelper.props[14],matrixHelper.props[15]];
            }
            letterO = elemOpacity;
        }

        if(renderedLettersCount <= i) {
            letterValue = new LetterProps(letterO,letterSw,letterSc,letterFc,letterM,letterP);
            this.renderedLetters.push(letterValue);
            renderedLettersCount += 1;
            this.lettersChangedFlag = true;
        } else {
            letterValue = this.renderedLetters[i];
            this.lettersChangedFlag = letterValue.update(letterO, letterSw, letterSc, letterFc, letterM, letterP) || this.lettersChangedFlag;
        }
    }
}

TextAnimatorProperty.prototype.getValue = function(){
	if(this._elem.globalData.frameId === this._frameId){
        return;
    }
    this._frameId = this._elem.globalData.frameId;
	var i, len = this._dynamicProperties.length;
    this.mdf = false;
	for(i = 0; i < len; i += 1) {
		this._dynamicProperties[i].getValue();
        this.mdf = this._dynamicProperties[i].mdf || this.mdf;
	}
}

TextAnimatorProperty.prototype.mHelper = new Matrix();
TextAnimatorProperty.prototype.defaultPropsArray = [];
function LetterProps(o, sw, sc, fc, m, p){
    this.o = o;
    this.sw = sw;
    this.sc = sc;
    this.fc = fc;
    this.m = m;
    this.p = p;
    this.mdf = {
    	o: true,
    	sw: !!sw,
    	sc: !!sc,
    	fc: !!fc,
    	m: true,
    	p: true
    };
}

LetterProps.prototype.update = function(o, sw, sc, fc, m, p) {
	this.mdf.o = false;
	this.mdf.sw = false;
	this.mdf.sc = false;
	this.mdf.fc = false;
	this.mdf.m = false;
	this.mdf.p = false;
	var updated = false;

	if(this.o !== o) {
		this.o = o;
		this.mdf.o = true;
		updated = true;
	}
	if(this.sw !== sw) {
		this.sw = sw;
		this.mdf.sw = true;
		updated = true;
	}
	if(this.sc !== sc) {
		this.sc = sc;
		this.mdf.sc = true;
		updated = true;
	}
	if(this.fc !== fc) {
		this.fc = fc;
		this.mdf.fc = true;
		updated = true;
	}
	if(this.m !== m) {
		this.m = m;
		this.mdf.m = true;
		updated = true;
	}
	if(p.length && (this.p[0] !== p[0] || this.p[1] !== p[1] || this.p[4] !== p[4] || this.p[5] !== p[5] || this.p[12] !== p[12] || this.p[13] !== p[13])) {
		this.p = p;
		this.mdf.p = true;
		updated = true;
	}
	return updated;
}
function TextProperty(elem, data, dynamicProperties){
	this._frameId = -99999;
	this.pv = '';
	this.v = '';
	this.kf = false;
	this.firstFrame = true;
	this.mdf = true;
	this.data = data;
	this.elem = elem;
	this.keysIndex = -1;
	this.currentData = {
		ascent: 0,
        boxWidth: [0,0],
        f: '',
        fStyle: '',
        fWeight: '',
        fc: '',
        j: '',
        justifyOffset: '',
        l: [],
        lh: 0,
        lineWidths: [],
        ls: '',
        of: '',
        s: '',
        sc: '',
        sw: 0,
        t: 0,
        tr: 0,
        fillColorAnim: false,
        strokeColorAnim: false,
        strokeWidthAnim: false,
        yOffset: 0,
        __complete: false

	}
	if(this.searchProperty()) {
		dynamicProperties.push(this);
	} else {
		this.getValue(true);
	}
}

TextProperty.prototype.setCurrentData = function(data){
		var currentData = this.currentData;
        currentData.ascent = data.ascent;
        currentData.boxWidth = data.boxWidth ? data.boxWidth : currentData.boxWidth;
        currentData.f = data.f;
        currentData.fStyle = data.fStyle;
        currentData.fWeight = data.fWeight;
        currentData.fc = data.fc;
        currentData.j = data.j;
        currentData.justifyOffset = data.justifyOffset;
        currentData.l = data.l;
        currentData.lh = data.lh;
        currentData.lineWidths = data.lineWidths;
        currentData.ls = data.ls;
        currentData.of = data.of;
        currentData.s = data.s;
        currentData.sc = data.sc;
        currentData.sw = data.sw;
        currentData.t = data.t;
        currentData.tr = data.tr;
        currentData.fillColorAnim = data.fillColorAnim || currentData.fillColorAnim;
        currentData.strokeColorAnim = data.strokeColorAnim || currentData.strokeColorAnim;
        currentData.strokeWidthAnim = data.strokeWidthAnim || currentData.strokeWidthAnim;
        currentData.yOffset = data.yOffset;
        currentData.__complete = false;
}

TextProperty.prototype.searchProperty = function() {
	this.kf = this.data.d.k.length > 1;
	return this.kf;
}

TextProperty.prototype.getValue = function() {
	this.mdf = false;
	var frameId = this.elem.globalData.frameId;
	if((frameId === this._frameId || !this.kf) && !this.firstFrame) {
		return;
	}
	var textKeys = this.data.d.k, textDocumentData;
    var i = 0, len = textKeys.length;
    while(i <= len - 1) {
        textDocumentData = textKeys[i].s;
        if(i === len - 1 || textKeys[i+1].t > frameId){
            break;
        }
        i += 1;
    }
    if(this.keysIndex !== i) {
    	if(!textDocumentData.__complete) {
            this.completeTextData(textDocumentData);
        }
        this.setCurrentData(textDocumentData);
        this.mdf = this.firstFrame ? false : true;
        this.pv = this.v = this.currentData.t;
        this.keysIndex = i;
    }
	this._frameId = frameId;
}

TextProperty.prototype.completeTextData = function(documentData) {
    documentData.__complete = true;
    var fontManager = this.elem.globalData.fontManager;
    var data = this.data;
    var letters = [];
    var i, len;
    var newLineFlag, index = 0, val;
    var anchorGrouping = data.m.g;
    var currentSize = 0, currentPos = 0, currentLine = 0, lineWidths = [];
    var lineWidth = 0;
    var maxLineWidth = 0;
    var j, jLen;
    var fontData = fontManager.getFontByName(documentData.f);
    var charData, cLength = 0;
    var styles = fontData.fStyle.split(' ');

    var fWeight = 'normal', fStyle = 'normal';
    len = styles.length;
    var styleName;
    for(i=0;i<len;i+=1){
        styleName = styles[i].toLowerCase();
        switch(styleName) {
            case 'italic':
            fStyle = 'italic';
            break;
            case 'bold':
            fWeight = '700';
            break;
            case 'black':
            fWeight = '900';
            break;
            case 'medium':
            fWeight = '500';
            break;
            case 'regular':
            case 'normal':
            fWeight = '400';
            case 'light':
            case 'thin':
            fWeight = '200';
            break;
        }
    }
    documentData.fWeight = fWeight;
    documentData.fStyle = fStyle;
    len = documentData.t.length;
    var trackingOffset = documentData.tr/1000*documentData.s;
    if(documentData.sz){
        var boxWidth = documentData.sz[0];
        var lastSpaceIndex = -1;
        for(i=0;i<len;i+=1){
            newLineFlag = false;
            if(documentData.t.charAt(i) === ' '){
                lastSpaceIndex = i;
            }else if(documentData.t.charCodeAt(i) === 13){
                lineWidth = 0;
                newLineFlag = true;
            }
            if(fontManager.chars){
                charData = fontManager.getCharData(documentData.t.charAt(i), fontData.fStyle, fontData.fFamily);
                cLength = newLineFlag ? 0 : charData.w*documentData.s/100;
            }else{
                //tCanvasHelper.font = documentData.s + 'px '+ fontData.fFamily;
                cLength = fontManager.measureText(documentData.t.charAt(i), documentData.f, documentData.s);
            }
            if(lineWidth + cLength > boxWidth && documentData.t.charAt(i) !== ' '){
                if(lastSpaceIndex === -1){
                    len += 1;
                } else {
                    i = lastSpaceIndex;
                }
                documentData.t = documentData.t.substr(0,i) + "\r" + documentData.t.substr(i === lastSpaceIndex ? i + 1 : i);
                lastSpaceIndex = -1;
                lineWidth = 0;
            }else {
                lineWidth += cLength;
                lineWidth += trackingOffset;
            }
        }
        len = documentData.t.length;
    }
    lineWidth = - trackingOffset;
    cLength = 0;
    var uncollapsedSpaces = 0;
    var currentChar;
    for (i = 0;i < len ;i += 1) {
        newLineFlag = false;
        currentChar = documentData.t.charAt(i);
        if(currentChar === ' '){
            val = '\u00A0';
        }else if(currentChar.charCodeAt(0) === 13){
            uncollapsedSpaces = 0;
            lineWidths.push(lineWidth);
            maxLineWidth = lineWidth > maxLineWidth ? lineWidth : maxLineWidth;
            lineWidth = - 2 * trackingOffset;
            val = '';
            newLineFlag = true;
            currentLine += 1;
        }else{
            val = documentData.t.charAt(i);
        }
        if(fontManager.chars){
            charData = fontManager.getCharData(currentChar, fontData.fStyle, fontManager.getFontByName(documentData.f).fFamily);
            cLength = newLineFlag ? 0 : charData.w*documentData.s/100;
        }else{
            //var charWidth = fontManager.measureText(val, documentData.f, documentData.s);
            //tCanvasHelper.font = documentData.s + 'px '+ fontManager.getFontByName(documentData.f).fFamily;
            cLength = fontManager.measureText(val, documentData.f, documentData.s);
        }

        //
        if(currentChar === ' '){
            uncollapsedSpaces += cLength + trackingOffset;
        } else {
            lineWidth += cLength + trackingOffset + uncollapsedSpaces;
            uncollapsedSpaces = 0;
        }
        letters.push({l:cLength,an:cLength,add:currentSize,n:newLineFlag, anIndexes:[], val: val, line: currentLine});
        if(anchorGrouping == 2){
            currentSize += cLength;
            if(val == '' || val == '\u00A0' || i == len - 1){
                if(val == '' || val == '\u00A0'){
                    currentSize -= cLength;
                }
                while(currentPos<=i){
                    letters[currentPos].an = currentSize;
                    letters[currentPos].ind = index;
                    letters[currentPos].extra = cLength;
                    currentPos += 1;
                }
                index += 1;
                currentSize = 0;
            }
        }else if(anchorGrouping == 3){
            currentSize += cLength;
            if(val == '' || i == len - 1){
                if(val == ''){
                    currentSize -= cLength;
                }
                while(currentPos<=i){
                    letters[currentPos].an = currentSize;
                    letters[currentPos].ind = index;
                    letters[currentPos].extra = cLength;
                    currentPos += 1;
                }
                currentSize = 0;
                index += 1;
            }
        }else{
            letters[index].ind = index;
            letters[index].extra = 0;
            index += 1;
        }
    }
    documentData.l = letters;
    maxLineWidth = lineWidth > maxLineWidth ? lineWidth : maxLineWidth;
    lineWidths.push(lineWidth);
    if(documentData.sz){
        documentData.boxWidth = documentData.sz[0];
        documentData.justifyOffset = 0;
    }else{
        documentData.boxWidth = maxLineWidth;
        switch(documentData.j){
            case 1:
                documentData.justifyOffset = - documentData.boxWidth;
                break;
            case 2:
                documentData.justifyOffset = - documentData.boxWidth/2;
                break;
            default:
                documentData.justifyOffset = 0;
        }
    }
    documentData.lineWidths = lineWidths;

    var animators = data.a, animatorData, letterData;
    jLen = animators.length;
    var based, ind, indexes = [];
    for(j=0;j<jLen;j+=1){
        animatorData = animators[j];
        if(animatorData.a.sc){
            documentData.strokeColorAnim = true;
        }
        if(animatorData.a.sw){
            documentData.strokeWidthAnim = true;
        }
        if(animatorData.a.fc || animatorData.a.fh || animatorData.a.fs || animatorData.a.fb){
            documentData.fillColorAnim = true;
        }
        ind = 0;
        based = animatorData.s.b;
        for(i=0;i<len;i+=1){
            letterData = letters[i];
            letterData.anIndexes[j] = ind;
            if((based == 1 && letterData.val != '') || (based == 2 && letterData.val != '' && letterData.val != '\u00A0') || (based == 3 && (letterData.n || letterData.val == '\u00A0' || i == len - 1)) || (based == 4 && (letterData.n || i == len - 1))){
                if(animatorData.s.rn === 1){
                    indexes.push(ind);
                }
                ind += 1;
            }
        }
        data.a[j].s.totalChars = ind;
        var currentInd = -1, newInd;
        if(animatorData.s.rn === 1){
            for(i = 0; i < len; i += 1){
                letterData = letters[i];
                if(currentInd != letterData.anIndexes[j]){
                    currentInd = letterData.anIndexes[j];
                    newInd = indexes.splice(Math.floor(Math.random()*indexes.length),1)[0];
                }
                letterData.anIndexes[j] = newInd;
            }
        }
    }
    documentData.yOffset = documentData.lh || documentData.s*1.2;
    documentData.ls = documentData.ls || 0;
    documentData.ascent = fontData.ascent*documentData.s/100;
}

TextProperty.prototype.updateDocumentData = function(newData, index) {
	index = index === undefined ? this.keysIndex : index;
    var dData = this.data.d.k[index].s;
    dData.__complete = false;
    dData.t = newData.t;
    this.keysIndex = -1;
    this.firstFrame = true;
    this.getValue();
}

var pooling = (function(){

	function double(arr){
		return arr.concat(Array.apply(null,{length:arr.length}))
	}

	return {
		double: double
	}
}());
var point_pool = (function(){
	var ob = {
		newPoint: newPoint,
		release: release
	}

	var _length = 0;
	var _maxLength = 8;
	var pool = Array.apply(null,{length:_maxLength});

	function newPoint(){
		var point;
		if(_length){
			_length -= 1;
			point = pool[_length];
		} else {
			point = [0.1,0.1];
		}
		return point;
	}

	function release(point) {
		if(_length === _maxLength) {
			pool = pooling.double(pool);
			_maxLength = _maxLength*2;
		}
		pool[_length] = point;
		_length += 1;
	}


	return ob;
}());
var shape_pool = (function(){
	var ob = {
		clone: clone,
		newShape: newShape,
		release: release,
		releaseArray: releaseArray
	}

	var _length = 0;
	var _maxLength = 4;
	var pool = Array.apply(null,{length:_maxLength});

	function newShape(){
		var shapePath;
		if(_length){
			_length -= 1;
			shapePath = pool[_length];
		} else {
			shapePath = new ShapePath();
		}
		return shapePath;
	}

	function release(shapePath) {
		if(_length === _maxLength) {
			pool = pooling.double(pool);
			_maxLength = _maxLength*2;
		}
		var len = shapePath._length, i;
		for(i = 0; i < len; i += 1) {
			point_pool.release(shapePath.v[i]);
			point_pool.release(shapePath.i[i]);
			point_pool.release(shapePath.o[i]);
			shapePath.v[i] = null;
			shapePath.i[i] = null;
			shapePath.o[i] = null;
		}
		shapePath._length = 0;
		shapePath.c = false;
		pool[_length] = shapePath;
		_length += 1;
	}

	function releaseArray(shapePathsCollection, length) {
		while(length--) {
			release(shapePathsCollection[length]);
		}
	}

	function clone(shape, transform) {
		var i, len = shape._length === undefined ? shape.v.length : shape._length;
		var cloned = newShape();
		cloned.setLength(len);
		cloned.c = shape.c;

		var pt;
		
		for(i = 0; i < len; i += 1) {
			if(transform){
				pt = transform.applyToPointArray(shape.v[i][0],shape.v[i][1],0,2);
				cloned.setXYAt(pt[0],pt[1],'v',i);
				point_pool.release(pt);
				pt = transform.applyToPointArray(shape.o[i][0],shape.o[i][1],0,2);
				cloned.setXYAt(pt[0],pt[1],'o',i);
				point_pool.release(pt);
				pt = transform.applyToPointArray(shape.i[i][0],shape.i[i][1],0,2);
				cloned.setXYAt(pt[0],pt[1],'i',i);
				point_pool.release(pt);
			}else{
				cloned.setTripleAt(shape.v[i][0],shape.v[i][1],shape.o[i][0],shape.o[i][1],shape.i[i][0],shape.i[i][1], i);
			}
		}
		return cloned
	}


	return ob;
}());
var shapeCollection_pool = (function(){
	var ob = {
		newShapeCollection: newShapeCollection,
		release: release,
		clone: clone
	}

	var _length = 0;
	var _maxLength = 4;
	var pool = Array.apply(null,{length:_maxLength});

	var cont = 0;

	function newShapeCollection(){
		var shapeCollection;
		if(_length){
			_length -= 1;
			shapeCollection = pool[_length];
		} else {
			shapeCollection = new ShapeCollection();
		}
		return shapeCollection;
	}

	function release(shapeCollection) {
		var i, len = shapeCollection._length;
		for(i = 0; i < len; i += 1) {
			shape_pool.release(shapeCollection.shapes[i]);
		}
		shapeCollection._length = 0;

		if(_length === _maxLength) {
			pool = pooling.double(pool);
			_maxLength = _maxLength*2;
		}
		pool[_length] = shapeCollection;
		_length += 1;
	}

	function clone(shapeCollection, originCollection) {
		release(shapeCollection);
		if(_length === _maxLength) {
			pool = pooling.double(pool);
			_maxLength = _maxLength*2;
		}
		pool[_length] = shapeCollection;
		_length += 1;
	}


	return ob;
}());
function BaseRenderer(){}
BaseRenderer.prototype.checkLayers = function(num){
    var i, len = this.layers.length, data;
    this.completeLayers = true;
    for (i = len - 1; i >= 0; i--) {
        if (!this.elements[i]) {
            data = this.layers[i];
            if(data.ip - data.st <= (num - this.layers[i].st) && data.op - data.st > (num - this.layers[i].st))
            {
                this.buildItem(i);
            }
        }
        this.completeLayers = this.elements[i] ? this.completeLayers:false;
    }
    this.checkPendingElements();
};

BaseRenderer.prototype.createItem = function(layer){
    switch(layer.ty){
        case 2:
            return this.createImage(layer);
        case 0:
            return this.createComp(layer);
        case 1:
            return this.createSolid(layer);
        case 4:
            return this.createShape(layer);
        case 5:
            return this.createText(layer);
        case 13:
            return this.createCamera(layer);
        case 99:
            return null;
    }
    return this.createBase(layer);
};

BaseRenderer.prototype.createCamera = function(){
    throw new Error('You\'re using a 3d camera. Try the html renderer.');
}

BaseRenderer.prototype.buildAllItems = function(){
    var i, len = this.layers.length;
    for(i=0;i<len;i+=1){
        this.buildItem(i);
    }
    this.checkPendingElements();
};

BaseRenderer.prototype.includeLayers = function(newLayers){
    this.completeLayers = false;
    var i, len = newLayers.length;
    var j, jLen = this.layers.length;
    for(i=0;i<len;i+=1){
        j = 0;
        while(j<jLen){
            if(this.layers[j].id == newLayers[i].id){
                this.layers[j] = newLayers[i];
                break;
            }
            j += 1;
        }
    }
};

BaseRenderer.prototype.setProjectInterface = function(pInterface){
    this.globalData.projectInterface = pInterface;
};

BaseRenderer.prototype.initItems = function(){
    if(!this.globalData.progressiveLoad){
        this.buildAllItems();
    }
};
BaseRenderer.prototype.buildElementParenting = function(element, parentName, hierarchy){
    hierarchy = hierarchy || [];
    var elements = this.elements;
    var layers = this.layers;
    var i=0, len = layers.length;
    while(i<len){
        if(layers[i].ind == parentName){
            if(!elements[i] || elements[i] === true){
                this.buildItem(i);
                this.addPendingElement(element);
            } else if(layers[i].parent !== undefined){
                hierarchy.push(elements[i]);
                elements[i]._isParent = true;
                this.buildElementParenting(element,layers[i].parent, hierarchy);
            } else {
                hierarchy.push(elements[i]);
                elements[i]._isParent = true;
                element.setHierarchy(hierarchy);
            }


        }
        i += 1;
    }
};

BaseRenderer.prototype.addPendingElement = function(element){
    this.pendingElements.push(element);
};
function SVGRenderer(animationItem, config){
    this.animationItem = animationItem;
    this.layers = null;
    this.renderedFrame = -1;
    this.globalData = {
        frameNum: -1
    };
    this.renderConfig = {
        preserveAspectRatio: (config && config.preserveAspectRatio) || 'xMidYMid meet',
        progressiveLoad: (config && config.progressiveLoad) || false,
        hideOnTransparent: (config && config.hideOnTransparent === false) ? false : true,
        viewBoxOnly: (config && config.viewBoxOnly) || false,
        className: (config && config.className) || ''
    };
    this.globalData.renderConfig = this.renderConfig;
    this.elements = [];
    this.pendingElements = [];
    this.destroyed = false;

}

extendPrototype(BaseRenderer,SVGRenderer);

SVGRenderer.prototype.createBase = function (data) {
    return new SVGBaseElement(data, this.layerElement,this.globalData,this);
};

SVGRenderer.prototype.createShape = function (data) {
    return new IShapeElement(data, this.layerElement,this.globalData,this);
};

SVGRenderer.prototype.createText = function (data) {
    return new SVGTextElement(data, this.layerElement,this.globalData,this);

};

SVGRenderer.prototype.createImage = function (data) {
    return new IImageElement(data, this.layerElement,this.globalData,this);
};

SVGRenderer.prototype.createComp = function (data) {
    return new ICompElement(data, this.layerElement,this.globalData,this);

};

SVGRenderer.prototype.createSolid = function (data) {
    return new ISolidElement(data, this.layerElement,this.globalData,this);
};

SVGRenderer.prototype.configAnimation = function(animData){
    this.layerElement = document.createElementNS(svgNS,'svg');
    this.layerElement.setAttribute('xmlns','http://www.w3.org/2000/svg');
    this.layerElement.setAttribute('viewBox','0 0 '+animData.w+' '+animData.h);
    if(!this.renderConfig.viewBoxOnly) {
        this.layerElement.setAttribute('width',animData.w);
        this.layerElement.setAttribute('height',animData.h);
        this.layerElement.style.width = '100%';
        this.layerElement.style.height = '100%';
    }
    if(this.renderConfig.className) {
        this.layerElement.setAttribute('class', this.renderConfig.className);
    }
    this.layerElement.setAttribute('preserveAspectRatio',this.renderConfig.preserveAspectRatio);
    //this.layerElement.style.transform = 'translate3d(0,0,0)';
    //this.layerElement.style.transformOrigin = this.layerElement.style.mozTransformOrigin = this.layerElement.style.webkitTransformOrigin = this.layerElement.style['-webkit-transform'] = "0px 0px 0px";
    this.animationItem.wrapper.appendChild(this.layerElement);
    //Mask animation
    var defs = document.createElementNS(svgNS, 'defs');
    this.globalData.defs = defs;
    this.layerElement.appendChild(defs);
    this.globalData.getAssetData = this.animationItem.getAssetData.bind(this.animationItem);
    this.globalData.getAssetsPath = this.animationItem.getAssetsPath.bind(this.animationItem);
    this.globalData.progressiveLoad = this.renderConfig.progressiveLoad;
    this.globalData.frameId = 0;
    this.globalData.nm = animData.nm;
    this.globalData.compSize = {
        w: animData.w,
        h: animData.h
    };
    this.data = animData;
    this.globalData.frameRate = animData.fr;
    var maskElement = document.createElementNS(svgNS, 'clipPath');
    var rect = document.createElementNS(svgNS,'rect');
    rect.setAttribute('width',animData.w);
    rect.setAttribute('height',animData.h);
    rect.setAttribute('x',0);
    rect.setAttribute('y',0);
    var maskId = 'animationMask_'+randomString(10);
    maskElement.setAttribute('id', maskId);
    maskElement.appendChild(rect);
    var maskedElement = document.createElementNS(svgNS,'g');
    maskedElement.setAttribute("clip-path", "url(" + locationHref + "#"+maskId+")");
    this.layerElement.appendChild(maskedElement);
    defs.appendChild(maskElement);
    this.layerElement = maskedElement;
    this.layers = animData.layers;
    this.globalData.fontManager = new FontManager();
    this.globalData.fontManager.addChars(animData.chars);
    this.globalData.fontManager.addFonts(animData.fonts,defs);
    this.elements = Array.apply(null,{length:animData.layers.length});
};


SVGRenderer.prototype.destroy = function () {
    this.animationItem.wrapper.innerHTML = '';
    this.layerElement = null;
    this.globalData.defs = null;
    var i, len = this.layers ? this.layers.length : 0;
    for (i = 0; i < len; i++) {
        if(this.elements[i]){
            this.elements[i].destroy();
        }
    }
    this.elements.length = 0;
    this.destroyed = true;
    this.animationItem = null;
};

SVGRenderer.prototype.updateContainerSize = function () {
};

SVGRenderer.prototype.buildItem  = function(pos){
    var elements = this.elements;
    if(elements[pos] || this.layers[pos].ty == 99){
        return;
    }
    elements[pos] = true;
    var element = this.createItem(this.layers[pos]);

    elements[pos] = element;
    if(expressionsPlugin){
        if(this.layers[pos].ty === 0){
            this.globalData.projectInterface.registerComposition(element);
        }
        element.initExpressions();
    }
    this.appendElementInPos(element,pos);
    if(this.layers[pos].tt){
        if(!this.elements[pos - 1] || this.elements[pos - 1] === true){
            this.buildItem(pos - 1);
            this.addPendingElement(element);
        } else {
            element.setMatte(elements[pos - 1].layerId);
        }
    }
};

SVGRenderer.prototype.checkPendingElements  = function(){
    while(this.pendingElements.length){
        var element = this.pendingElements.pop();
        element.checkParenting();
        if(element.data.tt){
            var i = 0, len = this.elements.length;
            while(i<len){
                if(this.elements[i] === element){
                    element.setMatte(this.elements[i - 1].layerId);
                    break;
                }
                i += 1;
            }
        }
    }
};

SVGRenderer.prototype.renderFrame = function(num){
    if(this.renderedFrame == num || this.destroyed){
        return;
    }
    if(num === null){
        num = this.renderedFrame;
    }else{
        this.renderedFrame = num;
    }
    //clearPoints();
    /*console.log('-------');
    console.log('FRAME ',num);*/
    this.globalData.frameNum = num;
    this.globalData.frameId += 1;
    this.globalData.projectInterface.currentFrame = num;
    var i, len = this.layers.length;
    if(!this.completeLayers){
        this.checkLayers(num);
    }
    for (i = len - 1; i >= 0; i--) {
        if(this.completeLayers || this.elements[i]){
            this.elements[i].prepareFrame(num - this.layers[i].st);
        }
    }
    for (i = len - 1; i >= 0; i--) {
        if(this.completeLayers || this.elements[i]){
            this.elements[i].renderFrame();
        }
    }
};

SVGRenderer.prototype.appendElementInPos = function(element, pos){
    var newElement = element.getBaseElement();
    if(!newElement){
        return;
    }
    var i = 0;
    var nextElement;
    while(i<pos){
        if(this.elements[i] && this.elements[i]!== true && this.elements[i].getBaseElement()){
            nextElement = this.elements[i].getBaseElement();
        }
        i += 1;
    }
    if(nextElement){
        this.layerElement.insertBefore(newElement, nextElement);
    } else {
        this.layerElement.appendChild(newElement);
    }
};

SVGRenderer.prototype.hide = function(){
    this.layerElement.style.display = 'none';
};

SVGRenderer.prototype.show = function(){
    this.layerElement.style.display = 'block';
};

SVGRenderer.prototype.searchExtraCompositions = function(assets){
    var i, len = assets.length;
    var floatingContainer = document.createElementNS(svgNS,'g');
    for(i=0;i<len;i+=1){
        if(assets[i].xt){
            var comp = this.createComp(assets[i],floatingContainer,this.globalData.comp,null);
            comp.initExpressions();
            //comp.compInterface = CompExpressionInterface(comp);
            //Expressions.addLayersInterface(comp.elements, this.globalData.projectInterface);
            this.globalData.projectInterface.registerComposition(comp);
        }
    }
};

function MaskElement(data,element,globalData) {
    this.dynamicProperties = [];
    this.data = data;
    this.element = element;
    this.globalData = globalData;
    this.storedData = [];
    this.masksProperties = this.data.masksProperties;
    this.viewData = Array.apply(null,{length:this.masksProperties.length});
    this.maskElement = null;
    this.firstFrame = true;
    var defs = this.globalData.defs;
    var i, len = this.masksProperties.length;


    var path, properties = this.masksProperties;
    var count = 0;
    var currentMasks = [];
    var j, jLen;
    var layerId = randomString(10);
    var rect, expansor, feMorph,x;
    var maskType = 'clipPath', maskRef = 'clip-path';
    for (i = 0; i < len; i++) {

        if((properties[i].mode !== 'a' && properties[i].mode !== 'n')|| properties[i].inv || properties[i].o.k !== 100){
            maskType = 'mask';
            maskRef = 'mask';
        }

        if((properties[i].mode == 's' || properties[i].mode == 'i') && count == 0){
            rect = document.createElementNS(svgNS, 'rect');
            rect.setAttribute('fill', '#ffffff');
            rect.setAttribute('width', this.element.comp.data.w);
            rect.setAttribute('height', this.element.comp.data.h);
            currentMasks.push(rect);
        } else {
            rect = null;
        }

        path = document.createElementNS(svgNS, 'path');
        if(properties[i].mode == 'n') {
            this.viewData[i] = {
                op: PropertyFactory.getProp(this.element,properties[i].o,0,0.01,this.dynamicProperties),
                prop: ShapePropertyFactory.getShapeProp(this.element,properties[i],3,this.dynamicProperties,null),
                elem: path
            };
            defs.appendChild(path);
            continue;
        }
        count += 1;

        if(properties[i].mode == 's'){
            path.setAttribute('fill', '#000000');
        }else{
            path.setAttribute('fill', '#ffffff');
        }
        path.setAttribute('clip-rule','nonzero');

        if(properties[i].x.k !== 0){
            maskType = 'mask';
            maskRef = 'mask';
            x = PropertyFactory.getProp(this.element,properties[i].x,0,null,this.dynamicProperties);
            var filterID = 'fi_'+randomString(10);
            expansor = document.createElementNS(svgNS,'filter');
            expansor.setAttribute('id',filterID);
            feMorph = document.createElementNS(svgNS,'feMorphology');
            feMorph.setAttribute('operator','dilate');
            feMorph.setAttribute('in','SourceGraphic');
            feMorph.setAttribute('radius','0');
            expansor.appendChild(feMorph);
            defs.appendChild(expansor);
            if(properties[i].mode == 's'){
                path.setAttribute('stroke', '#000000');
            }else{
                path.setAttribute('stroke', '#ffffff');
            }
        }else{
            feMorph = null;
            x = null;
        }


        this.storedData[i] = {
             elem: path,
             x: x,
             expan: feMorph,
            lastPath: '',
            lastOperator:'',
            filterId:filterID,
            lastRadius:0
        };
        if(properties[i].mode == 'i'){
            jLen = currentMasks.length;
            var g = document.createElementNS(svgNS,'g');
            for(j=0;j<jLen;j+=1){
                g.appendChild(currentMasks[j]);
            }
            var mask = document.createElementNS(svgNS,'mask');
            mask.setAttribute('mask-type','alpha');
            mask.setAttribute('id',layerId+'_'+count);
            mask.appendChild(path);
            defs.appendChild(mask);
            g.setAttribute('mask','url(' + locationHref + '#'+layerId+'_'+count+')');

            currentMasks.length = 0;
            currentMasks.push(g);
        }else{
            currentMasks.push(path);
        }
        if(properties[i].inv && !this.solidPath){
            this.solidPath = this.createLayerSolidPath();
        }
        this.viewData[i] = {
            elem: path,
            lastPath: '',
            op: PropertyFactory.getProp(this.element,properties[i].o,0,0.01,this.dynamicProperties),
            prop:ShapePropertyFactory.getShapeProp(this.element,properties[i],3,this.dynamicProperties,null)
        };
        if(rect){
            this.viewData[i].invRect = rect;
        }
        if(!this.viewData[i].prop.k){
            this.drawPath(properties[i],this.viewData[i].prop.v,this.viewData[i]);
        }
    }

    this.maskElement = document.createElementNS(svgNS, maskType);

    len = currentMasks.length;
    for(i=0;i<len;i+=1){
        this.maskElement.appendChild(currentMasks[i]);
    }

    this.maskElement.setAttribute('id', layerId);
    if(count > 0){
        this.element.maskedElement.setAttribute(maskRef, "url(" + locationHref + "#" + layerId + ")");
    }

    defs.appendChild(this.maskElement);
};

MaskElement.prototype.getMaskProperty = function(pos){
    return this.viewData[pos].prop;
};

MaskElement.prototype.prepareFrame = function(){
    var i, len = this.dynamicProperties.length;
    for(i=0;i<len;i+=1){
        this.dynamicProperties[i].getValue();

    }
};

MaskElement.prototype.renderFrame = function (finalMat) {
    var i, len = this.masksProperties.length;
    for (i = 0; i < len; i++) {
        if(this.viewData[i].prop.mdf || this.firstFrame){
            this.drawPath(this.masksProperties[i],this.viewData[i].prop.v,this.viewData[i]);
        }
        if(this.viewData[i].op.mdf || this.firstFrame){
            this.viewData[i].elem.setAttribute('fill-opacity',this.viewData[i].op.v);
        }
        if(this.masksProperties[i].mode !== 'n'){
            if(this.viewData[i].invRect && (this.element.finalTransform.mProp.mdf || this.firstFrame)){
                this.viewData[i].invRect.setAttribute('x', -finalMat.props[12]);
                this.viewData[i].invRect.setAttribute('y', -finalMat.props[13]);
            }
            if(this.storedData[i].x && (this.storedData[i].x.mdf || this.firstFrame)){
                var feMorph = this.storedData[i].expan;
                if(this.storedData[i].x.v < 0){
                    if(this.storedData[i].lastOperator !== 'erode'){
                        this.storedData[i].lastOperator = 'erode';
                        this.storedData[i].elem.setAttribute('filter','url(' + locationHref + '#'+this.storedData[i].filterId+')');
                    }
                    feMorph.setAttribute('radius',-this.storedData[i].x.v);
                }else{
                    if(this.storedData[i].lastOperator !== 'dilate'){
                        this.storedData[i].lastOperator = 'dilate';
                        this.storedData[i].elem.setAttribute('filter',null);
                    }
                    this.storedData[i].elem.setAttribute('stroke-width', this.storedData[i].x.v*2);

                }
            }
        }
    }
    this.firstFrame = false;
};

MaskElement.prototype.getMaskelement = function () {
    return this.maskElement;
};

MaskElement.prototype.createLayerSolidPath = function(){
    var path = 'M0,0 ';
    path += ' h' + this.globalData.compSize.w ;
    path += ' v' + this.globalData.compSize.h ;
    path += ' h-' + this.globalData.compSize.w ;
    path += ' v-' + this.globalData.compSize.h + ' ';
    return path;
};

MaskElement.prototype.drawPath = function(pathData,pathNodes,viewData){
    var pathString = " M"+pathNodes.v[0][0]+','+pathNodes.v[0][1];
    var i, len;
    len = pathNodes._length;
    for(i=1;i<len;i+=1){
        //pathString += " C"+pathNodes.o[i-1][0]+','+pathNodes.o[i-1][1] + " "+pathNodes.i[i][0]+','+pathNodes.i[i][1] + " "+pathNodes.v[i][0]+','+pathNodes.v[i][1];
        pathString += " C"+bm_rnd(pathNodes.o[i-1][0])+','+bm_rnd(pathNodes.o[i-1][1]) + " "+bm_rnd(pathNodes.i[i][0])+','+bm_rnd(pathNodes.i[i][1]) + " "+bm_rnd(pathNodes.v[i][0])+','+bm_rnd(pathNodes.v[i][1]);
    }
        //pathString += " C"+pathNodes.o[i-1][0]+','+pathNodes.o[i-1][1] + " "+pathNodes.i[0][0]+','+pathNodes.i[0][1] + " "+pathNodes.v[0][0]+','+pathNodes.v[0][1];
    if(pathNodes.c && len > 1){
        pathString += " C"+bm_rnd(pathNodes.o[i-1][0])+','+bm_rnd(pathNodes.o[i-1][1]) + " "+bm_rnd(pathNodes.i[0][0])+','+bm_rnd(pathNodes.i[0][1]) + " "+bm_rnd(pathNodes.v[0][0])+','+bm_rnd(pathNodes.v[0][1]);
    }
    //pathNodes.__renderedString = pathString;


    if(viewData.lastPath !== pathString){
        if(viewData.elem){
            if(!pathNodes.c){
                viewData.elem.setAttribute('d','');
            }else if(pathData.inv){
                viewData.elem.setAttribute('d',this.solidPath + pathString);
            }else{
                viewData.elem.setAttribute('d',pathString);
            }
        }
        viewData.lastPath = pathString;
    }
};

MaskElement.prototype.destroy = function(){
    this.element = null;
    this.globalData = null;
    this.maskElement = null;
    this.data = null;
    this.masksProperties = null;
};
function BaseElement(){
};
BaseElement.prototype.checkMasks = function(){
    if(!this.data.hasMask){
        return false;
    }
    var i = 0, len = this.data.masksProperties.length;
    while(i<len) {
        if((this.data.masksProperties[i].mode !== 'n' && this.data.masksProperties[i].cl !== false)) {
            return true;
        }
        i += 1;
    }
    return false;
}

BaseElement.prototype.checkParenting = function(){
    if(this.data.parent !== undefined){
        this.comp.buildElementParenting(this, this.data.parent);
    }
}

BaseElement.prototype.prepareFrame = function(num){
    if(this.data.ip - this.data.st <= num && this.data.op - this.data.st > num)
    {
        if(this.isVisible !== true){
            this.elemMdf = true;
            this.globalData.mdf = true;
            this.isVisible = true;
            this.firstFrame = true;
            if(this.data.hasMask){
                this.maskManager.firstFrame = true;
            }
        }
    }else{
        if(this.isVisible !== false){
            this.elemMdf = true;
            this.globalData.mdf = true;
            this.isVisible = false;
        }
    }
    var i, len = this.dynamicProperties.length;
    for(i=0;i<len;i+=1){
        if(this.isVisible || (this._isParent && this.dynamicProperties[i].type === 'transform')){
            this.dynamicProperties[i].getValue();
            if(this.dynamicProperties[i].mdf){
                this.elemMdf = true;
                this.globalData.mdf = true;
            }
        }
    }
    if(this.data.hasMask && this.isVisible){
        this.maskManager.prepareFrame(num*this.data.sr);
    }
    
    /* TODO check this
    if(this.data.sy){
        if(this.data.sy[0].renderedData[num]){
            if(this.data.sy[0].renderedData[num].c){
                this.feFlood.setAttribute('flood-color','rgb('+Math.round(this.data.sy[0].renderedData[num].c[0])+','+Math.round(this.data.sy[0].renderedData[num].c[1])+','+Math.round(this.data.sy[0].renderedData[num].c[2])+')');
            }
            if(this.data.sy[0].renderedData[num].s){
                this.feMorph.setAttribute('radius',this.data.sy[0].renderedData[num].s);
            }
        }
    }
    */


    this.currentFrameNum = num*this.data.sr;
    return this.isVisible;
};

BaseElement.prototype.globalToLocal = function(pt){
    var transforms = [];
    transforms.push(this.finalTransform);
    var flag = true;
    var comp = this.comp;
    while(flag){
        if(comp.finalTransform){
            if(comp.data.hasMask){
                transforms.splice(0,0,comp.finalTransform);
            }
            comp = comp.comp;
        } else {
            flag = false;
        }
    }
    var i, len = transforms.length,ptNew;
    for(i=0;i<len;i+=1){
        ptNew = transforms[i].mat.applyToPointArray(0,0,0);
        //ptNew = transforms[i].mat.applyToPointArray(pt[0],pt[1],pt[2]);
        pt = [pt[0] - ptNew[0],pt[1] - ptNew[1],0];
    }
    return pt;
};

BaseElement.prototype.initExpressions = function(){
    this.layerInterface = LayerExpressionInterface(this);
    //layers[i].layerInterface = LayerExpressionInterface(layers[i]);
    //layers[i].layerInterface = LayerExpressionInterface(layers[i]);
    if(this.data.hasMask){
        this.layerInterface.registerMaskInterface(this.maskManager);
    }
    var effectsInterface = EffectsExpressionInterface.createEffectsInterface(this,this.layerInterface);
    this.layerInterface.registerEffectsInterface(effectsInterface);

    if(this.data.ty === 0 || this.data.xt){
        this.compInterface = CompExpressionInterface(this);
    } else if(this.data.ty === 4){
        this.layerInterface.shapeInterface = ShapeExpressionInterface.createShapeInterface(this.shapesData,this.itemsData,this.layerInterface);
    } else if(this.data.ty === 5){
        this.layerInterface.textInterface = TextExpressionInterface(this);
    }
}

BaseElement.prototype.setBlendMode = function(){
    var blendModeValue = '';
    switch(this.data.bm){
        case 1:
            blendModeValue = 'multiply';
            break;
        case 2:
            blendModeValue = 'screen';
            break;
        case 3:
            blendModeValue = 'overlay';
            break;
        case 4:
            blendModeValue = 'darken';
            break;
        case 5:
            blendModeValue = 'lighten';
            break;
        case 6:
            blendModeValue = 'color-dodge';
            break;
        case 7:
            blendModeValue = 'color-burn';
            break;
        case 8:
            blendModeValue = 'hard-light';
            break;
        case 9:
            blendModeValue = 'soft-light';
            break;
        case 10:
            blendModeValue = 'difference';
            break;
        case 11:
            blendModeValue = 'exclusion';
            break;
        case 12:
            blendModeValue = 'hue';
            break;
        case 13:
            blendModeValue = 'saturation';
            break;
        case 14:
            blendModeValue = 'color';
            break;
        case 15:
            blendModeValue = 'luminosity';
            break;
    }
    var elem = this.baseElement || this.layerElement;

    elem.style['mix-blend-mode'] = blendModeValue;
}

BaseElement.prototype.init = function(){
    if(!this.data.sr){
        this.data.sr = 1;
    }
    this.dynamicProperties = this.dynamicProperties || [];
    if(this.data.ef){
        this.effects = new EffectsManager(this.data,this,this.dynamicProperties);
        //this.effect = this.effectsManager.bind(this.effectsManager);
    }
    //this.elemInterface = buildLayerExpressionInterface(this);
    this.hidden = false;
    this.firstFrame = true;
    this.isVisible = false;
    this._isParent = false;
    this.currentFrameNum = -99999;
    this.lastNum = -99999;
    if(this.data.ks){
        this.finalTransform = {
            mProp: PropertyFactory.getProp(this,this.data.ks,2,null,this.dynamicProperties),
            matMdf: false,
            opMdf: false,
            mat: new Matrix(),
            opacity: 1
        };
        if(this.data.ao){
            this.finalTransform.mProp.autoOriented = true;
        }
        this.finalTransform.op = this.finalTransform.mProp.o;
        this.transform = this.finalTransform.mProp;
        if(this.data.ty !== 11){
            this.createElements();
        }
        if(this.data.hasMask){
            this.addMasks(this.data);
        }
    }
    this.elemMdf = false;
};
BaseElement.prototype.getType = function(){
    return this.type;
};

BaseElement.prototype.resetHierarchy = function(){
    if(!this.hierarchy){
        this.hierarchy = [];
    }else{
        this.hierarchy.length = 0;
    }
};

BaseElement.prototype.getHierarchy = function(){
    if(!this.hierarchy){
        this.hierarchy = [];
    }
    return this.hierarchy;
};

BaseElement.prototype.setHierarchy = function(hierarchy){
    this.hierarchy = hierarchy;
};

BaseElement.prototype.getLayerSize = function(){
    if(this.data.ty === 5){
        return {w:this.data.textData.width,h:this.data.textData.height};
    }else{
        return {w:this.data.width,h:this.data.height};
    }
};

BaseElement.prototype.hide = function(){

};

BaseElement.prototype.sourceRectAtTime = function(){
    return {
        top:0,
        left:0,
        width:100,
        height:100
    }
};

BaseElement.prototype.mHelper = new Matrix();
function SVGBaseElement(data,parentContainer,globalData,comp, placeholder){
    this.globalData = globalData;
    this.comp = comp;
    this.data = data;
    this.matteElement = null;
    this.transformedElement = null;
    this.isTransparent = false;
    this.parentContainer = parentContainer;
    this.layerId = placeholder ? placeholder.layerId : 'ly_'+randomString(10);
    this.placeholder = placeholder;
    this._sizeChanged = false;
    this.init();
};

createElement(BaseElement, SVGBaseElement);

SVGBaseElement.prototype.createElements = function(){
    this.layerElement = document.createElementNS(svgNS,'g');
    this.transformedElement = this.layerElement;
    if(this.data.hasMask){
        this.maskedElement = this.layerElement;
    }
    var layerElementParent = null;
    if(this.data.td){
        if(this.data.td == 3 || this.data.td == 1){
            var masker = document.createElementNS(svgNS,'mask');
            masker.setAttribute('id',this.layerId);
            masker.setAttribute('mask-type',this.data.td == 3 ? 'luminance':'alpha');
            masker.appendChild(this.layerElement);
            layerElementParent = masker;
            this.globalData.defs.appendChild(masker);
            ////// This is only for IE and Edge when mask if of type alpha
            if(!featureSupport.maskType && this.data.td == 1){
                masker.setAttribute('mask-type','luminance');
                var filId = randomString(10);
                var fil = filtersFactory.createFilter(filId);
                this.globalData.defs.appendChild(fil);
                fil.appendChild(filtersFactory.createAlphaToLuminanceFilter());
                var gg = document.createElementNS(svgNS,'g');
                gg.appendChild(this.layerElement);
                layerElementParent = gg;
                masker.appendChild(gg);
                gg.setAttribute('filter','url(' + locationHref + '#'+filId+')');
            }
        }else if(this.data.td == 2){
            var maskGroup = document.createElementNS(svgNS,'mask');
            maskGroup.setAttribute('id',this.layerId);
            maskGroup.setAttribute('mask-type','alpha');
            var maskGrouper = document.createElementNS(svgNS,'g');
            maskGroup.appendChild(maskGrouper);
            var filId = randomString(10);
            var fil = filtersFactory.createFilter(filId);
            ////

            var feColorMatrix = document.createElementNS(svgNS,'feColorMatrix');
            feColorMatrix.setAttribute('type','matrix');
            feColorMatrix.setAttribute('color-interpolation-filters','sRGB');
            feColorMatrix.setAttribute('values','1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 -1 1');
            fil.appendChild(feColorMatrix);

            ////
            /*var feCTr = document.createElementNS(svgNS,'feComponentTransfer');
            feCTr.setAttribute('in','SourceGraphic');
            fil.appendChild(feCTr);
            var feFunc = document.createElementNS(svgNS,'feFuncA');
            feFunc.setAttribute('type','table');
            feFunc.setAttribute('tableValues','1.0 0.0');
            feCTr.appendChild(feFunc);*/
            this.globalData.defs.appendChild(fil);
            var alphaRect = document.createElementNS(svgNS,'rect');
            alphaRect.setAttribute('width',this.comp.data.w);
            alphaRect.setAttribute('height',this.comp.data.h);
            alphaRect.setAttribute('x','0');
            alphaRect.setAttribute('y','0');
            alphaRect.setAttribute('fill','#ffffff');
            alphaRect.setAttribute('opacity','0');
            maskGrouper.setAttribute('filter','url(' + locationHref + '#'+filId+')');
            maskGrouper.appendChild(alphaRect);
            maskGrouper.appendChild(this.layerElement);
            layerElementParent = maskGrouper;
            if(!featureSupport.maskType){
                maskGroup.setAttribute('mask-type','luminance');
                fil.appendChild(filtersFactory.createAlphaToLuminanceFilter());
                var gg = document.createElementNS(svgNS,'g');
                maskGrouper.appendChild(alphaRect);
                gg.appendChild(this.layerElement);
                layerElementParent = gg;
                maskGrouper.appendChild(gg);
            }
            this.globalData.defs.appendChild(maskGroup);
        }
    }else if(this.data.hasMask || this.data.tt){
        if(this.data.tt){
            this.matteElement = document.createElementNS(svgNS,'g');
            this.matteElement.appendChild(this.layerElement);
            layerElementParent = this.matteElement;
            this.baseElement = this.matteElement;
        }else{
            this.baseElement = this.layerElement;
        }
    }else{
        this.baseElement = this.layerElement;
    }
    if((this.data.ln || this.data.cl) && (this.data.ty === 4 || this.data.ty === 0)){
        if(this.data.ln){
            this.layerElement.setAttribute('id',this.data.ln);
        }
        if(this.data.cl){
            this.layerElement.setAttribute('class',this.data.cl);
        }
    }
    if(this.data.ty === 0){
            var cp = document.createElementNS(svgNS, 'clipPath');
            var pt = document.createElementNS(svgNS,'path');
            pt.setAttribute('d','M0,0 L'+this.data.w+',0'+' L'+this.data.w+','+this.data.h+' L0,'+this.data.h+'z');
            var clipId = 'cp_'+randomString(8);
            cp.setAttribute('id',clipId);
            cp.appendChild(pt);
            this.globalData.defs.appendChild(cp);
        if(this.checkMasks()){
            var cpGroup = document.createElementNS(svgNS,'g');
            cpGroup.setAttribute('clip-path','url(' + locationHref + '#'+clipId+')');
            cpGroup.appendChild(this.layerElement);
            this.transformedElement = cpGroup;
            if(layerElementParent){
                layerElementParent.appendChild(this.transformedElement);
            } else {
                this.baseElement = this.transformedElement;
            }
        } else {
            this.layerElement.setAttribute('clip-path','url(' + locationHref + '#'+clipId+')');
        }
        
    }
    if(this.data.bm !== 0){
        this.setBlendMode();
    }
    if(this.layerElement !== this.parentContainer){
        this.placeholder = null;
    }
    /* Todo performance killer
    if(this.data.sy){
        var filterID = 'st_'+randomString(10);
        var c = this.data.sy[0].c.k;
        var r = this.data.sy[0].s.k;
        var expansor = document.createElementNS(svgNS,'filter');
        expansor.setAttribute('id',filterID);
        var feFlood = document.createElementNS(svgNS,'feFlood');
        this.feFlood = feFlood;
        if(!c[0].e){
            feFlood.setAttribute('flood-color','rgb('+c[0]+','+c[1]+','+c[2]+')');
        }
        feFlood.setAttribute('result','base');
        expansor.appendChild(feFlood);
        var feMorph = document.createElementNS(svgNS,'feMorphology');
        feMorph.setAttribute('operator','dilate');
        feMorph.setAttribute('in','SourceGraphic');
        feMorph.setAttribute('result','bigger');
        this.feMorph = feMorph;
        if(!r.length){
            feMorph.setAttribute('radius',this.data.sy[0].s.k);
        }
        expansor.appendChild(feMorph);
        var feColorMatrix = document.createElementNS(svgNS,'feColorMatrix');
        feColorMatrix.setAttribute('result','mask');
        feColorMatrix.setAttribute('in','bigger');
        feColorMatrix.setAttribute('type','matrix');
        feColorMatrix.setAttribute('values','0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0');
        expansor.appendChild(feColorMatrix);
        var feComposite = document.createElementNS(svgNS,'feComposite');
        feComposite.setAttribute('result','drop');
        feComposite.setAttribute('in','base');
        feComposite.setAttribute('in2','mask');
        feComposite.setAttribute('operator','in');
        expansor.appendChild(feComposite);
        var feBlend = document.createElementNS(svgNS,'feBlend');
        feBlend.setAttribute('in','SourceGraphic');
        feBlend.setAttribute('in2','drop');
        feBlend.setAttribute('mode','normal');
        expansor.appendChild(feBlend);
        this.globalData.defs.appendChild(expansor);
        var cont = document.createElementNS(svgNS,'g');
        if(this.layerElement === this.parentContainer){
            this.layerElement = cont;
        }else{
            cont.appendChild(this.layerElement);
        }
        cont.setAttribute('filter','url(#'+filterID+')');
        if(this.data.td){
            cont.setAttribute('data-td',this.data.td);
        }
        if(this.data.td == 3){
            this.globalData.defs.appendChild(cont);
        }else if(this.data.td == 2){
            maskGrouper.appendChild(cont);
        }else if(this.data.td == 1){
            masker.appendChild(cont);
        }else{
            if(this.data.hasMask && this.data.tt){
                this.matteElement.appendChild(cont);
            }else{
                this.appendNodeToParent(cont);
            }
        }
    }*/
    if(this.data.ef){
        this.effectsManager = new SVGEffects(this);
    }
    this.checkParenting();
};


SVGBaseElement.prototype.setBlendMode = BaseElement.prototype.setBlendMode;

SVGBaseElement.prototype.renderFrame = function(parentTransform){
    if(this.data.ty === 3 || this.data.hd || !this.isVisible){
        return false;
    }

    this.lastNum = this.currentFrameNum;
    this.finalTransform.opMdf = this.firstFrame || this.finalTransform.op.mdf;
    this.finalTransform.matMdf = this.firstFrame || this.finalTransform.mProp.mdf;
    this.finalTransform.opacity = this.finalTransform.op.v;

    var mat;
    var finalMat = this.finalTransform.mat;

    if(this.hierarchy){
        var i = 0, len = this.hierarchy.length;
        if(!this.finalTransform.matMdf) {
            while(i < len) {
                if(this.hierarchy[i].finalTransform.mProp.mdf) {
                    this.finalTransform.matMdf = true;
                    break;
                }
                i += 1;
            }
        }
        
        if(this.finalTransform.matMdf) {
            mat = this.finalTransform.mProp.v.props;
            finalMat.cloneFromProps(mat);
            for(i=0;i<len;i+=1){
                mat = this.hierarchy[i].finalTransform.mProp.v.props;
                finalMat.transform(mat[0],mat[1],mat[2],mat[3],mat[4],mat[5],mat[6],mat[7],mat[8],mat[9],mat[10],mat[11],mat[12],mat[13],mat[14],mat[15]);
            }
        }
        
    }else if(this.isVisible){
        finalMat = this.finalTransform.mProp.v;
    }
    if(this.finalTransform.matMdf && this.layerElement){
        this.transformedElement.setAttribute('transform',finalMat.to2dCSS());
    }
    if(this.finalTransform.opMdf && this.layerElement){
        if(this.finalTransform.op.v <= 0) {
            if(!this.isTransparent && this.globalData.renderConfig.hideOnTransparent){
                this.isTransparent = true;
                this.hide();
            }
        } else if(this.hidden && this.isTransparent){
            this.isTransparent = false;
            this.show();
        }
        this.transformedElement.setAttribute('opacity',this.finalTransform.op.v);
    }

    if(this.data.hasMask){
        this.maskManager.renderFrame(finalMat);
    }
    if(this.effectsManager){
        this.effectsManager.renderFrame(this.firstFrame);
    }
    return this.isVisible;
};

SVGBaseElement.prototype.destroy = function(){
    this.layerElement = null;
    this.parentContainer = null;
    if(this.matteElement) {
        this.matteElement = null;
    }
    if(this.maskManager) {
        this.maskManager.destroy();
    }
};

SVGBaseElement.prototype.getBaseElement = function(){
    return this.baseElement;
};
SVGBaseElement.prototype.addMasks = function(data){
    this.maskManager = new MaskElement(data,this,this.globalData);
};

SVGBaseElement.prototype.setMatte = function(id){
    if(!this.matteElement){
        return;
    }
    this.matteElement.setAttribute("mask", "url(" + locationHref + "#" + id + ")");
};

SVGBaseElement.prototype.hide = function(){
    if(!this.hidden){
        this.layerElement.style.display = 'none';
        this.hidden = true;
    }
};

SVGBaseElement.prototype.show = function(){
    if(this.isVisible && !this.isTransparent){
        this.hidden = false;
        this.layerElement.style.display = 'block';
    }
};

function IShapeElement(data,parentContainer,globalData,comp, placeholder){
    this.shapes = [];
    this.shapesData = data.shapes;
    this.stylesList = [];
    this.itemsData = [];
    this.prevViewData = [];
    this.shapeModifiers = [];
    this.processedElements = [];
    this._parent.constructor.call(this,data,parentContainer,globalData,comp, placeholder);
}
createElement(SVGBaseElement, IShapeElement);

IShapeElement.prototype.identityMatrix = new Matrix();

IShapeElement.prototype.lcEnum = {
    '1': 'butt',
    '2': 'round',
    '3': 'square'
}

IShapeElement.prototype.ljEnum = {
    '1': 'miter',
    '2': 'round',
    '3': 'butt'
}

IShapeElement.prototype.searchProcessedElement = function(elem){
    var i = this.processedElements.length;
    while(i){
        i -= 1;
        if(this.processedElements[i].elem === elem){
            return this.processedElements[i].pos;
        }
    }
    return 0;
};

IShapeElement.prototype.addProcessedElement = function(elem, pos){
    var i = this.processedElements.length;
    while(i){
        i -= 1;
        if(this.processedElements[i].elem === elem){
            this.processedElements[i].pos = pos;
            break;
        }
    }
    if(i === 0){
        this.processedElements.push({
            elem: elem,
            pos: pos
        })
    }
};

IShapeElement.prototype.buildExpressionInterface = function(){};

IShapeElement.prototype.createElements = function(){
    //TODO check if I can use symbol so i can set its viewBox
    this._parent.createElements.call(this);
    this.searchShapes(this.shapesData,this.itemsData,this.prevViewData,this.layerElement,this.dynamicProperties, 0, [], true);
    if(!this.data.hd || this.data.td){
        styleUnselectableDiv(this.layerElement);
    }
};

IShapeElement.prototype.setGradientData = function(pathElement,arr,data){

    var gradientId = 'gr_'+randomString(10);
    var gfill;
    if(arr.t === 1){
        gfill = document.createElementNS(svgNS,'linearGradient');
    } else {
        gfill = document.createElementNS(svgNS,'radialGradient');
    }
    gfill.setAttribute('id',gradientId);
    gfill.setAttribute('spreadMethod','pad');
    gfill.setAttribute('gradientUnits','userSpaceOnUse');
    var stops = [];
    var stop, j, jLen;
    jLen = arr.g.p*4;
    for(j=0;j<jLen;j+=4){
        stop = document.createElementNS(svgNS,'stop');
        gfill.appendChild(stop);
        stops.push(stop);
    }
    pathElement.setAttribute( arr.ty === 'gf' ? 'fill':'stroke','url(#'+gradientId+')');
    this.globalData.defs.appendChild(gfill);
    data.gf = gfill;
    data.cst = stops;
}

IShapeElement.prototype.setGradientOpacity = function(arr, data, styleOb){
    if((arr.g.k.k[0].s && arr.g.k.k[0].s.length > arr.g.p*4) || arr.g.k.k.length > arr.g.p*4){
        var opFill;
        var stop, j, jLen;
        var mask = document.createElementNS(svgNS,"mask");
        var maskElement = document.createElementNS(svgNS, 'path');
        mask.appendChild(maskElement);
        var opacityId = 'op_'+randomString(10);
        var maskId = 'mk_'+randomString(10);
        mask.setAttribute('id',maskId);
        if(arr.t === 1){
            opFill = document.createElementNS(svgNS,'linearGradient');
        } else {
            opFill = document.createElementNS(svgNS,'radialGradient');
        }
        opFill.setAttribute('id',opacityId);
        opFill.setAttribute('spreadMethod','pad');
        opFill.setAttribute('gradientUnits','userSpaceOnUse');
        jLen = arr.g.k.k[0].s ? arr.g.k.k[0].s.length : arr.g.k.k.length;
        var stops = [];
        for(j=arr.g.p*4;j<jLen;j+=2){
            stop = document.createElementNS(svgNS,'stop');
            stop.setAttribute('stop-color','rgb(255,255,255)');
            //stop.setAttribute('offset',Math.round(arr.y[j][0]*100)+'%');
            //stop.setAttribute('style','stop-color:rgb(255,255,255);stop-opacity:'+arr.y[j][1]);
            opFill.appendChild(stop);
            stops.push(stop);
        }
        maskElement.setAttribute( arr.ty === 'gf' ? 'fill':'stroke','url(#'+opacityId+')');
        this.globalData.defs.appendChild(opFill);
        this.globalData.defs.appendChild(mask);
        data.of = opFill;
        data.ost = stops;
        styleOb.msElem = maskElement;
        return maskId;
    }
};

IShapeElement.prototype.createStyleElement = function(data, level, dynamicProperties){
    var elementData = {
    };
    var styleOb = {
        data: data,
        type: data.ty,
        d: '',
        ld: '',
        lvl: level,
        mdf: false,
        closed: false
    };
    var pathElement = document.createElementNS(svgNS, "path");
    elementData.o = PropertyFactory.getProp(this,data.o,0,0.01,dynamicProperties);
    if(data.ty == 'st' || data.ty == 'gs') {
        pathElement.setAttribute('stroke-linecap', this.lcEnum[data.lc] || 'round');
        ////pathElement.style.strokeLinecap = this.lcEnum[data.lc] || 'round';
        pathElement.setAttribute('stroke-linejoin',this.ljEnum[data.lj] || 'round');
        ////pathElement.style.strokeLinejoin = this.ljEnum[data.lj] || 'round';
        pathElement.setAttribute('fill-opacity','0');
        ////pathElement.style.fillOpacity = 0;
        if(data.lj == 1) {
            pathElement.setAttribute('stroke-miterlimit',data.ml);
            ////pathElement.style.strokeMiterlimit = data.ml;
        }

        elementData.w = PropertyFactory.getProp(this,data.w,0,null,dynamicProperties);
        if(data.d){
            var d = PropertyFactory.getDashProp(this,data.d,'svg',dynamicProperties);
            if(!d.k){
                pathElement.setAttribute('stroke-dasharray', d.dasharray);
                ////pathElement.style.strokeDasharray = d.dasharray;
                pathElement.setAttribute('stroke-dashoffset', d.dashoffset);
                ////pathElement.style.strokeDashoffset = d.dashoffset;
            }
            elementData.d = d;
        }

    }
    if(data.ty == 'fl' || data.ty == 'st'){
        elementData.c = PropertyFactory.getProp(this,data.c,1,255,dynamicProperties);
    } else {
        elementData.g = PropertyFactory.getGradientProp(this,data.g,dynamicProperties);
        if(data.t == 2){
            elementData.h = PropertyFactory.getProp(this,data.h,0,0.01,dynamicProperties);
            elementData.a = PropertyFactory.getProp(this,data.a,0,degToRads,dynamicProperties);
        }
        elementData.s = PropertyFactory.getProp(this,data.s,1,null,dynamicProperties);
        elementData.e = PropertyFactory.getProp(this,data.e,1,null,dynamicProperties);
        this.setGradientData(pathElement,data,elementData, styleOb);
        var maskId = this.setGradientOpacity(data,elementData, styleOb);
        if(maskId){
            pathElement.setAttribute('mask','url(#'+maskId+')');
        }
    }
    elementData.elem = pathElement;
    //container.appendChild(pathElement);
    if(data.r === 2) {
        pathElement.setAttribute('fill-rule', 'evenodd');
    }

    if(data.ln){
        pathElement.setAttribute('id',data.ln);
    }
    if(data.cl){
        pathElement.setAttribute('class',data.cl);
    }
    styleOb.pElem = pathElement;
    this.stylesList.push(styleOb);
    elementData.style = styleOb;
    return elementData;
}

IShapeElement.prototype.createGroupElement = function(data) {
    var elementData = {
        it: [],
        prevViewData: []
    };
    var g = document.createElementNS(svgNS,'g');
    elementData.gr = g;
    if(data.ln){
        elementData.gr.setAttribute('id',data.ln);
    }
    return elementData;
}

IShapeElement.prototype.createTransformElement = function(data, dynamicProperties) {
    var elementData = {
        transform : {
            op: PropertyFactory.getProp(this,data.o,0,0.01,dynamicProperties),
            mProps: PropertyFactory.getProp(this,data,2,null,dynamicProperties)
        },
        elements: []
    };
    return elementData;
}

IShapeElement.prototype.createShapeElement = function(data, ownTransformers, level, dynamicProperties) {
    var elementData = {
        elements : [],
        caches:[],
        styles : [],
        transformers: ownTransformers,
        lStr: ''
    };
    var ty = 4;
    if(data.ty == 'rc'){
        ty = 5;
    }else if(data.ty == 'el'){
        ty = 6;
    }else if(data.ty == 'sr'){
        ty = 7;
    }
    elementData.sh = ShapePropertyFactory.getShapeProp(this,data,ty,dynamicProperties);
    elementData.lvl = level;
    this.shapes.push(elementData.sh);
    this.addShapeToModifiers(elementData);
    return elementData;
}

var cont = 0;

IShapeElement.prototype.setElementStyles = function(){
    var j, jLen = this.stylesList.length;
    var arr = [];
    for(j=0;j<jLen;j+=1){
        if(!this.stylesList[j].closed){
            arr.push(this.stylesList[j]);
        }
    }
    return arr;
}

IShapeElement.prototype.reloadShapes = function(){
    this.firstFrame = true;
    var i, len = this.itemsData.length;
    for(i=0;i<len;i+=1){
        this.prevViewData[i] = this.itemsData[i];
    }
    this.searchShapes(this.shapesData,this.itemsData,this.prevViewData,this.layerElement,this.dynamicProperties, 0, [], true);
    var i, len = this.dynamicProperties.length;
    for(i=0;i<len;i+=1){
        this.dynamicProperties[i].getValue();
    }
    this.renderModifiers();
}

IShapeElement.prototype.searchShapes = function(arr,itemsData,prevViewData,container,dynamicProperties, level, transformers, render){
    var ownTransformers = [].concat(transformers);
    var i, len = arr.length - 1;
    var j, jLen;
    var ownStyles = [], ownModifiers = [], styleOb, currentTransform, modifier, processedPos;
    for(i=len;i>=0;i-=1){
        processedPos = this.searchProcessedElement(arr[i]);
        if(!processedPos){
            arr[i]._render = render;
        } else {
            itemsData[i] = prevViewData[processedPos - 1];
        }
        if(arr[i].ty == 'fl' || arr[i].ty == 'st' || arr[i].ty == 'gf' || arr[i].ty == 'gs'){
            if(!processedPos){
                itemsData[i] = this.createStyleElement(arr[i], level, dynamicProperties);
            } else {
                itemsData[i].style.closed = false;
            }
            if(arr[i]._render){
                container.appendChild(itemsData[i].elem);
            }
            ownStyles.push(itemsData[i].style);
        }else if(arr[i].ty == 'gr'){
            if(!processedPos){
                itemsData[i] = this.createGroupElement(arr[i]);
            } else {
                jLen = itemsData[i].it.length;
                for(j=0;j<jLen;j+=1){
                    itemsData[i].prevViewData[j] = itemsData[i].it[j];
                }
            }
            this.searchShapes(arr[i].it,itemsData[i].it,itemsData[i].prevViewData,itemsData[i].gr,dynamicProperties, level + 1, ownTransformers, render);
            if(arr[i]._render){
                container.appendChild(itemsData[i].gr);
            }
        }else if(arr[i].ty == 'tr'){
            if(!processedPos){
                itemsData[i] = this.createTransformElement(arr[i], dynamicProperties);
            }
            currentTransform = itemsData[i].transform;
            ownTransformers.push(currentTransform);
        }else if(arr[i].ty == 'sh' || arr[i].ty == 'rc' || arr[i].ty == 'el' || arr[i].ty == 'sr'){
            if(!processedPos){
                itemsData[i] = this.createShapeElement(arr[i], ownTransformers, level, dynamicProperties);
            }
            itemsData[i].elements = this.setElementStyles();

        }else if(arr[i].ty == 'tm' || arr[i].ty == 'rd' || arr[i].ty == 'ms'){
            if(!processedPos){
                modifier = ShapeModifiers.getModifier(arr[i].ty);
                modifier.init(this,arr[i],dynamicProperties);
                itemsData[i] = modifier;
                this.shapeModifiers.push(modifier);
            } else {
                modifier = itemsData[i];
                modifier.closed = false;
            }
            ownModifiers.push(modifier);
        }else if(arr[i].ty == 'rp'){
            if(!processedPos){
                modifier = ShapeModifiers.getModifier(arr[i].ty);
                itemsData[i] = modifier;
                modifier.init(this,arr,i,itemsData,dynamicProperties);
                this.shapeModifiers.push(modifier);
                render = false;
            }else{
                modifier = itemsData[i];
                modifier.closed = true;
            }
            ownModifiers.push(modifier);
        }
        this.addProcessedElement(arr[i], i + 1);
    }
    len = ownStyles.length;
    for(i=0;i<len;i+=1){
        ownStyles[i].closed = true;
    }
    len = ownModifiers.length;
    for(i=0;i<len;i+=1){
        ownModifiers[i].closed = true;
    }
};

IShapeElement.prototype.addShapeToModifiers = function(data) {
    var i, len = this.shapeModifiers.length;
    for(i=0;i<len;i+=1){
        this.shapeModifiers[i].addShape(data);
    }
};

IShapeElement.prototype.renderModifiers = function() {
    if(!this.shapeModifiers.length){
        return;
    }
    var i, len = this.shapes.length;
    for(i=0;i<len;i+=1){
        this.shapes[i].reset();
    }


    len = this.shapeModifiers.length;

    for(i=len-1;i>=0;i-=1){
        this.shapeModifiers[i].processShapes(this.firstFrame);
    }
};

IShapeElement.prototype.renderFrame = function(parentMatrix){
    //this.reloadShapes();
    var renderParent = this._parent.renderFrame.call(this,parentMatrix);
    if(renderParent===false){
        this.hide();
        return;
    }
    if(this.hidden){
        this.layerElement.style.display = 'block';
        this.hidden = false;
    }
    this.renderModifiers();
    var i, len = this.stylesList.length;
    for(i=0;i<len;i+=1){
        this.stylesList[i].d = '';
        this.stylesList[i].mdf = false;
    }
    this.renderShape(this.shapesData,this.itemsData, null);

    for (i = 0; i < len; i += 1) {
        if (this.stylesList[i].ld === '0') {
            this.stylesList[i].ld = '1';
            this.stylesList[i].pElem.style.display = 'block';
            //this.stylesList[i].parent.appendChild(this.stylesList[i].pElem);
        }
        if (this.stylesList[i].mdf || this.firstFrame) {
            this.stylesList[i].pElem.setAttribute('d', this.stylesList[i].d);
            if(this.stylesList[i].msElem){
                this.stylesList[i].msElem.setAttribute('d', this.stylesList[i].d);
            }
        }
    }
    if (this.firstFrame) {
        this.firstFrame = false;
    }
};

IShapeElement.prototype.hide = function(){
    if(!this.hidden){
        this.layerElement.style.display = 'none';
        var i, len = this.stylesList.length;
        for(i=len-1;i>=0;i-=1){
            if(this.stylesList[i].ld !== '0'){
                this.stylesList[i].ld = '0';
                this.stylesList[i].pElem.style.display = 'none';
                if(this.stylesList[i].pElem.parentNode){
                    this.stylesList[i].parent = this.stylesList[i].pElem.parentNode;
                    //this.stylesList[i].pElem.parentNode.removeChild(this.stylesList[i].pElem);
                }
            }
        }
        this.hidden = true;
    }
};

IShapeElement.prototype.renderShape = function(items,data, container){
    var i, len = items.length - 1;
    var ty;
    for(i=len;i>=0;i-=1){
        ty = items[i].ty;
        if(ty == 'tr'){
            if(this.firstFrame || data[i].transform.op.mdf && container){
                container.setAttribute('opacity',data[i].transform.op.v);
            }
            if(this.firstFrame || data[i].transform.mProps.mdf && container){
                container.setAttribute('transform',data[i].transform.mProps.v.to2dCSS());
            }
        }else if(ty == 'sh' || ty == 'el' || ty == 'rc' || ty == 'sr'){
            this.renderPath(items[i],data[i]);
        }else if(ty == 'fl'){
            this.renderFill(items[i],data[i]);
        }else if(ty == 'gf'){
            this.renderGradient(items[i],data[i]);
        }else if(ty == 'gs'){
            this.renderGradient(items[i],data[i]);
            this.renderStroke(items[i],data[i]);
        }else if(ty == 'st'){
            this.renderStroke(items[i],data[i]);
        }else if(ty == 'gr'){
            this.renderShape(items[i].it,data[i].it, data[i].gr);
        }else if(ty == 'tm'){
            //
        }
    }

};

IShapeElement.prototype.buildShapeString = function(pathNodes, length, closed, mat) {
    var i, shapeString = '';
    for(i = 1; i < length; i += 1) {
        if (i === 1) {
            shapeString += " M" + mat.applyToPointStringified(pathNodes.v[0][0], pathNodes.v[0][1]);
        }
        shapeString += " C" + mat.applyToPointStringified(pathNodes.o[i - 1][0], pathNodes.o[i - 1][1]) + " " + mat.applyToPointStringified(pathNodes.i[i][0], pathNodes.i[i][1]) + " " + mat.applyToPointStringified(pathNodes.v[i][0], pathNodes.v[i][1]);
    }
    if (length === 1) {
        shapeString += " M" + mat.applyToPointStringified(pathNodes.v[0][0], pathNodes.v[0][1]);
    }
    if (closed && length) {
        shapeString += " C" + mat.applyToPointStringified(pathNodes.o[i - 1][0], pathNodes.o[i - 1][1]) + " " + mat.applyToPointStringified(pathNodes.i[0][0], pathNodes.i[0][1]) + " " + mat.applyToPointStringified(pathNodes.v[0][0], pathNodes.v[0][1]);
        shapeString += 'z';
    }
    return shapeString;
};

IShapeElement.prototype.renderPath = function(pathData,itemData){
    var len, i, j, jLen,pathStringTransformed,redraw,pathNodes,l, lLen = itemData.elements.length;
    var lvl = itemData.lvl;
    if(!pathData._render){
        return;
    }
    for(l=0;l<lLen;l+=1){
        if(itemData.elements[l].data._render){
            redraw = itemData.sh.mdf || this.firstFrame;
            pathStringTransformed = 'M0 0';
            var paths = itemData.sh.paths;
            jLen = paths._length;
            if(itemData.elements[l].lvl < lvl){
                var mat = this.mHelper.reset(), props;
                var iterations = lvl - itemData.elements[l].lvl;
                var k = itemData.transformers.length-1;
                while(iterations > 0) {
                    redraw = itemData.transformers[k].mProps.mdf || redraw;
                    props = itemData.transformers[k].mProps.v.props;
                    mat.transform(props[0],props[1],props[2],props[3],props[4],props[5],props[6],props[7],props[8],props[9],props[10],props[11],props[12],props[13],props[14],props[15]);
                    iterations --;
                    k --;
                }
                if(redraw){
                    for(j=0;j<jLen;j+=1){
                        pathNodes = paths.shapes[j];
                        if(pathNodes && pathNodes._length){
                            pathStringTransformed += this.buildShapeString(pathNodes, pathNodes._length, pathNodes.c, mat);
                        }
                    }
                    itemData.caches[l] = pathStringTransformed;
                } else {
                    pathStringTransformed = itemData.caches[l];
                }
            } else {
                if(redraw){
                    for(j=0;j<jLen;j+=1){
                        pathNodes = paths.shapes[j];
                        if(pathNodes && pathNodes._length){
                            pathStringTransformed += this.buildShapeString(pathNodes, pathNodes._length, pathNodes.c, this.identityMatrix);
                        }
                    }
                    itemData.caches[l] = pathStringTransformed;
                } else {
                    pathStringTransformed = itemData.caches[l];
                }
            }
            itemData.elements[l].d += pathStringTransformed;
            itemData.elements[l].mdf = redraw || itemData.elements[l].mdf;
        } else {
            itemData.elements[l].mdf = true;
        }
    }
};

IShapeElement.prototype.renderFill = function(styleData,itemData){
    var styleElem = itemData.style;

    if(itemData.c.mdf || this.firstFrame){
        styleElem.pElem.setAttribute('fill','rgb('+bm_floor(itemData.c.v[0])+','+bm_floor(itemData.c.v[1])+','+bm_floor(itemData.c.v[2])+')');
        ////styleElem.pElem.style.fill = 'rgb('+bm_floor(itemData.c.v[0])+','+bm_floor(itemData.c.v[1])+','+bm_floor(itemData.c.v[2])+')';
    }
    if(itemData.o.mdf || this.firstFrame){
        styleElem.pElem.setAttribute('fill-opacity',itemData.o.v);
    }
};

IShapeElement.prototype.renderGradient = function(styleData,itemData){
    var gfill = itemData.gf;
    var opFill = itemData.of;
    var pt1 = itemData.s.v,pt2 = itemData.e.v;

    if(itemData.o.mdf || this.firstFrame){
        var attr = styleData.ty === 'gf' ? 'fill-opacity':'stroke-opacity';
        itemData.elem.setAttribute(attr,itemData.o.v);
    }
    //clippedElement.setAttribute('transform','matrix(1,0,0,1,-100,0)');
    if(itemData.s.mdf || this.firstFrame){
        var attr1 = styleData.t === 1 ? 'x1':'cx';
        var attr2 = attr1 === 'x1' ? 'y1':'cy';
        gfill.setAttribute(attr1,pt1[0]);
        gfill.setAttribute(attr2,pt1[1]);
        if(opFill){
            opFill.setAttribute(attr1,pt1[0]);
            opFill.setAttribute(attr2,pt1[1]);
        }
    }
    var stops, i, len, stop;
    if(itemData.g.cmdf || this.firstFrame){
        stops = itemData.cst;
        var cValues = itemData.g.c;
        len = stops.length;
        for(i=0;i<len;i+=1){
            stop = stops[i];
            stop.setAttribute('offset',cValues[i*4]+'%');
            stop.setAttribute('stop-color','rgb('+cValues[i*4+1]+','+cValues[i*4+2]+','+cValues[i*4+3]+')');
        }
    }
    if(opFill && (itemData.g.omdf || this.firstFrame)){
        stops = itemData.ost;
        var oValues = itemData.g.o;
        len = stops.length;
        for(i=0;i<len;i+=1){
            stop = stops[i];
            stop.setAttribute('offset',oValues[i*2]+'%');
            stop.setAttribute('stop-opacity',oValues[i*2+1]);
        }
    }
    if(styleData.t === 1){
        if(itemData.e.mdf  || this.firstFrame){
            gfill.setAttribute('x2',pt2[0]);
            gfill.setAttribute('y2',pt2[1]);
            if(opFill){
                opFill.setAttribute('x2',pt2[0]);
                opFill.setAttribute('y2',pt2[1]);
            }
        }
    } else {
        var rad;
        if(itemData.s.mdf || itemData.e.mdf || this.firstFrame){
            rad = Math.sqrt(Math.pow(pt1[0]-pt2[0],2)+Math.pow(pt1[1]-pt2[1],2));
            gfill.setAttribute('r',rad);
            if(opFill){
                opFill.setAttribute('r',rad);
            }
        }
        if(itemData.e.mdf || itemData.h.mdf || itemData.a.mdf || this.firstFrame){
            if(!rad){
                rad = Math.sqrt(Math.pow(pt1[0]-pt2[0],2)+Math.pow(pt1[1]-pt2[1],2));
            }
            var ang = Math.atan2(pt2[1]-pt1[1], pt2[0]-pt1[0]);

            var percent = itemData.h.v >= 1 ? 0.99 : itemData.h.v <= -1 ? -0.99:itemData.h.v;
            var dist = rad*percent;
            var x = Math.cos(ang + itemData.a.v)*dist + pt1[0];
            var y = Math.sin(ang + itemData.a.v)*dist + pt1[1];
            gfill.setAttribute('fx',x);
            gfill.setAttribute('fy',y);
            if(opFill){
                opFill.setAttribute('fx',x);
                opFill.setAttribute('fy',y);
            }
        }
        //gfill.setAttribute('fy','200');
    }
};

IShapeElement.prototype.renderStroke = function(styleData,itemData){
    var styleElem = itemData.style;
    //TODO fix dashes
    var d = itemData.d;
    var dasharray,dashoffset;
    if(d && d.k && (d.mdf || this.firstFrame)){
        styleElem.pElem.setAttribute('stroke-dasharray', d.dasharray);
        ////styleElem.pElem.style.strokeDasharray = d.dasharray;
        styleElem.pElem.setAttribute('stroke-dashoffset', d.dashoffset);
        ////styleElem.pElem.style.strokeDashoffset = d.dashoffset;
    }
    if(itemData.c && (itemData.c.mdf || this.firstFrame)){
        styleElem.pElem.setAttribute('stroke','rgb('+bm_floor(itemData.c.v[0])+','+bm_floor(itemData.c.v[1])+','+bm_floor(itemData.c.v[2])+')');
        ////styleElem.pElem.style.stroke = 'rgb('+bm_floor(itemData.c.v[0])+','+bm_floor(itemData.c.v[1])+','+bm_floor(itemData.c.v[2])+')';
    }
    if(itemData.o.mdf || this.firstFrame){
        styleElem.pElem.setAttribute('stroke-opacity',itemData.o.v);
    }
    if(itemData.w.mdf || this.firstFrame){
        styleElem.pElem.setAttribute('stroke-width',itemData.w.v);
        if(styleElem.msElem){
            styleElem.msElem.setAttribute('stroke-width',itemData.w.v);
        }
        ////styleElem.pElem.style.strokeWidth = itemData.w.v;
    }
};

IShapeElement.prototype.destroy = function(){
    this._parent.destroy.call(this._parent);
    this.shapeData = null;
    this.itemsData = null;
    this.parentContainer = null;
    this.placeholder = null;
};

function ITextElement(data, animationItem,parentContainer,globalData){
}
ITextElement.prototype.init = function(){
    this.lettersChangedFlag = true;
    this.dynamicProperties = this.dynamicProperties || [];
    this.textAnimator = new TextAnimatorProperty(this.data.t, this.renderType, this);
    this.textProperty = new TextProperty(this, this.data.t, this.dynamicProperties);
    this._parent.init.call(this);
    this.textAnimator.searchProperties(this.dynamicProperties);
};

ITextElement.prototype.prepareFrame = function(num) {
    this._parent.prepareFrame.call(this, num);
    if(this.textProperty.mdf || this.textProperty.firstFrame) {
        this.buildNewText();
        this.textProperty.firstFrame = false;
    }
}

ITextElement.prototype.createPathShape = function(matrixHelper, shapes) {
    var j,jLen = shapes.length;
    var k, kLen, pathNodes;
    var shapeStr = '';
    for(j=0;j<jLen;j+=1){
        pathNodes = shapes[j].ks.k;
        shapeStr += this.buildShapeString(pathNodes, pathNodes.i.length, true, matrixHelper);
    }
    return shapeStr;
};

ITextElement.prototype.updateDocumentData = function(newData, index) {
    this.textProperty.updateDocumentData(newData, index);
}

ITextElement.prototype.applyTextPropertiesToMatrix = function(documentData, matrixHelper, lineNumber, xPos, yPos) {
    if(documentData.ps){
        matrixHelper.translate(documentData.ps[0],documentData.ps[1] + documentData.ascent,0);
    }
    matrixHelper.translate(0,-documentData.ls,0);
    switch(documentData.j){
        case 1:
            matrixHelper.translate(documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[lineNumber]),0,0);
            break;
        case 2:
            matrixHelper.translate(documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[lineNumber] )/2,0,0);
            break;
    }
    matrixHelper.translate(xPos, yPos, 0);
}

ITextElement.prototype.buildColor = function(colorData) {
    return 'rgb(' + Math.round(colorData[0]*255) + ',' + Math.round(colorData[1]*255) + ',' + Math.round(colorData[2]*255) + ')';
}

ITextElement.prototype.buildShapeString = IShapeElement.prototype.buildShapeString;

ITextElement.prototype.emptyProp = new LetterProps();

ITextElement.prototype.destroy = function(){
    this._parent.destroy.call(this._parent);
};
function SVGTextElement(data,parentContainer,globalData,comp, placeholder){
    this.textSpans = [];
    this.renderType = 'svg';
    this._parent.constructor.call(this,data,parentContainer,globalData,comp, placeholder);
}
createElement(SVGBaseElement, SVGTextElement);

extendPrototype(ITextElement, SVGTextElement);

SVGTextElement.prototype.createElements = function(){

    this._parent.createElements.call(this);


    if(this.data.ln){
        this.layerElement.setAttribute('id',this.data.ln);
    }
    if(this.data.cl){
        this.layerElement.setAttribute('class',this.data.cl);
    }
    if (this.data.singleShape && !this.globalData.fontManager.chars) {
        this.textContainer = document.createElementNS(svgNS,'text');
    }
};

SVGTextElement.prototype.buildNewText = function(){
    var i, len;

    var documentData = this.textProperty.currentData;
    this.renderedLetters = Array.apply(null,{length:documentData ? documentData.l.length : 0});
    if(documentData.fc) {
        this.layerElement.setAttribute('fill', this.buildColor(documentData.fc));
    }else{
        this.layerElement.setAttribute('fill', 'rgba(0,0,0,0)');
    }
    if(documentData.sc){
        this.layerElement.setAttribute('stroke', this.buildColor(documentData.sc));
        this.layerElement.setAttribute('stroke-width', documentData.sw);
    }
    this.layerElement.setAttribute('font-size', documentData.s);
    var fontData = this.globalData.fontManager.getFontByName(documentData.f);
    if(fontData.fClass){
        this.layerElement.setAttribute('class',fontData.fClass);
    } else {
        this.layerElement.setAttribute('font-family', fontData.fFamily);
        var fWeight = documentData.fWeight, fStyle = documentData.fStyle;
        this.layerElement.setAttribute('font-style', fStyle);
        this.layerElement.setAttribute('font-weight', fWeight);
    }

    var letters = documentData.l || [];
    var usesGlyphs = this.globalData.fontManager.chars;
    len = letters.length;
    if(!len){
        return;
    }
    var tSpan;
    var matrixHelper = this.mHelper;
    var shapes, shapeStr = '', singleShape = this.data.singleShape;
    var xPos = 0, yPos = 0, firstLine = true;
    var trackingOffset = documentData.tr/1000*documentData.s;
    if(singleShape && !usesGlyphs) {
        var tElement = this.textContainer;
        var justify = '';
        switch(documentData.j) {
            case 1:
                justify = 'end';
                break;
            case 2:
                justify = 'middle';
                break;
            case 2:
                justify = 'start';
                break;
        }
        tElement.setAttribute('text-anchor',justify);
        tElement.setAttribute('letter-spacing',trackingOffset);
        var textContent = documentData.t.split(String.fromCharCode(13));
        len = textContent.length;
        var yPos = documentData.ps ? documentData.ps[1] + documentData.ascent : 0;
        for ( i = 0; i < len; i += 1) {
            tSpan = this.textSpans[i] || document.createElementNS(svgNS,'tspan');
            tSpan.textContent = textContent[i];
            tSpan.setAttribute('x', 0);
            tSpan.setAttribute('y', yPos);
            tSpan.style.display = 'inherit';
            tElement.appendChild(tSpan);
            this.textSpans[i] = tSpan;
            yPos += documentData.lh;
        }
        
        this.layerElement.appendChild(tElement);
    } else {
        var cachedSpansLength = this.textSpans.length;
        var shapeData, charData;
        for (i = 0; i < len; i += 1) {
            if(!usesGlyphs || !singleShape || i === 0){
                tSpan = cachedSpansLength > i ? this.textSpans[i] : document.createElementNS(svgNS,usesGlyphs?'path':'text');
                if (cachedSpansLength <= i) {
                    tSpan.setAttribute('stroke-linecap', 'butt');
                    tSpan.setAttribute('stroke-linejoin','round');
                    tSpan.setAttribute('stroke-miterlimit','4');
                    this.textSpans[i] = tSpan;
                    this.layerElement.appendChild(tSpan);
                }
                tSpan.style.display = 'inherit';
            }
            
            matrixHelper.reset();
            if(usesGlyphs) {
                matrixHelper.scale(documentData.s / 100, documentData.s / 100);
                if (singleShape) {
                    if(letters[i].n) {
                        xPos = -trackingOffset;
                        yPos += documentData.yOffset;
                        yPos += firstLine ? 1 : 0;
                        firstLine = false;
                    }
                    this.applyTextPropertiesToMatrix(documentData, matrixHelper, letters[i].line, xPos, yPos);
                    xPos += letters[i].l || 0;
                    //xPos += letters[i].val === ' ' ? 0 : trackingOffset;
                    xPos += trackingOffset;
                }
                charData = this.globalData.fontManager.getCharData(documentData.t.charAt(i), fontData.fStyle, this.globalData.fontManager.getFontByName(documentData.f).fFamily);
                shapeData = charData && charData.data || {};
                shapes = shapeData.shapes ? shapeData.shapes[0].it : [];
                if(!singleShape){
                    tSpan.setAttribute('d',this.createPathShape(matrixHelper,shapes));
                } else {
                    shapeStr += this.createPathShape(matrixHelper,shapes);
                }
            } else {
                tSpan.textContent = letters[i].val;
                tSpan.setAttributeNS("http://www.w3.org/XML/1998/namespace", "xml:space","preserve");
            }
            //
        }
        if (singleShape) {
            tSpan.setAttribute('d',shapeStr);
        }
    }
    while (i < this.textSpans.length){
        this.textSpans[i].style.display = 'none';
        i += 1;
    }
    
    this._sizeChanged = true;
}

SVGTextElement.prototype.sourceRectAtTime = function(time){
    this.prepareFrame(this.comp.renderedFrame - this.data.st);
    this.renderLetters();
    if(this._sizeChanged){
        this._sizeChanged = false;
        var textBox = this.layerElement.getBBox();
        this.bbox = {
            top: textBox.y,
            left: textBox.x,
            width: textBox.width,
            height: textBox.height
        }
    }
    return this.bbox;
}

SVGTextElement.prototype.renderLetters = function(){

    if(!this.data.singleShape){
        this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag);
        if(this.lettersChangedFlag || this.textAnimator.lettersChangedFlag){
            this._sizeChanged = true;
            var  i,len;
            var renderedLetters = this.textAnimator.renderedLetters;

            var letters = this.textProperty.currentData.l;

            len = letters.length;
            var renderedLetter, textSpan;
            for(i=0;i<len;i+=1){
                if(letters[i].n){
                    continue;
                }
                renderedLetter = renderedLetters[i];
                textSpan = this.textSpans[i];
                if(renderedLetter.mdf.m) {
                    textSpan.setAttribute('transform',renderedLetter.m);
                }
                if(renderedLetter.mdf.o) {
                    textSpan.setAttribute('opacity',renderedLetter.o);
                }
                if(renderedLetter.mdf.sw){
                    textSpan.setAttribute('stroke-width',renderedLetter.sw);
                }
                if(renderedLetter.mdf.sc){
                    textSpan.setAttribute('stroke',renderedLetter.sc);
                }
                if(renderedLetter.mdf.fc){
                    textSpan.setAttribute('fill',renderedLetter.fc);
                }
            }
        }
    }
}

SVGTextElement.prototype.renderFrame = function(parentMatrix){

    var renderParent = this._parent.renderFrame.call(this,parentMatrix);
    if(renderParent===false){
        this.hide();
        return;
    }
    if(this.hidden){
        this.show();
    }
    if(this.firstFrame) {
        this.firstFrame = false;
    }
    this.renderLetters();
}
function SVGTintFilter(filter, filterManager){
    this.filterManager = filterManager;
    var feColorMatrix = document.createElementNS(svgNS,'feColorMatrix');
    feColorMatrix.setAttribute('type','matrix');
    feColorMatrix.setAttribute('color-interpolation-filters','linearRGB');
    feColorMatrix.setAttribute('values','0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0');
    feColorMatrix.setAttribute('result','f1');
    filter.appendChild(feColorMatrix);
    feColorMatrix = document.createElementNS(svgNS,'feColorMatrix');
    feColorMatrix.setAttribute('type','matrix');
    feColorMatrix.setAttribute('color-interpolation-filters','sRGB');
    feColorMatrix.setAttribute('values','1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0');
    feColorMatrix.setAttribute('result','f2');
    filter.appendChild(feColorMatrix);
    this.matrixFilter = feColorMatrix;
    if(filterManager.effectElements[2].p.v !== 100 || filterManager.effectElements[2].p.k){
        var feMerge = document.createElementNS(svgNS,'feMerge');
        filter.appendChild(feMerge);
        var feMergeNode;
        feMergeNode = document.createElementNS(svgNS,'feMergeNode');
        feMergeNode.setAttribute('in','SourceGraphic');
        feMerge.appendChild(feMergeNode);
        feMergeNode = document.createElementNS(svgNS,'feMergeNode');
        feMergeNode.setAttribute('in','f2');
        feMerge.appendChild(feMergeNode);
    }
}

SVGTintFilter.prototype.renderFrame = function(forceRender){
    if(forceRender || this.filterManager.mdf){
        var colorBlack = this.filterManager.effectElements[0].p.v;
        var colorWhite = this.filterManager.effectElements[1].p.v;
        var opacity = this.filterManager.effectElements[2].p.v/100;
        this.matrixFilter.setAttribute('values',(colorWhite[0]- colorBlack[0])+' 0 0 0 '+ colorBlack[0] +' '+ (colorWhite[1]- colorBlack[1]) +' 0 0 0 '+ colorBlack[1] +' '+ (colorWhite[2]- colorBlack[2]) +' 0 0 0 '+ colorBlack[2] +' 0 0 0 ' + opacity + ' 0');
    }
};
function SVGFillFilter(filter, filterManager){
    this.filterManager = filterManager;
    var feColorMatrix = document.createElementNS(svgNS,'feColorMatrix');
    feColorMatrix.setAttribute('type','matrix');
    feColorMatrix.setAttribute('color-interpolation-filters','sRGB');
    feColorMatrix.setAttribute('values','1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0');
    filter.appendChild(feColorMatrix);
    this.matrixFilter = feColorMatrix;
}
SVGFillFilter.prototype.renderFrame = function(forceRender){
    if(forceRender || this.filterManager.mdf){
        var color = this.filterManager.effectElements[2].p.v;
        var opacity = this.filterManager.effectElements[6].p.v;
        this.matrixFilter.setAttribute('values','0 0 0 0 '+color[0]+' 0 0 0 0 '+color[1]+' 0 0 0 0 '+color[2]+' 0 0 0 '+opacity+' 0');
    }
};
function SVGStrokeEffect(elem, filterManager){
    this.initialized = false;
    this.filterManager = filterManager;
    this.elem = elem;
    this.paths = [];
}

SVGStrokeEffect.prototype.initialize = function(){

    var elemChildren = this.elem.layerElement.children || this.elem.layerElement.childNodes;
    var path,groupPath, i, len;
    if(this.filterManager.effectElements[1].p.v === 1){
        len = this.elem.maskManager.masksProperties.length;
        i = 0;
    } else {
        i = this.filterManager.effectElements[0].p.v - 1;
        len = i + 1;
    }
    groupPath = document.createElementNS(svgNS,'g'); 
    groupPath.setAttribute('fill','none');
    groupPath.setAttribute('stroke-linecap','round');
    groupPath.setAttribute('stroke-dashoffset',1);
    for(i;i<len;i+=1){
        path = document.createElementNS(svgNS,'path');
        groupPath.appendChild(path);
        this.paths.push({p:path,m:i});
    }
    if(this.filterManager.effectElements[10].p.v === 3){
        var mask = document.createElementNS(svgNS,'mask');
        var id = 'stms_' + randomString(10);
        mask.setAttribute('id',id);
        mask.setAttribute('mask-type','alpha');
        mask.appendChild(groupPath);
        this.elem.globalData.defs.appendChild(mask);
        var g = document.createElementNS(svgNS,'g');
        g.setAttribute('mask','url(' + locationHref + '#'+id+')');
        if(elemChildren[0]){
            g.appendChild(elemChildren[0]);
        }
        this.elem.layerElement.appendChild(g);
        this.masker = mask;
        groupPath.setAttribute('stroke','#fff');
    } else if(this.filterManager.effectElements[10].p.v === 1 || this.filterManager.effectElements[10].p.v === 2){
        if(this.filterManager.effectElements[10].p.v === 2){
            var elemChildren = this.elem.layerElement.children || this.elem.layerElement.childNodes;
            while(elemChildren.length){
                this.elem.layerElement.removeChild(elemChildren[0]);
            }
        }
        this.elem.layerElement.appendChild(groupPath);
        this.elem.layerElement.removeAttribute('mask');
        groupPath.setAttribute('stroke','#fff');
    }
    this.initialized = true;
    this.pathMasker = groupPath;
}

SVGStrokeEffect.prototype.renderFrame = function(forceRender){
    if(!this.initialized){
        this.initialize();
    }
    var i, len = this.paths.length;
    var mask, path;
    for(i=0;i<len;i+=1){
        mask = this.elem.maskManager.viewData[this.paths[i].m];
        path = this.paths[i].p;
        if(forceRender || this.filterManager.mdf || mask.prop.mdf){
            path.setAttribute('d',mask.lastPath);
        }
        if(forceRender || this.filterManager.effectElements[9].p.mdf || this.filterManager.effectElements[4].p.mdf || this.filterManager.effectElements[7].p.mdf || this.filterManager.effectElements[8].p.mdf || mask.prop.mdf){
            var dasharrayValue;
            if(this.filterManager.effectElements[7].p.v !== 0 || this.filterManager.effectElements[8].p.v !== 100){
                var s = Math.min(this.filterManager.effectElements[7].p.v,this.filterManager.effectElements[8].p.v)/100;
                var e = Math.max(this.filterManager.effectElements[7].p.v,this.filterManager.effectElements[8].p.v)/100;
                var l = path.getTotalLength();
                dasharrayValue = '0 0 0 ' + l*s + ' ';
                var lineLength = l*(e-s);
                var segment = 1+this.filterManager.effectElements[4].p.v*2*this.filterManager.effectElements[9].p.v/100;
                var units = Math.floor(lineLength/segment);
                var j;
                for(j=0;j<units;j+=1){
                    dasharrayValue += '1 ' + this.filterManager.effectElements[4].p.v*2*this.filterManager.effectElements[9].p.v/100 + ' ';
                }
                dasharrayValue += '0 ' + l*10 + ' 0 0';
            } else {
                dasharrayValue = '1 ' + this.filterManager.effectElements[4].p.v*2*this.filterManager.effectElements[9].p.v/100;
            }
            path.setAttribute('stroke-dasharray',dasharrayValue);
        }
    }
    if(forceRender || this.filterManager.effectElements[4].p.mdf){
        this.pathMasker.setAttribute('stroke-width',this.filterManager.effectElements[4].p.v*2);
    }
    
    if(forceRender || this.filterManager.effectElements[6].p.mdf){
        this.pathMasker.setAttribute('opacity',this.filterManager.effectElements[6].p.v);
    }
    if(this.filterManager.effectElements[10].p.v === 1 || this.filterManager.effectElements[10].p.v === 2){
        if(forceRender || this.filterManager.effectElements[3].p.mdf){
            var color = this.filterManager.effectElements[3].p.v;
            this.pathMasker.setAttribute('stroke','rgb('+bm_floor(color[0]*255)+','+bm_floor(color[1]*255)+','+bm_floor(color[2]*255)+')');
        }
    }
};
function SVGTritoneFilter(filter, filterManager){
    this.filterManager = filterManager;
    var feColorMatrix = document.createElementNS(svgNS,'feColorMatrix');
    feColorMatrix.setAttribute('type','matrix');
    feColorMatrix.setAttribute('color-interpolation-filters','linearRGB');
    feColorMatrix.setAttribute('values','0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0');
    feColorMatrix.setAttribute('result','f1');
    filter.appendChild(feColorMatrix);
    var feComponentTransfer = document.createElementNS(svgNS,'feComponentTransfer');
    feComponentTransfer.setAttribute('color-interpolation-filters','sRGB');
    filter.appendChild(feComponentTransfer);
    this.matrixFilter = feComponentTransfer;
    var feFuncR = document.createElementNS(svgNS,'feFuncR');
    feFuncR.setAttribute('type','table');
    feComponentTransfer.appendChild(feFuncR);
    this.feFuncR = feFuncR;
    var feFuncG = document.createElementNS(svgNS,'feFuncG');
    feFuncG.setAttribute('type','table');
    feComponentTransfer.appendChild(feFuncG);
    this.feFuncG = feFuncG;
    var feFuncB = document.createElementNS(svgNS,'feFuncB');
    feFuncB.setAttribute('type','table');
    feComponentTransfer.appendChild(feFuncB);
    this.feFuncB = feFuncB;
}

SVGTritoneFilter.prototype.renderFrame = function(forceRender){
    if(forceRender || this.filterManager.mdf){
        var color1 = this.filterManager.effectElements[0].p.v;
        var color2 = this.filterManager.effectElements[1].p.v;
        var color3 = this.filterManager.effectElements[2].p.v;
        var tableR = color3[0] + ' ' + color2[0] + ' ' + color1[0]
        var tableG = color3[1] + ' ' + color2[1] + ' ' + color1[1]
        var tableB = color3[2] + ' ' + color2[2] + ' ' + color1[2]
        this.feFuncR.setAttribute('tableValues', tableR);
        this.feFuncG.setAttribute('tableValues', tableG);
        this.feFuncB.setAttribute('tableValues', tableB);
        //var opacity = this.filterManager.effectElements[2].p.v/100;
        //this.matrixFilter.setAttribute('values',(colorWhite[0]- colorBlack[0])+' 0 0 0 '+ colorBlack[0] +' '+ (colorWhite[1]- colorBlack[1]) +' 0 0 0 '+ colorBlack[1] +' '+ (colorWhite[2]- colorBlack[2]) +' 0 0 0 '+ colorBlack[2] +' 0 0 0 ' + opacity + ' 0');
    }
};
function SVGProLevelsFilter(filter, filterManager){
    this.filterManager = filterManager;
    var effectElements = this.filterManager.effectElements;
    var feComponentTransfer = document.createElementNS(svgNS,'feComponentTransfer');
    var feFuncR, feFuncG, feFuncB;
    
    if(effectElements[9].p.k || effectElements[9].p.v !== 0 || effectElements[10].p.k || effectElements[10].p.v !== 1 || effectElements[11].p.k || effectElements[11].p.v !== 1 || effectElements[12].p.k || effectElements[12].p.v !== 0 || effectElements[13].p.k || effectElements[13].p.v !== 1){
        this.feFuncR = this.createFeFunc('feFuncR', feComponentTransfer);
    }
    if(effectElements[16].p.k || effectElements[16].p.v !== 0 || effectElements[17].p.k || effectElements[17].p.v !== 1 || effectElements[18].p.k || effectElements[18].p.v !== 1 || effectElements[19].p.k || effectElements[19].p.v !== 0 || effectElements[20].p.k || effectElements[20].p.v !== 1){
        this.feFuncG = this.createFeFunc('feFuncG', feComponentTransfer);
    }
    if(effectElements[23].p.k || effectElements[23].p.v !== 0 || effectElements[24].p.k || effectElements[24].p.v !== 1 || effectElements[25].p.k || effectElements[25].p.v !== 1 || effectElements[26].p.k || effectElements[26].p.v !== 0 || effectElements[27].p.k || effectElements[27].p.v !== 1){
        this.feFuncB = this.createFeFunc('feFuncB', feComponentTransfer);
    }
    if(effectElements[30].p.k || effectElements[30].p.v !== 0 || effectElements[31].p.k || effectElements[31].p.v !== 1 || effectElements[32].p.k || effectElements[32].p.v !== 1 || effectElements[33].p.k || effectElements[33].p.v !== 0 || effectElements[34].p.k || effectElements[34].p.v !== 1){
        this.feFuncA = this.createFeFunc('feFuncA', feComponentTransfer);
    }
    
    if(this.feFuncR || this.feFuncG || this.feFuncB || this.feFuncA){
        feComponentTransfer.setAttribute('color-interpolation-filters','sRGB');
        filter.appendChild(feComponentTransfer);
        feComponentTransfer = document.createElementNS(svgNS,'feComponentTransfer');
    }

    if(effectElements[2].p.k || effectElements[2].p.v !== 0 || effectElements[3].p.k || effectElements[3].p.v !== 1 || effectElements[4].p.k || effectElements[4].p.v !== 1 || effectElements[5].p.k || effectElements[5].p.v !== 0 || effectElements[6].p.k || effectElements[6].p.v !== 1){

        feComponentTransfer.setAttribute('color-interpolation-filters','sRGB');
        filter.appendChild(feComponentTransfer);
        this.feFuncRComposed = this.createFeFunc('feFuncR', feComponentTransfer);
        this.feFuncGComposed = this.createFeFunc('feFuncG', feComponentTransfer);
        this.feFuncBComposed = this.createFeFunc('feFuncB', feComponentTransfer);
    }
}

SVGProLevelsFilter.prototype.createFeFunc = function(type, feComponentTransfer) {
    var feFunc = document.createElementNS(svgNS,type);
    feFunc.setAttribute('type','table');
    feComponentTransfer.appendChild(feFunc);
    return feFunc;
};

SVGProLevelsFilter.prototype.getTableValue = function(inputBlack, inputWhite, gamma, outputBlack, outputWhite) {
    var cnt = 0;
    var segments = 256;
    var perc;
    var min = Math.min(inputBlack, inputWhite);
    var max = Math.max(inputBlack, inputWhite);
    var table = Array.call(null,{length:segments});
    var colorValue;
    var pos = 0;
    var outputDelta = outputWhite - outputBlack; 
    var inputDelta = inputWhite - inputBlack; 
    while(cnt <= 256) {
        perc = cnt/256;
        if(perc <= min){
            colorValue = inputDelta < 0 ? outputWhite : outputBlack;
        } else if(perc >= max){
            colorValue = inputDelta < 0 ? outputBlack : outputWhite;
        } else {
            colorValue = (outputBlack + outputDelta * Math.pow((perc - inputBlack) / inputDelta, 1 / gamma));
        }
        table[pos++] = colorValue;
        cnt += 256/(segments-1);
    }
    return table.join(' ');
};

SVGProLevelsFilter.prototype.renderFrame = function(forceRender){
    if(forceRender || this.filterManager.mdf){
        var val, cnt, perc, bezier;
        var effectElements = this.filterManager.effectElements;
        if(this.feFuncRComposed && (forceRender || effectElements[2].p.mdf || effectElements[3].p.mdf || effectElements[4].p.mdf || effectElements[5].p.mdf || effectElements[6].p.mdf)){
            val = this.getTableValue(effectElements[2].p.v,effectElements[3].p.v,effectElements[4].p.v,effectElements[5].p.v,effectElements[6].p.v);
            this.feFuncRComposed.setAttribute('tableValues',val);
            this.feFuncGComposed.setAttribute('tableValues',val);
            this.feFuncBComposed.setAttribute('tableValues',val);
        }

        if(this.feFuncR && (forceRender || effectElements[9].p.mdf || effectElements[10].p.mdf || effectElements[11].p.mdf || effectElements[12].p.mdf || effectElements[13].p.mdf)){
            val = this.getTableValue(effectElements[9].p.v,effectElements[10].p.v,effectElements[11].p.v,effectElements[12].p.v,effectElements[13].p.v);
            this.feFuncR.setAttribute('tableValues',val);
        }

        if(this.feFuncG && (forceRender || effectElements[16].p.mdf || effectElements[17].p.mdf || effectElements[18].p.mdf || effectElements[19].p.mdf || effectElements[20].p.mdf)){
            val = this.getTableValue(effectElements[16].p.v,effectElements[17].p.v,effectElements[18].p.v,effectElements[19].p.v,effectElements[20].p.v);
            this.feFuncG.setAttribute('tableValues',val);
        }

        if(this.feFuncB && (forceRender || effectElements[23].p.mdf || effectElements[24].p.mdf || effectElements[25].p.mdf || effectElements[26].p.mdf || effectElements[27].p.mdf)){
            val = this.getTableValue(effectElements[23].p.v,effectElements[24].p.v,effectElements[25].p.v,effectElements[26].p.v,effectElements[27].p.v);
            this.feFuncB.setAttribute('tableValues',val);
        }

        if(this.feFuncA && (forceRender || effectElements[30].p.mdf || effectElements[31].p.mdf || effectElements[32].p.mdf || effectElements[33].p.mdf || effectElements[34].p.mdf)){
            val = this.getTableValue(effectElements[30].p.v,effectElements[31].p.v,effectElements[32].p.v,effectElements[33].p.v,effectElements[34].p.v);
            this.feFuncA.setAttribute('tableValues',val);
        }
        
    }
};
function SVGDropShadowEffect(filter, filterManager){
    /*<feGaussianBlur in="SourceAlpha" stdDeviation="3"/> <!-- stdDeviation is how much to blur -->
  <feOffset dx="2" dy="2" result="offsetblur"/> <!-- how much to offset -->
  <feMerge> 
    <feMergeNode/> <!-- this contains the offset blurred image -->
    <feMergeNode in="SourceGraphic"/> <!-- this contains the element that the filter is applied to -->
  </feMerge>*/
  /*<feFlood flood-color="#3D4574" flood-opacity="0.5" result="offsetColor"/>*/
    filter.setAttribute('x','-100%');
    filter.setAttribute('y','-100%');
    filter.setAttribute('width','400%');
    filter.setAttribute('height','400%');
    this.filterManager = filterManager;

    var feGaussianBlur = document.createElementNS(svgNS,'feGaussianBlur');
    feGaussianBlur.setAttribute('in','SourceAlpha');
    feGaussianBlur.setAttribute('result','drop_shadow_1');
    feGaussianBlur.setAttribute('stdDeviation','0');
    this.feGaussianBlur = feGaussianBlur;
    filter.appendChild(feGaussianBlur);

    var feOffset = document.createElementNS(svgNS,'feOffset');
    feOffset.setAttribute('dx','25');
    feOffset.setAttribute('dy','0');
    feOffset.setAttribute('in','drop_shadow_1');
    feOffset.setAttribute('result','drop_shadow_2');
    this.feOffset = feOffset;
    filter.appendChild(feOffset);
    var feFlood = document.createElementNS(svgNS,'feFlood');
    feFlood.setAttribute('flood-color','#00ff00');
    feFlood.setAttribute('flood-opacity','1');
    feFlood.setAttribute('result','drop_shadow_3');
    this.feFlood = feFlood;
    filter.appendChild(feFlood);

    var feComposite = document.createElementNS(svgNS,'feComposite');
    feComposite.setAttribute('in','drop_shadow_3');
    feComposite.setAttribute('in2','drop_shadow_2');
    feComposite.setAttribute('operator','in');
    feComposite.setAttribute('result','drop_shadow_4');
    filter.appendChild(feComposite);


    var feMerge = document.createElementNS(svgNS,'feMerge');
    filter.appendChild(feMerge);
    var feMergeNode;
    feMergeNode = document.createElementNS(svgNS,'feMergeNode');
    feMerge.appendChild(feMergeNode);
    feMergeNode = document.createElementNS(svgNS,'feMergeNode');
    feMergeNode.setAttribute('in','SourceGraphic');
    this.feMergeNode = feMergeNode;
    this.feMerge = feMerge;
    this.originalNodeAdded = false;
    feMerge.appendChild(feMergeNode);
}

SVGDropShadowEffect.prototype.renderFrame = function(forceRender){
    if(forceRender || this.filterManager.mdf){
        if(forceRender || this.filterManager.effectElements[4].p.mdf){
            this.feGaussianBlur.setAttribute('stdDeviation', this.filterManager.effectElements[4].p.v / 4);
        }
        if(forceRender || this.filterManager.effectElements[0].p.mdf){
            var col = this.filterManager.effectElements[0].p.v;
            this.feFlood.setAttribute('flood-color',rgbToHex(Math.round(col[0]*255),Math.round(col[1]*255),Math.round(col[2]*255)));
        }
        if(forceRender || this.filterManager.effectElements[1].p.mdf){
            this.feFlood.setAttribute('flood-opacity',this.filterManager.effectElements[1].p.v/255);
        }
        if(forceRender || this.filterManager.effectElements[2].p.mdf || this.filterManager.effectElements[3].p.mdf){
            var distance = this.filterManager.effectElements[3].p.v
            var angle = (this.filterManager.effectElements[2].p.v - 90) * degToRads
            var x = distance * Math.cos(angle)
            var y = distance * Math.sin(angle)
            this.feOffset.setAttribute('dx', x);
            this.feOffset.setAttribute('dy', y);
        }
        /*if(forceRender || this.filterManager.effectElements[5].p.mdf){
            if(this.filterManager.effectElements[5].p.v === 1 && this.originalNodeAdded) {
                this.feMerge.removeChild(this.feMergeNode);
                this.originalNodeAdded = false;
            } else if(this.filterManager.effectElements[5].p.v === 0 && !this.originalNodeAdded) {
                this.feMerge.appendChild(this.feMergeNode);
                this.originalNodeAdded = true;
            }
        }*/
    }
};
function SVGMatte3Effect(filterElem, filterManager, elem){
    this.initialized = false;
    this.filterManager = filterManager;
    this.filterElem = filterElem;
    this.elem = elem;
    elem.matteElement = document.createElementNS(svgNS,'g');
    elem.matteElement.appendChild(elem.layerElement);
    elem.matteElement.appendChild(elem.transformedElement);
    elem.baseElement = elem.matteElement;
}

SVGMatte3Effect.prototype.setElementAsMask = function(elem, mask) {
    var masker = document.createElementNS(svgNS,'mask');
    masker.setAttribute('id',mask.layerId);
    masker.setAttribute('mask-type','alpha');
    masker.appendChild(mask.layerElement);
    elem.setMatte(mask.layerId);
    mask.data.hd = false;
    var defs = elem.globalData.defs;
    defs.appendChild(masker);
}

SVGMatte3Effect.prototype.initialize = function() {
    var ind = this.filterManager.effectElements[0].p.v;
    var i = 0, len = this.elem.comp.elements.length;
    while(i < len) {
    	if(this.elem.comp.elements[i].data.ind === ind) {
    		this.setElementAsMask(this.elem, this.elem.comp.elements[i]);
    	}
    	i += 1;
    }
    this.initialized = true;
}

SVGMatte3Effect.prototype.renderFrame = function() {
	if(!this.initialized) {
		this.initialize();
	}
}
function SVGEffects(elem){
    var i, len = elem.data.ef.length;
    var filId = randomString(10);
    var fil = filtersFactory.createFilter(filId);
    var count = 0;
    this.filters = [];
    var filterManager;
    for(i=0;i<len;i+=1){
        if(elem.data.ef[i].ty === 20){
            count += 1;
            filterManager = new SVGTintFilter(fil, elem.effects.effectElements[i]);
            this.filters.push(filterManager);
        }else if(elem.data.ef[i].ty === 21){
            count += 1;
            filterManager = new SVGFillFilter(fil, elem.effects.effectElements[i]);
            this.filters.push(filterManager);
        }else if(elem.data.ef[i].ty === 22){
            filterManager = new SVGStrokeEffect(elem, elem.effects.effectElements[i]);
            this.filters.push(filterManager);
        }else if(elem.data.ef[i].ty === 23){
            count += 1;
            filterManager = new SVGTritoneFilter(fil, elem.effects.effectElements[i]);
            this.filters.push(filterManager);
        }else if(elem.data.ef[i].ty === 24){
            count += 1;
            filterManager = new SVGProLevelsFilter(fil, elem.effects.effectElements[i]);
            this.filters.push(filterManager);
        }else if(elem.data.ef[i].ty === 25){
            count += 1;
            filterManager = new SVGDropShadowEffect(fil, elem.effects.effectElements[i]);
            this.filters.push(filterManager);
        }else if(elem.data.ef[i].ty === 28){
            //count += 1;
            filterManager = new SVGMatte3Effect(fil, elem.effects.effectElements[i], elem);
            this.filters.push(filterManager);
        }
    }
    if(count){
        elem.globalData.defs.appendChild(fil);
        elem.layerElement.setAttribute('filter','url(' + locationHref + '#'+filId+')');
    }
}

SVGEffects.prototype.renderFrame = function(firstFrame){
    var i, len = this.filters.length;
    for(i=0;i<len;i+=1){
        this.filters[i].renderFrame(firstFrame);
    }
};
function ICompElement(data,parentContainer,globalData,comp, placeholder){
    this._parent.constructor.call(this,data,parentContainer,globalData,comp, placeholder);
    this.layers = data.layers;
    this.supports3d = true;
    this.completeLayers = false;
    this.pendingElements = [];
    this.elements = this.layers ? Array.apply(null,{length:this.layers.length}) : [];
    if(this.data.tm){
        this.tm = PropertyFactory.getProp(this,this.data.tm,0,globalData.frameRate,this.dynamicProperties);
    }
    if(this.data.xt){
        this.layerElement = document.createElementNS(svgNS,'g');
        this.buildAllItems();
    } else if(!globalData.progressiveLoad){
        this.buildAllItems();
    }
}
createElement(SVGBaseElement, ICompElement);

ICompElement.prototype.hide = function(){
    if(!this.hidden){
        this._parent.hide.call(this);
        var i,len = this.elements.length;
        for( i = 0; i < len; i+=1 ){
            if(this.elements[i]){
                this.elements[i].hide();
            }
        }
    }
};

ICompElement.prototype.prepareFrame = function(num){
    this._parent.prepareFrame.call(this,num);
    if(this.isVisible===false && !this.data.xt){
        return;
    }

    if(this.tm){
        var timeRemapped = this.tm.v;
        if(timeRemapped === this.data.op){
            timeRemapped = this.data.op - 1;
        }
        this.renderedFrame = timeRemapped;
    } else {
        this.renderedFrame = num/this.data.sr;
    }
    var i,len = this.elements.length;
    if(!this.completeLayers){
        this.checkLayers(this.renderedFrame);
    }
    for( i = 0; i < len; i+=1 ){
        if(this.completeLayers || this.elements[i]){
            this.elements[i].prepareFrame(this.renderedFrame - this.layers[i].st);
        }
    }
};

ICompElement.prototype.renderFrame = function(parentMatrix){
    var renderParent = this._parent.renderFrame.call(this,parentMatrix);
    var i,len = this.layers.length;
    if(renderParent===false){
        this.hide();
        return;
    }

    if(this.hidden) {
        this.show();
    }
    for( i = 0; i < len; i+=1 ){
        if(this.completeLayers || this.elements[i]){
            this.elements[i].renderFrame();
        }
    }
    if(this.firstFrame){
        this.firstFrame = false;
    }
};

ICompElement.prototype.setElements = function(elems){
    this.elements = elems;
};

ICompElement.prototype.getElements = function(){
    return this.elements;
};

ICompElement.prototype.destroy = function(){
    this._parent.destroy.call(this._parent);
    var i,len = this.layers.length;
    for( i = 0; i < len; i+=1 ){
        if(this.elements[i]){
            this.elements[i].destroy();
        }
    }
};

ICompElement.prototype.checkLayers = SVGRenderer.prototype.checkLayers;
ICompElement.prototype.buildItem = SVGRenderer.prototype.buildItem;
ICompElement.prototype.buildAllItems = SVGRenderer.prototype.buildAllItems;
ICompElement.prototype.buildElementParenting = SVGRenderer.prototype.buildElementParenting;
ICompElement.prototype.createItem = SVGRenderer.prototype.createItem;
ICompElement.prototype.createImage = SVGRenderer.prototype.createImage;
ICompElement.prototype.createComp = SVGRenderer.prototype.createComp;
ICompElement.prototype.createSolid = SVGRenderer.prototype.createSolid;
ICompElement.prototype.createShape = SVGRenderer.prototype.createShape;
ICompElement.prototype.createText = SVGRenderer.prototype.createText;
ICompElement.prototype.createBase = SVGRenderer.prototype.createBase;
ICompElement.prototype.appendElementInPos = SVGRenderer.prototype.appendElementInPos;
ICompElement.prototype.checkPendingElements = SVGRenderer.prototype.checkPendingElements;
ICompElement.prototype.addPendingElement = SVGRenderer.prototype.addPendingElement;
function IImageElement(data,parentContainer,globalData,comp,placeholder){
    this.assetData = globalData.getAssetData(data.refId);
    this._parent.constructor.call(this,data,parentContainer,globalData,comp,placeholder);
}
createElement(SVGBaseElement, IImageElement);

IImageElement.prototype.createElements = function(){

    var assetPath = this.globalData.getAssetsPath(this.assetData);

    this._parent.createElements.call(this);

    this.innerElem = document.createElementNS(svgNS,'image');
    this.innerElem.setAttribute('width',this.assetData.w+"px");
    this.innerElem.setAttribute('height',this.assetData.h+"px");
    this.innerElem.setAttribute('preserveAspectRatio','xMidYMid slice');
    this.innerElem.setAttributeNS('http://www.w3.org/1999/xlink','href',assetPath);
    this.maskedElement = this.innerElem;
    this.layerElement.appendChild(this.innerElem);
    if(this.data.ln){
        this.layerElement.setAttribute('id',this.data.ln);
    }
    if(this.data.cl){
        this.layerElement.setAttribute('class',this.data.cl);
    }

};

IImageElement.prototype.renderFrame = function(parentMatrix){
    var renderParent = this._parent.renderFrame.call(this,parentMatrix);
    if(renderParent===false){
        this.hide();
        return;
    }
    if(this.hidden){
        this.show();
    }
    if(this.firstFrame){
        this.firstFrame = false;
    }
};

IImageElement.prototype.destroy = function(){
    this._parent.destroy.call(this._parent);
    this.innerElem =  null;
};
function ISolidElement(data,parentContainer,globalData,comp, placeholder){
    this._parent.constructor.call(this,data,parentContainer,globalData,comp, placeholder);
}
createElement(SVGBaseElement, ISolidElement);

ISolidElement.prototype.createElements = function(){
    this._parent.createElements.call(this);

    var rect = document.createElementNS(svgNS,'rect');
    ////rect.style.width = this.data.sw;
    ////rect.style.height = this.data.sh;
    ////rect.style.fill = this.data.sc;
    rect.setAttribute('width',this.data.sw);
    rect.setAttribute('height',this.data.sh);
    rect.setAttribute('fill',this.data.sc);
    this.layerElement.appendChild(rect);
    this.innerElem = rect;
    if(this.data.ln){
        this.layerElement.setAttribute('id',this.data.ln);
    }
    if(this.data.cl){
        this.layerElement.setAttribute('class',this.data.cl);
    }
};

ISolidElement.prototype.renderFrame = IImageElement.prototype.renderFrame;
ISolidElement.prototype.destroy = IImageElement.prototype.destroy;

var animationManager = (function(){
    var moduleOb = {};
    var registeredAnimations = [];
    var initTime = 0;
    var len = 0;
    var idled = true;
    var playingAnimationsNum = 0;

    function removeElement(ev){
        var i = 0;
        var animItem = ev.target;
        while(i<len) {
            if (registeredAnimations[i].animation === animItem) {
                registeredAnimations.splice(i, 1);
                i -= 1;
                len -= 1;
                if(!animItem.isPaused){
                    subtractPlayingCount();
                }
            }
            i += 1;
        }
    }

    function registerAnimation(element, animationData){
        if(!element){
            return null;
        }
        var i=0;
        while(i<len){
            if(registeredAnimations[i].elem == element && registeredAnimations[i].elem !== null ){
                return registeredAnimations[i].animation;
            }
            i+=1;
        }
        var animItem = new AnimationItem();
        setupAnimation(animItem, element);
        animItem.setData(element, animationData);
        return animItem;
    }

    function addPlayingCount(){
        playingAnimationsNum += 1;
        activate();
    }

    function subtractPlayingCount(){
        playingAnimationsNum -= 1;
        if(playingAnimationsNum === 0){
            idled = true;
        }
    }

    function setupAnimation(animItem, element){
        animItem.addEventListener('destroy',removeElement);
        animItem.addEventListener('_active',addPlayingCount);
        animItem.addEventListener('_idle',subtractPlayingCount);
        registeredAnimations.push({elem: element,animation:animItem});
        len += 1;
    }

    function loadAnimation(params){
        var animItem = new AnimationItem();
        setupAnimation(animItem, null);
        animItem.setParams(params);
        return animItem;
    }


    function setSpeed(val,animation){
        var i;
        for(i=0;i<len;i+=1){
            registeredAnimations[i].animation.setSpeed(val, animation);
        }
    }

    function setDirection(val, animation){
        var i;
        for(i=0;i<len;i+=1){
            registeredAnimations[i].animation.setDirection(val, animation);
        }
    }

    function play(animation){
        var i;
        for(i=0;i<len;i+=1){
            registeredAnimations[i].animation.play(animation);
        }
    }

    function moveFrame (value, animation) {
        initTime = Date.now();
        var i;
        for(i=0;i<len;i+=1){
            registeredAnimations[i].animation.moveFrame(value,animation);
        }
    }

    function resume(nowTime) {

        var elapsedTime = nowTime - initTime;
        var i;
        for(i=0;i<len;i+=1){
            registeredAnimations[i].animation.advanceTime(elapsedTime);
        }
        initTime = nowTime;
        if(!idled) {
            window.requestAnimationFrame(resume);
        }
    }

    function first(nowTime){
        initTime = nowTime;
        window.requestAnimationFrame(resume);
    }

    function pause(animation) {
        var i;
        for(i=0;i<len;i+=1){
            registeredAnimations[i].animation.pause(animation);
        }
    }

    function goToAndStop(value,isFrame,animation) {
        var i;
        for(i=0;i<len;i+=1){
            registeredAnimations[i].animation.goToAndStop(value,isFrame,animation);
        }
    }

    function stop(animation) {
        var i;
        for(i=0;i<len;i+=1){
            registeredAnimations[i].animation.stop(animation);
        }
    }

    function togglePause(animation) {
        var i;
        for(i=0;i<len;i+=1){
            registeredAnimations[i].animation.togglePause(animation);
        }
    }

    function destroy(animation) {
        var i;
        for(i=(len-1);i>=0;i-=1){
            registeredAnimations[i].animation.destroy(animation);
        }
    }

    function searchAnimations(animationData, standalone, renderer){
        var animElements = document.getElementsByClassName('bodymovin');
        var i, len = animElements.length;
        for(i=0;i<len;i+=1){
            if(renderer){
                animElements[i].setAttribute('data-bm-type',renderer);
            }
            registerAnimation(animElements[i], animationData);
        }
        if(standalone && len === 0){
            if(!renderer){
                renderer = 'svg';
            }
            var body = document.getElementsByTagName('body')[0];
            body.innerHTML = '';
            var div = document.createElement('div');
            div.style.width = '100%';
            div.style.height = '100%';
            div.setAttribute('data-bm-type',renderer);
            body.appendChild(div);
            registerAnimation(div, animationData);
        }
    }

    function resize(){
        var i;
        for(i=0;i<len;i+=1){
            registeredAnimations[i].animation.resize();
        }
    }

    function start(){
        window.requestAnimationFrame(first);
    }

    function activate(){
        if(idled){
            idled = false;
            window.requestAnimationFrame(first);
        }
    }

    //start();

    setTimeout(start,0);

    moduleOb.registerAnimation = registerAnimation;
    moduleOb.loadAnimation = loadAnimation;
    moduleOb.setSpeed = setSpeed;
    moduleOb.setDirection = setDirection;
    moduleOb.play = play;
    moduleOb.moveFrame = moveFrame;
    moduleOb.pause = pause;
    moduleOb.stop = stop;
    moduleOb.togglePause = togglePause;
    moduleOb.searchAnimations = searchAnimations;
    moduleOb.resize = resize;
    moduleOb.start = start;
    moduleOb.goToAndStop = goToAndStop;
    moduleOb.destroy = destroy;
    return moduleOb;
}());

var AnimationItem = function () {
    this._cbs = [];
    this.name = '';
    this.path = '';
    this.isLoaded = false;
    this.currentFrame = 0;
    this.currentRawFrame = 0;
    this.totalFrames = 0;
    this.frameRate = 0;
    this.frameMult = 0;
    this.playSpeed = 1;
    this.playDirection = 1;
    this.pendingElements = 0;
    this.playCount = 0;
    this.prerenderFramesFlag = true;
    this.animationData = {};
    this.layers = [];
    this.assets = [];
    this.isPaused = true;
    this.autoplay = false;
    this.loop = true;
    this.renderer = null;
    this.animationID = randomString(10);
    this.scaleMode = 'fit';
    this.assetsPath = '';
    this.timeCompleted = 0;
    this.segmentPos = 0;
    this.subframeEnabled = subframeEnabled;
    this.segments = [];
    this.pendingSegment = false;
    this._idle = true;
    this.projectInterface = ProjectInterface();
};

AnimationItem.prototype.setParams = function(params) {
    var self = this;
    if(params.context){
        this.context = params.context;
    }
    if(params.wrapper || params.container){
        this.wrapper = params.wrapper || params.container;
    }
    var animType = params.animType ? params.animType : params.renderer ? params.renderer : 'svg';
    switch(animType){
        case 'canvas':
            this.renderer = new CanvasRenderer(this, params.rendererSettings);
            break;
        case 'svg':
            this.renderer = new SVGRenderer(this, params.rendererSettings);
            break;
        case 'hybrid':
        case 'html':
        default:
            this.renderer = new HybridRenderer(this, params.rendererSettings);
            break;
    }
    this.renderer.setProjectInterface(this.projectInterface);
    this.animType = animType;

    if(params.loop === '' || params.loop === null){
    }else if(params.loop === false){
        this.loop = false;
    }else if(params.loop === true){
        this.loop = true;
    }else{
        this.loop = parseInt(params.loop);
    }
    this.autoplay = 'autoplay' in params ? params.autoplay : true;
    this.name = params.name ? params.name :  '';
    this.prerenderFramesFlag = 'prerender' in params ? params.prerender : true;
    this.autoloadSegments = params.hasOwnProperty('autoloadSegments') ? params.autoloadSegments :  true;
    if(params.animationData){
        self.configAnimation(params.animationData);
    }else if(params.path){
        if(params.path.substr(-4) != 'json'){
            if (params.path.substr(-1, 1) != '/') {
                params.path += '/';
            }
            params.path += 'data.json';
        }

        var xhr = new XMLHttpRequest();
        if(params.path.lastIndexOf('\\') != -1){
            this.path = params.path.substr(0,params.path.lastIndexOf('\\')+1);
        }else{
            this.path = params.path.substr(0,params.path.lastIndexOf('/')+1);
        }
        this.assetsPath = params.assetsPath;
        this.fileName = params.path.substr(params.path.lastIndexOf('/')+1);
        this.fileName = this.fileName.substr(0,this.fileName.lastIndexOf('.json'));
        xhr.open('GET', params.path, true);
        xhr.send();
        xhr.onreadystatechange = function () {
            if (xhr.readyState == 4) {
                if(xhr.status == 200){
                    self.configAnimation(JSON.parse(xhr.responseText));
                }else{
                    try{
                        var response = JSON.parse(xhr.responseText);
                        self.configAnimation(response);
                    }catch(err){
                    }
                }
            }
        };
    }
};

AnimationItem.prototype.setData = function (wrapper, animationData) {
    var params = {
        wrapper: wrapper,
        animationData: animationData ? (typeof animationData  === "object") ? animationData : JSON.parse(animationData) : null
    };
    var wrapperAttributes = wrapper.attributes;

    params.path = wrapperAttributes.getNamedItem('data-animation-path') ? wrapperAttributes.getNamedItem('data-animation-path').value : wrapperAttributes.getNamedItem('data-bm-path') ? wrapperAttributes.getNamedItem('data-bm-path').value :  wrapperAttributes.getNamedItem('bm-path') ? wrapperAttributes.getNamedItem('bm-path').value : '';
    params.animType = wrapperAttributes.getNamedItem('data-anim-type') ? wrapperAttributes.getNamedItem('data-anim-type').value : wrapperAttributes.getNamedItem('data-bm-type') ? wrapperAttributes.getNamedItem('data-bm-type').value : wrapperAttributes.getNamedItem('bm-type') ? wrapperAttributes.getNamedItem('bm-type').value :  wrapperAttributes.getNamedItem('data-bm-renderer') ? wrapperAttributes.getNamedItem('data-bm-renderer').value : wrapperAttributes.getNamedItem('bm-renderer') ? wrapperAttributes.getNamedItem('bm-renderer').value : 'canvas';

    var loop = wrapperAttributes.getNamedItem('data-anim-loop') ? wrapperAttributes.getNamedItem('data-anim-loop').value :  wrapperAttributes.getNamedItem('data-bm-loop') ? wrapperAttributes.getNamedItem('data-bm-loop').value :  wrapperAttributes.getNamedItem('bm-loop') ? wrapperAttributes.getNamedItem('bm-loop').value : '';
    if(loop === ''){
    }else if(loop === 'false'){
        params.loop = false;
    }else if(loop === 'true'){
        params.loop = true;
    }else{
        params.loop = parseInt(loop);
    }
    var autoplay = wrapperAttributes.getNamedItem('data-anim-autoplay') ? wrapperAttributes.getNamedItem('data-anim-autoplay').value :  wrapperAttributes.getNamedItem('data-bm-autoplay') ? wrapperAttributes.getNamedItem('data-bm-autoplay').value :  wrapperAttributes.getNamedItem('bm-autoplay') ? wrapperAttributes.getNamedItem('bm-autoplay').value : true;
    params.autoplay = autoplay !== "false";

    params.name = wrapperAttributes.getNamedItem('data-name') ? wrapperAttributes.getNamedItem('data-name').value :  wrapperAttributes.getNamedItem('data-bm-name') ? wrapperAttributes.getNamedItem('data-bm-name').value : wrapperAttributes.getNamedItem('bm-name') ? wrapperAttributes.getNamedItem('bm-name').value :  '';
    var prerender = wrapperAttributes.getNamedItem('data-anim-prerender') ? wrapperAttributes.getNamedItem('data-anim-prerender').value :  wrapperAttributes.getNamedItem('data-bm-prerender') ? wrapperAttributes.getNamedItem('data-bm-prerender').value :  wrapperAttributes.getNamedItem('bm-prerender') ? wrapperAttributes.getNamedItem('bm-prerender').value : '';

    if(prerender === 'false'){
        params.prerender = false;
    }
    this.setParams(params);
};

AnimationItem.prototype.includeLayers = function(data) {
    if(data.op > this.animationData.op){
        this.animationData.op = data.op;
        this.totalFrames = Math.floor(data.op - this.animationData.ip);
        this.animationData.tf = this.totalFrames;
    }
    var layers = this.animationData.layers;
    var i, len = layers.length;
    var newLayers = data.layers;
    var j, jLen = newLayers.length;
    for(j=0;j<jLen;j+=1){
        i = 0;
        while(i<len){
            if(layers[i].id == newLayers[j].id){
                layers[i] = newLayers[j];
                break;
            }
            i += 1;
        }
    }
    if(data.chars || data.fonts){
        this.renderer.globalData.fontManager.addChars(data.chars);
        this.renderer.globalData.fontManager.addFonts(data.fonts, this.renderer.globalData.defs);
    }
    if(data.assets){
        len = data.assets.length;
        for(i = 0; i < len; i += 1){
            this.animationData.assets.push(data.assets[i]);
        }
    }
    //this.totalFrames = 50;
    //this.animationData.tf = 50;
    this.animationData.__complete = false;
    dataManager.completeData(this.animationData,this.renderer.globalData.fontManager);
    this.renderer.includeLayers(data.layers);
    if(expressionsPlugin){
        expressionsPlugin.initExpressions(this);
    }
    this.renderer.renderFrame(null);
    this.loadNextSegment();
};

AnimationItem.prototype.loadNextSegment = function() {
    var segments = this.animationData.segments;
    if(!segments || segments.length === 0 || !this.autoloadSegments){
        this.trigger('data_ready');
        this.timeCompleted = this.animationData.tf;
        return;
    }
    var segment = segments.shift();
    this.timeCompleted = segment.time * this.frameRate;
    var xhr = new XMLHttpRequest();
    var self = this;
    var segmentPath = this.path+this.fileName+'_' + this.segmentPos + '.json';
    this.segmentPos += 1;
    xhr.open('GET', segmentPath, true);
    xhr.send();
    xhr.onreadystatechange = function () {
        if (xhr.readyState == 4) {
            if(xhr.status == 200){
                self.includeLayers(JSON.parse(xhr.responseText));
            }else{
                try{
                    var response = JSON.parse(xhr.responseText);
                    self.includeLayers(response);
                }catch(err){
                }
            }
        }
    };
};

AnimationItem.prototype.loadSegments = function() {
    var segments = this.animationData.segments;
    if(!segments) {
        this.timeCompleted = this.animationData.tf;
    }
    this.loadNextSegment();
};

AnimationItem.prototype.configAnimation = function (animData) {
    var _this = this;
    if(this.renderer && this.renderer.destroyed){
        return;
    }
    //console.log(JSON.parse(JSON.stringify(animData)));
    //animData.w = Math.round(animData.w/blitter);
    //animData.h = Math.round(animData.h/blitter);
    this.animationData = animData;
    this.totalFrames = Math.floor(this.animationData.op - this.animationData.ip);
    this.animationData.tf = this.totalFrames;
    this.renderer.configAnimation(animData);
    if(!animData.assets){
        animData.assets = [];
    }
    if(animData.comps) {
        animData.assets = animData.assets.concat(animData.comps);
        animData.comps = null;
    }
    this.renderer.searchExtraCompositions(animData.assets);

    this.layers = this.animationData.layers;
    this.assets = this.animationData.assets;
    this.frameRate = this.animationData.fr;
    this.firstFrame = Math.round(this.animationData.ip);
    this.frameMult = this.animationData.fr / 1000;
    this.trigger('config_ready');
    this.imagePreloader = new ImagePreloader();
    this.imagePreloader.setAssetsPath(this.assetsPath);
    this.imagePreloader.setPath(this.path);
    this.imagePreloader.loadAssets(animData.assets, function(err) {
        if(!err) {
            _this.trigger('loaded_images');
        }
    });
    this.loadSegments();
    this.updaFrameModifier();
    if(this.renderer.globalData.fontManager){
        this.waitForFontsLoaded();
    }else{
        dataManager.completeData(this.animationData,this.renderer.globalData.fontManager);
        this.checkLoaded();
    }
};

AnimationItem.prototype.waitForFontsLoaded = (function(){
    function checkFontsLoaded(){
        if(this.renderer.globalData.fontManager.loaded){
            dataManager.completeData(this.animationData,this.renderer.globalData.fontManager);
            //this.renderer.buildItems(this.animationData.layers);
            this.checkLoaded();
        }else{
            setTimeout(checkFontsLoaded.bind(this),20);
        }
    }

    return function(){
        checkFontsLoaded.bind(this)();
    }
}());

AnimationItem.prototype.addPendingElement = function () {
    this.pendingElements += 1;
}

AnimationItem.prototype.elementLoaded = function () {
    this.pendingElements--;
    this.checkLoaded();
};

AnimationItem.prototype.checkLoaded = function () {
    if (this.pendingElements === 0) {
        if(expressionsPlugin){
            expressionsPlugin.initExpressions(this);
        }
        this.renderer.initItems();
        setTimeout(function(){
            this.trigger('DOMLoaded');
        }.bind(this),0);
        this.isLoaded = true;
        this.gotoFrame();
        if(this.autoplay){
            this.play();
        }
    }
};

AnimationItem.prototype.resize = function () {
    this.renderer.updateContainerSize();
};

AnimationItem.prototype.setSubframe = function(flag){
    this.subframeEnabled = flag ? true : false;
}

AnimationItem.prototype.gotoFrame = function () {
    if(this.subframeEnabled){
        this.currentFrame = this.currentRawFrame;
    }else{
        this.currentFrame = Math.floor(this.currentRawFrame);
    }

    if(this.timeCompleted !== this.totalFrames && this.currentFrame > this.timeCompleted){
        this.currentFrame = this.timeCompleted;
    }
    this.trigger('enterFrame');
    this.renderFrame();
};

AnimationItem.prototype.renderFrame = function () {
    if(this.isLoaded === false){
        return;
    }
    //console.log('this.currentFrame:',this.currentFrame + this.firstFrame);
    this.renderer.renderFrame(this.currentFrame + this.firstFrame);
};

AnimationItem.prototype.play = function (name) {
    if(name && this.name != name){
        return;
    }
    if(this.isPaused === true){
        this.isPaused = false;
        if(this._idle){
            this._idle = false;
            this.trigger('_active');
        }
    }
};

AnimationItem.prototype.pause = function (name) {
    if(name && this.name != name){
        return;
    }
    if(this.isPaused === false){
        this.isPaused = true;
        if(!this.pendingSegment){
            this._idle = true;
            this.trigger('_idle');
        }
    }
};

AnimationItem.prototype.togglePause = function (name) {
    if(name && this.name != name){
        return;
    }
    if(this.isPaused === true){
        this.play();
    }else{
        this.pause();
    }
};

AnimationItem.prototype.stop = function (name) {
    if(name && this.name != name){
        return;
    }
    this.pause();
    this.currentFrame = this.currentRawFrame = 0;
    this.playCount = 0;
    this.gotoFrame();
};

AnimationItem.prototype.goToAndStop = function (value, isFrame, name) {
    if(name && this.name != name){
        return;
    }
    if(isFrame){
        this.setCurrentRawFrameValue(value);
    }else{
        this.setCurrentRawFrameValue(value * this.frameModifier);
    }
    this.pause();
};

AnimationItem.prototype.goToAndPlay = function (value, isFrame, name) {
    this.goToAndStop(value, isFrame, name);
    this.play();
};

AnimationItem.prototype.advanceTime = function (value) {
    if(this.pendingSegment){
        this.pendingSegment = false;
        this.adjustSegment(this.segments.shift());
        if(this.isPaused){
            this.play();
        }
        return;
    }
    if (this.isPaused === true || this.isLoaded === false) {
        return;
    }
    this.setCurrentRawFrameValue(this.currentRawFrame + value * this.frameModifier);
};

AnimationItem.prototype.updateAnimation = function (perc) {
    this.setCurrentRawFrameValue(this.totalFrames * perc);
};

AnimationItem.prototype.moveFrame = function (value, name) {
    if(name && this.name != name){
        return;
    }
    this.setCurrentRawFrameValue(this.currentRawFrame+value);
};

AnimationItem.prototype.adjustSegment = function(arr){
    this.playCount = 0;
    if(arr[1] < arr[0]){
        if(this.frameModifier > 0){
            if(this.playSpeed < 0){
                this.setSpeed(-this.playSpeed);
            } else {
                this.setDirection(-1);
            }
        }
        this.totalFrames = arr[0] - arr[1];
        this.firstFrame = arr[1];
        this.setCurrentRawFrameValue(this.totalFrames - 0.01);
    } else if(arr[1] > arr[0]){
        if(this.frameModifier < 0){
            if(this.playSpeed < 0){
                this.setSpeed(-this.playSpeed);
            } else {
                this.setDirection(1);
            }
        }
        this.totalFrames = arr[1] - arr[0];
        this.firstFrame = arr[0];
        this.setCurrentRawFrameValue(0);
    }
    this.trigger('segmentStart');
};
AnimationItem.prototype.setSegment = function (init,end) {
    var pendingFrame = -1;
    if(this.isPaused) {
        if (this.currentRawFrame + this.firstFrame < init) {
            pendingFrame = init;
        } else if (this.currentRawFrame + this.firstFrame > end) {
            pendingFrame = end - init - 0.01;
        }
    }

    this.firstFrame = init;
    this.totalFrames = end - init;
    if(pendingFrame !== -1) {
        this.goToAndStop(pendingFrame,true);
    }
}

AnimationItem.prototype.playSegments = function (arr,forceFlag) {
    if(typeof arr[0] === 'object'){
        var i, len = arr.length;
        for(i=0;i<len;i+=1){
            this.segments.push(arr[i]);
        }
    }else{
        this.segments.push(arr);
    }
    if(forceFlag){
        this.adjustSegment(this.segments.shift());
    }
    if(this.isPaused){
        this.play();
    }
};

AnimationItem.prototype.resetSegments = function (forceFlag) {
    this.segments.length = 0;
    this.segments.push([this.animationData.ip*this.frameRate,Math.floor(this.animationData.op - this.animationData.ip+this.animationData.ip*this.frameRate)]);
    if(forceFlag){
        this.adjustSegment(this.segments.shift());
    }
};
AnimationItem.prototype.checkSegments = function(){
    if(this.segments.length){
        this.pendingSegment = true;
    }
}

AnimationItem.prototype.remove = function (name) {
    if(name && this.name != name){
        return;
    }
    this.renderer.destroy();
};

AnimationItem.prototype.destroy = function (name) {
    if((name && this.name != name) || (this.renderer && this.renderer.destroyed)){
        return;
    }
    this.renderer.destroy();
    this.trigger('destroy');
    this._cbs = null;
    this.onEnterFrame = this.onLoopComplete = this.onComplete = this.onSegmentStart = this.onDestroy = null;
};

AnimationItem.prototype.setCurrentRawFrameValue = function(value){
    this.currentRawFrame = value;
    //console.log(this.totalFrames);
    if (this.currentRawFrame >= this.totalFrames) {
        this.checkSegments();
        if(this.loop === false){
            this.currentRawFrame = this.totalFrames - 0.01;
            this.gotoFrame();
            this.pause();
            this.trigger('complete');
            return;
        }else{
            this.trigger('loopComplete');
            this.playCount += 1;
            if((this.loop !== true && this.playCount == this.loop) || this.pendingSegment){
                this.currentRawFrame = this.totalFrames - 0.01;
                this.gotoFrame();
                this.pause();
                this.trigger('complete');
                return;
            } else {
                this.currentRawFrame = this.currentRawFrame % this.totalFrames;
            }
        }
    } else if (this.currentRawFrame < 0) {
        this.checkSegments();
        this.playCount -= 1;
        if(this.playCount < 0){
            this.playCount = 0;
        }
        if(this.loop === false  || this.pendingSegment){
            this.currentRawFrame = 0;
            this.gotoFrame();
            this.pause();
            this.trigger('complete');
            return;
        }else{
            this.trigger('loopComplete');
            this.currentRawFrame = (this.totalFrames + this.currentRawFrame) % this.totalFrames;
            this.gotoFrame();
            return;
        }
    }

    this.gotoFrame();
};

AnimationItem.prototype.setSpeed = function (val) {
    this.playSpeed = val;
    this.updaFrameModifier();
};

AnimationItem.prototype.setDirection = function (val) {
    this.playDirection = val < 0 ? -1 : 1;
    this.updaFrameModifier();
};

AnimationItem.prototype.updaFrameModifier = function () {
    this.frameModifier = this.frameMult * this.playSpeed * this.playDirection;
};

AnimationItem.prototype.getPath = function () {
    return this.path;
};

AnimationItem.prototype.getAssetsPath = function (assetData) {
    var path = '';
    if(this.assetsPath){
        var imagePath = assetData.p;
        if(imagePath.indexOf('images/') !== -1){
            imagePath = imagePath.split('/')[1];
        }
        path = this.assetsPath + imagePath;
    } else {
        path = this.path;
        path += assetData.u ? assetData.u : '';
        path += assetData.p;
    }
    return path;
};

AnimationItem.prototype.getAssetData = function (id) {
    var i = 0, len = this.assets.length;
    while (i < len) {
        if(id == this.assets[i].id){
            return this.assets[i];
        }
        i += 1;
    }
};

AnimationItem.prototype.hide = function () {
    this.renderer.hide();
};

AnimationItem.prototype.show = function () {
    this.renderer.show();
};

AnimationItem.prototype.getAssets = function () {
    return this.assets;
};

AnimationItem.prototype.trigger = function(name){
    if(this._cbs && this._cbs[name]){
        switch(name){
            case 'enterFrame':
                this.triggerEvent(name,new BMEnterFrameEvent(name,this.currentFrame,this.totalFrames,this.frameMult));
                break;
            case 'loopComplete':
                this.triggerEvent(name,new BMCompleteLoopEvent(name,this.loop,this.playCount,this.frameMult));
                break;
            case 'complete':
                this.triggerEvent(name,new BMCompleteEvent(name,this.frameMult));
                break;
            case 'segmentStart':
                this.triggerEvent(name,new BMSegmentStartEvent(name,this.firstFrame,this.totalFrames));
                break;
            case 'destroy':
                this.triggerEvent(name,new BMDestroyEvent(name,this));
                break;
            default:
                this.triggerEvent(name);
        }
    }
    if(name === 'enterFrame' && this.onEnterFrame){
        this.onEnterFrame.call(this,new BMEnterFrameEvent(name,this.currentFrame,this.totalFrames,this.frameMult));
    }
    if(name === 'loopComplete' && this.onLoopComplete){
        this.onLoopComplete.call(this,new BMCompleteLoopEvent(name,this.loop,this.playCount,this.frameMult));
    }
    if(name === 'complete' && this.onComplete){
        this.onComplete.call(this,new BMCompleteEvent(name,this.frameMult));
    }
    if(name === 'segmentStart' && this.onSegmentStart){
        this.onSegmentStart.call(this,new BMSegmentStartEvent(name,this.firstFrame,this.totalFrames));
    }
    if(name === 'destroy' && this.onDestroy){
        this.onDestroy.call(this,new BMDestroyEvent(name,this));
    }
};

AnimationItem.prototype.addEventListener = _addEventListener;
AnimationItem.prototype.removeEventListener = _removeEventListener;
AnimationItem.prototype.triggerEvent = _triggerEvent;

function CanvasRenderer(animationItem, config){
    this.animationItem = animationItem;
    this.renderConfig = {
        clearCanvas: (config && config.clearCanvas !== undefined) ? config.clearCanvas : true,
        context: (config && config.context) || null,
        progressiveLoad: (config && config.progressiveLoad) || false,
        preserveAspectRatio: (config && config.preserveAspectRatio) || 'xMidYMid meet',
        className: (config && config.className) || ''
    };
    this.renderConfig.dpr = (config && config.dpr) || 1;
    if (this.animationItem.wrapper) {
        this.renderConfig.dpr = (config && config.dpr) || window.devicePixelRatio || 1;
    }
    this.renderedFrame = -1;
    this.globalData = {
        frameNum: -1
    };
    this.contextData = {
        saved : Array.apply(null,{length:15}),
        savedOp: Array.apply(null,{length:15}),
        cArrPos : 0,
        cTr : new Matrix(),
        cO : 1
    };
    var i, len = 15;
    for(i=0;i<len;i+=1){
        this.contextData.saved[i] = Array.apply(null,{length:16});
    }
    this.elements = [];
    this.pendingElements = [];
    this.transformMat = new Matrix();
    this.completeLayers = false;
}
extendPrototype(BaseRenderer,CanvasRenderer);

CanvasRenderer.prototype.createBase = function (data) {
    return new CVBaseElement(data, this, this.globalData);
};

CanvasRenderer.prototype.createShape = function (data) {
    return new CVShapeElement(data, this, this.globalData);
};

CanvasRenderer.prototype.createText = function (data) {
    return new CVTextElement(data, this, this.globalData);
};

CanvasRenderer.prototype.createImage = function (data) {
    return new CVImageElement(data, this, this.globalData);
};

CanvasRenderer.prototype.createComp = function (data) {
    return new CVCompElement(data, this, this.globalData);
};

CanvasRenderer.prototype.createSolid = function (data) {
    return new CVSolidElement(data, this, this.globalData);
};

CanvasRenderer.prototype.ctxTransform = function(props){
    if(props[0] === 1 && props[1] === 0 && props[4] === 0 && props[5] === 1 && props[12] === 0 && props[13] === 0){
        return;
    }
    if(!this.renderConfig.clearCanvas){
        this.canvasContext.transform(props[0],props[1],props[4],props[5],props[12],props[13]);
        return;
    }
    this.transformMat.cloneFromProps(props);
    this.transformMat.transform(this.contextData.cTr.props[0],this.contextData.cTr.props[1],this.contextData.cTr.props[2],this.contextData.cTr.props[3],this.contextData.cTr.props[4],this.contextData.cTr.props[5],this.contextData.cTr.props[6],this.contextData.cTr.props[7],this.contextData.cTr.props[8],this.contextData.cTr.props[9],this.contextData.cTr.props[10],this.contextData.cTr.props[11],this.contextData.cTr.props[12],this.contextData.cTr.props[13],this.contextData.cTr.props[14],this.contextData.cTr.props[15])
    //this.contextData.cTr.transform(props[0],props[1],props[2],props[3],props[4],props[5],props[6],props[7],props[8],props[9],props[10],props[11],props[12],props[13],props[14],props[15]);
    this.contextData.cTr.cloneFromProps(this.transformMat.props);
    var trProps = this.contextData.cTr.props;
    this.canvasContext.setTransform(trProps[0],trProps[1],trProps[4],trProps[5],trProps[12],trProps[13]);
};

CanvasRenderer.prototype.ctxOpacity = function(op){
    if(op === 1){
        return;
    }
    if(!this.renderConfig.clearCanvas){
        this.canvasContext.globalAlpha *= op < 0 ? 0 : op;
        return;
    }
    this.contextData.cO *= op < 0 ? 0 : op;
    this.canvasContext.globalAlpha = this.contextData.cO;
};

CanvasRenderer.prototype.reset = function(){
    if(!this.renderConfig.clearCanvas){
        this.canvasContext.restore();
        return;
    }
    this.contextData.cArrPos = 0;
    this.contextData.cTr.reset();
    this.contextData.cO = 1;
};

CanvasRenderer.prototype.save = function(actionFlag){
    if(!this.renderConfig.clearCanvas){
        this.canvasContext.save();
        return;
    }
    if(actionFlag){
        this.canvasContext.save();
    }
    var props = this.contextData.cTr.props;
    if(this.contextData.saved[this.contextData.cArrPos] === null || this.contextData.saved[this.contextData.cArrPos] === undefined){
        this.contextData.saved[this.contextData.cArrPos] = new Array(16);
    }
    var i,arr = this.contextData.saved[this.contextData.cArrPos];
    for(i=0;i<16;i+=1){
        arr[i] = props[i];
    }
    this.contextData.savedOp[this.contextData.cArrPos] = this.contextData.cO;
    this.contextData.cArrPos += 1;
};

CanvasRenderer.prototype.restore = function(actionFlag){
    if(!this.renderConfig.clearCanvas){
        this.canvasContext.restore();
        return;
    }
    if(actionFlag){
        this.canvasContext.restore();
    }
    this.contextData.cArrPos -= 1;
    var popped = this.contextData.saved[this.contextData.cArrPos];
    var i,arr = this.contextData.cTr.props;
    for(i=0;i<16;i+=1){
        arr[i] = popped[i];
    }
    this.canvasContext.setTransform(popped[0],popped[1],popped[4],popped[5],popped[12],popped[13]);
    popped = this.contextData.savedOp[this.contextData.cArrPos];
    this.contextData.cO = popped;
    this.canvasContext.globalAlpha = popped;
};

CanvasRenderer.prototype.configAnimation = function(animData){
    if(this.animationItem.wrapper){
        this.animationItem.container = document.createElement('canvas');
        this.animationItem.container.style.width = '100%';
        this.animationItem.container.style.height = '100%';
        //this.animationItem.container.style.transform = 'translate3d(0,0,0)';
        //this.animationItem.container.style.webkitTransform = 'translate3d(0,0,0)';
        this.animationItem.container.style.transformOrigin = this.animationItem.container.style.mozTransformOrigin = this.animationItem.container.style.webkitTransformOrigin = this.animationItem.container.style['-webkit-transform'] = "0px 0px 0px";
        this.animationItem.wrapper.appendChild(this.animationItem.container);
        this.canvasContext = this.animationItem.container.getContext('2d');
        if(this.renderConfig.className) {
            this.animationItem.container.setAttribute('class', this.renderConfig.className);
        }
    }else{
        this.canvasContext = this.renderConfig.context;
    }
    this.data = animData;
    this.globalData.canvasContext = this.canvasContext;
    this.globalData.renderer = this;
    this.globalData.isDashed = false;
    this.globalData.totalFrames = Math.floor(animData.tf);
    this.globalData.compWidth = animData.w;
    this.globalData.compHeight = animData.h;
    this.globalData.frameRate = animData.fr;
    this.globalData.frameId = 0;
    this.globalData.compSize = {
        w: animData.w,
        h: animData.h
    };
    this.globalData.progressiveLoad = this.renderConfig.progressiveLoad;
    this.layers = animData.layers;
    this.transformCanvas = {};
    this.transformCanvas.w = animData.w;
    this.transformCanvas.h = animData.h;
    this.globalData.fontManager = new FontManager();
    this.globalData.fontManager.addChars(animData.chars);
    this.globalData.fontManager.addFonts(animData.fonts,document.body);
    this.globalData.getAssetData = this.animationItem.getAssetData.bind(this.animationItem);
    this.globalData.getAssetsPath = this.animationItem.getAssetsPath.bind(this.animationItem);
    this.globalData.elementLoaded = this.animationItem.elementLoaded.bind(this.animationItem);
    this.globalData.addPendingElement = this.animationItem.addPendingElement.bind(this.animationItem);
    this.globalData.transformCanvas = this.transformCanvas;
    this.elements = Array.apply(null,{length:animData.layers.length});

    this.updateContainerSize();
};

CanvasRenderer.prototype.updateContainerSize = function () {
    var elementWidth,elementHeight;
    if(this.animationItem.wrapper && this.animationItem.container){
        elementWidth = this.animationItem.wrapper.offsetWidth;
        elementHeight = this.animationItem.wrapper.offsetHeight;
        this.animationItem.container.setAttribute('width',elementWidth * this.renderConfig.dpr );
        this.animationItem.container.setAttribute('height',elementHeight * this.renderConfig.dpr);
    }else{
        elementWidth = this.canvasContext.canvas.width * this.renderConfig.dpr;
        elementHeight = this.canvasContext.canvas.height * this.renderConfig.dpr;
    }
    var elementRel,animationRel;
    if(this.renderConfig.preserveAspectRatio.indexOf('meet') !== -1 || this.renderConfig.preserveAspectRatio.indexOf('slice') !== -1){
        var par = this.renderConfig.preserveAspectRatio.split(' ');
        var fillType = par[1] || 'meet';
        var pos = par[0] || 'xMidYMid';
        var xPos = pos.substr(0,4);
        var yPos = pos.substr(4);
        elementRel = elementWidth/elementHeight;
        animationRel = this.transformCanvas.w/this.transformCanvas.h;
        if(animationRel>elementRel && fillType === 'meet' || animationRel<elementRel && fillType === 'slice'){
            this.transformCanvas.sx = elementWidth/(this.transformCanvas.w/this.renderConfig.dpr);
            this.transformCanvas.sy = elementWidth/(this.transformCanvas.w/this.renderConfig.dpr);
        }else{
            this.transformCanvas.sx = elementHeight/(this.transformCanvas.h / this.renderConfig.dpr);
            this.transformCanvas.sy = elementHeight/(this.transformCanvas.h / this.renderConfig.dpr);
        }

        if(xPos === 'xMid' && ((animationRel<elementRel && fillType==='meet') || (animationRel>elementRel && fillType === 'slice'))){
            this.transformCanvas.tx = (elementWidth-this.transformCanvas.w*(elementHeight/this.transformCanvas.h))/2*this.renderConfig.dpr;
        } else if(xPos === 'xMax' && ((animationRel<elementRel && fillType==='meet') || (animationRel>elementRel && fillType === 'slice'))){
            this.transformCanvas.tx = (elementWidth-this.transformCanvas.w*(elementHeight/this.transformCanvas.h))*this.renderConfig.dpr;
        } else {
            this.transformCanvas.tx = 0;
        }
        if(yPos === 'YMid' && ((animationRel>elementRel && fillType==='meet') || (animationRel<elementRel && fillType === 'slice'))){
            this.transformCanvas.ty = ((elementHeight-this.transformCanvas.h*(elementWidth/this.transformCanvas.w))/2)*this.renderConfig.dpr;
        } else if(yPos === 'YMax' && ((animationRel>elementRel && fillType==='meet') || (animationRel<elementRel && fillType === 'slice'))){
            this.transformCanvas.ty = ((elementHeight-this.transformCanvas.h*(elementWidth/this.transformCanvas.w)))*this.renderConfig.dpr;
        } else {
            this.transformCanvas.ty = 0;
        }

    }else if(this.renderConfig.preserveAspectRatio == 'none'){
        this.transformCanvas.sx = elementWidth/(this.transformCanvas.w/this.renderConfig.dpr);
        this.transformCanvas.sy = elementHeight/(this.transformCanvas.h/this.renderConfig.dpr);
        this.transformCanvas.tx = 0;
        this.transformCanvas.ty = 0;
    }else{
        this.transformCanvas.sx = this.renderConfig.dpr;
        this.transformCanvas.sy = this.renderConfig.dpr;
        this.transformCanvas.tx = 0;
        this.transformCanvas.ty = 0;
    }
    this.transformCanvas.props = [this.transformCanvas.sx,0,0,0,0,this.transformCanvas.sy,0,0,0,0,1,0,this.transformCanvas.tx,this.transformCanvas.ty,0,1];
    var i, len = this.elements.length;
    for(i=0;i<len;i+=1){
        if(this.elements[i] && this.elements[i].data.ty === 0){
            this.elements[i].resize(this.globalData.transformCanvas);
        }
    }
};

CanvasRenderer.prototype.destroy = function () {
    if(this.renderConfig.clearCanvas) {
        this.animationItem.wrapper.innerHTML = '';
    }
    var i, len = this.layers ? this.layers.length : 0;
    for (i = len - 1; i >= 0; i-=1) {
        if(this.elements[i]) {
            this.elements[i].destroy();
        }
    }
    this.elements.length = 0;
    this.globalData.canvasContext = null;
    this.animationItem.container = null;
    this.destroyed = true;
};

CanvasRenderer.prototype.renderFrame = function(num){
    if((this.renderedFrame == num && this.renderConfig.clearCanvas === true) || this.destroyed || num === null){
        return;
    }
    this.renderedFrame = num;
    this.globalData.frameNum = num - this.animationItem.firstFrame;
    this.globalData.frameId += 1;
    this.globalData.projectInterface.currentFrame = num;
    if(this.renderConfig.clearCanvas === true){
        this.reset();
        this.canvasContext.save();
        //this.canvasContext.canvas.width = this.canvasContext.canvas.width;
        this.canvasContext.clearRect(this.transformCanvas.tx, this.transformCanvas.ty, this.transformCanvas.w*this.transformCanvas.sx, this.transformCanvas.h*this.transformCanvas.sy);
    }else{
        this.save();
    }
    this.ctxTransform(this.transformCanvas.props);
    this.canvasContext.beginPath();
    this.canvasContext.rect(0,0,this.transformCanvas.w,this.transformCanvas.h);
    this.canvasContext.closePath();
    this.canvasContext.clip();

    //console.log('--------');
    //console.log('NEW: ',num);
    var i, len = this.layers.length;
    if(!this.completeLayers){
        this.checkLayers(num);
    }

    for (i = 0; i < len; i++) {
        if(this.completeLayers || this.elements[i]){
            this.elements[i].prepareFrame(num - this.layers[i].st);
        }
    }
    for (i = len - 1; i >= 0; i-=1) {
        if(this.completeLayers || this.elements[i]){
            this.elements[i].renderFrame();
        }
    }
    if(this.renderConfig.clearCanvas !== true){
        this.restore();
    } else {
        this.canvasContext.restore();
    }
};

CanvasRenderer.prototype.buildItem = function(pos){
    var elements = this.elements;
    if(elements[pos] || this.layers[pos].ty == 99){
        return;
    }
    var element = this.createItem(this.layers[pos], this,this.globalData);
    elements[pos] = element;
    element.initExpressions();
    if(this.layers[pos].ty === 0){
        element.resize(this.globalData.transformCanvas);
    }
};

CanvasRenderer.prototype.checkPendingElements  = function(){
    while(this.pendingElements.length){
        var element = this.pendingElements.pop();
        element.checkParenting();
    }
};

CanvasRenderer.prototype.hide = function(){
    this.animationItem.container.style.display = 'none';
};

CanvasRenderer.prototype.show = function(){
    this.animationItem.container.style.display = 'block';
};

CanvasRenderer.prototype.searchExtraCompositions = function(assets){
    var i, len = assets.length;
    var floatingContainer = document.createElementNS(svgNS,'g');
    for(i=0;i<len;i+=1){
        if(assets[i].xt){
            var comp = this.createComp(assets[i],this.globalData.comp,this.globalData);
            comp.initExpressions();
            //comp.compInterface = CompExpressionInterface(comp);
            //Expressions.addLayersInterface(comp.elements, this.globalData.projectInterface);
            this.globalData.projectInterface.registerComposition(comp);
        }
    }
};

function HybridRenderer(animationItem, config){
    this.animationItem = animationItem;
    this.layers = null;
    this.renderedFrame = -1;
    this.globalData = {
        frameNum: -1
    };
    this.renderConfig = {
        className: (config && config.className) || ''
    };
    this.pendingElements = [];
    this.elements = [];
    this.threeDElements = [];
    this.destroyed = false;
    this.camera = null;
    this.supports3d = true;

}

extendPrototype(BaseRenderer,HybridRenderer);

HybridRenderer.prototype.buildItem = SVGRenderer.prototype.buildItem;

HybridRenderer.prototype.checkPendingElements  = function(){
    while(this.pendingElements.length){
        var element = this.pendingElements.pop();
        element.checkParenting();
    }
};

HybridRenderer.prototype.appendElementInPos = function(element, pos){
    var newDOMElement = element.getBaseElement();
    if(!newDOMElement){
        return;
    }
    var layer = this.layers[pos];
    if(!layer.ddd || !this.supports3d){
        var i = 0;
        var nextDOMElement, nextLayer;
        while(i<pos){
            if(this.elements[i] && this.elements[i]!== true && this.elements[i].getBaseElement){
                nextLayer = this.elements[i];
                nextDOMElement = this.layers[i].ddd ? this.getThreeDContainerByPos(i) : nextLayer.getBaseElement();
            }
            i += 1;
        }
        if(nextDOMElement){
            if(!layer.ddd || !this.supports3d){
                this.layerElement.insertBefore(newDOMElement, nextDOMElement);
            }
        } else {
            if(!layer.ddd || !this.supports3d){
                this.layerElement.appendChild(newDOMElement);
            }
        }
    } else {
        this.addTo3dContainer(newDOMElement,pos);
    }
};


HybridRenderer.prototype.createBase = function (data) {
    return new SVGBaseElement(data, this.layerElement,this.globalData,this);
};

HybridRenderer.prototype.createShape = function (data) {
    if(!this.supports3d){
        return new IShapeElement(data, this.layerElement,this.globalData,this);
    }
    return new HShapeElement(data, this.layerElement,this.globalData,this);
};

HybridRenderer.prototype.createText = function (data) {
    if(!this.supports3d){
        return new SVGTextElement(data, this.layerElement,this.globalData,this);
    }
    return new HTextElement(data, this.layerElement,this.globalData,this);
};

HybridRenderer.prototype.createCamera = function (data) {
    this.camera = new HCameraElement(data, this.layerElement,this.globalData,this);
    return this.camera;
};

HybridRenderer.prototype.createImage = function (data) {
    if(!this.supports3d){
        return new IImageElement(data, this.layerElement,this.globalData,this);
    }
    return new HImageElement(data, this.layerElement,this.globalData,this);
};

HybridRenderer.prototype.createComp = function (data) {
    if(!this.supports3d){
        return new ICompElement(data, this.layerElement,this.globalData,this);
    }
    return new HCompElement(data, this.layerElement,this.globalData,this);

};

HybridRenderer.prototype.createSolid = function (data) {
    if(!this.supports3d){
        return new ISolidElement(data, this.layerElement,this.globalData,this);
    }
    return new HSolidElement(data, this.layerElement,this.globalData,this);
};

HybridRenderer.prototype.getThreeDContainerByPos = function(pos){
    var i = 0, len = this.threeDElements.length;
    while(i<len) {
        if(this.threeDElements[i].startPos <= pos && this.threeDElements[i].endPos >= pos) {
            return this.threeDElements[i].perspectiveElem;
        }
        i += 1;
    }
}

HybridRenderer.prototype.createThreeDContainer = function(pos){
    var perspectiveElem = document.createElement('div');
    styleDiv(perspectiveElem);
    perspectiveElem.style.width = this.globalData.compSize.w+'px';
    perspectiveElem.style.height = this.globalData.compSize.h+'px';
    perspectiveElem.style.transformOrigin = perspectiveElem.style.mozTransformOrigin = perspectiveElem.style.webkitTransformOrigin = "50% 50%";
    var container = document.createElement('div');
    styleDiv(container);
    container.style.transform = container.style.webkitTransform = 'matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)';
    perspectiveElem.appendChild(container);
    this.resizerElem.appendChild(perspectiveElem);
    var threeDContainerData = {
        container:container,
        perspectiveElem:perspectiveElem,
        startPos: pos,
        endPos: pos
    };
    this.threeDElements.push(threeDContainerData);
    return threeDContainerData;
};

HybridRenderer.prototype.build3dContainers = function(){
    var i, len = this.layers.length;
    var lastThreeDContainerData;
    for(i=0;i<len;i+=1){
        if(this.layers[i].ddd){
            if(!lastThreeDContainerData){
                lastThreeDContainerData = this.createThreeDContainer(i);
            }
            lastThreeDContainerData.endPos = Math.max(lastThreeDContainerData.endPos,i);
        } else {
            lastThreeDContainerData = null;
        }
    }
};

HybridRenderer.prototype.addTo3dContainer = function(elem,pos){
    var i = 0, len = this.threeDElements.length;
    while(i<len){
        if(pos <= this.threeDElements[i].endPos){
            var j = this.threeDElements[i].startPos;
            var nextElement;
            while(j<pos){
                if(this.elements[j] && this.elements[j].getBaseElement){
                    nextElement = this.elements[j].getBaseElement();
                }
                j += 1;
            }
            if(nextElement){
                this.threeDElements[i].container.insertBefore(elem, nextElement);
            } else {
                this.threeDElements[i].container.appendChild(elem);
            }
            break;
        }
        i += 1;
    }
};

HybridRenderer.prototype.configAnimation = function(animData){
    var resizerElem = document.createElement('div');
    var wrapper = this.animationItem.wrapper;
    resizerElem.style.width = animData.w+'px';
    resizerElem.style.height = animData.h+'px';
    this.resizerElem = resizerElem;
    styleDiv(resizerElem);
    resizerElem.style.transformStyle = resizerElem.style.webkitTransformStyle = resizerElem.style.mozTransformStyle = "flat";
    if(this.renderConfig.className) {
      wrapper.setAttribute('class', this.renderConfig.className);
    }
    wrapper.appendChild(resizerElem);

    resizerElem.style.overflow = 'hidden';
    var svg = document.createElementNS(svgNS,'svg');
    svg.setAttribute('width','1');
    svg.setAttribute('height','1');
    styleDiv(svg);
    this.resizerElem.appendChild(svg);
    var defs = document.createElementNS(svgNS,'defs');
    svg.appendChild(defs);
    this.globalData.defs = defs;
    this.data = animData;
    //Mask animation
    this.globalData.getAssetData = this.animationItem.getAssetData.bind(this.animationItem);
    this.globalData.getAssetsPath = this.animationItem.getAssetsPath.bind(this.animationItem);
    this.globalData.elementLoaded = this.animationItem.elementLoaded.bind(this.animationItem);
    this.globalData.frameId = 0;
    this.globalData.compSize = {
        w: animData.w,
        h: animData.h
    };
    this.globalData.frameRate = animData.fr;
    this.layers = animData.layers;
    this.globalData.fontManager = new FontManager();
    this.globalData.fontManager.addChars(animData.chars);
    this.globalData.fontManager.addFonts(animData.fonts,svg);
    this.layerElement = this.resizerElem;
    this.build3dContainers();
    this.updateContainerSize();
};

HybridRenderer.prototype.destroy = function () {
    this.animationItem.wrapper.innerHTML = '';
    this.animationItem.container = null;
    this.globalData.defs = null;
    var i, len = this.layers ? this.layers.length : 0;
    for (i = 0; i < len; i++) {
        this.elements[i].destroy();
    }
    this.elements.length = 0;
    this.destroyed = true;
    this.animationItem = null;
};

HybridRenderer.prototype.updateContainerSize = function () {
    var elementWidth = this.animationItem.wrapper.offsetWidth;
    var elementHeight = this.animationItem.wrapper.offsetHeight;
    var elementRel = elementWidth/elementHeight;
    var animationRel = this.globalData.compSize.w/this.globalData.compSize.h;
    var sx,sy,tx,ty;
    if(animationRel>elementRel){
        sx = elementWidth/(this.globalData.compSize.w);
        sy = elementWidth/(this.globalData.compSize.w);
        tx = 0;
        ty = ((elementHeight-this.globalData.compSize.h*(elementWidth/this.globalData.compSize.w))/2);
    }else{
        sx = elementHeight/(this.globalData.compSize.h);
        sy = elementHeight/(this.globalData.compSize.h);
        tx = (elementWidth-this.globalData.compSize.w*(elementHeight/this.globalData.compSize.h))/2;
        ty = 0;
    }
    this.resizerElem.style.transform = this.resizerElem.style.webkitTransform = 'matrix3d(' + sx + ',0,0,0,0,'+sy+',0,0,0,0,1,0,'+tx+','+ty+',0,1)';
};

HybridRenderer.prototype.renderFrame = SVGRenderer.prototype.renderFrame;

HybridRenderer.prototype.hide = function(){
    this.resizerElem.style.display = 'none';
};

HybridRenderer.prototype.show = function(){
    this.resizerElem.style.display = 'block';
};

HybridRenderer.prototype.initItems = function(){
    this.buildAllItems();
    if(this.camera){
        this.camera.setup();
    } else {
        var cWidth = this.globalData.compSize.w;
        var cHeight = this.globalData.compSize.h;
        var i, len = this.threeDElements.length;
        for(i=0;i<len;i+=1){
            this.threeDElements[i].perspectiveElem.style.perspective = this.threeDElements[i].perspectiveElem.style.webkitPerspective = Math.sqrt(Math.pow(cWidth,2) + Math.pow(cHeight,2)) + 'px';
        }
    }
};

HybridRenderer.prototype.searchExtraCompositions = function(assets){
    var i, len = assets.length;
    var floatingContainer = document.createElement('div');
    for(i=0;i<len;i+=1){
        if(assets[i].xt){
            var comp = this.createComp(assets[i],floatingContainer,this.globalData.comp,null);
            comp.initExpressions();
            this.globalData.projectInterface.registerComposition(comp);
        }
    }
};

function CVBaseElement(data, comp,globalData){
    this.globalData = globalData;
    this.data = data;
    this.comp = comp;
    this.canvasContext = globalData.canvasContext;
    this.init();
}

createElement(BaseElement, CVBaseElement);

CVBaseElement.prototype.createElements = function(){
    this.checkParenting();
};

CVBaseElement.prototype.checkBlendMode = function(globalData){
    if(globalData.blendMode !== this.data.bm) {
        globalData.blendMode = this.data.bm;

        var blendModeValue = '';
        switch (this.data.bm) {
            case 0:
                blendModeValue = 'normal';
                break;
            case 1:
                blendModeValue = 'multiply';
                break;
            case 2:
                blendModeValue = 'screen';
                break;
            case 3:
                blendModeValue = 'overlay';
                break;
            case 4:
                blendModeValue = 'darken';
                break;
            case 5:
                blendModeValue = 'lighten';
                break;
            case 6:
                blendModeValue = 'color-dodge';
                break;
            case 7:
                blendModeValue = 'color-burn';
                break;
            case 8:
                blendModeValue = 'hard-light';
                break;
            case 9:
                blendModeValue = 'soft-light';
                break;
            case 10:
                blendModeValue = 'difference';
                break;
            case 11:
                blendModeValue = 'exclusion';
                break;
            case 12:
                blendModeValue = 'hue';
                break;
            case 13:
                blendModeValue = 'saturation';
                break;
            case 14:
                blendModeValue = 'color';
                break;
            case 15:
                blendModeValue = 'luminosity';
                break;
        }
        globalData.canvasContext.globalCompositeOperation = blendModeValue;
    }
};


CVBaseElement.prototype.renderFrame = function(parentTransform){
    if(this.data.ty === 3){
        return false;
    }
        this.checkBlendMode(this.data.ty === 0?this.parentGlobalData:this.globalData);

    if(!this.isVisible){
        return this.isVisible;
    }
    this.finalTransform.opMdf = this.finalTransform.op.mdf;
    this.finalTransform.matMdf = this.finalTransform.mProp.mdf;
    this.finalTransform.opacity = this.finalTransform.op.v;

    var mat;
    var finalMat = this.finalTransform.mat;

    if(this.hierarchy){
        var i, len = this.hierarchy.length;
        mat = this.finalTransform.mProp.v.props;
        finalMat.cloneFromProps(mat);
        for(i=0;i<len;i+=1){
            this.finalTransform.matMdf = this.hierarchy[i].finalTransform.mProp.mdf ? true : this.finalTransform.matMdf;
            mat = this.hierarchy[i].finalTransform.mProp.v.props;
            finalMat.transform(mat[0],mat[1],mat[2],mat[3],mat[4],mat[5],mat[6],mat[7],mat[8],mat[9],mat[10],mat[11],mat[12],mat[13],mat[14],mat[15]);
        }
    }else{
        if(!parentTransform){
            finalMat.cloneFromProps(this.finalTransform.mProp.v.props);
        }else{
            mat = this.finalTransform.mProp.v.props;
            finalMat.cloneFromProps(mat);
        }
    }

    if(parentTransform){
        mat = parentTransform.mat.props;
        finalMat.transform(mat[0],mat[1],mat[2],mat[3],mat[4],mat[5],mat[6],mat[7],mat[8],mat[9],mat[10],mat[11],mat[12],mat[13],mat[14],mat[15]);
        this.finalTransform.opacity *= parentTransform.opacity;
        this.finalTransform.opMdf = parentTransform.opMdf ? true : this.finalTransform.opMdf;
        this.finalTransform.matMdf = parentTransform.matMdf ? true : this.finalTransform.matMdf
    }

    if(this.data.hasMask){
        this.globalData.renderer.save(true);
        this.maskManager.renderFrame(this.data.ty === 0?null:finalMat);
    }
    if(this.data.hd){
        this.isVisible = false;
    }
    return this.isVisible;

};

CVBaseElement.prototype.addMasks = function(data){
    this.maskManager = new CVMaskElement(data,this,this.globalData);
};


CVBaseElement.prototype.destroy = function(){
    this.canvasContext = null;
    this.data = null;
    this.globalData = null;
    if(this.maskManager) {
        this.maskManager.destroy();
    }
};

CVBaseElement.prototype.mHelper = new Matrix();

function CVCompElement(data, comp,globalData){
    this._parent.constructor.call(this,data, comp,globalData);
    var compGlobalData = {};
    for(var s in globalData){
        if(globalData.hasOwnProperty(s)){
            compGlobalData[s] = globalData[s];
        }
    }
    compGlobalData.renderer = this;
    compGlobalData.compHeight = this.data.h;
    compGlobalData.compWidth = this.data.w;
    this.renderConfig = {
        clearCanvas: true
    };
    this.contextData = {
        saved : Array.apply(null,{length:15}),
        savedOp: Array.apply(null,{length:15}),
        cArrPos : 0,
        cTr : new Matrix(),
        cO : 1
    };
    this.completeLayers = false;
    var i, len = 15;
    for(i=0;i<len;i+=1){
        this.contextData.saved[i] = Array.apply(null,{length:16});
    }
    this.transformMat = new Matrix();
    this.parentGlobalData = this.globalData;
    var cv = document.createElement('canvas');
    //document.body.appendChild(cv);
    compGlobalData.canvasContext = cv.getContext('2d');
    this.canvasContext = compGlobalData.canvasContext;
    cv.width = this.data.w;
    cv.height = this.data.h;
    this.canvas = cv;
    this.globalData = compGlobalData;
    this.layers = data.layers;
    this.pendingElements = [];
    this.elements = Array.apply(null,{length:this.layers.length});
    if(this.data.tm){
        this.tm = PropertyFactory.getProp(this,this.data.tm,0,globalData.frameRate,this.dynamicProperties);
    }
    if(this.data.xt || !globalData.progressiveLoad){
        this.buildAllItems();
    }
}
createElement(CVBaseElement, CVCompElement);

CVCompElement.prototype.ctxTransform = CanvasRenderer.prototype.ctxTransform;
CVCompElement.prototype.ctxOpacity = CanvasRenderer.prototype.ctxOpacity;
CVCompElement.prototype.save = CanvasRenderer.prototype.save;
CVCompElement.prototype.restore = CanvasRenderer.prototype.restore;
CVCompElement.prototype.reset =  function(){
    this.contextData.cArrPos = 0;
    this.contextData.cTr.reset();
    this.contextData.cO = 1;
};
CVCompElement.prototype.resize = function(transformCanvas){
    var maxScale = Math.max(transformCanvas.sx,transformCanvas.sy);
    this.canvas.width = this.data.w*maxScale;
    this.canvas.height = this.data.h*maxScale;
    this.transformCanvas = {
        sc:maxScale,
        w:this.data.w*maxScale,
        h:this.data.h*maxScale,
        props:[maxScale,0,0,0,0,maxScale,0,0,0,0,1,0,0,0,0,1]
    }
    var i,len = this.elements.length;
    for( i = 0; i < len; i+=1 ){
        if(this.elements[i] && this.elements[i].data.ty === 0){
            this.elements[i].resize(transformCanvas);
        }
    }
};

CVCompElement.prototype.prepareFrame = function(num){
    this.globalData.frameId = this.parentGlobalData.frameId;
    this.globalData.mdf = false;
    this._parent.prepareFrame.call(this,num);
    if(this.isVisible===false && !this.data.xt){
        return;
    }
    var timeRemapped = num;
    if(this.tm){
        timeRemapped = this.tm.v;
        if(timeRemapped === this.data.op){
            timeRemapped = this.data.op - 1;
        }
    }
    this.renderedFrame = timeRemapped/this.data.sr;
    var i,len = this.elements.length;

    if(!this.completeLayers){
        this.checkLayers(num);
    }

    for( i = 0; i < len; i+=1 ){
        if(this.completeLayers || this.elements[i]){
            this.elements[i].prepareFrame(timeRemapped/this.data.sr - this.layers[i].st);
            if(this.elements[i].data.ty === 0 && this.elements[i].globalData.mdf){
                this.globalData.mdf = true;
            }
        }
    }
    if(this.globalData.mdf && !this.data.xt){
        this.canvasContext.clearRect(0, 0, this.data.w, this.data.h);
        this.ctxTransform(this.transformCanvas.props);
    }
};

CVCompElement.prototype.renderFrame = function(parentMatrix){
    if(this._parent.renderFrame.call(this,parentMatrix)===false){
        return;
    }
    if(this.globalData.mdf){
        var i,len = this.layers.length;
        for( i = len - 1; i >= 0; i -= 1 ){
            if(this.completeLayers || this.elements[i]){
                this.elements[i].renderFrame();
            }
        }
    }
    if(this.data.hasMask){
        this.globalData.renderer.restore(true);
    }
    if(this.firstFrame){
        this.firstFrame = false;
    }
    this.parentGlobalData.renderer.save();
    this.parentGlobalData.renderer.ctxTransform(this.finalTransform.mat.props);
    this.parentGlobalData.renderer.ctxOpacity(this.finalTransform.opacity);
    this.parentGlobalData.renderer.canvasContext.drawImage(this.canvas,0,0,this.data.w,this.data.h);
    this.parentGlobalData.renderer.restore();

    if(this.globalData.mdf){
        this.reset();
    }
};

CVCompElement.prototype.setElements = function(elems){
    this.elements = elems;
};

CVCompElement.prototype.getElements = function(){
    return this.elements;
};

CVCompElement.prototype.destroy = function(){
    var i,len = this.layers.length;
    for( i = len - 1; i >= 0; i -= 1 ){
        this.elements[i].destroy();
    }
    this.layers = null;
    this.elements = null;
    this._parent.destroy.call(this._parent);
};
CVCompElement.prototype.checkLayers = CanvasRenderer.prototype.checkLayers;
CVCompElement.prototype.buildItem = CanvasRenderer.prototype.buildItem;
CVCompElement.prototype.checkPendingElements = CanvasRenderer.prototype.checkPendingElements;
CVCompElement.prototype.addPendingElement = CanvasRenderer.prototype.addPendingElement;
CVCompElement.prototype.buildAllItems = CanvasRenderer.prototype.buildAllItems;
CVCompElement.prototype.createItem = CanvasRenderer.prototype.createItem;
CVCompElement.prototype.createImage = CanvasRenderer.prototype.createImage;
CVCompElement.prototype.createComp = CanvasRenderer.prototype.createComp;
CVCompElement.prototype.createSolid = CanvasRenderer.prototype.createSolid;
CVCompElement.prototype.createShape = CanvasRenderer.prototype.createShape;
CVCompElement.prototype.createText = CanvasRenderer.prototype.createText;
CVCompElement.prototype.createBase = CanvasRenderer.prototype.createBase;
CVCompElement.prototype.buildElementParenting = CanvasRenderer.prototype.buildElementParenting;
function CVImageElement(data, comp,globalData){
    this.assetData = globalData.getAssetData(data.refId);
    this._parent.constructor.call(this,data, comp,globalData);
    this.globalData.addPendingElement();
}
createElement(CVBaseElement, CVImageElement);

CVImageElement.prototype.createElements = function(){
    var imageLoaded = function(){
        this.globalData.elementLoaded();
        if(this.assetData.w !== this.img.width || this.assetData.h !== this.img.height){
            var canvas = document.createElement('canvas');
            canvas.width = this.assetData.w;
            canvas.height = this.assetData.h;
            var ctx = canvas.getContext('2d');

            var imgW = this.img.width;
            var imgH = this.img.height;
            var imgRel = imgW / imgH;
            var canvasRel = this.assetData.w/this.assetData.h;
            var widthCrop, heightCrop;
            if(imgRel>canvasRel){
                heightCrop = imgH;
                widthCrop = heightCrop*canvasRel;
            } else {
                widthCrop = imgW;
                heightCrop = widthCrop/canvasRel;
            }
            ctx.drawImage(this.img,(imgW-widthCrop)/2,(imgH-heightCrop)/2,widthCrop,heightCrop,0,0,this.assetData.w,this.assetData.h);
            this.img = canvas;
        }
    }.bind(this);
    var imageFailed = function(){
        this.failed = true;
        this.globalData.elementLoaded();
    }.bind(this);

    this.img = new Image();
    this.img.addEventListener('load', imageLoaded, false);
    this.img.addEventListener('error', imageFailed, false);
    var assetPath = this.globalData.getAssetsPath(this.assetData);
    this.img.src = assetPath;

    this._parent.createElements.call(this);

};

CVImageElement.prototype.renderFrame = function(parentMatrix){
    if(this.failed){
        return;
    }
    if(this._parent.renderFrame.call(this,parentMatrix)===false){
        return;
    }
    var ctx = this.canvasContext;
    this.globalData.renderer.save();
    var finalMat = this.finalTransform.mat.props;
    this.globalData.renderer.ctxTransform(finalMat);
    this.globalData.renderer.ctxOpacity(this.finalTransform.opacity);
    ctx.drawImage(this.img,0,0);
    this.globalData.renderer.restore(this.data.hasMask);
    if(this.firstFrame){
        this.firstFrame = false;
    }
};

CVImageElement.prototype.destroy = function(){
    this.img = null;
    this._parent.destroy.call(this._parent);
};

function CVMaskElement(data,element){
    this.data = data;
    this.element = element;
    this.dynamicProperties = [];
    this.masksProperties = this.data.masksProperties;
    this.viewData = Array.apply(null,{length:this.masksProperties.length});
    var i, len = this.masksProperties.length;
    for (i = 0; i < len; i++) {
        this.viewData[i] = ShapePropertyFactory.getShapeProp(this.element,this.masksProperties[i],3,this.dynamicProperties,null);
    }
}

CVMaskElement.prototype.prepareFrame = function(num){
    var i, len = this.dynamicProperties.length;
    for(i=0;i<len;i+=1){
        this.dynamicProperties[i].getValue(num);
        if(this.dynamicProperties[i].mdf){
            this.element.globalData.mdf = true;
        }
    }
};

CVMaskElement.prototype.renderFrame = function (transform) {
    var ctx = this.element.canvasContext;
    var i, len = this.data.masksProperties.length;
    var pt,pt2,pt3,data, hasMasks = false;
    for (i = 0; i < len; i++) {
        if(this.masksProperties[i].mode === 'n'){
            continue;
        }
        if(hasMasks === false){
            ctx.beginPath();
            hasMasks = true;
        }
        if (this.masksProperties[i].inv) {
            ctx.moveTo(0, 0);
            ctx.lineTo(this.element.globalData.compWidth, 0);
            ctx.lineTo(this.element.globalData.compWidth, this.element.globalData.compHeight);
            ctx.lineTo(0, this.element.globalData.compHeight);
            ctx.lineTo(0, 0);
        }
        data = this.viewData[i].v;
        pt = transform ? transform.applyToPointArray(data.v[0][0],data.v[0][1],0):data.v[0];
        ctx.moveTo(pt[0], pt[1]);
        var j, jLen = data._length;
        for (j = 1; j < jLen; j++) {
            pt = transform ? transform.applyToPointArray(data.o[j - 1][0],data.o[j - 1][1],0) : data.o[j - 1];
            pt2 = transform ? transform.applyToPointArray(data.i[j][0],data.i[j][1],0) : data.i[j];
            pt3 = transform ? transform.applyToPointArray(data.v[j][0],data.v[j][1],0) : data.v[j];
            ctx.bezierCurveTo(pt[0], pt[1], pt2[0], pt2[1], pt3[0], pt3[1]);
        }
        pt = transform ? transform.applyToPointArray(data.o[j - 1][0],data.o[j - 1][1],0) : data.o[j - 1];
        pt2 = transform ? transform.applyToPointArray(data.i[0][0],data.i[0][1],0) : data.i[0];
        pt3 = transform ? transform.applyToPointArray(data.v[0][0],data.v[0][1],0) : data.v[0];
        ctx.bezierCurveTo(pt[0], pt[1], pt2[0], pt2[1], pt3[0], pt3[1]);
    }
    if(hasMasks){
        ctx.clip();
    }
};

CVMaskElement.prototype.getMaskProperty = MaskElement.prototype.getMaskProperty;

CVMaskElement.prototype.destroy = function(){
    this.element = null;
};
function CVShapeElement(data, comp,globalData){
    this.shapes = [];
    this.shapesData = data.shapes;
    this.stylesList = [];
    this.itemsData = [];
    this.prevViewData = [];
    this.shapeModifiers = [];
    this.processedElements = [];
    this._parent.constructor.call(this,data, comp,globalData);
}
createElement(CVBaseElement, CVShapeElement);

CVShapeElement.prototype.transformHelper = {opacity:1,mat:new Matrix(),matMdf:false,opMdf:false};

CVShapeElement.prototype.dashResetter = [];

CVShapeElement.prototype.createElements = function(){

    this._parent.createElements.call(this);
    this.searchShapes(this.shapesData,this.itemsData,this.prevViewData,this.dynamicProperties, true);
};

CVShapeElement.prototype.createStyleElement = function(data, dynamicProperties){
    var styleElem = {
        data: data,
        type: data.ty,
        elements: []
    };
    var elementData = {};
    if(data.ty == 'fl' || data.ty == 'st'){
        elementData.c = PropertyFactory.getProp(this,data.c,1,255,dynamicProperties);
        if(!elementData.c.k){
            styleElem.co = 'rgb('+bm_floor(elementData.c.v[0])+','+bm_floor(elementData.c.v[1])+','+bm_floor(elementData.c.v[2])+')';
        }
    }
    elementData.o = PropertyFactory.getProp(this,data.o,0,0.01,dynamicProperties);
    if(data.ty == 'st') {
        styleElem.lc = this.lcEnum[data.lc] || 'round';
        styleElem.lj = this.ljEnum[data.lj] || 'round';
        if(data.lj == 1) {
            styleElem.ml = data.ml;
        }
        elementData.w = PropertyFactory.getProp(this,data.w,0,null,dynamicProperties);
        if(!elementData.w.k){
            styleElem.wi = elementData.w.v;
        }
        if(data.d){
            var d = PropertyFactory.getDashProp(this,data.d,'canvas',dynamicProperties);
            elementData.d = d;
            if(!elementData.d.k){
                styleElem.da = elementData.d.dasharray;
                styleElem.do = elementData.d.dashoffset;
            }
        }

    } else {

        styleElem.r = data.r === 2 ? 'evenodd' : 'nonzero';
    }
    this.stylesList.push(styleElem);
    elementData.style = styleElem;
    return elementData;
}

CVShapeElement.prototype.createGroupElement = function(data) {
    var elementData = {
        it: [],
        prevViewData: []
    };
    return elementData;
}

CVShapeElement.prototype.createTransformElement = function(data, dynamicProperties) {
    var elementData = {
        transform : {
            mat: new Matrix(),
            opacity: 1,
            matMdf:false,
            opMdf:false,
            op: PropertyFactory.getProp(this,data.o,0,0.01,dynamicProperties),
            mProps: PropertyFactory.getProp(this,data,2,null,dynamicProperties)
        },
        elements: []
    };
    return elementData;
}

CVShapeElement.prototype.createShapeElement = function(data, dynamicProperties) {
    var elementData = {
        nodes:[],
        trNodes:[],
        tr:[0,0,0,0,0,0]
    };
    var ty = 4;
    if(data.ty == 'rc'){
        ty = 5;
    }else if(data.ty == 'el'){
        ty = 6;
    }else if(data.ty == 'sr'){
        ty = 7;
    }
    elementData.sh = ShapePropertyFactory.getShapeProp(this,data,ty,dynamicProperties);
    this.shapes.push(elementData.sh);
    this.addShapeToModifiers(elementData);
    jLen = this.stylesList.length;
    var hasStrokes = false, hasFills = false;
    for(j=0;j<jLen;j+=1){
        if(!this.stylesList[j].closed){
            this.stylesList[j].elements.push(elementData);
            if(this.stylesList[j].type === 'st'){
                hasStrokes = true;
            }else{
                hasFills = true;
            }
        }
    }
    elementData.st = hasStrokes;
    elementData.fl = hasFills;
    return elementData;
}

CVShapeElement.prototype.reloadShapes = function(){
    this.firstFrame = true;
    var i, len = this.itemsData.length;
    for(i=0;i<len;i+=1){
        this.prevViewData[i] = this.itemsData[i];
    }
    this.searchShapes(this.shapesData,this.itemsData,this.prevViewData,this.dynamicProperties, true);
    var i, len = this.dynamicProperties.length;
    for(i=0;i<len;i+=1){
        this.dynamicProperties[i].getValue();
    }
    this.renderModifiers();
}

CVShapeElement.prototype.searchShapes = function(arr,itemsData, prevViewData,dynamicProperties, render){
    var i, len = arr.length - 1;
    var j, jLen;
    var ownArrays = [], ownModifiers = [], processedPos;
    for(i=len;i>=0;i-=1){
        processedPos = this.searchProcessedElement(arr[i]);
        if(!processedPos){
            arr[i]._render = render;
        } else {
            itemsData[i] = prevViewData[processedPos - 1];
        }
        if(arr[i].ty == 'fl' || arr[i].ty == 'st'){
            if(!processedPos){
                itemsData[i] = this.createStyleElement(arr[i], dynamicProperties);
            } else {
                itemsData[i].style.closed = false;
            }
            
            ownArrays.push(itemsData[i].style);
        }else if(arr[i].ty == 'gr'){
            if(!processedPos){
                itemsData[i] = this.createGroupElement(arr[i]);
            } else {
                jLen = itemsData[i].it.length;
                for(j=0;j<jLen;j+=1){
                    itemsData[i].prevViewData[j] = itemsData[i].it[j];
                }
            }
            this.searchShapes(arr[i].it,itemsData[i].it,itemsData[i].prevViewData,dynamicProperties, render);
        }else if(arr[i].ty == 'tr'){
            if(!processedPos){
                itemsData[i] = this.createTransformElement(arr[i], dynamicProperties);
            }
        }else if(arr[i].ty == 'sh' || arr[i].ty == 'rc' || arr[i].ty == 'el' || arr[i].ty == 'sr'){
            if(!processedPos){
                itemsData[i] = this.createShapeElement(arr[i], dynamicProperties);
            }
            
        }else if(arr[i].ty == 'tm' || arr[i].ty == 'rd'){
            if(!processedPos){
                var modifier = ShapeModifiers.getModifier(arr[i].ty);
                modifier.init(this,arr[i],dynamicProperties);
                itemsData[i] = modifier;
                this.shapeModifiers.push(modifier);
            } else {
                modifier = itemsData[i];
                modifier.closed = false;
            }
            ownModifiers.push(modifier);
        } else if(arr[i].ty == 'rp'){
            if(!processedPos){
                modifier = ShapeModifiers.getModifier(arr[i].ty);
                itemsData[i] = modifier;
                modifier.init(this,arr,i,itemsData,dynamicProperties);
                this.shapeModifiers.push(modifier);
                render = false;
            }else{
                modifier = itemsData[i];
                modifier.closed = true;
            }
            ownModifiers.push(modifier);
        }
        this.addProcessedElement(arr[i], i + 1);
    }
    len = ownArrays.length;
    for(i=0;i<len;i+=1){
        ownArrays[i].closed = true;
    }
    len = ownModifiers.length;
    for(i=0;i<len;i+=1){
        ownModifiers[i].closed = true;
    }
};

CVShapeElement.prototype.addShapeToModifiers = IShapeElement.prototype.addShapeToModifiers;
CVShapeElement.prototype.renderModifiers = IShapeElement.prototype.renderModifiers;
CVShapeElement.prototype.lcEnum = IShapeElement.prototype.lcEnum;
CVShapeElement.prototype.ljEnum = IShapeElement.prototype.ljEnum;
CVShapeElement.prototype.searchProcessedElement = IShapeElement.prototype.searchProcessedElement;
CVShapeElement.prototype.addProcessedElement = IShapeElement.prototype.addProcessedElement;

CVShapeElement.prototype.renderFrame = function(parentMatrix){
    if(this._parent.renderFrame.call(this, parentMatrix)===false){
        return;
    }
    this.transformHelper.mat.reset();
    this.transformHelper.opacity = this.finalTransform.opacity;
    this.transformHelper.matMdf = false;
    this.transformHelper.opMdf = this.finalTransform.opMdf;
    this.renderModifiers();
    this.renderShape(this.transformHelper,null,null,true);
    if(this.data.hasMask){
        this.globalData.renderer.restore(true);
    }
};

CVShapeElement.prototype.renderShape = function(parentTransform,items,data,isMain){
    var i, len;
    if(!items){
        items = this.shapesData;
        len = this.stylesList.length;
        for(i=0;i<len;i+=1){
            this.stylesList[i].d = '';
            this.stylesList[i].mdf = false;
        }
    }
    if(!data){
        data = this.itemsData;
    }
    ///
    ///
    len = items.length - 1;
    var groupTransform,groupMatrix;
    groupTransform = parentTransform;
    for(i=len;i>=0;i-=1){
        if(items[i].ty == 'tr'){
            groupTransform = data[i].transform;
            var mtArr = data[i].transform.mProps.v.props;
            groupTransform.matMdf = groupTransform.mProps.mdf;
            groupTransform.opMdf = groupTransform.op.mdf;
            groupMatrix = groupTransform.mat;
            groupMatrix.cloneFromProps(mtArr);
            if(parentTransform){
                var props = parentTransform.mat.props;
                groupTransform.opacity = parentTransform.opacity;
                groupTransform.opacity *= data[i].transform.op.v;
                groupTransform.matMdf = parentTransform.matMdf ? true : groupTransform.matMdf;
                groupTransform.opMdf = parentTransform.opMdf ? true : groupTransform.opMdf;
                groupMatrix.transform(props[0],props[1],props[2],props[3],props[4],props[5],props[6],props[7],props[8],props[9],props[10],props[11],props[12],props[13],props[14],props[15]);
            }else{
                groupTransform.opacity = groupTransform.op.o;
            }
        }else if(items[i].ty == 'sh' || items[i].ty == 'el' || items[i].ty == 'rc' || items[i].ty == 'sr'){
            this.renderPath(items[i],data[i],groupTransform);
        }else if(items[i].ty == 'fl'){
            this.renderFill(items[i],data[i],groupTransform);
        }else if(items[i].ty == 'st'){
            this.renderStroke(items[i],data[i],groupTransform);
        }else if(items[i].ty == 'gr'){
            this.renderShape(groupTransform,items[i].it,data[i].it);
        }else if(items[i].ty == 'tm'){
            //
        }
    }
    if(!isMain){
        return;
    }
    len = this.stylesList.length;
    var j, jLen, k, kLen,elems,nodes, renderer = this.globalData.renderer, ctx = this.globalData.canvasContext, type;
    renderer.save();
    renderer.ctxTransform(this.finalTransform.mat.props);
    for(i=0;i<len;i+=1){
        type = this.stylesList[i].type;
        if((type === 'st' && this.stylesList[i].wi === 0) || !this.stylesList[i].data._render){
            continue;
        }
        renderer.save();
        elems = this.stylesList[i].elements;
        if(type === 'st'){
            ctx.strokeStyle = this.stylesList[i].co;
            ctx.lineWidth = this.stylesList[i].wi;
            ctx.lineCap = this.stylesList[i].lc;
            ctx.lineJoin = this.stylesList[i].lj;
            ctx.miterLimit = this.stylesList[i].ml || 0;
        }else{
            ctx.fillStyle = this.stylesList[i].co;
        }
        renderer.ctxOpacity(this.stylesList[i].coOp);
        if(type !== 'st'){
            ctx.beginPath();
        }
        jLen = elems.length;
        for(j=0;j<jLen;j+=1){
            if(type === 'st'){
                ctx.beginPath();
                if(this.stylesList[i].da){
                    ctx.setLineDash(this.stylesList[i].da);
                    ctx.lineDashOffset = this.stylesList[i].do;
                    this.globalData.isDashed = true;
                }else if(this.globalData.isDashed){
                    ctx.setLineDash(this.dashResetter);
                    this.globalData.isDashed = false;
                }
            }
            nodes = elems[j].trNodes;
            kLen = nodes.length;

            for(k=0;k<kLen;k+=1){
                if(nodes[k].t == 'm'){
                    ctx.moveTo(nodes[k].p[0],nodes[k].p[1]);
                }else if(nodes[k].t == 'c'){
                    ctx.bezierCurveTo(nodes[k].p1[0],nodes[k].p1[1],nodes[k].p2[0],nodes[k].p2[1],nodes[k].p3[0],nodes[k].p3[1]);
                }else{
                    ctx.closePath();
                }
            }
            if(type === 'st'){
                ctx.stroke();
            }
        }
        if(type !== 'st'){
            ctx.fill(this.stylesList[i].r);
        }
        renderer.restore();
    }
    renderer.restore();
    if(this.firstFrame){
        this.firstFrame = false;
    }
};
CVShapeElement.prototype.renderPath = function(pathData,itemData,groupTransform){
    var len, i, j,jLen;
    var redraw = groupTransform.matMdf || itemData.sh.mdf || this.firstFrame;
    if(redraw) {
        var paths = itemData.sh.paths, groupTransformMat = groupTransform.mat;
        jLen = paths._length;
        var pathStringTransformed = itemData.trNodes;
        pathStringTransformed.length = 0;
        for(j=0;j<jLen;j+=1){
            var pathNodes = paths.shapes[j];
            if(pathNodes && pathNodes.v){
                len = pathNodes._length;
                for (i = 1; i < len; i += 1) {
                    if (i == 1) {
                        pathStringTransformed.push({
                            t: 'm',
                            p: groupTransformMat.applyToPointArray(pathNodes.v[0][0], pathNodes.v[0][1], 0)
                        });
                    }
                    pathStringTransformed.push({
                        t: 'c',
                        p1: groupTransformMat.applyToPointArray(pathNodes.o[i - 1][0], pathNodes.o[i - 1][1], 0),
                        p2: groupTransformMat.applyToPointArray(pathNodes.i[i][0], pathNodes.i[i][1], 0),
                        p3: groupTransformMat.applyToPointArray(pathNodes.v[i][0], pathNodes.v[i][1], 0)
                    });
                }
                if (len == 1) {
                    pathStringTransformed.push({
                        t: 'm',
                        p: groupTransformMat.applyToPointArray(pathNodes.v[0][0], pathNodes.v[0][1], 0)
                    });
                }
                if (pathNodes.c && len) {
                    pathStringTransformed.push({
                        t: 'c',
                        p1: groupTransformMat.applyToPointArray(pathNodes.o[i - 1][0], pathNodes.o[i - 1][1], 0),
                        p2: groupTransformMat.applyToPointArray(pathNodes.i[0][0], pathNodes.i[0][1], 0),
                        p3: groupTransformMat.applyToPointArray(pathNodes.v[0][0], pathNodes.v[0][1], 0)
                    });
                    pathStringTransformed.push({
                        t: 'z'
                    });
                }
                itemData.lStr = pathStringTransformed;
            }

        }

        if (itemData.st) {
            for (i = 0; i < 16; i += 1) {
                itemData.tr[i] = groupTransform.mat.props[i];
            }
        }
        itemData.trNodes = pathStringTransformed;

    }
};



CVShapeElement.prototype.renderFill = function(styleData,itemData, groupTransform){
    var styleElem = itemData.style;

    if(itemData.c.mdf || this.firstFrame){
        styleElem.co = 'rgb('+bm_floor(itemData.c.v[0])+','+bm_floor(itemData.c.v[1])+','+bm_floor(itemData.c.v[2])+')';
    }
    if(itemData.o.mdf || groupTransform.opMdf || this.firstFrame){
        styleElem.coOp = itemData.o.v*groupTransform.opacity;
    }
};

CVShapeElement.prototype.renderStroke = function(styleData,itemData, groupTransform){
    var styleElem = itemData.style;
    //TODO fix dashes
    var d = itemData.d;
    var dasharray,dashoffset;
    if(d && (d.mdf  || this.firstFrame)){
        styleElem.da = d.dasharray;
        styleElem.do = d.dashoffset;
    }
    if(itemData.c.mdf || this.firstFrame){
        styleElem.co = 'rgb('+bm_floor(itemData.c.v[0])+','+bm_floor(itemData.c.v[1])+','+bm_floor(itemData.c.v[2])+')';
    }
    if(itemData.o.mdf || groupTransform.opMdf || this.firstFrame){
        styleElem.coOp = itemData.o.v*groupTransform.opacity;
    }
    if(itemData.w.mdf || this.firstFrame){
        styleElem.wi = itemData.w.v;
    }
};


CVShapeElement.prototype.destroy = function(){
    this.shapesData = null;
    this.globalData = null;
    this.canvasContext = null;
    this.stylesList.length = 0;
    this.itemData.length = 0;
    this._parent.destroy.call(this._parent);
};


function CVSolidElement(data, comp,globalData){
    this._parent.constructor.call(this,data, comp,globalData);
}
createElement(CVBaseElement, CVSolidElement);

CVSolidElement.prototype.renderFrame = function(parentMatrix){
    if(this._parent.renderFrame.call(this, parentMatrix)===false){
        return;
    }
    var ctx = this.canvasContext;
    this.globalData.renderer.save();
    this.globalData.renderer.ctxTransform(this.finalTransform.mat.props);
    this.globalData.renderer.ctxOpacity(this.finalTransform.opacity);
    ctx.fillStyle=this.data.sc;
    ctx.fillRect(0,0,this.data.sw,this.data.sh);
    this.globalData.renderer.restore(this.data.hasMask);
    if(this.firstFrame){
        this.firstFrame = false;
    }
};
function CVTextElement(data, comp, globalData){
    this.textSpans = [];
    this.yOffset = 0;
    this.fillColorAnim = false;
    this.strokeColorAnim = false;
    this.strokeWidthAnim = false;
    this.stroke = false;
    this.fill = false;
    this.justifyOffset = 0;
    this.currentRender = null;
    this.renderType = 'canvas';
    this.values = {
        fill: 'rgba(0,0,0,0)',
        stroke: 'rgba(0,0,0,0)',
        sWidth: 0,
        fValue: ''
    }
    this._parent.constructor.call(this,data,comp, globalData);
}
createElement(CVBaseElement, CVTextElement);

extendPrototype(ITextElement, CVTextElement);

CVTextElement.prototype.tHelper = document.createElement('canvas').getContext('2d');

CVTextElement.prototype.createElements = function(){

    this._parent.createElements.call(this);
    //console.log('this.data: ',this.data);

};

CVTextElement.prototype.buildNewText = function(){
    var documentData = this.textProperty.currentData;
    this.renderedLetters = Array.apply(null,{length:documentData.l ? documentData.l.length : 0});

    var hasFill = false;
    if(documentData.fc) {
        hasFill = true;
        this.values.fill = this.buildColor(documentData.fc);
    }else{
        this.values.fill = 'rgba(0,0,0,0)';
    }
    this.fill = hasFill;
    var hasStroke = false;
    if(documentData.sc){
        hasStroke = true;
        this.values.stroke = this.buildColor(documentData.sc);
        this.values.sWidth = documentData.sw;
    }
    var fontData = this.globalData.fontManager.getFontByName(documentData.f);
    var i, len;
    var letters = documentData.l;
    var matrixHelper = this.mHelper;
    this.stroke = hasStroke;
    this.values.fValue = documentData.s + 'px '+ this.globalData.fontManager.getFontByName(documentData.f).fFamily;
    len = documentData.t.length;
    //this.tHelper.font = this.values.fValue;
    var charData, shapeData, k, kLen, shapes, j, jLen, pathNodes, commands, pathArr, singleShape = this.data.singleShape;
    var trackingOffset = documentData.tr/1000*documentData.s;
    var xPos = 0, yPos = 0, firstLine = true;
    var cnt = 0;
    for (i = 0; i < len; i += 1) {
        charData = this.globalData.fontManager.getCharData(documentData.t.charAt(i), fontData.fStyle, this.globalData.fontManager.getFontByName(documentData.f).fFamily);
        shapeData = charData && charData.data || {};
        matrixHelper.reset();
        if(singleShape && letters[i].n) {
            xPos = -trackingOffset;
            yPos += documentData.yOffset;
            yPos += firstLine ? 1 : 0;
            firstLine = false;
        }

        shapes = shapeData.shapes ? shapeData.shapes[0].it : [];
        jLen = shapes.length;
        matrixHelper.scale(documentData.s/100,documentData.s/100);
        if(singleShape){
            this.applyTextPropertiesToMatrix(documentData, matrixHelper, letters[i].line, xPos, yPos);
        }
        commands = Array.apply(null,{length:jLen})
        for(j=0;j<jLen;j+=1){
            kLen = shapes[j].ks.k.i.length;
            pathNodes = shapes[j].ks.k;
            pathArr = [];
            for(k=1;k<kLen;k+=1){
                if(k==1){
                    pathArr.push(matrixHelper.applyToX(pathNodes.v[0][0],pathNodes.v[0][1],0),matrixHelper.applyToY(pathNodes.v[0][0],pathNodes.v[0][1],0));
                }
                pathArr.push(matrixHelper.applyToX(pathNodes.o[k-1][0],pathNodes.o[k-1][1],0),matrixHelper.applyToY(pathNodes.o[k-1][0],pathNodes.o[k-1][1],0),matrixHelper.applyToX(pathNodes.i[k][0],pathNodes.i[k][1],0),matrixHelper.applyToY(pathNodes.i[k][0],pathNodes.i[k][1],0),matrixHelper.applyToX(pathNodes.v[k][0],pathNodes.v[k][1],0),matrixHelper.applyToY(pathNodes.v[k][0],pathNodes.v[k][1],0));
            }
            pathArr.push(matrixHelper.applyToX(pathNodes.o[k-1][0],pathNodes.o[k-1][1],0),matrixHelper.applyToY(pathNodes.o[k-1][0],pathNodes.o[k-1][1],0),matrixHelper.applyToX(pathNodes.i[0][0],pathNodes.i[0][1],0),matrixHelper.applyToY(pathNodes.i[0][0],pathNodes.i[0][1],0),matrixHelper.applyToX(pathNodes.v[0][0],pathNodes.v[0][1],0),matrixHelper.applyToY(pathNodes.v[0][0],pathNodes.v[0][1],0));
            commands[j] = pathArr;
        }
        if(singleShape){
            xPos += letters[i].l;
            xPos += trackingOffset;
        }
        if(this.textSpans[cnt]){
            this.textSpans[cnt].elem = commands;
        } else {
            this.textSpans[cnt] = {elem: commands};
        }
        cnt +=1;
    }
}

CVTextElement.prototype.renderFrame = function(parentMatrix){
    if(this._parent.renderFrame.call(this, parentMatrix)===false){
        return;
    }
    var ctx = this.canvasContext;
    var finalMat = this.finalTransform.mat.props;
    this.globalData.renderer.save();
    this.globalData.renderer.ctxTransform(finalMat);
    this.globalData.renderer.ctxOpacity(this.finalTransform.opacity);
    ctx.font = this.values.fValue;
    ctx.lineCap = 'butt';
    ctx.lineJoin = 'miter';
    ctx.miterLimit = 4;

    if(!this.data.singleShape){
        this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag);
    }

    var  i,len, j, jLen, k, kLen;
    var renderedLetters = this.textAnimator.renderedLetters;

    var letters = this.textProperty.currentData.l;

    len = letters.length;
    var renderedLetter;
    var lastFill = null, lastStroke = null, lastStrokeW = null, commands, pathArr;
    for(i=0;i<len;i+=1){
        if(letters[i].n){
            continue;
        }
        renderedLetter = renderedLetters[i];
        if(renderedLetter){
            this.globalData.renderer.save();
            this.globalData.renderer.ctxTransform(renderedLetter.p);
            this.globalData.renderer.ctxOpacity(renderedLetter.o);
        }
        if(this.fill){
            if(renderedLetter && renderedLetter.fc){
                if(lastFill !== renderedLetter.fc){
                    lastFill = renderedLetter.fc;
                    ctx.fillStyle = renderedLetter.fc;
                }
            }else if(lastFill !== this.values.fill){
                lastFill = this.values.fill;
                ctx.fillStyle = this.values.fill;
            }
            commands = this.textSpans[i].elem;
            jLen = commands.length;
            this.globalData.canvasContext.beginPath();
            for(j=0;j<jLen;j+=1) {
                pathArr = commands[j];
                kLen = pathArr.length;
                this.globalData.canvasContext.moveTo(pathArr[0], pathArr[1]);
                for (k = 2; k < kLen; k += 6) {
                    this.globalData.canvasContext.bezierCurveTo(pathArr[k], pathArr[k + 1], pathArr[k + 2], pathArr[k + 3], pathArr[k + 4], pathArr[k + 5]);
                }
            }
            this.globalData.canvasContext.closePath();
            this.globalData.canvasContext.fill();
            ///ctx.fillText(this.textSpans[i].val,0,0);
        }
        if(this.stroke){
            if(renderedLetter && renderedLetter.sw){
                if(lastStrokeW !== renderedLetter.sw){
                    lastStrokeW = renderedLetter.sw;
                    ctx.lineWidth = renderedLetter.sw;
                }
            }else if(lastStrokeW !== this.values.sWidth){
                lastStrokeW = this.values.sWidth;
                ctx.lineWidth = this.values.sWidth;
            }
            if(renderedLetter && renderedLetter.sc){
                if(lastStroke !== renderedLetter.sc){
                    lastStroke = renderedLetter.sc;
                    ctx.strokeStyle = renderedLetter.sc;
                }
            }else if(lastStroke !== this.values.stroke){
                lastStroke = this.values.stroke;
                ctx.strokeStyle = this.values.stroke;
            }
            commands = this.textSpans[i].elem;
            jLen = commands.length;
            this.globalData.canvasContext.beginPath();
            for(j=0;j<jLen;j+=1) {
                pathArr = commands[j];
                kLen = pathArr.length;
                this.globalData.canvasContext.moveTo(pathArr[0], pathArr[1]);
                for (k = 2; k < kLen; k += 6) {
                    this.globalData.canvasContext.bezierCurveTo(pathArr[k], pathArr[k + 1], pathArr[k + 2], pathArr[k + 3], pathArr[k + 4], pathArr[k + 5]);
                }
            }
            this.globalData.canvasContext.closePath();
            this.globalData.canvasContext.stroke();
            ///ctx.strokeText(letters[i].val,0,0);
        }
        if(renderedLetter) {
            this.globalData.renderer.restore();
        }
    }
    /*if(this.data.hasMask){
     this.globalData.renderer.restore(true);
     }*/
    this.globalData.renderer.restore(this.data.hasMask);
    if(this.firstFrame){
        this.firstFrame = false;
    }
};
function HBaseElement(data,parentContainer,globalData,comp, placeholder){
    this.globalData = globalData;
    this.comp = comp;
    this.data = data;
    this.matteElement = null;
    this.parentContainer = parentContainer;
    this.layerId = placeholder ? placeholder.layerId : 'ly_'+randomString(10);
    this.placeholder = placeholder;
    this.init();
};

createElement(BaseElement, HBaseElement);
HBaseElement.prototype.checkBlendMode = function(){

};
HBaseElement.prototype.setBlendMode = BaseElement.prototype.setBlendMode;

/*HBaseElement.prototype.appendNodeToParent = function(node) {
    if(this.data.hd){
        return;
    }
    if(this.placeholder){
        var g = this.placeholder.phElement;
        g.parentNode.insertBefore(node, g);
        //g.parentNode.removeChild(g);
    }else{
        this.parentContainer.appendChild(node);
    }
};*/


HBaseElement.prototype.getBaseElement = function(){
    return this.baseElement;
};

HBaseElement.prototype.createElements = function(){
    if(this.data.hasMask){
        this.layerElement = document.createElementNS(svgNS,'svg');
        styleDiv(this.layerElement);
        //this.appendNodeToParent(this.layerElement);
        this.baseElement = this.layerElement;
        this.maskedElement = this.layerElement;
    }else{
        this.layerElement = this.parentContainer;
    }
    this.transformedElement = this.layerElement;
    if(this.data.ln && (this.data.ty === 4 || this.data.ty === 0)){
        if(this.layerElement === this.parentContainer){
            this.layerElement = document.createElementNS(svgNS,'g');
            //this.appendNodeToParent(this.layerElement);
            this.baseElement = this.layerElement;
        }
        this.layerElement.setAttribute('id',this.data.ln);
    }
    this.setBlendMode();
    if(this.layerElement !== this.parentContainer){
        this.placeholder = null;
    }
    this.checkParenting();
};

HBaseElement.prototype.renderFrame = function(parentTransform){
    if(this.data.ty === 3){
        return false;
    }

    if(this.currentFrameNum === this.lastNum || !this.isVisible){
        return this.isVisible;
    }
    this.lastNum = this.currentFrameNum;

    this.finalTransform.opMdf = this.finalTransform.op.mdf;
    this.finalTransform.matMdf = this.finalTransform.mProp.mdf;
    this.finalTransform.opacity = this.finalTransform.op.v;
    if(this.firstFrame){
        this.finalTransform.opMdf = true;
        this.finalTransform.matMdf = true;
    }

    var mat;
    var finalMat = this.finalTransform.mat;

    if(this.hierarchy){
        var i, len = this.hierarchy.length;

        mat = this.finalTransform.mProp.v.props;
        finalMat.cloneFromProps(mat);
        for(i=0;i<len;i+=1){
            this.finalTransform.matMdf = this.hierarchy[i].finalTransform.mProp.mdf ? true : this.finalTransform.matMdf;
            mat = this.hierarchy[i].finalTransform.mProp.v.props;
            finalMat.transform(mat[0],mat[1],mat[2],mat[3],mat[4],mat[5],mat[6],mat[7],mat[8],mat[9],mat[10],mat[11],mat[12],mat[13],mat[14],mat[15]);
        }
    }else{
        if(this.isVisible && this.finalTransform.matMdf){
            if(!parentTransform){
                finalMat.cloneFromProps(this.finalTransform.mProp.v.props);
            }else{
                mat = this.finalTransform.mProp.v.props;
                finalMat.cloneFromProps(mat);
            }
        }
    }
    if(this.data.hasMask){
        this.maskManager.renderFrame(finalMat);
    }

    if(parentTransform){
        mat = parentTransform.mat.props;
        finalMat.cloneFromProps(mat);
        this.finalTransform.opacity *= parentTransform.opacity;
        this.finalTransform.opMdf = parentTransform.opMdf ? true : this.finalTransform.opMdf;
        this.finalTransform.matMdf = parentTransform.matMdf ? true : this.finalTransform.matMdf
    }

    if(this.finalTransform.matMdf){
        this.transformedElement.style.transform = this.transformedElement.style.webkitTransform = finalMat.toCSS();
        this.finalMat = finalMat;
    }
    if(this.finalTransform.opMdf){
        this.transformedElement.style.opacity = this.finalTransform.opacity;
    }
    return this.isVisible;
};

HBaseElement.prototype.destroy = function(){
    this.layerElement = null;
    this.transformedElement = null;
    this.parentContainer = null;
    if(this.matteElement) {
        this.matteElement = null;
    }
    if(this.maskManager) {
        this.maskManager.destroy();
        this.maskManager = null;
    }
};

HBaseElement.prototype.getDomElement = function(){
    return this.layerElement;
};
HBaseElement.prototype.addMasks = function(data){
    this.maskManager = new MaskElement(data,this,this.globalData);
};

HBaseElement.prototype.hide = function(){
};

HBaseElement.prototype.setMatte = function(){

}

HBaseElement.prototype.buildElementParenting = HybridRenderer.prototype.buildElementParenting;
function HSolidElement(data,parentContainer,globalData,comp, placeholder){
    this._parent.constructor.call(this,data,parentContainer,globalData,comp, placeholder);
}
createElement(HBaseElement, HSolidElement);

HSolidElement.prototype.createElements = function(){
    var parent = document.createElement('div');
    styleDiv(parent);
    var cont = document.createElementNS(svgNS,'svg');
    styleDiv(cont);
    cont.setAttribute('width',this.data.sw);
    cont.setAttribute('height',this.data.sh);
    parent.appendChild(cont);
    this.layerElement = parent;
    this.transformedElement = parent;
    //this.appendNodeToParent(parent);
    this.baseElement = parent;
    this.innerElem = parent;
    if(this.data.ln){
        this.innerElem.setAttribute('id',this.data.ln);
    }
    if(this.data.bm !== 0){
        this.setBlendMode();
    }
    var rect = document.createElementNS(svgNS,'rect');
    rect.setAttribute('width',this.data.sw);
    rect.setAttribute('height',this.data.sh);
    rect.setAttribute('fill',this.data.sc);
    cont.appendChild(rect);
    if(this.data.hasMask){
        this.maskedElement = rect;
    }
    this.checkParenting();
};



HSolidElement.prototype.hide = SVGBaseElement.prototype.hide;
HSolidElement.prototype.show = SVGBaseElement.prototype.show;
HSolidElement.prototype.renderFrame = IImageElement.prototype.renderFrame;
HSolidElement.prototype.destroy = IImageElement.prototype.destroy;
function HCompElement(data,parentContainer,globalData,comp, placeholder){
    this._parent.constructor.call(this,data,parentContainer,globalData,comp, placeholder);
    this.layers = data.layers;
    this.supports3d = true;
    this.completeLayers = false;
    this.pendingElements = [];
    this.elements = Array.apply(null,{length:this.layers.length});
    if(this.data.tm){
        this.tm = PropertyFactory.getProp(this,this.data.tm,0,globalData.frameRate,this.dynamicProperties);
    }
    if(this.data.hasMask) {
        this.supports3d = false;
    }
    if(this.data.xt){
        this.layerElement = document.createElement('div');
    }
    this.buildAllItems();

}
createElement(HBaseElement, HCompElement);

HCompElement.prototype.createElements = function(){
    var divElement = document.createElement('div');
    styleDiv(divElement);
    if(this.data.ln){
        divElement.setAttribute('id',this.data.ln);
    }
    divElement.style.clip = 'rect(0px, '+this.data.w+'px, '+this.data.h+'px, 0px)';
    if(this.data.hasMask){
        var compSvg = document.createElementNS(svgNS,'svg');
        styleDiv(compSvg);
        compSvg.setAttribute('width',this.data.w);
        compSvg.setAttribute('height',this.data.h);
        var g = document.createElementNS(svgNS,'g');
        compSvg.appendChild(g);
        divElement.appendChild(compSvg);
        this.maskedElement = g;
        this.baseElement = divElement;
        this.layerElement = g;
        this.transformedElement = divElement;
    }else{
        this.layerElement = divElement;
        this.baseElement = this.layerElement;
        this.transformedElement = divElement;
    }
    //this.appendNodeToParent(this.layerElement);
    this.checkParenting();
};

HCompElement.prototype.hide = ICompElement.prototype.hide;
HCompElement.prototype.prepareFrame = ICompElement.prototype.prepareFrame;
HCompElement.prototype.setElements = ICompElement.prototype.setElements;
HCompElement.prototype.getElements = ICompElement.prototype.getElements;
HCompElement.prototype.destroy = ICompElement.prototype.destroy;

HCompElement.prototype.renderFrame = function(parentMatrix){
    var renderParent = this._parent.renderFrame.call(this,parentMatrix);
    var i,len = this.layers.length;
    if(renderParent===false){
        this.hide();
        return;
    }

    this.hidden = false;

    for( i = 0; i < len; i+=1 ){
        if(this.completeLayers || this.elements[i]){
            this.elements[i].renderFrame();
        }
    }
    if(this.firstFrame){
        this.firstFrame = false;
    }
};

HCompElement.prototype.checkLayers = BaseRenderer.prototype.checkLayers;
HCompElement.prototype.buildItem = HybridRenderer.prototype.buildItem;
HCompElement.prototype.checkPendingElements = HybridRenderer.prototype.checkPendingElements;
HCompElement.prototype.addPendingElement = HybridRenderer.prototype.addPendingElement;
HCompElement.prototype.buildAllItems = BaseRenderer.prototype.buildAllItems;
HCompElement.prototype.createItem = HybridRenderer.prototype.createItem;
HCompElement.prototype.buildElementParenting = HybridRenderer.prototype.buildElementParenting;
HCompElement.prototype.createImage = HybridRenderer.prototype.createImage;
HCompElement.prototype.createComp = HybridRenderer.prototype.createComp;
HCompElement.prototype.createSolid = HybridRenderer.prototype.createSolid;
HCompElement.prototype.createShape = HybridRenderer.prototype.createShape;
HCompElement.prototype.createText = HybridRenderer.prototype.createText;
HCompElement.prototype.createBase = HybridRenderer.prototype.createBase;
HCompElement.prototype.appendElementInPos = HybridRenderer.prototype.appendElementInPos;
function HShapeElement(data,parentContainer,globalData,comp, placeholder){
    this.shapes = [];
    this.shapesData = data.shapes;
    this.stylesList = [];
    this.itemsData = [];
    this.prevViewData = [];
    this.shapeModifiers = [];
    this.processedElements = [];
    this._parent.constructor.call(this,data,parentContainer,globalData,comp, placeholder);
    this.currentBBox = {
        x:999999,
        y: -999999,
        h: 0,
        w: 0
    };
}
createElement(HBaseElement, HShapeElement);
var parent = HShapeElement.prototype._parent;
extendPrototype(IShapeElement, HShapeElement);
HShapeElement.prototype._parent = parent;
HShapeElement.prototype._renderShapeFrame = HShapeElement.prototype.renderFrame;

HShapeElement.prototype.createElements = function(){
    var parent = document.createElement('div');
    styleDiv(parent);
    var cont = document.createElementNS(svgNS,'svg');
    styleDiv(cont);
    var size = this.comp.data ? this.comp.data : this.globalData.compSize;
    cont.setAttribute('width',size.w);
    cont.setAttribute('height',size.h);
    if(this.data.hasMask){
        var g = document.createElementNS(svgNS,'g');
        parent.appendChild(cont);
        cont.appendChild(g);
        this.maskedElement = g;
        this.layerElement = g;
        this.shapesContainer = g;
    }else{
        parent.appendChild(cont);
        this.layerElement = cont;
        this.shapesContainer = document.createElementNS(svgNS,'g');
        this.layerElement.appendChild(this.shapesContainer);
    }
    if(!this.data.hd){
        //this.parentContainer.appendChild(parent);
        this.baseElement = parent;
    }
    this.innerElem = parent;
    if(this.data.ln){
        this.innerElem.setAttribute('id',this.data.ln);
    }

    this.searchShapes(this.shapesData,this.itemsData,this.prevViewData,this.layerElement,this.dynamicProperties,0, [], true);
    this.buildExpressionInterface();
    this.layerElement = parent;
    this.transformedElement = parent;
    this.shapeCont = cont;
    if(this.data.bm !== 0){
        this.setBlendMode();
    }
    this.checkParenting();
};

HShapeElement.prototype.renderFrame = function(parentMatrix){
    var firstFrame = this.firstFrame;
    this._renderShapeFrame();

    if(this.isVisible && (this.elemMdf || firstFrame)){
        var boundingBox = this.shapeCont.getBBox();
        var changed = false;
        if(this.currentBBox.w !== boundingBox.width){
            this.currentBBox.w = boundingBox.width;
            this.shapeCont.setAttribute('width',boundingBox.width);
            changed = true;
        }
        if(this.currentBBox.h !== boundingBox.height){
            this.currentBBox.h = boundingBox.height;
            this.shapeCont.setAttribute('height',boundingBox.height);
            changed = true;
        }
        if(changed  || this.currentBBox.x !== boundingBox.x  || this.currentBBox.y !== boundingBox.y){
            this.currentBBox.w = boundingBox.width;
            this.currentBBox.h = boundingBox.height;
            this.currentBBox.x = boundingBox.x;
            this.currentBBox.y = boundingBox.y;

            this.shapeCont.setAttribute('viewBox',this.currentBBox.x+' '+this.currentBBox.y+' '+this.currentBBox.w+' '+this.currentBBox.h);
            this.shapeCont.style.transform = this.shapeCont.style.webkitTransform = 'translate(' + this.currentBBox.x + 'px,' + this.currentBBox.y + 'px)';
        }
    }

};
function HTextElement(data,parentContainer,globalData,comp, placeholder){
    this.textSpans = [];
    this.textPaths = [];
    this.currentBBox = {
        x:999999,
        y: -999999,
        h: 0,
        w: 0
    }
    this.renderType = 'svg';
    this.isMasked = false;
    this._parent.constructor.call(this,data,parentContainer,globalData,comp, placeholder);

}
createElement(HBaseElement, HTextElement);

extendPrototype(ITextElement, HTextElement);

HTextElement.prototype.createElements = function(){
    this.isMasked = this.checkMasks();
    var parent = document.createElement('div');
    styleDiv(parent);
    this.layerElement = parent;
    this.transformedElement = parent;
    if(this.isMasked){
        this.renderType = 'svg';
        var cont = document.createElementNS(svgNS,'svg');
        styleDiv(cont);
        this.cont = cont;
        this.compW = this.comp.data.w;
        this.compH = this.comp.data.h;
        cont.setAttribute('width',this.compW);
        cont.setAttribute('height',this.compH);
        var g = document.createElementNS(svgNS,'g');
        cont.appendChild(g);
        parent.appendChild(cont);
        this.maskedElement = g;
        this.innerElem = g;
    } else {
        this.renderType = 'html';
        this.innerElem = parent;
    }
    this.baseElement = parent;

    this.checkParenting();

};

HTextElement.prototype.buildNewText = function(){
    var documentData = this.textProperty.currentData;
    this.renderedLetters = Array.apply(null,{length:this.textProperty.currentData.l ? this.textProperty.currentData.l.length : 0});
    var innerElemStyle = this.innerElem.style;
    innerElemStyle.color = innerElemStyle.fill = documentData.fc ? this.buildColor(documentData.fc) : 'rgba(0,0,0,0)';
    if(documentData.sc){
        innerElemStyle.stroke = this.buildColor(documentData.sc);
        innerElemStyle.strokeWidth = documentData.sw+'px';
    }
    var fontData = this.globalData.fontManager.getFontByName(documentData.f);
    if(!this.globalData.fontManager.chars){
        innerElemStyle.fontSize = documentData.s+'px';
        innerElemStyle.lineHeight = documentData.s+'px';
        if(fontData.fClass){
            this.innerElem.className = fontData.fClass;
        } else {
            innerElemStyle.fontFamily = fontData.fFamily;
            var fWeight = documentData.fWeight, fStyle = documentData.fStyle;
            innerElemStyle.fontStyle = fStyle;
            innerElemStyle.fontWeight = fWeight;
        }
    }
    var i, len;

    var letters = documentData.l;
    len = letters.length;
    var tSpan,tParent,tCont;
    var matrixHelper = this.mHelper;
    var shapes, shapeStr = '';
    var cnt = 0;
    for (i = 0;i < len ;i += 1) {
        if(this.globalData.fontManager.chars){
            if(!this.textPaths[cnt]){
                tSpan = document.createElementNS(svgNS,'path');
                tSpan.setAttribute('stroke-linecap', 'butt');
                tSpan.setAttribute('stroke-linejoin','round');
                tSpan.setAttribute('stroke-miterlimit','4');
            } else {
                tSpan = this.textPaths[cnt];
            }
            if(!this.isMasked){
                if(this.textSpans[cnt]){
                    tParent = this.textSpans[cnt];
                    tCont = tParent.children[0];
                } else {

                    tParent = document.createElement('div');
                    tCont = document.createElementNS(svgNS,'svg');
                    tCont.appendChild(tSpan);
                    styleDiv(tParent);
                }
            }
        }else{
            if(!this.isMasked){
                if(this.textSpans[cnt]){
                    tParent = this.textSpans[cnt];
                    tSpan = this.textPaths[cnt];
                } else {
                    tParent = document.createElement('span');
                    styleDiv(tParent);
                    tSpan = document.createElement('span');
                    styleDiv(tSpan);
                    tParent.appendChild(tSpan);
                }
            } else {
                tSpan = this.textPaths[cnt] ? this.textPaths[cnt] : document.createElementNS(svgNS,'text');
            }
        }
        //tSpan.setAttribute('visibility', 'hidden');
        if(this.globalData.fontManager.chars){
            var charData = this.globalData.fontManager.getCharData(documentData.t.charAt(i), fontData.fStyle, this.globalData.fontManager.getFontByName(documentData.f).fFamily);
            var shapeData;
            if(charData){
                shapeData = charData.data;
            } else {
                shapeData = null;
            }
            matrixHelper.reset();
            if(shapeData && shapeData.shapes){
                shapes = shapeData.shapes[0].it;
                matrixHelper.scale(documentData.s/100,documentData.s/100);
                shapeStr = this.createPathShape(matrixHelper,shapes);
                tSpan.setAttribute('d',shapeStr);
            }
            if(!this.isMasked){
                this.innerElem.appendChild(tParent);
                if(shapeData && shapeData.shapes){
                    document.body.appendChild(tCont);

                    var boundingBox = tCont.getBBox();
                    tCont.setAttribute('width',boundingBox.width + 2);
                    tCont.setAttribute('height',boundingBox.height + 2);
                    tCont.setAttribute('viewBox',(boundingBox.x-1)+' '+ (boundingBox.y-1)+' '+ (boundingBox.width+2)+' '+ (boundingBox.height+2));
                    tCont.style.transform = tCont.style.webkitTransform = 'translate(' + (boundingBox.x-1) + 'px,' + (boundingBox.y-1) + 'px)';

                    letters[i].yOffset = boundingBox.y-1;
                    tParent.appendChild(tCont);

                } else{
                    tCont.setAttribute('width',1);
                    tCont.setAttribute('height',1);
                }
            }else{
                this.innerElem.appendChild(tSpan);
            }
        }else{
            tSpan.textContent = letters[i].val;
            tSpan.setAttributeNS("http://www.w3.org/XML/1998/namespace", "xml:space","preserve");
            if(!this.isMasked){
                this.innerElem.appendChild(tParent);
                //
                tSpan.style.transform = tSpan.style.webkitTransform = 'translate3d(0,'+ -documentData.s/1.2+'px,0)';
            } else {
                this.innerElem.appendChild(tSpan);
            }
        }
        //
        if(!this.isMasked){
            this.textSpans[cnt] = tParent;
        }else{
            this.textSpans[cnt] = tSpan;
        }
        this.textSpans[cnt].style.display = 'block';
        this.textPaths[cnt] = tSpan;
        cnt += 1;
    }
    while(cnt < this.textSpans.length){
        this.textSpans[cnt].style.display = 'none';
        cnt += 1;
    }
}

HTextElement.prototype.hide = SVGTextElement.prototype.hide;

HTextElement.prototype.renderFrame = function(parentMatrix){

    var renderParent = this._parent.renderFrame.call(this,parentMatrix);
    if(renderParent===false){
        this.hide();
        return;
    }
    if(this.hidden){
        this.hidden = false;
        this.innerElem.style.display = 'block';
        this.layerElement.style.display = 'block';
    }

    if(this.data.singleShape){
        if(!this.firstFrame && !this.lettersChangedFlag){
            return;
        } else {
            // Todo Benchmark if using this is better than getBBox
             if(this.isMasked && this.finalTransform.matMdf){
                 this.cont.setAttribute('viewBox',-this.finalTransform.mProp.p.v[0]+' '+ -this.finalTransform.mProp.p.v[1]+' '+this.compW+' '+this.compH);
                this.cont.style.transform = this.cont.style.webkitTransform = 'translate(' + -this.finalTransform.mProp.p.v[0] + 'px,' + -this.finalTransform.mProp.p.v[1] + 'px)';
             }
        }
    }

    this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag);
    if(!this.lettersChangedFlag && !this.textAnimator.lettersChangedFlag){
        return;
    }
    var  i,len, count = 0;
    var renderedLetters = this.textAnimator.renderedLetters;

    var letters = this.textProperty.currentData.l;

    len = letters.length;
    var renderedLetter, textSpan, textPath;
    for(i=0;i<len;i+=1){
        if(letters[i].n){
            count += 1;
            continue;
        }
        textSpan = this.textSpans[i];
        textPath = this.textPaths[i];
        renderedLetter = renderedLetters[count];
        count += 1;
        if(!this.isMasked){
            textSpan.style.transform = textSpan.style.webkitTransform = renderedLetter.m;
        }else{
            textSpan.setAttribute('transform',renderedLetter.m);
        }
        ////textSpan.setAttribute('opacity',renderedLetter.o);
        textSpan.style.opacity = renderedLetter.o;
        if(renderedLetter.sw){
            textPath.setAttribute('stroke-width',renderedLetter.sw);
        }
        if(renderedLetter.sc){
            textPath.setAttribute('stroke',renderedLetter.sc);
        }
        if(renderedLetter.fc){
            textPath.setAttribute('fill',renderedLetter.fc);
            textPath.style.color = renderedLetter.fc;
        }
    }
    if(this.isVisible && (this.elemMdf || this.firstFrame)){
        if(this.innerElem.getBBox){
            var boundingBox = this.innerElem.getBBox();

            if(this.currentBBox.w !== boundingBox.width){
                this.currentBBox.w = boundingBox.width;
                this.cont.setAttribute('width',boundingBox.width);
            }
            if(this.currentBBox.h !== boundingBox.height){
                this.currentBBox.h = boundingBox.height;
                this.cont.setAttribute('height',boundingBox.height);
            }

            var margin = 1;
            if(this.currentBBox.w !== (boundingBox.width + margin*2) || this.currentBBox.h !== (boundingBox.height + margin*2)  || this.currentBBox.x !== (boundingBox.x - margin)  || this.currentBBox.y !== (boundingBox.y - margin)){
                this.currentBBox.w = boundingBox.width + margin*2;
                this.currentBBox.h = boundingBox.height + margin*2;
                this.currentBBox.x = boundingBox.x - margin;
                this.currentBBox.y = boundingBox.y - margin;

                this.cont.setAttribute('viewBox',this.currentBBox.x+' '+this.currentBBox.y+' '+this.currentBBox.w+' '+this.currentBBox.h);
                this.cont.style.transform = this.cont.style.webkitTransform = 'translate(' + this.currentBBox.x + 'px,' + this.currentBBox.y + 'px)';
            }
        }
    }
    if(this.firstFrame){
        this.firstFrame = false;
    }
}
function HImageElement(data,parentContainer,globalData,comp, placeholder){
    this.assetData = globalData.getAssetData(data.refId);
    this._parent.constructor.call(this,data,parentContainer,globalData,comp, placeholder);
}
createElement(HBaseElement, HImageElement);

HImageElement.prototype.createElements = function(){

    var assetPath = this.globalData.getAssetsPath(this.assetData);
    var img = new Image();

    if(this.data.hasMask){
        var parent = document.createElement('div');
        styleDiv(parent);
        var cont = document.createElementNS(svgNS,'svg');
        styleDiv(cont);
        cont.setAttribute('width',this.assetData.w);
        cont.setAttribute('height',this.assetData.h);
        parent.appendChild(cont);
        this.imageElem = document.createElementNS(svgNS,'image');
        this.imageElem.setAttribute('width',this.assetData.w+"px");
        this.imageElem.setAttribute('height',this.assetData.h+"px");
        this.imageElem.setAttributeNS('http://www.w3.org/1999/xlink','href',assetPath);
        cont.appendChild(this.imageElem);
        this.layerElement = parent;
        this.transformedElement = parent;
        this.baseElement = parent;
        this.innerElem = parent;
        this.maskedElement = this.imageElem;
    } else {
        styleDiv(img);
        this.layerElement = img;
        this.baseElement = img;
        this.innerElem = img;
        this.transformedElement = img;
    }
    img.src = assetPath;
    if(this.data.ln){
        this.innerElem.setAttribute('id',this.data.ln);
    }
    this.checkParenting();
};

HImageElement.prototype.show = HSolidElement.prototype.show;
HImageElement.prototype.hide = HSolidElement.prototype.hide;
HImageElement.prototype.renderFrame = HSolidElement.prototype.renderFrame;
HImageElement.prototype.destroy = HSolidElement.prototype.destroy;
function HCameraElement(data,parentContainer,globalData,comp, placeholder){
    this._parent.constructor.call(this,data,parentContainer,globalData,comp, placeholder);
    var getProp = PropertyFactory.getProp;
    this.pe = getProp(this,data.pe,0,0,this.dynamicProperties);
    if(data.ks.p.s){
        this.px = getProp(this,data.ks.p.x,1,0,this.dynamicProperties);
        this.py = getProp(this,data.ks.p.y,1,0,this.dynamicProperties);
        this.pz = getProp(this,data.ks.p.z,1,0,this.dynamicProperties);
    }else{
        this.p = getProp(this,data.ks.p,1,0,this.dynamicProperties);
    }
    if(data.ks.a){
        this.a = getProp(this,data.ks.a,1,0,this.dynamicProperties);
    }
    if(data.ks.or.k.length && data.ks.or.k[0].to){
        var i,len = data.ks.or.k.length;
        for(i=0;i<len;i+=1){
            data.ks.or.k[i].to = null;
            data.ks.or.k[i].ti = null;
        }
    }
    this.or = getProp(this,data.ks.or,1,degToRads,this.dynamicProperties);
    this.or.sh = true;
    this.rx = getProp(this,data.ks.rx,0,degToRads,this.dynamicProperties);
    this.ry = getProp(this,data.ks.ry,0,degToRads,this.dynamicProperties);
    this.rz = getProp(this,data.ks.rz,0,degToRads,this.dynamicProperties);
    this.mat = new Matrix();
}
createElement(HBaseElement, HCameraElement);

HCameraElement.prototype.setup = function() {
    var i, len = this.comp.threeDElements.length, comp;
    for(i=0;i<len;i+=1){
        //[perspectiveElem,container]
        comp = this.comp.threeDElements[i];
        comp.perspectiveElem.style.perspective = comp.perspectiveElem.style.webkitPerspective = this.pe.v+'px';
        comp.container.style.transformOrigin = comp.container.style.mozTransformOrigin = comp.container.style.webkitTransformOrigin = "0px 0px 0px";
        comp.perspectiveElem.style.transform = comp.perspectiveElem.style.webkitTransform = 'matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)';
    }
};

HCameraElement.prototype.createElements = function(){
};

HCameraElement.prototype.hide = function(){
};

HCameraElement.prototype.renderFrame = function(){
    var mdf = this.firstFrame;
    var i, len;
    if(this.hierarchy){
        len = this.hierarchy.length;
        for(i=0;i<len;i+=1){
            mdf = this.hierarchy[i].finalTransform.mProp.mdf ? true : mdf;
        }
    }
    if(mdf || (this.p && this.p.mdf) || (this.px && (this.px.mdf || this.py.mdf || this.pz.mdf)) || this.rx.mdf || this.ry.mdf || this.rz.mdf || this.or.mdf || (this.a && this.a.mdf)) {
        this.mat.reset();

        if(this.p){
            this.mat.translate(-this.p.v[0],-this.p.v[1],this.p.v[2]);
        }else{
            this.mat.translate(-this.px.v,-this.py.v,this.pz.v);
        }
        if(this.a){
            var diffVector = [this.p.v[0]-this.a.v[0],this.p.v[1]-this.a.v[1],this.p.v[2]-this.a.v[2]];
            var mag = Math.sqrt(Math.pow(diffVector[0],2)+Math.pow(diffVector[1],2)+Math.pow(diffVector[2],2));
            //var lookDir = getNormalizedPoint(getDiffVector(this.a.v,this.p.v));
            var lookDir = [diffVector[0]/mag,diffVector[1]/mag,diffVector[2]/mag];
            var lookLengthOnXZ = Math.sqrt( lookDir[2]*lookDir[2] + lookDir[0]*lookDir[0] );
            var m_rotationX = (Math.atan2( lookDir[1], lookLengthOnXZ ));
            var m_rotationY = (Math.atan2( lookDir[0], -lookDir[2]));
            this.mat.rotateY(m_rotationY).rotateX(-m_rotationX);

        }
        this.mat.rotateX(-this.rx.v).rotateY(-this.ry.v).rotateZ(this.rz.v);
        this.mat.rotateX(-this.or.v[0]).rotateY(-this.or.v[1]).rotateZ(this.or.v[2]);
        this.mat.translate(this.globalData.compSize.w/2,this.globalData.compSize.h/2,0);
        this.mat.translate(0,0,this.pe.v);
        if(this.hierarchy){
            var mat;
            len = this.hierarchy.length;
            for(i=0;i<len;i+=1){
                mat = this.hierarchy[i].finalTransform.mProp.iv.props;
                this.mat.transform(mat[0],mat[1],mat[2],mat[3],mat[4],mat[5],mat[6],mat[7],mat[8],mat[9],mat[10],mat[11],-mat[12],-mat[13],mat[14],mat[15]);
            }
        }
        len = this.comp.threeDElements.length;
        var comp;
        for(i=0;i<len;i+=1){
            comp = this.comp.threeDElements[i];
            comp.container.style.transform = comp.container.style.webkitTransform = this.mat.toCSS();
        }
    }
    this.firstFrame = false;
};

HCameraElement.prototype.destroy = function(){
};
var Expressions = (function(){
    var ob = {};
    ob.initExpressions = initExpressions;


    function initExpressions(animation){
        animation.renderer.compInterface = CompExpressionInterface(animation.renderer);
        animation.renderer.globalData.projectInterface.registerComposition(animation.renderer);
    }
   return ob;
}());

expressionsPlugin = Expressions;

(function addPropertyDecorator() {

    function getStaticValueAtTime() {
        return this.pv;
    }

    function loopOut(type,duration,durationFlag){
        if(!this.k || !this.keyframes){
            return this.pv;
        }
        var currentFrame = this.comp.renderedFrame;
        var keyframes = this.keyframes;
        var lastKeyFrame = keyframes[keyframes.length - 1].t;
        if(currentFrame<=lastKeyFrame){
            return this.pv;
        }else{
            var cycleDuration, firstKeyFrame;
            if(!durationFlag){
                if(!duration || duration > keyframes.length - 1){
                    duration = keyframes.length - 1;
                }
                firstKeyFrame = keyframes[keyframes.length - 1 - duration].t;
                cycleDuration = lastKeyFrame - firstKeyFrame;
            } else {
                if(!duration){
                    cycleDuration = Math.max(0,lastKeyFrame - this.elem.data.ip);
                } else {
                    cycleDuration = Math.abs(lastKeyFrame - elem.comp.globalData.frameRate*duration);
                }
                firstKeyFrame = lastKeyFrame - cycleDuration;
            }
            var offsetTime = this.offsetTime || 0;
            var i, len, ret;
            if(type.toLowerCase() === 'pingpong') {
                var iterations = Math.floor((currentFrame - firstKeyFrame)/cycleDuration);
                if(iterations % 2 !== 0){
                    return this.getValueAtTime(((cycleDuration - (currentFrame - firstKeyFrame) % cycleDuration +  firstKeyFrame) - offsetTime) / this.comp.globalData.frameRate, 0);
                }
            } else if(type === 'offset'){
                var initV = this.getValueAtTime(firstKeyFrame / this.comp.globalData.frameRate, 0);
                var endV = this.getValueAtTime(lastKeyFrame / this.comp.globalData.frameRate, 0);
                var current = this.getValueAtTime(((currentFrame - firstKeyFrame) % cycleDuration +  firstKeyFrame) / this.comp.globalData.frameRate, 0);
                var repeats = Math.floor((currentFrame - firstKeyFrame)/cycleDuration);
                if(this.pv.length){
                    ret = new Array(initV.length);
                    len = ret.length;
                    for(i=0;i<len;i+=1){
                        ret[i] = (endV[i]-initV[i])*repeats + current[i];
                    }
                    return ret;
                }
                return (endV-initV)*repeats + current;
            } else if(type === 'continue'){
                var lastValue = this.getValueAtTime(lastKeyFrame / this.comp.globalData.frameRate, 0);
                var nextLastValue = this.getValueAtTime((lastKeyFrame - 0.001) / this.comp.globalData.frameRate, 0);
                if(this.pv.length){
                    ret = new Array(lastValue.length);
                    len = ret.length;
                    for(i=0;i<len;i+=1){
                        ret[i] = lastValue[i] + (lastValue[i]-nextLastValue[i])*((currentFrame - lastKeyFrame)/ this.comp.globalData.frameRate)/0.0005;
                    }
                    return ret;
                }
                return lastValue + (lastValue-nextLastValue)*(((currentFrame - lastKeyFrame))/0.001);
            }
            return this.getValueAtTime((((currentFrame - firstKeyFrame) % cycleDuration +  firstKeyFrame) - offsetTime) / this.comp.globalData.frameRate, 0);
        }
    }

    function loopIn(type,duration, durationFlag) {
        if(!this.k){
            return this.pv;
        }
        var currentFrame = time*elem.comp.globalData.frameRate;
        var keyframes = this.keyframes;
        var firstKeyFrame = keyframes[0].t;
        var offsetTime = this.offsetTime || 0;
        if(currentFrame>=firstKeyFrame){
            return this.pv;
        }else{
            var cycleDuration, lastKeyFrame;
            if(!durationFlag){
                if(!duration || duration > keyframes.length - 1){
                    duration = keyframes.length - 1;
                }
                lastKeyFrame = keyframes[duration].t;
                cycleDuration = lastKeyFrame - firstKeyFrame;
            } else {
                if(!duration){
                    cycleDuration = Math.max(0,this.elem.data.op - firstKeyFrame);
                } else {
                    cycleDuration = Math.abs(elem.comp.globalData.frameRate*duration);
                }
                lastKeyFrame = firstKeyFrame + cycleDuration;
            }
            var i, len, ret;
            if(type === 'pingpong') {
                var iterations = Math.floor((firstKeyFrame - currentFrame)/cycleDuration);
                if(iterations % 2 === 0){
                    return this.getValueAtTime((((firstKeyFrame - currentFrame)%cycleDuration +  firstKeyFrame) - offsetTime) / this.comp.globalData.frameRate, 0);
                }
            } else if(type === 'offset'){
                var initV = this.getValueAtTime(firstKeyFrame / this.comp.globalData.frameRate, 0);
                var endV = this.getValueAtTime(lastKeyFrame / this.comp.globalData.frameRate, 0);
                var current = this.getValueAtTime((cycleDuration - (firstKeyFrame - currentFrame)%cycleDuration +  firstKeyFrame) / this.comp.globalData.frameRate, 0);
                var repeats = Math.floor((firstKeyFrame - currentFrame)/cycleDuration)+1;
                if(this.pv.length){
                    ret = new Array(initV.length);
                    len = ret.length;
                    for(i=0;i<len;i+=1){
                        ret[i] = current[i]-(endV[i]-initV[i])*repeats;
                    }
                    return ret;
                }
                return current-(endV-initV)*repeats;
            } else if(type === 'continue'){
                var firstValue = this.getValueAtTime(firstKeyFrame / this.comp.globalData.frameRate, 0);
                var nextFirstValue = this.getValueAtTime((firstKeyFrame + 0.001) / this.comp.globalData.frameRate, 0);
                if(this.pv.length){
                    ret = new Array(firstValue.length);
                    len = ret.length;
                    for(i=0;i<len;i+=1){
                        ret[i] = firstValue[i] + (firstValue[i]-nextFirstValue[i])*(firstKeyFrame - currentFrame)/0.001;
                    }
                    return ret;
                }
                return firstValue + (firstValue-nextFirstValue)*(firstKeyFrame - currentFrame)/0.001;
            }

            return this.getValueAtTime(((cycleDuration - (firstKeyFrame - currentFrame) % cycleDuration +  firstKeyFrame) - offsetTime) / this.comp.globalData.frameRate, 0);
        }
    }

    function getValueAtTime(frameNum) {
        if(!this._cachingAtTime) {
            this._cachingAtTime = {lastValue:-99999,lastIndex:0};
        }
        //console.log('this._cachingAtTime', JSON.parse(JSON.stringify(this._cachingAtTime)))
        if(frameNum !== this._cachingAtTime.lastFrame) {
            frameNum *= this.elem.globalData.frameRate;
            frameNum -= this.offsetTime;
            var i = this._caching.lastFrame < frameNum ? this._caching.lastIndex : 0;
            var interpolationResult = this.interpolateValue(frameNum, i, this.pv, this._cachingAtTime);
            this._cachingAtTime.lastIndex = interpolationResult.iterationIndex;
            this._cachingAtTime.value = interpolationResult.value;
            this._cachingAtTime.lastFrame = frameNum;
        }
        return this._cachingAtTime.value;

    }

    function getVelocityAtTime(frameNum) {
        if(this.vel !== undefined){
            return this.vel;
        }
        var delta = -0.01;
        //frameNum += this.elem.data.st;
        var v1 = this.getValueAtTime(frameNum);
        var v2 = this.getValueAtTime(frameNum + delta);
        var velocity;
        if(v1.length){
            velocity = Array.apply(null,{length:v1.length});
            var i;
            for(i=0;i<v1.length;i+=1){
                //removing frameRate
                //if needed, don't add it here
                //velocity[i] = this.elem.globalData.frameRate*((v2[i] - v1[i])/delta);
                velocity[i] = (v2[i] - v1[i])/delta;
            }
        } else {
            velocity = (v2 - v1)/delta;
        }
        return velocity;
    };

    function setGroupProperty(propertyGroup){
        this.propertyGroup = propertyGroup;
    }

    function searchExpressions(elem,data,prop){
        if(data.x){
            prop.k = true;
            prop.x = true;
            if(prop.getValue) {
                prop.getPreValue = prop.getValue;
            }
            prop.getValue = ExpressionManager.initiateExpression.bind(prop)(elem,data,prop);
        }
    }

    function getTransformValueAtTime(time) {
        console.log('time:', time)
    }

    function getTransformStaticValueAtTime(time) {

    }

    var TextExpressionSelectorProp = (function(){

        function getValueProxy(index,total){
            this.textIndex = index+1;
            this.textTotal = total;
            this.getValue();
            return this.v;
        }

        return function TextExpressionSelectorProp(elem,data){
            this.pv = 1;
            this.comp = elem.comp;
            this.elem = elem;
            this.mult = .01;
            this.type = 'textSelector';
            this.textTotal = data.totalChars;
            this.selectorValue = 100;
            this.lastValue = [1,1,1];
            searchExpressions.bind(this)(elem,data,this);
            this.getMult = getValueProxy;
            this.getVelocityAtTime = getVelocityAtTime;
            if(this.kf){
                this.getValueAtTime = getValueAtTime.bind(this);
            } else {
                this.getValueAtTime = getStaticValueAtTime.bind(this);
            }
            this.setGroupProperty = setGroupProperty;
        }
    }());


    var propertyGetProp = PropertyFactory.getProp;
    PropertyFactory.getProp = function(elem,data,type, mult, arr){
        var prop = propertyGetProp(elem,data,type, mult, arr);
        //prop.getVelocityAtTime = getVelocityAtTime;
        //prop.loopOut = loopOut;
        //prop.loopIn = loopIn;
        if(type === 2) {
            if(prop.dynamicProperties.length) {
                prop.getValueAtTime = getTransformValueAtTime.bind(prop);
            } else {
                prop.getValueAtTime = getTransformStaticValueAtTime.bind(prop);
            }
        } else {
            if(prop.kf){
                prop.getValueAtTime = getValueAtTime.bind(prop);
            } else {
                prop.getValueAtTime = getStaticValueAtTime.bind(prop);
            }
        }
        prop.setGroupProperty = setGroupProperty;
        prop.loopOut = loopOut;
        prop.loopIn = loopIn;
        prop.getVelocityAtTime = getVelocityAtTime;
        prop.numKeys = data.a === 1 ? data.k.length : 0;
        var isAdded = prop.k;
        if(data.ix !== undefined){
            Object.defineProperty(prop,'propertyIndex',{
                get: function(){
                    return data.ix;
                }
            })
        }
        searchExpressions(elem,data,prop);
        if(!isAdded && prop.x){
            arr.push(prop);
        }

        return prop;
    }

    function getShapeValueAtTime(frameNum) {
        if (!this._shapeValueAtTime) {
            this._lastIndexAtTime = 0;
            this._lastTimeAtTime = -999999;
            this._shapeValueAtTime = shape_pool.clone(this.pv);
        }
        if(frameNum !== this._lastTimeAtTime) {
            this._lastTimeAtTime = frameNum;
            frameNum *= this.elem.globalData.frameRate;
            var interpolationResult = this.interpolateShape(frameNum, this._lastIndexAtTime, this._shapeValueAtTime, false);
            this._lastIndexAtTime = interpolationResult.iterationIndex;
        }
        return this._shapeValueAtTime;
    }

    var ShapePropertyConstructorFunction = ShapePropertyFactory.getConstructorFunction();
    var KeyframedShapePropertyConstructorFunction = ShapePropertyFactory.getKeyframedConstructorFunction();

    ShapePropertyConstructorFunction.prototype.vertices = function(prop, time){
        var shapePath = this.v;
        if(time !== undefined) {
            shapePath = this.getValueAtTime(time, 0);
        }
        var i, len = shapePath._length;
        var vertices = shapePath[prop];
        var points = shapePath.v;
        var arr = Array.apply(null,{length:len})
        for(i = 0; i < len; i += 1) {
            if(prop === 'i' || prop === 'o') {
                arr[i] = [vertices[i][0] - points[i][0], vertices[i][1] - points[i][1]]
            } else {
                arr[i] = [vertices[i][0], vertices[i][1]]
            }
            
        }
        return arr;
    }

    ShapePropertyConstructorFunction.prototype.points = function(time){
        return this.vertices('v', time);
    }

    ShapePropertyConstructorFunction.prototype.inTangents = function(time){
        return this.vertices('i', time);
    }

    ShapePropertyConstructorFunction.prototype.outTangents = function(time){
        return this.vertices('o', time);
    }

    ShapePropertyConstructorFunction.prototype.isClosed = function(){
        return this.v.c;
    }

    ShapePropertyConstructorFunction.prototype.pointOnPath = function(perc, time){
        var shapePath = this.v;
        if(time !== undefined) {
            shapePath = this.getValueAtTime(time, 0);
        }
        if(!this._segmentsLength) {
            this._segmentsLength = bez.getSegmentsLength(shapePath);
        }

        var segmentsLength = this._segmentsLength;
        var lengths = segmentsLength.lengths;
        var lengthPos = segmentsLength.totalLength * perc;
        var i = 0, len = lengths.length;
        var j = 0, jLen;
        var accumulatedLength = 0;
        var segments;
        while(i < len) {
            if(accumulatedLength + lengths[i].addedLength > lengthPos) {
                segments = lengths[i].segments;
                var initIndex = i;
                var endIndex = (shapePath.c && i === len - 1) ? 0 : i + 1;
                var segmentPerc = (lengthPos - accumulatedLength)/lengths[i].addedLength;
                var pt = bez.getPointInSegment(shapePath.v[initIndex], shapePath.v[endIndex], shapePath.o[initIndex], shapePath.i[endIndex], segmentPerc, lengths[i])
                break;
            } else {
                accumulatedLength += lengths[i].addedLength;
            }
            i += 1;
        }
        if(!pt){
            pt = shapePath.c ? [shapePath.v[0][0],shapePath.v[0][1]]:[shapePath.v[shapePath._length-1][0],shapePath.v[shapePath._length-1][1]]
        }
        return pt;
    }

    ShapePropertyConstructorFunction.prototype.vectorOnPath = function(perc, time, vectorType){
        //perc doesn't use triple equality because can be a Number object, not a primitive.
        perc = perc == 1 ? this.v.c ? 0 : 0.999 : perc;
        var pt1 = this.pointOnPath(perc, time);
        var pt2 = this.pointOnPath(perc + 0.001, time);
        var xLength = pt2[0] - pt1[0];
        var yLength = pt2[1] - pt1[1];
        var magnitude = Math.sqrt(Math.pow(xLength,2) + Math.pow(yLength,2));
        var unitVector = vectorType === 'tangent' ? [xLength/magnitude, yLength/magnitude] : [-yLength/magnitude, xLength/magnitude];
        return unitVector;
    }

    ShapePropertyConstructorFunction.prototype.tangentOnPath = function(perc, time){
        return this.vectorOnPath(perc, time, 'tangent');
    }

    ShapePropertyConstructorFunction.prototype.normalOnPath = function(perc, time){
        return this.vectorOnPath(perc, time, 'normal');
    }

    ShapePropertyConstructorFunction.prototype.setGroupProperty = setGroupProperty;
    ShapePropertyConstructorFunction.prototype.getValueAtTime = getStaticValueAtTime;

    KeyframedShapePropertyConstructorFunction.prototype.vertices = ShapePropertyConstructorFunction.prototype.vertices;
    KeyframedShapePropertyConstructorFunction.prototype.points = ShapePropertyConstructorFunction.prototype.points;
    KeyframedShapePropertyConstructorFunction.prototype.inTangents = ShapePropertyConstructorFunction.prototype.inTangents;
    KeyframedShapePropertyConstructorFunction.prototype.outTangents = ShapePropertyConstructorFunction.prototype.outTangents;
    KeyframedShapePropertyConstructorFunction.prototype.isClosed = ShapePropertyConstructorFunction.prototype.isClosed;
    KeyframedShapePropertyConstructorFunction.prototype.pointOnPath = ShapePropertyConstructorFunction.prototype.pointOnPath;
    KeyframedShapePropertyConstructorFunction.prototype.vectorOnPath = ShapePropertyConstructorFunction.prototype.vectorOnPath;
    KeyframedShapePropertyConstructorFunction.prototype.tangentOnPath = ShapePropertyConstructorFunction.prototype.tangentOnPath;
    KeyframedShapePropertyConstructorFunction.prototype.normalOnPath = ShapePropertyConstructorFunction.prototype.normalOnPath;
    KeyframedShapePropertyConstructorFunction.prototype.setGroupProperty = ShapePropertyConstructorFunction.prototype.setGroupProperty;
    KeyframedShapePropertyConstructorFunction.prototype.getValueAtTime = getShapeValueAtTime;

    var propertyGetShapeProp = ShapePropertyFactory.getShapeProp;
    ShapePropertyFactory.getShapeProp = function(elem,data,type, arr, trims){
        var prop = propertyGetShapeProp(elem,data,type, arr, trims);
        var isAdded = prop.k;
        if(data.ix !== undefined){
            Object.defineProperty(prop,'propertyIndex',{
                get: function(){
                    return data.ix;
                }
            })
        }
        if(type === 3){
            searchExpressions(elem,data.pt,prop);
        } else if(type === 4){
            searchExpressions(elem,data.ks,prop);
        }
        if(!isAdded && prop.x){
            arr.push(prop);
        }
        return prop;
    }

    var propertyGetTextProp = PropertyFactory.getTextSelectorProp;
    PropertyFactory.getTextSelectorProp = function(elem, data,arr){
        if(data.t === 1){
            return new TextExpressionSelectorProp(elem, data,arr);
        } else {
            return propertyGetTextProp(elem,data,arr);
        }
    }
}());
(function addTextPropertyDecorator() {

    function searchExpressions(){
        if(this.data.d.x){
            this.comp = this.elem.comp;
            if(this.getValue) {
                this.getPreValue = this.getValue;
            }
            this.calculateExpression = ExpressionManager.initiateExpression.bind(this)(this.elem,this.data.d,this);
            this.getValue = this.getExpressionValue;
            return true;
        }
        return false;
    }

    TextProperty.prototype.searchProperty = function(){
        this.kf = this.searchExpressions() || this.data.d.k.length > 1;
        return this.kf;
    }

    TextProperty.prototype.getExpressionValue = function(num){
        this.calculateExpression();
        if(this.mdf) {
            this.currentData.t = this.v.toString();
            this.completeTextData(this.currentData);
        }
    }

    TextProperty.prototype.searchExpressions = searchExpressions;
    
}());
var ExpressionManager = (function(){
    var ob = {};
    var Math = BMMath;
    var window = null;
    var document = null;

    function duplicatePropertyValue(value, mult){
        mult = mult || 1;

        if(typeof value === 'number'  || value instanceof Number){
            return value*mult;
        }else if(value.i){
            return JSON.parse(JSON.stringify(value));
        }else{
            var arr = Array.apply(null,{length:value.length});
            var i, len = value.length;
            for(i=0;i<len;i+=1){
                arr[i]=value[i]*mult;
            }
            return arr;
        }
    }

    function shapesEqual(shape1, shape2) {
        if(shape1._length !== shape2._length || shape1.c !== shape2.c){
            return false;
        }
        var i, len = shape1._length;
        for(i = 0; i < len; i += 1) {
            if(shape1.v[i][0] !== shape2.v[i][0] || shape1.v[i][1] !== shape2.v[i][1]
                || shape1.o[i][0] !== shape2.o[i][0] || shape1.o[i][1] !== shape2.o[i][1]
                || shape1.i[i][0] !== shape2.i[i][0] || shape1.i[i][1] !== shape2.i[i][1]){
                return false;
            }
        }
        return true;
    }

    function $bm_neg(a){
        var tOfA = typeof a;
        if(tOfA === 'number' || tOfA === 'boolean'  || a instanceof Number ){
            return -a;
        }
        if(a.constructor === Array){
            var i, lenA = a.length;
            var retArr = [];
            for(i=0;i<lenA;i+=1){
                retArr[i] = -a[i];
            }
            return retArr;
        }
    }

    function sum(a,b) {
        var tOfA = typeof a;
        var tOfB = typeof b;
        if(tOfA === 'string' || tOfB === 'string'){
            return a + b;
        }
        if((tOfA === 'number' || tOfA === 'boolean' || tOfA === 'string' || a instanceof Number) && (tOfB === 'number' || tOfB === 'boolean' || tOfB === 'string'  || b instanceof Number)) {
            return a + b;
        }
        if(a.constructor === Array && (tOfB === 'number' || tOfB === 'boolean' || tOfB === 'string' || b instanceof Number )){
            a[0] = a[0] + b;
            return a;
        }
        if((tOfA === 'number' || tOfA === 'boolean' || tOfA === 'string' || a instanceof Number ) && b.constructor === Array){
            b[0] = a + b[0];
            return b;
        }
        if(a.constructor === Array && b.constructor === Array){
            
            var i = 0, lenA = a.length, lenB = b.length;
            var retArr = [];
            while(i<lenA || i < lenB){
                if((typeof a[i] === 'number' || a[i] instanceof Number) && (typeof b[i] === 'number' || b[i] instanceof Number)){
                    retArr[i] = a[i] + b[i];
                }else{
                    retArr[i] = b[i] == undefined ? a[i] : a[i] || b[i];
                }
                i += 1;
            }
            return retArr;
        }
        return 0;
    }
    var add = sum;

    function sub(a,b) {
        var tOfA = typeof a;
        var tOfB = typeof b;
        if((tOfA === 'number' || tOfA === 'boolean' || tOfA === 'string' || a instanceof Number ) && (tOfB === 'number' || tOfB === 'boolean' || tOfB === 'string' || b instanceof Number )) {
            if(tOfA === 'string') {
                a = parseInt(a);
            }
            if(tOfB === 'string') {
                b = parseInt(b);
            }
            return a - b;
        }
        if( a.constructor === Array && (tOfB === 'number' || tOfB === 'boolean' || tOfB === 'string' || b instanceof Number )){
            a[0] = a[0] - b;
            return a;
        }
        if((tOfA === 'number' || tOfA === 'boolean' || tOfA === 'string' || a instanceof Number ) &&  b.constructor === Array){
            b[0] = a - b[0];
            return b;
        }
        if(a.constructor === Array && b.constructor === Array){
            var i = 0, lenA = a.length, lenB = b.length;
            var retArr = [];
            while(i<lenA || i < lenB){
                if((typeof a[i] === 'number' || a[i] instanceof Number) && typeof (typeof b[i] === 'number' || b[i] instanceof Number)){
                    retArr[i] = a[i] - b[i];
                }else{
                    retArr[i] = b[i] == undefined ? a[i] : a[i] || b[i];
                }
                i += 1;
            }
            return retArr;
        }
        return 0;
    }

    function mul(a,b) {
        var tOfA = typeof a;
        var tOfB = typeof b;
        var arr;
        if((tOfA === 'number' || tOfA === 'boolean' || tOfA === 'string' || a instanceof Number ) && (tOfB === 'number' || tOfB === 'boolean' || tOfB === 'string' || b instanceof Number )) {
            return a * b;
        }

        var i, len;
        if(a.constructor === Array && (tOfB === 'number' || tOfB === 'boolean' || tOfB === 'string' || b instanceof Number )){
            len = a.length;
            arr = Array.apply(null,{length:len});
            for(i=0;i<len;i+=1){
                arr[i] = a[i] * b;
            }
            return arr;
        }
        if((tOfA === 'number' || tOfA === 'boolean' || tOfA === 'string' || a instanceof Number ) && b.constructor === Array){
            len = b.length;
            arr = Array.apply(null,{length:len});
            for(i=0;i<len;i+=1){
                arr[i] = a * b[i];
            }
            return arr;
        }
        return 0;
    }

    function div(a,b) {
        var tOfA = typeof a;
        var tOfB = typeof b;
        var arr;
        if((tOfA === 'number' || tOfA === 'boolean' || tOfA === 'string' || a instanceof Number ) && (tOfB === 'number' || tOfB === 'boolean' || tOfB === 'string' || b instanceof Number )) {
            return a / b;
        }
        var i, len;
        if(a.constructor === Array && (tOfB === 'number' || tOfB === 'boolean' || tOfB === 'string' || b instanceof Number  )){
            len = a.length;
            arr = Array.apply(null,{length:len});
            for(i=0;i<len;i+=1){
                arr[i] = a[i] / b;
            }
            return arr;
        }
        if((tOfA === 'number' || tOfA === 'boolean' || tOfA === 'string' || a instanceof Number ) && b.constructor === Array){
            len = b.length;
            arr = Array.apply(null,{length:len});
            for(i=0;i<len;i+=1){
                arr[i] = a / b[i];
            }
            return arr;
        }
        return 0;
    }
    function mod(a,b) {
        if(typeof a === 'string') {
            a = parseInt(a);
        }
        if(typeof b === 'string') {
            b = parseInt(b);
        }
        return a % b;
    }

    function clamp(num, min, max) {
        if(min > max){
            var mm = max;
            max = min;
            min = mm;
        }
        return Math.min(Math.max(num, min), max);
    }

    function radiansToDegrees(val) {
        return val/degToRads;
    }
    var radians_to_degrees = radiansToDegrees;

    function degreesToRadians(val) {
        return val*degToRads;
    }
    var degrees_to_radians = radiansToDegrees;

    var helperLengthArray = [0,0,0,0,0,0];

    function length(arr1,arr2){
        if(typeof arr1 === 'number' || arr1 instanceof Number){
            arr2 = arr2 || 0;
            return Math.abs(arr1 - arr2);
        }
        if(!arr2){
            arr2 = helperLengthArray;
        }
        var i,len = Math.min(arr1.length,arr2.length);
        var addedLength = 0;
        for(i=0;i<len;i+=1){
            addedLength += Math.pow(arr2[i]-arr1[i],2);
        }
        return Math.sqrt(addedLength);
    }

    function normalize(vec){
        return div(vec, length(vec));
    }

    function rgbToHsl(val){
        var r = val[0]; var g = val[1]; var b = val[2];
        var max = Math.max(r, g, b), min = Math.min(r, g, b);
        var h, s, l = (max + min) / 2;

        if(max == min){
            h = s = 0; // achromatic
        }else{
            var d = max - min;
            s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
            switch(max){
                case r: h = (g - b) / d + (g < b ? 6 : 0); break;
                case g: h = (b - r) / d + 2; break;
                case b: h = (r - g) / d + 4; break;
            }
            h /= 6;
        }

        return [h, s, l,val[3]];
    }
    function hslToRgb(val){
        var h = val[0];
        var s = val[1];
        var l = val[2];

        var r, g, b;

        if(s == 0){
            r = g = b = l; // achromatic
        }else{
            function hue2rgb(p, q, t){
                if(t < 0) t += 1;
                if(t > 1) t -= 1;
                if(t < 1/6) return p + (q - p) * 6 * t;
                if(t < 1/2) return q;
                if(t < 2/3) return p + (q - p) * (2/3 - t) * 6;
                return p;
            }

            var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
            var p = 2 * l - q;
            r = hue2rgb(p, q, h + 1/3);
            g = hue2rgb(p, q, h);
            b = hue2rgb(p, q, h - 1/3);
        }

        return [r, g , b, val[3]];
    }

    function linear(t, tMin, tMax, value1, value2){
        if(value1 === undefined || value2 === undefined){
            return linear(t,0,1,tMin,tMax);
        }
        if(t <= tMin) {
            return value1;
        }else if(t >= tMax){
            return value2;
        }
        var perc = tMax === tMin ? 0 : (t-tMin)/(tMax-tMin);
        if(!value1.length){
            return value1 + (value2-value1)*perc;
        }
        var i, len = value1.length;
        var arr = Array.apply( null, { length: len } );
        for(i=0;i<len;i+=1){
            arr[i] = value1[i] + (value2[i]-value1[i])*perc;
        }
        return arr;
    }
    function random(min,max){
        if(max === undefined){
            if(min === undefined){
                min = 0;
                max = 1;
            } else {
                max = min;
                min = undefined;
            }
        }
        if(max.length){
            var i, len = max.length;
            if(!min){
                min = Array.apply(null,{length:len});
            }
            var arr = Array.apply(null,{length:len});
            var rnd = BMMath.random();
            for(i=0;i<len;i+=1){
                arr[i] = min[i] + rnd*(max[i]-min[i])
            }
            return arr;
        }
        if(min === undefined){
            min = 0;
        }
        var rndm = BMMath.random();
        return min + rndm*(max-min);
    }

    function createPath(points, inTangents, outTangents, closed) {
        inTangents = inTangents && inTangents.length ? inTangents : points;
        outTangents = outTangents && outTangents.length ? outTangents : points;
        var path = shape_pool.newShape();
        var len = points.length;
        path.setPathData(closed, len);
        for(i = 0; i < len; i += 1) {
            path.setTripleAt(points[i][0],points[i][1],outTangents[i][0] + points[i][0],outTangents[i][1] + points[i][1],inTangents[i][0] + points[i][0],inTangents[i][1] + points[i][1],i,true)
        }
        return path
    }

    function initiateExpression(elem,data,property){
        var val = data.x;
        var needsVelocity = /velocity(?![\w\d])/.test(val);
        var _needsRandom = val.indexOf('random') !== -1;
        var elemType = elem.data.ty;
        var transform,content,effect;
        var thisComp = elem.comp;
        var thisProperty = property;
        elem.comp.frameDuration = 1/elem.comp.globalData.frameRate;
        var inPoint = elem.data.ip/elem.comp.globalData.frameRate;
        var outPoint = elem.data.op/elem.comp.globalData.frameRate;
        var width = elem.data.sw ? elem.data.sw : 0;
        var height = elem.data.sh ? elem.data.sh : 0;
        var loopIn, loop_in, loopOut, loop_out;
        var toWorld,fromWorld,fromComp,fromCompToSurface,anchorPoint,thisLayer,thisComp,mask,valueAtTime,velocityAtTime;
        var fn = new Function();
        //var fnStr = 'var fn = function(){'+val+';this.v = $bm_rt;}';
        //eval(fnStr);

        var fn = eval('[function(){' + val+';if($bm_rt.__shapeObject){this.v=shape_pool.clone($bm_rt.v);}else{this.v=$bm_rt;}}' + ']')[0];
        var bindedFn = fn.bind(this);
        var numKeys = property.kf ? data.k.length : 0;

        var wiggle = function wiggle(freq,amp){
            var i,j, len = this.pv.length ? this.pv.length : 1;
            var addedAmps = Array.apply(null,{len:len});
            for(j=0;j<len;j+=1){
                addedAmps[j] = 0;
            }
            freq = 5;
            var iterations = Math.floor(time*freq);
            i = 0;
            j = 0;
            while(i<iterations){
                //var rnd = BMMath.random();
                for(j=0;j<len;j+=1){
                    addedAmps[j] += -amp + amp*2*BMMath.random();
                    //addedAmps[j] += -amp + amp*2*rnd;
                }
                i += 1;
            }
            //var rnd2 = BMMath.random();
            var periods = time*freq;
            var perc = periods - Math.floor(periods);
            var arr = Array.apply({length:len});
            if(len>1){
                for(j=0;j<len;j+=1){
                    arr[j] = this.pv[j] + addedAmps[j] + (-amp + amp*2*BMMath.random())*perc;
                    //arr[j] = this.pv[j] + addedAmps[j] + (-amp + amp*2*rnd)*perc;
                    //arr[i] = this.pv[i] + addedAmp + amp1*perc + amp2*(1-perc);
                }
                return arr;
            } else {
                return this.pv + addedAmps[0] + (-amp + amp*2*BMMath.random())*perc;
            }
        }.bind(this);

        if(thisProperty.loopIn) {
            loopIn = thisProperty.loopIn.bind(thisProperty);
            loop_in = loopIn;
        }

        if(thisProperty.loopOut) {
            loopOut = thisProperty.loopOut.bind(thisProperty);
            loop_out = loopOut;
        }

        var loopInDuration = function loopInDuration(type,duration){
            return loopIn(type,duration,true);
        }.bind(this);

        var loopOutDuration = function loopOutDuration(type,duration){
            return loopOut(type,duration,true);
        }.bind(this);

        if(this.getValueAtTime) {
            valueAtTime = this.getValueAtTime.bind(this);
        }

        if(this.getVelocityAtTime) {
            velocityAtTime = this.getVelocityAtTime.bind(this);
        }

        var comp = elem.comp.globalData.projectInterface.bind(elem.comp.globalData.projectInterface);

        function lookAt(elem1,elem2){
            var fVec = [elem2[0]-elem1[0],elem2[1]-elem1[1],elem2[2]-elem1[2]];
            var pitch = Math.atan2(fVec[0],Math.sqrt(fVec[1]*fVec[1]+fVec[2]*fVec[2]))/degToRads;
            var yaw = -Math.atan2(fVec[1],fVec[2])/degToRads;
            return [yaw,pitch,0];
        };

        function easeOut(t, val1, val2){
            return -(val2-val1) * t*(t-2) + val1;
        };

        function nearestKey(time){
            var i, len = data.k.length,index,keyTime;
            if(!data.k.length || typeof(data.k[0]) === 'number'){
                index = 0;
                keyTime = 0;
            } else {
                index = -1;
                time *= elem.comp.globalData.frameRate;
                if (time < data.k[0].t) {
                    index = 1;
                    keyTime = data.k[0].t;
                } else {
                    for(i=0;i<len-1;i+=1){
                        if(time === data.k[i].t){
                            index = i + 1;
                            keyTime = data.k[i].t;
                            break;
                        }else if(time>data.k[i].t && time<data.k[i+1].t){
                            if(time-data.k[i].t > data.k[i+1].t - time){
                                index = i + 2;
                                keyTime = data.k[i+1].t;
                            } else {
                                index = i + 1;
                                keyTime = data.k[i].t;
                            }
                            break;
                        }
                    }
                    if(index === -1){
                        index = i + 1;
                        keyTime = data.k[i].t;
                    }
                }
                
            }
            var ob = {};
            ob.index = index;
            ob.time = keyTime/elem.comp.globalData.frameRate;
            return ob;
        };

        function key(ind){
            var ob, i, len;
            if(!data.k.length || typeof(data.k[0]) === 'number'){
                throw new Error('The property has no keyframe at index ' + ind);
            }
            ind -= 1;
            ob = {
                time: data.k[ind].t/elem.comp.globalData.frameRate
            };
            var arr;
            if(ind === data.k.length - 1 && !data.k[ind].h){
                arr = data.k[ind-1].e;
            }else{
                arr = data.k[ind].s;
            }
            len = arr.length;
            for(i=0;i<len;i+=1){
                ob[i] = arr[i];
            }
            return ob;
        };

        function framesToTime(frames,fps){
            if(!fps){
                fps = elem.comp.globalData.frameRate;
            }
            return frames/fps;
        };

        function timeToFrames(t,fps){
            if(!t && t !== 0){
                t = time;
            }
            if(!fps){
                fps = elem.comp.globalData.frameRate;
            }
            return t*fps;
        };

        function seedRandom(seed){
            BMMath.seedrandom(randSeed + seed);
        };

        function sourceRectAtTime() {
            return elem.sourceRectAtTime();
        }

        var time,velocity, value,textIndex,textTotal,selectorValue;
        var index = elem.data.ind;
        var hasParent = !!(elem.hierarchy && elem.hierarchy.length);
        var parent;
        var randSeed = Math.floor(Math.random()*1000000);
        function executeExpression(){
            if(_needsRandom){
                seedRandom(randSeed);
            }
            if(this.frameExpressionId === elem.globalData.frameId && this.type !== 'textSelector'){
                return;
            }
            if(this.lock){
                this.v = duplicatePropertyValue(this.pv,this.mult);
                return true;
            }
            if(this.type === 'textSelector'){
                textIndex = this.textIndex;
                textTotal = this.textTotal;
                selectorValue = this.selectorValue;
            }
            if(!thisLayer){
                thisLayer = elem.layerInterface;
                thisComp = elem.comp.compInterface;
                toWorld = thisLayer.toWorld.bind(thisLayer);
                fromWorld = thisLayer.fromWorld.bind(thisLayer);
                fromComp = thisLayer.fromComp.bind(thisLayer);
                mask = thisLayer.mask ? thisLayer.mask.bind(thisLayer):null;
                fromCompToSurface = fromComp;
            }
            if(!transform){
                transform = elem.layerInterface("ADBE Transform Group");
                anchorPoint = transform.anchorPoint;
            }
            
            if(elemType === 4 && !content){
                content = thisLayer("ADBE Root Vectors Group");
            }
            if(!effect){
                effect = thisLayer(4);
            }
            hasParent = !!(elem.hierarchy && elem.hierarchy.length);
            if(hasParent && !parent){
                parent = elem.hierarchy[0].layerInterface;
            }
            this.lock = true;
            if(this.getPreValue){
                this.getPreValue();
            }
            value = this.pv;
            time = this.comp.renderedFrame/this.comp.globalData.frameRate;
            if(needsVelocity){
                velocity = velocityAtTime(time);
            }
            bindedFn();
            this.frameExpressionId = elem.globalData.frameId;
            var i,len;
            if(this.mult){
                if(typeof this.v === 'number' || this.v instanceof Number || this.v instanceof String || typeof this.v === 'string'){
                    this.v *= this.mult;
                }else if(this.v.length === 1){
                    this.v = this.v[0] * this.mult;
                }else{
                    len = this.v.length;
                    if(value === this.v){
                        this.v = len === 2 ? [value[0],value[1]] : [value[0],value[1],value[2]];
                    }
                    for(i = 0; i < len; i += 1){
                        this.v[i] *= this.mult;
                    }
                }
            }
            if(this.v.length === 1){
                this.v = this.v[0];
            }
            if(typeof this.v === 'number' || this.v instanceof Number || this.v instanceof String || typeof this.v === 'string'){
                if(this.lastValue !== this.v){
                    this.lastValue = this.v;
                    this.mdf = true;
                }
            }else if( this.v._length){
                if(!shapesEqual(this.v,this.localShapeCollection.shapes[0])){
                    this.mdf = true;
                    this.localShapeCollection.releaseShapes();
                    this.localShapeCollection.addShape(shape_pool.clone(this.v));
                }
            }else{
                len = this.v.length;
                for(i = 0; i < len; i += 1){
                    if(this.v[i] !== this.lastValue[i]){
                        this.lastValue[i] = this.v[i];
                        this.mdf = true;
                    }
                }
            }
            this.lock = false;
        }
        return executeExpression;
    };

    ob.initiateExpression = initiateExpression;
    return ob;
}());
var ShapeExpressionInterface = (function(){
    var ob = {
        createShapeInterface:createShapeInterface,
        createGroupInterface:createGroupInterface,
        createTrimInterface:createTrimInterface,
        createStrokeInterface:createStrokeInterface,
        createTransformInterface:createTransformInterface,
        createEllipseInterface:createEllipseInterface,
        createStarInterface:createStarInterface,
        createRectInterface:createRectInterface,
        createRoundedInterface:createRoundedInterface,
        createRepatearInterface:createRepatearInterface,
        createPathInterface:createPathInterface,
        createFillInterface:createFillInterface
    };
    function createShapeInterface(shapes,view,propertyGroup){
        return shapeInterfaceFactory(shapes,view,propertyGroup);
    }
    function createGroupInterface(shapes,view,propertyGroup){
        return groupInterfaceFactory(shapes,view,propertyGroup);
    }
    function createFillInterface(shape,view,propertyGroup){
        return fillInterfaceFactory(shape,view,propertyGroup);
    }
    function createStrokeInterface(shape,view,propertyGroup){
        return strokeInterfaceFactory(shape,view,propertyGroup);
    }
    function createTrimInterface(shape,view,propertyGroup){
        return trimInterfaceFactory(shape,view,propertyGroup);
    }
    function createTransformInterface(shape,view,propertyGroup){
        return transformInterfaceFactory(shape,view,propertyGroup);
    }
    function createEllipseInterface(shape,view,propertyGroup){
        return ellipseInterfaceFactory(shape,view,propertyGroup);
    }
    function createStarInterface(shape,view,propertyGroup){
        return starInterfaceFactory(shape,view,propertyGroup);
    }
    function createRectInterface(shape,view,propertyGroup){
        return rectInterfaceFactory(shape,view,propertyGroup);
    }
    function createRoundedInterface(shape,view,propertyGroup){
        return roundedInterfaceFactory(shape,view,propertyGroup);
    }
    function createRepatearInterface(shape,view,propertyGroup){
        return repeaterInterfaceFactory(shape,view,propertyGroup);
    }
    function createPathInterface(shape,view,propertyGroup){
        return pathInterfaceFactory(shape,view,propertyGroup);
    }

    function iterateElements(shapes,view, propertyGroup){
        var arr = [];
        var i, len = shapes ? shapes.length : 0;
        for(i=0;i<len;i+=1){
            if(shapes[i].ty == 'gr'){
                arr.push(ShapeExpressionInterface.createGroupInterface(shapes[i],view[i],propertyGroup));
            }else if(shapes[i].ty == 'fl'){
                arr.push(ShapeExpressionInterface.createFillInterface(shapes[i],view[i],propertyGroup));
            }else if(shapes[i].ty == 'st'){
                arr.push(ShapeExpressionInterface.createStrokeInterface(shapes[i],view[i],propertyGroup));
            }else if(shapes[i].ty == 'tm'){
                arr.push(ShapeExpressionInterface.createTrimInterface(shapes[i],view[i],propertyGroup));
            }else if(shapes[i].ty == 'tr'){
                //arr.push(ShapeExpressionInterface.createTransformInterface(shapes[i],view[i],propertyGroup));
            }else if(shapes[i].ty == 'el'){
                arr.push(ShapeExpressionInterface.createEllipseInterface(shapes[i],view[i],propertyGroup));
            }else if(shapes[i].ty == 'sr'){
                arr.push(ShapeExpressionInterface.createStarInterface(shapes[i],view[i],propertyGroup));
            } else if(shapes[i].ty == 'sh'){
                arr.push(ShapeExpressionInterface.createPathInterface(shapes[i],view[i],propertyGroup));
            } else if(shapes[i].ty == 'rc'){
                arr.push(ShapeExpressionInterface.createRectInterface(shapes[i],view[i],propertyGroup));
            } else if(shapes[i].ty == 'rd'){
                arr.push(ShapeExpressionInterface.createRoundedInterface(shapes[i],view[i],propertyGroup));
            } else if(shapes[i].ty == 'rp'){
                arr.push(ShapeExpressionInterface.createRepatearInterface(shapes[i],view[i],propertyGroup));
            } else{
                //console.log(shapes[i].ty);
            }
        }
        return arr;
    }

    var shapeInterfaceFactory = (function(){
        return function(shapes,view,propertyGroup){
            var interfaces;
            function _interfaceFunction(value){
                if(typeof value === 'number'){
                    return interfaces[value-1];
                } else {
                    var i = 0, len = interfaces.length;
                    while(i<len){
                        if(interfaces[i]._name === value){
                            return interfaces[i];
                        }
                        i+=1;
                    }
                }
            }
            _interfaceFunction.propertyGroup = propertyGroup;
            interfaces = iterateElements(shapes, view, _interfaceFunction);
            return _interfaceFunction;
        }
    }());

    var contentsInterfaceFactory = (function(){
       return function(shape,view, propertyGroup){
           var interfaces;
           var interfaceFunction = function _interfaceFunction(value){
               var i = 0, len = interfaces.length;
                while(i<len){
                    if(interfaces[i]._name === value || interfaces[i].mn === value || interfaces[i].propertyIndex === value || interfaces[i].ix === value || interfaces[i].ind === value){
                       return interfaces[i];
                    }
                    i+=1;
                }
                if(typeof value === 'number'){
                   return interfaces[value-1];
                }
           };
           interfaceFunction.propertyGroup = function(val){
               if(val === 1){
                   return interfaceFunction;
               } else{
                   return propertyGroup(val-1);
               }
           };
           interfaces = iterateElements(shape.it, view.it, interfaceFunction.propertyGroup);
           interfaceFunction.numProperties = interfaces.length;
           interfaceFunction.propertyIndex = shape.cix;

           return interfaceFunction;
       }
    }());

    var groupInterfaceFactory = (function(){
        return function(shape,view, propertyGroup){
            var interfaceFunction = function _interfaceFunction(value){
                switch(value){
                    case 'ADBE Vectors Group':
                    case 'Contents':
                    case 2:
                        return interfaceFunction.content;
                    case 'ADBE Vector Transform Group':
                    case 3:
                    default:
                        return interfaceFunction.transform;
                }
            }
            interfaceFunction.propertyGroup = function(val){
                if(val === 1){
                    return interfaceFunction;
                } else{
                    return propertyGroup(val-1);
                }
            };
            var content = contentsInterfaceFactory(shape,view,interfaceFunction.propertyGroup);
            var transformInterface = ShapeExpressionInterface.createTransformInterface(shape.it[shape.it.length - 1],view.it[view.it.length - 1],interfaceFunction.propertyGroup);
            interfaceFunction.content = content;
            interfaceFunction.transform = transformInterface;
            Object.defineProperty(interfaceFunction, '_name', {
                get: function(){
                    return shape.nm;
                }
            });
            //interfaceFunction.content = interfaceFunction;
            interfaceFunction.numProperties = shape.np;
            interfaceFunction.propertyIndex = shape.ix;
            interfaceFunction.nm = shape.nm;
            interfaceFunction.mn = shape.mn;
            return interfaceFunction;
        }
    }());

    var fillInterfaceFactory = (function(){
        return function(shape,view,propertyGroup){

            function interfaceFunction(val){
                if(val === 'Color' || val === 'color'){
                    return interfaceFunction.color;
                } else if(val === 'Opacity' || val === 'opacity'){
                    return interfaceFunction.opacity;
                }
            }
            Object.defineProperty(interfaceFunction, 'color', {
                get: function(){
                    return ExpressionValue(view.c, 1 / view.c.mult, 'color');
                }
            });
            Object.defineProperty(interfaceFunction, 'opacity', {
                get: function(){
                    return ExpressionValue(view.o, 100);
                }
            });
            Object.defineProperty(interfaceFunction, '_name', { value: shape.nm });
            Object.defineProperty(interfaceFunction, 'mn', { value: shape.mn });

            view.c.setGroupProperty(propertyGroup);
            view.o.setGroupProperty(propertyGroup);
            return interfaceFunction;
        }
    }());

    var strokeInterfaceFactory = (function(){
        return function(shape,view,propertyGroup){
            function _propertyGroup(val){
                if(val === 1){
                    return ob;
                } else{
                    return propertyGroup(val-1);
                }
            };
            function _dashPropertyGroup(val){
                if(val === 1){
                    return dashOb;
                } else{
                    return _propertyGroup(val-1);
                }
            };
            function addPropertyToDashOb(i) {
                Object.defineProperty(dashOb, shape.d[i].nm, {
                    get: function(){
                        return ExpressionValue(view.d.dataProps[i].p)
                    }
                });
            }
            var i, len = shape.d ? shape.d.length : 0;
            var dashOb = {}
            for (i = 0; i < len; i += 1) {
                addPropertyToDashOb(i);
                view.d.dataProps[i].p.setGroupProperty(_dashPropertyGroup);
            }

            function interfaceFunction(val){
                if(val === 'Color' || val === 'color'){
                    return interfaceFunction.color;
                } else if(val === 'Opacity' || val === 'opacity'){
                    return interfaceFunction.opacity;
                } else if(val === 'Stroke Width' || val === 'stroke width'){
                    return interfaceFunction.strokeWidth;
                }
            }
            Object.defineProperty(interfaceFunction, 'color', {
                get: function(){
                    return ExpressionValue(view.c, 1 / view.c.mult, 'color');
                }
            });
            Object.defineProperty(interfaceFunction, 'opacity', {
                get: function(){
                    return ExpressionValue(view.o, 100);
                }
            });
            Object.defineProperty(interfaceFunction, 'strokeWidth', {
                get: function(){
                    return ExpressionValue(view.w);
                }
            });
            Object.defineProperty(interfaceFunction, 'dash', {
                get: function(){
                    return dashOb;
                }
            });
            Object.defineProperty(interfaceFunction, '_name', { value: shape.nm });
            Object.defineProperty(interfaceFunction, 'mn', { value: shape.mn });

            view.c.setGroupProperty(_propertyGroup);
            view.o.setGroupProperty(_propertyGroup);
            view.w.setGroupProperty(_propertyGroup);
            return interfaceFunction;
        }
    }());

    var trimInterfaceFactory = (function(){
        return function(shape,view,propertyGroup){
            function _propertyGroup(val){
                if(val == 1){
                    return interfaceFunction;
                } else {
                    return propertyGroup(--val);
                }
            }
            interfaceFunction.propertyIndex = shape.ix;

            view.s.setGroupProperty(_propertyGroup);
            view.e.setGroupProperty(_propertyGroup);
            view.o.setGroupProperty(_propertyGroup);

            function interfaceFunction(val){
                if(val === shape.e.ix || val === 'End' || val === 'end'){
                    return interfaceFunction.end;
                }
                if(val === shape.s.ix){
                    return interfaceFunction.start;
                }
                if(val === shape.o.ix){
                    return interfaceFunction.offset;
                }
            }
            interfaceFunction.propertyIndex = shape.ix;
            Object.defineProperty(interfaceFunction, 'start', {
                get: function(){
                    return ExpressionValue(view.s, 1 / view.s.mult);
                }
            });
            Object.defineProperty(interfaceFunction, 'end', {
                get: function(){
                    return ExpressionValue(view.e, 1 / view.e.mult);
                }
            });
            Object.defineProperty(interfaceFunction, 'offset', {
                get: function(){
                    return ExpressionValue(view.o);
                }
            });
            Object.defineProperty(interfaceFunction, '_name', {
                get: function(){
                    return shape.nm;
                }
            });
            interfaceFunction.mn = shape.mn;
            return interfaceFunction;
        }
    }());

    var transformInterfaceFactory = (function(){
        return function(shape,view,propertyGroup){
            function _propertyGroup(val){
                if(val == 1){
                    return interfaceFunction;
                } else {
                    return propertyGroup(--val);
                }
            }
            view.transform.mProps.o.setGroupProperty(_propertyGroup);
            view.transform.mProps.p.setGroupProperty(_propertyGroup);
            view.transform.mProps.a.setGroupProperty(_propertyGroup);
            view.transform.mProps.s.setGroupProperty(_propertyGroup);
            view.transform.mProps.r.setGroupProperty(_propertyGroup);
            if(view.transform.mProps.sk){
                view.transform.mProps.sk.setGroupProperty(_propertyGroup);
                view.transform.mProps.sa.setGroupProperty(_propertyGroup);
            }
            view.transform.op.setGroupProperty(_propertyGroup);

            function interfaceFunction(value){
                if(shape.a.ix === value){
                    return interfaceFunction.anchorPoint;
                }
                if(shape.o.ix === value){
                    return interfaceFunction.opacity;
                }
                if(shape.p.ix === value){
                    return interfaceFunction.position;
                }
                if(shape.r.ix === value){
                    return interfaceFunction.rotation;
                }
                if(shape.s.ix === value){
                    return interfaceFunction.scale;
                }
                if(shape.sk && shape.sk.ix === value){
                    return interfaceFunction.skew;
                }
                if(shape.sa && shape.sa.ix === value){
                    return interfaceFunction.skewAxis;
                }
                if(value === 'Opacity') {
                    return interfaceFunction.opacity;
                }
                if(value === 'Position') {
                    return interfaceFunction.position;
                }
                if(value === 'Anchor Point') {
                    return interfaceFunction.anchorPoint;
                }
                if(value === 'Scale') {
                    return interfaceFunction.scale;
                }
                if(value === 'Rotation' || value === 'ADBE Vector Rotation') {
                    return interfaceFunction.rotation;
                }
                if(value === 'Skew') {
                    return interfaceFunction.skew;
                }
                if(value === 'Skew Axis') {
                    return interfaceFunction.skewAxis;
                }

            }
            Object.defineProperty(interfaceFunction, 'opacity', {
                get: function(){
                    return ExpressionValue(view.transform.mProps.o, 1/view.transform.mProps.o.mult);
                }
            });
            Object.defineProperty(interfaceFunction, 'position', {
                get: function(){
                    return ExpressionValue(view.transform.mProps.p);
                }
            });
            Object.defineProperty(interfaceFunction, 'anchorPoint', {
                get: function(){
                    return ExpressionValue(view.transform.mProps.a);
                }
            });
            var scaleArray = [];
            Object.defineProperty(interfaceFunction, 'scale', {
                get: function(){
                    return ExpressionValue(view.transform.mProps.s, 1 / view.transform.mProps.s.mult);
                }
            });
            Object.defineProperty(interfaceFunction, 'rotation', {
                get: function(){
                    return ExpressionValue(view.transform.mProps.r, 1 / view.transform.mProps.r.mult);
                }
            });
            Object.defineProperty(interfaceFunction, 'skew', {
                get: function(){
                    return ExpressionValue(view.transform.mProps.sk);
                }
            });
            Object.defineProperty(interfaceFunction, 'skewAxis', {
                get: function(){
                    return ExpressionValue(view.transform.mProps.sa);
                }
            });
            Object.defineProperty(interfaceFunction, '_name', {
                get: function(){
                    return shape.nm;
                }
            });
            interfaceFunction.ty = 'tr';
            interfaceFunction.mn = shape.mn;
            return interfaceFunction;
        }
    }());

    var ellipseInterfaceFactory = (function(){
        return function(shape,view,propertyGroup){
            function _propertyGroup(val){
                if(val == 1){
                    return interfaceFunction;
                } else {
                    return propertyGroup(--val);
                }
            }
            interfaceFunction.propertyIndex = shape.ix;
            var prop = view.sh.ty === 'tm' ? view.sh.prop : view.sh;
            prop.s.setGroupProperty(_propertyGroup);
            prop.p.setGroupProperty(_propertyGroup);
            function interfaceFunction(value){
                if(shape.p.ix === value){
                    return interfaceFunction.position;
                }
                if(shape.s.ix === value){
                    return interfaceFunction.size;
                }
            }
            Object.defineProperty(interfaceFunction, 'size', {
                get: function(){
                    return ExpressionValue(prop.s);
                }
            });
            Object.defineProperty(interfaceFunction, 'position', {
                get: function(){
                    return ExpressionValue(prop.p);
                }
            });
            Object.defineProperty(interfaceFunction, '_name', {
                get: function(){
                    return shape.nm;
                }
            });
            interfaceFunction.mn = shape.mn;
            return interfaceFunction;
        }
    }());

    var starInterfaceFactory = (function(){
        return function(shape,view,propertyGroup){
            function _propertyGroup(val){
                if(val == 1){
                    return interfaceFunction;
                } else {
                    return propertyGroup(--val);
                }
            }
            var prop = view.sh.ty === 'tm' ? view.sh.prop : view.sh;
            interfaceFunction.propertyIndex = shape.ix;
            prop.or.setGroupProperty(_propertyGroup);
            prop.os.setGroupProperty(_propertyGroup);
            prop.pt.setGroupProperty(_propertyGroup);
            prop.p.setGroupProperty(_propertyGroup);
            prop.r.setGroupProperty(_propertyGroup);
            if(shape.ir){
                prop.ir.setGroupProperty(_propertyGroup);
                prop.is.setGroupProperty(_propertyGroup);
            }

            function interfaceFunction(value){
                if(shape.p.ix === value){
                    return interfaceFunction.position;
                }
                if(shape.r.ix === value){
                    return interfaceFunction.rotation;
                }
                if(shape.pt.ix === value){
                    return interfaceFunction.points;
                }
                if(shape.or.ix === value || 'ADBE Vector Star Outer Radius' === value){
                    return interfaceFunction.outerRadius;
                }
                if(shape.os.ix === value){
                    return interfaceFunction.outerRoundness;
                }
                if(shape.ir && (shape.ir.ix === value || 'ADBE Vector Star Inner Radius' === value)){
                    return interfaceFunction.innerRadius;
                }
                if(shape.is && shape.is.ix === value){
                    return interfaceFunction.innerRoundness;
                }

            }
            Object.defineProperty(interfaceFunction, 'position', {
                get: function(){
                    return ExpressionValue(prop.p);
                }
            });
            Object.defineProperty(interfaceFunction, 'rotation', {
                get: function(){
                    return ExpressionValue(prop.r, 1 / prop.r.mult);
                }
            });
            Object.defineProperty(interfaceFunction, 'points', {
                get: function(){
                    return ExpressionValue(prop.pt);
                }
            });
            Object.defineProperty(interfaceFunction, 'outerRadius', {
                get: function(){
                    return ExpressionValue(prop.or);
                }
            });
            Object.defineProperty(interfaceFunction, 'outerRoundness', {
                get: function(){
                    return ExpressionValue(prop.os);
                }
            });
            Object.defineProperty(interfaceFunction, 'innerRadius', {
                get: function(){
                    if(!prop.ir){
                        return 0;
                    }
                    return ExpressionValue(prop.ir);
                }
            });
            Object.defineProperty(interfaceFunction, 'innerRoundness', {
                get: function(){
                    if(!prop.is){
                        return 0;
                    }
                    return ExpressionValue(prop.is, 1 / prop.is.mult);
                }
            });
            Object.defineProperty(interfaceFunction, '_name', {
                get: function(){
                    return shape.nm;
                }
            });
            interfaceFunction.mn = shape.mn;
            return interfaceFunction;
        }
    }());

    var rectInterfaceFactory = (function(){
        return function(shape,view,propertyGroup){
            function _propertyGroup(val){
                if(val == 1){
                    return interfaceFunction;
                } else {
                    return propertyGroup(--val);
                }
            }
            var prop = view.sh.ty === 'tm' ? view.sh.prop : view.sh;
            interfaceFunction.propertyIndex = shape.ix;
            prop.p.setGroupProperty(_propertyGroup);
            prop.s.setGroupProperty(_propertyGroup);
            prop.r.setGroupProperty(_propertyGroup);

            function interfaceFunction(value){
                if(shape.p.ix === value){
                    return interfaceFunction.position;
                }
                if(shape.r.ix === value){
                    return interfaceFunction.roundness;
                }
                if(shape.s.ix === value || value === 'Size'){
                    return interfaceFunction.size;
                }

            }
            Object.defineProperty(interfaceFunction, 'position', {
                get: function(){
                    return ExpressionValue(prop.p);
                }
            });
            Object.defineProperty(interfaceFunction, 'roundness', {
                get: function(){
                    return ExpressionValue(prop.r);
                }
            });
            Object.defineProperty(interfaceFunction, 'size', {
                get: function(){
                    return ExpressionValue(prop.s);
                }
            });

            Object.defineProperty(interfaceFunction, '_name', {
                get: function(){
                    return shape.nm;
                }
            });
            interfaceFunction.mn = shape.mn;
            return interfaceFunction;
        }
    }());

    var roundedInterfaceFactory = (function(){
        return function(shape,view,propertyGroup){
            function _propertyGroup(val){
                if(val == 1){
                    return interfaceFunction;
                } else {
                    return propertyGroup(--val);
                }
            }
            var prop = view;
            interfaceFunction.propertyIndex = shape.ix;
            prop.rd.setGroupProperty(_propertyGroup);

            function interfaceFunction(value){
                if(shape.r.ix === value || 'Round Corners 1' === value){
                    return interfaceFunction.radius;
                }

            }
            Object.defineProperty(interfaceFunction, 'radius', {
                get: function(){
                    return ExpressionValue(prop.rd);
                }
            });

            Object.defineProperty(interfaceFunction, '_name', {
                get: function(){
                    return shape.nm;
                }
            });
            interfaceFunction.mn = shape.mn;
            return interfaceFunction;
        }
    }());

    var repeaterInterfaceFactory = (function(){
        return function(shape,view,propertyGroup){
            function _propertyGroup(val){
                if(val == 1){
                    return interfaceFunction;
                } else {
                    return propertyGroup(--val);
                }
            }
            var prop = view;
            interfaceFunction.propertyIndex = shape.ix;
            prop.c.setGroupProperty(_propertyGroup);
            prop.o.setGroupProperty(_propertyGroup);

            function interfaceFunction(value){
                if(shape.c.ix === value || 'Copies' === value){
                    return interfaceFunction.copies;
                } else if(shape.o.ix === value || 'Offset' === value){
                    return interfaceFunction.offset;
                }

            }
            Object.defineProperty(interfaceFunction, 'copies', {
                get: function(){
                    return ExpressionValue(prop.c);
                }
            });

            Object.defineProperty(interfaceFunction, 'offset', {
                get: function(){
                    return ExpressionValue(prop.o);
                }
            });

            Object.defineProperty(interfaceFunction, '_name', {
                get: function(){
                    return shape.nm;
                }
            });
            interfaceFunction.mn = shape.mn;
            return interfaceFunction;
        }
    }());

    var pathInterfaceFactory = (function(){
        return function(shape,view,propertyGroup){
            var prop = view.sh;
            function _propertyGroup(val){
                if(val == 1){
                    return interfaceFunction;
                } else {
                    return propertyGroup(--val);
                }
            }
            prop.setGroupProperty(_propertyGroup);

            function interfaceFunction(val){
                if(val === 'Shape' || val === 'shape' || val === 'Path' || val === 'path' || val === 'ADBE Vector Shape' || val === 2){
                    return interfaceFunction.path;
                }
            }

            Object.defineProperty(interfaceFunction, 'path', {
                get: function(){
                    if(prop.k){
                        prop.getValue();
                    }
                    return prop;
                    //return shape_pool.clone(prop.v);
                }
            });
            Object.defineProperty(interfaceFunction, 'shape', {
                get: function(){
                    if(prop.k){
                        prop.getValue();
                    }
                    return prop;
                    //return shape_pool.clone(prop.v);
                }
            });
            Object.defineProperty(interfaceFunction, '_name', { value: shape.nm });
            Object.defineProperty(interfaceFunction, 'ix', { value: shape.ix });
            Object.defineProperty(interfaceFunction, 'mn', { value: shape.mn });
            return interfaceFunction;
        }
    }());


    return ob;
}())

var TextExpressionInterface = (function(){
	return function(elem){
        var _prevValue, _sourceText;
        function _thisLayerFunction(){
        }
        Object.defineProperty(_thisLayerFunction, "sourceText", {
            get: function(){
                var stringValue = elem.textProperty.currentData.t;
                if(elem.textProperty.currentData.t !== _prevValue) {
                    elem.textProperty.currentData.t = _prevValue;
                    _sourceText = new String(stringValue);
                    //If stringValue is an empty string, eval returns undefined, so it has to be returned as a String primitive
                    _sourceText.value = stringValue ? stringValue : new String(stringValue);
                }
                return _sourceText;
            }
        });
        return _thisLayerFunction;
    }
}())
var LayerExpressionInterface = (function (){
    function toWorld(arr, time){
        var toWorldMat = new Matrix();
        toWorldMat.reset();
        var transformMat;
        if(time) {
            //Todo implement value at time on transform properties
            //transformMat = this._elem.finalTransform.mProp.getValueAtTime(time);
            transformMat = this._elem.finalTransform.mProp;
        } else {
            transformMat = this._elem.finalTransform.mProp;
        }
        transformMat.applyToMatrix(toWorldMat);
        if(this._elem.hierarchy && this._elem.hierarchy.length){
            var i, len = this._elem.hierarchy.length;
            for(i=0;i<len;i+=1){
                this._elem.hierarchy[i].finalTransform.mProp.applyToMatrix(toWorldMat);
            }
            return toWorldMat.applyToPointArray(arr[0],arr[1],arr[2]||0);
        }
        return toWorldMat.applyToPointArray(arr[0],arr[1],arr[2]||0);
    }
    function fromWorld(arr, time){
        var toWorldMat = new Matrix();
        toWorldMat.reset();
        var transformMat;
        if(time) {
            //Todo implement value at time on transform properties
            //transformMat = this._elem.finalTransform.mProp.getValueAtTime(time);
            transformMat = this._elem.finalTransform.mProp;
        } else {
            transformMat = this._elem.finalTransform.mProp;
        }
        transformMat.applyToMatrix(toWorldMat);
        if(this._elem.hierarchy && this._elem.hierarchy.length){
            var i, len = this._elem.hierarchy.length;
            for(i=0;i<len;i+=1){
                this._elem.hierarchy[i].finalTransform.mProp.applyToMatrix(toWorldMat);
            }
            return toWorldMat.inversePoint(arr);
        }
        return toWorldMat.inversePoint(arr);
    }
    function fromComp(arr){
        var toWorldMat = new Matrix();
        toWorldMat.reset();
        this._elem.finalTransform.mProp.applyToMatrix(toWorldMat);
        if(this._elem.hierarchy && this._elem.hierarchy.length){
            var i, len = this._elem.hierarchy.length;
            for(i=0;i<len;i+=1){
                this._elem.hierarchy[i].finalTransform.mProp.applyToMatrix(toWorldMat);
            }
            return toWorldMat.inversePoint(arr);
        }
        return toWorldMat.inversePoint(arr);
    }


    return function(elem){

        var transformInterface = TransformExpressionInterface(elem.transform);

        function _registerMaskInterface(maskManager){
            _thisLayerFunction.mask = new MaskManagerInterface(maskManager, elem);
        }
        function _registerEffectsInterface(effects){
            _thisLayerFunction.effect = effects;
        }

        function _thisLayerFunction(name){
            switch(name){
                case "ADBE Root Vectors Group":
                case "Contents":
                case 2:
                    return _thisLayerFunction.shapeInterface;
                case 1:
                case 6:
                case "Transform":
                case "transform":
                case "ADBE Transform Group":
                    return transformInterface;
                case 4:
                case "ADBE Effect Parade":
                    return _thisLayerFunction.effect;
            }
        }
        _thisLayerFunction.toWorld = toWorld;
        _thisLayerFunction.fromWorld = fromWorld;
        _thisLayerFunction.toComp = toWorld;
        _thisLayerFunction.fromComp = fromComp;
        _thisLayerFunction.sourceRectAtTime = elem.sourceRectAtTime.bind(elem);
        _thisLayerFunction._elem = elem;
        Object.defineProperty(_thisLayerFunction, 'hasParent', {
            get: function(){
                return !!elem.hierarchy;
            }
        });
        Object.defineProperty(_thisLayerFunction, 'parent', {
            get: function(){
                return elem.hierarchy[0].layerInterface;
            }
        });
        Object.defineProperty(_thisLayerFunction, "rotation", {
            get: function(){
                return transformInterface.rotation;
            }
        });
        Object.defineProperty(_thisLayerFunction, "scale", {
            get: function () {
                return transformInterface.scale;
            }
        });

        Object.defineProperty(_thisLayerFunction, "position", {
            get: function () {
                return transformInterface.position;
            }
        });

        Object.defineProperty(_thisLayerFunction, "anchorPoint", {
            get: function () {
                return transformInterface.anchorPoint;
            }
        });

        Object.defineProperty(_thisLayerFunction, "transform", {
            get: function () {
                return transformInterface;
            }
        });

        Object.defineProperty(_thisLayerFunction, "width", {
            get: function () {
                if(elem.data.ty === 0) {
                    return elem.data.w
                }
                return 100;
            }
        });

        Object.defineProperty(_thisLayerFunction, "height", {
            get: function () {
                if(elem.data.ty === 0) {
                    return elem.data.h
                }
                return 100;
            }
        });

        Object.defineProperty(_thisLayerFunction, "source", {
            get: function () {
                return elem.data.refId;
            }
        });

        Object.defineProperty(_thisLayerFunction, "index", {
            get: function () {
                return elem.data.ind;
            }
        });

        Object.defineProperty(_thisLayerFunction, "_name", { value:elem.data.nm });
        Object.defineProperty(_thisLayerFunction, "content", {
            get: function(){
                return _thisLayerFunction.shapeInterface;
            }
        });

        Object.defineProperty(_thisLayerFunction, "active", {
            get: function(){
                return elem.isVisible;
            }
        });

        Object.defineProperty(_thisLayerFunction, "text", {
            get: function(){
                return _thisLayerFunction.textInterface;
            }
        });

        _thisLayerFunction.registerMaskInterface = _registerMaskInterface;
        _thisLayerFunction.registerEffectsInterface = _registerEffectsInterface;
        return _thisLayerFunction;
    }
}());

var CompExpressionInterface = (function (){
    return function(comp){
        function _thisLayerFunction(name){
            var i=0, len = comp.layers.length;
            while(i<len){
                if(comp.layers[i].nm === name || comp.layers[i].ind === name){
                    return comp.elements[i].layerInterface;
                }
                i += 1;
            }
            return {active:false}
        }
        Object.defineProperty(_thisLayerFunction, "_name", { value:comp.data.nm });
        _thisLayerFunction.layer = _thisLayerFunction;
        _thisLayerFunction.pixelAspect = 1;
        _thisLayerFunction.height = comp.globalData.compSize.h;
        _thisLayerFunction.width = comp.globalData.compSize.w;
        _thisLayerFunction.pixelAspect = 1;
        _thisLayerFunction.frameDuration = 1/comp.globalData.frameRate;
        return _thisLayerFunction;
    }
}());
var TransformExpressionInterface = (function (){
    return function(transform){
        function _thisFunction(name){
            switch(name){
                case "scale":
                case "Scale":
                case "ADBE Scale":
                case 6:
                    return _thisFunction.scale;
                case "rotation":
                case "Rotation":
                case "ADBE Rotation":
                case "ADBE Rotate Z":
                case 10:
                    return _thisFunction.rotation;
                case "position":
                case "Position":
                case "ADBE Position":
                case 2:
                    return transform.position;
                case "anchorPoint":
                case "AnchorPoint":
                case "Anchor Point":
                case "ADBE AnchorPoint":
                case 1:
                    return _thisFunction.anchorPoint;
                case "opacity":
                case "Opacity":
                case 11:
                    return _thisFunction.opacity;
            }
        }

        Object.defineProperty(_thisFunction, "rotation", {
            get: function(){
                return transform.rotation;
            }
        });
        Object.defineProperty(_thisFunction, "scale", {
            get: function () {
                return transform.scale;
            }
        });

        Object.defineProperty(_thisFunction, "position", {
            get: function () {
                return transform.position;
            }
        });

        Object.defineProperty(_thisFunction, "xPosition", {
            get: function () {
                return transform.xPosition;
            }
        });

        Object.defineProperty(_thisFunction, "yPosition", {
            get: function () {
                return transform.yPosition;
            }
        });

        Object.defineProperty(_thisFunction, "anchorPoint", {
            get: function () {
                return transform.anchorPoint;
            }
        });

        Object.defineProperty(_thisFunction, "opacity", {
            get: function () {
                return transform.opacity;
            }
        });

        Object.defineProperty(_thisFunction, "skew", {
            get: function () {
                return transform.skew;
            }
        });

        Object.defineProperty(_thisFunction, "skewAxis", {
            get: function () {
                return transform.skewAxis;
            }
        });

        return _thisFunction;
    }
}());
var ProjectInterface = (function (){

    function registerComposition(comp){
        this.compositions.push(comp);
    }

    return function(){
        function _thisProjectFunction(name){
            var i = 0, len = this.compositions.length;
            while(i<len){
                if(this.compositions[i].data && this.compositions[i].data.nm === name){
                    if(this.compositions[i].prepareFrame) {
                        this.compositions[i].prepareFrame(this.currentFrame);
                    }
                    return this.compositions[i].compInterface;
                }
                i+=1;
            }
        }

        _thisProjectFunction.compositions = [];
        _thisProjectFunction.currentFrame = 0;

        _thisProjectFunction.registerComposition = registerComposition;



        return _thisProjectFunction;
    }
}());
var EffectsExpressionInterface = (function (){
    var ob = {
        createEffectsInterface: createEffectsInterface
    };

    function createEffectsInterface(elem, propertyGroup){
        if(elem.effects){

            var effectElements = [];
            var effectsData = elem.data.ef;
            var i, len = elem.effects.effectElements.length;
            for(i=0;i<len;i+=1){
                effectElements.push(createGroupInterface(effectsData[i],elem.effects.effectElements[i],propertyGroup,elem));
            }

            return function(name){
                var effects = elem.data.ef, i = 0, len = effects.length;
                while(i<len) {
                    if(name === effects[i].nm || name === effects[i].mn || name === effects[i].ix){
                        return effectElements[i];
                    }
                    i += 1;
                }
            }
        }
    }

    function createGroupInterface(data,elements, propertyGroup, elem){
        var effectElements = [];
        var i, len = data.ef.length;
        for(i=0;i<len;i+=1){
            if(data.ef[i].ty === 5){
                effectElements.push(createGroupInterface(data.ef[i],elements.effectElements[i],elements.effectElements[i].propertyGroup, elem));
            } else {
                effectElements.push(createValueInterface(elements.effectElements[i],data.ef[i].ty, elem, _propertyGroup));
            }
        }

        function _propertyGroup(val) {
            if(val === 1){
               return groupInterface;
            } else{
               return propertyGroup(val-1);
            }
        }

        var groupInterface = function(name){
            var effects = data.ef, i = 0, len = effects.length;
            while(i<len) {
                if(name === effects[i].nm || name === effects[i].mn || name === effects[i].ix){
                    if(effects[i].ty === 5){
                        return effectElements[i];
                    } else {
                        return effectElements[i]();
                    }
                }
                i += 1;
            }
            return effectElements[0]();
        }

        groupInterface.propertyGroup = _propertyGroup;

        if(data.mn === 'ADBE Color Control'){
            Object.defineProperty(groupInterface, 'color', {
                get: function(){
                    return effectElements[0]();
                }
            });
        }
        Object.defineProperty(groupInterface, 'numProperties', {
            get: function(){
                return data.np;
            }
        });
        groupInterface.active = data.en !== 0;
        return groupInterface
    }

    function createValueInterface(element, type, elem, propertyGroup){
        function interfaceFunction(){
            if(type === 10){
                return elem.comp.compInterface(element.p.v);
            }
            return ExpressionValue(element.p);
        }

        if(element.p.setGroupProperty) {
            element.p.setGroupProperty(propertyGroup);
        }

        return interfaceFunction;
    }

    return ob;

}());
var MaskManagerInterface = (function(){

	function MaskInterface(mask, data){
		this._mask = mask;
		this._data = data;
	}
	Object.defineProperty(MaskInterface.prototype, 'maskPath', {
        get: function(){
                if(this._mask.prop.k){
                    this._mask.prop.getValue();
                }
                return this._mask.prop;
            }
        });

	var MaskManager = function(maskManager, elem){
		var _maskManager = maskManager;
		var _elem = elem;
		var _masksInterfaces = Array.apply(null,{length: maskManager.viewData.length});
		var i, len = maskManager.viewData.length;
		for(i = 0; i < len; i += 1) {
			_masksInterfaces[i] = new MaskInterface(maskManager.viewData[i], maskManager.masksProperties[i]);
		}

		var maskFunction = function(name){
			i = 0;
		    while(i<len){
		        if(maskManager.masksProperties[i].nm === name){
		            return _masksInterfaces[i];
		        }
		        i += 1;
		    }
		}
		return maskFunction
	}
	return MaskManager
}())


var ExpressionValue = (function() {
	return function(elementProp, mult, type) {
        var expressionValue, arrayValue;

		if (elementProp.k) {
            elementProp.getValue();
        }
        var i, len, arrValue;
        if (type) {
        	if(type === 'color') {
        		len = 4;
		        expressionValue = Array.apply(null, {length: len});
		        arrValue = Array.apply(null, {length: len});
		        for (i = 0; i < len; i += 1) {
		            expressionValue[i] = arrValue[i] = (mult && i < 3) ? elementProp.v[i] * mult : 1;
		        }
	        	expressionValue.value = arrValue;
        	}
        } else if (typeof elementProp.v === 'number' || elementProp.v instanceof Number){
            expressionValue = mult ? new Number(elementProp.v * mult) : new Number(elementProp.v);
            expressionValue.value = mult ? elementProp.v * mult : elementProp.v;
        } else {
        	len = elementProp.v.length;
	        expressionValue = Array.apply(null, {length: len});
	        arrValue = Array.apply(null, {length: len});
	        for (i = 0; i < len; i += 1) {
	            expressionValue[i] = arrValue[i] = mult ? elementProp.v[i] * mult : elementProp.v[i];
	        }
	        expressionValue.value = arrValue;
        }
        
        expressionValue.numKeys = elementProp.keyframes ? elementProp.keyframes.length : 0;
        expressionValue.key = function(pos) {
            if (!expressionValue.numKeys) {
                return 0;
            } else {
                return elementProp.keyframes[pos-1].t;
            }
        };
        expressionValue.valueAtTime = elementProp.getValueAtTime;
        expressionValue.propertyGroup = elementProp.propertyGroup;
        return expressionValue;
	}
}())
function SliderEffect(data,elem, dynamicProperties){
    this.p = PropertyFactory.getProp(elem,data.v,0,0,dynamicProperties);
}
function AngleEffect(data,elem, dynamicProperties){
    this.p = PropertyFactory.getProp(elem,data.v,0,0,dynamicProperties);
}
function ColorEffect(data,elem, dynamicProperties){
    this.p = PropertyFactory.getProp(elem,data.v,1,0,dynamicProperties);
}
function PointEffect(data,elem, dynamicProperties){
    this.p = PropertyFactory.getProp(elem,data.v,1,0,dynamicProperties);
}
function LayerIndexEffect(data,elem, dynamicProperties){
    this.p = PropertyFactory.getProp(elem,data.v,0,0,dynamicProperties);
}
function MaskIndexEffect(data,elem, dynamicProperties){
    this.p = PropertyFactory.getProp(elem,data.v,0,0,dynamicProperties);
}
function CheckboxEffect(data,elem, dynamicProperties){
    this.p = PropertyFactory.getProp(elem,data.v,0,0,dynamicProperties);
}
function NoValueEffect(){
    this.p = {};
}
function EffectsManager(data,element,dynamicProperties){
    var effects = data.ef;
    this.effectElements = [];
    var i,len = effects.length;
    var effectItem;
    for(i=0;i<len;i++) {
        effectItem = new GroupEffect(effects[i],element,dynamicProperties);
        this.effectElements.push(effectItem);
    }
}

function GroupEffect(data,element,dynamicProperties){
    this.dynamicProperties = [];
    this.init(data,element,this.dynamicProperties);
    if(this.dynamicProperties.length){
        dynamicProperties.push(this);
    }
}

GroupEffect.prototype.getValue = function(){
    this.mdf = false;
    var i, len = this.dynamicProperties.length;
    for(i=0;i<len;i+=1){
        this.dynamicProperties[i].getValue();
        this.mdf = this.dynamicProperties[i].mdf ? true : this.mdf;
    }
};

GroupEffect.prototype.init = function(data,element,dynamicProperties){
    this.data = data;
    this.mdf = false;
    this.effectElements = [];
    var i, len = this.data.ef.length;
    var eff, effects = this.data.ef;
    for(i=0;i<len;i+=1){
        switch(effects[i].ty){
            case 0:
                eff = new SliderEffect(effects[i],element,dynamicProperties);
                this.effectElements.push(eff);
                break;
            case 1:
                eff = new AngleEffect(effects[i],element,dynamicProperties);
                this.effectElements.push(eff);
                break;
            case 2:
                eff = new ColorEffect(effects[i],element,dynamicProperties);
                this.effectElements.push(eff);
                break;
            case 3:
                eff = new PointEffect(effects[i],element,dynamicProperties);
                this.effectElements.push(eff);
                break;
            case 4:
            case 7:
                eff = new CheckboxEffect(effects[i],element,dynamicProperties);
                this.effectElements.push(eff);
                break;
            case 10:
                eff = new LayerIndexEffect(effects[i],element,dynamicProperties);
                this.effectElements.push(eff);
                break;
            case 11:
                eff = new MaskIndexEffect(effects[i],element,dynamicProperties);
                this.effectElements.push(eff);
                break;
            case 5:
                eff = new EffectsManager(effects[i],element,dynamicProperties);
                this.effectElements.push(eff);
                break;
            case 6:
                eff = new NoValueEffect(effects[i],element,dynamicProperties);
                this.effectElements.push(eff);
                break;
        }
    }
};
    var bodymovinjs = {};

    function setLocationHref (href) {
        locationHref = href;
    }
    function play(animation){
        animationManager.play(animation);
    }

    function pause(animation) {
        animationManager.pause(animation);
    }

    function togglePause(animation) {
        animationManager.togglePause(animation);
    }

    function setSpeed(value, animation) {
        animationManager.setSpeed(value, animation);
    }

    function setDirection(value, animation) {
        animationManager.setDirection(value, animation);
    }

    function stop(animation) {
        animationManager.stop(animation);
    }

    function moveFrame(value) {
        animationManager.moveFrame(value);
    }

    function searchAnimations() {
        if (standalone === true) {
            animationManager.searchAnimations(animationData, standalone, renderer);
        } else {
            animationManager.searchAnimations();
        }
    }

    function registerAnimation(elem) {
        return animationManager.registerAnimation(elem);
    }

    function resize() {
        animationManager.resize();
    }

    function start() {
        animationManager.start();
    }

    function goToAndStop(val, isFrame, animation) {
        animationManager.goToAndStop(val, isFrame, animation);
    }

    function setSubframeRendering(flag) {
        subframeEnabled = flag;
    }

    function loadAnimation(params) {
        if (standalone === true) {
            params.animationData = JSON.parse(animationData);
        }
        return animationManager.loadAnimation(params);
    }

    function destroy(animation) {
        return animationManager.destroy(animation);
    }

    function setQuality(value) {
        if (typeof value === 'string') {
            switch (value) {
                case 'high':
                    defaultCurveSegments = 200;
                    break;
                case 'medium':
                    defaultCurveSegments = 50;
                    break;
                case 'low':
                    defaultCurveSegments = 10;
                    break;
            }
        } else if (!isNaN(value) && value > 1) {
            defaultCurveSegments = value;
        }
        if (defaultCurveSegments >= 50) {
            roundValues(false);
        } else {
            roundValues(true);
        }
    }

    function inBrowser() {
        return typeof navigator !== 'undefined';
    }

    function installPlugin(type, plugin) {
        if (type === 'expressions') {
            expressionsPlugin = plugin;
        }
    }

    function getFactory(name) {
        switch (name) {
            case "propertyFactory":
                return PropertyFactory;
            case "shapePropertyFactory":
                return ShapePropertyFactory;
            case "matrix":
                return Matrix;
        }
    }
    bodymovinjs.play = play;
    bodymovinjs.pause = pause;
    bodymovinjs.setLocationHref = setLocationHref;
    bodymovinjs.togglePause = togglePause;
    bodymovinjs.setSpeed = setSpeed;
    bodymovinjs.setDirection = setDirection;
    bodymovinjs.stop = stop;
    bodymovinjs.moveFrame = moveFrame;
    bodymovinjs.searchAnimations = searchAnimations;
    bodymovinjs.registerAnimation = registerAnimation;
    bodymovinjs.loadAnimation = loadAnimation;
    bodymovinjs.setSubframeRendering = setSubframeRendering;
    bodymovinjs.resize = resize;
    bodymovinjs.start = start;
    bodymovinjs.goToAndStop = goToAndStop;
    bodymovinjs.destroy = destroy;
    bodymovinjs.setQuality = setQuality;
    bodymovinjs.inBrowser = inBrowser;
    bodymovinjs.installPlugin = installPlugin;
    bodymovinjs.__getFactory = getFactory;
    bodymovinjs.version = '4.13.0';

    function checkReady() {
        if (document.readyState === "complete") {
            clearInterval(readyStateCheckInterval);
            searchAnimations();
        }
    }

    function getQueryVariable(variable) {
        var vars = queryString.split('&');
        for (var i = 0; i < vars.length; i++) {
            var pair = vars[i].split('=');
            if (decodeURIComponent(pair[0]) == variable) {
                return decodeURIComponent(pair[1]);
            }
        }
    }
    var standalone = '__[STANDALONE]__';
    var animationData = '__[ANIMATIONDATA]__';
    var renderer = '';
    if (standalone) {
        var scripts = document.getElementsByTagName('script');
        var index = scripts.length - 1;
        var myScript = scripts[index] || {
            src: ''
        };
        var queryString = myScript.src.replace(/^[^\?]+\??/, '');
        renderer = getQueryVariable('renderer');
    }
    var readyStateCheckInterval = setInterval(checkReady, 100);
    return bodymovinjs;
}));

/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export initialState */
/* unused harmony export ActionTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_by_react_utils__ = __webpack_require__(59);
var _createReducer;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var initialState={reset:false,dock:false,nofooter:false};var ActionTypes={RESET_SEARCH:'RESET_SEARCH',LAYOUT:'LAYOUT'};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_by_react_utils__["a" /* createReducer */])(initialState,(_createReducer={},_defineProperty(_createReducer,ActionTypes.RESET_SEARCH,function(state){return Object.assign({},state,{reset:true});}),_defineProperty(_createReducer,ActionTypes.LAYOUT,function(state,_ref){var dock=_ref.dock,nofooter=_ref.nofooter;return Object.assign({},state,{dock:dock,nofooter:nofooter});}),_createReducer)));

/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Layout___ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Pages___ = __webpack_require__(584);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Auth=function(_Component){_inherits(Auth,_Component);function Auth(){_classCallCheck(this,Auth);return _possibleConstructorReturn(this,(Auth.__proto__||Object.getPrototypeOf(Auth)).apply(this,arguments));}_createClass(Auth,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Layout___["a" /* AuthLayout */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["f" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{exact:true,path:'/login',component:__WEBPACK_IMPORTED_MODULE_4__Pages___["c" /* Login */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{exact:true,path:'/forgot-password',component:__WEBPACK_IMPORTED_MODULE_4__Pages___["b" /* ForgotPassword */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{path:'/reset-password',component:__WEBPACK_IMPORTED_MODULE_4__Pages___["a" /* EditPassword */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{component:__WEBPACK_IMPORTED_MODULE_4__Pages___["c" /* Login */]})));}}]);return Auth;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* withRouter */])(Auth));

/***/ }),
/* 342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Header__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Footer__ = __webpack_require__(581);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var children=_ref.children;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Header__["a" /* default */],null),children,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Footer__["a" /* default */],null));});

/***/ }),
/* 343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hoc_withResize__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__HeaderDesktop__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__HeaderMobile__ = __webpack_require__(580);
var Header=function Header(_ref){var viewport=_ref.viewport;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'app-header '+__WEBPACK_IMPORTED_MODULE_1__styles__["_77" /* appHeader */]},viewport.isMobile?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__HeaderMobile__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__HeaderDesktop__["a" /* default */],null));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__hoc_withResize__["a" /* withResize */])(Header,{mobile:1224}));

/***/ }),
/* 344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Abs; });
var Abs={position:'absolute',top:'50%',left:'50%',zIndex:10,transform:'translateX(-50%) translateY(-50%)'};

/***/ }),
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return appLoader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return appHeader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return appFooter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return appBody; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_chirashi__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_emotion__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2____ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core__ = __webpack_require__(17);
var _mediaMinWidth;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}// LOADER
var appLoader=function appLoader(transition){return Object(__WEBPACK_IMPORTED_MODULE_1_emotion__["a" /* css */])({position:'fixed',top:0,left:0,width:'100%',height:'100%',background:'#FFFFFF',textAlign:'center',zIndex:2,opacity:transition?0:1,transition:'opacity 400ms ease','.shape':{display:'bloSubtitleck',margin:'2rem auto','stop':{stopColor:'#000000'}},'.loader--inner':Object.assign({},__WEBPACK_IMPORTED_MODULE_2____["a" /* Abs */]),'p':Object.assign({},__WEBPACK_IMPORTED_MODULE_2____["_55" /* Subtitle */],{lineHeight:1,margin:0})});};//HEADER
var appHeader=Object(__WEBPACK_IMPORTED_MODULE_1_emotion__["a" /* css */])({position:'fixed',top:'0px',left:'0px',width:'100%',height:'60px',lineHeight:'60px',zIndex:4,background:'white','@media (min-width: 1024px)':{height:'80px',lineHeight:'80px'},'.header':{position:'relative',zIndex:3,background:'white',height:'60px',borderBottom:'1px solid '+__WEBPACK_IMPORTED_MODULE_2____["x" /* Colors */].extraLightGrey,'@media (min-width: 1024px)':{height:'80px'}}});//FOOTER
var appFooter=Object(__WEBPACK_IMPORTED_MODULE_1_emotion__["a" /* css */])({position:'relative',width:'100%',background:'#000000',zIndex:2,padding:'2rem 0','.counter-logo':{width:'91px',marginRight:'20px'},'.counter-wrap':{display:'flex',alignItems:'center','@media (max-width: 1023px)':{marginLeft:'1rem',marginBottom:'1rem'},'@media (min-width: 1024px)':{position:'absolute',left:'30px',top:0}},'.counter':{display:'block',color:''+__WEBPACK_IMPORTED_MODULE_2____["x" /* Colors */].white,fontWeight:'bold',fontSize:'1.25rem',fontFamily:'Interstate-Bold-Condensed','span':{marginRight:'4px',width:'1.25rem',height:'25px',display:'inline-flex',alignItems:'center',justifyContent:'center',backgroundColor:'#353535',lineHeight:1.3,borderRadius:'4px'}},'&:after':{content:"''",position:'absolute',top:0,left:1,width:'calc(100% - 4px)',height:'calc(100% - 2px)',zIndex:1,border:'1px solid '+__WEBPACK_IMPORTED_MODULE_2____["x" /* Colors */].darkGrey},'@media (min-width: 1024px)':{height:'80px',lineHeight:'80px',padding:'0'},'& > ul ':{display:'flex',justifyContent:'center',flexWrap:'wrap',zIndex:2,position:'relative','li':{margin:'0px 1rem',maxWidth:'100%',flexBasis:'100%','@media (min-width: 1024px)':{maxWidth:'auto',flexBasis:'auto'}},'a':Object.assign({},__WEBPACK_IMPORTED_MODULE_2____["_0" /* Link */],{transition:'all 200ms ease',fontSize:'0.75rem',color:__WEBPACK_IMPORTED_MODULE_2____["x" /* Colors */].mediumGrey,padding:'1rem 0',display:'block',position:'relative','@media (min-width: 1024px)':(_mediaMinWidth={// display: 'inline',
padding:0,height:80,lineHeight:'80px'},_defineProperty(_mediaMinWidth,'padding','0px 1rem'),_defineProperty(_mediaMinWidth,'&:after',{content:'""',position:'absolute',left:0,bottom:0,height:4,width:'100%',background:'white',transform:'scaleX(0)',transformOrigin:'center left',transition:'all 400ms '+__WEBPACK_IMPORTED_MODULE_4__core__["b" /* Easings */].customEase}),_mediaMinWidth),'&:hover, &.active':{color:'white'},'&.active':{'&:after':{transform:'scaleX(1)'}}})},'body.nofooter &':{display:'none'}});//BODY
var appBody=Object(__WEBPACK_IMPORTED_MODULE_1_emotion__["a" /* css */])({width:'100%',minHeight:'calc(100vh - 60px)',zIndex:1,padding:'60px 0px 0px','@media (min-width: 1024px)':{minHeight:'calc(100vh - 80px)',padding:'80px 0px 0px'}});

/***/ }),
/* 346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emotion_memoize__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__emotion_unitless__ = __webpack_require__(348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__emotion_hash__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__emotion_stylis__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_stylis_rule_sheet__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_stylis_rule_sheet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_stylis_rule_sheet__);






var hyphenateRegex = /[A-Z]|^ms/g;
var processStyleName = Object(__WEBPACK_IMPORTED_MODULE_0__emotion_memoize__["a" /* default */])(function (styleName) {
  return styleName.replace(hyphenateRegex, '-$&').toLowerCase();
});
var processStyleValue = function processStyleValue(key, value) {
  if (value == null || typeof value === 'boolean') {
    return '';
  }

  if (__WEBPACK_IMPORTED_MODULE_1__emotion_unitless__["a" /* default */][key] !== 1 && key.charCodeAt(1) !== 45 && // custom properties
  !isNaN(value) && value !== 0) {
    return value + 'px';
  }

  return value;
};

if (false) {
  var contentValuePattern = /(attr|calc|counters?|url)\(/;
  var contentValues = ['normal', 'none', 'counter', 'open-quote', 'close-quote', 'no-open-quote', 'no-close-quote', 'initial', 'inherit', 'unset'];
  var oldProcessStyleValue = processStyleValue;

  processStyleValue = function processStyleValue(key, value) {
    if (key === 'content') {
      if (typeof value !== 'string' || contentValues.indexOf(value) === -1 && !contentValuePattern.test(value) && (value.charAt(0) !== value.charAt(value.length - 1) || value.charAt(0) !== '"' && value.charAt(0) !== "'")) {
        console.error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + value + "\"'`");
      }
    }

    return oldProcessStyleValue(key, value);
  };
}

var classnames = function classnames(args) {
  var len = args.length;
  var i = 0;
  var cls = '';

  for (; i < len; i++) {
    var arg = args[i];
    if (arg == null) continue;
    var toAdd = void 0;

    switch (typeof arg) {
      case 'boolean':
        break;

      case 'function':
        if (false) {
          console.error('Passing functions to cx is deprecated and will be removed in the next major version of Emotion.\n' + 'Please call the function before passing it to cx.');
        }

        toAdd = classnames([arg()]);
        break;

      case 'object':
        {
          if (Array.isArray(arg)) {
            toAdd = classnames(arg);
          } else {
            toAdd = '';

            for (var k in arg) {
              if (arg[k] && k) {
                toAdd && (toAdd += ' ');
                toAdd += k;
              }
            }
          }

          break;
        }

      default:
        {
          toAdd = arg;
        }
    }

    if (toAdd) {
      cls && (cls += ' ');
      cls += toAdd;
    }
  }

  return cls;
};
var isBrowser = typeof document !== 'undefined';

/*

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance
- 'polyfills' on server side

// usage

import StyleSheet from 'glamor/lib/sheet'
let styleSheet = new StyleSheet()

styleSheet.inject()
- 'injects' the stylesheet into the page (or into memory if on server)

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/
// $FlowFixMe
function sheetForTag(tag) {
  if (tag.sheet) {
    // $FlowFixMe
    return tag.sheet;
  } // this weirdness brought to you by firefox


  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      // $FlowFixMe
      return document.styleSheets[i];
    }
  }
}

function makeStyleTag(opts) {
  var tag = document.createElement('style');
  tag.setAttribute('data-emotion', opts.key || '');

  if (opts.nonce !== undefined) {
    tag.setAttribute('nonce', opts.nonce);
  }

  tag.appendChild(document.createTextNode('')) // $FlowFixMe
  ;
  (opts.container !== undefined ? opts.container : document.head).appendChild(tag);
  return tag;
}

var StyleSheet =
/*#__PURE__*/
function () {
  function StyleSheet(options) {
    this.isSpeedy = "production" === 'production'; // the big drawback here is that the css won't be editable in devtools

    this.tags = [];
    this.ctr = 0;
    this.opts = options;
  }

  var _proto = StyleSheet.prototype;

  _proto.inject = function inject() {
    if (this.injected) {
      throw new Error('already injected!');
    }

    this.tags[0] = makeStyleTag(this.opts);
    this.injected = true;
  };

  _proto.speedy = function speedy(bool) {
    if (this.ctr !== 0) {
      // cannot change speedy mode after inserting any rule to sheet. Either call speedy(${bool}) earlier in your app, or call flush() before speedy(${bool})
      throw new Error("cannot change speedy now");
    }

    this.isSpeedy = !!bool;
  };

  _proto.insert = function insert(rule, sourceMap) {
    // this is the ultrafast version, works across browsers
    if (this.isSpeedy) {
      var tag = this.tags[this.tags.length - 1];
      var sheet = sheetForTag(tag);

      try {
        sheet.insertRule(rule, sheet.cssRules.length);
      } catch (e) {
        if (false) {
          console.warn('illegal rule', rule); // eslint-disable-line no-console
        }
      }
    } else {
      var _tag = makeStyleTag(this.opts);

      this.tags.push(_tag);

      _tag.appendChild(document.createTextNode(rule + (sourceMap || '')));
    }

    this.ctr++;

    if (this.ctr % 65000 === 0) {
      this.tags.push(makeStyleTag(this.opts));
    }
  };

  _proto.flush = function flush() {
    // $FlowFixMe
    this.tags.forEach(function (tag) {
      return tag.parentNode.removeChild(tag);
    });
    this.tags = [];
    this.ctr = 0; // todo - look for remnants in document.styleSheets

    this.injected = false;
  };

  return StyleSheet;
}();

function createEmotion(context, options) {
  if (context.__SECRET_EMOTION__ !== undefined) {
    return context.__SECRET_EMOTION__;
  }

  if (options === undefined) options = {};
  var key = options.key || 'css';

  if (false) {
    if (/[^a-z-]/.test(key)) {
      throw new Error("Emotion key must only contain lower case alphabetical characters and - but \"" + key + "\" was passed");
    }
  }

  var current;

  function insertRule(rule) {
    current += rule;

    if (isBrowser) {
      sheet.insert(rule, currentSourceMap);
    }
  }

  var insertionPlugin = __WEBPACK_IMPORTED_MODULE_4_stylis_rule_sheet___default()(insertRule);
  var stylisOptions;

  if (options.prefix !== undefined) {
    stylisOptions = {
      prefix: options.prefix
    };
  }

  var caches = {
    registered: {},
    inserted: {},
    nonce: options.nonce,
    key: key
  };
  var sheet = new StyleSheet(options);

  if (isBrowser) {
    // 🚀
    sheet.inject();
  }

  var stylis = new __WEBPACK_IMPORTED_MODULE_3__emotion_stylis__["a" /* default */](stylisOptions);
  stylis.use(options.stylisPlugins)(insertionPlugin);
  var currentSourceMap = '';

  function handleInterpolation(interpolation, couldBeSelectorInterpolation) {
    if (interpolation == null) {
      return '';
    }

    switch (typeof interpolation) {
      case 'boolean':
        return '';

      case 'function':
        if (interpolation.__emotion_styles !== undefined) {
          var selector = interpolation.toString();

          if (selector === 'NO_COMPONENT_SELECTOR' && "production" !== 'production') {
            throw new Error('Component selectors can only be used in conjunction with babel-plugin-emotion.');
          }

          return selector;
        }

        if (this === undefined && "production" !== 'production') {
          console.error('Interpolating functions in css calls is deprecated and will be removed in the next major version of Emotion.\n' + 'If you want to have a css call based on props, create a function that returns a css call like this\n' + 'let dynamicStyle = (props) => css`color: ${props.color}`\n' + 'It can be called directly with props or interpolated in a styled call like this\n' + "let SomeComponent = styled('div')`${dynamicStyle}`");
        }

        return handleInterpolation.call(this, this === undefined ? interpolation() : // $FlowFixMe
        interpolation(this.mergedProps, this.context), couldBeSelectorInterpolation);

      case 'object':
        return createStringFromObject.call(this, interpolation);

      default:
        var cached = caches.registered[interpolation];
        return couldBeSelectorInterpolation === false && cached !== undefined ? cached : interpolation;
    }
  }

  var objectToStringCache = new WeakMap();

  function createStringFromObject(obj) {
    if (objectToStringCache.has(obj)) {
      // $FlowFixMe
      return objectToStringCache.get(obj);
    }

    var string = '';

    if (Array.isArray(obj)) {
      obj.forEach(function (interpolation) {
        string += handleInterpolation.call(this, interpolation, false);
      }, this);
    } else {
      Object.keys(obj).forEach(function (key) {
        if (typeof obj[key] !== 'object') {
          if (caches.registered[obj[key]] !== undefined) {
            string += key + "{" + caches.registered[obj[key]] + "}";
          } else {
            string += processStyleName(key) + ":" + processStyleValue(key, obj[key]) + ";";
          }
        } else {
          if (key === 'NO_COMPONENT_SELECTOR' && "production" !== 'production') {
            throw new Error('Component selectors can only be used in conjunction with babel-plugin-emotion.');
          }

          if (Array.isArray(obj[key]) && typeof obj[key][0] === 'string' && caches.registered[obj[key][0]] === undefined) {
            obj[key].forEach(function (value) {
              string += processStyleName(key) + ":" + processStyleValue(key, value) + ";";
            });
          } else {
            string += key + "{" + handleInterpolation.call(this, obj[key], false) + "}";
          }
        }
      }, this);
    }

    objectToStringCache.set(obj, string);
    return string;
  }

  var name;
  var stylesWithLabel;
  var labelPattern = /label:\s*([^\s;\n{]+)\s*;/g;

  var createClassName = function createClassName(styles, identifierName) {
    return Object(__WEBPACK_IMPORTED_MODULE_2__emotion_hash__["a" /* default */])(styles + identifierName) + identifierName;
  };

  if (false) {
    var oldCreateClassName = createClassName;
    var sourceMappingUrlPattern = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//g;

    createClassName = function createClassName(styles, identifierName) {
      return oldCreateClassName(styles.replace(sourceMappingUrlPattern, function (sourceMap) {
        currentSourceMap = sourceMap;
        return '';
      }), identifierName);
    };
  }

  var createStyles = function createStyles(strings) {
    var stringMode = true;
    var styles = '';
    var identifierName = '';

    if (strings == null || strings.raw === undefined) {
      stringMode = false;
      styles += handleInterpolation.call(this, strings, false);
    } else {
      styles += strings[0];
    }

    for (var _len = arguments.length, interpolations = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      interpolations[_key - 1] = arguments[_key];
    }

    interpolations.forEach(function (interpolation, i) {
      styles += handleInterpolation.call(this, interpolation, styles.charCodeAt(styles.length - 1) === 46 // .
      );

      if (stringMode === true && strings[i + 1] !== undefined) {
        styles += strings[i + 1];
      }
    }, this);
    stylesWithLabel = styles;
    styles = styles.replace(labelPattern, function (match, p1) {
      identifierName += "-" + p1;
      return '';
    });
    name = createClassName(styles, identifierName);
    return styles;
  };

  if (false) {
    var oldStylis = stylis;

    stylis = function stylis(selector, styles) {
      oldStylis(selector, styles);
      currentSourceMap = '';
    };
  }

  function insert(scope, styles) {
    if (caches.inserted[name] === undefined) {
      current = '';
      stylis(scope, styles);
      caches.inserted[name] = current;
    }
  }

  var css = function css() {
    var styles = createStyles.apply(this, arguments);
    var selector = key + "-" + name;

    if (caches.registered[selector] === undefined) {
      caches.registered[selector] = stylesWithLabel;
    }

    insert("." + selector, styles);
    return selector;
  };

  var keyframes = function keyframes() {
    var styles = createStyles.apply(this, arguments);
    var animation = "animation-" + name;
    insert('', "@keyframes " + animation + "{" + styles + "}");
    return animation;
  };

  var injectGlobal = function injectGlobal() {
    var styles = createStyles.apply(this, arguments);
    insert('', styles);
  };

  function getRegisteredStyles(registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function (className) {
      if (caches.registered[className] !== undefined) {
        registeredStyles.push(className);
      } else {
        rawClassName += className + " ";
      }
    });
    return rawClassName;
  }

  function merge(className, sourceMap) {
    var registeredStyles = [];
    var rawClassName = getRegisteredStyles(registeredStyles, className);

    if (registeredStyles.length < 2) {
      return className;
    }

    return rawClassName + css(registeredStyles, sourceMap);
  }

  function cx() {
    for (var _len2 = arguments.length, classNames = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      classNames[_key2] = arguments[_key2];
    }

    return merge(classnames(classNames));
  }

  function hydrateSingleId(id) {
    caches.inserted[id] = true;
  }

  function hydrate(ids) {
    ids.forEach(hydrateSingleId);
  }

  function flush() {
    if (isBrowser) {
      sheet.flush();
      sheet.inject();
    }

    caches.inserted = {};
    caches.registered = {};
  }

  if (isBrowser) {
    var chunks = document.querySelectorAll("[data-emotion-" + key + "]");
    Array.prototype.forEach.call(chunks, function (node) {
      // $FlowFixMe
      sheet.tags[0].parentNode.insertBefore(node, sheet.tags[0]); // $FlowFixMe

      node.getAttribute("data-emotion-" + key).split(' ').forEach(hydrateSingleId);
    });
  }

  var emotion = {
    flush: flush,
    hydrate: hydrate,
    cx: cx,
    merge: merge,
    getRegisteredStyles: getRegisteredStyles,
    injectGlobal: injectGlobal,
    keyframes: keyframes,
    css: css,
    sheet: sheet,
    caches: caches
  };
  context.__SECRET_EMOTION__ = emotion;
  return emotion;
}

/* harmony default export */ __webpack_exports__["a"] = (createEmotion);


/***/ }),
/* 347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function memoize(fn) {
  var cache = {};
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

/* harmony default export */ __webpack_exports__["a"] = (memoize);


/***/ }),
/* 348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

/* harmony default export */ __webpack_exports__["a"] = (unitlessKeys);


/***/ }),
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint-disable */
// murmurhash2 via https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
function murmurhash2_32_gc(str) {
  var l = str.length,
      h = l ^ l,
      i = 0,
      k;

  while (l >= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    k ^= k >>> 24;
    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
    l -= 4;
    ++i;
  }

  switch (l) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;

    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;

    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
  }

  h ^= h >>> 13;
  h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
  h ^= h >>> 15;
  return (h >>> 0).toString(36);
}

/* harmony default export */ __webpack_exports__["a"] = (murmurhash2_32_gc);


/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function stylis_min (W) {
  function M(d, c, e, h, a) {
    for (var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = '', p = '', F = '', G = '', C; l < B;) {
      g = e.charCodeAt(l);
      l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);

      if (0 === b + n + v + m) {
        if (l === J && (0 < r && (f = f.replace(N, '')), 0 < f.trim().length)) {
          switch (g) {
            case 32:
            case 9:
            case 59:
            case 13:
            case 10:
              break;

            default:
              f += e.charAt(l);
          }

          g = 59;
        }

        switch (g) {
          case 123:
            f = f.trim();
            q = f.charCodeAt(0);
            k = 1;

            for (t = ++l; l < B;) {
              switch (g = e.charCodeAt(l)) {
                case 123:
                  k++;
                  break;

                case 125:
                  k--;
                  break;

                case 47:
                  switch (g = e.charCodeAt(l + 1)) {
                    case 42:
                    case 47:
                      a: {
                        for (u = l + 1; u < J; ++u) {
                          switch (e.charCodeAt(u)) {
                            case 47:
                              if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                l = u + 1;
                                break a;
                              }

                              break;

                            case 10:
                              if (47 === g) {
                                l = u + 1;
                                break a;
                              }

                          }
                        }

                        l = u;
                      }

                  }

                  break;

                case 91:
                  g++;

                case 40:
                  g++;

                case 34:
                case 39:
                  for (; l++ < J && e.charCodeAt(l) !== g;) {
                  }

              }

              if (0 === k) break;
              l++;
            }

            k = e.substring(t, l);
            0 === q && (q = (f = f.replace(ca, '').trim()).charCodeAt(0));

            switch (q) {
              case 64:
                0 < r && (f = f.replace(N, ''));
                g = f.charCodeAt(1);

                switch (g) {
                  case 100:
                  case 109:
                  case 115:
                  case 45:
                    r = c;
                    break;

                  default:
                    r = O;
                }

                k = M(c, r, k, g, a + 1);
                t = k.length;
                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(''), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ''));
                if (0 < t) switch (g) {
                  case 115:
                    f = f.replace(da, ea);

                  case 100:
                  case 109:
                  case 45:
                    k = f + '{' + k + '}';
                    break;

                  case 107:
                    f = f.replace(fa, '$1 $2');
                    k = f + '{' + k + '}';
                    k = 1 === w || 2 === w && L('@' + k, 3) ? '@-webkit-' + k + '@' + k : '@' + k;
                    break;

                  default:
                    k = f + k, 112 === h && (k = (p += k, ''));
                } else k = '';
                break;

              default:
                k = M(c, X(c, f, I), k, h, a + 1);
            }

            F += k;
            k = I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
            break;

          case 125:
          case 59:
            f = (0 < r ? f.replace(N, '') : f).trim();
            if (1 < (t = f.length)) switch (0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(' ', ':')).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = '\x00\x00'), q = f.charCodeAt(0), g = f.charCodeAt(1), q) {
              case 0:
                break;

              case 64:
                if (105 === g || 99 === g) {
                  G += f + e.charAt(l);
                  break;
                }

              default:
                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
            }
            I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
        }
      }

      switch (g) {
        case 13:
        case 10:
          47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += '\x00');
          0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
          z = 1;
          D++;
          break;

        case 59:
        case 125:
          if (0 === b + n + v + m) {
            z++;
            break;
          }

        default:
          z++;
          y = e.charAt(l);

          switch (g) {
            case 9:
            case 32:
              if (0 === n + m + b) switch (x) {
                case 44:
                case 58:
                case 9:
                case 32:
                  y = '';
                  break;

                default:
                  32 !== g && (y = ' ');
              }
              break;

            case 0:
              y = '\\0';
              break;

            case 12:
              y = '\\f';
              break;

            case 11:
              y = '\\v';
              break;

            case 38:
              0 === n + b + m && (r = I = 1, y = '\f' + y);
              break;

            case 108:
              if (0 === n + b + m + E && 0 < u) switch (l - u) {
                case 2:
                  112 === x && 58 === e.charCodeAt(l - 3) && (E = x);

                case 8:
                  111 === K && (E = K);
              }
              break;

            case 58:
              0 === n + b + m && (u = l);
              break;

            case 44:
              0 === b + v + n + m && (r = 1, y += '\r');
              break;

            case 34:
            case 39:
              0 === b && (n = n === g ? 0 : 0 === n ? g : n);
              break;

            case 91:
              0 === n + b + v && m++;
              break;

            case 93:
              0 === n + b + v && m--;
              break;

            case 41:
              0 === n + b + m && v--;
              break;

            case 40:
              if (0 === n + b + m) {
                if (0 === q) switch (2 * x + 3 * K) {
                  case 533:
                    break;

                  default:
                    q = 1;
                }
                v++;
              }

              break;

            case 64:
              0 === b + v + n + m + u + k && (k = 1);
              break;

            case 42:
            case 47:
              if (!(0 < n + m + v)) switch (b) {
                case 0:
                  switch (2 * g + 3 * e.charCodeAt(l + 1)) {
                    case 235:
                      b = 47;
                      break;

                    case 220:
                      t = l, b = 42;
                  }

                  break;

                case 42:
                  47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = '', b = 0);
              }
          }

          0 === b && (f += y);
      }

      K = x;
      x = g;
      l++;
    }

    t = p.length;

    if (0 < t) {
      r = c;
      if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
      p = r.join(',') + '{' + p + '}';

      if (0 !== w * E) {
        2 !== w || L(p, 2) || (E = 0);

        switch (E) {
          case 111:
            p = p.replace(ha, ':-moz-$1') + p;
            break;

          case 112:
            p = p.replace(Q, '::-webkit-input-$1') + p.replace(Q, '::-moz-$1') + p.replace(Q, ':-ms-input-$1') + p;
        }

        E = 0;
      }
    }

    return G + p + F;
  }

  function X(d, c, e) {
    var h = c.trim().split(ia);
    c = h;
    var a = h.length,
        m = d.length;

    switch (m) {
      case 0:
      case 1:
        var b = 0;

        for (d = 0 === m ? '' : d[0] + ' '; b < a; ++b) {
          c[b] = Z(d, c[b], e, m).trim();
        }

        break;

      default:
        var v = b = 0;

        for (c = []; b < a; ++b) {
          for (var n = 0; n < m; ++n) {
            c[v++] = Z(d[n] + ' ', h[b], e, m).trim();
          }
        }

    }

    return c;
  }

  function Z(d, c, e) {
    var h = c.charCodeAt(0);
    33 > h && (h = (c = c.trim()).charCodeAt(0));

    switch (h) {
      case 38:
        return c.replace(F, '$1' + d.trim());

      case 58:
        return d.trim() + c.replace(F, '$1' + d.trim());

      default:
        if (0 < 1 * e && 0 < c.indexOf('\f')) return c.replace(F, (58 === d.charCodeAt(0) ? '' : '$1') + d.trim());
    }

    return d + c;
  }

  function P(d, c, e, h) {
    var a = d + ';',
        m = 2 * c + 3 * e + 4 * h;

    if (944 === m) {
      d = a.indexOf(':', 9) + 1;
      var b = a.substring(d, a.length - 1).trim();
      b = a.substring(0, d).trim() + b + ';';
      return 1 === w || 2 === w && L(b, 1) ? '-webkit-' + b + b : b;
    }

    if (0 === w || 2 === w && !L(a, 1)) return a;

    switch (m) {
      case 1015:
        return 97 === a.charCodeAt(10) ? '-webkit-' + a + a : a;

      case 951:
        return 116 === a.charCodeAt(3) ? '-webkit-' + a + a : a;

      case 963:
        return 110 === a.charCodeAt(5) ? '-webkit-' + a + a : a;

      case 1009:
        if (100 !== a.charCodeAt(4)) break;

      case 969:
      case 942:
        return '-webkit-' + a + a;

      case 978:
        return '-webkit-' + a + '-moz-' + a + a;

      case 1019:
      case 983:
        return '-webkit-' + a + '-moz-' + a + '-ms-' + a + a;

      case 883:
        if (45 === a.charCodeAt(8)) return '-webkit-' + a + a;
        if (0 < a.indexOf('image-set(', 11)) return a.replace(ja, '$1-webkit-$2') + a;
        break;

      case 932:
        if (45 === a.charCodeAt(4)) switch (a.charCodeAt(5)) {
          case 103:
            return '-webkit-box-' + a.replace('-grow', '') + '-webkit-' + a + '-ms-' + a.replace('grow', 'positive') + a;

          case 115:
            return '-webkit-' + a + '-ms-' + a.replace('shrink', 'negative') + a;

          case 98:
            return '-webkit-' + a + '-ms-' + a.replace('basis', 'preferred-size') + a;
        }
        return '-webkit-' + a + '-ms-' + a + a;

      case 964:
        return '-webkit-' + a + '-ms-flex-' + a + a;

      case 1023:
        if (99 !== a.charCodeAt(8)) break;
        b = a.substring(a.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
        return '-webkit-box-pack' + b + '-webkit-' + a + '-ms-flex-pack' + b + a;

      case 1005:
        return ka.test(a) ? a.replace(aa, ':-webkit-') + a.replace(aa, ':-moz-') + a : a;

      case 1e3:
        b = a.substring(13).trim();
        c = b.indexOf('-') + 1;

        switch (b.charCodeAt(0) + b.charCodeAt(c)) {
          case 226:
            b = a.replace(G, 'tb');
            break;

          case 232:
            b = a.replace(G, 'tb-rl');
            break;

          case 220:
            b = a.replace(G, 'lr');
            break;

          default:
            return a;
        }

        return '-webkit-' + a + '-ms-' + b + a;

      case 1017:
        if (-1 === a.indexOf('sticky', 9)) break;

      case 975:
        c = (a = d).length - 10;
        b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(':', 7) + 1).trim();

        switch (m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)) {
          case 203:
            if (111 > b.charCodeAt(8)) break;

          case 115:
            a = a.replace(b, '-webkit-' + b) + ';' + a;
            break;

          case 207:
          case 102:
            a = a.replace(b, '-webkit-' + (102 < m ? 'inline-' : '') + 'box') + ';' + a.replace(b, '-webkit-' + b) + ';' + a.replace(b, '-ms-' + b + 'box') + ';' + a;
        }

        return a + ';';

      case 938:
        if (45 === a.charCodeAt(5)) switch (a.charCodeAt(6)) {
          case 105:
            return b = a.replace('-items', ''), '-webkit-' + a + '-webkit-box-' + b + '-ms-flex-' + b + a;

          case 115:
            return '-webkit-' + a + '-ms-flex-item-' + a.replace(ba, '') + a;

          default:
            return '-webkit-' + a + '-ms-flex-line-pack' + a.replace('align-content', '').replace(ba, '') + a;
        }
        break;

      case 973:
      case 989:
        if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;

      case 931:
      case 953:
        if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(':') + 1)).charCodeAt(0) ? P(d.replace('stretch', 'fill-available'), c, e, h).replace(':fill-available', ':stretch') : a.replace(b, '-webkit-' + b) + a.replace(b, '-moz-' + b.replace('fill-', '')) + a;
        break;

      case 962:
        if (a = '-webkit-' + a + (102 === a.charCodeAt(5) ? '-ms-' + a : '') + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf('transform', 10)) return a.substring(0, a.indexOf(';', 27) + 1).replace(ma, '$1-webkit-$2') + a;
    }

    return a;
  }

  function L(d, c) {
    var e = d.indexOf(1 === c ? ':' : '{'),
        h = d.substring(0, 3 !== c ? e : 10);
    e = d.substring(e + 1, d.length - 1);
    return R(2 !== c ? h : h.replace(na, '$1'), e, c);
  }

  function ea(d, c) {
    var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
    return e !== c + ';' ? e.replace(oa, ' or ($1)').substring(4) : '(' + c + ')';
  }

  function H(d, c, e, h, a, m, b, v, n, q) {
    for (var g = 0, x = c, w; g < A; ++g) {
      switch (w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)) {
        case void 0:
        case !1:
        case !0:
        case null:
          break;

        default:
          x = w;
      }
    }

    if (x !== c) return x;
  }

  function T(d) {
    switch (d) {
      case void 0:
      case null:
        A = S.length = 0;
        break;

      default:
        switch (d.constructor) {
          case Array:
            for (var c = 0, e = d.length; c < e; ++c) {
              T(d[c]);
            }

            break;

          case Function:
            S[A++] = d;
            break;

          case Boolean:
            Y = !!d | 0;
        }

    }

    return T;
  }

  function U(d) {
    d = d.prefix;
    void 0 !== d && (R = null, d ? 'function' !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
    return U;
  }

  function B(d, c) {
    var e = d;
    33 > e.charCodeAt(0) && (e = e.trim());
    V = e;
    e = [V];

    if (0 < A) {
      var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
      void 0 !== h && 'string' === typeof h && (c = h);
    }

    var a = M(O, e, c, 0, 0);
    0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
    V = '';
    E = 0;
    z = D = 1;
    return a;
  }

  var ca = /^\0+/g,
      N = /[\0\r\f]/g,
      aa = /: */g,
      ka = /zoo|gra/,
      ma = /([,: ])(transform)/g,
      ia = /,\r+?/g,
      F = /([\t\r\n ])*\f?&/g,
      fa = /@(k\w+)\s*(\S*)\s*/,
      Q = /::(place)/g,
      ha = /:(read-only)/g,
      G = /[svh]\w+-[tblr]{2}/,
      da = /\(\s*(.*)\s*\)/g,
      oa = /([\s\S]*?);/g,
      ba = /-self|flex-/g,
      na = /[^]*?(:[rp][el]a[\w-]+)[^]*/,
      la = /stretch|:\s*\w+\-(?:conte|avail)/,
      ja = /([^-])(image-set\()/,
      z = 1,
      D = 1,
      E = 0,
      w = 1,
      O = [],
      S = [],
      A = 0,
      R = null,
      Y = 0,
      V = '';
  B.use = T;
  B.set = U;
  void 0 !== W && U(W);
  return B;
}

/* harmony default export */ __webpack_exports__["a"] = (stylis_min);


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

(function (factory) {
	 true ? (module['exports'] = factory()) :
		typeof define === 'function' && define['amd'] ? define(factory()) :
			(window['stylisRuleSheet'] = factory())
}(function () {

	'use strict'

	return function (insertRule) {
		var delimiter = '/*|*/'
		var needle = delimiter+'}'

		function toSheet (block) {
			if (block)
				try {
					insertRule(block + '}')
				} catch (e) {}
		}

		return function ruleSheet (context, content, selectors, parents, line, column, length, ns, depth, at) {
			switch (context) {
				// property
				case 1:
					// @import
					if (depth === 0 && content.charCodeAt(0) === 64)
						return insertRule(content+';'), ''
					break
				// selector
				case 2:
					if (ns === 0)
						return content + delimiter
					break
				// at-rule
				case 3:
					switch (ns) {
						// @font-face, @page
						case 102:
						case 112:
							return insertRule(selectors[0]+content), ''
						default:
							return content + (at === 0 ? delimiter : '')
					}
				case -2:
					content.split(needle).forEach(toSheet)
			}
		}
	}
}))


/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return ButtonStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return LinkButtonStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ButtonCard; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ButtonReturnCard; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ButtonPDFCard; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return LinkButtonPush; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return ButtonWhite; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ButtonRouter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ButtonLoadMoreStyle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_emotion__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core__ = __webpack_require__(17);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}// Default Button 
var defaultButton=Object.assign({display:'inline-block',position:'relative',width:'100%',border:0},__WEBPACK_IMPORTED_MODULE_1____["_0" /* Link */],{height:60,background:__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].extraLightGrey,transition:'all 400ms ease',cursor:'pointer',margin:'2rem 0px','.btn--label':{transition:'all 400ms ease'},'&:hover':{background:'black','.btn--label':{color:'white'},'svg':{fill:'white'}}// Button Base -> With Load or not
});var ButtonStyle=function ButtonStyle(theme,isLoaded){var _btnLabel;return Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])(Object.assign({},defaultButton,{background:theme==='grey'?__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].extraLightGrey:__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].red,'.btn--label':(_btnLabel={opacity:isLoaded?0:1,transition:'opacity 200ms ease',lineHeight:'60px',color:theme==='grey'?'black':'white'},_defineProperty(_btnLabel,'transition','all 400ms ease'),_defineProperty(_btnLabel,'svg',{verticalAlign:'middle',marginRight:'1rem',transition:'fill 400ms ease'}),_btnLabel),'.btn--load':{position:'absolute',top:'50%',left:'50%',transform:'translate(-50%, -50%)',zIndex:10,opacity:isLoaded?1:0,transition:'opacity 200ms ease','stop':{stopColor:'#000000'}}}),{'&:hover':{'.btn--load':{'stop':{stopColor:'#ffffff'}}}});};// Link 
var LinkButtonStyle=Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])(Object.assign({},defaultButton,{lineHeight:'60px',color:'black','svg':{verticalAlign:'middle',marginRight:'1rem',transition:'fill 400ms ease'}}));/*
* Button Card -
* PDFButton
* BookmarkButton
*/var ButtonCard=function ButtonCard(big){return Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])({position:'relative',display:'block',background:__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].extraLightGrey,width:'60px',height:'60px',border:0,cursor:'pointer',textAlign:'center','@media (min-width: 1024px)':{width:big?'80px':'60px',height:big?'80px':'60px'},'& svg':{fill:__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].mediumGrey,transition:'all 200ms ease',verticalAlign:'middle',transform:'translateX(2px)'},'&:hover':{'& svg':{fill:'black'}}});};/*
Return Card 
*/var ButtonReturnCard=function ButtonReturnCard(big){return Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])({width:big?'80px':'60px',height:big?'80px':'60px',background:'none',border:0,cursor:'pointer','& svg':{fill:__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].mediumGrey,transition:'fill 200ms ease'},'&:hover':{'svg':{fill:'black'}}});};// PDF
var ButtonPDFCard=Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])({position:'relative','a.btn, button':{display:'block',lineHeight:'60px','@media (min-width: 1024px)':{// lineHeight: '80px', 
}}});// Push Button 
var LinkButtonPush=Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])(Object.assign({},__WEBPACK_IMPORTED_MODULE_1____["_0" /* Link */],{display:'inline-block',border:'1px solid '+__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].mediumGrey,padding:'1rem 4rem',color:__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].mediumGrey,position:'relative',transition:'all 200ms ease',zIndex:1,overflow:'hidden','&:hover':{color:'black',background:'white'}}));var ButtonWhite=Object.assign({},__WEBPACK_IMPORTED_MODULE_1____["_0" /* Link */],{background:'white',height:60,lineHeight:'60px','&:hover':{background:'black'}});var ButtonRouter=Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])({justifyContent:'center','li > a':Object.assign({},__WEBPACK_IMPORTED_MODULE_1____["_0" /* Link */],{display:'block',padding:'0px 1.5rem',height:60,lineHeight:'60px',background:__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].extraLightGrey,borderRight:'1px solid #FFF','span':{color:'black'},'svg':{verticalAlign:'text-bottom',marginRight:'0.5rem'},'&:hover':{background:__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].lightGrey},'&.active':{background:'black','span':{color:'white'},'svg':{fill:'white'}}})});// Buton load More
var ButtonLoadMoreStyle=Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])({'button.btn-load-more':Object.assign({},__WEBPACK_IMPORTED_MODULE_1____["_0" /* Link */],{textAlign:'center',margin:'2rem auto',boreder:'1px solid '+__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].lightGrey,padding:'1rem 2rem',color:__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].grey,background:'none',display:'flex',fontSize:'0.75rem',transition:'all 400ms ease',cursor:'pointer','&:hover':{color:'white',background:'black'}})});

/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FieldStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TextareaStyle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_emotion__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(1);
//FORM
var FieldStyle=function FieldStyle(isEmpty,isBig){return Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])({position:'relative','input[type="text"], input[type="password"], input[type="email"], textarea, input[type="date"]':{position:'relative',zIndex:1,width:'100%',margin:'0.3125rem 0px',padding:'0.3125rem 0',background:'none',border:0,borderBottom:'1px solid '+__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].lightGrey,WebkitAppearance:'none','@media (min-width: 1024px)':{padding:'0.625rem 0px'},'& + label':Object.assign({position:'absolute',top:isEmpty?'50%':0,left:0,transform:isEmpty?'translate(0, -50%)':'scale(0.5) translateY(-15px)',transformOrigin:'top left',color:__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].lightGrey,zIndex:isEmpty?0:1,transition:'all '+(isEmpty?'400ms':'200ms')+' ease',transitionDelay:isEmpty?'200ms':0},__WEBPACK_IMPORTED_MODULE_1____["Z" /* Label */],{fontWeight:isEmpty?200:800,whiteSpace:'nowrap','svg':{fill:__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].lightGrey}}),'&:focus +label':{color:'black','svg':{fill:'black'}}}},{'input[type="text"], input[type="password"], input[type="email"], textarea, input[type="date"]':Object.assign({},__WEBPACK_IMPORTED_MODULE_1____["Z" /* Label */])},isBig&&{'input[type="text"], input[type="password"], input[type="email"], textarea , input[type="date"]':Object.assign({},__WEBPACK_IMPORTED_MODULE_1____["_37" /* SearchLabel */],{fontWeight:200,padding:'1rem 2rem 1rem 0','& + label':Object.assign({},__WEBPACK_IMPORTED_MODULE_1____["_37" /* SearchLabel */],{fontWeight:200,opacity:isEmpty?1:0.5})})});};var TextareaStyle=function TextareaStyle(isEmpty){return Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])({'textarea':{height:100,'@media (min-width: 1024px)':{height:200},'& + label':{top:'1rem',transform:'scale('+(isEmpty?1:0.5)+') translateY('+(isEmpty?0:-20)+'px)'}}});};

/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AccountStyle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_emotion__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(1);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var AccountStyle=function AccountStyle(open,picture){var _accountPanel;return Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])({position:'relative',display:'inline-block',verticalAlign:'middle',lineHeight:1.2,height:80,cursor:'pointer','&:after':{content:'""',position:'absolute',bottom:0,left:0,width:'100%',height:6,background:'#000',transition:'transform 200ms '+__WEBPACK_IMPORTED_MODULE_1____["G" /* Easings */].customEase+' ',transform:'scaleX('+(open?1:0)+')',transformOrigin:'center left'},'.account-card':{'&--inner':{height:80},'&--picture':{overflow:'hidden',width:60,height:60,lineHeight:'60px',textAlign:'center',background:picture===''?'black':'url('+picture+') no-repeat center',backgroundSize:'cover',borderRadius:9999,'@media (min-width: 1224px)':{width:40,height:40,lineHeight:'40px',backgroundSize:'cover'},'svg':{fill:'white',verticalAlign:'middle',display:'inline-block'}},'&--info':{paddingLeft:'1rem',maxWidth:'calc(100% - 60px - 1rem)',flexBasis:'calc(100% - 60px - 1rem)','@media (min-width: 1224px)':{minWidth:'100px',maxWidth:'none',flexBasis:'none'}},'&--name':Object.assign({},__WEBPACK_IMPORTED_MODULE_1____["_22" /* ProfileName */],{marginBottom:'0.5rem','svg':{transform:'scale(1.5)',transformOrigin:'center center',marginLeft:'0.5rem',verticalAlign:'middle',transition:'transform 200ms ease','@media (min-width: 1224px)':{transform:'rotate('+(open?-90:90)+'deg)'}}}),'&--type':Object.assign({},__WEBPACK_IMPORTED_MODULE_1____["_74" /* XSmall */],{color:__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].red})},'.account-panel':(_accountPanel={position:'fixed',top:0,left:0,zIndex:4,width:'100%',height:'100%',overflow:'auto',transition:'transform 300ms '+__WEBPACK_IMPORTED_MODULE_1____["G" /* Easings */].customEase+' '+(open?0:300)+'ms, visibility 0ms ease '+(open?0:600)+'ms',background:'white',cursor:'default'},_defineProperty(_accountPanel,'zIndex',2),_defineProperty(_accountPanel,'transform','translateX('+(open?0:100)+'%)'),_defineProperty(_accountPanel,'visibility',open?'visible':'hidden'),_defineProperty(_accountPanel,'@media (min-width: 1224px)',{position:'absolute',bottom:0,top:'auto',left:0,zIndex:4,width:260,maxHeight:220,height:'auto',padding:'0.5rem',transform:'translateY(100%) scaleY('+(open?1:0)+')',visibility:open?'visible':'hidden',transformOrigin:'top center',boxShadow:'0 5px 20px 0 '+__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].shadow}),_defineProperty(_accountPanel,'ul',{opacity:open?1:0,transition:'opacity 300ms ease '+(open?300:0)+'ms',padding:'2rem 1rem','@media (min-width: 1224px)':{padding:0}}),_defineProperty(_accountPanel,'a',Object.assign({},__WEBPACK_IMPORTED_MODULE_1____["_0" /* Link */],{fontSize:'1.125rem',color:__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].mediumGrey,display:'block',padding:'1rem','@media (min-width: 1224px)':Object.assign({},__WEBPACK_IMPORTED_MODULE_1____["_0" /* Link */],{padding:'0.5rem 1rem'}),'&:hover':{color:'black'},'&:active':{color:__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].red}})),_accountPanel)});};

/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProgressBarStyle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_emotion__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core__ = __webpack_require__(17);
var ProgressBarStyle=function ProgressBarStyle(theme,x,big){return Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])({position:'relative',display:'block',width:'100%',height:big?6:3,background:__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].extraLightGrey,zIndex:1,overflow:'hidden','.progress-bar':{'&--inner':{position:'absolute',top:0,left:0,width:x+'%',height:'100%',background:__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */][theme],zIndex:2,transform:'scaleX(0)',transformOrigin:'center left',animation:'progress2 200ms '+__WEBPACK_IMPORTED_MODULE_2__core__["b" /* Easings */].customEase+' forwards 400ms'}},'@keyframes progress2':{'0%':{transform:'scaleX(0)'},'100%':{transform:'scaleX(1)'}}});};

/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NotificationStyle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_emotion__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(1);
var NotificationStyle=function NotificationStyle(open){return Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])({position:'fixed',top:60,left:0,zIndex:4,width:'100%',height:'calc(100% - 60px)',lineHeight:1.2,overflow:'auto',padding:'1rem',transform:'scaleY('+(open?1:0)+')',visibility:open?'visible':'hidden',transformOrigin:'top center',boxShadow:'0 5px 20px 0 '+__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].shadow,background:'white',transition:'transform 300ms '+__WEBPACK_IMPORTED_MODULE_1____["G" /* Easings */].customEase+' '+(open?0:300)+'ms, visibility 0ms ease '+(open?0:600)+'ms',cursor:'default',textAlign:'left','@media (min-width: 1024px)':{position:'absolute',width:260,maxHeight:220,height:'auto',top:'auto',left:'auto',bottom:0,right:0,transform:'translateY(100%) scaleY('+(open?1:0)+')'},'.notification-line':{margin:'1rem 0px',textTransform:'uppercase',opacity:open?1:0,transition:'opacity 300ms ease '+(open?300:0)+'ms','&:first-child':{marginTop:0},'&:last-child':{marginBottom:0},'a':{display:'flex',alignItems:'center'},'.icon':{flexBasis:'16px',width:'16px',marginRight:'1rem',position:'relative','svg':{fill:'black',transition:'fill 400ms ease'}},'.label':Object.assign({},__WEBPACK_IMPORTED_MODULE_1____["_0" /* Link */],{fontWeight:'bold',color:__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].darkGrey,flexBasis:'calc(100% - 16px)',maxWidth:'calc(100% - 16px)'}),'&.hightlight':{'.icon':{'&:after':{content:"''",position:'absolute',top:3,right:-1,width:5,height:5,borderRadius:9999,background:__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].red,border:'1px solid white'}}},'&.alert':{'.label':{color:__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].red,'&:hover':{color:''}},'.icon svg':{fill:__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].red}}}});};

/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PushContentStyle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_emotion__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(1);
var PushContentStyle=function PushContentStyle(background){return Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])({maxWidth:450,'.push-content':{'&--desc':{// transform: 'translateY(-2rem)',
'@media (max-width: 1024px)':{// transform: 'translateY(-1.5rem)',
'a':{display:'block',textAlign:'center'}}},'&--picture':{position:'relative',height:250,overflow:'hidden',maxWidth:'100%','@media (min-width: 1024px)':{maxWidth:'calc(11/12 * 100%)',marginLeft:'calc(1/12 * 100%)',height:320},'.picture':{position:'relative',height:'100%',background:'url('+background+') no-repeat center',backgroundSize:'cover','img':{position:'absolute',top:0,left:'50%',height:'100%',maxHeight:'none',maxWidth:'none',transform:'translateX(-50%)'}}}},'h3':Object.assign({},__WEBPACK_IMPORTED_MODULE_1____["_27" /* PushTitle */],{margin:0,marginBottom:'1rem'})});};

/***/ }),
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SearchBarStyle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_emotion__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(1);
var SearchBarStyle=Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])({position:'relative',margin:'2rem 0rem','@media (min-width: 1024px)':{margin:'4rem 0rem 2rem'},'.form':{position:'relative'},'input[type="text"]':{color:'white !important','& + label, &:focus + label':{color:'white !important',whiteSpace:'nowrap'}},'button':Object.assign({position:'absolute',top:'50%',right:0},__WEBPACK_IMPORTED_MODULE_1____["_0" /* Link */],{color:'white',padding:'0px',transform:'translateY(-50%)',zIndex:2,opacity:0.5,transition:'opacity 400ms ease',cursor:'pointer','&:hover':{opacity:1}})});

/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CardStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LongCardStyle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_emotion__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(1);
var defaultCard=function defaultCard(cover,shadow,isCover){return{padding:'0.75rem','.card':{'&-bottom':{justifyContent:'flex-end'},'&-inner':{background:'white',boxShadow:shadow?'0 0 10px 0 '+__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].shadow:'0',// overflow: 'hidden',
'@media (min-width: 1024px)':{boxShadow:shadow?'0 0 20px 0 '+__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].shadow:'0'},'&:hover':{'.card-picture:after':{transform:'scale(1.5)',transitionDuration:'1s'}}},'&-picture':{overflow:'hidden',position:'relative',background:'#000','&:after':{content:"''",position:'absolute',top:0,left:0,width:'100%',height:'100%',background:'#000 url('+cover+') no-repeat center',backgroundSize:isCover?'cover':'auto 100%',transition:'transform 0.5s '+__WEBPACK_IMPORTED_MODULE_1____["G" /* Easings */].customEase,transform:'scale(1)',overflow:'hidden',transformOrigin:'center center'}},'&-info':{padding:'1rem','@media (min-width: 1024px)':{padding:'1.5rem'},'&--type':Object.assign({color:__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].mediumGrey},__WEBPACK_IMPORTED_MODULE_1____["_0" /* Link */]),'p, .description':Object.assign({},__WEBPACK_IMPORTED_MODULE_1____["r" /* CardSmall */],{color:'black',margin:0,textTransform:'uppercase'})},'&-link':Object.assign({},__WEBPACK_IMPORTED_MODULE_1____["_0" /* Link */],{fontSize:'0.75rem',color:__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].mediumGrey,transition:'color 400ms ease','@media (min-width: 1024px)':{fontSize:'0.825rem'}})},'h2':Object.assign({},__WEBPACK_IMPORTED_MODULE_1____["t" /* CardTitle */],{margin:'0.5rem 0',color:'black'}),'.card-button':{display:'flex',width:60,minHeight:60,justifyContent:'flex-end','@media (min-width: 1024px)':{width:120},'.btn-pdf':{display:'none','@media (min-width: 1024px)':{display:'block'}}},'.btn-pdf':{marginRight:1},'&:hover':{'.card':{'&-link':{color:'black'}}}};};var CardStyle=function CardStyle(shadow,cover,isCover){return Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])(Object.assign({maxWidth:'25%',flexBasis:'25%',minWidth:'280px'},defaultCard(cover,shadow,isCover),{'&:first-child':{paddingLeft:0,paddingRight:'1.4rem'},'&:last-child':{paddingRight:0,paddingLeft:'1.4rem'},'.card-link':{maxWidth:'calc(100% - 60px)',flexBasis:'calc(100% - 60px)',textAlign:'center','@media (min-width: 1024px)':{paddingLeft:'1.5rem',paddingRight:'1.5rem',maxWidth:'calc(100% - 120px)',flexBasis:'calc(100% - 120px)',textAlign:'left'}}}),{'.card-picture':{paddingTop:'70%'}});};var LongCardStyle=function LongCardStyle(shadow,cover,isCover){return Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])(Object.assign({},defaultCard(cover,shadow,isCover),{padding:'1.25rem 0','.card-inner > a:first-child':{display:'flex',flexWrap:'wrap'},'.card-bottom':{alignSelf:'flex-end',width:'100%',flexBasis:'100%','@media (min-width: 1024px)':{width:160,flexBasis:160}},'.card-picture':{width:'100%',flexBasis:'100%',height:220,'@media (min-width: 1024px)':{width:'calc(1/6 * 100%)',flexBasis:'calc(1/6 * 100%)',height:'auto'}},'.card-info':{maxWidth:'100%',flexBasis:'100%','@media (min-width: 1024px)':{maxWidth:'calc(5/6 * 100% - 160px)',flexBasis:'calc(5/6 * 100% - 160px)'},'h2':{minHeight:'0'},'.card-info--type':{display:'none'},'.highlight, .highlight > p':{fontSize:'1rem',color:'black','em':{color:__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].red,fontStyle:'normal'}}},'.card-link':{maxWidth:'calc(100% - 120px)',flexBasis:'calc(100% - 120px)',textAlign:'center','@media (min-width: 1024px)':{margin:'2rem 0',maxWidth:'100%',flexBasis:'100%'}},'.card-button':{width:120,display:'flex',justifyContent:'flex-end','@media (min-width: 1024px)':{width:160}}}));};

/***/ }),
/* 360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FeaturedStyle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_emotion__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(1);
var FeaturedStyle=function FeaturedStyle(ready){return Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])({margin:'4rem 0',transition:'opacity 400ms ease, transform 400ms '+__WEBPACK_IMPORTED_MODULE_1____["G" /* Easings */].customEase,transform:'translateY('+(ready?0:20)+'px)',opacity:ready?1:0,'h2':Object.assign({},__WEBPACK_IMPORTED_MODULE_1____["_7" /* MenuLink */],{color:'white'// margin: '1rem 0',
}),'.card':{minWidth:280}});};

/***/ }),
/* 361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SliderStyle; });
/* unused harmony export SlideStyle */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return IntroTemplateStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BaseTemplateStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return TextTemplateStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SliderTemplateStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SuggestTemplateStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SocialTemplateStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return flickitySlideStyle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_emotion__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core__ = __webpack_require__(17);
// SLIDER
var SliderStyle=Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])({position:'relative','.template-content':{padding:'1.5rem',paddingBottom:'calc(1.5rem)',// '@media (min-width: 1224px) ': {
//   padding: '4rem',
//   paddingBottom: '6rem',
// },
'@media (min-height: 660px) and (min-width: 1224px)':{padding:'8rem',paddingBottom:'6rem'},'p, ul, ol':Object.assign({},__WEBPACK_IMPORTED_MODULE_1____["_43" /* SliderContent */])},'.title':Object.assign({},__WEBPACK_IMPORTED_MODULE_1____["_49" /* SliderTitle */],{margin:0}),'.subtitle':Object.assign({},__WEBPACK_IMPORTED_MODULE_1____["_47" /* SliderSubtitle */],{margin:0,marginBottom:'2rem',textTransform:'uppercase','@media (min-width: 1024px)':{marginBottom:'4rem'},'&--brand':{fontSize:'1.875rem','@media (min-width: 1024px)':{fontSize:'3rem'},'&:after':{content:"''",width:50,height:4,background:'black',display:'block',marginTop:'2.5rem'}},'&-h3':{textTransform:'uppercase',fotnSize:'1.125rem',margin:'0.625rem 0'}}),'.title-brand':{textTransform:'uppercase',fontWeight:'bold',fontSize:'1rem'},'.product-template':{position:'relative',// overflow: 'visible',
'&--video':{height:'100%'}},'.template-scroll':{display:'flex',flexWrap:'wrap','@media (min-width: 1024px)':{display:'inherit'}}});var fixedCol=function fixedCol(picture,color){return{position:'relative',height:360,background:'url('+picture+') no-repeat center',backgroundSize:color?'contain':'cover',backgroundColor:color,'@media (min-width: 1024px)':{position:'fixed',top:80,height:'calc(100% - 160px)'}};};// SLIDES POSITION
var SlideStyle=function SlideStyle(isVisibled){return Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])({position:'absolute',top:0,left:0,width:'100%',height:'100%',opacity:isVisibled?1:0,display:isVisibled?'block':'none'});};// INTRO STYLE - Intro range
var IntroTemplateStyle=function IntroTemplateStyle(picture,color){return Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])({'.template-right':Object.assign({},fixedCol(picture,color),{right:0,width:'100%',order:-1}),'.template-left':{order:1,width:'100%',background:'white','@media (min-width: 1024px)':{maxWidth:'50%',flexBasis:'50%',width:'auto'}},'.template-inner':{width:'50%'},'.content-row':{margin:'1rem 0px','.label':Object.assign({},__WEBPACK_IMPORTED_MODULE_1____["_45" /* SliderLabel */],{color:__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].mediumGrey,maxWidth:'100px',flexBasis:'100px',paddingRight:5,'@media (min-width: 1024px)':{maxWidth:'calc(1/4 * 100%)',flexBasis:'calc(1/4 * 100%)',padding:0}}),'.description':Object.assign({maxWidth:'calc(100% - 100px)',flexBasis:'calc(100% - 100px)'},__WEBPACK_IMPORTED_MODULE_1____["_44" /* SliderDescription */],{margin:0,color:'black',fontWeight:'bold',paddingLeft:'0.625rem','@media (min-width: 1024px)':{maxWidth:'calc(3/4 * 100%)',flexBasis:'calc(3/4 * 100%)'},'.flex':{margin:'1rem 0px',alignItems:'center','&:first-child':{marginTop:0}}}),'.range-label':{maxWidth:'100px',flexBasis:'100px',paddingRight:'1rem',fontWeight:'bold'},'.range':{maxWidth:360,width:'calc(100% - 100px)',flexBasis:'calc(100% - 100px)'}}},{'.template-right':{'@media (min-width: 1024px)':{width:'50%'}}});};// BASE STYLE - Landscape - col 1/2 
var BaseTemplateStyle=function BaseTemplateStyle(picture,type,color){return Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])({height:'100%','.template-left':Object.assign({},fixedCol(picture,color),{left:0,width:'100%','@media (min-width: 1024px)':{position:'fixed',height:'calc(100% - 160px)'}}),'.template-right':{maxWidth:'100%',flexBasis:'100%','@media (min-width: 1024px)':{paddingLeft:'3rem',paddingRight:'3rem',maxWidth:type==='imagelandscape'?'calc(1/3 * 100%)':'calc(1/2 * 100%)',flexBasis:type==='imagelandscape'?'calc(1/3 * 100%)':'calc(1/2 * 100%)',marginLeft:type==='imagelandscape'?'calc(2/3 * 100%)':'calc(1/2 * 100%)'},'@media (min-width: 1440px)':{paddingLeft:'6rem',paddingRight:'6rem'},'@media (min-width: 1660px)':{paddingLeft:'8rem',paddingRight:'8rem'}},'.subtitle':{marginTop:'5rem','&:first-of-type':{marginTop:0}},'.content':{'h3':{// ...SliderSubtitle,
}},'.flickity':{'&-slider':{position:'absolute',top:0,left:0,width:'100%',height:'100%'},'&-button':{display:'none'},'&-page-dots':{display:'flex',listStyle:'none',position:'absolute',bottom:'2rem',left:'50%',transform:'translateX(-50%)',zIndex:5,padding:0,'& > li':{width:10,height:10,borderRadius:9999,background:'white',border:'1px solid black',opacity:0.5,margin:'0rem 5px','&:before':{display:'none'},'&.is-selected':{opacity:1}}}}},{'.template-left':{'@media (min-width: 1024px)':{width:type==='imagelandscape'?'calc(2/3 * 100%)':'calc(1/2 * 100%)'}}});};// BASE STYLE - Landscape - col 1/2 
var TextTemplateStyle=Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])({'.template-right':{maxWidth:'100%',flexBasis:'100%','@media (min-width: 1024px)':{maxWidth:'calc(1/2 * 100%)',flexBasis:'calc(1/2 * 100%)',paddingLeft:'4rem'}},'.template-left':{maxWidth:'100%',flexBasis:'100%','@media (min-width: 1024px)':{maxWidth:'calc(1/2 * 100%)',flexBasis:'calc(1/2 * 100%)',paddingRight:'4rem'}}});// SLIDER 
var SliderTemplateStyle=function SliderTemplateStyle(picture,ready,color){return Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])({'h2':{'maxWidth':'100%','flexBasis':'100%'},'ul':{'li':Object.assign({},__WEBPACK_IMPORTED_MODULE_1____["_43" /* SliderContent */],{margin:'2rem 0px',alignsItems:'flex-start',opacity:0.25,cursor:'pointer',transition:'all 400ms ease','&.active':{opacity:1}}),'.number':{position:'relative',paddingRight:'50px','&:after':{content:'""',position:'absolute',top:-8,left:32,height:40,width:4,background:'black'}},'.label':{maxWidth:'calc(100% - 80px)',flexBasis:'calc(100% - 80px)'}},'.template-right':{width:'100%','@media (min-width: 1024px)':{width:'50%',marginLeft:'50%'}},'.template-left':{width:'100%',height:360,background:'url('+picture+') no-repeat center',backgroundSize:color?'contain':'cover',backgroundColor:color,'&:after':{content:'""',position:'absolute',top:0,left:0,width:'100%',height:'100%',background:'white',zIndex:10,transition:'transform 400ms '+__WEBPACK_IMPORTED_MODULE_2__core__["b" /* Easings */].customEase,transform:'scaleX('+(ready?0:1)+')',transformOrigin:'center right'},'@media (min-width: 1024px)':{position:'fixed',top:80,height:'calc(100% - 160px)',width:'50%'}}},!color&&{'.template-left':{'&--top':{backgroundPosition:'center top'},'&--center':{backgroundPosition:'center center'},'&--bottom':{backgroundPosition:'center bottom'}}});};// SUGGESTION STYLE
var SuggestTemplateStyle=function SuggestTemplateStyle(picture,color){return Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])({height:'100%','.template-right':{width:'100%',paddingTop:'4rem','&:not(.full)':{paddingLeft:'1.5rem',paddingRight:'1.5rem','@media (min-width: 1024px)':{paddingLeft:'3rem',paddingRight:'3rem'},'@media (min-width: 1440px)':{paddingLeft:'6rem',paddingRight:'6rem'},'@media (min-width: 1660px)':{paddingLeft:'8rem',paddingRight:'8rem'}},'& > .flex':{alignItems:'flex-start'},'.slideshow-article-nav':{'button > svg':{fill:'black'}},'@media (min-width: 1024px)':{width:'calc(1/2 * 100%)',marginLeft:'calc(1/2 * 100%)'},'h2.subtitle, .suggest-container':{maxWidth:'100%',flexBasis:'100%'},'.suggest-container':{marginLeft:'-1rem',marginRight:'-1rem'},'&.full':{maxWidth:'100%',flexBasis:'100%',width:'100%',marginLeft:0,'h2.subtitle':{maxWidth:'100%',flexBasis:'100%','@media (min-width: 1024px)':{maxWidth:'calc(1/4 * 100%)',flexBasis:'calc(1/4 * 100%)'}},'.suggest-container':{maxWidth:'100%',flexBasis:'100%',overflow:'visible','@media (min-width: 1024px)':{maxWidth:'calc(3/4 * 100%)',flexBasis:'calc(3/4 * 100%)'}}},'.card':{maxWidth:'50%',flexBasis:'50%',padding:'0.5rem',minWidth:0,'@media (min-width: 1024px)':{maxWidth:'calc(1/'+(picture?2:3)+' * 100%)',flexBasis:'calc(1/'+(picture?2:3)+' * 100%)',padding:'1rem',minWidth:260},'@media (min-width: 1640px)':{minWidth:280},'&-info':{minHeight:110}},'.card-inner':{boxShadow:'0 0 10px 0 '+__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].shadow,'@media (min-width: 1024px)':{boxShadow:'0 0 20px 0 '+__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].shadow},'h2':{minHeight:0}}},'.template-scroll':{'@media (min-width: 1024px)':{height:'100%'}},'.template-left':Object.assign({},fixedCol(picture,color),{left:0,width:'100%'})},{'.template-left':{height:360,width:'100%','@media (min-width: 1024px)':{width:'50%',position:'fixed',top:80,height:'calc(100% - 160px)'}}},picture&&{'h2.subtitle':{marginBottom:'2rem'}});};// Social STYLE
var SocialTemplateStyle=function SocialTemplateStyle(picture){return Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])({'.template-left':{background:'url('+picture+') no-repeat center',backgroundSize:'contain',width:'100%',height:360,'@media (min-width: 1024px)':{width:'50%',position:'fixed',top:80,height:'calc(100% - 160px)'}},'.template-right':{width:'100%','@media (min-width: 1024px)':{width:'50%',marginLeft:'50%'}},'.social-label':{marginLeft:'1rem',marginRight:'0.5rem',fontWeight:'bold'},'.social-row':{margin:'1rem 0px','a':{maxWidth:'calc(100% - 140px)',flexBasis:'calc(100% - 140px)',wordBreak:'break-word'}},'.social-svg, .social-label':{display:'inherit'},'a':{color:'black'}});};// FLICKITY
var flickitySlideStyle=function flickitySlideStyle(picture,color){return Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])({height:'100%',width:'100%',background:'url('+picture+') no-repeat center ',backgroundSize:color?'contain':'cover',backgroundColor:color,opacity:0,zIndex:0,// transition: 'opacity 100ms ease !important',
'&.is-selected, &[aria-selected="true"]':{opacity:1,zIndex:2}});};

/***/ }),
/* 362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return VideoTemplateStyle; });
/* unused harmony export VideoContainerStyle */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FullVideoContainerStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return VideoCardStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return VideoStyle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_emotion__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(1);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var VideoTemplateStyle=function VideoTemplateStyle(picture){return Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])({height:'calc(100vh - 140px)',width:'100%','@media (min-width: 1024px)':{height:'calc(100vh - 160px)'},'.suggest-container':{flexGrow:1,maxWidth:'100%',flexBasis:'100%',overflow:'visible','@media (min-width: 1024px)':{maxWidth:'calc(3/4 * 100%)',flexBasis:'calc(3/4 * 100%)'}},'.card':{'@media (min-width: 1024px)':{maxWidth:'calc(1/'+(picture?2:3)+' * 100%)',flexBasis:'calc(1/'+(picture?2:3)+' * 100%)',padding:'1rem',minWidth:260},'@media (min-width: 1640px)':{minWidth:280},'&-info':{minHeight:110}},'h2.subtitle':{maxWidth:'100%',flexBasis:'100%','@media (min-width: 1024px)':{maxWidth:'calc(1/4 * 100%)',flexBasis:'calc(1/4 * 100%)'}},'.videos-template':{'&-inner':{position:'relative',zIndex:2,padding:'1.5rem',height:'100%',overflow:'auto','@media (min-width: 1024px)':{padding:'8rem'}}},'h2':{textTransform:'uppercase'},'.template-scroll':{height:'100%'},'.template-right':{height:'100%'}});};var VideoContainerStyle=function VideoContainerStyle(picture,isFull){return Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])({maxWidth:'calc(1/2 * 100vw - 4rem)',flexBasis:'calc(1/2 * 100vw - 4rem)',margin:'1rem','@media (min-width: 1024px)':{maxWidth:'calc(1/4 * 100vw - 8rem)',flexBasis:'calc(1/4 * 100vw - 8rem)'},'.video':{position:'relative',width:'100%',height:110,background:'black url('+picture+') no-repeat center',backgroundSize:'cover',cursor:'pointer','@media (min-width: 1024px)':{height:220},'.btn':{position:'absolute',top:'50%',left:'50%',transform:'translate(-50%, -50%)',width:50,height:50,border:0,padding:0,margin:0,zIndex:2,background:__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].red,transition:'background 400ms ease','&:hover':{background:'black'},'svg':{fill:'white',transform:'rotate(90deg)'}},'&-label':Object.assign({display:'block',color:'white'},__WEBPACK_IMPORTED_MODULE_1____["_45" /* SliderLabel */],{fontWeight:'bold',margin:'0.5rem 0'}),'&-container-full':{height:'100%',overflow:'hidden',width:'100%',display:isFull?'block':'none','.video-close':{position:'absolute',width:50,height:50,top:'2rem',right:'2rem',border:'2px solid white',zIndex:10,background:'none',borderRadius:9999,cursor:'pointer',transition:'all 400ms ease',margin:0,'@media (min-width: 1024px)':{top:'4rem',right:'4rem'},'span':{position:'absolute',top:'50%',left:'50%',height:'50%',width:'2px',background:'white',transform:'translate(-50%, -50%) rotate(-45deg)',transition:'all 400ms ease','&:last-child':{transform:'translate(-50%, -50%) rotate(45deg)'}},'&:hover':{background:'white','span':{background:'black'}}},'.video-wrapper':{display:'block',height:'100%',left:0,overflow:'hidden',position:'absolute',top:'50%',width:'100%',WebkitTransform:'translateY(-50%)',transform:'translateY(-50%)'},'.video-iframe':{left:0,overflow:'hidden',// paddingBottom: '56.25%',
position:'absolute',top:'50%',width:'100%',height:'100%',WebkitTransformOrigin:'50% 0',transformOrigin:'50% 0',WebkitTransform:'translateY(-50%)',transform:'translateY(-50%)',display:'block',zIndex:5,background:'black','iframe':{display:'block',height:'100%',width:'100%'}}}}});};var FullVideoContainerStyle=function FullVideoContainerStyle(picture,isFull){var pos=arguments.length>2&&arguments[2]!==undefined?arguments[2]:'center';return Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])({height:'100%',overflow:'hidden','.video':{position:'relative',width:'100%',height:'100%',background:isFull?'black':'black url('+picture+') no-repeat '+pos+' center',backgroundSize:'cover',cursor:'pointer','@media (min-width: 1024px)':{height:'100%'},'.btn':{position:'absolute',top:'50%',left:'50%',transform:'translate(-50%, -50%)',width:50,height:50,border:0,padding:0,margin:0,zIndex:2,background:__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].red,transition:'background 400ms ease',cursor:'pointer','&:hover':{background:'black'},'svg':{fill:'white',transform:'rotate(90deg)'}},'&-label':Object.assign({display:'block',color:'white'},__WEBPACK_IMPORTED_MODULE_1____["_45" /* SliderLabel */],{fontWeight:'bold',margin:'0.5rem 0'}),'&-container-full':{height:'100%',overflow:'hidden',width:'100%',display:isFull?'block':'none','.video-close':{position:'absolute',width:50,height:50,top:'2rem',right:'2rem',border:'2px solid white',zIndex:10,background:'none',borderRadius:9999,cursor:'pointer',transition:'all 400ms ease',margin:0,'@media (min-width: 1024px)':{top:'4rem',right:'4rem'},'span':{position:'absolute',top:'50%',left:'50%',height:'50%',width:'2px',background:'white',transform:'translate(-50%, -50%) rotate(-45deg)',transition:'all 400ms ease','&:last-child':{transform:'translate(-50%, -50%) rotate(45deg)'}},'&:hover':{background:'white','span':{background:'black'}}},'.video-wrapper':{display:'block',height:'100%',left:0,overflow:'hidden',position:'absolute',top:'50%',width:'100%',WebkitTransform:'translateY(-50%)',transform:'translateY(-50%)'},'.video-iframe':{left:0,overflow:'hidden',// paddingBottom: '56.25%',
position:'absolute',top:'50%',width:'100%',height:'100%',WebkitTransformOrigin:'50% 0',transformOrigin:'50% 0',WebkitTransform:'translateY(-50%)',transform:'translateY(-50%)',display:'block',zIndex:5,'iframe':{display:'block',height:'100%',width:'100%'}}}}});};var VideoCardStyle=function VideoCardStyle(isFull){return Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])({'.video-label':Object.assign({},__WEBPACK_IMPORTED_MODULE_1____["t" /* CardTitle */],{margin:'0.5rem 0',color:'black'}),'.card-inner':{display:'flex',flexDirection:'column',cursor:'pointer',width:'100%'},'.card-info':{flexGrow:1},'.card-link':{display:'block',padding:'1rem 1.5rem'},'.video-container-full':{position:'fixed',top:0,left:0,width:'100%',height:'100%',background:'black',zIndex:4,paddingTop:80,paddingBottom:80,display:isFull?'block':'none','.video-close':{position:'absolute',width:50,height:50,top:'2rem',right:'2rem',border:'2px solid white',zIndex:10,background:'none',borderRadius:9999,cursor:'pointer',transition:'all 400ms ease','@media (min-width: 1024px)':{top:'4rem',right:'4rem'},'span':{position:'absolute',top:'50%',left:'50%',height:'50%',width:'2px',background:'white',transform:'translate(-50%, -50%) rotate(-45deg)',transition:'all 400ms ease','&:last-child':{transform:'translate(-50%, -50%) rotate(45deg)'}},'&:hover':{background:'white','span':{background:'black'}}},'.video-iframe':{position:'absolute',top:0,right:0,bottom:0,left:0,fontSize:0,'iframe':{width:'100vw',height:'calc(100vh - 140px)','@media (min-width: 1024px)':{height:'calc(100vh - 160px)'}}}}});};var VideoStyle=function VideoStyle(picture,isFull){var _btn;return Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])({position:'relative',width:'100%',background:'black url('+picture+') no-repeat center',backgroundSize:'cover',cursor:'pointer',paddingTop:'45%','.btn':(_btn={position:'absolute',top:'50%',left:'50%',transform:'translate(-50%, -50%)',border:0,padding:0,margin:0,zIndex:2,color:'white',fontSize:'1rem',textTransform:'uppercase',letterSpacing:'2px',height:50,lineHeight:'50px'},_defineProperty(_btn,'padding','0 2rem'),_defineProperty(_btn,'cursor','pointer'),_defineProperty(_btn,'background',__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].red),_defineProperty(_btn,'transition','background 400ms ease'),_defineProperty(_btn,'&:hover',{background:'black'}),_defineProperty(_btn,'svg',{fill:'white',transform:'rotate(90deg)',verticalAlign:'middle',margin:'0 5px'}),_btn),'.video-container-full':{position:'fixed',top:0,left:0,width:'100%',height:'100%',background:'black',zIndex:4,paddingTop:80,paddingBottom:80,display:isFull?'block':'none','.video-close':{position:'absolute',width:50,height:50,top:'2rem',right:'2rem',border:'2px solid white',zIndex:10,background:'none',borderRadius:9999,cursor:'pointer',transition:'all 400ms ease','@media (min-width: 1024px)':{top:'4rem',right:'4rem'},'span':{position:'absolute',top:'50%',left:'50%',height:'50%',width:'2px',background:'white',transform:'translate(-50%, -50%) rotate(-45deg)',transition:'all 400ms ease','&:last-child':{transform:'translate(-50%, -50%) rotate(45deg)'}},'&:hover':{background:'white','span':{background:'black'}}},'.video-iframe':{position:'relative',fontSize:0,'iframe':{width:'100vw',height:'calc(100vh - 140px)','@media (min-width: 1024px)':{height:'calc(100vh - 160px)'}}}}});};

/***/ }),
/* 363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PanelPDFStyle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_emotion__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core__ = __webpack_require__(17);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var PanelPDFStyle=function PanelPDFStyle(active){var _a;return Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])({position:'absolute',top:0,right:0,width:'300px',padding:'1rem',transform:'translateY(-100%) scaleY('+(active?1:0)+')',background:'white',// display: active ? 'block' : 'none',
transformOrigin:'center bottom',transition:'transform 400ms '+__WEBPACK_IMPORTED_MODULE_2__core__["b" /* Easings */].customEase,border:'1px solid '+__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].lightGrey,// borderRight: 0,
'a':(_a={color:__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].mediumGrey,display:'block',margin:'1rem 0px',position:'relative',textAlign:'right'},_defineProperty(_a,'display','flex'),_defineProperty(_a,'opacity',active?1:0),_defineProperty(_a,'transition','opacity 200ms ease '+(active?400:0)+'ms, color 200ms ease'),_defineProperty(_a,'span',{width:'calc(100% - 50px)'// flexWidth: 'calc(100% - 50px)',
}),_defineProperty(_a,'svg',{fill:__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].grey,verticalAlign:'baseline',margin:'0 1rem'}),_defineProperty(_a,'&:hover',{color:'black'}),_a)});};

/***/ }),
/* 364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return PushQuizzStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PushHighScoreStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CurrentRankingStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return RankingIQStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BestRankingStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return QuizzRankingStyle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_emotion__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__static_montre_dark_jpg__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__static_montre_dark_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__static_montre_dark_jpg__);
var PushQuizzStyle=function PushQuizzStyle(){return Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])({background:'#292a2b',//  background: `url(${URL}) no-repeat center`,
//  backgroundSize: 'cover',
'h3':Object.assign({},__WEBPACK_IMPORTED_MODULE_1____["Z" /* Label */],{color:'white',textTransform:'uppercase',fontWeight:'bold'}),'p':{color:'white'},'.btn':Object.assign({},__WEBPACK_IMPORTED_MODULE_1____["q" /* ButtonWhite */],{display:'block',color:__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].darkGrey,transition:'all 400ms ease',margin:'2rem 0px','&:hover':{color:'white',background:'black'}}),'.link':Object.assign({},__WEBPACK_IMPORTED_MODULE_1____["_0" /* Link */],{color:__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].red,transition:'color 400ms ease','&:hover':{color:'white'}}),'.push-quizz-inner':{position:'relative',zIndex:2,padding:'4rem',textAlign:'center','@media (min-width: 1224px)':{padding:'6rem 4rem'}}});};var PushHighScoreStyle=Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])({'.link':Object.assign({},__WEBPACK_IMPORTED_MODULE_1____["_0" /* Link */],{color:'black',margin:'3rem 0',display:'block',transition:'color 200ms ease','&:hover':{color:__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].red}}),'h3':Object.assign({},__WEBPACK_IMPORTED_MODULE_1____["t" /* CardTitle */]),'.ranking-table':{'.ranking-line':{padding:'0.4rem 0px',alignItems:'center',fontWeight:'bold',fontSize:'0.9375rem','&.current':{position:'relative','&:after':{content:"''",width:'100%',height:'calc(100% + 2px)',border:'2px solid #000',position:'absolute',top:0,left:0,transform:'translateX(-2px) translateY(-2px)'},'&--menu:after':{borderColor:__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].red}},'.number':{maxWidth:'40px',flexBasis:'40px',paddingLeft:'0.5rem'},'.score':{maxWidth:'40px',flexBasis:'40px',color:__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].red},'.localisation':{maxWidth:'calc(50% - 40px )',flexBasis:'calc(50% - 40px )',color:__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].mediumGrey,textTransform:'uppercase',paddingLeft:'0.5rem'},'.name':{maxWidth:'calc(50% - 40px )',flexBasis:'calc(50% - 40px )',paddingLeft:'0.5rem'}},'.first':{border:'2px solid black','&.current':{border:'2px solid '+__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].red},'.number':{color:__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].red}}}});var CurrentRankingStyle=function CurrentRankingStyle(isMenu){return Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])({textAlign:'center','.current':Object.assign({color:__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].red,fontWeight:'bold'},__WEBPACK_IMPORTED_MODULE_1____["_49" /* SliderTitle */],{'sup':{fontSize:'2rem',textTransform:'none'}}),'.current-ranking-label':{textTransform:'uppercase',fontWeight:'bold'},'.link':Object.assign({},__WEBPACK_IMPORTED_MODULE_1____["_0" /* Link */],{color:'black',margin:'2rem 0',display:'inline-block'})},isMenu&&{textAlign:'left','.current':Object.assign({},__WEBPACK_IMPORTED_MODULE_1____["_6" /* MenuH2 */],{fontFamily:'Interstate-bold'}),'.all':{display:'inline-block',color:__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].mediumGrey,fontFamily:'Interstate-bold',transform:'translateY(0.5rem)'}});};var RankingIQStyle=function RankingIQStyle(isMenu,x){return Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])({position:'relative',textAlign:'center','.label':{textTransform:'uppercase',fontWeight:'bold'},'.score':Object.assign({},__WEBPACK_IMPORTED_MODULE_1____["_49" /* SliderTitle */],{color:__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].red,fontFamily:'Interstate-bold'}),'.ranking-iq-progress':{position:'absolute',top:'50%',left:'50%',width:160,height:160,transform:'translate(-50%, -50%)',zIndex:0,'@media (min-width: 1024px)':{width:270,height:270},'svg':{width:'100%',height:'100%',fill:'none',transform:'rotate(-90deg)'},'.progress':{stroke:__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].extraLightGrey,strokeWidth:2},'.progress-bar':{stroke:__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].red,strokeWidth:2,strokeDasharray:251.327412287,strokeDashoffset:251}}},isMenu&&{'.score':Object.assign({},__WEBPACK_IMPORTED_MODULE_1____["_6" /* MenuH2 */],{fontWeight:'bold',fontFamily:'Interstate-bold'}),'.ranking-iq-progress':{width:160,height:160}},x&&{'.progress-bar':{animation:'progress 1s '+__WEBPACK_IMPORTED_MODULE_2__core__["b" /* Easings */].customEase+' forwards'},'@keyframes progress':{'0%':{strokeDashoffset:251},'100%':{strokeDashoffset:x}}});};var BestRankingStyle=Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])({textAlign:'center','.label':{textTransform:'uppercase',fontWeight:'bold'},'.number':Object.assign({color:__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].red},__WEBPACK_IMPORTED_MODULE_1____["_49" /* SliderTitle */],{fontWeight:'bold','sup':{fontSize:'2rem',textTransform:'none'}})});var QuizzRankingStyle=function QuizzRankingStyle(x){return Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])({position:'relative',textAlign:'center',boxShadow:'0 0 20px 0 '+__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].shadow,paddingBottom:'1rem','&:after':{position:'absolute',bottom:0,left:0,content:"''",width:'calc('+x+'/100 * 100%)',height:4,background:__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].red,transform:'scaleX(0)',transformOrigin:'center left',animation:'progress2 200ms '+__WEBPACK_IMPORTED_MODULE_2__core__["b" /* Easings */].customEase+' forwards 400ms'},'.label':{textTransform:'uppercase',fontWeight:'bold'},'.link':Object.assign({},__WEBPACK_IMPORTED_MODULE_1____["_0" /* Link */],{color:'black',margin:'1rem 0',display:'inline-block','@media (min-width: 1024px)':{margin:'2rem 0'}}),'.quizz-ranking-number':{margin:'2rem 0'},'.number':Object.assign({color:__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].red},__WEBPACK_IMPORTED_MODULE_1____["_6" /* MenuH2 */],{fontFamily:'Interstate-bold'}),'.all':Object.assign({position:'relative',display:'inline-block',color:__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].mediumGrey},__WEBPACK_IMPORTED_MODULE_1____["Z" /* Label */],{fontWeight:'bold',transform:'translateY(10px)'})});};

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/montre-dark.ca0e34fd.jpg";

/***/ }),
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return NavPageStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ArticleNavStyle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_emotion__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(1);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var NavPageStyle=Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])({// textAlign: 'center',
marginBottom:'4rem','li':{margin:'0 0.5rem'},'a':Object.assign({},__WEBPACK_IMPORTED_MODULE_1____["_7" /* MenuLink */],{color:__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].mediumGrey,padding:'1rem',position:'relative',display:'block','&:after':{content:'""',position:'absolute',bottom:0,left:0,width:'100%',height:6,background:'black',transition:'all 200ms ease',transform:'scaleX(0)',transformOrigin:'center left'},'&:hover':{color:'black'},'&.active':{color:'black','&:after':{transform:'scaleX(1)'}}})});var ArticleNavStyle=function ArticleNavStyle(hasPdf,full){var _pdfAnnotation;return Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])({// marginTop: '4rem',
position:'relative',width:'100%',height:60,display:'flex',zIndex:2,'@media (min-width: 1024px)':{width:80,display:'block'},'.btn':{borderLeft:'1px solid white','@media (min-width: 1024px)':{borderRight:'0px'}},'.btn-return':{width:'calc(100% - '+(hasPdf?full?240:300:180)+'px)',height:60,lineHeight:'60px','@media (min-width: 1024px)':{width:80,height:80,lineHeight:'80px'}},'.panel-pdf':{right:full?-120:-60,zIndex:4,'@media (min-width: 1024px)':{right:'auto',left:0}},'.pdf-annotation':(_pdfAnnotation={position:'absolute',top:160,left:80,width:240,height:80,display:'flex',alignItems:'center',fontSize:'0.9375rem',padding:'1rem',animation:'fadeIn 300ms ease forwards',animationDelay:'3000ms'},_defineProperty(_pdfAnnotation,'display','none'),_defineProperty(_pdfAnnotation,'@media (min-width: 1024px)',{display:'flex'}),_defineProperty(_pdfAnnotation,'svg',{transform:'rotate(90deg)',marginRight:'1rem'}),_defineProperty(_pdfAnnotation,'span',{textAlign:'center'}),_defineProperty(_pdfAnnotation,'@keyframes fadeIn',{'0%':{opacity:1,transform:'translateX(0px)'},'100%':{opacity:0,transform:'translateX(-20px)'}}),_pdfAnnotation),'.btn__arrow':{width:60,height:60,lineHeight:'60px',textAlign:'center',display:'block',background:__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].extraLightGrey,'@media (min-width: 1024px)':{display:'none'},'&--previous':{'svg':{transform:'scale(-1)'}},'svg':{fill:__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].mediumGrey,verticalAlign:'middle'}}});};

/***/ }),
/* 367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UserNavStyle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_emotion__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(1);
var UserNavStyle=Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])({'h2':Object.assign({},__WEBPACK_IMPORTED_MODULE_1____["V" /* H2 */],{textAlign:'center',marginTop:'4rem'})});

/***/ }),
/* 368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SimpleFilterStyle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_emotion__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__typo__ = __webpack_require__(46);
var _Object$assign;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var SimpleFilterStyle=Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])({justifyContent:'center','@media (min-width: 1024px)':{margin:0},'li':{maxWidth:'100%',flexBasis:'100%',// margin: '0 2rem',
'@media (min-width: 1024px)':{maxWidth:'none',flexBasis:'auto',margin:0},'& > a':Object.assign({},__WEBPACK_IMPORTED_MODULE_2__typo__["f" /* Link */],(_Object$assign={display:'block',padding:'0px 1.5rem',height:60,lineHeight:'60px',background:__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].extraLightGrey,borderRight:'1px solid #FFF'},_defineProperty(_Object$assign,'display','block'),_defineProperty(_Object$assign,'@media (min-width: 1024px)',{width:'auto',display:'inline-block'}),_defineProperty(_Object$assign,'span',{color:'black'}),_defineProperty(_Object$assign,'svg',{verticalAlign:'text-bottom',marginRight:'0.5rem'}),_defineProperty(_Object$assign,'&:hover',{background:__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].lightGrey}),_defineProperty(_Object$assign,'&.active',{background:'black','span':{color:'white'},'svg':{fill:'white'}}),_Object$assign))}});

/***/ }),
/* 369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProdibiStyle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_emotion__ = __webpack_require__(3);
var ProdibiStyle=function ProdibiStyle(w,h){return Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])({position:'relative',height:h,width:w,overflow:'hidden',top:0,left:0,'canvas':{height:'100%',width:'100%',background:'#000000',cursor:'zoom-in'},'.prodibi-tap':{position:'absolute',top:'0px',left:'50%',height:'50px',lineHeight:'50px',textAlign:'center',width:'200px',background:'rgba(0,0,0,0.5)',color:'white',fontWeight:'bold',letterSpacing:'1px',transform:'translateX(-50%)'}});};

/***/ }),
/* 370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return QuantityStyle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_emotion__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core__ = __webpack_require__(17);
var QuantityStyle=Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])({alignItems:'center',position:'relative','.qty-less, .qty-more':{width:25,height:25,position:'absolute',top:'50%',cursor:'pointer',transform:'translateY(-50%)',zIndex:4,'&:after':{content:"''",position:'absolute',top:'50%',left:'50%',width:12,height:'1px',background:__WEBPACK_IMPORTED_MODULE_1__core__["a" /* Colors */].grey,transform:'translate(-50%, -50%)'}},'.qty-less':{left:0},'.qty-more':{right:0,'&:before':{content:"''",position:'absolute',top:'50%',left:'50%',width:12,height:'1px',background:__WEBPACK_IMPORTED_MODULE_1__core__["a" /* Colors */].grey,transform:'translate(-50%, -50%) rotate(-90deg)',transformOrigin:'center'}}});

/***/ }),
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CheckboxStyle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_emotion__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(1);
var CheckboxStyle=function CheckboxStyle(checked){return Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])({'input[type="checkbox"]':{display:'none'},'label':Object.assign({},__WEBPACK_IMPORTED_MODULE_1____["_45" /* SliderLabel */],{position:'relative',color:__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].mediumGrey,paddingLeft:'1.5rem',lineHeight:1.4,transition:'color 200ms ease','&:hover':{color:'black'},'&:before':{content:"''",position:'absolute',top:0,left:0,border:'2px solid '+(checked?'black':__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].mediumGrey),width:10,height:10},'&:after':{content:"''",position:'absolute',top:4,left:4,background:'black',width:6,height:6,opacity:checked?1:0,transform:'scale('+(checked?1:2)+')',transition:'all .2s ease'}})});};

/***/ }),
/* 372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SelectDropdownStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FilterDropdownStyle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_emotion__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(1);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var defaultDropDown=function defaultDropDown(open,dark){var _svg;return{position:'relative','.dropdown':{'&-list':{position:'relative',zIndex:10,width:'100%',maxHeight:200,overflow:'auto',transform:'scaleY('+(open?1:0)+')',transformOrigin:'top center',visibility:open?'visible':'hidden',transition:'transform 300ms '+__WEBPACK_IMPORTED_MODULE_1____["G" /* Easings */].customEase+' '+(open?0:300)+'ms, visibility 0ms ease '+(open?0:600)+'ms',willChange:'transform, visibility',display:open?'block':'none','@media (min-width: 1024px)':{position:'absolute',bottom:0,left:0,display:'block',transform:'translateY(100%) scaleY('+(open?1:0)+')'},'& > li':{padding:'0.5rem 0',textTransform:'uppercase',cursor:'pointer',opacity:open?1:0,transition:'opacity 300ms ease '+(open?300:0)+'ms'}},'&-label':{position:'relative',zIndex:1,width:'100%',background:'none',border:0,cursor:'pointer',textAlign:'center',padding:'1rem 0',color:dark?'white':__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].grey,'@media (min-width: 1024px)':{padding:0,color:'black'},'& > svg':(_svg={position:'absolute',transform:'rotate('+(open?-90:90)+'deg)',fill:__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].mediumGrey,top:'50%',right:0},_defineProperty(_svg,'transform','rotate('+(open?-90:90)+'deg) translateX('+(open?50:-50)+'%)'),_defineProperty(_svg,'marginLeft',0),_svg)}}};};var SelectDropdownStyle=function SelectDropdownStyle(open,label,dark){return Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])(Object.assign({},defaultDropDown(open,dark)),{'.dropdown':{'&-list':{background:'white',boxShadow:'0 5px 20px 0 '+__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].shadow,'& > li':Object.assign({},__WEBPACK_IMPORTED_MODULE_1____["_43" /* SliderContent */],{paddingLeft:'1rem'})},'&-label':Object.assign({},__WEBPACK_IMPORTED_MODULE_1____["Z" /* Label */],{margin:'0.3125rem 0px',padding:'0.3125rem 0',borderBottom:'1px solid '+__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].lightGrey,color:label?'black':__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].lightGrey,textAlign:'left','@media (min-width: 1024px)':{textAlign:'center'}})},'@media (min-width: 1024px)':{'.dropdown':{'&-label':{padding:'0.625rem 0px'}}}});};var FilterDropdownStyle=function FilterDropdownStyle(open,dark){return Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])(Object.assign({},defaultDropDown(open,dark)),{'.dropdown':{'&-list':{background:'white',padding:'1rem',width:'100%',transform:'scaleY('+(open?1:0)+')','@media (min-width: 1024px)':{width:200,transform:'translateY(100%) translateY(10px) scaleY('+(open?1:0)+')',boxShadow:'0 5px 20px 0 '+__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].shadow},' & > div':{opacity:open?1:0,transition:'opacity 300ms ease '+(open?300:0)+'ms'}}}});};

/***/ }),
/* 373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SlideshowStyle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_emotion__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(1);
var SlideshowStyle=function SlideshowStyle(prev,next){return Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])({position:'relative','.slideshow-article':{'&-container':{flexWrap:'nowrap','.flickity-viewport':{width:'100%'}},'&-nav':{position:'absolute',top:0,right:0,transform:'translateY(-100%)',zIndex:2,'button':{background:'none',border:0,padding:'0.5rem 1rem',cursor:'pointer','& > svg':{fill:'white'},'&.next':{transform:'rotate(-90deg)',opacity:next?1:0.5,cursor:next?'pointer':'default'},'&.prev':{transform:'rotate(90deg)',opacity:prev?1:0.5,cursor:prev?'pointer':'default'}}}}});};

/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FilterStyle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_emotion__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(1);
var FilterStyle=function FilterStyle(open,dark){return Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])({justifyContent:'flex-end',position:'relative','@media (min-width: 1024px)':{margin:'2rem 0'},'.filter':{'&-list':{position:'absolute',top:'100%',left:0,width:'100%',maxHeight:open?1000:0,overflow:'hidden',transition:'max-height 400ms ease',willChange:'max-height',backfaceVisibility:'hidden',zIndex:2,'@media (min-width: 1024px)':{maxHeight:'none',position:'relative',width:'auto',overflow:'inherit'}},'&-label, &-item .dropdown-label':{textTransform:'uppercase',fontSize:'0.75rem',fontWeight:800,letterSpacing:'2.5px'},'&-label':{padding:'1rem 0',textAlign:'center',display:'block','@media (min-width: 1024px)':{marginRight:'1.5rem',padding:0// display: 'none',
}},'&-item':{background:dark?__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].darkGrey:__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].extraLightGrey,borderBottom:dark?0:'1px solid '+__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].lightGrey,maxWidth:'100%',flexBasis:'100%',color:dark?'white':'black','@media (min-width: 1024px)':{marginRight:'1.5rem',background:'none',borderBottom:0,maxWidth:'none',flexBasis:'auto'},'.dropdown-label':{paddingRight:20}},'&-close':{position:'absolute',width:14,height:14,top:'50%',right:'2rem',transform:'translate(0, -50%) rotate('+(open?0:-45)+'deg)',transition:'transform 300ms ease','&:after, &:before':{content:'""',position:'absolute',top:'50%',left:'50%',width:'100%',height:1,background:'black'},'&:after':{transform:'translate(-50%, -50%) rotate(-45deg)'},'&:before':{transform:'translate(-50%, -50%) rotate(45deg)'}}}});};

/***/ }),
/* 375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UploadStyle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_emotion__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(1);
var UploadStyle=Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])({'input':{display:'none'},'input + label':Object.assign({},__WEBPACK_IMPORTED_MODULE_1____["_45" /* SliderLabel */],{background:__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].extraLightGrey,color:'black',height:60,lineHeight:'60px',margin:'2rem 0',display:'block',width:'100%',textAlign:'center',transition:'all 400ms ease',cursor:'pointer','&:hover ':{background:'black',color:'white'}})});

/***/ }),
/* 376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EventStyle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_emotion__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(1);
var EventStyle=function EventStyle(cover){return Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])({padding:'2rem',boxShadow:'0 0 20px 0 '+__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].shadow,margin:'2rem 0px',position:'relative',cursor:'pointer','.event':{'&-day':{maxWidth:'calc(1/6 * 100%)',flexBasis:'calc(1/6 * 100%)',textAlign:'center','.number':{fontSize:'3rem',color:__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].red,fontWeight:800},'.day':{textTransform:'uppercase',fontWeight:800,color:__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].red},'.hour':{textTransform:'uppercase',fontWeight:800,color:__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].grey}},'&-info':{maxWidth:'calc(4/6 * 100%)',flexBasis:'calc(4/6 * 100%)'},'&-link':{maxWidth:'calc(1/6 * 100%)',flexBasis:'calc(1/6 * 100%)',alignSelf:'center',textAlign:'center','span':Object.assign({},__WEBPACK_IMPORTED_MODULE_1____["_0" /* Link */],{color:__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].grey,transition:'color 200ms ease','&:hover':{color:'black'}})},'&-title':{textTransform:'uppercase',fontWeight:800,fontSize:'1.125rem'},'&-description, &-description p':{fontSize:'0.9375rem',lineHeight:'1.2rem',color:'black'},'&-picture':{width:'100%',height:460,background:'url('+cover+') no-repeat center',backgroundSize:'cover',margin:'2rem 0'}},'.close':{position:'absolute',top:'2rem',right:'2rem',width:20,height:20,'&:before, &:after':{content:'""',position:'absolute',top:'50%',left:'50%',transformOrigin:'center center',width:20,height:1,background:'black'},'&:before':{transform:'translate(-50%, -50%) rotate(45deg)'},'&:after':{transform:'translate(-50%, -50%) rotate(-45deg)'}}});};

/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ContentLoaderStyle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_emotion__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(1);
var ContentLoaderStyle=function ContentLoaderStyle(ready){return Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])({position:'relative','.content-loader':{position:'fixed',top:80,left:'0',width:80,height:80,textAlign:'center',lineHeight:'80px',transition:'opacity 400ms ease',opacity:ready?0:1,zIndex:0}});};

/***/ }),
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PanStyle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_emotion__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core__ = __webpack_require__(17);
var PanStyle=function PanStyle(x,enable){return Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])({overflow:'auto',maxWidth:'scroll'},!!enable&&{'ul.flex':{justifyContent:'flex-start','& > li':{flex:'1 0 auto'}}});};

/***/ }),
/* 379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GalleryStyle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_emotion__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core__ = __webpack_require__(17);
var GalleryStyle=function GalleryStyle(open,transition){return Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])({position:'relative','.gallery':{'&__pictures':{margin:'0 -0.375rem'},'&__picture':{position:'relative',width:'calc(1/2 * 100%)',height:180,overflow:'hidden',padding:'0.375rem',cursor:'pointer',opacity:0.3,transition:'opacity 300ms ease','&.active':{opacity:1},'img':{width:'100%',height:'100%',objectFit:'cover'},'@media (min-width: 1024px)':{width:'calc(1/4 * 100%)'}},'&__focus':{position:'relative',marginTop:'0.3125rem',display:'inline-block',transition:'transform 400ms ease, visibility 0ms '+(open?0:400)+'ms',transform:'scaleY('+(open?1:0)+')',transformOrigin:'center top',visibility:open?'visible':'hidden',fontSize:0,'img':{width:'auto',height:'auto',maxHeight:500,maxWidth:'100%',opacity:transition?1:0,transition:'opacity 300ms ease','@media (min-width: 1024px)':{maxHeight:500,maxWidth:'none'}},'&-legend':{textAlign:'left',margin:'1rem 0',fontSize:'0.8125rem'}},'&__close':{position:'absolute',top:'2rem',right:'2rem',width:30,height:30,zIndex:2,background:'transparent',border:0,cursor:'pointer',opacity:open?1:0,transition:'opacity 300ms ease '+(open?400:0)+'ms','&:after, &:before':{content:"''",position:'absolute',top:'50%',left:'50%',width:24,height:2,background:'white'},'&:after':{transform:'translate(-50%) rotate(-45deg)'},'&:before':{transform:'translate(-50%) rotate(45deg)'}}}});};

/***/ }),
/* 380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FaqPopinStyle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_emotion__ = __webpack_require__(3);
var FaqPopinStyle=function FaqPopinStyle(){return Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])({position:'fixed',display:'flex',alignItems:'center',justifyContent:'center',top:0,right:0,bottom:0,left:0,backgroundColor:'rgba(255, 255, 255, .9)',zIndex:100,visibility:'hidden',opacity:0,transition:'.4s ease-in-out visibility, .4s ease-in-out opacity','&.is-open':{visibility:'visible',opacity:1},'.popin-inner':{position:'relative',width:880,maxWidth:'calc(100vw - 80px)',padding:80,border:'1px solid #D8D8D8',backgroundColor:'#FFF','@media (max-width: 767px)':{padding:'2rem'},'.error':{fontWeight:300,fontSize:'1rem'}},'.popin-close':{position:'absolute',top:30,right:30,background:'transparent',border:'none',cursor:'pointer',margin:0,padding:0}});};

/***/ }),
/* 381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Form; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_emotion__ = __webpack_require__(3);
//FORM
var Form=Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])({'.btn':{marginTop:'3.75rem'}});

/***/ }),
/* 382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__error__ = __webpack_require__(383);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__error__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__success__ = __webpack_require__(384);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_1__success__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_1__success__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__header__ = __webpack_require__(385);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_2__header__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_2__header__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_2__header__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_2__header__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_2__header__["e"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__panel__ = __webpack_require__(386);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__panel__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__panel__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_3__panel__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__layout__ = __webpack_require__(387);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_4__layout__["a"]; });


/***/ }),
/* 383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ErrorStyle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_emotion__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(1);
var ErrorStyle=Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])({display:'inline-block',width:'100%',padding:'1rem 0px',margin:'1rem 0px',border:'1px solid '+__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].red,color:__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].red});

/***/ }),
/* 384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SuccessStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SuccessStyleInner; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_emotion__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(1);
var SuccessStyle=Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])({display:'inline-block',width:'100%',padding:'1rem 2rem',margin:'1rem 0px',border:'1px solid '+__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].green,color:__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].green,textAlign:'center'});var SuccessStyleInner=Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])({maxWidth:'284px',margin:'0 auto'});

/***/ }),
/* 385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LogoStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return NavStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SecondaryNav; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return MobileNav; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MenuMobileStyle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_emotion__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__typo__ = __webpack_require__(46);
// LOGO
var LogoStyle=Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])({padding:'0px 1.25rem',maxWidth:'200px',flexBasis:'200px','svg':{verticalAlign:'middle'},'a':{color:'black',lineHeight:'1rem'},'span':{fontSize:'1rem',verticalAlign:'middle',display:'inline-block','&:before':{content:'""',height:'1rem',width:1,background:__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].lightGrey,margin:'0px 0.75rem',display:'inline-block',verticalAlign:'middle'}}});//DEFAULT AFTER
var defaultAfterNav={'&:after':{content:'""',position:'absolute',bottom:0,left:0,width:'100%',height:6,background:'#000',transition:'transform 200ms '+__WEBPACK_IMPORTED_MODULE_1____["G" /* Easings */].customEase,transform:'scaleX(0)',transformOrigin:'center left'}};var defaultLiStyle=Object.assign({position:'relative',padding:'0px 1.5rem',cursor:'pointer'},defaultAfterNav);//NAV
var NavStyle=Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])({maxWidth:'calc(100% - 480px)',flexBasis:'calc(100% - 480px)','ul':{justifyContent:'center'},'li':Object.assign({},defaultLiStyle,{'svg':{transition:'fill 400ms ease'},'&:hover':{'span':{color:'black','svg':{fill:'black'}}},'&.active:not(.disable)':{'&:after':{transform:'scaleX(1)'},'&:not(.item-challenge) span':{color:'black','svg':{fill:'black'}}}}),'a.main-nav--item':Object.assign({},defaultLiStyle,{'&.in-view':{'&:after':{transform:'scaleX(1)'},'span':{color:'black','svg':{fill:'black'}}}}),'.middle':{position:'relative',display:'inline-block',verticalAlign:'middle',lineHeight:1.2},'span':Object.assign({},__WEBPACK_IMPORTED_MODULE_1____["_7" /* MenuLink */],{color:__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].mediumGrey,transition:'color 200ms ease','svg':{verticalAlign:'middle',fill:__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].mediumGrey}}),'.item-challenge':{'&:after':{background:__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].red},'span':{color:__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].red}// 'div': {
//   transform: 'translateY(0.3rem)',
// }
},'.main-nav--desc':Object.assign({display:'block'},__WEBPACK_IMPORTED_MODULE_1____["_74" /* XSmall */])});//SECONDARY MENU
var SecondaryNav=Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])({maxWidth:'280px',flexBasis:'280px',justifyContent:'flex-end','.profile-nav':{'@media (min-width: 1224px)':{maxWidth:'calc(100% - 120px)',flexBasis:'calc(100% - 120px)'}},'.btn':Object.assign({display:'block',position:'relative',height:'80px',width:60,border:0,cursor:'pointer',background:'transparent',padding:0,textAlign:'center'},defaultAfterNav,{'svg':{fill:__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].mediumGrey,verticalAlign:'middle',transition:'fill 200ms ease'},'&:hover':{'svg':{fill:'black'}},'&.notification-nav button':{'&.open':{'&:after':{transform:'scaleX(1)'}}},'&.active':{'svg':{fill:'black'},'&:after':{transform:'scaleX(1)'}},'.dot':{position:'absolute',top:'50%',left:'50%',zIndex:4,minWidth:16,height:16,lineHeight:'14px',fontSize:'0.6rem',color:'white',border:'1px solid #FFF',transform:'translate(4px, -10px)',background:__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].red,borderRadius:9999}})});// MENU 
var MobileNav=function MobileNav(open){return Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])({'.mobile-nav':{maxWidth:'calc(1/4 * 100%)',flexBasis:'calc(1/4 * 100%)'},'.btn':Object.assign({display:'block',position:'relative',height:60,width:'100%',border:0,cursor:'pointer',background:'transparent',padding:0,textAlign:'center',fill:__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].mediumGrey},defaultAfterNav,{'@media (min-width: 1024px)':{height:80},'svg':{verticalAlign:'middle'},'.dot':{position:'absolute',top:'50%',left:'50%',zIndex:0,minWidth:16,height:16,lineHeight:'14px',fontSize:'0.6rem',color:'white',border:'1px solid #FFF',transform:'translate(4px, -10px)',background:__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].red,borderRadius:9999},'&.notification-nav button':Object.assign({},defaultAfterNav,{'&.open':{'&:after':{transform:'scaleX(1)'}}}),'&.active:not(.disable)':{'&:after':{transform:'scaleX(1)'}}}),'.menu-nav':Object.assign({},defaultAfterNav,{'span':{position:'absolute',top:'50%',left:'50%',height:2,width:18,background:__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].mediumGrey,transform:'translateX(-50%)',transition:'transform 0.4s ease',transformOrigin:'center left','&:first-child':{transform:'translateY(-50%) translateX(-50%) translateY(-4px)'},'&:last-child':{transform:'translateY(-50%) translateX(-50%) translateY(6px) scaleX(0.6)',transformOrigin:'center left'}}}),'.menu-nav, .search-nav':{'&.active:after:not(.disable)':{transform:'scaleX(1)'}}},open&&{'.menu-nav':{'&:after':{transform:'scaleX(1)'},'span':{'&:first-child':{transform:'translateY(-50%) translateX(-50%) translateY(0px) rotate(-45deg)',transformOrigin:'center center'},'&:nth-child(2)':{transform:'translateX(-50%) scaleX(0.01)'},'&:last-child':{transform:'translateY(-50%) translateX(-50%) translateY(0px) scaleX(1) rotate(45deg)',transformOrigin:'center center'}}}});};// MENU MOBILE 
var MenuMobileStyle=function MenuMobileStyle(open,visible){return Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])({position:'fixed',top:60,left:0,width:'100%',height:'100%',background:'white',zIndex:0,padding:'2rem',transform:'translateX('+(open?0:100)+'%)',transformOrigin:'center left',transition:'transform 400ms ease','.main-nav':{paddingLeft:'calc(1/4 * 100%)','& > li':{textTransform:'uppercase',fontWeight:800,lineHeight:1.2,fontSize:'1.5rem',padding:'1rem 0','&.item-challenge':{color:__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].red},'.main-nav--desc':{display:'block',fontSize:'0.8rem',fontWeight:800}}},'.account-card':{width:'100%',position:'inherit','&--inner':{position:'absolute',bottom:0,left:0,width:'100%',padding:'0 2rem',transform:'translateY(-100%) translateY(-2rem)'}},'.menu-mobile':{'&-head':{position:'fixed',top:-60,left:0,background:'white',borderBottom:'1px solid '+__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].lightGrey,width:'100%',height:60,lineHeight:'60px',transform:'translateX('+(visible?0:100)+'%)',opacity:visible?1:0,transition:'all 300ms '+__WEBPACK_IMPORTED_MODULE_1____["G" /* Easings */].customEase,'@media (min-width: 1024px)':{height:80,lineHeight:'80px'},'&-title':Object.assign({fontSize:'1rem',textTransform:'uppercase',fontWeight:800,color:'black',padding:'0 1rem',position:'relative'},defaultAfterNav,{'&--challenge':{'&:after':{background:__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].red}},'&--inline':{color:__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].red,display:'inline-block',verticalAlign:'middle',lineHeight:1.2,'span':{fontSize:'0.7rem',display:'block'}}}),'&-title:after':{transform:'scaleX(1)'}},'&-return':{width:60,height:60,transform:'scaleX(-1)',textAlign:'center','svg':{fill:__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].lightGrey,verticalAlign:'middle'}},'&-close':{width:60,height:60,position:'absolute',top:0,right:0,padding:0,border:0,background:'none','span':{position:'absolute',top:'50%',left:'50%',width:16,height:2,background:__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].lightGrey,transformOrigin:'center center','&:first-child':{transform:'translateX(-50%) translateY(-50%) rotate(-45deg)'},'&:last-child':{transform:'translateX(-50%) translateY(-50%) rotate(45deg)'}}}}});};

/***/ }),
/* 386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PanelStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BaseStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ChallengePanelStyle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_emotion__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_chirashi__ = __webpack_require__(60);
// Panel
var PanelStyle=function PanelStyle(theme,open,isMobile,load){return Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])({position:'fixed',top:60,left:0,width:'100%',height:'100%',overflow:'auto',background:theme,zIndex:isMobile?3:1,transform:'scaleY('+(open?1:0)+')',transformOrigin:'center top',transition:'transform '+(open?600:300)+'ms '+__WEBPACK_IMPORTED_MODULE_1____["G" /* Easings */].customEase+' '+(open?0:300)+'ms',lineHeight:1,'.panel-transition':{transition:'opacity '+(open&&load?600:200)+'ms ease '+(open&&load?600:0)+'ms',opacity:open&&load?1:0,height:'100%',position:'relative'},'@media (min-width: 1024px)':{top:0,paddingTop:'80px'}});};// Base Style
var BaseStyle=function BaseStyle(bgd,load){return Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])({position:'relative',padding:'2rem 3rem 4rem 3rem',background:'url('+bgd+') no-repeat center',backgroundSize:'cover',minHeight:'100%',transition:'opacity 300ms ease','@media (min-width: 1024px)':{padding:'6rem'},'.panel-content':{position:'relative',zIndex:2,opacity:load?1:0,transform:'translateY('+(load?0:20)+'px)',transition:'all 1s '+__WEBPACK_IMPORTED_MODULE_1____["G" /* Easings */].customEase+' '+(load?600:0)+'ms'},'.panel-inner':{'&--categories':{position:'relative',zIndex:2,maxWidth:'100%',flexBasis:'100%','@media (min-width: 1024px)':{maxWidth:'calc(2/3 * 100%)',flexBasis:'calc(2/3 * 100%)'},'h2':Object.assign({},__WEBPACK_IMPORTED_MODULE_1____["_6" /* MenuH2 */],{color:__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].mediumGrey}),'li':{margin:'1rem 0px'},'a':Object.assign({},__WEBPACK_IMPORTED_MODULE_1____["_0" /* Link */],{fontSize:'1.125rem',letterSpacing:0,color:__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].grey,transition:'color 400ms ease','&.link-all':{fontSize:'0.75rem',letterSpacing:'2.5px',color:'white',position:'relative',display:'inline-block',marginTop:'2rem','&:after':{content:'""',position:'absolute',bottom:-5,left:0,width:'100%',height:1,background:'white',transition:'transform 200ms '+__WEBPACK_IMPORTED_MODULE_1____["G" /* Easings */].customEase,transformOrigin:'center left',transform:'scaleX(0)'},'&:hover':{'&:after':{transform:'scaleX(1)'}}},'&:hover, &.active':{color:'white'}}),'.category':{maxWidth:'100%',flexBasis:'100%','@media (min-width: 768px)':{maxWidth:'50%',flexBasis:'50%'}}},'&--push':{position:'relative',zIndex:2,maxWidth:'100%',flexBasis:'100%',margin:'4rem 0','@media (min-width: 1024px)':{maxWidth:'calc(1/3 * 100%)',flexBasis:'calc(1/3 * 100%)',margin:0},'h3':{color:'white',transform:'translateX(-1.5rem)','@media (min-width: 1024px)':{transform:'none'}}}}},bgd!==''&&{'&:after':{content:'""',position:'absolute',top:0,left:0,width:'100%',height:'100%',background:'black',opacity:'0.8',zIndex:1}});};// Challenge
var ChallengePanelStyle=function ChallengePanelStyle(bgd,load){return Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])({minHeight:'100%',background:'white url('+bgd+') no-repeat center',backgroundSize:'cover',transition:'opacity 300ms ease',// padding: '0px 3rem',
// '@media (min-width: 1024px)': {
//   padding: '4rem 8rem',
// },
'.panel-challenge-content':{opacity:load?0.99:0.01,transform:'translateY('+(load?0:20)+'px)',transition:'all 1s '+__WEBPACK_IMPORTED_MODULE_1____["G" /* Easings */].customEase+' '+(load?600:0)+'ms',paddingBottom:'4rem'},'.challenge-panel':{'&-top':{justifyContent:'center',textAlign:'center'},'&-title':{color:__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].red,marginBottom:'4rem',maxWidth:'100%',flexBasis:'100%','@media (min-width: 1024px)':{maxWidth:'calc(2/3 * 100%)',flexBasis:'calc(2/3 * 100%)'},'h2':Object.assign({},__WEBPACK_IMPORTED_MODULE_1____["_6" /* MenuH2 */],{fontFamily:__WEBPACK_IMPORTED_MODULE_2__core__["c" /* Font */].title_font_bold,margin:0,textTransform:'uppercase',fontWeight:'bold'}),'span':Object.assign({},__WEBPACK_IMPORTED_MODULE_1____["_55" /* Subtitle */],{fontWeight:'bold'})},'&-push':{justifyContent:'center','.push':{maxWidth:'100%',flexBasis:'100%',marginBottom:'2rem',order:-1,'@media (min-width: 1024px)':{maxWidth:'calc(1/3 * 100%)',flexBasis:'calc(1/3 * 100%)',padding:'0 1rem',marginBottom:0},'&:first-child':{paddingLeft:0,marginBottom:0,order:1,'@media (min-width: 1024px)':{paddingRight:'2rem',order:-1}},'&:last-child':{paddingRight:0,marginBottom:0,'@media (min-width: 1024px)':{// paddingRight: '2rem',
marginBottom:0}}}}},'.push-content':{maxWidth:'none',padding:'0px 2rem','@media (min-width: 1024px)':{padding:0},'h3':{color:'black',// transform: 'translateX(-1.5rem)',
'@media (min-width: 1024px)':{// transform: 'translateX(-3rem)',
// minHeight: 96,
marginBottom:'1rem',marginTop:'1rem'}},'a':{borderColor:'black',color:'black','&:hover':{color:'white',background:'black'}},'&--picture':{maxWidth:'none',margin:0}},'.challenge-panel-ranking':{maxWidth:'100%',flexBasis:'100%',marginBottom:'4rem','@media (min-width: 1024px)':{maxWidth:'calc(1/3 * 100%)',flexBasis:'calc(1/3 * 100%)'}},'.ranking-push':{maxWidth:'calc(1/2 * 100%)',flexBasis:'calc(1/2 * 100%)',padding:'0 2rem','@media (min-width: 1024px)':{maxWidth:'calc(1/2 * 100%)',flexBasis:'calc(1/2 * 100%)'}}});};

/***/ }),
/* 387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HeaderMenuStyle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_emotion__ = __webpack_require__(3);
var HeaderMenuStyle=function HeaderMenuStyle(open){return Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])({'.header-outside':{position:'fixed',zIndex:2,top:0,left:0,width:'100%',height:'100%',display:open?'block':'none'}});};

/***/ }),
/* 388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout__ = __webpack_require__(389);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__layout__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__login__ = __webpack_require__(391);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__login__["a"]; });


/***/ }),
/* 389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AuthStyle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_emotion__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__static_login_jpg__ = __webpack_require__(390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__static_login_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__static_login_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2____ = __webpack_require__(1);
var AuthStyle=Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])({display:'flex',flexWrap:'wrap',alignItems:'center',position:'relative',padding:'30px 0px',background:'white url('+__WEBPACK_IMPORTED_MODULE_1__static_login_jpg___default.a+') no-repeat top left',backgroundSize:'contain',minHeight:'100vh',textAlign:'center','@media (min-width: 1024px)':{padding:'50px 0px',backgroundSize:'auto 100%'},'.logo':{margin:'0px auto',height:22,'@media (min-width: 1024px) and (min-height: 800px)':{height:'auto'}},'h2':Object.assign({},__WEBPACK_IMPORTED_MODULE_2____["_55" /* Subtitle */],{margin:0}),'.auth--container':{margin:'0px auto',marginTop:'8vh',padding:'0 2rem',width:'100%',maxWidth:420,'@media (min-width: 1024px)':{padding:'0'},'@media (min-height: 800px)':{marginTop:'11.25rem'}},'.auth--middle':{width:'100%'}});

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/login.4b0b310f.jpg";

/***/ }),
/* 391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LoginStyle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_emotion__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(1);
var LoginStyle=Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])({'.login--bottom':Object.assign({display:'inline-block',marginTop:'8vh'},__WEBPACK_IMPORTED_MODULE_1____["_0" /* Link */],{transition:'all 400ms ease',cursor:'pointer','@media (min-height: 1024px)':{marginTop:'11.25rem'},'a':{color:__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].mediumGrey,transition:'all 400ms ease','&:hover':{color:'black'}}})});

/***/ }),
/* 392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__search__ = __webpack_require__(393);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_0__search__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "J", function() { return __WEBPACK_IMPORTED_MODULE_0__search__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__product__ = __webpack_require__(395);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_1__product__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__gift__ = __webpack_require__(396);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_2__gift__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__hubQuizz__ = __webpack_require__(397);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_3__hubQuizz__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__challenge__ = __webpack_require__(398);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "H", function() { return __WEBPACK_IMPORTED_MODULE_4__challenge__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ranking__ = __webpack_require__(399);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_5__ranking__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__user__ = __webpack_require__(400);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "I", function() { return __WEBPACK_IMPORTED_MODULE_6__user__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__social__ = __webpack_require__(401);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_7__social__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__team__ = __webpack_require__(402);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "C", function() { return __WEBPACK_IMPORTED_MODULE_8__team__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "D", function() { return __WEBPACK_IMPORTED_MODULE_8__team__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__agenda__ = __webpack_require__(403);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_9__agenda__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_9__agenda__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__stock__ = __webpack_require__(404);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_10__stock__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "B", function() { return __WEBPACK_IMPORTED_MODULE_10__stock__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__alerts__ = __webpack_require__(405);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_11__alerts__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__theft__ = __webpack_require__(406);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "E", function() { return __WEBPACK_IMPORTED_MODULE_12__theft__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "F", function() { return __WEBPACK_IMPORTED_MODULE_12__theft__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__catalog__ = __webpack_require__(407);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_13__catalog__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__article__ = __webpack_require__(408);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_14__article__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_14__article__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_14__article__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__quizz__ = __webpack_require__(409);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_15__quizz__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_15__quizz__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_15__quizz__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_15__quizz__["d"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__counterfeits__ = __webpack_require__(410);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_16__counterfeits__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_16__counterfeits__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_16__counterfeits__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__pages__ = __webpack_require__(411);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_17__pages__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_17__pages__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_17__pages__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_17__pages__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_17__pages__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_17__pages__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "K", function() { return __WEBPACK_IMPORTED_MODULE_17__pages__["g"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__training__ = __webpack_require__(412);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "G", function() { return __WEBPACK_IMPORTED_MODULE_18__training__["a"]; });


/***/ }),
/* 393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SearchStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return searchListStyle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_emotion__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__static_search_jpg__ = __webpack_require__(394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__static_search_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__static_search_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2____ = __webpack_require__(1);
var SearchStyle=function SearchStyle(search){return Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])({position:'relative',background:'#000000 url('+__WEBPACK_IMPORTED_MODULE_1__static_search_jpg___default.a+') no-repeat left center fixed',backgroundSize:'contain',overflowX:'hidden',minHeight:'calc(100vh - 120px)','.home-search-list':{display:search?'block':'none'},'.home-featured':{display:!search?'block':'none'},'.card h2':{height:42},'@media (min-width: 1024px)':{minHeight:'calc(100vh - 160px)'}});};var searchListStyle=function searchListStyle(ready){return Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])({margin:'2rem 20px','.search-transition':{opacity:ready?1:0,transform:'translateY('+(ready?0:10)+'px)',transition:'all 400ms ease'},'.search-load':{position:'absolute',top:'50%',left:'50%',transform:'translate(-50%, -50%)',padding:'1rem',opacity:ready?0:1,transition:'all 400ms ease','svg':{'path':{stroke:'#ffffff'},'circle':{fill:'#ffffff'}}// background: 'rgba(255, 255, 255, 0.5)',
},'@media (min-width: 1024px)':{margin:'2rem 8rem 4rem'},'.product-list':{marginTop:'2rem'},'.filter-item .dropdown-label':{'@media (min-width: 1024px)':{color:__WEBPACK_IMPORTED_MODULE_2____["x" /* Colors */].grey,transition:'color 200ms ease','svg':{transition:'color 200ms ease'},'&:hover':{color:'white','svg':{fill:'white'}}}},'.results, .no-results':Object.assign({},__WEBPACK_IMPORTED_MODULE_2____["Z" /* Label */],{color:__WEBPACK_IMPORTED_MODULE_2____["x" /* Colors */].mediumGrey}),'.categories-filter':{margin:'0rem 0px 2rem','@media (min-width: 1024px)':{margin:'1rem 0px 2rem'},'li':{color:'white',padding:'1rem 0px',textTransform:'uppercase',fontWeight:800,position:"relative",margin:'0 1rem',opacity:0.5,cursor:'pointer',transition:'opacity 200ms ease',whiteSpace:'nowrap','&:first-child':{marginLeft:0},'&:after':{content:'""',background:'white',height:4,width:'100%',position:'absolute',bottom:0,left:0,transform:'scaleX(0)',transition:'transform 400ms '+__WEBPACK_IMPORTED_MODULE_2____["G" /* Easings */].customEase,transformOrigin:'center left'},'&:hover':{opacity:1},'&.active':{opacity:1,'&:after':{transform:'scaleX(1)'}}}},'.filter':{margin:'0px -20px'}});};

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/search.3c96d47c.jpg";

/***/ }),
/* 395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProductStyle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_emotion__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(1);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var ProductStyle=function ProductStyle(max,ready,active,hasPdf){var _pdfAnnotation;return Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])({position:'relative',height:'100%',width:'100%',opacity:ready?1:0,transition:'all 1000ms ease 400ms','@media (min-width: 1024px)':{height:'calc(100vh - 160px)'},'.product':{position:'relative',width:'100%',height:'calc(100vh - 120px)','@media (min-width: 1024px)':{height:'calc(100vh - 160px)'}},'.product-template':{height:'calc(100vh - 120px)','@media (min-width: 1024px)':{height:'calc(100vh - 160px)'}},'.product-nav':{position:'fixed',bottom:0,left:0,width:'100%',height:'60px',borderTop:'1px solid '+__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].extraLightGrey,zIndex:3,background:'white','@media (min-width: 1024px)':{height:'80px'},'.btn-return':{borderRight:'1px solid '+__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].extraLightGrey},'.btn-bookmark':{borderRight:'1px solid white'},'.btn':{height:60,lineHeight:'60px',width:60,'svg':{verticalAlign:'middle'},'@media (min-width: 1024px)':{height:'80px',lineHeight:'80px',width:80}},'.pdf-annotation':(_pdfAnnotation={position:'absolute',top:0,right:0,padding:'1rem',transform:'translateY(-125%)',opacity:1,zIndex:10,display:'flex',alignItems:'center'},_defineProperty(_pdfAnnotation,'display','none'),_defineProperty(_pdfAnnotation,'fontSize','0.9375rem'),_defineProperty(_pdfAnnotation,'span',{maxWidth:'210px',textAlign:'center'}),_defineProperty(_pdfAnnotation,'@media (min-width: 1024px)',{display:'flex'}),_defineProperty(_pdfAnnotation,'svg',{marginLeft:'5px'}),_pdfAnnotation),'@keyframes fadeIn':{'0%':{opacity:1,transform:'translateY(-125%)'},'100%':{opacity:0,transform:'translateY(-100%)'}},'.nav':{position:'relative',maxWidth:hasPdf?'calc(100% - 180px)':'calc(100% - 120px)',flexBasis:hasPdf?'calc(100% - 180px)':'calc(100% - 120px)',padding:'0 10px','@media (min-width: 1024px)':{maxWidth:hasPdf?'calc(100% - 240px)':'calc(100% - 160px)',flexBasis:hasPdf?'calc(100% - 240px)':'calc(100% - 160px)',padding:0,'&:after':{content:"''",position:'absolute',bottom:0,left:0,height:4,background:'black',width:'100%',transition:'transform 400ms ease',zIndex:10,transform:'scaleX('+active/max+')',transformOrigin:'center left'}},'li':{position:'relative',cursor:'pointer',width:8,color:__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].grey,height:60,lineHeight:'60px',margin:'0 6px',fontSize:'0.8375rem',transition:'color 200ms ease','&:hover':{color:'black'},'@media (min-width: 1024px)':Object.assign({},__WEBPACK_IMPORTED_MODULE_1____["_45" /* SliderLabel */],{textTransform:"none",height:80,lineHeight:'80px',maxWidth:'calc(1/'+max+' * 100%)',flexBasis:'calc(1/'+max+' * 100%)',textAlign:'center',margin:0}),'span':{display:'inline-block',verticalAlign:'middle',lineHeight:1.2,position:'absolute',top:'20%',whiteSpace:'nowrap',opacity:0,left:0,textTransform:'uppercase','&.reverse':{right:0,left:'auto'},'@media (min-width: 1024px)':{position:'relative',top:0,whiteSpace:'normal',opacity:1,left:0,transform:'none'}},'&:after':{content:'""',width:8,height:8,borderRadius:9999,position:'absolute',left:0,top:'60%',background:__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].lightGrey,'@media (min-width: 1024px)':{display:'none'}},'&.active':{color:'black','span':{opacity:1},'&:after':{background:__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].darkGrey,'@media (min-width: 1024px)':{transform:'scaleX(1)'}}}}}},'.product-slider':{height:'100%',width:'100%'},'.flickity':{'&-viewport':{'@media (max-width: 1023px)':{overflow:'hidden'}},'&-slider':{height:'100%',width:'100%',transform:'none !important'},'&-slide':{opacity:0,transition:'all 0ms ease',height:'100%',width:'100%',top:0,left:'0 !important',zIndex:0,transitionDelay:'600ms',overflow:'hidden','&:first-child':{position:'relative !important',zIndex:1},'.template-content':{opacity:0,transform:'translateY(10px)',transition:'all 400ms '+__WEBPACK_IMPORTED_MODULE_1____["G" /* Easings */].customEase},'.template-bgd':{opacity:0,transition:'all 400ms '+__WEBPACK_IMPORTED_MODULE_1____["G" /* Easings */].customEase},'.template-picture':{'&:before':{content:'""',position:'absolute',top:0,left:0,width:'100%',height:'100%',background:'white',zIndex:10,transition:'all 400ms '+__WEBPACK_IMPORTED_MODULE_1____["G" /* Easings */].customEase,transformOrigin:'center right',transform:'scaleX(1)'},'&--top':{backgroundPosition:'center top'},'&--center':{backgroundPosition:'center center'},'&--bottom':{backgroundPosition:'center bottom'}},'&.is-selected, &[aria-selected="true"]':{opacity:1,zIndex:2,overflow:'visible','.template-content':{opacity:1,transform:'translateY(0px)',transitionDelay:'600ms'},'.template-bgd':{opacity:1,transitionDelay:'500ms'},'&.template-picture, .template-scroll > .template-picture':{'&:before':{transform:'scaleX(0)',transitionDelay:'600ms'}}}}}});};

/***/ }),
/* 396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GiftStyle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_emotion__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core__ = __webpack_require__(17);
var GiftStyle=Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])({'h3':{color:'black'},'.gift':{maxWidth:'100%',flexBasis:'100%',position:'relative',margin:'2rem 0rem','.push-content':{maxWidth:'none','h3':{margin:0},'p':{margin:0,'@media (min-width: 1024px)':{margin:'1rem 0'}},'.picture':{height:210},'&--desc':{transform:'none',marginTop:'1rem'},'&--picture':{height:'auto',maxWidth:'calc(100% - 1.5rem)',marginLeft:'1.5rem','@media (min-width: 1024px)':{maxWidth:'calc(100% - 2.5rem)',marginLeft:'2.5rem'}}},'@media (min-width: 1024px)':{maxWidth:'calc(1/3 * 100%)',flexBasis:'calc(1/3 * 100%)',margin:'1rem 0px'},'&-inner':{position:'relative','@media (min-width: 1024px)':{padding:'0px 2rem'}},'&:nth-child(3n)':{'@media (min-width: 1024px)':{marginTop:'6rem'}},'&:nth-child(3n - 1)':{marginTop:'3rem'},'&:first-child':{maxWidth:'100%',flexBasis:'100%',padding:0,marginTop:0,marginBottom:'4rem','@media (min-width: 1024px)':{// marginBottom: '4rem',
},'.picture':{'@media (min-width: 1024px)':{height:420}},'.gift-number':{transform:'translate(-10px, -60%)'//   '@media (min-width: 1024px)': {
//     transform: 'translate(3.5vw, -8rem)',
//   }
}},'&:nth-child(2)':{maxWidth:'100%',flexBasis:'100%',marginTop:0,'@media (min-width: 1024px)':{maxWidth:'50%',flexBasis:'50%'},'.picture':{height:260,'@media (min-width: 1024px)':{height:320}}},'&:nth-child(3)':{maxWidth:'100%',flexBasis:'100%','@media (min-width: 1024px)':{maxWidth:'50%',flexBasis:'50%'},'.picture':{height:260,'@media (min-width: 1024px)':{height:320}}},'&-number':{color:__WEBPACK_IMPORTED_MODULE_1__core__["a" /* Colors */].extraLightGrey,position:'absolute',top:0,left:0,fontWeight:'bold',fontSize:'6.5rem',transform:'translate(-10%, -65%)','@media (min-width: 1024px)':{fontSize:'9.375rem'},'sup':{fontSize:'2.5rem','@media (min-width: 1024px)':{fontSize:'3.75rem'}}},'&.highlight':{'.gift':{'&-number':{color:__WEBPACK_IMPORTED_MODULE_1__core__["a" /* Colors */].red}}}}});

/***/ }),
/* 397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HubQuizzStyle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_emotion__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__static_quizz_jpg__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__static_quizz_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__static_quizz_jpg__);
var HubQuizzStyle=function HubQuizzStyle(){return Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])({'h2':{textAlign:'center',fontSize:'2rem',fontWeight:'bold',textTransform:'uppercase'},'.quizz':{boxShadow:'0 0 20px 0 '+__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].shadow,'.btn':Object.assign({},__WEBPACK_IMPORTED_MODULE_1____["_0" /* Link */],{display:'inline-block',height:'60px',lineHeight:'60px',padding:'0px 1.5rem','@media (min-width: 1224px)':{padding:'0px 3rem'},'span':{display:'inline-block',verticalAlign:'middle',lineHeight:1.2}}),'&-inner':{backgroundColor:'#000','p':{color:'white'},'h3':{color:'white',fontWeight:'bold',textTransform:'uppercase',margin:0},'.score':{color:__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].red,fontWeight:'bold',fontSize:'1.3125rem'}}},'.current-quizz':{'&-inner':{background:'black url('+__WEBPACK_IMPORTED_MODULE_2__static_quizz_jpg___default.a+') no-repeat center',backgroundSize:'cover',maxWidth:'100%',flexBasis:'100%',padding:'2rem','@media (min-width: 1024px)':{maxWidth:'calc(9/12 * 100%)',flexBasis:'calc(9/12 * 100%)',padding:'5rem'},'h3':Object.assign({},__WEBPACK_IMPORTED_MODULE_1____["_27" /* PushTitle */]),'.btn':{background:__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].red,color:'white',transition:'all 200ms ease','&:hover':{background:'black',color:'white'}}},'&-info':{maxWidth:'100%',flexBasis:'100%',textAlign:'center','@media (min-width: 1024px)':{maxWidth:'50%',flexBasis:'50%',textAlign:'left'}},'&-link':{mmaxWidth:'100%',flexBasis:'100%',display:'flex',justifyContent:'center','@media (min-width: 1024px)':{maxWidth:'50%',flexBasis:'50%',justifyContent:'flex-end'}},'&-days':{maxWidth:'100%',flexBasis:'100%',padding:'2rem',textAlign:'center',color:__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].red,'@media (min-width: 1024px)':{maxWidth:'calc(3/12 * 100%)',flexBasis:'calc(3/12 * 100%)'},'.label':Object.assign({display:'block'},__WEBPACK_IMPORTED_MODULE_1____["_7" /* MenuLink */]),'.days':Object.assign({},__WEBPACK_IMPORTED_MODULE_1____["V" /* H2 */],{fontWeight:'bold',margin:'1rem 0'})}},'.hub-quizz-previous':{margin:'4rem 0','p':{textAlign:'center'},'h3':{fontSize:'2rem'}},'.previous-quizz':{maxWidth:'100%',flexBasis:'100%',margin:'2rem','@media (min-width: 1024px)':{maxWidth:'calc(50% - 2rem)',flexBasis:'calc(50% - 2rem)'},'&:nth-child(odd)':{marginLeft:0},'&:nth-child(even)':{marginRight:0},'.btn':{color:__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].grey,border:'1px solid '+__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].mediumGrey,transition:'all 200ms ease','&:hover':{color:'white',background:'black'}},'&-inner':{padding:'2rem',textAlign:'center',maxWidth:'100%',flexBasis:'100%','@media (min-width: 1024px)':{padding:'4rem 2rem',maxWidth:'calc(1/2 * 100%)',flexBasis:'calc(1/2 * 100%)'}},'&-days':{padding:'2rem',maxWidth:'100%',flexBasis:'100%',textAlign:'center','@media (min-width: 1024px)':{padding:'4rem 2rem',maxWidth:'calc(1/2 * 100%)',flexBasis:'calc(1/2 * 100%)',textAlign:'left'},'p':{textAlign:'center',marginTop:0,'@media (min-width: 1024px)':{textAlign:'left'}}}}});};

/***/ }),
/* 398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UserChallengeStyle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_emotion__ = __webpack_require__(3);
var UserChallengeStyle=Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])({padding:'0rem 2rem 4rem 2rem','@media (min-width: 1024px)':{padding:'0rem 8rem 8rem 8rem'},'.user-challenge':{'&-push':{maxWidth:'calc(1/2 * 100%)',flexBasis:'calc(1/2 * 100%)','@media (min-width: 1024px)':{maxWidth:'calc(1/4 * 100%)',flexBasis:'calc(1/4 * 100%)'},'& > div:first-child':{padding:'2rem 0px','@media (min-width: 1024px)':{padding:'3rem 0px'}}},'&-charts':{textTransform:'uppercase',fontWeight:'bold',marginTop:'2rem','@media (min-width: 1024px)':{marginTop:0},'canvas':{margin:'2rem 0',width:'100%',height:'250px','@media (min-width: 1024px)':{height:'600px'}}}}});

/***/ }),
/* 399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RankingStyle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_emotion__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__typo__ = __webpack_require__(46);
var RankingStyle=function RankingStyle(ready){return Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])({'.filter-ranking, .ranking-position-go':{transition:'opacity 400ms ease',opacity:ready?1:0},'.ranking-user':{margin:'4rem auto',maxWidth:800,'&-line':{justifyContent:'center',padding:'0.5rem','&.current':{border:'2px solid #000'}},'&-name, &-pos':Object.assign({},__WEBPACK_IMPORTED_MODULE_1____["_22" /* ProfileName */],{fontWeight:'bold',color:'black'}),'&-name':{maxWidth:'calc(1/2 * 100% - 60px)',flexBasis:'calc(1/2 * 100% - 60px)'},'&-pos':{width:60},'&-localisation':Object.assign({},__WEBPACK_IMPORTED_MODULE_1____["_22" /* ProfileName */],{textTransform:'uppercase',fontWeight:'bold',color:__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].lightGrey,maxWidth:'calc(1/2 * 100% - 60px)',flexBasis:'calc(1/2 * 100% - 60px)'}),'&-score':Object.assign({},__WEBPACK_IMPORTED_MODULE_1____["r" /* CardSmall */],{fontWeight:'bold',color:__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].red,width:60,textAlign:'right'})},'.ranking-position-go':Object.assign({},__WEBPACK_IMPORTED_MODULE_2__typo__["f" /* Link */],{position:'fixed',bottom:40,right:40,background:'transparent',border:0,display:'flex','.label':{maxWidth:100,flexBasis:100}})});};

/***/ }),
/* 400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UserInformationStyle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_emotion__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(1);
var UserInformationStyle=function UserInformationStyle(cover,ready){return Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])({'.user-form-edit':{margin:'4rem auto',maxWidth:1000,padding:'0 20px','&-picture':{width:'100%','@media (min-width: 1024px)':{width:240},'.picture':{height:240,background:'url('+cover+') no-repeat center',backgroundSize:'cover',position:'relative','svg':{position:'absolute',top:'50%',left:'50%',transform:'translate(-50%, -50%)',transition:'opacity 200ms ease',opacity:ready?0:1}}},'&-information':{maxWidth:'100%',flexBasis:'100%','@media (min-width: 1024px)':{maxWidth:'calc(100% - 240px)',flexBasis:'calc(100% - 240px)',paddingLeft:'4rem'},'.form-row':{margin:'1rem 0','&:first-child':{marginTop:0},'.label, .information':Object.assign({},__WEBPACK_IMPORTED_MODULE_1____["r" /* CardSmall */],{textTransform:'uppercase',color:__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].mediumGrey,fontWeight:'bold'}),'.information':{color:'black',maxWidth:'100%',flexBasis:'100%',margin:'0.5rem 0','@media (min-width: 1024px)':{maxWidth:'calc(100% - 250px)',flexBasis:'calc(100% - 250px)',paddingLeft:'1rem'}},'.label':{width:110},'.button':{width:'100%','@media (min-width: 1024px)':{width:140},'button':{margin:0}},'input[type="password"]':{width:'90%','@media (min-width: 1024px)':{fontSize:'1rem'}},'input[type="password"] + label':{textTransform:'none',fontSize:'1rem'},'input[type="password"]:disabled':{border:0,background:'none',color:'black',fontSize:'1.2rem'},'.alert > p':{fontWeight:200,fontSize:'0.8rem',padding:'0 1rem',textAlign:'center'}},'.pass-row':{'.btn-request-pass':{alignSelf:'flex-end'}},'.logout-btn':Object.assign({display:'block'},__WEBPACK_IMPORTED_MODULE_1____["_0" /* Link */],{background:'black',width:'100%',height:60,lineHeight:'60px',textAlign:'center',margin:'4rem auto','@media (min-width: 1024px)':{width:240,margin:'4rem 0px 0px auto'},'svg':{fill:'white',marginRight:'1rem',verticalAlign:'middle'},'span':{color:'white'},'&:hover':{background:__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].red,color:'white'}})},'select':{appearance:'none',width:'90%',border:0,borderBottom:'1px solid '+__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].lightGrey,padding:'1rem 0',fontSize:'1rem',borderRadius:0,color:__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].mediumGrey,background:'white'}}});};

/***/ }),
/* 401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SocialStyle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_emotion__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(1);
var SocialStyle=Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])({'.social':{'&-col':{maxWidth:'100%',flexBasis:'100%','@media (min-width: 1024px)':{maxWidth:'calc(1/3 * 100% - 2rem)',flexBasis:'calc(1/3 * 100% - 2rem)',margin:'0 1rem'},'&:first-child':{marginLeft:0},'&:last-child':{marginRight:0}},'&-box':{padding:'1rem',margin:'2rem 0',border:'1px solid '+__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].mediumGrey,'@media (min-width: 1O24px)':{margin:'4rem 0',padding:'2rem'}},'&-title':{textTransform:'uppercase',margin:0,wordBreak:'break-all'},'&-date':{fontSize:'0.75rem'},'&-desc':{fontSize:'0.9375rem'},'&-head':{maxWidth:'calc(100% - 40px)',flexBasis:'calc(100% - 40px)',marginLeft:'10px'},'&-container':{margin:'2rem 0','@media (min-width: 1024px)':{margin:'4rem 0'}}},'a':{color:'black'},'img':{maxWidth:'100%',maxHeight:'100%'}});

/***/ }),
/* 402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TeamStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TeamCardStyle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_emotion__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(1);
var TeamStyle=function TeamStyle(userReady){return Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])({'.team-filter':{margin:'0 2rem'},'.teams-inner':{maxWidth:1400,margin:'4rem auto',opacity:userReady?1:0,transform:'translateY('+(userReady?0:10)+'px)',transition:'all '+(userReady?400:200)+'ms ease','h2':Object.assign({textAlign:'center'},__WEBPACK_IMPORTED_MODULE_1____["_56" /* SubtitlePage */])},'h3':{fontSize:'1.125rem'},'.team':{maxWidth:'50%',flexBasis:'50%',margin:'1rem 0','&:nth-child(even)':{paddingLeft:'0.5rem'},'&:nth-child(odd)':{paddingRight:'0.5rem'},'@media (min-width: 1024px)':{maxWidth:'50%',flexBasis:'50%',margin:'2rem 0','&:nth-child(even)':{paddingLeft:'2rem'},'&:nth-child(odd)':{paddingRight:'2rem'}}}});};var TeamCardStyle=function TeamCardStyle(cover,active){return Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])({'.team':{'&-picture':{background:'black url('+cover+') no-repeat center',backgroundSize:'cover',maxWidth:'100%',flexBasis:'100%',height:240,'@media (min-width: 1024px)':{maxWidth:'calc(1/3 * 100%)',flexBasis:'calc(1/3 * 100%)'}},'&-inner':{position:'relative',background:'white',boxShadow:'0 0 20px 0 '+__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].shadow,'@media (min-width: 1024px)':{height:240}},'&-verso':{background:'black',position:'absolute',top:0,left:0,width:'100%',height:'100%',display:active?'block':'none',color:'white',zIndex:2,padding:'1rem','@media (min-width: 1024px)':{paddingTop:'2rem',paddingRight:'calc(1rem + 40px)',paddingBottom:'2rem',paddingLeft:'2rem'}},'&-information':{position:'relative',padding:'1rem',maxWidth:'100%',flexBasis:'100%','@media (min-width: 1024px)':{maxWidth:'calc(2/3 * 100%)',flexBasis:'calc(2/3 * 100%)',padding:'2rem'}},'&-link':Object.assign({},__WEBPACK_IMPORTED_MODULE_1____["_0" /* Link */],{color:__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].grey,'@media (min-width: 1024px)':{bottom:'2rem',left:'2rem',position:'absolute',cursor:'pointer'}}),'&-job, &-name':{textTransform:'uppercase'},'&-name':{margin:0},'&-job':Object.assign({},__WEBPACK_IMPORTED_MODULE_1____["r" /* CardSmall */],{fontSize:'1rem',marginBottom:'1rem'}),'&-description, &-description p':Object.assign({},__WEBPACK_IMPORTED_MODULE_1____["r" /* CardSmall */],{fontSize:'1rem',lineHeight:1.4}),'&-close':{position:'absolute',top:'1rem',right:'1rem',width:12,height:12,cursor:'pointer','@media (min-width: 1024px)':{width:20,height:20},'&:after, &:before':{content:'""',position:'absolute',width:'100%',height:2,background:'white',top:'50%',left:0,transformOrigin:'center center',zIndex:3},'&:after':{transform:'rotate(45deg)'},'&:before':{transform:'rotate(-45deg)'}}}});};

/***/ }),
/* 403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AgendaStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DatePickerStyle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_emotion__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(1);
var AgendaStyle=function AgendaStyle(ready){return Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])({paddingBottom:'1rem','.agenda':{'&-container':{position:'relative',maxWidth:1440,margin:'2rem auto 8rem'},'&-title':{textTransform:'uppercase',fontWeight:800,fontSize:'0.75rem'},'&-transition':{opacity:ready?1:0,transition:'all 400ms ease',transform:'translateY('+(ready?0:10)+'px)'},'&-upcomming, &-past-event':{margin:'2rem 0'},'&-past':{marginTop:'4rem'},'&-load':{position:'absolute',left:'50%',top:300,zIndex:10,opacity:ready?0:1,transition:'all 400ms ease'}}});};var DatePickerStyle=Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])({textAlign:'center','.react-datepicker':{border:0,fontFamily:__WEBPACK_IMPORTED_MODULE_1____["Q" /* Font */].base,width:'100%','&__tirangle':{display:'none'},'&__month':{'@media (min-width: 1024px)':{marginTop:'2rem'},'&-container':{float:'none'}},'&__header':{background:'none',border:0},'&__day--outside-month, &__day-names':{'@media (min-width: 1024px)':{display:'none'}},'&__day-name':{width:'38px',fontSize:'1rem'},'&__week':{'@media (min-width: 1024px)':{display:'inline-block',verticalAlign:'middle'}},'&__day':{fontSize:'1rem',color:'black',fontFamily:__WEBPACK_IMPORTED_MODULE_1____["Q" /* Font */].base,fontWeight:800,width:'36px',textAlign:'center',padding:'10px 0px',border:'2px solid transparent',margin:0,'&:hover':{background:'none',borderRadius:0,borderColor:__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].lightGrey},'&:before':{display:'none',textAlign:'center',fontWeight:200,marginBottom:10,fontSize:' 0.865rem','@media all and (min-width: 1024px)':{display:'block'}},'&--fri:before':{content:"'F'"},'&--sat:before':{content:"'S'"},'&--mon:before':{content:"'M'"},'&--sun:before':{content:"'S'"},'&--tue:before':{content:"'T'"},'&--thu:before':{content:"'T'"},'&--wed:before':{content:"'W'"}},'&__current-month':{fontSize:'2rem',textTransform:'uppercase',fontWeight:800,'@media (min-width: 1024px)':{fontSize:'2rem'}},'&__day--highlighted':{background:'none',color:__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].red,'&:before':{color:'black'}},'&__day--selected, &__day--in-selecting-range, &__day--in-range, &__day--selected:hover, &__day--in-selecting-range:hover, &__day--in-range:hover':{background:__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].red,color:'white',borderRadius:0,'&:hover':{borderColor:__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].red},'&:before':{color:'white'}},'&__day--today':{background:'none',borderRadius:0,borderColor:'black',color:'black','&:before':{color:'black'},'&.react-datepicker__day--highlighted':{color:__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].red},'&.react-datepicker__day--selected':{background:__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].red,color:'white','&:before':{color:'white'}}},'.react-datepicker__day--outside-month':{color:__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].lightGrey}}});

/***/ }),
/* 404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return StockStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StockLineStyle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_emotion__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(1);
var StockStyle=function StockStyle(ready){return Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])({maxWidth:'1400px',margin:'0 auto',minHeight:'100vh','@media (min-width: 1024px)':{maxWidth:'calc(10/12 * 100%)'},'.print-head':{textAlign:'center',display:'none','&-title':{textTransform:'uppercase',fontWeight:'bold',margin:'1rem 0 2rem',fontSize:'2rem'}},'.stock':{'&-filter':{position:'relative'},'&-zone':Object.assign({},__WEBPACK_IMPORTED_MODULE_1____["_0" /* Link */],{background:'black',display:'inline-block',margin:'0px auto 2rem auto',height:60,lineHeight:'60px',padding:'0 2rem',color:'white','@media (min-width: 1024px)':{margin:'0px auto 6rem auto'},'svg':{fill:'white',verticalAlign:'middle',marginRight:'1rem'}}),'&-button':{position:'fixed',bottom:'0',right:0,width:60,zIndex:3,opacity:ready?1:0,transition:'opacity 400ms ease 400ms','@media (min-width: 1024px)':{width:80},'button':{width:60,height:60,padding:0,textAlign:'center',margin:0,'@media (min-width: 1024px)':{width:80,height:80},'svg':{margin:0},'&.btn-edit':{'svg':{fill:'white'}}},'.tooltip':{position:'absolute',top:'auto',bottom:0,right:60,width:'calc(100vw - 60px)',fontSize:'0.9rem',fontFamily:__WEBPACK_IMPORTED_MODULE_1____["Q" /* Font */].base,padding:'0 1rem',height:60,background:'rgba(255, 255, 255, 0.5)','@media (min-width: 1024px)':{top:'50%',right:80,width:220,transform:'translateY(-50%)',height:80},'&-label':{maxWidth:'calc(100% - 30px)',flexBasis:'calc(100% - 30px)'},'svg':{transform:'rotate(-90deg)'}}},'&-table':{marginBottom:'4rem',overflow:'auto',display:'flex',flexWrap:'wrap','@media (min-width: 1024px)':{display:'inherit',flexWrap:'inherit'},'.head':{position:'relative',color:__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].grey,fontSize:'0.8rem',fontFamily:__WEBPACK_IMPORTED_MODULE_1____["Q" /* Font */].title,fontWeight:'bold',textTransform:'uppercase',borderBottom:'1px solid '+__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].extraLightGrey,padding:'1rem 0',flexWrap:'nowrap',paddingRight:120,'@media (min-width: 1024px)':{paddingRight:0,width:'100%',flexWrap:'wrap'},'&-item':{padding:'0 0.5rem',flexShrink:0},'.quantity, .price':{textAlign:'right'},'.quantity':{position:'absolute',right:0,top:0,padding:'1rem 0',background:'white',textAlign:'center','@media (min-width: 1024px)':{position:'relative',padding:0}}},'.quantity':{width:'120px',flexShrink:0,'.qty-number':{fontSize:'1.2rem',fontWeight:'bold',textAlign:'center',width:'100%',padding:'0 25px',background:__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].extraLightGrey,'&:after':{content:'""',position:'absolute',top:0,left:-8,width:'100%',height:'100%',background:'linear-gradient(to right, rgba(0,0,0,0) 0%,rgba(0,0,0,0.5) 25%,rgba(0,0,0,0) 100%)',zIndex:-1,'@media (min-width: 1024px)':{display:'none'}}}},'.ref':{width:'120px','@media (min-width: 1024px)':{width:'100px'}},'.model':{width:'120px','@media (min-width: 1024px)':{width:'80px'}},'.desc':{width:200,'@media (min-width: 1024px)':{maxWidth:'calc(2/5 * 100% - 440px/3)',flexBasis:'calc(2/5 * 100% - 440px/3)',width:'auto'}},'.picture':{width:80,'@media (min-width: 1024px)':{maxWidth:'calc(1.5/5 * 100% - 440px/3)',flexBasis:'calc(1.5/5 * 100% - 440px/3)',width:'auto'}},'.material':{width:200,'@media (min-width: 1024px)':{maxWidth:'calc(1.5/5 * 100% - 440px/3)',flexBasis:'calc(1.5/5 * 100% - 440px/3)',width:'auto'}},'.price':{textAlign:'right',width:'140px'}},'&-line':{position:'relative',width:'100%',alignItems:'center',borderBottom:'1px solid '+__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].extraLightGrey,fontSize:'0.9rem',fontFamily:__WEBPACK_IMPORTED_MODULE_1____["Q" /* Font */].base,flexWrap:'nowrap',flexShrink:0,paddingRight:120,'@media (min-width: 1024px)':{paddingRight:0,flexWrap:'wrap'},'.model':{fontWeight:'bold'},'.picture, .quantity':{height:80,lineHeight:'80px'},'.quantity':{background:__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].extraLightGrey,color:__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].red,position:'absolute',top:0,right:0,zIndex:5,'@media (min-width: 1024px)':{position:'relative'},'&.body-item':{padding:0},'&.fixed':{position:'fixed'}},'.body-item':{padding:'0 0.5rem',flexShrink:0},'&.no-stock':{'.quantity':{color:'black'}}},'&-search':{width:'100%',padding:'1rem',textAlign:'center','@media (min-width: 1024px)':{position:'absolute',top:0,maxWidth:360},'input':{borderBottom:'0px !important',margin:0,fontSize:'0.825rem','& + label':{textTransform:'uppercase',fontWeight:800,fontSize:'0.825rem',color:'black',width:'100%','svg':{fill:'black',verticalAlign:'middle'}}}}},'@media print':{'.print-head':{display:'block'}}});};var StockLineStyle=function StockLineStyle(picture,first,disabled){return Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])({'&.no-stock':{opacity:first?1:0.5,display:disabled&&!first?'none':'flex'},'.picture':{background:'url('+picture+') no-repeat left center',backgroundSize:'60%'}});};

/***/ }),
/* 405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CounterfeitStyle; });
/* unused harmony export TheftStyle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_emotion__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(1);
var CounterfeitStyle=Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])({marginBottom:'4rem','.counterfeit':{'&-content':{maxWidth:'calc(10/12 * 100%)',flexBasis:'calc(10/12 * 100%)',marginLeft:'calc(1/12 * 100%)'},'&-title':{color:__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].red,fontSize:'3rem',marginBottom:'2rem',textTransform:'uppercase','svg':{verticalAlign:'middle',fill:__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].red}},'&-subtitle':{fontSize:'2rem',textTransform:'uppercase',fontWeight:'bold',marginBottom:'2rem','&:after':{content:"''",display:'block',margin:'1rem 0',height:4,width:50,background:'black'}},'&-bloc':{margin:'2rem 0','@media (min-width: 1024px)':{margin:'4rem 0'},'.bloc':{'&-title':{fontSize:'1.125rem',textTransform:'uppercase',fontWeight:'bold',margin:'1rem 0'}},'.video-container':{margin:'2rem 0','@media (min-width: 1024px)':{margin:'4rem 0'}}}}});var TheftStyle=Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])({});

/***/ }),
/* 406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TheftsStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TheftSoloStyle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_emotion__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core__ = __webpack_require__(17);
var TheftsStyle=Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])({'.theft':{'&-container':{margin:'4rem auto',width:'100%',maxWidth:1000,'h2':Object.assign({textAlign:'center'},__WEBPACK_IMPORTED_MODULE_1____["_56" /* SubtitlePage */],{textTransform:'uppercase',fontWeight:800,marginBottom:'4rem'})},'&-select, &-ref':{maxWidth:'100%',flexBasis:'100%',marginBottom:'1rem','@media (min-width: 1024px)':{maxWidth:'calc(50% - 50px)',flexBasis:'calc(50% - 50px)',marginBottom:0}},'&-submit':{width:'100%',textAlign:'right','@media (min-width: 1024px)':{width:'100px',alignSelf:'center',textAlign:'center'},'button':Object.assign({background:'none'},__WEBPACK_IMPORTED_MODULE_1____["_0" /* Link */],{border:0,cursor:'pointer',padding:'1rem','@media (min-width: 1024px)':{padding:0,marginRight:'1rem'}})},'&-select':{'@media (min-width: 1024px)':{paddingRight:'2rem'}},'&-ref':{'@media (min-width: 1024px)':{paddingLeft:'2rem'}}},'form':{width:'100%',marginBottom:'4rem'},'.theft-result__loader':{textAlign:'center'},'.error':{textAlign:'center'}});var TheftSoloStyle=Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])({'.theft-form':{maxWidth:'900px',margin:'4rem auto','.form-field':{marginBottom:'1rem'}},'.content-loader':{textAlign:'center'}});

/***/ }),
/* 407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CatalogStyle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_emotion__ = __webpack_require__(3);
var CatalogStyle=Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])({'.list':{justifyContent:'center'},'.card':{maxWidth:'50%',flexBasis:'50%',minWidth:0,padding:'0.5rem',margin:'1rem 0px','&:first-child, &:last-child':{padding:'0.5rem'},'@media (min-width: 1024px)':{maxWidth:'calc(1/3 * 100%)',flexBasis:'calc(1/3 * 100%)'},'@media (min-width: 1220px)':{maxWidth:'25%',flexBasis:'25%'}},'.card-info':{minHeight:'150px'},'.catalog-filter':{margin:' 0px -20px','@media (min-width: 1024px)':{margin:0}},'&.catalog':{'.page-inner':{paddingTop:0,'@media (min-width: 1024px)':{paddingTop:'4rem'}}}});

/***/ }),
/* 408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return NewsStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return NewsCardStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ArticleStyle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_emotion__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core__ = __webpack_require__(17);
var NewsStyle=Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])({'.spotlight':{'&-title':{textTransform:'uppercase',fontSize:'1.125rem'},'&-news':{'.news-info':{maxWidth:'100%',flexBasis:'100%','@media (min-width: 1024px)':{maxWidth:'calc(100% - 160px)',flexBasis:'calc(100% - 160px)'}},'.news-link':{display:'block',height:60,lineHeight:'60px',textAlign:'left','@media (min-width: 1024px)':{textAlign:'center',height:80,lineHeight:'80px'}},'.news-picture':{position:'relative',height:260,'@media (min-width: 1024px)':{height:540}},'.news-button':{justifyContent:'flex-end'},'.news-right':{width:'100%',display:'flex','@media (min-width: 1024px)':{width:160,display:'block'},'.news-link':{paddingLeft:'2rem',maxWidth:'calc(100% - 120px)',flexBasis:'calc(100% - 120px)','@media (min-width: 1024px)':{maxWidth:'100%',flexBasis:'100%',padding:0}}}}},'.publication-list':{margin:'4rem auto 0 auto',maxWidth:'1200px','.filter':{justifyContent:'flex-start'},'.news':{'&-picture':{height:240,maxWidth:'100%',flexBasis:'100%','@media (min-width: 1024px)':{maxWidth:'calc(1/3 * 100% - 40px)',flexBasis:'calc(1/3 * 100% - 40px)'}},'&-info':{position:'relative',maxWidth:'100%',flexBasis:'100%','@media (min-width: 1024px)':{maxWidth:'calc(2/3 * 100% - 40px)',flexBasis:'calc(2/3 * 100% - 40px)'}},'&-button':{width:'100%',alignSelf:'flex-end',justifyContent:'flex-end',display:'flex','@media (min-width: 1024px)':{width:80,justifyContent:'flex-start',display:'block'}},'&-link':{position:'absolute',bottom:-36,left:'2rem','@media (min-width: 1024px)':{bottom:'2rem'}}}}});var defaultNews={'&-date':{color:__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].mediumGrey},'&-title':{textTransform:'uppercase',fontSize:'2rem',fontWeight:'bold',color:'black'},'&-info':{padding:'2rem'},'&-link':Object.assign({},__WEBPACK_IMPORTED_MODULE_1____["_0" /* Link */],{color:__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].mediumGrey})};var NewsCardStyle=function NewsCardStyle(picture){return Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])({width:'100%',background:'white',boxShadow:'0 0 20px 0 '+__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].shadow,margin:'2rem 0','.news':Object.assign({},defaultNews,{'&-picture':{position:'relative',overflow:'hidden','&:after':{content:'""',position:'absolute',top:0,left:0,width:'100%',height:'100%',background:'#000 url('+picture+') no-repeat center',backgroundSize:'auto 100%',transition:'transform 1000ms '+__WEBPACK_IMPORTED_MODULE_2__core__["b" /* Easings */].customEase}}}),'&:hover':{'.news-picture:after':{transform:'scale(1.2)'}}});};var ArticleStyle=Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])({position:'relative',zIndex:2,'@media (min-width: 1024px)':{'.btn-pdf':{borderTop:'1px solid white'}},'.news':Object.assign({maxWidth:'100%',flexBasis:'100%',order:-1,'@media (min-width: 1024px)':{maxWidth:'calc(100% - 80px)',flexBasis:'calc(100% - 80px)',order:1},'&-inner':{maxWidth:'100%',margin:'4rem 1rem',textAlign:'center','@media (min-width: 1024px)':{margin:'4rem auto',width:'calc(9/11 * 100%)',maxWidth:960}}},defaultNews,{'&-content':{maxWidth:680,margin:'2rem auto','p':{textAlign:'left'// textAlign: 'justify',
// textAlignLast: 'center',
}},'&-cover':{margin:'4rem auto'},'&-picture':{height:600,backgroundSize:'contain',backgroundRepeat:'no-repeat',backgroundPosition:'center center'},'&-legend':{textAlign:'left',margin:'1rem 0',fontSize:'0.8125rem'},'&__nav':{marginTop:'2rem',display:'none','@media (min-width: 1024px)':{display:'flex'},'&-item':{width:'50%',textTransform:'uppercase','&--full':{width:'100%'},'a':{color:__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].grey,fontWeight:'bold',fontSize:'0.8125rem'}},'.btn--arrow':{background:__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].extraLightGrey,width:80,height:80,lineHeight:'80px',display:'inline-block',textAlign:'center','svg':{fill:__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].grey,verticalAlign:'middle'}}},'&__previous':{textAlign:'left','.btn--arrow':{marginRight:'1rem'},'svg':{transform:'scale(-1)'}},'&__next':{textAlign:'right','.btn--arrow':{marginLeft:'1rem'}}}),'.news-title':{position:'relative','&:after':{content:"''",display:"block",width:50,height:4,background:'black',margin:'1rem auto'}}});

/***/ }),
/* 409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return QuizzStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return QuizzContainerStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return QuizzSlidesStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return QuizzFinalStyle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_emotion__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__static_quizz_jpg__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__static_quizz_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__static_quizz_jpg__);
var QuizzStyle=Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])({position:'relative',padding:'4rem',background:'black url('+__WEBPACK_IMPORTED_MODULE_2__static_quizz_jpg___default.a+') no-repeat center ',backgroundSize:'cover',color:'white',height:'100%','@media (min-width: 1024px)':{height:'calc(100vh - 80px)'},'.quizz':{'&-title':Object.assign({textAlign:'center'},__WEBPACK_IMPORTED_MODULE_1____["j" /* Brand */],{fontWeight:200,lineHeight:1,'svg':{fill:'white',marginRight:'1rem'}}),'&-up':{textTransform:'uppercase',fontWeight:'bold'},'&-subtitle':{fontSize:'2rem'}},'&.quizz-intro':{textAlign:'center',display:'flex',flexDirection:'column',justifyContent:'center','.quizz-container':{margin:'4rem 0'},'.quizz-date':{justifyContent:'center','.quizz-start, .quizz-end':{margin:'1rem'},'.date':{color:__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].mediumGrey}},'.quizz-description':{maxWidth:500,margin:'1rem auto'}},'button':{maxWidth:150,color:'white'}});var QuizzContainerStyle=function QuizzContainerStyle(ready){return Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])({'.quizz-title, .quizz-container':{opacity:ready?1:0,transition:'all 400ms ease',transform:'translateY('+(ready?0:10)+'px)'}});};var QuizzSlidesStyle=function QuizzSlidesStyle(cover,timer,ready,nextStep,type){return Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])({position:'relative',padding:'4rem',background:'black',overflow:'hidden',color:'white',height:'100%','@media (min-width: 1024px)':{height:'calc(100vh - 80px)'},'&:after':{content:"''",position:"absolute",top:0,left:0,width:'100%',height:'100%',background:'url('+__WEBPACK_IMPORTED_MODULE_2__static_quizz_jpg___default.a+') no-repeat center left',backgroundSize:'cover',transform:'translateX(50%)',zIndex:1},'.quizz':{'&-container':{position:'relative',zIndex:2,opacity:ready?1:0,transition:'opacity 300ms ease'},'&-picture':{maxWidth:'100%',flexBasis:'100%',height:300,background:'url('+cover+') no-repeat center',backgroundSize:type,'@media (min-width: 1024px)':{maxWidth:'calc(1/2 * 100%)',flexBasis:'calc(1/2 * 100%)',height:'calc(100vh - 160px - 8rem)'}},'&-question':{maxWidth:'100%',flexBasis:'100%','@media (min-width: 1024px)':{maxWidth:'calc(1/2 * 100%)',flexBasis:'calc(1/2 * 100%)',paddingLeft:'4rem'}},'&-pagination':{fontSize:'1.125rem',fontWeight:800,'&-active':{color:__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].red,marginRight:'1rem',paddingRight:'1rem',borderRight:'1px solid white'}},'&-category':{position:'relative',textTransform:'uppercase',fontWeight:800,fontSize:'3rem',margin:'2.5rem 0','&:after':{content:'""',display:'block',width:50,height:4,background:'white',margin:'2.5rem 0'}},'&-title':{textTransform:'uppercase',fontWeight:800,fontSize:'1.125rem',margin:'2rem 0'},'&-valid':{margin:'2rem 0','.quizz-timer':{maxWidth:'100%',flexBasis:'100%','@media (min-width: 1024px)':{maxWidth:'calc(100% - 2rem - 150px)',flexBasis:'calc(100% - 2rem - 150px)'},'.time':{fontSize:'0.75rem',marginLeft:'1rem',fontWeight:800},'.timer':{position:'relative',height:2,background:__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].grey,width:'calc(100% - 40px)',maxWidth:'calc(100% - 40px)',flexBasis:'calc(100% - 40px)','&-progress':{background:__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].red,position:'absolute',top:0,left:0,width:(timer===0?0:100)+'%',height:'100%',transformOrigin:'center left'}}},'button':{width:150,color:'white','@media (min-width: 1024px)':{marginLeft:'2rem'}}},'&-choices':{'.checkbox':{margin:'0.5rem 0','&:hover':{'input + label':{color:'white','&:after':{background:'white'},'&:before':{borderColor:'white'}}},'svg':{fill:'white',verticalAlign:'middle',display:'none',marginLeft:'0.5rem'},'input:checked + label':{'&:after':{background:'white'},'&:before':{borderColor:'white'}}},'&:not(.quizz-choices--current)':{'.checkbox':{'&.bad':{'label':{color:__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].red,textDecoration:'line-through'}},'&.good, &.valid':{'svg':{display:'inline'}},'&.good':{'label':{color:__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].green},'svg':{fill:__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].green}},'&.valid':{'label':{color:'white'}}}}}},'.btn-next-question':{textAlign:'right','button':{maxWidth:150}},'@keyframes scaleX':{'from':{transform:'scaleX(1)'},'to':{transform:'scaleX(0)'}}},ready&&{'.quizz':{'&-timer':{'.timer-progress':{animation:'scaleX '+(timer+0.2)+'s linear forwards'}}}});};var QuizzFinalStyle=Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])({position:'relative',padding:'4rem',background:'black url('+__WEBPACK_IMPORTED_MODULE_2__static_quizz_jpg___default.a+') no-repeat center ',backgroundSize:'cover',color:'white',textAlign:'center',textTransform:'uppercase',fontWeight:800,justifyContent:'center',flexDirection:'column',minHeight:'calc(100vh - 60px)','@media (min-width: 1024px)':{height:'calc(100vh - 80px)'},'.quizz-final':{'&-middle':{justifyContent:'center',flexDirection:'column'},'&-title':{fontSize:'3rem'},'&-name':{fontSize:'2rem',margin:'1rem 0'},'&-score':{color:__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].red,fontSize:'4.375rem'},'&-next':{position:'absolute',bottom:'4rem',left:0,width:'100%'}}});

/***/ }),
/* 410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CounterfeitsCardStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CounterfeitsContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CounterfeitContentStyle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_emotion__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__typo__ = __webpack_require__(46);
var CounterfeitsCardStyle=Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])({alignItems:'center',padding:'1rem 2rem',background:'white',boxShadow:' 0 0 20px 0 '+__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].shadow,margin:'2rem 0','.counterfeit':{'&-title':{color:__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].red,textTransform:'uppercase',fontWeight:'bold',maxWidth:'100%',flexBasis:'100%',margin:'1rem 0','@media (min-width: 1024px)':{maxWidth:'calc(100% - 240px)',flexBasis:'calc(100% - 240px)',margin:0},'svg':{fill:__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].red,marginRight:'1rem',verticalAlign:'middle'}},'&-subtitle':{},'&-bookmark':{width:60,'@media (min-width: 1024px)':{width:80},'button':{background:'white'}},'&-link':Object.assign({},__WEBPACK_IMPORTED_MODULE_2__typo__["f" /* Link */],{color:__WEBPACK_IMPORTED_MODULE_1____["x" /* Colors */].grey,width:160,transition:'color 200ms ease','&:hover':{color:'black'}})}});var CounterfeitsContainer=Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])({'.counterfeits-container':{margin:'4rem 0'}});var CounterfeitContentStyle=function CounterfeitContentStyle(picture){return Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])({maxWidth:'100%',flexBasis:'100%','@media (min-width: 1024px)':{maxWidth:'50%',flexBasis:'50%'},'.bloc-picture':{'&__picture':{width:'100%',height:400,background:'url('+picture+') no-repeat center',backgroundSize:'contain'},'&__legend':{textTransform:'uppercase',fontSize:'0.75em',padding:'1rem 0'}},'ol':{listStyle:'none',padding:0,'li':{counterIncrement:'step-counter',paddingLeft:'2rem',position:'relative','&:before':{content:'counter(step-counter)',fontSize:'1rem',fontWeight:'bold',position:'absolute',top:'0.5rem',left:0},'&:nth-child(-n + 9)':{'&:before':{content:'"0" counter(step-counter)'}}}}});};

/***/ }),
/* 411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return PageStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ContactStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SitemapStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return srOnlyStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return PollStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FAQStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FAQBottomStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_chirashi__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_emotion__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3____ = __webpack_require__(1);
var title={fontSize:'2rem',fontWeight:800,textAlign:'center',textTransform:'uppercase',position:'relative','&:after':{content:'""',display:'block',width:50,height:4,margin:'1rem auto',background:'black'}};var PageStyle=function PageStyle(ready){return Object(__WEBPACK_IMPORTED_MODULE_1_emotion__["a" /* css */])({transition:'all 400ms ease',opacity:ready?1:0,transform:'translateY('+(ready?0:10)+'px)','.page':{'&-title':Object.assign({},title),'&-container':{margin:'2rem 0','h2':{marginTop:'4rem'}}}});};var ContactStyle=function ContactStyle(ready){return Object(__WEBPACK_IMPORTED_MODULE_1_emotion__["a" /* css */])({transition:'opacity 400ms ease',// transform: `translateY(${ready ? 0 : 20}px)`,
opacity:ready?1:0,'.contact':{'&-title':Object.assign({},title),'&-title-faq':{textTransform:'uppercase',fontSize:'30px',lineHeight:'36px',margin:0,textAlign:'left',fontFamily:'Interstate-Bold',marginBottom:'22px'},'&-form':{maxWidth:800,margin:'0 auto','input[type="text"], textarea':{margin:'0.5rem 0px'}},'&-btn-submit':{textAlign:'right','button':{maxWidth:150}}},'.error':{textAlign:'center'}});};var SitemapStyle=Object(__WEBPACK_IMPORTED_MODULE_1_emotion__["a" /* css */])({'.sitemap':{'&-row':{padding:'2rem 0',borderBottom:'1px solid '+__WEBPACK_IMPORTED_MODULE_3____["x" /* Colors */].extraLightGrey,'&:last-child':{borderBottom:0},'@media (min-width: 1024px)':{padding:'4rem 0'}},'&-title':{maxWidth:'100%',flexBasis:'100%',textTransform:'uppercase',fontWeight:800,fontSize:'2rem','@media (min-width: 1024px)':{maxWidth:'calc(1/3 * 100%)',flexBasis:'calc(1/3 * 100%)'}},'&-categories':{maxWidth:'100%',flexBasis:'100%','@media (min-width: 1024px)':{maxWidth:'calc(2/3 * 100%)',flexBasis:'calc(2/3 * 100%)'}},'&-category':{maxWidth:'100%',flexBasis:'100%',marginTop:'1rem','@media (min-width: 1024px)':{maxWidth:'calc(1/3 * 100%)',flexBasis:'calc(1/3 * 100%)',marginTop:0},'.category':{color:__WEBPACK_IMPORTED_MODULE_3____["x" /* Colors */].grey,fontSize:'1.5rem'}},'&-link':{margin:'1rem 0','a':{fontSize:'0.9375rem',color:'black',padding:'0.5rem 0'}}}});var srOnlyStyle=Object(__WEBPACK_IMPORTED_MODULE_1_emotion__["a" /* css */])({position:'absolute',width:1,height:1,padding:0,overflow:'hidden',border:0,clip:'rect(0, 0, 0, 0)',pointerEvents:'none'});var PollStyle=Object(__WEBPACK_IMPORTED_MODULE_1_emotion__["a" /* css */])({position:'absolute',top:'120px',left:'0',padding:'1rem 110px 2rem 1.75rem',maxWidth:'calc(100% - 1rem)',border:'1px solid #000',borderLeft:'none',zIndex:3,backgroundColor:'#FFF',transition:'.4s ease-in-out transform','@media (max-width: 767px)':{paddingRight:'3.75rem'},'&.is-closed':{transform:'translateX(calc(-100% + 1rem))','.poll__close svg':{transform:'none'}},'fieldset':{border:'none',padding:'0'},'.poll':{'&__close':{backgroundColor:'#D0021B',width:'1rem',position:'absolute',top:0,right:0,bottom:0,border:'none',cursor:'pointer','svg':{strokeWidth:'8px',stroke:'#000',marginLeft:'-6px',transform:'scaleX(-1)'}},'&__free-wrap':{display:'flex'},'&__free':{'label':{visibility:'hidden',position:'absolute'},'input':{border:'none',marginLeft:'.5rem'}},'&__title':{margin:'0 0 1rem',fontWeight:'bold',borderBottom:'6px solid #000',textTransform:'uppercase',lineHeight:'1.25rem'},'&__question':{fontWeight:'bold',marginBottom:'1rem'},'&__submit':{marginTop:'1.5rem',border:'1px solid #000',textTransform:'uppercase',backgroundColor:'transparent',padding:'.5rem 1rem',cursor:'pointer',transition:'.4s ease-in-out background-color, .4s ease-in-out color','&:hover':{backgroundColor:'#000',color:'#FFF'}},'&__error':{color:'#D0021B',margin:'0'},'&__radio':{position:'relative',marginBottom:'.75rem',cursor:'pointer','input':{position:'absolute',opacity:'0','&:checked + label:after':{opacity:'1'}},'label':{paddingLeft:'1.5rem',cursor:'pointer','&:before':{content:'""',position:'absolute',top:'2px',left:0,width:'10px',height:'10px',border:'2px solid #000',borderRadius:'50%'},'&:after':{content:'""',position:'absolute',left:'4px',top:'6px',width:'6px',height:'6px',backgroundColor:'#000',borderRadius:'50%',opacity:'0'}}}}});var FAQStyle=Object(__WEBPACK_IMPORTED_MODULE_1_emotion__["a" /* css */])({'.nav':{marginBottom:'4rem',justifyContent:'center','@media (max-width: 767px)':{margin:'0 -1.25rem 4rem',padding:'0 1.25rem',overflow:'auto',flexWrap:'nowrap',justifyContent:'flex-start'},'li':{margin:'0 0.5rem',flexShrink:0},'span, button':Object.assign({},__WEBPACK_IMPORTED_MODULE_3____["_7" /* MenuLink */],{color:__WEBPACK_IMPORTED_MODULE_3____["x" /* Colors */].mediumGrey,padding:'1rem',position:'relative',display:'block',cursor:'pointer',background:'transparent',border:'none',transition:'color 200ms ease','&:after':{content:'""',position:'absolute',bottom:0,left:0,width:'100%',height:6,background:'black',transition:'all 200ms ease',transform:'scaleX(0)',transformOrigin:'center left'},'&:hover':{color:'black'},'&.active':{color:'black','&:after':{transform:'scaleX(1)'}}}),'button:after':{height:5}},'.accordion':{borderBottom:'1px solid '+__WEBPACK_IMPORTED_MODULE_3____["x" /* Colors */].extraLightGrey,'&-item':{padding:'1.25rem 0',borderTop:'1px solid '+__WEBPACK_IMPORTED_MODULE_3____["x" /* Colors */].extraLightGrey,'&.is-hidden':{display:'none'},'&.is-open .accordion-title-icon:after':{display:'none'}},'&-title':{display:'flex',alignItems:'center',justifyContent:'space-between',padding:0,background:'transparent',border:'none',width:'100%',textAlign:'left',fontSize:'1.5rem',position:'relative',fontFamily:'Overpass',fontWeight:200,cursor:'pointer','&-icon':{display:'block',position:'relative',flexShrink:0,width:16,height:16,'&:after, &:before':{content:"''",position:'absolute',top:'50%',left:'50%',width:'100%',height:2,background:'black',transformOrigin:'center'},'&:after':{transform:'translateX(-50%) translateY(-50%) rotate(-90deg)'},'&:before':{transform:'translateX(-50%) translateY(-50%)'}}},'&-content':{maxHeight:0,overflow:'hidden',cursor:'pointer',transition:'.4s max-height ease-in-out','&-inner':{margin:0,padding:'22px 85px 35px 0',fontSize:'15px',fontWeight:400,lineHeight:'25px','@media (max-width: 767px)':{paddingRight:'40px'},'p:first-child':{marginTop:0},'p:last-child':{marginBottom:0}}}}});var FAQBottomStyles=Object(__WEBPACK_IMPORTED_MODULE_1_emotion__["a" /* css */])({paddingTop:'4rem',margin:'0 auto',textAlign:'center',maxWidth:445,'@media (max-width: 767px)':{paddingBottom:'2.5rem'},'p':{fontSize:'18px','@media (max-width: 767px)':{fontSize:'15px'}},'button':{maxWidth:248,margin:'.75rem 0 0',color:'#FFF'}});

/***/ }),
/* 412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TrainingStyle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_emotion__ = __webpack_require__(3);
var TrainingStyle=Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])({height:'calc(100vh - 80px)','.videos-template':{height:'100%','.video-container-full':{height:'calc(100% - 80px)'}}});

/***/ }),
/* 413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Logo__ = __webpack_require__(576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Panel__ = __webpack_require__(166);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var HeaderDesktop=function(_Component){_inherits(HeaderDesktop,_Component);function HeaderDesktop(){var _ref;var _temp,_this,_ret;_classCallCheck(this,HeaderDesktop);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=HeaderDesktop.__proto__||Object.getPrototypeOf(HeaderDesktop)).call.apply(_ref,[this].concat(args))),_this),_this.state={navPanel:false,accountPanel:false,notificationPanel:false,panelItem:'',load:false},_this.getPanelItem=function(val){return function(e){e.preventDefault();_this.setState({load:false});var hasActive=document.querySelector('.main-nav--item.active');var hasActiveDisable=document.querySelector('.main-nav--item.active.disable');var textActive='';if(hasActive)textActive=hasActive.querySelector('span:first-child').textContent.toLowerCase();if(val!==_this.state.panelItem){if(hasActive&&val!==textActive)hasActive.classList.add('disable');}else{if(hasActiveDisable)hasActiveDisable.classList.remove('disable');}_this.timeout=setTimeout(function(){_this.setState({panelItem:val!==_this.state.panelItem?val:'',navPanel:val!==_this.state.panelItem,load:true,notificationPanel:_this.state.notificationPanel},function(){document.body.style.overflow=val!==_this.state.panelItem?'auto':'hidden';});},_this.state.navPanel?300:0);};},_this.updateAccountPanel=function(){_this.setState({accountPanel:!_this.state.accountPanel,notificationPanel:false});},_this.updateNotificationPanel=function(){_this.setState({notificationPanel:!_this.state.notificationPanel,accountPanel:false,panelItem:_this.state.panelItem,navPanel:_this.state.navPanel},function(){document.body.style.overflow='auto';});},_this.closeSecondaryPanel=function(){_this.setState({notificationPanel:false,accountPanel:false});},_this.resetAllPanel=function(){_this.closeSecondaryPanel();_this.setState({navPanel:false},function(){document.body.style.overflow='auto';});},_this.handlerOpenMenu=function(e){e.preventDefault();_this.setState({notificationPanel:_this.props.viewport.isMobile?false:_this.state.notificationPanel,panelItem:'',navPanel:false},function(){document.body.style.overflow='auto';});},_this.isActive=function(item){var location=_this.props.location.pathname.split('/');if(item==='brand'){return location.includes(item)||location.includes('friends-and-partners')||location.includes('materials')||location.includes('complications');}return location.includes(item);},_this.callback=function(e){e.preventDefault();_this.resetAllPanel();_this.setState({panelItem:''});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(HeaderDesktop,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(_ref2){var location=_ref2.location;if(this.props.location.pathname!==location.pathname){this.resetAllPanel();}}},{key:'render',value:function render(){var _state=this.state,panelItem=_state.panelItem,notificationPanel=_state.notificationPanel,accountPanel=_state.accountPanel,navPanel=_state.navPanel,load=_state.load;var location=this.props.location;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:Object(__WEBPACK_IMPORTED_MODULE_2__styles__["W" /* HeaderMenuStyle */])(notificationPanel||accountPanel)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'header flex'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{onClick:this.callback},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Logo__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_2__styles__["_11" /* NavStyle */]+' main-nav'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'reset flex'},location.pathname==='/'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* NavLink */],{to:'/',className:'main-nav--item '+(panelItem===''?'in-view':''),onClick:this.clearPanel},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'middle'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["_1" /* Search */],{width:24,height:24}),' Search'))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'main-nav--item '+(panelItem==='search'?'active':''),onClick:this.getPanelItem('search')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'middle'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["_1" /* Search */],{width:24,height:24}),' Search'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'main-nav--item '+(panelItem==='news'||this.isActive('news')||this.isActive('social-media')?'active':''),onClick:this.getPanelItem('news')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'middle'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'News'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'main-nav--item '+(panelItem==='models'||this.isActive('models')||this.isActive('class')?'active':''),onClick:this.getPanelItem('models')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'middle'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Models'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'main-nav--item '+(panelItem==='brand'||this.isActive('brand')?'active':''),onClick:this.getPanelItem('brand')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'middle'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Brand'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'main-nav--item item-challenge '+(panelItem==='challenge'?'active':''),onClick:this.getPanelItem('challenge')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'middle'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,' Challenge'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'secondary-nav flex '+__WEBPACK_IMPORTED_MODULE_2__styles__["_39" /* SecondaryNav */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'profile-nav'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["a" /* Account */],{open:accountPanel,callbackClick:this.updateAccountPanel})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'btn--icon btn notification-nav'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["L" /* Notifications */],{open:notificationPanel,callbackClick:this.updateNotificationPanel})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'btn--icon btn bookmarks-nav'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["l" /* Bookmarks */],null)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'header-outside',onClick:this.closeSecondaryPanel}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Panel__["a" /* default */],{open:navPanel,isLoad:load,content:panelItem,isMobile:false}));}}]);return HeaderDesktop;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["g" /* withRouter */])(HeaderDesktop));

/***/ }),
/* 414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2____ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Video=function(_Component){_inherits(Video,_Component);function Video(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Video);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Video.__proto__||Object.getPrototypeOf(Video)).call.apply(_ref,[this].concat(args))),_this),_this.state={active:false},_this.handlerClick=function(e){e.preventDefault();_this.setState({url:_this.props.type==='vimeo'?'https://player.vimeo.com/video/'+_this.props.link:'https://www.youtube.com/embed/'+_this.props.link},function(){_this.setState({active:true});document.querySelector('.app-body').scrollIntoView();});},_this.handlerClose=function(e){e.preventDefault();_this.setState({active:false},function(){_this.setState({url:''});});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Video,[{key:'render',value:function render(){var _props=this.props,title=_props.title,poster=_props.poster,label=_props.label;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'video-container '+Object(__WEBPACK_IMPORTED_MODULE_1__styles__["_72" /* VideoStyle */])(poster,this.state.active)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'video',onClick:this.handlerClick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn--play'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2____["_14" /* Triangle */],{width:12,height:12}),' ',label)),title&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'video-label'},title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'video-container-full'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'video-close',onClick:this.handlerClose},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'video-iframe'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('iframe',{src:this.state.url,frameBorder:'0',allowFullScreen:true,title:title||'Video iframe'}))));}}]);return Video;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Video);

/***/ }),
/* 415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Shapes__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles___ = __webpack_require__(1);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var transition=_ref.transition;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:Object(__WEBPACK_IMPORTED_MODULE_2__styles___["_78" /* appLoader */])(transition)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'loader--inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Shapes__["o" /* Logo */],{width:'359',height:'28'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Brand Center'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Shapes__["m" /* Load */],{width:'50',height:'50'})));});

/***/ }),
/* 416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var width=_ref.width,height=_ref.height,nClass=_ref.nClass;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',{width:width,height:height,className:'shape shape--logo '+nClass,viewBox:'0 0 359 28'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M28,28 L18.9983133,28 L14.3479141,15.6347988 L8.43180029,15.6347988 L8.43180029,24.391719 C8.43180029,26.1404978 8.68683234,27.0165155 8.93871584,28 L0,28 C0.255032048,27.0165155 0.510064095,26.1404978 0.510064095,24.391719 L0.510064095,3.56594557 C0.510064095,1.8269365 0.255032048,0.957431961 0,0 L21.532891,0 C25.0812999,0 26.7720679,2.12979763 26.7720679,5.18771807 L26.7720679,11.1472435 C26.7720679,13.8501977 25.4244912,15.3742731 22.5876532,15.7683182 L25.8873271,24.391719 C26.3942427,25.7464527 26.8570786,26.8015818 28,28 Z M19.0801754,10.1832984 L19.0801754,5.3668295 C19.0801754,4.13584555 18.6992016,3.56594557 17.6003598,3.56594557 L8.43180029,3.56594557 L8.43180029,12.0688532 L17.6003598,12.0688532 C18.7464298,12.0688532 19.0801754,11.4989532 19.0801754,10.1832984 Z M33.6,28 C33.8395775,27.0134884 34.0761972,26.1409302 34.0761972,24.3925581 L34.0761972,3.58790698 C34.0761972,1.83953488 33.8395775,0.96372093 33.6,0 L42,0 C41.7604225,0.96372093 41.5238028,1.83953488 41.5238028,3.58790698 L41.5238028,24.3925581 C41.5238028,26.1409302 41.7604225,27.0134884 42,28 L33.6,28 Z M69.3041468,28 L53.0567837,28 C49.3315417,28 47.6,25.9102534 47.6,22.5054638 L47.6,5.49779121 C47.6,2.08974657 49.3315417,0 53.0567837,0 L69.3041468,0 L70,4.228319 C68.9125271,3.78888631 67.7797428,3.57079749 66.0417281,3.57079749 L57.2221933,3.57079749 C56.3094928,3.57079749 55.7463372,3.92234364 55.7463372,5.06161358 L55.7463372,22.9448965 C55.7463372,24.0841665 56.3094928,24.4324576 57.2221933,24.4324576 L66.0417281,24.4324576 C67.7797428,24.4324576 68.9125271,24.2143688 70,23.7781911 L69.3041468,28 Z M94.5223744,28 C94.7812785,27.0134884 95.0369863,26.1409302 95.0369863,24.3893023 L95.0369863,15.6344186 L84.1598174,15.6344186 L84.1598174,24.3893023 C84.1598174,26.1409302 84.4187215,27.0134884 84.6776256,28 L75.6,28 C75.8589041,27.0134884 76.1146119,26.1409302 76.1146119,24.3893023 L76.1146119,3.58790698 C76.1146119,1.83953488 75.8589041,0.96372093 75.6,0 L84.6776256,0 C84.4187215,0.96372093 84.1598174,1.83953488 84.1598174,3.58790698 L84.1598174,12.0660465 L95.0369863,12.0660465 L95.0369863,3.58790698 C95.0369863,1.83953488 94.7812785,0.96372093 94.5223744,0 L103.6,0 C103.341096,0.96372093 103.085388,1.83953488 103.085388,3.58790698 L103.085388,24.3893023 C103.085388,26.1409302 103.341096,27.0134884 103.6,28 L94.5223744,28 Z M140,28 L129.662542,28 C129.750646,27.729736 129.750646,27.5506454 129.750646,27.2803814 C129.750646,26.5770438 129.486336,25.4894755 129.003399,24.398651 L127.078178,20.0386091 L114.332563,20.0386091 L112.446499,24.398651 C112.094086,25.2224677 111.790619,26.6226305 111.790619,28 L106.4,28 C107.232087,26.7984649 108.109857,25.4015583 108.543848,24.398651 L118.711625,1.83974881 L117.527124,0 L126.683345,0 L137.810469,24.398651 C138.427192,25.7076404 139.216859,27.2803814 140,28 Z M125.456424,16.4698221 L120.679266,5.87091522 L115.996737,16.4698221 L125.456424,16.4698221 Z M170.8,28 L161.798313,28 L157.147914,15.6347988 L151.2318,15.6347988 L151.2318,24.391719 C151.2318,26.1404978 151.486832,27.0165155 151.738716,28 L142.8,28 C143.055032,27.0165155 143.310064,26.1404978 143.310064,24.391719 L143.310064,3.56594557 C143.310064,1.8269365 143.055032,0.957431961 142.8,0 L164.332891,0 C167.8813,0 169.575216,2.12979763 169.575216,5.18771807 L169.575216,11.1472435 C169.575216,13.8501977 168.224491,15.3742731 165.387653,15.7683182 L168.684179,24.391719 C169.194243,25.7464527 169.660227,26.8015818 170.8,28 Z M161.883324,10.1832984 L161.883324,5.3668295 C161.883324,4.13584555 161.50235,3.56594557 160.40036,3.56594557 L151.2318,3.56594557 L151.2318,12.0688532 L160.40036,12.0688532 C161.54643,12.0688532 161.883324,11.4989532 161.883324,10.1832984 Z M201.6,22.5015696 C201.6,25.9132659 199.868574,28 196.150531,28 L173.6,28 C173.858422,27.042902 174.120074,26.1737007 174.120074,24.4352982 L174.120074,3.52563655 C174.120074,1.80676666 173.858422,0.947331706 173.6,0 L196.150531,0 C199.868574,0 201.6,2.06394605 201.6,5.45610975 L201.6,22.5015696 Z M193.469405,22.9410534 L193.469405,5.01662597 C193.469405,3.88047901 192.900877,3.52563655 191.98994,3.52563655 L182.247439,3.56795721 L182.247439,24.4352982 L191.98994,24.4352982 C192.900877,24.4352982 193.469405,24.0869666 193.469405,22.9410534 Z M251.682777,28 C251.937961,27.0134884 252.189995,26.1409302 252.189995,24.3925581 L252.189995,4.02744186 L252.104933,4.02744186 L242.842687,28 L237.345196,28 L228.253073,4.02744186 L228.164861,4.02744186 L228.164861,24.3925581 C228.164861,26.1409302 228.420045,27.0134884 228.672079,28 L224,28 C224.255184,27.0134884 224.507218,26.1409302 224.507218,24.3925581 L224.507218,3.58790698 C224.507218,1.83953488 224.255184,0.96372093 224,0 L234.683088,0 L242.42368,20.3293023 L250.290289,0 L260.4,0 C260.144816,0.96372093 259.889631,1.83953488 259.889631,3.58790698 L259.889631,24.3925581 C259.889631,26.1409302 260.144816,27.0134884 260.4,28 L251.682777,28 Z M266,28 C266.239577,27.0134884 266.476197,26.1409302 266.476197,24.3925581 L266.476197,3.58790698 C266.476197,1.83953488 266.239577,0.96372093 266,0 L274.4,0 C274.160423,0.96372093 273.923803,1.83953488 273.923803,3.58790698 L273.923803,24.3925581 C273.923803,26.1409302 274.160423,27.0134884 274.4,28 L266,28 Z M304.53337,28 L282.8,28 C283.049986,27.0430133 283.296886,26.170658 283.296886,24.4324576 L283.296886,3.59358289 C283.296886,1.84236224 283.049986,0.966751918 282.8,0 L291.568035,0 C291.318049,0.966751918 291.071149,1.84236224 291.071149,3.59358289 L291.071149,24.4324576 L301.302067,24.4324576 C303.082833,24.4324576 304.206228,24.172053 305.2,23.7781911 L304.53337,28 Z M329.736365,28 L308,28 C308.250021,27.0430133 308.493868,26.170658 308.493868,24.4324576 L308.493868,3.59358289 C308.493868,1.84236224 308.250021,0.966751918 308,0 L316.766157,0 C316.516136,0.966751918 316.269202,1.84236224 316.269202,3.59358289 L316.269202,24.4324576 L326.50153,24.4324576 C328.282541,24.4324576 329.406091,24.172053 330.4,23.7781911 L329.736365,28 Z M357.736365,28 L336,28 C336.250021,27.0430133 336.496955,26.170658 336.496955,24.4324576 L336.496955,3.57079749 C336.496955,1.82934201 336.250021,0.956986747 336,0 L357.736365,0 L358.4,4.22506394 C357.406091,3.83120205 356.285628,3.57079749 354.504616,3.57079749 L344.269202,3.57079749 L344.269202,12.0632411 L353.427367,12.0632411 C354.875017,12.0632411 356.202287,11.7995815 357.115943,11.4057196 L357.115943,16.288305 C356.202287,15.8976982 354.875017,15.6340386 353.427367,15.6340386 L344.269202,15.6340386 L344.269202,24.4324576 L354.504616,24.4324576 C356.285628,24.4324576 357.406091,24.168798 358.4,23.7749361 L357.736365,28 Z'}));});

/***/ }),
/* 417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var width=_ref.width,height=_ref.height;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{className:"shape shape--loader",width:width,height:height,viewBox:"0 0 38 38",xmlns:"http://www.w3.org/2000/svg"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("defs",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("linearGradient",{x1:"8.042%",y1:"0%",x2:"65.682%",y2:"23.865%",id:"a"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("stop",{stopOpacity:"0",offset:"0%"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("stop",{stopOpacity:".631",offset:"63.146%"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("stop",{offset:"100%"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{fill:"none",fillRule:"evenodd"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{transform:"translate(1 1)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M36 18c0-9.94-8.06-18-18-18",id:"Oval-2",stroke:"url(#a)",strokeWidth:"2"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("animateTransform",{attributeName:"transform",type:"rotate",from:"0 18 18",to:"360 18 18",dur:"0.9s",repeatCount:"indefinite"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#000",cx:"36",cy:"18",r:"1"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("animateTransform",{attributeName:"transform",type:"rotate",from:"0 18 18",to:"360 18 18",dur:"0.9s",repeatCount:"indefinite"})))));});

/***/ }),
/* 418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var width=_ref.width,height=_ref.height;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{className:"shape shape--user",width:width,height:height,viewBox:"0 0 24 24",xmlns:"http://www.w3.org/2000/svg"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M12,5.9 C13.16,5.9 14.1,6.84 14.1,8 C14.1,9.16 13.16,10.1 12,10.1 C10.84,10.1 9.9,9.16 9.9,8 C9.9,6.84 10.84,5.9 12,5.9 L12,5.9 Z M12,14.9 C14.97,14.9 18.1,16.36 18.1,17 L18.1,18.1 L5.9,18.1 L5.9,17 C5.9,16.36 9.03,14.9 12,14.9 L12,14.9 Z M12,4 C9.79,4 8,5.79 8,8 C8,10.21 9.79,12 12,12 C14.21,12 16,10.21 16,8 C16,5.79 14.21,4 12,4 L12,4 Z M12,13 C9.33,13 4,14.34 4,17 L4,20 L20,20 L20,17 C20,14.34 14.67,13 12,13 L12,13 Z"}));});

/***/ }),
/* 419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var width=_ref.width,height=_ref.height;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{className:"shape shape--rm",width:width,height:height,viewBox:"0 0 38 15"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M33.2,15c0.1-0.5,0.3-1,0.3-1.9V2.2h0L28.4,15h-3l-5-12.8h0v10.9c0,0.9,0.1,1.4,0.3,1.9 H18c0.1-0.5,0.3-1,0.3-1.9V1.9C18.3,1,18.1,0.5,18,0h5.9l4.3,10.9L32.4,0H38c-0.1,0.5-0.3,1-0.3,1.9v11.1c0,0.9,0.1,1.4,0.3,1.9 H33.2z M15,15h-4.8L7.7,8.4H4.5v4.7c0,0.9,0.1,1.4,0.3,1.9H0c0.1-0.5,0.3-1,0.3-1.9V1.9C0.3,1,0.1,0.5,0,0h11.5 c1.9,0,2.8,1.1,2.8,2.8V6c0,1.4-0.7,2.3-2.2,2.5l1.8,4.6C14.1,13.8,14.4,14.4,15,15z M10.5,5.5V3.1c0-0.7-0.2-1.1-0.8-1.1H4.5v4.5 h5.2C10.3,6.5,10.5,6.3,10.5,5.5z"}));});

/***/ }),
/* 420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var width=_ref.width,height=_ref.height;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',{width:width,height:height,viewBox:'0 0 24 24'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M14.71,14 L14.43,13.73 C15.41,12.59 16,11.11 16,9.5 C16,5.91 13.09,3 9.5,3 C5.91,3 3,5.91 3,9.5 C3,13.09 5.91,16 9.5,16 C11.11,16 12.59,15.41 13.73,14.43 L14,14.71 L14,15.5 L19,20.49 L20.49,19 L15.5,14 L14.71,14 Z M9.5,14 C7.01,14 5,11.99 5,9.5 C5,7.01 7.01,5 9.5,5 C11.99,5 14,7.01 14,9.5 C14,11.99 11.99,14 9.5,14 L9.5,14 Z'}));});

/***/ }),
/* 421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var width=_ref.width,height=_ref.height;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{className:"shape shape--bookmark",width:width,height:height,viewBox:"0 0 24 24"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M12.81,6.62 L10.3907185,0.920482635 C10.1749306,0.412114113 9.82422192,0.414736193 9.60928154,0.921873093 L7.19,6.63 L0.999738693,7.15518211 C0.447598259,7.20202574 0.341547453,7.53588268 0.759189606,7.89768623 L5.46,11.97 L4.04803497,18.0225086 C3.92209474,18.5623622 4.20658668,18.7666718 4.67930252,18.4813595 L10,15.27 L15.3206975,18.4813595 C15.7952772,18.7677967 16.0780362,18.560242 15.9533555,18.0225086 L14.55,11.97 L19.2422009,7.89768623 C19.6607218,7.53445616 19.5502333,7.20121622 19.0002613,7.15379166 L12.81,6.62 Z M10,13.4 L6.24,15.67 L7.24,11.39 L3.92,8.51 L8.3,8.13 L10,4.1 L11.71,8.14 L16.09,8.52 L12.77,11.4 L13.77,15.68 L10,13.4 L10,13.4 Z"}));});

/***/ }),
/* 422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var width=_ref.width,height=_ref.height;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{className:"shape shape--bookmark-plain",width:width,height:height,viewBox:"0 0 24 24"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M12.81,6.62 L10.3907185,0.920482635 C10.1749306,0.412114113 9.82422192,0.414736193 9.60928154,0.921873093 L7.19,6.63 L0.999738693,7.15518211 C0.447598259,7.20202574 0.341547453,7.53588268 0.759189606,7.89768623 L5.46,11.97 L4.04803497,18.0225086 C3.92209474,18.5623622 4.20658668,18.7666718 4.67930252,18.4813595 L10,15.27 L15.3206975,18.4813595 C15.7952772,18.7677967 16.0780362,18.560242 15.9533555,18.0225086 L14.55,11.97 L19.2422009,7.89768623 C19.6607218,7.53445616 19.5502333,7.20121622 19.0002613,7.15379166 L12.81,6.62 Z"}));});

/***/ }),
/* 423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var width=_ref.width,height=_ref.height;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{className:"shape shape--notification",width:width,height:height,viewBox:"0 0 24 24"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M13.59,3.31 C17,4 19,6 19,10 L19,16 L21,18 L21,19 L3,19 L3,18 L5,16 L5,10 C5,6 7,4 10.41,3.31 L10.41,2.59 C10.41,1.71 11.12,1 12,1 C12.88,1 13.59,1.71 13.59,2.59 L13.59,3.31 Z M10.01,20.01 L13.99,20.01 C13.99,21.11 13.1,22 12,22 C10.9,22 10.01,21.11 10.01,20.01 Z M17,17 L17,10 C17,7 15.3156503,5.77403552 13.1290672,5.25616057 L12,4.98874991 L10.8709328,5.25616057 C8.68434966,5.77403552 7,7 7,10 L7,17 L17,17 Z"}));});

/***/ }),
/* 424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var width=_ref.width,height=_ref.height;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{className:"shape shape--pdf",width:width,height:height,viewBox:"0 0 24 24"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M14,4 L6.00863704,4 C6.00989647,4.00010666 6,20 6,20 L18,20 L18,8 L14,8 L14,4 Z M6,2 L14,2 L20,8 L20,20 C20,21.1 19.1,22 18,22 L5.99,22 C4.89,22 4,21.1 4,20 L4.01,4 C4.01,2.9 4.9,2 6,2 Z M12.041866,7.77707351 C12.2510968,7.86802185 12.2043802,8.00568683 12.1352992,8.65276193 C12.0642303,9.32319534 11.8281622,10.5442887 11.3724265,11.7430176 C10.9161938,12.9432376 10.2392996,14.1210932 9.64937785,14.9942967 C9.06045005,15.8665062 8.5555128,16.4335666 8.17134303,16.7605831 C7.78518531,17.0875995 7.5183041,17.174572 7.3438622,17.2043911 C7.17091125,17.2342102 7.09238755,17.2043911 7.04567091,17.1174186 C6.99895428,17.0304462 6.98255376,16.8838355 7.02280958,16.7103875 C7.06207143,16.5349517 7.15600169,16.3311876 7.42238591,16.0707672 C7.69125505,15.8088559 8.1310872,15.4892942 8.74486427,15.1901089 C9.35864134,14.8924146 10.1443754,14.6155937 10.7899595,14.4272362 C11.4355437,14.2378848 11.938493,14.1364997 12.3788221,14.056982 C12.8201452,13.9769674 13.1973572,13.9188201 13.5666174,13.8899949 C13.9368716,13.8601758 14.299174,13.8601758 14.6530277,13.8899949 C15.0068813,13.9188201 15.3532802,13.9769674 15.6524655,14.0485333 C15.9511537,14.1215902 16.2031254,14.2090596 16.4232899,14.3477186 C16.6429575,14.4853835 16.832309,14.674735 16.9262393,14.8854568 C17.0216605,15.0966757 17.0216605,15.3292649 16.9426398,15.496252 C16.8641161,15.6632391 16.7060747,15.7656181 16.525669,15.8227715 C16.3452632,15.8809188 16.1405052,15.8953313 15.8964853,15.8227715 C15.6524655,15.7502116 15.3681898,15.5906792 15.0699985,15.3789634 C14.7718072,15.1687386 14.4567184,14.9078212 14.0476994,14.5002931 C13.6386803,14.092765 13.134737,13.5391232 12.7103114,13.0018819 C12.2858858,12.4636466 11.938493,11.9403209 11.7024249,11.4970098 C11.4673507,11.0532018 11.3411164,10.6899054 11.2387374,10.3256151 C11.1363584,9.96231867 11.0578347,9.59902228 11.0265246,9.27200584 C10.9952145,8.94399542 11.0101241,8.65325891 11.0419312,8.42216066 C11.0732412,8.18857749 11.1214488,8.01463257 11.1994756,7.89833797 C11.2779993,7.78154638 11.388827,7.72339908 11.4673507,7.69457392 C11.5458744,7.66475479 11.593585,7.66475479 11.6403017,7.65829398 C11.6870183,7.65133618 11.733735,7.63642662 11.8057978,7.65829398 C11.8743818,7.6781734 11.9658272,7.73383577 12.041866,7.77707351 Z"}));});

/***/ }),
/* 425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var width=_ref.width,height=_ref.height;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{className:"shape shape--arrow-back",width:width,height:height,viewBox:"0 0 24 24"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M16,8.02038361 C19.2805754,8.28860929 22,11.1676859 22,14.5 C22,18 19,21 15.500765,21 L3,21 L3,19 L15.500765,19 C18,19 20,17 20,14.5 C20,12 18,10 15.500765,10 L6.83,10 L10.41,13.59 L9,15 L3,9 L9,3 L10.42,4.41 L6.83,8 L16,8 L16,8.02038361 Z"}));});

/***/ }),
/* 426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var width=_ref.width,height=_ref.height;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{width:width,height:height,viewBox:"0 0 12 12"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"6 0 12 12 0 12"}));});

/***/ }),
/* 427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var width=_ref.width,height=_ref.height;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{className:"shape shape--upload",width:width,height:height,viewBox:"0 0 24 24"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M11,16.5857864 L11,3.9999602 C11,3.44769743 11.4438648,3 12,3 C12.5522847,3 13,3.45470893 13,3.9999602 L13,16.6568542 L15.9518475,13.7050068 C16.3365092,13.320345 16.9734367,13.3165825 17.363961,13.7071068 C17.757208,14.1003537 17.7554255,14.7298558 17.366061,15.1192203 L13.1192203,19.366061 C13.0316746,19.4536067 12.9310621,19.5214227 12.8232614,19.5693511 C12.6434885,19.8295905 12.3431113,20 12,20 C11.6379832,20 11.3208964,19.8046269 11.1453838,19.5164452 C11.0761153,19.4753566 11.0109988,19.4252123 10.9518475,19.366061 L6.70500677,15.1192203 C6.31564228,14.7298558 6.31385983,14.1003537 6.70710678,13.7071068 C7.09763107,13.3165825 7.73455861,13.320345 8.11922033,13.7050068 L11,16.5857864 Z M3,23 C3,22.4438648 3.44475929,22 3.99339768,22 L20.0066023,22 C20.5550537,22 21,22.4477153 21,23 C21,23.5561352 20.5552407,24 20.0066023,24 L3.99339768,24 C3.44494629,24 3,23.5522847 3,23 Z"}));});

/***/ }),
/* 428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var width=_ref.width,height=_ref.height;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{className:"shape shape--alert",width:width,height:height,viewBox:"0 0 24 24"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M1.50123914,19.1342376 L11.4989431,1.86576235 C11.7804494,1.3795322 12.2245872,1.38761501 12.5014048,1.86576235 L22.4987775,19.1342376 C22.7802745,19.6204678 22.5511826,20 21.9975383,20 L2.00246167,20 C1.43945834,20 1.22441241,19.612385 1.50123914,19.1342376 Z M12,4.50411444 L4.5,18 L19.5,18 L12,4.50411444 Z M13,17 L11,17 L11,15 L13,15 L13,17 L13,17 Z M12,14 C11.4477153,14 11,13.5562834 11,13.0001925 L11,9.99980749 C11,9.44762906 11.4438648,9 12,9 L12,9 C12.5522847,9 13,9.44371665 13,9.99980749 L13,13.0001925 C13,13.5523709 12.5561352,14 12,14 L12,14 Z"}));});

/***/ }),
/* 429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var width=_ref.width,height=_ref.height;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{className:"shape shape--arrow",width:width,height:height,viewBox:"0 0 24 24"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M11,16.5857864 L11,3.9999602 C11,3.44769743 11.4438648,3 12,3 C12.5522847,3 13,3.45470893 13,3.9999602 L13,16.6568542 L15.9518475,13.7050068 C16.3365092,13.320345 16.9734367,13.3165825 17.363961,13.7071068 C17.757208,14.1003537 17.7554255,14.7298558 17.366061,15.1192203 L13.1192203,19.366061 C13.0316746,19.4536067 12.9310621,19.5214227 12.8232614,19.5693511 C12.6434885,19.8295905 12.3431113,20 12,20 C11.6379832,20 11.3208964,19.8046269 11.1453838,19.5164452 C11.0761153,19.4753566 11.0109988,19.4252123 10.9518475,19.366061 L6.70500677,15.1192203 C6.31564228,14.7298558 6.31385983,14.1003537 6.70710678,13.7071068 C7.09763107,13.3165825 7.73455861,13.320345 8.11922033,13.7050068 L11,16.5857864 Z"}));});

/***/ }),
/* 430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var width=_ref.width,height=_ref.height;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{className:"shape shape--arrow",width:width,height:height,viewBox:"0 0 129 129"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"m40.4,121.3c-0.8,0.8-1.8,1.2-2.9,1.2s-2.1-0.4-2.9-1.2c-1.6-1.6-1.6-4.2 0-5.8l51-51-51-51c-1.6-1.6-1.6-4.2 0-5.8 1.6-1.6 4.2-1.6 5.8,0l53.9,53.9c1.6,1.6 1.6,4.2 0,5.8l-53.9,53.9z"}));});

/***/ }),
/* 431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var width=_ref.width,height=_ref.height;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{className:"shape shape--upload",width:width,height:height,viewBox:"0 0 561 561"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M280.5,76.5V0l-102,102l102,102v-76.5c84.15,0,153,68.85,153,153c0,25.5-7.65,51-17.85,71.4l38.25,38.25 C471.75,357,484.5,321.3,484.5,280.5C484.5,168.3,392.7,76.5,280.5,76.5z M280.5,433.5c-84.15,0-153-68.85-153-153 c0-25.5,7.65-51,17.85-71.4l-38.25-38.25C89.25,204,76.5,239.7,76.5,280.5c0,112.2,91.8,204,204,204V561l102-102l-102-102V433.5z"}));});

/***/ }),
/* 432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var width=_ref.width,height=_ref.height;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{width:width,height:height,viewBox:"0 0 40 40"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M20,9 C15.1828571,9 10,10.4521429 10,13.6428571 L10,27.2142857 C10,30.4035714 15.1828571,31.8571429 20,31.8571429 C24.8164286,31.8571429 30,30.4035714 30,27.2142857 L30,13.6428571 C30,10.4521429 24.8157143,9 20,9 Z M28.5714286,27.2142857 C28.5714286,28.9885714 24.7335714,30.4285714 20,30.4285714 C15.2657143,30.4285714 11.4285714,28.9885714 11.4285714,27.2142857 L11.4285714,25.26 C12.9042857,26.7807143 16.4642857,27.5714286 20,27.5714286 C23.5357143,27.5714286 27.0957143,26.7807143 28.5714286,25.26 L28.5714286,27.2142857 Z M28.5714286,22.9285714 L28.5685714,22.9285714 C28.5685714,22.9357143 28.5714286,22.9435714 28.5714286,22.9507143 C28.5714286,24.7142857 24.7335714,26.1428571 20,26.1428571 C15.2664286,26.1428571 11.4285714,24.7142857 11.4285714,22.9507143 C11.4285714,22.9435714 11.4314286,22.9357143 11.4314286,22.9285714 L11.4285714,22.9285714 L11.4285714,20.9742857 C12.9042857,22.495 16.4642857,23.2857143 20,23.2857143 C23.5357143,23.2857143 27.0957143,22.495 28.5714286,20.9742857 L28.5714286,22.9285714 Z M28.5714286,18.6428571 L28.5685714,18.6428571 C28.5685714,18.65 28.5714286,18.6578571 28.5714286,18.665 C28.5714286,20.4285714 24.7335714,21.8571429 20,21.8571429 C15.2664286,21.8571429 11.4285714,20.4285714 11.4285714,18.665 C11.4285714,18.6578571 11.4314286,18.65 11.4314286,18.6428571 L11.4285714,18.6428571 L11.4285714,16.1885714 C13.3007143,17.615 16.7321429,18.2857143 20,18.2857143 C23.2678571,18.2857143 26.6992857,17.615 28.5714286,16.1885714 L28.5714286,18.6428571 Z M20,16.8571429 C15.2657143,16.8571429 11.4285714,15.4171429 11.4285714,13.6428571 C11.4285714,11.8671429 15.2657143,10.4285714 20,10.4285714 C24.7335714,10.4285714 28.5714286,11.8671429 28.5714286,13.6428571 C28.5714286,15.4171429 24.7335714,16.8571429 20,16.8571429 Z"}));});

/***/ }),
/* 433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var width=_ref.width,height=_ref.height;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{width:width,height:height,viewBox:"0 0 40 40"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M20.140625,7 C15.1004844,7 11,11.1004844 11,16.140625 C11,17.8435234 11.471707,19.5053906 12.3644414,20.9471719 L19.6203203,32.6399102 C19.7593086,32.8639062 20.0041758,33 20.2675273,33 C20.2695586,33 20.2715391,33 20.2735703,33 C20.539207,32.997918 20.784582,32.8576094 20.9210312,32.6297031 L27.9919648,20.8236719 C28.8354414,19.4123594 29.28125,17.7929961 29.28125,16.140625 C29.28125,11.1004844 25.1807656,7 20.140625,7 Z M26.6846016,20.0415391 L20.256,30.7750703 L13.6592617,20.1445234 C12.9161797,18.9444609 12.5132812,17.5599609 12.5132812,16.140625 C12.5132812,11.9405078 15.9405078,8.51328125 20.140625,8.51328125 C24.3407422,8.51328125 27.7628906,11.9405078 27.7628906,16.140625 C27.7628906,17.5178633 27.3865508,18.8669687 26.6846016,20.0415391 Z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M20.140625,11.5703125 C17.6205547,11.5703125 15.5703125,13.6205547 15.5703125,16.140625 C15.5703125,18.6445977 17.5871914,20.7109375 20.140625,20.7109375 C22.725543,20.7109375 24.7109375,18.6170742 24.7109375,16.140625 C24.7109375,13.6205547 22.6606953,11.5703125 20.140625,11.5703125 Z M20.140625,19.1976562 C18.451793,19.1976562 17.0835938,17.8248867 17.0835938,16.140625 C17.0835938,14.4605781 18.4605781,13.0835938 20.140625,13.0835938 C21.8206719,13.0835938 23.1925781,14.4605781 23.1925781,16.140625 C23.1925781,17.8003086 21.8562188,19.1976562 20.140625,19.1976562 Z"}));});

/***/ }),
/* 434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var width=_ref.width,height=_ref.height;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{className:"shape shape--print",width:width,height:height,viewBox:"0 0 512 512"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M475.934,108.229H380.35V54.285c0-5.995-4.862-10.857-10.857-10.857H142.507c-5.995,0-10.857,4.862-10.857,10.857v53.945 H36.066C16.179,108.229,0,124.409,0,144.296v172.837C0,337.02,16.179,353.2,36.066,353.2h95.584v104.515 c0,5.995,4.862,10.857,10.857,10.857h226.987c5.995,0,10.857-4.862,10.857-10.857V353.2h95.584 c19.886,0,36.066-16.179,36.066-36.067V144.296C512,124.409,495.82,108.229,475.934,108.229z M380.349,129.942h25.897v30.385 h-25.897V129.942z M153.363,65.142h205.273v95.186H153.363V65.142z M105.753,129.943h25.897v30.385h-25.897V129.943z M358.637,446.858H153.363V303.879h205.273V446.858z M490.288,317.133h-0.001c0,7.915-6.439,14.354-14.352,14.354H380.35v-27.607 h19.805c5.995,0,10.857-4.862,10.857-10.857s-4.862-10.857-10.857-10.857h-30.661H142.507h-30.661 c-5.995,0-10.857,4.862-10.857,10.857s4.862,10.857,10.857,10.857h19.805v27.607H36.066c-7.913,0-14.352-6.439-14.352-14.354 V144.296c0-7.914,6.439-14.354,14.352-14.354H84.04v41.241c0,5.995,4.861,10.857,10.857,10.857h322.207 c5.995,0,10.857-4.862,10.857-10.857v-41.241h47.974c7.913,0,14.353,6.439,14.353,14.354V317.133z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{cx:"68.799",cy:"219.261",r:"13.602"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M252.849,386.456h-50.68c-5.995,0-10.857,4.86-10.857,10.857c0,5.995,4.861,10.857,10.857,10.857h50.68 c5.995,0,10.857-4.862,10.857-10.857C263.706,391.316,258.844,386.456,252.849,386.456z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M309.831,331.483H202.169c-5.995,0-10.857,4.862-10.857,10.857c0,5.996,4.861,10.857,10.857,10.857h107.661 c5.995,0,10.857-4.861,10.857-10.857C320.687,336.345,315.826,331.483,309.831,331.483z"}));});

/***/ }),
/* 435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var width=_ref.width,height=_ref.height;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{className:"shape shape--edit",width:width,height:height,viewBox:"0 -1 401.52289 401"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"m370.589844 250.972656c-5.523438 0-10 4.476563-10 10v88.789063c-.019532 16.5625-13.4375 29.984375-30 30h-280.589844c-16.5625-.015625-29.980469-13.4375-30-30v-260.589844c.019531-16.558594 13.4375-29.980469 30-30h88.789062c5.523438 0 10-4.476563 10-10 0-5.519531-4.476562-10-10-10h-88.789062c-27.601562.03125-49.96875 22.398437-50 50v260.59375c.03125 27.601563 22.398438 49.96875 50 50h280.589844c27.601562-.03125 49.96875-22.398437 50-50v-88.792969c0-5.523437-4.476563-10-10-10zm0 0"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"m376.628906 13.441406c-17.574218-17.574218-46.066406-17.574218-63.640625 0l-178.40625 178.40625c-1.222656 1.222656-2.105469 2.738282-2.566406 4.402344l-23.460937 84.699219c-.964844 3.472656.015624 7.191406 2.5625 9.742187 2.550781 2.546875 6.269531 3.527344 9.742187 2.566406l84.699219-23.464843c1.664062-.460938 3.179687-1.34375 4.402344-2.566407l178.402343-178.410156c17.546875-17.585937 17.546875-46.054687 0-63.640625zm-220.257812 184.90625 146.011718-146.015625 47.089844 47.089844-146.015625 146.015625zm-9.40625 18.875 37.621094 37.625-52.039063 14.417969zm227.257812-142.546875-10.605468 10.605469-47.09375-47.09375 10.609374-10.605469c9.761719-9.761719 25.589844-9.761719 35.351563 0l11.738281 11.734375c9.746094 9.773438 9.746094 25.589844 0 35.359375zm0 0"}));});

/***/ }),
/* 436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var width=_ref.width,height=_ref.height;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{className:"shape shape--valid",width:width,height:height,viewBox:"0 0 288.941 288.941"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{id:"Check",d:"M285.377,46.368c-4.74-4.704-12.439-4.704-17.179,0L96.309,217.114L20.734,142.61 c-4.74-4.704-12.439-4.704-17.179,0s-4.74,12.319,0,17.011l84.2,82.997c4.692,4.644,12.499,4.644,17.191,0l180.43-179.239 C290.129,58.687,290.129,51.06,285.377,46.368C280.637,41.664,290.129,51.06,285.377,46.368z"}));});

/***/ }),
/* 437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Facebook__ = __webpack_require__(438);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__Facebook__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Twitter__ = __webpack_require__(439);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_1__Twitter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Instagram__ = __webpack_require__(440);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__Instagram__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Desktop__ = __webpack_require__(441);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__Desktop__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Weibo__ = __webpack_require__(442);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_4__Weibo__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Linkedin__ = __webpack_require__(443);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_5__Linkedin__["a"]; });


/***/ }),
/* 438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var width=_ref.width,height=_ref.height;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{className:"shape shape--facebook",width:width,height:height,viewBox:"0 0 24 24"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M16.6,9.2h2.1v-3h-2.1c-1.1,0-2,0.4-2.8,1.2c-0.7,0.8-1.1,2.3-1.1,3.5v1.3h-3v3h3v7h3v-7h3v-3h-3v-2.1 C15.7,9.6,16.1,9.2,16.6,9.2z"}));});

/***/ }),
/* 439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var width=_ref.width,height=_ref.height;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{className:"shape shape--twitter",width:width,height:height,viewBox:"0 0 24 24"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M21.1,9.2c0.8-0.5,1.3-1.2,1.6-2c-0.8,0.4-1.6,0.7-2.4,0.9c-0.7-0.8-1.6-1.1-2.7-1.1c-1,0-1.9,0.4-2.6,1.1 c-0.7,0.7-1.1,1.6-1.1,2.6c0,0.3,0,0.6,0.1,0.8C11,11.3,8.4,10,6.4,7.5C6.1,8.1,5.9,8.8,5.9,9.4c0,1.3,0.5,2.3,1.6,3.1 c-0.6-0.1-1.2-0.2-1.6-0.5c0,0.9,0.3,1.7,0.8,2.4c0.5,0.7,1.3,1.1,2.1,1.3c-0.3,0.1-0.6,0.1-1,0.1c-0.3,0-0.5,0-0.7-0.1 c0.2,0.8,0.7,1.4,1.3,1.8c0.6,0.5,1.3,0.7,2.2,0.7c-1.3,1-2.9,1.6-4.6,1.6c-0.4,0-0.7,0-0.9,0c1.7,1.1,3.6,1.6,5.7,1.6 c2.1,0,4-0.5,5.7-1.6c1.6-1.1,2.9-2.4,3.6-4c0.8-1.6,1.2-3.2,1.2-4.9v-0.5c0.8-0.6,1.4-1.2,1.8-1.9C22.5,8.9,21.8,9.1,21.1,9.2z"}));});

/***/ }),
/* 440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var width=_ref.width,height=_ref.height;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{className:"shape shape--instagram",width:width,height:height,viewBox:"0 0 512 512"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M256,49.471c67.266,0,75.233.257,101.8,1.469,24.562,1.121,37.9,5.224,46.778,8.674a78.052,78.052,0,0,1,28.966,18.845,78.052,78.052,0,0,1,18.845,28.966c3.45,8.877,7.554,22.216,8.674,46.778,1.212,26.565,1.469,34.532,1.469,101.8s-0.257,75.233-1.469,101.8c-1.121,24.562-5.225,37.9-8.674,46.778a83.427,83.427,0,0,1-47.811,47.811c-8.877,3.45-22.216,7.554-46.778,8.674-26.56,1.212-34.527,1.469-101.8,1.469s-75.237-.257-101.8-1.469c-24.562-1.121-37.9-5.225-46.778-8.674a78.051,78.051,0,0,1-28.966-18.845,78.053,78.053,0,0,1-18.845-28.966c-3.45-8.877-7.554-22.216-8.674-46.778-1.212-26.564-1.469-34.532-1.469-101.8s0.257-75.233,1.469-101.8c1.121-24.562,5.224-37.9,8.674-46.778A78.052,78.052,0,0,1,78.458,78.458a78.053,78.053,0,0,1,28.966-18.845c8.877-3.45,22.216-7.554,46.778-8.674,26.565-1.212,34.532-1.469,101.8-1.469m0-45.391c-68.418,0-77,.29-103.866,1.516-26.815,1.224-45.127,5.482-61.151,11.71a123.488,123.488,0,0,0-44.62,29.057A123.488,123.488,0,0,0,17.3,90.982C11.077,107.007,6.819,125.319,5.6,152.134,4.369,179,4.079,187.582,4.079,256S4.369,333,5.6,359.866c1.224,26.815,5.482,45.127,11.71,61.151a123.489,123.489,0,0,0,29.057,44.62,123.486,123.486,0,0,0,44.62,29.057c16.025,6.228,34.337,10.486,61.151,11.71,26.87,1.226,35.449,1.516,103.866,1.516s77-.29,103.866-1.516c26.815-1.224,45.127-5.482,61.151-11.71a128.817,128.817,0,0,0,73.677-73.677c6.228-16.025,10.486-34.337,11.71-61.151,1.226-26.87,1.516-35.449,1.516-103.866s-0.29-77-1.516-103.866c-1.224-26.815-5.482-45.127-11.71-61.151a123.486,123.486,0,0,0-29.057-44.62A123.487,123.487,0,0,0,421.018,17.3C404.993,11.077,386.681,6.819,359.866,5.6,333,4.369,324.418,4.079,256,4.079h0Z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M256,126.635A129.365,129.365,0,1,0,385.365,256,129.365,129.365,0,0,0,256,126.635Zm0,213.338A83.973,83.973,0,1,1,339.974,256,83.974,83.974,0,0,1,256,339.973Z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{cx:"390.476",cy:"121.524",r:"30.23"}));});

/***/ }),
/* 441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var width=_ref.width,height=_ref.height;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{className:"shape shape--desktop",width:width,height:height,viewBox:"0 0 24 24"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M20.6495453,1 L3.26045451,1 C1.41286366,1 0,2.41286366 0,4.26045451 L0,15.1286363 C0,16.9762272 1.41286366,18.3890908 3.26045451,18.3890908 L10.8681818,18.3890908 L10.8681818,20.5627272 L7.60772719,20.5627272 C6.95563633,20.5627272 6.52090902,20.9974544 6.52090902,21.6495453 C6.52090902,22.3016362 6.95563633,22.7363635 7.60772719,22.7363635 L16.3022727,22.7363635 C16.9543635,22.7363635 17.3890908,22.3016362 17.3890908,21.6495453 C17.3890908,20.9974544 16.9543635,20.5627272 16.3022727,20.5627272 L13.0418182,20.5627272 L13.0418182,18.3890908 L20.6495453,18.3890908 C22.4971362,18.3890908 23.9099998,16.9762272 23.9099998,15.1286363 L23.9099998,4.26045451 C23.9099998,2.41286366 22.4971362,1 20.6495453,1 Z M21.7363635,15.1286363 C21.7363635,15.7807272 21.3016362,16.2154545 20.6495453,16.2154545 L3.26045451,16.2154545 C2.60836365,16.2154545 2.17363634,15.7807272 2.17363634,15.1286363 L2.17363634,4.26045451 C2.17363634,3.60836365 2.60836365,3.17363634 3.26045451,3.17363634 L20.6495453,3.17363634 C21.3016362,3.17363634 21.7363635,3.60836365 21.7363635,4.26045451 L21.7363635,15.1286363 Z"}));});

/***/ }),
/* 442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var width=_ref.width,height=_ref.height;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{className:"shape shape--weibo",width:width,height:height,viewBox:"0 0 511.794 511.795"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M413.691,261.553c-8.747-5.522-18.555-9.995-29.403-13.42c-2.286-0.765-3.907-1.333-4.859-1.715 c-0.951-0.381-2.098-1.093-3.425-2.141c-1.335-1.049-1.767-2.24-1.284-3.571c0.479-1.332,0.903-3.234,1.284-5.708 c8.559-21.888,8.559-38.828,0-50.819c-8.762-11.61-23.315-17.417-43.688-17.417c-20.365,0-43.776,5.617-70.229,16.845 l-1.718,0.572c-1.135,0.381-2.422,0.71-3.847,0.998c-1.431,0.288-2.812,0.333-4.143,0.144c-1.328-0.188-2.281-0.854-2.853-1.997 c-0.572-1.143-0.474-3.046,0.287-5.711c8.561-27.6,6.661-47.488-5.713-59.672c-14.083-14.084-37.541-14.75-70.377-1.997 c-32.827,12.756-65.326,35.214-97.496,67.384c-24.362,24.362-43.159,48.916-56.387,73.66C6.611,281.736,0,305.045,0,326.939 c0,20.554,6.186,39.54,18.555,56.959c12.375,17.419,28.693,31.788,48.966,43.112c20.268,11.32,43.158,20.177,68.662,26.553 c25.505,6.372,51.678,9.562,78.515,9.562c26.838,0,52.58-2.947,77.226-8.847c24.646-5.903,46.158-13.798,64.521-23.698 c18.371-9.894,34.407-21.077,48.109-33.548c13.709-12.467,24.078-25.498,31.124-39.115c7.043-13.606,10.568-26.885,10.568-39.823 c0-12.18-3.23-23.274-9.709-33.264C430.07,274.827,422.452,267.072,413.691,261.553z M320.482,392.474 c-27.884,22.553-63.05,36.019-105.493,40.396c-27.79,2.666-53.915,0.667-78.371-5.995c-24.457-6.667-44.302-17.036-59.527-31.121 c-15.227-14.09-23.697-30.27-25.41-48.544c-2.667-27.788,9.945-52.958,37.829-75.513c27.884-22.56,63.05-36.025,105.494-40.402 c27.79-2.668,53.913-0.666,78.365,5.996c24.455,6.661,44.304,17.034,59.532,31.118c15.229,14.089,23.695,30.269,25.406,48.54 C360.969,344.742,348.366,369.912,320.482,392.474z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M223.269,274.126c-20.174-5.141-40.208-3.327-60.098,5.427c-19.892,8.754-34.307,21.978-43.254,39.684 c-8.946,18.076-9.567,35.923-1.857,53.529c7.71,17.607,21.745,29.644,42.112,36.121c21.126,6.848,42.447,5.708,63.953-3.433 c21.508-9.137,36.542-23.414,45.115-42.824c8.559-19.038,8.322-37.165-0.719-54.393 C259.475,291.018,244.395,279.646,223.269,274.126z M192.719,366.63c-4.188,6.468-10.135,10.992-17.848,13.559 c-7.708,2.573-14.803,2.334-21.271-0.712c-6.47-3.046-10.562-7.851-12.275-14.421c-1.714-6.561-0.477-13.076,3.71-19.551 c3.995-6.286,9.707-10.66,17.129-13.131c7.426-2.475,14.372-2.382,20.844,0.284c6.662,2.851,10.948,7.614,12.851,14.273 C197.761,353.592,196.716,360.155,192.719,366.63z M219.554,332.076c-1.331,2.478-3.427,4.24-6.28,5.287 c-2.855,1.048-5.617,1.092-8.28,0.144c-5.708-2.669-6.945-6.946-3.711-12.847c1.332-2.478,3.378-4.236,6.136-5.287 c2.758-1.047,5.47-1.092,8.136-0.14c2.474,0.947,4.139,2.713,4.998,5.283C221.409,327.08,221.078,329.609,219.554,332.076z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M407.983,206.884c2.102,4.093,5.332,6.899,9.712,8.423c4.381,1.332,8.61,0.953,12.703-1.143 c4.093-2.091,6.902-5.327,8.426-9.707c3.613-10.656,4.236-21.842,1.848-33.545c-2.375-11.704-7.562-22.032-15.55-30.978 c-7.994-8.947-17.614-15.181-28.839-18.704c-11.231-3.521-22.556-4.043-33.972-1.569c-4.575,0.953-8.094,3.381-10.571,7.282 c-2.471,3.9-3.23,8.136-2.275,12.703c0.76,4.569,3.135,8.09,7.128,10.564c4.001,2.474,8.282,3.235,12.854,2.286 c11.995-2.475,22.169,0.857,30.55,9.992c8.378,9.134,10.656,19.698,6.852,31.691C405.505,198.556,405.892,202.792,407.983,206.884 z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M508.917,156.918c-4.859-24.075-15.561-45.251-32.121-63.522c-16.562-18.46-36.356-31.261-59.395-38.403 c-23.028-7.139-46.243-8.232-69.661-3.284c-5.332,1.143-9.473,3.949-12.423,8.424c-2.95,4.476-3.854,9.375-2.707,14.705 c1.14,5.33,3.99,9.469,8.565,12.419c4.562,2.95,9.514,3.855,14.839,2.712c16.563-3.424,33.03-2.614,49.396,2.428 c16.371,5.044,30.457,14.13,42.26,27.264c11.797,12.944,19.418,27.978,22.844,45.111c3.429,17.128,2.478,33.498-2.854,49.105 c-1.52,5.142-1.047,10.09,1.431,14.849c2.471,4.758,6.276,7.992,11.416,9.707c5.141,1.709,10.089,1.331,14.846-1.143 c4.76-2.474,7.997-6.28,9.712-11.42C512.486,203.981,513.769,180.997,508.917,156.918z"}));});

/***/ }),
/* 443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var width=_ref.width,height=_ref.height;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{className:"shape shape--linkedib",width:width,height:height,viewBox:"0 0 24 24"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M5.37549141,9.34059351 L8.27756202,9.34059351 L8.27756202,18.536 L5.37549141,18.536 L5.37549141,9.34059351 Z M16.2067939,9.25219943 C18.2693225,9.25219943 19.8898807,10.5748817 19.8898807,13.42327 L19.8898807,18.536 L16.5991183,18.536 L16.5991183,13.7776536 C16.5991183,12.5320639 16.0844952,11.6820277 14.9523244,11.6820277 C14.0865468,11.6820277 13.605021,12.2555802 13.3810086,12.8085477 C13.2970544,13.0071317 13.3099704,13.2836155 13.3099704,13.5600992 L13.3099704,18.536 L10.0498836,18.536 C10.0498836,18.536 10.0918607,10.1070792 10.0498836,9.34059351 L13.3099704,9.34059351 L13.3099704,10.7839599 C13.5025,10.1526889 14.5442586,9.25219943 16.2067939,9.25219943 Z M6.77284447,5 C7.84366412,5 8.50197805,5.68656775 8.5229666,6.59391889 C8.5229666,7.485125 7.84366412,8.19066317 6.75266317,8.19066317 L6.73167462,8.19066317 C5.68143989,8.19066317 5.00011927,7.48754676 5.00011927,6.59634065 C5.00011927,5.68818225 5.70121756,5 6.77284447,5 Z"}));});

/***/ }),
/* 444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2____ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Button=function(_Component){_inherits(Button,_Component);function Button(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Button);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Button.__proto__||Object.getPrototypeOf(Button)).call.apply(_ref,[this].concat(args))),_this),_this.state={isLoaded:false},_this.handlerClick=function(e){e.preventDefault();if(_this.props.withLoad)_this.setState({isLoaded:true});_this.props.onCallback().then(function(){_this.setState({isLoaded:false});}).catch(function(err){console.log('Something wrong with callback.');});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Button,[{key:'render',value:function render(){var _props=this.props,theme=_props.theme,withLoad=_props.withLoad,children=_props.children,type=_props.type,className=_props.className;var isLoaded=this.state.isLoaded;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:this.handlerClick,type:type,className:className+' btn '+Object(__WEBPACK_IMPORTED_MODULE_3__styles__["p" /* ButtonStyle */])(theme,isLoaded)},withLoad&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'btn--load'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2____["F" /* Load */],{width:'25',height:'25'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'btn--label'},children));}}]);return Button;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Button.defaultProps={withLoad:true,theme:'grey',type:'button'};/* harmony default export */ __webpack_exports__["a"] = (Button);Button.propTypes={theme:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,withLoad:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,children:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,type:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};

/***/ }),
/* 445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(1);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var children=_ref.children;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:__WEBPACK_IMPORTED_MODULE_1__styles__["H" /* ErrorStyle */]+' error'},children);});

/***/ }),
/* 446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(1);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var children=_ref.children;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_1__styles__["_57" /* SuccessStyle */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:__WEBPACK_IMPORTED_MODULE_1__styles__["_58" /* SuccessStyleInner */]},children));});

/***/ }),
/* 447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProgressBar=function(_Component){_inherits(ProgressBar,_Component);function ProgressBar(){_classCallCheck(this,ProgressBar);return _possibleConstructorReturn(this,(ProgressBar.__proto__||Object.getPrototypeOf(ProgressBar)).apply(this,arguments));}_createClass(ProgressBar,[{key:'render',value:function render(){var _props=this.props,theme=_props.theme,x=_props.x,big=_props.big;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'progress-bar '+Object(__WEBPACK_IMPORTED_MODULE_2__styles__["_23" /* ProgressBarStyle */])(theme,x,big)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'progress-bar--inner'}));}}]);return ProgressBar;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ProgressBar.defaultProps={big:false};/* harmony default export */ __webpack_exports__["a"] = (ProgressBar);ProgressBar.propTypes={theme:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};

/***/ }),
/* 448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3____ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_Router__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shapes__ = __webpack_require__(47);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var STOCK_ROLE=['ROLE_SELLER','ROLE_STORE_MANAGER','ROLE_ZONE_MANAGER','ROLE_MANAGER','ROLE_ADMIN','ROLE_SUPER_ADMIN'];var CHALLENGE_ROLE=['ROLE_SELLER','ROLE_STORE_MANAGER'];var Account=function(_Component){_inherits(Account,_Component);function Account(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Account);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Account.__proto__||Object.getPrototypeOf(Account)).call.apply(_ref,[this].concat(args))),_this),_this.state={type:'super seller'},_this.controlPanel=function(){_this.props.callbackClick();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Account,[{key:'render',value:function render(){var _props=this.props,open=_props.open,name=_props.name,picture=_props.picture,role=_props.role,quizz=_props.quizz,total=_props.total;var real_score=parseInt(quizz)/parseInt(total)*100;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'account-card '+Object(__WEBPACK_IMPORTED_MODULE_4__styles__["b" /* AccountStyle */])(open,picture&&picture!=='/media/cache/default/images/default_cover.png'?picture:'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'flex items-center account-card--inner',onClick:this.controlPanel},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'account-card--picture'},picture&&picture!=='/media/cache/default/images/default_cover.png'?'':__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3____["Y" /* RM */],{width:24,height:24})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'account-card--info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'account-card--name'},name,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3____["f" /* ArrowDrop */],{width:12,height:12})),CHALLENGE_ROLE.indexOf(role)!==-1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3____["T" /* ProgressBar */],{theme:'red',x:real_score}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'account-panel'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'reset'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["c" /* NavLink */],{to:__WEBPACK_IMPORTED_MODULE_5__services_Router__["a" /* default */].information.path},' My information ')),CHALLENGE_ROLE.indexOf(role)!==-1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["c" /* NavLink */],{to:__WEBPACK_IMPORTED_MODULE_5__services_Router__["a" /* default */].challenge.path},' My challenge ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["c" /* NavLink */],{to:__WEBPACK_IMPORTED_MODULE_5__services_Router__["a" /* default */].team.exactPath},' Team ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["c" /* NavLink */],{to:__WEBPACK_IMPORTED_MODULE_5__services_Router__["a" /* default */].event.path},' Agenda ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["c" /* NavLink */],{to:__WEBPACK_IMPORTED_MODULE_5__services_Router__["a" /* default */].counterfeits.path},' Counterfeits ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["c" /* NavLink */],{to:__WEBPACK_IMPORTED_MODULE_5__services_Router__["a" /* default */].thefts.path},' Thefts ')))));}}]);return Account;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(_ref2){var Session=_ref2.Session;return{name:Session.username,role:Session.role,picture:Session.picture,quizz:Session.challenge.quizz,total:Session.challenge.quizzTotal};})(Account));

/***/ }),
/* 449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_ga__ = __webpack_require__(36);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Search=function(_Component){_inherits(Search,_Component);function Search(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Search);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Search.__proto__||Object.getPrototypeOf(Search)).call.apply(_ref,[this].concat(args))),_this),_this.state={search:''},_this.searchCallback=function(data){_this.setState({search:data});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Search,[{key:'componentDidMount',value:function componentDidMount(){__WEBPACK_IMPORTED_MODULE_3_react_ga__["a" /* default */].pageview('/');}},{key:'render',value:function render(){var home=this.props.home;var search=this.state.search;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'search '+Object(__WEBPACK_IMPORTED_MODULE_2__styles__["_38" /* SearchStyle */])(search!=='')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components__["_2" /* SearchBar */],{callback:this.searchCallback}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'home-featured'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components__["w" /* Featured */],{home:home})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'home-search-list'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components__["_3" /* SearchList */],{search:search})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components__["P" /* Poll */],null));}}]);return Search;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Search.defaultProps={home:true};/* harmony default export */ __webpack_exports__["a"] = (Search);

/***/ }),
/* 450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ProductNav__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__hoc_withResize__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__hoc_withLoader__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ProductTemplates__ = __webpack_require__(160);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import { fetchPage } from './../../../../services/ApiController'
var Product=function(_Component){_inherits(Product,_Component);function Product(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Product);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Product.__proto__||Object.getPrototypeOf(Product)).call.apply(_ref,[this].concat(args))),_this),_this.state={active:0,ready:false,subtitle:'',isBrand:false// data: [],
},_this.isBrand=function(location){var locationSplit=location.pathname.split('/');_this.setState({isBrand:locationSplit.indexOf('brand')!==-1});},_this.updateSlides=function(index){if(index!==_this.state.active){_this.setState({active:index});}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Product,[{key:'componentDidMount',value:function componentDidMount(){document.body.classList.add('nofooter');this.isBrand(this.props.location);}},{key:'componentWillUnmount',value:function componentWillUnmount(){clearTimeout(this.timer);document.body.classList.remove('nofooter');}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(_ref2){var _this2=this;var location=_ref2.location,data=_ref2.data;if(location.pathname!==this.props.location.pathname){this.setState({ready:false});this.isBrand(location);}if(data!==this.props.data){this.timer=setTimeout(function(){_this2.setState({data:data,active:0,ready:true});},400);}}},{key:'render',value:function render(){var _state=this.state,active=_state.active,data=_state.data,ready=_state.ready,isBrand=_state.isBrand;var viewport=this.props.viewport;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,data&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:''+Object(__WEBPACK_IMPORTED_MODULE_2__styles__["_21" /* ProductStyle */])(data&&data.summary?data.summary.length:0,ready,active+1,data&&data.pdfs&&data.pdfs.length>0)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'product'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'product-nav flex'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["_0" /* ReturnButton */],{big:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ProductNav__["a" /* default */],{panels:data,callback:this.updateSlides,active:active}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["j" /* BookmarkButton */],{item:{slug_bookmark:data.slug_bookmark,type:data.type},is_bookmark:data.is_bookmark,big:true}),data.pdfs.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["M" /* PDFButton */],{big:true,pdfs:data.pdfs}),data.pdfs.length>0&&isBrand&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pdf-annotation'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Click here to download the PDF'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["d" /* Arrow */],{width:24,height:16}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["A" /* FlickitySlider */],{className:__WEBPACK_IMPORTED_MODULE_2__styles__["_46" /* SliderStyle */]+' product-slider',active:active,callback:this.updateSlides,ready:ready,options:{lazyLoad:2,draggable:viewport.isMobile?true:false,selectedAttraction:0.01,friction:0.15,pageDots:false,prevNextButtons:false}},data.summary.map(function(slide,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'product-template template flickity-slide',key:index},slide.type==='intro'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__ProductTemplates__["c" /* IntroTemplate */],Object.assign({},slide,{category:data.category,picture_position:data.picture_position,titleProduct:data.title,picture:data.picture,isBrand:isBrand})),slide.type==='introproduct'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__ProductTemplates__["c" /* IntroTemplate */],Object.assign({},slide,{category:data.category,titleProduct:data.title,picture:data.picture,isBrand:isBrand})),slide.type==='textfull'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__ProductTemplates__["b" /* FullTextTemplate */],Object.assign({},slide.fields,{subtitle:data.title,category:data.category,isBrand:isBrand})),slide.type==='imagelandscape'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__ProductTemplates__["a" /* BaseTemplate */],Object.assign({},slide,{category:data.category,subtitle:data.title,isBrand:isBrand})),slide.type==='imagetext'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__ProductTemplates__["a" /* BaseTemplate */],Object.assign({},slide,{category:data.category,subtitle:data.title,isBrand:isBrand})),slide.type==='imagetextblack'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__ProductTemplates__["a" /* BaseTemplate */],Object.assign({},slide,{category:data.category,subtitle:data.title,isBrand:isBrand})),slide.type==='social'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__ProductTemplates__["f" /* SocialTemplate */],Object.assign({},slide,{category:data.category,subtitle:data.title,isBrand:isBrand})),slide.type==='list'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__ProductTemplates__["e" /* SliderTemplate */],Object.assign({},slide,{category:data.category,subtitle:data.title,isBrand:isBrand})),slide.type==='videos'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__ProductTemplates__["h" /* VideoTemplate */],Object.assign({},slide,{category:data.category,subtitle:data.title,isBrand:isBrand})),slide.type==='video'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__ProductTemplates__["d" /* SingleVideoTemplate */],Object.assign({},slide,{category:data.category,subtitle:data.title,isBrand:isBrand})),slide.type==='push'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__ProductTemplates__["g" /* SuggestTemplate */],Object.assign({},slide,{category:data.category,subtitle:data.title,isBrand:isBrand})),slide.type==='pushpicture'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__ProductTemplates__["g" /* SuggestTemplate */],Object.assign({},slide,{category:data.category,subtitle:data.title,isBrand:isBrand})));})))));}}]);return Product;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__hoc_withLoader__["a" /* withLoader */])(Object(__WEBPACK_IMPORTED_MODULE_5__hoc_withResize__["a" /* withResize */])(Product)));

/***/ }),
/* 451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hoc_withResize__ = __webpack_require__(61);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProductNav=function(_Component){_inherits(ProductNav,_Component);function ProductNav(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ProductNav);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ProductNav.__proto__||Object.getPrototypeOf(ProductNav)).call.apply(_ref,[this].concat(args))),_this),_this.spanPos=function(){var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=_this.span[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var item=_step.value;if(item.parentElement.offsetLeft+item.offsetWidth>=_this.max){item.classList.add('reverse');if(item.parentElement.offsetLeft-item.offsetWidth<0)item.style.transform='translateX('+(item.offsetWidth-item.parentElement.offsetLeft)+'px)';}}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}},_this.resetSpan=function(){var _iteratorNormalCompletion2=true;var _didIteratorError2=false;var _iteratorError2=undefined;try{for(var _iterator2=_this.span[Symbol.iterator](),_step2;!(_iteratorNormalCompletion2=(_step2=_iterator2.next()).done);_iteratorNormalCompletion2=true){var item=_step2.value;item.classList.remove('reverse');item.style.transform='none';}}catch(err){_didIteratorError2=true;_iteratorError2=err;}finally{try{if(!_iteratorNormalCompletion2&&_iterator2.return){_iterator2.return();}}finally{if(_didIteratorError2){throw _iteratorError2;}}}},_this.updateSlides=function(index){return function(e){e.preventDefault();_this.props.callback(index);};},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ProductNav,[{key:'componentDidMount',value:function componentDidMount(){this.span=this.list.querySelectorAll('span');this.max=this.list.offsetWidth;if(this.props.viewport.isMobile)this.spanPos();}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(_ref2){var viewport=_ref2.viewport;if(!viewport.isMobile)this.resetSpan();else this.spanPos();}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.resetSpan();}},{key:'render',// capitalizing = (words) => {
//   return words.toLowerCase().split(' ').reduce((acc, current) => {
//     return `${acc} ${current.charAt(0).toUpperCase()}${current.substring(1)}`
//   }, '')
// }
value:function render(){var _this2=this;var _props=this.props,panels=_props.panels,active=_props.active;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'nav'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'reset flex items-center',ref:function ref(elt){return _this2.list=elt;}},panels&&panels.summary.map(function(slide,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:index,className:index===active?'active':'',onClick:_this2.updateSlides(index)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,// slide.type === 'introproduct' ? 
//   this.capitalizing(slide.fields.bottomLabel) : 
//   this.capitalizing(slide.title)
slide.type==='introproduct'?slide.fields.bottomLabel:slide.title));})));}}]);return ProductNav;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__hoc_withResize__["a" /* withResize */])(ProductNav));

/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g = (function() { return this })() || Function("return this")();

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__(453);

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}


/***/ }),
/* 453 */
/***/ (function(module, exports) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() { return this })() || Function("return this")()
);


/***/ }),
/* 454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_getAverageColor__ = __webpack_require__(37);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BaseTemplate=function(_Component){_inherits(BaseTemplate,_Component);function BaseTemplate(){var _ref;var _temp,_this,_ret;_classCallCheck(this,BaseTemplate);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=BaseTemplate.__proto__||Object.getPrototypeOf(BaseTemplate)).call.apply(_ref,[this].concat(args))),_this),_this.state={color:null},_this.updateAverageColor=function(_ref2){var fields=_ref2.fields;Object(__WEBPACK_IMPORTED_MODULE_3__helpers_getAverageColor__["a" /* getAverageColor */])(fields.image&&fields.image.type==='file'?fields.image.url:null).then(function(data){_this.setState({color:data});}).catch(function(e){console.log(e);});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(BaseTemplate,[{key:'componentDidMount',value:function componentDidMount(){if(this.props.fields.image&&this.props.fields.image.type==='file')this.updateAverageColor(this.props);}},{key:'render',value:function render(){var _props=this.props,type=_props.type,title=_props.title,fields=_props.fields,isBrand=_props.isBrand,subtitle=_props.subtitle,category=_props.category;var color=this.state.color;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'product-template--base '+Object(__WEBPACK_IMPORTED_MODULE_1__styles__["h" /* BaseTemplateStyle */])(fields.image&&fields.image.type==='file'?fields.image.url:'',type,color)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'template-scroll'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'template-left template-picture'},fields.images&&fields.images.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["_8" /* SimpleSlider */],{images:fields.images})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'template-right template-content'},category&&isBrand&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'title-brand'},category),title&&!isBrand&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'subtitle'},title),isBrand&&subtitle&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'subtitle subtitle--brand '},subtitle),title&&isBrand&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'subtitle-h3'},' ',title,' '),fields.description&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content',dangerouslySetInnerHTML:{__html:fields.description}}),fields.titleBis&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'subtitle'},fields.titleBis),fields.descriptionBis&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content',dangerouslySetInnerHTML:{__html:fields.descriptionBis}}))));}}]);return BaseTemplate;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (BaseTemplate);

/***/ }),
/* 455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_flickity__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_flickity___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_flickity__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(1);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var title=_ref.title,description=_ref.description,description2=_ref.description2,isBrand=_ref.isBrand,subtitle=_ref.subtitle,category=_ref.category;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'product-template--base '+__WEBPACK_IMPORTED_MODULE_2__styles__["_62" /* TextTemplateStyle */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'template-scroll'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'template-content'},category&&isBrand&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'title-brand'},category),title&&!isBrand&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'subtitle'},title),isBrand&&subtitle&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'subtitle subtitle--brand '},subtitle),title&&isBrand&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'subtitle-h3'},' ',title,' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'flex'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'template-left'},description&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content',dangerouslySetInnerHTML:{__html:description}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'template-right '},description2&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content',dangerouslySetInnerHTML:{__html:description2}}))))));});

/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * matchesSelector v2.0.2
 * matchesSelector( element, '.selector' )
 * MIT license
 */

/*jshint browser: true, strict: true, undef: true, unused: true */

( function( window, factory ) {
  /*global define: false, module: false */
  'use strict';
  // universal module definition
  if ( true ) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory();
  } else {
    // browser global
    window.matchesSelector = factory();
  }

}( window, function factory() {
  'use strict';

  var matchesMethod = ( function() {
    var ElemProto = window.Element.prototype;
    // check for the standard method name first
    if ( ElemProto.matches ) {
      return 'matches';
    }
    // check un-prefixed
    if ( ElemProto.matchesSelector ) {
      return 'matchesSelector';
    }
    // check vendor prefixes
    var prefixes = [ 'webkit', 'moz', 'ms', 'o' ];

    for ( var i=0; i < prefixes.length; i++ ) {
      var prefix = prefixes[i];
      var method = prefix + 'MatchesSelector';
      if ( ElemProto[ method ] ) {
        return method;
      }
    }
  })();

  return function matchesSelector( elem, selector ) {
    return elem[ matchesMethod ]( selector );
  };

}));


/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// Flickity.Cell
( function( window, factory ) {
  // universal module definition
  if ( true ) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
      __webpack_require__(161),
    ], __WEBPACK_AMD_DEFINE_RESULT__ = function( getSize ) {
      return factory( window, getSize );
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
        window,
        require('get-size')
    );
  } else {
    // browser global
    window.Flickity = window.Flickity || {};
    window.Flickity.Cell = factory(
        window,
        window.getSize
    );
  }

}( window, function factory( window, getSize ) {

'use strict';

function Cell( elem, parent ) {
  this.element = elem;
  this.parent = parent;

  this.create();
}

var proto = Cell.prototype;

proto.create = function() {
  this.element.style.position = 'absolute';
  this.element.setAttribute( 'aria-hidden', 'true' );
  this.x = 0;
  this.shift = 0;
};

proto.destroy = function() {
  // reset style
  this.unselect();
  this.element.style.position = '';
  var side = this.parent.originSide;
  this.element.style[ side ] = '';
  this.element.removeAttribute('aria-hidden');
};

proto.getSize = function() {
  this.size = getSize( this.element );
};

proto.setPosition = function( x ) {
  this.x = x;
  this.updateTarget();
  this.renderPosition( x );
};

// setDefaultTarget v1 method, backwards compatibility, remove in v3
proto.updateTarget = proto.setDefaultTarget = function() {
  var marginProperty = this.parent.originSide == 'left' ? 'marginLeft' : 'marginRight';
  this.target = this.x + this.size[ marginProperty ] +
    this.size.width * this.parent.cellAlign;
};

proto.renderPosition = function( x ) {
  // render position of cell with in slider
  var side = this.parent.originSide;
  this.element.style[ side ] = this.parent.getPositionValue( x );
};

proto.select = function() {
  this.element.classList.add('is-selected');
  this.element.removeAttribute('aria-hidden');
};

proto.unselect = function() {
  this.element.classList.remove('is-selected');
  this.element.setAttribute( 'aria-hidden', 'true' );
};

/**
 * @param {Integer} shift - 0, 1, or -1
 */
proto.wrapShift = function( shift ) {
  this.shift = shift;
  this.renderPosition( this.x + this.parent.slideableWidth * shift );
};

proto.remove = function() {
  this.element.parentNode.removeChild( this.element );
};

return Cell;

} ) );


/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;// slide
( function( window, factory ) {
  // universal module definition
  if ( true ) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory();
  } else {
    // browser global
    window.Flickity = window.Flickity || {};
    window.Flickity.Slide = factory();
  }

}( window, function factory() {
'use strict';

function Slide( parent ) {
  this.parent = parent;
  this.isOriginLeft = parent.originSide == 'left';
  this.cells = [];
  this.outerWidth = 0;
  this.height = 0;
}

var proto = Slide.prototype;

proto.addCell = function( cell ) {
  this.cells.push( cell );
  this.outerWidth += cell.size.outerWidth;
  this.height = Math.max( cell.size.outerHeight, this.height );
  // first cell stuff
  if ( this.cells.length == 1 ) {
    this.x = cell.x; // x comes from first cell
    var beginMargin = this.isOriginLeft ? 'marginLeft' : 'marginRight';
    this.firstMargin = cell.size[ beginMargin ];
  }
};

proto.updateTarget = function() {
  var endMargin = this.isOriginLeft ? 'marginRight' : 'marginLeft';
  var lastCell = this.getLastCell();
  var lastMargin = lastCell ? lastCell.size[ endMargin ] : 0;
  var slideWidth = this.outerWidth - ( this.firstMargin + lastMargin );
  this.target = this.x + this.firstMargin + slideWidth * this.parent.cellAlign;
};

proto.getLastCell = function() {
  return this.cells[ this.cells.length - 1 ];
};

proto.select = function() {
  this.cells.forEach( function( cell ) {
    cell.select();
  } );
};

proto.unselect = function() {
  this.cells.forEach( function( cell ) {
    cell.unselect();
  } );
};

proto.getCellElements = function() {
  return this.cells.map( function( cell ) {
    return cell.element;
  } );
};

return Slide;

} ) );


/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// animate
( function( window, factory ) {
  // universal module definition
  if ( true ) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
      __webpack_require__(26),
    ], __WEBPACK_AMD_DEFINE_RESULT__ = function( utils ) {
      return factory( window, utils );
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
        window,
        require('fizzy-ui-utils')
    );
  } else {
    // browser global
    window.Flickity = window.Flickity || {};
    window.Flickity.animatePrototype = factory(
        window,
        window.fizzyUIUtils
    );
  }

}( window, function factory( window, utils ) {

'use strict';

// -------------------------- animate -------------------------- //

var proto = {};

proto.startAnimation = function() {
  if ( this.isAnimating ) {
    return;
  }

  this.isAnimating = true;
  this.restingFrames = 0;
  this.animate();
};

proto.animate = function() {
  this.applyDragForce();
  this.applySelectedAttraction();

  var previousX = this.x;

  this.integratePhysics();
  this.positionSlider();
  this.settle( previousX );
  // animate next frame
  if ( this.isAnimating ) {
    var _this = this;
    requestAnimationFrame( function animateFrame() {
      _this.animate();
    } );
  }
};

proto.positionSlider = function() {
  var x = this.x;
  // wrap position around
  if ( this.options.wrapAround && this.cells.length > 1 ) {
    x = utils.modulo( x, this.slideableWidth );
    x -= this.slideableWidth;
    this.shiftWrapCells( x );
  }

  this.setTranslateX( x, this.isAnimating );
  this.dispatchScrollEvent();
};

proto.setTranslateX = function( x, is3d ) {
  x += this.cursorPosition;
  // reverse if right-to-left and using transform
  x = this.options.rightToLeft ? -x : x;
  var translateX = this.getPositionValue( x );
  // use 3D transforms for hardware acceleration on iOS
  // but use 2D when settled, for better font-rendering
  this.slider.style.transform = is3d ?
    'translate3d(' + translateX + ',0,0)' : 'translateX(' + translateX + ')';
};

proto.dispatchScrollEvent = function() {
  var firstSlide = this.slides[0];
  if ( !firstSlide ) {
    return;
  }
  var positionX = -this.x - firstSlide.target;
  var progress = positionX / this.slidesWidth;
  this.dispatchEvent( 'scroll', null, [ progress, positionX ] );
};

proto.positionSliderAtSelected = function() {
  if ( !this.cells.length ) {
    return;
  }
  this.x = -this.selectedSlide.target;
  this.velocity = 0; // stop wobble
  this.positionSlider();
};

proto.getPositionValue = function( position ) {
  if ( this.options.percentPosition ) {
    // percent position, round to 2 digits, like 12.34%
    return ( Math.round( ( position / this.size.innerWidth ) * 10000 ) * 0.01 ) + '%';
  } else {
    // pixel positioning
    return Math.round( position ) + 'px';
  }
};

proto.settle = function( previousX ) {
  // keep track of frames where x hasn't moved
  var isResting = !this.isPointerDown &&
      Math.round( this.x * 100 ) == Math.round( previousX * 100 );
  if ( isResting ) {
    this.restingFrames++;
  }
  // stop animating if resting for 3 or more frames
  if ( this.restingFrames > 2 ) {
    this.isAnimating = false;
    delete this.isFreeScrolling;
    // render position with translateX when settled
    this.positionSlider();
    this.dispatchEvent( 'settle', null, [ this.selectedIndex ] );
  }
};

proto.shiftWrapCells = function( x ) {
  // shift before cells
  var beforeGap = this.cursorPosition + x;
  this._shiftCells( this.beforeShiftCells, beforeGap, -1 );
  // shift after cells
  var afterGap = this.size.innerWidth - ( x + this.slideableWidth + this.cursorPosition );
  this._shiftCells( this.afterShiftCells, afterGap, 1 );
};

proto._shiftCells = function( cells, gap, shift ) {
  for ( var i = 0; i < cells.length; i++ ) {
    var cell = cells[i];
    var cellShift = gap > 0 ? shift : 0;
    cell.wrapShift( cellShift );
    gap -= cell.size.outerWidth;
  }
};

proto._unshiftCells = function( cells ) {
  if ( !cells || !cells.length ) {
    return;
  }
  for ( var i = 0; i < cells.length; i++ ) {
    cells[i].wrapShift( 0 );
  }
};

// -------------------------- physics -------------------------- //

proto.integratePhysics = function() {
  this.x += this.velocity;
  this.velocity *= this.getFrictionFactor();
};

proto.applyForce = function( force ) {
  this.velocity += force;
};

proto.getFrictionFactor = function() {
  return 1 - this.options[ this.isFreeScrolling ? 'freeScrollFriction' : 'friction' ];
};

proto.getRestingPosition = function() {
  // my thanks to Steven Wittens, who simplified this math greatly
  return this.x + this.velocity / ( 1 - this.getFrictionFactor() );
};

proto.applyDragForce = function() {
  if ( !this.isDraggable || !this.isPointerDown ) {
    return;
  }
  // change the position to drag position by applying force
  var dragVelocity = this.dragX - this.x;
  var dragForce = dragVelocity - this.velocity;
  this.applyForce( dragForce );
};

proto.applySelectedAttraction = function() {
  // do not attract if pointer down or no slides
  var dragDown = this.isDraggable && this.isPointerDown;
  if ( dragDown || this.isFreeScrolling || !this.slides.length ) {
    return;
  }
  var distance = this.selectedSlide.target * -1 - this.x;
  var force = distance * this.options.selectedAttraction;
  this.applyForce( force );
};

return proto;

} ) );


/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// drag
( function( window, factory ) {
  // universal module definition
  if ( true ) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
      __webpack_require__(28),
      __webpack_require__(461),
      __webpack_require__(26),
    ], __WEBPACK_AMD_DEFINE_RESULT__ = function( Flickity, Unidragger, utils ) {
      return factory( window, Flickity, Unidragger, utils );
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
        window,
        require('./flickity'),
        require('unidragger'),
        require('fizzy-ui-utils')
    );
  } else {
    // browser global
    window.Flickity = factory(
        window,
        window.Flickity,
        window.Unidragger,
        window.fizzyUIUtils
    );
  }

}( window, function factory( window, Flickity, Unidragger, utils ) {

'use strict';

// ----- defaults ----- //

utils.extend( Flickity.defaults, {
  draggable: '>1',
  dragThreshold: 3,
} );

// ----- create ----- //

Flickity.createMethods.push('_createDrag');

// -------------------------- drag prototype -------------------------- //

var proto = Flickity.prototype;
utils.extend( proto, Unidragger.prototype );
proto._touchActionValue = 'pan-y';

// --------------------------  -------------------------- //

var isTouch = 'createTouch' in document;
var isTouchmoveScrollCanceled = false;

proto._createDrag = function() {
  this.on( 'activate', this.onActivateDrag );
  this.on( 'uiChange', this._uiChangeDrag );
  this.on( 'deactivate', this.onDeactivateDrag );
  this.on( 'cellChange', this.updateDraggable );
  // TODO updateDraggable on resize? if groupCells & slides change
  // HACK - add seemingly innocuous handler to fix iOS 10 scroll behavior
  // #457, RubaXa/Sortable#973
  if ( isTouch && !isTouchmoveScrollCanceled ) {
    window.addEventListener( 'touchmove', function() {} );
    isTouchmoveScrollCanceled = true;
  }
};

proto.onActivateDrag = function() {
  this.handles = [ this.viewport ];
  this.bindHandles();
  this.updateDraggable();
};

proto.onDeactivateDrag = function() {
  this.unbindHandles();
  this.element.classList.remove('is-draggable');
};

proto.updateDraggable = function() {
  // disable dragging if less than 2 slides. #278
  if ( this.options.draggable == '>1' ) {
    this.isDraggable = this.slides.length > 1;
  } else {
    this.isDraggable = this.options.draggable;
  }
  if ( this.isDraggable ) {
    this.element.classList.add('is-draggable');
  } else {
    this.element.classList.remove('is-draggable');
  }
};

// backwards compatibility
proto.bindDrag = function() {
  this.options.draggable = true;
  this.updateDraggable();
};

proto.unbindDrag = function() {
  this.options.draggable = false;
  this.updateDraggable();
};

proto._uiChangeDrag = function() {
  delete this.isFreeScrolling;
};

// -------------------------- pointer events -------------------------- //

proto.pointerDown = function( event, pointer ) {
  if ( !this.isDraggable ) {
    this._pointerDownDefault( event, pointer );
    return;
  }
  var isOkay = this.okayPointerDown( event );
  if ( !isOkay ) {
    return;
  }

  this._pointerDownPreventDefault( event );
  this.pointerDownFocus( event );
  // blur
  if ( document.activeElement != this.element ) {
    // do not blur if already focused
    this.pointerDownBlur();
  }

  // stop if it was moving
  this.dragX = this.x;
  this.viewport.classList.add('is-pointer-down');
  // track scrolling
  this.pointerDownScroll = getScrollPosition();
  window.addEventListener( 'scroll', this );

  this._pointerDownDefault( event, pointer );
};

// default pointerDown logic, used for staticClick
proto._pointerDownDefault = function( event, pointer ) {
  // track start event position
  // Safari 9 overrides pageX and pageY. These values needs to be copied. #779
  this.pointerDownPointer = {
    pageX: pointer.pageX,
    pageY: pointer.pageY,
  };
  // bind move and end events
  this._bindPostStartEvents( event );
  this.dispatchEvent( 'pointerDown', event, [ pointer ] );
};

var focusNodes = {
  INPUT: true,
  TEXTAREA: true,
  SELECT: true,
};

proto.pointerDownFocus = function( event ) {
  var isFocusNode = focusNodes[ event.target.nodeName ];
  if ( !isFocusNode ) {
    this.focus();
  }
};

proto._pointerDownPreventDefault = function( event ) {
  var isTouchStart = event.type == 'touchstart';
  var isTouchPointer = event.pointerType == 'touch';
  var isFocusNode = focusNodes[ event.target.nodeName ];
  if ( !isTouchStart && !isTouchPointer && !isFocusNode ) {
    event.preventDefault();
  }
};

// ----- move ----- //

proto.hasDragStarted = function( moveVector ) {
  return Math.abs( moveVector.x ) > this.options.dragThreshold;
};

// ----- up ----- //

proto.pointerUp = function( event, pointer ) {
  delete this.isTouchScrolling;
  this.viewport.classList.remove('is-pointer-down');
  this.dispatchEvent( 'pointerUp', event, [ pointer ] );
  this._dragPointerUp( event, pointer );
};

proto.pointerDone = function() {
  window.removeEventListener( 'scroll', this );
  delete this.pointerDownScroll;
};

// -------------------------- dragging -------------------------- //

proto.dragStart = function( event, pointer ) {
  if ( !this.isDraggable ) {
    return;
  }
  this.dragStartPosition = this.x;
  this.startAnimation();
  window.removeEventListener( 'scroll', this );
  this.dispatchEvent( 'dragStart', event, [ pointer ] );
};

proto.pointerMove = function( event, pointer ) {
  var moveVector = this._dragPointerMove( event, pointer );
  this.dispatchEvent( 'pointerMove', event, [ pointer, moveVector ] );
  this._dragMove( event, pointer, moveVector );
};

proto.dragMove = function( event, pointer, moveVector ) {
  if ( !this.isDraggable ) {
    return;
  }
  event.preventDefault();

  this.previousDragX = this.dragX;
  // reverse if right-to-left
  var direction = this.options.rightToLeft ? -1 : 1;
  if ( this.options.wrapAround ) {
    // wrap around move. #589
    moveVector.x %= this.slideableWidth;
  }
  var dragX = this.dragStartPosition + moveVector.x * direction;

  if ( !this.options.wrapAround && this.slides.length ) {
    // slow drag
    var originBound = Math.max( -this.slides[0].target, this.dragStartPosition );
    dragX = dragX > originBound ? ( dragX + originBound ) * 0.5 : dragX;
    var endBound = Math.min( -this.getLastSlide().target, this.dragStartPosition );
    dragX = dragX < endBound ? ( dragX + endBound ) * 0.5 : dragX;
  }

  this.dragX = dragX;

  this.dragMoveTime = new Date();
  this.dispatchEvent( 'dragMove', event, [ pointer, moveVector ] );
};

proto.dragEnd = function( event, pointer ) {
  if ( !this.isDraggable ) {
    return;
  }
  if ( this.options.freeScroll ) {
    this.isFreeScrolling = true;
  }
  // set selectedIndex based on where flick will end up
  var index = this.dragEndRestingSelect();

  if ( this.options.freeScroll && !this.options.wrapAround ) {
    // if free-scroll & not wrap around
    // do not free-scroll if going outside of bounding slides
    // so bounding slides can attract slider, and keep it in bounds
    var restingX = this.getRestingPosition();
    this.isFreeScrolling = -restingX > this.slides[0].target &&
      -restingX < this.getLastSlide().target;
  } else if ( !this.options.freeScroll && index == this.selectedIndex ) {
    // boost selection if selected index has not changed
    index += this.dragEndBoostSelect();
  }
  delete this.previousDragX;
  // apply selection
  // TODO refactor this, selecting here feels weird
  // HACK, set flag so dragging stays in correct direction
  this.isDragSelect = this.options.wrapAround;
  this.select( index );
  delete this.isDragSelect;
  this.dispatchEvent( 'dragEnd', event, [ pointer ] );
};

proto.dragEndRestingSelect = function() {
  var restingX = this.getRestingPosition();
  // how far away from selected slide
  var distance = Math.abs( this.getSlideDistance( -restingX, this.selectedIndex ) );
  // get closet resting going up and going down
  var positiveResting = this._getClosestResting( restingX, distance, 1 );
  var negativeResting = this._getClosestResting( restingX, distance, -1 );
  // use closer resting for wrap-around
  var index = positiveResting.distance < negativeResting.distance ?
    positiveResting.index : negativeResting.index;
  return index;
};

/**
 * given resting X and distance to selected cell
 * get the distance and index of the closest cell
 * @param {Number} restingX - estimated post-flick resting position
 * @param {Number} distance - distance to selected cell
 * @param {Integer} increment - +1 or -1, going up or down
 * @returns {Object} - { distance: {Number}, index: {Integer} }
 */
proto._getClosestResting = function( restingX, distance, increment ) {
  var index = this.selectedIndex;
  var minDistance = Infinity;
  var condition = this.options.contain && !this.options.wrapAround ?
    // if contain, keep going if distance is equal to minDistance
    function( dist, minDist ) {
      return dist <= minDist;
    } : function( dist, minDist ) {
      return dist < minDist;
    };
  while ( condition( distance, minDistance ) ) {
    // measure distance to next cell
    index += increment;
    minDistance = distance;
    distance = this.getSlideDistance( -restingX, index );
    if ( distance === null ) {
      break;
    }
    distance = Math.abs( distance );
  }
  return {
    distance: minDistance,
    // selected was previous index
    index: index - increment,
  };
};

/**
 * measure distance between x and a slide target
 * @param {Number} x - horizontal position
 * @param {Integer} index - slide index
 * @returns {Number} - slide distance
 */
proto.getSlideDistance = function( x, index ) {
  var len = this.slides.length;
  // wrap around if at least 2 slides
  var isWrapAround = this.options.wrapAround && len > 1;
  var slideIndex = isWrapAround ? utils.modulo( index, len ) : index;
  var slide = this.slides[ slideIndex ];
  if ( !slide ) {
    return null;
  }
  // add distance for wrap-around slides
  var wrap = isWrapAround ? this.slideableWidth * Math.floor( index/len ) : 0;
  return x - ( slide.target + wrap );
};

proto.dragEndBoostSelect = function() {
  // do not boost if no previousDragX or dragMoveTime
  if ( this.previousDragX === undefined || !this.dragMoveTime ||
    // or if drag was held for 100 ms
    new Date() - this.dragMoveTime > 100 ) {
    return 0;
  }

  var distance = this.getSlideDistance( -this.dragX, this.selectedIndex );
  var delta = this.previousDragX - this.dragX;
  if ( distance > 0 && delta > 0 ) {
    // boost to next if moving towards the right, and positive velocity
    return 1;
  } else if ( distance < 0 && delta < 0 ) {
    // boost to previous if moving towards the left, and negative velocity
    return -1;
  }
  return 0;
};

// ----- staticClick ----- //

proto.staticClick = function( event, pointer ) {
  // get clickedCell, if cell was clicked
  var clickedCell = this.getParentCell( event.target );
  var cellElem = clickedCell && clickedCell.element;
  var cellIndex = clickedCell && this.cells.indexOf( clickedCell );
  this.dispatchEvent( 'staticClick', event, [ pointer, cellElem, cellIndex ] );
};

// ----- scroll ----- //

proto.onscroll = function() {
  var scroll = getScrollPosition();
  var scrollMoveX = this.pointerDownScroll.x - scroll.x;
  var scrollMoveY = this.pointerDownScroll.y - scroll.y;
  // cancel click/tap if scroll is too much
  if ( Math.abs( scrollMoveX ) > 3 || Math.abs( scrollMoveY ) > 3 ) {
    this._pointerDone();
  }
};

// ----- utils ----- //

function getScrollPosition() {
  return {
    x: window.pageXOffset,
    y: window.pageYOffset,
  };
}

// -----  ----- //

return Flickity;

} ) );


/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Unidragger v2.3.1
 * Draggable base class
 * MIT license
 */

/*jshint browser: true, unused: true, undef: true, strict: true */

( function( window, factory ) {
  // universal module definition
  /*jshint strict: false */ /*globals define, module, require */

  if ( true ) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
      __webpack_require__(95)
    ], __WEBPACK_AMD_DEFINE_RESULT__ = function( Unipointer ) {
      return factory( window, Unipointer );
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
      window,
      require('unipointer')
    );
  } else {
    // browser global
    window.Unidragger = factory(
      window,
      window.Unipointer
    );
  }

}( window, function factory( window, Unipointer ) {

'use strict';

// -------------------------- Unidragger -------------------------- //

function Unidragger() {}

// inherit Unipointer & EvEmitter
var proto = Unidragger.prototype = Object.create( Unipointer.prototype );

// ----- bind start ----- //

proto.bindHandles = function() {
  this._bindHandles( true );
};

proto.unbindHandles = function() {
  this._bindHandles( false );
};

/**
 * Add or remove start event
 * @param {Boolean} isAdd
 */
proto._bindHandles = function( isAdd ) {
  // munge isAdd, default to true
  isAdd = isAdd === undefined ? true : isAdd;
  // bind each handle
  var bindMethod = isAdd ? 'addEventListener' : 'removeEventListener';
  var touchAction = isAdd ? this._touchActionValue : '';
  for ( var i=0; i < this.handles.length; i++ ) {
    var handle = this.handles[i];
    this._bindStartEvent( handle, isAdd );
    handle[ bindMethod ]( 'click', this );
    // touch-action: none to override browser touch gestures. metafizzy/flickity#540
    if ( window.PointerEvent ) {
      handle.style.touchAction = touchAction;
    }
  }
};

// prototype so it can be overwriteable by Flickity
proto._touchActionValue = 'none';

// ----- start event ----- //

/**
 * pointer start
 * @param {Event} event
 * @param {Event or Touch} pointer
 */
proto.pointerDown = function( event, pointer ) {
  var isOkay = this.okayPointerDown( event );
  if ( !isOkay ) {
    return;
  }
  // track start event position
  // Safari 9 overrides pageX and pageY. These values needs to be copied. flickity#842
  this.pointerDownPointer = {
    pageX: pointer.pageX,
    pageY: pointer.pageY,
  };

  event.preventDefault();
  this.pointerDownBlur();
  // bind move and end events
  this._bindPostStartEvents( event );
  this.emitEvent( 'pointerDown', [ event, pointer ] );
};

// nodes that have text fields
var cursorNodes = {
  TEXTAREA: true,
  INPUT: true,
  SELECT: true,
  OPTION: true,
};

// input types that do not have text fields
var clickTypes = {
  radio: true,
  checkbox: true,
  button: true,
  submit: true,
  image: true,
  file: true,
};

// dismiss inputs with text fields. flickity#403, flickity#404
proto.okayPointerDown = function( event ) {
  var isCursorNode = cursorNodes[ event.target.nodeName ];
  var isClickType = clickTypes[ event.target.type ];
  var isOkay = !isCursorNode || isClickType;
  if ( !isOkay ) {
    this._pointerReset();
  }
  return isOkay;
};

// kludge to blur previously focused input
proto.pointerDownBlur = function() {
  var focused = document.activeElement;
  // do not blur body for IE10, metafizzy/flickity#117
  var canBlur = focused && focused.blur && focused != document.body;
  if ( canBlur ) {
    focused.blur();
  }
};

// ----- move event ----- //

/**
 * drag move
 * @param {Event} event
 * @param {Event or Touch} pointer
 */
proto.pointerMove = function( event, pointer ) {
  var moveVector = this._dragPointerMove( event, pointer );
  this.emitEvent( 'pointerMove', [ event, pointer, moveVector ] );
  this._dragMove( event, pointer, moveVector );
};

// base pointer move logic
proto._dragPointerMove = function( event, pointer ) {
  var moveVector = {
    x: pointer.pageX - this.pointerDownPointer.pageX,
    y: pointer.pageY - this.pointerDownPointer.pageY
  };
  // start drag if pointer has moved far enough to start drag
  if ( !this.isDragging && this.hasDragStarted( moveVector ) ) {
    this._dragStart( event, pointer );
  }
  return moveVector;
};

// condition if pointer has moved far enough to start drag
proto.hasDragStarted = function( moveVector ) {
  return Math.abs( moveVector.x ) > 3 || Math.abs( moveVector.y ) > 3;
};

// ----- end event ----- //

/**
 * pointer up
 * @param {Event} event
 * @param {Event or Touch} pointer
 */
proto.pointerUp = function( event, pointer ) {
  this.emitEvent( 'pointerUp', [ event, pointer ] );
  this._dragPointerUp( event, pointer );
};

proto._dragPointerUp = function( event, pointer ) {
  if ( this.isDragging ) {
    this._dragEnd( event, pointer );
  } else {
    // pointer didn't move enough for drag to start
    this._staticClick( event, pointer );
  }
};

// -------------------------- drag -------------------------- //

// dragStart
proto._dragStart = function( event, pointer ) {
  this.isDragging = true;
  // prevent clicks
  this.isPreventingClicks = true;
  this.dragStart( event, pointer );
};

proto.dragStart = function( event, pointer ) {
  this.emitEvent( 'dragStart', [ event, pointer ] );
};

// dragMove
proto._dragMove = function( event, pointer, moveVector ) {
  // do not drag if not dragging yet
  if ( !this.isDragging ) {
    return;
  }

  this.dragMove( event, pointer, moveVector );
};

proto.dragMove = function( event, pointer, moveVector ) {
  event.preventDefault();
  this.emitEvent( 'dragMove', [ event, pointer, moveVector ] );
};

// dragEnd
proto._dragEnd = function( event, pointer ) {
  // set flags
  this.isDragging = false;
  // re-enable clicking async
  setTimeout( function() {
    delete this.isPreventingClicks;
  }.bind( this ) );

  this.dragEnd( event, pointer );
};

proto.dragEnd = function( event, pointer ) {
  this.emitEvent( 'dragEnd', [ event, pointer ] );
};

// ----- onclick ----- //

// handle all clicks and prevent clicks when dragging
proto.onclick = function( event ) {
  if ( this.isPreventingClicks ) {
    event.preventDefault();
  }
};

// ----- staticClick ----- //

// triggered after pointer down & up with no/tiny movement
proto._staticClick = function( event, pointer ) {
  // ignore emulated mouse up clicks
  if ( this.isIgnoringMouseUp && event.type == 'mouseup' ) {
    return;
  }

  this.staticClick( event, pointer );

  // set flag for emulated clicks 300ms after touchend
  if ( event.type != 'mouseup' ) {
    this.isIgnoringMouseUp = true;
    // reset flag after 300ms
    setTimeout( function() {
      delete this.isIgnoringMouseUp;
    }.bind( this ), 400 );
  }
};

proto.staticClick = function( event, pointer ) {
  this.emitEvent( 'staticClick', [ event, pointer ] );
};

// ----- utils ----- //

Unidragger.getPointerPoint = Unipointer.getPointerPoint;

// -----  ----- //

return Unidragger;

}));


/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// prev/next buttons
( function( window, factory ) {
  // universal module definition
  if ( true ) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
      __webpack_require__(28),
      __webpack_require__(95),
      __webpack_require__(26),
    ], __WEBPACK_AMD_DEFINE_RESULT__ = function( Flickity, Unipointer, utils ) {
      return factory( window, Flickity, Unipointer, utils );
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
        window,
        require('./flickity'),
        require('unipointer'),
        require('fizzy-ui-utils')
    );
  } else {
    // browser global
    factory(
        window,
        window.Flickity,
        window.Unipointer,
        window.fizzyUIUtils
    );
  }

}( window, function factory( window, Flickity, Unipointer, utils ) {
'use strict';

var svgURI = 'http://www.w3.org/2000/svg';

// -------------------------- PrevNextButton -------------------------- //

function PrevNextButton( direction, parent ) {
  this.direction = direction;
  this.parent = parent;
  this._create();
}

PrevNextButton.prototype = Object.create( Unipointer.prototype );

PrevNextButton.prototype._create = function() {
  // properties
  this.isEnabled = true;
  this.isPrevious = this.direction == -1;
  var leftDirection = this.parent.options.rightToLeft ? 1 : -1;
  this.isLeft = this.direction == leftDirection;

  var element = this.element = document.createElement('button');
  element.className = 'flickity-button flickity-prev-next-button';
  element.className += this.isPrevious ? ' previous' : ' next';
  // prevent button from submitting form http://stackoverflow.com/a/10836076/182183
  element.setAttribute( 'type', 'button' );
  // init as disabled
  this.disable();

  element.setAttribute( 'aria-label', this.isPrevious ? 'Previous' : 'Next' );

  // create arrow
  var svg = this.createSVG();
  element.appendChild( svg );
  // events
  this.parent.on( 'select', this.update.bind( this ) );
  this.on( 'pointerDown', this.parent.childUIPointerDown.bind( this.parent ) );
};

PrevNextButton.prototype.activate = function() {
  this.bindStartEvent( this.element );
  this.element.addEventListener( 'click', this );
  // add to DOM
  this.parent.element.appendChild( this.element );
};

PrevNextButton.prototype.deactivate = function() {
  // remove from DOM
  this.parent.element.removeChild( this.element );
  // click events
  this.unbindStartEvent( this.element );
  this.element.removeEventListener( 'click', this );
};

PrevNextButton.prototype.createSVG = function() {
  var svg = document.createElementNS( svgURI, 'svg' );
  svg.setAttribute( 'class', 'flickity-button-icon' );
  svg.setAttribute( 'viewBox', '0 0 100 100' );
  var path = document.createElementNS( svgURI, 'path' );
  var pathMovements = getArrowMovements( this.parent.options.arrowShape );
  path.setAttribute( 'd', pathMovements );
  path.setAttribute( 'class', 'arrow' );
  // rotate arrow
  if ( !this.isLeft ) {
    path.setAttribute( 'transform', 'translate(100, 100) rotate(180) ' );
  }
  svg.appendChild( path );
  return svg;
};

// get SVG path movmement
function getArrowMovements( shape ) {
  // use shape as movement if string
  if ( typeof shape == 'string' ) {
    return shape;
  }
  // create movement string
  return 'M ' + shape.x0 + ',50' +
    ' L ' + shape.x1 + ',' + ( shape.y1 + 50 ) +
    ' L ' + shape.x2 + ',' + ( shape.y2 + 50 ) +
    ' L ' + shape.x3 + ',50 ' +
    ' L ' + shape.x2 + ',' + ( 50 - shape.y2 ) +
    ' L ' + shape.x1 + ',' + ( 50 - shape.y1 ) +
    ' Z';
}

PrevNextButton.prototype.handleEvent = utils.handleEvent;

PrevNextButton.prototype.onclick = function() {
  if ( !this.isEnabled ) {
    return;
  }
  this.parent.uiChange();
  var method = this.isPrevious ? 'previous' : 'next';
  this.parent[ method ]();
};

// -----  ----- //

PrevNextButton.prototype.enable = function() {
  if ( this.isEnabled ) {
    return;
  }
  this.element.disabled = false;
  this.isEnabled = true;
};

PrevNextButton.prototype.disable = function() {
  if ( !this.isEnabled ) {
    return;
  }
  this.element.disabled = true;
  this.isEnabled = false;
};

PrevNextButton.prototype.update = function() {
  // index of first or last slide, if previous or next
  var slides = this.parent.slides;
  // enable is wrapAround and at least 2 slides
  if ( this.parent.options.wrapAround && slides.length > 1 ) {
    this.enable();
    return;
  }
  var lastIndex = slides.length ? slides.length - 1 : 0;
  var boundIndex = this.isPrevious ? 0 : lastIndex;
  var method = this.parent.selectedIndex == boundIndex ? 'disable' : 'enable';
  this[ method ]();
};

PrevNextButton.prototype.destroy = function() {
  this.deactivate();
  this.allOff();
};

// -------------------------- Flickity prototype -------------------------- //

utils.extend( Flickity.defaults, {
  prevNextButtons: true,
  arrowShape: {
    x0: 10,
    x1: 60, y1: 50,
    x2: 70, y2: 40,
    x3: 30,
  },
} );

Flickity.createMethods.push('_createPrevNextButtons');
var proto = Flickity.prototype;

proto._createPrevNextButtons = function() {
  if ( !this.options.prevNextButtons ) {
    return;
  }

  this.prevButton = new PrevNextButton( -1, this );
  this.nextButton = new PrevNextButton( 1, this );

  this.on( 'activate', this.activatePrevNextButtons );
};

proto.activatePrevNextButtons = function() {
  this.prevButton.activate();
  this.nextButton.activate();
  this.on( 'deactivate', this.deactivatePrevNextButtons );
};

proto.deactivatePrevNextButtons = function() {
  this.prevButton.deactivate();
  this.nextButton.deactivate();
  this.off( 'deactivate', this.deactivatePrevNextButtons );
};

// --------------------------  -------------------------- //

Flickity.PrevNextButton = PrevNextButton;

return Flickity;

} ) );


/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// page dots
( function( window, factory ) {
  // universal module definition
  if ( true ) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
      __webpack_require__(28),
      __webpack_require__(95),
      __webpack_require__(26),
    ], __WEBPACK_AMD_DEFINE_RESULT__ = function( Flickity, Unipointer, utils ) {
      return factory( window, Flickity, Unipointer, utils );
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
        window,
        require('./flickity'),
        require('unipointer'),
        require('fizzy-ui-utils')
    );
  } else {
    // browser global
    factory(
        window,
        window.Flickity,
        window.Unipointer,
        window.fizzyUIUtils
    );
  }

}( window, function factory( window, Flickity, Unipointer, utils ) {

// -------------------------- PageDots -------------------------- //

'use strict';

function PageDots( parent ) {
  this.parent = parent;
  this._create();
}

PageDots.prototype = Object.create( Unipointer.prototype );

PageDots.prototype._create = function() {
  // create holder element
  this.holder = document.createElement('ol');
  this.holder.className = 'flickity-page-dots';
  // create dots, array of elements
  this.dots = [];
  // events
  this.handleClick = this.onClick.bind( this );
  this.on( 'pointerDown', this.parent.childUIPointerDown.bind( this.parent ) );
};

PageDots.prototype.activate = function() {
  this.setDots();
  this.holder.addEventListener( 'click', this.handleClick );
  this.bindStartEvent( this.holder );
  // add to DOM
  this.parent.element.appendChild( this.holder );
};

PageDots.prototype.deactivate = function() {
  this.holder.removeEventListener( 'click', this.handleClick );
  this.unbindStartEvent( this.holder );
  // remove from DOM
  this.parent.element.removeChild( this.holder );
};

PageDots.prototype.setDots = function() {
  // get difference between number of slides and number of dots
  var delta = this.parent.slides.length - this.dots.length;
  if ( delta > 0 ) {
    this.addDots( delta );
  } else if ( delta < 0 ) {
    this.removeDots( -delta );
  }
};

PageDots.prototype.addDots = function( count ) {
  var fragment = document.createDocumentFragment();
  var newDots = [];
  var length = this.dots.length;
  var max = length + count;

  for ( var i = length; i < max; i++ ) {
    var dot = document.createElement('li');
    dot.className = 'dot';
    dot.setAttribute( 'aria-label', 'Page dot ' + ( i + 1 ) );
    fragment.appendChild( dot );
    newDots.push( dot );
  }

  this.holder.appendChild( fragment );
  this.dots = this.dots.concat( newDots );
};

PageDots.prototype.removeDots = function( count ) {
  // remove from this.dots collection
  var removeDots = this.dots.splice( this.dots.length - count, count );
  // remove from DOM
  removeDots.forEach( function( dot ) {
    this.holder.removeChild( dot );
  }, this );
};

PageDots.prototype.updateSelected = function() {
  // remove selected class on previous
  if ( this.selectedDot ) {
    this.selectedDot.className = 'dot';
    this.selectedDot.removeAttribute('aria-current');
  }
  // don't proceed if no dots
  if ( !this.dots.length ) {
    return;
  }
  this.selectedDot = this.dots[ this.parent.selectedIndex ];
  this.selectedDot.className = 'dot is-selected';
  this.selectedDot.setAttribute( 'aria-current', 'step' );
};

PageDots.prototype.onTap = // old method name, backwards-compatible
PageDots.prototype.onClick = function( event ) {
  var target = event.target;
  // only care about dot clicks
  if ( target.nodeName != 'LI' ) {
    return;
  }

  this.parent.uiChange();
  var index = this.dots.indexOf( target );
  this.parent.select( index );
};

PageDots.prototype.destroy = function() {
  this.deactivate();
  this.allOff();
};

Flickity.PageDots = PageDots;

// -------------------------- Flickity -------------------------- //

utils.extend( Flickity.defaults, {
  pageDots: true,
} );

Flickity.createMethods.push('_createPageDots');

var proto = Flickity.prototype;

proto._createPageDots = function() {
  if ( !this.options.pageDots ) {
    return;
  }
  this.pageDots = new PageDots( this );
  // events
  this.on( 'activate', this.activatePageDots );
  this.on( 'select', this.updateSelectedPageDots );
  this.on( 'cellChange', this.updatePageDots );
  this.on( 'resize', this.updatePageDots );
  this.on( 'deactivate', this.deactivatePageDots );
};

proto.activatePageDots = function() {
  this.pageDots.activate();
};

proto.updateSelectedPageDots = function() {
  this.pageDots.updateSelected();
};

proto.updatePageDots = function() {
  this.pageDots.setDots();
};

proto.deactivatePageDots = function() {
  this.pageDots.deactivate();
};

// -----  ----- //

Flickity.PageDots = PageDots;

return Flickity;

} ) );


/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// player & autoPlay
( function( window, factory ) {
  // universal module definition
  if ( true ) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
      __webpack_require__(94),
      __webpack_require__(26),
      __webpack_require__(28),
    ], __WEBPACK_AMD_DEFINE_RESULT__ = function( EvEmitter, utils, Flickity ) {
      return factory( EvEmitter, utils, Flickity );
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
        require('ev-emitter'),
        require('fizzy-ui-utils'),
        require('./flickity')
    );
  } else {
    // browser global
    factory(
        window.EvEmitter,
        window.fizzyUIUtils,
        window.Flickity
    );
  }

}( window, function factory( EvEmitter, utils, Flickity ) {

'use strict';

// -------------------------- Player -------------------------- //

function Player( parent ) {
  this.parent = parent;
  this.state = 'stopped';
  // visibility change event handler
  this.onVisibilityChange = this.visibilityChange.bind( this );
  this.onVisibilityPlay = this.visibilityPlay.bind( this );
}

Player.prototype = Object.create( EvEmitter.prototype );

// start play
Player.prototype.play = function() {
  if ( this.state == 'playing' ) {
    return;
  }
  // do not play if page is hidden, start playing when page is visible
  var isPageHidden = document.hidden;
  if ( isPageHidden ) {
    document.addEventListener( 'visibilitychange', this.onVisibilityPlay );
    return;
  }

  this.state = 'playing';
  // listen to visibility change
  document.addEventListener( 'visibilitychange', this.onVisibilityChange );
  // start ticking
  this.tick();
};

Player.prototype.tick = function() {
  // do not tick if not playing
  if ( this.state != 'playing' ) {
    return;
  }

  var time = this.parent.options.autoPlay;
  // default to 3 seconds
  time = typeof time == 'number' ? time : 3000;
  var _this = this;
  // HACK: reset ticks if stopped and started within interval
  this.clear();
  this.timeout = setTimeout( function() {
    _this.parent.next( true );
    _this.tick();
  }, time );
};

Player.prototype.stop = function() {
  this.state = 'stopped';
  this.clear();
  // remove visibility change event
  document.removeEventListener( 'visibilitychange', this.onVisibilityChange );
};

Player.prototype.clear = function() {
  clearTimeout( this.timeout );
};

Player.prototype.pause = function() {
  if ( this.state == 'playing' ) {
    this.state = 'paused';
    this.clear();
  }
};

Player.prototype.unpause = function() {
  // re-start play if paused
  if ( this.state == 'paused' ) {
    this.play();
  }
};

// pause if page visibility is hidden, unpause if visible
Player.prototype.visibilityChange = function() {
  var isPageHidden = document.hidden;
  this[ isPageHidden ? 'pause' : 'unpause' ]();
};

Player.prototype.visibilityPlay = function() {
  this.play();
  document.removeEventListener( 'visibilitychange', this.onVisibilityPlay );
};

// -------------------------- Flickity -------------------------- //

utils.extend( Flickity.defaults, {
  pauseAutoPlayOnHover: true,
} );

Flickity.createMethods.push('_createPlayer');
var proto = Flickity.prototype;

proto._createPlayer = function() {
  this.player = new Player( this );

  this.on( 'activate', this.activatePlayer );
  this.on( 'uiChange', this.stopPlayer );
  this.on( 'pointerDown', this.stopPlayer );
  this.on( 'deactivate', this.deactivatePlayer );
};

proto.activatePlayer = function() {
  if ( !this.options.autoPlay ) {
    return;
  }
  this.player.play();
  this.element.addEventListener( 'mouseenter', this );
};

// Player API, don't hate the ... thanks I know where the door is

proto.playPlayer = function() {
  this.player.play();
};

proto.stopPlayer = function() {
  this.player.stop();
};

proto.pausePlayer = function() {
  this.player.pause();
};

proto.unpausePlayer = function() {
  this.player.unpause();
};

proto.deactivatePlayer = function() {
  this.player.stop();
  this.element.removeEventListener( 'mouseenter', this );
};

// ----- mouseenter/leave ----- //

// pause auto-play on hover
proto.onmouseenter = function() {
  if ( !this.options.pauseAutoPlayOnHover ) {
    return;
  }
  this.player.pause();
  this.element.addEventListener( 'mouseleave', this );
};

// resume auto-play on hover off
proto.onmouseleave = function() {
  this.player.unpause();
  this.element.removeEventListener( 'mouseleave', this );
};

// -----  ----- //

Flickity.Player = Player;

return Flickity;

} ) );


/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// add, remove cell
( function( window, factory ) {
  // universal module definition
  if ( true ) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
      __webpack_require__(28),
      __webpack_require__(26),
    ], __WEBPACK_AMD_DEFINE_RESULT__ = function( Flickity, utils ) {
      return factory( window, Flickity, utils );
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
        window,
        require('./flickity'),
        require('fizzy-ui-utils')
    );
  } else {
    // browser global
    factory(
        window,
        window.Flickity,
        window.fizzyUIUtils
    );
  }

}( window, function factory( window, Flickity, utils ) {

'use strict';

// append cells to a document fragment
function getCellsFragment( cells ) {
  var fragment = document.createDocumentFragment();
  cells.forEach( function( cell ) {
    fragment.appendChild( cell.element );
  } );
  return fragment;
}

// -------------------------- add/remove cell prototype -------------------------- //

var proto = Flickity.prototype;

/**
 * Insert, prepend, or append cells
 * @param {[Element, Array, NodeList]} elems - Elements to insert
 * @param {Integer} index - Zero-based number to insert
 */
proto.insert = function( elems, index ) {
  var cells = this._makeCells( elems );
  if ( !cells || !cells.length ) {
    return;
  }
  var len = this.cells.length;
  // default to append
  index = index === undefined ? len : index;
  // add cells with document fragment
  var fragment = getCellsFragment( cells );
  // append to slider
  var isAppend = index == len;
  if ( isAppend ) {
    this.slider.appendChild( fragment );
  } else {
    var insertCellElement = this.cells[ index ].element;
    this.slider.insertBefore( fragment, insertCellElement );
  }
  // add to this.cells
  if ( index === 0 ) {
    // prepend, add to start
    this.cells = cells.concat( this.cells );
  } else if ( isAppend ) {
    // append, add to end
    this.cells = this.cells.concat( cells );
  } else {
    // insert in this.cells
    var endCells = this.cells.splice( index, len - index );
    this.cells = this.cells.concat( cells ).concat( endCells );
  }

  this._sizeCells( cells );
  this.cellChange( index, true );
};

proto.append = function( elems ) {
  this.insert( elems, this.cells.length );
};

proto.prepend = function( elems ) {
  this.insert( elems, 0 );
};

/**
 * Remove cells
 * @param {[Element, Array, NodeList]} elems - ELements to remove
 */
proto.remove = function( elems ) {
  var cells = this.getCells( elems );
  if ( !cells || !cells.length ) {
    return;
  }

  var minCellIndex = this.cells.length - 1;
  // remove cells from collection & DOM
  cells.forEach( function( cell ) {
    cell.remove();
    var index = this.cells.indexOf( cell );
    minCellIndex = Math.min( index, minCellIndex );
    utils.removeFrom( this.cells, cell );
  }, this );

  this.cellChange( minCellIndex, true );
};

/**
 * logic to be run after a cell's size changes
 * @param {Element} elem - cell's element
 */
proto.cellSizeChange = function( elem ) {
  var cell = this.getCell( elem );
  if ( !cell ) {
    return;
  }
  cell.getSize();

  var index = this.cells.indexOf( cell );
  this.cellChange( index );
};

/**
 * logic any time a cell is changed: added, removed, or size changed
 * @param {Integer} changedCellIndex - index of the changed cell, optional
 * @param {Boolean} isPositioningSlider - Positions slider after selection
 */
proto.cellChange = function( changedCellIndex, isPositioningSlider ) {
  var prevSelectedElem = this.selectedElement;
  this._positionCells( changedCellIndex );
  this._getWrapShiftCells();
  this.setGallerySize();
  // update selectedIndex
  // try to maintain position & select previous selected element
  var cell = this.getCell( prevSelectedElem );
  if ( cell ) {
    this.selectedIndex = this.getCellSlideIndex( cell );
  }
  this.selectedIndex = Math.min( this.slides.length - 1, this.selectedIndex );

  this.emitEvent( 'cellChange', [ changedCellIndex ] );
  // position slider
  this.select( this.selectedIndex );
  // do not position slider after lazy load
  if ( isPositioningSlider ) {
    this.positionSliderAtSelected();
  }
};

// -----  ----- //

return Flickity;

} ) );


/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// lazyload
( function( window, factory ) {
  // universal module definition
  if ( true ) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
      __webpack_require__(28),
      __webpack_require__(26),
    ], __WEBPACK_AMD_DEFINE_RESULT__ = function( Flickity, utils ) {
      return factory( window, Flickity, utils );
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
        window,
        require('./flickity'),
        require('fizzy-ui-utils')
    );
  } else {
    // browser global
    factory(
        window,
        window.Flickity,
        window.fizzyUIUtils
    );
  }

}( window, function factory( window, Flickity, utils ) {
'use strict';

Flickity.createMethods.push('_createLazyload');
var proto = Flickity.prototype;

proto._createLazyload = function() {
  this.on( 'select', this.lazyLoad );
};

proto.lazyLoad = function() {
  var lazyLoad = this.options.lazyLoad;
  if ( !lazyLoad ) {
    return;
  }
  // get adjacent cells, use lazyLoad option for adjacent count
  var adjCount = typeof lazyLoad == 'number' ? lazyLoad : 0;
  var cellElems = this.getAdjacentCellElements( adjCount );
  // get lazy images in those cells
  var lazyImages = [];
  cellElems.forEach( function( cellElem ) {
    var lazyCellImages = getCellLazyImages( cellElem );
    lazyImages = lazyImages.concat( lazyCellImages );
  } );
  // load lazy images
  lazyImages.forEach( function( img ) {
    new LazyLoader( img, this );
  }, this );
};

function getCellLazyImages( cellElem ) {
  // check if cell element is lazy image
  if ( cellElem.nodeName == 'IMG' ) {
    var lazyloadAttr = cellElem.getAttribute('data-flickity-lazyload');
    var srcAttr = cellElem.getAttribute('data-flickity-lazyload-src');
    var srcsetAttr = cellElem.getAttribute('data-flickity-lazyload-srcset');
    if ( lazyloadAttr || srcAttr || srcsetAttr ) {
      return [ cellElem ];
    }
  }
  // select lazy images in cell
  var lazySelector = 'img[data-flickity-lazyload], ' +
    'img[data-flickity-lazyload-src], img[data-flickity-lazyload-srcset]';
  var imgs = cellElem.querySelectorAll( lazySelector );
  return utils.makeArray( imgs );
}

// -------------------------- LazyLoader -------------------------- //

/**
 * class to handle loading images
 * @param {Image} img - Image element
 * @param {Flickity} flickity - Flickity instance
 */
function LazyLoader( img, flickity ) {
  this.img = img;
  this.flickity = flickity;
  this.load();
}

LazyLoader.prototype.handleEvent = utils.handleEvent;

LazyLoader.prototype.load = function() {
  this.img.addEventListener( 'load', this );
  this.img.addEventListener( 'error', this );
  // get src & srcset
  var src = this.img.getAttribute('data-flickity-lazyload') ||
    this.img.getAttribute('data-flickity-lazyload-src');
  var srcset = this.img.getAttribute('data-flickity-lazyload-srcset');
  // set src & serset
  this.img.src = src;
  if ( srcset ) {
    this.img.setAttribute( 'srcset', srcset );
  }
  // remove attr
  this.img.removeAttribute('data-flickity-lazyload');
  this.img.removeAttribute('data-flickity-lazyload-src');
  this.img.removeAttribute('data-flickity-lazyload-srcset');
};

LazyLoader.prototype.onload = function( event ) {
  this.complete( event, 'flickity-lazyloaded' );
};

LazyLoader.prototype.onerror = function( event ) {
  this.complete( event, 'flickity-lazyerror' );
};

LazyLoader.prototype.complete = function( event, className ) {
  // unbind events
  this.img.removeEventListener( 'load', this );
  this.img.removeEventListener( 'error', this );

  var cell = this.flickity.getParentCell( this.img );
  var cellElem = cell && cell.element;
  this.flickity.cellSizeChange( cellElem );

  this.img.classList.add( className );
  this.flickity.dispatchEvent( 'lazyLoad', event, cellElem );
};

// -----  ----- //

Flickity.LazyLoader = LazyLoader;

return Flickity;

} ) );


/***/ }),
/* 467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_emotion__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_getAverageColor__ = __webpack_require__(37);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var IntroTemplate=function(_Component){_inherits(IntroTemplate,_Component);function IntroTemplate(){var _ref;var _temp,_this,_ret;_classCallCheck(this,IntroTemplate);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=IntroTemplate.__proto__||Object.getPrototypeOf(IntroTemplate)).call.apply(_ref,[this].concat(args))),_this),_this.state={color:null},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(IntroTemplate,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var picture=this.props.picture;Object(__WEBPACK_IMPORTED_MODULE_4__helpers_getAverageColor__["a" /* getAverageColor */])(picture).then(function(data){_this2.setState({color:data});}).catch(function(e){console.log(e);});}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(_ref2){var _this3=this;var picture=_ref2.picture;if(this.props.picture!==picture){Object(__WEBPACK_IMPORTED_MODULE_4__helpers_getAverageColor__["a" /* getAverageColor */])(picture).then(function(data){_this3.setState({color:data});}).catch(function(e){console.log(e);});}}},{key:'render',value:function render(){var _props=this.props,titleProduct=_props.titleProduct,title=_props.title,picture=_props.picture,picture_position=_props.picture_position,fields=_props.fields,type=_props.type,isBrand=_props.isBrand;var color=this.state.color;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:Object(__WEBPACK_IMPORTED_MODULE_2__styles__["Y" /* IntroTemplateStyle */])(picture,color)+' product-template--intro'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'template-scroll'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'template-left template-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'title'},titleProduct),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content '},type==='introproduct'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-row flex'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'label'},'Class'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'description'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'flex'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'range-label  '+Object(__WEBPACK_IMPORTED_MODULE_1_emotion__["a" /* css */])({color:__WEBPACK_IMPORTED_MODULE_2__styles__["x" /* Colors */].red})},' Sport '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'range'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["T" /* ProgressBar */],{theme:'red',x:fields.sport,big:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'flex'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'range-label  '+Object(__WEBPACK_IMPORTED_MODULE_1_emotion__["a" /* css */])({color:__WEBPACK_IMPORTED_MODULE_2__styles__["x" /* Colors */].blue})},' Expert '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'range'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["T" /* ProgressBar */],{theme:'blue',x:fields.expert,big:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'flex'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'range-label '+Object(__WEBPACK_IMPORTED_MODULE_1_emotion__["a" /* css */])({color:__WEBPACK_IMPORTED_MODULE_2__styles__["x" /* Colors */].green})},' Lifestyle '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'range'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["T" /* ProgressBar */],{theme:'green',x:fields.lifestyle,big:true}))))),fields.items&&fields.items.map(function(item,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-row flex',key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'label'},item.label),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'description'},' ',item.description,' '));}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'template-right template-picture template-picture--'+(picture_position?picture_position:'center')})));}}]);return IntroTemplate;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (IntroTemplate);

/***/ }),
/* 468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Videos_Video__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Shapes__ = __webpack_require__(47);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SingleVideoTemplate=function(_Component){_inherits(SingleVideoTemplate,_Component);function SingleVideoTemplate(){var _ref;var _temp,_this,_ret;_classCallCheck(this,SingleVideoTemplate);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=SingleVideoTemplate.__proto__||Object.getPrototypeOf(SingleVideoTemplate)).call.apply(_ref,[this].concat(args))),_this),_this.state={active:false},_this.handlerClick=function(e){e.preventDefault();_this.setState({url:_this.props.fields.type==='vimeo'?'https://player.vimeo.com/video/'+_this.props.fields.link+'?muted=1&autoplay=1':'https://www.youtube.com/embed/'+_this.props.fields.link+'?autoplay=1'},function(){_this.setState({active:true});document.querySelector('.video-wrapper').scrollTop=0;document.querySelector('.video-wrapper').style.overflow='hidden';});},_this.handlerClose=function(e){e.preventDefault();_this.setState({active:false},function(){_this.setState({url:''});document.querySelector('.video-wrapper').style.overflow='auto';});},_this.scaleVideo=function(){var windowHeight=window.innerHeight;var videoHeight=_this.video;var scale=windowHeight/videoHeight;if(videoHeight<=windowHeight){_this.video.style.transform='scale('+scale+') translateY(-50%)';}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(SingleVideoTemplate,[{key:'componentDidMount',value:function componentDidMount(){this.scaleVideo();}},{key:'render',value:function render(){var _this2=this;var _props=this.props,title=_props.title,picture=_props.picture,picture_position=_props.picture_position;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'product-template product-template--video'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'video-container '+Object(__WEBPACK_IMPORTED_MODULE_2__styles__["S" /* FullVideoContainerStyle */])(picture,this.state.active,picture_position?picture_position:'center')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'video',onClick:this.handlerClick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn--play'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_Shapes__["v" /* Triangle */],{width:12,height:12}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'video-label'},title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'video-container-full'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'video-close',onClick:this.handlerClose},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'video-iframe',ref:function ref(video){return _this2.video=video;}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'video-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('iframe',{src:this.state.url,frameBorder:'0',allowFullScreen:true,title:title}))))));}}]);return SingleVideoTemplate;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (SingleVideoTemplate);

/***/ }),
/* 469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__static_default_picture_RM_jpg__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__static_default_picture_RM_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__static_default_picture_RM_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_getAverageColor__ = __webpack_require__(37);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SliderTemplate=function(_Component){_inherits(SliderTemplate,_Component);function SliderTemplate(){var _ref;var _temp,_this,_ret;_classCallCheck(this,SliderTemplate);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=SliderTemplate.__proto__||Object.getPrototypeOf(SliderTemplate)).call.apply(_ref,[this].concat(args))),_this),_this.state={active:0,lastPicture:__WEBPACK_IMPORTED_MODULE_2__static_default_picture_RM_jpg___default.a,ready:true,color:false},_this.updateSlides=function(index){return function(e){e.preventDefault();_this.setState({ready:false});_this.timer=setTimeout(function(){_this.setState({active:index,lastPicture:_this.props.fields.items[index].image!==''?_this.props.fields.items[index].image:_this.state.lastPicture,lastPicturePosition:_this.props.fields.items[index].picture_position!==''?_this.props.fields.items[index].picture_position:_this.state.lastPicturePosition},function(){_this.updateAverageColor();});},500);};},_this.updateAverageColor=function(){Object(__WEBPACK_IMPORTED_MODULE_3__helpers_getAverageColor__["a" /* getAverageColor */])(_this.state.lastPicture).then(function(data){_this.setState({color:data,ready:true});}).catch(function(e){console.log(e);});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(SliderTemplate,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;this.setState({lastPicture:this.props.fields.items.length>0&&this.props.fields.items[0].image!==''?this.props.fields.items[0].image:this.state.lastPicture,lastPicturePosition:this.props.fields.items.length>0&&this.props.fields.items[0].picture_position!==''?this.props.fields.items[0].picture_position:this.state.lastPicturePosition},function(){_this2.updateAverageColor();});}},{key:'componentWillUnmount',value:function componentWillUnmount(){clearTimeout(this.timer);}},{key:'render',value:function render(){var _this3=this;var _props=this.props,title=_props.title,fields=_props.fields,isBrand=_props.isBrand,subtitle=_props.subtitle,category=_props.category;var _state=this.state,ready=_state.ready,lastPicture=_state.lastPicture,lastPicturePosition=_state.lastPicturePosition,active=_state.active,color=_state.color;// picturePosition should be either : top; center; bottom. default on center.
var formatedPicturePosition=lastPicturePosition||'center';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'product-template--slider '+Object(__WEBPACK_IMPORTED_MODULE_1__styles__["_48" /* SliderTemplateStyle */])(lastPicture,ready,color)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'template-scroll flex'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'template-left template-picture template-picture--'+formatedPicturePosition}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'template-right template-content'},category&&isBrand&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'title-brand'},category),title&&!isBrand&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'subtitle'},title),isBrand&&subtitle&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'subtitle subtitle--brand '},subtitle),title&&isBrand&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'subtitle-h3'},' ',title,' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'reset'},fields.items.map(function(slide,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:index,className:'flex '+(index===active?'active':''),onClick:_this3.updateSlides(index)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'number'},index+1),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'label'},' ',slide.description,' '));})))));}}]);return SliderTemplate;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (SliderTemplate);

/***/ }),
/* 470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_getAverageColor__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SocialTemplate=function(_Component){_inherits(SocialTemplate,_Component);function SocialTemplate(){var _ref;var _temp,_this,_ret;_classCallCheck(this,SocialTemplate);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=SocialTemplate.__proto__||Object.getPrototypeOf(SocialTemplate)).call.apply(_ref,[this].concat(args))),_this),_this.state={},_this.getIcons=function(type){var nComponent=null;switch(type){case'instagram':nComponent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["D" /* Instagram */],{width:24,height:24});break;case'facebook':nComponent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["v" /* Facebook */],{width:24,height:24});break;case'twitter':nComponent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["_15" /* Twitter */],{width:24,height:24});break;case'linkedin':nComponent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["E" /* Linkedin */],{width:24,height:24});break;case'weibo':nComponent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["_23" /* Weibo */],{width:24,height:24});break;case'website':nComponent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["r" /* Desktop */],{width:24,height:24});break;default:break;}return nComponent;},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(SocialTemplate,[{key:'render',value:function render(){var _this2=this;var _props=this.props,fields=_props.fields,title=_props.title,picture=_props.picture,picture_position=_props.picture_position,isBrand=_props.isBrand,subtitle=_props.subtitle,category=_props.category;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'product-template--social '+Object(__WEBPACK_IMPORTED_MODULE_1__styles__["_52" /* SocialTemplateStyle */])(picture)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'template-scroll flex'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'template-left template-picture template-picture--'+(picture_position?picture_position:'center')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'template-right template-content'},category&&isBrand&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'title-brand'},category),title&&!isBrand&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'subtitle'},title),isBrand&&subtitle&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'subtitle subtitle--brand '},subtitle),title&&isBrand&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'subtitle-h3'},' ',title,' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'social-container'},fields.items.map(function(social,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'social-row flex',key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'social-svg'},_this2.getIcons(social.type)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'social-label'},' ',social.label,' : '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:social.link,target:'_blank'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'link'},' ',social.link,' ')));})))));}}]);return SocialTemplate;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (SocialTemplate);

/***/ }),
/* 471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_getAverageColor__ = __webpack_require__(37);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SuggestTemplate=function(_Component){_inherits(SuggestTemplate,_Component);function SuggestTemplate(){var _ref;var _temp,_this,_ret;_classCallCheck(this,SuggestTemplate);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=SuggestTemplate.__proto__||Object.getPrototypeOf(SuggestTemplate)).call.apply(_ref,[this].concat(args))),_this),_this.state={color:false},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(SuggestTemplate,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;Object(__WEBPACK_IMPORTED_MODULE_3__helpers_getAverageColor__["a" /* getAverageColor */])(this.props.picture?this.props.picture:null).then(function(data){_this2.setState({color:data});}).catch(function(e){console.log(e);});}},{key:'render',value:function render(){var _props=this.props,picture=_props.picture,picture_position=_props.picture_position,title=_props.title,fields=_props.fields,isBrand=_props.isBrand,subtitle=_props.subtitle,category=_props.category;var color=this.state.color;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'product-template--suggest '+Object(__WEBPACK_IMPORTED_MODULE_2__styles__["_59" /* SuggestTemplateStyle */])(picture?picture:null,color)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'template-scroll'},picture&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'template-left template-picture--'+(picture_position?picture_position:'center')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'template-right '+(!picture?'full':'')+' template-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'flex'},category&&isBrand&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'title-brand'},category),title&&!isBrand&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'subtitle'},title),isBrand&&subtitle&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'subtitle subtitle--brand '},subtitle),title&&isBrand&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'subtitle-h3'},' ',title,' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'suggest-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'flex flex-wrap'},fields.items&&fields.items.map(function(product,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components__["n" /* Card */],{title:product.name,description:product.subTitle,slug:product.url,card_picture:product.picture,pdfs:product.pdfs,is_bookmark:product.is_bookmark,slug_bookmark:product.slug_bookmark,type:'page',label:'discover',key:index});})))))));}}]);return SuggestTemplate;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (SuggestTemplate);

/***/ }),
/* 472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var VideoTemplate=function(_Component){_inherits(VideoTemplate,_Component);function VideoTemplate(){_classCallCheck(this,VideoTemplate);return _possibleConstructorReturn(this,(VideoTemplate.__proto__||Object.getPrototypeOf(VideoTemplate)).apply(this,arguments));}_createClass(VideoTemplate,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components__["_22" /* Videos */],this.props);}}]);return VideoTemplate;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (VideoTemplate);

/***/ }),
/* 473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__hoc_withLoader__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Product_ProductTemplates__ = __webpack_require__(160);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Catalog=function(_Component){_inherits(Catalog,_Component);function Catalog(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,Catalog);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Catalog.__proto__||Object.getPrototypeOf(Catalog)).call.apply(_ref,[this].concat(args))),_this),_this.state={filters:{},products:[],filterProduct:null,filtering:{}},_this.getFilters=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(filters){var product_filters,nProduct;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:product_filters=[];Object.keys(filters).map(function(category){product_filters[category]=[];_this.state.products.map(function(product){if(product.filters.models[category]){product.filters.models[category].map(function(filter){if(filters[category].indexOf(''+filter)!==-1)product_filters[category].push(product);});}});});// const nProduct = product_filters[Object.keys(product_filters)[0]]
nProduct=Object.keys(product_filters).reduce(function(acc,category){if(acc.length===0){product_filters[category].map(function(product){acc.push(product);});}else{acc=product_filters[category].filter(function(product){return acc.indexOf(product)!==-1;});}return acc;},[]);_this.setState({filterProduct:Object.keys(filters).length>0?nProduct:null});case 4:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref2.apply(this,arguments);};}(),_this.isFilters=function(categories,slug){var filters=categories.models.filters;var data={flag:false,filters:{}};Object.keys(filters).map(function(category){filters[category].map(function(filter){var slugify_name=filter.name.toString().toLowerCase().replace('\'','-').replace(/ /g,'-').replace(/[^\w-]+/g,'');if(slugify_name===slug){data.flag=true;data.filters[category]=[filter.name];}});});return data;},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Catalog,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(_ref3){var data=_ref3.data;if(data!==this.props.data){this.setState({filters:data.categories[Object.keys(data.categories)[0]].filters,products:data.pages});}}/** TODO:
   * get better 
   * use reducer 
   */},{key:'render',value:function render(){var isReady=this.props.isReady;var _state=this.state,filters=_state.filters,products=_state.products;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_3__styles__["u" /* CatalogStyle */]+' catalog'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'page-inner transition '+(isReady?'transition--ready':'')},filters&&Object.keys(filters).length>0&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'catalog-filter'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["y" /* Filter */],{filters:filters,filtering:this.getFilters})),products&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'catalog-list'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["S" /* ProductList */],{products:this.state.filterProduct?this.state.filterProduct:this.state.products}))));}}]);return Catalog;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4__hoc_withLoader__["a" /* withLoader */])(Catalog));

/***/ }),
/* 474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_Router__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__hoc_withLoader__ = __webpack_require__(15);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Bookmarks=function(_Component){_inherits(Bookmarks,_Component);function Bookmarks(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Bookmarks);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Bookmarks.__proto__||Object.getPrototypeOf(Bookmarks)).call.apply(_ref,[this].concat(args))),_this),_this.state={products:[],nav:[{value:'Saved',url:__WEBPACK_IMPORTED_MODULE_2__services_Router__["a" /* default */].bookmarks.saved},{value:'Recently viewed',url:__WEBPACK_IMPORTED_MODULE_2__services_Router__["a" /* default */].bookmarks.viewed}]},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Bookmarks,[{key:'render',value:function render(){var nav=this.state.nav;var _props=this.props,data=_props.data,isReady=_props.isReady;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:' bookmarks '+__WEBPACK_IMPORTED_MODULE_3__styles__["u" /* CatalogStyle */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'page-inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'catalog-nav'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components__["J" /* Nav */],{nav:nav})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'catalog-list transition '+(isReady?'transition--ready':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components__["S" /* ProductList */],{products:data}))));}}]);return Bookmarks;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4__hoc_withLoader__["a" /* withLoader */])(Bookmarks));

/***/ }),
/* 475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_Router__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__hoc_withLoader__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_date__ = __webpack_require__(64);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Publications=function(_Component){_inherits(Publications,_Component);function Publications(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Publications);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Publications.__proto__||Object.getPrototypeOf(Publications)).call.apply(_ref,[this].concat(args))),_this),_this.state={nav:[{value:'Publications',url:__WEBPACK_IMPORTED_MODULE_3__services_Router__["a" /* default */].publications.path},{value:'Social Wall',url:__WEBPACK_IMPORTED_MODULE_3__services_Router__["a" /* default */].social.exactPath+'/instagram'}],isFiltering:[],count:6},_this.getFilters=function(filters){var isFiltering=[];if(filters.year&&filters.year.length>0){filters.year.map(function(item){isFiltering.push(item);});}_this.setState({isFiltering:isFiltering});},_this.getMore=function(){_this.setState({count:_this.state.count+6});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Publications,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(_ref2){var data=_ref2.data;if(data!==this.props.data){var years=[];var isExist=[];data.news.map(function(news){if(isExist.indexOf(news.year)===-1){isExist.push(news.year);years.push({name:news.year,checked:false});}});this.setState({filters:{year:years}});}}},{key:'render',value:function render(){var _state=this.state,nav=_state.nav,filters=_state.filters,isFiltering=_state.isFiltering,count=_state.count;var _props=this.props,data=_props.data,isReady=_props.isReady;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_4__styles__["_13" /* NewsStyle */]+' '+__WEBPACK_IMPORTED_MODULE_4__styles__["l" /* ButtonLoadMoreStyle */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'page-inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'publication-nav'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["J" /* Nav */],{nav:nav})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'transition '+(isReady?'transition--ready':'')},data&&Object.keys(data.spotlight).length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'publication-spotlight'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'spotlight-title'},'In the Spotlight'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'spotlight-news news '+Object(__WEBPACK_IMPORTED_MODULE_4__styles__["_12" /* NewsCardStyle */])(data.spotlight.picture)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:data.spotlight.slug},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'news-head flex'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'news-info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'news-date'},' ',Object(__WEBPACK_IMPORTED_MODULE_6__helpers_date__["b" /* Date_FR */])(data.spotlight.date),' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'news-title'},' ',data.spotlight.title,' ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'news-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'news-link'},' Read more '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'news-button flex'},data.spotlight.pdf&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["M" /* PDFButton */],{big:true,pdfs:data.spotlight.pdf}),data.spotlight.slug_bookmark&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["j" /* BookmarkButton */],{item:{slug_bookmark:data.spotlight.slug_bookmark,type:data.spotlight.type},is_bookmark:data.spotlight.is_bookmark,big:true})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'news-picture'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'publication-list'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'publication-filter'},filters&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'catalog-filter'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["y" /* Filter */],{filters:filters,filtering:this.getFilters}))),data&&data.news&&data.news.filter(function(item){return isFiltering.length>0&&isFiltering.indexOf(item.year.toString())!==-1||isFiltering.length===0;}).slice(0,count).map(function(item,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'news card '+Object(__WEBPACK_IMPORTED_MODULE_4__styles__["_12" /* NewsCardStyle */])(item.cover),key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:item.slug,className:'flex'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'news-picture'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'news-info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'news-date'},' ',item.data.slice(0,10),' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'news-title'},' ',item.title,' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'news-link'},' Read more ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'news-button'},item.pdf&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["M" /* PDFButton */],{big:true,pdfs:item.pdf}),item.slug_bookmark&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["j" /* BookmarkButton */],{item:{slug_bookmark:item.slug_bookmark,type:item.type},is_bookmark:item.is_bookmark,big:true}))));}),data&&data.news&&count<data.news.length&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-load-more',onClick:this.getMore},'Load more')))));}}]);return Publications;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__hoc_withLoader__["a" /* withLoader */])(Publications,'/news'));

/***/ }),
/* 476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_datepicker__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_datepicker_dist_react_datepicker_css__ = __webpack_require__(478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_datepicker_dist_react_datepicker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_datepicker_dist_react_datepicker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_Router__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_ApiController__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Week=["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"];var Agenda=function(_Component){_inherits(Agenda,_Component);function Agenda(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,Agenda);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Agenda.__proto__||Object.getPrototypeOf(Agenda)).call.apply(_ref,[this].concat(args))),_this),_this.state={upcomming:[],lastEvent:[],now:new Date(),month:new Date().getMonth(),year:new Date().getFullYear(),highlight:[],startDate:false,selectDay:null,ready:false},_this.getEvent=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var type,_this$state,month,year;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:type=_this.props.location.pathname.split('/');_this$state=_this.state,month=_this$state.month,year=_this$state.year;_this.setState({ready:false});_context.next=5;return Object(__WEBPACK_IMPORTED_MODULE_8__services_ApiController__["fetchPage"])('/'+type[type.length-1]+'/'+year+'/'+(month+1<10?'0'+(month+1):month+1)).then(function(data){_this.setEventTime(data);}).catch(function(e){console.log('Oups something wrong with',type[type.length-1]+'/'+year+'/'+month,e);});case 5:case'end':return _context.stop();}}},_callee,_this2);})),_this.setEventTime=function(data){var lastEvent=[];var upcomming=[];var highlight=[];data.map(function(event){var end=__WEBPACK_IMPORTED_MODULE_4_moment__(event.date_end);var start=__WEBPACK_IMPORTED_MODULE_4_moment__(event.date_start);var max=__WEBPACK_IMPORTED_MODULE_4_moment__().daysInMonth();if(end.diff(__WEBPACK_IMPORTED_MODULE_4_moment__(),'days')>=0)upcomming.push(event);else lastEvent.push(event);if(end!==start){var nb=end.diff(start,'days');highlight.push(start.format());for(var i=0;i<nb;i++){var nDate=start.add(1,'days');highlight.push(nDate.format());}}else{highlight.push(__WEBPACK_IMPORTED_MODULE_4_moment__(event.date_start).format());}});lastEvent.sort(function(a,b){return __WEBPACK_IMPORTED_MODULE_4_moment__(a.date).diff(__WEBPACK_IMPORTED_MODULE_4_moment__(b.date));});upcomming.sort(function(a,b){return __WEBPACK_IMPORTED_MODULE_4_moment__(a.date).diff(__WEBPACK_IMPORTED_MODULE_4_moment__(b.date));});_this.setState({lastEvent:lastEvent,upcomming:upcomming,highlight:[{"react-datepicker__day--highlighted":highlight}],ready:true});},_this.handleChange=function(date){_this.setState({startDate:date// selectDay: date._d.getDate(), 
});},_this.handleClick=function(date){_this.setState({ready:false},function(){_this.timer=setTimeout(function(){_this.setState({ready:true,selectDay:_this.state.selectDay&&__WEBPACK_IMPORTED_MODULE_4_moment__(date._d).format()!==_this.state.selectDay.format()||!_this.state.selectDay?__WEBPACK_IMPORTED_MODULE_4_moment__(date._d):null},function(){if(!_this.state.selectDay)document.querySelector('.react-datepicker__day--selected').classList.remove('react-datepicker__day--selected');});},400);});},_this.handlerMonth=function(date){_this.setState({month:date._d.getMonth(),year:date._d.getFullYear(),ready:false},function(){_this.getEvent();});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Agenda,[{key:'componentDidMount',value:function componentDidMount(){this.getEvent();}},{key:'componentWillMount',value:function componentWillMount(){clearTimeout(this.timer);}},{key:'render',value:function render(){var _state=this.state,upcomming=_state.upcomming,lastEvent=_state.lastEvent,startDate=_state.startDate,highlight=_state.highlight,selectDay=_state.selectDay,ready=_state.ready;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:' '+Object(__WEBPACK_IMPORTED_MODULE_9__styles__["c" /* AgendaStyle */])(ready)},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components__["_19" /* UserNav */],null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'fluid'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'agenda-nav'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('ul',{className:'reset '+__WEBPACK_IMPORTED_MODULE_9__styles__["o" /* ButtonRouter */]+' flex'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["c" /* NavLink */],{to:__WEBPACK_IMPORTED_MODULE_7__services_Router__["a" /* default */].event.path,exact:true},' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Event'),' ')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'agenda-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'agenda-datepicker '+__WEBPACK_IMPORTED_MODULE_9__styles__["F" /* DatePickerStyle */]+' '},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_datepicker___default.a,{inline:true,selected:startDate,onChange:this.handleChange,onSelect:this.handleClick,highlightDates:highlight,placeholderText:'Date',onMonthChange:this.handlerMonth})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'agenda-load'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components__["F" /* Load */],{width:24,height:24})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'agenda-transition'},upcomming.length>0&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'agenda-upcomming'},!selectDay&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'agenda-title'},'Upcoming event'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'agenda-upcomming-event'},upcomming.filter(function(event){return selectDay&&__WEBPACK_IMPORTED_MODULE_4_moment__(event.date_end).diff(selectDay,'days')>=0&&__WEBPACK_IMPORTED_MODULE_4_moment__(event.date_start).diff(selectDay,'days')<=0||!selectDay;}).map(function(event,index){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components__["u" /* Event */],Object.assign({},event,{key:index}));}))),lastEvent.filter(function(event){return selectDay&&__WEBPACK_IMPORTED_MODULE_4_moment__(event.date_end).diff(selectDay,'days')>=0&&__WEBPACK_IMPORTED_MODULE_4_moment__(event.date_start).diff(selectDay,'days')<=0||!selectDay;}).length>0&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'agenda-past'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'agenda-title'},'Past event'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'agenda-past-event'},lastEvent.filter(function(event){return selectDay&&__WEBPACK_IMPORTED_MODULE_4_moment__(event.date_end).diff(selectDay,'days')>=0&&__WEBPACK_IMPORTED_MODULE_4_moment__(event.date_start).diff(selectDay,'days')<=0||!selectDay;}).map(function(event,index){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components__["u" /* Event */],Object.assign({},event,{key:index}));})))))));}}]);return Agenda;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Agenda);

/***/ }),
/* 477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IGNORE_CLASS_NAME", function() { return IGNORE_CLASS_NAME; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}/**
 * Check whether some DOM node is our Component's node.
 */
function isNodeFound(current, componentNode, ignoreClass) {
  if (current === componentNode) {
    return true;
  } // SVG <use/> elements do not technically reside in the rendered DOM, so
  // they do not have classList directly, but they offer a link to their
  // corresponding element, which can have classList. This extra check is for
  // that case.
  // See: http://www.w3.org/TR/SVG11/struct.html#InterfaceSVGUseElement
  // Discussion: https://github.com/Pomax/react-onclickoutside/pull/17


  if (current.correspondingElement) {
    return current.correspondingElement.classList.contains(ignoreClass);
  }

  return current.classList.contains(ignoreClass);
}
/**
 * Try to find our node in a hierarchy of nodes, returning the document
 * node as highest node if our node is not found in the path up.
 */

function findHighest(current, componentNode, ignoreClass) {
  if (current === componentNode) {
    return true;
  } // If source=local then this event came from 'somewhere'
  // inside and should be ignored. We could handle this with
  // a layered approach, too, but that requires going back to
  // thinking in terms of Dom node nesting, running counter
  // to React's 'you shouldn't care about the DOM' philosophy.


  while (current.parentNode) {
    if (isNodeFound(current, componentNode, ignoreClass)) {
      return true;
    }

    current = current.parentNode;
  }

  return current;
}
/**
 * Check if the browser scrollbar was clicked
 */

function clickedScrollbar(evt) {
  return document.documentElement.clientWidth <= evt.clientX || document.documentElement.clientHeight <= evt.clientY;
}// ideally will get replaced with external dep
// when rafrex/detect-passive-events#4 and rafrex/detect-passive-events#5 get merged in
var testPassiveEventSupport = function testPassiveEventSupport() {
  if (typeof window === 'undefined' || typeof window.addEventListener !== 'function') {
    return;
  }

  var passive = false;
  var options = Object.defineProperty({}, 'passive', {
    get: function get() {
      passive = true;
    }
  });

  var noop = function noop() {};

  window.addEventListener('testPassiveEventSupport', noop, options);
  window.removeEventListener('testPassiveEventSupport', noop, options);
  return passive;
};function autoInc(seed) {
  if (seed === void 0) {
    seed = 0;
  }

  return function () {
    return ++seed;
  };
}

var uid = autoInc();var passiveEventSupport;
var handlersMap = {};
var enabledInstances = {};
var touchEvents = ['touchstart', 'touchmove'];
var IGNORE_CLASS_NAME = 'ignore-react-onclickoutside';
/**
 * Options for addEventHandler and removeEventHandler
 */

function getEventHandlerOptions(instance, eventName) {
  var handlerOptions = null;
  var isTouchEvent = touchEvents.indexOf(eventName) !== -1;

  if (isTouchEvent && passiveEventSupport) {
    handlerOptions = {
      passive: !instance.props.preventDefault
    };
  }

  return handlerOptions;
}
/**
 * This function generates the HOC function that you'll use
 * in order to impart onOutsideClick listening to an
 * arbitrary component. It gets called at the end of the
 * bootstrapping code to yield an instance of the
 * onClickOutsideHOC function defined inside setupHOC().
 */


function onClickOutsideHOC(WrappedComponent, config) {
  var _class, _temp;

  var componentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
  return _temp = _class = /*#__PURE__*/function (_Component) {
    _inheritsLoose(onClickOutside, _Component);

    function onClickOutside(props) {
      var _this;

      _this = _Component.call(this, props) || this;

      _this.__outsideClickHandler = function (event) {
        if (typeof _this.__clickOutsideHandlerProp === 'function') {
          _this.__clickOutsideHandlerProp(event);

          return;
        }

        var instance = _this.getInstance();

        if (typeof instance.props.handleClickOutside === 'function') {
          instance.props.handleClickOutside(event);
          return;
        }

        if (typeof instance.handleClickOutside === 'function') {
          instance.handleClickOutside(event);
          return;
        }

        throw new Error("WrappedComponent: " + componentName + " lacks a handleClickOutside(event) function for processing outside click events.");
      };

      _this.__getComponentNode = function () {
        var instance = _this.getInstance();

        if (config && typeof config.setClickOutsideRef === 'function') {
          return config.setClickOutsideRef()(instance);
        }

        if (typeof instance.setClickOutsideRef === 'function') {
          return instance.setClickOutsideRef();
        }

        return Object(__WEBPACK_IMPORTED_MODULE_1_react_dom__["findDOMNode"])(instance);
      };

      _this.enableOnClickOutside = function () {
        if (typeof document === 'undefined' || enabledInstances[_this._uid]) {
          return;
        }

        if (typeof passiveEventSupport === 'undefined') {
          passiveEventSupport = testPassiveEventSupport();
        }

        enabledInstances[_this._uid] = true;
        var events = _this.props.eventTypes;

        if (!events.forEach) {
          events = [events];
        }

        handlersMap[_this._uid] = function (event) {
          if (_this.componentNode === null) return;

          if (_this.props.preventDefault) {
            event.preventDefault();
          }

          if (_this.props.stopPropagation) {
            event.stopPropagation();
          }

          if (_this.props.excludeScrollbar && clickedScrollbar(event)) return;
          var current = event.target;

          if (findHighest(current, _this.componentNode, _this.props.outsideClickIgnoreClass) !== document) {
            return;
          }

          _this.__outsideClickHandler(event);
        };

        events.forEach(function (eventName) {
          document.addEventListener(eventName, handlersMap[_this._uid], getEventHandlerOptions(_assertThisInitialized(_this), eventName));
        });
      };

      _this.disableOnClickOutside = function () {
        delete enabledInstances[_this._uid];
        var fn = handlersMap[_this._uid];

        if (fn && typeof document !== 'undefined') {
          var events = _this.props.eventTypes;

          if (!events.forEach) {
            events = [events];
          }

          events.forEach(function (eventName) {
            return document.removeEventListener(eventName, fn, getEventHandlerOptions(_assertThisInitialized(_this), eventName));
          });
          delete handlersMap[_this._uid];
        }
      };

      _this.getRef = function (ref) {
        return _this.instanceRef = ref;
      };

      _this._uid = uid();
      return _this;
    }
    /**
     * Access the WrappedComponent's instance.
     */


    var _proto = onClickOutside.prototype;

    _proto.getInstance = function getInstance() {
      if (WrappedComponent.prototype && !WrappedComponent.prototype.isReactComponent) {
        return this;
      }

      var ref = this.instanceRef;
      return ref.getInstance ? ref.getInstance() : ref;
    };

    /**
     * Add click listeners to the current document,
     * linked to this component's state.
     */
    _proto.componentDidMount = function componentDidMount() {
      // If we are in an environment without a DOM such
      // as shallow rendering or snapshots then we exit
      // early to prevent any unhandled errors being thrown.
      if (typeof document === 'undefined' || !document.createElement) {
        return;
      }

      var instance = this.getInstance();

      if (config && typeof config.handleClickOutside === 'function') {
        this.__clickOutsideHandlerProp = config.handleClickOutside(instance);

        if (typeof this.__clickOutsideHandlerProp !== 'function') {
          throw new Error("WrappedComponent: " + componentName + " lacks a function for processing outside click events specified by the handleClickOutside config option.");
        }
      }

      this.componentNode = this.__getComponentNode(); // return early so we dont initiate onClickOutside

      if (this.props.disableOnClickOutside) return;
      this.enableOnClickOutside();
    };

    _proto.componentDidUpdate = function componentDidUpdate() {
      this.componentNode = this.__getComponentNode();
    }
    /**
     * Remove all document's event listeners for this component
     */
    ;

    _proto.componentWillUnmount = function componentWillUnmount() {
      this.disableOnClickOutside();
    }
    /**
     * Can be called to explicitly enable event listening
     * for clicks and touches outside of this element.
     */
    ;

    /**
     * Pass-through render
     */
    _proto.render = function render() {
      // eslint-disable-next-line no-unused-vars
      var _this$props = this.props;
          _this$props.excludeScrollbar;
          var props = _objectWithoutPropertiesLoose(_this$props, ["excludeScrollbar"]);

      if (WrappedComponent.prototype && WrappedComponent.prototype.isReactComponent) {
        props.ref = this.getRef;
      } else {
        props.wrappedRef = this.getRef;
      }

      props.disableOnClickOutside = this.disableOnClickOutside;
      props.enableOnClickOutside = this.enableOnClickOutside;
      return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(WrappedComponent, props);
    };

    return onClickOutside;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.displayName = "OnClickOutside(" + componentName + ")", _class.defaultProps = {
    eventTypes: ['mousedown', 'touchstart'],
    excludeScrollbar: config && config.excludeScrollbar || false,
    outsideClickIgnoreClass: IGNORE_CLASS_NAME,
    preventDefault: false,
    stopPropagation: false
  }, _class.getClass = function () {
    return WrappedComponent.getClass ? WrappedComponent.getClass() : WrappedComponent;
  }, _temp;
}/* harmony default export */ __webpack_exports__["default"] = (onClickOutsideHOC);

/***/ }),
/* 478 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__hoc_withLoader__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_date__ = __webpack_require__(64);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Article=function(_Component){_inherits(Article,_Component);function Article(){_classCallCheck(this,Article);return _possibleConstructorReturn(this,(Article.__proto__||Object.getPrototypeOf(Article)).apply(this,arguments));}_createClass(Article,[{key:'render',value:function render(){var _props=this.props,data=_props.data,isReady=_props.isReady;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_2__styles__["e" /* ArticleStyle */]+' news-article transition '+(isReady?'transition--ready':'')},data&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'flex'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["g" /* ArticleNav */],{is_bookmark:data.is_bookmark,pdf:data.pdf,slug_bookmark:data.slug_bookmark,type:data.type,classname:'news-nav',next:data.next,previous:data.previous}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'news'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'news-inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'news-date'},' ',Object(__WEBPACK_IMPORTED_MODULE_5__helpers_date__["b" /* Date_FR */])(data.date),' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'news-title'},' ',data.title,' '),data.blocks&&data.blocks.length>0&&data.blocks.map(function(bloc,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'news-block',key:index},bloc.type==='text'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'news-content content',dangerouslySetInnerHTML:{__html:bloc.fields.text}}),bloc.type==='image'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'news-cover'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'news-picture',style:{backgroundImage:'url('+bloc.fields.image+')'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'news-legend'},' ',bloc.fields.legend,'\xA0')),bloc.type==='gallery'&&bloc.fields.images.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["B" /* Gallery */],{images:bloc.fields.images}));}),(data.next||data.previous)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'flex news__nav'},data.previous&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'news__previous news__nav-item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:data.previous,className:'btn btn--next'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'btn--arrow'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["f" /* ArrowDrop */],{width:24,height:24})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Previous'))),data.next&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'news__next news__nav-item '+(!data.previous?'news__nav-item--full':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:data.next,className:'btn btn--next'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Next'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'btn--arrow'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["f" /* ArrowDrop */],{width:24,height:24})))))))));}}]);return Article;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4__hoc_withLoader__["a" /* withLoader */])(Article));

/***/ }),
/* 480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(8);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Challenge=function(_Component){_inherits(Challenge,_Component);function Challenge(){_classCallCheck(this,Challenge);return _possibleConstructorReturn(this,(Challenge.__proto__||Object.getPrototypeOf(Challenge)).apply(this,arguments));}_createClass(Challenge,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:' user-challenge '+__WEBPACK_IMPORTED_MODULE_2__styles__["_68" /* UserChallengeStyle */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components__["_19" /* UserNav */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'flex user-challenge-ranking'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'user-challenge-push'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components__["Z" /* RankingIQ */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'user-challenge-push'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components__["q" /* CurrentRanking */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'user-challenge-push'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components__["h" /* BestRanking */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'user-challenge-push'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components__["X" /* QuizzRanking */],null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'user-challenge-charts'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components__["o" /* ChartRanking */],null)));}}]);return Challenge;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Challenge);

/***/ }),
/* 481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_ApiController__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__hoc_withLoader__ = __webpack_require__(15);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var REGEX_MAIL=/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;var Contact=function(_Component){_inherits(Contact,_Component);function Contact(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,Contact);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Contact.__proto__||Object.getPrototypeOf(Contact)).call.apply(_ref,[this].concat(args))),_this),_this.state={ready:true,error:'',fields:{email:{label:'Email'},firstName:{label:'First Name'},lastName:{label:'Last Name'},subject:{label:'Subject'},message:{label:'Message',type:'textearea'},_token:{label:'token'}},action:'',form:{},clean:false},_this.addFormData=function(data){var form=_this.state.form;var row=[];row[data.key]=data.value;_this.setState({form:Object.assign({},form,row)});},_this.handlerSubmit=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:console.log(_this.state.action);_this.setState({error:''},function(){if(_this.check().valid){Object(__WEBPACK_IMPORTED_MODULE_3__services_ApiController__["addContact"])(_this.state.action,_this.state.form).then(function(data){if(data.success){_this.setState({form:{},clean:true});_this.setState({success:'Thank you for contacting us. We have received your enquiry and will respond to you'});}}).then(function(){_this.setState({clean:false});}).catch(function(e){console.log('Something wrong with postMessage');});}else{_this.setState({error:_this.check().err});}});case 2:case'end':return _context.stop();}}},_callee,_this2);})),_this.check=function(){var valid=true;var err='';if(Object.keys(_this.state.form).length<6){err='All fields are required';valid=false;}else{Object.keys(_this.state.form).map(function(row){if(_this.state.form[row]===''){valid=false;err='All fields are required';}});}if(_this.state.form['contact[email]']){if(!_this.isMail(_this.state.form['contact[email]'])){err='Email is not valid.';valid=false;}}return{valid:valid,err:err};},_this.isMail=function(val){return REGEX_MAIL.test(val.toLowerCase());},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Contact,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(_ref3){var data=_ref3.data;if(data!==this.props.data){this.setState({fields:{email:Object.assign({label:'Email'},data.fields.email),firstName:Object.assign({label:'First Name'},data.fields.firstName),lastName:Object.assign({label:'Last Name'},data.fields.lastName),subject:Object.assign({label:'Subject'},data.fields.subject),_token:Object.assign({label:'token'},data.fields['_token'])},message:Object.assign({label:'Message'},data.fields.message),action:data.action,form:{}});var row=[];row[data.fields['_token'].name]=data.fields['_token'].value;this.setState({form:row});}}},{key:'render',value:function render(){var _this3=this;var _state=this.state,fields=_state.fields,success=_state.success,ready=_state.ready,message=_state.message,error=_state.error;var isReady=this.props.isReady;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:' contact '+Object(__WEBPACK_IMPORTED_MODULE_2__styles__["y" /* ContactStyle */])(ready)},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'page-inner'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'contact-title title'},'Contact'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('form',{className:'contact-form '+__WEBPACK_IMPORTED_MODULE_2__styles__["R" /* Form */]+' transition '+(isReady?'transition--ready':''),onSubmit:this.handlerSubmit},Object.keys(fields).map(function(field,index){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["x" /* Field */],Object.assign({clean:_this3.state.clean,onChange:_this3.addFormData},fields[field],{key:field}),' ',fields[field].label,' ');}),message&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["_13" /* Textarea */],Object.assign({clean:this.state.clean,onChange:this.addFormData},message),' ',message.label,' '),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'contact-btn-submit'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["m" /* Button */],{theme:'red',type:'submit',onCallback:this.handlerSubmit},' Send ')),error!==''&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["t" /* Error */],{className:'error'},' ',error,' '),error===''&&success&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["_11" /* Success */],{className:'success'},' ',success,' '))));}}]);return Contact;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__hoc_withLoader__["a" /* withLoader */])(Contact));

/***/ }),
/* 482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_Router__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__hoc_withLoader__ = __webpack_require__(15);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Counterfeits=function(_Component){_inherits(Counterfeits,_Component);function Counterfeits(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Counterfeits);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Counterfeits.__proto__||Object.getPrototypeOf(Counterfeits)).call.apply(_ref,[this].concat(args))),_this),_this.state={counterfeits:[]},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Counterfeits,[{key:'render',value:function render(){var _props=this.props,data=_props.data,isReady=_props.isReady;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fluid counterfeits '+__WEBPACK_IMPORTED_MODULE_4__styles__["D" /* CounterfeitsContainer */]+' '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["_19" /* UserNav */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'filter-counterfeits'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'reset '+__WEBPACK_IMPORTED_MODULE_4__styles__["o" /* ButtonRouter */]+' flex'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* NavLink */],{to:__WEBPACK_IMPORTED_MODULE_3__services_Router__["a" /* default */].counterfeits.path,exact:true},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Counterfeits'),' ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* NavLink */],{to:__WEBPACK_IMPORTED_MODULE_3__services_Router__["a" /* default */].thefts.path,exact:true},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Thefts'),' ')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'counterfeits-container transition '+(isReady?'transition--ready':'')},data&&data.counterfeits.map(function(counterfeit,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["c" /* AlertCard */],Object.assign({},counterfeit,{key:index}));})));}}]);return Counterfeits;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__hoc_withLoader__["a" /* withLoader */])(Counterfeits,'/alerts/counterfeits'));

/***/ }),
/* 483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__hoc_withLoader__ = __webpack_require__(15);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Counterfeit=function(_Component){_inherits(Counterfeit,_Component);function Counterfeit(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Counterfeit);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Counterfeit.__proto__||Object.getPrototypeOf(Counterfeit)).call.apply(_ref,[this].concat(args))),_this),_this.state={data:{}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Counterfeit,[{key:'render',value:function render(){var _props=this.props,data=_props.data,isReady=_props.isReady;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'counterfeit '+__WEBPACK_IMPORTED_MODULE_2__styles__["B" /* CounterfeitStyle */]+' transition '+(isReady?'transition--ready':'')},data&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'flex'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components__["g" /* ArticleNav */],{is_bookmark:data.is_bookmark,pdf:data.pdf,slug_bookmark:data.slug_bookmark,type:data.type,classname:'news-nav'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'counterfeit-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'counterfeit-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components__["b" /* Alert */],{width:48,height:48}),' ',data.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'counterfeit-intro content',dangerouslySetInnerHTML:{'__html':data.intro}}),data.sub_title&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'counterfeit-subtitle'},data.sub_title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'counterfeit-blocs'},data.blocks&&data.blocks.map(function(bloc,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'counterfeit-bloc bloc',key:index},bloc.type==='video'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bloc-title'},bloc.fields.title),bloc.fields.link&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components__["_21" /* Video */],Object.assign({},bloc.fields,{title:'',label:'play the video',type:'vimeo'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bloc-content content',dangerouslySetInnerHTML:{'__html':bloc.fields.description}})),bloc.type==='content'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bloc-title'},bloc.fields.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'flex'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bloc-content '+Object(__WEBPACK_IMPORTED_MODULE_2__styles__["A" /* CounterfeitContentStyle */])(bloc.fields.image_left.url)},bloc.fields.image_left.url&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bloc-picture'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bloc-picture__picture'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bloc-picture__legend'},bloc.fields.image_legend_left)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content',dangerouslySetInnerHTML:{'__html':bloc.fields.text_left}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bloc-content '+Object(__WEBPACK_IMPORTED_MODULE_2__styles__["A" /* CounterfeitContentStyle */])(bloc.fields.image_right.url)},bloc.fields.image_right.url&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bloc-picture'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bloc-picture__picture'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bloc-picture__legend'},bloc.fields.image_legend_right)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content',dangerouslySetInnerHTML:{'__html':bloc.fields.text_right}})))));})))));}}]);return Counterfeit;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3__hoc_withLoader__["a" /* withLoader */])(Counterfeit,'/alerts/counterfeits',true));

/***/ }),
/* 484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_FaqItem__ = __webpack_require__(485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_FaqPopin__ = __webpack_require__(486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_ApiController__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_actions_FaqModal__ = __webpack_require__(164);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Faq=function(_Component){_inherits(Faq,_Component);function Faq(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Faq);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Faq.__proto__||Object.getPrototypeOf(Faq)).call.apply(_ref,[this].concat(args))),_this),_this.state={activeTheme:'all',activeItem:null,ready:false,popinOpen:false},_this.changeTheme=function(theme){_this.setState({activeTheme:theme});},_this.setActiveItem=function(item){_this.setState({activeItem:item});},_this.getDatas=function(){Object(__WEBPACK_IMPORTED_MODULE_4__services_ApiController__["fetchFaq"])().then(function(data){var nData=[];var i=0;Object.keys(data).map(function(row,index){nData.push(data[row]);i=index;if(i===Object.keys(data).length-1)_this.setState({FAQ:nData,ready:true});});_this.setState({activeTheme:nData[0].filter(function(item){return nData[1].map(function(item2){return item2.category;}).includes(item);})[0]});}).catch(function(err){console.log('Something Wrong with FAQ data',err);});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Faq,[{key:'componentDidMount',value:function componentDidMount(){this.getDatas();}},{key:'render',value:function render(){var _this2=this;var FAQ=this.state.FAQ;var allCategories=[];// get all questions categories to remove categories with 0 question from nav
if(FAQ){allCategories=FAQ[1].map(function(item){return item.category;});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'faq pages-faq '+__WEBPACK_IMPORTED_MODULE_5__styles__["K" /* FAQStyle */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:__WEBPACK_IMPORTED_MODULE_5__styles__["_81" /* srOnlyStyle */]},'Q&A'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'page-inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'nav reset flex flex-wrap items-center'},FAQ&&FAQ[0].filter(function(item){return allCategories.includes(item);}).map(function(item,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){return _this2.changeTheme(item);},className:_this2.state.activeTheme===item?'active':''},item));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'accordion'},FAQ&&FAQ[1].map(function(item,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_FaqItem__["a" /* default */],{key:index,activeTheme:_this2.state.activeTheme,themes:[item.category],question:item.question,activeItem:_this2.state.activeItem,setActiveItem:_this2.setActiveItem,currentItem:index,answer:item.answer});})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_5__styles__["J" /* FAQBottomStyles */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'This Q&A space is for participation purposes.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' If you do not find an answer to your question, please ask us using the button below.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){return _this2.props.openModal();},className:'btn '+Object(__WEBPACK_IMPORTED_MODULE_5__styles__["p" /* ButtonStyle */])('red',true)},'Ask us your question'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_FaqPopin__["a" /* default */],null))));}}]);return Faq;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(_ref2){var FaqModal=_ref2.FaqModal;return{isOpen:FaqModal.isOpen};},function(dispatch){return{openModal:function openModal(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__store_actions_FaqModal__["b" /* openModal */])());}};})(Faq));

/***/ }),
/* 485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FaqItem=function(_Component){_inherits(FaqItem,_Component);function FaqItem(){var _ref;var _temp,_this,_ret;_classCallCheck(this,FaqItem);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=FaqItem.__proto__||Object.getPrototypeOf(FaqItem)).call.apply(_ref,[this].concat(args))),_this),_this.toggleAccordion=function(){_this.props.setActiveItem(_this.props.currentItem!==_this.props.activeItem?_this.props.currentItem:null);},_this.calcMaxHeight=function(){_this.maxHeight=_this.innerContent.offsetHeight;},_this.onResize=Object(__WEBPACK_IMPORTED_MODULE_1_lodash__["throttle"])(function(){_this.calcMaxHeight();},400),_temp),_possibleConstructorReturn(_this,_ret);}_createClass(FaqItem,[{key:'componentDidMount',value:function componentDidMount(){this.calcMaxHeight();}},{key:'render',value:function render(){var _this2=this;var _props=this.props,themes=_props.themes,activeTheme=_props.activeTheme,question=_props.question,answer=_props.answer;if(this.content){if(this.props.currentItem===this.props.activeItem){this.content.style.maxHeight=this.maxHeight+'px';}else{this.content.style.maxHeight=0;}}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'accordion-item '+(this.props.activeItem===this.props.currentItem?'is-open':'')+' '+(activeTheme!=='all'&&!themes.includes(activeTheme)?'is-hidden':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'accordion-title',onClick:function onClick(){return _this2.toggleAccordion();}},question,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'accordion-title-icon'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'accordion-content',ref:function ref(content){return _this2.content=content;}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'accordion-content-inner',ref:function ref(innerContent){return _this2.innerContent=innerContent;},dangerouslySetInnerHTML:{__html:answer}})));}}]);return FaqItem;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (FaqItem);

/***/ }),
/* 486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_ApiController__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4____ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_actions_FaqModal__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__hoc_withLoader__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux__ = __webpack_require__(8);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FaqPopin=function(_Component){_inherits(FaqPopin,_Component);function FaqPopin(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,FaqPopin);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=FaqPopin.__proto__||Object.getPrototypeOf(FaqPopin)).call.apply(_ref,[this].concat(args))),_this),_this.state={ready:true,error:'',fields:{question:{label:'Your question',type:'text',id:'question_question',value:'',name:'question[question]'}},action:'/question',form:{}},_this.handleOverlay=function(e){if(e.target.closest('.popin-inner')===null){_this.props.closeModal();}},_this.handlerSubmit=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_this.setState({error:''},function(){if(_this.check().valid){Object(__WEBPACK_IMPORTED_MODULE_3__services_ApiController__["addFaqQuestion"])(_this.state.action,_this.state.form).then(function(data){if(data.success){_this.setState({form:{},clean:true});_this.setState({success:'Thank you for your question.',success2:'We will examine it shortly.'});}}).then(function(){_this.setState({clean:false});}).catch(function(e){console.log('Something wrong with postMessage');});}else{_this.setState({error:_this.check().err});}});case 1:case'end':return _context.stop();}}},_callee,_this2);})),_this.addFormData=function(data){var form=_this.state.form;var row=[];row[data.key]=data.value;_this.setState({form:Object.assign({},form,row)});},_this.check=function(){var valid=true;var err='';if(!_this.state.form['question[question]']){err='Field question is required';valid=false;}return{valid:valid,err:err};},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(FaqPopin,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(_ref3){var data=_ref3.data;var row=[];row[data.fields['_token'].name]=data.fields['_token'].value;this.setState({form:row});}},{key:'render',value:function render(){var _this3=this;var _state=this.state,fields=_state.fields,success=_state.success,success2=_state.success2,error=_state.error;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:Object(__WEBPACK_IMPORTED_MODULE_2__styles__["L" /* FaqPopinStyle */])()+' '+(this.props.isOpen?'is-open':''),onClick:function onClick(e){return _this3.handleOverlay(e);}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'contact popin-inner '+Object(__WEBPACK_IMPORTED_MODULE_2__styles__["y" /* ContactStyle */])(true)},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'popin-close',onClick:function onClick(){return _this3.props.closeModal();}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('svg',{className:'shape',viewBox:'0 0 24 24',width:'24',height:'24'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M5.97786163,5.59528375 C6.37110859,5.20203679 6.99946072,5.20266928 7.38740665,5.5906152 L7.38740665,5.5906152 L12.3416453,10.5450002 L17.2962387,5.5906152 C17.6841846,5.20266928 18.3125367,5.20203679 18.7057837,5.59528375 C19.096308,5.98580804 19.0982659,6.61701507 18.7104522,7.00482877 L13.7556453,11.9590002 L18.7104522,16.9136608 C19.0684341,17.2716427 19.0943029,17.8370129 18.7890065,18.2290327 L18.7057837,18.3232058 L18.6110774,18.4069662 C18.2172897,18.7140637 17.6543426,18.6859783 17.2962387,18.3278744 L17.2962387,18.3278744 L12.3416453,13.3730002 L7.38740665,18.3278744 C7.02930272,18.6859783 6.46635562,18.7140637 6.07256796,18.4069662 L5.97786163,18.3232058 C5.58733734,17.9326815 5.58537939,17.3014745 5.97319309,16.9136608 L10.9276453,11.9590002 L5.97319309,7.00482877 C5.61521121,6.64684689 5.58934246,6.08147662 5.89463882,5.68945688 Z',id:'path-1'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('form',{className:'contact-form '+__WEBPACK_IMPORTED_MODULE_2__styles__["R" /* Form */],onSubmit:this.handlerSubmit},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'contact-title-faq'},'You have a question ?',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),'Submit it'),Object.keys(fields).map(function(field,index){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4____["x" /* Field */],Object.assign({onChange:_this3.addFormData},fields[field],{key:field}),' ',fields[field].label,' ');}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'contact-btn-submit'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4____["m" /* Button */],{theme:'red',type:'submit',onCallback:this.handlerSubmit},' Send ')),error!==''&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4____["t" /* Error */],{className:'error'},' ',error,' '),error===''&&success&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4____["_11" /* Success */],{className:'success'},' ',success,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),success2))));}}]);return FaqPopin;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__hoc_withLoader__["a" /* withLoader */])(Object(__WEBPACK_IMPORTED_MODULE_7_react_redux__["b" /* connect */])(function(_ref4){var FaqModal=_ref4.FaqModal;return{isOpen:FaqModal.isOpen};},function(dispatch){return{closeModal:function closeModal(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__store_actions_FaqModal__["a" /* closeModal */])());}};})(FaqPopin),'/question'));

/***/ }),
/* 487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_Router__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__hoc_withLoader__ = __webpack_require__(15);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Gift=function(_Component){_inherits(Gift,_Component);function Gift(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Gift);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Gift.__proto__||Object.getPrototypeOf(Gift)).call.apply(_ref,[this].concat(args))),_this),_this.state={nav:[// {
//   value: 'Gift',
//   url: Router.gifts.path
// },
{value:'Quizzes',url:__WEBPACK_IMPORTED_MODULE_3__services_Router__["a" /* default */].hubQuizz.path},{value:'Ranking',url:__WEBPACK_IMPORTED_MODULE_3__services_Router__["a" /* default */].ranking.exactPath}],gifts:[]},_this.returnSup=function(sup){var str='th';switch(sup){case 0:str='st';break;case 1:str='nd';break;case 3:str='rd';break;default:break;}return str;},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Gift,[{key:'render',value:function render(){var _this2=this;var _props=this.props,data=_props.data,isReady=_props.isReady;var nav=this.state.nav;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'gift page-inner '+__WEBPACK_IMPORTED_MODULE_2__styles__["U" /* GiftStyle */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components__["J" /* Nav */],{nav:nav}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'gift-container flex transition '+(isReady?'transition--ready':'')},data&&data.map(function(gift,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'gift '+(index<3?'highlight':''),key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'gift-inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'gift-number'},index+1,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('sup',null,_this2.returnSup(index))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components__["U" /* PushContent */],gift)));})));}}]);return Gift;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4__hoc_withLoader__["a" /* withLoader */])(Gift,'/challenge/quiz/gifts'));

/***/ }),
/* 488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_Router__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_date__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__hoc_withLoader__ = __webpack_require__(15);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var HubQuizz=function(_Component){_inherits(HubQuizz,_Component);function HubQuizz(){var _ref;var _temp,_this,_ret;_classCallCheck(this,HubQuizz);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=HubQuizz.__proto__||Object.getPrototypeOf(HubQuizz)).call.apply(_ref,[this].concat(args))),_this),_this.state={nav:[// {
//   value: 'Gift',
//   url: Router.gifts.path
// },
{value:'Quizzes',url:__WEBPACK_IMPORTED_MODULE_4__services_Router__["a" /* default */].hubQuizz.path},{value:'Ranking',url:__WEBPACK_IMPORTED_MODULE_4__services_Router__["a" /* default */].ranking.exactPath}]},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(HubQuizz,[{key:'render',value:function render(){var nav=this.state.nav;var _props=this.props,data=_props.data,isReady=_props.isReady;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'hub-quizz page-inner '+Object(__WEBPACK_IMPORTED_MODULE_3__styles__["X" /* HubQuizzStyle */])()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components__["J" /* Nav */],{nav:nav}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'hub-quizz-container transition '+(isReady?'transition--ready':'')},data&&Object.keys(data.currentQuiz).length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'hub-quizz-title subtitle'},' Current Quizz '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'current-quizz quizz flex items-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'current-quizz-inner quizz-inner flex items-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'current-quizz-info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,data.currentQuiz.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{dangerouslySetInnerHTML:{'__html':Object(__WEBPACK_IMPORTED_MODULE_5__helpers_date__["a" /* DateFormat */])(data.currentQuiz.start.substring(0,2))+' of '+Object(__WEBPACK_IMPORTED_MODULE_5__helpers_date__["d" /* GetMonth */])(data.currentQuiz.start.substring(3,5))+' to '+Object(__WEBPACK_IMPORTED_MODULE_5__helpers_date__["a" /* DateFormat */])(data.currentQuiz.end.substring(0,2))+' of '+Object(__WEBPACK_IMPORTED_MODULE_5__helpers_date__["d" /* GetMonth */])(data.currentQuiz.end.substring(3,5))}}),data.currentQuiz.score&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'score'},data.currentQuiz.score,' pts')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'current-quizz-link'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Link */],{to:__WEBPACK_IMPORTED_MODULE_4__services_Router__["a" /* default */].currentQuizz.path,className:'btn'},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Start the quizz'),' '))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'current-quizz-days'},Object(__WEBPACK_IMPORTED_MODULE_5__helpers_date__["c" /* DayDiff */])(new Date(),new Date(data.currentQuiz.end.substring(6,10),parseInt(data.currentQuiz.end.substring(3,5))-1,data.currentQuiz.end.substring(0,2)))>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'days'},data.currentQuiz.enabled?Object(__WEBPACK_IMPORTED_MODULE_5__helpers_date__["c" /* DayDiff */])(new Date(),new Date(data.currentQuiz.end.substring(6,10),parseInt(data.currentQuiz.end.substring(3,5))-1,data.currentQuiz.end.substring(0,2))):Object(__WEBPACK_IMPORTED_MODULE_5__helpers_date__["c" /* DayDiff */])(new Date(),new Date(data.currentQuiz.start.substring(6,10),parseInt(data.currentQuiz.start.substring(3,5))-1,data.currentQuiz.start.substring(0,2)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'label'},data.currentQuiz.enabled&&!!data.currentQuiz.score?'days left to participate':'days to participate')):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'label'},'You can practice again but your score cannot be taken into account')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'hub-quizz-previous'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'hub-quizz-title'},' Previous Quizz '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,' You can practice again but your score cannot be taken into account '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'previous-quizz-container flex items-center'},data&&data.previousQuizzes.map(function(quizz,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'previous-quizz quizz flex',key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'previous-quizz-inner quizz-inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,quizz.title),quizz.score?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'score'},quizz.score,' pts'):null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'previous-quizz-days'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,' ',quizz.start.substring(0,2),'th of ',Object(__WEBPACK_IMPORTED_MODULE_5__helpers_date__["d" /* GetMonth */])(quizz.start.substring(3,5)),' to ',quizz.end.substring(0,2),'th of ',Object(__WEBPACK_IMPORTED_MODULE_5__helpers_date__["d" /* GetMonth */])(quizz.end.substring(3,5)),' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Link */],{to:__WEBPACK_IMPORTED_MODULE_4__services_Router__["a" /* default */].quizz.exactPath+'/'+quizz.id,className:'btn'},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Start the quizz'),' ')));})),data&&data.previousQuizzes.length===0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'No previous quizz available at the moment'))));}}]);return HubQuizz;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__hoc_withLoader__["a" /* withLoader */])(HubQuizz,'/challenge/quiz/all'));

/***/ }),
/* 489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Pages=function(_Component){_inherits(Pages,_Component);function Pages(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Pages);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Pages.__proto__||Object.getPrototypeOf(Pages)).call.apply(_ref,[this].concat(args))),_this),_this.state={ready:false},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Pages,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;this.timer=setTimeout(function(){_this2.setState({ready:true});},400);}},{key:'render',value:function render(){var _props=this.props,children=_props.children,title=_props.title;var ready=this.state.ready;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'page '+Object(__WEBPACK_IMPORTED_MODULE_1__styles__["_15" /* PageStyle */])(ready)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'page-inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'page-title title'},title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'page-container'},children)));}}]);return Pages;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Pages);

/***/ }),
/* 490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Intro__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Final__ = __webpack_require__(492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Slides__ = __webpack_require__(493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_ApiController__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Quizz=function(_Component){_inherits(Quizz,_Component);function Quizz(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,Quizz);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Quizz.__proto__||Object.getPrototypeOf(Quizz)).call.apply(_ref,[this].concat(args))),_this),_this.state={intro:true,slides:false,final:false,isReady:false,finalResult:{}},_this.getData=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_6__services_ApiController__["fetchPage"])(_this.props.match.params.slug==='current'?'/challenge/quiz':'/challenge/quiz/'+_this.props.match.params.slug).then(function(data){_this.setState({data:data,isReady:true});}).catch(function(e){console.log('Ooops something wrong with Question');});case 2:case'end':return _context.stop();}}},_callee,_this2);})),_this.handlerStart=function(){_this.setState({intro:false,slides:true});},_this.handlerFinal=function(data){_this.setState({slides:false,final:true,finalResult:data});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Quizz,[{key:'componentDidMount',value:function componentDidMount(){document.body.classList.add('nofooter');this.getData();}},{key:'componentWillUnmount',value:function componentWillUnmount(){document.body.classList.remove('nofooter');}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(_ref3){var data=_ref3.data;if(data!==this.props.data){var _setState;this.setState((_setState={isReady:false,intro:true,slides:false,final:false},_defineProperty(_setState,'isReady',false),_defineProperty(_setState,'finalResult',{}),_setState));this.getData();}}},{key:'render',value:function render(){var _state=this.state,intro=_state.intro,slides=_state.slides,final=_state.final,data=_state.data,isReady=_state.isReady,finalResult=_state.finalResult;var username=this.props.username;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:' quizz '+Object(__WEBPACK_IMPORTED_MODULE_7__styles__["_29" /* QuizzContainerStyle */])(isReady)},intro&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Intro__["a" /* default */],Object.assign({},data,{startQuizz:this.handlerStart})),slides&&data&&!final&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Slides__["a" /* default */],{id:this.props.match.params.slug,current:data.current,getFinal:this.handlerFinal}),final&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Final__["a" /* default */],{id:this.props.match.params.slug,name:username,current:data.current,alreadyPlayed:data.alreadyPlayed,result:finalResult}));}}]);return Quizz;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function(_ref4){var Session=_ref4.Session;return{username:Session.username};})(Quizz));

/***/ }),
/* 491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Intro=function(_Component){_inherits(Intro,_Component);function Intro(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,Intro);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Intro.__proto__||Object.getPrototypeOf(Intro)).call.apply(_ref,[this].concat(args))),_this),_this.state={},_this.handlerClick=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return _this.props.startQuizz();case 2:case'end':return _context.stop();}}},_callee,_this2);})),_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Intro,[{key:'render',value:function render(){var _props=this.props,date_end=_props.date_end,date_start=_props.date_start,questions=_props.questions,title=_props.title,alreadyPlayed=_props.alreadyPlayed,enabled=_props.enabled,current=_props.current;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'quizz-intro quizz '+__WEBPACK_IMPORTED_MODULE_3__styles__["_33" /* QuizzStyle */]},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'quizz-title'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["Y" /* RM */],{width:228,height:92}),' Challenge'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'quizz-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'quizz-subtitle quizz-up'},title),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'quizz-date flex'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'quizz-start quizz-up'},'Start : ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'date'},date_start)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'quizz-end quizz-up'},'End : ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'date'},date_end))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'quizz-description'},'This test will have ',questions,' questions, spread in the following themes. The test will be limited in time and every question will have a proper time'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["m" /* Button */],{theme:'red',onCallback:this.handlerClick},' ',alreadyPlayed?'restart':'start',' ')));}}]);return Intro;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Intro);

/***/ }),
/* 492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_ApiController__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_actions_Session__ = __webpack_require__(39);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ROLE=['ROLE_ZONE_MANAGER','ROLE_MANAGER','ROLE_ADMIN','ROLE_SUPER_ADMIN'];var Final=function(_Component){_inherits(Final,_Component);function Final(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Final);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Final.__proto__||Object.getPrototypeOf(Final)).call.apply(_ref,[this].concat(args))),_this),_this.state={result:{}},_this.update=function(){if(!_this.props.alreadyPlayed)_this.props.editChallenge();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Final,[{key:'componentDidMount',value:function componentDidMount(){this.update();}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(_ref2){var result=_ref2.result;if(result!==result)this.update();}},{key:'render',value:function render(){var _props=this.props,name=_props.name,role=_props.role,alreadyPlayed=_props.alreadyPlayed,result=_props.result;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'quizz quizz-final '+__WEBPACK_IMPORTED_MODULE_2__styles__["_30" /* QuizzFinalStyle */]+' flex'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'quizz-final-middle flex'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'quizz-final-title quizz-up'},'Test completed'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'quizz-final-name quizz-up'},' Congratulations ',name,' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'quizz-final-score quizz-red'},' Score ',result.result,' pts'),ROLE.indexOf(role)!==-1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,' Your score cannot be taken into account '),alreadyPlayed&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'You can practice again but your score cannot be taken into account')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'quizz-final-next'},'NEXT SESSION : ',result.next_session));}}]);return Final;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(_ref3){var Session=_ref3.Session;return{role:Session.role};},function(dispatch){return{editChallenge:function editChallenge(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__store_actions_Session__["b" /* editChallenge */])());}};})(Final));

/***/ }),
/* 493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_ApiController__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__static_default_picture_RM_quizz_png__ = __webpack_require__(494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__static_default_picture_RM_quizz_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__static_default_picture_RM_quizz_png__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Intro=function(_Component){_inherits(Intro,_Component);function Intro(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,Intro);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Intro.__proto__||Object.getPrototypeOf(Intro)).call.apply(_ref,[this].concat(args))),_this),_this.state={question:{},response:{},time:0,initTime:0,ready:false,data:{hash:'',answers:[]},good:[],explanation:'',valid:false,nextStep:false,disabled:false,last:false},_this.handlerChecked=function(data){var nAnswers=_this.state.data.answers;if(data.checked)nAnswers.push(data.value);else nAnswers=nAnswers.filter(function(answer){return answer!==data.value;});_this.setState({data:{hash:_this.state.data.hash,answers:nAnswers}});},_this.getQuestion=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:clearTimeout(_this.timerNextQuestion);clearTimeout(_this.timerNextStep);_context.next=4;return Object(__WEBPACK_IMPORTED_MODULE_4__services_ApiController__["fetchQuestion"])(_this.props.id).then(function(data){console.log(data);if(data.state!=='score'){_this.setState({question:data,time:data.time_left,initTime:data.time_left,ready:true,last:data.position_question===data.total_questions,data:{hash:data.hash,answers:[]}});}else{_this.props.getFinal(data);}return data.state;}).then(function(state){if(state!=='score'){_this.timer_quiz=setInterval(function(){return _this.tick();},1000);}}).catch(function(e){console.log('Ooops something wrong with Question');});case 4:case'end':return _context.stop();}}},_callee,_this2);})),_this.submitQuizz=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:if(_this.state.data.answers.length===0){_this.setState({data:{hash:_this.state.data.hash,answers:["-1"]}},function(){_this.submitQuizzHandler();});}else{_this.submitQuizzHandler();}case 1:case'end':return _context2.stop();}}},_callee2,_this2);})),_this.submitQuizzHandler=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(){var url;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:url=_this.props.current?'/challenge/quiz/question.json':'/challenge/quiz/'+_this.props.id+'/question.json';clearInterval(_this.timer_quiz);_context3.next=4;return Object(__WEBPACK_IMPORTED_MODULE_4__services_ApiController__["addQuiz"])(url,_this.state.data).then(function(data){_this.setState({good:data.good_answers,explanation:data.explanation,valid:data.valid,nextStep:data.valid,disabled:!data.valid});}).then(function(){if(_this.props.current){_this.nextQuestion();}else{if(_this.state.question.current){_this.nextQuestion();}else{_this.timerNextStep=setTimeout(function(){_this.setState({nextStep:true});},3000);}}}).catch(function(e){console.log('Something wrong with fetching question',e);});case 4:case'end':return _context3.stop();}}},_callee3,_this2);})),_this.nextQuestion=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:_this.setState({ready:false});_this.timerNextQuestion=setTimeout(function(){_this.setState({question:{},response:{},time:0,initTime:0,ready:false,data:{hash:'',answers:[]},good:[],explanation:'',valid:false,nextStep:false,disabled:false},_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.next=2;return _this.getQuestion();case 2:case'end':return _context4.stop();}}},_callee4,_this2);})));},300);case 2:case'end':return _context5.stop();}}},_callee5,_this2);})),_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Intro,[{key:'componentDidMount',value:function componentDidMount(){this.getQuestion();}},{key:'componentWillUnmount',value:function componentWillUnmount(){clearInterval(this.timer_quiz);clearInterval(this.timer);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(_ref7){var data=_ref7.data;if(data!==this.props.data){}}},{key:'tick',value:function tick(){if(this.state.time>0){this.setState({time:this.state.time-1});}else{this.submitQuizz();}}},{key:'render',value:function render(){var _this3=this;var _state=this.state,question=_state.question,time=_state.time,ready=_state.ready,explanation=_state.explanation,good=_state.good,valid=_state.valid,initTime=_state.initTime,nextStep=_state.nextStep,disabled=_state.disabled,data=_state.data,last=_state.last;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:' quizz '+Object(__WEBPACK_IMPORTED_MODULE_2__styles__["_32" /* QuizzSlidesStyle */])(question.image?question.image:__WEBPACK_IMPORTED_MODULE_5__static_default_picture_RM_quizz_png___default.a,initTime,ready,nextStep,question.image?'cover':'contain')},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'quizz-container flex'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'quizz-picture'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'quizz-question'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('form',{onSubmit:this.submitQuizz},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'quizz-pagination flex'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'quizz-pagination-active'},' ',question.position_question,' '),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'quizz-pagination-total'},' ',question.total_questions,' ')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'quizz-category'},question.category_question),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'quizz-title'},question.position_question,'. ',question.question),!(nextStep&&!valid)&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'quizz-first-step'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'quizz-choices '+(this.props.current?'quizz-choices--current':'')},question.choices&&question.choices.length>0&&question.choices.map(function(choice){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["p" /* Checkbox */],{className:'\n                              '+(!question.current&&good.length>0&&data.answers.indexOf(choice.id.toString())!==-1&&good.indexOf(choice.id)!==-1&&'good')+' \n                              '+(!question.current&&good.length>0&&data.answers.indexOf(choice.id.toString())!==-1&&good.indexOf(choice.id)===-1&&'bad')+' \n                              '+(!question.current&&good.length>0&&data.answers.indexOf(choice.id.toString())===-1&&good.indexOf(choice.id)!==-1&&'valid'),onCallback:_this3.handlerChecked,key:choice.id,name:question.question+'['+choice.id+']',id:question.question+'['+choice.id+']',value:choice.id},choice.value,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["_20" /* Valid */],{width:16,height:16}));}))),nextStep&&!valid&&!question.current&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'quizz-explanation',dangerouslySetInnerHTML:{'__html':explanation}}),disabled||!nextStep&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'quizz-valid flex items-center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'quizz-timer flex items-center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'timer'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'timer-progress'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'time'},time,'s')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["m" /* Button */],{type:'submit',theme:'red',onCallback:this.submitQuizz},' Validate ')),nextStep&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'btn-next-question '},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["m" /* Button */],{type:'button',onCallback:this.nextQuestion},' ',last?'Result':'Next',' '))))));}}]);return Intro;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Intro);

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/default_picture_RM_quizz.aaacac9b.png";

/***/ }),
/* 495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_Router__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__hoc_withLoader__ = __webpack_require__(15);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Ranking=function(_Component){_inherits(Ranking,_Component);function Ranking(props){_classCallCheck(this,Ranking);var _this=_possibleConstructorReturn(this,(Ranking.__proto__||Object.getPrototypeOf(Ranking)).call(this,props));_this.state={nav:[// {
//   value: 'Gift',
//   url: Router.gifts.path
// },
{value:'Quizzes',url:__WEBPACK_IMPORTED_MODULE_2__services_Router__["a" /* default */].hubQuizz.path},{value:'Ranking',url:__WEBPACK_IMPORTED_MODULE_2__services_Router__["a" /* default */].ranking.exactPath}],viewButton:false};_this.handlerClick=function(){_this.setState({viewButton:false});document.documentElement.scrollTop=_this.current.offsetTop-window.innerHeight/2;};_this.current=null;return _this;}_createClass(Ranking,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(_ref){var _this2=this;var data=_ref.data;// await fetchPage().then((data) => {
if(data!==this.props){var nZone=[];var i=0;Object.keys(data).map(function(zone,index){nZone.push({label:zone,slug:zone});i=index;if(i===Object.keys(data).length-1)_this2.setState({filters:nZone});return nZone;});this.setState({ranking:data});this.current=document.querySelector('.ranking-user-line.current');if(this.current)this.setState({viewButton:this.current.offsetTop>window.innerHeight});}}},{key:'render',value:function render(){var _state=this.state,ranking=_state.ranking,viewButton=_state.viewButton;var isReady=this.props.isReady;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ranking page-inner '+Object(__WEBPACK_IMPORTED_MODULE_3__styles__["_35" /* RankingStyle */])(isReady)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components__["J" /* Nav */],{nav:this.state.nav}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ranking-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ranking filter-ranking'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components__["_7" /* SimpleFilter */],{filters:this.state.filters,parentPath:__WEBPACK_IMPORTED_MODULE_2__services_Router__["a" /* default */].ranking.exactPath})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ranking-user transition '+(isReady?'transition--ready':'')+' '},ranking&&ranking[this.props.match.params.filter!==undefined?this.props.match.params.filter:'General'].map(function(item,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ranking-user-line flex '+(item.current?'current':''),key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ranking-user-pos'},item.ranking),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ranking-user-name'},'\xA0',item.score?item.name:'-',' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ranking-user-localisation'},item.score?item.city:'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ranking-user-score'},item.score?item.score:'-',' '));})),viewButton&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'ranking-position-go btn btn--reset',onClick:this.handlerClick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'label'},' View my Position '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components__["d" /* Arrow */],{width:24,height:24}))));}}]);return Ranking;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4__hoc_withLoader__["a" /* withLoader */])(Ranking,'/challenge/quiz/ranking'));

/***/ }),
/* 496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony default export */ __webpack_exports__["a"] = (function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"catalog"},"Catalog");});

/***/ }),
/* 497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__hoc_withLoader__ = __webpack_require__(15);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Sitemap=function(_Component){_inherits(Sitemap,_Component);function Sitemap(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Sitemap);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Sitemap.__proto__||Object.getPrototypeOf(Sitemap)).call.apply(_ref,[this].concat(args))),_this),_this.state={data:{}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Sitemap,[{key:'render',value:function render(){var _props=this.props,data=_props.data,isReady=_props.isReady;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'sitemap '+__WEBPACK_IMPORTED_MODULE_2__styles__["_42" /* SitemapStyle */]+' transition '+(isReady?'transition--ready':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'page-inner'},data&&Object.keys(data).map(function(title,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'sitemap-row flex',key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'sitemap-title'},title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'sitemap-categories flex'},data[title].categories.map(function(category,category_index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'sitemap-category',key:category_index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'category'},' ',category.name,' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'sitemap-link reset'},category.pages.map(function(page,page_index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:page_index},'  ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:page.url},' ',page.label,' '),' ');})));})));})));}}]);return Sitemap;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3__hoc_withLoader__["a" /* withLoader */])(Sitemap));

/***/ }),
/* 498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_Router__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__hoc_withLoader__ = __webpack_require__(15);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Social=function(_Component){_inherits(Social,_Component);function Social(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Social);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Social.__proto__||Object.getPrototypeOf(Social)).call.apply(_ref,[this].concat(args))),_this),_this.state={nav:[{value:'Publications',url:__WEBPACK_IMPORTED_MODULE_3__services_Router__["a" /* default */].publications.path},{value:'Social Wall',url:__WEBPACK_IMPORTED_MODULE_3__services_Router__["a" /* default */].social.exactPath+'/instagram'}],filters:[{label:'instagram',slug:'instagram',icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["D" /* Instagram */],{width:24,height:24})},{label:'twitter',slug:'twitter',icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["_15" /* Twitter */],{width:24,height:24})},{label:'facebook',slug:'facebook',icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["v" /* Facebook */],{width:24,height:24})},{label:'weibo',slug:'weibo',icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["_23" /* Weibo */],{width:24,height:24})}],count:6},_this.getMore=function(){_this.setState({count:_this.state.count+6});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Social,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(_ref2){var _this2=this;var data=_ref2.data,match=_ref2.match;if(data!==this.props.data||match.params.filter!==this.props.match.params.filter){var nextFilter=match.params.filter;var filteredData=nextFilter?data.filter(function(social){return social.type===match.params.filter;}):data;var i=0;var increase=0;var nData=[[],[],[]];filteredData.map(function(social){nData[i].push(social);i=i<2?i+1:0;increase=increase+1;if(increase===filteredData.length-1){_this2.setState({socials:nData});}return social;});return nData;}}},{key:'getPictureID',value:function getPictureID(link,type){var linkSplit=link.split('/');var subNum=type==='facebook'?3:2;return linkSplit[linkSplit.length-subNum];}},{key:'render',value:function render(){var _state=this.state,nav=_state.nav,filters=_state.filters,count=_state.count,socials=_state.socials;var _props=this.props,match=_props.match,isReady=_props.isReady;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:' social '+__WEBPACK_IMPORTED_MODULE_5__styles__["_51" /* SocialStyle */]+' '+__WEBPACK_IMPORTED_MODULE_5__styles__["l" /* ButtonLoadMoreStyle */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'page-inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'social-nav'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components__["J" /* Nav */],{nav:nav})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'social-filter'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'simple-filter '+__WEBPACK_IMPORTED_MODULE_5__styles__["_41" /* SimpleFilterStyle */]+' reset flex'},filters&&filters.map(function(filter,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:index,className:'simple-filter-item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["c" /* NavLink */],{to:__WEBPACK_IMPORTED_MODULE_3__services_Router__["a" /* default */].social.exactPath+'/'+filter.label,exact:true},filter.icon&&filter.icon,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'  ',filter.label,' ')));}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:' social-container flex transition '+(isReady?'transition--ready':'')},socials&&socials.map(function(row,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'social-col',key:index},row.slice(0,count).map(function(social,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'social-box',key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:social.link,target:'_blank'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'flex'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'social-type'},social.type==='facebook'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["v" /* Facebook */],{width:24,height:24}),social.type==='twitter'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["_15" /* Twitter */],{width:24,height:24}),social.type==='instagram'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["D" /* Instagram */],{width:24,height:24}),social.type==='weibo'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["_23" /* Weibo */],{width:24,height:24})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'social-head'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'social-title'},social.account_name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'social-date'},social.date))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'social-desc',dangerouslySetInnerHTML:{__html:social.title}}),social.image&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'social-img'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:social.image,alt:'',referrerPolicy:'no-referrer'}))));}));})),socials&&count<(socials[0].length+socials[1].length+socials[2].length)/3&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-load-more',onClick:this.getMore},'Load more')));}}]);return Social;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__hoc_withLoader__["a" /* withLoader */])(Social,'/social-media'));

/***/ }),
/* 499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_ApiController__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__hoc_withLoader__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * TODO: 
 * If user is already update 
 * 
*/// ROLE
var ROLE=['ROLE_SELLER','ROLE_STORE_MANAGER','ROLE_ZONE_MANAGER','ROLE_MANAGER','ROLE_ADMIN','ROLE_SUPER_ADMIN'];var STORE_EDIT=['ROLE_STORE_MANAGER','ROLE_ZONE_MANAGER','ROLE_MANAGER','ROLE_ADMIN','ROLE_SUPER_ADMIN'];var Stock=function(_Component){_inherits(Stock,_Component);function Stock(){var _ref,_this$state,_this2=this;var _temp,_this,_ret;_classCallCheck(this,Stock);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Stock.__proto__||Object.getPrototypeOf(Stock)).call.apply(_ref,[this].concat(args))),_this),_this.state=(_this$state={load:true,references:[],store:'',error:''},_defineProperty(_this$state,'store',{}),_defineProperty(_this$state,'first',true),_defineProperty(_this$state,'stock',[]),_defineProperty(_this$state,'disabled',true),_defineProperty(_this$state,'search',''),_this$state),_this.initMobileStock=function(){var allQuantities=document.querySelectorAll('.stock-line:not(.no-stock) .quantity');var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=allQuantities[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var quantity=_step.value;quantity.style.top='0';}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}},_this.hasFirstStore=function(){// document.querySelector('.stock-table').addEventListener('scroll', this.onScroll)
_this.setState({first:true},function(){_this.state.references.map(function(item){if(item.quantity>0)_this.setState({first:false});});_this.initMobileStock();});},_this.printStock=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return window.print();case 2:case'end':return _context.stop();}}},_callee,_this2);})),_this.sendStock=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_4__services_ApiController__["addStock"])(_this.state.stock).then(function(data){if(data.success){_this.props.getData(_this.props.location,_this.props.location.match);}_this.setState({disabled:true});}).catch(function(e){console.log('Oups Something wrong with stock upload',e);});case 2:case'end':return _context2.stop();}}},_callee2,_this2);})),_this.editStock=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return _this.setState({disabled:false});case 2:case'end':return _context3.stop();}}},_callee3,_this2);})),_this.updateStock=function(qty,id){var nStock=_this.state.stock.filter(function(stock){return stock.referenceId!==id;});_this.setState({stock:[].concat(_toConsumableArray(nStock),[{id:_this.state.store.id,referenceId:id,quantity:qty}])});},_this.addFormData=function(data){_this.setState({search:data.value});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Stock,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(_ref5){var _this3=this;var data=_ref5.data;if(data!==this.props.data){if(!data.success){this.setState({references:data[0].entries,store:{label:data[0].label,type:data[0].type,id:data[0].id}},function(){_this3.hasFirstStore();});}else{this.setState({error:data.error});}}}},{key:'render',value:function render(){var _this4=this;var _state=this.state,references=_state.references,store=_state.store,first=_state.first,disabled=_state.disabled,search=_state.search;var _props=this.props,role=_props.role,isReady=_props.isReady;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:Object(__WEBPACK_IMPORTED_MODULE_3__styles__["_54" /* StockStyle */])(isReady)+' stock',ref:function ref(elt){return _this4.stockPrint=elt;}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["_19" /* UserNav */],null),ROLE.indexOf(role)!==-1?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'transition '+(isReady?'transition--ready':'')},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'stock-filter flex no-print'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'stock-search'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["x" /* Field */],{type:'text',onChange:this.addFormData,id:'search-model',name:'search-model',value:''},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["_1" /* Search */],{width:24,height:24}),' Search by model ')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'stock-zone'},store.type==='store'?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["_10" /* Store */],{width:40,height:40}):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["H" /* Localisation */],{width:40,height:40}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,' ',store.label,' '))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'print-head only-print'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["I" /* Logo */],{nClass:'logo',width:'359',height:'28'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'print-head-title'},' Store\'s stock')),references.filter(function(item){return item.model.toLowerCase().match(search.toLowerCase());}).length>0&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'stock-table',ref:function ref(elt){return _this4.eltTable=elt;}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'head flex'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'head-item picture'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'head-item ref'},' Reference'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'head-item model'},' Model'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'head-item material'},' Case Materials'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'head-item desc'},' Description'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'head-item price'},' Price in Chf '),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'head-item quantity'},' Quantity')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'stock-body'},references.filter(function(item){return item.model.toLowerCase().match(search.toLowerCase());}).map(function(item){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:Object(__WEBPACK_IMPORTED_MODULE_3__styles__["_53" /* StockLineStyle */])(item.picture,first,disabled)+' '+(item.quantity===0?'no-stock':'')+' stock-line flex',key:item.referenceId},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'body-item picture'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'body-item ref'},' ',item.reference,' '),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'body-item model'},' ',item.model,' '),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'body-item material'},' ',item.materials,' '),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'body-item desc'},' ',item.description,' '),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'body-item price'},' ',item.price,' '),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'body-item quantity'},first||!first&&!disabled&&STORE_EDIT.indexOf(role)!==-1?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["W" /* Quantity */],{updateQty:_this4.updateStock,id:item.referenceId,qty:item.quantity}):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'qty-number'},' ',item.quantity,' ')));})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'stock-button no-print'},first&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'tooltip flex items-center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'tooltip-label'},'Click here to generate your store\'s stock'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["d" /* Arrow */],{width:24,height:24})),STORE_EDIT.indexOf(role)!==-1&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["m" /* Button */],{type:'button',theme:'red',className:'btn btn-first-stock btn-edit',onCallback:this.sendStock},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["C" /* Generate */],{width:24,height:24}))),!first&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'tooltip flex items-center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'tooltip-label'},'Click here to edit or print your store\'s stock'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["d" /* Arrow */],{width:24,height:24})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["m" /* Button */],{type:'button',className:'btn btn-print',onCallback:this.printStock},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["Q" /* Print */],{width:24,height:24})),STORE_EDIT.indexOf(role)!==-1&&(disabled?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["m" /* Button */],{type:'button',theme:'red',className:'btn btn-edit',onCallback:this.editStock},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["s" /* Edit */],{width:24,height:24})):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["m" /* Button */],{type:'button',theme:'red',className:'btn btn-edit',onCallback:this.sendStock},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["_20" /* Valid */],{width:24,height:24})))))):'<p> You are not authorized to view this page. </p>');}}]);return Stock;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__hoc_withLoader__["a" /* withLoader */])(Object(__WEBPACK_IMPORTED_MODULE_5_react_redux__["b" /* connect */])(function(_ref6){var Session=_ref6.Session;return{role:Session.role};})(Stock),'/stock'));

/***/ }),
/* 500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_Router__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__hoc_withLoader__ = __webpack_require__(15);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Team=function(_Component){_inherits(Team,_Component);function Team(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Team);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Team.__proto__||Object.getPrototypeOf(Team)).call.apply(_ref,[this].concat(args))),_this),_this.state={categories:[],users:[],userReady:false,filter:''},_this.update=function(){_this.setState({filter:_this.props.match.params.filter?_this.props.match.params.filter:'',userReady:true});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Team,[{key:'componentDidMount',value:function componentDidMount(){this.update();}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(_ref2){var _this2=this;var data=_ref2.data,location=_ref2.location;if(this.props.location.pathname!==location.pathname){this.setState({userReady:false});this.timer=setTimeout(function(){_this2.update();},400);}if(data!==this.props.data){var nCategories=[];var i=0;data.categories.map(function(cat,index){nCategories.push({slug:cat.name.toLowerCase(),label:cat.name});i=index;if(i===data.categories.length-1){_this2.setState({categories:nCategories,users:data.members});}});}}},{key:'componentWillUnmount',value:function componentWillUnmount(){clearTimeout(this.timer);}},{key:'render',value:function render(){var isReady=this.props.isReady;var _state=this.state,categories=_state.categories,users=_state.users,userReady=_state.userReady,filter=_state.filter;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'team '+Object(__WEBPACK_IMPORTED_MODULE_3__styles__["_61" /* TeamStyle */])(userReady)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components__["_19" /* UserNav */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'transition '+(isReady?'transition--ready':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'team-filter'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components__["_7" /* SimpleFilter */],{filters:categories,parentPath:__WEBPACK_IMPORTED_MODULE_2__services_Router__["a" /* default */].team.exactPath})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fluid'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'teams-inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,' ',filter!==''?filter:"Sales Marketing",' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'flex'},users.filter(function(user){return filter===user.team_category.toLowerCase()||filter===''&&user.team_category==='Sales Marketing';}).map(function(user,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components__["_12" /* TeamCard */],{user:user,key:index});}))))));}}]);return Team;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4__hoc_withLoader__["a" /* withLoader */])(Team,'/brand/company/team',false,false));

/***/ }),
/* 501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_Router__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__hoc_withLoader__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_ApiController__ = __webpack_require__(10);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Thefts=function(_Component){_inherits(Thefts,_Component);function Thefts(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,Thefts);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Thefts.__proto__||Object.getPrototypeOf(Thefts)).call.apply(_ref,[this].concat(args))),_this),_this.state={results:[],ref:'',models:'',lists:[],ready:true,error:''},_this.updateModels=function(data){_this.setState({models:data});},_this.addSerialNumber=function(data){_this.setState({ref:data.value});},_this.getResult=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(e){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:e.preventDefault();_this.setState({ready:false});if(_this.state.ref!==''&&_this.state.models!==''){Object(__WEBPACK_IMPORTED_MODULE_7__services_ApiController__["fetchThefts"])(_this.state.models,_this.state.ref).then(function(data){_this.setState({results:data.results?data.results:[],ready:true,error:!data.results||data.results&&data.results.length>0?'':'No results'});}).catch(function(e){console.log('Something wrong with thefts...');});}else{_this.setState({error:'Model and Serial Number are required !',ready:true});}case 3:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref2.apply(this,arguments);};}(),_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Thefts,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(_ref3){var data=_ref3.data;if(data!==this.props.data){this.setState({lists:data.models});}}},{key:'render',value:function render(){var _state=this.state,results=_state.results,lists=_state.lists,ready=_state.ready,error=_state.error;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'thefts page-inner '+__WEBPACK_IMPORTED_MODULE_5__styles__["_65" /* TheftsStyle */]},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["_19" /* UserNav */],null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'thefts-nav'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('ul',{className:'reset '+__WEBPACK_IMPORTED_MODULE_5__styles__["o" /* ButtonRouter */]+' flex'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["c" /* NavLink */],{to:__WEBPACK_IMPORTED_MODULE_4__services_Router__["a" /* default */].counterfeits.path,exact:true},' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Counterfeits'),' ')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["c" /* NavLink */],{to:__WEBPACK_IMPORTED_MODULE_4__services_Router__["a" /* default */].thefts.path,exact:true},' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Thefts'),' ')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'theft-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h2',null,'Search a stolen watch'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('form',{className:'flex'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'theft-select'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["_5" /* SelectDropdown */],{label:'Select a model',lists:lists,callback:this.updateModels})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'theft-ref'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["x" /* Field */],{onChange:this.addSerialNumber,type:'text',id:'serial-number',name:'serial-number',value:'',className:''},' Serial Number (ex: 4492) ')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'theft-submit'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{type:'submit',className:'btn-submit reset',onClick:this.getResult},' Search '))),results.length===0&&error&&error!==''&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["t" /* Error */],null,error),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'theft-result'},!ready&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'theft-result__loader'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["F" /* Load */],{width:24,height:24})),results&&results.length>0&&results.map(function(result,index){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["c" /* AlertCard */],Object.assign({},result,{title:''+result.model,slug:'/thefts/'+result.id,key:index}));}))));}}]);return Thefts;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__hoc_withLoader__["a" /* withLoader */])(Thefts,'/alerts/thefts'));

/***/ }),
/* 502 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_ApiController__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_actions_Session__ = __webpack_require__(39);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var User=function(_Component){_inherits(User,_Component);function User(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,User);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=User.__proto__||Object.getPrototypeOf(User)).call.apply(_ref,[this].concat(args))),_this),_this.state={editPass:false,editStore:false,token:'',formData:{},error:'',success:'',storeName:'',storeID:'',stores:[],picture:'',pictReady:false},_this.getStore=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_5__services_ApiController__["fetchPage"])('/change-store').then(function(data){if(data.success){_this.setState({stores:data.stores,storeName:data.stores[_this.props.store],storeID:_this.props.store,picture:_this.props.picture,pictReady:true});}}).catch(function(){console.log('Oops something wrong with the store');});case 2:case'end':return _context.stop();}}},_callee,_this2);})),_this.changeStore=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return _this.setState({editStore:true});case 2:case'end':return _context2.stop();}}},_callee2,_this2);})),_this.changePassword=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return _this.setState({editPass:true});case 2:case'end':return _context3.stop();}}},_callee3,_this2);})),_this.requestSore=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.next=2;return Object(__WEBPACK_IMPORTED_MODULE_5__services_ApiController__["updateProfile"])(_this.props.urls.updateStore,{store:_this.state.storeID}).then(function(data){if(data.success)_this.setState({editStore:false,storeName:_this.state.stores[_this.state.storeID]});}).catch(function(e){console.log('Whooops something wrong with user picture');});case 2:case'end':return _context4.stop();}}},_callee4,_this2);})),_this.requestPassword=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(){var formData;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:formData=_this.state.formData;if(!(formData['changePassword[plainPassword][first]']===formData['changePassword[plainPassword][second]'])){_context5.next=6;break;}_context5.next=4;return Object(__WEBPACK_IMPORTED_MODULE_5__services_ApiController__["updateProfile"])(_this.props.form.action,_this.state.formData).then(function(data){if(data.error&&data.error!=='')_this.setState({error:data.error});if(data.success&&data.success!==''){_this.setState({success:'Password changed',editPass:false});}}).catch(function(err){console.log(err);});case 4:_context5.next=8;break;case 6:_context5.next=8;return _this.setState({error:'You must have the same password'});case 8:case'end':return _context5.stop();}}},_callee5,_this2);})),_this.requestUpload=function(){var _ref7=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(picture){var formData;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:formData=new FormData();formData.append('file',picture);_context6.next=4;return Object(__WEBPACK_IMPORTED_MODULE_5__services_ApiController__["postFile"])(_this.props.urls.updatePicture,formData).then(function(data){if(data.success){_this.setState({picture:data.picture});_this.props.setPicture(data.picture);}}).catch(function(e){console.log('Whooops something wrong with user picture',e);});case 4:case'end':return _context6.stop();}}},_callee6,_this2);}));return function(_x){return _ref7.apply(this,arguments);};}(),_this.requestLogout=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:_context7.next=2;return _this.props.logOut();case 2:case'end':return _context7.stop();}}},_callee7,_this2);})),_this.handlerChangeStore=function(e){_this.setState({storeID:e.currentTarget.value});},_this.addFormData=function(data){var formData=_this.state.formData;var row=[];row[data.key]=data.value;_this.setState({formData:Object.assign({},formData,row)});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(User,[{key:'componentDidMount',value:function componentDidMount(){this.getStore();}},{key:'render',value:function render(){var _this3=this;var _props=this.props,role=_props.role,username=_props.username,form=_props.form;var _state=this.state,editPass=_state.editPass,editStore=_state.editStore,error=_state.error,success=_state.success,storeName=_state.storeName,stores=_state.stores,storeID=_state.storeID,pictReady=_state.pictReady,picture=_state.picture;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:Object(__WEBPACK_IMPORTED_MODULE_4__styles__["_69" /* UserInformationStyle */])(picture!==''?picture:this.props.picture,pictReady)+' user-information'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["_19" /* UserNav */],null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'user-form-edit'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'flex'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'user-form-edit-picture'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'picture'},' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["F" /* Load */],{width:24,height:24}),' '),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('form',{ref:function ref(form){return _this3.uploadForm=form;}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["_17" /* UploadFile */],{accept:'.jpg,.png,.gif,.jpeg',value:picture,uploadCallback:this.requestUpload,name:'upload-profile',id:'upload-profile-picture'},' Edit Profile '))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'user-form-edit-information'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'flex form-row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'label'},'Name'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'information'},username)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'flex form-row pass-row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'label'},'Password'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'information'},editPass?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["x" /* Field */],{type:'password',onChange:this.addFormData,id:form.fields.oldPassword.id,name:form.fields.oldPassword.name,value:''},' Old password '),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["x" /* Field */],{type:'password',onChange:this.addFormData,id:form.fields.plainPassword.id+'$first',name:form.fields.plainPassword.name+'[first]',value:''},'New Password '),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["x" /* Field */],{type:'password',onChange:this.addFormData,id:form.fields.plainPassword.id+'$second',name:form.fields.plainPassword.name+'[second]',value:''},'Confirm new Password '),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["x" /* Field */],{type:'hidden',onChange:this.addFormData,id:form.fields['_token'].id,name:form.fields['_token'].name,value:form.fields['_token'].value}),error&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'alert'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["t" /* Error */],{className:'error'},error)),success!==''&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'alert'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["_11" /* Success */],null,success))):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'password',name:'password',disabled:true,value:'toto1234'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'button'},editPass?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["m" /* Button */],{type:'button',className:'btn btn-edit btn-request-pass',onCallback:this.requestPassword},'Valid'):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["m" /* Button */],{type:'button',className:'btn btn-edit',onCallback:this.changePassword},'Edit'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["m" /* Button */],{type:'button',className:'btn btn-logout logout-btn',onCallback:this.requestLogout},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["_18" /* User */],{width:24,height:24}),' Log out')))));}}]);return User;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function(_ref9){var Session=_ref9.Session;return{username:Session.username,role:Session.role,urls:Session.urls,form:Session.forgotForm,store:Session.store,picture:Session.picture};},function(dispatch){return{setPicture:function setPicture(file){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__store_actions_Session__["h" /* updateProfilePicture */])(file));},logOut:function logOut(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__store_actions_Session__["g" /* logOut */])());}};})(User));

/***/ }),
/* 503 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_Router__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_ApiController__ = __webpack_require__(10);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Theft=function(_Component){_inherits(Theft,_Component);function Theft(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,Theft);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Theft.__proto__||Object.getPrototypeOf(Theft)).call.apply(_ref,[this].concat(args))),_this),_this.state={fields:[],ready:false},_this.getData=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_6__services_ApiController__["fetchPage"])('/alerts/theft/'+_this.props.match.params.slug).then(function(data){var fields=[{type:'text',id:'models',name:'models',value:data.model,label:'Models'},// {
//   type: 'text',
//   id: 'date',
//   name: 'date',
//   value: data.date,
//   label: 'Date',
// },
// {
//   type: 'text',
//   id: 'reported_date',
//   name: 'reported_date',
//   value: data.reportedTo,
//   label: 'Reported Date',
// },
{type:'text',id:'reference',name:'reference',value:data.reference,label:'Reference'},{type:'text',id:'description',name:'description',value:data.description,label:'Description'},{type:'text',id:'serial_number',name:'serial_number',value:data.serialNumber,label:'Serial Number'},{type:'text',id:'status',name:'status',value:data.status,label:'Status'}];_this.setState({fields:fields,ready:true});}).catch(function(e){console.log('Ooops something wrong with Question',e);});case 2:case'end':return _context.stop();}}},_callee,_this2);})),_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Theft,[{key:'componentDidMount',value:function componentDidMount(){this.getData();}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(_ref3){var data=_ref3.data;if(data!==this.props.data){// this.setState({
// })
}}},{key:'render',value:function render(){var _state=this.state,fields=_state.fields,ready=_state.ready;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'theft page-inner '+__WEBPACK_IMPORTED_MODULE_5__styles__["_64" /* TheftSoloStyle */]},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["_19" /* UserNav */],null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'thefts-nav'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('ul',{className:'reset '+__WEBPACK_IMPORTED_MODULE_5__styles__["o" /* ButtonRouter */]+' flex '},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["c" /* NavLink */],{to:__WEBPACK_IMPORTED_MODULE_4__services_Router__["a" /* default */].counterfeits.path,exact:true},' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Counterfeits'),' ')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["c" /* NavLink */],{to:__WEBPACK_IMPORTED_MODULE_4__services_Router__["a" /* default */].thefts.path},' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Thefts'),' ')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'theft-form'},!ready&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'content-loader'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["F" /* Load */],{width:24,height:24})),fields.map(function(field,index){return field.type==='text'?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["x" /* Field */],Object.assign({disabled:true},field,{key:index}),' ',field.label,' '):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["_13" /* Textarea */],Object.assign({disabled:true},field,{key:index}),' ',field.label,' ');})));}}]);return Theft;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Theft);

/***/ }),
/* 504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(62);
/* harmony default export */ __webpack_exports__["a"] = (function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1____["r" /* Page */],{title:'Legal Info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'User is made aware and acknowledges that the materials (data, pictures, trademarks, slogans and more broadly information and documents posted on \u201CLe BrandCenter\u201D website) are covered by intellectual property rights and shall remain the sole property of RICHARD MILLE Group \u2013 HOROMETRIE S.A. RICHARD MILLE \u2013 HOROMETRIE S.A. owns and shall continue to retain the rights, title and interest in its own intellectual property including, without limitation as contained in patent applications, inventions, discovery, process, art, method, know-how, trade secrets, product trademarks, service trademarks, commercial brand names, design, copyright and other intellectual property rights, whether or not patentable, existing in relation with the information, pictures, materials, documents, products and inventions displayed on \u201CLe BrandCenter\u201D website.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'User agrees that he will use such information only to the extend necessary for the purpose of which he accessed to the \u201CLe BrandCenter\u201D website and that no right of any kind nor license of any kind is either granted or implied by the access to such information, material and other documents posted on \u201CLe BrandCenter\u201D website.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Consequently, user shall prevent himself from copying or having copied any of such information, nor to disclose or spread it to the public.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'No permission is granted to print, copy, reproduce, distribute, transmit, upload, download, store, perform, display in public, alter, or modify the content contained on or in this website.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'ALL BRAND NAMES, TRADEMARKS AND PERSONAL NAMES ARE PROPERTY OF THEIR RESPECTIVE OWNERS WHICH IS EXPRESSLY RESERVED AND PROTECTED.'));});

/***/ }),
/* 505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(62);
/* harmony default export */ __webpack_exports__["a"] = (function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1____["r" /* Page */],{title:'Privacy'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'We consider that by using the \xAB Le BrandCenter \xBB you shall provide us only with professional information related to the e-learning services you are provided you with within the fulfilment of your contractual obligations towards RICHARD MILLE Group.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Nevertheless, in the improbable case you would provide us with personal information, you shall know that we respect the confidentiality of any such information. Consequently, the same personal data policy that applies to the www.richardmille.com Website shall also apply to the \u201CLe BrandCenter\u201D users and covers the processing of personal data you may provide us with in order to allow us to offer you the required e-learning services and features.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'The personal data processing is carried out in France at Paris by R.D.M.M. Concepts (RICHARD MILLE France) and in Switzerland at Les Breuleux by Horom\xE9trie S.A. a company of the RICHARD MILLE Group. The RICHARD MILLE\u2019s data processing policy is described hereunder.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'By providing us with personal data according to that data processing policy, you express your acceptance of it and your consent to the data processing it describes.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'User data will be collected during user visits and according to his/her interaction with the services and features offered on the Website. At any time, the user may exercise his/her rights in compliance with the law.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'Data use and transfer'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'The personal data you provide us with, for example in an order or by email (for example, your name and address or email address), are processed solely for correspondence with you and solely for the purpose for which you have provided these data, which is managing contractual relations with you and fulfil relevant legal obligations.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'We hereby confirm that we will not pass on your personal data to other third parties excepted for their processing in Les Breuleux Switzerland by Horom\xE9trie S.A. a company of RICHARD MILLE Group, unless we are legally required to do so or you have previously given us your express permission. To the extent that we make use of service companies to carry out and process administrative tasks, contractual relations are regulated in compliance with the provisions of EU\u2019s Data Protection Law.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'R.D.M.M. Concepts (RICHARD MILLE France) is the data controller and the data processing respondent according to GDPR.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'Consent and revocation'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'By providing us with personal data, you express your acceptance to their aforementioned processing.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'If you have provided us with personal data, you may revoke your consent, and can modify and/or delete them at any time, by writing to privacy@richardmille.com or by post to 45 Rue Boissy d\u2019Anglas, 75008 Paris, France.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'Storage period'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Personal data conveyed to us through our website are stored only until the purpose for which they were conveyed is fulfilled and for the length of time needed to achieve it. Data collected for contract management will be retained for the time period necessary for the performance of the contract, with legal and conventional guarantees provided for, or in accordance with obligatory legal terms regarding the retention of data. If storage periods are stipulated by trade law or tax law, a secured storage of particular data can last up to 10 years.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'Data security'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'In the ordering process, your personal data are transmitted by means of SSL via the Internet. We carry out technical and organizational measures to secure our website and other storage systems to prevent loss, destruction, access, or change to your data by unauthorized persons.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'Use of cookies'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'We use cookies on various pages to make a visit to our website more attractive and to enable the use of certain functions. Cookies are small text files deposited on your computer. Most of the cookies we use are deleted from your hard disk after the end of a browser session (\u201Csession cookies\u201D). Other cookies may remain on your computer and enable us to recognize your computer when you next visit our website (\u201Cpermanent cookies\u201D). Our partner companies are not permitted to use our cookies and our website to gather, process, or use personal data.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'Your rights, information'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'If you no longer agree to the storage of your personal data or if these data are no longer correct, upon receiving your corresponding request we will have your data deleted or blocked or carry out the necessary corrections (to the extent that this is permissible under valid law). Upon request and at no charge, we will inform you about all personal data about you that we have stored.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'If you have questions about the gathering, processing, or use of your personal data or if you want to provide information or corrections or to block or delete data, please contact us by email at privacy@richardmille.com'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'Google Analytics'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'This website uses Google Analytics, a web analysis service provided by Google Inc., 1600 Amphitheatre Parkway, Mountain View, CA 94043, USA (\u201CGoogle\u201D).'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Google Analytics uses so-called \u201Ccookies\u201C, text files that are stored on your computer and allow an analysis to be performed of your Richard Mille\u2019s website usage. The information generated by the cookie about your usage of this website (including your IP address), is transferred to a Google server in the US and stored there. Google uses the stored information to evaluate your usage of Richard Mille\u2019s website, to compile reports about activities performed on this website for the website operator and in order to provide further services related to said website and internet usage.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Google also transfers this information to third parties when necessary, for example if it is legally required or in the case that third parties are commissioned by Google to process this data. Google never links your IP address to other Google data. You can prevent installation of the cookies by adjusting an appropriate setting in your browser software; however, we would like to advise you that you may not be able to use all functions of this website to their full extent in this case. By using this website, you agree for the data recorded on you by Google in the aforementioned manner to be processed and agree to the aforementioned purpose.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'You can stop your data from being collected in future at any time by using the desactivation addon for Google Analytics browsers at http://tools.google.com/dlpage/gaoptout?hl=en. You can also prevent your data being recorded by Google Universal Analytics by clicking on the following link: https://tools.google.com/dlpage/gaoptout/eula.html?hl=en. An opt-out cookie will be set, which prevents your data from being recorded in future when you visit Richard Mille\u2019s website: Desactivate Google Analytics. We would like to advise you that this website uses Google Analytics with the extension \u201C_anonymizeIp()\u201D. This means IP addresses are only stored in an anonymous form; any direct reference to a specific person in relation to the stored data is therefore excluded. Third parties, including Google, use the stored cookies to place advertisements not related to Richard Mille\u2019s products on the basis of your previous visits to Richard Mille\u2019s website. If you do not wish for this to happen, you can deactivate this via the ad settings manager http://www.google.com/settings/ads/onweb/?hl=en&.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'For more detailed information on user conditions and data protection, please visit http://www.google.com/analytics/terms/us.html.'));});

/***/ }),
/* 506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hoc_withLoader__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Training=function(_Component){_inherits(Training,_Component);function Training(){_classCallCheck(this,Training);return _possibleConstructorReturn(this,(Training.__proto__||Object.getPrototypeOf(Training)).apply(this,arguments));}_createClass(Training,[{key:'componentDidMount',value:function componentDidMount(){document.body.classList.add('nofooter');}},{key:'componentWillUnmount',value:function componentWillUnmount(){document.body.classList.remove('nofooter');}},{key:'render',value:function render(){var data=this.props.data;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'training '+__WEBPACK_IMPORTED_MODULE_3__styles__["_66" /* TrainingStyle */]},data&&data.summary.map(function(panel,index){return panel.type==='videos'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components__["_22" /* Videos */],{title:panel.title,groups:panel.fields.groups,picture:panel.picture,key:index});}));}}]);return Training;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__hoc_withLoader__["a" /* withLoader */])(Training));

/***/ }),
/* 507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__hoc_withLoader__ = __webpack_require__(15);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CatalogEvent=function(_Component){_inherits(CatalogEvent,_Component);function CatalogEvent(){_classCallCheck(this,CatalogEvent);return _possibleConstructorReturn(this,(CatalogEvent.__proto__||Object.getPrototypeOf(CatalogEvent)).apply(this,arguments));}_createClass(CatalogEvent,[{key:'render',value:function render(){var _props=this.props,isReady=_props.isReady,data=_props.data;if(data){data.pages.sort(function(a,b){return a.title>b.title?1:b.title>a.title?-1:0;});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_2__styles__["u" /* CatalogStyle */]+' catalog'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'page-inner transition '+(isReady?'transition--ready':'')},data&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'catalog-list'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components__["S" /* ProductList */],{products:data.pages}))));}}]);return CatalogEvent;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3__hoc_withLoader__["a" /* withLoader */])(CatalogEvent));

/***/ }),
/* 508 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__hoc_withLoader__ = __webpack_require__(15);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Interviews=function(_Component){_inherits(Interviews,_Component);function Interviews(){_classCallCheck(this,Interviews);return _possibleConstructorReturn(this,(Interviews.__proto__||Object.getPrototypeOf(Interviews)).apply(this,arguments));}_createClass(Interviews,[{key:'render',value:function render(){var _props=this.props,isReady=_props.isReady,data=_props.data;if(data){data.pages.sort(function(a,b){return a.title>b.title?1:b.title>a.title?-1:0;});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_2__styles__["u" /* CatalogStyle */]+' catalog'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'page-inner transition '+(isReady?'transition--ready':'')},data&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'catalog-list'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components__["S" /* ProductList */],{products:data.pages}))));}}]);return Interviews;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3__hoc_withLoader__["a" /* withLoader */])(Interviews));

/***/ }),
/* 509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__hoc_withLoader__ = __webpack_require__(15);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var InDepth=function(_Component){_inherits(InDepth,_Component);function InDepth(){_classCallCheck(this,InDepth);return _possibleConstructorReturn(this,(InDepth.__proto__||Object.getPrototypeOf(InDepth)).apply(this,arguments));}_createClass(InDepth,[{key:'render',value:function render(){var _props=this.props,isReady=_props.isReady,data=_props.data;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_2__styles__["u" /* CatalogStyle */]+' catalog'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'page-inner transition '+(isReady?'transition--ready':'')},data&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'catalog-list'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components__["S" /* ProductList */],{products:data.pages}))));}}]);return InDepth;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3__hoc_withLoader__["a" /* withLoader */])(InDepth));

/***/ }),
/* 510 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_emotion__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__static_rm_charity_org_jpg__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__static_rm_charity_org_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__static_rm_charity_org_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_ApiController__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_datepicker__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dateInputTypeTe;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var pattern=/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;var Style=Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["a" /* css */])({'.charity':{'&-inner':{padding:'2rem',display:'flex',flexDirection:'column',justifyContent:'center',alignItems:'center',maxWidth:1088,margin:'0 auto','@media (min-width: 768px)':{padding:'4rem'},'.btn-reload':{display:'inline-block',background:'black',width:'200px',color:'white',border:0,textTransform:'uppercase',fontWeight:800,fontFamily:__WEBPACK_IMPORTED_MODULE_6__styles__["Q" /* Font */].base,letterSpacing:'0.125rem',height:60,transition:'all 400ms ease',cursor:'pointer',margin:'1rem 0px'},'.text-center':{textAlign:'center'},'.btn-expand':{textTransform:'uppercase',color:__WEBPACK_IMPORTED_MODULE_6__styles__["x" /* Colors */].grey,fontSize:'0.75rem',letterSpacing:'2.5px',padding:0,border:0,fontFamily:__WEBPACK_IMPORTED_MODULE_6__styles__["Q" /* Font */].base,fontWeight:800,background:'none'}},'&-title':{color:'black',fontSize:'2rem',textTransform:'uppercase','&:after':{content:"''",display:"block",width:50,height:4,background:'black',margin:'1rem auto'}},'&-picture':{// maxWidth: 100%,
display:'flex',justifyContent:'center',alignItems:'flex-start',maxHeight:270,overflow:'hidden','img':{maxWidth:'100%','@media (min-width: 768px)':{transform:'translateY(-60px)'}}},'&-description':{color:'black',fontSize:'0.9375rem',fontWeight:600,'span':{color:__WEBPACK_IMPORTED_MODULE_6__styles__["x" /* Colors */].red}},'&-bottom':{color:'black',fontSize:'0.9375rem',fontStyle:'italic',fontWeight:200,'p > a':{color:'black'}},'&-mandatory':{color:__WEBPACK_IMPORTED_MODULE_6__styles__["x" /* Colors */].red,fontSize:'0.9375rem'},'&-container':{maxWidth:'100%','@media (min-width: 768px)':{padding:'0 3.6rem'}},'&-form':{'input[type="text"], input[type="text"] + label':{fontSize:'1.5rem'},'.dropdown-list':{zIndex:2},'.required-phone':{display:'flex',alignItems:'flex-end','.form-field':{maxWidth:'calc(100% - 110px)',flexBasis:'calc(100% - 110px)',width:'100%',marginLeft:10}},'.required-id':{width:100},'.required-location':{width:440},'.required-comment ':{'label':{fontWeight:400,zIndex:-1},'textarea':{height:60,fontSize:'0.875rem',fontWeight:600,marginTop:16}},'sup':{color:__WEBPACK_IMPORTED_MODULE_6__styles__["x" /* Colors */].red},'&-row':{margin:'1.5rem 0 3.5rem'},'.row':{display:'flex',flexDirection:'row',flexWrap:'wrap',justifyContent:'space-between'},'&-label':{textTransform:'uppercase',// marginBottom: '1rem',
fontWeight:800,fontFamily:__WEBPACK_IMPORTED_MODULE_6__styles__["Q" /* Font */].base,fontSize:'1rem',color:__WEBPACK_IMPORTED_MODULE_6__styles__["x" /* Colors */].grey},'&-full':{width:'100%'},'&-col':{width:'100%','@media (min-width: 768px)':{width:'calc(50% - 1rem)',maxWidth:'calc(50% - 1rem)',flexBasis:'calc(50% - 1rem)'}},'&-radio':{display:'flex',alignItems:'center'},'.dropdown-label':{textAlign:'left',fontSize:22},'.react-datepicker-wrapper, .react-datepicker-popper, .react-datepicker__input-container':{zIndex:2,width:'100%'},'.date input[type="text"]':(_dateInputTypeTe={fontSize:22,color:__WEBPACK_IMPORTED_MODULE_6__styles__["x" /* Colors */].dark,fontFamily:__WEBPACK_IMPORTED_MODULE_6__styles__["Q" /* Font */].base,width:'100%',zIndex:2},_defineProperty(_dateInputTypeTe,'width','100%'),_defineProperty(_dateInputTypeTe,'margin','0.3125rem 0px'),_defineProperty(_dateInputTypeTe,'padding','0.3125rem 0'),_defineProperty(_dateInputTypeTe,'background','none'),_defineProperty(_dateInputTypeTe,'border',0),_defineProperty(_dateInputTypeTe,'borderBottom','1px solid '+__WEBPACK_IMPORTED_MODULE_6__styles__["x" /* Colors */].lightGrey),_defineProperty(_dateInputTypeTe,'WebkitAppearance','none'),_defineProperty(_dateInputTypeTe,'@media (min-width: 1024px)',{padding:'0.625rem 0px'}),_defineProperty(_dateInputTypeTe,'&::placeholder',{color:__WEBPACK_IMPORTED_MODULE_6__styles__["x" /* Colors */].lightGrey}),_dateInputTypeTe),'&-bottom':{display:"flex",justifyContent:'space-between',flexWrap:'wrap','.btn':{background:__WEBPACK_IMPORTED_MODULE_6__styles__["x" /* Colors */].red,width:260,border:0,fontSize:'0.825rem',lineHeight:'1.2em',textTransform:'uppercase',fontFamily:__WEBPACK_IMPORTED_MODULE_6__styles__["Q" /* Font */].base,fontWeight:800,letterSpacing:'0.125rem',height:60,transition:'all 400ms ease',cursor:'pointer',margin:'1rem 0px',color:'white'}},'.is-error':{'input, label > span:before, .dropdown-label':{borderColor:__WEBPACK_IMPORTED_MODULE_6__styles__["x" /* Colors */].red+' !important'},'label, input::placeholder, label > span, .dropdown-label':{color:__WEBPACK_IMPORTED_MODULE_6__styles__["x" /* Colors */].red+' !important'}}},'&-radio':{marginRight:'1rem','input':{position:'absolute',width:'1px',height:'1px',padding:'0',margin:'-1px',overflow:'hidden',clip:'rect(0, 0, 0, 0)',border:0,'&:checked + span':{'&:after':{opacity:1}}},'label':{'span':{position:'relative',display:'flex',alignItems:'center',color:__WEBPACK_IMPORTED_MODULE_6__styles__["x" /* Colors */].grey,fontSize:22,'&:before':{display:'block',width:12,height:12,borderRadius:'50%',marginRight:8,border:'1px solid '+__WEBPACK_IMPORTED_MODULE_6__styles__["x" /* Colors */].grey,content:"''"},'&:after':{position:'absolute',width:8,height:8,top:'50%',left:3,background:'black',borderRadius:'50%',content:"''",transform:'translateY(-50%)',opacity:0}}},'&--check':{'label':{'span':{fontSize:'0.9375rem',color:'black',fontWeight:600,'i':{display:'inline-block',marginLeft:'10px',maxWidth:'calc(100% - 50px)'},'&:before, &:after':{borderRadius:0}}}}},'&-error':{fontSize:14,color:__WEBPACK_IMPORTED_MODULE_6__styles__["x" /* Colors */].red},'&-btn':{position:'relative',textAlign:'right'},'&-success':{color:'#0C7B2A',fontSize:18,textAlign:'center',fontWeight:800,textTransform:'uppercase'}}});var CharityForm=function(_Component){_inherits(CharityForm,_Component);function CharityForm(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,CharityForm);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=CharityForm.__proto__||Object.getPrototypeOf(CharityForm)).call.apply(_ref,[this].concat(args))),_this),_this.state={formData:_defineProperty({comments:'',gender:'',email:'',location:'',meetingDate:'',name:'',phone:'',postalAddress:'',preferredLanguage:'',referer:'',surname:'',country:'',title:'',token:'',refererGender:'',refererName:'',refererSurname:'',contactId:'',postalCode:'',city:'',phonePrefix:''},'token',''),form:{},wait:true,error:'',isSend:false,isExpand:false,consent:''},_this.getData=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var res;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_4__services_ApiController__["fetchDonator"])();case 2:res=_context.sent;if(res){_this.setState({formData:Object.assign({},_this.state.formData,{token:res.donator.token.value}),form:Object.assign({},res.donator),wait:false});}case 4:case'end':return _context.stop();}}},_callee,_this2);})),_temp),_possibleConstructorReturn(_this,_ret);}_createClass(CharityForm,[{key:'componentDidMount',value:function componentDidMount(){this.getData();}},{key:'handlerSubmit',value:function handlerSubmit(e){var _this3=this;e.preventDefault();var _state$formData=this.state.formData,title=_state$formData.title,surname=_state$formData.surname,name=_state$formData.name,phone=_state$formData.phone,email=_state$formData.email,referer=_state$formData.referer,meetingDate=_state$formData.meetingDate,location=_state$formData.location,contactId=_state$formData.contactId,refererName=_state$formData.refererName,refererSurname=_state$formData.refererSurname,country=_state$formData.country,refererGender=_state$formData.refererGender,gender=_state$formData.gender,phonePrefix=_state$formData.phonePrefix;this.setState({error:''});if(surname===''||name===''||phone===''||email===''||country===''||referer===''||meetingDate===''||location===''||this.state.consent===''||contactId===''||refererName===''||refererSurname===''||refererGender===''||gender===''||phonePrefix===''||title===''){this.setState({error:'Contact ID, Referer, Client meeting date, Referer name, Referer Surname(s), email, phone number and consent are required !'});this.isRequired(document.querySelector('.required-meeting'),'meetingDate');this.isRequired(document.querySelector('.required-referer'),'referer');this.isRequired(document.querySelector('.required-title'),'title');this.isRequired(document.querySelector('.required-refererGender'),'refererGender');this.isRequired(document.querySelector('.required-country'),'country');this.isRequired(document.querySelector('.required-surname'),'surname');this.isRequired(document.querySelector('.required-refererSurname'),'refererSurname');this.isRequired(document.querySelector('.required-name'),'name');this.isRequired(document.querySelector('.required-refererName'),'refererName');this.isRequired(document.querySelector('.required-phone'),'phone');this.isRequired(document.querySelector('.required-phone'),'phonePrefix');this.isRequired(document.querySelector('.required-email'),'email');this.isRequired(document.querySelector('.required-location'),'location');this.isRequired(document.querySelector('.required-consent'),'consent');this.isRequired(document.querySelector('.required-id'),'contactId');this.isRequired(document.querySelector('.required-gender'),'gender');}else if(!pattern.test(email)){document.querySelector('.required-email').classList.add('is-error');this.setState({error:' Email address is not valid'});}else{document.querySelector('.required-email').classList.remove('is-error');document.querySelector('.required-meeting').classList.remove('is-error');document.querySelector('.required-referer').classList.remove('is-error');document.querySelector('.required-country').classList.remove('is-error');document.querySelector('.required-surname').classList.remove('is-error');document.querySelector('.required-refererSurname').classList.remove('is-error');document.querySelector('.required-refererGender').classList.remove('is-error');document.querySelector('.required-name').classList.remove('is-error');document.querySelector('.required-refererName').classList.remove('is-error');document.querySelector('.required-phone').classList.remove('is-error');document.querySelector('.required-location').classList.remove('is-error');document.querySelector('.required-consent').classList.remove('is-error');document.querySelector('.required-id').classList.remove('is-error');document.querySelector('.required-title').classList.remove('is-error');document.querySelector('.required-gender').classList.remove('is-error');Object(__WEBPACK_IMPORTED_MODULE_4__services_ApiController__["submitDonator"])({donator:this.state.formData}).then(function(res){if(res.success){_this3.setState({isSend:true});}});}}},{key:'isRequired',value:function isRequired(row,key){row.classList.remove('is-error');if(this.state.formData[key]===''){row.classList.add('is-error');}}},{key:'reload',value:function reload(){document.location.reload();}},{key:'handleClickExpand',value:function handleClickExpand(){this.setState({isExpand:!this.state.isExpand});}},{key:'render',value:function render(){var _this4=this;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'charity '+Style},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'charity-inner'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h1',{className:'charity-title'},'DONATOR CONTACT FORM'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'charity-picture'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_3__static_rm_charity_org_jpg___default.a,alt:''})),!this.state.wait&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'charity-container'},!this.state.isSend&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('form',{className:'charity-form',onSubmit:function onSubmit(e){return _this4.handlerSubmit(e);}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'charity-description'},'Enter the following information and keep paper registration form for record (GDPR legislation). Client will be contacted by Paris Brain Institute team. ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Important: All fields must be filled in english.')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'charity-form-row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'charity-form-label'},'Referer ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('sup',null,'*')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'charity-form-third charity-form-radio required-referer'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'charity-radio'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'chartiy[referer][boutique]'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'radio',id:'chartiy[referer][boutique]',name:'chartiy[referer]',value:'boutique',onChange:function onChange(e){_this4.setState({formData:Object.assign({},_this4.state.formData,{referer:e.target.value})});}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Boutique'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'charity-radio'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'chartiy[referer][office]'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'radio',id:'chartiy[referer][office]',name:'chartiy[referer]',value:'office',onChange:function onChange(e){_this4.setState({formData:Object.assign({},_this4.state.formData,{referer:e.target.value})});}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Office')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'charity-form-third required-id'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components__["x" /* Field */],{type:'text',name:'chartiy[referer][ID]',onChange:function onChange(data){return _this4.setState({formData:Object.assign({},_this4.state.formData,{contactId:data.value})});}},' ID',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('sup',null,'*'),' ')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'charity-form-third required-location'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components__["x" /* Field */],{type:'text',name:'chartiy[referer][location]',onChange:function onChange(data){return _this4.setState({formData:Object.assign({},_this4.state.formData,{location:data.value})});}},'City and Country (e: Paris France)',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('sup',null,'*')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'charity-form-col charity-form-radio required-refererGender'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'charity-radio'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'charity[referer][gender][mr]'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'radio',id:'charity[referer][gender][mr]',name:'charity[referer][gender]',value:'Mr',onChange:function onChange(e){_this4.setState({formData:Object.assign({},_this4.state.formData,{refererGender:e.target.value})});}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Mr ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('sup',null,'*')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'charity-radio'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'charity[referer][gender][ms]'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'radio',id:'charity[referer][gender][ms]',name:'charity[referer][gender]',value:'Ms',onChange:function onChange(e){_this4.setState({formData:Object.assign({},_this4.state.formData,{refererGender:e.target.value})});}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Ms ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('sup',null,'*')))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'charity-form-col required-refererSurname'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components__["x" /* Field */],{type:'text',onChange:function onChange(data){return _this4.setState({formData:Object.assign({},_this4.state.formData,{refererName:data.value})});}},'First name ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('sup',null,'*'),' ')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'charity-form-col required-refererName'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components__["x" /* Field */],{type:'text',onChange:function onChange(data){return _this4.setState({formData:Object.assign({},_this4.state.formData,{refererSurname:data.value})});}},'Surname (s) ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('sup',null,'*'),' ')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'charity-form-row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'charity-form-label'},'Client meeting date ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('sup',null,'*')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'charity-form-col date required-meeting'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_datepicker___default.a,{selected:this.state.date,onChange:function onChange(date){return _this4.setState({formData:Object.assign({},_this4.state.formData,{meetingDate:__WEBPACK_IMPORTED_MODULE_8_moment__(date).format('DD/MM/YYYY')}),date:date});},placeholderText:'DD/MM/YYYY'})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'charity-form-row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'charity-form-label'},'Contact detail'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'charity-form-col charity-form-radio required-gender'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'charity-radio'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'charity[gender][mr]'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'radio',id:'charity[gender][mr]',name:'charity[gender]',value:'Mr',onChange:function onChange(e){_this4.setState({formData:Object.assign({},_this4.state.formData,{gender:e.target.value})});}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Mr ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('sup',null,'*')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'charity-radio'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'charity[gender][ms]'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'radio',id:'charity[gender][ms]',name:'charity[gender]',value:'Ms',onChange:function onChange(e){_this4.setState({formData:Object.assign({},_this4.state.formData,{gender:e.target.value})});}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Ms ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('sup',null,'*')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'charity-radio'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'charity[gender][mr-ms]'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'radio',id:'charity[gender][mr-ms]',name:'charity[gender]',value:'Mr-ms',onChange:function onChange(e){_this4.setState({formData:Object.assign({},_this4.state.formData,{gender:e.target.value})});}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Mr & Ms ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('sup',null,'*'))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'charity-form-col required-title'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components__["x" /* Field */],{type:'text',onChange:function onChange(data){return _this4.setState({formData:Object.assign({},_this4.state.formData,{title:data.value})});}},'Title ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('sup',null,'*'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'charity-form-col required-name'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components__["x" /* Field */],{type:'text',onChange:function onChange(data){return _this4.setState({formData:Object.assign({},_this4.state.formData,{name:data.value})});}},'First Name ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('sup',null,'*'),' ')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'charity-form-col required-surname'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components__["x" /* Field */],{type:'text',onChange:function onChange(data){return _this4.setState({formData:Object.assign({},_this4.state.formData,{surname:data.value})});}},'Surname(s) ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('sup',null,'*'),' ')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'charity-form-col'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components__["x" /* Field */],{type:'text',onChange:function onChange(data){return _this4.setState({formData:Object.assign({},_this4.state.formData,{postalAddress:data.value})});}},'Postal address ')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'charity-form-col'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components__["x" /* Field */],{type:'text',onChange:function onChange(data){return _this4.setState({formData:Object.assign({},_this4.state.formData,{postalCode:data.value})});}},'Postal code ')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'charity-form-col'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components__["x" /* Field */],{type:'text',onChange:function onChange(data){return _this4.setState({formData:Object.assign({},_this4.state.formData,{city:data.value})});}},'City ')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'charity-form-col required-country'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components__["x" /* Field */],{type:'text',onChange:function onChange(data){return _this4.setState({formData:Object.assign({},_this4.state.formData,{country:data.value})});}},'Country ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('sup',null,'*'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'charity-form-col required-email'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components__["x" /* Field */],{type:'text',onChange:function onChange(data){return _this4.setState({formData:Object.assign({},_this4.state.formData,{email:data.value})});}},'Email ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('sup',null,'*'),' ')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'charity-form-col required-phone'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components__["_6" /* SelectPhone */],{label:'',callback:function callback(data){return _this4.setState({formData:Object.assign({},_this4.state.formData,{phonePrefix:data})});}},'--',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('sup',null,'*')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components__["x" /* Field */],{type:'text',onChange:function onChange(data){return _this4.setState({formData:Object.assign({},_this4.state.formData,{phone:data.value})});}},'Phone number ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('sup',null,'*'),' ')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'charity-form-col'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components__["_4" /* SelectCountries */],{label:'Prefered language',callback:function callback(data){return _this4.setState({formData:Object.assign({},_this4.state.formData,{preferredLanguage:data})});}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,'If we are not able to honor the preferred language, the client will automatically be contacted in English.')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'charity-form-full required-comment'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components__["_13" /* Textarea */],{onChange:function onChange(data){return _this4.setState({formData:Object.assign({},_this4.state.formData,{comments:data.value})});}},'Comments '))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'charity-form-row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'charity-form-full required-consent'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'charity-radio charity-radio--check'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'charity[consent]'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'checkbox',id:'charity[consent]',name:'charity[consent]',value:'1',onChange:function onChange(e){_this4.setState({consent:e.target.value});}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',null,'In the context of the amended French Data Protection Act and European regulations, by ticking this box, you declare that you have actually received the informed consent of the customer on the processing of his personal data and are able to provide proof of this consent. ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('sup',null,'*')))))))),!this.state.isExpand?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'charity-bottom'},'The information collected on this form is collected and recorded in a computerised file by the sales staff of the Richard MILLE stores on behalf of the company RDMM CONCEPTS, data controller, whose head office is located 1 rue de la Manutention \u2013 75116 Paris \u2013 France. Represented by Mr Richard MILLE. ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),'The legal basis of the treatment is the client\u2019s consent.'):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'charity-bottom--expand'},'The information collected on this form is collected and recorded in a computerised file by the sales staff of the Richard MILLE stores on behalf of the company RDMM CONCEPTS, data controller, whose head office is located 1 rue de la Manutention \u2013 75116 Paris \u2013 France. Represented by Mr Richard MILLE.',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),'The legal basis of the treatment is the client\u2019s consent.',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),'The purpose of the treatment is to build up a file of Richard MILLE clients who are concerned about the cause of the Paris Brain Institute (\u201CICM\u201D) and who wish to become members of the Richard Mille Donors\u2019 Club. The data collected is shared with the ICM.',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),'The data collected will be communicated to the following recipients only: Richard Mille staff and partners; ICM staff in charge of fundraising.',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),'The data will be kept for 3 years from the last contact or until the consent\u2019s withdraw.',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),'In accordance with the amended French Data Protection Act and European regulations, you may withdraw your consent at any time. You have a right of access to your data, a right of rectification, a right to limit processing, a right of opposition, portability and deletion. In addition, you can define guidelines on the fate of your data after your death. You can exercise your rights by contacting RDMM Concepts [1 rue de la Manutention, 75116 Paris, France] or the Data Protection Officer by e-mail ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'mailto:privacy@richardmille.com',target:'_blank'},'privacy@richardmille.com'),'. You also have the right to lodge a complaint with a supervisory authority, the CNIL in France.'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{type:'button',className:'btn btn-expand',onClick:function onClick(){return _this4.handleClickExpand();}},!this.state.isExpand?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'View more'):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'View less')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'charity-form-bottom'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'charity-mandatory'},'*mandatory'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'charity-btn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{type:'submit',className:'btn btn-submit'},'Send'),this.state.error!==''&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'charity-error'},this.state.error)))),this.state.isSend&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{'class':'text-center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'charity-success'},'Registration confirmed. ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),'Your client will be contacted shortly by Paris Brain institute team.'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{type:'button',className:'btn btn-reload',onClick:function onClick(){return _this4.reload();}},'New Registration')))));}}]);return CharityForm;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (CharityForm);

/***/ }),
/* 511 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_emotion__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__static_rm_charity_org_jpg__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__static_rm_charity_org_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__static_rm_charity_org_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_ApiController__ = __webpack_require__(10);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Style=Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])({'.charity':{'&-inner':{padding:'2rem 1.25rem',display:'flex',flexWrap:'wrap',justifyContent:'center','@media (max-width: 1023px)':{'.card':{maxWidth:'50%',flexBasis:'50%',minWidth:'1px',padding:'.5rem'}},'.card-info':{minHeight:140},'@media (min-width: 1024px)':{padding:'4rem'}}}});var CharityCatalog=function(_Component){_inherits(CharityCatalog,_Component);function CharityCatalog(){var _ref;var _temp,_this,_ret;_classCallCheck(this,CharityCatalog);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=CharityCatalog.__proto__||Object.getPrototypeOf(CharityCatalog)).call.apply(_ref,[this].concat(args))),_this),_this.state={data:[]},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(CharityCatalog,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;Object(__WEBPACK_IMPORTED_MODULE_6__services_ApiController__["fetchCharity"])().then(function(res){_this2.setState({data:res.pages});});}},{key:'render',value:function render(){console.log(this.state.data);return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'charity '+Style},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'charity-inner'},this.state.data.length>0&&this.state.data.map(function(item){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components__["n" /* Card */],{title:item.title,cover:item.cover,card_picture:item.card_picture,slug:item.slug,is_bookmark:item.is_bookmark,slug_bookmark:item.slug_bookmark,type:item.type,key:item.id,shadow:true,category:null,label:'discover'});}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components__["n" /* Card */],{title:'CLIENT REGISTER FORM',cover:__WEBPACK_IMPORTED_MODULE_3__static_rm_charity_org_jpg___default.a,card_picture:__WEBPACK_IMPORTED_MODULE_3__static_rm_charity_org_jpg___default.a,slug:'/brand/charity/contact',is_bookmark:null,slug_bookmark:null,type:'',shadow:true,category:null,label:'Register'})));}}]);return CharityCatalog;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (CharityCatalog);

/***/ }),
/* 512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3____ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Notifications=function(_Component){_inherits(Notifications,_Component);function Notifications(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Notifications);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Notifications.__proto__||Object.getPrototypeOf(Notifications)).call.apply(_ref,[this].concat(args))),_this),_this.state={open:false,seen:false,number:0},_this.checkSeen=function(){_this.props.notifications.map(function(notification){if(!notification.page_seen)_this.setState({seen:true});return notification.page_seen;});_this.setState({number:_this.props.notifications.filter(function(notification){return!notification.page_seen;}).length});},_this.controlPanel=function(){_this.props.callbackClick();},_this.handleSeen=function(e){if(e.currentTarget.classList.contains('hightlight')){e.currentTarget.classList.remove('hightlight');_this.setState({number:_this.state.number-1,seen:_this.state.number-1>0?true:false});}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Notifications,[{key:'componentDidMount',value:function componentDidMount(){this.checkSeen();}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(_ref2){var page_seen=_ref2.page_seen;if(page_seen!==this.props.page_seen){this.checkSeen();}}},{key:'render',value:function render(){var _this2=this;var _props=this.props,open=_props.open,notifications=_props.notifications;var _state=this.state,seen=_state.seen,number=_state.number;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{ref:function ref(el){return _this2.notification=el;},className:'notification'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn--icon '+(open?'open':''),onClick:this.controlPanel},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3____["K" /* Notification */],{width:24,height:24}),seen?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'dot'},' ',number,' '):''),notifications.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:Object(__WEBPACK_IMPORTED_MODULE_4__styles__["_14" /* NotificationStyle */])(open)+' notification-panel'},notifications.map(function(notification,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'notification-line '+(!notification.page_seen&&'hightlight')+' '+(notification.type==='alert'&&'alert'),key:index,onClick:_this2.handleSeen},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Link */],{to:notification.link},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'icon'},notification.type==='alert'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3____["b" /* Alert */],{width:18,height:18}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3____["K" /* Notification */],{width:18,height:18})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'label'},notification.name)));})));}}]);return Notifications;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{notifications:state.Session.notifications};})(Notifications));

/***/ }),
/* 513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_Router__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3____ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Notification=function(_Component){_inherits(Notification,_Component);function Notification(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Notification);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Notification.__proto__||Object.getPrototypeOf(Notification)).call.apply(_ref,[this].concat(args))),_this),_this.isActive=function(){return function(){var location=_this.props.location;return location.pathname.split('/').indexOf('bookmarks')!==-1;};},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Notification,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bookmark-nav'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* NavLink */],{className:'btn',to:__WEBPACK_IMPORTED_MODULE_2__services_Router__["a" /* default */].bookmarks.viewed,isActive:this.isActive()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3____["i" /* Bookmark */],{width:'24',height:'24'})));}}]);return Notification;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["g" /* withRouter */])(Notification));

/***/ }),
/* 514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2____ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PushContent=function(_Component){_inherits(PushContent,_Component);function PushContent(){_classCallCheck(this,PushContent);return _possibleConstructorReturn(this,(PushContent.__proto__||Object.getPrototypeOf(PushContent)).apply(this,arguments));}_createClass(PushContent,[{key:'render',value:function render(){var _props=this.props,picture=_props.picture,title=_props.title,page=_props.page,label=_props.label,description=_props.description;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'push-content '+Object(__WEBPACK_IMPORTED_MODULE_3__styles__["_24" /* PushContentStyle */])(picture)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'push-content--picture'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'picture'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'push-content--desc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,title),page&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:page||'',className:__WEBPACK_IMPORTED_MODULE_3__styles__["_1" /* LinkButtonPush */]},' ',label,' '),description&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,description)));}}]);return PushContent;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (PushContent);

/***/ }),
/* 515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import LazyImage from 'vanilla-lazyload'
var Picture=function(_Component){_inherits(Picture,_Component);function Picture(){_classCallCheck(this,Picture);return _possibleConstructorReturn(this,(Picture.__proto__||Object.getPrototypeOf(Picture)).apply(this,arguments));}_createClass(Picture,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"picture"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",Object.assign({},this.props,{alt:this.props.alt||this.props.src})));}}]);return Picture;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* unused harmony default export */ var _unused_webpack_default_export = (Picture);

/***/ }),
/* 516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SearchBar=function(_Component){_inherits(SearchBar,_Component);function SearchBar(){var _ref;var _temp,_this,_ret;_classCallCheck(this,SearchBar);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=SearchBar.__proto__||Object.getPrototypeOf(SearchBar)).call.apply(_ref,[this].concat(args))),_this),_this.state={searchKey:''},_this.addSearch=function(data){var searchKey=_this.state.searchKey;_this.setState({searchKey:data.value},function(){_this.props.callback(data.value);});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(SearchBar,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'searchbar '+__WEBPACK_IMPORTED_MODULE_2__styles__["_36" /* SearchBarStyle */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fluid'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1____["x" /* Field */],{type:'text',name:'search',id:'search',value:'',onChange:this.addSearch,big:true},' What are you looking for? '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn-reset'},' Search '))));}}]);return SearchBar;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (SearchBar);

/***/ }),
/* 517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4____ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_actions_Content__ = __webpack_require__(518);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BookmarkButton=function(_Component){_inherits(BookmarkButton,_Component);function BookmarkButton(){var _ref;var _temp,_this,_ret;_classCallCheck(this,BookmarkButton);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=BookmarkButton.__proto__||Object.getPrototypeOf(BookmarkButton)).call.apply(_ref,[this].concat(args))),_this),_this.state={isBooked:false,isLoad:false},_this.handlerClick=function(e){e.preventDefault();e.stopPropagation();_this.setState({isBooked:!_this.state.isBooked},function(){_this.state.isBooked?_this.props.addBookmark(_this.props.item):_this.props.removeBookmark(_this.props.item);});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(BookmarkButton,[{key:'componentDidMount',value:function componentDidMount(){this.setState({isBooked:this.props.is_bookmark});}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(_ref2){var is_bookmark=_ref2.is_bookmark;if(is_bookmark!==this.state.isBooked){this.setState({isBooked:is_bookmark});}}},{key:'render',value:function render(){var isBooked=this.state.isBooked;var big=this.props.big;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-bookmark '+Object(__WEBPACK_IMPORTED_MODULE_3__styles__["k" /* ButtonCard */])(big),onClick:this.handlerClick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'btn--label'},!isBooked?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4____["i" /* Bookmark */],{width:24,height:24}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4____["k" /* BookmarkPlain */],{width:24,height:24})));}}]);return BookmarkButton;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);BookmarkButton.defaultProps={big:false};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(null,function(dispatch){return{addBookmark:Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["a" /* compose */])(dispatch,__WEBPACK_IMPORTED_MODULE_5__store_actions_Content__["a" /* addBookmark */]),removeBookmark:Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["a" /* compose */])(dispatch,__WEBPACK_IMPORTED_MODULE_5__store_actions_Content__["b" /* removeBookmark */])};})(BookmarkButton));

/***/ }),
/* 518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export fetchFeatured */
/* unused harmony export searchTerm */
/* unused harmony export fetchPage */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addBookmark; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return removeBookmark; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers_Content__ = __webpack_require__(152);
var _this=this;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var fetchFeatured=function fetchFeatured(){return function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(dispatch,getState,api){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:if(!getState().Content.featured.length){_context.next=2;break;}return _context.abrupt('return');case 2:_context.next=4;return api.fetchFeatured();case 4:response=_context.sent;dispatch({type:__WEBPACK_IMPORTED_MODULE_1__reducers_Content__["a" /* ActionTypes */].SET_FEATURED,featured:response});case 6:case'end':return _context.stop();}}},_callee,_this);}));return function(_x,_x2,_x3){return _ref.apply(this,arguments);};}();};var searchTerm=function searchTerm(term){return function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(dispatch,getState,api){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:return _context2.abrupt('return',api.searchTerm(term));case 1:case'end':return _context2.stop();}}},_callee2,_this);}));return function(_x4,_x5,_x6){return _ref2.apply(this,arguments);};}();};var fetchPage=function fetchPage(page){return function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(dispatch,getState,api){var request;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:request=api.fetchPage(page);request.then(function(res){if(res){dispatch({type:__WEBPACK_IMPORTED_MODULE_1__reducers_Content__["a" /* ActionTypes */].SET_PAGE_CONTENT,page:page,contents:res});}});return _context3.abrupt('return',request);case 3:case'end':return _context3.stop();}}},_callee3,_this);}));return function(_x7,_x8,_x9){return _ref3.apply(this,arguments);};}();};var addBookmark=function addBookmark(item){return function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(dispatch,getState,api){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:return _context4.abrupt('return',api.addBookmark(item));case 1:case'end':return _context4.stop();}}},_callee4,_this);}));return function(_x10,_x11,_x12){return _ref4.apply(this,arguments);};}();};var removeBookmark=function removeBookmark(item){return function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(dispatch,getState,api){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:return _context5.abrupt('return',api.removeBookmark(item));case 1:case'end':return _context5.stop();}}},_callee5,_this);}));return function(_x13,_x14,_x15){return _ref5.apply(this,arguments);};}();};

/***/ }),
/* 519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PDFButton=function(_Component){_inherits(PDFButton,_Component);function PDFButton(){var _ref;var _temp,_this,_ret;_classCallCheck(this,PDFButton);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=PDFButton.__proto__||Object.getPrototypeOf(PDFButton)).call.apply(_ref,[this].concat(args))),_this),_this.state={active:false},_this.handlerClick=function(e){e.preventDefault();e.stopPropagation();_this.setState({active:!_this.state.active});},_this.closePanel=function(e){// e.preventDefault()
e.stopPropagation();_this.setState({active:false});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(PDFButton,[{key:'render',value:function render(){var _this2=this;var _props=this.props,big=_props.big,pdfs=_props.pdfs;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_2__styles__["m" /* ButtonPDFCard */]},pdfs&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'panel-pdf '+Object(__WEBPACK_IMPORTED_MODULE_2__styles__["_17" /* PanelPDFStyle */])(this.state.active)},pdfs.map(function(pdf,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:pdf.path,onClick:_this2.closePanel,download:true,className:'pdf-line',key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,pdf.label),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1____["_16" /* Upload */],{width:24,height:24}));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-pdf '+Object(__WEBPACK_IMPORTED_MODULE_2__styles__["k" /* ButtonCard */])(big),onClick:this.handlerClick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1____["O" /* Pdf */],{width:24,height:24}))));}}]);return PDFButton;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);PDFButton.defaultProps={big:false};/* harmony default export */ __webpack_exports__["a"] = (PDFButton);

/***/ }),
/* 520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__static_default_picture_RM_jpg__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__static_default_picture_RM_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__static_default_picture_RM_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3____ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Cards=function(_Component){_inherits(Cards,_Component);function Cards(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Cards);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Cards.__proto__||Object.getPrototypeOf(Cards)).call.apply(_ref,[this].concat(args))),_this),_this.state={isCOver:false},_this.defaultProps={shadow:false,label:'Discover'},_this.isVertical=function(){_this.setState({isCover:_this.props.slug.indexOf('friends-and-partners')!==-1||_this.props.slug.indexOf('materials')!==-1||_this.props.slug.indexOf('complications')!==-1||_this.img.naturalWidth>_this.img.naturalHeight});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Cards,[{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,card_picture=_props.card_picture,cover=_props.cover;this.img=new Image();this.img.src=card_picture?card_picture:cover;this.img.addEventListener('load',this.isVertical);}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.img.addEventListener('load',this.isVertical);}},{key:'render',value:function render(){var _props2=this.props,title=_props2.title,cover=_props2.cover,card_picture=_props2.card_picture,category=_props2.category,slug=_props2.slug,pdfs=_props2.pdfs,description=_props2.description,slug_bookmark=_props2.slug_bookmark,type=_props2.type,search=_props2.search,highlight=_props2.highlight,shadow=_props2.shadow,is_bookmark=_props2.is_bookmark,label=_props2.label;var isCover=this.state.isCover;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card '+(search?Object(__WEBPACK_IMPORTED_MODULE_4__styles__["_5" /* LongCardStyle */])(shadow,card_picture?card_picture:cover?cover:__WEBPACK_IMPORTED_MODULE_2__static_default_picture_RM_jpg___default.a,isCover):Object(__WEBPACK_IMPORTED_MODULE_4__styles__["s" /* CardStyle */])(shadow,card_picture?card_picture:cover?cover:__WEBPACK_IMPORTED_MODULE_2__static_default_picture_RM_jpg___default.a,isCover))},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:slug},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-picture'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-info'},category&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-info--type'},' ',category,' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,' ',title,' '),description&&!search&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'description',dangerouslySetInnerHTML:{'__html':description.length>80?description.slice(0,80)+'...':description}}),search&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'highlight',dangerouslySetInnerHTML:{'__html':highlight}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-bottom flex items-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'card-link'},label),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-button'},pdfs&&pdfs.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3____["M" /* PDFButton */],{pdfs:pdfs,big:search}),slug_bookmark&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3____["j" /* BookmarkButton */],{item:{slug_bookmark:slug_bookmark,type:type},is_bookmark:is_bookmark,big:search}))))));}}]);return Cards;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Cards);

/***/ }),
/* 521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_ApiController__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2____ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Featured=function(_Component){_inherits(Featured,_Component);function Featured(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Featured);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Featured.__proto__||Object.getPrototypeOf(Featured)).call.apply(_ref,[this].concat(args))),_this),_this.state={featured:[],ready:false},_this.getFeatured=function(){Object(__WEBPACK_IMPORTED_MODULE_1__services_ApiController__["fetchFeatured"])().then(function(data){var nData=[];var i=0;Object.keys(data).map(function(row,index){nData.push(data[row]);i=index;if(i===Object.keys(data).length-1)_this.setState({featured:nData,ready:true});});}).catch(function(err){console.log('Something Wrong with Featured data',err);});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Featured,[{key:'componentDidMount',value:function componentDidMount(){this.getFeatured();}},{key:'render',value:function render(){var home=this.props.home;var _state=this.state,featured=_state.featured,ready=_state.ready;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'featured fluid '+Object(__WEBPACK_IMPORTED_MODULE_3__styles__["M" /* FeaturedStyle */])(ready)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'Featured'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2____["_9" /* SlideshowMobile */],{isHome:home,ready:ready},featured&&featured.map(function(feature,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2____["n" /* Card */],Object.assign({},feature,{description:'',key:index,label:'discover'}));})));}}]);return Featured;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);// title, picture, type, path
/* harmony default export */ __webpack_exports__["a"] = (Featured);

/***/ }),
/* 522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2____ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ReturnButton=function(_Component){_inherits(ReturnButton,_Component);function ReturnButton(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ReturnButton);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ReturnButton.__proto__||Object.getPrototypeOf(ReturnButton)).call.apply(_ref,[this].concat(args))),_this),_this.handlerClick=function(e){e.preventDefault();_this.props.history.goBack();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ReturnButton,[{key:'render',value:function render(){var big=this.props.big;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-return '+Object(__WEBPACK_IMPORTED_MODULE_3__styles__["n" /* ButtonReturnCard */])(big),onClick:this.handlerClick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2____["e" /* ArrowBack */],{width:24,height:24}));}}]);return ReturnButton;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["g" /* withRouter */])(ReturnButton));

/***/ }),
/* 523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2____ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Slider=function(_Component){_inherits(Slider,_Component);function Slider(props){_classCallCheck(this,Slider);var _this=_possibleConstructorReturn(this,(Slider.__proto__||Object.getPrototypeOf(Slider)).call(this,props));_this.state={active:0};_this.next=function(){_this.setState({active:_this.state.active<_this.props.max-1?_this.state.active+1:0});};_this.prev=function(){_this.setState({active:_this.state.active>0?_this.state.active-1:_this.props.max});};_this.slides=[];return _this;}_createClass(Slider,[{key:'componentDidMount',value:function componentDidMount(){document.body.style.height=this.slides[0].querySelector('.template-scroll').offsetHeight+'px';}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(_ref){var _this2=this;var active=_ref.active;if(active!==this.state.active){this.setState({active:active},function(){document.body.style.height=_this2.slides[active].querySelector('.template-scroll').offsetHeight+'px';});}}},{key:'componentWillUnmount',value:function componentWillUnmount(){document.body.setAttribute('style','');}},{key:'render',value:function render(){var children=this.props.children;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:''+__WEBPACK_IMPORTED_MODULE_1__styles__["_46" /* SliderStyle */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2____["A" /* FlickitySlider */],null,children));}}]);return Slider;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* unused harmony default export */ var _unused_webpack_default_export = (Slider);

/***/ }),
/* 524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recompose__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__hoc_withScript__ = __webpack_require__(525);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}if(!window.prodibiAsync){window.prodibiAsync=[{type:'settings',settings:{account:'richardmille'}}];}var Prodibi=function(_Component){_inherits(Prodibi,_Component);function Prodibi(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Prodibi);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Prodibi.__proto__||Object.getPrototypeOf(Prodibi)).call.apply(_ref,[this].concat(args))),_this),_this.state={disabledTap:false},_this.handlerClick=function(){_this.setState({disabledTap:true});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Prodibi,[{key:'render',value:function render(){var _props=this.props,className=_props.className,onMount=_props.onMount,id=_props.id,width=_props.width,height=_props.height,heightMode=_props.heightMode,smartX=_props.smartX,smartY=_props.smartY,mediaView=_props.mediaView,mode=_props.mode,noTap=_props.noTap;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{ref:onMount,className:Object(__WEBPACK_IMPORTED_MODULE_2__styles__["_20" /* ProdibiStyle */])(window.innerWidth/2,window.innerHeight-160)},!this.state.disabledTap&&!noTap&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'prodibi-tap'},'Tap to zoom in'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('canvas',{className:'prodibi-picture','data-prodibi':JSON.stringify({id:id,width:width,height:height,heightMode:heightMode,smartX:smartX,smartY:smartY,mediaView:mediaView,mode:mode}),onClick:this.handlerClick}));}}]);return Prodibi;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var enhance=Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["a" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["d" /* withHandlers */])({onMount:function onMount(){return function(node){window.prodibiAsync.push({type:'renderAll',elements:node});};}}),Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["b" /* defaultProps */])({className:'',heightMode:null,smartX:0.5,smartY:0.666667,mediaView:null,mode:'zoom'}),Object(__WEBPACK_IMPORTED_MODULE_3__hoc_withScript__["a" /* default */])('https://max1.prodibicdn.com/libraries/pages/prodibi.embed.1.2.min.js',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Loading...')),__WEBPACK_IMPORTED_MODULE_1_recompose__["c" /* pure */]);/* harmony default export */ __webpack_exports__["a"] = (enhance(Prodibi));

/***/ }),
/* 525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_chirashi_event_emitter__ = __webpack_require__(526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_recompose__ = __webpack_require__(35);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var apiLoaderFactory=function apiLoaderFactory(){var emitter=Object(__WEBPACK_IMPORTED_MODULE_1_chirashi_event_emitter__["a" /* default */])();var fetching=[];var loaded=[];return{load:function load(api){if(loaded.includes(api)){return Promise.resolve();}if(!fetching.includes(api)){var tag=document.createElement('script');Object.assign(tag,{async:true,src:api});document.body.appendChild(tag);tag.addEventListener('load',function(){return emitter.emit('loaded:'+api);});}return new Promise(function(resolve){emitter.on('loaded:'+api,resolve);});}};};var apiLoader=apiLoaderFactory();/* harmony default export */ __webpack_exports__["a"] = (function(src){var loading=arguments.length>1&&arguments[1]!==undefined?arguments[1]:null;return function(WrappedComponent){return function(_Component){_inherits(EnsureApi,_Component);function EnsureApi(){var _ref;var _temp,_this,_ret;_classCallCheck(this,EnsureApi);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=EnsureApi.__proto__||Object.getPrototypeOf(EnsureApi)).call.apply(_ref,[this].concat(args))),_this),_this.state={apiLoaded:false},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(EnsureApi,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;apiLoader.load(src).then(function(){_this2.setState({apiLoaded:true});});}},{key:'render',value:function render(){return this.state.apiLoaded?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedComponent,this.props):loading;}}]);return EnsureApi;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);};});

/***/ }),
/* 526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * ChirashiEventEmitter.js v2.0.3
 * (c) 2017 Alex Toudic
 * Released under MIT License.
 **/

var toConsumableArray = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  } else {
    return Array.from(arr);
  }
};

/**
 * The TEventEmitter factory function.
 */
var EventEmitter$1 = function EventEmitter() {
  var _events = {};

  var self = {
    on: function on(event, callback) {
      if (!(event in _events)) {
        _events[event] = [];
      }

      _events[event].push(callback);

      return function () {
        return self.off(event, callback);
      };
    },
    off: function off(event, callback) {
      if (!(event in _events)) return;

      if (typeof callback === 'function') {
        var index = void 0;
        if ((index = _events[event].indexOf(callback)) !== -1) {
          _events[event].splice(index, 1);
        }
      } else {
        delete _events[event];
      }
    },
    emit: function emit(event) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      if (!(event in _events)) return;

      var listeners = _events[event].slice(); // copy current listeners in case of unbinding
      var n = listeners.length;

      var _loop = function _loop(i) {
        setTimeout(function () {
          listeners[i].apply(listeners, toConsumableArray(args));
        });
      };

      for (var i = 0; i < n; ++i) {
        _loop(i);
      }
    }
  };

  return self;
};

/* harmony default export */ __webpack_exports__["a"] = (EventEmitter$1);


/***/ }),
/* 527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Video__ = __webpack_require__(162);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Videos=function(_Component){_inherits(Videos,_Component);function Videos(){_classCallCheck(this,Videos);return _possibleConstructorReturn(this,(Videos.__proto__||Object.getPrototypeOf(Videos)).apply(this,arguments));}_createClass(Videos,[{key:'render',value:function render(){var _props=this.props,title=_props.title,picture=_props.picture,fields=_props.fields;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'product-template--suggest '+Object(__WEBPACK_IMPORTED_MODULE_1__styles__["_73" /* VideoTemplateStyle */])()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'template-scroll'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'template-right '+(!picture?'full':'')+' template-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'flex'},title&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'subtitle'},' ',title,' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'suggest-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'flex'},fields.videos.map(function(video,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Video__["a" /* default */],Object.assign({},video,{key:index}));})))))));}}]);return Videos;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Videos);

/***/ }),
/* 528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Nav=function(_Component){_inherits(Nav,_Component);function Nav(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Nav);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Nav.__proto__||Object.getPrototypeOf(Nav)).call.apply(_ref,[this].concat(args))),_this),_this.state={enable:false},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Nav,[{key:'render',value:function render(){var nav=this.props.nav;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'nav-page '+__WEBPACK_IMPORTED_MODULE_2__styles__["_10" /* NavPageStyle */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["N" /* Pan */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'reset flex content-center flex-nowrap'},nav.map(function(item,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* NavLink */],{to:item.url},' ',item.value));}))));}}]);return Nav;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Nav);

/***/ }),
/* 529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__hoc_withResize__ = __webpack_require__(61);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Filter=function(_Component){_inherits(Filter,_Component);function Filter(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Filter);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Filter.__proto__||Object.getPrototypeOf(Filter)).call.apply(_ref,[this].concat(args))),_this),_this.state={isOpen:null,mobileOpen:false,filtering:[]},_this.callBackFilter=function(){_this.props.filters(_this.state.filter);},_this.getFilter=function(filters){if(filters&&Object.keys(filters).length>0){var nArr=[];var i=0;Object.keys(filters).map(function(filter,index){nArr.push({name:filter,items:filters[filter]});i=index;if(i===Object.keys(filters).length-1){_this.setState({filters:nArr});}return filter;});}},_this.filtering=function(filters,category){var nFilters=_this.state.filtering;if(filters.length>0)nFilters[category]=filters;else delete nFilters[category];_this.setState({filtering:Object.assign({},nFilters)},function(){_this.props.filtering(_this.state.filtering);});},_this.callbackOpen=function(n){_this.setState({isOpen:n!==_this.state.isOpen?n:null});},_this.handlerClick=function(e){e.preventDefault();_this.setState({mobileOpen:!_this.state.mobileOpen});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Filter,[{key:'componentDidMount',value:function componentDidMount(){this.getFilter(this.props.filters);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(_ref2){var filters=_ref2.filters;if(filters!==this.props.filters){this.getFilter(filters);}}},{key:'render',value:function render(){var _this2=this;var _state=this.state,filters=_state.filters,isOpen=_state.isOpen,mobileOpen=_state.mobileOpen;var _props=this.props,dark=_props.dark,viewport=_props.viewport;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'filter '+Object(__WEBPACK_IMPORTED_MODULE_2__styles__["P" /* FilterStyle */])(mobileOpen,dark)+' flex'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'filter-item filter-focus',onClick:this.handlerClick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'filter-label'},' ',viewport.isMobile?'Filters':'Filter by'),viewport.isMobile&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'filter-close'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'reset flex items-center filter-list'},filters&&filters.map(function(filter,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:index,className:'filter-item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1____["z" /* FilterDropdown */],{callbackFilters:_this2.filtering,toggleOpen:_this2.callbackOpen,id:index,isOpen:isOpen!==null&&index===isOpen,lists:filter.items,label:filter.name,dark:dark}));})));}}]);return Filter;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Filter.defaultProps={dark:false};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3__hoc_withResize__["a" /* withResize */])(Filter));

/***/ }),
/* 530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2____ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FilterDropdown=function(_Component){_inherits(FilterDropdown,_Component);function FilterDropdown(){var _ref;var _temp,_this,_ret;_classCallCheck(this,FilterDropdown);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=FilterDropdown.__proto__||Object.getPrototypeOf(FilterDropdown)).call.apply(_ref,[this].concat(args))),_this),_this.state={open:false,filters:[],category:''},_this.handlerClick=function(){_this.props.toggleOpen(_this.props.id);},_this.getFilters=function(checkbox){var nFilters=_this.state.filters;if(checkbox.checked)nFilters.push(checkbox.value);else nFilters=nFilters.filter(function(filter){return filter!==checkbox.value;});_this.setState({filters:nFilters},function(){_this.props.callbackFilters(_this.state.filters,_this.props.label);});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(FilterDropdown,[{key:'render',value:function render(){var _this2=this;var _props=this.props,isOpen=_props.isOpen,label=_props.label,lists=_props.lists,dark=_props.dark;var open=this.state.open;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:Object(__WEBPACK_IMPORTED_MODULE_1__styles__["O" /* FilterDropdownStyle */])(isOpen,dark)+' dropdown'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'dropdown-label',onClick:this.handlerClick},' ',label,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2____["f" /* ArrowDrop */],{width:10,height:10}),' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'dropdown-list'},lists.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2____["p" /* Checkbox */],{key:i,onCallback:_this2.getFilters,name:item.name+'['+label+']',id:label+'['+item.name+']',value:item.name,checked:item.checked},' ',item.name,' ');})));}}]);return FilterDropdown;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (FilterDropdown);

/***/ }),
/* 531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2____ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SelectDropdown=function(_Component){_inherits(SelectDropdown,_Component);function SelectDropdown(){var _ref;var _temp,_this,_ret;_classCallCheck(this,SelectDropdown);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=SelectDropdown.__proto__||Object.getPrototypeOf(SelectDropdown)).call.apply(_ref,[this].concat(args))),_this),_this.state={open:false,value:''},_this.handlerClick=function(){_this.setState({open:!_this.state.open});},_this.updateSelect=function(select){return function(e){e.preventDefault();_this.setState({value:select,open:!_this.state.open},function(){_this.props.callback(_this.state.value);});};},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(SelectDropdown,[{key:'render',value:function render(){var _this2=this;var _props=this.props,label=_props.label,lists=_props.lists;var _state=this.state,open=_state.open,value=_state.value;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:Object(__WEBPACK_IMPORTED_MODULE_1__styles__["_40" /* SelectDropdownStyle */])(open,value)+' dropdown'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'dropdown-label',onClick:this.handlerClick},' ',value!==''?value:label,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2____["f" /* ArrowDrop */],{width:16,height:16}),' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'reset dropdown-list'},lists&&Object.keys(lists).map(function(key,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:i,onClick:_this2.updateSelect(Object.keys(lists)[i]),className:value===Object.keys(lists)[i]?'active':''},Object.keys(lists)[i]);})));}}]);return SelectDropdown;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (SelectDropdown);

/***/ }),
/* 532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2____ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var COUNTRIES={"AF":"Afrikaans","SQ":"Albanian","AR":"Arabic","HY":"Armenian","EU":"Basque","BN":"Bengali","BG":"Bulgarian","CA":"Catalan","KM":"Cambodian","ZH":"Chinese (Mandarin)","HR":"Croatian","CS":"Czech","DA":"Danish","NL":"Dutch","EN":"English","ET":"Estonian","FJ":"Fiji","FI":"Finnish","FR":"French","KA":"Georgian","DE":"German","EL":"Greek","GU":"Gujarati","HE":"Hebrew","HI":"Hindi","HU":"Hungarian","IS":"Icelandic","ID":"Indonesian","GA":"Irish","IT":"Italian","JA":"Japanese","JW":"Javanese","KO":"Korean","LA":"Latin","LV":"Latvian","LT":"Lithuanian","MK":"Macedonian","MS":"Malay","ML":"Malayalam","MT":"Maltese","MI":"Maori","MR":"Marathi","MN":"Mongolian","NE":"Nepali","NO":"Norwegian","FA":"Persian","PL":"Polish","PT":"Portuguese","PA":"Punjabi","QU":"Quechua","RO":"Romanian","RU":"Russian","SM":"Samoan","SR":"Serbian","SK":"Slovak","SL":"Slovenian","ES":"Spanish","SW":"Swahili","SV":"Swedish ","TA":"Tamil","TT":"Tatar","TE":"Telugu","TH":"Thai","BO":"Tibetan","TO":"Tonga","TR":"Turkish","UK":"Ukrainian","UR":"Urdu","UZ":"Uzbek","VI":"Vietnamese","CY":"Welsh","XH":"Xhosa"};var SelectCountries=function(_Component){_inherits(SelectCountries,_Component);function SelectCountries(){var _ref;var _temp,_this,_ret;_classCallCheck(this,SelectCountries);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=SelectCountries.__proto__||Object.getPrototypeOf(SelectCountries)).call.apply(_ref,[this].concat(args))),_this),_this.state={open:false,value:''},_this.handlerClick=function(){_this.setState({open:!_this.state.open});},_this.updateSelect=function(select){return function(e){e.preventDefault();_this.setState({value:select,open:!_this.state.open},function(){_this.props.callback(_this.state.value);});};},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(SelectCountries,[{key:'render',value:function render(){var _this2=this;var label=this.props.label;var _state=this.state,open=_state.open,value=_state.value;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:Object(__WEBPACK_IMPORTED_MODULE_1__styles__["_40" /* SelectDropdownStyle */])(open,value)+' dropdown'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'dropdown-label',onClick:this.handlerClick},' ',value!==''?value:label,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2____["f" /* ArrowDrop */],{width:16,height:16}),' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'reset dropdown-list'},Object.keys(COUNTRIES).map(function(key){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:COUNTRIES[key],onClick:_this2.updateSelect(COUNTRIES[key]),className:value===COUNTRIES[key]?'active':''},COUNTRIES[key]);})));}}]);return SelectCountries;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (SelectCountries);

/***/ }),
/* 533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2____ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_emotion__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__static_ISOPHONE__ = __webpack_require__(534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_world_flags__ = __webpack_require__(535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_world_flags___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_world_flags__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Style=Object(__WEBPACK_IMPORTED_MODULE_3_emotion__["a" /* css */])({width:100,'img':{width:18}});var SelectCountries=function(_Component){_inherits(SelectCountries,_Component);function SelectCountries(){var _ref;var _temp,_this,_ret;_classCallCheck(this,SelectCountries);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=SelectCountries.__proto__||Object.getPrototypeOf(SelectCountries)).call.apply(_ref,[this].concat(args))),_this),_this.state={open:false,value:'',isoCodeSelected:'',isoPhone:[]},_this.handlerClick=function(){_this.setState({open:!_this.state.open});},_this.updateSelect=function(select,key){return function(e){e.preventDefault();_this.setState({value:select,open:!_this.state.open,isoCodeSelected:key},function(){_this.props.callback(_this.state.value);});};},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(SelectCountries,[{key:'componentDidMount',value:function componentDidMount(){var nArr=[];Object.keys(__WEBPACK_IMPORTED_MODULE_4__static_ISOPHONE__["a" /* ISOPHONE */]).map(function(key){return nArr[__WEBPACK_IMPORTED_MODULE_4__static_ISOPHONE__["a" /* ISOPHONE */][key].code.replace('+','')]={code:key,country:__WEBPACK_IMPORTED_MODULE_4__static_ISOPHONE__["a" /* ISOPHONE */][key].name,phone:__WEBPACK_IMPORTED_MODULE_4__static_ISOPHONE__["a" /* ISOPHONE */][key].code};});this.setState({isoPhone:nArr});}},{key:'render',value:function render(){var _this2=this;var _props=this.props,label=_props.label,children=_props.children;var _state=this.state,open=_state.open,value=_state.value,isoCodeSelected=_state.isoCodeSelected,isoPhone=_state.isoPhone;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:Object(__WEBPACK_IMPORTED_MODULE_1__styles__["_40" /* SelectDropdownStyle */])(open,value)+' dropdown '+Style+' required-indicator'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'dropdown-label',onClick:this.handlerClick},isoCodeSelected!==''&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_world_flags___default.a,{code:isoCodeSelected}),value===''?children:value,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2____["f" /* ArrowDrop */],{width:16,height:16})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'reset dropdown-list'},isoPhone.map(function(item){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:item.code,onClick:_this2.updateSelect(item.phone,item.code),className:value===item.phone?'active':''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_world_flags___default.a,{code:item.code}),' ',item.phone);})));}}]);return SelectCountries;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (SelectCountries);

/***/ }),
/* 534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ISOPHONE; });
var ISOPHONE={AF:{name:'Afghanistan',code:'+93'},AL:{name:'Albania',code:'+355'},DZ:{name:'Algeria',code:'+213'},AS:{name:'American Samoa',code:'+1-684'},AD:{name:'Andorra',code:'+376'},AO:{name:'Angola',code:'+244'},AI:{name:'Anguilla',code:'+1-264'},AQ:{name:'Antarctica',code:'+672'},AG:{name:'Antigua and Barbuda',code:'+1-268'},AR:{name:'Argentina',code:'+54'},AM:{name:'Armenia',code:'+374'},AW:{name:'Aruba',code:'+297'},AU:{name:'Australia',code:'+61'},AT:{name:'Austria',code:'+43'},AZ:{name:'Azerbaijan',code:'+994'},BS:{name:'Bahamas',code:'+1-242'},BH:{name:'Bahrain',code:'+973'},BD:{name:'Bangladesh',code:'+880'},BB:{name:'Barbados',code:'+1-246'},BY:{name:'Belarus',code:'+375'},BE:{name:'Belgium',code:'+32'},BZ:{name:'Belize',code:'+501'},BJ:{name:'Benin',code:'+229'},BM:{name:'Bermuda',code:'+1-441'},BT:{name:'Bhutan',code:'+975'},BO:{name:'Bolivia',code:'+591'},BA:{name:'Bosnia and Herzegovina',code:'+387'},BW:{name:'Botswana',code:'+267'},BR:{name:'Brazil',code:'+55'},IO:{name:'British Indian Ocean Territory',code:'+246'},VG:{name:'British Virgin Islands',code:'+1-284'},BN:{name:'Brunei',code:'+673'},BG:{name:'Bulgaria',code:'+359'},BF:{name:'Burkina Faso',code:'+226'},BI:{name:'Burundi',code:'+257'},KH:{name:'Cambodia',code:'+855'},CM:{name:'Cameroon',code:'+237'},CA:{name:'Canada',code:'+1'},CV:{name:'Cape Verde',code:'+238'},KY:{name:'Cayman Islands',code:'+1-345'},CF:{name:'Central African Republic',code:'+236'},TD:{name:'Chad',code:'+235'},CL:{name:'Chile',code:'+56'},CN:{name:'China',code:'+86'},CX:{name:'Christmas Island',code:'+61'},CC:{name:'Cocos Islands',code:'+61'},CO:{name:'Colombia',code:'+57'},KM:{name:'Comoros',code:'+269'},CK:{name:'Cook Islands',code:'+682'},CR:{name:'Costa Rica',code:'+506'},HR:{name:'Croatia',code:'+385'},CU:{name:'Cuba',code:'+53'},CW:{name:'Curacao',code:'+599'},CY:{name:'Cyprus',code:'+357'},CZ:{name:'Czech Republic',code:'+420'},CD:{name:'Democratic Republic of the Congo',code:'+243'},DK:{name:'Denmark',code:'+45'},DJ:{name:'Djibouti',code:'+253'},DM:{name:'Dominica',code:'+1-767'},DO:{name:'Dominican Republic',code:'+1-809, 1-829, 1-849'},TL:{name:'East Timor',code:'+670'},EC:{name:'Ecuador',code:'+593'},EG:{name:'Egypt',code:'+20'},SV:{name:'El Salvador',code:'+503'},GQ:{name:'Equatorial Guinea',code:'+240'},ER:{name:'Eritrea',code:'+291'},EE:{name:'Estonia',code:'+372'},ET:{name:'Ethiopia',code:'+251'},FK:{name:'Falkland Islands',code:'+500'},FO:{name:'Faroe Islands',code:'+298'},FJ:{name:'Fiji',code:'+679'},FI:{name:'Finland',code:'+358'},FR:{name:'France',code:'+33'},PF:{name:'French Polynesia',code:'+689'},GA:{name:'Gabon',code:'+241'},GM:{name:'Gambia',code:'+220'},GE:{name:'Georgia',code:'+995'},DE:{name:'Germany',code:'+49'},GH:{name:'Ghana',code:'+233'},GI:{name:'Gibraltar',code:'+350'},GR:{name:'Greece',code:'+30'},GL:{name:'Greenland',code:'+299'},GD:{name:'Grenada',code:'+1-473'},GU:{name:'Guam',code:'+1-671'},GT:{name:'Guatemala',code:'+502'},GG:{name:'Guernsey',code:'+44-1481'},GN:{name:'Guinea',code:'+224'},GW:{name:'Guinea-Bissau',code:'+245'},GY:{name:'Guyana',code:'+592'},HT:{name:'Haiti',code:'+509'},HN:{name:'Honduras',code:'+504'},HK:{name:'Hong Kong',code:'+852'},HU:{name:'Hungary',code:'+36'},IS:{name:'Iceland',code:'+354'},IN:{name:'India',code:'+91'},ID:{name:'Indonesia',code:'+62'},IR:{name:'Iran',code:'+98'},IQ:{name:'Iraq',code:'+964'},IE:{name:'Ireland',code:'+353'},IM:{name:'Isle of Man',code:'+44-1624'},IL:{name:'Israel',code:'+972'},IT:{name:'Italy',code:'+39'},CI:{name:'Ivory Coast',code:'+225'},JM:{name:'Jamaica',code:'+1-876'},JP:{name:'Japan',code:'+81'},JE:{name:'Jersey',code:'+44-1534'},JO:{name:'Jordan',code:'+962'},KZ:{name:'Kazakhstan',code:'+7'},KE:{name:'Kenya',code:'+254'},KI:{name:'Kiribati',code:'+686'},XK:{name:'Kosovo',code:'+383'},KW:{name:'Kuwait',code:'+965'},KG:{name:'Kyrgyzstan',code:'+996'},LA:{name:'Laos',code:'+856'},LV:{name:'Latvia',code:'+371'},LB:{name:'Lebanon',code:'+961'},LS:{name:'Lesotho',code:'+266'},LR:{name:'Liberia',code:'+231'},LY:{name:'Libya',code:'+218'},LI:{name:'Liechtenstein',code:'+423'},LT:{name:'Lithuania',code:'+370'},LU:{name:'Luxembourg',code:'+352'},MO:{name:'Macau',code:'+853'},MK:{name:'Macedonia',code:'+389'},MG:{name:'Madagascar',code:'+261'},MW:{name:'Malawi',code:'+265'},MY:{name:'Malaysia',code:'+60'},MV:{name:'Maldives',code:'+960'},ML:{name:'Mali',code:'+223'},MT:{name:'Malta',code:'+356'},MH:{name:'Marshall Islands',code:'+692'},MR:{name:'Mauritania',code:'+222'},MU:{name:'Mauritius',code:'+230'},YT:{name:'Mayotte',code:'+262'},MX:{name:'Mexico',code:'+52'},FM:{name:'Micronesia',code:'+691'},MD:{name:'Moldova',code:'+373'},MC:{name:'Monaco',code:'+377'},MN:{name:'Mongolia',code:'+976'},ME:{name:'Montenegro',code:'+382'},MS:{name:'Montserrat',code:'+1-664'},MA:{name:'Morocco',code:'+212'},MZ:{name:'Mozambique',code:'+258'},MM:{name:'Myanmar',code:'+95'},NA:{name:'Namibia',code:'+264'},NR:{name:'Nauru',code:'+674'},NP:{name:'Nepal',code:'+977'},NL:{name:'Netherlands',code:'+31'},AN:{name:'Netherlands Antilles',code:'+599'},NC:{name:'New Caledonia',code:'+687'},NZ:{name:'New Zealand',code:'+64'},NI:{name:'Nicaragua',code:'+505'},NE:{name:'Niger',code:'+227'},NG:{name:'Nigeria',code:'+234'},NU:{name:'Niue',code:'+683'},KP:{name:'North Korea',code:'+850'},MP:{name:'Northern Mariana Islands',code:'+1-670'},NO:{name:'Norway',code:'+47'},OM:{name:'Oman',code:'+968'},PK:{name:'Pakistan',code:'+92'},PW:{name:'Palau',code:'+680'},PS:{name:'Palestine',code:'+970'},PA:{name:'Panama',code:'+507'},PG:{name:'Papua New Guinea',code:'+675'},PY:{name:'Paraguay',code:'+595'},PE:{name:'Peru',code:'+51'},PH:{name:'Philippines',code:'+63'},PN:{name:'Pitcairn',code:'+64'},PL:{name:'Poland',code:'+48'},PT:{name:'Portugal',code:'+351'},PR:{name:'Puerto Rico',code:'+1-787, 1-939'},QA:{name:'Qatar',code:'+974'},CG:{name:'Republic of the Congo',code:'+242'},RE:{name:'Reunion',code:'+262'},RO:{name:'Romania',code:'+40'},RU:{name:'Russia',code:'+7'},RW:{name:'Rwanda',code:'+250'},BL:{name:'Saint Barthelemy',code:'+590'},SH:{name:'Saint Helena',code:'+290'},KN:{name:'Saint Kitts and Nevis',code:'+1-869'},LC:{name:'Saint Lucia',code:'+1-758'},MF:{name:'Saint Martin',code:'+590'},PM:{name:'Saint Pierre and Miquelon',code:'+508'},VC:{name:'Saint Vincent and the Grenadines',code:'+1-784'},WS:{name:'Samoa',code:'+685'},SM:{name:'San Marino',code:'+378'},ST:{name:'Sao Tome and Principe',code:'+239'},SA:{name:'Saudi Arabia',code:'+966'},SN:{name:'Senegal',code:'+221'},RS:{name:'Serbia',code:'+381'},SC:{name:'Seychelles',code:'+248'},SL:{name:'Sierra Leone',code:'+232'},SG:{name:'Singapore',code:'+65'},SX:{name:'Sint Maarten',code:'+1-721'},SK:{name:'Slovakia',code:'+421'},SI:{name:'Slovenia',code:'+386'},SB:{name:'Solomon Islands',code:'+677'},SO:{name:'Somalia',code:'+252'},ZA:{name:'South Africa',code:'+27'},KR:{name:'South Korea',code:'+82'},SS:{name:'South Sudan',code:'+211'},ES:{name:'Spain',code:'+34'},LK:{name:'Sri Lanka',code:'+94'},SD:{name:'Sudan',code:'+249'},SR:{name:'Suriname',code:'+597'},SJ:{name:'Svalbard and Jan Mayen',code:'+47'},SZ:{name:'Swaziland',code:'+268'},SE:{name:'Sweden',code:'+46'},CH:{name:'Switzerland',code:'+41'},SY:{name:'Syria',code:'+963'},TW:{name:'Taiwan',code:'+886'},TJ:{name:'Tajikistan',code:'+992'},TZ:{name:'Tanzania',code:'+255'},TH:{name:'Thailand',code:'+66'},TG:{name:'Togo',code:'+228'},TK:{name:'Tokelau',code:'+690'},TO:{name:'Tonga',code:'+676'},TT:{name:'Trinidad and Tobago',code:'+1-868'},TN:{name:'Tunisia',code:'+216'},TR:{name:'Turkey',code:'+90'},TM:{name:'Turkmenistan',code:'+993'},TC:{name:'Turks and Caicos Islands',code:'+1-649'},TV:{name:'Tuvalu',code:'+688'},VI:{name:'U.S. Virgin Islands',code:'+1-340'},UG:{name:'Uganda',code:'+256'},UA:{name:'Ukraine',code:'+380'},AE:{name:'United Arab Emirates',code:'+971'},GB:{name:'United Kingdom',code:'+44'},US:{name:'United States',code:'+1'},UY:{name:'Uruguay',code:'+598'},UZ:{name:'Uzbekistan',code:'+998'},VU:{name:'Vanuatu',code:'+678'},VA:{name:'Vatican',code:'+379'},VE:{name:'Venezuela',code:'+58'},VN:{name:'Vietnam',code:'+84'},WF:{name:'Wallis and Futuna',code:'+681'},EH:{name:'Western Sahara',code:'+212'},YE:{name:'Yemen',code:'+967'},ZM:{name:'Zambia',code:'+260'},ZW:{name:'Zimbabwe',code:'+263'}};

/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

!function(a,i){ true?module.exports=i(__webpack_require__(0)):"function"==typeof define&&define.amd?define(["react"],i):"object"==typeof exports?exports["react-world-flags"]=i(require("react")):a["react-world-flags"]=i(a.react)}(this,(function(a){return function(a){var i={};function c(l){if(i[l])return i[l].exports;var o=i[l]={i:l,l:!1,exports:{}};return a[l].call(o.exports,o,o.exports,c),o.l=!0,o.exports}return c.m=a,c.c=i,c.d=function(a,i,l){c.o(a,i)||Object.defineProperty(a,i,{enumerable:!0,get:l})},c.r=function(a){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(a,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(a,"__esModule",{value:!0})},c.t=function(a,i){if(1&i&&(a=c(a)),8&i)return a;if(4&i&&"object"==typeof a&&a&&a.__esModule)return a;var l=Object.create(null);if(c.r(l),Object.defineProperty(l,"default",{enumerable:!0,value:a}),2&i&&"string"!=typeof a)for(var o in a)c.d(l,o,function(i){return a[i]}.bind(null,o));return l},c.n=function(a){var i=a&&a.__esModule?function(){return a.default}:function(){return a};return c.d(i,"a",i),i},c.o=function(a,i){return Object.prototype.hasOwnProperty.call(a,i)},c.p="",c(c.s=259)}([function(i,c){i.exports=a},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 1000 700'%3E %3Cpath fill='%23d0103a' d='M0 0h1000v700H0z'/%3E %3Cpath fill='%23fedf00' d='M0 0h680v700H0z'/%3E %3Cpath fill='%230018a8' d='M0 0h320v700H0z'/%3E %3Cpath fill='%23c7b37f' d='M469.37 188.48c12.05 0 16.98 10.34 29.03 10.34 7.44 0 11.78-2.43 18.26-6.09 4.52-2.56 7.41-3.93 12.6-3.93 5.32 0 8.58 1.61 11.3 6.17 1.54 2.58 2.82 7.63 2.14 10.53a62.43 62.43 0 0 1-4.26 12.95c-1.04 2.44-2.03 3.9-2.03 6.56 0 6.4 8.7 8.6 14.63 8.69 1.29.02 12.13.2 18.81-6.56-3.62-.16-7.67-2.97-7.67-6.59 0-4.1 2.88-6.87 6.78-8.05.74-.22 2 .44 2.68.09.95-.5.5-1.57 1.35-2.24 1.95-1.56 3.21-2.53 5.7-2.53 1.63 0 2.58.23 3.89 1.17.69.49.94 1.1 1.79 1.1 1.78 0 2.67-1.13 4.45-1.13 1.45 0 2.33.2 3.6.85 1.07.55 1.04 2.35 2.24 2.35.6 0 3.78-1.3 5.44-1.3 3.45 0 5.29 1.25 7.52 3.87.6.7.98 2.13 1.6 2.13a9.72 9.72 0 0 1 7.5 4.6c.41.65 1.03 2.25 1.75 2.53.84.32 1.55.26 2.66.97 2.52 1.62 4.47 4.66 4.37 7.6-.03 1-.48 2.38-.75 3.32-2.94 10.28-9.94 13.55-17 22.38-3 3.76-5.38 6.77-5.38 11.6 0 1.16 1.44 3.3 2.07 4.26-.39-2.26.65-5.05 3.05-5.18 3.28-.17 5.81 2.32 6.25 5.57.1.76-.19 2.08-.51 2.85a14.92 14.92 0 0 1 6.21-2.2c1.15-.12 1.82-.16 2.98-.13 5.25.13 11.04 3.08 14.55 6.07 10.75 9.13 12.05 22.49 11.46 26.2-1.3 8.24-.48 23.17-21.56 29.12 3.9 1.64 6.55 4.57 6.55 8.17 0 3.93-3 7.28-6.93 7.28-2.24 0-3.8-.55-5.37-2.12-4.38 4.38-5.23 8.85-5.23 15.06 0 3.7.7 5.9 2.26 9.26 1.65 3.55 2.83 5.63 5.8 8.2 1.57-2.37 3.23-4.1 6.08-4.1 2.75 0 5.09.88 6.22 3.39.33.76.03 1.38.42 2.12.5.95 1.33 1.16 1.84 2.12.8 1.46.02 2.72.7 4.24.45.99 1.42 1.13 1.84 2.12.67 1.52.85 2.56.85 4.24 0 4.7-4.27 8.06-8.97 8.06-1.42 0-2.2-.57-3.6-.43 2.68 2.69 4.73 3.86 6.78 7.07 2.96 4.65 3.7 7.95 4.38 13.43.12 1.02.14 1.64.14 2.69 0 7.03-1.1 11.23-4.24 17.52-3 6.03-5.57 9.37-11.03 13.3-8.51 6.12-14.72 7.89-25.02 9.89a116.22 116.22 0 0 1-17.1 2.26c-8.59.55-13.48.56-22.05 1.13-11.24.76-19.03 2.35-27 10.32 3.76 2.75 6.36 5.46 6.36 10.1 0 4.78-2.95 8.19-7.5 9.69-1.05.35-1.83.03-2.82.56-1.19.62-1.13 1.98-2.26 2.69-2 1.27-3.55 1.55-5.94 1.55-4.2 0-7.07-.99-10.04-3.95-3.44 2.86-4.6 5.44-8.48 7.63-1.27.7-1.92 1.7-3.4 1.7-2.3 0-3.37-1.47-5.22-2.83a35.86 35.86 0 0 1-6.93-6.36c-3.51 2.1-5.67 3.81-9.75 3.81-2.51 0-4.1-.35-6.22-1.7-1.11-.68-1.3-1.7-2.4-2.4-1.17-.72-2.14-.46-3.4-.99-4.72-2.03-7.77-5.53-7.77-10.67 0-4.5 2.84-7.37 6.92-9.26-7.82-7.82-15.53-9.18-26.57-9.9-8.54-.54-13.4-.56-21.91-1.12-6.77-.46-10.53-1.15-17.25-2.26-5.07-.83-8.07-1.1-12.72-3.26-16-7.45-26.19-17.68-28.27-35.2-.18-1.5-.14-2.36-.14-3.88 0-9.12 3.58-14.68 10.03-21.13-1.66-.4-2.77.16-4.38-.43-4.03-1.46-6.93-4.26-6.93-8.55 0-1.59.07-2.65.85-4.03.55-.97 1.6-1.16 1.84-2.26.32-1.45-.1-2.47.57-3.82.44-.9 1.27-1.07 1.7-1.98 1.39-2.9 3.14-5.23 6.35-5.23 2.76 0 4.53 1.45 5.94 3.82 2.69-1.24 3.43-3.25 4.95-5.8 2.52-4.22 3.67-7.17 3.67-12.08 0-3.43-.33-5.44-1.41-8.7-.78-2.33-1.1-3.92-2.83-5.65a6.83 6.83 0 0 1-5.37 2.12c-4.49 0-7.92-3.85-7.92-8.34a7.51 7.51 0 0 1 4.67-7.2c-2.42-2.1-4.52-2.27-7.21-3.97-4.08-2.58-5.51-5.3-8.2-9.33-1.75-2.63-2.2-4.47-3.1-7.49-1.09-3.64-1.7-5.81-1.7-9.6 0-1 .01-1.58.14-2.55 1-7.67 2.38-12.48 7.2-18.52 2.87-3.59 4.81-5.8 9.05-7.63 3.6-1.56 5.76-2.7 9.68-2.7 1.19 0 1.88 0 3.04.15 1.8.23 2.96.39 4.53 1.27.6.34 1.7 1.35 1.7.64 0-.81-.43-1.24-.43-2.05 0-3.25 2.33-6.22 5.58-6.22 2.35 0 3.3 2.07 4.46 4.1a6.1 6.1 0 0 0 1.13-3.53c0-5.38-2.88-8.12-6.22-12.3-7.28-9.1-16.4-13.36-16.4-25.02 0-3.48 1.68-5.85 4.66-7.64.87-.5 2.03 0 2.88-.54.73-.46.64-1.4 1.1-2.14.73-1.14 1.37-1.64 2.38-2.52 1.66-1.45 3.12-1.02 4.95-2.29.92-.63 1.14-1.46 1.85-2.3 2.05-2.48 3.89-3.68 7.12-3.68 1.62 0 2.54.01 4.04.61.51.2 1.47.97 1.6.82a7.4 7.4 0 0 1 2.24-1.82c1.36-.65 1.9-.9 3.43-.9 1.73 0 2.86.97 4.6.97.63 0 .78-.64 1.3-.97 1.53-1.04 2.41-1.63 4.29-1.63 1.8 0 2.8.6 4.31 1.56 1.43.9 1.64 2.11 3.1 2.96.82.48 1.5.26 2.41.57 4.03 1.34 7.07 4.02 7.07 8.26 0 2.3-.55 3.94-2.26 5.45-1.36 1.2-2.65.99-4.39 1.55 5.62 4.49 10.51 5.6 17.69 5.6 6.57 0 14.6-2.68 14.6-9.26 0-3.05-1.68-4.7-2.88-7.5-2.16-5-3.33-7.95-3.33-13.39 0-4.31.47-6.93 2.98-10.43 2.58-3.6 5.73-4.44 10.17-4.44z'/%3E %3Cg fill='none' stroke='%23703d29'%3E %3Cpath stroke-width='1.04' stroke-linejoin='round' d='M425.59 223.46a5.56 5.56 0 0 0 3.82 3.8 5.9 5.9 0 0 0 5.99-2.17c1.5-1.95 1.4-4.37.83-6.3-.37-1.24-1.37-2.44-2.7-3.47l-7.94 8.06v.08z'/%3E %3Cpath stroke-width='1.04' stroke-linecap='round' d='M626.61 343.94c-1.87-4.5-6.69-2.49-6.98 0-.69 5.73 4.34 7.46 7.91 6.53a6.22 6.22 0 0 0 3.9-3.03 7.54 7.54 0 0 0 .6-5.82 7.66 7.66 0 0 0-1.32-2.59 7.77 7.77 0 0 0-2-1.89c-1.37-.87-2.87-.96-5.22-.96-8.7 0-16.33 10.29-18.89 20.98-.84 3.52-2 11.37-.4 18.81 1.72 7.93 5.15 13.42 9.17 17.59 2.18 2.25 5.14 4.26 8.99 6.43 1.18.67 4.32 2.06 6.5 2.68 2.23.64 4.3.55 6.15.15 5.16-1.12 7.56-5.92 4.96-10.83-2.13-4.02-8.4-6.22-11.35-1.1a5.08 5.08 0 0 0-.63 2.42c.02 1.37.59 3.02 1.56 3.64 2.25 1.43 5.84 1.02 5.68-2.94'/%3E %3Cpath stroke-width='1.28' d='M599.69 403.07c1.75-2.06 5.76-5.14 10.34-5.7 4.66-.58 8.7.78 12.83 3 8.06 4.34 12.55 9 15.55 17.64.76 2.2 1.4 5.5 1.3 9.02-.14 5.6-1.56 11.73-3.09 14.7-1.33 2.58-4.82 13.99-23.94 21.86-11.16 4.6-28.3 5.66-40.12 6.12-16.26.65-31.26 1.25-39.96 11.98'/%3E %3Cg stroke-width='1.12'%3E %3Cpath d='M603.75 421.45c-.47-1.71-.03-3.35 1.32-5.2 1.82-2.5 5.68-3.35 9.18-1.4 1.17.64 2.63 1.5 3.96 3.26.5.66 1.35 1.74 1.79 2.48 1.06 1.82 1.5 3.3 1.7 3.9 3.85 10.92-2.26 22.76-10.25 27.51-6.2 3.7-13.61 5.34-22.47 6.38-3.98.47-6.26.44-10.26.62-3.23.15-6.01.1-8.63.07-2.16-.03-4.21-.02-6.3-.07a110.9 110.9 0 0 0-11.28.16c-4.55.33-7.97.44-11.81 1.09-2.52.41-5.46.82-8.55 1.51-.92.2-1.86.38-2.8.66l-1.89.58c-5.57 1.7-10.98 3.77-15.25 6.52-1.32.85-2.81 1.7-3.88 2.7-.66.63-1.47 1.26-2.12 1.9-3 2.95-6.05 6.13-6.77 10.44-.13.8-.13 1.63-.13 2.5 0 2.8 2.28 6.62 8.42 7.86M516.37 229.11c1.29 2.32 2 3.74 1.24 6.14-.84 2.73-2.77 4.36-5.52 4.36-6.22 0-9.87-7.37-7.07-12.06 4.97-8.31 14.54-3.64 23.4.48-.43-2.13-1.17-2.83-1.1-5.47.2-6.57 5.07-9.54 7.01-15.6 1.16-3.62 1.62-6.76-1.03-9.32-2.3-2.24-4.98-2.2-7.99-1.03-6.02 2.36-13.25 9.14-25.97 9.33-12.72-.19-20.01-6.97-26.03-9.33-3.01-1.18-5.69-1.21-8 1.03-2.64 2.56-2.18 5.7-1.02 9.31 1.95 6.07 6.81 9.04 7 15.6.08 2.65-.66 3.34-1.09 5.48 8.86-4.12 18.8-9.21 23.4-.48 2.57 4.87-.85 12.06-7.07 12.06-2.74 0-4.67-1.75-5.52-4.36-.76-2.32 0-4.35 1.24-6.14'/%3E %3Cpath stroke-linecap='round' d='M491.5 224.79c2.4 1.84 4.1 4.1 3.82 7.77-.31 4-1.28 4.95-4.39 7.07M494.68 233.7c-.14 2.4-1.13 3.96-3.53 4.95'/%3E %3C/g%3E %3Cpath fill='%23c7b37f' d='M432.4 214.49l1.09.78 1.16 1.24.78 1.56.4 1.32.07 1.7-.08 1.17-.39 1.33-.78.93-.93 1.01-1.32.7-1.71.39-1.48.23-1.55-.7-1.4-1-.86-1.25-.62-1.56v-.62l7.62-7.23z' stroke='none'/%3E %3Cpath stroke-width='1.04' stroke-linecap='round' d='M430.01 220.57c-.48-2.58-3.5-3.11-4.66-1.59-1.8 2.35-.49 6.26 3.17 7.4a5.9 5.9 0 0 0 5.99-2.17c1.51-1.96 1.4-4.38.83-6.3-.37-1.24-1.36-2.33-2.7-3.34-4.25-3.24-11.12-2.49-13.37 2.95-2.91 7.02 3.42 12.29 9.25 16.25 7.34 5 15.7 5.9 22 5.83 14.31-.15 25.2-7 32.27-10.88 1.65-.9 3.34-.72 4.2.3a3.11 3.11 0 0 1-.4 4.29'/%3E %3Cpath stroke-width='1.06' d='M387.6 414.35l-3.19 1.17-3.26 2.48-1.4 1.95-1.8 3.1-.77 2.34-.62 2.88-.31 2.17M405.95 414.66l-.23 2.8-.47 1.94-1.4 3.35-2.18 2.87-2.33 1.87-1.7.85-2.42.55'/%3E %3Cpath stroke-width='1.2' d='M499.6 489.23c-.58 2.59-3 5.55-8.28 6.62l-1.02.2'/%3E %3Cpath stroke-width='1.36' d='M631.59 406.57c3.34 3.11 5.69 6.9 7.49 12.1.76 2.2 1.39 5.51 1.3 9.03-.14 5.6-1.56 11.73-3.09 14.7-1.33 2.58-4.82 13.99-23.95 21.86-11.16 4.6-28.3 5.65-40.11 6.12-16.03.63-30.83 1.23-39.59 11.52'/%3E %3Cpath stroke-width='.93' d='M605.45 416.95c1.19-1.62 5.52-3.67 9.02-1.73a9.67 9.67 0 0 1 3.71 3.24'/%3E %3Cpath stroke-width='1.36' d='M627.51 402.79c.78.3 1.56.57 2.24.77 2.24.64 4.34.69 6.16.14 4.42-1.33 7.26-5.46 4.96-10.83a8.84 8.84 0 0 0-2.71-3.33'/%3E %3Cpath stroke-width='1.04' stroke-linecap='round' d='M375.44 287.13c-2.97 1.84-5.18 2.27-7.5 4.95-2.3 4.55-3.2 7-4.1 10.65M435.88 221.96c0 2.69-1.98 4.38-4.66 4.95'/%3E %3Cpath d='M620.49 275.03c7.39-.15 28.86 5.64 29.01 30.88.15 24.92-15.38 29-21.6 30.65'/%3E %3Cpath stroke-width='1.04' d='M622.43 275.03c12.74-.55 25.9 8.83 26.47 32.24.45 18.28-12.52 26.58-18.74 28.24'/%3E %3Cg stroke-width='.88'%3E %3Cpath d='M615.33 363.16l.2-2.5.83-3.98 1.18-3.09 1.32-2.55 1.72-2.06M632.74 343.67l-.2 2.45-.7 1.67-1.08 1.6-1.25.93-1.9.7-1.67.11-1.25-.2M602.33 268.42l.54-2.64 1.17-2.45 1.52-2.45 2.6-3.34 2.06-2.3 3.34-3.38 2.88-2.92 1.83-2.1 2.4-2.91 2.15-3.23 1.28-2.64.7-3.42.21-4.24-.39-1.23M605.44 429.44l2.53-.5 1.9-1.02 1.05-1.05.74-1.2.5-1.94.04-1.37M364.94 403.38l1.87.16 2.4-.2 2.42-.85M379.44 345.38l-.31 2.18-.5.97-.75.93-1 .78-1.13.5-1.48.24-1.01.08M388.73 326.65l-.54 3.38-.66 1.48-1.37 1.87-1.82 1.4-1.87.93-3.61.9M402.76 274.48l-.7 2.02-.85 1.48-1.17 1.63-1.63 1.48-1.95.93-1.63.39-1.01-.08M394.41 272.65l.04 1.55'/%3E %3C/g%3E %3Cg stroke-width='.99'%3E %3Cpath stroke-linecap='round' d='M397.32 325.09a10.71 10.71 0 0 1-3.27 2.03M629.24 397.16c.13.14.58.22.74.31 2.21 1.32 6.58-.33 5.3-3.75'/%3E %3Cpath d='M621.54 349.38c1.57 2.05 4.54 2.59 6.88 1.98a6.22 6.22 0 0 0 3.9-3.03 7.55 7.55 0 0 0 .6-5.83 7.67 7.67 0 0 0-1.32-2.58 10.6 10.6 0 0 0-2.13-2.23c-.17-.11-.34-.26-.52-.38M638.99 390.46a6.13 6.13 0 0 0-1.9-5.71c-.43-.38-.85-.97-1.37-1.23M636.47 384.25c-.07-2.91-2.46-5-5.41-5.51M624.54 383.17c-.68-.55-1.4-1.02-2.04-1.69-3.83-4-6.7-9.92-6.74-16.68-.04-6.47 2.56-13.06 5.6-15.62M533.07 481.44l2.8-2.57 1.94-1.47 3.66-2.26 3.42-1.63 2.4-.62 4.83-1.1 5.6-.85M511.61 501.2c-2.02 3.11-6.84 7.77-11.9 9.64-5.05-1.87-9.87-6.53-11.9-9.64'/%3E %3Cpath stroke-linecap='round' d='M491.28 494.73a15.48 15.48 0 0 1-3.47 6.45'/%3E %3Cpath d='M491.78 491.47l-.7 3.42M487.43 501.42l-1.48 1.48-2.64 1.47-3.03.94M471.46 227.45c.38-1.18.77-2.07.71-4.01-.2-6.57-5.06-9.55-7-15.61-1.16-3.61-1.62-6.75 1.02-9.32 2.3-2.24 4.98-2.2 8-1.02 6.01 2.36 13.3 9.14 26.03 9.33-12.73-.2-20.02-6.97-26.04-9.33-3-1.18-5.93-1.53-8.24.71-2.64 2.57-1.93 6.02-.77 9.63 1.94 6.06 6.56 9.04 6.75 15.6.06 1.95-.45 2.84-.83 4.02M500.18 206.37c12.52-.66 23.25-9.07 26.7-9.76 3.1-.6 4.81-.33 7.08 1.72-2.27-2.05-4.84-1.99-7.77-.84-6.02 2.36-13.25 9.14-25.97 9.32M624.59 383.2a24.29 24.29 0 0 1-9.72-19.27c-.03-6.48 2.57-13.07 5.6-15.63M511.17 500.76c-2.02 3.11-6.84 7.77-11.9 9.64-5.05-1.87-9.87-6.53-11.89-9.64'/%3E %3Cpath stroke-linecap='round' d='M479.17 230.74l3.62-2.02c1.65-.9 3.63-.71 4.49.32.96 1.16 1.1 3.18-.23 4.41'/%3E %3Cpath d='M460.48 239.49c8.59-1.8 15.59-5.64 20.88-8.6M531.78 487.43c.71.48 1.17 1.5 1.17 1.5.2.46.45.9.52 1.32.4 2.38-1.16 3.86-3.09 4.08a5.26 5.26 0 0 1-5.48-3.17M460.04 239.05c8.59-1.8 15.59-5.64 20.88-8.6M633.38 397.49c-1.63.63-2.53.54-4.56-.36-.83-.37-1.79-.94-2.9-1.58-3.98-2.26-8.71-5.82-13.14-14.14a29.4 29.4 0 0 1-3.45-12.2c-.11-3 .21-6.14.96-9.72 1.24-5.93 2.72-9.15 6.37-14.15 1.8-2.47 3.35-3.97 6.7-4.05M398.83 279.88a11.12 11.12 0 0 1 4.12 8.94c0 4.84-4.05 12.75-14 15.55-3.82 1.07-7.59.2-9.87-1.18'/%3E %3Cpath d='M400.46 296.28c1.79 1.24 2.49 2.64 2.49 5.07 0 1.66-1.08 3.82-2.9 5.87-3 3.34-8.1 6.19-13.73 6.26a16 16 0 0 1-9.42-2.74 14.16 14.16 0 0 1-5.98-8.4'/%3E %3Cpath d='M400.3 306.71c2.03 1.86 2.65 4.2 2.65 7.13 0 4.29-1.74 7.6-5.75 11.1-.9.79-1.9 1.52-3.03 2.18M596.4 292.63v5.52M595.96 291.27v7.77M596.4 274.44v10.19M595.96 272.19v13.92M592.99 414.17a29.23 29.23 0 0 1-6.53 8.86c-3.09 3.04-5.22 4.44-9.1 6.38-3.77 1.89-6.14 2.49-10.26 3.42a52.45 52.45 0 0 1-10.73 1.32c-3.86.18-6.05.01-9.9-.25-4.14-.29-6.43-.86-10.55-1.23-3.4-.3-5.32-.57-8.74-.56-3.51 0-5.52.03-8.98.64a34.42 34.42 0 0 0-8.09 2.26c-4.2 1.7-8.94 4.66-9.95 5.98-1.01-1.32-5.75-4.28-9.95-5.98a34.42 34.42 0 0 0-8.09-2.26 44.73 44.73 0 0 0-8.98-.64c-3.42-.01-5.34.26-8.74.56-4.13.37-6.42.94-10.54 1.23-3.86.26-6.05.43-9.91.25a52.26 52.26 0 0 1-10.73-1.32c-4.12-.93-6.49-1.54-10.26-3.42-3.88-1.94-6.02-3.34-9.1-6.38l-.95-.95M478.8 505.47l2.8-.35M528.9 501.44l2.83-.27 2.69-1.08 1.88-1.14 2.56-3.03.53-1.14.4-2.62.14-1.21M613.23 277.36c1.21-4.13-.27-8.48-4.27-8.37M402.79 341.75a12.78 12.78 0 0 1-5.62 7.3M402.86 276.05c-1 2.89-2.83 4.95-5.72 6.26-2.89 1.3-6.23.09-8.02-1.3'/%3E %3Cpath stroke-linecap='round' d='M380.95 291.2c2.4 1.25 4.82-.58 4.32-3.7a4.45 4.45 0 0 0-3.93-3.43'/%3E %3Cpath d='M390.87 422.86c.52.49.63 1.11 1.32 1.24 1.05.2 1.87.59 2.92-.81 1.3-1.73.6-4.41-.75-6.1-1.44-1.8-5.61-3.4-9.11-1.46a11.6 11.6 0 0 0-3.97 3.26c-.5.67-1.35 1.74-1.79 2.5-1.05 1.8-1.49 3.28-1.7 3.88-3.2 9.1.6 18.66 6.49 24.5'/%3E %3Cpath stroke-linecap='round' d='M531.59 487.23a9.2 9.2 0 0 1 1.01 1.24c.2.47.36.92.43 1.33.4 2.38-1.16 3.86-3.08 4.09-2.65.3-4.42-1.26-5.27-3.16'/%3E %3Cpath d='M608.5 216.81c5.23.64 9.78 5.63 9.78 11 0 6.91-2.33 9.49-5.97 14.44-3.9 5.3-16.64 15-16.64 26.04 0 6.69 1.87 10.96 6.69 13.14 3.1 1.4 6.74-.11 8.4-1.6 4.04-3.66 2.42-10.07-1.8-10.84-5.13-.93-6.09 7.15-1.08 6.61M635.73 383.51a5.77 5.77 0 0 0-5.65-4.88 5.8 5.8 0 0 0-5.73 5.87c0 1.59.62 3.03 1.62 4.09'/%3E %3Cpath d='M599.79 279.88a11.12 11.12 0 0 0-4.12 8.94c0 4.84 4.05 12.75 14 15.55 3.81 1.07 7.46.97 9.74-.42M375.61 287.8c-2.38.8-5.35 2.28-7.55 5.4-1.86 2.63-2.94 6.28-3.6 9.48-.3 1.4-.65 5.83.24 10.41a24.61 24.61 0 0 0 3.6 8.8 12.4 12.4 0 0 0 1.63 1.94c.51.52 1.25.97 1.77 1.37M471.72 469.02c7.58 3.36 13.13 5.87 17.84 13.31 1.48 2.33 1.87 5.68 1.87 7.62 0 4.2-1.72 8.94-5.21 11.9-3.25 2.74-6.46 3.57-10.42 3.18-3-.3-5.83-2.49-6.3-4.04M396.88 325.2c4.28 3.34 6.06 6.59 6.06 11.74 0 5.9-2.87 9.56-6.22 11.66'/%3E %3Cpath stroke-linecap='round' d='M392.99 344.41c6.38 7.93 9.76 12.64 9.95 22.08.18 8.86-2.64 14.93-7.93 21.3'/%3E %3Cpath d='M515.23 239.57a6.43 6.43 0 0 0 2.5-3.48c.75-2.33.77-4.31-.48-6.1 1.54 2 1.68 3.7 1.25 6.14-.28 1.55-1.27 2.37-2.5 3.49M596.4 374.24v25.24h.07c0 .02-.01 2.39-.22 3.89-.13.98-.27 1.87-.42 2.7'/%3E %3Cpath d='M595.96 371.81v27.22h.07c0 .02-.01 2.4-.21 3.9a42.94 42.94 0 0 1-.73 4.11M595.96 339.94v22.7M596.4 341.73v18.46M596.4 318.25v13.84M595.96 316.62v17.06M596.4 304.1v5.37M595.96 303.01v7.78M593.08 412.65l-.53 1.08a29.22 29.22 0 0 1-6.53 8.87c-3.09 3.04-5.22 4.43-9.1 6.37-3.77 1.9-6.14 2.5-10.26 3.42a52.44 52.44 0 0 1-10.73 1.33c-3.86.17-6.05 0-9.9-.26-4.14-.29-6.43-.86-10.55-1.22-3.4-.3-5.32-.58-8.74-.57-3.51.01-5.52.03-8.98.65a34.41 34.41 0 0 0-8.09 2.25c-4.2 1.7-8.94 4.66-9.95 5.99-1.01-1.33-5.75-4.29-9.95-5.99a34.4 34.4 0 0 0-8.09-2.25 44.75 44.75 0 0 0-8.98-.65c-3.42 0-5.34.27-8.74.57-4.13.36-6.41.93-10.54 1.22-3.86.27-6.05.43-9.91.25a52.24 52.24 0 0 1-10.73-1.32c-4.12-.93-6.49-1.53-10.26-3.42-3.88-1.94-6.01-3.33-9.1-6.37-1.62-1.6-2.8-2.9-3.86-4.36M406.42 413.26c.67 4.94-1.41 9.8-3.52 12.03-1.32 1.4-4.2 4.08-7.78 4.12-5.9.08-7.67-3.98-8.03-4.97'/%3E %3Cpath d='M399.4 410.7c1.1 1.08 2.07 2.4 2.9 3.96 1.47 2.8 1.02 7.49-.15 9.65-.13.23-.3.49-.48.74M370.04 453.2c3.51 3.69 8.83 7.7 16.99 11.05 11.16 4.6 28.3 5.66 40.12 6.12 15.71.62 30.2 1.27 39 11M493.29 475.01c2.6 2.56 5.25 5.3 6.37 8.8M488.18 501.7c-.34.36-.7.7-1.08 1.03-3.25 2.74-6.46 3.58-10.42 3.19-3-.3-5.9-2.55-6.69-4.03M461.63 497.35c.14.2.3.4.46.58a11.88 11.88 0 0 0 7.97 3.83M512.05 501.64c-2.02 3.11-6.84 7.77-11.9 9.64-5.05-1.87-9.87-6.53-11.9-9.64l-.46-.73M512.13 501.62c.36.4.75.76 1.16 1.1 3.24 2.75 6.45 3.59 10.41 3.2 3.01-.3 5.4-2.3 6.36-4.05 0 0 .54-.58.7-1.13'/%3E %3Cpath d='M529.75 500.99l-1.16 1.87-1.77 1.46-2.67 1.11-2.42.1'/%3E %3Cpath d='M536.03 483.22a12 12 0 0 1 3.6 4.53c.49 1.15.72 2.4.79 3.7a9.15 9.15 0 0 1-2.23 6.48 11.74 11.74 0 0 1-9.16 3.86M529.32 501.35c-3.17.13-6-1.23-8.1-3.38M620.72 391.93a37.1 37.1 0 0 1-7.5-10.08 29.38 29.38 0 0 1-3.46-12.2c-.1-3 .22-6.13.97-9.72 1.23-5.93 3.44-10.51 6.37-14.15 1-1.24 2.16-2.8 3.25-3.49M618.2 223.83c3.97.31 7.64 4.58 7.59 8.76-.07 6.08-2.1 8.6-6.89 14.55-4.12 5.13-16.48 14.15-16.17 22.78.05 1.53.88 3.11 1.8 4.39M599.59 279.72c.88.87 1.94 1.58 3.2 2.16 2.27 1.02 4.8.5 6.66-.45M576.37 213.9c1.33.9 2.68 2.3 3.42 4.06 2.9 7.02-3.43 12.29-9.26 16.25a33.33 33.33 0 0 1-12.97 5.13'/%3E %3Cpath d='M569.69 227.43c-1.41-.01-3.1-.42-4.92-2.34a5.23 5.23 0 0 1-1.1-1.55M540.45 231.2a7.22 7.22 0 0 1-2.06-1.5c-1.39-1.55-2.31-3.65-1.24-6.86.98-2.96 5.74-11.27 5.97-17.02.36-8.8-3.02-13.98-8.3-16'/%3E %3Cpath stroke-linecap='round' d='M542.68 203.85l-.2 3.3-.9 3.38-1.72 4.61-1.31 2.96-1.38 2.96-.69 2.07-.27 1.51.2 1.45M595.81 423.4c.27.66.93 1.3.93 1.3 1.01 1.7 4.94 4.66 8.52 4.7 5.9.09 7.3-4.05 7.46-4.97.75-4.5-.8-5.74-3.1-7.01 0 0-1.37-.7-3-.43'/%3E %3Cpath d='M370.23 403.67c-2.09.53-4.05.55-5.76.03-4.42-1.32-8-5.56-6.18-10.83M379.21 343.15c.44.44.59 1.1.65 1.67.69 5.73-4.34 7.4-7.91 6.47a8.8 8.8 0 0 1-4.71-3.56 7.35 7.35 0 0 1-.97-3.6M400.74 307.15c.9.82 1.52 1.74 1.93 2.76M400.9 296.6a5.98 5.98 0 0 1 1.82 2.04'/%3E %3Cpath stroke-linecap='round' d='M402.91 303.94a13.22 13.22 0 0 1-2.43 3.72c-3 3.34-8.08 6.19-13.72 6.26a16 16 0 0 1-9.42-2.74c-3.41-2.28-5.64-5.53-6.37-8.71'/%3E %3Cpath d='M399.11 280.13a12.11 12.11 0 0 1 3.7 5.3'/%3E %3Cpath stroke-linecap='round' d='M402.86 292.56c-1.38 4.57-5.51 10.23-13.47 12.25-3.8.96-8.7-.24-10.38-1.67'/%3E %3Cpath d='M375.06 291.49c.42 4.12 3.17 7.2 8.4 7.3 7.35.15 11.82-10.57 5.29-18.09'/%3E %3Cpath stroke-linecap='round' d='M358.52 327.39a25.45 25.45 0 0 0 3.63 3.64 26.24 26.24 0 0 0 9.27 5.15M379.67 336.95c6.57-.79 10.27-5.68 9.54-11.41-.56-4.36-4.56-7.72-7.29-7.91'/%3E %3Cpath d='M390.39 268.92c2.85-.1 4.47 2.48 4.44 4.66'/%3E %3Cpath stroke-linecap='round' d='M389.72 229.81a17.95 17.95 0 0 0 7.86 9.1M622.86 287.29c2.69 3.68.93 10.93-6.38 11.07a8.1 8.1 0 0 1-6.94-3.92'/%3E %3Cpath d='M596.4 239.25v24.69'/%3E %3Cpath stroke-linecap='round' d='M380.87 291.14c2.25 1.63 5.15-1.12 4.03-4.05-.76-1.97-3.56-4.1-7.45-1.46-4.3 2.92-3.11 12.13 5.13 12.28 7.35.14 11.82-10.57 5.29-18.1-6.29-7.23-17.73-5.53-25.2.4-3.17 2.53-9.17 9.15-11.03 18.17-.58 2.8-.96 5.11-.91 7.93.02 1.85.2 3.93.75 6.53a32.6 32.6 0 0 0 4.8 11.74c.71 1.03 1.35 1.87 2.04 2.56 1.28 1.28 1.67 1.96 2.96 3.04 4.22 3.51 9.66 6.27 16.32 5.98 7.31-.3 11.51-5.44 10.73-11.5-.75-5.88-6.69-8.8-10.57-6.07-2.64 1.87-3.58 7.65 1.09 9.02 2.64.78 4.97-2.57 3.1-4.5M584.4 210.68c4.22-2.3 7.47-1.87 9.87 1.47 2.62 3.63 2.99 8.45 2.41 11.28-.85 4.2-2.06 5.94-5.4 8.99'/%3E %3Cpath stroke-linecap='round' d='M594.58 212.55c4.82-3.19 10.04-1.83 12.9 2.41 2.1 3.11 2.64 5.71 2.5 9.56-.26 6.6-4.39 11.83-8.95 14.39'/%3E %3Cpath d='M617.28 223.67c3.96.31 7.15 3.9 7.15 8.09 0 5.98-1.67 8.58-6.45 14.53-4.12 5.14-16.48 14.15-16.17 22.78.12 3.27 2.87 6.34 5.24 6.51'/%3E %3Cpath stroke-linecap='round' d='M617.75 291.14c-2.25 1.63-5.13-1-3.89-3.8.86-1.94 3.42-4.36 7.31-1.71 4.3 2.92 3.11 12.13-5.13 12.28-7.35.14-12.32-10.3-5.29-18.1 6.42-7.1 18.32-5.72 25.78.22 3.18 2.53 9.57 9.47 10.94 18.58 1.65 11.02 1.44 24.57-9.94 32.92-4.58 3.35-10.92 4.88-16.52 4.63-7.3-.32-11.5-5.44-10.72-11.5.75-5.88 6.41-8.37 10.57-6.07 4.32 2.4 3.56 8.47-1.09 9.02-2.74.33-4.98-2.56-3.1-4.5'/%3E %3Cpath d='M613.86 287.34c1.21-5.45 5.88-5.96 9.66-5.9 10.3.14 17.41 12.36 17.53 24.17.15 14.92-6.33 23.71-17.24 24.18-2.82.12-7.68-1.22-7.77-4.67'/%3E %3Cpath stroke-linecap='square' d='M620.2 284.9c10.86 2.41 14.67 12.2 14.67 21.53 0 7.62-.75 18.02-15.57 21.68'/%3E %3Cpath d='M638.11 389.58a6.1 6.1 0 1 0-9.79 3.66'/%3E %3Cpath stroke-linecap='round' d='M616.33 380.33c2.04 3.03 4.52 6.4 9.74 9.24M624.11 406.05c-5.12-3.36-14.84-7.76-23.62-3.43-3.26 1.61-5.45 3.6-6.68 6.84-2.22 5.84.26 12.28 2.79 14.95 1.32 1.4 4.2 4.07 7.77 4.12 5.91.08 7.32-4.06 7.47-4.97.7-4.28-1.8-6-3.11-6.46-1.02-.35-4.31-.26-5.01 2.07-.24.78-.28 2.13.34 3.14'/%3E %3Cpath stroke-linecap='round' d='M531.99 488.16c1.63 3.34-.22 5.02-2.49 5.29-3.34.39-5.13-2.26-5.36-4.67a6.87 6.87 0 0 1 6.84-7.38c3.53.05 6.41 2.33 7.76 5.47.5 1.14.72 2.4.8 3.7a9.14 9.14 0 0 1-2.23 6.47c-2 2.33-5.11 3.74-8.43 3.87-6.6.27-11.74-5.9-11.74-12.2 0-12.06 17.87-18.63 24.96-20.32 8.7-2.08 14-2.86 27.99-3.63 5.6-.31 9.7-.16 15.86-.8 5.51-.57 8.4-.83 14.07-2.16 7.08-1.65 13.68-4.58 19.6-9.95 4.54-4.13 7.14-7.07 9.25-12.75 1.82-4.9 2.65-14.6-1.95-21.77-4.07-6.34-9.72-9.63-16.17-10.56-5.83-.85-10.94 1.67-14 7.45-1.47 2.8-1.02 7.48.15 9.64 1.01 1.87 3.9 4.62 7.47 4.67 5.91.08 7.32-4.06 7.47-4.98.7-4.27-1.8-5.98-3.11-6.45-1.02-.36-4.32-.27-5.02 2.07-.23.77-.27 2.13.35 3.14'/%3E %3Cpath stroke-linecap='round' d='M526.9 469.02c-7.58 3.36-13.13 5.87-17.84 13.31-1.48 2.33-1.87 5.68-1.87 7.62 0 4.2 1.72 8.94 5.21 11.9 3.25 2.74 6.46 3.57 10.42 3.18 3-.3 5.83-2.49 6.3-4.04'/%3E %3Cpath d='M601.73 325.2c-3.54 1.18-6.06 6.59-6.06 11.74 0 5.9 2.87 9.56 6.22 11.66'/%3E %3Cpath stroke-linecap='round' d='M605.62 344.41c-6.38 7.93-9.76 12.64-9.95 22.08-.18 8.86 2.64 14.93 7.93 21.3'/%3E %3Cpath d='M571.64 212.58l.55-.81c2.64-3.89 7.3-4.91 10.73-2.33 4.12 3.1 5.16 8.4 4.04 14-.7 3.5-3.07 6.4-6.33 8.51'/%3E %3Cpath stroke-linecap='round' d='M414.22 210.68c-4.04-1.87-7.37-1.5-9.87 1.47-2.88 3.42-3 8.45-2.41 11.28.85 4.2 2.06 5.94 5.4 8.99'/%3E %3Cpath d='M404.03 212.55c-4.82-3.19-10.04-1.83-12.9 2.41-2.1 3.11-2.64 5.71-2.5 9.56.26 6.6 4.39 11.83 8.95 14.39'/%3E %3Cpath d='M390.12 216.81c-5.23.64-9.4 5.07-9.4 10.43 0 6.92 1.7 9.72 5.59 15 3.9 5.3 16.64 15.01 16.64 26.05 0 6.69-1.87 10.96-6.69 13.14-3.1 1.4-6.74-.11-8.4-1.6-4.04-3.66-2.42-10.07 1.8-10.84 5.12-.93 6.09 7.15 1.08 6.61'/%3E %3Cpath d='M381.33 223.67c-3.97.31-7.87 3.72-7.87 7.9 0 6 2.39 8.77 7.17 14.72 4.12 5.14 15.76 13.98 15.45 22.6-.12 3.27-2.31 7.26-4.49 6.8'/%3E %3Cpath stroke-linecap='round' d='M372 343.94c1.87-4.5 6.69-2.49 6.98 0 .69 5.73-4.34 7.46-7.91 6.53a6.22 6.22 0 0 1-3.9-3.03 7.55 7.55 0 0 1-.6-5.82c.27-.93.65-1.71 1.32-2.59a7.77 7.77 0 0 1 2-1.89c1.37-.87 2.87-.96 5.22-.96 8.7 0 16.33 10.29 18.89 20.98.84 3.52 2 11.37.4 18.81-1.72 7.93-5.15 13.42-9.17 17.59-2.17 2.25-5.14 4.26-8.99 6.43a38.65 38.65 0 0 1-6.5 2.68c-2.23.64-4.33.7-6.15.15-4.42-1.33-7.26-5.46-4.96-10.83 1.79-4.18 8.4-6.22 11.35-1.1.25.44.64 1.4.63 2.42-.02 1.37-.59 3.02-1.56 3.64-2.25 1.43-5.84 1.02-5.68-2.94'/%3E %3Cpath d='M365.24 397.49c1.63.63 2.53.54 4.56-.36.83-.37 1.79-.94 2.9-1.58 3.98-2.26 8.71-5.82 13.14-14.14a29.38 29.38 0 0 0 3.45-12.2c.11-3-.21-6.14-.96-9.72-1.24-5.93-2.72-9.15-6.37-14.15-1.8-2.47-3.35-3.97-6.7-4.05M360.51 389.58a6.1 6.1 0 1 1 9.79 3.66'/%3E %3Cpath d='M362.88 383.51a5.77 5.77 0 0 1 5.65-4.88 5.8 5.8 0 0 1 5.73 5.87c0 1.59-.62 3.03-1.62 4.09'/%3E %3Cpath d='M374.02 383.2a24.29 24.29 0 0 0 9.72-19.27c.03-6.48-2.57-13.07-5.6-15.63'/%3E %3Cpath stroke-linecap='round' d='M382.29 380.33c-2.04 3.03-4.52 6.4-9.74 9.24'/%3E %3Cpath d='M397.81 402.63c-1.45-3.4-4.33-4.99-9.02-5.49-4.66-.5-8.7.79-12.83 3-8.06 4.34-12.55 9-15.55 17.65-.76 2.2-1.39 5.5-1.3 9.02.14 5.6 1.56 11.73 3.1 14.7 1.33 2.58 4.81 13.99 23.94 21.86 11.16 4.6 28.3 5.66 40.12 6.12 16.25.64 31.25 1.25 39.96 11.97'/%3E %3Cpath stroke-linecap='round' d='M374.5 406.05c5.12-3.36 14.84-7.76 23.62-3.43 3.26 1.61 5.45 3.6 6.68 6.84 2.22 5.84-.26 12.28-2.79 14.95-1.32 1.4-4.2 4.07-7.77 4.12-5.91.08-7.32-4.06-7.47-4.97-.7-4.28 1.8-6 3.11-6.46 1.02-.35 4.31-.26 5.01 2.07.24.78.28 2.13-.34 3.14'/%3E %3Cpath d='M394.86 421.45c.47-1.71.23-3.5-1.32-5.2-1.56-1.72-5.68-3.35-9.18-1.4a11.6 11.6 0 0 0-3.96 3.26c-.5.66-1.35 1.74-1.79 2.48-1.06 1.82-1.5 3.3-1.7 3.9-3.85 10.92 2.41 22.52 10.25 27.51 6.85 4.36 13.84 5.6 22.47 6.38 4 .36 6.26.44 10.27.62 3.22.15 6 .1 8.63.07 2.15-.03 4.2-.02 6.3-.07 3.4-.08 6.94-.16 11.27.16 4.55.33 7.97.44 11.81 1.09 2.52.41 5.46.82 8.55 1.51.92.2 1.86.38 2.8.66l1.89.58c5.57 1.7 10.98 3.77 15.25 6.52 1.32.85 2.84 1.67 3.88 2.7.8.8 1.47 1.26 2.12 1.9 3 2.95 6.05 6.13 6.77 10.44.13.8.13 1.63.13 2.5 0 2.8-2.28 6.62-8.42 7.86'/%3E %3Cpath d='M466.62 488.16c-1.63 3.34.22 5.02 2.49 5.29 3.34.39 5.13-2.26 5.36-4.67a6.87 6.87 0 0 0-6.84-7.38c-3.53.05-6.41 2.33-7.76 5.47-.5 1.14-.72 2.4-.8 3.7a9.15 9.15 0 0 0 2.23 6.47c2 2.33 5.11 3.74 8.43 3.87 6.6.27 11.74-5.9 11.74-12.2 0-12.06-17.87-18.63-24.96-20.32-8.7-2.08-14-2.86-27.99-3.63-5.6-.31-9.7-.16-15.86-.8-5.51-.57-8.4-.83-14.07-2.16-7.08-1.65-13.68-4.58-19.6-9.95-4.54-4.13-7.14-7.07-9.25-12.75-1.82-4.9-2.65-14.6 1.95-21.77 4.07-6.34 9.72-9.63 16.17-10.56 5.83-.85 10.94 1.67 14 7.45 1.47 2.8 1.02 7.48-.15 9.64-1.01 1.87-3.9 4.62-7.47 4.67-5.91.08-7.32-4.06-7.47-4.98-.7-4.27 1.8-5.98 3.11-6.45 1.02-.36 4.32-.27 5.01 2.07.24.77.28 2.13-.34 3.14'/%3E %3Cpath stroke-linecap='round' d='M426.97 212.58l-.55-.81c-2.64-3.89-7.3-4.91-10.73-2.33-4.12 3.1-5.16 8.4-4.04 14 .7 3.5 3.07 6.4 6.33 8.51'/%3E %3Cpath d='M573.04 224.37c-6.3 6.84-12.6 9.03-22 9.33-2.94.1-8.56-.93-11.82-3.26-2.1-1.5-4.43-4.05-2.96-8.48 1-2.96 5.75-11.27 5.98-17.03.36-8.79-3.02-13.6-8.3-15.47-9.78-3.45-20.27 6.21-26.6 8.32a21.34 21.34 0 0 1-8 1.24 21.63 21.63 0 0 1-8.07-1.24c-6.33-2.1-16.82-11.77-26.6-8.32-5.28 1.87-8.66 6.68-8.3 15.47.23 5.76 4.99 14.07 5.97 17.03 1.48 4.43-.85 6.99-2.95 8.48-3.27 2.33-8.88 3.35-11.82 3.26-9.4-.3-15.7-2.49-22-9.33'/%3E %3Cpath stroke-linecap='round' d='M464.58 466.27c1.25.49.3-.3 8.2 3.2 7.57 3.36 12.95 6.3 17.66 13.74 1.48 2.33 1.86 5.67 1.86 7.62 0 1.25-.15 2.55-.45 3.84'/%3E %3Cpath d='M465.09 500.06c1.54.77 3.28 1.22 5.08 1.29 6.6.26 11.74-5.91 11.74-12.2 0-4.37-2.38-8.05-5.7-11'/%3E %3Cpath stroke-linecap='round' d='M466.52 488.15c-1.6 3.55.68 5.47 2.94 5.74 3.34.39 5.22-2.26 5.46-4.67a6.98 6.98 0 0 0-3.28-6.48'/%3E %3Cpath d='M609.53 216.87c5.02 0 9.4 5.59 9.4 11.32 0 6.6-3.52 10.65-6.1 13.7-2.07 2.46-4.3 4.66-6.98 7.35'/%3E %3Cpath stroke-linecap='round' d='M603.58 211.58c1.7.79 3.2 2.13 4.35 3.82 2.1 3.1 2.63 5.71 2.48 9.56-.25 6.6-5 11.17-9.24 13.96M593.71 211.58c.35.3.68.63 1 1.01 2.88 3.43 3.1 8.48 2.41 11.29-1.03 4.2-2.43 6.02-5.85 8.54M583.36 209.85c4.12 3.11 5.35 8.49 3.98 14.03-.97 3.95-3.46 6.32-6.56 8.21M598.16 296.28c.5 1.45 1.3 1.95 2.33 3.02a21.15 21.15 0 0 0 9.62 5.5c3.82 1.08 7.25.27 9.88-1.36M365.29 387.87c1.94-.04 3.87 1.27 5.13 3.47.25.43.64 1.38.63 2.4-.01 1.38-.61 2.84-1.6 3.46-2.24 1.43-6.22.82-6.06-3.15'/%3E %3Cpath d='M377.33 336.4c7.7 1.44 15.12 10.73 17.55 20.86.84 3.53 2 11.38.4 18.82-1.72 7.93-5.15 13.42-9.17 17.59-.95.98-2.06 1.92-3.32 2.85l-1.64 1.11M368.76 378.67c3.16 0 5.93 3.03 5.93 6.27 0 1.6-.61 3.03-1.61 4.09'/%3E %3Cpath d='M366.62 382.35c3.3 0 6.43 3.18 6.43 6.55a6.1 6.1 0 0 1-2.31 4.78'/%3E %3Cpath stroke-linecap='round' d='M396.84 349.2c3.03 4.06 5.03 7.56 5.95 12.07M402.69 374.53a26.98 26.98 0 0 1-2.26 6.32 27.85 27.85 0 0 1-5.56 7.25'/%3E %3Cpath d='M397.32 325.52c2.92 2.28 4.68 4.64 5.5 7.47'/%3E %3Cpath stroke-linecap='round' d='M402.9 317.92c-.77 2.66-2.5 4.67-5.27 7.2M383.33 298.27l3.37-.89 2-1.5 1.28-1.82 1.1-2.84.45-2.3'/%3E %3Cpath d='M376.51 286.41c-1.06.27-2.41.66-3.82 1.33-1.9.9-3.9 2.3-5.51 4.58-1.86 2.63-2.94 6.28-3.6 9.48-.3 1.4-.65 5.84.24 10.41a24.61 24.61 0 0 0 3.6 8.81c.56.82 1.06 1.52 1.63 2.09 2.02 2.02 3.88 3.26 7 2.64'/%3E %3Cpath stroke-linecap='round' d='M395.38 271.58c-.55 2-1.62 4.5-4.77 4.22'/%3E %3Cpath d='M383.87 285.2c-3.02-2.96-9.43-3.73-15.8.3-.82.52-1.64 1.19-2.45 1.86-.87.73-1.57 1.57-2.25 2.48-.73 1-1.63 2.68-2.18 3.8a19.54 19.54 0 0 0-1.47 4.14 31.74 31.74 0 0 0-1.02 9.78c.17 1.51.32 2.9.56 4.18a29.13 29.13 0 0 0 3.48 9.66c1.4 2.33 4.9 7.69 12.06 8.4 2.8.27 7.61-1.01 7.77-4.67'/%3E %3Cpath stroke-linecap='round' d='M568.38 220.42c.48-2.58 3.59-3.08 4.76-1.55 1.8 2.34.6 6.38-3.05 7.52a5.9 5.9 0 0 1-5.99-2.18c-1.51-1.95-1.4-4.37-.83-6.3.36-1.24 1.36-2.32 2.7-3.34 4.25-3.23 11.11-2.48 13.37 2.96 2.9 7.02-3.42 12.28-9.25 16.25-7.34 4.99-15.7 5.9-22 5.83-14.31-.16-25.2-7-32.27-10.89-1.65-.9-3.35-.72-4.2.31a3.11 3.11 0 0 0 .39 4.28'/%3E %3Cpath stroke-linecap='round' d='M571.26 218c1.52.07 1.92.66 2.39 1.27 1.8 2.35.48 6.38-3.18 7.52M598.34 307.33c-5.45 5.93-.44 16.12 3.64 18.42 1.4 1.1 2 .51 3.14 1.17'/%3E %3Cpath d='M598.63 295.99c-1.79 1.24-2.42 2.64-2.49 5.07-.06 2.03.3 4.29 2.2 6.27 2.98 3.1 8.8 5.79 14.43 5.86a16 16 0 0 0 9.42-2.74 14.16 14.16 0 0 0 5.98-8.4M595.58 398.6c0 .02 0 2.39-.21 3.89a29.5 29.5 0 0 1-3.27 10.8 29.23 29.23 0 0 1-6.53 8.87c-3.08 3.04-5.22 4.43-9.1 6.37-3.77 1.9-6.14 2.5-10.26 3.42a52.45 52.45 0 0 1-10.73 1.33c-3.86.17-6.05 0-9.9-.26-4.13-.28-6.42-.86-10.54-1.22-3.4-.3-5.33-.58-8.75-.57-3.5.01-5.52.03-8.98.65a34.41 34.41 0 0 0-8.09 2.25c-4.2 1.7-8.94 4.67-9.95 5.99-1-1.32-5.75-4.29-9.95-5.99a34.41 34.41 0 0 0-8.09-2.25 44.76 44.76 0 0 0-8.98-.65c-3.42 0-5.34.27-8.74.57-4.12.36-6.41.94-10.54 1.22-3.86.27-6.05.43-9.9.26-4.22-.2-6.63-.4-10.74-1.33s-6.49-1.53-10.26-3.42c-3.87-1.94-6.01-3.33-9.1-6.37a29.22 29.22 0 0 1-6.53-8.87 29.51 29.51 0 0 1-3.26-10.8c-.2-1.5-.22-3.87-.22-3.89V239.58h192.55V398.6h.07z'/%3E %3C/g%3E %3Cg fill='%23c7b37f' stroke='%23c7b37f'%3E %3Cpath stroke-width='.51' d='M387.41 421.32a3.9 3.9 0 1 1 7.81 0 3.9 3.9 0 0 1-7.81 0zM363.42 393.71c0-1.93 1.24-3.5 2.76-3.5s2.76 1.57 2.76 3.5-1.24 3.5-2.76 3.5-2.76-1.57-2.76-3.5z'/%3E %3Cpath d='M377.05 324.36c0-1.59 1.2-2.87 2.66-2.87 1.48 0 2.67 1.28 2.67 2.87s-1.2 2.87-2.67 2.87-2.66-1.28-2.66-2.87zM424.91 221.81c-.17-1.6.79-3 2.13-3.14 1.35-.14 2.58 1.04 2.75 2.63.17 1.6-.79 3-2.14 3.14-1.34.14-2.57-1.04-2.74-2.63z' stroke='none'/%3E %3C/g%3E %3Cg stroke='%23c7b37f' stroke-width='.99' stroke-linecap='round'%3E %3Cpath d='M373.92 340.54c-.57.25-.9.46-1.32.91-.41.43-.5.59-.82 1.3-.23.52-.3 1.12-.38 1.86M378.77 386.4c.54-.66.87-1.01 1.4-1.69.43-.56.68-.87 1.06-1.47.35-.54.5-.86.8-1.43.43-.8.65-1.25 1.05-2.06M381.11 401.53c-.92.42-1.47.61-2.37 1.09-.68.36-1.06.6-1.71 1-.78.49-1.2.77-1.95 1.3-.76.57-1.16.94-1.9 1.53M396.56 347.25c-.5-.52-.77-.82-1.28-1.32-.54-.53-.83-.84-1.4-1.32-.56-.47-.91-.69-1.5-1.12'/%3E %3Cpath stroke-linecap='butt' d='M397.17 326.47c-.74.33-1.13.6-1.9.85-.89.29-1.49.44-2.34.48'/%3E %3Cpath d='M371 300.68c.25.9.31 1.45.65 2.32.43 1.1.8 1.69 1.45 2.67.68 1.03 1.1 1.6 1.99 2.46.77.76 1.26 1.14 2.17 1.73.86.57 1.42.76 2.32 1.25M378.04 301.95c.76.4 1.15.71 1.94 1.04.72.3 1.15.43 1.9.6 1.04.24 1.64.3 2.7.32 1.13.03 1.47 0 2.9-.23M398.69 240.15c-1.25-.73-2-1.05-3.2-1.87a19.05 19.05 0 0 1-2.92-2.37 14.57 14.57 0 0 1-1.81-2.02c-.56-.76-.78-1.26-1.28-2.06M401.2 224.72c.4 1.05.5 1.68 1 2.68.68 1.36 1.2 2.07 2.23 3.19 1.41 1.55 2.61 2 4.28 3.27M410.98 224.61c.39.94.5 1.52 1 2.41.43.79.72 1.2 1.3 1.9.72.9 1.2 1.36 2.1 2.07 1.04.82 1.79 1.06 2.93 1.74'/%3E %3C/g%3E %3Cpath fill='%23703d29' stroke-width='.28' d='M520.78 211.91c-.08-2.65-2.69-2.92-3.69-2.92-2.88 0-3.67 1.8-7.27 3.73-4.5 2.42-6.45 2.96-10.46 3-4.01-.04-6-.58-10.52-3-3.6-1.93-4.2-3.68-7.09-3.68a3.64 3.64 0 0 0-3.51 3.84s-.03.8.1 1.34c.04.2.29.14.36.32-.03-1.2.21-1.82.8-2.63a3.42 3.42 0 0 1 2.54-1.31c2.89 0 3.96 1.85 7.56 3.78 4.51 2.42 6.45 2.96 10.46 3 4.01-.04 6-.58 10.52-3 3.6-1.93 4.63-3.94 7.52-3.94 1 0 1.7.65 2.03 1.67.2.63.1 1.04.14 1.3.03.11.18.1.21.23.1-.46.33-.63.3-1.73z'/%3E %3C/g%3E %3Cg fill='%23703d29'%3E %3Cpath d='M413.12 434.42c.81-.87 1.42-.54 1.57-.95.11-.3-.13-.32-.46-.45-.44-.16-.9-.26-1.34-.42-.46-.17-.87-.4-1.33-.58-.19-.07-.63-.29-.75.04-.23.61 1.6.56.99 2.2-.1.28-.37.88-1.28 1.88l-4.14 4.5c-.09.11-.24.33-.34.3-.1-.04-.08-.31-.08-.45l.06-6.4c0-1.2.1-2.1.3-2.63.28-.73 1.12-.12 1.3-.6.1-.29.02-.3-.48-.49-.25-.1-.73-.2-1.74-.57-.53-.2-1.04-.47-1.56-.66-.24-.1-.67-.41-.83 0-.05.13.12.31.16.35.58.41.73.69.74 1.47l.11 11.63c.01.84.1 1.08.26 1.13.17.07.3 0 .64-.4l8.2-8.9z'/%3E %3Cpath d='M417.95 436.22c.53-1.69 1.53-.67 1.72-1.28.07-.21 0-.27-.48-.42-.91-.29-1.51-.4-2.09-.58-.56-.18-1.16-.45-1.78-.64-.15-.05-.53-.23-.63.07-.2.63 1.77.7 1.26 2.32l-2.7 8.54c-.52 1.69-1.53.86-1.73 1.49-.03.08-.03.22.11.26.42.14 1.13.28 1.82.5 1.25.4 1.82.65 2.41.84.37.11.53.09.6-.1.18-.58-1.88-.32-1.19-2.51l2.68-8.49zM423.73 437.93c.32-1.07.82-.93 1.41-.75 1.63.48 2.14 2.07 1.62 3.83-.31 1.05-.7 2.03-3.15 1.3-.49-.14-1.08-.32-.95-.77l1.07-3.61zm-4.43 7.7c-.67 2.25-1.8 1.27-1.97 1.85-.1.35.25.4.42.45.81.24 1.64.4 2.5.67.68.2 1.1.4 1.37.48.37.1.53.04.58-.12.19-.65-1.62-.39-1.06-2.3l.92-3.1c.19-.62.13-.78.98-.52.8.24 1.05.48 1.18 1.38l.52 3.23c.2 1.18.37 2.46 1.64 2.84.65.19 1.83.11 2-.44.03-.15-.03-.28-.18-.33-.16-.04-.35.02-.51-.03-.13-.04-.43-.13-.5-.46-.49-2.6-1.09-5.6-1.05-5.7.05-.18.56-.2 1.15-.48.6-.29 1.26-.81 1.6-1.96.24-.82.67-3.44-2.86-4.48-1.08-.32-2.2-.58-3.27-.9-1.02-.3-1.12-.4-1.87-.62-.19-.06-.38-.02-.43.16-.19.64 1.76.5 1.17 2.5l-2.33 7.88zM432.46 449.48c-.52 2.16-2.15.85-2.32 1.55-.1.4.18.45.48.52.65.16 1.2.21 2.3.48 1.1.26 1.61.46 2.27.62.47.11.78.25.89-.19.12-.5-2.1-.48-1.56-2.72l1.97-8.2c.2-.87.4-.92 1.06-.76l1.4.34c1.89.37.88 2.26 1.53 2.42.43.1.42-.65.44-.88l.22-1.7c.03-.2.09-.45-.16-.5-1.52-.37-2.63-.56-5.01-1.13-2.39-.57-3.46-.91-4.98-1.27-.25-.06-.3.2-.37.37l-.83 2.33c-.1.23-.29.6.06.69.73.17.81-2.32 2.66-1.88l1.37.33c.67.16.81.3.6 1.16l-2.02 8.42zM452.3 444.42c.65-1 1.3-.78 1.38-1.2.06-.32-.18-.3-.53-.37-.46-.08-.93-.1-1.4-.18-.47-.1-.92-.25-1.4-.34-.2-.04-.67-.18-.73.17-.12.64 1.67.27 1.35 2-.05.29-.2.93-.93 2.06l-3.3 5.16c-.07.12-.18.36-.28.35-.1-.02-.13-.3-.16-.43l-1.05-6.3c-.2-1.2-.26-2.1-.16-2.65.14-.78 1.08-.32 1.17-.81.06-.31-.02-.31-.55-.4-.27-.06-.76-.07-1.81-.27-.57-.1-1.11-.28-1.66-.38-.25-.05-.73-.29-.81.15-.03.13.17.28.21.3.65.32.84.56.99 1.33l2.13 11.44c.15.82.29 1.04.45 1.07.18.03.29-.06.56-.5l6.53-10.2zM453.23 454.93c0 .46-.03.6.36.78.92.4 1.7.98 2.7 1.15 2.17.36 3.97-1.02 4.38-3.43.39-2.34-.57-3.31-2.2-4.47-2.04-1.46-2.91-1.85-2.7-3.08.2-1.24 1.06-1.81 2.16-1.63 2.85.48 2.52 3.94 2.9 4 .37.07.45-.14.49-.55l.23-2.5c.04-.43.13-.7-.12-.74-.21-.03-.67.19-.89.15-.5-.08-1.07-.91-2.43-1.14-1.94-.32-3.52 1-3.88 3.12-.32 1.93.54 2.8 1.85 3.75 2.44 1.75 3.45 2.16 3.18 3.73-.24 1.47-1.38 2.19-2.67 1.97-1.84-.3-2.59-2.15-2.82-4-.03-.26-.04-.43-.3-.48-.41-.06-.34.5-.33.76l.09 2.61zM477.95 447.96c.54-1.06 1.22-.91 1.25-1.34.03-.32-.21-.28-.56-.3-.47-.05-.95 0-1.42-.05-.48-.03-.94-.14-1.43-.18-.2-.02-.68-.11-.71.24-.05.65 1.7.1 1.56 1.84-.03.3-.11.95-.71 2.16l-2.74 5.47c-.06.13-.15.38-.25.37-.1 0-.16-.27-.2-.4l-1.7-6.16a8.49 8.49 0 0 1-.44-2.62c.06-.78 1.04-.42 1.08-.93.03-.31-.06-.3-.6-.34-.26-.02-.75.01-1.82-.07-.57-.05-1.14-.17-1.69-.21-.25-.02-.76-.2-.8.24 0 .13.2.26.25.28.68.24.9.46 1.12 1.21l3.32 11.15c.24.8.4 1 .56 1.02.18.01.27-.1.5-.56l5.43-10.82z'/%3E %3Cpath d='M480.6 457c-.02 1.9-1.63 1.55-1.63 2.3 0 .32.33.23.52.23.45 0 .9-.07 1.44-.06.59 0 1.16.08 1.98.09.22 0 .64.02.64-.24 0-.88-2.15.37-2.12-3.2l.06-6.35c0-.17.03-.3.13-.3.09 0 .19.1.3.25l8 9.77c.11.15.2.26.43.26.2 0 .2-.14.2-.55l.1-10.47c.01-1.96 1.44-1.5 1.44-2.06 0-.05 0-.24-.31-.24-.16 0-.74.06-1.8.05-1.16 0-1.65-.08-1.92-.09-.21 0-.27.19-.27.32 0 .61 2.05.3 2.03 2l-.05 6.2c0 .47-.04.7-.14.7s-.3-.23-.52-.5l-6.68-8.28c-.3-.36-.1-.49-.63-.5-.89 0-1.33.07-1.76.07-.32 0-.62-.08-.94-.08-.2 0-.29.14-.3.31 0 .9 1.9-.3 1.86 3.28l-.06 7.1zM496.86 448.6c.02-1.77 1.27-1.09 1.27-1.72 0-.23-.08-.27-.58-.27-.96-.01-1.56.06-2.17.06-.59 0-1.24-.1-1.9-.1-.15 0-.56-.06-.57.26 0 .65 1.8.15 1.8 1.85v8.95c0 1.77-1.21 1.28-1.22 1.93 0 .1.03.22.18.23.44 0 1.16-.07 1.88-.06 1.31 0 1.93.09 2.56.1.38 0 .53-.07.54-.28 0-.6-1.89.24-1.87-2.05l.08-8.9zM503.9 457.27c.02 2.22-1.89 1.34-1.88 2.07 0 .4.29.39.6.39.66-.01 1.22-.09 2.34-.1 1.13-.01 1.68.06 2.35.05.49 0 .83.05.82-.4 0-.52-2.15.04-2.17-2.25l-.07-8.43c0-.9.16-1 .85-1l1.42-.01c1.94-.1 1.42 1.98 2.09 1.98.43 0 .24-.73.2-.96l-.2-1.71c-.01-.19-.01-.45-.26-.45-1.57.02-2.7.1-5.14.12-2.45.02-3.58-.04-5.14-.03-.25 0-.25.27-.27.45l-.24 2.47c-.03.24-.13.65.22.65.76-.01.23-2.45 2.13-2.46l1.41-.02c.69 0 .86.09.86.98l.08 8.66zM513.68 453.74c-.3.02-.53.06-.55-.13-.02-.26.06-.47.13-.7l1.03-3.4c.07-.2.13-.23.17-.23.08 0 .03 0 .14.14l1.64 3.26c.1.21.22.41.24.67.01.19-.22.19-.52.21l-2.28.18zm2.87.78c.44-.03.54.15 1.2 1.56.23.48.37.81.4 1.22.1 1.13-1.11 1.02-1.07 1.56.02.26.24.2.54.18.48-.03 1.1-.16 1.83-.21 1.1-.1 1.57-.05 2.17-.1.45-.04.6-.01.58-.33-.05-.61-.9.19-1.54-1.1l-5.41-11.02c-.26-.54-.3-.58-.45-.56-.22.01-.27.37-.37.68l-3.65 11.61c-.33 1.07-1.2 1.03-1.16 1.46.02.24.28.18.52.16.48-.04.96-.15 1.46-.19.54-.04 1.05 0 1.58-.05.35-.02.88.07.85-.33-.04-.5-1.82-.06-1.93-1.4-.03-.44.15-1.11.24-1.5.29-1.25.63-1.35.92-1.38l3.3-.26zM529.53 446.79c-.17-1.28-.1-1.3 1.91-1.57 3.21-.42 2.2 1.91 2.98 1.81.39-.05.22-.65.17-.89l-.3-1.82c-.03-.17-.17-.34-.38-.3-1.47.18-2.6.41-3.79.57-2.55.33-3.76.41-4.44.5-.23.04-.34.2-.32.37.1.74 1.9-.1 2.12 1.56l1.14 8.66c.3 2.26-1.1 1.42-1 2.27.03.12.14.2.35.17.92-.12 1.6-.29 2.12-.36.74-.1 1.36-.1 2-.18.41-.06.77-.03.72-.4-.06-.5-1.88.2-2.15-1.84l-.37-2.74c-.14-1.07-.23-1.29.53-1.39l1.24-.16c1.73-.23 1.52 1.8 2.05 1.72.4-.05.21-.7.17-.94l-.55-3.28c-.09-.5-.27-.43-.38-.42-.34.05-.16 1.75-1.6 1.94l-1.04.14c-.72.1-.73-.03-.84-.83l-.34-2.59zM535.67 451.03c.69 3.72 3.38 5.79 6.7 5.17 5.26-.97 5.44-5.65 4.96-8.22-.72-3.9-3.62-5.8-6.83-5.17-3.94.77-5.57 4.2-4.83 8.22zm1.84-1.42c-.5-2.66-.14-5.35 2.64-5.92 2.12-.43 4.53 1.32 5.28 5.38.57 3.04.1 5.67-2.73 6.25-2.95.6-4.7-3.03-5.2-5.71zM550.53 443.11c-.26-1.09.25-1.21.85-1.36 1.65-.4 2.88.73 3.31 2.51.26 1.07.4 2.11-2.08 2.7-.49.12-1.1.27-1.2-.19l-.88-3.66zm0 8.88c.56 2.29-.9 2-.77 2.59.09.36.42.22.6.18.81-.2 1.61-.46 2.5-.68.68-.16 1.14-.2 1.42-.26.37-.1.48-.23.44-.4-.16-.65-1.6.48-2.06-1.46l-.76-3.14c-.15-.63-.28-.73.59-.94.81-.2 1.15-.1 1.71.6l2.06 2.54c.76.93 1.56 1.95 2.85 1.64.65-.16 1.63-.82 1.5-1.38-.04-.14-.16-.23-.3-.2-.17.05-.3.2-.47.23-.13.03-.44.1-.66-.15-1.72-2-3.74-4.3-3.77-4.4-.04-.19.4-.46.77-1s.68-1.33.4-2.49c-.2-.83-1.14-3.31-4.72-2.46-1.1.27-2.18.6-3.28.87-1.03.25-1.18.2-1.93.38-.2.05-.33.18-.3.36.17.66 1.78-.44 2.27 1.59l1.92 7.98zM564.01 448.98c.56 2.15-1.5 1.76-1.32 2.46.1.4.37.31.66.23.65-.16 1.17-.37 2.26-.66 1.09-.28 1.65-.34 2.3-.51.47-.12.8-.15.7-.59-.14-.5-2.08.56-2.66-1.66l-2.1-8.17c-.23-.87-.1-1 .57-1.17l1.39-.36c1.85-.55 1.84 1.59 2.5 1.42.42-.11.06-.77-.03-.98l-.61-1.61c-.06-.18-.13-.43-.37-.37-1.52.4-2.59.75-4.96 1.36-2.37.61-3.48.82-5 1.21-.24.07-.17.32-.14.5l.36 2.46c.02.24.03.66.37.57.73-.19-.37-2.43 1.47-2.9l1.37-.35c.66-.18.85-.13 1.07.74l2.17 8.38zM572.6 437.52c-.47-1.7.92-1.4.75-2-.06-.22-.15-.24-.64-.1-.92.25-1.48.49-2.06.65-.57.15-1.22.26-1.85.43-.15.04-.57.1-.48.4.17.64 1.86-.37 2.31 1.26l2.4 8.63c.47 1.7-.82 1.56-.65 2.2.03.08.1.2.24.16.42-.12 1.1-.38 1.8-.57 1.25-.35 1.87-.45 2.47-.61.37-.1.5-.22.44-.42-.16-.57-1.74.76-2.35-1.45l-2.38-8.58zM576.18 441.69c1.2 3.6 4.15 5.26 7.35 4.19 5.08-1.7 4.6-6.36 3.77-8.84-1.25-3.75-4.39-5.24-7.48-4.16-3.8 1.3-4.94 4.94-3.64 8.81zm1.62-1.66c-.86-2.57-.88-5.28 1.8-6.23 2.04-.72 4.67.68 5.98 4.59.98 2.94.88 5.6-1.84 6.57-2.83 1.01-5.07-2.35-5.94-4.93zM589.72 431.56c-.41-1.04.07-1.23.65-1.46 1.58-.62 2.96.32 3.63 2.02.4 1.02.7 2.03-1.68 2.97-.47.18-1.05.41-1.22-.02l-1.38-3.51zm1.24 8.8c.87 2.18-.63 2.1-.4 2.66.13.35.44.17.61.1.78-.3 1.54-.68 2.38-1.02.65-.25 1.1-.35 1.37-.46.36-.14.44-.3.38-.45-.24-.62-1.51.7-2.24-1.16l-1.19-3c-.24-.61-.38-.7.45-1.02.78-.3 1.13-.26 1.79.36l2.39 2.23c.88.81 1.81 1.7 3.04 1.22.63-.24 1.51-1.03 1.3-1.57-.06-.14-.2-.2-.33-.15-.16.06-.27.23-.43.29-.12.05-.42.16-.67-.06-1.99-1.74-4.3-3.74-4.35-3.84-.07-.17.32-.5.62-1.09.29-.6.49-1.41.05-2.52-.31-.8-1.59-3.13-5.01-1.78-1.05.41-2.08.9-3.13 1.31-.98.4-1.14.37-1.86.65-.18.08-.3.23-.24.4.25.63 1.7-.69 2.47 1.26l3 7.63z'/%3E %3C/g%3E %3Cg fill='%23fedf00'%3E %3Cpath fill='%23d52b1e' d='M412.66 249.25h82.18v82.02h-82.18z'/%3E %3Cpath id='a' fill='%23fff' d='M451.2 313.83s-.05 2.93-.86 5.29c-.93 2.72-.94 2.72-1.8 4.04a13.13 13.13 0 0 1-3.8 3.89c-1.96 1.26-3.95 1.88-5.95 1.7-5.49-.48-8.04-6.43-9.28-11.27-1.32-5.13-5.07-7.92-7.47-6.06-1.4 1.09-1.47 2.91-.3 4.67 1.24 1.86 4.1 2.8 4.1 2.8l-2.94 3.73s-6.3-.82-7.53-7.4c-.47-2.49.74-7.13 4.89-8.52 5.3-1.77 8.68 2 10.31 5.2 2.25 4.38 3.21 12.43 9.43 11.18 3.39-.67 4.98-5.6 4.98-7.85l2.47-2.64 3.65 1.16.1.08z'/%3E %3Cuse xlink:href='%23a' transform='matrix(-1 0 0 1 907.52 0)'/%3E %3Cpath d='M461.12 278.95l10.76-11.64s1.62-1.31 1.61-3.4l-2.22.34-.5-1.14-.1-1.15 2.98-.63c.04-.48 0-.85.09-1.38.08-.5.19-.76.3-1.25l-3.26.22c.17-.57.13-.87.31-1.4.16-.45.2-.62.5-1.1.61-.1 1.16-.24 1.91-.31.73-.07 1.15-.04 1.88-.09 1.78-3.32 9.19-6.37 14.45-.9 3.81 3.96 2.99 11.22-1.95 13.14a6.32 6.32 0 0 1-6.86-1.11l1.97-3.87c2.72 1.63 4.98-.4 4.82-2.5-.2-2.65-1.92-4.29-4.35-4.5-2.26-.2-3.88 1.1-4.9 3.1-.63 1.24-.34 2.14-.55 3.5-.22 1.49-.1 2.32-.53 3.82a8.75 8.75 0 0 1-2.37 3.59l-11.03 11.93-42.94 46.45-3.23-2.98 43.21-46.74z'/%3E %3Cpath fill='%23fff' d='M429.51 283.04s2.7 13.37 11.87 33.43c4.67-1.7 7.42-2.8 12.37-2.8 4.94 0 7.7.93 12.36 2.8 9.17-20.06 11.87-33.43 11.87-33.43l-24.23-31.18-24.24 31.18z'/%3E %3Cpath d='M456.12 262.41l16.82 21.64s-2.24 10.52-9.08 26.35c-2.64-.6-4.91-1.13-7.73-1.32v-46.67zM451.38 262.41l-16.82 21.64s2.24 10.52 9.08 26.35c2.64-.6 4.91-1.13 7.73-1.32v-46.67z'/%3E %3C/g%3E %3Cg fill='%23d52b1e'%3E %3Cpath fill='%23fedf00' d='M503.6 249.25h82.18v82.02H503.6z'/%3E %3Cpath d='M515.11 249.25h12.25v82.02h-12.25zM538.59 249.25h12.25v82.02H538.6zM562.07 249.25h12.25v82.02h-12.25z'/%3E %3C/g%3E %3Cg fill='%23d52b1e' stroke='%23d52b1e' stroke-width='.51'%3E %3Cpath fill='%23fedf00' d='M412.97 402.41c.23 1.48.76 4.01 2.16 6.6 1.48 2.34.94 2.28 4.28 6.01 1.64 1.84 4.21 3.41 6.23 4.5 2.02 1.08 3.51 1.62 6.84 2.49 6.52 1.71 11.09 1.82 16.57 1.6 4.28-.17 7.55-.7 10.25-1.06 3.86-.52 6.73-.83 11.12-1.01 2.13-.1 4.15-.11 6.14 0 2.4.13 4.78.5 7.3 1a79.61 79.61 0 0 1 10.97 3.2l.01-85.66-82.19-.02v58.54s.17 2.86.32 3.8z' stroke='none'/%3E %3Cpath d='M422.51 417.43l3.85 2.24 5.28 1.9v-81.53h-9.13zM468.17 421.14l.01-81.1h-9.14v82.4s6.25-.8 9.13-1zM486.41 340.05h-9.11v81.38c2.97.32 6.02.85 9.13 1.68l-.02-83.06zM449.92 340.05v83.33c-.09.01-6.1.32-9.17 0v-83.32z'/%3E %3C/g%3E %3Cpath fill='%23fedf00' d='M585.48 402.39a20.75 20.75 0 0 1-2.16 6.6c-1.48 2.34-.94 2.28-4.28 6-1.64 1.85-4.21 3.42-6.23 4.5-2.02 1.1-3.51 1.63-6.84 2.5-6.52 1.71-11.09 1.82-16.57 1.6-4.28-.17-7.55-.7-10.25-1.06-3.86-.52-6.73-.83-11.12-1.01a63.34 63.34 0 0 0-6.14 0c-2.4.13-4.78.5-7.3 1-5.45 1.1-11.04 3.2-11.04 3.2l.05-85.66 82.2-.02v58.54s-.17 2.86-.32 3.8z'/%3E %3Cg id='b'%3E %3Cpath fill='%23d52b1e' d='M524.62 346.91l-.6.28c-.3.33-.44.52-.77.81-.45.4-.77.5-1.25.85-.24.16-.42.21-.6.44-.25.32-.08.62-.25 1-.19.4-.37.6-.65.93-.37.44-.65.61-1.07 1-.42.4-.59.73-1.1 1-.13.07-.19.14-.34.19-.21.07-.34-.01-.56.06-.39.14-.5.56-.78.72.11.22.1.37.22.6.16.32.7 1.21.81 1.43.21.3.27.7.53.78.54.17.86.16 1.32.13.79.18 1.28.16 2.03.47.61.25.86.57 1.47.84.47.21.77.34 1.28.44.38.07.6.13 1 .1.25-.03.37-.13.62-.16h.13l-.03.37v.09h.06l2.06.91c-.07.12-.15.26-.19.38-.1.32-.11.68-.06.84.63 1.89 1.16 3.07 1.47 3.19.62.23.8.86 1.16 1.5-.13.13-.23.2-.35.3-.61.6-1.15 1.02-1.65 1.82-.75 1.19-1.25 1.2-.32 2.78.55.93.82 1.1 1.53 2.4.37.67.57 1.18.79 1.98.2.75.27 1.19.3 1.97l.98.37.65-.65.63-1.2.03-.9c-.24-.2-.3-.47-.25-.78.07-.37.51-.3.72-.62.28-.47-.33-.74-.66-1.1-.6-.67-1.43-.83-1.62-1.84-.05-.28.08-.43.37-.72.86-.84 1.13-.97 1.97-1.81.24.14.61.19.97.12.28-.05.53.13 1.4.38.62.17.88.08 1.22.03l.38-.1c.05.22.11.42.12.7.06 1.05-.15 2.99.16 3.5.13.2.19.32.28.55.1.24.22.4.22.66.01.7.05 1.14 0 1.87-.04.7-.1 1.05-.22 1.75-.07.46-.16.72-.44 1.07-.28.36-.59.41-.96.68l-.1 1 1.13.47 1.28.32.69-.29c0-.25.04-.4.15-.62.13-.25.23-.44.47-.53.36-.14.76.13.9-.1.17-.24.07-.33.04-.75-.05-.66-.18-.98-.28-1.65a11.81 11.81 0 0 1-.16-2.75c.03-.62.04-.96.16-1.56.17-.89.48-1.32.68-2.2.23-.97.27-1.6.38-2.46 3.17.45 5.8.4 9.34-.38.17-.03.75-.25.75-.25.8.7 1.71 1.27 2.72 1.63v.97c.04.29-.04.48.13.72.1.15.2.24.37.28.27.06.46.02.66-.16.23-.2.18-.45.25-.75.03-.14 0-.56 0-.69.37.06.49.07.87.07.36 0 .53.01.88-.03l.03.46c.03.25-.08.44.03.66.11.23.25.36.5.4.2.05.35.02.53-.09.3-.18.27-.5.31-.84.02-.11.02-.7 0-.78l1.04-.38c0 .25-.04.52-.1.82a5 5 0 0 1-.25.93c-.2.57-.44.86-.75 1.38-.37.63-.57.98-1.03 1.56-.21.27-.36.39-.56.66-.26.33-.34.56-.6.9-.32.44-.5.73-.93 1.07-.7.55-1.15.1-2.1.84l-.22 1.03 1.44.53 1.28.25.44-.25c-.01-.3.03-.51.22-.75.21-.27.44-.35.78-.4.36-.06.75.03 1.03-.22.35-.31.35-.92.63-1.47a12.66 12.66 0 0 1 3-3.9c.61-.6 1.13-.77 1.65-1.45.25-.32.52-.46.53-.87.01-.28-.14-.42-.21-.69-.1-.38-.2-1-.2-1 1.53.75.98.65 1.26 1.4.22.62-.03 1.05.06 1.7.11.75.47 1.1.53 1.87.08.9-.14 1.42-.31 2.31-.15.79-.13 1.28-.47 2a3.85 3.85 0 0 1-1.16 1.57c-.2.17-.36.25-.59.4l-.12 1.03 1.12.38 1.63.44.37-.35c.16-.65-.05-1.61.4-1.69.41-.06.7 0 .79-.3.04-.14.06-.33.1-.63.21-1.89.41-3.65.62-4.5.23-.97.21-1.18.4-1.91.18-.66-.08-.28.41-1.69.73-2.1-.2-2.37-1.06-3.65-.46-.7-.62-.95-.69-1.5-.1-.82.16-1.5.12-2.75a42.32 42.32 0 0 1 0-2.88c.12-.05.23-.12.35-.19 1.17-.64 1.63-.83 2.37-2.46.23-.5.32-1 .32-1.47 0-.34-.07-.66-.1-1.03-.03-.4-.19-.64-.31-.94a3.17 3.17 0 0 0-.56-.85c-.78-.92-1.78-1.13-2.72-1.46-1.48-.54-2.5-.44-4.13-.57-1.67-.13-2.6-.15-4.28-.06-2 .12-3.13.52-5.12.75-1.92.22-2.98.37-4.9.4-2.27.05-4.43-.45-5.79-.34-2.45.21-2.5.76-6.19 1.07-1.92.15-3.84.18-3.84.18l-2.16-.68c.86-.31 1.07-.5 1.47-1.04.27-.36.23-.67.56-1.06.27-.31.45-.62.78-.97a2.2 2.2 0 0 0-.93-.43c-.37-.08-.58-.05-.94 0-.5.05-.77.12-1.22.34-.36.18-.62.36-.84.6 0 0-1.29-.84-2.19-1.23-1.12-.48-1.6-.7-3-.9zm1.97 11.9h.06l-.03.04-.03-.03z'/%3E %3Cg fill='none' stroke='%23fedf00' stroke-width='.99' stroke-linecap='round'%3E %3Cpath d='M568.77 359.52l-.76.24c-.87.4-1.58.42-2.6.5-2.65.2-4.27-1.06-7-.85-1.4.11-2.03 1.2-3.46 1.55-.65.16-1.03.23-1.7.28l.51-1.03s-1.28.26-2.11.26c-.6 0-.94-.03-1.53-.13l1.02-.95s-.81-.13-1.3-.33a3.92 3.92 0 0 1-1.05-.63c.66-.12 1.03-.2 1.69-.36 1.55-.38 2.04-1.14 3.89-1.32 1.15-.11 3.03-.05 7.64.72 3.03.5 4.38.26 5.53-.26.77-.35 1.02-1.01 1.1-1.79.1-.78-.4-1.4-.87-1.81-.12-.1-.44-.33-1.1-.36'/%3E %3Cpath fill='%23fcd900' stroke-width='.51' stroke-linecap='butt' d='M524.8 350.61c-.53-.07-.88.01-1.34.3-.48.29-.54.69-.89 1.13.45.1.7.36 1.14.26.35-.09.53-.24.77-.51.31-.36.43-.68.42-1.16l-.1-.02z'/%3E %3Cpath d='M536.04 363.79s.26.48.4.8c.25.55.38.88.53 1.47.2.8.11 1.28.24 2.1.02.14.05.26.08.37l-.05 1.13M544.04 362.71l-.35 1.33c-.36 1.36-.68 2.09-.95 3.46-.04.23-.08.45-.1.65M531.78 364.17c.79.18.54 3.36 1.79 4.09'/%3E %3Cpath stroke-linecap='butt' d='M560.12 369.78l.38-.25a8.15 8.15 0 0 0 2.69-1.79'/%3E %3Cpath d='M552.38 368.02c3.54-.88 5.9-2.65 7.59-2.87M555.97 363.61c.3-.01.58-.03.83-.07 1.47-.2 1.7.69 2.73 1.26 1.85 1.04 2.1 2.3 4.3 3.36l.32.15.84.43'/%3E %3Cpath fill='%23fcd900' stroke-width='.51' stroke-linecap='butt' d='M517.7 354.53c.27.07.43.08.7.05.34-.03.5-.23.82-.24.27-.01.47-.04.69.12.14.1.2.19.28.34.08.17.16.28.12.47-.06.28-.32.42-.61.42-.24 0-.44-.06-.55-.27a.47.47 0 0 1-.03-.4c-.29.11-.5.12-.78.02-.3-.1-.48-.24-.64-.51z'/%3E %3C/g%3E %3Cg fill='%230065bd'%3E %3Cpath d='M525.13 364.17c-.8-.24-1.97-.83-1.97-.83.33-.25.6-.26.87-.55.39-.4.37-.79.59-1.32.22-.52.18-.95.67-1.34.3-.23.76-.27 1.12-.17.35.11.76.4.85.77.13.56-.16.88-.25 1.45-.08.57-.3.9-.2 1.46.07.38.23.52.36.9 0 0-1.26-.14-2.04-.37zM524.14 365.12a.63.63 0 1 1 1.26-.02.63.63 0 0 1-1.26.02zM522.38 348.61l-.14-.1c-.39-.31-.42-.66-.6-1.11-.18-.44-.26-.7-.32-1.16-.05-.4 0-.64 0-1.05 0-.36.04-.57 0-.94-.04-.38-.03-.61-.21-.94-.1-.18-.4-.34-.31-.42.09-.1.25-.02.42 0 .4.04.63.16.94.42.38.3.53.57.67 1.04.17.55.25.9.4 1.47.1.3.14.47.3.74.15.27.31.38.52.63l-.02.02c-.3.33-.44.54-.77.83-.3.27-.56.4-.85.58l-.03-.01zM525.98 359.25l2.23 1.03a9.24 9.24 0 0 0 3.5-3.92c.88-1.72 1.02-2.65 1.36-4.31l-1.79-.58-.35.07c-.56 1.72-.7 2.7-1.62 4.2-.8 1.28-1.72 2.3-2.65 3.03l-.68.48zM530.92 377.37c.36-.5.51-.81.92-1.26.46-.5.8-.7 1.31-1.15.16.01.34-.02.48.07a9 9 0 0 1-.52 2.75c-.14.39-.16.64-.4.98-.15.22-.28.31-.47.51-.5-.74-1.33-1.3-1.32-1.9zM563.93 379.22c.57.21.92.27 1.47.54.61.3.9.57 1.47.94.02.16.1.32.06.48a8.97 8.97 0 0 1-2.79.26c-.41-.03-.66.02-1.05-.1-.26-.1-.38-.2-.63-.32.58-.7.88-1.64 1.47-1.8zM554.17 377.18c.57.21.92.27 1.47.54.6.3.9.57 1.47.94.02.16.1.32.06.48a8.98 8.98 0 0 1-2.79.26c-.41-.03-.66.02-1.05-.1-.26-.1-.38-.2-.63-.32.58-.7.88-1.64 1.47-1.8zM536.83 379.31c.57.21.92.27 1.47.54.61.3.9.57 1.47.94.02.16.1.32.06.48a9 9 0 0 1-2.79.26c-.41-.03-.66.02-1.05-.1-.26-.1-.38-.2-.63-.32.58-.7.88-1.64 1.47-1.8zM527.85 349.51c-.61-.28-1.05-1.04-.66-1.6.15-.21.41-.17.57-.39.18-.27.14-.5.13-.84 0-.37-.14-.57-.2-.94-.08-.4-.15-.64-.14-1.05 0-.63-.04-1.08.34-1.57.25-.32.66-.6.83-.62.14.14-.06.5-.04.83.04.46.13.71.3 1.15.2.56.47.8.7 1.36.2.52.4.81.41 1.37.02.45-.02.73-.2 1.15a2 2 0 0 1-.62.84c-.27.22-.45.32-.8.42-.24.02-.4-.01-.62-.11z'/%3E %3C/g%3E %3C/g%3E %3Cuse xlink:href='%23b' y='36.59'/%3E %3Cg fill='none' stroke='%23703d29' stroke-width='.8'%3E %3Cpath d='M412.66 249.25h82.18v82.02h-82.18zM503.6 249.25h82.18v82.02H503.6zM412.97 402.41c.23 1.48.76 4.01 2.16 6.6 1.48 2.34.94 2.28 4.28 6.01 1.64 1.84 4.21 3.41 6.23 4.5 2.02 1.08 3.51 1.62 6.84 2.49 6.52 1.71 11.09 1.82 16.57 1.6 4.28-.17 7.55-.7 10.25-1.06 3.86-.52 6.73-.83 11.12-1.01 2.13-.1 4.15-.11 6.14 0 2.4.13 4.78.5 7.3 1a79.61 79.61 0 0 1 10.97 3.2l.01-85.66-82.19-.02v58.54s.17 2.86.32 3.8zM585.48 402.39a20.75 20.75 0 0 1-2.16 6.6c-1.48 2.34-.94 2.28-4.28 6-1.64 1.85-4.21 3.42-6.23 4.5-2.02 1.1-3.51 1.63-6.84 2.5-6.52 1.71-11.09 1.82-16.57 1.6-4.28-.17-7.55-.7-10.25-1.06-3.86-.52-6.73-.83-11.12-1.01a63.34 63.34 0 0 0-6.14 0c-2.4.13-4.78.5-7.3 1-5.45 1.1-11.04 3.2-11.04 3.2l.05-85.66 82.2-.02v58.54s-.17 2.86-.32 3.8z'/%3E %3C/g%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 6'%3E %3Crect width='12' height='2' fill='%2300732f' id='green'/%3E %3Crect width='12' height='2' y='2' fill='%23fff'/%3E %3Crect width='12' height='2' y='4'/%3E %3Crect width='3' height='6' fill='%23f00' id='red'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 600 400'%3E %3Crect width='600' fill='%23090' height='400'/%3E %3Crect width='400' fill='%23bf0000' height='400'/%3E %3Crect width='200' height='400'/%3E %3Cg stroke-width='.5' stroke='%23bd6b00' fill-rule='evenodd' fill='%23fff'%3E %3Cpath d='m319.5 225.84 8.354 0.001c0.0311 3.1574 1.8815 6.5489 4.4798 8.4926h-16.008c2.5051-2.271 3.1897-4.9625 3.1741-8.4938z'/%3E %3Cpath stroke='none' d='m266.71 178.53 4.5742 5.0402 56.934 0.0932 4.6674-5.0402-14.56-0.18636-7.0937-4.947-22.868-0.0932-6.6266 5.1333h-15.027z'/%3E %3Cpath d='m290.02 172.74 19.66-0.0203c2.6616-1.4073 3.4919-5.9014 3.4788-8.4161-0.037-7.4282-5.2325-10.991-10.447-11.18-0.78128-0.0394-1.688-0.64749-1.8947-1.3595-0.51368-1.6128-0.38108-2.6411-0.94375-2.5838-0.50055-0.007-0.35361 0.93999-0.79921 2.4524-0.24489 0.75261-1.0907 1.4945-1.9341 1.5375-6.4904 0.32374-10.676 5.0616-10.513 11.134 0.1099 4.0151 0.577 6.4127 3.3927 8.4364z'/%3E %3Cpath stroke='none' d='m257.66 242.83h84.469l-7.5608-6.1607h-69.348l-7.5596 6.1607z'/%3E %3Cpath d='m296.39 219.69 1.5399 4.6196h3.4991l-2.799-4.6208-2.2399 0.001zm-1.9592 4.6196 0.88641 4.573 4.1059 0.0466-1.4933-4.6208-3.4991 0.001zm6.9527 0.0466 2.8468 4.5264h5.8334l-4.573-4.5742-4.1071 0.0478zm-34.441 10.36c3.0953-2.8778 5.0712-5.3352 5.0867-8.8665h7.5596c0.0155 1.9759 0.73111 3.1574 1.8206 3.0797l7.654-0.0466-0.0466-4.5264h-5.5538l-0.001-24.688c-0.2019-8.7267 10.609-13.813 15.028-13.767l-26.275-0.0466v-0.79324h55.255l0.0466 0.79324-26.647 0.0466c7.9025 0.0155 15.524 7.4987 15.587 13.815v6.9993h-1.0274l-0.0466-6.9061c0-6.9073-8.6993-13.363-15.681-13.161-6.0364 0.17322-15.4 5.9277-15.307 13.115v2.1467l14.327 0.0932-0.13978 2.4729 2.2495 1.4359 4.487 1.43-0.0657 3.7093 3.2136 0.94734 0.0275 3.7057 3.8551 1.6546v3.8359l2.4454 1.5064-0.1123 3.8957 3.3139 2.3331h-7.8403l4.9004 5.4606h-7.2335l-3.5946-5.4606h-4.7594l2.1467 5.4128-5.0855-0.0466-1.2149-5.3662h-6.2061l0.0466 5.7856-22.214 0.001zm22.168-14.981v4.573h5.3209l-1.0752-4.573h-4.2457z'/%3E %3Crect y='211.66' x='289.39' height='7.6068' fill='none' width='3.3134'/%3E %3Cpath d='m284.71 219.8h3.2339l-0.0203-5.5968c-0.0418-2.4329 2.142-4.8854 3.1873-4.967 1.1588-0.0439 2.8671 2.2965 2.9244 4.7757l0.0466 5.8064 3.431-0.007v-14.411l-12.803 0.0682v14.332z' fill='none'/%3E %3Crect y='223.14' x='310.3' height='3.1268' fill='none' width='4.0135'/%3E %3Crect y='217.77' x='307.92' height='3.1268' fill='none' width='4.0135'/%3E %3Crect y='212.4' x='304.05' height='3.1268' fill='none' width='4.0135'/%3E %3Crect y='207.88' x='300.74' height='3.1268' fill='none' width='4.0135'/%3E %3Cpath d='m298.08 219.82 4.1059 0.13977 7.3266 6.4868v-3.8264l-2.4729-1.7728v-3.0344l-3.5934-2.0524v-3.2673l-3.5002-1.166v-4.4344l-1.774-1.4467-0.092 14.374z' fill='none'/%3E %3Crect y='210.35' x='315.43' height='7.0468' width='.98004'/%3E %3Cg id='c'%3E %3Cpath d='m257.32 186.53c-1.234-1.9819-2.7118 2.7488-7.7878 6.2706-2.363 1.608-4.0092 5.8931-4.0247 8.7124-0.0777 1.9365 0.21503 3.8682-0.001 5.7414-0.13619 1.1851-1.3714 3.8156-0.52683 4.4882 2.234 1.6605 5.1261 5.4308 6.4677 6.7317 1.16 1.0166 2.1647-5.248 3.0355-8.0518 0.93301-3.0045 0.51489-6.5955 3.1024-9.3718 1.8338-1.8744 6.4594-3.7189 5.9397-4.5539l-6.2049-9.9668z'/%3E %3Cpath d='m257.06 201.88c-0.38526-0.88581-0.95754-1.8017-1.6562-2.5938-0.69871-0.79204-1.5248-1.4569-2.4375-1.7812-0.88164-0.32494-1.7792-0.75131-2.4062-1.5312-0.31351-0.38997-0.58408-0.88198-0.71875-1.4688-0.12477-0.54363-0.12348-1.2104-0.0312-1.9688-0.10986 0.0798-0.16783 0.17131-0.28125 0.25-2.363 1.608-4.0157 5.8994-4.0312 8.7188-0.0312 0.77881-0.0314 1.5387 0 2.3125 0.17489 0.48532 0.34357 0.95597 0.59375 1.25 0.32596 0.3831 0.71323 0.63629 1.125 0.8125 0.82354 0.35241 1.7746 0.42507 2.6562 0.75 0.9127 0.32434 1.8518 1.058 2.6562 1.9375 0.76683 0.83843 1.3575 1.8005 1.75 2.6562 0.0663-0.2425 0.15395-0.60389 0.21875-0.8125 0.84505-2.7212 0.69713-5.8888 2.5625-8.5312z' fill='%23bf0000'/%3E %3Cpath d='m249.82 192.39c-0.48382 3.3557 1.3846 4.4727 3.1478 5.1226 1.8254 0.64868 3.3223 2.6067 4.0928 4.3783' fill='none'/%3E %3Cpath d='m245.3 203.44c0.77054 2.8934 2.7978 2.5314 4.5611 3.1813 1.8254 0.64868 3.7452 2.9567 4.5157 4.7283' fill='none'/%3E %3Cpath d='m255.61 184.48 0.92464-0.59373 17.752 29.898-0.92345 0.59373-17.753-29.898z'/%3E %3Cpath d='m257.52 183.29a2.0459 2.0459 0 1 1 -4.0919 0 2.0459 2.0459 0 1 1 4.0919 0z'/%3E %3Crect y='159.27' x='272.7' height='1.6499' width='7.1937'/%3E %3Crect y='162.4' x='272.7' height='13.784' width='7.1937'/%3E %3Cpath d='m272.26 157.39 7.9801 0.0466c0.3118-2.7058-2.3893-5.6291-3.9662-5.5992-1.559 0.0753-4.0761 2.9555-4.014 5.5526z'/%3E %3Cpath stroke='none' d='m292.62 155.76c-1.5214 0.63988-2.6876 2.3773-3.4062 4.375-0.71863 1.9977-0.99146 4.2674-0.65625 6.0938v0.0312c0.12767 0.63033 0.30087 1.0828 0.5 1.4062s0.42233 0.51338 0.6875 0.5625c0.26517 0.0491 0.51389-0.0929 0.65625-0.3125 0.14236-0.21963 0.21213-0.50902 0.1875-0.84375-0.14424-1.8787-0.13498-3.7323 0.3125-5.4062 0.44748-1.674 1.3381-3.1644 2.9688-4.375 0.29479-0.21603 0.46415-0.46321 0.5-0.71875 0.0358-0.25554-0.0995-0.47402-0.28125-0.625-0.36346-0.30196-0.93739-0.40779-1.4688-0.1875zm0.15625 0.4375c0.37058-0.15363 0.84219-0.0633 1.0312 0.0937 0.0945 0.0785 0.10575 0.13319 0.0937 0.21875-0.012 0.0856-0.0775 0.23402-0.3125 0.40625-1.7131 1.2718-2.6562 2.8713-3.125 4.625s-0.45856 3.6602-0.3125 5.5625c0.019 0.2578-0.0553 0.45499-0.125 0.5625s-0.10683 0.13994-0.1875 0.125c-0.0807-0.0149-0.24759-0.11733-0.40625-0.375s-0.31728-0.65644-0.4375-1.25c-0.31467-1.7145-0.0372-3.9474 0.65625-5.875 0.69341-1.9276 1.8032-3.5378 3.125-4.0938z' fill='%23bd6b00'/%3E %3Cpath stroke='none' d='m295.19 157.73c-1.5192 0.63893-2.5013 2.292-3.0312 4.1875-0.52999 1.8955-0.61336 4.0655-0.28125 5.875 0.26002 1.2838 0.9344 1.9611 1.5938 2.0625 0.32968 0.0507 0.64783-0.0795 0.84375-0.34375 0.19592-0.26429 0.26001-0.61887 0.15625-1.0625-0.37233-1.4981-0.51562-3.366-0.25-5.0625s0.94019-3.2115 2.2188-4.125c0.29553-0.21508 0.46393-0.46314 0.5-0.71875 0.0361-0.25561-0.0995-0.50509-0.28125-0.65625-0.36357-0.30232-0.93709-0.37666-1.4688-0.15625zm0.1875 0.4375c0.37028-0.15351 0.81045-0.0639 1 0.0937 0.0948 0.0788 0.13702 0.13359 0.125 0.21875-0.012 0.0852-0.10826 0.23486-0.34375 0.40625-1.4117 1.0086-2.1286 2.6642-2.4062 4.4375-0.27764 1.7733-0.105 3.6646 0.28125 5.2188 0.0826 0.35318 0.00066 0.59139-0.0937 0.71875-0.0944 0.12736-0.21432 0.18576-0.40625 0.15625-0.38385-0.059-0.98301-0.5548-1.2188-1.7188-0.31777-1.7314-0.22749-3.868 0.28125-5.6875s1.4572-3.2869 2.7812-3.8438z' fill='%23bd6b00'/%3E %3Crect y='187.39' x='272.31' height='11.107' width='8.0268'/%3E %3Crect y='204.85' x='272.78' height='2.3334' width='7.7468'/%3E %3Crect y='208.95' x='272.59' height='8.6802' width='7.9335'/%3E %3Crect y='219.41' x='272.03' height='4.8534' width='8.6802'/%3E %3Cpath d='m273.1 202.76h6.9946l1.387-2.3092h-9.6359l1.2544 2.3092z'/%3E %3Cpath d='m282.53 194.25 0.0657-6.0711h4.8179c-1.8923 1.5614-3.652 3.4537-4.8836 6.0711z'/%3E %3Cpath d='m273.56 196.74c0.0478 1.2986 1.5184 0.71916 1.5184 0.0657 0-2.0034 0.0263-4.1693-0.0538-5.5873-0.01-1.0453 2.4908-0.78368 2.4765-0.13978 0.01 1.6916 0.0287 4.0116 0.0382 5.9911-0.0179 0.96407 1.6151 0.88045 1.5924 0-0.01-2.2113-0.0108-5.4248 0-7.0519 0.0143-2.0954-5.5013-2.05-5.5443-0.0466 0.002 1.645-0.0299 4.5898-0.0275 6.7688z' fill='none'/%3E %3Crect y='209.98' x='273.57' height='7.0935' fill='none' width='5.6935'/%3E %3Crect y='212.92' x='277.21' height='1.1667' width='2.0067'/%3E %3Crect y='212.92' x='273.71' height='1.1667' width='1.96'/%3E %3Crect y='210.07' x='275.67' height='2.8934' width='1.54'/%3E %3Crect y='214.04' x='275.67' height='3.0801' width='1.54'/%3E %3Cpath d='m243.99 138.97c0.356 5.567-1.3714 8.6228-4.3198 8.1581-0.81235-3.0881 1.0357-5.1596 4.3198-8.1581z'/%3E %3Cpath d='m237.52 151.31c-2.621-1.3332-0.72992-11.513 0.27596-15.78 0.74425 5.4965 1.9891 13.309-0.27596 15.78z'/%3E %3Cpath d='m238.45 151.79c4.4058 1.5327 7.8941-3.2124 9.0732-8.7077-3.6364 5.0186-9.5546 5.0246-9.0732 8.7077z'/%3E %3Cpath d='m235.11 156.93c-3.4453-0.9103-1.3702-11.71-0.74425-16.03 0.75739 4.4619 3.1323 14.552 0.74425 16.03z'/%3E %3Cpath d='m236.29 156.59c0.19233-3.7248 3.9052-2.6485 6.4677-4.6364-0.41812 1.8612-1.9938 5.1596-6.4677 4.6364z'/%3E %3Cpath d='m232.07 161.58c-3.4142-0.92106-1.3619-12.544-1.5554-17.329 1.0011 4.1346 4.1705 16.209 1.5554 17.329z'/%3E %3Cpath d='m233.66 161.08c2.7966 0.90911 6.5012-0.90792 6.7927-4.2386-2.4084 1.6343-6.2539 0.38467-6.7927 4.2386z'/%3E %3Cpath d='m229.52 166.71c-3.2649 0.26043-1.8039-9.6383-1.8015-18.857 1.1994 8.6169 4.4667 16.505 1.8015 18.857z'/%3E %3Cpath d='m230.65 166.26c2.2053 1.1062 6.1559-0.66182 7.2837-4.3867-3.9841 1.7322-6.6481 0.0394-7.2837 4.3867z'/%3E %3Cpath d='m256.28 144.13c-0.58059 4.8287-2.5541 7.6385-5.5025 7.1738-0.81235-3.0881 1.5781-5.0616 5.5025-7.1738z'/%3E %3Cpath d='m248.48 156.52c4.898 0.69527 6.6624-3.0642 9.9596-7.8702-4.6208 3.3438-10.146 4.039-9.9596 7.8702z'/%3E %3Cpath d='m247.09 155.97c-2.67-3.204-0.0896-7.2275 1.9508-10.657-0.43842 5.1023 1.2998 7.9407-1.9508 10.657z'/%3E %3Cpath d='m245.91 161.26c-0.30105-3.1335 5.0378-3.83 7.4521-5.5718-0.81235 1.811-2.0428 6.6863-7.4521 5.5718z'/%3E %3Cpath d='m244.79 161.33c-3.6914-0.41812-2.1587-6.6863 0.4874-10.17-1.1146 4.8072 1.9496 8.1498-0.4874 10.17z'/%3E %3Cpath d='m242.01 166.55c-4.2015-1.8576-1.5088-7.1272 0.0705-10.238-0.67377 4.0856 2.6927 7.1964-0.0705 10.238z'/%3E %3Cpath d='m242.84 166.06c2.2053 2.879 6.5012-0.85894 7.3828-5.2241-3.738 3.112-6.5 2.6007-7.3828 5.2241z'/%3E %3Cpath d='m233.24 186.32c-0.43166-4.2875 2.7929-12.084 0.50438-16.24-0.31201-0.57103 0.68503-2.087 1.329-1.1672 1.0064 1.4682 2.041 5.6518 2.4738 4.1071 0.45863-1.6796 0.52901-4.6507 2.0164-5.2277 0.94895-0.33808 2.2908-0.55909 1.9249 0.9342-0.36362 1.4359-1.1777 3.419-0.27565 3.5469 0.52315 0.0776 2.0304-1.9544 3.2996-2.8934 1.0228-0.83743 2.5489 0.47308 1.0533 1.7262-4.8608 4.0367-9.5704 5.8537-12.326 15.214z'/%3E %3Cpath d='m224.51 250.85c-0.57042-0.10939-1.3518-0.30325-0.64081 0.58385 5.6789 6.9961 7.3221 8.924 15.603 7.9397 8.3647-1.1012 10.357-3.3637 16.214-6.6504 3.1284-1.8351 7.7026-2.2426 11.17-1.1055 1.6142 0.52834 2.5906 0.56022 1.4336-0.59826-1.1575-1.1569-2.5249-2.7312-3.9485-3.8153-3.1181-2.3942-8.4069-3.4322-12.723-2.6616-6.1044 0.95734-11.148 4.8442-17.176 6.3123-3.1669 0.72294-6.6407 0.61388-9.9317-0.005z'/%3E %3Cpath d='m272.3 263.35c1.056 0.13141 1.725 2.1766 2.2447 0.79204 0.88164-2.2423 0.26401-4.0259-0.72633-3.8288-1.1696 0.3118-3.1478 2.934-1.5184 3.0368z'/%3E %3Cpath stroke='none' d='m220.6 182.92c-1.2149-1.2687-0.86372-1.7537 0.933-1.774 1.4252-0.0896 4.2493 0.87328 5.3209 0.0932 0.98198-0.71319 0.59134-3.738 1.0274-5.1333 0.18994-0.77771 0.7347-1.9986 1.9592-0.0932 3.6221 5.8047 8.1462 12.773 10.08 19.6 1.0572 3.8264 0.0621 9.7996-3.4537 13.814 0.12425-3.4226-1.1516-5.7247-2.707-8.587-1.921-3.7619-9.0565-13.951-13.16-17.919z'/%3E %3Cpath d='m235.53 213.44c3.9829 0.0191 4.6674-5.3197 4.6674-6.813-1.9604 0.37272-5.4141 3.64-4.6674 6.813z'/%3E %3Cpath d='m269.95 265.26c2.8326 0.64461 2.7937-6.1781-0.0995-9.0701 1.274 4.3824-2.1286 8.3884 0.0995 9.0701z'/%3E %3Cpath d='m268.85 265.2c0.18688 3.2427-7.9586-0.42377-10.052-2.9462 4.8125 2.0445 9.8145 0.35216 10.052 2.9462z'/%3E %3Cpath d='m265.28 260.57c0.29129 3.1414-7.0638 0.37929-9.2378-2.074 4.83 1.5602 8.9164-0.51099 9.2378 2.074z'/%3E %3Cpath d='m266.63 261.01c2.8326 0.64461 2.3737-6.412-0.37932-8.8369 1.3211 4.7091-1.8488 8.1552 0.37932 8.8369z'/%3E %3Cpath d='m263.65 256.72c2.8326 0.64461 1.207-5.4312-0.89265-7.8575 0.34096 4.4298-1.055 7.5021 0.89265 7.8575z'/%3E %3Cpath d='m262.15 256.7c0.29185 3.2349-5.4301 0.75147-7.6509-2.3088 4.783 1.561 7.3296-0.27617 7.6509 2.3088z'/%3E %3Cpath d='m260.59 254.24c1.8558-1.3343-0.11294-4.8633-3.645-4.6447 0.34557 2.1312 1.5659 5.88 3.645 4.6447z'/%3E %3Cpath d='m274.54 268.87c0.18688 3.2427-7.9595 1.6298-10.519-1.8255 5.1387 0.97109 10.281-0.76847 10.519 1.8255z'/%3E %3Cpath d='m242.18 263.07c0.29185 3.2349-8.6024-0.32249-10.823-3.3827 4.783 1.561 10.502 0.79778 10.823 3.3827z'/%3E %3Cpath d='m247.63 264.45c1.8558-1.3343-1.9327-4.7703-4.951-5.578 0.34558 2.1312 2.8719 6.8132 4.951 5.578z'/%3E %3Cpath d='m248.2 266.69c0.1986 2.9084-9.5373 1.3132-12.084-1.3741 8.3771 1.5142 11.81-1.1172 12.084 1.3741z'/%3E %3Cpath d='m252.76 268.63c1.0806 2.7015-8.2641 2.0422-11.545 0.4715 5.3012-0.0461 10.802-2.3534 11.545-0.4715z'/%3E %3Cpath d='m257.13 270.6c1.0345 2.421-7.6104 2.3687-11.824 1.0303 5.5812-0.0458 10.801-3.4259 11.824-1.0303z'/%3E %3Cpath d='m263.42 271.9c1.531 2.8646-7.5878 3.1435-10.547 1.7331 5.2725-0.72515 9.2422-3.9877 10.547-1.7331z'/%3E %3Cpath d='m252.74 267c-2.9011 1.8295-2.7458-3.5643-5.0532-7.2996 3.6255 3.3017 7.0194 5.5553 5.0532 7.2996z'/%3E %3Cpath d='m257.88 268.94c-2.4335 2.156-4.379-5.2459-6.594-9.399 3.5805 3.9539 8.8395 7.6085 6.594 9.399z'/%3E %3Cpath d='m264.68 271c-2.0609 2.3888-8.0196-7.0181-10.187-11.919 3.2992 3.8152 11.826 9.895 10.187 11.919z'/%3E %3Cpath d='m258.88 278.18c-1.028 3.6318-16.192-3.4234-17.885-7.0785 8.6768 4.5975 18.092 3.6359 17.885 7.0785z'/%3E %3Cpath d='m210.15 204.38c-0.35481-0.45993-1.3738 0.012-1.1194 1.1206 0.23653 1.5004 2.449 9.2034 6.2515 11.853 2.7118 1.9544 16.965 5.1023 23.427 6.439 3.5564 0.71558 6.5346 2.4896 8.8677 5.3209-0.96526-3.7022-1.7406-6.445-2.9866-9.7996-1.2114-2.9483-4.4213-6.1738-7.746-6.3471-6.175-0.2222-14.167-0.74783-19.974-3.2673-2.9973-1.252-4.7917-2.9436-6.7198-5.3197z'/%3E %3Cpath d='m245.54 234.87c1.9469 1.4336 4.0958-3.704 1.6225-8.588-0.0776 4.7012-3.8141 6.2791-1.6225 8.588z'/%3E %3Cpath d='m247.41 239.58c2.6927 0.82665 3.536-3.937 1.7626-7.7474 0.2957 4.0938-4.2336 6.5596-1.7626 7.7474z'/%3E %3Cpath d='m249.46 243.36c2.6006 1.2948 3.5848-3.5179 1.7159-7.0917 0.2039 4.5593-3.7203 5.9035-1.7159 7.0917z'/%3E %3Cpath d='m248.39 243.65c-1.0304 3.0802-7.0069-2.6554-8.0141-5.7748 3.7094 3.6852 8.7568 3.278 8.0141 5.7748z'/%3E %3Cpath d='m245.68 238.94c-1.171 3.0797-8.6865-4.8497-10.348-8.6679 3.7094 3.6852 11.184 6.4975 10.348 8.6679z'/%3E %3Cpath d='m244.19 234.32c-1.1706 3.5001-9.3403-5.829-11.654-9.1352 3.8968 3.6388 12.537 6.5919 11.654 9.1352z'/%3E %3Cpath d='m243.93 230.86c2.8765-0.55945-0.1633-2.9553-3.6892-6.849-0.16487 4.0999 0.50799 6.9664 3.6892 6.849z'/%3E %3Cpath d='m239.08 228.53c1.2422-1.3529-1.1906-1.9289-4.203-5.3096-0.44441 2.2798 2.7942 6.4535 4.203 5.3096z'/%3E %3Cpath d='m253 243.73c1.5742 0.92123 2.6516-2.3045 0.68982-5.225-0.44888 3.1594-2.1332 4.0368-0.68982 5.225z'/%3E %3Cpath d='m218.81 223.38c-3.3424 2.004-8.6516-5.992-10.068-9.2817 2.9329 3.7754 10.699 7.2242 10.068 9.2817z'/%3E %3Cpath d='m221.65 228.04c-1.8496 2.0506-7.6713-3.5187-9.6942-6.3413 3.1204 2.7022 10.512 3.0236 9.6942 6.3413z'/%3E %3Cpath d='m224.82 232.22c-0.61034 2.801-9.1062-3.4952-11.092-6.4756 3.6626 3.4518 11.649 3.1398 11.092 6.4756z'/%3E %3Cpath d='m223.52 235.25c-1.3106 2.5218-8.2206-3.7268-9.8794-6.9868 4.222 3.6843 10.949 4.4926 9.8794 6.9868z'/%3E %3Cpath d='m219.97 222.97c2.1805-2.2988 1.2516-3.3763-0.338-6.9994-0.8689 3.7206-2.1793 5.2055 0.338 6.9994z'/%3E %3Cpath d='m222.86 227.31c3.9544 0.17418 0.0381-4.6378-0.89693-8.6793 0.3439 4.6062-1.0136 8.2375 0.89693 8.6793z'/%3E %3Cpath d='m225.38 231.13c2.7405-0.61933 1.95-4.4971-0.15066-9.1933 0.43644 5.0738-2.3203 8.0055 0.15066 9.1933z'/%3E %3Cpath d='m224.45 238.8c-1.0304 3.0802-8.8265-4.0555-10.067-6.7554 3.9426 3.3119 10.763 4.4456 10.067 6.7554z'/%3E %3Cpath d='m229.12 243.61c-1.1698 3.0817-9.3391-3.1669-11.839-6.5678 4.9223 3.8722 12.443 3.5126 11.839 6.5678z'/%3E %3Cpath d='m233.88 248.46c-1.3096 4.2937-9.8528-2.5609-12.399-5.9148 5.4358 4.1511 13.096 2.859 12.399 5.9148z'/%3E %3Cpath d='m225.85 237.43c2.3206 1.201 3.2577-5.3837 1.9487-10.033 0.0175 5.0736-4.6535 8.8452-1.9487 10.033z'/%3E %3Cpath d='m229.81 242.66c2.7876 0.82809 1.904-6.2694-0.47802-10.873-0.30875 4.561-2.3662 8.8924 0.47802 10.873z'/%3E %3Cpath d='m234.76 247.56c3.1142 0.17446 0.97142-6.084-1.5973-9.6132 0.4372 4.6069-1.0129 9.0788 1.5973 9.6132z'/%3E %3Cpath d='m229.3 250.23c-0.93619 1.5864-3.226-1.3475-6.9861-3.4886 3.3817 0.88442 7.4021 2.0185 6.9861 3.4886z'/%3E %3Cpath d='m227.52 197.49c2.9065-2.1503 0.6893-6.1726 0-9.9979-0.93539 3.6281-3.3975 8.3887 0 9.9979z'/%3E %3Cpath d='m227.42 202.85c-4.3664-0.52444-3.7093-6.1715-3.8407-9.7506 1.3129 4.8586 4.892 5.6793 3.8407 9.7506z'/%3E %3Cpath d='m228.11 202.12c3.6938-0.21384 3.4979-4.4166 3.695-8.6682-1.872 3.9076-4.0892 4.5145-3.695 8.6682z'/%3E %3Cpath d='m227.96 207.34c-2.8731 0.22937-4.3664-2.5935-5.0234-6.9934 2.725 4.0546 5.2038 2.7907 5.0234 6.9934z'/%3E %3Cpath d='m228.99 206.99c3.6938 0.47546 3.1036-3.8252 2.9555-6.9946-1.1325 3.0212-4.137 3.9733-2.9555 6.9946z'/%3E %3Cpath d='m223.23 205.17c0.29507 2.8074 2.0691 7.6337 4.9255 6.5502 1.1815-3.4477-2.5123-4.137-4.9255-6.5502z'/%3E %3Cpath d='m229.04 212.02c-1.2806-2.4621 2.9053-3.695 3.7918-6.8954 0.50891 4.5802 0.0824 7.5847-3.7918 6.8954z'/%3E %3Cpath d='m217.13 182.84c2.2997-2.4765 0.26879-6.4056-0.42051-10.231-0.9354 3.6281-2.5565 8.4353 0.42051 10.231z'/%3E %3Cpath d='m217.06 187.45c-4.039 0.40976-5.0162-7.8045-5.4272-11.337 1.3129 4.8586 5.9648 7.0794 5.4272 11.337z'/%3E %3Cpath d='m217.89 187.37c2.854-1.4742 2.191-4.6495 3.0881-7.0352-1.9186 2.928-3.6687 3.3474-3.0881 7.0352z'/%3E %3Cpath d='m217.09 192.75c-4.2254 0.36197-6.7425-8.7387-6.8739-12.318 1.3129 4.8586 7.3661 7.4999 6.8739 12.318z'/%3E %3Cpath d='m217.9 192.61c3.9733-0.91389 3.4979-3.4835 2.9018-7.642-1.2651 4.1884-3.4824 3.3008-2.9018 7.642z'/%3E %3Cpath d='m217.04 198c-4.6459 0.78845-4.3198-6.5609-8.0088-11.893 3.1909 3.9602 8.9358 8.9502 8.0088 11.893z'/%3E %3Cpath d='m218.09 197.75c3.5074 0.10154 3.8503-5.1787 3.6556-7.3207-0.80638 2.1336-4.9302 4.1597-3.6556 7.3207z'/%3E %3Cpath d='m209.78 192.34c1.7418 5.6542 4.2158 11.32 7.2586 10.89 1.461-3.2148-2.8862-3.6245-7.2586-10.89z'/%3E %3Cpath d='m218.14 202.4c-1.2806-2.4621 2.9053-3.695 3.7918-6.8954 0.50891 4.5802 0.0824 7.5847-3.7918 6.8954z'/%3E %3Cpath d='m210.98 198.8c2.4872 5.0939 3.609 10.948 7.0244 10.097 1.2747-3.9614-3.7714-4.7905-7.0244-10.097z'/%3E %3Cpath d='m218.71 207.93c-1.467-2.6951 2.719-3.6484 3.7452-7.3625 0.5555 4.861 0.0358 8.3314-3.7452 7.3625z'/%3E %3Cpath d='m225.87 173.45c2.4514 0.66302 5.0222-2.0894 4.131-6.2085-2.8014 0.69766-4.0868 3.241-4.131 6.2085z'/%3E %3Cpath d='m218.03 171.39c0.21384 1.1588 1.6235 1.2639 1.2137-0.37272-0.34166-1.3284-0.4002-2.3271 0-3.4071 0.54834-1.3535 0.36556-3.658-0.0466-4.6196-0.41573-1.0154-1.7931-0.42051-1.2137 0.37392 0.63793 0.92106 0.67138 2.8372 0.23295 3.732-0.577 1.3212-0.4205 3.075-0.18636 4.2935z'/%3E %3Cpath d='m240.9 187.31c-0.94705 1.3932-2.8812 0.54113-1.4078-1.3724 1.2073-1.5486 2.9282-2.8138 3.0552-4.4136 0.10028-2.0286 1.2909-5.1066 2.3726-6.1447 1.1177-1.106 2.4089 0.44989 1.2142 1.1874-1.3426 0.87203-2.2147 4.4568-2.1853 5.836-0.0453 2.0013-2.0413 3.447-3.0489 4.9072z'/%3E %3Cpath d='m237.92 185.07c-0.94705 1.3932-2.4566 0.58456-1.6013-1.6522 0.72225-1.5486 0.79972-3.4676 1.6042-4.6 1.125-1.7165 3.0307-3.1471 4.1125-4.1853 1.1177-1.106 2.0456-0.0402 1.0207 0.90749-1.2445 1.2453-2.5947 2.7953-3.345 3.9693-1.3993 2.2808-0.78335 4.1004-1.7909 5.5607z'/%3E %3Cpath d='m222.18 177.86c-0.11229 1.9667 1.4706 2.4433 1.4001-0.40889-0.0717-2.9777-2.179-5.702-0.88642-10.235 0.67975-2.2176 0.69169-6.2814 0.27955-8.4413-0.36198-2.1423-1.8863-0.74253-1.3069 0.92566 0.63793 1.9341-0.11946 5.6442-0.60687 7.5106-1.4634 5.4335 1.2066 8.0801 1.1206 10.649z'/%3E %3Cpath d='m226.5 166.98c-0.23238 1.8098-1.7642 1.974-1.319-0.58213 0.37128-2.0748 0.43489-3.6346 0-5.3213-0.59586-2.114-0.39724-5.7131 0.0506-7.2151 0.45176-1.5859 1.9486-0.65676 1.319 0.584-0.69323 1.4385-0.72958 4.4313-0.25315 5.8288 0.62702 2.0636 0.45696 4.8026 0.20252 6.7057z'/%3E %3Cpath d='m210.94 204c0.75806 0.90214 2.0358 0.29761 0.87149-0.92336-0.95298-0.98655-0.63931-1.2979-1.22-2.4999-0.57427-1.343-0.54434-2.084-1.2375-3.0436-0.61297-0.91033-1.535 0.0184-0.91733 0.78454 0.77539 0.90604 0.56133 1.5743 1.0356 2.4508 0.87626 1.4999 0.66261 2.2875 1.4678 3.2315z'/%3E %3Cpath d='m231.34 228.61c2.4394 1.1994 4.2911 4.1955 4.413 6.6361 0.20667 2.8086 0.61165 5.1799 1.8732 7.1761-2.0082-0.55909-2.9698-3.7595-3.2554-6.8249-0.2891-3.1729-1.9986-4.5491-3.0308-6.9874z'/%3E %3Cpath d='m236.42 234.49c1.688 3.1159 4.0486 4.3044 4.1692 6.6167 0.2045 2.661 0.40664 2.7968 1.1277 5.4136-1.9871-0.5297-2.4871-0.70287-3.0238-4.6847-0.33098-2.7979-2.571-4.7718-2.2732-7.3456z'/%3E %3Cpath stroke='none' d='m288.97 263.32c0.94853 1.7884 2.038 4.5109 4.0128 4.0128 0.0311-1.369-2.1312-2.3176-4.0128-4.0128z'/%3E %3Cpath stroke='none' d='m291.91 263.93c3.8353 1.5721 7.1472 1.1839 7.5598 3.5946-3.598 0.38826-4.9137-1.0895-7.5598-3.5946z'/%3E %3Cpath stroke='none' d='m275.85 251.24c2.5828 2.1157 4.2588 4.5312 5.0401 7.6528 0.81474 2.9077 1.9604 5.2265 3.6412 7.8403-2.7381-1.8672-4.4596-4.407-5.3209-7.4676-0.7562-3.0081-1.6486-5.2564-3.3605-8.0255z'/%3E %3Cpath stroke='none' d='m279.03 251.23c2.7692 2.2101 5.3794 4.7188 6.1607 7.8403 0.81474 2.9077 1.3069 5.1333 3.1741 8.0267-2.9244-1.8672-4.0856-4.6877-4.947-7.7483-0.7562-3.0069-2.4896-5.2552-4.3879-8.1187z'/%3E %3Cpath stroke='none' d='m288.17 258.47c-0.0765-0.54594 0.29746-1.0226 0.74664-1.166 0.87446-0.32733 1.7454-0.59373 2.6126-0.83982 0.98556-0.23296 1.5375 0.47068 1.5411 0.933 0.005 0.76934 0.0406 1.4228 0 2.0058-0.0538 0.72634-0.19234 0.78009-0.65347 0.88761-0.73827 0.12424-1.6844 0.25087-2.4263 0.74664-0.58776 0.36078-1.1528 0.0753-1.4467-0.55908-0.18994-0.48502-0.29387-1.4336-0.37391-2.0082z'/%3E %3Cpath stroke='none' d='m298.8 258.47c0.0683-0.54594-0.21986-1.0692-0.62115-1.2126-0.78124-0.32732-1.5593-0.40736-2.38-0.37391-0.91144-0.0143-1.1409 0.19114-1.1441 0.65346-0.004 0.76934-0.0363 1.516 0 2.099 0.048 0.72634 0.032 0.78009 0.44398 0.88761 0.65957 0.12424 1.7845 0.15769 2.4472 0.65346 0.5251 0.36078 1.1238 0.0753 1.1526-0.60568-0.0128-0.51368 0.0299-1.5267 0.10139-2.1013z'/%3E %3C/g%3E %3Cuse x='-600' xlink:href='%23c' transform='scale(-1,1)'/%3E %3Cg stroke='none'%3E %3Cpath d='m328.54 286.65c0.0466 1.1815 0.18756 2.1312 0.88761 3.0797-4.0761-1.633-9.8306-0.75859-13.767 1.074-1.7561 0.83863-3.8802-0.95809-1.8206-2.6604 2.9292-2.3737 9.7063-1.0274 14.7-1.4933zm-57.505-0.0621c0.0573 1.1134-0.0717 2.1336-0.48144 3.106 4.4309-1.8349 9.1879-0.3106 13.664 1.4945 3.0774 1.2723 3.3258-0.93061 2.7823-1.6928-0.9342-1.3523-2.7417-2.8372-5.0282-2.8695-1.522-0.0215-7.3816-0.0741-10.937-0.0382zm3.7404-21.642c-1.2364-0.5328-2.6724-0.0203-3.9602 1.3356-4.3269 4.2397-9.4041 8.3707-13.502 11.584-1.5291 1.3284-3.0917 3.7117 3.431 6.0938 0.23654 0.0896 4.9912 1.8517 8.004 1.964 1.2305-0.0346 1.2269 1.8027 0.99871 2.2925-0.51966 0.9784-0.14336 1.3523-1.1934 2.2937-1.0943 0.92345 0.11707 2.1193 0.9772 1.3069 3.6723-3.1884 9.6275-1.148 15.366 0.71797 1.3559 0.37511 3.8371 0.26999 3.8156-1.6008 0.0239-2.038 1.5004-3.4787 2.4036-3.5313 2.3427 0.40617 13.919 0.53519 17.485 0.10154 2.0786-0.26998 2.2041 2.848 3.3163 4.0773 0.76695 0.81473 3.7189 1.031 5.7426 0.13738 4.0008-1.8588 10.097-1.8588 12.582-0.0824 1.0214 0.7777 1.8278 0.14694 1.2472-0.64271-0.74784-1.0799-0.73112-1.5805-1.1026-2.4334-0.933-1.8983-0.18875-2.363 0.78965-2.5004 11.054-1.4252 14.582-5.1966 11.202-8.2716-4.364-3.8276-9.2225-7.6755-13.408-12.198-1.1349-1.1994-1.8851-1.6808-4.2469-0.69885-7.2215 3.2888-16.388 5.6864-25.358 5.862-8.3469 0.0717-19.824-3.7894-24.589-5.8071z'/%3E %3Cpath d='m326.62 265.54c-0.58023 0.0578-1.1972 0.23826-1.6562 0.40625-8.921 3.1336-17.117 5.328-25.656 5.3125-8.3351-0.0155-17.066-2.3091-24.906-5.5312-0.44624-0.19053-0.95981-0.16084-1.4688-0.0312-0.50894 0.12959-1.0125 0.36576-1.3438 0.6875-3.6409 3.6266-7.5824 7.1483-11.812 10.344-0.63909 0.48801-0.53496 1.7307 0.5 2.1562h0.0312c8.3042 2.9793 16.412 8.5315 39.625 8.3125 23.433-0.22135 31.746-5.64 39.188-8.125 0.52464-0.19981 1.0644-0.4994 1.3125-0.96875 0.12404-0.23467 0.15766-0.52598 0.0625-0.8125-0.0952-0.28652-0.28357-0.55445-0.625-0.84375h-0.0312c-4.2235-3.4524-8.7488-6.2064-11.719-10.406-0.33382-0.47902-0.91977-0.55785-1.5-0.5zm0.0312 0.4375c0.50718-0.0506 0.89476 0.027 1.0938 0.3125 3.0414 4.3011 7.621 7.0738 11.812 10.5 0.30008 0.25426 0.44154 0.48023 0.5 0.65625 0.0585 0.17602 0.0438 0.29557-0.0312 0.4375-0.15003 0.28386-0.58962 0.56991-1.0625 0.75-7.534 2.5157-15.668 7.9043-39.031 8.125-23.115 0.21804-31.094-5.3023-39.469-8.3125-0.75458-0.31029-0.68706-1.1606-0.40625-1.375 4.2421-3.2062 8.227-6.7414 11.875-10.375 0.25052-0.24332 0.65266-0.45018 1.0938-0.5625 0.44109-0.11232 0.91238-0.13081 1.2188 0 7.8791 3.2384 16.613 5.5781 25.031 5.5938 8.6179 0.0156 16.903-2.2032 25.844-5.3438 0.44524-0.16293 1.0241-0.35569 1.5312-0.40625z' fill='%23bd6b00'/%3E %3Cpath d='m269.71 114.56c-0.0681-1.3788 2.0691-1.4841 1.8242 0.41202-0.313 2.3623 4.4583 8.342 4.8538 12.029 0.2652 2.4726-1.4527 4.6371-3.1538 5.9841-2.0858 1.6157-5.2934 1.3935-6.7938 0.46662-0.90792-0.73075-1.7358-3.2334-1.056-4.224 0.24012-0.33342 1.3272 3.673 3.7213 3.6574 3.2578-0.021 5.8967-2.4682 5.9934-4.6508 0.16725-3.8014-5.3292-9.8095-5.389-13.675z'/%3E %3Cpath d='m279.24 123.95c0.53878-0.38503 1.3989 1.2959 0.79204 1.716-0.50533 0.33652-1.4921-1.2493-0.79204-1.716z'/%3E %3Cpath d='m280.69 120.54c-0.27237 0.13212-0.81354-0.0555-0.65226-0.28671 0.76217-1.0889 2.3869-2.7279 3.5648-3.3 0.36198-0.17585 0.99513 0.46303 0.77651 0.77602-0.70483 1.0071-2.4203 2.1949-3.689 2.8107z'/%3E %3Cpath d='m293.28 110.55c0.30224-0.63089 2.1169-1.3441 2.5792-1.7707 0.42767-0.43783 0.63195 0.37046 0.44917 0.75202-0.30224 0.63052-1.8684 1.6954-2.5553 1.724-0.36914 0.0154-0.65585-0.32422-0.47307-0.7053z'/%3E %3Cpath d='m297.59 110.75c0.39304-1.1074 1.6605-2.7861 2.5326-3.3387 0.44799-0.28336 1.252-0.0605 1.1014 0.364-0.3333 0.93958-1.8839 2.5812-2.9268 3.3546-0.31657 0.28169-0.79801-0.12328-0.70722-0.37989z'/%3E %3Cpath d='m293.9 113.52c-0.26282 0.13153-0.12066 0.69133 0.1326 0.77591 0.53878 0.17943 1.5196 0.21443 1.964-0.0307 0.6451-0.39757 0.35122-2.8442-0.5125-1.5372-0.57939 0.80625-1.0023 0.54726-1.5841 0.79204z'/%3E %3Cpath d='m286.61 119.14c-1.3177-1.0262 0.3548-2.4639 1.7322-1.4601 2.6831 2.024-4.0032 9.7781-7.6408 13.403-0.66541 0.70984-1.2496-1.078-0.39662-1.848 2.6079-2.2121 5.0497-4.8551 6.7472-7.5854 0.32733-0.52563 0.64032-1.6587-0.44201-2.5092z'/%3E %3Cpath d='m301.88 112.47c0.16366-0.9821-1.5889 0.0206-1.6211-1.2814-0.0167-0.68906 1.915-1.1725 2.7226-0.37989 1.3643 1.384 0.34406 3.7184-1.9245 3.8653-1.8911 0.0835-5.0461 2.685-4.5659 3.2319 0.54595 0.67532 5.4499 1.1213 8.3015 0.67472 1.7657-0.24776 1.3953 1.3314-0.41334 1.5452-1.7477 0.20142-3.1717 0.0147-4.8048 0.52803-1.9222 0.54917-2.7608 3.1292-3.8288 4.0921-0.23773 0.16737-0.87925-0.84591-0.63554-1.2268 0.76934-1.2032 1.9962-3.0449 3.3462-3.572 0.85176-0.34501-2.3486-0.45384-3.37-0.74533-0.80995-0.24418-0.57461-1.2735-0.26401-1.848 0.41215-0.89513 3.4286-3.916 4.6447-3.8666 1.1421 0.0483 2.2997-0.2842 2.4132-1.0173z'/%3E %3Cpath d='m306.96 112.73c0.56745-0.50055 0.85775-1.3381 1.4527-1.848 0.32613-0.32661 0.84699 0.0647 0.75978 0.85332-0.0729 0.62084-0.90672 1.1559-1.467 1.6227-0.45635 0.34178-0.98676-0.39638-0.74545-0.62802z'/%3E %3Cpath d='m313.43 110.43c0.8446-0.0933 1.0548 1.5372 0.13141 1.8012-0.56028 0.18672-1.0501-1.7051-0.13141-1.8012z'/%3E %3Cpath d='m311.3 115.47c-0.0131 1.4037 0.67974 1.2746 2.0022 1.2266 1.283-0.0483 2.412 0.0331 2.4072-1.2346-0.006-1.3141-0.72753-2.4637-0.93898-1.5694-0.18636 0.84006-0.33449 2.2154-0.8231 1.6161-0.46112-0.515-0.27834-0.6279-1.0716 0.2173-0.43962 0.46579-0.48979-0.22578-0.75381-0.66003-0.18397-0.2572-0.8207 0.20775-0.8219 0.40402z'/%3E %3Cpath d='m302.08 122.63c-0.31538 1.8576-0.0263 4.4587 0.92464 4.4881 1.1755 0.0382 3.6078-4.0615 4.7594-6.188 0.6905-1.1867 1.8768-1.3942 1.3822-0.15602-0.74903 1.9104-0.68213 5.9976-0.0239 7.1987 0.35361 0.64689 2.9639-0.59325 3.3856-1.5147 0.76695-1.6746 0.14335-4.7616 0.41214-6.6468 0.13022-1.2376 1.2627-1.4963 1.203-0.34919-0.11229 2.0524-0.30702 5.8151-0.16247 7.524 0.086 0.98234 2.8946 2.432 3.3462-0.54272 0.23774-1.8724 1.2018-3.7189-0.0466-5.7933-0.77411-1.297 1.1361-1.1345 2.1659 0.63733 0.72036 1.2058-0.60687 3.2015-0.56028 4.744 0.11947 2.3731-1.7262 3.7214-3.0654 3.7494-1.197 0.0241-1.9771-1.4462-2.9579-1.4668-1.0883-0.0694-2.2065 1.693-3.106 1.6307-3.4859-0.23821-1.6402-5.3335-2.7022-5.396-1.1815-0.0695-2.5744 4.994-4.0295 4.8134-1.4348-0.17227-2.9197-4.1268-2.3224-5.8 0.53998-1.5567 1.5578-1.9216 1.3977-0.93204z'/%3E %3Cpath d='m318.96 114.6c-1.7012-1.0376 0.10752-3.7361 0.93898-2.788 1.6056 1.9229 3.2243 6.487 4.3556 6.8641 0.71678 0.23905 0.68333-3.3736 1.1886-5.016 0.32614-1.2133 1.7931-0.81724 1.5124 0.73733-0.0956 0.51906-1.9162 6.4213-1.7764 6.6546 1.2615 2.522 2.5099 5.0812 3.2996 7.788 0.32613 1.1667-1.0752 0.38097-1.2424 0.1387-0.89478-1.3375-2.4609-6.452-2.4609-6.2187-0.72036 3.598-0.89 4.6599-1.6546 7.7174-0.23295 0.97995-1.6749 0.80147-1.3499-0.92393 0.31299-1.4182 2.3749-8.3926 2.259-8.5947-1.6211-2.8616-3.1036-5.1252-5.07-6.3588z'/%3E %3Cpath d='m322.03 131.2c-0.47427-0.0538-1.2102 1.055 1.1516 1.4906 3.1562 0.57127 6.6111-0.49171 7.6695-3.5866 1.2125-3.6865 2.0141-7.1765 2.6473-8.4934 0.79084-1.5347 1.8027-1.4107 1.056-3.6506-0.52683-1.6123-1.51-1.1258-1.7167-0.26402-0.55192 2.3498-2.6461 9.9521-3.2996 11.352-1.2328 2.5547-3.7177 3.5654-7.5082 3.152z'/%3E %3Cpath d='m328.35 119.07c-0.33808-0.72537-1.1265-0.1639-0.98557 0.62933 0.0836 0.71702 0.66541 1.1068 1.2496 1.0866 0.69169-0.0239 2.1551 0.0232 2.1587-1.1253 0.002-0.80685-0.63196-1.481-1.1026-0.59063-0.45037 0.80614-1.0298 0.72168-1.3201 0z'/%3E %3Cpath d='m329.14 116.03c-0.24251 0.16833-0.0251 1.0656 0.26401 1.0559 1.031-0.0344 2.492-0.36328 3.2745-0.90791 0.22937-0.15937 0.1338-0.70161-0.19233-0.69073-0.99393 0.0331-2.5756 0.007-3.3462 0.54271z'/%3E %3Cpath d='m337.9 118.29c0.74664-1.1667 2.8062-1.2855 2.0655 0.38001-0.52444 1.1476-5.6518 11.055-6.3518 12.315-0.76337 1.4167-1.3882 0.71522-0.8458-0.38802 0.72992-1.4197 4.898-11.962 5.1321-12.307z'/%3E %3Cpath d='m330.18 133.04c-0.21862-0.78845-1.4419-1.9543-1.3045 0.1547 0.2437 3.8285 5.5036 2.6184 7.0961 1.2577 1.4455-1.2811 0.19114 4.3222 2.1121 4.9218 1.0584 0.33927 3.0511-1.105 4.0307-2.3761 2.7166-3.5249 4.4452-8.5779 7.0579-12.058 0.98676-1.3608-0.53997-2.3322-1.1576-1.2493-2.2722 3.8098-5.0939 11.585-8.176 13.604-2.5123 1.608-1.768-2.0703-1.8553-3.1753-0.1099-0.81068-1.0979-2.0034-2.4155-0.9084-0.92106 0.71964-2.3522 1.305-3.6484 1.1879-0.75142-0.0418-1.3858-0.0287-1.7394-1.3586z'/%3E %3Cpath d='m339.57 125.93c0.0275-0.21611-1.1122-0.31419-1.056 0.79204 0.0394 0.81891 1.019 1.0412 1.1875 0.92404 1.5411-1.1208-0.32733-0.56183-0.13141-1.7161z'/%3E %3Cpath d='m337.33 130.42c-0.30343 0.071-0.58178 1.0397 0.13261 1.0946 0.65346 0.0466 3.2135-0.22817 3.9208-0.18672 0.45755-0.0172 0.63196-0.89191-0.34883-0.84531-1.1898 0.0596-2.7536-0.23857-3.7045-0.0626z'/%3E %3Cpath d='m275.37 113.76c0.40617 0.0194 1.5196 1.4621 1.4467 1.9133-0.0502 0.21276-1.191-0.0317-1.5399-0.32661-0.25804-0.21838-0.15411-1.5984 0.0932-1.5867zm-5.3687 10.452c-1.0178 0.55514 0.16128 1.651 0.92345 1.1879 2.8611-1.8525 7.1546-3.7984 8.0518-7.4681 0.2879-1.2429 1.4431-3.1481 2.5398-3.5732 1.0596-0.41083 2.5983 1.9171 3.603 0.0853 0.58895-1.0471 2.6533 0.68715 3.1514-0.43329 0.60687-1.3533 0.31778-2.0984 0.34286-3.3946-0.0442-0.84914-0.69288-1.1028-1.1636 0.27202-0.2449 0.62252 0.043 1.251-0.1565 1.576-0.15172 0.24705-0.62479 0.48609-0.89955 0.28002-0.25327-0.18995-0.0777-0.72036-0.68453-0.95475-0.23534-0.1179-0.61284-0.21598-0.7765 0.0853-0.72036 1.2847-1.1194 2.4826-2.1276 1.1174-0.89836-1.176-1.3535-3.2088-2.0118-0.42672-0.23653 0.98187-1.7286 2.4067-2.6091 2.4067-1.0991 0-0.8231-2.8938-3.2374-2.4534-1.2412 0.26473-1.1552 2.6396-0.97004 3.5175 0.30463 1.22 3.9315 0.34369 3.7511 1.1412-0.62001 2.7712-4.4667 5.4053-7.7268 7.0348z'/%3E %3Cpath d='m247.3 137.42c-0.15411 0.46352 0.46232 1.7227 1.1014 1.8158 0.62718 0.0466 0.94734-1.3595 0.74545-1.8158-0.14933-0.33569-1.737-0.32852-1.8469 0z'/%3E %3Cpath d='m250.63 142.3c-0.40259-0.43365-1.5889 0.72992-0.62957 1.553 0.53877 0.43604 2.5123 1.0692 3.0523 0.14814 0.73111-1.1851-0.72037-5.4881-0.0777-6.0568 0.50175-0.4444 2.8277 2.8743 3.9757 3.1132 2.6975 0.37392 2.05-4.6184 4.9565-4.2792 1.9807 0.26402 2.1981-2.2113 1.9222-3.7568-0.221-1.483-2.6222-3.6238-3.726-4.5814-1.4527-1.2093-2.1002 0.89156-1.1886 1.5841 1.1731 0.93946 3.2362 2.8371 3.5648 4.0924 0.1553 0.59253-1.4336 1.7704-2.0189 1.4515-1.3511-0.73708-2.6079-3.898-3.7894-4.62-0.40259-0.24586-1.3929 0.30977-0.91628 1.296 0.53639 1.0566 2.9053 2.6932 3.0439 3.8209 0.12543 1.0286-1.0561 3.253-1.8314 3.253-0.85297 0-3.0272-2.6879-3.7057-3.953-0.33928-0.60567-1.5148-0.54714-1.6378 0.28911-0.19473 1.2556 0.18158 3.9124 0.48143 5.5586 0.23774 1.559-0.87805 1.6378-1.4754 1.0871z'/%3E %3Cpath d='m246.56 133.73c-0.33927 0.38359 0.79204 1.1338 1.0166 0.9391 0.43604-0.37751 2.1288-2.3073 1.8027-2.9818-0.29029-0.6015-2.6186-1.9187-2.9973-1.2666-0.70244 1.1287 2.1945 1.6344 1.7406 1.9653-0.2234 0.12818-1.0202 0.67855-1.5626 1.344z'/%3E %3Cpath d='m250.73 125.27s0.72752 2.4891 1.3201 1.4521c0.47905-0.71869-1.3201-1.4521-1.3201-1.4521z'/%3E %3Cpath d='m251.92 129.23c-0.2664 0.14563-1.0166 0.73996-0.52802 1.0561 0.77292 0.45718 2.8755 0.81915 2.4215-0.67605-0.27596-0.88068 3.1706 0.0245 2.3307-2.36-0.21981-0.65991-1.2591-1.6123-1.7704-1.7468-0.32494-0.0855-1.4288 0.5199-0.73828 0.85344 0.50413 0.26103 2.0249 1.1546 1.4598 1.7399-0.64152 0.61225-1.0883-0.27477-1.8863-0.13189-0.4014 0.0763-0.13977 1.2186-0.36556 1.5294-0.12663 0.17334-0.70603-0.3824-0.92345-0.26402z'/%3E %3Cpath d='m257.4 119.77c-0.43485 0.2173-1.2138 1.3963-1.2424 1.9414-0.0155 0.2909 0.30344 0.69074 0.55192 0.56662 0.45635-0.22794 1.1612-1.3438 1.1875-1.856 0.0167-0.32386-0.22698-0.78678-0.49696-0.65203z'/%3E %3Cpath d='m260.24 119.46c-0.83982-1.0267 0.8912-2.5509 1.6701-0.49601 0.47069 1.2891 5.4881 7.8921 6.5143 10.132 0.72634 1.516-0.0263 2.1423-0.92464 1.056-2.541-3.242-4.6256-7.2831-7.2598-10.692z'/%3E %3Cpath d='m265.39 119.6c0.89478-0.96932 2.7214-2.9492 2.2292-4.0533-0.3775-0.94961-1.4873-0.85524-1.6773-0.63614-1.0859 1.2962 0.77173 0.97087 0.50413 1.4135-0.55311 1.0384-1.1038 1.61-1.3894 2.608-0.0669 0.23403 0.17203 0.84257 0.3333 0.66792z'/%3E %3Cpath d='m343.17 122.84c-0.6427-0.52062 0.63196-3.044 1.4945-2.0534 2.3678 2.74 3.468 11.636 4.1525 18.294 0 0-1.0644 0.8876-1.0728 0.74664 0-3.5468-1.4252-14.397-4.5742-16.987z'/%3E %3Cpath d='m290.07 114.18c-0.76575-1.7604 1.1492-2.412 1.436-1.1572 1.3308 5.7827 4.5169 10.161 6.942 14.093 0.72992 1.2293 0.14455 1.9618-1.6307 0.83063-1.2293-0.84281-2.4777-3.9162-3.0821-4.0374-1.0943-0.20368-3.7129 4.9927-9.0696 3.5094-1.3858-0.38718-1.2938-4.5079-1.3201-6.328-0.0585-0.85332 0.88402-1.0787 0.91628 0.0853 0.049 1.6781-0.002 5.164 2.1444 5.2813 1.7501 0.0978 5.6267-2.3765 6.4438-4.3107 0.72753-1.9887-1.952-5.9413-2.7799-7.9667z'/%3E %3Cpath d='m344.61 138.38c0.42767-1.191 6.1141-10.735 6.8607-12.835 0.38228-1.0126 2.0141 1.7366 0.42051 3.2201-1.4001 1.26-5.5311 8.0342-6.3017 10.408-0.3548 1.0716-1.4312 0.56148-0.97959-0.79323z'/%3E %3Cpath d='m354.28 129.28c1.0501-3.9348 3.5934 0.60699 1.3535 2.8469-3.4584 3.3874-4.5002 9.8539-9.9871 10.827-1.479 0.31777-4.082-0.66541-4.8538-1.2137-0.30105-0.21384 0.19472-1.6187 1.1194-0.93301 1.3368 1.0441 4.0976 1.2794 5.555 0.0932 3.118-3.0606 5.6566-7.1136 6.813-11.621z'/%3E %3Cpath d='m297.27 142.02c-0.24729 0.28432-1.0035 0.23773-1.0716 0.63674-0.29747 1.4801 0 2.2304-0.32614 3.6556-0.31179 1.3643-1.2591 1.4156-1.1946 0.30343 0.086-1.4419 1.2747-3.4776 0.43484-3.6173-0.55909-0.13141-0.99035-0.87925-0.41215-1.2484 1.0919-0.75739 1.6784-0.64151 2.4287-0.41334 0.26162 0.08 0.32852 0.46471 0.14097 0.68333z'/%3E %3Cpath d='m296.5 140.09c-1.4479 1.2663-2.7906 1.7836-4.1227 3.3844-0.54475 0.65585-0.52922 1.5697-0.85416 2.406-0.32613 0.88761-1.375 1.062-1.7 0.87685-0.54356-0.35719-0.46471-2.0034-1.0716-1.117-0.51489 0.81593-0.84699 1.9401-1.608 1.9257-0.68811-0.0143-1.9867-1.4216-1.3284-1.4897 2.2519-0.23057 2.2244-2.0332 3.0678-2.1515 0.94615-0.12663 1.0083 1.4885 1.5924 1.1648 0.45874-0.23534 0.67497-2.1169 1.1731-2.6246 1.5267-1.5602 2.7345-2.3845 4.2923-3.5313 0.78845-0.62837 1.3511 0.50533 0.55909 1.1564z'/%3E %3Cpath d='m301.78 144.94c-1.1588 0.23415-0.96168 1.7238-0.62121 1.909 0.56148 0.26163 1.43 0.37153 1.7549-1.3416 0.15172-0.70363 0.2891 3.4979 1.8314 1.8792 0.88761-0.98079 3.0869 0.17799 4.008-1.056 0.65943-0.82191 0.86252-1.3953 0.34883-2.6091-0.14933-0.36914-1.0525-0.18756-1.0011 0.70841 0.0454 0.755-0.53519 1.6868-1.2902 1.5279-0.36675-0.0669 0.20667-1.8469-0.16127-2.3295-0.20309-0.26521-0.5113-0.23654-0.71319 0.0382-0.28313 0.38467 0.28432 2.0906-0.6463 2.3152-1.1743 0.27118-0.55908-1.1409-1.056-1.3989-1.5984-0.80637-1.7525 0.20906-2.4538 0.35719z'/%3E %3Cpath d='m310.83 142.08c0.84938-0.23892 0.58418-0.24012 1.921-1.3344 0.52086-0.39423 0.6236 0.75978 0.56865 1.2161-0.0968 0.77532-1.0178 0.22818-1.3033 0.91031-0.41812 0.88641-0.24848 2.9483-0.38826 3.7882-0.0956 0.43126-0.78726 0.39423-0.85296 0.0538-0.19831-1.0238 0.13977-2.0261 0.10752-3.3067-0.0108-0.43484-0.63316-1.117-0.0526-1.3272z'/%3E %3Cpath d='m305.83 139.46c-0.20548 0.92655-0.18995 1.6899-0.18995 2.3255 0.0466 0.51369 0.98557 0.18278 0.98199 0.11707-0.0466-0.81354 0.13857-1.9389-0.10155-2.2526-0.13021-0.16928-0.64271-0.36484-0.69049-0.18995z'/%3E %3Cpath d='m299.54 130.19-1.4584 5.5938-2.029-3.75v3.8438l-4.375-5.1875 1.5218 5.5625-3.9312-3.3438 2.0924 3.7812-6.9747-4.5 4.4385 5.1875-5.5798-2.75 3.9946 3.375-9.1305-3.4375 8.8135 4.3438c3.2225-1.5882 7.6406-2.5625 12.554-2.5625 4.8962 0 9.3348 0.98435 12.554 2.5625 0.0116 0.006 0.0518-0.006 0.0634 0l8.7501-4.3438-9.0037 3.4688 3.9312-3.4062-5.5164 2.7188 4.375-5.1562-6.9747 4.5 2.0924-3.7812-3.9312 3.3438 1.5218-5.5625-4.375 5.2188 0.0634-3.875-2.029 3.75-1.4584-5.5938z'/%3E %3C/g%3E %3C/g%3E %3Cpath d='m291.82 251.63c-0.00001 0.59294-0.0892 1.4489-0.26749 2.5679h-0.41461c-0.00001-0.76234-0.0357-1.3486-0.107-1.7588-0.0669-0.41014-0.20062-0.89831-0.40124-1.4645-0.16495-0.47701-0.34551-0.88271-0.54166-1.2171-0.19617-0.33881-0.51047-0.78909-0.94291-1.3508l0.82922-2.0463c0.3834 0.4904 0.65535 0.86712 0.81585 1.1301 0.18278 0.30317 0.35442 0.68434 0.51492 1.1435 0.16495 0.4592 0.292 0.94068 0.38117 1.4444 0.0892 0.50378 0.13374 1.0209 0.13375 1.5514' fill='%23fff'/%3E %3Cpath d='m298.32 247.67c-0.00001 0.62415-0.11815 1.0923-0.35443 1.4043-0.23628 0.31208-0.63975 0.53499-1.2104 0.66873 0.16495 0.57957 0.27417 1.0321 0.32768 1.3575 0.0579 0.32546 0.0869 0.6888 0.0869 1.09 0 0.25858-0.0156 0.53498-0.0468 0.82922-0.0268 0.29424-0.078 0.69102-0.15381 1.1903h-0.37448c-0.00001-0.44582-0.0245-0.82922-0.0736-1.1502-0.0446-0.32544-0.11369-0.63083-0.20731-0.91615-0.0223-0.0713-0.14044-0.38563-0.35442-0.94291-0.20954-0.56172-0.41908-1.0276-0.62861-1.3976-0.20507-0.37448-0.54167-0.8894-1.0098-1.5448l0.64197-1.9259c0.33882 0.48595 0.63529 0.82254 0.88941 1.0098 0.25411 0.1828 0.55504 0.27419 0.90278 0.27418 0.75788 0.00001 1.1368-0.41014 1.1368-1.2304h0.38786c0 0.2675 0.007 0.49041 0.0201 0.66872 0.0134 0.17388 0.0201 0.37896 0.0201 0.61523' fill='%23fff'/%3E %3Cpath d='m304.29 252.19-0.48148 2.0062c-0.30316-0.0847-0.55059-0.32321-0.74229-0.71553-0.1605-0.32545-0.27641-0.73783-0.34774-1.2372-0.0669-0.49931-0.10031-1.0165-0.1003-1.5514-0.4057 0.107-0.72669 0.1605-0.96297 0.16049-0.46811 0.00001-0.85597-0.12259-1.1636-0.3678-0.30316-0.24965-0.45474-0.56395-0.45474-0.9429 0-0.81584 0.20954-1.5492 0.62861-2.2001 0.42352-0.65534 0.90054-0.98301 1.4311-0.98302 0.41015 0.00001 0.69547 0.11592 0.85597 0.34773 0.17832 0.25413 0.28755 0.54391 0.32767 0.86935 0.0401 0.32545 0.0602 0.95405 0.0602 1.8858-0.00001 0.83369 0.0669 1.4222 0.20062 1.7654 0.10699 0.26749 0.35665 0.58848 0.74897 0.96297m-1.8056-3.3303c-0.0803-0.50822-0.34774-0.76234-0.80247-0.76235-0.19616 0.00001-0.37672 0.0535-0.54167 0.1605s-0.24743 0.20062-0.24743 0.28086c0 0.2675 0.32099 0.40124 0.96297 0.40124 0.20507 0 0.4146-0.0267 0.6286-0.0802' fill='%23fff'/%3E %3Cpath d='m310.61 251.69-0.24074 2.4342c-0.47703-0.33436-0.91839-0.93844-1.3241-1.8122-0.42353-0.91392-0.85151-2.209-1.284-3.8853-0.37003 1.6139-0.67542 2.7975-0.91615 3.5509-0.23629 0.74898-0.47034 1.2795-0.70217 1.5916-0.15603 0.20953-0.40569 0.4213-0.74897 0.63529l0.0535-2.3272c0.44136-0.60185 0.7512-1.061 0.92953-1.3776 0.26303-0.46811 0.47925-1.0142 0.64866-1.6384 0.17387-0.6286 0.3299-1.469 0.46811-2.5211h0.44136c0.27194 1.0566 0.53498 1.897 0.7891 2.5211 0.23627 0.58848 0.51268 1.1079 0.82922 1.5581 0.2229 0.31653 0.57509 0.74006 1.0566 1.2706' fill='%23fff'/%3E %3Cpath d='m328.98 274.65c0.32497 0.38098 0.55329 0.75473 0.68495 1.1212 0.12801 0.36224 0.22048 0.87984 0.27742 1.5528l-0.72521 0.0591c-0.30903-0.60477-0.60962-1.0784-0.90172-1.4208-0.22275-0.26111-0.58253-0.63238-1.0794-1.1138-0.49683-0.48142-1.0047-0.95049-1.5236-1.4072-0.52252-0.46101-1.188-0.99369-1.9966-1.598-0.28364-0.21128-0.4638-0.36187-0.54049-0.45177-0.11319-0.13269-0.20263-0.39415-0.26833-0.78437-0.0693-0.39448-0.1128-0.88494-0.13041-1.4714l2.5326 2.0598c0.95529 0.78652 1.746 1.4811 2.3722 2.0839 0.48224 0.46431 0.91504 0.92119 1.2984 1.3706m-8.9817-5.4124-0.15174 1.8623-2.9822-0.0806 0.22403-1.9006 2.9099 0.11878m7.8445 8.3364-7.1052 2.1647-1.3076-1.8069 6.1428-1.8715c-0.27881-0.38529-0.49459-0.65466-0.64729-0.80813-0.23728-0.23579-0.50854-0.4207-0.81378-0.55472-0.0197 0.34113-0.16097 0.6409-0.42377 0.89933-0.26282 0.25845-0.60239 0.45109-1.0187 0.57793-0.54602 0.16636-1.0917 0.18937-1.6369 0.069-0.54524-0.12034-0.94606-0.35767-1.2024-0.71196-0.37818-0.52257-0.58114-1.2174-0.60891-2.0846-0.0312-0.95257 0.22954-1.5131 0.78239-1.6815 0.71666-0.21834 1.6856-0.019 2.9069 0.59805 1.2212 0.61706 2.1588 1.3773 2.8126 2.2808l2.12 2.9295m-5.457-3.7938c-0.33492-0.15199-0.60288-0.24601-0.8039-0.28207-0.1974-0.0425-0.378-0.0389-0.54181 0.011-0.20476 0.0624-0.34578 0.17832-0.42306 0.34779-0.0773 0.16949-0.0582 0.33394 0.0571 0.49337 0.0737 0.10186 0.19763 0.16951 0.37177 0.20293 0.17775 0.0269 0.3656 0.0102 0.56352-0.0501 0.15699-0.0478 0.29314-0.12444 0.40847-0.22984 0.11893-0.1119 0.24156-0.27628 0.36786-0.49314m-7.612-1.4544-0.4351 1.8434-2.9552-0.2717 0.44889-1.8622 2.9415 0.29042m7.0047 7.1968-1.5782 0.36205c-0.56162 0.12885-1.0959 0.16839-1.6029 0.11863-0.50697-0.0497-0.98121-0.20821-1.4227-0.47537-0.26101 0.47503-0.71972 0.87346-1.3761 1.1953-0.43524 0.21401-0.94077 0.38707-1.5166 0.51917l-1.1197 0.25686-1.0255-1.882 1.1197-0.25687c0.59006-0.13536 0.99233-0.2484 1.2068-0.33912 0.21909-0.097 0.49354-0.26112 0.82335-0.49247-0.36157-0.22321-0.65323-0.37685-0.87497-0.46091-0.26987-0.099-0.50788-0.12479-0.71405-0.0775-0.0782 0.0179-0.14279 0.0535-0.19377 0.10673-0.0464 0.047-0.0858 0.12867-0.11836 0.24511l-0.49183 0.0661c-0.45495-0.8349-0.5588-1.4805-0.31158-1.9368 0.25182-0.46253 0.85759-0.80388 1.8173-1.0241 0.98816-0.22668 1.8322-0.2776 2.532-0.15275 0.70446 0.11863 1.1761 0.39704 1.4148 0.83524 0.1282 0.23525 0.17671 0.4784 0.14556 0.72944-0.0337 0.24645-0.15614 0.60147-0.36737 1.0651 0.14727 0.0648 0.32005 0.10302 0.51832 0.11461 0.19826 0.0116 0.37559-0.00054 0.53199-0.0364l1.5782-0.36206 1.0255 1.882m-7.5437 1.7549-1.5392 0.2414c-0.85751 0.13449-1.5619 0.003-2.1131-0.3934-0.61288-0.43741-1.1417-1.253-1.5864-2.4466l-0.75738-2.033c-0.17186-0.46128-0.40456-0.80481-0.69812-1.0306-0.14134-0.10869-0.42766-0.25254-0.85894-0.43154l0.52296-1.9696c0.56683 0.31379 1.0036 0.64292 1.3104 0.98741 0.3591 0.40173 0.66356 0.93786 0.91337 1.6084l0.52353 1.4053c0.37027 0.99393 0.72978 1.6674 1.0785 2.0204 0.2764 0.28383 0.5905 0.39815 0.94231 0.34297l1.5391-0.2414 0.72284 1.9403m-6.5774-7.0651-0.99392 1.7499-2.812-0.64929 1.002-1.7654 2.804 0.66485m1.6358 7.9213-7.0124 0.63521-0.42537-1.977 5.8922-0.53374c-0.15305-0.32205-0.36236-0.58714-0.62792-0.79527-0.13913-0.11583-0.44742-0.31021-0.92488-0.58312l0.52396-1.811c0.6487 0.36114 1.1224 0.7579 1.421 1.1903 0.30605 0.43171 0.55448 1.0909 0.74528 1.9776l0.40816 1.897m-5.6298 0.89755c-0.84343-0.028-1.5407-0.0904-2.0917-0.18713-0.55109-0.0967-1.091-0.23959-1.6196-0.42863-0.45261 0.18581-0.85462 0.30471-1.206 0.35671-0.34389 0.0523-0.85848 0.067-1.5437 0.0442l-1.8412-0.0612c-0.50454-0.0168-0.89691-0.11555-1.1771-0.29634-0.28019-0.18078-0.52137-0.47293-0.72355-0.87648-0.4466 0.39667-0.93288 0.67443-1.4588 0.83331-0.44873 0.13694-0.97807 0.19528-1.588 0.17499l-1.6153-0.0537 0.15746-1.9935 1.6153 0.0537c0.7907 0.0263 1.461-0.0959 2.0109-0.36668 0.71498-0.35345 1.1028-0.91373 1.1634-1.6809l0.73973 0.0981c-0.0274 0.15586-0.0566 0.33371-0.0874 0.53354-0.0309 0.19983-0.056 0.4219-0.0753 0.6662-0.0197 0.2492 0.0957 0.46124 0.34614 0.63613 0.25043 0.1749 0.5451 0.26798 0.88397 0.27924l1.3894 0.0462c0.91871 0.0306 1.5804-0.0307 1.9851-0.18384 0.49023-0.18455 0.75696-0.55046 0.80019-1.0977 0.009-0.11727 0.074-0.22044 0.19433-0.30953 0.072-0.0515 0.2177-0.12747 0.43705-0.22796l0.4466-0.2056c0.008 0.0933 0.009 0.22075 0.004 0.38224-0.005 0.15661-0.009 0.25935-0.013 0.3082-0.0212 0.26874-0.10966 0.62343-0.26524 1.0641 0.27166 0.0972 0.57819 0.18334 0.91959 0.25838 0.34136 0.075 0.70273 0.13605 1.0841 0.18302 0.0131-0.16613-0.064-0.38425-0.23145-0.65436-0.16743-0.27011-0.24748-0.45158-0.24013-0.54443 0.01-0.12703 0.0441-0.22387 0.10223-0.29053 0.017-0.0239 0.10579-0.0969 0.26644-0.21895l1.0267-0.81093c0.17899 0.3146 0.29988 0.60031 0.36266 0.85714 0.0707 0.2522 0.0911 0.56641 0.0614 0.94264l-0.21882 2.7704m-10.645-8.1911-1.7712 1.2539-1.3356-0.8244-1.3149 0.9805-1.7572-1.06 1.6777-1.1935 1.4181 0.79248 1.3698-1.0018 1.7134 1.0528m-2.785 7.6352-6.8649-1.1248 0.75327-1.9354 5.7682 0.94517c0.0451-0.33575 0.005-0.63246-0.12018-0.89015-0.0617-0.1413-0.23446-0.39669-0.51839-0.76618l1.5364-1.5497c0.39138 0.49306 0.59992 0.97634 0.62562 1.4498 0.033 0.4747-0.11944 1.1461-0.45729 2.0142l-0.7228 1.8571m-5.7788-0.89598-1.4847-0.3572c-0.82718-0.19901-1.2988-0.56293-1.4148-1.0918-0.13218-0.58491 0.13072-1.4531 0.78871-2.6045l1.1207-1.9611c0.25427-0.44496 0.35675-0.81428 0.30743-1.1079-0.0238-0.14137-0.13755-0.36442-0.34138-0.66916l2.1284-1.4447c0.20032 0.46565 0.27957 0.89694 0.23771 1.2939-0.0477 0.46337-0.25632 1.0185-0.62594 1.6653l-0.77464 1.3556c-0.54789 0.95877-0.82902 1.6478-0.8434 2.067-0.0149 0.3356 0.1474 0.54422 0.48676 0.62586l1.4847 0.3572-1.0696 1.8716m-3.5159-7.43-2.4095 1.0168-1.6552-1.6116 2.4303-1.0261 1.6344 1.6209m-1.0246 6.2246c-0.50104 0.59175-0.99326 1.0359-1.4767 1.3325-0.47979 0.2923-1.0171 0.47477-1.612 0.54741-0.58829 0.075-1.3338 0.0409-2.2364-0.10218-0.89965-0.13648-1.7658-0.35312-2.5985-0.64994-1.6059-0.57245-2.6835-1.205-3.2327-1.8976-0.54624-0.68595-0.52347-1.3784 0.0683-2.0774 0.50465-0.59604 1.1045-1.0912 1.7996-1.4853 0.76509-0.43622 1.9589-0.93173 3.5815-1.4866l0.36605 0.48217c-1.2678 0.49146-2.1422 0.86363-2.623 1.1165-0.4742 0.25522-0.85833 0.55649-1.1524 0.90383-0.38122 0.45025-0.32337 0.95094 0.17355 1.5021 0.50717 0.54921 1.3654 1.0394 2.5748 1.4705 1.1896 0.42403 2.316 0.63299 3.3794 0.62687 1.0634-0.006 1.7766-0.22359 2.1397-0.65239 0.22509-0.26586 0.37567-0.55549 0.45177-0.86889 0.0827-0.31104 0.13265-0.83749 0.14995-1.5794l2.3428-1.4257c0.001 0.70949-0.032 1.186-0.10052 1.4295-0.11762 0.44373-0.41968 0.9529-0.90616 1.5275l-1.0892 1.2864' fill='%23bf0000'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 138 92'%3E %3Crect width='138' height='92' fill='%23fff'/%3E %3Crect width='138' height='36' fill='%23000'/%3E %3Cg transform='translate(69,36)'%3E %3Cg id='c3'%3E %3Cpath id='c' d='M-30,0 0,-5.7423716V5.7423716z' fill='%23fcd116'/%3E %3Cuse xlink:href='%23c' transform='rotate(22.5)'/%3E %3Cuse xlink:href='%23c' transform='rotate(45)'/%3E %3C/g%3E %3Cuse xlink:href='%23c3' transform='rotate(67.5)'/%3E %3Cuse xlink:href='%23c3' transform='rotate(135)'/%3E %3C/g%3E %3Crect y='36' width='138' height='20' fill='%230072c6'/%3E %3Cpath d='M0,0V92H68' fill='%23ce1126'/%3E %3Cpath d='M138,0V92H68' fill='%23ce1126'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1200 600'%3E %3CclipPath id='c'%3E %3Cpath d='M0,0V150H700V300H600zM600,0H300V350H0V300z'/%3E %3C/clipPath%3E %3Crect width='1200' height='600' fill='%2300247d'/%3E %3Cpath d='M0,0 600,300M600,0 0,300' stroke='%23fff' stroke-width='60'/%3E %3Cpath d='M0,0 600,300M600,0 0,300' stroke='%23cf142b' stroke-width='40' clip-path='url(%23c)'/%3E %3Cpath d='M300,0V350M0,150H700' stroke='%23fff' stroke-width='100'/%3E %3Cpath d='M300,0V350M0,150H700' stroke='%23cf142b' stroke-width='60'/%3E %3Cpath d='M0,300H600V0H800V400H0z' fill='%2300247d'/%3E %3Cg%3E %3Cpath fill='%23cc3' d='m780.583,154.039c0,148.827,11.8732,201.675,52.6064,242.479,40.7332,40.8042,56.1659,47.2313,67.5231,53.4827,13.1015-7.21148,28.1971-15.1341,65.1152-52.0521,36.513-36.515,54.173-89.15,54.173-246.452-26.559,11.3712-39.7859,15.1175-63.0119,15.0513-17.202,1.68548-43.7399-9.33789-59.6086-16.5484-10.371,6.60246-25.4152,14.4763-52.4514,15.3604-31.2252,1.30952-41.1191-3.73522-64.3451-11.3217z'/%3E %3Cpath fill='%23fff' d='m787.775,163.438c0,46.0434-2.72184,108.794,7.00639,145.1,9.77001,36.4622,12.0129,41.8034,19.3596,54.5282l171.206-1.27105c10.576-18.3181,11.1098-29.6647,18.9526-58.9348,7.8148-29.1649,9.7886-94.177,10.0167-142.6-17.216,8.72445-39.7613,14.9075-61.6436,12.1948-17.5423-1.2754-33.7513-5.09258-52.6268-15.2637-16.374,9.35261-22.0822,13.6217-49.1184,14.7138-21.0507,0.98975-38.1018,2.61503-63.1522-8.46789z'/%3E %3Cpath fill='%239cf' d='m814.51,362.056c12.1849,24.4477,69.6325,71.3032,86.433,81.0029,19.168-11.0667,69.8476-57.368,83.9727-81.0029h-170.406z'/%3E %3Cpath fill='%23f90' d='m904.221,231.606c5.41355,12.1396,22.7699,25.5448,27.5414,32.1145-6.07314,6.56934-7.28706,5.85387-6.49064,18.0587,10.5604-10.534,10.7499-11.6322,17.5423-10.0346,14.8794,14.1555,2.66292,44.5571-9.63422,51.1666-12.2936,7.05101-10.0622-0.24417-28.4886,8.59299,8.44836,6.88711,18.237-1.01015,26.2362,1.10047,4.34697,4.91697-2.06648,13.8779,1.31216,22.317,7.06953-0.6489,6.22049-14.2559,7.86595-19.1896,5.16445-18.0757,36.2143-30.6826,37.7931-47.2631,6.54677-2.93012,13.09-0.9165,21.0507,3.34487-3.96455-15.5336-17.0792-15.3664-20.5946-20.2178-8.36767-12.1907-15.7845-26.0981-33.6566-29.7059-13.5672-2.73878-12.5532,0.82385-21.2472-4.83-5.41355-4.01853-21.8612-11.6181-19.2298-5.45416z'/%3E %3Cpath fill='%23f90' d='m860.839,283.106c8.72935-10.2344,13.0534-31.1272,16.9171-38.2184,8.92956,2.05041,8.83312,3.40792,19.7799-2.96497-14.7027-3.98084-15.8096-3.62755-17.5012-10.0994,6.17695-19.1553,40.0786-23.0599,51.953-15.7817,12.2822,7.06894,4.4742,8.596,21.2779,20.0001,2.44044-10.3389-9.45634-14.9009-11.2359-22.6298,2.52932-5.96126,13.8358-4.74122,20.084-11.5316-3.90439-5.6561-16.127,1.41619-21.4712,2.33396-19.1762,4.09085-45.373-16.1931-61.4875-9.77821-5.77578-4.14976-6.96507-10.606-6.73193-19.3072-12.5539,10.5985-6.27225,21.5753-9.12921,26.805-7.39678,12.7485-16.8297,25.4974-11.8265,42.248,3.79803,12.7158,6.62838,10.1968,5.44639,20.1666-1.19785,6.44061-0.56211,23.8553,3.92513,18.7577z'/%3E %3Cpath fill='%23f90' d='m931.763,290.302c-13.7027-1.82835-34.6943,5.45107-43.0585,5.96673-2.77851-8.34642-1.51002-8.96995-12.8934-14.605,4.03197,14.0554,4.9217,14.7758-0.0129,19.5038-20.3904,4.86884-41.4321-20.7724-41.0411-34.2257-0.008-13.6779,5.40195-8.09713,6.94685-27.7067-10.5433,3.35691-8.48447,15.4235-14.502,20.8735-6.65962,1.01994-11.4131-8.83635-20.7407-10.4218-3.05765,6.11145,9.61345,12.4257,13.2018,16.3114,13.5917,13.53,8.93457,45.397,23.0288,55.2268-0.7374,6.85915-5.91783,11.1692-13.8492,15.48,16.0079,4.76053,22.612-6.04289,28.7845-6.41709,15.2702-0.5594,31.594,0.5423,44.0424-12.2046,9.45-9.67656,5.72467-10.6828,15.2857-14.8756,6.40117-2.35427,21.7049-11.8813,14.8078-12.9056z'/%3E %3Ccircle fill='%23fff' cx='266.239' cy='122.104' r='0.806' transform='matrix(3.5084546,0,0,3.3448778,6.3307176,-163.01097)'/%3E %3Ccircle fill='%23fff' cx='266.239' cy='122.104' r='0.806' transform='matrix(-1.6389991,-2.9574373,3.1020668,-1.5625831,914.32327,1224.3275)'/%3E %3Ccircle fill='%23fff' cx='266.239' cy='122.104' r='0.806' transform='matrix(-1.8069804,2.8671155,-3.007328,-1.7227325,1749.0027,-240.21318)'/%3E %3C/g%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 700 500'%3E %3Crect width='700' height='500' fill='%23e41e20'/%3E %3Cpath id='half' d='m300.094,97.2043c-4.8618-0.082-12.9308,1.54998-12.75,5.2812-13.5419-2.32092-14.952,3.27267-14.1562,8.25003,1.28844-1.97532,2.85723-3.04776,4.06251-3.24999,1.80576-0.2997,3.6954,0.2835,5.625,1.46871,1.92969,1.1853,4.05558,3.09798,5.00004,4.28121-4.77945,1.14264-8.4717,0.405-12.2188-0.2502-1.84716-0.3231-4.43205-1.36224-5.96871-2.43747-1.53666-1.07541-2.0205-2.08755-4.43754-4.56246-2.84967-2.91798-5.88258-2.09637-4.93749,2.43747,2.18556,4.21092,5.83659,6.08859,10.4375,6.84378,2.214,0.3636,5.51196,1.15263,9.25,1.15623,3.73806,0.004,7.93521-0.54,10.2188-0.0625-1.37187,0.8613-2.92428,2.34621-6.00003,2.93751-3.12777,0.6012-7.88301-1.85994-10.7812-2.53125,0.3681,2.43855,3.44403,4.71816,9.49999,5.90625,9.95152,2.16693,18.2208,3.81375,23.6875,6.78123,5.46669,2.96748,8.91342,6.68268,11.375,9.59375,4.89861,5.79312,5.15628,10.2402,5.46876,11.2187,1.00782,9.2557-2.21958,14.4622-8.21871,16.0625-2.99961,0.8001-8.32788-0.7065-10.2812-2.99997-1.95345-2.29293-3.85407-6.23421-3.31254-12.4062,0.5265-2.42127,3.29526-8.72811,0.93753-10.0312-10.8616-6.00326-24.0512-12.0744-33.5938-15.6873-2.60815-0.98745-4.75675,2.55735-5.59375,3.9375-16.2111-1.97418-30.827-12.9443-37.4062-24.625-4.48101-7.95555-11.8665,0.0164-10.625,7.5312,2.0043,8.38764,8.39502,14.4519,16.0625,18.75,7.86951,4.33314,17.7059,8.59698,27.6562,8.37504,5.36067,1.01412,5.30775,7.94943-1.125,9.24999-12.5809,0.0796-22.6175-0.234-32.0938-9.375-7.18776-6.5628-11.2342,1.25694-9.15624,5.68746,3.52134,13.6583,23.0063,17.483,42.7187,13.0625,7.63344-1.26414,3.06252,6.91542,0.90621,7.00002-8.23662,5.90562-22.9827,11.6841-35.9688-0.0625-5.94243-4.55022-9.96016-0.7254-7.74999,5.84379,5.76216,17.1274,27.8037,13.5302,42.9375,5.09373,3.89529-2.17143,7.43049,2.88045,2.68749,6.71877-18.8201,13.1503-28.2298,13.2999-36.7187,8.24998-10.6275-4.1913-11.5623,7.59637-5.25,11.4688,7.01595,4.30398,24.8701,1.07703,37.9688-7.15626,5.61537-4.17483,5.86944,2.35305,2.31246,4.93749-15.5442,13.4334-21.671,16.971-37.875,14.7812-8.03511-0.6264-7.91442,9.2799-1.59372,13.1562,8.62983,5.29245,25.4827-3.49245,38.5625-14.3438,5.50521-2.94165,6.40935,1.88271,3.68748,7.59375-7.99209,10.0832-15.4932,16.0281-22.7187,18.7812-7.22556,2.75319-14.1755,2.31453-19.0938,0.6246-6.00021-2.06145-6.75261,4.17429-3.43746,9.84375,1.99836,3.41748,10.2797,4.51332,19.2187,1.34379,8.93907-3.16908,18.5358-10.6026,25.125-19.3125,5.73291-5.01894,5.01993,1.72368,2.40624,6.46875-13.1944,20.8587-25.262,28.5963-41.1562,27.2812-7.04754-1.19673-8.6481,4.28364-4.1562,9.34375,7.88742,6.54111,17.7493,6.336,26.375-0.1251,7.66818-7.39323,22.3379-23.3134,30.0312-31.8438,5.42133-4.32189,7.1532-0.0612,5.56254,8.71875-1.44666,5.02803-5.06826,10.3234-14.9375,14.1875-6.74226,3.84804-1.67904,9.15142,3.375,9.25,2.78136,0.0542,8.42922-3.19716,12.75-8.06247,5.68422-6.40053,6.02226-10.6976,9.15625-20.6562,2.96091-4.85442,8.24949-2.58858,8.25003,2.50002-2.53647,9.97519-4.71582,11.7638-9.84375,15.8438-4.90482,4.60494,3.41523,6.13962,6.21873,4.24998,8.11044-5.46678,11.0713-12.5383,13.7812-18.9688,1.95606-4.64166,7.63038-2.39148,5.00004,5.18751-6.28605,18.1128-16.6152,25.2447-34.6875,28.9062-1.83159,0.3258-2.94876,1.40661-2.31246,3.53124,2.42559,2.51811,4.85559,4.80303,7.28127,7.3125-11.1751,3.25377-20.2541,5.08171-31.4377,8.34421-5.48685-3.59721-9.9194-6.64909-15.4062-10.25-1.44684-3.38229-2.12149-8.54505-10.2188-4.90626-5.48685-2.53413-8.01783-1.60488-11.0625,0.93753,4.39542,0.1638,6.30783,1.34091,8.03124,3.34377,2.25009,5.92614,7.43877,6.49863,12.75,4.81248,3.45528,2.91078,5.29542,5.1435,8.74998,8.06247-6.44922-0.2205-10.9422-0.3348-17.375-0.531-6.1407-6.5934-11.042-6.23223-15.4375-1.06245-3.35007,0.5148-4.77018,0.5868-7.06248,4.65624,3.60513-1.4796,5.87322-1.92312,7.43751-0.3123,6.52869,3.78495,10.7938,2.94012,14.0313,0,6.29874,0.3852,11.9746,0.711,18.2812,1.125-2.3166,1.96911-5.49585,3.01365-7.81254,5.00004-9.4603-2.70648-14.3979,0.93663-16.0625,8.65629-1.26783,3.11571-1.86147,6.32349-1.31247,9.65626,0.91566-3.04839,2.38788-5.66937,5.09373-7.3125,8.43201,2.14182,11.6026-1.3005,12.0625-6.34374,4.06449-3.31632,10.1935-4.04766,14.25-7.40628,4.743,1.51839,7.03575,2.45889,11.8125,3.96873,1.6983,5.16078,5.5413,7.20423,11.7812,5.87502,7.42797,0.2331,6.11667,3.28095,6.71877,5.71878,1.97406-3.50109,1.91907-6.90588-2.65626-10-1.66464-4.52241-5.35275-6.57918-10.1875-3.96873-4.55094-1.29204-5.7474-3.1491-10.2812-4.43754,11.4681-3.65526,19.603-4.47777,31.0625-8.12502,2.86848,2.70585,5.14188,4.64841,8.03124,7.06248,1.5228,0.90891,2.98053,1.13787,3.87504,0,7.18083-10.3932,10.3879-19.5528,17.0625-26.4062,2.54997-2.83554,5.77161-6.66135,9.34375-7.59375,1.78605-0.4662,3.97638-0.1818,5.37498,1.34379,1.3986,1.52541,2.49723,4.33683,2.0313,8.53128-0.6687,6.02082-2.12337,7.9218-3.81249,11.5312-1.68912,3.60954-3.75336,5.82975-5.87502,8.59374-4.24341,5.52789-9.8424,8.74539-13.1562,10.9062-6.62769,4.3218-9.43073,2.43027-14.5625,2.15622-6.63273,0.7443-8.39754,3.97467-2.96874,8.4375,5.07492,2.64051,9.63652,2.96649,13.3438,2.28123,3.18312-0.5886,6.90831-4.6971,9.5625-6.90624,2.98764-3.4515,7.94097,0.6417,4.56246,4.65624-6.13935,7.29477-12.2738,12.1044-19.8438,12-7.95465,1.07055-6.46668,5.54004-1.18746,7.71876,9.50117,3.92121,18.0796-3.42351,22.4375-8.25003,3.36222-3.67839,5.75028-3.82185,5.15628,1.87497-3.33783,10.3136-7.89912,14.2977-15.3438,14.8125-6.03855-0.5607-6.1038,4.10058-1.6875,7.25004,10.0603,6.96321,17.3459-4.89474,20.75-12.0625,2.42568-6.46569,6.14619-3.39093,6.5313,1.93752,0.0502,7.11936-3.16674,12.9321-11.7812,20.2187,6.59115,10.5015,14.2752,21.1829,20.8749,31.7188l20.005-222.806-20-35.202c-2.08305-1.92312-9.12777-10.223-10.9686-11.375-0.6714-0.7173-1.07973-1.22409-0.0936-1.59372,0.95364-0.3573,3.18591-0.7578,4.68747-1.03122-4.2417-4.2489-7.87662-5.61159-15.9065-7.93728,1.95687-0.8334,3.86037-0.3483,9.625-0.6246-2.2886-3.24868-7.40028-8.22482-14-10.6254,4.35852-3.09852,5.20785-3.30617,9.53126-6.93749-7.48656-0.531-13.8798-1.95712-20.3125-3.90625-4.06692-1.90161-9.71539-3.51615-12.4687-3.56251zm0.7191,8.71875c3.95622,0,6.40629,1.35612,6.40629,2.99997,0,1.67238-2.45007,3.03129-6.40629,3.03129-3.93975,0-6.43752-1.48293-6.43752-3.15621,0.00071-1.64385,2.49777-2.87505,6.43752-2.87505z' fill='%23000'/%3E %3Cuse xlink:href='%23half' transform='matrix(-1,0,0,1,700,0)'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1200 600'%3E %3Crect fill='%23F2A800' width='1200' height='600'/%3E %3Crect fill='%230033A0' width='1200' height='400'/%3E %3Crect fill='%23D90012' width='1200' height='200'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns:dc='http://purl.org/dc/elements/1.1/' xmlns:cc='http://creativecommons.org/ns%23' xmlns:rdf='http://www.w3.org/1999/02/22-rdf-syntax-ns%23' xmlns:svg='http://www.w3.org/2000/svg' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' xmlns:sodipodi='http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd' xmlns:inkscape='http://www.inkscape.org/namespaces/inkscape' viewBox='-27 -14 54 36' id='svg2' inkscape:version='0.47 r22583' sodipodi:docname='Flag_of_the_Netherlands_Antilles.svg'%3E %3Cdefs id='defs32'%3E %3Cinkscape:perspective sodipodi:type='inkscape:persp3d' inkscape:vp_x='0 : 300 : 1' inkscape:vp_y='0 : 1000 : 0' inkscape:vp_z='900 : 300 : 1' inkscape:persp3d-origin='450 : 200 : 1' id='perspective36'/%3E %3C/defs%3E %3Csodipodi:namedview pagecolor='%23ffffff' bordercolor='%23666666' borderopacity='1' objecttolerance='10' gridtolerance='10' guidetolerance='10' inkscape:pageopacity='0' inkscape:pageshadow='2' inkscape:window-width='1280' inkscape:window-height='1004' id='namedview30' showgrid='false' inkscape:zoom='1.1125147' inkscape:cx='468.641' inkscape:cy='260.37544' inkscape:window-x='-8' inkscape:window-y='-8' inkscape:window-maximized='1' inkscape:current-layer='svg2'/%3E %3Crect fill='white' x='-27' y='-14' width='54' height='36' id='rect4'/%3E %3Crect fill='%23dc171d' x='-6' y='-14' width='12' height='36' id='rect6'/%3E %3Crect fill='%2300007b' x='-27' y='-2' width='54' height='12' id='rect8' style='fill:%23012a87;fill-opacity:1'/%3E %3Cg id='star' fill='white' transform='scale(1.5)'%3E %3Cg id='cone'%3E %3Cpolygon id='triangle' points='0,0 0,1 .5,1' transform='translate(0,-1) rotate(18)'/%3E %3Cuse xlink:href='%23triangle' transform='scale(-1,1)' id='use13'/%3E %3C/g%3E %3Cuse xlink:href='%23cone' transform='rotate(72)' id='use15'/%3E %3Cuse xlink:href='%23cone' transform='rotate(-72)' id='use17'/%3E %3Cuse xlink:href='%23cone' transform='rotate(144)' id='use19'/%3E %3Cuse xlink:href='%23cone' transform='rotate(-144)' id='use21'/%3E %3C/g%3E %3Cg id='2stars'%3E %3Cuse xlink:href='%23star' transform='rotate(22.5) translate(8.65913760233915175039557128586223072097712) rotate(-22.5)' id='use24'/%3E %3Cuse xlink:href='%23star' transform='rotate(67.5) translate(8.65913760233915175039557128586223072097712) rotate(-67.5)' id='use26'/%3E %3C/g%3E %3Cuse xlink:href='%232stars' transform='scale(-1,1)' id='use28'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 450 300'%3E %3Crect width='450' height='300' fill='%23000'/%3E %3Crect width='450' height='150' fill='%23ce1126'/%3E %3Cg fill='%23f9d616'%3E %3Cpath d='M231.115,91.82A58.5,58.5 0 1,1 187.916,195.244L179.358,205.685A72,72 0 1,0 232.526,78.394z'/%3E %3Cg id='s3'%3E %3Cpath id='s' d='M302.62435,142.35494C303.12516,147.43953 303.12516,152.56101 302.62435,157.6456L287.69659,156.17534C288.10106,152.06855 288.10106,147.93196 287.69659,143.82518z'/%3E %3Cuse xlink:href='%23s' transform='rotate(22.5,225,150)'/%3E %3Cuse xlink:href='%23s' transform='rotate(45,225,150)'/%3E %3C/g%3E %3Cuse xlink:href='%23s3' transform='rotate(-67.5,225,150)'/%3E %3Cuse xlink:href='%23s3' transform='rotate(67.5,225,150)'/%3E %3Cpath d='M199.32444,114.65618H250.67551L209.1325,144.84033 224.99998,96.000328 240.86746,144.84033z'/%3E %3Cpath d='M287.87869,216.3146C291.71694,220.02891 296.88529,223.69038 300.6338,227.01716C304.38231,230.34392 307.25434,233.10958 309.57908,236.88884C312.98624,242.42773 309.16023,248.7008 303.85486,245.01872C300.98581,243.02751 299.18307,237.65214 294.78788,233.20395C291.53252,230.43267 288.96764,227.52745 280.78551,226.1257C280.39268,226.05841 280.27777,225.22842 280.58665,224.86618z'/%3E %3Cpath fill='%23000' d='M231.36058,197.84505 251.60791,209.8174 256.00949,226.89558 279.24991,225.13494 289.46162,213.16262 251.60791,186.9291 231.36058,197.84505z'/%3E %3Cpath d='M279.66324,223.6894C253.62799,206.37539 237.07238,197.02622 212.12131,182.83938C202.31974,177.26634 187.0985,163.25747 199.1052,139.81914C199.86106,155.20638 260.67394,197.4423 286.3703,215.80679z'/%3E %3Cpath fill='none' stroke='%23000' stroke-width='1.5' stroke-linecap='round' d='M216.08561,167.51949C236.13137,186.41034 261.37565,201.82127 283.89761,218.85496'/%3E %3Ccircle id='c' cx='290.4' cy='222.297' r='1.008' fill='%23000'/%3E %3Cuse xlink:href='%23c' x='7.41957' y='6.4655991'/%3E %3Cuse xlink:href='%23c' x='13.93812' y='13.090317'/%3E %3C/g%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns:dc='http://purl.org/dc/elements/1.1/' xmlns:cc='http://creativecommons.org/ns%23' xmlns:rdf='http://www.w3.org/1999/02/22-rdf-syntax-ns%23' xmlns:svg='http://www.w3.org/2000/svg' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 267 267'%3E %3Ctitle id='title4'%3EAntarctic Treaty System flag%3C/title%3E %3Cdefs id='defs6'%3E %3Cg id='lines' style='fill:none'%3E %3Ccircle cx='133.5' cy='133.5' r='49.5' id='circle9'/%3E %3Ccircle cx='133.5' cy='133.5' r='92.5' id='circle11'/%3E %3Ccircle cx='133.5' cy='133.5' r='133' id='circle13'/%3E %3Cpath d='M -100,133.5 H 367 M 133.5,-100 v 467' id='axes'/%3E %3Cuse transform='matrix(0.8660254,0.5,-0.5,0.8660254,84.635609,-48.864391)' id='use16' x='0' y='0' width='267' height='267' xlink:href='%23axes'/%3E %3Cuse transform='matrix(0.5,0.8660254,-0.8660254,0.5,182.36439,-48.864391)' id='use18' x='0' y='0' width='267' height='267' xlink:href='%23axes'/%3E %3C/g%3E %3Cpath d='m 146.39642,44.921091 -0.62414,-0.267304 0.62414,0.267304 z m 17.83255,176.420599 -2.40739,-1.42562 -7.13302,1.78204 -6.24138,-3.92046 0,1.51472 -1.51576,-2.04931 1.78325,-1.78204 -0.26749,-5.34606 2.05074,0 1.24828,-3.56408 1.4266,-0.62369 -1.15911,-1.78204 1.78325,-0.62369 -0.26748,-2.67305 -1.78326,-0.891 2.31823,-0.26731 -1.4266,-6.50441 -3.56652,-3.56405 -2.13991,0.89101 0.89163,2.94035 -7.40052,0 -6.24138,-2.67304 -2.40739,-1.15832 -11.85865,-2.67304 -0.89162,1.42563 -4.19065,0.35638 -1.15912,0 -1.78325,2.94035 -5.08228,-3.56408 -2.67488,0.89104 0.35665,2.40573 -6.598031,-3.56408 -0.26749,2.31663 -6.50889,-2.94032 -0.356652,0.26728 -3.20987,1.24742 -0.624139,-2.4057 -7.757141,-3.83136 -8.292116,-2.67305 -1.515767,-6.86082 0,-1.51472 -3.20987,-5.88068 1.426603,-7.1281 -2.674879,-0.89101 -0.891627,-3.02945 4.458122,-0.53459 -2.05074,0 0.267488,-4.45506 -6.508889,2.04932 -0.267488,-1.78201 -0.891627,3.29674 -3.566522,1.4256 -2.407394,-2.3166 -0.891627,-2.40577 -0.891628,-4.72236 2.050743,-1.51473 0.891627,1.15831 0.624137,-1.42559 -1.515764,-10.69218 2.407391,0.53461 1.159115,-11.22677 0.356652,-0.35641 2.318231,-1.42562 -2.94237,0.26731 -1.159113,-2.67304 5.349753,-5.96979 -4.814774,-0.89102 -3.566521,3.56407 -1.426604,-4.09865 -2.139906,2.94034 -0.534973,-2.04933 -2.674882,0.89102 -1.783255,0.89101 1.426603,-5.34607 -1.159112,-0.6237 0.624137,-1.51472 -1.515764,0.3564 -0.267488,-3.02946 5.617258,0 -0.267488,-1.42562 -1.783258,0 -3.299015,-5.702466 -1.783255,0.623709 -1.159115,-2.049329 -0.624137,1.782028 -1.783255,-1.247416 1.783255,-1.158315 -2.674882,-0.891014 0.624139,-1.514723 -2.1399,-1.158315 -0.53498,-4.72237 -2.1399,-0.623709 1.24827,-0.891014 -2.40739,-6.237081 0.26749,-2.049328 0.89163,-6.237084 1.78325,0 -0.53497,3.831353 4.458119,6.237084 3.20987,4.187761 6.598037,1.782027 0,0.267302 0.891628,-1.51472 3.566521,4.187761 1.783255,2.049326 0.891627,0.891013 10.07538,4.811459 1.783255,0.891013 0.624137,0.534606 4.725627,5.702472 2.67488,-1.24742 19.615777,-4.455046 0.62414,-3.564064 1.4266,0.623707 -0.26748,-1.158312 0.89162,-0.62371 4.190651,-1.514723 0,-4.098642 1.4266,-1.514723 1.78326,-6.860809 -0.89163,-2.673038 4.19065,-10.068437 0,-1.514723 0,-4.72237 2.05074,0 2.4074,-3.564064 2.94236,-0.891013 0.35665,-3.296745 4.10147,-4.989662 1.78326,0.891014 8.3813,-3.029456 0.89163,-0.891013 1.78325,-1.782025 -0.62414,-2.940342 1.78326,0 0.89163,4.72237 9.18374,2.138432 1.51577,-1.514723 0.62414,0.267304 8.02464,1.782028 0.26749,-0.267305 4.19065,-2.405736 0.26749,2.673038 3.56652,0.356405 2.94237,2.316633 0.62412,0.623709 4.45812,3.831354 5.34976,0.356408 3.29902,0.534605 4.10147,-1.425619 0.35665,2.673038 1.78328,1.158315 1.42658,-2.673038 1.78328,0 1.24829,6.860811 1.42656,0.267305 -0.26746,2.405733 -0.26753,0.267302 0.53499,0 3.56654,-1.782025 3.299,-1.158315 9.18376,3.207656 1.78324,-0.534606 0.62418,3.207659 2.40739,0.356405 -0.62418,-1.51472 2.05074,0 0.62417,3.296745 2.40739,-2.673038 5.61725,3.564066 1.51575,6.504404 -2.40738,0.623706 0.62417,4.989662 0.89158,1.51472 6.24139,15.770913 -3.29902,2.940335 -0.26746,3.56407 -2.67491,3.29674 2.9424,2.04933 -1.15913,0.89101 2.67488,2.67304 4.10147,0.62371 1.24829,1.78203 1.15909,2.31663 2.94237,1.24741 3.56655,-2.40573 2.40736,0.26731 -2.94234,4.18776 2.94234,7.75179 -3.56652,2.94034 1.51578,4.72237 -0.8916,4.18776 1.78321,2.40574 4.72564,0.891 -4.72564,6.50441 0.89164,1.15834 1.15912,1.24739 -2.05076,3.20767 2.05076,1.24741 -10.43202,8.55373 2.40739,5.96978 -0.62415,3.56408 -3.56654,1.15828 -0.89158,3.02946 -4.10147,1.78204 -1.24829,3.83136 -0.89163,2.04932 4.19066,2.13845 -6.2414,0.53459 1.51575,3.29674 -3.03153,2.94036 -4.72565,0.891 -1.51575,2.67305 3.56652,1.78201 -6.77635,6.23709 2.05073,3.29674 -5.34975,-1.15832 -5.97391,3.56408 -8.02463,3.83135 -1.78328,2.67305 -1.15909,-0.89101 1.15909,-2.67307 -5.34976,2.04932 -1.15909,-2.04932 -8.02464,4.72239 -3.56652,-1.15831 -6.50888,1.15831 -1.78327,-0.89103 m 0.26749,-172.232701 -0.62415,-0.623706 -0.26746,0 0,0.356404 0.62412,0 0.26749,0.267305 0,0 z m -2.05076,171.341841 1.78327,0.89101 -1.78327,-0.89101 z m 0,0 1.78327,0.89101 M 39.044473,98.738565 l 0.356652,-2.138429 -3.299019,-2.049329 2.94237,4.187761 -3e-6,0 z m -7.133017,-16.394636 -1.78325,0 0.89163,2.673035 0.89162,-2.316633 0,-0.356405 0,0 z m -0.89162,-2.673038 -0.89163,0.891014 1.78325,1.247418 -0.89162,-2.138432 z m 8.02464,19.067656 0.356652,-2.138429 -3.299022,-2.049329 2.942373,4.187761 0,0 z m -7.13301,-16.394636 -1.78326,0 0.89163,2.673035 0.89163,-2.31663 0,-0.356408 0,0 z m -0.89163,-2.673038 -0.89163,0.891013 1.78326,1.247419 -0.89163,-2.138432 z m 8.024643,19.067659 0.356652,-2.138432 -3.299015,-2.049326 2.942366,4.187761 -3e-6,0 z m -7.133013,-16.394639 -1.78325,0 0.89162,2.673038 0.89163,-2.316633 0,-0.356408 0,0 z m -0.89163,-2.673035 -0.89162,0.89101 1.78325,1.247419 -0.89163,-2.138429 z m 5.34976,-6.237084 0,-2.316633 -2.05075,0.534605 0.26749,1.514723 1.78326,0.267305 0,0 z m -2.31824,-6.504404 0.53498,1.158316 1.24828,-2.673039 -1.78326,1.247419 0,0.267304 0,0 z m 2.31824,6.504404 0,-2.316633 -2.05075,0.534605 0.26749,1.514723 1.78326,0.267305 0,0 z m -2.31824,-6.504404 0.53498,1.158316 1.24828,-2.673039 -1.78326,1.247419 0,0.267304 0,0 z m 2.31824,6.504404 0,-2.316633 -2.05075,0.534605 0.26749,1.514723 1.78326,0.267305 0,0 z m -2.31824,-6.504404 0.53498,1.158316 1.24828,-2.673039 -1.78326,1.247419 0,0.267304 0,0 z m 31.74199,90.88333 -2.050742,0.26734 -1.783255,2.4057 2.94237,-0.62369 0.891627,-2.04932 0,0 z m 0,0 -2.050742,0.26734 -1.783255,2.4057 2.94237,-0.62369 0.891627,-2.04932 0,0 z m 0,0 -2.050742,0.26734 -1.783255,2.4057 2.94237,-0.62369 0.891627,-2.04932 0,0 z m 2.139904,-60.321433 -0.62414,-0.534606 -1.783254,-0.891013 1.783254,0.891013 0.62414,0.534606 z' transform='translate(0,-1.5)' id='antarctica' style='fill:%23ffffff'/%3E %3CclipPath id='clip'%3E %3Cuse id='use22' x='0' y='0' width='267' height='267' xlink:href='%23antarctica'/%3E %3C/clipPath%3E %3C/defs%3E %3Crect width='267' height='267' x='0' y='0' id='fondo' style='fill:%23072b5f;fill-opacity:1'/%3E %3Cuse id='use25' style='stroke:%23ffffff;stroke-width:3;stroke-miterlimit:4;stroke-dasharray:none' x='0' y='0' width='267' height='267' xlink:href='%23lines'/%3E %3Cuse id='use27' x='0' y='0' width='267' height='267' xlink:href='%23antarctica'/%3E %3Cuse clip-path='url(%23clip)' id='use29' style='stroke:%23072b5f;stroke-width:3;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' x='0' y='0' width='267' height='267' xlink:href='%23lines'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 800 500'%3E %3Crect width='800' fill='%2374acdf' height='500'/%3E %3Crect y='166.67' width='800' fill='%23fff' height='166.67'/%3E %3Cg id='rays'%3E %3Cpath id='ray1' stroke-width='1.1116' stroke='%2385340a' fill='%23f6b40e' d='m396.84 251.31l28.454 61.992s0.4896 1.185 1.28 0.8586c0.7902-0.3267 0.2988-1.5116 0.2988-1.5116l-23.715-63.956m-0.68 24.12c-0.3465 9.4278 5.4526 14.613 4.6943 23.032-0.7569 8.42 3.8673 13.18 4.9396 16.454 1.0733 3.2744-1.16 5.2323-0.198 5.6982 0.96336 0.4662 3.07-2.1207 2.3833-6.7756-0.68675-4.6549-4.2204-6.0368-3.3898-16.32 0.83-10.283-4.206-12.678-2.98-22.058'/%3E %3Cuse xlink:href='%23ray1' transform='rotate(22.5 400,250)'/%3E %3Cuse xlink:href='%23ray1' transform='rotate(45 400,250)'/%3E %3Cuse xlink:href='%23ray1' transform='rotate(67.5 400,250)'/%3E %3Cpath id='ray2' fill='%2385340a' d='m404.31 274.41c0.45334 9.0538 5.5867 13.063 4.5787 21.314 2.2133-6.5249-3.1233-11.583-2.82-21.22m-7.6487-23.757l19.487 42.577-16.329-43.887'/%3E %3Cuse xlink:href='%23ray2' transform='rotate(22.5 400,250)'/%3E %3Cuse xlink:href='%23ray2' transform='rotate(45 400,250)'/%3E %3Cuse xlink:href='%23ray2' transform='rotate(67.5 400,250)'/%3E %3C/g%3E %3Cuse xlink:href='%23rays' transform='rotate(90 400,250)'/%3E %3Cuse xlink:href='%23rays' transform='rotate(180 400,250)'/%3E %3Cuse xlink:href='%23rays' transform='rotate(270 400,250)'/%3E %3Ccircle r='27.778' stroke='%2385340a' cy='250' cx='400' stroke-width='1.5' fill='%23f6b40e'/%3E %3Cpath id='loweyecontour' fill='%23843511' d='m409.47 244.06c-1.8967 0.00003-3.7131 0.82183-4.7812 2.5312 2.1367 1.9227 6.8565 2.1318 10.062-0.21875-1.3883-1.4954-3.3845-2.3125-5.2812-2.3125zm-0.0312 0.4375c1.8462-0.0335 3.5717 0.81446 3.8125 1.6562-2.1367 2.3504-5.5508 2.1463-7.6875 0.4375 0.9348-1.4957 2.4391-2.0677 3.875-2.0938z'/%3E %3Cuse xlink:href='%23uppalpebra' transform='matrix(-1 0 0 1 800.25 0)'/%3E %3Cuse xlink:href='%23eyebrow_nose' transform='matrix(-1 0 0 1 800.25 0)'/%3E %3Cuse xlink:href='%23pupil' transform='translate(18.862)'/%3E %3Cuse xlink:href='%23lowpalpebra' transform='matrix(-1 0 0 1 800.25 0)'/%3E %3Cpath d='m395.75 253.84c-0.91341 0.16668-1.5625 0.97727-1.5625 1.9062 0 1.0614 0.87748 1.9062 1.9375 1.9062 0.62667 0 1.2025-0.2968 1.5625-0.8125 0.73952 0.55614 1.7646 0.61511 2.3125 0.625 0.0843 0.002 0.19312 0 0.25 0 0.54791-0.01 1.573-0.0689 2.3125-0.625 0.36 0.5157 0.93583 0.8125 1.5625 0.8125 1.06 0 1.9375-0.84488 1.9375-1.9062 0-0.92898-0.64918-1.7396-1.5625-1.9062 0.513 0.1809 0.84375 0.6765 0.84375 1.2188 0 0.7074-0.57124 1.2812-1.2812 1.2812-0.6804 0-1.2413-0.54015-1.2812-1.2188-0.20862 0.41637-1.0341 1.6551-2.6562 1.7188-1.6222-0.0636-2.4476-1.3024-2.6562-1.7188-0.04 0.6786-0.60085 1.2188-1.2812 1.2188-0.71001 0-1.2812-0.57385-1.2812-1.2812 0-0.54225 0.33075-1.0378 0.84375-1.2188z' fill='%2385340a'/%3E %3Cpath d='m397.84 259.53c-2.138 0-2.9829 1.9368-4.9062 3.2188 1.0687-0.42633 1.9096-1.2693 3.4062-2.125 1.496-0.85442 2.7717 0.1875 3.625 0.1875h0.0312c0.8532 0 2.129-1.0416 3.625-0.1875 1.4967 0.8559 2.3688 1.6987 3.4375 2.125-1.9233-1.282-2.7996-3.2188-4.9375-3.2188-0.4266 0-1.2716 0.23055-2.125 0.65625h-0.0312c-0.85334-0.42642-1.6983-0.65625-2.125-0.65625z' fill='%2385340a'/%3E %3Cpath d='m397.12 262.06c-0.8439 0.0374-1.9596 0.20675-3.5625 0.6875 3.8473-0.85434 4.6962 0.4375 6.4062 0.4375h0.0312c1.71 0 2.5588-1.292 6.4062-0.4375-4.2744-1.282-5.1242-0.4375-6.4062-0.4375h-0.0312c-0.80125 0-1.4372-0.3124-2.8438-0.25z' fill='%2385340a'/%3E %3Cpath d='m393.75 262.72c-0.24819 0.003-0.51871 0.005-0.8125 0.0312 4.488 0.42766 2.3306 3 7.0312 3h0.0312c4.7007 0 2.5745-2.5724 7.0625-3-4.7007-0.4266-3.2146 2.3438-7.0625 2.3438h-0.0312c-3.6075 0-2.4959-2.4215-6.2188-2.375z' fill='%2385340a'/%3E %3Cpath d='m403.85 269.66c0-2.1234-1.7233-3.8465-3.8463-3.8465-2.1233 0-3.8463 1.723-3.8463 3.8465 0.423-1.781 2.0166-3.0393 3.8463-3.0393 1.8333 0 3.424 1.2586 3.8463 3.0393v0 0z' fill='%2385340a'/%3E %3Cpath id='eyebrow_nose' fill='%2385340a' d='m382.73 244.02c4.9146-4.2729 11.11-4.9147 14.53-1.7086 0.837 1.1207 1.3733 2.319 1.5934 3.5696 0.4302 2.433-0.3303 5.0617-2.2367 7.7559 0.2151-0.001 0.6435 0.2124 0.8568 0.4266 1.6967-3.244 2.2967-6.5761 1.74-9.7454-0.1458-0.828-0.3735-1.643-0.6696-2.4357-4.7007-3.8452-11.11-4.2729-15.811 2.1377z'/%3E %3Cpath id='uppalpebra' fill='%2385340a' d='m390.42 242.74c2.7767 0 3.4186 0.6417 4.7007 1.71 1.2833 1.0683 1.9233 0.8541 2.1367 1.0683 0.2124 0.2142 0 0.8541-0.4266 0.6399s-1.2833-0.6399-2.5633-1.7086c-1.2833-1.0696-2.5633-1.0683-3.8463-1.0683-3.8463 0-5.983 3.2046-6.4094 2.9907-0.4266-0.2142 2.1367-3.6325 6.4094-3.6325z'/%3E %3Cuse xlink:href='%23loweyecontour' transform='translate(-19.181)'/%3E %3Ccircle id='pupil' cy='246.15' cx='390.54' r='1.923' fill='%2385340a'/%3E %3Cpath id='lowpalpebra' fill='%2385340a' d='m385.29 247.44c3.6327 2.7783 7.265 2.5644 9.4017 1.282 2.1367-1.282 2.1367-1.7086 1.71-1.7086-0.4266 0-0.8532 0.4266-2.5633 1.281-1.71 0.8559-4.273 0.8559-8.546-0.8541z'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1000 500'%3E %3Crect height='500' width='1000' fill='%23006'/%3E %3Cpath d='M0,250 1000,0V500z' fill='%23bd1021'/%3E %3Cpath d='M107.14,250 1000,26.79V473.21' fill='%23fff'/%3E %3Cg stroke='%23000' stroke-width='1.72'%3E %3Cpath d='m832.04,306.06s-6.2429-5.108,1.135-13.337c-3.973-3.4049-0.2834-9.9312-0.2834-9.9312s-6.8111-2.5547,0.2834-13.054c-5.108-3.4049-2.8381-11.068-2.8381-11.068s-16.742-6.2429-0.85018-12.201c-13.054,5.6748-25.257-7.6626-25.257-7.6626l-19.012,0.56816c-3.2161-15.797-28.283-2.0814-9.6482-47.39-4.8242-0.85142-10.216-2.27-15.607,1.7027-5.3916,3.9728-20.715,12.486-29.796,3.9728-9.0806-8.5131,5.9593-20.715,6.2431-20.999,0.28367-0.2838,20.148-10.5,22.986-17.31-0.28381-5.108-6.5269-9.0806-0.85142-20.148,6.5267-10.5,46.538-20.432,64.701-23.837,8.7962-3.9728,12.769-11.635,12.769-11.635l1.9865,7.378s40.296-11.918,42.282-17.594c1.9865-5.6755,0.85156,5.1078,0.85156,5.1078,15.891-1.4189,36.038-15.04,38.876-8.7969,13.337-2.5539,38.877-13.905,38.877-13.905s8.7962-0.28364,2.5533,9.3646c3.973,6.2429-1.135,11.635-1.4184,11.635-0.28477,0,1.7017,6.2429-3.4062,9.6482,1.7045,5.3916-3.1215,9.6482-3.1215,9.6482s2.2713,6.5267-6.8097,9.932c0.85157,5.6755-5.108,6.8106-5.108,6.8106s0.85156,5.9593-3.1215,8.5131c0,4.5404-4.5398,6.8106-4.5398,6.8106s2.8367,1.7026-1.1363,4.5404c-3.9716,2.8377-45.119,28.093-45.119,27.81,0-0.28366,30.08,5.3917,32.066,6.5268,1.9865,1.1351,24.688,16.175,24.688,16.175l-22.987,28.377s-25.539-2.8367-26.673-1.4184c-1.135,1.4184,5.3914,1.9865,6.8097,4.2564,1.4197,2.2699,3.6896,7.6627,8.2294,7.0945,4.5412-0.56816-8.5129,8.2295-17.026,9.081,0,3.1215,10.783,3.4049,13.621,0.85155,2.8381-2.5547-6.8111,7.3779-7.9461,8.7962s12.771-1.9865,12.771-1.9865-2.2713,9.3644-14.472,12.202c4.8232,7.946,2.8367,13.054,2.5533,13.054-0.28339,0-7.946-7.946-15.324-6.5277,1.9865,7.6627,7.9461,14.756,9.6492,15.892,1.7017,1.135-13.337,0.85018-15.324-3.4062-1.9865-4.2564-3.6896,10.216,1.7018,14.757-6.2416,0.2834-11.634-3.4062-11.634-3.4062s-3.6882,8.5128-1.135,12.771c2.5547,4.2564-8.7962-8.5142-8.7962-8.5142l-21.567,9.081-4.8246-8.2294z' fill='%239c3900' stroke-linejoin='round'/%3E %3Cg fill='%23ffc221'%3E %3Cpath d='m665.36,289.17c0.50543,0,31.331-0.50627,45.48-8.5913,7.0747,11.117,16.676,18.697,16.676,18.697l4.5481-16.17s11.117,0.50489,12.128,3.032c-1.516,3.0307-2.0213,7.0739-2.0213,7.0739s7.58,0.50627,8.0853,1.516c0.5053,1.0111-2.0213,9.601-2.0213,9.601l32.342,7.5801s2.5266-12.633,5.0532-11.117c2.5268,1.516,13.644,17.181,29.31,18.192,15.665,1.0111,16.676-13.139,16.676-13.139l3.5369,2.0223s6.569-14.149,7.5801-14.149,2.5272,2.0209,11.117,2.0209c2.5272,3.032,3.5383,10.106,3.5383,10.106s-9.6024,9.6024-6.5704,17.183c3.032,7.5801,3.5383,5.5578,3.5383,5.5578l69.736,16.676s3.5383,5.5592-2.5258,8.5913c0,0.50489-70.242-16.171-70.242-16.171s-6.5704,7.5801-11.623,6.0641c-5.053-1.516-1.516,3.032-1.516,3.032l75.8,6.0641s5.5592,7.0752,1.516,9.0962c-5.053,0.50488-81.864-5.053-81.864-5.053s-4.5481,9.601-9.601,1.516c-3.5369,5.5578-7.5801-1.516-7.5801-1.516s-6.569,5.053-7.5801-0.50626c-5.5592,4.0432-9.0961-2.5258-9.0961-2.5258l-32.341-2.0223-2.0213,3.032s5.5587,1.516-3.032,5.0543c-8.5907,3.5369,51.544,2.0209,53.06,2.5258,1.516,0.50625-4.0418,5.0543-4.0418,5.0543s30.825,2.0209,36.383-4.5481c5.5592-6.5703-2.0209,8.5899-2.0209,8.5899s24.256-1.0098,24.256-2.0209-0.50626,7.5801-17.181,6.569c10.106,6.5704,22.739,10.612,22.739,10.612s-12.633,3.032-27.287-0.50488c2.5258,6.569,13.644,12.633,13.644,12.633s-8.0864,7.0752-26.279-10.107c5.0543,9.0962,1.0111,12.634,0.50625,11.623-0.50625-1.0111-9.0961-13.644-29.309-18.192,12.633,8.085,7.0739,11.623,7.0739,11.623s-6.569-11.623-17.181,0c-4.0432-10.612-19.708-16.676-38.911-17.687-6.064-7.0739-9.6014-5.0529-23.751-9.0961-8.0853-9.0948-19.708-19.202-19.708-19.202s0.5053-13.644,14.149-12.128c1.516,4.5481,1.516,3.032,1.516,3.032s15.16-5.5592,19.708,2.0209c6.5692-11.623,15.665-1.7375,17.181,2.3043,4.3537,0.63832,26.278,1.2326,26.278,1.2326s-2.5272-4.5481-1.0112-4.0418c1.516,0.50488,13.644-4.5481,13.139-6.0641-0.50625-1.516-1.0111-6.569,1.0098-6.0641,2.0223,0.50489-17.181-2.5272-27.793,5.5592-3.5373-3.5383-1.0106-13.139-1.0106-13.139l-31.331-6.569-1.516,8.085s-9.096,1.516-8.5907-0.50487c0.50529-2.0223-2.0213,7.0739-2.0213,7.0739s-12.128-3.0321-12.128-3.5369c0-0.50489,3.5374-18.192,3.5374-17.687,0,0.50626-10.107,1.0112-24.256,11.623-4.0426-12.633-35.879-29.309-35.879-29.814z'/%3E %3Cpath d='m704.78,247.73s-21.224,18.191,0,28.803c1.0106-7.0752,2.5268-8.085,2.5268-8.085s17.687,6.569,28.299-9.0961c-4.5481-6.569-12.633-4.0418-12.633-4.0418s-16.676-0.001-18.192-7.5801z'/%3E %3C/g%3E %3Cpath d='m722.47,255.82-14.655,12.633' fill='none'/%3E %3Cg fill='%23fff'%3E %3Cpath d='m705.48,247.88,0,0s2.8377-2.8381,3.6891-6.2429c0.85129-3.4049-1.1351-7.0945,2.2702-10.216,3.4051-3.1215,48.241-22.134,51.93-25.823,3.6891-3.6888,10.499-11.634,11.351-13.337,0.85129-1.7027,3.4053,8.5131-4.2566,13.054,8.2293-2.2707,13.621-4.8243,17.026-3.6892-3.4058,4.8242-12.486,12.77-16.743,12.77,9.932-3.6896,19.012-6.8111,21.567-4.8246,2.5533,1.9865-12.202,11.919-18.162,12.486,9.932-2.5533,23.27-6.5263,24.971-2.2699-5.3914,1.7031-3.6896,3.1201-14.756,9.3644-1.4188,1.1363-8.5131,1.4184-8.5131,1.4184,8.5131-0.85156,20.147-4.2564,21.282,1.9865-6.8097,2.5533-9.3639,5.9595-15.039,7.3779-5.6755,1.4197-18.729,3.973-26.675,7.0945-7.9455,3.1215-19.58,12.202-19.58,12.202s-25.256,0.85155-25.256,0.56678c0-0.28339-4.824-11.634-5.1078-11.918z' stroke-linejoin='round'/%3E %3Cpath d='m921.99,230.57,49.092,9.3644s5.3928-6.2429,2.5547-9.6478c7.3779-1.7017,5.3914-11.351,5.3914-11.351s8.5128-3.6883,1.4183-12.202c4.826-4.8239-1.135-8.5128-1.135-8.5128s1.9865-8.5131-4.2564-9.3644c1.7031-6.8104-10.783-9.0807-10.783-9.0807s-25.823,7.0944-43.985,7.6618c5.9595,5.9593-2.2699,9.6482-2.2699,9.6482s4.8246,3.4053,3.4049,6.2429c-1.4183,2.8382,0.85157,5.9597-5.3914,7.9462,8.2294,3.6896-0.85156,9.9312-0.85156,9.9312s9.081,6.2429,6.8111,9.3644z'/%3E %3C/g%3E %3Cg fill='none'%3E %3Cpath d='m742.17,293.72-6.5694,29.309'/%3E %3Cpath d='m748.24,304.83-2.0213,9.601'/%3E %3Cpath d='m780.58,312.41-3.032,9.0962'/%3E %3Cpath d='m836.67,374.06c-0.50489,0-16.17,2.0209-18.192,1.516-2.0209-0.50489,24.761,8.085,24.761,11.622'/%3E %3Cpath d='m808.37,377.6s-15.666-10.106-18.192-9.0961c-2.5269,1.0111,15.665-0.50489,17.181-2.0209'/%3E %3Cpath d='m776.03,365.98s-16.171,0.50488-17.687-1.0111,15.665,11.117,18.697,10.107'/%3E %3Cpath d='m744.7,358.9c-0.5053,0-11.117-4.0418-15.665-5.0543,4.0426,4.0432,7.0747,9.6024,17.181,11.623'/%3E %3Cpath d='m748.74,352.34c-0.50529-1.0111-20.213-7.0752-20.213-10.107,4.5481,1.516,11.117,3.5369,17.181,2.0209'/%3E %3Cpath d='m853.35,329.09-2.0209,9.0948'/%3E %3Cpath d='m767.6,343.56s3.3779,3.724,0.34585,8.2721'/%3E %3Cpath d='m838.69,347.28-5.5578,0.50625'/%3E %3Cpath d='m793.21,344.25,10.106,1.516'/%3E %3Cpath d='m820.4,318.26s0.2834,10.216-8.2294,9.9326c-8.5128-0.28477-5.6762,0.2834-5.6762,0.2834'/%3E %3Cpath d='m826.93,316.55s3.4049,1.135,2.5547,3.6896c-0.85155,2.5533,0.85018,9.9312-9.081,17.026-10.501,2.2699-9.3644-8.7962-9.3644-8.7962'/%3E %3Cpath d='m830.62,319.68s6.2429-3.6883,7.0945,2.2713c0.85018,5.9582-5.108,17.026-9.3644,18.729-4.2578,1.7018-9.081-0.28476-8.5142-3.1215'/%3E %3Cpath d='m838.28,322.23s5.6762-4.5412,7.3779,1.4184c1.7031,5.9596-4.5398,19.297-7.0945,19.58'/%3E %3Cpath d='m846.23,323.65s2.8381-1.4184,4.8232,0.28339'/%3E %3Cpath d='m837.15,344.08c-1.135,0.28339-5.9595,0.56678-7.6613-3.1215'/%3E %3Cpath d='m811.61,334.15c-0.28339,0-5.9582,0.28476-5.9582,0.28476'/%3E %3Cpath d='m833.46,356.57-0.56679-9.3644-2.2699-3.1215-3.973,3.973s-0.56816,9.3644-2.2699,10.216'/%3E %3Cpath d='m826.65,347.77c-0.28339-0.56678-3.1215-5.9582-3.1215-5.9582l-4.8246,5.9582s-0.5668,8.5142-2.2699,9.3658'/%3E %3Cpath d='m818.7,347.49c0-0.28339-1.9865-5.6748-1.9865-5.6748s-5.6748,3.1215-6.2429,5.3914c-0.56679,2.2699-0.85156,8.5128-2.2699,9.081'/%3E %3Cpath d='m810.47,346.07s0.56816-5.108-1.135-5.108c-1.7018,0-9.3644,7.0945-9.6478,13.337'/%3E %3Cpath d='m717.39,245.9s0.28382-5.6748,2.8377-7.6613c2.554-1.9865,15.324-6.8111,18.161-11.068,2.8377-4.2564-4.2566,7.3779-3.1215,10.499'/%3E %3Cpath d='m722.5,237.38s6.2431,2.2713,4.8242,7.0945'/%3E %3Cpath d='m57.344,126.01a3.9192,3.9192,0,1,1,-7.8384,0,3.9192,3.9192,0,1,1,7.8384,0z' transform='matrix(1.1946929,0,0,1.1946929,661.37184,90.106184)' stroke-width='1pt'/%3E %3Cpath d='m917.17,220.07,0,0s43.417,5.108,45.404,5.108c1.9865,0,9.6478,2.5547,11.068,5.108'/%3E %3Cpath d='m919.44,217.52,60.443,1.4184'/%3E %3Cpath d='m919.72,216.1s57.321-3.4049,61.294-9.3644'/%3E %3Cpath d='m921.43,203.61s57.606-6.2429,58.174-5.3916'/%3E %3Cpath d='m919.44,196.52s55.903-8.7969,56.47-7.378'/%3E %3Cpath d='m759.96,160.48s17.594,19.296,15.891,32.35'/%3E %3Cpath d='m774.72,182.61s5.6753,8.2293,7.9455,9.0806c2.2702,0.85128,22.134,1.9864,23.269,10.5,1.135,5.3916-4.2564,3.6885-3.4049,7.6616,1.4184,5.108,14.756,11.634,29.228,3.973'/%3E %3Cpath d='m818.42,217.8s11.918,17.594,29.512-1.4183'/%3E %3Cpath d='m838.85,224.05s14.472,7.6613,26.39-12.202'/%3E %3Cpath d='m849.92,225.75s7.0945,5.9596,21.852-1.9851'/%3E %3Cpath d='m892.2,215.82s21.85,4.5398,23.27,5.9596'/%3E %3Cpath d='m900.43,210.99c0.28339,0,15.324,0.56817,15.324,0.56817'/%3E %3Cpath d='m891.06,202.48s26.107-1.7026,29.513,3.6895'/%3E %3Cpath d='m879.71,194.25s36.607,1.4188,38.309,3.4053'/%3E %3Cpath d='m887.94,231.71s6.2429-1.7017,7.0945-0.85019'/%3E %3Cpath d='m873.75,247.03s8.2294,7.0945,18.73,3.973'/%3E %3Cpath d='m878.29,258.95s9.3644,4.2564,20.432,1.7018'/%3E %3Cpath d='m881.41,266.04s9.3644,6.2429,15.607,5.1066'/%3E %3Cpath d='m877.16,269.73s6.5263,4.8246,6.8097,7.3779'/%3E %3Cpath d='m868.08,275.41s1.9865,10.215,9.081,13.904'/%3E %3Cpath d='m863.25,279.95s-3.1215,13.337,4.8246,21.567'/%3E %3Cpath d='m855.02,290.45c0,0.28339-0.56679,6.2429-0.2834,6.8111'/%3E %3Cpath d='m803.94,238.8,15.324-0.85157s5.6748-2.2699,1.7017-5.9582'/%3E %3Cpath d='m822.96,235.4c0.28477,0,14.472,1.135,18.162,5.3914,3.6882,4.2564,8.2294,12.769,10.783,14.189,2.5547,1.4184,3.1215-0.56816,3.1215-0.56816'/%3E %3Cpath d='m848.78,252.14s-7.6613,13.054-1.7018,17.027'/%3E %3Cpath d='m844.52,266.61s-6.8097,9.081-1.4184,13.621'/%3E %3Cpath d='m841.69,279.1s-5.3914,8.7976,1.1363,14.756'/%3E %3Cpath d='m839.3,255.76c-0.36594,0.36594-6.591,4.7599-8.788,3.6621'/%3E %3Cpath d='m832.71,269.68s2.5629,2.5629,4.7599,2.197'/%3E %3Cpath d='m833.01,282.98,4.09,2.805'/%3E %3Cpath d='m833.56,293.17,3.5383,2.1351'/%3E %3Cpath d='m769.47,154.01s7.4602,3.8794,13.428,0c5.9688-3.8792,34.615-18.501,42.075-20.888,7.4591-2.3873,11.637-16.114,13.13-22.082'/%3E %3Cpath d='m832.44,127.15,41.777-12.235s6.8634-5.6697,7.1619-16.114'/%3E %3Cpath d='m878.39,110.14s41.776-4.1776,41.776-19.695'/%3E %3Cpath d='m913.6,101.19s43.866-11.936,48.044-16.412'/%3E %3Cpath d='m791.26,163.55s26.558-13.727,30.736-15.219c4.1766-1.4921,13.725-13.428-0.59705-13.428'/%3E %3Cpath d='m804.09,168.93c0.29852,0,21.783-14.025,28.945-15.815,3.8795-5.3712,1.7912-11.041-4.7737-9.8473'/%3E %3Cpath d='m834.82,149.53c0.59705-0.29839,11.638-0.59678,7.759,8.0569-5.6679,4.1776-30.139,16.412-30.139,16.412'/%3E %3Cpath d='m829.15,140.28,46.551-15.517s3.8795-8.0569-1.7898-9.2505'/%3E %3Cpath d='m912.71,101.49c0,0.29839,5.9692,3.5808,2.3882,8.9521-6.5648,3.8793-37.599,11.339-37.599,11.339'/%3E %3Cpath d='M959.85,96.712,915.99,108.95'/%3E %3Cpath d='m956.57,106.56-38.195,11.638'/%3E %3Cpath d='M953.29,116.11,919.57,126.25'/%3E %3Cpath d='m947.02,125.66c-0.89558,0-25.065,7.4602-25.065,7.4602'/%3E %3Cpath d='m941.65,133.12-15.518,6.2665'/%3E %3Cpath d='m937.77,141.47c-0.59705,0-13.428,5.6697-13.428,5.6697'/%3E %3Cpath d='m933.89,148.34-11.936,5.6695'/%3E %3Cpath d='m913.3,161.17s1.4926,0.59678,1.1941,2.3873'/%3E %3Cpath d='m883.16,177.58s5.0736,1.7903,0.29853,6.5649c-2.3868,3.2824-9.2502,2.3874-13.428,8.3553'/%3E %3Cpath d='m915.69,110.74s6.2677,1.4919,1.4926,9.5489c-12.534,4.7745-37.898,12.533-37.898,12.533s-1.1927,2.0889-4.4752,3.8793c-3.2824,1.7904-39.389,11.936-39.389,11.936'/%3E %3Cpath d='m917.78,119.99s6.8634,2.984,0,8.0569c-7.759,4.476-34.914,12.831-34.914,12.831s-0.29854,2.3871-1.4913,3.2824c-1.1941,0.89517-37.002,12.831-37.002,12.831'/%3E %3Cpath d='m919.57,128.04s7.1619,2.0889,0.89558,8.0568c-7.4604,4.4761-31.333,12.533-31.333,12.533s-2.3868,2.9839-6.2663,4.1776c-3.8795,1.1936-28.646,11.339-28.646,11.339'/%3E %3Cpath d='m921.36,136.1c2.0897,0.89517,7.759,1.7905,0.89559,7.1618-8.0561,3.5808-27.751,11.339-27.751,11.339l-1.7912,3.2824-31.332,13.428'/%3E %3Cpath d='m923.15,144.16s2.9839,3.581-3.581,7.7586c-7.1619,3.8792-22.678,9.8473-22.678,9.8473'/%3E %3Cpath d='m919.57,152.51s3.2824,2.0889-0.8942,5.0729c-4.7751,2.3873-23.574,12.235-23.574,12.235l-12.236,8.0569'/%3E %3Cpath d='m876.6,125.06c0,0.29839,5.0736,4.4761,3.2824,9.2505,4.4765,3.2824,3.581,6.8634,3.581,6.8634s6.2663,3.5808,5.3721,8.6537c6.2663,1.4921,5.9678,5.0729,5.9678,5.0729l-2.0897,3.2824s6.2663-0.29839,0.89558,7.7586c3.2824,1.7905,1.7912,3.8792,1.7912,3.8792'/%3E %3Cpath d='m893.61,166.24c-0.89558,0-21.783,7.7586-27.155,12.533'/%3E %3Cpath d='m843.18,156.99s6.2663-0.29839,5.3721,6.5648c7.1619-2.3873,5.6693,4.476,5.6693,4.476s8.3546-3.2824,6.8634,7.1618c5.3707-1.1936,4.4752,4.1776,4.4752,4.1776s4.7751-0.29839,4.7751,2.3873c3.2824-2.984,6.8634-1.492,6.8634-1.492s2.3868-3.2826,5.6693-2.3872'/%3E %3Cpath d='m848.85,163.26c0,0.59706-28.051,16.114-28.051,16.114'/%3E %3Cpath d='m854.22,168.33-21.187,13.13'/%3E %3Cpath d='m861.38,174.89c0,0.29839-18.502,11.041-18.502,11.041'/%3E %3Cpath d='m865.56,179.07s-13.13,10.743-16.114,10.146'/%3E %3Cpath d='m870.04,182.35s-7.4604,5.6698-13.727,8.3553'/%3E %3Cpath d='m877.79,179.97s2.3868,2.984-12.533,10.742'/%3E %3C/g%3E %3C/g%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 900 600'%3E %3Crect fill='%23ed2939' width='900' height='600'/%3E %3Crect fill='%23fff' y='200' width='900' height='200'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 10080 5040'%3E %3Cdefs%3E %3CclipPath id='c'%3E %3Cpath d='M0,0V1.5H7V3H6zM6,0H3V3.5H0V3z'/%3E %3C/clipPath%3E %3Cpath id='Star7' d='M0,-360 69.421398,-144.155019 281.459334,-224.456329 155.988466,-35.603349 350.974048,80.107536 125.093037,99.758368 156.198146,324.348792 0,160 -156.198146,324.348792 -125.093037,99.758368 -350.974048,80.107536 -155.988466,-35.603349 -281.459334,-224.456329 -69.421398,-144.155019z'/%3E %3Cpath id='Star5' d='M0,-210 54.859957,-75.508253 199.721868,-64.893569 88.765275,28.841586 123.434903,169.893569 0,93.333333 -123.434903,169.893569 -88.765275,28.841586 -199.721868,-64.893569 -54.859957,-75.508253z'/%3E %3Cuse id='Cstar' xlink:href='%23Star7' transform='scale(2.1)'/%3E %3C/defs%3E %3Cg transform='scale(840)'%3E %3Crect width='12' height='6' fill='%2300008b'/%3E %3Cpath d='M0,0 6,3M6,0 0,3' stroke='%23fff' stroke-width='0.6'/%3E %3Cpath d='M0,0 6,3M6,0 0,3' stroke='%23f00' stroke-width='0.4' clip-path='url(%23c)'/%3E %3Cpath d='M3,0V3.5M0,1.5H7' stroke='%23fff'/%3E %3Cpath d='M3,0V3.5M0,1.5H7' stroke='%23f00' stroke-width='0.6'/%3E %3Cpath d='M0,3H6V0H8V4H0z' fill='%2300008b'/%3E %3C/g%3E %3Cg fill='%23fff'%3E %3Cuse id='Comwlth' xlink:href='%23Cstar' x='2520' y='3780'/%3E %3Cuse id='&%23x3B1;Crucis' xlink:href='%23Star7' x='7560' y='4200'/%3E %3Cuse id='&%23x3B2;Crucis' xlink:href='%23Star7' x='6300' y='2205'/%3E %3Cuse id='&%23x3B3;Crucis' xlink:href='%23Star7' x='7560' y='840'/%3E %3Cuse id='&%23x3B4;Crucis' xlink:href='%23Star7' x='8680' y='1869'/%3E %3Cuse id='&%23x3B5;Crucis' xlink:href='%23Star5' x='8064' y='2730'/%3E %3C/g%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 27 18'%3E %3Cpath fill='%234189DD' d='M0,0h27v18H0V0z'/%3E %3Cpath fill='%23F9D616' d='M0,12h27v1H0v1h27v1H0V12z'/%3E %3Cpolygon fill='%23D21034' stroke='%23FFF' stroke-width='0.2' stroke-miterlimit='10' points='4.625,3.375 4,1.349609 3.375,3.375 1.349609,4 3.375,4.625 4,6.650391 4.625,4.625 6.650391,4'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 260 170'%3E %3Crect fill='%230053A5' width='260' height='170'/%3E %3Cg fill='%23FFCE00'%3E %3Crect x='80' width='50' height='170'/%3E %3Crect y='60' width='260' height='50'/%3E %3C/g%3E %3Cg fill='%23D21034'%3E %3Crect x='95' width='20' height='170'/%3E %3Crect y='75' width='260' height='20'/%3E %3C/g%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1200 600'%3E %3Crect width='1200' height='600' fill='%233f9c35'/%3E %3Crect width='1200' height='400' fill='%23ed2939'/%3E %3Crect width='1200' height='200' fill='%2300b9e4'/%3E %3Ccircle cx='580' cy='300' r='90' fill='%23fff'/%3E %3Ccircle cx='600' cy='300' r='75' fill='%23ed2939'/%3E %3Cpath d='M680,250 689.567,276.903 715.355,264.645 703.097,290.433 730,300 703.097,309.567 715.355,335.355 689.567,323.097 680,350 670.433,323.097 644.645,335.355 656.903,309.567 630,300 656.903,290.433 644.645,264.645 670.433,276.903 680,250z' fill='%23fff'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 16 8'%3E %3Crect width='16' height='8' fill='%23002395'/%3E %3Cpath d='m4.24,0h8v8z' fill='%23fecb00'/%3E %3Cg id='g'%3E %3Cpath d='M2.353283,0.5248529 2.8,-0.85 3.246717,0.524853 2.077197,-0.324853H3.522803z' fill='%23fff' id='s'/%3E %3Cuse xlink:href='%23s' x='1' y='1'/%3E %3Cuse xlink:href='%23s' x='2' y='2'/%3E %3C/g%3E %3Cuse xlink:href='%23g' x='3' y='3'/%3E %3Cuse xlink:href='%23g' x='6' y='6'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 24000 16000'%3E %3Ctitle%3EFlag of Barbados%3C/title%3E %3Crect width='24000' height='16000' fill='%2300267f'/%3E %3Crect width='8000' height='16000' fill='%23ffc726' x='8000'/%3E %3Cpath id='h' fill='%23000' d='M 12000,4124 C 11740,4833 11475,5571 10908,6136 C 11084,6078 11392,6026 11590,6031 L 11590,9013 L 10748,9138 C 10718,9135 10708,9088 10708,9024 C 10627,8098 10408,7320 10156,6515 C 10138,6405 9819,5985 10065,6059 C 10095,6063 10424,6197 10372,6133 C 9924,5669 9269,5335 8633,5236 C 8577,5222 8544,5250 8594,5315 C 9438,6614 10144,8147 10138,9966 C 10466,9966 11261,9772 11590,9772 C 11590,9772 11590,11876 11590,11876 L 12005,11876 12100, 6000 z'/%3E %3Cuse xlink:href='%23h' transform='translate(24000,0) scale(-1,1)'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 12'%3E %3Crect width='20' height='12' fill='%23006a4e'/%3E %3Ccircle cx='9' cy='6' r='4' fill='%23f42a41'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 450 390'%3E %3Crect fill='%23ED2939' width='450' height='390'/%3E %3Crect fill='%23FAE042' width='300' height='390'/%3E %3Crect width='150' height='390'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 900 600'%3E %3Crect width='900' height='600' fill='%23009e49'/%3E %3Crect width='900' height='300' fill='%23ef2b2d'/%3E %3Cg transform='translate(450,300)' fill='%23fcd116'%3E %3Cg id='c'%3E %3Cpath id='t' d='M 0,-100 V 0 H 50' transform='rotate(18 0,-100)'/%3E %3Cuse xlink:href='%23t' transform='scale(-1,1)'/%3E %3C/g%3E %3Cuse xlink:href='%23c' transform='rotate(72)'/%3E %3Cuse xlink:href='%23c' transform='rotate(144)'/%3E %3Cuse xlink:href='%23c' transform='rotate(216)'/%3E %3Cuse xlink:href='%23c' transform='rotate(288)'/%3E %3C/g%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 5 3'%3E %3Crect width='5' height='3' fill='%23fff'/%3E %3Crect width='5' height='2' y='1' fill='%2300966E'/%3E %3Crect width='5' height='1' y='2' fill='%23D62612'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 150 90'%3E %3Cpath d='M0,0H150V90H0' fill='%23fff'/%3E %3Cpath fill='%23ce1126' d='M150,0 37,0l23,9 -23,9 23,9 -23,9 23,9 -23,9 23,9 -23,9 23,9 -23,9H150'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 500 300'%3E %3Cdefs%3E %3Cg id='b' fill='%231eb53a'%3E %3Cg id='s'%3E %3Cg id='t'%3E %3Cg id='c'%3E %3Cpath id='h' d='M0,-20V0H20' transform='rotate(30,0,-20)'/%3E %3Cuse xlink:href='%23h' transform='scale(-1,1)'/%3E %3C/g%3E %3Cuse xlink:href='%23c' transform='rotate(120)'/%3E %3Cuse xlink:href='%23c' transform='rotate(240)'/%3E %3C/g%3E %3Cuse xlink:href='%23t' transform='rotate(180)'/%3E %3C/g%3E %3Cuse xlink:href='%23s' fill='%23ce1126' transform='scale(0.82)'/%3E %3C/g%3E %3Cuse id='star' xlink:href='%23b' x='250' y='106'/%3E %3C/defs%3E %3Cpath d='M0,0H500L0,300H500z' fill='%23ce1126'/%3E %3Cpath d='M0,0V300L500,0V300z' fill='%231eb53a'/%3E %3Cpath d='M0,0 500,300M500,0 0,300' stroke='%23fff' stroke-width='40'/%3E %3Ccircle cx='250' cy='150' r='85' fill='%23fff'/%3E %3Cuse xlink:href='%23star'/%3E %3Cuse xlink:href='%23star' transform='rotate(120,250,150)'/%3E %3Cuse xlink:href='%23star' transform='rotate(240,250,150)'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 15 10'%3E %3Crect fill='%23E8112D' width='15' height='10'/%3E %3Crect fill='%23FCD116' width='15' height='5'/%3E %3Crect fill='%23008751' width='6' height='10'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 900 600'%3E %3Cpath fill='%23FFF' d='M0 625h937.5V0H0V625z'/%3E %3Cg fill='none'%3E %3Cpath fill='%23CE0F25' d='M659.049 394.35c10.735 25.244 6.121 45.149 0 64.53 15.479-5.609 48.359-21.014 44.419-40.226C696.574 401.836 675.119 397.716 659.049 394.35'/%3E %3Cpath stroke='%23221B0F' d='M659.049 394.35c10.735 25.244 6.121 45.149 0 64.53 15.479-5.609 48.359-21.014 44.419-40.226C696.574 401.836 675.119 397.716 659.049 394.35z'/%3E %3Cpath fill='%23FAF8F0' d='M604.198 503.635c9.756-3.152 16.456-6.744 32.61-8.985 6.658-0.923 24.596 0.161 34.996-3.075 10.015-3.12 15.813-6.081 16.099-11.106 0.509-9.006 3.43-19.321 6.961-28.685 5.036-13.362 11.151-24.134 12.095-27.744 0.891-3.404-0.64-6.816-2.896-9.945 -8.792-12.194-28.496-21.087-46.054-21.066l0.746 2.989c13.518 0.245 40.244 10.371 41.851 23.915 2.423 20.399-66.544 23.491-104.855 31.064 0 0-9.878 2.456-13.244 5.93 -2.384 2.456-3.599 8.816-1.119 11.172C598.908 484.747 604.198 503.635 604.198 503.635'/%3E %3Cpath stroke='%23221B0F' d='M604.198 503.635c9.756-3.152 16.456-6.744 32.61-8.985 6.658-0.923 24.596 0.161 34.996-3.075 10.015-3.12 15.813-6.081 16.099-11.106 0.509-9.006 3.43-19.321 6.961-28.685 5.036-13.362 11.151-24.134 12.095-27.744 0.891-3.404-0.64-6.816-2.896-9.945 -8.792-12.194-28.496-21.087-46.054-21.066l0.746 2.989c13.518 0.245 40.244 10.371 41.851 23.915 2.423 20.399-66.544 23.491-104.855 31.064 0 0-9.878 2.456-13.244 5.93 -2.384 2.456-3.599 8.816-1.119 11.172C598.908 484.747 604.198 503.635 604.198 503.635z'/%3E %3Cpath fill='%23F6E4BE' d='M700.591 432.568c-25.791 16.68-60.626 17.901-91.055 20.664l-19.374 19.696 17.76 26.156c0 0 19.784-6.49 30.028-8.074 7.24-1.117 15.374-0.115 22.601-1.29 6.188-1.007 11.685-0.457 15.823-5.167 4.81-5.48 4.564-15.445 7.103-22.28 1.62-4.356 4.209-7.956 7.579-13.121C696.457 440.869 700.591 432.568 700.591 432.568'/%3E %3Cpath fill='%23CE0F25' d='M594.856 514.846c4.751-22.985-10-32.042-17.935-45.961 0 0 8.549 3.504 13.076 4.109 8.494 1.134 13.394 0.96 25.681-1.019 10.059-1.621 18.512-6.689 25.515-3.465 0.973 0.448 1.72 1.554 1.867 2.617 0.454 3.278-1.45 6.64-3.362 9.341C629.205 495.276 594.856 514.846 594.856 514.846'/%3E %3Cpath stroke='%23221B0F' d='M594.856 514.846c4.751-22.985-10-32.042-17.935-45.961 0 0 8.549 3.504 13.076 4.109 8.494 1.134 13.394 0.96 25.681-1.019 10.059-1.621 18.512-6.689 25.515-3.465 0.973 0.448 1.72 1.554 1.867 2.617 0.454 3.278-1.45 6.64-3.362 9.341C629.205 495.276 594.856 514.846 594.856 514.846z'/%3E %3Cpath fill='%23CE0F25' d='M278.37 394.35c-10.736 25.244-6.121 45.149 0 64.53 -15.479-5.609-48.36-21.014-44.417-40.226C240.847 401.836 262.3 397.716 278.37 394.35'/%3E %3Cpath stroke='%23221B0F' d='M278.37 394.35c-10.736 25.244-6.121 45.149 0 64.53 -15.479-5.609-48.36-21.014-44.417-40.226C240.847 401.836 262.3 397.716 278.37 394.35z'/%3E %3Cpath fill='%23FAF8F0' d='M333.22 503.635c-9.757-3.152-16.455-6.744-32.608-8.985 -6.66-0.923-24.596 0.161-34.996-3.075 -10.016-3.12-15.816-6.081-16.1-11.106 -0.51-9.006-3.431-19.321-6.961-28.685 -5.039-13.362-11.154-24.134-12.096-27.744 -0.89-3.404 0.64-6.816 2.898-9.945 8.792-12.194 28.499-21.087 46.054-21.066l-0.747 2.989c-13.516 0.245-40.242 10.371-41.851 23.915 -2.423 20.399 66.544 23.491 104.856 31.064 0 0 9.876 2.456 13.244 5.93 2.384 2.456 3.599 8.816 1.117 11.172C338.513 484.747 333.22 503.635 333.22 503.635'/%3E %3Cpath stroke='%23221B0F' d='M333.22 503.635c-9.757-3.152-16.455-6.744-32.608-8.985 -6.66-0.923-24.596 0.161-34.996-3.075 -10.016-3.12-15.816-6.081-16.1-11.106 -0.51-9.006-3.431-19.321-6.961-28.685 -5.039-13.362-11.154-24.134-12.096-27.744 -0.89-3.404 0.64-6.816 2.898-9.945 8.792-12.194 28.499-21.087 46.054-21.066l-0.747 2.989c-13.516 0.245-40.242 10.371-41.851 23.915 -2.423 20.399 66.544 23.491 104.856 31.064 0 0 9.876 2.456 13.244 5.93 2.384 2.456 3.599 8.816 1.117 11.172C338.513 484.747 333.22 503.635 333.22 503.635z'/%3E %3Cpath fill='%23F6E4BE' d='M236.83 432.568c25.79 16.68 60.625 17.901 91.054 20.664l19.372 19.696 -17.759 26.156c0 0-19.785-6.49-30.029-8.074 -7.239-1.117-15.37-0.115-22.601-1.29 -6.188-1.007-11.686-0.457-15.821-5.167 -4.81-5.48-4.564-15.445-7.104-22.28 -1.617-4.356-4.207-7.956-7.579-13.121C240.964 440.869 236.83 432.568 236.83 432.568'/%3E %3Cpath fill='%23CE0F25' d='M342.561 514.846c-4.749-22.985 10-32.042 17.938-45.961 0 0-8.55 3.504-13.08 4.109 -8.49 1.134-13.391 0.96-25.679-1.019 -10.057-1.621-18.513-6.689-25.514-3.465 -0.974 0.448-1.722 1.554-1.869 2.617 -0.454 3.278 1.45 6.64 3.362 9.341C308.215 495.276 342.561 514.846 342.561 514.846'/%3E %3Cpath stroke='%23221B0F' d='M342.561 514.846c-4.749-22.985 10-32.042 17.938-45.961 0 0-8.55 3.504-13.08 4.109 -8.49 1.134-13.391 0.96-25.679-1.019 -10.057-1.621-18.513-6.689-25.514-3.465 -0.974 0.448-1.722 1.554-1.869 2.617 -0.454 3.278 1.45 6.64 3.362 9.341C308.215 495.276 342.561 514.846 342.561 514.846z'/%3E %3Cpath fill='%23FAF8F0' d='M305.291 543.188c-4.464-2.861-9.549-5.693-12.377-9.996 -1.949-2.965-2.796-7.039-1.904-10.474 5.216-20.094 4.106-30.854 0.49-46.069 -1.167-4.917-2.358-12.341 3.794-12.01 15.78 0.851 33.471 5.886 46.178 5.431 5.191-0.189 12.95-1.221 13.616-6.881 0.791-6.723-16.472-12.695-16.472-12.695 10.261 1.178 18.752 5.424 21.666 11.428 1.184 2.441 0.635 5.897-0.894 8.141 -3.009 4.423-8.734 5.621-14.034 6.331 -10.558 1.425-28.455-1.47-38.575-3.412 -4.577-0.878-6.177-1.598-6.976-0.971 -2.002 1.577 0.731 4.762 7.103 10.72 12.891 12.055 27.917 21.872 43.424 30.307 42.229 22.967 74.524 30.305 118.381 30.305 43.855 0 76.149-7.337 118.38-30.305 15.506-8.435 30.531-18.253 43.423-30.307 6.372-5.957 9.108-9.143 7.1-10.72 -0.794-0.626-2.395 0.094-6.974 0.971 -10.12 1.943-28.017 4.837-38.576 3.413 -5.296-0.71-11.024-1.909-14.033-6.331 -1.529-2.244-2.077-5.7-0.891-8.141 2.914-6.004 11.402-10.25 21.664-11.427 0 0-17.262 5.973-16.471 12.695 0.665 5.66 8.424 6.693 13.615 6.881 12.709 0.455 30.396-4.58 46.179-5.431 6.152-0.331 4.962 7.092 3.792 12.01 -3.616 15.215-4.728 25.975 0.491 46.069 0.89 3.435 0.042 7.509-1.905 10.474 -2.827 4.304-7.911 7.135-12.378 9.996 -51.901 33.279-110.235 50.366-163.416 50.366C415.528 593.555 357.193 576.467 305.291 543.188'/%3E %3Cpath stroke='%23221B0F' d='M305.291 543.188c-4.464-2.861-9.549-5.693-12.377-9.996 -1.949-2.965-2.796-7.039-1.904-10.474 5.216-20.094 4.106-30.854 0.49-46.069 -1.167-4.917-2.358-12.341 3.794-12.01 15.78 0.851 33.471 5.886 46.178 5.431 5.191-0.189 12.95-1.221 13.616-6.881 0.791-6.723-16.472-12.695-16.472-12.695 10.261 1.178 18.752 5.424 21.666 11.428 1.184 2.441 0.635 5.897-0.894 8.141 -3.009 4.423-8.734 5.621-14.034 6.331 -10.558 1.425-28.455-1.47-38.575-3.412 -4.577-0.878-6.177-1.598-6.976-0.971 -2.002 1.577 0.731 4.762 7.103 10.72 12.891 12.055 27.917 21.872 43.424 30.307 42.229 22.967 74.524 30.305 118.381 30.305 43.855 0 76.149-7.337 118.38-30.305 15.506-8.435 30.531-18.253 43.423-30.307 6.372-5.957 9.108-9.143 7.1-10.72 -0.794-0.626-2.395 0.094-6.974 0.971 -10.12 1.943-28.017 4.837-38.576 3.413 -5.296-0.71-11.024-1.909-14.033-6.331 -1.529-2.244-2.077-5.7-0.891-8.141 2.914-6.004 11.402-10.25 21.664-11.427 0 0-17.262 5.973-16.471 12.695 0.665 5.66 8.424 6.693 13.615 6.881 12.709 0.455 30.396-4.58 46.179-5.431 6.152-0.331 4.962 7.092 3.792 12.01 -3.616 15.215-4.728 25.975 0.491 46.069 0.89 3.435 0.042 7.509-1.905 10.474 -2.827 4.304-7.911 7.135-12.378 9.996 -51.901 33.279-110.235 50.366-163.416 50.366C415.528 593.555 357.193 576.467 305.291 543.188z'/%3E %3Cpath fill='%23F6E4BE' d='M637.419 535.408c0 0 3.499-3.49 4.145-6.447 1.611-7.385-2.131-15.006-2.303-22.563 -0.185-8.148 1.383-24.404 1.383-24.404 -20.186 19.274-75.825 68.013-171.934 68.013 -93.4 0-151.749-48.739-171.935-68.013 0 0 1.565 16.256 1.381 24.404 -0.17 7.556-3.915 15.178-2.301 22.563 0.645 2.958 4.143 6.448 4.143 6.448 52.923 33.996 109.461 54.795 168.712 54.795C527.959 590.203 584.498 569.404 637.419 535.408'/%3E %3C/g%3E %3Cpath d='M365.845 550.515c1.832-5.256 7.756-10.813 17.201-7.524 7.839 2.731 11.168 8.888 8.714 15.929 -2.452 7.039-9.43 10.85-17.426 8.066C365.298 563.839 363.949 555.956 365.845 550.515M386.956 558.521c2.399-6.886-0.174-12.572-5.338-14.371 -3.62-1.261-8.43-0.731-11.098 6.925 -2.227 6.395-0.374 12.729 5.671 14.831C378.396 566.676 383.86 567.408 386.956 558.521'/%3E %3Cpath d='M398.135 558.267c1.155-4.813 1.368-5.697 1.545-6.727 0.195-1.091 0.056-1.659-0.961-2.138 -0.245-0.126-0.787-0.29-1.241-0.399 -0.356-0.085-0.536-0.193-0.484-0.418 0.054-0.22 0.296-0.23 0.783-0.11 1.719 0.41 3.737 0.996 4.71 1.229 0.779 0.188 2.844 0.583 4.011 0.859 0.487 0.117 0.699 0.236 0.646 0.456 -0.054 0.224-0.264 0.24-0.589 0.16 -0.355-0.082-0.557-0.1-0.961-0.128 -0.915-0.052-1.304 0.423-1.634 1.515 -0.307 0.997-0.521 1.884-1.675 6.696l-1.064 4.431c-1.101 4.59-0.624 6.745 0.661 8.395 1.178 1.519 2.639 2.004 3.741 2.269 1.428 0.341 3.284 0.319 4.885-0.639 2.201-1.311 2.982-4.137 3.764-7.397l0.95-3.958c1.154-4.811 1.366-5.697 1.545-6.726 0.194-1.092 0.056-1.661-0.961-2.138 -0.245-0.125-0.789-0.29-1.144-0.375 -0.357-0.086-0.537-0.198-0.484-0.418 0.053-0.223 0.295-0.23 0.75-0.12 1.653 0.396 3.673 0.981 3.705 0.989 0.389 0.095 2.455 0.489 3.72 0.79 0.454 0.109 0.665 0.226 0.612 0.448 -0.054 0.223-0.264 0.24-0.652 0.145 -0.356-0.085-0.559-0.1-0.964-0.13 -0.912-0.051-1.301 0.424-1.632 1.516 -0.307 0.999-0.52 1.884-1.675 6.695l-0.813 3.388c-0.842 3.516-2.096 7.164-5.366 8.79 -2.765 1.38-5.184 1.167-7.291 0.664 -1.719-0.413-4.809-1.255-6.673-3.913 -1.305-1.852-1.975-4.491-0.874-9.081L398.135 558.267z'/%3E %3Cpath d='M427.129 571.524c-0.165-0.025-0.24 0.031-0.334 0.215l-2.416 4.159c-0.445 0.759-0.72 1.509-0.776 1.897 -0.084 0.579 0.153 1.04 1.176 1.188l0.495 0.07c0.396 0.056 0.485 0.135 0.459 0.329 -0.037 0.258-0.245 0.294-0.607 0.241 -1.056-0.153-2.463-0.45-3.485-0.598 -0.363-0.052-2.191-0.216-3.908-0.462 -0.429-0.061-0.618-0.153-0.581-0.412 0.029-0.194 0.169-0.239 0.434-0.201 0.296 0.044 0.764 0.079 1.031 0.083 1.548 0.025 2.331-0.981 3.222-2.497l11.15-18.791c0.53-0.879 0.779-1.204 1.107-1.156 0.298 0.042 0.454 0.361 0.679 1.15 0.537 1.886 3.967 15.532 5.378 20.734 0.838 3.081 1.73 3.668 2.399 3.929 0.481 0.167 0.972 0.27 1.369 0.326 0.264 0.038 0.424 0.095 0.391 0.321 -0.036 0.258-0.343 0.28-1.564 0.102 -1.189-0.17-3.598-0.515-6.229-0.959 -0.589-0.115-0.985-0.172-0.952-0.399 0.027-0.193 0.169-0.239 0.504-0.224 0.24-0.031 0.513-0.288 0.403-0.698l-1.688-7.019c-0.043-0.169-0.132-0.25-0.298-0.271L427.129 571.524zM434.091 570.877c0.166 0.025 0.214-0.066 0.192-0.169l-1.832-8.354c-0.014-0.134-0.022-0.3-0.123-0.315 -0.097-0.014-0.187 0.138-0.239 0.265l-4.17 7.46c-0.051 0.122-0.033 0.225 0.1 0.244L434.091 570.877z'/%3E %3Cpath d='M451.349 578.297c-0.025 2.54 0.378 3.401 1.036 3.654 0.559 0.214 1.191 0.27 1.724 0.288 0.366 0.016 0.565 0.089 0.557 0.282 -0.01 0.259-0.311 0.315-0.777 0.299 -2.166-0.079-3.495-0.225-4.129-0.246 -0.3-0.011-1.869 0.028-3.601-0.034 -0.434-0.015-0.732-0.057-0.721-0.351 0.006-0.195 0.21-0.254 0.542-0.241 0.433 0.016 1.034 0.005 1.505-0.109 0.876-0.23 1.043-1.167 1.179-3.996l0.991-19.151c0.024-0.65 0.14-1.101 0.472-1.089 0.366 0.014 0.653 0.446 1.196 1.05 0.385 0.441 5.261 5.826 9.955 10.719 2.186 2.295 6.515 7.141 7.063 7.683l0.167 0.005 0.193-14.619c0.039-1.985-0.239-2.614-1.026-2.969 -0.493-0.211-1.292-0.242-1.757-0.259 -0.401-0.013-0.531-0.115-0.524-0.311 0.01-0.26 0.378-0.28 0.878-0.26 1.731 0.063 3.329 0.219 4.025 0.244 0.368 0.014 1.639-0.039 3.27 0.017 0.435 0.015 0.768 0.06 0.757 0.321 -0.007 0.194-0.211 0.286-0.61 0.27 -0.334-0.012-0.601-0.022-1.005 0.063 -0.943 0.226-1.232 0.901-1.333 2.721l-1.107 20.513c-0.026 0.716-0.167 1.005-0.469 0.994 -0.366-0.013-0.754-0.386-1.107-0.758 -2.029-2.028-6.139-6.443-9.482-9.917 -3.506-3.644-7.06-7.746-7.638-8.386l-0.1-0.003L451.349 578.297z'/%3E %3Cpath d='M483.181 574.563c-0.169 0.014-0.229 0.081-0.281 0.283l-1.472 4.578c-0.273 0.836-0.383 1.627-0.353 2.019 0.041 0.584 0.371 0.984 1.404 0.907l0.499-0.035c0.396-0.028 0.503 0.027 0.516 0.224 0.019 0.259-0.175 0.339-0.541 0.365 -1.064 0.078-2.502 0.084-3.533 0.161 -0.365 0.024-2.189 0.255-3.916 0.381 -0.431 0.033-0.636-0.018-0.656-0.279 -0.013-0.194 0.114-0.269 0.381-0.29 0.3-0.02 0.762-0.085 1.025-0.138 1.516-0.307 2.066-1.456 2.614-3.128l6.88-20.739c0.331-0.971 0.505-1.342 0.837-1.367 0.3-0.022 0.52 0.256 0.908 0.98 0.926 1.727 7.195 14.326 9.681 19.106 1.479 2.83 2.475 3.215 3.185 3.328 0.505 0.06 1.007 0.057 1.406 0.028 0.268-0.02 0.435 0 0.452 0.227 0.018 0.261-0.276 0.346-1.509 0.438 -1.195 0.086-3.623 0.264-6.288 0.39 -0.6 0.014-1.002 0.041-1.016-0.185 -0.015-0.195 0.114-0.269 0.444-0.328 0.228-0.081 0.44-0.39 0.244-0.768l-3.147-6.495c-0.079-0.159-0.184-0.214-0.349-0.204L483.181 574.563zM489.846 572.447c0.166-0.014 0.191-0.113 0.152-0.208l-3.575-7.769c-0.043-0.128-0.09-0.289-0.189-0.281s-0.155 0.174-0.176 0.306l-2.481 8.178c-0.024 0.134 0.018 0.229 0.15 0.219L489.846 572.447z'/%3E %3Cpath d='M509.529 570.608c0.65 4.115 0.999 6.334 1.781 6.804 0.635 0.396 1.527 0.486 4.095 0.081 1.746-0.274 3.027-0.509 3.714-1.506 0.329-0.481 0.583-1.445 0.551-2.066 -0.011-0.291 0.024-0.497 0.289-0.537 0.229-0.039 0.286 0.119 0.347 0.503 0.056 0.355 0.206 2.804 0.088 3.78 -0.085 0.737-0.225 0.925-1.939 1.194 -2.37 0.371-4.094 0.576-5.58 0.781 -1.493 0.166-2.684 0.319-4.034 0.534 -0.363 0.056-1.088 0.173-1.872 0.328 -0.757 0.119-1.604 0.319-2.263 0.422 -0.429 0.068-0.675 0.006-0.711-0.217 -0.024-0.162 0.091-0.279 0.488-0.341 0.494-0.079 0.879-0.204 1.166-0.315 0.639-0.232 0.691-0.968 0.676-1.919 -0.049-1.378-0.448-3.917-0.912-6.876l-0.891-5.661c-0.768-4.889-0.909-5.79-1.137-6.807 -0.236-1.083-0.581-1.556-1.704-1.609 -0.275-0.025-0.674 0.005-1.103 0.074 -0.363 0.054-0.569 0.023-0.605-0.201 -0.035-0.225 0.185-0.325 0.679-0.405 1.549-0.244 3.638-0.474 4.528-0.612 0.791-0.126 3.179-0.601 4.466-0.802 0.46-0.073 0.701-0.045 0.735 0.181 0.037 0.225-0.151 0.321-0.545 0.384 -0.364 0.056-0.886 0.171-1.271 0.299 -0.864 0.299-1.041 0.888-0.93 2.024 0.096 1.04 0.237 1.941 1.006 6.83L509.529 570.608z'/%3E %3Cpath d='M527.885 568.32c-0.16 0.04-0.209 0.119-0.23 0.324l-0.699 4.759c-0.132 0.87-0.11 1.667-0.018 2.046 0.137 0.57 0.529 0.91 1.534 0.667l0.486-0.117c0.389-0.096 0.502-0.054 0.547 0.134 0.061 0.254-0.119 0.364-0.474 0.451 -1.037 0.251-2.452 0.493-3.459 0.738 -0.356 0.086-2.116 0.611-3.802 1.02 -0.42 0.103-0.631 0.086-0.691-0.167 -0.045-0.189 0.069-0.284 0.327-0.347 0.291-0.069 0.739-0.21 0.99-0.306 1.445-0.55 1.8-1.775 2.064-3.515l3.381-21.584c0.166-1.01 0.276-1.409 0.6-1.486 0.291-0.069 0.555 0.166 1.055 0.816 1.2 1.552 9.452 12.95 12.69 17.258 1.923 2.55 2.969 2.766 3.69 2.759 0.506-0.024 1-0.109 1.39-0.204 0.26-0.061 0.43-0.071 0.484 0.151 0.059 0.254-0.215 0.388-1.415 0.677 -1.166 0.282-3.531 0.855-6.14 1.421 -0.591 0.109-0.98 0.203-1.034-0.019 -0.048-0.189 0.069-0.285 0.384-0.395 0.212-0.119 0.37-0.459 0.116-0.799l-4.173-5.889c-0.103-0.141-0.216-0.182-0.376-0.143L527.885 568.32zM534.114 565.137c0.162-0.039 0.171-0.141 0.116-0.228l-4.804-7.075c-0.06-0.119-0.134-0.27-0.23-0.246 -0.096 0.025-0.125 0.198-0.128 0.33l-1.1 8.472c-0.004 0.134 0.054 0.222 0.183 0.19L534.114 565.137z'/%3E %3Cpath d='M545.004 560.026c-1.8-5.266-0.558-13.291 8.909-16.526 7.857-2.681 14.272 0.115 16.683 7.17 2.409 7.055-0.735 14.355-8.75 17.09C552.79 570.856 546.866 565.481 545.004 560.026M566.566 553.32c-2.358-6.901-7.889-9.794-13.064-8.025 -3.629 1.237-7.089 4.621-4.47 12.291 2.188 6.409 7.553 10.253 13.611 8.184C564.852 565.016 569.609 562.224 566.566 553.32'/%3E %3Cpath fill='%23666' d='M600.99 134.593H336.514v18.726H600.99V134.593z'/%3E %3Cpath fill='none' stroke='%23552200' d='M600.99 134.593H336.514v18.726H600.99V134.593z'/%3E %3Cg fill='%235E520E' stroke='%23552200'%3E %3Cpath fill='%23EACE24' stroke='%23806600' stroke-width='2' d='M336.514 153.318l-29.936-70.443 -5.031 1.529 -10.99-25.175 20.187-5.964 4.571 11.818 9.746-2.889 -4.171-11.585 20.56-4.742 3.655 12.07 10.121-1.949L351.723 43.8l20.62-3.595 2.823 12.279 13.641-1.932 1.185 6.206 5.063-0.641 -1.04-6.175 10.45-1.36 1.066 6.281 5.11-0.515 -0.769-6.331 10.382-0.948 0.872 6.326 10.099-0.775 -1.841-18.731 20.92-1.069 0.684 12.324 9.976-0.152 -0.18-12.441 21.006 0.001 -0.323 12.592 10.155 0.208 0.739-12.533 20.871 0.917 -1.906 18.997 10.095 0.699 0.876-6.261 10.35 0.95 -0.821 6.271 5.219 0.511 0.944-6.116 10.415 1.115 -1 6.25 5.158 0.716 1.247-6.245 13.487 1.995 2.859-12.379 20.592 3.594 -3.194 12.415 9.72 1.908 3.766-12.221 20.524 4.649 -4.271 12.059 9.779 2.671 4.725-12.066 20.263 5.779L641.07 84.203l-8.674-2.857 -30.483 71.973C517.724 129.097 417.809 128.996 336.514 153.318'/%3E %3Cpath d='M462.536 95.047V72.721c0-8.93 16.066-8.93 16.066 0v22.326'/%3E %3Cpath d='M345.25 110.217l-6.93-21.565c-2.771-8.625 12.746-12.092 15.519-3.466l6.929 21.565'/%3E %3Cpath d='M579.064 105.929l6.929-21.564c2.775-8.626 18.29-5.16 15.519 3.465l-6.931 21.565'/%3E %3Cpath fill='none' stroke='%23806600' d='M514.974 119.629l-0.915 7.759M333.067 144.973c88.135-25.836 184.129-26.221 272.559-1.09M329.87 137.896c90.111-26.456 188.276-26.865 278.703-1.165M327.021 130.716c92.091-27.003 192.401-27.375 284.776-1.056M324.11 124.146c93.783-27.525 195.94-27.951 290.05-1.212M549.956 123.741l-1.609 7.573M596.106 133.588l-2.605 7.077M576.629 128.849l-2.204 7.189M548.824 115.996l-1.526 7.467M564.871 118.697l-1.971 7.166M583.166 122.409l-2.198 7.155M603.71 127.503l-2.72 7.089M578.848 114.276l-1.96 6.535M602.296 119.591l-2.536 6.84M593.418 117.503l-2.266 6.595M558.132 110.558l-1.626 6.79M546.068 108.28l-1.464 7.136M503.769 118.94l-0.689 7.505M530.669 121.308l-1.236 7.325M497.786 110.866l-0.525 7.583M511.589 111.635l-0.804 7.483M535.02 114.313l-1.284 7.229M529.905 106.382l-1.091 6.825M516.019 105.132l-0.854 7.013M494.619 103.346l-0.442 7M365.031 129.124l2.147 6.95M488.345 118.026l-0.356 7.741M351.105 132.363l2.505 7.096M433.071 119.18l0.79 7.59M452.047 118.344l0.397 7.355M410.636 121.244l1.295 7.516M464.826 118.026l0.135 7.47M383.307 125.404l1.8 7.411M357.934 122.717l2.351 7.265M375.902 119.012l1.938 7.189M387.103 117.042l1.699 7.427M403.415 114.579l1.386 7.331M425.885 112.362l0.944 7.518M443.539 111.024l0.589 7.699M459.268 110.489l0.246 7.474M481.416 110.03l-0.21 7.471M340.824 126.968l2.734 7.245M477.316 103.044l-0.118 7.185M461.38 103.235l0.184 6.9M446.812 103.804l0.457 6.908M419.722 105.892l0.981 7M398.551 108.28l1.342 6.74M383.754 110.458l1.655 6.865M366.379 113.665l1.927 6.596M340.5 119.212l2.599 7.026M556.506 101.82l8.036-37.306M321.068 116.431c95.924-28.114 200.404-28.491 296.615-1.075M506.806 67.845c18.643 1.164 37.333 3.221 55.693 6.163M513.746 52.902l-0.69 5.793 0 0c-27.5-1.91-55.476-1.919-82.977-0.013l0 0 -0.737-5.916M379.247 74.024c18.179-2.916 37.099-4.966 55.557-6.138M376.891 64.68l8.567 37.223M437.545 96.112l-3.638-37.683M507.314 58.353l-2.018 37.784M377.7 52.127l2.61 12.115 0 0c-26.975 4.16-52.976 12.363-78.764 20.163M562.536 51.915c0 0-2.528 11.995-2.527 11.996 27.659 4.176 54.641 12.294 81.062 20.292'/%3E %3C/g%3E %3Cpath fill='%231353B4' stroke='%23554400' stroke-width='2' d='M336.514 153.317c-0.704 45.093-0.662 90.191 0 135.284 0.636 43.444 2.766 77.346 21.895 103.856 23.042 31.931 61.427 54.975 110.806 77.616 49.376-22.641 87.764-45.685 110.806-77.616 19.126-26.51 21.258-60.413 21.894-103.856 0.664-45.092 0.704-90.191 0-135.284L336.514 153.317 336.514 153.317z'/%3E %3Cpath fill='%23CE0F25' d='M598.216 344.999c0.088-11.274 2.433-16.629 2.434-27.901 1.169-22.626 1.618-45.096 1.265-67.644H336.514c-0.354 22.548 0.094 44.817 1.262 67.644 0.004 11.272 2.416 16.628 2.501 27.901H598.216z'/%3E %3Cpath fill='none' stroke='%23554400' stroke-width='2' d='M336.135 248.863h266.159M340.106 344.999h258.111'/%3E %3Cpath fill='%23FFF' stroke='%23000' stroke-width='0.805' d='M436.14 311.056l32.228-13.13 -13.13 32.229 14.324-9.548 14.325 9.548 -13.131-32.229 32.229 13.13 -9.55-14.323 9.55-14.324 -32.229 13.13 13.131-32.228 -14.325 9.549 -14.324-9.549 13.13 32.228 -32.228-13.13 9.549 14.324L436.14 311.056z'/%3E %3Cg id='t1' fill='%23FFF' stroke='%23000'%3E %3Cpath fill='%23EACE24' stroke='none' d='M256.42 398.03c-0.345 39.061-0.69 40.443-0.69 40.443 17.109 16.765 19.139 22.906 24.195 28.346 6.567-9.507 16.764-5.705 16.764-5.705 2.075-8.986 12.964-16.764 12.964-16.764 -15.209-1.209-41.48-8.989-43.554-12.099 -6.888-10.332 2.592-41.651 2.592-41.651L256.42 398.03z'/%3E %3Cpath fill='none' stroke='%23806600' d='M256.42 398.03c-0.345 39.061-0.69 40.443-0.69 40.443 17.109 16.765 19.139 22.906 24.195 28.346 6.567-9.507 16.764-5.705 16.764-5.705 2.075-8.986 12.964-16.764 12.964-16.764 -15.209-1.209-41.48-8.989-43.554-12.099 -6.888-10.332 2.592-41.651 2.592-41.651L256.42 398.03z'/%3E %3Cpath fill='%23EACE24' stroke='none' d='M293.936 459.211l-16.865-12.953 20.042 11.975'/%3E %3Cpath fill='none' stroke='%23806600' d='M293.936 459.211l-16.865-12.953 20.042 11.975'/%3E %3Cpath fill='%23EACE24' d='M268.904 379.505c0 0 21.131-8.626 42.788 6.57 2.069 0.604 3.581 0.427 5.227 0.141 4.186-4.489 13.681-17.685 21.014-15.974 0.54-11.15-0.734-55.728-0.734-55.728 -3.176-0.124-4.277 6.11-4.277 6.11 1.834 12.709-5.5 89.948-35.563 38.862l-21.265 2.2L268.904 379.505z'/%3E %3Cpath fill='none' stroke='%23806600' d='M268.904 379.505c0 0 21.131-8.626 42.788 6.57 2.069 0.604 3.581 0.427 5.227 0.141 4.186-4.489 13.681-17.685 21.014-15.974 0.54-11.15-0.734-55.728-0.734-55.728 -3.176-0.124-4.277 6.11-4.277 6.11 1.834 12.709-5.5 89.948-35.563 38.862l-21.265 2.2L268.904 379.505z'/%3E %3Cpath fill='%23EACE24' stroke='none' d='M257.333 200.842c18.148 6.567 18.375 10.037 36.347 25.937 14.345 5.705 35.71 19.692 36.92 22.804l-1.164 4.543c2.766 1.727 5.378-4.644 5.378-4.644 -2.765-15.729-53.276-63.103-53.276-63.103l-22.249 4.685L257.333 200.842z'/%3E %3Cpath fill='none' stroke='%23806600' d='M257.333 200.842c18.148 6.567 18.375 10.037 36.347 25.937 14.345 5.705 35.71 19.692 36.92 22.804l-1.164 4.543c2.766 1.727 5.378-4.644 5.378-4.644 -2.765-15.729-53.276-63.103-53.276-63.103l-22.249 4.685L257.333 200.842z'/%3E %3Cpath fill='none' d='M274.395 193.804l56.861 52.195 1.211 3.802'/%3E %3Cpath fill='none' d='M286.838 213.161c5.704 10.025 16.248 13.654 16.248 13.654'/%3E %3Cpath d='M263.87 180.412c-0.244-18.82 21.999-31.285 21.999-32.996 -2.201-13.415-33.976 18.575-35.688 22.731 -1.964 6.064 2.445 13.443 2.445 13.443'/%3E %3Cpath d='M269.981 155.725c-6.6 5.377-11.976 22.976-11.976 22.976'/%3E %3Cpath d='M253.604 180.168c-2.688-18.088 11-33.73 10.022-34.219 -8.411-4.205-19.311 18.086-22.487 25.42l4.155 24.93'/%3E %3Cpath d='M249.205 165.258c-3.423 8.799 0.244 20.775 0.244 20.775'/%3E %3Cpath d='M246.516 189.7c-4.4-4.399-0.245-35.929-1.467-35.929 -9.288 0-14.175 30.307-12.22 36.663 6.342 20.614 11.487 24.197 11.487 24.197'/%3E %3Cpath d='M238.206 178.946c-0.734 9.289 6.599 20.776 6.599 20.776'/%3E %3Cpath d='M244.316 212.92c-11.731-10.999-13.766-40.511-15.397-43.506 -12.553 2.445-6.11 33.73-6.11 33.73 0.244 2.444 16.62 21.998 16.62 21.998'/%3E %3Cpath d='M227.451 188.967c-4.155 8.31 14.665 32.998 14.665 32.998'/%3E %3Cpath d='M258.982 282.823c0 0-3.178-42.528 2.199-48.882l-15.886-23.465 -20.531 40.817 18.575 33.975L258.982 282.823z'/%3E %3Cpath fill='none' d='M258.982 282.823c0 0-3.178-42.528 2.199-48.882l-15.886-23.465 -20.531 40.817 18.575 33.975L258.982 282.823z'/%3E %3Cpath d='M244.026 375.503c6.966 8.92 10.37 29.036 10.37 29.036l2.074-6.569c0.978 0.611 1.571 5.705 2.938 5.705 0.611 0 0.504-5.251 1.901-5.533 0.611-0.12 0.206 7.26 1.556 7.26 1.1 0 1.188-5.256 1.555-5.013 0.864 0.575 1.035 6.978 1.729 3.63 -0.977-34.341 66.34-62.443 64.985-100.936 1.711-39.839-41.135-54.959-67.405-88.488 0 0-7.381-21.987 6.221-12.271 11-1.711 10.025-12.616 10.025-12.616h6.049c2.69-23.464-20.912-17.974-20.912-17.974 -21.875 0-23.85 22.64-23.85 22.64 -5.622 29.454 32.542 64.53 32.542 64.53 5.621 12.221-0.05 33.295-0.05 33.295l-53.114 50.04'/%3E %3Cpath d='M221.253 341.843c-2.934 3.545-18.003 21.403-21.669 27.635 -5.191 5.723 4.9 4.113 4.9 4.113s-14.922 15.775-22.17 20.389c2.225 6.675 16.536-2.994 16.536-2.994s-13.933 8.555-13.198 10.266c4.251 3.244 16.619-5.865 16.619-5.865s-2.954 4.154-0.489 5.621c4.156 0 13.687-7.576 13.687-7.576s-1.955 4.399 0.245 5.131c3.974-2.505 28.843-23.221 28.843-23.221'/%3E %3Cpath fill='none' d='M230.855 331.268c0 0-7.432 9.851-2.42 8.296'/%3E %3Cpath d='M229.809 305.698c-6.049 11.753-13.77 31.131-5.359 39.75 2.766 0.865 10.145-27.608 15.901-30.245 0.864-2.936 4.666-15.899 4.666-15.899'/%3E %3Cpath d='M239.184 304.332c3.173 0-6.347 6.356-9.778 15.154'/%3E %3Cpath d='M241.734 306.564c-4.666 21.949-0.345 26.615 1.556 26.789 2.765-1.385 7.605-21.434 13.135-22.643'/%3E %3Cpath d='M218.056 204.938c-19.356-18.148-21.95-38.886-24.024-39.061 -9.135-0.76 3.111 36.815 3.111 36.815l23.159 18.492'/%3E %3Cpath d='M214.986 209.499c0 0-9.286-7.089-14.176-16.621'/%3E %3Cpath d='M218.056 218.074c-28.69-15.901-32.147-41.825-34.566-40.962 -8.834 3.489 2.419 27.309 2.419 27.309 1.556 6.567 24.37 27.134 24.37 27.134'/%3E %3Cpath d='M212.542 225.63c0 0-12.22-9.044-21.997-23.954'/%3E %3Cpath d='M209.242 229.653c-34.393-19.01-35.085-40.789-38.887-39.405 -8.168 22.139 21.776 43.034 42.862 58.762'/%3E %3Cpath d='M211.076 239.073c0 0-15.644-5.621-25.421-20.531'/%3E %3Cpath d='M212.526 248.491c-29.9-9.505-44.336-37.371-48.048-35.949 -8.641 3.284 9.506 26.616 9.506 26.616 14.69 13.654 38.887 23.678 38.887 23.678'/%3E %3Cpath d='M213.276 252.761c0 0-20.776-3.911-32.02-15.4'/%3E %3Cpath d='M212.699 261.108c-47.874-15.383-49.775-30.418-54.269-29.209 -8.525 6.483 18.839 27.999 18.839 27.999 3.455 5.184 38.369 14.691 38.369 14.691'/%3E %3Cpath d='M216.453 263.516c0 0-24.198 0.489-34.463-7.822'/%3E %3Cpath d='M214.945 274.417c-45.8-9.68-52.54-23.16-56.171-22.295 -5.724 7.781 21.951 24.713 21.951 24.713 17.11 9.852 40.269 11.234 40.269 11.234'/%3E %3Cpath d='M220.119 279.89c0 0-16.131 0.489-26.398-5.132'/%3E %3Cpath d='M213.562 304.487c-12.788 11.753-20.047 33.695-13.48 35.086 3.629 0.171 13.48-25.581 27.826-29.208l9.159-7.952'/%3E %3Cpath d='M231.851 301.155c3.171 0-16.614 6.112-20.043 14.911'/%3E %3Cpath d='M206.822 293.773c-18.665 13.999-24.637 30.557-21.948 31.455 4.147 1.383 20.745-15.871 26.789-16.939 2.938-0.518 20.394-9.85 20.394-9.85'/%3E %3Cpath d='M218.164 295.533c3.171 0-12.948 5.621-16.376 14.423'/%3E %3Cpath d='M220.131 287.724c-20.394 2.419-56.17-19.357-56.861-17.456 -8.879 10.401 29.554 27.826 38.022 26.961l30.072 1.901'/%3E %3Cpath d='M228.184 293.577c0 0-24.686 0.246-35.93-4.886'/%3E %3Cpath d='M284.156 290.157c0 0 0-11.488-5.621-11.977 0 0-12.71-0.976-26.886 1.467 -32.424-19.357-7.024-44.221-11.489-52.795 -1.466-13.198-23.219-32.997-23.219-32.997 -2.2 1.957 0.443 14.277-1.223 13.444 -4.399-2.199-1.686 7.485-2.933 10.021 -4.155-1.466-3.942 4.823-2.933 9.532 -3.422 0.49-2.201 6.355-1.467 10.511 -6.71-3.691 2.031 10.464-0.245 10.02 -10.265-1.467 1.467 9.778 1.467 9.778 -5.866 2.2-3.126 6.563 0.979 8.31 -5.134 3.666 0.121 9.519 1.954 9.778 -4.644 2.443 0.524 5.976 3.177 8.554 -4.155 3.911 3.422 5.581 7.09 7.087 -2.934 4.644 0.515 5.648 3.665 7.088 -1.955 3.666 2.856 3.394 5.865 2.935 -3.665 3.91 2.445 5.621 4.889 5.13 0 0 1.304 5.074 5.623 3.179 -1.221 3.913 7.578 3.423 7.578 3.423 0 3.914 12.954 2.445 12.954 2.445'/%3E %3Cg fill='none'%3E %3Cpath d='M221.087 223.77c0 0 2.689 7.088 5.866 7.088'/%3E %3Cpath d='M216.209 207.054c0 0 3.421 11.978 6.599 11.978'/%3E %3Cpath d='M213.276 216.342c0 0 0.978 7.821 4.154 7.821'/%3E %3Cpath d='M209.854 226.363c0 0 2.689 7.088 5.865 7.088'/%3E %3Cpath d='M208.142 236.628c0 0 2.934 6.355 6.111 6.355'/%3E %3Cpath d='M208.387 246.894c0 0 4.889 7.821 8.065 7.821'/%3E %3Cpath d='M209.365 257.405c0 0 5.132 4.4 8.31 4.4'/%3E %3Cpath d='M210.586 265.714c0 0 5.132 4.4 8.31 4.4'/%3E %3Cpath d='M211.809 274.758c0 0 7.576 3.666 10.754 3.666'/%3E %3Cpath d='M215.23 283.313c0 0 8.555 0.734 11.732 0.734'/%3E %3Cpath d='M222.205 290.33c0 0 7.173-0.304 10.349-0.304'/%3E %3Cpath d='M226.354 297.244c0 0 6.136-1.688 10.004-0.304'/%3E %3Cpath d='M232.057 301.218c0 0 6.134-1.689 10.004-0.304'/%3E %3Cpath d='M236.55 305.884c0 0 5.963-0.82 10.176-2.551'/%3E %3Cpath d='M242.6 308.996c0 0 2.504 0.732 6.719-0.994'/%3E %3Cpath d='M249.859 312.105c0 0 2.16-0.13 6.375-1.856'/%3E %3Cpath d='M280.26 189.816c-5.011-9.505-10.198-8.468-10.198-8.468 -2.591 0-3.456 1.728-6.394 1.728 -3.63 0-2.765-3.803-2.765-3.803'/%3E %3C/g%3E %3Cpath fill='%23000' stroke='none' d='M272.137 181.521c-1.037 4.494-4.338 5.366-4.338 5.366s0.716 4.289 3.474 4.485c5.065 0.907 6.719-3.649 4.32-7.605C274.731 182.73 272.137 181.521 272.137 181.521'/%3E %3Cpath stroke='none' d='M275.279 186.708c0.164 0.554-0.675 1.33-1.875 1.731 -1.2 0.404-2.306 0.279-2.47-0.276 0 0-0.001-0.001-0.001-0.003 -0.164-0.555 0.676-1.33 1.875-1.732 1.201-0.401 2.306-0.277 2.471 0.277V186.708'/%3E %3Cpath fill='none' d='M206.061 373.022c-1.589 2.566 5.745 3.248 7.7 0.244 0 4.156 5.665 4.314 7.699 2.322 0.855 2.689 4.813 2.003 7.333-0.489 0.428 1.16 4.014 3.647 5.339 3.17 2.59-0.934 12.71-15.254 14.909-16.475M195.77 392.969c0 0 11.623-11.319 19.226-17.367M199.745 397.117c0 0 15.289-14.13 22.894-20.179M214.436 394.352c0 0 10.156-10.464 17.76-16.512M204.325 373.292c0 0 11.356-13.535 18.961-19.584M213.187 373.652c0 0 9.546-10.953 20.45-18.711M221.89 375.286c0 0 4.499-8.628 18.214-19.196M228.856 375.165c0 0 5.22-9.049 14.658-15.831M228.261 376.377c-7.778 7.95-14 13.309-14 13.309M217.029 377.069c-7.779 7.95-15.727 14.345-15.727 14.345M209.423 374.822c-7.778 7.95-9.851 8.643-9.851 8.643M217.06 347.612c-1.59 2.566 2.004 8.781 9.663 5.086 -2.42 6.402 1.171 4.66 6.145 2.324 -1.392 5.452 4.813 2 7.331-0.49 0.427 1.161 0.557 3.995 2.919 4.21 2.743 0.249 5.623-7.651 7.824-8.871M226.471 352.814l13.889-12.731M219.081 353.483l6.761-10.289M232.714 354.938l8.338-9.151M239.943 354.744l4.392-4.809M226.534 356.155c-1.729 1.902-5.704 4.84-5.704 4.84M233.965 358.058c-3.803 2.938-7.085 6.05-7.085 6.05M246.064 360.995c-7.778 7.95-6.049 5.876-6.049 5.876M241.915 357.711c-3.803 2.939-6.049 5.185-6.049 5.185M249.692 338.354c-11.061 13.827 4.84 2.765 4.84 2.765M235.44 344.943c0 0-6.486 1.188 0.945-7.799M247.965 330.577l-2.074 3.284M245.539 239.562c-1.955 5.621 3.423 11.244 3.423 11.244M241.384 242.74c-1.956 5.621 7.086 14.909 7.086 14.909M239.671 252.271c-1.954 5.623 8.066 10.266 8.066 10.266M244.072 266.448c0.489 4.155 7.821 3.177 7.821 3.177M233.611 220.838c0 0 0.624 4.735 2.939 11.235 -3.63 3.629-4.32 9.159-4.32 9.159M221.087 223.77c0 0 2.689 7.088 5.866 7.088M219.532 232.586c0 0 2.689 7.088 5.866 7.088M216.594 240.017c0 0 3.38 4.669 6.557 4.669M217.803 249.35c0 0 3.381 4.669 6.559 4.669M220.223 259.201c0 0 3.726 0.866 6.903 0.866M222.47 266.114c0 0 0.787 0.175 3.965 0.175M226.272 217.377c0 0-0.423 3.978 2.756 3.978M229.976 280.763c0 0 3.972-0.463 3.272-3.561M224.1 275.234c0 0 6.91-2.019 6.213-5.117M238.618 288.713c0 0 1.208-8.066 0.509-11.166M248.124 295.109c0 0-1.213-10.66-3.639-12.031M258.666 297.7c-2.591-8.986-6.051-13.079-8.478-13.932M268.864 297.183c-2.592-8.987-9.509-12.387-11.936-13.241M280.961 297.526c-2.592-8.986-9.506-12.387-11.934-13.238M272.498 309.5c-9.333 3.456-13.653 11.925-13.653 11.925M259.947 195.563c-2.445 0-3.178 1.466-3.178 1.466M251.881 209.983c-1.037 2.938 2.23 6.975 1.711 6.111M252.042 186.292c-2.421 0-2.594 4.666-2.594 4.666M265.178 226.734l3.456 4.494M266.905 239.869l3.629 4.147M282.114 253.868l4.321 4.667'/%3E %3Cpath fill='%23000' stroke='none' d='M304.346 270.347c0 0 2.054 5.674 3.519 6.162 0 0 1.666 0.56 2.766-0.172 1.001-0.668 0-2.075 0-2.075C309.289 272.307 304.346 270.347 304.346 270.347M295.601 273.193c0 0-0.339 6.024 0.819 7.049 0 0 1.313 1.17 2.611 0.926 1.184-0.221 0.815-1.908 0.815-1.908C299.376 276.934 295.601 273.193 295.601 273.193M301.589 294.457c0 0-0.338 6.024 0.82 7.05 0 0 1.313 1.167 2.611 0.926 1.181-0.222 0.814-1.909 0.814-1.909C305.364 298.198 301.589 294.457 301.589 294.457M316.377 300.495l-0.13 0.301h-0.329c-0.2 0-0.387-0.087-0.527-0.246 -0.636-0.721-0.359-3.964-0.116-5.977 -0.627-0.818-2.075-2.852-1.885-3.942 0.05-0.286 0.199-0.513 0.43-0.658l0.317-0.198 0.28 0.248c0.368 0.326 3.603 3.232 3.83 4.825C318.38 295.77 316.849 299.403 316.377 300.495zM283.702 318.162c-1.099 0-2.07 3.32-1.346 4.689 0 0 0.816 1.555 2.118 1.785 1.185 0.209 1.434-1.5 1.434-1.5C286.285 320.793 285.906 318.162 283.702 318.162M277.098 366.725c-0.472 0.821-2.362 1.968-2.735 2.189l-0.294 0.174 -0.27-0.211c-0.673-0.529-0.293-1.921 1.128-4.138 0.006-0.99 0.106-3.571 0.945-4.327 0.216-0.193 0.47-0.281 0.745-0.253l0.372 0.039 0.067 0.367C277.145 361.05 277.901 365.332 277.098 366.725zM261.578 371.246c-0.273 0.477-0.762 0.633-1.26 0.633 -0.436 0-0.878-0.119-1.191-0.249l-0.116-0.068c-0.819-0.641-0.438-2.657-0.216-3.561 0.001-0.916 0.081-3.635 0.945-4.413 0.215-0.193 0.473-0.281 0.744-0.253l0.349 0.037 0.083 0.341C261.166 364.729 262.37 369.867 261.578 371.246zM274.41 347.66c-0.285 0.494-0.774 0.637-1.241 0.637 -0.569 0-1.107-0.211-1.208-0.253l-0.118-0.068c-0.839-0.658-0.42-2.752-0.201-3.622 0.176-0.507 1.055-2.805 2.531-2.649l0.384 0.041 0.058 0.382C274.677 342.547 275.207 346.272 274.41 347.66zM294.456 330.261c0 0-2.435 5.519-1.714 6.886 0 0 0.817 1.558 2.119 1.786 1.185 0.209 1.433-1.5 1.433-1.5C296.674 335.091 294.456 330.261 294.456 330.261M287.36 344.519c-3.62 1.194-4.38 5.486-4.112 7.005 0 0 0.3 1.732 1.467 2.351 1.064 0.565 1.825-0.986 1.825-0.986C287.62 350.775 289.926 346.475 287.36 344.519M267.809 323.201c-2.441 1.646-2.449 3.084-2.465 4.629 0 0-0.022 1.756 1.013 2.58 0.943 0.747 4.174-0.638 4.174-0.638C271.979 327.893 267.931 327.844 267.809 323.201M293.961 299.615c-2.441 1.646-2.448 1.371-2.464 4.626 0 0 0.832 2.614 1.869 3.436 0.94 0.748 1.974-1.614 1.974-1.614C296.789 304.186 296.039 300.225 293.961 299.615M311.933 312.664c-1.1 0-2.07 3.32-1.347 4.686 0 0 0.818 1.556 2.119 1.786 1.185 0.21 1.434-1.499 1.434-1.499C314.515 315.294 314.136 312.664 311.933 312.664M304.355 322.073c-1.571 5.08-3.413 6.621-2.691 7.988 0 0 1.794 0.455 3.096 0.684 1.185 0.211 1.432-1.497 1.432-1.497C306.573 326.904 304.721 327.572 304.355 322.073M261.58 381.247c-1.1 0-2.07 3.319-1.347 4.686 0 0 0.816 1.555 2.119 1.785 1.185 0.209 1.432-1.499 1.432-1.499C264.164 383.878 263.783 381.247 261.58 381.247'/%3E %3C/g%3E %3Cuse xlink:href='%23t1' transform='matrix(-1,0,0,1,937.5,0) translate(-1,0)'/%3E %3Cg id='t2' fill='%23EACE24' stroke='%23806600'%3E %3Cpath d='M462.575 214.875c0.309-2.981 0.144-8.604-1.376-11.159 -0.514-0.862-1.772-1.869-2.755-1.826 -0.966 0.043-2.298 0.336-2.753 1.216 -0.417 0.808-0.689 2.541-0.59 3.45 0.137 1.264 1.572 3.854 1.572 3.854s-5.142-1.064-6.884-2.434c-1.721-1.356-3.581-3.925-4.13-6.088 -0.189-0.74-0.924-3.139 0.005-6.017 0.539-1.67 2.159-3.905 3.415-5.018 3.276-2.909 9.636-2.064 10.939-1.341 1.719 0.957 3.816 2.991 4.522 4.87 0.549 1.459 1.689 5.766 1.967 7.305 0.568 3.137 0.734 4.323 0.983 7.506 0.171 2.185 0.645 4.146 0.196 6.29 -0.241 1.155-0.541 3.804-1.196 5.549 -0.658 1.754-1.67 2.604-2.541 3.379 -1.78 1.585-7.473 2.435-7.473 2.435s3.128-4.073 3.933-5.884C461.368 218.809 462.333 217.23 462.575 214.875'/%3E %3Cpath d='M476.522 214.875c-0.308-2.981-0.144-8.604 1.376-11.159 0.514-0.862 1.774-1.869 2.755-1.826 0.966 0.043 2.296 0.336 2.753 1.216 0.419 0.808 0.69 2.541 0.59 3.45 -0.139 1.264-1.574 3.854-1.574 3.854s5.144-1.064 6.886-2.434c1.721-1.356 3.579-3.925 4.129-6.088 0.189-0.74 0.924-3.139-0.005-6.017 -0.539-1.67-2.161-3.905-3.414-5.018 -3.277-2.909-9.639-2.064-10.94-1.341 -1.721 0.957-3.818 2.991-4.524 4.87 -0.549 1.459-1.688 5.766-1.967 7.305 -0.568 3.137-0.733 4.323-0.983 7.506 -0.173 2.185-0.646 4.146-0.197 6.29 0.243 1.155 0.544 3.804 1.197 5.549 0.656 1.754 1.67 2.604 2.541 3.379 1.779 1.585 7.474 2.435 7.474 2.435s-3.129-4.073-3.934-5.884C477.73 218.809 476.766 217.23 476.522 214.875'/%3E %3Cpath d='M469.513 237.02c0 0 4.594-3.887 5.356-8.286 0.683-3.958-2.362-8.591-2.594-10.455 -0.921-7.454 1.034-17.384 1.21-18.195 0.701-3.224 1.581-4.604 2.051-5.66 0.339-0.76 1.304-2.271 2.269-3.735 0.554-0.841 1.787-2.406 2.416-3.999 0.666-1.687 0.71-3.405 0.721-4.321 0.016-1.561-0.271-2.89-0.673-4.161 -0.381-1.209-1.626-3.186-3.429-4.323 -1.944-1.226-3.515-2.211-4.114-2.601 -1.975-1.289-3.191-5.528-3.215-5.528s-1.24 4.238-3.215 5.528c-0.598 0.39-2.098 1.375-4.043 2.601 -1.802 1.136-3.048 3.114-3.427 4.323 -0.403 1.271-0.689 2.6-0.671 4.161 0.009 0.916 0.054 2.634 0.721 4.321 0.628 1.592 1.861 3.156 2.416 3.999 0.966 1.464 1.93 2.975 2.268 3.735 0.47 1.056 1.351 2.436 2.051 5.66 0.176 0.811 2.132 10.741 1.209 18.195 -0.231 1.864-3.348 6.497-2.664 10.455C464.918 233.132 469.513 237.02 469.513 237.02'/%3E %3Cpath d='M479.837 213.11l-2.213-3.16h-16.145l-2.218 3.16 2.218 3.144h16.146L479.837 213.11z'/%3E %3C/g%3E %3Cuse xlink:href='%23t2' x='-86.94'/%3E %3Cuse xlink:href='%23t2' x='86.94'/%3E %3Cg id='t3'%3E %3Cpath fill='%23EACE24' stroke='%23806600' stroke-miterlimit='10' d='M445.151 439.394h48.684v11.395h-48.684V439.394zM445.149 436.915c-0.081-10.701-1.586-21.734-6.15-31.13 0.566-0.17 1.165-0.26 1.785-0.26 3.441 0 6.231 2.788 6.231 6.229 0 0.854-0.169 1.663-0.479 2.401 0.8-0.374 1.693-0.582 2.634-0.582 3.44 0 6.231 2.79 6.231 6.234 0 3.439-2.791 6.23-6.231 6.23 -0.446 0-0.882-0.05-1.302-0.138 0.467 4.205 2.625 7.391 5.216 7.391 2 0 3.74-1.897 4.647-4.696 0.905 2.799 2.648 4.696 4.647 4.696 2.785 0 5.069-3.681 5.291-8.356 -1.004 0.695-2.221 1.103-3.533 1.103 -3.443 0-6.232-2.791-6.232-6.23 0-3.426 2.765-6.207 6.184-6.234 -0.525-0.911-0.826-1.971-0.826-3.101 0-3.441 2.79-6.23 6.231-6.23 3.441 0 6.232 2.789 6.232 6.23 0 1.128-0.303 2.19-0.827 3.101 3.419 0.026 6.184 2.807 6.184 6.234 0 3.439-2.79 6.23-6.231 6.23 -1.313 0-2.529-0.408-3.534-1.103 0.221 4.675 2.506 8.356 5.293 8.356 2 0 3.741-1.897 4.647-4.696 0.906 2.799 2.646 4.696 4.646 4.696 2.593 0 4.749-3.186 5.218-7.391 -0.42 0.088-0.858 0.138-1.304 0.138 -3.44 0-6.23-2.791-6.23-6.23 0-3.444 2.79-6.234 6.23-6.234 0.941 0 1.835 0.209 2.634 0.582 -0.307-0.739-0.479-1.548-0.479-2.401 0-3.441 2.79-6.229 6.23-6.229 0.622 0 1.223 0.09 1.787 0.26 -4.565 9.396-6.069 20.429-6.151 31.13H445.149L445.149 436.915z'/%3E %3Cpath fill='%23806600' d='M470.924 419.776l6.634-1.04 -6.97-1.095 -1.095-6.969 -1.091 6.969 -6.971 1.095 6.635 1.04H470.924z'/%3E %3Cpath fill='%23806600' d='M444.93 441.269c0.255-0.001 0.509 0.095 0.702 0.289 0.101 0.103 0.176 0.22 0.225 0.35l1.149 2.526c0.121 0.269 0.111 0.563-0.001 0.814h0.001l-1.173 2.579c-0.165 0.366-0.525 0.582-0.904 0.582L444.93 441.269 444.93 441.269z'/%3E %3Cpath fill='%23806600' d='M445.503 421.533l6.361-2.151 -7.054 0.103 -2.26-6.681 1.696 8.401L445.503 421.533z'/%3E %3Cpath fill='%23806600' d='M443.709 418.248h0.05 0.017c0.063 0.004 0.115 0.01 0.158 0.014 0.132 0.016 0.253 0.064 0.351 0.141l0.003 0.004 0.005 0.004c0.119 0.087 0.231 0.18 0.334 0.276l0.034 0.038c0.109 0.102 0.206 0.202 0.286 0.301l0.034 0.042c0.489 0.613 0.783 1.391 0.783 2.235h0.004v0.009h-0.004c0 0.325-0.042 0.632-0.121 0.92l-0.009 0.03 -0.03 0.1c-0.006 0.02-0.013 0.038-0.019 0.056l-0.004 0.008 -0.004 0.009c-0.074 0.219-0.166 0.434-0.278 0.628 -0.061 0.11-0.15 0.194-0.252 0.256h0.001l-0.006 0.004 -0.004 0.001 -0.005 0.005c-0.046 0.026-0.1 0.057-0.165 0.092l-0.13 0.063c-0.321-1.766-0.707-3.514-1.16-5.232l0.042-0.003v-0.001h0.005c0.029 0 0.055 0.001 0.084 0.004C443.709 418.252 443.709 418.248 443.709 418.248z'/%3E %3Cpath fill='%23FF8080' d='M464.851 444.943l4.365-2.579 4.365 2.579 -4.365 2.579L464.851 444.943z'/%3E %3Cpath fill='none' stroke='%239E7800' stroke-linejoin='round' d='M464.851 444.943l4.365-2.579 4.365 2.579 -4.365 2.579L464.851 444.943z'/%3E %3Cpath fill='%23FF8080' d='M464.851 444.943l4.365-2.579 4.365 2.579 -4.365 2.579L464.851 444.943z'/%3E %3Cpath fill='%23BA0028' d='M473.581 444.943l-4.289 2.534 -0.076 0.045v-2.579H473.581z'/%3E %3Cpath fill='%23CF1E45' d='M469.216 444.943v2.579l-4.366-2.579H469.216z'/%3E %3Cpath fill='%23FF083C' d='M469.216 442.361v2.381 0.2h4.365l-0.103-0.061 -3.95-2.334L469.216 442.361z'/%3E %3Cpath fill='%23FF99CC' d='M442.574 444.852l2.577-2.578 1.174 2.578 -1.174 2.579L442.574 444.852z'/%3E %3Cpath fill='%23F00' d='M442.574 444.852h3.751l-1.174 2.579L442.574 444.852z'/%3E %3Cpath fill='%23CCC' d='M443.626 418.944c0.077 0 0.153 0.004 0.229 0.014 0.732 0.52 1.211 1.379 1.211 2.346 0 0.514-0.138 0.996-0.374 1.414 -0.311 0.191-0.675 0.304-1.066 0.304 -1.126 0-2.04-0.913-2.04-2.039C441.586 419.858 442.5 418.944 443.626 418.944'/%3E %3Cpath fill='none' stroke='%239E7800' d='M443.626 418.944c0.077 0 0.153 0.004 0.229 0.014 0.732 0.52 1.211 1.379 1.211 2.346 0 0.514-0.138 0.996-0.374 1.414 -0.311 0.191-0.675 0.304-1.066 0.304 -1.126 0-2.04-0.913-2.04-2.039C441.586 419.858 442.5 418.944 443.626 418.944z'/%3E %3Cpath fill='%23FFF' d='M442.649 419.753c0.537 0 0.973 0.438 0.973 0.974 0 0.537-0.435 0.974-0.973 0.974s-0.974-0.436-0.974-0.974C441.675 420.191 442.111 419.753 442.649 419.753'/%3E %3Cpath fill='%23806600' d='M493.485 421.533l-6.36-2.151 7.051 0.103 2.26-6.681 -1.695 8.401L493.485 421.533z'/%3E %3Cpath fill='%23806600' d='M495.281 418.248h-0.05 -0.02c-0.06 0.004-0.114 0.01-0.156 0.014 -0.131 0.016-0.254 0.064-0.35 0.141l-0.004 0.004 -0.004 0.004c-0.119 0.087-0.231 0.18-0.334 0.276l-0.037 0.038c-0.109 0.102-0.204 0.202-0.284 0.301l-0.034 0.042c-0.49 0.613-0.785 1.391-0.785 2.235h-0.001v0.009h0.001c0.001 0.325 0.045 0.632 0.124 0.92l0.011 0.03 0.028 0.1c0.005 0.02 0.012 0.038 0.019 0.056l0.004 0.008 0.004 0.009c0.074 0.219 0.166 0.434 0.279 0.628 0.06 0.11 0.149 0.194 0.251 0.256l0.004 0.004 0.006 0.001 0.004 0.005c0.046 0.026 0.1 0.057 0.165 0.092l0.129 0.063c0.323-1.766 0.706-3.514 1.161-5.232l-0.042-0.003v-0.001h-0.006c-0.028 0-0.054 0.001-0.084 0.004L495.281 418.248z'/%3E %3Cpath fill='%23CCC' d='M495.365 418.944c-0.079 0-0.158 0.004-0.232 0.014 -0.731 0.52-1.209 1.379-1.209 2.346 0 0.514 0.135 0.996 0.372 1.414 0.314 0.191 0.675 0.304 1.069 0.304 1.124 0 2.036-0.913 2.036-2.039C497.401 419.858 496.489 418.944 495.365 418.944'/%3E %3Cpath fill='none' stroke='%239E7800' d='M495.365 418.944c-0.079 0-0.158 0.004-0.232 0.014 -0.731 0.52-1.209 1.379-1.209 2.346 0 0.514 0.135 0.996 0.372 1.414 0.314 0.191 0.675 0.304 1.069 0.304 1.124 0 2.036-0.913 2.036-2.039C497.401 419.858 496.489 418.944 495.365 418.944z'/%3E %3Cpath fill='%23FFF' d='M495.723 419.368c-0.537 0-0.974 0.435-0.974 0.973 0 0.537 0.436 0.972 0.974 0.972 0.535 0 0.974-0.435 0.974-0.972C496.696 419.803 496.258 419.368 495.723 419.368'/%3E %3Cpath fill='%23806600' d='M494.059 441.269c-0.255-0.001-0.509 0.095-0.704 0.289 -0.1 0.103-0.176 0.22-0.225 0.35l-1.149 2.526c-0.12 0.269-0.111 0.563 0.003 0.814h-0.003l1.173 2.579c0.165 0.366 0.526 0.582 0.905 0.582C494.059 448.409 494.059 441.269 494.059 441.269z'/%3E %3Cpath fill='%23FF083C' d='M496.415 444.852l-2.579-2.578 -1.174 2.578 1.174 2.579L496.415 444.852z'/%3E %3Cpath fill='%23BA0028' d='M496.415 444.852h-3.753l1.174 2.579L496.415 444.852z'/%3E %3Ccircle fill='%23CCC' stroke='%239E7800' stroke-width='0.5' cx='469.496' cy='418.747' r='2.287'/%3E %3Ccircle fill='%23FFF' cx='469.085' cy='418.041' r='0.975'/%3E %3Ccircle fill='%23CCC' stroke='%239E7800' stroke-width='0.5' cx='458.079' cy='442.665' r='1.668'/%3E %3Ccircle fill='%23FFF' cx='457.793' cy='442.174' r='0.677'/%3E %3Ccircle fill='%23CCC' stroke='%239E7800' stroke-width='0.5' cx='458.079' cy='447.518' r='1.668'/%3E %3Ccircle fill='%23FFF' cx='457.793' cy='447.026' r='0.677'/%3E %3Ccircle fill='%23CCC' stroke='%239E7800' stroke-width='0.5' cx='481.16' cy='442.665' r='1.668'/%3E %3Ccircle fill='%23FFF' cx='480.874' cy='442.174' r='0.677'/%3E %3Ccircle fill='%23CCC' stroke='%239E7800' stroke-width='0.5' cx='481.16' cy='447.518' r='1.668'/%3E %3Ccircle fill='%23FFF' cx='480.874' cy='447.026' r='0.677'/%3E %3C/g%3E %3Cuse xlink:href='%23t3' x='-49.151' y='-55.104'/%3E %3Cuse xlink:href='%23t3' x='49.151' y='-55.104'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1200 600'%3E %3CclipPath id='a'%3E %3Cpath d='M0 0v150h700v150H600zm600 0H300v350H0v-50z'/%3E %3C/clipPath%3E %3Cpath fill='%2300247d' d='M0 0h1200v600H0z'/%3E %3Cpath d='M0 0l600 300m0-300L0 300' stroke='%23fff' stroke-width='60'/%3E %3Cpath d='M0 0l600 300m0-300L0 300' stroke='%23cf142b' stroke-width='40' clip-path='url(%23a)'/%3E %3Cpath d='M300 0v350M0 150h700' stroke='%23fff' stroke-width='100'/%3E %3Cpath d='M300 0v350M0 150h700' stroke='%23cf142b' stroke-width='60'/%3E %3Cpath d='M0 300h600V0h600v600H0z' fill='%23cf142b'/%3E %3Cpath fill='%23fff' d='M767.32 145.154v253.639c3.002 36.316 78.686 59.178 131.454 97.748 69.212-46.422 136.34-55.812 139.039-107.858l.842-243.529h-271.33z'/%3E %3Cg fill='none'%3E %3Cpath fill='%232f8f22' stroke='%23000' stroke-width='.456' d='M767.292 395.158l2.834 14.485 9.447 11.338 68.34 44.085 50.072 31.18 97.626-53.222 33.697-25.826 6.615-33.696-4.096-7.872.946 8.188-2.521 6.613-2.832-1.891-1.89-12.28-.316 9.13-4.723 5.357-.945-6.617 1.26-4.722-1.89-5.353-.63 10.706-2.518 4.726-2.206-3.151.946-4.726-.315-4.406-1.575-2.207-.317 4.725-.943 1.574.315 2.833-1.89 1.891-1.26-3.778.631-3.466-.63-3.147-1.26-3.467.316 5.67-3.15 6.928-2.52 1.574-1.574-1.89.316-6.613-2.205-3.777.629 8.187-3.148 7.245-1.889-2.207-.948-2.203v-3.467l3.467-8.817-3.467 3.15-2.832 7.557-1.26 2.203-1.574-3.778 2.205-8.503-1.26-1.572-2.834 10.391-2.521 1.574-1.889-.63-1.259.63-152.425 8.504-4.094-5.985-.943 5.985-2.522 2.203-2.517-11.023-1.89 11.654-2.521-5.669 1.26-12.914-1.26-.943-1.888 6.927v9.763l-.946 6.614-1.89-1.26-2.518-5.984-.315-9.764.943-6.928-2.518 8.188v10.079l-.315 5.036-3.151-6.927-1.574-5.67-3.15-6.612 1.89 8.503V392l-5.354-4.726-2.833-13.225-.63 9.763 1.26 4.722-1.574 1.891-3.149-5.67-1.889-7.556-2.204-7.244v11.65l1.574 6.3-1.26 1.576-2.519-1.26-.945-6.931-.631-10.075-2.518 6.927-.631 7.241-.945 5.67-1.574 3.781-4.409.323z'/%3E %3Cpath stroke='%234dcf4a' stroke-width='.913' d='M876.022 472.104c-.818-14.885 12.643-29.772-23.593-44.66'/%3E %3Cpath stroke='%2338bb26' stroke-width='1.141' d='M910.572 463.678c0-19.662-11.236-28.087-33.707-25.28'/%3E %3Cpath stroke='%2351c757' stroke-width='.913' d='M922.368 472.104c-11.875-14.298-27.737-12.642-46.346 0M951.86 453.566c-4.51-8.406-20.974-2.87-38.761 4.217'/%3E %3Cpath stroke='%237acb73' stroke-width='.822' d='M1011.69 426.602c-4.494-12.92-12.358-20.225-23.594-21.91'/%3E %3Cpath stroke='%234cb135' stroke-width='1.141' d='M1026.86 406.376c-2.98-6.674-6.1-13.075-13.482-10.955'/%3E %3Cpath stroke='%2360c85a' stroke-width='1.278' d='M845.686 459.466c3.925-13.476-.332-18.77-7.583-21.067'/%3E %3Cpath stroke='%2371ce5b' stroke-width='1.187' d='M781.645 409.747c7.5-3.256 13.49-9.532 24.436-5.896M772.375 401.323c6.125.128 10.402 2.519 11.796 8.425'/%3E %3C/g%3E %3Cg stroke='%23000' stroke-width='.456'%3E %3Cpath d='M905.36 150.642c-3.542 3.26-7.176 6.25-12.28 4.957-3.494 1.432-.106 9.672-5.793 7.974-5.519-4.368-4.058 5.21-7.595 7.214-3.232 1.033-9.232 2.622-4.482 6.46 2.904 2.836 5.695 7.763.941 10.235-2.755 5.184-3.342-4.775-7.426 1.074-1.324 5.916 8.79 4.627 4.088 9.212-.788 2.743-3.598-6.762-6.447.795-2.214 3.127-2.3 7.744 1.952 9.141 3.622 2.08 11.215-1.083 6.692 5.021.001 3.602-5.948 9.583-3.69 2.8 4.065-4.719-1.835-6.024-4.507-2.805-5.486 3.741-3.207 12.066 2.152 14.468 1.587 3.324 3.199 4.202-.818 8.203.55 4.008-.283 7.452-5.568 7.201-2.95 2.797-4.934 7.463-10.547 6.759-5.388 2.171-6.743-1.373-7.759-5.65-1.744-4.248-8.866-6.678-11.465-1.983-3.119-1.262-7.171-7.188-10.37-1.356-2.843 3.895-7.341-2.278-10.345 2.79-3.494 3.837 2.174 7.421 2.993 10.348 4.673 3.767 2.16 5.993 1.161 10.864-1.695 4.413 6.185 7.145 3.746 10.683-3.502 2.735-9.136 5.89-7.783 11.13-4.964 1.75-4.293 7.444-2.756 11.386 2.5 5.628 13.084 4.99 12.577-1.9 2.802-.4 6.096 5.682 8.138 8.635-1.98 2.08-8.403-.427-11.948 1.373-4.648-.479-8.635 4.573-13.273 5.254-3.363 1.993-7.842 4.584-6.724 9.42.834 4.066 2.372 8.11 1.774 12.29-2.23 3.695-4.14 7.612-3.958 12.07-1.966 6.513 2.427 14.368-3.145 19.699-1.574 4.818 2.702 4.796 4.608 1.724 2.583 1.132 4.215-3.28 3.972-5.184 2.26 4.124 3.04-1.13 5.086 2.742 4.139-1.374-.941-13.305 1.652-8.313 1.976 2.898 3.022 9.057 5.87 9.488 3.167-1.254 1.556-12.902 3.844-3.841 2.471 8.078 3.753 16.602 7.83 24.029 2.397 6.986 8.719 13.51 16.717 12.147 2.267 2.148-3.514 6.589-4.624 9.624-3.574 2.705-7.987-.786-11.767-.938-3.79 1.473-8.143 2.277-10.838 5.536-1.727 3.792-3.046 7.099-3.434 10.855-.888 5.31.13 11.423 5.43 14.047 1.325-4.065.321-7.529 5.987-7.18 3.963 2.273-.436 8.102 3.088 11.678 1.781 3.71 6.917 8.342 5.22 1.03-2.016-5.742 3.357-5.794 6.617-8.162 4.295-4.53 4.972-.126 4.394 4.302 2.408 3.15 7.216-2.93 8.382-5.643 1.664-3.145.099-9.927 3.056-8.559 3.808-.98 6.274-4.468 9.262-6.941 2.693-5.24 7.736-.069 11.705.689 4.944 2.133 11.575 1.377 13.803 7.372-3.808-1.882-8.258 1.64-6.864 6.386 1.926 4.869 7.81 3.45 11.35 2.756 3.562 1.468 7.575-3.006 11.407.298 3.75-.817 7.885-.305 11.406-2.178 3.468-2.849 2.047-9.281-3.03-8.3 2.323-3.432 7.59-4.394 11.093-6.785 4.027-.366 7.53-4.832 11.058-4.17 5.026 3.478 7.524 9.095 11.844 13.11 4.235.49.311 6.377.765 9.973-1.134 4.345 1.297 10.36 4.926 4.42 2.186-3.95 8.198-2.82 8.523-8.005 1.678-4.38 2.811 6.4 7.104 5.824.289 3.346-.977 11.535 4.07 6.148 4.429-4.065 5.167-10.29 3.59-15.805.71-4.513 7.239 2.715 6.054 5.954 1.008 4.168 6.179-3.6 6.91-5.973.567-6.085.746-13.275-3.864-17.94-3.499-1.736-4.948-7.176-9.954-6.974-3.445 1.895-7.375 5.505-8.844-.822-4.543-4.036 3.08-4.32 5.626-6.172 5.123-3.238 7.928-8.794 8.967-14.566 1.864-5.297 3.463-10.685 4.685-16.168 4.008-1.44 7.765-4.377 9.996-6.806 4.553-8.556.198 6.417-1.419 9.938 3.48 1.54 8.027-1.245 9.517-4.931 2.241-2.484 2.735-12.253 3.902-4.43.52 2.708-4.304 10.748-.395 9.326 4.04-1.293 7.281-5.18 9.137-8.92 1.619-5.02 3.228-11.126 1.187-15.964 3.248-2.224-.235-11.523-3.75-6.467-4.514-.85-3.216-7.42-4.04-10.66 3.697-5.233.614-15.367-6.579-15.12-3.635-2.084-6.535-3.016-10.262-4.421-4.842 1.51-8.301-3.067-13.119-2.274-7.278.361.612-7.967 3.435-5.097 3.301 4.252 10.294 6.275 13.691 1.072-.16-3.923-.152-9.324-3.654-12.394-.695-4.386-1.865-8.533-4.883-11.951-3.705-5.446 3.11-6.713 5.354-10.104.996-4.387-1.666-9.2-4.292-12.782 2.824-2.826 5.67-8.063 2.635-11.652 1.13-3.422-6.573-4.017-9.066-3.68-4.991-.331-9.182 4.22-14.151 4.562-4.251 3.468-9.404 5.395-14.873 4.014-3.869-.961-6.9-5.21-8.975-7.735-5.043 2.76-.915-5.447-5.01-7.85-2.833-3.885-8.7-3.051-6.572 2.649-3.706 4.527-.474-6.087-2.79-8.26-3.017-7.273-1.782-2.055 2.292-.066 4.528 3.1 11.121 1.226 12.254-4.338-2.223-3.304.26-9.824-4.752-9.356-3.67.56-3.854 9.498-5.909 2.19-.557-4.032-2.83-7.386-4.864-10.847 2.731 4.795 8.022 9.975 13.89 7.019 3.15-2.06 4.268-7.18 2.375-10.247.177-10.609-5.948 5.636-8.76-2.757-6.502-1.926 12.459-8.926 4.682-11.246-2.645 3.682-8.39 1.949-8.996-1.917 3.28-1.836 6.403-8.92 4.234-11.263-4.732-2.685-6.564-6.739-5.507-12.178-2.773-2.97-9.863 2.25-10.276-4.43-.23-6.205-5.882.82-8.98-1.423-2.338-1.382-4.713-2.755-6.924-4.479z'/%3E %3Cg fill='%23d40000'%3E %3Cpath d='M904.106 194.538c-.31 6.88-6.22 5.435-7.908 3.553-1.624-6.29 7.801-8.015 7.908-3.553zM907.309 194.143c.616 5.434 6.847 6.188 8.027 3.912 2.059-5.189-5.677-8.485-8.027-3.912z'/%3E %3Cpath stroke-linejoin='round' d='M903.481 188.9v1.19l-.655.12-.238-.297-.177-1.847-.358-.178v-.834l.833-.058v-.776h-1.012l-.359.776-.18 1.071.42.894-.42.715-.772.417-1.073 1.014-.717.356-1.668.179-1.369-.656-1.373-1.31s-.595-.954-.655-1.192c-.059-.238-.417-1.072-.417-1.072l-.36-.894-.654-.715-1.013-.12-.298 1.251-.356.477-.835.119-.892-.774-.596-1.013-.657-1.312-.536-.894-.774-1.13-.359-.655-.356-1.55-.896-1.132-.595-.953-.951-.774-1.014-.775h-1.192l-.775-.596-1.13-1.072-.835-1.132-.534-.655.12-.597.416-.537.894-.535.892-.06 1.014-.238 1.013-.536.179-.716.179-1.191 1.071-1.907.477-1.37.06-1.072 1.549-.239 1.49.179 1.072.299 1.132.356 1.31-.655 1.073-1.372.356-2.382.477-2.204.537-1.25h2.742l.95.655.776-.357.714-.357 1.729.177h.893s.715-1.131 1.014-1.31c.296-.179 1.727-2.086 1.727-2.086l1.846-.476.953.12 1.312 1.49 1.071.656.954.06 2.265 1.489s.715.595.954.475c.237-.119 2.265-1.013 2.265-1.013l1.785-.119 1.908-.655.655 1.488s.954 2.265 1.252 2.503c.298.238 1.489 2.501 1.489 2.501s.596-.297.895-.357c.296-.06 1.667.298 1.667.298l3.932.18.537-.597.415.715-.534 2.74.237 2.086.716 2.801.892 1.31 1.193.06 1.55 1.311.06 1.31-1.192.418-1.073-.358-1.373.774-2.143 1.25-1.79 1.789-1.546 2.203-1.014 2.204-1.012.716-.895-.358-.894.059-.416 1.073-.894 1.071-.775 2.741-1.668 1.847-1.728.834-1.25.954h-.834l-1.43-1.372-.655-.595-.178-2.144-1.373-1.074h-1.014l1.49 1.192.06 1.608-.832.714-.419-.118-.415-.834h-.479l-.06 1.608-1.787 2.085-1.786-1.489-.06-1.907-.892-.175z'/%3E %3Cpath d='M874.307 173.86l2.662.085 1.375 2.063 1.202 1.288 1.201.945 1.032.17 1.976 2.921v.345l1.544 1.374.43 1.802.172.601-.086.773-.86.516-1.03-.173-.601-.43-1.888 1.633-1.203 1.632-.773.173-2.063 2.232-1.03.344-1.632 1.202-2.576-.086-1.63-1.975-.343-.774-.086-1.546 1.46-1.03.687.772-.342.773.084.946.86.343.858-.087 3.092-2.662.773-.43 1.804-1.802 1.117-.602-.085-1.116-1.289-1.975-.428-1.374-.344-1.289-.342-.945-1.203-1.373-.688-.774-.258-.773-1.201-.945-.343-.173v-.599h-.005z'/%3E %3Cpath fill='%23a00' d='M926.009 183.908h1.375l1.46-.688 1.118-.944h1.03l.687.686 1.117-.085.687-.859.258-1.03.944-1.288.258-1.29.86-1.803.257-1.289-2.147-.085-2.49 2.148-1.89.085-1.546 1.632-1.202.17-1.288 1.89-.429 1.118.172 1.117.769.515z'/%3E %3Cpath stroke-linejoin='round' d='M899.472 201.173l-1.633 1.632-.429 1.46.687 1.458 1.547.258 1.117-.6 1.03 1.202.171 2.061 2.062 2.232.944.258.774-.859.858-.86.086-.857 1.376-.601.343-2.577.774.943 1.286-.772 1.633-.17v-2.149l-.6-1.459-1.29-.946-1.975-.859-2.147-.773-1.03.087-1.893 1.118-2.06.685-1.631.088z'/%3E %3Cpath stroke-linejoin='round' d='M912.4 200.641l3.1-.142c2.128-1.38 3.049-7 4.513-10.713 2.271-2.945 5.06-3.826 8.46-2.256l1.974.564 2.537 1.973h1.83l1.272.282 1.974.141 3.525-2.82-.14 2.96-2.398 2.115-4.934 1.834-3.808-2.255-.14.564 8.178 9.021h.704l1.41 1.41.705-.564.141-2.396 2.821-2.537.281 3.665.987 1.832v3.525l-2.679 3.384-4.229.564-4.934-3.101-.14-1.41-4.514-5.216v2.256l2.68 5.498.422 2.114.988.988.706 1.693v2.115l1.267 2.96 2.256.28.566-1.408v-1.974l2.397-2.398 1.551-.14.564.846-.705.704-.282 1.552v.986l1.974 2.679.565 1.692-2.962 4.51-1.975.566-3.523-.565-2.116-1.41h-1.128l-3.243-4.935-.422-2.396-4.371-6.909-.143 1.41 1.694 2.116.845 3.242.845 5.78 2.538 4.935.14 9.165.848.986h1.125l1.411-1.127 1.127-1.55-.282-5.358h1.552l2.678 1.551 1.974 3.243.705 1.41v2.96l-.986.14-1.975 2.116-3.243 1.409h-5.638l-1.268-1.127h-1.128l-.845-.846h-1.552l-4.373-6.203-.139-10.292.564-2.255v-3.102h-.704v3.102l-.707 1.975-.14 2.82.14 7.754 4.652 7.472 3.384 1.692.988 1.128h-1.551l.142 1.128-1.271-.282-.281.564-.704-.282-1.271-.847-1.692.283-1.126.564h-2.96l-1.271-2.538-.985-1.974-3.384-3.102H909.3l-.564-1.832.423-3.243.707-2.96v-7.896l-.566 9.024-1.55 5.075-.565.423-.141 5.78.987 2.679 3.947 4.37-2.678.282-1.974-.844-2.116.42-3.241-.704-3.667-1.268-2.397-2.396-1.128-2.68-.423-2.677-.564-2.82.564-2.255.282-2.256-1.127 2.537v6.062l-1.552-.422v-1.692l-1.268-1.692-.28-2.256-.424-3.383-.143-5.498.143-3.384.704-3.807-.564-.141-.425 4.795-.28 9.445-.987.283-2.255 3.101H881.1l-1.974-1.69 3.808-4.09-.423-3.243-.424-3.805-.423-6.486-4.371 4.652-4.934 3.526h-4.23l-2.396-2.962-.425-3.382.283-2.398 2.537-3.384 1.831-.28.707-.706.423.564-.986 2.82-.987 2.114.845 1.974 2.398.282 3.101-4.793 2.397-5.64 1.832-2.82v-1.55l-1.69 1.268-1.975.424-5.779.141-3.383-2.115-.565-1.692.14-1.55.143-2.115 3.665-2.398.14 5.075 2.4-1.974v-.982l3.1-4.09 7.472-6.625h4.512l2.678 1.974 1.126.282 3.244 3.102.14 3.947 3.808 3.102-2.256 2.679.138 1.41 2.118 1.551 1.973-.564.846 5.217 2.396 1.41 1.269.14 4.795-5.64 2.115-.28 1.269-2.82-.567-2.257-.561-1.277z'/%3E %3Cpath d='M858.209 249.643v.827l1.657 2.247-.119 2.367-8.4 4.259-3.664.237-1.895 1.774-4.85 1.538-2.128-.474.354-1.182.236-2.011-.236-1.183-1.537-.828v-1.895l1.892-.59-.593-.827-1.064-.12.237-2.483.473-.946.119-.592-.119-1.184-.473-1.064-1.302-.356-3.784 1.54-.592-.594-1.775 1.893-.947.119-.117-1.539-1.893-2.485v-.474l-3.548-.59-2.485 3.194h-1.775l-1.3-.946h-1.066l-1.181.708-.712-.235-1.064 1.894h-.59l-.712-1.54-.946-1.537-.354-.948.474-1.891 1.537-.947 1.89-.948 1.424-.235 1.654.947.71 1.536 2.13-2.01 2.128-2.367 1.774-.709 2.249.354 2.485 3.313 2.364.235 2.84-2.01 1.065-.592 2.604.355 2.603 1.42 2.72 4.02.474 3.904.59 1.066 4.732-.357 4.968-.945 2.838-.113z'/%3E %3Cpath d='M861.049 244.319l-1.302 5.797 1.537 1.656-.119 1.893.827.828 1.539-.828 1.537-1.065 1.537-.593 1.775-.945.235-1.066 1.892-.945 2.013-.593 2.601-.71 2.604-.355-1.892-1.302-5.442-3.547-2.249-.237-.828.709-3.192.119-1.773.472-1.3.712z' stroke='none'/%3E %3Cpath d='M887.192 238.523l-3.785-.119h-2.486l-2.01-.827-1.656-1.656-.237-1.538-1.182-1.892-1.183-1.184h-1.775l-2.482 1.656-1.066 2.13-.235 3.43 1.418 2.957 4.732 3.55 2.721.59 1.895-.826 4.257-1.893 2.721-1.774.95-1.538-.597-1.066zM878.083 233.08l2.128-2.246.118-5.088-.591-.473.591-2.011.237-1.656h-.828l-4.614 4.376-3.195.473-1.653.948-.12 1.182 1.302.828 2.366-.237 1.3.12 2.959 3.784z'/%3E %3Cpath d='M879.976 246.448l4.139-.355 3.313.237 1.656.474 3.313 1.774 1.894.948 3.667-.238-1.42-1.773-1.42-1.775-.948-1.775-.236-1.773-.825.236-.948-.236-1.182-1.538-.71-2.248-.475-2.957-.944-.12-.712 1.42.712.709.708 1.42-1.183 1.536-.118 1.185-1.537 1.183-2.13.947-2.011.827-2.248.828-.355 1.064zM910.26 241.006l.119 5.087 1.775 1.538h1.654l1.302-.709.356-1.064-1.184-.71-.474-1.42-2.484-2.72h-1.065v-.002zM929.543 245.028l5.086 3.43 1.538.475 1.42-.474 2.365-1.893 1.182-2.602.12-1.892-1.182-.118-1.893 1.302-2.721.236-2.129.354h-1.657l-1.657.355-.472.827zM944.21 241.126l-.944 1.538-.947 2.366-2.13 2.248.119 1.655h-.948l.12 1.302 1.654 1.3 4.616.709 3.668-4.73v-1.302l-2.012-2.367-1.421-.354-1.775-2.365zM965.74 254.375l2.368 1.183v.828l-.947 1.302-.59 2.483-.238 1.538-2.84.12-2.956-1.065-1.657-1.065h-1.538l-.828-.709-1.418-.947-1.776-1.184-1.891-2.483-1.301-1.656v-1.183l1.775-2.248 1.775-.59h7.926l3.666-1.302 2.956-2.484 3.55-.71.828-.946 2.366-.474 5.915-3.076 3.312.59 3.313-.117 2.838.827 1.066.947-.592.355-1.537-.119-1.775.947-.237 3.194 1.42 2.602-.355.71-1.774-.118-1.182-.593-.593-1.065v-1.064l-1.181-1.656-.947-.354h-2.127l-.71 4.494h-1.068l-2.008-1.774-2.96-.356-2.01 1.775.708 2.366 2.96 2.84h1.537l1.42 1.654-.12 1.301-2.128-.474-2.13-.472-1.774-.83-1.42.238-1.657-.948-1.656-.708-1.064-.474-.714.95zM973.724 307.228l-1.882 1.705-1.255 2.42-.447 2.507-.807 3.137-.359 2.42.36 5.287.18 2.866 1.7 2.69.896.268 1.075 2.15 1.523-4.211.719.537.447 3.136 2.51 2.15s-2.33-1.164-2.868-1.164-.627.626-.627.626l.627 1.344 1.432 1.434 2.51.984 4.66.09-1.075 1.075h-3.225l-.81.626 1.167 1.703 1.433 2.24 2.6 1.254 2.686-.716h.896l-.447 1.075 1.344.984 1.164 1.075 1.076 1.166.895.178v1.344l-1.612 4.034-.36 1.88-.894 1.524-.538 2.328-1.613 2.778-.179.986h.807l1.164-1.525 1.704-.716 2.061-2.688s1.164.36 1.434-.18c.268-.538 1.523-4.301 1.523-4.301l1.254-.269.628-3.942 1.075 3.675.898 4.66-.36 3.942-2.33 4.3-.626.72.358 1.432h1.702l1.972-2.063 3.404-4.57 1.347-4.57.716-8.871 1.523 4.123 1.434 4.031.719 3.136-1.077 4.122-1.344 4.84 1.793-1.256 3.765-4.212 2.955-4.388.808-3.226.717-6.184-.448-4.838.177-1.793.628-.985-.09-3.226-.627-1.344-2.149 2.867-.896.18-2.51-1.703-.626-.18-1.434-2.061-.984-3.316.088-3.763h-.536s.269-3.137.536-3.943c.27-.807.628-2.328.628-2.328l-.449-3.317-1.702-3.137-2.061-1.79-3.315-.985-3.855-1.077-2.24-1.79-4.211-.448-2.15.269-4.033-1.882-2.599-.986-3.314-.088-3.137-.36-1.617.094zM829.548 307.424l-8.264-.164-1.323-.662-1.982 1.652h-3.802l-4.133 2.314-2.809 2.148-1.487-.164-5.786 5.29.827 4.296.66 1.158.331 4.132.164 5.949-1.32.993-1.984 4.96-1.158 4.296-.992 8.43.827 6.28-1.158 3.306-2.313 3.637-.496 1.818 1.982-1.324-.328-.661.99 1.487 2.478-4.463.993 1.654.99.164v-5.62l-1.155-8.76 2.809 9.093.662 3.305.496-.167.33-7.438 1.817 4.133.166 3.635.826.662.498-.992v-5.454l-2.977-8.76-1.487-8.101 3.967 10.579 2.315 2.148 2.148 5.786 1.82 3.305.33 2.148 1.322-.826.498-.825-1.158-.827.825-.66-.167-2.975-.99-6.94h-.99l-3.472-7.273 3.14 4.464h1.322l.166-1.159-1.487-2.975-.33-3.471 2.975 4.298.99-.495-1.652-4.796-.33-5.454.992 2.314-.166 2.645 2.15 2.646 2.148 1.155 1.652-1.98-1.158-.829-.494-2.312-1.655-1.984v-2.646l2.317 4.133 2.147 1.488 2.149.496 2.15-1.487 3.634-4.133-.493-.497-3.804.167-2.975-1.984-2.644-2.478v-2.149l.496.329 1.156 2.316 2.149 2.15 2.479.328 3.142.167 3.469-3.14 1.82-5.951.496-3.306-.661-4.132-2.15-4.794-1.323-2.15-1.157-.496zM951.204 398.996l-8.762 9.088-1.157-.33-3.14 2.646-.165 2.81 2.975 2.316 1.158 2.148.827-.167 2.973 3.636 2.812 3.969 1.158.662.824 1.817-1.485 2.148.495 1.325 2.314-.333 2.646.167 1.651.991.662 2.976v1.155l1.818-.99 1.488-2.15.166-5.288-.329-1.487.493-3.968.496 5.288 1.158 1.654.826-.663.99 3.473 2.15 2.15 1.158 1.98.167-1.32-.167-2.644 1.158-2.976 1.322-3.47 1.323-.829 1.155.5 1.656 1.65-.166.662 1.488-.167-.333-3.966-2.147-2.976-3.307-2.145-1.652-1.653-1.487-2.645 2.314 1.322 2.479 2.314 2.313 1.158 1.654.33 2.812 5.454 1.818 2.645.33-3.636 1.322-4.134 1.324-1.817 1.652-.166 2.15.662-.498-2.48-1.652-3.14-3.306-2.974-3.472-2.645-2.973-1.325-2.647 2.316-.826.329-1.488 1.325-1.156-.496-3.802-3.64-.992-.658-1.652-3.969-2.48-1.158-3.802.333-4.632-.994zM851.863 396.848l1.158 1.981.992 3.14 1.652 1.821-.165.99 2.314 1.982 2.313 3.636 3.803 3.14-2.81 2.481-6.612 4.96-2.15.662-2.809-1.657.33 3.968 1.157 1.82-2.975-.662-3.472.33-2.148 1.82-.497 1.816-.826-1.32-1.158-1.821-.33-.329-.66.496.496.328.164 3.306-.825.663-.167.991-3.8 2.478-.992-2.478-1.325-2.81-2.313-1.158-2.478.332-2.81 1.652.825-2.314 1.654-2.645 3.139-2.644 3.14-1.982 2.48-.991.662-.333-.828-.825-4.626 1.32-3.307 2.15-3.472 2.48-2.644 3.8-1.322.99v-2.807l-1.49-3.802-.495-2.481-1.488-1.817h-1.817l-2.479.495 1.82-3.139 3.634-1.982 1.654-2.81 2.975-2.482 2.479-.496 3.637.496 1.816.995 3.474.163 2.146-.163 2.646-1.325 2.15-3.969 2.973-4.294 3.474-1.82 4.133-.326z'/%3E %3C/g%3E %3Cpath d='M892.877 173.292v2.084l-.775 1.25h-1.37l-.833.895-.24.715 1.55 1.43 1.43 1.012.594.716.36.178 5.957-.06.714.715 1.312-.953 1.61-2.443 5.064.06 2.68 1.966.179 1.609.596.239 1.428-1.25 1.192-.06.595.775h1.074l3.515-3.159.596-.834 1.31-.06-.177-1.013-1.43-.357-1.25-1.25-.359-2.086-1.131-.178-1.966 1.013-3.396 1.668-1.133.834-1.012.059s-.417-.357-.656-.357h-1.31l-1.074.894h-.834l-.298-.298-4.587-.358-3.813-.953-1.968-1.31-1.25-1.013-.359-.356-.535.236z'/%3E %3Cg fill='%23fff'%3E %3Cpath d='M895.739 178.772h2.62l.656.536v.714l-1.25.537-2.206.119-1.55-.238-1.073-.954-.237-1.906 1.428-1.609h1.372l.12.537.12 2.264zM913.254 178.654l-.416.356v.716l.534.357 2.623.12 2.86-2.263.06-.895-1.726-1.49h-1.49l-.24.417.36.775.475.715-.476.953-2.564.239z'/%3E %3C/g%3E %3Cg fill='%2348489c'%3E %3Cpath fill='%235656a6' d='M819.408 249.526l1.538 2.72-.117 4.85-.593.592-2.246-1.893-1.185-1.655-1.183-2.011v-1.774l1.183-.947 1.537-.354 1.066.472zM824.141 257.33l3.43-7.097v-1.892l-1.302-1.895h-1.775l-1.891 1.775v6.27l1.538 2.839zM830.054 257.33l1.894-.827 4.614-4.377.709-1.301-.357-1.065-1.3-.946-.826-.237-1.894.828-1.064 1.065-2.13 3.784.354 3.076zM838.219 260.406l-1.657 1.184-1.894-.118-3.428-2.367.117-.474 2.13-.355 1.892-.828 1.892.118 1.067.946.353 1.066-.472.828z'/%3E %3Cpath d='M970 256.975h2.722l1.537.828h3.075v1.184l-1.774 1.3-3.431.947-1.539.709-1.182-.119-.828-1.064v-1.656l.71-1.42.71-.709zM988.808 253.31s1.894-1.067 2.246-1.892c.357-.828 1.184-2.604 1.184-2.604l.711-3.076-.945-2.602-1.775-.472-1.537.117-.828.827-.236 2.249.827 1.892.71 1.065-.118 2.01-.239 2.486zM981.71 254.255l1.894-.946 1.18-2.247.122-2.485-.947-1.894-1.302-1.417h-1.775l-.474 3.31 1.3 1.303v4.376h.002zM979.463 256.385l.71-.828.357-1.775-.71-2.601-1.067-1.184-1.3-1.183-1.42-.945h-2.013l-1.3 1.064.353 2.13 2.369 1.774 1.892.355 2.129 3.193zM988.106 250.757v2.134l-2.132.306-.153-2.896 2.285.456z'/%3E %3Cpath fill='%234f4d9f' d='M971.699 428.416l-1.818 2.48v4.132l.826 1.985-.826 7.767 4.133-5.784 1.485-2.977-.164-3.965-1.158-1.82-1.322-1.157-1.156-.661zM985.418 419.824l-1.322.329-1.488 3.139-.33 4.132.826 2.148v2.977l.332 1.817 1.485-2.146 2.15-3.638.328-2.645v-3.635l-.991-1.654-.99-.824zM949.384 441.308l2.15-1.487 1.653-1.158 2.15-2.808-.332-2.148-1.324-.991-1.652-.662-1.487.166-1.654 2.313.167 4.63.329 2.145z'/%3E %3Cpath fill='%234748a5' d='M848.724 426.766l1.652.659v4.464l-2.809 3.14-3.139 2.315.163-2.976-.825-.988v-3.144l.662-.825v-1.486l2.81-1.49 1.486.331zM827.234 429.409l2.314-.166 2.479 1.486.991 2.812-1.487 1.323-.825 1.321-.496 2.15.33 3.472.166 3.14-2.81-3.473-2.313-3.635-.167-3.635.826-3.14.992-1.655zM819.3 425.278l-.661 2.312-.826.496-.991 1.324v4.957l-1.654-.988-1.818-2.316-.99-2.48.33-6.28.826-2.645 1.984-.662 1.983.662 1.651 3.802.166 1.818zM819.468 409.246l-.992 2.477-2.645 1.982c-.405-2.64.955-4.026 3.637-4.459z'/%3E %3C/g%3E %3C/g%3E %3Cg stroke='%23000' stroke-width='.456'%3E %3Cpath fill='%23dfda4d' d='M825.559 261.236l3.193 2.957 2.368 1.537 1.892.71 2.367 1.301h4.969l4.494-.474 2.247-.828 4.377-.119 3.55-1.656 2.601-1.773 2.602-.118 1.423-1.42h1.891l3.784-2.84 5.325-2.364 5.56-2.011 6.035-1.183 2.482.117.946.71 1.184 2.01.472.948-.59 2.01-2.247 1.303-.474-1.421 1.419-1.183-.354-.71-2.25-.355h-1.538l-1.417 1.42-.237 3.194 1.892 1.655 2.011 1.302 1.775.119 2.13-1.3 2.84-2.485 1.654-2.839-.474-4.14-.946-2.604-2.839-2.129-3.548-1.42-6.151.12-3.668.945-1.42.474-3.903 2.602-1.775.118-3.903 2.602-1.54.59-1.775.71-2.72 1.184-5.207 2.364-3.547 2.13-1.775.238-4.139 2.601-5.916.474-1.064-.593-2.722-.354-1.774-.711-1.774-.946-2.483-2.957-.711-.474h-2.248l-.71.948.356 2.014z'/%3E %3Cpath fill='%23d9d24d' d='M894.408 251.299l.71 5.915-1.3 3.666 2.721.119h3.192l2.84-.593 2.721-.237 2.485.12 2.011.236 2.483-.946.119-1.892-.592-1.656 1.182-3.669-.474-.828-18.098-.235z'/%3E %3Cpath fill='%23d9d34a' d='M922.444 257.804l-.71.474-1.064-.474-.592-1.655 1.183-1.065 2.601.118 2.367 2.13v3.075l-3.195 1.54-3.31.827-3.669-1.065-2.247-3.076-.592-2.129.474-3.668.592-2.366 3.194-2.367 3.43-1.064 4.02-.593 4.617 1.183 9.343 3.55 6.27 2.839 6.98 3.668 4.14 1.893 5.443 2.601 3.313 1.184 3.785-.474 1.656.118 3.312-1.064 2.247-.238L981 255.91l2.012-1.183-.236 2.602-3.313 3.668-2.838 3.194-1.182.12-1.538 1.299-2.957-.119-6.862.356-3.312-1.064-5.205-1.066-6.151-2.72-4.852-2.485-2.366-.353-3.669-1.894-2.246-.236-1.301-.947-4.024-1.182-3.313-1.184-3.192-.355-2.485-.354-1.182.709-1.183 1.656-.59 2.247.827 2.722 1.42.238 1.302-.59.472-.948-.592-.236z'/%3E %3Cpath fill='%23ddd457' d='M852.564 388.192l-1.51 1.507-2.374-1.507 1.077-2.804 3.883-.648 2.158 3.235-.864 3.234-3.02 3.018-3.668 1.08-3.666.43-4.312-.214-5.825-1.297-4.528-5.39-3.451-6.902-2.586-5.822-3.02-11.862-1.511-4.961-.647-4.529-3.234-6.254 1.292-1.078 11.216-9.92h.648l2.373-2.158 4.096-7.764.432-.43 1.293-4.744-.216-8.195-1.077-3.882-2.587-4.314s-.863-1.51 0-1.294c.861.216-2.373-3.667-2.373-3.667l-3.884-4.1v-.86l-2.802-2.804-1.941-1.078h-1.51l-.648-.864-2.804-.862-1.293 1.294-.863 2.804v1.08l1.94.86.646-.43-.646-1.08.216-1.294 1.512-1.077 1.724 1.291-.216 3.235-1.294 1.511-3.234.217-2.588-1.295-1.078-2.157-.861-3.233.861-1.942 1.295-1.077 2.157.43 3.45-.863 1.077-.431 2.805.43 1.941 1.942 2.155 1.294 5.393 6.04 1.509 1.508 2.804 4.099 3.451 7.764.862 5.39-.43 5.393-2.804 7.764-3.235 4.96-4.528 5.607-7.764 6.472-1.078.215-1.725 2.157 3.02 6.47 4.744 19.842 3.882 8.194 5.607 5.823 4.313 2.373 5.609.648 4.96-1.296 2.157-1.938-.864-1.294z'/%3E %3Cpath fill='%23dbd45d' d='M861.622 392.72l-.647 1.076.863 1.727 2.158.431 1.508-1.942v-2.158l-1.295-2.37-1.724-.435-1.94.217-2.805 1.942-1.51 1.726-.864 4.096 2.158 6.688 3.451 4.528 8.626 5.607 9.275 3.45 5.82.862 4.316 4.315 2.156 5.174-1.94 3.238-2.588.215v-1.294l1.077-.217 1.295-1.294-.647-1.293-2.587-1.511-2.156 1.726-.218 3.883 1.94 1.941 2.804.645 2.158-.863 2.155-2.374.218-2.803-.863-4.098-3.668-5.173-3.88-1.942-9.705-3.452-6.255-2.37-4.53-3.239-4.096-4.311-2.373-6.252 1.078-4.098 2.373-1.727 1.294.43-.432 1.299z'/%3E %3Cpath fill='%23e5dc5e' d='M939.906 392.934l1.726 1.079.217 1.724-1.942.863-2.587-.43v-2.587l1.508-3.235 4.316-.217 1.94 2.373 1.295 4.528-1.295 4.746-4.96 4.097-6.902 4.746-7.548 3.234-11.214 5.39-3.235 2.37-2.805 5.177 1.727 3.022 2.157.43v-1.078l-.648-.863.43-2.374 1.295-1.292 2.586 1.51.65 3.235-2.374 2.373-2.589.431-4.096-1.942-1.295-2.155-.215-3.023 1.726-2.803 3.45-3.449 5.392-3.022 7.764-3.234 11.43-5.606 7.978-8.628v-3.448l-1.726-2.157-2.156.215z'/%3E %3Cpath fill='%23d7d643' d='M949.826 386.681v1.938h1.51l1.51-.215.647-2.586-1.293-1.724-1.726-.219-2.158.431-2.37 1.726-.217 3.452 1.077 2.37 2.157 3.234 3.882 1.942 3.881 1.079 5.825-.431 6.685-3.234 6.254-4.529 2.588-6.256 3.234-11.43 4.096-14.448 2.589-5.39 2.156-1.943-.647-.861h-1.94l-4.96-3.666-5.175-3.236-6.687-7.978-3.45-6.687-1.078-9.488 1.941-9.275 4.097-6.901 6.685-5.608 6.04-4.313 6.038-.213.86 2.371-.86 1.942-1.295-1.08-1.94-.215-.862 3.235 2.154 1.078 3.882-.431 1.08-2.587-.43-3.666-2.805-2.589-4.962.431-3.666.43-4.53 2.59-4.742 4.959-3.234 4.745-4.1 6.685-1.293 6.038.216 10.569 5.393 11.428 4.743 6.04 9.273 6.253 1.51 1.079-2.803 6.254-4.098 13.156-2.587 10.567-2.156 4.529-6.901 6.038-7.766 3.018-6.684-.213-3.235-2.374-.864-2.156-.216-3.234 1.727-.431z'/%3E %3Cg fill='%235db7d2'%3E %3Cpath fill='%2344b3cc' d='M890.873 284.615l-.33 3.305.991 7.273 3.636 20h1.82l.164-3.14-6.281-27.438z'/%3E %3Cpath fill='%2350aece' d='M900.127 313.706l-6.61-28.926 4.956 29.422 1.654-.496z'/%3E %3Cpath fill='%2350afce' d='M901.285 313.375l2.314-.826-8.596-27.769 6.282 28.595z'/%3E %3Cpath fill='%2350abce' d='M897.484 283.127l10.082 28.926-1.983.66-8.099-29.586z'/%3E %3Cpath fill='%2350b0ce' d='M909.054 311.39l-9.752-29.255 12.397 28.926-2.645.329z'/%3E %3Cpath fill='%2350b3ce' d='M912.69 309.904l-11.57-27.935 14.38 28.266-2.81-.331z'/%3E %3Cpath fill='%2364b4d1' d='M822.091 258.767l-1.56.239-1.918 1.56-.84 2.039.122 3.717 1.318 2.278 2.28 2.4 1.078 1.799-.6 3.236-3.236 2.039-3.478 2.519-1.32 2.038-.48 2.278.121 2.399.479.599 2.639-.122 1.559-.477 2.397-.24 2.278.36 3.477 2.399 4.918 4.437 2.156 2.519-1.557-3.719-.839-4.437-.6-4.437.721-2.637 1.199-1.68 1.319.72 1.079-.6 1.44.72 1.2-.72 1.917.6 2.397-1.2 3.598-2.757h2.518l.721.599 1.438-.599.84 1.2 2.999-2.28 2.397-1.199 2.398.96 3.119.72 1.2-1.08 2.517-.12 3.477-.48 1.68 1.2 1.676 4.076 1.2 1.32 1.8.358.959.48 1.677 4.198 1.2 3.358.6 4.076-.24 1.079 1.078-.119 1.68 1.676 1.439.722 1.199 1.318.357 2.158.961-.119.84-1.079 1.68.36 1.438 1.558 1.438.121-2.52-16.669-2.398-1.319-.12-3.836 5.636-2.04.12-1.438-.838-2.4-1.08-2.157-2.158.238 1.678-5.395 4.197 4.317-1.919.24 1.677 6.595 7.197-1.199 1.32 1.8-.48 1.558.6 1.078.358 1.92 2.16 2.757 5.636 12.23 5.396 11.033 2.398-2.518 2.52-.598 2.758-1.92 1.678-.6 1.198-1.558 3.12-.121 4.674 4.197.722-1.078 4.435-.242 1.439 2.878.24 1.2 1.8-.72 4.916 1.078 2.998 2.4 2.276.957.601 1.201 1.319-1.56.96.122 1.56.36 4.915-.36 2.52-5.038s2.277-4.675 3.359-5.875c1.078-1.199 5.515-5.995 5.515-5.995l5.395-3.6 4.077-2.277 3.837-.48 3.6-.12-.12-3.237-1.44-3.118-3.598-4.675-.72-3.718v-2.28l3.118-2.039 3.718-2.997.121-3.119-1.079-3.838-2.16-3.236-.72-.6-1.2-.239-1.677 1.078-3.358 4.676-3.717 3.719-4.557 2.759-5.276.599-8.393-1.32-5.875-1.8-7.317-2.757-7.675-3.597-4.196-.842-6.357-3.116-2.397-.121-.121 1.08 1.917 1.917-.477 3.36-1.68 1.797-3.117.121s.36.241-1.439.72c-1.8.48-3.357 0-3.357 0l-2.998-1.799-2.879-.48h-5.755l-6.355.601-7.196.6-3.597 3.118-3.119.48-3.357-.84-3.477-4.076.12-2.278 2.518-3.119-1.319-.12-7.915 2.879-4.918 2.756-2.636 1.68-1.919-.12-2.52 2.278-3.117.24-1.8 1.918-.6-.24-5.034 1.32-4.558.838s-5.756.84-6.355.84c-.601 0-6.115-.72-6.115-.72l-4.08-2.038-1.917-2.158-1.8-1.2-2.397-2.516.12-1.92-.718-.478z'/%3E %3Cpath d='M893.774 318.595l-.17 3.743 2.722-.678-.34-3.574-2.212.509zM897.348 317.575v3.062h1.192v-3.232l-1.192.17zM900.071 316.895v3.403l1.7-.511-.17-3.062-1.53.17zM903.643 316.213l.172 2.552h1.528l.172-3.062-1.872.51zM907.046 315.533v2.724h2.38l-.339-3.065-2.041.341zM910.788 314.683v2.552l2.042-.51-.51-2.724-1.532.682z'/%3E %3C/g%3E %3Cg fill='%23ccc'%3E %3Cpath fill='%23fffcfc' d='M973.633 345.67v2.69l.628.36.18.894 2.775.45-.27-.897-1.793-1.703-.447-1.255-1.073-.539z'/%3E %3Cpath d='M916.933 309.892l-.46-.916L918 307.3l2.893-.607 2.286-1.83 2.896-1.829 3.048-.762 3.963 3.352-1.371 1.07-1.374-.154-2.59 1.676-1.98 1.22-1.676-.305-1.526-.457-.913.762h-1.374l-1.068.61-2.281-.154zM935.527 305.623l1.523-.607h2.286l1.22 3.351v1.068l1.98-.61h3.659l2.59 1.22 2.286 2.286 2.438 1.373h1.98v-1.068h1.981l.459.61 2.132.304 1.525-.456.457 1.372-.304 1.827-.459 1.374.61 5.79 2.744 9.906 5.182 8.384-1.98-.916-4.421-.61-1.373.61-1.827-.152-2.134 1.98-1.068.152-.913.763-1.677-2.286-6.4-8.534-1.677-1.829-3.657-7.924-5.03-10.822-.306-4.421-1.218-1.22-.61-.152v-.763h.002zM933.697 364.607l2.592 1.22-.152-1.22 1.828 1.22s1.676.305 2.59.152c.913-.153 2.896-2.133 2.896-2.133l.61-4.115 3.963-6.859 2.893-1.676.918-.153 2.74-3.049 5.182-2.742 2.439-.915 3.963.762 2.896 1.372.61 2.439.458 6.553 1.828 1.374 1.525-.764 1.371-1.676 3.352-1.221 2.44.303-.154 3.05-1.066 5.64-1.676 5.943L975 377.56l-2.59 6.708-6.402 4.878-5.029 3.198h-8.078l-2.438-2.285 3.048-.764 1.067-1.826.305-3.201-2.742-1.981-2.743.152-3.658 2.135-1.374 1.825-.762 2.136h-1.37l-3.05-.154-2.287 1.526-1.675 2.13-.458 3.202.764 2.288 1.675 1.066 3.048-.153.764-.607h.61l-2.745 3.044-3.504 3.66-4.573 3.048-3.048.913-5.03 1.83-3.657 1.677-4.116.152-4.267 3.809-2.896 2.288-1.981 2.742-.915 4.726v3.503l2.284 3.048-.304.916-1.371-.156-.763-.607h-3.352l-.916-1.373-1.676.306-2.437.761-1.068 1.07-1.829-.917 1.068-2.742.152-2.59-.762-3.508-2.286-4.573-1.98-2.131-3.507-2.135-6.706-1.982-7.314-2.739-5.334-2.594-1.981-3.048-.763-3.809 1.22 1.22-1.068-4.268 1.524 1.979 1.07.152 3.047 3.813 2.439.458.61.303h.76l.153-.303 2.286 1.22 2.592.76h3.656l-3.2-.76-3.963-1.83-4.115-2.288-2.286-3.044-.306-1.373-1.219-.152.154-.917.914-1.067 1.22.154.305.913 1.22-.459 1.98 1.527 3.354.302 2.437.306-2.131-1.219-3.354-1.829-3.353-3.049-1.068-.152-3.354-5.18-1.828-5.03-1.524-5.333v-6.25l1.98-5.027 2.896-4.574 1.676-1.525 1.372.457 3.505-2.59 2.438-.761 3.202.15 2.438.763 3.506 1.068 1.675 2.132 1.676.154.456 1.22-.913.304 1.22 1.676-.458 1.067 1.068 1.372-.152 1.98-1.98 2.287 1.37 2.285-.154.764 1.677 1.829 1.525 2.284 2.59.458 6.097.154 4.418-.459 2.592-.153-1.068-1.22 1.829-.458 2.286-.458 4.115-3.197s3.201-5.489 3.811-6.251c.61-.76 1.828-3.353 1.828-3.353l5.181-5.334 1.98-.762 4.573-2.285h4.726l1.222 1.373 1.98.305 1.828 2.285.914 6.25-2.896 1.98h-2.436l-1.676-1.067-.459.914-1.981-.456zM859.741 387.068s.359-.716.719-.716c.359 0 1.165-.088 1.165-.088l.089-4.662s-.627-.356-.718-.716c-.089-.357-.089-2.06-.089-2.06l-.626-.628-.09-18.819-1.793-4.838-1.523-2.598-1.254-.987-1.972-.177-2.24 1.434-1.345.716-2.868-.625-1.074-.719-1.705-.087-1.523-2.778-3.135-.987-1.433-.447-4.301-.36-1.254-.09-1.615 1.077-1.882 2.24-1.343 2.597-.178 4.214.985 1.344v1.97l.449.806v1.703l-1.434-1.703-1.434-3.494-.717-2.15-.627.896.178 2.868.09 2.328.807 2.153.806 3.044 1.344 3.853 1.075 4.125.987 3.94 1.881 3.585 1.613 2.24 3.675 3.674 2.329 1.612 3.584 1.257 4.032-.088 1.253-.9-1.613-1.521s-.267-.984-.267-1.344.536-2.152.536-2.152l1.703-1.793 4.928-.895 1.703 1.255 2.24 2.51 1.882.981zM913.682 313.831v2.552l1.53-.34-.338-2.212h-1.192zM916.234 313.151v2.041h1.022v-2.211l-1.022.17zM918.448 312.98l.17 1.87 1.7-.338-.17-2.212-1.7.68zM921.848 311.62v2.554h1.022l.34-2.554h-1.362zM924.743 311.11v2.213l1.36.17-.34-2.382h-1.02zM927.466 310.429v2.551l1.36.17v-2.211l-1.36-.51zM930.187 309.577l-.511 2.892h1.532l-.171-2.212-.85-.68zM932.228 309.577v2.383l2.213-1.022-.342-2.554-1.871 1.193z'/%3E %3C/g%3E %3Cpath fill='%2376401b' d='M890.046 266.598l-1.488 4.463 5.125-.827-3.637-3.636z' stroke='none'/%3E %3Cg fill='%23784421'%3E %3Cpath d='M932.194 351.556l-4.792 1.325-3.306 2.645-4.298 4.461-3.472 6.282-3.966 4.794-7.274 2.974-6.612.167-5.124-1.486-1.818-2.813-.496-3.635-.66-4.464-1.489-2.809-2.313-2.811-2.645-1.818 2.811-11.902.826-2.645v-3.471l.496-4.626 2.479-4.133 2.479-2.314 4.297-1.983 7.602-1.983 7.605-2.479 7.934-1.818 8.926-2.15 3.801-.33-.33 4.96.993 1.818-.167 12.892-.826 11.406-.661 5.946zM934.014 351.391l4.627.992 3.636 2.15 1.487 2.148 1.984-1.653.825-2.811 3.472-1.982 5.29-4.628-4.465-6.778-2.314-3.306-3.14-3.634-3.802-6.942-4.298-9.423h-2.314l-.33 18.677.166 6.776-.824 10.414z'/%3E %3Cpath fill='%23a05a2c' d='M886.904 279.325l.167 3.472 14.215-4.463v-1.323l-14.382 2.314z'/%3E %3C/g%3E %3Cg fill='none'%3E %3Cpath d='M846.526 359.353l.64 3.21 2.14 3.852 4.064 3.528-3.423-2.46 2.567 3.424-4.384-2.78 4.277 2.78-4.493-6.42-1.388-5.134zM841.285 373.577l-1.604 1.711-2.782-.427.107 3.53 3.85 5.67-3.85-5.347.108-3.635 2.675.21 1.496-1.712zM836.686 383.419l-.856-2.461v-2.78l.856 5.241z'/%3E %3C/g%3E %3Cg fill='%23666'%3E %3Cpath d='M887.275 369.728l-1.283 1.282-2.138.536s-2.139-.214-2.567-.536c-.427-.32-2.782-1.71-2.782-1.71l2.782 1.496h4.919l1.069-1.068zM890.698 374.756l.534 3.102 2.138 3.74 1.39 1.82-4.062-8.662z'/%3E %3Cpath fill='gray' d='M898.078 383.525l-2.034-.638-1.818-1.715-2.567-4.596 2.674 3.422 3.745 3.527z'/%3E %3Cpath stroke-width='.137' d='M880.217 371.011l.322 9.091.855 3.53 1.28 2.567 1.714 2.675.427-1.069 1.818 1.283.537-.537-1.82-1.816-1.819-2.462-1.071-2.566-1.175-4.385-.427-4.705h1.495l-.427-.856-1.709-.75z'/%3E %3Cpath fill='gray' stroke-width='.137' d='M920.644 385.344l3.422-.32 3.21-2.675.534-1.82 1.497-1.071-.214 3.103.748 1.606 2.031.642 1.283 1.175 2.248.214 3.207-2.03 2.354-2.461 2.032-1.82 1.497-.641.535-2.994h.962l.214-1.392-.427-2.672-.963-2.568-1.282-1.71-2.14-1.926-.961.429 2.352 2.245 1.925 2.46.106 3.85-.534 1.497-2.888 3.317-3.743 4.063-1.818.856-3.85-.533-1.391-1.82-.32-1.282-.43-1.283v-1.497l.536-1.07-3.956 4.49-1.605.106-4.171 3.532z'/%3E %3Cpath fill='gray' stroke-width='.228' d='M972.088 357.323l.856-.749.962 1.392.216 3.849.106.108v2.566l-1.496 2.782-3.21 3.422-3.742 1.602-3.424.428-2.353-.532-.856-1.392-.534-1.39v-3.207l.642-1.284.214.64-.107 3.531 1.175 1.39 2.46.747 2.245-.746 2.675-.75 2.245-1.283.108-.749-.856-.107.214-.32h1.283l1.604-3.21.534-2.675v-2.138l-.64-.641-.322-.534v-.75z'/%3E %3Cpath d='M887.381 406.842l-5.348 2.567-4.92 1.496-2.674-.427 5.24 1.925 2.033-1.603 3.208-1.606 2.461-2.352z'/%3E %3Cpath fill='%23999' stroke-width='.183' d='M891.553 417.643l2.887.856 1.39.536 2.995.427-2.246 1.389 2.886.64s-2.778.323-3.207.323-1.926.961-1.926.961-.32 1.715.642 1.606c.965-.108 2.352-.323 2.887-.323s2.247.323 2.247.323l1.07.856-.642.964-4.493.106.644.536h3.636l-3.528 2.352 4.275-.109 3.423 1.392v.856l-3.315.75-.749-1.287-4.278 1.178-.855 1.07-1.605-1.07 1.283-2.78-.107-2.888-.642-2.248-1.496-3.313-1.176-3.103z'/%3E %3C/g%3E %3Cg fill='%23e2d67e'%3E %3Cpath fill='%23e4cb5e' stroke-width='.228' d='M868.889 274.852l-3.445.416-2.436.298-1.605.952-1.306-.774-.773.475-2.911-1.545-3.388 1.844-1.604 1.424h-1.008l-.774-1.01-1.545 1.072-.891-.892-.95-.534-6.417 4.634-2.317-.773-1.01.892-.418.356-.236 1.01-.952-2.498-.83.594-1.426-.475-1.01 1.427-.238 3.743.594 4.693 1.546 5.17 1.425 2.138 1.188.237.357-1.485.654 2.792.95.95.298 5.05 3.862 8.675.356 4.456.178 7.723-1.426 1.725-1.84 2.793.058.829-1.9 3.625.117 5.526.418.475.12 5.288 1.484.118 1.188 1.307 2.615-.236v-1.605l.356 1.841 2.079 2.735 1.783 1.424 1.246.06.654-.95-.06-5.941.416 6.535 1.307-.06 1.665-1.484 2.199-.298.713.06s.594.356.891.89c.297.534 1.367 1.012 1.367 1.012l.773 1.604.95.357.475-1.012-.652-12.655-.654-10.337-.713-13.129-.714-16.757-.119-5.346-.832-.713.06-1.723 2.021-.594 1.187-.356-.535-1.603-.593-5.348v-2.02l.714-.593 1.426-.059 1.01 1.188 1.96 8.138 1.011.357 3.564-.06 8.081 12.775 2.851 4.278 3.922 7.307 5.11 7.308 1.605 2.138 1.07.121.356-7.784 2.26-1.96-1.903-13.428-1.544-.296-2.139-1.96-1.188.177-1.188 1.96-1.484-1.663-.18-1.902-1.367-.889h-1.008l-1.309-1.782-.712-.18-.831.773-.179-6.059-1.307-2.851-.237-1.723-2.436-3.447-2.554-.594s-1.128-2.556-1.128-2.912-.478-1.604-.478-1.604l-1.79-1.846z'/%3E %3Cpath fill='%23dcc56a' d='M871.027 356.128l-1.722-2.197-.594-2.317-.238-4.991-.534-4.755-.951-7.366-1.545-9.09-1.246-7.367-.477-4.337-1.009-5.11-.416-3.506-.417-2.911-.356-4.158 1.188 3.743 1.962 8.733 2.196 6.06.891 4.1v2.317l1.546 3.325 1.01 4.22 2.079 8.911 2.198 7.31 1.128 5.286.178 2.02-2.317.774-1.128.533-1.426.773z'/%3E %3Cpath fill='%23e2cc75' d='M882.613 354.348l1.25-6.001 1.485-4.575.653-3.09.475-2.494-.12-3.743-1.01-2.199-4.633-9.327-2.793-5.644-1.13-2.912-2.078-3.625-2.792-5.823-2.496-4.335-2.079-3.566-1.96-2.616-.593.537 1.78 6.654 1.485 5.702 1.427 6.298 2.376 8.258 1.367 5.705 1.366 3.505 1.307 4.931 3.624 11.765.714 3.089 1.783 3.566.592-.06z'/%3E %3Cpath fill='%23ddd690' d='M863.999 357.562l-1.873 1.87.17.682h2.212l.683-1.532-1.192-1.02zM861.785 355.008l.34 2.042 1.532-.17.85-1.53-.17-1.192-1.53.341-1.022.509zM865.528 354.158l.511 1.36h2.893v-1.02l-1.19-.51-2.214.17zM865.19 351.607l.168 1.53h2.044l1.02-1.363-1.19-1.02-2.042.853zM861.104 352.116l-.34 1.022 1.022.51 2.214-.51v-.852l-2.896-.17zM861.104 349.564v1.192l2.213.17.681-1.021-.852-.68-2.042.339zM865.528 348.544l-.337 1.02 2.04.511 1.02-.85-1.529-1.023-1.194.342zM861.276 345.821l-.34 1.531 1.36.17 1.192-.85.17-1.19-1.362-.172-1.02.511zM865.019 345.14v1.53l2.213.509v-2.212l-1.021-.338-1.192.511zM862.976 342.587h-2.041l-.173 2.38 2.383-1.02-.169-1.36zM864.677 341.906l-.85 1.702h2.382l1.022-2.21-1.362-.342-1.192.85zM864.167 339.014l.173 1.362 2.213-.34-.854-1.701-1.532.679zM861.955 339.526l-1.53-.34.172 1.872 2.211-.34-.853-1.192zM860.425 336.462l-.17 1.703h2.722l-.51-1.703h-2.042zM863.658 335.611v2.042h2.552l-.512-2.042h-2.04zM862.296 334.08l-1.7 2.04-.682-1.7 1.19-2.043 1.192 1.703zM863.827 332.548l-.34 1.703h2.21v-1.703l-.848-.51-1.022.51zM861.104 330.508h-1.19l-.17 1.362h2.04l-.68-1.362z'/%3E %3Cpath d='M863.488 329.996l-.34 1.531h1.702v-1.531h-1.362zM862.976 326.933l-.34 1.53h2.381l.173-1.36-2.214-.17zM860.255 327.614l-.34 2.212 2.04-.849v-1.191l-1.7-.172zM860.084 324.552l-.68 1.36 1.02.512.853-1.192-.341-1.02-.852.34zM862.894 323.405l-.538 1.128.882 1.52 1.227-.295.051-1.717-1.376-.688-.246.052zM860 321.684l-.444 1.228.884.784s.735-.292.735-.54c0-.244.246-1.03.246-1.03l-.98-.59-.441.148zM862.356 321.047l-.295 1.375.687.442 1.227.098s.049-.933.049-1.277c0-.342-.884-.735-.884-.735l-.784.097zM859.754 319.181l-.1 1.374 1.032.246s.54-.538.54-.734c0-.196-.492-1.08-.492-1.08l-.98.194zM862.061 318.788l-.197 1.13s.394.538.885.538c.49 0 .686-.49.686-.685 0-.198-.197-1.032-.197-1.032l-1.177.049zM859.655 317.267l-.342 1.13.98.44.737-.98-.786-.538-.589-.052zM861.962 316.58l-.146 1.03s.685.49.932.343c.246-.147.539-.784.539-.784l-.885-.589h-.44zM858.968 314.371l-.245 1.276s.735.687.931.59c.198-.1 1.228-.394 1.228-.394l-.54-1.275s-.637-.148-.833-.148c-.197 0-.59 0-.541-.049zM861.521 313.733l-.293 1.226 1.667.296s.246-1.376-.096-1.376c-.347.001-1.18-.097-1.278-.146zM859.116 312.065l-.294.737.833.637.687-.391-.442-.934-.784-.049zM861.618 311.574l-.636.983 1.03.439.882-.685-1.276-.737zM859.165 309.415l-.442.737.491.783.786-.638-.835-.882zM860.932 308.924l-.392.54.589.784.98-.54.099-.44-.442-.54-.834.196zM858.919 307.402l-.442 1.03.98.54.543-.686-.345-.786-.736-.098zM860.784 306.42l-.54.689.737.735.931-.54-.636-.786-.492-.098zM858.919 305.683h-.392v.834l1.128-.098-.197-.834-.539.098zM860.441 304.702l-.05.932 1.03-.147-.049-.833-.931.048zM858.674 303.967l-.342.49.587.786.59-.542s.196-.734 0-.734h-.835zM858.772 302.347l-.44.392.538.54.687-.343-.785-.589zM858.919 301.121l-.54.784h.934l-.394-.784zM860.146 301.561l.098.786h.786l-.884-.786zM860.195 302.838s-.194 1.03 0 1.03c.197 0 .737-.148.737-.148l-.737-.882z'/%3E %3Cpath fill='%23d3c55f' d='M886.307 326.544l-1.078 1.472.098 1.523 1.424 1.325 1.325-1.866-1.769-2.454z'/%3E %3Cpath fill='%23d3c75f' d='M888.222 324.432l-1.325 1.916 1.276 2.013 1.325-.833s.196-1.672-.05-1.967c-.246-.293-1.275-1.178-1.226-1.129z'/%3E %3Cpath d='M885.767 321.733s-.588.883-.588 1.081c0 .196.344 1.618.344 1.618l.834 1.081s.93-.295 1.029-.59c.098-.292.443-1.424.443-1.424l-1.128-1.473-.934-.293z'/%3E %3Cpath fill='%23d3c95f' d='M883.706 323.844l-.246.49s-.145 1.18.148 1.375c.294.197 1.177 1.13 1.177 1.13s.783-.49.783-.737-.588-1.768-.588-1.768l-.685-.686-.589.196z'/%3E %3Cpath d='M881.693 320.458l-.391.931.49 1.277.933.932s1.03-.194 1.03-.393v-1.374l-.64-1.079-1.079-.49-.343.196zM883.902 319.574l-.245.736s.099 1.032.294 1.128l.982.492.685-1.13-.685-1.423-1.031.197zM882.824 317.22l-.492 1.079.295.783.688.345s.783-.393.783-.59v-1.029l-.882-.541-.392-.047zM880.565 318.004l-.637.834.246 1.032 1.079.343.735-.884-.59-1.177-.833-.148zM879.728 315.794l-.538.49v.64l.834.639.784-.394-.196-.884-.39-.59-.494.099zM881.89 315.157l-.344.785.49 1.03.788-.441-.15-.884-.784-.49zM880.417 313.048l-.194 1.766 1.225-.196.295-.932-.44-.688-.886.05zM879.14 313.439c-.196.048-.882.098-.882.098l.197 1.766.783-.096.296-.639-.099-.785-.295-.344zM877.669 311.672l-.588.737.588.98.54-.098.342-.735-.882-.884zM879.581 311.179l-.49.541.394.59.49.049.49-.59-.44-.538-.444-.052zM876.442 309.906l-.344.931.933.246.244-.589-.293-.541-.54-.047zM878.062 309.415l-.097 1.079 1.03-.099-.099-.882-.834-.098zM875.264 308.188l.05.931h1.029s.344-1.079-.099-1.03c-.441.05-.882.146-.98.099zM877.228 307.745v.932l1.079-.147-.245-.833-.834.048zM875.803 306.764h-1.079l.148.932.98-.098-.049-.834zM876.491 306.125l-.148.884 1.13-.049v-.835h-.982zM875.412 304.702l-.05 1.03s1.227.196 1.227 0-.246-.882-.246-.882l-.931-.148zM874.724 304.8h-.982l.1 1.128h1.177l.147-.784-.442-.344zM872.418 301.463l-.492.49 1.523 2.406h.931l-.882-1.227s.146-.588-.098-.685c-.244-.098-.44-.098-.44-.098l-.542-.886z'/%3E %3Cpath d='M872.612 300.53l-.342.442 1.817 1.226v1.03l.834.786.685.194-.244-.833-.343-.931-.689-.541-.488-.882s-.246-.05-.443-.099c-.194-.049-.391-.344-.391-.344l-.396-.048z'/%3E %3C/g%3E %3Cg fill='none'%3E %3Cpath fill='%23000' d='M851.578 283.375l-.173 7.996.511 2.552v4.426l.17 6.806v4.594l-3.914-4.767 4.084 5.106.68 4.933 1.023 1.874-.68 2.552.17 4.253v12.08l-3.915-9.528.341 19.738.341-11.399 1.362-2.044 2.212 5.618.34 2.552-.512-9.53'/%3E %3Cpath d='M835.582 282.694l-.68 5.106 1.362 3.571.171 4.936-.171-5.445-1.362-2.722.68-5.446zM840.517 285.757v6.466l1.19 1.53-.338 6.807 1.02 2.041v11.23M847.492 278.101l-1.36 2.551.51 4.595.34 3.233-.51 5.102M878.462 290.52l-.173 7.828.851 4.252.682 4.594M885.776 301.921l1.531 17.016M842.047 327.275l.34 9.869.681 4.255.17 4.592'/%3E %3C/g%3E %3Cg fill='%23d38d5f'%3E %3Cpath d='M893.264 345.481v-1.703l7.487-1.703-1.192.852.17 5.105M913.682 341.226v-2.213l7.487-1.36-1.703.34.34 5.274M897.518 357.731v-1.703l6.296-1.189-.171 6.295M912.491 355.35v-2.724l6.805-1.19.341 5.953M890.372 333.059v4.254l-1.531.34v-2.042l1.531-2.552zM893.946 332.377l.17 4.255h-1.192l-.34-3.744 1.362-.511zM896.665 331.528l-1.19.68v3.402l1.704-.34-.514-3.742zM899.9 330.337l-1.192 1.021v3.063l1.871-.17-.679-3.914zM903.643 329.485l-1.703.68v3.404l1.875-.34-.172-3.744zM907.217 328.464l-1.531.172v4.254l1.873-.341-.342-4.085zM911.81 327.614l-1.7.68.17 2.891 1.7-.509-.17-3.062zM916.064 326.424l-1.7.85v2.893h1.53l.17-3.743zM919.468 325.402l-1.362.68v3.233h1.703l-.341-3.913zM923.21 325.063l-1.362.85v2.55h1.874l-.512-3.4zM927.295 323.7l-1.532.682.171 2.55 1.531-.339-.17-2.893zM931.718 322.679l-1.702.85v2.724l2.044-.17-.342-3.404z'/%3E %3C/g%3E %3Cg stroke-width='.913'%3E %3Cpath fill='%23fffcfc' d='M891.564 368.79l26.371-5.954'/%3E %3Cpath fill='%23c87137' d='M885.096 352.285l2.725.34 44.919-10.209'/%3E %3Cpath fill='%23c87137' stroke-width='.867' d='M887.65 340.717l6.976-1.024 38.794-10.208'/%3E %3Cpath fill='none' stroke-width='1.187' d='M935.122 327.955l6.635-1.192'/%3E %3Cpath fill='%23fffcfc' stroke-width='1.324' d='M935.122 341.906l14.633-3.912'/%3E %3C/g%3E %3C/g%3E %3Cpath fill='none' stroke='%23000' stroke-width='8.216' d='M767.32 145.154v253.639c3.002 36.316 78.686 59.178 131.454 97.748 69.212-46.422 136.34-55.812 139.039-107.858l.842-243.529h-271.33z'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 1440 720'%3E %3Crect width='1440' height='720' fill='%23f7e017'/%3E %3Cpath d='M0,50V370L1440,520V350z' fill='%23fff'/%3E %3Cpath d='M0,220V370L1440,670V520z' fill='%23000'/%3E %3Cg fill='%23cf1126'%3E %3Cpath d='M695.74,569.72c-19.36-2.57-37.11-8.73-49.44-17.17-2.39-1.64-4.64-2.98-4.99-2.98-0.36,0-0.65,1.82-0.65,4.07,0,6.37-2.56,9.58-9,11.25-6.16,1.6-15.56-1.63-23.18-7.95-7.89-6.55-17-11.55-24.71-13.55-6.35-1.66-14.78-1.39-20.87,0.65-2.83,0.95-6.05,2.29-7.17,2.98-1.11,0.69-2.36,1.25-2.76,1.25-1.08,0-0.93-6.85,0.2-9.04,1.49-2.87,5.16-5.7,9.44-7.26,2.16-0.79,3.93-1.8,3.93-2.25s-0.73-2.1-1.62-3.65c-2.9-5.08-1.71-10,3.35-13.87,5.18-3.96,13.95-4.64,21.7-1.69,1.95,0.74,3.77,1.35,4.04,1.35,1.02,0,0.4-1.43-2.41-5.52-3.24-4.74-3.88-7.08-3.48-12.72,0.52-7.14,6.34-12.98,13.47-13.5,5.82-0.42,9.44,1.54,18.03,9.72,25.65,24.46,53.54,37.94,86.07,41.59,8.21,0.92,24.73,0.43,34.42-1.03,29.27-4.41,58.76-19.13,81.79-40.82,6.38-6.01,9.45-7.6,14.68-7.62,4.55-0.02,7.74,1.45,11,5.05,2.97,3.3,3.98,6.43,3.66,11.44-0.21,3.21-0.73,4.79-2.64,7.9-2.82,4.59-2.34,5.01,3.24,2.85,7.54-2.94,16.83-1.58,21.84,3.18,4.41,4.19,4.83,8.38,1.4,14.06-1.25,2.08-2.27,4.03-2.27,4.34,0,0.57,0.95,0.84,5.53,1.58,5.99,0.96,9.42,5.41,9.42,12.21,0,2.04-0.25,3.7-0.56,3.7-0.3,0-2.57-0.83-5.04-1.85-6.98-2.88-10.95-3.62-19.11-3.57-6.21,0.04-8.35,0.33-12.68,1.74-6.63,2.17-13.72,6.35-19.5,11.5-6.37,5.68-10.38,7.47-16.58,7.42-5.76-0.06-9.7-1.73-11.78-5.02-1.11-1.76-1.27-2.83-1-6.81,0.18-2.59,0.14-4.71-0.07-4.71-0.22,0-2.46,1.42-4.99,3.17-6.64,4.56-10.87,6.82-18.47,9.83-23.18,9.17-56.63,13.14-82.24,9.75z'/%3E %3Cpath d='m706.34,525.17c-38.58-3.7033-75.494-23.798-97.939-55.657-24.37-33.235-32.05-77.117-24.611-117.24,3.9535-18.267,11.929-36.546,25.544-49.554-10.85,23.003-14.516,49.369-8.7299,74.29,8.989,49.753,51.036,91.87,101.34,99.156,19.9,5.761,40.487-0.32356,59.496-6.4934,41.935-14.779,73.879-54.583,77.777-99.079,3.3363-24.078-0.36023-49.114-11.207-70.916,6.1825,3.2692,13.987,16.087,18.589,24.707,16.003,31.003,16.734,68.155,7.3126,101.24-12.78,42.097-44.965,78.978-87.511,92.382-19.308,6.3081-39.842,8.2315-60.058,7.1679z'/%3E %3Cg id='hand'%3E %3Cpath d='m512.02,469.9c-2.5284-0.39577-5.3161,2.092-4.3628,4.6971,1.823,2.633,4.9641,3.9201,7.798,5.1795,6.7915,2.7224,14.179,3.7823,21.471,3.6055-2.5133-0.006,0.86258,0.026,1.8015-0.00068,5.774,0.0171,11.516-1.0234,16.944-2.98,3.018-1.0614,6.8641-2.0244,8.1009-5.3629,1.2069-2.1744-0.98008-4.3462-3.1859-3.9108-3.0714,0.67078-5.9433,2.064-8.9896,2.8576-6.5725,1.8534-13.494,2.5704-20.303,2.0116-4.9792-0.60782-9.8039-2.2005-14.41-4.1433-1.5972-0.70457-3.0962-1.7322-4.8648-1.9536z'/%3E %3Cpath d='m514.83,459.52c-2.5558-0.38057-4.7577,2.5607-3.6917,4.9076,1.965,2.8484,5.2671,4.3651,8.356,5.6992,5.3706,2.1486,11.204,3.0471,16.975,2.8752-2.1917-0.006,0.75258,0.026,1.5651-0.00068,4.9069,0.006,9.7882-0.96448,14.325-2.8311,2.7732-1.0787,6.1693-2.1246,7.3241-5.177,0.89621-1.6768,0.21293-4.1165-1.8997-4.2476-1.9288-0.0953-3.5928,1.1322-5.3782,1.6831-6.4849,2.6815-13.622,3.8183-20.614,3.2146-4.3567-0.56071-8.519-2.1681-12.47-4.0312-1.4847-0.71699-2.8205-1.8356-4.4909-2.092z'/%3E %3Cpath d='m518.28,449.57c-2.1908-0.26295-3.6978,2.2088-3.3288,4.1816,0.32687,1.7334,1.8824,2.8984,3.1689,3.9607,5.3292,3.8973,12.083,5.5573,18.626,5.3398-2.5415-0.009,3.4093,0.0418,1.5947-0.007,4.1442-0.0169,8.2378-1.0309,11.966-2.825,2.4889-1.0824,5.4115-2.3356,6.2502-5.1771,0.40122-1.3236,0.65233-3.227-0.84101-3.97-1.5638-0.87412-3.1169,0.47031-4.5388,1.0156-4.7891,2.4374-10.125,3.7932-15.507,3.7682-4.6507,0.15705-9.0334-1.799-13.068-3.9072-1.464-0.74578-2.6708-2.0422-4.3214-2.3798z'/%3E %3Cpath d='m481.53,302.7c-3.2575,3.2606-0.7701,9.2712-0.94626,13.543,1.6879,13.158,3.785,26.484,8.697,38.87,6.015,12.102,18.791,18.573,26.533,29.268,2.7675,5.155,1.7849,11.355,2.3681,16.994,0.45808,15.366,0.31593,30.743,0.047,46.111,6.9387,3.4817,14.474,6.9863,22.456,5.6471,4.7306-1.13,13.512-1.8326,14.496-6.5436-0.38235-26.5-0.6304-53.01-0.98289-79.506-2.6903-8.1185-10.951-12.32-17.129-17.514-5.0992-5.0259-9.844-10.435-14.188-16.099-2.6218-4.4175-12.868-6.0092-9.1612,1.6764,2.1735,6.6538,7.7204,11.61,9.1091,18.602,0.30342,3.8316,4.8776,10.879,0.97314,13.114-2.4837-4.2216-6.0823-7.815-10.682-9.9574-4.4324-3.3044-11.759-4.68-13.359-10.517-1.1745-8.2799-5.4152-15.782-10.887-21.986,1.4102-7.4368,0.005-16.737-6.4234-21.49l-0.92101-0.21254-0.00013-0.00002z'/%3E %3Cpath d='m491.44,304.19c-2.9629,0.47847-2.8621,4.2538-1.491,6.239,1.4583,4.2881,1.8554,8.9449,1.0659,13.409,5.2675,6.1665,9.3467,13.543,10.576,21.64,0.0299,3.0437,3.2327,4.0512,5.309,5.5551,4.8712,3.1016,10.348,5.3512,14.686,9.2326,0.91286,0.97602,1.6017,2.0271,0.9566,0.035-0.67695-2.5463-1.0251-5.3576-3.0207-7.2849-2.7345-2.939-6.15-5.5628-10.133-6.4593-0.33199-4.114-2.2913-7.8931-4.1017-11.532-2.0066-3.4792-4.1026-7.2065-7.5407-9.4626,0.13834-6.098,0.0385-12.495-2.5857-18.122-0.7696-1.4455-1.9032-3.163-3.7197-3.2499z'/%3E %3Cpath d='m499.73,306.62c-2.0642,0.61274-1.6695,3.1587-1.0158,4.7165,0.98881,4.3156,1.1436,8.7732,1.063,13.184,3.7911,3.0003,6.1624,7.3501,8.3216,11.586,1.3534,2.8304,2.6366,5.7518,3.1556,8.8651,3.0757,1.0188,5.7672,2.946,8.171,5.0773-0.95256-2.8824-3.0766-5.1129-4.5042-7.7441-1.5516-2.7372-3.0336-5.5913-3.6904-8.6923-2.9581-3.1576-4.5872-7.6305-3.9408-11.952,0.13267-4.7762-1.4093-9.7114-4.6059-13.311-0.8049-0.79276-1.7658-1.6692-2.954-1.7296z'/%3E %3Cpath d='m509.16,307.97c-1.1224,0.1984-1.8054,1.2662-2.4064,2.1373-0.23225,0.87316,0.83776,1.8114,1.0081,2.7596,1.3127,3.2919,1.8084,6.903,1.4162,10.426-0.0864,2.5018,0.80881,4.9458,2.0839,7.0649,0.36793-1.5628,1.8164-2.6864,3.3865-2.8406,0.57114-0.10043,1.4107,0.18835,1.0779-0.68251-0.39881-4.7853-1.128-9.5978-2.8007-14.119-0.64833-1.615-1.3844-3.3147-2.7835-4.4203-0.28367-0.20186-0.62304-0.3745-0.98205-0.32512z'/%3E %3C/g%3E %3Cuse xlink:href='%23hand' transform='matrix(-1,0,0,1,1440,0)'/%3E %3Cpath d='m715.67,475.98c-13.493-1.2846-25.667-11.12-29.829-24,0.22423-2.2187,2.9867,1.2413,4.2917,1.4741,2.4503,1.3606,5.0998,2.4802,7.9211,2.6539,3.5571,1.529,5.7565,5.0346,9.1516,6.8629,1.5764,1.2278,7.1544,3.641,6.1182-0.26421-1.307-2.04-2.2057-4.6242-1.0806-6.9613,1.8918-4.1503,4.8018-7.7638,7.7306-11.226,2.1527-0.71996,3.5939,3.5262,5.1338,4.9568,2.1308,3.2786,4.7004,7.2793,3.447,11.352-1.2198,1.5087-2.0216,6.0472,1.2409,4.5219,4.0213-1.7692,7.3158-4.7418,10.651-7.5175,2.9183-2.0384,6.6539-2.1824,9.7125-3.9699,1.4177-0.35921,4.3706-3.1946,4.9861-1.6225-1.6759,4.4876-4.4822,8.5068-7.4822,12.211-4.8588,5.5503-11.432,9.7247-18.786,10.902-4.3459,0.79562-8.806,0.96352-13.207,0.62747z'/%3E %3Cpath d='m731.53,460.22c0.29719-2.7079-0.31965-5.4735-1.703-7.9349-2.123-4.3258-5.1213-8.1663-8.0456-11.961-2.7573-1.615-4.2871,3.6582-6.1205,5.1714-2.8566,4.2769-6.4434,8.6562-6.617,14.036-1.6071,2.5012-4.6044-2.0411-5.8962-3.5357-2.4673-3.4911-4.3356-7.6206-4.0297-11.987-0.29227-7.0356,1.0571-14.041,3.6204-20.581,1.9348-5.5826,5.0755-11.006,4.7564-17.105,0.22416-4.5905-0.70745-9.6582-4.4262-12.745-3.538-2.7758,2.2916-3.3674,4.1432-1.928,3.1686,0.21257,4.8825,5.4481,7.7771,4.152,1.1532-2.7346,1.3824-5.9968,3.7595-8.1295,2.3338-3.1959,4.773,1.3562,5.5715,3.488,1.6467,1.8723-0.0931,6.5066,2.5817,6.6282,3.2062-2.2473,5.4923-6.0227,9.5918-6.8447,1.6623-0.94835,4.5034-0.12664,2.3114,1.7848-3.0339,2.8443-5.6262,6.4002-6.1786,10.631-0.92788,5.3074,0.39912,10.69,2.7124,15.47,4.4468,9.3901,7.8854,19.996,5.6361,30.444-1.0432,4.644-4.1982,8.6454-8.0313,11.341-0.4847,0.29274-1.2499,0.27192-1.4134-0.39473z'/%3E %3Cpath d='m726.73,389.63c-1.4562-2.6239-3.2238-5.2103-5.673-6.9945-2.3812-0.005-3.8508,2.9985-5.468,4.5721-1.134,2.11-2.5118,5.6386-5.3053,2.8796-4.4442-2.5928-5.2306-8.2748-5.202-12.958-0.27951-7.5908,2.777-14.674,5.4923-21.587,1.7275-4.3277,1.3019-9.1991,0.24806-13.634-1.3266-5.0918-5.4137-8.6231-8.5601-12.595,0.214-1.5365,4.235-0.69686,5.7483-0.40478,3.3588,0.85136,5.3664,3.8249,7.8703,5.9259,1.7818-0.53937,1.0545-4.1395,1.8839-5.833,0.0613-2.3821,3.233-5.5228,4.5407-2.1121,1.9588,2.1674-0.0626,6.4643,2.4686,7.8144,2.4113-0.89283,3.6009-3.5283,5.8666-4.72,2.2295-1.5204,5.3776-1.69,7.7781-0.49647,0.84484,2.2126-2.6402,4.0548-3.6496,5.9771-4.052,5.0056-5.4756,11.91-3.7401,18.112,1.3759,4.8649,3.8133,9.4058,4.6546,14.434,1.0126,5.6525,0.97903,11.589-0.48403,17.159-0.87455,3.3816-3.8021,5.6402-6.8258,7.0448-0.74602-0.69428-1.1395-1.7142-1.6436-2.583z'/%3E %3Cpath d='M711.61,326.89c-3.36-2.46-4.47-4.81-4.47-9.46,0-2.38,0.44-3.67,2.01-5.83,2.31-3.2,1.89-4.21-1.38-3.27-5.26,1.51-7.77,0.13-7.95-4.35-0.08-2.19,0.38-3.12,3.33-6.66,2.36-2.84,3.22-4.33,2.75-4.8-0.46-0.46-3.25,1.96-8.98,7.79-4.57,4.65-9.71,9.4-11.42,10.56-9.84,6.64-19.24,7.67-23.53,2.56-2.2-2.61-2.08-4.08,0.46-5.66,1.17-0.72,3.14-2.38,4.39-3.69,2.95-3.07,11.74-9.41,16.1-11.61,3.54-1.79,4.38-3,2.08-3-2.98,0-12.54,6.22-19.79,12.88-2.13,1.97-5.2,4.16-6.81,4.87-3.62,1.6-10.73,2.19-13.89,1.15-2.23-0.74-6.3-4.58-6.3-5.95,0-0.36,0.93-1.16,2.06-1.77,1.13-0.6,3.16-2.07,4.5-3.24,5.8-5.09,16.79-10.33,25.51-12.16,2.77-0.58,1.75-1.98-1.34-1.84-5.99,0.26-17.88,5.83-24.98,11.69-8.32,6.86-20.87,6.21-24.91-1.29-0.7-1.29-1.11-2.5-0.91-2.69,0.19-0.19,2.66-0.93,5.49-1.65,3.06-0.77,9.12-3.28,14.91-6.17,9.11-4.54,11.81-5.51,18.08-6.52,2.82-0.45,2.97-1.83,0.23-2.15-3.53-0.42-8.94,1.35-18.5,6.05-12.28,6.04-15.72,7.08-22.19,6.7-5.9-0.36-9.23-1.87-14.02-6.4-3.13-2.97-7.57-10.51-6.7-11.38,0.21-0.21,1.65,0,3.2,0.45,1.72,0.51,6.65,0.85,12.59,0.86,8.31,0.02,10.52-0.2,14.95-1.48,7.41-2.14,17.26-7.15,24-12.18,12.89-9.64,23.4-13.51,36.8-13.57,12.37-0.05,20.24,2.81,27.21,9.88,2.36,2.39,4.37,3.94,4.7,3.61,0.31-0.31,0.65-4.49,0.75-9.29,0,0,3.64-0.35,4.41,0.67,0,7.79,0.09,8.4,1.22,8.4,0.74,0,1.53-0.76,2.02-1.94,1.06-2.55,4.98-6.04,9.17-8.16,9.05-4.59,24.71-4.73,37.29-0.34,5.3,1.86,11.18,5.18,16.78,9.5,5.62,4.32,17.11,10.1,23.9,12.03,6.87,1.95,18.98,2.44,25.19,1.03,2.56-0.58,4.96-1.06,5.34-1.06,2.29,0-1.61,7.63-6.19,12.1-8.37,8.18-19.26,8.14-34.58-0.12-9.55-5.14-20.97-7.95-20.97-5.15,0,0.58,0.6,0.97,1.49,0.97,3.32,0,9.73,2.23,18.67,6.47,9.67,4.6,15.1,6.54,18.32,6.54,2.34,0,2.41,1.45,0.23,4.65-2.31,3.41-6.23,5.1-11.77,5.09-5.29-0.02-8.23-1.18-12.96-5.11-7.91-6.58-27.62-13.92-26.86-10,0.15,0.78,1.1,1.26,3.13,1.57,6.86,1.05,14.91,4.89,23.15,11.06,2.54,1.91,5.18,3.79,5.85,4.19,1.13,0.66,1.15,0.86,0.26,2.53-1.48,2.76-5.21,4.9-9.25,5.32-5.23,0.54-9.78-1.02-14.49-4.96-9.94-8.32-19.31-14.34-22.31-14.34-2.45,0-1.35,1.35,2.97,3.64,5.68,3.01,11.52,7.08,15.82,11.03,2.03,1.88,4.32,3.74,5.08,4.15,1.8,0.96,1.73,2.37-0.25,4.96-2.02,2.64-5.36,3.8-9.69,3.34-8.64-0.91-15.38-5.08-25.97-16.07-4.14-4.29-7.83-7.8-8.21-7.8-1.41,0-0.58,1.91,2.15,4.97,3.38,3.78,4.03,5.91,2.75,8.98-1.13,2.72-3.01,3.35-6.87,2.31-3.95-1.07-4.57-0.1-1.98,3.12,3.86,4.81,3.29,10.7-1.44,14.75-1.47,1.25-3.01,2.28-3.43,2.28-0.41,0-1.45-1.07-2.32-2.38-3.04-4.62-5.71-4.59-8.67,0.08-1.03,1.63-1.9,2.95-1.93,2.94-0.04-0.01-1.43-1.01-3.08-2.23z'/%3E %3Cpath d='M726.67,233.03,721.54,237.09,716.94,233.62,716.94,261.36,726.67,261.48z'/%3E %3Cpath d='M694.89,204.25c-1.02,13.11-4.35,22.26-8.98,32.35l11.1-10.29,7.72,9.17,8.36-9.33,8.53,7.88,8.2-8.2,8.52,9.97,7.4-8.2,12.54,9c-4.55-10.09-10.71-18.64-9.94-32.84-12.15,9.03-41.02,10.66-53.45,0.49z'/%3E %3Cpath d='M716.95,197.56c-4.46,0.08-9.16,0.14-13.39,0.97-2.93,0.58-5.59,1.53-7.81,3.1,0.36,8.53,41,12.09,51.9,0.16-2.29-1.67-5.09-2.66-8.17-3.26-4.07-0.79-8.57-0.87-12.84-0.94,0,2.34,0.02,4.69,0.02,7.04l-9.71-0.03v-7.04z'/%3E %3Cpath d='M724.9,153.97,718.59,154.02,718.59,203.4,725.03,203.43z'/%3E %3Cpath d='M724.89,155.24,722.48,178.88,746.8,190.76,734.49,174.3,751.3,168.85z'/%3E %3Cpath d='M722.18,149.08c-3.69,0-6.42,1.38-6.42,3.02s2.73,3.03,6.42,3.03,6.4-1.39,6.4-3.03-2.71-3.02-6.4-3.02z'/%3E %3C/g%3E %3Cg fill='%23f7e017'%3E %3Cpath d='M711.05,563.82c3.99-1.32,6.26-3.74,7.89-8.4,0.81-2.32,1.36-4.73,1.22-5.36-0.34-1.49-2.06-1.41-3.96,0.17-1.3,1.09-1.46,1.64-1.09,3.86,0.95,5.6-1.04,6.99-11.64,8.13-1.05,0.11-4.09-0.07-6.77-0.4-5.04-0.63-6.84-0.13-5.01,1.39,0.55,0.46,1.95,1.08,3.11,1.37,2.83,0.73,13.22,0.24,16.25-0.76z'/%3E %3Cpath d='M733.02,562.89c0.6-0.55,2.66-1.5,4.58-2.12,2.56-0.82,3.88-1.7,4.96-3.31,3.11-4.63,2.53-8.62-2.04-14-2.48-2.92-3.58-2.84-5.56,0.4-1.71,2.8-1.67,2.98,0.79,3.62,1.29,0.33,2.53,1.28,3.21,2.45,2.68,4.64,1.89,7.51-2.08,7.54-3.6,0.03-4.59,0.54-5.56,2.87-0.51,1.21-0.92,2.5-0.92,2.87,0,0.98,1.36,0.81,2.62-0.32z'/%3E %3Cpath d='M725.81,557.65c0.68-1.84,0.92-5.15,0.84-11.9-0.05-5.14-0.25-9.5-0.45-9.7-0.6-0.6-3.56,1.31-3.95,2.54-0.2,0.64,0.13,2.12,0.73,3.28,0.92,1.79,1.04,3.46,0.76,10.47-0.36,8.86,0.22,10.35,2.07,5.31z'/%3E %3Cpath d='M708.89,553.43c0.36-1.65,0.82-5.03,1.03-7.5s0.72-5.59,1.12-6.94c1.02-3.46-0.01-4.37-2.74-2.43l-2.03,1.45,0.42,4.97c0.39,4.48-0.32,12.83-1.35,16.07-0.28,0.86,0.12,0.64,1.25-0.68,0.91-1.06,1.95-3.29,2.3-4.94z'/%3E %3Cpath d='m693.88,555.84c3.6514-3.0546,3.2318-8.2704,4.04-12.52-0.0835-2.8248,1.8038-6.2116,0.58588-8.6828-3.4119,0.62408-5.5147,3.8554-3.7684,7.0746,0.14546,3.7382,0.0129,7.8076-1.9089,11.113-1.5698,2.1618-6.5419,1.6234-6.3131-1.4406,1.2477-4.6065-4.2718-2.3648-6.4264-1.1571-1.6657,1.1597-5.1825,1.2451-3.9601-1.6569-0.80663-3.8664-5.7798-1.4479-8.4816-1.4651-2.552-0.0466-0.21096-5.1708-3.8736-4.271-6.8058-0.53675-14.319,0.0602-20.21-4.0515-3.4486-1.6577-2.937-5.8052-1.1415-8.4888,2.1442-3.6651,2.7555-8.249,6.1588-11.093,3.369-3.231-3.1775-1.8666-4.6517-0.77788-3.2819,1.7962-0.23302,6.4226-2.9192,8.9886-1.5695,2.6611-3.6362,6.3361-7.2698,5.8296-5.2398-0.9908-8.2605-5.8651-12.017-9.1317-3.218-0.64222-1.4087,5.2218,0.25284,6.4543,3.2878,2.4618,7.1291,4.2558,11.092,5.3187,3.9439-0.63072,4.0717,4.5336,7.4444,5.3437,6.1873,2.883,13.083,3.7467,19.833,4.0986,2.6511,0.22107,1.16,4.9425,4.6458,4.0096,1.948,0.50493,6.3478-0.72487,6.5682,1.5381-2.9527,3.5059,2.8341,3.4276,4.9757,2.7999,2.742-0.41905,6.2461-1.4668,6.9708,2.2924,2.289,2.413,6.4921,2.057,9.2796,0.67619,0.39162-0.22691,0.75972-0.49483,1.0937-0.80043z'/%3E %3Cpath d='M634.12,525.57c1.11-1.41,2.77-4.26,3.69-6.34,0.91-2.09,2.28-4.46,3.03-5.27,1.76-1.9,0.78-3.07-2.06-2.44-1.5,0.33-2.11,0.88-2.36,2.18-0.85,4.24-2.39,8.58-3.76,10.6-2.48,3.66-2.54,3.81-1.52,3.81,0.53,0,1.87-1.14,2.98-2.54z'/%3E %3Cpath d='M596.66,502.09c-2.8,0-2.92,1.77-0.19,2.72,1.32,0.46,2.44,1.57,3.34,3.38,2.66,5.29,4.22,6.23,11.28,6.84l4.53,0.41,0.22,2.75c0.11,1.52,0.47,2.78,0.82,2.78s2.1-0.76,3.87-1.66c3.32-1.68,6.47-5.6,6.47-8.03,0-1.59-2.65-3.31-5.06-3.31-1.07,0-3.11,0.86-4.72,2.03-5.04,3.65-10.43,2.91-13.38-1.84-2.42-3.92-4.95-6.07-7.18-6.07zm24.46,9.75c1.34,0,1.67,0.99,0.94,2.88-0.5,1.3-2.13,1.34-2.62,0.06-0.58-1.51,0.23-2.94,1.68-2.94z'/%3E %3Cpath d='M810.84,505.69c-1.83,0.07-2.37,0.47-3.53,2.19-1.9,2.82-2.09,8.93-0.34,11.09,1.09,1.34,1.25,1.37,3.56,0.41,3.22-1.35,3.76-1.3,3.75,0.43-0.02,4.42-6.36,12.94-13,17.47-1.79,1.22-3.39,2.58-3.56,3.03-0.48,1.26,1.98,0.98,5-0.56,4.12-2.1,9.53-7.62,11.75-11.97,1.76-3.47,2.01-4.65,2.22-10.72,0.19-5.59,0.04-7.23-0.91-9.09-1.06-2.09-1.4-2.28-4.06-2.28-0.32,0-0.61-0.01-0.88,0zm0.22,3.9c1.38,0,1.62,0.31,1.78,2.29,0.14,1.64-0.15,2.64-1.06,3.46-1.24,1.12-1.34,1.11-2.44-0.56-1.54-2.36-0.59-5.19,1.72-5.19z'/%3E %3Cpath d='M780.7,552.27c5.85-2.88,9.3-6.12,11.52-10.81,1.05-2.23,1.91-4.33,1.91-4.69,0-0.81-2.88-2.15-4.61-2.15-1.72,0-2.07-1.19-1.33-4.48,0.72-3.21-0.15-7.23-1.56-7.23-0.51,0-1.41,0.75-2.01,1.66-0.92,1.41-0.97,2.01-0.29,4.06,1,3.04,0.21,5.31-2.51,7.25-1.29,0.92-2,1.98-2,3.01,0,0.87,0.11,1.58,0.24,1.58,0.14,0,1.56-0.74,3.16-1.63l2.92-1.63,1.72,1.35c0.94,0.74,1.72,1.95,1.72,2.69,0,3.56-10.15,9.54-17.12,10.1-3.71,0.3-4.34,0.17-5.63-1.11-1.05-1.05-1.35-1.93-1.09-3.17,0.2-0.95,0.56-2.68,0.8-3.84,0.64-3.1-0.69-2.68-2.99,0.94-1.89,2.99-2.45,6.18-1.39,7.86,0.87,1.37,6.65,2.68,10.74,2.43,2.57-0.15,5.11-0.87,7.8-2.19z'/%3E %3Cpath d='M819.74,530.49c3.68-3.67,5.24-8.14,5.26-15.05l0.01-5.19,3.04-1.44c3.95-1.88,7.69-5.62,7.69-7.7,0-2.14-0.95-2.03-2.67,0.3-1.25,1.69-2.92,2.71-9.03,5.52-1.54,0.71-1.64,1.09-1.99,7.55-0.41,7.45-1.42,10.24-5.58,15.33-2.55,3.1-2.64,3.51-0.87,3.51,0.73,0,2.59-1.27,4.14-2.83z'/%3E %3Cpath d='M779.66,526.33c0.35-1.07-1.68-1.83-2.56-0.96-0.37,0.37-0.47,1.01-0.22,1.42,0.58,0.93,2.42,0.62,2.78-0.46z'/%3E %3Cpath d='M834.93,512.02c0.36-1.07-1.68-1.83-2.55-0.96-0.38,0.38-0.48,1.02-0.23,1.43,0.58,0.93,2.42,0.62,2.78-0.47z'/%3E %3Cpath d='m768.41,473.28c-1.4296,0.68071-2.1713,2.2244-3.165,3.4028-0.71516,0.48622-0.14203,0.9405,0.26976,1.3988,2.5225,2.7171,3.5898,6.3866,4.7883,9.8088,1.177,4.0402,2.659,8.3784,1.4283,12.588-0.48423,1.6123-1.7525,3.2813-3.6466,2.746-3.0304-0.18916-6.0122-0.99351-9.0512-0.96152-2.705,0.14095-4.7956,2.6024-7.5614,2.3341-1.767,0.11638-1.6925-3.618-3.3341-2.6194-0.8128,1.9472-0.41254,4.1196-0.50932,6.1787,0.30628,0.29508,1.165,0.0377,1.6799,0.1242h5.4451c0.38492,1.8802,0.33677,4.0358,1.6875,5.5312,1.8899,0.67214,4.0159,0.0917,5.8116-0.64309,1.9256-0.89569,2.1834-3.2112,2.7274-5.0153,0.57858-1.9384,3.117-1.4302,4.6149-2.1913,3.6648-1.0697,6.0666-4.8789,5.852-8.6268-0.23686-5.722-2.4198-11.105-4.0759-16.521-0.83346-2.386-1.4104-4.875-2.377-7.2045-0.11331-0.20034-0.34573-0.36894-0.58432-0.32903zm-9.07,32.72c2.0364-0.13276,2.9212,2.3697,2.4899,4.0293-0.76215,2.2555-3.5349,0.80928-4.0958-0.81602-1.0301-1.4517-0.39353-3.4044,1.6058-3.2133z'/%3E %3Cpath d='M683.94,487.22c-0.91-0.02-1.93,0.32-2.94,1.03-5.31,3.72-6.67,8.12-3.06,9.84,2.65,1.27,1.98,2.76-2.19,4.85-5.97,2.98-11.24,2.61-21.25-1.53-2.46-1.02-3.1-0.63-2.53,1.62,0.55,2.21,2.57,3.42,7.59,4.56,5.4,1.24,11.93,0.84,16.13-0.97,2.05-0.88,4.48-2.73,6.53-4.96l3.25-3.57,3.78,0.47c4.66,0.57,4.75,0.62,4.75,2.85,0,1.77,0.1,1.81,4.38,2.21,2.41,0.23,5.58,0.44,7.06,0.44,1.89,0.01,2.96,0.34,3.59,1.22,0.84,1.17,1.34,1.23,8.38,0.6,6.58-0.6,7.87-0.55,10.84,0.46,2.11,0.72,4.43,1.01,6.19,0.82,5.04-0.57,11.99-4.69,13-7.72,0.12-0.37,1.95-1.02,4.06-1.44,5.09-1.02,5.31-2.13,0.56-2.72-2.06-0.26-5.15-1.01-6.87-1.69-1.73-0.68-4.09-1.25-5.25-1.25-2.56,0-4.97,1.6-4.97,3.25,0,1.08,0.38,1.19,3.41,0.88,2.85-0.29,3.68-0.13,5.18,1.06,0.99,0.78,1.65,1.7,1.44,2.03-0.67,1.09-6.62,3.8-9.25,4.22-1.76,0.28-3.18,0.09-4.56-0.62-2.31-1.2-5.71-1.38-6.35-0.35-0.27,0.45-1,0.16-2-0.78l-1.56-1.47-3.53,1.47c-3.59,1.49-4.91,1.43-4.91-0.28,0-0.78-1.05-0.87-6.34-0.53-5.83,0.38-6.44,0.28-7.53-0.94-1.01-1.12-1.03-1.51-0.31-2.66,0.66-1.06,0.66-1.52,0.03-2.15s-1.45-0.62-3.75,0c-5.8,1.55-7.44,0.68-7.44-3.85,0-2.72-1.56-4.37-3.56-4.4zm-1.44,4.16c0.31,0,0.57,0.19,0.97,0.59,0.51,0.51,0.78,1.4,0.56,1.97-0.52,1.35-2.98,1.3-3.5-0.06-0.25-0.66,0.07-1.4,0.81-1.94,0.52-0.38,0.85-0.57,1.16-0.56z'/%3E %3Cpath d='M672.1,495.6c3.53-2.24,3.45-2.07,3.96-8.29,0.35-4.39,0.29-4.72-0.9-4.72-1.73,0-2.63,1.9-2.63,5.52,0,2.32-0.36,3.36-1.6,4.59-2.94,2.94-10.24,1.6-11.16-2.05-0.31-1.25,0.09-2.38,1.62-4.55,3.19-4.53,2.47-5.64-1.44-2.2-2.69,2.35-3.17,2.42-2.66,0.39,0.47-1.87-0.51-2.61-2.7-2.06-1.12,0.28-1.73,0.98-2,2.34-0.26,1.33-0.87,2.07-1.93,2.33-1.77,0.45-4.79-1.23-4.79-2.66,0-1.06,4.52-6.58,10.32-12.6,2.19-2.28,3.98-4.4,3.98-4.72s-1.17-0.58-2.6-0.58c-2.09,0-2.6,0.23-2.6,1.2,0,0.66-2.92,4.49-6.5,8.52-7.46,8.4-8.08,10.15-4.39,12.39,2.97,1.82,6.78,1.68,9.77-0.35l2.42-1.65v2.99c0,3.82,0.76,5.19,3.76,6.78,3.77,1.99,8.33,1.75,12.07-0.62z'/%3E %3Cpath d='m828.66,443.69c-2.7668,1.6519-0.60168,5.1236-0.18254,7.4288-1.1299,3.146-5.1718,3.9934-8.1183,4.5774-4.1736,0.69135-7.1308,4.1827-8.7186,7.8921-0.86037,2.4089-2.9366,6.1445-5.1993,2.4767-1.9667-1.9933-5.5819-3.5732-7.9078-1.2462-1.7668,1.6824-2.2148,4.1568-2.8735,6.4025-1.0427-1.7262-1.5104-4.2966-3.7201-4.8424-3.5276,0.49628-2.2527,4.9439-0.594,6.7779,1.5076,2.1378,2.9558,4.9578,1.4779,7.4969-1.303,3.0516-5.8095,5.11-8.4565,2.4995-2.4722-1.305-0.81896-5.9649-3.254-6.221-1.204,0.86977-1.3032,5.7458-3.2303,3.1024-1.3906-2.2586-0.65318-5.3523-2.3547-7.3843-2.0106,0.24966-3.6272,3.7115-2.9583,5.5709,2.6825,3.6176,3.7849,8.1558,4.8314,12.467,0.65196,1.7264-0.0951,5.2267,1.5199,5.9106,1.1196-2.7787,0.0791-5.9306,0.96044-8.7358,2.6182-0.32901,5.5303,0.86591,8.2761,0.23077,3.9286-0.50981,6.9646-3.825,8.3424-7.3555,0.41644-2.6542-0.079-5.3476-0.15274-8.0168,3.1034,0.48084,6.3281,0.47101,9.3135,1.4788,1.4804,2.2709-0.46974,5.4485-0.87913,7.9295-1.5586,5.0524-5.5163,8.7194-9.366,12.097-1.6101,0.95299-1.8264,3.4782,0.55162,2.118,5.1735-2.2122,9.0295-6.8975,11.248-11.969,1.619-3.9019,0.31744-8.2474,1.3744-12.238,1.5617-2.9959,5.3215-2.3646,8.1035-2.3553,2.879-0.10959,5.3363-3.464,4.3747-6.2619-0.91607-3.2468,2.519-4.8109,4.8661-5.9714,3.1119-1.5702,5.4981-4.7591,5.2571-8.3583-0.12787-1.8402-0.0371-5.3318-2.5312-5.5zm-11.031,18.75c3.3336,0.88568-0.60342,7.2524-2.375,3.2188-0.54528-1.539,0.75001-3.2741,2.375-3.2188zm-15.47,4.56c4.3385-0.25338,2.7806,6.0812-0.88479,3.2048-1.9006-0.95441-1.2718-3.3229,0.88479-3.2048z'/%3E %3Cpath d='M645.1,491.48c0.12-0.63-0.2-1.08-0.77-1.08-1.21,0-1.94,1.06-1.37,1.98,0.59,0.95,1.89,0.41,2.14-0.9z'/%3E %3Cpath d='M695.94,485.8c0-0.93-0.35-1.28-1.13-1.13-1.7,0.32-1.89,2.48-0.22,2.48,0.93,0,1.35-0.42,1.35-1.35z'/%3E %3Cpath d='m633.03,455.28c-2.029-0.41667-3.3053,1.3004-4,2.9375-1.5174,2.5503-3.3705,5.1587-6.0931,6.5091-1.9578,0.54422-4.0937-0.20046-5.7819-1.2102-2.0147-1.0029-1.5567-3.4259-2.4202-5.1005-1.457-1.1443-4.0407,0.4921-3.9834,2.2714-0.16115,2.3862,2.0713,3.7641,3.9242,4.6869,1.5747,0.96445,3.8577,1.5009,4.4871,3.4529-0.0437,1.6587,0.6235,3.5571,2.6435,2.9166,2.2597-0.0372,2.8449,2.7155,1.9326,4.3671-0.92932,1.8613-1.5564,4.0416-1.1119,6.1154,1.08,0.90934,2.1827-1.5301,2.9652-2.2268,0.53138-0.70851,1.0628-1.417,1.5941-2.1255,3.9984,0.21679,7.9929,0.72673,12.001,0.5846,2.8505-0.0516,5.2778-1.8114,7.0906-3.875,2.5633-2.6802,4.6693-5.8294,7.597-8.142,2.0839-0.50859,0.96439-4.4336-1.2124-3.3001-1.9608,0.7355-2.578,2.9513-3.9368,4.3632-2.3146,2.8028-4.6762,5.6471-7.5941,7.8434-2.1245,0.8812-4.5705,0.49663-6.7532-0.00022-0.91062-0.79618,1.8087-1.445,2.188-2.33,1.252-1.2507,2.7385-2.438,3.4639-4.0814-0.69398-1.5148-2.8167-1.6373-4.3126-1.6678-3.6856,0.44249-6.5007,3.5363-10.223,3.8277-2.8253,0.099-1.355-2.9607-0.0813-4.0046,2.4916-2.9589,5.1844-5.7458,7.7858-8.6074,0.73816-0.88845,3.4086-1.732,1.7006-2.98-0.59723-0.21503-1.2431-0.21478-1.8694-0.22424zm1.8125,14.969c1.8586,1.0454-1.1858,2.7567-2.4681,2.5229-1.6823,0.50416-1.7125-1.2116-0.2183-1.5533,0.8401-0.43711,1.7274-0.89316,2.6864-0.96961zm-5.7188,3.9062c1.0579-0.0202,3.2748,0.99623,1.1931,1.6469-1.4494,1.1234-3.0867-1.1434-1.1931-1.6469z'/%3E %3Cpath d='M674.15,476.74c0-1.41-2.53-1.21-2.81,0.22-0.18,0.92,0.11,1.14,1.29,0.97,0.84-0.12,1.52-0.65,1.52-1.19z'/%3E %3Cpath d='M786.2,466.82c0.26-1.35-1.62-2.25-2.61-1.26s-0.08,2.87,1.26,2.61c0.62-0.12,1.23-0.73,1.35-1.35z'/%3E %3Cpath d='M611.82,453.09c1.76-1.51,1.78-1.61,1.02-4.93-1.08-4.65-1.01-5.15,0.76-5.59,2.24-0.57,7.93,2.48,9.19,4.92,0.98,1.89,0.95,2.02-0.71,3.56-1.79,1.65-1.78,3.58,0.01,3.58,1.48,0,5.57-3.87,5.57-5.26,0-1.93-4.54-6.49-8.13-8.16-2.22-1.04-4.44-1.52-7.01-1.53-4.6,0-5.22,0.99-3.98,6.34,1.46,6.27-0.52,7.12-5.57,2.39-3.75-3.51-5.23-7.16-5.21-12.91,0.01-6.17,2.37-9.22,7.69-9.94,3.53-0.47,3.44-1.3-0.19-1.84-5.3-0.8-9.78,2.74-11.48,9.06-1.89,7.01,2.44,15.55,10.1,19.95,4.01,2.3,5.61,2.37,7.94,0.36z'/%3E %3Cpath d='M820.66,445.4c0.43-0.43,0.78-1.4,0.78-2.15s0.73-2.36,1.62-3.57c0.9-1.21,1.63-2.45,1.63-2.75,0-1.23-2.03-1.19-3.63,0.08-1.64,1.28-2.87,1.31-2.87,0.06,0-0.31,0.78-0.95,1.74-1.42,2.38-1.16,2.58-2.31,0.57-3.23-2.58-1.17-5.17,0.97-5.44,4.5-0.17,2.36,0.02,2.77,1.84,3.84,1.66,0.98,1.97,1.5,1.69,2.9-0.48,2.43,0.53,3.28,2.07,1.74z'/%3E %3Cpath d='M840.29,443.18c1.44-1.29,2.61-2.76,2.61-3.25s1.24-1.79,2.76-2.88c4.31-3.1,5.26-6.23,3.33-11.04-0.75-1.89-3.11-4.5-8.24-9.12-3.94-3.56-7.57-6.47-8.04-6.47-1.4,0-1.15,5.15,0.27,5.6,2.56,0.82,4.11,1.87,8.14,5.5,4.68,4.23,6.84,8.18,5.66,10.38-1.13,2.13-2.63,1.47-6.76-2.96-2.17-2.33-4.32-4.23-4.76-4.23-0.48,0.01-0.82,0.85-0.82,2.03,0,1.48,0.79,2.89,2.93,5.27,3.49,3.88,3.83,6.21,1.21,8.27-0.94,0.74-1.91,1.35-2.15,1.35-0.23,0-1-1.16-1.7-2.57-1.46-2.96-10.39-12.39-11.73-12.39-0.61,0-0.91,0.76-0.91,2.26,0,1.81,0.36,2.45,1.8,3.19,1.77,0.92,6.15,5.33,10.55,10.65,1.26,1.52,2.5,2.75,2.77,2.76,0.26,0,1.65-1.06,3.08-2.35z'/%3E %3Cpath d='M849.05,418.11c-0.58-1.87-12.56-14.2-13.79-14.2-0.64,0-0.84,0.76-0.69,2.72,0.17,2.38,0.43,2.79,2.07,3.22,1.02,0.27,4.18,2.75,7.01,5.5,2.82,2.75,5.3,4.84,5.5,4.63,0.2-0.2,0.16-1.04-0.1-1.87z'/%3E %3Cpath d='m777.5,556.89a1.7806,1.6322,0,1,1,-3.5612,0,1.7806,1.6322,0,1,1,3.5612,0z'/%3E %3Cpath d='m783.79,554.79a1.7806,1.6322,0,1,1,-3.5612,0,1.7806,1.6322,0,1,1,3.5612,0z'/%3E %3C/g%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1100 750'%3E %3Cpath fill='%23007934' d='M0 0h1100v750H0z'/%3E %3Cpath fill='%23ffe000' d='M0 0h1100v500H0z'/%3E %3Cpath fill='%23d52b1e' d='M0 0h1100v250H0z'/%3E %3Cg stroke='%23000' stroke-width='1.5'%3E %3Cg stroke-width='.22'%3E %3Cpath d='M400.7 187.88c1.07.92 183.54 161.54 184.34 162.24.47-.56 1.39-1.63 1.84-2.13-.76-.68-183.29-161.2-184.36-162.18.33-.6-2.5 2.7-1.83 2.07z' fill='%23a05a2c' transform='matrix(-.94799 .11424 .13323 .81283 980.72 130.74)'/%3E %3Cpath d='M389.18 177.62c.77 1.22 2.96 4.3 2.63 6.85 1.14-1.15 1.68-1.97 2.76-3.2-.59 1.81-.2 2.76.67 3.26.63.72 2.36.29 3.45-.12-1.01.96-2.14 1.96-3.68 2.36-1.53.4-2.1.37-3.03.61 1.03.46 3.66 1.08 5.44 1.16.9.03 2.6-.03 3.27-.66 1.08.92 2.9-1.09 1.83-2.07.33-.6.25-1.48.19-2.66a12.7 12.7 0 0 0-1.87-5.54c0 1.08-.13 2.24-.34 3.3-.2 1.06-.81 1.97-1.4 2.96.28-.98.34-2.4-.63-3.3-.97-.88-2.18-.7-3.24-.03.88-1.05 1.57-1.7 2.64-2.9-1.26.16-5.53-1.08-7-1.82-1.45-.74-6.21-4.04-8.91-6.06 2.32 2.35 6.48 6.68 7.22 7.86z' fill='%23e7e7e7' transform='matrix(-.94799 .11424 .13323 .81283 980.72 130.74)'/%3E %3Cpath d='M400.7 187.88c1.07.92 183.54 161.54 184.34 162.24.47-.56 1.39-1.63 1.84-2.13-.76-.68-183.29-161.2-184.36-162.18.33-.6-2.5 2.7-1.83 2.07z' fill='%23a05a2c' transform='matrix(-.94799 -.11424 -.13323 .81283 1059.61 241.16)'/%3E %3Cpath d='M389.18 177.62c.77 1.22 2.96 4.3 2.63 6.85 1.14-1.15 1.68-1.97 2.76-3.2-.59 1.81-.2 2.76.67 3.26.63.72 2.36.29 3.45-.12-1.01.96-2.14 1.96-3.68 2.36-1.53.4-2.1.37-3.03.61 1.03.46 3.66 1.08 5.44 1.16.9.03 2.6-.03 3.27-.66 1.08.92 2.9-1.09 1.83-2.07.33-.6.25-1.48.19-2.66a12.7 12.7 0 0 0-1.87-5.54c0 1.08-.13 2.24-.34 3.3-.2 1.06-.81 1.97-1.4 2.96.28-.98.34-2.4-.63-3.3-.97-.88-2.18-.7-3.24-.03.88-1.05 1.57-1.7 2.64-2.9-1.26.16-5.53-1.08-7-1.82-1.45-.74-6.21-4.04-8.91-6.06 2.32 2.35 6.48 6.68 7.22 7.86z' fill='%23e7e7e7' transform='matrix(-.94799 -.11424 -.13323 .81283 1059.61 241.16)'/%3E %3Cg%3E %3Cpath d='M400.7 187.88c1.07.92 183.54 161.54 184.34 162.24.47-.56 1.39-1.63 1.84-2.13-.76-.68-183.29-161.2-184.36-162.18.33-.6-2.5 2.7-1.83 2.07z' fill='%23a05a2c' transform='matrix(-.9573 0 0 .82082 1021.59 185.6)'/%3E %3Cpath d='M389.18 177.62c.77 1.22 2.96 4.3 2.63 6.85 1.14-1.15 1.68-1.97 2.76-3.2-.59 1.81-.2 2.76.67 3.26.63.72 2.36.29 3.45-.12-1.01.96-2.14 1.96-3.68 2.36-1.53.4-2.1.37-3.03.61 1.03.46 3.66 1.08 5.44 1.16.9.03 2.6-.03 3.27-.66 1.08.92 2.9-1.09 1.83-2.07.33-.6.25-1.48.19-2.66a12.7 12.7 0 0 0-1.87-5.54c0 1.08-.13 2.24-.34 3.3-.2 1.06-.81 1.97-1.4 2.96.28-.98.34-2.4-.63-3.3-.97-.88-2.18-.7-3.24-.03.88-1.05 1.57-1.7 2.64-2.9-1.26.16-5.53-1.08-7-1.82-1.45-.74-6.21-4.04-8.91-6.06 2.32 2.35 6.48 6.68 7.22 7.86z' fill='%23e7e7e7' transform='matrix(-.9573 0 0 .82082 1021.59 185.6)'/%3E %3C/g%3E %3C/g%3E %3Cg stroke-width='.22'%3E %3Cpath d='M400.7 187.88c1.07.92 183.54 161.54 184.34 162.24.47-.56 1.39-1.63 1.84-2.13-.76-.68-183.29-161.2-184.36-162.18.33-.6-2.5 2.7-1.83 2.07z' fill='%23a05a2c' transform='matrix(.94799 .11424 -.13323 .81283 119.28 130.74)'/%3E %3Cpath d='M389.18 177.62c.77 1.22 2.96 4.3 2.63 6.85 1.14-1.15 1.68-1.97 2.76-3.2-.59 1.81-.2 2.76.67 3.26.63.72 2.36.29 3.45-.12-1.01.96-2.14 1.96-3.68 2.36-1.53.4-2.1.37-3.03.61 1.03.46 3.66 1.08 5.44 1.16.9.03 2.6-.03 3.27-.66 1.08.92 2.9-1.09 1.83-2.07.33-.6.25-1.48.19-2.66a12.7 12.7 0 0 0-1.87-5.54c0 1.08-.13 2.24-.34 3.3-.2 1.06-.81 1.97-1.4 2.96.28-.98.34-2.4-.63-3.3-.97-.88-2.18-.7-3.24-.03.88-1.05 1.57-1.7 2.64-2.9-1.26.16-5.53-1.08-7-1.82-1.45-.74-6.21-4.04-8.91-6.06 2.32 2.35 6.48 6.68 7.22 7.86z' fill='%23e7e7e7' transform='matrix(.94799 .11424 -.13323 .81283 119.28 130.74)'/%3E %3Cpath d='M400.7 187.88c1.07.92 183.54 161.54 184.34 162.24.47-.56 1.39-1.63 1.84-2.13-.76-.68-183.29-161.2-184.36-162.18.33-.6-2.5 2.7-1.83 2.07z' fill='%23a05a2c' transform='matrix(.94799 -.11424 .13323 .81283 40.39 241.16)'/%3E %3Cpath d='M389.18 177.62c.77 1.22 2.96 4.3 2.63 6.85 1.14-1.15 1.68-1.97 2.76-3.2-.59 1.81-.2 2.76.67 3.26.63.72 2.36.29 3.45-.12-1.01.96-2.14 1.96-3.68 2.36-1.53.4-2.1.37-3.03.61 1.03.46 3.66 1.08 5.44 1.16.9.03 2.6-.03 3.27-.66 1.08.92 2.9-1.09 1.83-2.07.33-.6.25-1.48.19-2.66a12.7 12.7 0 0 0-1.87-5.54c0 1.08-.13 2.24-.34 3.3-.2 1.06-.81 1.97-1.4 2.96.28-.98.34-2.4-.63-3.3-.97-.88-2.18-.7-3.24-.03.88-1.05 1.57-1.7 2.64-2.9-1.26.16-5.53-1.08-7-1.82-1.45-.74-6.21-4.04-8.91-6.06 2.32 2.35 6.48 6.68 7.22 7.86z' fill='%23e7e7e7' transform='matrix(.94799 -.11424 .13323 .81283 40.39 241.16)'/%3E %3Cg%3E %3Cpath d='M400.7 187.88c1.07.92 183.54 161.54 184.34 162.24.47-.56 1.39-1.63 1.84-2.13-.76-.68-183.29-161.2-184.36-162.18.33-.6-2.5 2.7-1.83 2.07z' fill='%23a05a2c' transform='matrix(.9573 0 0 .82082 78.41 185.6)'/%3E %3Cpath d='M389.18 177.62c.77 1.22 2.96 4.3 2.63 6.85 1.14-1.15 1.68-1.97 2.76-3.2-.59 1.81-.2 2.76.67 3.26.63.72 2.36.29 3.45-.12-1.01.96-2.14 1.96-3.68 2.36-1.53.4-2.1.37-3.03.61 1.03.46 3.66 1.08 5.44 1.16.9.03 2.6-.03 3.27-.66 1.08.92 2.9-1.09 1.83-2.07.33-.6.25-1.48.19-2.66a12.7 12.7 0 0 0-1.87-5.54c0 1.08-.13 2.24-.34 3.3-.2 1.06-.81 1.97-1.4 2.96.28-.98.34-2.4-.63-3.3-.97-.88-2.18-.7-3.24-.03.88-1.05 1.57-1.7 2.64-2.9-1.26.16-5.53-1.08-7-1.82-1.45-.74-6.21-4.04-8.91-6.06 2.32 2.35 6.48 6.68 7.22 7.86z' fill='%23e7e7e7' transform='matrix(.9573 0 0 .82082 78.41 185.6)'/%3E %3C/g%3E %3C/g%3E %3Cg stroke-width='.24'%3E %3Cpath d='M408.42 331.3c-4.15-7.96-21.27-18.78-24.22-19.1 7.87 17.36 20.84 23.65 24.22 19.1z' fill='%2300e519' transform='matrix(-.7956 -.30372 -.35422 .68216 961.26 340.95)'/%3E %3Cpath d='M408.34 331.3c-3.38 4.55-16.27-1.74-24.14-19.01 11.72 11.1 22.2 19.17 24.14 19z' fill='%23ffe533' transform='matrix(-.7956 -.30372 -.35422 .68216 961.26 340.95)'/%3E %3Cpath d='M408.34 331.3c-3.38 4.55-16.27-1.74-24.14-19.01 11.72 11.1 22.2 19.17 24.14 19z' fill='none' stroke-linecap='round' transform='matrix(-.7956 -.30372 -.35422 .68216 961.26 340.95)'/%3E %3Cpath d='M408.42 331.22c-4.42-8.46-22.36-18.94-24.26-19.13 7.91 17.32 20.88 23.68 24.26 19.13z' fill='none' transform='matrix(-.7956 -.30372 -.35422 .68216 961.26 340.95)'/%3E %3Cpath d='M384.56 175.7l-2.8 118.6c1.25 2.8 4.09 1.05 4.55 1.6 1.05 4.38 4.2 6.59 4.58 7.68.85 5.9-2.42 8.93-2.73 9.17-3.7 2.45-.43 7.88-1.1 8.86.08 2.33 3.77 3.45 3.46 6.1.27-.2.02 19.07-.02 21.12.62 1.4.76 14.38.76 14.38 3.5 1.47 21.21-2.5 21.4-2.24-1.26-17.28-9.66-46.68-8.69-47.89-.6-12.2-3.86-26.56-7.35-28.04-3.57-5.2-2.52-14.02-.77-15.38-3.72-1.78-4.61-5.32-4.8-5.59l1.16-85.54c-2.14-2.13-2.3-.73-3.89.63 0 0-.61-3.03-.38-3.27-1.09-1.47-3.03-.93-3.38-.19z' fill='%23a05a2c' transform='matrix(-.7956 -.30372 -.35422 .68216 961.26 340.95)'/%3E %3Cpath d='M392.66 153.16c-.08 2.34-1.32 1.8-1.87 1.87l-2.02-.23c-2.02-.85-3.61-.11-3.96.62l-3.04 138.88c1.24 2.8 4.27 1.32 4.77 1.9l1.96-94.94s-.44-33.87-.35-43.2l5.44-.24c1.55.24 2.44-.66 2.56-2.56l-2.2-50.5-1.25 47.51-.04.9' fill='%23cce5e5' transform='matrix(-.7956 -.30372 -.35422 .68216 961.26 340.95)'/%3E %3Cpath d='M392.66 153.16c-.08 2.34-1.32 1.8-1.87 1.87l-2.02-.23c-2.02-.85-3.61-.11-3.96.62l-3.04 138.88c1.24 2.8 4.27 1.32 4.77 1.9l1.96-94.94s-.44-33.87-.35-43.2l5.44-.24c1.55.24 2.44-.66 2.56-2.56l-2.2-50.5-1.25 47.51-.04.9' fill='%23e7e7e7' transform='matrix(-.7956 -.30372 -.35422 .68216 961.26 340.95)'/%3E %3Cpath d='M403.6 303.92c4.92 1.9 5.77 7.26.4 10.83M403.74 309.28c1.24 1.86 3.1.61 3.1.61M392.97 273.78c-2.22 11.85-.75 21.02-.8 23.62 1.67 5.79.34 16.67-.94 18.1l1.95 31.35' fill='none' transform='matrix(-.7956 -.30372 -.35422 .68216 961.26 340.95)'/%3E %3Cpath d='M381.8 294.8c2.57.08 13.22-4.51 19.66-.01 2.13 9.67 2.05 18.53 2.55 19.96-9.37 3.4-15.08 4.6-17.1 4.84-.7-1.25-.3-3.65-.3-3.65-.59-2.37 1.78-3.2 1.78-3.2 1.91-4.77.44-9.35-2.43-10.9-3.58-2.02-2.37-1.9-2.84-2.14-1.2-1.9-1.31-4.9-1.31-4.9z' fill='%23cce5e5' transform='matrix(-.7956 -.30372 -.35422 .68216 961.26 340.95)'/%3E %3Cpath d='M381.8 294.8c2.57.08 13.22-4.51 19.66-.01 2.13 9.67 2.05 18.53 2.55 19.96-9.37 3.4-15.08 4.6-17.1 4.84-.7-1.25-.3-3.65-.3-3.65-.59-2.37 1.78-3.2 1.78-3.2 1.91-4.77.44-9.35-2.43-10.9-3.58-2.02-2.37-1.9-2.84-2.14-1.2-1.9-1.31-4.9-1.31-4.9z' fill='none' transform='matrix(-.7956 -.30372 -.35422 .68216 961.26 340.95)'/%3E %3Cpath d='M388.87 298.14c3.34 1.4 5.9 4.74 5.55 8.5l-5.55-8.5' fill='%23cce5e5' transform='matrix(-.7956 -.30372 -.35422 .68216 961.26 340.95)'/%3E %3Cpath d='M388.87 298.14c3.34 1.4 5.9 4.74 5.55 8.5M399.74 310.56c-.66.66-1.71.7-2.37.04a1.71 1.71 0 0 1 0-2.4c.66-.67 1.71-.63 2.37.03.66.66.66 1.67 0 2.33zM398.54 302.21c-.66.66-1.75.66-2.4 0-.66-.66-.63-1.7.04-2.37a1.62 1.62 0 0 1 2.33 0c.66.66.7 1.71.03 2.37z' fill='none' transform='matrix(-.7956 -.30372 -.35422 .68216 961.26 340.95)'/%3E %3Cpath d='M383.19 188.72c-1.09-1.09-.9-3.07.47-4.43l9.13.18s.81.59 1.04 2.14c.2 1.6-1.28 2.14-1.28 2.14l-9.36-.03' fill='%23cce5e5' transform='matrix(-.7956 -.30372 -.35422 .68216 961.26 340.95)'/%3E %3Cpath d='M383.19 188.72c-1.09-1.09-.9-3.07.47-4.43l9.13.18s.81.59 1.04 2.14c.2 1.6-1.28 2.14-1.28 2.14l-9.36-.03' fill='none' transform='matrix(-.7956 -.30372 -.35422 .68216 961.26 340.95)'/%3E %3C/g%3E %3Cg stroke-width='.24'%3E %3Cpath d='M408.42 331.3c-4.15-7.96-21.27-18.78-24.22-19.1 7.87 17.36 20.84 23.65 24.22 19.1z' fill='%2300e519' transform='matrix(-.80166 -.29177 -.34028 .68736 950.35 338.41)'/%3E %3Cpath d='M408.34 331.3c-3.38 4.55-16.27-1.74-24.14-19.01 11.72 11.1 22.2 19.17 24.14 19z' fill='%23ffe533' transform='matrix(-.80166 -.29177 -.34028 .68736 950.35 338.41)'/%3E %3Cpath d='M408.34 331.3c-3.38 4.55-16.27-1.74-24.14-19.01 11.72 11.1 22.2 19.17 24.14 19z' fill='none' stroke-linecap='round' transform='matrix(-.80166 -.29177 -.34028 .68736 950.35 338.41)'/%3E %3Cpath d='M408.42 331.22c-4.42-8.46-22.36-18.94-24.26-19.13 7.91 17.32 20.88 23.68 24.26 19.13z' fill='none' transform='matrix(-.80166 -.29177 -.34028 .68736 950.35 338.41)'/%3E %3Cpath d='M384.56 175.7l-2.8 118.6c1.25 2.8 4.09 1.05 4.55 1.6 1.05 4.38 4.2 6.59 4.58 7.68.85 5.9-2.42 8.93-2.73 9.17-3.7 2.45-.43 7.88-1.1 8.86.08 2.33 3.77 3.45 3.46 6.1.27-.2.02 19.07-.02 21.12.62 1.4.76 14.38.76 14.38 3.5 1.47 21.21-2.5 21.4-2.24-1.26-17.28-9.66-46.68-8.69-47.89-.6-12.2-3.86-26.56-7.35-28.04-3.57-5.2-2.52-14.02-.77-15.38-3.72-1.78-4.61-5.32-4.8-5.59l1.16-85.54c-2.14-2.13-2.3-.73-3.89.63 0 0-.61-3.03-.38-3.27-1.09-1.47-3.03-.93-3.38-.19z' fill='%23a05a2c' transform='matrix(-.80166 -.29177 -.34028 .68736 950.35 338.41)'/%3E %3Cpath d='M384.56 175.7l-2.8 118.6c1.25 2.8 4.09 1.05 4.55 1.6 1.05 4.38 4.2 6.59 4.58 7.68.85 5.9-2.42 8.93-2.73 9.17-3.7 2.45-.43 7.88-1.1 8.86.08 2.33 3.77 3.45 3.46 6.1.27-.2.02 19.07-.02 21.12.62 1.4.76 14.38.76 14.38 3.5 1.47 21.21-2.5 21.4-2.24-1.26-17.28-9.66-46.68-8.69-47.89-.6-12.2-3.86-26.56-7.35-28.04-3.57-5.2-2.52-14.02-.77-15.38-3.72-1.78-4.61-5.32-4.8-5.59l1.16-85.54c-2.14-2.13-2.3-.73-3.89.63 0 0-.61-3.03-.38-3.27-1.09-1.47-3.03-.93-3.38-.19z' fill='none' transform='matrix(-.80166 -.29177 -.34028 .68736 950.35 338.41)'/%3E %3Cpath d='M392.66 153.16c-.08 2.34-1.32 1.8-1.87 1.87l-2.02-.23c-2.02-.85-3.61-.11-3.96.62l-3.04 138.88c1.24 2.8 4.27 1.32 4.77 1.9l1.96-94.94s-.44-33.87-.35-43.2l5.44-.24c1.55.24 2.44-.66 2.56-2.56l-2.2-50.5-1.25 47.51-.04.9' fill='%23cce5e5' transform='matrix(-.80166 -.29177 -.34028 .68736 950.35 338.41)'/%3E %3Cpath d='M392.66 153.16c-.08 2.34-1.32 1.8-1.87 1.87l-2.02-.23c-2.02-.85-3.61-.11-3.96.62l-3.04 138.88c1.24 2.8 4.27 1.32 4.77 1.9l1.96-94.94s-.44-33.87-.35-43.2l5.44-.24c1.55.24 2.44-.66 2.56-2.56l-2.2-50.5-1.25 47.51-.04.9' fill='%23e7e7e7' transform='matrix(-.80166 -.29177 -.34028 .68736 950.35 338.41)'/%3E %3Cpath d='M403.6 303.92c4.92 1.9 5.77 7.26.4 10.83M403.74 309.28c1.24 1.86 3.1.61 3.1.61M392.97 273.78c-2.22 11.85-.75 21.02-.8 23.62 1.67 5.79.34 16.67-.94 18.1l1.95 31.35' fill='none' transform='matrix(-.80166 -.29177 -.34028 .68736 950.35 338.41)'/%3E %3Cpath d='M381.8 294.8c2.57.08 13.22-4.51 19.66-.01 2.13 9.67 2.05 18.53 2.55 19.96-9.37 3.4-15.08 4.6-17.1 4.84-.7-1.25-.3-3.65-.3-3.65-.59-2.37 1.78-3.2 1.78-3.2 1.91-4.77.44-9.35-2.43-10.9-3.58-2.02-2.37-1.9-2.84-2.14-1.2-1.9-1.31-4.9-1.31-4.9z' fill='%23cce5e5' transform='matrix(-.80166 -.29177 -.34028 .68736 950.35 338.41)'/%3E %3Cpath d='M381.8 294.8c2.57.08 13.22-4.51 19.66-.01 2.13 9.67 2.05 18.53 2.55 19.96-9.37 3.4-15.08 4.6-17.1 4.84-.7-1.25-.3-3.65-.3-3.65-.59-2.37 1.78-3.2 1.78-3.2 1.91-4.77.44-9.35-2.43-10.9-3.58-2.02-2.37-1.9-2.84-2.14-1.2-1.9-1.31-4.9-1.31-4.9z' fill='none' transform='matrix(-.80166 -.29177 -.34028 .68736 950.35 338.41)'/%3E %3Cpath d='M388.87 298.14c3.34 1.4 5.9 4.74 5.55 8.5l-5.55-8.5' fill='%23cce5e5' transform='matrix(-.80166 -.29177 -.34028 .68736 950.35 338.41)'/%3E %3Cpath d='M388.87 298.14c3.34 1.4 5.9 4.74 5.55 8.5M399.74 310.56c-.66.66-1.71.7-2.37.04a1.71 1.71 0 0 1 0-2.4c.66-.67 1.71-.63 2.37.03.66.66.66 1.67 0 2.33zM398.54 302.21c-.66.66-1.75.66-2.4 0-.66-.66-.63-1.7.04-2.37a1.62 1.62 0 0 1 2.33 0c.66.66.7 1.71.03 2.37z' fill='none' transform='matrix(-.80166 -.29177 -.34028 .68736 950.35 338.41)'/%3E %3Cpath d='M383.19 188.72c-1.09-1.09-.9-3.07.47-4.43l9.13.18s.81.59 1.04 2.14c.2 1.6-1.28 2.14-1.28 2.14l-9.36-.03' fill='%23cce5e5' transform='matrix(-.80166 -.29177 -.34028 .68736 950.35 338.41)'/%3E %3Cpath d='M383.19 188.72c-1.09-1.09-.9-3.07.47-4.43l9.13.18s.81.59 1.04 2.14c.2 1.6-1.28 2.14-1.28 2.14l-9.36-.03' fill='none' transform='matrix(-.80166 -.29177 -.34028 .68736 950.35 338.41)'/%3E %3C/g%3E %3Cg stroke-width='.24'%3E %3Cpath d='M408.42 331.3c-4.15-7.96-21.27-18.78-24.22-19.1 7.87 17.36 20.84 23.65 24.22 19.1z' fill='%2300e519' transform='matrix(.80363 -.30679 .3578 .68905 135.46 339.65)'/%3E %3Cpath d='M408.34 331.3c-3.38 4.55-16.27-1.74-24.14-19.01 11.72 11.1 22.2 19.17 24.14 19z' fill='%23ffe533' transform='matrix(.80363 -.30679 .3578 .68905 135.46 339.65)'/%3E %3Cpath d='M408.34 331.3c-3.38 4.55-16.27-1.74-24.14-19.01 11.72 11.1 22.2 19.17 24.14 19z' fill='none' stroke-linecap='round' transform='matrix(.80363 -.30679 .3578 .68905 135.46 339.65)'/%3E %3Cpath d='M408.42 331.22c-4.42-8.46-22.36-18.94-24.26-19.13 7.91 17.32 20.88 23.68 24.26 19.13z' fill='none' transform='matrix(.80363 -.30679 .3578 .68905 135.46 339.65)'/%3E %3Cpath d='M384.56 175.7l-2.8 118.6c1.25 2.8 4.09 1.05 4.55 1.6 1.05 4.38 4.2 6.59 4.58 7.68.85 5.9-2.42 8.93-2.73 9.17-3.7 2.45-.43 7.88-1.1 8.86.08 2.33 3.77 3.45 3.46 6.1.27-.2.02 19.07-.02 21.12.62 1.4.76 14.38.76 14.38 3.5 1.47 21.21-2.5 21.4-2.24-1.26-17.28-9.66-46.68-8.69-47.89-.6-12.2-3.86-26.56-7.35-28.04-3.57-5.2-2.52-14.02-.77-15.38-3.72-1.78-4.61-5.32-4.8-5.59l1.16-85.54c-2.14-2.13-2.3-.73-3.89.63 0 0-.61-3.03-.38-3.27-1.09-1.47-3.03-.93-3.38-.19z' fill='%23a05a2c' transform='matrix(.80363 -.30679 .3578 .68905 135.46 339.65)'/%3E %3Cpath d='M392.66 153.16c-.08 2.34-1.32 1.8-1.87 1.87l-2.02-.23c-2.02-.85-3.61-.11-3.96.62l-3.04 138.88c1.24 2.8 4.27 1.32 4.77 1.9l1.96-94.94s-.44-33.87-.35-43.2l5.44-.24c1.55.24 2.44-.66 2.56-2.56l-2.2-50.5-1.25 47.51-.04.9' fill='%23cce5e5' transform='matrix(.80363 -.30679 .3578 .68905 135.46 339.65)'/%3E %3Cpath d='M392.66 153.16c-.08 2.34-1.32 1.8-1.87 1.87l-2.02-.23c-2.02-.85-3.61-.11-3.96.62l-3.04 138.88c1.24 2.8 4.27 1.32 4.77 1.9l1.96-94.94s-.44-33.87-.35-43.2l5.44-.24c1.55.24 2.44-.66 2.56-2.56l-2.2-50.5-1.25 47.51-.04.9' fill='%23e7e7e7' transform='matrix(.80363 -.30679 .3578 .68905 135.46 339.65)'/%3E %3Cpath d='M403.6 303.92c4.92 1.9 5.77 7.26.4 10.83M403.74 309.28c1.24 1.86 3.1.61 3.1.61M392.97 273.78c-2.22 11.85-.75 21.02-.8 23.62 1.67 5.79.34 16.67-.94 18.1l1.95 31.35' fill='none' transform='matrix(.80363 -.30679 .3578 .68905 135.46 339.65)'/%3E %3Cpath d='M381.8 294.8c2.57.08 13.22-4.51 19.66-.01 2.13 9.67 2.05 18.53 2.55 19.96-9.37 3.4-15.08 4.6-17.1 4.84-.7-1.25-.3-3.65-.3-3.65-.59-2.37 1.78-3.2 1.78-3.2 1.91-4.77.44-9.35-2.43-10.9-3.58-2.02-2.37-1.9-2.84-2.14-1.2-1.9-1.31-4.9-1.31-4.9z' fill='%23cce5e5' transform='matrix(.80363 -.30679 .3578 .68905 135.46 339.65)'/%3E %3Cpath d='M381.8 294.8c2.57.08 13.22-4.51 19.66-.01 2.13 9.67 2.05 18.53 2.55 19.96-9.37 3.4-15.08 4.6-17.1 4.84-.7-1.25-.3-3.65-.3-3.65-.59-2.37 1.78-3.2 1.78-3.2 1.91-4.77.44-9.35-2.43-10.9-3.58-2.02-2.37-1.9-2.84-2.14-1.2-1.9-1.31-4.9-1.31-4.9z' fill='none' transform='matrix(.80363 -.30679 .3578 .68905 135.46 339.65)'/%3E %3Cpath d='M388.87 298.14c3.34 1.4 5.9 4.74 5.55 8.5l-5.55-8.5' fill='%23cce5e5' transform='matrix(.80363 -.30679 .3578 .68905 135.46 339.65)'/%3E %3Cpath d='M388.87 298.14c3.34 1.4 5.9 4.74 5.55 8.5M399.74 310.56c-.66.66-1.71.7-2.37.04a1.71 1.71 0 0 1 0-2.4c.66-.67 1.71-.63 2.37.03.66.66.66 1.67 0 2.33zM398.54 302.21c-.66.66-1.75.66-2.4 0-.66-.66-.63-1.7.04-2.37a1.62 1.62 0 0 1 2.33 0c.66.66.7 1.71.03 2.37z' fill='none' transform='matrix(.80363 -.30679 .3578 .68905 135.46 339.65)'/%3E %3Cpath d='M383.19 188.72c-1.09-1.09-.9-3.07.47-4.43l9.13.18s.81.59 1.04 2.14c.2 1.6-1.28 2.14-1.28 2.14l-9.36-.03' fill='%23cce5e5' transform='matrix(.80363 -.30679 .3578 .68905 135.46 339.65)'/%3E %3Cpath d='M383.19 188.72c-1.09-1.09-.9-3.07.47-4.43l9.13.18s.81.59 1.04 2.14c.2 1.6-1.28 2.14-1.28 2.14l-9.36-.03' fill='none' transform='matrix(.80363 -.30679 .3578 .68905 135.46 339.65)'/%3E %3C/g%3E %3Cg stroke-width='.24'%3E %3Cpath d='M408.42 331.3c-4.15-7.96-21.27-18.78-24.22-19.1 7.87 17.36 20.84 23.65 24.22 19.1z' fill='%2300e519' transform='matrix(.80166 -.29177 .34028 .68736 149.9 338.41)'/%3E %3Cpath d='M408.34 331.3c-3.38 4.55-16.27-1.74-24.14-19.01 11.72 11.1 22.2 19.17 24.14 19z' fill='%23ffe533' transform='matrix(.80166 -.29177 .34028 .68736 149.9 338.41)'/%3E %3Cpath d='M408.34 331.3c-3.38 4.55-16.27-1.74-24.14-19.01 11.72 11.1 22.2 19.17 24.14 19z' fill='none' stroke-linecap='round' transform='matrix(.80166 -.29177 .34028 .68736 149.9 338.41)'/%3E %3Cpath d='M408.42 331.22c-4.42-8.46-22.36-18.94-24.26-19.13 7.91 17.32 20.88 23.68 24.26 19.13z' fill='none' transform='matrix(.80166 -.29177 .34028 .68736 149.9 338.41)'/%3E %3Cpath d='M384.56 175.7l-2.8 118.6c1.25 2.8 4.09 1.05 4.55 1.6 1.05 4.38 4.2 6.59 4.58 7.68.85 5.9-2.42 8.93-2.73 9.17-3.7 2.45-.43 7.88-1.1 8.86.08 2.33 3.77 3.45 3.46 6.1.27-.2.02 19.07-.02 21.12.62 1.4.76 14.38.76 14.38 3.5 1.47 21.21-2.5 21.4-2.24-1.26-17.28-9.66-46.68-8.69-47.89-.6-12.2-3.86-26.56-7.35-28.04-3.57-5.2-2.52-14.02-.77-15.38-3.72-1.78-4.61-5.32-4.8-5.59l1.16-85.54c-2.14-2.13-2.3-.73-3.89.63 0 0-.61-3.03-.38-3.27-1.09-1.47-3.03-.93-3.38-.19z' fill='%23a05a2c' transform='matrix(.80166 -.29177 .34028 .68736 149.9 338.41)'/%3E %3Cpath d='M384.56 175.7l-2.8 118.6c1.25 2.8 4.09 1.05 4.55 1.6 1.05 4.38 4.2 6.59 4.58 7.68.85 5.9-2.42 8.93-2.73 9.17-3.7 2.45-.43 7.88-1.1 8.86.08 2.33 3.77 3.45 3.46 6.1.27-.2.02 19.07-.02 21.12.62 1.4.76 14.38.76 14.38 3.5 1.47 21.21-2.5 21.4-2.24-1.26-17.28-9.66-46.68-8.69-47.89-.6-12.2-3.86-26.56-7.35-28.04-3.57-5.2-2.52-14.02-.77-15.38-3.72-1.78-4.61-5.32-4.8-5.59l1.16-85.54c-2.14-2.13-2.3-.73-3.89.63 0 0-.61-3.03-.38-3.27-1.09-1.47-3.03-.93-3.38-.19z' fill='none' transform='matrix(.80166 -.29177 .34028 .68736 149.9 338.41)'/%3E %3Cpath d='M392.66 153.16c-.08 2.34-1.32 1.8-1.87 1.87l-2.02-.23c-2.02-.85-3.61-.11-3.96.62l-3.04 138.88c1.24 2.8 4.27 1.32 4.77 1.9l1.96-94.94s-.44-33.87-.35-43.2l5.44-.24c1.55.24 2.44-.66 2.56-2.56l-2.2-50.5-1.25 47.51-.04.9' fill='%23cce5e5' transform='matrix(.80166 -.29177 .34028 .68736 149.9 338.41)'/%3E %3Cpath d='M392.66 153.16c-.08 2.34-1.32 1.8-1.87 1.87l-2.02-.23c-2.02-.85-3.61-.11-3.96.62l-3.04 138.88c1.24 2.8 4.27 1.32 4.77 1.9l1.96-94.94s-.44-33.87-.35-43.2l5.44-.24c1.55.24 2.44-.66 2.56-2.56l-2.2-50.5-1.25 47.51-.04.9' fill='%23e7e7e7' transform='matrix(.80166 -.29177 .34028 .68736 149.9 338.41)'/%3E %3Cpath d='M403.6 303.92c4.92 1.9 5.77 7.26.4 10.83M403.74 309.28c1.24 1.86 3.1.61 3.1.61M392.97 273.78c-2.22 11.85-.75 21.02-.8 23.62 1.67 5.79.34 16.67-.94 18.1l1.95 31.35' fill='none' transform='matrix(.80166 -.29177 .34028 .68736 149.9 338.41)'/%3E %3Cpath d='M381.8 294.8c2.57.08 13.22-4.51 19.66-.01 2.13 9.67 2.05 18.53 2.55 19.96-9.37 3.4-15.08 4.6-17.1 4.84-.7-1.25-.3-3.65-.3-3.65-.59-2.37 1.78-3.2 1.78-3.2 1.91-4.77.44-9.35-2.43-10.9-3.58-2.02-2.37-1.9-2.84-2.14-1.2-1.9-1.31-4.9-1.31-4.9z' fill='%23cce5e5' transform='matrix(.80166 -.29177 .34028 .68736 149.9 338.41)'/%3E %3Cpath d='M381.8 294.8c2.57.08 13.22-4.51 19.66-.01 2.13 9.67 2.05 18.53 2.55 19.96-9.37 3.4-15.08 4.6-17.1 4.84-.7-1.25-.3-3.65-.3-3.65-.59-2.37 1.78-3.2 1.78-3.2 1.91-4.77.44-9.35-2.43-10.9-3.58-2.02-2.37-1.9-2.84-2.14-1.2-1.9-1.31-4.9-1.31-4.9z' fill='none' transform='matrix(.80166 -.29177 .34028 .68736 149.9 338.41)'/%3E %3Cpath d='M388.87 298.14c3.34 1.4 5.9 4.74 5.55 8.5l-5.55-8.5' fill='%23cce5e5' transform='matrix(.80166 -.29177 .34028 .68736 149.9 338.41)'/%3E %3Cpath d='M388.87 298.14c3.34 1.4 5.9 4.74 5.55 8.5M399.74 310.56c-.66.66-1.71.7-2.37.04a1.71 1.71 0 0 1 0-2.4c.66-.67 1.71-.63 2.37.03.66.66.66 1.67 0 2.33zM398.54 302.21c-.66.66-1.75.66-2.4 0-.66-.66-.63-1.7.04-2.37a1.62 1.62 0 0 1 2.33 0c.66.66.7 1.71.03 2.37z' fill='none' transform='matrix(.80166 -.29177 .34028 .68736 149.9 338.41)'/%3E %3Cpath d='M383.19 188.72c-1.09-1.09-.9-3.07.47-4.43l9.13.18s.81.59 1.04 2.14c.2 1.6-1.28 2.14-1.28 2.14l-9.36-.03' fill='%23cce5e5' transform='matrix(.80166 -.29177 .34028 .68736 149.9 338.41)'/%3E %3Cpath d='M383.19 188.72c-1.09-1.09-.9-3.07.47-4.43l9.13.18s.81.59 1.04 2.14c.2 1.6-1.28 2.14-1.28 2.14l-9.36-.03' fill='none' transform='matrix(.80166 -.29177 .34028 .68736 149.9 338.41)'/%3E %3C/g%3E %3Cg stroke-width='.22'%3E %3Cpath d='M5.33 370.91c.94-1.06 62.72-68.44 63.43-69.23l-2.1-1.88c-.68.74-62.62 68.2-63.61 69.25-.6-.34 2.9 2.54 2.28 1.86z' fill='%23a05a2c' transform='matrix(.95347 -.03737 .07151 .82132 510.97 87.23)'/%3E %3Cg stroke-width='.36'%3E %3Cpath d='M146.62 176.74c1.44 1.8 4.09 4.05 6.25 3.7.18 3.41-4.41 6.38-6.03 5.66.99-3.6-3.35-6.5-3.26-6.5l3.04-2.86z' fill='%23e7e7e7' fill-rule='evenodd' transform='matrix(-1.14336 .12305 -.17678 -.9872 795.47 488.01)' stroke-width='.18'/%3E %3Cpath d='M125.9 161.76c.23-3.52-.34-4.52-.86-8.86-.52-4.26-8.34-4.63-11.24-5.35 0 0 6.85-8.48 15.96-8.48 9.11 0 14.57 4.29 16.3 9.67 0 0-10.75-.54-11.66 3.82-.88 4.22-.46 5.16-.37 8.62' fill='%23e7e7e7' transform='matrix(-.35384 .3844 -.45764 -.3157 718.74 331.43)'/%3E %3Cpath fill='%23e7e7e7' d='M123.74 158.97h12.37v6.36h-12.37z' transform='matrix(-.35384 .3844 -.45764 -.3157 718.74 331.43)'/%3E %3C/g%3E %3C/g%3E %3Cg fill-rule='evenodd'%3E %3Cpath d='M531.52 453.63l-1.44 14.12s2.18-2.68 2.7-3.57c.53-.88 2.43-3.26 2.83-11.5 0 0-1.48-4.55-2.17-4.54-1.16-.57-1.92 5.49-1.92 5.49zm3.47-31.5s-3.8 22.69-4.18 24.75c0 .7 1.93 2.57 3.32-1.81l2.29-16.49s-1.03-4.39-1.43-6.44z' fill='%23007934' stroke-width='.19231499999999999'/%3E %3Cpath d='M543.56 444.64c-.92-1.16-2.08-2.61-2.2-3.2l-.59 5s3.16 2.3 2.7 6.72l.62-.89.35-1.77s.65-2.94.66-4.7c0 0-.67-.29-1.54-1.16z' fill='%23d52b1e' stroke-width='.19231499999999999'/%3E %3Cpath d='M530.08 467.75s5.23-4.48 5.53-15.07l.65-2.94s.1 2.35 1.16.57c1.02-2.37.97-4.42.97-4.42s1.9-2.38 2.47.55c0 0-1.76 13.83-1.88 15.01a80.2 80.2 0 0 1-.42 3.24s-1.04-1.75-2.09.03c-1.14 1.78-2.94 4.15-6.4 3.03zm6.34-39.17l-2.3 16.49s1.83.85 2.14 4.67c.17 1.76.87.87 1.16.57.38-1.18.1-3.53.1-3.53l1-11.47s-1.99-5.26-2.1-6.73z' fill='%23ffe000' stroke-width='.19231499999999999'/%3E %3Cpath d='M534.6 466.8l-.33 4.12s1.57-.02 2.62-1.8c1.22-1.78 1.67-4.43 1.67-4.43s-1.21-1.74-2.09.03c-.85 1.48-1.86 2.08-1.86 2.08zm2.82-16.49c.84-1.48 1.12-4.13.97-4.42l-1.06.9c.34 1.75.09 3.52.09 3.52z' fill='%23ffe000' stroke-width='.19231499999999999'/%3E %3Cpath d='M542.58 448.65c-.72-1.46-1.94-2.32-1.94-2.32l-2.33 18.54s-.65 4.71-3.56 5.93c0 0 1.66 16.13 6.9 11.65.76-.6 1.7-5.6 1.4-8.54-.37-3.23-1.23-7.62-1.31-9.38-.05-2.06.24-4.14.74-7.38.21-1.18.82-3.76.94-4.06.29-.3-.06-2.69-.84-4.44z' fill='%23d52b1e' stroke-width='.19231499999999999'/%3E %3Cpath d='M545.1 445.8s1.41 1.45 1.68 1.44c.34 0-3.68 30.24-3.68 30.24s.15-3.17-1.03-9.32c-.95-5 .28-11.72 1.36-14.94 0 0 1.27-.95 1.67-7.42z' fill='%23d52b1e' stroke-width='.19231499999999999'/%3E %3Cpath d='M538.4 435.61s-.79 8.53-.97 11.18c0 0 2.65-3.86 3.34-.34l.6-5s-2.31-3.8-2.97-5.84z' fill='%23f7e214' stroke-width='.19231499999999999'/%3E %3Cpath d='M536.36 449.71s-.87-9.56-5.5-2.8c-.18 0-.42 3.8-.15 4.7.14 1.22 1.42 2.72 1.96 3.63 1 1.5 2.1-.34 2.1-.34s1.04-1.53 1.6-5.19z' fill='%23007934' stroke-width='.19231499999999999'/%3E %3C/g%3E %3Cpath d='M586.93 838.9c-1.33-42.47-14.68-113.66-15.34-162.07l-146.33-156s-18.06 119.97-71.2 186.54l232.87 131.61' fill='%23d52b1e' transform='matrix(.1282 -.00603 0 .1282 424.44 266.2)'/%3E %3Cpath d='M597.5 844.43c6.16-29.21 13.55-62.06 18.46-123.54l-94.2-97.24c.38 38.74-43.5 96.6-46.46 168.84' fill='%23ffe000' transform='matrix(.1282 -.00603 0 .1282 424.44 266.2)'/%3E %3Cpath d='M678.73 937.6c10.8-51.25-15.69-58.91 23.72-129.9l-87.05-87.55c-16.22 48.32-27.14 79.4-25.73 121.88l74.17 56.26' fill='%23007934' transform='matrix(.1282 -.00603 0 .1282 424.44 266.2)'/%3E %3Cpath d='M468.05 422.01c-2.26-6.72.8-19.9.47-28.34-.26-5.44 3.75-25.92 3.66-32.12l-22.05-13.77s-.97 22.38-3.5 46.76c-2.29 12.52-2.27 23.97-.63 33.53 2.34 13.58 4.65 19.16 10.14 24.9 9.74 10.09 30.71 4.27 30.71 4.27 17.67-3.66 27.85-14.8 27.85-14.8s-5.75 1.37-15.06 2.31c-20.4-1.43-28.45 3.67-29.08-17.27' fill='%23d52b1e' stroke-width='.19231499999999999'/%3E %3Cpath d='M527.16 435.58l.34-.15c-3.83 1.43-9.16 3.01-9.16 3.01l-12.44.96c-26.97.63-23.6-16.07-22.52-43.02.25-10.22 2.28-23.1 1.76-27.66l-18.08-10.36c-5.9 16.67-4.06 28.32-5.24 36.85-.62 9.18-2.58 27.11.4 34.93 4.21 18.2 18.47 17.47 37.76 15.86 9.57-.79 14.72-3.25 14.72-3.25l12.45-7.16' fill='%23f7e214' stroke-width='.19231499999999999'/%3E %3Cpath d='M527.51 435.21c-3.74 1.94-9.25 3.37-9.25 3.37l-12.6 1.24c-19.55 1.66-31-12.07-28.5-43.13.02-10.97.37-15.85 4.16-30.46l10.75 6.3v1.01c-.61 3.28-2.15 10.96-2.15 14.47 0 24.93 15.77 44.09 37.25 47.34l.34-.15' fill='%23007a3d' stroke-width='.19231499999999999'/%3E %3Cpath d='M456.13 360.23c1.82 3.07 12.7 19.64 18.8 22.78M457.96 371.06c1.82 3.14 15.14 21.8 21.14 22.86M454.91 399.6c3.05 3.65 6.09 10.9 15.14 15.59M459.17 420.34c6.09 5.68 21.15 18.15 35.69 18.66M459.17 429.68c3.05 3.66 9.66 20.76 37.52 13M454.91 432.82c1.82 4.1 15.75 26.96 40.56 18.14' fill='none' stroke-width='.19231499999999999'/%3E %3Cpath d='M483.99 413.8c-2.26-6.71.8-19.89.46-28.33-.25-5.45 2.32-24.28 2.23-30.48l-20.62-15.42s-.96 22.39-3.5 46.77c-2.28 12.52-4.02 27.86-2.33 37.4 2.77 15.64 10.28 20.03 11.64 21.24 10.53 9.38 34.31 8.46 36.67 7.62 17-6.08 24.4-16.87 24.4-16.87s-8.05-.13-17.36.82c-20.41-1.43-30.72-.58-31.35-21.52' fill='%23d52b1e' stroke-width='.19231499999999999'/%3E %3Cpath d='M543.1 427.37l.33-.15c-3.82 1.44-9.16 3.02-9.16 3.02l-12.43.95c-26.97.63-23.6-16.07-22.53-43.01.26-10.23.61-19.41.09-23.97l-16.17-11.8c-5.9 16.67-4.3 26.07-5.48 34.6-.61 9.17-2.57 27.1.4 34.93 4.22 18.2 18.47 17.46 37.76 15.86 9.58-.8 14.73-3.26 14.73-3.26l12.44-7.16' fill='%23ffe000' stroke-width='.19231499999999999'/%3E %3Cpath d='M543.57 427.13c-3.74 1.93-9.24 3.36-9.24 3.36l-12.6 1.25c-19.56 1.66-31-12.08-28.5-43.14.02-10.97-.35-11.74 3.43-26.35 6 3.88 17.44 13.65 17.44 13.65s-3.11 4.38-2.38 10.51c0 24.94 10.03 37.6 31.51 40.85l2.36-20.36' fill='%23007934' stroke-width='.19231499999999999'/%3E %3Cpath d='M472.06 352.03c1.82 3.06 12.7 19.64 18.8 22.77M473.9 362.86c1.82 3.13 15.14 21.8 21.14 22.85M470.85 391.39c3.04 3.65 6.08 10.9 15.14 15.6M475.11 412.14c6.09 5.67 21.14 18.15 35.68 18.66M475.11 421.48c3.05 3.65 9.66 20.75 37.51 13M470.85 424.61c1.82 4.1 15.75 26.96 40.56 18.14' fill='none' stroke-width='.19231499999999999'/%3E %3Cpath d='M450.27 349.95s-.91 7.94-1 9.36c-.42 6.9-.23 12.1.1 15.35-.02.35 1.33 8.59.86 9.03-1.58 1.8-1.64 2-3.3.67-.25-.28.71-8.71.78-9.87.17-1.25.43-11.1.6-15.4.02-1.7 1.48-10.08 1.48-10.08s.2-1.78.47.91' fill='%23e8a30e' stroke-width='.19231499999999999'/%3E %3Cpath d='M450.27 349.95s-.91 7.94-1 9.36c-.42 6.9-.22 12.1.1 15.35-.02.35 1.6 11.82 1.1 9.04-1.58 1.8-1.9 2.49-3.58 1.15-.24-.27.75-9.2.82-10.36.17-1.25.43-11.1.6-15.4.02-1.7 1.48-10.08 1.48-10.08s.2-1.78.47.91l.01.03z' fill='none' stroke-width='.19231499999999999'/%3E %3Cpath d='M450.1 347.16s-1.8 9.52-1.96 14.98c-.24 6.62-.52 8.5-.42 12.36.07.26-.64 4.99-.85 7.04-.15 1.06.15.27-.02.35-1.36.83-2.28.16-3.1-.5-.25-.18 2.18-5.9 2.26-7.06 1.28-16.8 3.72-26.66 3.72-26.66s-.98 5.96.37-.5' fill='%23f7e214' stroke-width='.19231499999999999'/%3E %3Cpath d='M450.1 347.16s-1.8 9.52-1.95 14.98c-.24 6.62-.52 8.5-.42 12.36.07.26-.64 4.99-.85 7.04-.15 1.06.15.27-.02.35-1.36.83-2.28.16-3.1-.49-.25-.19 2.19-5.9 2.26-7.08 1.28-16.81 3.7-26.66 3.7-26.66s-.97 5.96.38-.5zm-.78 27.06s-1.43.64-1.59.28m-.06-1.96s1.22-.03 1.41-.38m-.07-1.64s-.9.59-1.14.22m1.12-2.63l-.87.03m.93-2.37l-.95.03m.8-3.35s-.54.24-.6-.12m.77-2.65l-.78-.04m-.74 14.95s-1.4.2-1.56-.25m1.67-2.98s-1.4.12-1.45-.33m1.5-2s-1.13.04-1.2-.05m1.43-2.18l-1.13-.06m1.12-2.63l-.77-.13m1.08-2.19s-.7.15-.85-.21m.93-2.49s-.63.42-.6-.02m-.08 14s-1.39 0-1.36-.42M466.2 341.74s-.9 7.94-1 9.37c-.41 6.89-.22 12.1.1 15.34-.02.35 1.33 8.6.87 9.03-1.59 1.8-1.64 2.01-3.31.67-.24-.27.72-8.71.8-9.87.15-1.25.41-11.1.59-15.4.02-1.7 1.48-10.07 1.48-10.07s.2-1.78.47.9' fill='%23e8a30e' stroke-width='.19231499999999999'/%3E %3Cpath d='M466.2 341.74s-.9 7.94-1 9.37c-.41 6.89-.2 12.1.1 15.34-.02.35 1.61 11.82 1.1 9.04-1.58 1.81-1.9 2.5-3.57 1.15-.24-.27.75-9.2.82-10.36.16-1.25.42-11.1.6-15.4.02-1.7 1.48-10.07 1.48-10.07s.2-1.78.47.9v.03z' fill='none' stroke-width='.19231499999999999'/%3E %3Cpath d='M466.04 338.96s-1.8 9.51-1.97 14.97c-.23 6.63-.52 8.5-.41 12.36.07.27-.65 4.99-.86 7.04-.15 1.06.16.27-.02.35-1.35.83-2.27.17-3.1-.49-.24-.18 2.2-5.9 2.26-7.07 1.29-16.8 3.72-26.66 3.72-26.66l.38-.5' fill='%23e8a30e' stroke-width='.19231499999999999'/%3E %3Cpath d='M466.04 338.96s-1.8 9.51-1.96 14.97c-.23 6.63-.51 8.5-.4 12.36.06.27-.66 4.99-.87 7.04-.15 1.06.16.27-.02.35-1.35.83-2.27.17-3.1-.49-.24-.18 2.2-5.9 2.26-7.08 1.29-16.8 3.71-26.66 3.71-26.66l.38-.5zm-.78 27.05s-1.43.65-1.59.28m-.06-1.96s1.22-.03 1.41-.37m-.07-1.64s-.9.58-1.14.21m1.12-2.63l-.87.04m.92-2.37l-.95.03m.8-3.36s-.53.24-.6-.11m.77-2.66l-.77-.03m-.75 14.94s-1.4.2-1.55-.25m1.67-2.97s-1.4.11-1.46-.33m1.51-2s-1.13.04-1.21-.05m1.44-2.19l-1.13-.05m1.12-2.64l-.77-.12m1.08-2.2s-.7.15-.85-.2m.93-2.5s-.63.42-.6-.02m-.08 14s-1.4.01-1.36-.41' fill='none' stroke-width='.19231499999999999'/%3E %3Cg fill='%23e8a30e' stroke-width='.22'%3E %3Cpath d='M356.47 216.7s1.26 9.72 1.09 15.26c-.18 6.73 0 8.64-.37 12.55-.08.27.37 5.1.44 7.18.08 1.08-.17.27 0 .36 1.36.9 2.36.27 3.27-.36.35-.17-1.9-6.09-1.9-7.27-.27-17.1-2.19-27.2-2.19-27.2l-.36-.53' transform='matrix(.956 .04296 -.0501 .8197 148.72 137.16)'/%3E %3Cpath d='M356.47 216.7s1.26 9.72 1.08 15.26c-.18 6.73 0 8.64-.37 12.55-.08.27.37 5.1.44 7.18.08 1.08-.17.27 0 .36 1.36.9 2.36.27 3.27-.36.35-.17-1.9-6.09-1.9-7.28-.28-17.1-2.18-27.2-2.18-27.2l-.36-.53zM357.38 244.61s1.45.27 1.64-.18M357.57 241.34s1.45.18 1.45-.27M357.57 238.98s1.17.09 1.27 0M357.47 236.7h1.18M357.65 233.97l.8-.09M357.57 231.6s.62.19.81-.17M357.57 228.87s.62.45.62 0M357.38 243.07s1.45.07 1.45-.36' transform='matrix(.956 .04296 -.0501 .8197 148.72 137.16)'/%3E %3C/g%3E %3Cpath d='M528.15 346.33l1.24.1-1.24-.1z' fill='%23005000' stroke-width='.19231499999999999'/%3E %3Cpath d='M544.89 400.63s-.59-.25-.73 0c0 .13.14.25.29.25.15 0 .44-.25.44-.25zM543.29 402.37s2.47-.25 3.34-.25' fill='%23fff' fill-rule='evenodd' stroke-width='.19231499999999999'/%3E %3Cg%3E %3Cg stroke-width='1.51'%3E %3Cg stroke-width='.19'%3E %3Cpath d='M156.9 89.5c-.03 1.92-3.76 4.27-6.82.32-3.2-2.73-2.73-7.08-.33-7.77l27.82-34.58c1.14-.8 1.22-1.52 1.77-2.27a77.52 77.52 0 0 0 5.45 5.42c-.81.86-1.46 1.67-1.62 2.32L156.9 89.5z' fill='%23e8a30e' fill-rule='evenodd' transform='matrix(2.89906 .09014 -.13563 2.47944 63.82 208.03)' stroke-width='.07'/%3E %3Cg stroke-width='.04' fill-rule='evenodd'%3E %3Cpath d='M123.24 190.48c.84-1.42 4.37 2.18 3.5 3.33-.89 1.16-4.26-1.89-3.5-3.33z' fill='%23e7e7e7' stroke-linejoin='round' transform='matrix(4.63332 .07484 -.13578 3.96195 32.67 -427.9)'/%3E %3Cpath d='M126.42 193.54c-.63.59-3.19-1.82-2.8-2.76.66-.88 3.48 2.19 2.8 2.76z' fill='%23cccccf' transform='matrix(4.63332 .07484 -.13578 3.96195 32.67 -427.9)'/%3E %3C/g%3E %3C/g%3E %3Cpath d='M3513.15 736.64c56.55-19.26 95.95-57.23 120-113.04M3934.48 1159.29c71.13-23.52 119-70.3 139.06-144.9M3964.46 1190.93c71.13-23.52 119-70.3 139.06-144.89M4138.5 1357.47c71.12-23.52 127.32-76.13 147.38-150.72M4169.3 1389.11c71.13-23.52 128.16-76.96 148.22-151.55' fill='none' transform='matrix(-.1253 .00359 .00348 .12902 1025.18 248.4)'/%3E %3Cpath d='M4338.34 1405.77c4.01 16.34 13.42 21.21 26.23 15.82M4192.59 1403.14c28.07 40.4 57.66 27.18 82.72 26.9' fill='none' stroke-linecap='round' transform='matrix(-.1253 .00359 .00348 .12902 1025.18 248.4)'/%3E %3Cpath d='M4375.22 1406.93c.31 11-9.01 20.16-20.85 20.47-11.84.32-21.72-8.32-22.09-19.32-.37-11 8.9-20.2 20.74-20.57 11.84-.38 21.76 11.55 22.2 22.55' fill='%23e8a30e' transform='matrix(-.1253 .00359 .00348 .12902 1025.18 248.4)'/%3E %3Cpath d='M4336.24 1403.84c4.01 16.34 13.42 21.21 26.23 15.82M4192.59 1403.14c28.07 40.4 57.66 27.18 82.72 26.9' fill='none' stroke-linecap='round' transform='matrix(-.1253 .00359 .00348 .12902 1025.18 248.4)'/%3E %3C/g%3E %3C/g%3E %3Cg%3E %3Cg fill-rule='evenodd'%3E %3Cpath d='M568.48 453.63l1.44 14.12s-2.18-2.68-2.7-3.57c-.53-.88-2.43-3.26-2.83-11.5 0 0 1.48-4.55 2.17-4.54 1.16-.57 1.92 5.49 1.92 5.49zm-3.47-31.5s3.8 22.69 4.18 24.75c0 .7-1.93 2.57-3.32-1.81l-2.29-16.49s1.03-4.39 1.43-6.44z' fill='%23007934' stroke-width='.19231499999999999'/%3E %3Cpath d='M556.44 444.64c.92-1.16 2.08-2.61 2.2-3.2l.59 5s-3.15 2.3-2.7 6.72l-.62-.89-.35-1.77s-.65-2.94-.66-4.7c0 0 .67-.29 1.54-1.16z' fill='%23d52b1e' stroke-width='.19231499999999999'/%3E %3Cpath d='M569.92 467.75s-5.23-4.48-5.53-15.07l-.65-2.94s-.1 2.35-1.16.57c-1.02-2.37-.97-4.42-.97-4.42s-1.9-2.38-2.47.55a2814 2814 0 0 0 2.3 18.25s1.04-1.75 2.09.03c1.14 1.78 2.94 4.15 6.4 3.03zm-6.34-39.17l2.3 16.49s-1.83.85-2.14 4.67c-.17 1.76-.87.87-1.16.57-.38-1.18-.1-3.53-.1-3.53l-1-11.47s1.99-5.26 2.1-6.73z' fill='%23ffe000' stroke-width='.19231499999999999'/%3E %3Cpath d='M565.4 466.8l.33 4.12s-1.57-.02-2.62-1.8c-1.22-1.78-1.67-4.43-1.67-4.43s1.21-1.74 2.09.03c.85 1.48 1.86 2.08 1.86 2.08zm-2.82-16.49c-.84-1.48-1.12-4.13-.97-4.42l1.06.9c-.34 1.75-.09 3.52-.09 3.52z' fill='%23ffe000' stroke-width='.19231499999999999'/%3E %3Cpath d='M557.42 448.65c.72-1.46 1.94-2.32 1.94-2.32l2.33 18.54s.65 4.71 3.56 5.93c0 0-1.66 16.13-6.9 11.65-.76-.6-1.7-5.6-1.4-8.54.37-3.23 1.23-7.62 1.31-9.38.05-2.06-.24-4.14-.74-7.38-.21-1.18-.82-3.76-.94-4.06-.29-.3.06-2.69.84-4.44z' fill='%23d52b1e' stroke-width='.19231499999999999'/%3E %3Cpath d='M554.9 445.8s-1.41 1.45-1.68 1.44c-.34 0 3.68 30.24 3.68 30.24s-.15-3.17 1.03-9.32c.95-5-.28-11.72-1.36-14.94 0 0-1.27-.95-1.67-7.42z' fill='%23d52b1e' stroke-width='.19231499999999999'/%3E %3Cpath d='M561.6 435.61s.79 8.53.97 11.18c0 0-2.65-3.86-3.34-.34l-.6-5s2.31-3.8 2.97-5.84z' fill='%23f7e214' stroke-width='.19231499999999999'/%3E %3Cpath d='M563.64 449.71s.87-9.56 5.5-2.8c.18 0 .42 3.8.15 4.7-.14 1.22-1.42 2.72-1.96 3.63-1 1.5-2.1-.34-2.1-.34s-1.04-1.53-1.6-5.19z' fill='%23007934' stroke-width='.19231499999999999'/%3E %3C/g%3E %3Cpath d='M586.93 838.9c-1.33-42.47-14.68-113.66-15.34-162.07l-146.33-156s-18.06 119.97-71.2 186.54l232.87 131.61' fill='%23d52b1e' transform='matrix(-.1282 -.00603 0 .1282 675.56 266.2)'/%3E %3Cpath d='M597.5 844.43c6.16-29.21 13.55-62.06 18.46-123.54l-94.2-97.24c.38 38.74-43.5 96.6-46.46 168.84' fill='%23ffe000' transform='matrix(-.1282 -.00603 0 .1282 675.56 266.2)'/%3E %3Cpath d='M678.73 937.6c10.8-51.25-15.69-58.91 23.72-129.9l-87.05-87.55c-16.22 48.32-27.14 79.4-25.73 121.88l74.17 56.26' fill='%23007934' transform='matrix(-.1282 -.00603 0 .1282 675.56 266.2)'/%3E %3Cpath d='M631.95 422.01c2.26-6.72-.8-19.9-.47-28.34.26-5.44-3.75-25.92-3.66-32.12l22.05-13.77s.97 22.38 3.5 46.76c2.29 12.52 2.27 23.97.63 33.53-2.34 13.58-4.65 19.16-10.14 24.9-9.74 10.09-30.71 4.27-30.71 4.27-17.67-3.66-27.85-14.8-27.85-14.8s5.75 1.37 15.06 2.31c20.4-1.43 28.45 3.67 29.08-17.27' fill='%23d52b1e' stroke-width='.19231499999999999'/%3E %3Cpath d='M572.84 435.58l-.34-.15c3.83 1.43 9.16 3.01 9.16 3.01l12.44.96c26.97.63 23.6-16.07 22.52-43.02-.25-10.22-2.28-23.1-1.76-27.66l18.08-10.36c5.9 16.67 4.06 28.32 5.24 36.85.62 9.18 2.58 27.11-.4 34.93-4.21 18.2-18.47 17.47-37.76 15.86-9.57-.79-14.72-3.25-14.72-3.25l-12.45-7.16' fill='%23f7e214' stroke-width='.19231499999999999'/%3E %3Cpath d='M572.49 435.21c3.74 1.94 9.25 3.37 9.25 3.37l12.6 1.24c19.55 1.66 31-12.07 28.5-43.13-.02-10.97-.37-15.85-4.16-30.46l-10.75 6.3v1.01c.61 3.28 2.15 10.96 2.15 14.47 0 24.93-15.77 44.09-37.25 47.34l-.34-.15' fill='%23007a3d' stroke-width='.19231499999999999'/%3E %3Cpath d='M643.87 360.23c-1.82 3.07-12.7 19.64-18.8 22.78M642.04 371.06c-1.82 3.14-15.14 21.8-21.14 22.86M645.09 399.6c-3.05 3.65-6.09 10.9-15.14 15.59M640.83 420.34c-6.09 5.68-21.15 18.15-35.69 18.66M640.83 429.68c-3.05 3.66-9.66 20.76-37.52 13M645.09 432.82c-1.82 4.1-15.75 26.96-40.56 18.14' fill='none' stroke-width='.19231499999999999'/%3E %3Cpath d='M616.01 413.8c2.26-6.71-.8-19.89-.46-28.33.25-5.45-2.32-24.28-2.23-30.48l20.62-15.42s.96 22.39 3.5 46.77c2.28 12.52 4.02 27.86 2.33 37.4-2.77 15.64-10.28 20.03-11.64 21.24-10.53 9.38-34.31 8.46-36.67 7.62-17-6.08-24.4-16.87-24.4-16.87s8.05-.13 17.36.82c20.41-1.43 30.72-.58 31.35-21.52' fill='%23d52b1e' stroke-width='.19231499999999999'/%3E %3Cpath d='M556.9 427.37l-.33-.15c3.82 1.44 9.16 3.02 9.16 3.02l12.43.95c26.97.63 23.6-16.07 22.53-43.01-.26-10.23-.61-19.41-.09-23.97l16.17-11.8c5.9 16.67 4.3 26.07 5.48 34.6.61 9.17 2.57 27.1-.4 34.93-4.22 18.2-18.47 17.46-37.76 15.86-9.58-.8-14.73-3.26-14.73-3.26l-12.44-7.16' fill='%23ffe000' stroke-width='.19231499999999999'/%3E %3Cpath d='M556.43 427.13c3.74 1.93 9.24 3.36 9.24 3.36l12.6 1.25c19.56 1.66 31-12.08 28.5-43.14-.02-10.97.35-11.74-3.43-26.35-6 3.88-17.44 13.65-17.44 13.65s3.11 4.38 2.38 10.51c0 24.94-10.03 37.6-31.51 40.85l-2.36-20.36' fill='%23007934' stroke-width='.19231499999999999'/%3E %3Cpath d='M627.94 352.03c-1.82 3.06-12.7 19.64-18.8 22.77M626.1 362.86c-1.82 3.13-15.14 21.8-21.14 22.85M629.15 391.39c-3.04 3.65-6.08 10.9-15.14 15.6M624.89 412.14c-6.09 5.67-21.14 18.15-35.68 18.66M624.89 421.48c-3.05 3.65-9.66 20.75-37.51 13M629.15 424.61c-1.82 4.1-15.75 26.96-40.56 18.14' fill='none' stroke-width='.19231499999999999'/%3E %3Cpath d='M649.73 349.95s.91 7.94 1 9.36c.42 6.9.23 12.1-.1 15.35.02.35-1.33 8.59-.86 9.03 1.58 1.8 1.64 2 3.3.67.25-.28-.71-8.71-.78-9.87-.17-1.25-.43-11.1-.6-15.4-.02-1.7-1.48-10.08-1.48-10.08s-.2-1.78-.47.91' fill='%23f7e214' stroke-width='.19231499999999999'/%3E %3Cpath d='M649.73 349.95s.91 7.94 1 9.36c.42 6.9.22 12.1-.1 15.35.02.35-1.6 11.82-1.1 9.04 1.58 1.8 1.9 2.49 3.58 1.15.24-.27-.75-9.2-.82-10.36-.17-1.25-.43-11.1-.6-15.4-.02-1.7-1.48-10.08-1.48-10.08s-.2-1.78-.47.91l-.01.03z' fill='%23e8a30e' stroke-width='.19231499999999999'/%3E %3Cpath d='M649.9 347.16s1.8 9.52 1.96 14.98c.24 6.62.52 8.5.42 12.36-.07.26.64 4.99.85 7.04.15 1.06-.15.27.02.35 1.36.83 2.28.16 3.1-.5.25-.18-2.18-5.9-2.26-7.06-1.28-16.8-3.72-26.66-3.72-26.66s.98 5.96-.37-.5' fill='%23f7e214' stroke-width='.19231499999999999'/%3E %3Cpath d='M649.9 347.16s1.8 9.52 1.95 14.98c.24 6.62.52 8.5.42 12.36-.07.26.64 4.99.85 7.04.15 1.06-.15.27.02.35 1.36.83 2.28.16 3.1-.49.25-.19-2.19-5.9-2.26-7.08-1.28-16.81-3.7-26.66-3.7-26.66s.97 5.96-.38-.5zm.78 27.06s1.43.64 1.59.28m.06-1.96s-1.22-.03-1.41-.38m.07-1.64s.9.59 1.14.22m-1.12-2.63l.87.03m-.93-2.37l.95.03m-.8-3.35s.54.24.6-.12m-.77-2.65l.78-.04m.74 14.95s1.4.2 1.56-.25m-1.67-2.98s1.4.12 1.45-.33m-1.5-2s1.13.04 1.2-.05m-1.43-2.18l1.13-.06m-1.12-2.63l.77-.13m-1.08-2.19s.7.15.85-.21m-.93-2.49s.63.42.6-.02m.08 14s1.39 0 1.36-.42' fill='%23e8a30e' stroke-width='.19231499999999999'/%3E %3Cpath d='M633.8 341.74s.9 7.94 1 9.37c.41 6.89.22 12.1-.1 15.34.02.35-1.33 8.6-.87 9.03 1.59 1.8 1.64 2.01 3.31.67.24-.27-.72-8.71-.79-9.87-.16-1.25-.42-11.1-.6-15.4-.02-1.7-1.48-10.07-1.48-10.07s-.2-1.78-.47.9' fill='%23f7e214' stroke-width='.19231499999999999'/%3E %3Cpath d='M633.8 341.74s.9 7.94 1 9.37c.41 6.89.2 12.1-.1 15.34.02.35-1.61 11.82-1.1 9.04 1.58 1.81 1.9 2.5 3.57 1.15.24-.27-.75-9.2-.82-10.36-.16-1.25-.42-11.1-.6-15.4-.02-1.7-1.48-10.07-1.48-10.07s-.2-1.78-.47.9v.03z' fill='%23e8a30e' stroke-width='.19231499999999999'/%3E %3Cpath d='M633.96 338.96s1.8 9.51 1.97 14.97c.23 6.63.52 8.5.41 12.36-.07.27.65 4.99.86 7.04.15 1.06-.16.27.02.35 1.35.83 2.27.17 3.1-.49.24-.18-2.2-5.9-2.26-7.07-1.29-16.8-3.72-26.66-3.72-26.66l-.38-.5' fill='%23f7e214' stroke-width='.19231499999999999'/%3E %3Cpath d='M633.96 338.96s1.8 9.51 1.96 14.97c.23 6.63.51 8.5.4 12.36-.06.27.66 4.99.87 7.04.15 1.06-.16.27.02.35 1.35.83 2.27.17 3.1-.49.24-.18-2.2-5.9-2.26-7.08-1.29-16.8-3.71-26.66-3.71-26.66l-.38-.5zm.78 27.05s1.43.65 1.59.28m.06-1.96s-1.22-.03-1.41-.37m.07-1.64s.9.58 1.14.21m-1.12-2.63l.87.04m-.92-2.37l.95.03m-.8-3.36s.53.24.6-.11m-.77-2.66l.77-.03m.75 14.94s1.4.2 1.55-.25m-1.67-2.97s1.4.11 1.46-.33m-1.51-2s1.13.04 1.21-.05m-1.44-2.19l1.13-.05m-1.12-2.64l.77-.12m-1.08-2.2s.7.15.85-.2m-.93-2.5s.63.42.6-.02m.08 14s1.4.01 1.36-.41' fill='%23e8a30e' stroke-width='.19231499999999999'/%3E %3Cg fill='%23e8a30e' stroke-width='.22'%3E %3Cpath d='M356.47 216.7s1.26 9.72 1.09 15.26c-.18 6.73 0 8.64-.37 12.55-.08.27.37 5.1.44 7.18.08 1.08-.17.27 0 .36 1.36.9 2.36.27 3.27-.36.35-.17-1.9-6.09-1.9-7.27-.27-17.1-2.19-27.2-2.19-27.2l-.36-.53' transform='matrix(-.956 .04296 .0501 .8197 951.28 137.16)'/%3E %3Cpath d='M356.47 216.7s1.26 9.72 1.08 15.26c-.18 6.73 0 8.64-.37 12.55-.08.27.37 5.1.44 7.18.08 1.08-.17.27 0 .36 1.36.9 2.36.27 3.27-.36.35-.17-1.9-6.09-1.9-7.28-.28-17.1-2.18-27.2-2.18-27.2l-.36-.53zM357.38 244.61s1.45.27 1.64-.18M357.57 241.34s1.45.18 1.45-.27M357.57 238.98s1.17.09 1.27 0M357.47 236.7h1.18M357.65 233.97l.8-.09M357.57 231.6s.62.19.81-.17M357.57 228.87s.62.45.62 0M357.38 243.07s1.45.07 1.45-.36' transform='matrix(-.956 .04296 .0501 .8197 951.28 137.16)'/%3E %3C/g%3E %3Cpath d='M571.85 346.33l-1.24.1 1.24-.1z' fill='%23005000' stroke-width='.19231499999999999'/%3E %3Cpath d='M555.11 400.63s.59-.25.73 0c0 .13-.14.25-.29.25-.15 0-.44-.25-.44-.25zM556.71 402.37s-2.47-.25-3.34-.25' fill='%23fff' fill-rule='evenodd' stroke-width='.19231499999999999'/%3E %3C/g%3E %3Cg%3E %3Cpath d='M505.73 336.68c-.05-3.28 3.05-5.18 3.52-5.5 1.52-1.02 2.55-1.91 5.82-2.34 0 0 .22.68.2 1.26 0 .58-.72 2.6-3.23 4.29-2.56 1.73-6.31 2.3-6.31 2.3z' fill='%23d52b1e' stroke-width='.19231499999999999'/%3E %3Cpath d='M505.7 335.43L552 395.56l2.2-2.17-47.25-61.08-1.27 3.12z' fill='%23a05a2c' fill-rule='evenodd' stroke-width='.19231499999999999'/%3E %3Cpath d='M504.98 323.69s5-.52 4.35-3.39c-.71-2.83-4.09-2.78-5.5-2.9-1.45-.1-6.05.96-7.41 2.33-1.41 1.4-4.29 3.8-3.36 7.8a31.27 31.27 0 0 0 3.6 9.3 7.63 7.63 0 0 1 .7 6.14c-.12.46-.58 1.99.68 2.54 1.84.79 2.3.8 3.9-.99 1.64-1.74 3.83-4.56 3.79-7.84-.05-3.28 3.05-5.18 3.52-5.5 1.52-1.02 2.55-1.91 5.82-2.34 0 0-1.16-1.89-2.9-1.8-1.78.06-5.3-1.5-7.2-3.35z' fill='%23d52b1e' stroke-width='.19231499999999999'/%3E %3Cpath d='M504.98 323.69s5-.52 4.35-3.39c-.71-2.83-4.09-2.78-5.5-2.9-1.45-.1-6.05.96-7.41 2.33-1.41 1.4-4.29 3.8-3.36 7.8a31.27 31.27 0 0 0 3.6 9.3 7.63 7.63 0 0 1 .7 6.14c-.12.46-.58 1.99.68 2.54 1.84.79 2.3.8 3.9-.99 1.64-1.74 3.83-4.56 3.79-7.84-.05-3.28 3.05-5.18 3.52-5.5 1.52-1.02 2.55-1.91 5.82-2.34 0 0-1.16-1.89-2.9-1.8-1.78.06-5.3-1.5-7.2-3.35z' fill='none' stroke-width='.19231499999999999'/%3E %3Cpath d='M504.98 323.69c-.68 0-2.68-.87-4.06-.38-1.35.53-4.15 2.17-3.7 4.54M513.51 327.53s-2.89 1.2-4.92 2.57c-.86.58-3.69 3.2-5.51 5.06-1.62 1.6-1.97 3.75-5.43 6.1M511.7 327.11c-.6.53-1.2 1.06-2.21 1.62-.97.53-1.28 1.37-1.9 2.04' fill='none' stroke-width='.19231499999999999'/%3E %3C/g%3E %3Cg%3E %3Cg stroke-width='1.51'%3E %3Cg stroke-width='.19'%3E %3Cpath d='M156.9 89.5c-.03 1.92-3.76 4.27-6.82.32-3.2-2.73-2.73-7.08-.33-7.77l27.82-34.58c1.14-.8 1.22-1.52 1.77-2.27a77.52 77.52 0 0 0 5.45 5.42c-.81.86-1.46 1.67-1.62 2.32L156.9 89.5z' fill='%23e8a30e' fill-rule='evenodd' transform='matrix(-2.89906 .09014 .13563 2.47944 1036.18 208.03)' stroke-width='.07'/%3E %3Cg stroke-width='.04' fill-rule='evenodd'%3E %3Cpath d='M123.24 190.48c.84-1.42 4.37 2.18 3.5 3.33-.89 1.16-4.26-1.89-3.5-3.33z' fill='%23e7e7e7' stroke-linejoin='round' transform='matrix(-4.63332 .07484 .13578 3.96195 1067.33 -427.9)'/%3E %3Cpath d='M126.42 193.54c-.63.59-3.19-1.82-2.8-2.76.66-.88 3.48 2.19 2.8 2.76z' fill='%23cccccf' transform='matrix(-4.63332 .07484 .13578 3.96195 1067.33 -427.9)'/%3E %3C/g%3E %3C/g%3E %3Cpath d='M3513.15 736.64c56.55-19.26 95.95-57.23 120-113.04M3934.48 1159.29c71.13-23.52 119-70.3 139.06-144.9M3964.46 1190.93c71.13-23.52 119-70.3 139.06-144.89M4138.5 1357.47c71.12-23.52 127.32-76.13 147.38-150.72M4169.3 1389.11c71.13-23.52 128.16-76.96 148.22-151.55' fill='none' transform='matrix(.1253 .00359 -.00348 .12902 74.82 248.4)'/%3E %3Cpath d='M4338.34 1405.77c4.01 16.34 13.42 21.21 26.23 15.82M4192.59 1403.14c28.07 40.4 57.66 27.18 82.72 26.9' fill='none' stroke-linecap='round' transform='matrix(.1253 .00359 -.00348 .12902 74.82 248.4)'/%3E %3Cpath d='M4375.22 1406.93c.31 11-9.01 20.16-20.85 20.47-11.84.32-21.72-8.32-22.09-19.32-.37-11 8.9-20.2 20.74-20.57 11.84-.38 21.76 11.55 22.2 22.55' fill='%23e8a30e' transform='matrix(.1253 .00359 -.00348 .12902 74.82 248.4)'/%3E %3Cpath d='M4336.24 1403.84c4.01 16.34 13.42 21.21 26.23 15.82M4192.59 1403.14c28.07 40.4 57.66 27.18 82.72 26.9' fill='none' stroke-linecap='round' transform='matrix(.1253 .00359 -.00348 .12902 74.82 248.4)'/%3E %3C/g%3E %3C/g%3E %3C/g%3E %3Cg fill='%23007934' stroke='%23000' stroke-width='2.16'%3E %3Cpath d='M580.7 274.25c2.78 4.43 6.89 12.44 8.01 18.57 2.07 11.31-1.17 23.85-11.02 32.71-8.03 7.22-20.63 9.46-25.89 10.53-5.25 1.08-9.04 2.77-9.91 3.93-.05-.82-.16-1.63.71-2.45 2.5-1.1 6.54-1.75 12.18-2.91 11.33-2.34 23.23-6.58 29.71-18.95 8.46-16.12 3.42-28.79-3.9-41.37l.11-.06z' fill-rule='evenodd' stroke-width='.19202400000000003'/%3E %3Cpath d='M148.4 484.16a5.78 8.12 0 1 1-11.56 0 5.78 8.12 0 1 1 11.56 0z' transform='matrix(.0845 .08154 -.07896 .07515 609.5 273.75)' fill='%23d52b1e' stroke-width='1.7'/%3E %3Cpath d='M591.52 320.22c-1.68 1-3.35 1.26-4.69 1.7-1.03.35-2.81.91-3.43 1.14-.58.22-1.5.64-2.28.99-1.24.56-2.58 2.12-2.58 2.12s1.89 1.98 4.14 1.7c1.77-.22 2.66-.7 3.54-1.14.92-.45.9-.96 2.23-1.91 1.47-1.06 2.5-3.15 3.07-4.6zM582.7 322.09c-.55.84-1.84.78-2.58.66l-.33.42c1.01.02 2.4.03 3.1-.88-.02-.14-.1-.2-.2-.2z' fill-rule='evenodd' stroke-width='.19202400000000003'/%3E %3Cpath d='M591.5 320.3c-1.52 1.48-4.37 3.13-7.23 4.35a21.94 21.94 0 0 1-7.81 1.6l-.42.45c2.31-.21 5.37-.63 7.95-1.7 3.38-1.38 6.15-3.16 7.53-4.62l-.02-.09zM587.79 327.44c-3.05-.1-4.72.84-7.55 1.46-2.64.58-5.73-.8-7.44 1.75 6.88 4.46 11.86 1.46 14.99-3.2z' fill-rule='evenodd' stroke-width='.19202400000000003'/%3E %3Cpath d='M581.6 333.7c-1.32-1.13-12.59-4.94-14.38-.68 2.68 2.96 10.52 3.62 14.37.67z' fill-rule='evenodd' stroke-width='.19202400000000003'/%3E %3Cpath d='M578.92 336.7c-1.19-.2-2.59-.47-3.96-.63-1.38-.16-1.92-.4-2.93-.54-1.67-.23-3.58-2.56-9.44-.78 2.27 5.23 10.02 6.33 16.33 1.94zM581.46 333.78c-6 1.2-13.06 0-15.85-1.65l-.44.3c6.43 2.74 12.68 2.38 16.29 1.35zM587.7 327.44c-3.54 2.37-8.1 4.14-17.86 2.83l-.13.34c13.37 1.15 14.7-1.3 17.98-3.17z' fill-rule='evenodd' stroke-width='.19202400000000003'/%3E %3Cpath d='M578.88 336.74c-4.67.16-7.3 2.24-16.03-2.06-.72-.35-1.67-.6-2.22-.86l-.8.3c.6.27 1.59.26 2.13.5 10.92 4.82 10.61 2.57 16.92 2.12z' fill-rule='evenodd' stroke-width='.19202400000000003'/%3E %3Cpath d='M148.4 484.16a5.78 8.12 0 1 1-11.56 0 5.78 8.12 0 1 1 11.56 0z' transform='matrix(-.05923 -.0996 -.0979 .05129 617.52 320.58)' fill='%23d52b1e' stroke-width='1.7'/%3E %3Cpath d='M561.17 331.64c-1 .26-1.3 1.46-1.39 2.17l-.52.18c.27-.92.64-2.2 1.76-2.57.13.05.17.14.15.22z' fill-rule='evenodd' stroke-width='.19202400000000003'/%3E %3Cpath d='M148.4 484.16a5.78 8.12 0 1 1-11.56 0 5.78 8.12 0 1 1 11.56 0z' transform='matrix(.11688 .02781 -.02616 .1032 585.82 237.8)' fill='%23d52b1e' stroke-width='1.7'/%3E %3Cpath d='M583.78 317.43c-.21-3.26-1.8 1.25-5-6.03-.92-2.11-.91-3.46-1.54-6.64 1.74 2.75 4.65 3.49 5.83 5.6 1.16 2.1.86 5.45.71 7.07z' fill-rule='evenodd' stroke-width='.19202400000000003'/%3E %3Cpath d='M577.3 305s1.57 3.67 3.84 6.27c2.28 2.62 2.7 5.8 2.7 5.8' fill-rule='evenodd' stroke-width='.19202400000000003'/%3E %3Cpath d='M578.86 308.12c2 2.7 4.7 5.9 4.82 9.26l.32.11c-.47-4.41-3.08-6.45-4.7-8.68l-.44-.7zM595.8 312.29c-1.46 1.2-3 1.64-4.21 2.24-.93.46-1.72 1.07-2.27 1.37-.52.3-1.38.42-2.07.87-1.1.7-3.26 3.17-3.26 3.17s2.04 1.68 3.3 1.4c3.69-.71 4.76-2.17 6.62-3.52 1.43-1.18 1.53-3.96 1.9-5.53z' fill-rule='evenodd' stroke-width='.19202400000000003'/%3E %3Cpath d='M582.34 320.06l-.35.5c2.11-.2 5.48-2.23 7.72-3.36 3.01-1.52 4.7-2.67 5.98-4.83-1.44 2.16-3.33 3.38-6.16 4.75-2.38 1.15-5.76 3.1-7.2 2.94z' fill-rule='evenodd' stroke-width='.19202400000000003'/%3E %3Cpath d='M597.06 305.15c-1.23 1.43-2.67 2.1-3.76 2.89-.83.6-1.5 1.33-1.98 1.72-.47.37-1.3.64-1.9 1.19-.95.87-2.38 3.42-2.38 3.42s1.02 1.09 2.22.61c3.71-.46 4.8-2.22 6.18-5.38.77-1.64 1.53-2.84 1.62-4.45z' fill-rule='evenodd' stroke-width='.19202400000000003'/%3E %3Cpath d='M148.4 484.16a5.78 8.12 0 1 1-11.56 0 5.78 8.12 0 1 1 11.56 0z' transform='matrix(-.10957 .0476 .04556 .09693 577.86 257.64)' fill='%23d52b1e' stroke-width='1.7'/%3E %3Cpath d='M585.17 314.98l-.25.55c4.45-2.02 10.28-6.11 12.2-10.27-2.72 4.49-7.2 7.45-11.95 9.72zM598.07 298.28c-1.05 1.49-2.36 2.25-3.33 3.1-.74.64-1.32 1.4-1.75 1.82-.41.4-1.17.71-1.7 1.3-.84.92-2 3.52-2 3.52s1.36 1.27 2.46.73c1.1-.55 2.56-1.8 3.29-2.44.75-.68.94-2.3 1.83-3.55a6.9 6.9 0 0 0 1.2-4.48z' fill-rule='evenodd' stroke-width='.19202400000000003'/%3E %3Cpath d='M594.87 302.87c-2.15 2.46-4.8 4.8-7.3 5.87l-.19.57c4.05-2.3 5.75-4.37 7.54-6.36l-.05-.08zM596.54 294.05c-.73 1.44-1.84 2.3-2.6 3.17-.59.67-1 1.42-1.33 1.84-.32.4-.98.79-1.38 1.37-.63.92-1.26 3.34-1.26 3.34s.92.98 1.86.35a18.3 18.3 0 0 0 2.85-2.6c.6-.7.9-2.2 1.52-3.4.72-1.41.66-2.7.34-4.07zM589.72 292.34c-.4.85-.55 1.68-.8 2.55l-.1-.63c.2-.68.37-1.4.7-2.02.06-.02.13-.02.2.1z' fill-rule='evenodd' stroke-width='.19202400000000003'/%3E %3Cpath d='M594.33 298.5c-1.6 2.44-3.7 4.86-5.86 6.15l-.08.52c3.41-2.58 4.66-4.63 6-6.61l-.06-.06zM585.55 313.96a5.05 5.05 0 0 0-.84-2.1c-.07 0-.13.03-.14.1.46.75.66 1.42.79 2.33l.19-.33z' fill-rule='evenodd' stroke-width='.19202400000000003'/%3E %3Cpath d='M148.4 484.16a5.78 8.12 0 1 1-11.56 0 5.78 8.12 0 1 1 11.56 0z' transform='matrix(.06585 -.05973 .05891 .0576 545.9 264.29)' fill='%23d52b1e' stroke-width='2.25'/%3E %3Cpath d='M586.17 285.2c-.56-.48-1.25-.92-1.95-1.35-.08.03-.09.09-.07.16.81.5 1.52 1 2.12 1.57l-.1-.38zM594.8 285.76c-1.77 3.73-6.02 6.33-4.31 11.8 4.39 3.97 4.67-7.1 4.31-11.8z' fill-rule='evenodd' stroke-width='.19202400000000003'/%3E %3Cpath d='M590.77 277.6c-.72 3.81-4.1 6.96-1.89 12.01 6.23 1.57 3.26-6.82 1.9-12z' fill-rule='evenodd' stroke-width='.19202400000000003'/%3E %3Cpath d='M587.09 271.9c3.13 5.81 3.88 9.18.19 13 0 0-1.94-1.83-2.4-5.18-.4-2.84 1.92-6.23 2.2-7.82z' fill-rule='evenodd' stroke-width='.19202400000000003'/%3E %3Cpath d='M581.9 268.52c.83 3.69-2.37 5.38 2.2 10.13 3.26-3.88 1.7-4.84-2.2-10.13z' fill-rule='evenodd' stroke-width='.19202400000000003'/%3E %3Cpath d='M580.67 274.97c-5.26.57-3.21-4-4.71-8.2 3.1 2.3 7.3 3.23 4.7 8.2zM584.1 281.93c-1.48-6.86-6.2-4.17-8.81-7.2 1.35 4.43 3.33 7.45 8.8 7.2zM586.22 288.32c-4.11-.27-7.44-2.3-9.66-6.85 4.22 1.89 8.9 2.08 9.66 6.85z' fill-rule='evenodd' stroke-width='.19202400000000003'/%3E %3Cpath d='M586.85 294.27c-1.63-1.86-1.67-3.06-2.28-4.3a14.07 14.07 0 0 0-4.76-5.8c.02 4.86.71 10.22 7.04 10.1z' fill-rule='evenodd' stroke-width='.19202400000000003'/%3E %3Cpath d='M587.78 299.34c-2.52-3.51-4.86-6.5-8.68-8.95 1.58 3.45.85 9.84 8.68 8.95z' fill-rule='evenodd' stroke-width='.19202400000000003'/%3E %3Cpath d='M587.07 306.32c-7.75-.22-7.02-7.53-7.08-10.95 1.4 2.1 3.11 3.91 4.38 5.42 1.4 1.64 2.74 3.5 2.7 5.53z' fill-rule='evenodd' stroke-width='.19202400000000003'/%3E %3Cpath d='M586.13 310.67c-.62-1.59-.14-2.23-1.53-3.62-1.49-1.5-4.36-4.2-5.86-7.28-.21 2.73-.25 6.94 1.87 8.36 1.6 1.06 3 1.36 5.52 2.54zM579.37 322c-6.08-4.74-2.43-8.73-1.92-12.26 1.55 3.99 5.9 7.42 1.92 12.25zM581.86 276.4a86.01 86.01 0 0 0-5.75-9.5c3.01 4.35 4.31 7.12 6.04 10.1' fill-rule='evenodd' stroke-width='.19202400000000003'/%3E %3Cpath d='M579.46 323.17c.24-4.81-1.07-8.96-1.92-13.3.8 4.58 1.95 9.2 1.52 13.68l.4-.38zM586.67 311.63c-.63-2.94-6.43-4.9-7.88-11.74 1.19 6.8 7.07 8.52 7.66 12.34l.22-.6zM587.97 307.63l-.16.74c-.86-4.6-6.27-6.87-7.83-13.02 2.28 6.66 6.7 7.54 7.99 12.28zM589.04 300.73c-2.66-4.07-6.39-5.6-9.91-10.37 3.3 4.69 7.45 6.88 9.97 11l-.06-.63zM588.95 295.38c-2.94-1.26-5.98-4.77-9.16-11.2 2.09 4.75 4.73 9.06 9.16 11.92v-.72z' fill-rule='evenodd' stroke-width='.19202400000000003'/%3E %3Cpath d='M587.6 289.1c-3.43-2.7-7.86-4.5-11.05-7.67 2.65 3.02 7.74 5.13 11.14 8.12l-.1-.45zM584.95 282.38c-3.46-2.35-6.79-3.08-9.66-7.53 2.3 4.36 5.98 5.46 9.78 7.86l-.12-.33zM594.8 285.85c-1.24 4.8-2.29 9.85-5.57 13.08l.03-.62c1.5-.84 3.88-5.85 5.54-12.46zM590.8 277.78c-.22 4.96-.14 10.21-2.7 13.03l-.2-.57c2.62-2.12 2.4-7.73 2.9-12.46zM587.28 272.14c.88 4.36.94 8.4-.22 14.93l-.25-.47c.73-3.85 1.55-7.8.47-14.46zM581.99 268.67c1.75 3.7 3.1 7.45 1.95 11.47l-.31-.45c1.36-3.67-.23-7.35-1.64-11.02z' fill-rule='evenodd' stroke-width='.19202400000000003'/%3E %3Cg fill-rule='evenodd'%3E %3Cpath d='M575.2 317.43c2.08 5-.66 8.62-3.9 10.72-2.53-7.26 2.73-6.44 3.9-10.72z' stroke-width='.19202400000000003'/%3E %3Cpath d='M575.3 317.41c.35 3.1-3 6.55-4.05 11.77l-.47.43c1.55-6.37 4.8-8.82 4.51-12.2z' stroke-width='.19202400000000003'/%3E %3C/g%3E %3Cpath d='M148.4 484.16a5.78 8.12 0 1 1-11.56 0 5.78 8.12 0 1 1 11.56 0z' transform='matrix(.08752 .01564 -.0096 .08183 578.72 241.2)' fill='%23d52b1e' stroke-width='2.25'/%3E %3Cpath d='M586.76 285.87c.04-.74-.04-1.55-.12-2.37-.07-.05-.12-.02-.17.04.1.95.13 1.81.05 2.64l.24-.31z' fill-rule='evenodd' stroke-width='.19202400000000003'/%3E %3Cpath d='M148.4 484.16a5.78 8.12 0 1 1-11.56 0 5.78 8.12 0 1 1 11.56 0z' transform='matrix(.06806 -.0338 .01538 .06954 568.1 253.97)' fill='%23d52b1e' stroke-width='2.65'/%3E %3Cpath d='M586.18 284.93c-.17-.6-.45-1.2-.74-1.8-.06 0-.1.04-.1.11.32.7.59 1.37.75 2.06l.1-.37z' fill-rule='evenodd' stroke-width='.19202400000000003'/%3E %3Cpath d='M148.4 484.16a5.78 8.12 0 1 1-11.56 0 5.78 8.12 0 1 1 11.56 0z' transform='matrix(.08889 -.00182 .00663 .08212 572.2 252.5)' fill='%23d52b1e' stroke-width='2.25'/%3E %3Cpath d='M588.84 294.72c-.1-.73-.34-1.52-.59-2.3-.08-.03-.12 0-.15.07.28.92.49 1.75.57 2.58l.17-.35z' fill-rule='evenodd' stroke-width='.19202400000000003'/%3E %3Cpath d='M148.4 484.16a5.78 8.12 0 1 1-11.56 0 5.78 8.12 0 1 1 11.56 0z' transform='matrix(.06188 -.0663 .05536 .06394 550.9 271.43)' fill='%23d52b1e' stroke-width='2.2'/%3E %3Cpath d='M588.74 294.65a13.93 13.93 0 0 0-1.83-1.5c-.07.03-.08.1-.06.17a13.4 13.4 0 0 1 1.99 1.75l-.1-.42z' fill-rule='evenodd' stroke-width='.19202400000000003'/%3E %3Cpath d='M148.4 484.16a5.78 8.12 0 1 1-11.56 0 5.78 8.12 0 1 1 11.56 0z' transform='matrix(.083 .03187 -.02487 .07855 586.21 268.38)' fill='%23d52b1e' stroke-width='2.25'/%3E %3Cpath d='M585.69 313.76c.18-.72.25-1.53.32-2.35-.06-.06-.11-.05-.17 0-.09.96-.21 1.81-.45 2.6l.3-.25z' fill-rule='evenodd' stroke-width='.19202400000000003'/%3E %3Cpath d='M148.4 484.16a5.78 8.12 0 1 1-11.56 0 5.78 8.12 0 1 1 11.56 0z' transform='matrix(-.06585 -.05973 -.05891 .0576 625.76 293.28)' fill='%23d52b1e' stroke-width='2.25'/%3E %3Cpath d='M585.5 314.2c.55-.48 1.24-.92 1.94-1.35.09.03.1.09.07.16-.8.5-1.51 1-2.12 1.57l.1-.38z' fill-rule='evenodd' stroke-width='.19202400000000003'/%3E %3Cpath d='M148.4 484.16a5.78 8.12 0 1 1-11.56 0 5.78 8.12 0 1 1 11.56 0z' transform='matrix(.05877 .0667 -.05844 .05807 601.94 282.16)' fill='%23d52b1e' stroke-width='2.25'/%3E %3Cpath d='M580.44 322.12c.5-.55.94-1.23 1.38-1.93-.03-.08-.09-.09-.16-.07-.52.8-1.02 1.5-1.6 2.1l.38-.1z' fill-rule='evenodd' stroke-width='.19202400000000003'/%3E %3Cpath d='M148.4 484.16a5.78 8.12 0 1 1-11.56 0 5.78 8.12 0 1 1 11.56 0z' transform='matrix(-.11967 -.0134 -.01416 .10528 604.06 270.57)' fill='%23d52b1e' stroke-width='1.7'/%3E %3Cpath d='M580.28 320.42c-.37.95-.1 1.31.11 1.72l-.23.49c-.32-.55-.45-1.14-.16-2.27.14-.05.23-.01.28.06zM561.35 335.09c-1.04.08-1.56-.5-1.9-1.13h-.55c.58.78 1.2 1.4 2.4 1.39.1-.1.1-.2.05-.26z' fill-rule='evenodd' stroke-width='.19202400000000003'/%3E %3Cpath d='M148.4 484.16a5.78 8.12 0 1 1-11.56 0 5.78 8.12 0 1 1 11.56 0z' transform='matrix(-.02645 .11159 -.10932 -.0223 618.28 330.4)' fill='%23d52b1e' stroke-width='1.7'/%3E %3Cpath d='M569.83 322a8.61 8.61 0 0 1-6.26 9.94c-1.38-6.2 4.34-6.43 6.26-9.94z' fill-rule='evenodd' stroke-width='.19202400000000003'/%3E %3Cpath d='M569.84 322.04a33.7 33.7 0 0 1-7.43 11.17l-.8.1c4.19-3.31 6.5-7.63 8.23-11.27z' fill-rule='evenodd' stroke-width='.19202400000000003'/%3E %3Cpath d='M148.4 484.16a5.78 8.12 0 1 1-11.56 0 5.78 8.12 0 1 1 11.56 0z' transform='matrix(.05417 .0985 -.0893 .02218 597.38 307.93)' fill='%23d52b1e' stroke-width='1.92'/%3E %3Cpath d='M559.23 334.05c.77-.24 1.52-.65 2.27-1.07-.01-.09-.08-.13-.17-.15-.88.47-1.71.85-2.6 1.1l.5.12z' fill-rule='evenodd' stroke-width='.19202400000000003'/%3E %3Cg stroke-width='2.42' fill-rule='evenodd'%3E %3Cpath d='M563.33 326.25c-.2 1.93-1.72 3.67-3.13 5.03-1.4 1.36-1.55 1.86-3.53 2.45-1.9-4.33 4.46-5.19 6.66-7.48z' stroke-width='.192027'/%3E %3Cpath d='M563.32 326.2c-2.13 3.97-5.5 5.92-7.34 8.48l-.27-.02c2.64-3.48 4.88-4.14 7.6-8.46z' stroke-width='.192027'/%3E %3C/g%3E %3Cg%3E %3Cpath d='M519.41 274.25c-2.77 4.43-6.89 12.44-8 18.57-2.08 11.31 1.16 23.85 11.01 32.71 8.03 7.22 20.63 9.46 25.9 10.53 5.24 1.08 9.04 2.77 9.9 3.93.05-.82.17-1.63-.7-2.45-2.5-1.1-6.55-1.75-12.18-2.91-11.33-2.34-23.24-6.58-29.72-18.95-8.46-16.12-3.42-28.79 3.9-41.37l-.11-.06z' fill-rule='evenodd' stroke-width='.19202400000000003'/%3E %3Cg stroke-width='1.7'%3E %3Cpath d='M-609.04 575.42c2.99-5.86 54.13-52.97 100.64-49.44 34.05 2.58 39.68 11.2 39.68 11.2s3.18 8.86-27.06 15.36c-30.54 6.56-83.49 28.46-113.26 22.88z' fill-rule='evenodd' transform='matrix(-.11577 0 0 -.11026 470.28 397.17)'/%3E %3Cpath d='M-470.4 536.96c-36.55-4.34-73.8 11.16-102.96 22.85' transform='matrix(-.11577 0 0 -.11026 470.28 397.17)'/%3E %3C/g%3E %3Cg stroke-width='2.8'%3E %3Cpath d='M-609.04 575.42c2.99-5.86 54.13-52.97 100.64-49.44 34.05 2.58 39.68 11.2 39.68 11.2s3.18 8.86-27.06 15.36c-30.54 6.56-83.49 28.46-113.26 22.88z' fill-rule='evenodd' transform='matrix(.0444 .06862 -.05494 .02167 594.9 355.34)'/%3E %3Cpath d='M-470.4 536.96c-36.55-4.34-73.8 11.16-102.96 22.85' transform='matrix(.0444 .06862 -.05494 .02167 594.9 355.34)'/%3E %3C/g%3E %3Cg stroke-width='2.65'%3E %3Cpath d='M-609.04 575.42c2.99-5.86 54.13-52.97 100.64-49.44 34.05 2.58 39.68 11.2 39.68 11.2s3.18 8.86-27.06 15.36c-30.54 6.56-83.49 28.46-113.26 22.88z' fill-rule='evenodd' transform='matrix(.05524 -.03793 .04771 .06236 525.35 215.78)'/%3E %3Cpath d='M-470.4 536.96c-36.55-4.34-73.8 11.16-102.96 22.85' transform='matrix(.05524 -.03793 .04771 .06236 525.35 215.78)'/%3E %3C/g%3E %3Cg stroke-width='3.12'%3E %3Cpath d='M-609.04 575.42c2.99-5.86 54.13-52.97 100.64-49.44 34.05 2.58 39.68 11.2 39.68 11.2s3.18 8.86-27.06 15.36c-30.54 6.56-83.49 28.46-113.26 22.88z' fill-rule='evenodd' transform='matrix(.02243 -.06172 .053 .0239 500.95 225.9)'/%3E %3Cpath d='M-470.4 536.96c-36.55-4.34-73.8 11.16-102.96 22.85' transform='matrix(.02243 -.06172 .053 .0239 500.95 225.9)'/%3E %3C/g%3E %3Cg stroke-width='3.75'%3E %3Cpath d='M-609.04 575.42c2.99-5.86 54.13-52.97 100.64-49.44 34.05 2.58 39.68 11.2 39.68 11.2s3.18 8.86-27.06 15.36c-30.54 6.56-83.49 28.46-113.26 22.88z' fill-rule='evenodd' transform='matrix(.04201 -.04403 -.03718 -.02348 564.75 263.98)'/%3E %3Cpath d='M-470.4 536.96c-36.55-4.34-73.8 11.16-102.96 22.85' transform='matrix(.04201 -.04403 -.03718 -.02348 564.75 263.98)'/%3E %3C/g%3E %3Cg stroke-width='3.13'%3E %3Cpath d='M-609.04 575.42c2.99-5.86 54.13-52.97 100.64-49.44 34.05 2.58 39.68 11.2 39.68 11.2s3.18 8.86-27.06 15.36c-30.54 6.56-83.49 28.46-113.26 22.88z' fill-rule='evenodd' transform='matrix(.0109 -.0722 .04959 .01802 494.01 226.27)'/%3E %3Cpath d='M-470.4 536.96c-36.55-4.34-73.8 11.16-102.96 22.85' transform='matrix(.0109 -.0722 .04959 .01802 494.01 226.27)'/%3E %3C/g%3E %3Cg stroke-width='2.63'%3E %3Cpath d='M-609.04 575.42c2.99-5.86 54.13-52.97 100.64-49.44 34.05 2.58 39.68 11.2 39.68 11.2s3.18 8.86-27.06 15.36c-30.54 6.56-83.49 28.46-113.26 22.88z' fill-rule='evenodd' transform='matrix(.00144 -.07793 .0687 .00644 475.88 232.54)'/%3E %3Cpath d='M-470.4 536.96c-36.55-4.34-73.8 11.16-102.96 22.85' transform='matrix(.00144 -.07793 .0687 .00644 475.88 232.54)'/%3E %3C/g%3E %3Cg stroke-width='3.13'%3E %3Cpath d='M-609.04 575.42c2.99-5.86 54.13-52.97 100.64-49.44 34.05 2.58 39.68 11.2 39.68 11.2s3.18 8.86-27.06 15.36c-30.54 6.56-83.49 28.46-113.26 22.88z' fill-rule='evenodd' transform='matrix(-.01157 -.07209 .05272 .00208 475.45 242.62)'/%3E %3Cpath d='M-470.4 536.96c-36.55-4.34-73.8 11.16-102.96 22.85' transform='matrix(-.01157 -.07209 .05272 .00208 475.45 242.62)'/%3E %3C/g%3E %3Cg stroke-width='3.04'%3E %3Cpath d='M-609.04 575.42c2.99-5.86 54.13-52.97 100.64-49.44 34.05 2.58 39.68 11.2 39.68 11.2s3.18 8.86-27.06 15.36c-30.54 6.56-83.49 28.46-113.26 22.88z' fill-rule='evenodd' transform='matrix(.04886 -.04636 -.04417 -.04006 571.17 275.47)'/%3E %3Cpath d='M-470.4 536.96c-36.55-4.34-73.8 11.16-102.96 22.85' transform='matrix(.04886 -.04636 -.04417 -.04006 571.17 275.47)'/%3E %3C/g%3E %3Cg stroke-width='3.04'%3E %3Cpath d='M-609.04 575.42c2.99-5.86 54.13-52.97 100.64-49.44 34.05 2.58 39.68 11.2 39.68 11.2s3.18 8.86-27.06 15.36c-30.54 6.56-83.49 28.46-113.26 22.88z' fill-rule='evenodd' transform='matrix(.05208 -.04272 -.04117 -.04314 569.92 282.54)'/%3E %3Cpath d='M-470.4 536.96c-36.55-4.34-73.8 11.16-102.96 22.85' transform='matrix(.05208 -.04272 -.04117 -.04314 569.92 282.54)'/%3E %3C/g%3E %3Cg stroke-width='2.84'%3E %3Cpath d='M-609.04 575.42c2.99-5.86 54.13-52.97 100.64-49.44 34.05 2.58 39.68 11.2 39.68 11.2s3.18 8.86-27.06 15.36c-30.54 6.56-83.49 28.46-113.26 22.88z' fill-rule='evenodd' transform='matrix(.05391 -.04792 -.04589 -.04442 572.3 284.15)'/%3E %3Cpath d='M-470.4 536.96c-36.55-4.34-73.8 11.16-102.96 22.85' transform='matrix(.05391 -.04792 -.04589 -.04442 572.3 284.15)'/%3E %3C/g%3E %3Cg stroke-width='4.24' fill-rule='evenodd'%3E %3Cpath d='M513.8 285.95s-.44-.87-.44-1.67c-.01-.8.2-1.21.2-1.21l-.32-.2s-.15.86-.15 1.28l.01.51s-.56-.48-.68-.75l-.28-.68-.27.12s.25.85.47 1.02c.75.57 1.21 1.73 1.21 1.73' stroke-width='.1923688'/%3E %3Cpath d='M511.87 281.72a.58.85-6.47 1 1 .19 1.69.58.85-6.47 1 1-.2-1.69z' style='marker:none' fill='%23000' stroke-width='.1928355' overflow='visible'/%3E %3Cpath d='M513.8 281.7a.85.58-70.71 1 1-.55 1.61.85.58-70.71 1 1 .56-1.6z' style='marker:none' fill='%23000' stroke-width='.1928355' overflow='visible'/%3E %3C/g%3E %3Cg stroke-width='4.24' fill-rule='evenodd'%3E %3Cpath d='M513.64 285.86s.89-.39 1.4-1c.5-.63.61-1.08.61-1.08l.37.05s-.43.77-.69 1.09l-.34.39s.74-.02 1.01-.16c.27-.13.64-.35.64-.35l.14.27s-.73.5-1 .49c-.96-.03-2.04.58-2.04.58' stroke-width='.1923688'/%3E %3Cpath d='M517.8 283.8a.85.58-44.43 1 0-1.2 1.2.85.58-44.43 1 0 1.2-1.2z' style='marker:none' fill='%23000' stroke-width='.1928355' overflow='visible'/%3E %3Cpath d='M516.31 282.57a.85.58-70.18 1 0-.57 1.6.85.58-70.18 1 0 .57-1.6z' style='marker:none' fill='%23000' stroke-width='.1928355' overflow='visible'/%3E %3C/g%3E %3Cg stroke-width='3'%3E %3Cpath d='M-609.04 575.42c2.99-5.86 54.13-52.97 100.64-49.44 34.05 2.58 39.68 11.2 39.68 11.2s3.18 8.86-27.06 15.36c-30.54 6.56-83.49 28.46-113.26 22.88z' fill-rule='evenodd' transform='matrix(-.01678 -.07418 .05494 -.0013 469.8 247.56)'/%3E %3Cpath d='M-470.4 536.96c-36.55-4.34-73.8 11.16-102.96 22.85' transform='matrix(-.01678 -.07418 .05494 -.0013 469.8 247.56)'/%3E %3C/g%3E %3Cg stroke-width='2.72'%3E %3Cpath d='M-609.04 575.42c2.99-5.86 54.13-52.97 100.64-49.44 34.05 2.58 39.68 11.2 39.68 11.2s3.18 8.86-27.06 15.36c-30.54 6.56-83.49 28.46-113.26 22.88z' fill-rule='evenodd' transform='matrix(.05289 -.05337 -.05062 -.04316 573.21 284.35)'/%3E %3Cpath d='M-470.4 536.96c-36.55-4.34-73.8 11.16-102.96 22.85' transform='matrix(.05289 -.05337 -.05062 -.04316 573.21 284.35)'/%3E %3C/g%3E %3Cg stroke-width='2.93'%3E %3Cpath d='M-609.04 575.42c2.99-5.86 54.13-52.97 100.64-49.44 34.05 2.58 39.68 11.2 39.68 11.2s3.18 8.86-27.06 15.36c-30.54 6.56-83.49 28.46-113.26 22.88z' fill-rule='evenodd' transform='matrix(.05443 -.05577 -.04812 -.02978 572.05 279.46)'/%3E %3Cpath d='M-470.4 536.96c-36.55-4.34-73.8 11.16-102.96 22.85' transform='matrix(.05443 -.05577 -.04812 -.02978 572.05 279.46)'/%3E %3C/g%3E %3Cg stroke-width='2.45'%3E %3Cpath d='M-609.04 575.42c2.99-5.86 54.13-52.97 100.64-49.44 34.05 2.58 39.68 11.2 39.68 11.2s3.18 8.86-27.06 15.36c-30.54 6.56-83.49 28.46-113.26 22.88z' fill-rule='evenodd' transform='matrix(-.02128 -.07612 .07793 -.01146 453.26 256.53)'/%3E %3Cpath d='M-470.4 536.96c-36.55-4.34-73.8 11.16-102.96 22.85' transform='matrix(-.02128 -.07612 .07793 -.01146 453.26 256.53)'/%3E %3C/g%3E %3Cg stroke-width='2.84'%3E %3Cpath d='M-609.04 575.42c2.99-5.86 54.13-52.97 100.64-49.44 34.05 2.58 39.68 11.2 39.68 11.2s3.18 8.86-27.06 15.36c-30.54 6.56-83.49 28.46-113.26 22.88z' fill-rule='evenodd' transform='matrix(.04466 -.06692 -.05426 -.02125 569.63 273.14)'/%3E %3Cpath d='M-470.4 536.96c-36.55-4.34-73.8 11.16-102.96 22.85' transform='matrix(.04466 -.06692 -.05426 -.02125 569.63 273.14)'/%3E %3C/g%3E %3Cg stroke-width='2.42'%3E %3Cpath d='M-609.04 575.42c2.99-5.86 54.13-52.97 100.64-49.44 34.05 2.58 39.68 11.2 39.68 11.2s3.18 8.86-27.06 15.36c-30.54 6.56-83.49 28.46-113.26 22.88z' fill-rule='evenodd' transform='matrix(-.0337 -.0747 .07231 -.02674 448.84 271.75)'/%3E %3Cpath d='M-470.4 536.96c-36.55-4.34-73.8 11.16-102.96 22.85' transform='matrix(-.0337 -.0747 .07231 -.02674 448.84 271.75)'/%3E %3C/g%3E %3Cg stroke-width='3.89' fill-rule='evenodd'%3E %3Cpath d='M511.02 299.36s-.7-.8-.92-1.64c-.22-.85-.12-1.34-.12-1.34l-.38-.12s.07.95.18 1.38l.15.55s-.72-.36-.92-.62l-.48-.64-.25.2s.49.83.76.94c.96.42 1.75 1.52 1.75 1.52' stroke-width='.192555'/%3E %3Cpath d='M507.84 295.4a.63.93-20.56 1 1 .65 1.74.63.93-20.56 1 1-.65-1.74z' style='marker:none' fill='%23000' stroke-width='.19274030000000003' overflow='visible'/%3E %3Cpath d='M509.9 294.87a.63.93 5.2 1 1-.18 1.85.63.93 5.2 1 1 .17-1.85z' style='marker:none' fill='%23000' stroke-width='.19274030000000003' overflow='visible'/%3E %3C/g%3E %3Cg stroke-width='3.89' fill-rule='evenodd'%3E %3Cpath d='M511 299.3s.84-.65 1.22-1.44c.38-.79.36-1.3.36-1.3l.4-.04s-.24.92-.43 1.33l-.26.5s.78-.21 1.03-.43c.24-.2.59-.54.59-.54l.21.25s-.64.72-.93.78c-1.02.23-2 1.16-2 1.16' stroke-width='.192555'/%3E %3Cpath d='M514.87 296.02a.93.63-58.51 1 0-.96 1.58.93.63-58.51 1 0 .96-1.58z' style='marker:none' fill='%23000' stroke-width='.19274030000000003' overflow='visible'/%3E %3Cpath d='M512.96 295.1a.63.93 5.73 1 0-.18 1.85.63.93 5.73 1 0 .18-1.84z' style='marker:none' fill='%23000' stroke-width='.19274030000000003' overflow='visible'/%3E %3C/g%3E %3Cg stroke-width='2.54'%3E %3Cpath d='M-609.04 575.42c2.99-5.86 54.13-52.97 100.64-49.44 34.05 2.58 39.68 11.2 39.68 11.2s3.18 8.86-27.06 15.36c-30.54 6.56-83.49 28.46-113.26 22.88z' fill-rule='evenodd' transform='matrix(-.05002 -.07495 .06077 -.0238 446.17 274.65)'/%3E %3Cpath d='M-470.4 536.96c-36.55-4.34-73.8 11.16-102.96 22.85' transform='matrix(-.05002 -.07495 .06077 -.0238 446.17 274.65)'/%3E %3C/g%3E %3Cg stroke-width='2.21'%3E %3Cpath d='M-609.04 575.42c2.99-5.86 54.13-52.97 100.64-49.44 34.05 2.58 39.68 11.2 39.68 11.2s3.18 8.86-27.06 15.36c-30.54 6.56-83.49 28.46-113.26 22.88z' fill-rule='evenodd' transform='matrix(.03692 -.0818 -.0792 -.02929 580.01 273.54)'/%3E %3Cpath d='M-470.4 536.96c-36.55-4.34-73.8 11.16-102.96 22.85' transform='matrix(.03692 -.0818 -.0792 -.02929 580.01 273.54)'/%3E %3C/g%3E %3Cg stroke-width='2.34'%3E %3Cpath d='M-609.04 575.42c2.99-5.86 54.13-52.97 100.64-49.44 34.05 2.58 39.68 11.2 39.68 11.2s3.18 8.86-27.06 15.36c-30.54 6.56-83.49 28.46-113.26 22.88z' fill-rule='evenodd' transform='matrix(.0346 -.08362 -.07299 -.0195 576.5 271.62)'/%3E %3Cpath d='M-470.4 536.96c-36.55-4.34-73.8 11.16-102.96 22.85' transform='matrix(.0346 -.08362 -.07299 -.0195 576.5 271.62)'/%3E %3C/g%3E %3Cg stroke-width='1.98'%3E %3Cpath d='M-609.04 575.42c2.99-5.86 54.13-52.97 100.64-49.44 34.05 2.58 39.68 11.2 39.68 11.2s3.18 8.86-27.06 15.36c-30.54 6.56-83.49 28.46-113.26 22.88z' fill-rule='evenodd' transform='matrix(-.0568 -.08234 .081 -.0479 431.82 288.74)'/%3E %3Cpath d='M-470.4 536.96c-36.55-4.34-73.8 11.16-102.96 22.85' transform='matrix(-.0568 -.08234 .081 -.0479 431.82 288.74)'/%3E %3C/g%3E %3Cg stroke-width='2.61'%3E %3Cpath d='M-609.04 575.42c2.99-5.86 54.13-52.97 100.64-49.44 34.05 2.58 39.68 11.2 39.68 11.2s3.18 8.86-27.06 15.36c-30.54 6.56-83.49 28.46-113.26 22.88z' fill-rule='evenodd' transform='matrix(.01123 -.08405 -.06502 .0048 563.24 267.44)'/%3E %3Cpath d='M-470.4 536.96c-36.55-4.34-73.8 11.16-102.96 22.85' transform='matrix(.01123 -.08405 -.06502 .0048 563.24 267.44)'/%3E %3C/g%3E %3Cg stroke-width='1.87'%3E %3Cpath d='M-609.04 575.42c2.99-5.86 54.13-52.97 100.64-49.44 34.05 2.58 39.68 11.2 39.68 11.2s3.18 8.86-27.06 15.36c-30.54 6.56-83.49 28.46-113.26 22.88z' fill-rule='evenodd' transform='matrix(-.0827 -.06704 .07183 -.06909 426.97 320.2)'/%3E %3Cpath d='M-470.4 536.96c-36.55-4.34-73.8 11.16-102.96 22.85' transform='matrix(-.0827 -.06704 .07183 -.06909 426.97 320.2)'/%3E %3C/g%3E %3Cg stroke-width='2.22'%3E %3Cpath d='M-609.04 575.42c2.99-5.86 54.13-52.97 100.64-49.44 34.05 2.58 39.68 11.2 39.68 11.2s3.18 8.86-27.06 15.36c-30.54 6.56-83.49 28.46-113.26 22.88z' fill-rule='evenodd' transform='matrix(-.07484 -.07005 .06288 -.04124 434.11 298.38)'/%3E %3Cpath d='M-470.4 536.96c-36.55-4.34-73.8 11.16-102.96 22.85' transform='matrix(-.07484 -.07005 .06288 -.04124 434.11 298.38)'/%3E %3C/g%3E %3Cg stroke-width='2.12'%3E %3Cpath d='M-609.04 575.42c2.99-5.86 54.13-52.97 100.64-49.44 34.05 2.58 39.68 11.2 39.68 11.2s3.18 8.86-27.06 15.36c-30.54 6.56-83.49 28.46-113.26 22.88z' fill-rule='evenodd' transform='matrix(.01884 -.09267 -.08599 -.0123 577.2 267.75)'/%3E %3Cpath d='M-470.4 536.96c-36.55-4.34-73.8 11.16-102.96 22.85' transform='matrix(.01884 -.09267 -.08599 -.0123 577.2 267.75)'/%3E %3C/g%3E %3Cg stroke-width='3.47' fill-rule='evenodd'%3E %3Cpath d='M514.75 314.8s-1.08-.5-1.68-1.27c-.6-.78-.72-1.33-.72-1.33l-.44.05s.49.94.8 1.34c.3.4.4.5.4.5s-.9-.05-1.22-.23c-.33-.17-.78-.44-.78-.44l-.18.32s.88.63 1.22.62a5.8 5.8 0 0 1 2.47.78' stroke-width='.19234210000000002'/%3E %3Cpath d='M509.72 312.16a.7 1.04-44.11 1 1 1.44 1.49.7 1.04-44.11 1 1-1.44-1.49z' style='marker:none' fill='%23000' stroke-width='.19278089999999998' overflow='visible'/%3E %3Cpath d='M511.59 310.7a.7 1.04-18.35 1 1 .65 1.97.7 1.04-18.35 1 1-.65-1.97z' style='marker:none' fill='%23000' stroke-width='.19278089999999998' overflow='visible'/%3E %3C/g%3E %3Cg stroke-width='3.47' fill-rule='evenodd'%3E %3Cpath d='M514.9 314.74s.56-1.04.6-2.02c.03-.98-.2-1.49-.2-1.49l.38-.22s.16 1.05.15 1.56c-.02.5-.04.63-.04.63s.7-.57.86-.9c.16-.33.36-.82.36-.82l.33.15s-.33 1.03-.6 1.23c-.94.68-1.54 2.08-1.54 2.08' stroke-width='.19234210000000002'/%3E %3Cpath d='M517.4 309.64a.7 1.04 7.93 1 0-.29 2.06.7 1.04 7.93 1 0 .29-2.06z' style='marker:none' fill='%23000' stroke-width='.19278089999999998' overflow='visible'/%3E %3Cpath d='M515.03 309.57a.7 1.04-17.83 1 0 .63 1.97.7 1.04-17.83 1 0-.63-1.97z' style='marker:none' fill='%23000' stroke-width='.19278089999999998' overflow='visible'/%3E %3C/g%3E %3Cg stroke-width='2.21'%3E %3Cpath d='M-609.04 575.42c2.99-5.86 54.13-52.97 100.64-49.44 34.05 2.58 39.68 11.2 39.68 11.2s3.18 8.86-27.06 15.36c-30.54 6.56-83.49 28.46-113.26 22.88z' fill-rule='evenodd' transform='matrix(-.0873 -.03844 .03616 -.07072 447.54 341.65)'/%3E %3Cpath d='M-470.4 536.96c-36.55-4.34-73.8 11.16-102.96 22.85' transform='matrix(-.0873 -.03844 .03616 -.07072 447.54 341.65)'/%3E %3C/g%3E %3Cg stroke-width='2.94'%3E %3Cpath d='M-609.04 575.42c2.99-5.86 54.13-52.97 100.64-49.44 34.05 2.58 39.68 11.2 39.68 11.2s3.18 8.86-27.06 15.36c-30.54 6.56-83.49 28.46-113.26 22.88z' fill-rule='evenodd' transform='matrix(.00173 -.07673 -.05583 -.00256 555.07 279)'/%3E %3Cpath d='M-470.4 536.96c-36.55-4.34-73.8 11.16-102.96 22.85' transform='matrix(.00173 -.07673 -.05583 -.00256 555.07 279)'/%3E %3C/g%3E %3Cg stroke-width='1.96'%3E %3Cpath d='M-609.04 575.42c2.99-5.86 54.13-52.97 100.64-49.44 34.05 2.58 39.68 11.2 39.68 11.2s3.18 8.86-27.06 15.36c-30.54 6.56-83.49 28.46-113.26 22.88z' fill-rule='evenodd' transform='matrix(-.10019 -.03492 .04827 -.0788 438.61 352.73)'/%3E %3Cpath d='M-470.4 536.96c-36.55-4.34-73.8 11.16-102.96 22.85' transform='matrix(-.10019 -.03492 .04827 -.0788 438.61 352.73)'/%3E %3C/g%3E %3Cg stroke-width='2.42'%3E %3Cpath d='M-609.04 575.42c2.99-5.86 54.13-52.97 100.64-49.44 34.05 2.58 39.68 11.2 39.68 11.2s3.18 8.86-27.06 15.36c-30.54 6.56-83.49 28.46-113.26 22.88z' fill-rule='evenodd' transform='matrix(-.0355 -.06479 -.07228 .04669 547.73 262.28)'/%3E %3Cpath d='M-470.4 536.96c-36.55-4.34-73.8 11.16-102.96 22.85' transform='matrix(-.0355 -.06479 -.07228 .04669 547.73 262.28)'/%3E %3C/g%3E %3Cg stroke-width='3.01' fill-rule='evenodd'%3E %3Cpath d='M523.96 326.03s-.9.71-1.88.15a4.1 4.1 0 0 1-1.33-1.11l-.46.24s.93.8 1.43 1.1c.5.29.64.35.64.35s-.99.33-1.4.29c-.42-.05-1.03-.15-1.03-.15l-.05.42s1.19.18 1.57.15c.38-.02 2.4-.8 2.4-.8' stroke-width='.1923089'/%3E %3Cpath d='M517.9 326.15a.81 1.2-65.89 1 1 2.19.98.81 1.2-65.89 1 1-2.18-.98z' style='marker:none' fill='%23000' stroke-width='.1918091' overflow='visible'/%3E %3Cpath d='M519.28 323.79a.81 1.2-40.13 1 1 1.54 1.83.81 1.2-40.13 1 1-1.54-1.83z' style='marker:none' fill='%23000' stroke-width='.1918091' overflow='visible'/%3E %3C/g%3E %3Cg stroke-width='3.01' fill-rule='evenodd'%3E %3Cpath d='M524.07 326.57s.77-.87.26-1.88a4.1 4.1 0 0 0-1.02-1.4l.26-.43s.75.97 1.01 1.5a8 8 0 0 1 .31.65s.4-.96.38-1.38c-.02-.42-.08-1.03-.08-1.03l.42-.02s.1 1.19.05 1.57c-.05.38-.95 2.34-.95 2.34' stroke-width='.1923089'/%3E %3Cpath d='M524.56 320.53a.81 1.2-20.55 1 0 .84 2.24.81 1.2-20.55 1 0-.84-2.24z' style='marker:none' fill='%23000' stroke-width='.1918091' overflow='visible'/%3E %3Cpath d='M522.12 321.76a.81 1.2-46.3 1 0 1.73 1.65.81 1.2-46.3 1 0-1.73-1.65z' style='marker:none' fill='%23000' stroke-width='.1918091' overflow='visible'/%3E %3C/g%3E %3Cg stroke-width='1.84'%3E %3Cpath d='M-609.04 575.42c2.99-5.86 54.13-52.97 100.64-49.44 34.05 2.58 39.68 11.2 39.68 11.2s3.18 8.86-27.06 15.36c-30.54 6.56-83.49 28.46-113.26 22.88z' fill-rule='evenodd' transform='matrix(-.10758 -.0135 .01448 -.10023 457.88 380.47)'/%3E %3Cpath d='M-470.4 536.96c-36.55-4.34-73.8 11.16-102.96 22.85' transform='matrix(-.10758 -.0135 .01448 -.10023 457.88 380.47)'/%3E %3C/g%3E %3Cg stroke-width='2.61' fill-rule='evenodd'%3E %3Cpath d='M535.58 332.1s-.73 1.11-2 .86c-1.28-.26-1.87-.72-1.87-.72l-.41.43s1.31.53 1.97.67c.66.13.83.15.83.15s-.95.73-1.43.83c-.47.1-1.17.22-1.17.22l.1.47s1.36-.24 1.77-.41a24.5 24.5 0 0 0 2.3-1.76' stroke-width='.1920699'/%3E %3Cpath d='M529.01 334.47a.93 1.38-84.59 1 1 2.75.26.93 1.38-84.59 1 1-2.75-.26z' style='marker:none' fill='%23000' stroke-width='.1924824' overflow='visible'/%3E %3Cpath d='M529.64 331.38a.93 1.38-58.83 1 1 2.36 1.43.93 1.38-58.83 1 1-2.36-1.43z' style='marker:none' fill='%23000' stroke-width='.1924824' overflow='visible'/%3E %3C/g%3E %3Cg stroke-width='2.27'%3E %3Cpath d='M-609.04 575.42c2.99-5.86 54.13-52.97 100.64-49.44 34.05 2.58 39.68 11.2 39.68 11.2s3.18 8.86-27.06 15.36c-30.54 6.56-83.49 28.46-113.26 22.88z' fill-rule='evenodd' transform='matrix(-.05025 -.05913 -.07391 .0559 545.48 263.4)'/%3E %3Cpath d='M-470.4 536.96c-36.55-4.34-73.8 11.16-102.96 22.85' transform='matrix(-.05025 -.05913 -.07391 .0559 545.48 263.4)'/%3E %3C/g%3E %3Cg stroke-width='2.61' fill-rule='evenodd'%3E %3Cpath d='M536.48 332.92s.34-1.29-.7-2.07a4.72 4.72 0 0 0-1.78-.9l.05-.6s1.27.62 1.81 1.02.66.52.66.52-.09-1.2-.33-1.62c-.24-.42-.62-1.01-.62-1.01l.42-.24s.73 1.17.88 1.58c.14.42.23 2.9.23 2.9' stroke-width='.1920699'/%3E %3Cpath d='M533.86 326.45a.93 1.38-47.26 1 0 2.03 1.87.93 1.38-47.26 1 0-2.03-1.87z' style='marker:none' fill='%23000' stroke-width='.1924824' overflow='visible'/%3E %3Cpath d='M531.98 328.98a.93 1.38-73.02 1 0 2.64.8.93 1.38-73.02 1 0-2.64-.8z' style='marker:none' fill='%23000' stroke-width='.1924824' overflow='visible'/%3E %3C/g%3E %3C/g%3E %3C/g%3E %3Cpath d='M548.6 326.54s-3.66 8.5-2.4 9.34c0 0 3.72-6.6 6.97-9.09 1.7-1.6 2.73.01 2.95-1.39.21-1.4-4.46-3.42-4.46-3.42l-3 4.21' fill='%23452c25'/%3E %3Cpath d='M593.68 214.48s-8.43 19.15-5.52 21.05c0 0 8.55-14.87 16.06-20.5 3.9-3.6 6.27.04 6.77-3.13s-10.26-7.71-10.26-7.71l-6.9 9.5' transform='matrix(.43415 0 0 .44354 290.86 231.41)' fill='none' stroke='%23000' stroke-width='.58'/%3E %3Cpath d='M535.26 333.01s-5.32 9.26-3.93 9.37c1.4.1 7.08-11.8 7.08-11.8l-1.94.33-1.21 2.1z' fill='%23452c25'/%3E %3Cpath d='M562.94 229.06s-12.24 20.87-9.03 21.12c3.2.24 16.3-26.61 16.3-26.61l-4.46.74-2.8 4.75z' transform='matrix(.43415 0 0 .44354 290.86 231.41)' fill='none' stroke='%23000' stroke-width='.47'/%3E %3Cpath d='M536.86 330.43s-5.56 9.1-4.17 9.26c1.4.14 7.39-11.6 7.39-11.6l-1.95.27-1.27 2.07z' fill='%23452c25'/%3E %3Cpath d='M566.64 223.25s-12.8 20.53-9.6 20.86c3.2.33 17.02-26.16 17.02-26.16l-4.49.63-2.93 4.67z' transform='matrix(.43415 0 0 .44354 290.86 231.41)' fill='none' stroke='%23000' stroke-width='.47'/%3E %3Cpath d='M537.99 328.85s-6.33 8.56-4.96 8.84c1.37.27 8.37-10.9 8.37-10.9l-1.97.11-1.44 1.95z' fill='%23452c25'/%3E %3Cpath d='M569.23 219.67S554.66 239 557.82 239.6c3.16.62 19.27-24.55 19.27-24.55l-4.52.23-3.34 4.4z' transform='matrix(.43415 0 0 .44354 290.86 231.41)' fill='none' stroke='%23000' stroke-width='.47'/%3E %3Cpath d='M539.68 327.34s-7.41 7.61-6.09 8.07c1.32.46 9.74-9.62 9.74-9.62l-1.96-.18-1.7 1.73z' fill='%23452c25'/%3E %3Cpath d='M573.13 216.28s-17.07 17.15-14.02 18.2c3.05 1.03 22.43-21.7 22.43-21.7l-4.51-.4-3.9 3.9z' transform='matrix(.43415 0 0 .44354 290.86 231.41)' fill='none' stroke='%23000' stroke-width='.47'/%3E %3Cpath d='M539.94 324.58s-6.46 8.45-5.1 8.75c1.37.3 8.54-10.74 8.54-10.74l-1.96.06-1.48 1.93z' fill='%23452c25'/%3E %3Cpath d='M573.74 210.04s-14.9 19.07-11.75 19.74c3.15.67 19.68-24.23 19.68-24.23l-4.53.16-3.4 4.33z' transform='matrix(.43415 0 0 .44354 290.86 231.41)' fill='none' stroke='%23000' stroke-width='.47'/%3E %3Cpath d='M538.3 331.84s-6.34 8.57-4.96 8.84c1.37.28 8.36-10.88 8.36-10.88l-1.96.1-1.45 1.94z' fill='%23452c25'/%3E %3Cpath d='M569.94 226.43s-14.58 19.31-11.42 19.93c3.16.61 19.27-24.55 19.27-24.55l-4.52.23-3.33 4.4z' transform='matrix(.43415 0 0 .44354 290.86 231.41)' fill='none' stroke='%23000' stroke-width='.47'/%3E %3Cpath d='M541.85 330.15s-3.7 6.97-3.28 7.26c.43.3 4.92-3.97 7.15-8.12 2.22-4.15-4.03.69-4.03.69' fill='%23452c25'/%3E %3Cpath d='M578.14 222.61s-8.53 15.72-7.56 16.37c.98.66 11.34-8.96 16.46-18.31 5.12-9.36-9.27 1.55-9.27 1.55' transform='matrix(.43415 0 0 .44354 290.86 231.41)' fill='none' stroke='%23000' stroke-width='.47'/%3E %3Cpath d='M542.25 329.46s-3.66 8.5-2.4 9.34c0 0 4.6-5.13 5.8-9.2 1.19-4.07 0-.28 0-.28l-.34-4.42-3 4.2' fill='%23452c25'/%3E %3Cpath d='M579.05 221.05s-8.42 19.16-5.51 21.06c0 0 10.57-11.56 13.33-20.74 2.75-9.18 0-.63 0-.63l-.77-9.98-6.9 9.5' transform='matrix(.43415 0 0 .44354 290.86 231.41)' fill='none' stroke='%23000' stroke-width='.58'/%3E %3Cpath d='M540.35 328.72s-7.4 7.6-6.09 8.07c1.33.46 9.74-9.63 9.74-9.63l-1.96-.17-1.69 1.73z' fill='%23452c25'/%3E %3Cpath d='M574.68 219.38s-17.07 17.15-14.02 18.19c3.04 1.04 22.43-21.7 22.43-21.7l-4.51-.39-3.9 3.9z' transform='matrix(.43415 0 0 .44354 290.86 231.41)' fill='none' stroke='%23000' stroke-width='.47'/%3E %3Cpath d='M540.94 329.75s-7.41 7.6-6.09 8.07c1.33.46 9.74-9.63 9.74-9.63l-1.96-.17-1.7 1.73z' fill='%23452c25'/%3E %3Cpath d='M576.03 221.7s-17.06 17.16-14.02 18.2c3.05 1.03 22.44-21.7 22.44-21.7l-4.51-.4-3.9 3.9z' transform='matrix(.43415 0 0 .44354 290.86 231.41)' fill='none' stroke='%23000' stroke-width='.47'/%3E %3Cpath d='M541.53 330.95s-7.41 7.6-6.09 8.07c1.32.46 9.74-9.63 9.74-9.63l-1.96-.17-1.7 1.73z' fill='%23452c25'/%3E %3Cpath d='M577.39 224.41s-17.07 17.16-14.02 18.2c3.05 1.03 22.43-21.7 22.43-21.7l-4.51-.4-3.9 3.9z' transform='matrix(.43415 0 0 .44354 290.86 231.41)' fill='none' stroke='%23000' stroke-width='.47'/%3E %3Cpath d='M542.08 320.5s-5.5 7.04-4.71 8.25c.8 1.2 5.82-3.23 7.41-6.34 1.59-3.11-2.65-2.13-2.65-2.13' fill='%23452c25'/%3E %3Cpath d='M578.66 200.87s-12.67 15.85-10.85 18.58c1.83 2.73 13.41-7.28 17.07-14.3 3.66-7-6.1-4.8-6.1-4.8' transform='matrix(.43415 0 0 .44354 290.86 231.41)' fill='none' stroke='%23000' stroke-width='.47'/%3E %3Cpath d='M541.9 327.97s-4.71 9.03-3.5 8.52c1.22-.52 6-7.31 6.53-8.81.53-1.5.35-3.07.35-3.07l-3.65 2.25.32 1.75' fill='%23452c25'/%3E %3Cpath d='M578.26 217.7s-10.87 20.36-8.07 19.2c2.8-1.18 13.82-16.49 15.04-19.86 1.22-3.38.81-6.91.81-6.91l-8.41 5.07.72 3.94' transform='matrix(.43415 0 0 .44354 290.86 231.41)' fill='none' stroke='%23000' stroke-width='.47'/%3E %3Cpath d='M541.94 325s3.91-7.2-.03 1.36c-3.94 8.55-5.42 7.14-5.42 7.14-.3-.49 3.43-6.28 3.43-6.28s2.77-4.46 3.44-4.88' fill='%23452c25'/%3E %3Cpath d='M578.33 211.01s9.02-16.23-.06 3.06c-9.08 19.28-12.48 16.1-12.48 16.1-.7-1.1 7.9-14.17 7.9-14.17s6.38-10.05 7.91-11' transform='matrix(.43415 0 0 .44354 290.86 231.41)' fill='none' stroke='%23000' stroke-width='.4'/%3E %3Cpath d='M546.14 324.05s4.35-7.15-.02 1.36c-4.36 8.5-6.06 7.06-6.06 7.06-.36-.49 3.81-6.23 3.81-6.23s3.1-4.43 3.84-4.84' fill='%23452c25'/%3E %3Cpath d='M588 208.85s10.03-16.11-.02 3.06C577.93 231.1 574 227.85 574 227.85c-.81-1.11 8.79-14.07 8.79-14.07s7.12-9.97 8.85-10.9' transform='matrix(.43415 0 0 .44354 290.86 231.41)' fill='none' stroke='%23000' stroke-width='.43'/%3E %3Cpath d='M584.32 202.05s-12.67 15.85-10.85 18.58c1.83 2.73 13.41-7.27 17.07-14.29s-6.1-4.8-6.1-4.8' transform='matrix(.43415 0 0 .44354 290.86 231.41)' fill='%23452c25' stroke='%23000' stroke-width='.47'/%3E %3Cg%3E %3Cpath d='M601.28 392.3a51.28 57.7 0 1 1-102.56 0 51.28 57.7 0 1 1 102.56 0z' fill='%23e8a30e'/%3E %3Cpath d='M508.9 392.3c0-26.8 18.86-47.36 41.1-47.36 22.24 0 41.1 20.57 41.1 47.37' style='text-indent:0;text-align:start;line-height:normal;text-transform:none;block-progression:tb;marker:none;-inkscape-font-specification:Sans' font-weight='400' color='%23000' fill='none' stroke='%23390' stroke-width='1.2820999999999998' overflow='visible' font-family='Sans'/%3E %3Cpath d='M498.79 395.33C500.19 425.8 522.59 450 550 450c27.42 0 49.81-24.21 51.21-54.67H498.8z' fill='%23007934' stroke='%23eee' stroke-width='.12821'/%3E %3Cpath d='M-237.6 1162.17a577.6 643.15 0 1 1-1155.21 0 577.6 643.15 0 1 1 1155.21 0z' transform='matrix(.08878 0 0 .0897 622.38 288.06)' fill='none' stroke='%23000' stroke-width='6.46'/%3E %3Cg stroke='%23000' stroke-width='1.11'%3E %3Cpath d='M200.51 493.62c-4.87 19.06.5 34.74 9.81 49.52 7.2 11.43 11.93 23.61 11.7 36.7-3.27 1.85-6.4 3.84-9.4 5.98l-75.26-49.99 50.52 74.43c-.9 1.26-1.8 2.56-2.64 3.85-14.33-6.46-27.79-7.74-40.6-5.26-18.13 3.5-33.51-.29-49.58-9.86 10.03 16.92 25 24.2 42.03 28.07 13.2 3 25.13 8.26 34.24 17.7-1 3.57-1.81 7.17-2.43 10.82L80.3 673.55l88.39 16.9c.24 1.52.53 3.04.84 4.55-14.7 5.57-25.15 14.15-32.46 24.97-10.34 15.3-23.83 23.5-41.96 28.08 19.06 4.88 34.72-.56 49.5-9.87 11.43-7.2 23.6-11.93 36.7-11.7 1.84 3.27 3.83 6.4 5.98 9.4l-49.97 75.33 74.47-50.62c1.24.9 2.5 1.83 3.78 2.67-6.45 14.33-7.7 27.85-5.23 40.67 3.5 18.12-.31 33.44-9.89 49.5 16.92-10.02 24.21-24.99 28.08-42.02 3-13.2 8.25-25.13 17.7-34.24 3.57 1 7.15 1.8 10.82 2.43l17.96 88.59 16.9-88.39c1.52-.24 3.04-.53 4.56-.84 5.56 14.7 14.15 25.15 24.97 32.46 15.29 10.34 23.49 23.83 28.08 41.96 4.87-19.06-.57-34.72-9.88-49.5-7.21-11.45-11.9-23.6-11.64-36.72 3.25-1.84 6.35-3.83 9.35-5.96l75.32 49.97-50.55-74.5c.89-1.22 1.77-2.49 2.6-3.75 14.34 6.47 27.85 7.71 40.67 5.23 18.12-3.5 33.44.31 49.51 9.89-10.03-16.92-24.97-24.15-42-28.01-13.19-3-25.1-8.36-34.2-17.8a107.4 107.4 0 0 0 2.37-10.79l88.6-17.9-88.4-16.96c-.25-1.52-.54-3.04-.85-4.56 14.72-5.55 25.15-14.14 32.47-24.97 10.33-15.29 23.85-23.42 41.98-28.01-19.06-4.88-34.74.5-49.52 9.8-11.46 7.22-23.6 11.9-36.73 11.65a106.67 106.67 0 0 0-5.95-9.35l49.99-75.26-74.52 50.49c-1.23-.89-2.5-1.77-3.76-2.6 6.47-14.33 7.74-27.79 5.26-40.6-3.5-18.13.29-33.51 9.86-49.58-16.92 10.03-24.14 24.97-28.01 42-3 13.22-8.35 25.19-17.83 34.3-3.54-1-7.12-1.85-10.75-2.47l-17.9-88.6-16.97 88.4c-1.52.25-3.04.54-4.55.85-5.57-14.7-14.15-25.15-24.97-32.47-15.3-10.33-23.43-23.85-28.02-41.98z' style='marker:none' fill='%23d52b1e' stroke-width='1.67' overflow='visible' transform='translate(518.3 295.25) scale(.11524)'/%3E %3Cg transform='translate(563.85 374.24) scale(.22284)' stroke='none'%3E %3Cuse transform='rotate(22.5 138.15 65.85)' width='330' height='330' fill='%23fcbf49'/%3E %3Cuse transform='matrix(-1 0 0 1 35.71 -47.86)' width='330' height='330' fill='%23fcbf49'/%3E %3Cg transform='translate(-30.7 2.14)'%3E %3Cpath d='M9.57-21.86c-11.5-10-26-11.5-34-4-5.8 7.77-5.29 16.9 1.5 26.5-.5 0-1.5.5-2 1-5.04-9.6-5.9-19.49-2.5-28.5 11-9 26-10 37 5'/%3E %3Cpath d='M-8.43-24.86c-6.5 0-8 1.5-11 4s-4.5 2-5 2.5 0 2 1 1.5 3-1.5 6-4 6-2.5 9-2.5c9 0 14 7.5 15 7s-5-8.5-15-8.5'/%3E %3Cpath d='M3.07-16.36c-6.5-7-18.5-7.5-23.5.5h2c5-8 17-4.5 18-1v1'/%3E %3Ccircle cx='22' cy='-9' r='4.5' transform='translate(-31.43 -7.86)'/%3E %3Cpath d='M-20.43-15.86c5 4.5 16 5 23.5-.5l-3.5-.5c-5 5.5-13 5-18 1v-1'/%3E %3Cpath d='M3.57-13.86c-8.5 6.5-17 6-22 3s-5-4-4-4 2 1 6 3 10 2 20-2M-20.93 1.14a3 3 0 1 1-4 3c-.5 1-2.5 4-6.5 4h-1l1 1.5c1 0 4 0 6-1.5a4.5 4.5 0 1 0 4.5-7M-14.93 22.14c-4.5-3-6.5-7.5-11.5-7.5-1 0-3 .5-5 1.5h-1l1 1.5c2 0 5-2.5 8.5-.5s5.5 4 8 5M-16.43 22.14c-10-3-12-1-15-1h-1l1 2c4 0 6-3 15-1'/%3E %3Cpath d='M-14.93 22.14c-11-1-7.5 5.5-16.5 5.5h-1l1 1.5c11 0 6-6 16.5-7'/%3E %3C/g%3E %3Cg transform='matrix(-1 0 0 1 -93.57 2.14)'%3E %3Cpath d='M9.57-21.86c-11.5-10-26-11.5-34-4-5.8 7.77-5.29 16.9 1.5 26.5-.5 0-1.5.5-2 1-5.04-9.6-5.9-19.49-2.5-28.5 11-9 26-10 37 5'/%3E %3Cpath d='M-8.43-24.86c-6.5 0-8 1.5-11 4s-4.5 2-5 2.5 0 2 1 1.5 3-1.5 6-4 6-2.5 9-2.5c9 0 14 7.5 15 7s-5-8.5-15-8.5'/%3E %3Cpath d='M3.07-16.36c-6.5-7-18.5-7.5-23.5.5h2c5-8 17-4.5 18-1v1'/%3E %3Ccircle cx='22' cy='-9' r='4.5' transform='translate(-31.43 -7.86)'/%3E %3Cpath d='M-20.43-15.86c5 4.5 16 5 23.5-.5l-3.5-.5c-5 5.5-13 5-18 1v-1'/%3E %3Cpath d='M3.57-13.86c-8.5 6.5-17 6-22 3s-5-4-4-4 2 1 6 3 10 2 20-2M-20.93 1.14a3 3 0 1 1-4 3c-.5 1-2.5 4-6.5 4h-1l1 1.5c1 0 4 0 6-1.5a4.5 4.5 0 1 0 4.5-7M-14.93 22.14c-4.5-3-6.5-7.5-11.5-7.5-1 0-3 .5-5 1.5h-1l1 1.5c2 0 5-2.5 8.5-.5s5.5 4 8 5M-16.43 22.14c-10-3-12-1-15-1h-1l1 2c4 0 6-3 15-1'/%3E %3Cpath d='M-14.93 22.14c-11-1-7.5 5.5-16.5 5.5h-1l1 1.5c11 0 6-6 16.5-7'/%3E %3C/g%3E %3C/g%3E %3C/g%3E %3Cg fill='%23007934' stroke='%23000' stroke-width='1.02'%3E %3Cpath d='M975.08 1010.9c13.59 1.21 27.74.35 39.85-3.7 11.06-4.1 23.17-7 35.28-6.2 0-1.62 3.52-2.87 1.48-4.1-4.5-2.47-10.07-2.02-15.63-4.5-9.08-3.7-14.58-10.34-23.66-14.9-1-.35-5-2.44-5-4.52 19.65 25.35 63.52 10.67 101.38 6.6 3.52.81 12.6-2.03 20.14-4.52 9.08-3.28 31.26-1.64 36.82-5.39.93-.35-9.57-6.16-11.61-7.83-5.5-6.18-19.15-4.92-26.2-11.56-11.06-11.14-27.68-14.03-41.4-23.15-3.02-1.63-9.08-.9-13.58-1.75-5.67-4.3-.29-4.32-43.5-36.27-38.62-13.85-36.77-25.36-60.72-33.36-8.53-3.7-16.44-10.55-23.48-8.46-12.6 3.7-39.7 18.12-51.82 25.57-10.07 6.19-22.59 17.12-31.17 24.16-2.26 1.85-28.31 24.56-58.13 41.57-29.82 17-73.03 40.38-76.8 40.78 68.44-5.49-60.65 20.65 247.75 31.52z' stroke-linecap='round' transform='matrix(.18472 .00617 -.00642 .19224 381.4 203.44)'/%3E %3Cpath d='M804.22 940.41c17.05-9.61 82.27-46.69 102.03-71.93-2.8.27 5.85 7.47 5.27 10.53 6.43-.43 2.89-7.04 8.23-7.47 4.12 0 7.08-1.72 10.61-3.06 4.12-.86 1.74 1.72 1.74 3.06-5.27 10.1-17.04 16.22-26.5 24.12 1.15.86 2.3 1.72 1.73 3.06 3.46.38 7.58.38 9.96-1.72.58-.43.58-1.77.58-2.63 3.54 1.3 2.31 3.92 1.16 5.7-2.31 5.26-12.35 4.78-15.31 9.61-3.47 5.21-7 9.62-12.35 13.6 4.11-3.5 8.8-7.9 14.15-8.34 8.24-.86 11.2-6.12 18.27-7.84 7.66-1.72 12.35-7.9 18.28-12.73-2.31 3.5-7.08 6.55-5.28 10.53a5.08 5.08 0 0 0 4.87.77c-5.28 7.03-16.06 12.34-19.6 20.66-3.54-1.29-5.85 1.3-8.23 1.72-3.47 1.3-2.31 6.56-4.7 8.33-9.96 5.7-14.73 14.93-18.84 22.77-.58.86-8.24 5.26-11.2 6.13-5.27 2.2-37.9 28.15-38.48 24.66-3.47-16.65-36.27 14.65-112.75-9M985.95 971.96c-.58-.65-1.73-.96-1.73-1.28 1.15-2.61-4.12-2.94-4.12-5.59 8.81 0 15.89 9.47 21.23 3.57 1.16-1.32-2.31-3.25 2.9-4.89 1.15-.28-1.16-1.28-.59-1.97-2.89 0-5.27.32-7.08-.28-2.3-.64-3.53-1.28-6.42-1.97-2.9-.64-4.12-3.57 0-4.57 7.65-1.33 15.89 3.57 21.8.64 4.7-2.29 9.4-2.93 14.09-4.57 2.31-.65 10.04-.28 7.65 1.92-1.73 1.33-5.85.97-8.23 1.6-4.11 1.3-7.65 3.26-11.77 4.9 2.89-.32 2.31 2.93 5.85 1.97 5.27-1.6 10.62-3.57 16.47-4.25-.58-1.29 1.15-2.3 1.15-3.62h1.73c-2.88-3.89 5.28-2.24 8.24-5.53 0 .64.5.64 1.15.96-4.11 1.6-2.3 4.21-3.46 6.22-.58.64-2.31.96-1.74 1.97 2.32 1.6 2.32-1.29 4.12-.64 1.73.32 4.12.96 5.27.64 2.89 0 5.85-1.29 4.05-3.62-2.32-1.92-4.7-3.57-4.7-6.18 0-.32-.58-.64-1.73-.96 4.7 0 8.23 1.33 9.96 3.25 2.32 1.97 2.9 4.9 6.5 5.58 7 .96 6.43-2.29 6.43-5.58 5.27.32 12.93 2.29 11.77 4.9-.5 1.93-4.69 3.57-8.8 3.93-2.9.28-1.16 2.29-2.9 2.61-3.46 0-7.65.64-8.8 1.97-1.16 1.96.57 5.86 2.88 7.18 3.47 1.6 10.55-.64 15.89 0 .5-2.93 4.12-3.89 7.08-5.9 3.46-1.92-1.74-3.57-4.7-4.9-2.3-.64-.57-1.28.58-2.92 1.73-1.93 7.08-.33 7.66-1.93 1.15-1.97-1.16-4.9 1.15-6.22 1.73-1.29 4.12.96 3.47 2.6 2.3-.27 2.89-1.6 5.27-1.92 2.89-.32 4.7 1.93 3.47 2.6-3.47 2.3-6.43 3.9-5.28 7.2 0 1.64-4.11 2.28-2.3 3.6 3.46 2.3 3.46 4.58 4.69 7.2 1.15 2.92 7.65 3.57 13.5 2.28-2.3-5.55 11.2-3.26 17.12-4.9.5 0 .5-.97 0-1.28-2.9-1.6-3.47-2.25-2.9-4.58 0-.28-1.08-.96-1.72-1.28 8.8 2.6 24.4 6.07 30.9 10.97-8.23 1.6-23.83-1.5-32.06.47-9.97 2.6-20 5.85-30.7 5.85-4.69 0-9.38-1.92-14.07-1.92m-94.97-2.6c1.15.27-2.89-.33-3.47-.66' transform='matrix(.18472 .00617 -.00642 .19224 381.4 203.44)'/%3E %3Cpath d='M957.99 1017.33c16.35-1.41 19.33 10.72 29.7-.3 9.86 1.41 18.84-2.03 18.93-3.4 23.02 3.87 93.8-4.72 88.95-9.4-7.6-7.8-19.6-10.45-29.23-17.05-2.14-1.2-6.54-1.74-9.8-2.51-5.43-1.4-12.54.02-17.2-2.14-7.5-3.73-15.44-6.93-22.15-11.71-4.22-2.7-5.78-7.17-10.41-10.45-4.95-3.28-11.94-3.71-16.98-5.66-7.57-2.64-11.92-9.45-19.04-14.26-2.46-1.75-6.56-1.47-9.4-3.01-6.06-2.81-10.86-9.12-16.1-8.07-9.35 1.85-14.64 9.41-23.8 13.75-7.6 3.6-10.96 9.92-17.53 14.15-1.73 1.1-21.71 14.8-44.2 24.6-22.5 9.79-52.02 21.71-54.79 21.8 0 0 20.64 13.6 67.46 10.2l28.98 7.95 15.93-3.22s39.91-1.32 40.68-1.27z' transform='matrix(.18472 .00617 -.00642 .19224 381.4 203.44)'/%3E %3Cpath d='M860.35 985.45c10.36-5.19 50.02-25.21 62-38.77-1.72.16 3.58 3.98 3.23 5.61 3.92-.24 1.74-3.77 5-4.01 2.51-.01 4.31-.94 6.46-1.67 2.51-.47 1.07.91 1.07 1.63-3.19 5.41-10.35 8.72-16.1 12.97.71.46 1.42.92 1.07 1.64 2.12.19 4.63.17 6.07-.95.35-.24.35-.95.35-1.41 2.16.68 1.42 2.09.72 3.04-1.4 2.82-7.52 2.6-9.3 5.18a28.96 28.96 0 0 1-7.5 7.3c2.5-1.87 5.35-4.24 8.6-4.49 5.02-.48 6.81-3.3 11.12-4.25 4.66-.94 7.5-4.26 11.1-6.86-1.4 1.87-4.29 3.53-3.18 5.65.36.22 1.77 1.4 3.22.9-3.2 3.78-10 6.14-12.14 10.6-2.16-.68-3.56.7-5.01.94-2.11.7-1.4 3.51-2.84 4.47-6.06 3.07-8.94 8.03-11.43 12.23-.35.46-5 2.84-6.8 3.31-3.22 1.2-23.04 15.17-23.4 13.3-2.16-8.89-21.4 4.95-68.08-7.45' transform='matrix(.18472 .00617 -.00642 .19224 381.4 203.44)'/%3E %3C/g%3E %3Cpath d='M550 334.62c-28.32 0-51.28 25.83-51.28 57.69S521.68 450 550 450s51.28-25.84 51.28-57.7c0-31.86-22.96-57.7-51.28-57.7zm0 12.88c20.65 0 38.53 19.2 38.53 44.8 0 25.62-17.88 44.81-38.53 44.81-20.65 0-38.53-19.2-38.53-44.8 0-25.6 17.88-44.8 38.53-44.8z' style='text-indent:0;text-align:start;line-height:normal;text-transform:none;block-progression:tb;marker:none;-inkscape-font-specification:Sans' font-weight='400' color='%23000' fill='%2300a6de' stroke='%23000' stroke-width='.19231499999999999' overflow='visible' font-family='Sans'/%3E %3Cg fill='%23e8a30e' fill-rule='nonzero' stroke='%23000' stroke-width='1.27'%3E %3Cpath d='M133.87 24.41c.1 6.95-1.99 7.2-12.55 8.97-10.34 1.73-12.33 1.77-12.47-4.82-.1-6.95 2.2-7.23 12.54-8.97 9.78-1.63 12.33-2.48 12.48 4.82z' transform='matrix(.05586 0 0 .0453 549.9 415.76)'/%3E %3Cpath d='M136.1 24.02c.14 4.36-6.63 5.42-14.74 6.77-8.15 1.35-14.56 2.27-14.7-1.84-.18-4.36 6.58-5.42 14.73-6.77 8.12-1.35 14.53-2.7 14.7 1.84zM56.9 333.89c22.26-73.42 28.1-128.87-3.75-207.57 52.87-62.22 91.66-40.64 126.7 3.54-33.33 77.7-24.62 133.09-5.55 204.56-41.46 27.03-77.57 26.25-117.4-.53z' transform='matrix(.05586 0 0 .0453 549.9 415.76)'/%3E %3Cpath d='M115.33 87.63c-1.1.03-2.2.07-3.3.17 3.7 89.26.58 177.8-.06 266.42 1.45.08 2.94.11 4.4.11-.26-89.18 3.93-175.53-.82-266.7h-.22z' transform='matrix(.05586 0 0 .0453 549.9 415.76)'/%3E %3Cpath d='M125.36 88.55c-9.35 81.25-12.82 163.34-10.56 265.78 1.28 0 2.59 0 3.87-.03C118.13 253.2 121 171.04 129 89.43c-1.2-.32-2.44-.63-3.65-.88zM143.3 3.58c-9.4 12.75-14.57 12.65-9.86 32.42 10.38-8.72 10.1-15.94 9.85-32.42z' transform='matrix(.05586 0 0 .0453 549.9 415.76)'/%3E %3Cpath d='M122.46 12.12c6.13 7.97 15.1 12.12 9.39 33.62-11.2-11.94-9.75-13.14-9.4-33.62zM120.54 34.09c8.12 7.26 15.56 8.78 10 27.53-7.13-10.49-10.2-9.6-10-27.53z' transform='matrix(.05586 0 0 .0453 549.9 415.76)'/%3E %3Cpath d='M118.31 45.78c6.17 7.83 15.13 11.9 9.46 32.95-11.2-11.7-9.74-12.86-9.46-32.95z' transform='matrix(.05586 0 0 .0453 549.9 415.76)'/%3E %3Cpath d='M114.73 62.82c7.2 7.7 17.61 11.8 11.23 32.1-12.43-12.93-6.3-15.94-11.23-32.1z' transform='matrix(.05586 0 0 .0453 549.9 415.76)'/%3E %3Cpath d='M113.35 80.04c6.73 7.44 17.36 11.8 11.34 31.43-9.6-10.84-10.84-12.54-11.34-31.43zM149.5 21.54c-4.9 5.03-16.17 4.54-16.63 26.01 13.9-9.85 13.75-7.97 16.62-26z' transform='matrix(.05586 0 0 .0453 549.9 415.76)'/%3E %3Cpath d='M148.75 36.81c-5.21 4.65-17.26 4.08-17.65 24.2 14.81-9.07 14.67-7.3 17.65-24.2z' transform='matrix(.05586 0 0 .0453 549.9 415.76)'/%3E %3Cpath d='M146.98 50.63c-5.39 5.04-17.86 4.43-18.29 26.15 15.35-9.81 15.17-7.93 18.29-26.15z' transform='matrix(.05586 0 0 .0453 549.9 415.76)'/%3E %3Cpath d='M146.06 69.63c-5.67 2.58-18.93-2.56-19.03 24.37 11.34-3.72 10.56-11.9 19.03-24.37z' transform='matrix(.05586 0 0 .0453 549.9 415.76)'/%3E %3Cpath d='M139.75 86.03c-7.9 4.08-12.37 3.26-13.82 24.91 11.44-9.53 11.3-7.76 13.82-24.9zM148.43 98.79c-19.99 70.62-24.2 137.48-22.22 254.87 1.63-.22 3.23-.46 4.86-.75-1-116.4 2.62-180.81 20.97-251.54-1.2-.92-2.4-1.77-3.61-2.58zM181.03 20.98c-11.41 9.95-16.44 8.5-15.24 28.98 11.7-5.74 12.65-12.86 15.24-28.98z' transform='matrix(.05586 0 0 .0453 549.9 415.76)'/%3E %3Cpath d='M159.1 23.85c4.67 9.39 12.75 15.73 3.47 35.18-8.93-14.53-7.3-15.34-3.48-35.18z' transform='matrix(.05586 0 0 .0453 549.9 415.76)'/%3E %3Cpath d='M153.46 44.72c6.73 9.17 13.75 12.61 5.07 29.44-5.18-12.12-8.36-12.05-5.07-29.44z' transform='matrix(.05586 0 0 .0453 549.9 415.76)'/%3E %3Cpath d='M149.28 55.52c4.68 9.25 12.8 15.56 3.58 34.55-8.97-14.31-7.34-15.1-3.58-34.55z' transform='matrix(.05586 0 0 .0453 549.9 415.76)'/%3E %3Cpath d='M142.8 71.15c5.74 9.39 15.27 16.12 5.52 34.2-9.99-15.85-3.43-17.16-5.52-34.2z' transform='matrix(.05586 0 0 .0453 549.9 415.76)'/%3E %3Cpath d='M138.47 87.56c5.39 9 15.03 16.05 5.74 33.59-7.54-13.11-8.47-15.1-5.74-33.6zM184.04 40.11c-5.67 3.61-16.65.18-20.8 20.94 15.3-5.92 14.85-4.14 20.8-20.94z' transform='matrix(.05586 0 0 .0453 549.9 415.76)'/%3E %3Cpath d='M180.67 54.78c-5.91 3.15-17.64-.6-21.47 18.92 16.09-4.92 15.63-3.3 21.47-18.92z' transform='matrix(.05586 0 0 .0453 549.9 415.76)'/%3E %3Cpath d='M176.56 67.75c-6.16 3.47-18.28-.36-22.46 20.66 16.76-5.53 16.26-3.76 22.46-20.66z' transform='matrix(.05586 0 0 .0453 549.9 415.76)'/%3E %3Cpath d='M172.38 86c-6.02 1.02-18.1-7.44-22.85 18.74 11.76-.67 12.4-8.82 22.85-18.74z' transform='matrix(.05586 0 0 .0453 549.9 415.76)'/%3E %3Cpath d='M163.35 100.31c-8.44 1.88-12.69-.07-17.83 20.59 12.9-6.24 12.44-4.57 17.83-20.59zM167.17 115.16c-25.97 64.2-31.5 122.99-18.56 232.69 1.87-.71 3.79-1.53 5.7-2.38-12.86-104.74-7.8-163.38 16.05-226.88-1.06-1.2-2.12-2.33-3.19-3.43zM210.5 38.34c-12.4 8-17.25 5.77-18.2 26.22 12.22-3.83 13.96-10.7 18.2-26.22z' transform='matrix(.05586 0 0 .0453 549.9 415.76)'/%3E %3Cpath d='M188.4 37.63c3.65 10.03 11.02 17.65-.25 35.36-7.37-15.8-5.67-16.33.25-35.36z' transform='matrix(.05586 0 0 .0453 549.9 415.76)'/%3E %3Cpath d='M180.6 57.4c5.7 10.17 12.33 14.67 1.95 29.9-3.86-12.78-7.05-13.2-1.95-29.9z' transform='matrix(.05586 0 0 .0453 549.9 415.76)'/%3E %3Cpath d='M175.29 67.43c3.72 9.88 11.09 17.43-.04 34.72-7.4-15.59-5.7-16.08.04-34.72z' transform='matrix(.05586 0 0 .0453 549.9 415.76)'/%3E %3Cpath d='M167.24 81.85c4.72 10.2 13.47 18.35 1.88 34.69-8.25-17.26-1.6-17.54-1.88-34.69z' transform='matrix(.05586 0 0 .0453 549.9 415.76)'/%3E %3Cpath d='M161.22 97.37c4.4 9.78 13.25 18.28 2.16 34.12-6.1-14.14-6.8-16.26-2.16-34.12zM211.46 57.76c-5.98 2.62-16.54-2.52-22.85 17.36 15.84-3.4 15.2-1.74 22.85-17.36z' transform='matrix(.05586 0 0 .0453 549.9 415.76)'/%3E %3Cpath d='M206.61 71.72c-6.2 2.16-17.5-3.4-23.35 15.23 16.51-2.26 15.9-.7 23.35-15.23z' transform='matrix(.05586 0 0 .0453 549.9 415.76)'/%3E %3Cpath d='M201.15 83.87c-6.48 2.44-18.14-3.3-24.48 16.83 17.22-2.8 16.55-1.1 24.48-16.83z' transform='matrix(.05586 0 0 .0453 549.9 415.76)'/%3E %3Cpath d='M195.1 101.23c-6.1.07-17.23-10.24-24.7 14.88 11.76 1.24 13.25-6.73 24.7-14.88z' transform='matrix(.05586 0 0 .0453 549.9 415.76)'/%3E %3Cpath d='M184.6 113.95c-8.6.53-12.6-2.05-19.87 17.54 13.46-4.14 12.83-2.51 19.88-17.54zM101.37 89.86c-1.17.35-2.37.78-3.57 1.2 8.57 81.29 14.06 163.35 13 263.1 1.1.06 2.2.14 3.3.14 2.83-101.77-2.95-183.34-12.73-264.44zM83.34 1.91c9.32 13.26 14.5 13.43 9.67 33-10.34-9.33-10.03-16.56-9.67-33z' transform='matrix(.05586 0 0 .0453 549.9 415.76)'/%3E %3Cpath d='M104.14 11.59c-6.2 7.65-15.2 11.3-9.6 33.13 11.23-11.3 9.81-12.62 9.6-33.13z' transform='matrix(.05586 0 0 .0453 549.9 415.76)'/%3E %3Cpath d='M105.9 33.66c-8.18 6.8-15.62 7.94-10.16 27 7.2-10.13 10.24-9.03 10.17-27z' transform='matrix(.05586 0 0 .0453 549.9 415.76)'/%3E %3Cpath d='M108.07 45.5c-6.2 7.5-15.2 11.05-9.67 32.42 11.3-11.06 9.85-12.33 9.67-32.42z' transform='matrix(.05586 0 0 .0453 549.9 415.76)'/%3E %3Cpath d='M111.54 62.72c-7.23 7.33-17.68 10.84-11.4 31.5 12.5-12.23 6.37-15.6 11.4-31.5z' transform='matrix(.05586 0 0 .0453 549.9 415.76)'/%3E %3Cpath d='M112.82 80.04c-6.8 7.05-17.43 10.81-11.52 30.8 9.64-10.35 10.88-11.98 11.52-30.8zM77.03 19.52c4.86 5.28 16.12 5.46 16.48 26.93C79.65 35.82 79.8 37.7 77.03 19.52z' transform='matrix(.05586 0 0 .0453 549.9 415.76)'/%3E %3Cpath d='M77.67 34.83c5.17 4.93 17.26 5.03 17.5 25.16-14.77-9.85-14.6-8.12-17.5-25.16z' transform='matrix(.05586 0 0 .0453 549.9 415.76)'/%3E %3Cpath d='M79.37 48.72c5.35 5.35 17.82 5.46 18.14 27.21-15.27-10.7-15.13-8.82-18.14-27.21z' transform='matrix(.05586 0 0 .0453 549.9 415.76)'/%3E %3Cpath d='M80.19 67.78c5.66 2.9 18.92-1.48 18.88 25.44-11.34-4.35-10.49-12.5-18.88-25.44z' transform='matrix(.05586 0 0 .0453 549.9 415.76)'/%3E %3Cpath d='M86.39 84.54c7.9 4.5 12.33 3.97 13.67 25.66-11.4-10.14-11.26-8.37-13.67-25.66zM79.37 101.2c-1.17.85-2.34 1.77-3.54 2.73 18.5 70.12 25.3 134.96 23.67 248.77 1.41.28 2.87.53 4.28.74 2.63-115.12-4.46-182.01-24.41-252.24zM45.5 17.22c11.37 10.56 16.4 9.39 15.1 29.84-11.67-6.45-12.62-13.61-15.1-29.84z' transform='matrix(.05586 0 0 .0453 549.9 415.76)'/%3E %3Cpath d='M67.43 21.26c-4.71 9.14-12.86 15.06-3.69 35 9.04-14.02 7.41-14.91 3.69-35z' transform='matrix(.05586 0 0 .0453 549.9 415.76)'/%3E %3Cpath d='M72.92 42.45c-6.77 8.82-13.82 11.87-5.24 29.16 5.24-11.8 8.43-11.55 5.24-29.16z' transform='matrix(.05586 0 0 .0453 549.9 415.76)'/%3E %3Cpath d='M77.07 53.5c-4.75 9-12.9 14.85-3.83 34.34 9.07-13.82 7.44-14.67 3.83-34.34z' transform='matrix(.05586 0 0 .0453 549.9 415.76)'/%3E %3Cpath d='M83.4 69.48c-5.77 9.08-15.33 15.28-5.7 33.88 10.07-15.27 3.55-16.94 5.7-33.88z' transform='matrix(.05586 0 0 .0453 549.9 415.76)'/%3E %3Cpath d='M87.63 86.14c-5.39 8.71-15.1 15.2-5.92 33.23 7.62-12.65 8.54-14.56 5.92-33.23zM42.41 36.18c5.64 3.9 16.62 1.1 20.66 22.07-15.3-6.77-14.85-5-20.66-22.07z' transform='matrix(.05586 0 0 .0453 549.9 415.76)'/%3E %3Cpath d='M45.67 51.02c5.89 3.48 17.65.4 21.33 20.1-16.05-5.82-15.62-4.15-21.33-20.1z' transform='matrix(.05586 0 0 .0453 549.9 415.76)'/%3E %3Cpath d='M49.68 64.2C55.8 68.03 68 64.88 72 86.14c-16.69-6.49-16.23-4.68-22.32-21.94z' transform='matrix(.05586 0 0 .0453 549.9 415.76)'/%3E %3Cpath d='M53.75 82.67c6.03 1.38 18.18-6.42 22.75 20.02-11.76-1.32-12.33-9.5-22.75-20.02zM62.68 97.48c8.43 2.37 12.69.67 17.72 21.61-12.86-6.98-12.4-5.24-17.72-21.61zM60.9 117.67c-.95 1-1.9 2.02-2.86 3.09 23.5 65.09 27.32 120.86 19.66 224.57l1.07.74c1.24.54 2.44 1.07 3.68 1.56 8.72-105.2 4.43-162.1-21.54-229.96zM15.94 32.92c12.34 8.68 17.23 6.7 18.04 27.25-12.19-4.54-13.89-11.52-18.04-27.25z' transform='matrix(.05586 0 0 .0453 549.9 415.76)'/%3E %3Cpath d='M38.06 33.45c-3.73 9.81-11.13 17 .03 35.36 7.44-15.38 5.74-16.01-.03-35.36z' transform='matrix(.05586 0 0 .0453 549.9 415.76)'/%3E %3Cpath d='M45.7 53.61c-5.77 9.85-12.43 14.03-2.12 29.83 3.97-12.57 7.12-12.82 2.13-29.83z' transform='matrix(.05586 0 0 .0453 549.9 415.76)'/%3E %3Cpath d='M50.95 63.96c-3.75 9.67-11.2 16.8-.17 34.72 7.54-15.16 5.84-15.77.17-34.72z' transform='matrix(.05586 0 0 .0453 549.9 415.76)'/%3E %3Cpath d='M58.93 78.84c-4.79 9.92-13.58 17.6-2.1 34.58 8.37-16.8 1.7-17.43 2.1-34.58z' transform='matrix(.05586 0 0 .0453 549.9 415.76)'/%3E %3Cpath d='M64.84 94.68c-4.43 9.53-13.36 17.54-2.37 34.01 6.2-13.82 6.9-15.87 2.37-34.01zM14.85 52.26c5.98 2.98 16.58-1.56 22.74 18.64-15.83-4.29-15.16-2.59-22.74-18.64z' transform='matrix(.05586 0 0 .0453 549.9 415.76)'/%3E %3Cpath d='M19.63 66.47c6.2 2.52 17.5-2.4 23.24 16.59-16.5-3.23-15.87-1.63-23.24-16.59z' transform='matrix(.05586 0 0 .0453 549.9 415.76)'/%3E %3Cpath d='M25.02 78.94c6.44 2.84 18.14-2.26 24.37 18.22-17.22-3.76-16.54-2.02-24.37-18.22z' transform='matrix(.05586 0 0 .0453 549.9 415.76)'/%3E %3Cpath d='M30.97 96.66c6.1.4 17.29-9.28 24.59 16.27-11.76.56-13.22-7.48-24.6-16.27z' transform='matrix(.05586 0 0 .0453 549.9 415.76)'/%3E %3Cpath d='M41.35 109.95c8.61 1.03 12.61-1.35 19.8 18.64-13.46-4.86-12.85-3.23-19.8-18.64zM102.3.53c8.71 13.9 13.85 14.42 8.14 33.56-9.88-10-9.24-17.19-8.14-33.56z' transform='matrix(.05586 0 0 .0453 549.9 415.76)'/%3E %3Cpath d='M122.63 11.66c-6.52 7.19-15.7 10.17-11.09 32.31 11.77-10.49 10.39-11.87 11.1-32.31z' transform='matrix(.05586 0 0 .0453 549.9 415.76)'/%3E %3Cpath d='M123.41 33.77c-8.47 6.23-15.98 6.84-11.37 26.22 7.62-9.6 10.63-8.3 11.37-26.22z' transform='matrix(.05586 0 0 .0453 549.9 415.76)'/%3E %3Cpath d='M125 45.7c-6.51 7.06-15.65 10-11.08 31.69C125.68 67.15 124.3 65.76 125 45.7z' transform='matrix(.05586 0 0 .0453 549.9 415.76)'/%3E %3Cpath d='M127.74 63.14c-7.59 6.8-18.18 9.57-12.87 30.62 13.08-11.34 7.1-15.13 12.87-30.62z' transform='matrix(.05586 0 0 .0453 549.9 415.76)'/%3E %3Cpath d='M128.23 80.5c-7.12 6.56-17.93 9.6-12.93 29.9 10.1-9.63 11.44-11.15 12.93-29.9zM95.17 17.68c4.64 5.6 15.88 6.52 15.27 28-13.35-11.56-13.28-9.68-15.27-28z' transform='matrix(.05586 0 0 .0453 549.9 415.76)'/%3E %3Cpath d='M95.14 32.99c4.96 5.28 17 6.2 16.37 26.29-14.32-10.88-14.25-9.1-16.37-26.3zM96.2 46.95c5.1 5.7 17.58 6.66 16.9 28.38-14.77-11.73-14.74-9.81-16.9-28.38z' transform='matrix(.05586 0 0 .0453 549.9 415.76)'/%3E %3Cpath d='M96.13 66.01c5.56 3.3 19-.18 17.75 26.68-11.12-5.13-9.92-13.18-17.75-26.68z' transform='matrix(.05586 0 0 .0453 549.9 415.76)'/%3E %3Cpath d='M101.59 83.16c7.69 5.07 12.15 4.82 12.5 26.54-10.94-10.91-10.87-9.14-12.5-26.54zM91.1 94a69.62 69.62 0 0 0-3.9 2.1c16.37 82.52 20.2 158.7 18.78 257.66.46.04.92.07 1.38.15l1.88-.43c2.37-88.3 0-174.58-18.14-259.48zM63.14 11.59c10.8 11.44 15.91 10.66 13.54 30.93-11.34-7.33-11.87-14.53-13.54-30.93z' transform='matrix(.05586 0 0 .0453 549.9 415.76)'/%3E %3Cpath d='M84.83 17.36c-5.18 8.75-13.61 14-5.5 34.62 9.75-13.29 8.19-14.31 5.5-34.62z' transform='matrix(.05586 0 0 .0453 549.9 415.76)'/%3E %3Cpath d='M89.26 38.94c-7.23 8.26-14.46 10.74-6.77 28.63 5.84-11.37 9-10.84 6.77-28.63z' transform='matrix(.05586 0 0 .0453 549.9 415.76)'/%3E %3Cpath d='M92.8 50.28c-5.2 8.57-13.64 13.75-5.6 33.9 9.78-13.03 8.19-14.02 5.6-33.9z' transform='matrix(.05586 0 0 .0453 549.9 415.76)'/%3E %3Cpath d='M98.33 66.72c-6.27 8.58-16.13 14-7.48 33.3 10.88-14.41 4.43-16.65 7.48-33.3z' transform='matrix(.05586 0 0 .0453 549.9 415.76)'/%3E %3Cpath d='M101.7 83.62c-5.89 8.26-15.92 13.96-7.66 32.67 8.26-12.01 9.28-13.85 7.65-32.67zM59.07 30.26c5.42 4.32 16.54 2.4 19.49 23.63-14.92-7.97-14.57-6.13-19.5-23.63z' transform='matrix(.05586 0 0 .0453 549.9 415.76)'/%3E %3Cpath d='M61.55 45.28c5.7 3.94 17.6 1.81 20.3 21.76-15.77-7.09-15.41-5.39-20.3-21.76z' transform='matrix(.05586 0 0 .0453 549.9 415.76)'/%3E %3Cpath d='M64.91 58.75c5.92 4.32 18.22 2.12 21.16 23.63-16.37-7.8-15.98-5.95-21.16-23.63z' transform='matrix(.05586 0 0 .0453 549.9 415.76)'/%3E %3Cpath d='M68 77.5c5.95 1.83 18.5-4.97 21.72 21.75C78.02 97.02 77.85 88.8 68 77.49z' transform='matrix(.05586 0 0 .0453 549.9 415.76)'/%3E %3Cpath d='M76.15 92.98c8.32 3 12.65 1.66 16.58 22.92-12.47-7.97-12.12-6.23-16.58-22.92zM54.64 124.58c-.5.57-1 1.14-1.49 1.74 19.38 47.94 24.84 87.24 21.08 127.24v.07c-.7 26.18-3.93 54.35-9.35 85.29 1.38.81 2.76 1.56 4.1 2.3l.79.28c15.27-88.54 13.82-153.95-15.13-216.92z' transform='matrix(.05586 0 0 .0453 549.9 415.76)'/%3E %3Cpath d='M71.11 107.86c-1.2 1.06-2.44 2.16-3.65 3.3C89.65 184.28 92.7 251.71 89.5 350.03l2.94 1 1.28.31c4.22-100.06 1.49-170-22.6-243.5zM31 24.98c12.05 9.35 16.98 7.65 17.08 28.17C36.04 47.98 34.62 40.93 31 24.98z' transform='matrix(.05586 0 0 .0453 549.9 415.76)'/%3E %3Cpath d='M53.08 26.72c-4.04 9.6-11.73 16.4-1.2 35.32 8-14.95 6.3-15.66 1.2-35.32z' transform='matrix(.05586 0 0 .0453 549.9 415.76)'/%3E %3Cpath d='M60.06 47.3c-6.13 9.5-12.93 13.3-3.23 29.63 4.43-12.34 7.59-12.4 3.23-29.63z' transform='matrix(.05586 0 0 .0453 549.9 415.76)'/%3E %3Cpath d='M64.91 57.86c-4.1 9.46-11.8 16.2-1.41 34.7 8.07-14.75 6.4-15.46 1.41-34.7z' transform='matrix(.05586 0 0 .0453 549.9 415.76)'/%3E %3Cpath d='M72.35 73.17c-5.13 9.64-14.2 16.83-3.33 34.4 8.97-16.3 2.34-17.32 3.33-34.4z' transform='matrix(.05586 0 0 .0453 549.9 415.76)'/%3E %3Cpath d='M77.7 89.33c-4.78 9.24-13.96 16.76-3.57 33.8 6.7-13.46 7.47-15.48 3.57-33.8zM29.23 44.26c5.88 3.3 16.62-.68 22.08 19.84-15.66-5.17-15.1-3.4-22.08-19.84z' transform='matrix(.05586 0 0 .0453 549.9 415.76)'/%3E %3Cpath d='M33.52 58.71c6.1 2.84 17.57-1.49 22.64 17.79-16.4-4.11-15.84-2.48-22.64-17.79z' transform='matrix(.05586 0 0 .0453 549.9 415.76)'/%3E %3Cpath d='M38.44 71.43c6.35 3.2 18.25-1.27 23.75 19.53-17.08-4.72-16.48-2.94-23.75-19.53z' transform='matrix(.05586 0 0 .0453 549.9 415.76)'/%3E %3Cpath d='M43.76 89.47c6.1.7 17.61-8.36 24.02 17.54-11.8-.07-12.93-8.19-24.02-17.54z' transform='matrix(.05586 0 0 .0453 549.9 415.76)'/%3E %3Cpath d='M53.68 103.29c8.58 1.49 12.65-.68 19.13 19.66-13.28-5.6-12.72-3.93-19.13-19.66zM.5 46.7c13.14 6.66 17.71 3.93 20.69 24.2C8.65 68.35 6.27 61.7.49 46.7z' transform='matrix(.05586 0 0 .0453 549.9 415.76)'/%3E %3Cpath d='M22.43 43.69c-2.66 10.38-9.25 18.7 3.72 35.18 5.78-16.5 4-16.86-3.72-35.18z' transform='matrix(.05586 0 0 .0453 549.9 415.76)'/%3E %3Cpath d='M32.14 62.54c-4.71 10.7-10.84 15.9.99 29.98 2.59-13.15 5.7-13.9-1-29.98z' transform='matrix(.05586 0 0 .0453 549.9 415.76)'/%3E %3Cpath d='M38.37 71.96c-2.69 10.24-9.28 18.5 3.48 34.55 5.84-16.3 4.1-16.62-3.48-34.55z' transform='matrix(.05586 0 0 .0453 549.9 415.76)'/%3E %3Cpath d='M47.83 85.46c-3.68 10.67-11.58 19.7 1.53 34.73 6.52-18.04-.1-17.61-1.53-34.73z' transform='matrix(.05586 0 0 .0453 549.9 415.76)'/%3E %3Cpath d='M55.35 100.31c-3.4 10.17-11.38 19.56 1.2 34.16 4.68-14.7 5.17-16.87-1.2-34.16zM1.45 66.08C7.7 68.1 17.68 61.9 25.9 81c-16.12-1.74-15.27-.14-24.45-14.92z' transform='matrix(.05586 0 0 .0453 549.9 415.76)'/%3E %3Cpath d='M7.69 79.48c6.38 1.52 17.04-5.21 24.7 12.75-16.66-.56-15.88.96-24.7-12.75z' transform='matrix(.05586 0 0 .0453 549.9 415.76)'/%3E %3Cpath d='M14.28 91.03c6.7 1.77 17.75-5.18 26.04 14.2-17.43-.99-16.58.6-26.04-14.2z' transform='matrix(.05586 0 0 .0453 549.9 415.76)'/%3E %3Cpath d='M22.04 107.68c6.06-.6 16.12-11.98 26.04 12.23-11.58 2.44-13.85-5.32-26.04-12.23z' transform='matrix(.05586 0 0 .0453 549.9 415.76)'/%3E %3Cpath d='M33.7 119.23c8.6-.35 12.33-3.36 21.54 15.38-13.82-2.7-13.04-1.17-21.54-15.38zM139.6 93.54c-18.84 84.51-21.5 171.89-19.66 260.68a60.2 60.2 0 0 0 4.36-.35c-.78-99.92 2.4-175.93 19.24-258.2a71.26 71.26 0 0 0-3.93-2.13zM167.56 14.5c-10.87 10.83-15.94 9.77-13.71 30.18 11.37-6.7 11.98-13.89 13.71-30.19z' transform='matrix(.05586 0 0 .0453 549.9 415.76)'/%3E %3Cpath d='M145.84 19.06c5.14 9.04 13.54 14.74 5.28 34.9-9.67-13.81-8.08-14.74-5.28-34.9z' transform='matrix(.05586 0 0 .0453 549.9 415.76)'/%3E %3Cpath d='M141.3 40.4c7.2 8.64 14.4 11.5 6.6 28.98-5.81-11.66-8.97-11.34-6.6-28.99z' transform='matrix(.05586 0 0 .0453 549.9 415.76)'/%3E %3Cpath d='M137.7 51.52c5.13 8.86 13.56 14.53 5.38 34.23-9.71-13.6-8.12-14.5-5.39-34.23z' transform='matrix(.05586 0 0 .0453 549.9 415.76)'/%3E %3Cpath d='M132.06 67.64c6.2 8.93 16.05 14.88 7.26 33.73-10.77-15.02-4.32-16.86-7.26-33.73z' transform='matrix(.05586 0 0 .0453 549.9 415.76)'/%3E %3Cpath d='M128.62 84.37c5.78 8.6 15.8 14.84 7.44 33.1-8.18-12.48-9.21-14.4-7.44-33.1zM171.53 33.38c-5.46 4.04-16.55 1.49-19.63 22.57 14.99-7.16 14.6-5.35 19.63-22.57z' transform='matrix(.05586 0 0 .0453 549.9 415.76)'/%3E %3Cpath d='M168.94 48.3c-5.7 3.6-17.6.81-20.4 20.58 15.8-6.2 15.4-4.5 20.4-20.58z' transform='matrix(.05586 0 0 .0453 549.9 415.76)'/%3E %3Cpath d='M165.54 61.58c-5.95 3.94-18.24 1.07-21.33 22.43 16.4-6.87 16.02-5.07 21.33-22.43z' transform='matrix(.05586 0 0 .0453 549.9 415.76)'/%3E %3Cpath d='M162.32 80.11c-5.95 1.53-18.46-5.98-21.83 20.56 11.7-1.6 11.9-9.78 21.83-20.56z' transform='matrix(.05586 0 0 .0453 549.9 415.76)'/%3E %3Cpath d='M154.06 95.14c-8.32 2.58-12.65.95-16.72 22 12.54-7.26 12.19-5.56 16.72-22zM159.34 107.47c-25.97 72.46-29.44 142.51-23.38 244.38 1.95-.5 3.9-1.03 5.84-1.63-6.7-103.04-3.36-168.98 20.73-239.78a122.43 122.43 0 0 0-3.19-2.97zM199.63 29.7c-12.12 8.67-17 6.69-17.26 27.2 12.09-4.5 13.54-11.47 17.26-27.2z' transform='matrix(.05586 0 0 .0453 549.9 415.76)'/%3E %3Cpath d='M177.52 30.19c4 9.85 11.66 17.04 1.03 35.4-7.9-15.42-6.24-16.05-1.03-35.4z' transform='matrix(.05586 0 0 .0453 549.9 415.76)'/%3E %3Cpath d='M170.47 50.39c6.06 9.85 12.83 14 3.01 29.8-4.32-12.58-7.51-12.83-3.01-29.8z' transform='matrix(.05586 0 0 .0453 549.9 415.76)'/%3E %3Cpath d='M165.5 60.7c4.05 9.67 11.7 16.8 1.21 34.72-7.97-15.2-6.27-15.77-1.2-34.72z' transform='matrix(.05586 0 0 .0453 549.9 415.76)'/%3E %3Cpath d='M158 75.54c5.06 9.96 14.1 17.65 3.11 34.59-8.85-16.8-2.23-17.44-3.11-34.59z' transform='matrix(.05586 0 0 .0453 549.9 415.76)'/%3E %3Cpath d='M152.54 91.42c4.71 9.53 13.85 17.54 3.37 33.98-6.6-13.82-7.37-15.88-3.37-33.98zM201.26 49.04c-5.88 2.98-16.58-1.6-22.18 18.6 15.7-4.25 15.1-2.55 22.18-18.6z' transform='matrix(.05586 0 0 .0453 549.9 415.76)'/%3E %3Cpath d='M196.9 63.28c-6.1 2.48-17.54-2.48-22.75 16.52 16.44-3.2 15.84-1.6 22.75-16.52z' transform='matrix(.05586 0 0 .0453 549.9 415.76)'/%3E %3Cpath d='M191.9 75.72c-6.37 2.8-18.2-2.27-23.84 18.18 17.11-3.72 16.48-2.02 23.85-18.18z' transform='matrix(.05586 0 0 .0453 549.9 415.76)'/%3E %3Cpath d='M186.48 93.44c-6.09.39-17.57-9.32-24.13 16.23 11.8.56 13-7.48 24.13-16.23z' transform='matrix(.05586 0 0 .0453 549.9 415.76)'/%3E %3Cpath d='M176.5 106.72c-8.58 1-12.7-1.38-19.25 18.6 13.29-4.85 12.72-3.22 19.24-18.6zM176.92 126.18c-30.33 65.62-27.75 135.42-15.24 215.68 1.56-.82 3.08-1.67 4.68-2.55-5.35-34.7-8.79-66.51-8.68-96.66v-.18c-1.56-35.04 4.14-70.55 22.21-112.6-.99-1.25-1.98-2.49-2.97-3.7zM230 53.11c-13.19 5.92-17.76 2.95-20.84 23.04 12.54-1.85 14.99-8.4 20.84-23.04z' transform='matrix(.05586 0 0 .0453 549.9 415.76)'/%3E %3Cpath d='M208.1 48.9c2.59 10.49 9.1 19.17-3.97 34.93-5.63-16.83-3.9-17.07 3.97-34.93z' transform='matrix(.05586 0 0 .0453 549.9 415.76)'/%3E %3Cpath d='M198.28 67.18c4.61 10.95 10.74 16.51-1.2 29.9-2.52-13.28-5.6-14.2 1.2-29.9z' transform='matrix(.05586 0 0 .0453 549.9 415.76)'/%3E %3Cpath d='M191.94 76.25c2.66 10.38 9.21 19-3.65 34.37-5.77-16.62-4-16.86 3.65-34.37z' transform='matrix(.05586 0 0 .0453 549.9 415.76)'/%3E %3Cpath d='M182.44 89.22c3.62 10.84 11.45 20.34-1.77 34.62-6.37-18.36.25-17.58 1.77-34.62z' transform='matrix(.05586 0 0 .0453 549.9 415.76)'/%3E %3Cpath d='M174.83 103.64c3.33 10.35 11.26 20.2-1.42 34.09-4.6-14.95-5.07-17.15 1.42-34.09zM228.93 72.46c-6.23 1.63-16.19-5.1-24.55 13.54 16.12-.85 15.3.7 24.55-13.54z' transform='matrix(.05586 0 0 .0453 549.9 415.76)'/%3E %3Cpath d='M222.63 85.46c-6.38 1.17-17.01-6.13-24.8 11.41 16.68.36 15.87 1.81 24.8-11.4z' transform='matrix(.05586 0 0 .0453 549.9 415.76)'/%3E %3Cpath d='M215.93 96.66c-6.7 1.38-17.68-6.16-26.12 12.76 17.44-.04 16.59 1.52 26.12-12.76z' transform='matrix(.05586 0 0 .0453 549.9 415.76)'/%3E %3Cpath d='M208.1 112.85c-6.06-.92-16.05-12.86-26.12 10.81 11.56 3.08 13.9-4.57 26.12-10.8z' transform='matrix(.05586 0 0 .0453 549.9 415.76)'/%3E %3Cpath d='M196.33 123.77c-8.6-.85-12.3-4.08-21.61 14.17 13.85-1.95 13.08-.46 21.61-14.17zM98.79 218.16l31.85.89c19.28.53 34.76 5.95 34.73 12.19 0 6.2-15.52 10.77-34.8 10.24l-31.85-.89c-19.28-.53-34.76-5.95-34.73-12.19.04-6.2 15.52-10.8 34.8-10.24z' transform='matrix(.05586 0 0 .0453 549.9 415.76)'/%3E %3Cpath d='M76.71 217.52l-9.53 19.78a7.88 7.88 0 0 0 5.46 2.58l5.74.14 10.7-22.14-12.37-.36zm24.8.71l-10.66 22.15 12.33.35 10.7-22.18-12.36-.32zm24.84.68l-10.7 22.14 12.33.36 10.7-22.15-12.33-.35zm24.8.7l-10.7 22.15 12.37.35 9.4-19.48a8.07 8.07 0 0 0-5.75-2.87l-5.31-.15z' transform='matrix(.05586 0 0 .0453 549.9 415.76)'/%3E %3C/g%3E %3Cg fill='%23e7e7e7' stroke='%23000' stroke-width='3.09'%3E %3Cpath d='M-123.18 1511.6c.24-.04 3 43.37 6.39 64.53.41 2.59 3.55 4.1 4.25 6.62.76 2.73-.2 5.67-.24 8.5 0 .32.05.64 0 .95-.55 3.9-4 7.47-3.3 11.35.39 2.22 3.14 3.36 4.01 5.44 5.1 12.06 4.04 26.47 6.39 38.76.98 5.18-.95-1 8.27 13.7.92 1.49 4.96 1.66 4.96 1.66l4.02.24 3.76 3.88-5.69 5.18-17.55 1.67-7.85-5.01s2.48-4.25 1-6.35c-1.06-1.51-4.83-.5-5.01-2.34-.33-3.37-.7-12.53-.84-12.54-.3-.01-.15-.6-.33-.83 0 0-12.78-14.68-17.22-23.24-2.3-4.42-2.14-9.91-4.68-14.2-1.62-2.75-5.22-4.1-6.52-7.02-10.75-24.3-21.52-71.13-21.56-70.87M-333.8 1500.42l45.3 11.33-18.01 62.89c-9.69 19.86-8.98 20.58-6.88 26.27 4.41 10.93 7.1 27.28 23.61 53.25 5.98 6.62 12.87 7.4 15.19 10.1.97 2.83 6.14 7.1 10.65 8.88h14.52c2.69-3.22 2.63-2.15 3.46-4.6-.81-2.96-7.8-1.94-12.33-6.02-1.93-7.7-11.72-19.56-12.56-27.67-4.45-17.72-2.74-18.24.12-36.2 1.43-9.26 11.11-29.68 14.98-40.79 7.8-11.86 16.29-32.53 16.48-47.46l-16.39-41.7-10.2-16.98M-307.15 1424.29c-75.62 20.37-49.75 84.64-28.89 85.87M-80.85 1319.76l12.9-22.82 1.45-8.42-.9-1.78-21.49 21.78-.37 1.45' transform='matrix(.06022 -.00163 .00525 .06438 544.07 322.5)'/%3E %3Cpath d='M-41.13 1358.04c4.58 1.77 10.4 3.54 11.67.94 1.58-3.21 2.36-5.48-1.03-8.1-1.63-1.46 1.23-3.65-.47-7.8-12.2-8.8-21.06-9.24-23.65-16.07l-.1-4.68c-.14-5.93-18.51-8.84-22.78-11.85 0 0-7.51-3.84-11.6-4.78-1.74-.4-5.37-.34-5.37-.34-18.85-.65-29.12 17.69-33.25 28.9 0 0-8.2 51.38-19.4 74.44-1.03 2.1-2.52 4-4.25 5.56-1.69 1.53-3.56 3.8-5.82 3.6-51.97-4.69-87.39-7.79-108.68-7.6-21.3.2-46.9 14.99-48.54 16.63 0 0-24.88 13.89-32.12 37.4-2.42 7.86-1.16 17.23 1.34 26.6 18.07 63.04 46.7.95 55.06 1.9l10.29 1.18c12.07 1.37 31.42 36.92 64.99 44.77 101.33 23.72 134.01-26.04 141.59-138.26l1.39-1.59v-3.82l6.03-8.8.1-12.44-1.35-5.93.39-2.3 29.37-2.77 5.19-2.04' transform='matrix(.06022 -.00163 .00525 .06438 544.07 322.5)'/%3E %3Cpath d='M-88.42 1324.95l14.75-26.12 1.66-9.63-1.02-2.04-24.6 24.93-.42 1.65M-345.18 1490.89c4.99 18.68 15.28 37.39 13.85 44.19-2.16 10.2-8.71 14.76-9.25 15.72-.5.87-2.9 2.12-3.7 2.75-3.4 2.68-5.99 8.22-7.77 12.18-2.2 4.9-3.57 9.28-3.4 14.13.61 18 8.4 55.14 8.93 55.69 0 0 5.94 3.6 7.44 7.06 1.52 3.51.62 6.84.06 10.62-.77 5.2-4.9 16.72-4.9 16.72s.04 2.26.68 2.94c1.8 1.91 8.19 5.31 8.19 5.31h14s-7.15-7.55-7.6-9.22c-.49-1.85-.68-3.27.04-5.34 1.32-3.83 5.66-8.3 7.15-10.56 1.6-2.44.66-8.94.66-8.94.06-2.37-1.88-3.5-1.94-4.5-.48-7.79-.5-13.4-.19-21.13.28-6.81 3.28-27.18 3.28-27.18s3.55-2.55 5-4.16c1.33-1.46 3.32-4.9 3.32-4.9s17.68-8.67 25.47-14.6c9.23-7.03 24.71-24.5 24.71-24.5s4.64-7.13 5.6-11.19c.32-1.38.2-2.85 0-4.25a83.82 83.82 0 0 0-6.69-22.1c-3.07-6.8-6.77-13.49-11.81-19-.52-.56-1.85-1.37-1.85-1.37M-126.06 1534.25c-14.59 8.23-47.98 14.46-49.05 20.64 0 0-4.35 38.84-10.44 54.23-2.4 6.06-5.65 7.77-8.58 13.6-3.05 6.06-3.3 10.75-6.02 16.8-2.9 6.46-7.6 12.2-9.2 23.5l-.47 9.4 9.57 5.83-10.71 3.06-15.79-6.5-.1-14.35 4.88-14.74.39-2.39-3.26-9.09.2-32.34 4.87-24 4.12-88.7M-83.29 1362.83c6.11 5.1 14.47 8.51 34.7 3.02 3.58 2.35 7.34 5.27 16.7-5.37M-39.67 1347.53c.13-.13 3.6 2.47 4.95 2.5 1.06.03 2.56-1.96 1.75-2.65-.88-.75-2.56-1.62-3.45-1.1-1.29.75-3.23 1.47-3.25 1.25z' transform='matrix(.06022 -.00163 .00525 .06438 544.07 322.5)'/%3E %3Cpath d='M546.53 408.47s.1 0 .15.1c.14.31.48.36.76.03.03-.04.11-.1.12-.1-.05 0-.09 0-.13-.05-.3-.3-.62-.04-.72-.02l-.18.04z' fill='%23000' stroke='none'/%3E %3C/g%3E %3Cg fill-rule='evenodd' stroke='%23e3e4e5' stroke-width='.42'%3E %3Cg fill='%23e7e7e7' stroke='%23000'%3E %3Cpath d='M564.27 426.42c-.09.47-.08.84-.02 1.17-.09.42-.1.83-.02 1.17-.07.37-.09.74-.02 1.11-.07.37-.07.73-.02 1.06.39.3 1.48.33 1.97.06.06-.33.06-.74 0-1.1.07-.37.06-.75-.01-1.12.07-.34.07-.75 0-1.17.06-.32.07-.7-.01-1.17a3.5 3.5 0 0 0-.01-1.2c.06-.37.06-.76-.01-1.17.07-.36.06-.76-.01-1.22a4.1 4.1 0 0 0 0-1.23c.06-.43.05-.84-.02-1.23a3.8 3.8 0 0 0 0-1.23c.06-.35.06-.75-.02-1.22.1-.38.07-.86 0-1.23.06-.45.05-.85-.01-1.23.06-.4.06-.81-.01-1.22.05-.4.04-.81-.01-1.23.05-.4.04-.8-.01-1.22.04-.37.04-.77-.02-1.23.06-.38.07-.8 0-1.23.06-.4.05-.81-.01-1.23.05-.38.06-.78-.02-1.22a3.6 3.6 0 0 0-.01-1.2c.05-.4.05-.7 0-1.1.01-.13 0-.36-.01-.48l-1.23-.02c-.06.08-.07.25-.04.48-.06.18-.06.94.01 1.12a3.6 3.6 0 0 0-.02 1.2c-.08.43-.09.84-.03 1.22-.07.41-.08.82-.03 1.22-.08.44-.07.85-.02 1.24-.07.45-.07.85-.03 1.22-.06.42-.08.81-.03 1.22-.06.42-.07.83-.02 1.23-.08.41-.09.82-.03 1.23-.07.37-.08.77-.02 1.21-.08.38-.12.86-.03 1.24-.08.47-.09.87-.02 1.23a3.8 3.8 0 0 0-.03 1.22c-.07.4-.08.8-.02 1.23-.08.47-.08.87-.03 1.24-.08.45-.08.85-.02 1.2-.08.42-.08.8-.02 1.17-.09.45-.09.85-.03 1.2z' stroke-width='.1907934'/%3E %3Cpath d='M564.26 427.57c.45.21 1.61.18 1.88.04M564.25 426.4c.43.19 1.47.18 1.89.04M564.3 425.18c.42.21 1.42.16 1.83.04M564.33 424.02a3.3 3.3 0 0 0 1.79.04M564.35 422.83c.5.14 1.38.14 1.76 0M564.37 421.6c.52.13 1.32.13 1.73.01M564.4 420.37c.47.12 1.37.12 1.7 0M564.42 419.15c.4.13 1.27.12 1.66 0M564.46 417.93c.52.12 1.24.13 1.61 0M564.48 416.69c.53.12 1.28.1 1.59 0M564.5 415.47a4.3 4.3 0 0 0 1.56 0M564.53 414.28c.49.09 1.3.04 1.52-.03M564.55 413.01c.48.13 1.28.07 1.49 0M564.59 411.82c.45.12 1.17.07 1.44-.03M564.62 410.57c.45.1 1.2.07 1.4 0M564.64 409.35c.45.09 1.18.05 1.37-.01M564.68 408.13a4.5 4.5 0 0 0 1.3-.01M564.71 406.88c.4.08 1.08.08 1.26.02M564.74 405.68c.44.07 1.05.07 1.23.01M564.7 404.57c.32.04 1.13.06 1.27.02M564.23 428.73c.47.21 1.64.18 1.92.04M564.21 429.84c.47.21 1.66.18 1.94.04' stroke-linejoin='round' stroke-width='.1907934'/%3E %3C/g%3E %3Cg stroke='%23e7e7e7'%3E %3Cpath d='M567.98 401.68c.75-.17 1.82-.19 3.3-.23a21.4 21.4 0 0 0-1.34-.4c.86-.12 2.92-.1 3.45-.1a7.7 7.7 0 0 0-1.48-.61c1.13-.2 2.48-.01 3.44.14-.45-.25-.95-.57-1.59-.74 1.36-.1 1.9.01 3.16.18a4.09 4.09 0 0 0-1.38-.75 12.6 12.6 0 0 1 3.84-.22c-4.27-1.96-9.47-.94-12.59 1.21.31-.49.99-1.23 1.65-1.8a3.94 3.94 0 0 0-1.08.07 6.44 6.44 0 0 1 1.9-1.4 4.58 4.58 0 0 0-1.17.04 10.4 10.4 0 0 1 2.17-1.47 4.86 4.86 0 0 0-1.31.03 8.08 8.08 0 0 1 2.49-1.8c-.59-.02-.95 0-1.47.1.75-.67 1.74-1.39 3.05-2.05-5.19.58-8.05 4.32-8.3 7.5-1.38-2.99-5.14-5.84-10.33-5.62 1.55.47 2.78 1.04 3.74 1.63-.58-.03-.96.01-1.58.11 1.06.3 2.3.86 3.08 1.47-.47-.01-.94.07-1.39.18.87.27 1.92.71 2.66 1.17-.42-.02-.8.05-1.24.14.67.15 1.75.7 2.36 1.14-.47 0-.81.04-1.16.12 1.56.6 1.66.88 2 1.09-3.23-.7-7.9.37-11.5 4.55.52-.44 2.75-1.27 3.45-1.46-.36.44-.5.67-.78 1.23.8-.66 2.03-1.2 3.2-1.66a7.5 7.5 0 0 0-.64 1.16c.85-.52 1.1-.6 2.84-1.42-.13.21-.47.67-.64 1.1.53-.3 1.8-.75 2.65-1.06.06-.02-.51.47-.77 1.06l1.42-.52c-2.74 1.91-4.78 5.12-4.36 9.02.16-.61.88-2.36 1.29-3.06-.05.46.06 1.23.14 1.58.4-1.17.85-2.1 1.51-3.1-.05.62-.04 1.3.05 1.59.37-.87.66-1.6 1.56-3.2-.06.24-.07.91-.02 1.5.3-.65 1-1.95 1.68-2.9-.03.35-.1.95-.07 1.2.07-.13.28-.49.53-.88.4-.61.87-1.33 1.02-1.44.12.12.23.26.34.43.42.69.73 1.73.82 2.81.23-.53.33-1.07.36-1.36a12.94 12.94 0 0 1 1.07 3.73c.16-.5.25-.81.3-1.59.51.81.95 2.81 1 3.68.2-.34.35-.76.47-1.4.5 1.12.7 2.51.81 3.47 1.27-4.62-.55-7.61-2.77-9.9.56.31 1.26.93 1.95 1.68a7.62 7.62 0 0 0-.4-1.36 22.6 22.6 0 0 1 2.36 2.13c-.05-.45-.12-.7-.36-1.28.97.67 1.83 1.82 2.33 2.46-.04-.3-.12-.84-.32-1.47a9.44 9.44 0 0 1 2.16 2.73c0-.5-.15-1.05-.27-1.6 1.2 1.01 1.65 2.09 2.03 2.74 0-4.18-4.82-7.93-9.32-8.32z' fill='%23007934' stroke-width='.1907934'/%3E %3Cpath d='M566.12 401.72c4.9-.7 11.19 3.52 11.18 8.28-.38-.65-.83-1.73-2.03-2.75.12.56.26 1.1.27 1.61a9.43 9.43 0 0 0-2.16-2.73c.2.63.28 1.18.32 1.47-.5-.64-1.36-1.79-2.33-2.46.24.58.3.83.36 1.28a22.53 22.53 0 0 0-2.37-2.13c.16.35.35 1.01.41 1.36a8.67 8.67 0 0 0-1.95-1.67M565.03 401.66c-2.93-1.89-9.16-1.55-13.67 3.7.52-.44 2.75-1.27 3.45-1.46-.36.44-.5.67-.78 1.23.8-.66 2.03-1.2 3.2-1.66-.25.37-.52.86-.64 1.16.84-.52 1.1-.6 2.84-1.42-.13.21-.47.67-.64 1.1.53-.3 1.8-.75 2.65-1.06.06-.02-.52.47-.77 1.06l1.42-.52' fill='none' stroke-linecap='round' stroke-linejoin='round' stroke-width='.1907934'/%3E %3Cpath d='M565.22 400.91c-.62-3.44-4.75-7.4-10.83-7.15 1.55.47 2.78 1.04 3.74 1.63-.58-.03-.96.01-1.58.11 1.06.3 2.3.86 3.08 1.47-.47-.01-.94.07-1.39.18.87.27 1.92.71 2.66 1.17-.42-.02-.8.05-1.24.14.67.15 1.75.7 2.36 1.14a4.3 4.3 0 0 0-1.16.12c1.56.6 1.66.88 2 1.09M565.18 402.28c-4.07 1.24-8.01 5.25-7.45 10.53.16-.61.88-2.36 1.29-3.06-.05.46.06 1.23.14 1.58.4-1.17.85-2.1 1.51-3.1-.05.62-.04 1.3.05 1.59.37-.87.66-1.6 1.56-3.2-.06.24-.07.91-.02 1.5.3-.65 1-1.95 1.68-2.9-.03.35-.1.95-.07 1.2.18-.33 1.3-2.13 1.55-2.32M562.89 404.35c-.29.8-.52 1.67-.61 2.27M561.4 405.37c-.28.72-.62 2.02-.73 2.85M559.9 406.8c-.4.91-.77 2.24-.88 2.95' fill='none' stroke-linecap='round' stroke-linejoin='round' stroke-width='.1907934'/%3E %3Cpath class='fil1 str2' fill='none' stroke-linecap='round' stroke-linejoin='round' d='M565.42 404.1l.02-.95' stroke-width='.1907934'/%3E %3Cpath d='M569.64 408.2c.13.75.19 1.14.14 2.2M568.1 405.63c.15.83.22 1.38.22 2.5M566.65 403.96c.18.52.29 1.18.29 2.02M574.36 405.37c.54.7.8 1.48.9 1.88M572.15 403.84a7.98 7.98 0 0 1 1.23 2.29M570.3 403.22c.46.6.77 1.23 1.07 1.92M554.81 403.9a7.29 7.29 0 0 1 2.7-1.87M557.22 403.47c.6-.77.92-1.25 2.5-1.94M559.43 403.2c.5-.63 1.3-1.36 2.52-1.79M561.44 403.25a8.02 8.02 0 0 1 2.5-1.53M558.13 395.39c1.04.11 2.5.48 3.38 1.06M559.63 396.97c.96.02 2.26.3 2.93.66M560.9 398.32a7 7 0 0 1 3.1.96M562.02 399.6a6 6 0 0 1 2.7.92M566.03 400.74c2.98-2.53 8.7-3.92 13.35-1.79a12.58 12.58 0 0 0-3.84.22c.62.17 1.2.6 1.38.75-1.26-.17-1.8-.28-3.16-.18.64.17 1.14.5 1.59.74-.96-.15-2.31-.33-3.44-.14.23.04 1.12.4 1.48.61-.53 0-2.59-.02-3.45.1.59.16.99.28 1.34.4-1.48.04-2.55.06-3.3.23M575.54 399.17a9.46 9.46 0 0 0-3.35-.5M573.76 399.74a9.06 9.06 0 0 0-3.95-.4M571.9 400.34c-1.42-.4-3.1-.42-3.88-.3M569.94 401.05a7.82 7.82 0 0 0-3.14-.17M568.1 402.55c.57.48.97 1.04 1.26 1.74' fill='none' stroke-linecap='round' stroke-linejoin='round' stroke-width='.1907934'/%3E %3Cpath d='M564.72 399.37c.25-3.17 3.11-6.9 8.3-7.49a13.6 13.6 0 0 0-3.05 2.05c.52-.1.88-.12 1.47-.1-.9.42-1.91 1.11-2.5 1.8.44-.08.89-.07 1.32-.03-.73.37-1.6.93-2.17 1.47.38-.08.74-.07 1.17-.05-.59.23-1.45.9-1.9 1.4.43-.07.74-.08 1.08-.05a9.56 9.56 0 0 0-1.65 1.8M569.97 393.93c-.75.21-1.72.61-2.41 1.11M568.95 395.63c-.71.12-1.6.45-2.19.8M568.09 397.07a5.7 5.7 0 0 0-2.3 1.08M567.36 398.43a5.02 5.02 0 0 0-2.26 1.23M564.4 403.4a9.41 9.41 0 0 0-.46 1.82M565.77 402.08c2.88 2.52 6.48 5.77 4.82 11.8-.12-.97-.31-2.36-.8-3.48a4.27 4.27 0 0 1-.49 1.4c-.04-.87-.48-2.87-.98-3.68a5.52 5.52 0 0 1-.31 1.59c-.04-.94-.59-2.64-1.07-3.73-.03.29-.13.83-.36 1.36-.11-1.35-.56-2.64-1.16-3.24' fill='none' stroke-linecap='round' stroke-linejoin='round' stroke-width='.1907934'/%3E %3C/g%3E %3C/g%3E %3Cg style='text-align:center;line-height:125%25;-inkscape-font-specification:Linux Biolinum Bold' font-size='100' font-weight='700' letter-spacing='60' word-spacing='0' text-anchor='middle' fill='%23e8a30e' stroke='%23000' stroke-width='1.5' font-family='Linux Biolinum'%3E %3Cpath d='M508.28 364.86l1.97 1.07.47-.88c.25-.45.32-.8.23-1.06-.1-.26-.36-.5-.8-.74-.46-.26-.84-.35-1.12-.29-.3.06-.53.26-.7.6-.25.44-.36.74-.36.9.01.16.11.3.3.4m2.58 1.4l2.53 1.37c.2.1.37.12.52.03a4.28 4.28 0 0 0 .94-1.64.93.93 0 0 0-.03-.64c-.08-.17-.17-.3-.28-.4-.11-.1-.29-.2-.52-.33-1.18-.64-2.05-.46-2.6.56l-.56 1.05m-4.06-1.21a47.42 47.42 0 0 0 .96-1.84c.26-.5.55-.9.86-1.2.3-.31.6-.5.88-.6.29-.09.54-.12.78-.11.23.01.46.08.66.19.3.16.52.43.67.81.16.38.23.77.2 1.17a3.5 3.5 0 0 1 1.45-.92 1.9 1.9 0 0 1 1.53.17c.55.3.9.82 1.05 1.57.15.73-.06 1.62-.62 2.65l-.62 1.1-.54.96-.48.97h-.04c-.56-.43-1.29-.88-2.18-1.37l-2.76-1.5a18.3 18.3 0 0 0-2.33-1.08l-.02-.04.55-.93M520.66 348.13c-1.12.94-.92 2.31.59 4.12a4.35 4.35 0 0 0 2.28 1.62 2.3 2.3 0 0 0 2.06-.52c.55-.47.79-1.03.7-1.69a4.87 4.87 0 0 0-1.23-2.3c-.85-1.02-1.62-1.62-2.31-1.8-.7-.2-1.4 0-2.09.57m5.83-.29a4.23 4.23 0 0 1 1.08 3.2 4.42 4.42 0 0 1-1.73 3 4.53 4.53 0 0 1-3.18 1.16 3.81 3.81 0 0 1-2.86-1.46 4.38 4.38 0 0 1-1.08-3.24c.09-1.19.63-2.2 1.62-3.02a4.54 4.54 0 0 1 3.25-1.2 4 4 0 0 1 2.9 1.56M539 343.77c.23.84.41 1.36.54 1.57a22.54 22.54 0 0 0 2.96-1.05l.5-.2.03.03a7.12 7.12 0 0 0 .34 1.23l-.01.04c-.2.03-.46.09-.75.17l-3.76 1.05-1 .32-.04-.03a20 20 0 0 0-.56-2.51l-.84-3.02c-.28-1-.56-1.82-.83-2.44l.02-.04c.38-.08.7-.16.98-.24l1.02-.32.02.04c.07.56.26 1.4.57 2.5l.8 2.9M553.44 339.3c.1-.98.15-1.84.13-2.57l.03-.03a17.57 17.57 0 0 0 2.1.23l.01.03c-.17.66-.32 1.51-.43 2.54l-.34 3.12c-.1.96-.15 1.82-.12 2.56l-.03.04a17.58 17.58 0 0 0-2.1-.23l-.01-.04c.17-.68.32-1.52.42-2.53l.34-3.12M568.83 347.48a56.06 56.06 0 0 0 4.92-4.19c.08.07.3.2.64.39.27.14.46.23.56.25a436.38 436.38 0 0 0-7.3 5.61l-.78-.42.33-3.22.37-3.67c.1-1.01.16-1.74.18-2.16.11.09.49.3 1.12.64.45.24.74.38.87.43a54.59 54.59 0 0 0-.9 6.34M582.06 353.49c.73-.67 1.33-1.28 1.8-1.84h.04a17.57 17.57 0 0 0 1.43 1.55l-.02.04c-.57.38-1.24.92-2 1.61l-2.32 2.11c-.72.66-1.32 1.27-1.8 1.85h-.04a17.58 17.58 0 0 0-1.42-1.56l.02-.03c.58-.4 1.24-.93 2-1.62l2.31-2.11M589.85 369.12a67.7 67.7 0 0 0 2.07-2.21l-.03-.08-3.04.1a29.95 29.95 0 0 0 1 2.2m-1.79-2.17c-1.33.07-2.33.17-3 .29a2.9 2.9 0 0 0-.22-.54 4.09 4.09 0 0 0-.33-.64c4.33-.03 7.4-.06 9.21-.12l.49 1.05c-3.14 3.3-5.19 5.54-6.14 6.73-.04-.14-.2-.5-.46-1.07-.23-.5-.39-.8-.47-.93a37.6 37.6 0 0 0 2.18-2.07 54.72 54.72 0 0 0-1.26-2.7' style='-inkscape-font-specification:Linux Biolinum Bold' stroke-width='.19231499999999999'/%3E %3C/g%3E %3Cg fill='%23e8a30e' stroke-width='1.79' stroke='%23000' stroke-linecap='square' stroke-linejoin='round'%3E %3Cpath d='M557.7 438.45l-1.2 3.45-3.66.08 2.91 2.2-1.06 3.5 3-2.09 3 2.09-1.06-3.5 2.91-2.2-3.65-.08zM571.97 432.37l-1.2 3.45-3.65.07 2.9 2.21-1.05 3.5 3-2.09 3 2.09-1.06-3.5 2.9-2.2-3.64-.08zM594.02 393.37l-1.2 3.45-3.66.07 2.91 2.21-1.05 3.5 3-2.09 3 2.09-1.06-3.5 2.9-2.2-3.65-.08zM583.55 421.2l1.2 3.44 3.65.08-2.91 2.2 1.06 3.5-3-2.09-3 2.1 1.06-3.5-2.91-2.21 3.65-.08zM590.94 408.47l1.2 3.45 3.65.08-2.9 2.2 1.05 3.5-3-2.09-3 2.1 1.06-3.5-2.9-2.21 3.64-.08zM542.3 438.45l1.2 3.45 3.66.08-2.91 2.2 1.06 3.5-3-2.09-3 2.09 1.06-3.5-2.91-2.2 3.65-.08zM528.03 432.37l1.2 3.45 3.65.07-2.9 2.21 1.05 3.5-3-2.09-3 2.09 1.06-3.5-2.9-2.2 3.64-.08zM505.98 393.37l1.2 3.45 3.66.07-2.91 2.21 1.05 3.5-3-2.09-3 2.09 1.06-3.5-2.9-2.2 3.65-.08zM516.45 421.2l-1.2 3.44-3.65.08 2.91 2.2-1.06 3.5 3-2.09 3 2.1-1.06-3.5 2.91-2.21-3.65-.08zM509.06 408.47l-1.2 3.45-3.65.08 2.9 2.2-1.05 3.5 3-2.09 3 2.1-1.06-3.5 2.9-2.21-3.64-.08z' stroke-width='.1921207'/%3E %3C/g%3E %3Cg stroke='%23000'%3E %3Cg fill='%23e7e7e7' stroke-width='.37'%3E %3Cpath d='M361.88 211.78l-.02-4.44h.54l-6.79-4.4h-5.46l-6.76 4.39h.54l.02 4.44 17.93.01' transform='matrix(.1902 0 0 .1695 482.85 351.75)'/%3E %3Cpath d='M361.88 211.78l-.02-4.44h.54l-6.79-4.4-.51-6.68h-4.43l-.52 6.68-6.76 4.39h.54l.02 4.44 17.93.01zM363.97 217.62V219l-21.88-.03-.01-1.38 21.89.02' transform='matrix(.1902 0 0 .1695 482.85 351.75)'/%3E %3Cpath d='M363.97 217.62V219l-21.88-.03-.01-1.38 21.89.02z' transform='matrix(.1902 0 0 .1695 482.85 351.75)'/%3E %3Cpath d='M343.54 217.53l-.02-4.7h.89l-.05 4.76.05-4.73-1.28-.03v-1.01l19.56.02.01 1h-1.2l.02 4.77-.04-4.77h.9l.01 4.71' transform='matrix(.1902 0 0 .1695 482.85 351.75)'/%3E %3Cpath d='M343.54 217.53l-.02-4.7h.89l-.05 4.76.05-4.73-1.28-.03v-1.01l19.56.02.01 1h-1.2l.02 4.77-.04-4.77h.9l.01 4.71' transform='matrix(.1902 0 0 .1695 482.85 351.75)'/%3E %3Cpath d='M347.74 216.37l-.01-3.28h-2.63l.02 3.28h2.62' transform='matrix(.1902 0 0 .1695 482.85 351.75)'/%3E %3Cpath d='M345.82 213.78v1.9h1.2v-1.9h-1.2M360.58 216.38l-.01-3.27h-2.62l.01 3.27h2.62' transform='matrix(.1902 0 0 .1695 482.85 351.75)'/%3E %3Cpath d='M358.66 213.79l.01 1.9h1.2l-.01-1.9h-1.2M360.56 211.04l-.01-3.28h-2.62v3.28h2.63z' transform='matrix(.1902 0 0 .1695 482.85 351.75)'/%3E %3Cpath d='M358.64 208.45v1.9h1.2v-1.9h-1.2M347.72 211.03l-.02-3.28h-2.62l.01 3.28h2.63z' transform='matrix(.1902 0 0 .1695 482.85 351.75)'/%3E %3Cpath d='M345.8 208.44v1.9h1.2v-1.9h-1.2M352.47 211.03v-3.27h-2.63v3.27h2.63' transform='matrix(.1902 0 0 .1695 482.85 351.75)'/%3E %3Cpath d='M350.55 208.44v1.9h1.2v-1.9h-1.2M356.14 211.04l-.02-3.28h-2.62l.01 3.27 2.63.01' transform='matrix(.1902 0 0 .1695 482.85 351.75)'/%3E %3Cpath d='M354.21 208.44l.01 1.9h1.2v-1.9h-1.2' transform='matrix(.1902 0 0 .1695 482.85 351.75)'/%3E %3Cpath d='M356.79 210.03l.03 7.57-7.6-.01-.03-7.56h7.6' transform='matrix(.1902 0 0 .1695 482.85 351.75)'/%3E %3Cpath d='M356.79 210.03l.03 7.57-7.6-.01-.03-7.56h7.6zM349.14 212.2h7.65M350.1 217.6l-.03-5.35M355.9 217.6l-.03-5.34M359.56 206.81l-4.28-3.12-4.8-.01-4.25 3.12 13.33.01M350.85 203h4.05M351.94 201.56v.95h1.86v-.95h-1.86' transform='matrix(.1902 0 0 .1695 482.85 351.75)'/%3E %3Cpath d='M349.54 210.25h.56l-.16.3s.26.34 0 .73l.15.27h-.54l.15-.26s-.28-.45 0-.75l-.16-.3M350.67 210.25h.56l-.16.3s.26.33 0 .73l.14.27h-.53l.14-.26s-.26-.45.02-.75l-.17-.3M351.9 210.25h.56l-.17.3s.27.34 0 .73l.15.28h-.53l.14-.27s-.27-.45.01-.75l-.16-.3zM353.3 210.25h.55l-.16.3s.26.34 0 .73l.15.28h-.54l.14-.26s-.26-.46.02-.75l-.16-.3zM354.53 210.25h.55l-.16.3s.27.34 0 .73l.15.28h-.54l.14-.26s-.27-.46.02-.75l-.16-.3M355.76 210.25h.55l-.16.3s.27.34 0 .73l.14.28h-.53l.14-.26s-.27-.46.02-.75l-.16-.3' transform='matrix(.1902 0 0 .1695 482.85 351.75)'/%3E %3C/g%3E %3Cpath d='M549.75 384.42h.5v.58h-.5v-.58z' fill='%23e7e7e7' fill-rule='evenodd' stroke-width='.050000600000000006'/%3E %3Cpath d='M550 383.7v.75' fill='none' stroke-width='.115386'/%3E %3Cpath d='M549.73 383.98h.54' fill='none' stroke-width='.1461556'/%3E %3C/g%3E %3C/g%3E %3Cg%3E %3Cpath d='M545.53 328.6s-3.66 8.5-2.4 9.34c0 0 4.6-5.13 5.8-9.2 1.19-4.07 0-.28 0-.28l-.34-4.42-3 4.2' fill='%23452c25'/%3E %3Cpath d='M586.6 219.12s-8.42 19.15-5.5 21.05c0 0 10.56-11.55 13.32-20.74 2.76-9.18 0-.63 0-.63l-.77-9.97-6.89 9.5' transform='matrix(.43415 0 0 .44354 290.86 231.41)' fill='none' stroke='%23000' stroke-width='.58'/%3E %3Cpath d='M546.3 324.54s-4.4 9.36-3.39 10.05c0 0 3.65-4.2 4.6-7.55.96-3.34 0-.23 0-.23l1.23-6.02' fill='%23452c25'/%3E %3Cpath d='M588.39 209.96s-10.13 21.1-7.81 22.66c0 0 8.41-9.49 10.6-17.02 2.2-7.54 0-.52 0-.52l2.82-13.56' transform='matrix(.43415 0 0 .44354 290.86 231.41)' fill='none' stroke='%23000' stroke-width='.47'/%3E %3Cpath d='M550.83 322.46s-4.4 9.35-3.39 10.04c0 0 3.65-4.2 4.6-7.55.96-3.34 0-.23 0-.23l1.23-6.01' fill='%23452c25'/%3E %3Cpath d='M598.82 205.26s-10.13 21.1-7.81 22.66c0 0 8.41-9.49 10.6-17.02 2.2-7.54 0-.52 0-.52l2.82-13.56' transform='matrix(.43415 0 0 .44354 290.86 231.41)' fill='none' stroke='%23000' stroke-width='.47'/%3E %3Cpath d='M607.56 305.63l5.22 2.97s1.27 1.05-1.52.43c-2.8-.62-8.76-2.68-20.02-9.92-5.09-3.28-6.7-3.19-6.7-3.19l7.1.2 15.92 9.51z' fill='%23452c25'/%3E %3Cpath d='M607.56 305.63l5.22 2.97s1.27 1.05-1.52.43c-2.8-.62-8.76-2.68-20.02-9.92-5.09-3.28-6.7-3.19-6.7-3.19l7.1.2 15.92 9.51z' fill='none' stroke='%23000' stroke-width='.1875456'/%3E %3Cpath d='M609.28 304.35l5.22 2.96s1.28 1.05-1.52.43c-2.8-.62-8.75-2.68-20.01-9.92-5.1-3.28-1 2.7-1 2.7l.87-3.93 16.44 7.76z' fill='%23452c25'/%3E %3Cpath d='M609.28 304.35l5.22 2.96s1.28 1.05-1.52.43c-2.8-.62-8.75-2.68-20.01-9.92-5.1-3.28-1 2.7-1 2.7l.87-3.93 16.44 7.76z' fill='none' stroke='%23000' stroke-width='.1875456'/%3E %3Cpath d='M617.96 307.2s-6.23-1.16-8.5-2.82c0 0 .4.72-2.64-.67 0 0 1.17 2.67-7.4-3.18-8.59-5.84-5.59-2.9-5.59-2.9l2.4-.62s13.17 5.26 14.62 5.81c1.44.55 7.11 4.38 7.11 4.38' fill='%23452c25'/%3E %3Cpath d='M617.96 307.2s-6.23-1.16-8.5-2.82c0 0 .4.72-2.64-.67 0 0 1.17 2.67-7.4-3.18-8.59-5.84-5.59-2.9-5.59-2.9l2.4-.62s13.17 5.26 14.62 5.81c1.44.55 7.11 4.38 7.11 4.38z' fill='none' stroke='%23000' stroke-width='.18315'/%3E %3Cpath d='M585.38 309.53l2.09 2.98s-.7 2.8-7.94-2.64c-7.25-5.43-6.87-4.98-6.87-4.98l4-.56 8.8 4.99' fill='%23452c25'/%3E %3Cpath d='M585.38 309.53l2.09 2.98s-.7 2.8-7.94-2.64c-7.25-5.43-6.87-4.98-6.87-4.98l4-.56 8.8 4.99' fill='none' stroke='%23000' stroke-width='.2080584'/%3E %3Cpath d='M575.97 311.03s3.37 4.4 2.62 4.95c-.75.54-4.73.3-7.57-4-2.84-4.31-.06-.22-.06-.22l.27-6.97 4.81 6.02' fill='%23452c25'/%3E %3Cpath d='M575.97 311.03s3.37 4.4 2.62 4.95c-.75.54-4.73.3-7.57-4-2.84-4.31-.06-.22-.06-.22l.27-6.97 4.81 6.02' fill='none' stroke='%23000' stroke-width='.2080584'/%3E %3Cpath d='M579.43 309s3.24 4.18 2.88 4.82c-.35.63-4.92.23-8.56-3.9-3.64-4.12-.54-5.44-.54-5.44l6.16 4.3' fill='%23452c25'/%3E %3Cpath d='M579.4 308.89s3.27 4.29 2.91 4.93c-.35.63-4.92.23-8.56-3.9-3.64-4.12-.54-5.44-.54-5.44l6.19 4.4z' fill='none' stroke='%23000' stroke-width='.2080584'/%3E %3Cpath d='M597.9 306.53s9.23 3.97 2.38 3.71c0 0-13.42-3.61-20.36-9.56l1.96-2.6 15.9 8.22' fill='%23452c25'/%3E %3Cpath d='M597.9 306.53s9.23 3.97 2.38 3.71c0 0-13.42-3.61-20.36-9.56l1.96-2.6 15.9 8.22' fill='none' stroke='%23000' stroke-width='.2080584'/%3E %3Cpath d='M602.74 305.38s5 3.04 5.37 4.19c.37 1.15-15.53-2.97-23.93-9.96l3.75-1.83 14.8 7.6z' fill='%23452c25'/%3E %3Cpath d='M602.74 305.38s5 3.04 5.37 4.19c.37 1.15-15.53-2.97-23.93-9.96l3.75-1.83 14.8 7.6z' fill='none' stroke='%23000' stroke-width='.2080584'/%3E %3Cpath d='M588.22 308.13s3.61 2.97 3.2 3.31c-.4.35-7.74-.75-13.5-5.18l.7-2.65 9.67 4.38' fill='%23452c25'/%3E %3Cpath d='M588.22 308.13s3.61 2.97 3.2 3.31c-.4.35-7.74-.75-13.5-5.18l.7-2.65 9.67 4.38' fill='none' stroke='%23000' stroke-width='.2080584'/%3E %3Cpath d='M594.4 307.88s3.57 2.46 2.83 2.72c-.74.26-3.54 2.46-16.81-5.32l-1.57-.86 2.11-3.31 13.45 6.55' fill='%23452c25'/%3E %3Cpath d='M594.4 307.77s3.57 2.57 2.83 2.83c-.74.26-3.54 2.46-16.81-5.32l-1.57-.86 2.11-3.31 13.45 6.66z' fill='none' stroke='%23000' stroke-width='.2080584'/%3E %3Cpath d='M580.78 300.6s4.31 3.86 3.76 4.42c-.55.55-5.68-.67-7.95-2.36-2.26-1.68-3.91-3.84-3.91-3.84l4.81-1.03 3.29 2.8z' fill='%23452c25'/%3E %3Cpath d='M580.78 300.6s4.31 3.86 3.76 4.42c-.55.55-5.68-.67-7.95-2.36-2.26-1.68-3.91-3.84-3.91-3.84l4.81-1.03 3.29 2.8z' fill='none' stroke='%23000' stroke-width='.2080584'/%3E %3Cpath d='M575.63 294.14l7.87 4.69s6.41 4.53 5.73 4.93c-.67.4-5.73-1.17-9.32-3.13-3.58-1.95-7.74-6.16-7.74-6.16' fill='%23452c25'/%3E %3Cpath d='M575.63 294.14l7.87 4.69s6.41 4.53 5.73 4.93c-.67.4-5.73-1.17-9.32-3.13-3.58-1.95-7.74-6.16-7.74-6.16' fill='none' stroke='%23000' stroke-width='.2080584'/%3E %3Cpath d='M570.67 316.3s1.47 3.75.6 4.07c-.88.33-3.05-.34-4.8-3.73-1.73-3.4 1.53-1.97 1.53-1.97l2.67 1.63z' fill='%23452c25'/%3E %3Cpath d='M570.67 316.3s1.47 3.75.6 4.07c-.88.33-3.05-.34-4.8-3.73-1.73-3.4 1.19-1.9 1.19-1.9l3.01 1.56z' fill='none' stroke='%23000' stroke-width='.2080584'/%3E %3Cpath d='M573.28 313.88s2.2 3.63 1.72 4.05c-.48.41-3.38 1.66-6.54-3.02-3.15-4.68 3.25-3.7 3.25-3.7l1.57 2.67z' fill='%23452c25'/%3E %3Cpath d='M573.28 313.88s2.2 3.63 1.72 4.05c-.48.41-3.38 1.66-6.54-3.02-3.15-4.68 3.25-3.7 3.25-3.7l1.57 2.67z' fill='none' stroke='%23000' stroke-width='.2080584'/%3E %3Cpath d='M566.71 297.49s7.5 14.47 6.88 15.24c-.63.77-3.59 0-5.25-3.83-1.66-3.82-3.02-8.8-3.02-8.8l1.4-2.61z' fill='%23452c25'/%3E %3Cpath d='M566.71 297.49s7.5 14.47 6.88 15.24c-.63.77-3.59 0-5.25-3.83-1.66-3.82-3.02-8.8-3.02-8.8l1.4-2.61z' fill='none' stroke='%23000' stroke-width='.2080584'/%3E %3Cpath d='M575.45 301.17s6.25 5.32 4.97 5.99c-1.29.67-3.77-.3-7.43-3.92-3.66-3.62 2.4-2.29 2.4-2.29' fill='%23452c25'/%3E %3Cpath d='M575.42 301.06s6.28 5.43 5 6.1c-1.29.67-3.77-.3-7.43-3.92-3.66-3.62 2.43-2.18 2.43-2.18z' fill='none' stroke='%23000' stroke-width='.2080584'/%3E %3Cpath d='M572.41 301.26s4.48 8.21 3.92 8.98c-.56.78-3.91-2.04-5.57-4.13a25.29 25.29 0 0 1-2.9-5.13' fill='%23452c25'/%3E %3Cpath d='M572.41 301.26s4.48 8.21 3.92 8.98c-.56.78-3.91-2.04-5.57-4.13a25.29 25.29 0 0 1-2.9-5.13' fill='none' stroke='%23000' stroke-width='.2080584'/%3E %3Cpath d='M538.9 318.12s-.26 4.84 0 5.2c.27.37 2.73.37 2.86-3.25.13-3.6-.53-3.75-.53-3.75l-2.4 1.66' fill='%23452c25'/%3E %3Cpath d='M538.9 318.12s-.26 4.84 0 5.2c.27.37 2.73.37 2.86-3.25.13-3.6-.53-3.75-.53-3.75l-2.4 1.66' fill='none' stroke='%23000' stroke-width='.2080584'/%3E %3Cpath d='M540.37 312.29s-1.72 5.42-.06 6.5c1.66 1.09 2.98-5.34 3.05-6.79.07-1.44-2.99.29-2.99.29' fill='%23452c25'/%3E %3Cpath d='M540.37 312.29s-1.72 5.42-.06 6.5c1.66 1.09 2.98-5.34 3.05-6.79.07-1.44-2.99.29-2.99.29z' fill='none' stroke='%23000' stroke-width='.2080584'/%3E %3Cpath d='M541.56 319.2s.33 5.06 1.26 5.28c.93.22 2.45-1.44 2.45-2.74 0-1.3-1.59-4.34-1.59-4.34l-2.19 1.6' fill='%23452c25'/%3E %3Cpath d='M541.56 319.2s.33 5.06 1.26 5.28c.93.22 2.45-1.44 2.45-2.74 0-1.3-1.59-4.34-1.59-4.34l-2.19 1.6' fill='none' stroke='%23000' stroke-width='.2080584'/%3E %3Cpath d='M541.6 313.15s-1.72 5.42-.06 6.5c1.66 1.09 2.98-5.34 3.05-6.79.07-1.44-2.99.3-2.99.3z' fill='%23452c25' stroke='%23000' stroke-width='.2080584'/%3E %3Cpath d='M541.74 304.46s-2.52 2.6-2.46 4.04c.07 1.45 3.72-1.95 4.05-2.6.33-.65-1.6-1.44-1.6-1.44' fill='%23452c25'/%3E %3Cpath d='M541.74 304.46s-2.52 2.6-2.46 4.04c.07 1.45 3.72-1.95 4.05-2.6.33-.65-1.6-1.44-1.6-1.44z' fill='none' stroke='%23000' stroke-width='.2080584'/%3E %3Cpath d='M540 303s-1.99 3.68-1.46 4.84c.54 1.15 2.46-.87 3.39-2.17.93-1.3-1.93-2.67-1.93-2.67' fill='%23452c25'/%3E %3Cpath d='M540 303s-1.99 3.68-1.46 4.84c.54 1.15 2.46-.87 3.39-2.17.93-1.3-1.93-2.67-1.93-2.67z' fill='none' stroke='%23000' stroke-width='.2080584'/%3E %3Cpath d='M567.98 298.12s3.18 5.98 2.3 6.31c-.87.33-2.2-1.18-3.54-2.97-1.33-1.79 1.24-3.34 1.24-3.34' fill='%23452c25'/%3E %3Cpath d='M567.98 298.12s3.18 5.98 2.3 6.31c-.87.33-2.2-1.18-3.54-2.97-1.33-1.79 1.24-3.34 1.24-3.34z' fill='none' stroke='%23000' stroke-width='.2080584'/%3E %3Cpath d='M568.06 310.36s1.15 5.04.14 5.5c-1.98.91-3.09-3.58-3.2-5.26-.14-1.89 3.06-.24 3.06-.24zM564.1 318.35s.26 3.77-.28 4.1c-.54.34-1.87.43-3.36-2.74-1.48-3.17-.79-1.98-.79-1.98l3.65-1.8.79 2.05' fill='%23452c25' stroke='%23000' stroke-width='.2080584'/%3E %3Cpath d='M567.74 317.48s.43 4-.37 4.1c-.8.12-2.93-1.23-3.86-3.62-1.07-2.76 3.72-1.94 3.72-1.94l.51 1.46z' fill='%23452c25' stroke='%23000' stroke-width='.2080584'/%3E %3Cpath d='M563.99 305.24s4.1 9.17 3.44 10.47c-1.3 2.56-5.02-5.58-6.14-8.76-1.26-3.56 2.7-1.71 2.7-1.71z' fill='%23452c25' stroke='%23000' stroke-width='.2080584'/%3E %3Cpath d='M562.09 306.77s5.59 10.1 3.23 10.33c-2.36.23-6.64-7.32-7.36-9.08-.72-1.76 4.13-1.25 4.13-1.25z' fill='%23452c25' stroke='%23000' stroke-width='.2080584'/%3E %3Cpath d='M561.75 308.86s2.75 9.68.98 8.82c-1.77-.85-3.9-8.14-4.2-9.71-.28-1.58 3.22.9 3.22.9zM571.41 295.1s4.24 6.48 2.87 6.67c-1.38.2-6.4-4.32-6.45-5.07-.04-.75 3.58-1.6 3.58-1.6z' fill='%23452c25' stroke='%23000' stroke-width='.2080584'/%3E %3Cpath d='M568.76 295.38s5.4 7.38 3.78 7.75c-1.63.37-1.75-.78-1.75-.78s-4.32-3.89-4.6-4.87c-.3-.98 2.42-2.2 2.42-2.2M574.12 295.5s3.72 3.83 2.74 5.12c-.97 1.3-6.14-4.85-6.84-5.63-.7-.78 4.5.35 4.5.35M565.1 300.82s6 11.66 4.9 12.84c-1.11 1.19-7.76-8.74-8-10.18-.23-1.44 3.17-2.88 3.17-2.88' fill='%23452c25' stroke='%23000' stroke-width='.2080584'/%3E %3Cpath d='M561.67 301.87s2.39 3.65 2.25 5.62c-.13 1.96-3.61-2.82-3.91-3.71-.3-.9 1.66-1.9 1.66-1.9z' fill='%23452c25' stroke='%23000' stroke-width='.241758'/%3E %3Cpath d='M566.59 299.98s1.86 3.77 1.29 4.9c-.57 1.13-3.1-2.28-3.99-3.62-.88-1.34 2.7-1.28 2.7-1.28z' fill='%23452c25' stroke='%23000' stroke-width='.2080584'/%3E %3Cpath d='M557.95 303.68s2.93 3.25 2.78 4.97c-.14 1.73-4.38-2.52-4.75-3.31-.37-.8 1.97-1.66 1.97-1.66z' fill='%23452c25' stroke='%23000' stroke-width='.249084'/%3E %3Cpath d='M576.84 294.33s4.42 3.97 3.73 4.6c-.68.62-6.67-3.67-7.57-4.5-.9-.83 3.84-.1 3.84-.1z' fill='%23452c25' stroke='%23000' stroke-width='.2080584'/%3E %3Cpath d='M573.1 294.05l3.46 2.91s3.2 2.15 2.66 2.7c-.55.56-5.58-1.74-6.48-2.8-.9-1.04-.79-2.12-.79-2.12l1.15-.7zM584.5 294.96s13.09 5.31 12.58 6.6c-.51 1.28-13.73-4.26-15.8-5.72-2.08-1.45 3.02-.96 3.02-.96' fill='%23452c25' stroke='%23000' stroke-width='.2080584'/%3E %3Cpath d='M584.97 296.65s9.83 5.53 8.68 6.06c-1.14.54-8.18-1.34-11.82-3.8-3.63-2.47-5.18-3.83-5.18-3.83l4.49-1.05 3.83 2.62zM560.76 303.38s1.86 3.76 1.29 4.9c-.57 1.13-2.42-.97-3.3-2.31-.9-1.34 2-2.6 2-2.6zM561.2 311.86s1.54 5.49-.16 6.5c-1.7 1.02-2.8-5.46-2.81-6.9-.02-1.45 2.97.4 2.97.4z' fill='%23452c25' stroke='%23000' stroke-width='.2080584'/%3E %3Cpath d='M553.59 302.83s5.47-2.4 6.43-2.21c0 0 1.15-.29 1.77-.77.62-.48 2.03-1.63 2.03-1.63s-.97-6.63 6-5.95c6.96.67 16.13 1.53 17.98 1.82 1.85.29 8.64 2.2 10.23 2.98a367 367 0 0 0 14.05 6.21c1.25.46 4.02 2.19 6.06 3.52 1.41.92-.04.26-.04.26s-16.75-8.89-22.67-10.08c-1.48-.3.1 1.7.1 1.7s-3.85-1.52-5.44-2.19a9.26 9.26 0 0 0-4.4-.86c-1.5.1-2.65-.2-3.53-.48-.88-.3-5.91-.48-6.8-.58-.87-.1-1.58-.29-1.58-.29l.35.58-2.46-.39-.71 1.06s-2.38.48-2.56-.29c-.17-.77-1.4 3.46-2.03 4.7-.61 1.26-2.9 1.25-3.61 2.02a8 8 0 0 1-1.5 1.44c-.35.2-2.12 1.25-2.73 1.25-.62 0-4.41.29-4.41.29l-.97-1.54.44-.57zM560.78 318.35s.1 4.85-.18 5.2c-.28.35-2.73.25-2.74-3.36-.01-3.62.66-3.74.66-3.74l2.33 1.76' fill='%23452c25' stroke='%23000' stroke-width='.2080584'/%3E %3Cpath d='M561.37 314.63s-.47-2.1-.8-2.38c-.33-.3.13-.58.13-.58s-.86-2.1-1.4-2.46c-.52-.37.07-.65.07-.65s-.92-1.45-1.59-1.89c-.66-.43 0-.5 0-.5s-.7-1.95-2.3-2.84c0 0-1.08-1.13-2.17-1.44-1.1-.3-3.8-.6-7.09-.53-3.45.06-4.91 2.45-4.91 2.45l-.22 2.78.5-.34-.74 3.46c-.11.79.62 2.16.66 3.81.02.53.05 1.07.1 1.63.16 1.49.51 3.06 1.19 4.51.05.12.1.45.16.34.17-.29.55.98.89 1.44 0 0 .2 1.72.37 1.08.06-.24.62.98.96 1.75.12.28.77 2.18.75 1.31-.03-.94.57 2.02.57 2.44l.8-1.15.4 1.3.66-.07-.2 1.23s1.86-1.52 1.93-2.1c.06-.58.13-1.02.13-1.02l.6-.57.93-1.45s2.32 1.8 2.58 2.46l.53 1.23.6-.58.53 1.3.33-.65.33.9.02-.05.22.6c.16.15.53.22 1.22-.94 1-1.67.93-2.97 1-3.26.07-.29.46.5.46.5s.87-1.58.73-2.6c-.13-1.01.54-.65.54-.65s.13-2.68 0-3.33c-.14-.65.46-.5.46-.5s-.2-3.19-.4-3.55c-.2-.36.47-.44.47-.44z' fill='%23452c25' stroke='%23000' stroke-width='.2080584'/%3E %3Cpath d='M556.72 307.27c.46.14.7.66.9 1.07-.02-.02.02-.14 0-.19-.2-.41-.43-.94-.9-1.09 0 0-.04.2 0 .2M557.14 309.27c.86.73.94 1.73.9 2.82v.1c.06-1.15.05-2.32-.9-3.12.02.01-.04.16 0 .2M558.94 310.3a4.71 4.71 0 0 1 .54 2.54c0-.96-.03-1.9-.54-2.74.01.02-.03.15 0 .2M559.57 314.07a17.3 17.3 0 0 1-.26 1.66v.18c.12-.56.22-1.13.27-1.7 0-.02 0-.22-.01-.14M558.99 316.97c.04.37.09.73.05 1.1a6.04 6.04 0 0 0-.04-1.24c-.01-.08-.02.12-.01.14M560.05 316.84c.26.27.41.59.47.96 0 .04.02-.03.02-.04v-.13a1.82 1.82 0 0 0-.49-1c.02.03-.04.17 0 .21M559.9 312.78c.26.22.47.49.68.76-.02-.03.04-.15 0-.2a4.85 4.85 0 0 0-.69-.76c.02.02-.04.17 0 .2M557.71 315.82c0 .55-.05 1.1-.15 1.64v.18a10.16 10.16 0 0 0 .15-1.82M556.55 317.03c.05.5.05.98 0 1.48a9.74 9.74 0 0 0 .01-1.62l-.01.14'/%3E %3Cpath d='M535.53 303.64s-1.33 4.98-.33 5.49c1.95.99 3.2-3.45 3.38-5.13.2-1.88-3.05-.36-3.05-.36' fill='%23452c25'/%3E %3Cpath d='M535.53 303.64s-1.33 4.98-.33 5.49c1.95.99 3.2-3.45 3.38-5.13.2-1.88-3.05-.36-3.05-.36z' fill='none' stroke='%23000' stroke-width='.2080584'/%3E %3Cpath d='M538.4 303.6s-2.52 2.6-2.45 4.04c.06 1.45 3.71-1.95 4.04-2.6.34-.65-1.59-1.44-1.59-1.44' fill='%23452c25'/%3E %3Cpath d='M538.4 303.6s-2.52 2.6-2.45 4.04c.06 1.45 3.71-1.95 4.04-2.6.34-.65-1.59-1.44-1.59-1.44z' fill='none' stroke='%23000' stroke-width='.2080584'/%3E %3Cpath d='M495.4 303.96s-5.2 2.62-5.67 3.73c-.45 1.12 15.72-1.69 24.6-7.97l-3.6-2.13-15.33 6.37z' fill='%23452c25'/%3E %3Cpath d='M495.4 303.96s-5.2 2.62-5.67 3.73c-.45 1.12 15.72-1.69 24.6-7.97l-3.6-2.13-15.33 6.37z' fill='none' stroke='%23000' stroke-width='.2080584'/%3E %3Cpath d='M501.49 305.01s-9.43 3.43-2.57 3.57c0 0 13.58-2.83 20.82-8.36l-1.83-2.7-16.3 7.27' fill='%23452c25'/%3E %3Cpath d='M501.55 304.9s-9.49 3.54-2.63 3.68c0 0 13.58-2.83 20.82-8.36l-1.83-2.7-16.36 7.38z' fill='none' stroke='%23000' stroke-width='.2080584'/%3E %3Cpath d='M515.48 295.44s-10.01 5.13-8.89 5.7c1.13.58 8.23-1 11.95-3.32 3.71-2.3 5.3-3.61 5.3-3.61l-4.44-1.23-3.92 2.46z' fill='%23452c25'/%3E %3Cpath d='M515.48 295.44s-10.01 5.13-8.89 5.7c1.13.58 8.23-1 11.95-3.32 3.71-2.3 5.3-3.61 5.3-3.61l-4.44-1.23-3.92 2.46z' fill='none' stroke='%23000' stroke-width='.2080584'/%3E %3Cpath d='M511.7 306.69s-3.58 3-3.16 3.34c.41.34 7.73-.82 13.43-5.29l-.72-2.64-9.62 4.45' fill='%23452c25'/%3E %3Cpath d='M511.7 306.69s-3.58 3-3.16 3.34c.41.34 7.73-.82 13.43-5.29l-.72-2.64-9.62 4.45' fill='none' stroke='%23000' stroke-width='.2080584'/%3E %3Cpath d='M505.47 306.22s-3.44 2.63-2.69 2.85c.76.23 3.66 2.29 16.53-6.1l1.52-.94-2.27-3.2-13.1 7.18' fill='%23452c25'/%3E %3Cpath d='M505.46 306.12s-3.43 2.73-2.68 2.95c.76.23 3.66 2.29 16.53-6.1l1.52-.94-2.27-3.2-13.1 7.29z' fill='none' stroke='%23000' stroke-width='.2080584'/%3E %3Cpath d='M502.82 296.24c-10.83 3.78-21.68 11.33-21.68 11.33 1.06-.36 27.85-11.15 27.85-11.15M526.56 313.14s-2.32 3.54-1.85 3.97c.46.44 3.31 1.8 6.63-2.74 3.32-4.55-3.12-3.83-3.12-3.83l-1.66 2.6z' fill='%23452c25'/%3E %3Cpath d='M526.56 313.14s-2.32 3.54-1.85 3.97c.46.44 3.31 1.8 6.63-2.74 3.32-4.55-3.12-3.83-3.12-3.83l-1.66 2.6z' fill='none' stroke='%23000' stroke-width='.2080584'/%3E %3Cpath d='M529.09 315.67s-1.6 3.68-.73 4.04c.86.36 3.05-.21 4.9-3.54 1.86-3.32-.86-1.66-.86-1.66l-3.31 1.16zM523.98 310.18s-3.52 4.26-2.79 4.84c.73.57 4.71.5 7.7-3.69 2.98-4.19.06-.21.06-.21l-.86-3.83-4.18 2.67' fill='%23452c25'/%3E %3Cpath d='M529.09 315.67s-1.6 3.68-.73 4.04c.86.36 3.05-.21 4.9-3.54 1.86-3.32-.86-1.66-.86-1.66l-3.31 1.16zM523.98 310.18s-3.52 4.26-2.79 4.84c.73.57 4.71.5 7.7-3.69 2.98-4.19.06-.21.06-.21l-.86-3.83-4.18 2.67' fill='none' stroke='%23000' stroke-width='.2080584'/%3E %3Cpath d='M520.6 308s-3.39 4.05-3.06 4.7c.33.66 4.91.44 8.7-3.54 3.78-3.97.72-5.41.72-5.41l-6.3 4.04' fill='%23452c25'/%3E %3Cpath d='M520.6 308s-3.39 4.05-3.06 4.7c.33.66 4.91.44 8.7-3.54 3.78-3.97.72-5.41.72-5.41l-6.3 4.04' fill='none' stroke='%23000' stroke-width='.2080584'/%3E %3Cpath d='M514.62 308.3l-2.19 2.89s.6 2.82 8.03-2.31 7.03-4.7 7.03-4.7l-3.98-.72-8.95 4.62' fill='%23452c25'/%3E %3Cpath d='M514.59 308.19l-2.16 3s.6 2.82 8.03-2.31 7.03-4.7 7.03-4.7l-3.98-.72-8.92 4.73z' fill='none' stroke='%23000' stroke-width='.2080584'/%3E %3Cpath d='M490.92 303.87l-4.7 2.12s-1.07.93 1.7 1c2.76.07 8.47-.7 18.42-6.33a51.59 51.59 0 0 0 7.34-4.98l-3.62-1.35-19.14 9.54z' fill='%23452c25'/%3E %3Cpath d='M490.92 303.87l-4.7 2.12s-1.07.93 1.7 1c2.76.07 8.47-.7 18.42-6.33a51.59 51.59 0 0 0 7.34-4.98l-3.62-1.35-19.14 9.54z' fill='none' stroke='%23000' stroke-width='.2080584'/%3E %3Cpath d='M482.85 306.84s6.78-.73 9.47-2.5c0 0-.55.82 2.92-.53 0 0-1.73 3.1 8.38-3.05 10.1-6.15.08-.12.08-.12l11.22-6.43-.65-1.28s-21.44 9.18-23.07 9.7c-1.62.5-8.35 4.21-8.35 4.21' fill='%23452c25'/%3E %3Cpath d='M503.66 300.7l11.26-6.49-.65-1.28s-21.44 9.18-23.07 9.7c-1.62.5-8.35 4.21-8.35 4.21s6.78-.73 9.47-2.5c0 0-.55.82 2.92-.53 0 0-1.69 3.04 8.42-3.1z' fill='none' stroke='%23000' stroke-width='.2080584'/%3E %3Cpath d='M532.07 315.51s-.66 5.37.13 5.57c.8.2 3.06-1.5 3.99-4.77.92-3.29-3.65-2.89-3.65-2.89l-.67 1.9' fill='%23452c25'/%3E %3Cpath d='M532.07 315.51s-.66 5.37.13 5.57c.8.2 3.06-1.5 3.99-4.77.92-3.29-3.65-2.89-3.65-2.89l-.67 1.9' fill='none' stroke='%23000' stroke-width='.2432232'/%3E %3Cpath d='M535.59 317.98s-.4 3.76.13 4.12c.53.36 1.86.5 3.45-2.6 1.6-3.11.86-1.95.86-1.95l-3.58-1.96-.86 2.03' fill='%23452c25'/%3E %3Cpath d='M535.59 317.8s-.4 3.94.13 4.3c.53.36 1.86.5 3.45-2.6 1.6-3.11.86-1.95.86-1.95l-3.58-1.96-.86 2.2z' fill='none' stroke='%23000' stroke-width='.2080584'/%3E %3Cpath d='M536.58 310.97s-2.92 6.36-1.26 6.29c1.66-.08 3.92-4.84 4.25-5.93.33-1.08-2.99-.36-2.99-.36' fill='%23452c25'/%3E %3Cpath d='M536.58 310.97s-2.92 6.36-1.26 6.29c1.66-.08 3.92-4.84 4.25-5.93.33-1.08-2.99-.36-2.99-.36z' fill='none' stroke='%23000' stroke-width='.2080584'/%3E %3Cpath d='M536.33 310.92s-1.1 7 .47 6.4c1.57-.59 2.45-5.86 2.48-7 .03-1.15-2.95.6-2.95.6' fill='%23452c25'/%3E %3Cpath d='M536.33 310.92s-1.1 7 .47 6.4c1.57-.59 2.45-5.86 2.48-7 .03-1.15-2.95.6-2.95.6z' fill='none' stroke='%23000' stroke-width='.2080584'/%3E %3Cpath d='M538.7 311.62s-1.72 5.42-.06 6.5c1.66 1.09 2.99-5.34 3.05-6.79.07-1.44-2.98.3-2.98.3' fill='%23452c25'/%3E %3Cpath d='M538.7 311.62s-1.72 5.42-.06 6.5c1.66 1.09 2.99-5.34 3.05-6.79.07-1.44-2.98.3-2.98.3z' fill='none' stroke='%23000' stroke-width='.2080584'/%3E %3Cpath d='M531.9 309.84s-1.65 4.98-.66 5.49c1.95.99 3.54-3.45 3.72-5.13.2-1.88-3.05-.36-3.05-.36zM519.53 299.56s-4.44 3.68-3.91 4.26c.53.58 5.7-.43 8.03-2.02 2.32-1.6 3.25-2.46 3.25-2.46l-3.98-2.46-3.39 2.68z' fill='%23452c25' stroke='%23000' stroke-width='.2080584'/%3E %3Cpath d='M523.45 295.8s-2.86 2.31-2.33 2.89c.54.58 5.64-1.52 6.57-2.53.93-1.01.87-2.1.87-2.1l-5.11 1.74z' fill='none' stroke='%23000' stroke-width='.2080584'/%3E %3Cpath d='M526.37 295.44s-3.85 3.18-2.92 4.33c.93 1.16 6.3-3.97 7.03-4.62.73-.65-4.51.14-4.51.14' fill='%23452c25' stroke='%23000' stroke-width='.2080584'/%3E %3Cpath d='M524.64 294l-7.76 3.68s-6.57 4.26-5.9 4.7c.66.43 5.77-.95 9.41-2.75 3.65-1.8 7.7-4.84 7.7-4.84M526.8 298.19s-8.4 7.22-7.13 7.94c1.26.72 6.87-2.3 10.65-5.77' fill='%23452c25' stroke='%23000' stroke-width='.2080584'/%3E %3Cpath d='M527.87 300.57s-4.76 8.02-4.22 8.81c.53.8 3.98-1.88 5.7-3.9 1.73-2.02 3.08-5.01 3.08-5.01' fill='%23452c25' stroke='%23000' stroke-width='.2080584'/%3E %3Cpath d='M530.6 301.27s-5.15 9.57-4.55 10.37c.6.8 3.58.14 5.37-3.61 1.8-3.76 1.64-6.18 1.64-6.18l-2.46-.58z' fill='%23452c25' stroke='%23000' stroke-width='.2080584'/%3E %3Cpath d='M533.6 301.73s-5.73 11.81-4.6 12.97c1.13 1.16 7.46-8.96 7.75-10.39.51-2.51-3.22-2.8-3.22-2.8M521.52 293.92s-5.17 2.46-4.11 2.96c1.06.5 5.9-1.66 6.57-1.88.66-.21-2.46-1.08-2.46-1.08z' fill='%23452c25' stroke='%23000' stroke-width='.2080584'/%3E %3Cpath d='M522.32 294.72s-3.19 2.52-2.52 3.18c.66.65 5.5-1.96 6.43-2.75.93-.8-3.91-.43-3.91-.43z' fill='%23452c25' stroke='%23000' stroke-width='.2080584'/%3E %3Cpath d='M529 294.92s-4.35 5.85-3.02 6.08c1.34.23 6.39-3.77 6.46-4.46.07-.7-3.44-1.62-3.44-1.62z' fill='%23452c25' stroke='%23000' stroke-width='.21978000000000003'/%3E %3Cpath d='M530.94 296.23s-4.64 5.85-3.31 6.22c1.32.36 1.46-.58 1.46-.58s3.64-3.04 3.91-3.83c.27-.8-1.92-1.88-1.92-1.88' fill='%23452c25' stroke='%23000' stroke-width='.2080584'/%3E %3Cpath d='M532.4 297.6s-3.38 5.86-2.52 6.22c.87.36 2.26-1.08 3.65-2.82 1.4-1.73-1.13-3.4-1.13-3.4z' fill='%23452c25' stroke='%23000' stroke-width='.2080584'/%3E %3Cpath d='M533.27 300.28s-2 3.68-1.46 4.84c.53 1.16 2.45-.87 3.38-2.17.93-1.3-1.92-2.67-1.92-2.67zM534.1 310.5s-1.33 5-.33 5.5c1.95.99 3.2-3.45 3.38-5.13.2-1.88-3.05-.36-3.05-.36z' fill='%23452c25' stroke='%23000' stroke-width='.2080584'/%3E %3Cpath d='M543.22 303.77s-1.33-.44-2.32-.44c0 0-2.92-2.31-4.52-2.53-1.59-.21-.23-.25-.23-.25s-.16-3.8-.63-4.08c0 0-.26-3.9-2.72-4.2-2.45-.28-7.96.22-8.96-.14-1-.36-4.04-1.63-9.81-.07-5.91 1.6-17.54 6.82-18.14 6.96-.6.15 13.36-3.06 17.27-4.8 0 0 3.92-.28 5.11-.64 0 0-4.44 2.17-.33 1.23s3.18 0 3.18 0-.4.94 1.93.43c2.32-.5 2.32 0 2.32 0s2.65.94 4.71-.29c0 0 1.06 3.69 2.39 4.2 0 0 1.58 3.37 4.9 4.02l1.9 1.33 1.88.62 2-1.57' fill='%23452c25' stroke='%23000' stroke-width='.2080584'/%3E %3Cpath d='M516.02 293.78s-13.27 4.76-12.81 6.07c.46 1.3 13.87-3.69 15.99-5.06 2.12-1.37-2.99-1.09-2.99-1.09' fill='%23452c25' stroke='%23000' stroke-width='.2080584'/%3E %3Cpath d='M552.75 304.06c.3.05.56.19.83.33.01 0 .13.07.15.04.02-.03-.08-.12-.1-.12a2.4 2.4 0 0 0-.56-.42c-.34-.18-.68-.37-1.07-.43-.08-.02.21.26.23.27.14.12.34.3.52.33M542.42 314.08c.2.37.23.81.42 1.19-.01-.03.03-.15 0-.2-.19-.37-.22-.81-.42-1.19.02.03-.03.15 0 .2M544.22 303.86c.45-.16.92-.16 1.38-.22.02 0 0-.2 0-.2-.46.06-.93.06-1.38.22-.03 0 0 .2 0 .2M546.87 303.64a3 3 0 0 1 1.32-.21c.02 0 .02-.2 0-.2a3 3 0 0 0-1.32.21c-.04.02.01.2 0 .2M542.26 305.98c-.05.01-.06.06-.06.1v.15c.01.03.02-.04.02-.04 0 .04.02 0 .04 0 .03-.01 0-.2 0-.2M541.99 313.12a7.68 7.68 0 0 0 .07 1.07v-.13a6.24 6.24 0 0 1-.07-.94'/%3E %3Cpath d='M544.67 334.2s-1.5 1.17-1.67 1.72c-.17.55-.22 1.07-.22 1.07s1.34-.16 1.18.58c0 0 .44.25 1.13-1.36.7-1.6 1.35-2.3 1.84-2.25.49.04 1.11.52 1.43.86.31.33.75.58 1.3.43 0 0-.58-.88-.22-1.07.37-.2.92-.15.92-.15s-.46-1.1-1.44-1.25c-.99-.16-1.67-.43-1.44-.86.24-.43 1.5-3.76 1.5-3.76l-1.67-2.45-.67 2.14s.22 1.26.23 1.58c0 .32-1.33 3.08-1.5 3.24-.19.16-3.77 1.54-4.2 1.67-.42.14-1.3 1.2-1.3 1.2l-.1.8s.6-.5.78-.2c0 0 .42-.53.79-.33.37.2.31.27.31.27s.67-.44.78-.65c.12-.21.15-.19.15-.19s.34-.09.82-.17' fill='%23bd8759'/%3E %3Cpath d='M544.67 334.2s-1.5 1.17-1.67 1.72c-.17.55-.22 1.07-.22 1.07s1.34-.16 1.18.58c0 0 .44.25 1.13-1.36.7-1.6 1.35-2.3 1.84-2.25.49.04 1.11.52 1.43.86.31.33.75.58 1.3.43 0 0-.58-.88-.22-1.07.37-.2.92-.15.92-.15s-.46-1.1-1.44-1.25c-.99-.16-1.67-.43-1.44-.86.24-.43 1.5-3.76 1.5-3.76l-1.67-2.45-.67 2.14s.22 1.26.23 1.58c0 .32-1.33 3.08-1.5 3.24-.19.16-3.77 1.54-4.2 1.67-.42.14-1.3 1.2-1.3 1.2l-.1.8s.6-.5.78-.2c0 0 .42-.53.79-.33.37.2.31.27.31.27s.67-.44.78-.65c.12-.21.15-.19.15-.19s.34-.09.82-.17' fill='none' stroke='%23000' stroke-width='.2080584'/%3E %3Cpath d='M554.87 326.83l.06 3.35a3.6 3.6 0 0 1-.36 1.77c-.3.46-.6.72-1.08.72-.49 0-1.75-.07-2 .4-.24.45-.42.71-.42.71s.79-.45.9 0c.13.46-.3.86-.3.86s.73.13 1.4-.26c.66-.4 1.02-.46 1.32-.46.3 0 .54.32.54.32s.18.99.12 1.58c-.06.59-.18 1.77.48 1.77 0 0 .24-.59.49-.66.24-.06.9.6.78.8 0 0 .12-1.26-.12-1.98s-.36-1.5-.36-1.5 2.05.72 2.23.98c.18.26.66.72.84.65.18-.06 0-.65.36-.78s.54.2.54.2-.6-1.38-1.5-1.84c-.9-.46-1.5-.46-1.87-.86-.36-.39-.42-.85-.48-1.3-.06-.47.01-4.43.01-4.43l-1.52-.3' fill='%23bd8759'/%3E %3Cpath d='M554.9 326.62l.03 3.56a3.6 3.6 0 0 1-.36 1.77c-.3.46-.6.72-1.08.72-.49 0-1.75-.07-2 .4-.23.45-.42.71-.42.71s.79-.45.9 0c.13.46-.3.86-.3.86s.73.13 1.4-.26c.66-.4 1.02-.46 1.32-.46.3 0 .54.32.54.32s.18.99.12 1.58c-.06.59-.18 1.77.48 1.77 0 0 .24-.59.49-.66.24-.06.9.6.78.8 0 0 .12-1.26-.12-1.98s-.36-1.5-.36-1.5 2.05.72 2.23.98c.18.26.66.72.84.65.18-.06 0-.65.36-.78s.54.2.54.2-.6-1.38-1.5-1.84c-.9-.46-1.5-.46-1.87-.86-.36-.39-.42-.85-.48-1.3-.06-.47.01-4.43.01-4.43l-1.55-.25z' fill='none' stroke='%23000' stroke-width='.2080584'/%3E %3Cpath d='M542.3 308.31s-.2-2 .36-2.22c0 0 .2-1.85 2.65-1.6 0 0 .83-1.37 2.16-.64 0 0 1.26-.62 1.99-.26s1.63.98 1.7 1.12c0 0 1.05-.21 1.55.18.5.4.27 1.7.27 1.7s1.2.92 1.29 1.72c.1.81.1 1.13-.17 1.35 0 0 .53.43.44 1.05-.1.61-.6 1.5-.7 1.5-.1 0 .06 1.6-.47 2.15-.53.54-1.02.65-1.26.72-.23.07-.83.94-1.39 1.05-.56.1-1.33-.87-1.4-1.16-.06-.29-.82-.61-.82-.61s-1.73 1.84-2.89 1.55a3 3 0 0 1-1.82-1.44c-.1-.18-.43-1.52-.43-1.52s-1.3-.76-1.2-1.48c.1-.72.63-1.6.63-1.6l-.5-1.56z' fill='%23dcddde'/%3E %3Cpath d='M546.6 331.16c-.15.03-.26 0-.36-.07M547.18 329.7a1.25 1.25 0 0 1-.5-.18M546.59 330.45c.1.06.24.09.37.07M545.36 332.73a.5.5 0 0 0 .25.09M555.65 331.36c.25.04.47.17.73.2M556.08 330.63c-.2.05-.37.01-.49-.13M556.2 329.78c-.23.03-.47.02-.67-.06M555.35 332.67c.23.03.44.14.67.2M555.41 333.59c.11-.03.22 0 .3.06M555.6 336.08c.14-.03.3 0 .42.07M548.06 332.86a.53.53 0 0 0-.42.33M549.29 332.97c-.26.16-.5.37-.53.68M541.67 334.33c.2.18.5.3.68.46M557.82 333.33a.55.55 0 0 0-.3.39M558.67 333.59a.29.29 0 0 0-.18.26' fill='none' stroke='%23000' stroke-width='.2080584'/%3E %3Cpath d='M539.77 336.05l.86-.22.08.03s-.56 1.1-.41 1.36c.15.26-.77-.48-.53-1.17' fill='%23d9c0b9'/%3E %3Cpath d='M539.77 336.05l.86-.22.08.03s-.56 1.1-.41 1.36c.15.26-.77-.48-.53-1.17z' fill='none' stroke='%23000' stroke-width='.2080584'/%3E %3Cpath d='M543.04 336.7s-.95 1.59.28 2.38c0 0-.07-1.48.9-1.8l-1.18-.58z' fill='%23d9c0b9'/%3E %3Cpath d='M543.04 336.7s-.95 1.59.28 2.38c0 0-.07-1.48.9-1.8l-1.18-.58z' fill='none' stroke='%23000' stroke-width='.2080584'/%3E %3Cpath d='M549.35 335.21l-.28-.85.33-.46h.68l.28.13s.55 1.24.07 1.9c0 0-.2-.7-.43-.8 0 0-.5-.08-.65.08' fill='%23d9c0b9'/%3E %3Cpath d='M549.35 335.21l-.28-.85.33-.46h.68l.28.13s.55 1.24.07 1.9c0 0-.2-.7-.43-.8 0 0-.5-.08-.65.08z' fill='none' stroke='%23000' stroke-width='.2080584'/%3E %3Cpath d='M551.47 333.4h.56l.22.52-.08.5-.5.22s-.8-.2-.6.75c0 0-.38-1.76.4-2' fill='%23d9c0b9'/%3E %3Cpath d='M551.47 333.4h.56l.22.52-.08.5-.5.22s-.8-.2-.6.75c0 0-.38-1.76.4-2z' fill='none' stroke='%23000' stroke-width='.2080584'/%3E %3Cpath d='M555.46 337.33l.58-.64.63.33s-.26 1.7-.36 1.83c-.1.12-.12.14-.12.2 0 .04-.1-.33-.28-.54-.2-.22-.39-1.16-.45-1.18' fill='%23d9c0b9'/%3E %3Cpath d='M555.46 337.33l.58-.64.63.33s-.26 1.7-.36 1.83c-.1.12-.12.14-.12.2 0 .04-.1-.33-.28-.54-.2-.22-.39-1.16-.45-1.18z' fill='none' stroke='%23000' stroke-width='.2080584'/%3E %3Cpath d='M559.26 335.62s.94 1.18.82 1.56c0 0 .97-.98-.27-2.37l-.55.81z' fill='%23d9c0b9'/%3E %3Cpath d='M559.26 335.62s.94 1.18.82 1.56c0 0 .97-.98-.27-2.37l-.55.81z' fill='none' stroke='%23000' stroke-width='.2080584'/%3E %3Cpath d='M555.13 306.08c.19.05.3.19.37.37v-.07-.12c-.06-.19-.18-.33-.37-.39 0 0-.03.2 0 .2M555.34 309.32c.3.31.51.67.63 1.08 0-.03.02-.14 0-.2a2.65 2.65 0 0 0-.63-1.08c.02.02-.04.16 0 .2M554.65 306.94c.29.25.53.54.8.81-.03-.02.03-.16 0-.2-.27-.27-.51-.56-.8-.81.02.02-.04.17 0 .2M555.44 312.34c.08.48-.03.9-.2 1.33-.03.05 0 .16 0 .2.23-.56.31-1.12.21-1.7 0-.02-.02.13-.01.17M556.18 314.01c.04.25.05.5 0 .75v.14s0 .07.01.03c.07-.36.06-.73 0-1.09l-.01.04v.13M559.04 319.92a7.6 7.6 0 0 1 .23 2.07 8.3 8.3 0 0 0-.22-2.27c0 .04-.02.14 0 .2M558.57 321.3c-.16.47-.32.95-.53 1.4-.03.05.01.17 0 .2.22-.46.38-.94.53-1.41.02-.06-.01-.17 0-.2M542.58 316.73c.44.58.68 1.27 1.06 1.9-.02-.03.03-.16 0-.2-.37-.63-.61-1.32-1.06-1.9.03.03-.04.15 0 .2M545.39 316.8c-.4.05-.5-.53-.85-.65 0 0-.03.2 0 .2.34.12.44.7.85.65.02 0 0-.2 0-.2M543.8 319.49c.29.5.48 1.07.79 1.56-.01-.02.03-.14 0-.19-.3-.5-.5-1.06-.79-1.57.01.02-.03.15 0 .2M545.65 320.14c.33.4.62.8.8 1.3-.02-.04.02-.15 0-.2-.17-.5-.47-.9-.8-1.3.03.03-.04.15 0 .2M545.49 322.08c.16.34.31.69.48 1.03-.02-.03.03-.14 0-.2l-.48-1.02c.02.02-.02.14 0 .2M547.24 322.46a4.36 4.36 0 0 1 .17 1.1c0-.44-.05-.87-.17-1.3.01.04-.02.14 0 .2M546.5 324.07c.1.52.26 1.02.53 1.47-.02-.02.03-.14 0-.19a4.95 4.95 0 0 1-.53-1.45c0-.02-.02.13 0 .17M546.92 317.22c.42.16.84.32 1.27.43 0 0 .03-.2 0-.2-.43-.12-.85-.27-1.27-.43 0 0-.03.19 0 .2M547.24 319c.5.28 1.02.5 1.53.76 0 0 .04-.18 0-.2-.5-.26-1.03-.48-1.53-.76.01.01-.04.18 0 .2M547.72 321c.25.32.54.6.84.87-.02-.02.04-.17 0-.2-.3-.27-.59-.55-.84-.87.02.03-.04.16 0 .2M548.24 323.49c.22.34.32.72.37 1.12 0 .04.01-.03.01-.03v-.14a2.8 2.8 0 0 0-.37-1.15c.01.02-.04.15 0 .2M549.72 317.31l.16.72c0-.04.02-.14 0-.2a15.8 15.8 0 0 1-.16-.66v.14M553.43 315.83c-.1.26-.23.51-.37.76-.03.04.02.17 0 .2.15-.25.27-.5.38-.76.02-.06-.02-.17 0-.2M554.96 315.77c0 .42 0 .84-.1 1.26v.17a6.52 6.52 0 0 0 .1-1.43M555.28 318.1c.04.37 0 .73-.05 1.1v.17a5.81 5.81 0 0 0 .05-1.26M556.45 320.33c-.07.5-.38.9-.74 1.23-.04.04.02.18 0 .2.37-.33.68-.74.75-1.26l-.01-.17M552.69 318.16c-.1.2-.24.4-.37.6-.02.02 0 .09 0 .12v.07c.13-.2.27-.39.37-.6.02-.03.01-.09.01-.12 0-.01 0-.08-.01-.07M553.12 321.13c-.16.21-.32.43-.53.6-.04.02.02.18 0 .2.2-.17.37-.39.53-.6v-.1-.1M551.8 322.7c-.52-.52-.77-1.17-.53-1.92.01-.05-.02-.16-.01-.19-.26.83-.09 1.7.53 2.3-.02-.02.04-.16 0-.2M550.04 321.05c.04.3.04.6-.05.9-.02.05.01.15 0 .19.13-.41.12-.85.06-1.27l-.01.04v.14M554.07 323.02c-.11.37-.31.7-.48 1.03-.03.05.02.17 0 .2.17-.34.37-.66.48-1.03.02-.06-.01-.16 0-.2M556.66 324.1c-.22.4-.48.77-.74 1.14-.03.04.02.18 0 .2.26-.37.52-.75.75-1.14.02-.05-.02-.17-.01-.2M557.93 325.47a26.56 26.56 0 0 0-.2 2.2c.05-.68.1-1.36.2-2.03.02-.04 0-.19 0-.17M559.57 323.04c0 .24.04.47.05.7 0 .14.02.01.02-.05 0-.24-.05-.47-.06-.7 0-.15-.02-.01-.01.05M542.15 315.4c-.1.7-.01 1.37.22 2.03-.01-.03.02-.14 0-.2a3.42 3.42 0 0 1-.2-1.65l-.02-.17'/%3E %3Cpath d='M548.15 306.8c1.12-1.04 2.6-2.12 4.18-1.74 0 0 .03-.2 0-.2-1.58-.38-3.06.7-4.18 1.73-.04.04.03.18 0 .2M553.53 308.01c-1.13-.76-3.08-1.04-4.18-.1-.04.03.02.18 0 .2 1.1-.94 3.05-.66 4.18.1-.02 0 .04-.17 0-.2M549.24 309.74c.46 1.48 1.06 3 .8 4.59v.17c.29-1.72-.29-3.34-.8-4.96.02.03-.01.14 0 .2M547.45 310.64c.28 1.5.1 3.03 0 4.54 0 .03 0 .23.01.1.11-1.6.3-3.22 0-4.81 0-.02-.02.13-.01.17M549.84 309.54a6 6 0 0 1 3.68 2.64c0-.03.04-.15 0-.2a6 6 0 0 0-3.68-2.65s-.02.2 0 .2M548.54 311.57c0 .93.08 1.85-.2 2.75 0 .06.02.16.01.2.3-.97.22-1.96.21-2.95 0-.11-.02-.11-.02 0M550.84 311.37c.92.76 1.65 1.9 1.78 3.12.01.08.02-.12.02-.14a4.99 4.99 0 0 0-1.8-3.19c.02.02-.04.17 0 .2M544.07 313.9c.3-.43.69-.93 1.2-1.11.03-.01-.01-.2 0-.2-.52.18-.9.68-1.2 1.12-.03.04.02.18 0 .2M546.26 306c-.19-.83-.81-1.32-1.48-1.77.02.01-.03.16 0 .18.66.45 1.29.93 1.48 1.76 0-.03.02-.13 0-.18M544.97 305.98a5.37 5.37 0 0 0-2.4-.4v.2c.84 0 1.63.04 2.4.4-.01 0 .03-.18 0-.2M547.36 305.85c.1-.8-.02-1.54-.7-2.03.02 0-.03.15 0 .17.57.41.78.99.7 1.7v.16M550.24 306.8c.72-.4 1.5-.32 2.29-.31.01 0 .02-.2 0-.2-.78-.01-1.57-.08-2.29.3-.04.02.02.2 0 .2M551.54 308.72c1.1.12 1.95.69 2.68 1.53-.05-.06.08-.32 0-.4a4.07 4.07 0 0 0-2.68-1.53c-.02 0-.05.4 0 .4M546.65 311.78c-.26 1.06-.06 2.4-1.28 2.84-.07.02 0 .4 0 .4 1.24-.44 1.03-1.78 1.3-2.85.02-.11-.03-.32-.02-.39' fill='%23fff'/%3E %3Cpath d='M549.24 310.95c.43 1.12 1.02 2.26.8 3.5-.02.08 0 .38.01.34.28-1.52-.26-2.83-.8-4.23.02.06-.05.28 0 .4M550.84 310.75a2.63 2.63 0 0 1 2.18 2.21c0 .08.03-.06.03-.07l-.01-.27a2.67 2.67 0 0 0-2.2-2.27c-.02 0-.05.4 0 .4M550.83 312.35c.17.93.43 1.86.1 2.79-.04.1.04.33.01.39.41-1.16.12-2.36-.1-3.52 0-.04-.02.26-.01.34M550.24 308.32c1.2-.2 2.45-.39 3.48.4-.04-.03.08-.34 0-.4-1.03-.79-2.29-.61-3.48-.4-.05 0 0 .4 0 .4M548.06 305.95c.15-.99 1.01-1.69 1.88-2 .07-.03-.01-.4 0-.41-.9.33-1.75 1.05-1.9 2.06-.01.1 0 .19 0 .28 0 0 .01.15.02.07M546.97 306.54c-.02-1.1-.5-1.97-.97-2.93.02.05-.06.26-.01.35.42.85.93 1.69.95 2.68 0 .25.04.01.03-.1M545.97 307.13a3.04 3.04 0 0 0-1.7-2.07c.03.02-.07.37 0 .4a3 3 0 0 1 1.68 2.01c.01.04.04-.27.02-.34M544.37 306.74a4.43 4.43 0 0 0-1.82-.86s-.03.31 0 .31c.68.1 1.26.47 1.82.86-.03-.02.06-.27 0-.31M547.84 311.3c.1 1.04.22 2.08-.29 3.02-.05.1.04.35.01.4.62-1.14.42-2.47.3-3.7 0-.16-.03.23-.02.29' fill='%23fff'/%3E %3Cpath d='M549.04 310.75c.35.97.76 2 .69 3.06 0 .06.02.45.03.2a9.04 9.04 0 0 0-.7-3.65c.01.06-.06.28-.02.39M549.84 309.33c1 .3 1.97.63 2.69 1.42-.05-.05.08-.31 0-.4-.72-.8-1.7-1.12-2.69-1.42.01 0-.06.38 0 .4M547.17 307.14c.1-.86.2-1.72.2-2.59.01-.23-.03-.22-.03 0-.01.78-.1 1.54-.2 2.3 0 .05.01.45.03.29M545.37 306.59a8.77 8.77 0 0 1-2-1.32c.05.04-.07.34 0 .4.62.52 1.27 1 2 1.32-.03 0 .07-.37 0-.4M545.07 311.78c-.47.3-.8.7-1 1.22-.03.07-.02.18-.02.25 0 .02.02.16.03.14.2-.51.52-.92.99-1.21.07-.05-.04-.38 0-.4M546.34 312.53c-.02.71-.4 1.3-.88 1.79-.07.08.05.35 0 .4a3 3 0 0 0 .92-2.08c0-.13-.03-.39-.04-.1M549.68 306.97c.59-.93 2.01-1 2.96-1.27.06-.01 0-.4 0-.4-.96.26-2.37.34-2.97 1.28-.06.09.04.35.01.39M543.16 306.95a3.24 3.24 0 0 1-.65-.3c.02.01-.04.22 0 .25.21.12.42.23.65.3 0 0 .03-.24 0-.25M543.28 311.7c-.2.08-.41.17-.55.35-.04.04-.02.15-.02.2v.14s.01.07.02.06c.14-.18.35-.26.55-.35.04-.01.02-.17.02-.2 0-.01 0-.2-.02-.2M544.14 311.92c-.42.19-.73.55-.99.92-.05.07.03.28.01.3.26-.36.57-.72.98-.9.06-.03-.01-.32 0-.32M545.77 312.32c-.37.9-1.37 1.89-.65 2.89-.02-.04.08-.3.01-.4-.5-.69.39-1.47.65-2.1.04-.1-.04-.33-.01-.4M546.91 312.3c.03.92-.13 1.82-.29 2.71-.01.08.01.39.02.35.19-1.05.34-2.1.31-3.16 0-.29-.04-.02-.04.1M549.85 311.23c.66.87 1.25 1.8 1.54 2.88-.02-.07.04-.27 0-.39a8.37 8.37 0 0 0-1.54-2.9c.05.07-.07.31 0 .4M550.2 310.52c1.09.84 2.3 1.62 3.08 2.8-.03-.04.06-.3 0-.39-.77-1.18-1.99-1.97-3.09-2.81.04.03-.08.34 0 .4' fill='%23fff'/%3E %3Cpath d='M550.84 309.08c.4-.04.78-.02 1.17.12.35.13.64.42.95.6.32.2.64.37.9.65.34.35.34.96.44 1.42.01.03.03-.23.02-.3-.08-.37-.12-.75-.25-1.12-.13-.36-.44-.57-.74-.77l-1.07-.7c-.42-.27-.94-.29-1.42-.24-.04 0-.02.34 0 .34' fill='%23fff'/%3E %3Cpath d='M553.52 311.32l.38 1.06c-.02-.04.03-.18 0-.26l-.38-1.05c.02.04-.03.18 0 .25M550.45 305.75c.77-.22 1.56-.36 2.32-.62.06-.02-.01-.4 0-.4-.76.26-1.55.4-2.32.61-.06.02 0 .4 0 .4M547.24 306.13c.1-.4.28-.74.51-1.09.29-.43.33-.96.68-1.36.08-.08-.05-.34 0-.4-.29.32-.39.74-.56 1.13-.2.47-.5.82-.64 1.33-.03.12.03.32 0 .4M544.6 313.35c-.13.66-.1 1.35.14 1.99-.03-.06.05-.28 0-.4-.15-.4-.2-.8-.12-1.24.02-.1.02-.2.01-.28 0-.01-.01-.15-.03-.07M546.2 314.6c-.27.38-.28.95-.13 1.38l.02-.13c0-.07.01-.16-.01-.23-.08-.24-.02-.44.12-.64.03-.04.02-.14.02-.19 0-.02-.03-.18-.02-.19M547.39 313.97c-.01.38-.22.74-.38 1.08-.03.07.03.24.01.28.2-.42.38-.82.4-1.29 0-.09-.02-.28-.03-.07M547.43 311.72v.49c0 .01 0 .2.02.2s.02-.19.02-.2v-.49s0-.2-.02-.2c-.03 0-.02.2-.02.2M546.88 312l.08.18c.01.09.02.1.02.02 0 .03 0 .06-.02.1a1.2 1.2 0 0 0 0 .27c0 .01.01.15.02.07a1.6 1.6 0 0 0-.09-1.02l-.02.14c0 .06-.02.19.01.25M546.11 311.75c-.08.25-.13.5-.18.77v.27c0 .01.01.15.02.07.05-.24.1-.48.17-.72.03-.08.02-.17.02-.25a.65.65 0 0 0-.03-.14M545.52 311.79c-.37.44-.85.73-1.33 1-.08.05.03.4 0 .4.48-.27.96-.56 1.33-1 .03-.04.02-.15.02-.2l-.02-.2M544.49 311.96c-.22.18-.47.3-.73.4-.07.02 0 .4 0 .4.26-.1.5-.22.73-.4.03-.02.02-.16.02-.2l-.02-.2M543.03 311.6l-.65.27c-.05.03.02.32 0 .33l.65-.27c.05-.03-.02-.32 0-.33M547.47 311.43c0 .26.05.52.1.78.01.07.02-.06.02-.08v-.27c-.04-.18-.08-.36-.08-.54a.6.6 0 0 0-.03-.14c-.02.07-.01.17-.01.25M548.16 311.11c0 .31.03.6.14.9a.6.6 0 0 0 .02-.14c0-.08.02-.18-.01-.25a1.5 1.5 0 0 1-.11-.5c0-.02 0-.21-.02-.21-.03 0-.02.19-.02.2M548.68 311.04c.1.13.2.31.2.48 0 .01.02.15.03.14.03-.08.02-.18.01-.25 0-.28-.06-.53-.22-.76-.02-.02-.03.13-.03.14 0 .06-.02.2.02.25M549.33 310.79c.23.05.44.14.6.3l.02-.2c0-.04.02-.17-.01-.2a1.2 1.2 0 0 0-.6-.3s-.06.39 0 .4M549.68 310.26c.26.22.56.39.9.44 0 0 .05-.4 0-.4a1.83 1.83 0 0 1-.9-.44l-.02.2c0 .04-.02.17.02.2M550.4 308.5c.24.01.47.05.7.1 0 0 .05-.4 0-.4a3.62 3.62 0 0 0-.7-.1c-.02 0-.02.4 0 .4M550.07 307.67c.14-.23.35-.4.55-.57.04-.02.02-.16.02-.2l-.02-.2c-.2.17-.42.34-.56.58-.04.05-.02.18-.02.25 0 .01.02.16.03.14M549.43 306.86c.04-.27.13-.5.29-.72.03-.04.02-.15.02-.2l-.02-.2a1.63 1.63 0 0 0-.32 1.05s.02.15.03.07M548.91 306.48c.26-.37.44-.8.69-1.18.03-.05.01-.19.01-.25 0-.01-.01-.16-.02-.14-.25.39-.43.81-.69 1.18-.04.05-.02.2-.01.25 0 .02 0 .16.02.14' fill='%23fff'/%3E %3Cpath d='M547.73 305.16c0 .45.04.9.13 1.35.02.07.03-.06.03-.08v-.27a5.71 5.71 0 0 1-.12-1.1c-.01-.3-.05-.03-.04.1M545.81 305.48c.07.16.16.31.24.47a3.13 3.13 0 0 1 .18.43c-.03-.09.02-.06-.03.02-.06.1.03.35 0 .4.12-.21.1-.53.05-.75-.08-.35-.3-.64-.43-.96.02.05-.05.28 0 .39M545.43 306.26a7.05 7.05 0 0 0-.86-.7l-.02.2c0 .04-.01.18.02.2.3.22.6.44.86.7l.02-.2c0-.04.01-.16-.02-.2M546.68 306.68a4.3 4.3 0 0 0-.22-2.6c.03.05-.05.28 0 .39a3 3 0 0 1 .2 1.86c-.01.1 0 .2 0 .28 0 .01 0 .15.02.07M548.56 305.53c.03 0 .03-.4 0-.4s-.03.4 0 .4' fill='%23fff'/%3E %3Cpath d='M546.44 306.72c.04-.5.16-.99.21-1.49a2.2 2.2 0 0 0 0-.43c0-.1-.03-.1-.04 0-.05.5-.17 1-.21 1.5a2.3 2.3 0 0 0 0 .42c0 .1.03.1.04 0M551.87 309.84c.43.14.86.43 1.06.86.01.03.04-.19.04-.21 0-.1.02-.27-.02-.37a1.8 1.8 0 0 0-1.08-.89c.01 0-.1.57 0 .6M550.4 312.85c.08.26.08.5.03.76-.02.13-.01.28 0 .42 0 .01.01.22.04.1.1-.6.12-1.27-.05-1.86-.01-.03-.04.18-.04.2 0 .12-.02.26.02.38M549.18 312.03c0 .5.02 1-.08 1.5-.02.13-.01.27 0 .4 0 .03.01.23.03.12.14-.67.1-1.34.1-2.02 0-.02.01-.3-.02-.3-.04 0-.03.28-.03.3M548.55 312.57c-.17.67-.34 1.33-.48 2-.02.14-.01.29 0 .42 0 .02.01.22.04.1.13-.64.3-1.29.46-1.93.04-.17-.04-.48-.02-.59M549.39 313c0 .57.07 1.14 0 1.71a2.1 2.1 0 0 0 0 .43c.02.1.04.1.05 0 .08-.72.02-1.43.01-2.14 0-.02 0-.3-.03-.3s-.03.28-.03.3M545.37 313.3v-.1a.93.93 0 0 1-.12.3c-.05.08-.02.27-.02.37 0 .02.02.24.04.2.2-.37.2-.87.13-1.3-.01-.1-.04.1-.04.12l.01.41M547.14 312.1c.12.23.1.43.1.68 0 .02 0 .3.03.3.04 0 .03-.28.03-.3 0-.42.05-.88-.15-1.26-.01-.03-.03.2-.03.21 0 .1-.03.28.02.37M547.62 311.9a.57.57 0 0 1 .21.28c.01.04.02.15.02.02l.01.18s0 .07.02.03c.04-.1.03-.26.02-.37 0-.3-.04-.56-.28-.75l-.02.09-.01.21v.22c.01.02.01.07.03.09M548.21 311.36l.3.57c.02.03.02-.03.02-.03l.02-.18v-.24c-.01-.03 0-.1-.02-.13l-.3-.57c-.02-.04-.03.02-.03.03l-.01.18v.23c0 .04 0 .1.02.14M549.54 310.88c.23.33.48.66.74.97l.03-.3c0-.07.02-.24-.03-.3-.26-.31-.5-.63-.72-.96-.02-.03-.04.2-.04.21 0 .09-.03.3.02.38M550.23 309.74c.18.31.38.6.6.88l.04-.3c0-.07.02-.24-.03-.3a6.44 6.44 0 0 1-.6-.87c-.01-.03-.03.2-.03.21 0 .1-.03.29.02.38M543.54 306.69c-.2-.16-.4-.3-.64-.4-.02 0-.03.3-.03.3 0 .04-.02.29.03.3.23.1.44.24.64.4l.03-.3c0-.06.02-.26-.03-.3M545.64 305.97a1.88 1.88 0 0 1 .06.18c0 .06 0 .12.02.18 0 0 0 .07.02.03.04-.1.02-.26.02-.37 0-.2-.02-.42-.1-.6-.02-.04-.03.02-.03.02l-.01.18c0 .11-.03.28.02.38M547.29 304.4c0 .4-.03.81-.24 1.16-.05.08-.02.28-.02.37 0 .02.02.24.04.21.32-.54.3-1.29.28-1.9a.88.88 0 0 0-.04-.22c-.04.11-.02.26-.02.38M547.66 306.64c.35-.24.6-.6.78-.98.05-.1.02-.27.02-.37 0-.02-.02-.24-.03-.21-.19.37-.42.72-.77.95-.05.03-.03.25-.03.3 0 .02.02.31.03.3M548.69 306.6c.12-.13.22-.28.34-.4.02-.02.02-.07.02-.1l.01-.2v-.22c0 .01-.02-.1-.03-.09l-.34.4c-.02.02-.02.06-.02.09a2.13 2.13 0 0 0 0 .42l.02.1M550.24 306.86c-.4 0-.78 0-1.16-.04-.03 0-.07.6 0 .6.38.04.77.05 1.16.05.04 0 .04-.6 0-.6M549.9 308.26c.5.3 1 .64 1.54.92-.04-.02.1-.55 0-.6-.53-.28-1.03-.62-1.55-.93.05.03-.11.54 0 .6' fill='%23fff'/%3E %3Cpath d='M549.93 309.31c.46.3.96.52 1.38.88l.03-.3c0-.07.02-.26-.03-.3-.42-.37-.92-.6-1.38-.89l-.02.3c0 .05-.03.28.02.31M546.98 307.1c.07-.21.07-.45.07-.68 0-.02 0-.3-.03-.3-.04 0-.03.28-.03.3 0 .08 0 .01 0 0l-.02.1c-.04.12-.03.26-.02.38l.01.18c0-.01.01.07.02.03M543.37 305.5c.4.49.91.85 1.4 1.23.38.29.65.78 1.05 1-.05-.02.11-.54 0-.6-.36-.2-.6-.64-.92-.9-.52-.44-1.1-.8-1.53-1.34.07.1-.11.47 0 .6M544.23 307.13c-.24-.25-.47-.52-.69-.8l-.02.1v.21c0 .07-.03.24.02.3.22.27.44.54.69.8l.03-.31c0-.07.02-.25-.03-.3M543.75 311.13c-.16.29-.3.6-.5.86-.06.07-.04.23-.04.3l.03.3c.21-.26.36-.58.52-.88.05-.09.03-.28.02-.37 0-.02-.02-.24-.03-.21M544.2 311.73c0 .34-.12.67-.16 1a2 2 0 0 0 0 .44c0 .1.02.1.04 0 .05-.43.17-.84.18-1.28 0-.11.01-.26-.02-.37-.01-.02-.04.19-.04.21M545.78 314.52c.29-.96.26-1.97.24-2.96-.01-.43-.07-.04-.06.16.01.75.02 1.49-.2 2.21-.05.17.05.49.02.59M546.7 312.2c.12.32.14.63.09.97-.02.14-.02.28-.01.42 0 .02.02.22.04.1.1-.68.12-1.42-.1-2.08l-.03.21c0 .11-.02.26.02.37M547.62 311.85c.33.41.43.95.4 1.48 0 .1.03.67.05.3.05-.79.07-1.74-.45-2.38l-.03.3c0 .07-.02.24.03.3' fill='%23fff'/%3E %3Cpath d='M547.87 311.45c.2.87.37 1.74.46 2.64.02.23.05-.35.04-.43-.1-.95-.27-1.88-.49-2.8.03.1-.05.41-.01.59M548.73 311.23c.38.52.71 1.08.9 1.7l.03-.2c0-.12.02-.26-.02-.38a5.67 5.67 0 0 0-.9-1.7c.04.04-.1.45-.01.58M550.5 309.77c-.18-.3-.55-.35-.87-.32-.06 0-.02.6 0 .6.3-.02.69 0 .85.3.02.03.04-.19.04-.21 0-.1.03-.29-.02-.37' fill='%23fff'/%3E %3Cpath d='M549.6 309.53c.55-.08 1.1-.09 1.66-.09.05 0 .05-.6 0-.6-.56 0-1.11 0-1.67.08-.07.01-.02.61 0 .6M550.62 304.93a4.55 4.55 0 0 0-.83 1.93c-.03.13-.02.28 0 .41 0 .03 0 .23.03.11a4.4 4.4 0 0 1 .8-1.84c.05-.06.03-.23.03-.3l-.03-.3M548.2 305.45c.09.52.3.99.44 1.48l.04-.21c0-.12 0-.26-.02-.37-.14-.48-.35-.93-.43-1.42-.02-.11-.04.1-.04.11l.01.41M547.75 306.34c-.2-.25-.37-.51-.47-.83 0-.03-.02.04-.02.04l-.01.18c0 .11-.02.25.02.37.1.32.27.59.48.84l.02-.09v-.21c0-.07.03-.24-.02-.3M546.93 306.73a6.22 6.22 0 0 1-1.89-.92c.06.05-.12.52 0 .6.57.44 1.22.7 1.9.93-.02 0 .09-.58 0-.6' fill='%23fff'/%3E %3Cpath d='M547.67 306.56s-2.67.46-3.37.62c-.7.16-2.3.32-2.86.32-.55 0-1.4-.44-2-.56-.59-.12-2.52-.33-3.22.4-.7.73-1.15.97-1.37 1.21-.23.24-1.12 1.04-1.15 1.39-.04.35.22.87.66.87.45 0 1.38.95 1.38 1.15 0 .33 1.22.68 2.38.68 2.08-.02 3.1-1.06 6.22-.7 1.7.2 4.81-1.13 5.37-1.93.56-.81.9-1.66.33-2.59-.55-.93-2.22-.83-2.37-.86' fill='%23dba05f'/%3E %3Cpath d='M547.67 306.56s-2.67.46-3.37.62c-.7.16-2.3.32-2.86.32-.55 0-1.4-.44-2-.56-.59-.12-2.52-.33-3.22.4-.7.73-1.15.97-1.37 1.21-.23.24-1.12 1.04-1.15 1.39-.04.35.22.87.66.87.45 0 1.38.95 1.38 1.15 0 .33 1.22.68 2.38.68 2.08-.02 3.1-1.06 6.22-.7 1.7.2 4.81-1.13 5.37-1.93.56-.81.9-1.66.33-2.59-.55-.93-2.22-.83-2.37-.86z' fill='none' stroke='%23000' stroke-width='.2080584'/%3E %3Cpath d='M536.5 309.56s-.01.05-.02-.04l-.02-.07-.02-.05v-.05c-.01-.02.06.01.27-.2l.18-.28c0 .01.27-.34.68-.44.4-.1.78-.02.83-.02.02-.02-.92-.03-.98.08 0-.08.9-.1.95-.04.01-.03-.85-.03-.91.09 0-.06.78-.1.86-.02l-.18-.02.07.02h-.11l-.07-.01s.18.02.19.04c0 0 .07-.03-.23-.01 0 0-.19-.03-.5.06-.4.06-.38.6-1 .96'/%3E %3Cpath d='M536.43 309.33c.03 0 .3-.1.55-.57-.07-.13.94-.52 1.05-.4 0 0 .27 0 .43.03' fill='none'/%3E %3Cpath d='M537.43 308.45c-.1-.01-.61.42-.57.44-.1.27-.4.45-.43.44M537.48 308.51c0-.03.7-.1.83-.05M537.35 308.7c-.02-.07.72-.18.8-.13' fill='none'/%3E %3Cpath d='M538.12 309.17s.04.02 0-.02l-.04-.04-.02-.03-.02-.02s-.03 0-.21.17c0 0-.09.06-.18.15 0 0-.18.15-.38.26-.22.04-.52.17-.52.23-.02-.08.6-.25.6-.26.04.03-.56.14-.57.26-.02-.07.55-.21.58-.22.03.04-.51.13-.53.24 0 0 .08-.07.1-.07l-.03.03.06-.03.04-.02s-.1.04-.1.07c0 0-.06-.01.14-.06 0 .02.5-.1 1.08-.64'/%3E %3Cpath d='M538.03 309.04s-.22.22-.45.38c0 .04-.47.32-.6.29 0-.02-.2.08-.28.18' fill='none'/%3E %3Cpath d='M537.33 309.6l.33-.24c.1-.1.37-.32.37-.32M537.34 309.66c.02.02-.44.09-.52.2M537.47 309.64c.03.06-.5.2-.52.22' fill='none'/%3E %3Cpath d='M538.86 307.01s-.04-.85-.85-1.17a5.04 5.04 0 0 0-2.08-.32c-.33.04-.39.19-.8.25-.42.07-.86.27-.86.27s0-.04-.23.37c-.22.4-.59.6-.4.97.18.36.06.42.29.5.23.06-.12-.13-.12-.13s-1.43.46-1.08 1.33c.35.88.7.55.8.53.1-.01.81-.38.81-.38l1.16-1.08s1.36-.53 1.5-.57c.16-.04.8.01.8.01l1.06-.58z' fill='%23c6262c'/%3E %3Cpath d='M538.86 307.01s-.04-.85-.85-1.17a5.04 5.04 0 0 0-2.08-.32c-.33.04-.39.19-.8.25-.42.07-.86.27-.86.27s0-.04-.23.37c-.22.4-.59.6-.4.97.18.36.06.42.29.5.23.06-.12-.13-.12-.13s-1.43.46-1.08 1.33c.35.88.7.55.8.53.1-.01.81-.38.81-.38l1.16-1.08s1.36-.53 1.5-.57c.16-.04.8.01.8.01l1.06-.58z' fill='none' stroke='%23000' stroke-width='.2080584'/%3E %3Cpath d='M537.83 309c0 .21-.22.48-.48.61-.27.12-.48.05-.48-.16 0-.2.21-.48.48-.6.26-.13.48-.06.48.15'/%3E %3Cpath d='M532.16 312.87s-1.11-1.92 1.99-2.87c0 0 .94.51 1.15.87 0 0-.54.9-2.3 1.14 0 0-.8.23-.84.86' fill='%23d9c0b9'/%3E %3Cpath d='M532.16 312.87s-1.11-1.92 1.99-2.87c0 0 .94.51 1.15.87 0 0-.54.9-2.3 1.14 0 0-.8.23-.84.86z' fill='none' stroke='%23000' stroke-width='.2080584'/%3E %3Cpath d='M532.49 312.56s1.25.26 2.1-.36c.68-.5.93-.27 1.1-.23 0 0 .05-.63-.39-1.1 0 0-.87.72-1.52.92-.65.2-1.1.13-1.3.77' fill='%23d9c0b9'/%3E %3Cpath d='M532.49 312.56s1.25.26 2.1-.36c.68-.5.93-.27 1.1-.23 0 0 .05-.63-.39-1.1 0 0-.87.72-1.52.92-.65.2-1.1.13-1.3.77z' fill='none' stroke='%23000' stroke-width='.2080584'/%3E %3Cpath d='M535.96 311.93c.23 0 .47 0 .7-.06.02 0 0-.2 0-.2-.23.06-.47.05-.7.05v.2M535.52 308.7c-.19 0-.13.22-.25.32v.2c.12-.1.07-.32.25-.33.02 0 .02-.2 0-.2M536.17 309.13c.1-.18.29-.26.46-.34.03-.02-.01-.2 0-.2-.18.08-.37.16-.47.34v.2M537 310.24a.4.4 0 0 0 .38-.18v-.1-.1a.4.4 0 0 1-.38.18s-.02.2 0 .2M537.66 310c.26-.1.45-.26.6-.5v-.13s0-.08-.01-.07c-.14.24-.34.4-.59.5-.03.02.01.2 0 .2M536.63 308.92c-.15.24-.43.37-.6.6-.02.04.02.17.01.19.17-.23.44-.35.59-.6.02-.03 0-.1 0-.12v-.07M537.07 312.13c.53.03 1.04-.04 1.55-.18.03 0 0-.2 0-.2-.5.14-1.02.21-1.55.18 0 0-.02.2 0 .2M539.51 312.04c.7-.5 1.28-.93 1.5-1.8.02-.06-.01-.16 0-.2-.23.87-.81 1.3-1.5 1.8-.04.03.02.19 0 .2M539.92 310.84c.5-.29.85-.75 1.04-1.3.02-.05-.02-.16 0-.19-.2.54-.55 1-1.04 1.3-.03.01.02.18 0 .2M539.7 307.78c.37-.04.78.27 1.04.51-.02-.02.04-.16 0-.2-.26-.24-.67-.55-1.05-.5-.02 0 0 .2 0 .2M549.48 309.31c.42-.7.2-1.56-.25-2.18 0 .02-.04.15 0 .2.37.52.62 1.18.24 1.79-.03.04.02.17 0 .19M542 308.33c.44.31 1.63 1.11 1.3 1.77-.02.05.02.17.01.2.45-.9-.7-1.74-1.3-2.17.02.01-.04.17 0 .2M545.37 311.55a2.26 2.26 0 0 0 .1-.71c0-.04 0-.04 0 0-.02.18-.05.35-.11.52v.19' fill='%237a2e26'/%3E %3Cpath d='M546.65 311.24c.26-.05.52-.18.78-.36M534.21 310.5c-.5.32-1.3.32-1.46 1.02v.05c.16-.7.96-.7 1.46-1.01v-.05' fill='%235e3f17'/%3E %3Cpath d='M533.87 308.26c.22 0 .48.12.44.4v.13c0 .04.01.04.02 0 .02-.16.02-.35-.04-.5-.07-.17-.25-.22-.42-.23-.01 0-.02.2 0 .2M534.92 308.67c.1-.3.08-.65-.1-.9.01.01-.04.14 0 .19.1.16.16.32.1.51-.03.06 0 .17 0 .2M535.77 307.77c-.06-.35-.18-.74-.5-.93 0 .01-.04.18 0 .2.31.18.44.56.49.9 0 .05.01-.02.01-.03v-.14M536.51 307.59c.05-.33.02-.68-.25-.9.02.02-.04.17 0 .2.15.12.27.32.24.53v.13c0 .01 0 .08.01.04M535.26 306.49c.73-.37 2.22-.54 2.8.2-.03-.03.03-.16 0-.2-.58-.74-2.07-.58-2.8-.2-.03.01.02.19 0 .2' fill='%23842116'/%3E %3Cpath d='M533.53 309.53c.16-.24.1-.57-.05-.8 0 .01-.04.15-.01.2.04.05.08.11.1.18.04.09 0 .16-.05.23-.02.02 0 .1 0 .12v.07M540.97 311.67c.24-.15.4-.37.46-.65v-.14s0-.07-.01-.04a.95.95 0 0 1-.45.63c-.03.02.02.19 0 .2M542.1 311.58a.6.6 0 0 0 .14-.4l-.01-.12-.01.07c0 .09-.07.19-.13.25v.2M548.84 307.88c.18.32.21.68.13 1.05 0 .04 0 .19.01.17.1-.46.1-1-.14-1.42.02.03-.03.15 0 .2M548.17 308.56c.13.33.12.67.08 1.02 0 .03 0 .22.02.14.05-.46.08-.91-.1-1.35.02.03-.02.14 0 .2M547.54 309.15c0 .25 0 .5-.09.72-.02.06.02.17 0 .2.12-.3.1-.61.1-.92 0-.11-.01-.11-.01 0' fill='%237a2e26'/%3E %3Cpath d='M556.65 328.86l.14.4s.03.07.1.14l-.22-.6-.02.06z' fill='%23452c25'/%3E %3Cpath d='M541.33 304.6c-2.68.16-5.32-1.62-5.32-1.62-3.32-.65-3.51-3.65-3.51-3.65-1.33-.5-2.47-3.91-2.47-3.91-2.06 1.23-4.63.01-4.63.01s0-.5-2.32 0-1.93-.43-1.93-.43.93-.94-3.18 0 .33-1.23.33-1.23c-1.2.36-5.1.65-5.1.65-1.44.06-2.9.77-4.49 1.23-.99.28-2.68.6-3.53.97-2.28.98-6.85 3.07-10.63 4.55-4.96 1.95-8.9 3.43-8.64 3.37.31-.08 5.4-3.3 11.75-6.18 5.91-2.68 12.7-5.16 16.11-6.13a15.42 15.42 0 0 1 10.13-.02c1 .36 6.49-.17 8.94.12 2.45.3 2.71 4.33 2.71 4.33.47.29.63 4.08.63 4.08s-1.36.04.23.25c1.6.22 4.51 2.53 4.51 2.53 1 0 1.11-.03 1.11-.03s.58-.73 1.38-1.04c.8-.3 1.52-.6 2.42-.67.9-.07 2.16-.08 3.05.02.9.1 1.96.11 3.22.35 1.26.24 1.4.3 1.79.44.4.13.75.05.75.05 1.64-.69 4.68-1.9 5.38-1.76 0 0 1.15-.29 1.77-.77l2.03-1.63s-.98-6.86 5.99-6.19c6.96.68 16.2 1.57 18.05 1.86 1.85.29 8.49 2.18 10.07 2.95 1.6.77 6.15 2.81 8.18 3.7.83.37 3.96 1.76 6.29 2.68a23.21 23.21 0 0 1 6.09 3.67c-2.19-.92-3.95-1.98-5.68-2.73-1.4-.61-2.87-.9-4-1.4-2.42-1.07-4.28-2.05-5.74-2.73-5.4-2.51-5.35-2.61-7.53-2.78-1.51-.12 1.08 1.83 1.08 1.83s-4.94-1.92-6.53-2.59a9.25 9.25 0 0 0-4.4-.86c-1.5.1-2.65-.2-3.53-.48-.88-.3-5.91-.48-6.8-.58-.87-.1-1.58-.29-1.58-.29l.35.58-2.47-.39-.7 1.06s-2.38.48-2.56-.29c-.18-.77-1.41 3.46-2.03 4.7-.62 1.26-3.43.84-4.14 1.61-.7.77-2.2 1.28-2.56 1.47-.35.2-1.42.1-2.04.1-.92 0-.14.02-1.64.3 0 0-1.3 0-1.8-.21-.5-.2-1.6-.52-2.15-.68-.75-.21-4.94-.3-5.53-.27-.6.03-1.61.34-2.27.61-.67.27-1.83.98-1.83 1.15' fill='%23dcddde'/%3E %3Cpath d='M541.33 304.6c-2.68.16-5.32-1.62-5.32-1.62-3.32-.65-3.51-3.65-3.51-3.65-1.33-.5-2.47-3.91-2.47-3.91-2.06 1.23-4.63.01-4.63.01s0-.5-2.32 0-1.93-.43-1.93-.43.93-.94-3.18 0 .33-1.23.33-1.23c-1.2.36-5.1.65-5.1.65-1.44.06-2.9.77-4.49 1.23-.99.28-2.68.6-3.53.97-2.28.98-6.85 3.07-10.63 4.55-4.96 1.95-8.9 3.43-8.64 3.37.31-.08 5.4-3.3 11.75-6.18 5.91-2.68 12.7-5.16 16.11-6.13a15.42 15.42 0 0 1 10.13-.02c1 .36 6.49-.17 8.94.12 2.45.3 2.71 4.33 2.71 4.33.47.29.63 4.08.63 4.08s-1.36.04.23.25c1.6.22 4.51 2.53 4.51 2.53 1 0 1.11-.03 1.11-.03s.58-.73 1.38-1.04c.8-.3 1.52-.6 2.42-.67.9-.07 2.16-.08 3.05.02.9.1 1.96.11 3.22.35 1.26.24 1.4.3 1.79.44.4.13.75.05.75.05 1.64-.69 4.68-1.9 5.38-1.76 0 0 1.15-.29 1.77-.77l2.03-1.63s-.98-6.86 5.99-6.19c6.96.68 16.2 1.57 18.05 1.86 1.85.29 8.49 2.18 10.07 2.95 1.6.77 6.15 2.81 8.18 3.7.83.37 3.96 1.76 6.29 2.68 3.48 1.38 6.09 3.67 6.09 3.67-2.19-.92-3.95-1.98-5.68-2.73-1.4-.61-2.87-.9-4-1.4-2.42-1.07-4.28-2.05-5.74-2.73-5.4-2.51-5.35-2.61-7.53-2.78-1.51-.12 1.08 1.83 1.08 1.83s-4.94-1.92-6.53-2.59a9.26 9.26 0 0 0-4.4-.86c-1.5.1-2.65-.2-3.53-.48-.88-.3-5.91-.48-6.8-.58-.87-.1-1.58-.29-1.58-.29l.35.58-2.47-.39-.7 1.06s-2.38.48-2.56-.29c-.18-.77-1.41 3.46-2.03 4.7-.62 1.26-3.43.84-4.14 1.61-.7.77-2.2 1.28-2.56 1.47-.35.2-1.42.1-2.04.1-.92 0-.14.02-1.64.3 0 0-1.3 0-1.8-.21-.5-.2-1.6-.52-2.15-.68-.75-.21-4.94-.3-5.53-.27-.6.03-1.61.34-2.27.61-.67.27-1.83.98-1.83 1.15' fill='%23e7e7e7' stroke='%23000' stroke-width='.1010988'/%3E %3Cpath d='M541.6 303.8s-.27.22-.35.76c-.07.54-.03.33-.03.33' fill='%23452c25'/%3E %3Cpath d='M555.14 303.02c.36.26.72.53 1.04.85 0 0 .11.1.08.03a.85.85 0 0 0-.17-.22c-.35-.35-.75-.66-1.15-.95-.06-.05.01.07.02.08.05.07.11.15.18.2' fill='%23574f4c'/%3E %3C/g%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 9 6'%3E %3Crect fill='%2321468B' width='9' height='6'/%3E %3Crect fill='%23FFF' width='9' height='4'/%3E %3Crect fill='%23AE1C28' width='9' height='2'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='-2100 -1470 4200 2940'%3E %3Cdefs%3E %3Cpath id='D' fill-rule='evenodd' d='m-31.5 0h33a30 30 0 0 0 30 -30v-10a30 30 0 0 0 -30 -30h-33zm13-13h19a19 19 0 0 0 19 -19v-6a19 19 0 0 0 -19 -19h-19z'/%3E %3Cpath id='E' transform='translate(-31.5)' d='m0 0h63v-13h-51v-18h40v-12h-40v-14h48v-13h-60z'/%3E %3Cpath id='e' d='m-26.25 0h52.5v-12h-40.5v-16h33v-12h-33v-11h39.25v-12h-51.25z'/%3E %3Cg id='G'%3E %3CclipPath id='gcut'%3E %3Cpath d='m-31.5 0v-70h63v70zm31.5-47v12h31.5v-12z'/%3E %3C/clipPath%3E %3Cuse xlink:href='%23O' clip-path='url(%23gcut)'/%3E %3Crect y='-35' x='5' height='10' width='26.5'/%3E %3Crect y='-35' x='21.5' height='35' width='10'/%3E %3C/g%3E %3Cpath id='M' d='m-31.5 0h12v-48l14 48h11l14-48v48h12v-70h-17.5l-14 48-14-48h-17.5z'/%3E %3Cpath id='O' fill-rule='evenodd' d='m0 0a31.5 35 0 0 0 0 -70 31.5 35 0 0 0 0 70m0-13a18.5 22 0 0 0 0 -44 18.5 22 0 0 0 0 44'/%3E %3Cpath id='P' fill-rule='evenodd' d='m-31.5 0h13v-26h28a22 22 0 0 0 0 -44h-40zm13-39h27a9 9 0 0 0 0 -18h-27z'/%3E %3Cg id='R'%3E %3Cuse xlink:href='%23P'/%3E %3Cpath d='m28 0c0-10 0-32-15-32h-19c22 0 22 22 22 32'/%3E %3C/g%3E %3Cpath id='S' d='m-15.75-22c0 7 6.75 10.5 16.75 10.5s14.74-3.25 14.75-7.75c0-14.25-46.75-5.25-46.5-30.25 0.25-21.5 24.75-20.5 33.75-20.5s26 4 25.75 21.25h-15.25c0-7.5-7-10.25-15-10.25-7.75 0-13.25 1.25-13.25 8.5-0.25 11.75 46.25 4 46.25 28.75 0 18.25-18 21.75-31.5 21.75-11.5 0-31.55-4.5-31.5-22z'/%3E %3Cg id='star' fill='%23fff'%3E %3Cg id='c'%3E %3Cpath id='t' transform='rotate(18 0,-1)' d='m0-1v1h0.5'/%3E %3Cuse xlink:href='%23t' transform='scale(-1,1)'/%3E %3C/g%3E %3Cuse xlink:href='%23c' transform='rotate(72)'/%3E %3Cuse xlink:href='%23c' transform='rotate(-72)'/%3E %3Cuse xlink:href='%23c' transform='rotate(144)'/%3E %3Cuse xlink:href='%23c' transform='rotate(216)'/%3E %3C/g%3E %3Cuse id='star1' xlink:href='%23star' transform='scale(31.5)'/%3E %3Cuse id='star2' xlink:href='%23star' transform='scale(26.25)'/%3E %3Cuse id='star3' xlink:href='%23star' transform='scale(21)'/%3E %3Cuse id='star4' xlink:href='%23star' transform='scale(15)'/%3E %3Cuse id='star5' xlink:href='%23star' transform='scale(10.5)'/%3E %3C/defs%3E %3Crect y='-50%25' x='-50%25' height='100%25' fill='%23009b3a' width='100%25'/%3E %3Cpath d='m-1743 0 1743 1113 1743-1113-1743-1113z' fill='%23fedf00'/%3E %3Ccircle r='735' fill='%23002776'/%3E %3CclipPath id='band'%3E %3Ccircle r='735'/%3E %3C/clipPath%3E %3Cpath fill='%23fff' d='m-2205 1470a1785 1785 0 0 1 3570 0h-105a1680 1680 0 1 0 -3360 0z' clip-path='url(%23band)'/%3E %3Cg transform='translate(-420,1470)' fill='%23009b3a'%3E %3Cuse y='-1697.5' xlink:href='%23O' transform='rotate(-7)'/%3E %3Cuse y='-1697.5' xlink:href='%23R' transform='rotate(-4)'/%3E %3Cuse y='-1697.5' xlink:href='%23D' transform='rotate(-1)'/%3E %3Cuse y='-1697.5' xlink:href='%23E' transform='rotate(2)'/%3E %3Cuse y='-1697.5' xlink:href='%23M' transform='rotate(5)'/%3E %3Cuse y='-1697.5' xlink:href='%23e' transform='rotate(9.75)'/%3E %3Cuse y='-1697.5' xlink:href='%23P' transform='rotate(14.5)'/%3E %3Cuse y='-1697.5' xlink:href='%23R' transform='rotate(17.5)'/%3E %3Cuse y='-1697.5' xlink:href='%23O' transform='rotate(20.5)'/%3E %3Cuse y='-1697.5' xlink:href='%23G' transform='rotate(23.5)'/%3E %3Cuse y='-1697.5' xlink:href='%23R' transform='rotate(26.5)'/%3E %3Cuse y='-1697.5' xlink:href='%23E' transform='rotate(29.5)'/%3E %3Cuse y='-1697.5' xlink:href='%23S' transform='rotate(32.5)'/%3E %3Cuse y='-1697.5' xlink:href='%23S' transform='rotate(35.5)'/%3E %3Cuse y='-1697.5' xlink:href='%23O' transform='rotate(38.5)'/%3E %3C/g%3E %3Cuse id='&%23x3B1;CMi' y='-132' x='-600' xlink:href='%23star1'/%3E %3Cuse id='&%23x3B1;CMa' y='177' x='-535' xlink:href='%23star1'/%3E %3Cuse id='&%23x3B2;CMa' y='243' x='-625' xlink:href='%23star2'/%3E %3Cuse id='&%23x3B3;CMa' y='132' x='-463' xlink:href='%23star4'/%3E %3Cuse id='&%23x3B4;CMa' y='250' x='-382' xlink:href='%23star2'/%3E %3Cuse id='&%23x3B5;CMa' y='323' x='-404' xlink:href='%23star3'/%3E %3Cuse id='&%23x3B1;Vir' y='-228' x='228' xlink:href='%23star1'/%3E %3Cuse id='&%23x3B1;Sco' y='258' x='515' xlink:href='%23star1'/%3E %3Cuse id='&%23x3B2;Sco' y='265' x='617' xlink:href='%23star3'/%3E %3Cuse id='&%23x3B5;Sco' y='323' x='545' xlink:href='%23star2'/%3E %3Cuse id='&%23x3B8;Sco' y='477' x='368' xlink:href='%23star2'/%3E %3Cuse id='&%23x3B9;Sco' y='551' x='367' xlink:href='%23star3'/%3E %3Cuse id='&%23x3BA;Sco' y='419' x='441' xlink:href='%23star3'/%3E %3Cuse id='&%23x3BB;Sco' y='382' x='500' xlink:href='%23star2'/%3E %3Cuse id='&%23x3BC;Sco' y='405' x='365' xlink:href='%23star3'/%3E %3Cuse id='&%23x3B1;Hya' y='30' x='-280' xlink:href='%23star2'/%3E %3Cuse id='&%23x3B3;Hya' y='-37' x='200' xlink:href='%23star3'/%3E %3Cuse id='&%23x3B1;Cru' y='330' xlink:href='%23star1'/%3E %3Cuse id='&%23x3B2;Cru' y='184' x='85' xlink:href='%23star2'/%3E %3Cuse id='&%23x3B3;Cru' y='118' xlink:href='%23star2'/%3E %3Cuse id='&%23x3B4;Cru' y='184' x='-74' xlink:href='%23star3'/%3E %3Cuse id='&%23x3B5;Cru' y='235' x='-37' xlink:href='%23star4'/%3E %3Cuse id='&%23x3B1;TrA' y='495' x='220' xlink:href='%23star2'/%3E %3Cuse id='&%23x3B2;TrA' y='430' x='283' xlink:href='%23star3'/%3E %3Cuse id='&%23x3B3;TrA' y='412' x='162' xlink:href='%23star3'/%3E %3Cuse id='&%23x3B1;Car' y='390' x='-295' xlink:href='%23star1'/%3E %3Cuse id='&%23x3C3;Oct' y='575' xlink:href='%23star5'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 600 300'%3E %3Crect width='600' height='300' fill='%2300abc9'/%3E %3Crect width='600' height='100' y='100' fill='%23fae042'/%3E %3Cpath d='M0,0V300L259.8076,150z' fill='%23000'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 900 600'%3E %3Crect width='900' height='600' fill='%23ffd520'/%3E %3Cpath d='M0,600H900V0z' fill='%23ff4e12'/%3E %3Cg stroke='%23000' stroke-width='0.5208'%3E %3Cg fill='%23fff'%3E %3Cpath d='m481.74,187.59c-4.9875-1.7708-8.2083,0.805-8.0458,7.2442,0.15833,6.4392,3.5417,10.142,8.5292,7.7271l-0.48334-14.971z'/%3E %3Cpath d='m486.12,175.53c-4.1542-3.28-8.0292-1.8738-9.9458,4.2758-1.9167,6.1492,0.0958,10.742,5.5958,10.058l4.35-14.333z'/%3E %3Cpath d='m493.04,163.86c-3.5792-3.9046-7.6292-3.1383-10.508,2.6246-2.875,5.7633-1.625,10.618,3.9167,10.825l6.5917-13.45z'/%3E %3Cpath d='m488.5,220.59c-6.1167,2.2538-6.7625,10.625-2.8958,15.776,3.8625,5.1512,10.946,6.1171,14.808,0l-11.91-15.78z'/%3E %3Cpath d='m481.42,202.88c-5.7958-1.9317-11.017,5.8525-11.913,12.878-1.125,8.8538-13.683,11.751-6.7583,25.113,1.4458-8.5317,7.0833-13.2,11.588-13.522,4.5083-0.32208,11.271-1.2879,14.167-6.7613l-7.0833-17.708z'/%3E %3Cpath d='m499.77,237.33c-6.7625,1.6096-7.7292,10.625-2.9,17.064,4.1333,5.5129,17.063,4.1854,16.742-1.2879l-13.842-15.776z'/%3E %3Cpath d='m518.93,291.58c0.32084-5.795-9.0125-8.0488-13.521-6.9221-4.5083,1.1271-13.121-0.16083-15.133-4.9904-1.6083,3.8638,0.72501,8.0492,7.2458,10.142,4.9333,1.5846,4.8292,5.1512,3.3792,6.7613,3.7042,0.64375,14.65,0.64375,18.029-4.9904z'/%3E %3Cpath d='m513.62,254.56c-6.6-2.8975-10.513,1.5158-13.038,5.795-3.7042,6.2783-15.133-1.7704-18.996,6.6004,5.2333-2.2538,10.558,2.5525,13.038,4.1854,7.0833,4.6683,20.767,3.2196,22.7-7.7271l-3.7042-8.8538z'/%3E %3Cpath d='m517.48,262.28c-6.6,4.99-9.175,10.946-9.0125,14.971,0.1625,4.0246,5.7958,12.878,11.913,13.361,3.5417-7.2442,5.3125-22.537-2.9-28.332z'/%3E %3Cpath d='m490.12,293.35c0-2.4146,3.5417-3.3804,5.9542-2.5758,2.4167,0.805,6.1167,3.2196,4.8292,5.7954l-10.783-3.2196z'/%3E %3Cpath d='m453.73,280.15c-0.64167-2.8975,4.025-7.8879,10.304-5.1513,6.275,2.7367,7.0833,8.0492,4.5042,10.142l-14.808-4.9904z'/%3E %3Cpath d='m469.02,285.46c-0.48333-1.61,4.0375-4.8254,11.754-2.8979,7.725,1.9321,9.6208,6.9067,9.3375,10.786l-21.092-7.8879z'/%3E %3Cpath d='m452.93,280.15c4.025-3.0583,2.5-8.855-1.1292-10.625-6.6-3.2196-4.1833-11.59-8.3708-13.2-4.1833-1.61-8.2083-4.5075-8.3708-7.405-2.0917,4.0242-0.80417,7.7271,2.0958,10.303,2.8958,2.5758-2.2542,13.039,1.4458,15.776l14.329,5.1513z'/%3E %3Cpath d='m366.64,277.9c-3.3804-5.3121-11.43-4.3463-14.81-0.64375-3.3804,3.7025-2.8975,9.1758,0.32208,11.59l14.488-10.947z'/%3E %3Cpath d='m385.96,270.01c-1.2879-7.0829-9.82-7.8879-14.488-6.1171-4.6683,1.7708-7.8879,8.8538-4.8292,14.005l19.318-7.8879z'/%3E %3Cpath d='m398.84,269.04c3.0583-5.9563-2.8975-14.81-9.6588-16.098-5.6446-1.0738-12.315-1.0462-14.488-6.6-1.3683,4.8296,2.2542,7.8879,6.4396,10.625,4.185,2.7367-0.80542,9.82,5.9558,13.844l11.752-1.7708z'/%3E %3Cpath d='m398.2,269.25c-1.4088-4.2667,1.4488-9.9434,7.2325-9.5454,5.7842,0.39792,9.08,4.6013,6.53,9.8558l-13.763-0.31041z'/%3E %3Cpath d='m411.07,269.57c-0.79583-4.4221,2.83-9.6404,8.5008-8.435s8.3417,5.83,5.0833,10.675l-13.584-2.2396z'/%3E %3Cpath d='m423.86,271.6c-0.575-4.4575,3.3083-9.4875,8.9125-8.0013,5.6042,1.4871,8.0417,6.2404,4.5417,10.915l-13.454-2.9142z'/%3E %3Cpath d='m326.72,345.35c-10.786,0-13.42,2.5679-14.971,13.683-1.9317,13.844,16.903,15.454,14.971-13.683z'/%3E %3Cpath d='m331.55,330.86c-16.581-6.2783-25.595,19.961-42.015,15.293,5.8754,9.3367,20.118,0.0167,25.434,0.96583,9.015,1.61,28.493-1.7708,16.581-16.259z'/%3E %3Cpath d='m320.76,366.76c-8.21-3.7021-17.064,8.8542-15.454,14.327,2.0438,6.9521,20.766,1.2879,15.454-14.327z'/%3E %3Cpath d='m282.45,420.85c4.5075,1.2833,9.9804,3.8625,9.0146,12.554-0.96583,8.6917-17.385,26.4-32.195,27.367-14.81,0.96667-20.123,18.833-32.84,13.842,11.912-2.25,11.912-15.775,21.249-19.958-6.7612-2.4167-10.303,12.879-18.995,12.879-8.6929,0-12.878,13.842-23.503,12.875-10.625-0.9625-11.743,16.854-33,17.067-16.259,0.15834-36.381,19.154-43.625,10.946,15.776-2.2542,22.142-10.996,31.552-20.608,15.132-15.45,32.196-8.5292,37.991-22.213-6.9225,4.6667-14.971,6.9208-22.859,6.7625-9.9017-0.20417-20.766,15.775-31.874,8.6917,6.4392-0.80416,10.625-3.5417,17.386-10.625,6.9238-7.2542,17.083-2.5667,25.113-9.9792,12.556-11.592,23.342-1.9333,35.415-16.421-3.3808-1.6083-10.625-0.48334-17.386,3.0583-6.7613,3.5417-15.454-2.4167-23.181,1.7708,0.96583-9.4958,18.995-4.0625,30.264-10.625,12.718-7.4042,23.262-5.2333,33.323-4.3458-14.005-0.0792-19.478-13.363-38.795-9.5-8.425,1.6875-15.132-11.588-23.503-4.8292,0.24125-4.9875,9.015-9.0134,18.03-4.1833,9.0146,4.8292,12.648-4.2258,30.586,7.0833,7.405,4.6667,20.122-2.9,28.171,2.0917-1.0462-3.0583-5.6346-4.9917-11.027-4.5875,3.3808-6.9208,25.193-6.0375,34.691,0.8875z'/%3E %3Cpath d='m296.78,410.38c-7.0829-5.4733-16.903,1.1283-23.664-1.4488,0,4.5062,2.2538,11.269,9.6588,13.844,2.2538-1.6083,12.395-10.463,14.005-12.395z'/%3E %3Cpath d='m307.89,394.77c-11.108-5.6342-13.039,8.3708-21.732,5.4733,0.32209,4.0246,3.5417,9.015,10.625,10.142l11.108-15.615z'/%3E %3Cpath d='m314.49,382.05c-16.42-6.4392-18.513,9.3367-28.171,6.2779,2.2538,5.4733,16.098,8.3708,23.181,6.4392l4.9904-12.717z'/%3E %3Cpath d='m337.02,312.99c-4.3467-6.1171-13.522-1.1267-14.971,6.1171-1.4488,7.2442,2.0925,17.386,8.21,15.132l6.7608-21.249z'/%3E %3Cpath d='m348.13,293.67c-7.5658-1.7704-16.259-0.96584-15.293,6.4392-2.8979,1.2879-3.7025,10.786,4.1854,12.878l11.108-19.318z'/%3E %3Cpath d='m353.12,288.68c-7.405-8.6929-15.663-8.4908-20.283-4.8296-8.5321,6.7613-16.823,2.8979-17.064,9.6588,5.1517-3.9438,9.6588,0.805,13.844-0.64375,4.1854-1.4488,7.2442,6.6,18.835,3.2196l4.6683-7.405z'/%3E %3Cpath d='m335.25,418.6c1.1271,2.0917,8.0488,3.0583,11.43-0.48334,4.4804-4.6958-0.48291-17.709-7.5663-18.675-7.0829-0.96583-7.7267,14.65-3.8633,19.158z'/%3E %3Cpath d='m327.2,418.92c10.141,3.7,14.488-4.6708,9.0146-9.9813-1.4488,1.7708-6.7613,8.2104-9.0146,9.9813z'/%3E %3Cpath d='m289.21,432.76c-1.9321,5.7958-11.913,6.7625-23.181,24.792-11.269,18.029-22.054,10.463-24.791,22.858,13.522-10.946,24.142-3.675,32.195-14.488,12.235-16.421,22.309-14.063,27.045-25.113,6.7608-15.775,36.381-15.454,37.991-40.244-9.9808-1.9321-41.533,24.79-49.259,32.194z'/%3E %3Cpath d='m543.24,189.36c12.879,4.1854,13.2,20.927,28.008,26.4,14.813,5.4733,16.263,18.673,28.333,15.454-11.267-3.0588-10.463-16.098-22.213-19.318-13.783-3.7758-18.996-24.791-29.946-28.01'/%3E %3Cpath d='m602.32,276.77c2.2542,5.1512,1.9333,14.327-6.1167,16.742,4.3458,2.7367,10.783,0.16084,14.325-5.795-5.3125,11.751-1.7708,22.376,6.6,24.469-4.025-8.21,4.9917-12.074,2.0958-17.386,5.3125,2.2538,9.9792,9.4979,9.8167,14.005,6.925-7.7271-5.15-18.03-2.8958-25.273l-23.825-6.7613z'/%3E %3Cpath d='m518.93,359.51c-7.8875-6.9221-11.254,1.8096-15.133-1.2075-3.6208-2.8171-8.45-3.2196-10.3-0.4025,6.7625,0.24167,3.4583,5.4733,16.579,6.7613-13.121,0.88541-10.704,15.535-19.479,14.81,9.3375,8.8538,14.167-7.8879,21.733-5.1512-2.2542,0.64375,3.5417,5.9562-0.48333,13.039,6.5208-0.16084,9.175-9.1758,9.9833-13.844l-2.9-14.005z'/%3E %3Cpath d='m345.23,434.69c-2.8979-2.4125-11.269-3.5417-14.488-1.6083-3.2192,1.9292-2.0925,2.4125,1.7708,2.7375,3.8638,0.32084,8.8525,6.5708,0.48291,6.9208-3.8633,0.15834-2.5754,9.4958-10.625,10.142,3.3,4.025,12.718,1.3667,16.098-3.0583-0.64375,3.6208,4.1854,6.9208,2.2538,11.267,5.9562,0.64584,2.495-12.071,11.913-11.429-3.8638,0.48334-2.2538,9.175,4.5071,6.9208-4.0242,1.9333-1.9317,6.6,2.5758,5.475-2.8975,0.96667-3.8638,4.6667,0.16084,6.7625,3.8638-5.3125-0.48292-24.308-14.649-34.129z'/%3E %3Cpath d='m695.85,257.07c12.321,0,22.308-9.9896,22.308-22.312,0-12.32-9.9875-22.31-22.308-22.31-12.325,0-22.313,9.99-22.313,22.31,0,12.322,9.9875,22.312,22.313,22.312z'/%3E %3Cpath d='m579.3,284.02c6.7625-6.4392,17.067-9.6588,24.146-4.8296,7.0833,4.8296,30.588,10.625,42.179,2.5758,11.588-8.0492,17.063-12.235,22.213-11.269,3.8667,5.7954,8.5334,8.5321,14.329,9.015,1.7708,1.9317,8.05,3.5417,11.592,3.0583,5.15,1.2879,11.429-0.32166,16.417-5.795,7.7292,1.1267,14.971-4.6683,17.708-13.361,8.2083-0.96583,8.6917-10.142,3.5417-16.259-4.8292-0.96584-1.125-17.225-18.675-14.005,7.4083,4.5071,1.7708,13.522,7.8917,17.708-4.1875,0-9.5792,1.7708-10.867,8.0488,1.6083-4.3462-0.24167-7.2438-1.3708-8.2096,0.1625-3.7025-8.0458-12.798-15.775-9.4979,5.5542,1.2075,2.4167,10.142,6.4417,13.522-2.9,0.16125-5.9583,1.61-7.7292,4.1854-2.0917-3.7025-9.4958-7.5658-14.004-7.8879,0-1.2879-0.24166-3.8633-0.80416-5.1512-2.0125-3.8633-3.7042-8.4508-2.9-14.327-3.8625,4.1854-7.0833,9.9808-9.0125,14.166-6.1167-4.1854-21.25,1.9317-28.333,3.5412-7.0833,1.61-30.908-2.2533-36.383-8.0488-5.4708-5.795-16.096-9.3367-26.075-12.234-13.725-3.9833-13.846-18.995-28.979-29.298-0.32083,18.674,28.013,77.914,34.45,84.353z'/%3E %3Cpath d='m421.54,426.32c11.913,0,21.571-9.6583,21.571-21.571s-9.6583-21.57-21.571-21.57-21.571,9.6575-21.571,21.57c0,11.913,9.6575,21.571,21.571,21.571z'/%3E %3Cpath d='m370.02,409.74c4.3462,5.6346,11.751,5.3138,14.81,4.8304,2.5758,6.7583,10.785,6.6,14.327,10.3,3.5417,3.7042,15.613,3.3833,19.155,1.2875-3.2167-0.32083-7.4033-2.25-11.428-5.6333-4.8579-4.0792-2.5758-12.234-6.4392-15.131,2.8975-3.2196,3.3804-8.5317,2.7367-10.625,3.0588-1.7708,5.3121-4.6683,5.6342-6.1171,5.3129-0.32208,9.9796-3.0588,11.913-5.1512,2.7375,2.5754,9.6583-0.805,13.363,3.5412,0.80417-10.625-9.3375-16.259-16.1-12.717-2.7375-1.4488-9.9804-0.48292-11.268,1.4488-2.2538-0.96584-8.5321,2.2538-11.43,4.3462,3.2196-1.7704,3.7025-7.0829,2.4146-9.0146,2.7367-1.1267,5.7954-4.8292,6.1171-7.5658,3.8638,0.64375,9.6575-1.9321,12.233-1.2879-4.1833-5.4733-11.105-7.405-18.189-6.9221-7.325,0.40292-10.463,5.5542-11.429,11.108-4.3467,2.5754-5.7954,11.268-4.1854,14.327-2.4958-0.08-4.8296,2.3346-5.7954,3.7025-3.3804-1.4488-8.21-2.4946-11.671-2.4946'/%3E %3Cpath d='m366.32,373.2c-1.4488-4.1854,0.47-7.9533,1.4488-11.268,2.495-8.4508,0.96584-10.625-6.6-9.4975-0.64375,4.0242,3.2196,17.225,5.1513,20.766z'/%3E %3Cpath d='m360.77,352.91c1.9317,1.9317,8.7738,2.8175,9.4979-3.2996,0.83167-7.0225-2.0121-9.74-8.1292-7.0033-0.48292,1.61-1.0471,8.21-1.3688,10.303z'/%3E %3Cpath d='m362.22,342.37c2.5758,1.0458,8.13,3.1388,11.188-2.8175,2.5658-4.9954-0.80458-8.8538-6.1167-8.5321-1.2883,1.4488-3.8638,6.6004-5.0717,11.35z'/%3E %3Cpath d='m366.97,330.54c0.64375,1.9317,7.2442,8.3708,12.073,3.7025,4.8296-4.6683,4.8296-11.59-2.4146-14.166-1.9321,0.32166-7.7271,7.0829-9.6588,10.463z'/%3E %3Cpath d='m376.62,320.08c1.4488,4.0242,5.9558,10.946,14.327,7.7267,8.3713-3.2196,4.8296-13.683,0.96625-15.776-2.2538,0.16125-11.43,4.3467-15.293,8.0492z'/%3E %3Cpath d='m391.92,312.03c-0.64417,3.5417,0,13.2,11.429,13.039,11.428-0.16083,8.2113-13.522,5.3125-15.454-4.6683,0-12.556,0.16083-16.742,2.4146z'/%3E %3Cpath d='m409.14,310.09c-1.2879,2.7367-4.1896,20.75,18.191,15.776,2.8958-0.64375,10.463-17.225-18.191-15.776z'/%3E %3Cpath d='m421.37,311.7c-2.25,2.2533,3.5417,20.444,18.675,17.385,15.133-3.0588,2.4167-20.283-18.675-17.385z'/%3E %3Cpath d='m434.25,314.44c-2.4125,4.9904,1.2125,19.8,19.883,19.8,16.921,0-0.8875-19.478-19.883-19.8z'/%3E %3Cpath d='m448.9,318.79c-1.2125,2.7662-2.6958,18.468,19.317,19.8,15.938,0.96583,12.075-21.571-19.317-19.8z'/%3E %3Cpath d='m472.57,325.39c-2.7333,4.8296-5.6333,16.903,18.513,17.869,15.471,0.61917,5.9583-17.547-18.513-17.869z'/%3E %3Cpath d='m492.69,329.09c-3.5417,4.8296-0.93333,14.303,8.0458,16.098,11.271,2.2538,12.879-8.3708,5.1542-13.522-7.7292-5.1513-13.2-2.5758-13.2-2.5758z'/%3E %3Cpath d='m503.64,331.34c-2.575,4.5075-0.97917,15.454,16.096,15.454,3.5417,0,17.067-13.844-16.096-15.454z'/%3E %3Cpath d='m371.48,541.27c13.83,0,25.042-11.213,25.042-25.042,0-13.833-11.212-25.046-25.042-25.046-13.831,0-25.043,11.213-25.043,25.046,0,13.829,11.212,25.042,25.043,25.042z'/%3E %3Cpath d='m555.15,177.13c-1.9333,1.9317-5.9542,7.7267-6.7625,9.9804-8.3708,25.113,13.975,43.871,27.046,70.83,10.304,21.249,9.0167,54.733-7.0833,75.982-5.5083,7.2683-3.8625,9.3367-10.946,16.742-2.7167,2.8408-5.7958,6.4392-4.8292,16.742,4.5083-1.61,10.946,2.5758,12.233,6.1171,3.2208-1.6096,7.7292-0.96584,9.3375,0.96583,5.4708-2.5754,9.9792-1.2879,14.808,3.8638,4.1875-0.64416,8.6958,0,12.879,4.5071,2.2542-4.5071,6.7625-6.1171,9.9792-5.1512-0.32083-5.795,5.475-9.9804,10.625-7.7267-1.6083-7.7271,5.475-13.523,12.238-11.269,5.7917-4.5075,17.383-4.8292,23.179,1.9317-10.304-2.8975-9.9792,8.0492-18.675,7.0833,2.2542,6.4392-3.5417,10.142-9.3334,12.234,3.7-1.7708,7.725-3.8633,9.0125-1.6096,3.2208-2.8167,9.6584-1.7708,11.271-0.32208,4.2625-1.3679,8.3708-0.32208,10.3,4.8292,5.7958,3.5417,9.6583,12.556,5.475,19.318-1.2875-7.0829-6.1167-6.7613-8.05-9.6588-4.5083,1.61-9.0167,1.61-10.304-1.2879-2.575,2.5758-11.267,4.8296-15.129,0.96584-1.45,5.7954-6.4417,10.625-12.238,10.625,1.6125,4.5071-2.8958,12.236-6.4375,16.098,5.475,2.8958,3.8625,9.3375,2.575,13.2,8.3708,1.2875,1.2875,8.6917,15.775,13.521-7.0792,2.2542-20.925,0-22.858-8.6917-7.0833-0.32083-11.913-7.4042-11.588-14.813-5.475-5.15-6.2792-12.554,1.2875-17.705-6.4417,1.9317-9.9834-8.3708-19.321-4.1854-4.6417,2.0825-16.9-1.4488-16.738-5.7954-1.9333,3.2196-13.683,1.9321-15.296-3.5412-3.8625,2.0925-12.879-1.4488-12.717-6.7613-4.9917,2.2538-11.75-1.7708-11.429-6.9221-4.6667-0.64375-5.15-4.8292-4.8292-8.3708-4.1875-1.9317-3.0583-5.9563-1.45-10.785-2.8958-3.2196-1.6083-7.7271,0.64583-11.913-3.2208-3.2196-2.575-7.0829-1.6125-11.59-15.454-1.2879-34.813-5.015-79.2-18.673-66.967-20.605-84.997,27.688-70.187,57.952,17.087,34.919-1.9317,42.5,3.8638,68.579,6.1171,1.2875,9.3367,6.4375,9.015,11.913,3.6208,0.15834,6.1967,3.5375,4.9088,9.9792,3.0588-0.5625,7.0034,0.32083,9.5788,2.8958,2.2538-4.1833,9.6588-5.15,13.523-0.32084,8.3688-0.64583,12.556,6.1167,12.235,14.488,4.5042,8.05,2.8958,17.871-1.9333,24.146,0.48334-3.3792,0-8.2084-0.15833-11.104-0.3-5.3292-7.7292-6.4417-6.9242-10.788-3.8633,0.32083-7.5663-1.7708-8.8538-4.6667-2.2538,1.9292-5.4733,2.575-8.21,1.6083,4.3462,1.9333,7.7271,9.6583,6.4392,14.808,2.2538,3.8667,1.7708,10.95-0.96583,14.008-1.2879,6.275-6.1171,8.5292-12.395,5.7917,3.5417-2.25,4.8292-6.275,4.6683-9.6583-2.2538-1.9292-3.3804-5.6333-3.5417-7.8875-6.2779,0.96667-14.971-4.3458-16.574-6.4458-13.831,0-25.043,11.213-25.043,25.046-0.64375-5.1542-7.1588-10.229-6.3542-14.575-3.8633-11.913,1.61-23.021,17.386-25.271-1.9317-4.5083,4.8292-9.1792,2.2538-14.329-3.2904-6.5792-9.3367-15.133-18.351-25.113,5.4733-9.3375,3.8633-21.892,0.64375-29.62-4.6233-11.096-9.015-8.3708-25.435,9.6579-26.76,29.383-62.46,21.25-94.012,40.567-8.3838,5.1333-16.741,7.0833-7.7267-1.9292,9.015-9.0167,32.84-18.029,48.293-25.758,28.94-14.471,53.445-38.635,63.104-85.64,22.697-110.46,106.24-74.05,159.04-53.445,49.571,19.346,40.567-24.469,15.454-50.869-30.183-31.732-24.146-56.664-9.9792-76.626,25.433-3.5412,74.213,5.3125,64.392,13.845z'/%3E %3Cpath d='m644.82,448.48c15.217,0,27.554-12.333,27.554-27.55,0-15.218-12.338-27.554-27.554-27.554-15.217,0-27.554,12.336-27.554,27.554,0,15.217,12.338,27.55,27.554,27.55z'/%3E %3C/g%3E %3Cg fill='none'%3E %3Cpath d='m539.7,178.41c-6.1167,27.045-0.96667,39.279,8.05,51.191,18.629,24.621,33.483,80.811,12.233,117.51'/%3E %3Cg stroke-linecap='round'%3E %3Cpath d='m571.89,315.41c2.575-0.96583,7.4042-4.0242,8.5333-9.3367'/%3E %3Cpath d='m573.82,303.66c0.80417-4.6683,8.0458-6.68,8.2083-11.67'/%3E %3Cpath d='m573.98,285.46c-0.48334-4.8296,7.2458-9.1758,6.1167-14.005'/%3E %3Cpath d='m569.8,268.08c-0.64584-2.7367,6.4375-7.8879,4.5083-12.234'/%3E %3Cpath d='m564.49,251.18c-1.45-3.0588,3.3792-6.6004,1.2875-9.82'/%3E %3Cpath d='m556.76,237.65c-0.48334-2.0925,2.4958-6.68,0.8875-9.4163'/%3E %3Cpath d='m549.03,221.72c0.64167-0.805,3.2208-2.7367,2.1708-5.1513'/%3E %3Cpath d='m543.72,210.05c1.0458-0.56375,4.1833-1.53,3.7833-3.8633'/%3E %3Cpath stroke-linejoin='round' d='m382.58,513.57c-6.4392-2.2542-14.488,0.96667-16.098,6.4417'/%3E %3Cpath stroke-linejoin='round' d='m371.31,525c0.805-5.4708,9.1758-7.8875,11.751-5.3125-5.3121-2.8958-7.8879,7.4042-3.2196,7.7292'/%3E %3Cpath stroke-linejoin='round' d='m423.15,397.67c-3.8625,1.9321-4.9875,9.015,0,14.329'/%3E %3Cpath stroke-linejoin='round' d='m428.94,399.28c-2.7333,2.2538-2.575,9.0146,1.45,10.625-3.3792-2.4146,0-6.6,2.4167-6.7612,2.4125-0.16084,4.0208,2.7367,1.125,5.6342'/%3E %3Cpath stroke-linejoin='round' d='m655.12,415.21c-9.0125-2.4125-16.258,8.05-8.05,17.388-0.15833-9.0167,6.2792-14.971,14.167-13.363'/%3E %3Cpath stroke-linejoin='round' d='m657.61,425.47c-2.2167,0-3.4625,1.7333-3.4625,3.4208,0,1.7708,1.5292,3.4625,4.025,3.4625,1.6125,0,2.9-1.85,2.9-3.3'/%3E %3Cpath stroke-linejoin='round' d='m689.4,227.83c1.45,5.4733,9.0167,7.7271,14.971,6.4392'/%3E %3Cpath stroke-linejoin='round' d='m704.37,230.73c-4.6667,0.16125-8.5292-4.1854-8.2083-7.8879,0,2.7367,6.2792,4.0246,8.2083,2.2538'/%3E %3Cpath d='m384.83,414.57c-1.2875-3.2208,3.8638-6.4404,4.0246-9.4992,0.16125-3.0583,5.795-5.4729,11.59,0.32209'/%3E %3Cpath d='m397.71,371.11c-1.1267,0.48292-2.0929,1.1267-3.0588,1.4488'/%3E %3Cpath d='m408.82,388.65c-1.3688,0.0813-4.1854-0.08-5.715-1.1271'/%3E %3Cpath d='m403.19,394.77c-1.1267,0.56417-3.6229,1.53-5.0717,1.8521'/%3E %3Cpath d='m347.97,492c-0.16125,2.9,2.7367,7.0833,4.3462,8.3708'/%3E %3Cpath d='m360.53,485.08c-1.61,2.4125-2.5754,6.6-1.61,9.4958'/%3E %3Cpath d='m384.51,494.74c-2.8979-1.9333-0.96583-6.925-1.2879-10.142-0.32208-3.2208,3.3808-8.3708,10.625-4.025'/%3E %3Cpath d='m357.47,476.39c2.8979-0.48333,5.9563-0.325,7.8879,0.47917'/%3E %3Cpath d='m394.17,467.21c-1.2875,1.7708-1.6096,3.7042-1.7704,4.9917'/%3E %3Cpath d='m407.69,466.89c-2.2538,0-4.1854,1.6083-5.1513,3.2208'/%3E %3Cpath d='m376.46,384.47c2.5758,0.88584,9.2558,4.9904,9.4979,9.2567'/%3E %3Cpath d='m403.83,363.54c-7.8875-0.16125-10.946-8.21-4.99-8.21'/%3E %3Cpath d='m418,374.32c-3.0583,1.2879-1.6083,6.6,2.7375,9.1758'/%3E %3Cpath d='m399.16,424.87c-1.5296-1.9292,0.48291-7.5625,5.4733-5.875'/%3E %3Cpath d='m410.91,483.63c0.32-4.9083,6.52-7.8083,9.0158-2.2542'/%3E %3Cpath d='m388.05,497.63c-0.40292-5.3917,2.3338-7.1625,4.7483-7.4833,2.4146-0.32084,5.8767,1.6875,7.4863,5.2292'/%3E %3Cpath d='m340.08,501.66c0.32208-3.2208,3.0588-6.6,5.9562-6.1167'/%3E %3Cpath d='m634.67,358.71c-2.0958,1.53-3.4625,8.3708,4.5042,9.015'/%3E %3Cpath d='m622.44,369.98c0,0.80459,1.0458,1.9317,1.6917,2.4146'/%3E %3Cpath d='m660.43,382.86c-2.0917-1.6096-7.4875,4.9104-2.575,9.6588'/%3E %3Cpath d='m609.24,436.95c-1.2083-4.5875,3.0583-5.7958,7.0833-4.8292'/%3E %3Cpath d='m598.94,404.43c2.4125-1.6096,4.8292-3.3804,7.8875-4.1854'/%3E %3Cpath d='m597.65,422.13c0-3.8625,1.9292-7.0792,3.7-8.0458'/%3E %3Cpath d='m611.81,377.71c-0.32083,4.6683,1.6125,9.1758,3.0625,11.59'/%3E %3Cpath d='m650.13,378.03c-2.3375,0.725-4.4292,1.6096-5.3125,3.5417'/%3E %3Cpath d='m647.55,391.23c1.1292-0.96583,2.4167-2.0925,2.9792-2.8975'/%3E %3Cpath d='m708.4,250.69c0,4.5071-5.6333,6.9217-9.3333,4.0242'/%3E %3Cpath d='m720.64,250.85c2.4917,1.9317,11.104,0.0812,9.0917-4.9092'/%3E %3Cpath d='m710.17,276.77c-1.7708-0.32209-4.8292-2.2538-6.1167-3.8633'/%3E %3Cpath d='m727.88,263.41c-2.8958,0.64375-4.8292,0-6.2792-0.64375'/%3E %3Cpath d='m682.16,279.51c1.6083,0,5.4708-0.64417,8.1292-2.0117'/%3E %3Cpath d='m677.33,251.02c-2.0917-0.24083-3.625,0.16125-4.8292,0.96584'/%3E %3Cpath d='m709.77,258.9c-0.5625,2.0129-2.0125,5.1512-3.7833,6.5204'/%3E %3Cpath stroke-linejoin='round' d='m671.86,265.99c4.025-1.7708,9.0167,11.912,18.675,7.0829'/%3E %3Cpath stroke-linejoin='round' d='m691.34,258.9c-1.2875,1.7708-2.0917,4.5075-2.2542,6.9221'/%3E %3C/g%3E %3Cpath d='m498.81,237.98c1.2875-0.16083,3.5417-0.64375,4.025-2.2538'/%3E %3Cpath d='m333.16,387.85c4.8296,2.7367,8.2104,7.405,6.1175,14.327'/%3E %3Cpath d='m554.5,223.17c1.45,0.96583,6.925,0.96583,9.9833-0.16083'/%3E %3Cpath d='m568.35,226.39c-0.1625,2.2538,0.48333,10.785-3.8625,12.556'/%3E %3Cpath d='m566.1,237.82c4.025,1.2879,12.075,0.80459,14.65-6.6'/%3E %3Cpath d='m575.11,237.49c2.0917,3.2196,2.7333,9.4979-3.5417,12.878'/%3E %3Cpath d='m576.72,242.81c4.6667,1.6096,15.454,1.7704,14.325-7.405'/%3E %3Cpath d='m587.35,242.81c3.2208,4.5071,17.388,9.8196,15.133,0.48292'/%3E %3Cpath d='m574.31,255.84c5.4708,1.2879,13.2-2.415,9.9792-12.073'/%3E %3Cpath d='m599.74,248.6c0.80416,3.7025,18.833,7.5658,16.421-0.805'/%3E %3Cpath d='m612.78,252.63c3.3833,7.7267,21.25,7.0829,15.617-3.2196'/%3E %3Cpath d='m625.5,257.45c3.5417,4.3467,19.321,1.7708,13.042-8.6929'/%3E %3Cpath d='m638.37,257.29c9.8208,7.405,21.25-3.2196,8.8542-10.947'/%3E %3Cpath d='m652.86,254.88c8.6958,6.9221,19.321-5.6346,11.754-9.1758'/%3E %3Cpath d='m584.12,251.98c2.7375,0.805,8.5333,0.48292,9.8208-4.5071'/%3E %3Cpath d='m591.77,250.85c-0.32083,7.325,11.996,10.142,15.133,1.6908'/%3E %3Cpath d='m602.8,257.13c2.2542,4.8292,13.038,6.7608,14.808-0.16125'/%3E %3Cpath d='m615.84,260.19c1.7708,4.8296,11.108,4.3467,13.683-0.64375'/%3E %3Cpath d='m626.14,262.77c2.8958,6.2779,14.808,6.2779,17.546-2.8979'/%3E %3Cpath d='m641.6,263.89c4.6667,2.8979,14.65,1.7708,13.842-7.2438'/%3E %3Cpath d='m653.51,263.09c6.9208,5.6346,16.742,0.16125,11.913-9.3367'/%3E %3Cpath d='m664.94,270.49c3.7042-0.64375,5.6333-8.0488,1.7708-9.9804'/%3E %3Cpath d='m579.14,271.78c7.725-4.1854,9.175-11.268,3.8625-18.19'/%3E %3Cpath d='m585.74,264.7c4.8292,2.8975,14.004-0.16083,15.613-7.2442'/%3E %3Cpath d='m592.34,265.5c2.7333,3.5413,3.2167,7.8879-0.325,11.912'/%3E %3Cpath d='m594.59,270.01c8.5292-5.3121,19.154,4.5075,11.267,10.464'/%3E %3Cpath d='m604.41,269.53c1.9333-0.48291,5.3125-4.0242,5.6333-8.0488'/%3E %3Cpath d='m608.27,273.23c3.5417-3.7025,27.692,3.8638,12.396,11.59'/%3E %3Cpath d='m619.54,263.09c4.6667,1.7708,7.0833,8.3713,0,10.625'/%3E %3Cpath d='m625.66,279.19c5.15-5.3121,21.25-1.9317,15.454,4.8296'/%3E %3Cpath d='m637.25,277.09c2.8958-9.82,20.121-3.7025,14.488,0.32167'/%3E %3Cpath d='m633.71,267.27c0.48333,1.9321,0.64166,6.7613-2.575,9.3371'/%3E %3Cpath d='m648.2,265.34c0.64167,1.61,0.48334,4.6683-0.96667,6.6004'/%3E %3Cpath d='m659.14,265.5c0.96666,1.7704,2.575,5.1513-0.96667,7.8879'/%3E %3Cpath d='m521.35,191.45c0.15833,9.1754,3.3792,15.293,15.775,9.4975'/%3E %3Cpath d='m525.21,202.4c-6.1167,8.21,0.80417,17.064,12.879,8.21'/%3E %3Cpath d='m506.37,206.42c8.3708,9.0146,23.342,2.4146,13.683-11.269'/%3E %3Cpath d='m530.2,214.15c-1.6125,8.8538,5.6333,10.625,11.588,6.6'/%3E %3Cpath d='m498.97,207.87c1.525,8.9013,10.625,15.937,19.479,10.464'/%3E %3Cpath d='m509.92,220.11c0,12.718,17.546,14.166,21.571,0.96625'/%3E %3Cpath d='m525.21,229.12c5.6333,11.59,17.867,6.9221,21.892-0.16084'/%3E %3Cpath d='m512.81,210.61c2.2542,5.6342,6.7625,11.913,17.225,7.2442'/%3E %3Cpath d='m480.62,207.87c1.45,4.6683,9.8208,10.303,19.479,3.8633'/%3E %3Cpath d='m486.57,213.83c-5.1542,7.5658,5.15,14.649,17.546,3.3804'/%3E %3Cpath d='m492.69,223.17c2.0917,10.625,6.275,19.157,21.408,5.4733'/%3E %3Cpath d='m506.53,234.11c5.475,6.7608,13.846,10.946,21.733-0.48292'/%3E %3Cpath d='m534.06,236.04c-0.48333,8.0488,1.125,12.073,7.4042,11.751,4.95-0.25334,9.6584-4.1854,12.396-8.3708'/%3E %3Cpath d='m540.34,247.8c-0.1625,9.1758,7.0792,16.42,20.604,7.0833'/%3E %3Cpath d='m545.97,258.58c-2.575,6.9221,5.15,18.19,20.283,12.395'/%3E %3Cpath d='m513.94,240.23c-0.9625,8.8538,7.2458,14.81,20.446,3.3804'/%3E %3Cpath d='m520.38,250.05c0.48334,7.2442,8.6917,15.937,20.767,3.3804'/%3E %3Cpath d='m526.17,259.23c-0.96667,12.395,10.463,15.937,20.121,6.4392'/%3E %3Cpath d='m508.95,250.05c2.575,0.16125,4.6667-2.0925,5.9542-3.7025'/%3E %3Cpath d='m514.42,259.06c2.2542,0.48292,6.1208-1.61,7.4083-4.1854'/%3E %3Cpath d='m520.06,273.71c2.575,2.7367,11.267,0.805,12.392-2.8975'/%3E %3Cpath d='m529.72,273.55c4.8292,11.268,17.704,10.785,23.017-1.9317'/%3E %3Cpath d='m550.32,276.13c2.4125,6.6,8.5333,10.785,18.513,8.5317'/%3E %3Cpath d='m555.15,282.89c-5.6333,9.1758,1.7708,19.961,14.325,9.3367'/%3E %3Cpath d='m558.21,296.57c-0.64167,5.795,4.6708,12.395,11.913,13.2'/%3E %3Cpath d='m534.38,279.67c-1.9333,13.039,7.4042,19.318,19.158,12.395'/%3E %3Cpath d='m520.7,285.95c3.0583,2.4146,8.5333,2.7367,13.683,0.805'/%3E %3Cpath d='m540.66,294.32c-2.9,10.947,8.3708,18.835,18.029,6.6'/%3E %3Cpath d='m525.05,287.72c0.1625,5.6342,5.6375,11.751,15.133,9.9804'/%3E %3Cpath d='m566.74,308.97c-6.4417,4.3462-7.7292,12.073,1.2875,17.063'/%3E %3Cpath d='m550.96,306.71c0.325,6.6,3.3833,10.303,10.625,10.946'/%3E %3Cpath d='m541.47,303.33c-9.6583,8.8542-0.1625,19.157,11.267,10.464'/%3E %3Cpath d='m548.23,316.53c-3.2208,10.142,8.8542,16.259,15.292,5.9562'/%3E %3Cpath d='m528.27,294.96c-3.5417,9.9808,0.96667,16.581,9.175,15.937'/%3E %3Cpath d='m515.55,293.03c0.48334,5.9562,5.6333,8.0488,11.429,6.7612'/%3E %3Cpath d='m519.25,299.31c-4.3458,8.3708,2.2542,12.878,10.95,9.6588'/%3E %3Cpath d='m556.6,327.64c-1.45,5.3121-0.64583,9.1758,7.2417,10.947'/%3E %3Cpath d='m557.08,335.21c-9.5,4.3467-10.304,13.523-2.9,19.478'/%3E %3Cpath d='m549.43,324.99c-4.9875,4.5075-4.025,12.314,1.45,15.373'/%3E %3Cpath d='m507.18,295.61c-5.475,5.3933-0.24167,20.283,11.829,12.155'/%3E %3Cpath d='m538.57,314.44c-7.4083,6.1175-4.025,17.225,8.2083,14.166'/%3E %3Cpath d='m526.33,309.77c-3.8625,10.947-0.15834,14.81,8.5333,14.971'/%3E %3Cpath d='m499.13,295.12c-6.6,4.99-4.8292,12.073-1.9292,15.293,2.8958,3.2196,8.3667,1.7708,10.138-2.4146'/%3E %3Cpath d='m485.28,290.78c-7.4042,9.4979,0,20.766,10.467,17.386'/%3E %3Cpath d='m524.89,318.95c-7.5667,2.7367-13.338,9.6071-8.6958,15.615,2.7375,3.5417,14.65,4.0246,18.029-9.6588'/%3E %3Cpath d='m511.2,310.09c-4.3458,6.2783-2.9,12.235,5.15,15.293'/%3E %3Cpath d='m510.72,321.85c-4.6708,2.5758-7.7292,5.6346-6.6,11.269'/%3E %3Cpath d='m500.26,312.03c-1.7708,7.5663,0.32083,12.235,4.9875,14.488'/%3E %3Cpath d='m500.1,321.04c-7.2458-0.48292-10.946,2.5754-8.5333,9.6588'/%3E %3Cpath d='m492.21,322.81c-7.0833-2.5758-8.2125-8.6929-5.1542-15.132'/%3E %3Cpath d='m486.09,317.18c-7.7292,0.32208-11.108,4.1854-11.108,9.4979'/%3E %3Cpath d='m475.62,287.07c-5.6333,2.4146-7.4042,9.9808-5.3125,14.166,2.0958,4.1854,8.6958,4.5075,12.721,1.7708'/%3E %3Cpath d='m459.85,281.12c-5.15,5.7954,0.80417,17.064,9.9834,14.327'/%3E %3Cpath d='m446.65,276.61c-4.8292,6.7608,0.48333,18.03,12.879,14.81'/%3E %3Cpath d='m460.17,322.81c-1.2875-8.0492,7.0833-13.361,17.388-2.8979'/%3E %3Cpath d='m472.57,303.66c-3.0583,2.7367-4.5042,7.0829-4.025,10.625'/%3E %3Cpath d='m433.45,272.75c-5.3125,9.015,1.1292,17.225,12.558,14.005'/%3E %3Cpath d='m463.23,295.12c-7.5667,7.5658-4.9917,15.132,0.64167,19.478'/%3E %3Cpath d='m458.4,303.98c-11.429,0.16084-12.071,13.361-2.7333,17.547'/%3E %3Cpath d='m449.71,290.78c-4.6667,3.2196-6.1167,12.073,1.9333,15.615'/%3E %3Cpath d='m449.39,310.58c-4.8292-2.2538-10.625,0.48292-10.142,6.1171'/%3E %3Cpath d='m442.14,310.74c-4.3458-10.303-17.063-8.5317-15.933,2.0929'/%3E %3Cpath d='m445.68,298.02c-2.7333,0.48291-8.2083,2.0925-10.3,6.2783'/%3E %3Cpath d='m436.19,286.43c-5.15,5.795-1.1292,12.717,3.0583,14.166'/%3E %3Cpath d='m420.9,270.17c-0.96667,6.9221,1.7708,10.303,10.463,9.6588'/%3E %3Cpath d='m423.95,279.03c-3.3833,8.3708,1.125,12.073,9.8167,11.59'/%3E %3Cpath d='m425.88,289.33c-5.15,6.1171-1.6083,12.718,3.3792,15.454'/%3E %3Cpath d='m423.47,297.06c-9.175-1.1271-10.625,9.4975-7.5667,14.488'/%3E %3Cpath d='m416.06,269.37c-5.6321,2.4146-8.8517,9.4975-5.7933,13.844,3.06,4.3463,9.1767,2.8975,12.556,0.64375'/%3E %3Cpath d='m412.2,285.14c-4.6675,7.0829-0.48333,12.395,4.5083,14.488'/%3E %3Cpath d='m394.17,268.56c-3.7021,3.8633-1.4488,11.752,7.5663,11.913,7.2579,0.13,10.946-6.7612,8.6929-11.59'/%3E %3Cpath d='m400.45,280.47c-2.8975,6.4392-1.1267,13.361,9.8196,12.234'/%3E %3Cpath d='m414.94,302.85c-6.7608-3.0583-15.776,0-11.912,8.0492'/%3E %3Cpath d='m402.06,291.42c-2.7367,3.8633-1.7708,9.3367,1.2875,12.717'/%3E %3Cpath d='m401.58,301.72c-4.5075,0.805-8.8542,3.2196-6.1175,10.303'/%3E %3Cpath d='m394.81,306.23c-5.795-1.7708-13.2,2.4146-8.6929,8.3708'/%3E %3Cpath d='m385.16,308.97c-4.9904-0.80501-10.946,4.5071-6.1171,9.8196'/%3E %3Cpath d='m377.11,314.44c-4.5075,1.1271-9.8196,6.2783-5.1517,10.303'/%3E %3Cpath d='m399.81,289.17c-6.4392,2.8975-7.0833,10.142-4.0246,15.454'/%3E %3Cpath d='m393.04,275.81c-9.6588,3.7025-9.4975,16.581,1.1267,20.605'/%3E %3Cpath d='m389.66,293.51c-5.795,3.3804-6.9221,9.8196-3.0583,14.005'/%3E %3Cpath d='m379.52,270.98c-3.8638,1.2879-3.5417,13.2,6.7613,12.878'/%3E %3Cpath d='m368.9,275c-7.7271,5.1513,1.6096,18.19,14.166,8.8538'/%3E %3Cpath d='m376.14,287.07c-1.1267,5.3125,0.32209,11.108,8.8542,11.752'/%3E %3Cpath d='m376.62,294.16c-6.1175,2.2533-7.2442,14.81,3.8633,15.776'/%3E %3Cpath d='m357.15,282.73c-7.8879,7.2442,6.4392,13.522,11.752,3.0588'/%3E %3Cpath d='m346.2,294.8c-3.8638,4.6683,9.6583,16.903,15.615-3.5417'/%3E %3Cpath d='m363.26,290.94c0.32167,4.8292,3.2196,7.7267,9.1754,8.0488'/%3E %3Cpath d='m372.28,303.66c-9.4975,1.4488-12.556,13.361-1.9317,15.937'/%3E %3Cpath d='m354.73,302.05c-0.32208,4.5071,4.3463,8.2096,9.6588,7.405'/%3E %3Cpath d='m369.22,319.27c-8.6925,1.9317-9.8196,13.2-2.0925,12.556'/%3E %3Cpath d='m363.1,342.29c-7.2446-2.1729-7.4054-10.786-0.96625-14.005'/%3E %3Cpath d='m357.15,334.72c-6.1167,3.7025-3.7021,12.556-0.48292,13.844,3.2196,1.2879,5.7954-0.32166,6.1175-3.0583'/%3E %3Cpath d='m362.3,357.9c0.64417,4.1854-14.891,2.5758-6.9217-10.463'/%3E %3Cpath d='m355.29,358.63c-5.2313,8.21,3.3008,14.89,8.6929,7.8883'/%3E %3Cpath d='m356.02,368.53c-2.0929,6.6004,5.875,11.35,11.026,6.1983'/%3E %3Cpath d='m338.63,306.71c-2.8979,5.9563,11.59,8.2096,12.556-4.0246'/%3E %3Cpath d='m334.61,315.57c-2.8975,11.59,18.995,9.1758,13.361-5.7954'/%3E %3Cpath d='m348.45,317.5c3.0583,1.7708,12.235,1.9317,14.488-7.8879'/%3E %3Cpath d='m356.34,317.82c0.64375,3.0583,3.3804,6.7608,5.9558,7.8879'/%3E %3Cpath d='m345.88,320.88c-0.96583,6.2783,5.3121,11.43,12.556,10.947'/%3E %3Cpath d='m347,327c-3.5412,4.8296-4.6683,14.166,6.4396,14.81'/%3E %3Cpath d='m330.1,328.61c-1.7708,4.9904,8.6929,10.142,14.81,1.9317'/%3E %3Cpath d='m326.88,341.32c-0.88625,3.7838,8.5317,8.8542,13.844-7.2438'/%3E %3Cpath d='m336.54,342.29c2.2538,4.0242,9.8196,7.2438,14.488-0.64417'/%3E %3Cpath d='m343.46,346.48c-1.9317,5.6342,3.3808,10.946,9.8196,9.3367'/%3E %3Cpath d='m331.39,345.19c-1.2879,8.0488,8.0488,12.717,13.844,8.5317'/%3E %3Cpath d='m325.27,348.73c-2.7362,10.303,10.464,14.166,15.454,6.4388'/%3E %3Cpath d='m337.35,358.23c0.48333,5.7954,9.4983,10.785,16.581,5.9563'/%3E %3Cpath d='m321.25,363.06c-0.64375,2.5754,10.142,5.1513,11.751-3.8638'/%3E %3Cpath d='m327.53,365.31c2.5754,6.6004,11.268,8.21,16.259,0.16125'/%3E %3Cpath d='m340.89,368.69c1.1271,6.1171,9.015,9.4975,15.937,5.3121'/%3E %3Cpath d='m359.72,376.42c-1.7704,8.21,6.7613,14.81,12.073,10.303'/%3E %3Cpath d='m346.04,374.97c-2.5754,9.015,8.6929,14.166,14.971,9.1758'/%3E %3Cpath d='m332.52,370.46c-0.64375,8.3708,5.9562,13.361,13.522,9.6583'/%3E %3Cpath d='m318.19,371.27c-2.2542,5.4733,9.6588,9.9808,15.293,5.3125'/%3E %3Cpath d='m310.78,386.24c3.0588,3.5412,13.683,0,14.649-7.8879'/%3E %3Cpath d='m322.54,384.14c3.8633,4.5075,13.039,6.9221,16.742-2.7367'/%3E %3Cpath d='m336.06,386.4c-0.16125,6.9221,12.235,11.913,16.259-0.805'/%3E %3Cpath d='m366.88,388.09c-1.1271,3.3808,1.53,8.7729,7.0829,9.4167'/%3E %3Cpath d='m356.66,386c-0.805,3.8633,4.8296,9.2554,10.786,7.0829'/%3E %3Cpath d='m368.58,394.69c-1.6096,4.1854-0.24208,10.221,5.3921,10.141'/%3E %3Cpath d='m369.14,402.5c-4.1854,3.5412-2.415,9.8204,3.6229,10.062'/%3E %3Cpath d='m366.97,408.45c-5.9563,4.0225-3.8633,12.877,4.0242,12.398'/%3E %3Cpath d='m348.94,391.39c0,8.6929,10.785,9.9804,12.878,1.9317'/%3E %3Cpath d='m357.63,398.47c-1.61,5.1512,2.5754,10.142,9.1754,8.6929'/%3E %3Cpath d='m358.92,460.61c1.4492,2.0958,7.405-1.4458,5.7954-4.9875s-7.9192-1.6167-7.2442,2.0917'/%3E %3Cpath d='m363.26,454.17c0.80459-7.0833-7.5663-8.2083-9.6588-2.0917'/%3E %3Cpath d='m356.66,448.54c2.0929-3.5417-4.99-8.3708-7.8879-3.2208'/%3E %3Cpath d='m351.35,443.22c1.9317-5.1542-6.1171-7.4042-6.7613-2.7375'/%3E %3Cpath d='m342.82,433.72c0.96625-2.575,9.9808-0.96667,6.1175,4.3458'/%3E %3Cpath d='m355.86,444.51c3.5417-3.2208-2.4142-9.8208-6.1171-7.4042'/%3E %3Cpath d='m379.68,454.33c-2.8179,0.32084-5.7158,2.1708-3.6229,8.1292,1.4512,4.1333,7.6471,4.3458,8.5317,1.85'/%3E %3Cpath d='m375.58,457.31c-2.7367-1.7708-8.6929,1.2083-5.9562,7.0042,2.0604,4.3625,7.2442,2.575,8.0488,0.32083'/%3E %3Cpath d='m360.2,465.6c1.3675,2.4125,8.2088,1.3708,9.4167-1.2875'/%3E %3Cpath d='m364.87,457.63c1.4488-0.96667,4.1042,0.2375,4.6683,1.4458'/%3E %3Cpath d='m364.39,417.95c-4.6683,3.0583-1.7708,12.396,5.4733,9.9792'/%3E %3Cpath d='m362.94,425.52c-3.7025,2.8958-0.32208,11.913,6.6,8.5333'/%3E %3Cpath d='m364.07,434.05c-2.5754,2.575-0.0808,9.7375,6.6004,8.3708'/%3E %3Cpath d='m363.1,437.59c-1.4492-0.64584-5.2325-0.1625-6.8425,2.25'/%3E %3Cpath d='m358.92,404.99c-3.5412,3.3804-1.8517,10.304,4.7483,10.866'/%3E %3Cpath d='m357.63,412.07c-5.0717,2.4958-5.0717,12.554,5.07,12.958'/%3E %3Cpath d='m357.23,423.42c-2.8167,2.2542-1.4488,10.946,5.7954,9.8167'/%3E %3Cpath d='m359.56,432.92c-1.0471,1.0458-1.2083,3.7042-0.32208,4.8292'/%3E %3Cpath d='m356.34,429.62c-2.5754,0.0792-5.9562,1.9333-6.8425,4.5875'/%3E %3Cpath d='m344.83,424.87c0.96583-2.575,8.9354-2.4125,9.4979,5.1542'/%3E %3Cpath d='m355.13,421.01c-1.1271,0.24167-3.2996,1.2875-3.8633,3.4625'/%3E %3Cpath d='m351.67,397.43c-3.4617,3.1388-5.1512,13.04,5.3921,14.97'/%3E %3Cpath d='m344.67,417.87c0-2.6583,7.1642-4.9125,9.6588-0.96666'/%3E %3Cpath d='m340.08,403.46c1.0458,2.0129,6.0362,4.7496,9.095,2.4958'/%3E %3Cpath d='m314.16,387.69c-0.16042,4.6683,3.7029,8.8538,9.015,8.21,5.3121-0.64417,6.4392-5.3125,4.8292-8.3713'/%3E %3Cpath d='m323.98,396.06c-3.5417,4.3463,0.805,10.464,4.8292,8.6929'/%3E %3Cpath d='m328.01,393c2.0929-0.805,9.015-1.7708,11.108,1.4488'/%3E %3Cpath d='m305.63,394.29c-1.61,2.4146,8.3712,4.8296,11.751,0.16083'/%3E %3Cpath d='m314,396.86c-0.3225,3.2196,1.2875,8.6925,9.4975,6.4392'/%3E %3Cpath d='m324.79,408.29c1.2875-2.7367-4.8296-7.2438-9.4979-2.2538-4.6683,4.9904,0.64375,10.625,3.5417,8.6917'/%3E %3Cpath d='m303.38,397.51c-2.4146,4.1854,6.9221,11.833,12.235,4.7496'/%3E %3Cpath d='m297.18,404.75c-3.3804,3.4617,0.805,9.8208,5.8763,7.8875,5.0704-1.9313,4.5875-7.2438,3.3808-8.6113'/%3E %3Cpath d='m290.66,411.19c-2.7367,2.4942-0.0813,8.3692,3.7025,8.3692,3.7821,0,6.1171-2.975,5.3921-6.7583'/%3E %3Cpath d='m306.03,410.71c-0.48333,3.7021,4.99,6.2771,8.5317,2.8188'/%3E %3Cpath d='m314.73,406.76c0.48292-0.805,0.0813-2.1742-0.72334-2.8179'/%3E %3Cpath d='m284.79,416.18c-3.1383,2.4958,3.6229,9.4167,7.8879,3.0583'/%3E %3Cpath d='m309.01,414.81c-2.0129,1.9292,1.2067,7,4.4262,5.4708'/%3E %3Cpath d='m297.99,418.35c0.48292,3.4583,7.2442,6.0333,11.51,0.725'/%3E %3Cpath d='m301.69,421.81c-1.0458,2.175,1.0471,5.6375,3.6225,5.1542'/%3E %3Cpath d='m365.76,441.7c-2.4942,4.9083,5.4733,10.625,11.269,4.6667'/%3E %3Cpath d='m371.55,449.02c-1.2067,2.6542,0.24209,6.3583,2.4146,7.725'/%3E %3Cpath d='m363.99,454.57c0.56417-2.4167,4.0242-4.6708,7.1642-3.5417'/%3E %3Cpath d='m359.8,448.21c0.48292-2.1708,3.3804-4.3458,5.5542-3.7792'/%3E %3Cpath d='m549.35,347.76c-11.429,0.16125-6.6,18.513,3.2208,14.81'/%3E %3Cpath d='m545.65,361.29c-2.2542,3.7025,2.0917,9.5788,6.9208,6.1171'/%3E %3Cpath d='m551.29,368.13c-3.3833,5.6342,8.6917,14.246,13.521,5.3921'/%3E %3Cpath d='m560.95,376.9c0.15834,5.3125,15.613,8.6929,13.363-1.9317'/%3E %3Cpath d='m572.86,380.76c3.7,6.2779,17.546,6.9221,16.096-2.4146'/%3E %3Cpath d='m585.9,384.79c2.9,4.1854,16.421,6.7608,15.938-1.9321'/%3E %3Cpath d='m531,331.83c1.9292,4.9904,8.5292,6.7613,15.775,3.8633'/%3E %3Cpath d='m526.82,335.37c4.5083,2.8975-2.0917,16.098-9.0125,10.785'/%3E %3Cpath d='m526.82,343.58c4.9917,2.415,11.108,0.64417,12.879-6.4392'/%3E %3Cpath d='m536.64,342.61c0.48334,3.7025,5.7958,6.6004,12.717,5.1512'/%3E %3Cpath d='m524.24,346.48c6.4417,5.4733-2.8958,16.742-7.0833,11.59'/%3E %3Cpath d='m526.66,350.66c3.0583,2.2538,10.946,0.96584,11.75-4.9904'/%3E %3Cpath d='m534.87,350.66c0.64583,3.8633,3.7042,5.3121,8.05,5.4733'/%3E %3Cpath d='m524.89,355.97c3.2167,4.5075,11.267,5.7954,14.808-0.16083'/%3E %3Cpath d='m536.15,359.19c-0.32083,4.3467,4.5083,7.8879,9.5,6.9221'/%3E %3Cpath d='m518.61,368.85c4.1833,2.0925,8.6917-5.795,5.15-11.268'/%3E %3Cpath d='m523.44,377.22c4.9917,0.32208,5.6333-7.2438,0.96667-11.43'/%3E %3Cpath d='m534.87,384.14c4.1875-0.96583,2.8958-10.142-7.2458-10.947'/%3E %3Cpath d='m547.58,390.91c4.025-1.1271,0.80417-11.269-10.3-10.625'/%3E %3Cpath d='m562.88,394.45c2.7333-4.1854-6.2792-11.268-13.683-7.5658'/%3E %3Cpath d='m570.44,400.24c4.9917,1.4488,8.3708-11.751-7.4042-9.6588'/%3E %3Cpath d='m579.62,400.24c4.35-1.1267,7.4084-9.015-5.3083-6.4392'/%3E %3Cpath d='m589.28,400.89c3.8625,1.9321,5.6333-9.3367-6.1208-6.2779'/%3E %3Cpath d='m524.4,365.79c4.8292,2.7367,12.396-0.48291,11.75-6.6'/%3E %3Cpath d='m534.22,364.51c1.6125,2.8975,0.96667,8.5317-2.0917,9.9804'/%3E %3Cpath d='m534.7,371.27c3.2208,1.2879,7.5667,0.16125,10.142-4.99'/%3E %3Cpath d='m540.34,371.27c0.9625,2.2538,1.2875,6.7613-0.80833,9.015'/%3E %3Cpath d='m541.15,375.13c3.5417,1.9317,7.725-0.64417,9.4958-4.3467'/%3E %3Cpath d='m548.39,374c2.575,1.61,4.8292,9.1758,0.48333,12.235'/%3E %3Cpath d='m551.29,382.7c3.0583,0.16083,7.5667,0.16083,10.463-3.7025'/%3E %3Cpath d='m559.66,381.09c2.7375,0.805,5.9542,5.3125,4.8292,9.3371'/%3E %3Cpath d='m564.65,388.97c3.0625-0.32209,8.3708-2.415,9.8208-6.1175'/%3E %3Cpath d='m573.02,385.27c2.5792,1.4488,4.35,4.5071,4.025,8.0488'/%3E %3Cpath d='m577.04,390.74c3.0583-0.16084,5.7958-1.7704,6.6-5.1513'/%3E %3Cpath d='m582.84,387.85c2.2542,0.805,4.9917,3.3804,5.1542,6.4392'/%3E %3Cpath d='m587.67,392.35c2.2542-0.32209,3.8625-1.7708,5.3125-4.0246'/%3E %3Cpath d='m599.1,388.01c2.9,2.8979-0.9625,12.557-6.9208,10.786'/%3E %3Cpath d='m537.28,192.9c-5.9583,3.5412-22.863,2.4146-14.492-11.59'/%3E %3Cpath d='m538.89,183.4c-11.75,4.6683-26.242-4.3462-11.108-14.166'/%3E %3Cpath d='m523.76,166.02c-9.8208,0-16.421,15.776-3.2167,21.249'/%3E %3Cpath d='m485.61,172.62c-2.575,4.99,6.6,10.463,12.879,5.4733,4.8625-3.8662,4.5042-14.327,1.6083-18.352'/%3E %3Cpath d='m480.62,184.53c-3.2208,10.624,20.446,11.268,16.742-5.6346'/%3E %3Cpath d='m479.33,200.31c0.80417,8.0488,22.7,5.4733,15.613-10.786'/%3E %3Cpath d='m497.52,185.01c1.7708,2.4146,6.6,6.6,14.808,5.795'/%3E %3Cpath d='m501.38,173.58c0.725,2.8975,5.6333,5.1512,11.913,2.9788'/%3E %3Cpath d='m281.73,418.51c-5.5533,3.9458,2.9788,10.142,6.1171,3.3'/%3E %3Cpath d='m277.38,421.57c-5.5529,3.9417,2.9788,10.138,6.1175,3.2958'/%3E %3Cpath d='m272.79,424.55c-5.5546,3.9458,2.9775,10.142,6.1171,3.3'/%3E %3Cpath d='m267.96,427.29c-5.3125,2.8167,0.88458,9.7375,6.2779,3.6208'/%3E %3Cpath d='m262.73,429.95c-5.3125,2.8125,0.88584,9.7375,6.2783,3.6208'/%3E %3Cpath d='m289.7,421.65c-0.0813,4.1042,7.7271,5.7958,10.543-0.325'/%3E %3Cpath d='m294.61,425.44c-2.4146,3.0583,2.0129,6.8417,4.4275,5.4708'/%3E %3Cpath d='m284.22,424.87c-0.24208,3.4625,6.5188,5.475,9.8196,1.6917'/%3E %3Cpath d='m287.93,428.5c-2.1738,2.8167,2.0925,6.6,4.8292,5.4708'/%3E %3Cpath d='m279.72,428.01c0.24083,2.7375,4.1042,5.875,8.29,4.1042'/%3E %3Cpath d='m282.21,431.71c-1.61,1.45-0.80459,4.8333,1.4488,5.8792'/%3E %3Cpath d='m273.84,431.47c-0.64375,2.4958,3.6225,6.925,7.9688,4.025'/%3E %3Cpath d='m274.72,434.37c-2.5754,2.0125-2.2538,5.0708,1.0458,5.4708'/%3E %3Cpath d='m268.53,434.05c-0.32167,1.6875,1.8521,4.425,4.5888,4.1042'/%3E %3Cpath d='m254.76,433.89c-2.5754,1.3667,4.0246,8.3708,8.1288,1.85'/%3E %3Cpath d='m248.4,436.78c-3.2196,1.5333,4.7492,9.2584,8.2913,1.3708'/%3E %3Cpath d='m269.25,436.46c-2.4958,0.5625-4.1054,4.1875-2.0129,5.6333'/%3E %3Cpath d='m261.12,437.75c-0.32208,1.45,2.7367,3.8625,5.2329,2.9792'/%3E %3Cpath d='m259.03,438.4c-2.4146,1.5292-1.1271,5.7917,1.6908,5.15'/%3E %3Cpath d='m250.42,441.21c-2.2538,1.6875-0.725,5.0708,2.4146,4.2667'/%3E %3Cpath d='m254.52,440.97c0.0813,0.88333,2.0929,2.2542,3.7838,1.6917'/%3E %3Cpath d='m242.61,439.52c-2.8162,1.2083-2.6554,8.2917,6.8425,4.4292'/%3E %3Cpath d='m236.25,442.34c-3.9446,1.9333-2.6567,7.2458,5.9562,2.175'/%3E %3Cpath d='m242.93,444.92c-1.0458,0.80416-2.1725,4.3458,1.7708,2.975'/%3E %3Cpath d='m235.69,446.6c-1.6096,1.45-0.5625,4.4292,2.9792,3.3'/%3E %3Cpath d='m227.4,447.09c-2.8975,1.6917,3.4604,3.9458,7.7271-0.5625'/%3E %3Cpath d='m229.33,449.18c-1.2883,1.2875-1.2883,5.0708,2.0925,3.7042'/%3E %3Cpath d='m221.12,450.71c-1.9317,1.45,1.3679,3.3833,7.405,0.725'/%3E %3Cpath d='m223.53,452.8c-2.2538,1.85-2.0129,4.1833,1.2875,3.4583'/%3E %3Cpath d='m216.85,453.85c-2.4946,2.2542,1.1267,3.7833,5.4733,1.9292'/%3E %3Cpath d='m216.93,456.35c-4.2667,1.9292-2.415,5.4708,0.24084,4.1042'/%3E %3Cpath d='m359.4,468.66c-0.98917,2.1292,2.2538,3.8625,5.3125,3.3792,2.9379-0.4625,5.7483-2.8833,3.5413-6.275'/%3E %3Cpath d='m368.41,469.95c2.8975,2.2542,8.0488-0.32083,8.0488-3.7042'/%3E %3C/g%3E %3Cg fill='%23fff'%3E %3Cpath d='m545.97,128.83c-12.879-6.4392-39.6-18.352-47.167-8.6929,6.9208-2.8975,27.204,0.16125,43.946,15.615l3.2208-6.9221z'/%3E %3Cpath d='m553.78,128.15c-14.892-17.347-23.663-13.464-34.371-19.439-10.058-5.6142-26.079-6.7612-29.183,2.1671,14.696-7.1575,28.188,3.8488,36.475,5.1804,11.383,1.8279,17.808,10.628,21.138,14.675l5.9417-2.5833z'/%3E %3Cpath d='m609.88,125.93c-7.7292-17.708-24.254-13.083-31.554-20.605-10.621-10.946-37.504-21.088-48.613-13.522,24.467-1.2879,34.888,16.865,47.971,23.181,9.3375,4.5075,19.317,14.166,32.196,10.947z'/%3E %3Cpath d='m580.91,124c-13.2-16.42-33.488-30.908-42.821-25.435,12.233,0.64375,16.096,9.1758,24.792,14.649,8.6917,5.4733,4.8292,13.361,18.029,10.786z'/%3E %3Cpath d='m518.12,152.98c-13.846-5.1513-40.888-7.7267-53.446,8.0492,20.929,3.5413,52.479,1.6096,53.446-8.0492z'/%3E %3Cpath d='m515.55,159.1c-13.846-6.4392-24.658,2.555-37.671,1.2875-24.788-2.4146-42.496-0.96584-44.75,10.947,14.167-12.717,37.992-2.2538,47.65-4.8292,9.6584-2.5758,45.396-0.32208,56.663,4.5071-5.7958-7.0829-14.808-9.0146-21.892-11.912z'/%3E %3Cpath d='m559.01,122.23c-3.2167-10.625-3.0583-21.893,12.879-21.088-4.025-4.9904-18.833-7.5658-21.25,11.108-17.546-12.878-36.704-15.132-40.242-4.0242,9.0125-7.7271,23.017-2.0929,39.758,16.903,1.45-0.805,5.3125-2.4146,8.8542-2.8975z'/%3E %3Cpath d='m534.87,136.88c-9.9792-6.4388-23.504-16.903,0.1625-21.088-10.142-5.4733-24.954-3.0588-23.342,15.615-27.046-10.947-46.467-7.2521-50.55,3.5413-4.5083,11.913,12.238,18.513,15.133,10.947-3.0583,1.2879-13.521-2.2538-8.05-9.015,5.475-6.7608,33.525-1.6854,60.208,12.235,7.4042,3.8633,32.838,3.2196,6.4375-12.235z'/%3E %3Cpath d='m527.78,154.59c-7.7-15.722-32.679-1.4488-37.713-16.678-6.8792,22.312,35.521,9.9658,37.713,16.678z'/%3E %3Cpath d='m686.67,171.65c5.2375,2.6025,9.7667-1.4888,1.7542-4.6979,5.2417,2.6012,9.8125-1.3925,1.8-4.6029,5.2417,2.6012,9.8125-1.3921,1.8-4.6025-2.1375,2.1517-5.1958,10.04-5.3542,13.903z'/%3E %3Cpath d='m689.4,141.39c11.592-12.234-0.9625-16.42,13.2-28.976,11.592-10.273,2.2125-17.12,13.204-25.113,3.5417-2.5754,11.267-7.7267,11.913-12.878,4.6667,11.59-14.492,13.2-13.204,31.874,0.82084,11.89-7.2167,10.851-10.3,30.908-0.64583,4.1854-3.5417,13.522-14.813,4.1854z'/%3E %3Cpath d='m694.56,146.86c6.4375-13.844,13.829-13.578,17.383-18.995,6.7625-10.303,21.088,1.7708,33.163-7.405-2.0917,13.039-18.35,8.3708-25.433,16.742-7.0833,8.3708-12.879,12.235-25.113,9.6588z'/%3E %3Cpath d='m696.17,151.37c11.271-9.015,19.575-3.0008,27.367-7.7271,19.638-11.913,27.529,2.4146,45.075-3.2196-4.6708,11.268-30.588,1.61-41.854,9.9808-11.271,8.3708-50.871,16.42-30.588,0.96583z'/%3E %3Cpath d='m663.33,215.6c-0.1625-5.1513-4.9917-11.752-11.754-12.556-6.7583-0.805-9.6583-7.8883-14.808-8.21-5.15-0.32209-8.5333-10.625-15.617-10.464-7.0833,0.16125-9.9792,9.3367,6.6,17.708,16.583,8.3713,34.933,18.03,35.579,13.523z'/%3E %3Cpath d='m642.4,219.95c-7.0833,0.32209-8.05,10.625-14.808,10.947,9.3334,4.9904,16.096-2.2538,20.925-8.6929l-6.1167-2.2538z'/%3E %3Cpath d='m648.2,221.23c-6.1167,5.1513-7.8875,15.937,0.96667,18.995-5.3125-7.3246,9.3375-10.625,4.8292-17.386l-5.7958-1.6096z'/%3E %3Cpath d='m654.31,221.56c-4.8292,9.3367,7.5667,10.463,4.3458,17.547,7.0833-1.61,8.2125-14.971,1.7708-18.513l-6.1167,0.96625z'/%3E %3Cpath d='m606.98,201.59c11.592-0.64375,22.192,5.6267,29.3,15.776,4.5083,6.4388,19.638,9.0146,24.792,3.8633,5.15-5.1512,2.2542-16.098-10.625-12.556-3.2208-5.4733-12.558-3.5417-17.063-8.0492-4.5083-4.5071-21.896-17.385-26.404,0.96584z'/%3E %3Cpath stroke-linecap='round' d='m650.45,208.68c-3.0583,0.64375-4.025,5.9562-2.0958,8.6929'/%3E %3Cpath stroke-linecap='round' d='m657.05,211.9c0.96667,1.6096,0.32083,3.8633-0.1625,4.9904'/%3E %3Cpath stroke-linecap='round' d='m625.34,202.08c5.9542,0.32209,7.0833,4.6688,13.521,6.2783'/%3E %3Cpath d='m621.4,187.43c20.571,5.1512,36.892,9.6588,47.013,15.454,10.121,5.7954,25.792,7.405,39.504,3.5417,13.713-3.8633,40.154-7.405,38.85,9.6588,7.1875-8.5321-1.9583-17.708-20.242-19.318,0.32916-8.3708-8.6292-15.937-15.071-10.947,5.9583-0.80459,11.1,10.303-0.65,14.81,2.2833-8.3708-6.0417-15.937-14.692-12.234,5.55,1.6096,11.163,10.917-1.2542,14.488-7.8375,2.2538-19.263-0.64375-27.75-5.795-8.4875-5.1517-56.154-23.825-45.708-9.6588z'/%3E %3Cpath d='m673.31,179.06c-6.4375,2.8975-2.2542,9.6588-12.233,13.522-9.9833,3.8633-16.904,12.717-14.65,20.283,6.7625-14.81,18.675-14.166,22.858-19.961,4.1875-5.7954,10.304-14.327,4.025-13.844z'/%3E %3Cpath d='m675.08,180.02c-0.32083,11.751-9.5708,7.4704-5.9583,23.986,1.1292,5.1512,3.2208,13.522-0.32083,21.893,10.383-7.5658,3.7042-23.46,8.3708-29.459,2.2542-2.8975,5.15-7.405,6.2792-11.268-2.4167,6.7608-2.2542,19.318,4.3458,22.537-5.3125-12.557,14.329-22.859,0.80417-37.347-1.9292,3.5417-8.05,9.8196-13.521,9.6588z'/%3E %3Cpath d='m642.24,168.27c1.6125,2.4146,3.2208,8.5321,1.7708,11.913,3.2208-1.9317,7.8917-6.9221,9.3375-10.303,6.6,0.96584,9.175,9.1758,2.9,12.717,3.8625,0,10.463,0,14.163-4.3462-4.5042-4.9904-18.508-12.718-28.171-9.9808z'/%3E %3Cpath d='m542.11,145.18c-1.0417-0.94916-2.8-1.8517-5.9542-2.4996-9.7458-1.9988-4.7125-10.784,3.5833-10.706,17.704-19.317,27.646-4.4262,49.217-10.543,7.55-2.1404,12.733-1.5079,16.846,0.27167,9.6583-6.4392,20.988-4.64,29.2,2.9262,0.9125-1.4517,2.1375-2.5592,3.8583-3.0371,7.5625-2.1004,13.679,4.3479,15.771,12.719,5.8958-1.0921,12.629,1.8262,17.058,5.8504,6.1333-3.15,10.358-3.29,11.913-0.0512,5.475-2.5758,12.567-4.1908,16.108,4.5021,3.5417,8.6929-8.3708,6.1171-10.304,24.469-1.1917,11.321-13.842,15.776-23.825,9.015-15.967-10.817-31.55-12.557-39.279,3.8633-7.725,16.42-13.779,25.96-32.517,20.605-6.7583-1.9321-15.454,0.64375-20.925,8.0488-5.475,7.405-13.846,0.48291-23.825,1.2879,12.554-1.9317,7.7458-5.0896,18.675-5.7954,9.9792-0.64375,7.4042-9.9804,13.842-11.268-25.113,6.4392-24.146-2.8979-44.75,3.5412,9.0125-11.59,23.179-5.1513,30.263-11.912-18.675-0.32208-27.025-12.522-35.417-7.405-13.2,8.0488-7.4083,30.965-41.854,28.976-16.742-0.96583-27.367,1.2879-37.346,11.269,17.388-36.059,41.038-16.249,52.479-27.688,6.7625-6.7613,11.913-11.913,15.454-18.352,1.2458-2.2667,2.9333-3.5621,5.0417-4.0629-28.654-9.015-11.325-23.058,16.688-24.023z'/%3E %3Cpath stroke-linecap='round' d='m683.59,140.11c0.4375,0.90542,0.6625,2.08,0.6625,3.5325,0,7.0829-10.625,7.405-11.267,17.869-0.3375,5.4733-0.96666,8.5317-4.6708,7.8879-3.7-0.64417-6.9208-6.4392-3.3792-13.2'/%3E %3Cpath d='m547.42,134.63c-2.6667-1.8738-5.3333-2.635-7.725-2.6571'/%3E %3Cpath d='m605.74,121.65c8.525,3.6908,12.683,12.546,25.067,12.98,11.921,0.41833,19.321,17.708,39.279,6.4388,0.54167-0.305,1.0708-0.58959,1.5833-0.85375'/%3E %3Cpath d='m635,124.63c-1.7792,2.8292-2.1833,6.7783-1.6958,10.244'/%3E %3Cpath d='m596.04,161.03c-15.129,0-18.996,7.7267-18.996,15.132,0,7.405,7.0833,17.064,19.642,17.064,12.554,0,19.317-7.7267,19.317-16.098s-7.7292-16.098-19.963-16.098z'/%3E %3Cpath d='m598.77,192.9c-0.32084-4.1854-7.8875-3.5417-7.5667-6.7613,0.32084-3.2196,4.1875-4.5075,4.1875-9.0146,0-4.5075,6.7583-4.8296,9.0125-1.2879,2.2542,3.5412,9.0167,10.463,10.467,6.9221'/%3E %3Cpath d='m604.41,175.84c-3.5417,3.5412-5.15,10.785-0.48334,16.42'/%3E %3Cpath d='m609.24,181.31c-1.125,2.4146-1.4458,6.1171-0.15833,8.3708'/%3E %3Cpath fill='none' d='m669.36,169.48c11.833,0.96583,13.846-12.074,4.9917-12.878'/%3E %3Cpath fill='none' d='m654.8,134.31c-4.1042-5.2313-13.521-7.0021-13.683,4.1054'/%3E %3Cpath d='m639.99,151.05c-4.025-9.9808-14.329-11.43-19.804-6.4392-4.5542,4.1533-4.6667,14.971,5.1542,17.225,3.3792-4.0242,9.9792-9.3367,14.65-10.785z'/%3E %3Cpath d='m635.56,144.77c-5.7958-5.1517-14.329,4.5883-6.6,13.522'/%3E %3Cpath d='m525.31,169.16c3.8792-0.92083,9.55,0.9775,18.246,5.0675,5.475,2.5758,21.896,8.0492,32.196,2.5758-10.625,3.8633-18.671-12.235-26.721-10.303-8.05,1.9317-22.779,4.9096-28.975-0.96625,15.129,0.96625,23.267-11.021,40.563-0.64375,4.8333,2.8975,10.95,4.8296,16.421,4.5075-14.163-17.064-32.838-6.1175-34.771-19.961,8.5333,9.1758,29.379-2.0929,40.004,15.132'/%3E %3Cpath d='m545.33,152.01c-1.9917-2.4792-1.0917-4.9504-3.2292-6.9054'/%3E %3C/g%3E %3Cpath fill='%23000' stroke='none' d='m654.8,134.31c-3.5417-3.7829-11.267-0.805-9.0958,6.8421,1.6917-3.5413,5.3125-6.52,9.0958-6.8421z'/%3E %3Cpath fill='%23000' stroke='none' d='m632.91,154.93c2.4375-1.7696,4.9542-3.2233,7.075-3.8817-1.1583-2.8642-2.8292-5.0262-4.7583-6.5346-1.8417-1.2721-7.1333,5.8442-2.3167,10.416z'/%3E %3Cg fill='none' stroke-linecap='round'%3E %3Cpath d='m623.4,141.87c-5.7958-3.8633-11.108-3.5413-12.879-0.32167-4.1833-0.16125-7.6458,2.8975-7.8083,9.0146'/%3E %3Cpath d='m611.65,153.14c-6.9208-4.7483-16.421-2.9775-15.775,7.6471'/%3E %3Cpath d='m591.69,166.82c3.3792-2.7367,8.2083-4.6683,11.913,0.16125'/%3E %3Cpath d='m643.37,156.36c-1.2875,1.7704-2.2542,4.5071-0.1625,8.6929-2.575-3.3808-9.0125-3.3808-15.938,5.6338'/%3E %3Cpath d='m658.66,155.88c-8.3708,0.96583-8.2083,6.4388-1.45,8.8538'/%3E %3Cpath d='m599.1,135.43c-7.0833-1.4488-12.233,2.7367-2.4125,6.2783'/%3E %3Cpath d='m612.62,130.6c-9.9834-2.4146-14.008,0.16084-9.5,2.4146'/%3E %3Cpath d='m583.8,170.69c-0.32083,3.5417,1.6083,8.21,7.4042,2.8979'/%3E %3Cpath d='m585.74,181.31c0,0.96583-0.1625,2.0925-0.80833,2.8975'/%3E %3Cpath d='m562.55,134.14c-6.1167-1.7708-7.2417-7.405-0.15834-6.9221'/%3E %3Cpath d='m560.46,147.18c-6.7625-2.2538-6.7625-8.8538-1.1292-8.21'/%3E %3Cpath d='m573.02,143.8c-7.8875-1.9321-8.2083-7.4054-2.25-6.6004'/%3E %3Cpath d='m573.98,127.06c-4.1833-0.32166-10.625,4.3467,0.1625,7.0833'/%3E %3Cpath d='m585.74,136.4c-9.8208-1.4488-9.6583,2.5758-3.8667,5.1517'/%3E %3Cpath d='m593.14,127.06c-7.5667-1.4488-10.142,3.0588-4.9917,4.9904'/%3E %3Cpath d='m569.32,154.91c-1.8542-1.5288-3.3792-8.8542,5.4708-6.68'/%3E %3Cpath d='m587.67,152.66c-5.9542-1.61-11.588,4.1854-6.1167,7.5658'/%3E %3Cpath d='m595.55,145.74c-6.275-1.1271-11.588,0.64375-8.2083,2.8975'/%3E %3C/g%3E %3Cpath fill='%23fff' d='m654.46,134.31c-3.5375,0.65541-6.7083,2.7342-8.7625,6.8396'/%3E %3C/g%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1100 800'%3E %3Crect width='1100' height='800' fill='%23ef2b2d'/%3E %3Crect width='200' height='800' x='300' fill='%23fff'/%3E %3Crect width='1100' height='200' y='300' fill='%23fff'/%3E %3Crect width='100' height='800' x='350' fill='%23002868'/%3E %3Crect width='1100' height='100' y='350' fill='%23002868'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 36 24'%3E %3Crect width='36' height='24' fill='%2375aadb'/%3E %3Crect y='9' width='36' height='6' fill='%23fff'/%3E %3Crect y='10' width='36' height='4'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 1098 549'%3E %3Ctitle%3EFlag of Belarus%3C/title%3E %3Crect fill='%23C8313E' width='1098' height='549'/%3E %3Crect y='366' fill='%234AA657' width='1098' height='183'/%3E %3Crect fill='%23FFF' width='122' height='549'/%3E %3Cg id='h'%3E %3Cg id='q' fill='%23C8313E' fill-rule='evenodd' transform='scale(5.304347826,9)'%3E %3Cpath d='M4,0h3v1h1v1h1v1h1v1h1v1h-1v1h-1v1h-1v1h-1v1h-1v1h-1v-1h-1v-1h-1v-1h-1v-1h-1v-1h-1v-1h1v-1h1v-1h1v-1h1zM5,2h1v1h1v1h1v1h-1v1h-1v1h-1v-1h-1v-1h-1v-1h1v-1h1zM5,4h1v1h-1zM0,1h1v1h-1zM0,7h1v1h-1zM11,0h0.6v2h-.6zM11,7h.6v2h-.6zM2,9h1v1h1v1h1v1h-1v1h-1v1h-1v-1h-1v-1h-1v-1h1v-1h1zM2,11h1v1h-1zM8,9h1v1h1v1h1v1h-1v1h-1v1h-1v-1h-1v-1h-1v-1h1v-1h1zM8,11h1v1h-1zM0,15h1v1h-1zM11,14h.6v2h-.6z'/%3E %3Cpath d='M0,18h1v-1h1v-1h1v-1h1v-1h1v-1h1v1h1v1h1v1h1v1h1v1h1v1h.6v4h-.6v1h-1v1h-1v1h-1v1h-1v1h-1v2.6h-2v-0.6h-1v-1h-1v-1h-1v-1h-1 v-3h1v1h1v1h1v1h1v-1h1v-1h1v-1h1v-1h1v-1h1v-1h-1v-1h-1v-1h-3v1h2v1h-1v1h-1v1h-1v-1h-1v-1h-1v-1h-1zM0,22h1v1h-1zM11,25h.6v1h-.6zM9,27h1v1h1v1h.6v1.6h-.6v-.6h-1v-1h-1zM7,30h1v.6h-1z'/%3E %3C/g%3E %3Cuse xlink:href='%23q' transform='translate(122,0) scale(-1,1)'/%3E %3C/g%3E %3Cuse xlink:href='%23h' transform='translate(0,549) scale(1,-1)'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 750 500'%3E %3Cdefs%3E %3CradialGradient id='a'%3E %3Cstop stop-color='%23ffef5d' offset='0'/%3E %3Cstop stop-color='%23ea5700' offset='1'/%3E %3C/radialGradient%3E %3CradialGradient id='b'%3E %3Cstop stop-color='%23952d1a' offset='0'/%3E %3Cstop stop-color='%23570a00' offset='1'/%3E %3C/radialGradient%3E %3C/defs%3E %3Cpath fill='%23ce1126' d='M0 0h750v500H0z'/%3E %3Cpath fill='%23003f87' d='M0 35.71h750v428.57H0z'/%3E %3Ccircle cx='375' cy='250' r='196.43' fill='%23fff'/%3E %3Ccircle cx='375' cy='249' r='162.81' fill='none' stroke='%23552300' stroke-width='4.1'/%3E %3Cg fill='%23007f00'%3E %3Cpath d='M356.19 76.24c14.72-15.8 28.04 2.45 27.68 11-.35 8.55-15.2 27.42-28.64 12.24 13.92 3.56 18.08-12 25.12-12.16-7.04.16-9.92-15.26-24.16-11.08zM202.92 200.12c-7.74-20.1 14.64-23.86 22.2-19.75 7.57 4.1 18.03 25.68-1.64 30.9 9.39-10.8-2.82-21.4.16-27.73-2.98 6.33-18.18 2.06-20.72 16.58zM533.28 180.24c20.17 7.9 7.85 26.83-.31 29.6-8.16 2.76-31.26-4.15-21.87-22.08 1.7 14.17 17.83 12.39 20.52 18.85-2.7-6.46 10.74-14.7 1.66-26.37zM269.58 393.14c-21.58-2.14-14.92-23.68-7.83-28.56 7.09-4.87 31.2-4.47 27.1 15.32-5.52-13.17-20.55-7.09-24.92-12.57 4.37 5.48-6.3 17.05 5.65 25.81zM487.64 377.55c.3 21.52-22.01 17.4-27.7 10.97-5.68-6.43-8.03-30.26 12.25-28.46-12.56 6.94-4.76 21.07-9.75 26 5-4.93 17.79 4.26 25.2-8.5zM218.64 159.24c-1.97-21.43 20.6-19.03 26.77-13.04 6.16 5.98 10.34 29.56-10.02 29.3 11.99-7.87 3.12-21.36 7.72-26.66-4.6 5.3-18.06-2.9-24.47 10.4zM241.76 360.29c-21.38-3.59-13.28-24.63-5.87-29.02 7.4-4.38 31.44-2.37 26 17.1-4.62-13.51-20.03-8.45-24.01-14.22 3.98 5.77-7.44 16.6 3.88 26.14zM410.72 77.13c19.42-9.58 25.33 12.17 21.94 20.04-3.4 7.87-24.03 20.27-31.16 1.34 11.74 8.24 21.2-4.85 27.84-2.51-6.64-2.34-3.81-17.76-18.62-18.87zM452.04 404.49c-9.63 19.28-27.6 5.51-29.69-2.79-2.1-8.3 6.78-30.56 24-19.77-14.37.49-13.93 16.59-20.64 18.7 6.7-2.11 13.86 11.86 26.33 3.86zM546.33 218.38c16.32 14.18-1.7 27.88-10.32 27.76-8.63-.11-28.03-14.33-13.1-28.08-3.22 13.9 12.57 17.61 12.92 24.6-.35-6.99 15.1-10.26 10.5-24.28zM272.4 105.04c4.87-20.97 25.56-11.7 29.54-4.1 3.97 7.6.52 31.29-18.74 24.74 13.87-3.77 9.69-19.33 15.72-22.94-6.04 3.6-16.25-8.35-26.52 2.3zM208.27 284.73c-19-10.37-4.36-27.6 4.08-29.32 8.45-1.72 30.48 8.04 18.87 24.64.13-14.26-16.1-14.52-17.95-21.26 1.85 6.74-12.52 13.23-5 25.94zM482.8 118.48c21.46-3.09 20.24 19.41 14.54 25.84-5.7 6.42-29.2 11.81-30.02-8.38 8.56 11.46 21.67 1.96 27.24 6.24-5.57-4.28 1.96-18.06-11.76-23.7zM360.73 425.12c-19.8 8.78-24.8-13.2-21.1-20.92 3.72-7.72 24.85-19.27 31.2-.07-11.4-8.7-21.4 3.98-27.93 1.38 6.54 2.6 3.08 17.9 17.83 19.61zM538.37 305.08c8.94 19.6-13.18 24.68-20.98 21.03-7.8-3.64-19.54-24.56-.22-30.95-8.72 11.35 4.11 21.2 1.52 27.7 2.6-6.5 18.02-3.13 19.68-17.78zM199.66 241.93c-12.44-17.63 8.36-26.68 16.7-24.52 8.35 2.16 23.78 20.56 5.98 30.38 6.46-12.75-7.99-20.08-6.65-26.95-1.34 6.86-17.13 6.39-16.03 21.09zM316.63 412.08c-20.35 7.43-23.85-14.83-19.62-22.29 4.23-7.45 26.1-17.56 31.12 2.03-10.77-9.46-21.6 2.53-27.95-.5 6.34 3.03 1.85 18.06 16.45 20.76zM310.76 84.94c12.06-17.89 28.08-1.93 29.08 6.57s-10.7 29.44-26.37 16.53c14.3 1.36 15.97-14.66 22.9-15.9-6.93 1.24-12.2-13.54-25.61-7.2zM519.27 347.62c1.3 21.48-21.19 18.39-27.16 12.22-5.98-6.17-9.42-29.87 10.93-29-12.23 7.51-3.79 21.27-8.55 26.42 4.76-5.15 17.97 3.46 24.78-9.64zM513.74 145.08c21.26 4.26 12.48 25.04 4.94 29.19-7.54 4.15-31.5 1.38-25.43-17.92 4.17 13.66 19.73 9.09 23.53 14.97-3.8-5.88 7.97-16.34-3.04-26.24zM244.54 129.94c.2-21.52 22.42-16.89 27.95-10.32 5.53 6.57 7.3 30.45-12.93 28.17 12.72-6.65 5.26-20.95 10.38-25.76-5.11 4.8-17.68-4.68-25.4 7.91zM217.66 323.91c-19.35-9.72-5.31-27.43 3.07-29.44 8.39-2 30.74 7 19.71 23.99-.36-14.26-16.59-13.97-18.67-20.65 2.08 6.68-12.07 13.65-4.11 26.1zM450 94.8c20.29-7.6 23.98 14.64 19.8 22.13-4.16 7.5-25.94 17.78-31.13-1.77 10.85 9.37 21.59-2.71 27.95.28-6.36-2.99-2-18.05-16.62-20.63zM406.94 422.71c-15.78 14.8-27.8-4.3-26.86-12.8.94-8.52 17.05-26.36 29.42-10.33-13.65-4.47-18.87 10.8-25.9 10.48 7.03.31 8.84 15.88 23.34 12.65zM545.18 258.13c14.8 15.73-4.51 27.57-13.08 26.6-8.56-.98-26.44-17.06-10.2-29.25-4.6 13.52 10.74 18.78 10.38 25.76.36-6.98 16.06-8.7 12.9-23.11z'/%3E %3C/g%3E %3Cg fill='%23005800'%3E %3Cpath d='M355.23 99.48c13.92 3.56 17.41-11.82 24.45-11.97-4.11 4.9-14.83 17.42-24.45 11.97zM356.19 76.24c14.72-15.8 28.04 2.45 27.68 11-11.95-20.83-15.69-17.62-27.68-11zM223.48 211.27c9.39-10.8-2.95-20.73.03-27.06 2.61 5.83 9.16 20.92-.03 27.06zM202.92 200.12c-7.74-20.1 14.64-23.86 22.2-19.75-24.1 1.4-22.86 6.15-22.2 19.75zM511.11 187.76c1.7 14.17 17.4 11.83 20.1 18.3-6.1-2.04-21.74-7.43-20.1-18.3zM533.28 180.24c20.17 7.9 7.85 26.83-.31 29.6 15.24-18.6 10.86-20.9.31-29.6zM288.85 379.91c-5.52-13.18-20-6.67-24.36-12.16 6.43.3 22.95 1.26 24.36 12.16zM269.58 393.14c-21.58-2.14-14.92-23.68-7.83-28.56-9.55 22.02-4.72 23.05 7.83 28.56zM472.19 360.06c-12.56 6.94-4.4 20.47-9.4 25.4-.43-6.37-1.35-22.77 9.4-25.4zM487.64 377.55c.3 21.52-22.01 17.4-27.7 10.97 23.14 6.91 23.61 2.03 27.7-10.97zM235.39 175.5c11.99-7.88 2.81-20.75 7.41-26.04.93 6.32 3.11 22.6-7.41 26.04zM218.64 159.24c-1.97-21.43 20.6-19.03 26.77-13.04-23.6-5.14-23.7-.23-26.77 13.04zM261.88 348.37c-4.61-13.52-19.5-8-23.48-13.76 6.4.72 22.81 2.79 23.48 13.76zM241.76 360.29c-21.38-3.59-13.28-24.63-5.87-29.02-11.03 21.33-6.27 22.68 5.87 29.02zM401.51 98.5c11.74 8.25 20.5-4.9 27.14-2.56-5.6 3.14-20.1 11.05-27.14 2.57zM410.72 77.13c19.42-9.58 25.33 12.17 21.94 20.04-3.72-23.69-8.36-22-21.94-20.04zM446.35 381.93c-14.37.48-13.34 16.22-20.05 18.34 2.55-5.86 9.27-20.87 20.05-18.34zM452.04 404.49c-9.63 19.28-27.6 5.51-29.69-2.79 17.4 16.63 20.07 12.5 29.69 2.79zM522.9 218.06c-3.21 13.9 12.38 16.95 12.72 23.93-5.05-3.94-17.95-14.24-12.72-23.93zM546.33 218.38c16.32 14.18-1.7 27.88-10.32 27.76 20.65-12.42 17.31-16.04 10.32-27.76zM283.2 125.68c13.87-3.77 9.2-18.84 15.23-22.45-1.11 6.3-4.15 22.44-15.23 22.45zM272.4 105.04c4.87-20.97 25.56-11.7 29.54-4.1-20.81-12.19-22.45-7.56-29.54 4.1zM231.22 280.05c.13-14.27-15.75-13.92-17.6-20.66 5.8 2.77 20.61 10.08 17.6 20.66zM208.27 284.73c-19-10.37-4.36-27.6 4.08-29.32-17.49 16.54-13.44 19.37-4.08 29.32zM467.32 135.94c8.56 11.46 21.02 1.69 26.6 5.96-6.31 1.26-22.58 4.28-26.6-5.96zM482.8 118.48c21.46-3.09 20.24 19.41 14.54 25.84 3.92-23.66-1.02-23.5-14.54-25.84zM370.82 404.14c-11.39-8.71-20.7 4.07-27.23 1.46 5.73-2.9 20.55-10.23 27.23-1.46zM360.73 425.12c-19.8 8.78-24.8-13.2-21.1-20.92 2.74 23.82 7.45 22.32 21.1 20.92zM517.17 295.17c-8.72 11.34 4.2 20.52 1.6 27.01-2.96-5.66-10.4-20.33-1.6-27.01zM538.37 305.08c8.94 19.6-13.18 24.68-20.98 21.03 24-2.83 22.46-7.5 20.98-21.03zM222.34 247.79c6.46-12.75-7.94-19.4-6.6-26.25 3.96 5.02 14 18.08 6.6 26.25zM199.66 241.93c-12.44-17.63 8.36-26.68 16.7-24.52-23.05 7.18-20.68 11.49-16.7 24.52zM328.12 391.82c-10.77-9.46-20.92 2.67-27.26-.37 5.9-2.52 21.19-8.82 27.26.37zM316.63 412.08c-20.35 7.43-23.85-14.83-19.62-22.29 1.1 23.95 5.9 22.78 19.62 22.29zM313.47 108.04c14.31 1.36 15.34-14.37 22.27-15.61-3.29 5.48-11.91 19.5-22.27 15.61zM310.76 84.94c12.06-17.89 28.08-1.93 29.08 6.57-15.1-18.72-18.28-14.97-29.08-6.57zM503.03 330.85c-12.23 7.5-3.46 20.65-8.22 25.8-.72-6.34-2.4-22.68 8.22-25.8zM519.27 347.62c1.3 21.48-21.19 18.39-27.16 12.22 23.43 5.85 23.68.95 27.16-12.22zM493.24 156.35c4.18 13.65 19.23 8.61 23.02 14.5-6.36-.93-22.7-3.51-23.02-14.5zM513.74 145.08c21.26 4.26 12.48 25.04 4.94 29.19 11.7-20.97 7-22.47-4.94-29.19zM259.57 147.78c12.72-6.65 4.9-20.36 10-25.17.28 6.37.81 22.8-10 25.17zM244.54 129.94c.2-21.52 22.42-16.89 27.95-10.32-22.96-7.45-23.55-2.58-27.95 10.32zM240.44 318.46c-.36-14.26-16.22-13.38-18.3-20.06 5.88 2.58 20.95 9.39 18.3 20.06zM217.66 323.91c-19.35-9.72-5.31-27.43 3.07-29.44-16.9 17.12-12.77 19.81-3.07 29.44zM438.67 115.16c10.85 9.37 20.9-2.84 27.27.14-5.9 2.57-21.12 9-27.27-.14zM450 94.8c20.29-7.6 23.98 14.64 19.8 22.13-1.3-23.94-6.1-22.72-19.8-22.12zM409.5 399.59c-13.64-4.47-18.18 10.64-25.22 10.33 4.44-4.63 16-16.4 25.22-10.33zM406.94 422.71c-15.78 14.8-27.8-4.3-26.86-12.8 10.5 21.57 14.44 18.61 26.86 12.8zM521.9 255.48c-4.6 13.52 10.6 18.1 10.24 25.08-4.63-4.43-16.42-15.96-10.24-25.08zM545.18 258.13c14.8 15.73-4.51 27.57-13.08 26.6 21.81-10.31 18.85-14.25 13.08-26.6z'/%3E %3C/g%3E %3Cg%3E %3Cg stroke-width='.51'%3E %3Cg fill='%23730000' stroke='%23000'%3E %3Cpath d='M405.26 125.34s.61-1.43 1.73-.61c1.02.81 1.32 4.38 1.32 4.38l-1.63.8s.92-1.31-1.42-4.57zM396.01 157.29s.81-1.12-.3-3.56l1.62-.51s.61 1.93-.2 4.07H396M424.19 151.69l-3.87 2.34 1.94.92 4.68-2.75-2.75-.51M372.4 166.85c-1.02.81-1.12 2.24-1.73 3.05-.5.82-2.03 1.93-2.14 3.16a6.6 6.6 0 0 0 .2 3.66c.62 1.63 3.16 8.85 2.14 14.35-1.12 5.49-.7 7.83-.3 8.65.4.81 1.63 3.05 2.34 3.05 1.63-.2.92-.71 1.52-1.73 1.53-2.65 0-23.1-.7-28.8-.51-4.37-2.55-8.34-2.75-8.75-.2-.5-.61-1.83-.92-2.65-1.52-3.66-3.36-6.81-3.36-14.45 0 0-4.98 1.13-9.25-8.54-2.24-4.89-5.5-4.38-9.36-6l1.73-1.13s3.25 1.63 4.88 1.63 1.12-3.25 1.12-3.25l1.63-1.63v7.12c0 3.26 4.48 7.73 7.12 9.06 1.63.81 3.77-2.55 3.26-5.8-.51-3.26 0-7.63 0-7.63l2.24 1.32s-.82 1.42-.61 2.24c.3.81 1.42-.82 2.23-1.63 0 0 .2.2 1.02.2 0 0-1.63 2.75-2.44 4.17-.81 1.33-.81 6.52-.81 8.45 0 1.94.71 6.41.71 7.83 0 1.03 1.93 5.2 3.46 7.74.5 1.02 1.73 3.66 1.73 3.66 1.22 1.93 1.32 3.26 2.03 4.89.4.81 1.12 3.15 1.63 7.22.2 1.02.4 4.89.71 7.43.3 2.44 2.34.5 4.78-1.22 2.45-1.83 2.45-6.2 2.45-6.2s1.93-1.64 1.62-.72c-.2 1.02 1.02 2.04 1.02 2.04-1.52 3.45-.6 3.05.92 2.95 1.52-.21 6.81-4.18 6.81-4.18.72-.2 3.87-.2 3.36 0-.6.3-1.42 1.83-1.42 1.83l3.46-.4c-1.23.91-5.8 3.56-6.82 4.17a93.97 93.97 0 0 1-8.95 4.27c-2.34 1.02-6.92 3.26-7.12 5.6-.1 2.34.3 8.65 0 10.68-.2 2.04-1.02 11.1-1.02 11.1h-10.89s2.14-7.94-.1-10.08c-2.14-2.24-7.12-8.75-10.38-10.99-3.26-2.14 2.14-.5 2.14-.5v-2.25l4.98 6.01s8.65-7.63 0-18.01c-2.75-3.26-5.5-8.24-7.63-8.75-2.24-.61-3.36-1.12-7.12 0-3.87 1.12-13.13 1.12-17-4.99l3.27-.5 2.74-1.13s-1.12 3.87 6.61 3.87c7.63 0 8.75 0 8.14-7.12l2.24-1.12 1.63 1.63s-1.12 3.86-.51 5.5c.5 1.62 3.26 2.74 5.4 4.37.9.7 1.62.81 2.23.81.92-.1 1.12-.1 2.34-1.32 1.83-2.04 1.42-1.94 3.26-3.56 0 0 .91-1.43 1.12-1.63l1.12 2.95h-.01z'/%3E %3Cpath d='M374.03 161.46c.4-.4 1.22-1.93 1.93-3.26 1.22-2.03 2.65-3.25 4.27-5.8 1.53-2.34 2.14-5.8 1.53-8.24l1.42.82.1 3.86s1.94-1.63 2.76-2.03l.8.4s-6.1 6.31-11.8 16.49l-1.01-2.24zM320.52 140.3c.81 1.42 1.63 4.17 4.07 6.3l1.63-.5s-3.77-4.38-3.77-6.3l-1.93.5M330.08 137.85s.5 5.19-.81 7.12l1.62-.8s1.12-3.57.82-5.5l-1.63-.82zM383.7 121.47s-.3 7.33 1.12 11.8l1.93-.6s-.3-1.33 1.32-1.94c1.63-.51 5.5-2.14 7.43-3.77l-.6-1.62s-2.96 2.34-4.38 2.95c-1.33.5-2.14 1.11-3.26.81-1.12-.3-2.44-2.14-1.63-6.3l-1.93-1.33M405.26 155.66s-.5 5.19-.2 7.43l1.73.4s-.4-6.2.7-6.7l-2.23-1.13M413 159.53s-1.93 3.36-4.17 3.66l3.56-.71s1.02-.5 2.54-2.13l-1.93-.82'/%3E %3C/g%3E %3Cg fill='%23289400' stroke='%23030'%3E %3Cpath d='M381.87 144.16l1.32.81 1.43.2s1.52 1.43 3.25 2.75c1.32 1.12 1.32-.2 1.32-.2l.81 3.26h1.12s-.3 2.13-.3 3.25l1.93-1.63 2.24 1.94s1.63-1.43 2.44-1.43 1.12-.8 1.12-.8h.1c-5.39-2.56-7.73-5.2-6.1-7.95 2.65-4.58 7.02-1.63 8.44-1.01l19.74 10.58s1.32-.82.4-1.63c-1.01-.81-1.42-2.85-1.11-3.66.3-.82 2.54 2.54 3.66 2.84 1.12.31 3.66.72 3.66.72l-.1-1.02s3.25 2.24 3.25 3.36c0 0 2.34-1.22 1.53-1.94-.82-.7 3.56 1.74 3.86 3.06l.92-1.02c-.1 0 .3-3.26 1.42-4.78 1.02-1.53 2.14-1.94 2.14-1.94s1.02-1.73 2.03-1.73c0 0-1.02-.7-1.42-1.52-.51-.82-1.73-1.22-1.73-1.22s1.52-1.12 1.93-1.63c.4-.61.82-.72.82-.72s-2.34-1.93-3.97-2.23c0 0-.1-2.65-2.14-2.85h.92s-1.53-2.85-2.95-2.95c0 0 .91-1.02 1.73-1.12 0 0-1.73-2.24-4.07-1.42l1.52-.61s-1.12-1.22-4.57-.61c0 0 .3-1.43-1.22-2.55 0 0-1.33.1-1.33 1.12 0 0-1.22-1.12-2.74-1.12-1.53 0 .5 1.63.5 1.63s-2.03-1.32-3.25-.91c0 0 .5-2.34-.81-3.57 0 0-1.53.82-1.94 1.84l-.4-1.02s-2.04 2.44-2.44 1.73c-.3-.4-.61-2.14-.61-2.14l-1.22 1.84.2-2.55s-1.42.81-2.54 3.46c0 0-1.43 1.32-1.43 2.54 0 0-1.12-1.32-2.14 0-.91 1.42 0 1.12 0 1.12s-.4.5-1.42.71l.2.81s-1.32-.7-2.33-.4l.5 1.22s-2.64.2-2.74-1.93c0 0-2.24-1.12-2.55.1l-1.62 1.02s-.51-1.02-1.43-1.22c-1.02-.3-.2 1.32-.2 1.32s-.3-1.22-1.53-1.83c-1.22-.51-.2 1.12-.2 1.12s-1.63-1.33-.81-2.34c0 0-1.53 1.42-.82 2.75l-1.01.7s-.51-.5-.41-.91c.1-.4-1.73 1.22-1.73 1.22s-1.12-2.64 0-2.64c.1 0-1.93-.1-2.24 2.24 0 0-1.32.1-2.54.5-1.32.4.91 1.33.91 1.33s-1.93-.41-3.05.2l.71.92s-.71-.72-2.44-.1c-1.83.5.4.8.4.8s-1.82-.4-2.74 0c-.92.41.3 1.12.3 1.12s-3.35-1.01-3.86-.7c-.5.3 1.12 1.93 1.12 1.93s-2.04.5-2.44 2.03l1.83.71s-.81.4-1.22 1.23c-.4.8 1.22.4 1.22.4s-2.24 1.63-2.24 2.85c0 0 1.63.5 2.85-.71s.4-.82.4-.82l.1.82s2.35-1.02 2.35-1.63c0-.5-.4.81-.4.81l2.34-1.22 1.52 1.02z'/%3E %3Cpath d='M379.93 112.42l-.5-2.24 5.18.61.91-2.13s2.45 1.11 3.26 1.92c0 0 4.78-1.21 6.2-.7l-.6 2.23s4.37.3 5.8.82c1.32.5-.61 1.63-.61 1.63s4.98.6 7.12 1.93c2.24 1.32 2.24 2.44 1.12 2.74l2.74 4.38s-4.37.5-5.18 1.62c-.82 1.12-1.63-1.11-1.63-1.11l-.82 3.05s-2.74-1.43-3.86-2.44c0 0-1.32 1.63-.5 2.44l-5-3.26s-2.13-.3-2.13 1.63c0 0-2.44-2.75-3.05-3.56l-2.75.81s-.81-1.11-1.83-1.42c-1.12-.2-.3 1.42-.3 1.42l-1.63-1.93-1.63-1.93s-1.43 1.93-2.55 1.93c-1.02 0-1.02-1.32-.81-2.24.3-.81-3.26-1.01-3.56 0 0 0-1.02-4.07 2.75-5.18l3.86-1.02zM360.2 126.36l-1.73 1.63-1.02-.5-2.03 2.23-.4-1.22-1.13 1.83-1.73-.61-.81 1.32-1.53-.3s-1.32 1.22-2.13 1.52c-.82.2 0-1.83 0-1.83s-1.22 2.03-2.14 2.03c-.81 0-.5-.91-.5-.91s-.52 1.32-1.53 1.52c-.92.1-.51-1.01-.51-1.01l-1.63 1.22v-1.02l-.71-.3s.4-1.84 1.12-2.24c.7-.41-.71-1.63-.71-1.63l.7-.81s-2.03-.51-2.03-.1c0 0 1.02-2.75 2.44-3.26l.1-3.05s1.43-1.22 2.75-1.33c1.43-.2-.4-2.34-.4-2.34l3.25-1.93.4-2.34 5 .4 1-2.13 3.98 1.02 3.35-1.73 2.44 2.85 3.67.3s-.1 2.54-.1 3.26c0 0 4.37 1.32 4.88 1.73 0 0-.82 2.64-.82 3.15 0 0 3.06-.81 3.97-.6l.4 3.55s5.2 1.63 5.5 2.55c0 0-1.12.7-1.73 1.63 0 0 .61 3.15.61 4.17l-.4.6s-1.53-1.42-2.75-1.62l-1.02 2.24-1.83-1.22-1.12.1s-.92-1.12-1.63-1.12l-.1-1.02-1.43.92s-2.23-1.12-2.23-1.83c0-.61.1-1.63.1-1.63l-2.34 1.63s-.5-1.22-.4-1.73c.1-.51-.92 1.22-.92 1.22s-1.22-2.14-1.12-2.55l-.3 1.73s-2.45-.8-2.75-2.44z'/%3E %3Cpath d='M327.64 136.33s4.27 2.14 4.27 3.16c0 0 1.12-2.24.51-3.06l1.63 1.12s.5-2.03-.1-2.64c-.51-.51 3.66-2.24 4.57.5 0 0 2.55-2.64-2.33-4.88 0 0-.41-1.62 2.54-1.22 0 0-.2-1.01-.92-1.42h2.85s-1.73-1.43-4.27-1.83c-2.44-.41-.92-.71-1.02-1.23-.2-.5 0-2.34 0-2.34s-1.42-.5-2.54.1l.4-.5s-2.64-.71-3.66-.1c0 0-1.52-.62-1.32-2.25 0 0-1.53-.1-2.24 1.53 0 0-1.42 1.63-3.35 1.63-.4 0-1.84-.82-1.84-.82l-1.22 2.85-1.93-.1.61 1.12s-2.95-.81-3.87 0c0 0 1.12 1.73.82 2.95 0 0-2.34.4-2.85.82-.61.4.81.7.81.7s-2.64.82-3.26 1.64l1.02.8-1.22 1.64 1.02.2s-1.73.5-2.64.81c-.92.3 1.62.51 1.62.51l-1.22 1.12 1.94.3s-1.53 4.08-1.63 6c0 0 2.34-2.84 2.95-3.04l-1.83 3.05s3.46-1.12 3.77-1.63c.3-.61.6-1.12.6-1.12l.1 1.73s1.33-1.83 1.53-2.54c.1-.71 2.14.7 2.14.7v-1.01s1.83.6 2.44.71c.71.1.81-.3.81-.3l1.73-.2-.3 1.42s1.22-.82 1.52-1.63c.2-.82.81 0 .81 0l.81-3.26h1.73l.01.01zM313.7 150.78l1.63 3.36c-1.32.1-3.26 1.62-3.26 1.62.3 5.6-1.12 5.3-1.12 5.3.4 1.01-.25 2.9-.25 2.9l8.09-4.84.1-.5 9.56-4.48.3.5 2.75-1.52 1.94 5.08-1.94 1.12c.1 1.73 2.14 4.79 2.14 4.79l2.54-.61 2.75-1.02s.1 1.52.1 1.02c0-.41 2.95-1.42 2.95-1.42l1.33 1.32c1.02-.1 2.84-2.55 2.84-2.55l2.14.82s.71-1.22.71-2.14c0-.81 2.65-.81 2.65-.81l1.83 1.32 2.34-1.93s.71 1.42 1.63 1.62c1.02.1 3.56 2.04 3.56 1.63 0-.4 1.12-2.64 1.12-2.64l4.27 1.73c-.6-1.94-2.03-4.28-2.03-4.28s2.03-1.62 1.62-2.03-1.62 0-1.62 0l1.22-2.44h-1.63l.5-.61-2.64-1.12 1.42-2.85c-.6-.71-7.62-2.14-7.62-2.14l1.62-1.52s-.81-1.22-1.62-1.22-5.1.1-5.3-.3c-.1-.41-1.83-1.94-1.83-1.94l-2.64 1.94-1.33-.41-2.34.91s0 1.33-.3.4c-.3-.8-2.44-2.94-2.44-2.94-.4.7-3.16 3.97-3.16 3.97s-.4 1.73-1.32.5c-1.02-1.22-3.15-2.54-3.46-1.52-.3 1.12-2.23 2.13-2.64 1.83-.4-.3-2.65-.1-2.85.5-.1.72-2.55 2.55-2.55 2.55-1.52-.7-3.97-.3-3.97-.3s-.7 1.12-.8 2.03l-5 1.32h.01zM359.69 191.99v-2.14l2.44 1.63 1.43-1.63 1.83 1.83 1.12-1.83v2.95l2.74-2.44 1.63.71v-2.34s1.93-3.25 1.12-3.86l1.63-.51s-2.75-2.75-3.56-3.26c-.82-.6-1.94-.6-1.94-.6s-2.13-2.15-3.56-2.75c-1.32-.51-2.14.6-2.14.6s-.8-1.62-2.23-1.93c-1.32-.3-1.32 1.12-1.32 1.12s-1.02-1.02-2.34-1.53c-1.33-.6-.41 1.22-.41 1.22l-4.68-1.42.6 1.42-4.37-1.11.51 1.63-3.05-.52-.2 1.33-4.38.81.82 1.43-2.75-1.12v1.93l-3.05 1.12 1.12 1.02s-4.07 1.93-4.89 2.54c-.81.51 1.63 1.63 1.63 1.63l-4.37-.61 1.62 1.42-3.86 3.57 2.74 1.93-1.62 2.44 4.07.81 1.62 2.75 3.36-.61v3.05l4.88-3.86s3.57 3.15 3.87 2.23c.2-.81.2-3.56.2-3.56h1.73v-2.74l1.32 1.11 2.24-3.25 2.95 4.07 2.24-5.19 3.25.5.01.01zM379.63 179.68l-.5-4.68-1.43 1.42.6-4.37-2.23-.4.81-4.28-1.62-.82.4-2.03 1.63-1.22 2.95-2.85 6.81.1.82-2.23 4.88.81c.81.92 3.36-1.83 3.36-1.83h1.02l1.12 2.13s3.56-.5 5.18.61l-1.93 2.65 3.56.3 2.44.51 2.54-.81 3.26-.2.81 1.32h3.06l-1.02 1.22 3.97 1.83-.82.81s2.24.82 3.87.82h.81s.81 1.93-.3 2.74c0 0 1.11 2.75 3.56 3.26 2.44.5 2.44.5 2.74 1.12.31.5 0 3.25-2.74 3.25v2.75s-2.14 1.94-2.44 2.75l-1.63-1.12s-1.43 1.63-1.43 2.75c0 0-3.56-4.69-4.88-4.9-1.42-.3-1.12 2.66-1.12 2.66l-3.86-3.26-.51 2.24-3.26-2.75-1.93 1.32-3.46-3.56-3.36.41 1.32-1.73h-4.07l-.81-3.56-.61 2.95-2.44-1.63-3.15 3.46s-.41-.4-.92-2.03c-.5-1.63-1.93 1.93-1.93 1.93l-1.12-2.55-1.33 2.55s-1.12-1.94-2.23-2.55c-1.02-.5-2.14 3.06-2.44 4.69zM380.24 190.36l.2-1.63 5.8-2.24 4.89-1.83 2.43-1.12 1.12 1.94 1.43-2.75 2.24 2.85 1.22-1.53 1.93 1.43h1.63l.3 2.14s4.07.3 4.38-.51c.3-.82.8 2.74.8 2.74l3.87.51.82 4.38s1.93 4.07 1.32 5.7c-.51 1.73-2.14-2.14-2.14-2.14s-.3 3.05-.6 3.86c-.21.82-5.2-.8-5.2-.8l-2.13 4.06s-2.24-3.25-3.26-3.25c-1.12 0-1.12 3.25-1.12 3.25s-3.25-3.87-4.68-5.5c-1.32-1.62-1.62 1.63-1.62 1.63s-2.14-3.56-2.14-4.57c0-1.12-1.93-2.24-1.93-2.24s-3.36 3.86-5.8 4.88c0 0 .3-2.44-.51-3.25-.82-.82-3.26 1.62-3.26 1.62s-1.73-3.76 0-7.63h.01z'/%3E %3C/g%3E %3Cg fill='none' stroke='%23004b00'%3E %3Cpath d='M407.1 129.71l.5 2.04s1.84-.41 3.06-.31c0 0-.3 1.63-.71 2.34 0 0 2.44-.4 3.56.3l-.5 1.22 2.84 1.22-2.64 2.14s4.27 1.53 5.08 2.75c0 0-2.74 1.93-3.15 1.83-.4-.2-.1.81.6 1.73l-2.33-.1s.91 2.13.81 2.95c-.1.81-3.87.6-3.87.6M425 142.94s.71-4.07-.4-5.09c0 0 2.64 2.24 4.37 2.34 1.83.1-.1-3.35-.1-3.35s2.54 1.32 3.76 1.62c1.22.2-.92-2.54-.92-2.54s.72-1.32 2.75-.1M387.16 119.64s.1-.92-.3-1.42c-2.45-3.36 2.54 2.54 3.55 2.74M395.09 120.96s1.63 1.22 2.44 1.22c.82 0-.5-3.26-.91-3.66-.41-.41 2.95 1.32 4.17 1.52 1.22.3 1.42-2.03 1.42-2.03s3.77.6 4.58 1.12M380.64 118.42s-.3-2.14-.4-3.05M355.01 128.6c-.2-.4 1.02-2.24.5-3.05 0 0 .72.6 1.43.71.61.1.4-2.34.4-2.34l.82.3s2.14-1.02 1.73-1.83c-.4-.81 1.42 1.22 1.42 1.22s1.23-1.22 1.23-1.73 1.42 1.22 1.42 1.22 1.52-.3 1.52-1.22c0-.91 1.94.3 1.94.3s.8-1.11.7-1.83M347.58 130.53s.91-2.13-.1-3.56M322.86 137.24c.1-1.02.6-3.76.1-4.17-.5-.4 1.02.4 2.24.71M334.86 133.38c-1.22-1.22-1.93-1.83-3.86-1.83M314.21 140.19c.3-.71.81-2.44.5-3.46M340.76 190.66l1.32-2.75 1.63 3.87 1.12-2.44.4.81 2.44-2.64 2.65 3.96M392.75 174.28l1.73-3.46 2.34 1.22 1.12-3.35 2.44 1.52 1.42-3.15 2.75.71.2-2.24s1.94 1.12 2.44 1.93c.61.82 0-2.74 0-2.74l2.24 1.02s1.63-1.63-.6-2.55'/%3E %3Cpath d='M399.57 169.91l2.44 3.56 2.03-2.34 1.84 3.97 2.34-1.42 3.35 1.93 1.53-1.22 3.66 2.64 1.52-3.15 3.26 1.02 2.14-3.66M335.78 161.67s1.43-2.45.92-3.56c-.62-1.12 2.95 1.93 2.95 1.93s.8-2.44.3-3.56c-.61-1.12 4.07 3.26 4.07 3.26s.81-3.77 0-4.58c-.81-.82 4.48 1.12 4.48 1.12s2.13-.61 1.32-1.73c-.82-1.12 3.56 1.62 3.56 1.62s1.02-2.74 0-3.76c-1.12-1.12 3.25 1.32 3.25 1.32l-1.62-2.95 3.56.2-.3-3.25M389.8 194.73l2.34-1.12 2.03 2.04 2.24-3.56 2.75 2.64.4-2.64 2.95 1.22.62-1.63 3.25 1.73.3-2.44 1.63.5.3-1.62'/%3E %3C/g%3E %3C/g%3E %3Cpath fill='%239dd7ff' d='M336.59 310.53a72.75 72.75 0 0 1-6.2-13.53l44.04-38.77 44.06 38.66a67.3 67.3 0 0 1-6.4 13.84l-.36.57c-.81-.3-3.31-1.28-3.31-1.28s-1.43 1.33-2.54 1.43c-1.53.2-2.85-1.32-2.85-1.32s-1.94 1.62-3.87 1.32c-1.93-.2-2.75-1.43-2.75-1.43s-2.03 1.63-3.46 1.33c-1.32-.31-2.23-1.23-2.23-1.23s-1.22 1.53-2.95 1.23c-1.63-.31-3.16-1.23-3.16-1.23s-2.54 1.12-4.17 1.32c-1.62.31-3.05-1.42-3.05-1.42s-2.14 1.42-2.95 1.42-3.86-1.42-3.86-1.42-3.16 1.02-4.28 1.02c-1.02 0-4.17-1.32-4.17-1.32s-2.95.8-4.27.8c-1.42 0-3.46-.8-3.46-.8s-2.44 1.11-3.76.8c-1.43-.3-2.55-.8-2.55-.8s-2.64 1.11-4.37.8c-1.63-.3-3.56-1.41-3.56-1.41s-.3.81-3.46 1.42h-.1'/%3E %3Cpath fill='%23fff' stroke='%23000' stroke-width='.71' d='M374.44 213.66v44.57l-44.05 38.97a87.68 87.68 0 0 1-4.58-28.29v-55.25h48.63'/%3E %3Cpath fill='%23ffd83c' stroke='%23000' stroke-width='.71' d='M374.44 213.66v44.57l43.95 38.97a87.7 87.7 0 0 0 4.58-28.29v-55.25h-48.53'/%3E %3Cg stroke='%23000' stroke-width='.51'%3E %3Cpath fill='%23730000' d='M346.02 301.27c3.31 1.8 2.19 1.23 9.05 3.66 5.6 1.94 12.11 2.85 21.57 2.85 8.28 0 12.94-.66 15.56-1.38 2.72-.78 3.37-1.88 3.37-1.88l-6.82 6.92s-27.4 1.48-32.35-1.73c-1.93-1.02-6.1-4.37-10.38-8.44z'/%3E %3Cg fill='none'%3E %3Cpath d='M386.21 288.35s8.75 4.98 0 14.55M346.84 301.78l12.62-12.01-1.43 16.08M364.64 307.27v-26.86M386.21 307.27v-28.49M375.32 307.78v-30.63'/%3E %3C/g%3E %3Cg fill='%23ff0018'%3E %3Cpath d='M364.64 281.84l-5.7 1.83 5.7.61v-2.44M375.32 277.66l-6 2.24 6 .2v-2.44M386.21 279.29l-6 2.24 6 .3v-2.54zM389.77 292.22c-.3-1.22 3.56-1.12 3.56-1.12s1.12 4.07 0 6.61l-3.25-.6s.3-2.75-.31-4.89z'/%3E %3C/g%3E %3Cg fill='%23fff'%3E %3Cpath d='M348.77 300.15l10.68-10.38-.5 6.2s-5.5 3.57-5.5 6.11l-4.68-1.93M354.46 302.29s1.12-3.26 4.17-4.88l-.3 6.5-3.87-1.62zM369.83 284.28s4.37-.61 7.63 0c0 0-.5 4.38 0 5.19 0 0-6-1.43-8.44.81 0 0-.82-4.07.81-6zM360.57 285.4s4.38-.61 7.63 0c0 0-.81 4.89-.3 5.7 0 0-4.9-2.75-7.33-.51 0 0-1.63-3.36 0-5.19z'/%3E %3Cpath d='M360.26 291.09s4.37-.5 7.63 0c0 0-.5 4.38 0 5.2 0 0-5.7-1.33-8.14.8 0 0-1.12-4.07.51-6zM369.01 290.28s6.3-.81 9.56-.3c0 0-1.32 3.56.3 6 0 0-6.8-1.83-9.35.3 0 0-2.14-4.07-.51-6zM359.76 297.1l8.44.6s-.81 6.22-.3 7.03c0 0-6.82-1.63-8.14.6 0 0-2.24-5.69 0-8.23zM369.32 297.1s7.32-.51 10.68 0c0 0-1.93 4.68.2 8.75 0 0-9.56-2.74-10.88-.51 0 0-2.24-5.7 0-8.24zM380.51 284.28s4.37-.61 7.63 0c0 0-.5 4.38 0 5.19 0 0-6-1.43-8.44.81 0 0-.82-4.07.81-6zM380.51 290.28s4.37-.5 7.63 0c0 0-.5 4.38 0 5.19 0 0-6-1.32-8.44.81 0 0-.82-4.07.81-6zM381.02 296.59s4.37-.6 7.73 0c0 0-1.12 6.82-.6 7.63 0 0-5-2.34-7.33-.3 0 0-1.43-5.4.2-7.33z'/%3E %3Cpath d='M390.07 297.1s1.42 5.19 3.25 5.8l-2.44 2.95s-2.95-2.14-3.25-4.58c0 0 1.93-2.24 2.44-4.17z'/%3E %3C/g%3E %3C/g%3E %3Cg stroke='%23000' stroke-width='.61'%3E %3Cpath fill='%23006ac8' d='M411.88 311.14c-7.02 11.7-18.52 22.69-37.44 29.5-19.23-6.91-30.93-18.4-37.84-30.01l.1-.1c3.15-.62 3.46-1.43 3.46-1.43s1.93 1.12 3.56 1.43c1.73.3 4.37-.82 4.37-.82s1.12.51 2.55.82c1.32.3 3.76-.82 3.76-.82s2.03.82 3.46.82c1.32 0 4.27-.82 4.27-.82s3.15 1.32 4.17 1.32c1.12 0 4.27-1.01 4.27-1.01s3.06 1.42 3.87 1.42 2.95-1.42 2.95-1.42 1.42 1.72 3.05 1.42c1.63-.2 4.17-1.32 4.17-1.32s1.53.92 3.16 1.22c1.72.3 2.95-1.22 2.95-1.22s.91.92 2.23 1.22c1.43.3 3.46-1.32 3.46-1.32s.81 1.22 2.75 1.42c1.93.3 3.87-1.32 3.87-1.32s1.32 1.53 2.84 1.32c1.12-.1 2.55-1.42 2.55-1.42s2.54.81 3.45 1.12' stroke='none'/%3E %3Cpath fill='none' stroke-width='.51' d='M410.15 313.79c-1.52.1-1.73-.92-1.73-.92s-2.03 1.74-3.97 1.43c-2.03-.3-2.95-1.63-2.95-1.63s-2.13 1.73-3.56 1.43c-1.42-.2-2.44-1.23-2.44-1.23s-1.32 1.53-3.05 1.23c-1.73-.2-3.26-1.23-3.26-1.23s-2.74 1.13-4.47 1.43c-1.73.3-3.16-1.63-3.16-1.63s-3.97 1.33-4.78 1.33c-.91 0-3.76-1.33-3.76-1.33s-1.94 1.23-3.06 1.23c-1.22 0-4.47-1.43-4.47-1.43s-3.06.82-4.48.82c-1.42 0-3.56-.82-3.56-.82s-2.65 1.12-4.07.82c-1.42-.31-2.54-.82-2.54-.82s-2.85 1.12-4.58.82a15 15 0 0 1-3.77-1.43s-.3.71-3.66 1.43h-.1'/%3E %3Cpath fill='%235ac800' d='M346.97 317.94s-.28.67-2.94 1.25c-.05 0-.72.16-.72.16l.66-.13-.75.25c3 4.34 7.5 8.27 12.18 11.42 4.68 3.16 10.06 6.93 19.23 9.61 9.63-3.76 12.2-5.19 18.5-9.4 6.3-4.6 9.58-7.47 13.09-12.2-2.75 1.57-2.36 1.59-3.78 1.38-1.43-.3-2.47-1.34-2.47-1.34s-1.3 1.55-3.03 1.34c-1.73-.3-3.25-1.34-3.25-1.34s-2.26 1.54-4.5 1.44c-1.73-.1-3.16-1.63-3.16-1.63s-3.97 1.31-4.78 1.31c-.92 0-3.75-1.3-3.75-1.3s-1.94 1.21-3.06 1.21c-1.22 0-4.47-1.44-4.47-1.44s-3.05.82-4.47.82-3.56-.82-3.56-.82-2.54 1.12-4.06.82c-1.43-.3-2.57-.82-2.57-.82s-2.83 1.12-4.56.82c-1.73-.3-3.78-1.41-3.78-1.41z'/%3E %3Cpath fill='%23ffd800' d='M374.63 340.51c9.95-4.14 11.75-5.27 17.77-8.95-1.05.03-4.1-.96-3-1.27 0 0-1.22 1.1-2.44 1.1-1.12 0-4.38-1.42-4.38-1.42s-3.05.81-4.47.81-3.56-.81-3.56-.81-2.65 1.12-4.07.81c-1.43-.3-2.55-.81-2.55-.81s-2.95 1.12-4.57.81c-1.73-.3-3.77-1.42-3.77-1.42s-2.5 1.32-4.08 1.48c4.81 3.52 9.88 6.96 19.12 9.67z'/%3E %3C/g%3E %3Cg stroke='%23000' stroke-width='.51'%3E %3Cpath fill='%23b34b00' d='M367.88 259.34c1.98-1.61 3.11-3.16 2.45-4.36-.74-1.04-1.9.64-3.21.25 0 0-1.98-1.22-2.52-2.1-1.15-1.28-2.63-2.43-3.49-3.53-.9-1.02-4.3-5.53-9.49-10.7-1.49-.98-1.15-4.66-2.22-5.8-.09-.8-10.35-10.96-14.02-14.64-1.48-1.09-2.26-1.8-4.86.57-2.06 1.85-2.8 3.76-.1 6.07l13.35 12.15c1.96 1.9 4.68 2.24 5.82 3.22l13.58 13.88c1.7 1.48 2.53 2.53 1.56 3.8-1.07 2.07.08 2.35.32 2.41.16.09 1.12.08 1.76-.4l1.07-.82z'/%3E %3Cpath fill='none' stroke-width='.5' d='M334.02 222.92l13.96 13.8'/%3E %3Cpath fill='%23fff' stroke-width='.57' d='M352.92 229.22c.22-.41.69-1.47 1.19-2.63.2-.45 3.95-6.44 5.82-6.62 0 0 11.68 8.5 11.69 8.61.03.46-5.07 8.1-5.51 7.51 0 0-13.68-5.74-13.19-6.87z'/%3E %3Cpath fill='%23ccb8c8' d='M360.36 231.22c-1.6-1.24-4.24-2.45-6.38-3.88l-.95 2c.77.87 10.48 5.39 12.08 6.25 0 0-1.85-2.12-4.75-4.37z' stroke='none'/%3E %3Cpath fill='none' stroke-width='.4' d='M353.98 227.09c1.25.88 3.63 2.38 5.13 3.25 2.87 2 4.69 4.2 6.75 5.38'/%3E %3Cpath fill='%23782121' d='M330.32 263.48l26.59-32.9c.5-.46 2.96-.48 3.3 2.06l-25.18 34.32s-2.87-.28-4.71-3.48z'/%3E %3Cpath fill='%23730000' d='M419.44 263.84c-.92.71-2.47.9-2.47.9-1.73-2.04-3.16-4.17-5.6-6.82l-26.55-32.66 2.74-2.64 23.9 27.98c.72.7 4.9 5.08 8.86 10.27 0 0 .35 2.03-.88 2.97z'/%3E %3Cpath fill='%23fff' d='M393.87 229.43l-4.27-5.09s-3.26.4-3.87 2.14c0 0-2.34 3.87-8.54 4.27 0 0 1.72 7.23 8.95 11.1 0 0 2.64-7.44 5.19-8.76 0 0 2.64-1.93 2.54-3.66z'/%3E %3Cpath fill='%23730000' d='M383.19 252.02c-.6-.2-1.22 0-2.14.5-.8.52-1.83.31-1.73-.7.1-.92 0-.82 1.12-1.53a6.52 6.52 0 0 1 5.09-.5l-2.34 2.23M412.18 223.12c-.2-.71-.4-1.42.3-2.34.72-.81.72-2.24-1.01-1.52-1.73.7-2.34 2.64-.92 5.6l1.63-1.74z'/%3E %3Cpath fill='%23fff' d='M382.58 252.63l30.11-29.91 7.43 7.93s-1.53-.61-2.14-.2c-.5.4.61 1.93.61 1.93s-1.42-.5-2.03-.1c-.71.4 0 2.13 0 2.13s-1.22-.91-1.83-.5c-.51.4 0 2.33 0 2.33s-1.63-.5-2.04-.1c-.4.4 0 2.14 0 2.14s-1.63-.81-2.44 0 .4 1.93.4 1.93-2.03-.81-2.84.4c-.81 1.23.1 2.35.1 2.35s-1.63-.81-2.03-.41c-.4.4 0 2.34 0 2.34s-1.43-.81-2.34.2c-.92 1.13.1 2.04.1 2.04s-1.32-.81-2.04-.41c-.7.41.2 2.34.2 2.34s-1.31-.92-2.23 0c-.91 1.02 0 2.04 0 2.04s-1.12-1.02-2.24 0c-1.02 1.12 0 2.23 0 2.23s-1.62-.8-2.23 0c-.71.82.2 1.94.2 1.94s-1.22-.71-2.03-.31c-.82.4 0 2.24 0 2.24s-1.22-1.32-1.73-.6c-.61.7.1 2.43.1 2.43s-1.12-1.32-1.73-.6c-.71.6.4 2.13.4 2.13s-2.03-.92-1.52-.92z'/%3E %3Cg fill='%237e4b7e' stroke='none'%3E %3Cpath d='M410.96 225.16l-2.34 2.34.5 8.04s.52-2.34 1.23-.72c0 0 .2-1.93.71-1.62-.4-.2-.1-8.04-.1-8.04M406.59 229.53l-1.73 1.63.61 8.04s.51-3.06 1.22-.61c0 0-.1-2.04-.1-2.75v-6.31M388.38 247.55l-1.63 1.73.41 4.88s.5-3.15 1.22-.71c0 0-.2-2.03-.2-2.75 0 .51.2-3.15.2-3.15'/%3E %3C/g%3E %3Cg fill='none' stroke='%237e4b7e' stroke-width='.92'%3E %3Cpath d='M386.34 227.4a95.54 95.54 0 0 1 4.27 5.19M387.77 229.64c-.2.61-.6 2.34-1.52 3.26M388.27 230.04c-.1.4-.1 1.73-1.52 3.05M388.78 230.66c-.2.71-.3 1.22-.81 1.73M389.09 231.27c0 .5-.3.61-.4.92M385.33 229.33c-.4.4-3.36 2.34-4.99 2.95M384.51 230.45c-.4.4-2.24 1.83-3.26 2.24M384.21 231.67c-.6.41-1.63 1.42-2.44 1.73M383.6 232.89c-.4.5-1.02.92-1.52 1.22'/%3E %3Cpath d='M365.94 234.01c.33-.61.91-1.82 1.67-2.92.96-1.4 1.37-1.63 1.87-2.12' stroke-linecap='square'/%3E %3C/g%3E %3C/g%3E %3Cg%3E %3Cpath fill='%23289400' stroke='%23060' stroke-width='.51' d='M267.72 316.03c1.53.71 0-4.99.5-7.12.62-2.24 5 5.5 7.13 6.51 2.24 1.12 15.87-5.4 15.87-5.4l3.26-6.1 1.73 4.99s3.76-4.38 4.88-6c1.12-1.63 0 3.25-1.12 4.88s3.25 2.24 2.74 5.5c-.5 3.25 4.38-2.24 4.38-2.24l12.62 1.11s2.13-7.63 5.49-12l1.02 4.88 5.18-5.29c5.8 15.27 18.01 31.85 43.04 40.9 23.5-8.54 35.6-23.7 41.91-38.15l7.02 7.23s5.5-1.63 6.51-2.24c1.12-.51 12.92 4.17 12.92 4.17s2.14.81 3.26 1.63c1.12.81.3-3.56.3-3.56s6 1.12 5.5 4.37c0 0 1.32-3.05 2.44-3.56s3.76 2.75 4.37 3.87c.51 1.02 13.43 2.64 15.26 3.76 0 0 1.43 1.63 1.43 2.75 0 0 2.75-.3 4.88-.3 0 0-1.62.8-1.62 2.54 0 1.63-.82 2.95-2.45 3.76-1.62.82 0 1.43 2.14 1.63 2.24.3 0 3.05-4.37 4.69 0 0-1.02 2.43.81 3.25 0 0-3.77.3-4.38-.81 0 0-1.32 2.54-1.32 3.86 0 0-4.06-1.32-5.18-1.93 0 0-1.63 1.62-.51 2.44 0 0-7.43-.81-8.85-3.56 0 0-2.65.81-2.14 1.73 0 0-5.19-3.56-6.82-3.56l-1.11 1.83s-3.57-2.14-4.69-2.14c-1.02 0-.2 1.63-.2 1.63l-4.98-3.05-1.94 3.05s-4.07-1.94-5.18-2.75c-1.02-.81-1.32 1.63-2.14 1.93 0 0-1.63-2.23-3.87-1.93 0 0-.8 2.75-.5 3.56 0 0-6.31-1.32-7.43-1.63-1.12-.3-.5 1.33 0 2.45 0 0-4.68-1.33-5.7-2.14l-.3 2.14s-3.87-.31-4.68-1.12l-2.44 3.35h-3.56l-.82 2.95s-6.81-1.93-7.42-.8c-.51 1.1.3 2.74.3 2.74l-6-.82-.5 2.44s-6.93-2.13-8.55-1.12c0 0-2.14 2.24-3.57 2.75-1.31.61 0-.81 0-.81l-2.13-2.95s-2.44 1.32-3.87.81c-1.32-.61-5.7 2.14-7.12 1.32 0 0 0-1.93-1.12-2.44-1.02-.5-2.95-.5-3.76.82 0 0-.81-1.13-2.24-3.26-1.32-2.24-3.26.2-3.26.2l-.3-2.64-3.77-.31c-2.24-.3-2.74-2.24-2.74-2.24s-5.8.6-6.62.3l1.43-1.32s-7.94 1.63-9.56 1.02c-1.73-.5 1.83-2.74 1.83-2.74s-7.33-1.83-8.75-2.14c-1.33-.3-9.26 1.32-10.38 1.32-1.12 0-1.63-1.83-1.63-1.83s-1.93 1.63-3.56 2.14c0 0-1.32-3.26-.5-3.57 0 0-5.2 1.43-5.5 2.75 0 0-1.33-2.13-1.12-3.05 0 0-2.44 3.87-3.56 4.68-1.12.81-.2-1.93-.2-1.93s-3.06 3.86-4.18 4.17v-2.75s-8.75 4.68-11.19 4.07c0 0 0-1.93.81-2.44l-5.49-.3c-1.32-.2-2.95-.82-4.37-1.12-1.33-.21 1.93-1.63 4.17-1.02 0 0-6.1-2.24-7.94-1.12 0 0-.81-2.24 2.44-3.06 0 0-4.17-4.06-6.61-3.76 0 0 2.74-1.63 4.98-.82 0 0-2.54-6.91-4.17-7.73 0 0 5.8-1.01 7.43-.2z'/%3E %3Cpath fill='%23730000' stroke='%23000' stroke-width='.51' d='M259.27 196.67l74.06-38.36c.36-1.98-.77-3.54-1.93-5.09-21.18 10.39-40.45 23-63.99 30.63-1.32.5-13.02 5.4-19.03 12.62-1.9 1.9-2.04 4.72-2.04 4.72s.15 3.23.83 4.1c0 0 .17.9 1.28 1.6-.01 0 .68.34 1.16.17.54.1 1.42.1 2.64-2.04a54.59 54.59 0 0 1 7.02-8.35z'/%3E %3Cpath d='M318.89 158.72l9.56-4.58s3.26 2.44 2.95 5.19c0 0 .72 6.3 8.55 10.68 0 0-6.61 8.24-18.21 8.96 0 0 1.33-10.88-1.11-14.04 0 0-.4.4-.23-.15.35-1.05-.24-4.68-1.72-5.48-.18-.1.12-.4.21-.58z' stroke='%23000' stroke-width='.51' fill='%23FFF'/%3E %3Cg fill='none' stroke='%237e4b7e' stroke-width='.81'%3E %3Cpath d='M330.08 160.04c-2.03.81-8.65 4.27-8.65 4.27M326.93 162.07c-.1 1.02-.71 3.46 0 5.19M326.01 162.38c0 .5-.81 2.34.1 4.78M325 162.89c-.2 1.02-.4 1.63 0 2.75M324.18 163.5c-.2.6 0 .92 0 1.32M330.18 163.19c.3.81 3.05 5.09 4.68 6.82M330.59 165.12c.3.81 1.83 3.77 2.95 4.89M330.39 166.85c.4 1.02 1.22 2.85 2.03 3.87M330.39 168.89c.2.81.61 1.83 1.22 2.55'/%3E %3C/g%3E %3Cg stroke='%23000' stroke-width='.51'%3E %3Cpath fill='%23b34b00' d='M398.22 154.46l27.2 13.32c5.46 2.65 7.42.2 10.5 1.54l53.69 27.35c4.6 2.01 7.18 2.66 6.52 5.04-.11 3.79 1.8 3.84 2.31 3.88.38.1 2.2-.16 2.95-1.17.57-.65.59-.72.59-.72.6-.61.5-.66.69-.94 2.25-3.24 3.5-6.06 1.14-7.9-2.7-1.27-3.01 1.6-5.86 1.3 0 0-5.08-1.93-6.91-3.25-3.38-1.84-8.09-4.02-9.16-5.21-3.43-.65-29.23-15.16-43.85-22.45-1.57-1.3-2.42-6.16-5.5-7.79-.9-1.3-20.7-10.34-31.05-15.52-3.81-1.42-5.95-2.4-8.7 2.28-2.4 4.6-1.81 7.1 5.44 10.24z'/%3E %3Cpath fill='none' d='M400.52 148.76l30.46 15.2'/%3E %3C/g%3E %3Cg fill='%23ffa54b' stroke='%23000' stroke-width='.51'%3E %3Cpath fill='url(%23a)' d='M309.73 165.12c-.2.61-.71.2-.71.4-.4 2.14-.3 3.26-.81 4.48-.72 1.43-3.26 2.75-3.16 2.65-2.03.6-4.47 3.05-8.44.81-.2-.1-.4-.3-.61-.5 0 0 1.12 4.16-2.95 6.2-1.42.71-15.77 8.24-15.77 8.24s-1.53 2.75-.51 6.51c.1.61.3 1.12-.3 1.53-.92.71-2.65 2.75-3.67 6 0 0-3.05-1.32-3.05-3.25 0-1.94 1.22-2.95 1.53-4.38.3-1.32 1.11-4.68.7-5.7-.4-1.12-2.23-1.52-2.94-1.93-.61-.4-1.43.4-1.32 1.32.1 1.02.8.81 1.62 1.02 0 0-.91 1.93-.8 3.35l-9.27 4.79s1.22 1.62 1.63 2.34c.4.71 1.32 10.17 4.07 14.65s3.66 3.26 4.27 3.87c.51.5 1.32 1.32 2.04 1.93.7.5 3.86.81 4.47-.91a8.91 8.91 0 0 1 3.16-4.18c1.93-1.52 5.9-5.39 5.9-7.12 0 0 2.34 6.71 2.03 12.31 0 0 8.55 1.73 16.18 1.93 7.63.1 11.5-1.52 11.5-1.52s1.01-6.41.6-7.63c0 0 1.22 4.17 2.14 5.6 1.02 1.72 2.14 5.28 4.37 5.49 2.14.1 3.97-2.14 4.17-3.05v-6.72h8.65c0-.1 3.87 1.42 5.09 1.22 1.22-.1 1.93-1.22.81-1.63l-.4-.3c1.11 0 2.54.7 2.54.7h4.27c.1-.1 0-.4-.1-.5-.3-1.22-2.55-2.24-4.17-2.95-1.63-.6-3.46-1.32-4.68-1.42-1.94-.2-3.26-.1-6.21.4-.81.1-3.87.41-5.8 1.33-.5.3-1.02.4-.81-.92.3-1.43.2-7.84-1.32-10.58-1.12-1.94-1.02-3.57-.82-5.2.1-1.62.2-7.22 0-8.85-.3-1.62-2.54-3.86-6.6-4.37-3.87-.51-7.13-3.66-7.33-6.2-.3-2.55.4-7.23.81-9.26'/%3E %3Cg fill='none'%3E %3Cpath fill='url(%23a)' d='M292.44 153.63c-.71 3.25-.71 6.1-.6 9.26.1 2.13 1.1 4.57 2.03 6.71.6 1.43 1.42 3.05 2.74 3.87 3.56 2.34 6.92-.2 8.85-1.02a6.4 6.4 0 0 0 2.75-2.44c.5-1.22.3-2.13.81-4.47-.1.1.82-.41.71-.41.92-1.53.72-2.04 1.22-3.06.51-1.01-.6-2.13-1.83-1.93.61-1.93 1.02-4.07.4-5.9-.2-.61.52-2.24-.6-1.83-4.58 1.83-9.97 1.42-14.85 1.42-.41 0-.72-.81-1.33-.7-.1 0-.2.3-.3.5'/%3E %3Cpath fill='%23000' d='M292.03 155.35c-.5-.4-.61-1.32 0-3.26.71-1.93 0-2.03 1.12-3.15s.81-1.63 1.53-1.93c.7-.2 2.84-.2 3.56-.5.6-.32 1.52-.72 2.94-.92 1.53-.31 4.58-.21 6 .6 1.53.82 2.55 2.85 3.47 3.56 1.02.71 1.63 3.67 1.42 7.94-.3 4.27-1.12 3.46-1.12 3.46s-1.22-2.03-2.24-.3c0 0 0-1.63.2-2.86.11-1.22-.6-3.45.11-4.98 0 0-5.8 1.83-8.75 1.73-3.05-.2-7.32-.92-7.53-1.63l-.71 2.24'/%3E %3Cpath fill='%23fff' stroke='%23fff' d='M294.98 151.8c-.3-.61-1.83-2.85-.6-3.56 1.11-.61.4 2.74 1.93 3.46 0 0-.51 1.52-1.32.1h-.01z'/%3E %3Cpath d='M298.34 160.14c-.5 1.73-.71 2.14-.92 3.16M308.01 164.92c.2.61.4.3.91.4M309.33 161.36c.5-.6 1.22-.3.81 1.22'/%3E %3Cpath d='M292.44 157.7c.92.3 1.83.6 2.75 1.02 1.52.61.6 2.85.2 4.27-.2.71-1.02 1.93-.6 2.55.5.8 1.11.3 2.03.4 0-.3.6-.5.81-.5.71-.1 1.12.5 1.63.3.6-.3.5-1.22.3-1.73M299.46 159.53c.1-.4 1.02-.81 1.53-.92 2.13-.4 3.66-.7 5.39.52M300.68 170.21c-1.73.4-3.56.71-5.19-.2M295.49 169.2c.81-.4 1.12-.82 2.14-.3 0-.1 1.12-.41 1.12-.41.8 0 1.32.3 2.13.8M295.39 169.6c.92-.3 3.36-.3 5.4.1'/%3E %3Cpath fill='%23fff' stroke-width='.31' d='M292.34 160.14c.71-.1 1.53-.92 3.15.3 1.12.72-1.83 1.43-1.32 1.33-1.32.2-1.73-.5-1.83-1.12 0-.2-.2-.51 0-.51zM300.68 160.95c.71-1.43 1.83-1.12 2.85-.82 1.02.31.71.1 1.63.62-1.12.2-.82.3-1.63.7-.92.42-1.73.62-2.34.21-.2-.2-.71-.5-.71-.91 0 .1.1.2.2.2z'/%3E %3Cpath fill='%23000' stroke-width='.31' d='M293.76 161.36c.4 0 .71-.4.71-.81 0-.51-.3-.92-.71-.92-.5 0-.81.4-.81.92 0 .4.3.81.81.81zM302.41 161.56c.4 0 .71-.4.71-.92a.8.8 0 0 0-.81-.8c-.4 0-.71.3-.71.8 0 .52.4.92.81.92z'/%3E %3C/g%3E %3Cg id='c'%3E %3Cg fill='none'%3E %3Cpath d='M345.85 213.66a3.85 3.85 0 0 0-1.83-1.32l-2.04-1.02c-.7-.4-1.72-.5-2.34-.92M340.05 213.05c-.3-.2-.5-.3-.81-.51-.3-.1-.71-.1-1.02-.2-.1 0-.1-.2-.2-.2a3.48 3.48 0 0 1-2.44-1.33M272.8 201.45c.91.71 3.15 2.24 3.36 5.19a10.5 10.5 0 0 0 1.01 3.05M264.05 201.86c.51 1.73.61 7.42 6 13.43M265.07 193.92c-.4 1.12-.92 2.14.2 2.95M279.72 207.56c1.12-2.54 4.58-2.34 4.58-4.78'/%3E %3Cpath d='M284.81 207.25c-.3-2.85-.92-4.47-.4-8.65.2-1.22.4-5.9 0-8.14 0 0 1.62 7.84-3.67 9.37M315.13 212.34c0-3.97.92-6.2.92-6.2 1.22-5.6-1.12-7.74-.2-9.16.8-1.22 2.03-3.77.4-8.86 0 0 2.85 10.49-4.48 10.49-7.42 0-7.12-2.75-7.12-2.75'/%3E %3Cpath d='M284.4 190.46c0 2.13 0 8.45 9.05 8.45 2.75 0 5.7-1.94 7.33-3.26M303.02 192.9c-.3-1.93-.3-4.38-.3-6.92M289.08 182.53c2.44-.3 4.38-.61 8.96-.61M298.34 175.6c.5 2.24-.3 5.8 3.87 6.3M306.58 174.79c-.61 1.63-.61 3.26-.81 4.38M305.97 181.92c1.73 0 4.99-1.12 9.05-.3M316.45 204.4c.81 1.63 1.02 3.77 3.56 6.2M288.27 199.21c.2 1.32-1.73 5.7-.3 9.26a12.31 12.31 0 0 1-1.13 11.1M293.46 200.54c-.81 1.63-2.24 3.26-2.54 4.68M297.52 203.59c0 1.02-2.74 8.75-4.68 10.89 0 0 3.56 1.42 3.05 6.61M303.22 200.03c0 1.32-.2 1.63.92 2.44M306.58 202.47c1.32 1.63 5.5 6.51 4.58 9.26M303.83 205.22c.3 1.02.3 6.3-.61 8.96M301.09 213.97c-1.12 0-2.75.81-3.05 2.75M306.78 213.66c1.12-.3 3.35 1.63 3.35 7.12M325.81 210.51c-2.14.61-3.05 1.73-2.44 1.12-1.12.91-2.14 1.52-2.14 1.52'/%3E %3C/g%3E %3Cpath fill='%23000' stroke-width='.31' d='M289.79 197.99c.6 0 1.12-.4 1.12-.92 0-.4-.5-.81-1.12-.81-.5 0-1.02.4-1.02.81 0 .5.5.92 1.02.92zM312.89 198.3c.51 0 1.02-.4 1.02-.92 0-.5-.5-.8-1.02-.8-.6 0-1.12.3-1.12.8 0 .52.51.92 1.12.92z'/%3E %3Cpath fill='%23fff' d='M280.54 239.81c1.22-7.94 4.99-14.55 5.09-15.16 0 0 3.86.81 10.58 1.42 6.6.71 8.44.41 11.5.2 2.94-.3 6.8-.8 6.8-.8s1.23 2.43 1.33 4.88c.3 5.18 2.24 27.67 2.44 33.68 0 0 .81 3.56.81 12.3 0 9.57 2.65 29 2.65 39.39l-2.65.5s-14.44 1.13-14.44-.8c0-2.14-.82-27.07 1.32-42.13 0 0-.51-2.95-1.32-5.5-.82-2.44-4.38-10.07-4.38-11.7 0 0-5.7 16.08-6 18.83-.3 2.54-1.12 38.35-1.63 41.31 0 0-8.24 6.3-9.36 6.92-1.12.5-9.05-3.36-9.26-4.37-.3-1.12.82-13.23 4.58-33.18 1.43-7.12.61-8.44.61-10.38 0-1.93.1-27.47 1.32-35.4l.01-.01z'/%3E %3Cg fill='none'%3E %3Cpath d='M294.27 274.92c-.6 2.24-1.63 4.38-3.56 5.8M287.96 227.09c-.3 1.32-2.24 7.33-7.12 10.89M295.08 228.21c-1.12 3.56-5.5 22.7-6.3 45.38M288.47 280.72c-.2 2.13-1.32 18.01-1.63 20.76M286.03 304.53c-.5 1.12-2.75 10.38-2.75 18.62M315.53 287.23c-.2 1.93-1.02 15.67 3.56 27.98M300.58 229.23c-.3 2.24-.81 16.69-.81 17.8 0 1.12 1.63 2.75 2.44 3.06 0 0-1.63.5-1.94 6M296.2 243.17c-.3 1.73-1.93 8.55-3.05 11.3M306.27 229.03s4.88 1.02 5.19 0c0 0 1.63 29.51 3.86 45.9M304.14 232.79c0 1.93-.6 16.48-.6 16.48M305.97 251.41s1.93 2.75 1.43 4.07M289.59 227.4c1.63.5 3.05.81 3.05.81M297.83 229.84c-.3.81-.61 4.58-.61 4.58M305.97 273.29c.61.81 1.43 1.94.81 4.38'/%3E %3C/g%3E %3Cpath fill='%239b5f00' d='M284.91 224.45s0-3.26 1.22-4.89c0 0 3.46.72 8.34 1.23 4.99.5 8.95.91 12.62.5 3.66-.4 7.43-1.32 7.43-1.32s1.01 4.79.5 5.5c0 0-3.97.81-8.34 1.01-4.48.3-11.9-.4-14.45-.8-3.35-.42-6.3-1.03-7.32-1.23z'/%3E %3Cpath fill='%23fff' d='M288.06 224.85l.6-4.88 1.03.1-.2 5.08-1.43-.3M310.14 220.78l.1 5.5 1.22-.21-.1-5.6-1.22.31M294.47 220.78l-.4 5.3h.7l.72-5.3h-1.02'/%3E %3Cpath d='M276.77 320.81c-.3 1.32-.81 3.15-1.02 5.5 0 .5-.5 3.25 1.02 3.35 1.12.1 1.43-2.85 1.43-2.85s-1.02 3.26.3 3.67c1.83.4 2.03-3.57 2.03-3.57-.2 1.12-1.42 3.97.31 4.28 1.83.3 2.34-3.87 2.34-3.87s-1.53 4.17.3 4.27c1.73.1 1.73-4.07 1.73-4.07s-.91 4.99 1.53 4.58c1.32-.2 1.63-1.93 1.93-2.95.4-1.52 1.32-3.46.2-6.61-.8-2.34-.5-2.95-.5-2.95s-2.85 2.14-5.09 3.56c-1.02.6-6.51-2.34-6.51-2.34zM306.48 316.43c-.5-.3-.4 1.83-.6 2.85-.11 1.02.2 3.25 3.65 3.05 3.36-.3 6.72-1.02 8.86-.5 2.13.6 5.28.7 7.02.7 1.73 0 2.85-.2 3.66-.5.71-.3 2.24.4 2.95.4s1.83-1.12 1.73-1.83c-.1-1.32-1.32-1.32-3.06-1.42-1.62-.2-3.86-.51-4.98-.92-1.12-.4-3.15-1.53-5.7-2.03 0 0-4.88.2-5.9.2-1.01 0-7.02.3-7.63 0z'/%3E %3C/g%3E %3Cg fill='none'%3E %3Cpath fill='%23ffb366' d='M255.71 189.85c-.5.3-1.12-2.04.4-2.95 0 0 .41-1.93 2.04-2.14 0 0 1.32-1.83 3.26-1.62 0 0 2.23-1.53 3.05-1.33.81.1 2.85 2.14 2.95 2.85.2.71 0 1.94-.51 2.44-.61.61-1.02-.1-1.12-.91 0 0 .4 1.52-.81 2.13-1.22.72-1.12.21-1.22-.6 0 0-.31 1.62-1.12 1.83-.82.3-1.33-.41-1.94-.41 0 0 1.02.81.3 1.42-.7.51-1.52.3-2.03-.1-.5-.5-1.12-1.83-3.25-.6v-.01z'/%3E %3Cpath d='M265.68 186.09c-.51-1.63-2.14-3.05-4.07-2.85M263.85 187.61c-.3-.4-.4-.82-.71-1.22-.92-1.53-2.85-1.42-4.48-1.83M261.1 189.14c-.6-.4-.81-1.22-1.43-1.52-1.01-.41-2.03-.92-3.25-.72'/%3E %3C/g%3E %3C/g%3E %3Cg stroke='%23000' stroke-width='.51'%3E %3Cpath fill='url(%23b)' d='M439.14 165.12c.71-.3.51.61.61.92.3 1.32.3 2.74.81 3.96.61 1.12.81 1.53 1.83 2.04 1.63.91 6.41 3.56 9.77 1.42.2-.1.5-.3.71-.5 0 0-1.22 4.17 2.95 6.2 1.32.71 15.67 8.24 15.67 8.24s1.52 2.75.6 6.51c-.2.61-.4 1.12.21 1.53 1.02.71 2.65 2.75 3.77 6 0 0 2.95-1.32 2.95-3.25 0-1.94-1.22-2.95-1.53-4.38-.2-1.32-1.02-4.68-.6-5.7.4-1.11 2.13-1.52 2.84-1.93.71-.4 1.53.4 1.32 1.32-.1 1.02-.81.82-1.63 1.02 0 0 1.02 1.93.82 3.35l9.36 4.79s-1.23 1.63-1.63 2.34c-.51.71-1.43 10.17-4.17 14.65-2.75 4.48-3.67 3.26-4.17 3.87-.61.5-1.43 1.32-2.14 1.93-.6.5-3.76.81-4.48-.92a8.94 8.94 0 0 0-3.15-4.17c-1.93-1.52-5.9-5.39-5.9-7.12 0 0-2.34 6.72-2.03 12.31 0 0-8.45 1.73-16.18 1.94-7.63.1-11.5-1.53-11.5-1.53s-1.02-6.41-.6-7.63c0 0-1.23 4.17-2.04 5.6-1.12 1.72-2.24 5.28-4.38 5.49-2.23.1-3.96-2.14-4.27-3.05v-6.72h-8.64c0-.1-3.77 1.42-5.09 1.22-1.22-.1-1.83-1.22-.81-1.63l.4-.3c-1.12 0-2.54.7-2.54.7h-4.27c0-.1.1-.4.1-.5.3-1.22 2.55-2.24 4.27-2.95 1.63-.6 3.36-1.32 4.58-1.42 1.93-.2 3.26-.1 6.2.4.82.1 3.97.41 5.8 1.33.51.3 1.12.4.82-.92-.3-1.42-1.22-5.6.3-8.34 1.02-1.94.92-3.56.82-5.2-.2-1.72-1.12-5.6-1.12-7.32 0-5.7 4.38-8.04 8.24-9.26 4.27-1.32 7.12-2.75 6.92-5.29-.1-2.64.6-7.02.2-9.06'/%3E %3Cg fill='none'%3E %3Cpath fill='url(%23b)' d='M456.34 153.63c.92 3.36 1.12 4.17 1.12 5.3 0 1.21-.5 1.41-.1 2.74.7 2.44-.72 5.09-2.45 7.94-.8 1.32-1.42 3.05-2.74 3.86-3.36 2.14-7.43-.4-9.56-1.32a3.73 3.73 0 0 1-2.04-2.14c-.4-1.22-.5-2.34-.81-3.97 0-.3.1-1.22-.6-.91-1.23-1.43-1.03-2.04-1.53-3.05-.51-1.02.91-2.14 2.03-1.94-.6-1.93-.91-4.07-.3-5.9.2-.61-.51-2.24.5-1.83 4.58 1.83 9.97 1.42 14.86 1.42.4 0 .7-.81 1.32-.7.1 0 .2.3.3.5'/%3E %3Cpath fill='%23000' d='M456.75 155.35c.5-.4.2-2.34-.3-4.38-.2-1.01-1.02-1.42-2.14-2.54s-1.53-1.12-2.24-1.42c-.6-.2-2.03-.2-2.74-.5-.61-.32-2.24-.11-3.77.1-2.04.3-3.15.2-4.68 1.01-1.52.81-2.74 1.73-3.25 3.26-.41 1.11-1.12 2.54-.82 6.81.2 4.27 1.02 3.46 1.02 3.46s1.12-1.63 1.83-.6c0 0-.1-2.25-.3-3.57-.1-1.22 0-2.75.5-4.58 0 0 4.69 1.73 9.06 1.73 3.05 0 7.02-.3 7.12-1.02l.71 2.24z'/%3E %3Cpath d='M450.44 160.14c.61 1.73.1 1.22.4 2.34M440.57 164.51c0 .81-.61.61-1.02.61'/%3E %3Cpath d='M456.85 158.82c-.92-.71-2.65-.2-3.46.1-1.52.71-.71 2.24-.2 3.67.2.7 1.02 1.72.5 2.44-.4.8-.7.4-1.62.5.1-.3-.81 0-1.12 0-.6-.1-.91.41-1.42.2-.61-.3-.51-1.21-.31-1.72M449.32 159.53c0-.4-1.32-.81-2.75-.92-2.23-.1-2.44.1-4.17 1.33M453.9 168.89c-.4-.6-1.02-.92-2.14-.4 0-.2-1.52-.41-1.52-.41-.81 0-1.32.3-2.14.7M453.69 169.4c-.92-.6-3.26-.2-5.6-.2M448.3 170.01c1.73.51 3.46.82 5.19 0'/%3E %3Cpath fill='%23fff' stroke-width='.31' d='M456.44 160.14c-.71-.1-1.02-.92-3.15.3-1.12.62 1.83 1.43 1.42 1.33 1.22.2 1.63-.5 1.73-1.12 0-.2.2-.51 0-.51zM448.1 160.95c0-.82-1.83-1.12-2.85-.82-1.02.31-.6.1-1.52.62 1.02.2.7.3 1.52.7.92.42 1.12.82 2.34.21.3-.1.71-.5.82-.91-.1.1-.2.2-.31.2z'/%3E %3Cpath fill='%23000' stroke-width='.31' d='M455.12 161.36a.8.8 0 0 1-.81-.81c0-.51.3-.92.81-.92.4 0 .71.4.71.92 0 .4-.3.81-.71.81zM446.37 161.56c-.4 0-.71-.4-.71-.92 0-.5.4-.8.81-.8s.71.3.71.8c0 .52-.3.92-.81.92z'/%3E %3C/g%3E %3Cuse xlink:href='%23c' fill='%23730000' transform='matrix(-1 0 0 1 748.82 0)'/%3E %3Cg fill='none'%3E %3Cpath fill='%23730000' d='M491.64 193.51c.5.2 1.93-2.03.5-3.05 0 0-.5-1.93-2.13-2.04 0 0-1.32-1.93-3.26-1.62 0 0-2.13-1.53-2.94-1.43-.92.2-2.95 2.24-3.06 2.95-.1.61 0 1.84.51 2.45.61.5 1.02-.1 1.12-1.02 0 0-.4 1.52.81 2.24 1.22.7 1.12.1 1.22-.71 0 0 .31 1.62 1.12 1.93.82.3 1.33-.41 1.94-.41 0 0-1.02.81-.3 1.32.7.61 1.52.3 2.03-.1.6-.4.3-1.73 2.44-.51z'/%3E %3Cpath d='M482.49 189.75c.5-1.73 2.23-3.15 4.07-2.85M484.42 191.28c.2-.41.3-.82.61-1.22.92-1.53 2.95-1.53 4.58-1.84M487.06 192.7c.61-.4.81-1.12 1.43-1.42a5.28 5.28 0 0 1 3.25-.72'/%3E %3Cpath fill='%23730000' d='M482.31 186.77c-.9.72-1.84 1.8-1.9 2.28-.1.61-.01 1.83.5 2.44.54.46.94-.02 1.09-.78-.06.46-.07 1.46.84 2 1.22.7 1.12.1 1.22-.72 0 0 .31 1.63 1.13 1.94.81.3 1.32-.4 1.94-.4 0 0-1.03.8-.32 1.3.71.61 1.52.31 2.03-.1.61-.4.3-1.71 2.44-.5.27.12.8-.44 1.03-1.15l-7.69-5.53-2.31-.78z' stroke='none'/%3E %3Cpath d='M480.68 188.19c-1.5 2.58.5 4.13 1.16 2.62-.19 2.38 1.61 2.3 2.29 1.54.66 2.5 1.83 1.4 2.9 1.16-1.21 2.3 1.49 1.61 2.13 1.08.92-1.36 1.35-.28 2.03-.41l1.17-1.25M484.38 187.23c-1.69.9-2.51 2.14-2.54 3.7M486.71 188.73c-1.69.9-2.51 2.14-2.54 3.7M489.58 190.68c-1.69.9-1.76 1.72-2.5 2.83'/%3E %3C/g%3E %3C/g%3E %3Cg fill='%235ac800'%3E %3Cpath d='M290.1 323.66l-.2-4.68 1.93 1.63.5-3.56c.82-.2 2.15 1.42 2.15 1.42l-.2-3.56 2.94 3.26s-.2-2.75.81-4.38c0 0 2.24 1.93 2.24 4.17 0 1.94 1.93-2.75 1.93-2.75l1.63 5.2 1.32-1.94 1.12 4.07 2.45-3.56 1.93 4.17 4.37-.3.51 2.43 1.93-2.13 2.55 1.62s2.13-.6 3.25-.6 2.45 1.42 2.45 1.42.8-1.42 1.62-1.94c.82-.5 1.94.82 2.24 1.63l1.63-2.95s2.14 2.14 2.44 2.95c0 0 .3-2.44.81-3.25.51-.82 1.32.3 1.94 1.32l1.32-4.37s1.42.3 2.44 1.93c1.11 1.63 1.11-2.44 1.11-2.44s2.45 3.26 3.06 5.5c0 0-16.85 5.78-28.73 4.2-13.98-1.87-25.5-4.51-25.5-4.51M405.57 323.15s.81-2.24 1.94-3.36c0 0 2.13 2.55 2.13 3.36 0 0 .6-.3 1.73-1.12l1.63 1.63 1.93-1.32 1.83 1.62 3.36-1.42 1.32 1.42 5.2-.6 1.92.8 1.84-2.33 1.73 1.83 2.74-2.75s1.32 1.12 1.63 1.94c0 0 2.24-1.12 2.75-1.94 0 0 2.13-.81 2.44.51 0 0 1.32-1.02 1.22-2.13-.1-1.12 1.52-.31 2.03 1.11 0 0 .61-2.23 2.24-2.44 0 0 1.12 1.32.81 3.77 0 0 2.44-1.94 3.56-2.14 0 0 .51 2.75-.3 5.2 0 0 2.54-4.18 3.05-2.76.2.82.81 3.56.2 5.5l2.24-1.43.81 2.75 2.44-.51s-14.44 2.21-28.05.91c-13.6-1.3-26.37-6.1-26.37-6.1M395.51 333.25c.66-.4-4.55 10.7-17.17 11.3-17.56.82-32.58-7.94-32.58-7.94s1.83-3.05 2.95-3.87c0 0 2.44 1.94 3.26 4.38 0 0 .3-1.63 1.12-3.05 0 0 3.05 1.42 3.56 3.35 0 0 1.12-1.93 1.93-2.44.81-.61 1.63 2.14 1.63 3.77 0 0 1.93-2.04 3.05-2.14 0 0 2.14 1.02 2.75 4.58 0 0 2.04-1.93 2.75-1.63 0 0 2.44 1.63 1.83 3.86-.3 1.23 2.44-1.42 5.8-2.23l2.95 2.24s2.74-3.66 3.56-4.89c0 0 2.23.82 2.23 2.14 0 0 1.02-3.87 1.84-4.27.8-.51 1.93 1.22 1.93 2.34 0 0 .3-2.95 1.93-3.56 0 0 1.63 1.11 1.63 2.24 0 0 1.73-3.36 3.05-4.18z'/%3E %3C/g%3E %3Cg stroke-width='.51' stroke='%23060' fill='none'%3E %3Cpath d='M290.1 323.66l-.2-4.68 1.93 1.63.5-3.56c.82-.2 2.15 1.42 2.15 1.42l-.2-3.56 2.94 3.26s-.2-2.75.81-4.38c0 0 2.24 1.94 2.24 4.17 0 1.94 1.93-2.74 1.93-2.74l1.63 5.19 1.32-1.94 1.12 4.07 2.44-3.56 1.94 4.17 4.37-.3.51 2.44 1.93-2.14 2.55 1.63s2.13-.6 3.25-.6 2.44 1.41 2.44 1.41.82-1.42 1.63-1.93c.81-.5 1.94.82 2.24 1.63l1.63-2.95s2.13 2.14 2.44 2.95c0 0 .3-2.44.81-3.26.51-.8 1.32.31 1.93 1.33l1.33-4.38s1.42.3 2.44 1.94c1.12 1.62 1.12-2.45 1.12-2.45s2.44 3.26 3.05 5.5M405.57 323.15s.81-2.23 1.93-3.36c0 0 2.14 2.55 2.14 3.36 0 0 .6-.3 1.73-1.12l1.63 1.63 1.93-1.32 1.83 1.63 3.36-1.43 1.32 1.43 5.19-.61 1.93.81 1.83-2.34 1.73 1.83 2.75-2.74s1.32 1.11 1.63 1.93c0 0 2.23-1.12 2.74-1.93 0 0 2.14-.82 2.44.5 0 0 1.32-1.02 1.22-2.13-.1-1.12 1.53-.3 2.04 1.12 0 0 .6-2.24 2.24-2.45 0 0 1.11 1.33.8 3.77 0 0 2.45-1.93 3.57-2.14 0 0 .5 2.75-.3 5.2 0 0 2.54-4.18 3.05-2.76.2.82.81 3.57.2 5.5l2.24-1.43.81 2.75 2.44-.5M345.68 336.63s1.83-3.05 2.95-3.87c0 0 2.44 1.94 3.26 4.38 0 0 .3-1.63 1.12-3.05 0 0 3.05 1.42 3.56 3.36 0 0 1.12-1.94 1.93-2.45.81-.6 1.63 2.14 1.63 3.77 0 0 1.93-2.04 3.05-2.14 0 0 2.14 1.02 2.75 4.58 0 0 2.03-1.93 2.74-1.63 0 0 2.44 1.63 1.83 3.87-.3 1.22 2.45-1.42 5.8-2.24l2.95 2.24s2.75-3.66 3.56-4.89c0 0 2.24.82 2.24 2.14 0 0 1.02-3.87 1.83-4.27.82-.51 1.93 1.22 1.93 2.34 0 0 .31-2.95 1.94-3.56 0 0 1.63 1.11 1.63 2.24 0 0 1.73-3.36 3.05-4.18'/%3E %3C/g%3E %3C/g%3E %3Cg%3E %3Cg fill='%23fff'%3E %3Cpath d='M374.44 376.98c22.9.2 36.42-8.14 43.85-13.13 17.4-11.7 21.06-12.1 23.9-11.9 3.27.3 8.04 1.42 8.25 4.27.3 4.38-6.82 6.31-10.89 6.31-4.17 0-15.06-2.75-15.06-2.75l-2.85 1.94c1.94.91 24.22 8.34 28.5 1.32 4.36-7.12 8.74-18.62 8.74-18.62s-4.88-8.75-15.77-8.75c-10.99 0-21.67 6.92-28.79 12.1-7.12 5.2-16.07 12.32-39.88 12.32-23.81 0-32.86-7.12-39.98-12.31-7.12-5.2-17.8-12.11-28.7-12.11-10.98 0-15.86 8.75-15.86 8.75s4.37 11.5 8.74 18.62c4.28 7.02 26.56-.4 28.49-1.32l-2.75-1.94s-10.98 2.75-15.05 2.75c-4.18 0-11.3-1.93-11-6.3.21-2.86 5-3.98 8.25-4.28 2.85-.2 6.51.2 23.9 11.9 7.44 4.99 20.97 13.03 43.96 13.13'/%3E %3Cpath d='M337.61 350.01s0-1.94-.3-4.78c-.41-3.67-2.55-4.58-4.28-4.07-1.12.4-3.35 3.15-3.35 3.15v.1a32.36 32.36 0 0 0-3.16-1.93c.82-.92 5.5-3.77 6.61-3.77 1.02 0 15.06 5.7 19.54 9.57 1.12 1.02 1.93 7.32 1.32 9.36a48.39 48.39 0 0 1-16.38-7.53v-.1M330.89 364.26s-3.05 3.05-3.15 8.65c-.1 6.61 4.68 6.92 7.83 6.81 3.77-.1 6.82-2.23 6.71-9.26 0 0-6.2-2.64-11.4-6.2M411.17 350.01s.1-1.94.4-4.78c.41-3.67 2.45-4.58 4.18-4.07 1.12.4 3.35 3.15 3.35 3.15v.1a32.21 32.21 0 0 1 3.16-1.93c-.82-.92-5.5-3.77-6.51-3.77-1.12 0-15.16 5.7-19.64 9.57-1.02 1.02-1.83 7.32-1.32 9.36a47.43 47.43 0 0 0 16.38-7.53v-.1M417.88 364.26s3.05 3.05 3.15 8.65c.2 6.61-4.68 6.92-7.83 6.81-3.77-.1-6.71-2.23-6.71-9.26 0 0 6.2-2.64 11.4-6.2'/%3E %3C/g%3E %3Cg fill='%2369f'%3E %3Cpath d='M324.28 359.78s-10.89 2.75-14.96 2.75c-4.17 0-11.29-1.93-10.98-6.31.2-2.85 4.98-3.97 8.24-4.27 2.44-.2 5.6.1 17.7 7.83M424.5 359.78s10.88 2.75 15.06 2.75c4.07 0 11.19-1.93 10.88-6.31-.2-2.85-4.98-3.97-8.24-4.27-2.44-.2-5.6.1-17.7 7.83M337.61 350.11a98.36 98.36 0 0 1-3.26-2.44c-1.52-1.12-3.05-2.14-4.68-3.26 0 0 2.24-2.85 3.36-3.15 1.73-.61 3.86.3 4.27 3.96.3 2.85.3 4.9.3 4.9M330.18 378.81c1.94 1.12 4.07 1.02 5.4.92 3.76-.1 6.81-2.24 6.7-9.26 0 0 4.69 2.34 12.32 4.17 0 0 1.22 1.53 1.42 4.58.31 2.54-1.42 5.29-3.45 5.09 0 0-10.69-1.94-17.2-3.05-3.76-.72-5.19-2.45-5.19-2.45M411.17 350.11l3.35-2.44c1.43-1.12 2.96-2.14 4.58-3.26 0 0-2.23-2.85-3.35-3.15-1.73-.61-3.77.3-4.17 3.96-.3 2.85-.41 4.89-.41 4.89M418.59 378.81c-1.93 1.12-4.07 1.02-5.4.92-3.76-.1-6.7-2.24-6.7-9.26 0 0-4.69 2.34-12.22 4.17 0 0-1.32 1.53-1.52 4.58-.2 2.54 1.52 5.29 3.46 5.09 0 0 10.78-1.94 17.19-3.05 3.76-.72 5.19-2.45 5.19-2.45'/%3E %3C/g%3E %3Cg fill='none' stroke='%23000' stroke-width='.71'%3E %3Cpath d='M374.44 376.98c22.9.2 36.42-8.14 43.85-13.13 17.4-11.7 21.06-12.1 23.9-11.9 3.26.3 8.05 1.42 8.25 4.27.3 4.38-6.82 6.3-10.89 6.3-4.17 0-15.06-2.73-15.06-2.73l-2.84 1.93c1.93.92 24.2 8.34 28.48 1.32 4.38-7.12 8.75-18.62 8.75-18.62s-4.88-8.75-15.77-8.75c-10.99 0-21.67 6.92-28.8 12.1-7.11 5.2-16.06 12.32-39.87 12.32s-32.86-7.12-39.98-12.31c-7.13-5.2-17.81-12.11-28.7-12.11-10.98 0-15.86 8.75-15.86 8.75s4.37 11.5 8.74 18.62c4.28 7.02 26.56-.4 28.49-1.32l-2.74-1.93s-11 2.74-15.06 2.74c-4.17 0-11.3-1.93-10.99-6.3.2-2.86 4.98-3.97 8.24-4.28 2.85-.2 6.51.2 23.9 11.9 7.44 5 20.97 13.03 43.96 13.13z'/%3E %3Cpath d='M324.28 359.78s-10.89 2.75-14.95 2.75c-4.18 0-11.3-1.94-11-6.31.21-2.85 5-3.97 8.25-4.27 2.44-.2 5.6.1 17.7 7.83zM424.49 359.78s10.89 2.75 15.06 2.75c4.07 0 11.19-1.94 10.88-6.31-.2-2.85-4.98-3.97-8.23-4.27-2.45-.2-5.6.1-17.7 7.83h-.01zM337.61 350.11a97.32 97.32 0 0 1-3.26-2.44c-1.52-1.12-3.05-2.14-4.68-3.26 0 0 2.24-2.85 3.36-3.15 1.73-.61 3.86.3 4.27 3.97.31 2.84.31 4.88.31 4.88z'/%3E %3Cpath d='M337.61 350.01s0-1.94-.3-4.78c-.41-3.67-2.55-4.58-4.28-4.07-1.12.4-3.36 3.15-3.36 3.15v.1a33.2 33.2 0 0 0-3.15-1.93c.81-.92 5.5-3.77 6.61-3.77 1.02 0 15.06 5.7 19.54 9.57 1.12 1.02 1.93 7.32 1.32 9.36a48.52 48.52 0 0 1-16.39-7.53M330.89 364.26s-3.05 3.05-3.15 8.65c-.1 6.6 4.68 6.92 7.83 6.81 3.77-.1 6.82-2.23 6.72-9.26 0 0-6.2-2.64-11.4-6.2z'/%3E %3Cpath d='M333.44 365.78s-2.44 2.54-2.85 6.71c-.2 3.26 1.94 5.1 4.68 4.89 3.87-.2 5.4-5.5 3.56-8.45l-5.39-3.15'/%3E %3Cpath d='M330.18 378.81c1.93 1.12 4.07 1.02 5.4.92 3.76-.1 6.8-2.24 6.7-9.26a63 63 0 0 0 12.32 4.17s1.22 1.52 1.42 4.58c.3 2.54-1.42 5.29-3.45 5.08 0 0-10.69-1.93-17.2-3.05-3.77-.71-5.19-2.44-5.19-2.44zM411.17 350.11l3.36-2.44c1.42-1.12 2.95-2.14 4.58-3.26 0 0-2.24-2.85-3.36-3.15-1.73-.61-3.77.3-4.17 3.97-.3 2.84-.4 4.88-.4 4.88h-.01z'/%3E %3Cpath d='M411.17 350.01s.1-1.94.4-4.78c.41-3.67 2.45-4.58 4.18-4.07 1.12.4 3.35 3.15 3.35 3.15v.1a33.2 33.2 0 0 1 3.16-1.93c-.82-.92-5.5-3.77-6.51-3.77-1.12 0-15.16 5.7-19.64 9.57-1.02 1.02-1.83 7.32-1.32 9.36a47.55 47.55 0 0 0 16.38-7.53M417.88 364.26s3.05 3.05 3.15 8.65c.2 6.6-4.68 6.92-7.83 6.81-3.76-.1-6.71-2.23-6.71-9.26 0 0 6.2-2.64 11.39-6.2z'/%3E %3Cpath d='M415.34 365.78s2.44 2.54 2.85 6.71c.3 3.26-1.94 5.1-4.68 4.89-3.87-.2-5.3-5.5-3.56-8.45l5.39-3.15'/%3E %3Cpath d='M418.59 378.81c-1.93 1.12-4.07 1.02-5.4.92-3.76-.1-6.7-2.24-6.7-9.26 0 0-4.69 2.34-12.21 4.17 0 0-1.33 1.52-1.53 4.58-.2 2.54 1.53 5.29 3.46 5.08 0 0 10.78-1.93 17.2-3.05 3.76-.71 5.18-2.44 5.18-2.44z'/%3E %3C/g%3E %3Cg fill='none' stroke='%23fff' stroke-width='.71'%3E %3Cpath d='M353.79 376.47s3.36 2.44-.71 5.5M343.72 374.84l10.28 4.48M345.44 377.18l7.53 3.25M348.09 375.25l5.7 2.55M395.09 376.47s-3.46 2.44.61 5.5M405.06 374.84l-10.28 4.48M403.43 377.18l-7.53 3.25M400.69 375.25l-5.6 2.55'/%3E %3C/g%3E %3Cg stroke='%23000' stroke-width='.7'%3E %3Cpath d='M313.56 345.17c.15.24.24.48.28.74.04.25.03.54-.02.86a2.44 2.44 0 0 1-1.21 1.71c-.66.4-1.42.5-2.25.34a4.53 4.53 0 0 1-2.06-1.02l-.35.39-.49-.1.48-2.95.5.1c.02.38.09.73.17 1.05.07.32.2.62.38.92.17.28.38.52.64.7.26.2.57.34.95.4.28.06.53.07.76.04a1.28 1.28 0 0 0 .95-.63 1.87 1.87 0 0 0 .1-1.61c-.14-.34-.4-.62-.75-.84l-.85-.53c-.32-.2-.59-.36-.82-.52a2.85 2.85 0 0 1-.97-1.08c-.2-.4-.26-.88-.15-1.45.06-.33.19-.62.37-.87a2.63 2.63 0 0 1 1.65-.98 3.03 3.03 0 0 1 2.09.4c.3.18.56.37.79.58l.33-.36.49.1-.5 2.85-.5-.1a11.7 11.7 0 0 0-.11-.99 3.7 3.7 0 0 0-.29-.9c-.13-.26-.31-.49-.53-.68a1.92 1.92 0 0 0-.9-.38 1.44 1.44 0 0 0-1.06.18c-.32.2-.52.47-.58.82-.07.37-.04.7.09.97.13.28.34.53.65.75.27.2.54.37.81.53a14.62 14.62 0 0 1 1.42.98c.19.18.36.37.49.58M326.04 346.92c-.1-.05-.27-.11-.48-.18-.22-.07-.41-.1-.58-.09-.17.01-.35.14-.54.37-.2.23-.4.54-.6.9-.6 1.12-1.22 2.22-1.83 3.33a2.51 2.51 0 0 1-2 1.34c-.4.04-.78 0-1.15-.08a4.34 4.34 0 0 1-2.77-2.24 2.32 2.32 0 0 1 .1-1.94l2.5-4.52c.07-.12.1-.25.11-.35 0-.1-.04-.23-.13-.37-.06-.1-.15-.21-.28-.32l-.32-.25.21-.38 3.23 1.78-.21.38a3.23 3.23 0 0 0-.8-.27c-.14-.02-.27 0-.36.08a.91.91 0 0 0-.25.3l-2.33 4.22c-.11.2-.2.43-.28.68a1.75 1.75 0 0 0 .23 1.58c.18.26.48.5.9.74.4.22.78.34 1.12.37a1.94 1.94 0 0 0 1.56-.58c.17-.17.32-.37.44-.58l1.73-3.14c.22-.4.38-.74.45-1.03.09-.29.09-.5.02-.64a1.57 1.57 0 0 0-.4-.5c-.2-.17-.35-.3-.46-.36l.21-.38 3.17 1.75a20 20 0 0 1-.21.38M330.53 354.69a1.94 1.94 0 0 1-.07 1.92c-.2.35-.45.6-.76.78-.3.17-.63.26-.97.29-.34.03-.68 0-1.03-.1a4.2 4.2 0 0 1-1.02-.41l-3.63-2.1.21-.37a4.94 4.94 0 0 0 .81.3c.14.01.26-.02.36-.07.09-.06.17-.15.25-.28l3.13-5.44a.98.98 0 0 0 .13-.36.58.58 0 0 0-.12-.36 1.75 1.75 0 0 0-.3-.34l-.3-.24.22-.38 3.54 2.04c.27.16.52.33.74.53.22.2.4.43.55.7a1.67 1.67 0 0 1-.01 1.7 1.88 1.88 0 0 1-1.27.93 3.46 3.46 0 0 1-1.6-.14l-.03.04c.2.16.42.35.64.59.23.24.4.5.53.77zm-.65-1.9c.22-.07.41-.18.57-.33.15-.16.3-.35.45-.6.23-.42.3-.81.21-1.19-.09-.37-.39-.7-.88-.98l-.44-.24-.44-.24-1.68 2.91.68.4c.3.17.57.27.82.32.26.04.5.04.7-.04zm-.64 2.85c.26-.44.31-.9.18-1.36-.14-.47-.5-.86-1.06-1.19l-.59-.33-.36-.19-1.53 2.67a.65.65 0 0 0-.02.66c.11.22.34.43.67.62.53.3 1.03.4 1.5.25.46-.16.86-.52 1.21-1.13zM348.94 360.14a3.6 3.6 0 0 0-.5-.13 1.49 1.49 0 0 0-.58-.03c-.17.03-.34.17-.5.42-.17.25-.34.57-.5.97l-1.5 3.49a2.53 2.53 0 0 1-1.86 1.52c-.4.08-.77.09-1.14.04a4.49 4.49 0 0 1-2.25-1.03 3.2 3.2 0 0 1-.74-.93 2.32 2.32 0 0 1-.09-1.94l2.03-4.74a.94.94 0 0 0 .08-.36c0-.1-.06-.23-.16-.36-.08-.1-.18-.19-.31-.29l-.35-.21.18-.4 3.38 1.45c-.05.14-.1.27-.17.4a3.6 3.6 0 0 0-.82-.19c-.15 0-.27.03-.35.12a.98.98 0 0 0-.22.31l-1.9 4.44c-.09.21-.16.45-.21.7a1.76 1.76 0 0 0 .4 1.55c.19.24.51.46.96.64.42.19.8.27 1.15.26.33-.01.63-.08.89-.23.24-.13.45-.3.6-.5.16-.18.3-.4.39-.62l1.4-3.3c.19-.41.3-.77.36-1.06.05-.3.03-.5-.05-.64-.09-.15-.24-.3-.45-.45a3.88 3.88 0 0 0-.5-.32l.18-.4 3.32 1.42-.17.4M358.51 371.38l-3.75-1.09.12-.42c.14.04.31.07.53.11.22.04.38.05.47.03.15-.04.26-.1.35-.18a.74.74 0 0 0 .2-.34l1.76-6.1a1.44 1.44 0 0 0-.1-.03c-1.64 2.12-3.32 4.2-4.96 6.31l-.3-.08c-.2-2.7-.46-5.4-.66-8.1a.74.74 0 0 0-.07-.02l-1.45 5.01c-.14.48-.21.86-.22 1.13-.02.27.03.48.12.63a3.35 3.35 0 0 0 .98.67l-.12.42-3.43-1 .12-.42a5 5 0 0 0 .6.08c.2.02.37 0 .51-.06.17-.08.31-.21.44-.43.11-.21.25-.59.4-1.12l1.24-4.3c.07-.24.1-.45.09-.63a.99.99 0 0 0-.15-.46c-.1-.14-.22-.26-.39-.36-.16-.11-.33-.2-.5-.25l.12-.42 2.89.84c.19 2.34.43 4.67.62 7 1.19-1.56 2.41-3.1 3.6-4.66a4.64 4.64 0 0 0 .58-.95l2.77.8-.12.42a4.02 4.02 0 0 0-.85-.1.46.46 0 0 0-.34.17c-.08.1-.14.2-.17.33l-1.75 6.05a.82.82 0 0 0-.03.37c.02.11.09.22.2.33a3.62 3.62 0 0 0 .77.4l-.12.42M367.6 368.62a1.96 1.96 0 0 1 .68 1.8 2.1 2.1 0 0 1-1.18 1.66c-.3.15-.63.25-.99.3-.36.06-.73.07-1.1.02l-4.16-.52.06-.44a4.47 4.47 0 0 0 .86-.04c.13-.04.23-.1.3-.2.06-.08.1-.2.13-.35l.78-6.23a1 1 0 0 0-.02-.37.6.6 0 0 0-.25-.3 1.73 1.73 0 0 0-.4-.19c-.15-.05-.27-.1-.38-.1l.06-.44 4.05.5c.31.05.6.12.9.21.27.1.53.24.77.43a1.68 1.68 0 0 1 .65 1.58 1.8 1.8 0 0 1-.81 1.35 3.55 3.55 0 0 1-1.53.49l-.02.05c.25.06.52.16.82.29.3.13.56.3.78.5zm-1.33-1.5c.17-.15.3-.33.4-.53.07-.2.14-.44.17-.73.06-.47-.02-.86-.25-1.17-.23-.3-.63-.49-1.2-.56a28.4 28.4 0 0 0-1-.1l-.42 3.33.78.1c.34.04.64.03.89-.02.25-.06.46-.16.63-.31zm.51 2.88a1.7 1.7 0 0 0-.36-1.33c-.3-.38-.79-.6-1.44-.68l-.67-.08-.4-.04-.4 3.06c-.02.25.06.46.25.62.2.16.48.26.85.3.62.08 1.11-.03 1.48-.35.37-.32.6-.81.69-1.5zM378.69 372.75h-2.39c-.52-.82-1-1.52-1.42-2.12-.43-.6-.9-1.2-1.4-1.84h-.9v2.77a1 1 0 0 0 .07.38c.05.1.15.2.3.25.07.03.2.05.39.08.19.02.34.04.47.04v.44h-3.74v-.44l.44-.04c.19-.02.32-.05.4-.08a.53.53 0 0 0 .26-.23c.06-.1.09-.24.09-.4v-6.31c0-.14-.02-.27-.06-.38-.05-.11-.14-.2-.3-.25-.1-.04-.23-.08-.4-.1-.17-.04-.3-.06-.43-.06v-.44h4.09c.37 0 .72.03 1.05.1.33.1.63.2.9.38.25.17.46.37.61.64a2.41 2.41 0 0 1 .08 1.85c-.1.26-.26.48-.47.67-.18.18-.41.33-.67.46a5.5 5.5 0 0 1-.86.33l1.09 1.44 1.06 1.42a2.78 2.78 0 0 0 .93.83c.1.06.25.1.4.12.17.03.3.05.41.05v.44zm-3.28-6.5c0-.53-.16-.95-.46-1.27-.3-.3-.74-.46-1.3-.46h-1.06v3.74h.81c.58 0 1.06-.17 1.44-.54.37-.37.57-.85.57-1.48zM388.88 372.1l-3.67.28-.03-.44c.32-.04.59-.1.8-.18.2-.08.3-.16.3-.25l-.02-.14a.48.48 0 0 0-.05-.14c-.29-.63-.6-1.26-.88-1.9l-3.1.24c-.1.3-.17.55-.22.77l-.16.6-.08.44c0 .12-.02.2 0 .27 0 .17.14.28.41.36.27.07.57.1.9.09l.03.44-3.32.25-.03-.44a2.08 2.08 0 0 0 .78-.29c.16-.12.28-.25.36-.38.09-.12.16-.3.23-.52.35-1.12.77-2.38 1.19-3.79l1.15-3.75.5-.03c1.15 2.44 2.35 4.85 3.5 7.28a1.35 1.35 0 0 0 .6.63c.1.06.23.1.38.12.16.03.29.04.4.04 0 .15.02.3.03.44zm-3.82-3.3l-1.6-3.26c-.34 1.16-.7 2.31-1.06 3.47l2.66-.2zM401.43 361.92l-.45.12c-.17-.3-.44-.57-.8-.86-.36-.29-.67-.41-.93-.38l-.45.08-.58.15-1.44.39.92 3.38.98-.27c.3-.08.53-.17.67-.28.14-.1.27-.23.34-.39.06-.11.1-.27.11-.47.02-.2.01-.4-.02-.63l.45-.12.9 3.32-.45.12a2.98 2.98 0 0 0-.29-.56c-.13-.2-.25-.34-.36-.42a.91.91 0 0 0-.53-.18c-.2 0-.43.03-.68.1l-.98.27.78 2.9c.04.13.1.24.18.33.08.09.19.14.34.17.07.02.21.01.42 0l.47-.07.12.42-3.7 1-.12-.41a9.76 9.76 0 0 0 .85-.35c.1-.08.18-.19.2-.3a.84.84 0 0 0-.02-.39l-1.65-6.08c-.03-.13-.1-.24-.16-.33-.07-.09-.19-.14-.34-.17a2.53 2.53 0 0 0-.47-.02c-.2.01-.36.03-.46.05l-.12-.42 6.7-1.82.57 2.12M411.29 361.17l.96 2.42-6.22 3-.2-.39.38-.23c.16-.1.26-.18.31-.24.1-.1.15-.2.15-.33a.8.8 0 0 0-.1-.39c-.9-1.87-1.8-3.75-2.72-5.63a.97.97 0 0 0-.22-.3.53.53 0 0 0-.37-.1c-.1-.01-.25 0-.43.04-.17.03-.31.06-.41.1l-.2-.39 3.37-1.62.19.4c-.1.05-.23.13-.38.24-.15.12-.26.2-.32.27a.43.43 0 0 0-.15.35c0 .13.04.26.1.38l2.55 5.28c.11.24.21.42.3.55.1.12.2.2.33.23.11.03.26.01.44-.06.19-.06.43-.16.73-.31l.43-.22c.15-.08.28-.17.4-.25.13-.09.23-.18.32-.27.1-.1.15-.18.18-.26.06-.25.13-.59.16-1.04.03-.44.05-.79.02-1.04l.4-.19M415.95 352.52c.54.15 1.05.4 1.53.79a5.36 5.36 0 0 1 1.91 3.25 4.32 4.32 0 0 1-.76 3.2c-.33.44-.74.8-1.25 1.1a4.09 4.09 0 0 1-4.78-.36 5.24 5.24 0 0 1-1.88-3.22 4.13 4.13 0 0 1 2-4.3 4.16 4.16 0 0 1 3.23-.46zm2.35 5.8c0-.44-.05-.89-.2-1.35a7.51 7.51 0 0 0-1.65-2.77 4.1 4.1 0 0 0-1.12-.83 2.32 2.32 0 0 0-2.33.08c-.42.25-.73.56-.91.94-.18.38-.28.78-.28 1.22 0 .41.08.85.24 1.32a7.46 7.46 0 0 0 1.6 2.7c.33.35.7.62 1.08.82.39.2.77.29 1.17.3.4 0 .8-.12 1.2-.36a2.4 2.4 0 0 0 1.2-2.06zM429.27 352.37l-1.95 1.38c-.9-.37-1.7-.66-2.38-.9-.7-.25-1.43-.46-2.2-.7l-.74.53 1.6 2.26c.08.1.18.2.27.26.1.06.24.07.39.04a4.56 4.56 0 0 0 .78-.4l.25.35-3.05 2.16-.25-.35a8.2 8.2 0 0 0 .6-.58.5.5 0 0 0 .09-.35.78.78 0 0 0-.16-.37l-3.65-5.15a1.1 1.1 0 0 0-.27-.27c-.1-.07-.23-.08-.38-.04a3.2 3.2 0 0 0-.77.35l-.26-.36 3.33-2.36c.3-.21.61-.39.93-.52.31-.12.62-.2.94-.21.3-.02.6.04.87.16.28.13.53.35.74.65.2.28.33.55.39.82.07.27.07.54.02.81-.05.26-.15.5-.3.76-.13.26-.3.52-.5.77l1.72.54c.45.16 1.02.33 1.68.55a2.6 2.6 0 0 0 1.25.14 2.74 2.74 0 0 0 .76-.33l.25.36zm-6.43-3.41c-.31-.43-.68-.68-1.11-.76-.43-.08-.87.05-1.33.37-.3.2-.58.41-.87.62l2.17 3.05.67-.47c.46-.33.76-.76.85-1.27.1-.52-.03-1.04-.39-1.54zM436.56 346.87l.73 2.47-6.89 2.56-.15-.41a4.29 4.29 0 0 0 .8-.45c.1-.1.17-.21.18-.32a.77.77 0 0 0-.05-.38l-2.19-5.88a1.02 1.02 0 0 0-.19-.32c-.08-.08-.2-.12-.36-.14-.12 0-.28 0-.46.03-.2.02-.35.05-.46.09l-.15-.41 6.42-2.39.73 1.98c-.14.06-.3.1-.43.16a2.82 2.82 0 0 0-.85-.74c-.4-.24-.7-.32-.95-.27l-.44.13-.58.2-1.3.48 1.2 3.25.94-.34c.3-.11.5-.22.63-.33.11-.1.2-.24.26-.41.05-.15.06-.32.05-.54a3 3 0 0 0-.07-.57l.43-.16 1.2 3.21-.44.17a3.3 3.3 0 0 0-.35-.55c-.14-.17-.27-.3-.38-.36a.9.9 0 0 0-.52-.14c-.17 0-.38.06-.64.15l-.93.35.9 2.46c.1.25.2.43.28.56.09.14.2.21.32.25.13.04.29.03.47-.02s.44-.12.76-.24l.5-.2a3.6 3.6 0 0 0 .96-.47c.14-.1.24-.2.27-.29.12-.25.2-.6.26-1.05s.08-.77.07-.96l.42-.16M443.96 340.81c.44.35.81.79 1.1 1.32a5.33 5.33 0 0 1 .49 3.75c-.15.59-.4 1.1-.74 1.56a4.03 4.03 0 0 1-2.8 1.6 4.03 4.03 0 0 1-3.19-.88 4.27 4.27 0 0 1-1.06-1.32 5.07 5.07 0 0 1-.56-1.76c-.1-.7-.06-1.35.09-1.94a4.14 4.14 0 0 1 3.53-3.17 4.23 4.23 0 0 1 3.14.84zm-.11 6.26c.18-.4.3-.84.34-1.32a7.52 7.52 0 0 0-.44-3.2 4.05 4.05 0 0 0-.69-1.2 2.34 2.34 0 0 0-2.18-.83c-.49.06-.9.22-1.2.5-.32.27-.58.6-.74 1.01-.15.39-.26.82-.29 1.31a7.25 7.25 0 0 0 .42 3.1c.16.46.4.85.67 1.19.26.34.58.56.95.73.36.15.78.2 1.25.14a2.39 2.39 0 0 0 1.9-1.43z'/%3E %3C/g%3E %3C/g%3E %3Cpath d='M422.97 213.66v55.25c0 10.99-1.52 54.74-48.53 71.74-47.1-17-48.63-60.75-48.63-71.74v-55.25h97.16' stroke='%23000' stroke-width='1.02' fill='none'/%3E %3C/g%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1000 500'%3E %3Crect width='1000' height='500' fill='%23f00'/%3E %3Crect width='500' height='500' fill='%23fff' x='250'/%3E %3Cpath fill='%23ff0000' d='m 499.99228,46.875 -34.11312,63.62529 c -3.87086,6.91501 -10.80627,6.27363 -17.74169,2.41138 l -24.69699,-12.78858 18.40705,97.72711 c 3.87086,17.85419 -8.54859,17.85419 -14.67765,10.13435 l -43.10105,-48.25099 -6.99738,24.503 c -0.80692,3.21777 -4.35481,6.59744 -9.67748,5.79261 l -54.50177,-11.45912 14.31524,52.04475 c 3.06451,11.58054 5.4549,16.37528 -3.09375,19.42959 l -19.42619,9.13025 93.82127,76.20838 c 3.7135,2.88151 5.58971,8.067 4.26768,12.7621 l -8.21136,26.94707 c 32.30405,-3.72371 61.24898,-9.32594 93.56939,-12.77619 2.85323,-0.30459 7.62988,4.40408 7.61029,7.71058 l -4.28024,98.72342 15.70639,0 -2.47237,-98.5117 c -0.0197,-3.3065 4.31372,-8.22689 7.16695,-7.9223 32.32041,3.45026 61.26538,9.05248 93.56942,12.77619 l -8.21134,-26.94707 c -1.32203,-4.6951 0.55417,-9.88059 4.26767,-12.7621 l 93.82125,-76.20838 -19.42617,-9.13025 c -8.54867,-3.05431 -6.15828,-7.84905 -3.09377,-19.42959 l 14.31527,-52.04475 -54.5018,11.45912 c -5.32267,0.80483 -8.87056,-2.57484 -9.6775,-5.79261 l -6.99737,-24.503 -43.10103,48.25099 c -6.12908,7.71984 -18.54854,7.71984 -14.67768,-10.13435 l 18.40702,-97.72711 -24.69694,12.78858 c -6.93559,3.86225 -13.87083,4.50363 -17.7417,-2.41138'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 10080 5040'%3E %3Cdefs%3E %3Cpath id='Star7' d='M0,-360 69.421398,-144.155019 281.459334,-224.456329 155.988466,-35.603349 350.974048,80.107536 125.093037,99.758368 156.198146,324.348792 0,160 -156.198146,324.348792 -125.093037,99.758368 -350.974048,80.107536 -155.988466,-35.603349 -281.459334,-224.456329 -69.421398,-144.155019z'/%3E %3Cpath id='Star5' d='M0,-210 54.859957,-75.508253 199.721868,-64.893569 88.765275,28.841586 123.434903,169.893569 0,93.333333 -123.434903,169.893569 -88.765275,28.841586 -199.721868,-64.893569 -54.859957,-75.508253z'/%3E %3C/defs%3E %3Crect width='10080' height='5040' fill='%23008000'/%3E %3Ccircle cx='5040' cy='2520' r='1050' fill='%23ffe000'/%3E %3Ccircle cx='5367.4' cy='2520' r='864' fill='%23008000'/%3E %3Ccircle cx='1730' cy='1470' r='1100' fill='%23ffe000'/%3E %3Cpath fill='%23802000' stroke='%237b3100' stroke-width='23.333' d='m1654.1,2299.4,274.67,0s12.398-25.178-2.7658-37.767-74.229-15.36-58.271-59.892c32.807-91.555,37.385-63.326,57.985-280.77s30.518-558.49,30.518-558.49h-39.674s7.6296,106.05-15.259,244.15-29.755,150.3-54.933,256.35-28.992,115.21-51.881,177.01-25.178,64.852-61.037,122.07c-35.859,57.222-22.889,35.859-42.726,70.192-9.9186,17.166-22.126,12.589-28.802,25.082-6.6759,12.494-7.8204,42.058-7.8204,42.058z'/%3E %3Cpath fill='%23008000' d='m1863.7,668.6c2.2817,42.661-2.0069,99.138-19.688,145.1-17.928,51.216-37.423,102.27-36.458,155.31-28.502,9.6945-57.877-61.678-85.312-19.688,20.624,58.016,68.239,103.95,100.86,156.22,5.5021,16.205,52.438,58.518,25.281,68.358-68.547-23.46-85.162-110.31-127.68-163.05-49.38-88.757-141.44-151.49-244-155.82-38.524,1.0094-163.78-9.548-131.19,56.419,47.997,32.632,107.14,53.91,154.53,90.537,35.31,3.3032,99.31,62.248,95.579,84.52-62.102-25.153-91.169-55.299-158.08-81.758-90.658-35.014-216.06-13.954-266.25,76.021-9.3572,23.433-23.172,91.731,6.2547,98.238,34.384-53.685,83.569-113.7,156.45-97.6,57.244,4.4692-63.877,106.64-17.544,86.084,14.681-6.5147,48.583-28.769,72.102-31.093,23.518-2.324,36.653,15.282,54.497,17.718,35.688,4.8718,45.515,19.833,42.207,28.537-3.9027,10.269-15.241,1.5013-51.52,13.004-18.14,5.7513-27.615,21.692-48.774,28.989-21.158,7.2976-65.173,7.8148-81.621,1.3436-57.547-24.996-151.89-20.645-169.83,51.468-0.016,31.711-28.236-3.5038-41.278,10.196-9.7795,34.603-12.309,70.132-63.633,66.99-31.155,32.684-63.06,66.527-102.62,89.781,23.215,53.284,115.2-53.516,110.9-8.4838-40.21,54.832,20.689,66.37,47.348,24.166,45.088-47.64,100.93-105.63,168.21-57.618,32.044,30.169,50.664-15.951,73.857-13.481,14.612,37.475,32.998,1.8444,49.583-8.75,27.15-3.3824,19.511,33.91,51.771,10.938,64.293-42.551,143.39-6.796,206.2-48.197,66.852-30.458,9.3858,24.532-9.0659,46.028-29.373,56.97-3.8997,131.76-67.613,167.14-25.593,67.895,30.237,157.4-26.707,207.63-8.2836,31.496,73.234,27.889,96.113,40.832,40.09,1.5876-1.7229-91.758,38.054-104.27,53.344,33.019,50.846-59.049,39.831-87.447,5.1712-64.552,8.8142-135.13,40.892-193.6,34.102-71.662,65.666,29.186,27.491,57.558-21.685,65.896-53.25,148.36-3.9423,209.64,14.211,3.1803,25.879,37.625,44.279,48.212s43.531-2.6843,48.118-34.022c23.601-94.369,11.712-195.85,45.415-287.63,23.788-28.43,56.603-4.584,71.355,21.559,47.23,54.833,80.43,123.38,137.61,168.56,52.063,24.362,98.106,61.211,122.1,114.81-0.3209,41.353,117.45,47.692,82.258,1.7272-33.768-44.747-11.488-89.504,22.715-119.26,18.318,4.5181,12.904-28.289-1.4583-15.312-22.995-5.4244-24.466-47.512,7.4967-27.507,53.836,17.379-4.197-38.962-23.655-40.69-45.52-28.215-97.819-60.676-120.2-109.72,59.256,0.6043,120.77,32.564,181.32,12.74,48.538-24.937,97.769,2.0801,114.72,44.864,37.52-5.9873,21.524-43.614,0-56.146,27.443-11.325,46.422-34.805,13.147-55.515-17.574-22.934,23.566-62.052-27.001-60.422,1.6515-38.627-13.556-73.973-55.66-87.318-42.178-35.717-165.95,52.62-162.36-27.89-12.471-43.818,50.278-5.8539,67.812-27.708,18.118-46.194-86.337-41.686-51.87-77.5,22.511-14.494,128.15-35.314,45.306-50.82-41.347,11.364-76.832,2.9489-109.37-17.513-29.657,49.603-114.34-26.938-99.252,61.251-11.585,33.23-87.278,119.57-107.76,53.423,17.422-51.845,107.1-68.797,79.291-138.7-4.2682-43.636-40.446,7.5887-57.49,4.335-8.6308-27.162,26.103-59.178,50.312-65.625,48.038,36.948,49.493-46.614,95.178-39.816,33.355-7.4109-10.771-21.718-20.074-27.996,9.1407-24.416,60.346-36.892,10.136-58.094-44.302-32.872-77.138,32.72-113.68,36.218-35.072-39.595,31.842-58.628,50.312-79.479,0.9929-15.543-39.017-4.6894-26.979-18.229,10.456-18.69,81.301-20.081,48.125-48.125-49.965-17.153-114.44-12.876-162.38,9.3461-30.203,9.7774-39.089,78.069-65.122,75.237-12.24-30.398,3.9853-90.372-37.917-99.167zm236.25,667.19c38.072-6.447,0.8081,57.818-17.5,56.875,1.6178-23.092-55.065-20.869-19.897-40.988,11.405-7.3645,24.112-12.982,37.397-15.887z'/%3E %3Cg fill='%23ffe000'%3E %3Cuse xlink:href='%23Star7' x='7560' y='4200'/%3E %3Cuse xlink:href='%23Star7' x='6300' y='2205'/%3E %3Cuse xlink:href='%23Star7' x='7560' y='840'/%3E %3Cuse xlink:href='%23Star7' x='8680' y='1869'/%3E %3Cuse xlink:href='%23Star5' x='8064' y='2730'/%3E %3C/g%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 800 600'%3E %3Crect width='800' height='600' x='0' y='0' style='fill:%23007fff'/%3E %3Cpath d='m 36,120 84,0 26,-84 26,84 84,0 -68,52 26,84 -68,-52 -68,52 26,-84 -68,-52 z M 750,0 0,450 0,600 0,600 50,600 800,150 800,0 750,0' style='fill:%23f7d618'/%3E %3Cpath d='M 800,0 0,480 0,600 0,600 0,600 800,120 800,0' style='fill:%23ce1021'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 450 300'%3E %3Crect fill='%23FFCE00' width='450' height='300'/%3E %3Crect fill='%23289728' width='450' height='225'/%3E %3Crect fill='%23FFFFFF' width='450' height='150'/%3E %3Crect fill='%23003082' width='450' height='75'/%3E %3Crect x='187.5' fill='%23D21034' width='75' height='300'/%3E %3Cpath fill='%23FFCE00' d='M75.028,7.004L94.9,67.996L42.902,30.333h64.197L55.1,67.996L75.028,7.004z'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 3 2'%3E %3Crect id='green_area' width='3' height='2' fill='%23009543'/%3E %3Cpath id='yellow_area' d='M 0 2 L 2 0 h 1 v 2 z' fill='%23FBDE4A'/%3E %3Cpath id='red_area' d='M 3 0 v 2 h -2 z' fill='%23DC241F'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 320 320'%3E %3Crect fill='%23D52B1E' height='320' width='320'/%3E %3Crect fill='%23fff' height='60' width='200' x='60' y='130'/%3E %3Crect fill='%23fff' height='200' width='60' x='130' y='60'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 450 300'%3E %3Crect fill='%23009E60' width='450' height='300'/%3E %3Crect fill='%23FFF' width='300' height='300'/%3E %3Crect fill='%23F77F00' width='150' height='300'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 600 300'%3E %3CclipPath id='cp'%3E %3Cpath d='M0,0V75H350V150H300zM300,0H150V200H0V150z'/%3E %3C/clipPath%3E %3Crect width='600' height='300' fill='%2300247d'/%3E %3Cpath d='M0,0L300,150M300,0L0,150' stroke='%23fff' stroke-width='30'/%3E %3Cpath d='M0,0L300,150M300,0L0,150' stroke='%23cf142b' stroke-width='20' clip-path='url(%23cp)'/%3E %3Cpath d='M150,0V200M0,75H350' stroke='%23fff' stroke-width='50'/%3E %3Cpath d='M150,0V200M0,75H350' stroke='%23cf142b' stroke-width='30'/%3E %3Cpath d='M300,0V150H0V300H600V0z' fill='%2300247d'/%3E %3Cg transform='translate(450,150)'%3E %3Cg id='s1' transform='translate(0,-102)' fill='%23fff'%3E %3Cg id='c'%3E %3Cpath id='t' d='M0,-22.5V0H12' transform='rotate(18,0,-22.5)'/%3E %3Cuse xlink:href='%23t' transform='scale(-1,1)'/%3E %3C/g%3E %3Cuse xlink:href='%23c' transform='rotate(72)'/%3E %3Cuse xlink:href='%23c' transform='rotate(144)'/%3E %3Cuse xlink:href='%23c' transform='rotate(216)'/%3E %3Cuse xlink:href='%23c' transform='rotate(288)'/%3E %3C/g%3E %3Cg id='s7'%3E %3Cuse xlink:href='%23s1' transform='rotate(24)'/%3E %3Cuse xlink:href='%23s1' transform='rotate(48)'/%3E %3Cuse xlink:href='%23s1' transform='rotate(72)'/%3E %3Cuse xlink:href='%23s1' transform='rotate(96)'/%3E %3Cuse xlink:href='%23s1' transform='rotate(120)'/%3E %3Cuse xlink:href='%23s1' transform='rotate(144)'/%3E %3Cuse xlink:href='%23s1' transform='rotate(168)'/%3E %3C/g%3E %3Cuse xlink:href='%23s7' transform='rotate(168)'/%3E %3C/g%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='-4 -4 24 16'%3E %3Cpath d='M20,12H-4V-4H20z' fill='%23d52b1e'/%3E %3Cpath d='M4,4H20V-4H-4z' fill='%23fff'/%3E %3Cpath d='M4,4H-4V-4H4z' fill='%230039a6'/%3E %3Cg id='f'%3E %3Cg id='t'%3E %3Cpath d='M0,-2V0H1z' fill='%23fff' transform='rotate(18,0,-2)' id='o'/%3E %3Cuse xlink:href='%23o' transform='scale(-1,1)'/%3E %3C/g%3E %3Cuse xlink:href='%23t' transform='rotate(72)'/%3E %3C/g%3E %3Cuse xlink:href='%23t' transform='rotate(-72)'/%3E %3Cuse xlink:href='%23f' transform='rotate(144)'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 90 60'%3E %3Crect width='30' height='60' fill='%23007a5e'/%3E %3Crect x='30' width='30' height='60' fill='%23ce1126'/%3E %3Crect x='60' width='30' height='60' fill='%23fcd116'/%3E %3Cg transform='translate(45,30)' fill='%23fcd116'%3E %3Cg id='c'%3E %3Cpath id='t' d='M 0,-8 v 8 h 4 z' transform='rotate(18 0,-8)'/%3E %3Cuse xlink:href='%23t' transform='scale(-1,1)'/%3E %3C/g%3E %3Cuse xlink:href='%23c' transform='rotate(72)'/%3E %3Cuse xlink:href='%23c' transform='rotate(144)'/%3E %3Cuse xlink:href='%23c' transform='rotate(216)'/%3E %3Cuse xlink:href='%23c' transform='rotate(288)'/%3E %3C/g%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 30 20'%3E %3Cdefs%3E %3Cpath id='s' d='M0,-1 0.587785,0.809017 -0.951057,-0.309017H0.951057L-0.587785,0.809017z' fill='%23ffde00'/%3E %3C/defs%3E %3Crect width='30' height='20' fill='%23de2910'/%3E %3Cuse xlink:href='%23s' transform='translate(5,5) scale(3)'/%3E %3Cuse xlink:href='%23s' transform='translate(10,2) rotate(23.036243)'/%3E %3Cuse xlink:href='%23s' transform='translate(12,4) rotate(45.869898)'/%3E %3Cuse xlink:href='%23s' transform='translate(12,7) rotate(69.945396)'/%3E %3Cuse xlink:href='%23s' transform='translate(10,9) rotate(20.659808)'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 4'%3E %3Crect fill='%23CE1126' width='6' height='4'/%3E %3Crect fill='%23003893' width='6' height='3'/%3E %3Crect fill='%23FCD116' width='6' height='2'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg height='600' width='1000' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3ClinearGradient id='a'%3E%3Cstop offset='0' stop-color='%23fbd55f'/%3E%3Cstop offset='1' stop-color='%23cb8e32'/%3E%3C/linearGradient%3E%3CradialGradient id='f' cx='416.38' cy='814.57' gradientTransform='matrix(1 0 0 1.0057 0 -4.636)' gradientUnits='userSpaceOnUse' r='7.422' xlink:href='%23a'/%3E%3CradialGradient id='e' cx='393.34' cy='837.95' gradientTransform='matrix(1 0 0 .99109 0 7.468)' gradientUnits='userSpaceOnUse' r='7.506' xlink:href='%23a'/%3E%3CradialGradient id='d' cx='416.58' cy='860.97' gradientTransform='matrix(1 0 0 1.0082 0 -7.063)' gradientUnits='userSpaceOnUse' r='7.422' xlink:href='%23a'/%3E%3CradialGradient id='c' cx='439.62' cy='837.58' gradientTransform='matrix(1 0 0 .98778 0 10.237)' gradientUnits='userSpaceOnUse' r='7.506' xlink:href='%23a'/%3E%3CradialGradient id='b' cx='416.51' cy='837.65' gradientTransform='matrix(1 0 0 .98848 0 9.646)' gradientUnits='userSpaceOnUse' r='11.146' xlink:href='%23a'/%3E%3CradialGradient id='g' cx='760.54' cy='474.25' gradientTransform='matrix(1 0 0 .99305 0 3.294)' gradientUnits='userSpaceOnUse' r='12.039' xlink:href='%23a'/%3E%3CradialGradient id='h' cx='731.81' cy='474.25' gradientTransform='matrix(1 0 0 .99305 0 1.88)' gradientUnits='userSpaceOnUse' r='12.039' xlink:href='%23a'/%3E%3CradialGradient id='i' cx='703.46' cy='474.25' gradientTransform='matrix(1 0 0 .99305 0 3.294)' gradientUnits='userSpaceOnUse' r='12.039' xlink:href='%23a'/%3E%3CradialGradient id='j' cx='771.02' cy='499.67' gradientTransform='matrix(1 0 0 .991 0 4.502)' gradientUnits='userSpaceOnUse' r='12.039' xlink:href='%23a'/%3E%3CradialGradient id='k' cx='742.68' cy='499.67' gradientTransform='matrix(1 0 0 .991 0 4.502)' gradientUnits='userSpaceOnUse' r='12.039' xlink:href='%23a'/%3E%3CradialGradient id='l' cx='714.14' cy='499.67' gradientTransform='matrix(1 0 0 .991 0 4.502)' gradientUnits='userSpaceOnUse' r='12.039' xlink:href='%23a'/%3E%3CradialGradient id='m' cx='772.18' cy='526.29' gradientTransform='matrix(1 0 0 .99305 0 3.655)' gradientUnits='userSpaceOnUse' r='12.039' xlink:href='%23a'/%3E%3CradialGradient id='n' cx='745.39' cy='525.29' gradientTransform='matrix(1 0 0 .99305 0 3.648)' gradientUnits='userSpaceOnUse' r='12.039' xlink:href='%23a'/%3E%3CradialGradient id='o' cx='716.86' cy='525.29' gradientTransform='matrix(1 0 0 .99305 0 3.648)' gradientUnits='userSpaceOnUse' r='12.039' xlink:href='%23a'/%3E%3CradialGradient id='p' cx='768.04' cy='552.78' gradientTransform='matrix(1 0 0 .98916 0 5.991)' gradientUnits='userSpaceOnUse' r='11.383' xlink:href='%23a'/%3E%3CradialGradient id='q' cx='741.28' cy='552.78' gradientTransform='matrix(1 0 0 .99234 0 4.237)' gradientUnits='userSpaceOnUse' r='11.347' xlink:href='%23a'/%3E%3CradialGradient id='r' cx='714.26' cy='552.78' gradientTransform='matrix(1 0 0 .989 0 6.08)' gradientUnits='userSpaceOnUse' r='11.385' xlink:href='%23a'/%3E%3CradialGradient id='s' cx='761.91' cy='580.39' gradientTransform='matrix(1 0 0 .99259 0 4.303)' gradientUnits='userSpaceOnUse' r='10.886' xlink:href='%23a'/%3E%3CradialGradient id='t' cx='737.53' cy='577.5' gradientTransform='matrix(1 0 0 .99205 0 4.59)' gradientUnits='userSpaceOnUse' r='10.886' xlink:href='%23a'/%3E%3CradialGradient id='u' cx='711.71' cy='576.36' gradientTransform='matrix(1 0 0 .99259 0 4.272)' gradientUnits='userSpaceOnUse' r='10.886' xlink:href='%23a'/%3E%3CradialGradient id='v' cx='751.9' cy='604.02' gradientTransform='matrix(1 0 0 .98919 0 6.531)' gradientUnits='userSpaceOnUse' r='10.462' xlink:href='%23a'/%3E%3CradialGradient id='w' cx='729.67' cy='600.54' gradientTransform='matrix(1 0 0 .99915 0 .513)' gradientUnits='userSpaceOnUse' r='9.95' xlink:href='%23a'/%3E%3CradialGradient id='x' cx='706.08' cy='597.51' gradientTransform='matrix(1 0 0 .99726 0 1.636)' gradientUnits='userSpaceOnUse' r='8.123' xlink:href='%23a'/%3E%3CradialGradient id='y' cx='741.9' cy='625.39' gradientTransform='matrix(1 0 0 .99915 0 .535)' gradientUnits='userSpaceOnUse' r='9.95' xlink:href='%23a'/%3E%3CradialGradient id='z' cx='720.45' cy='618.78' gradientTransform='matrix(1 0 0 1.0069 0 -4.273)' gradientUnits='userSpaceOnUse' r='8.345' xlink:href='%23a'/%3E%3CradialGradient id='A' cx='700.55' cy='614.7' gradientTransform='matrix(1 0 0 .99645 0 2.18)' gradientUnits='userSpaceOnUse' r='7.03' xlink:href='%23a'/%3E%3CradialGradient id='B' cx='731.65' cy='644.12' gradientTransform='matrix(1 0 0 .99834 0 1.067)' gradientUnits='userSpaceOnUse' r='9.333' xlink:href='%23a'/%3E%3CradialGradient id='C' cx='712.98' cy='635.08' gradientTransform='matrix(1 0 0 1.00597 0 -3.791)' gradientUnits='userSpaceOnUse' r='7.792' xlink:href='%23a'/%3E%3CradialGradient id='D' cx='695.15' cy='628.49' gradientTransform='matrix(1 0 0 .99767 0 1.462)' gradientUnits='userSpaceOnUse' r='6.64' xlink:href='%23a'/%3E%3CradialGradient id='E' cx='718.42' cy='660.82' gradientTransform='matrix(1 0 0 1.00252 0 -1.666)' gradientUnits='userSpaceOnUse' r='8.623' xlink:href='%23a'/%3E%3CradialGradient id='F' cx='702.21' cy='650.42' gradientTransform='matrix(1 0 0 .999 0 .647)' gradientUnits='userSpaceOnUse' r='7.301' xlink:href='%23a'/%3E%3CradialGradient id='G' cx='686.7' cy='642.53' gradientTransform='matrix(1 0 0 1.0069 0 -4.435)' gradientUnits='userSpaceOnUse' r='6.091' xlink:href='%23a'/%3E%3CradialGradient id='H' cx='707.38' cy='674.82' gradientTransform='matrix(1 0 0 .9913 0 5.871)' gradientUnits='userSpaceOnUse' r='7.953' xlink:href='%23a'/%3E%3CradialGradient id='I' cx='693.57' cy='664.01' gradientTransform='matrix(1 0 0 1.01302 0 -8.648)' gradientUnits='userSpaceOnUse' r='6.615' xlink:href='%23a'/%3E%3CradialGradient id='J' cx='680.18' cy='655.53' gradientTransform='matrix(1 0 0 1.00534 0 -3.497)' gradientUnits='userSpaceOnUse' r='5.651' xlink:href='%23a'/%3E%3CradialGradient id='K' cx='694.25' cy='686.15' gradientTransform='matrix(1 0 0 1.00986 0 -6.764)' gradientUnits='userSpaceOnUse' r='6.753' xlink:href='%23a'/%3E%3CradialGradient id='L' cx='682.92' cy='676.43' gradientTransform='matrix(1 0 0 1.00582 0 -3.938)' gradientUnits='userSpaceOnUse' r='5.721' xlink:href='%23a'/%3E%3CradialGradient id='M' cx='671.83' cy='668.65' gradientTransform='matrix(1 0 0 1.02442 0 -16.33)' gradientUnits='userSpaceOnUse' r='4.779' xlink:href='%23a'/%3E%3CradialGradient id='N' cx='682.71' cy='696.23' gradientTransform='matrix(1 0 0 1.00802 0 -5.585)' gradientUnits='userSpaceOnUse' r='6.282' xlink:href='%23a'/%3E%3CradialGradient id='O' cx='673.31' cy='686.5' gradientTransform='matrix(1 0 0 1.01694 0 -11.63)' gradientUnits='userSpaceOnUse' r='5.292' xlink:href='%23a'/%3E%3CradialGradient id='P' cx='663.89' cy='678.28' gradientTransform='matrix(1 0 0 1.00862 0 -5.844)' gradientUnits='userSpaceOnUse' r='4.489' xlink:href='%23a'/%3E%3CradialGradient id='Q' cx='671.6' cy='705.18' gradientTransform='matrix(1 0 0 1.0059 0 -4.166)' gradientUnits='userSpaceOnUse' r='6.282' xlink:href='%23a'/%3E%3CradialGradient id='R' cx='662.2' cy='695.65' gradientTransform='matrix(1 0 0 1.01055 0 -7.342)' gradientUnits='userSpaceOnUse' r='5.292' xlink:href='%23a'/%3E%3CradialGradient id='S' cx='654.58' cy='687.37' gradientTransform='matrix(1 0 0 1.01672 0 -11.49)' gradientUnits='userSpaceOnUse' r='4.49' xlink:href='%23a'/%3E%3CradialGradient id='T' cx='646.03' cy='696.48' gradientTransform='matrix(1 0 0 1.02355 0 -16.403)' gradientUnits='userSpaceOnUse' r='4.136' xlink:href='%23a'/%3E%3CradialGradient id='U' cx='653.02' cy='704.68' gradientTransform='matrix(1 0 0 1.00552 0 -3.892)' gradientUnits='userSpaceOnUse' r='4.489' xlink:href='%23a'/%3E%3CradialGradient id='V' cx='660.59' cy='713.14' gradientTransform='matrix(1 0 0 1.0171 0 -12.2)' gradientUnits='userSpaceOnUse' r='4.846' xlink:href='%23a'/%3E%3CradialGradient id='W' cx='637.01' cy='705.72' gradientTransform='matrix(1 0 0 1.01093 0 -7.714)' gradientUnits='userSpaceOnUse' r='3.872' xlink:href='%23a'/%3E%3CradialGradient id='X' cx='642.62' cy='712.94' gradientTransform='matrix(1 0 0 1.01384 0 -9.865)' gradientUnits='userSpaceOnUse' r='4.135' xlink:href='%23a'/%3E%3CradialGradient id='Y' cx='649.42' cy='720.03' gradientTransform='matrix(1 0 0 1.0073 0 -5.25)' gradientUnits='userSpaceOnUse' r='4.405' xlink:href='%23a'/%3E%3CradialGradient id='Z' cx='628.35' cy='711.82' gradientTransform='matrix(1 0 0 1.02676 0 -19.049)' gradientUnits='userSpaceOnUse' r='3.517' xlink:href='%23a'/%3E%3CradialGradient id='aa' cx='633.37' cy='718.62' gradientTransform='matrix(1 0 0 1.02113 0 -15.183)' gradientUnits='userSpaceOnUse' r='3.871' xlink:href='%23a'/%3E%3CradialGradient id='ab' cx='639.59' cy='726.09' gradientTransform='matrix(1 0 0 1.03175 0 -23.056)' gradientUnits='userSpaceOnUse' r='4.048' xlink:href='%23a'/%3E%3CradialGradient id='ac' cx='621.03' cy='717.31' gradientTransform='matrix(1 0 0 1.01622 0 -11.635)' gradientUnits='userSpaceOnUse' r='3.417' xlink:href='%23a'/%3E%3CradialGradient id='ad' cx='625.6' cy='723.58' gradientTransform='matrix(1 0 0 1.01891 0 -13.684)' gradientUnits='userSpaceOnUse' r='3.634' xlink:href='%23a'/%3E%3CradialGradient id='ae' cx='629.94' cy='730.32' gradientTransform='matrix(1 0 0 1.0334 0 -24.397)' gradientUnits='userSpaceOnUse' r='3.904' xlink:href='%23a'/%3E%3CradialGradient id='af' cx='614.05' cy='721.3' gradientTransform='matrix(1 0 0 1.00982 0 -7.086)' gradientUnits='userSpaceOnUse' r='3.053' xlink:href='%23a'/%3E%3CradialGradient id='ag' cx='617.69' cy='727.85' gradientTransform='matrix(1 0 0 1.0159 0 -11.57)' gradientUnits='userSpaceOnUse' r='3.256' xlink:href='%23a'/%3E%3CradialGradient id='ah' cx='621.24' cy='734.22' gradientTransform='matrix(1 0 0 1.00532 0 -3.906)' gradientUnits='userSpaceOnUse' r='3.473' xlink:href='%23a'/%3E%3CradialGradient id='ai' cx='606.69' cy='724.91' gradientTransform='matrix(1 0 0 1.0049 0 -3.546)' gradientUnits='userSpaceOnUse' r='2.946' xlink:href='%23a'/%3E%3CradialGradient id='aj' cx='609.28' cy='730.85' gradientTransform='matrix(1 0 0 1.01859 0 -13.586)' gradientUnits='userSpaceOnUse' r='3.122' xlink:href='%23a'/%3E%3CradialGradient id='ak' cx='612.94' cy='737.49' gradientTransform='matrix(1 0 0 1.01562 0 -11.523)' gradientUnits='userSpaceOnUse' r='3.378' xlink:href='%23a'/%3E%3CradialGradient id='al' cx='600.03' cy='728.91' gradientTransform='matrix(1 0 0 1.0265 0 -19.31)' gradientUnits='userSpaceOnUse' r='2.506' xlink:href='%23a'/%3E%3CradialGradient id='am' cx='602' cy='734.39' gradientTransform='matrix(1 0 0 .98882 0 8.212)' gradientUnits='userSpaceOnUse' r='2.724' xlink:href='%23a'/%3E%3CradialGradient id='an' cx='604.74' cy='740' gradientTransform='matrix(1 0 0 1.00265 0 -1.96)' gradientUnits='userSpaceOnUse' r='2.914' xlink:href='%23a'/%3E%3CradialGradient id='ao' cx='685.79' cy='453.08' gradientTransform='matrix(1 0 0 .99658 1.768 2.964)' gradientUnits='userSpaceOnUse' r='8.107' xlink:href='%23a'/%3E%3Cg stroke-width='1.2'%3E%3Cpath d='M0 0h1000v600H0z' fill='%23002b7f'/%3E%3Cpath d='M0 100h1000v399.996H0z' fill='%23fff'/%3E%3Cpath d='M0 200.004h1000v200.004H0z' fill='%23ce1126'/%3E%3Cellipse cx='300.001' cy='300' fill='%23fff' rx='75' ry='87.5'/%3E%3C/g%3E%3Cg transform='translate(235.939 234.475) scale(.15382)'%3E%3Cg stroke='%23000' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M105.36 349.34l11-20.25-26-7.25-8 18zm622.24 0l-11-20.25 26-7.25 8 18z' fill='%23cea849' stroke-width='3'/%3E%3Cpath d='M409.48 91.438l-40.094 1.157c-25.601 2.418-35.334 12.29-19.437 30.965-41.272 6.469-81.637 15.908-118.94 35.626-10.486-1.74-22.662 4.134-26.156 14.232-2.912 8.158 4.188 16.828 16.812 13.387-8.35 21.987-106.99 19.428-109.5 56.05 7.472-6.368 15.699-11.766 23.906-6.318l-5.656 17.11c-14.363 4.277-24.455 6.644-30.47 22.363-6.212 15.77-15.13 39.832-21.343 51.671-4.08 5.472-5.063 11.284-5.063 14.17 0 6.814 4.869 16.326 16.125 16.326 11.456 0 17.094-7.175 17.094-14.388-.666-5.02-2.644-10.912-14.75-10.228 20.321-4.871 37.886 1.953 49.687 9.477 16.306 12.038 20.387 35.38 10.875 54.58-9.323 18.654-33.013 29.543-68.344 15.764-28.736-11.292-57.644 3.484-67.156 29.151-43.293 117.15 32.408 212.17 118.22 267.58 89.304 57.703 105.21 73.418 129.09 101.62 24.07 28.155 47.37 60.398 82.312 60.398 5.437 0 10.682-1.56 15.344-4.097 21.995 0 23.424 8.208 52.937 8.727v.03c.512 0 1.004-.026 1.5-.03.492.004.962.03 1.47.03v-.03c29.544-.514 30.965-8.727 52.968-8.727 4.662 2.537 9.876 4.097 15.312 4.097 34.943 0 58.243-32.243 82.312-60.398 23.88-28.205 39.821-43.92 129.12-101.62 85.81-55.415 161.51-150.44 118.22-267.58-9.512-25.668-38.45-40.443-67.187-29.15-35.33 13.778-58.989 2.89-68.312-15.765-9.512-19.2-5.431-42.542 10.875-54.58 11.802-7.524 29.335-14.349 49.656-9.477-12.106-.684-14.053 5.209-14.719 10.228 0 7.213 5.638 14.388 17.094 14.388 11.257 0 16.094-9.512 16.094-16.327 0-2.885-.95-8.697-5.031-14.169-6.212-11.839-15.163-35.903-21.375-51.67-6.014-15.72-16.106-18.087-30.47-22.365l-5.624-17.109c8.207-5.448 16.434-.05 23.906 6.318-2.507-36.622-101.18-34.064-109.53-56.05 12.625 3.442 19.756-5.229 16.844-13.387-3.494-10.098-15.67-15.973-26.156-14.232-37.27-19.72-77.67-29.16-118.94-35.63 15.89-18.68 6.16-28.547-19.44-30.964l-40.094-1.157-7-.219-6.969.219z' fill='%23dca842' stroke-width='3.001'/%3E%3Cg fill='none' stroke-width='3'%3E%3Cpath d='M365.36 93.093c38.572.12 30.016 46.144-5 48.25-43.149 5.035-96.201 3.62-125 15.5m-99 61.247c33.314-9.378 69.202-1.792 91-11.75s26.49-42.896 3-47.25'/%3E%3Cpath d='M349.11 123.59c7.68-1.77 15.889-2.044 19.979-5.77 4.09-3.727 5.313-10.405-4.48-11.23m-142.989 80.5c7.161-12.05 4.837-20.454-4.518-14.67M467.6 93.093c-38.572.12-30.016 46.144 5 48.25 43.149 5.035 96.201 3.62 125 15.5m99 61.247c-33.314-9.378-69.202-1.792-91-11.75s-26.49-42.896-3-47.25'/%3E%3Cpath d='M483.85 123.59c-7.68-1.77-15.889-2.044-19.979-5.77-4.09-3.727-5.312-10.405 4.48-11.23m142.979 80.5c-7.161-12.05-4.837-20.454 4.518-14.67M219.23 742.45c61.736 43.665 70.667 100.43 134.54 103.15'/%3E%3Cpath d='M354.55 854.5c-37.662 8.11-62.318-12.363-92.023-56.818-15.15-22.4-54.94-53.9-122.89-96.38-106.78-66.66-138.42-182.91-103.67-246.66 8.543-15.676 30.48-21.857 43.099-18.346 32.811 8.852 87.947 0 88.141-53.159.194-29.917-24.268-64.879-55.912-64.879-19.224 0-29.511 6.38-34.556 13.154'/%3E%3Cpath d='M349.89 831.9c0-2.918 2.52-5.984 6.212-5.984 3.688 0 6.988 3.264 6.988 7.32 0 8.9-5.05 13.697-15.725 11.57-8.737-1.73-12.619-11.176-8.93-20.67 3.687-9.643 16.111-15.626 29.505-9.643 13.4 6.182 11.843 26.654 7.187 38.275-2.719 6.725-8.156 12.363-14.756 16.022M613.72 742.45c-61.73 43.66-70.66 100.43-134.73 103.15'/%3E%3Cpath d='M478.41 854.5c37.662 8.11 62.318-12.363 92.018-56.818 14.949-22.401 54.942-53.901 122.89-96.379 106.77-66.659 138.42-182.92 103.67-246.66-8.538-15.676-30.475-21.857-43.094-18.346-32.811 8.852-87.947 0-88.141-53.159-.194-29.917 24.268-64.879 55.911-64.879 19.219 0 29.511 6.38 34.556 13.154'/%3E%3Cpath d='M495.88 830.52c0-26.456-44.843-34.764-79.205-34.764-34.168 0-79.205 8.308-79.205 34.764'/%3E%3Cpath d='M483.07 831.9c0-2.918-2.52-5.984-6.212-5.984-3.688 0-6.988 3.264-6.988 7.32 0 8.9 5.05 13.697 15.725 11.57 8.737-1.73 12.619-11.176 8.93-20.67-3.687-9.643-16.111-15.626-29.505-9.643-13.4 6.182-11.843 26.654-7.187 38.275 2.719 6.725 8.156 12.363 14.756 16.022'/%3E%3Cpath d='M460.16 857.17c-18.056 0-17.474 19.44-43.681 19.44-26.012 0-25.431-19.44-43.487-19.44'/%3E%3C/g%3E%3C/g%3E%3Cg stroke='%23000' stroke-width='3'%3E%3Cpath d='M416.48 828.14c-12.812 0-12.812 19.035 0 19.035s13.006-19.035 0-19.035' fill='url(%23b)'/%3E%3Cpath d='M439.58 831.66c-7.957 0-7.957 11.828 0 11.828 7.962 0 8.156-11.828 0-11.828' fill='url(%23c)'/%3E%3Cpath d='M422.5 860.99c0-8.002-11.843-8.002-11.843 0 0 7.952 11.843 7.952 11.843 0' fill='url(%23d)'/%3E%3Cpath d='M393.38 843.89c7.957 0 7.957-11.878 0-11.878-7.962 0-8.156 11.878 0 11.878' fill='url(%23e)'/%3E%3Cpath d='M410.46 814.57c0 7.952 11.843 7.952 11.843 0s-11.843-7.952-11.843 0' fill='url(%23f)'/%3E%3C/g%3E%3Cg id='ap' stroke='%23000'%3E%3Cpath d='M154.052 272.66c2.176.121 4.391.67 6.438 1.531 3.615 1.523 6.784 4.129 7.906 7.75.007.023.024.04.031.063 31.912 88.55 14.845 126.29-13.5 183.59-40.958 82.506-11.105 205.42 80.375 259.16 44.974 26.295 79.656 35.262 106.22 41.906 13.281 3.322 24.558 6.07 34.094 10.156 9.2 3.94 18.697 11 24.695 19.174-9.19.76-24.19 3.281-31.554 5.445-10.704-13.603-37.624-26.11-65.484-35.588-27.86-9.478-56.925-16.224-72.688-19.344h-.031c-51.284-14.874-99.1-48.249-135.12-90.656-38.135-44.889-57.625-106.35-50.094-167.97 1.687-14.102 7.292-22.719 15.28-27.406 7.99-4.687 18.097-5.486 28.813-4.78 19.477 1.123 38.56-4.195 56-14.939 22.488-13.845 31.704-38.325 31.344-64.906-.36-26.58-10.401-55.133-26.312-76.406-5.686-7.658-7.962-13.4-7.844-17.844.119-4.444 3.002-7.378 6.531-8.406a13.699 13.699 0 012.75-.5 16.09 16.09 0 012.156-.031z' fill='%23825123' stroke-width='3'/%3E%3Cpath d='M760.57 462.8c15.337 0 15.337 22.911 0 22.911s-15.531-22.911 0-22.911' fill='url(%23g)' transform='matrix(-1 0 0 1 833.412 0)'/%3E%3Cpath d='M731.84 461.38c15.337 0 15.337 22.911 0 22.911s-15.531-22.911 0-22.911' fill='url(%23h)' transform='matrix(-1 0 0 1 833.412 0)'/%3E%3Cpath d='M703.5 462.8c15.337 0 15.337 22.911 0 22.911s-15.531-22.911 0-22.911' fill='url(%23i)' transform='matrix(-1 0 0 1 833.412 0)'/%3E%3Cpath d='M771.06 488.24c15.337 0 15.337 22.862 0 22.862s-15.531-22.862 0-22.862' fill='url(%23j)' transform='matrix(-1 0 0 1 833.412 0)'/%3E%3Cpath d='M742.71 488.24c15.337 0 15.337 22.862 0 22.862s-15.531-22.862 0-22.862' fill='url(%23k)' transform='matrix(-1 0 0 1 833.412 0)'/%3E%3Cpath d='M714.17 488.24c15.337 0 15.337 22.862 0 22.862s-15.531-22.862 0-22.862' fill='url(%23l)' transform='matrix(-1 0 0 1 833.412 0)'/%3E%3Cpath d='M772.22 514.84c15.337 0 15.337 22.911 0 22.911s-15.531-22.911 0-22.911' fill='url(%23m)' transform='matrix(-1 0 0 1 833.412 0)'/%3E%3Cpath d='M745.43 513.84c15.337 0 15.337 22.911 0 22.911s-15.531-22.911 0-22.911' fill='url(%23n)' transform='matrix(-1 0 0 1 833.412 0)'/%3E%3Cpath d='M716.89 513.84c15.337 0 15.337 22.911 0 22.911s-15.531-22.911 0-22.911' fill='url(%23o)' transform='matrix(-1 0 0 1 833.412 0)'/%3E%3Cpath d='M768.14 542.02c14.368 0 14.368 21.52 0 21.52-14.557 0-14.751-21.52 0-21.52' fill='url(%23p)' transform='matrix(-1 0 0 1 833.412 0)'/%3E%3Cpath d='M741.35 542.02c14.363 0 14.363 21.52 0 21.52-14.562 0-14.562-21.52 0-21.52' fill='url(%23q)' transform='matrix(-1 0 0 1 833.412 0)'/%3E%3Cpath d='M714.37 542.02c14.368 0 14.368 21.52 0 21.52-14.562 0-14.756-21.52 0-21.52' fill='url(%23r)' transform='matrix(-1 0 0 1 833.412 0)'/%3E%3Cpath d='M762.43 570.11c13.782.547 12.812 21.172-.97 20.575-13.786-.596-13.01-21.371.97-20.575' fill='url(%23s)' transform='matrix(-1 0 0 1 833.412 0)'/%3E%3Cpath d='M738.05 567.22c13.782.596 12.812 21.172-.974 20.575-13.782-.547-13.006-21.122.974-20.575' fill='url(%23t)' transform='matrix(-1 0 0 1 833.412 0)'/%3E%3Cpath d='M712.23 566.07c13.787.596 12.817 21.172-.97 20.575-13.781-.596-13.005-21.371.97-20.575' fill='url(%23u)' transform='matrix(-1 0 0 1 833.412 0)'/%3E%3Cpath d='M752.61 594.2c13.205.994 11.843 20.575-1.357 19.631-13.2-.795-12.037-20.575 1.357-19.631' fill='url(%23v)' transform='matrix(-1 0 0 1 833.412 0)'/%3E%3Cpath d='M730.29 591.12c12.619.745 11.262 19.581-1.163 18.836-12.619-.795-11.456-19.631 1.163-18.836' fill='url(%23w)' transform='matrix(-1 0 0 1 833.412 0)'/%3E%3Cpath d='M706.61 589.93c10.094.596 9.12 15.953-.974 15.158-10.094-.596-9.319-15.705.974-15.158' fill='url(%23x)' transform='matrix(-1 0 0 1 833.412 0)'/%3E%3Cpath d='M742.52 615.97c12.619.745 11.262 19.581-1.163 18.836-12.619-.795-11.456-19.631 1.163-18.836' fill='url(%23y)' transform='matrix(-1 0 0 1 833.412 0)'/%3E%3Cpath d='M720.97 610.9c10.487.795 9.319 16.5-.97 15.755-10.485-.795-9.512-16.5.97-15.755' fill='url(%23z)' transform='matrix(-1 0 0 1 833.412 0)'/%3E%3Cpath d='M700.97 608.22c8.737.348 7.763 13.568-.775 12.971-8.737-.398-7.962-13.568.775-12.971' fill='url(%23A)' transform='matrix(-1 0 0 1 833.412 0)'/%3E%3Cpath d='M733.59 635.55c11.456 2.535 7.574 19.83-3.881 17.096-11.456-2.535-7.57-19.581 3.881-17.096' fill='url(%23B)' transform='matrix(-1 0 0 1 833.412 0)'/%3E%3Cpath d='M714.56 628c9.512 2.137 6.212 16.5-3.106 14.164-9.513-2.137-6.406-16.5 3.106-14.164' fill='url(%23C)' transform='matrix(-1 0 0 1 833.412 0)'/%3E%3Cpath d='M696.51 622.58c7.962 1.74 5.243 13.767-2.719 11.828-7.956-1.74-5.238-13.767 2.719-11.828' fill='url(%23D)' transform='matrix(-1 0 0 1 833.412 0)'/%3E%3Cpath d='M721.16 653.24c10.099 3.479 4.662 18.836-5.437 15.158-10.094-3.529-4.85-18.836 5.437-15.158' fill='url(%23E)' transform='matrix(-1 0 0 1 833.412 0)'/%3E%3Cpath d='M704.47 644.1c8.543 2.932 3.881 15.755-4.468 12.624-8.538-2.883-4.075-15.705 4.468-12.624' fill='url(%23F)' transform='matrix(-1 0 0 1 833.412 0)'/%3E%3Cpath d='M688.55 637.34c6.988 2.286 3.3 12.971-3.688 10.437-6.992-2.485-3.3-13.17 3.688-10.437' fill='url(%23G)' transform='matrix(-1 0 0 1 833.412 0)'/%3E%3Cpath d='M710.49 668.2c8.93 4.075 2.719 17.444-6.212 13.17-8.931-3.877-2.719-17.246 6.212-13.17' fill='url(%23H)' transform='matrix(-1 0 0 1 833.412 0)'/%3E%3Cpath d='M696.12 658.46c7.38 3.33 2.137 14.562-5.045 11.083-7.38-3.28-2.33-14.562 5.045-11.083' fill='url(%23I)' transform='matrix(-1 0 0 1 833.412 0)'/%3E%3Cpath d='M682.34 650.91c6.212 2.932 1.744 12.027-4.274 9.294-6.212-2.883-1.938-12.226 4.274-9.294' fill='url(%23J)' transform='matrix(-1 0 0 1 833.412 0)'/%3E%3Cpath d='M697.09 680.63c7.38 3.678 1.556 14.91-5.626 11.033-7.38-3.678-1.75-14.91 5.626-11.033' fill='url(%23K)' transform='matrix(-1 0 0 1 833.412 0)'/%3E%3Cpath d='M685.25 671.88c6.212 3.081 1.357 12.425-4.662 9.095-6.212-3.081-1.357-12.425 4.662-9.095' fill='url(%23L)' transform='matrix(-1 0 0 1 833.412 0)'/%3E%3Cpath d='M673.79 664.87c5.05 2.733.97 10.288-3.881 7.604-5.05-2.535-1.168-10.486 3.881-7.604' fill='url(%23M)' transform='matrix(-1 0 0 1 833.412 0)'/%3E%3Cpath d='M685.83 691.46c6.406 4.075 0 13.816-6.212 9.542-6.407-4.075-.194-13.816 6.212-9.542' fill='url(%23N)' transform='matrix(-1 0 0 1 833.412 0)'/%3E%3Cpath d='M675.93 682.57c5.238 3.479 0 11.431-5.243 7.952-5.243-3.479 0-11.68 5.243-7.952' fill='url(%23O)' transform='matrix(-1 0 0 1 833.412 0)'/%3E%3Cpath d='M666.03 674.96c4.468 2.932 0 9.542-4.27 6.61-4.462-2.882 0-9.492 4.27-6.61' fill='url(%23P)' transform='matrix(-1 0 0 1 833.412 0)'/%3E%3Cpath d='M674.73 700.43c6.406 4.274 0 13.767-6.212 9.492-6.407-4.075-.194-13.767 6.212-9.492' fill='url(%23Q)' transform='matrix(-1 0 0 1 833.412 0)'/%3E%3Cpath d='M664.83 691.66c5.238 3.529 0 11.48-5.243 7.952-5.243-3.479 0-11.431 5.243-7.952' fill='url(%23R)' transform='matrix(-1 0 0 1 833.412 0)'/%3E%3Cpath d='M656.71 684.11c4.463 2.932 0 9.492-4.274 6.61-4.463-2.932 0-9.741 4.274-6.61' fill='url(%23S)' transform='matrix(-1 0 0 1 833.412 0)'/%3E%3Cpath d='M647.98 693.4c4.075 2.535 0 8.747-3.886 6.212-4.076-2.683 0-8.896 3.886-6.212' fill='url(%23T)' transform='matrix(-1 0 0 1 833.412 0)'/%3E%3Cpath d='M655.16 701.4c4.463 2.883 0 9.492-4.27 6.56-4.467-2.882 0-9.492 4.27-6.56' fill='url(%23U)' transform='matrix(-1 0 0 1 833.412 0)'/%3E%3Cpath d='M662.92 709.55c4.85 3.28 0 10.486-4.662 7.157-4.855-3.082 0-10.487 4.662-7.157' fill='url(%23V)' transform='matrix(-1 0 0 1 833.412 0)'/%3E%3Cpath d='M638.85 702.94c3.688 2.535 0 7.952-3.688 5.616-3.692-2.535 0-8.15 3.688-5.616' fill='url(%23W)' transform='matrix(-1 0 0 1 833.412 0)'/%3E%3Cpath d='M644.57 709.92c4.075 2.733 0 8.747-3.881 6.014-4.08-2.684 0-8.698 3.881-6.014' fill='url(%23X)' transform='matrix(-1 0 0 1 833.412 0)'/%3E%3Cpath d='M651.55 716.84c4.274 2.684 0 9.294-4.27 6.411-4.273-2.932 0-9.343 4.27-6.411' fill='url(%23Y)' transform='matrix(-1 0 0 1 833.412 0)'/%3E%3Cpath d='M630 709.28c3.3 2.137 0 7.405-3.3 5.07-3.3-2.138 0-7.356 3.3-5.07' fill='url(%23Z)' transform='matrix(-1 0 0 1 833.412 0)'/%3E%3Cpath d='M635.21 715.78c3.688 2.535 0 8.15-3.688 5.666-3.687-2.535 0-8.15 3.688-5.666' fill='url(%23aa)' transform='matrix(-1 0 0 1 833.412 0)'/%3E%3Cpath d='M641.53 723.19c3.881 2.535 0 8.747-3.881 5.815-3.882-2.535 0-8.747 3.881-5.815' fill='url(%23ab)' transform='matrix(-1 0 0 1 833.412 0)'/%3E%3Cpath d='M622.74 714.97c3.106 2.336-.393 7.008-3.499 4.672-2.912-2.336.393-7.008 3.499-4.672' fill='url(%23ac)' transform='matrix(-1 0 0 1 833.412 0)'/%3E%3Cpath d='M627.45 721.07c3.3 2.535-.388 7.554-3.688 5.02-3.3-2.485.388-7.555 3.688-5.02' fill='url(%23ad)' transform='matrix(-1 0 0 1 833.412 0)'/%3E%3Cpath d='M631.97 727.58c3.494 2.733-.388 8.35-4.075 5.467-3.494-2.733.387-8.35 4.075-5.467' fill='url(%23ae)' transform='matrix(-1 0 0 1 833.412 0)'/%3E%3Cpath d='M615.7 719.44c2.525 2.137-.775 6.063-3.3 3.727-2.52-2.335.78-6.013 3.3-3.727' fill='url(%23af)' transform='matrix(-1 0 0 1 833.412 0)'/%3E%3Cpath d='M619.58 725.92c2.525 2.286-.97 6.56-3.688 3.877-2.718-2.336.97-6.61 3.688-3.877' fill='url(%23ag)' transform='matrix(-1 0 0 1 833.412 0)'/%3E%3Cpath d='M623.18 732.05c2.912 2.733-.97 7.008-3.881 4.274-2.913-2.485.969-6.958 3.881-4.274' fill='url(%23ah)' transform='matrix(-1 0 0 1 833.412 0)'/%3E%3Cpath d='M608.34 723.22c2.33 2.137-.97 5.616-3.3 3.479-2.33-2.336.97-5.815 3.3-3.479' fill='url(%23ai)' transform='matrix(-1 0 0 1 833.412 0)'/%3E%3Cpath d='M611.02 729c2.525 2.535-.97 6.212-3.494 3.678-2.524-2.336.97-6.213 3.494-3.678' fill='url(%23aj)' transform='matrix(-1 0 0 1 833.412 0)'/%3E%3Cpath d='M614.9 735.44c2.719 2.733-1.163 6.809-3.881 4.075-2.719-2.534.974-6.808 3.881-4.075' fill='url(%23ak)' transform='matrix(-1 0 0 1 833.412 0)'/%3E%3Cpath d='M601.5 727.58c1.744 1.938-1.168 4.672-2.912 2.733-1.75-1.938.969-4.87 2.912-2.733' fill='url(%23al)' transform='matrix(-1 0 0 1 833.412 0)'/%3E%3Cpath d='M603.61 732.94c1.943 2.137-1.163 5.02-3.3 2.883-1.744-2.137 1.168-5.02 3.3-2.883' fill='url(%23am)' transform='matrix(-1 0 0 1 833.412 0)'/%3E%3Cpath d='M606.49 738.49c2.132 2.336-1.362 5.417-3.499 3.131-2.132-2.336 1.362-5.666 3.499-3.131' fill='url(%23an)' transform='matrix(-1 0 0 1 833.412 0)'/%3E%3Cpath d='M687.6 446.92c10.094 0 10.094 15.158 0 15.158s-10.288-15.158 0-15.158' fill='url(%23ao)' transform='matrix(-1 0 0 1 833.412 0)'/%3E%3C/g%3E%3Cuse height='500' transform='matrix(-1 0 0 1 832.957 0)' width='833.333' xlink:href='%23ap'/%3E%3Cpath d='M182.15 433.08c11.262-37.473 16.893-85.632.974-148.3 70.081-45.226 119.39-86.576 233.55-86.576 113.96 0 167.73 31.41 233.55 86.576-15.725 62.671-10.094 110.63.97 148.3h-469.42' fill='%2389c5e3' stroke='%23000'/%3E%3Cpath d='M235.5 341.84l-5.22 56.66c-.051.007-.105-.008-.156 0l-20.12-56.16 9.687 59.312c-.072.033-.147.06-.219.094l-22.47-29.65 13.5 35.25-16.5-11.5 10.031 18.812c-.09.129-.192.245-.28.375l-11.75-1.438 7.28 10.22a38.86 38.86 0 00-2.28 13.17c0 .213.06.411.063.624h77.625c.003-.213.062-.41.062-.625 0-4.637-.791-9.095-2.28-13.219l15.29-14.67-19.25 6.72c-.156-.24-.309-.483-.47-.719 2.958-3.633 31.908-39.25 30.72-39.25-1.229 0-36.6 30.34-37.844 31.406l-.188-.156 27.781-61.5-38.438 55.188c-.126-.05-.248-.108-.375-.156l11.32-58.28-20.25 56-5.25-56.5z' fill='%23fcdd09'/%3E%3Cpath d='M181.82 433.08c-6.212 20.774-13.975 38.467-20.769 53.576-17.668 39.809-21.356 132.4 43.874 197.85 96.873 96.863 170.65 57.85 207.73 110.63h7.57c37.08-52.78 110.85-13.767 207.73-110.63 65.23-65.454 61.735-158.04 43.873-197.85-6.6-14.959-14.562-32.801-20.774-53.576h-469.42' fill='%230f47af' stroke='%23000'/%3E%3Cpath d='M323.62 343.97c-1.122-5.432-13.795-4.388-12.875-13.125-8.429-1.344-6.858-16.406 8.875-15.375 1.657-2.99 20.674-9.835 18.375-.375 9.544-8.316 16.457-.702 11.125 3 3.682 3.687 5.54 12.114-5.75 11.375 4.32 7.685-5.712 7.399-12.375 5.25.164 2.911-.332 5.217-4.125 4.5-2.394 1.618-.582 3.704-.25 5.625zm174.6 5.93c.107-6.855-12.811-4.763-12.33-12.57-7.012-1.075-5.993-15.596 8.5-14.724-.808-4.194 19.513-9.577 17.596-.36 7.079-7.505 14.066-.489 9.78 2.874 3.526 3.53 7.806 9.601-4.632 10.894 5.013 4.86-5.47 7.085-11.851 5.028.157 2.788-1.693 3.746-5.326 3.06-2.292 1.55.818 4.796 1.136 6.636l-2.873-.838zm100.68 23.69c1.202-5.19-10.656-4.731-10.349-10.643-5.387-.814-4.605-11.809 6.53-11.149-.62-3.176 13.868-8.502 12.896-.772 5.439-5.683 11.432.13 8.139 2.675 2.71 2.674 5.998 7.27-3.559 8.249 3.852 3.68-4.203 5.365-9.105 3.807.12 2.11-.55 2.461-3.342 1.942-1.762 1.173 2.128 4.007 2.372 5.4l-3.582.49z' fill='%23fff'/%3E%3Cpath d='M-308.88 472.49c2.912-15.158 15.337-29.124 16.699-40.952 1.163-10.685 3.3-15.158 9.512-26.39 6.213-11.282 8.733-16.5 10.094-24.303 1.939-10.089 9.513-12.226 13.006-1.938 3.3 10.288 9.9 36.13 13.394 42.145 3.3 6.013 6.8 14.363 6.213 18.438-.582 4.075 4.468 5.616 7.38 8.548 2.913 2.733 3.3 12.226 11.843 20.377 8.538 8.15 18.051 13.965 26.012 18.04 7.182 16.153 12.037 40.605 10.87 68.536h-533.29c-.195-7.356 0-14.562.387-21.52 47.368-12.226 65.036-43.487 85.03-41.35 10.874-15.158 24.074-31.46 33.199-39.81 10.869-9.89 32.225-49.3 37.662-73.405 5.437-23.856 13.394-36.678 19.412-35.336 6.018 1.392 8.543 2.535 15.725 24.104 9.905 29.67 16.699 33.199 24.268 54.52 6.6 18.488 20.387 51.637 41.548 68.933 13.2-9.89 28.343-20.973 33.194-28.726 4.08-6.809 10.293-17.295 17.668-22.315 3.3-9.89 7.569-27.583 11.068-31.857 3.3-3.877 4.657-7.753 5.044-14.562.194-6.809 5.437-21.172 12.62-33.2 7.186-11.827 16.698-15.704 20.967 0 4.076 15.756 13.588 48.756 22.52 69.33 3.687 8.55 10.486 25.397 25.43 43.09l1.614 1.906c.303-.53.607-.926.911-2.304z' fill='%23509164' stroke='%23000' stroke-width='.999' transform='matrix(1.00186 0 0 1 867.911 0)'/%3E%3Cg fill='%23034418'%3E%3Cpath d='M497.202 528.38c-9.919-9.542-25.673-7.405-33.645-14.959-7.782-7.356-20.23-2.336-47.073-15.904-3.307-1.74-6.613-3.876-9.919-6.411-21.201-17.295-35.008-50.494-41.62-68.933-7.394-21.172-14.395-24.651-24.314-54.57-5.252-15.904-8.17-20.774-11.67-22.514 9.142 9.94 4.282 25.446 11.67 42.145 2.918 6.61-1.946 6.61-3.5 4.473-1.36-2.137-5.835-3.131-7.976-2.932 3.893 3.33 4.476 11.679 8.364 20.377 3.695 8.747-2.917 7.802 5.06 20.228 2.135 3.478 2.917 8.697-.195 10.834-3.306 1.938-5.641-6.014-10.506-3.28 1.364 3.13 7 8.746 10.7 12.026 3.694 3.33.194 5.07-2.724 3.529-3.112-1.59-7.2-3.131-9.336-4.87 0 2.534 3.112 5.417 7.389 9.293 4.476 3.728 1.558 6.411-8.753 6.411 1.558 2.336.976 8.151-3.695 8.946 6.418.398 11.283 12.226 19.255 13.021 7.782.547 8.56 6.014.976 7.356-7.588 1.342-22.954-10.884-30.537-18.836-1.947 2.733-6.03 3.876-8.948 2.336-.194 3.677.971 12.624 4.472 18.438-3.695-1.541-8.554-6.412-13.42-12.425-4.665-5.616-7.777 2.733-3.694 7.753 4.083 5.069 6.807 9.144.194 13.02-6.418 3.678-10.501 2.336-15.365-4.472-6.807 5.665-9.53 6.013-14.784 5.069 0 3.28-5.641 11.083-8.165 16.898-5.642 11.232 250.125 34.541 242.931 7.356'/%3E%3Cpath d='M681.164 530.1c-67.298-5.864-104.444-31.857-125.454-56.707-14.976-17.494-21.783-34.541-25.478-43.089-8.947-20.575-18.477-53.576-22.56-69.33-1.365-5.218-3.307-8.35-5.642-9.492-3.5-1.74-1.753 4.274.777 7.355 2.723 2.932 2.529 5.666-.971 3.529-3.5-1.939-5.253 1.938-1.947 6.759 3.112 4.671 7.976 10.139 8.947 15.357.976 5.069 1.365 9.492 3.889 12.027 2.335 2.534-6.418 3.13-10.113-2.883-.194 3.877.976 9.493 3.5 8.896 2.336-.397 3.113 1.74-.194 7.604-3.306 5.616-2.917 7.555-1.747 10.09 1.747 3.876 6.224-11.48 8.947-2.734 1.36 4.075 3.695 9.144 5.83 12.425 2.142 3.13 1.948 5.07-1.164 5.07s-5.836-7.804-6.224-1.194c-.194 6.412 4.864 8.549 10.113 8.151 5.058-.199 5.835 1.74 5.058 4.473-.582 2.733 1.554 5.417 4.472 4.87 2.723-.795 7.005 1.74 9.336 8.35 2.335 6.61-1.554 9.492-7.195 4.82-5.642-4.82-13.808-9.094-14.59-12.623-.582-3.082-2.917 1.391-.388 5.665 2.335 4.274 3.695 6.213 6.807 7.952 3.112 1.54-.194 7.952-5.442 3.877-5.06-3.877-7.394-2.933-8.948 1.54-2.53 7.207-10.113 5.467-7.782 9.344 2.335 3.876 1.364 10.089-2.137 11.63-3.699 1.54-7.976-.746-7.588-7.555-.97 1.342-4.665 1.939-7.583 1.144-.388 9.542-3.112 12.822-8.948 10.288-.194 2.137-.388 5.814-3.306 8.548 6.418-.945 7.778 3.479 8.36 6.212.394 2.734 1.365 2.336 5.06 2.734 3.5.198 7.976 4.82 1.363 3.677-6.617-.944-16.924 1.342-22.953-3.081 6.224 5.616 23.924 5.815 31.314 12.97 53.88 22.167 148.797 29.92 186.326 19.632.195-4.473-.388-14.761-.776-18.041'/%3E%3Cpath d='M603.028 372.77c1.554.745 3.112 2.883 4.472 6.212 3.306 10.288 9.918 36.082 13.424 42.095 3.306 6.014 6.806 14.363 6.224 18.438-.588 4.076 4.471 5.666 7.389 8.549 2.918 2.733 3.306 12.226 11.865 20.377 8.559 8.15 18.09 14.015 26.06 18.09 4.865 10.834 8.56 25.396 10.113 42.493-22.949-1.74-51.733-8.549-66.128-14.96.583-2.136.583-4.82-.194-8.895-.971-4.076-.194-7.207 4.083-11.083 4.282-3.877 2.918-10.487.587-14.164-2.335-3.48-2.14-5.616-.199-7.753 1.753-1.939 1.753-5.467-2.33-9.344-4.282-3.876-1.364-7.952.97-11.43 2.336-3.53 5.836-9.543 3.307-17.296-2.53-7.554-6.418 1.74-9.53-1.143-1.947-1.988-3.112-5.666-.971-8.747 2.136-2.932.777-8.548-1.753-12.822 5.642-1.54-3.888-18.041-5.447-25.048-1.553-7.008 1.753-10.486-1.942-13.22'/%3E%3C/g%3E%3Cpath d='M358.313 435.81c0 3.678-.97 8.946-1.946 10.685 2.335 3.678 5.447 11.232 5.058 13.568 3.112-2.882 9.142-.596 10.502 7.405 1.364 8.15 2.724 15.705 1.947 20.178 2.723 2.336 8.559 6.411 9.53 10.884.97 4.274 3.889 3.678 6.806 3.28 9.142-1.342 8.365 9.692 17.896 8.15 13.419-1.937 5.059 8.748 18.477 8.35 7.778-.397 18.477 1.143 23.925 8.747 6.024-8.15 11.278-5.069 16.725-2.932 5.447 1.938 12.253 1.392 6.224-2.882-6.224-4.473-18.478-5.07-23.925-3.728-5.447 1.392-13.613.398-19.255-4.622-5.447-5.07-14.976-9.343-20.812-9.542-5.836-.199-7.195-.547-11.666-7.157-4.282-6.41-11.283-5.665-14.784-6.013-3.306-.2-5.835-4.473-1.946-8.548 5.641-6.014-2.336-6.81.582-10.487 2.918-3.678 1.365-8.549-6.418-9.145-7.777-.596-4.86-3.082-3.694-8.548 2.723-12.971-14.784-10.834-13.42-17.047m305.562 69.284c.777-7.952-5.253-11.232-6.612-17.295-1.165-6.014-10.7-6.212-13.225-4.423.971 1.74 0 4.82-1.17 6.56-1.165 1.59-1.165 2.535 1.17 3.33 2.525.596 4.666 1.143 4.86 3.28.194 1.938 1.364.199 2.335-2.336.777-2.485 7.584 3.131 8.365 8.15.583 5.07 3.306 8.549 4.083 2.535m-31.314-8.351c1.165 2.932 5.447 7.008 7.777 7.008 2.335 0 5.836 1.74 6.418 4.472.394 2.336 2.335 5.616 4.865 6.014 2.53.398 1.165 2.336-1.947 2.137-3.306-.199-8.36-2.137-8.748-4.473 1.165 4.87-.394 7.008-3.506 3.48-2.917-3.28-4.47-7.953-8.36-8.549 2.918-.547 3.306-1.342 1.942-4.274-1.165-2.883-.194-10.636 1.559-5.815' fill='%23509164'/%3E%3Cpath d='M-716.69 545.89c6.382-3.131 16.23-1.938 19.904 1.342 1.93-3.678 5.025-6.411 10.828-5.417 4.644-5.07 8.511-7.604 11.22-5.07 2.708-5.02 11.799-6.212 14.894-3.08 3.288-5.07 9.863-7.406 14.309-4.673 5.803-7.604 16.052-10.288 22.241-6.41 5.417-4.076 11.606-3.28 14.314-.597 2.708 2.535 8.511-2.684 10.833 2.137 4.06-.944 11.794-1.143 13.344 3.13.965-2.335 4.446-3.726 6.382-1.937 0-8.946 6.382-15.755 15.28-13.618 4.253-6.412 11.606-9.095 15.087-6.81 3.674-3.677 11.215-1.142 14.502 3.33 7.16-.198 10.64 3.082 14.314 9.493 3.674 6.411 14.314 10.288 21.083 7.405 6.769-2.534 12.958-3.33 15.28-.198 4.06-3.678 8.511-2.734 11.215-.2 4.644 4.076 9.09-3.13 11.8-.397 4.257 4.473 8.124-4.075 15.665.398 7.353 4.473 21.855 11.232 33.075 11.232s20.117-13.767 27.272-4.076c7.155-4.82 17.988-7.156 25.53-3.08 4.45-4.076 14.7-5.418 18.76-1.542 4.06-6.212 11.798-9.94 18.373-7.802 3.674-6.362 18.374-7.356 22.821 1.59 3.679 0 9.477 3.28 9.477 7.356 3.679 0 9.482 2.335 9.482 6.61 4.06-.994 9.085 1.54 9.863 6.41 8.12-.596 14.7 2.734 18.374 9.493 2.708-2.336 1.158-8.35 7.347-9.492 6.19-.994 8.126.944 9.863 3.081 6.769-5.02 16.25-4.423 24.177 2.733 5.803-2.335 11.22-1.341 12.958 1.541 2.516-2.336 6.576-2.882 10.64-2.882.194 13.17-.97 27.533-3.871 42.294h-523.75c-2.709-14.363-3.867-28.726-3.674-41.946' fill='%23078930' stroke='%23000' stroke-width='.999' transform='matrix(1.00186 0 0 1 867.911 0)'/%3E%3Cpath d='M416.28 245.04l-5.243 16.898H393.18l14.557 10.486-5.437 16.898 14.174-10.487 14.368 10.487-5.438-16.898 14.363-10.089h-17.663l-5.437-16.898m-67.947 5.223l-2.525 17.494-17.469 2.733 15.92 7.952-2.72 17.444 12.426-12.624 15.725 8.002-8.156-15.755 12.62-12.425-17.47 2.733-8.155-15.755M282.72 267.16l.194 17.693-16.893 5.616 17.087 5.268v17.643l10.094-14.562 16.893 5.268-10.68-14.214 10.293-14.363-16.893 5.666-10.675-14.214M220.4 294.14l3.106 17.494-15.725 8.35 17.663 2.335 2.913 17.444 7.574-15.904 17.469 2.336-12.812-12.425 7.768-15.755-15.725 8.35-12.812-12.226M484.23 250.66l2.525 17.494 17.469 2.733-15.92 7.952 2.72 17.444-12.426-12.624-15.725 8.002 8.15-15.755L458.6 263.48l17.474 2.733 8.155-15.755m66.011 16.702l-.194 17.693 16.888 5.616-17.082 5.268v17.643l-10.094-14.562-16.893 5.268 10.68-14.214-10.293-14.363 16.7 5.666 10.674-14.214m61.934 27.179l-3.106 17.494 15.725 8.35-17.668 2.335-2.908 17.444-7.574-15.904-17.474 2.336 12.817-12.425-7.768-15.755 15.725 8.35 12.812-12.226' fill='%23fff'/%3E%3Cpath d='M387.186 672.52l1.938-129.86c0-6.212 1.168-7.206 1.362-.398l.388 131.65' fill='%23865800'/%3E%3Cpath d='M387.186 672.52l1.938-129.86c0-6.212 1.168-7.206 1.362-.398l.388 131.65' fill='%23704d25' stroke='%23000' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M390.676 542.46c4.463-3.877 14.75 4.87 21.157 1.193-3.882 12.574-19.412 2.684-21.157 7.355v-8.548' fill='%23fff'/%3E%3Cpath d='M390.676 542.46c4.463-3.877 14.75 4.87 21.157 1.193-3.882 12.574-19.412 2.684-21.157 7.355v-8.548' fill='none' stroke='%23000' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M431.056 672.72l1.938-129.66c0-6.212 1.168-7.405 1.362-.199l.388 131.4' fill='%23865800'/%3E%3Cpath d='M431.056 672.72l1.938-129.66c0-6.212 1.168-7.405 1.362-.199l.388 131.4' fill='%23704d25' stroke='%23000' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M434.746 542.86c4.463-3.877 14.756 4.87 21.162 1.143-4.08 12.624-19.417 2.733-21.162 7.405v-8.548' fill='%23fff'/%3E%3Cpath d='M434.746 542.86c4.463-3.877 14.756 4.87 21.162 1.143-4.08 12.624-19.417 2.733-21.162 7.405v-8.548' fill='none' stroke='%23000' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M472.596 679.93l1.943-129.91c0-6.212 1.163-7.157 1.357-.15l.388 131.4' fill='%23865800'/%3E%3Cpath d='M472.596 679.93l1.943-129.91c0-6.212 1.163-7.157 1.357-.15l.388 131.4' fill='%23704d25' stroke='%23000' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M476.096 550.02c4.468-3.877 14.756 4.87 21.162.994-4.075 12.624-19.412 2.733-21.162 7.355v-8.498' fill='%23fff'/%3E%3Cpath d='M476.096 550.02c4.468-3.877 14.756 4.87 21.162.994-4.075 12.624-19.412 2.733-21.162 7.355v-8.498.149z' fill='none' stroke='%23000' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M487.546 694.84c-4.468 0-10.094-2.087-11.65-5.616-3.3 3.131-17.081 4.87-22.518.199-3.688 3.13-15.143 5.268-20.968 1.54-4.657 4.076-18.443 3.728-25.625-.546-2.912 3.081-11.262 5.417-15.725 5.815-6.406-9.145-23.687-23.706-34.556-29.124-12.231-6.014-36.693-17.693-49.7-23.31-7.573-3.28-14.561-8.945-.193-2.733 15.337 6.61 39.993 16.5 56.687 23.905 23.88 10.487 119.2 8.946 134.92 7.555 8.156-.547 19.025-6.76 26.6-11.431 5.824-3.53 6.018-1.392.387 1.54-6.213 3.28-13.006 5.815-17.862 12.624-6.6 9.145-15.725 13.22-19.22 19.234' fill='%23704d25'/%3E%3Cpath d='M487.546 694.84c-4.468 0-10.094-2.087-11.65-5.616-3.3 3.131-17.081 4.87-22.518.199-3.688 3.13-15.143 5.268-20.968 1.54-4.657 4.076-18.443 3.728-25.625-.546-2.912 3.081-11.262 5.417-15.725 5.815-6.406-9.145-23.687-23.706-34.556-29.124-12.231-6.014-36.693-17.693-49.7-23.31-7.573-3.28-14.561-8.945-.193-2.733 15.337 6.61 39.993 16.5 56.687 23.905 23.88 10.487 119.2 8.946 134.92 7.555 8.156-.547 19.025-6.76 26.6-11.431 5.824-3.53 6.018-1.392.387 1.54-6.213 3.28-13.006 5.815-17.862 12.624-6.6 9.145-15.725 13.22-19.22 19.234l-.58.348z' fill='%23704d25' stroke='%23000' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M496.476 572.18l-30.868-3.33c-5.437 9.145-6.212 20.575-3.3 28.577 9.9-9.343 27.762-4.473 36.693.348-2.912-8.15-7.38-19.184-2.331-25.396' fill='%23fff'/%3E%3Cpath d='M496.476 572.18l-30.868-3.33c-5.437 9.145-6.212 20.575-3.3 28.577 9.9-9.343 27.762-4.473 36.693.348-2.912-8.15-7.38-19.184-2.331-25.396l-.194-.199z' fill='none' stroke='%23000' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M498.806 597.58c-9.12.199-30.863-.348-37.662-.348-7.375 9.493-3.3 23.856-1.55 29.322 8.15-13.02 33.973-6.063 43.873 3.28-5.05-9.542-8.93-17.693-4.463-32.404' fill='%23fff'/%3E%3Cpath d='M498.806 597.58c-9.12.199-30.863-.348-37.662-.348-7.375 9.493-3.3 23.856-1.55 29.322 8.15-13.02 33.973-6.063 43.873 3.28-5.05-9.542-8.93-17.693-4.463-32.404l-.198.15z' fill='none' stroke='%23000' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M503.276 630.23c-8.931-1.59-37.662-3.529-43.487-5.07-4.662 9.692-8.543 22.316-10.482 34.393 13.975-15.357 46.399-4.076 53.193 10.834-6.794-12.822-13.593-32.205.97-40.157' fill='%23fff'/%3E%3Cpath d='M503.276 630.23c-8.931-1.59-37.662-3.529-43.487-5.07-4.662 9.692-8.543 22.316-10.482 34.393 13.975-15.357 46.399-4.076 53.193 10.834-6.794-12.822-13.593-32.205.97-40.157h-.195z' fill='none' stroke='%23000' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M464.836 562.84l-40.773-5.417c-5.82 6.809-10.094 18.836-9.512 32.8 8.543-8.15 39.799-4.87 47.76 6.81-2.718-12.624-6.212-28.527 2.719-34.392' fill='%23fff'/%3E%3Cpath d='M464.836 562.84l-40.773-5.417c-5.82 6.809-10.094 18.836-9.512 32.8 8.543-8.15 39.799-4.87 47.76 6.81-2.718-12.624-6.212-28.527 2.719-34.392l-.194.198z' fill='none' stroke='%23000' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M461.726 598.18l-45.236-6.014c-7.182 9.145-6.794 22.116-5.05 35.932 10.294-8.548 43.875-3.876 51.837 7.555-4.851-16.7-8.931-26.59-1.357-37.473' fill='%23fff'/%3E%3Cpath d='M461.726 598.18l-45.236-6.014c-7.182 9.145-6.794 22.116-5.05 35.932 10.294-8.548 43.875-3.876 51.837 7.555-4.851-16.7-8.931-26.59-1.357-37.473h-.194z' fill='none' stroke='%23000' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M463.086 635.65l-46.011-4.672c-7.182 8.946-12.037 18.09-10.482 31.46 7.181-11.828 37.662-3.28 50.668 9.89-7.763-10.288-8.543-25.048 5.825-36.678' fill='%23fff'/%3E%3Cpath d='M463.086 635.65l-46.011-4.672c-7.182 8.946-12.037 18.09-10.482 31.46 7.181-11.828 37.662-3.28 50.668 9.89-7.763-10.288-8.543-25.048 5.825-36.678z' fill='none' stroke='%23000' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M388.146 562.84c-5.05 3.877-12.812 17.295-13.98 20.973 8.543-3.479 26.599-4.473 37.86 3.877-3.3-6.412-4.467-17.644-1.555-22.316-4.463-1.938-16.306-2.932-22.13-2.335' fill='%23fff'/%3E%3Cpath d='M388.146 562.84c-5.05 3.877-12.812 17.295-13.98 20.973 8.543-3.479 26.599-4.473 37.86 3.877-3.3-6.412-4.467-17.644-1.555-22.316-4.463-1.938-16.306-2.932-22.13-2.335l-.194-.2z' fill='none' stroke='%23000' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M369.316 590.02c11.843-.199 36.106 2.733 46.593 5.616-6.212 9.343-5.437 25.247-2.912 35.137-16.112-15.904-42.711-15.506-58.436-10.834 2.912-7.206 10.094-22.166 14.562-30.118' fill='%23fff'/%3E%3Cpath d='M369.316 590.02c11.843-.199 36.106 2.733 46.593 5.616-6.212 9.343-5.437 25.247-2.912 35.137-16.112-15.904-42.711-15.506-58.436-10.834 2.912-7.206 10.094-22.166 14.562-30.118l.193.199z' fill='none' stroke='%23000' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M416.296 634.31c-11.456.398-40.768-4.672-54.167-11.282-4.657 12.624-6.794 33.597-7.182 41.151 13.006-17.444 44.848-7.753 54.942 10.089-.969-9.493-4.467-32.801 6.407-40.157' fill='%23fff'/%3E%3Cpath d='M416.296 634.31c-11.456.398-40.768-4.672-54.167-11.282-4.657 12.624-6.794 33.597-7.182 41.151 13.006-17.444 44.848-7.753 54.942 10.089-.969-9.493-4.467-32.801 6.407-40.157v.199z' fill='none' stroke='%23000' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M388.146 562.84c-32.23 19.432-56.687 58.645-65.812 85.83 9.125-.199 20.575 2.733 24.656 10.884 9.512-39.063 22.906-75.145 41.156-96.913' fill='%23fff'/%3E%3Cpath d='M388.146 562.84c-32.23 19.432-56.687 58.645-65.812 85.83 9.125-.199 20.575 2.733 24.656 10.884 9.512-39.063 22.906-75.145 41.156-96.913v.199zm.97-18.84c-26.4 26.589-63.868 74.002-77.461 99.796m184.821-71.616c7.181 34.938 8.93 81.904 6.019 99.199' fill='none' stroke='%23000' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M534.686 635.28c-8.185 4.083-23.7-7.338-31.024-2.152v-4.524c7.11-4.966 22.624 6.455 31.024 2.152v4.745' fill='%2300009e'/%3E%3Cpath d='M534.686 635.28c-8.185 4.083-23.7-7.338-31.024-2.152v-4.524c7.11-4.966 22.624 6.455 31.024 2.152v4.745-.22z' fill='%23002b7f'/%3E%3Cpath d='M534.686 640.02c-8.185 4.083-23.7-7.338-31.024-2.373v-4.745c7.11-4.966 22.624 6.456 31.024 2.152v4.745' fill='%23fff'/%3E%3Cpath d='M534.686 640.02c-8.185 4.083-23.7-7.338-31.024-2.373v-4.745c7.11-4.966 22.624 6.456 31.024 2.152v4.745z' fill='none'/%3E%3Cpath d='M534.686 644.77c-8.185 4.304-23.7-7.118-31.024-2.152v-4.745c7.11-4.966 22.624 6.456 31.024 2.373v4.524' fill='%23ff0016'/%3E%3Cpath d='M534.686 644.77c-8.185 4.304-23.7-7.118-31.024-2.152v-4.745c7.11-4.966 22.624 6.456 31.024 2.373v4.524' fill='%23ce1126'/%3E%3Cpath d='M534.686 649.51c-8.185 4.304-23.7-7.118-31.024-2.152v-4.745c7.11-4.745 22.624 6.456 31.024 2.152z' fill='%23fff'/%3E%3Cpath d='M534.686 649.51c-8.185 4.304-23.7-7.118-31.024-2.152v-4.745c7.11-4.745 22.624 6.456 31.024 2.152z' fill='none'/%3E%3Cpath d='M534.686 654.04c-8.185 4.304-23.7-7.118-31.024-2.152v-4.745c7.11-4.966 22.624 6.456 31.024 2.152v4.524' fill='%2300009e'/%3E%3Cpath d='M534.686 654.04c-8.185 4.304-23.7-7.118-31.024-2.152v-4.745c7.11-4.966 22.624 6.456 31.024 2.152v4.744z' fill='%23002b7f'/%3E%3Cg stroke-width='1.832'%3E%3Cpath d='M404.084 440.136l.688-46.081c0-2.205.414-2.558.483-.142l.137 46.717' fill='%23865800'/%3E%3Cpath d='M404.084 440.136l.688-46.081c0-2.205.414-2.558.483-.142l.137 46.717' fill='%23704d25' stroke='%23000' stroke-linecap='round' stroke-linejoin='round' stroke-width='.65'/%3E%3Cpath d='M405.322 393.984c1.584-1.376 5.235 1.728 7.508.423-1.377 4.462-6.888.952-7.508 2.61v-3.033' fill='%23fff'/%3E%3Cpath d='M405.322 393.984c1.584-1.376 5.235 1.728 7.508.423-1.377 4.462-6.888.952-7.508 2.61v-3.033' fill='none' stroke='%23000' stroke-linecap='round' stroke-linejoin='round' stroke-width='.65'/%3E%3Cpath d='M419.651 440.207l.688-46.01c0-2.205.415-2.628.483-.071l.138 46.628' fill='%23865800'/%3E%3Cpath d='M419.651 440.207l.688-46.01c0-2.205.415-2.628.483-.071l.138 46.628' fill='%23704d25' stroke='%23000' stroke-linecap='round' stroke-linejoin='round' stroke-width='.65'/%3E%3Cpath d='M420.96 394.126c1.584-1.376 5.237 1.728 7.51.405-1.448 4.48-6.89.97-7.51 2.628v-3.033' fill='%23fff'/%3E%3Cpath d='M420.96 394.126c1.584-1.376 5.237 1.728 7.51.405-1.448 4.48-6.89.97-7.51 2.628v-3.033' fill='none' stroke='%23000' stroke-linecap='round' stroke-linejoin='round' stroke-width='.65'/%3E%3Cpath d='M434.392 442.765l.69-46.099c0-2.204.412-2.54.481-.053l.138 46.628' fill='%23865800'/%3E%3Cpath d='M434.392 442.765l.69-46.099c0-2.204.412-2.54.481-.053l.138 46.628' fill='%23704d25' stroke='%23000' stroke-linecap='round' stroke-linejoin='round' stroke-width='.65'/%3E%3Cpath d='M435.634 396.666c1.585-1.375 5.236 1.729 7.51.353-1.447 4.48-6.889.97-7.51 2.61v-3.016' fill='%23fff'/%3E%3Cpath d='M435.634 396.666c1.585-1.375 5.236 1.729 7.51.353-1.447 4.48-6.889.97-7.51 2.61v-3.016.053z' fill='none' stroke='%23000' stroke-linecap='round' stroke-linejoin='round' stroke-width='.65'/%3E%3Cpath d='M439.697 448.056c-1.585 0-3.582-.74-4.134-1.993-1.17 1.112-6.061 1.729-7.99.071-1.31 1.111-5.374 1.87-7.441.547-1.653 1.446-6.545 1.322-9.093-.194-1.034 1.093-3.997 1.922-5.58 2.063-2.274-3.245-8.406-8.412-12.263-10.335-4.34-2.134-13.02-6.278-17.636-8.27-2.687-1.165-5.167-3.175-.069-.97 5.443 2.345 14.192 5.854 20.116 8.482 8.474 3.721 42.299 3.174 47.877 2.68 2.894-.193 6.751-2.398 9.439-4.056 2.067-1.252 2.136-.494.137.547-2.204 1.164-4.615 2.063-6.338 4.48-2.342 3.245-5.58 4.69-6.82 6.825' fill='%23704d25'/%3E%3Cpath d='M439.697 448.056c-1.585 0-3.582-.74-4.134-1.993-1.17 1.112-6.061 1.729-7.99.071-1.31 1.111-5.374 1.87-7.441.547-1.653 1.446-6.545 1.322-9.093-.194-1.034 1.093-3.997 1.922-5.58 2.063-2.274-3.245-8.406-8.412-12.263-10.335-4.34-2.134-13.02-6.278-17.636-8.27-2.687-1.165-5.167-3.175-.069-.97 5.443 2.345 14.192 5.854 20.116 8.482 8.474 3.721 42.299 3.174 47.877 2.68 2.894-.193 6.751-2.398 9.439-4.056 2.067-1.252 2.136-.494.137.547-2.204 1.164-4.615 2.063-6.338 4.48-2.342 3.245-5.58 4.69-6.82 6.825l-.206.123z' fill='%23704d25' stroke='%23000' stroke-linecap='round' stroke-linejoin='round' stroke-width='.65'/%3E%3Cpath d='M442.866 404.53l-10.954-1.182c-1.93 3.245-2.204 7.301-1.17 10.141 3.512-3.316 9.85-1.587 13.02.123-1.034-2.892-2.619-6.807-.827-9.011' fill='%23fff'/%3E%3Cpath d='M442.866 404.53l-10.954-1.182c-1.93 3.245-2.204 7.301-1.17 10.141 3.512-3.316 9.85-1.587 13.02.123-1.034-2.892-2.619-6.807-.827-9.011l-.069-.071z' fill='none' stroke='%23000' stroke-linecap='round' stroke-linejoin='round' stroke-width='.65'/%3E%3Cpath d='M443.693 413.543c-3.236.07-10.952-.123-13.365-.123-2.617 3.368-1.17 8.465-.55 10.405 2.892-4.62 12.056-2.152 15.569 1.164-1.792-3.386-3.17-6.279-1.584-11.499' fill='%23fff'/%3E%3Cpath d='M443.693 413.543c-3.236.07-10.952-.123-13.365-.123-2.617 3.368-1.17 8.465-.55 10.405 2.892-4.62 12.056-2.152 15.569 1.164-1.792-3.386-3.17-6.279-1.584-11.499l-.07.053z' fill='none' stroke='%23000' stroke-linecap='round' stroke-linejoin='round' stroke-width='.65'/%3E%3Cpath d='M445.279 425.13c-3.17-.565-13.365-1.253-15.432-1.8-1.654 3.44-3.031 7.919-3.72 12.204 4.96-5.449 16.466-1.446 18.877 3.845-2.411-4.55-4.824-11.428.343-14.25' fill='%23fff'/%3E%3Cpath d='M445.279 425.13c-3.17-.565-13.365-1.253-15.432-1.8-1.654 3.44-3.031 7.919-3.72 12.204 4.96-5.449 16.466-1.446 18.877 3.845-2.411-4.55-4.824-11.428.343-14.25h-.068z' fill='none' stroke='%23000' stroke-linecap='round' stroke-linejoin='round' stroke-width='.65'/%3E%3Cpath d='M431.638 401.216l-14.468-1.923c-2.065 2.416-3.582 6.684-3.376 11.64 3.032-2.892 14.123-1.729 16.949 2.416-.965-4.48-2.205-10.123.964-12.204' fill='%23fff'/%3E%3Cpath d='M431.638 401.216l-14.468-1.923c-2.065 2.416-3.582 6.684-3.376 11.64 3.032-2.892 14.123-1.729 16.949 2.416-.965-4.48-2.205-10.123.964-12.204l-.069.07z' fill='none' stroke='%23000' stroke-linecap='round' stroke-linejoin='round' stroke-width='.65'/%3E%3Cpath d='M430.535 413.756l-16.052-2.134c-2.549 3.245-2.411 7.848-1.792 12.75 3.652-3.033 15.569-1.375 18.394 2.681-1.721-5.925-3.17-9.435-.482-13.297' fill='%23fff'/%3E%3Cpath d='M430.535 413.756l-16.052-2.134c-2.549 3.245-2.411 7.848-1.792 12.75 3.652-3.033 15.569-1.375 18.394 2.681-1.721-5.925-3.17-9.435-.482-13.297h-.068z' fill='none' stroke='%23000' stroke-linecap='round' stroke-linejoin='round' stroke-width='.65'/%3E%3Cpath d='M431.017 427.053l-16.327-1.658c-2.548 3.174-4.271 6.42-3.72 11.163 2.549-4.197 13.365-1.163 17.98 3.51-2.754-3.65-3.031-8.888 2.067-13.015' fill='%23fff'/%3E%3Cpath d='M431.017 427.053l-16.327-1.658c-2.548 3.174-4.271 6.42-3.72 11.163 2.549-4.197 13.365-1.163 17.98 3.51-2.754-3.65-3.031-8.888 2.067-13.015z' fill='none' stroke='%23000' stroke-linecap='round' stroke-linejoin='round' stroke-width='.65'/%3E%3Cpath d='M404.425 401.216c-1.792 1.375-4.547 6.137-4.961 7.442 3.031-1.235 9.438-1.587 13.435 1.375-1.171-2.275-1.586-6.26-.552-7.918-1.584-.688-5.786-1.04-7.854-.829' fill='%23fff'/%3E%3Cpath d='M404.425 401.216c-1.792 1.375-4.547 6.137-4.961 7.442 3.031-1.235 9.438-1.587 13.435 1.375-1.171-2.275-1.586-6.26-.552-7.918-1.584-.688-5.786-1.04-7.854-.829l-.068-.07z' fill='none' stroke='%23000' stroke-linecap='round' stroke-linejoin='round' stroke-width='.65'/%3E%3Cpath d='M397.743 410.86c4.202-.07 12.812.97 16.533 1.993-2.204 3.316-1.929 8.96-1.033 12.469-5.718-5.644-15.156-5.502-20.736-3.845 1.033-2.557 3.581-7.865 5.167-10.687' fill='%23fff'/%3E%3Cpath d='M397.743 410.86c4.202-.07 12.812.97 16.533 1.993-2.204 3.316-1.929 8.96-1.033 12.469-5.718-5.644-15.156-5.502-20.736-3.845 1.033-2.557 3.581-7.865 5.167-10.687l.069.07z' fill='none' stroke='%23000' stroke-linecap='round' stroke-linejoin='round' stroke-width='.65'/%3E%3Cpath d='M414.414 426.577c-4.066.141-14.467-1.658-19.222-4.003-1.652 4.48-2.41 11.922-2.548 14.602 4.615-6.19 15.914-2.751 19.496 3.58-.344-3.368-1.585-11.64 2.274-14.25' fill='%23fff'/%3E%3Cpath d='M414.414 426.577c-4.066.141-14.467-1.658-19.222-4.003-1.652 4.48-2.41 11.922-2.548 14.602 4.615-6.19 15.914-2.751 19.496 3.58-.344-3.368-1.585-11.64 2.274-14.25v.07z' fill='none' stroke='%23000' stroke-linecap='round' stroke-linejoin='round' stroke-width='.65'/%3E%3Cpath d='M404.425 401.216c-11.437 6.895-20.116 20.81-23.354 30.457 3.238-.07 7.3.97 8.75 3.862 3.375-13.862 8.127-26.666 14.604-34.39' fill='%23fff'/%3E%3Cpath d='M404.425 401.216c-11.437 6.895-20.116 20.81-23.354 30.457 3.238-.07 7.3.97 8.75 3.862 3.375-13.862 8.127-26.666 14.604-34.39v.07zm.344-6.686c-9.368 9.435-22.664 26.26-27.488 35.413m65.585-25.413c2.548 12.398 3.17 29.064 2.136 35.201' stroke-width='.65' fill='none' stroke='%23000' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M456.425 426.921c-2.905 1.45-8.41-2.604-11.01-.763v-1.606c2.524-1.762 8.03 2.29 11.01.764V427' fill='%2300009e'/%3E%3Cpath d='M456.425 426.921c-2.905 1.45-8.41-2.604-11.01-.763v-1.606c2.524-1.762 8.03 2.29 11.01.764V427v-.079z' fill='%23002b7f'/%3E%3Cpath d='M456.425 428.603c-2.905 1.45-8.41-2.604-11.01-.842v-1.684c2.524-1.762 8.03 2.291 11.01.764v1.684' fill='%23fff'/%3E%3Cpath d='M456.425 428.603c-2.905 1.45-8.41-2.604-11.01-.842v-1.684c2.524-1.762 8.03 2.291 11.01.764v1.684z' fill='none'/%3E%3Cpath d='M456.425 430.289c-2.905 1.527-8.41-2.526-11.01-.764v-1.684c2.524-1.762 8.03 2.291 11.01.842v1.606' fill='%23ff0016'/%3E%3Cpath d='M456.425 430.289c-2.905 1.527-8.41-2.526-11.01-.764v-1.684c2.524-1.762 8.03 2.291 11.01.842v1.606' fill='%23ce1126'/%3E%3Cpath d='M456.425 431.97c-2.905 1.528-8.41-2.525-11.01-.763v-1.684c2.524-1.684 8.03 2.291 11.01.764z' fill='%23fff'/%3E%3Cpath d='M456.425 431.97c-2.905 1.528-8.41-2.525-11.01-.763v-1.684c2.524-1.684 8.03 2.291 11.01.764z' fill='none'/%3E%3Cpath d='M456.425 433.578c-2.905 1.528-8.41-2.525-11.01-.763v-1.684c2.524-1.762 8.03 2.29 11.01.763v1.606' fill='%2300009e'/%3E%3Cpath d='M456.425 433.578c-2.905 1.528-8.41-2.525-11.01-.763v-1.684c2.524-1.762 8.03 2.29 11.01.763v1.684z' fill='%23002b7f'/%3E%3C/g%3E%3Cpath d='M650.12 284.78c-24.656 97.46 2.912 159.19 21.937 201.88 17.862 39.809 21.356 132.4-43.874 197.85-96.873 96.863-170.65 57.85-207.73 110.63m-7.953.19c-37.08-52.78-110.85-13.76-207.73-110.63-65.23-65.45-61.73-158.04-43.87-197.85 19.02-42.49 46.59-104.22 21.94-201.88' fill='none' stroke='%23000' stroke-width='3'/%3E%3Cg stroke='%23000' stroke-linecap='round' stroke-linejoin='round' stroke-width='3'%3E%3Cpath d='M427.55 39.787c1.357 6.308 3.106 23.321-6.212 25.758 17.082 21.075 41.737 24.086 85.03 24.086 27.18 0 49.118-.191 65.23 0 0 5.4-1.75 11.183-1.75 17.921 0 6.5 6.799 9.51 16.7 7.264 9.9-2.246 31.061-8.602 42.512 1.481 19.224 17.204 54.555 20.167 64.067 31.015-2.912-13.094-15.337-26.332-29.119-37.37 13.006-1.864 29.894-.526 35.72 3.918-14.76-15.999-41.55-16.382-55.14-24.219-13.59-7.838-26.6-14.767-36.69-17.395 0-4.444-.587-8.028-4.469-10.609-8.543-5.974-25.237-8.028-38.825-8.793 1.939-2.055 2.326-4.492 2.326-8.22V23.55c0-7.312.78-9.175-7.57-14.385-32.224-19.785-71.441-33.978-142.88-33.978-71.248 0-110.47 14.002-142.88 33.978-8.542 5.21-7.568 7.073-7.568 14.385v21.075c0 3.728.194 6.165 2.326 8.22-13.588.573-30.088 2.628-38.825 8.793-3.688 2.58-4.468 5.974-4.468 10.61-9.9 2.437-22.906 9.366-36.688 17.394-13.593 7.838-40.38 8.22-55.136 24.23 5.63-4.445 22.519-5.974 35.525-3.92-13.588 10.849-26.012 24.087-29.12 37.372 9.513-10.849 44.844-13.812 64.262-31.016 11.257-10.084 32.419-3.918 42.513-1.481 9.9 2.246 16.699-.573 16.699-7.264 0-6.738-1.75-12.521-1.75-17.921 15.92-.382 37.856 0 65.23 0 43.1 0 67.755-3.01 85.03-24.086-9.512-2.437-7.763-19.259-6.212-25.758-20.188-4.492-30.282-12.138-46.593-12.138-16.112 0-19.025 8.554-19.025 11.756v2.628c-12.812 0-30.868-3.202-35.331-11.613 24.85-10.084 61.736-19.21 112.4-19.21 50.668 0 87.555 9.127 112.4 19.21-4.463 8.411-22.52 11.613-35.331 11.613v-2.628c0-3.01-2.719-11.756-19.025-11.756s-26.405 7.455-46.593 12.138h-.775z' fill='%2389c5e3'/%3E%3Cg fill='none'%3E%3Cpath d='M260.98 89.965c-12.619.191-21.55.956-26.405 2.437-7.763 2.438-8.538 6.547-3.494 8.793M339.21 42.176v9.749c0 6.308 6.794 14.528 17.28 14.528 25.819 0 30.868-4.444 50.087-3.919'/%3E%3Cpath d='M406.38 62.009c-17.86-3.011-32.03-12.521-47.76-12.521-15.531 0-18.831 7.073-16.112 10.466M224.48 72.809V92.02c0 5.257 3.688 12.521 17.668 9.749 12.231-2.246 20.188.526 20.188 5.782'/%3E%3Cpath d='M267.96 53.215c2.912 2.963 9.319 5.591 23.493 10.657 26.012 9.51 85.805 16.009 124.64-.956M528.88 30.42c5.05 2.055 9.706 4.11 13.787 6.165 24.263 12.138 26.012 14.958 17.469 19.594m11.654 33.786c12.619.191 21.55.956 26.405 2.437 7.763 2.438 8.538 6.547 3.494 8.793M493.36 42.176v9.749c0 6.308-6.794 14.528-17.28 14.528-25.819 0-30.868-4.444-50.087-3.919'/%3E%3Cpath d='M426.18 62.009c17.87-3.011 32.04-12.521 47.77-12.521 15.526 0 18.831 7.073 15.919 10.466M608.09 72.809V92.02c0 5.257-3.688 12.521-17.668 9.749-12.231-2.246-20.193.526-20.193 5.782'/%3E%3Cpath d='M564.61 53.215c-2.912 2.963-9.319 5.591-23.493 10.657-26.012 9.51-85.805 16.009-124.64-.956'/%3E%3C/g%3E%3Cpath d='M416.28 66.453c11.843 0 12.231-8.937 12.231-17.156 0-8.029-.388-17.013-12.231-17.013s-12.231 8.984-12.231 17.013.388 17.156 12.231 17.156z' fill='%2389c5e3'/%3E%3Cpath d='M304.55 30.437c-5.169 2.052-9.936 4.105-14.113 6.157-24.843 12.123-26.628 14.939-17.883 19.568' fill='none'/%3E%3C/g%3E%3Cg id='aq' fill='%23078930' stroke='%23000' stroke-width='3'%3E%3Cpath d='M387.94 192.56c16.306-10.486 36.499-28.13 43.874-39.809 10.094-16.301 11.456-8.35 19.219-9.691-18.25 19.979-40.962 41.35-57.074 52.63l-6.019-3.13m-136.48 39.21c-40.768-23.11-56.299.994-65.812 2.137 11.257 2.734 20.769 20.774 65.812-2.137z'/%3E%3Cpath d='M269.71 218.4c-38.83-26.241-56.105-3.33-65.816-2.733 11.068 3.479 19.224 22.315 65.816 2.733z'/%3E%3Cpath d='M297.47 202.84c-38.248-26.987-56.105-4.473-65.816-4.075 11.068 3.876 18.637 22.514 65.816 4.075z'/%3E%3Cpath d='M320.38 189.08c-35.137-31.062-55.33-10.486-64.842-11.282 10.482 5.07 16.112 24.452 64.842 11.282z'/%3E%3Cpath d='M349.69 178.99c-33.582-32.851-54.744-13.22-64.256-14.562 10.288 5.417 14.95 25.396 64.256 14.562z'/%3E%3Cpath d='M380.37 175.66c-27.762-37.672-51.831-21.917-61.15-24.651 9.125 7.206 10.482 27.384 61.15 24.651z'/%3E%3Cpath d='M385.42 177.2c-1.362-8.498-17.28-19.383-18.637-23.458 4.075-.398 4.657-5.268 2.912-7.008-1.361-1.342-4.661-.596-6.406 1.193-1.75 2.137-3.494 7.157 2.132 11.431 5.825 4.274 13.205 12.027 15.536 17.842'/%3E%3Cpath d='M214.38 234.5c11.063-3.33 25.043-1.74 34.75-2.733M232.44 218.2c11.451-2.535 25.043 0 34.943 0m-7.183-16.35c11.451-2.087 25.043.596 34.943.596M283.49 184.01c11.65-.944 24.85 3.33 34.556 4.473M313 171.98c11.644-.398 24.656 4.473 34.362 6.212m-1.942-15.162c11.649 1.193 23.686 8.548 32.811 11.48' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/g%3E%3Cuse height='100%25' transform='matrix(-1 0 0 1 832.76 0)' width='100%25' xlink:href='%23aq'/%3E%3Cg stroke='%23000' stroke-linecap='round' stroke-linejoin='round' stroke-width='3'%3E%3Cg fill='%23fff'%3E%3Cpath d='M416.49 190.46c9.125 0 16.888 0 22.519-.745v-13.021c0-4.275 15.143-9.344 38.05-4.871 89.692 17.494 101.92 58.049 170.07 81.357.775.199 3.3.994 6.212 1.54 1.75-4.075 3.688-8.15 5.825-13.17 1.163-3.727 11.068-3.528 19.8.547 10.1 4.87 14.562 10.487 12.817 13.42-1.75 4.274-3.499 7.753-5.05 11.231 15.92 5.666 44.844 14.214 35.332 52.433-7.376-7.156-25.237-14.959-36.3-14.959-12.62 0-26.211-4.82-21.937-18.637-2.331-1.143-6.411-3.28-8.544-3.677-.387 1.193-.969 2.336-1.555 3.479-2.913 7.206-15.531 9.74-28.15 5.467-71.055-24.253-92.992-77.878-176.86-78.624v2.335c0 6.76-8.737 12.971-32.225 12.971-23.3 0-32.225-6.212-32.225-12.97v-2.336c-83.673.546-105.81 54.172-176.86 78.624-12.425 4.274-25.043 1.54-28.15-5.467-.393-1.143-.974-2.287-1.556-3.48-2.137.398-6.212 2.535-8.543 3.678 4.08 13.618-9.125 18.637-21.937 18.637-11.063 0-28.731 7.803-36.3 14.96-9.513-38.02 19.025-46.569 35.33-52.434-1.555-3.478-3.105-6.957-5.049-11.232-1.55-2.932 2.719-8.548 12.812-13.419 8.738-4.274 18.443-4.472 19.805-.546 2.138 4.82 3.882 8.896 5.825 13.17 2.913-.547 5.238-1.342 6.213-1.541 67.949-23.309 80.373-63.863 170.06-81.357 22.717-4.473 38.055.596 38.055 4.87v13.022c5.63.546 13.394.745 22.519.745z'/%3E%3Cpath d='M393.78 189.71c-6.019-.596-9.512-1.938-9.512-4.274 0-5.815 9.512-3.877 9.512-8.747M165.27 253.58c3.494 8.35 7.962 19.035 12.037 28.13m-20.577-23.86c3.494 8.15 10.099 22.116 12.037 27.931'/%3E%3C/g%3E%3Cpath d='M140.62 255.71c2.33 4.075 14.562-1.938 16.112 1.938 1.362 4.076-2.326 6.213-10.869 9.294m27.567-25.392c1.744 5.218-10.487 7.356-7.962 12.027 1.556 3.081 8.35 2.137 13.786.944' fill='none'/%3E%3Cpath d='M384.06 185.24v26.987m55.14-22.517c5.825-.596 9.512-1.938 9.512-4.274 0-5.815-9.512-3.877-9.512-8.747m228.5 76.891c-3.494 8.35-7.962 19.035-12.037 28.13m20.577-23.86c-3.499 8.15-10.099 22.116-12.037 27.931' fill='%23fff'/%3E%3Cpath d='M692.36 255.71c-2.33 4.075-14.562-1.938-16.112 1.938-1.362 4.076 2.326 6.213 10.869 9.294M659.55 241.55c-1.744 5.218 10.487 7.356 7.962 12.027-1.556 3.081-8.35 2.137-13.787.944' fill='none'/%3E%3Cpath d='M448.91 185.24v26.987' fill='%23fff'/%3E%3C/g%3E%3Cpath d='M203.96 281.77l-7.523-26.884 9.371-2.622c2.396-.67 4.176-.908 5.338-.713 1.162.196 2.24.797 3.233 1.805.994 1.007 1.724 2.342 2.189 4.005.588 2.102.558 3.937-.092 5.503-.649 1.566-1.857 2.774-3.623 3.624 1.146.417 2.144.946 2.995 1.584.85.639 2.108 1.859 3.773 3.66l4.145 4.496-5.3 1.483-4.865-4.947c-1.753-1.79-2.912-2.892-3.476-3.308-.565-.415-1.107-.659-1.629-.73-.52-.072-1.295.035-2.322.323l-.917.256 3.141 11.223zm.097-16.756l3.3-.924c2.018-.564 3.277-1.012 3.777-1.343.5-.331.847-.814 1.039-1.448.192-.633.163-1.396-.087-2.289-.24-.856-.603-1.495-1.09-1.92a2.718 2.718 0 00-1.695-.682c-.453-.018-1.676.251-3.669.81l-3.484.974zm24.613 9.536l-12.392-25.016 15.221-7.54 2.096 4.232-11.092 5.494 2.748 5.546 10.306-5.105 2.088 4.215-10.307 5.105 3.373 6.809 11.467-5.68 2.088 4.214zm20.14-10.63l-15.128-23.463 6.242-4.024c2.326-1.5 3.919-2.368 4.778-2.605 1.376-.373 2.816-.207 4.321.5 1.505.705 2.86 1.992 4.064 3.86 1.094 1.696 1.69 3.324 1.79 4.884.099 1.56-.182 2.881-.843 3.964-.661 1.084-2.165 2.382-4.513 3.896l-2.545 1.64 5.707 8.85zm-8.695-21.991l4.292 6.658 2.145-1.383c1.44-.928 2.354-1.66 2.74-2.197.388-.537.576-1.175.566-1.917-.01-.741-.262-1.496-.757-2.264-.502-.78-1.096-1.325-1.782-1.639-.685-.313-1.337-.399-1.955-.257-.619.142-1.74.736-3.36 1.781zm10.435-12.159l3.778-2.64 8.66 12.396c1.345 1.925 2.268 3.146 2.769 3.664.871.893 1.815 1.395 2.83 1.507 1.015.111 2.037-.193 3.068-.913.874-.61 1.45-1.304 1.73-2.08.278-.775.277-1.58-.004-2.413-.28-.834-1.217-2.39-2.81-4.67l-8.844-12.66 3.793-2.65 8.398 12.02c2.145 3.07 3.532 5.404 4.16 7.001.628 1.598.664 3.222.106 4.874-.557 1.652-1.777 3.135-3.661 4.451-1.957 1.367-3.73 2.083-5.318 2.148-1.589.065-3.075-.368-4.46-1.297s-3.274-3.106-5.666-6.53zm19.27-13.94l7.703-4.957c2.103-1.353 3.705-2.112 4.806-2.278 1.102-.165 2.259.049 3.471.643 1.212.593 2.214 1.504 3.004 2.732.728 1.131 1.135 2.315 1.22 3.55s-.13 2.33-.65 3.284c1.404-.33 2.744-.211 4.022.355 1.278.567 2.37 1.555 3.278 2.964 1.099 1.708 1.617 3.416 1.554 5.125s-.565 3.063-1.508 4.061c-.655.694-2.403 1.955-5.243 3.782l-6.55 4.215zm6.39 1.413l3.493 5.43 2.562-1.65c1.538-.989 2.47-1.627 2.8-1.914.593-.533.93-1.146 1.012-1.84.081-.695-.129-1.431-.63-2.21-.447-.695-.961-1.16-1.544-1.396-.582-.237-1.124-.27-1.625-.098-.501.172-1.777.917-3.826 2.236zm6.008 9.337l4.04 6.277 3.602-2.319c1.58-1.017 2.541-1.752 2.883-2.206.342-.454.51-1.022.5-1.703-.007-.682-.252-1.396-.733-2.144-.495-.768-1.065-1.296-1.71-1.583a2.97 2.97 0 00-1.956-.19c-.66.16-1.822.776-3.488 1.848zm20.582.56l-12.79-24.557 4.087-2.129 10.617 20.386 10.201-5.313 2.173 4.172zm17.29-9.33l-10.795-25.746 4.25-1.782 10.795 25.746zm18.42-16.67l4.784.377c.226 3.192-.232 5.712-1.376 7.558s-2.853 3.11-5.127 3.79c-2.859.855-5.505.448-7.94-1.222-2.803-1.93-4.851-5.055-6.143-9.372-1.365-4.561-1.405-8.439-.121-11.632 1.118-2.773 3.185-4.611 6.202-5.514 2.456-.735 4.763-.51 6.92.673 1.536.839 2.929 2.35 4.178 4.534l-3.996 2.587c-.713-1.364-1.601-2.307-2.666-2.83a4.377 4.377 0 00-3.293-.277c-1.617.484-2.726 1.584-3.325 3.3-.6 1.717-.414 4.2.558 7.447 1.008 3.369 2.224 5.616 3.647 6.74s2.931 1.449 4.525.972c1.167-.35 2.041-1.105 2.621-2.265.58-1.161.764-2.783.552-4.866zm30.13 3.41l-4.942.924-3.13-5.866-8.986 1.68-.687 6.58-4.83.903 3.63-29.079 4.81-.9zm-10.397-9.292l-4.993-9.606-1.147 10.753zm39.057-1.318l8.208.624c2.076.157 3.624.508 4.645 1.051 1.02.544 1.934 1.399 2.74 2.566.806 1.167 1.396 2.646 1.769 4.439.373 1.793.46 3.992.263 6.598-.179 2.348-.6 4.369-1.262 6.064-.663 1.695-1.44 3.018-2.333 3.97a7.852 7.852 0 01-3.13 2.063c-1.193.425-2.698.569-4.514.43l-8.45-.641zm4.135 4.936l-1.367 17.992 3.373.256c1.445.11 2.502.053 3.171-.17a3.8 3.8 0 001.687-1.11c.456-.519.865-1.36 1.227-2.526.361-1.165.616-2.717.763-4.656.153-2.014.135-3.612-.055-4.794-.19-1.182-.553-2.13-1.089-2.84a4.14 4.14 0 00-2.04-1.479c-.618-.208-1.828-.381-3.632-.518zm19.335 23.604l-1.723-27.188 16.542-1.049.291 4.6-12.054.764.382 6.027 11.201-.71.29 4.58-11.2.71.469 7.4 12.462-.79.29 4.58zm50.4-26.02l4.378 1.965c-.86 3.082-2.14 5.3-3.838 6.654s-3.732 1.969-6.103 1.845c-2.98-.156-5.335-1.43-7.065-3.822-1.992-2.761-2.87-6.392-2.634-10.893.25-4.754 1.516-8.42 3.799-10.995 1.986-2.235 4.55-3.27 7.695-3.106 2.56.134 4.658 1.121 6.29 2.961 1.165 1.307 1.968 3.199 2.41 5.676l-4.633 1.092c-.213-1.524-.732-2.711-1.558-3.562-.827-.85-1.83-1.307-3.008-1.368-1.687-.089-3.1.575-4.243 1.99-1.142 1.414-1.801 3.814-1.978 7.2-.184 3.511.205 6.036 1.166 7.574.962 1.537 2.274 2.35 3.935 2.437 1.217.063 2.294-.354 3.23-1.252.937-.898 1.656-2.363 2.157-4.397zm10.29-2.53c.794-3.23 1.926-5.772 3.396-7.627 1.47-1.854 3.1-3.104 4.893-3.748 1.793-.644 3.786-.696 5.98-.156 3.181.782 5.474 2.634 6.88 5.555 1.406 2.922 1.557 6.626.453 11.113-1.116 4.537-3.048 7.82-5.796 9.85-2.416 1.799-5.22 2.305-8.414 1.52-3.217-.792-5.482-2.532-6.795-5.221-1.493-3.074-1.692-6.836-.597-11.286zm4.668.952c-.767 3.12-.75 5.604.05 7.455.8 1.85 2.074 2.99 3.825 3.421 1.763.434 3.414.02 4.953-1.242s2.704-3.496 3.492-6.701c.773-3.144.781-5.606.023-7.388-.758-1.781-2.05-2.897-3.874-3.345-1.824-.45-3.496-.056-5.016 1.178s-2.67 3.442-3.453 6.622zm19.442 10.388l4.363 1.272c-.926 3.483-.092 5.774 2.502 6.875 1.286.546 2.44.639 3.46.28 1.022-.36 1.744-1.037 2.165-2.03.248-.584.33-1.136.247-1.654-.084-.518-.333-1.02-.747-1.506s-1.5-1.468-3.26-2.945c-1.578-1.318-2.652-2.477-3.22-3.477-.569-1-.88-2.128-.932-3.385s.176-2.487.687-3.69c.595-1.403 1.449-2.53 2.562-3.382 1.113-.851 2.352-1.325 3.717-1.422s2.871.205 4.519.904c2.477 1.052 4.126 2.545 4.947 4.479.82 1.934.74 4.169-.24 6.704l-4.355-1.58c.398-1.458.404-2.593.017-3.405-.386-.812-1.152-1.461-2.297-1.947-1.145-.486-2.13-.621-2.952-.405-.823.216-1.385.68-1.688 1.394-.297.701-.267 1.41.09 2.127.358.718 1.426 1.791 3.205 3.222 1.876 1.527 3.145 2.835 3.807 3.922.662 1.088 1.015 2.28 1.06 3.574s-.263 2.712-.917 4.255c-.947 2.232-2.43 3.816-4.448 4.753s-4.488.785-7.41-.455c-5.165-2.192-6.792-6.352-4.882-12.478zm21.51 20.02l11.3-20.255-5.937-3.312 2.301-4.124 15.882 8.86-2.3 4.124-5.921-3.303-11.3 20.255zm29.75 18.53l-4.205-2.756 1.805-6.4-7.645-5.01-5.053 4.27-4.109-2.694 22.758-18.462 4.093 2.683zm-1.064-13.904l3.051-10.386-8.275 6.962zm10.274 20.564l15.933-22.924 7.99 5.554c2.044 1.42 3.36 2.64 3.95 3.66.589 1.02.812 2.235.669 3.643-.144 1.407-.708 2.82-1.694 4.238-1.246 1.793-2.68 2.938-4.3 3.434-1.621.497-3.322.336-5.102-.484.407 1.149.636 2.255.686 3.317.05 1.063-.09 2.81-.419 5.24l-.825 6.06-4.519-3.141.715-6.901c.263-2.492.375-4.088.336-4.788-.04-.7-.198-1.273-.474-1.72-.277-.448-.853-.976-1.728-1.584l-.782-.544-6.652 9.57zm12.979-10.599l2.815 1.956c1.72 1.196 2.867 1.881 3.441 2.056.574.175 1.167.134 1.777-.121.611-.256 1.18-.765 1.71-1.526.507-.73.769-1.417.785-2.063a2.718 2.718 0 00-.553-1.741c-.275-.361-1.262-1.132-2.96-2.313l-2.972-2.065zm5.891 23.619l15.362-23.31 3.848 2.536-15.362 23.31zm25.3 3.49l3.024 3.726c-2.156 2.364-4.298 3.768-6.424 4.213-2.126.444-4.219.076-6.28-1.102-2.59-1.482-4.118-3.68-4.586-6.595-.535-3.362.317-6.999 2.555-10.91 2.363-4.133 5.144-6.835 8.343-8.106 2.78-1.101 5.536-.87 8.27.693 2.225 1.273 3.653 3.099 4.282 5.477.45 1.691.316 3.742-.404 6.153l-4.63-1.112c.497-1.457.568-2.75.213-3.882a4.374 4.374 0 00-2.069-2.577c-1.466-.838-3.027-.883-4.684-.134-1.656.749-3.326 2.595-5.01 5.537-1.745 3.053-2.535 5.482-2.369 7.288s.971 3.122 2.415 3.948c1.058.605 2.207.718 3.448.338 1.241-.38 2.543-1.365 3.906-2.955zm21.63 20.25l-4.709-1.762.35-6.64-8.561-3.203-3.988 5.279-4.602-1.722 18.13-23.024 4.584 1.715zm-4.102-13.327l.687-10.804-6.537 8.615zM307.368 23.483l-3.876 1.752-3.752-4.192-7.048 3.185.757 5.547-3.789 1.712-2.856-24.632 3.773-1.706zm-10.412-5.55l-6.033-6.892 1.217 9.07zm12.357 4.955L301.914.455l5.555-1.833 8.383 14.203-1.742-16.393 5.57-1.837 7.4 22.433-3.444 1.136L317.812.505l2.167 18.866-3.58 1.18-9.452-16.462 5.825 17.658zm21.567-6.83l-5.652-22.936 13.955-3.439.956 3.88-10.17 2.506 1.253 5.085 9.45-2.329.952 3.865-9.45 2.328 1.539 6.243 10.513-2.591.952 3.864zm17.554-4.207l-4.196-23.247 8.103-1.462c2.072-.374 3.59-.432 4.553-.175.963.257 1.823.85 2.58 1.777.757.928 1.265 2.11 1.525 3.548.328 1.819.156 3.361-.516 4.629-.671 1.267-1.785 2.189-3.34 2.764.931.443 1.73.968 2.396 1.573.666.606 1.628 1.734 2.887 3.385l3.133 4.117-4.582.827-3.704-4.555c-1.335-1.647-2.223-2.669-2.665-3.064-.443-.395-.88-.643-1.314-.745-.433-.102-1.094-.073-1.981.088l-.793.143 1.751 9.704zm1.416-14.108l2.854-.515c1.744-.315 2.84-.592 3.288-.831.448-.24.778-.618.99-1.137.213-.518.249-1.163.11-1.935-.134-.74-.39-1.308-.766-1.704a2.3 2.3 0 00-1.373-.71c-.38-.051-1.432.079-3.155.39l-3.013.543zm17.71 10.869l-3.202-23.403 3.864-.53 3.202 23.405zm19.11-10.906l3.909 1.099c-.336 2.686-1.13 4.702-2.383 6.047s-2.878 2.114-4.878 2.305c-2.512.241-4.642-.531-6.389-2.317-2.01-2.063-3.198-4.992-3.562-8.788-.385-4.01.218-7.235 1.808-9.675 1.383-2.118 3.4-3.305 6.052-3.559 2.16-.207 4.038.358 5.634 1.694 1.138.948 2.046 2.431 2.725 4.449l-3.742 1.492c-.368-1.25-.95-2.178-1.748-2.787a3.702 3.702 0 00-2.688-.77c-1.422.136-2.523.868-3.302 2.194-.78 1.327-1.032 3.418-.758 6.273.284 2.962.924 5.026 1.92 6.193s2.196 1.684 3.597 1.55c1.027-.099 1.876-.582 2.548-1.45.672-.87 1.091-2.185 1.256-3.95zm25.38 7.385l-4.25.17-1.905-5.294-7.728.309-1.38 5.425-4.154.166 6.593-23.905 4.137-.165zm-7.57-9.05l-3.006-8.653-2.274 8.863zm29.878.829l3.735 1.594c-.68 2.621-1.727 4.518-3.142 5.69-1.416 1.172-3.127 1.724-5.135 1.656-2.523-.085-4.535-1.125-6.037-3.121-1.728-2.305-2.528-5.363-2.4-9.174.136-4.026 1.15-7.147 3.041-9.362 1.645-1.922 3.799-2.838 6.461-2.748 2.169.073 3.958.875 5.368 2.406 1.006 1.087 1.716 2.675 2.13 4.763l-3.904.997c-.204-1.286-.662-2.282-1.374-2.989a3.702 3.702 0 00-2.567-1.11c-1.427-.048-2.613.535-3.557 1.75-.944 1.215-1.464 3.256-1.56 6.122-.101 2.974.268 5.104 1.106 6.39.838 1.286 1.96 1.952 3.366 2 1.03.035 1.936-.335 2.714-1.11.779-.774 1.364-2.025 1.755-3.753zm6.837 9.04l2.042-23.533 14.32 1.242-.346 3.981-10.434-.905-.453 5.217 9.696.841-.344 3.965-9.696-.84-.556 6.404 10.788.936-.344 3.965zm18.007 1.647l3.343-23.384 3.764.538 5.616 16.738 2.232-15.617 3.605.515-3.342 23.385-3.893-.556-5.54-16.353-2.18 15.248zm23.541 3.759l3.863-19.242-5.64-1.132.787-3.918 15.087 3.029-.787 3.918-5.624-1.13-3.863 19.243zm11.97 2.468l6.036-22.838 7.96 2.104c2.036.538 3.436 1.128 4.2 1.769.764.64 1.292 1.541 1.586 2.702.293 1.16.253 2.447-.12 3.86-.473 1.786-1.281 3.111-2.426 3.975-1.145.864-2.544 1.228-4.197 1.091.657.796 1.158 1.609 1.505 2.44.348.83.742 2.26 1.184 4.287l1.097 5.057-4.502-1.19-1.429-5.694c-.513-2.058-.893-3.36-1.128-3.904-.226-.545-.522-.956-.87-1.231-.348-.276-.966-.53-1.834-.76l-.78-.206-2.519 9.534zm7.253-12.182l2.804.74c1.714.454 2.824.666 3.331.64.508-.028.967-.231 1.379-.611.411-.38.717-.95.917-1.708.193-.727.202-1.35.027-1.868a2.3 2.3 0 00-.943-1.224c-.323-.207-1.33-.535-3.023-.982l-2.96-.783zm28.111 22.96l-4.023-1.382.143-5.625-7.315-2.512-3.252 4.557-3.932-1.35 14.806-19.892 3.916 1.345zm-3.776-11.18l.333-9.153-5.332 7.437zm5.769 12.051l9.405-21.458 3.572 1.565-7.808 17.813 8.914 3.907-1.598 3.645z'/%3E%3C/g%3E%3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns:svg='http://www.w3.org/2000/svg' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 800 400'%3E %3Cpath d='M0,0h800v400H0z' fill='%23002a8f'/%3E %3Cpath d='M0,80h800v80H0v80h800v80H0z' fill='%23fff'/%3E %3Cpath d='M346.4,200L0,0v400z' fill='%23cf142b'/%3E %3Cpath d='M115.5,140l35.35,108.5 l-92.5-67h114.2l-92.5,67z' fill='%23fff'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 510 300'%3E %3Crect width='510' height='300' fill='%23003893'/%3E %3Crect width='510' height='75' y='150' fill='%23fff'/%3E %3Crect width='510' height='25' y='175' fill='%23cf2027'/%3E %3Cg fill='%23f7d116' transform='translate(191.25,187.5)'%3E %3Cg id='s2'%3E %3Cg id='s' transform='translate(0,-75)'%3E %3Cg id='c'%3E %3Cpath id='t' d='M0,-15V0H7.5' transform='rotate(18,0,-15)'/%3E %3Cuse xlink:href='%23t' transform='scale(-1,1)'/%3E %3C/g%3E %3Cuse xlink:href='%23c' transform='rotate(72)'/%3E %3Cuse xlink:href='%23c' transform='rotate(144)'/%3E %3Cuse xlink:href='%23c' transform='rotate(216)'/%3E %3Cuse xlink:href='%23c' transform='rotate(288)'/%3E %3C/g%3E %3Cuse xlink:href='%23s' y='150'/%3E %3C/g%3E %3Cuse xlink:href='%23s2' transform='rotate(72)'/%3E %3Cuse xlink:href='%23s2' transform='rotate(144)'/%3E %3Cuse xlink:href='%23s2' transform='rotate(216)'/%3E %3Cuse xlink:href='%23s2' transform='rotate(288)'/%3E %3C/g%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 54 36'%3E %3Crect width='54' height='36' fill='%23002b7f'/%3E %3Cpath d='M0,22.5H54V27H0z' fill='%23f9e814'/%3E %3Cg fill='%23fff' id='s'%3E %3Cg id='f'%3E %3Cg id='t'%3E %3Cpath d='m12,8v4h2z' transform='rotate(18,12,8)' id='o'/%3E %3Cuse xlink:href='%23o' x='-24' transform='scale(-1,1)'/%3E %3C/g%3E %3Cuse xlink:href='%23t' transform='rotate(72,12,12)'/%3E %3C/g%3E %3Cuse xlink:href='%23t' transform='rotate(-72,12,12)'/%3E %3Cuse xlink:href='%23f' transform='rotate(144,12,12)'/%3E %3C/g%3E %3Cuse xlink:href='%23s' x='-4' y='-4' transform='scale(0.75)'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 1000 500'%3E %3Crect width='1000' height='500' fill='%230021ad'/%3E %3Cpath d='M0,0H1000V500z' fill='%231c8a42'/%3E %3Ccircle cx='500' cy='250' r='90.32' fill='%23ffc639'/%3E %3Cpath fill='%231c8a42' d='m444.84,209.43c6.1786,8.4767,15.542,22.689,23.072,18.979,5.8763,0.0202,8.9102,0.43341,9.7064,4.3442,13.859,2.3586,37.153-3.4875,51.647-22.366,0,0,1.2196,0.16127,0.79627-7.0152,0.0806-3.1246,4.2736-2.4997,4.3744-1.4817,0.5846,1.5522,0.4838,2.7114,1.27,2.7517,1.784-0.59468,4.2233-4.5962,6.2694-7.1362,0.55436-1.1188,0.25198-2.2981,0.38301-3.7092,1.0785-2.6509,3.7697-2.0763,4.3341-0.68539,0.51404,0.89706,0.52412,1.5825,1.0281,2.4795,2.7315,1.8244,7.6603,0.12095,8.0433,0.12095,0.48381-2.2275,1.9151-2.0159,1.9151-2.0159,1.8244-0.40317,1.1087-0.24191,2.3082,0.38302-1.0583,12.005,2.3586,12.539,2.0764,18.697,0.12095,6.8741-2.0764,8.8295-2.0764,11.45,0.69548,3.2052,10.835,3.3161,7.2672,6.0275-3.1347,1.6732,0.0101,4.8078-4.7071,6.0275-13.728,6.9648-16.359,12.942-16.359,12.942s-3.4471,6.5113-3.8302,6.5113c-2.2981,4.3442-5.211,1.9756-6.8338,4.0922-0.80635,2.661-1.7135,8.5574-0.1008,11.622,0.80635,4.2132-0.10079,6.5113-1.1087,10.724-0.90714,8.7892-4.3946,10.12-4.7978,13.204-1.6127,3.296,0.3427,18.778-1.1894,18.778-10.22,0.20159-18.052-1.9554-22.094-2.7617,3.941-16.984,2.409-31.901,2.409-33.433-1.0079-12.146-18.193-9.1924-20.824-10.805-2.1772-0.46366-3.5479-2.2376-4.314-3.0036-2.4291-0.26207-3.3363-0.81643-5.7654-1.0684-1.2095,0.60477-0.48381,1.2297-3.1851,2.0663-6.854,0.82651-9.8778-5.9771-9.8778-5.9771,0.33262-2.288-15.411,0.46365-23.969-1.522-3.5076,1.9554-5.0397,7.741-7.9123,8.4263-0.0806,1.7941-4.7272-1.4716-5.6646-3.2355-0.19151-5.1304,4.4752-7.3982,4.4752-7.3982,3.7092-2.6106,5.9065-3.0339,7.6906-4.8381,0.89706-4.4652,0.44349-7.7712,2.3485-11.128,1.6127-2.5602,3.9914-1.3607,5.6041-2.5098,1.7336-1.149,2.4694-8.6682,0.86683-10.724,0,0-6.9346-6.2593-7.3176-6.6423-2.2578-6.4709,2.6408-10.644,4.0418-10.17z'/%3E %3Cpath fill='%23ffc639' d='m877.93,97.555c-4.0922-16.194-40.721-51.071-68.247-73.265-6.5717-4.4773-10.855-1.8103-9.9987,4.573,3.427,5.716,5.9972,12,9.4242,17.716,0.95754,3.81,2.7618,6.477,3.7193,10.286,0,0,0.28222,6.5728,0.85674,7.1442,8.5675,9.4333,9.7165,17.432,9.7165,17.432,4.949,9.526,9.3335,16.478,18.002,24.29,9.7165,6.098,2.5702,25.047,2.8525,35.147,0,6.3802-4.566,5.6243-8.5674,4.8582-31.528-28.958-62.774-29.049-90.301-37.435-10.765-1.139-10.956,4.0015-7.4285,6.854,19.242,20.582,37.334,34.582,61.151,46.294,4.0015,2.4795,8.003,4.959,12.005,7.4386,4.566,3.81,9.142,7.62,13.708,11.43,10.573,6.854,11.44,13.143,11.44,13.708,0.28222,12.861-6.5818,22.86-8.5775,26.861-3.6084,13.637-10.855,16.006-10.855,16.006-58.874,39.723-89.737,50.004-185.18,37.717-1.4313-0.75595-10.573,0.76603,0,4.576,24.291,8.0937,83.961,21.076,141.69-6.2593,13.859-9.7165,23.132-6.5314,33.171-12.347,16.49-10.17,40.035-22.83,44.319-24.251,12.861-6.864,48.865-14.575,57.16-21.439,9.5149-0.76603,19.393-2.0159,20.058-10.2,3.1246-2.026,7.7006-0.54428,11.097-7.2168,7.5494-1.3103,6.2794-4.0116,6.2794-4.0116-1.905-5.332-8.9606-7.5293-14-11.43-7.4386-2.4795-12.579-3.2456-18.012-0.57452-1.7135,0.76603-3.427,1.522-5.1405,2.288,0,0-8.003-1.149-8.003-1.7135-17.78-0.9777-16.046-59.902-22.336-84.478z'/%3E %3Cpath fill='%231c8a42' d='m919.63,194.01a4.4025,2.7511,15.947,0,1,-8.3961,-2.6368,4.4025,2.7511,15.947,0,1,8.3961,2.6368z'/%3E %3Cg fill='%23fff'%3E %3Cpath id='s' d='m188.16,190.94-12.751-11.936-12.904,11.77,1.383-17.405-17.249-2.753,14.475-9.7743-8.6056-15.197,16.668,5.2197,6.5177-16.204,6.3099,16.287,16.734-5.0072-8.8005,15.086,14.348,9.959-17.283,2.5313,1.1585,17.424z'/%3E %3Cpath d='m233.39,335.53-13.752-9.1669-13.391,9.6641,4.7117-15.568-13.582-9.4155,16.667-0.44539,4.9883-15.496,5.5945,15.299,16.667-0.15537-13.21,9.9023,5.3073,15.382z'/%3E %3Cuse xlink:href='%23s' x='2.5215' y='269.0608'/%3E %3Cuse xlink:href='%23s' x='-112.0655' y='123.2228'/%3E %3Cuse xlink:href='%23s' x='108.4275' y='85.0268'/%3E %3C/g%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 900 600'%3E %3Crect width='900' height='600' fill='%23fff'/%3E %3Cpath id='branch' fill='%23435125' d='m434.8,498.25c-0.18-0.086-0.218-0.122-0.347-0.245l-0.125-0.117c-0.324-0.297-0.861-0.822-1.582-1.643-1.332-1.513-3.119-3.728-4.69-5.685-3.115-3.883-5.689-7.228-6.174-7.858l-0.793-1.032-7.767-2.395-5.671-2.644,3.03-3.406,10.408,4.456,7.767,1.594,14.363,10.564-0.011,0.009c-0.029,0.024-2.089,1.738-4.136,3.599-0.913,0.83-2.064,1.896-2.877,2.783-0.375,0.408-0.705,0.813-0.93,1.14-0.138,0.201-0.215,0.383-0.252,0.471l0.892-0.555,0.967,0.752-1.968,0.184-0.09,0.02zm-53.34-16.02c-6.777-0.001-13.471-1.874-19.895-5.567l-0.007-0.004,0.003-0.008s0.84-1.601,2.878-3.096c1.941-1.425,5.442-3.128,11.1-3.15h0.117c6.701,0,14.901,2.278,24.373,6.771-0.32,0.212-7.756,5.054-18.566,5.054l0.01,0.01zm-29.37-6.51c-1.253,0-2.379-0.474-3.17-1.333-0.649-0.706-1.114-1.646-1.422-2.878-0.504-2.018-0.365-4.025-0.351-4.217,0.526-0.221,1.062-0.342,1.562-0.354l0.112-0.002c2.511,0,4.49,2.178,5.338,4.337,0.481,1.227,0.574,2.259,0.274,3.067-0.3,0.81-1.24,1.37-2.34,1.37zm51.68-5.99c-17.359-2.479-24.717-8.755-27.833-13.583-3.323-5.149-2.641-9.912-2.634-9.96l0.003-0.014,0.013-0.004c0.005,0,1.061-0.285,2.658-0.293,4.618,0,16.43,2.323,27.798,23.842l0.007,0.014-0.02-0.01zm-35.58-3.44c-7.416-0.001-13.062-1.28-16.782-3.804-2.138-1.45-3.184-3.043-3.686-4.125-0.47-1.014-0.577-1.856-0.594-2.023,0.196-0.09,3.232-1.438,7.765-1.65,0.383-0.018,0.769-0.029,1.174-0.03,5.732,0,14.448,1.87,23.646,10.78l0.009,0.009-0.011,0.001c-4.2,0.55-8.08,0.84-11.53,0.84zm-35.91-1.38c-7.82,0-18.563-2.388-25.263-9.087l-0.007-0.008,0.02-0.005c0.07-0.018,7.342-1.863,15.523-2.062,0.488-0.012,0.979-0.019,1.475-0.019,7.332,0,12.944,1.422,16.682,4.225,1.305,0.979,2.018,1.89,2.178,2.783,0.134,0.746-0.26,1.55-1.056,2.15-1.683,1.271-4.692,1.949-8.945,2.017l-0.6,0.02zm-25.34-13c-0.963,0-1.867-0.426-2.479-1.167-0.506-0.614-0.858-1.416-1.108-2.522-0.418-1.848-0.292-3.656-0.291-3.674l0.001-0.018c0.364-0.172,0.771-0.264,1.217-0.275h0.003c1.157,0,2.039,0.63,2.589,1.158,0.733,0.705,1.333,1.645,1.688,2.645,0.365,1.03,0.424,1.892,0.18,2.635-0.2,0.59-0.88,1.21-1.8,1.21zm58.53-1.32c-1.253,0-2.379-0.474-3.17-1.333-0.649-0.706-1.114-1.646-1.422-2.878-0.504-2.018-0.365-4.025-0.351-4.217,0.526-0.221,1.062-0.342,1.562-0.354l0.112-0.002c2.511,0,4.49,2.178,5.338,4.337,0.481,1.227,0.574,2.259,0.274,3.067-0.3,0.82-1.25,1.37-2.34,1.37zm-28.51-1.18c-15.737-0.554-23.904-5.027-27.984-8.683-2.297-2.058-3.574-4.098-4.24-5.447-0.628-1.274-0.866-2.249-0.908-2.438l0.021-0.009c0.003,0,1.489-0.532,3.885-0.579l0.368-0.004c5.307,0,16.111,2.229,28.852,17.153v0.01zm17.09-1.59c-12.661-1.928-19.834-7.363-23.622-11.585-3.971-4.425-5.16-8.546-5.213-8.738,0.023-0.007,1.57-0.41,3.9-0.469,0.169-0.005,0.345-0.007,0.524-0.007,0.181,0,0.365,0.002,0.553,0.007,6.368,0.139,17.934,3.023,23.855,20.785h0.01zm-65-6.08c-4.149,0-8.174-0.48-11.962-1.427-6.629-1.658-9.473-4.189-10.691-6.021-0.692-1.04-0.943-1.952-1.031-2.534-0.085-0.556-0.04-0.999-0.031-1.073l0.031-0.011c0.017-0.004,4.4-1.235,10.464-1.328,0.239-0.004,0.48-0.006,0.725-0.006,2.927,0,5.808,0.279,8.564,0.83,10.536,2.107,16,10.06,16.053,10.14l0.005,0.009-0.013,0.003c-0.06,0.01-5.08,1.42-12.12,1.42zm29.39-10.68c-1.269,0-2.395-0.463-3.172-1.304-0.639-0.691-1.104-1.643-1.42-2.908-0.506-2.015-0.365-4.002-0.351-4.185,0.526-0.221,1.062-0.342,1.562-0.354l0.112-0.002c2.506,0,4.488,2.179,5.339,4.338,0.468,1.188,0.55,2.208,0.243,3.034-0.31,0.84-1.22,1.38-2.31,1.38zm-22.1-3.03c-0.095-0.023-5.977-1.536-11.967-5.225-5.544-3.413-12.326-9.45-13.153-18.83v-0.005l0.014-0.004c0.001,0,0.516-0.125,1.278-0.154,0.105-0.004,0.217-0.006,0.334-0.006,1.656,0,5.046,0.466,9.147,3.584,5.22,3.98,10.04,10.92,14.35,20.65zm14.43-0.53c-0.037-0.015-4.229-1.693-9.469-6.084-4.882-4.092-11.746-11.46-16.716-23.33,0.003-0.001,1.142-0.608,2.886-0.718,0.101-0.007,0.203-0.009,0.306-0.009,0.15,0,0.305,0.005,0.463,0.009,2.411,0.068,6.083,1.07,10.154,5.463,4.676,5.047,8.85,13.34,12.404,24.651l0.01,0.032-0.03-0.01zm-37.39-1.09c-4.821,0-6.471-2.615-6.957-3.74-0.798-1.849-0.556-3.689-0.554-3.707l0.003-0.02c0.78-0.195,1.605-0.303,2.398-0.314l0.165-0.001c3.799,0,6.798,1.929,8.084,3.841,0.255,0.379,1.037,1.694,0.39,2.721-0.52,0.81-1.7,1.22-3.53,1.22zm-10.68-13.47c-2.692,0-6.811-0.165-11.141-0.952-4.294-0.781-6.728-4.432-8.013-7.356-1.399-3.185-1.794-6.223-1.798-6.254h0.012c13.282,0.39,19.555,4.271,22.478,7.457,3.018,3.29,3.197,6.706,3.206,6.922l-0.009,0.001c-0.02,0-1.89,0.18-4.74,0.18zm13.83-13.82c-0.018-0.022-1.535-1.898-3.033-4.228-1.573-2.445-3.028-4.996-3.028-7.084,0-2.016-0.474-6.266-0.757-8.619-0.358-2.985-0.72-5.54-0.75-5.757l0.013,0.004c0.337,0.123,8.308,3.114,8.308,10.591,0,7.489-0.738,15.014-0.745,15.089l-0.001,0.011h-0.01zm-10.33-0.71c-0.084,0-0.167-0.008-0.25-0.021-2.356-0.393-6.496-2.194-11.073-4.818-5.082-2.914-9.209-6.036-11.62-8.791-2.198-2.512-3.503-6.457-3.88-11.726-0.267-3.739,0.053-6.854,0.087-7.163,0.412-0.137,0.85-0.204,1.315-0.204,1.764,0.029,3.647,0.823,6.189,2.574,1.981,1.365,4.165,3.221,6.49,5.514,4.012,3.957,7.168,7.932,7.199,7.971l0.032,0.04c0.265,0.475,2.537,4.571,4.307,8.558,1.124,2.532,1.767,4.357,2.024,5.746,0.147,0.791,0.19,1.31-0.004,1.781-0.081,0.195-0.235,0.376-0.385,0.448-0.14,0.06-0.28,0.09-0.44,0.09z'/%3E %3Cuse xlink:href='%23branch' transform='matrix(-1,0,0,1,842.178,0)'/%3E %3Cpath fill='%23d47600' d='m698.83,95.476l-2.355,0.938-0.923,0.368-2.854-0.157-2.673,1.283-4.74,3.239-0.209,0.15-1.767,0.461-1.641-0.708-0.932,0.424-0.321,1.92-0.887,1.379-1.092,0.767-3.783,0.387-3.19,1.645-4.15-1.111-1.928,0.755-4.099,3.692-2.095,0.992-0.732-0.042-2.778-0.143-1.173,0.384-1.752,1.693-3.315,0.258-1.033,0.715-1.618,3.26-1.753,1.808-1.003,0.212-1.087-0.398-0.817,0.144-0.37,2.086-0.793,0.874-2.219,0.764-1.773,1.477-1.556,0.799-2.084-0.052h-0.479l-2.076,1.146-3.905,0.342-1.624,1.549-0.358,0.331-0.758,0.458-1.24,0.74-0.304,0.184-1.495-0.267-1.75,0.693-0.708-1.089-1.211,0.727-1.604,0.069-1.998-0.889-1.522-0.678-1.113,0.161-0.387,1.94-0.039,0.206-1.17,1.557-2.184,1.323-0.297,0.387-2.485,3.208-4.722,4.966-3.993,2.028-4.139,1.259-2.897,2.38-7.599,3.767-11.994,5.967-2.453,0.786-3.52,0.562-6.278,2.312-5.539,1.671-0.308,0.094-1.096,0.332-7.81,2.363-3.635-0.384-2.153,0.782-5.605-0.622-3.897,0.077-2.467,0.513-4.637,2.224-7.827,3.762-2.586,2.366-4.027,2.101-4.715,1.493,0.011-1.981-0.028-0.084-1.636,0.517-1.181,0.373-3.825,0.59h-2.128l-1.321-0.384-0.204,0.069-7.818,2.576-8.719,0.842-4.363,1.399-3.26-0.052-2.038,0.607-3.995,0.488-1.428-0.381-0.322-0.088-11.75,0.51-5.372-0.607-2.564,0.583-4.296-1.445-6.269-0.727-1.465-0.439-3.295-0.978-1.491,0.859-1.116,0.119-2.667-0.967-0.96-0.025-2.202,0.796-1.267-0.325-1.177-0.938-2.761-0.411-1.682-1.414-9.402,1.246-2.551-0.75-8.554-2.492-1.361,0.069-1.696,1.271-2.548,0.929-2.212,0.575-3.012,0.105-3.497-0.918-3.606-1.748-1.333-0.317-2.974,0.3-0.91,0.083-5.466-2.932-7.042-4.404-4.778-2.296-1.794-0.291-0.241,0.853,0.89,2.805,0.303,2.774-0.091,2.563-0.049,1.587,0.446,1.425,1.725,1.912,0.719,1.92,0.526,5.284-0.006,5.362-0.839,8.551-0.283,1.302-1.001,4.43-0.914,4.069-3.546,10.833-0.974,1.343-2.391,1.631-5.419,3.688-3.99,2.301-1.263,0.523-3.239,0.245-2.018-0.105-2.513-1.361-2.467-0.635-3.232-2.324-3.595-0.744-3.941-2.278-1.026-1.233-2.146-0.202-2.976-0.893,0.002-0.005-1.093-0.327-0.755-0.22v-0.001l-3.796-0.104-3.54-1.634-1.864-0.45-2.547-0.129-2.666,1.239-0.001-0.004-1.351,0.629-1.707-0.678-1.235,0.077-1.399,2.115-0.209,0.328-0.964,0.51-1.2-0.017-0.939-0.025-1.016,0.444-1.368,0.593v0.003l-1.208,0.527-0.59,0.255-0.01-0.01-0.363,0.073-0.645,0.112-0.8,0.153-1.41-0.824-0.75-0.442-1.257-0.256-0.677,0.489-0.133,2.301-0.618,1.378-1.961,1.734-1.993,1.755-1.389,2.047-3.676,8.39-2.303,3.385-0.715,0.789-2.408,2.656-2.136,1.657-4.922,3.815-4.659,1.741-4.013,0.82-1.951,0.008-3.696-0.492-3.323-1.02-3.65-2.282-4.003-3.217-5.794-5.724-0.82-0.493-0.171-0.114-1.825-1.167-1.354,0.035-0.53,0.874-0.29,1.263-0.245,1.12-0.664,6.367,0.049,0.369,0.349,2.622,4.401,6.15,1.358,3.267,0.223,0.373,0.908,1.525,0.691,1.163,0.069,0.118,1.504,4.488-1.057,2.534,0.534,1.697-1.336,1.037-0.245,1.465,3.951,4.953,0.862,2.185-0.963,3.029-1.536,1.671-0.429,0.457,0.216,1.28,1.818,1.635,3.089,2.75,1.647,4.086,1.253,1.096,1.456-0.31,0.81,0.618,1.228-0.021,1.208,1.208,0.782,0.379,1.236,0.616,0.977,1.272,0.216,3.911,1.822,4.86,0.028,2.635,0.01,0.374,1.134,1.948,0.356,1.538-0.604,4.069,1.445,1.306,1.567-0.32,1.012,0.16,1.626,1.354,1.969,3.001,1.926-0.282,1.222,0.589,5.902,5.334,1.339,0.676,0.074,0.042,0.963,0.483,1.197,1.208,1.856-1.232,0.206-0.021,2.018-0.178,0.886,0.597,1.704,1.149,2.234-0.029,4.844,1.485,2.119,0.543,4.261,2.648,1.811,1.12,1.072,0.871,1.424,1.161,2.845,1.224,2.44,0.584,1.322,0.314,0.995,0.384,0.025-0.062,0.014,0.004-0.024,0.063,5.284,2.023,2.862,0.668,2.648,0.975,1.927,0.703,1.414,0.023,2-1.682,1.937-0.112,1.609,0.401,1.57-0.263,2.485-1.531,0.485-0.719,1.762-0.839,5.944-0.738,1.737,0.564,4.46-1.94,2.988,0.831,2.645-0.938,5.779,1.284,1.536,1.081,1.717,1.965,0.21,0.009,1.912,0.037-0.799,1.331,2.523,2.647,2.279,3.445,0.154,0.455,1.657,4.864,1.232,1.723,0.862,2.405,0.042,1.568-1.34,1.022-0.22,0.583-0.076,0.216,0.272,0.655,0.506-0.276,0.963-0.533,1.166-0.181,2.066,0.22,1.364,0.143,2.154-1.069,1.427-0.71,2.293,0.987,2.52-0.028,1.058,0.471,2.995,1.358,1.529,0.144,0.565-0.371,0.36-0.856-0.185-0.996-1.145-1.323-2.531-2.938-1.036-1.51-0.789-2.186-0.245-2.794-0.174-1.885,0.314-2.477,0.68-0.884,0.5-1.968h0.009l0.129-0.515,1.406-1.866,3.724-2.393,4-3.582,3.162-2.085,3.26-1.412,0.087-0.396,0.363,0.146,8.292-2.819,0.137-0.016,3.692-0.643,24.92,1.755,0.924-0.279,0.004-0.006,0.83-2.33,0.447-0.432,0.297-0.282,2.74-1.206,1.281-0.183,3.556,0.878,1.456,0.359,2.332-1.307,1.654,0.028,3.417-1.866,2.111,0.053,0.803-0.321,4.112-2.955,3.961-1.135,1.03-0.548,0.363-0.199,4.06-2.144,2.579-1.981,2.226-1.183,2.438-0.629,6.38-0.449,1.283-2.138,2.744-0.366,1.657-1.87,1.896-0.771,1.359-1.958,1.139-1.641,1.591-0.921,5.1-0.32,6.045,0.749,0.799-0.485,1.366-4.875,1.43-0.915,3.851-5.612,0.013-2.045,0.004-1.708,0.633-2.432-0.43-4.391,0.51-4.446,2.394-5.65,2.109-2.279,3.401-2.301,1.729-0.753,2.449-0.412v-0.006l0.36-0.061,0.624-0.107,8.433-0.116c0.117-0.087,3.067-0.042,3.067-0.042l2.812-0.038,7.114,1.266,0.506,0.088,2.405,0.779,2.774,2.157,2.936,2.868,0.551,0.535,1.902,0.801,0.575,0.251,1.571-0.251,2.237-1.165,1.688-1.427,2.301-1.257,0.056-0.08,1.295-1.948,0.039-0.04,0.028,0.007,0.003-0.011-0.022-0.005,0.511-0.775,4.447-1.733,5.23-0.304,0.588-0.318,0.327-0.175,1.382-1.623,1.295-0.011,3.135,1.134,2.204-0.437,1.75,0.699,1.36-0.161,2.565-0.304,2.754,1.938,1.605,0.205,5.658,3.31,0.294,0.048,0.152,0.028,0.324,0.053,0.671-0.199,0.998-0.289,0.132-0.039,0.126,0.174,0.643,0.907,0.882,0.126,1.044-1.393-0.415-0.632-0.157-0.23-2.021-0.411-1.815-3.103,1.728-1.861-2.711-3.326-0.45-0.551-0.153-0.234-0.937-1.423-4.746-7.235-6.182-4.935-0.002,0.004-2.165-1.732-0.014-0.01-0.758-0.596-3.302-3.358-2.358-3.13-0.309-0.674-0.487-1.062-1.413-3.078-2.462-1.896-2.006-2.191-0.098-0.129-4.14-5.626-0.68-0.943-0.978-0.565-2.066-0.014-0.195-0.196-0.116-0.121,0.07-0.074,0.991-0.985,1.105-0.278,0.476-1.089-2.108-6.104-0.014-0.213-0.157-1.95,1.718-8.855,0.22-1.079,2.928-5.958,1.814-1.486,1.98-3.892,1.696-2.488,1.625-1.582,0.284-0.168,2.934-1.776,2.465-0.347,2.348-0.331,4.099,1.264,3.901-0.076,0.761-0.081,1.77-0.203,2.911-0.917,1.374-0.848,0.713-1.093,1.487-4.987,0.478-1.587,0.917-1.724,5.306-6.108,4.011-3.71,9.019-6.613,4.415-2.639,2.254-1.347,20.126-8.946,5.23-5.302,2.725-2.757,4.821-3.235,5.641-2.311,4.854-3.842,1.06-1.334,1.336-4.303,1.113-0.269,1.005-2.174,0.286-0.618,3.961-2.792,0.448-0.223,15.388-7.71,2.236,0.307,1.197-1.793,4.477-0.751,0.824-0.14,1.104-0.551,0.939-1.599v-0.316l0.129-4.273,0.956-1.155,0.521-2.816,0.491-0.65,0.513-0.676,1.268-0.891-0.22-0.531z'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 900 600'%3E %3Crect width='900' height='600' fill='%23d7141a'/%3E %3Crect width='900' height='300' fill='%23fff'/%3E %3Cpath d='M 450,300 0,0 V 600 z' fill='%2311457e'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 5 3'%3E %3Cdesc%3EFlag of Germany%3C/desc%3E %3Crect id='black_stripe' width='5' height='3' y='0' x='0' fill='%23000'/%3E %3Crect id='red_stripe' width='5' height='2' y='1' x='0' fill='%23D00'/%3E %3Crect id='gold_stripe' width='5' height='1' y='2' x='0' fill='%23FFCE00'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 15 10'%3E %3Crect width='15' height='10' id='blue' style='fill:%236ab2e7'/%3E %3Crect width='15' height='5' y='5' id='green' style='fill:%2312ad2b'/%3E %3Cpath d='M 0,0 0,5 0,10 4.330127,7.5 8.660254,5 4.330127,2.5 0,0 z' id='path6904' style='fill:%23fff'/%3E %3Cpath d='m 3.3143278,3.75 0.3102707,0.954915 1.0040571,0 L 3.8163564,5.295085 4.126627,6.25 3.3143278,5.65983 2.5020286,6.25 2.8122992,5.295085 2,4.704915 l 1.004057,0 L 3.3143278,3.75 z' id='path6929' style='fill:%23d7141a'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 370 280'%3E %3Crect width='370' height='280' fill='%23c60c30'/%3E %3Crect width='40' height='280' x='120' fill='%23fff'/%3E %3Crect width='370' height='40' y='120' fill='%23fff'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 1200 600'%3E %3Ctitle%3EFlag of Dominica%3C/title%3E %3Crect height='600' width='1200' fill='%23006b3f'/%3E %3Crect width='75' height='600' x='525' fill='%23fcd116'/%3E %3Crect width='1200' height='75' y='225' fill='%23fcd116'/%3E %3Crect width='75' height='600' x='600' fill='%23fff'/%3E %3Crect width='1200' height='75' y='300' fill='%23fff'/%3E %3Crect width='50' height='600' x='575' fill='%23000'/%3E %3Crect width='1200' height='50' y='275' fill='%23000'/%3E %3Cg fill='%23006b3f' transform='translate(600,300)'%3E %3Ccircle r='150' fill='%23d41c30'/%3E %3Cg id='star2'%3E %3Cpath id='star' stroke='%23000' d='m-4.81,-118.41 4.81,-13.72 4.37,13.5 14.65,0.22 -11.59,8.85 5.25,15.05 -12.68,-9.29 -12.46,8.85 4.81,-14.61 -11.37,-8.63 14.21,-0.22z'/%3E %3Cuse xlink:href='%23star' transform='rotate(180)'/%3E %3C/g%3E %3Cuse xlink:href='%23star2' transform='rotate(36)'/%3E %3Cuse xlink:href='%23star2' transform='rotate(72)'/%3E %3Cuse xlink:href='%23star2' transform='rotate(108)'/%3E %3Cuse xlink:href='%23star2' transform='rotate(144)'/%3E %3Cg stroke='%23000' stroke-width='2.5'%3E %3Cellipse cx='680.21' cy='586.13' rx='30.805' ry='189.82' transform='matrix(0.289553,-0.03018225,0.01658794,0.23225804,-186.11735,-75.926206)'/%3E %3Cellipse cx='680.21' cy='586.13' rx='30.805' ry='189.82' transform='matrix(0.30625538,-0.03184484,0.01668502,0.23224838,-188.73313,-74.886801)'/%3E %3Cellipse cx='680.21' cy='586.13' rx='30.805' ry='189.82' transform='matrix(0.24500433,-0.0258909,0.01789798,0.25675005,-151.94706,-90.935577)'/%3E %3Cpath fill='%239c4a00' stroke-width='0.6573' d='m-44.213085,62.564681c7.657331,-0.318514 4.332103,-4.415732 8.199242,-6.595651 3.864538,-2.177268 9.365358,-0.736785 11.015564,1.985834 1.650207,2.72262 0.327013,5.396731 2.450471,5.433299 2.12601,0.03661 59.928115,-2.387638 62.010231,-0.105265 2.084719,2.27972 2.428307,6.775972 0.269442,8.524141 -2.159263,1.769736 -75.234738,2.587907 -77.751167,0.737649 -2.516925,-1.823297 -6.202071,-9.529768 -6.193783,-9.980007z'/%3E %3Cpath fill='%23fcd116' stroke-width='0.6326' d='M-3.3768912,68.194919C-3.5157446,73.97045 5.0266835,72.334565 5.1440072,77.158287 4.886691,82.271863 -9.1802916,77.470843 -9.3156063,68.11661 -8.7307374,58.771874 5.0382371,54.154377 5.208533,59.491796c0.1266662,4.435124 -8.4465709,2.927591 -8.5854242,8.703123z'/%3E %3Cpath fill='%23fcd116' stroke-width='0.6326' d='M1.6637058,68.261384C1.5248524,74.036915 10.067281,72.40103 10.184604,77.224752 9.927288,82.338328 -4.1396946,77.537308 -4.2750093,68.183075 -3.6901404,58.838339 10.078834,54.220842 10.24913,59.558261c0.126666,4.435124 -8.4465709,2.927591 -8.5854242,8.703123z'/%3E %3Cpath fill='%23fcd116' stroke-width='0.6326' d='M7.0709208,68.057753C6.9320674,73.833284 15.474496,72.197399 15.591819,77.021121 15.334503,82.134697 1.2675204,77.333677 1.1322057,67.979444 1.7170746,58.634708 15.486049,54.017211 15.656345,59.35463c0.126666,4.435124 -8.4465709,2.927591 -8.5854242,8.703123z'/%3E %3Cpath fill='%23fcd116' stroke-width='0.6326' d='m12.111394,68.124255c-0.138854,5.775532 8.403575,4.139646 8.520898,8.963369C20.374976,82.2012 6.3079934,77.40018 6.1726787,68.045947 6.7575476,58.701211 20.526522,54.083714 20.696818,59.421133c0.126666,4.435124 -8.446571,2.927591 -8.585424,8.703122z'/%3E %3Cellipse fill='%239c4a00' stroke-width='0.3991' cx='478.38' cy='-41.085999' rx='3.5339' ry='3.4030001' transform='matrix(1.3799165,0.02078085,-0.03061721,1.4544413,-625.22695,117.20523)'/%3E %3Cellipse cx='427.11' cy='905' rx='20.814' ry='24.144' transform='matrix(0.20742248,-0.03129182,0.04226118,0.39513675,-119.97806,-293.41566)'/%3E %3Cellipse cx='427.11' cy='905' rx='20.814' ry='24.144' transform='matrix(0.20742248,-0.03129182,0.04226118,0.39513675,-127.33463,-293.99555)'/%3E %3Cellipse cx='427.11' cy='905' rx='20.814' ry='24.144' transform='matrix(0.20742248,-0.0312918,0.04226106,0.39513549,-132.603,-303.41129)'/%3E %3Cellipse cx='427.11' cy='905' rx='20.814' ry='24.144' transform='matrix(0.19942957,-0.0315355,0.04632234,0.43592867,-125.4075,-340.63478)'/%3E %3Cellipse cx='427.11' cy='905' rx='20.814' ry='24.144' transform='matrix(0.19950028,-0.03083913,0.04356143,0.40873864,-112.65072,-316.23218)'/%3E %3Cellipse cx='427.11' cy='905' rx='20.814' ry='24.144' transform='matrix(0.19950028,-0.03083913,0.04356143,0.40873864,-118.30405,-319.63879)'/%3E %3Cellipse cx='427.11' cy='905' rx='20.814' ry='24.144' transform='matrix(0.19950028,-0.03083913,0.04356143,0.40873864,-125.43742,-324.55362)'/%3E %3Cellipse cx='427.11' cy='905' rx='20.814' ry='24.144' transform='matrix(0.19950028,-0.03083913,0.04356143,0.40873864,-132.04249,-327.53171)'/%3E %3Cpath fill='%239461c9' stroke-width='0.5749' d='m-14.73408,-52.686013c0,0 -14.655341,12.719161 -13.010831,47.1436528 1.845436,34.6199222 32.3934914,50.8943372 32.3934914,50.8943372 0,0 7.7859806,-9.826932 6.8819576,-37.6434978C9.3473299,-32.960001 -5.0778778,-50.928723 -5.0778778,-50.928723l-9.6562022,-1.75729z'/%3E %3Cellipse cx='427.11' cy='905' rx='20.814' ry='24.144' transform='matrix(0.20967854,0.00617733,-0.02883923,0.39634241,-45.183498,-309.40147)'/%3E %3Cellipse cx='427.11' cy='905' rx='20.814' ry='24.144' transform='matrix(0.20967854,0.00617733,-0.02883923,0.39634241,-52.318928,-311.28321)'/%3E %3Cellipse cx='427.11' cy='905' rx='20.814' ry='24.144' transform='matrix(0.20967854,0.00617736,-0.02883913,0.39634115,-55.824816,-321.48715)'/%3E %3Cellipse cx='427.11' cy='905' rx='20.814' ry='24.144' transform='matrix(0.20185704,0.00451301,-0.03211329,0.43720504,-42.110313,-356.83224)'/%3E %3Cellipse cx='427.11' cy='905' rx='20.814' ry='24.144' transform='matrix(0.2018025,0.00521083,-0.02998402,0.40995827,-33.906971,-330.54675)'/%3E %3Cellipse cx='427.11' cy='905' rx='20.814' ry='24.144' transform='matrix(0.2018025,0.00521083,-0.02998402,0.40995827,-38.862639,-334.90639)'/%3E %3Cellipse cx='427.11' cy='905' rx='20.814' ry='24.144' transform='matrix(0.2018025,0.00521083,-0.02998402,0.40995827,-45.005838,-341.01389)'/%3E %3Cellipse cx='427.11' cy='905' rx='20.814' ry='24.144' transform='matrix(0.2018025,0.00521083,-0.02998402,0.40995827,-50.974388,-345.12149)'/%3E %3Cellipse fill='%23d41c30' stroke-width='1pt' cx='624.42' cy='606.11' rx='58.28' ry='186.49' transform='matrix(0.19786701,-0.07643491,0.08023488,0.18709671,-155.83813,-59.21337)'/%3E %3Cellipse stroke-width='1.4635' cx='218.13' cy='356.75' rx='10.823' ry='12.905' transform='matrix(0.49827764,0.00887179,-0.00656928,0.3689586,-99.510833,-162.76931)'/%3E %3Cellipse stroke-width='1.5462' cx='218.13' cy='356.75' rx='10.823' ry='12.905' transform='matrix(0.44637456,0.00794766,-0.00656928,0.3689586,-84.135444,-169.29958)'/%3E %3Cellipse stroke-width='1.5462' cx='218.13' cy='356.75' rx='10.823' ry='12.905' transform='matrix(0.44637456,0.00794766,-0.00656928,0.3689586,-90.652069,-169.41561)'/%3E %3Cellipse stroke-width='1.56' cx='218.13' cy='356.75' rx='10.823' ry='12.905' transform='matrix(0.46713655,0.00831733,-0.00616707,0.34636886,-93.887858,-166.3691)'/%3E %3Cellipse stroke-width='1.56' cx='218.13' cy='356.75' rx='10.823' ry='12.905' transform='matrix(0.46713655,0.00831733,-0.00616707,0.34636886,-94.461639,-172.01688)'/%3E %3Cellipse stroke-width='1.5462' cx='218.13' cy='356.75' rx='10.823' ry='12.905' transform='matrix(0.44637456,0.00794766,-0.00656928,0.3689586,-96.8782,-173.22007)'/%3E %3Cellipse stroke-width='1.5623' cx='218.13' cy='356.75' rx='10.823' ry='12.905' transform='matrix(0.44637456,0.00794766,-0.0064352,0.36142827,-95.468785,-176.63136)'/%3E %3Cellipse stroke-width='1.4635' cx='218.13' cy='356.75' rx='10.823' ry='12.905' transform='matrix(0.49827764,0.00887179,-0.00656928,0.3689586,-114.72518,-179.36983)'/%3E %3Cellipse stroke-width='1.56' cx='218.13' cy='356.75' rx='10.823' ry='12.905' transform='matrix(0.46713655,0.00831733,-0.00616707,0.34636886,-98.157196,-179.08115)'/%3E %3Cellipse stroke-width='1.5623' cx='218.13' cy='356.75' rx='10.823' ry='12.905' transform='matrix(0.44637456,0.00794766,-0.0064352,0.36142827,-100.2913,-183.52126)'/%3E %3Cellipse stroke-width='1.5462' cx='218.13' cy='356.75' rx='10.823' ry='12.905' transform='matrix(0.44637456,0.00794766,-0.00656928,0.3689586,-110.48856,-178.90566)'/%3E %3Cellipse stroke-width='1.5623' cx='218.13' cy='356.75' rx='10.823' ry='12.905' transform='matrix(0.44637456,0.00794766,-0.0064352,0.36142827,-108.8569,-179.77161)'/%3E %3Cellipse stroke-width='1.5623' cx='218.13' cy='356.75' rx='10.823' ry='12.905' transform='matrix(0.44637456,0.00794766,-0.0064352,0.36142827,-106.80676,-183.69602)'/%3E %3Cellipse stroke-width='2.5449' cx='528.68' cy='564.48' rx='67.438' ry='205.64' transform='matrix(0.21931516,-0.07742835,0.08682875,0.20202384,-145.01539,-72.55561)'/%3E %3Cellipse cx='528.68' cy='646.07' rx='13.321' ry='40.796' transform='matrix(0.20574399,-0.0978521,0.09471329,0.21196041,-137.12211,-77.403485)'/%3E %3Cpath stroke-width='0.5749' d='M31.462582,7.798675C44.273286,23.396889 42.655575,33.30197 41.319929,41.68219 37.295042,32.018935 35.09747,25.935914 22.284544,10.334996 9.4716187,-5.2659225 15.867064,-16.212552 16.746886,-21.981169c1.926581,4.993077 1.90277,14.1789256 14.715696,29.779844z'/%3E %3Cpath stroke-width='0.5749' d='M32.616052,20.397765C45.426756,35.995979 43.809045,45.90106 42.473399,54.28128 38.448512,44.618025 36.25094,38.535004 23.438014,22.934086 10.625089,7.3331675 17.020534,-3.6134618 17.900356,-9.382079c1.926581,4.993077 1.90277,14.1789256 14.715696,29.779844z'/%3E %3Cpath stroke-width='0.5749' d='M33.001502,30.545466C46.121623,45.867895 44.702257,55.805012 43.534416,64.211635 39.317096,54.636146 36.998322,48.601234 23.875927,33.276148 10.753531,17.951062 16.928895,6.8711542 17.693213,1.0852029 19.719255,6.0361835 19.879107,15.22038 33.001502,30.545466z'/%3E %3Cellipse stroke-width='1.3887' cx='528.68' cy='646.07' rx='13.321' ry='40.796' transform='matrix(0.40784061,-0.1037946,0.16693789,0.37767112,-299.57061,-196.0302)'/%3E %3Cellipse stroke-width='1.6398' cx='528.68' cy='646.07' rx='13.321' ry='40.796' transform='matrix(0.36689221,-0.0631048,0.12978287,0.31264984,-259.00282,-166.87124)'/%3E %3Cellipse stroke-width='1.6398' cx='528.68' cy='646.07' rx='13.321' ry='40.796' transform='matrix(0.36814797,-0.0553158,0.1232589,0.31530969,-261.52366,-166.81962)'/%3E %3Cellipse stroke-width='2.0966' cx='528.68' cy='646.07' rx='13.321' ry='40.796' transform='matrix(0.29657862,-0.05431058,0.11151259,0.23307633,-211.06958,-135.53834)'/%3E %3Cellipse stroke-width='2.0966' cx='528.68' cy='646.07' rx='13.321' ry='40.796' transform='matrix(0.29951522,-0.03800069,0.09680807,0.23872917,-208.27027,-143.86531)'/%3E %3Cpath stroke-width='0.5749' d='M8.6195396,-15.767835C12.407426,-6.5127711 13.940854,1.8088668 12.039861,2.8095164 10.141163,3.8089573 5.5266551,-2.8908549 1.7387689,-12.145919'/%3E %3Cellipse stroke-width='2.0966' cx='528.68' cy='646.07' rx='13.321' ry='40.796' transform='matrix(0.29951522,-0.03800069,0.09680807,0.23872917,-208.89375,-154.73721)'/%3E %3Cellipse stroke-width='2.0966' cx='528.68' cy='646.07' rx='13.321' ry='40.796' transform='matrix(0.30032211,-0.03210428,0.09144035,0.24056268,-212.194,-155.98718)'/%3E %3Cpath stroke-width='0.5749' d='m2.0257453,-28.338145c3.6779608,6.253928 5.6581289,12.09375 4.4184823,13.037247 -1.2381494,0.942356 -5.2275031,-3.368272 -8.9054639,-9.622201'/%3E %3Cpath stroke-width='0.5749' d='m4.5726443,-32.485105c3.6779608,6.253928 5.6581287,12.09375 4.4184823,13.037247 -1.2381494,0.942356 -5.2275031,-3.368272 -8.9054639,-9.622201'/%3E %3Cpath stroke-width='0.5749' d='m16.013433,-31.606808c5.124964,8.542601 7.882604,16.520579 6.153303,17.810625 -1.727212,1.288488 -7.287655,-4.598619 -12.4126197,-13.14122'/%3E %3Cpath stroke-width='0.5749' d='m8.4524006,-36.082328c3.6926974,6.904591 5.6865404,13.348237 4.4490124,14.385262 -1.236034,1.035772 -5.2356299,-3.727092 -8.9283268,-10.631682'/%3E %3Cpath fill='%239461c9' stroke-width='0.5905' d='m8.1245845,-46.086178c-2.4652011,2.482234 -0.05083,7.123595 2.2055225,8.801039 2.530629,2.294221 16.742134,17.286089 26.768781,4.672222C29.06535,-32.759025 14.072204,-51.617449 8.1245845,-46.086178z'/%3E %3Cpath fill='%239461c9' stroke-width='0.5905' d='m6.3689905,-53.485518c-2.4652011,2.482234 -0.05083,7.123595 2.2055226,8.801039 2.5306289,2.294221 16.7421339,17.286089 26.7687809,4.672222C27.309756,-40.158365 12.31661,-59.016789 6.3689905,-53.485518z'/%3E %3Cpath fill='%239461c9' stroke-width='0.5905' d='m4.1226915,-60.575768c-2.4652011,2.482234 -0.05083,7.123595 2.2055226,8.801039 2.5306294,2.294221 16.7421339,17.286089 26.7687809,4.672222 -8.033538,-0.146108 -23.026684,-19.004532 -28.9743035,-13.473261z'/%3E %3Cpath fill='%239461c9' stroke-width='0.5905' d='m-0.75854747,-68.686568c-2.46520113,2.482234 -0.0508299,7.123595 2.20552257,8.801039 2.5306294,2.294221 16.7421339,17.286089 26.7687809,4.672222 -8.033538,-0.146108 -23.0266836,-19.004532 -28.97430347,-13.473261z'/%3E %3Cpath fill='%239461c9' stroke-width='0.6276' d='m-18.271949,-76.448224c5.080302,-3.778951 14.4116525,-4.884005 21.6814205,-1.183186 6.0553769,2.966807 16.1473035,15.072925 23.7340285,17.934947 -5.339994,0.952539 -8.588551,0.147731 -12.001308,-1.491593 -6.7388646,4.879721 -9.1401688,5.611298 -16.00788077,6.570161 -9.55160223,1.377954 -17.47968323,-1.108557 -20.26606523,-6.089426 -2.839252,-4.699505 -1.61543,-12.238734 2.859805,-15.740903z'/%3E %3Cellipse fill='%23d41c30' cx='287.23' cy='323.04' rx='14.154' ry='14.986' transform='matrix(0.30909157,0.00550335,-0.00301489,0.16932914,-95.304017,-125.19072)'/%3E %3Cellipse fill='%23fcd116' cx='204.58' cy='348.26' rx='23.254' ry='15.895' transform='matrix(0.24579207,-0.09143683,0.08132205,0.2192462,-99.445497,-116.289)'/%3E %3Cellipse fill='%23000' stroke='none' cx='283.9' cy='333.86' rx='5.828' ry='5.8279' transform='matrix(0.26990081,0.00480556,-0.00415607,0.23342269,-82.956029,-148.37388)'/%3E %3Cpath fill='%23fcd116' stroke-width='0.7318' d='m-17.127905,-65.514747c0.402078,1.948925 -1.043505,4.582316 -4.180015,5.515002 -3.195207,1.322722 -5.618416,4.322017 -7.016075,9.226342 -4.855803,-11.183796 -1.769609,-15.915544 3.387899,-17.06567 4.436579,-1.414945 7.11029,-1.235679 7.808191,2.324326z'/%3E %3Cellipse fill='%23000' stroke='none' cx='198.98' cy='362.39' rx='4.7097' ry='4.7097' transform='matrix(0.23597119,-0.0123552,0.01333585,0.24161486,-73.600709,-149.7658)'/%3E %3C/g%3E %3C/g%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 750 500'%3E %3Cpath fill='%23fff' d='M0 0h750v500H0z'/%3E %3Cpath fill='%23002d62' d='M0 0h325v200H0z'/%3E %3Cpath fill='%23ce1126' d='M0 300h325v200H0z'/%3E %3Cpath fill='%23002d62' d='M425 300h325v200H425z'/%3E %3Cpath fill='%23ce1126' d='M425 0h325v200H425z'/%3E %3Cg transform='matrix(.8 0 0 .8 -25 0)'%3E %3Cpath fill='%23fff' d='M474.5 281.05c.07.43.03 36.78.03 40.54 0 3.6.04 5.87 1.75 8.15 1.41 1.97 3.77 3.6 6.08 4.13 1.63.33 7.63.2 9.72.2 4.63-.22 5.19.81 6.94 3.1 2-3.21 4.19-3.26 8.29-3.1 2.08 0 6.55.17 8.41-.23a9.4 9.4 0 0 0 5.38-3.36c2.35-2.7 2.22-6.06 2.22-9.59v-38.31c0-1.73-.2-1.3.68-2.2l5.78-6.06-61.67.04 6.39 6.69z'/%3E %3Cpath fill='%23002d62' d='M493.76 299.09v-24.77h-25.5l6.32 6.7.06 18.07z'/%3E %3Cpath fill='%23ce1126' d='M503.98 299.09v-24.77h25.99l-6.64 7.11v17.66zM493.76 309.32h-19.3l-.06 15.6c.88 6.82 5.92 9.14 10.44 9.11 3.06.04 4.1-.02 8.92-.05z'/%3E %3Cpath fill='%23002d62' d='M503.98 309.32h19.42l-.06 15.6c-.46 6.76-5.92 9.14-10.44 9.11l-8.92-.05z'/%3E %3Cpath fill='none' stroke='%23000' stroke-width='.45' d='M474.61 281.05c.07.43.03 36.78.03 40.54 0 3.6 0 5.79 1.8 8.32a9.23 9.23 0 0 0 6.03 3.96c1.63.33 7.63.2 9.72.2 2.67 0 3.91-.13 5.7 1.67.56.53.69.8 1.11 1.46.23-.17.23-.2.36-.43a5.27 5.27 0 0 1 2.68-2.33c1.4-.57 3.75-.37 5.38-.37 2.08 0 6.55.17 8.41-.23a10.63 10.63 0 0 0 5.38-3.36c2.35-2.7 2.22-6.06 2.22-9.59v-38.31c0-1.73-.2-1.3.68-2.2l5.78-6.06-61.67.04 6.39 6.69z'/%3E %3Cpath fill='%23eac102' stroke='%23000' stroke-width='.27' d='M497.92 280.41v2.77h-2.8v2.35h2.8v9.93h2.3v-9.93h2.84v-2.35h-2.84v-2.77z'/%3E %3Cg id='a'%3E %3Cpath fill='%23fff' d='M481.88 284.06l.03 4.53-1.91-1.93.28 31.93c0 4.76 3.43 8.6 7.66 8.6 4.19 0 7.6-3.79 7.65-8.5l-.31-16.44-2.06-2.13-.03-1.68z'/%3E %3Cpath fill='%23002d62' d='M481.88 284.22l.03 4.56-1.91-1.94.16 18.19 8.25 7.85.06-17.41-.31-.35v-2.93l-6.28-7.97z'/%3E %3Cpath fill='%23ce1126' d='M490.77 295.51l2.42 3.08.02 1.04-2.45-2.5zM495.3 302.42l.22 11.44c-1.18 2.21-3.57 1.01-3.57 1.01l.08-15.79z'/%3E %3Cpath fill='%23002d62' d='M495.55 319.64c-3.13 2.34-4-1.13-4-1.13a4.42 4.42 0 0 0 3.98-2.98z'/%3E %3Cpath fill='%23ce1126' d='M480.21 309.72c4.3 4.87 7.96 7.5 7.96 7.5.97 7.67 5.5 5.12 7.14 3.93-.92 3.6-3.87 6.22-7.36 6.22-4.23 0-7.66-3.86-7.66-8.62z'/%3E %3Cpath fill='none' stroke='%23000' stroke-width='.26' d='M493.2 299.63l-.02-1.16-11.32-14.38.03 3.96z'/%3E %3Cpath fill='none' stroke='%23000' stroke-width='.32' d='M480 286.66l.3 31.92c0 4.76 3.42 8.62 7.65 8.62 4.2 0 7.6-3.8 7.65-8.51l-.3-16.44z'/%3E %3Cg fill='%23eac102' stroke='%23000' stroke-width='.06'%3E %3Cpath d='M486.17 281.23c-.78-1.46-.62-2.08-.08-2.64l-2.93-3 .81 4.2c.84-.22 1.43 0 2.2 1.44zM483.15 275.58l3 5.62'/%3E %3Cpath d='M498.07 300.74l-.76.3-11.93-20.43.7-.4z'/%3E %3Cpath d='M484.98 280.59c-.1-.19.1-.5.47-.7.36-.21.73-.22.84-.03.1.19-.11.5-.47.7-.36.2-.74.22-.84.03zM481.02 282.22c-.95-1.34-.88-1.99-.41-2.6l-3.3-2.6 1.35 4.05c.8-.32 1.41-.18 2.36 1.15zM477.32 277.02l3.69 5.18'/%3E %3Cpath d='M495.28 300.01l-.72.39-14.4-18.68.65-.49z'/%3E %3Cpath d='M479.76 281.75c-.13-.17.04-.52.38-.76.33-.25.7-.31.82-.14.13.18-.04.52-.37.77-.33.24-.7.3-.83.13zM480.18 286.36c-1.1-1.22-1.1-1.87-.7-2.54l-3.55-2.2 1.78 3.87c.76-.4 1.38-.35 2.47.87zM475.93 281.61l4.24 4.72'/%3E %3Cpath d='M495.66 302.86l-16.38-16.9.59-.56 16.46 16.99z'/%3E %3Cpath d='M478.88 286.03c-.14-.16-.01-.52.29-.8.3-.29.66-.39.8-.23.15.16.02.52-.28.8-.3.29-.67.39-.81.23z'/%3E %3C/g%3E %3C/g%3E %3Cuse xlink:href='%23a' transform='matrix(-1 0 0 1 998.26 0)'/%3E %3Cg stroke='%23000' stroke-width='.24'%3E %3Cpath fill='%23ce1126' d='M496.73 314.54l-.63 10.1c-.64-.05-1.88-.16-1.97-.98-.06-.46 1.26-8.73 1.3-9.53.45.12.9.32 1.3.41z'/%3E %3Cpath fill='%23002d62' d='M495.77 314.12c-.06.4-.28 2.8-.22 3.1.19.97 1.38.82 2.04.86l.13-5.18c-.22.21-1.7 1.11-1.95 1.22z'/%3E %3Cpath fill='%23002d62' d='M495.88 327.04c1.66-2.08 4.78-.54 4.78-.54 3.42.77 2.57-3.13 2.57-3.13-.7-7.8-1.52-13.15-1.52-13.15l-4.99 3.34z'/%3E %3Cpath fill='%23002d62' stroke-width='.19' d='M495.86 327.17c-.36 2.32 1.96 1.98 1.96 1.98 2.76-.04 1.97-2.96 1.97-2.96-2.96-.85-3.93.98-3.93.98z'/%3E %3Cpath fill='%23ce1126' d='M497.83 312.74c-.17 8.07-.25 8.9-.25 8.9.12 2.2 2.54 1.01 2.54 1.01.57-.24 1.2-.06 1.2-.06l-.11-2.75c4.02-.3 3.09-2.64 3.09-2.64-1.64-7.62-1.75-7.29-1.75-7.29z'/%3E %3Cpath fill='none' stroke-width='.23' d='M501.31 319.81c-2.54-.04-3.57.96-3.57.96l-.1.22'/%3E %3Cpath fill='%23fff' stroke-width='.21' d='M500.99 326.45l-.88-15.2 1.76-1.17 1.51 14.22v.15c0 2.64-2.39 2-2.39 2z'/%3E %3C/g%3E %3Cg fill='%23fff' stroke='%23000'%3E %3Cpath fill='%23000' stroke-width='.04' d='M488.23 302.2l6.79 12.45 14.63-9.71-7.62-11.25z'/%3E %3Cpath stroke-width='.27' d='M488.49 302.1l13.75-8.01 7.52 10.82-14.53 9.35z'/%3E %3Cpath fill='%23000' stroke-width='.04' d='M495.43 313.53l13.7-8.82-1.06-1.69-6.86-9.32-4.96 4-6.33 3.52-1.12-.7.22 1.5z'/%3E %3Cpath stroke-width='.15' d='M496.18 297.77c-2.03-.96-4.38 2.07-5.06 2.67-.68.6-2.04.24-2.04.24l6.18 11.08c1.82.72 3-1.61 3.85-2.33 1.55-1.33 3.37-1.23 3.37-1.23z'/%3E %3Cpath stroke-width='.15' d='M496.36 297.88c0-2.38 2.95-3.14 3.74-3.56.78-.42 1.03-1.9 1.03-1.9l6.93 10.56c-.13 2.08-2.6 2.29-3.55 2.83-1.76.98-2 2.5-2 2.5z'/%3E %3Cpath stroke-width='.1' d='M495.02 311.82c-3.95-7.24-6.13-11.02-6.13-11.02-.1 1.33-.02 1.25-.02 1.25a128.3 128.3 0 0 1 6.5 11.4l-.35-1.63z'/%3E %3Cg fill='%23000' stroke='none'%3E %3Cpath d='M490.87 302.2l.11.19c.03-.02.06-.05.06-.1 0-.02-.03-.06-.02-.08l.02.03.13.2c-.02.03-.03-.03-.06-.03-.03-.03-.09-.03-.1 0l.1.17c.01.02.04 0 .06-.01.06-.03.1-.09.1-.15.02-.03-.02-.07.01-.09l.07.16-.39.25c-.01-.02 0-.02.01-.03.04-.02.03-.07 0-.1l-.2-.31c0-.04-.05-.03-.08 0v-.03l.37-.23.08.14c-.03.02-.04-.04-.07-.04-.05-.03-.1 0-.14.02l-.06.04zM491.27 301.92l.24.4c.01.03.05.04.07.02v.02l-.16.1c-.02-.02.03-.03.01-.06-.01-.04-.04-.07-.06-.1l-.16-.26a.04.04 0 0 0-.06-.03V302l.12-.08zM491.79 301.56l.1.15c-.03.02-.04-.03-.07-.03-.05-.04-.14-.04-.18.02-.03.03-.02.1.03.1.06.02.12 0 .18 0 .05 0 .12 0 .16.05.05.05.05.14.02.2-.04.06-.11.1-.18.1-.04 0-.04.04-.05.06l-.01-.01-.1-.15c.02-.03.04.02.06.03.06.04.15.05.2 0 .05-.03.05-.11 0-.13-.06-.03-.12 0-.18 0s-.13-.01-.17-.06c-.05-.07-.04-.17.02-.22a.21.21 0 0 1 .13-.05c.04 0 .04-.03.03-.05l.01-.01zM492.3 301.83c-.01.05-.04.1-.08.12-.04.02-.1 0-.1-.05-.01-.05.02-.1.04-.15.01-.02.04-.05.04-.08l-.04-.07c-.04-.02-.1.02-.09.06.03.01.07.02.06.05 0 .05-.06.07-.1.04-.03-.04 0-.1.02-.13a.22.22 0 0 1 .13-.08c.05-.01.09.02.1.06l.1.16c.01.02.05.01.04-.01.03 0 .01.03.01.04-.01.04-.05.07-.1.07a.08.08 0 0 1-.03-.03zm-.01-.02l-.07-.11c-.02.04-.04.08-.02.12 0 .05.07.04.08 0v-.01zM492.43 301.37l.02.04c.01-.05.04-.1.09-.12.04-.02.1.01.11.05l.12.19c0 .02.04.02.05.01v.02l-.15.1c-.02-.03.02-.04 0-.06-.01-.05-.04-.09-.07-.13-.02-.03-.03-.07-.06-.1-.04-.03-.07.04-.06.08l.1.18c.02.02.05.03.07.02l-.01.02-.15.1c-.02-.03.03-.04.01-.07l-.08-.14-.07-.1c0-.02-.04.02-.05-.01l.13-.08zM492.74 301.02l.07.11.07-.04.02.03-.07.05.13.2c.01.04.06.04.06 0 0-.01 0-.03.02-.03.01.05-.01.11-.06.13-.05.02-.1 0-.12-.05l-.12-.2-.04.03c-.02-.02 0-.04 0-.06a.45.45 0 0 0 .03-.16h.01zM493.05 300.97a.16.16 0 0 1 .18 0c.06.04.1.11.1.18 0 .06-.02.12-.07.15a.15.15 0 0 1-.15.02.22.22 0 0 1-.12-.28.16.16 0 0 1 .06-.07zm.02.02c-.05.03-.01.09 0 .12l.1.16c.04.04.1 0 .1-.04l-.06-.11-.08-.12c-.02-.01-.04-.02-.06 0zM491.4 303.06l.11.19c.03-.02.06-.05.06-.1 0-.02-.03-.06-.02-.08l.02.03.13.2c-.02.03-.03-.03-.06-.03-.03-.03-.09-.03-.1 0l.1.17c.01.02.04 0 .06-.01.06-.03.1-.09.1-.15.02-.03-.02-.07.01-.09l.07.16-.39.25c-.01-.02 0-.02.01-.03.04-.02.03-.07 0-.1l-.2-.31c0-.04-.05-.03-.08 0v-.03l.37-.23.08.14c-.03.02-.04-.04-.07-.04-.05-.03-.1 0-.14.02l-.06.04zM492.1 303.24c-.1-.06-.18-.13-.27-.2-.03 0-.05-.02-.08-.01V303l.16-.1v.02c-.03.04.02.06.04.08l.12.08-.03-.17c0-.03-.03-.06-.06-.04v-.01l.1-.06c.01.02-.02.03-.02.05l.02.13.04.24-.02.01zM492.43 302.94c-.01.05-.04.1-.08.12-.04.02-.1 0-.1-.05-.01-.05.02-.1.04-.15.01-.02.04-.05.04-.08l-.04-.07c-.04-.02-.1.02-.09.06.03.01.07.02.06.05 0 .05-.06.07-.1.04-.03-.04 0-.1.02-.13a.22.22 0 0 1 .13-.08c.05-.01.09.02.1.06l.1.16c.01.02.05.01.04-.01.03 0 .01.03 0 .04 0 .04-.04.07-.08.07a.07.07 0 0 1-.04-.03zm-.01-.02l-.07-.11c-.02.04-.04.08-.02.12 0 .05.07.04.08 0v-.01zM492.57 302.49l.02.04c.01-.05.04-.1.09-.12.04-.02.1.01.11.05l.12.19c0 .02.04.02.05.01v.02l-.15.1c-.02-.03.03-.04 0-.06-.01-.05-.04-.09-.07-.13-.02-.03-.03-.07-.06-.1-.04-.03-.07.04-.06.08l.1.18c.02.02.05.03.07.03l-.01.01-.15.1c-.02-.03.03-.04.01-.07l-.08-.14-.07-.1c0-.02-.04.02-.05-.01l.13-.08zM493.02 302.21l.1-.07.03.04-.06.04c.06 0 .1.08.08.13a.18.18 0 0 1-.1.12c-.05.02-.03.1.02.07.06-.03.1-.07.17-.08.04-.01.08.02.1.06 0 .05-.02.1-.06.14a.37.37 0 0 1-.17.1c-.05 0-.1-.05-.06-.1.01 0 .03-.02 0-.01a.07.07 0 0 1-.07-.07c0-.03.01-.07.03-.1-.04.02-.1.01-.13-.03-.05-.05-.04-.14.01-.18a.2.2 0 0 1 .11-.06zm-.05.04c-.04.03-.02.08 0 .11.02.04.04.09.1.09.03 0 .04-.06.02-.09a.28.28 0 0 0-.08-.1.04.04 0 0 0-.04 0zm.2.37c-.04 0-.08.06-.03.08.04.02.08-.01.11-.04.04-.02.09-.06.05-.1-.04-.02-.08.02-.12.04l-.02.02zM493.5 302.08l-.17.1c.03.05.07.09.12.1.05 0 .08-.05.08-.1 0-.01 0-.02.02-.02v.03c0 .05-.01.1-.05.13-.04.04-.1.06-.15.03a.25.25 0 0 1-.13-.15c-.02-.07 0-.16.07-.2.05-.03.12-.02.16.03a.3.3 0 0 1 .05.05zm-.1.03c-.02-.03-.04-.08-.08-.09-.05 0-.05.06-.03.1l.02.05.1-.06zM493.49 301.7l.24.4c.01.03.05.04.07.02v.02l-.16.1c-.02-.02.03-.03.01-.06-.01-.04-.04-.07-.06-.1l-.16-.26a.04.04 0 0 0-.06-.03v-.01l.12-.08zM493.62 301.59c.03-.02.08 0 .09.04.01.04-.02.08-.07.07-.04 0-.06-.06-.04-.1l.02-.01zm.14.12l.16.26c0 .03.04.04.06.02v.02l-.16.1c-.02-.02.03-.03.02-.05l-.05-.1-.1-.14c0-.03-.04-.02-.05-.01v-.02l.12-.08zM493.97 301.58a.16.16 0 0 1 .18 0c.06.05.1.12.1.2 0 .05-.03.1-.08.13a.15.15 0 0 1-.15.01.22.22 0 0 1-.11-.27.16.16 0 0 1 .06-.07zm.02.02c-.05.03-.01.09 0 .12l.1.16c.04.04.1 0 .1-.04l-.06-.11-.08-.12c-.02-.01-.05-.02-.06 0zM492.04 303.81l.1.15c-.03.02-.04-.03-.07-.03-.05-.04-.14-.04-.18.02-.03.03-.02.1.03.1.06.02.12 0 .18 0 .05 0 .12 0 .16.05.05.05.05.13.02.2-.04.06-.11.1-.18.1-.04 0-.04.04-.05.06l-.01-.01-.1-.15c.02-.03.04.02.06.03.06.04.15.05.2 0 .05-.03.05-.11 0-.13-.06-.03-.12 0-.18 0s-.13-.01-.17-.06c-.06-.07-.04-.17.03-.22a.22.22 0 0 1 .12-.05c.04 0 .04-.03.03-.05l.01-.01zM492.57 303.89l-.17.1c.03.05.07.09.12.1.05 0 .08-.05.08-.1 0-.01 0-.02.02-.02v.03c0 .05-.01.1-.05.13-.04.04-.1.06-.15.03a.25.25 0 0 1-.13-.15c-.02-.07 0-.16.07-.2.05-.03.12-.02.16.03a.3.3 0 0 1 .05.05zm-.1.03c-.02-.03-.04-.08-.08-.09-.05 0-.05.06-.03.1l.02.05.1-.06zM492.71 303.59l.1-.07.03.04-.06.04c.06 0 .1.08.08.13a.18.18 0 0 1-.1.12c-.05.02-.03.1.02.07.06-.03.1-.07.17-.08.04-.01.08.02.1.06 0 .05-.02.1-.06.14a.37.37 0 0 1-.17.1c-.05 0-.1-.05-.06-.1.01 0 .03-.02 0-.01a.07.07 0 0 1-.07-.07c0-.03.01-.07.03-.1-.04.02-.1.01-.13-.03-.05-.05-.04-.14.01-.18a.19.19 0 0 1 .11-.06zm-.05.04c-.04.03-.02.08 0 .11.02.04.04.09.1.09.03 0 .04-.06.02-.09a.28.28 0 0 0-.08-.1.04.04 0 0 0-.04 0zm.2.37c-.04 0-.08.06-.03.08.04.02.08-.01.11-.04.04-.02.09-.06.05-.1-.04-.02-.08.02-.12.04l-.02.02zM493.15 303.31l.16.26c.01.03.04.03.06.02v.02l-.12.07-.03-.04c0 .05-.03.1-.08.12-.04.02-.1 0-.11-.05l-.12-.18c-.01-.03-.04-.02-.05-.02v-.02l.11-.07.15.24c.01.04.07.03.08-.02v-.05l-.11-.17a.04.04 0 0 0-.06-.02v-.02l.12-.07zM493.36 303.18l.02.04c.01-.05.04-.1.09-.12.04-.02.1.01.11.05l.12.19c.01.02.04.02.05.01v.02l-.15.1c-.02-.03.03-.04 0-.06-.01-.05-.04-.09-.07-.13-.02-.03-.03-.07-.06-.1-.04-.03-.07.04-.06.08l.1.18c.02.02.05.03.07.02l-.01.02-.15.1c-.02-.03.03-.04.01-.07l-.08-.14-.07-.1c0-.02-.04.02-.05-.01l.13-.08zM493.98 302.58l.1.15c-.03.02-.04-.03-.07-.03-.05-.04-.14-.04-.18.02-.03.03-.02.1.03.1.06.02.12 0 .18 0 .05 0 .12 0 .16.05.05.05.05.13.02.2-.04.06-.11.1-.18.1-.04 0-.04.04-.05.06l-.01-.01-.1-.15c.02-.03.04.02.06.03.06.04.15.05.2 0 .05-.03.05-.11 0-.13-.06-.03-.12 0-.18 0s-.13-.01-.17-.06c-.05-.07-.04-.16.02-.22a.21.21 0 0 1 .13-.05c.04 0 .04-.03.03-.05l.01-.01zM494.48 302.82c-.01.05-.04.1-.08.12-.04.02-.1-.01-.1-.05-.01-.05.01-.1.04-.14.01-.03.04-.06.04-.09l-.04-.07c-.04-.02-.1.02-.09.06.03.01.07.02.06.05 0 .05-.06.07-.1.04-.03-.04 0-.1.02-.13a.22.22 0 0 1 .13-.08c.05-.01.09.02.1.06l.1.16c.01.02.05.01.04-.01.03 0 .01.03 0 .04 0 .04-.04.07-.08.07a.07.07 0 0 1-.04-.03zm-.01-.02l-.07-.11c-.02.04-.04.08-.02.12 0 .05.07.04.08 0v-.01zM494.62 302.38l.02.04c.01-.05.04-.1.09-.12.04-.02.1.01.11.05l.12.19c.01.02.04.02.05.01v.02l-.15.1c-.02-.03.03-.04 0-.06-.01-.05-.04-.09-.07-.13-.02-.03-.03-.07-.06-.1-.04-.03-.07.04-.06.08l.1.18c.02.02.05.03.07.02l-.01.02-.15.1c-.02-.03.03-.04.01-.07l-.08-.14-.07-.1c0-.02-.04.02-.05-.01l.13-.08zM495.04 301.94v-.02l.23-.14v.02c-.04.01-.05.06-.02.09l.16.25c.02.04.04.1.02.14a.2.2 0 0 1-.14.12c-.05 0-.11-.01-.13-.07-.01-.04.03-.08.07-.07.05.01.03.06.05.1.04.02.1-.04.06-.08l-.13-.22-.08-.13c-.02-.03-.06-.01-.08 0h-.01zM495.68 301.71l.16.26c.01.03.04.03.06.02v.02l-.12.07-.03-.04c0 .05-.03.1-.07.12-.05.02-.1 0-.12-.04l-.12-.2c-.01-.02-.04-.01-.05 0v-.03l.11-.07.15.24c.01.04.07.03.08-.02V302l-.11-.17a.04.04 0 0 0-.06-.02v-.02l.12-.07zM496.09 301.81c-.01.05-.04.1-.08.12-.04.02-.1-.01-.1-.05-.01-.05.02-.1.04-.15.01-.02.04-.05.04-.08l-.04-.07c-.04-.02-.1.02-.09.06.03.01.07.02.06.05 0 .05-.06.07-.1.04-.03-.04 0-.1.02-.13a.22.22 0 0 1 .13-.08c.05-.01.09.02.1.06l.1.16c.01.02.05.01.04-.01.03 0 .01.03 0 .04 0 .04-.04.07-.08.07a.07.07 0 0 1-.04-.03zm-.01-.02l-.07-.11c-.02.04-.04.08-.02.12 0 .05.07.04.08 0v-.01zM496.22 301.36l.02.04c.01-.05.04-.1.09-.12.04-.02.1.01.11.05l.12.19c0 .02.04.02.05.01v.02l-.15.1c-.02-.03.03-.04 0-.06-.01-.05-.04-.09-.07-.13-.02-.03-.03-.07-.06-.1-.04-.03-.07.04-.06.08l.1.18c.02.02.05.03.07.02l-.01.02-.15.1c-.02-.03.03-.04.01-.07l-.08-.14-.07-.1c0-.02-.04.02-.05-.01l.13-.08zM493.52 306.1l.1.15c-.02.02-.04-.03-.06-.03a.16.16 0 0 0-.19 0 .17.17 0 0 0-.07.17c.01.08.05.15.1.2.04.06.1.09.17.08.08-.02.15-.07.17-.15l.01-.07c.02 0 0 .04 0 .05 0 .08-.04.14-.1.18a.24.24 0 0 1-.23.03.3.3 0 0 1-.16-.39.26.26 0 0 1 .22-.16c.04 0 .03-.04.03-.05l.01-.01zM494.06 306.18l-.17.11c0 .04 0 .08.02.13 0 .04.05.01.07 0 .02.02 0 .02 0 .03l-.13.08c-.02-.03.03-.04.02-.07 0-.05 0-.1-.02-.15l-.06-.4h.03l.4.29a.1.1 0 0 0 .1.01 168.36 168.36 0 0 1-.17.12c-.03-.02.03-.02.02-.05 0-.03-.04-.04-.06-.06l-.05-.04zm-.02-.02l-.2-.13.04.23.16-.1zM494.34 305.91l.1.15c0 .04.05.04.08.02h.01l-.19.12v-.02c.05-.01.05-.06.02-.1l-.2-.3a.05.05 0 0 0-.08-.02l-.01-.01.2-.13c.04-.02.1-.04.16-.01.07.03.1.14.05.2a.28.28 0 0 1-.14.1zm-.01-.02c.04-.01.09-.04.1-.09.01-.06-.03-.13-.1-.15-.04-.01-.09.02-.12.05l.12.2zM494.92 305.84v.02l-.18.11v-.02c.04-.01.04-.06.02-.09a55 55 0 0 0-.2-.32c-.01-.03-.06-.04-.09-.01 0 0-.02 0-.01-.01l.19-.12v.02c-.04.01-.05.06-.02.09l.19.31c.01.04.06.06.09.03l.01-.01zM495.05 305.13l.07.1c-.02.03-.03-.03-.06-.03-.05-.02-.08.02-.12.04l-.03.02.23.36c.01.03.05.04.08.01l.01.01a188.64 188.64 0 0 1-.18.1c.05-.02.04-.07.01-.1l-.2-.34c-.04.02-.08.04-.1.07-.03.03-.01.07 0 .1-.02.01-.02 0-.03-.02l-.05-.09.37-.23zM495.41 304.93v-.02a114.07 114.07 0 0 0 .14-.07c-.04.02-.03.07 0 .1.04.08.1.15.13.23.03.04.05.1.03.15-.03.07-.1.12-.17.15a.16.16 0 0 1-.19-.06l-.14-.23c-.02-.02-.03-.06-.06-.07l-.06.02v-.02l.19-.11-.01.02c-.04.02-.03.07 0 .1l.13.22c.02.04.06.09.11.09.07 0 .12-.05.15-.1a.13.13 0 0 0 0-.12l-.11-.2-.07-.1c-.02-.01-.05 0-.07.02zM496.15 304.88c.01-.01.01 0 .02.01 0 .05.02.09.03.13l-.35.22v-.02c.05-.02.04-.07.01-.1l-.18-.3c-.02-.04-.06-.05-.09-.02 0 0-.02 0-.01-.01l.2-.13c.02.02-.04.03-.04.05-.03.03 0 .07.02.1l.18.28c.02.05.07.02.1 0 .03-.03.08-.05.1-.1.02-.03.01-.07 0-.11zM496.23 304.38c.1-.07.24-.04.32.05.07.07.1.18.08.28a.26.26 0 0 1-.28.19.27.27 0 0 1-.2-.14.28.28 0 0 1-.03-.25c.02-.06.06-.1.11-.13zm0 .03a.15.15 0 0 0-.06.15c0 .08.05.15.1.22.05.04.11.09.18.08a.16.16 0 0 0 .13-.16.39.39 0 0 0-.1-.21c-.03-.05-.09-.1-.16-.1a.15.15 0 0 0-.08.02zM497.12 303.82c.02.02-.02.03-.02.06l.01.14.07.4c0 .02-.02.01-.02 0l-.42-.28c-.03-.03-.07-.01-.09 0-.01-.02 0-.02.01-.03l.17-.1c.02.02-.04.03-.03.06 0 .03.04.04.07.06l.26.19-.06-.35c0-.05-.04-.08-.08-.05v-.01l.13-.09zM497.61 304.13v.02l-.18.11v-.02c.04-.01.04-.06.02-.09l-.2-.32c-.01-.03-.06-.04-.09-.01 0 0-.02 0-.01-.01l.19-.12v.02c-.04.01-.05.06-.02.09l.19.31c.01.04.06.06.09.03l.01-.01zM497.84 303.98v.02l-.18.11v-.02c.04-.01.04-.06.02-.09l-.2-.32c-.01-.03-.06-.04-.09-.01 0 0-.02 0-.01-.01l.19-.12v.02c-.04.01-.05.06-.02.09l.19.31c.01.04.06.06.09.03l.01-.01zM498.06 303.84v.02l-.18.11v-.02c.04-.01.04-.06.02-.09l-.2-.32c-.01-.03-.06-.04-.09-.01 0 0-.02 0-.01-.01l.19-.12v.02c-.04.01-.05.06-.02.09l.19.31c.01.04.06.06.09.03l.01-.01zM494.14 307.96c0-.05 0-.12.04-.16.04-.03.1-.05.14-.03.05.02.07.09.06.14 0 .01-.02.04 0 .04.05 0 .1.01.14.06.04.07.04.16-.01.22a.27.27 0 0 1-.12.09c-.04.01-.07-.03-.04-.06.04-.02.1 0 .13-.03.04-.04.04-.12 0-.16a.12.12 0 0 0-.12-.04l-.07.03c-.01-.02.03-.03.03-.05a.12.12 0 0 0 0-.14c-.03-.05-.1-.05-.14 0-.02.02-.02.06-.03.09h-.01zM494.5 307.67l.08-.12h.01l.24.4c.01.02.05.04.08.01h.02l-.17.12c-.02-.03.03-.03.03-.05.01-.03-.02-.06-.03-.08-.05-.09-.1-.18-.17-.27 0-.03-.05-.06-.07-.02 0 .01 0 .02-.02.01zM495.23 307.16l.16-.1c.02.02-.02.02-.02.04-.03.04-.02.1-.03.16v.2l.09.13c.02.04.06.02.08 0a366.2 366.2 0 0 1-.17.1c.04 0 .03-.06 0-.09l-.06-.1-.28-.13c-.03-.02-.07 0-.08 0-.01-.01 0-.02.01-.02l.17-.11c.02.02-.01.02-.02.04-.03.03.03.06.06.07l.17.08v-.22c.01-.04-.04-.07-.07-.04v-.01zM496.05 307.2c0 .05-.04.1-.1.12-.06.01-.14-.02-.17-.08a.22.22 0 0 1-.02-.23c.03-.04.08-.08.13-.07l-.07-.12c-.02-.02-.05 0-.06.01v-.02l.06-.08h.02l.24.39c0 .02.04.05.06.02 0-.02.03 0 .01.01l-.06.09h-.02l-.02-.04zm-.01-.02l-.1-.16c-.03-.04-.08-.06-.12-.04-.05.03-.04.1-.02.14.02.06.07.12.13.14.04 0 .08-.02.1-.06v-.02zM496.13 306.94c.03.05.07.09.13.1.06 0 .11-.04.12-.1v-.05c.02 0 .01.03.02.04 0 .05 0 .12-.05.15a.15.15 0 0 1-.16.01.25.25 0 0 1-.1-.14.17.17 0 0 1 .04-.18c.04-.04.1-.05.14-.03.03.02.06.04.07.07l-.21.13zm-.01-.02l.14-.09c-.02-.03-.06-.06-.1-.05-.05.02-.07.08-.05.12v.02zM496.69 306.7c.02.06.02.12-.01.17a.13.13 0 0 1-.15.05c-.06-.01-.11-.07-.14-.13-.03-.08 0-.18.07-.22.04-.03.09-.03.13 0 .03 0 .03.05 0 .06-.05.02-.06-.06-.11-.04-.05.01-.07.07-.06.11a.2.2 0 0 0 .13.15c.05.02.1-.01.12-.06.02-.03 0-.07.01-.09zM496.59 306.26c.05-.03.09.05.03.07-.04.02-.07-.05-.03-.07zm.13.14l.16.26c0 .03.04.04.07.02v.02l-.14.08c-.02-.02.03-.02.02-.05 0-.03-.02-.05-.04-.07l-.09-.15c-.02-.03-.05-.01-.06 0 0 0-.01 0 0 0l.06-.1h.02zM497.13 306.51c-.02.04-.02.08-.06.1-.04.04-.1.02-.13-.03-.02-.04 0-.08.02-.12l.07-.1c-.01-.04-.03-.06-.06-.08-.04 0-.1.04-.07.08 0 .02.02.03.01.05-.01.04-.07.02-.07-.02 0-.05.03-.1.08-.12.03-.02.08-.04.11-.02l.07.08.08.13c.02.03.04 0 .04-.02 0-.01 0-.02.01 0 .02.01 0 .04 0 .06-.02.04-.07.06-.1.02v-.01zm-.01-.02l-.07-.12c-.03.04-.07.08-.07.13 0 .04.04.08.08.07.03-.01.05-.05.06-.08zM497.23 305.88v-.02l.18-.11v.01c-.03.02-.05.06-.02.09l.16.26c.02.04.04.1.02.15a.12.12 0 0 1-.1.08c-.05 0-.08-.07-.02-.09.03 0 .06.06.09.03.01-.03-.01-.06-.03-.09l-.18-.3c-.02-.03-.06-.04-.1-.02v.01zM497.65 305.97c.03.05.07.09.13.1.06 0 .11-.04.12-.1v-.05c.02 0 .01.03.02.04 0 .05 0 .12-.05.15a.15.15 0 0 1-.16.01.24.24 0 0 1-.1-.14.17.17 0 0 1 .04-.18c.04-.04.1-.05.14-.03.03.02.06.04.07.07l-.21.13zm-.01-.02l.14-.09c-.02-.03-.06-.06-.1-.05-.05.02-.07.08-.05.12v.02zM498.02 305.56l.06.1c-.01.02-.03-.01-.04-.02-.04-.03-.1-.02-.12.02-.03.04.01.09.05.08.05 0 .1-.01.14 0a.1.1 0 0 1 .1.08c0 .06-.04.1-.1.13-.02.02-.06.01-.07.04h-.01l-.06-.1c.01-.02.02.02.04.02.04.03.1.03.14-.01.02-.03 0-.08-.03-.1-.06 0-.12.02-.18 0-.05-.01-.08-.08-.06-.13.02-.04.06-.07.1-.08.02 0 .03 0 .03-.02l.01-.01zM498.37 305.37l.15.24c0 .03.05.02.06 0v.02l-.06.08s-.01.02-.01 0l-.04-.05c-.01.04-.02.1-.06.12-.03.03-.09.02-.12-.01l-.08-.13c-.02-.03-.03-.06-.06-.08-.02-.03-.05 0-.06 0v-.02l.1-.06.13.22c.02.04.08.05.1.01.02-.02.04-.05.03-.08l-.1-.17c-.02-.04-.06-.03-.08-.01v-.02l.1-.06zM498.63 305.18l.06.1c-.01.02-.03-.01-.04-.02-.04-.03-.1-.02-.12.02-.03.04.01.09.05.08.05 0 .1-.01.14 0a.1.1 0 0 1 .1.08c0 .06-.04.1-.1.13-.02.02-.06.01-.07.04h-.01l-.06-.1c.01-.02.02.02.04.02.04.03.1.03.14-.01.02-.03 0-.08-.03-.1-.06 0-.13.02-.19 0-.05-.02-.07-.09-.04-.14.02-.04.06-.06.1-.06l.02-.03.01-.01zM499.2 305.2c-.02.04-.02.08-.06.1-.04.04-.1.02-.13-.03-.02-.04 0-.08.02-.12l.07-.1c-.01-.04-.03-.06-.06-.08-.04 0-.1.04-.07.08 0 .02.02.03.01.05-.01.04-.07.02-.07-.02 0-.05.03-.1.08-.12.03-.02.08-.04.11-.02l.07.08.08.13c.02.03.04 0 .04-.02 0-.01 0-.02.01 0 .02.01 0 .04 0 .06-.02.04-.07.06-.1.02v-.01zm-.01-.02l-.07-.12c-.03.04-.07.08-.07.13 0 .04.04.08.08.07.03-.01.05-.05.06-.08zM494.69 308.65l.26.42c.01.04.05.03.07.02v.01l-.14.09c-.02-.02.03-.02.02-.05 0-.03-.02-.05-.04-.08l-.17-.29c-.01-.02-.05-.04-.06-.01 0 0-.03 0-.02-.01l.07-.1h.01zM495.02 308.65c.05-.03.1-.04.16-.01.07.03.11.1.11.18.01.07-.02.13-.07.16a.15.15 0 0 1-.16 0 .21.21 0 0 1-.12-.19c0-.06.03-.11.08-.14zm0 .03c-.04.02-.04.07-.02.11.02.07.07.13.13.16.04.02.1 0 .11-.04.03-.04 0-.1-.02-.13-.03-.05-.08-.1-.14-.11h-.06zM495.4 308.41l.06.1c-.01.02-.03-.01-.04-.02-.04-.03-.1-.02-.12.02-.03.04.01.09.05.08.05 0 .1-.01.14 0a.1.1 0 0 1 .1.08c0 .06-.04.1-.1.13-.02.02-.06.01-.07.04h-.01l-.06-.1c.01-.02.02.02.04.02.04.03.1.03.14-.01.02-.03 0-.08-.03-.1-.06 0-.12.02-.18 0-.05-.01-.08-.08-.06-.13.02-.04.06-.07.1-.07.02 0 .03-.02.03-.03l.01-.01zM495.62 308.06c.05-.03.09.05.04.07-.05.02-.08-.04-.04-.07zm.13.14l.2.33c.02.05.04.11 0 .17-.02.03-.06.07-.1.06-.05-.03 0-.08.04-.06.04.01.07-.03.05-.06l-.12-.19c-.03-.05-.05-.1-.1-.15 0-.03-.03.01-.05.01v-.02l.06-.08h.02zM496.11 307.99l.15.24c0 .03.05.02.06 0v.02l-.06.08s-.01.02-.01 0l-.04-.05c-.01.04-.02.1-.06.12-.03.03-.09.02-.12-.01l-.08-.13c-.02-.03-.03-.06-.06-.08-.02-.03-.05 0-.06 0v-.02l.1-.06.13.22c.02.04.08.05.1.01.02-.02.04-.05.03-.08l-.1-.17c-.02-.04-.06-.03-.08-.01v-.02l.1-.06zM496.56 308.09c0 .05-.04.1-.1.12-.06.01-.14-.02-.17-.08a.22.22 0 0 1-.02-.23c.03-.04.08-.08.13-.07l-.07-.12c-.02-.02-.05 0-.06.01v-.02l.06-.08h.02l.24.39c0 .02.04.05.06.02 0-.02.03 0 .01 0l-.06.1h-.02l-.02-.04zm-.01-.02l-.1-.16c-.03-.04-.08-.06-.12-.04-.05.03-.04.1-.02.14.02.06.07.13.13.14.04 0 .08-.02.1-.06v-.02zM496.49 307.51c.05-.03.09.05.03.07-.04.02-.07-.05-.03-.07zm.13.14l.16.26c0 .03.04.04.07.02v.02l-.14.08c-.02-.02.03-.02.02-.05 0-.03-.02-.05-.04-.07l-.09-.15c-.02-.03-.05-.01-.06 0 0 0-.01 0 0 0l.06-.1h.02zM496.84 307.5c.05-.03.1-.04.16-.01.07.03.11.1.11.18.01.07-.02.13-.07.16a.15.15 0 0 1-.16 0 .21.21 0 0 1-.12-.19c0-.06.03-.11.08-.14zm0 .03c-.04.02-.04.07-.02.11.02.07.07.13.13.16.04.02.1 0 .11-.04.03-.04 0-.1-.02-.13-.03-.05-.08-.1-.14-.11h-.06zM497.23 307.25l.06.1c-.02.02-.03-.02-.06-.03-.04-.02-.11 0-.11.07 0 .04.06.05.1.04.05 0 .1-.02.15.01.04.03.05.1.03.14-.03.05-.08.07-.13.08-.01 0-.02.04-.03.02l-.06-.1c.02-.02.03.03.06.03.04.02.1.01.13-.04.01-.03-.02-.08-.06-.07h-.17a.1.1 0 0 1-.04-.16c.03-.04.07-.05.11-.06.02 0 0-.03.02-.03zM497.73 306.93l.25.4c.01.04.05.04.08.02v.02l-.15.09c-.02-.02.01-.02.02-.03.02-.03 0-.06-.02-.08l-.07-.12c-.01.05-.03.1-.08.13-.06.03-.13 0-.17-.05-.05-.06-.07-.14-.04-.22.02-.06.07-.11.14-.1.02 0 .02-.05.04-.06zm.1.28l-.1-.16c-.02-.04-.07-.04-.1-.02-.06.03-.06.1-.04.15.03.05.06.11.13.12.05 0 .1-.03.1-.08v-.01zM498.08 306.74l.15.24c0 .03.05.02.06 0v.02l-.06.08s-.01.02-.01 0l-.04-.05c-.01.04-.02.1-.06.12-.03.03-.09.02-.12-.01l-.08-.13c-.02-.03-.03-.06-.06-.08-.02-.03-.05 0-.06 0v-.02l.1-.06.13.22c.02.04.08.05.1.01.02-.02.04-.06.03-.08l-.1-.17c-.02-.04-.06-.03-.08-.01v-.02l.1-.06zM498.27 306.76c.03.05.07.09.13.1.06 0 .11-.04.12-.1v-.05c.02 0 .01.03.02.04 0 .05 0 .12-.05.15a.15.15 0 0 1-.16.01.24.24 0 0 1-.1-.14.17.17 0 0 1 .04-.18c.04-.04.1-.05.14-.03.03.02.06.04.07.07l-.21.13zm-.01-.02l.14-.09c-.02-.03-.06-.06-.1-.05-.05.02-.07.08-.05.12v.02zM498.63 306.15l.26.42c.01.04.05.03.07.02v.01l-.14.1c-.02-.03.03-.03.02-.06 0-.03-.02-.05-.04-.08l-.17-.29c-.01-.02-.05-.04-.06-.01 0 0-.03 0-.02-.01l.07-.1h.01zM498.93 306.35c.03.05.07.09.13.1.06 0 .11-.04.12-.1v-.05c.02 0 .01.03.02.04 0 .05 0 .12-.05.15a.15.15 0 0 1-.16.01.24.24 0 0 1-.1-.14.17.17 0 0 1 .04-.18c.04-.04.1-.05.14-.03.03.02.06.04.07.07l-.21.13zm-.01-.02l.14-.09c-.02-.03-.06-.06-.1-.05-.05.02-.07.08-.05.12v.02zM495.2 309.52l.14.22c0-.04.02-.1.07-.13.04-.02.1 0 .12.04l.11.19c.02.03.05.01.07 0 .01.02 0 .02-.01.03l-.13.08c-.02-.02.02-.02.02-.04.01-.03-.01-.05-.02-.07l-.1-.15c-.03-.05-.1-.02-.1.03-.01.02-.03.04-.01.06l.1.17c.02.04.06 0 .08 0 0 .02-.01.02-.02.03l-.13.08c-.02-.02.04-.03.02-.06 0-.03-.03-.06-.05-.1l-.17-.26c-.01-.04-.05-.03-.06 0-.02-.01 0-.02 0-.03l.06-.08.01-.01zM495.88 309.68c-.02.04-.02.08-.06.1-.04.04-.1.02-.13-.03-.02-.04 0-.08.02-.12l.07-.1c-.01-.04-.03-.06-.06-.08-.04 0-.1.04-.07.08 0 .02.02.03.01.05-.01.04-.07.02-.07-.02 0-.05.03-.1.08-.12.03-.02.08-.04.11-.02l.07.08.08.13c.02.03.04 0 .04-.02 0-.01 0-.02.01 0 .02.01 0 .04 0 .06-.02.04-.07.06-.1.02v-.01zm-.01-.02l-.07-.12c-.03.04-.07.08-.07.13 0 .04.04.08.08.07.03-.01.05-.05.06-.08zM495.96 309.33c0-.05.02-.11.08-.13.06-.03.13 0 .17.06.04.05.06.12.04.2a.18.18 0 0 1-.13.12c-.03 0-.06.02-.08 0l-.22-.35c0-.02-.04-.05-.06-.02 0 .02-.03 0-.01 0l.06-.1h.02l.13.22zm.01.02l.12.19c.04 0 .1 0 .12-.05.02-.06-.01-.12-.04-.17-.03-.04-.08-.07-.13-.06-.04.02-.06.05-.07.1zM496.17 308.9c.05-.03.09.05.03.07-.04.02-.07-.05-.03-.07zm.13.14l.16.26c0 .03.04.04.07.02v.02l-.14.08c-.02-.02.03-.02.02-.05 0-.03-.02-.05-.04-.07l-.09-.15c-.02-.03-.05-.01-.06 0 0 0-.01 0 0 0l.06-.1h.02zM496.71 309.15c-.02.04-.02.08-.06.1-.04.04-.1.02-.13-.03-.02-.04 0-.08.02-.12l.07-.1c-.01-.04-.03-.06-.06-.08-.04 0-.1.04-.07.08 0 .02.02.03.01.05-.01.04-.07.02-.07-.02 0-.05.03-.1.08-.12.03-.02.08-.04.11-.02l.07.08.08.14c.02.02.04-.01.04-.03 0-.01 0-.02.01 0 .02.01 0 .04 0 .06-.02.04-.07.06-.1.02v-.01zm-.01-.02l-.07-.12c-.03.04-.07.08-.07.13 0 .04.04.08.08.07.03-.01.05-.05.06-.08zM496.81 308.82c0-.05.02-.11.07-.14.05-.02.1.01.12.05l.11.18c.02.03.05.02.07 0v.03a209.3 209.3 0 0 0-.13.06c.03-.02 0-.06 0-.08l-.1-.15c-.02-.04-.07-.04-.1 0-.01.02-.04.05-.02.08l.1.17c.02.04.06.02.08.01v.02l-.15.09.01-.03c.03-.02 0-.06 0-.08l-.11-.17c-.02-.03-.05 0-.06 0 0 0-.02 0 0 0l.06-.1h.02l.03.06zM497.57 308.52c.02.06.02.12-.01.17a.13.13 0 0 1-.15.05c-.06-.01-.11-.07-.14-.13-.03-.08 0-.18.07-.22.03-.03.09-.03.13 0 .03 0 .03.05 0 .06-.05.02-.06-.06-.11-.04-.05.01-.07.07-.06.11a.2.2 0 0 0 .13.15c.05.02.1-.01.12-.06.02-.03 0-.07.01-.09zM497.58 308.24l.04.07c0-.04 0-.1.04-.12.03-.03.1.02.06.06-.02.02-.07-.02-.08.03v.07l.1.15c.01.03.06.03.08.01v.02l-.15.1c-.02-.03.02-.03.02-.05.01-.02 0-.05-.02-.07l-.1-.16c-.02-.03-.05-.02-.06 0 0 0-.02 0 0-.01l.06-.1h.01zM497.83 308.23c.03.05.07.09.13.1.06 0 .11-.04.12-.1v-.05c.02 0 .01.03.02.04 0 .05 0 .12-.05.15a.15.15 0 0 1-.16.01.24.24 0 0 1-.1-.14.17.17 0 0 1 .04-.18c.04-.04.1-.05.14-.03.03.02.06.04.07.07l-.21.13zm-.01-.02l.14-.09c-.02-.03-.06-.06-.1-.05-.05.02-.07.08-.05.12v.02zM497.99 307.74c.05-.03.09.05.03.07-.04.02-.07-.05-.03-.07zm.13.14l.16.26c0 .03.04.04.07.02v.02l-.14.08c-.02-.02.03-.02.02-.05 0-.03-.02-.05-.04-.07l-.09-.15c-.02-.03-.05-.01-.06 0v-.01l.06-.09h.02zM498.59 307.99c0 .05-.05.1-.1.12-.07.01-.14-.03-.18-.1a.22.22 0 0 1 0-.2c.02-.05.07-.09.12-.08l-.07-.12c-.02-.02-.05 0-.06.01v-.02l.06-.08h.02l.24.39c0 .02.04.05.06.02 0-.02.03 0 .01 0l-.06.1h-.02l-.02-.04zm-.01-.02l-.1-.16c-.03-.04-.08-.06-.12-.04-.05.03-.04.1-.02.14.02.06.07.13.13.14.04 0 .08-.02.1-.06v-.02zM498.69 307.54c.05-.03.1-.04.16-.01.07.03.11.11.11.2 0 .05-.03.11-.08.14a.16.16 0 0 1-.17 0 .22.22 0 0 1-.09-.24.17.17 0 0 1 .07-.09zm0 .03c-.04.02-.04.07-.02.11.02.07.07.13.13.16.04.02.1 0 .11-.04.03-.04 0-.1-.02-.13-.03-.05-.08-.1-.14-.11h-.06zM497.67 298.28l.08.13c-.02.02-.03-.02-.04-.02-.05-.05-.14-.04-.17.02-.03.04 0 .1.04.1h.22c.06.01.1.08.1.14-.02.06-.08.11-.14.13-.03 0-.08.01-.06.04h-.01l-.08-.12c.02-.02.03.02.05.03.05.04.14.02.18-.03.03-.04 0-.1-.05-.12h-.16c-.04 0-.1 0-.12-.05-.04-.05-.02-.13.03-.17.03-.03.08-.02.12-.04.01-.02-.01-.03.01-.04zM497.79 298.17c.04-.03.07.05.03.06-.04.02-.06-.04-.03-.06zm.1.12l.14.23c.01.02.05.03.07.01v.01l-.12.08c-.02-.02.02-.02.02-.04 0-.03-.02-.05-.04-.07l-.07-.12c-.01-.03-.04-.02-.05 0 0 0-.02 0 0-.01l.05-.08zM498.11 298.18l.12-.08v.02c-.02 0-.01.04.01.05l.15.11-.03-.2c0-.02-.02-.03-.04-.02h-.01l.08-.06v.02c-.02.01-.01.04 0 .06 0 .1.02.18.04.28h-.02l-.23-.17c-.02-.01-.05 0-.07 0v-.01zM498.54 297.9c.04-.03.1-.03.14 0 .07.03.1.1.1.18-.01.07-.1.14-.17.12a.17.17 0 0 1-.13-.14c-.01-.05 0-.1.02-.13a.14.14 0 0 1 .04-.03zm0 .02c-.04.03-.03.09-.01.13.03.05.07.1.12.11.04.01.09-.02.09-.06 0-.04-.03-.09-.05-.12-.03-.04-.09-.08-.14-.06zM498.87 297.69l.05.09-.03-.02c-.03-.03-.1-.02-.11.03-.02.05.04.06.08.05h.11c.05.02.07.08.05.12-.02.05-.08.07-.12.08 0 0-.01.03-.02.02l-.06-.09c.02-.02.03.02.04.02.04.03.11.02.13-.03.01-.04-.04-.07-.08-.06h-.12a.09.09 0 0 1-.03-.13c.02-.04.07-.04.1-.06v-.02zM499.06 297.58c.04-.03.1-.03.14 0 .07.03.1.1.1.18-.01.07-.1.14-.17.12a.17.17 0 0 1-.13-.14c-.01-.05 0-.1.03-.14l.03-.02zm0 .02c-.04.03-.03.09-.01.13.03.05.07.1.12.11.04.01.09-.02.09-.06 0-.05-.03-.09-.05-.12-.03-.04-.09-.08-.14-.06zM499.24 297.34l.05.09.06-.04.02.02-.06.04.1.17c.01.03.05.04.06.01.01-.01 0-.03.02-.04.01.04 0 .1-.04.1-.04.02-.07-.01-.09-.04l-.1-.17-.04.02c-.02-.01 0-.02 0-.04.02-.04.01-.08.01-.11l.01-.01zM499.46 297.32l.04.06c0-.04 0-.1.05-.11.04 0 .05.06.01.06-.02 0-.05 0-.05.02v.06l.08.13c.02.03.05.03.07.01v.02l-.12.08c-.02-.02.01-.02.02-.04l-.02-.06-.1-.14c0-.02-.03-.01-.04 0 0 0-.02 0 0 0l.05-.08.01-.01zM499.7 297.17c.04-.03.1-.03.14 0 .07.03.1.1.1.18-.01.07-.1.14-.17.12a.17.17 0 0 1-.13-.14c-.01-.05 0-.1.02-.13a.14.14 0 0 1 .04-.03zm0 .02c-.04.03-.03.09-.01.13.03.05.07.1.12.11.04.01.09-.02.09-.06 0-.04-.03-.09-.05-.12-.03-.04-.09-.08-.14-.06zM500.03 296.96l.05.09-.03-.02c-.03-.03-.1-.02-.11.03-.02.05.04.06.08.05h.11c.05.02.07.08.05.12-.02.05-.08.07-.12.08 0 0-.01.03-.02.02a44.9 44.9 0 0 1-.06-.09c.02-.02.03.02.04.02.04.03.11.02.13-.03.01-.04-.04-.07-.08-.06h-.12a.09.09 0 0 1-.03-.13c.02-.04.07-.04.1-.06v-.02zM497.95 299.35l.06-.08h.02c0 .02.02.03.03.05 0-.04 0-.1.04-.11.04-.03.1-.02.13 0 .06.06.1.15.07.23a.12.12 0 0 1-.1.08h-.02l.06.1c.02.02.05 0 .06 0v.01l-.13.08v-.02c.04-.02.02-.05 0-.08l-.16-.25c0-.03-.04-.02-.05 0l-.01-.01zm.12-.01l.08.13c.03.04.08.03.1 0 .04-.04.02-.1 0-.13-.02-.04-.06-.09-.12-.09-.04 0-.06.05-.06.09zM498.34 299.19c.02.04.06.08.11.08s.1-.04.1-.09v-.04c.02 0 .02.03.02.04 0 .05 0 .1-.04.13a.13.13 0 0 1-.15 0 .22.22 0 0 1-.09-.12.14.14 0 0 1 .06-.15.11.11 0 0 1 .12-.02l.05.06-.18.11zm-.01-.02l.12-.07c-.02-.05-.09-.06-.12-.02-.02.03-.02.07 0 .1zM498.56 298.9l.04.06c0-.04 0-.1.05-.11.04 0 .05.06.01.06-.02 0-.05 0-.05.02v.06l.08.13c.02.03.05.03.07.01v.02l-.12.08c-.02-.02.01-.02.02-.04l-.02-.06-.1-.14c0-.02-.03-.01-.04 0 0 0-.02 0 0 0l.05-.08.01-.01zM498.8 298.84c0-.05.02-.1.07-.12.03-.01.06 0 .09.02 0-.04.02-.1.06-.12.04-.02.09.01.11.05l.1.15c0 .02.04 0 .05 0 .01.01 0 .02-.01.02l-.11.07c-.02-.02.03-.02.02-.05l-.04-.08-.07-.1c-.04-.04-.09.01-.1.05v.04l.1.15c0 .03.04 0 .06 0l-.02.02-.11.07c-.02-.02.03-.02.02-.05l-.03-.07-.07-.1c-.03-.04-.09-.01-.1.03 0 .02-.02.04 0 .05l.09.15c.01.03.04 0 .06 0l-.01.02-.12.07c-.01-.02.04-.02.02-.05 0-.03-.03-.06-.05-.1l-.07-.1c-.01 0-.04.04-.04.01l.05-.08h.02l.03.05zM499.42 298.68c-.02.04-.03.1-.08.1-.05.02-.1-.04-.09-.08.01-.06.05-.1.08-.15l-.01-.03c-.02-.04-.08-.04-.1 0v.04c.03.02.01.06-.02.05-.04-.02-.03-.08 0-.11.04-.03.08-.06.12-.05.03 0 .05.04.06.07l.08.12c0 .02.04 0 .04-.01v-.02l.01.02c0 .03-.02.1-.07.07l-.02-.02zm-.01-.02l-.06-.1c-.03.03-.05.07-.06.1 0 .05.06.1.09.06a.16.16 0 0 0 .03-.06zM499.5 298.39c0-.04.02-.1.06-.12.04-.02.08 0 .1.04l.1.15c.01.03.04.03.06.01v.02l-.12.07v-.02c.03-.01.01-.05 0-.07l-.07-.12c-.02-.03-.07-.04-.1-.01 0 .02-.03.05-.02.07l.1.15c0 .03.04.02.06.01v.01l-.13.08.01-.02c.03-.02 0-.05 0-.07l-.1-.14c0-.03-.03-.01-.05 0v-.02l.05-.07h.02l.03.05zM499.79 298.27c.02.04.06.08.11.08s.1-.04.1-.09v-.04c.02 0 .02.03.02.04 0 .05 0 .1-.04.13a.13.13 0 0 1-.15 0 .22.22 0 0 1-.09-.12.14.14 0 0 1 .06-.15.11.11 0 0 1 .12-.02l.05.06-.18.11zm-.01-.02l.12-.07c-.02-.05-.09-.06-.12-.02-.02.03-.02.07 0 .1zM500.26 298.06c.02.05.02.1-.01.15a.11.11 0 0 1-.13.04c-.05-.01-.1-.07-.12-.12-.02-.06 0-.15.06-.18.04-.03.1-.03.13 0 .02.05-.05.08-.07.03-.03-.04-.1.01-.09.06 0 .04.03.09.06.12.03.02.07.04.1.03.05-.02.07-.07.06-.12l.01-.01zM500.3 297.94c.02.04.06.08.11.08s.1-.04.1-.09v-.04c.02 0 .02.03.02.04 0 .05 0 .1-.04.13a.13.13 0 0 1-.15 0 .22.22 0 0 1-.09-.12.14.14 0 0 1 .06-.15.11.11 0 0 1 .12-.02l.05.06-.18.11zm-.01-.02l.12-.07c-.02-.05-.09-.06-.12-.02a.09.09 0 0 0 0 .1zM500.53 297.65l.04.06c0-.04 0-.1.05-.11.04 0 .05.06.01.06-.02 0-.05 0-.05.02v.06l.08.13c.02.03.05.03.07.01v.02l-.12.08c-.02-.02.01-.02.02-.04l-.02-.06-.1-.14c0-.02-.03-.01-.04 0 0 0-.02 0 0 0l.05-.08h.01zM500.75 297.66c.02.04.06.08.11.08s.1-.04.1-.09v-.04c.02 0 .02.03.02.04 0 .05 0 .1-.04.13a.13.13 0 0 1-.15 0 .22.22 0 0 1-.09-.12.14.14 0 0 1 .06-.15.11.11 0 0 1 .12-.02l.05.06-.18.11zm-.01-.02l.12-.07c-.02-.05-.09-.06-.12-.02-.02.03-.02.07 0 .1zM500.89 297.24c.04-.03.07.05.03.06-.04.02-.06-.04-.03-.06zm.1.12l.14.23c.01.02.05.03.07.01v.01l-.12.08c-.02-.02.02-.02.02-.04 0-.03-.02-.05-.04-.07l-.07-.12c-.01-.03-.04-.02-.05 0 0 0-.02 0 0-.01l.05-.08zM501.23 297.2l.05.09-.03-.02c-.03-.03-.1-.02-.11.03-.02.05.04.06.08.05h.11c.05.02.07.08.05.12-.02.05-.08.07-.12.08 0 0-.01.03-.02.02l-.05-.09c0-.02.02.02.03.02.04.03.11.02.13-.03.01-.04-.04-.07-.08-.06h-.12a.09.09 0 0 1-.03-.13c.02-.04.07-.04.1-.06l.01-.02zM498.51 300.12c.02.04.06.08.11.08s.1-.03.1-.08v-.05c.02 0 .02.03.02.04 0 .05 0 .1-.04.13a.13.13 0 0 1-.13.01.2.2 0 0 1-.1-.13.14.14 0 0 1 .04-.15.11.11 0 0 1 .13-.02l.05.06-.18.11zm-.01-.02l.12-.07c-.02-.05-.09-.06-.12-.02-.02.03-.02.07 0 .1zM498.76 299.87c0-.04.02-.1.06-.12.04-.02.08 0 .1.04l.1.15c.01.03.04.03.06.01v.02l-.12.07v-.02c.03-.01.01-.05 0-.07l-.07-.12c-.02-.03-.07-.04-.1-.01 0 .02-.03.05-.02.07l.1.15c0 .03.04.02.06.01v.01l-.13.08.01-.02c.03-.02 0-.05 0-.07l-.1-.14c0-.03-.03-.01-.05 0v-.02l.05-.07h.02l.03.05zM499.19 299.6c0-.05.02-.1.07-.12.03-.01.06 0 .09.02 0-.04.02-.1.06-.12.04-.02.09.01.11.05l.1.15c0 .02.04 0 .05 0 .01.01 0 .02-.01.02l-.11.07c-.02-.02.03-.02.02-.05l-.04-.08-.07-.1c-.04-.04-.09.01-.1.05v.05l.1.14c0 .03.04 0 .06 0l-.02.02-.11.07c-.02-.02.03-.02.02-.05l-.04-.07-.06-.1c-.03-.04-.09-.01-.1.03 0 .02-.02.04 0 .05l.09.15c.01.03.04 0 .06 0l-.01.02-.12.07c-.01-.02.04-.02.02-.05 0-.03-.03-.06-.05-.1l-.07-.1c-.01 0-.04.04-.04.01l.05-.08h.02l.03.05zM499.52 299.12c.04-.03.07.05.03.06-.04.02-.06-.04-.03-.06zm.1.12l.14.23c.01.02.05.03.07.01v.01l-.12.08c-.02-.02.02-.02.02-.04 0-.03-.02-.05-.04-.07l-.07-.12c-.01-.03-.04-.02-.05 0 0 0-.02 0 0-.01l.05-.08zM499.84 299.15l.06-.08h.02c0 .02.02.03.03.05 0-.04 0-.1.04-.11.04-.03.1-.02.13 0 .06.06.1.15.07.23a.12.12 0 0 1-.1.08h-.02l.06.1c.02.02.05 0 .06 0v.01l-.13.08v-.02c.04-.02.02-.05 0-.08l-.16-.25c0-.04-.04-.02-.05 0l-.01-.01zm.12-.01l.08.13c.03.04.08.03.1 0 .04-.04.02-.1 0-.13-.02-.04-.06-.09-.12-.09-.04 0-.06.05-.06.09zM500.43 299.08c-.02.04-.03.1-.08.1-.06.02-.1-.04-.09-.1.02-.05.05-.1.09-.14-.02-.02-.03-.05-.06-.05-.04-.01-.08.03-.06.07.01 0 .03.03.01.04-.02.04-.06 0-.05-.04 0-.05.04-.08.08-.1.04-.02.1 0 .1.03l.1.15c0 .02.04.01.04-.01V299s.02.01.01.02c0 .03-.02.1-.07.07l-.02-.02zm-.01-.02l-.06-.1c-.03.03-.05.07-.06.1 0 .05.06.1.09.06a.16.16 0 0 0 .03-.06zM500.39 298.57l.22.36c.01.03.04.03.07.01v.02l-.13.07c-.01-.02.03-.02.02-.04 0-.03-.02-.05-.03-.07l-.15-.25c-.01-.02-.04-.04-.05-.01h-.02l.06-.08.01-.01zM500.85 298.81c-.02.04-.03.1-.08.1-.06.02-.1-.04-.09-.1.02-.05.05-.1.09-.14-.02-.02-.03-.05-.06-.05-.04-.01-.08.03-.06.07.01 0 .03.03.01.04-.02.04-.06 0-.05-.04 0-.05.04-.08.08-.1.04-.02.1 0 .1.03l.1.15c0 .02.04.01.04-.01v-.02s.02.01.01.02c0 .03-.02.1-.07.07l-.02-.02zm-.01-.02l-.06-.1c-.03.03-.05.07-.06.1 0 .05.06.1.09.06a.16.16 0 0 0 .03-.06zM500.91 298.51c0-.04.02-.1.06-.11.06-.02.12 0 .15.04.04.05.06.12.04.18a.15.15 0 0 1-.13.1c-.02 0-.05.02-.06 0l-.18-.3c0-.02-.04-.04-.05 0 0 0-.02-.01-.01-.02l.05-.07s.02-.02.02 0l.11.18zm.01.02l.1.16c.04 0 .1-.01.1-.06.02-.05-.01-.1-.05-.14-.02-.04-.08-.05-.12-.02-.02.01-.02.04-.03.06zM501.18 298.28l.04.06c0-.04 0-.1.05-.11.04 0 .05.06.01.06-.02 0-.05 0-.05.02v.06l.08.13c.02.03.05.03.07.01v.02l-.12.08c-.02-.02.01-.02.02-.04l-.02-.06-.1-.14c0-.02-.03-.01-.04 0 0 0-.02 0 0 0l.05-.08.01-.01zM501.59 298.34c-.02.04-.03.1-.08.1-.06.02-.1-.04-.09-.1.02-.05.05-.1.09-.14-.02-.02-.03-.05-.06-.05-.04-.01-.08.03-.06.07.01 0 .03.03.01.04-.02.04-.06 0-.05-.04 0-.05.04-.08.08-.1.04-.02.1 0 .1.03l.1.15c0 .02.04.01.04-.01v-.02s.02.01.01.02c0 .03-.02.1-.07.07l-.02-.02zm-.01-.02l-.06-.1c-.03.03-.05.07-.06.1 0 .05.06.1.09.06a.16.16 0 0 0 .03-.06zM499.01 300.66l.05.09-.03-.02c-.03-.03-.1-.02-.11.03-.02.05.04.06.08.05h.11c.05.02.07.08.05.12-.02.05-.08.07-.12.08 0 0-.01.03-.02.02a44.9 44.9 0 0 1-.06-.09c.02-.02.03.02.04.02.04.03.11.02.13-.03.01-.04-.04-.07-.08-.06h-.12a.09.09 0 0 1-.03-.13c.02-.04.07-.04.1-.06v-.02zM499.18 300.7c.02.04.06.08.11.08s.1-.04.1-.09v-.04c.02 0 .02.03.02.04 0 .05 0 .1-.04.13a.13.13 0 0 1-.15 0 .22.22 0 0 1-.09-.12.14.14 0 0 1 .06-.15.11.11 0 0 1 .12-.01c.02 0 .04.03.05.05l-.18.11zm-.01-.02l.12-.07c-.02-.05-.09-.06-.12-.02-.02.03-.02.07 0 .1zM499.4 300.41l.04.06c0-.04 0-.1.05-.11.04 0 .05.06.01.06-.02 0-.05 0-.05.02v.06l.08.13c.02.03.05.03.07.01v.02l-.12.08c-.02-.02.01-.02.02-.04l-.02-.06-.1-.14c0-.02-.03-.01-.04 0 0 0-.02 0 0 0l.05-.08.01-.01zM499.63 300.42c.02.04.06.08.11.08s.1-.04.1-.09v-.04c.02 0 .02.03.02.04 0 .05 0 .1-.04.13a.13.13 0 0 1-.15 0 .22.22 0 0 1-.09-.12.14.14 0 0 1 .06-.15.11.11 0 0 1 .12-.01c.02 0 .04.03.05.05l-.18.11zm-.01-.02l.12-.07c-.02-.05-.09-.06-.12-.02-.02.03-.02.07 0 .1zM499.76 300.01c.04-.03.07.05.03.06-.04.02-.06-.04-.03-.06zm.1.12l.14.23c.01.02.05.03.07.01v.01l-.12.08c-.02-.02.02-.02.02-.04 0-.03-.02-.05-.04-.07l-.07-.12c-.01-.03-.04-.02-.05 0 0 0-.02 0 0-.01l.05-.08zM500.1 299.97l.05.09-.03-.02c-.03-.03-.1-.02-.11.03-.02.05.04.06.08.05h.11c.05.02.07.08.05.12-.02.05-.08.07-.12.08 0 0-.01.03-.02.02l-.06-.09c.02-.02.03.02.04.02.04.03.11.02.13-.03.01-.04-.04-.07-.08-.06h-.12a.09.09 0 0 1-.03-.13c.02-.04.07-.04.1-.06v-.02zM500.29 299.85l.12-.08v.02c-.02 0-.01.04.01.05l.15.11-.03-.2c0-.02-.02-.03-.04-.02h-.01l.08-.06v.02c-.02.01-.01.04 0 .06 0 .1.02.18.04.28h-.02l-.23-.17c-.02-.01-.05 0-.07 0v-.01zM500.7 299.73c.02.04.06.08.11.08s.1-.04.1-.09v-.04c.02 0 .02.03.02.04 0 .05 0 .1-.04.13a.13.13 0 0 1-.15 0 .22.22 0 0 1-.09-.12.14.14 0 0 1 .06-.15.11.11 0 0 1 .12-.01c.02 0 .04.03.05.05l-.18.11zm-.01-.02l.12-.07c-.02-.05-.09-.06-.12-.02-.02.03-.02.07 0 .1zM500.93 299.44l.04.06c0-.04 0-.1.05-.11.04 0 .05.06.01.06-.02 0-.05 0-.05.02v.06l.08.13c.02.03.05.03.07.01v.02l-.12.08c-.02-.02.01-.02.02-.04l-.02-.06-.1-.14c0-.02-.03-.01-.04 0 0 0-.02 0 0 0l.05-.08.01-.01zM501.37 299.49c0 .05-.05.1-.1.1-.06 0-.12-.03-.14-.08a.19.19 0 0 1 0-.18c.01-.04.07-.07.1-.06l-.06-.1c-.01-.02-.04 0-.05 0v-.01l.05-.07h.02l.2.32c0 .03.04.06.06.03 0-.02.02 0 0 0l-.05.08h-.01l-.02-.03zm-.01-.02l-.09-.14c-.02-.03-.07-.05-.1-.02-.04.04-.03.1 0 .13.02.05.06.1.11.1.04 0 .07-.03.08-.07zM501.63 299.33c-.02.04-.03.1-.08.1-.06.02-.1-.04-.09-.1.02-.05.05-.1.09-.14-.02-.02-.03-.05-.06-.05-.04-.01-.08.03-.06.07.01 0 .03.03.01.04-.02.04-.06 0-.05-.04 0-.05.04-.08.08-.1.04-.02.1 0 .1.03l.1.15c0 .02.04 0 .04-.01v-.02s.02.01.01.02c0 .03-.02.1-.07.07l-.02-.02zm-.01-.02l-.06-.1c-.03.03-.05.07-.06.1 0 .05.06.1.09.06a.16.16 0 0 0 .03-.06zM501.92 299.14c0 .05-.05.1-.1.1-.06 0-.12-.03-.14-.08a.19.19 0 0 1 0-.18c.01-.04.07-.07.1-.06l-.06-.1c-.01-.02-.04 0-.05 0v-.01l.05-.07h.02l.2.32c0 .03.04.06.06.03 0-.02.02 0 0 0l-.05.08h-.01l-.02-.03zm-.01-.02l-.09-.14c-.02-.03-.07-.05-.1-.02-.04.04-.03.1 0 .13.02.05.06.1.11.1.04 0 .07-.03.08-.07zM501.99 298.92c.02.04.06.08.11.08s.1-.04.1-.09v-.04c.02 0 .02.03.02.04 0 .05 0 .1-.04.13a.13.13 0 0 1-.15 0 .22.22 0 0 1-.09-.12.14.14 0 0 1 .06-.15.11.11 0 0 1 .12-.01c.02 0 .04.03.05.05l-.18.11zm-.01-.02l.12-.07c-.02-.05-.09-.06-.12-.02-.02.03-.02.07 0 .1zM502.22 298.62l.04.06c0-.04 0-.1.05-.11.04 0 .05.06.01.06-.02 0-.05 0-.05.02v.06l.08.13c.02.03.05.03.07.01v.02l-.12.08c-.02-.02.01-.02.02-.04l-.02-.06-.1-.14c0-.02-.03-.01-.04 0 0 0-.02 0 0 0l.05-.08.01-.01zM502.63 298.69c-.02.04-.03.1-.08.1-.06.02-.1-.04-.09-.1.02-.05.05-.1.09-.14-.02-.02-.03-.05-.06-.05-.04-.01-.08.03-.06.07.01 0 .03.03.01.04-.02.04-.06 0-.05-.04 0-.05.04-.08.08-.1.04-.02.1 0 .1.03l.1.15c0 .02.04 0 .04-.01v-.02s.02.01.01.02c0 .03-.02.1-.07.07l-.02-.02zm-.01-.02l-.06-.1c-.03.03-.05.07-.06.1 0 .05.06.1.09.06a.16.16 0 0 0 .03-.06zM502.71 298.4c0-.05.02-.1.07-.12.03-.01.06 0 .09.02 0-.04.02-.1.06-.12.04-.02.09.01.11.05l.1.15c0 .02.04 0 .05 0 .01.01 0 .02-.01.02l-.11.07c-.02-.02.03-.02.02-.05l-.04-.08-.07-.1c-.04-.04-.09.01-.1.05v.04l.1.15c0 .03.04 0 .06 0l-.02.02-.11.07c-.02-.02.03-.02.02-.05l-.04-.07-.06-.1c-.03-.04-.09-.01-.1.03 0 .02-.02.04 0 .05l.09.15c.01.03.04 0 .06 0l-.01.02-.12.07c-.01-.02.04-.02.02-.05 0-.03-.03-.06-.05-.1l-.07-.1c-.02 0-.04.04-.04.01l.05-.08h.02l.03.05zM503.15 298.18c.02.04.06.08.11.08s.1-.04.1-.09v-.04c.02 0 .02.03.02.04 0 .05 0 .1-.04.13a.13.13 0 0 1-.15 0 .22.22 0 0 1-.09-.12.14.14 0 0 1 .06-.15.11.11 0 0 1 .12-.01c.02 0 .04.03.05.05l-.18.11zm-.01-.02l.12-.07c-.02-.05-.09-.06-.12-.02-.02.03-.02.07 0 .1zM503.42 297.95c0-.04.02-.1.06-.12.04-.02.08 0 .1.04l.1.15c.01.03.04.03.06.01v.02l-.12.07v-.02c.03-.01.01-.05 0-.07l-.07-.12c-.02-.03-.07-.04-.1-.01 0 .02-.03.05-.02.07l.1.15c0 .03.04.02.06.01v.01l-.13.08.01-.02c.03-.02 0-.05 0-.07l-.1-.14c0-.03-.03-.01-.05 0v-.02l.05-.07h.02l.03.05zM503.62 297.62l.05.09.06-.04.02.02-.06.04.1.17c.01.03.05.04.06.01.02-.01 0-.03.02-.04.01.04 0 .1-.04.1-.04.02-.07-.01-.09-.04l-.1-.17-.04.02c-.02-.01 0-.02 0-.04.02-.04.01-.08.01-.11l.01-.01zM503.86 297.73c.02.04.06.08.11.08s.1-.04.1-.09v-.04c.02 0 .02.03.02.04 0 .05 0 .1-.04.13a.13.13 0 0 1-.15 0 .22.22 0 0 1-.09-.12.14.14 0 0 1 .06-.15.11.11 0 0 1 .12-.01c.02 0 .04.03.05.05l-.18.11zm-.01-.02l.12-.07c-.02-.05-.09-.06-.12-.02a.09.09 0 0 0 0 .1zM499.4 301.51c0-.05.02-.1.07-.12.03-.01.06 0 .09.02 0-.04.02-.1.06-.12.04-.02.09.01.11.05l.1.15c0 .02.04 0 .05 0 .01.01 0 .02-.01.02l-.11.07c-.02-.02.03-.02.02-.05l-.04-.08-.07-.1c-.04-.04-.09.01-.1.05v.04l.1.15c0 .03.04 0 .06 0l-.02.02-.11.07c-.02-.02.03-.02.02-.05l-.04-.07-.06-.1c-.03-.04-.09-.01-.1.03 0 .02-.02.04 0 .05l.09.15c.01.03.04 0 .06 0l-.01.02-.12.07c-.01-.02.04-.02.02-.05 0-.03-.03-.05-.04-.08l-.07-.11c-.02-.03-.05.03-.05 0l.05-.08h.02l.03.05zM499.72 301.04c.04-.03.07.05.03.06-.04.02-.06-.04-.03-.06zm.1.12l.14.23c.01.02.05.03.07.01v.01l-.12.08c-.02-.02.02-.02.02-.04 0-.03-.02-.05-.04-.07l-.07-.12c-.01-.03-.04-.02-.05 0 0 0-.02 0 0-.01l.05-.08zM500.07 301l.05.09-.03-.02c-.03-.03-.1-.02-.11.03-.02.05.04.06.08.05h.11c.05.02.07.08.05.12-.02.05-.08.07-.12.08 0 0-.01.03-.02.02a44.9 44.9 0 0 1-.06-.09c.02-.02.03.02.04.02.04.03.11.02.13-.03.01-.04-.04-.07-.08-.06h-.12a.09.09 0 0 1-.03-.13c.02-.04.07-.04.1-.06l.01-.02zM500.61 301.01c0 .05-.05.1-.1.1-.06 0-.12-.03-.14-.08a.19.19 0 0 1 0-.18c.01-.04.07-.07.1-.06l-.06-.1c-.01-.03-.04 0-.05 0v-.01l.05-.07h.02l.2.32c0 .03.04.06.06.03 0-.02.02 0 0 0l-.05.08h-.01l-.02-.03zm-.01-.02l-.09-.14c-.02-.03-.07-.05-.1-.02-.04.04-.03.1 0 .13.02.05.06.1.11.1.04 0 .07-.03.08-.07zM500.55 300.52c.04-.03.07.05.03.06-.04.02-.06-.04-.03-.06zm.1.12l.14.23c.01.02.05.03.07.01v.01l-.12.08c-.02-.02.02-.02.02-.04 0-.03-.02-.05-.04-.07l-.07-.12c-.01-.03-.04-.02-.05 0 0 0-.02 0 0-.01l.05-.08zM500.89 300.48l.05.09-.03-.02c-.03-.03-.1-.02-.11.03-.02.05.04.06.08.05h.11c.05.02.07.08.05.12-.02.05-.08.07-.12.08 0 0-.01.03-.02.02l-.06-.09c.02-.02.03.02.04.02.04.03.11.02.13-.03.01-.04-.04-.07-.08-.06h-.12a.09.09 0 0 1-.03-.13c.02-.04.07-.04.1-.06v-.02zM501.27 300.47c.02.05.02.1-.01.15a.11.11 0 0 1-.13.04c-.05-.01-.1-.07-.12-.12-.02-.06 0-.15.06-.18.04-.03.1-.03.13 0 .02.05-.05.08-.07.03-.03-.04-.1.01-.09.06 0 .04.03.09.06.12.03.02.07.04.1.03.05-.02.07-.07.06-.12l.01-.01zM501.19 300.11c.04-.03.07.05.03.06-.04.02-.06-.04-.03-.06zm.1.12l.14.23c.01.02.05.03.07.01v.01l-.12.08c-.02-.02.02-.02.02-.04 0-.03-.03-.05-.04-.07l-.07-.12c-.01-.03-.04-.02-.05 0 0 0-.02 0 0-.01l.05-.08zM501.37 300.23l.06-.08h.02c0 .02.02.03.03.05 0-.04 0-.1.04-.11.04-.03.1-.02.13 0 .06.06.1.15.07.23a.12.12 0 0 1-.1.08h-.02l.06.1c.02.02.05 0 .06 0v.01l-.13.08v-.02c.04-.02.02-.05 0-.08l-.16-.25c0-.04-.04-.02-.05 0l-.01-.01zm.12-.01l.08.13c.03.04.08.03.1 0 .04-.04.02-.1 0-.13-.02-.04-.06-.09-.12-.09-.04 0-.06.05-.06.09zM501.64 299.82c.04-.03.07.05.03.06-.04.02-.06-.04-.03-.06zm.1.12l.14.23c.01.02.05.03.07.01v.01l-.12.08c-.02-.02.02-.02.02-.04 0-.03-.02-.05-.04-.07l-.07-.12c-.01-.03-.04-.02-.05 0 0 0-.02 0 0-.01l.05-.08zM501.82 299.71l.22.36c.01.03.04.03.07.01v.02l-.13.07c-.01-.02.03-.02.02-.04 0-.03-.02-.05-.03-.07l-.15-.25c-.01-.02-.04-.04-.05-.01h-.02l.06-.08h.01zM502.1 299.71c.04-.03.1-.03.14 0 .07.03.1.1.1.18-.01.07-.1.14-.17.12a.17.17 0 0 1-.13-.14c-.01-.05 0-.1.02-.13a.14.14 0 0 1 .04-.03zm0 .02c-.04.03-.03.09-.01.13.03.05.07.1.12.11.04.01.09-.02.09-.06 0-.04-.03-.09-.05-.12-.03-.04-.09-.08-.14-.06zM502.43 299.5l.05.09-.03-.02c-.03-.03-.1-.02-.11.03-.02.05.04.06.08.05h.11c.05.02.07.08.05.12-.02.05-.08.07-.12.08 0 0-.01.03-.02.02a44.9 44.9 0 0 1-.06-.09c.02-.02.03.02.04.02.04.03.11.02.13-.03.01-.04-.04-.07-.08-.06h-.12a.09.09 0 0 1-.03-.13c.02-.04.07-.04.1-.06l.01-.02zM500.67 303.76c0-.05 0-.1.04-.14.03-.02.08-.04.12-.02.04.03.05.08.04.13 0 0-.02.03 0 .02.05 0 .1.02.13.07.04.06.02.15-.03.2l-.1.05c-.04 0-.04-.06 0-.06s.1 0 .11-.05c.02-.05 0-.1-.05-.13-.04-.02-.08-.01-.12 0 0 .02-.01.02-.01 0 .03-.02.06-.08.04-.12-.01-.05-.07-.07-.11-.05-.04.02-.04.07-.05.1h-.01zM501.34 303.66l.02.1-.23.14c-.02-.03.01-.05.01-.08.02-.08.05-.17.03-.26-.01-.05-.05-.1-.1-.1-.06 0-.1.06-.1.12v.02c-.03-.05-.03-.1 0-.15.04-.04.11-.06.17-.04.05.03.07.09.07.14 0 .09-.02.17-.04.25 0 0 0 .02 0 0 .05-.02.1-.04.13-.07.03-.02.03-.05.03-.07h.01zM501.45 303.62c.02-.01.05 0 .05.02.01.02 0 .05-.02.05a.04.04 0 0 1-.05-.03c0-.02 0-.03.02-.04zM501.73 302.97l.13-.09c.02.02-.01.03-.01.04-.03.04-.02.1-.02.14v.16l.07.12c.02.03.05.02.07 0v.02l-.15.1v-.02c.04-.02.03-.07 0-.1 0-.02-.03-.05-.05-.08-.08-.04-.15-.08-.24-.11-.02-.02-.05 0-.07 0l.02-.02.14-.1c.02.02 0 .02-.01.04-.03.03.02.05.04.06l.15.07v-.2c0-.03-.04-.04-.06-.02l-.01-.01zM502.44 302.93c.02.05.02.1-.01.15a.11.11 0 0 1-.13.04c-.05-.01-.1-.07-.12-.12-.02-.06 0-.15.06-.18.04-.03.1-.03.13 0 .02.05-.05.08-.07.03-.03-.04-.1.01-.09.06 0 .04.03.09.06.12.03.02.07.04.1.03.05-.02.07-.07.06-.12l.01-.01zM502.5 302.66c.04-.03.1-.03.14 0 .07.03.1.1.1.18-.01.07-.1.14-.17.12a.17.17 0 0 1-.13-.14c-.01-.05 0-.1.03-.14l.03-.02zm0 .02c-.04.03-.03.09-.01.13.03.05.07.1.12.11.04.01.09-.02.09-.06 0-.04-.03-.09-.05-.12-.03-.04-.09-.08-.14-.06zM502.77 302.55c0-.04.02-.1.06-.12.04-.02.08 0 .1.04l.1.15c.01.03.04.03.06.01v.02l-.12.07v-.02c.03-.01.01-.05 0-.07l-.07-.12c-.02-.03-.07-.04-.1-.01 0 .02-.03.05-.02.07l.1.15c0 .03.04.02.06.01v.01l-.13.08.01-.02c.03-.02 0-.05 0-.07l-.1-.14c0-.03-.03-.01-.05 0v-.02l.05-.07h.02l.03.05zM503.08 302.29c.04-.03.1-.03.14 0 .07.03.1.1.1.17-.01.08-.09.14-.16.13a.17.17 0 0 1-.14-.14c-.01-.05 0-.1.03-.14l.03-.02zm0 .02c-.04.03-.03.09-.01.13.03.05.07.1.12.11.04.01.09-.02.09-.06 0-.04-.03-.09-.05-.12-.03-.04-.09-.08-.14-.06zM503.57 302.22c.02.05.02.1-.01.15a.11.11 0 0 1-.13.04c-.05-.01-.1-.07-.12-.12-.02-.06 0-.15.06-.18.04-.03.1-.03.13 0 .02.05-.05.08-.07.03-.03-.04-.1.01-.09.06 0 .04.03.09.06.12.03.02.07.04.1.03.05-.02.07-.07.06-.12l.01-.01zM503.61 302.1c.02.04.06.08.11.08s.1-.04.1-.09v-.04c.02 0 .02.03.02.04 0 .05 0 .1-.04.13a.13.13 0 0 1-.15 0 .22.22 0 0 1-.09-.12.14.14 0 0 1 .06-.15.11.11 0 0 1 .12-.02l.05.06-.18.11zm-.01-.02l.12-.07c-.02-.05-.09-.06-.12-.02-.02.03-.02.07 0 .1zM503.83 301.81l.04.06c0-.04 0-.1.05-.11.04 0 .05.06.01.06-.02 0-.05 0-.05.02v.06l.08.13c.02.03.05.03.07.01v.02l-.12.08c-.02-.02.01-.02.02-.04l-.02-.06-.1-.14c0-.02-.03-.01-.04 0 0 0-.02 0 0 0l.05-.08.01-.01zM504.06 301.82c.02.04.06.08.11.08s.1-.04.1-.09v-.04c.02 0 .02.03.02.04 0 .05 0 .1-.04.13a.13.13 0 0 1-.15 0 .22.22 0 0 1-.09-.12.14.14 0 0 1 .06-.15.11.11 0 0 1 .12-.02l.05.06-.18.11zm-.01-.02l.12-.07c-.02-.05-.09-.06-.12-.02-.02.03-.02.07 0 .1zM504.19 301.38c.04-.03.07.05.03.06-.04.02-.06-.04-.03-.06zm.1.12l.14.23c.01.02.05.03.07.01v.01l-.12.08c-.02-.02.02-.02.02-.04 0-.03-.02-.05-.04-.07l-.07-.12c-.01-.03-.04-.02-.05 0 0 0-.02 0 0-.01l.05-.08zM504.54 301.37l.05.09-.03-.02c-.03-.03-.1-.02-.11.03-.02.05.04.06.08.05h.11c.05.02.07.08.05.12-.02.05-.08.07-.12.08 0 0-.01.03-.02.02l-.06-.09c.02-.02.03.02.04.02.04.03.11.02.13-.03.01-.04-.04-.07-.08-.06h-.12a.09.09 0 0 1-.03-.13c.02-.04.07-.04.1-.06l.01-.02zM504.74 301.03l.22.36c.01.03.04.03.07.01v.02l-.13.07c-.01-.02.03-.02.02-.04 0-.03-.02-.05-.03-.07l-.15-.25c-.01-.02-.04-.04-.05-.01h-.02l.06-.08.01-.01zM505.19 301.28c-.02.04-.03.1-.08.1-.05.02-.1-.04-.09-.08.01-.06.05-.1.08-.15l-.01-.03c-.02-.04-.08-.04-.1 0v.04c.03.02.01.06-.02.05-.04-.02-.03-.08 0-.11.04-.03.08-.06.12-.05.03 0 .05.04.06.06l.08.13c0 .02.04 0 .04-.01v-.02s.02.01.01.02c0 .03-.02.1-.07.07l-.02-.02zm-.01-.02l-.06-.1c-.03.03-.05.07-.06.1 0 .05.06.1.09.06a.16.16 0 0 0 .03-.06zM501.13 304.57l.12-.08v.02c-.02 0-.01.04.01.05l.15.11-.03-.2c0-.02-.02-.03-.04-.02h-.01l.08-.06v.02c-.02.01-.01.04 0 .06 0 .1.02.19.04.28h-.02l-.23-.17c-.02-.01-.05 0-.07 0v-.01zM501.53 304.43c.02.04.06.08.11.08s.1-.04.1-.09v-.04c.02 0 .02.03.02.04 0 .05 0 .1-.04.13a.13.13 0 0 1-.15 0 .22.22 0 0 1-.09-.12.14.14 0 0 1 .06-.15.11.11 0 0 1 .12-.01c.02 0 .04.03.05.05l-.18.11zm-.01-.02l.12-.07c-.02-.05-.09-.06-.12-.02-.02.03-.02.07 0 .1zM501.75 304.14l.04.06c0-.04 0-.1.05-.11.04 0 .05.06.01.06-.02 0-.05 0-.05.02v.06l.08.13c.02.03.05.03.07.01v.02l-.12.08c-.02-.02.01-.02.02-.04l-.02-.06-.1-.14c0-.02-.03-.01-.04 0 0 0-.02 0 0 0l.05-.08.01-.01zM502.21 304.21c0 .05-.05.1-.1.1-.06 0-.12-.03-.14-.08a.19.19 0 0 1 0-.18c.01-.04.07-.07.1-.06l-.06-.1c-.01-.03-.04 0-.05 0v-.01l.05-.07h.02l.2.32c0 .03.04.06.06.03 0-.02.02 0 0 0l-.05.08h-.01l-.02-.03zm-.01-.02l-.09-.14c-.02-.03-.08-.05-.1-.02-.04.04-.03.1 0 .13.02.05.06.1.11.1.04 0 .07-.03.08-.07zM502.45 304.03c-.02.04-.03.1-.08.1-.06.02-.1-.04-.09-.1.02-.05.05-.1.09-.14-.02-.02-.03-.05-.06-.05-.04-.01-.08.03-.06.07.01 0 .03.03.01.04-.02.04-.06 0-.05-.04 0-.05.04-.08.08-.1.04-.02.1 0 .1.03l.1.15c0 .02.04 0 .04-.01v-.02s.02.01.01.02c0 .03-.02.1-.07.07l-.02-.02zm-.01-.02l-.06-.1c-.03.03-.05.07-.06.1 0 .05.06.1.09.06a.16.16 0 0 0 .03-.06zM502.75 303.86c0 .05-.05.1-.1.1-.06 0-.12-.03-.14-.08a.19.19 0 0 1 0-.18c.01-.04.07-.07.1-.06l-.06-.1c-.01-.03-.04 0-.05 0v-.01l.05-.07h.02l.2.32c0 .03.04.06.06.03 0-.02.02 0 0 0l-.05.08h-.01l-.02-.03zm-.01-.02l-.09-.14c-.02-.03-.07-.05-.1-.02-.04.04-.03.1 0 .13.02.05.06.1.11.1.04 0 .07-.03.08-.07zM502.95 303.91v-.01c.02-.03.03-.1 0-.12-.01 0-.01.02-.03.02-.02.02-.06-.01-.05-.04.01-.04.07-.05.1-.02.03.04.03.1 0 .13l-.02.04zM502.99 303.38l.12-.08c.02.02 0 .02-.01.03-.01.03.02.04.04.06l.13.08-.03-.19c0-.03-.03-.03-.05-.02l.01-.01.07-.05c.02.02-.01.03 0 .05l.02.2.03.17c0 .05 0 .1-.05.12-.04.03-.08-.03-.04-.06.03 0 .07 0 .07-.04l-.02-.1-.22-.14a.09.09 0 0 0-.07-.01v-.01zM503.44 302.89l.22.36c.01.03.04.03.07.01v.02l-.13.07c-.01-.02.03-.02.02-.04 0-.03-.02-.05-.03-.07l-.15-.25c-.01-.02-.04-.04-.05-.01h-.02l.06-.08h.01zM503.88 303.12c-.02.04-.03.1-.08.1-.06.02-.1-.04-.09-.1.02-.05.05-.1.09-.14-.02-.02-.03-.05-.06-.05-.04-.01-.08.03-.06.07.01 0 .03.03.01.04-.02.04-.06 0-.05-.04 0-.05.04-.08.08-.1.04-.02.1 0 .1.03l.1.15c0 .02.04 0 .04-.01v-.02s.02.01.01.02c0 .03-.02.1-.07.07l-.02-.02zm-.01-.02l-.06-.1c-.03.03-.05.07-.06.1 0 .05.06.1.09.06a.16.16 0 0 0 .03-.06zM503.99 302.75l.12-.08v.02c-.02 0-.01.04.01.05l.15.11-.03-.2c0-.02-.02-.03-.04-.02h-.01l.08-.06v.02c-.02.01-.01.04 0 .06 0 .1.02.19.04.28h-.02l-.23-.17c-.02-.01-.05 0-.07 0v-.01zM504.39 302.61c.02.04.06.08.11.08s.1-.04.1-.09v-.04c.02 0 .02.03.02.04 0 .05 0 .1-.04.13a.13.13 0 0 1-.15 0 .22.22 0 0 1-.09-.12.14.14 0 0 1 .06-.15.11.11 0 0 1 .12-.01c.02 0 .04.03.05.05l-.18.11zm-.01-.02l.12-.07c-.02-.05-.09-.06-.12-.02-.02.03-.02.07 0 .1zM504.62 302.32l.04.06c0-.04 0-.1.05-.11.04 0 .05.06.01.06-.02 0-.05 0-.05.02v.06l.08.13c.02.03.05.03.07.01v.02l-.12.08c-.02-.02.01-.02.02-.04l-.02-.06-.1-.14c0-.02-.03-.01-.04 0 0 0-.02 0 0 0l.05-.08.01-.01zM505.07 302.39c0 .05-.05.1-.1.1-.06 0-.12-.03-.14-.08a.2.2 0 0 1 0-.18c.01-.04.07-.07.1-.06l-.06-.1c-.02-.03-.04 0-.05 0v-.01l.05-.07h.02l.2.32c0 .03.04.06.06.03 0-.02.02 0 0 0l-.05.08h-.01l-.02-.03zm-.01-.02l-.09-.14c-.02-.03-.08-.05-.1-.02-.04.04-.03.1 0 .13.02.05.06.1.11.1.04 0 .07-.03.08-.07zM505.32 302.21c-.02.04-.03.1-.08.1-.06.02-.1-.04-.09-.1.02-.05.05-.1.09-.14-.02-.02-.03-.05-.06-.05-.04-.01-.08.03-.06.07.01 0 .03.03.01.04-.02.04-.06 0-.05-.04 0-.04.04-.08.08-.1.03-.02.09-.01.1.03l.1.15c0 .02.04 0 .04-.01v-.02s.02.01.01.02c0 .03-.02.1-.07.07l-.02-.02zm-.01-.02l-.06-.1c-.03.03-.05.07-.06.1 0 .05.06.1.09.06a.16.16 0 0 0 .03-.06zM505.62 302.04c0 .05-.05.1-.1.1-.06 0-.12-.03-.14-.08a.19.19 0 0 1 0-.18c.01-.04.07-.07.1-.06l-.06-.1c-.01-.03-.04 0-.05 0v-.01l.05-.07h.02l.2.32c0 .03.04.06.06.03 0-.02.02 0 0 0l-.05.08h-.01l-.02-.03zm-.01-.02l-.09-.14c-.02-.03-.07-.05-.1-.02-.04.04-.03.1 0 .13.02.05.06.1.11.1.04 0 .07-.03.08-.07zM505.85 301.54c.04-.03.1-.03.14 0 .07.03.1.1.1.18-.01.07-.1.14-.17.12a.17.17 0 0 1-.13-.14c-.01-.05 0-.1.03-.14l.03-.02zm0 .02c-.04.03-.03.09-.01.13.03.05.07.1.12.11.04.01.09-.02.09-.06 0-.05-.03-.09-.05-.12-.03-.04-.09-.08-.14-.06zM506.18 301.33l.05.09-.03-.02c-.03-.03-.1-.02-.11.03-.02.05.04.06.08.05h.11c.05.02.07.08.05.12-.02.05-.08.07-.12.08 0 0-.01.03-.02.02a44.9 44.9 0 0 1-.06-.09c.02-.02.03.02.04.02.04.03.11.02.13-.03.01-.04-.04-.07-.08-.06h-.12a.09.09 0 0 1-.03-.13c.02-.04.07-.04.1-.06v-.02zM501.57 305.09l.12.2c0-.05.01-.1.06-.12.04-.02.08 0 .1.04l.1.15c.01.03.04.01.06 0l-.01.03-.12.07c-.01-.02.02-.02.02-.03.02-.03 0-.05-.02-.07l-.08-.13c-.03-.04-.09 0-.1.05l.01.04.09.14c.01.03.04 0 .06 0l-.01.02-.12.07c-.01-.02.04-.02.02-.05 0-.03-.03-.06-.05-.09l-.14-.22c0-.03-.04-.02-.05 0v-.02l.05-.07.01-.01zM502.17 305.24c-.02.04-.03.1-.08.1-.06.02-.1-.04-.09-.1.02-.05.05-.1.09-.14-.02-.02-.03-.05-.06-.05-.04-.01-.08.03-.06.06.01.02.03.04.01.05-.02.04-.06 0-.05-.04 0-.05.04-.08.08-.1.04-.02.1 0 .1.03l.1.15c0 .02.04 0 .04-.01v-.02s.02.01.01.02c0 .03-.02.1-.07.07l-.02-.02zm-.01-.02l-.06-.1c-.03.03-.05.07-.06.1 0 .05.06.1.09.06a.16.16 0 0 0 .03-.06z'/%3E %3Cpath d='M502.21 304.89l.04.06c0-.04 0-.1.05-.11.04 0 .05.06.01.06-.02 0-.05 0-.05.02v.06l.08.13c.02.03.05.03.07.01v.02l-.12.08c-.02-.02.01-.02.02-.04l-.02-.06-.1-.14c0-.02-.03-.01-.04 0 0 0-.02 0 0 0l.05-.08.01-.01zM502.61 304.96c-.02.04-.03.1-.08.1-.06.02-.1-.04-.09-.1.02-.05.05-.1.09-.14-.02-.02-.03-.05-.06-.05-.04-.01-.08.03-.06.06.01.02.03.04.01.05-.02.04-.06 0-.05-.04 0-.05.04-.08.08-.1.04-.02.1 0 .1.03l.1.15c0 .02.04.01.04-.01v-.02s.02.01.01.02c0 .03-.02.1-.07.07l-.02-.02zm-.01-.02l-.06-.1c-.03.03-.05.07-.06.1 0 .05.06.1.09.06a.16.16 0 0 0 .03-.06zM502.73 304.36l.22.36c.01.03.04.03.07.01v.02l-.13.07c-.01-.02.03-.02.02-.04 0-.03-.02-.05-.03-.07l-.15-.25c-.01-.02-.04-.04-.05-.01h-.02l.06-.08.01-.01zM502.86 304.27c.04-.03.07.05.03.06-.04.02-.06-.04-.03-.06zm.1.12l.14.23c.01.02.05.03.07.01v.01l-.12.08c-.02-.02.02-.02.02-.04 0-.03-.03-.05-.04-.07l-.07-.12c-.01-.03-.04-.02-.05 0 0 0-.02 0 0-.01l.05-.08zM503.15 304.35c0-.04.02-.1.06-.11.06-.02.12 0 .15.04.04.05.06.12.04.18a.15.15 0 0 1-.13.1c-.02 0-.05.02-.06 0l-.18-.3c0-.02-.04-.04-.05 0 0 0-.02-.01-.01-.02l.05-.07s.02-.02.02 0l.11.18zm.01.02l.1.16c.04 0 .1-.01.1-.06.02-.05-.01-.1-.05-.14-.02-.04-.08-.05-.12-.02-.02.01-.02.04-.03.06zM503.42 304.12l.04.06c0-.04 0-.1.05-.11.04 0 .05.06.01.06-.02 0-.05 0-.05.02v.06l.08.13c.02.03.05.03.07.01v.02l-.12.08c-.02-.02.01-.02.02-.04l-.02-.06-.1-.14c0-.02-.03-.01-.04 0 0 0-.02 0 0 0l.05-.08.01-.01zM503.64 304.13c.02.04.06.08.11.08s.1-.04.1-.09v-.04c.02 0 .02.03.02.04 0 .05 0 .1-.04.13a.13.13 0 0 1-.15 0 .22.22 0 0 1-.09-.12.14.14 0 0 1 .06-.15.11.11 0 0 1 .12-.02l.05.06-.18.11zm-.01-.02l.12-.07c-.02-.05-.09-.06-.12-.02-.02.03-.02.07 0 .1zM503.96 303.78l.05.09-.03-.02c-.03-.03-.1-.02-.11.03-.02.05.04.06.08.05h.11c.05.02.07.08.05.12-.02.05-.08.07-.12.08 0 0-.01.03-.02.02l-.06-.09c.02-.02.03.02.04.02.04.03.11.02.13-.03.01-.04-.04-.07-.08-.06h-.12a.09.09 0 0 1-.03-.13c.02-.04.07-.04.1-.06l.01-.02zM504.2 303.92c.02-.01.05 0 .05.02.01.02 0 .05-.02.05a.04.04 0 0 1-.05-.03c0-.02 0-.03.02-.04z'/%3E %3C/g%3E %3C/g%3E %3C/g%3E %3Cpath fill='%23201b18' d='M362.48 203.9c-6.2-.11-12.45 1.3-17.65 4.53-2.4 1.48-2.96 1.98-1.64 4.37-.31.21-2.49.88-3.03 1.07-1.99.75-4.01 1.5-5.7 2.52-1.03.62-1.46 1.08-2.25 1.9l4.96-.38c-.15.32-.51.79-.71 1.1-.85 1.22-1.38 2.19-2.12 3.47 1.4-.95 2.67-1.84 4.3-2.63 3.54-1.8 9.93-1.84 12.55-4.99.67-.8.26-1.27-.3-2.56 1.94-.64 2.67-1.1 5.02-1.63 5.7-1.27 9.62.24 12.37-.44.86-.21 1.7-.68 1.76-1.59l-.4-2.87 9.24-.01c0 1.63-1.56 3.71 1.31 4.46 2.6.68 7.85-.8 12.38.45l5.02 1.63c-.02.24-.38.88-.49 1.21-.21.58-.19.89.18 1.3a7.88 7.88 0 0 0 1.93 1.55 20.6 20.6 0 0 0 5.21 1.81c5.23 1.27 5.72 1.6 9.74 4.29-.27-.78-2.18-3.57-2.81-4.56l4.94.4c-.85-1.3-3.46-2.67-4.97-3.26l-6.01-2.2c.54-1.04 1-1.92.45-2.78-.84-1.27-5.86-3.74-7.13-4.09a63.61 63.61 0 0 0-6.58-1.41c-2.14-.35-6.26-.64-6.26-.64-.3-.31.57-1.94-.75-3.09-.78-.61-1.9-.83-3.05-.95-4.6-.44-10.85-.3-15.5 0-1.33.09-2.28.23-3.04.95-.93.88-1.05 1.42-.97 3.07z'/%3E %3Cg fill='%23002d62'%3E %3Cpath d='M363.77 207.17c.68-.6.78-.79 1.86-1.15 2.37-.8 6.1-.73 8.6-.73 2.04.01 4.02-.02 6.03.17 2.03.2 3.23.45 4.58 1.62.24-1.4.55-2.62.6-4.17.06-1.68-.89-2.17-2.37-2.47-2.45-.51-6.56-.46-9.2-.44-1.73.01-7.85.06-9.1.51-1.13.4-2.03 1.3-1.93 2.84.03.77.6 3.33.93 3.82z'/%3E %3Cpath d='M345.75 215.17c.42-.38.13-.76 2.07-1.84a32.35 32.35 0 0 1 8.66-3.18c2.43-.48 4.93-.47 7.46-.28 1.13.09 2.61.27 3.72.09 0 0 1.2-.28 1.54-.58.44-.39.41-1.29.41-1.29-.81-.65-3.13 1.6-5.24.9-.68-.23-.87-1.33-1.13-2.1l-.68-2.58c-3.86-.5-10.46 1.04-14.02 2.63-1.62.72-4.27 2.06-5.26 3.09-.89.9.02 2.22.52 2.88.64.83 1.49 1.8 1.95 2.26zM378.89 208.03c-.22 1.36.78 1.75 1.97 1.92 2.48.35 6.18-.78 11.1.18 2.1.42 4.16 1.12 6 1.87.73.3 3.32 1.5 3.84 2.03l.94 1.11c.26-.14 1.68-1.85 1.97-2.22.55-.7 1.36-1.96.53-2.92-.73-.84-3.92-2.49-5.33-3.1a36 36 0 0 0-7.2-1.92c-2.37-.4-7.09-.74-7.09-.74s-.3 4.39-1.5 4.75c-2.36.7-3.51-1.27-5.23-.96z'/%3E %3Cpath d='M397.51 213.48c-.15.68-.45.74.8 1.77 2.9 2.4 7.79 2.51 10.85 3.83 1.56.68 2.42 1.24 3.8 2.07-.14-.4-1.92-2.98-2.36-3.66 1.36-.02 3.14.1 4.54.2-.07-.06-.1-.13-.2-.2-2.05-1.8-7.29-3.45-9.92-4.32-.76.89-1.48 1.75-2.32 2.62-.32.31-.52.53-1.17.35-.81-.23-1.45-.93-1.94-1.37-.48-.42-1.44-1.23-2.08-1.29zM378.96 207.6c1.48.1 1.69.37 2.81.87.45.2 1.03.3 1.62.25.8-.06.9-.17 1.1-.8.32-.9-1.2-1.5-1.9-1.65l-3.27-.48zM369.51 207.6l-.3-1.77c-.99-.1-5.53.66-5.2 2.06.17.66.31.76 1.03.83 1.97.18 2.28-1.05 4.47-1.11zM346.12 215.44c.66 1.17 2.42-.93 3.44-1.69.59-.43.66-.42 1.32-.7l-.36-.57c-.56.12-1.97.9-2.5 1.18-.78.43-1.64.98-1.9 1.78z'/%3E %3Cpath d='M397.64 213.06c.22.1.43.13.68.28 1.47.86 3.27 3.15 3.97 2.3.43-.54-1.17-1.63-1.66-1.9l-2.6-1.24c-.14.12-.32.35-.39.56zM350.93 213.53c.15.67.45.73-.8 1.77-2.9 2.4-7.79 2.51-10.85 3.83-1.56.68-2.42 1.23-3.8 2.07.14-.4 1.92-2.98 2.36-3.66-1.36-.02-3.14.1-4.54.19.07-.05.1-.12.2-.19 2.05-1.8 7.29-3.45 9.92-4.32.27.28.5.6.75.89.31.38 1.22 1.4 1.57 1.73.32.31.52.52 1.17.35.81-.23 1.45-.93 1.94-1.37.48-.43 1.44-1.23 2.08-1.3z'/%3E %3C/g%3E %3Cg fill='%23eac102'%3E %3Cpath d='M351.62 206.83c-.42 0-.8.2-1.18.36-.12.03-.43.15-.19.26.19.08.19.32.27.48l.3.84c.15.46.32.9.48 1.34.03.12-.1.4.13.29.24-.1.49-.18.73-.27.34-.11.65-.34.81-.66.1-.14.1-.3.15-.46a.75.75 0 0 0 0-.4c-.04-.2-.05-.4-.14-.57-.1-.25-.2-.5-.4-.69a1.5 1.5 0 0 0-.63-.44.7.7 0 0 0-.33-.08zm-.2.3c.28-.02.49.23.62.45l.31.7c.12.37.25.75.2 1.14-.05.21-.25.35-.42.46-.18.1-.36-.08-.36-.26-.07-.19-.15-.37-.21-.56-.14-.32-.22-.66-.37-.99a4.32 4.32 0 0 1-.2-.67c-.06-.21.22-.27.38-.28h.05zM353.06 206.31c.06.1.23.12.22.28.07.19.14.38.18.58.05.16.08.32.15.47l.17.61c.07.2.14.4.18.6.03.15.15.33.05.48-.07.07-.04.17.07.12.16-.01.3-.12.46-.12.1-.03.31-.03.3-.14-.1-.09-.23-.15-.23-.3l-.2-.7-.16-.5c-.04-.13-.05-.26-.1-.39l-.25-.82c-.04-.1-.08-.22.03-.32.03-.16-.22-.02-.31-.02-.2.04-.37.12-.56.17zM355.78 205.55c-.24 0-.47.14-.64.3-.19.22-.32.5-.32.79-.01.26-.03.52.04.78.08.4.28.77.53 1.09.17.17.38.3.6.38.19.05.4.06.58.01.32-.1.56-.37.66-.68.07-.22.14-.44.12-.68 0-.22-.07-.42-.11-.64a2.39 2.39 0 0 0-.3-.65c-.13-.19-.3-.33-.47-.5a1.05 1.05 0 0 0-.66-.2h-.03zm-.01.21c.27.04.45.28.55.52.18.36.25.75.36 1.12.05.16.04.32.08.48.03.22.03.46-.06.67-.12.18-.4.24-.57.09-.17-.11-.24-.32-.34-.49-.06-.23-.18-.45-.22-.7-.05-.18-.13-.36-.14-.56-.05-.3-.13-.63-.02-.93.06-.14.21-.2.36-.2zM357.97 205.29c-.11.15-.2.3-.23.5-.04.19.03.38.06.57.07.17.19.33.36.42.25.18.53.3.8.43.19.07.39.19.44.39.05.14.07.3.02.43-.07.15-.22.29-.4.24a.62.62 0 0 1-.44-.2 1.1 1.1 0 0 1-.34-.54c-.07-.14-.21 0-.17.1-.03.16-.06.33-.03.49.1.1.26.16.39.24.16.08.33.14.51.14.17-.02.36-.01.5-.1.18-.09.33-.2.4-.38.1-.2.15-.45.08-.68a1.06 1.06 0 0 0-.64-.8c-.18-.1-.37-.18-.57-.26-.2-.1-.46-.22-.51-.48-.05-.17 0-.4.18-.47.18-.07.37 0 .5.12.12.1.2.24.26.37-.03.19.26.12.16-.03-.05-.15.16-.38-.04-.47a1.3 1.3 0 0 0-.52-.2.86.86 0 0 0-.59.08l-.18.09zM368.4 201.2c-.29 0-.56.08-.83.12-.11.09-.38-.02-.4.15.1.1.17.24.19.4.03.25-.03.51.04.77.01.18-.03.37.04.54.03.28-.04.56.05.82.03.17.08.39-.06.52-.16.13.1.2.2.12l.58-.06c.14-.04.05-.16-.03-.2-.11-.2-.08-.43-.1-.64v-.5c.2-.08.41-.06.6-.14.38-.09.75-.35.81-.75a1 1 0 0 0-.35-.95c-.22-.14-.49-.2-.75-.2zm-.07.3c.23-.04.4.19.47.38.05.17.05.36.04.53-.01.28-.25.49-.51.53-.13.01-.35.05-.3-.14-.03-.21-.06-.42-.04-.63-.01-.2-.12-.42 0-.61.08-.11.23-.03.34-.06zM370.8 201.06c-.17-.05-.33.12-.3.3-.06.21-.07.43-.14.64-.04.32-.1.63-.17.94-.09.38-.14.77-.27 1.14-.01.1-.25.24-.12.31.2-.02.39 0 .58-.01.18-.07-.08-.2-.11-.3-.03-.14.01-.3.04-.44.01-.08.02-.17.12-.14h.72c.02.19.14.38.12.58-.05.09-.12.3.06.25.22 0 .44-.08.67-.06.2-.06-.06-.19-.09-.29-.09-.2-.15-.43-.2-.65l-.23-.82c-.06-.14-.08-.3-.13-.46-.1-.3-.17-.62-.24-.93-.01-.1-.22-.05-.3-.06zm-.14.75c.14.4.21.82.36 1.21.08.15-.07.23-.2.2s-.45.12-.45-.1c.06-.16.08-.32.1-.49.05-.2.09-.4.12-.61.01-.08.04-.15.07-.21zM373.38 200.95l-1.16.02c0 .13 0 .26-.06.36l-.05.37c.13.03.18-.13.26-.2.11-.12.24-.27.43-.27.1 0 .25-.05.2.1.01.16.07.31.05.48.01.71.03 1.42.01 2.14 0 .1-.1.13-.15.22.04.05.23 0 .33.02h.55c.1.02.08-.13-.02-.13-.07-.17-.05-.35-.07-.53 0-.76-.03-1.53 0-2.3.1-.05.22-.11.32-.04l.26.15.17.26c-.02.02.19.1.14-.02 0-.15-.07-.28-.07-.43-.03-.11.02-.28-.16-.23-.32-.03-.65.03-.98.03zM376.03 200.86c-.25-.01-.5.07-.74.05-.08 0-.24.03-.11.1.15.1.1.3.1.44-.01.78.03 1.55-.01 2.33-.03.13-.05.27-.18.34.03.1.23.02.33.05l.6.01c0-.12-.17-.17-.12-.3v-1.08c.18-.05.3.06.32.24.02.16.1.3.17.45.08.16.18.31.3.45.13.11.25.26.4.35.11.04.23.06.35.09 0-.15-.14-.23-.2-.35-.13-.21-.2-.46-.31-.69-.08-.15-.11-.3-.14-.47-.1-.15.1-.13.18-.2.17-.1.31-.23.4-.4.1-.17.08-.38.07-.57 0-.17-.12-.31-.21-.45-.11-.12-.27-.2-.41-.27-.19-.05-.37-.1-.56-.11h-.23zm.23.26c.17-.01.32.08.43.2.08.1.11.25.12.39 0 .14.02.29-.02.43-.07.18-.21.36-.42.38-.15.02-.3.05-.45.02-.04-.1 0-.23-.02-.34l.01-.87c.02-.2.19-.2.35-.21zM378.33 201.42c0 .14-.05.28-.04.43 0 .25 0 .5-.04.76-.03.42 0 .85-.02 1.28a.74.74 0 0 1-.15.35c-.05.06-.08.1.02.09.13-.02.25.03.37.05h.46c.15-.04-.08-.1-.06-.2-.08-.18-.04-.37 0-.55.02-.4-.02-.81.05-1.21.02-.25-.03-.5.02-.74.07-.15-.03-.34.13-.45.03-.06.09-.14-.02-.11-.19 0-.38 0-.56-.04-.09 0-.3-.07-.3.04.04.1.16.18.14.3zM380.67 201.3c-.06.27-.18.52-.24.79l-.15.48c-.1.26-.17.52-.26.78-.1.32-.19.67-.41.94-.13.04-.1.25.05.17.15.01.3.06.45.05.13.04.16-.08.04-.13-.14-.12-.16-.32-.06-.47 0-.19.14-.28.31-.23.19.02.38.06.57.05 0 .18.08.35.08.53.03.13-.22.37.01.36.2.02.39.06.59.06.09 0 .22 0 .12-.11-.13-.26-.14-.56-.2-.84-.01-.3-.1-.58-.13-.88-.05-.3-.13-.6-.15-.9 0-.16-.03-.3-.08-.45.02-.12-.07-.18-.19-.15-.11 0-.23-.06-.35-.05zm.04.71c.09.19.06.4.1.6.04.23.05.47.12.7.07.27-.26.14-.4.13-.13 0-.37 0-.25-.19.06-.14.09-.28.13-.42l.12-.4c.1-.11.08-.3.16-.42h.02zM386.66 205.3c0 .15.21.2.17.38-.01.35 0 .7.03 1.06.01.54.04 1.08 0 1.62 0 .09-.03.17-.1.22-.1.08.07.11.14.1l1.63-.06c.05-.24.1-.49.12-.73 0-.12-.11-.07-.13.02-.15.2-.35.42-.62.43-.13 0-.3.05-.4-.06-.06-.13-.04-.27-.06-.41a29.5 29.5 0 0 1-.01-2.19c-.02-.15.07-.29.12-.42l-.89.04zM388.88 208.6l.88-.01c0-.18-.12-.08-.14-.33-.01-.22.02-2.55.04-2.7.04-.3.13-.18.13-.31l-.86-.02c0 .22.1.02.11.35v.45l-.01 2.23c-.02.22-.14.16-.15.33zM390.25 205.22c.03.13.17.22.13.38 0 .36-.07.72-.08 1.09 0 .42-.03.85-.07 1.28-.02.15 0 .31-.08.45-.06.03-.2.13-.06.16.36.07.73.04 1.09.13.26.06.53-.02.76-.15.32-.21.4-.65.3-1-.02-.17-.16-.28-.28-.39l-.31-.27a.7.7 0 0 0 .61-.55c.06-.23.02-.5-.16-.68-.05-.06-.1-.13-.18-.16-.13-.08-.27-.16-.42-.18-.42-.07-.84-.08-1.25-.1zm.77.3c.17.02.38 0 .5.15.2.22.2.57.06.83-.02.11-.15.19-.26.22-.13.03-.28.02-.42 0-.03-.27.04-.55.03-.82 0-.13.02-.27.1-.37zm-.17 1.46c.24 0 .52.05.68.26.16.2.11.46.12.69-.03.29-.31.56-.61.5-.16 0-.26-.1-.23-.27-.02-.4 0-.79.04-1.18zM392.44 208.83c.07.12.23.08.35.13.27.06.54.12.8.2l.7.14c.04-.19.19-.33.2-.52.1-.13-.1-.22-.16-.08a.86.86 0 0 1-.81.14c-.2 0-.33-.17-.26-.35.02-.39.06-.77.16-1.14.12-.04.27.02.39.07.16.07.24.23.32.38.1.08.1-.18.12-.25.01-.23.05-.45.07-.68-.18.03-.25.32-.47.21-.15-.06-.47.03-.39-.21.03-.27.1-.52.16-.78.29-.1.6.04.78.28.1.09.17.31.27.34.06-.23.02-.46.02-.69-.09-.14-.3-.1-.43-.16-.42-.1-.83-.22-1.25-.28-.24-.05.08.17.02.29l-.22 1.52c-.06.39-.1.78-.18 1.17-.03.1-.09.21-.19.27zM395.25 206.18c.1.18.1.4.05.6-.1.49-.24.98-.3 1.48l-.18.9c-.03.13-.35.23-.1.32.2.08.42.13.63.2.21.01-.05-.21.02-.33.03-.23.1-.45.13-.67.04-.12 0-.35.17-.36.2.02.1.27.14.39.07.36.17.71.32 1.05.11.21.32.36.52.49.04-.14-.12-.35-.14-.52-.07-.23-.07-.47-.08-.7l-.03-.56c.2-.06.4-.1.54-.24.22-.24.3-.6.22-.9-.08-.34-.32-.61-.61-.78-.35-.2-.76-.2-1.13-.34a1.08 1.08 0 0 0-.17-.03zm.75.44a.6.6 0 0 1 .55.35c.12.33.08.71-.11 1-.12.17-.34.18-.52.14-.15-.01-.35-.06-.25-.26.05-.33.13-.65.18-.97.03-.1.09-.18.15-.26zM397.42 207.7c.16.02.25-.16.4-.19.14-.05.32-.13.44 0 .1.1.03.26 0 .38-.07.2-.1.42-.16.62l-.36 1.52c-.05.14-.05.32-.23.36-.08.15.21.15.3.22.18.08.36.15.54.2-.01-.14-.13-.26-.07-.4.07-.4.19-.78.27-1.17.11-.48.23-.95.36-1.42.2-.06.36.12.44.28.08.15.11.32.2.47.12-.09.07-.26.09-.39l.03-.37c-.25-.13-.53-.2-.78-.32l-.57-.23-.62-.23c-.11.17-.15.38-.27.55a.26.26 0 0 0 0 .12zM400.55 208.33c-.13.08-.17.25-.25.37-.1.16-.22.3-.3.45l-.8 1.31a1.1 1.1 0 0 1-.43.4c-.12.15.16.18.25.24.1.06.26.2.33.14-.03-.16-.14-.31-.05-.48.07-.12.1-.4.3-.28.18.12.4.2.56.35.05.15-.06.3-.03.46.05.16-.22.26-.14.38.14.11.3.17.46.26.1.05.3.2.24-.01 0-.22-.05-.44 0-.65.08-.16.04-.35.06-.53 0-.23.06-.47.07-.7l.12-1.17c.01-.12.11-.35-.07-.38-.1-.04-.2-.2-.32-.16zm-.22.7c.02.05.06.1.04.16-.05.4-.11.81-.14 1.22 0 .2-.24-.02-.33-.05-.12-.08-.35-.13-.2-.3.12-.21.3-.4.4-.61.08-.14.18-.27.23-.43zM402.38 209.45c-.04.2-.01.42-.16.58-.1.2-.2.39-.33.56-.12.22-.23.44-.36.64l-.5.84c-.1.03-.3.05-.14.17.12.16.3.27.42.43l.56.52c.3.21.72.3 1.02.08.15-.14.3-.27.43-.43a2.11 2.11 0 0 0 .4-1.46 2 2 0 0 0-.57-1.22c-.19-.18-.39-.34-.57-.52-.08-.05-.14-.13-.2-.2zm.55.82c.24.17.4.47.38.77-.02.49-.25.93-.52 1.32-.15.24-.32.52-.62.58-.22.06-.45-.1-.55-.28-.1-.22.06-.43.15-.62.24-.42.5-.82.73-1.26.08-.17.18-.35.33-.47.03-.01.06-.05.1-.04z'/%3E %3C/g%3E %3Cg%3E %3Cpath fill='%23006300' d='M363.22 281.23c.6.2 1.83.78 2.33 1.01l1.7 3.16c.64.46.54.36 1.27.54l-4.04 1.67c-1.18.44-.7 1.46-.16 1.67.6.18 1.85-.33 2.3-.54 2-.92 3.83-1.88 5.63-3.03.29-.18 1.62-1.1 1.88-1.05l7.15 4.05c.52.24 1.56.9 2.13.5.24-.16.6-.52.47-.93-.1-.44-.39-.52-.73-.64-.54-.24-3.78-1.7-3.88-1.7l.86-.23c.26-.18-.2-.71.15-.61l1.78-2.91 2.21-.8c-.01-2.04-16.68-3.31-21.05-.16z'/%3E %3Cpath fill='%23ff0' d='M364.38 288.1c-.6.18-.44 1.33.76.95.8-.29.18-1.26-.76-.95zM382.12 288.14c-.18.44-.16.65.26.83.44.2.7.2 1-.1.38-.4.07-.55-.27-.73-.36-.2-.08-.18-.36-.1-.21.08-.37.05-.63.1z'/%3E %3Cpath fill='%23006300' stroke='olive' stroke-width='.2' d='M399.22 221.87c-.06.08-.1.06.05.33 1.5 3.02.97 1.59 2.21 5.53-.24-.25-.55-.68-.79-1a28.5 28.5 0 0 1-1.81-2.83 1.26 1.26 0 0 0-.45-.54c-.11.3.42 1.88.55 2.32.55 1.94 2.03 4.15 3.1 5.9-.3-.15-.5-.4-.76-.65-.94-.78-.68-.58-1.23-1.55a19 19 0 0 1-1.32-2.9c-.26-.7-.52-1.37-.81-2.04-.11.13-.03-.1-.11.19-.08.27.02.59.05.86.13 1.13.32 2.27.5 3.4-.76-.32-1.5-.84-2.24-1.24-.16-.08-.37-.22-.55-.27l-.21.02c-.16.4 1.29 1.7 1.55 1.92.34.27 1.82 1.3 1.98 1.67.58 1.35 1.1 2.4 2 3.48l.79 1.02-1.74-1.75c-1.26-1.16-1.76-1.64-3.18-2.77.02.4.52.75.79 1l2.18 2.44c.68.9 1.5 1.65 2.1 2.6l1.38 2.31a13.2 13.2 0 0 0-.77-1.04l-2.1-2.62c-.74-.89-1.55-1.5-2.5-2.26a8.69 8.69 0 0 0-2.24-1.46c-.05.24.26.43.44.59 1.06.86 1.98 1.84 2.98 2.78.4.38.77.75 1.14 1.18.37.4.7.76 1.05 1.2.63.86 1.26 1.85 1.81 2.8l.85 1.48c-.66-.24-3.71-3.72-4.45-4.47-.6-.62-.87-.98-1.63-1.35.05.37 2.13 2.75 2.6 3.26.21.22.3.35.45.54l.92 1.05c.6.73 1.71 2.02 2.14 2.83l.63 1.3a20.02 20.02 0 0 0-1.42-1.91 8.77 8.77 0 0 0-.8-.95c-.68-.75-1.81-2.03-2.63-2.6l-2.1-1.2c-.11.21.34.53.6.75l.8.75c.94.76 2.23 2.22 2.96 3.19.5.6.88 1.16 1.3 1.8-.27-.15-.48-.4-.66-.61-.3-.3-.42-.38-.69-.62-.39-.4-.92-.78-1.44-1.16l-3.4-1.68c.05.27 1.18.97 1.5 1.16.65.43 1.76 1.13 2.34 1.75.26.27.4.47.63.68.5.46.88.94 1.27 1.51.4.57.74 1 1.1 1.6.4.61.64 1.15.95 1.83l1.16 4.29c-.37-1.4-1.08-2.95-1.58-4.32-.4-1.06-1.26-3.61-2.6-3.15-.5.19-.74.72-.95 1.15-.32.6-.74-.21-1.8 1.94a16.88 16.88 0 0 0-1.23 3.97c-.06.24-.06.4 0 .65.26-.11.44-.84.55-1.16.53-1.32 1.06-2.1 1.8-3.35l-1.01 4.57c.34-.06.45-.66.58-.98.45-1.13.84-2.26 1.26-3.4 1.5 1.05 1.98 6.72 2.2 8.74-.17-.7-.75-2.2-1.06-2.88l-1.53-2.54c-.9.1-1 1.24-1.21 1.94-.27-.35-.53-.94-1.14-.88-.55.02-.76.67-.84 1.29-.08.65-.08 1.34.03 2 .02.13.18 1.45.26 1.56l.19.18.31-3.88c.58.27 1.7 2.78 1.53 3.8-.58 3.76-.92 4.94-2.93 8.04-.34.54-.7 1.1-1.1 1.6a8.1 8.1 0 0 1-.58.75l-.66.73c1.03-1.78 1.47-2.49 2.21-4.54.53-1.53.98-3.15 1.16-4.8a2.6 2.6 0 0 0-.02-.78c-.21.08-.27.38-.35.62-1.74 5.4-1.97 5.58-4.81 10.39l.52-3.08c-.26.03-.21.16-.32.46l-.23.6c-.4 1.18-.8 2.34-1.42 3.4.05-.33.23-.76.34-1.09.29-1 .47-2.07.63-3.1l.02-.7c-.31-.03-.33.6-.47.97-.34 1.1-.84 2.08-1.34 3.1v-.3c.1-.67.29-1.7.16-2.37 0 0 .1.17-.08-.24-.27.08-.32.6-.37.84-.08.32-.19.65-.3.94-.65 1.84-1.46 3.02-2.41 4.7-.56-.02-.12.03.12.05l-.13-.04c.39.05.3.05.13.04.79.2 5.28 1.05 5.28 1.05 2.6-.11 4.34-.32 6.92-.05.4.02 2 .32 2.24.13-.76-.43-1.5-.62-2.34-.9l-2.48-.61 7.03-.19-.63-.35c-1.16-.46-4.3-.65-5.53-.73 2.32-.22 4.03-.4 6.35-.43.6-.17 2.67.5 1.76-.43-.81-.57-3.47-.65-4.34-.62l4.16-.19c.66-.17 4.94.83 3.43-.16-1.19-.6-3.8-1.14-5.06-1.33.73-.43 1.4-.86 2.18-1.18a38.83 38.83 0 0 1 5-1.62c1.87-.29 3.26-1.17.82-.78-1.5.16-3.31.59-4.63.72l1.18-.64c1.16-.6 2.5-.84 3.77-1.27.23-.08.16 0 .24-.21l-.21-.08c-.24-.03-.45.08-.7.1.77-.46 2.88-.89 3.67-1.08.95-.21 1.9-.48 2.85-.75.29-.08.68-.08.84-.32l-.18-.11c-.3-.1-5.4.65-5.95.76-.5.08-1.46.3-1.88.3 1.55-.65 3.08-1.33 4.72-1.82.29-.08 1.48-.3 1.63-.56-.31-.14-.58-.06-1.02.02-1.53.25-3 .65-4.46 1.11-.5.16-1.19.43-1.66.54 5.24-2.03 3.24-1.43 8.1-2.38.54-.1 1-.05 1.04-.43l-2.79-.16c-.92.03-1.87.24-2.63.27l2.08-1.75c.57-.49.31-.62 1.31-.65.4-.03 1.6.06 1.85-.08-.71-.73-.92-.35-1.6-.73l.84-1.03c.2-.27.42-.5.57-.86.08-.16.08-.13.03-.24l-.34.06-2.16 1.77c-.37.27-.29.25-.84.28-.95.08-1.87.37-2.74.53 1.02-.8 1.68-1.29 2.81-1.96.5-.33 1.03-.6 1.56-.9.42-.21 1.47-.56 1.55-.83l-3.34.86c-.66.24-2.48 1.1-2.87 1.43a42.88 42.88 0 0 1 5.47-4.85c.21-.16.75-.43.82-.67-.13-.06-.18-.09-.32-.06-.92.19-3 1.59-3.7 2.05a34.05 34.05 0 0 0-3.54 2.56 26.17 26.17 0 0 1 2.48-2.4l.5-.46c.37-.3.66-.59 1.03-.89.7-.59 1.42-1.21 2.05-1.86l1.05-.92c.24-.21.95-.64.92-1.02a51.8 51.8 0 0 0-4.15 2.64c-.69.46-1.32.94-1.98 1.4-.5.33-1.53 1.27-1.92 1.46.81-1.32 1.66-2.7 2.71-3.83a42.82 42.82 0 0 1 4.4-4.13c.4-.32.76-.72 1.13-1v-.13c-.34-.03-1.48.81-1.74 1.03a36.26 36.26 0 0 0-4.45 3.8c-.23.24-.42.49-.66.7-.68.65-1.34 1.5-1.9 2.3a59.74 59.74 0 0 0-2.21 3.3c.45-2.04 1.9-3.63 3-4.84l2.53-2.78c.19-.2.27-.33.43-.52 1.69-1.85 2.5-3.29 2.84-5.46-.29.42-.7.91-1.34 1.7-.2.24-.37.42-.57.69l-5.13 5.9c.23-.83 1.23-2.6 1.7-3.3a59.32 59.32 0 0 1 5.3-7.03l.24-.24c.06-.36.35-.55.72-.86.42-.35.5-.54 1-.8-.47-.5-2.24.61-2.58.85-2.24 1.54-3.84 3.64-5.47 5.75a24.54 24.54 0 0 1 2.18-5.4c.52-.7 1-1.61 1.53-2.26l1.47-2.32c-.34.02-.73.54-.95.75l-.42.44c-1.97 2.1-3.14 4.44-4.5 7.03.07-1.3 1.24-3.47 1.87-4.52.82-1.4 1.74-2.6 2.58-3.94-.48-.14-1.87 1.54-2.1 1.89-.62.75-1.22 1.5-1.75 2.37a29.16 29.16 0 0 0-2.5 5.17l-.16.39c.11-1.7 1.8-5.75 2.53-7.07.45-.79.92-1.4 1.45-2.08.21-.24.34-.46.53-.7l1.05-1.32 1.03-1.38c-.66-.24-3.03 2.46-3.48 3.02-.58.73-1.1 1.54-1.6 2.32.26-1.3 1.23-3.1 1.94-4.18.64-.97 1.3-1.75 2-2.61.24-.27.43-.54.61-.87-.73-.1-3.76 3.43-4.37 4.21-.26.35-.48.67-.71 1.02l-1 1.6-.16.3-.21.27c.16-1.25.9-3.84 1.3-4.97.54-1.46 1.3-2.78 1.94-4.2-.53-.09-1.53 1.26-1.82 1.7l-1.18 2.26c.13-1.05 1.76-4.72 2.31-6.07-.31.08-.52.57-.81 1-.74 1.16-1.4 2.29-2.09 3.48.11-1.19.88-2.43 1.4-3.46-.97.43-2.6 3.92-3 5.02-.19.46-.37 1-.5 1.51l-.21.54c-.05-2.67.5-5.4.89-8.01-.24.05-.29.32-.4.57l-.28.67c-.16.49-.35.94-.53 1.48l-.77 3.18c-1.13-1.59-1.41-4.52-3.65-7.84-.71-1.05-.95-1.16-1.9-1.84zm1.19 31.83c.92 2.57 1.29 3.46 1.97 6.18a.63.63 0 0 0-.26.27c-.1.27-.21.76-.4 1.13l-.68-2.37c-.26-.86.1-2.62-.18-2.92-.26.46-.19.54-.24 1.38-.16-.19-.31-.73-.42-1-.53-1.45-.6-1.02-.26-1.86.1-.24.26-.7.47-.8z'/%3E %3Cg fill='%23008f4c'%3E %3Cpath d='M407.34 249.25c.34-3.56 4.73-11.98 6.02-12.16.19-.03-1.45 2.35-2.58 4.7a53.42 53.42 0 0 0-2.76 6.84 15.72 15.72 0 0 1-.75 2.42c-.04-.06-.01-.88.07-1.8zM416.89 247.06c-.01.06-.81.85-1.8 1.75a41.64 41.64 0 0 0-8.98 12.9c-1.9 4.7-1.41 3.5-.86 1.23 1.45-4.92 5.4-11.15 9.07-14.2 1.3-1.08 2.61-1.93 2.57-1.68zM405.83 239.06c0-3.25.31-4.38 2.18-8.28 1.19-2.5 1.64-3.32 1.77-3.13.08.13-.02.59-.25 1.02-1.1 2.13-2.9 8.22-3.22 10.88-.1.9-.26 1.64-.34 1.65-.09.02-.15-.94-.14-2.14zM400.58 257.18a19 19 0 0 1-1.33 8.3c-.67 1.73-3.31 5.73-3.94 5.98-.31.12-.24-.05.46-.86a20.8 20.8 0 0 0 4.65-12.61c-.16-2.43 0-2.75.16-.8z'/%3E %3Cpath d='M408.62 254.13c.38 1.13.44 3.81.03 5.2-1 3.34-3.38 5.78-6.77 6.96-.66.23-1.23.4-1.28.35-.03-.03.48-.32 1.16-.63a11.63 11.63 0 0 0 6.9-10.44c0-.83-.17-1.24-.21-1.45-.08-.34-.16-.61-.05-.7.06-.04-.05-.12.22.7z'/%3E %3Cpath d='M417.87 261.24c-.04.04-1.88.39-4.08.77-2.2.37-5.04.9-6.3 1.18-1.92.42-2.31.47-2.43.3a.8.8 0 0 1-.14-.27c0-.08 5.97-1.15 9.35-1.66 2.46-.37 3.79-.49 3.6-.32zM400.51 223.98c1.41 1.7 1.74 2.43 2.46 5.33.46 1.86.58 2.5.43 2.46-.1-.03-.24-.32-.31-.65a32.35 32.35 0 0 0-3.04-7.18 3.55 3.55 0 0 1-.54-1.02c.04-.05.49.42 1 1.06z'/%3E %3Cpath d='M398.98 226.06c.67 2.12 1.1 2.8 3.13 4.95 1.3 1.38 1.75 1.82 1.8 1.67.03-.11-.14-.38-.37-.62a31.86 31.86 0 0 1-4.34-6.43 3.53 3.53 0 0 0-.56-1c-.07 0 .09.64.34 1.43zM411.6 232.66c-2.23 2.04-5.85 8.59-5.32 9.61.08.15 1.01-1.35 2.02-3.36 1.02-2 2.48-4.44 3.24-5.45.76-.99 1.31-1.78 1.25-1.77s-.6.44-1.18.97zM412.62 234.33c-2.5 2.29-6.55 9.6-5.96 10.74.1.17 1.13-1.51 2.26-3.75a50.82 50.82 0 0 1 3.62-6.1c.85-1.1 1.47-1.98 1.4-1.97s-.67.5-1.32 1.08zM398.29 227.62c.4 2.2.74 2.93 2.47 5.33 1.11 1.54 1.52 2.04 1.58 1.9.04-.1-.09-.4-.29-.66-1-1.3-2.96-5.2-3.5-6.96a3.56 3.56 0 0 0-.43-1.07c-.06 0 .01.65.17 1.46z'/%3E %3Cpath d='M396.68 229.17c1.57 1.55 2.26 1.93 5.02 2.83 1.78.59 2.39.75 2.36.59-.03-.1-.3-.27-.61-.36a30.5 30.5 0 0 1-6.78-3.54 3.38 3.38 0 0 0-.96-.61c-.05.03.39.52.97 1.09zM416.89 239.76c-3.4 2.36-9.48 10.57-8.94 12.05.08.22 1.61-1.64 3.34-4.18a61.69 61.69 0 0 1 5.36-6.8c1.21-1.19 2.1-2.16 2.02-2.16-.08 0-.9.5-1.78 1.09zM416.37 244.78c-1.49 2.99-7.18 8.7-8.37 8.4-.18-.05 1.1-1.47 2.88-3.11a48.53 48.53 0 0 0 4.69-5c.8-1.09 1.45-1.9 1.46-1.84 0 .07-.29.77-.66 1.55zM396.34 265.37c-.61 2.94-4.25 9.26-5.34 9.29-.17 0 .62-1.54 1.78-3.4a44.57 44.57 0 0 0 2.93-5.44c.44-1.15.83-2 .85-1.95.02.05-.08.73-.22 1.5zM405.65 247.7c-.6-1.88-2.27-4.15-4.59-6.2-2.32-2.1-3.03-2.42-.99-.47a27.1 27.1 0 0 1 5.09 6.9c.36.77.7 1.39.78 1.33.1-.04-.03-.74-.3-1.56zM407.4 271.6c-2.61-.75-9.32-.68-9.86.12-.08.12 1.51.17 3.52.07a44.65 44.65 0 0 1 7.63.27c-.03-.04-.62-.25-1.29-.45zM404.53 272.77c-2.64-.66-9.35-.3-9.85.5-.07.13 1.52.12 3.52-.06a44.66 44.66 0 0 1 7.64-.04c-.04-.04-.63-.22-1.31-.4zM401.58 274.2c-2.66-.59-9.35-.06-9.83.77-.08.12 1.51.07 3.51-.16a44.67 44.67 0 0 1 7.64-.24c-.04-.04-.64-.2-1.32-.37z'/%3E %3Cpath d='M399.83 275.88c-2.25-.85-8.09-1-8.57-.22-.08.12 1.3.22 3.06.2a33.87 33.87 0 0 1 6.62.52 8.24 8.24 0 0 0-1.1-.5zM410.26 267.6c-5.5 1.57-12.16 2.52-12.54 3.84-.06.2 2.43-.2 4.87-1.18 2.45-.97 5.6-1.95 7.05-2.24 1.42-.27 2.53-.58 2.5-.73-.05-.04-.97.31-1.88.31zM417.45 264.06c-.06.05-2.25.46-4.86.92-2.6.44-5.99 1.08-7.48 1.4-2.3.5-2.76.57-2.9.36a.95.95 0 0 1-.17-.32c0-.1 7.1-1.37 11.13-1.97 2.92-.44 4.5-.59 4.28-.39z'/%3E %3Cpath d='M415.74 262.64c-.04.05-1.84.58-3.98 1.18-2.15.6-4.93 1.41-6.15 1.81-1.89.61-2.27.7-2.4.55a.8.8 0 0 1-.17-.25c0-.09 5.83-1.76 9.15-2.6 2.41-.62 3.72-.88 3.55-.69z'/%3E %3Cpath d='M414.38 256.15c-3.8 1.56-11.44 8.24-11.22 9.81.03.24 1.92-1.25 4.13-3.35 2.22-2.1 5.2-4.52 6.64-5.46a17.6 17.6 0 0 0 2.42-1.67c-.08-.02-.97.28-1.97.67z'/%3E %3Cpath d='M417.2 257.98c-3.79.25-12.4 4.12-12.65 5.68-.04.24 2.04-.56 4.58-1.84s5.86-2.61 7.4-3.04c1.51-.4 2.66-.76 2.6-.8-.07-.05-.94-.05-1.92 0z'/%3E %3Cpath d='M417.09 258.4c-9.71 8.16-15.17 12.15-17.1 11.3-.3-.12 3.56-2.34 6.86-4.45 3.3-2.1 7.23-5.1 8.83-6.62 1.56-1.53 2.82-2.64 2.82-2.53 0 .11-.63 1.16-1.41 2.3zM406.7 260.95c1.95-3.18 2.93-4.1 7.11-6.73 2.68-1.7 3.62-2.21 3.63-1.94 0 .18-.38.56-.86.84-2.37 1.39-7.8 6.21-9.71 8.63-.64.8-1.25 1.44-1.33 1.4-.1-.04.42-1.03 1.16-2.2zM407.76 251.78c.34-3.56 6.43-15.45 7.72-15.63.2-.03-1.44 2.35-2.58 4.7a53.42 53.42 0 0 0-2.76 6.84 69.37 69.37 0 0 1-2.63 6.53c-.03-.07.17-1.52.25-2.44zM405.2 238.06c-1.03-2.41-1.06-3.34-.32-6.75.48-2.18.7-2.92.9-2.81.12.08.15.44.05.83-.5 1.88-.48 6.9.03 8.97.17.7.24 1.3.15 1.32-.08.04-.45-.66-.82-1.56zM407.06 251.1c-.54-1.7-2.05-3.73-4.13-5.58-2.1-1.88-2.74-2.18-.9-.42a24.4 24.4 0 0 1 4.59 6.2c.32.7.63 1.26.7 1.2.1-.03-.03-.66-.26-1.4zM397.72 253.84c1.92-6.9 3.44-5.7 3.44-5.7 4.2 3.95 2.13 17.53 2.13 17.53-.03-27.8-5.57-11.83-5.57-11.83z'/%3E %3Cpath d='M399.27 253.36c1.92-6.9 2.43-6.6 2.43-6.6 3.47.7 3.25 15.93 3.25 15.93-1.52-26.12-5.68-9.33-5.68-9.33zM397.44 258.72c-.08-4.96.9-4.22.9-4.22 2.8 2.51 3.85 12.17 3.85 12.17-4.35-19.49-4.75-7.95-4.75-7.95zM405.95 244.15c-.84-2.66-3.2-5.87-6.48-8.78-3.3-2.95-4.3-3.43-1.4-.66 2.66 2.54 6 7.06 7.19 9.76.5 1.1 1 1.97 1.11 1.89.14-.06-.05-1.05-.42-2.2z'/%3E %3Cpath d='M405.67 241.82c-.65-2.05-2.47-4.52-5-6.76-2.52-2.28-3.3-2.64-1.07-.5 2.05 1.94 4.62 5.42 5.54 7.5.39.84.77 1.52.85 1.46.11-.05-.03-.81-.32-1.7zM391.7 269.3c-.2 1.5-1.8 4.83-2.35 4.89-.08 0 .26-.8.78-1.78a22.63 22.63 0 0 0 1.63-3.88c.01.03-.01.37-.06.77zM390.32 270.17c-.2 1.5-1.8 4.83-2.35 4.89-.09 0 .25-.8.77-1.78a22.66 22.66 0 0 0 1.64-3.88c.01.03-.01.38-.06.77zM392.4 270.28c-.2 1.5-1.8 4.83-2.35 4.89-.08 0 .26-.8.78-1.78a22.66 22.66 0 0 0 1.64-3.88l-.06.77z'/%3E %3C/g%3E %3Cpath fill='%2300873f' d='M341.2 232.3c.02.75.22.94.55 1.41l.09-1.45c-.27-.17-.38-.03-.63.04z'/%3E %3Cg fill='none' stroke='%23006300' stroke-width='.63' transform='matrix(.8 0 0 .8 -25 0)'%3E %3Cpath d='M455.17 303.94l-.87-.7M456.08 298.62c-.7-1-.74-1-.74-1M453.57 311.08c-.26-2.12-1.47-2.73-1.47-2.73M463.44 338.34c-5.4-5.97-7.17-16.77-7.17-16.77 1.77-4.52 4.1-5.56 4.1-5.56M456.28 321.52c-1.77-6.96-1.32-14.23-1.32-14.23.62-8.93 3.45-16.82 3.45-16.82M454.9 309.78c1.43-6.54 6.87-5.75 6.87-5.75'/%3E %3Cpath d='M454.83 310.99c4.88-1.98 4.3-6.29 5.18-8.04 1.32-2.64 2.27-3.41 2.27-3.41M459.7 332.37c-1.66-4.2.31-4.98.31-4.98M459.03 331.02c-2.13-2.75-4.83-2.54-4.83-2.54M458.09 318.2c1.3-2.39-.05-4.78-.05-4.78M458.73 329.72l-3.8-4.93M457.21 294.36c.51-1.95-1.03-2.83-1.03-2.83'/%3E %3Cg transform='matrix(.1567 0 0 .1567 442.05 224.22)'%3E %3Cpath id='b' fill='red' stroke-width='2' d='M91.38 425.97a5.97 5.97 0 1 1-11.95 0 5.97 5.97 0 0 1 11.95 0z'/%3E %3C/g%3E %3Cuse xlink:href='%23b' transform='matrix(.1567 0 0 .18128 444.57 235.35)'/%3E %3Cuse xlink:href='%23b' transform='matrix(.1567 0 0 .1567 443.69 248.32)'/%3E %3Cuse xlink:href='%23b' transform='matrix(.16899 0 0 .16899 440 252.04)'/%3E %3Cuse xlink:href='%23b' transform='matrix(.16899 0 0 .16899 438.74 256.23)'/%3E %3Cuse xlink:href='%23b' transform='matrix(.16899 0 0 .16899 440.29 257.84)'/%3E %3Cuse xlink:href='%23b' transform='matrix(.12289 0 0 .12289 463.22 286.05)'/%3E %3Cuse xlink:href='%23b' transform='matrix(.12289 0 0 .12289 464.3 287.3)'/%3E %3Cpath d='M458.76 316.61a1.8 1.8 0 0 0-1.1-1.25M472.4 339.53c1.6 1.16 2.08.43 2.08.43'/%3E %3C/g%3E %3Cg fill='%23006300'%3E %3Cpath d='M354.5 274.35c-.78-2.79-.58-3.43-.58-3.43M347.82 269.32s-.46-1.09.3-1.71c.45-.37 2.4.69 3.4-3.67 0 0-.6-.07-2 .57v-.35s-.31-.97-.17-2.18c0 0 .66-1.02.68-1.43 0 0-1.26-.47-3.71 2.7 0 0-.23-.68-2.03-1.9 0 0-.97 2.77-.48 4.33.38 1.22.4 1.65 1.7 2.53 0 0 1.03.45 1.17 1.84.49 0 1.12-.09 1.12-.09s.06.02.02-.64zM346 272.54c-.4.23-.58.43-1.29.52-3.17.41-4.95-3.77-4.95-3.77-.1-.83.28-.4.93-.16.87.31 1.13.07 2.1-.05 1.28-.15 2.72 1.1 2.72 1.1.81.72.88 2.14.88 2.14-.09.22-.4.22-.4.22zM342.22 265c-3.31-1.4-5.28.17-5.28.17-.13.21.2.3.2.3 2.07.26 1.4.17 2.27 1.35 1.48 2.04 4.1 1.6 4.1 1.6.54.13 1.08.78 1.08.78-.22-1.81-2.37-4.2-2.37-4.2zM336.48 251.86c-.64-.44-.5.44-.5.44-1.36-2.4-4.98-2.58-4.98-2.58-.3-.01-.47-.24-.47-.24-.6 0 .14 1.21.14 1.21 1.09 2.91 2.13 3.24 2.13 3.24-1.24.7-3.22-.83-2.77.3 1.92 2.02 3.22 2.3 3.22 2.3 2.42.59 3.5 0 3.5 0 .55 1 .91 1.14.91 1.14 2.2.66 2.68 1.92 2.68 1.92 0-2.4-.9-5.37-.9-5.37-.69-1.03-2.96-2.36-2.96-2.36z'/%3E %3Cpath d='M353.6 275.18c-1.18.37-1.27 1.2-1.27 1.2-1.15 1.57-5.3.08-5.3.08-1.26-.35-1.02-.69-1.02-.69 1.15-.59 1.54-1.05 1.54-1.05a8.07 8.07 0 0 1-2.52-4.56c3.43-.68 4.48-.04 4.48-.04-.22-1.33-1.35-1.35-1.35-1.35-.26-.42.32-.44.32-.44 3.01.3 4.63 2.18 4.63 2.18 1.13 1.59.78 3.16.78 3.16.27 1.59-.29 1.51-.29 1.51zM339.6 261.38c-1.66-.5-2.62.05-2.62.05-.87.34-2.44-.66-2.44-.66-2.08-1.73-2.48-2.8-2.48-2.8 0-.32 1.83-.25 1.83-.25 2.42-.05 2.97.44 2.97.44 1.25.71 1.12 1.36 1.57 1.62 1.08.63 1.25.93 1.25.93.3.41.44.82-.07.67zM342.84 262.22c1.14-1.31 2.7-.41 2.7-.41 2.39.28 3.15-2.43 3.15-2.43.56-1.1.97-1.62.97-1.62.14-.63-1.04-.1-1.04-.1-2.04.51-2.11.72-2.11.72l.35-3.25c.03-.52-.56-.14-.56-.14-2.94 1.7-3.29 2.94-3.29 2.94l-1.2-2.28c-.39-.94-.67.1-.67.1-.55 2.77-.34 3.01-.34 3.01.38 1.49.76 1.9.76 1.9.7.9.7 1.25.7 1.25z'/%3E %3Cpath d='M360.16 269.8c-.47.12-1.69 2.06-1.69 2.06-1.47-2.77-3.43-3.21-3.43-3.21-.39.17.05.8.05.8a3.12 3.12 0 0 1-.1 2.63c-.22 1.07.03 1.32.03 1.32-2.33-1.2-2.47-1.08-2.47-1.08-.03 1.5 1.76 4.29 1.76 4.29 3.87-1.03 4.16-.96 4.16-.96 1.44-.22 1.4-.24 1.4-.24 1.17-3.33.29-5.61.29-5.61zM341.2 254.57c1.5.73 1.6 1.71 1.6 1.71.38 1.28 3.86 1.57 3.86 1.57 2.84-.3 2.55-.8 2.55-.8-1.64-1.45-1.17-1.34-1.86-2.02-1.24-1.2-2.87-1.25-2.87-1.25-2.18.35-2.64-.1-2.64-.1-.79.42-.64.89-.64.89zM337.83 249.58c-.7-2.56 1.62-5.73 1.62-5.73 1.93 3.6 1.56 4.6 1.56 4.6-.68 2.4-1.63 4.16-1.63 4.16-.35-1.81-1.29-2.1-1.55-3.03z'/%3E %3Cpath d='M336.6 250.58c-2.46.07-4.8-2.71-4.8-2.71 3.66-.95 4.48-.4 4.48-.4 2 1.14 3.38 2.38 3.38 2.38-1.7-.08-2.17.7-3.07.73z'/%3E %3Cpath d='M334.7 247.13c-1.55.24-2.9-1.28-2.9-1.28-2.08-2.77-1.39-3.67-1.39-3.67.17-.1.42.24.42.24a3.9 3.9 0 0 0 1.83.73c-3.32-2.08-1.14-6.69-1.14-6.69.41-.45.55.66.55.66.45 1.21 1.77 1.94 1.77 1.94.7.93.7 1.32.7 1.32.34-1.56.72-1.15.72-1.15.41 1.25 1.8 2.12 1.97 2.98.49 2.32.1 2.63.1 2.63-.27 1.35-.29 2.37-.29 2.37-1.26-.46-2.34-.08-2.34-.08zM342.53 252.7c.8-1.07 0-3.08 0-3.08-.31-2.14 2.9-4.19 2.9-4.19.94 1.73.84 2.77.84 2.77 2.46-.59 3.01-.76 3.01-.76.1 1.39-1.21 3.4-1.21 3.4 2 .58 2.7-.39 2.7-.39-.97 4.47-5.23 3.57-5.23 3.57-1.77-1.14-3.01-1.32-3.01-1.32z'/%3E %3Cpath d='M335.85 239.68c.24-2.7.73-2.8.73-2.8.3.12.43 1.31.82 1.5 1.7.77 1.68 2.57 1.68 2.57-.05 2.16-.36 1.96-.36 1.96-2.36-.03-2.87-3.23-2.87-3.23zM343.64 240.22c.82-3.06.33-3.36.33-3.36-.37 0-1 1.25-1.5 1.3-2.17.16-2.89 2.14-2.89 2.14-.82 2.39-.4 2.3-.4 2.3 2.6.92 4.17-1.3 4.46-2.38z'/%3E %3Cpath d='M335.95 234.63c.29-3.15.86-3.26.86-3.26.34.12.5 1.52.96 1.73 1.97.91 1.96 3.02 1.96 3.02-.05 2.52-.42 2.3-.42 2.3-2.75-.04-3.46-2.67-3.36-3.79zM344.74 235.38c.9-3.03.4-3.35.4-3.35-.36 0-1.03 1.24-1.52 1.26-2.17.12-2.94 2.09-2.94 2.09-.87 2.36-.45 2.29-.45 2.29 2.58.98 4.2-1.2 4.51-2.29zM348.36 243.86c2.5-1.93 2.3-2.47 2.3-2.47-.3-.22-1.56.39-1.98.12-1.83-1.18-3.6-.04-3.6-.04-2.1 1.4-1.71 1.59-1.71 1.59 1.5 2.3 4.1 1.5 4.99.8z'/%3E %3Cpath d='M348.28 245.52c2.38-1.1 2.3-1.55 2.3-1.55-.2-.21-1.35.06-1.65-.21-1.3-1.2-2.95-.6-2.95-.6-1.96.76-1.68.96-1.68.96.86 2.01 3.13 1.79 3.98 1.4zM340.06 231.06c-.95-2.82 1.9-6.56 1.9-6.56.6 1.76.94 3.14.94 3.14 2.27-2.31 4.29-2.67 4.29-2.67l-.08 1.78c1.52-.14 2.15-.49 2.15-.49-.32 2.27-3.18 4.56-3.18 4.56-1.08.68-2.4.44-2.4.44-2.07.59-2.55 2-2.55 2-.2-1.23-.35-.04-1.07-2.2zM344.22 240.51c1.29-1.7 3.33-.97 3.33-.97 1.83.14 3.4-1.76 3.4-1.76.82-1.35 1.34-1.67 1.34-1.67-.07-.45-.52-.38-.52-.38-1.1.25-1.1.28-1.1.28.83-3.08.38-3.22.38-3.22-.28 0-.45.2-.45.2-.49 1.43-2.46 1.36-2.46 1.36-.1-2.04-.56-1.77-.56-1.77-.3.52-.97.83-.97.83-1.94 1.94-1.94 2.77-1.94 2.77.1 2.29-.45 4.33-.45 4.33z'/%3E %3C/g%3E %3Cg fill='%2300863d'%3E %3Cpath d='M343.86 251.72c.25-.3.84-.74 1.28-1 .45-.25.3-.14.52-.63.2-.46.15-.36.47-.68l-.29.87c.45-.26.62-.4 1.26-.75.05.25-.42.48-.8.73-.34.23-.64.43-1 .64l-1.73 1.47c1.64-.38 1.35-.1 2.17-.24 1.75-.3 2.58-2.77 3.18-4.22-1.2.22-2.45.5-3.34 1.09-1.12.76-1.04 1.45-1.72 2.72zM339.38 257.98c-.1-.27-.41-.72-.58-1.01-.47-.84-.52-1.08-1.13-2.04-.4-.62-.25-.3-.5-.98.23.02.55.71.81 1v-1.02c.28.03.2.27.21.58.06.99-.04.82.57 1.9l1.24 2.04c-.08-.32-.24-.6-.32-.94-.37-1.32.46-2.9-2.81-4.85l-.81-.49c.06 1.6.24 4.26 1.71 5.1.26.14.56.2.84.31.3.13.5.28.77.4zM338.62 237.84c-.12-.41-.32-.78-.44-1.24-.12-.42-.05-.32-.35-.52l-.38-.47.49.25a3.12 3.12 0 0 0-.4-.76c-.3-.43-.16-.14-.47-.7.56-.07 1.15 1.6 1.27 2.03.39 1.28.37 1.12 1.13 2.15 0-.17-.28-.49-.35-.75-.2-.7.56-1.66-.2-3.17-.44-.9-1.37-1.05-1.82-1.81l-.4-.78a7.22 7.22 0 0 0-.4 1.7c-.06 1.1.2 2.55.98 3.29.27.26.96.64 1.34.78zM342.8 229.86c.15-.1.45-.54.73-.77l.8-.67-.12-.74c.15.05.09-.07.25.5.2-.18.68-.99.9-1.3.15.21-.32.9-.46 1.1-.23.38-.45.64-.8.9l-1.52 1.88c.32-.1.55-.22.9-.28 1-.2 1.38-.29 2.07-1.4.66-1.04.84-2.33 1.1-3.54-1.42.57-2.92 1.15-3.65 2.47-.28.5-.16.91-.2 1.85zM333.84 243.28c-.4-1.05-1.52-2.27-1.64-2.8l-.16-1.25c.23.03.12-.06.2.16 0 0 .06.7.14.9l.5.91c.02-.6-.08-.3.16-.83.24.32-.13.85.23 1.46.2.31.45.81.69 1.09-.01-.87.58-2.2-.4-3.46-.34-.43-.74-.58-1.16-.94l-.82-1.3c-.67 1.41-.54 4.27.78 5.22.26.18.49.24.76.4l.37.2c.12.09.22.17.35.24zM340.24 237.7c.57-.47.4-.65 1.72-1.65.33-.25.57-.53.85-.84.41-.44.28-.36.82-.88.13.24-.74 1.15-1.02 1.48l.53.07c-.08.32-.38.08-.81.2-.4.1-1.42 1.27-1.7 1.56.25-.07.49-.18.8-.23.82-.17 1.33.05 2.22-1.08.75-.95 1.02-2.15 1.38-3.3a7.64 7.64 0 0 0-3.15 1.46c-.92.88-.84 1.64-1.18 2.43-.14.3-.34.5-.46.78zM335.8 246.3c-.14-.2-.59-.54-.8-.7-.46-.33-.52-.33-1.16-.38l-1.9-1.06c.23-.12.35.16.8.4l.9.38-.12-.5c.17.02.19.04.26.23l.05.31c.86.07.72.09 1.57.63-.1-.39-.14-.36-.39-.56-.2-.16-.25-.3-.42-.52-.27-.37.03.17-.43-.52-.74-1.12-1.55-.63-2.08-.76l-1.36-.56c.23 1.31.93 2.3 1.6 2.93.36.33.78.7 1.43.82.2.03 1.78-.1 2.04-.14zM335.02 253.42c-.26-.27-.56-.49-.88-.72-.24-.17-.35-.15-.67-.18l-.61-.2.7-.04c-.09-.05-.23-.18-.33-.26-.49-.39-.58-.38-.9-.86.14-.12.23.04.42.18.56.44 1.65 1.32 2.2 1.7l1.02.56c-.05-.55-.98-2.3-1.74-2.64l-3.41-.94c.17.58 1.02 2.16 1.37 2.64 1 1.35 1.1.9 1.82.8.37-.06.65-.03 1.01-.04zM336.66 245.74l-1.3-4.26c.24.07.2.36.35.84l.34.88c.17-.37-.07-.05.3-.63.16.19-.03.59-.1.83-.13.45-.12.28.06.74l.6 1.58c.04-.36 0-.55.07-.92.2-1.03.36-1.6-.13-2.68-.43-.94-1.15-1.64-1.8-2.37-.1.18-.31 1.4-.35 1.7-.16 1.1-.07 2.6.8 3.3.69.57.29.12 1.16 1zM339.2 251.26c.03-.44-.05-2.47-.03-3.39v-.59c.01-.31-.02-.2.15-.44.08.11.09.23.08.39l-.02 1.4.4-.69c.27.1.05.35-.07.6-.1.18-.3.54-.34.71l.07 2 .03-.03c.02.03.22-.52.34-.72.42-.71.9-1.72.7-2.63l-1.12-3.22c-.23.4-.52 1.06-.72 1.5a6.87 6.87 0 0 0-.5 1.77c-.22 1.5.19 1.8.65 2.58.14.24.25.5.38.76zM341 232.14c.02-.38.17-2.35.13-2.52-.02-.05-.14-.28-.17-.37l-.18-.8c.28.04.16.21.32.5l.1.15.05-.58c.03-.39-.02-.2.14-.58.16.1.07-.06.11.18.01.03-.01.26-.02.3-.13 1.3-.19 2.75-.25 4.07.13-.21.17-.56.31-.82.34-.67.93-1.82.87-2.6l-.74-3.86c-.27.41-.53 1.06-.75 1.52-.5 1.03-.97 2.6-.66 3.77l.66 1.52c.04.08.03.06.08.12zM330.7 254.33a6.08 6.08 0 0 0 3.95 2.02l1.73-.32-.27-.8c-.32 0-.57.14-.93.15a13.41 13.41 0 0 1-2.04-.25c-.6-.12-.39-.03-.83-.34l1.81.27c-.47-.37-.3-.18-.65-.66.27-.02.8.5 1.04.66l1.55-.08-.12-.91a4.07 4.07 0 0 0-2.67-.03c-1.61.55-1.04.42-2.57.29zM332.75 258.36c.1.3 1.73 2.17 2.12 2.3l3.58.15c-.44-.25-1.07-.5-1.58-.7-.69-.29-.73-.14-1.84-.02.06-.25.27-.2.86-.34-.25-.14-1.34-.44-1.35-.45l-.16-.17c.07-.08.02-.09.18-.07.06 0 .21.06.28.08 1.66.54 2.13.76 3.7 1.4-.5-.38-.62-.51-1-1-1.45-1.83-2.96-1.24-4.79-1.18zM345.2 238.37l.56-1c.27-.57-.16-.59.03-1.35.2.06.14.04.24.7l.66-1.52c.19.5-.86 2.46-1.08 2.93l-.36.98c.86-.95 1.9-1.4 2.08-2.2l.12-3.84a9.75 9.75 0 0 0-1.87 2c-.62 1-.57 1.92-.37 3.3zM343.55 261.06c.32-.14.55-.33.92-.48 1.41-.39.85.29 1.75-.96l-.24.66c.64-.21.8-.6 1.28-1.08.12.24-.25.63-.43.82-.8.78-1.6.53-2.07.7l-.93.47c1.07-.17.95.03 1.83.16 1.8.27 2.3-1.52 2.92-2.58l.42-.75a9.08 9.08 0 0 0-4.25 2.06c-.16.15-.36.35-.55.5-.27.2-.47.25-.65.48z'/%3E %3Cpath d='M343.42 251.54c.63-.6.5-2 .97-2.86.08-.16.15-.24.26-.37.17-.22.1-.18.33-.17.08.16-.26.34-.4.64l-.28.9.1-.08a.87.87 0 0 0 .1-.12c.43-.63.83-.79 1.47-1.19l-.61-2.27-1.12.97c-.3.26-.7.75-.94 1.16-.8 1.4.07 2.06.12 3.39zM343.1 260.85l1.47-2.42v-1.13c.22.04.14-.08.29.67.5-.72.15-.64.71-1 .04.21-.57 1.32-.65 1.44-.62.87-.93 1.42-1.47 2.35.35-.14.83-.65 1.09-.89.2-.19.32-.3.55-.44.21-.14.44-.24.64-.37l.62-3.45a10 10 0 0 0-2.52 1.86c-.92 1.17-.97 1.53-.73 3.38zM346.4 252.38l1.92-.17c-.06.25-.33.25-.87.33-.87.14-2.46.12-3.39.14.27.15.54.24.81.4.28.17.48.3.76.45.6.3 1.34.28 1.98.03l2.52-2.33c-1.32.3-.6.35-2.38-.01-.27.24-.4.53-.97.91-.11.08-.27.16-.38.25zM332.77 247.74c.54 1.12 2.12 2.45 3.55 2.27.63-.08.75-.28 1.13-.65-.08-.1.02-.02-.1-.09a.61.61 0 0 0-.17-.05c-1.09-.21-1.22-.12-2.33 0l.5-.26-.87-.22c-.45-.13-.39-.1-.74-.36.13-.12.1-.1.32-.03 1.46.47 1.8.44 3.38.69-.15-.48-1.4-1.08-2.07-1.17-1.05-.13-1.42.4-2.6-.13zM342.17 260.5l-.49-3.1c.26.07.18.17.3.82l.56 2.8c.04-1.06.4-1.82.09-2.92l-1.1-2.12c-.21.5-.36 1.93-.32 2.54.07.94.26 1.22.76 1.8.1.1.09.1.2.18zM346.37 228.86c.16-.1.28-.26.42-.44l.46-.35c.01.26-.37.57-.62.89-.36.46-.59.53-.77.75-.7.9-.63.75-1.76 1.24 2.32.14 3.57-2.3 4.56-3.96-2.19.3-1.79.46-2 1.09-.1.27-.22.53-.3.78zM347.12 238.63l.63-1.04c.38-.56.62-.17 1.22-.76-.16-.14-.1-.1-.77.16l1.05-1.43c-.57.1-1.8 2.12-2.12 2.58l-.72.85c.42-1.3.27-2.5.92-3.1l3.47-2.17a10.4 10.4 0 0 1-.84 2.8c-.59 1.11-1.46 1.55-2.84 2.11zM338.45 242.74c-.2-.58-.88-1.17-1-1.49l-.5-2.01c.28.03.28.56.33.8l.27.86c.17-.61-.11-.18.27-.77.2.37-.22 1 .03 1.35.26.35.28.3.69.9.23-.92.27-2.1-.3-2.74l-1.61-1.77c-.41.6-.37 2.28-.08 3.13.33.96.7 1.07 1.3 1.39.24.12.37.24.6.35zM339.85 242.51c.4-.54 1.36-.92 1.6-1.21l1.27-1.96c-.3-.07-.5.5-.64.73l-.6.82c.04-.71.18-.15-.01-.92-.34.33-.13 1.14-.53 1.42s-.4.22-1.06.72c.1-1.07.49-2.34 1.32-2.81l2.36-1.29c.22.78-.44 2.56-1.06 3.36-.7.9-1.13.87-1.89 1-.3.04-.48.12-.76.14zM344.1 242.75c.63-.03 2.34-.06 2.87-.34l.73-.33c0 .19 0 .09-.28.37.7-.04.4-.08 1.06.03-.08.14.13.12-.55.16-.78.06-1.19.14-1.88.21l-2.56.26c1.64.6 1.9 1.5 3.76.81 1.48-.55 1.77-1.15 2.7-2.28-2.3.54-2.55-1.41-4.8.08-.28.18-.9.8-1.05 1.03z'/%3E %3Cpath d='M347.17 244.17c.6.07.35-.01.85.22-.23.2-1.24-.05-1.63.04l-1.66-.04c.53.74 1.42 1.1 2.67.96 1.24-.13 1.56-.45 2.55-1.05l-1.87-.62zM346.48 254.94a2.98 2.98 0 0 0-.82-.46c-1.05-.4-1.87-.02-2.4-.03l-1.2-.14c.32.35 1.6.82 2.23.93 1.6.26.52.68 2.19-.3zM346.65 256.12l.48.43c-.13.06-.3-.05-.5-.15l-.1 1.09 2.19-.28a15.79 15.79 0 0 0-1.95-2.04c-.06.33-.16.58-.12.95zM343.85 256.74l1.3-.99c-.33-.26-.93-.25-1.4-.39l-1.25-.5c.3.42.31.32.67.94.2.34.35.7.68.94zM350.16 237.43c-.57.33-.96.85-1.6 1.11-.85.35-1.77 0-2.3.56 1.44-.09 2.39.46 3.5-.57.7-.63 1.3-1.6 1.86-2.42-.23-.01-.98.22-1.13.37-.08.08-.18.33-.27.46-.25.41-.08.1-.06.5zM345.4 270.25l1.05 2.13 1.45 1.78c.3-.14.64-.38.98-.56l1.16-.4c-.65-.29-.68-.6-1.05-.64-.9-.06-.37.09-1.56-.11.1-.2.06-.1.68-.12l.75-.02c-.44-.4-.99-.69-1.48-1.05l1.56.8-.05-1.04c.38.04.15.63.32 1.2.08.26.58.6.85.73.52.26.7.2 1.24.33l1.21.39c-.5-.7-.27.09-1.11-1.66a3.18 3.18 0 0 0-1.24-1.5c-1.41-.87-3.15-.28-4.76-.26zM347.17 268.15c.01-.86-.05-1.64.02-2.51.03-.41-.16-1.46-.23-2.06.2.06.17.15.22.4l.16.56c.2-.9.24-.88.73-1.52.08.2-.48.9-.58 1.93l-.1 2.55c.1-.12.1-.16.22-.3l.26-.26c.18-.19.3-.36.48-.63 1.21-1.9.47-2.98.5-3.55l.35-1.83c-.38.15-1.42.9-1.66 1.15-.94.95-1.87 2.63-1.28 4.07.14.33.32.62.47.95.15.33.26.76.44 1.05z'/%3E %3Cpath d='M346.52 275.44c.2.13 1.38.5 1.69.6 1.12.35 2.87.48 3.65-.56.42-.58.68-.73 1.22-1.16-.83.02-1.4.34-2.13.5-.54.13-.58.5-1.02.93l-.41.28c0-.27.52-.77.76-1.06l-1.63-.01c.06-.27.5-.14 1.21-.2 1.41-.12 1.65-.5 3.18-.68a.63.63 0 0 0 .3-.08c-2.29-.01-2.78-1.55-5.52.4zM356.95 274.03v-1.14c-.5-.38-.5-.5-.8-1.09.27.02.38.45.79.74-.05-.55-.27-1.46-.4-2.05.26.05.4.78.45 1.04.32 1.33.05 2.36.28 2.8l.65.87c.22-.93 1.18-1.53.04-3.81-.7-1.4-1.25-1.63-2.42-2.51.14.64.3.86.2 1.65-.08.54-.3.96-.35 1.5-.15 1.22.23 1.15.47 1.3.4.22.79.47 1.1.7zM345.66 271.86l-.34-.76c-.96.01-1.25.4-2.59-.5-.35-.23-.3-.2-.49-.57l1.49.83c-.08-.17-.26-.34-.56-.95.05-.03-.03-.1.14 0 .07.03.1.09.13.13l.72.96.98-.11c-.02-.17-.19-.45-.26-.62-.14-.33-.07-.38-.32-.57a2.52 2.52 0 0 0-1.25-.52c-.62-.06-.99.15-1.55.2l-1.51-.32c.06.3.63 1.24.79 1.46.64.9 2.34 2.22 3.78 1.65.2-.08.67-.21.84-.3zM337.78 264.85l.08.04.12.05c.43.18.8.38 1.11.73.4.44.42.65 1.01 1.15.96.8 2 .77 3.27.93a6.57 6.57 0 0 0-.58-.7c-1.02-1.08-.84-1.02-1.5-.93l-1.06.08c.05-.22.7-.26 1.16-.36-.24-.1-.43-.17-.69-.22-.54-.1-.16.04-.77-.19.28-.37 1.65.12 2.29.72.47.43 1.06 1.13 1.51 1.66l-.74-1.6c-.76-1.38-2.76-1.87-4.23-1.6-.24.03-.77.11-.98.24zM346.69 268.5c-.53-1.69-1.4-2.4-1.64-3.42-.15-.7-.1-.77.03-1.4.34.47-.29.79.7 2.46-.05-.54-.18-.78-.09-1.43.04-.27.36-1.27.36-1.3-.05-.27-1.26-1.38-1.59-1.73-.17 1.49-.56 2.81-.07 4.3.5 1.52 1.32 1.17 2.3 2.52zM354.73 276.07l1.06-.28a5.86 5.86 0 0 1-.69-.85c-.46-.67-.4-.73-.22-1.07.05.1.01 0 .04.14.02.18-.02.23.11.46.1.18.18.28.3.44.27.35.44.56.77.8-.02-.52-.12-.78.03-1.1.2.08.06-.06.14.15l.06.91 1.18-.31c-.8-1.4-2.32-1.9-3.71-2.46l.38 1.65c.15.63.32.99.55 1.52zM352.86 273.05c-.12-.32-.35-.66-.52-1.02-.38-.82-.32-1.2-1.08-1.98-.14-.14-.24-.27-.4-.4-.08-.05-.28-.18-.31-.26l-.01-.03v-.11c.27-.06.8.55.96.71.45.44 1.5 2.66 1.86 3.35-.05-.3-.2-.67-.1-.96.3-.88-.54-2.24-.96-2.52l-3.3-1.46c.4.38.63.6.9 1.2.22.48.32.06 1.18.98.9.96.83 2.15 1.78 2.5z'/%3E %3Cpath d='M358.91 273.04l.18-.49c.1-.3.02-.17.27-.42.12.2 0 .3-.14.72-.27.8-.44 1.47-.67 2.29.74-.1.7-.12 1.01-.66a4 4 0 0 0 .41-1.23l-.09-3.1-.95 1.24c-.5.71-.18.33-.02 1.65zM349 266c.24-.13.8-.8 1.03-1.05.14.25-.5.9-.63 1.05-.54.5-.2 0-.9.83 1.41.21 2-1.65 2.45-2.6-.28 0-1.17.3-1.4.44-.18.1-.13.05-.18.3l-.1.37c-.07.23-.17.45-.26.67z'/%3E %3C/g%3E %3Cg fill='%23ce1126' stroke='%23000'%3E %3Cpath stroke-width='.21600000000000003' d='M362.17 283.71l1.78.92-1.02 2c.74-.13 3.42-1.05 4.3-1.32-.22-.63-.3-.7-.22-1.47l-.3-1.42-2.16.72c-.82.25-1.5.42-2.38.57zM385.49 283.4l-1.78.92 1.01 2c-.74-.13-3.42-1.05-4.29-1.33.22-.62.3-.7.22-1.47l.3-1.42 2.16.73c.82.25 1.5.42 2.38.57z'/%3E %3Cpath stroke-width='.21600000000000003' d='M368.62 286.54c2-.29 3.78-1.34 3.78-1.34.3.32 1.9.09 1.9.09.74-.14 1.07-.26 1.07-.26 2 1.27 3.52 1.46 3.52 1.46 1.77-.1 1.82-1.46 1.82-1.46-.07-1.2-.2-1.25-.2-1.25.95-1.48-.06-2.65-.06-2.65-.47-.54-3.2.33-3.2.33-1.84.87-1.95.49-1.95.49-.52-.82-2.44-.67-3.27-.05a16.2 16.2 0 0 1-2.3-.59c-2.05-.77-2.38-.3-2.38-.3-.73.87-.5 1.79-.5 1.79 0 .51.17.96.17.96-.45 2.63 1.6 2.78 1.6 2.78z'/%3E %3Cpath stroke-width='.17600000000000002' d='M375.36 284.31c4.4 1 4.09 1.62 4.09 1.62-.27.46-1.56-.13-1.56-.13-3.43-1.2-2.53-1.49-2.53-1.49zM372.63 284.33c-4.4.99-4.09 1.61-4.09 1.61.27.46 1.56-.13 1.56-.13 3.43-1.2 2.53-1.48 2.53-1.48z'/%3E %3Cpath fill='%23aa241e' stroke-width='.16000000000000003' d='M372.82 281.34c-1.9.34-.4 1.75-.34 2.62 0 .47-.46 1.28.04 1.48.46.2 1.46-.03 1.99-.03.73-.04 1.22.03 1.12-.91-.06-.7-.3-.94-.3-1.85-.03-.63.1-1.34-.6-1.4-.42-.04-1.48.03-1.91.1z'/%3E %3Cpath fill='none' stroke-width='.17600000000000002' d='M375.42 282.4c5.02-.03 4.65-.83 4.65-.83M375.51 283.92c4.97.67 4.3 1.39 4.3 1.39'/%3E %3Cpath fill='none' stroke-width='.168' d='M372.4 283.78c-4.63 1.02-4.21 1.76-4.21 1.76M371.89 282.29c-4.73.34-4.25-.46-4.25-.46'/%3E %3C/g%3E %3C/g%3E %3Cg%3E %3Cpath d='M354.14 276.64c-2.5.82-4.15 1.4-6.54 2.8-.91-1.38-2.16-3.4-3.04-4.58a6.43 6.43 0 0 0-2.05-1.75c-1.35-.63-1.85-.44-2.7.3l-.61-1.15c-1.22-2.14-2.49-3.12-3.84-4.85l-1.21-1.42c-.17-.2-.23-.33-.45-.44.53 1.72.9 3.36 1.25 5.23-.75-.41-1.44-.82-2.21-1.15a8.4 8.4 0 0 0-2.8-.47l.89.8a10.91 10.91 0 0 1 3.12 5.12 15.44 15.44 0 0 0 3.84 6.05 7.26 7.26 0 0 0 1.88 1.4c1.82.66 1.74-.03 2.4-.36 1.4 2.38 2.3 3.57 3.93 5.37 1.74 1.84 4.47 2.33 6.96 1.75 1.1-.27 1.8-.57 2.65-1.06 3.23-1.87 1.68-3.32 1.3-4.8a94.14 94.14 0 0 1 6.63-1.84c5.2-.97 14.86-1.1 21.02-.2.56.09 6.78 1.74 7.39 2.1a4.96 4.96 0 0 0-.55 2.67c.1 1.05 1 1.6 1.8 2.07a9.24 9.24 0 0 0 6 1.2c2.32-.38 3.53-1.73 4.53-2.93 1.65-1.89 2.16-3.03 3-4.36 0 0 .48.44.81.55.32.1 1.35-.08 1.63-.19.8-.3 1.3-.9 1.85-1.42a14.34 14.34 0 0 0 3.84-6.11c.83-2.74 1.96-4.03 3.98-5.8-2.6.08-3.5.79-4.98 1.6l.56-2.68c.16-.73.58-1.83.66-2.54-1.19 1.26-2.24 2.58-3.29 3.75-.5.66-1.05 1.2-1.54 1.92-1.05 1.6-.85 1.66-1.25 2.19-3.66-2.04-5.31 2.92-7.79 5.97-4.6-2.59-8.6-3.4-14-4.38-1.21-.13-2.3-.3-3.29-.41-6.8-.8-14.28-.77-21.05.24-3.5.44-5.65 1.09-8.73 1.81z'/%3E %3Cg fill='%23ce1126'%3E %3Cpath d='M349.42 287.2c.42-1.2.94-1.46 1.98-1.96 3.35-1.54 5-2.17 8.82-3.18a49.18 49.18 0 0 1 6.7-1.26c1.18-.19 1.46-.2 3.52-.33 3.04-.16 4.8-.16 7.84 0 1.32.01 2.44.15 3.51.33 2.26.27 4.67.68 6.8 1.26 3.42.88 5.69 1.7 8.78 3.15 1.4.66 1.21.68 2.02 1.97 1.02-.68 1.76-2.16 2.34-3.15.3-.52.75-1.23.94-1.83.33-1.02-.3-1.35-.77-1.73-1.71-1.48-4.92-2.77-7.65-3.53-11.74-3.26-27.9-3.4-39.61-.03-2.85.82-5.75 1.97-7.63 3.48-.25.19-.5.4-.72.66-.66.76.43 2.28.78 2.93.34.64.64 1.27 1 1.75.42.58.94 1.08 1.35 1.48z'/%3E %3Cpath d='M337.82 276.75c1.32.25 1.8.63 2.65 1.78 1.9 2.63 1.99 4.5 5.22 8.05.74.83 1.3 1.48 2.43 1.98 1.19.52 2.43.68 3.84.49a8.3 8.3 0 0 0 3.31-1.1s1.2-.68 1.5-1.1c.32-.42.38-1.42.38-1.42-.96-.3-2.7 1.6-3.84 2.33-2.07 1.37-2.87.88-4.33-.4-1.28-1.1-1.74-2.28-2.57-3.7-.33-.58-.94-1.46-.72-2.36l1.55-1.59c-.62-1-1.38-2.12-1.94-2.99-.77-1.17-1.21-1.97-2.2-2.73-.59-.47-1.75-1.15-2.58-.66-.7.54-1.19 1.18-1.8 1.92-.32.38-.71.93-.9 1.5z'/%3E %3Cpath d='M335.6 271.7c-.3-.1-1.4-.95-1.98-1.2l-2.43-.82c.33.4.66.65 1.32 1.48 1.55 1.97 1.55 3.56 2.77 5.91.41.8 1.13 1.84 1.74 2.55.41.52 1.81 1.85 2.18 2.16.85.7 1.74.8 2.22.22.1-.41-1-1.15-1.61-1.45a9.56 9.56 0 0 1-1.94-1.34c-1.43-1.45-.33-3.23.78-4.5l.74-.87c.17-.6-1.04-2.28-1.68-3.12-.67-.8-2.35-2.69-3.1-3.54.11.69.34 1.62.47 2.33.11.5.5 1.81.53 2.2zM357.07 285l-.58-1.38c-.8.08-4.72 1.81-5.63 2.39-.28.16-1.38 1.04-.86 1.58 1.52 1.65 3.81-.76 5.17-1.8.47-.39 1.07-.83 1.9-.8z'/%3E %3Cpath d='M341.9 281.82c-.24-.08-.19-.57-1.07-1.23-.33-.27-2.33-1.31-2.68-1.7 0 0-.65-.46-.57-1.14.06-.51.48-.6.48-.6 1.8.05 3.93 4.45 3.84 4.67zM411.03 276.83c-1.32.25-1.8.63-2.65 1.78-1.9 2.63-1.99 4.5-5.22 8.05-.75.83-1.3 1.48-2.43 1.98a6.93 6.93 0 0 1-3.84.49 8.3 8.3 0 0 1-3.32-1.1s-1.19-.68-1.5-1.1c-.31-.42-.37-1.42-.37-1.42.96-.3 2.7 1.6 3.84 2.33 2.07 1.37 2.87.88 4.33-.4 1.27-1.1 1.74-2.28 2.57-3.7.33-.58.94-1.46.72-2.36l-1.55-1.59c.61-1 1.38-2.12 1.94-2.99.77-1.17 1.21-1.97 2.2-2.73.59-.47 1.75-1.15 2.57-.66.7.54 1.2 1.18 1.8 1.92.33.38.72.93.91 1.5z'/%3E %3Cpath d='M413.25 271.8c.3-.12 1.4-.97 1.99-1.21l2.43-.82c-.33.4-.67.65-1.33 1.47-1.55 1.98-1.55 3.56-2.76 5.92-.41.8-1.13 1.83-1.74 2.55-.42.52-1.81 1.85-2.18 2.16-.85.7-1.95.7-2.22.22-.1-.41 1-1.15 1.6-1.45.76-.41 1.42-.85 1.94-1.34 1.44-1.46.33-3.24-.77-4.5l-.75-.87c.23-1.13 1.05-2.28 1.69-3.12.66-.8 2.35-2.69 3.1-3.54-.12.69-.34 1.62-.48 2.33-.18.73-.36 1.47-.52 2.2zM391.78 285.08l.58-1.37c.8.08 4.73 1.8 5.64 2.38.28.17 1.38 1.04.86 1.6-1.52 1.64-3.82-.78-5.17-1.82-.47-.38-1.08-.82-1.9-.79z'/%3E %3Cpath d='M406.95 281.9c.25-.08.2-.57 1.08-1.23.33-.27 2.33-1.31 2.67-1.7 0 0 .66-.46.58-1.14-.06-.51-.49-.6-.49-.6-1.8.05-3.92 4.45-3.84 4.67z'/%3E %3C/g%3E %3Cg fill='%23eac102'%3E %3Cpath d='M353.51 279.28c-.2 0-.38.07-.57.12-.28.12-.56.25-.85.35-.11.04-.14.17 0 .18.16.13.12.36.2.53.06.19.1.38.17.57.06.25.15.49.2.74.06.24.14.48.18.72.01.11-.2.33.01.27.22-.05.4-.2.63-.21.08 0 .23-.15.06-.15-.2-.1-.13-.38-.23-.55l-.14-.55c.05-.2.33-.06.35.1.11.16.26.3.4.42.19.12.36.28.59.32.16.04.34.03.49-.04-.22-.2-.48-.35-.65-.6-.14-.19-.26-.4-.4-.6.21-.2.4-.44.45-.73a.86.86 0 0 0-.41-.8c-.15-.05-.32-.1-.48-.09zm-.26.27c.17 0 .31.13.4.27.1.18.15.38.14.59a.51.51 0 0 1-.3.42c-.12.1-.44.31-.46.03-.08-.32-.19-.63-.24-.95-.05-.2.15-.27.3-.32l.16-.04zM354.6 278.84c.03.15.23.22.2.39.05.23.1.46.17.69.01.2.08.4.11.61.03.15.08.3.1.44.04.21.1.41.13.62.04.09-.2.27-.03.26l1.7-.45c.14.02.19-.09.16-.22v-.51c-.17 0-.16.24-.3.31-.2.22-.48.32-.75.4-.16.02-.24-.13-.27-.27-.05-.13-.03-.27-.08-.4l-.12-.6c.2-.08.43-.13.64-.08.11 0 .2.22.3.11 0-.18-.07-.35-.1-.52-.04-.08-.06-.35-.17-.27-.06.12-.08.28-.23.32-.14.08-.3.14-.46.16-.1-.1-.1-.34-.13-.5.02-.18-.1-.44.14-.48a.73.73 0 0 1 .76.03c.09.06.28.25.29.04-.1-.17-.11-.4-.25-.54-.15-.02-.3.08-.45.1-.45.1-.9.24-1.35.36zM358.38 277.8c-.23.02-.46.08-.68.13l-.73.22c-.2.1.18.18.17.33.02.16.05.33.09.48.03.17.07.32.09.49.06.24.1.48.14.71.02.22.12.43.12.66.04.14-.04.29-.08.4.25-.06.49-.1.73-.18.12 0 .18-.17.03-.18-.1-.15-.1-.35-.15-.53-.03-.2-.08-.38-.12-.57.34-.08.69-.19.96-.4.19-.16.34-.38.34-.63.02-.23-.05-.46-.18-.65a.97.97 0 0 0-.34-.23c-.13-.04-.26-.04-.4-.04zm.42.05zm-.69.22c.2 0 .4.15.47.34.08.2.11.41.08.62-.04.14-.12.27-.26.32-.14.06-.26.19-.43.16-.1-.1-.02-.28-.1-.4-.06-.24-.09-.5-.16-.73-.03-.15.1-.27.23-.29a.78.78 0 0 1 .17-.02zM361.16 277.23c.1.09.19.17.25.28.08.12.05.27.1.4.06.2.05.4.1.6.03.16.07.32.07.48.07.2.06.43.05.64a.58.58 0 0 1-.67.47.41.41 0 0 1-.31-.24.9.9 0 0 1-.16-.42l-.11-.63-.1-.65c-.02-.17-.06-.34-.09-.5-.03-.1.22-.3.02-.28-.25.03-.49.1-.74.14-.18.12.14.17.13.32.03.15.02.3.06.45.05.33.13.65.16.99.02.15.07.3.07.45.04.15.13.29.22.42.14.13.31.26.51.27.36.06.75-.02 1-.29.1-.13.2-.28.23-.45 0-.24 0-.48-.06-.71-.02-.24-.02-.49-.1-.72l-.08-.6a.46.46 0 0 1-.02-.3c0-.1.18-.2.1-.27-.16 0-.3.06-.46.06-.06 0-.13.03-.17.1zM363.58 276.78c-.34-.01-.66.07-.99.12-.13.05-.35.04-.43.15.1.1.2.2.19.35l.15 1.02c0 .22.08.42.09.64.02.25.06.5.05.75.01.09-.18.28 0 .24.14-.05.28-.02.42-.07.18-.04.37-.06.55-.08.23-.04.45-.09.66-.17.12-.08.23-.17.32-.28.1-.1.15-.23.15-.36.01-.24-.02-.5-.22-.66-.12-.1-.27-.14-.42-.2-.1-.02-.24-.12-.07-.16.17-.1.33-.26.38-.46a.58.58 0 0 0-.12-.54c-.07-.18-.26-.23-.42-.26l-.3-.03zm-.45.24c.21-.05.46.03.57.22.12.16.08.36.06.53 0 .2-.22.27-.37.33-.11.07-.39.15-.36-.07.04-.15-.02-.3-.04-.45a3.57 3.57 0 0 1-.01-.43l.15-.13zm.25 1.36c.16-.01.37-.02.48.13.16.13.2.35.2.55 0 .16 0 .36-.14.46-.15.1-.34.19-.53.16-.17-.08-.16-.31-.18-.48-.03-.16-.07-.32-.08-.5-.04-.11-.07-.34.12-.3a.48.48 0 0 1 .13-.02zM364.91 276.5c-.02.12.18.13.17.27.03.17 0 .34.05.5.03.17 0 .34.05.5.05.2 0 .42.07.61.03.2-.02.42.05.61.04.18.02.4-.11.53-.06.1.16.06.23.04.24-.02.48-.03.72-.07.15-.01.29-.02.42-.05l.5-.05c.04-.2.07-.42.08-.62.01-.08.02-.2-.08-.14-.05.14-.15.25-.23.36a.68.68 0 0 1-.26.14c-.12.03-.24.08-.36.07-.14.03-.29-.02-.3-.18-.03-.2-.01-.4-.06-.59-.04-.37-.06-.75-.08-1.12-.03-.23-.08-.45-.05-.68.01-.1.25-.27.05-.24-.12.03-.24.05-.36.05s-.25.05-.38.04c-.04 0-.08 0-.12.02zM367.24 276.24c-.03.11.13.06.15.17.06.12 0 .27.06.4l.04.43.1 1.42c.04.12.04.24.04.37.02.1-.15.19-.13.26.3 0 .6-.02.9-.08.1-.02 0-.13-.07-.14-.09-.1-.08-.24-.1-.36-.01-.23-.01-.45-.06-.67-.02-.18 0-.36-.04-.53-.04-.24 0-.5-.06-.74-.02-.15-.06-.32 0-.47.02-.06.2-.19.05-.17-.28.01-.56.03-.83.1l-.05.01zM370.94 278.15c-.17-.01-.22.15-.31.25-.1.16-.28.22-.45.26-.2.05-.36-.1-.5-.21a1.5 1.5 0 0 1-.25-.5c-.06-.16-.07-.34-.11-.5-.04-.25-.03-.51 0-.76.05-.17.12-.37.27-.49.19-.12.45-.06.6.1.14.12.19.29.26.44.11.18.17-.08.18-.18.02-.12.1-.25.06-.37-.1-.13-.27-.18-.42-.23a1.1 1.1 0 0 0-1.06.22c-.11.08-.19.19-.26.3a.98.98 0 0 0-.16.37c-.06.17-.07.35-.1.52-.03.38.06.76.2 1.1.1.18.26.31.39.47.11.16.31.2.5.22.22.02.45-.03.64-.17.16-.1.27-.26.36-.43a.9.9 0 0 0 .15-.36.1.1 0 0 0 0-.05zM372.22 275.82c-.14.03-.32-.02-.42.04-.03.24-.1.47-.14.7-.03.16-.08.31-.09.48-.1.4-.18.8-.26 1.22l-.23.58c-.1.05-.07.18.05.13l.58-.01c-.02-.13-.19-.18-.2-.31-.05-.15.01-.28.02-.42 0-.16.25-.05.36-.09h.5c-.03.18.14.32.12.51.03.1-.2.31 0 .3.23.01.46-.07.68-.06.21-.02-.05-.2-.06-.3-.07-.24-.16-.46-.22-.7-.1-.33-.2-.66-.28-.99-.1-.29-.16-.58-.25-.87-.02-.1 0-.24-.15-.21h-.01zm-.32.71l.36 1.2c.06.16-.11.12-.21.13-.13.02-.25.03-.38.03-.09-.12.03-.3.04-.45.01-.18.1-.35.1-.54.04-.12 0-.26.1-.37zM375.88 275.7l-.9.06c-.06.1.16.12.12.25.02.24 0 .48 0 .73l-.04 1.97c-.01.1-.25.28-.05.26.45.02.9.06 1.33-.05a.86.86 0 0 0 .36-.22c.15-.13.26-.3.35-.47a2.48 2.48 0 0 0 .13-1.28c-.03-.18-.1-.36-.17-.54-.1-.11-.15-.26-.26-.36-.11-.12-.26-.2-.4-.27-.16 0-.3-.1-.47-.08zm.07.25c.19-.01.38.09.44.27.07.13.12.25.14.4.04.14 0 .3.04.44.06.28 0 .56-.03.84 0 .2-.07.4-.17.58-.05.14-.22.19-.34.25-.15.04-.37.03-.4-.16-.03-.18-.01-.36-.02-.53 0-.63 0-1.26.05-1.9-.01-.17.15-.22.3-.2zM378.7 275.8a.74.74 0 0 0-.53.15c-.18.13-.28.33-.4.5-.14.24-.19.52-.22.79 0 .23-.04.46 0 .68.08.17.12.35.18.53a1.03 1.03 0 0 0 .86.7c.32.04.62-.16.8-.4.14-.2.3-.4.33-.65.06-.2.08-.4.1-.6.01-.14-.02-.3-.03-.44-.02-.2-.1-.39-.19-.57-.13-.2-.23-.43-.44-.56a.81.81 0 0 0-.46-.13zm0 .2c.23 0 .38.24.41.46.05.17.07.34.09.52-.01.29 0 .58-.02.86-.05.18-.02.38-.1.56a.88.88 0 0 1-.23.48c-.13.09-.3.13-.4.01-.15-.08-.16-.25-.23-.39-.08-.23-.05-.48-.06-.73l.04-1.03c.04-.18.07-.36.15-.52.06-.14.2-.22.35-.22zM379.9 279.2c.2-.02.38.07.58.06.14-.12-.16-.23-.12-.4-.02-.19.03-.39.08-.58l.07-.54c.05-.18.05-.36.1-.54.02-.15.03-.4.08-.49.1.16.04.35.1.52.03.2.04.39.08.58l.08.62.08.56c.04.13-.04.4.19.34.2.07.13-.2.22-.32l.2-.86c.07-.15.09-.33.14-.5.07-.26.14-.54.25-.8 0 .78.06 1.56 0 2.34-.03.08-.24.23-.02.24.2.01.4.03.59.07.19.04.16-.12.04-.2-.12-.2-.05-.43-.06-.65 0-.38-.03-.76-.02-1.14 0-.35 0-.7.03-1.06.04-.06.22-.2.05-.21l-.7-.03c-.02.19-.1.36-.13.55l-.18.66c-.03.2-.1.4-.14.6 0 .08-.07.17-.07.03 0-.18-.1-.35-.07-.53 0-.14-.08-.28-.06-.43-.01-.3-.11-.6-.11-.92-.04-.14-.25-.07-.37-.12l-.38-.02c.05.2.1.4.06.6-.03.18-.07.35-.08.52-.07.4-.16.8-.2 1.2-.06.14-.05.3-.11.44-.05.13-.08.25-.2.33-.02.02-.01.05 0 .08zM382.98 279.54c.17.06.36.05.53.1.08 0 .29.1.3-.03-.07-.1-.17-.2-.13-.35.02-.18.06-.35.05-.53 0-.17.06-.32.06-.49a20.66 20.66 0 0 1 .13-1.48c0-.1.08-.15.14-.2.05-.17-.17-.1-.27-.12-.19-.02-.37-.07-.56-.06-.05.08.12.14.1.24.03.14 0 .27 0 .4-.07.2-.05.41-.07.61 0 .2-.03.39-.05.58-.06.14-.05.3-.05.45 0 .17-.01.35-.04.52 0 .12-.04.24-.13.3v.06zM384.06 279.77c.15-.01.3.07.44.06.08.03.25.08.17-.07a.7.7 0 0 1-.12-.45c0-.27.03-.53.07-.8 0-.2.01-.38.06-.57.02-.17.02-.35.07-.52.1.09.11.28.18.4l.74 1.92c.06.12.09.3.23.35.19.07.14-.14.15-.25.01-.16.1-.3.06-.48.03-.17.06-.35.06-.52.04-.18.07-.35.06-.53.03-.17.07-.34.06-.52 0-.18.06-.36.1-.54 0-.13.32-.25.12-.33-.17 0-.4-.11-.54-.05.04.14.16.25.13.41.03.36-.07.72-.07 1.07-.04.18-.05.38-.07.55-.1-.14-.14-.34-.21-.5-.08-.2-.14-.4-.24-.59-.04-.16-.13-.31-.17-.48l-.27-.66a3.2 3.2 0 0 1-.6-.12c-.16.09.09.23.06.36.05.27 0 .53-.03.79a3.9 3.9 0 0 1-.06.51c0 .19 0 .37-.06.55-.02.2-.05.39-.09.58 0 .16-.16.24-.23.36v.07zM386.87 277.07c.02.12.16.2.1.32 0 .16-.03.31-.05.46-.01.15-.03.3-.06.43-.02.24-.07.47-.07.7 0 .15-.06.28-.06.42 0 .11-.05.22-.06.33-.01.1-.02.2-.05.29-.04.05-.07.11-.14.12-.07.13.2.12.29.14.15.04.3.05.45.1.11.05.16-.08.06-.14-.11-.14-.03-.33-.02-.5.01-.12.02-.24.05-.37.03-.16.02-.33.06-.5.02-.12.01-.26.06-.38.03-.17 0-.34.06-.5 0-.15.03-.29.06-.42 0-.13.04-.27.16-.34-.11-.05-.24-.08-.36-.1-.13-.01-.25-.07-.37-.09-.04 0-.08 0-.1.03zM387.86 279.28c-.02.17 0 .35.03.51.04.24.15.45.28.64.08.16.25.22.39.32.17.1.4.09.58.01.1-.05.24-.08.3-.19.12-.15.27-.28.32-.47-.08-.17-.2.08-.27.13-.18.14-.46.2-.66.07a.78.78 0 0 1-.27-.42c-.03-.15-.1-.3-.08-.46 0-.2 0-.41.02-.62.08-.16.03-.36.1-.52.07-.14.1-.3.2-.43a.43.43 0 0 1 .34-.17c.14.02.23.16.32.26.1.13.15.3.14.46-.03.12.1.27.18.13.05-.17.16-.33.17-.5-.02-.15-.17-.22-.27-.32-.1-.08-.22-.13-.34-.2-.21-.05-.48-.08-.67.06-.13.07-.25.15-.34.26-.16.15-.23.36-.3.55-.1.2-.14.42-.17.63v.27zM391.09 278.07c-.2.4-.36.83-.55 1.24-.07.15-.11.31-.2.46-.09.21-.17.44-.3.64-.09.14-.12.35-.28.42-.13.03-.1.17.03.17.16.02.31.12.46.13.13-.08-.07-.18-.05-.3-.02-.15.04-.3.1-.43.12-.12.3-.01.43.01.1.07.27.03.34.11v.66c-.13.06-.1.21.04.21l.44.12c.08.04.25.07.15-.07-.1-.21-.07-.45-.08-.68 0-.18 0-.38-.03-.56-.04-.16 0-.32-.02-.48 0-.35.02-.7-.02-1.04l-.01-.48c-.14-.06-.29-.08-.43-.12h-.02zm-.07.68l.03 1.45c-.19 0-.36-.08-.54-.12-.1-.15.13-.27.12-.43l.29-.67c.04-.07.04-.17.1-.23zM392.47 281.8c0-.18-.15-.34-.09-.54-.01-.24.07-.46.12-.69 0-.16.08-.32.09-.49.03-.2.1-.39.12-.6.07-.17.13.06.14.15.1.32.18.66.27 1 .04.14.07.29.12.43.1.27.14.56.24.83-.01.17.08.38.28.34.08-.19.1-.4.15-.6.05-.18.03-.37.12-.53.06-.3.08-.62.18-.91l.17-.72c.05-.1.34-.23.13-.31-.16-.03-.34-.17-.5-.13.04.13.12.25.11.4 0 .18-.06.37-.07.56l-.12.48-.1.57c-.14-.12-.09-.33-.17-.49-.06-.21-.13-.43-.17-.65-.07-.2-.12-.42-.17-.64a1.97 1.97 0 0 1-.14-.5c-.1-.15-.33-.16-.5-.23-.14-.08-.26.01-.14.15.08.33 0 .66-.07.98-.06.29-.15.57-.18.85-.07.18-.07.37-.12.56-.06.15-.11.32-.26.41-.18.16.18.17.27.22.09.05.19.1.3.1zM395.63 279.67c-.1.24-.25.46-.36.7-.1.23-.23.43-.35.65-.22.4-.46.78-.68 1.17-.12.04-.27.2-.06.23.16.05.3.16.47.2.11-.06-.08-.22-.05-.32.01-.17.07-.32.14-.47.1-.06.25.08.37.1.12.09.4.07.36.26.01.2.01.4-.06.6-.1 0-.15.07-.05.13l.36.15c.12.02.24.14.35.08-.03-.14-.1-.3-.08-.46.02-.25.02-.5.02-.75 0-.17.06-.33.05-.5 0-.55.02-1.1.03-1.64-.17.01-.3-.14-.46-.13zm-.1.66l-.02 1.47c-.12-.03-.24-.1-.36-.13-.09-.07-.33-.1-.2-.23.1-.2.22-.39.31-.58.08-.19.18-.36.27-.53z'/%3E %3C/g%3E %3C/g%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 900 600'%3E %3Crect fill='%23fff' width='900' height='600'/%3E %3Crect fill='%23006233' width='450' height='600'/%3E %3Cpath fill='%23d21034' d='M580,225a150,150 0 1,0 0,150 120,120 0 1,1 0-150m5,75-135-44 84,115v-142l-84,115z'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 1440 960'%3E %3Cdefs%3E %3ClinearGradient id='d' y2='277.58' gradientUnits='userSpaceOnUse' x2='601.38' gradientTransform='matrix(1.14637 0 0 1.17117 33.18 82.14)' y1='342.3' x1='597.92'%3E %3Cstop stop-color='%23fff' offset='0'/%3E %3Cstop stop-color='%231ea8d1' offset='1'/%3E %3C/linearGradient%3E %3ClinearGradient id='e' y2='399.5' gradientUnits='userSpaceOnUse' x2='600.31' gradientTransform='matrix(1.14637 0 0 1.17117 33.18 82.14)' y1='326.43' x1='599.96'%3E %3Cstop stop-color='%23FFF' offset='0'/%3E %3Cstop stop-color='%23c1d3e8' offset='.13'/%3E %3Cstop stop-color='%2388b0d5' offset='.3'/%3E %3Cstop stop-color='%235998c6' offset='.46'/%3E %3Cstop stop-color='%232c87bc' offset='.62'/%3E %3Cstop stop-color='%23007db5' offset='.76'/%3E %3Cstop stop-color='%230077b0' offset='.9'/%3E %3Cstop stop-color='%230075af' offset='1'/%3E %3C/linearGradient%3E %3C/defs%3E %3Cpath fill='%23ed1c24' d='M0 0h1440v960H0z'/%3E %3Cpath fill='%23034ea2' d='M0 0h1440v720H0z'/%3E %3Cpath fill='%23fd0' d='M0 0h1440v480H0z'/%3E %3Cg id='a' stroke='%23000' stroke-width='.46' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'%3E %3Cpath fill='%23b1babf' d='M452.3 476.58a.57.57 0 0 1-.11.18s-2.73 1.42-5.71 1.62c0 0-2.7 8.42-5.89 11 3.72-2.49 9.8-4.76 11.33-4.92.08-2.35.51-5.13 2.02-6l.22-.05a9.58 9.58 0 0 0-1.86-1.83z'/%3E %3Cpath fill='none' stroke-width='.23' d='M442.15 487.98l10.95-10.45M451.94 484.32l-5.44-6.08'/%3E %3Cpath fill='%23b1babf' d='M472.76 455.57l3.2 3.78-20.28 19.03h-1.26l-2.3-2.06.12-1.6z'/%3E %3Cpath fill='none' stroke-width='.23' d='M454.08 476.66l19.83-18.34'/%3E %3Cpath fill='%23b1babf' d='M478.97 217.63l8.48 8.02-2.18.92-8.36-7.9 2.06-1.04'/%3E %3Cpath fill='%23034ea2' d='M509.97 317.7l11.08 10.95 5.2-12.53.99-7.69c-.78-22.02-.38-43.66-.38-43.66l3.26 2.84-12.44-12.45-7.33-7.2s-.14 46.32-.38 69.74z'/%3E %3Cpath fill='%23ed1c24' d='M527.24 308.43l11-32.7-11.38-10.96s-.4 21.64.38 43.66z'/%3E %3Cpath fill='%23fd0' d='M510.36 247.96l7.32 7.2c-13.33-13.35-28.93-29-36.85-37.02-1.46-1.48-1.8 31.9-1.64 69.12l30.79 30.44c.24-23.42.38-69.74.38-69.74z'/%3E %3Cpath fill='none' stroke-width='.23' d='M534.98 272.44l-59.13-59.49'/%3E %3Cpath fill='%23b1babf' stroke-width='.34' d='M476.98 214.13c-.12-.06-.2-.11-.21-.14 0 0-1.68-3.45-1.86-7.2 0 0-10.18-3.55-13.26-7.6 2.96 4.7 5.6 12.38 5.76 14.3 2.86.15 6.22.75 7.26 2.66l.05.27c.84-.64 1.6-1.4 2.26-2.29z'/%3E %3Cpath fill='%23ed1c24' stroke-width='.34' d='M484.95 223.48l-2.6-2.65c-.2.6-.5 1.62-1 3.41-1.04 3.82-.23 16.62-.8 21.01s-1.63 10.41-1.74 12.99l-.02.16c-.03 3.05 1.12 6.8 1.12 6.8s1.83.94 2.14.12.46-7.2.46-8.52.38-2.08 1.52-8.4.61-9.9.16-13.75c-.46-3.85.76-11.17.76-11.17z'/%3E %3Cpath fill='%23034ea2' stroke-width='.34' d='M480.06 218.04s-2.87 7.83-2.75 13.85c.11 6.01-.81 14.32-.93 15.56-.09.92-1.18 5.8-1.28 9.47-.04 1.3.29 1.16.59 1.93 0 0 1.98 1.24 3.1-.45l.02-.16c.11-2.58 1.15-8.6 1.73-12.99.58-4.39-.23-17.19.81-21 .5-1.8.8-2.83 1-3.42.2-.67.27-.79.27-.79l-2.56-2z'/%3E %3Cpath fill='%23ed1c24' stroke-width='.34' d='M487.82 216.7a86.75 86.75 0 0 1-7.84 1.64c6.5.13 9.11 4.02 9.11 4.02l2.2-2.65c1.96-3.24-1.74-3.59-3.47-3.01z'/%3E %3Cpath fill='%23ed1c24' stroke-width='.23' d='M479.99 218.34l.17.33c.77 1.4 3.94 6.65 7.59 4.73l1.35-1.03s-2.6-3.9-9.11-4.03z'/%3E %3Cpath fill='%23034ea2' stroke-width='.34' d='M480.53 218.34s6.41-3.56 7.3-3.53c.9.04 1.01 1.51 1.23 2.37s-.02 1.91-3.2 1.82c-3.16-.08-2.23-.43-5.33-.66z'/%3E %3Cpath fill='%23034ea2' stroke-width='.34' d='M490.62 214.23c-.95-4.4-5.46-3.48-5.46-3.48-4.43.74-4.99 6.12-5.06 7.54l-.01.34c10.45-8.9 9 .21 9 .21 1.05-1.85 1.53-4.61 1.53-4.61z'/%3E %3Cpath fill='none' stroke-width='.23' d='M462.2 200.03l13.75 15.31M467.41 213.52l7.57-6.7'/%3E %3Cpath fill='%23b1babf' stroke-width='.34' d='M480.04 203.82a2 2 0 0 0-.43-.46c.48 2.86.2 5.81-1 8.46a12.7 12.7 0 0 1-3.73 4.76c-3.45 2.64-8.22 3.26-12.77 1.43l.25.17c.38.25.77.5 1.17.72 7.19 4.06 15.19 2.52 17.87-3.43 1.6-3.55.95-7.88-1.36-11.65z'/%3E %3Ccircle fill='%23e8b909' cx='477.02' cy='257.56' r='2.09'/%3E %3Cpath fill='%23e8b909' d='M479.63 269.7c-2.96-.11-4.6-.28-6.53-.4.25-4.08.6-9.75 3.86-9.55 3.23.2 2.92 5.86 2.67 9.95z'/%3E %3Cpath fill='none' d='M475.83 263.2s-.56 5.84-.61 6.18M477.45 263.26s.07 4.43-.28 6.26'/%3E %3Ccircle fill='%23e8b909' cx='480.7' cy='263.46' r='2.09'/%3E %3Cpath fill='%23e8b909' d='M484.04 275.42c-2.97.07-4.62 0-6.54 0 0-4.1 0-9.77 3.27-9.77 3.24 0 3.27 5.68 3.27 9.77z'/%3E %3Cpath fill='none' d='M479.86 269.15s-.2 5.86-.24 6.2M481.48 269.12s.34 4.42.1 6.27'/%3E %3C/g%3E %3Cuse xlink:href='%23a' transform='matrix(-1 0 0 1 1439.03 0)'/%3E %3Cg stroke='%23000' stroke-width='.34'%3E %3Cpath fill='none' d='M529.89 257.24c-3.95 1.18-6.94 3.1-11.21 3.63' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3E %3Cpath fill='%2339b54a' d='M511.32 264.35s-.4-8.1-.07-9c.32-.88 7.38-6.38 5.24-20.15 0 0-1.39-4.62-.67-5.76 0 0-6.12 11.66-6.62 15.14-.51 3.48.36 9.15.7 10.53.34 1.38.89 5.1.89 5.1' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3E %3Cpath fill='none' d='M515.3 233.09c0 1.67-.57 3.39-.85 5.02-.28 1.62-.5 3.13-1.06 4.68-.71 1.98-1.68 4.03-2.05 6.08-.3 1.72-.3 3.47-.35 5.22M510.66 255.44c-.1-1.5 1.77-3.5 2.96-4.53M511.26 249.28c.44-1.09-.95-3.34-1.1-4.54M511.16 251.06c-.05-2.64 3.2-3.36 3.32-5.76M512.36 245.31c-.28-1.27-2.34-2.27-1.71-3.73' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3E %3Cpath fill='none' d='M513.32 242.88c.26-.8.92-1.6 1.41-2.35.45-.67 1.32-1.16 1.64-1.86M514 240.05c.06-1.67-.48-3-.42-4.62' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3E %3Cpath fill='%2339b54a' d='M518.47 255.06c.02-2.97.41-4.65 2.81-6.48 2.1-1.6 4.84-2.35 5.73-4.98-.48.9-.28 2.07-.5 3.06a16.46 16.46 0 0 1-1.24 3.52 28.45 28.45 0 0 1-2.97 4.75' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3E %3Cpath fill='%2339b54a' d='M508 264.51c1.63-3.75 4.27-6.78 8.07-8.46 2.91-1.28 6.03-1.72 9.16-1.88 1.9-.1 3.67-.12 5.52-.73 1.34-.44 3.67-1.05 4.53-2.2-5.33 2.99-8.41 8.88-14.2 11.26-4.56 1.87-10.6.94-14.61 4.05' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3E %3Cpath fill='none' d='M508.38 264.89c2.88-2.97 6.5-5 10.48-6.1 3.12-.86 6.65-1.9 9.44-3.6M518.98 259.15c.91.46 3 1.46 4.08 1.28M522.82 257.73c.95 0 2.54.75 3.32.38M519.74 258.51c-1.1-1.93 1.65-2.06 2.3-3.2' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3E %3Cpath fill='%2339b54a' d='M536.73 243.83c1-1.15.65-4.4 1.18-5.97.68-2.04 2.24-3.48 3.14-5.36-.82 1.85-.09 4.39-.74 6.35-.74 2.18-2.48 4.05-3.7 6' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3E %3Cpath fill='none' d='M538.26 241.27c-.2-1.84 1.28-3.33 1.66-4.98' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3E %3Cpath fill='%2339b54a' d='M505.23 305.87c2.2 3.34 4.85 8.7 1.85 12.42-.65-.96-.71-2.81-1.75-3.48-.75-.48-2.12-.27-3.01-.65-2.39-1.01-1.93-3.59-3.53-4.88l-.38-.94 6.28-3.1.54.63z' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3E %3Cpath fill='none' d='M502.38 308.56c2.8 2.08 4.74 5.5 4.47 9.06M502 308.43c.8 1.92.11 3.38.28 5.2.08-.11.14-.24.23-.35M503.14 308.94c1.83 1.35 3.09 2.36 4.34 4.21' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3E %3Cpath fill='%2339b54a' d='M495.23 296.18c1.02-1.23 1.29-3.41 2.17-4.86 1.11-1.8 2.98-3.6 4.97-4.3a24.56 24.56 0 0 1 7.39-1.44c2.43-.1 5.25.96 7.32.76-4.26 1.56-9.49 1.75-13.41 4.19-2.56 1.58-5.13 4.24-7.16 6.45-1.7 1.84-2.13 3.9-3.07 6.1' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3E %3Cpath fill='none' d='M495.36 297.71c1.04-2.53 3.19-5.73 5.4-7.4 2.2-1.7 5.08-2.71 7.88-2.56M497.14 294.39c1.44-1 3.37-1.94 4.6-3.2' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3E %3Cpath fill='%2339b54a' d='M505.44 288.1c1.35-1.52 3.25-1.39 4.98-1.63M493.57 305.11c.56-.75.85-1.72 1.3-2.58.63-1.18 1.47-2.19 2.28-3.27a43.6 43.6 0 0 1 5.23-6.02 14.55 14.55 0 0 1 6.4-3.43c2.2-.5 6.09.04 7.73-1.64-1.22 1.47-1.77 3.28-3.2 4.7-2.07 2.07-4.23 4.37-6.86 5.82-2 1.1-4.61 2.32-6.79 2.82-1.91.44-5.23.44-6.33 2.43.1.05.18.14.24.22.35-.23.71-.52 1.02-.84' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3E %3Cpath fill='none' d='M494.85 302.56c1.13-.38 2.16-1.98 3.03-2.8 1.26-1.2 2.6-2.14 4.08-3.07a38.18 38.18 0 0 1 5.75-3.1c1.64-.69 3.23-1.3 4.63-2.4' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3E %3Cpath fill='none' d='M500.97 297.33c1.35-.44 2.68-1.04 4.08-1.28.79-.13 1.73.03 2.43-.38M503.02 295.92c1.01-1.48 2.69-2.72 3.32-4.34' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3E %3Cpath fill='%2339b54a' d='M524.72 254.04c1.75-2.38 3.82-4.09 6.17-5.93 1.56-1.24 2.77-2.91 4.66-3.68 5.01-2.05 10.55 1.9 15.69 1.81-2.23.97-4.19 2.37-6.6 2.98-2.4.61-4.77.97-7.27.99-4.41.04-10.25.1-12.78 4.47' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3E %3Cpath fill='none' d='M527.66 251.49c2.9-.72 5.77-2.56 8.58-3.67 2.85-1.11 5.98-.52 8.78-1.44M536.15 247.91c1.85-.68 4.49.76 6.51.77' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3E %3Cpath fill='none' d='M533.41 249.06c.92-.76 1.86-1.6 2.84-2.3.74-.51 1.78-1 2.01-1.91' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3E %3Cpath fill='%2339b54a' d='M504.58 280.18c2.1-.42 2.83-4.03 3.4-5.62.76-2.18 1.42-5.22 2.78-7.09.9-1.21 2.62-2.16 3.88-3.06 1.6-1.15 2.37-1.57 4.25-1.85 2.52-.38 5.2-.63 7.76-.65 2.3-.03 4.93.36 7.07-.73-2.34.78-4.69 2.75-6.11 4.61-2.23 2.92-3.66 5.6-7 7.7-2.97 1.89-6.64 2.77-10.01 3.8-1.92.58-5.12 1.27-5.6 3.46' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3E %3Cpath fill='none' d='M507.61 277.54c3.65-3.69 5.16-9 10.73-10.47 3.4-.9 8.7-1.37 10.98-4.34' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3E %3Cpath fill='none' d='M510.51 274.11a6.2 6.2 0 0 1 4.31-1.79c1.64 0 3.37.41 4.88-.38M518.72 267.32c1-.37 2.02.25 3.03.26 1.05.01 1.88-.6 2.84-.77M515.4 268.34c.47-2 1.51-2.83 2.56-4.47' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3E %3Cpath fill='%2339b54a' d='M501.48 285.78c1.62-.1 2.35-2.1 2.85-2.98.7-1.18 1.34-2.87 2.46-3.85.74-.63 2.1-1.06 3.1-1.49a7.4 7.4 0 0 1 3.34-.78c1.93-.05 3.99-.03 5.94.12 1.76.13 3.75.52 5.43.04a11 11 0 0 0-4.88 2.23c-1.84 1.52-3.06 2.95-5.7 3.93-2.35.88-5.2 1.15-7.81 1.52-1.5.2-3.96.4-4.43 1.61' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3E %3Cpath fill='none' d='M503.92 284.47c2.96-1.86 4.36-4.79 8.68-5.26 2.64-.3 6.69-.23 8.57-1.77' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3E %3Cpath fill='none' d='M506.92 282.53a5.68 5.68 0 0 1 3.37-.74c1.25.1 2.55.45 3.74.1M512.87 279.37c.78-.14 1.53.27 2.3.34.8.07 1.46-.21 2.2-.26M510.29 279.74c.45-1.1 1.28-1.5 2.16-2.38' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3E %3Cpath fill='%2339b54a' d='M491.42 308.23s-13.45-14.3-6.2-32.03c0 0 .22 4.9.65 5.55.43.64 7.9 11.85 6.83 21.57-1.06 9.72-.53 5.77-.53 5.77l-.75-.86z' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3E %3Cpath fill='none' d='M491.42 307.05s-1.7-11.32-3.84-14.42c-2.14-3.1-2.46-9.6-2.25-10.78M487.57 291.36c.58-.73 1.21-1.5 1.28-2.46M489.5 296.16c.6-.8.7-1.84.96-2.67M489.28 298.4c-.7-.88-3.29-1.04-3.42-2.03M487.15 293.07c-.52-1.08-3.15-1.36-3.2-2.67M485.22 286.77c-1.01-.76-1.22-1.4-1.6-2.56M490.35 302.57c-1.02-1.16-2.16-1.54-3.31-2.24M490.46 300.11c.2-1.01 1.22-2 1.18-2.99' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3E %3Cpath fill='%2339b54a' d='M514.17 250.18s3.23-7.34 3.92-7.98c.68-.64 9.48-2.23 13.66-15.39 0 0 .8-4.72 1.95-5.39 0 0-10.68 7.48-12.68 10.32s-3.74 8.25-4.04 9.63c-.3 1.37-1.46 4.91-1.46 4.91' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3E %3Cpath fill='none' d='M531.62 224.41c-.73 1.48-2.02 2.73-3 4.04-.96 1.3-1.83 2.54-3.02 3.64-1.52 1.43-3.3 2.8-4.54 4.43-1.08 1.43-1.87 3.07-2.73 4.64M517.52 242.01c.58-1.38 3.15-2.27 4.68-2.64M520.79 236.85c.88-.76.62-3.39 1.02-4.51M520.32 237.5c.81-2.35 5.55-.33 6.52-2.32M523.55 233.85c.31-1.25-1.1-3.08.11-4.08' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3E %3Cpath fill='none' d='M525.49 232.15c.6-.6 1.54-1 2.31-1.42.7-.39 1.7-.42 2.3-.89M527.36 229.96c.79-1.45.9-2.88 1.67-4.27' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3E %3Cpath fill='%2339b54a' d='M496.94 255.01s.5-4.56.29-5.06c-.22-.5-5.3-3.6-3.36-11.35 0 0 1.14-2.6.64-3.24 0 0 4.22 6.56 4.5 8.53s-.5 5.15-.78 5.92c-.29.78-.79 2.87-.79 2.87' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3E %3Cpath fill='none' d='M494.84 237.54c-.05.94.34 1.9.5 2.83.17.9.3 1.76.66 2.63.47 1.12 1.14 2.27 1.36 3.42.19 1.01.12 2.04.12 3.07M497.7 250.13c.11-.85-1.22-1.97-2.07-2.55M497.41 246.66c-.3-.61.79-1.88.93-2.55M497.49 247.12c.3-1.4-3.43-1.61-3.36-2.87M496.7 244.43c.24-.71 1.79-1.27 1.36-2.1' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3E %3Cpath fill='none' d='M496.06 243.06c-.17-.45-.64-.9-.98-1.32-.31-.38-.95-.66-1.16-1.05M495.63 241.46c0-.94.43-1.7.43-2.6' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3E %3Cpath fill='%2339b54a' d='M496.44 275.23s.5-9.38.9-10.37c.41-.99 7.74-6.47 7.2-22.6 0 0-.82-5.48-.01-6.7 0 0-7.1 12.69-7.96 16.64-.86 3.95-.65 10.59-.48 12.22s.29 5.98.29 5.98' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3E %3Cpath fill='none' d='M503.64 239.7c-.17 1.92-.92 3.83-1.36 5.68-.44 1.83-.82 3.55-1.51 5.26-.9 2.2-2.04 4.44-2.62 6.76-.5 2.02-.67 4.14-.93 6.22M496.79 264.88c.07-1.75 2.07-3.81 3.32-4.86M498.03 257.86c.54-1.2-.54-3.96-.56-5.36M498.04 258.92c-.04-2.9 4.84-2.71 5.06-5.3M499.51 253.43c-.13-1.5-1.98-2.9-1.23-4.5' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3E %3Cpath fill='none' d='M500.69 250.75c.33-.9 1.05-1.74 1.6-2.53.5-.72 1.4-1.18 1.77-1.95M501.64 247.56c.24-1.91-.13-3.52.1-5.37' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3E %3Cpath fill='%2339b54a' d='M495.94 265.35s-2.67-4.48-3.52-6.94c-.86-2.46-2.35-4.8-2.89-5.23s5.88 3.3 6.3 4.38' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3E %3Cpath fill='none' d='M495.83 261.29c-.9-2.1-2.11-4.9-4.27-5.98M495.08 260.97c-.21-.94-1.26-1.61-1.92-2.14M494.87 259.26c-.26-.85-.42-1.84-.64-2.67' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3E %3Cpath fill='%2339b54a' d='M496.36 280.08s.75-9.72 5.13-12.28c0 0 4.27-2.14 6.08-3.84 0 0 2.57-3.53.96-1.28-1.6 2.24-2.67 14.73-2.77 15.48-.1.74-1.71 5.55-4.7 9.18s-4.38 5.87-5.02 7.16c-.64 1.28-1.18 4.7-1.18 4.7' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3E %3Cpath fill='none' d='M495.94 291.19c1.61-1.34 1.94-3.46 2.67-5.37.8-2.1 1.74-4.07 2.05-6.28.33-2.27.9-4.27 1.82-6.37.94-2.16 2.7-3.76 3.82-5.69M500.72 280.47c1.4-1.93 2.96-1.98 4.72-3.2M498.57 286.26c.99-1.51 3.1-1.22 3.83-3.06M499.32 282c.57-2.07-1.24-3.22-1.66-5.1M501.41 276.03a7.24 7.24 0 0 1 0-6.26M496.89 274.22a23.85 23.85 0 0 1 2.04-7.8c.62-1.35 1.54-2.63 2.27-3.91.5-.9 1.15-2.18 2.08-2.72' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3E %3Cpath stroke-width='.23' fill='%23ffdf4f' d='M503.27 259.4c-.1.48.6.77 1.13.49.04-.12.02-.23.04-.35.65.2 2.15.2 1.3-.78.6-.1 1.57-.67.74-1.18.48-.47.52-1.32-.02-1.77-.08.07-.17.17-.26.23-.04-.58-.55-.83-1.12-.7-.02.1.01.22-.01.31-.4-.27-.87-.3-1.27-.05.04.08.15.15.19.23-.36-.06-.53.13-.83.15.06.1.07.4.12.5.1-.01.1-.02 0-.02-.4.14-.67.43-.77.87.15.04.31.14.47.18-.76.22-.74.87-.08 1.13.1 0 .1 0 0-.01-.74.67.56.84 1 .26' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3E %3Cpath fill='%23de2126' d='M611.07 383.12c.5.3.23 1.16 1.2 1.24.18-.5.33-.66.44-1.18-.29 0-1.43.17-.79.37' stroke='none'/%3E %3Cpath stroke-width='.23' fill='%23ffdf4f' d='M504.45 265.29c-.1.48.6.77 1.13.49.04-.12.02-.23.04-.35.65.2 2.15.2 1.3-.78.6-.1 1.57-.67.74-1.18.48-.47.52-1.32-.02-1.77-.08.07-.17.17-.26.23-.04-.58-.55-.83-1.12-.7-.02.1.01.22-.01.31-.4-.27-.87-.3-1.27-.05.04.08.15.15.19.23-.36-.06-.53.13-.83.14.06.1.07.4.12.5.1 0 .1-.01 0-.01-.4.14-.67.43-.77.87.15.04.31.14.47.18-.76.22-.74.87-.08 1.13.1 0 .1 0 0-.01-.74.67.56.84 1 .26' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3E %3Cpath fill='%23de2126' d='M612.47 389.93c.44.31.2 1.2 1.07 1.28.17-.52.3-.68.4-1.21-.25 0-1.28.17-.7.38' stroke='none'/%3E %3Cpath fill='none' d='M503.78 264.38c-4.63 2.68-8.54 7.49-7.4 13.15' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3E %3Cpath fill='%2339b54a' d='M513.74 252.13c3.73-1.83 4.71-6.08 8.2-8.14 2.27-1.33 4.95-1.71 7.5-2.2 1.8-.34 4.23-.66 5.3-2.37-1.6 1.95-3.47 3.46-5.27 5.18-1.9 1.8-3.5 3.32-6.12 4.09-2 .58-4.07.37-6.03 1.05-1.63.56-2.59 1.89-3.96 2.9l.38-.51z' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3E %3Cpath fill='none' d='M517.45 249.44c1.9-1.18 3.12-3.06 5.2-3.92 2.31-.96 4.92-1.18 7.19-2.2M520.26 247.11c1.68-.96 4.07 0 5.62-1.15M522.94 245.36c.85-.72 1.9-1.34 2.68-2.04M514.64 261.32c-2.1 1.01-6.44 1.68-7.28 4.34' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3E %3Cpath stroke-width='.23' fill='%23ffdf4f' d='M514.64 261.19c.28.77 1.01 1.02 1.77.88l.14-.36c.93.44 1.84-.23 1.2-1.16.64-.1.72-.61.44-1.13-.15 0-.33-.04-.47-.04 1.1-1.4-2.43-2.45-2.46-.89-.66-.04-1.54.44-.8.9-.68.37-.85 1.46.05 1.67' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3E %3Cpath fill='%23de2126' d='M624.46 386.4c.05 2.38 1.94-1.32.03-.12.03.19.21.16.26.27' stroke='none'/%3E %3Cpath stroke-width='.23' fill='%23ffdf4f' d='M522.3 267.32c.28.77 1.01 1.02 1.77.88l.14-.36c.93.44 1.84-.23 1.2-1.16.64-.1.73-.61.45-1.13-.15 0-.33-.04-.48-.04 1.11-1.4-2.43-2.45-2.46-.89-.66-.04-1.54.44-.8.9-.68.37-.84 1.46.05 1.67' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3E %3Cpath fill='%23de2126' d='M633.24 393.57c.05 2.4 1.94-1.31.03-.1.03.18.21.15.27.25' stroke='none'/%3E %3Cpath stroke-width='.23' fill='%23ffdf4f' d='M517.57 270.77c.28.77 1.01 1.02 1.77.88l.14-.36c.94.44 1.84-.23 1.2-1.17.64-.1.73-.6.45-1.12-.15 0-.33-.04-.48-.04 1.11-1.4-2.42-2.45-2.46-.89-.66-.04-1.54.44-.8.9-.68.37-.84 1.45.05 1.67' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3E %3Cpath fill='%23de2126' d='M627.82 397.6c.05 2.4 1.94-1.31.02-.1.03.18.22.14.27.25' stroke='none'/%3E %3Cpath fill='%23ffdf4f' d='M619.34 399.85c.31.9 1.16 1.2 2.02 1.03l.17-.41c1.07.5 2.1-.28 1.37-1.37.74-.12.84-.72.52-1.32-.18 0-.38-.05-.55-.05 1.27-1.63-2.78-2.87-2.82-1.04-.76-.04-1.76.51-.91 1.06-.79.43-.97 1.7.05 1.95' stroke='none'/%3E %3Cpath fill='%23de2126' d='M620.66 398.2c.04 2.39 1.93-1.32.02-.11.03.18.22.15.27.26' stroke='none'/%3E %3Cpath stroke-width='.23' fill='%23ffdf4f' d='M506.59 276.51c.28.77 1.01 1.02 1.77.88l.14-.36c.93.44 1.84-.23 1.2-1.16.64-.1.73-.61.45-1.13-.15 0-.33-.04-.48-.04 1.11-1.4-2.43-2.45-2.46-.89-.66-.04-1.54.44-.8.9-.68.37-.84 1.46.05 1.67' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3E %3Cpath fill='%23de2126' d='M615.23 404.34c.05 2.39 1.94-1.32.03-.11.03.18.21.15.27.26' stroke='none'/%3E %3Cpath stroke-width='.23' fill='%23ffdf4f' d='M530.08 258.51c.28.77 1.01 1.02 1.77.88l.14-.36c.93.44 1.84-.23 1.2-1.16.64-.1.73-.61.45-1.13-.15 0-.33-.04-.48-.04 1.11-1.4-2.42-2.45-2.46-.89-.66-.04-1.54.44-.8.9-.68.37-.84 1.45.05 1.67' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3E %3Cpath fill='%23de2126' d='M642.16 383.24c.05 2.4 1.94-1.31.03-.1.03.18.21.15.27.25' stroke='none'/%3E %3Cpath stroke-width='.23' fill='%23ffdf4f' d='M538.64 246c.28.77 1.01 1.02 1.77.88l.14-.36c.94.44 1.84-.23 1.2-1.17.64-.1.73-.6.45-1.12-.15 0-.33-.04-.48-.04 1.11-1.4-2.42-2.45-2.46-.89-.66-.04-1.54.44-.8.9-.68.37-.84 1.45.05 1.67' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3E %3Cpath fill='%23de2126' d='M651.98 368.6c.04 2.38 1.93-1.32.02-.12.03.19.21.15.27.26' stroke='none'/%3E %3Cpath stroke-width='.23' fill='%23ffdf4f' d='M531.75 245.49c.28.77 1.01 1.02 1.77.88l.14-.36c.94.44 1.84-.23 1.2-1.16.64-.1.73-.61.45-1.13-.15 0-.33-.04-.48-.04 1.1-1.4-2.43-2.45-2.46-.89-.66-.04-1.54.44-.8.9-.68.37-.84 1.46.05 1.67' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3E %3Cpath fill='%23de2126' d='M644.08 368c.04 2.38 1.93-1.32.02-.12.03.19.22.16.27.27' stroke='none'/%3E %3Cpath stroke-width='.23' fill='%23ffdf4f' d='M514.12 281.11c.28.77 1.01 1.02 1.77.88l.14-.36c.93.44 1.84-.23 1.2-1.16.64-.1.73-.61.45-1.13-.15 0-.33-.04-.48-.04 1.11-1.4-2.43-2.45-2.46-.89-.66-.04-1.54.44-.8.9-.68.37-.84 1.46.05 1.67' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3E %3Cpath fill='%23de2126' d='M623.88 409.71c.04 2.4 1.94-1.31.02-.1.03.18.22.14.27.25' stroke='none'/%3E %3Cpath stroke-width='.23' fill='%23ffdf4f' d='M506.98 283.54c.28.77 1.01 1.02 1.77.88l.14-.36c.93.44 1.84-.23 1.2-1.16.64-.1.73-.61.45-1.13-.15 0-.33-.04-.48-.04 1.1-1.4-2.43-2.45-2.46-.89-.66-.04-1.54.44-.8.9-.68.37-.84 1.46.05 1.67' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3E %3Cpath fill='%23de2126' d='M615.67 412.56c.04 2.39 1.94-1.32.02-.11.03.18.22.15.27.26' stroke='none'/%3E %3Cpath stroke-width='.23' fill='%23ffdf4f' d='M506.59 294.26c.28.77 1.01 1.02 1.77.88l.14-.36c.93.44 1.84-.23 1.2-1.16.64-.1.73-.61.45-1.13-.15 0-.33-.04-.48-.04 1.11-1.4-2.43-2.45-2.46-.89-.66-.04-1.54.44-.8.9-.68.37-.84 1.46.05 1.67' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3E %3Cpath fill='%23de2126' d='M615.23 425.13c.05 2.38 1.94-1.32.03-.12.03.19.21.16.27.27' stroke='none'/%3E %3Cpath stroke-width='.23' fill='%23ffdf4f' d='M500.08 298.73c.28.77 1.01 1.02 1.77.88l.14-.36c.93.44 1.84-.23 1.2-1.16.64-.1.73-.61.45-1.13-.15 0-.33-.04-.48-.04 1.1-1.4-2.43-2.45-2.46-.89-.66-.04-1.54.44-.8.9-.68.37-.84 1.46.05 1.67l.14.08' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3E %3Cpath fill='%23de2126' d='M607.77 430.36c.05 2.39 1.94-1.32.03-.11.02.18.21.15.26.26' stroke='none'/%3E %3Cpath stroke-width='.23' fill='%23ffdf4f' d='M520.13 253.4c.28.77 1.01 1.02 1.77.88l.14-.36c.93.44 1.84-.23 1.2-1.16.64-.1.73-.61.45-1.13-.15 0-.33-.04-.48-.04 1.1-1.4-2.43-2.45-2.46-.89-.66-.04-1.54.44-.8.9-.68.37-.84 1.46.05 1.67' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3E %3Cpath fill='%23de2126' d='M630.76 377.27c.04 2.39 1.93-1.32.02-.11.03.19.22.15.27.26' stroke='none'/%3E %3Cpath fill='%2339b54a' d='M537.75 242.93c2.74-2.5 2.59-6.66 6.38-8.43 1.92-.89 4.22-1.43 5.83-2.76-2.95 5-7.02 8.71-12.21 11.19' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3E %3Cpath fill='%2339b54a' d='M537.11 243.19c1.87-.68 3.25-2.28 5.04-3.12 2-.93 3.69-.26 5.8-.45 2.1-.18 4.03-.72 6.01-1.4-3.8 5.2-11.86 1.37-16.6 4.72' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3E %3Cpath fill='none' d='M539.28 241.15c1.69-.3 2.5-2.2 3.42-3.44 1.08-1.47 2.62-1.8 4.24-2.56M499.22 291.68c.95-1.32 1.79-2.83 2.94-3.96' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3E %3Cpath fill='%2339b54a' d='M492.65 309.16c.66-1.44.85-3.01 1.94-4.18 1.21-1.3 3.3-2.67 4.9-3.42 4.46-2.1 10.47-1.28 14.22-4.75-1.6 4.51-7.27 8.45-11.47 10.43-1.75.83-3.61 1.61-5.53 1.92-1.5.25-3.4-.08-4.83.38' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3E %3Cpath fill='none' d='M492.9 309.28c1.45-.66 2.33-2.02 3.6-2.83a19.97 19.97 0 0 1 4.7-2.18c2.01-.64 4.1-1.27 6.05-2.12.74-.32 3.02-1.34 3.14-2.06M497.13 306.35c1.39.38 2.68 1.35 4.21.51M500.56 304.43c2.56.01 4.57.36 7.02-.77' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3E %3Cpath fill='none' d='M497.37 306.15c.56-.58.65-1.43 1.11-2.08.45-.63 1.16-1.18 1.57-1.8M501.58 303.92c.53-.62 1.05-1.23 1.76-1.7.7-.45 1.81-.62 2.33-1.36M491.62 308.57c.27-1.81 1.58-3.13 2.34-4.71.48-1.03.93-3.06.98-4.17' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3E %3Cpath fill='%2339b54a' d='M493.27 305.39s.75-10.68.43-11.85c-.32-1.18-7.9-8.44-5.02-26.6 0 0 1.7-6.08.96-7.57 0 0 6.3 15.37 6.73 19.96.42 4.6-.75 12.07-1.18 13.89-.42 1.81-1.17 6.72-1.17 6.72' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3E %3Cpath fill='none' d='M490.06 264.17c-.07 2.2.5 4.47.75 6.62.24 2.13.43 4.13.98 6.17.71 2.61 1.7 5.31 2.03 8.02.29 2.36.19 4.78.19 7.17' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3E %3Cpath fill='%2339b54a' d='M494.34 293.64c.17-1.99-1.82-4.61-3.1-5.98' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3E %3Cpath fill='none' d='M493.91 285.53c-.45-1.43 1.18-4.4 1.39-5.98' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3E %3Cpath fill='%2339b54a' d='M494.02 286.6c.45-3.27-5.13-3.77-5.02-6.73' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3E %3Cpath fill='none' d='M492.84 280.29c.36-1.67 2.67-2.98 2.03-4.91M491.88 277.09c-.26-1.06-.95-2.12-1.47-3.1-.46-.88-1.41-1.53-1.73-2.45M491.24 273.35c0-2.2.64-3.96.64-6.09' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3E %3C/g%3E %3Cg stroke='%23000'%3E %3Cg fill='%23009c4f' stroke-width='.43'%3E %3Cpath d='M706.69 299.29c-.76-11.43-6.04-56.73-16.34-71.32 0 0 10 14.14 11.1 76.8l5.24-5.48z' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3E %3Cpath d='M705.16 292.54c-5.62-35.75-25.08-67.02-25.08-67.02 7.35 15.13 20.25 53.84 23.64 77.45l2.33-2.23-.89-8.2z' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3E %3Cpath d='M674.47 227.34c16.47 29.84 23.28 73.26 24.32 80.45l5.79-5.56c-5.35-33.64-30.11-74.89-30.11-74.89' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3E %3Cpath d='M664.8 224.38c2.81 4.74 15.4 29.58 20.51 43.94 4.15 11.63 8.35 32.79 10.21 42.73l7.13-6.85c-6.56-30.92-33.85-73.69-37.84-79.82' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3E %3Cpath d='M654.57 221.39s21.01 32.36 27.47 54.44c2.04 6.99 8.15 28.02 10.46 37.93l8.22-6.55c-6.51-19.03-26.9-67.2-46.15-85.82' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3E %3Cpath d='M654.81 240.03c10.93 14.65 29.6 49.29 34.66 76.94l9.45-9.09c-8.15-22.15-34.4-55.83-44.11-67.85' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3E %3Cpath d='M661.97 260.62c13.04 17.11 23.02 45.73 23.75 59.02l8.08-6.54c-8.23-22.02-31.83-52.48-31.83-52.48' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3E %3C/g%3E %3Cg fill='none' stroke-width='.27' stroke-linecap='round'%3E %3Cpath d='M823.61 452.48c-3-14.1-10.05-29.28-16.96-42.47M829.61 446.19c-6.6-19.32-18.14-41.61-31.06-61.33M827.66 427.33c-7.95-20.24-24.31-59.8-36.91-75.74M834.41 435.46c-5.7-21.77-18.3-50.74-25.06-64.4M836.36 428.87c-6-24.07-13.65-45.23-18.46-56.27M840.26 432.09c-1.8-19.16-11.7-51.05-19.2-67.76M838.16 408.17c-.75-9.35-3.75-28.67-5.85-37.1'/%3E %3C/g%3E %3C/g%3E %3Cg id='b' fill='none' stroke='%23000' stroke-width='.46' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'%3E %3Cpath fill='%23b1babf' d='M486.92 512.12a.57.57 0 0 1-.11.18s-2.73 1.42-5.71 1.62c0 0-2.7 8.42-5.89 11 3.72-2.49 9.8-4.76 11.33-4.92.08-2.36.51-5.13 2.02-6l.22-.05a9.5 9.5 0 0 0-1.86-1.83z'/%3E %3Cpath stroke-width='.23' d='M476.77 523.52l10.95-10.45M486.55 519.85l-5.44-6.08'/%3E %3Cpath fill='%23b1babf' d='M527.78 478.26l-37.48 35.65h-1.26l-2.3-2.07.12-1.6 37.71-35.76 3.21 3.78'/%3E %3Cpath stroke-width='.23' d='M488.69 512.19l35.19-33.01'/%3E %3Cpath fill='%23fd0' d='M517.38 449.99c-24.76-15.59-28.8-63.2-28.43-69.69s.61-82.52.61-82.52l7.33 7.2c-13.33-13.35-28.93-29-36.85-37.02-2.54-2.57-.72 99.61-.72 144.98 0 21.28 13.27 96.33 91.1 58.56 0 0 38.9-13.96 50.25-30.8-2.65 0-5.27-.16-7.85-.49a41.85 41.85 0 0 1-3.78 1.78c-44.89 30.25-71.66 8-71.66 8z'/%3E %3Cpath fill='%23034ea2' d='M488.96 380.3c-.38 6.5 3.67 54.1 28.43 69.69 0 0 26.77 22.25 71.66-8-13.57 5.6-24.65 6.78-31.91 4.63-21.7-6.41-44.65-31.48-48.31-56.84-3.67-25.37-2.75-75.2-2.75-75.2l3.25 2.85-12.43-12.45-7.33-7.2s-.23 76.02-.61 82.52z'/%3E %3Cpath fill='%23ed1c24' d='M520.74 347.46c-.22-2.3-.38-10.48-.4-19.4-5.11-5.12.98 1.16-10.95-10.77l-3.32-3.41-.01 1.63c-.1 6.9-.61 50.93 2.76 74.27 3.67 25.37 25.99 50.44 47.69 56.85 7.26 2.15 18.96.97 32.54-4.63.91-.62 1.84-1.25 2.77-1.91-39.25-5.6-66.33-42.19-71.08-92.63z'/%3E %3Cpath stroke-width='.23' d='M519.52 327.41l-59.13-59.49'/%3E %3Cpath fill='%23b1babf' stroke-width='.34' d='M458.98 264.71c-.91-.9-2-1.46-3.06-1.65.17-.7.07-1.32-.32-1.7-.83-.83-2.69-.3-4.15 1.17-1.46 1.48-1.97 3.35-1.14 4.17.4.39 1 .47 1.7.3a5.9 5.9 0 0 0 1.68 3.06c1.95 1.93 4.7 2.3 6.17.82 1.46-1.48 1.07-4.24-.88-6.17z'/%3E %3Cpath d='M458.96 267.62l-.17-.33.17.33zM467.89 271.31l-1.35 1.03c.44-.23.9-.56 1.35-1.03z'/%3E %3Cpath fill='%23ed1c24' stroke-width='.34' d='M460.84 324.05c.3-1 .46-8.71.46-10.31 0-1.61.38-2.53 1.53-10.17 1.14-7.64.6-12 .15-16.66-.46-4.66 1-14.65 1-14.65l-2.85-2.08c-.19.72-.5 1.96-.99 4.14-1.04 4.62-.23 20.11-.8 25.43-.58 5.32-1.62 12.6-1.74 15.73l-.01.19c-.04 3.7 1.1 8.23 1.1 8.23'/%3E %3Cpath fill='%23034ea2' stroke-width='.34' d='M458.64 267.84s-2.66 8.44-2.54 15.72c.11 7.29-.81 17.35-.93 18.85-.11 1.5-2.08 11.8-.92 15.38l1.38 1.96s1.77-1.1 1.96-4.09v-.18c.13-3.13 1.17-10.4 1.74-15.73.58-5.32-.23-20.81.81-25.44.5-2.17.8-3.41 1-4.13.2-.82.28-.95.28-.95l-2.78-1.39z'/%3E %3Cpath fill='%23ed1c24' stroke-width='.34' d='M466.62 265.65a86.75 86.75 0 0 1-7.84 1.64c6.5.13 9.11 4.02 9.11 4.02l2.2-2.65c1.96-3.24-1.74-3.59-3.47-3.01z'/%3E %3Cpath fill='%23ed1c24' stroke-width='.34' d='M458.78 267.28l.17.33c.77 1.4 3.94 6.65 7.59 4.73l1.35-1.03s-2.6-3.9-9.11-4.03z'/%3E %3Cpath fill='%23034ea2' stroke-width='.34' d='M459.21 267.21s5.1-5.28 5.96-5.5c.87-.24 1.4 1.14 1.86 1.9.46.77.53 1.84-2.52 2.68-3.06.84-2.27.24-5.3.92z'/%3E %3Cpath fill='%23034ea2' stroke-width='.34' d='M467.66 260.33c-2.2-3.93-6.24-1.73-6.24-1.73-4.01 2-2.98 7.31-2.64 8.69l.1.32c7.4-11.56 8.66-2.42 8.66-2.42.47-2.09.12-4.86.12-4.86z'/%3E %3Cpath fill='%23e8b909' stroke-width='.53' d='M558.44 469.55c.28-4.79.64-11.43-3.06-11.66-3.74-.23-4.14 6.4-4.42 11.23 2.2.16 4.08.36 7.48.49' transform='matrix(.87232 0 0 .85385 -28.94 -70.13)'/%3E %3Ccircle fill='%23e8b909' cx='455.52' cy='318.82' r='2.09'/%3E %3Cpath d='M454.26 324.19s-.56 5.84-.61 6.18M455.88 324.26s.07 4.43-.28 6.26'/%3E %3Cpath fill='%23e8b909' stroke-width='.53' d='M560.55 463.61s.39 5.17.12 7.34m-1.98-7.3s-.23 6.87-.27 7.26m5.07.08c-3.4.08-5.3 0-7.5 0 0-4.8 0-11.45 3.75-11.45 3.7 0 3.75 6.65 3.75 11.45z' transform='matrix(.87232 0 0 .85385 -28.94 -70.13)'/%3E %3Ccircle fill='%23e8b909' cx='459.27' cy='321.64' r='2.09'/%3E %3Cellipse fill='%23c0cad0' stroke-width='.23' cx='452.96' cy='264.03' rx='1.97' ry='3.5' transform='rotate(44.76 452.94 264)'/%3E %3Cpath fill='%23b1babf' stroke-width='.34' d='M448.94 274.96s-2.8-1.6-3.08-4.92c-.19-2.32 1.43-4.41 2.44-5.48.47.33.87.53 1.07.54l.61-.36 2.16-2.23 1.36-1.34c.5-.63.86-1.15.87-1.36l-.2-.5c1.75-1.9 5.71-6.56 3.94-7.73-1.52-.98-6.03 2.68-7.56 3.99l-.74-.32c-.2.02-.57.27-1.02.64a31.9 31.9 0 0 1-3.12-10.4s-15.83-4.7-20.83-10.68c4.84 6.99 9.44 18.55 9.84 21.46 4.08.01 8.86.63 10.88 3.01-.29.38-.49.71-.5.87-.04.38.08.8.28 1.22a9.95 9.95 0 0 1-4.98 2.8c-3 .54-5.74-2.72-5.74-2.72h-.05a11.31 11.31 0 0 0-.52 3.4c0 6.14 4.84 11.1 10.8 11.1 1.5 0 2.92-.3 4.21-.87l-.12-.12z'/%3E %3Cpath stroke-width='.23' d='M426.06 236.42l21.32 21.32M434.65 256.4l10.88-10.71'/%3E %3Cpath stroke-width='.34' d='M446.18 260.15a3.37 3.37 0 0 1 3.44-3.3c1.83.07 3.27 1.64 3.21 3.51s-1.6 3.36-3.43 3.3a3.37 3.37 0 0 1-3.22-3.51z'/%3E %3Cpath stroke-width='.27' d='M533 389.88c-.27 2.3.93 7.18 3.35 9.65s6.2 4.31 10.26 3.8' transform='matrix(.87232 0 0 .85385 -28.94 -70.13)'/%3E %3C/g%3E %3Cuse xlink:href='%23b' transform='matrix(-1 0 0 1 1440 0)'/%3E %3Cg id='c' stroke='%23000' stroke-width='.46'%3E %3Cpath fill='%23fd0' d='M581.88 467.92c-6.19.17-17.65 1.6-17.65 1.6s-19.97 26.48-20.46 32.01c-.48 5.53-.48 10.1 12.76 8.18 0 0 6.4-1.21 11.69-1.6 5.82-1.9 6.46-.52 7.07-.12.47-2.02 1.6-6.86 2.96-12.5 2.7-11.14 6.28-25.38 7.35-26.87l.05-.38c-.33-.3-1.77-.38-3.77-.32z' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3E %3Cpath fill='%23ed1c24' d='M587.08 458.22s-.29 1.86-.73 4.96l5.3 2.5s-.48 7.7-.72 12.27c-.16 3.02-2.2 23.76-3.58 37.5l-1.06 10.56c.28 4.22-3.06 8-3.06 8-2.23 2.18-3.33 3.97-3.68 5.42l-.11 1.24c.01.17.04.34.07.5.57 2.54 4.04 3.48 6.37 3.2 3.85-.49 11.07-5.1 11.07-5.1l.72-73.11-10.59-7.94z' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3E %3Cpath fill='%23034ea2' stroke-linecap='round' d='M586.35 463.18c-.2 1.44-.45 3.15-.7 5.05.1.1.1.2-.01.33l-.05.06c-1.07 1.5-4.65 15.72-7.34 26.88-1.36 5.63-3.02 12.35-3.49 14.37-.57 1.25-10.67 12.84-10.86 16.6-.08 1.53 1.16 2.46 4.65 2.25 5.33-.32 9.05-1.3 11.69-1.95 3.32-.82 4.94-1.14 5.88.99l.18-1.75c.2-2.1.6-5.93 1.05-10.56 1.38-13.74 3.42-34.48 3.58-37.5.24-4.57.72-12.27.72-12.27l-5.3-2.5z' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3E %3Cpath fill='%23ebc900' d='M574.87 507.48c-.42-.3-.12-1.38-7.42.68-1.63 7.31-3.55 18.31-3.55 18.31.03-3.72 7.8-11.38 10.06-14.85 1.13-1.75 1.44-3.26.91-4.14z' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3E %3Cpath fill='%23023f88' d='M585.7 529.77l.51-2.01c-.95-2.13-2.59-1.8-5.96-.99-.18 4.42-.4 9.33-.68 12.68.35-1.45 1.45-3.27 3.71-5.44 0 0 1.7-1.43 2.42-4.24z' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3E %3C/g%3E %3Cuse xlink:href='%23c' transform='matrix(-1 0 0 1 1435.18 0)'/%3E %3Cg fill='%23452c25' stroke='%23000' stroke-width='.47'%3E %3Cpath stroke-width='.58' d='M593.68 214.48s-8.43 19.15-5.51 21.05c0 0 8.54-14.87 16.05-20.5 3.9-3.6 6.27.04 6.77-3.13s-10.26-7.7-10.26-7.7l-6.9 9.49' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3E %3Cpath d='M562.94 229.06s-12.25 20.87-9.04 21.11c3.22.25 16.31-26.6 16.31-26.6l-4.46.74-2.81 4.75z' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3E %3Cpath d='M566.64 223.25s-12.8 20.53-9.6 20.86c3.2.33 17.01-26.16 17.01-26.16l-4.48.63-2.93 4.67z' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3E %3Cpath d='M569.23 219.67s-14.57 19.31-11.41 19.93c3.16.61 19.27-24.55 19.27-24.55l-4.53.23-3.33 4.39z' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3E %3Cpath d='M573.13 216.28s-17.07 17.15-14.02 18.19c3.05 1.04 22.43-21.7 22.43-21.7l-4.5-.39-3.91 3.9z' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3E %3Cpath d='M573.74 210.04s-14.9 19.07-11.74 19.74 19.67-24.23 19.67-24.23l-4.52.15-3.41 4.34zM569.94 226.43s-14.57 19.31-11.41 19.93c3.16.61 19.27-24.55 19.27-24.55l-4.52.23-3.34 4.39zM578.14 222.61s-8.53 15.72-7.56 16.37c.98.65 11.34-8.96 16.46-18.32s-9.27 1.56-9.27 1.56' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3E %3Cpath stroke-width='.58' d='M586.61 219.12s-8.43 19.15-5.51 21.05c0 0 10.56-11.55 13.32-20.73s0-.64 0-.64l-.76-9.97-6.9 9.5' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3E %3Cpath stroke-width='.58' d='M579.05 221.05s-8.43 19.15-5.51 21.05c0 0 10.56-11.55 13.32-20.73s0-.64 0-.64l-.76-9.97-6.9 9.5' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3E %3Cpath d='M574.68 219.38s-17.07 17.15-14.02 18.19 22.43-21.7 22.43-21.7l-4.51-.39-3.9 3.9z' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3E %3Cpath d='M576.03 221.7s-17.07 17.15-14.02 18.19c3.05 1.04 22.43-21.7 22.43-21.7l-4.5-.39-3.91 3.9z' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3E %3Cpath d='M577.39 224.42s-17.07 17.15-14.02 18.19 22.43-21.7 22.43-21.7l-4.5-.39-3.91 3.9zM578.66 200.87s-12.68 15.85-10.85 18.58c1.83 2.73 13.4-7.28 17.07-14.3 3.65-7-6.1-4.8-6.1-4.8' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3E %3Cpath d='M578.26 217.71s-10.87 20.36-8.06 19.19c2.8-1.17 13.82-16.48 15.04-19.86 1.22-3.38.8-6.9.8-6.9l-8.4 5.06.71 3.94' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3E %3Cpath stroke-width='.4' d='M578.33 211.01s9.02-16.23-.06 3.06c-9.08 19.28-12.48 16.1-12.48 16.1-.7-1.1 7.9-14.17 7.9-14.17s6.38-10.05 7.9-11' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3E %3Cpath stroke-width='.43' d='M588 208.86s10.03-16.12-.02 3.06C577.92 231.1 574 227.86 574 227.86c-.81-1.12 8.78-14.07 8.78-14.07s7.13-9.97 8.85-10.9' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3E %3Cpath d='M588.39 209.96s-10.13 21.1-7.8 22.65c0 0 8.4-9.48 10.6-17.02 2.19-7.53 0-.52 0-.52l2.8-13.56M598.82 205.26s-10.13 21.1-7.81 22.65c0 0 8.41-9.48 10.6-17.02 2.2-7.53 0-.52 0-.52l2.82-13.56' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3E %3Cpath d='M584.32 202.05s-12.68 15.85-10.85 18.58c1.83 2.73 13.4-7.28 17.07-14.3 3.65-7-6.1-4.8-6.1-4.8' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3E %3C/g%3E %3Cg fill='%23c69024' stroke='%23000' stroke-width='.53'%3E %3Cpath fill='%23b1babf' stroke-width='.46' d='M682.1 459.3c0 2.91-.97 3.47-.97 3.47H532.06v-6.64h149.08s.97.26.97 3.17z' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3E %3Cpath fill='%23b87510' d='M655.42 620.46c0 1.17.02 2.32.07 3.48h126.56a90.35 90.35 0 0 0-.02-7.55H655.5c-.06 1.35-.1 2.7-.1 4.07z'/%3E %3Cpath fill='%23b76e11' d='M655.51 616.38h126.52c-.08-1.91-.22-3.8-.42-5.68H655.93c-.2 1.87-.34 3.77-.42 5.68z'/%3E %3Cpath fill='%23ac620e' d='M655.94 610.69h125.68c-.2-1.88-.45-3.74-.76-5.58H656.7c-.31 1.84-.57 3.7-.77 5.58z'/%3E %3Cpath fill='%23a2550b' d='M776.82 599.51h-116.1c-2.33 0-3.7 3.7-4.02 5.58h124.15c-.32-1.88-1.81-5.58-4.02-5.58z'/%3E %3Cpath fill='%23b76e11' d='M655.91 630.01h125.72c.2-2 .35-4.02.42-6.07H655.5c.08 2.05.22 4.07.42 6.07z'/%3E %3Cpath fill='%23ac620e' d='M656.56 634.94h124.43c.26-1.62.47-3.27.65-4.93H655.92c.17 1.66.38 3.3.64 4.93z'/%3E %3Cpath fill='%23a2550b' d='M660.71 640.2H776.8c2.28 0 3.9-3.48 4.18-5.25H656.55c.28 1.78 1.72 5.25 4.15 5.25z'/%3E %3Cpath d='M671.4 640.34c-1.14-3.61-1.95-12.01-2.09-20.9-.13-8.9 2.56-20.28 2.56-20.28h-6.27s-2.7 11.39-2.56 20.28c.14 8.89.95 17.29 2.1 20.9h6.26zM766.43 640.4c1.15-3.61 1.95-12.01 2.09-20.9.13-8.9-2.56-20.28-2.56-20.28h6.27s2.7 11.39 2.56 20.28c-.14 8.89-.95 17.29-2.1 20.9h-6.26zM708.86 640.34c-.94-5.4-1.05-12.53-1.05-20.9s.89-17.9 1.52-20.28h-6.27c-1.1 3.55-1.51 13.04-1.51 20.28 0 7.24.2 15.68 1.04 20.9h6.27zM728.44 640.34c.94-5.4 1.05-12.53 1.05-20.9s-.89-17.9-1.52-20.28h6.27c1.1 3.55 1.51 13.04 1.51 20.28 0 7.24-.2 15.68-1.04 20.9h-6.27z'/%3E %3Cpath stroke-width='.55' d='M686.12 620.17c3.7 6.65 11.28 20.39 11.28 20.39l5.3-.16s-3.09-6.54-11.43-20.63c-8.35-14.1-13.94-20.82-13.94-20.82l-5.3.15s10.39 14.42 14.09 21.07zM751.71 620.17c-3.7 6.65-11.28 20.39-11.28 20.39l-5.3-.16s3.09-6.54 11.43-20.63c8.34-14.1 13.94-20.82 13.94-20.82l5.3.15s-10.39 14.42-14.09 21.07z'/%3E %3Cpath stroke-width='.55' d='M749.23 620.17a8113.7 8113.7 0 0 1 11.28 20.39l5.3-.16s-3.09-6.54-11.43-20.63c-8.35-14.1-13.95-20.82-13.95-20.82l-5.3.15s10.4 14.42 14.1 21.07z'/%3E %3Cpath fill='%23b1babf' d='M634.54 627.22s2.77-13.45-1.63-21c-4.4-7.56-10.11-9.77-11.42-9.22-1.3.55 14.02-22.67 30.33-.37 0 0-14.35 1.66-11.41 29.67'/%3E %3Cpath fill='%23d3dce0' d='M623.71 597.01c4.45-4.96 14.81-12.42 25.97.29a8.1 8.1 0 0 1 2.13-.67c-16.3-22.3-31.62.92-30.32.37.37-.16 1.08-.1 2.01.24l.21-.23' stroke='none'/%3E %3Cpath fill='%23b1babf' d='M631.92 622.28a27.8 27.8 0 0 0-8.4 4.62s-10.85-5.92-17.86-6.51c-.6-.05-1.19-.14-1.72-.1.55-.1 1.13-.15 1.7-.28 7.12-1.64 15.85-5.45 17.75-6.93 2.55 2.59 5.9 5.23 8.63 5'/%3E %3Cpath fill='none' stroke-width='.4' d='M605.71 620.21h26.48M623.45 612.98l.1 13.7'/%3E %3Cpath fill='%23b1babf' d='M640.52 627.22c-.2 4.17-1.38 7.37-2.8 7.37-1.44 0-2.63-3.3-2.81-7.56'/%3E %3Cpath fill='%23b1babf' d='M631.2 613.4h13.05v13.64H631.2z'/%3E %3Cpath fill='none' d='M633.81 616.12h7.83v8.18h-7.83z'/%3E %3Cpath fill='none' d='M636.16 618.58h3.13v3.27h-3.13zM649.58 597.36l.3-.1c1.21-.53 2.03-.63 2.03-.63-16.31-22.3-31.63.92-30.32.37.34-.15 1-.1 1.86.2.05 0 .16.08.21.1'/%3E %3Cpath fill='none' stroke-width='.27' d='M649.56 597.28c-11.26-12.77-21.7-5.04-26.06-.09'/%3E %3Cpath stroke-width='.55' d='M688.61 620.17c-3.7 6.65-11.28 20.39-11.28 20.39l-5.3-.16s3.09-6.54 11.43-20.63c8.35-14.1 13.94-20.82 13.94-20.82l5.3.15s-10.39 14.42-14.09 21.07z'/%3E %3C/g%3E %3Cg%3E %3Cpath fill='url(%23d)' d='M631.37 476.35c0 62.57 39.41 113.29 88.03 113.29s88.04-50.72 88.04-113.29c0-62.57-39.42-113.3-88.04-113.3s-88.03 50.72-88.03 113.3'/%3E %3Cpath fill='%23395054' stroke='%23000' stroke-width='.46' d='M641.6 329.09c3.35-2.15 6.54-2.11 10.55-3.38 2.79-.88 6.16-1.05 8.87-1.69 2.47-.58 9.95 4.32 12.45 5.07l.17 6.8s-12.4 1.3-16.82-.38c-4.42-1.67-15.22-6.84-15.22-6.84' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3E %3Cpath fill='%23006c3c' d='M683.24 486.82c1.6 1.33.26 1.9-.67 2.99-.53.62 3.06 3.39 6.9 4.6a5.2 5.2 0 0 1 2.93 2.31c.53.81 1.72 1.63 3.58 2.98 1.85 1.36.4 1.77 4.78 1.9 4.37.14 6.1 1.22 7.83 1.63 1.72.4 2.78.68 7.03 1.22 4.25.54 19.3-.04 18.9.1-.4.13-10.55 2.27-11.48 2.81-.93.55-5.7-.6-6.63-.06-.92.54-1.85 1.35-2.91 2.17-1.07.8-.27 1.08.8 1.35s2.25.54 4.1 1.5c1.86.94 1.86 1.08 5.98 1.62 4.11.54 2.52 0 6.37.81 3.85.82 2.92.55 7.3.68 4.38.14.93.54 6.63.14 5.71-.41 4.38-.27 6.64-.27 2.25 0 2.26-.41 4.78-.55s4.3 3.84 1.77 3.84 1.98-.8.26-.67c-1.73.14-6.28-.32-7.2.22-.94.55-1.87 1.63-4.39 3.53-2.52 1.9-.53 2.85.27 3.39s1.99.81 3.05 1.22c1.06.4 2.12.27 5.44 1.49 3.32 1.22 4.12 1.36 6.24 1.49 2.12.14 5.18.95 5.18.95s4.1 1.76 6.23 1.9c2.13.13 1.33.54 3.98 1.76 2.66 1.22 2.52.27 4.65.27 2.12 0 2.92.27 4.11 1.09 1.2.8 2.92 1.49 2.92 1.49s-.93 2.57-9.69 17.08c-8.75 14.51-22.3 23.19-32.24 28.88-9.96 5.7-22.96 6.37-41.28 4.47-18.31-1.9-36.1-20.74-43.8-30.5a68.07 68.07 0 0 1-10.74-19.53l1.59-.13c.93-.14 1.86-.27 3.32-.54 1.46-.28 1.33-.14 3.05-.55s2.26-.4 3.85-1.08c1.6-.68 1.06-.95 3.58-1.63s1.73-.54 2.39-.68c.66-.13 1.73-.27 3.18-.81 1.46-.54 3.19-1.35 1.6-2.17s0-.95 0-.95 1.72.14 4.11.27c2.39.14 1.46.4 3.05.54 1.6.14 1.46 0 2.66-.27 1.2-.27-.27-1.62-.53-2.98-.27-1.36-.93-.54-1.46-1.09-.53-.54-1.06-.27-2.79-1.35-1.73-1.09-1.2-.14-4.91-1.36-3.72-1.21-.39 1.1-5.03-.26s-2.07.95-5.92-.27-5.1-3.94-1.52-3.4 1.06-.13 1.45-.68 1.07-.13 3.19-.27c2.12-.13 1.86 0 3.85-.13 1.99-.14 2.79-.68 2.79-.68s1.72.68 2.91.68.8-.27.8-1.09 1.2 0 2.12.27c.93.27 3.19-.13 3.19-.13s1.06-.14 3.05-.14c2 0 .8-.4 2.66-1.08 1.85-.68 0-1.36-.67-1.5-.66-.13-.8-.4-1.72-1.21a7.9 7.9 0 0 0-2.9-1.71c-1.2-.41-8.19.52-9.91-.02s-1.66-2.75 1.8-2.88c3.44-.14 1.32 0 3.04 0s1.33.27 2 .27c.66 0 1.32 0 4.1-.41 2.8-.4 1.6-.54 3.46-1.36s3.85-.54 5.44-1.22c1.6-.67-.66-1.35-2.65-2.3-2-.95 0 .54-1.46-.95-1.46-1.5-8.88-5.85-11.14-7.88-2.08-1.87 1.8-1.17 3.75-2.07 0 0 .84-1.97-1.33-2.71s-1.93-.74-4.22-1.6-3.38-2.47-5.07-2.84c-1.69-.37-2.53-.86-2.53-.86'/%3E %3Cpath fill='%236dbe45' d='M683.24 486.82c-1.02.76-1.02 1.8-.67 2.99.24.79 1.77 4.1 5.62 5.32 1.6.5 3.67.78 4.2 1.59.53.81 1.73 1.63 3.59 2.98 1.85 1.36.4 1.77 4.78 1.9 4.37.14 6.1 1.22 7.83 1.63 1.72.4 2.78.68 7.03 1.22 4.25.54 18.52.17 18.13.3-.4.14-12.76 2.72-13.7 3.26-.92.54-2.7-1.26-3.64-.71-.92.54-1.85 1.35-2.91 2.17-1.07.8-.27 1.08.8 1.35s2.25.54 4.1 1.5c1.86.94 1.86 1.08 5.98 1.62 4.11.54 2.52 0 6.37.81 3.85.82 2.92.55 7.3.68 4.38.14.88 1.06 6.59.66s3.78.09 6.04.09 2.9.67 5.43.53c2.52-.13 8.46 1.65 5.94 1.65-1.57 0-4.02-.72-6.79-.5-1.73.13-3.41-.26-4.34.28-.93.54-1.86 1.63-4.38 3.53-2.52 1.9-.53 2.84.27 3.39.8.54 1.99.81 3.05 1.22 1.06.4 2.12.27 5.44 1.49 3.32 1.22 4.11 1.35 6.24 1.49 2.12.13 5.17.95 5.17.95s4.12 1.76 6.24 1.9c2.12.13 1.33.54 3.98 1.76 2.66 1.22 2.52.27 4.65.27 2.12 0 2.92.27 4.11 1.09.75.5 1.7.96 2.32 1.23 0 0 5.47-15.31 7.6-21.97 2.12-6.66 4.39-25.9 4.39-27.06 0-1.16-3.12-2.9-4.11-2.6-.99.28-5.24.28-6.52.28h-17.85c-1.13 0-1.98.87-4.1-.14-2.13-1.01-5.95-1.6-7.23-1.45-1.27.15-6.52.3-7.65.3-1.13 0-13.74-.59-15.86-.44s-6.1.14-8.65 0c-2.55-.15-5.8-.15-7.08-.3-1.27-.14-5.95-.43-7.08.44-1.14.87-4.25 1.16-5.67 1.45s-5.24 1.01-7.22 1.16c-1.99.14-7.8 1.3-9.63 1-1.85-.28-8.11-.3-8.11-.3'/%3E %3Cpath d='M683.24 486.68c-1.18 1.03-1.03 2.53-.43 3.86a9.08 9.08 0 0 0 5.38 4.72c1.31.45 2.94.5 4.05 1.41.36.29.63.76.98 1.08.62.56 1.32 1.04 2 1.53a10.5 10.5 0 0 1 1.92 1.7c.5.58 1.33.6 2.02.67 1.66.15 3.31.13 4.96.43 1.18.2 2.32.6 3.45.98 1.89.63 3.9.93 5.85 1.22 4.7.69 9.44.62 14.17.6l4.38-.02c.3 0 1.53-.2 1.78.02v-.27c-.24.15-.65.16-.92.22l-2.53.55c-2.15.47-4.3.95-6.45 1.45-1.34.32-2.7.6-3.99 1.12-.86.34-2.15-.82-3.03-.9-.61-.06-1.38.75-1.83 1.09-.66.5-1.5 1-1.98 1.7-.68 1.02 3.24 1.67 3.73 1.85 1.06.4 2.03 1 3.06 1.45.91.4 1.91.54 2.88.7 2.28.34 4.6.37 6.85.8 2.33.43 4.46.85 6.83.88 1.23.02 2.51-.03 3.72.25.4.1.74.36 1.15.46 1.06.27 2.33.06 3.4-.02 1.3-.08 2.6-.2 3.91-.14 1.29.06 2.72.2 3.98.4 2.56.43 5.11.32 7.65.93.78.2 1.66.38 2.36.81.13.08.08-.06-.03-.03-.14.05-.32.03-.46.04-.78.01-1.58-.14-2.34-.25a33.94 33.94 0 0 0-5.38-.23c-1.48.02-2.8-.25-4.04.7-1.02.8-1.96 1.69-2.96 2.48-.7.55-2 1.25-2.03 2.3-.04 1.75 2.5 2.49 3.75 2.9 1.3.43 2.6.67 3.9 1.02 2.13.56 4.13 1.54 6.29 1.99 1.82.38 3.7.37 5.52.75 1.04.21 1.97.47 2.95.86 1.67.66 3.44 1.33 5.24 1.5 1.71.15 2.87 1.27 4.43 1.95 1.7.75 3.3.03 5.1.1 2.13.08 3.65 1.45 5.53 2.3 1.16-3.24 2.3-6.48 3.44-9.73 1.6-4.58 3.41-9.19 4.63-13.9 1.25-4.82 1.94-9.81 2.64-14.74.5-3.5 1.03-7.01 1.28-10.53.1-1.33-1.33-2.1-2.34-2.6-.9-.44-1.54-.4-2.47-.29-1.28.16-2.6.15-3.88.16-3.4.05-6.8.01-10.21.01h-6.54c-1.21 0-2.54-.15-3.74.1a5.3 5.3 0 0 1-3.69-.37c-1.41-.64-3-.94-4.52-1.17-2.18-.33-4.42-.01-6.62.06-3.63.12-7.23-.05-10.86-.18-4.43-.17-8.81-.05-13.23-.07-3.3-.01-6.61-.17-9.9-.32-2.25-.1-4.47-.4-6.72-.1-1 .14-1.72.72-2.65 1.04-1.35.45-2.8.58-4.19.82-2.55.45-5.07 1-7.65 1.22-3.13.26-6.46 1.43-9.6.98-2.61-.38-5.33-.28-7.95-.3-.02 0-.02.27 0 .27 3.94.02 7.94.6 11.85.11 5.1-.64 10.13-1.47 15.19-2.31 1.2-.2 2.55-.4 3.59-1.1.88-.6 2.17-.56 3.17-.6 2.4-.07 4.8.25 7.18.31 3.37.1 6.73.3 10.1.24 1.84-.04 3.66-.13 5.51-.1 4.11.1 8.22.31 12.33.43 4.25.12 8.41-.7 12.6.28 1.44.33 2.76 1.13 4.2 1.36.93.14 1.8-.33 2.73-.33h16.62c1.64 0 3.27 0 4.91-.05.96-.03 1.89-.1 2.83-.27 1.02-.18 2.36.79 3.1 1.38 1.25 1 .72 2.49.56 3.89-.26 2.29-.56 4.57-.87 6.86a149.06 149.06 0 0 1-2.7 15.41c-1.17 4.7-3 9.28-4.6 13.83-1.16 3.35-2.34 6.7-3.53 10.03-.02.05-3.24-1.8-3.62-1.95a7.49 7.49 0 0 0-4.23-.2 4.7 4.7 0 0 1-3.22-.44c-1-.44-1.86-1.3-2.89-1.62-1.1-.34-2.32-.31-3.44-.63a34.74 34.74 0 0 1-3.48-1.24 19.53 19.53 0 0 0-5.88-1.14c-2.82-.19-5.29-1.35-7.96-2.14-2.22-.66-4.63-.83-6.62-2.14-.36-.23-.7-.46-1-.76-.99-.98.6-2.06 1.28-2.58 1.15-.87 2.21-1.86 3.34-2.77 1.07-.87 2.27-.75 3.59-.7 1.97.05 3.85-.06 5.83.22.36.05 3.21.79 2.94-.18-.1-.39-1.39-.62-1.68-.7-1.19-.36-2.41-.6-3.64-.73-1.3-.15-2.58 0-3.88-.24-1.2-.22-2.35-.28-3.55-.38-1.32-.1-2.53-.22-3.89-.15-1.87.1-3.82.54-5.58-.24-.85-.38-1.96-.31-2.86-.34-1.19-.03-2.37 0-3.55-.08-2-.15-3.91-.82-5.9-1.05-2.12-.24-4.24-.36-6.36-.73-1.83-.32-3.3-1.3-5.01-1.99-1.12-.45-2.35-.59-3.46-1.07-.55-.25 1.57-1.83 1.72-1.94.52-.41 1.14-1.01 1.82-1.1.83-.09 1.78.72 2.58.9.42.1.93-.2 1.33-.32 1.52-.46 3.09-.79 4.63-1.14 1.87-.43 3.75-.84 5.62-1.25.8-.17 2.05-.2 2.76-.62.03-.02.03-.24 0-.27-.12-.11-.67-.02-.82-.03l-2.44.01c-2.37.02-4.73.03-7.09.02-4.6-.03-9.13-.25-13.64-1.25-2.02-.45-3.95-1.25-6-1.61-1.62-.3-3.26-.25-4.9-.4-.69-.06-1.32-.17-1.8-.72-.64-.76-1.39-1.29-2.19-1.87-.56-.41-1.12-.83-1.65-1.28-.44-.38-.73-.88-1.17-1.24-1.08-.88-2.97-.95-4.25-1.39a8.81 8.81 0 0 1-3.68-2.57c-1.19-1.35-2.6-3.82-.88-5.33.05-.04-.03-.24 0-.27'/%3E %3Cpath fill='%236dbe45' d='M680.46 490.44c1.41 1.74.15.55-3.24 2.38-2.66 1.43 11.47 8.81 12.93 10.3 1.46 1.5-.53 0 1.46.95 2 .95 4.25 1.63 2.65 2.3-1.59.69-3.58.42-5.44 1.23-1.85.81-.66.95-3.45 1.35s-3.45.41-4.11.41c-.66 0-.5-.25-2.23-.25s-.28.35-3.73.48c-.34.01-4.87.53-4.83.53 2.18.24 7.33.46 9.64.55 1.28.06 2.46.67 4.2 1.27 1.2.4 2 .95 2.92 1.76.93.81 1.06 1.08 1.73 1.22s2.52.81.66 1.5c-1.86.67-.66 1.08-2.65 1.08-2 0-3.06.13-3.06.13s-2.25.4-3.18.14c-.93-.27-2.13-1.09-2.13-.27s.4 1.08-.8 1.08-2.91-.68-2.91-.68-.8.55-2.79.68c-1.99.14-1.72 0-3.85.14-2.12.13-3.25-.4-3.18.27.13 1.31-1.83.71-1.5 1.67.29.1-2.46.1-2.24.17 3.85 1.22 4.93-.49 9.58.87 4.64 1.36 1.46.68 5.17 1.9 3.72 1.22 3.19.27 4.91 1.35s2.26.82 2.8 1.36c.52.54 1.19-.27 1.45 1.08.27 1.36 1.73 2.71.53 2.99s-1.06.4-2.65.27c-1.6-.14-.67-.41-3.05-.55-2.4-.13-4.12-.26-4.12-.26s-1.6.13 0 .94c1.6.82-.13 1.63-1.6 2.17-1.45.55-2.51.68-3.18.82-.66.13.14 0-2.39.67-2.52.68-1.98.96-3.58 1.63-1.6.68-2.12.68-3.85 1.09-1.72.4-1.59.27-3.05.54-1.46.27-2.39.4-3.32.54-.93.14-2.64.43-2.64.43s-6.11-10.1-9.15-22.64c-3.05-12.55-4.42-32.93-4.42-33.93s4.5-1.04 6.01-.49c1.52.56 8.8 1.11 12.17 1.56 3.37.44 11.73 1.66 12.38 1.88.65.23 2.65-1.12 4.28 0 1.63 1.1 6.37 4.44 6.37 4.44'/%3E %3Cpath d='M680.46 490.57c.2.24.76.67.32.85-.4.16-.86.2-1.27.32-.7.18-2.33.52-2.6 1.3-.21.6.32 1.2.68 1.59 1.25 1.35 2.92 2.37 4.44 3.37 1.8 1.18 3.63 2.3 5.45 3.42.64.4 1.27.8 1.9 1.23.2.14.4.28.59.44l.18.16.42.45c.14.28.2.28.15-.01-.2.1.82.48.9.51.79.37 1.6.7 2.37 1.1 1.1.54.3.97-.49 1.2-.94.27-1.97.3-2.94.46a6.88 6.88 0 0 0-3.06 1.3c-.95.7-2.66.64-3.77.78-.78.1-1.56.18-2.35.18-.93 0-1.83-.28-2.78-.24-.4.01-.74.19-1.13.28-.83.2-1.71.14-2.56.22-1.47.15-2.98.24-4.43.5-.03 0-.03.27 0 .27 5.63.58 12.1-.4 16.75 3.58.48.4.89.9 1.47 1.15.45.2.91.24 1.36.48.86.46-.87.99-1.14 1.13-.37.19-.56.56-.96.7-1.12.37-2.65.07-3.85.18-.78.07-1.55.22-2.34.25-.61.02-1.12-.1-1.68-.33-.4-.16-1.06-.6-1.44-.25-.27.26.18.93-.1 1.2-.64.62-2.81-.27-3.5-.52-.21-.07-.23 0-.44.09-.63.3-1.35.4-2.03.49-1.16.15-2.33.09-3.5.13-.84.03-1.66.08-2.5.03-.41-.02-1.09-.22-1.46.06-.07.05-.06.23-.06.3-.02.46-.23.67-.63.84-.4.17-.91.16-.91.72 0 .1 0 .26.07.33v-.27c-.69.25-1.55 0-2.26.14-.03 0-.03.24 0 .26.15.25 1.17.32 1.45.37a9 9 0 0 0 1.8.11c1.3-.02 2.55-.2 3.85-.1 1.92.17 4 .78 5.72 1.69 1.8.94 3.79 1.1 5.71 1.53.98.21 1.81 1 2.75 1.35.36.13.72.21 1.04.43.43.3.75.25 1.21.44.4.17.7 1.66.9 2.07.35.7.64 1.25-.31 1.48a6.36 6.36 0 0 1-3.22.05c-1.06-.28-2.04-.39-3.15-.45-1-.06-2.16-.32-3.17-.21-.27.02-.68.09-.68.43 0 .87 2.11 1.02.65 2-1.73 1.15-3.99 1.29-5.95 1.86-1.2.34-2.45.57-3.5 1.27a10.7 10.7 0 0 1-3.56 1.42c-2.71.62-5.45 1.05-8.19 1.47-.32.04-2.24.56-2.39.3l-.71-1.24a88.76 88.76 0 0 1-3.04-6.09 87.4 87.4 0 0 1-6.38-20.05 215.26 215.26 0 0 1-2.56-18.83c-.24-2.38-.45-4.76-.63-7.14-.06-.77-.6-2.9.21-3.34 1.7-.9 4.27-.34 6 .1 2.41.61 5 .7 7.45.96 4.95.5 9.88 1.21 14.79 2 .62.1 1.25.2 1.86.35.4.1.8-.06 1.19-.17a4.95 4.95 0 0 1 2.42-.17c.98.21 2.03 1.25 2.84 1.8l3.16 2.23 1.09.76c-.03-.02.05-.23 0-.27l-4.75-3.33c-.97-.67-1.86-1.47-3.07-1.56-1.04-.09-2.01.63-3.03.4-4.32-.98-8.85-1.45-13.25-1.97-2.77-.32-5.55-.55-8.32-.9-2-.26-3.89-.89-5.92-.88-.79 0-2.93-.09-2.89 1.13.04 1.08.13 2.15.21 3.23 1.4 18.36 3.72 37.32 13.37 53.32 4.9-.83 10.15-1.06 14.56-3.55 1.56-.88 3.64-1.2 5.4-1.56 1.02-.21 4.8-.88 4.22-2.6-.07-.2-1.36-.8-1.1-.98.13-.1.4-.15.56-.14 1.36.1 2.73.2 4.09.27 2.1.12 3.84.96 5.95.18.27-.1.24-.5.22-.73-.04-.39-.3-.77-.47-1.1-.26-.5-.38-1.6-.75-1.95-.31-.3-.67-.2-1.05-.33-.32-.1-.58-.42-.93-.54-1.08-.37-1.99-1.09-3.05-1.46-.47-.16-1.02-.14-1.5-.21a19.3 19.3 0 0 1-3.61-1.05c-1.06-.39-2-.89-3.09-1.22a16.22 16.22 0 0 0-4.36-.82c-1.04-.02-2.08.14-3.12.16-.5.01-1.02-.04-1.52-.12-.36-.05-.71-.14-1.06-.23-.22-.06-.52.13-.1.11.6-.04 1.4.1 1.97-.11.02-.01.02-.25 0-.27-.22-.18.95-.57 1.01-.6.26-.1.42-.32.47-.59.04-.23 0-.5.27-.57.57-.16 1.4.07 2 .08 1.22.04 2.46-.06 3.68-.1 1.26-.03 2.65-.09 3.8-.69.48-.26 3.88 1.62 3.85.17 0-.35-.17-.9.27-.97.52-.07 1.3.46 1.78.62.95.32 2.2.03 3.16-.12.85-.15 1.74-.13 2.6-.14.56-.01 1.25.1 1.76-.2.5-.3.8-.66 1.38-.9 1.82-.73.1-1.55-.93-1.82-.56-.15-1.05-.78-1.46-1.15a9.93 9.93 0 0 0-1.84-1.3 16.1 16.1 0 0 0-4.94-1.7c-2.72-.42-5.62-.25-8.37-.44a49.5 49.5 0 0 1-1.61-.14v.27c1.2-.22 2.44-.28 3.65-.41 1.23-.14 2.6 0 3.77-.44 1.1-.43 2.25.04 3.36.09 1.64.06 3.35-.27 4.95-.54.55-.1 1.04-.23 1.48-.57a6.66 6.66 0 0 1 2.88-1.16c.74-.14 4.28-.13 4.25-1.32-.01-.38-.23-.51-.53-.71a15 15 0 0 0-3.45-1.58c-.37-.12-.13.35-.1.34.04-.02.02-.23 0-.26-.17-.54-.92-1-1.36-1.31-.87-.6-1.78-1.16-2.68-1.71-2.29-1.42-4.58-2.8-6.77-4.37-.82-.6-1.63-1.21-2.33-1.94-.27-.27-.5-.57-.65-.92-.23-.57 1.28-.98 1.54-1.09.41-.17 2.44-.4 2.55-.9.1-.45-.34-.85-.57-1.15.03.04-.05.21 0 .27'/%3E %3Cpath fill='%23557176' d='M635.57 484.14s.26-2.15 5.52-2.15 3.68.54 9.72 1.35c6.04.8 10.51.8 12.62 1.07s6.56.8 8.14 1.34c1.58.54 4.2 1.88 4.2 1.88s-1.04.8 3.42.8c4.47 0 3.15-.26 9.46-.26s2.1 1.6 10.25 0c8.14-1.61 14.45-2.42 16.55-2.96 2.1-.53-2.36-2.14 5.52-1.07s11.57.27 12.88.27c1.31 0 6.83.27 9.46.27 2.63 0 6.3 0 7.88.26 1.58.27 3.94-.26 7.36.27 3.42.54 4.2-1.07 6.83.54s7.36.54 9.2.27c1.84-.27 5.52 0 6.57 0s6.04.53 8.4.53c2.37 0 7.1-.53 7.1-.53l4.47.53s.79-11.54.79-12.88c0-1.35 2.85-3.36-2.18-3.85-18.5-1.79-11.34-2.94-22.26-3.67-2.63-.54-15.24-3.76-17.87-4.3-2.63-.53-16.82-4.83-21.02-4.83-4.2 0-14.72.54-17.35.54s-25.49-.54-28.64-.54c0 0-8.4-2.95-10.51-3.76s-2.37-.53-9.2-.27-8.4 1.08-14.71.27-11.57 0-14.46.54c-2.89.54-7.1 2.15-7.1 2.15l-1.04 28.2z'/%3E %3Cpath d='M635.6 484.36c.09-.64.82-1.1 1.32-1.37 1.8-.95 4.11-.77 6.05-.7 1.29.04 2.5.29 3.74.58 2.32.55 4.7.83 7.08 1.07 3.91.41 7.85.49 11.76 1 1.94.25 3.94.47 5.84 1 1.52.44 2.99 1.23 4.4 1.95v-.54c-.24.2-.2.76.03.94.68.54 2.12.38 2.9.4 1.15.03 2.3 0 3.46-.06 3.7-.2 7.39-.48 11.01.43.58.14 1.2.08 1.79.02 1.66-.16 3.3-.53 4.94-.85 3.51-.68 7.04-1.27 10.57-1.85 1.12-.19 2.25-.37 3.37-.57.64-.12 1.44-.17 2.02-.5.2-.12.25-.33.25-.55.01-.25.07-.89-.06-.44.11-.39 1.07-.28 1.33-.28 1.7.02 3.4.35 5.08.55 2.86.34 5.76.46 8.64.29 4.08-.25 8.12.04 12.2.06 2.9 0 5.76.18 8.65.34 1.4.07 2.82-.08 4.23-.04 1.78.06 3.47.48 5.27.23 1.16-.17 2.13-.3 3.25.18.65.27 1.2.66 1.87.88.78.26 1.62.32 2.43.35 2.61.09 5.15-.7 7.75-.72 4.76-.04 9.5.84 14.26.61 1.3-.06 2.59-.18 3.88-.3.55-.06 1.23-.26 1.78-.19l4.45.54c.02 0 .02-.13.02-.14.24-3.53.48-7.06.68-10.6.09-1.42.1-2.44.7-3.74.42-.95.3-1.9-.68-2.35-1.46-.69-3.42-.56-4.99-.74a132 132 0 0 1-4.8-.6 44.42 44.42 0 0 1-5.17-1c-2.07-.56-4-1.23-6.15-1.5-1.77-.2-3.47-.3-5.2-.72-2.29-.54-4.57-1.1-6.84-1.67-3.6-.88-7.24-1.67-10.83-2.6-4.7-1.24-9.36-2.6-14.1-3.63-1.85-.4-3.72-.8-5.62-.78-2.54.01-5.08.12-7.62.22-3.7.14-7.39.35-11.08.3l-12.48-.26c-4.2-.08-8.38-.18-12.57-.24-.98-.02-1.74 0-2.66-.32l-6.27-2.23c-2.26-.8-4.35-1.82-6.78-1.76-4.77.11-9.51.62-14.27.85-2.61.12-5.17-.23-7.76-.48a44.24 44.24 0 0 0-20.04 2.84c-.03.02-.02.18-.02.2l-1.05 28.19c0 .17.03.52.05.14l.73-19.58.31-8.4.01-.2c-.01.3.16.12.4.03 1.25-.46 2.52-.88 3.8-1.26 2.67-.81 5.45-1.22 8.23-1.45 3.8-.33 7.48.09 11.26.42 2.76.24 5.5 0 8.26-.23 3.2-.27 6.43-.39 9.65-.52a9.3 9.3 0 0 1 3.84.52c3.48 1.31 7 2.52 10.5 3.75.32.11.86.01 1.2.02l2.28.03 6.25.12c7.64.16 15.3.54 22.94.26 2.78-.1 5.55-.22 8.32-.31 2.06-.07 4.18-.26 6.24-.03 4.8.52 9.55 2.02 14.2 3.28a506.04 506.04 0 0 0 23.1 5.69c1.68.36 3.48.3 5.18.58.96.16 1.89.41 2.81.72 3.28 1.07 6.67 1.55 10.08 1.96 1.8.22 3.63.34 5.42.6 1.02.15 2.4.5 1.83 1.77-.52 1.14-.55 1.95-.62 3.2-.2 3.73-.46 7.45-.71 11.17.01-.15-3.7-.5-4.28-.58-.46-.05-.95.07-1.4.11-1.36.14-2.72.26-4.09.35-4.84.3-9.72-.59-14.58-.6-2.6 0-5.13.74-7.74.72a7.85 7.85 0 0 1-3.98-1.07c-1.16-.67-2.32-.54-3.58-.34-1.64.25-3.2-.08-4.83-.2-1.55-.11-3.11.05-4.67.01-1.17-.03-2.35-.24-3.54-.29-1.7-.06-3.4-.05-5.1-.05-4.1 0-8.13-.33-12.2-.06-2.89.2-5.78.03-8.65-.29-1.62-.18-3.22-.45-4.84-.54-.4-.02-1.26-.14-1.56.24-.1.13-.07.38-.06.53 0 .08 0 .17.02.26.05.35.04 0 .02.05-.15.37-.89.42-1.2.49-.93.2-1.87.35-2.8.5-2.93.5-5.86.96-8.77 1.49-2.95.52-5.92 1.35-8.92 1.53-.98.06-1.8-.33-2.75-.51-2.3-.45-4.8-.23-7.14-.13-1.54.06-3.06.18-4.6.2-1.2 0-2.43.04-3.6-.22-.2-.05-.46-.12-.57-.31.23.4-.13.43.08.26.05-.04.06-.5 0-.54a29.82 29.82 0 0 0-4.4-1.94c-1.97-.63-4.14-.79-6.18-1.05-4.11-.54-8.26-.6-12.37-1.05-3.66-.4-7.23-1.52-10.9-1.59-1.49-.02-6.02-.18-6.37 2.18-.02.1.02.5.02.46'/%3E %3Cg fill='%2399afca'%3E %3Cpath d='M784.27 477.04c-.5 1.01-1 2.01-1.58 2.97-.07.13.05.46.01.52.58-.96 1.09-1.97 1.58-2.97.06-.14-.05-.45-.01-.52M649.45 475.31c-.61.88-1.21 1.76-1.7 2.72-.06.13.05.45.02.52a21.8 21.8 0 0 1 1.7-2.73c.08-.1-.05-.46-.02-.51M652.96 473.86c-.02.13-.1.24-.12.37-.02.12-.02.24 0 .36 0 .02.01.2.03.1.02-.13.1-.24.12-.37.02-.12.01-.25 0-.37 0-.01-.01-.2-.03-.1M657.2 472.09c-.26 1.01-.6 2-.97 2.97-.05.14.05.43.02.51.36-.98.71-1.96.97-2.97.03-.15-.04-.42-.02-.51M658.64 471.23c-.01.6-.12 1.18-.23 1.75-.03.12-.02.25-.01.37 0 .02.01.2.03.1.15-.74.25-1.47.26-2.22 0-.3-.05-.3-.05 0M661.32 469.26a96.66 96.66 0 0 0-3.64 6.68c-.06.13.05.45.02.51a97.16 97.16 0 0 1 3.63-6.68c.08-.12-.04-.46-.01-.51M662.89 468.33c-.17 1.64-.83 3.13-1.44 4.63-.06.14.04.44.01.52.64-1.55 1.3-3.09 1.47-4.77 0-.07-.02-.59-.04-.38M664.33 468.32a16.41 16.41 0 0 1-.47 3.18c-.02.1.02.5.03.46.25-1.16.47-2.31.5-3.5 0-.17-.05-.52-.06-.14M666.16 468.08c.07.88-.3 1.73-.6 2.53-.05.14.04.43.02.51.42-1.14.71-2.19.61-3.41-.02-.21-.04.3-.03.37M653.58 480.8c.6-.34 1.1-.8 1.7-1.12.1-.06-.04-.51 0-.54-.6.33-1.1.79-1.7 1.12-.1.05.04.5 0 .53M657.08 478.9c-.21.33-.4.67-.6 1-.05.07-.03.24-.03.32 0 .02.02.22.04.19l.6-1c.05-.06.02-.24.02-.32 0-.02-.02-.21-.03-.18M676.34 464.17c-.13.37-.34.7-.6.98-.05.05-.03.21-.03.27l.03.27c.27-.29.48-.63.61-1 .03-.1.02-.23.02-.33a.78.78 0 0 0-.03-.19M677.32 468.28a7.9 7.9 0 0 0 1.96-5.47c-.02-.33-.05.18-.04.27.1 1.66-.9 3.44-1.92 4.67-.1.12.07.45 0 .53M681.29 462.5a16.57 16.57 0 0 1-.47 3.32c-.03.1.01.5.02.46.26-1.2.48-2.4.5-3.63 0-.17-.05-.51-.05-.14M678.03 462.94c-.41 1.43-1.19 2.7-1.94 3.96-.07.13.05.46.02.52.75-1.27 1.52-2.53 1.94-3.96.04-.15-.04-.43-.02-.52M663.01 476.55c-.26.67-.53 1.34-.84 1.98-.07.14.04.45.01.52.31-.65.59-1.32.85-1.98.05-.15-.04-.44-.02-.52M664.6 476.55a14.1 14.1 0 0 1-1.57 2.1c-.1.1.06.46 0 .53.61-.64 1.1-1.37 1.58-2.11.08-.12-.05-.47-.01-.52M667.86 477.17l-.72 1.49c-.04.08-.02.24-.02.33 0 .02.02.2.03.18l.73-1.48c.04-.09.02-.24.02-.33 0-.02-.02-.21-.04-.19M669.32 475.69c-.63 1.4-1.3 2.77-2.3 3.95-.1.11.07.45 0 .53 1-1.18 1.68-2.57 2.31-3.97.06-.14-.04-.44-.01-.51M699.48 465.4a2.4 2.4 0 0 0-.73.88c-.05.08-.02.24-.02.32 0 .02.02.22.03.2.17-.35.41-.64.72-.86.04-.04.02-.23.02-.27a4 4 0 0 0-.02-.27M699.13 470.4c1.87-1.19 2.78-3.68 2.8-5.84.01-.3-.04-.3-.05 0-.02 1.94-1.11 4.26-2.75 5.3-.1.06.04.5 0 .53M684.7 473.33a7.63 7.63 0 0 1-2.3 2.1c-.1.06.05.5 0 .53a7.68 7.68 0 0 0 2.32-2.11c.08-.12-.05-.47-.02-.52M680.83 480.17c3.06-.86 5.55-3.49 7.15-6.2.07-.12-.05-.45-.01-.5-1.6 2.69-4.1 5.3-7.14 6.17-.08.02 0 .53 0 .53M685.68 483.64a9.57 9.57 0 0 0 3.15-3.1c.08-.12-.04-.47-.01-.52a9.53 9.53 0 0 1-3.14 3.09c-.1.05.04.5 0 .53M692.45 479.14a37.17 37.17 0 0 1-6.17 6.56c-.1.09.05.48 0 .53a37.21 37.21 0 0 0 6.17-6.56c.1-.12-.06-.44 0-.53M694.29 478.3c.37-.78.76-1.57 1.32-2.22.1-.12-.06-.46 0-.54-.57.67-.96 1.46-1.34 2.24-.06.14.05.45.02.52M699.37 483.12c1.05-1.93 2.02-4.03 3.62-5.56.1-.1-.06-.47 0-.53-1.6 1.54-2.58 3.64-3.64 5.58-.07.13.05.45.02.51M703.72 479.02c-1.07 1.21-2.26 2.32-3.27 3.59-.1.12.07.45 0 .53 1.01-1.27 2.2-2.38 3.27-3.58.1-.12-.06-.47 0-.54M716.08 476.82c.54-1.49.78-3.07.74-4.66 0-.37-.05-.03-.05.14.04 1.36-.25 2.74-.7 4-.06.15.04.44.01.52M715.34 472.24c-.35 1.58-.48 3.22-1.21 4.68-.07.13.05.45.01.51.74-1.47.88-3.14 1.22-4.73.02-.1-.01-.5-.02-.46M718.25 472.12c-.23 1.53-.18 3.1-.72 4.56-.06.14.04.43.01.51.56-1.49.5-3.05.73-4.6.02-.11-.02-.51-.02-.47M719.8 473.52c-.03 1.52-.47 3-1.07 4.4-.06.13.05.43.02.5.65-1.5 1.07-3.1 1.1-4.76.01-.17-.04-.52-.04-.14M721.39 474.47c.16 3.05-1.22 6.1-3.13 8.38-.1.12.07.46 0 .53a13.19 13.19 0 0 0 3.17-9.18c-.01-.33-.05.18-.04.27M722.97 475.2c-.5 1.37-1.08 2.7-1.58 4.08-.05.14.05.43.02.51.5-1.37 1.08-2.7 1.57-4.08.06-.15-.04-.44-.01-.52M724.18 474.44c-.34.92-.85 1.75-1.33 2.6-.07.13.05.46.02.52.48-.86.98-1.69 1.33-2.6.05-.15-.04-.44-.02-.52M725.15 476.18c-.95 1.83-1.72 3.78-3.27 5.19-.1.09.06.47 0 .53 1.56-1.42 2.33-3.37 3.28-5.2.07-.14-.05-.46-.01-.52M726.24 475.35a6.42 6.42 0 0 1-.6 1.95c-.07.12.05.45.01.51.35-.62.48-1.31.61-2 .03-.12.02-.25.01-.37 0-.02-.01-.2-.03-.1M727.95 474.95c-1.05 2.08-2.46 3.9-3.76 5.81-.08.12.05.47.02.52 1.3-1.92 2.7-3.74 3.75-5.82.07-.13-.05-.45-.01-.51M734.95 469.57c.08.76-.31 1.6-.6 2.28-.05.14.05.44.02.51a6.4 6.4 0 0 0 .62-3.17c-.02-.2-.05.31-.04.38M734.5 477.31a19.6 19.6 0 0 0 3.39-7.7c.02-.1-.02-.5-.03-.46a19.48 19.48 0 0 1-3.38 7.65c-.08.11.04.47.01.51M739.91 469.31a4.61 4.61 0 0 1-.7 2.42c-.08.12.04.46.01.51.53-.85.73-1.78.74-2.78 0-.17-.04-.52-.05-.15M729.53 476.91c-1.2 1.36-2.27 2.8-3.4 4.21-.09.12.07.45 0 .53 1.13-1.4 2.2-2.85 3.4-4.2.1-.12-.07-.46 0-.54M731.21 477.8a156.62 156.62 0 0 1-3.87 5.18c-.1.13.07.45 0 .53 1.32-1.71 2.64-3.43 3.88-5.2.09-.12-.04-.47 0-.52M732.06 480.12l-1.7 1.36c-.1.09.06.5 0 .54l1.7-1.36c.1-.09-.06-.5 0-.54M748.17 472.09c-.47.7-1.1 1.25-1.7 1.85-.1.1.07.46 0 .53.6-.6 1.23-1.16 1.71-1.87.08-.11-.05-.46-.01-.51M748.79 474.97c.9-.64 1.21-1.84 1.23-2.92 0-.17-.04-.51-.05-.14-.02.94-.41 1.98-1.18 2.53-.1.07.05.5 0 .53M741.72 478.84c0 .44-.1.91-.34 1.3-.05.07-.02.24-.02.32 0 .02.02.21.03.19.3-.5.37-1.1.38-1.67 0-.1.02-.23-.02-.33l-.03.19M743.82 483.12c.69-1.64 1.5-3.22 1.7-5.02.02-.07 0-.58-.03-.37-.2 1.75-1.02 3.29-1.68 4.88-.06.14.04.44.01.51M743.57 477.8c-.35.91-.85 1.74-1.33 2.6-.07.12.04.45.01.5.48-.85.98-1.68 1.33-2.6.06-.14-.04-.43-.01-.5M746.57 477.5c.05 1.33-1.1 2.52-1.67 3.63-.07.13.04.45.01.52.74-1.44 1.77-2.58 1.71-4.29-.01-.38-.05-.03-.05.14M747.46 482c.43-.9 1.05-1.72 1.21-2.74.02-.12.02-.24.01-.37 0-.01-.02-.2-.03-.1-.16 1-.79 1.82-1.2 2.7-.07.14.04.45 0 .52M750.95 472.35a20.65 20.65 0 0 0-1.7 3.59c-.05.14.05.43.02.5.49-1.23.98-2.46 1.7-3.58.07-.12-.05-.46-.02-.51M753.74 473.48a9.45 9.45 0 0 1-1.33 3.2c-.07.11.05.46.02.5a9.59 9.59 0 0 0 1.34-3.24c.02-.1-.02-.5-.03-.46M755.92 474.44a15.3 15.3 0 0 1-1.46 3.47c-.07.12.05.46.02.51a15.4 15.4 0 0 0 1.45-3.46c.04-.15-.04-.43-.01-.52M757.75 480.53c.6-.9.5-1.94.5-2.98 0-.3-.05-.3-.05 0 0 .88.03 1.72-.46 2.47-.08.12.04.46.01.51M760.15 478.3c-.1 2.12-1.73 3.82-3.01 5.34-.09.1.06.41 0 .48 1.36-1.62 2.95-3.34 3.05-5.58 0-.08-.03-.54-.04-.24M753.14 480.38c-.49.5-.98.99-1.57 1.36-.1.07.04.5 0 .54.59-.38 1.08-.87 1.57-1.37.05-.04.03-.2.03-.26l-.03-.27M756.4 480a21.93 21.93 0 0 0-2.78 2.85c-.1.12.07.46 0 .54.87-1.02 1.75-2.01 2.79-2.85.1-.09-.06-.49 0-.53M766.92 474.2c0 .3-.02.58-.1.87-.03.1-.02.22-.02.32l.03.19c.14-.45.14-.9.14-1.37 0-.02 0-.27-.02-.27-.03 0-.03.25-.03.27M768.38 472.86a5.05 5.05 0 0 1-1.08 3.2c-.08.11.05.47.02.51a5.98 5.98 0 0 0 1.1-3.98c-.02-.32-.05.18-.04.27M770.82 473.95a68.63 68.63 0 0 0-2.06 4.2c-.06.15.04.45.01.52a70.68 70.68 0 0 1 2.06-4.2c.07-.13-.04-.46-.01-.52M772.62 475.26a9.95 9.95 0 0 1-1.2 3.65c-.07.12.05.45.01.51.64-1.2 1.08-2.43 1.23-3.78 0-.07-.02-.59-.04-.38M775.18 476.18l-2.55 4.82c-.07.13.05.45.02.52l2.54-4.83c.07-.13-.05-.45-.01-.51M776.63 478.65a24.76 24.76 0 0 1-2.41 4.2c-.1.12.06.44 0 .53a24.8 24.8 0 0 0 2.42-4.22c.07-.13-.04-.44 0-.51M778.82 480.63c-1.22 1.4-2.1 3.1-3.51 4.33-.1.09.06.48 0 .53 1.4-1.23 2.3-2.93 3.51-4.33.1-.11-.06-.46 0-.53M767.31 484c.47-.16.87-.37 1.13-.8.27-.47.43-.91.8-1.3.11-.11-.06-.47 0-.53-.33.35-.53.74-.74 1.18-.25.5-.67.75-1.19.92-.08.03.01.53 0 .53M770.8 481.56c-.04 1-.78 1.78-1.32 2.54-.08.11.05.47.02.52.65-.93 1.3-1.73 1.35-2.91 0-.17-.04-.52-.05-.15M772.38 482.31c-.06 1.4-1.29 2.41-2.16 3.34-.09.1.06.4 0 .46 1.01-1.08 2.14-2.08 2.2-3.67 0-.15-.03-.45-.04-.13'/%3E %3Cpath d='M785.83 475.13c-.22 1.98-1.91 3.38-3.02 4.88-.09.12.07.44 0 .53 1.15-1.57 2.82-2.97 3.05-5.03 0-.07-.01-.59-.03-.38M786.46 480.04a10.1 10.1 0 0 0 2.06-3.35c.06-.14-.04-.44-.01-.51a10.03 10.03 0 0 1-2.05 3.33c-.1.1.06.47 0 .53M790.32 476.18a22.53 22.53 0 0 1-2.54 4.2c-.08.12.04.47 0 .52.96-1.34 1.9-2.68 2.55-4.2.06-.15-.04-.45-.01-.52M792.99 476.3c-1.09 1.36-2.13 2.75-3.4 3.95-.1.1.07.48 0 .54 1.27-1.2 2.31-2.6 3.4-3.96.1-.12-.07-.45 0-.54M794.69 476.8a11.34 11.34 0 0 1-1.34 2.97c-.07.12.05.46.02.51.56-.93 1.05-1.9 1.33-2.97.04-.15-.04-.42-.01-.51M792.14 482.11c-1.18 1.53-2.9 2.42-4.6 3.22-.1.05.03.52 0 .53 1.7-.8 3.42-1.69 4.6-3.21.1-.13-.06-.45 0-.54M784.63 483.75c.77-.57 1.67-.9 2.55-1.23.08-.04-.02-.53 0-.54-.88.34-1.78.67-2.55 1.24-.1.08.06.5 0 .53M794.69 482.11c-.69 1.19-1.88 1.94-3.03 2.6-.1.05.04.5 0 .53 1.16-.66 2.35-1.42 3.04-2.61.07-.13-.05-.46-.01-.52M758.46 466.66c-.66 1.13-1.82 1.71-3.02 2.09-.08.03.01.53 0 .53 1.2-.38 2.37-.97 3.04-2.11.07-.12-.05-.46-.02-.51M709.65 471.34c.27 1.78-.79 3.26-1.93 4.45-.1.11.07.47 0 .54 1.47-1.54 2.28-3.3 1.95-5.45 0-.05-.04.35-.02.46M656.85 462.44a41.5 41.5 0 0 1-4.85 2.85c-.1.05.04.51 0 .53 1.67-.86 3.3-1.77 4.85-2.85.1-.07-.05-.5 0-.53M649.58 461.69a13.64 13.64 0 0 1-3.76 3.1c-.1.05.04.5 0 .53a13.56 13.56 0 0 0 3.76-3.1c.1-.11-.06-.46 0-.53'/%3E %3C/g%3E %3Cpath fill='url(%23e)' d='M722.72 507.13h.01c.04 0 .06-.02.05-.02l-.06.02m.9-.18l4.14-.9c-1.48.3-2.96.6-4.13.9m4.86-1.07l-.73.17c3.02-.6 6.04-1.14 6.46-1.42-.06 0-2.9.63-5.73 1.25m5.73-1.25zm-60.41-33.45c-1.12.74-5.52 2.69-7.82 3.83-2.3 1.14-2.36 3.42-1.58 3.83.8.4 6.05 3.62 6.44 4.22.4.6-2.23 1.74-2.54 1.92-.3.18-.15.9-.15.9 2.78 3.81 13.55 4.03 11.82 5.26-1.72 1.21-4.87 1.01-2.71 3.15a39.23 39.23 0 0 0 7.35 5.5c3.23 1.65 3.06 3.03 3.77 3.77 1.46 1.49.62 1 2.6 1.94 2 .95 4.25 1.63 2.66 2.3-1.6.69-3.58.42-5.44 1.23-1.86.81-.66.95-3.45 1.35-2.79.41-3.45.41-4.11.41-.67 0-.27-.27-2-.27-1.72 0 .4-.13-3.05 0-3.05.12-8.9-1.35-10.21-1.69 1.43.38 8.19 2.16 10.08 2.64 2.12.54 1.99.27 3.72.82 1.72.54 3.31.67 4.5 1.08 1.2.4 2 .95 2.93 1.76.93.81 1.06 1.09 1.72 1.22.67.14 2.53.82.67 1.5-1.86.67-.67 1.08-2.66 1.08-1.99 0-3.05.13-3.05.13s-2.26.41-3.18.14c-.93-.27-2.13-1.08-2.13-.27s.4 1.08-.8 1.08c-1.19 0-2.91-.67-2.91-.67s-.8.54-2.8.67c-.99.07-1.42.07-1.86.07-.45 0-.92 0-1.98.07-.77.05-1.35.03-1.8 0-.77-.04-1.13-.07-1.38.27-.4.54 2.12 1.22-1.47.68-3.58-.54-2.25-.54 1.6.68 3.85 1.22 1.06 0 5.7 1.35 4.65 1.36 1.47.68 5.18 1.9s3.19.27 4.91 1.36c1.73 1.08 2.26.81 2.79 1.35.53.54 1.2-.27 1.46 1.09.27 1.35 1.72 2.7.53 2.98-1.2.27-1.06.4-2.65.27-1.6-.13-.67-.4-3.06-.54-2.38-.14-4.11-.27-4.11-.27s-1.6.13 0 .95c1.6.81-.13 1.63-1.6 2.17-1.45.54-2.52.68-3.18.81-.66.14.13 0-2.39.68s-1.99.95-3.58 1.63c-1.6.67-2.12.67-3.85 1.08-1.72.4-1.6.27-3.05.54-1.46.27-2.39.41-3.32.55-.93.13-1.6.13-1.6.13s3.06 9.76 10.76 19.52c7.7 9.77 25.48 28.61 43.8 30.5 18.3 1.9 31.31 1.23 41.27-4.46 9.95-5.7 23.49-14.37 32.25-28.88 8.76-14.5 9.4-16.57 9.4-16.57s-1.82-.82-3.22-.51c-1.4.31-1.4-2.58-3.53-2.58s-2 .95-4.65-.27c-2.65-1.22-1.85-1.63-3.98-1.77-2.12-.13-6.23-1.9-6.23-1.9s-3.05-.8-5.18-.94c-2.12-.14-2.92-.27-6.24-1.5-3.32-1.21-4.38-1.08-5.44-1.48-1.06-.41-2.26-.68-3.05-1.22-.8-.55-2.79-1.5-.26-3.4 2.51-1.9 3.45-2.98 4.37-3.52.93-.54 2.92-1.76 4.65-1.9 1.72-.13 1.86-.54 4.38-.54 2.52 0-1.33-1.09-3.85-.95-2.52.13-2.52.54-4.78.54-2.26 0-.93-.13-6.63.27-5.71.4-2.26 0-6.64-.13-4.38-.14-3.45.13-7.3-.68s-2.25-.27-6.37-.81-4.11-.68-5.97-1.63c-1.86-.95-3.05-1.22-4.12-1.5-1.06-.26-1.85-.53-.8-1.35 1.07-.81 5.15-3.92 6.07-4.47a9.9 9.9 0 0 1 2.15-.73 33.7 33.7 0 0 1-1.34.28c-.7.12-2.2.23-4.75-.1-4.25-.54-5.3-.8-7.03-1.21-1.73-.41-3.45-1.5-7.83-1.63-4.38-.14-2.92-.55-4.78-1.9-1.86-1.36-3.05-2.17-3.58-2.98a5.18 5.18 0 0 0-2.92-2.3c-3.85-1.23-7.44-4-6.9-4.62.93-1.08 2.26-1.65.66-2.98-1.63-1.35-10.82-2.95-13.4-3.76 0 0 .06-.44.2-.49.58-.2 1.91-.56 2.9-1.25 1.25-.87 0-1.41-1.51-2.22-2.06-1.1-5.59-2.68-7.16-3.82-1.64-1.19 1.7-3.22 5.06-4.7 3.35-1.48 11.75-8.73 13-9.87l-.06-.4s-9.26 7.45-10.38 8.18'/%3E %3Cpath d='M684.26 463.26a120.91 120.91 0 0 1-6.62 5.52 65.81 65.81 0 0 1-4.24 3.1c-1.6 1.08-3.4 1.76-5.07 2.71-.91.52-2.55 1.39-2.58 2.64-.03 1.07 1.7 1.66 2.43 2.06 1.98 1.08 4.04 2.02 6.03 3.08 2.97 1.6-2.23 2.09-2.46 3.26 0 .03-.03.24 0 .25 4.22 1.28 8.95 1.47 12.93 3.45.52.26 1.4.9 1.1 1.62-.26.6-.98.86-1.29 1.4a.72.72 0 0 0-.02.54c.35.84 1.29 1.42 1.98 1.91a19.05 19.05 0 0 0 4.95 2.43c1.43.47 2.12 1.35 3.04 2.48.94 1.14 2.28 1.95 3.46 2.8.52.38.87.87 1.32 1.3.6.6 1.82.52 2.58.57 1.66.1 3.28.16 4.9.52 1.1.24 2.14.64 3.2.97 2.02.64 4.17.92 6.24 1.2 1.63.23 3.26.43 4.91.4.52-.02 1.24 0 1.74-.23.02-.01.01-.26 0-.27l-.08.02c-.03.02-.02.27 0 .27.5.08 1.26-.26 1.74-.36l3.9-.85 3.95-.88c.57-.12 1.33-.44 1.92-.4v-.28c-1.31.73-3.27.8-4.71 1.07-2.24.44-4.5.84-6.7 1.47-1.74.5-3.12 1.75-4.56 2.83l-2.58 1.96c-.4.3-.79.55-.76 1.1.04.66 1.67.8 2.14.93 1.42.37 2.74 1 4.05 1.67 2.08 1.06 4.57 1.19 6.84 1.42 2.2.23 4.3.56 6.5.98 2.24.44 4.54.24 6.81.38 1.26.08 2.37.27 3.65.2 2.26-.14 4.53-.43 6.8-.42 1.85.01 3.59-.24 5.43-.45a13.5 13.5 0 0 1 4.3.26c.4.08.83.18 1.19.39-.11-.07.1-.12-.23-.06-.46.08-.95.03-1.41.04-2.66.1-5.37.83-7.68 2.15-.84.49-1.54 1.1-2.28 1.73-1.17 1.01-2.8 1.88-3.63 3.2-1.84 2.9 6.63 4.22 8.17 4.68 2.68.8 5.09 1.86 7.9 2.05 1.91.13 3.97.46 5.76 1.2 1.08.43 2.19.82 3.3 1.16 1.2.36 2.46.33 3.63.7.94.28 1.82 1.13 2.7 1.55 1.25.6 2.17.67 3.46.39 1.14-.25 2.12-.13 2.9.8.5.63.85 1.79 1.82 1.66.74-.09 1.4-.04 2.13.14.43.1.94.53 1.08.11l-.07.16c-.82 1.97-1.96 3.82-3 5.67-3.42 6.03-6.83 12.21-11.15 17.63a77.85 77.85 0 0 1-14.85 13.95 99.14 99.14 0 0 1-14.51 9.06c-5.08 2.52-10.72 3.64-16.3 4.12-7.17.62-14.4.16-21.55-.52-6.6-.64-12.62-2.84-18.36-6.2-10.28-5.99-19.16-14.73-26.6-24.06a69.56 69.56 0 0 1-11.04-19.83c0-.03-.02-.06-.03-.08.13.4.34.24.76.21 2.8-.2 5.65-.85 8.39-1.44 1.24-.27 2.48-.63 3.58-1.3a13.33 13.33 0 0 1 3.5-1.38c1.99-.55 4.04-.88 5.92-1.76.49-.23 1.07-.56 1.06-1.18-.02-.62-1.8-1.16-.91-1.4.64-.17 1.47.05 2.12.1 1.34.09 2.9-.06 4.19.45.67.27 1.45.27 2.17.28.39 0 1.85-.17 2-.55.34-.9-.54-1.9-.84-2.68-.33-.88-.24-1.12-1.18-1.23-.3-.04-.53-.36-.79-.49-.3-.16-.67-.23-1-.36-.84-.31-1.53-.92-2.37-1.22-.48-.16-1.02-.14-1.51-.21a12.97 12.97 0 0 1-4.53-1.47c-1.26-.76-2.9-1.04-4.3-1.42-.92-.25-1.84-.29-2.75-.5-1.81-.43-3.57-1.08-5.39-1.52v.26c.58.06 4.06.92 4.06.35 0-.24-.18-.33-.34-.48-.66-.6 1.94-.44 2.14-.44 1.21.01 2.44-.07 3.66-.1 1.25-.04 2.65-.1 3.79-.7.49-.26 3.88 1.62 3.86.17 0-.35-.17-.9.27-.97.51-.07 1.3.46 1.78.62.94.32 2.2.03 3.15-.13.85-.14 1.75-.12 2.6-.13.57-.01 1.26.09 1.76-.21.5-.29.81-.65 1.38-.88 1.83-.74.1-1.56-.92-1.83-.56-.15-1.06-.78-1.47-1.15a9.88 9.88 0 0 0-1.84-1.3c-1.55-.86-3.44-.97-5.12-1.41-4.83-1.27-9.7-2.39-14.54-3.66 0 0-.04.25 0 .26 1.73.47 3.48.86 5.24 1.2 2.48.47 4.8.46 7.31.5 1.12.03 2.24.35 3.34.33.95 0 1.9-.15 2.85-.27 1.05-.14 2.34-.15 3.22-.84 1.07-.83 2.44-1.1 3.74-1.28.6-.08 3.29-.16 3.38-1.06.03-.32-.07-.48-.3-.69-1.07-.97-2.86-1.34-4.14-2-1.45-.76-1.95-2.69-3.1-3.78-1.07-1-2.5-1.55-3.71-2.33a42.5 42.5 0 0 1-3.91-2.93c-.58-.47-3.04-2.23-2.21-3.02.79-.76 2.23-.85 3.15-1.45.48-.31.07-.76-.27-.91-1.63-.72-3.56-.9-5.26-1.35-2.05-.55-4.29-1.24-5.86-2.76-1.55-1.5 2.32-1.73 2.32-3.07 0-.32-.28-.48-.5-.65-.86-.7-1.82-1.27-2.75-1.87-.88-.56-1.77-1.1-2.66-1.63-.23-.14-.48-.26-.7-.4-.9-.6.05-2.1.52-2.64.85-.97 2.4-1.44 3.53-1.97 1.37-.65 2.74-1.28 4.09-1.95 2.24-1.12 4.15-2.88 6.1-4.43 1.9-1.5 3.77-3 5.65-4.51.05-.04-.03-.25 0-.27-2.7 2.17-5.39 4.32-8.1 6.46a22 22 0 0 1-3.65 2.48c-1.24.63-2.5 1.2-3.76 1.8-1.3.6-2.8 1.11-3.86 2.12-.56.54-1.37 2.28-.62 3.06.44.47 1.22.76 1.77 1.1 1.06.64 2.1 1.3 3.14 2 .31.2 1.98 1.07 1.59 1.54-.57.7-1.62 1.01-2.38 1.43-.25.13-.22.64-.2.86.07.7.84 1.17 1.37 1.54 1.82 1.29 4.15 1.84 6.27 2.36.91.22 1.83.42 2.74.65.5.12 1.19.23 1.6.6.12.11-2.19 1.07-2.49 1.18-.53.2-1.06.44-1.08 1.08-.02.54.4.95.74 1.3.96 1.03 2.12 1.9 3.21 2.75 1.16.9 2.36 1.74 3.62 2.48 1.34.78 2.66 1.41 3.52 2.77.42.66.7 1.19 1.25 1.77a6.03 6.03 0 0 0 2.13 1.45c.79.37 1.6.7 2.38 1.1 1.1.54.3.96-.49 1.19-1.76.5-3.54.37-5.22 1.23-.64.32-1.04.72-1.77.9-1.39.32-2.86.46-4.28.57-1.15.08-2.22-.23-3.37-.25-1.05-.01-2.1.01-3.16.01-3.33 0-6.77-.9-9.97-1.77v.27c3.6.95 7.2 1.94 10.8 2.83 2.8.69 5.85.94 8.52 2.08 1.36.57 2.22 1.77 3.44 2.53.38.23.93.27 1.35.45 1.18.51-.46 1-.92 1.24-.32.16-.5.47-.8.64-.52.32-1.5.13-2.07.14-.8.02-1.62.05-2.41.17-1.06.17-2.2.34-3.23-.01-.44-.15-1.8-1.03-1.82-.07 0 .2.02.4.04.6.08.62-1.21.36-1.51.33-.77-.1-1.8-.8-2.51-.48-1.17.56-2.58.57-3.84.6-1.36.04-2.74.13-4.1.09-.45-.02-2.14-.12-1.58.83.08.14.24.25.36.36.12.1.08-.08-.06-.06-.19.02-.4-.02-.6-.04-1.1-.1-2.18-.4-3.28-.5 0 0-.03.26 0 .26 1.99.48 3.98 1.41 6 1.64 1.98.22 3.93.82 5.8 1.5 1.57.57 3 1.29 4.66 1.67.67.16 1.36.14 2.02.32 1.07.3 1.97 1.1 3.04 1.45.38.12.62.32.93.55.5.36.8-.15 1.18.57.31.6.45 1.35.77 1.99.51 1-.12 1.09-.94 1.3-.88.24-2 .18-2.86-.11-1.26-.43-2.6-.39-3.9-.47-.34-.03-3.03-.59-2.97.35 0 .18.01.17.13.33.2.26.67.43.94.6.7.44-.61 1.1-.77 1.18-1.39.75-2.96 1.02-4.48 1.34-1.05.21-2.11.59-3.13.9-1.46.45-2.67 1.44-4.15 1.9-1.56.48-3.21.75-4.82 1-1.85.26-3.7.76-5.57.78-.02 0-.01.24 0 .27 3.08 9.78 9.33 18.36 16.1 25.82 8.5 9.38 18.75 18.3 30.76 22.47a40.95 40.95 0 0 0 9.66 1.94c3.8.36 7.63.62 11.45.72 6.24.16 12.57-.17 18.66-1.72 5.28-1.34 9.9-3.98 14.52-6.84a98.27 98.27 0 0 0 15.2-11.42 69.1 69.1 0 0 0 9.52-10.91c2.82-4.02 5.23-8.38 7.68-12.64 1.14-1.98 2.27-3.96 3.3-6 .22-.42.47-.86.62-1.32 0-.03.03-.24 0-.26-1.02-.45-2.13-.68-3.22-.51-.94.15-1.36-1.03-1.83-1.66-.73-1-1.78-1-2.89-.8a5.1 5.1 0 0 1-3.45-.4c-.96-.41-1.75-1.16-2.7-1.55-.48-.2-1.04-.18-1.54-.23-.7-.06-1.4-.27-2.1-.46-1.67-.48-3.23-1.27-4.93-1.67-2.46-.58-5.02-.54-7.46-1.2-2.6-.71-5.08-1.7-7.72-2.29-1.23-.27-2.6-.75-3.68-1.4-.34-.21-.68-.44-.98-.7-1.2-1.02.34-2.14 1.12-2.74 2.14-1.62 3.9-3.36 6.36-4.48 1.24-.56 2.52-.6 3.82-.88.52-.11 1.03-.2 1.56-.25.65-.06 1.42.1 2.04-.13.1-.03.05-.27.04-.34-.11-.49-2.21-.64-2.56-.69-2.56-.35-5.02.47-7.57.44-1.4-.02-2.77.05-4.17.15-1.9.13-4.04.59-5.93.2-2.06-.44-4.25-.18-6.34-.3-2.2-.12-4.32-.96-6.53-1.1-2.4-.15-4.9-.3-7.2-.99-1.03-.3-1.97-.91-2.94-1.36-.77-.36-1.58-.63-2.4-.86-.55-.15-2.78-.41-1.51-1.39 1.94-1.49 3.86-3.1 5.94-4.38.72-.44 1.65-.6 2.44-.8 1.37-.34 2.76-.62 4.15-.9 1.34-.26 2.68-.5 4.01-.78.68-.14 1.52-.22 2.14-.56.03-.02.02-.27 0-.27-.54-.03-1.21.26-1.73.37l-3.9.85c-1.31.3-2.63.59-3.95.87-.53.12-1.38.49-1.93.4v.28c.02-.01.05-.03.07-.02v-.27c-.42.2-1.02.18-1.47.2-1.73.12-3.46-.14-5.17-.37-2.09-.28-4.2-.6-6.24-1.2-.97-.29-1.9-.65-2.89-.9-1.71-.44-3.46-.52-5.21-.6-.8-.03-1.81 0-2.5-.49-.53-.36-.88-.98-1.4-1.37-1.12-.85-2.35-1.59-3.32-2.63-1.05-1.14-1.63-2.1-3.18-2.66a22.85 22.85 0 0 1-4.64-2.22c-.55-.35-1.08-.75-1.57-1.19a4.92 4.92 0 0 1-.48-.5c-.4-.48.18-.85.5-1.17 3.1-3-5.58-4.4-7.03-4.74-1.78-.42-3.57-.8-5.35-1.23a23.4 23.4 0 0 1-.93-.25c-.24-.07 1.13-.63 1.19-.65.75-.27 2.11-.69 2.28-1.6.22-1.12-2.23-1.87-2.94-2.23-2.1-1.08-4.61-1.96-6.43-3.51-1.46-1.26 5.14-4.2 5.76-4.52 1.63-.84 3.12-2 4.58-3.1 2.72-2.05 5.39-4.22 7.91-6.52.06-.04-.02-.23 0-.26M642.55 467.89c-.6.96-1.38 1.78-2.17 2.58-.1.1.06.47 0 .54.8-.82 1.58-1.64 2.19-2.61.07-.12-.05-.46-.02-.51M643.64 469c-.5.79-.96 1.6-1.33 2.47-.06.14.04.44.01.52.37-.87.83-1.69 1.34-2.48.07-.12-.05-.46-.02-.51'/%3E %3Cg fill='%234f91c5'%3E %3Cpath d='M702.98 507.39c.93-.66 1.78-.36 2.8-.1.93.22 1.67.07 2.54-.29.05-.02-.01-.26 0-.27-.89.37-1.6.48-2.54.28-1.03-.21-1.85-.56-2.8.11-.05.04.02.25 0 .27M704.49 508.6c.24-.6 1.13-.44 1.63-.44.02 0 .02-.26 0-.26-.51 0-1.4-.17-1.64.45-.02.07.03.22.01.26M701.59 506.49c1.02-.67 2-.5 3.14-.65.03 0 .01-.26 0-.26-1.13.15-2.12-.03-3.14.64-.05.03.02.25 0 .27M695.4 509.66c-2.21-.96-4.5.66-6.73-.26.01 0-.05.25 0 .27 2.24.92 4.52-.7 6.73.26-.01 0 .05-.25 0-.27'/%3E %3Cpath d='M690.77 510.08c-1.32-.59-2.6.47-3.96.01.01 0-.04.26 0 .27 1.37.46 2.64-.6 3.96-.01-.01 0 .05-.25 0-.27M688.13 511.11c-.99-.79-2.58-.08-3.7-.12-.03 0-.03.26 0 .26 1.12.04 2.71-.66 3.7.13-.03-.02.05-.23 0-.27M692.16 567.14c-1.08.42-3.27.58-4.16-.34-1.17-1.21-2.4-.54-3.9-.37-.03 0-.01.26 0 .26 1.23-.13 2.76-.89 3.74.19.97 1.06 3.07 1.02 4.32.53.04-.02-.02-.26 0-.27M674.08 536.08c2.16-1.25 4.32.4 6.57-.27.04 0 0-.26 0-.26-2.25.66-4.4-.99-6.57.27-.05.03.02.25 0 .26M655.55 540.92c.9-.34 1.67-.48 2.6-.2.85.27 1.61.66 2.5.8 2.22.33 4.52-.55 6.73-.6.02 0 .02-.27 0-.27-2.26.06-4.46.79-6.72.6-.88-.08-1.7-.49-2.51-.79-.9-.33-1.74-.13-2.6.2-.04 0 .01.26 0 .26M657.78 543.33c2.46-.98 5.09.04 7.62-.53.03-.01 0-.27 0-.27-2.53.57-5.16-.45-7.62.53-.05.02 0 .27 0 .27M678.67 534.34c2.18-.86 4.2-.31 6.44-.27.02 0 .02-.27 0-.27-2.25-.04-4.26-.6-6.44.27-.04.02.01.26 0 .27M685.63 532.1c1.32-.2 2.49-.25 3.81-.04.01 0 .03-.27 0-.27-1.32-.2-2.49-.15-3.8.04-.04 0-.02.27 0 .27M663.04 550.45c2.69-1.51 5.67.95 8.28-.67.05-.03-.03-.25 0-.26-2.61 1.61-5.6-.85-8.28.67-.05.02.02.25 0 .26M665.27 552.45c1.79-.38 3.59-.67 5.39-.94.03 0 0-.26 0-.26-1.8.26-3.6.55-5.39.94-.03 0 0 .26 0 .26M671.05 545.74c1.72-.95 4 .17 5.39-1.47.05-.06-.03-.23 0-.27-1.4 1.64-3.67.53-5.39 1.48-.05.03.02.25 0 .26M679.73 555.28c1.94-1.49 4.43.05 6.44-1.21.05-.03-.03-.25 0-.27-2 1.26-4.5-.27-6.44 1.21-.05.04.03.25 0 .27M679.06 550.31c1.3-.18 2.64-.62 3.94-.31 1.25.3 2.2 1.15 3.55 1.12.03 0 .02-.27 0-.27-1.17.02-2.12-.56-3.18-1-1.37-.55-2.91 0-4.3.2-.03 0-.01.26 0 .26M680.38 565.35c1.99-.96 3.81-.9 5.92-.4 1.82.42 3.02 1.17 4.46-.54.05-.06-.03-.23 0-.27-1.36 1.62-2.7 1.12-4.46.54a7.83 7.83 0 0 0-5.92.4c-.05.03.02.26 0 .27M698.78 559.58c2.2.43 4.02.16 6.1-.6 1.08-.4 2.12-.85 3.28-.96 1.07-.1 2.17.13 3.23.21.02 0 .03-.26 0-.26-1.07-.08-2.15-.24-3.23-.21-1.15.03-2.23.55-3.29.95a10.55 10.55 0 0 1-6.09.6s-.03.26 0 .27M713.36 558.5c1.73-.27 3.4-.76 5.17-.62 1.78.15 3.2 1.1 4.95.22.05-.03-.02-.26 0-.27-1.54.78-2.89.18-4.47-.13-1.9-.38-3.78.25-5.65.53-.03 0 0 .27 0 .27M727.3 558.23c3.4-1.27 5.91 1.78 9.19 2.01.01 0 .02-.26 0-.26-3.28-.24-5.8-3.29-9.2-2.02-.04.02.01.27 0 .27M740.3 558.77c1.52-.5 2.94-.23 4.47.1 1.64.35 3.09.3 4.59-.5.05-.03-.02-.26 0-.27-1.51.82-2.94.84-4.59.5-1.54-.32-2.94-.6-4.48-.1-.04.01 0 .27 0 .27M751.2 560.11c2.45-1.38 5.02-.92 7.63-1.6.03-.02 0-.27 0-.27-2.61.69-5.18.22-7.63 1.6-.05.04.02.26 0 .27M733.07 568.57c1.16-1 2.49-.95 3.92-.73 1.33.2 2.75.56 3.83-.48.05-.05-.03-.23 0-.26-1 .95-2.28.73-3.52.52-1.52-.25-2.98-.4-4.23.68-.05.05.03.24 0 .27M734.78 571.4c1.96-1.6 4.43-.92 6.57-2.02.05-.03-.02-.26 0-.27-2.14 1.1-4.6.42-6.57 2.02-.06.04.03.24 0 .26M759.08 565.08c2.24-.1 4.48.1 6.7-.27.03 0 0-.27 0-.27-2.22.38-4.46.17-6.7.27-.02 0-.02.27 0 .27M759.87 567.63a5.68 5.68 0 0 1 2.53-.73c.78-.02 1.55.1 2.33.06.03 0 .02-.26 0-.26-.78.03-1.55-.06-2.33-.07-.9-.02-1.73.32-2.53.74-.05.02.02.25 0 .26M764.6 562.13c.72-.78 1.84-.47 2.76-.67.04-.01 0-.27 0-.27-.92.2-2.04-.1-2.75.67-.05.06.03.23 0 .27M701.53 566.16c1.32-1.05 2.7-1.08 4.3-1 1.75.07 3.17-.22 4.5-1.42.06-.04-.02-.24 0-.26-1.34 1.2-2.75 1.47-4.5 1.4-1.6-.06-2.97-.04-4.3 1.01-.05.04.03.25 0 .27M702.85 567.63c2.06-1.6 4.65-.27 6.97-.94.03 0 0-.26 0-.26-2.32.66-4.91-.67-6.97.94-.05.04.03.24 0 .26M699.82 562.4c3.03-1.7 6.83 1.76 9.46-.94.06-.05-.03-.24 0-.27-2.63 2.7-6.43-.75-9.46.94-.05.03.02.26 0 .27M709.95 575.28c1.23-.93 1.94-.47 3.28-.13 1.91.47 3.82.53 5.78.53a.65.65 0 0 0 0-.26c-1.78 0-3.54-.05-5.29-.42-1.5-.31-2.4-1.03-3.77.02-.06.03.02.24 0 .26M709.95 577.3c2.37-1.73 5.3.95 7.88.53.03 0 0-.27 0-.27-2.58.42-5.51-2.26-7.88-.53-.05.04.02.25 0 .27M694.96 533.53c2.45-1.77 5.02.5 7.62-.4.05-.02 0-.27 0-.27-2.6.9-5.18-1.36-7.62.4-.05.04.03.25 0 .27M696.4 534.88c1.67-.44 3.34.3 5-.14.04 0 0-.27 0-.27-1.66.44-3.33-.3-5 .14-.03 0 .01.27 0 .27M682.88 547.9c2.03-.9 4.02-.7 6.18-.67.02 0 .02-.27 0-.27-2.16-.02-4.14-.23-6.18.67-.05.02.01.26 0 .27M756.58 551.66c1.47-1.74 3.92-1.25 5.91-1.48.03 0 .01-.27 0-.27-2 .23-4.44-.26-5.9 1.48-.06.06.02.23 0 .27M750.54 556.09c2.42-2.37 5.47-.34 8.28-1.48.04-.02-.01-.26 0-.27-2.8 1.14-5.86-.9-8.28 1.48-.05.05.03.24 0 .27M691.16 559.97c1.55-2.05 3.85-1.43 6.04-2 .04-.02 0-.28 0-.28-2.19.59-4.49-.04-6.04 2.02-.05.06.03.22 0 .26M775.54 539.2c1.4-.3 2.71-.67 4.15-.55 1.47.12 2.7.27 4.09-.36.05-.02-.01-.26 0-.27-1.36.62-2.64.54-4.09.36-1.41-.17-2.78.25-4.15.55-.03 0 0 .27 0 .27M774.44 541.72c.97-.2 1.87-.24 2.85-.28a4.76 4.76 0 0 0 2.18-.82c.05-.03-.02-.25 0-.26a5.3 5.3 0 0 1-1.95.8c-1.04.14-2.04.08-3.08.3-.03 0 0 .26 0 .26M770.51 536.7c1.77-.83 4.52 1.04 5.79-.91.04-.06-.02-.23 0-.26-1.27 1.94-4.03.08-5.79.9-.05.02.01.25 0 .26M777.7 543.09c.98-.35 1.8-.6 2.84-.57.9.03 1.7.2 2.52-.27.05-.03-.03-.25 0-.27-.8.46-1.63.34-2.52.27-1.02-.07-1.88.23-2.83.57-.04.01 0 .26 0 .27M764.38 536.06c1.7-1.97 4.7 1.07 6.73-.26.05-.03-.03-.25 0-.27-2.03 1.33-5.03-1.7-6.73.26-.05.06.03.23 0 .27M760.93 535.09c.6-1 1.91-.67 2.89-.75 1.1-.1 1.93-.74 2.7-1.5.05-.05-.03-.23 0-.26a4.63 4.63 0 0 1-2.7 1.49c-1 .14-2.27-.26-2.9.76-.04.06.02.23 0 .26M709.97 513.1c1.62-.8 3.24.14 4.9-.27.04 0 0-.26 0-.26-1.66.4-3.28-.54-4.9.26-.05.02.02.25 0 .26M711.98 514.58c.82-.69 1.8-.03 2.7-.45.05-.02-.02-.26 0-.27-.9.42-1.88-.23-2.7.45-.06.05.02.24 0 .27M748.35 561.59c.88-.1 1.88.4 2.7-.07.06-.02-.02-.25 0-.26-.82.45-1.82-.04-2.7.06-.03 0-.01.27 0 .27M684.3 520.04a7.18 7.18 0 0 0-4.09-.38c-.92.23-.86 1.15-1.98.8 0 .01-.04.26 0 .28 1.01.3 1.16-.43 1.98-.81 1.16-.54 2.96-.02 4.08.37 0 0 .05-.25 0-.26M683.48 521.45c-2.3-1.06-4.76-.13-7.17-.38-.02 0-.03.26 0 .26 2.4.25 4.87-.67 7.17.39-.02 0 .04-.24 0-.27'/%3E %3Cpath d='M680.52 522.8c-1.19-.42-2.3-1-3.5-1.37-1.38-.42-2.9-.42-4.3-.75 0 0-.04.26 0 .27 1.27.3 2.55.45 3.84.64 1.38.2 2.65 1.02 3.96 1.48 0 0 .04-.25 0-.27M675.49 547.62c1.62-2.07 4.02-.62 6.16-1.1.04 0 0-.26 0-.26-2.14.47-4.54-.98-6.16 1.1-.05.05.03.22 0 .26M675.56 548.84c.78-.36 1.5-.83 2.39-.84.8-.01 1.6.53 2.39.64 0 0 .03-.26 0-.26-.83-.12-1.57-.53-2.4-.65-.81-.11-1.68.52-2.38.84-.05.02.01.26 0 .27M677 552.37c.49-.48.95-.63 1.59-.4.52.2.95.42 1.5.15.04-.03-.02-.26 0-.27-.54.27-.98.07-1.5-.14-.63-.25-1.11-.08-1.59.4-.05.05.03.23 0 .26M678.07 544.34c.6-.36 1.13-.34 1.77-.08.65.27 1.16.43 1.81.08.05-.03-.02-.26 0-.27-.59.32-1.08.23-1.68-.02-.68-.29-1.23-.37-1.9.02-.05.03.02.26 0 .27M671.77 543.57c1.05-.26 1.84.33 2.86.48.79.11 1.66-.4 2.43-.55.03 0 0-.27 0-.27-.82.16-1.6.58-2.43.55-1.05-.04-1.77-.75-2.86-.48-.03 0 0 .27 0 .27M686.94 557.9c1.28-1.34 3.1-.22 4.6-.96.04-.03-.03-.26 0-.27-1.5.75-3.32-.37-4.6.96-.05.06.03.24 0 .27M715 559.9c1.7-1.04 3.5-.32 5.34-.33.02 0 .02-.27 0-.27-1.85.01-3.64-.7-5.35.32-.05.04.02.26 0 .27M726.82 559.58c2.17-.79 3.88 1.27 6.04.83.04 0 0-.27 0-.27-2.16.44-3.87-1.62-6.04-.83-.04.01.01.26 0 .27M741.72 559.95c1.75-.32 4.37 1.38 5.8-.13.04-.05-.04-.23 0-.26-1.43 1.5-4.05-.2-5.8.12-.03 0 0 .27 0 .27M752.11 561.3c.64-1.3 1.98-.74 3.12-.62 1.36.15 2.63.03 3.73-.86.06-.04-.02-.24 0-.26-1.23 1-2.63.98-4.13.82-1.08-.12-2.14-.52-2.73.66-.03.07.03.22.01.26M703.67 560.47c1.15-.06 2.13-.53 3.21-.9 1.2-.42 2.48-.03 3.64-.52.05-.02-.01-.26 0-.27-1.03.44-2.19.17-3.27.41-1.25.27-2.28.95-3.58 1.01-.03 0-.02.27 0 .27M711.53 571c1.82-2.12 4.64-.04 6.8-1.34.04-.03-.03-.26 0-.27-2.16 1.3-4.98-.77-6.8 1.35-.05.06.03.23 0 .27M714.05 571.72c1.73-.62 4.52.44 5.79-1.22.05-.06-.04-.22 0-.27-1.27 1.66-4.06.6-5.79 1.22-.04.02.01.27 0 .27M730.4 578.78c1.28-1.35 2.73-1.5 4.46-1.18 2.03.39 3.93.81 5.98.35.04-.01 0-.27 0-.27-1.88.43-3.66.13-5.52-.25-1.9-.39-3.49-.42-4.92 1.09-.05.05.03.23 0 .26'/%3E %3Cpath d='M731.22 579.37c1.06-.73 2.2-1 3.46-.84.01 0 .03-.26 0-.26-1.26-.17-2.4.1-3.46.83-.05.04.03.25 0 .27M696.36 556.98c.85-1.08 2.46-.44 3.57-.94.05-.02-.02-.26 0-.27-1.11.5-2.72-.14-3.57.94-.05.06.04.22 0 .27M702.48 557.07c.27-1.5 2.4-.72 3.36-1.34.05-.03-.02-.25 0-.26-1 .63-3.09-.19-3.37 1.37l.01.23M713.37 556.09c-.87-.06-1.66-.38-2.54-.32-.98.07-1.93.55-2.86.84-.04 0 .01.26 0 .26.96-.3 1.87-.67 2.86-.83.86-.14 1.7.26 2.54.31.02 0 .03-.26 0-.26M717.25 556.57a10.1 10.1 0 0 1 3.45-.12c.97.12 2.01.68 2.97.53.03 0 0-.27 0-.27-.84.13-1.72-.31-2.56-.46a9.85 9.85 0 0 0-3.86.05c-.04 0 0 .27 0 .27M729.58 556.98c1.49-.16 3.03.32 4.28-.73.05-.05-.02-.25 0-.27-1.25 1.05-2.8.57-4.28.73-.02 0 0 .27 0 .27M737.63 556.67c2.4-2.52 5.8.12 8.66-.73.04-.01 0-.26 0-.26-2.86.85-6.25-1.8-8.66.73-.05.05.03.23 0 .26M685.46 556.67c1.12-.9 2.47-.9 3.77-1.35.04-.02 0-.27 0-.27-1.3.45-2.65.46-3.77 1.36-.05.04.03.24 0 .26M726.02 556.76c.96-1.39 2.6-1.46 4.07-1.86.04-.02 0-.27 0-.27-1.48.4-3.12.48-4.08 1.88-.04.05.03.23 0 .25M747.51 555.94c.97-.99 2.34-.76 3.57-1.04.03 0 0-.26 0-.26-1.23.28-2.6.05-3.57 1.04-.05.05.04.23 0 .26M753.42 553.86c.89-.66 1.9-.63 2.95-.73.03 0 .02-.27 0-.27-1.05.1-2.06.08-2.95.73-.06.04.02.25 0 .27M753.42 551.05c.98-.29 2-.43 2.85-1.04.05-.04-.02-.25 0-.27-.85.61-1.88.75-2.85 1.04-.04.02 0 .27 0 .27M681.29 551.88c1.12-.12 2.22-.48 3.36-.31 0 0 .03-.26 0-.27-1.14-.17-2.24.19-3.36.32-.03 0-.01.26 0 .26'/%3E %3C/g%3E %3Cpath fill='%23fff' stroke='%23000' stroke-width='.46' d='M523.83 317.68s8.07-.73 7.67.65c-.39 1.38.4 1.38 2.57 1.38s8.09-.79 8.68.2c.6.98 6.31-.4 8.48-.8 2.17-.39 3.75-.39 4.93-.59 1.19-.2 3.36-.78 3.36 0s.59 2.57.59 2.57 2.56 2.17 4.34 2.17c1.77 0 2.37.6 2.76 1.18.4.6 0 1.78 1.58 1.38 1.58-.39.2.4 3.94-.98 3.75-1.38 2.17-.2 3.16-.99a4.34 4.34 0 0 1 3.95-.98c1.77.4 3.15 1.18 3.74.98.6-.2 1.98-.59 4.54.6 2.56 1.18 5.33 1.57 7.5 1.77s3.35.6 4.53 0 3.95-.6 4.74-.6-.8-.39 3.75.2c4.53.6 4.93.6 5.52 0s2.17-.98 2.96-1.18c.79-.2 1.18-1.18 1.97-.79.79.4 2.76 1.19 4.34 1.97 1.58.8 5.33 1.19 7.5.8 2.17-.4.79-.2 4.34.59 3.55.78 4.73.98 6.11.98s6.35-.59 6.35-.59l-1.81-.41c-2.17-1.78-1.18-.18-5.33-2.35s-2.36-1.38-8.48-2.76c-6.11-1.39-4.73-2.57-6.7-3.75-1.98-1.19-2.18 0-4.35 0-2.17 0-1.38-1.38-6.5-5.13-5.13-3.75-4.74-2.76-6.71-4.34-1.98-1.58-6.12-4.14-8.29-6.12-2.17-1.97-6.7-1.5-8.68-1.57-4.37-.15-6.04-4.31-9.86-3.48-1.72.38-4.74-2.25-9.08-3.23-4.34-.99-8.48 2.56-11.63 4.54-3.16 1.97-10.66 6.11-14.01 9.07-3.35 2.96-10.53 6.5-14.87 7.88s-7.47 1.35-7.47 1.35' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3E %3Cpath d='M690.58 437.7c-.63.42-1.32.69-2.03.93-.08.03.02.53 0 .53.71-.24 1.4-.5 2.03-.92.1-.07-.04-.5 0-.54M721.57 442.79c-2.4 1.3-4.26 3.39-6.56 4.85-.1.06.05.5 0 .53 2.3-1.46 4.16-3.55 6.56-4.85.1-.05-.04-.51 0-.53M721.77 439.3a14.76 14.76 0 0 1-4.64 4.47c-.1.06.04.51 0 .54a14.85 14.85 0 0 0 4.65-4.49c.08-.11-.05-.47-.01-.51M719.93 437.6a7.18 7.18 0 0 1-2.98 1.79c-.07.02 0 .53 0 .53 1.16-.3 2.1-1 2.98-1.79.1-.1-.06-.48 0-.53M720.1 439.04c-1.31 1.35-2.55 2.87-4.29 3.67-.1.04.03.52 0 .53 1.74-.8 2.98-2.31 4.3-3.67.1-.1-.07-.47 0-.53M720.98 445.93c-1.22 1.61-2 3.62-3.95 4.47-.09.04.03.52 0 .53 1.96-.85 2.73-2.85 3.95-4.47.09-.13-.07-.45 0-.53M719.93 449.78c-.71.84-1.29 1.92-2.36 2.33-.1.03.02.52 0 .53 1.07-.4 1.65-1.49 2.36-2.33.1-.11-.06-.46 0-.53M720.46 452.81c1.03.75 1.5 2.03 2.54 2.78-.05-.04.1-.46 0-.54-1.03-.74-1.5-2.02-2.54-2.77.05.04-.1.46 0 .53M722.73 458.27c.5.36.8.9 1.22 1.34l.03-.27c0-.05.02-.21-.03-.26-.42-.44-.72-.99-1.22-1.34l-.03.26c0 .05-.02.24.03.27M688.13 442.34c-1.39 1.48-3 2.71-4.82 3.58-.1.05.04.52 0 .53 1.82-.86 3.43-2.1 4.82-3.58.1-.1-.06-.46 0-.53M685.85 446.37c-2.22 1.93-4.88 3.02-7.62 3.94-.08.03.01.53 0 .53 2.74-.91 5.4-2 7.62-3.94.1-.09-.06-.48 0-.53M682.17 450.41c-1.16 1.68-2.86 3.7-4.9 4.2-.07.02 0 .53 0 .53 2.05-.5 3.75-2.52 4.91-4.21.08-.12-.04-.47 0-.52M669.65 452.2c-1.26.81-2.54 1.59-3.94 2.14-.09.03.02.52 0 .53 1.4-.55 2.68-1.32 3.94-2.15.1-.06-.04-.5 0-.53M667.03 451.3c-.33.1-.64.24-.97.36-.08.03.02.53 0 .53.33-.11.64-.26.97-.36.07-.02 0-.53 0-.53M686.03 454.7c-.66.39-1.3.8-1.92 1.25-.1.07.05.5 0 .53.62-.45 1.26-.86 1.92-1.25.1-.06-.04-.5 0-.53M710.12 455.78c-.93.43-1.84.9-2.72 1.43-.1.06.05.5 0 .53.88-.53 1.8-1 2.72-1.43.1-.05-.03-.52 0-.53M716.34 454.7c-.62.37-1.13.9-1.5 1.53-.04.08-.01.24-.01.33 0 .02.02.2.03.18.36-.63.87-1.14 1.48-1.5.1-.07-.04-.52 0-.54'/%3E %3Cg opacity='.59' fill='%23007638'%3E %3Cpath d='M658.31 514.56c-.1 1.21-.1 2.57.6 3.62-.03-.05.09-.4.01-.52a4.19 4.19 0 0 1-.57-2.73c0-.07-.02-.58-.04-.37M657.62 517.96c-.42-.64-1.15-1.54-1.1-2.36 0-.09-.03-.6-.05-.27-.06 1.23.48 2.15 1.13 3.15-.03-.05.1-.4.02-.52M655.75 517.47a10.7 10.7 0 0 1-2.21-6.13c-.02-.33-.05.18-.05.26.14 2.3.8 4.61 2.26 6.4-.07-.07.1-.4 0-.53M660.5 517.67c-.18-.2-.27-.42-.37-.65-.01-.03-.03.16-.03.18 0 .1-.03.24.01.33.12.24.2.48.38.67l.03-.26c0-.06.02-.22-.03-.27M661.7 517.86c-.22-.08-.43-.16-.55-.37-.02-.03-.03.17-.03.18 0 .09-.03.25.01.33.13.22.34.31.57.4-.02-.01.08-.51 0-.54M652.3 516.72c-.77-1.53-.82-3.22-.9-4.9-.03-.34-.06.17-.05.26.1 1.77.13 3.55.94 5.16-.03-.07.08-.39.02-.52M653.67 502.54c.01.94.4 2.93-.8 3.25-.09.02 0 .53 0 .53 1.28-.34.87-2.8.85-3.78 0-.3-.05-.3-.05 0M651.65 506.42c.26-.28.45-.6.57-.96.03-.1.02-.23.02-.33l-.03-.19c-.12.36-.3.68-.55.94-.05.05-.03.21-.03.27 0 .02.03.26.02.27M653.98 506.42c.77-.54.68-1.52.68-2.36 0-.3-.05-.3-.05 0 0 .71 0 1.38-.63 1.82-.1.08.05.5 0 .54M662.53 503.95c.29.7.08 1.56.08 2.3 0 .3.04.3.05 0 0-.9.24-1.96-.11-2.82.03.08-.08.37-.02.52M655 506.51c1-.63 1.04-2.09.85-3.16 0-.04-.04.36-.03.46.15.82-.1 1.72-.82 2.17-.1.06.05.5 0 .53M661.8 506.31c.21-.35.29-.73.3-1.14 0-.1.01-.23-.02-.32-.01-.02-.03.16-.03.18-.01.27-.13.54-.27.77-.04.07-.02.24-.01.32 0 .02.01.22.03.2M657.97 502.14c.45 1.14-.16 2.65-.29 3.83 0 .07.01.59.04.38.17-1.49.85-3.25.26-4.72.04.07-.07.37 0 .51M663.3 506.15v-1.05c0-.02 0-.26-.02-.26-.03 0-.03.24-.03.26v1.05c0 .02 0 .26.03.26.02 0 .02-.24.02-.26M673.14 507.56c.61-.68.58-1.66.58-2.54 0-.3-.05-.3-.05 0 0 .73-.03 1.45-.53 2.01-.1.11.06.46 0 .53M658.44 506.23c.93-1.12 1.04-2.53 1.14-3.93 0-.09-.02-.6-.05-.27-.09 1.32-.22 2.62-1.09 3.67-.1.12.07.45 0 .53M656.02 506.42c1.66-.55.97-3.62.76-4.87 0-.05-.04.36-.03.46.2 1.18.75 3.39-.73 3.87-.08.03.01.53 0 .54M660.1 504.03c-.05.68-.13 1.44-.73 1.86-.1.07.05.5 0 .53.67-.47.72-1.37.77-2.12 0-.1-.03-.6-.05-.27M663.46 506.51c.3-.22.38-.5.4-.86 0-.1.02-.23-.02-.33a.8.8 0 0 0-.03.19c0 .18-.22.37-.35.47-.04.03-.02.22-.02.26l.02.27M660.58 506.51a6.46 6.46 0 0 0 1.15-3.9c0-.17-.05-.52-.06-.14a5.84 5.84 0 0 1-1.09 3.5c-.09.13.07.45 0 .54M650.73 506.14c.1-.1.16-.18.2-.32.02-.12.01-.25 0-.37 0-.02 0-.2-.03-.1-.04.1-.1.18-.17.25-.05.05-.03.21-.03.27l.03.27M654.26 517.1c-.95-1.23-1.29-2.78-1.67-4.27.02.1-.05.37-.01.52.38 1.49.72 3.04 1.68 4.28-.07-.09.1-.4 0-.53M651.01 516.72a8.19 8.19 0 0 1-.74-1.52l-.03.19c0 .1-.02.23.02.33.18.54.45 1.03.74 1.52.01.02.03-.17.03-.19 0-.08.03-.25-.02-.33M663.07 516.5c.03.35.1.69.2 1.02l.03-.19c0-.1.01-.22-.02-.33a4.52 4.52 0 0 1-.17-.88c-.01-.09-.03-.09-.04 0a1.8 1.8 0 0 0 0 .38M672.19 526.67c.06.62.46 1.06.75 1.58.02.03.03-.16.03-.18 0-.09.03-.25-.02-.33-.25-.46-.68-.9-.73-1.45 0-.09-.03-.09-.04 0v.38M672.12 528.5c-.48-.42-.67-1.02-.83-1.61.02.09-.06.36-.02.51.17.6.36 1.2.85 1.63-.06-.06.1-.45 0-.54M725.01 507.18c.94-.63 1.29-1.75 1.68-2.77.05-.14-.04-.43-.01-.5-.4 1-.74 2.12-1.67 2.74-.1.06.05.5 0 .53M727.35 506.6c1.13-1.92.79-4.25.67-6.37-.02-.33-.05.18-.05.27.1 1.9.37 3.9-.63 5.59-.08.12.04.46 0 .51M776.73 512.8v-1.24c0-.02 0-.26-.02-.26-.03 0-.03.24-.03.26v1.24c0 .02 0 .27.03.27s.02-.25.02-.27M782.12 513.03c.09-.39.1-.78.1-1.18 0-.01.01-.26-.02-.26s-.02.25-.02.26c0 .25-.03.48-.08.72-.03.12-.02.25-.01.37 0 .02 0 .2.03.1M777.65 513.72c.64-1.48.84-3.07.94-4.68.01-.09-.02-.6-.04-.27-.1 1.53-.3 3.03-.91 4.44-.06.14.04.44.01.51M780.74 513.37c0-1.08.17-2.15.18-3.23 0-.3-.05-.3-.05 0-.01 1.08-.17 2.15-.19 3.23 0 .3.05.3.06 0M779.42 513.24c.56-2 1.1-3.97 1.13-6.07 0-.17-.04-.52-.05-.14-.04 1.97-.57 3.82-1.1 5.7-.04.15.04.43.02.51M775.62 513.19c0-.51.09-1.01.1-1.52 0-.02 0-.27-.03-.27s-.03.25-.03.27c0 .5-.08 1-.09 1.52 0 .01 0 .26.03.26s.02-.25.02-.26M778.3 513.72c.54-1.73.4-3.56.66-5.34.02-.1-.02-.5-.02-.46-.26 1.76-.12 3.58-.65 5.29-.04.15.04.43.01.51M777.1 513.8c.2-.88.37-1.74.39-2.63 0-.17-.05-.52-.06-.15 0 .8-.19 1.55-.35 2.31-.03.12-.02.25-.01.37 0 .02 0 .2.03.1M779.15 513.28c.02-1 .17-1.98.19-2.97 0-.17-.05-.51-.05-.14-.02 1.04-.18 2.07-.19 3.1 0 .31.05.31.05 0M726.23 506.9a6.58 6.58 0 0 0 1.32-3.8c0-.18-.04-.52-.05-.15a6.1 6.1 0 0 1-1.27 3.41c-.1.13.06.45 0 .54M723.91 507.37c.26-.52.54-1.03.84-1.53.04-.07.02-.24.02-.32 0-.02-.02-.22-.04-.19-.29.5-.58 1-.83 1.52-.05.09-.03.24-.02.33 0 .02.02.21.03.19M728.84 505.91c.1-.7.1-1.42.1-2.13 0-.02 0-.26-.02-.26s-.03.24-.03.26c0 .56 0 1.12-.08 1.67v.37c0 .01.02.2.03.1M730.97 505.27c.36-1.42.57-2.87.85-4.3.02-.1-.02-.51-.03-.46-.27 1.41-.48 2.84-.83 4.24-.04.16.03.43.01.52M732.58 504.34c0-.82.08-1.64.09-2.47 0-.3-.05-.3-.05 0 0 .83-.09 1.65-.1 2.47 0 .3.05.3.06 0M734.04 503.75c.47-1.47.74-2.96.86-4.5 0-.08-.03-.6-.05-.26-.1 1.44-.38 2.86-.82 4.24-.05.15.04.43.01.52M736.08 503.47c.54-.97.66-2.03.76-3.11 0-.07-.02-.59-.04-.38a7.31 7.31 0 0 1-.73 2.97c-.07.13.05.46.01.52M737.76 503.95c.62-.97.83-2.07.94-3.2 0-.08-.02-.6-.04-.38a6.64 6.64 0 0 1-.92 3.06c-.07.12.05.46.02.52M740.54 502.9c1-.86 1.66-1.97 2.06-3.24.04-.14-.04-.43-.02-.51a6.89 6.89 0 0 1-2.04 3.22c-.1.1.06.48 0 .53M744.36 502.98c.85-1.17.67-2.73.76-4.1 0-.1-.02-.6-.04-.28-.09 1.32.08 2.75-.73 3.87-.08.11.04.47.01.51M746.58 502.14c1.15-.64 1.5-1.88 1.52-3.14 0-.17-.05-.51-.05-.14-.02 1.13-.46 2.2-1.47 2.75-.1.05.04.51 0 .53M742.53 503.02c0-.43 0-.86.08-1.29.02-.12.01-.25 0-.36 0-.02-.01-.2-.03-.1-.1.58-.1 1.16-.1 1.75 0 .02 0 .27.02.27s.03-.25.03-.27M736.85 504.25c0-.53 0-1.05.08-1.58.02-.11.02-.24.01-.36 0-.02-.02-.2-.03-.1-.1.68-.1 1.36-.11 2.04 0 .02 0 .26.02.26.04 0 .03-.24.03-.26M734.12 505.56c.67-.63.68-1.59.77-2.45 0-.07-.02-.59-.04-.38-.09.82-.1 1.7-.73 2.3-.1.1.06.47 0 .53M732.83 505.75c.38-.83.4-1.73.4-2.63 0-.3-.06-.3-.06 0 0 .74-.04 1.44-.36 2.12-.06.13.05.44.02.5'/%3E %3Cpath d='M731.09 506.53v-1.33c0-.01 0-.26-.03-.26s-.03.25-.03.26v1.33c0 .02 0 .27.03.27s.03-.25.03-.27M729.39 507.07c.48-1.43 1.1-2.8 1.4-4.3.02-.1-.02-.5-.02-.46-.3 1.47-.92 2.83-1.4 4.25-.04.14.05.43.02.51M738.97 504.13c.46-.98.65-2.03.76-3.1 0-.08-.02-.6-.04-.38a8.94 8.94 0 0 1-.73 2.97c-.06.13.05.44.01.51M740.92 503.56c.1-.22.2-.44.28-.67.03-.1.02-.22.02-.32a.8.8 0 0 0-.03-.19 5.4 5.4 0 0 1-.28.67c-.04.08-.02.23-.02.32 0 .02.02.21.03.19M743.52 503.08c.76-1.4.42-3.02.3-4.53-.02-.21-.05.3-.04.38.1 1.22.34 2.5-.27 3.63-.07.13.05.46.01.52M745.76 502.8c.73-1.5.84-3.14.94-4.78.01-.09-.02-.6-.04-.27-.1 1.56-.22 3.11-.91 4.53-.07.14.04.45.01.52M722.67 503.97c-.1.88-.55 1.7-.37 2.6.02.1.04-.08.04-.1 0-.11.01-.24-.01-.36-.06-.29.15-.71.22-1 .07-.25.13-.5.16-.77 0-.06-.01-.58-.04-.37M722.7 507.46c.16-.7.27-1.4.46-2.1.04-.14-.04-.41-.02-.5-.18.69-.3 1.39-.46 2.09-.04.15.04.42.01.5M731.92 505.4v-1.05c0-.02 0-.26-.02-.26-.03 0-.03.24-.03.26v1.05c0 .02 0 .26.03.26s.02-.24.02-.26M735.45 504.57c-.01-.9-.26-1.71-.48-2.57.02.1-.05.37-.01.52.18.72.43 1.43.44 2.19.01.37.06.03.05-.14M739.62 503.84a9.7 9.7 0 0 0 1.12-3.54c.01-.1-.02-.5-.03-.46a9.61 9.61 0 0 1-1.1 3.49c-.08.12.04.45 0 .51M754.31 517.52c.54-1.01 1-2.06 1.4-3.14.05-.14-.05-.43-.02-.5-.39 1.07-.86 2.11-1.4 3.13-.06.12.05.45.02.5M757.56 517.25a6.32 6.32 0 0 0 1.5-3.27c.01-.1-.02-.5-.03-.46a6.16 6.16 0 0 1-1.47 3.2c-.1.11.06.45 0 .53M760.25 516.77a5.76 5.76 0 0 0 1.22-4.58c0-.05-.04.35-.02.46.2 1.35-.4 2.57-1.2 3.59-.1.12.07.45 0 .53M762.77 516.1c.88-1.64.68-3.6.48-5.38-.03-.21-.05.3-.04.37.17 1.54.29 3.11-.45 4.5-.07.13.04.45.01.51M756.43 515.05c.12.37.47.94 0 1.18-.09.06.05.52 0 .54.35-.18.34-.62.32-.97-.03-.44-.17-.85-.3-1.27.02.09-.06.37-.02.52M758.68 516.97c.52-.58.5-1.43.5-2.17 0-.02 0-.27-.03-.27s-.03.25-.03.27c0 .6-.03 1.18-.44 1.64-.1.1.06.46 0 .53M761.66 516.38c.3-.73.47-1.47.48-2.27 0-.17-.04-.52-.05-.14 0 .66-.2 1.29-.44 1.9-.06.14.04.44.01.51M755.63 516.8c0-.35 0-.68.08-1.01.02-.12.02-.25 0-.37 0-.02 0-.2-.03-.1-.1.49-.1.98-.1 1.47 0 .02 0 .27.02.27.03 0 .03-.25.03-.27M753.02 517.68c.08-.44.17-.89.36-1.3.04-.09.02-.24.02-.33 0-.02-.02-.2-.03-.18-.2.42-.29.9-.38 1.35-.02.12-.02.25 0 .37 0 .01 0 .2.03.1M760.88 511.78c-.04 1.05-.66 2.01-.35 3.08-.03-.08.05-.36.01-.51-.13-.46.16-1.04.26-1.49.08-.31.12-.61.13-.94 0-.17-.03-.51-.05-.14M757.57 514.18a9 9 0 0 1-.08-1.38c0-.02 0-.27-.03-.27s-.02.25-.02.27c0 .61 0 1.23.1 1.84.02.1.04-.08.04-.1l-.01-.36M759.62 514.56l.28-2v-.36c0-.02-.01-.2-.03-.1l-.28 2v.36c0 .02.02.2.03.1M758.23 514.32c0-.43.02-.85.17-1.26.03-.1.02-.23.02-.33l-.03-.18c-.2.56-.2 1.18-.21 1.77 0 .02 0 .27.03.27s.02-.25.02-.27M762.61 514.13c0-.46 0-.91-.1-1.37-.03-.1-.04.08-.04.1 0 .12-.02.25 0 .36.08.3.09.6.09.91 0 .02 0 .27.02.27.03 0 .03-.25.03-.27M759.42 516.76c.21-.45.3-.93.3-1.42 0-.1.02-.23-.02-.33a.9.9 0 0 0-.03.19c0 .36-.1.72-.26 1.04-.04.1-.02.24-.02.33 0 .02.02.21.03.19M756.56 514.25c0-.41-.09-.82-.1-1.23a.85.85 0 0 0-.03-.19c-.03.1-.02.23-.01.33 0 .41.08.82.09 1.23 0 .03.02.21.03.19.03-.1.02-.23.02-.33M787.05 525.76c.29-2.03 1.96-3.48 2.33-5.5.01-.11-.02-.51-.03-.47-.37 2.03-2.04 3.47-2.32 5.51-.02.1.01.5.02.46M788.36 525.03c0-.56.2-1.06.63-1.42.1-.1-.06-.48 0-.54-.54.47-.67 1.13-.68 1.81 0 .17.04.52.05.15M785.93 525.5c.26-.53.56-1.03 1.02-1.41.04-.04.02-.22.02-.27l-.02-.26c-.47.39-.77.9-1.03 1.43-.05.09-.02.24-.02.33 0 .02.02.21.03.19M789.37 524.65c.36-1.17.47-2.37.57-3.58 0-.07-.02-.59-.04-.38-.1 1.17-.2 2.33-.55 3.45-.04.15.04.43.02.51M785.26 524.8c-.05-.14-.07-.18-.07-.12 0-.1-.03-.09-.04 0v.38c.01.1.05.18.11.26l.03-.26c0-.07.02-.21-.03-.27M789.83 525.41a9.91 9.91 0 0 0 1.22-6.43c-.03-.2-.05.31-.04.38a8.52 8.52 0 0 1-1.2 5.54c-.07.12.05.46.02.51M781.38 513.28c.1-.87.1-1.75-.1-2.6-.02-.1-.03.07-.04.1 0 .1-.01.24.01.36.14.58.16 1.16.1 1.76-.02.07 0 .59.03.38'/%3E %3Cpath d='M790.66 524.75c.91-1.5.75-3.43.94-5.1.01-.08 0-.6-.03-.38-.2 1.65-.03 3.5-.92 4.96-.07.12.05.46.01.52M771.77 525.25c-.04.37-.04.76.1 1.1.02.03.04-.16.04-.18 0-.1.02-.23-.02-.33-.02-.04-.09-.16-.08-.22v-.37c-.01-.1-.03-.09-.04 0M719.26 504.61c1.1-.7 1.55-2 1.86-3.24.04-.15-.03-.42-.01-.51-.31 1.23-.75 2.51-1.85 3.22-.1.07.04.5 0 .53M770.78 526.38c0-.33.02-.7-.1-1.01-.02-.03-.04.16-.04.18 0 .1-.02.24.02.33.07.16.07.33.07.5 0 .02 0 .27.03.27s.02-.25.02-.27M772.65 526.2v-2.38c0-.3-.05-.3-.05 0v2.38c0 .3.05.3.05 0M719.42 500.64c-.1 1.13-.14 2.5-1.2 3.15-.1.07.05.51 0 .54 1.1-.68 1.13-2.15 1.23-3.31 0-.07-.02-.58-.03-.38M723.07 507.65a15.2 15.2 0 0 0 1.04-5.22c0-.17-.04-.52-.05-.15a14.1 14.1 0 0 1-1 4.85c-.05.14.04.44.01.52M717.4 504.32c.17-.27.27-.56.37-.85.03-.1.02-.23.02-.33l-.03-.19c-.1.3-.2.59-.37.86-.05.07-.02.24-.02.32 0 .02.01.22.03.19M721.51 506.9v-.66c0-.01 0-.26-.02-.26-.03 0-.03.25-.03.26v.67c0 .02 0 .26.03.26s.02-.24.02-.26M716.64 504.24a.37.37 0 0 0 .19-.1c.04-.04.02-.21.02-.27l-.02-.26a.37.37 0 0 1-.19.1c-.07 0 0 .53 0 .53M770.22 495.24c0-.35.04-.66.23-.97.04-.08.01-.25.01-.33 0-.02-.01-.21-.03-.18-.27.44-.26.98-.26 1.48 0 .02 0 .27.03.27s.02-.25.02-.27M785.66 495.62c.01-.46.12-.9.22-1.35a1.21 1.21 0 0 0 0-.5 8.27 8.27 0 0 0-.27 1.85c0 .02 0 .27.03.27s.02-.25.02-.27M777.93 495.88c.6-2 .73-4.09.74-6.17 0-.3-.05-.3-.05 0-.01 1.91-.15 3.81-.7 5.65-.05.15.03.43 0 .52M776.01 495.86v-1.35c0-.02 0-.27-.02-.27-.03 0-.03.25-.03.27v1.35c0 .02 0 .27.03.27s.02-.25.02-.27M782.15 496c.14-.55.05-1.1-.12-1.63-.01-.02-.04.16-.04.19 0 .1-.01.22.02.32.06.18.17.41.12.6-.02.1-.02.22-.02.33 0 .02.03.2.04.18M774.33 495.37c.01-1.26.23-2.5.35-3.75 0-.07-.02-.59-.03-.38-.14 1.38-.36 2.74-.37 4.13 0 .3.04.3.05 0M779.97 495.75c.6-.94.62-2.07.73-3.15.01-.07-.01-.59-.03-.38-.11 1.04-.13 2.11-.71 3.01-.08.12.04.47 0 .52M771.66 495.6c.12-.65.12-1.31.24-1.96.02-.12.01-.25 0-.37 0-.02-.01-.2-.03-.1-.12.66-.12 1.32-.24 1.98-.02.11-.02.24 0 .36 0 .02 0 .2.03.1M776.96 495.84c.14-.6.14-1.22.14-1.83 0-.02 0-.27-.03-.27s-.02.25-.02.27c0 .46-.01.92-.11 1.37-.03.12-.02.25-.01.37 0 .01.01.19.03.1M774.79 496c.5-1.37 1.18-2.66 1.45-4.1.02-.1-.02-.5-.03-.46-.26 1.43-.94 2.7-1.44 4.04-.05.14.05.43.02.51M772.73 494.99c-.19-.31-.33-.68-.34-1.05 0-.02-.02-.21-.03-.19-.04.1-.02.23-.02.33.01.5.12.99.38 1.42.02.02.03-.17.03-.19 0-.08.03-.25-.02-.32M779.24 495.75c.11-.24.14-.5.25-.74.03-.1.02-.23.02-.33 0-.02-.03-.2-.04-.18-.1.23-.13.5-.24.73-.04.1-.02.24-.02.33 0 .02.02.21.03.19M784.42 493.66c.26.57.2 1.13.1 1.73v.37c0 .02.02.2.04.1.13-.9.26-1.87-.13-2.71.03.07-.08.38-.01.51M780.69 496.13c.4-.29.6-.76.73-1.24.03-.1.02-.22.02-.33l-.03-.18a2.1 2.1 0 0 1-.72 1.22c-.04.03-.02.22-.02.27l.02.26M783.48 496.46c.26-1.6.75-3.49-.25-4.92.03.05-.1.4-.02.51.84 1.2.47 2.6.24 3.95-.02.1.02.5.03.46M778.3 495.56c.12-1.06.33-2.1.59-3.14.03-.15-.04-.41-.02-.5a27.26 27.26 0 0 0-.61 3.26c-.01.07 0 .59.03.38M773.24 495.49v-2.46c0-.3-.05-.3-.05 0v2.46c0 .3.05.3.05 0M770.68 495.51c.18-.2.15-.5.15-.75 0-.02 0-.27-.03-.27s-.02.25-.02.27c0 .1-.03.15-.1.22-.04.05-.02.2-.02.27l.02.26M783.13 495.37c0-.86 0-1.72-.13-2.57-.02-.1-.04.08-.04.1l.01.36c.1.7.1 1.4.1 2.11 0 .3.06.3.06 0M785.88 495.5c.12-.28.14-.57.14-.87 0-.02 0-.27-.02-.27s-.03.25-.03.27c0 .12-.05.24-.1.36-.04.09-.02.23-.02.32 0 .02.02.21.03.2M773.6 495.55c-.1-1-.12-2.01-.12-3.02 0-.3-.05-.3-.05 0 0 1.14.01 2.27.13 3.4.02.2.04-.31.03-.38'/%3E %3Cpath d='M775.16 496.12c.12-1.72.13-3.45.24-5.17.01-.09-.02-.6-.04-.27-.11 1.72-.13 3.45-.24 5.17 0 .09.02.6.04.27M777.45 495.5c.27-.91.27-1.94 0-2.85.02.08-.06.36-.02.51.19.62.19 1.2 0 1.83-.04.14.04.42.02.51M779.61 496c.26-.82.37-1.63.38-2.48 0-.3-.05-.3-.05 0 0 .67-.14 1.32-.34 1.96-.05.15.04.43.01.51M782 493.9c.2.65.65 1.45.6 2.14 0 .07.02.58.04.38.08-1.1-.3-2.01-.62-3.04.03.09-.06.37-.01.52M771.07 495.24v-.49c0-.02 0-.27-.02-.27-.03 0-.03.25-.03.27v.5c0 .01 0 .26.03.26.02 0 .02-.25.02-.27M786.6 495.1a.84.84 0 0 1-.23-.48c0-.02-.01-.2-.03-.1-.02.12-.02.25-.01.37.02.28.08.53.26.75l.03-.27c0-.06.02-.22-.03-.27M780.94 495.84c.26-1.38.37-2.77.38-4.17 0-.3-.05-.3-.06 0 0 1.25-.12 2.48-.35 3.71-.02.1.02.5.03.46M775.87 513.62c.14-.55.25-1.1.26-1.67 0-.1.02-.23-.01-.32-.01-.02-.04.16-.04.18 0 .44-.12.87-.22 1.3a1.3 1.3 0 0 0 .01.5M779.73 513.26c.63-.71.63-1.71.63-2.61 0-.3-.05-.3-.06 0 0 .75-.05 1.5-.57 2.07-.1.11.06.46 0 .54M789.12 523.41l.12 1.35c0 .1.02.1.03 0v-.37l-.12-1.36c0-.09-.03-.08-.03 0-.02.13-.01.25 0 .38M773.18 525.44v.61c0 .02 0 .27.03.27s.02-.25.02-.27v-.61c0-.02 0-.27-.02-.27s-.03.25-.03.27M772.22 523.96v2.59c0 .3.05.3.05 0v-2.59c0-.3-.05-.3-.05 0M762.36 515.47c.5-.91.72-1.86.74-2.9 0-.17-.05-.51-.05-.14a5.4 5.4 0 0 1-.7 2.53c-.07.12.04.45 0 .51M762.71 518.43a2.22 2.22 0 0 0 1.23-2.12c0-.02-.02-.2-.03-.1-.12.78-.5 1.33-1.2 1.69-.1.05.04.51 0 .53M771.3 526.6a7.6 7.6 0 0 0-.26-1.67l-.03.19c0 .1 0 .22.02.33.1.42.21.85.22 1.29 0 .02.02.2.03.18.04-.1.02-.22.02-.32'/%3E %3Cpath d='M762.35 515.96c.14.48.1.97.1 1.47 0 .02 0 .27.02.27.03 0 .03-.25.03-.27 0-.67.06-1.34-.14-1.98.03.08-.06.36-.01.51M761.04 517.53c.12-.63.24-1.24.25-1.88 0-.1.02-.23-.02-.33l-.03.19c0 .53-.12 1.04-.22 1.56-.03.12-.02.25-.01.37 0 .01.01.2.03.1M755.33 510.15c0 1.34.17 2.71-.46 3.93-.07.13.05.45.01.52.72-1.38.51-2.95.5-4.45 0-.3-.05-.3-.05 0M756.48 517.43c0-.3.02-.57.1-.86.03-.1.02-.22.02-.32l-.03-.19c-.14.44-.14.9-.14 1.37 0 .01 0 .26.02.26.03 0 .03-.25.03-.26M764.27 513.3c.1 1.13-.67 2.37-1.43 3.12-.1.1.07.47 0 .53a5.03 5.03 0 0 0 1.47-4.02c-.02-.21-.04.3-.04.37M757.4 511.77c-.12.9-.39 1.77-.38 2.7 0 .3.06.3.05 0 0-.76.26-1.5.35-2.24.02-.12.02-.24.01-.37 0-.01-.02-.2-.03-.1M759.58 517.45a5.14 5.14 0 0 0 1.23-3.24c0-.01-.02-.2-.03-.1a5.01 5.01 0 0 1-1.2 2.8c-.1.12.07.47 0 .54M736.16 503.45c.01.33-.22.69-.45.9-.05.04-.03.21-.03.27l.03.26c.45-.4.52-.99.5-1.57a.8.8 0 0 0-.03-.18c-.03.1-.02.22-.02.32M731.75 505.47v-1.48c0-.02 0-.27-.03-.27-.02 0-.02.25-.02.27v1.48c0 .02 0 .26.02.26.03 0 .03-.24.03-.26M729.2 505.73c.3-.5.4-1.18.24-1.75a.9.9 0 0 0-.04.19c0 .1 0 .22.02.32.06.22-.12.54-.24.72-.05.08-.02.25-.02.33 0 .02.02.21.03.19M724.74 506.57c.11-.52.13-1.06.13-1.59 0-.02 0-.26-.03-.26s-.02.24-.02.26c0 .38-.03.76-.11 1.13-.03.11-.02.25-.01.36 0 .02.01.2.04.1M719.9 507.22c.34-.35.5-.68.5-1.18 0-.1.02-.23-.01-.33-.01-.02-.04.17-.04.2 0 .3-.25.57-.45.78-.05.05-.03.21-.03.27l.03.26M720.86 503.64c-.04.2-.17.24-.35.21-.01 0-.06.52 0 .53.23.04.34-.06.38-.28.02-.12.01-.24 0-.36 0-.02-.01-.2-.03-.1M723.65 507.08c.36-.5.68-1.04.96-1.6.04-.08.02-.23.02-.32 0-.02-.02-.22-.03-.19-.28.56-.6 1.1-.97 1.6-.08.11.05.47.02.51M739.66 501.88c-.03.68-.15 1.31-.58 1.84-.1.12.07.45 0 .54.49-.6.6-1.35.63-2.1 0-.1-.03-.6-.05-.28M742.8 501.05c.01.46.07.95-.23 1.33-.04.05-.02.2-.02.26 0 .03.03.26.02.27.45-.56.3-1.47.27-2.12-.02-.33-.05.18-.05.26M745 502.65a2.2 2.2 0 0 0 .24-1.23c-.02-.1-.04.08-.04.1-.01.21-.13.42-.22.61-.04.09-.02.24-.02.33 0 .02.02.21.03.19M748.34 501.58c0-.07-.04-.1-.1-.07-.04 0-.03.53 0 .53.17 0 .14-.18.15-.32 0-.1.02-.23-.02-.33l-.03.19M720.16 490.68c.14-.6.13-1.22.13-1.84 0-.01 0-.26-.02-.26s-.03.25-.03.26c0 .47 0 .92-.1 1.38-.03.11-.02.24-.01.36 0 .02 0 .2.03.1M727.77 489.7c.01-.86.12-1.72.12-2.58 0-.3-.05-.3-.05 0 0 .86-.11 1.72-.12 2.58 0 .3.05.3.05 0M723.99 486.48c.1.58.4 1.5-.23 1.85-.1.05.04.51 0 .53.83-.44.38-2.13.26-2.84-.02-.1-.04.08-.04.1 0 .12-.01.24.01.36M725.82 488.09c-.08-.28-.1-.56-.1-.86 0-.01 0-.26-.02-.26-.03 0-.03.25-.03.26 0 .47.01.93.14 1.37l.03-.19c0-.1.01-.22-.02-.32M722.66 486.12c-.04.82.02 1.71-.35 2.47-.06.13.05.44.02.5.4-.8.34-1.81.37-2.7.01-.09-.03-.6-.04-.27M726.54 488.61c.25-.29.26-.63.26-1 0-.02 0-.27-.02-.27-.03 0-.03.25-.03.27 0 .2-.1.34-.21.47-.05.05-.03.2-.03.27l.03.26M720.9 490.38c0-.31.12-.62.22-.92.03-.1.02-.23.02-.33 0-.02-.03-.2-.04-.18a4.6 4.6 0 0 0-.26 1.3c0 .1-.01.22.02.32.01.02.03-.16.03-.19M722.92 488.85c.14-.28.24-.55.26-.86v-.37c-.03-.1-.04.08-.04.1-.02.22-.14.43-.23.61-.04.09-.02.24-.02.33 0 .02.02.21.03.19M721.25 489.4c0-.33.1-.65.12-.99 0-.1.02-.23-.02-.32a.9.9 0 0 0-.03.18c-.01.33-.11.65-.12.99 0 .1-.02.23.02.33a.8.8 0 0 0 .03-.2M724.85 488.32a.42.42 0 0 1-.1-.22c0-.02 0-.27-.02-.27-.03 0-.03.25-.03.27 0 .25 0 .55.15.75l.03-.26c0-.07.01-.21-.03-.27M726.66 489.6c.26-.28.37-.64.5-1 .02-.1.01-.22 0-.32a.9.9 0 0 0-.02-.2c-.12.36-.23.71-.48.99-.04.05-.02.2-.02.26 0 .03.03.26.02.27M648.3 489.95v-4.68c0-.3-.06-.3-.06 0v4.68c0 .3.06.3.06 0M643.2 490.56c-1.43-2.13-2.34-4.6-1.68-7.25.03-.15-.04-.42-.02-.51-.72 2.92.03 5.82 1.7 8.27-.04-.05.08-.4 0-.51M646.83 490.18c-.26-.46-.43-.93-.24-1.45.05-.15-.05-.44-.02-.52-.28.8-.16 1.76.24 2.49-.03-.06.09-.39.02-.52M648.87 490.7a7.1 7.1 0 0 0 .14-1.61c0-.02 0-.27-.03-.27s-.02.25-.02.27c0 .37-.02.73-.1 1.1a1.06 1.06 0 0 0 .01.51M645.02 490.31c-.59-1-.94-2.1-1.08-3.26-.02-.2-.04.31-.03.38a8.7 8.7 0 0 0 1.1 3.4c-.04-.06.08-.4 0-.52M647.68 490.34c-.12-.59-.23-1.17-.37-1.75.02.09-.05.36-.02.5.14.57.25 1.14.36 1.7.02.1.03-.07.04-.09l-.01-.36M645.5 490.06c-.45-1.22-.72-2.82.11-3.92.1-.12-.06-.44 0-.53-.98 1.3-.64 3.55-.12 4.96-.04-.08.06-.37 0-.51'/%3E %3Cpath d='M642.96 489.07c-.55-1.33-.26-2.7 1.08-3.3.1-.03-.02-.51 0-.53-1.66.73-1.71 2.85-1.09 4.35-.03-.08.07-.38.01-.52M649.6 489.82a.96.96 0 0 1-.1-.36c0-.02 0-.27-.02-.27-.04 0-.03.25-.03.27 0 .3.02.6.14.87.01.03.03-.16.03-.18 0-.1.02-.24-.02-.33M646.1 486.85c-.41.5-.46 1.25-.61 1.85-.04.15.03.43.01.52.15-.6.2-1.35.6-1.84.1-.12-.07-.45 0-.53M643.93 490.18c-.2-.31-.34-.66-.35-1.04 0-.03-.02-.21-.03-.19-.03.1-.02.23-.02.33.01.52.1.98.38 1.42.02.02.04-.17.04-.19 0-.08.02-.25-.02-.33M646.35 490.06a2 2 0 0 1-.23-.74c0-.02-.02-.2-.03-.1a2.59 2.59 0 0 0 .25 1.35l.03-.19c0-.09.02-.24-.02-.32M649.33 489.82v.99c0 .02 0 .26.02.26.03 0 .03-.24.03-.26v-.99c0-.02 0-.26-.03-.26s-.02.24-.02.26M641.9 490.57c0-1.27-.11-2.55-.12-3.82 0-.3-.06-.3-.05 0 0 1.28.11 2.55.12 3.82 0 .3.05.3.05 0'/%3E %3C/g%3E %3Cpath fill='%23999b9e' d='M692.79 473.45c-.43.16-.8.41-1.18.67-.05.03-.03.22-.03.27l.03.26c.38-.25.75-.51 1.18-.67.09-.03-.02-.53 0-.53M686.56 470.11a9.5 9.5 0 0 0-2.78 2.48c-.1.13.07.45 0 .54.76-1 1.7-1.86 2.78-2.49.1-.06-.04-.5 0-.53'/%3E %3Cg fill='none' stroke='%23000' stroke-width='.92'%3E %3Cpath fill='%23949699' stroke-width='.23' d='M660.05 288.89c.78 1.4 4.05 12.05 4.05 12.05-10.84-11.93-36.22-20.3-65.8-20.3-29.17 0-54.44 8.16-65.53 19.83-.18.19 1.69-5.34 3.9-10.62 2.16-5.16 4.67-10.08 4.83-10.18 13.05-7.96 33.64-13.09 56.8-13.09 23.33 0 44.05 5.2 57.08 13.26 0 0 4.02 6.37 4.67 9.05z' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3E %3Cg fill='%23fd0' stroke-width='.46' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'%3E %3Cpath d='M597.16 284.19s1.03 5.9 1.97 7.87c0 0 2.23-6.29 2.23-7.78M593.36 282.54s-1.48 5.8-1.42 7.99c0 0 4.6-4.83 5.21-6.2M590.43 279.25s-3.85 4.6-4.74 6.58c0 0 6.24-2.36 7.38-3.32'/%3E %3Cpath d='M589.27 275.66s-5.29 2.83-6.86 4.34c0 0 6.67.14 8.1-.33'/%3E %3Cpath d='M589.52 271.93s-5.96.68-7.97 1.5c0 0 6.14 2.6 7.64 2.68'/%3E %3Cpath d='M591.04 268.71s-5.81-1.47-8-1.42c0 0 4.84 4.6 6.2 5.21'/%3E %3Cpath d='M593.73 266.13s-4.86-3.51-6.9-4.27c0 0 2.79 6.06 3.83 7.13M597.64 264.65s-2.98-5.2-4.54-6.73c0 0 .05 6.67.57 8.08'/%3E %3Cpath d='M601.08 264.74s-1.02-5.9-1.96-7.88c0 0-2.23 6.3-2.23 7.79M604.97 266.45s1.54-5.8 1.5-7.97c0 0-4.65 4.77-5.27 6.13'/%3E %3Cpath d='M607.56 269.24s3.6-4.79 4.4-6.82c0 0-6.12 2.67-7.2 3.7'/%3E %3Cpath d='M608.9 272.79s5.14-3.09 6.64-4.67c0 0-6.67.18-8.07.72'/%3E %3Cpath d='M608.9 276.11s5.87-1.22 7.81-2.22c0 0-6.36-2.03-7.85-1.98'/%3E %3Cpath d='M607.74 279.37s5.93.87 8.1.6c0 0-5.28-4.1-6.7-4.56'/%3E %3Cpath d='M605.43 282.12s5.23 2.93 7.35 3.44c0 0-3.47-5.7-4.63-6.64M601.44 284.11s3.42 4.92 5.1 6.31c0 0-.62-6.64-1.26-8'/%3E %3Cellipse cx='599.04' cy='274.46' rx='10.52' ry='10.1'/%3E %3C/g%3E %3Cg transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'%3E %3Cpath fill='%23000' d='M595.62 271.52c0 .49-.42.89-.94.89s-.94-.4-.94-.89.42-.88.94-.88.94.4.94.88' stroke='none'/%3E %3Cpath stroke-width='.68' d='M592.77 271.5c1.02-1.52 2.71-1.45 3.88 0'/%3E %3Cpath fill='%23000' d='M604.29 271.64c0 .49-.42.88-.94.88s-.94-.4-.94-.88c0-.49.42-.88.94-.88s.94.4.94.88' stroke='none'/%3E %3Cpath stroke-width='.68' d='M601.44 271.61c1.02-1.52 2.71-1.45 3.88 0M597.38 275.32c.61.05 1.04.33 1.67.36.65.03 1.03-.26 1.58-.42'/%3E %3Cellipse stroke-width='.68' cx='599' cy='278.37' rx='2.34' ry='.33'/%3E %3Cpath stroke-width='.81' d='M598.04 280.83c.6 0 1.19.12 1.74-.06'/%3E %3C/g%3E %3Cpath d='M557.53 278.96l-.95-2s-2.95.2-4.32 2.74c0 0-1.9-2.22-5.16-.95l-.1 2.95s2.21-3.06 4.53-.95c0 0-1.06 4.42 1.58 4.21 2.63-.2.84-3.9.31-4.1l-.52-.22s1.47-2.52 4.63-1.68zm-4.33 3.57c.15.62.07 1.18-.18 1.24-.25.06-.58-.39-.74-1-.16-.63-.08-1.18.17-1.25s.59.39.75 1zM575 271.52c-.21-.13-.73-.47-1.48-.34 0 0 .69.64.58.9 0 0-.1.55-.7.49 0 0-2.34-.26-4.24 1 0 0-1.33.2-1.43-.08 0 0-.23-.45-.03-.63a.19.19 0 0 1 .05-.03c.28-.15-1.42.23-1.03 1.04.39.82 1.28 1.12 2.05 1.05h.12v-.02s.56-.03 0 .01c.05.13 2.17 4.78 3.54 4.31 1.4-.47 1.57-4.85 1.42-5.33l-.07-.19s-.05-.16 0 0c.03 0 3.02-1.1 1.22-2.18zm-2.87 6.05c-1 .2-2.22-2.94-2.1-3.03 1.32-1.03 2.3-.89 2.57-.82-.16-.2.09.02.09.02l-.09-.02c.18.22.54 3.66-.47 3.85z' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3E %3Cpath stroke-width='1.61' d='M626.1 274.92c0-.38-.02-.75-.11-1.1a2.35 2.35 0 0 0-.44-.8 4.04 4.04 0 0 0-.9-.85c-.55-.34-1.11-.08-1.08.58.03.66.6 1.2 1.13 1.52.44.26.91.47 1.4.65 1.67.6 3.31.94 4.26 1.55.4.25.76.51 1.2.69a2.4 2.4 0 0 0 2.1-.09c.46-.27 1.15-.97.63-1.5-.6-.59-1.64-.38-2.36-.11-.56.21-1.17.55-1.64.9.27.58-.1 1.18-.23 1.83-.16.5-.32 1.01-.31 1.55.01.72 1.08 2.26 1.53.98.26-.74.13-1.85-.63-2.25-.2-.1-.39-.2-.59-.28-1.46-.6-2.97-.86-4.26-1.44a3.76 3.76 0 0 0-1.55-.3c-.45.03-.9.2-1.1.62-.17.32-.36.73-.15 1.07.43.7 1.6.06 2.06-.28.35-.26.58-.67.74-1.1a6 6 0 0 0 .3-1.84z' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3E %3Cpath d='M645.98 282.55s-1.35-.7-2.25.73c0 0-3.35-.37-1.22-5.5.06-.14-2.16.92-1.69 4.2 0 0 .43 2.75 3.6 4.01 0 0 2.65.58 2.55-1.99 0 0-.13-1.24-.99-1.45zm-.77 2.25c-.32 0-.58-.27-.58-.6s.26-.6.58-.6c.32 0 .58.27.58.6 0 .33-.26.6-.58.6z' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3E %3Cpath d='M644.19 281.61s1.46.43 2.06-1.15c0 0 3.37-.3 2.27 5.16-.03.15 1.94-1.33.84-4.45 0 0-.96-2.62-4.3-3.24 0 0-2.72-.05-2.12 2.44 0 0 .37 1.2 1.25 1.24zm.32-2.35c.3-.07.62.15.68.47a.59.59 0 0 1-.45.7.59.59 0 0 1-.68-.47.59.59 0 0 1 .45-.7z' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3E %3Cpath fill='%23fd0' d='M672.31 408.85l-1.09-2.35s-3.38.25-4.95 3.21c0 0-2.17-2.6-5.91-1.11l-.12 3.45s2.54-3.57 5.19-1.1c0 0-1.2 5.17 1.81 4.93 3.02-.25.97-4.57.36-4.81l-.6-.25s1.69-2.96 5.31-1.97m-4.97 4.18c.18.72.1 1.37-.2 1.45-.29.07-.67-.45-.85-1.18-.18-.73-.09-1.38.2-1.45s.67.45.85 1.18M692.34 400.13c-.25-.15-.83-.55-1.7-.4 0 0 .8.75.67 1.06 0 0-.12.65-.81.57 0 0-2.67-.3-4.86 1.18 0 0-1.52.22-1.64-.1 0 0-.26-.52-.03-.74a.22.22 0 0 1 .05-.04c.32-.17-1.61.28-1.17 1.23.44.95 1.47 1.3 2.35 1.23l.13-.01v-.02s.65-.04 0 .02c.07.15 2.5 5.59 4.07 5.04 1.6-.55 1.79-5.68 1.62-6.24l-.08-.22s-.05-.19 0 0c.03-.01 3.46-1.3 1.4-2.56m-3.29 7.1c-1.15.22-2.54-3.45-2.4-3.56 1.5-1.2 2.62-1.04 2.94-.96-.19-.24.1.03.1.03l-.1-.03c.2.26.61 4.29-.54 4.51' stroke='none'/%3E %3Cpath stroke='%23fd0' d='M626.1 274.92c0-.38-.02-.75-.11-1.1a2.35 2.35 0 0 0-.44-.8 4.04 4.04 0 0 0-.9-.85c-.55-.34-1.11-.08-1.08.58.03.66.6 1.2 1.13 1.52.44.26.91.47 1.4.65 1.67.6 3.31.94 4.26 1.55.4.25.76.51 1.2.69a2.4 2.4 0 0 0 2.1-.09c.46-.27 1.15-.97.63-1.5-.6-.59-1.64-.38-2.36-.11-.56.21-1.17.55-1.64.9.27.58-.1 1.18-.23 1.83-.16.5-.32 1.01-.31 1.55.01.72 1.08 2.26 1.53.98.26-.74.13-1.85-.63-2.25-.2-.1-.39-.2-.59-.28-1.46-.6-2.97-.86-4.26-1.44a3.76 3.76 0 0 0-1.55-.3c-.45.03-.9.2-1.1.62-.17.32-.36.73-.15 1.07.43.7 1.6.06 2.06-.28.35-.26.58-.67.74-1.1a6 6 0 0 0 .3-1.84z' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3E %3Cpath fill='%23fd0' d='M773.7 413.05s-1.54-.83-2.57.85c0 0-3.85-.42-1.4-6.44.07-.17-2.47 1.08-1.93 4.91 0 0 .49 3.24 4.12 4.71 0 0 3.04.68 2.92-2.33 0 0-.15-1.45-1.13-1.7m-.88 2.63c-.37 0-.67-.31-.67-.7s.3-.7.67-.7c.36 0 .66.31.66.7 0 .39-.3.7-.66.7' stroke='none'/%3E %3Cpath fill='%23fd0' d='M771.66 411.95s1.67.5 2.36-1.35c0 0 3.86-.35 2.6 6.04-.04.18 2.22-1.55.96-5.2 0 0-1.1-3.08-4.94-3.8 0 0-3.1-.06-2.41 2.86 0 0 .41 1.4 1.43 1.45m.36-2.76c.36-.07.7.18.78.56.08.38-.15.75-.51.82-.36.07-.71-.18-.79-.56-.07-.38.16-.74.52-.82' stroke='none'/%3E %3C/g%3E %3Cg%3E %3Cpath fill='%23fd0' d='M716.54 549.26l.09-3.64s16.09.7 23.83.62v2.84s-21.14.36-23.92.18'/%3E %3Cpath fill='%235c5342' d='M744.34 543.92h6.45v1.66h-6.45z'/%3E %3Cpath d='M753.97 544.68v3.4h-.35v-3.4L750 525.76l.2-.05 3.64 18.78 3.09-6.28.18.03M740.68 545.91h.35v2.3h-.35zM741.29 545.91h.35v2.3h-.35zM742.76 545.91h.35v2.3h-.35zM743.59 545.91h.35v2.3h-.35zM744.84 545.91h.35v2.3h-.35zM746.12 545.91h.35v2.3h-.35zM746.95 545.91h.35v2.3h-.35zM747.99 545.91h.35v2.3h-.35zM749.03 545.91h.35v2.3h-.35zM750.02 545.91h.35v2.3h-.35zM751.42 545.91h.35v2.3h-.35zM755.06 545.68h.35v2.3h-.35zM756.01 542.28h.35v5.34h-.35zM751.98 543.24h.35v4.97h-.35zM741.99 547.59h.48v.62h-.48z'/%3E %3Cpath d='M752.88 547.84l.03-.02c.25-.17 2.09-1.45 2.6-1.44.53.01 1.13-.03 1.13-.03v.38l-1.17.04-2.03 1.06M754.73 548l.03-.02c.24-.18 2.07-1.48 2.57-1.48.54 0 1.14-.05 1.14-.05v.38l-1.16.06-2.01 1.09M750.75 543.04h1.6v.29h-1.6z'/%3E %3Cpath d='M752.37 541.74c-.2.03-.36.62-.34 1.32.02.7.2 1.25.41 1.22.2-.02.36-.62.34-1.32-.02-.7-.2-1.25-.41-1.22m.06 2.17c-.15.02-.28-.37-.3-.86 0-.5.1-.92.25-.94.15-.02.28.37.29.87.01.5-.1.91-.24.93M746.04 528.22l-9.02.39v-.23l9.4-.34'/%3E %3Cpath d='M737.14 522.23l4.04 23.16-3.74-12.84.04-.65 2.8 9.78-3.18-17.96.04-1.49z'/%3E %3Cpath d='M739.27 545.55l-1.8-14.64-.15.57 1.57 13.87.3.11M738.15 545.43s-.04-5.31-.67-6.76l-.08.42.6 6.26c.04.46.15.08.15.08M737.44 533.88l-1.5 11.43.26.15 1.35-11.23M737.06 528.27l-1.94 16.01.19.27 1.71-15.94'/%3E %3Cpath d='M737.36 532.4l-12.46 8.29-.15-.23 12.53-8.3v.16'/%3E %3Cpath fill='%23858d8d' d='M744.7 542.83h6.45l-.35 1.09h-6.45z'/%3E %3Cpath fill='%23755338' d='M755.24 545.24l.02-.12 1.9-8.03.25.05-1.9 7.9'/%3E %3Cpath fill='%23fd0' d='M761.19 540.61c-.82.3-1.87-1.45-2.36-2.3-.48-.83-1.72-.53-1.72-.53l-.31 1.06c.24-.05 1.23-.19 1.66.55.49.84 1.53 2.6 2.36 2.29l-.46 1.33h.01l.82-2.4z'/%3E %3Cpath fill='%23034ea2' d='M758.46 539.39c-.42-.73-1.42-.6-1.66-.55l-.17.57c.31-.06 1.2-.14 1.6.55.5.84 1.54 2.6 2.36 2.3l-.25.74.02.02.46-1.34c-.83.3-1.87-1.45-2.36-2.29'/%3E %3Cpath fill='%23ed1c24' d='M756.52 539.77h.07c1.34.04 1.72 1.03 1.98 1.68.24.6 1.56 1.42 1.76 1.55l.26-.74c-.82.3-1.87-1.46-2.36-2.3-.4-.69-1.3-.6-1.6-.56l-.1.31s-.03.06-.01.06'/%3E %3Cg fill='%23a37853'%3E %3Cpath d='M737.46 533.62l13.1-8v-.17h-.28l-12.85 7.66v.37'/%3E %3Cpath d='M737.6 528.53l.26 16.77-.5.2-.43-16.23.06-12.98.14.09.11 12z'/%3E %3Cpath d='M736.25 545.64c0 .22.16.4.35.4l19.45-.29c.2 0 .35-.18.34-.4 0-.23-.16-.4-.35-.4l-19.45.28c-.2 0-.34.19-.34.41'/%3E %3C/g%3E %3Cg stroke='%23000' stroke-width='.13'%3E %3Cpath fill='%23616264' d='M727.71 541.95s.8.04 2.43.3c0 0-1.8.24-2.77.55-.98.32-2.87 2.18-3.27 2.54-.4.35-.58.53-.58.53l-3.06-.02s1.42-1.83 2.03-2.27c.6-.45 1.81-1.26 2.4-1.36.6-.1 1.7-.36 2.82-.3' stroke='none'/%3E %3Cpath fill='%23a3a5a8' d='M736.66 546.21a6.06 6.06 0 0 0-5.93-3.95h-.1c-4.53.19-4.76 2.05-6.47 3.61h-.32l-.04.06s9.32.28 12.86.28z'/%3E %3Cg fill='%23797a7d' stroke='none'%3E %3Cpath d='M735.41 545.57a.1.1 0 0 1-.14-.05.11.11 0 0 1 .05-.15.1.1 0 0 1 .14.06.1.1 0 0 1-.05.14M735.17 545.08a.11.11 0 0 1-.15-.03.1.1 0 0 1 .03-.15.11.11 0 0 1 .15.03.1.1 0 0 1-.03.15M734.87 544.63c-.05.03-.11.03-.14-.02-.04-.05-.04-.11.01-.15.05-.04.12-.04.15.01.04.05.03.12-.02.16M734.52 544.22a.1.1 0 0 1-.15 0 .12.12 0 0 1 0-.16.1.1 0 0 1 .15 0c.05.05.04.12 0 .16M734.14 543.84a.11.11 0 0 1-.15.02c-.05-.04-.05-.1-.02-.15s.1-.06.15-.02c.05.04.06.1.02.15M733.73 543.51c-.03.05-.1.06-.15.03a.1.1 0 0 1-.03-.14c.03-.05.1-.07.15-.04.06.03.06.1.03.15M733.27 543.23c-.03.05-.1.07-.14.04a.12.12 0 0 1-.05-.15.1.1 0 0 1 .15-.04c.05.03.07.1.04.15M732.79 543a.11.11 0 0 1-.14.06.11.11 0 0 1-.06-.14.1.1 0 0 1 .14-.06.1.1 0 0 1 .06.14M732.29 542.8a.11.11 0 0 1-.13.08.1.1 0 0 1-.08-.13c.02-.05.08-.1.13-.08.06.02.1.07.08.13M731.77 542.69c-.01.06-.06.1-.12.09a.12.12 0 0 1-.09-.13c.01-.06.06-.1.12-.09.06.01.1.07.09.13M731.24 542.62c0 .06-.05.1-.11.1a.1.1 0 0 1-.1-.1c0-.07.05-.12.11-.11.06 0 .1.05.1.11M730.71 542.6c0 .06-.04.1-.1.1a.1.1 0 0 1-.11-.1c0-.05.04-.1.1-.11.06 0 .1.05.11.11M730.18 542.64c0 .06-.04.11-.1.12a.1.1 0 0 1-.11-.1.1.1 0 0 1 .1-.12.1.1 0 0 1 .11.1M729.65 542.69c0 .06-.03.11-.1.12a.11.11 0 0 1-.11-.1.1.1 0 0 1 .09-.12c.06 0 .11.04.12.1M729.13 542.77c.01.06-.02.12-.08.13a.1.1 0 0 1-.13-.08.11.11 0 0 1 .09-.13.1.1 0 0 1 .12.08M728.61 542.89a.1.1 0 0 1-.07.13c-.06.01-.12-.03-.14-.08a.1.1 0 0 1 .08-.13c.06-.01.11.02.13.08M728.11 543.06c.02.06 0 .12-.06.14a.1.1 0 0 1-.14-.06.1.1 0 0 1 .06-.14.1.1 0 0 1 .14.06M727.62 543.27c.03.06.01.12-.04.15a.1.1 0 0 1-.14-.03.11.11 0 0 1 .04-.15.1.1 0 0 1 .14.03M727.17 543.56c.03.05.02.12-.02.15-.05.03-.11.03-.15-.02-.04-.05-.03-.12.02-.16.05-.03.12-.02.15.03M726.76 543.91a.1.1 0 0 1 0 .15.11.11 0 0 1-.16 0 .1.1 0 0 1 0-.16.1.1 0 0 1 .16.01M726.39 544.29c.04.04.05.1 0 .15a.1.1 0 0 1-.14.01.11.11 0 0 1-.01-.15.1.1 0 0 1 .15 0M726.03 544.7c.05.04.05.1.01.15a.1.1 0 0 1-.15.02.11.11 0 0 1 0-.16.1.1 0 0 1 .14-.01M725.68 545.1a.1.1 0 0 1 0 .15.1.1 0 0 1-.15 0 .11.11 0 0 1 0-.15.1.1 0 0 1 .15 0'/%3E %3C/g%3E %3Cpath fill='%23939598' d='M729.55 542.2c-4.65.17-4.85 2.06-6.59 3.63l.88.03.32.01c1.71-1.56 1.93-3.42 6.48-3.6a6.23 6.23 0 0 0-1.09-.07z'/%3E %3Cg fill='%23442c13' stroke-width='.12'%3E %3Cpath d='M596.42 395.94l.13-2.25.52-.03v.62l3.72-.1-.81 2.09-3.53-.13-.06-.3' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3E %3Cpath d='M598.22 389.02l.1 5.58-.46.03.23-5.61zM600.28 388.69l.1 5.68-.33.06.03-5.74zM602.59 393.2l-.23-5.42-.13.04.1 5.41zM605.91 392.63l.99-4.98-.1.07-1.2 4.9z' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3E %3Cpath d='M602.23 387.81l-2.25 6.5-.36-.07 2.35-6.46zM602.75 387.91l.56 4.9.29-.04-.62-4.86z' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3E %3C/g%3E %3Cpath fill='%23a48b58' stroke-width='.12' d='M606.8 387.71h-5.1l-3.61 1.3 4.27.14z' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3E %3Cpath fill='%23a37853' stroke-width='.12' d='M597.96 389.15l3.85-1.27 5.1-.1.02-.36-5.22.1-3.72 1.2z' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3E %3Cpath d='M722.38 542.35c0-.8.53-1.45 1.2-1.45.57 0 1.05.5 1.16 1.16l.25-.04c-.13-.8-.71-1.41-1.42-1.41-.8 0-1.44.78-1.44 1.74 0 .28.06.54.16.78l.22-.15c-.08-.19-.13-.4-.13-.63z'/%3E %3Cpath fill='%23939598' d='M721.11 545.75c1.9-1.6 1.96-3.58 6.67-3.78a6.25 6.25 0 0 0-1.09-.06c-4.8.17-4.85 2.18-6.76 3.78a.6.6 0 0 0-.1.13l1.19.03.09-.1z'/%3E %3C/g%3E %3Cpath fill='%23fd0' d='M743.67 548.94v-.25s12.6.02 12.66-.71c.08-.75-6.1-.45-15.75.05'/%3E %3Cpath fill='%23696161' opacity='.75' d='M708.02 530.86c-.75.09-1.3-.77-2 .34l-.06.07c-.48.56-.73 1.34-.43 1.93.17.35 1 .66 1.37.71.92.13 1.66-.63 1.75-1.52.43.54 1.68.56 2.31.6 1.1.06 1.4-.14 1.58-1.32.65.93 1.17 1 2.27.8 1.27-.22 2.74-.37 3.67-1.33.35.55.86.85 1.48.85.54.01 1.25-.09 1.75-.28.42-.16.89-.75 1.31-.83.33.5.98.3 1.41.39.81.5 1.69.82 2.99.11.34-.19 1.56.27 1.98.07.3-.15.36-.44.6-.6.54.42 1.4-.01 1.97-.16.45.02 1.08-.05 1.25-.6.79-.49.56-.9.31-1.12-1.26-.52-2.13-.52-3.3.34-.4-.1-.59-.1-.87.42-.5-.78-1.39-1-2.3-.44-.78-.45-1.18-.12-1.81-.1-1.26-.96-3.5-.83-5.06.1-1.77-.84-2.31-.36-3.48.53-.66-.3-1.47-.11-2.2-.06-.64.05-.98.89-1.55.6-1.27-.61-1.88.34-2.83.3-1.04-.91-2.1.2-2.1.2'/%3E %3Cg%3E %3Cpath fill='%2384848a' d='M707.99 548.97c0 .61-.48 1.1-1.08 1.1-.6 0-1.08-.5-1.08-1.1v-13.59c0-.6.48-1.1 1.08-1.1.6 0 1.08.5 1.08 1.1v13.59z'/%3E %3Cpath fill='%23453717' d='M717.07 546.5s-.7.69-.87.75c-.17.05-1.01.42-1.18.42-.17 0-.53.03-.92.03h-.76l-.68-.05.28 1.34 3.76.09.37-2.58z'/%3E %3Cpath fill='%236a5e46' d='M713 546.61h-1.4l-.02.14h-1.22l-.27 2.26 2.85-.02'/%3E %3Cg fill='%23453717'%3E %3Cpath d='M710.59 548.62c0 .03-.02.06-.06.06a.06.06 0 0 1-.05-.06v-1.17a.06.06 0 1 1 .11 0v1.17zM710.9 548.62c0 .03-.02.06-.06.06a.06.06 0 0 1-.05-.06v-1.17a.06.06 0 1 1 .11 0v1.17zM711.23 548.62c0 .03-.02.06-.06.06a.06.06 0 0 1-.05-.06v-1.17c0-.04.02-.06.05-.06s.06.02.06.06v1.17zM711.74 548.62a.06.06 0 1 1-.11 0v-1.17c0-.04.02-.06.05-.06.03 0 .06.02.06.06v1.17zM712.21 548.62c0 .03-.02.06-.06.06a.06.06 0 0 1-.05-.06v-1.17c0-.04.02-.06.05-.06s.06.02.06.06v1.17zM712.61 548.62c0 .03-.02.06-.06.06s-.05-.03-.05-.06v-1.17c0-.04.02-.06.05-.06.04 0 .06.02.06.06v1.17z'/%3E %3C/g%3E %3Cpath fill='%232f2311' d='M709.66 548.93v-.12l.06-2.6-.28.08-.03 1.33-.28.1-.11-.3h-.68l-.23.1v1.23zM700.94 547.33l-.37.03v.2h-.42l-.03-.41h-.36v-.32l-.45-.02-.08-1.09H699v-1.49l-.31-.03.1 3.18-.18.03v.35h.2l-.09 1.05 4.27.24-.12-1.72h-.4v.23l-1.1-.12-.07.4h-.28z'/%3E %3Cpath fill='%23866d46' d='M703.75 547.72l-.91-.04.15 1.25.78-.08z'/%3E %3Cpath fill='%23acacad' d='M708.09 539.94a1.7 1.7 0 0 0-1.19-.44c-.48 0-.91.17-1.18.44a.57.57 0 0 0-.02.14c0 .05 0 .1.02.14.27-.27.7-.44 1.18-.44.5 0 .92.17 1.19.44l.02-.14-.02-.14'/%3E %3Cpath fill='%23866d46' d='M707.28 547.33l-.04-.38.27-.34-.68-.12-.04.36-.35.02-.06.2h-.25l-.17.06-.12.37-.2-.26.09 1.6 2.22-.05v-1.44'/%3E %3Cpath fill='%232f2311' d='M703.5 548.93l2.4-.08-.08-1.23-2.25.02'/%3E %3Cpath fill='%23453717' d='M698.38 548.94l.04-1.76-.49.08h-.34l-.26-.15-.04.11-1.23.04-.15-.38-.75.07-.04.27-.93.04-.15-.35h-.26v-1.9l-.41.03-.19 2.3-.37.03v-.3l-.49-.04-.07.57-.57-.08.04-.53h-.52l-.08.61-3.17.08.15-2.76-.53-.07.04 2.75s-2.06-.69-2.4-1.03l1.24 1.49s4.11.8 11.93.88'/%3E %3Cpath fill='%23895f33' d='M685.52 547.95s-.67-.2-5.9-1.8c-5.25-1.6-7.75-2.75-8.24-2.9-.49-.15-1.2 0 1.01 1 2.2.99 10.51 3.85 11.9 3.82 1.38-.04 1.5.07 2.43-.12.93-.2-1.2 0-1.2 0'/%3E %3Cpath fill='%23fff' d='M708.02 530.86c-.76.09-1.3-.77-2 .35l-.06.06c-.48.56-.73 1.34-.44 1.93.18.35 1 .66 1.38.72.91.12 1.66-.64 1.74-1.53.44.54 1.69.56 2.32.6 1.1.06 1.4-.14 1.58-1.32.65.93 1.16 1 2.27.8 1.27-.21 2.74-.37 3.67-1.33.35.55.86.85 1.48.86a5.2 5.2 0 0 0 1.75-.29c.42-.16.88-.75 1.31-.83.33.5.98.3 1.41.4.8.5 1.69.8 2.99.1.34-.18 1.55.27 1.98.07.3-.15.36-.44.6-.6.54.42 1.4 0 1.97-.16.45.03 1.08-.05 1.25-.6.79-.49.56-.9.3-1.12-1.25-.51-2.12-.51-3.3.34-.39-.1-.58-.09-.86.42-.5-.78-1.39-1-2.3-.44-.78-.45-1.19-.12-1.81-.1-1.26-.96-3.5-.83-5.07.1-1.76-.84-2.3-.36-3.47.53-.66-.3-1.47-.11-2.2-.05-.65.05-.98.88-1.56.6-1.26-.62-1.87.33-2.82.29-1.04-.91-2.11.2-2.11.2'/%3E %3C/g%3E %3Cg%3E %3Cpath fill='%23ffe600' d='M740.68 548.21l.61.77H716.6l-18.03-.23s-7.85-.2-11.7-.58c-3.86-.38-8.24-1.49-8.24-1.49.04 1.19.87 1.8 1.54 2.41.09.08.25.17.46.25 1.45.59 5.41 1.32 6.68 1.55 1.46.27 6.66.57 10.18.53 3.51-.03 39.24-.19 39.24-.19v-.34c1.38.23 18.93-1.07 18.93-1.07.05-.08.1-.21.17-.37.18-.44.38-1.1.47-1.36l.03-.12-15.65.24z'/%3E %3Cpath d='M683.35 552.03l-8.83-7.03.68.23 8.15 6.5z'/%3E %3Ccircle transform='matrix(1.14637 0 0 1.17117 33.18 82.14)' fill='%23565759' stroke='%23000' stroke-width='.23' cx='567.74' cy='398.67' r='.48'/%3E %3Cpath fill='%23565759' stroke='%23000' stroke-width='.13' d='M684.74 550.52l.06.2c-.36.4-.67.21-.67.21v-1.58a.22.22 0 0 0 .14-.2c0-.13-.1-.23-.22-.23-.11 0-.21.1-.21.22 0 .09.05.16.12.2v1.6s-.32.19-.68-.23l.06-.2-.48.07.19.44.08-.13s.5.43.89.43h.04c.38 0 .9-.43.9-.43l.08.13.19-.44-.49-.06z'/%3E %3Cpath d='M686 549.04c0-.18.15-.33.33-.33.17 0 .32.15.32.33 0 .18-.15.33-.32.33a.33.33 0 0 1-.33-.33M689.02 549.65c0-.18.15-.33.32-.33.18 0 .33.15.33.33 0 .18-.15.33-.33.33a.33.33 0 0 1-.32-.33M692 549.76c0-.18.15-.33.32-.33.18 0 .33.15.33.33 0 .18-.15.33-.33.33a.33.33 0 0 1-.32-.33M695.42 549.71c0-.18.15-.33.33-.33.18 0 .32.15.32.33 0 .18-.14.33-.32.33a.33.33 0 0 1-.33-.33M698.73 549.76c0-.18.15-.33.33-.33.18 0 .32.15.32.33 0 .18-.14.33-.32.33a.33.33 0 0 1-.33-.33M701.82 549.71c0-.18.15-.33.32-.33.18 0 .33.15.33.33 0 .18-.15.33-.33.33a.33.33 0 0 1-.32-.33M710.57 550.05c0-.18.15-.33.32-.33.18 0 .33.15.33.33 0 .18-.15.33-.33.33a.33.33 0 0 1-.32-.33M719.55 550.28c0-.18.15-.33.33-.33.18 0 .32.15.32.33 0 .18-.14.33-.32.33a.33.33 0 0 1-.33-.33M722.63 550.39c0-.18.15-.33.33-.33.18 0 .32.15.32.33 0 .18-.14.33-.32.33a.33.33 0 0 1-.33-.33M725.33 550.39c0-.18.15-.33.33-.33.18 0 .32.15.32.33 0 .18-.14.33-.32.33a.33.33 0 0 1-.33-.33M728.08 550.39c0-.18.15-.33.33-.33.18 0 .32.15.32.33 0 .18-.14.33-.32.33a.33.33 0 0 1-.33-.33M730.71 550.34c0-.18.15-.33.33-.33.17 0 .32.15.32.33s-.15.33-.32.33a.33.33 0 0 1-.33-.33M733.24 550.22c0-.18.15-.33.33-.33s.32.15.32.33c0 .18-.14.33-.32.33s-.33-.14-.33-.33M735.88 550.22c0-.18.15-.33.33-.33.18 0 .32.15.32.33 0 .18-.14.33-.32.33a.33.33 0 0 1-.33-.33M704.79 549.76c0-.18.15-.33.33-.33.18 0 .32.15.32.33 0 .18-.14.33-.32.33a.33.33 0 0 1-.33-.33M707.6 549.93c0-.18.15-.33.33-.33.17 0 .32.15.32.33 0 .18-.15.33-.32.33a.33.33 0 0 1-.33-.33'/%3E %3Cg fill='none' stroke-width='.23' stroke='%23000' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'%3E %3Ccircle cx='622.02' cy='399.23' r='.35'/%3E %3Ccircle cx='624.18' cy='399.04' r='.35'/%3E %3Ccircle cx='626.28' cy='398.89' r='.35'/%3E %3C/g%3E %3Cpath fill='%23ed1c24' d='M682.56 551.38l.5.4-.09.31a1 1 0 0 0 .22.29l.09.09h.03c1.05 1.03 3.88 2.59 3.88 2.59l12.15.35h.22s55.16-.37 55.16-.66-.47-2.56-.47-2.56-.29-.23-.59-.16c-.73.17-4.72.52-7.57.81-.94.1-1.79.18-2.31.25-2.09.31-.28 0-.28 0s-21.54.24-24.53.16c-2.99-.07-20.38.09-20.38.09s-10.91-.78-11.81-.78-2.69-.76-3.44-.84a2.55 2.55 0 0 1-.78-.34z'/%3E %3Cpath fill='%23034ea2' d='M755.83 549.45c-.06.16-.12.3-.17.37 0 0-17.55 1.3-18.93 1.07v.34s-35.73.16-39.24.2a82.1 82.1 0 0 1-10.18-.54c-1.27-.23-5.23-.96-6.67-1.54l-.73.09s1.57 1.3 2.64 1.94c.34.2.62.33.8.35.74.08 2.54.84 3.44.84s11.82.77 11.82.77 17.36-.16 20.35-.08c3 .08 24.54-.15 24.54-.15s-1.8.3.3 0 8.9-.84 9.87-1.07c.3-.08.65-.36.97-.72.68-.77 1.28-1.88 1.28-1.88l-.09.01'/%3E %3Cpath fill='%23fd0' d='M716.54 549.26l.09-3.64s16.09.7 23.83.62v2.84s-21.14.36-23.92.18'/%3E %3Cg fill='%239b7e39'%3E %3Cpath d='M730.02 554.92l.39.29.42-.29-.17-2.78-.53-.02-.11 2.8zM729.34 552.14l-.83 2.47.28.38.49-.15.62-2.72h-.1l-.46.02M727.16 553.87l.17.46h.5l1.2-2.18-.7.04-1.17 1.68zM726.12 552.82l.04.48.49.14 1.23-1.23-1.05.03-.71.58zM731.86 554.7l.46.13.3-.41-.96-2.24-.6-.02.8 2.54zM732.96 554.21l.47.02.2-.47-1.13-1.55-.72-.03 1.18 2.03zM734.1 553.31l.47-.1.07-.52-.55-.43-1.1-.03 1.11 1.08z'/%3E %3C/g%3E %3C/g%3E %3Cg%3E %3Cg fill='none' stroke='%23d0c9ce' stroke-width='.13'%3E %3Cpath fill='%23fff' stroke='%23999b9e' d='M716.79 523.61l.12.1s.12-.2.24-.2.43.15.43.15l.06-.2.54.15-.03-.26s.36.05.35.02l-.04-.22.45.03-.03-.2s.61.08.6.04l-.13-.24s.5.05.7.05c.2 0 .18.06.18.06v-.16l.8-.02-.13-.19.6-.01-.26-.28s1.2.4 1.57.04c0 0-.55.04-1.16-.16-.62-.2-1.2-.26-1.42-.32a8.02 8.02 0 0 1-1.7-.66h.21s-1.34-.51-2.03-.62c0 0-.87-.18-1.28.12 0 0-.19.24-.34.3-.15.07-.48.29-.5.32-.03.03-.1-.07-.5.17 0 0-.1.04-.12.03 0 0-.77-.39-1.68-.03l-.07.04s-.37-.17-.66-.17c-.03 0-.34-.18-.4-.21l-.02-.01s-.37-.77-1.06-.7c-.68.06-1 .22-1.1.25-.1.02-.8.27-.94.3-.14.03-.45.17-.45.17s-.62.27-.76.3c-.15.02-.99.21-1.02.21-.04 0 .08.04.1.04 0 0-.64.2-1.02.24-.36.05-1.5.23-1.6.2-.08-.02-.03 0-.03 0s.33.17 1.27.08l.37-.01h.04l-.41.2c.02-.01.99-.01.8.03-.07.02-.3.18-.3.18l.93.01-.13.13s.86.04.95.02l-.15.18s.44-.02.74-.1l-.15.22.63-.03-.23.23s.4.06.5.04l.05-.01-.17.14h.6l-.06.12.53-.1.14.16s.42-.19.47-.18l.27.2s.27-.23.3-.24h.04s.1.22.21.28c0 0 .2-.14.26-.13.05 0 .15.15.15.15l.14-.13.35.13s.07-.2.17-.17c.1.02.52.79 1.46.85 1.18.07 1.65-.59 1.65-.59l.35-.22.05.21.37-.17v.1s.47-.2.48-.28l.17.24s.3-.2.33-.19c.05.01.1.14.34.18'/%3E %3Cpath d='M713.3 523.5l.06.08M713.12 523.57c0 .04.02.08.04.11'/%3E %3Cpath stroke='%23fff' d='M706.23 522.25a.15.15 0 0 1-.1.05M705.93 522.31c-.05.02-.09.06-.15.07'/%3E %3Cpath d='M720.25 522.73s-1.37-.35-1.83-.83c0 0 .04-.09-.02-.16s-.03-.02-.03-.02.24.14.45.12c0 0-.02-.17-.14-.25M719.97 521.74s-.72.03-1.17-.02'/%3E %3Cpath d='M720.57 522.06s-.24 0-.41.04c-.17.03-.7.05-.89-.06-.19-.12-.3-.13-.44-.17M719.34 522.77c-.04 0-1.01-.34-1.33-.72M718.89 522.99s-.67-.13-1.45-.92M718.48 523.17c-.04-.03-1.45-.46-1.5-1.13M718.16 523.36s-.8-.16-1.5-1.19M717.64 523.46s-.82-.63-1.04-1.12M717.16 523.53c-.02-.04-.59-.76-.67-1.23M716.43 523.42s-.3-.9-.19-1.29M715.94 523.38c0-.03-.04-.08.02-.34a.78.78 0 0 0-.05-.51M715.45 523.56c0-.02 0-.31.1-.52.1-.21.14-.41-.01-.65M715.03 523.53s-.06-.2.13-.45l.02-.23s.07.01.05-.04l-.06-.14M714.37 522.05c.08-.07.2-.24.19-.27l-.05-.1.08.1s.04.01.13-.05c.1-.07.2-.07.26-.14.06-.06.1-.12.15-.14.04-.03.12.02.2-.01.07-.03.3-.15.34-.2l.1-.14c.04-.03.1-.12.1-.12s.25.07.42.07l.4-.01c.15 0 .5-.03.64 0l.53.08c.05 0 .2.05.33.07.11.02.31-.04.38-.06'/%3E %3Cpath d='M715.05 522.61c.06.02.2.08.22.13-.05-.12.13-.2.2-.28.07-.09.07-.19.07-.3M715.39 521.98c.21.18.39.38.56.6.02-.13.02-.25.07-.38.03-.06.14-.13.12-.21'/%3E %3Cpath d='M715.78 521.36l.15.34c.05.1.09.22.16.3.06.08.15.14.24.2.07.04.16.11.24.13.06-.05.08-.16.08-.23 0-.08-.1-.2-.05-.27M716.39 521.32c.03.32.22.48.5.65.11.06.33.17.45.15.18-.02.1-.22.1-.32'/%3E %3Cpath d='M716.72 521.41c.08.08.2.12.3.18l.2.2c.04-.03.04-.1.02-.12M717.01 521.26c.02.1.12.25.19.33.1.12.22.23.36.3.08.06.23.13.33.13.14.01.13-.13.08-.21.08.13.33.08.45.12'/%3E %3Cpath d='M715.74 521.37c.24 0 .46-.07.7-.1.16-.02.34-.04.5-.02.15.02.29.08.43.08.04-.08-.04-.2-.09-.26M717.44 521.12c.12.1.24.19.4.24.06.03.13.03.19.06.05.02.08.06.12.1M717.56 521.41c.13.04.26.08.3.22M714.87 522.73c-.06.09-.1.18-.18.26M715.4 522.74c0 .06.02.12 0 .17M715.38 523.17c-.02.08-.06.17-.05.26.02 0 .02-.01.03-.02M715.87 523.18l-.03.12M715.6 522.3c.05.07.07.14.12.2.04.06.08.09.09.15M716.14 522.54a.2.2 0 0 1-.05-.1M716.1 522.32l.06.12M716.11 522.18l.04.08M716.31 523.31l.04.05M716.54 523.05c.04.06.04.13.06.2M716.86 523.41c-.04-.05-.02-.11-.04-.17M717.63 523.25c.04.04.08.07.14.08M717.93 523.41c.04.04.16.06.17 0M717.91 523c.04.06.1.11.17.14M718.83 522.68c.1-.01.18.07.28.08M718.86 522.27c.03.05.16.2.23.2M719.43 522.56c.02.06.19.06.24.09M717.15 520.76l.2.1c.05.02.13.06.19.03M716.92 520.76c.11 0 .19.09.3.09a.46.46 0 0 0-.12-.05M716.67 520.78c.12.03.12.04.2.12v-.03M716.43 520.72c.05.05.13.07.16.14M716.3 520.73c0 .04.03.07.07.09M716 520.8a.17.17 0 0 1-.08-.1M716.11 521.45c.19.1.23.3.28.47M718.7 521.38c.15.03.21.13.33.2 0-.03-.01-.02-.03-.03M718.24 521.29c.12.05.25.05.34.13l.11.12.02-.04M717.34 522.2c.07.05.15.13.2.2.03.04.05.11.09.14M714.95 521.66c.08.07.26.08.24.21 0 .05-.06.08-.07.13 0 .05.03.1.04.14M714.88 521.86c.03.06.1.1.04.17l.01-.02M715.35 521.5c.12.09.25.14.35.25.05.05.1.2.16.21M715.19 521.16c.18.06.2-.1.32-.17M715.58 521.09c.07-.07.04-.23.15-.26M715.4 520.85c.12-.1.16-.23.34-.25M714.21 521.58c.07.03.14.07.13.15M714.16 521.73c.02.03.05.06.05.1a.25.25 0 0 1-.04-.03M713.95 521.65l.06.08c.03.03.02.05.03.04M714.36 522.18c-.03.08 0 .17 0 .23M714.01 523.45c.02.04.05.24-.03.22M711.49 522.3c.06 0 .06-.05.1-.07.05-.03.1-.03.16-.03M711.78 522.47c.02.03.02.06 0 .06M711.62 522.49v.05M711.5 522.48l-.01.06M712.08 521.56a.92.92 0 0 0-.12.25h.03M712.25 521.65a.22.22 0 0 0-.05.15M712.53 521.4l-.16.11M711.49 521.82c-.15-.05-.18-.1-.19-.22-.12 0-.3-.19-.2-.3-.04.21-.3.13-.43.06a1 1 0 0 1-.45-.46c-.05.09-.13.08-.24.08-.21 0-.42.03-.64.04-.23.02-.45-.07-.68-.06-.2 0-.36.1-.55.13l-.5.01M711.71 521.48c-.1.02-.22.01-.3.08.02.01 0 .02 0 .03M705.85 521.64c.27.01.54.07.81.06.14 0 .27-.03.4-.05.12-.02.26-.03.36-.08M705.95 522.57c.24-.01.5-.1.74-.17.26-.06.52-.13.75-.26a.45.45 0 0 0 .23-.24c.04-.1.11-.2.12-.31M706.75 522.74c.12-.03.23-.17.34-.23.11-.07.24-.1.37-.14.27-.09.52-.23.71-.42M707.33 522.84c.1-.1.26-.11.39-.17a2.74 2.74 0 0 0 .94-.8M707.85 522.99l.8-.4c.13-.08.24-.17.36-.28.09-.08.13-.22.22-.3M708.17 523.26c.28-.17.57-.35.84-.55.23-.18.5-.3.62-.58M708.58 523.42c.14-.25.38-.45.62-.62.19-.13.37-.28.39-.51M709.08 523.44c0-.09.09-.18.14-.25l.23-.31c.08-.13.13-.26.19-.4M709.7 523.4c.09-.25.1-.54.13-.8v-.2c0-.1.04-.18.07-.28M710.27 523.33c.02-.06-.02-.11-.02-.17 0-.06.03-.1.04-.15.02-.1 0-.24 0-.34 0-.1-.04-.23-.01-.33.02-.08.12-.13.2-.17M710.75 523.5c-.08-.26-.28-.5-.26-.77 0-.12.01-.29.13-.35M711.02 523.53c.07-.17.07-.47.01-.64M711.56 523.49c-.08-.16-.24-.26-.2-.45.02-.1.08-.17.1-.27'/%3E %3Cpath d='M711.3 522.71a.4.4 0 0 1-.23.16c-.09.02-.2-.02-.27.06-.06-.08-.03-.29-.03-.39 0-.13-.02-.27.03-.4.09-.22.31-.35.56-.39'/%3E %3Cpath d='M711.18 521.61c-.12.18-.37.09-.51.24-.13.14-.15.41-.11.58.04-.04.1-.05.16-.09M710.45 521.28c-.04.12-.17.18-.24.28-.07.09-.09.18-.11.28-.03.1-.04.2 0 .3.04.1.08.18.1.27M710.06 521.06c-.03.21-.32.4-.48.54-.07.07-.13.15-.11.25.02.07.08.12.12.18l.05.14a.56.56 0 0 1 .18-.1c.08-.02.19-.02.24-.08M707.94 521.14c-.2.18-.57.27-.68.52M708.67 521.72c-.07.06-.14.15-.22.2-.1.04-.2.03-.31.03M707.66 521.94c.12-.06.54-.06.56-.22M708.77 522.11c.16-.01.3-.01.38-.15M708.21 521.71c-.02.08-.07.16-.08.23M708.66 521.74c.11.1 0 .3.13.38M709.56 521.2l-.25.27c-.06.05-.15.1-.18.18-.04.1.01.2.03.3M708.94 521.08c.08.08.2 0 .3.02.06 0 .14.03.25.02.09-.01.17-.04.26 0 .05.04.08.1.16.1M709.42 521.86a.93.93 0 0 1-.26.12M708.25 521.53l-.04.11M708.49 521.5c.1-.15.2-.19.34-.26M711 521.08c0 .04-.02.09 0 .12v-.03M710.8 520.92c0 .1.02.12.06.21l-.04-.05M710.68 520.89c-.01.05-.01.12.01.15M710.37 520.73a.5.5 0 0 1 .1-.12M710.33 520.6a.46.46 0 0 1-.14.14M710.15 520.58a.2.2 0 0 1-.13.15M709.94 520.64a.35.35 0 0 1-.16.11M709.63 520.66a.52.52 0 0 1-.14.1M709.36 520.67c-.01.03-.05.05-.09.05M711.39 522.05c.02-.09.18-.1.26-.08M711.2 522.18c.04-.01.07-.05.07-.08M710.12 522.61c0 .1.01.17-.06.26M709.92 523.42v-.1M710.04 523.29c0 .02 0 .05-.02.07M709.87 523.21c0 .02 0 .04-.02.06M709.32 523.42s0-.03.02-.04M709.54 523.29v.06M709.76 522.47c0 .1 0 .26-.1.35M710.25 521.28c-.1.13-.42.24-.4.41M709.35 521.25a.15.15 0 0 1-.07.06M709.6 521.32l-.1.15M710.66 521.59c-.15.05-.29.1-.32.25M708.75 522.2c.02.14-.15.26-.29.3M709.42 522.19c-.05.06-.13.14-.21.16M708.39 522.89c-.02.05-.07.08-.1.11M708.09 523.04c-.04.02-.12.1-.16.07M707.6 522.44c-.02.06-.1.09-.14.12M707.11 522.67l-.24.06'/%3E %3Cpath stroke='%23fff' d='M706.76 522.55c-.03.05-.1.08-.15.09'/%3E %3Cpath d='M707.13 521.42a.8.8 0 0 0-.4.14'/%3E %3Cpath stroke='%23fff' d='M706.03 522.48c-.04.02-.11.06-.16.04M704.9 522.16c.2-.12.48-.17.7-.22.12-.03.21-.05.3-.1.1-.05.18-.11.26-.14'/%3E %3Cpath d='M706.66 522.49h-.14'/%3E %3C/g%3E %3Cpath fill='%232f3b30' stroke='%23fff' stroke-width='.13' d='M711.87 544.25s.26-1.37 1.24-1.63c.98-.27 2.01-1.06 2.01-2.06s-.57-1.58-1.19-1.9c0 0 1.86-1.26 1.86-3.1 0-1.85-1.96-2.85-1.96-2.85s3-1.16 3.2-2.69c.2-1.53-1.34-3.32-1.8-3.84-.47-.53-1.2-.58-1.2-.58l.32.63-.62-.27s.3.87 1.13 1.59c.62.53 1.7 1.63 1.4 2.47-.31.85-3.05 2.22-3.05 2.22v1.15s1.96 1.22 1.91 2.27c-.05 1.06-1.75 2.27-1.75 2.27l-.1 1.05s1.18.8 1.13 1.63c-.05.85-1.3 1.27-1.3 1.27s-1.49.68-1.28 2.21'/%3E %3Cpath fill='%232f3b30' stroke='%23fff' stroke-width='.13' d='M714.47 544.25s-.26-1.37-1.24-1.63c-.98-.27-2.01-1.06-2.01-2.06s.57-1.58 1.19-1.9c0 0-1.86-1.26-1.86-3.1 0-1.85 1.96-2.85 1.96-2.85s-3-1.16-3.2-2.69c-.2-1.53 1.34-3.32 1.8-3.84.47-.53 1.2-.58 1.2-.58l-.32.63.62-.27s-.3.87-1.13 1.59c-.62.53-1.7 1.63-1.4 2.47.31.85 3.05 2.22 3.05 2.22v1.15s-1.96 1.22-1.91 2.27c.05 1.06 1.75 2.27 1.75 2.27l.1 1.05s-1.18.8-1.13 1.63c.05.85 1.3 1.27 1.3 1.27s1.49.68 1.28 2.21'/%3E %3Cpath fill='%2364472d' d='M712.67 520.55h.75v27.9h-.75z'/%3E %3Cpath fill='%2364472d' d='M712.94 520.2h.2v.53h-.2z'/%3E %3Cpath fill='%2364472d' d='M712.32 519.45c0-.42.34-.76.75-.76.4 0 .75.34.75.76s-.34.77-.75.77a.76.76 0 0 1-.75-.77'/%3E %3C/g%3E %3C/g%3E %3Cg fill='none' stroke='%23000'%3E %3Cpath stroke-width='1.28' d='M630.79 241.91c27.11 16.28 45.97 52.4 45.97 94.32 0 49.9-26.7 91.57-62.26 101.37' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3E %3Cpath stroke-width='.64' d='M629.83 243.6c26.74 15.87 45.37 51.37 45.37 92.63 0 48.97-26.25 89.84-61.16 99.37' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3E %3Cpath stroke-width='1.3' d='M581.76 438.03a59.66 59.66 0 0 0 34-.13' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3E %3Cpath stroke-width='1.29' d='M658.8 386.73c-10.25 22.96-27.38 39.6-47.5 44.6l.2-1a51.65 51.65 0 0 1-27.03-.48l.12 1.14c-18.5-5.08-34.39-20.06-44.54-40.7l.53 1.06c10.16 20.1 25.82 34.64 44.01 39.64l-.12-1.14a51.73 51.73 0 0 0 27.02.47l-.19 1c19.75-4.9 36.63-21.02 46.93-43.33' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3E %3Cpath fill='%23b1babf' d='M756.95 364.67s-16.9-10.47-38.95-10.22c-16.15.2-34.57 9.45-34.57 9.45-18.49 11.06-33.66 30.64-43.12 54.73a155.82 155.82 0 0 0-10.57 57.08c0 59.12 32.85 106.44 73.9 117.7 0 0 6.1 2.68 14.45 2.68 8.36 0 16.03-1.07 16.03-1.07 41.87-10.38 74.9-58.76 74.9-118.67 0-77.67-60.07-116.67-52.07-111.68m-22.8 222.67s-8.44 1.54-15.96 1.54a64.65 64.65 0 0 1-14.71-1.93c-36.96-10.3-66.32-55.13-66.32-109.25 0-19 4.2-37.76 10.24-53.43 8.52-22.05 22.99-39.13 39.63-49.25 0 0 16.79-10.44 31.32-10.61 19.85-.24 34.87 11.32 34.87 11.32 27.85 17.65 47.2 56.53 47.2 101.65 0 54.85-28.57 100.46-66.26 109.96' stroke='none'/%3E %3Cg fill='%23c69024' stroke='%23080101' stroke-width='.46'%3E %3Cpath d='M566.69 242.43c-26.9 15.88-45.66 51.71-45.66 93.37 0 49.34 26.31 90.51 61.3 100.03l-.94 1.87c-35.39-10.02-61.93-51.84-61.93-101.89 0-41.96 18.57-78.14 45.46-94.64l1.77 1.27zM630.28 242.57c26.94 15.88 45.73 51.73 45.73 93.4 0 49.36-26.35 90.54-61.39 100.06l.93 1.88c35.45-10.04 62.03-51.86 62.03-101.94 0-41.98-18.68-78.17-45.61-94.68l-.21-.15-1.9 1.22.42.2z' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3E %3Cpath d='M570.08 251.03c-24.52 14.61-41.62 47.6-41.62 85.96 0 45.42 23.98 83.32 55.87 92.08l.59 2.34-1.44-.61c-32.26-9.24-56.45-47.73-56.45-93.81 0-38.64 17-71.94 41.51-87.13l.2-.14 1.72 1.12-.38.19z' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3E %3Cpath stroke-width='.49' d='M631.14 240.63l.24.17-4.73 9.93-.16-.09c-3.84-2.37-15.17-8.52-29.13-8.33-11.1.15-23.56 6.6-26.46 8.2.92-2.26-5.08-9.89-5.08-9.89l1.31-.75s16.04-9.16 30.1-9.34c19.19-.25 33.91 10.1 33.91 10.1' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3E %3Cpath d='M626.76 251.03c24.56 14.62 41.69 47.62 41.69 85.99 0 45.44-24.03 83.35-55.96 92.11l.05 2 1.27-.41c32.07-9.48 56.07-47.83 56.07-93.7 0-38.65-17.03-71.96-41.58-87.16l-.02-.02-1.42-.82-.48 1.82.38.19z' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3E %3Cpath stroke-width='.57' d='M758.74 365.2l-.08.04c-2.57 1.26-4.68 4.3-5.52 8.1-.26 1.2-.4 2.7-.36 3.77 0 0-2.87-1.56-2.87-1.8-.02-.98.08-2.03.32-3.1.93-4.24 3.49-7.66 6.4-8.58.04 0 2.11 1.57 2.11 1.57zM679.17 365.5l.08.04c2.57 1.26 4.68 4.3 5.52 8.1.26 1.2.4 2.7.36 3.77 0 0 2.87-1.56 2.87-1.8.02-.98-.08-2.03-.31-3.1-.94-4.24-3.45-7.64-6.37-8.55a70.56 70.56 0 0 0-2.15 1.54z'/%3E %3Cpath stroke-width='.53' d='M738.76 595.14s-.6-.47-1.37-1.32c-.56-3.65-2.58-5.31-2.58-5.31l-.43.04c-.37-1.32-.52-2.8-.26-4.41l-.21.03a65.33 65.33 0 0 1-15.93 1.84 56.54 56.54 0 0 1-13.75-2.12c-.04-.02-.8-.01-.78.06.54 1.58.45 3.14.06 4.56h-.03s-1.81 1.49-2.48 4.74c-.78.98-1.41 1.57-1.41 1.57l1.17.34-.01.22c-.08 3.18 2.9 3.72 4.87 3.74.6 4.02 3.13 3.39 4.46 2.74l-.29.39c.2 2.7 1.6 2.92 3.16 4.25.14.12 1.14.76 1.47 1.22l.06-.02c1.46 2.04 2.55 7.17 4.45 7.17h.5c1.9 0 2.98-5.09 4.44-7.15.32-.46 1.32-1.1 1.46-1.22 1.57-1.33 2.96-1.55 3.16-4.25l-.29-.39c1.33.65 3.85 1.28 4.46-2.74 1.96-.02 4.9-.55 4.87-3.65l1.23-.33z'/%3E %3Cpath stroke-width='.53' d='M740.44 594.56c-2.12-1.25-3.9-4.13-4.4-7.48a11.56 11.56 0 0 1-.08-2.98l-2.37-.23c-.27 1.2-.32 2.57-.1 4.03.57 3.79 2.77 6.97 5.24 7.88l1.71-1.22zM698.03 594.44c2.12-1.25 3.9-4.13 4.4-7.48.17-1.05.18-2.05.08-2.98l2.37-.23c.27 1.2.32 2.57.1 4.03-.57 3.79-2.77 6.97-5.24 7.88l-1.71-1.22z'/%3E %3C/g%3E %3Cg fill='%23000' stroke='none'%3E %3Cpath d='M705.48 599.31c1.82-1.34 2.43-3.6 2.9-5.74.03-.1-.01-.51-.02-.46-.47 2.1-1.08 4.34-2.88 5.67-.1.08.05.5 0 .53M709.73 602.29c2.12-.87 3.22-4.2 3.75-6.25.04-.15-.04-.42-.01-.52-.53 2.07-1.64 5.37-3.74 6.24-.09.03.03.52 0 .53M714.61 607.9a13.02 13.02 0 0 0 2.38-6.86c0-.07-.02-.58-.03-.37a12.7 12.7 0 0 1-2.35 6.7c-.1.13.07.44 0 .53M732.58 598.77c-1.8-1.33-2.4-3.56-2.88-5.67 0-.05-.05.36-.02.46.48 2.13 1.08 4.4 2.9 5.74-.05-.04.1-.45 0-.53M728.47 601.76c-2.1-.87-3.2-4.17-3.74-6.23.03.09-.05.36-.01.51.53 2.06 1.63 5.38 3.75 6.25-.02 0 .1-.5 0-.53M723.59 607.52a12.7 12.7 0 0 1-2.35-6.7c-.01-.21-.04.3-.03.37.21 2.54.88 4.8 2.38 6.86-.06-.09.1-.4 0-.53'/%3E %3C/g%3E %3C/g%3E %3C/g%3E %3Cg%3E %3Cg fill='%23452c25' stroke='%23000' stroke-width='.55'%3E %3Cpath d='M662.23 304.61s-4.2 9.73-1.93 10.68c2.28.96 8.06-.57 12.97-9.35 4.9-8.77-2.91-5.49-2.91-5.49l-8.13 4.16zM688.15 311.1s-.7 12.78 0 13.73c.7.96 7.18.96 7.53-8.58.35-9.54-1.4-9.92-1.4-9.92l-6.3 4.39'/%3E %3Cpath d='M692.03 295.69s-4.55 14.3-.17 17.17c4.37 2.86 7.88-14.12 8.05-17.93.18-3.82-7.88.76-7.88.76zM695.16 313.96s.88 13.35 3.33 13.93c2.45.57 6.48-3.82 6.48-7.25 0-3.44-4.2-11.45-4.2-11.45l-5.79 4.2'/%3E %3Cpath d='M695.28 297.97s-4.55 14.3-.18 17.17c4.38 2.86 7.89-14.12 8.06-17.93.18-3.82-7.88.76-7.88.76zM695.63 275.01s-6.66 6.87-6.48 10.68c.17 3.82 9.8-5.15 10.68-6.87.88-1.71-4.2-3.81-4.2-3.81z'/%3E %3Cpath d='M691.06 271.16s-5.26 9.73-3.85 12.78 6.48-2.29 8.93-5.72c2.45-3.44-5.08-7.06-5.08-7.06zM679.24 272.84s-3.5 13.16-.88 14.5c5.15 2.61 8.47-9.11 8.94-13.55.52-4.96-8.06-.95-8.06-.95z'/%3E %3Cpath d='M686.82 272.73s-6.66 6.87-6.48 10.68c.17 3.82 9.8-5.15 10.68-6.87.88-1.71-4.2-3.81-4.2-3.81zM573.28 273.7s-13.76 6.9-14.96 9.86c-1.2 2.95 41.49-4.48 64.95-21.06l-9.52-5.63-40.47 16.83z'/%3E %3Cpath d='M589.51 276.18s-25.05 9.35-6.95 9.72c0 0 35.88-7.47 54.99-22.08l-4.83-7.14-43.21 19.5z'/%3E %3Cpath d='M626.31 251.19s-26.45 13.54-23.48 15.07c2.98 1.53 21.73-2.67 31.54-8.77 9.81-6.1 14.02-9.54 14.02-9.54l-11.74-3.25-10.34 6.49zM616.32 280.9s-9.45 7.91-8.36 8.81c1.1.9 20.42-2.14 35.48-13.96l-1.9-6.97-25.41 11.75'/%3E %3Cpath d='M599.85 279.39s-9.06 7.22-7.07 7.8c1.98.6 9.66 6.04 43.64-16.12l4.01-2.47-6-8.46-34.58 19.25zM592.86 253.31c-28.58 10-57.24 29.91-57.24 29.91 2.8-.95 73.54-29.43 73.54-29.43M655.57 297.93s-6.13 9.35-4.9 10.5c1.22 1.14 8.76 4.76 17.51-7.26 8.76-12.01-8.23-10.1-8.23-10.1l-4.38 6.86z'/%3E %3Cpath d='M648.65 289.83s-9.2 11.54-7.27 13.07c1.93 1.52 12.44 1.33 20.32-9.73 7.89-11.07.18-.57.18-.57l-2.28-10.11-10.95 7.34z'/%3E %3Cpath d='M639.8 284.39s-8.93 10.68-8.06 12.4c.88 1.72 12.97 1.14 22.95-9.35s1.93-14.3 1.93-14.3l-16.64 10.68'/%3E %3Cpath d='M623.95 284.87l-5.7 7.92s1.58 7.44 21.2-6.1c19.63-13.55 18.58-12.4 18.58-12.4l-10.52-1.91-23.56 12.5zM561.45 273.47l-12.44 5.59s-2.8 2.46 4.5 2.65c7.3.18 22.4-1.84 48.65-16.72a136.13 136.13 0 0 0 19.38-13.15l-9.56-3.56-50.53 25.19z'/%3E %3Cpath d='M540.15 281.31s17.9-1.95 25-6.6c0 0-1.45 2.17 7.7-1.4l51.97-25.36-1.73-3.38s-56.61 24.25-60.9 25.6c-4.28 1.35-22.04 11.14-22.04 11.14z'/%3E %3Cpath stroke-width='.64' d='M670.11 304.2s-1.75 14.18.35 14.7c2.1.53 8.06-3.93 10.51-12.6 2.45-8.67-9.63-7.62-9.63-7.62l-1.75 5'/%3E %3Cpath d='M679.4 310.24s-1.05 10.4.35 11.35c1.4.95 4.9 1.34 9.11-6.87 4.2-8.2 2.28-5.15 2.28-5.15l-9.46-5.15-2.28 5.82z'/%3E %3Cpath d='M682.02 292.21s-7.7 16.79-3.33 16.6c4.38-.2 10.34-12.79 11.21-15.65.88-2.86-7.88-.95-7.88-.95z'/%3E %3Cpath d='M681.35 292.06s-2.9 18.5 1.24 16.93c4.14-1.56 6.48-15.5 6.56-18.51.07-3.02-7.8 1.58-7.8 1.58z'/%3E %3Cpath d='M687.63 293.93s-4.55 14.3-.18 17.17c4.38 2.86 7.89-14.12 8.06-17.93.18-3.82-7.88.76-7.88.76zM669.67 289.22s-3.5 13.16-.88 14.5c5.15 2.61 8.47-9.11 8.94-13.55.52-4.96-8.06-.95-8.06-.95zM637 262.07s-11.74 9.73-10.34 11.26c1.4 1.52 15.07-1.15 21.2-5.35 6.13-4.2 8.58-6.48 8.58-6.48l-10.5-6.49-8.94 7.06z'/%3E %3Cpath d='M647.34 252.15s-7.53 6.1-6.13 7.63c1.4 1.53 14.89-4 17.34-6.68 2.45-2.67 2.28-5.53 2.28-5.53l-13.49 4.58z'/%3E %3Cpath d='M654.52 251s-9.64 8.58-7.18 11.64c2.45 3.05 16.64-10.5 18.57-12.21 1.92-1.72-11.39.57-11.39.57z'/%3E %3Cpath d='M650.49 247.38l-20.5 9.73s-17.34 11.25-15.59 12.4c1.75 1.14 15.24-2.48 24.88-7.25 9.63-4.77 20.32-12.78 20.32-12.78M656.2 258.45s-22.18 19.07-18.85 20.98c3.33 1.9 15.37-3.33 25.35-12.49'/%3E %3Cpath d='M659.84 263.77s-13.38 22.14-11.98 24.24c1.4 2.1 10.5-4.96 15.07-10.3 4.55-5.34 8.13-13.23 8.13-13.23'/%3E %3Cpath d='M666.23 266.6s-13.6 25.27-12.02 27.37c1.57 2.1 9.46.38 14.19-9.54 4.73-9.92 4.32-16.32 4.32-16.32l-6.49-1.51z'/%3E %3Cpath d='M674.13 267.81s-15.11 31.2-12.13 34.24c2.98 3.06 19.7-23.65 20.48-27.43 1.34-6.63-8.53-7.38-8.53-7.38M642.26 247.19s-13.66 6.49-10.86 7.82c2.8 1.34 15.59-4.39 17.34-4.96 1.75-.57-6.48-2.86-6.48-2.86z'/%3E %3Cpath d='M644.36 249.29s-8.4 6.68-6.66 8.4c1.75 1.71 14.54-5.16 17-7.26 2.45-2.1-10.34-1.14-10.34-1.14z'/%3E %3Cpath stroke-width='.58' d='M662 249.82s-11.5 15.45-7.97 16.06c3.52.61 16.87-9.96 17.05-11.79.19-1.83-9.08-4.27-9.08-4.27z'/%3E %3Cpath d='M667.13 253.29s-12.26 15.45-8.76 16.4c3.5.96 3.85-1.52 3.85-1.52s9.64-8.01 10.34-10.11c.7-2.1-5.08-4.96-5.08-4.96'/%3E %3Cpath d='M670.99 256.92s-8.94 15.45-6.66 16.4c2.28.96 5.96-2.86 9.64-7.43 3.68-4.58-2.98-8.97-2.98-8.97z'/%3E %3Cpath d='M673.26 263.98s-5.26 9.73-3.85 12.78c1.4 3.05 6.48-2.29 8.93-5.72 2.45-3.44-5.08-7.06-5.08-7.06zM675.47 290.98s-3.5 13.16-.88 14.5c5.15 2.61 8.47-9.11 8.94-13.55.52-4.96-8.06-.95-8.06-.95z'/%3E %3Cpath d='M699.54 273.18s-3.5-1.14-6.13-1.14c0 0-7.71-6.1-11.91-6.68-4.2-.57-.62-.67-.62-.67s-.44-10.01-1.66-10.78c0 0-.7-10.3-7.18-11.06-6.49-.76-21.03.57-23.66-.38-2.62-.96-10.68-4.32-25.92-.2-15.6 4.23-46.3 18.01-47.88 18.4-1.58.37 35.26-8.1 45.6-12.67 0 0 10.33-.76 13.49-1.72 0 0-11.74 5.73-.88 3.25 10.86-2.48 8.41 0 8.41 0s-1.05 2.48 5.08 1.14 6.13 0 6.13 0 7.01 2.48 12.44-.76c0 0 2.8 9.73 6.3 11.06 0 0 4.17 8.92 12.93 10.63 0 0 4.16 2.95 5.04 3.52l4.95 1.63 5.3-4.14'/%3E %3Cpath d='M627.71 246.81s-35.04 12.59-33.81 16.02c1.22 3.44 36.61-9.72 42.22-13.35 5.6-3.62-7.88-2.86-7.88-2.86'/%3E %3C/g%3E %3Cg fill='%23452c25' stroke='%23000' stroke-width='.55'%3E %3Cpath stroke-width='.49' d='M869.44 278.12l13.78 7.82s3.36 2.79-4.02 1.15c-7.38-1.65-23.11-7.08-52.84-26.2-13.44-8.66-17.68-8.41-17.68-8.41l18.73.5 42.03 25.14z'/%3E %3Cpath stroke-width='.49' d='M873.99 274.72l13.78 7.82s3.36 2.79-4.02 1.15c-7.38-1.65-23.11-7.08-52.84-26.2-13.44-8.66-2.63 7.13-2.63 7.13l2.28-10.38 43.43 20.48z'/%3E %3Cpath stroke-width='.48' d='M896.91 282.25s-16.45-3.06-22.45-7.44c0 0 1.06 1.89-7-1.77 0 0 3.11 7.05-19.54-8.38-22.66-15.44-14.74-7.68-14.74-7.68l6.34-1.64s34.78 13.9 38.6 15.35c3.81 1.46 18.8 11.56 18.8 11.56z'/%3E %3Cpath d='M810.88 288.41l5.51 7.86s-1.83 7.37-20.97-6.97c-19.13-14.34-18.13-13.15-18.13-13.15l10.57-1.48 23.21 13.18M786.02 292.35s8.89 11.63 6.9 13.07c-1.97 1.45-12.47.83-19.96-10.55-7.5-11.38-.16-.58-.16-.58l.7-18.4 12.71 15.9'/%3E %3Cpath d='M795.15 287s8.56 11.04 7.62 12.72c-.93 1.68-13 .61-22.6-10.28-9.62-10.9-1.44-14.38-1.44-14.38L795 286.42M843.91 280.48s24.39 10.49 6.3 9.8c0 0-35.43-9.54-53.76-25.24l5.18-6.85 42 21.68'/%3E %3Cpath d='M856.71 277.45s13.2 8 14.18 11.05c.99 3.05-41.02-7.84-63.18-26.3l9.9-4.84 39.1 20.09zM818.37 284.71s9.55 7.84 8.46 8.75c-1.08.9-20.44-1.99-35.64-13.69l1.82-6.98 25.55 11.55'/%3E %3Cpath d='M834.7 284.04s9.42 6.5 7.47 7.18c-1.96.68-9.35 6.49-44.4-14.04l-4.13-2.27 5.57-8.75 35.5 17.3'/%3E %3Cpath d='M798.72 264.81s11.4 10.2 9.94 11.67c-1.45 1.47-15.02-1.76-21-6.2-5.98-4.45-10.33-10.15-10.33-10.15l12.7-2.74 8.69 7.42z'/%3E %3Cpath d='M785.14 247.77l20.76 12.37s16.94 11.96 15.15 13.03c-1.8 1.07-15.14-3.1-24.6-8.26-9.47-5.17-20.45-16.28-20.45-16.28M772.04 306.29s3.87 9.9 1.56 10.75c-2.31.86-8.04-.9-12.64-9.87-4.6-8.97 2.43-4.29 2.43-4.29l8.65 3.41z'/%3E %3Cpath d='M778.92 299.89s5.8 9.6 4.54 10.69c-1.27 1.09-8.92 4.4-17.26-7.97-8.33-12.37 8.58-9.76 8.58-9.76l4.14 7.04z'/%3E %3Cpath d='M761.58 256.61s19.8 38.23 18.15 40.26c-1.65 2.03-9.47 0-13.85-10.11-4.38-10.11-7.96-23.23-7.96-23.23l3.66-6.92zM784.64 266.33s16.52 14.04 13.13 15.81c-3.4 1.77-9.97-.79-19.63-10.35-9.66-9.56 6.34-6.04 6.34-6.04'/%3E %3Cpath d='M776.64 266.57s11.8 21.68 10.33 23.72c-1.47 2.04-10.33-5.39-14.7-10.91-4.36-5.53-7.67-13.56-7.67-13.56'/%3E %3Cpath d='M764.94 258.27s8.4 15.8 6.08 16.67c-2.3.86-5.85-3.1-9.37-7.83-3.51-4.73 3.29-8.84 3.29-8.84zM765.13 290.6s3.04 13.3.37 14.52c-5.23 2.4-8.14-9.45-8.46-13.9-.35-4.98 8.09-.62 8.09-.62zM754.67 311.68s.7 9.96-.73 10.85c-1.43.9-4.94 1.13-8.86-7.24-3.92-8.36-2.1-5.24-2.1-5.24l9.63-4.75 2.1 5.43'/%3E %3Cpath d='M764.03 309.58s1.4 10.37-.72 10.66c-2.11.3-7.95-3.19-10.19-9.58-2.23-6.4 9.82-5.13 9.82-5.13l1.63 3.69'/%3E %3Cpath d='M754.39 277.06s10.82 24.22 9.08 27.67c-3.4 6.75-13.24-14.75-16.21-23.15-3.32-9.39 7.13-4.52 7.13-4.52z'/%3E %3Cpath d='M749.37 281.11s14.76 26.66 8.53 27.28c-6.22.62-17.53-19.34-19.43-23.97-1.9-4.64 10.9-3.3 10.9-3.3z'/%3E %3Cpath d='M748.49 286.64s7.26 25.55 2.58 23.29c-4.67-2.26-10.3-21.5-11.07-25.66-.77-4.15 8.49 2.37 8.49 2.37zM773.99 250.32s11.2 17.1 7.56 17.6c-3.63.51-16.9-11.42-17.02-13.4-.12-1.97 9.46-4.2 9.46-4.2z'/%3E %3Cpath d='M767 251.04s14.27 19.48 9.97 20.47c-4.3.99-4.63-2.06-4.63-2.06s-11.39-10.26-12.15-12.86c-.77-2.6 6.39-5.8 6.39-5.8M793.99 249.73s13.43 7.04 10.58 8.26c-2.84 1.22-15.43-5.02-17.16-5.67-1.73-.64 6.58-2.59 6.58-2.59zM781.14 251.34s9.81 10.12 7.24 13.55c-2.58 3.43-16.2-12.82-18.06-14.88-1.86-2.07 11.89.93 11.89.93M757.34 265.4s15.8 30.78 12.9 33.91c-2.92 3.13-20.48-23.08-21.1-26.88-.6-3.8 8.36-7.6 8.36-7.6'/%3E %3Cpath stroke-width='.64' d='M748.26 268.19s6.32 9.63 5.96 14.82c-.36 5.19-9.55-7.43-10.34-9.8-.8-2.38 4.38-5.02 4.38-5.02z'/%3E %3Cpath d='M761.25 263.2s4.92 9.94 3.4 12.93c-1.5 3-8.2-6.04-10.53-9.57-2.33-3.53 7.13-3.36 7.13-3.36z'/%3E %3Cpath stroke-width='.66' d='M738.45 272.97s7.71 8.56 7.34 13.12c-.37 4.56-11.57-6.66-12.55-8.76-.98-2.1 5.21-4.36 5.21-4.36z'/%3E %3Cpath d='M788.31 248.28s11.68 10.47 9.86 12.12c-1.8 1.64-17.6-9.67-19.98-11.87-2.38-2.2 10.12-.25 10.12-.25z'/%3E %3Cpath d='M778.44 247.52l9.13 7.7s8.49 5.66 7.03 7.13c-1.45 1.47-14.74-4.62-17.1-7.39-2.36-2.77-2.08-5.62-2.08-5.62l3.02-1.82zM808.53 249.94s34.58 14.02 33.23 17.4c-1.34 3.38-36.25-11.22-41.73-15.08-5.47-3.85 7.98-2.53 7.98-2.53'/%3E %3Cpath d='M809.78 254.39s25.96 14.62 22.94 16.02c-3.03 1.4-21.62-3.56-31.21-10.06-9.6-6.5-13.68-10.1-13.68-10.1l11.84-2.77 10.11 6.91zM745.86 272.16s4.92 9.94 3.4 12.93c-1.5 3-6.39-2.55-8.72-6.08-2.33-3.54 5.32-6.85 5.32-6.85zM747.03 294.57s4.06 14.48-.42 17.16c-4.47 2.68-7.39-14.43-7.43-18.25-.04-3.82 7.85 1.09 7.85 1.09z'/%3E %3Cpath d='M726.92 270.71s14.44-6.34 17-5.83c0 0 3.03-.76 4.65-2.03 1.63-1.27 5.36-4.31 5.36-4.31s-2.56-17.5 15.83-15.72c18.4 1.78 42.61 4.06 47.5 4.82 4.9.76 22.82 5.83 27.02 7.86 4.19 2.03 31.5 14.39 37.09 16.42 3.3 1.2 10.6 5.76 16.01 9.29 3.72 2.42-.11.69-.11.69s-44.23-23.48-59.87-26.62c-3.91-.79.27 4.48.27 4.48s-10.16-4-14.35-5.78c-4.2-1.78-7.68-2.54-11.64-2.29-3.96.26-6.99-.5-9.32-1.26-2.32-.76-15.6-1.27-17.92-1.52-2.33-.26-4.2-.76-4.2-.76l.94 1.52-6.52-1.02-1.87 2.8s-6.28 1.26-6.75-.77c-.46-2.03-3.73 9.13-5.36 12.42-1.63 3.3-7.68 3.3-9.54 5.33-1.86 2.03-3.03 3.3-3.96 3.8-.93.51-5.59 3.3-7.22 3.3s-11.64.76-11.64.76l-2.56-4.06 1.16-1.52zM745.91 311.7s.26 12.8-.48 13.72c-.73.93-7.2.66-7.23-8.88-.02-9.55 1.75-9.86 1.75-9.86l6.15 4.65'/%3E %3Cpath d='M742.56 296.15s4.06 14.48-.42 17.16c-4.47 2.68-7.39-14.43-7.43-18.25-.05-3.82 7.85 1.09 7.85 1.09z'/%3E %3Cpath d='M739.24 298.29s4.06 14.48-.42 17.16c-4.47 2.68-7.39-14.43-7.43-18.25-.04-3.82 7.85 1.09 7.85 1.09z'/%3E %3C/g%3E %3Cg fill='%23d9c0b9' stroke-width='.55' stroke='%23000'%3E %3Cpath d='M741.9 357.31s2.49 3.1 2.18 4.1c0 0 2.56-2.58-.74-6.24l-1.44 2.14zM721.32 351.43h1.5l.56 1.4-.21 1.28-1.3.6s-2.11-.55-1.6 1.98c0 0-.99-4.64 1.05-5.26zM731.86 361.82l1.54-1.7 1.66.87s-.69 4.5-.95 4.83c-.26.33-.3.38-.3.51s-.27-.85-.77-1.42c-.5-.56-1.01-3.04-1.18-3.09zM715.75 356.23l-.76-2.27.88-1.2 1.79-.01.75.36s1.44 3.27.18 4.98c0 0-.53-1.84-1.14-2.1 0 0-1.33-.2-1.7.24zM699.07 360.14s-2.51 4.2.75 6.3c0 0-.2-3.92 2.35-4.76l-3.1-1.54zM690.43 358.44l2.27-.59.22.1s-1.49 2.87-1.09 3.57c.41.7-2.03-1.27-1.4-3.08z'/%3E %3C/g%3E %3Cpath fill='%23bd8759' stroke='%23000' stroke-width='.55' d='M730.39 333.74s.08 7.8.08 9.18c0 1.39-.16 3.47-.96 4.68-.79 1.21-1.59 1.9-2.86 1.9-1.27 0-4.61-.17-5.25 1.05-.64 1.2-1.11 1.9-1.11 1.9s2.06-1.21 2.38 0c.32 1.21-.8 2.25-.8 2.25s1.92.35 3.67-.69 2.7-1.21 3.5-1.21c.8 0 1.43.86 1.43.86s.48 2.6.32 4.16c-.16 1.56-.48 4.68 1.27 4.68 0 0 .64-1.56 1.27-1.73.64-.17 2.39 1.56 2.07 2.08 0 0 .32-3.3-.32-5.2-.63-1.9-.95-3.99-.95-3.99s5.41 1.91 5.89 2.6c.47.7 1.75 1.91 2.22 1.74.48-.18 0-1.74.96-2.08.95-.35 1.43.52 1.43.52s-1.59-3.64-3.98-4.85c-2.38-1.22-3.98-1.22-4.93-2.26-.95-1.04-1.12-2.25-1.27-3.46-.16-1.22.04-11.69.04-11.69l-4.1-.44zM703.37 353.57s-3.96 3.07-4.4 4.51c-.45 1.45-.58 2.84-.58 2.84s3.55-.43 3.11 1.53c0 0 1.15.66 2.98-3.59s3.56-6.08 4.86-5.96c1.3.13 2.95 1.39 3.78 2.27.83.9 1.98 1.55 3.43 1.14 0 0-1.52-2.31-.56-2.82.95-.5 2.41-.4 2.41-.4s-1.2-2.88-3.8-3.3c-2.6-.42-4.4-1.14-3.79-2.27.62-1.13 3.94-9.91 3.94-9.91l-4.4-6.47-1.77 5.63s.58 3.32.6 4.18c.02.85-3.5 8.12-3.98 8.54-.47.43-9.92 4.08-11.04 4.44-1.12.36-3.47 3.15-3.47 3.15l-.27 2.1s1.58-1.3 2.09-.52c0 0 1.1-1.39 2.08-.87.98.52.82.72.82.72s1.75-1.15 2.06-1.72c.3-.56.4-.5.4-.5l2.78-.48'/%3E %3Cg fill='none' stroke='%23000' stroke-width='.55'%3E %3Cpath d='M708.49 345.51c-.41.07-.7.01-.98-.18M710.01 341.66a3.3 3.3 0 0 1-1.3-.46M708.44 343.64c.3.17.63.23.98.18M705.2 349.67c.19.13.41.21.65.23M732.38 346.04c.65.11 1.24.46 1.91.52M733.5 344.13c-.51.13-.95.03-1.27-.35M733.81 341.88c-.6.07-1.23.04-1.75-.17M731.59 349.5c.6.08 1.17.38 1.75.52M731.75 351.93c.3-.07.57-.01.8.17M732.22 358.51c.4-.07.78-.01 1.11.17M712.33 350c-.5.08-.9.38-1.1.87M715.57 350.31c-.7.4-1.32.97-1.4 1.78M695.45 353.88c.54.5 1.34.78 1.81 1.23M738.11 351.24c-.41.19-.69.56-.8 1.04M740.34 351.93a.76.76 0 0 0-.48.7'/%3E %3C/g%3E %3Cpath fill='%23452c25' stroke='%23000' stroke-width='.55' d='M747.46 301.88s-1.23-5.54-2.1-6.3c-.88-.77.35-1.54.35-1.54s-2.28-5.54-3.68-6.5c-1.4-.95.17-1.71.17-1.71s-2.45-3.83-4.2-4.97c-1.75-1.15 0-1.34 0-1.34s-1.83-5.13-6.1-7.48c0 0-2.83-2.98-5.72-3.8-2.89-.82-10.05-1.58-18.7-1.42-9.12.16-12.98 6.48-12.98 6.48l-.59 7.33 1.32-.9-1.93 9.14c-.3 2.09 1.63 5.71 1.74 10.08.03 1.38.12 2.82.28 4.3a37.88 37.88 0 0 0 3.1 11.9c.15.3.28 1.2.45.9.44-.76 1.44 2.6 2.34 3.8 0 0 .54 4.55.97 2.86.17-.65 1.63 2.58 2.54 4.61.32.74 2.05 5.76 1.98 3.47-.07-2.5 1.52 5.32 1.52 6.45l2.1-3.06 1.05 3.44 1.75-.2-.52 3.26s4.9-4.02 5.08-5.55c.17-1.52.35-2.67.35-2.67l1.58-1.53 2.45-3.82s6.13 4.77 6.83 6.5c.7 1.71 1.4 3.24 1.4 3.24l1.58-1.53 1.4 3.44.88-1.72.85 2.4.07-.15.56 1.57c.43.4 1.4.6 3.25-2.48 2.62-4.4 2.45-7.83 2.62-8.6.18-.76 1.23 1.34 1.23 1.34s2.28-4.2 1.93-6.88c-.35-2.68 1.4-1.72 1.4-1.72s.35-7.07 0-8.8c-.35-1.71 1.23-1.33 1.23-1.33s-.53-8.4-1.06-9.36c-.52-.96 1.23-1.15 1.23-1.15z'/%3E %3Cpath d='M735.18 282.43c1.24.37 1.84 1.76 2.37 2.85-.03-.07.08-.38.01-.52-.53-1.08-1.14-2.5-2.38-2.86 0 0-.08.5 0 .53M736.3 287.71c2.28 1.93 2.48 4.57 2.35 7.45 0 .1.03.6.05.27.13-3.05.1-6.14-2.4-8.25.06.05-.1.44 0 .53M741.05 290.41c1.26 2.07 1.38 4.35 1.38 6.74 0 .3.05.3.05 0 0-2.54-.06-5.03-1.42-7.25.04.05-.09.39-.01.51M742.71 300.4c-.14 1.48-.4 2.93-.7 4.39-.01.1.02.5.03.46.3-1.49.56-2.97.7-4.47.01-.07-.01-.59-.03-.38M741.18 308.06c.12.97.24 1.93.14 2.9 0 .08.01.6.04.39.13-1.24 0-2.44-.14-3.67-.03-.2-.05.31-.04.38M738.23 298.44c0 1.64.01 3.27.15 4.9.02.21.04-.3.03-.38-.12-1.5-.13-3-.13-4.52 0-.3-.05-.3-.05 0M736.98 309.06c.13 1.55.13 3.1.13 4.67 0 .3.05.3.05 0 0-1.69 0-3.37-.14-5.05-.02-.2-.05.31-.04.38M743.99 307.71c.68.71 1.1 1.55 1.24 2.53.02.1.04-.08.04-.1v-.36a4.8 4.8 0 0 0-1.28-2.6c.06.07-.1.42 0 .53M743.57 296.99c.7.58 1.26 1.29 1.82 2-.07-.08.1-.41 0-.53a12.8 12.8 0 0 0-1.82-2c.06.05-.1.44 0 .53M737.81 305.01c0 1.46-.14 2.9-.4 4.34-.03.1.01.5.02.46.3-1.59.42-3.19.43-4.8 0-.3-.05-.3-.05 0M734.75 308.2c.12 1.3.12 2.6 0 3.9 0 .08.02.6.04.38.14-1.55.14-3.1 0-4.66-.02-.2-.05.31-.04.38M724.71 273.96c.8.13 1.48.5 2.2.87.02 0 .33.2.38.12.06-.08-.21-.32-.23-.34a6.35 6.35 0 0 0-1.5-1.1c-.9-.48-1.8-.97-2.83-1.14-.2-.03.56.7.6.73.37.3.9.78 1.38.86M697.43 300.41c.52 1 .6 2.15 1.12 3.14-.03-.06.08-.38.01-.51-.52-1-.6-2.15-1.12-3.14.04.06-.08.38-.01.51M702.19 273.43c1.17-.42 2.41-.43 3.64-.57.05 0 .02-.54 0-.53-1.22.14-2.47.15-3.64.57-.09.03.02.52 0 .53M709.18 272.86a7.93 7.93 0 0 1 3.5-.57c.03 0 .03-.53 0-.53-1.2 0-2.39.04-3.5.57-.1.04.03.52 0 .53M697.02 279.04c-.15.03-.15.14-.16.28v.36c.02.1.04-.08.04-.1 0 .1.06 0 .12 0 .07-.02.01-.54 0-.54M696.29 297.87c0 .98 0 1.97.15 2.94.02.1.04-.08.04-.1l-.01-.36c-.13-.82-.13-1.65-.13-2.48 0-.3-.05-.3-.05 0M730.99 279.29c.5.14.8.5.97.99a.8.8 0 0 0 .03-.19c0-.1.02-.23-.02-.32-.16-.5-.48-.87-.98-1.01 0 0-.08.5 0 .53M731.55 287.85a6.94 6.94 0 0 1 1.67 2.85c-.02-.09.06-.37.02-.52a7 7 0 0 0-1.69-2.86c.06.06-.1.42 0 .53M729.73 281.57c.76.66 1.4 1.42 2.1 2.14-.07-.06.1-.43 0-.53-.7-.72-1.34-1.49-2.1-2.14.06.05-.1.44 0 .53M731.82 295.82a6.06 6.06 0 0 1-.55 3.51c-.06.14.04.44.01.52.61-1.46.83-2.93.57-4.49-.01-.05-.05.36-.03.46M733.77 300.24c.1.66.12 1.3 0 1.97a1.6 1.6 0 0 0 0 .36c0 .02 0 .2.03.1a8.9 8.9 0 0 0 0-2.89c-.02-.1-.04.08-.04.1l.01.36M741.33 315.84c.5 1.79.54 3.61.54 5.46 0 .3.05.3.05 0 0-2.02-.03-4.02-.58-5.97.03.08-.05.36-.01.51M740.07 319.47a30.58 30.58 0 0 1-1.4 3.71c-.06.14.05.45.02.52.57-1.2.98-2.46 1.4-3.72.04-.14-.05-.43-.02-.51M697.86 307.42c1.17 1.52 1.8 3.35 2.79 4.99-.03-.06.09-.4.01-.51-.99-1.65-1.62-3.48-2.8-5.01.07.08-.1.4 0 .53M705.27 307.6c-1.07.14-1.33-1.4-2.24-1.71.02 0-.08.5 0 .53.9.32 1.17 1.85 2.24 1.71.06 0 .02-.53 0-.53M701.07 314.69c.77 1.35 1.27 2.83 2.1 4.14-.04-.05.09-.4.01-.51-.82-1.31-1.33-2.8-2.1-4.14.04.05-.08.38-.01.51M705.97 316.42a11.07 11.07 0 0 1 2.09 3.42c-.03-.08.06-.37.01-.52a11.2 11.2 0 0 0-2.1-3.43c.07.08-.1.41 0 .53M705.54 321.55c.43.9.82 1.82 1.26 2.71-.03-.06.08-.38.01-.51-.43-.9-.82-1.82-1.26-2.71.04.06-.07.38-.01.51M710.15 322.55c.25.94.4 1.9.4 2.88 0 .3.05.3.05 0a13.55 13.55 0 0 0-.44-3.4c.03.1-.05.37-.01.52M708.19 326.81c.3 1.36.7 2.68 1.4 3.88-.03-.05.09-.39.02-.51-.7-1.18-1.1-2.5-1.4-3.83 0-.05-.04.36-.02.46M709.32 308.71c1.1.42 2.21.84 3.36 1.14 0 0 .07-.51 0-.53-1.15-.3-2.25-.72-3.36-1.14.02 0-.09.5 0 .53M710.16 313.42c1.32.73 2.7 1.32 4.05 2-.03-.02.1-.48 0-.53-1.34-.68-2.73-1.27-4.05-2 .04.02-.1.47 0 .53M711.42 318.7c.68.83 1.42 1.59 2.24 2.29-.06-.06.1-.45 0-.54-.82-.7-1.56-1.45-2.24-2.28.07.08-.1.41 0 .53M712.81 325.26c.57.9.83 1.91.97 2.97.02.1.04-.08.04-.1l-.01-.36a7.39 7.39 0 0 0-.99-3.02c.04.05-.08.39-.01.51M716.72 308.95c.12.63.27 1.26.43 1.88-.03-.09.05-.36.01-.51-.15-.6-.3-1.22-.41-1.83-.02-.1-.04.08-.04.1 0 .12-.01.24.01.36M726.51 305.04c-.28.7-.6 1.36-.98 2-.07.12.05.46.01.51.38-.64.7-1.3.98-2 .06-.14-.04-.43-.01-.51M730.54 304.87c0 1.12-.02 2.24-.27 3.34-.02.1.02.51.03.46.28-1.25.3-2.52.3-3.8 0-.3-.06-.3-.06 0M731.39 311.06c.1.96 0 1.91-.13 2.87-.02.1.02.5.02.46.17-1.24.28-2.46.15-3.7-.03-.21-.05.3-.04.37M734.47 316.92a5.44 5.44 0 0 1-1.94 3.25c-.1.1.06.48 0 .53a5.54 5.54 0 0 0 1.97-3.32c.01-.1-.02-.5-.03-.46M724.55 311.18c-.28.56-.64 1.06-.98 1.57-.05.07-.02.25-.02.33 0 .02.02.21.03.18.34-.51.7-1.01.98-1.57.04-.08.02-.23.02-.32 0-.02-.02-.21-.03-.19M725.68 319.03a7.8 7.8 0 0 1-1.4 1.57c-.1.08.06.49 0 .53.56-.43.98-1 1.4-1.57.04-.06.03-.2.03-.26 0-.03-.04-.26-.03-.27M722.18 323.17c-1.37-1.35-2-3.08-1.4-5.05.06-.14-.03-.43 0-.51a5.9 5.9 0 0 0 1.4 6.1c-.06-.07.1-.44 0-.54M717.56 318.81c.1.8.1 1.6-.13 2.37-.05.15.04.43.01.51.33-1.08.3-2.23.15-3.34-.02-.1-.04.08-.04.1l.01.36M728.19 324.04c-.29.97-.81 1.82-1.26 2.71-.06.14.05.45.02.52.44-.9.97-1.75 1.25-2.72.05-.14-.04-.42-.01-.51M735.04 326.89a38.1 38.1 0 0 1-1.96 3c-.08.11.05.47.02.51.68-.98 1.36-1.95 1.95-3 .07-.12-.04-.45-.01-.51M738.38 330.49a70.2 70.2 0 0 0-.57 5.52c0 .09.02.6.05.27.13-1.78.27-3.56.55-5.33.01-.1-.02-.5-.03-.46M742.71 324.08c.01.62.13 1.24.14 1.86 0 .37.05.02.05-.15-.01-.62-.13-1.23-.14-1.85 0-.38-.05-.03-.05.14M696.73 303.93a11.3 11.3 0 0 0 .57 5.34c-.03-.08.06-.37 0-.51a9.03 9.03 0 0 1-.54-4.37c.01-.1-.03-.5-.03-.46'/%3E %3Cpath fill='%23dcddde' d='M697.1 285.19s-.53-5.3.96-5.88c0 0 .53-4.87 7.01-4.2 0 0 2.2-3.62 5.7-1.71 0 0 3.32-1.63 5.25-.67 1.93.95 4.3 2.57 4.47 2.95 0 0 2.8-.57 4.11.48s.7 4.48.7 4.48 3.16 2.42 3.42 4.55c.26 2.13.26 2.99-.44 3.56 0 0 1.4 1.15 1.14 2.77s-1.58 3.97-1.84 3.97.18 4.23-1.22 5.66c-1.4 1.43-2.72 1.72-3.33 1.91-.61.2-2.2 2.48-3.68 2.77-1.49.28-3.5-2.3-3.68-3.06-.18-.76-2.19-1.62-2.19-1.62s-4.56 4.87-7.62 4.1a7.93 7.93 0 0 1-4.82-3.81c-.26-.48-1.14-4-1.14-4s-3.41-2.01-3.15-3.92c.26-1.9 1.66-4.2 1.66-4.2l-1.31-4.13z'/%3E %3Cg fill='%23fff'%3E %3Cpath d='M712.57 281.17c2.95-2.7 6.85-5.56 11.04-4.56 0 0 .07-.52 0-.54-4.19-1-8.09 1.86-11.04 4.57-.1.1.06.47 0 .53M726.76 284.4c-2.96-2.01-8.14-2.75-11.04-.27-.1.1.06.48 0 .53 2.9-2.48 8.08-1.74 11.04.27-.05-.03.1-.46 0-.53M715.46 288.95c1.21 3.93 2.78 7.93 2.1 12.13-.02.1.02.5.02.46.74-4.55-.78-8.82-2.1-13.1.02.08-.07.36-.02.51M710.72 291.34c.73 3.97.26 7.99 0 11.98-.02.1.01.6.04.27.28-4.23.76-8.5-.01-12.7-.01-.06-.05.35-.03.45M717.04 288.42c3.86.92 7.64 3.49 9.72 6.97-.04-.06.08-.39.01-.51a15.86 15.86 0 0 0-9.73-7s-.07.52 0 .54M713.6 293.79c.01 2.44.2 4.89-.5 7.26-.05.15.03.43 0 .51.77-2.53.57-5.15.55-7.77 0-.3-.05-.3-.05 0M719.67 293.25c2.43 2 4.35 5.04 4.71 8.24.03.21.05-.3.04-.37a13.17 13.17 0 0 0-4.75-8.4c.06.05-.1.44 0 .53M701.8 299.95c.8-1.15 1.8-2.45 3.15-2.94.08-.04-.02-.53 0-.54-1.36.5-2.35 1.81-3.16 2.97-.08.11.04.46.01.51M707.58 279.07c-.51-2.18-2.15-3.47-3.9-4.65.04.03-.1.42 0 .48 1.74 1.16 3.38 2.45 3.89 4.63-.02-.09.04-.32.01-.46M704.16 279.03c-2.02-.96-4.11-1.07-6.3-1.07-.05 0-.05.53 0 .53 2.19 0 4.28.11 6.3 1.07-.03-.01.1-.48 0-.53M710.48 278.69c.27-2.1-.04-4.08-1.85-5.37.04.03-.1.4 0 .46 1.52 1.09 2.07 2.6 1.83 4.5a2 2 0 0 0 .02.41M718.09 281.17c1.9-1.01 3.97-.82 6.04-.8.04 0 .04-.54 0-.54-2.07-.01-4.14-.2-6.04.8-.1.06.04.52 0 .54M721.51 286.27c2.93.31 5.17 1.82 7.1 4.03-.13-.15.2-.84 0-1.07-1.93-2.2-4.17-3.72-7.1-4.03-.04 0-.11 1.06 0 1.07M708.62 294.35c-.7 2.8-.16 6.35-3.4 7.5-.18.06.03 1.05 0 1.06 3.28-1.16 2.73-4.7 3.43-7.53.07-.3-.08-.85-.03-1.03'/%3E %3Cpath d='M715.45 292.16c1.12 2.95 2.7 5.96 2.09 9.23-.04.2.03 1.01.05.92.74-4.03-.7-7.48-2.11-11.18.06.16-.14.75-.03 1.03M719.67 291.64a6.95 6.95 0 0 1 5.75 5.83c.03.21.08-.16.08-.19.01-.24 0-.49-.02-.73-.39-2.97-2.88-5.6-5.81-5.98-.04 0-.12 1.06 0 1.07M719.64 295.86c.45 2.45 1.14 4.9.27 7.35-.1.29.09.86.03 1.03 1.08-3.06.31-6.22-.25-9.3-.02-.1-.09.71-.05.92M718.09 285.2c3.15-.53 6.47-1 9.2 1.07-.11-.08.2-.9 0-1.06-2.73-2.08-6.05-1.6-9.2-1.08-.13.03-.02 1.07 0 1.07M712.33 278.95c.38-2.6 2.67-4.46 4.97-5.3.17-.06-.04-1.05 0-1.06-2.38.86-4.64 2.77-5.02 5.44a3.7 3.7 0 0 0-.02.73c0 .03.04.4.07.19M709.46 280.51c-.08-2.88-1.34-5.2-2.58-7.73.05.12-.14.68-.03.91 1.12 2.26 2.45 4.47 2.52 7.07.02.66.1.05.09-.25M706.82 282.06c-.56-2.57-2.25-4.27-4.5-5.44.08.04-.19.96 0 1.06 2.17 1.14 3.9 2.8 4.45 5.3.02.1.1-.71.05-.92M702.58 281.03c-1.47-1.02-3.01-1.99-4.8-2.26-.02 0-.1.82 0 .83 1.79.28 3.33 1.24 4.8 2.26-.08-.05.16-.72 0-.83M711.75 293.09c.25 2.73.6 5.48-.77 7.97-.13.25.1.9.03 1.03 1.63-2.98 1.11-6.5.81-9.75-.03-.42-.08.61-.07.75'/%3E %3Cpath d='M714.92 291.62c.91 2.56 1.99 5.3 1.8 8.08 0 .17.06 1.2.1.54.22-3.4-.75-6.5-1.87-9.65.05.16-.13.74-.03 1.03M717.04 287.88c2.6.8 5.2 1.65 7.1 3.76-.13-.14.2-.84 0-1.07-1.9-2.1-4.5-2.95-7.1-3.76.02.01-.16 1.02 0 1.07M709.98 282.09c.28-2.27.52-4.53.54-6.82 0-.6-.1-.6-.1 0a54.3 54.3 0 0 1-.51 6.07c-.02.14.02 1.17.07.75M705.21 280.64a23.15 23.15 0 0 1-5.26-3.49c.12.1-.2.89 0 1.07a23.12 23.12 0 0 0 5.26 3.49c-.06-.03.19-.98 0-1.07M704.42 294.33a6.64 6.64 0 0 0-2.64 3.24c-.08.19-.04.46-.04.66 0 .04.05.41.07.37a6.57 6.57 0 0 1 2.61-3.2c.2-.13-.1-1.01 0-1.07M707.79 296.33c-.05 1.87-1.08 3.42-2.32 4.7-.2.22.13.94 0 1.08a7.93 7.93 0 0 0 2.42-5.5c0-.34-.08-1.03-.1-.28M716.61 281.63c1.55-2.45 5.3-2.65 7.8-3.34.16-.04 0-1.06 0-1.06-2.53.69-6.26.9-7.83 3.37-.15.24.1.93.03 1.03M699.38 281.59a8.55 8.55 0 0 1-1.7-.8c.05.03-.12.6 0 .66.55.31 1.1.62 1.7.8-.01 0 .1-.63 0-.66M699.72 294.13c-.54.22-1.1.45-1.47.93-.1.1-.05.4-.05.53l.01.38c0-.02.03.17.04.15.37-.48.93-.7 1.47-.92.08-.04.05-.47.05-.54 0-.02-.02-.54-.05-.53M701.98 294.71a6.8 6.8 0 0 0-2.62 2.45c-.12.17.08.73.03.8a6.73 6.73 0 0 1 2.6-2.41c.14-.07-.05-.82-.01-.84M706.27 295.77c-.97 2.37-3.62 4.98-1.7 7.63-.06-.1.19-.81.03-1.03-1.33-1.83 1.01-3.9 1.7-5.57.11-.28-.1-.88-.03-1.03M709.3 295.73c.07 2.41-.35 4.8-.77 7.15-.04.21.04 1.02.05.92.5-2.77.9-5.53.82-8.35-.02-.75-.11-.06-.1.28M717.05 292.88c1.76 2.3 3.31 4.78 4.06 7.62-.04-.18.11-.73.03-1.03-.75-2.86-2.32-5.34-4.09-7.66.13.18-.19.82 0 1.07M717.96 291.03c2.89 2.2 6.1 4.27 8.14 7.39-.06-.1.18-.8.03-1.03-2.05-3.13-5.27-5.21-8.17-7.43.1.09-.2.91 0 1.07'/%3E %3Cpath d='M719.66 287.22a6.78 6.78 0 0 1 3.1.31c.92.34 1.68 1.1 2.51 1.6.84.5 1.69.97 2.37 1.69.9.94.91 2.55 1.17 3.77.02.08.09-.61.05-.79-.22-1-.33-2-.67-2.97-.33-.94-1.14-1.52-1.94-2.02-.95-.61-1.88-1.23-2.82-1.85-1.12-.73-2.5-.77-3.77-.65-.1.01-.04.91 0 .91'/%3E %3Cpath d='M726.73 293.14c.32.93.7 1.85 1.01 2.78-.03-.1.08-.48.02-.67-.32-.93-.7-1.85-1.01-2.78.03.11-.08.48-.02.67M718.64 278.41c2.04-.56 4.12-.93 6.12-1.62.17-.06-.03-1.06 0-1.07-2 .7-4.08 1.06-6.12 1.62-.16.05.01 1.07 0 1.07M710.15 279.43a9.3 9.3 0 0 1 1.36-2.88c.76-1.13.87-2.55 1.8-3.58.2-.23-.13-.93 0-1.07-.77.85-1.04 1.95-1.48 2.98-.52 1.25-1.35 2.17-1.7 3.52-.09.3.07.85.02 1.03M703.2 298.49a9.33 9.33 0 0 0 .35 5.26c-.06-.16.14-.75.03-1.03a5.63 5.63 0 0 1-.33-3.31c.05-.23.03-.5.02-.73 0-.04-.03-.4-.07-.19M707.42 301.8c-.73 1-.74 2.5-.35 3.65.01.04.06-.31.06-.35 0-.2.02-.44-.04-.62-.21-.64-.05-1.16.33-1.68.08-.1.05-.37.05-.5 0-.05-.07-.47-.05-.5M710.56 300.12c-.03 1.01-.57 1.97-1 2.86-.08.2.07.64.03.74.52-1.1 1-2.16 1.04-3.4.01-.24-.05-.74-.07-.2M710.65 294.2v1.27c0 .04 0 .54.05.54.06 0 .05-.5.05-.54v-1.27c0-.04.01-.53-.05-.53-.06 0-.05.5-.05.53M709.22 294.94c.08.15.15.3.2.46.04.23.06.24.06.04l-.05.26c-.04.24-.03.5-.01.73 0 .04.03.4.07.2.16-.88.2-1.92-.24-2.72-.03-.05-.07.34-.07.38 0 .17-.05.5.04.65M707.18 294.27a14.3 14.3 0 0 0-.47 2.02c-.03.24-.03.5-.01.73 0 .03.03.4.07.2.1-.66.24-1.3.44-1.92.06-.2.04-.45.03-.66 0-.05-.05-.41-.06-.37M705.61 294.36a11.7 11.7 0 0 1-3.51 2.66c-.2.11.08 1.02 0 1.07a11.7 11.7 0 0 0 3.51-2.66c.09-.11.05-.4.05-.54 0-.05-.07-.51-.05-.53M702.89 294.82c-.58.46-1.23.8-1.93 1.04-.17.06.03 1.06 0 1.07.7-.25 1.35-.58 1.93-1.04.1-.08.05-.44.05-.54l-.05-.53M699.04 293.88c-.56.25-1.14.47-1.7.72-.15.06.04.83 0 .85.56-.25 1.14-.46 1.7-.72.15-.06-.04-.83 0-.85M710.77 293.41c.01.7.12 1.37.25 2.06.04.2.07-.16.07-.2.02-.23.03-.5-.02-.73-.09-.46-.2-.94-.2-1.41 0-.05-.05-.42-.06-.37-.07.19-.04.45-.04.65M712.58 292.58c0 .82.09 1.6.38 2.37.01.04.06-.33.06-.38 0-.2.04-.46-.03-.65-.16-.43-.3-.88-.3-1.34 0-.04 0-.53-.06-.53s-.05.5-.05.53M713.98 292.4c.24.34.52.81.53 1.25 0 .04.05.41.06.37.07-.2.05-.45.04-.65a3.44 3.44 0 0 0-.6-2c-.04-.05-.07.34-.07.38 0 .15-.05.52.04.65M715.69 291.72c.6.13 1.14.37 1.59.81l.05-.53c0-.11.04-.45-.05-.54a3.15 3.15 0 0 0-1.59-.8s-.14 1.03 0 1.06M716.6 290.33c.7.58 1.47 1.02 2.38 1.16.03 0 .12-1.05 0-1.07a4.83 4.83 0 0 1-2.38-1.16l-.05.54c0 .1-.04.45.05.53M718.52 285.7c.61 0 1.21.1 1.81.23.01 0 .14-1.04 0-1.06-.6-.13-1.2-.23-1.81-.24-.08 0-.08 1.07 0 1.07M717.63 283.49c.37-.6.92-1.05 1.46-1.49.09-.07.05-.43.05-.53l-.05-.53c-.55.45-1.11.9-1.49 1.52-.09.15-.04.5-.04.66 0 .03.04.42.07.37M715.94 281.35c.1-.7.34-1.33.77-1.9.08-.11.05-.4.05-.53 0-.06-.07-.5-.05-.53a4.3 4.3 0 0 0-.84 2.77c0 .03.04.4.07.19M714.57 280.36c.7-.98 1.17-2.1 1.81-3.12.1-.15.04-.5.04-.66 0-.04-.03-.42-.07-.37-.64 1.01-1.11 2.14-1.8 3.12-.1.14-.05.5-.04.66 0 .03.02.42.06.37'/%3E %3Cpath d='M711.45 276.86c.03 1.2.11 2.39.36 3.56.05.2.07-.15.08-.2.01-.22.03-.5-.02-.72-.21-.96-.3-1.94-.32-2.92-.02-.75-.1-.06-.1.28M706.39 277.7c.18.43.42.84.64 1.26a8.28 8.28 0 0 1 .46 1.12c-.06-.22.05-.16-.08.07-.15.24.1.9.03 1.02.3-.53.26-1.39.12-1.96-.22-.92-.78-1.68-1.14-2.54.06.15-.15.75-.03 1.03M705.38 279.78a18.6 18.6 0 0 0-2.27-1.85l-.05.53c0 .1-.04.47.05.53a18.8 18.8 0 0 1 2.27 1.86l.05-.54c0-.11.04-.44-.05-.53M708.69 280.89c.47-2.34.38-4.68-.58-6.88.06.15-.15.75-.03 1.03.7 1.6.91 3.17.56 4.93-.05.23-.03.5-.02.73 0 .03.03.4.07.19M713.65 277.83c.08 0 .08-1.07 0-1.07s-.08 1.07 0 1.07'/%3E %3Cpath d='M708.04 280.99c.12-1.32.43-2.62.57-3.94a5.8 5.8 0 0 0 0-1.13c-.03-.27-.09-.26-.11 0-.14 1.32-.45 2.62-.57 3.94a6.1 6.1 0 0 0 0 1.13c.03.27.08.27.11 0M722.38 289.21a4.68 4.68 0 0 1 2.81 2.29c.04.07.1-.5.1-.56 0-.28.06-.73-.06-.99a4.76 4.76 0 0 0-2.85-2.34c.04.01-.25 1.52 0 1.6M718.5 297.17c.2.68.22 1.3.1 2.01-.07.35-.05.74-.03 1.1 0 .05.05.59.1.28.3-1.6.34-3.37-.13-4.93-.01-.06-.1.49-.1.56 0 .3-.03.68.06.98M715.27 295.01c0 1.32.08 2.64-.19 3.94-.07.35-.05.74-.02 1.1 0 .05.04.58.1.28.36-1.75.28-3.54.27-5.32 0-.05.01-.8-.08-.8s-.08.74-.08.8M713.63 296.44c-.46 1.75-.9 3.51-1.27 5.29-.06.35-.04.74-.02 1.1 0 .05.04.58.1.28.35-1.73.79-3.43 1.23-5.13.12-.45-.11-1.27-.04-1.54M715.84 297.56c.01 1.5.19 3.03.02 4.53-.04.37-.03.76 0 1.13.03.27.08.26.11 0 .22-1.9.05-3.77.03-5.66 0-.06.01-.8-.08-.8s-.08.74-.08.8M705.23 298.36c.03-.48.03-.57-.01-.29a2.5 2.5 0 0 1-.31.8c-.13.23-.06.72-.06.98 0 .05.06.64.1.56.56-1 .51-2.32.36-3.43-.04-.3-.1.24-.1.29-.03.36-.03.73.02 1.09M709.89 295.2c.31.6.29 1.12.28 1.78 0 .05 0 .8.08.8.09 0 .08-.75.08-.8 0-1.1.12-2.31-.4-3.32-.04-.08-.1.5-.1.56 0 .26-.07.73.06.98M711.16 294.65c.17.14.32.29.44.48l.12.27c.04.1.05.39.04.05 0 .16.01.32.04.48 0 0 .02.18.06.08.1-.29.06-.68.06-.98-.02-.78-.13-1.48-.76-1.98-.03-.02-.06.26-.06.24a5.49 5.49 0 0 0 0 1.13c.01.04.01.19.06.23M712.73 293.23c.25.5.54 1 .8 1.5.03.09.05-.06.05-.08.03-.15.03-.31.04-.47l-.01-.62c0-.1 0-.27-.05-.37-.25-.5-.54-1-.79-1.5-.04-.08-.06.07-.06.08l-.03.48v.61c0 .1 0 .27.05.37M716.24 291.96a39.9 39.9 0 0 0 1.95 2.58c-.03-.03.07-.72.07-.8 0-.2.06-.64-.07-.8-.68-.81-1.3-1.66-1.9-2.52-.06-.08-.1.5-.1.56-.01.22-.1.78.05.98M718.05 288.95c.47.83 1.01 1.6 1.6 2.34-.02-.03.08-.72.08-.8 0-.19.06-.63-.07-.8a17 17 0 0 1-1.57-2.28c-.04-.08-.1.5-.1.56 0 .25-.07.75.06.98M700.4 280.9a7.08 7.08 0 0 0-1.7-1.04 4.6 4.6 0 0 0-.08.8c0 .1-.04.74.08.8.62.26 1.18.62 1.7 1.04l.08-.8c0-.15.06-.69-.08-.8M705.93 279a4.55 4.55 0 0 1 .17.48c0 .16.01.33.04.48 0 0 .02.18.06.08.1-.29.06-.68.05-.98 0-.55-.06-1.1-.28-1.6-.04-.09-.06.07-.06.08l-.03.48c-.01.28-.07.71.05.98M710.29 274.85a5.74 5.74 0 0 1-.62 3.07c-.14.23-.07.73-.06.98 0 .06.05.64.1.56.84-1.44.77-3.41.73-5.04 0-.06-.07-.62-.1-.55-.1.29-.06.68-.05.98M711.27 280.76a6.46 6.46 0 0 0 2.06-2.58c.12-.25.06-.71.06-.98 0-.05-.06-.63-.1-.56a6.3 6.3 0 0 1-2.02 2.52c-.13.1-.08.67-.08.8 0 .05.06.81.08.8M713.99 280.65c.32-.33.59-.7.9-1.04.05-.05.05-.17.06-.24a5.83 5.83 0 0 0 0-1.13c0 .03-.03-.25-.05-.23-.32.33-.6.7-.91 1.04-.05.05-.05.17-.06.24a5.49 5.49 0 0 0 0 1.13c0-.03.04.25.06.23M718.07 281.36c-1.02 0-2.04-.01-3.06-.12-.07 0-.16 1.59 0 1.6 1.02.1 2.04.12 3.06.12.11 0 .12-1.6 0-1.6M717.16 285.04c1.36.82 2.68 1.7 4.08 2.43-.1-.06.3-1.44 0-1.6-1.4-.73-2.72-1.61-4.08-2.43.13.08-.3 1.42 0 1.6'/%3E %3Cpath d='M717.28 287.82c1.21.77 2.53 1.36 3.63 2.32l.07-.8c0-.16.06-.68-.07-.8-1.1-.96-2.42-1.55-3.63-2.32-.02-.01-.08.76-.08.8 0 .13-.05.71.08.8M709.48 282.01c.17-.58.17-1.2.17-1.81 0-.06.01-.8-.08-.8s-.08.74-.08.8c0 .22 0 .03 0 0 0 .1-.02.18-.05.27-.1.3-.06.67-.06.98 0 .16.01.32.04.48 0-.02.03.18.06.08M699.94 277.75c1.06 1.3 2.41 2.25 3.72 3.27.97.75 1.7 2.04 2.74 2.63-.12-.07.3-1.42 0-1.6-.94-.53-1.58-1.67-2.41-2.37-1.39-1.16-2.89-2.1-4.05-3.53.2.24-.3 1.24 0 1.6M702.21 282.06a31.68 31.68 0 0 1-1.81-2.08c-.02-.02-.06.26-.06.23-.02.19-.02.38-.02.57 0 .19-.06.63.08.8.58.71 1.17 1.42 1.8 2.08l.09-.8c0-.17.06-.66-.08-.8M700.94 292.62c-.43.78-.79 1.59-1.34 2.29-.13.16-.08.6-.08.8 0 .08.1.76.08.8.57-.72.94-1.55 1.38-2.35.13-.24.06-.72.06-.98 0-.06-.06-.64-.1-.56M702.13 294.22c-.02.89-.32 1.78-.43 2.66-.05.37-.04.76 0 1.13.02.27.07.26.1 0 .15-1.14.46-2.21.48-3.36 0-.3.05-.7-.05-.99-.03-.06-.1.5-.1.56M706.31 301.57c.76-2.53.67-5.2.62-7.81-.02-1.12-.16-.09-.15.42.04 1.98.06 3.94-.51 5.85-.13.44.12 1.28.04 1.54M708.76 295.43c.29.88.35 1.68.2 2.6a5.2 5.2 0 0 0-.02 1.08c0 .05.06.6.1.29.28-1.8.34-3.76-.24-5.51-.02-.06-.1.49-.1.56 0 .3-.04.68.06.98M711.16 294.54a5.55 5.55 0 0 1 1.06 3.9c-.01.25.08 1.78.14.8.13-2.08.18-4.6-1.2-6.3.02.03-.08.72-.08.8 0 .2-.05.64.08.8'/%3E %3Cpath d='M711.82 293.47c.55 2.3.98 4.62 1.21 6.97.06.63.13-.92.11-1.13a55.1 55.1 0 0 0-1.28-7.38c.07.28-.15 1.08-.04 1.54M714.09 292.89a15 15 0 0 1 2.38 4.51c.02.06.1-.48.1-.55 0-.32.03-.68-.06-.99a14.98 14.98 0 0 0-2.38-4.51c.1.13-.28 1.21-.04 1.54M718.77 289.03c-.47-.8-1.45-.9-2.29-.84-.15.01-.07 1.6 0 1.6.8-.07 1.8 0 2.25.78.04.08.1-.5.1-.56 0-.25.07-.75-.06-.98'/%3E %3Cpath d='M716.37 288.4c1.47-.21 2.94-.23 4.42-.23.12 0 .12-1.6 0-1.6-1.48 0-2.95.02-4.42.23-.18.03-.05 1.6 0 1.6M719.09 276.27c-1.17 1.4-1.8 3.31-2.2 5.09-.07.34-.04.74-.02 1.09 0 .06.04.59.1.29.38-1.69 1-3.54 2.12-4.87.14-.16.08-.61.08-.8 0-.08-.1-.77-.08-.8M712.71 277.64c.22 1.35.77 2.6 1.15 3.9.02.06.1-.49.1-.56 0-.31.03-.68-.06-.98-.36-1.25-.9-2.45-1.11-3.74-.05-.3-.1.24-.1.29-.03.36-.04.73.02 1.09M711.5 279.97a6.39 6.39 0 0 1-1.22-2.17c-.04-.1-.07.1-.06.08-.03.16-.04.32-.04.48 0 .3-.04.68.05.98.26.84.73 1.55 1.27 2.23.02.02.06-.26.06-.24l.02-.56c0-.2.05-.63-.08-.8M709.35 281.02a16.4 16.4 0 0 1-4.99-2.43c.17.12-.3 1.36 0 1.6a16.4 16.4 0 0 0 4.99 2.43c-.04-.01.25-1.52 0-1.6'/%3E %3C/g%3E %3Cg stroke-width='0'%3E %3Cpath fill='%23d9c0b9' stroke='%23000' stroke-width='.55' d='M670.35 297.23s-2.95-5.08 5.24-7.57c0 0 2.48 1.35 3.05 2.28 0 0-1.43 2.39-6.1 3 0 0-2.1.63-2.19 2.29z'/%3E %3Cpath fill='%235e3f17' d='M675.77 290.98c-1.34.82-3.45.83-3.87 2.68v.12c.43-1.85 2.54-1.85 3.87-2.67.03-.01-.01-.12 0-.13'/%3E %3Cpath fill='%23d9c0b9' stroke='%23000' stroke-width='.55' d='M671.21 296.4s3.3.7 5.52-.93c1.83-1.34 2.48-.73 2.96-.63 0 0 .1-1.65-1.05-2.9 0 0-2.32 1.91-4.03 2.43-1.71.52-2.87.35-3.4 2.03z'/%3E %3Cpath fill='%23dba05f' stroke='%23000' stroke-width='.55' d='M711.3 280.57s-7.05 1.2-8.9 1.63a50.5 50.5 0 0 1-7.54.86c-1.47 0-3.72-1.18-5.3-1.5-1.56-.32-6.65-.85-8.5 1.07s-3.04 2.56-3.63 3.2c-.58.64-2.94 2.73-3.04 3.65-.09.93.6 2.31 1.77 2.31 1.18 0 3.64 2.5 3.64 3.03 0 .87 3.22 1.8 6.27 1.79 5.49-.03 8.19-2.8 16.42-1.83 4.48.53 12.72-2.99 14.2-5.12 1.46-2.13 2.34-4.37.87-6.82-1.46-2.45-5.87-2.2-6.26-2.27z'/%3E %3Cpath d='M681.79 288.47s-.02.16-.05-.09l-.04-.18-.05-.13-.01-.15c-.03-.05.15.04.72-.52l.48-.73c-.04.02.7-.91 1.77-1.16 1.08-.25 2.07-.07 2.21-.06.05-.06-2.44-.1-2.6.2 0-.2 2.4-.28 2.52-.11.03-.06-2.25-.08-2.42.24 0-.14 2.07-.24 2.3-.05 0 0-.39-.05-.5-.04l.19.04h-.3l-.16-.02c0-.01.45.05.48.1 0 0 .2-.07-.6-.02 0 0-.5-.1-1.3.16-1.07.16-1.03 1.6-2.64 2.52'/%3E %3Cpath fill='none' d='M681.62 287.87c.1 0 .79-.27 1.45-1.5-.19-.33 2.49-1.38 2.77-1.04 0-.01.73 0 1.14.07'/%3E %3Cpath fill='none' d='M684.27 285.55c-.27-.04-1.63 1.1-1.5 1.17-.3.7-1.07 1.17-1.15 1.15M684.38 285.72c0-.09 1.84-.26 2.2-.13M684.04 286.21c-.05-.2 1.91-.46 2.1-.33'/%3E %3Cpath d='M686.09 287.46s.08.05-.03-.06l-.08-.1-.05-.08-.07-.06s-.06.03-.56.46c0 0-.21.16-.47.4 0-.02-.48.4-1 .69-.57.08-1.38.45-1.38.6-.05-.23 1.61-.66 1.59-.69.12.08-1.48.37-1.5.7-.06-.2 1.46-.58 1.52-.59.08.1-1.34.33-1.38.63 0 .01.2-.19.27-.2l-.1.08c.05-.05.12-.06.18-.08l.1-.05s-.28.13-.27.19c.01.03-.16-.02.37-.16 0 .05 1.34-.27 2.86-1.68'/%3E %3Cpath fill='none' d='M685.84 287.12c0-.02-.59.58-1.2 1 0 .1-1.24.84-1.57.75-.02-.04-.53.22-.74.48'/%3E %3Cpath fill='none' d='M683.99 288.6c.1-.1.88-.63.88-.64.28-.3.97-.85.98-.85M684.02 288.74c.07.06-1.17.23-1.37.53M684.37 288.71c.08.16-1.32.53-1.38.58'/%3E %3Cpath fill='%23c6262c' stroke='%23000' stroke-width='.55' d='M688.04 281.76s-.1-2.24-2.25-3.1c-2.15-.84-4.6-.95-5.48-.84-.88.1-1.03.5-2.13.67-1.1.18-2.28.71-2.28.71s0-.1-.58.96c-.6 1.07-1.57 1.6-1.08 2.56s.17 1.13.77 1.3c.6.2-.3-.32-.3-.32s-3.77 1.22-2.86 3.53c.92 2.31 1.84 1.45 2.12 1.4.27-.05 2.13-1 2.13-1l3.06-2.86s3.6-1.41 3.99-1.52c.39-.1 2.1.04 2.1.04l2.79-1.53z'/%3E %3Cpath d='M685.31 287.01c0 .56-.57 1.28-1.27 1.6-.7.34-1.26.15-1.26-.4 0-.56.56-1.28 1.26-1.61.7-.33 1.27-.15 1.27.41'/%3E %3Cpath fill='%235e3f17' d='M708.62 292.91a5.35 5.35 0 0 0 2.05-.93'/%3E %3Cg fill='%23842116'%3E %3Cpath d='M674.86 285.06c.58.01 1.25.31 1.16 1.02v.38c.01.09.03.09.04 0 .06-.43.08-.93-.09-1.34-.18-.45-.67-.58-1.11-.6-.04 0-.04.54 0 .54M677.63 286.13a2.7 2.7 0 0 0-.26-2.4c.03.05-.1.4-.02.52.3.42.45.85.27 1.37-.06.14.04.43.01.51M679.87 283.76c-.14-.93-.47-1.97-1.33-2.45.04.02-.1.47 0 .53.84.47 1.17 1.47 1.3 2.38.02.1.04-.08.04-.1l-.01-.36M681.84 283.28c.12-.87.05-1.8-.67-2.38.06.05-.1.45 0 .54.4.32.72.84.64 1.38v.36c0 .02.02.2.03.1M678.54 280.37c1.93-.98 5.85-1.41 7.36.54-.07-.09.1-.41 0-.54-1.51-1.94-5.43-1.51-7.36-.53-.1.05.04.51 0 .53'/%3E %3C/g%3E %3Cg fill='%237a2e26'%3E %3Cpath d='M680.38 294.73c.61 0 1.24 0 1.84-.13.07-.02 0-.54 0-.54-.6.14-1.23.14-1.84.14-.04 0-.04.53 0 .53M679.22 286.19c-.5 0-.35.61-.66.87-.04.03-.02.21-.02.26l.02.27c.3-.26.17-.86.66-.87.04 0 .04-.53 0-.53M680.92 287.34c.26-.48.76-.67 1.22-.9.1-.05-.04-.52 0-.54-.47.24-.97.44-1.23.93-.04.08-.02.24-.02.32 0 .02.02.22.03.19M683.13 290.28c.42.03.74-.15.99-.48.04-.06.02-.2.02-.27 0-.03-.03-.25-.02-.26-.25.33-.57.51-.99.48-.03 0-.05.53 0 .53M684.87 289.66a3.1 3.1 0 0 0 1.56-1.35c.04-.08.02-.25.02-.33 0-.02-.02-.21-.03-.19a3.07 3.07 0 0 1-1.55 1.34c-.1.04.02.52 0 .53M682.13 286.78c-.39.65-1.11.98-1.55 1.59-.08.1.04.47.01.51.44-.6 1.17-.94 1.55-1.59.05-.07.03-.24.02-.32 0-.02-.02-.22-.03-.19M683.32 295.28c1.4.07 2.74-.11 4.1-.48.07-.02-.01-.53 0-.53-1.36.36-2.7.55-4.1.48-.03 0-.05.53 0 .53M689.76 295.04c1.82-1.32 3.36-2.46 3.96-4.77.04-.15-.04-.42-.02-.51-.59 2.3-2.14 3.44-3.94 4.75-.1.07.05.5 0 .53M690.85 291.87a6.43 6.43 0 0 0 2.74-3.42c.05-.15-.05-.44-.02-.52a6.39 6.39 0 0 1-2.72 3.4c-.1.07.04.51 0 .54M690.23 283.8c1-.12 2.08.7 2.78 1.35-.07-.06.1-.44 0-.54-.7-.64-1.79-1.46-2.78-1.34-.06 0-.02.53 0 .53M716.07 287.82c1.13-1.83.51-4.12-.66-5.75.03.04-.1.4-.01.51.99 1.39 1.65 3.13.66 4.73-.08.12.04.46.01.51M696.35 285.24c1.14.83 4.29 2.94 3.43 4.67-.07.13.04.45.01.51 1.18-2.37-1.86-4.57-3.44-5.71.05.03-.1.45 0 .53M705.21 293.75a5.98 5.98 0 0 0 .3-1.89c-.02-.09-.03-.09-.04 0-.05.47-.1.93-.27 1.38-.04.1-.02.23-.02.32 0 .02.02.21.03.19M673.95 288.41c.44-.65.3-1.52-.13-2.12.03.04-.1.4-.02.51.12.16.21.32.29.5.1.22-.03.42-.15.6-.05.06-.02.25-.02.32 0 .02.01.22.03.19M693.62 294.06c.62-.4 1.05-.98 1.2-1.73.02-.11.01-.24 0-.36 0-.02-.01-.2-.03-.1-.13.71-.58 1.28-1.17 1.66-.1.06.05.5 0 .53M696.57 293.82c.27-.3.36-.65.38-1.04 0-.1.02-.23-.02-.33l-.03.19c0 .23-.19.49-.33.65-.04.05-.03.2-.03.26 0 .03.04.26.03.27M714.39 284.04c.48.86.56 1.8.35 2.77-.03.1.01.5.02.46a5.37 5.37 0 0 0-.36-3.74c.04.06-.08.38-.01.51M712.61 285.85c.35.87.32 1.77.22 2.69 0 .07.02.59.04.38a7.24 7.24 0 0 0-.25-3.58c.03.07-.07.37-.01.51M710.94 287.4c0 .65 0 1.3-.22 1.91-.05.15.05.44.02.52.28-.77.25-1.62.25-2.43 0-.3-.05-.3-.05 0'/%3E %3C/g%3E %3C/g%3E %3Cpath fill='%23dcddde' stroke='%23000' stroke-width='.27' d='M694.56 275.41c-7.07.4-14.05-4.3-14.05-4.3-8.76-1.7-9.27-9.63-9.27-9.63-3.5-1.34-6.52-10.34-6.52-10.34-5.43 3.24-12.23.04-12.23.04s0-1.34-6.13 0c-6.13 1.33-5.08-1.15-5.08-1.15s2.45-2.48-8.4 0c-10.87 2.48.87-3.24.87-3.24-3.16.95-13.5 1.72-13.5 1.72-3.78.17-7.63 2.04-11.83 3.23-2.6.75-7.07 1.61-9.33 2.58-6.02 2.57-18.09 8.1-28.05 12.02-13.1 5.14-23.5 9.05-22.81 8.89.82-.2 14.23-8.7 31.03-16.31 15.6-7.08 33.5-13.62 42.53-16.19 11.7-3.88 21.3-2.02 26.74-.05 2.63.96 17.13-.44 23.6.32 6.5.76 7.17 11.42 7.17 11.42 1.22.76 1.66 10.78 1.66 10.78s-3.6.1.61.67c4.2.57 11.92 6.67 11.92 6.67 2.62 0 2.92-.1 2.92-.1s1.53-1.92 3.63-2.72c2.1-.8 4.03-1.61 6.4-1.79 2.36-.18 5.7-.2 8.06.07 2.37.27 5.16.29 8.5.91 3.32.63 3.67.81 4.72 1.17 1.05.36 2 .12 2 .12 4.32-1.8 12.35-5 14.2-4.64 0 0 3.03-.76 4.66-2.03 1.62-1.26 5.35-4.3 5.35-4.3s-2.57-18.11 15.82-16.34c18.4 1.78 42.79 4.14 47.68 4.9 4.89.76 22.4 5.76 26.59 7.8 4.2 2.02 16.24 7.42 21.6 9.79 2.17.96 10.46 4.63 16.59 7.05a61.3 61.3 0 0 1 16.08 9.69c-5.77-2.44-10.43-5.23-15-7.21-3.7-1.6-7.56-2.35-10.56-3.69-6.38-2.83-11.3-5.41-15.16-7.21-14.24-6.64-14.11-6.9-19.88-7.36-3.98-.3 2.86 4.86 2.86 4.86s-13.04-5.07-17.23-6.85c-4.2-1.77-7.69-2.53-11.65-2.28-3.95.25-6.98-.5-9.3-1.27-2.34-.76-15.61-1.27-17.94-1.52-2.33-.25-4.19-.76-4.19-.76l.93 1.52-6.52-1.01-1.86 2.79s-6.29 1.26-6.75-.77c-.47-2.02-3.73 9.13-5.36 12.43-1.63 3.3-9.07 2.2-10.93 4.23-1.86 2.03-5.84 3.39-6.77 3.9-.93.5-3.75.26-5.38.26-2.43 0-.36.04-4.34.8 0 0-3.44-.04-4.75-.58a73.89 73.89 0 0 0-5.66-1.78c-1.99-.57-13.05-.82-14.63-.73-1.57.09-4.24.9-6 1.62-1.74.72-4.8 2.6-4.8 3.04'/%3E %3Cpath fill='%23452c25' d='M695.29 273.29s-.74.57-.93 2c-.18 1.42-.1.85-.1.85'/%3E %3Cpath fill='%23574f4c' d='M731.03 271.21c.94.7 1.9 1.41 2.74 2.24.02.03.3.28.2.08-.1-.22-.28-.42-.44-.58a26.97 26.97 0 0 0-3.02-2.5c-.18-.13.01.18.04.22.13.2.29.4.48.54'/%3E %3C/g%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 33 21'%3E %3Crect fill='%23FFF' width='33' height='21'/%3E %3Crect width='33' height='14'/%3E %3Crect fill='%234891D9' width='33' height='7'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 900 600'%3E %3Crect width='900' height='600' fill='%23000'/%3E %3Crect width='900' height='400' fill='%23fff'/%3E %3Crect width='900' height='200' fill='%23ce1126'/%3E %3Cg fill='%23fff' stroke='%23c09300'%3E %3Cpath stroke-width='1.2703' stroke-linejoin='round' d='m450.81,302.4,68.488,63.579-4.8759-115.47c-0.71638-17.5-15.924-13.485-26.971-7.1723-11.191,7.1723-23.958,7.1723-37.446,2.437-13.485,4.7353-26.253,4.7353-37.444-2.437-11.046-6.3123-26.252-10.328-26.97,7.1723l-4.8789,115.47,70.098-63.579z'/%3E %3Cg id='w' fill='%23c09300' stroke='none'%3E %3Cpath d='m393.47,246.49-4.7342,112.32-8.0347,7.168,4.8784-115.47c2.2949-1.5782,6.3132-4.0171,7.8905-4.0171z'/%3E %3Cpath d='m403.09,254.53-4.0171,93.955-8.0323,8.2204,4.8772-108.49c1.5791,1.577,6.3138,5.4498,7.1721,6.3104z'/%3E %3Cpath d='m411.84,261.7-3.1545,78.362-6.4556,6.3092,4.0177-89.405c1.5748,1.5782,4.7311,3.8734,5.5924,4.7334z'/%3E %3Cpath d='m421.31,265.72-3.1563,66.787-6.3132,5.1193,3.1563-74.344c1.5791,0.71638,4.7348,2.4376,6.3132,2.4376z'/%3E %3Cpath d='m430.06,265.72-2.2974,55.657-6.4544,6.3129,2.4392-61.252c1.576-0.00061,5.5937-0.00061,6.3126-0.7182z'/%3E %3C/g%3E %3Cuse xlink:href='%23w' transform='matrix(-1,0,0,1,900,0)'/%3E %3Cpath fill='%23c09300' stroke-width='1.0739' d='m453.16,315.06,9.6126,43.755-3.1575,3.1552-3.2993-2.4388-5.4518-39.018,2.2955,39.018-3.1569,4.0158-3.1563-4.0158,2.2962-39.018-5.4506,39.018-3.3024,2.4388-3.1545-3.1552,9.6113-43.755h6.3138z'/%3E %3Cg id='b' fill='none' stroke-width='1.2705' stroke-linejoin='round'%3E %3Cpath fill='%23fff' stroke-width='1.1888' d='m428.48,295.84-19.08,67.705,26.255,4.0177,11.188-50.924-18.363-20.799z'/%3E %3Cpath d='m422.17,318.94,2.2955,5.5928,12.405-11.848'/%3E %3Cpath d='m430.76,304.92,2.5957,24.346,7.8905-10.328'/%3E %3Cpath d='m438.09,322.95,4.31,14.875'/%3E %3Cpath d='m444.09,332.36-8.7177,13.241m2.7189,13.216-2.7902-13.198-2.4356-13.423-5.8406,7.9091-2.5613-9.1191-8.1747,8.3847,4.1575,15.251,5.7375-9.4349,3.1557,9.6123,5.8903-9.1621'/%3E %3Cpath d='m414.99,361.97,5.2997-7.4437,3.4528,11.457,4.7342-8.0323,3.1575,9.6136'/%3E %3C/g%3E %3Cuse xlink:href='%23b' transform='matrix(-1,0,0,1,900,0)'/%3E %3Cg stroke-width='1.2705' stroke-linejoin='round' stroke-linecap='round'%3E %3Cpath stroke-width='2.3777' stroke-linejoin='round' d='m450,393.81c19.943,0,39.024-1.5776,50.213-4.734,4.7354-0.8588,4.7354-3.2976,4.7354-6.4553,4.7354-1.5776,2.2949-7.1704,5.5943-7.1704-3.2994,0.86244-4.0158-5.5941-8.0329-4.7316,0-5.5965-5.5955-6.3129-10.33-4.7377-9.4695,3.1576-26.255,3.8752-42.18,3.8752-15.924-0.71758-32.567-0.71758-42.179-3.8752-4.7342-1.5752-10.327-0.85881-10.327,4.7377-4.0183-0.86245-4.7354,5.5941-8.0341,4.7316,3.2988,0,0.85954,5.5928,5.5943,7.1704,0,3.1576,0,5.5965,4.8778,6.4553,11.045,3.1564,30.128,4.734,50.068,4.734z'/%3E %3Cpath d='m422.89,363.54c6.4544,0.86123,13.628,1.5776,19.225,0.86123,3.1533,0,5.4494,5.4504-0.86257,6.3129-5.5931,0.71515-14.345,0-19.08-0.86245-4.0171-0.71759-12.768-2.2946-18.364-3.8752-5.5949-2.4364-1.576-7.168,1.5772-6.4522,4.879,1.577,11.192,3.1564,17.505,4.0158z'/%3E %3Cpath d='m477.12,363.54c-6.4569,0.86123-13.628,1.5776-19.081,0.86123-3.3006,0-5.5961,5.4504,0.71711,6.3129,5.5955,0.71515,14.347,0,19.078-0.86245,4.0189-0.71759,12.769-2.2946,18.364-3.8752,5.5967-2.4364,1.5803-7.168-1.5772-6.4522-4.8778,1.577-11.19,3.1564-17.501,4.0158z'/%3E %3Cpath d='m403.09,360.39c-4.8771-0.86123-7.1723,4.7316-5.5928,7.8868,0.71637-1.5776,4.0164-1.5776,4.7346-3.1552,0.8582-2.437-0.7182-2.437,0.8582-4.7316z'/%3E %3Cpath d='m422.17,375.06c0-3.1528,3.1545-2.7651,3.1545-5.9215,0-1.577-0.85893-4.0171-2.4368-4.0171-1.5785,0-3.1575,1.5776-3.1575,3.1552-0.7177,3.157,2.4398,3.6312,2.4398,6.7834z'/%3E %3Cpath d='m444.88,365.98c4.7305,0,4.2618,6.3141,1.9656,9.4699,0-2.2952-4.0164-3.1558-4.0164-4.7316,0-2.4419,3.6262-2.4419,2.0508-4.7383z'/%3E %3Cpath d='m496.91,360.39c4.8777-0.86123,7.1741,4.7316,5.5953,7.8868-0.71819-1.5776-4.017-1.5776-4.734-3.1552-0.86124-2.437,0.71759-2.437-0.86124-4.7316z'/%3E %3Cpath d='m477.83,375.06c0-3.1528-3.1532-2.7651-3.1532-5.9215,0-1.577,0.85953-4.0171,2.438-4.0171,1.5772,0,3.1563,1.5776,3.1563,3.1552,0.71771,3.157-2.441,3.6312-2.441,6.7834z'/%3E %3Cpath d='m455.12,365.98c-4.7323,0-4.263,6.3141-1.9674,9.4699,0-2.2952,4.0158-3.1558,4.0158-4.7316,0.00061-2.4419-3.6262-2.4419-2.0484-4.7383z'/%3E %3Cg stroke-width='0.8915'%3E %3Cpath d='m404.67,361.97c1.58,0,4.0177,0.71758,4.7353,1.577l-4.74-1.58z'/%3E %3Cpath d='m412.55,364.41c0.86184,0,4.0183,0.71639,5.5959,1.5752l-5.6-1.58z'/%3E %3Cpath d='m441.25,367.56c-1.5776,0-4.734,0-5.5928,0.71516l5.59-0.72z'/%3E %3Cpath d='m432.5,367.56c-0.8588-0.86245-4.0165-0.86245-5.5935,0h5.59z'/%3E %3Cpath d='m495.34,361.97c-1.5776,0-3.8746,0.71758-4.7353,1.577l4.7353-1.577z'/%3E %3Cpath d='m487.45,364.41c-0.86002,0-4.0171,0.71639-5.5953,1.5752l5.6-1.58z'/%3E %3Cpath d='m458.75,367.56c1.5794,0,4.7352,0,5.5953,0.71516l-5.6-0.72z'/%3E %3Cpath d='m467.5,367.56c0.86002-0.86245,4.0183-0.86245,5.5953,0h-5.6z'/%3E %3C/g%3E %3Cg fill='%23c09300' stroke='none'%3E %3Cpath d='m403.34,374.58c-0.53406-0.10208-0.81452-0.52459-0.68011-1.0246,0.16371-0.609,0.65161-0.95739,1.1126-0.79442,0.29312,0.10362,0.82973,0.64469,0.83184,0.83874,0.003,0.22275-0.28059,0.75257-0.40266,0.75379-0.0527,0.00053-0.1342,0.0465-0.18122,0.10201-0.10001,0.11816-0.41341,0.17549-0.68041,0.12446z'/%3E %3Cpath d='m458.27,378.5c-0.19869-0.0736-0.51521-0.5185-0.51485-0.72377,0.002-0.38717,0.57418-1.0178,0.92881-1.0214,0.17516-0.001,0.65475,0.2481,0.83411,0.43462,0.32504,0.33789,0.25419,0.89278-0.15423,1.2079-0.20096,0.15505-0.80025,0.21125-1.0938,0.1026z'/%3E %3Cpath d='m458.63,380.98c-0.42018-0.14209-0.57388-0.34776-0.60803-0.8136-0.0355-0.4854,0.0116-0.56097,0.52453-0.84064l0.36556-0.19931,0.34646,0.1545c0.47988,0.21397,0.69338,0.44463,0.71031,0.76742,0.0182,0.34768-0.2397,0.70345-0.64012,0.8829-0.35162,0.15758-0.37253,0.15904-0.69871,0.0488z'/%3E %3Cpath d='m407.75,370.09c-0.34619-0.0109-0.82136,0.30729-1.0938,0.46875-0.64912,0.15215-1.4047,0.5511-2.0312,0.125-0.61719-0.19079-1.438-0.0404-1.5312,0.71875,0.15839,0.65179,1.0715,1.0243,1.625,0.59375,0.4106-0.53758,1.5312-0.8528,1.6562,0.0625-0.45705,0.69215-0.40489,1.6089-0.78125,2.3438-0.0612,0.45773-0.25176,0.8924-0.5,1.2812-0.4621,0.0464-0.95375-0.008-1.3438,0.28125-0.62601,0.0342-1.2647,0.34537-1.625,0.875-0.40338,0.57818-0.78869,1.1654-0.90625,1.875,0.10725,0.72494,0.93754,0.93275,1.5625,0.96875,0.66694,0.18359,1.3344,0.42433,2,0.625,1.0853,0.24303,2.102,0.63539,3.1875,0.875,1.5844,0.47758,3.2479,0.69739,4.8438,1.125,0.16722,0.0555,0.32405,0.1038,0.5,0.125,0.66233,0.13773,1.0079-0.58289,1.0625-1.125,0.32864-1.1596,0.57948-2.3391,0.90625-3.5,0.22487-0.46559,0.49645-1.5172-0.40625-1.2812-0.51485,0.30872-0.95182,0.7734-1.5938,0.8125-0.87392,0.0509-0.37513,0.94518-0.0312,1.3125,0.0759,0.5872-0.10989,1.2888-0.5,1.75-0.51994,0.32957-1.1716-0.0561-1.7188-0.1875-0.57469,0.01-1.7234-0.28325-1.1875-1.0625,0.19033-0.57691,0.20718-1.2083,0.4375-1.7812,0.29353-0.61455,0.33553-1.2851,0.46875-1.9375-0.36122-0.77733-0.97856,0.25585-1.4688,0.34375-0.33769,0.23455-1.6054,0.33418-0.9375,0.9375,0.57518,0.43696,0.1343,1.1967,0.0312,1.75-0.0369,0.77025-0.83781,0.95394-1.4688,0.78125-0.62768-0.0303-1.5013-0.49748-0.96875-1.1875,0.12115-0.57512,0.322-1.1402,0.4375-1.7188,0.2374-0.69777,0.43732-1.3628,0.6875-2.0625,0.10851-0.61996,0.33113-1.2079,0.625-1.75,0.0173-0.68543,0.47775-1.2752,0.46875-1.9688-0.0469-0.33876-0.19853-0.4622-0.40625-0.46875zm-3.5938,7.25c0.0817-0.0141,0.1399-0.002,0.21875,0.0312,0.24971,0.10625,0.25708,0.30938,0,0.53125-0.11238,0.097-0.23995,0.1905-0.28125,0.1875-0.46771-0.0402-0.6056-0.10974-0.625-0.28125-0.0172-0.15117,0.0307-0.19455,0.34375-0.34375,0.15556-0.0742,0.26207-0.11086,0.34375-0.125z'/%3E %3Cpath d='m403.12,382.36c-0.49596-0.46627-0.41621-0.80642,0.31729-1.3532,0.31384-0.23393,0.50421-0.20747,0.8631,0.11997,0.55237,0.50393,0.57448,0.82295,0.0869,1.2548-0.24101,0.21344-0.34645,0.25721-0.62697,0.26001-0.29347,0.003-0.3766-0.0334-0.64036-0.28155z'/%3E %3Cpath d='m406.17,383.28c-0.48488-0.11955-0.76441-0.60787-0.62254-1.0876,0.12852-0.43459,0.20285-0.47736,0.84026-0.48378,0.71478-0.007,0.85352,0.11244,0.86039,0.74185,0.004,0.35432-0.0235,0.43652-0.19971,0.60041-0.2071,0.19261-0.6052,0.29644-0.8784,0.22908z'/%3E %3Cpath d='m495.28,383.36c-0.22701-0.18894-0.27272-0.27435-0.27532-0.51479-0.003-0.41064,0.23349-0.71172,0.74605-0.94382,0.68183-0.30882,0.95981-0.26636,1.2166,0.18575,0.34158,0.60129,0.32512,0.84675-0.0839,1.252-0.22578,0.22366-0.26805,0.2367-0.78493,0.2419-0.50756,0.003-0.56562-0.0105-0.8185-0.22102z'/%3E %3Cpath d='m410.22,384.51c-0.36389-0.0971-0.5525-0.37016-0.55726-0.80675-0.004-0.33383,0.0201-0.38706,0.25362-0.56985,0.15122-0.11834,0.39018-0.21971,0.57856-0.24541,0.2669-0.0365,0.36442-0.0132,0.57916,0.13775,0.55052,0.38698,0.66746,0.76972,0.3487,1.1412-0.33953,0.39572-0.66141,0.48753-1.2028,0.34303z'/%3E %3Cpath d='m432.14,385.49c-0.0807-0.10062-0.25916-0.16012-0.2775-0.287,0.032-0.55487,0.0585-1.1167,0.23525-1.6482,0.0962-0.52301,0.012-1.0692,0.19432-1.5787,0.18698-0.92682,0.18682-1.8826,0.40217-2.8036,0.01-0.47427,0.0549-0.949,0.19241-1.4054,0.15774-0.72168,0.0136-1.4762,0.22606-2.1894-0.0228-0.26786,0.28574-0.98321,0.55658-0.55944,0.39321,0.57645,0.91139,1.0451,1.4208,1.5153,0.43771,0.25252,0.0359,0.62445-0.26658,0.74975-0.41521,0.16364-0.51613,0.62086-0.48666,1.0222-0.0582,0.41455-0.22464,0.80685-0.24153,1.23-0.0878,0.62242-0.0706,1.2546-0.15153,1.8765-0.18211,0.60901-0.11244,1.2597-0.17323,1.8875,0.008,0.39859-0.18142,0.7606-0.15525,1.1604-0.0484,0.40592-0.0665,0.89432-0.40713,1.1724-0.32888,0.16605-0.80429,0.13737-1.0682-0.14228z'/%3E %3Cpath d='m461.84,375.69c-0.48222,0.36463-0.91353,0.79527-1.3438,1.2188-0.59251,0.4489,0.48677,0.70998,0.625,1.0938,0.15716,0.58638,0.1478,1.2106,0.1875,1.8125,0.17923,0.55142,0.25835,1.1384,0.21875,1.7188-0.0519,0.6223-0.86338,0.49115-1.2188,0.84375-0.49176,0.20722-0.68789,0.69047-1.0625,1.0312-0.24625,0.48275-0.31215,1.0763-0.34375,1.625,0.0353,0.44788-0.30248,0.94931,0,1.3438,0.039,0.0557,0.0852,0.132,0.125,0.1875,0.10115,0.1452,0.3425,0.0292,0.5,0.0625,0.50368-0.0282,1.0285,0.0473,1.5-0.15625,1.21-0.20943,2.4311-0.22605,3.6562-0.28125,0.74925,0.0239,1.4701-0.23695,2.2188-0.21875,0.58681,0.12974,0.85075-0.50626,0.84375-0.96875-0.33224-0.65359-0.045-1.4285-0.3125-2.0938-0.23494-0.67246-0.14236-1.428-0.25-2.125-0.0148-0.54835-0.71068-0.75172-1.0625-0.34375-0.34144,0.34514-0.89289,0.41403-1.1562,0.84375-0.29659,0.60239,0.62745,0.60317,0.78125,1.0625,0.17589,0.4642,0.11825,0.98059,0.15625,1.4688,0.11422,0.59237-0.52919,0.6262-0.9375,0.6875-0.53675,0.20112-1.29,0.33589-1.5938-0.3125-0.1909-0.47948-0.16475-0.99286-0.21875-1.5-0.0131-0.89182-0.22755-1.7684-0.28125-2.6562-0.0514-1.0968-0.2407-2.1866-0.3125-3.2812-0.01-0.45549-0.0706-1.198-0.71875-1.0625zm-0.625,8.25,0.3125,0.0312,0.0312,0.375,0.0312,0.375-0.40625,0.125c-0.21512,0.0636-0.40325,0.0943-0.40625,0.0937-0.003-0.00085-0.088-0.0531-0.1875-0.125-0.21959-0.1586-0.16345-0.38503,0.125-0.6875,0.1626-0.17028,0.23879-0.2033,0.5-0.1875z'/%3E %3Cpath d='m431.25,374.66c-0.38018,0.13504-0.86245,0.69313-1.25,0.6875-0.88,0.0623-0.75718,0.91919-0.125,1.2188,0.0833,0.25988,0.005,0.58789,0.0312,0.875,0.12288,0.7896-0.37535,1.4249-0.28125,2.2188-0.0442,0.87031-0.30695,1.7177-0.34375,2.5938-0.24704,0.90327-0.24984,1.8321-0.40625,2.75-0.10431,0.82323-0.69963,0.53271-1.2188,0.3125-0.004-0.35689-0.0272-0.70562-0.0312-1.0625,0.21637-0.81711-0.44101-1.0556-1.0938-1.1562-0.68611,0.0649-1.0228-0.52316-0.875-1.125,0.29488-0.35103,1.036-0.2534,1.5-0.3125,0.9813,0.20342,0.9416-1.1118,0.4375-1.5625-0.34472-0.63567-1.1982-0.90926-1.4375-1.5625,0.0956-0.86642-0.47971-1.7322-1.1875-2.1562-1.0885-0.0764-1.9104,0.86306-2.3125,1.7812-0.4525,0.13085-0.90391,0.26657-1.3438,0.4375-0.70889,0.17748-1.7197,1.407-0.75,1.875,0.54424,0.14988,2.2002,0.52782,1.4688,1.2812-0.41224,0.7071-1.201,0.71914-1.9062,0.53125-0.72365,0.00063-1.5294-0.35207-1.5-1.1875-0.14765-0.74985-0.12337-1.5579-0.46875-2.25-0.14847-0.83929-1.1008-0.64297-1.1562,0.125-0.73341,0.53403-0.6357,1.3978-0.125,2.0312,0.31876,0.72891,0.003,1.5776-0.3125,2.25-0.19091,0.87497-1.1559,0.90473-1.8438,1.1875-0.33751,0.13104-1.6285-0.0779-1.1562,0.65625,0.75312,0.26578,1.6525,0.50493,2.4375,0.3125,0.82295-0.10214,1.5375-0.66484,1.9375-1.375,0.55266-0.56003,1.502-0.26685,2.2188-0.28125,0.7728-0.002,1.5626,0.54243,2.3125,0.1875,0.21739-0.56438,1.2219-1.4958,1.5312-0.53125-0.0526,0.86265,0.70932,1.3257,1.5,1.2188,0.86375-0.0494,0.54445,0.61096,0.53125,1.125,0.0571,0.93448,0.65972,1.4247,1.4375,1.8125,0.26491,0.0715,0.545,0.0474,0.8125,0,0.74793-0.23513,1.5536-0.5689,1.7812-1.4062,0.30361-0.68071,0.31071-1.4507,0.53125-2.1562,0.17722-1.1299,0.406-2.26,0.4375-3.4062,0.27617-1.0383,0.19684-2.136,0.40625-3.1875,0.13231-0.7818,0.2308-1.5634,0.3125-2.3438-0.0917-0.41735-0.27189-0.48727-0.5-0.40625zm-6.7812,4.1562c0.15144,0.0185,0.2356,0.20409,0.25,0.53125,0.016,0.36409,0.20628,0.66075,0.4375,0.71875,0.18245,0.0457,0.16681,0.23882-0.0312,0.375-0.11507,0.0791-0.3209,0.127-0.6875,0.125-0.57804-0.003-0.93643-0.15276-1.25-0.46875l-0.1875-0.1875,0.28125-0.1875c0.14178-0.10831,0.39834-0.33259,0.5625-0.5,0.28494-0.29065,0.47356-0.42473,0.625-0.40625z'/%3E %3Cpath d='m490.5,370.94c-0.56713,0.026-1.1373,0.11796-1.6562,0.25-1.0402-0.0647-1.5624,1.0271-0.5625,1.5625,0.60166,1.5343,1.5404-0.31684,2.5-0.1875,1.4375,0.27956,1.559,1.8323,1.7812,3,0.0809,1.1567,0.41439,2.2816,0.75,3.375,0.96222,1.0695-0.72072,1.7402-1.4375,0.90625-0.61128-0.66434-1.9204-1.4795-2.6562-0.5625-0.9036,0.38266-0.94069,1.5903-1.6875,1.9375-1.2091,0.36803-1.3613-1.1188-2-1.75-0.58724-0.82427-1.7103-0.89646-2.625-1.1875-0.42913-0.86865-0.20548-2.3456-1.0938-2.9375-0.7458,0.30425-2.1131,1.7022-0.96875,2.3438,1.1177,0.96067-0.48782,1.4011-1,2.0625-0.73158,0.81456-0.84849,1.936-0.96875,2.9688-1.2593,0.69566-1.5044-0.78769-1.6562-1.7188-0.0981-1.1115-1.0358-0.78521-1.6875-0.375-0.95249,0.38586-1.4281,1.2903-2.0938,2-0.0799,0.64767,0.0372,1.3567,0.0312,2.0312,0.21646,0.81142,1.2024,0.4303,1.8125,0.375,0.9788-0.40937,1.3795,0.62745,0.59375,1.2188-0.53181,0.67603-2.2198,0.32293-2.0625,1.4062,0.54395,0.0636,1.1105,0.0432,1.6562,0,1.0905-0.29799,2.2614-1.0673,2.375-2.2812,0.1436-1.0582,1.6676-0.86544,2.5-1.0938,1.0408-0.30002,2.2948-0.37704,2.5312,0.9375,0.70943,0.74499,2.2486,1.584,3.0312,0.5625,0.79451-0.48523,1.1764-1.3376,1.125-2.25-0.16203-0.78461,1.2688-0.81314,1.625-0.375,0.52141,0.85796,2.151,0.60478,2.9375,0.125,0.8361-0.61721,1.0176-1.705,2.2188-1.7188,1.7823-0.53352,3.6342-0.84122,5.375-1.5,1.4104-0.3073-0.2099-1.1977-0.5625-1.7188-1.0737-0.53098-2.0081,1.6419-3.2188,0.5625-0.93564-0.71605-0.87212-2.0766-1.2188-3.125-0.23714-1.3573-0.17721-2.9227-1.1562-4-0.67242-0.71491-1.586-0.887-2.5312-0.84375zm-6.8125,9.4688c0.12573-0.003,0.26757,0.0593,0.5,0.1875,0.43841,0.24193,0.75063,0.64294,0.75,0.96875-0.00043,0.21261-0.0545,0.22697-0.375,0.375-0.19719,0.091-0.4214,0.1885-0.5,0.1875-0.18098-0.002-0.62438-0.35688-0.625-0.5-0.00065-0.0594-0.0581-0.28649-0.125-0.46875-0.11761-0.32068-0.0994-0.31643,0.0625-0.53125,0.10347-0.13744,0.18677-0.21532,0.3125-0.21875zm6.5312,0.34375c0.37229-0.0244,0.59356,0.0918,0.75,0.375,0.18178,0.32896,0.0582,0.58095-0.40625,0.78125-0.20349,0.0878-0.407,0.15925-0.4375,0.15625-0.0306-0.003-0.19844-0.10253-0.375-0.21875-0.27012-0.17777-0.3095-0.26387-0.3125-0.46875-0.003-0.31541,0.34928-0.5967,0.78125-0.625zm-8.9375,0.0937c0.10904-0.017,0.20831,0.04,0.34375,0.15625,0.17999,0.15456,0.23685,0.27887,0.28125,0.59375,0.0314,0.21884,0.0265,0.50184,0,0.625-0.0486,0.2261-0.0532,0.21575-0.5625,0.21875-0.64029,0.006-0.6997-0.0639-0.6875-0.65625,0.008-0.37682,0.0118-0.4782,0.21875-0.6875,0.16044-0.16228,0.29721-0.23305,0.40625-0.25zm-5.5,1.4375c0.19951,0.0469,0.3879,0.19761,0.4375,0.4375,0.0656,0.3175,0.008,0.46223-0.25,0.59375-0.2221,0.1131-0.73401,0.1508-0.875,0.0625-0.0457-0.0286-0.1399-0.103-0.1875-0.1875-0.068-0.12114-0.0555-0.1794,0.0312-0.25,0.0605-0.0492,0.12539-0.11985,0.125-0.15625-0.0004-0.0364,0.0673-0.16316,0.15625-0.28125,0.14608-0.1939,0.36299-0.26563,0.5625-0.21875zm9.25,1.1875c0.17794-0.001,0.32863,0.0609,0.4375,0.15625,0.18526,0.16231,0.179,0.40039-0.0312,0.5625-0.13509,0.1044-0.87165,0.0948-1.125,0-0.11272-0.0421-0.15563-0.0987-0.15625-0.21875-0.002-0.14091,0.0375-0.22767,0.28125-0.34375,0.20425-0.0976,0.41581-0.15507,0.59375-0.15625z'/%3E %3Cpath d='m467.86,388.29c-0.0958-0.0625-0.23767-0.11699-0.0948-0.22157,0.17277-0.30247,0.51785-0.40716,0.82434-0.51974,0.54779-0.23732,1.0207-0.64036,1.3737-1.1184,0.05-0.33298,0.42384-0.51355,0.42219-0.86174,0.003-0.47487,0.0311-0.9616-0.0846-1.426-0.12837-0.4257-0.45147-0.75199-0.82649-0.97395-0.25667-0.20149-0.674-0.25712-0.76877-0.61402-0.0525-0.34279,0.25343-0.60401,0.36053-0.90935,0.22325-0.42151,0.41109-0.86364,0.6509-1.275,0.25912-0.2878,0.65892-0.0156,0.79298,0.26239,0.18915,0.27771,0.35679,0.57593,0.45076,0.89748,0.30225,0.33175,0.57024,0.72087,0.679,1.1618,0.14839,0.31056,0.38316,0.60234,0.36929,0.96609,0.0003,0.4164,0.23509,0.78738,0.22034,1.2063,0.0133,0.56042,0.0131,1.1449-0.19184,1.6741-0.14001,0.29344-0.42058,0.46964-0.60639,0.73256-0.31897,0.29554-0.67037,0.57899-1.0797,0.73615-0.28928,0.092-0.45706,0.42565-0.81934,0.34466-0.51458,0.009-1.0366,0.079-1.5472-0.004,0.0323,0.0542-0.15633-0.0915-0.12493-0.0573z'/%3E %3Cpath d='m461.01,388.74c-0.24268-0.24958-0.2952-0.35543-0.29788-0.60032-0.003-0.24747,0.0446-0.34567,0.2822-0.58569,0.43829-0.44275,0.65248-0.45344,1.4091-0.0705,0.72304,0.36598,0.9675,0.39912,1.0322,0.14002,0.0625-0.25022,0.47885-0.47916,0.87435-0.4808,0.25006-0.002,0.39157,0.0477,0.59183,0.20368,0.25136,0.19583,0.26349,0.22634,0.26989,0.67935,0.004,0.46299-0.002,0.48055-0.29042,0.73591-0.27723,0.24409-0.32183,0.25915-0.66541,0.22476-0.43718-0.0439-0.69954-0.24407-0.77073-0.58844-0.0516-0.25001-0.13942-0.3097-0.20523-0.1397-0.0209,0.0546-0.12864,0.12185-0.23894,0.1496-0.20352,0.0514-0.5488,0.26862-0.79415,0.50006-0.0927,0.0874-0.25526,0.12855-0.51863,0.13122-0.35563,0.003-0.40513-0.0183-0.67826-0.29915z'/%3E %3Cpath d='m441.19,379.84c-0.66466,0.007-1.3805,0.5662-1.4688,1.2188,0.15206,0.75226,0.77698,1.4895,0.375,2.2812,0.27756,1.0131-0.76147,1.3974-1.4688,0.8125-0.4271-0.97134-0.64349-2.0358-1.2812-2.9062-0.80411-0.22762-1.1545,1.0569-1.7188,1.5,0.27975,0.75505,1.0958,1.4324,1.1875,2.375,0.1952,0.91482-0.36128,1.9306-1.1562,2.4062-0.68584,0.65472-1.6254,0.42074-2.4688,0.5625-1.0242,0.59857,0.75182,0.81755,1.2188,0.84375,1.0477,0.10646,2.1354-0.0317,2.9062-0.8125,0.76911-0.36708,0.70971-1.6972,1.625-1.8438,1.5884-0.0709,3.1626,0.24355,4.75,0.28125,0.84936,0.20336,2.1635-0.10098,2.75,0.53125,0.002,1.1075,0.94078,1.7905,1.8438,2.2188,0.4987,0.13872,1.0241-0.47928,1.5312-0.59375,0.96531-0.30764,0.67182-1.502,1.25-1.9688,1.6504-0.0893,3.3163-0.0704,4.9688-0.0937,0.31463,0.008,0.40734-0.43988,0.625-0.625-0.0363-0.63881-0.0593-1.2726-0.15625-1.9062-0.31819-0.80653,0.0513-1.8446-0.53125-2.5312-0.83011-0.22606-1.5362,0.53355-2.375,0.59375-0.92616,0.41246-1.7065,1.2677-1.75,2.3125-0.54833,0.89658-1.4277-0.15958-1.125-0.90625-0.0346-0.32541,0.0704-0.70429-0.0312-1-0.50698-0.60814-1.3947-0.4094-2.0938-0.5-1.0184,0.0406-2.0127-0.17955-3.0312-0.15625-0.89293-0.0674-1.822,0.0777-2.6875-0.15625-1.0317-0.0293-0.88959-1.0382-1.0625-1.75-0.18299-0.13571-0.40345-0.18973-0.625-0.1875zm2,3.6875c0.34308,0.007,0.66656,0.052,1,0.0937,0.43082,0.0709,0.8899-0.14816,1.3125,0,0.97651,0.16608,1.9536,0.12685,2.9375,0.21875,0.25985-0.004,0.44579,0.18471,0.625,0.34375,0.002,0.68357,0.00066,1.3789,0,2.0625-0.0299,0.25767,0.0763,0.5982-0.15625,0.78125-0.0747,0.0513-0.1583,0.1072-0.25,0.125-0.27065-0.07-0.55731-0.2479-0.6875-0.5-0.0414-0.35742,0.0179-0.70404,0.0312-1.0625-0.007-0.0927,0.0404-0.237,0-0.3125-0.21278-0.15067-0.45387-0.249-0.71875-0.25-0.84945-0.0291-1.682-0.0916-2.5312-0.125-0.7069-0.0446-1.4333,0.0604-2.125-0.125-0.26845-0.0976-0.61789-0.0641-0.78125-0.34375-0.23417-0.27227,0.10362-0.59695,0.34375-0.71875,0.31827-0.1447,0.65692-0.19411,1-0.1875zm11.281,0.25c0.15866-0.002,0.20935,0.05,0.28125,0.34375,0.0459,0.18765,0.0996,0.4172,0.125,0.5,0.0363,0.11811-0.0218,0.15625-0.1875,0.21875-0.494,0.18646-0.98566,0.16797-1.1562-0.0625-0.0774-0.10454,0.0129-0.43451,0.15625-0.5625,0.28946-0.25851,0.60992-0.43691,0.78125-0.4375z'/%3E %3C/g%3E %3C/g%3E %3Cpath stroke-width='1.1502' d='m449.98,327.23c32.642-25.106,29.843-61.883,29.843-61.883-0.8613,0.17223-1.6795,0.25835-2.5408,0.25835-6.8471,0-23.178-3.9171-26.988-8.8926-4.0812,4.5034-20.77,8.8926-27.574,8.8926-0.86129,0-1.7225-0.0861-2.5407-0.25835,0,0-2.8422,36.776,29.8,61.883z'/%3E %3Cpath stroke-width='0.9157' d='m477.22,268.04c-0.28097,0.0176-0.5633,0.0264-0.8477,0.0264-6.2055,0-20.619-3.1838-26.175-7.9572-5.8195,4.4095-20.471,7.9572-26.576,7.9572-0.28635,0-0.56925-0.035-0.84965-0.0865-0.0142,1.3908,0.0581,2.8324,0.14448,4.1436,0.323,4.9008,1.1826,9.819,2.4876,14.552,4.1081,14.895,12.516,27.553,24.572,37.155,12.066-9.61,20.484-22.28,24.601-37.186,1.3071-4.7319,2.1694-9.6497,2.4955-14.55,0.0853-1.2845,0.15716-2.6918,0.14745-4.0545z'/%3E %3Cpath fill='%23c09300' stroke='none' d='m439.38,265.03c-5.8724,1.8448-12.229,3.0312-15.75,3.0312-0.28633,0-0.56336-0.0423-0.84375-0.0937-0.0142,1.3907,0.0699,2.8451,0.15625,4.1562,0.32298,4.9006,1.1638,9.7995,2.4688,14.531,2.765,10.025,7.5063,19.032,13.969,26.781v-48.406z'/%3E %3Cpath fill='%23c09300' stroke='none' d='m460,264.94,0,49.25c6.794-7.9213,11.733-17.206,14.594-27.562,1.307-4.7317,2.1427-9.6313,2.4688-14.531,0.0853-1.2844,0.16596-2.6999,0.15625-4.0625-0.28095,0.0176-0.55937,0.0312-0.84375,0.0312-3.7302,0-10.42-1.1704-16.375-3.125z'/%3E %3Cg stroke-width='1.2704'%3E %3Cpath stroke-width='1.2179' d='m462.31,253.09c0.66655,0.0392-0.90178-3.568-0.90178-3.568,1.7643,1.8036,8.4297,2.2349,8.4297,2.2349-3.999-1.7656-7.9979-15.096-7.528-25.721,0.4319-10.664-1.5284-14.859-3.0971-16.428-1.9995-1.9995-8.4298-3.7639-12.664-3.9991-2.3922-0.11761-1.9995,1.8036-1.9995,1.8036-4.4308-1.137-8.8606-1.5684-10.861-0.2353-1.882,1.2547-2.274,7.5278-0.90178,6.43,3.3326-2.6661,6.2341-0.23524,8.2335,2.6661,1.7644,2.5485,1.6467,9.7627-0.90178,18.192-2.6661,8.8609-9.9588,17.722-9.9588,17.722,3.96,0,9.5276-3.5287,9.5276-3.5287l-1.3331,5.5283c4.1951-1.9996,7.5278-5.0969,7.5278-5.0969l3.9992,4.1951c1.333-1.7643,3.9991-4.1951,3.9991-4.1951s3.3328,3.5286,8.4297,3.9992z'/%3E %3Cpath fill='none' d='m446.12,227.57s-2.2349,16.428-6.43,21.094'/%3E %3Cpath fill='none' d='m449.65,227.14s-0.86252,16.623-3.7639,21.956'/%3E %3Cpath fill='none' d='m452.78,227.81s0,18.192,1.0978,21.289'/%3E %3Cpath fill='none' d='m456.74,228.71s0.90178,15.291,4.6657,20.819'/%3E %3Cpath fill='%23c09300' stroke-width='0.3542' d='m442.08,219.61c-0.19598-1.4508-0.54888-2.5878-1.0586-3.3328-1.9996-2.9013-4.9009-5.3321-8.2335-2.6661,0,0,1.137-3.5287,3.5678-3.6463,1.882-0.11767,6.1556,1.4115,9.9196,7.8415,0,0-2.7837-0.62739-3.4502-0.0393-1.2546,1.0979-0.74495,1.8428-0.74495,1.8428z'/%3E %3Cpath fill='%23c09300' stroke-width='0.3542' d='m432.44,209.26c0.27439-0.90178,0.7057-1.7251,1.2546-2.078,1.9996-1.333,6.43-0.90177,10.86,0.23524,0,0-0.39205-1.9212,1.9996-1.8036,4.2344,0.23523,10.665,1.9996,12.664,3.9992,0.47046,0.50973,1.0194,1.2547,1.4899,2.3916h-0.0784c-0.98015-1.3721-3.764-1.2937-4.4308-1.2154-1.0586,0.11756-1.7251,0.0784-3.1365,0.4312-0.66655,0.15693-1.686,0.3529-2.2349,0.78422-0.43131,0.3529-0.7841,1.6467-1.4506,1.6467-1.0586,0-0.98019-0.27449-1.2547-0.58814-0.35279-0.43131-0.54888-1.0586-0.90178-1.0194-1.0978,0.19608-2.8621-0.66644-5.0969-2.4308-2.2344-1.7644-3.0971-2.1956-5.9984-1.9996-2.8622,0.23524-3.7639,1.8427-3.7639,1.8427l0.0784-0.19598z'/%3E %3Ccircle cx='448.824' cy='210.672' r='1.176' stroke='none'/%3E %3C/g%3E %3C/g%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 600 300'%3E %3Crect width='600' height='150' fill='%23000'/%3E %3Crect y='150' width='600' height='150' fill='%23007a3d'/%3E %3Crect y='100' width='600' height='100' fill='%23fff'/%3E %3Cpath d='M 0,0 200,150 0,300 z' fill='%23c4111b'/%3E %3Ccircle cx='300' cy='150' r='40' fill='%23c4111b'/%3E %3Ccircle cx='315' cy='150' r='40' fill='%23fff'/%3E %3Cpath d='m 289.26294,174.2204 17.05633,-12.19273 16.92296,12.37709 -6.32527,-19.98928 17.00081,-12.26999 -20.96556,-0.16131 -6.41591,-19.96036 -6.63215,19.88957 -20.96606,-0.0661 16.86669,12.45373 -6.54184,19.91946 z' fill='%23c4111b'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1000 500'%3E %3Crect width='1000' height='500' fill='%23ea0437'/%3E %3Cpath d='M 0,500 H 1000 V 250' fill='%234189dd'/%3E %3Cpath d='M 0,0 H 1000 V 250' fill='%2312ad2b'/%3E %3Cpath d='m 230.24958,369.16163 c -10.81019,2.98487 -17.00779,11.37176 -16.84908,19.28459 l 53.21067,-.21363 c .47814,-8.50288 -6.51706,-16.36688 -17.16651,-19.46365 52.09769,-1.07633 97.35688,-20.59084 105.581,-33.1122 -8.13867,-3.53218 -17.549,2.15268 -24.25731,.84438 15.92738,-7.36142 63.64648,-38.2477 55.88829,-71.3599 -6.03077,18.39137 -24.30006,33.60865 -32.08062,37.69427 17.82572,-27.0672 42.16648,-55.24736 21.04864,-77.06919 1.06617,12.64749 -8.03695,26.56668 -12.05744,27.61248 10.34017,-28.59929 20.20628,-64.50713 -2.19744,-88.17848 2.94212,8.55578 1.75387,32.69103 -2.29716,33.77551 -1.24724,-19.44736 -4.56579,-60.35236 -25.04676,-59.77044 6.50483,5.79067 9.35132,21.59597 9.49579,37.55999 -4.66752,-10.93635 -9.97191,-19.17065 -21.31722,-27.24625 -9.1784,-17.60192 -25.50865,-32.18643 -41.84094,-42.63446 1.83323,12.81231 3.3511,22.92055 21.2399,36.20897 -9.32691,-.57988 -18.65181,-18.26115 -28.61965,-18.75151 -7.9291,-.38252 -14.15112,7.18442 -27.10788,2.83023 1.43443,4.27687 7.47944,6.17115 8.75516,9.33506 -2.77528,1.91666 -9.36353,-.2991 -14.84086,-3.1517 7.53437,10.26287 19.2093,16.29769 29.12018,14.26099 11.78683,-2.26662 24.42417,-1.0682 36.47755,5.79067 -3.07847,1.58094 -15.06063,1.57076 -22.74963,.60837 6.98908,7.07657 11.67696,11.76649 23.83003,11.68917 10.85496,-.0712 16.54593,-5.79067 19.33342,-2.24831 6.80802,8.06746 11.39008,16.13085 17.08512,25.62869 -12.58035,1.38968 -8.78773,-14.22843 -22.79846,-22.21654 -7.87213,16.29363 9.05427,35.60873 20.57661,43.63753 .15464,12.24667 1.94515,22.49328 7.13964,31.81816 3.50167,6.57402 8.02882,13.30267 6.32173,28.13947 -6.89753,-5.0236 -13.63838,-21.96628 -11.15813,-35.41544 -8.6331,2.35412 -12.00862,17.53477 -7.93928,25.177 3.0398,5.81712 5.06836,16.95083 1.56263,21.92763 -3.41621,4.63701 -3.77431,4.11816 -3.72955,14.06973 .12208,5.95547 -3.2046,12.99747 -8.62293,17.90712 1.13128,-4.19549 2.42126,-11.4145 1.1679,-15.9274 -4.28297,7.26581 -15.02806,14.78391 -18.41171,22.59501 -3.32262,7.82941 -4.16498,21.39048 -20.24496,24.51776 -20.68648,4.10597 -27.82614,7.69106 -41.13694,13.13786 -1.47717,-10.11027 2.94416,-31.19351 11.39822,-29.99103 8.25464,1.46904 33.28107,-8.62292 24.32853,-29.70616 -1.76813,6.64524 -7.66663,13.12972 -14.04328,13.41661 6.88939,-8.9383 19.18489,-18.19401 13.19686,-33.17121 -3.32872,6.36648 -8.56392,14.00667 -16.5032,18.30592 8.51101,-16.30991 .98885,-21.18904 -9.11736,-7.75616 -3.81704,5.1823 -6.12232,15.56724 -8.54765,28.75598 -3.96963,-10.72678 -3.70716,-24.84738 -8.41131,-36.31274 -4.91373,-12.39928 6.52111,-15.67305 11.90282,-14.67811 13.17651,3.51795 35.19773,3.51591 33.56185,-18.25301 -5.69096,7.36346 -15.67102,9.63823 -26.44865,6.98704 12.10424,-8.83859 21.66109,-25.46387 8.17326,-34.14377 -.44966,9.20485 -7.57304,19.52469 -17.08309,24.27768 -2.22592,-7.76634 -2.22592,-16.00879 -.3174,-25.04475 -5.31048,5.58923 -9.18856,17.2194 -12.27312,30.44068 -.23196,-13.06868 2.24017,-22.48513 4.0734,-29.51491 2.77936,-10.26897 9.68706,-3.58712 20.26124,-2.83022 10.18352,.57784 24.20443,-5.05005 21.52476,-18.85935 -3.47724,5.46309 -10.61486,7.58932 -17.90712,7.01148 8.7796,-5.31863 24.07624,-14.76967 15.6873,-29.30738 -3.52405,5.50581 -4.6655,10.21606 -14.8653,11.90485 2.67152,-6.14471 3.11509,-14.83274 11.03199,-18.27539 -14.12264,-2.81192 -22.20842,6.456 -26.31845,20.97132 -1.6664,-10.06347 -3.65019,-13.7686 -4.04493,-21.13003 7.63408,-8.47848 8.43371,-25.06509 -8.0939,-28.7743 -.98072,8.55579 -.68976,10.59453 1.19027,17.56123 -7.75819,-4.60852 -18.6925,-7.15186 -25.97254,-.63481 4.93203,5.3227 12.56611,10.00854 24.3326,4.20363 -2.77936,9.09292 -10.00854,7.53641 -19.94179,4.06932 6.07146,11.40432 13.73402,13.43087 22.1901,12.11647 4.42744,11.67289 4.62277,20.54201 -8.3157,37.54168 .59819,-10.564 -.15259,-18.43411 -8.5456,-26.97565 -7.19256,-7.04402 -13.03816,.30114 -1.79865,15.96198 -6.81818,-5.02156 -14.53567,-15.21321 -16.85927,-25.40284 -2.2483,12.58849 -.22381,27.42531 6.74493,35.74304 -3.29616,3.522 -7.04403,-.37439 -12.5885,-8.99122 2.09775,27.57587 13.8622,32.89653 29.67362,26.74981 .44966,15.13589 .44966,29.1507 1.34898,47.43424 -9.21908,-13.26199 -20.90623,-23.15455 -27.42733,-25.62667 -2.02247,7.41841 5.62179,17.08308 9.89256,22.47902 -6.51909,-1.34898 -20.68242,-12.13883 -20.68242,-12.13883 -1.42427,12.28941 14.46447,23.67949 24.72938,28.77429 -12.06357,-.52495 -17.38626,-5.0948 -25.17904,-12.5885 .15057,34.09496 36.94145,28.17406 43.83694,22.92869 .89933,16.78601 2.18117,36.19065 3.0805,52.97669 -10.40123,-1.81493 -9.5833,-4.94223 -18.48295,-5.76626 -24.70088,-.9624 -44.29473,-29.65123 -50.78329,-50.75482 -1.86173,3.47317 -.38456,7.10709 -2.08757,11.3738 -4.01034,-10.3585 -9.13363,-23.73645 -16.00471,-29.96253 1.74981,6.03889 1.93497,12.17545 1.3266,23.46176 -2.35818,-7.31259 -4.55155,-9.5548 -4.71026,-18.13907 .15057,-6.59029 6.35834,-11.45316 6.01449,-20.72311 -.25434,-6.76731 -6.42752,-21.43525 -7.33499,-32.79073 -2.98893,11.68715 -4.86489,24.00707 -9.44289,31.24235 2.27476,-12.48066 1.54553,-21.09341 5.3939,-29.49253 4.44575,-8.84267 8.22617,-16.73718 5.26573,-25.66125 -2.83837,3.44674 -1.86173,6.57808 -8.99304,14.95279 -1.54899,-9.10719 9.22092,-23.68356 19.67301,-29.5434 7.37162,-3.88419 16.66394,-17.77691 10.6108,-27.29915 -6.93211,4.97883 -10.04516,11.70544 -19.83802,23.1993 6.98502,-27.30527 25.13426,-34.44899 46.8625,-34.54258 4.80792,-.0224 14.50109,-1.75796 17.22144,-8.12037 -6.12435,2.36429 -13.36574,2.66542 -19.80954,1.37544 4.68991,-6.88532 14.5662,-5.99007 23.769,-6.03076 7.219,-.0346 18.48904,-1.01327 23.04467,-11.29445 -8.80605,3.815 -22.54007,4.60853 -31.18741,1.90648 13.75232,-7.12541 35.29336,-7.89248 46.34162,-17.24382 -12.59256,-9.39813 -44.10349,2.18931 -64.00661,15.8399 5.56278,-5.08667 14.35457,-14.11043 19.20523,-21.39454 -10.88547,-5.21893 -38.41454,25.27873 -47.89814,43.39949 -9.00748,5.08666 -12.61088,13.06054 -16.10848,18.62537 4.79979,-16.21836 5.30845,-27.98688 9.31268,-41.34245 -30.87691,10.62911 -18.04263,67.6792 -24.75887,81.32776 .79047,-15.06877 .15036,-34.42661 -6.05355,-44.40869 -9.51045,7.25563 -10.27792,49.95927 -1.34898,85.51104 -3.22434,-9.51411 -9.31004,-18.39545 -11.2625,-29.97475 -14.075438,25.67142 8.25119,55.95747 26.9207,79.8811 -14.05509,-7.32073 -27.95188,-23.06704 -37.08022,-36.26796 2.51954,45.94689 50.5009,55.49356 57.94982,66.78596 -10.11027,-4.70617 -29.43881,-14.01886 -37.64056,-4.26059 13.3519,3.08253 24.00218,6.64523 32.58441,12.27109 12.45217,15.54691 36.03195,22.34677 77.09767,24.06403 z' fill='%23ffc726'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' height='500' width='750' viewBox='0 0 750 500'%3E %3Cpath fill='%23c60b1e' d='M0 0h750v500H0z'/%3E %3Cpath fill='%23ffc400' d='M0 125h750v250H0z'/%3E %3Cpath d='M167.99 222.24s-.51 0-.8-.16c-.27-.16-1.12-.96-1.12-.96l-.68-.49-.62-.85s-.73-1.18-.4-2.09c.34-.9.9-1.23 1.42-1.5.5-.26 1.58-.59 1.58-.59s.85-.37 1.13-.42c.28-.06 1.3-.33 1.3-.33s.28-.15.56-.26c.29-.1.68-.1.9-.16.23-.06.8-.24 1.14-.26.52-.02 1.35.1 1.64.1.28 0 1.24.05 1.64.05.39 0 1.8-.1 2.2-.1.4 0 .68-.06 1.13 0 .45.05 1.24.31 1.47.42.23.1 1.58.6 2.1.75.5.16 1.74.37 2.31.64.56.27.9.72 1.19 1.1.28.37.34.78.45 1.05.1.26.11.84 0 1.1-.11.27-.51.82-.51.82l-.62 1.02-.8.64s-.56.54-1 .48c-.46-.05-5.04-.86-7.98-.86-2.94 0-7.63.86-7.63.86' fill='%23ad1519'/%3E %3Cpath d='M167.99 222.24s-.51 0-.8-.16c-.27-.16-1.12-.96-1.12-.96l-.68-.49-.62-.85s-.73-1.18-.4-2.09c.34-.9.9-1.23 1.42-1.5.5-.26 1.58-.59 1.58-.59s.85-.37 1.13-.42c.28-.06 1.3-.33 1.3-.33s.28-.15.56-.26c.29-.1.68-.1.9-.16.23-.06.8-.24 1.14-.26.52-.02 1.35.1 1.64.1.28 0 1.24.05 1.64.05.39 0 1.8-.1 2.2-.1.4 0 .68-.06 1.13 0 .45.05 1.24.31 1.47.42.23.1 1.58.6 2.1.75.5.16 1.74.37 2.31.64.56.27.9.72 1.19 1.1.28.37.34.78.45 1.05.1.26.11.84 0 1.1-.11.27-.51.82-.51.82l-.62 1.02-.8.64s-.56.54-1 .48c-.46-.05-5.04-.86-7.98-.86-2.94 0-7.63.86-7.63.86z' fill='none' stroke='%23000' stroke-linejoin='round' stroke-width='.26'/%3E %3Cpath d='M174.28 215.68c0-1.38.62-2.5 1.38-2.5.76 0 1.38 1.12 1.38 2.5s-.62 2.5-1.38 2.5c-.76 0-1.38-1.12-1.38-2.5' fill='%23c8b100'/%3E %3Cpath d='M174.28 215.68c0-1.38.62-2.5 1.38-2.5.76 0 1.38 1.12 1.38 2.5s-.62 2.5-1.38 2.5c-.76 0-1.38-1.12-1.38-2.5z' fill='none' stroke='%23000' stroke-width='.26'/%3E %3Cpath d='M175.05 215.68c0-1.27.28-2.3.63-2.3s.64 1.03.64 2.3c0 1.26-.28 2.3-.64 2.3-.35 0-.63-1.04-.63-2.3' fill='%23c8b100'/%3E %3Cpath d='M175.05 215.68c0-1.27.28-2.3.63-2.3s.64 1.03.64 2.3c0 1.26-.28 2.3-.64 2.3-.35 0-.63-1.04-.63-2.3z' fill='none' stroke='%23000' stroke-width='.26'/%3E %3Cpath d='M174.75 213.04a.9.9 0 0 1 .93-.87c.5 0 .92.4.92.87 0 .49-.41.87-.92.87-.52 0-.93-.38-.93-.87' fill='%23c8b100'/%3E %3Cpath d='M176.33 212.74v.58h-1.43v-.58h.47v-1.31h-.62v-.58h.62v-.57h.6v.57h.62v.58h-.62v1.3h.36' fill='%23c8b100'/%3E %3Cpath d='M176.33 212.74v.58h-1.43v-.58h.47v-1.31h-.62v-.58h.62v-.57h.6v.57h.62v.58h-.62v1.3h.36' fill='none' stroke='%23000' stroke-width='.3'/%3E %3Cpath d='M176.97 212.74v.58h-2.54v-.58h.94v-1.31h-.62v-.58h.62v-.57h.6v.57h.62v.58h-.62v1.3h1' fill='%23c8b100'/%3E %3Cpath d='M176.97 212.74v.58h-2.54v-.58h.94v-1.31h-.62v-.58h.62v-.57h.6v.57h.62v.58h-.62v1.3h1' fill='none' stroke='%23000' stroke-width='.3'/%3E %3Cpath d='M175.94 212.2c.38.1.66.45.66.84 0 .49-.41.87-.92.87-.52 0-.93-.38-.93-.87 0-.4.3-.75.69-.84' fill='none' stroke='%23000' stroke-width='.26'/%3E %3Cpath d='M175.68 222.08h-4.8l-.12-1.18-.23-1.23-.24-1.53c-1.32-1.75-2.54-2.9-2.95-2.65.1-.32.22-.56.47-.71 1.18-.7 3.6.98 5.44 3.74.16.25.32.5.46.75h3.97c.14-.25.3-.5.46-.75 1.83-2.76 4.26-4.44 5.43-3.74.26.15.37.39.47.71-.4-.24-1.62.9-2.95 2.65l-.24 1.53-.23 1.23-.1 1.18h-4.84' fill='%23c8b100'/%3E %3Cpath d='M175.68 222.08h-4.8l-.12-1.18-.23-1.23-.24-1.53c-1.32-1.75-2.54-2.9-2.95-2.65.1-.32.22-.56.47-.71 1.18-.7 3.6.98 5.44 3.74.16.25.32.5.46.75h3.97c.14-.25.3-.5.46-.75 1.83-2.76 4.26-4.44 5.43-3.74.26.15.37.39.47.71-.4-.24-1.62.9-2.95 2.65l-.24 1.53-.23 1.23-.1 1.18h-4.84z' fill='none' stroke='%23000' stroke-width='.26'/%3E %3Cpath d='M167.55 215.44c.9-.53 3.02 1.15 4.73 3.74m11.55-3.74c-.9-.53-3.01 1.15-4.73 3.74' fill='none' stroke='%23000' stroke-width='.26'/%3E %3Cpath d='M168.58 224.25c-.2-.57-.58-1.08-.58-1.08a28.7 28.7 0 0 1 7.67-.94c3.01 0 5.75.37 7.69.94l-.52.91c-.17.3-.39.81-.38.81a23.8 23.8 0 0 0-6.8-.82c-2.79 0-5.46.35-6.86.86.02 0-.1-.32-.23-.68' fill='%23c8b100'/%3E %3Cpath d='M168.58 224.25c-.2-.57-.58-1.08-.58-1.08a28.7 28.7 0 0 1 7.67-.94c3.01 0 5.75.37 7.69.94l-.52.91c-.17.3-.39.81-.38.81a23.8 23.8 0 0 0-6.8-.82c-2.79 0-5.46.35-6.86.86.02 0-.1-.32-.23-.68' fill='none' stroke='%23000' stroke-width='.26'/%3E %3Cpath d='M175.67 226.73c2.43 0 5.11-.38 6.1-.63.66-.2 1.05-.5.98-.84-.04-.16-.18-.3-.37-.38-1.46-.47-4.07-.8-6.7-.8-2.65 0-5.28.33-6.73.8-.19.08-.33.22-.36.38-.08.35.31.65.97.84.99.25 3.68.62 6.11.63' fill='%23c8b100'/%3E %3Cpath d='M175.67 226.73c2.43 0 5.11-.38 6.1-.63.66-.2 1.05-.5.98-.84-.04-.16-.18-.3-.37-.38-1.46-.47-4.07-.8-6.7-.8-2.65 0-5.28.33-6.73.8-.19.08-.33.22-.36.38-.08.35.31.65.97.84.99.25 3.68.62 6.11.63z' fill='none' stroke='%23000' stroke-width='.26'/%3E %3Cpath d='M183.48 222.08l-.6-.53s-.56.34-1.27.24c-.7-.11-.93-.97-.93-.97s-.8.67-1.44.62a1.7 1.7 0 0 1-1.07-.62s-.7.5-1.33.46c-.62-.06-1.21-.83-1.21-.83s-.63.8-1.25.86c-.62.05-1.13-.54-1.13-.54s-.28.59-1.07.72c-.8.13-1.47-.62-1.47-.62s-.45.73-.99.92c-.53.18-1.24-.27-1.24-.27l-.2.43c-.09.16-.31.19-.31.19l.18.47c1.93-.56 4.56-.9 7.53-.9 2.97 0 5.67.34 7.61.9l.2-.53' fill='%23c8b100'/%3E %3Cpath d='M183.48 222.08l-.6-.53s-.56.34-1.27.24c-.7-.11-.93-.97-.93-.97s-.8.67-1.44.62a1.7 1.7 0 0 1-1.07-.62s-.7.5-1.33.46c-.62-.06-1.21-.83-1.21-.83s-.63.8-1.25.86c-.62.05-1.13-.54-1.13-.54s-.28.59-1.07.72c-.8.13-1.47-.62-1.47-.62s-.45.73-.99.92c-.53.18-1.24-.27-1.24-.27l-.2.43c-.09.16-.31.19-.31.19l.18.47c1.93-.56 4.56-.9 7.53-.9 2.97 0 5.67.34 7.61.9l.2-.53z' fill='none' stroke='%23000' stroke-width='.26'/%3E %3Cpath d='M175.69 219.5l.28.04a1.09 1.09 0 0 0 1.06 1.43c.5 0 .91-.3 1.06-.73.01.01.1-.38.15-.38.03 0 .03.41.05.4.07.53.55.9 1.1.9.62 0 1.1-.47 1.1-1.06v-.12l.35-.35.2.44a.9.9 0 0 0-.11.46c0 .56.47 1 1.06 1 .37 0 .7-.17.88-.44l.23-.29v.35c0 .35.15.66.49.72 0 0 .38.03.9-.38.52-.41.81-.75.81-.75l.03.42s-.5.84-.97 1.1c-.25.15-.64.3-.95.25-.32-.04-.55-.3-.67-.6-.23.13-.5.21-.8.21-.63 0-1.2-.35-1.42-.86a1.62 1.62 0 0 1-2.42-.08 1.63 1.63 0 0 1-2.43-.26 1.62 1.62 0 0 1-2.42.26 1.63 1.63 0 0 1-2.42.08c-.22.5-.79.86-1.42.86-.29 0-.56-.08-.8-.22-.11.3-.34.56-.67.61-.3.06-.69-.1-.94-.25-.47-.26-1.02-1.1-1.02-1.1l.07-.42s.3.34.8.75c.53.41.92.38.92.38.34-.06.49-.37.49-.72v-.35l.22.29c.19.27.51.45.88.45.59 0 1.06-.45 1.06-1.01a.94.94 0 0 0-.1-.46l.2-.44.34.35-.01.12c0 .59.5 1.06 1.11 1.06.55 0 1.03-.37 1.1-.9.02.01.02-.4.05-.4.05 0 .14.4.16.38.14.42.56.73 1.06.73a1.09 1.09 0 0 0 1.06-1.43l.29-.05' fill='%23c8b100'/%3E %3Cpath d='M175.69 219.5l.28.04a1.09 1.09 0 0 0 1.06 1.43c.5 0 .91-.3 1.06-.73.01.01.1-.38.15-.38.03 0 .03.41.05.4.07.53.55.9 1.1.9.62 0 1.1-.47 1.1-1.06v-.12l.35-.35.2.44a.9.9 0 0 0-.11.46c0 .56.47 1 1.06 1 .37 0 .7-.17.88-.44l.23-.29v.35c0 .35.15.66.49.72 0 0 .38.03.9-.38.52-.41.81-.75.81-.75l.03.42s-.5.84-.97 1.1c-.25.15-.64.3-.95.25-.32-.04-.55-.3-.67-.6-.23.13-.5.21-.8.21-.63 0-1.2-.35-1.42-.86a1.62 1.62 0 0 1-2.42-.08 1.63 1.63 0 0 1-2.43-.26 1.62 1.62 0 0 1-2.42.26 1.63 1.63 0 0 1-2.42.08c-.22.5-.79.86-1.42.86-.29 0-.56-.08-.8-.22-.11.3-.34.56-.67.61-.3.06-.69-.1-.94-.25-.47-.26-1.02-1.1-1.02-1.1l.07-.42s.3.34.8.75c.53.41.92.38.92.38.34-.06.49-.37.49-.72v-.35l.22.29c.19.27.51.45.88.45.59 0 1.06-.45 1.06-1.01a.94.94 0 0 0-.1-.46l.2-.44.34.35-.01.12c0 .59.5 1.06 1.11 1.06.55 0 1.03-.37 1.1-.9.02.01.02-.4.05-.4.05 0 .14.4.16.38.14.42.56.73 1.06.73a1.09 1.09 0 0 0 1.06-1.43l.29-.05z' fill='none' stroke='%23000' stroke-width='.26'/%3E %3Cpath d='M175.67 222.23c-3.01 0-5.72.37-7.67.94-.13.04-.29-.06-.33-.17-.04-.13.05-.28.18-.32 1.95-.6 4.73-.97 7.82-.98 3.09 0 5.88.38 7.83.98.13.04.22.2.18.32-.04.11-.2.21-.33.17a28.45 28.45 0 0 0-7.68-.94' fill='%23c8b100'/%3E %3Cpath d='M175.67 222.23c-3.01 0-5.72.37-7.67.94-.13.04-.29-.06-.33-.17-.04-.13.05-.28.18-.32 1.95-.6 4.73-.97 7.82-.98 3.09 0 5.88.38 7.83.98.13.04.22.2.18.32-.04.11-.2.21-.33.17a28.45 28.45 0 0 0-7.68-.94z' fill='none' stroke='%23000' stroke-linejoin='round' stroke-width='.26'/%3E %3Cpath d='M172.75 223.3c0-.22.2-.4.44-.4s.44.18.44.4c0 .23-.2.41-.44.41s-.44-.18-.44-.4' fill='%23fff'/%3E %3Cpath d='M172.75 223.3c0-.22.2-.4.44-.4s.44.18.44.4c0 .23-.2.41-.44.41s-.44-.18-.44-.4z' fill='none' stroke='%23000' stroke-width='.26'/%3E %3Cpath d='M175.7 223.48h-.96c-.18 0-.33-.14-.33-.31 0-.17.14-.3.32-.3h1.96c.19 0 .33.13.33.3 0 .17-.15.31-.33.31h-.98' fill='%23ad1519'/%3E %3Cpath d='M175.7 223.48h-.96c-.18 0-.33-.14-.33-.31 0-.17.14-.3.32-.3h1.96c.19 0 .33.13.33.3 0 .17-.15.31-.33.31h-.98' fill='none' stroke='%23000' stroke-width='.26'/%3E %3Cpath d='M170.85 223.81l-.7.1c-.17.03-.34-.08-.37-.25a.3.3 0 0 1 .27-.35l.7-.1.71-.11c.18-.02.34.09.37.25.02.17-.1.33-.27.35l-.71.11' fill='%23058e6e'/%3E %3Cpath d='M170.85 223.81l-.7.1c-.17.03-.34-.08-.37-.25a.3.3 0 0 1 .27-.35l.7-.1.71-.11c.18-.02.34.09.37.25.02.17-.1.33-.27.35l-.71.11' fill='none' stroke='%23000' stroke-width='.26'/%3E %3Cpath d='M168.05 224.3l.3-.5.66.13-.38.56-.58-.19' fill='%23ad1519'/%3E %3Cpath d='M168.05 224.3l.3-.5.66.13-.38.56-.58-.19' fill='none' stroke='%23000' stroke-width='.26'/%3E %3Cpath d='M177.72 223.3c0-.22.2-.4.44-.4s.43.18.43.4c0 .23-.2.41-.43.41-.25 0-.44-.18-.44-.4' fill='%23fff'/%3E %3Cpath d='M177.72 223.3c0-.22.2-.4.44-.4s.43.18.43.4c0 .23-.2.41-.43.41-.25 0-.44-.18-.44-.4z' fill='none' stroke='%23000' stroke-width='.26'/%3E %3Cpath d='M180.5 223.81l.7.1c.17.03.34-.08.37-.25a.3.3 0 0 0-.27-.35l-.7-.1-.71-.11c-.18-.02-.34.09-.37.25-.03.17.1.33.27.35l.7.11' fill='%23058e6e'/%3E %3Cpath d='M180.5 223.81l.7.1c.17.03.34-.08.37-.25a.3.3 0 0 0-.27-.35l-.7-.1-.71-.11c-.18-.02-.34.09-.37.25-.03.17.1.33.27.35l.7.11' fill='none' stroke='%23000' stroke-width='.26'/%3E %3Cpath d='M183.24 224.33l-.25-.53-.67.06.32.59.6-.12' fill='%23ad1519'/%3E %3Cpath d='M183.24 224.33l-.25-.53-.67.06.32.59.6-.12' fill='none' stroke='%23000' stroke-width='.26'/%3E %3Cpath d='M175.66 226.16c-2.43 0-4.63-.22-6.3-.65 1.67-.43 3.87-.7 6.3-.7 2.44 0 4.65.27 6.33.7-1.68.44-3.9.65-6.33.65' fill='%23ad1519'/%3E %3Cpath d='M175.66 226.16c-2.43 0-4.63-.22-6.3-.65 1.67-.43 3.87-.7 6.3-.7 2.44 0 4.65.27 6.33.7-1.68.44-3.9.65-6.33.65z' fill='none' stroke='%23000' stroke-linejoin='round' stroke-width='.26'/%3E %3Cpath d='M183.34 220.88c.06-.18 0-.37-.13-.41-.14-.04-.3.08-.37.26-.06.19 0 .38.13.42.14.04.3-.08.37-.27' fill='%23c8b100'/%3E %3Cpath d='M183.34 220.88c.06-.18 0-.37-.13-.41-.14-.04-.3.08-.37.26-.06.19 0 .38.13.42.14.04.3-.08.37-.27z' fill='none' stroke='%23000' stroke-width='.26'/%3E %3Cpath d='M178.5 219.95c.02-.2-.08-.37-.22-.39-.14-.02-.28.13-.3.33-.02.2.07.37.21.38.14.02.28-.13.3-.32' fill='%23c8b100'/%3E %3Cpath d='M178.5 219.95c.02-.2-.08-.37-.22-.39-.14-.02-.28.13-.3.33-.02.2.07.37.21.38.14.02.28-.13.3-.32z' fill='none' stroke='%23000' stroke-width='.26'/%3E %3Cpath d='M172.87 219.95c-.03-.2.07-.37.21-.39.14-.02.28.13.3.33.03.2-.07.37-.21.38-.14.02-.28-.13-.3-.32' fill='%23c8b100'/%3E %3Cpath d='M172.87 219.95c-.03-.2.07-.37.21-.39.14-.02.28.13.3.33.03.2-.07.37-.21.38-.14.02-.28-.13-.3-.32z' fill='none' stroke='%23000' stroke-width='.26'/%3E %3Cpath d='M168.02 220.88c-.06-.18 0-.37.13-.41.14-.04.3.08.37.26.06.19 0 .38-.14.42-.13.04-.3-.08-.36-.27' fill='%23c8b100'/%3E %3Cpath d='M168.02 220.88c-.06-.18 0-.37.13-.41.14-.04.3.08.37.26.06.19 0 .38-.14.42-.13.04-.3-.08-.36-.27z' fill='none' stroke='%23000' stroke-width='.26'/%3E %3Cpath d='M175.66 217.15l-.85.52.63 1.38.22.14.22-.14.64-1.38-.86-.52' fill='%23c8b100'/%3E %3Cpath d='M175.66 217.15l-.85.52.63 1.38.22.14.22-.14.64-1.38-.86-.52' fill='none' stroke='%23000' stroke-width='.26'/%3E %3Cpath d='M173.78 219.24l.4.57 1.34-.42.14-.18-.15-.2-1.33-.39-.4.62' fill='%23c8b100'/%3E %3Cpath d='M173.78 219.24l.4.57 1.34-.42.14-.18-.15-.2-1.33-.39-.4.62' fill='none' stroke='%23000' stroke-width='.26'/%3E %3Cpath d='M177.55 219.24l-.39.57-1.34-.42-.14-.18.14-.2 1.34-.39.4.62' fill='%23c8b100'/%3E %3Cpath d='M177.55 219.24l-.39.57-1.34-.42-.14-.18.14-.2 1.34-.39.4.62' fill='none' stroke='%23000' stroke-width='.26'/%3E %3Cpath d='M170.08 217.76l-.67.64.86 1.14.23.09.17-.18.3-1.37-.89-.32' fill='%23c8b100'/%3E %3Cpath d='M170.08 217.76l-.67.64.86 1.14.23.09.17-.18.3-1.37-.89-.32' fill='none' stroke='%23000' stroke-width='.26'/%3E %3Cpath d='M168.67 220.04l.5.48 1.23-.66.1-.21-.18-.16-1.4-.13-.25.68' fill='%23c8b100'/%3E %3Cpath d='M168.67 220.04l.5.48 1.23-.66.1-.21-.18-.16-1.4-.13-.25.68' fill='none' stroke='%23000' stroke-width='.26'/%3E %3Cpath d='M172.36 219.3l-.26.63-1.4-.13-.18-.16.1-.21 1.22-.65.52.52' fill='%23c8b100'/%3E %3Cpath d='M172.36 219.3l-.26.63-1.4-.13-.18-.16.1-.21 1.22-.65.52.52' fill='none' stroke='%23000' stroke-width='.26'/%3E %3Cpath d='M167.32 220.22l-.11.66-1.4.15-.21-.12.05-.23 1.05-.87.62.41' fill='%23c8b100'/%3E %3Cpath d='M167.32 220.22l-.11.66-1.4.15-.21-.12.05-.23 1.05-.87.62.41' fill='none' stroke='%23000' stroke-width='.26'/%3E %3Cpath d='M170.02 219.65c0-.26.22-.47.5-.47.26 0 .48.21.48.47 0 .25-.22.46-.49.46a.48.48 0 0 1-.49-.46' fill='%23c8b100'/%3E %3Cpath d='M170.02 219.65c0-.26.22-.47.5-.47.26 0 .48.21.48.47 0 .25-.22.46-.49.46a.48.48 0 0 1-.49-.46z' fill='none' stroke='%23000' stroke-width='.26'/%3E %3Cpath d='M181.27 217.76l.67.64-.86 1.14-.23.09-.16-.18-.3-1.37.88-.32' fill='%23c8b100'/%3E %3Cpath d='M181.27 217.76l.67.64-.86 1.14-.23.09-.16-.18-.3-1.37.88-.32' fill='none' stroke='%23000' stroke-width='.26'/%3E %3Cpath d='M182.68 220.04l-.5.48-1.23-.66-.1-.21.19-.16 1.4-.13.24.68' fill='%23c8b100'/%3E %3Cpath d='M182.68 220.04l-.5.48-1.23-.66-.1-.21.19-.16 1.4-.13.24.68' fill='none' stroke='%23000' stroke-width='.26'/%3E %3Cpath d='M179 219.3l.25.63 1.4-.13.18-.16-.1-.21-1.22-.65-.52.52' fill='%23c8b100'/%3E %3Cpath d='M179 219.3l.25.63 1.4-.13.18-.16-.1-.21-1.22-.65-.52.52' fill='none' stroke='%23000' stroke-width='.26'/%3E %3Cpath d='M183.84 220.22l.11.66 1.4.15.21-.12-.05-.23-1.05-.87-.62.41' fill='%23c8b100'/%3E %3Cpath d='M183.84 220.22l.11.66 1.4.15.21-.12-.05-.23-1.05-.87-.62.41' fill='none' stroke='%23000' stroke-width='.26'/%3E %3Cpath d='M175.18 219.2c0-.25.22-.46.5-.46.26 0 .48.2.48.47 0 .25-.22.46-.49.46s-.49-.2-.49-.46' fill='%23c8b100'/%3E %3Cpath d='M175.18 219.2c0-.25.22-.46.5-.46.26 0 .48.2.48.47 0 .25-.22.46-.49.46s-.49-.2-.49-.46z' fill='none' stroke='%23000' stroke-width='.26'/%3E %3Cpath d='M180.36 219.65c0-.26.22-.47.49-.47s.49.21.49.47c0 .25-.22.46-.5.46a.48.48 0 0 1-.48-.46' fill='%23c8b100'/%3E %3Cpath d='M180.36 219.65c0-.26.22-.47.49-.47s.49.21.49.47c0 .25-.22.46-.5.46a.48.48 0 0 1-.48-.46z' fill='none' stroke='%23000' stroke-width='.26'/%3E %3Cpath d='M165.43 221c-.01 0-.38-.49-.66-.73-.2-.18-.67-.33-.67-.33 0-.09.28-.28.58-.28.18 0 .35.07.45.2l.04-.2s.24.05.36.32c.1.29.04.72.04.72s-.05.2-.14.3' fill='%23c8b100'/%3E %3Cpath d='M165.43 221c-.01 0-.38-.49-.66-.73-.2-.18-.67-.33-.67-.33 0-.09.28-.28.58-.28.18 0 .35.07.45.2l.04-.2s.24.05.36.32c.1.29.04.72.04.72s-.05.2-.14.3z' fill='none' stroke='%23000' stroke-width='.26'/%3E %3Cpath d='M165.45 220.75c.12-.12.36-.1.53.06.18.15.24.38.12.5-.12.13-.36.1-.53-.06-.18-.15-.24-.38-.12-.5' fill='%23c8b100'/%3E %3Cpath d='M165.45 220.75c.12-.12.36-.1.53.06.18.15.24.38.12.5-.12.13-.36.1-.53-.06-.18-.15-.24-.38-.12-.5z' fill='none' stroke='%23000' stroke-width='.26'/%3E %3Cpath d='M185.73 221c.01 0 .38-.49.66-.73.19-.18.67-.33.67-.33 0-.09-.28-.28-.58-.28a.58.58 0 0 0-.45.2l-.04-.2s-.24.05-.36.32c-.1.29-.03.72-.03.72s.04.2.13.3' fill='%23c8b100'/%3E %3Cpath d='M185.73 221c.01 0 .38-.49.66-.73.19-.18.67-.33.67-.33 0-.09-.28-.28-.58-.28a.58.58 0 0 0-.45.2l-.04-.2s-.24.05-.36.32c-.1.29-.03.72-.03.72s.04.2.13.3z' fill='none' stroke='%23000' stroke-width='.26'/%3E %3Cpath d='M185.74 220.75c-.11-.12-.35-.1-.53.06-.18.15-.24.38-.12.5.12.13.36.1.54-.06.18-.15.22-.38.11-.5' fill='%23c8b100'/%3E %3Cpath d='M185.74 220.75c-.11-.12-.35-.1-.53.06-.18.15-.24.38-.12.5.12.13.36.1.54-.06.18-.15.22-.38.11-.5z' fill='none' stroke='%23000' stroke-width='.26'/%3E %3Cpath d='M164.58 232.37h22.29v-5.84h-22.29v5.84z' fill='%23c8b100'/%3E %3Cpath d='M164.58 232.37h22.29v-5.84h-22.29v5.84z' fill='none' stroke='%23000' stroke-width='.39'/%3E %3Cpath d='M166.92 236.26a.97.97 0 0 1 .41-.07h16.7c.16 0 .31.03.44.08a1.4 1.4 0 0 1-.98-1.32c0-.6.45-1.14 1.03-1.33-.14.04-.33.08-.49.08h-16.7c-.17 0-.33-.01-.47-.06l.1.02c.59.18.93.71.93 1.3 0 .55-.38 1.12-.97 1.3' fill='%23c8b100'/%3E %3Cpath d='M166.92 236.26a.97.97 0 0 1 .41-.07h16.7c.16 0 .31.03.44.08a1.4 1.4 0 0 1-.98-1.32c0-.6.45-1.14 1.03-1.33-.14.04-.33.08-.49.08h-16.7c-.17 0-.33-.01-.47-.06l.1.02c.59.18.93.71.93 1.3 0 .55-.38 1.12-.97 1.3z' fill='none' stroke='%23000' stroke-linejoin='round' stroke-width='.39'/%3E %3Cpath d='M167.33 236.2h16.7c.56 0 1.01.34 1.01.77 0 .44-.45.79-1.02.79h-16.69c-.56 0-1.02-.35-1.02-.79 0-.43.46-.78 1.02-.78' fill='%23c8b100'/%3E %3Cpath d='M167.33 236.2h16.7c.56 0 1.01.34 1.01.77 0 .44-.45.79-1.02.79h-16.69c-.56 0-1.02-.35-1.02-.79 0-.43.46-.78 1.02-.78z' fill='none' stroke='%23000' stroke-width='.39'/%3E %3Cpath d='M167.33 232.37h16.7c.56 0 1.03.3 1.03.66 0 .37-.47.67-1.03.67h-16.7c-.56 0-1.02-.3-1.02-.67 0-.36.46-.66 1.02-.66' fill='%23c8b100'/%3E %3Cpath d='M167.33 232.37h16.7c.56 0 1.03.3 1.03.66 0 .37-.47.67-1.03.67h-16.7c-.56 0-1.02-.3-1.02-.67 0-.36.46-.66 1.02-.66z' fill='none' stroke='%23000' stroke-width='.39'/%3E %3Cpath d='M191.28 330.68a8.48 8.48 0 0 1-3.93-.87 8.7 8.7 0 0 0-3.86-.82c-1.5 0-2.9.32-3.9.83-1.02.53-2.41.86-3.93.86a8.48 8.48 0 0 1-3.93-.9c-1-.5-2.33-.8-3.8-.8a8.5 8.5 0 0 0-3.85.82 8.64 8.64 0 0 1-3.95.88v2.41c1.53 0 2.94-.35 3.95-.88 1-.52 2.34-.82 3.86-.82 1.45 0 2.79.3 3.79.8 1 .54 2.39.9 3.93.9 1.52 0 2.91-.33 3.92-.86 1-.52 2.4-.84 3.9-.84s2.87.32 3.87.84a8.4 8.4 0 0 0 3.91.86l.02-2.41' fill='%23005bbf'/%3E %3Cpath d='M191.28 330.68a8.48 8.48 0 0 1-3.93-.87 8.7 8.7 0 0 0-3.86-.82c-1.5 0-2.9.32-3.9.83-1.02.53-2.41.86-3.93.86a8.48 8.48 0 0 1-3.93-.9c-1-.5-2.33-.8-3.8-.8a8.5 8.5 0 0 0-3.85.82 8.64 8.64 0 0 1-3.95.88v2.41c1.53 0 2.94-.35 3.95-.88 1-.52 2.34-.82 3.86-.82 1.45 0 2.79.3 3.79.8 1 .54 2.39.9 3.93.9 1.52 0 2.91-.33 3.92-.86 1-.52 2.4-.84 3.9-.84s2.87.32 3.87.84a8.4 8.4 0 0 0 3.91.86l.02-2.41z' fill='none' stroke='%23000' stroke-width='.39'/%3E %3Cpath d='M191.28 333.09a8.5 8.5 0 0 1-3.93-.86c-1-.52-2.36-.84-3.86-.84s-2.9.32-3.9.84c-1.02.53-2.41.86-3.93.86a8.52 8.52 0 0 1-3.93-.9c-1-.5-2.33-.8-3.8-.8-1.5 0-2.85.3-3.85.82a8.69 8.69 0 0 1-3.95.88v2.4a8.7 8.7 0 0 0 3.95-.87c1-.52 2.34-.82 3.86-.82 1.45 0 2.79.3 3.79.8 1 .54 2.39.9 3.93.9a8.7 8.7 0 0 0 3.92-.86c1-.52 2.4-.84 3.9-.84s2.87.32 3.87.83c1.02.54 2.37.87 3.91.87l.02-2.41' fill='%23ccc'/%3E %3Cpath d='M191.28 333.09a8.5 8.5 0 0 1-3.93-.86c-1-.52-2.36-.84-3.86-.84s-2.9.32-3.9.84c-1.02.53-2.41.86-3.93.86a8.52 8.52 0 0 1-3.93-.9c-1-.5-2.33-.8-3.8-.8-1.5 0-2.85.3-3.85.82a8.69 8.69 0 0 1-3.95.88v2.4a8.7 8.7 0 0 0 3.95-.87c1-.52 2.34-.82 3.86-.82 1.45 0 2.79.3 3.79.8 1 .54 2.39.9 3.93.9a8.7 8.7 0 0 0 3.92-.86c1-.52 2.4-.84 3.9-.84s2.87.32 3.87.83c1.02.54 2.37.87 3.91.87l.02-2.41' fill='none' stroke='%23000' stroke-width='.39'/%3E %3Cpath d='M191.28 335.5a8.52 8.52 0 0 1-3.93-.87c-1-.5-2.36-.83-3.86-.83s-2.9.32-3.9.84c-1.02.53-2.41.86-3.93.86a8.52 8.52 0 0 1-3.93-.9c-1-.5-2.33-.8-3.8-.8-1.5 0-2.85.3-3.85.82a8.7 8.7 0 0 1-3.95.88v2.4c1.53 0 2.94-.34 3.95-.88 1-.51 2.34-.8 3.86-.8 1.45 0 2.79.3 3.79.79 1 .54 2.39.9 3.93.9 1.52 0 2.91-.33 3.92-.86 1-.52 2.4-.83 3.9-.83s2.87.3 3.87.82c1.02.55 2.37.86 3.91.86l.02-2.4' fill='%23005bbf'/%3E %3Cpath d='M191.28 335.5a8.52 8.52 0 0 1-3.93-.87c-1-.5-2.36-.83-3.86-.83s-2.9.32-3.9.84c-1.02.53-2.41.86-3.93.86a8.52 8.52 0 0 1-3.93-.9c-1-.5-2.33-.8-3.8-.8-1.5 0-2.85.3-3.85.82a8.7 8.7 0 0 1-3.95.88v2.4c1.53 0 2.94-.34 3.95-.88 1-.51 2.34-.8 3.86-.8 1.45 0 2.79.3 3.79.79 1 .54 2.39.9 3.93.9 1.52 0 2.91-.33 3.92-.86 1-.52 2.4-.83 3.9-.83s2.87.3 3.87.82c1.02.55 2.37.86 3.91.86l.02-2.4' fill='none' stroke='%23000' stroke-width='.39'/%3E %3Cpath d='M191.26 340.32c-1.54 0-2.9-.33-3.9-.87a8.7 8.7 0 0 0-3.87-.82c-1.5 0-2.9.31-3.9.83-1.02.52-2.41.86-3.93.86a8.48 8.48 0 0 1-3.93-.9c-1-.5-2.33-.8-3.8-.8-1.5 0-2.85.3-3.85.82a8.64 8.64 0 0 1-3.95.88v-2.4c1.53 0 2.94-.36 3.95-.9 1-.51 2.34-.8 3.86-.8 1.45 0 2.79.3 3.79.79 1 .54 2.39.9 3.93.9 1.52 0 2.91-.33 3.92-.86 1-.52 2.4-.83 3.9-.83s2.87.3 3.87.82c1.02.55 2.39.86 3.93.86l-.02 2.42' fill='%23ccc'/%3E %3Cpath d='M191.26 340.32c-1.54 0-2.9-.33-3.9-.87a8.7 8.7 0 0 0-3.87-.82c-1.5 0-2.9.31-3.9.83-1.02.52-2.41.86-3.93.86a8.48 8.48 0 0 1-3.93-.9c-1-.5-2.33-.8-3.8-.8-1.5 0-2.85.3-3.85.82a8.64 8.64 0 0 1-3.95.88v-2.4c1.53 0 2.94-.36 3.95-.9 1-.51 2.34-.8 3.86-.8 1.45 0 2.79.3 3.79.79 1 .54 2.39.9 3.93.9 1.52 0 2.91-.33 3.92-.86 1-.52 2.4-.83 3.9-.83s2.87.3 3.87.82c1.02.55 2.39.86 3.93.86l-.02 2.42' fill='none' stroke='%23000' stroke-width='.39'/%3E %3Cpath d='M191.26 342.73c-1.54 0-2.9-.33-3.9-.86a8.6 8.6 0 0 0-3.87-.84c-1.5 0-2.9.32-3.9.84-1.02.52-2.41.86-3.93.86a8.52 8.52 0 0 1-3.93-.9c-1-.5-2.33-.8-3.8-.8a8.5 8.5 0 0 0-3.85.82 8.69 8.69 0 0 1-3.95.88v-2.4c1.53 0 2.94-.36 3.95-.9 1-.51 2.34-.8 3.86-.8 1.45 0 2.79.3 3.79.79 1 .53 2.39.9 3.93.9a8.7 8.7 0 0 0 3.92-.86c1-.52 2.4-.83 3.9-.83s2.87.31 3.87.82a8.5 8.5 0 0 0 3.93.87l-.02 2.4' fill='%23005bbf'/%3E %3Cpath d='M191.26 342.73c-1.54 0-2.9-.33-3.9-.86a8.6 8.6 0 0 0-3.87-.84c-1.5 0-2.9.32-3.9.84-1.02.52-2.41.86-3.93.86a8.52 8.52 0 0 1-3.93-.9c-1-.5-2.33-.8-3.8-.8a8.5 8.5 0 0 0-3.85.82 8.69 8.69 0 0 1-3.95.88v-2.4c1.53 0 2.94-.36 3.95-.9 1-.51 2.34-.8 3.86-.8 1.45 0 2.79.3 3.79.79 1 .53 2.39.9 3.93.9a8.7 8.7 0 0 0 3.92-.86c1-.52 2.4-.83 3.9-.83s2.87.31 3.87.82a8.5 8.5 0 0 0 3.93.87l-.02 2.4z' fill='none' stroke='%23000' stroke-width='.39'/%3E %3Cpath d='M166.92 320.78c.05.2.13.4.13.62 0 1.46-1.27 2.63-2.81 2.63h22.94c-1.55 0-2.81-1.17-2.81-2.63 0-.21.04-.41.1-.62-.14.05-.3.06-.45.06h-16.69c-.13 0-.29-.02-.41-.06' fill='%23c8b100'/%3E %3Cpath d='M166.92 320.78c.05.2.13.4.13.62 0 1.46-1.27 2.63-2.81 2.63h22.94c-1.55 0-2.81-1.17-2.81-2.63 0-.21.04-.41.1-.62-.14.05-.3.06-.45.06h-16.69c-.13 0-.29-.02-.41-.06z' fill='none' stroke='%23000' stroke-linejoin='round' stroke-width='.39'/%3E %3Cpath d='M167.33 319.27h16.7c.56 0 1.01.35 1.01.78 0 .44-.45.79-1.02.79h-16.69c-.56 0-1.02-.35-1.02-.79 0-.43.46-.78 1.02-.78' fill='%23c8b100'/%3E %3Cpath d='M167.33 319.27h16.7c.56 0 1.01.35 1.01.78 0 .44-.45.79-1.02.79h-16.69c-.56 0-1.02-.35-1.02-.79 0-.43.46-.78 1.02-.78z' fill='none' stroke='%23000' stroke-width='.39'/%3E %3Cpath d='M164.27 329.86h22.88v-5.83h-22.88v5.83z' fill='%23c8b100'/%3E %3Cpath d='M164.27 329.86h22.88v-5.83h-22.88v5.83z' fill='none' stroke='%23000' stroke-width='.39'/%3E %3Cpath d='M162.48 298.62c-2.26 1.3-3.8 2.64-3.55 3.31.12.62.84 1.07 1.87 1.75 1.62 1.13 2.6 3.14 1.83 4.07a5.76 5.76 0 0 0-.15-9.13' fill='%23ad1519'/%3E %3Cpath d='M162.48 298.62c-2.26 1.3-3.8 2.64-3.55 3.31.12.62.84 1.07 1.87 1.75 1.62 1.13 2.6 3.14 1.83 4.07a5.76 5.76 0 0 0-.15-9.13z' fill='none' stroke='%23000' stroke-width='.39'/%3E %3Cpath d='M167.55 318.32h16.25V238.7h-16.25v79.63z' fill='%23ccc'/%3E %3Cpath d='M179.13 238.8v79.46m1.83-79.46v79.46M167.55 318.32h16.25V238.7h-16.25v79.63z' fill='none' stroke='%23000' stroke-width='.39'/%3E %3Cpath d='M200.4 268.47c-3.54-1.46-9.57-2.55-16.5-2.78a50.2 50.2 0 0 0-7.78.7c-9.72 1.63-17.13 5.5-16.54 8.67l.05.26s-3.64-8.2-3.7-8.52c-.65-3.51 7.56-7.82 18.35-9.62 3.39-.57 6.7-.79 9.56-.76 6.9 0 12.9.89 16.52 2.23l.04 9.82' fill='%23ad1519'/%3E %3Cpath d='M200.4 268.47c-3.54-1.46-9.57-2.55-16.5-2.78a50.2 50.2 0 0 0-7.78.7c-9.72 1.63-17.13 5.5-16.54 8.67l.05.26s-3.64-8.2-3.7-8.52c-.65-3.51 7.56-7.82 18.35-9.62 3.39-.57 6.7-.79 9.56-.76 6.9 0 12.9.89 16.52 2.23l.04 9.82' fill='none' stroke='%23000' stroke-linejoin='round' stroke-width='.39'/%3E %3Cpath d='M167.52 278.47c-4.5-.32-7.59-1.53-7.94-3.41-.28-1.5 1.25-3.17 3.97-4.68 1.21.14 2.58.3 4 .3l-.03 7.79' fill='%23ad1519'/%3E %3Cpath d='M167.52 278.47c-4.5-.32-7.59-1.53-7.94-3.41-.28-1.5 1.25-3.17 3.97-4.68 1.21.14 2.58.3 4 .3l-.03 7.79' fill='none' stroke='%23000' stroke-width='.39'/%3E %3Cpath d='M183.83 272.38c2.82.43 4.93 1.13 5.98 1.99l.1.17c.5 1.03-1.97 3.22-6.1 5.67l.02-7.83' fill='%23ad1519'/%3E %3Cpath d='M183.83 272.38c2.82.43 4.93 1.13 5.98 1.99l.1.17c.5 1.03-1.97 3.22-6.1 5.67l.02-7.83' fill='none' stroke='%23000' stroke-width='.39'/%3E %3Cpath d='M157.42 293.83c-.43-1.28 3.97-3.86 10.18-6.14 2.84-1.01 5.18-2.07 8.09-3.35 8.63-3.82 15-8.2 14.22-9.8l-.09-.16c.46.38 1.18 8.24 1.18 8.24.78 1.46-5.05 5.78-13 9.58-2.54 1.22-7.9 3.2-10.44 4.1-4.54 1.56-9.04 4.53-8.63 5.63l-1.5-8.1' fill='%23ad1519'/%3E %3Cpath d='M157.42 293.83c-.43-1.28 3.97-3.86 10.18-6.14 2.84-1.01 5.18-2.07 8.09-3.35 8.63-3.82 15-8.2 14.22-9.8l-.09-.16c.46.38 1.18 8.24 1.18 8.24.78 1.46-5.05 5.78-13 9.58-2.54 1.22-7.9 3.2-10.44 4.1-4.54 1.56-9.04 4.53-8.63 5.63l-1.5-8.1z' fill='none' stroke='%23000' stroke-linejoin='round' stroke-width='.39'/%3E %3Cpath d='M166.43 264.65c1.98-.72 3.28-1.58 2.65-3.14-.4-1-1.43-1.19-2.97-.63l-2.72.99 2.45 6.03c.27-.12.54-.24.81-.34.28-.1.57-.18.85-.26l-1.07-2.64zm-1.19-2.9l.69-.26c.57-.2 1.22.1 1.5.8.21.53.16 1.13-.5 1.55-.21.13-.46.23-.7.33l-.99-2.43M172.78 259.22c-.29.07-.57.16-.86.22l-.88.13 1.41 6.27 4.38-.88c-.05-.13-.12-.26-.14-.38-.03-.14-.03-.28-.04-.41-.77.22-1.6.46-2.61.66l-1.26-5.61M181.56 264.63c.82-2.28 1.82-4.46 2.81-6.67a5.51 5.51 0 0 1-1.08.07c-.53 1.6-1.18 3.2-1.87 4.8-.82-1.51-1.73-2.99-2.43-4.51-.34.04-.69.1-1.03.12-.34.02-.7.01-1.04.02 1.26 2.06 2.48 4.1 3.64 6.23l.5-.08c.16 0 .33 0 .5.02M190.72 259.8c.15-.3.3-.6.48-.89a3.6 3.6 0 0 0-1.81-.63c-1.79-.18-2.81.61-2.93 1.7-.26 2.25 3.3 2.06 3.14 3.56-.07.64-.75.9-1.48.83-.81-.08-1.4-.53-1.51-1.19l-.22-.02c-.12.4-.3.77-.48 1.15.53.34 1.2.53 1.85.6 1.83.18 3.22-.55 3.35-1.75.23-2.15-3.37-2.27-3.23-3.54.06-.53.47-.88 1.4-.79.67.07 1.08.43 1.26.95l.18.02' fill='%23c8b100'/%3E %3Cpath d='M324.85 220.42s-.74.78-1.28.89c-.53.1-1.21-.49-1.21-.49s-.48.5-1.08.64c-.59.14-1.41-.67-1.41-.67s-.57.8-1.07 1c-.51.18-1.13-.24-1.13-.24s-.23.4-.65.61c-.18.09-.48-.05-.48-.05l-.6-.38-.68-.72-.62-.24s-.28-.91-.3-1.07l-.1-.57c-.12-.64.88-1.4 2.31-1.72.82-.2 1.54-.18 2.06-.02.57-.48 1.78-.82 3.2-.82 1.29 0 2.42.27 3.04.7.61-.43 1.74-.7 3.03-.7 1.42 0 2.62.34 3.2.82a4.1 4.1 0 0 1 2.06.02c1.42.32 2.43 1.08 2.3 1.72l-.08.57c-.03.16-.31 1.07-.31 1.07l-.63.24-.68.72-.59.38s-.3.14-.47.05a1.76 1.76 0 0 1-.66-.61s-.62.42-1.13.24c-.5-.2-1.07-1-1.07-1s-.82.8-1.42.67c-.59-.13-1.07-.64-1.07-.64s-.68.6-1.21.49c-.54-.11-1.27-.89-1.27-.89' fill='%23ad1519'/%3E %3Cpath d='M324.85 220.42s-.74.78-1.28.89c-.53.1-1.21-.49-1.21-.49s-.48.5-1.08.64c-.59.14-1.41-.67-1.41-.67s-.57.8-1.07 1c-.51.18-1.13-.24-1.13-.24s-.23.4-.65.61c-.18.09-.48-.05-.48-.05l-.6-.38-.68-.72-.62-.24s-.28-.91-.3-1.07l-.1-.57c-.12-.64.88-1.4 2.31-1.72.82-.2 1.54-.18 2.06-.02.57-.48 1.78-.82 3.2-.82 1.29 0 2.42.27 3.04.7.61-.43 1.74-.7 3.03-.7 1.42 0 2.62.34 3.2.82a4.1 4.1 0 0 1 2.06.02c1.42.32 2.43 1.08 2.3 1.72l-.08.57c-.03.16-.31 1.07-.31 1.07l-.63.24-.68.72-.59.38s-.3.14-.47.05a1.76 1.76 0 0 1-.66-.61s-.62.42-1.13.24c-.5-.2-1.07-1-1.07-1s-.82.8-1.42.67c-.59-.13-1.07-.64-1.07-.64s-.68.6-1.21.49c-.54-.11-1.27-.89-1.27-.89z' fill='none' stroke='%23000' stroke-width='.27'/%3E %3Cpath d='M323.45 216.2c0-1.09.61-1.96 1.37-1.96.76 0 1.38.87 1.38 1.96 0 1.08-.62 1.96-1.38 1.96-.76 0-1.37-.88-1.37-1.96' fill='%23c8b100'/%3E %3Cpath d='M323.45 216.2c0-1.09.61-1.96 1.37-1.96.76 0 1.38.87 1.38 1.96 0 1.08-.62 1.96-1.38 1.96-.76 0-1.37-.88-1.37-1.96z' fill='none' stroke='%23000' stroke-width='.26'/%3E %3Cpath d='M324.22 216.2c0-1 .28-1.8.63-1.8s.63.8.63 1.8-.28 1.8-.63 1.8-.63-.8-.63-1.8' fill='%23c8b100'/%3E %3Cpath d='M324.22 216.2c0-1 .28-1.8.63-1.8s.63.8.63 1.8-.28 1.8-.63 1.8-.63-.8-.63-1.8z' fill='none' stroke='%23000' stroke-width='.26'/%3E %3Cpath d='M317.75 224.25a4.72 4.72 0 0 0-.58-1.08c1.94-.57 4.65-.93 7.67-.94 3.01 0 5.74.37 7.69.94l-.52.91c-.17.3-.4.81-.38.81a23.8 23.8 0 0 0-6.8-.82c-2.79 0-5.47.35-6.86.86.02 0-.1-.32-.24-.68h.02' fill='%23c8b100'/%3E %3Cpath d='M317.75 224.25a4.72 4.72 0 0 0-.58-1.08c1.94-.57 4.65-.93 7.67-.94 3.01 0 5.74.37 7.69.94l-.52.91c-.17.3-.4.81-.38.81a23.8 23.8 0 0 0-6.8-.82c-2.79 0-5.47.35-6.86.86.02 0-.1-.32-.24-.68h.02' fill='none' stroke='%23000' stroke-width='.26'/%3E %3Cpath d='M324.84 226.73c2.43 0 5.1-.38 6.1-.63.66-.2 1.05-.5.97-.84-.03-.16-.17-.3-.37-.38-1.45-.47-4.06-.8-6.7-.8-2.64 0-5.27.33-6.72.8-.19.08-.33.22-.37.38-.07.35.32.65.98.84.99.25 3.68.62 6.1.63' fill='%23c8b100'/%3E %3Cpath d='M324.84 226.73c2.43 0 5.1-.38 6.1-.63.66-.2 1.05-.5.97-.84-.03-.16-.17-.3-.37-.38-1.45-.47-4.06-.8-6.7-.8-2.64 0-5.27.33-6.72.8-.19.08-.33.22-.37.38-.07.35.32.65.98.84.99.25 3.68.62 6.1.63z' fill='none' stroke='%23000' stroke-width='.26'/%3E %3Cpath d='M330.74 217.07c0-.23.2-.42.44-.42.26 0 .46.19.46.42 0 .24-.2.43-.45.43a.44.44 0 0 1-.45-.43' fill='%23fff'/%3E %3Cpath d='M330.74 217.07c0-.23.2-.42.44-.42.26 0 .46.19.46.42 0 .24-.2.43-.45.43a.44.44 0 0 1-.45-.43zM330.48 215.58c0-.24.2-.43.45-.43s.45.19.45.43c0 .23-.2.42-.45.42a.44.44 0 0 1-.45-.42zm-1.13-.94c0-.24.2-.43.45-.43s.45.2.45.43c0 .24-.2.43-.45.43a.44.44 0 0 1-.45-.43zm-1.42-.45c0-.24.2-.44.46-.44.25 0 .45.2.45.44 0 .23-.2.42-.45.42s-.46-.2-.46-.42zm-1.44.05c0-.24.2-.43.45-.43.26 0 .46.19.46.43 0 .23-.2.42-.45.42a.44.44 0 0 1-.45-.42z' fill='none' stroke='%23000' stroke-width='.21'/%3E %3Cpath d='M335.2 219.99a2.85 2.85 0 0 0-2.6-3.96c-.5 0-.97.13-1.38.37' fill='none' stroke='%23000' stroke-linecap='round' stroke-width='.26'/%3E %3Cpath d='M330.17 217.96c.15-.26.25-.57.25-.87 0-1.15-1.18-2.08-2.64-2.08-.62 0-1.2.17-1.64.45' fill='none' stroke='%23000' stroke-width='.26'/%3E %3Cpath d='M335.6 218.68c0-.24.2-.43.45-.43s.45.2.45.43c0 .24-.2.43-.45.43s-.45-.2-.45-.43zm-.18-1.58c0-.24.21-.42.46-.42s.45.18.45.42-.2.43-.45.43-.45-.2-.45-.43zm-1-1.2c0-.24.2-.43.44-.43.25 0 .45.2.45.43 0 .23-.2.42-.45.42a.44.44 0 0 1-.45-.42zm-1.37-.65c0-.23.2-.42.46-.42.25 0 .45.19.45.42 0 .24-.2.44-.45.44a.44.44 0 0 1-.46-.44zm-1.44.06c0-.24.2-.43.45-.43s.46.2.46.43c0 .23-.2.43-.46.43-.25 0-.45-.2-.45-.43z' fill='none' stroke='%23000' stroke-width='.21'/%3E %3Cpath d='M332.65 222.08l-.6-.53s-.56.34-1.27.24c-.7-.11-.93-.97-.93-.97s-.8.67-1.44.62a1.7 1.7 0 0 1-1.07-.62s-.71.5-1.33.46c-.62-.06-1.22-.83-1.22-.83s-.62.8-1.24.86c-.62.05-1.13-.54-1.13-.54s-.29.59-1.08.72-1.47-.62-1.47-.62-.44.73-.98.92c-.54.18-1.24-.27-1.24-.27l-.2.43c-.09.16-.31.19-.31.19l.17.47c1.94-.56 4.57-.9 7.54-.9 2.97 0 5.67.34 7.6.9l.2-.53' fill='%23c8b100'/%3E %3Cpath d='M332.65 222.08l-.6-.53s-.56.34-1.27.24c-.7-.11-.93-.97-.93-.97s-.8.67-1.44.62a1.7 1.7 0 0 1-1.07-.62s-.71.5-1.33.46c-.62-.06-1.22-.83-1.22-.83s-.62.8-1.24.86c-.62.05-1.13-.54-1.13-.54s-.29.59-1.08.72-1.47-.62-1.47-.62-.44.73-.98.92c-.54.18-1.24-.27-1.24-.27l-.2.43c-.09.16-.31.19-.31.19l.17.47c1.94-.56 4.57-.9 7.54-.9 2.97 0 5.67.34 7.6.9l.2-.53z' fill='none' stroke='%23000' stroke-width='.26'/%3E %3Cpath d='M317.98 217.07c0-.23.2-.42.45-.42s.45.19.45.42c0 .24-.2.43-.45.43s-.45-.19-.45-.43' fill='%23fff'/%3E %3Cpath d='M317.98 217.07c0-.23.2-.42.45-.42s.45.19.45.42c0 .24-.2.43-.45.43s-.45-.19-.45-.43zM318.23 215.58c0-.24.2-.43.45-.43s.45.19.45.43c0 .23-.2.42-.44.42-.26 0-.46-.19-.46-.42zm1.13-.94c0-.24.2-.43.45-.43s.46.2.46.43c0 .24-.2.43-.46.43a.44.44 0 0 1-.45-.43zm1.41-.45c0-.24.2-.44.46-.44.25 0 .45.2.45.44 0 .23-.2.42-.45.42s-.46-.2-.46-.42zm1.45.05c0-.24.2-.43.45-.43s.45.19.45.43c0 .23-.2.42-.45.42a.44.44 0 0 1-.45-.42z' fill='none' stroke='%23000' stroke-width='.21'/%3E %3Cpath d='M314.4 219.99a2.85 2.85 0 0 1 2.6-3.96c.51 0 .98.13 1.4.37' fill='none' stroke='%23000' stroke-linecap='round' stroke-width='.26'/%3E %3Cpath d='M319.48 217.93a1.75 1.75 0 0 1-.29-.84c0-1.15 1.19-2.08 2.64-2.08.62 0 1.2.17 1.65.45' fill='none' stroke='%23000' stroke-width='.26'/%3E %3Cpath d='M313.11 218.68c0-.24.2-.43.46-.43.24 0 .45.2.45.43 0 .24-.2.43-.45.43s-.46-.2-.46-.43zm.17-1.58c0-.24.2-.42.46-.42.25 0 .45.18.45.42s-.2.43-.45.43-.46-.2-.46-.43zm1.02-1.2c0-.24.2-.43.46-.43.24 0 .45.2.45.43 0 .23-.2.42-.45.42a.44.44 0 0 1-.46-.42zm1.36-.65c0-.23.2-.42.45-.42s.45.19.45.42c0 .24-.2.44-.45.44a.44.44 0 0 1-.45-.44zm1.44.06c0-.24.2-.43.45-.43s.45.2.45.43c0 .23-.2.43-.45.43s-.45-.2-.45-.43z' fill='none' stroke='%23000' stroke-width='.21'/%3E %3Cpath d='M324.85 219.5l.28.04c-.04.12-.05.24-.05.38 0 .58.5 1.05 1.12 1.05.5 0 .91-.3 1.05-.73.02.01.11-.38.16-.38.04 0 .03.41.04.4.07.53.56.9 1.1.9.62 0 1.12-.47 1.12-1.06l-.01-.12.35-.35.19.44c-.08.14-.1.3-.1.46 0 .56.47 1 1.06 1 .37 0 .7-.17.88-.44l.23-.29v.35c0 .35.14.66.48.72 0 0 .4.03.91-.38.53-.41.81-.75.81-.75l.03.42s-.51.84-.97 1.1c-.25.15-.64.3-.95.25-.33-.04-.55-.3-.68-.6-.23.13-.5.21-.8.21-.62 0-1.19-.35-1.41-.86a1.63 1.63 0 0 1-2.42-.08 1.63 1.63 0 0 1-2.43-.26 1.62 1.62 0 0 1-2.42.26c-.3.35-.75.58-1.26.58-.47 0-.87-.19-1.16-.5-.22.5-.79.86-1.42.86-.29 0-.56-.08-.8-.22-.11.3-.34.56-.67.61-.3.06-.69-.1-.94-.25-.47-.26-1.02-1.1-1.02-1.1l.07-.42s.28.34.8.75.92.38.92.38c.34-.06.48-.37.48-.72v-.35l.23.29c.19.27.51.45.88.45.6 0 1.07-.45 1.07-1.01a.93.93 0 0 0-.1-.46l.18-.44.35.35-.01.12c0 .59.5 1.06 1.1 1.06.56 0 1.04-.37 1.11-.9.02.01.01-.4.05-.4.05 0 .14.4.15.38.15.42.57.73 1.06.73a1.09 1.09 0 0 0 1.07-1.43l.29-.05' fill='%23c8b100'/%3E %3Cpath d='M324.85 219.5l.28.04c-.04.12-.05.24-.05.38 0 .58.5 1.05 1.12 1.05.5 0 .91-.3 1.05-.73.02.01.11-.38.16-.38.04 0 .03.41.04.4.07.53.56.9 1.1.9.62 0 1.12-.47 1.12-1.06l-.01-.12.35-.35.19.44c-.08.14-.1.3-.1.46 0 .56.47 1 1.06 1 .37 0 .7-.17.88-.44l.23-.29v.35c0 .35.14.66.48.72 0 0 .4.03.91-.38.53-.41.81-.75.81-.75l.03.42s-.51.84-.97 1.1c-.25.15-.64.3-.95.25-.33-.04-.55-.3-.68-.6-.23.13-.5.21-.8.21-.62 0-1.19-.35-1.41-.86a1.63 1.63 0 0 1-2.42-.08 1.63 1.63 0 0 1-2.43-.26 1.62 1.62 0 0 1-2.42.26c-.3.35-.75.58-1.26.58-.47 0-.87-.19-1.16-.5-.22.5-.79.86-1.42.86-.29 0-.56-.08-.8-.22-.11.3-.34.56-.67.61-.3.06-.69-.1-.94-.25-.47-.26-1.02-1.1-1.02-1.1l.07-.42s.28.34.8.75.92.38.92.38c.34-.06.48-.37.48-.72v-.35l.23.29c.19.27.51.45.88.45.6 0 1.07-.45 1.07-1.01a.93.93 0 0 0-.1-.46l.18-.44.35.35-.01.12c0 .59.5 1.06 1.1 1.06.56 0 1.04-.37 1.11-.9.02.01.01-.4.05-.4.05 0 .14.4.15.38.15.42.57.73 1.06.73a1.09 1.09 0 0 0 1.07-1.43l.29-.05z' fill='none' stroke='%23000' stroke-width='.26'/%3E %3Cpath d='M324.84 222.23c-3.02 0-5.72.37-7.67.94-.13.04-.29-.06-.33-.17-.04-.13.05-.28.18-.32 1.95-.6 4.73-.97 7.82-.98 3.08 0 5.87.38 7.83.98.13.04.22.2.18.32-.04.11-.2.21-.33.17a28.45 28.45 0 0 0-7.68-.94' fill='%23c8b100'/%3E %3Cpath d='M324.84 222.23c-3.02 0-5.72.37-7.67.94-.13.04-.29-.06-.33-.17-.04-.13.05-.28.18-.32 1.95-.6 4.73-.97 7.82-.98 3.08 0 5.87.38 7.83.98.13.04.22.2.18.32-.04.11-.2.21-.33.17a28.45 28.45 0 0 0-7.68-.94z' fill='none' stroke='%23000' stroke-width='.26'/%3E %3Cpath d='M321.92 223.3c0-.22.2-.4.44-.4s.44.18.44.4c0 .23-.2.41-.44.41s-.44-.18-.44-.4' fill='%23fff'/%3E %3Cpath d='M321.92 223.3c0-.22.2-.4.44-.4s.44.18.44.4c0 .23-.2.41-.44.41s-.44-.18-.44-.4z' fill='none' stroke='%23000' stroke-width='.26'/%3E %3Cpath d='M324.88 223.48h-.98c-.18 0-.33-.14-.33-.31 0-.17.15-.3.33-.3h1.96c.18 0 .32.13.32.3 0 .17-.14.31-.32.31h-.99' fill='%23ad1519'/%3E %3Cpath d='M324.88 223.48h-.98c-.18 0-.33-.14-.33-.31 0-.17.15-.3.33-.3h1.96c.18 0 .32.13.32.3 0 .17-.14.31-.32.31h-.99' fill='none' stroke='%23000' stroke-width='.26'/%3E %3Cpath d='M320.02 223.81l-.7.1a.33.33 0 0 1-.37-.25.3.3 0 0 1 .27-.35l.7-.1.7-.11c.18-.02.35.09.38.25.02.17-.1.33-.27.35l-.71.11' fill='%23058e6e'/%3E %3Cpath d='M320.02 223.81l-.7.1a.33.33 0 0 1-.37-.25.3.3 0 0 1 .27-.35l.7-.1.7-.11c.18-.02.35.09.38.25.02.17-.1.33-.27.35l-.71.11' fill='none' stroke='%23000' stroke-width='.26'/%3E %3Cpath d='M317.21 224.3l.31-.5.66.13-.38.56-.59-.19' fill='%23ad1519'/%3E %3Cpath d='M317.21 224.3l.31-.5.66.13-.38.56-.59-.19' fill='none' stroke='%23000' stroke-width='.26'/%3E %3Cpath d='M326.89 223.3c0-.22.2-.4.43-.4.25 0 .44.18.44.4 0 .23-.2.41-.44.41s-.43-.18-.43-.4' fill='%23fff'/%3E %3Cpath d='M326.89 223.3c0-.22.2-.4.43-.4.25 0 .44.18.44.4 0 .23-.2.41-.44.41s-.43-.18-.43-.4z' fill='none' stroke='%23000' stroke-width='.26'/%3E %3Cpath d='M329.66 223.81l.7.1c.18.03.34-.08.37-.25a.3.3 0 0 0-.26-.35l-.7-.1-.71-.11c-.18-.02-.35.09-.38.25-.03.17.1.33.28.35l.7.11' fill='%23058e6e'/%3E %3Cpath d='M329.66 223.81l.7.1c.18.03.34-.08.37-.25a.3.3 0 0 0-.26-.35l-.7-.1-.71-.11c-.18-.02-.35.09-.38.25-.03.17.1.33.28.35l.7.11' fill='none' stroke='%23000' stroke-width='.26'/%3E %3Cpath d='M332.4 224.33l-.24-.53-.68.06.33.59.6-.12' fill='%23ad1519'/%3E %3Cpath d='M332.4 224.33l-.24-.53-.68.06.33.59.6-.12' fill='none' stroke='%23000' stroke-width='.26'/%3E %3Cpath d='M324.83 226.16c-2.43 0-4.63-.22-6.3-.65 1.67-.43 3.87-.7 6.3-.7 2.44 0 4.65.27 6.32.7-1.67.44-3.88.65-6.32.65' fill='%23ad1519'/%3E %3Cpath d='M324.83 226.16c-2.43 0-4.63-.22-6.3-.65 1.67-.43 3.87-.7 6.3-.7 2.44 0 4.65.27 6.32.7-1.67.44-3.88.65-6.32.65z' fill='none' stroke='%23000' stroke-linejoin='round' stroke-width='.26'/%3E %3Cpath d='M332.5 220.88c.07-.18.01-.37-.13-.41-.13-.04-.3.08-.36.26-.06.19 0 .38.13.42.14.04.3-.08.37-.27' fill='%23c8b100'/%3E %3Cpath d='M332.5 220.88c.07-.18.01-.37-.13-.41-.13-.04-.3.08-.36.26-.06.19 0 .38.13.42.14.04.3-.08.37-.27z' fill='none' stroke='%23000' stroke-width='.26'/%3E %3Cpath d='M327.66 219.95c.03-.2-.07-.37-.21-.39-.14-.02-.28.13-.3.33-.03.2.06.37.2.38.15.02.28-.13.31-.32' fill='%23c8b100'/%3E %3Cpath d='M327.66 219.95c.03-.2-.07-.37-.21-.39-.14-.02-.28.13-.3.33-.03.2.06.37.2.38.15.02.28-.13.31-.32z' fill='none' stroke='%23000' stroke-width='.26'/%3E %3Cpath d='M322.04 219.95c-.03-.2.06-.37.2-.39.15-.02.28.13.31.33.02.2-.07.37-.2.38-.15.02-.29-.13-.31-.32' fill='%23c8b100'/%3E %3Cpath d='M322.04 219.95c-.03-.2.06-.37.2-.39.15-.02.28.13.31.33.02.2-.07.37-.2.38-.15.02-.29-.13-.31-.32z' fill='none' stroke='%23000' stroke-width='.26'/%3E %3Cpath d='M317.2 220.88c-.07-.18-.01-.37.12-.41.13-.04.3.08.36.26.07.19.01.38-.12.42-.14.04-.3-.08-.37-.27' fill='%23c8b100'/%3E %3Cpath d='M317.2 220.88c-.07-.18-.01-.37.12-.41.13-.04.3.08.36.26.07.19.01.38-.12.42-.14.04-.3-.08-.37-.27z' fill='none' stroke='%23000' stroke-width='.26'/%3E %3Cpath d='M324.83 217.15l-.85.52.63 1.38.22.14.22-.14.64-1.38-.86-.52' fill='%23c8b100'/%3E %3Cpath d='M324.83 217.15l-.85.52.63 1.38.22.14.22-.14.64-1.38-.86-.52' fill='none' stroke='%23000' stroke-width='.26'/%3E %3Cpath d='M322.95 219.24l.4.57 1.33-.42.14-.18-.14-.2-1.34-.39-.39.62' fill='%23c8b100'/%3E %3Cpath d='M322.95 219.24l.4.57 1.33-.42.14-.18-.14-.2-1.34-.39-.39.62' fill='none' stroke='%23000' stroke-width='.26'/%3E %3Cpath d='M326.72 219.24l-.39.57-1.34-.42-.14-.18.14-.2 1.34-.39.4.62' fill='%23c8b100'/%3E %3Cpath d='M326.72 219.24l-.39.57-1.34-.42-.14-.18.14-.2 1.34-.39.4.62' fill='none' stroke='%23000' stroke-width='.26'/%3E %3Cpath d='M319.25 217.76l-.67.64.86 1.14.23.09.17-.18.3-1.37-.89-.32' fill='%23c8b100'/%3E %3Cpath d='M319.25 217.76l-.67.64.86 1.14.23.09.17-.18.3-1.37-.89-.32' fill='none' stroke='%23000' stroke-width='.26'/%3E %3Cpath d='M317.84 220.04l.5.48 1.23-.66.09-.21-.18-.16-1.4-.13-.24.68' fill='%23c8b100'/%3E %3Cpath d='M317.84 220.04l.5.48 1.23-.66.09-.21-.18-.16-1.4-.13-.24.68' fill='none' stroke='%23000' stroke-width='.26'/%3E %3Cpath d='M321.53 219.3l-.26.63-1.4-.13-.18-.16.1-.21 1.22-.65.52.52' fill='%23c8b100'/%3E %3Cpath d='M321.53 219.3l-.26.63-1.4-.13-.18-.16.1-.21 1.22-.65.52.52' fill='none' stroke='%23000' stroke-width='.26'/%3E %3Cpath d='M316.5 220.22l-.12.66-1.4.15-.22-.12.06-.23 1.05-.87.62.41' fill='%23c8b100'/%3E %3Cpath d='M316.5 220.22l-.12.66-1.4.15-.22-.12.06-.23 1.05-.87.62.41' fill='none' stroke='%23000' stroke-width='.26'/%3E %3Cpath d='M319.19 219.65c0-.26.22-.47.49-.47s.49.21.49.47c0 .25-.22.46-.5.46a.48.48 0 0 1-.48-.46' fill='%23c8b100'/%3E %3Cpath d='M319.19 219.65c0-.26.22-.47.49-.47s.49.21.49.47c0 .25-.22.46-.5.46a.48.48 0 0 1-.48-.46z' fill='none' stroke='%23000' stroke-width='.26'/%3E %3Cpath d='M330.44 217.76l.67.64-.86 1.14-.23.09-.17-.18-.3-1.37.89-.32' fill='%23c8b100'/%3E %3Cpath d='M330.44 217.76l.67.64-.86 1.14-.23.09-.17-.18-.3-1.37.89-.32' fill='none' stroke='%23000' stroke-width='.26'/%3E %3Cpath d='M331.85 220.04l-.5.48-1.23-.66-.1-.21.18-.16 1.4-.13.25.68' fill='%23c8b100'/%3E %3Cpath d='M331.85 220.04l-.5.48-1.23-.66-.1-.21.18-.16 1.4-.13.25.68' fill='none' stroke='%23000' stroke-width='.26'/%3E %3Cpath d='M328.16 219.3l.26.63 1.4-.13.18-.16-.1-.21-1.22-.65-.52.52' fill='%23c8b100'/%3E %3Cpath d='M328.16 219.3l.26.63 1.4-.13.18-.16-.1-.21-1.22-.65-.52.52' fill='none' stroke='%23000' stroke-width='.26'/%3E %3Cpath d='M333 220.22l.12.66 1.4.15.2-.12-.04-.23-1.05-.87-.62.41' fill='%23c8b100'/%3E %3Cpath d='M333 220.22l.12.66 1.4.15.2-.12-.04-.23-1.05-.87-.62.41' fill='none' stroke='%23000' stroke-width='.26'/%3E %3Cpath d='M324.35 219.2c0-.25.22-.46.5-.46.26 0 .48.2.48.47 0 .25-.22.46-.49.46a.48.48 0 0 1-.49-.46' fill='%23c8b100'/%3E %3Cpath d='M324.35 219.2c0-.25.22-.46.5-.46.26 0 .48.2.48.47 0 .25-.22.46-.49.46a.48.48 0 0 1-.49-.46z' fill='none' stroke='%23000' stroke-width='.26'/%3E %3Cpath d='M329.52 219.65c0-.26.23-.47.5-.47s.5.21.5.47c0 .25-.23.46-.5.46a.48.48 0 0 1-.5-.46' fill='%23c8b100'/%3E %3Cpath d='M329.52 219.65c0-.26.23-.47.5-.47s.5.21.5.47c0 .25-.23.46-.5.46a.48.48 0 0 1-.5-.46z' fill='none' stroke='%23000' stroke-width='.26'/%3E %3Cpath d='M323.92 213.95a.9.9 0 0 1 .92-.87c.51 0 .93.39.93.87 0 .49-.42.88-.93.88a.9.9 0 0 1-.92-.88' fill='%23c8b100'/%3E %3Cpath d='M325.5 213.64v.58h-1.43v-.58h.47v-1.3h-.62v-.59h.62v-.57h.6v.57h.61v.59h-.6v1.3h.34' fill='%23c8b100'/%3E %3Cpath d='M325.5 213.64v.58h-1.43v-.58h.47v-1.3h-.62v-.59h.62v-.57h.6v.57h.61v.59h-.6v1.3h.34z' fill='none' stroke='%23000' stroke-width='.3'/%3E %3Cpath d='M326.13 213.64v.58h-2.53v-.58h.94v-1.3h-.62v-.59h.62v-.57h.6v.57h.62v.59h-.61v1.3h.98' fill='%23c8b100'/%3E %3Cpath d='M325.1 213.12c.39.1.67.44.67.83a.9.9 0 0 1-.93.88.9.9 0 0 1-.92-.88c0-.4.29-.74.68-.84' fill='none' stroke='%23000' stroke-width='.26'/%3E %3Cpath d='M314.6 221c-.01 0-.38-.49-.66-.73-.2-.18-.67-.33-.67-.33 0-.09.28-.28.58-.28.18 0 .35.07.45.2l.03-.2s.25.05.36.32c.11.29.04.72.04.72s-.05.2-.13.3' fill='%23c8b100'/%3E %3Cpath d='M314.6 221c-.01 0-.38-.49-.66-.73-.2-.18-.67-.33-.67-.33 0-.09.28-.28.58-.28.18 0 .35.07.45.2l.03-.2s.25.05.36.32c.11.29.04.72.04.72s-.05.2-.13.3z' fill='none' stroke='%23000' stroke-width='.26'/%3E %3Cpath d='M314.62 220.75c.11-.12.35-.1.53.06.18.15.23.38.11.5-.11.13-.35.1-.53-.06-.18-.15-.23-.38-.11-.5' fill='%23c8b100'/%3E %3Cpath d='M314.62 220.75c.11-.12.35-.1.53.06.18.15.23.38.11.5-.11.13-.35.1-.53-.06-.18-.15-.23-.38-.11-.5z' fill='none' stroke='%23000' stroke-width='.26'/%3E %3Cpath d='M334.9 221c.01 0 .38-.49.65-.73.2-.18.68-.33.68-.33 0-.09-.28-.28-.59-.28a.58.58 0 0 0-.44.2l-.04-.2s-.25.05-.36.32c-.1.29-.04.72-.04.72s.05.2.14.3' fill='%23c8b100'/%3E %3Cpath d='M334.9 221c.01 0 .38-.49.65-.73.2-.18.68-.33.68-.33 0-.09-.28-.28-.59-.28a.58.58 0 0 0-.44.2l-.04-.2s-.25.05-.36.32c-.1.29-.04.72-.04.72s.05.2.14.3z' fill='none' stroke='%23000' stroke-width='.26'/%3E %3Cpath d='M334.91 220.75c-.12-.12-.36-.1-.54.06-.18.15-.23.38-.11.5.11.13.35.1.53-.06.18-.15.24-.38.12-.5' fill='%23c8b100'/%3E %3Cpath d='M334.91 220.75c-.12-.12-.36-.1-.54.06-.18.15-.23.38-.11.5.11.13.35.1.53-.06.18-.15.24-.38.12-.5z' fill='none' stroke='%23000' stroke-width='.26'/%3E %3Cpath d='M313.71 232.37H336v-5.84H313.7v5.84z' fill='%23c8b100'/%3E %3Cpath d='M313.71 232.37H336v-5.84H313.7v5.84z' fill='none' stroke='%23000' stroke-width='.39'/%3E %3Cpath d='M333.66 236.26a.98.98 0 0 0-.41-.07h-16.7c-.16 0-.31.03-.45.08.57-.19.98-.7.98-1.32 0-.6-.44-1.14-1.02-1.33.14.04.32.08.49.08h16.7c.17 0 .32-.01.47-.06l-.1.02c-.6.18-.93.71-.93 1.3 0 .55.37 1.12.97 1.3' fill='%23c8b100'/%3E %3Cpath d='M333.66 236.26a.98.98 0 0 0-.41-.07h-16.7c-.16 0-.31.03-.45.08.57-.19.98-.7.98-1.32 0-.6-.44-1.14-1.02-1.33.14.04.32.08.49.08h16.7c.17 0 .32-.01.47-.06l-.1.02c-.6.18-.93.71-.93 1.3 0 .55.37 1.12.97 1.3z' fill='none' stroke='%23000' stroke-linejoin='round' stroke-width='.39'/%3E %3Cpath d='M316.56 236.2h16.69c.56 0 1.02.34 1.02.77 0 .44-.46.79-1.02.79h-16.7c-.56 0-1.01-.35-1.01-.79 0-.43.45-.78 1.02-.78' fill='%23c8b100'/%3E %3Cpath d='M316.56 236.2h16.69c.56 0 1.02.34 1.02.77 0 .44-.46.79-1.02.79h-16.7c-.56 0-1.01-.35-1.01-.79 0-.43.45-.78 1.02-.78z' fill='none' stroke='%23000' stroke-width='.39'/%3E %3Cpath d='M316.55 232.37h16.7c.56 0 1.02.3 1.02.66 0 .37-.46.67-1.02.67h-16.7c-.57 0-1.03-.3-1.03-.67 0-.36.46-.66 1.03-.66' fill='%23c8b100'/%3E %3Cpath d='M316.55 232.37h16.7c.56 0 1.02.3 1.02.66 0 .37-.46.67-1.02.67h-16.7c-.57 0-1.03-.3-1.03-.67 0-.36.46-.66 1.03-.66z' fill='none' stroke='%23000' stroke-width='.39'/%3E %3Cpath d='M309.3 330.68c1.54 0 2.91-.33 3.93-.87 1-.5 2.36-.82 3.86-.82s2.9.32 3.9.83c1.01.53 2.4.86 3.93.86a8.5 8.5 0 0 0 3.93-.9c1-.5 2.33-.8 3.8-.8a8.5 8.5 0 0 1 3.85.82c1.01.54 2.42.88 3.95.88v2.41a8.67 8.67 0 0 1-3.95-.88c-1-.52-2.34-.82-3.86-.82-1.46 0-2.8.3-3.79.8-1 .54-2.4.9-3.93.9a8.7 8.7 0 0 1-3.92-.86c-1-.52-2.4-.84-3.9-.84s-2.87.32-3.88.84a8.4 8.4 0 0 1-3.9.86l-.02-2.41' fill='%23005bbf'/%3E %3Cpath d='M309.3 330.68c1.54 0 2.91-.33 3.93-.87 1-.5 2.36-.82 3.86-.82s2.9.32 3.9.83c1.01.53 2.4.86 3.93.86a8.5 8.5 0 0 0 3.93-.9c1-.5 2.33-.8 3.8-.8a8.5 8.5 0 0 1 3.85.82c1.01.54 2.42.88 3.95.88v2.41a8.67 8.67 0 0 1-3.95-.88c-1-.52-2.34-.82-3.86-.82-1.46 0-2.8.3-3.79.8-1 .54-2.4.9-3.93.9a8.7 8.7 0 0 1-3.92-.86c-1-.52-2.4-.84-3.9-.84s-2.87.32-3.88.84a8.4 8.4 0 0 1-3.9.86l-.02-2.41z' fill='none' stroke='%23000' stroke-width='.39'/%3E %3Cpath d='M309.3 333.09a8.5 8.5 0 0 0 3.93-.86c1-.52 2.36-.84 3.86-.84s2.9.32 3.9.84c1.01.53 2.4.86 3.93.86 1.54 0 2.92-.36 3.93-.9 1-.5 2.33-.8 3.8-.8 1.5 0 2.84.3 3.85.82 1.01.53 2.42.88 3.95.88v2.4a8.67 8.67 0 0 1-3.95-.87c-1-.52-2.34-.82-3.86-.82-1.46 0-2.8.3-3.79.8-1 .54-2.4.9-3.93.9a8.7 8.7 0 0 1-3.92-.86c-1-.52-2.4-.84-3.9-.84s-2.87.32-3.88.83a8.43 8.43 0 0 1-3.9.87l-.02-2.41' fill='%23ccc'/%3E %3Cpath d='M309.3 333.09a8.5 8.5 0 0 0 3.93-.86c1-.52 2.36-.84 3.86-.84s2.9.32 3.9.84c1.01.53 2.4.86 3.93.86 1.54 0 2.92-.36 3.93-.9 1-.5 2.33-.8 3.8-.8 1.5 0 2.84.3 3.85.82 1.01.53 2.42.88 3.95.88v2.4a8.67 8.67 0 0 1-3.95-.87c-1-.52-2.34-.82-3.86-.82-1.46 0-2.8.3-3.79.8-1 .54-2.4.9-3.93.9a8.7 8.7 0 0 1-3.92-.86c-1-.52-2.4-.84-3.9-.84s-2.87.32-3.88.83a8.43 8.43 0 0 1-3.9.87l-.02-2.41' fill='none' stroke='%23000' stroke-width='.39'/%3E %3Cpath d='M309.3 335.5c1.54 0 2.91-.33 3.93-.87 1-.5 2.36-.83 3.86-.83s2.9.32 3.9.84c1.01.53 2.4.86 3.93.86 1.54 0 2.92-.36 3.93-.9 1-.5 2.33-.8 3.8-.8 1.5 0 2.84.3 3.85.82 1.01.53 2.42.88 3.95.88v2.4a8.63 8.63 0 0 1-3.95-.88c-1-.51-2.34-.8-3.86-.8-1.46 0-2.8.3-3.79.79-1 .54-2.4.9-3.93.9a8.71 8.71 0 0 1-3.92-.86c-1-.52-2.4-.83-3.9-.83s-2.87.3-3.88.82a8.37 8.37 0 0 1-3.9.86l-.02-2.4' fill='%23005bbf'/%3E %3Cpath d='M309.3 335.5c1.54 0 2.91-.33 3.93-.87 1-.5 2.36-.83 3.86-.83s2.9.32 3.9.84c1.01.53 2.4.86 3.93.86 1.54 0 2.92-.36 3.93-.9 1-.5 2.33-.8 3.8-.8 1.5 0 2.84.3 3.85.82 1.01.53 2.42.88 3.95.88v2.4a8.63 8.63 0 0 1-3.95-.88c-1-.51-2.34-.8-3.86-.8-1.46 0-2.8.3-3.79.79-1 .54-2.4.9-3.93.9a8.71 8.71 0 0 1-3.92-.86c-1-.52-2.4-.83-3.9-.83s-2.87.3-3.88.82a8.37 8.37 0 0 1-3.9.86l-.02-2.4' fill='none' stroke='%23000' stroke-width='.39'/%3E %3Cpath d='M309.32 340.32a8.4 8.4 0 0 0 3.9-.87c1.01-.51 2.37-.82 3.87-.82s2.9.31 3.9.83c1.01.52 2.4.86 3.93.86a8.5 8.5 0 0 0 3.93-.9c1-.5 2.33-.8 3.8-.8 1.5 0 2.84.3 3.85.82 1.01.53 2.42.88 3.95.88v-2.4a8.63 8.63 0 0 1-3.95-.9c-1-.51-2.34-.8-3.86-.8-1.46 0-2.8.3-3.79.79-1 .54-2.4.9-3.93.9a8.71 8.71 0 0 1-3.92-.86c-1-.52-2.4-.83-3.9-.83s-2.87.3-3.88.82a8.46 8.46 0 0 1-3.92.86l.02 2.42' fill='%23ccc'/%3E %3Cpath d='M309.32 340.32a8.4 8.4 0 0 0 3.9-.87c1.01-.51 2.37-.82 3.87-.82s2.9.31 3.9.83c1.01.52 2.4.86 3.93.86a8.5 8.5 0 0 0 3.93-.9c1-.5 2.33-.8 3.8-.8 1.5 0 2.84.3 3.85.82 1.01.53 2.42.88 3.95.88v-2.4a8.63 8.63 0 0 1-3.95-.9c-1-.51-2.34-.8-3.86-.8-1.46 0-2.8.3-3.79.79-1 .54-2.4.9-3.93.9a8.71 8.71 0 0 1-3.92-.86c-1-.52-2.4-.83-3.9-.83s-2.87.3-3.88.82a8.46 8.46 0 0 1-3.92.86l.02 2.42' fill='none' stroke='%23000' stroke-width='.39'/%3E %3Cpath d='M309.32 342.73c1.54 0 2.9-.33 3.9-.86a8.6 8.6 0 0 1 3.87-.84c1.5 0 2.9.32 3.9.84 1.01.52 2.4.86 3.93.86 1.54 0 2.92-.37 3.93-.9 1-.5 2.33-.8 3.8-.8 1.5 0 2.84.3 3.85.82 1.01.53 2.42.88 3.95.88v-2.4a8.61 8.61 0 0 1-3.95-.9c-1-.51-2.34-.8-3.86-.8-1.46 0-2.8.3-3.79.79-1 .53-2.4.9-3.93.9a8.7 8.7 0 0 1-3.92-.86c-1-.52-2.4-.83-3.9-.83s-2.87.31-3.88.82a8.5 8.5 0 0 1-3.92.87l.02 2.4' fill='%23005bbf'/%3E %3Cpath d='M309.32 342.73c1.54 0 2.9-.33 3.9-.86a8.6 8.6 0 0 1 3.87-.84c1.5 0 2.9.32 3.9.84 1.01.52 2.4.86 3.93.86 1.54 0 2.92-.37 3.93-.9 1-.5 2.33-.8 3.8-.8 1.5 0 2.84.3 3.85.82 1.01.53 2.42.88 3.95.88v-2.4a8.61 8.61 0 0 1-3.95-.9c-1-.51-2.34-.8-3.86-.8-1.46 0-2.8.3-3.79.79-1 .53-2.4.9-3.93.9a8.7 8.7 0 0 1-3.92-.86c-1-.52-2.4-.83-3.9-.83s-2.87.31-3.88.82a8.5 8.5 0 0 1-3.92.87l.02 2.4z' fill='none' stroke='%23000' stroke-width='.39'/%3E %3Cpath d='M333.66 320.78c-.06.2-.13.4-.13.62 0 1.46 1.27 2.63 2.8 2.63H313.4c1.55 0 2.8-1.17 2.8-2.63 0-.21-.03-.41-.08-.62.12.05.28.06.44.06h16.69c.13 0 .29-.02.4-.06' fill='%23c8b100'/%3E %3Cpath d='M333.66 320.78c-.06.2-.13.4-.13.62 0 1.46 1.27 2.63 2.8 2.63H313.4c1.55 0 2.8-1.17 2.8-2.63 0-.21-.03-.41-.08-.62.12.05.28.06.44.06h16.69c.13 0 .29-.02.4-.06z' fill='none' stroke='%23000' stroke-linejoin='round' stroke-width='.39'/%3E %3Cpath d='M316.56 319.27h16.69c.56 0 1.02.35 1.02.78 0 .44-.46.79-1.02.79h-16.7c-.56 0-1.01-.35-1.01-.79 0-.43.45-.78 1.02-.78' fill='%23c8b100'/%3E %3Cpath d='M316.56 319.27h16.69c.56 0 1.02.35 1.02.78 0 .44-.46.79-1.02.79h-16.7c-.56 0-1.01-.35-1.01-.79 0-.43.45-.78 1.02-.78z' fill='none' stroke='%23000' stroke-width='.39'/%3E %3Cpath d='M313.43 329.86h22.88v-5.83h-22.88v5.83z' fill='%23c8b100'/%3E %3Cpath d='M313.43 329.86h22.88v-5.83h-22.88v5.83z' fill='none' stroke='%23000' stroke-width='.39'/%3E %3Cpath d='M338.1 298.62c2.26 1.3 3.8 2.64 3.55 3.31-.12.62-.84 1.07-1.87 1.75-1.62 1.13-2.6 3.14-1.83 4.07a5.76 5.76 0 0 1 .15-9.13' fill='%23ad1519'/%3E %3Cpath d='M338.1 298.62c2.26 1.3 3.8 2.64 3.55 3.31-.12.62-.84 1.07-1.87 1.75-1.62 1.13-2.6 3.14-1.83 4.07a5.76 5.76 0 0 1 .15-9.13z' fill='none' stroke='%23000' stroke-width='.39'/%3E %3Cpath d='M316.78 318.32h16.25V238.7h-16.25v79.63z' fill='%23ccc'/%3E %3Cpath d='M328.57 238.66v79.46m1.82-79.46v79.46M316.78 318.32h16.25V238.7h-16.25v79.63z' fill='none' stroke='%23000' stroke-width='.39'/%3E %3Cpath d='M300.17 268.47c3.55-1.46 9.58-2.55 16.5-2.78 2.38.02 5.04.25 7.79.7 9.72 1.63 17.12 5.5 16.54 8.67l-.05.26s3.64-8.2 3.7-8.52c.65-3.51-7.56-7.82-18.35-9.62a55.7 55.7 0 0 0-9.56-.76c-6.9 0-12.9.89-16.52 2.23l-.05 9.82' fill='%23ad1519'/%3E %3Cpath d='M300.17 268.47c3.55-1.46 9.58-2.55 16.5-2.78 2.38.02 5.04.25 7.79.7 9.72 1.63 17.12 5.5 16.54 8.67l-.05.26s3.64-8.2 3.7-8.52c.65-3.51-7.56-7.82-18.35-9.62a55.7 55.7 0 0 0-9.56-.76c-6.9 0-12.9.89-16.52 2.23l-.05 9.82' fill='none' stroke='%23000' stroke-linejoin='round' stroke-width='.39'/%3E %3Cpath d='M333.06 278.47c4.5-.32 7.59-1.53 7.94-3.41.28-1.5-1.25-3.17-3.97-4.68-1.22.14-2.59.3-4 .3l.03 7.79' fill='%23ad1519'/%3E %3Cpath d='M333.06 278.47c4.5-.32 7.59-1.53 7.94-3.41.28-1.5-1.25-3.17-3.97-4.68-1.22.14-2.59.3-4 .3l.03 7.79' fill='none' stroke='%23000' stroke-width='.39'/%3E %3Cpath d='M316.75 272.38c-2.82.43-4.93 1.13-5.99 1.99l-.1.17c-.5 1.03 1.98 3.22 6.11 5.67l-.02-7.83' fill='%23ad1519'/%3E %3Cpath d='M316.75 272.38c-2.82.43-4.93 1.13-5.99 1.99l-.1.17c-.5 1.03 1.98 3.22 6.11 5.67l-.02-7.83' fill='none' stroke='%23000' stroke-width='.39'/%3E %3Cpath d='M343.15 293.83c.43-1.28-3.96-3.86-10.17-6.14-2.84-1.01-5.19-2.07-8.1-3.35-8.62-3.82-15-8.2-14.2-9.8l.08-.16c-.46.38-1.17 8.24-1.17 8.24-.79 1.46 5.05 5.78 12.98 9.58 2.55 1.22 7.92 3.2 10.45 4.1 4.54 1.56 9.04 4.53 8.63 5.63l1.5-8.1' fill='%23ad1519'/%3E %3Cpath d='M343.15 293.83c.43-1.28-3.96-3.86-10.17-6.14-2.84-1.01-5.19-2.07-8.1-3.35-8.62-3.82-15-8.2-14.2-9.8l.08-.16c-.46.38-1.17 8.24-1.17 8.24-.79 1.46 5.05 5.78 12.98 9.58 2.55 1.22 7.92 3.2 10.45 4.1 4.54 1.56 9.04 4.53 8.63 5.63l1.5-8.1z' fill='none' stroke='%23000' stroke-linejoin='round' stroke-width='.39'/%3E %3Cpath d='M310.3 264.98c.62-2.33 1.41-4.58 2.2-6.87a5.52 5.52 0 0 1-1.08.16 54.67 54.67 0 0 1-1.42 4.94c-.95-1.44-2-2.84-2.83-4.3-.34.07-.68.15-1.02.2-.34.05-.7.07-1.04.1 1.45 1.95 2.85 3.9 4.2 5.92.16-.04.32-.1.5-.12.16-.02.33-.02.5-.03M316.49 258.16l-.9.03c-.29 0-.59-.04-.88-.06l-.12 6.41 4.49.08c-.03-.13-.06-.27-.06-.41 0-.13.04-.27.07-.4-.8.05-1.68.1-2.71.08l.1-5.73M323.52 259.21c.72.06 1.41.19 2.1.31-.01-.13-.03-.27-.02-.4 0-.14.06-.27.1-.4l-6.07-.5c.01.13.03.27.02.4-.01.14-.06.27-.1.4a20.1 20.1 0 0 1 2.2.05l-.52 5.77c.3 0 .59 0 .88.03.3.02.6.07.88.11l.53-5.77M326 265.53c.3.05.6.09.89.15.28.06.57.15.85.23l.72-2.94.08.01.5 1.19.9 2.22c.35.06.7.1 1.04.18.36.08.7.18 1.04.28l-.31-.67c-.48-1-1-2-1.41-3.02 1.12.04 1.98-.36 2.2-1.26.15-.62-.1-1.11-.69-1.53-.43-.31-1.27-.48-1.82-.6l-2.44-.53-1.54 6.3m3.14-5.43c.7.16 1.59.27 1.59 1.07 0 .2-.03.35-.06.48-.23.94-.94 1.26-2.13.9l.6-2.45M337.57 267.45c-.05.7-.18 1.38-.31 2.1.3.15.6.28.9.45.3.16.57.34.86.52l.6-7.23a4.03 4.03 0 0 1-.78-.43l-6.38 4.05c.17.08.35.16.51.25l.47.28c.54-.45 1.1-.82 1.74-1.3l2.39 1.31zm-1.8-1.65l2.12-1.37-.25 2.4-1.88-1.03' fill='%23c8b100'/%3E %3Cpath d='M225.2 200.45c0-1.14.97-2.06 2.17-2.06 1.19 0 2.16.92 2.16 2.06 0 1.13-.97 2.05-2.16 2.05-1.2 0-2.17-.92-2.17-2.05z' fill='none' stroke='%23000' stroke-width='.05'/%3E %3Cpath d='M249.65 182.72c6.64 0 12.56.99 16.4 2.51 2.21 1 5.17 1.73 8.41 2.17 2.47.33 4.81.4 6.85.24 2.73-.06 6.67.74 10.62 2.48 3.26 1.45 5.99 3.2 7.8 4.91l-1.57 1.4-.45 3.96-4.3 4.92-2.15 1.83-5.09 4.07-2.6.21-.79 2.25-32.91-3.86-33.02 3.86-.8-2.25-2.6-.21-5.08-4.07-2.15-1.83-4.3-4.92-.44-3.96-1.58-1.4a28.79 28.79 0 0 1 7.8-4.91c3.95-1.74 7.9-2.54 10.62-2.48 2.04.15 4.38.09 6.85-.24a31.2 31.2 0 0 0 8.4-2.17c3.86-1.52 9.44-2.5 16.08-2.5z' fill='%23ad1519' stroke='%23000' stroke-width='.26'/%3E %3Cpath d='M250.15 226.18c-12.26-.02-23.25-1.47-31.09-3.83a1.2 1.2 0 0 1-.84-1.25c0-.52.29-1 .84-1.17 7.84-2.36 18.83-3.81 31.1-3.83 12.26.02 23.23 1.47 31.08 3.83.55.17.84.65.83 1.17a1.2 1.2 0 0 1-.83 1.25c-7.85 2.36-18.82 3.81-31.09 3.83' fill='%23c8b100' stroke='%23000' stroke-width='.39'/%3E %3Cpath d='M250.12 224.57c-11.06-.01-21.07-1.3-28.68-3.26 7.61-1.97 17.62-3.17 28.68-3.2 11.07.03 21.13 1.23 28.74 3.2-7.61 1.97-17.67 3.25-28.74 3.26' fill='%23ad1519'/%3E %3Cpath d='M250.95 224.64v-6.57' fill='none' stroke='%23000' stroke-width='.09'/%3E %3Cpath d='M249.16 224.64v-6.57' fill='none' stroke='%23000' stroke-width='.14'/%3E %3Cpath d='M247.48 224.64v-6.57' fill='none' stroke='%23000' stroke-width='.18'/%3E %3Cpath d='M245.8 224.64v-6.57' fill='none' stroke='%23000' stroke-width='.23'/%3E %3Cpath d='M244.32 224.64v-6.57' fill='none' stroke='%23000' stroke-width='.28'/%3E %3Cpath d='M241.48 224.28l-.03-5.97m1.38 6.05v-6.25' fill='none' stroke='%23000' stroke-width='.33'/%3E %3Cpath d='M238.87 224.01v-5.5m1.32 5.66l-.04-5.86' fill='none' stroke='%23000' stroke-width='.37'/%3E %3Cpath d='M235.35 223.7v-4.84m1.15 4.92v-5.08m1.2 5.24v-5.28' fill='none' stroke='%23000' stroke-width='.42'/%3E %3Cpath d='M234.12 223.66v-4.68' fill='none' stroke='%23000' stroke-width='.46'/%3E %3Cpath d='M232.97 223.42v-4.36' fill='none' stroke='%23000' stroke-width='.51'/%3E %3Cpath d='M231.74 223.3v-4.05' fill='none' stroke='%23000' stroke-width='.56'/%3E %3Cpath d='M229.22 222.95l-.04-3.22m1.33 3.38v-3.62' fill='none' stroke='%23000' stroke-width='.6'/%3E %3Cpath d='M227.93 222.68v-2.84' fill='none' stroke='%23000' stroke-width='.63'/%3E %3Cpath d='M226.74 222.45v-2.36' fill='none' stroke='%23000' stroke-width='.68'/%3E %3Cpath d='M225.45 222.13v-1.84' fill='none' stroke='%23000' stroke-width='.73'/%3E %3Cpath d='M224.12 221.98v-1.38' fill='none' stroke='%23000' stroke-width='.77'/%3E %3Cpath d='M222.72 221.66V221' fill='none' stroke='%23000' stroke-width='.91'/%3E %3Cpath d='M258.04 224.28v-6.01m-3.02 6.21l.04-6.37m-2.24 6.45v-6.49' fill='none' stroke='%23000' stroke-width='.05'/%3E %3Cpath d='M250.07 216.1c-12.41.02-23.55 1.57-31.4 3.99.66-.31.6-1.12-.21-3.2-.98-2.53-2.5-2.42-2.5-2.42 8.66-2.56 20.73-4.16 34.16-4.18 13.44.02 25.6 1.62 34.27 4.18 0 0-1.53-.1-2.5 2.42-.82 2.08-.88 2.89-.22 3.2-7.84-2.42-19.2-3.97-31.6-4' fill='%23c8b100' stroke='%23000' stroke-width='.39'/%3E %3Cpath d='M250.12 210.3c-13.43.02-25.5 1.61-34.16 4.18-.58.17-1.2-.05-1.38-.6-.19-.55.12-1.18.7-1.35 8.7-2.68 21.09-4.35 34.84-4.38 13.77.03 26.2 1.7 34.9 4.38.58.17.89.8.7 1.35-.19.55-.8.77-1.38.6-8.67-2.56-20.78-4.16-34.22-4.19' fill='%23c8b100' stroke='%23000' stroke-width='.39'/%3E %3Cpath d='M250.12 224.57c-11.06-.01-21.07-1.3-28.68-3.26 7.61-1.97 17.62-3.17 28.68-3.2 11.07.03 21.13 1.23 28.74 3.2-7.61 1.97-17.67 3.25-28.74 3.26z' fill='none' stroke='%23000' stroke-linejoin='round' stroke-width='.39'/%3E %3Cpath d='M240.54 213.35c0-.58.5-1.04 1.1-1.04.6 0 1.1.46 1.1 1.04 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04' fill='%23fff' stroke='%23000' stroke-width='.39'/%3E %3Cpath d='M250.15 214.16h-3.29c-.6 0-1.1-.46-1.1-1.03 0-.58.49-1.04 1.09-1.04h6.64c.6 0 1.1.46 1.1 1.04 0 .57-.5 1.03-1.11 1.03h-3.33' fill='%23ad1519' stroke='%23000' stroke-width='.39'/%3E %3Cpath d='M233.64 215.07l-2.36.27c-.6.07-1.17-.33-1.24-.9-.08-.57.35-1.09.96-1.15l2.37-.28 2.42-.28c.6-.07 1.15.33 1.22.9.07.57-.36 1.09-.96 1.16l-2.41.28' fill='%23058e6e' stroke='%23000' stroke-width='.39'/%3E %3Cpath d='M224.03 215.28c0-.58.5-1.04 1.1-1.04.6 0 1.1.46 1.1 1.03 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.03' fill='%23fff' stroke='%23000' stroke-width='.39'/%3E %3Cpath d='M216.72 217.16l1.22-1.6 3.37.44-2.7 1.96-1.89-.8' fill='%23ad1519' stroke='%23000' stroke-width='.39'/%3E %3Cpath d='M266.66 215.07l2.36.27c.6.07 1.17-.33 1.24-.9a1.05 1.05 0 0 0-.96-1.15l-2.37-.28-2.42-.28c-.6-.07-1.15.33-1.22.9-.08.57.36 1.09.96 1.16l2.41.28' fill='%23058e6e' stroke='%23000' stroke-width='.39'/%3E %3Cpath d='M257.56 213.35c0-.58.5-1.04 1.1-1.04.6 0 1.1.46 1.1 1.04 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04M274.07 215.28c0-.58.5-1.04 1.1-1.04.6 0 1.1.46 1.1 1.03 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.03' fill='%23fff' stroke='%23000' stroke-width='.39'/%3E %3Cpath d='M283.57 217.16l-1.21-1.6-3.37.44 2.7 1.96 1.88-.8' fill='%23ad1519' stroke='%23000' stroke-width='.39'/%3E %3Cpath d='M220.12 221.66c7.75-2.17 18.3-3.52 30-3.54 11.71.02 22.31 1.37 30.06 3.54' fill='none' stroke='%23000' stroke-width='.39'/%3E %3Cpath d='M225.34 191.42l1.38 1.11 2.09-3.4a7.7 7.7 0 0 1-3.75-7.42c.21-4.34 5.5-7.92 12.2-7.92 3.48 0 6.63.95 8.84 2.48.06-.67.12-1.25.21-1.86a18.11 18.11 0 0 0-9.05-2.28c-7.7 0-13.74 4.38-14.03 9.57a9.25 9.25 0 0 0 3.22 7.9l-1.11 1.82' fill='%23c8b100'/%3E %3Cpath d='M225.34 191.42l1.38 1.11 2.09-3.4a7.7 7.7 0 0 1-3.75-7.42c.21-4.34 5.5-7.92 12.2-7.92 3.48 0 6.63.95 8.84 2.48.06-.67.12-1.25.21-1.86a18.11 18.11 0 0 0-9.05-2.28c-7.7 0-13.74 4.38-14.03 9.57a9.25 9.25 0 0 0 3.22 7.9l-1.11 1.82' fill='none' stroke='%23000' stroke-width='.39'/%3E %3Cpath d='M225.43 191.46c-2.64-1.97-4.27-4.64-4.27-7.58 0-3.38 2.22-6.4 5.58-8.4a8.84 8.84 0 0 0-3.56 7.14 9.25 9.25 0 0 0 3.26 6.99l-1.01 1.85' fill='%23c8b100'/%3E %3Cpath d='M225.43 191.46c-2.64-1.97-4.27-4.64-4.27-7.58 0-3.38 2.22-6.4 5.58-8.4a8.84 8.84 0 0 0-3.56 7.14 9.25 9.25 0 0 0 3.26 6.99l-1.01 1.85' fill='none' stroke='%23000' stroke-width='.39'/%3E %3Cpath d='M202.2 194.89a9.16 9.16 0 0 1-2.37-6.12c0-1.4.32-2.75.91-3.95 2.13-4.38 8.81-7.57 16.76-7.57 2.16 0 4.23.23 6.14.67-.42.46-.75.97-1.08 1.48-1.59-.31-3.29-.48-5.06-.48-7.27 0-13.35 2.83-15.12 6.65a7.36 7.36 0 0 0-.73 3.2c0 2.32 1.09 4.4 2.8 5.82l-2.64 4.3-1.41-1.12 1.8-2.88' fill='%23c8b100'/%3E %3Cpath d='M202.2 194.89a9.16 9.16 0 0 1-2.37-6.12c0-1.4.32-2.75.91-3.95 2.13-4.38 8.81-7.57 16.76-7.57 2.16 0 4.23.23 6.14.67-.42.46-.75.97-1.08 1.48-1.59-.31-3.29-.48-5.06-.48-7.27 0-13.35 2.83-15.12 6.65a7.36 7.36 0 0 0-.73 3.2c0 2.32 1.09 4.4 2.8 5.82l-2.64 4.3-1.41-1.12 1.8-2.88z' fill='none' stroke='%23000' stroke-width='.39'/%3E %3Cpath d='M204.9 180.48a10.98 10.98 0 0 0-4.16 4.34 8.95 8.95 0 0 0-.91 3.95c0 2.33.9 4.47 2.38 6.12l-1.6 2.6a10.87 10.87 0 0 1-2.42-6.7c0-4.2 2.67-7.88 6.71-10.3' fill='%23c8b100'/%3E %3Cpath d='M204.9 180.48a10.98 10.98 0 0 0-4.16 4.34 8.95 8.95 0 0 0-.91 3.95c0 2.33.9 4.47 2.38 6.12l-1.6 2.6a10.87 10.87 0 0 1-2.42-6.7c0-4.2 2.67-7.88 6.71-10.3z' fill='none' stroke='%23000' stroke-width='.39'/%3E %3Cpath d='M250.04 171.27a3.69 3.69 0 0 1 3.64 2.72c.23 1.39.38 2.96.41 4.63l-.01.52c0 .2.04.41.05.61.06 3.52.56 6.62 1.27 8.52l-5.36 5.14-5.43-5.14c.72-1.9 1.22-5 1.28-8.52 0-.2.05-.41.05-.61l-.01-.51c.03-1.68.18-3.25.41-4.63.36-1.57 1.94-2.73 3.7-2.73' fill='%23c8b100'/%3E %3Cpath d='M250.04 171.27a3.69 3.69 0 0 1 3.64 2.72c.23 1.39.38 2.96.41 4.63l-.01.52c0 .2.04.41.05.61.06 3.52.56 6.62 1.27 8.52l-5.36 5.14-5.43-5.14c.72-1.9 1.22-5 1.28-8.52 0-.2.05-.41.05-.61l-.01-.51c.03-1.68.18-3.25.41-4.63.36-1.57 1.94-2.73 3.7-2.73z' fill='none' stroke='%23000' stroke-width='.39'/%3E %3Cpath d='M250.04 172.94c.91 0 1.69.58 1.87 1.4a30 30 0 0 1 .4 4.37l-.01.48c0 .2.03.4.04.6.05 3.31.53 6.24 1.21 8.04l-3.54 3.35-3.54-3.35c.68-1.8 1.15-4.73 1.21-8.05 0-.2.04-.4.04-.59v-.48c.02-1.58.16-3.07.39-4.38.18-.8 1.02-1.39 1.93-1.39' fill='%23c8b100'/%3E %3Cpath d='M250.04 172.94c.91 0 1.69.58 1.87 1.4a30 30 0 0 1 .4 4.37l-.01.48c0 .2.03.4.04.6.05 3.31.53 6.24 1.21 8.04l-3.54 3.35-3.54-3.35c.68-1.8 1.15-4.73 1.21-8.05 0-.2.04-.4.04-.59v-.48c.02-1.58.16-3.07.39-4.38.18-.8 1.02-1.39 1.93-1.39z' fill='none' stroke='%23000' stroke-width='.39'/%3E %3Cpath d='M274.7 191.42l-1.39 1.11-2.08-3.4a7.71 7.71 0 0 0 3.75-7.42c-.21-4.34-5.5-7.92-12.2-7.92-3.5 0-6.63.95-8.84 2.48-.06-.67-.12-1.25-.22-1.86a18.12 18.12 0 0 1 9.06-2.28c7.7 0 13.74 4.38 14.03 9.57a9.24 9.24 0 0 1-3.22 7.9l1.11 1.82' fill='%23c8b100'/%3E %3Cpath d='M274.7 191.42l-1.39 1.11-2.08-3.4a7.71 7.71 0 0 0 3.75-7.42c-.21-4.34-5.5-7.92-12.2-7.92-3.5 0-6.63.95-8.84 2.48-.06-.67-.12-1.25-.22-1.86a18.12 18.12 0 0 1 9.06-2.28c7.7 0 13.74 4.38 14.03 9.57a9.24 9.24 0 0 1-3.22 7.9l1.11 1.82' fill='none' stroke='%23000' stroke-width='.39'/%3E %3Cpath d='M274.61 191.46c2.63-1.97 4.27-4.64 4.27-7.58 0-3.38-2.22-6.4-5.58-8.4a8.87 8.87 0 0 1 3.56 7.14 9.24 9.24 0 0 1-3.27 6.99l1.02 1.85' fill='%23c8b100'/%3E %3Cpath d='M274.61 191.46c2.63-1.97 4.27-4.64 4.27-7.58 0-3.38-2.22-6.4-5.58-8.4a8.87 8.87 0 0 1 3.56 7.14 9.24 9.24 0 0 1-3.27 6.99l1.02 1.85' fill='none' stroke='%23000' stroke-width='.39'/%3E %3Cpath d='M297.83 194.89a9.02 9.02 0 0 0 1.46-10.07c-2.13-4.38-8.8-7.57-16.75-7.57-2.17 0-4.23.23-6.15.67.43.46.76.97 1.09 1.48 1.58-.31 3.29-.48 5.06-.48 7.27 0 13.35 2.83 15.11 6.65.47.97.73 2.06.73 3.2 0 2.32-1.09 4.4-2.79 5.82l2.63 4.3 1.42-1.12-1.8-2.88' fill='%23c8b100'/%3E %3Cpath d='M297.83 194.89a9.02 9.02 0 0 0 1.46-10.07c-2.13-4.38-8.8-7.57-16.75-7.57-2.17 0-4.23.23-6.15.67.43.46.76.97 1.09 1.48 1.58-.31 3.29-.48 5.06-.48 7.27 0 13.35 2.83 15.11 6.65.47.97.73 2.06.73 3.2 0 2.32-1.09 4.4-2.79 5.82l2.63 4.3 1.42-1.12-1.8-2.88z' fill='none' stroke='%23000' stroke-width='.39'/%3E %3Cpath d='M295.13 180.48a11.02 11.02 0 0 1 4.17 4.34 9.06 9.06 0 0 1-1.47 10.07l1.6 2.6a10.86 10.86 0 0 0 2.41-6.7c0-4.2-2.67-7.88-6.7-10.3' fill='%23c8b100'/%3E %3Cpath d='M295.13 180.48a11.02 11.02 0 0 1 4.17 4.34 9.06 9.06 0 0 1-1.47 10.07l1.6 2.6a10.86 10.86 0 0 0 2.41-6.7c0-4.2-2.67-7.88-6.7-10.3z' fill='none' stroke='%23000' stroke-width='.39'/%3E %3Cpath d='M248.13 188.93c0-1 .86-1.8 1.9-1.8 1.06 0 1.91.8 1.91 1.8s-.85 1.8-1.9 1.8c-1.05 0-1.9-.8-1.9-1.8' fill='%23fff'/%3E %3Cpath d='M248.13 188.93c0-1 .86-1.8 1.9-1.8 1.06 0 1.91.8 1.91 1.8s-.85 1.8-1.9 1.8c-1.05 0-1.9-.8-1.9-1.8z' fill='none' stroke='%23000' stroke-width='.39'/%3E %3Cpath d='M248.13 185.4c0-1 .86-1.8 1.9-1.8 1.06 0 1.91.8 1.91 1.8s-.85 1.8-1.9 1.8c-1.05 0-1.9-.8-1.9-1.8M248.51 181.6c0-.8.69-1.44 1.53-1.44.83 0 1.51.64 1.51 1.44 0 .8-.68 1.44-1.51 1.44-.84 0-1.53-.64-1.53-1.44M248.94 178.17c0-.57.5-1.03 1.1-1.03.6 0 1.09.46 1.09 1.03 0 .58-.49 1.05-1.1 1.05-.6 0-1.09-.47-1.09-1.05M249.16 175.18c0-.47.39-.83.88-.83.48 0 .87.37.87.83 0 .45-.4.83-.87.83a.86.86 0 0 1-.88-.83' fill='%23fff' stroke='%23000' stroke-width='.39'/%3E %3Cpath d='M250.2 199.78l1.23.22a4.8 4.8 0 0 0 4.68 6.28 4.9 4.9 0 0 0 4.68-3.21c.07.05.46-1.68.67-1.66.17.02.15 1.8.22 1.77.31 2.34 2.46 3.93 4.87 3.93a4.78 4.78 0 0 0 4.87-5.22l1.54-1.52.83 1.94c-.33.61-.46 1.3-.46 2.03 0 2.46 2.1 4.44 4.7 4.44 1.62 0 3.05-.78 3.9-1.97l.98-1.25v1.53c0 1.55.65 2.93 2.15 3.18 0 0 1.73.1 4.03-1.7 2.3-1.8 3.56-3.29 3.56-3.29l.2 1.8s-1.91 2.95-3.98 4.15c-1.14.66-2.86 1.35-4.23 1.13-1.44-.24-2.47-1.4-3-2.74a7 7 0 0 1-3.56.97c-2.8 0-5.33-1.54-6.32-3.86a7.28 7.28 0 0 1-10.77-.3 7.22 7.22 0 0 1-4.88 1.86 7.2 7.2 0 0 1-5.94-3.05 7.19 7.19 0 0 1-5.94 3.05c-1.89 0-3.61-.71-4.87-1.86a7.27 7.27 0 0 1-10.77.3c-1 2.32-3.52 3.86-6.32 3.86-1.3 0-2.52-.36-3.55-.97-.54 1.34-1.57 2.5-3.01 2.74-1.37.22-3.1-.47-4.23-1.13-2.07-1.2-3.98-4.14-3.98-4.14l.2-1.8s1.27 1.48 3.56 3.28c2.3 1.8 4.02 1.7 4.02 1.7 1.5-.25 2.16-1.63 2.16-3.18v-1.53l.98 1.25a4.76 4.76 0 0 0 3.9 1.97c2.6 0 4.7-1.98 4.7-4.44 0-.73-.14-1.42-.47-2.03l.83-1.94 1.54 1.52-.03.57c0 2.57 2.19 4.65 4.9 4.65 2.42 0 4.56-1.59 4.88-3.93.06.03.05-1.75.22-1.77.2-.02.6 1.7.67 1.66a4.9 4.9 0 0 0 4.68 3.21 4.79 4.79 0 0 0 4.67-6.28l1.29-.22' fill='%23c8b100' stroke='%23000' stroke-width='.39'/%3E %3Cpath d='M283.96 205.91c.28-.83.03-1.66-.57-1.84-.6-.18-1.32.34-1.6 1.17-.3.83-.04 1.65.56 1.84.6.18 1.32-.34 1.6-1.17M262.58 201.77c.11-.87-.3-1.63-.93-1.7-.63-.07-1.22.57-1.34 1.44-.11.86.3 1.63.93 1.7.63.07 1.23-.57 1.34-1.44M237.76 201.77c-.1-.87.31-1.63.93-1.7.63-.07 1.23.57 1.34 1.44.11.86-.3 1.63-.93 1.7-.63.07-1.22-.57-1.34-1.44M216.4 205.91c-.3-.83-.04-1.66.56-1.84.6-.18 1.32.34 1.6 1.17.28.83.03 1.65-.57 1.84-.6.18-1.31-.34-1.6-1.17' fill='%23fff' stroke='%23000' stroke-width='.39'/%3E %3Cpath d='M225.68 191.65a5.34 5.34 0 0 1 2.3 3.03s.13-.25.71-.6c.6-.32 1.09-.31 1.09-.31s-.17.97-.25 1.32c-.09.34-.1 1.38-.32 2.32a7.72 7.72 0 0 1-.63 1.68 1.98 1.98 0 0 0-1.58-.41 1.9 1.9 0 0 0-1.32.9s-.66-.58-1.2-1.38c-.56-.8-.94-1.78-1.14-2.08-.21-.3-.72-1.15-.72-1.15s.47-.18 1.14-.05c.67.12.88.32.88.32a5.1 5.1 0 0 1 1.04-3.59' fill='%23c8b100' stroke='%23000' stroke-width='.39'/%3E %3Cpath d='M226.13 201.86c-.34-.27-.6-.64-.68-1.08a1.7 1.7 0 0 1 .23-1.23s-.88-.44-1.83-.7c-.72-.18-1.99-.19-2.37-.2l-1.15-.02s.07.17.28.55c.26.46.5.75.5.75a5.25 5.25 0 0 0-3.03 2.09c.99.68 2.3 1.1 3.6.97 0 0-.12.34-.2.86-.06.43-.06.61-.06.61l1.07-.4c.35-.12 1.54-.54 2.15-.95.8-.54 1.49-1.25 1.49-1.25M228.97 201.38a1.72 1.72 0 0 0-.42-2.3s.67-.71 1.47-1.26c.6-.4 1.8-.82 2.15-.95l1.07-.4s0 .18-.06.61c-.08.52-.2.87-.2.87 1.3-.14 2.62.3 3.6.98a5.27 5.27 0 0 1-3.03 2.08 6.82 6.82 0 0 0 .78 1.3l-1.15-.03c-.38 0-1.65 0-2.37-.2-.95-.25-1.84-.7-1.84-.7' fill='%23c8b100' stroke='%23000' stroke-width='.39'/%3E %3Cpath d='M225.2 200.45c0-1.14.97-2.06 2.17-2.06 1.19 0 2.16.92 2.16 2.06 0 1.13-.97 2.05-2.16 2.05-1.2 0-2.17-.92-2.17-2.05' fill='%23ad1519' stroke='%23000' stroke-width='.39'/%3E %3Cpath d='M250.11 188.37a5.91 5.91 0 0 1 1.95 3.8s.19-.26.91-.52 1.28-.16 1.28-.16-.39 1.05-.56 1.42c-.16.37-.38 1.53-.83 2.53a8.58 8.58 0 0 1-1.05 1.76c-.4-.45-1-.75-1.67-.75-.67 0-1.27.3-1.67.75 0 0-.61-.76-1.06-1.76-.44-1-.66-2.16-.83-2.53-.17-.37-.56-1.42-.56-1.42s.56-.1 1.28.16.92.53.92.53c.1-1.46.86-2.87 1.9-3.81' fill='%23c8b100' stroke='%23000' stroke-width='.39'/%3E %3Cpath d='M248.5 199.83a1.96 1.96 0 0 1-.01-2.65s-.9-.67-1.9-1.12c-.77-.35-2.18-.59-2.6-.67l-1.28-.24s.04.2.2.67c.2.56.4.93.4.93a6.1 6.1 0 0 0-3.81 1.76 6.17 6.17 0 0 0 3.8 1.75s-.19.36-.39.93c-.16.46-.2.66-.2.66l1.28-.23c.42-.09 1.83-.32 2.6-.67 1-.46 1.9-1.11 1.9-1.11M251.76 199.83a1.95 1.95 0 0 0 .01-2.65s.9-.67 1.9-1.12c.77-.35 2.18-.59 2.6-.67l1.28-.24s-.03.2-.2.67c-.2.56-.4.93-.4.93 1.47.08 2.86.81 3.81 1.76a6.15 6.15 0 0 1-3.8 1.75 7.05 7.05 0 0 0 .59 1.6l-1.27-.24c-.43-.09-1.84-.32-2.6-.67-1-.46-1.92-1.11-1.92-1.11M274.67 191.65a5.36 5.36 0 0 0-2.3 3.03s-.13-.25-.72-.6c-.58-.32-1.09-.31-1.09-.31s.17.97.26 1.32c.09.34.09 1.38.31 2.32.23.93.64 1.68.64 1.68.42-.34.99-.5 1.57-.41.59.1 1.06.44 1.33.9 0 0 .66-.58 1.2-1.38.55-.8.93-1.78 1.13-2.08.21-.3.72-1.15.72-1.15s-.47-.18-1.14-.05c-.67.12-.88.32-.88.32a5.06 5.06 0 0 0-1.03-3.59' fill='%23c8b100' stroke='%23000' stroke-width='.39'/%3E %3Cpath d='M274.22 201.86c.34-.27.6-.64.67-1.08.09-.44 0-.87-.22-1.23 0 0 .88-.44 1.82-.7.73-.18 2-.19 2.37-.2l1.15-.02s-.06.17-.28.55c-.26.46-.5.75-.5.75a5.26 5.26 0 0 1 3.04 2.09 5.5 5.5 0 0 1-3.6.97s.11.34.2.86c.06.43.05.61.05.61l-1.06-.4c-.36-.12-1.55-.54-2.16-.95-.8-.54-1.48-1.25-1.48-1.25M271.38 201.38a1.74 1.74 0 0 1-.25-1.23c.09-.44.33-.8.67-1.08 0 0-.67-.7-1.47-1.25-.61-.4-1.8-.82-2.16-.95l-1.06-.4s0 .18.06.61c.08.52.2.87.2.87-1.3-.14-2.62.3-3.6.98a5.27 5.27 0 0 0 3.02 2.08s-.23.28-.49.74c-.22.39-.28.56-.28.56l1.14-.03c.38 0 1.66 0 2.37-.2.95-.25 1.84-.7 1.84-.7' fill='%23c8b100' stroke='%23000' stroke-width='.39'/%3E %3Cpath d='M270.81 200.45c0-1.14.97-2.06 2.17-2.06s2.17.92 2.17 2.06c0 1.13-.97 2.05-2.17 2.05s-2.17-.92-2.17-2.05M295.05 205c-.5-.53-1.57-.42-2.36.26-.79.67-1.02 1.66-.5 2.2.5.53 1.56.41 2.35-.26.8-.67 1.02-1.66.51-2.2' fill='%23ad1519' stroke='%23000' stroke-width='.39'/%3E %3Cpath d='M291.97 206.31c.11-.36.36-.74.72-1.05.8-.68 1.85-.8 2.36-.25.06.07.14.17.18.25 0 0 1.1-2.08 2.4-2.78 1.3-.7 3.5-.52 3.5-.52 0-1.6-1.3-2.89-3-2.89-.99 0-1.92.41-2.48 1.1l-.22-1.06s-1.36.27-1.98 1.82c-.62 1.55.05 3.8.05 3.8s-.33-.96-.84-1.6a8.33 8.33 0 0 0-2.49-1.66 11.2 11.2 0 0 1-1.37-.8s-.03.18-.06.6c-.02.52.02.84.02.84a8.21 8.21 0 0 0-3.83.48c.48.95 1.4 1.84 2.61 2.3 0 0-.43.36-.83.75-.33.34-.44.5-.44.5l1.28.18c.43.05 1.84.28 2.68.22.63-.04 1.32-.14 1.74-.22M208.37 206.31c-.1-.36-.35-.74-.72-1.05-.79-.68-1.84-.8-2.36-.25a1.1 1.1 0 0 0-.17.25s-1.1-2.08-2.4-2.78c-1.3-.7-3.5-.52-3.5-.52 0-1.6 1.3-2.89 2.99-2.89 1 0 1.92.41 2.48 1.1l.23-1.06s1.36.27 1.98 1.82c.62 1.55-.06 3.8-.06 3.8s.34-.96.85-1.6a8.36 8.36 0 0 1 2.49-1.66c.67-.32 1.37-.8 1.37-.8a8.21 8.21 0 0 0 .04 1.44c1.24-.17 2.7.04 3.83.48a4.92 4.92 0 0 1-2.62 2.3s.44.36.83.75c.34.34.44.5.44.5l-1.27.18c-.43.05-1.84.28-2.69.22-.62-.04-1.32-.14-1.74-.22' fill='%23c8b100' stroke='%23000' stroke-width='.39'/%3E %3Cpath d='M205.3 205c.5-.53 1.56-.42 2.35.26.8.67 1.02 1.66.51 2.2-.5.53-1.57.41-2.36-.26-.79-.67-1.02-1.66-.5-2.2M247.97 198.5c0-1.13.97-2.05 2.17-2.05s2.17.92 2.17 2.05c0 1.14-.97 2.06-2.17 2.06s-2.17-.92-2.17-2.06' fill='%23ad1519' stroke='%23000' stroke-width='.39'/%3E %3Cpath d='M245.63 167.3c0-2.32 1.98-4.2 4.42-4.2a4.32 4.32 0 0 1 4.43 4.2 4.31 4.31 0 0 1-4.43 4.2 4.32 4.32 0 0 1-4.43-4.2' fill='%23005bbf' stroke='%23000' stroke-width='.26'/%3E %3Cpath d='M248.9 155.54v2.26h-2.43v2.3h2.42V166.7h-3.05c-.03.21-.22.37-.22.6 0 .57.12 1.13.35 1.63 0 .02.02.02.03.03h8.12l.03-.03a4 4 0 0 0 .34-1.63c0-.23-.18-.39-.22-.6h-2.95v-6.61h2.42v-2.3h-2.42v-2.26h-2.43z' fill='%23c8b100' stroke='%23000' stroke-width='.26'/%3E %3Cpath d='M250.5 344.33a85.31 85.31 0 0 1-36.96-8.54 23.65 23.65 0 0 1-13.36-21.19v-33.3h100.43v33.3c0 9.19-5.33 17.21-13.37 21.2a84.42 84.42 0 0 1-36.75 8.53' fill='%23ccc'/%3E %3Cpath d='M250.5 344.33a85.31 85.31 0 0 1-36.96-8.54 23.65 23.65 0 0 1-13.36-21.19v-33.3h100.43v33.3c0 9.19-5.33 17.21-13.37 21.2a84.42 84.42 0 0 1-36.75 8.53z' fill='none' stroke='%23000' stroke-width='.52'/%3E %3Cpath d='M250.28 281.25h50.32v-55.72h-50.32v55.72z' fill='%23ccc'/%3E %3Cpath d='M250.28 281.25h50.32v-55.72h-50.32v55.72z' fill='none' stroke='%23000' stroke-width='.52'/%3E %3Cpath d='M250.32 314.57c0 13.16-11.16 23.82-25.05 23.82-13.9 0-25.16-10.66-25.16-23.82V281.2h50.2v33.36' fill='%23ad1519'/%3E %3Cpath d='M211.08 334.23c1.57.83 3.72 2.22 6.03 2.77l-.15-56.96h-5.88v54.19z' fill='%23c8b100' stroke='%23000' stroke-width='.52'/%3E %3Cpath d='M200.03 314.12a25.4 25.4 0 0 0 5.73 15.67v-49.47h-5.66l-.07 33.8z' fill='%23c8b100' stroke='%23000' stroke-linejoin='round' stroke-width='.5'/%3E %3Cpath d='M222.28 338.25c2.3.23 4.01.19 5.87 0v-58.21h-5.88v58.21z' fill='%23c7b500' stroke='%23000' stroke-width='.52'/%3E %3Cpath d='M233.32 337c2.3-.46 4.9-1.9 6.03-2.63v-54.33h-5.88l-.15 56.96z' fill='%23c8b100' stroke='%23000' stroke-width='.52'/%3E %3Cpath d='M200.12 281.25h50.18v-55.72h-50.18v55.72z' fill='%23ad1519'/%3E %3Cpath d='M200.12 281.25h50.18v-55.72h-50.18v55.72z' fill='none' stroke='%23000' stroke-width='.52'/%3E %3Cpath d='M244.81 329.24c2.45-2.18 4.75-7.13 5.59-12.76l.14-36.44h-5.87l.14 49.2z' fill='%23c8b100' stroke='%23000' stroke-width='.52'/%3E %3Cpath d='M250.32 314.57c0 13.16-11.16 23.82-25.05 23.82-13.9 0-25.16-10.66-25.16-23.82V281.2h50.2v33.36' fill='none' stroke='%23000' stroke-width='.52'/%3E %3Cpath d='M300.65 281.21v33.36c0 13.16-11.28 23.82-25.17 23.82-13.9 0-25.16-10.66-25.16-23.82V281.2h50.33' fill='%23ad1519'/%3E %3Cpath d='M300.65 281.21v33.36c0 13.16-11.28 23.82-25.17 23.82-13.9 0-25.16-10.66-25.16-23.82V281.2h50.33' fill='none' stroke='%23000' stroke-width='.52'/%3E %3Cpath d='M259.47 306.39c.08.17.13.34.13.52 0 .61-.52 1.1-1.17 1.1-.65 0-1.17-.49-1.17-1.1 0-.18.04-.35.12-.5l-1.63-.02a2.6 2.6 0 0 0 1.85 2.99v4.01l1.71.01v-4.04c.8-.26 1.43-.86 1.7-1.62h4.6v-1.35h-6.14m22.58 0v1.35l-4.14.01c-.06.19-.16.35-.26.51l4.8 5.46-1.29 1.05-4.78-5.47-.23.09v9.04h-1.7v-9.08c-.08-.02-.14-.05-.2-.09l-4.98 5.5-1.3-1.04 4.98-5.52c-.08-.14-.15-.3-.2-.46h-4.28v-1.35h13.59zm2.76 0v1.35h4.6c.28.76.9 1.36 1.7 1.62v4.04h1.71v-4.02a2.6 2.6 0 0 0 1.91-2.47c0-.18-.02-.36-.06-.52h-1.63c.08.17.12.34.12.52 0 .61-.52 1.1-1.16 1.1-.65 0-1.17-.49-1.17-1.1 0-.18.04-.35.12-.5l-6.14-.02m-6.96 23.04c1.34-.21 2.58-.58 3.8-1.1l.85 1.43c-1.41.6-2.93 1.04-4.5 1.28a2.7 2.7 0 0 1-2.67 2.04 2.7 2.7 0 0 1-2.67-2.02 18.23 18.23 0 0 1-4.73-1.3l.84-1.43c1.29.55 2.66.9 4.08 1.1a2.6 2.6 0 0 1 1.58-1.38l.01-7.01h1.7l.01 6.98c.75.22 1.38.74 1.7 1.4zm-11.5-2.35l-.83 1.44a17.35 17.35 0 0 1-3.8-3.22c-.86.26-1.85.1-2.59-.5a2.49 2.49 0 0 1-.3-3.64l.14-.16a15.9 15.9 0 0 1-1.32-5h1.71c.13 1.51.51 2.94 1.1 4.28.48-.06.99 0 1.45.16l4.28-4.73 1.29 1.04-4.25 4.73c.57.87.55 2-.1 2.85a15.8 15.8 0 0 0 3.23 2.75zm-6.33-4.96a1.21 1.21 0 0 1 1.65-.13c.49.4.55 1.1.13 1.56-.42.47-1.16.52-1.65.13-.5-.4-.55-1.1-.13-1.56zm-2.16-4.69l-1.76-.39-.25-4.45 1.75-.58v2.56c0 .99.09 1.92.26 2.86zm1.46-5.52l1.75.41s.09 2.87.05 2.22c-.04-.75.2 2.24.2 2.24l-1.77.58c-.18-.9-.24-1.84-.24-2.8v-2.65zm5.77 14.25a16.32 16.32 0 0 0 5.04 2.68l.4-1.7a14.27 14.27 0 0 1-4.18-2.1l-1.26 1.12m-.84 1.46c1.5 1.13 3.2 2.03 5.04 2.65l-1.31 1.23a19.49 19.49 0 0 1-4.12-2.11l.38-1.77m2.29-9.81l1.67.7 3.06-3.39-1-1.44-3.73 4.13m-1.3-1.05l-1-1.45 3.06-3.4 1.67.72-3.73 4.13m18.84 10.32l.83 1.44a17.4 17.4 0 0 0 3.8-3.22c.87.26 1.85.1 2.6-.5a2.5 2.5 0 0 0 .3-3.64l-.15-.16c.7-1.56 1.17-3.24 1.32-5h-1.7c-.14 1.51-.52 2.94-1.1 4.28-.48-.06-1 0-1.46.16l-4.27-4.73-1.3 1.04 4.26 4.73c-.57.87-.55 2 .1 2.85a15.71 15.71 0 0 1-3.23 2.75zm6.34-4.96a1.2 1.2 0 0 0-1.65-.13c-.5.4-.55 1.1-.13 1.56.42.47 1.16.52 1.65.13.5-.4.55-1.1.13-1.56zm2.15-4.69l1.76-.39.25-4.45-1.74-.58v2.56c0 .99-.1 1.92-.27 2.86zm-1.45-5.52l-1.75.41s-.1 2.87-.06 2.22c.05-.75-.2 2.24-.2 2.24l1.77.58c.18-.9.24-1.84.24-2.8v-2.65m-5.78 14.25a16.38 16.38 0 0 1-5.04 2.68l-.39-1.7a14.24 14.24 0 0 0 4.17-2.1l1.26 1.12m.85 1.46a18.18 18.18 0 0 1-5.04 2.65l1.31 1.23a19.5 19.5 0 0 0 4.12-2.11l-.39-1.77m-2.28-9.81l-1.67.7-3.06-3.39 1-1.44 3.73 4.13m1.3-1.05l1-1.45-3.06-3.4-1.67.72 3.72 4.13m-20.94-9.01l.51 1.67h4.72l.5-1.67h-5.73m22.02 0l-.52 1.67h-4.71l-.5-1.67h5.73m-12.11 22.75c0-.62.52-1.12 1.17-1.12.64 0 1.17.5 1.17 1.12 0 .6-.53 1.1-1.17 1.1-.65 0-1.17-.5-1.17-1.1zm1.98-8.08l1.76-.5v-4.45l-1.76-.48v5.43m-1.7 0l-1.76-.5v-4.45l1.76-.48v5.43' fill='%23c8b100'/%3E %3Cpath d='M255.75 306.43c.2-.93.93-1.69 1.86-1.97l-.01-5.5h1.7v5.53c.84.26 1.48.88 1.74 1.68h4.57v.26h-6.14a1.2 1.2 0 0 0-2.09.02l-1.63-.02m12.71 0v-.25h4.25c.05-.14.11-.28.19-.4l-5.25-5.85 1.3-1.04 5.17 5.75.27-.12.01-7.66h1.7v7.61l.26.07 5.06-5.76 1.3 1.03-5.08 5.74c.13.19.22.4.3.63h4.1v.25h-13.58zm22.5 0a1.2 1.2 0 0 1 1.04-.6c.45 0 .85.26 1.04.62l1.63-.02a2.68 2.68 0 0 0-1.86-1.97l.01-5.5h-1.7v5.54c-.83.26-1.48.87-1.73 1.67h-4.58v.26h6.14m-31.38-15.54l6.3 7.07 1.3-1.05-6.34-7.04c.12-.19.21-.4.29-.62h4.61v-1.6h-4.61a2.72 2.72 0 0 0-2.61-1.8 2.67 2.67 0 0 0-2.73 2.6c0 1.13.76 2.1 1.84 2.45l-.01 5.45h1.69v-5.42l.27-.04zm33.27.03l-.01 5.43h-1.7v-5.45c-.13-.04-.26-.1-.38-.15l-6.27 7.07-1.3-1.03 6.4-7.21c-.06-.1-.12-.21-.15-.33h-4.64v-1.6h4.62a2.71 2.71 0 0 1 2.6-1.8c1.5 0 2.73 1.17 2.73 2.6a2.6 2.6 0 0 1-1.9 2.47zm-16.73-.02l-.01 3.35h-1.7v-3.32a2.68 2.68 0 0 1-1.78-1.68h-4.13v-1.6h4.13a2.7 2.7 0 0 1 2.6-1.8c1.2 0 2.23.75 2.6 1.8h4.21v1.6h-4.23a2.63 2.63 0 0 1-1.69 1.65zm-18.49 4.06l-1.76.5v4.46l1.76.49v-5.45m1.7 0l1.76.5v4.46l-1.75.49v-5.45m31.78 0l-1.75.5v4.46l1.75.49v-5.45m1.71 0l1.76.5v4.46l-1.76.49v-5.45m-26.61.88l1.67-.7 3.06 3.4-1 1.44-3.73-4.14m-1.3 1.06l-1 1.45 3.06 3.4 1.67-.72-3.73-4.13m19.22-1.19l-1.68-.7-3.03 3.43 1.02 1.44 3.69-4.17m1.3 1.04l1.02 1.45-3.03 3.42-1.68-.7 3.7-4.17m-21.19 9.43l.51-1.67h4.72l.5 1.67h-5.73m-6.91-17.73c0-.61.52-1.11 1.17-1.11.64 0 1.17.5 1.17 1.11 0 .61-.53 1.1-1.17 1.1-.65 0-1.17-.49-1.17-1.1zm12.6.8l-.51 1.68h-4.71l-.51-1.67h5.74m0-1.62l-.52-1.67h-4.71l-.51 1.67h5.74m16.32 18.54l-.52-1.67h-4.71l-.5 1.67h5.73m4.57-17.73c0-.61.52-1.11 1.17-1.11.64 0 1.16.5 1.16 1.11 0 .61-.52 1.1-1.16 1.1-.65 0-1.17-.49-1.17-1.1zm-16.8 0c0-.61.53-1.11 1.17-1.11.65 0 1.17.5 1.17 1.11 0 .61-.52 1.1-1.17 1.1-.64 0-1.17-.49-1.17-1.1zm6.53.8l.52 1.68h4.7l.52-1.67h-5.74m0-1.62l.52-1.67h4.7l.52 1.67h-5.74m-6.15 5.22l-1.76.5v4.46l1.76.49v-5.45m1.69 0l1.75.5v4.46l-1.75.49v-5.45' fill='%23c8b100'/%3E %3Cpath d='M277.85 329.43c1.34-.21 2.58-.58 3.8-1.1l.85 1.43c-1.41.6-2.93 1.04-4.5 1.28a2.7 2.7 0 0 1-2.67 2.04 2.7 2.7 0 0 1-2.67-2.02 18.23 18.23 0 0 1-4.73-1.3l.84-1.43c1.29.55 2.66.9 4.08 1.1a2.6 2.6 0 0 1 1.58-1.38l.01-7.01h1.7l.01 6.98c.75.22 1.38.74 1.7 1.4zm-4.9-21.23c-.09-.14-.15-.3-.2-.46h-4.29v-1.6h4.25c.05-.14.12-.27.19-.4l-5.25-5.83 1.3-1.05 5.17 5.74.28-.12v-7.64h1.7v7.6c.07.02.19.04.26.07l5.06-5.75 1.3 1.03-5.08 5.72c.13.19.22.4.3.63h4.1v1.6l-4.13.01c-.06.19-.17.35-.26.51l4.8 5.47-1.29 1.04-4.78-5.47c-.09.03-.13.07-.23.1l-.01 9.03h-1.7v-9.08c-.07-.02-.13-.05-.2-.09l-4.98 5.51-1.29-1.04 4.98-5.53m-13.38-17.32l6.3 7.05 1.3-1.04-6.34-7.03c.12-.19.21-.4.29-.61h4.61v-1.6h-4.61a2.72 2.72 0 0 0-2.61-1.8 2.66 2.66 0 0 0-2.73 2.6c0 1.12.76 2.09 1.84 2.44l-.01 5.44h1.69v-5.4c.07-.03.2-.03.27-.05zm6.79 36.2l-.84 1.44a17.35 17.35 0 0 1-3.8-3.22c-.86.26-1.85.1-2.59-.5a2.49 2.49 0 0 1-.3-3.64l.14-.16a15.9 15.9 0 0 1-1.32-5h1.71c.13 1.51.51 2.94 1.1 4.28.48-.06.99 0 1.45.16l4.28-4.73 1.29 1.04-4.25 4.73c.57.87.55 2-.1 2.85a15.8 15.8 0 0 0 3.23 2.75zm-8.76-13.69v-4.01a2.6 2.6 0 0 1-1.9-2.47c0-1.16.8-2.15 1.91-2.48l-.01-5.5h1.7v5.53c.84.26 1.48.88 1.74 1.67h4.57v1.61h-4.6c-.27.76-.9 1.36-1.7 1.62v4.04h-1.71m2.42 8.72a1.21 1.21 0 0 1 1.65-.13c.49.4.55 1.1.13 1.56-.42.47-1.16.52-1.65.13-.5-.4-.55-1.1-.13-1.56zm-2.16-4.69l-1.76-.39-.25-4.45 1.75-.58v2.56c0 .99.09 1.92.26 2.86zm1.46-5.52l1.75.41s.09 2.87.05 2.22c-.04-.75.2 2.24.2 2.24l-1.77.58c-.18-.9-.24-1.84-.24-2.8v-2.65zm5.77 14.25a16.32 16.32 0 0 0 5.04 2.68l.4-1.7a14.27 14.27 0 0 1-4.18-2.1l-1.26 1.12m-.84 1.46c1.5 1.13 3.2 2.03 5.04 2.65l-1.31 1.23a19.49 19.49 0 0 1-4.12-2.11l.38-1.77' fill='none' stroke='%23c8b100' stroke-width='.26'/%3E %3Cpath d='M266.53 317.8l1.67.72 3.06-3.4-1-1.44-3.73 4.13m-1.3-1.05l-1-1.45 3.06-3.4 1.67.72-3.73 4.13m-7.97-9.85c0-.62.52-1.11 1.17-1.11.64 0 1.16.5 1.16 1.11 0 .61-.52 1.1-1.16 1.1-.65 0-1.17-.49-1.17-1.1zm26.8 20.17l.84 1.44a17.4 17.4 0 0 0 3.8-3.22c.87.26 1.85.1 2.6-.5a2.5 2.5 0 0 0 .3-3.64l-.15-.16c.7-1.56 1.17-3.24 1.32-5h-1.7c-.14 1.51-.52 2.94-1.1 4.28-.48-.06-1 0-1.46.16l-4.27-4.73-1.3 1.04 4.26 4.73c-.57.87-.55 2 .1 2.85a15.71 15.71 0 0 1-3.23 2.75zm8.77-13.69v-4.01a2.6 2.6 0 0 0 1.9-2.47c0-1.16-.81-2.15-1.92-2.48l.01-5.5h-1.7v5.53c-.83.26-1.48.88-1.73 1.67h-4.58v1.61h4.6c.28.76.9 1.36 1.7 1.62v4.04h1.71zm-2.42 8.73a1.2 1.2 0 0 0-1.65-.13c-.5.4-.55 1.1-.13 1.56.42.47 1.16.52 1.65.13.5-.4.55-1.1.13-1.56zm2.15-4.69l1.76-.39.25-4.45-1.74-.58v2.56c0 .99-.1 1.92-.27 2.86zm-1.45-5.52l-1.75.41s-.1 2.87-.06 2.22c.05-.75-.2 2.24-.2 2.24l1.77.58c.18-.9.24-1.84.24-2.8v-2.65m1.73-21l-.01 5.42h-1.7v-5.44c-.13-.04-.26-.1-.38-.15l-6.27 7.06-1.3-1.03 6.4-7.2c-.06-.1-.12-.2-.15-.32h-4.64v-1.6h4.62a2.71 2.71 0 0 1 2.6-1.8c1.5 0 2.73 1.16 2.73 2.6a2.6 2.6 0 0 1-1.9 2.46zm-16.73-.02l-.01 3.34h-1.7v-3.31a2.68 2.68 0 0 1-1.78-1.67h-4.13v-1.6h4.13a2.7 2.7 0 0 1 2.6-1.8c1.2 0 2.23.75 2.6 1.8h4.21v1.6h-4.23a2.63 2.63 0 0 1-1.69 1.64zm9.22 35.27a16.38 16.38 0 0 1-5.04 2.68l-.39-1.7a14.24 14.24 0 0 0 4.17-2.1l1.26 1.12m.85 1.46a18.18 18.18 0 0 1-5.04 2.65l1.31 1.23a19.5 19.5 0 0 0 4.12-2.11l-.39-1.77m-28.56-32.68l-1.76.5v4.46l1.76.48v-5.44m1.7 0l1.76.5v4.46l-1.75.48v-5.44m31.78 0l-1.75.5v4.46l1.75.48v-5.44' fill='none' stroke='%23c8b100' stroke-width='.26'/%3E %3Cpath d='M292.82 294.94l1.76.5v4.46l-1.76.48v-5.44m-8.92 22.87l-1.67.7-3.06-3.39 1-1.44 3.73 4.13m1.3-1.05l1-1.45-3.06-3.4-1.67.72 3.72 4.13m-18.98-20.94l1.67-.7 3.06 3.39-1 1.45-3.73-4.14m-1.3 1.05l-1 1.46 3.06 3.39 1.67-.72-3.73-4.13m19.22-1.18l-1.68-.7-3.03 3.43 1.02 1.43 3.69-4.16m1.3 1.04l1.02 1.44-3.03 3.42-1.68-.7 3.7-4.16m-21.19 9.4l.51-1.66h4.72l.5 1.67h-5.73m0 1.6l.51 1.68h4.72l.5-1.67h-5.73m-6.91-19.3c0-.62.52-1.11 1.17-1.11.64 0 1.17.5 1.17 1.1 0 .62-.53 1.1-1.17 1.1-.65 0-1.17-.48-1.17-1.1zm12.6.8l-.51 1.67h-4.71l-.51-1.67h5.74m0-1.62l-.52-1.66h-4.71l-.51 1.66h5.74m20.88 19.28c0-.62.52-1.11 1.17-1.11.64 0 1.16.5 1.16 1.11 0 .61-.52 1.1-1.16 1.1-.65 0-1.17-.49-1.17-1.1zm-4.56-.77l-.52-1.67h-4.71l-.5 1.67h5.73m0 1.6l-.52 1.68h-4.71l-.5-1.67h5.73m-12.11 22.75c0-.62.52-1.12 1.17-1.12.64 0 1.17.5 1.17 1.12 0 .6-.53 1.1-1.17 1.1-.65 0-1.17-.5-1.17-1.1zm1.98-8.08l1.76-.5v-4.45l-1.76-.48v5.43m-1.7 0l-1.76-.5v-4.45l1.76-.48v5.43m16.4-33.98c0-.6.52-1.1 1.17-1.1.64 0 1.16.5 1.16 1.1 0 .62-.52 1.1-1.16 1.1-.65 0-1.17-.48-1.17-1.1zm-16.8 0c0-.6.53-1.1 1.17-1.1.65 0 1.17.5 1.17 1.1 0 .62-.52 1.1-1.17 1.1-.64 0-1.17-.48-1.17-1.1zm6.53.81l.52 1.67h4.7l.52-1.67h-5.74m0-1.62l.52-1.66h4.7l.52 1.66h-5.74M274.42 292.85l-1.76.49v4.46l1.76.48v-5.43m1.69 0l1.75.49v4.46l-1.75.48v-5.43' fill='none' stroke='%23c8b100' stroke-width='.26'/%3E %3Cpath d='M272.6 306.94c0-1.44 1.22-2.6 2.73-2.6 1.5 0 2.73 1.16 2.73 2.6a2.66 2.66 0 0 1-2.73 2.58c-1.51 0-2.74-1.15-2.74-2.58' fill='%23058e6e'/%3E %3Cpath d='M275.93 239.26l.06-.62.08-.34s-1.61.13-2.46-.1a6.15 6.15 0 0 1-2.4-1.26c-.8-.68-1.1-1.1-1.67-1.18-1.36-.22-2.4.4-2.4.4s1.02.37 1.78 1.3a4.85 4.85 0 0 0 1.95 1.54c.6.18 2.66.05 3.22.07.57.03 1.84.2 1.84.2' fill='%23db4446'/%3E %3Cpath d='M275.93 239.26l.06-.62.08-.34s-1.61.13-2.46-.1a6.15 6.15 0 0 1-2.4-1.26c-.8-.68-1.1-1.1-1.67-1.18-1.36-.22-2.4.4-2.4.4s1.02.37 1.78 1.3a4.85 4.85 0 0 0 1.95 1.54c.6.18 2.66.05 3.22.07.57.03 1.84.2 1.84.2z' fill='none' stroke='%23000' stroke-width='.39'/%3E %3Cpath d='M283.46 237s0 .72.08 1.4c.06.67-.22 1.24-.1 1.61.1.37.15.66.3.93.13.26.2.94.2.94l-.74-.54c-.35-.27-.6-.44-.6-.44l.1 1.03c.04.31.22.9.51 1.24.29.33.87.89 1.05 1.33.18.45.14 1.44.14 1.44s-.46-.75-.87-.89c-.4-.14-1.26-.62-1.26-.62s.8.8.8 1.55-.33 1.6-.33 1.6-.36-.68-.83-1.13c-.47-.44-1.13-.89-1.13-.89s.52 1.17.52 1.95c0 .8-.15 2.47-.15 2.47s-.4-.64-.8-.96c-.4-.3-.86-.58-1-.78-.15-.2.46.64.53 1.16.07.51.32 2.35 1.92 4.7.94 1.36 2.39 3.76 5.5 2.97 3.11-.78 1.95-4.97 1.3-6.92a17.52 17.52 0 0 1-.94-4.87c.04-.75.58-2.97.5-3.39-.06-.4-.23-2 .15-3.28.4-1.33.73-1.85.94-2.4.22-.55.4-.86.47-1.34.07-.48.07-1.37.07-1.37s.58 1.06.72 1.44c.15.38.15 1.5.15 1.5s.1-1.12.98-1.67c.87-.55 1.88-1.13 2.13-1.44.25-.31.33-.51.33-.51s-.08 1.92-.62 2.67c-.36.5-1.77 2.1-1.77 2.1s.73-.29 1.23-.31c.5-.04.87 0 .87 0s-.62.48-1.41 1.64c-.8 1.16-.47 1.26-1.05 2.22-.58.96-1.05 1-1.78 1.58-1.08.87-.5 4.34-.36 4.86.15.51 2.03 4.76 2.07 5.8.03 1.02.21 3.32-1.6 4.79-1.16.95-3.07.96-3.5 1.23-.44.28-1.3 1.13-1.3 2.91 0 1.79.64 2.06 1.15 2.5.5.45 1.16.21 1.3.56.15.34.22.54.44.75.22.2.36.44.29.82-.07.38-.9 1.23-1.2 1.85-.29.61-.87 2.23-.87 2.47 0 .24-.06 1 .18 1.37 0 0 .9 1.06.3 1.26-.4.14-.8-.25-.98-.2-.54.14-.82.47-.98.44-.36-.06-.36-.24-.4-.75-.03-.51-.01-.72-.18-.72-.21 0-.32.18-.36.45-.04.27-.04.89-.29.89-.25 0-.61-.45-.83-.55-.22-.1-.83-.2-.87-.48-.03-.27.36-.85.76-.96.4-.1.76-.3.5-.5-.25-.21-.5-.21-.75 0-.25.2-.8.03-.76-.28.04-.31.1-.69.07-.86-.03-.17-.47-.51.1-.82.59-.3.84.27 1.42.17s.87-.31 1.08-.65c.22-.34.18-1.06-.21-1.5-.4-.45-.8-.52-.95-.8-.14-.27-.36-.92-.36-.92s.1 1.2.04 1.37c-.07.17-.04.89-.04.89l-.72-.79a5.1 5.1 0 0 1-.65-1.37l-.03 1.34c0 .37.43.72.29.86-.15.13-.83-.72-1.02-.86a3.81 3.81 0 0 1-1.01-1.06c-.25-.48-.44-1.16-.5-1.4-.08-.25-.2-1.32-.08-1.59.18-.4.47-1.13.47-1.13h-1.41c-.76 0-1.3-.23-1.6.28-.28.51-.14 1.54.22 2.88.37 1.33.58 1.98.48 2.22-.11.24-.58.8-.76.9-.19.1-.7.06-.91-.04a2.6 2.6 0 0 0-1.26-.27c-.69 0-1.12.03-1.38-.03-.25-.07-.87-.38-1.16-.31-.29.07-.79.32-.65.72.22.61-.21.75-.5.72-.3-.04-.54-.14-.91-.24-.36-.1-.9 0-.83-.42.07-.4.22-.44.4-.75.18-.3.25-.5.04-.53-.25-.02-.5-.05-.7.11-.2.16-.5.5-.76.38-.26-.14-.46-.43-.46-1.08 0-.64-.68-1.2-.05-1.17.62.03 1.41.48 1.55.13.14-.35.06-.5-.28-.78-.34-.26-.76-.43-.3-.77.44-.35.55-.35.73-.54.17-.18.4-.79.72-.64.63.3.03.73.66 1.42.62.7 1.01.94 2.06.83 1.04-.1 1.33-.24 1.33-.54 0-.3-.09-.82-.12-1.04-.02-.21.15-1 .15-1s-.48.3-.63.6c-.13.3-.42.8-.42.8s-.11-.6-.08-1.1c.02-.28.12-.78.11-.88-.03-.27-.22-.94-.22-.94s-.18.73-.29.94c-.1.21-.17 1.07-.17 1.07s-.66-.58-.47-1.55c.13-.75-.12-1.74.1-2.06.23-.33.77-1.64 2.07-1.7 1.3-.04 2.31.06 2.77.04.45-.03 2.06-.32 2.06-.32s-2.97-1.53-3.65-1.99a9.89 9.89 0 0 1-2.06-2.16c-.34-.54-.65-1.58-.65-1.58s-.53.03-1.02.3a5.13 5.13 0 0 0-1.97 2.03s.08-.94.08-1.24c0-.28-.06-.85-.06-.85s-.33 1.28-1.01 1.76c-.68.49-1.47 1.15-1.47 1.15s.08-.71.08-.88c0-.16.17-.99.17-.99s-.48.72-1.21.86c-.74.13-1.81.1-1.9.56-.08.45.2 1.07.03 1.4-.17.31-.54.53-.54.53s-.42-.35-.79-.38c-.36-.03-.7.16-.7.16s-.32-.4-.2-.67c.11-.26.68-.66.54-.83-.15-.16-.6.06-.88.2-.28.13-.88.26-.82-.2.06-.45.2-.72.06-1.04-.15-.32-.06-.53.17-.62.22-.07 1.13.03 1.21-.18.08-.21-.22-.48-.82-.61-.6-.14-.88-.49-.56-.78.3-.3.4-.38.53-.64.14-.27.2-.75.74-.51.53.24.42.82.99 1.01.56.2 1.89-.07 2.17-.23.29-.17 1.19-.84 1.5-1 .31-.16 1.6-1.12 1.6-1.12s-.75-.53-1.04-.8c-.28-.27-.78-.91-1.04-1.05a8.72 8.72 0 0 0-1.92-.64 12 12 0 0 1-1.73-.48s.6-.19.8-.35c.2-.16.64-.56.87-.53l.28.03s-1.21-.06-1.47-.14c-.25-.08-.99-.54-1.27-.54s-.84.11-.84.11.76-.48 1.38-.59c.62-.1 1.1-.08 1.1-.08s-.96-.26-1.19-.58c-.22-.33-.45-.8-.62-1.02-.17-.21-.28-.56-.6-.59-.3-.03-.84.38-1.15.35-.3-.02-.54-.22-.57-.67-.02-.46 0-.3-.1-.53-.12-.25-.57-.81-.15-.94.43-.14 1.33.08 1.42-.08.08-.16-.48-.65-.85-.83-.37-.19-.96-.51-.65-.78.31-.27.62-.37.8-.61.16-.24.36-.91.73-.7.36.21.87 1.26 1.16 1.18.28-.08.3-.83.25-1.15-.06-.32 0-.88.28-.83.28.05.5.43.96.46.45.02 1.13-.11 1.07.2-.05.33-.3.72-.62 1.08a1.6 1.6 0 0 0-.25 1.5c.2.45.7 1.18 1.16 1.47.45.3 1.3.5 1.84.85.53.36 1.78 1.34 2.2 1.45.42.1.85.32.85.32s.48-.21 1.13-.21c.65 0 2.15.1 2.71-.14.57-.24 1.3-.64 1.08-1.15-.23-.5-1.47-.96-1.36-1.36.11-.4.57-.43 1.33-.46.76-.02 1.8.14 2-.94.2-1.06.25-1.68-.81-1.92-1.08-.24-1.87-.27-2.07-1.04-.2-.78-.4-.97-.17-1.18.23-.21.62-.32 1.41-.37.8-.06 1.7-.06 1.95-.25.26-.18.31-.7.62-.91.31-.21 1.53-.4 1.53-.4s1.45.7 2.8 1.7c1.21.91 2.3 2.24 2.3 2.24' fill='%23ed72aa' stroke='%23000' stroke-width='.39'/%3E %3Cpath d='M273.05 236.24s-.17-.48-.2-.62c-.03-.13-.12-.29-.12-.29s.88 0 .85.27c-.02.27-.28.27-.33.37-.06.1-.2.27-.2.27'/%3E %3Cpath d='M273.05 236.24s-.17-.48-.2-.62c-.03-.13-.12-.29-.12-.29s.88 0 .85.27c-.02.27-.28.27-.33.37-.06.1-.2.27-.2.27z' fill='none' stroke='%23000' stroke-width='.26'/%3E %3Cpath d='M277.06 234.85l-.06-.43s.77 0 1.13.26c.57.4.93 1.02.9 1.05-.09.1-.53-.27-.84-.38 0 0-.23.06-.45.06-.23 0-.34-.1-.37-.22-.03-.1.03-.29.03-.29l-.34-.05'/%3E %3Cpath d='M277.06 234.85l-.06-.43s.77 0 1.13.26c.57.4.93 1.02.9 1.05-.09.1-.53-.27-.84-.38 0 0-.23.06-.45.06-.23 0-.34-.1-.37-.22-.03-.1.03-.29.03-.29l-.34-.05z' fill='none' stroke='%23000' stroke-width='.05'/%3E %3Cpath d='M282.57 240.9s-.34-.49-.42-.65c-.09-.15-.23-.48-.23-.48' fill='none' stroke='%23000' stroke-width='.26'/%3E %3Cpath d='M261.88 236.08s.48.34.85.4c.37.05.76.05.82.05.06 0 .17-.54.11-.9a1.84 1.84 0 0 0-1.3-1.48s.33.73.17 1.07c-.23.48-.65.86-.65.86' fill='%23db4446'/%3E %3Cpath d='M261.88 236.08s.48.34.85.4c.37.05.76.05.82.05.06 0 .17-.54.11-.9a1.84 1.84 0 0 0-1.3-1.48s.33.73.17 1.07c-.23.48-.65.86-.65.86z' fill='none' stroke='%23000' stroke-width='.39'/%3E %3Cpath d='M259.59 237.12s-.42-.77-1.33-.67c-.9.1-1.5.8-1.5.8s1-.02 1.25.14c.37.24.48.86.48.86s.54-.32.7-.54c.17-.21.4-.59.4-.59' fill='%23db4446'/%3E %3Cpath d='M259.59 237.12s-.42-.77-1.33-.67c-.9.1-1.5.8-1.5.8s1-.02 1.25.14c.37.24.48.86.48.86s.54-.32.7-.54c.17-.21.4-.59.4-.59z' fill='none' stroke='%23000' stroke-width='.39'/%3E %3Cpath d='M258.49 240.25s-.76.11-1.19.6c-.43.48-.37 1.39-.37 1.39s.51-.54.96-.54c.46 0 1.16.16 1.16.16s-.22-.56-.22-.8-.34-.8-.34-.8' fill='%23db4446'/%3E %3Cpath d='M258.49 240.25s-.76.11-1.19.6c-.43.48-.37 1.39-.37 1.39s.51-.54.96-.54c.46 0 1.16.16 1.16.16s-.22-.56-.22-.8-.34-.8-.34-.8z' fill='none' stroke='%23000' stroke-width='.39'/%3E %3Cpath d='M273.08 240.15l.33-.54.34.49-.67.05'/%3E %3Cpath d='M273.08 240.15l.33-.54.34.49-.67.05' fill='none' stroke='%23000' stroke-width='.26'/%3E %3Cpath d='M273.9 240.12l.39-.53.42.48-.82.05'/%3E %3Cpath d='M273.9 240.12l.39-.53.42.48-.82.05' fill='none' stroke='%23000' stroke-width='.26'/%3E %3Cpath d='M273.53 236.83l.82.3-.74.37-.08-.67'/%3E %3Cpath d='M273.53 236.83l.82.3-.74.37-.08-.67' fill='none' stroke='%23000' stroke-width='.26'/%3E %3Cpath d='M274.51 237.1l.74.18-.6.46-.13-.64'/%3E %3Cpath d='M274.51 237.1l.74.18-.6.46-.13-.64' fill='none' stroke='%23000' stroke-width='.26'/%3E %3Cpath d='M269 243.39s-.8.23-1.1.67c-.37.53-.34 1.07-.34 1.07s.68-.56 1.56-.33c.87.24.96.33 1.33.3.37-.03 1.27-.35 1.27-.35s-.74.86-.65 1.45c.08.59.2.85.17 1.15-.06.72-.6 1.6-.6 1.6s.31-.18 1.05-.34a4.77 4.77 0 0 0 1.75-.8c.4-.3.9-1.03.9-1.03s-.16 1 0 1.43c.17.42.23 1.66.23 1.66s.47-.42.85-.62c.2-.11.7-.38.9-.7.14-.22.31-1.06.31-1.06s.12.9.4 1.34c.28.42.7 1.74.7 1.74s.29-.86.6-1.21c.3-.35.68-.8.7-1.07.03-.27-.08-.85-.08-.85l.4.85m-11.42.61s.48-.83.93-1.1c.46-.27 1.08-.75 1.25-.8.16-.05.9-.46.9-.46m.99 5.17s1.09-.55 1.41-.75a4.11 4.11 0 0 0 1.16-1.12' fill='none' stroke='%23000' stroke-width='.39'/%3E %3Cpath d='M261.06 250.37s-.43-.45-1.16-.32c-.73.14-1.21.97-1.21.97s.62-.17.99-.08c.36.08.62.45.62.45s.33-.3.45-.45c.11-.16.3-.57.3-.57' fill='%23db4446'/%3E %3Cpath d='M261.06 250.37s-.43-.45-1.16-.32c-.73.14-1.21.97-1.21.97s.62-.17.99-.08c.36.08.62.45.62.45s.33-.3.45-.45c.11-.16.3-.57.3-.57z' fill='none' stroke='%23000' stroke-width='.39'/%3E %3Cpath d='M260.21 253.34s-.62-.1-1.16.33c-.53.43-.56 1.25-.56 1.25s.5-.43.9-.37c.4.05.88.27.88.27l.11-.64c.09-.38-.17-.84-.17-.84' fill='%23db4446'/%3E %3Cpath d='M260.21 253.34s-.62-.1-1.16.33c-.53.43-.56 1.25-.56 1.25s.5-.43.9-.37c.4.05.88.27.88.27l.11-.64c.09-.38-.17-.84-.17-.84z' fill='none' stroke='%23000' stroke-width='.39'/%3E %3Cpath d='M261.65 256.08s-.04.8.34 1.28c.4.51 1.13.59 1.13.59s-.24-.53-.28-.8c-.06-.4.34-.75.34-.75s-.37-.38-.73-.38c-.37 0-.8.06-.8.06' fill='%23db4446'/%3E %3Cpath d='M261.65 256.08s-.04.8.34 1.28c.4.51 1.13.59 1.13.59s-.24-.53-.28-.8c-.06-.4.34-.75.34-.75s-.37-.38-.73-.38c-.37 0-.8.06-.8.06zM278.33 257.41s2.04 1.26 1.98 2.3c-.06 1.05-1.13 2.42-1.13 2.42' fill='none' stroke='%23000' stroke-width='.39'/%3E %3Cpath d='M269 263.12s-.5-.64-1.21-.62c-.71.03-1.45.7-1.45.7s.88-.08 1.1.21c.24.3.46.67.46.67s.4-.21.57-.35c.17-.13.53-.61.53-.61' fill='%23db4446'/%3E %3Cpath d='M269 263.12s-.5-.64-1.21-.62c-.71.03-1.45.7-1.45.7s.88-.08 1.1.21c.24.3.46.67.46.67s.4-.21.57-.35c.17-.13.53-.61.53-.61z' fill='none' stroke='%23000' stroke-width='.39'/%3E %3Cpath d='M266.83 265.93s-.93-.14-1.39.35c-.45.48-.42 1.36-.42 1.36s.56-.61 1.07-.56c.51.05 1.08.32 1.08.32s-.09-.53-.15-.78c-.05-.24-.2-.7-.2-.7' fill='%23db4446'/%3E %3Cpath d='M266.83 265.93s-.93-.14-1.39.35c-.45.48-.42 1.36-.42 1.36s.56-.61 1.07-.56c.51.05 1.08.32 1.08.32s-.09-.53-.15-.78c-.05-.24-.2-.7-.2-.7z' fill='none' stroke='%23000' stroke-width='.39'/%3E %3Cpath d='M268.83 268.9s-.45.64-.1 1.15a2.3 2.3 0 0 0 1.04.75s-.26-.37-.14-.8c.09-.34.68-.8.68-.8l-1.48-.3' fill='%23db4446'/%3E %3Cpath d='M268.83 268.9s-.45.64-.1 1.15a2.3 2.3 0 0 0 1.04.75s-.26-.37-.14-.8c.09-.34.68-.8.68-.8l-1.48-.3z' fill='none' stroke='%23000' stroke-width='.39'/%3E %3Cpath d='M281.24 270.1s-.81-.18-1.27.09c-.45.26-.82 1.39-.82 1.39s.74-.62 1.28-.54c.53.08.93.3.93.3s.08-.46.02-.78c-.03-.19-.14-.45-.14-.45' fill='%23db4446'/%3E %3Cpath d='M281.24 270.1s-.81-.18-1.27.09c-.45.26-.82 1.39-.82 1.39s.74-.62 1.28-.54c.53.08.93.3.93.3s.08-.46.02-.78c-.03-.19-.14-.45-.14-.45z' fill='none' stroke='%23000' stroke-width='.39'/%3E %3Cpath d='M281.64 273.1s-.62.64-.4 1.18c.23.54.63 1.1.63 1.1s-.03-.8.22-1.02c.37-.32 1.05-.37 1.05-.37s-.54-.48-.71-.54c-.17-.05-.79-.35-.79-.35' fill='%23db4446'/%3E %3Cpath d='M281.64 273.1s-.62.64-.4 1.18c.23.54.63 1.1.63 1.1s-.03-.8.22-1.02c.37-.32 1.05-.37 1.05-.37s-.54-.48-.71-.54c-.17-.05-.79-.35-.79-.35z' fill='none' stroke='%23000' stroke-width='.39'/%3E %3Cpath d='M284.75 274.04s-.31.78.28 1.28c.6.51 1.1.57 1.1.57s-.45-.8-.3-1.23c.14-.45.53-.73.53-.73s-.74-.24-.85-.21c-.1.02-.76.32-.76.32' fill='%23db4446'/%3E %3Cpath d='M284.75 274.04s-.31.78.28 1.28c.6.51 1.1.57 1.1.57s-.45-.8-.3-1.23c.14-.45.53-.73.53-.73s-.74-.24-.85-.21c-.1.02-.76.32-.76.32z' fill='none' stroke='%23000' stroke-width='.39'/%3E %3Cpath d='M252.9 329.55c2.1.63 3.16 2.19 3.16 4.01 0 2.38-2.3 4.18-5.3 4.18-2.99 0-5.41-1.8-5.41-4.18 0-1.8 1-3.8 3.07-3.94 0 0-.06-.2-.24-.5l-.64-.66s.8-.15 1.25.02c.46.18.77.47.77.47s.21-.43.52-.76c.3-.33.7-.53.7-.53s.46.38.61.64c.15.27.25.59.25.59s.42-.35.8-.5c.36-.14.83-.25.83-.25s-.13.46-.22.69c-.1.23-.14.72-.14.72' fill='%23ffd691' stroke='%23000' stroke-width='.52'/%3E %3Cpath d='M250.32 340.32s-3.98-2.68-5.7-3.04c-2.2-.47-4.69-.1-5.76-.15.03.03 1.29.93 1.84 1.48.55.55 2.39 1.65 3.43 1.91 3.22.81 6.2-.2 6.2-.2M251.46 340.56s2.54-2.66 5.21-3.02c3.15-.44 5.22.26 6.44.58.03 0-1.01.5-1.56.87-.55.38-1.97 1.56-4.14 1.59-2.18.03-4.58-.23-4.98-.17l-.97.14' fill='%23058e6e' stroke='%23000' stroke-width='.52'/%3E %3Cpath d='M250.7 337.28a5.05 5.05 0 0 1 0-7.43 5.05 5.05 0 0 1 0 7.43' fill='%23ad1519' stroke='%23000' stroke-width='.52'/%3E %3Cpath d='M249.68 342.71s.61-1.52.67-2.83c.06-1.09-.15-2.17-.15-2.17h.8s.4 1.16.4 2.17c0 1.02-.2 2.37-.2 2.37s-.54.08-.72.17c-.19.09-.8.29-.8.29' fill='%23058e6e' stroke='%23000' stroke-width='.52'/%3E %3Cpath d='M300 198.67c0-.57.5-1.03 1.1-1.03.6 0 1.1.46 1.1 1.03 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.04' fill='%23fff'/%3E %3Cpath d='M300 198.67c0-.57.5-1.03 1.1-1.03.6 0 1.1.46 1.1 1.03 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.04z' fill='none' stroke='%23000' stroke-width='.39'/%3E %3Cpath d='M301.5 196.02c0-.57.5-1.04 1.1-1.04.6 0 1.1.47 1.1 1.04 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.04' fill='%23fff'/%3E %3Cpath d='M301.5 196.02c0-.57.5-1.04 1.1-1.04.6 0 1.1.47 1.1 1.04 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.04z' fill='none' stroke='%23000' stroke-width='.39'/%3E %3Cpath d='M302.5 192.94c0-.57.5-1.03 1.1-1.03.6 0 1.1.46 1.1 1.03 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.04' fill='%23fff'/%3E %3Cpath d='M302.5 192.94c0-.57.5-1.03 1.1-1.03.6 0 1.1.46 1.1 1.03 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.04z' fill='none' stroke='%23000' stroke-width='.39'/%3E %3Cpath d='M302.63 189.64c0-.57.49-1.03 1.1-1.03.6 0 1.09.46 1.09 1.03 0 .58-.5 1.04-1.1 1.04-.6 0-1.09-.46-1.09-1.04' fill='%23fff'/%3E %3Cpath d='M302.63 189.64c0-.57.49-1.03 1.1-1.03.6 0 1.09.46 1.09 1.03 0 .58-.5 1.04-1.1 1.04-.6 0-1.09-.46-1.09-1.04z' fill='none' stroke='%23000' stroke-width='.39'/%3E %3Cpath d='M301.82 186.4c0-.58.49-1.04 1.09-1.04.6 0 1.1.46 1.1 1.03 0 .58-.5 1.05-1.1 1.05-.6 0-1.1-.47-1.1-1.04' fill='%23fff'/%3E %3Cpath d='M301.82 186.4c0-.58.49-1.04 1.09-1.04.6 0 1.1.46 1.1 1.03 0 .58-.5 1.05-1.1 1.05-.6 0-1.1-.47-1.1-1.04z' fill='none' stroke='%23000' stroke-width='.39'/%3E %3Cpath d='M300.13 183.45c0-.58.49-1.04 1.1-1.04.6 0 1.1.46 1.1 1.04 0 .57-.5 1.04-1.1 1.04-.61 0-1.1-.47-1.1-1.04' fill='%23fff'/%3E %3Cpath d='M300.13 183.45c0-.58.49-1.04 1.1-1.04.6 0 1.1.46 1.1 1.04 0 .57-.5 1.04-1.1 1.04-.61 0-1.1-.47-1.1-1.04z' fill='none' stroke='%23000' stroke-width='.39'/%3E %3Cpath d='M297.88 181.03c0-.58.49-1.04 1.1-1.04.6 0 1.1.46 1.1 1.03 0 .58-.5 1.04-1.1 1.04-.61 0-1.1-.46-1.1-1.03' fill='%23fff'/%3E %3Cpath d='M297.88 181.03c0-.58.49-1.04 1.1-1.04.6 0 1.1.46 1.1 1.03 0 .58-.5 1.04-1.1 1.04-.61 0-1.1-.46-1.1-1.03z' fill='none' stroke='%23000' stroke-width='.39'/%3E %3Cpath d='M295.26 179.01c0-.57.5-1.04 1.1-1.04.6 0 1.1.47 1.1 1.04 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04' fill='%23fff'/%3E %3Cpath d='M295.26 179.01c0-.57.5-1.04 1.1-1.04.6 0 1.1.47 1.1 1.04 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04z' fill='none' stroke='%23000' stroke-width='.39'/%3E %3Cpath d='M292.14 177.36c0-.57.5-1.03 1.1-1.03.6 0 1.1.46 1.1 1.03 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.04' fill='%23fff'/%3E %3Cpath d='M292.14 177.36c0-.57.5-1.03 1.1-1.03.6 0 1.1.46 1.1 1.03 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.04z' fill='none' stroke='%23000' stroke-width='.39'/%3E %3Cpath d='M288.9 176.19c0-.57.5-1.04 1.1-1.04.6 0 1.1.47 1.1 1.04 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04' fill='%23fff'/%3E %3Cpath d='M288.9 176.19c0-.57.5-1.04 1.1-1.04.6 0 1.1.47 1.1 1.04 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04z' fill='none' stroke='%23000' stroke-width='.39'/%3E %3Cpath d='M285.28 175.54c0-.57.5-1.04 1.1-1.04.6 0 1.1.47 1.1 1.04 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04' fill='%23fff'/%3E %3Cpath d='M285.28 175.54c0-.57.5-1.04 1.1-1.04.6 0 1.1.47 1.1 1.04 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04z' fill='none' stroke='%23000' stroke-width='.39'/%3E %3Cpath d='M281.84 175.36c0-.57.5-1.03 1.1-1.03.6 0 1.1.46 1.1 1.03 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.04' fill='%23fff'/%3E %3Cpath d='M281.84 175.36c0-.57.5-1.03 1.1-1.03.6 0 1.1.46 1.1 1.03 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.04z' fill='none' stroke='%23000' stroke-width='.39'/%3E %3Cpath d='M278.47 175.48c0-.57.49-1.04 1.1-1.04.6 0 1.1.47 1.1 1.04 0 .57-.5 1.04-1.1 1.04-.61 0-1.1-.47-1.1-1.04' fill='%23fff'/%3E %3Cpath d='M278.47 175.48c0-.57.49-1.04 1.1-1.04.6 0 1.1.47 1.1 1.04 0 .57-.5 1.04-1.1 1.04-.61 0-1.1-.47-1.1-1.04z' fill='none' stroke='%23000' stroke-width='.39'/%3E %3Cpath d='M275.1 175.48c0-.57.49-1.04 1.1-1.04.6 0 1.09.47 1.09 1.04 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04' fill='%23fff'/%3E %3Cpath d='M275.1 175.48c0-.57.49-1.04 1.1-1.04.6 0 1.09.47 1.09 1.04 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04z' fill='none' stroke='%23000' stroke-width='.39'/%3E %3Cpath d='M276.79 178.37c0-.57.49-1.04 1.09-1.04.6 0 1.1.47 1.1 1.04 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04M277.47 181.57c0-.58.5-1.04 1.1-1.04.6 0 1.1.46 1.1 1.04 0 .57-.5 1.03-1.1 1.03-.6 0-1.1-.46-1.1-1.03M277.6 184.75c0-.57.49-1.04 1.1-1.04.6 0 1.09.47 1.09 1.04 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04M276.6 187.65c0-.57.49-1.04 1.1-1.04.6 0 1.09.47 1.09 1.04 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.04M274.73 190.31c0-.57.5-1.03 1.1-1.03.6 0 1.1.46 1.1 1.03 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.03' fill='%23fff' stroke='%23000' stroke-width='.39'/%3E %3Cpath d='M272.54 173.47c0-.57.5-1.03 1.1-1.03.6 0 1.1.46 1.1 1.03 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04' fill='%23fff'/%3E %3Cpath d='M272.54 173.47c0-.57.5-1.03 1.1-1.03.6 0 1.1.46 1.1 1.03 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04z' fill='none' stroke='%23000' stroke-width='.39'/%3E %3Cpath d='M269.55 171.81c0-.57.49-1.04 1.1-1.04.6 0 1.09.47 1.09 1.04 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.04' fill='%23fff'/%3E %3Cpath d='M269.55 171.81c0-.57.49-1.04 1.1-1.04.6 0 1.09.47 1.09 1.04 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.04z' fill='none' stroke='%23000' stroke-width='.39'/%3E %3Cpath d='M266.25 170.82c0-.58.49-1.04 1.1-1.04.6 0 1.09.46 1.09 1.04 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04' fill='%23fff'/%3E %3Cpath d='M266.25 170.82c0-.58.49-1.04 1.1-1.04.6 0 1.09.46 1.09 1.04 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04z' fill='none' stroke='%23000' stroke-width='.39'/%3E %3Cpath d='M262.81 170.23c0-.57.5-1.04 1.1-1.04.6 0 1.09.47 1.09 1.04 0 .57-.49 1.03-1.1 1.03-.6 0-1.09-.46-1.09-1.03' fill='%23fff'/%3E %3Cpath d='M262.81 170.23c0-.57.5-1.04 1.1-1.04.6 0 1.09.47 1.09 1.04 0 .57-.49 1.03-1.1 1.03-.6 0-1.09-.46-1.09-1.03z' fill='none' stroke='%23000' stroke-width='.39'/%3E %3Cpath d='M259.45 170.28c0-.57.49-1.04 1.1-1.04.6 0 1.09.47 1.09 1.04 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.04' fill='%23fff'/%3E %3Cpath d='M259.45 170.28c0-.57.49-1.04 1.1-1.04.6 0 1.09.47 1.09 1.04 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.04z' fill='none' stroke='%23000' stroke-width='.39'/%3E %3Cpath d='M255.95 170.87c0-.57.49-1.03 1.1-1.03.6 0 1.1.46 1.1 1.03 0 .58-.5 1.04-1.1 1.04-.61 0-1.1-.46-1.1-1.04' fill='%23fff'/%3E %3Cpath d='M255.95 170.87c0-.57.49-1.03 1.1-1.03.6 0 1.1.46 1.1 1.03 0 .58-.5 1.04-1.1 1.04-.61 0-1.1-.46-1.1-1.04z' fill='none' stroke='%23000' stroke-width='.39'/%3E %3Cpath d='M252.7 172c0-.58.5-1.05 1.1-1.05.61 0 1.1.47 1.1 1.04 0 .57-.49 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04' fill='%23fff'/%3E %3Cpath d='M252.7 172c0-.58.5-1.05 1.1-1.05.61 0 1.1.47 1.1 1.04 0 .57-.49 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04z' fill='none' stroke='%23000' stroke-width='.39'/%3E %3Cpath d='M197.84 198.67c0-.57.5-1.03 1.1-1.03.6 0 1.1.46 1.1 1.03 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.04' fill='%23fff'/%3E %3Cpath d='M197.84 198.67c0-.57.5-1.03 1.1-1.03.6 0 1.1.46 1.1 1.03 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.04z' fill='none' stroke='%23000' stroke-width='.39'/%3E %3Cpath d='M196.34 196.02c0-.57.5-1.04 1.1-1.04.6 0 1.1.47 1.1 1.04 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.04' fill='%23fff'/%3E %3Cpath d='M196.34 196.02c0-.57.5-1.04 1.1-1.04.6 0 1.1.47 1.1 1.04 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.04z' fill='none' stroke='%23000' stroke-width='.39'/%3E %3Cpath d='M195.34 192.94c0-.57.5-1.03 1.1-1.03.6 0 1.1.46 1.1 1.03 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.04' fill='%23fff'/%3E %3Cpath d='M195.34 192.94c0-.57.5-1.03 1.1-1.03.6 0 1.1.46 1.1 1.03 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.04z' fill='none' stroke='%23000' stroke-width='.39'/%3E %3Cpath d='M195.22 189.64c0-.57.49-1.03 1.1-1.03.6 0 1.1.46 1.1 1.03 0 .58-.5 1.04-1.1 1.04-.61 0-1.1-.46-1.1-1.04' fill='%23fff'/%3E %3Cpath d='M195.22 189.64c0-.57.49-1.03 1.1-1.03.6 0 1.1.46 1.1 1.03 0 .58-.5 1.04-1.1 1.04-.61 0-1.1-.46-1.1-1.04z' fill='none' stroke='%23000' stroke-width='.39'/%3E %3Cpath d='M196.03 186.4c0-.58.5-1.04 1.1-1.04.6 0 1.1.46 1.1 1.03 0 .58-.5 1.05-1.1 1.05-.6 0-1.1-.47-1.1-1.04' fill='%23fff'/%3E %3Cpath d='M196.03 186.4c0-.58.5-1.04 1.1-1.04.6 0 1.1.46 1.1 1.03 0 .58-.5 1.05-1.1 1.05-.6 0-1.1-.47-1.1-1.04z' fill='none' stroke='%23000' stroke-width='.39'/%3E %3Cpath d='M197.71 183.45c0-.58.5-1.04 1.1-1.04.6 0 1.1.46 1.1 1.04 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04' fill='%23fff'/%3E %3Cpath d='M197.71 183.45c0-.58.5-1.04 1.1-1.04.6 0 1.1.46 1.1 1.04 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04z' fill='none' stroke='%23000' stroke-width='.39'/%3E %3Cpath d='M199.97 181.03c0-.58.49-1.04 1.1-1.04.6 0 1.09.46 1.09 1.03 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.03' fill='%23fff'/%3E %3Cpath d='M199.97 181.03c0-.58.49-1.04 1.1-1.04.6 0 1.09.46 1.09 1.03 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.03z' fill='none' stroke='%23000' stroke-width='.39'/%3E %3Cpath d='M202.58 179.01c0-.57.49-1.04 1.1-1.04.6 0 1.1.47 1.1 1.04 0 .57-.5 1.04-1.1 1.04-.61 0-1.1-.47-1.1-1.04' fill='%23fff'/%3E %3Cpath d='M202.58 179.01c0-.57.49-1.04 1.1-1.04.6 0 1.1.47 1.1 1.04 0 .57-.5 1.04-1.1 1.04-.61 0-1.1-.47-1.1-1.04z' fill='none' stroke='%23000' stroke-width='.39'/%3E %3Cpath d='M205.7 177.36c0-.57.5-1.03 1.1-1.03.6 0 1.1.46 1.1 1.03 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.04' fill='%23fff'/%3E %3Cpath d='M205.7 177.36c0-.57.5-1.03 1.1-1.03.6 0 1.1.46 1.1 1.03 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.04z' fill='none' stroke='%23000' stroke-width='.39'/%3E %3Cpath d='M208.94 176.19c0-.57.5-1.04 1.1-1.04.6 0 1.1.47 1.1 1.04 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04' fill='%23fff'/%3E %3Cpath d='M208.94 176.19c0-.57.5-1.04 1.1-1.04.6 0 1.1.47 1.1 1.04 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04z' fill='none' stroke='%23000' stroke-width='.39'/%3E %3Cpath d='M212.57 175.54c0-.57.49-1.04 1.1-1.04.6 0 1.09.47 1.09 1.04 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04' fill='%23fff'/%3E %3Cpath d='M212.57 175.54c0-.57.49-1.04 1.1-1.04.6 0 1.09.47 1.09 1.04 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04z' fill='none' stroke='%23000' stroke-width='.39'/%3E %3Cpath d='M216 175.36c0-.57.5-1.03 1.1-1.03.6 0 1.1.46 1.1 1.03 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.04' fill='%23fff'/%3E %3Cpath d='M216 175.36c0-.57.5-1.03 1.1-1.03.6 0 1.1.46 1.1 1.03 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.04z' fill='none' stroke='%23000' stroke-width='.39'/%3E %3Cpath d='M219.38 175.48c0-.57.49-1.04 1.09-1.04.6 0 1.1.47 1.1 1.04 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04' fill='%23fff'/%3E %3Cpath d='M219.38 175.48c0-.57.49-1.04 1.09-1.04.6 0 1.1.47 1.1 1.04 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04z' fill='none' stroke='%23000' stroke-width='.39'/%3E %3Cpath d='M222.75 175.48c0-.57.5-1.04 1.1-1.04.6 0 1.1.47 1.1 1.04 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04' fill='%23fff'/%3E %3Cpath d='M222.75 175.48c0-.57.5-1.04 1.1-1.04.6 0 1.1.47 1.1 1.04 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04z' fill='none' stroke='%23000' stroke-width='.39'/%3E %3Cpath d='M221.06 178.37c0-.57.5-1.04 1.1-1.04.6 0 1.1.47 1.1 1.04 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04M220.38 181.57c0-.58.48-1.04 1.1-1.04.6 0 1.09.46 1.09 1.04 0 .57-.5 1.03-1.1 1.03-.6 0-1.1-.46-1.1-1.03M220.25 184.75c0-.57.5-1.04 1.1-1.04.6 0 1.1.47 1.1 1.04 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04M221.25 187.65c0-.57.5-1.04 1.1-1.04.6 0 1.1.47 1.1 1.04 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.04M223.11 190.31c0-.57.5-1.03 1.1-1.03.6 0 1.1.46 1.1 1.03 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.03' fill='%23fff' stroke='%23000' stroke-width='.39'/%3E %3Cpath d='M225.3 173.47c0-.57.5-1.03 1.1-1.03.6 0 1.1.46 1.1 1.03 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04' fill='%23fff'/%3E %3Cpath d='M225.3 173.47c0-.57.5-1.03 1.1-1.03.6 0 1.1.46 1.1 1.03 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04z' fill='none' stroke='%23000' stroke-width='.39'/%3E %3Cpath d='M228.3 171.81c0-.57.5-1.04 1.1-1.04.6 0 1.1.47 1.1 1.04 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.04' fill='%23fff'/%3E %3Cpath d='M228.3 171.81c0-.57.5-1.04 1.1-1.04.6 0 1.1.47 1.1 1.04 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.04z' fill='none' stroke='%23000' stroke-width='.39'/%3E %3Cpath d='M231.6 170.82c0-.58.5-1.04 1.1-1.04.6 0 1.1.46 1.1 1.04 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04' fill='%23fff'/%3E %3Cpath d='M231.6 170.82c0-.58.5-1.04 1.1-1.04.6 0 1.1.46 1.1 1.04 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04z' fill='none' stroke='%23000' stroke-width='.39'/%3E %3Cpath d='M235.04 170.23c0-.57.49-1.04 1.1-1.04.6 0 1.1.47 1.1 1.04 0 .57-.5 1.03-1.1 1.03-.61 0-1.1-.46-1.1-1.03' fill='%23fff'/%3E %3Cpath d='M235.04 170.23c0-.57.49-1.04 1.1-1.04.6 0 1.1.47 1.1 1.04 0 .57-.5 1.03-1.1 1.03-.61 0-1.1-.46-1.1-1.03z' fill='none' stroke='%23000' stroke-width='.39'/%3E %3Cpath d='M238.4 170.28c0-.57.49-1.04 1.1-1.04.6 0 1.09.47 1.09 1.04 0 .58-.5 1.04-1.1 1.04-.6 0-1.09-.46-1.09-1.04' fill='%23fff'/%3E %3Cpath d='M238.4 170.28c0-.57.49-1.04 1.1-1.04.6 0 1.09.47 1.09 1.04 0 .58-.5 1.04-1.1 1.04-.6 0-1.09-.46-1.09-1.04z' fill='none' stroke='%23000' stroke-width='.39'/%3E %3Cpath d='M241.9 170.87c0-.57.49-1.03 1.1-1.03.6 0 1.09.46 1.09 1.03 0 .58-.49 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.04' fill='%23fff'/%3E %3Cpath d='M241.9 170.87c0-.57.49-1.03 1.1-1.03.6 0 1.09.46 1.09 1.03 0 .58-.49 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.04z' fill='none' stroke='%23000' stroke-width='.39'/%3E %3Cpath d='M245.13 172c0-.58.5-1.05 1.1-1.05.6 0 1.1.47 1.1 1.04 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04' fill='%23fff'/%3E %3Cpath d='M245.13 172c0-.58.5-1.05 1.1-1.05.6 0 1.1.47 1.1 1.04 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04z' fill='none' stroke='%23000' stroke-width='.39'/%3E %3Cpath d='M217.34 238.41h-.92v-.92h-1.62v3.7h1.62v2.54h-3.47v7.4h1.85v14.78h-3.7v7.63h28.42v-7.63h-3.7v-14.79h1.86v-7.4h-3.47v-2.53h1.62v-3.7h-1.62v.92h-.93v-.92h-1.61v.92h-1.16v-.92h-1.62v3.7h1.62v2.54h-3.46v-8.1h1.84v-3.69h-1.84v.93h-.93v-.93h-1.62v.93h-.92v-.93h-1.85v3.7h1.85v8.09h-3.47v-2.54h1.62v-3.7h-1.62v.92h-.92v-.92h-1.85v.92zm-6.24 35.13h28.42m-28.42-1.85h28.42m-28.42-1.85h28.42m-28.42-1.85h28.42m-28.42-2.08h28.42m-24.72-1.62h21.03m-21.03-1.85h21.03m-21.03-2.08h21.03m-21.03-1.85h21.03m-21.03-1.84h21.03m-21.03-1.85h21.03m-21.03-1.85h21.03m-22.88-1.85h24.73m-24.73-1.85h24.73m-24.73-1.85h24.73m-24.73-1.84h24.73m-21.26-1.85h17.79m-10.63-1.85h3.47m-3.47-1.85h3.47m-3.47-1.85h3.47m-3.47-1.85h3.47m-5.32-2.3h7.16m-12.47 7.85h3.7m-5.32-2.31h6.93m-6.93 33.97v-1.85m0-1.85v-1.85m-1.85 1.85v1.85m3.47 0v-1.85m1.84 3.7v-1.85m0-1.85v-1.85m0-2.08v-1.62m0-1.85v-2.08m-1.84 7.63v-2.08m-3.47 2.08v-2.08m7.16 0v2.08m1.62-2.08v-1.62m-5.31-1.85v1.85m3.7-1.85v1.85m3.46-1.85v1.85m-1.85-1.85v-2.08m1.85-1.85v1.85m0-5.54v1.85m-1.85-3.7v1.85m1.85-3.7v1.85m-3.47-1.85v1.85m-3.7-1.85v1.85m-1.61-3.7v1.85m3.46-1.85v1.85m3.47-1.85v1.85m1.85-3.7v1.85m-3.47-1.85v1.85m-3.7-1.85v1.85m-1.61-3.7v1.85m6.93-1.84v1.84m-3.47-5.54v1.85m15.95-1.85h-3.7m5.32-2.31h-6.94m6.94 33.97v-1.85m0-1.85v-1.85m1.84 1.85v1.85m-3.46 0v-1.85m-1.85 3.7v-1.85m0-1.85v-1.85m0-2.08v-1.62m0-1.85v-2.08m1.85 7.63v-2.08m3.47 2.08v-2.08m-7.17 0v2.08m-1.62-2.08v-1.62m5.32-1.85v1.85m-3.7-1.85v1.85m-3.46-1.85v1.85m1.84-1.85v-2.08m-1.84-1.85v1.85m0-5.54v1.85m1.84-3.7v1.85m-1.84-3.7v1.85m3.46-1.85v1.85m3.7-1.85v1.85m1.62-3.7v1.85m-3.47-1.85v1.85m-3.47-1.85v1.85m-1.84-3.7v1.85m3.46-1.85v1.85m3.7-1.85v1.85m1.62-3.7v1.85m-6.94-1.84v1.84m3.47-5.54v1.85m-7.16 18.71v-2.08m0-5.54v-1.85m0 5.54v-1.84m0-5.55v-1.85m0-1.85v-1.84m0-3.7v-1.85m0-1.85v-1.85m-8.78 4.85h3.7m3.46-5.54h3.47m3.46 5.55h3.7' fill='%23c8b100' stroke='%23000' stroke-width='.46'/%3E %3Cpath d='M230.05 273.54v-4.86c0-.92-.46-3.7-4.85-3.7-4.16 0-4.62 2.78-4.62 3.7v4.86h9.47z' fill='%23c8b100' stroke='%23000' stroke-width='.46'/%3E %3Cpath d='M222.2 268.91l-2.32-.23c0-.92.23-2.3.93-2.77l2.08 1.62c-.23.23-.7.92-.7 1.38zM228.43 268.91l2.31-.23c0-.92-.23-2.3-.92-2.77l-2.08 1.62c.23.23.7.92.7 1.38zM226.12 266.6l1.16-2.08a5.52 5.52 0 0 0-2.08-.46c-.46 0-1.39.23-1.85.46l1.15 2.08h1.62zM221.73 260.83v-5.09c0-1.38-.92-2.54-2.54-2.54s-2.54 1.16-2.54 2.54v5.09h5.08zM228.9 260.83v-5.09c0-1.38.92-2.54 2.54-2.54 1.61 0 2.54 1.16 2.54 2.54v5.09h-5.09zM227.05 248.35l.46-4.62h-4.4l.24 4.62h3.7zM230.51 248.35l-.46-4.62h4.62l-.46 4.62h-3.7zM220.11 248.35l.23-4.62h-4.39l.47 4.62h3.7z' fill='%23c8b100' stroke='%23000' stroke-width='.46'/%3E %3Cpath d='M228.43 273.54v-4.17c0-.69-.46-2.77-3.23-2.77a2.8 2.8 0 0 0-3 2.77v4.17h6.23zM221.27 260.36v-4.39c0-1.15-.7-2.3-2.08-2.3-1.39 0-2.08 1.15-2.08 2.3v4.4h4.16zM229.36 260.36v-4.39c0-1.15.69-2.3 2.08-2.3 1.38 0 2.08 1.15 2.08 2.3v4.4h-4.16z' fill='%230039f0'/%3E %3Cpath d='M234.18 281c0-10.1 7.27-18.29 16.25-18.29s16.26 8.2 16.26 18.3c0 10.1-7.28 18.29-16.26 18.29s-16.25-8.2-16.25-18.3' fill='%23ad1519'/%3E %3Cpath d='M234.18 281c0-10.1 7.27-18.29 16.25-18.29s16.26 8.2 16.26 18.3c0 10.1-7.28 18.29-16.26 18.29s-16.25-8.2-16.25-18.3z' fill='none' stroke='%23000' stroke-width='.61'/%3E %3Cpath d='M239 280.97c0-7.4 5.12-13.41 11.44-13.41 6.31 0 11.43 6 11.43 13.41s-5.12 13.42-11.43 13.42c-6.32 0-11.44-6-11.44-13.42' fill='%23005bbf'/%3E %3Cpath d='M239 280.97c0-7.4 5.12-13.41 11.44-13.41 6.31 0 11.43 6 11.43 13.41s-5.12 13.42-11.43 13.42c-6.32 0-11.44-6-11.44-13.42z' fill='none' stroke='%23000' stroke-width='.61'/%3E %3Cpath d='M245.03 271.74s-1.35 1.49-1.35 2.86c0 1.39.57 2.54.57 2.54a1.5 1.5 0 0 0-1.41-.94c-.83 0-1.5.63-1.5 1.42 0 .22.14.58.24.77l.5.99c.15-.37.53-.57.97-.57.6 0 1.08.45 1.08 1.01 0 .09-.01.17-.04.25h-1.22v1.04h1.1l-.82 1.6 1.07-.41.81.91.84-.91 1.07.42-.8-1.6h1.08v-1.05H246a1.04 1.04 0 0 1 1.04-1.26c.44 0 .82.2.99.57l.48-.99c.1-.2.24-.55.24-.77 0-.79-.66-1.42-1.5-1.42-.65 0-1.2.4-1.4.94 0 0 .57-1.15.57-2.54 0-1.38-1.39-2.86-1.39-2.86' fill='%23c8b100'/%3E %3Cpath d='M245.03 271.74s-1.35 1.49-1.35 2.86c0 1.39.57 2.54.57 2.54a1.5 1.5 0 0 0-1.41-.94c-.83 0-1.5.63-1.5 1.42 0 .22.14.58.24.77l.5.99c.15-.37.53-.57.97-.57.6 0 1.08.45 1.08 1.01 0 .09-.01.17-.04.25h-1.22v1.04h1.1l-.82 1.6 1.07-.41.81.91.84-.91 1.07.42-.8-1.6h1.08v-1.05H246a1.04 1.04 0 0 1 1.04-1.26c.44 0 .82.2.99.57l.48-.99c.1-.2.24-.55.24-.77 0-.79-.66-1.42-1.5-1.42-.65 0-1.2.4-1.4.94 0 0 .57-1.15.57-2.54 0-1.38-1.39-2.86-1.39-2.86z' fill='none' stroke='%23000' stroke-linejoin='round' stroke-width='.34'/%3E %3Cpath d='M242.87 281.11h4.36v-1.04h-4.36v1.04z' fill='%23c8b100'/%3E %3Cpath d='M242.87 281.11h4.36v-1.04h-4.36v1.04z' fill='none' stroke='%23000' stroke-width='.34'/%3E %3Cpath d='M255.66 271.74s-1.35 1.49-1.35 2.86c0 1.39.57 2.54.57 2.54a1.5 1.5 0 0 0-1.41-.94c-.83 0-1.5.63-1.5 1.42 0 .22.14.58.24.77l.49.99c.16-.37.54-.57.98-.57.6 0 1.07.45 1.07 1.01 0 .09 0 .17-.03.25h-1.22v1.04h1.1l-.82 1.6 1.07-.41.81.91.84-.91 1.07.42-.8-1.6h1.08v-1.05h-1.22a.88.88 0 0 1-.03-.25c0-.56.48-1 1.07-1 .44 0 .82.2.98.56l.49-.99c.1-.2.24-.55.24-.77 0-.79-.67-1.42-1.5-1.42-.64 0-1.2.4-1.4.94 0 0 .57-1.15.57-2.54 0-1.38-1.39-2.86-1.39-2.86' fill='%23c8b100'/%3E %3Cpath d='M255.66 271.74s-1.35 1.49-1.35 2.86c0 1.39.57 2.54.57 2.54a1.5 1.5 0 0 0-1.41-.94c-.83 0-1.5.63-1.5 1.42 0 .22.14.58.24.77l.49.99c.16-.37.54-.57.98-.57.6 0 1.07.45 1.07 1.01 0 .09 0 .17-.03.25h-1.22v1.04h1.1l-.82 1.6 1.07-.41.81.91.84-.91 1.07.42-.8-1.6h1.08v-1.05h-1.22a.88.88 0 0 1-.03-.25c0-.56.48-1 1.07-1 .44 0 .82.2.98.56l.49-.99c.1-.2.24-.55.24-.77 0-.79-.67-1.42-1.5-1.42-.64 0-1.2.4-1.4.94 0 0 .57-1.15.57-2.54 0-1.38-1.39-2.86-1.39-2.86z' fill='none' stroke='%23000' stroke-linejoin='round' stroke-width='.34'/%3E %3Cpath d='M253.5 281.11h4.35v-1.04h-4.35v1.04z' fill='%23c8b100'/%3E %3Cpath d='M253.5 281.11h4.35v-1.04h-4.35v1.04z' fill='none' stroke='%23000' stroke-width='.34'/%3E %3Cpath d='M250.35 280.88s-1.36 1.49-1.36 2.87c0 1.38.57 2.53.57 2.53a1.5 1.5 0 0 0-1.41-.94c-.83 0-1.5.63-1.5 1.42 0 .23.14.58.25.78l.48.98c.17-.36.54-.57.99-.57.59 0 1.07.45 1.07 1.02a.9.9 0 0 1-.03.25h-1.22v1.04h1.09l-.81 1.6 1.07-.42.8.91.85-.9 1.07.41-.81-1.6h1.09v-1.04h-1.22a.94.94 0 0 1-.03-.25c0-.57.47-1.02 1.07-1.02.44 0 .81.2.98.57l.49-.98c.1-.2.24-.55.24-.78 0-.79-.67-1.42-1.5-1.42-.65 0-1.2.4-1.41.94 0 0 .57-1.15.57-2.53s-1.39-2.87-1.39-2.87' fill='%23c8b100'/%3E %3Cpath d='M250.35 280.88s-1.36 1.49-1.36 2.87c0 1.38.57 2.53.57 2.53a1.5 1.5 0 0 0-1.41-.94c-.83 0-1.5.63-1.5 1.42 0 .23.14.58.25.78l.48.98c.17-.36.54-.57.99-.57.59 0 1.07.45 1.07 1.02a.9.9 0 0 1-.03.25h-1.22v1.04h1.09l-.81 1.6 1.07-.42.8.91.85-.9 1.07.41-.81-1.6h1.09v-1.04h-1.22a.94.94 0 0 1-.03-.25c0-.57.47-1.02 1.07-1.02.44 0 .81.2.98.57l.49-.98c.1-.2.24-.55.24-.78 0-.79-.67-1.42-1.5-1.42-.65 0-1.2.4-1.41.94 0 0 .57-1.15.57-2.53s-1.39-2.87-1.39-2.87z' fill='none' stroke='%23000' stroke-linejoin='round' stroke-width='.34'/%3E %3Cpath d='M248.19 290.26h4.35v-1.04h-4.35v1.04z' fill='%23c8b100'/%3E %3Cpath d='M248.19 290.26h4.35v-1.04h-4.35v1.04z' fill='none' stroke='%23000' stroke-width='.34'/%3E %3Cpath d='M282.88 232.7l-.29.03c-.01.03-.14.24-.26.35-.26.25-.64.27-.86.07a.5.5 0 0 1-.14-.4.52.52 0 0 1-.51-.02c-.26-.14-.32-.5-.14-.8.03-.05.06-.13.1-.17l-.01-.32-.35.08-.1.2c-.22.24-.54.3-.7.16a.58.58 0 0 1-.13-.27c0 .01-.09.09-.18.1-.53.14-.74-1.04-.76-1.34l-.17.25s.16.7.08 1.3c-.08.6-.3 1.2-.3 1.2.75.18 1.87.79 2.98 1.64a9.39 9.39 0 0 1 2.35 2.42s.57-.32 1.17-.5c.6-.2 1.36-.2 1.36-.2l.22-.22c-.32.05-1.59.1-1.56-.43 0-.08.07-.18.08-.18 0 .01-.21 0-.3-.06-.18-.13-.18-.43.02-.69l.18-.13.01-.34-.34.05c-.03.04-.1.09-.15.13-.27.23-.65.25-.86.03a.44.44 0 0 1-.11-.46.57.57 0 0 1-.45-.05c-.26-.15-.31-.52-.11-.8.1-.14.28-.3.3-.32l-.06-.3' fill='%23c8b100'/%3E %3Cpath d='M282.88 232.7l-.29.03c-.01.03-.14.24-.26.35-.26.25-.64.27-.86.07a.5.5 0 0 1-.14-.4.52.52 0 0 1-.51-.02c-.26-.14-.32-.5-.14-.8.03-.05.06-.13.1-.17l-.01-.32-.35.08-.1.2c-.22.24-.54.3-.7.16a.58.58 0 0 1-.13-.27c0 .01-.09.09-.18.1-.53.14-.74-1.04-.76-1.34l-.17.25s.16.7.08 1.3c-.08.6-.3 1.2-.3 1.2.75.18 1.87.79 2.98 1.64a9.39 9.39 0 0 1 2.35 2.42s.57-.32 1.17-.5c.6-.2 1.36-.2 1.36-.2l.22-.22c-.32.05-1.59.1-1.56-.43 0-.08.07-.18.08-.18 0 .01-.21 0-.3-.06-.18-.13-.18-.43.02-.69l.18-.13.01-.34-.34.05c-.03.04-.1.09-.15.13-.27.23-.65.25-.86.03a.44.44 0 0 1-.11-.46.57.57 0 0 1-.45-.05c-.26-.15-.31-.52-.11-.8.1-.14.28-.3.3-.32l-.06-.3z' fill='none' stroke='%23000' stroke-width='.26'/%3E %3Cpath d='M280.63 233.4c.05-.07.16-.06.23 0 .08.06.1.16.06.21-.05.06-.15.06-.24 0-.07-.06-.1-.16-.05-.22'/%3E %3Cpath d='M280.63 233.4c.05-.07.16-.06.23 0 .08.06.1.16.06.21-.05.06-.15.06-.24 0-.07-.06-.1-.16-.05-.22z' fill='none' stroke='%23000' stroke-width='.05'/%3E %3Cpath d='M281.58 234.2l-.33-.26c-.06-.04-.07-.12-.04-.16.04-.04.12-.04.18 0l.32.26.34.25c.06.04.08.12.04.16-.04.04-.12.04-.18 0l-.33-.26'/%3E %3Cpath d='M281.58 234.2l-.33-.26c-.06-.04-.07-.12-.04-.16.04-.04.12-.04.18 0l.32.26.34.25c.06.04.08.12.04.16-.04.04-.12.04-.18 0l-.33-.26' fill='none' stroke='%23000' stroke-width='.05'/%3E %3Cpath d='M279.84 233l-.26-.15c-.07-.04-.1-.12-.07-.16.03-.06.1-.07.17-.03l.26.16.26.15c.06.03.1.1.07.16-.03.05-.1.06-.17.02l-.26-.15'/%3E %3Cpath d='M279.84 233l-.26-.15c-.07-.04-.1-.12-.07-.16.03-.06.1-.07.17-.03l.26.16.26.15c.06.03.1.1.07.16-.03.05-.1.06-.17.02l-.26-.15' fill='none' stroke='%23000' stroke-width='.05'/%3E %3Cpath d='M278.8 232.29c.05-.06.16-.06.24 0 .08.06.1.16.05.22-.05.05-.15.05-.23 0-.08-.07-.1-.16-.06-.22'/%3E %3Cpath d='M278.8 232.29c.05-.06.16-.06.24 0 .08.06.1.16.05.22-.05.05-.15.05-.23 0-.08-.07-.1-.16-.06-.22z' fill='none' stroke='%23000' stroke-width='.05'/%3E %3Cpath d='M282.63 234.93c.05-.06.02-.15-.05-.22-.08-.06-.19-.06-.23 0-.05.05-.03.15.05.21s.18.06.23 0'/%3E %3Cpath d='M282.63 234.93c.05-.06.02-.15-.05-.22-.08-.06-.19-.06-.23 0-.05.05-.03.15.05.21s.18.06.23 0z' fill='none' stroke='%23000' stroke-width='.05'/%3E %3Cpath d='M283.2 235.58l.22.2c.05.06.13.08.18.04.04-.04.04-.11-.01-.16l-.21-.2-.22-.22c-.05-.05-.14-.07-.18-.03-.05.03-.04.11.01.16l.21.21'/%3E %3Cpath d='M283.2 235.58l.22.2c.05.06.13.08.18.04.04-.04.04-.11-.01-.16l-.21-.2-.22-.22c-.05-.05-.14-.07-.18-.03-.05.03-.04.11.01.16l.21.21' fill='none' stroke='%23000' stroke-width='.05'/%3E %3Cpath d='M284.15 236.4c.05-.07.03-.16-.05-.22-.08-.07-.18-.07-.23 0-.05.05-.03.14.05.2s.18.07.23.01'/%3E %3Cpath d='M284.15 236.4c.05-.07.03-.16-.05-.22-.08-.07-.18-.07-.23 0-.05.05-.03.14.05.2s.18.07.23.01z' fill='none' stroke='%23000' stroke-width='.05'/%3E %3Cpath d='M281.4 230.35l-.59.02-.11.87.06.14h.15l.76-.52-.27-.5' fill='%23c8b100'/%3E %3Cpath d='M281.4 230.35l-.59.02-.11.87.06.14h.15l.76-.52-.27-.5' fill='none' stroke='%23000' stroke-width='.26'/%3E %3Cpath d='M279.8 230.84l-.02.54.92.12.15-.07-.02-.15-.53-.7-.5.26' fill='%23c8b100'/%3E %3Cpath d='M279.8 230.84l-.02.54.92.12.15-.07-.02-.15-.53-.7-.5.26' fill='none' stroke='%23000' stroke-width='.26'/%3E %3Cpath d='M281.7 231.92l-.5.27-.53-.71v-.15l.13-.06.93.11-.03.54' fill='%23c8b100'/%3E %3Cpath d='M281.7 231.92l-.5.27-.53-.71v-.15l.13-.06.93.11-.03.54' fill='none' stroke='%23000' stroke-width='.26'/%3E %3Cpath d='M280.51 231.25a.3.3 0 0 1 .4-.1c.13.08.17.25.1.38a.3.3 0 0 1-.4.1.27.27 0 0 1-.1-.38' fill='%23c8b100'/%3E %3Cpath d='M280.51 231.25a.3.3 0 0 1 .4-.1c.13.08.17.25.1.38a.3.3 0 0 1-.4.1.27.27 0 0 1-.1-.38z' fill='none' stroke='%23000' stroke-width='.26'/%3E %3Cpath d='M278.36 230.35c-.01 0-.13-.46-.26-.71-.08-.19-.39-.43-.39-.43.03-.06.42-.2.87.1.38.3-.03.86-.03.86s-.1.14-.19.18' fill='%23c8b100'/%3E %3Cpath d='M278.36 230.35c-.01 0-.13-.46-.26-.71-.08-.19-.39-.43-.39-.43.03-.06.42-.2.87.1.38.3-.03.86-.03.86s-.1.14-.19.18z' fill='none' stroke='%23000' stroke-width='.26'/%3E %3Cpath d='M279.4 230.66l-.43.37-.68-.6.06-.08.02-.15.93-.07.1.53' fill='%23c8b100'/%3E %3Cpath d='M279.4 230.66l-.43.37-.68-.6.06-.08.02-.15.93-.07.1.53' fill='none' stroke='%23000' stroke-width='.26'/%3E %3Cpath d='M278.24 230.3c.05-.16.18-.24.28-.21.1.04.15.18.1.33-.05.15-.18.23-.29.2-.1-.03-.15-.18-.1-.33' fill='%23c8b100'/%3E %3Cpath d='M278.24 230.3c.05-.16.18-.24.28-.21.1.04.15.18.1.33-.05.15-.18.23-.29.2-.1-.03-.15-.18-.1-.33z' fill='none' stroke='%23000' stroke-width='.26'/%3E %3Cpath d='M283.67 231.77l-.6-.06-.24.85.05.14h.15l.83-.4-.2-.53' fill='%23c8b100'/%3E %3Cpath d='M283.67 231.77l-.6-.06-.24.85.05.14h.15l.83-.4-.2-.53' fill='none' stroke='%23000' stroke-width='.26'/%3E %3Cpath d='M282 232.03l-.09.54.9.24.15-.05v-.14l-.42-.79-.53.2' fill='%23c8b100'/%3E %3Cpath d='M282 232.03l-.09.54.9.24.15-.05v-.14l-.42-.79-.53.2' fill='none' stroke='%23000' stroke-width='.26'/%3E %3Cpath d='M283.73 233.35l-.53.22-.42-.79.01-.15.15-.03.9.23-.1.52' fill='%23c8b100'/%3E %3Cpath d='M283.73 233.35l-.53.22-.42-.79.01-.15.15-.03.9.23-.1.52' fill='none' stroke='%23000' stroke-width='.26'/%3E %3Cpath d='M282.65 232.54c.1-.12.28-.13.4-.04.13.1.15.26.05.38a.3.3 0 0 1-.4.04.26.26 0 0 1-.05-.38' fill='%23c8b100'/%3E %3Cpath d='M282.65 232.54c.1-.12.28-.13.4-.04.13.1.15.26.05.38a.3.3 0 0 1-.4.04.26.26 0 0 1-.05-.38z' fill='none' stroke='%23000' stroke-width='.26'/%3E %3Cpath d='M285.64 233.6l.11.56-.87.3-.15-.03-.02-.15.36-.8.57.13' fill='%23c8b100'/%3E %3Cpath d='M285.64 233.6l.11.56-.87.3-.15-.03-.02-.15.36-.8.57.13' fill='none' stroke='%23000' stroke-width='.26'/%3E %3Cpath d='M285.49 235.2l-.56.13-.31-.84.03-.14.16-.02.85.35-.17.52' fill='%23c8b100'/%3E %3Cpath d='M285.49 235.2l-.56.13-.31-.84.03-.14.16-.02.85.35-.17.52' fill='none' stroke='%23000' stroke-width='.26'/%3E %3Cpath d='M283.97 233.66l-.18.52.85.34.16-.02.03-.14-.3-.83-.56.13' fill='%23c8b100'/%3E %3Cpath d='M283.97 233.66l-.18.52.85.34.16-.02.03-.14-.3-.83-.56.13' fill='none' stroke='%23000' stroke-width='.26'/%3E %3Cpath d='M284.91 234.63c.12-.11.12-.28.02-.4a.31.31 0 0 0-.41 0 .27.27 0 0 0-.01.38c.1.11.29.12.4.02' fill='%23c8b100'/%3E %3Cpath d='M284.91 234.63c.12-.11.12-.28.02-.4a.31.31 0 0 0-.41 0 .27.27 0 0 0-.01.38c.1.11.29.12.4.02z' fill='none' stroke='%23000' stroke-width='.26'/%3E %3Cpath d='M286.29 236.43c0 .01.5.03.79.09.2.04.52.27.52.27.06-.04.11-.42-.28-.78-.4-.29-.88.2-.88.2s-.12.13-.15.22' fill='%23c8b100'/%3E %3Cpath d='M286.29 236.43c0 .01.5.03.79.09.2.04.52.27.52.27.06-.04.11-.42-.28-.78-.4-.29-.88.2-.88.2s-.12.13-.15.22z' fill='none' stroke='%23000' stroke-width='.26'/%3E %3Cpath d='M285.75 235.53l-.29.47.76.51.1-.08.12-.04-.12-.88-.57.03' fill='%23c8b100'/%3E %3Cpath d='M285.75 235.53l-.29.47.76.51.1-.08.12-.04-.12-.88-.57.03' fill='none' stroke='%23000' stroke-width='.26'/%3E %3Cpath d='M286.37 236.53c.14-.07.2-.22.15-.3-.06-.1-.22-.1-.36-.03-.14.08-.2.22-.14.31.05.1.21.1.35.02' fill='%23c8b100'/%3E %3Cpath d='M286.37 236.53c.14-.07.2-.22.15-.3-.06-.1-.22-.1-.36-.03-.14.08-.2.22-.14.31.05.1.21.1.35.02z' fill='none' stroke='%23000' stroke-width='.26'/%3E %3Cpath d='M326.13 213.64v.58h-2.53v-.58h.94v-1.3h-.62v-.59h.62v-.57h.6v.57h.62v.59h-.61v1.3h.98' fill='none' stroke='%23000' stroke-width='.3'/%3E %3Cpath d='M175.44 226.15v-1.27' fill='none' stroke='%23000' stroke-width='.02'/%3E %3Cpath d='M175.1 226.15v-1.27' fill='none' stroke='%23000' stroke-width='.03'/%3E %3Cpath d='M174.77 226.15v-1.27M174.44 226.15v-1.27' fill='none' stroke='%23000' stroke-width='.04'/%3E %3Cpath d='M174.16 226.15v-1.27' fill='none' stroke='%23000' stroke-width='.05'/%3E %3Cpath d='M173.6 226.08v-1.15m.27 1.17v-1.21' fill='none' stroke='%23000' stroke-width='.06'/%3E %3Cpath d='M173.1 226.03v-1.06m.26 1.09v-1.13' fill='none' stroke='%23000' stroke-width='.07'/%3E %3Cpath d='M172.43 225.97v-.94m.22.95v-.97m.23 1V225' fill='none' stroke='%23000' stroke-width='.08'/%3E %3Cpath d='M172.19 225.96v-.9' fill='none' stroke='%23000' stroke-width='.09'/%3E %3Cpath d='M171.97 225.92v-.85' fill='none' stroke='%23000' stroke-width='.1'/%3E %3Cpath d='M171.73 225.9v-.79' fill='none' stroke='%23000' stroke-width='.11'/%3E %3Cpath d='M171.24 225.82v-.62m.25.66v-.7M171 225.77v-.55' fill='none' stroke='%23000' stroke-width='.12'/%3E %3Cpath d='M170.76 225.73v-.46' fill='none' stroke='%23000' stroke-width='.13'/%3E %3Cpath d='M170.51 225.67v-.36' fill='none' stroke='%23000' stroke-width='.14'/%3E %3Cpath d='M170.26 225.64v-.27' fill='none' stroke='%23000' stroke-width='.15'/%3E %3Cpath d='M169.99 225.58v-.13' fill='none' stroke='%23000' stroke-width='.18'/%3E %3Cpath d='M176.8 226.08v-1.16m-.58 1.2v-1.23m-.42 1.25v-1.26' fill='none' stroke='%23000' stroke-width='.01'/%3E %3Cpath d='M324.77 226.17v-1.27' fill='none' stroke='%23000' stroke-width='.02'/%3E %3Cpath d='M324.42 226.17v-1.27' fill='none' stroke='%23000' stroke-width='.03'/%3E %3Cpath d='M324.1 226.17v-1.27M323.78 226.17v-1.27' fill='none' stroke='%23000' stroke-width='.04'/%3E %3Cpath d='M323.49 226.17v-1.27' fill='none' stroke='%23000' stroke-width='.05'/%3E %3Cpath d='M322.94 226.1v-1.15m.26 1.17v-1.2' fill='none' stroke='%23000' stroke-width='.06'/%3E %3Cpath d='M322.44 226.05V225m.25 1.1v-1.14' fill='none' stroke='%23000' stroke-width='.07'/%3E %3Cpath d='M321.76 226v-.94m.22.95v-.98m.23 1v-1.01' fill='none' stroke='%23000' stroke-width='.08'/%3E %3Cpath d='M321.52 225.98v-.9' fill='none' stroke='%23000' stroke-width='.09'/%3E %3Cpath d='M321.3 225.94v-.84' fill='none' stroke='%23000' stroke-width='.1'/%3E %3Cpath d='M321.06 225.91v-.78' fill='none' stroke='%23000' stroke-width='.11'/%3E %3Cpath d='M320.57 225.85v-.63m.25.66v-.7M320.32 225.8v-.55' fill='none' stroke='%23000' stroke-width='.12'/%3E %3Cpath d='M320.1 225.75v-.46' fill='none' stroke='%23000' stroke-width='.13'/%3E %3Cpath d='M319.85 225.69v-.36' fill='none' stroke='%23000' stroke-width='.14'/%3E %3Cpath d='M319.6 225.66v-.27' fill='none' stroke='%23000' stroke-width='.15'/%3E %3Cpath d='M319.32 225.6v-.13' fill='none' stroke='%23000' stroke-width='.18'/%3E %3Cpath d='M326.14 226.1v-1.16m-.58 1.2v-1.23m-.43 1.25v-1.26' fill='none' stroke='%23000' stroke-width='.01'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 720 360'%3E %3Crect fill='%23da121a' height='360' width='720'/%3E %3Crect fill='%23fcdd09' height='240' width='720'/%3E %3Crect fill='%23078930' height='120' width='720'/%3E %3Cg transform='translate(360,180)'%3E %3Ccircle fill='%230f47af' r='120'/%3E %3Cg id='t'%3E %3Cpath fill='%23fcdd09' d='M0,-96 -4.205849,-83.055728 13.141645,-29.665631H-9.987258L-12.586616,-21.665631H61.576052L72.587108,-29.665631H21.553343z'/%3E %3Cpath stroke='%23fcdd09' stroke-width='4' d='M0,44V96' transform='rotate(216)'/%3E %3C/g%3E %3Cuse xlink:href='%23t' transform='rotate(72)'/%3E %3Cuse xlink:href='%23t' transform='rotate(144)'/%3E %3Cuse xlink:href='%23t' transform='rotate(216)'/%3E %3Cuse xlink:href='%23t' transform='rotate(288)'/%3E %3C/g%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 810 540'%3E %3Cdesc%3EEuropean flag%3C/desc%3E %3Cdefs%3E %3Cg id='s'%3E %3Cg id='c'%3E %3Cpath id='t' d='M0,0v1h0.5z' transform='translate(0,-1)rotate(18)'/%3E %3Cuse xlink:href='%23t' transform='scale(-1,1)'/%3E %3C/g%3E %3Cg id='a'%3E %3Cuse xlink:href='%23c' transform='rotate(72)'/%3E %3Cuse xlink:href='%23c' transform='rotate(144)'/%3E %3C/g%3E %3Cuse xlink:href='%23a' transform='scale(-1,1)'/%3E %3C/g%3E %3C/defs%3E %3Crect fill='%23039' width='810' height='540'/%3E %3Cg fill='%23fc0' transform='scale(30)translate(13.5,9)'%3E %3Cuse xlink:href='%23s' y='-6'/%3E %3Cuse xlink:href='%23s' y='6'/%3E %3Cg id='l'%3E %3Cuse xlink:href='%23s' x='-6'/%3E %3Cuse xlink:href='%23s' transform='rotate(150)translate(0,6)rotate(66)'/%3E %3Cuse xlink:href='%23s' transform='rotate(120)translate(0,6)rotate(24)'/%3E %3Cuse xlink:href='%23s' transform='rotate(60)translate(0,6)rotate(12)'/%3E %3Cuse xlink:href='%23s' transform='rotate(30)translate(0,6)rotate(42)'/%3E %3C/g%3E %3Cuse xlink:href='%23l' transform='scale(-1,1)'/%3E %3C/g%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1800 1100'%3E %3Crect width='1800' height='1100' fill='%23fff'/%3E %3Crect width='1800' height='300' y='400' fill='%23003580'/%3E %3Crect width='300' height='1100' x='500' fill='%23003580'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1200 600'%3E %3CclipPath id='a'%3E %3Cpath d='M0 0v150h700v150H600zm0 300v100h300V0h300z'/%3E %3C/clipPath%3E %3Cpath fill='%23002868' d='M0 0h1200v600H0z'/%3E %3Cpath d='M0 0l600 300M0 300L600 0' stroke='%23fff' stroke-width='60'/%3E %3Cpath d='M0 0l600 300M0 300L600 0' stroke='%23ce1126' stroke-width='40' clip-path='url(%23a)'/%3E %3Cpath d='M300 0v400M0 150h700' stroke='%23fff' stroke-width='100'/%3E %3Cpath d='M300 0v400M0 150h700' stroke='%23ce1126' stroke-width='60'/%3E %3Cpath d='M0 300h600V0h600v600H0z' fill='%2368bfe5'/%3E %3Cg stroke-miterlimit='4.8'%3E %3Cpath fill='%23fff' d='M778.8 143.94v205.09c0 67.08 121.2 106.91 121.2 106.91s121.2-39.833 121.2-106.91V143.94z'/%3E %3Cpath fill='%23d21034' d='M883.2 216v92.344H778.8v33.6h104.4v107.6l16.8 6.396 16.8-6.396v-107.6h104.4v-33.6H916.8V216z'/%3E %3Cpath fill='%23d21034' d='M778.8 143.94h242.4v79.2H778.8z'/%3E %3Cg stroke-miterlimit='3'%3E %3Cg fill='%23fff' stroke='%23000' stroke-width='.805'%3E %3Cellipse stroke-width='.803' cx='798.23' cy='192.212' rx='13.623' ry='10.962'/%3E %3Cellipse cx='798.23' cy='186.525' rx='12.114' ry='6.123'/%3E %3Cellipse cx='798.23' cy='198.769' rx='12.114' ry='6.123'/%3E %3Cellipse cx='798.23' cy='192.213' rx='12.114' ry='6.123'/%3E %3C/g%3E %3Cpath fill='%23ffd100' stroke='%23000' stroke-width='1.2' d='M1015.2 207.43l-1.985-5.476s-5.433-2.216-5.847-5.102c-.968-7.694-3.714-10.578-7.83-11.678-4.125-1.1-6.868.689-6.868.689-1.24 1.787-7.426 1.787-10.859 1.921-3.434.14-3.493-1.492-3.493-1.492-2.668.02-3.79-1.941-3.79-1.941-1.746-3.487-3.045-4.792-3.908-5.233 4.457.066 7.813-1.991 12.844-7.27 5.493-5.772 9.415-3.54 9.415-3.54-2.666 5.39.887 4.913.887 4.913 7.28-3.706.96-13.051-1.237-12.638-2.198.41-2.825-1.07-2.825-1.07.067 1.678-2.44 2.345-2.44 2.345 1.88-10.674-4.489-13.504-4.489-13.504-.964.962-1.516 2.884-1.516 2.884-1.783 6.458-7.69 5.497-14.29 2.335-6.592-3.158-24.179 3.3-29.672 5.497-5.5 2.199-15.528 5.634-24.596.55-9.064-5.087-11.269-4.124-14.839-3.16-3.574.96-9.888 2.475-12.222 1.235-2.338-1.236-5.002-1.313-5.002-1.313.636-.355-.358-1.846-.358-1.846-2.747-3.708.358-5.981.358-5.981s-5.115 1.44-3.08 10.169l.934 1.309s.685 2.746 2.2 3.571l-.054.601s1.293-.6 1.7 1.184c.418 1.785 2.34.138 3.164-1.372 0 0-1.376 7.97 8.52 9.892 0 0-1.107-1.238-.693-2.062.41-.824-1.234-1.517-1.095-2.75.136-1.232-2.47-1.782-.414-2.748 2.058-.962 3.026-2.886 7.42-.275s7.834 2.064 7.834 2.064-2.681-5.502-1.204-5.499c1.477.002 8.123 8.23 11.394 7.823 3.272-.403 9.593-4.113 12.754-2.74 0 0 .271-1.648 12.36-3.71 12.092-2.061 27.006-8.087 32.599-2.807 0 0 .654 4.182 2.987 5.283 0 0-.418 8.654-15.385 3.842l-5.43-1.428s-.834-2.629-29.304 4.693c0 0-1.675.585-2.775 1.412-1.102.82-2.614-.414-8.247 1.645-5.628 2.065-26.654 8.935-39.564 6.46l-.017.034c-2.844-.85-5.508-.41-5.616-.859-.14-.55 1.513.14 1.513.14-.96-1.102-1.374-1.191-1.374-1.191-10.855-1.19-8.936-6.094-8.936-6.094l.553 1.512c1.787-2.334-.692-7.83-.692-7.83l-.105.018a5.679 5.679 0 0 0-.1-.5l.897-.62c5.222-4.397 11.269-5.222 11.269-5.222-3.575-4.394-11.134-2.058-11.134-2.058.14-5.358-2.058-11.542-2.058-11.542-7.423.825-11.678 7.006-11.678 7.006-.275-5.494-7.284-8.652-7.284-8.652 2.608 3.158.964 10.714.964 10.714l.274.138c-.434-.011-.688 0-.688 0l-.156 1.62-.257-.108s-2.608.96-5.63 7.83c0 0-.305 1.623-1.474 3.087-.01-.19.01-.36-.013-.559 0 0-3.376 4.423-11.176 0 0 0-10.598-6.288-14.323-6.055-3.725.232-6.174 1.979-5.937 3.026 0 0-8.504-.7-11.413 4.19 0 0-6.403 2.329-.93 7.57 0 0 .733 2.277 2.326 3.497 0 0-.226-4.784.933-3.378 0 0 .302.472.874.802.152.67.666 2.534 1.804 3.483l.82-.26c.124-1.193.382-2.7.647-3.334.125.017.225.032.27.035-.036.035-.07.055-.104.087l1.513 2.329 1.745-.931c.817-.12 1.863.7 1.863.7l1.98-1.632c-.012-.018-.024-.021-.036-.04 1.95.326 2.483-3.454 2.483-3.454 1.752.46 3.39-.055 4.785-.9.85 3.134 7.791 6.496 7.791 6.496l.299-.026c-.588.376-.937.658-.937.658 3.158 2.202 9.067 1.651 9.067 1.651-2.47.964-2.125 5.537-2.125 5.537-1.444.593-1.585 2.018-1.585 2.018 4.81 1.92 8.095.33 8.095.33.264 1.565-.125 1.732-.125 1.732-1.922 4.12-2.747 8.105-2.747 8.105.042.018.091.027.132.042-.059.108-.132.212-.177.324 0 0-8.384 2.91-12.11 6.986 0 0-.35-1.166-1.399-1.166-1.047 0-4.308-2.675-5.822-3.143-1.51-.463-3.725.468-4.308-.23-.527-.635-.29-5.405-1.298-6.174l.019.004-1.049-2.91c-.698 1.512-3.608 1.161-3.608 1.161-.116.07-.563.396-1.197.869-.58.031-1.249-.17-1.249-.17-.299.062-.594.9-.811 1.716-.117.086-.235.176-.353.266v-.817c-.58.465-1.745-.233-2.213-.233-.228 0-.51.667-.739 1.352-1.184.22-2.754.279-2.754.279-.466.233-.119 3.842-.119 3.842-3.374 1.865-1.746 4.657-1.746 4.657 1.864 9.083 17.35 5.007 18.515 6.174 1.162 1.166 3.843 1.395 5.24 1.395 1.395 0 3.14 3.378 5.122 3.727 1.981.35 0-2.677 9.183-4.87 9.178-2.194 12.239-5.959 12.239-5.959 2.875-.554 3.675-4.049 3.89-5.46.028.65.104 1.37.209 2.19.414 3.161-1.77 4.312-1.77 4.312l7.955-2.388c3.157-.825 2.746-3.575 2.746-3.575 3.022 8.657 8.52 9.206 8.52 9.206 1.098-3.298.963-4.26.963-4.26l2.472-.135c.1-1.864-1.545-3.226-2.497-3.86l3.87 2.348 1.508-.275c0 1.374 2.062 2.608 2.062 2.608l.278-1.782c1.787 2.335 5.083 1.51 5.083 1.51a11.039 11.039 0 0 0-.291-1.284c7.04 4.346 18.286-1.189 18.286-1.189 3.021.687 3.434-1.1 3.434-1.1 3.434.41 4.231-1.937 4.231-1.937 8.083-.7 13.772-6.446 13.772-6.446 3.98-.275 4.11-3.122 4.11-3.122s3.991.788 7.84-4.022c8.928-12.775 22.28-6.124 22.28-6.124l-7.72.489c-20.194-.136-11.822 13.598-11.822 13.598l1.245-.132c1.923.411 8.515 5.633 6.085 9.522-.039.068-.091.13-.136.193-4.117 5.636-11.742.26-13.915-4.495-2.2-4.807-6.599-3.707-6.599-3.707s-11.4 1.924-6.73 10.991l.17.005c.086 2.213 1.475 4.734 5.542 7.24 2.284 3.231 9.794 3.568 15.31 2.373 2.566-.56 16.112-6.384 16.112-6.384.993-2.95 4.36-2.27 7.38-6.529s-4.26-5.772-5.907-8.105c-1.651-2.339.414-1.925.414-1.925 6.592 3.573 7.141-7.832 7.141-7.832.69 6.593 6.458 8.38 6.458 8.38 3.574-3.568.967-10.852.967-10.852 8.519 15.25 13.678 12.822 13.678 12.822-4.587-2.84-2.278-6.64-2.278-6.64 4.117 16.211 21.022 2.062 21.022 2.062-.824 2.332.004 3.705 1.513 5.217 1.51 1.512 3.297 2.2 2.476 4.948-.827 2.747-8.653 2.2-8.653 2.2s-7.698-.411-7.007 6.046c.403 1.509 5.49 2.058 7.414 1.648 0 0-.794.173 2.05.553.953.122 2.104.143 3.275.104 3.279-.1 6.77-.657 6.77-.657 4.391-.959 3.707-2.476 3.707-2.476 6.726-1.24 7.418-5.775 7.418-5.775z'/%3E %3Cpath d='M791.954 179.295c.005-.007.361-.848 1.04-.95.522-.077 1.157.31 1.828 1.125l.367-.276c-.015-.027-1.813-2.646-1.097-4.495.32-.824 1.114-1.39 2.357-1.67l-.1-.452c-1.403.322-2.306.98-2.686 1.958a3.132 3.132 0 0 0-.202 1.136c0 .904.318 1.82.645 2.522-.407-.255-.803-.36-1.184-.303-.69.104-1.026.601-1.208.925zM1004 215.28c-4.59.728-11.328 1.132-11.864-.257-.094-.247-.11-1.238 3.648-3.685l-.438-.673c-3.136 2.042-4.398 3.518-3.96 4.646.962 2.5 10.799 1.072 12.763.759zM916.2 217.93c-1.046-1.6-.576-3.793 1.398-6.523l-.65-.47c-2.194 3.019-2.672 5.524-1.422 7.435z'/%3E %3Cpath d='M910 211.02c.1 2.768 2.056 5.339 5.8 7.632l.42-.686c-3.504-2.144-5.322-4.49-5.417-6.974-.138-3.812 3.89-6.752 3.929-6.783l-.47-.654c-.18.128-4.418 3.216-4.262 7.465zM988.29 212.05c-1.259 1.859-.838 4.11-.82 4.205l.788-.155c-.007-.022-.372-2.026.703-3.604.645-.949 1.686-1.564 3.097-1.832l-.145-.79c-1.635.31-2.85 1.04-3.623 2.176zM808.92 176.89l-.248-.062-.034.255c-.007.025-.358 2.464-1.464 3.127-.31.185-.643.206-1.028.065l-1.878-1.142c-.375-.33-.696-.573-1.238-.414-.108-.14-.538-.724-.538-1.662 0-.105.007-.216.022-.329.134-1.1.902-2.161 2.29-3.151l-.264-.376c-1.505 1.075-2.338 2.243-2.484 3.48a3.351 3.351 0 0 0 .697 2.448l.112.129.152-.07c.418-.185.539-.076.946.284l2.027 1.233c.514.19.99.155 1.422-.102 1.144-.685 1.545-2.681 1.639-3.235 4.877 1.048 8.802-4.88 8.972-5.135l-.39-.252c-.035.062-4.04 6.134-8.713 4.909z'/%3E %3Cpath d='M797.23 175.98c-.244.988-.077 1.957.487 2.882.539.878 1.07 1.344 1.623 1.418.674.093 1.213-.407 1.688-.845.346-.324.674-.625.944-.605l.42.29.36-.288-.747-.46c-.472-.035-.868.332-1.29.726-.421.386-.853.793-1.314.73-.4-.056-.832-.463-1.29-1.207-.497-.815-.647-1.669-.436-2.53.526-2.176 3.127-3.775 3.155-3.79l-.236-.393c-.117.068-2.792 1.71-3.364 4.072zM790.52 207.04c.233-.841.88-1.558 1.919-2.135-.205.02 1.019 1.015 2.069.904l.681-.369c.279.24 2.097 1.895 2.097 3.992 0 .441-.08.894-.279 1.353l.426.179c1.33-3.15-2.015-5.944-2.046-5.974l-.122-.096-.207.134-.596.324c-.86.09-1.979-.819-1.987-.827-1.411.615-2.133 1.43-2.4 2.399zM806.05 199c-1.004.085-3.802.62-4.715 2.071-.33.527-.379 1.107-.139 1.733l.367.977c.871 2.343 1.776 4.765 2.763 5.312l.223-.4c-.838-.465-1.75-2.913-2.556-5.072l-.365-.977c-.187-.494-.156-.928.095-1.328.75-1.19 3.265-1.765 4.365-1.856.641-.052.85 2.313.977 3.727l.457-.042c-.183-2.083-.376-4.236-1.472-4.145z'/%3E %3Cpath d='M798.38 201.3c-.588.526-.47 1.318-.462 1.352.005.218.266 6.068 3.044 7.277l.183-.421c-2.514-1.096-2.767-6.845-2.771-6.901-.001-.035-.083-.616.317-.966.421-.375 1.259-.403 2.42-.084l.123-.442c-1.34-.37-2.3-.308-2.854.185z'/%3E %3Cpath d='M796.18 201.78c-1.229.856-1.178 3.298-1.177 3.4l.46-.008c0-.026-.046-2.303.98-3.015.383-.264.887-.275 1.501-.027l.17-.425c-.765-.312-1.418-.287-1.934.075z'/%3E %3Cg%3E %3Cpath d='M862.33 169.49c.022.038 1.31 2.945 1.31 5.305 0 .419-.198.717-.291 1.081-.052-.135-.5-1.366-.5-1.366l-.39.987c-.017.055-.525 1.384.382 2.883 1.2 1.977 4.187 3.243 8.884 3.758h-.002c0 .004.059.055.066.065-.195.026-.341.08-.385.122l-.189.16.025.4c.122.488.678.512 1.784.554.187.01.49.055.705.066.275.077.557.153.557.153l-.094-.108c1.07.074 2.274.338 3.581.826-.289.076-.995.252-.995.252l1.162.458c.088.035 8.648 3.474 12.191 6.303-1.006.872-5.3 4.08-12.736 2.247l-1.246-.306.845.965c.052.058 4.896 5.614 5.9 8.983-1.687.017-8.185-.042-10.455-1.971l-.588.535c.03.05 3.115 4.576 3.804 8.105-.884.116-3 .203-4.252-1.433l-.577-.751-.313 2.037c-.605-.456-1.367-1.137-1.367-1.867v-.48l-1.833.333-3.765-2.283a7.975 7.975 0 0 0-.605-.365c-.004-.004-.035-.022-.035-.022l-.027-.016-.39.706s.448.267.577.348c.806.525 2.186 1.67 2.325 3.188-.595.035-2.448.136-2.448.136l.046.426v.067c0 .252-.08 1.304-.848 3.679-1.158-.276-5.37-1.744-7.858-8.874l-.775.192c.004.02.013.114.013.265 0 .65-.23 2.279-2.465 2.86-.013.004-4.15 1.248-6.452 1.937.43-.616.824-1.46.824-2.685 0-.26-.017-.54-.051-.837-.14-1.036-.224-1.899-.224-2.619 0-1.501.369-2.395 1.406-3.031l-.362-.716c-.097.038-9.618 3.82-14.339 2.25.216-.922 1.016-4.162 2.628-7.616l-.208.198c.31-.132.625-.615.364-2.166l-.086-.528-.484.233c-.03.015-3.052 1.363-7.417-.236.089-.358.32-1.001 1.235-1.38l.268-.108-.026-.292c0-.01-.01-.213-.01-.531 0-1.179.184-3.94 1.88-4.602l-.18-.777c-.055.007-5.161.415-8.257-1.307.812-.56 2.519-1.592 4.505-1.878l.318-.045.022-.318c.004-.016.011-.11.011-.26 0-.403-.156-1.219-.511-2.04 1.178.328 2.59.625 3.091.249l.17-.128-.146-3.099-.803.039.123 2.562c-.504.027-1.788-.23-3.035-.626l-1.234-.392.795 1.024c.645.829.727 1.858.737 2.331-2.79.519-4.976 2.251-5.07 2.33l-.41.337.435.303c2.4 1.672 6.153 1.817 8.08 1.775-1.136 1.28-1.328 3.421-1.328 4.492 0 .22.007.278.011.386-1.363.736-1.568 2.118-1.577 2.182l-.03.3.282.116c4.125 1.644 6.941.85 7.897.497.007.128.035.302.035.393 0 .378-.07.494-.07.494-2.026 4.248-2.875 8.286-2.885 8.324l-.066.334.313.124c3.828 1.53 10.705-.559 13.75-1.634-.399.689-.632 1.464-.632 2.429 0 .809.098 1.718.233 2.731.035.257.05.494.05.724 0 2.28-1.541 3.142-1.615 3.18l.306.741 7.955-2.389c1.84-.478 2.531-1.565 2.824-2.489 3.139 7.444 8.066 8.115 8.285 8.14l.32.027.1-.302c.766-2.287.943-3.449.978-4.01a439.55 439.55 0 0 0 2.462-.131l.02-.361c.004-.063.004-.123.004-.182 0-.658-.205-1.24-.49-1.764.498.3 1.377.834 1.377.834l1.318-.24c.344 1.33 1.923 2.374 2.127 2.499l.512.307s.188-1.212.267-1.74c1.965 1.758 4.753 1.235 4.885 1.202l.352-.09-.052-.357c-.4-2.688-2.204-5.886-3.265-7.596 3.491 1.587 9.85 1.471 10.163 1.461l.474-.016-.093-.465c-.564-2.825-4.094-7.272-5.57-9.04 8.201 1.541 12.606-2.714 12.795-2.907l.288-.306-.317-.278c-2.757-2.402-9.112-5.19-11.665-6.257l.894-.226-.883-.494c-2.135-1.2-4.398-1.349-5.928-1.415l-.007-.012c-.97-1.111-1.464-1.289-1.589-1.316-5.546-.612-7.579-2.166-8.317-3.366-.062-.099-.031-.166-.077-.262.12-.16.244-.318.244-.318.535-.697.726-1.63.726-2.617 0-2.547-1.294-5.457-1.367-5.625l-.738.334z'/%3E %3Cpath d='M836.8 167.86c-.017.08-.608 3.119-3.196 4.543-1.947 1.07-4.52.982-7.639-.266l-.351-.14.037.376c.008.078.213 1.864 1.897 3.172 1.402 1.092 3.408 1.475 5.922 1.2-.841.998-3.544 4.452-3.544 7.802 0 .177.011.354.028.528.344.247 4.58 1.395 6.544-1.116.07 1.077.379 4.522 1.724 5.87.737.733.91 1.804.91 2.66 0 .771-.146 1.367-.146 1.379l-.152.613.511-.372c.163-.119 4.057-2.971 5.302-6.707-.004.01.623-.937 1.825-1.325-.025.163-.046.33-.046.563 0 1.444.633 4.064 4.836 5.671l.345.132-.031-.367a7.135 7.135 0 0 1-.028-.726c0-1.055.146-2.993 1.15-3.997.662-.66.86-1.404.86-2.049 0-.507-.112-.918-.226-1.22.849.215 2.855.862 3.672 2.39 1.186 2.223 5.338.454 5.516.38l-.143-.437c-.017.004-1.746.391-2.837-.358-.48-.33-.768-.837-.869-1.51l-.192-2.31c-.042-1.047-.187-1.712-.713-2.271.55-.05 1.652-.031 2.118 1 .734 1.617 3.251 1.774 3.356 1.783l.861.045-.723-.468c-.024-.014-2.198-1.456-1.822-3.336l.313-1.376c.595-2.48 1.585-6.632.779-9.181l-.438.14c.2.636.282 1.39.282 2.196 0 2.26-.64 4.944-1.072 6.738l-.316 1.395a2.608 2.608 0 0 0-.052.538c0 1.217.79 2.146 1.405 2.705-.74-.16-1.766-.512-2.151-1.37-.605-1.326-2.229-1.387-3.004-1.23l-.542.109.462.307c.73.487.75 1.054.802 2.293l.195 2.358c.115.804.473 1.419 1.06 1.824.515.35 1.117.4 1.666.44-1.233.321-2.924.522-3.531-.62-1.145-2.132-4.292-2.702-4.424-2.727l-.48-.083.24.421c.026.046.358.652.358 1.422 0 .546-.167 1.171-.733 1.735-1.116 1.126-1.287 3.167-1.287 4.296 0 .221.011.252.015.387-3.595-1.511-4.231-3.749-4.231-5.016 0-.539.104-.898.118-.945l.105-.354-.365.062c-1.746.288-2.472 1.71-2.503 1.77-.999 2.991-3.71 5.359-4.691 6.148a6.88 6.88 0 0 0 .066-.895c0-.935-.202-2.126-1.05-2.976-1.43-1.429-1.624-5.973-1.624-6.019l-.03-.82-.4.712c-1.582 2.833-6.2 1.472-6.245 1.46-.195-3.58 3.866-8.16 3.908-8.206l.425-.472-.626.092c-2.652.384-4.712.03-6.123-1.06a4.63 4.63 0 0 1-1.644-2.499c3.076 1.146 5.656 1.21 7.642.113 2.774-1.534 3.383-4.675 3.407-4.807 2.913-6.606 5.458-7.649 5.486-7.656l-.16-.431c-.115.04-2.74 1.073-5.768 7.95z'/%3E %3Cpath d='M843.45 158.07l-.194.007-2.364 3.24.702.07c12.829 1.248 19.613 8.988 19.679 9.068l.296.344 2.326-2.527-.17-.26c-6.506-10.244-20.136-9.947-20.275-9.942zm.22.804c1.585.004 13.27.365 19.189 9.331-.29.313-.935 1.019-1.28 1.397-1.387-1.438-7.962-7.582-19.237-8.906.437-.602 1.164-1.599 1.328-1.822z'/%3E %3Cpath d='M841.6 164.84c-1.096 1.495-2.114 3.707-2.114 4.742 0 .198.038.354.122.453.007.01.046.013.059.029-1.336 1.197-2.131 3.196-2.131 5.456 0 1.243.22 2.538.681 3.773l.257.695c1.259 3.424 2.344 6.384 7.788 4.641 5.244-1.675 5.45-2.011 6.77-4.189l.345-.564c.72-1.17 1.506-1.404 2.343-1.652.999-.3 2.034-.608 2.942-2.4l.883-1.324c.953-1.313 2.142-2.94 2.285-5.023l-.46-.031c-.132 1.95-1.28 3.518-2.197 4.78l-.922 1.388c-.82 1.616-1.715 1.884-2.664 2.167-.883.263-1.79.534-2.604 1.853l-.348.566c-1.27 2.096-1.431 2.366-6.512 3.994-5.027 1.606-5.946-.9-7.218-4.364l-.257-.702c-1.433-3.818-.313-7.669 1.55-9.049l.64-.475s-.793.089-.887.1c-.01-.038-.02-.071-.02-.131 0-.624.681-2.611 2.037-4.464 1.158-1.578 3.89-3.142 3.92-3.157l-.23-.399c-.115.069-2.845 1.63-4.058 3.287z'/%3E %3Cpath d='M839.16 178.65c.9.624 2.166.58 3.692 0 .007.544.129 1.7 1.078 2.538 1.116.988 2.965 1.178 5.5.574l-.108-.446c-2.375.567-4.089.407-5.087-.469-1.072-.945-.922-2.45-.918-2.463l.042-.394-.365.155c-1.537.662-2.74.702-3.575.125-1.495-1.04-1.383-3.755-1.38-3.786l-.46-.022c-.001.124-.127 3.002 1.581 4.188z'/%3E %3Cpath d='M842.07 174.99c-.656.156-.827.706-.827 1.13 0 .102.011.197.024.279.115 1.182 1.398 1.969 2.563 2.306 1.133.328 2.528.35 3.077-.356.22-.282.38-.79-.1-1.61-1.75-2.977-4.581-1.811-4.737-1.749zm1.888 3.271c-1.02-.291-2.142-.953-2.232-1.933-.022-.094-.132-.752.448-.89l.046-.015c.104-.047 2.611-1.136 4.19 1.55.281.48.327.845.132 1.093-.338.44-1.454.526-2.584.195zm-1.934-3.254c.004-.004.046-.018.046-.018l-.046.018zM843.65 180.98c-.295 2.514-.115 2.574.066 2.63l.16.05.18-.212 1.456-1.92-1.828-.866-.034.318zm.421.376l.737.348c-.198.253-.566.744-.845 1.11.007-.378.053-.912.108-1.458zM839.86 178.96l-.097 2.376 1.995-2.413-1.887-.209-.011.246zm.449.266l.552.06c-.195.233-.324.392-.585.706.02-.37.027-.575.033-.766z'/%3E %3Cpath d='M838.53 178.2c.017.031 1.484 2.9 1.745 3.947.167.665 1.015 1.422 2.027 1.797 1.008.38 1.953.318 2.659-.174l1.325-1.101c.441-.425.588-.544.945-.483l.077-.453c-.601-.101-.894.179-1.34.603l-1.269 1.058c-.782.546-1.739.313-2.239.12-.946-.35-1.63-1.028-1.742-1.48-.275-1.094-1.721-3.92-1.78-4.04l-.408.206zM840.44 169.6c-1.62.748-2.305 2.713-2.333 2.796l.435.151c.007-.019.654-1.87 2.092-2.53.702-.322 1.488-.311 2.344.025l.17-.425c-.973-.393-1.884-.396-2.708-.017zM851.33 174.76c.128.096 3.188 2.414 1.43 5.243l.39.243c1.984-3.188-1.514-5.83-1.545-5.858l-.275.372zM842.13 175.21s-.476 1.73 1.957 2.34c0 0-2.288-.02-2.433-.61-.154-.591.013-1.9.476-1.73zM849.57 177.28c0 .15-.122.274-.271.274a.275.275 0 0 1-.271-.274c0-.148.124-.271.27-.271.15 0 .272.123.272.271zM849.84 178.36c0 .15-.122.275-.271.275s-.268-.125-.268-.275c0-.146.119-.27.268-.27s.271.125.271.27z'/%3E %3Ccircle cx='848.01' cy='177.825' r='.27'/%3E %3Cpath d='M848.75 179.45a.27.27 0 1 1-.539 0c0-.151.123-.275.268-.275.149 0 .271.123.271.275zM841.65 172.13a.273.273 0 0 1-.546 0c0-.146.125-.271.271-.271.154 0 .275.125.275.271z'/%3E %3Ccircle cx='841.65' cy='173.22' r='.27'/%3E %3Ccircle cx='840.09' cy='172.68' r='.27'/%3E %3Cpath d='M840.83 174.3a.276.276 0 0 1-.275.271.273.273 0 0 1 0-.546.278.278 0 0 1 .275.275zM845.57 164.75s3.518 2.165.132 6.228c0 0 1.666-1.237 1.836-3.362.178-2.123-1.207-3.816-1.968-2.866zM859.07 170.59c-1.133.582-2.764-.496-3.58-1.514-.814-1.02-2.5-1.28-3.55.58-1.048 1.864-2.56 2.562-2.56 2.562s1.477-.872 2.998-2.503c1.512-1.627 2.385-.32 3.87.466s1.717.959 2.763.552l.059-.143z'/%3E %3Cpath d='M858.78 170.86c-.463.348-1.312.64-2.212-.09-.9-.727-1.658-1.715-2.792-1.134-1.138.584-3.293 2.212-3.293 2.212s3.495-2.417 4.165-1.892c.668.526 2.243 1.805 3.202 1.43.961-.383.93-.526.93-.526z'/%3E %3Cpath d='M856.1 172.34c-1.105-.844-2.212.989-3.143.76-.931-.237-1.69-1.779-1.69-1.779s.877 1.631 2.097 1.252c1.224-.377 2.069-1.135 2.824-.555.757.585-.088.322-.088.322z'/%3E %3Cpath d='M854.37 172.57c-2.183.226-2.399-1.813-2.399-1.834 0 0 .689 1.78 2.619 1.457l-.22.377z'/%3E %3Cpath d='M854.3 171.18c.143.552.112.803-.473.803-.588 0-.987-.196-.987-.766 0-.571 1.374-.392 1.46-.037zM846.46 168.15c0 .38-.313.685-.7.685s-.462-.26-.462-.636.076-.73.462-.73.7.307.7.681z'/%3E %3Cpath d='M844.05 165.71s3.74.04 1.888 4.72c0 0 1.425-2.33.531-4.006-.897-1.674-2.305-1.252-2.305-1.252s-.343.317-.114.538z'/%3E %3Cpath d='M843.94 167.58c-.01.938.616 1.907 1.856 2.876l.286-.36c-1.123-.876-1.69-1.72-1.682-2.506.007-.786.612-1.253.619-1.26l-.275-.37c-.032.026-.79.604-.804 1.62z'/%3E %3Cpath d='M844.77 168.37c.16.539.577.946 1.244 1.212l.17-.425c-.527-.21-.855-.518-.972-.913-.237-.796.403-1.724.41-1.732l-.372-.267c-.036.048-.779 1.12-.48 2.125zM849.9 170.97s.696 1.512-.32 3.143c-1.02 1.63-.992 1.544-.992 1.544s1.224-2.241.759-3.175c-.462-.931.553-1.512.553-1.512zM864.45 186.76c3.842.724 12.51 7.52 12.6 7.59l.498-.636c-.365-.282-8.915-6.985-12.948-7.744l-.15.79zM867.86 196.35c.257 3.41 3.967 5.528 4.127 5.614l.392-.7c-.038-.018-3.49-1.996-3.72-4.975l-.799.061zM858.65 197.06c0 3.824 3.584 8.45 3.738 8.647l.632-.497c-.034-.043-3.567-4.602-3.567-8.15h-.803zM846.5 197.49c.632 1.262.566 1.902.403 2.215-.19.353-.58.407-.594.41l.094.801c.295-.035.887-.24 1.2-.816.383-.7.253-1.7-.383-2.964l-.72.354z'/%3E %3C/g%3E %3Cg fill='%23fff' stroke='%23000' stroke-width='.36'%3E %3Cpath d='M791.86 178.63s.233 2.56 2.212 4.079c0 0-.233-2.8.35-3.96 0-.001-1.046-1.165-2.562-.119zM795.81 180.26s.468 2.326 1.865 3.376l.82-.233s.347-2.914.813-3.262c.466-.347-1.979 1.048-3.498.119z'/%3E %3Cpath d='M799.31 180.14l1.513 2.33 1.745-.932-.348-2.792s-1.046-.237-2.91 1.394z'/%3E %3Cpath d='M806.41 180.61l-1.98 1.63s-1.046-.816-1.864-.699l.352-2.562s1.397-1.047 3.492 1.631zM792.32 204.71s-.348-3.61.119-3.842c0 0 1.394.465 1.977-.12 0 0 .816 2.914.582 4.078-.231 1.163-1.628.701-2.678-.116zM801.29 200.98s-.115-3.028.466-3.38c0 0 2.91.351 3.608-1.16l1.049 2.91s-3.26-.351-5.123 1.63z'/%3E %3Cpath stroke-width='.35' d='M798.15 201.56s.58-3.143 1.165-3.26c0 0 1.513.465 1.979-.12l-.115 3.847c0-.001.115-1.632-3.029-.467zM794.77 202.03s.698-2.795 1.165-2.795c.468 0 1.632.699 2.213.233v2.096s-2.566-.58-2.911 2.91l-.467-2.444z'/%3E %3C/g%3E %3C/g%3E %3Cg fill='%2300a651' stroke='%23000' stroke-width='.78'%3E %3Cpath d='M840.16 260s7.914 7.35 5.845 13.758c0 0 5.087-10.932-.375-14.137-5.47-3.203-5.657-.748-5.47.38z'/%3E %3Cpath fill='%23964b36' d='M830.17 267.15s-2.07 2.833.188 4.906c0 0-2.448 3.574-.56 6.595 0 0-1.51 3.203-1.133 6.596 0 0-1.321 5.275 1.505 7.73 0 0 3.018 1.508 4.34.188 0 0 2.636-3.957.938-8.109 0 0 1.885-3.39-.188-7.725 0 0 .567-2.45-1.13-5.274 0 0 1.13-1.888.186-3.394 0 0-3.767-3.961-4.146-1.513z'/%3E %3Cpath d='M832.43 257.92s-9.422-18.09-16.02-18.848c-6.598-.755-6.972-7.16-6.972-7.16s.752 3.015 6.031 3.015c5.278 0 15.456 7.349 16.585 13.003 1.13 5.653 2.263 4.902 2.263 4.902l-1.887 5.088z'/%3E %3Cpath d='M832.43 256.6s3.394-22.805 18.286-23.184c14.885-.38 9.989 1.13 13.567-1.321 0 0-9.985 5.281-16.208 6.032-6.217.754-11.308 12.812-11.119 15.08.187 2.259-3.391 6.596-5.088 5.09-1.697-1.509.563-1.697.563-1.697z'/%3E %3Cpath d='M835.82 265.09s3.391-9.047 9.235-6.029c0 0-4.526-8.673-12.629-1.134 0 0 3.582 4.9 3.394 7.163zM824.51 256.03s4.902 20.17-2.639 26.387c0 0 .187-10.361-4.335-16.582-4.52-6.223 4.522-13.003 6.974-9.805z'/%3E %3Cpath d='M825.08 259.62s8.86 8.484 9.427 11.31c.567 2.827 2.637-8.48-1.508-11.682-4.147-3.209-8.67-3.773-8.67-3.773l.751 4.145z'/%3E %3Cpath fill='%23964b36' d='M808.74 281.85s.803 3.56 2.988 4.25c0 0 .113 2.645 2.068 3.448 0 0-1.037 2.184.69 3.56 0 0-.347 4.367 1.263 5.289 0 0 3.911-.23 5.285-1.38 0 0 .806-2.868-1.374-5.747 0 0 .34-2.758-1.843-4.25 0 0 .69-3.68-2.069-5.057 0 0-.457-2.99-2.184-4.482.001-.001-3.33 4.71-4.824 4.369z'/%3E %3Cpath d='M813.1 277.48s-11.606-4.252-18.042 1.84c0 0 9.88 1.38 11.147 3.333 1.264 1.95 7.352-3.216 6.895-5.173z'/%3E %3Cpath d='M809.54 284.72s-.918-.803-2.066-1.61c-1.15-.802-10.916-3.446-12.3 5.977 0 0-3.563-9.307 1.609-10.573 5.175-1.266 9.312 1.724 12.757 6.206M801.9 265.46s3.577 7.726 4.9 8.108c1.318.372 2.26-.942 2.26-.942s-4.71-6.974-7.16-7.166zM799.26 253.59s-3.018-9.988-6.596-7.35c-3.581 2.639-2.64 9.798-2.64 9.798s-7.162-7.346-3.017-13.192c4.152-5.842 12.253.566 12.253 10.744z'/%3E %3Cpath fill='%23964b36' d='M807.37 274.13s0 1.885 1.32 2.448c1.32.566 3.77 1.505 3.77.38 0-1.131-1.884-5.467-2.642-4.9-.755.567-2.069.56-2.448 2.072z'/%3E %3Cpath d='M805.11 262.45s-.377-8.668 5.274-11.876c0 0 1.134.194 1.7-1.501 0 0-4.528 10.927-3.207 16.393l-.187.755'/%3E %3Cpath d='M806.24 251.89s10.177-21.112 22.618-13.762c0 0-13.004 2.64-17.714 11.876l-4.715 6.967-.188-5.082z'/%3E %3Cpath d='M800.77 259.62s-3.017-14.134-4.9-16.016c-1.887-1.886-5.091-3.959-8.862-.756 0 0 6.6-5.845 13.572-.942 6.971 4.9 5.464 12.628 5.464 12.628l-.751 9.802L800.58 260'/%3E %3Cpath d='M811.7 276.39s-12.44-23.552-20.542-6.78c0 0-1.512 4.332.184 6.025 0 0-4.524-3.39-2.45-11.682 2.07-8.29 15.828-4.524 19.79 2.263 3.957 6.784 5.09 10.18 4.524 10.552-.567.38-1.507-.378-1.507-.378zM846.76 283.18s9.05-18.66 14.324-10.18c0 0 1.506 4.145-.757 5.845 0 0-3.577-4.335-6.78.942-3.205 5.275-1.885 4.902-1.885 4.902s-3.394.942-4.902-1.51z'/%3E %3Cpath d='M860.32 278.84s4.9 2.635 3.209 7.913c0 0 6.591-12.625-2.452-13.758.001 0 1.698 3.96-.757 5.845zM860.89 266.03s11.876 3.39 12.252 8.484c0 0 2.076-9.805-4.711-12.82 0 .001-8.107 1.322-7.541 4.336z'/%3E %3Cpath d='M866.17 250.38c5.09-9.989 11.498 3.204 11.498 3.204s2.26-10.364-4.145-12.252c-6.411-1.884-10.556 22.05-10.556 22.05l-7.54 1.697s2.074-20.917 13.381-22.805l1.318.19'/%3E %3Cpath d='M857.12 256.41s-7.16-14.7-12.061-16.206c-4.902-1.508 2.642-3.77 5.657-.944 3.01 2.824 8.665 6.408 8.101 13.948l-1.697 3.202zM849.77 276.58s2.072-9.985 7.726-13.003c5.653-3.018 10.932-1.884 10.932-1.884s-6.788 1.505-7.914 4.902c-1.133 3.39-3.018 3.577-3.018 3.577l-7.726 6.408z'/%3E %3Cpath fill='%23964b36' d='M846.76 283.18s-3.203 6.032-2.452 6.972c0 0-3.39 4.9-2.072 7.35 0 0 3.394 2.639 4.902 1.506 0 0 3.953-5.462 2.824-8.48 0 0 2.638-3.578 1.7-5.838 0 0-3.956.187-4.902-1.51z'/%3E %3Cg fill='%23000' stroke='none'%3E %3Cpath d='M830.18 272.41c.212.108 2.116 1.032 3.396.605l.916-.783-.72-.357c-.47.931-2.542.163-3.234-.18l-.358.715zM829.87 278.26l-.156.79c.162.03 3.986.771 5.81-.849l-.535-.599c-1.524 1.353-5.08.669-5.119.658zM828.9 284.92l-.472.65c.046.035 4.49 3.2 7.334-.256l-.623-.512c-2.362 2.868-6.08.233-6.239.118zM811.64 285.88l.167.43c.16-.065 3.925-1.577 4.164-4.331l-.457-.042c-.215 2.472-3.838 3.929-3.874 3.943zM813.77 289.32l.032.458c.147-.01 3.623-.27 4.23-2.7l-.448-.116c-.524 2.107-3.78 2.354-3.814 2.358zM814.49 292.88l-.025.462c.167.007 4.06.209 5.382-1.948l-.393-.243c-1.18 1.927-4.926 1.733-4.964 1.729zM844.02 290.44c.07.073 1.748 1.732 3.71 1.658.96-.034 1.811-.476 2.53-1.303l-.608-.528c-.567.653-1.224 1.001-1.948 1.029-1.606.058-3.104-1.408-3.119-1.426l-.565.57z'/%3E %3C/g%3E %3C/g%3E %3Cg fill='%23964b36' stroke='%23000' stroke-width='.42'%3E %3Cpath d='M961.06 304.22a1.66 1.66 0 0 0-.608.403l.608-.403zM974.92 300.75c-.134-.344-.222-.2-.4-.352-.253-.208-.4-.876-.622-1.125-.132-.153-.285-.004-.428-.042-.324-.713-.705-1.464-1.046-2.152a.597.597 0 0 0 .094-.32c0-.028-.16-.577-.17-.601-.098-.153-.252-.063-.345-.3-.105-.236-.025-.701-.063-.98-.027-.232-.118-.36-.104-.688.014-.285.167-.616.149-.866-.007-.156-.191-.507-.246-.64-.223-.538-.41-1.046-.438-1.71-.028-.602.093-.97.138-1.492.056-.625-.275-.929-.275-1.506.004-.442.19-.938.244-1.334.073-.543.079-1.329.033-1.884-.04-.532-.19-.852-.108-1.45.022-.146.091-.264.108-.47-.004-.146-.004-.287-.004-.43v-.858c0-.278.028-.592.004-.863-.024-.225-.156-.458-.156-.636 0-.306.195-.451.153-.866-.027-.299-.07-.369-.138-.629-.132-.493-.042-.991-.123-1.52-.038-.252-.119-.333-.143-.622-.033-.34.071-.458.105-.7.035-.24.07-.555.038-.81-.038-.306-.183-.522-.143-.855l-.111 3.782c-.094-3.3-.226-6.355-.226-6.355l-5.018-2.357s-.425 9.214-.317 10.496c.1 1.287.532 10.076.317 11.147-.216 1.072-.744 6.429-.744 6.429s-2.454 1.714-3.414 3.64c-.964 1.93-.748 2.573-1.072 2.573l2.385-.372-1.776 1.186a1.085 1.085 0 0 1 1.106.171c.04.034.306.26.34.26.093 0 .223-.238.337-.28.37-.125.681.568 1.032.515.188-.028.445-.226.599-.427.127-.17.176-.47.31-.584.122-.104.42.017.549.017.35 0 .705.011 1.056 0 .467-.013.845-.67 1.275-1.043.401-.337.696-.456 1.125-.43.469.034.893.472 1.37.5.361.018.612.062.904-.317.201-.264.344-.656.535-.931l1.186-.184c.235.098.475.206.676.198.303-.014.616-.051.916-.004.114.015.34.282.433.216.064-.049.172-.41.237-.518-.027-.145-.071-.506-.124-.628z'/%3E %3Cpath d='M964.77 304.05c.302 0 .58-.07.834.152.042.08.08.158.119.233a.26.26 0 0 0 .25.035c.171.115.206.18.393.223.174.037.365-.007.539-.004.22.007.326.083.531.167.358.146.594.007.904-.216.359-.264.49-.062.834.269.258.246.205.223.438.055.035-.08.076-.156.115-.223.115-.048.233-.08.35-.101.193-.09.383-.08.565-.149.19-.074.33-.285.531-.247.174.035.373.176.539.23.16.054.23.086.362.183.24-.493.768-.64 1.106-.879.351-.243.678.052 1.064.056.205 0 .288-.12.434-.167.164-.06.35.026.508-.039.167-.062.198-.223.382-.243.34-.042.72.513 1.06.618.191.063 1.076.261.946-.389-.125-.62-.68-.19-.8-.625-.063-.247.067-.599-.01-.876-.066-.253-.344-.546-.511-.601-.209-.066-.33.152-.508-.018-.146-.136-.201-.644-.33-.845-.171.125-.278.24-.504.194-.258-.062-.233-.15-.425-.393-.417-.522-.657.313-1.042.18-.293-.093-.564-.83-.794-1.13-.122-.16-.466-.678-.643-.562-.299.194-.027.758-.183 1.008-.112.174-.508-.004-.65.024-.226.049-.268.108-.432.379-.33.546-.522.98-1.035.918-.244-.028-.427-.275-.665-.185-.253.097-.396.368-.674.4-.202.016-.435.024-.633-.052-.194-.088-.414-.452-.591-.553a.23.23 0 0 0-.24-.046c-.02-.01-.288-.167-.292-.167-.31-.09-.284-.079-.41.33-.074.254-.101.515-.195.755-.09.202-.288.451-.403.587-.216.233-.32.17-.601.254-.226.074-.526.425-.647-.027-.18-.682.5-1.7-.258-1.523-.198.046-.317.083-.438.376-.134.337-.026.555-.086.925-.08.465-.968 1.248-.792 1.669.118.296.514-.16.622-.086.18.124.129.42.257.619.269.41 1.065-.636 1.11-.07M961.55 300.4c-.002-.059-.013-.115-.017-.176-.212-.039-.452-.264-.647-.268-.183-.01-.542.438-.668.653-.389.643-.28 1.519-.935 1.506-.16-.004-.535-.112-.675-.015-.246.174-.09.69-.09 1.04 0 .33.15 0-.027.428-.053.118-.212.156-.254.313-.132.56.333.382.539.376.528-.004 1.053-.004 1.575 0 .317.007.508-.105.803-.22.194-.066.608-.062.773-.236.059-.066.25-.508.277-.612.042-.216-.04-.477.01-.657.084-.316.367-.195.418-.622.136-1.048-.982-.264-.806-1.294'/%3E %3C/g%3E %3Cg stroke='%23000' stroke-width='.78'%3E %3Cpath d='M974.21 271.28c0 1.356-.928 2.448-2.078 2.448-1.137 0-2.073-1.092-2.073-2.448 0-1.352.935-2.452 2.073-2.452 1.15.001 2.078 1.1 2.078 2.452zM967.43 268.26c0 1.352-.929 2.448-2.074 2.448-1.147 0-2.078-1.096-2.078-2.448s.931-2.45 2.078-2.45c1.145 0 2.074 1.098 2.074 2.45z'/%3E %3Cpath d='M971.01 269.2c0 1.356-.929 2.448-2.074 2.448s-2.072-1.092-2.072-2.448.928-2.45 2.072-2.45 2.074 1.095 2.074 2.45z'/%3E %3Cpath d='M967.54 271.44c0 1.356-.932 2.454-2.076 2.454s-2.072-1.1-2.072-2.454c0-1.352.927-2.448 2.072-2.448s2.076 1.094 2.076 2.448z'/%3E %3Cpath d='M970.76 273.31c0 1.352-.935 2.454-2.075 2.454-1.143 0-2.076-1.102-2.076-2.454s.933-2.448 2.076-2.448c1.139.001 2.075 1.096 2.075 2.448z'/%3E %3C/g%3E %3Cpath fill='%2300a651' stroke='%23000' stroke-width='.78' d='M971.76 246.58s20.918-29.209 43.348 1.134c0 0 .187 3.018-1.885 6.22l-.567-2.448-1.318.374-.376-1.507-2.455-.187.758-3.206-2.642 2.074.379-2.263-3.016 3.02.38-6.411-3.207 5.466.376-3.767-1.13 1.693-.68-2.196-1.013 2.196-1.512-1.128v1.507l-2.635-2.262-.942 3.015-1.319-3.202-.378 2.26-1.322-2.64-.184 2.83-4.339-1.887.942 2.639-2.069-1.505.376 1.505-2.824-.563.185 1.694-3.015-.566.567 1.506-4.148-.562 1.502 1.696-.417.69s22.66-7.473 24.168 20.796l-4.148 2.072 1.133-2.256-1.133-.757-3.39-2.635.942-3.585-1.129.38-.19-2.073-.565.376-1.322-2.073-.376.755-.942-2.454-.942 1.7-.567-4.148-1.505 2.643-.192-1.509-.566.942-1.884-2.263-.56 1.508-.76-1.13-.562 1.318-2.074-1.888v1.513l-1.317-1.134-.571.755-3.198-1.697-.196 1.505-1.692-1.505-.568 1.505s20.55 11.689 14.137 30.725l-1.134 2.448-.372-6.404-1.884 3.39 1.31-7.35-1.31 1.317-.194-2.823-1.69 2.823-.574-3.201-.748.942-1.136-4.902-.942 2.076-1.506-5.466-1.13 2.26-.754-4.708-.755 2.826-2.263-4.149-.374 1.693-1.317-3.39-.759 1.134s-3.769-.192-4.898-1.134c-1.13-.938-4.336 5.657-4.336 5.657l.378-3.96-1.317 2.635v-2.635l-2.452 7.914-.566-5.653-1.319 4.9-.568-1.505-.375 2.075-.755-.758-.658 2.225-1.23-.903v3.014l-1.129-1.508-.942 4.524-.564-1.88v2.068l-.942-1.126-.945 4.524-1.318-1.884-.185 3.2.56 2.454-1.505-.755.567 3.953s-5.844-10.927 1.133-21.484c6.968-10.55 16.393-13.38 16.393-13.38l-.946-.938-.187-.945-5.653 2.826.19-1.7-1.509 1.32-.375-1.884-.946 1.697-.184-.755-1.322 2.076-.757-3.018-.94 3.585-.889-2.507-1.937 5.33v-3.957l-1.508 4.148-.564-4.524-1.13 5.274v-4.711l-1.7 4.711-1.129-4.52-.755 4.332-1.129-3.39-1.134 5.087-1.693-4.524-.942 6.787-1.13-2.643-.19 4.902-1.315-3.014 1.315 6.404-1.697-2.448.568 3.957-2.448-4.336.187 5.094-1.321-1.7-.568 1.885s-.56-19.6 12.816-23.372c13.386-3.768 22.055 1.133 22.055 1.133l-5.087-4.145.564-1.321h-1.884l.754-1.509-3.957.191 1.13-1.508-3.018.375v-.94l-1.884 1.503.754-1.693-2.638 1.693-.161-2.507-1.349 2.135-.748-2.263-6.034 6.028 1.695-6.218-1.129 1.322-.187-1.322-1.697 2.642-.378-1.887-.755 2.26-.567-2.637-1.314 2.637-1.323-2.446-.563 3.205-.945-1.7-1.13 2.45-1.505-1.51-.191 1.51-3.016-1.32.755 2.264-2.263-1.884-.568 3.014-1.315-1.508-.942 3.772-.942-3.583-.942 2.827s11.786-30.286 41.605-10.526c0 0 3.247 3.176 4.002 5.436.755 2.264.19.38.19.38l-.567-20.92 1.13 9.047.754-3.206-.187 4.713 3.012-6.598s-3.577 10.933-2.26 14.89c0 0 1.322-12.626 5.848-14.136l-4.148 9.046 1.317-.19-.942 1.888h1.13l-1.366 2.99-.707 1.534.751 1.506 1.139-1.141z'/%3E %3Cpath d='M968.66 258.87l.594.535c.08-.083 1.944-2.069 5.074.574l.518-.616c-3.742-3.164-6.17-.522-6.186-.493zM967.75 248.61l-.122.725s1.076-.459 1.453-.62c-.233.415-.999 1.748-.999 1.748l2.168-.721a9103.73 9103.73 0 0 1-2.688 3.517l.64.494 4.276-5.601-2.657.886c.277-.482 1.14-2.005 1.14-2.005l-2.298.988.475-2.874-.795-.133-.593 3.596z'/%3E %3Cpath d='M963.76 248.84s.528 1.169.925 2.039c-.171-.071-1.475-.593-1.475-.593l4.35 7.694s.525-.67.556-.712c-.438 1.123-.876 2.256-.876 2.256l.751.292 1.875-4.822-.692-.393-1.51 1.933c-.406-.723-1.91-3.386-2.625-4.645.09.034 1.207.484 1.207.484s-.82-1.812-1.203-2.653l1.63 1.018v-2.868h-.803v1.419l-2.663-1.662.553 1.213zM961.02 258.5l.32.737c1.178-.504 2.148-.588 2.885-.237.863.414 1.123 1.304 1.126 1.31l.775-.208c-.01-.052-.352-1.248-1.543-1.822-.952-.458-2.152-.385-3.563.22zM964.396 266.65l-.66-4.215.795-.125.661 4.214zM970.185 265.956l-1.074-3.22.765-.255 1.073 3.22zM972.309 268.336l-.807-3.216.782-.196.807 3.216z'/%3E %3Cg%3E %3Cg stroke='%23000' stroke-width='.78' fill='%2300a651'%3E %3Cpath d='M811.41 365.04s-3.534-1.606-5.143-.43c-1.608 1.181-1.389 2.892-2.783 2.784 0 0 5.354 1.179 6.532-.216 1.177-1.387 1.394-1.819 1.394-1.819M812.06 366.52s-2.326 3.11-1.522 4.93c.802 1.822 2.523 1.978 2.116 3.315 0 0 2.302-4.974 1.196-6.426-1.105-1.442-1.474-1.745-1.474-1.745M808.14 357.91s-3.71 1.15-4.126 3.095c-.426 1.946.879 3.086-.232 3.931 0 0 4.782-2.68 4.737-4.506-.045-1.823-.163-2.284-.163-2.284M810.32 359.19s1.76-3.467.652-5.118c-1.106-1.663-2.832-1.52-2.662-2.904 0 0-1.414 5.296-.073 6.536 1.343 1.23 1.763 1.468 1.763 1.468M806.68 357.93s.085-3.876-1.632-4.889c-1.715-1.015-3.209-.141-3.658-1.467 0 0 1.026 5.389 2.774 5.928 1.746.525 2.227.556 2.227.556M813.02 364.39s4.068-1.397 4.392 2.998c.32 4.39-.216 2.893-.216 2.893s-2.142-4.713-4.496-5.464l.32-.427z'/%3E %3C/g%3E %3Cpath d='M811.99 366.59c0 .094.426 3.414.426 3.414l.572-.073-.43-3.322c.014.004 1.39-7.3 1.39-7.3l-.567-.105-1.391 7.386z'/%3E %3Cpath d='M808.29 365.51l-.19.542c1.946.684 4.661-1.454 4.774-1.544l-.36-.448c-.024.017-2.578 2.034-4.224 1.45zM813.388 361.224l-9.102-4.605.363-.717 9.102 4.605z'/%3E %3Cpath d='M806.79 360.19l-.568-.567 1.821-1.82.567.568zM809.975 359.305l-1.927-4.18.729-.336 1.928 4.18zM812.67 364.42l.052.804c2.475-.168 3.08 1.435 3.084 1.453l.79-.164c-.094-.459-1.086-2.284-3.926-2.093z'/%3E %3Cpath d='M854.43 366.27c3.035-1.7 3.643-7.657 3.643-7.657-.726 2.191-6.31 4.375-6.31 4.375 4.126-2.556 9.101-14.084 9.101-14.084-1.334 4.13-12.138 7.526-19.06 11.411-6.923 3.883-3.279 15.058-3.279 15.058-1.94-1.337-5.706-7.283-6.432-12.509-.733-5.219-2.796-7.28-7.531-7.889-4.738-.608-7.529 4.732-7.529 4.732l-7.04 3.647 7.159.24s5.106 1.704 5.106 5.71c0 4.008-4.493 20.034 2.91 29.021 5.153 6.245 24.166 9.833 24.166 9.833' stroke='%23000' fill='%23FFF'/%3E %3Cpath d='M840.47 378.65s1.457-7.165 6.192-6.922c4.735.243 6.07-5.34 8.863-6.192 2.793-.848 17.242-4.731 18.821-11.656 0 0-1.335 11.416-14.568 17.122 0 0 10.681-3.523 11.898-5.83 0 0-4.739 10.2-16.272 11.778 0 0 10.806-.849 12.385-3.761 0 0-4.857 6.433-12.869 7.285 0 0 7.405 3.035 9.35.484 0 0-4.009 4.735-8.989 5.096l1.34.366s-4.736 5.587-9.958 1.822c-5.219-3.766-5.344.974-5.344.974' stroke='%23000' fill='%23FFF'/%3E %3Cpath d='M851.25 389.45s6.098 10.202 6.707 15.665c0 0 11.658 12.872 16.028 13.595 0 0-2.065.848-5.831-2.305 0 0 3.157 3.278 3.766 3.4.604.125-2.552-.243-3.039-1.095 0 0 1.338 1.948 2.187 2.19.852.244-.849-.242-.849-.242s-1.581-.244-2.309-.852c-.73-.605-.243 1.575-.243 1.575s-1.822-.486-2.427-1.092c-.608-.605.244 1.34.244 1.34l-1.578-.367-1.092.726s-.122.73-.856.123c-.723-.601-2.061 0-2.061 0s-.975.852-1.457.243c-.482-.606-2.323 2.336-2.323 2.336l-7.645-18.455' stroke='%23000' fill='%23FFF'/%3E %3Cg%3E %3Cpath d='M858.505 422.928l-9.662-18.393 1.014-.533 9.663 18.393zM866.947 421.688l-16.531-18.51.858-.766 16.532 18.51zM870.718 420.056l-18.864-17.58.783-.84 18.865 17.58z'/%3E %3C/g%3E %3Cg%3E %3Cpath d='M823.44 360.84s-1.231-2.204-2.303-1.376c-1.069.825-1.685.976-1.87.919 0 0 1.076.059 1.687-.522.613-.586 1.656-.216 2.486.979zM816.78 359.83s.676 1.398.685 1.422c-.068.004-.763 2.257-.763 2.257l.553.17.75-2.453c-.013-.213-.703-1.642-.703-1.642l-.522.246z'/%3E %3Cpath d='M823.16 360.5s-.918 1.075-2.176.766l-1.252-.306s1.066.06 1.776.093c.7.029 1.618-.337 1.652-.553z'/%3E %3Cpath d='M822.86 360.72s-1.132-1.195-1.9-.858c0 0 1.35-.43 2.116.73l-.216.128z'/%3E %3Cpath d='M822.67 360.5s-1.286.887-2.699-.09l-.086-.066.183-.059c.001.001 1.778.735 2.602.215z'/%3E %3Ccircle cx='821.573' cy='360.284' r='.383'/%3E %3C/g%3E %3Cpath d='M822.61 394.2s-.996 1.834-.475 2.939c.528 1.103 2.89 1.675 3.205 3.146.317 1.475 1.105 1.471 2.208 1.266 1.105-.212 1.314-.264 1.314-.264s-4.625-2.473-5.834-6.46l-.418-.627z'/%3E %3C/g%3E %3Cg%3E %3Cg stroke='%23000' fill='%23964b36' stroke-width='.48'%3E %3Cpath d='M972.09 356.85s8.418-11.099 15.882-8.184c7.465 2.917 12.316 4.321 12.316 4.321s.142 7.475-3.828 7.475c-3.96 0-7.757-7.465-11.366-5.246-3.616 2.215-6.584 5.25-6.818 6.296-.233 1.048-9.562 1.283-6.185-4.662z'/%3E %3Cpath stroke-width='.78' d='M940.14 410.37s-2.328 2.444-1.278 3.031c1.054.581 3.146-.122 3.146-.935 0-.82-1.395-2.329-1.868-2.096z'/%3E %3Cpath stroke-width='.78' d='M938.28 412.7s-4.312-2.455-7.694 3.376c-3.387 5.83-6.182 15.277-8.164 16.56-1.981 1.282 19.241-9.328 19.475-13.758 0 0 1.397-5.716-.817-5.602-2.215.122-2.333.356-2.8-.576z'/%3E %3Cpath d='M938.86 413.4s-4.43 1.043-5.362 7.337c-.932 6.303-7.114 9.565-7.462 9.797M1000.3 352.99s-6.738 2.344-5.574 7.01'/%3E %3C/g%3E %3Cpath fill='%23fff200' stroke='%23000' stroke-width='.48' d='M948.54 366.64s.232-15.976 13.284-15.277c2.473.23 1.294 3.146 1.294 3.146s2.823-1.977 4.113 1.166c0 0 4.117-1.864 4.585 2.218 0 0 4.47-.58 3.88 3.032 0 0 3.056-.699 2.942 1.867 0 0 3.526-1.4 3.17 2.215 0 0 3.882-2.566 3.297 2.096 0 0 3.999-2.794 5.404 1.869 1.411 4.662-3.995 14.574-9.287 17.138'/%3E %3Cpath d='M984.81 367.61c.018.125 1.76 12.498-5.257 17.026l.247.39c7.27-4.69 5.482-17.356 5.466-17.484l-.456.068zM976.36 381.16l.324.33c4.444-4.325 5.4-15.976 5.434-16.469l-.455-.038c-.011.122-.977 11.974-5.303 16.177zM972.21 378.39l.458.037c.572-7.195 6.196-15.425 6.256-15.509l-.38-.258c-.058.082-5.75 8.413-6.334 15.73zM968.95 376.29l.458.046c.8-8.68 6.533-15.196 6.59-15.258l-.341-.308c-.06.064-5.891 6.688-6.707 15.52zM964.4 373.39l.458.017c.456-10.25 7.18-15.28 7.247-15.33l-.272-.371c-.065.051-6.967 5.2-7.433 15.684zM960.2 370.84l.462-.014c-.336-9.328 6.835-14.912 6.91-14.97l-.279-.364c-.073.06-7.434 5.78-7.093 15.348zM952.63 367.43l.455.056c1.249-10.097 10.236-12.725 10.326-12.75l-.125-.441c-.09.024-9.373 2.729-10.656 13.135z'/%3E %3Cpath fill='%2300a651' stroke='%23000' stroke-width='.48' d='M940.84 386s-2.212-14.813 6.648-19.472c0 0 1.637-.352 2.566 1.748 0 0 4.666-1.98 4.784 1.978 0 0 2.33-1.864 2.914.7 0 0 5.013-1.047 4.08 2.683 0 0 4.197-1.165 3.847 2.445 0 0 4.2-1.514 3.497 1.635 0 0 4.429-1.047 3.382 2.567 0 0 5.483-.581 3.85 3.265 0 0 4.081-1.048 3.146 2.1 0 0 5.366.935 2.914 4.315-2.448 3.378-8.63 8.51-14.686 10.724'/%3E %3Cpath fill='%2300a651' stroke='%23000' stroke-width='.48' d='M936.06 400.92s-3.616-12.355 3.269-15.509c0 0 1.275-.352 1.51.935 0 0 1.519-1.985 2.686-.233 0 0 3.495-1.633 4.315.931 0 0 2.33-1.985 3.498.928 0 0 2.216-.928 2.216 1.401 0 0 3.03-1.282 3.03 1.517 0 0 2.91-1.165 2.33 1.981 0 0 4.433.699 3.15 2.798 0 0 3.97 1.046 2.448 2.683 0 0 4.312-.466 1.981 2.448 0 0 3.265-1.047 1.402 2.57-1.869 3.612-7.695 7.576-11.776 8.041'/%3E %3Cpath fill='%2300a651' stroke='%23000' stroke-width='.48' d='M940.37 410.71s-7.694-7.462-4.075-9.676c0 0 1.626.462 2.211 2.097 0 0 1.864-2.681 2.918.115 0 0 2.8-.931 2.8.938l2.21 1.634s2.57-.236 2.104 1.398c0 0 2.799-.352 2.68 1.165 0 0 2.452.115 2.219 1.745 0 0 4.193.7 2.329 2.803 0 0-7.346 1.512-12.475-.585 0 0-2.688-.936-2.92-1.634z'/%3E %3Cg%3E %3Cpath d='M966.76 398.38l.164.427c4.56-1.755 12.478-12.564 12.816-13.024l-.372-.275c-.084.117-8.174 11.164-12.608 12.871zM964.17 396.41l.223.4c3.967-2.213 11.867-12.676 12.2-13.121l-.366-.278c-.079.112-8.174 10.834-12.058 12.998zM961.92 395.49l.296.352c4.19-3.478 10.291-14.966 10.552-15.452l-.406-.216c-.062.117-6.32 11.896-10.441 15.317zM959.86 392.84l.456.064c.796-5.807 8.953-14.947 9.032-15.037l-.34-.308c-.338.38-8.334 9.336-9.148 15.281zM943.53 385.78l.46-.04c-.686-8.203 6.18-17.238 6.25-17.328l-.364-.277c-.074.089-7.044 9.262-6.346 17.645zM947.85 386.5l.456-.08c-1.136-6.576 6.63-15.928 6.71-16.02l-.351-.298c-.327.389-7.984 9.605-6.815 16.398zM954.49 388.92l.46-.013c-.226-7.507 6.976-15.032 7.05-15.11l-.33-.32c-.072.077-7.414 7.743-7.18 15.443zM938.65 402.52l.43-.16c-2.615-6.937 1.926-15.819 1.972-15.906l-.414-.212c-.045.091-4.677 9.149-1.988 16.278zM941.67 402.97l.438-.142c-2.281-7.065 1.585-16.535 1.626-16.628l-.427-.176c-.037.092-3.966 9.721-1.637 16.946zM954.17 410.03l.157.434c7.44-2.676 12.305-9.46 12.353-9.525l-.375-.269c-.046.067-4.826 6.738-12.134 9.36zM952.64 408.41l.187.421c5.934-2.677 11.467-10.146 11.52-10.223l-.37-.269c-.056.075-5.514 7.443-11.337 10.07zM951.2 407.85l.269.373c4.641-3.362 10.604-11.982 10.667-12.07l-.378-.257c-.061.088-5.977 8.638-10.558 11.953zM943.76 403.52l.456-.066c-1.026-7.414 3.773-16.208 3.824-16.295l-.403-.223c-.051.091-4.923 9.018-3.877 16.584zM946.99 405.53l.31.34c4.788-4.322 6.418-15.971 6.484-16.464l-.456-.064c-.014.119-1.672 11.981-6.338 16.188z'/%3E %3Cpath d='M950.27 406.91l.269.372c6.758-4.888 8.59-14.274 8.605-14.365l-.449-.086c-.018.09-1.815 9.295-8.425 14.08zM951.05 386.68c0 .438.022.875.062 1.318-.007-.038-5.125 16.583-5.125 16.583l.438.135 5.139-16.674c-.794-8.06 6.296-16.859 6.366-16.945l-.354-.288c-.071.08-6.526 8.093-6.526 15.871z'/%3E %3Cpath d='M956.41 390.74c-.067.233-1.627 11.618-7.768 15.818l.26.38c6.315-4.32 7.849-15.545 7.911-16.019 2.725-3.243 9.005-14.614 9.069-14.728l-.404-.222c-.063.114-6.318 11.45-9.068 14.77zM938.28 403.18c.046.239 1.072 5.896 2.246 7.891l.396-.231c-1.136-1.926-2.175-7.68-2.186-7.74l-.456.08zM941.19 403.25c.05 2.816.064 7.436-.094 7.847l.428.168c.236-.592.146-6.784.128-8.019l-.462.004z'/%3E %3Cpath d='M941.45 411.32l.418.187c1.971-4.29 2.578-7.249 2.586-7.277l-.452-.09c-.007.024-.602 2.942-2.552 7.18z'/%3E %3Cpath d='M941.89 411.45l.233.396c3.657-2.125 4.506-5.821 4.536-5.976l-.448-.1c-.01.036-.841 3.66-4.321 5.68z'/%3E %3Cpath d='M942.57 411.77l.046.455c3.584-.358 6.025-4.711 6.13-4.895l-.405-.223c-.023.045-2.429 4.328-5.771 4.663z'/%3E %3Cpath d='M942.93 412l.028.458c5.754-.354 8.343-3.793 8.448-3.938l-.372-.272c-.024.032-2.577 3.415-8.104 3.752z'/%3E %3Cpath d='M943.34 412.12l-.094.449c.31.07 7.642 1.625 10.152-2.197l-.385-.251c-2.334 3.558-9.601 2.013-9.673 1.999z'/%3E %3C/g%3E %3C/g%3E %3Cpath fill='none' stroke='%23000' stroke-width='4.2' d='M778.8 143.94v205.09c0 67.08 121.2 106.91 121.2 106.91s121.2-39.833 121.2-106.91V143.94z'/%3E %3C/g%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 1200 600'%3E %3Cdefs%3E %3ClinearGradient id='gradbase' gradientUnits='userSpaceOnUse'%3E %3Cstop stop-color='%23a43907' stop-opacity='0.9961' offset='0'/%3E %3Cstop stop-color='%23fff' offset='1'/%3E %3C/linearGradient%3E %3ClinearGradient id='grad1' xlink:href='%23gradbase' x1='826.45044' y1='419.93194' x2='786.12402' y2='396.11032'/%3E %3ClinearGradient id='grad2' xlink:href='%23gradbase' x1='851.56865' y1='436.06697' x2='763.03312' y2='419.67318'/%3E %3ClinearGradient id='grad3' xlink:href='%23gradbase' x1='1016.1496' y1='398.53933' x2='974.91928' y2='400.94143'/%3E %3ClinearGradient id='grad4' xlink:href='%23gradbase' x1='1033.33547' y1='421.21868' x2='945.904' y2='428.64452'/%3E %3ClinearGradient id='grad5' xlink:href='%23gradbase' x1='1023.35736' y1='445.13212' x2='776.64586' y2='445.13212'/%3E %3ClinearGradient id='grad6' xlink:href='%23gradbase' x1='783.43027' y1='462.50282' x2='1144.08805' y2='465.42083'/%3E %3ClinearGradient id='grad7' xlink:href='%23gradbase' x1='1032.1278' y1='442.28699' x2='1002.94064' y2='444.03323'/%3E %3ClinearGradient id='grad8' xlink:href='%23gradbase' x1='775.74733' y1='471.7178' x2='803.90792' y2='476.1845'/%3E %3ClinearGradient id='grad9' xlink:href='%23gradbase' x1='803.17707' y1='466.88819' x2='755.30821' y2='440.32034'/%3E %3CclipPath id='c'%3E %3Cpath d='M0,0V150H700V300H600zM600,0H300V350H0V300z'/%3E %3C/clipPath%3E %3C/defs%3E %3Crect width='1200' height='600' fill='%2300247d'/%3E %3Cpath d='M0,0 600,300M600,0 0,300' stroke='%23fff' stroke-width='60'/%3E %3Cpath d='M0,0 600,300M600,0 0,300' stroke='%23cf142b' stroke-width='40' clip-path='url(%23c)'/%3E %3Cpath d='M300,0V350M0,150H700' stroke='%23fff' stroke-width='100'/%3E %3Cpath d='M300,0V350M0,150H700' stroke='%23cf142b' stroke-width='60'/%3E %3Cpath d='M0,300H600V0H1200V600H0z' fill='%2300247d'/%3E %3Cg stroke='%23000' stroke-width='1.8'%3E %3Cuse xlink:href='%23scroll' stroke='%23fff' stroke-width='12'/%3E %3Cg id='scroll' stroke-linejoin='bevel'%3E %3Cpath fill='url(%23grad1)' d='m826.45,427.735s-8.53598-13.8843-15.65-12.8926c-7.11256,0.99174-13.7516,9.91737-14.2266,10.4124-0.47347,0.49666-10.9063-11.4042-10.4329-11.9008,0.47498-0.49508,10.9078-26.2802,16.5985-27.272,5.69065-0.99174,17.9773,1.89709,17.9773,2.88882,0,0.99174,5.73375,38.7641,5.73375,38.7641z'/%3E %3Cpath fill='url(%23grad2)' d='m845.419,412.859c0,0.99174-2.84532,37.686-15.1751,50.5786-12.3297,12.8926-32.247,20.8265-39.3611,18.843-7.11255-1.98348-23.2361-39.1728-23.2361-39.1728s17.072,17.8513,29.8752,14.8761c12.8047-2.97521,20.3922-25.2901,22.7626-36.1992,2.37186-10.9091,0.47498-32.2323,0.47498-32.2323l24.6595,23.3066z'/%3E %3Cpath fill='url(%23grad3)' d='m973.576,427.735s8.53598-13.8843,15.65-12.8926c7.11256,0.99174,13.7516,9.91737,14.2266,10.4124,0.4734,0.49666,10.9063-11.4042,10.4328-11.9008-0.4749-0.49508-10.9078-26.2802-16.5984-27.272-5.69065-0.99174-17.9773,1.89709-17.9773,2.88882,0,0.99174-5.73375,38.7641-5.73375,38.7641z'/%3E %3Cpath fill='url(%23grad4)' d='m954.608,412.859c0,0.99174,2.84532,37.686,15.1751,50.5786,12.3297,12.8926,32.247,20.8265,39.361,18.843,7.1126-1.98348,23.2361-39.1728,23.2361-39.1728s-17.072,17.8513-29.8752,14.8761c-12.8047-2.97521-20.3922-25.2901-22.7626-36.1992-2.37186-10.9091-0.47498-32.2323-0.47498-32.2323l-24.6595,23.3066z'/%3E %3Cpath fill='url(%23grad5)' d='m788.945,407.482c-5.69068,6.94218-8.7289,12.308-11.1,16.275-2.3711,3.96694-0.97668,9.4873,4.5,17.3625,5.90463,8.48767,54.4484,41.6625,117.675,41.6625,63.2265,0,111.77-33.1748,117.675-41.6625,5.4766-7.87519,6.8336-13.3956,4.4625-17.3625-2.3711-3.96695-5.3719-9.33282-11.0625-16.275,0,10.4124-40.2141,48.0375-111.075,48.0375-70.8609,0.00002-111.075-37.625-111.075-48.0375z'/%3E %3Cpath fill='url(%23grad6)' d='m1008.25,476.741c0.9485-1.48681,10.9063-18.843,10.9063-18.843l-5.46-4.02724c-1.6768,4.90949-7.8182,6.50738-8.7666,12.4578s4.2688,11.9008,3.3203,10.4124z'/%3E %3Cpath fill='url(%23grad7)' d='m1018.15,471.371s1.8969-8.42897-4.2673-9.42071c-6.1656-0.99173-9.4293,4.71805-8.5359,2.47855,0.9921-2.48691,4.7422-4.95868,5.2156-13.3877,0.475-8.43056-0.4734-12.8926-0.4734-12.8926s2.3703-10.9107,12.3297-9.4223c9.9579,1.4884,10.4329,9.4223,10.4329,12.3975,0,2.97521-0.9485,4.46202-0.9485,4.46202l-13.7531,25.7852z'/%3E %3Cpath fill='url(%23grad8)' d='M791.773,476.741c-0.949-1.487-10.907-18.843-10.907-18.843l5.45999-4.02724c1.67684,4.90949,7.81819,6.50738,8.76663,12.4578s-4.26874,11.9008-3.3203,10.4124z'/%3E %3Cpath fill='url(%23grad9)' d='m781.873,471.371s-1.89688-8.42897,4.26723-9.42071c6.16563-0.99173,9.42936,4.71805,8.53597,2.47855-0.99208-2.48691-4.7422-4.95868-5.21567-13.3877-0.47498-8.43056,0.47347-12.8926,0.47347-12.8926s-2.37035-10.9107-12.3297-9.4223c-9.95788,1.4884-10.4329,9.4223-10.4329,12.3975,0,2.97521,0.94844,4.46202,0.94844,4.46202l13.7532,25.7852z'/%3E %3C/g%3E %3Cg fill='%23000' stroke='none'%3E %3Cpath d='m813.43,438.565-5.16779-3.55994-0.60012,0.95373,1.0182,0.84192,0.0874,0.5064-6.50543,10.3388-0.47909,0.11619-1.14073-0.6472-0.60011,0.95374,5.16779,3.55994c1.7705,1.21965,3.2807,1.84224,4.96633,1.66477,2.1944-0.22005,4.06492-1.49869,5.5102-3.7956,2.573-4.08915,1.85084-8.10322-2.25661-10.9327zm-2.1551,0.0781,1.02686,0.70737c2.8141,1.93856,3.06199,4.64992,0.75905,8.30989-2.30295,3.65997-4.79294,4.51187-7.60704,2.57332l-1.02686-0.70738,6.84799-10.8832z'/%3E %3Cpath d='m815.174,457.273,10.2685,5.13308,1.71686-3.76452-1.2992-0.64945-1.34262,2.06734-0.40209,0.21206-4.43568-2.21733,2.495-5.47071,2.48537,1.2424,0.1338,0.42897-0.50075,1.60932,1.12889,0.56432,2.22605-4.88099-1.12889-0.56431-0.88123,1.42089-0.4021,0.15932-2.48537-1.24239,2.2835-5.00695,3.80416,1.90164,0.12401,0.39771-0.55685,1.9961,1.33839,0.66904,1.50666-3.30361-9.63852-4.81815-0.47001,1.03059,1.11826,0.68907,0.17148,0.44781-5.11404,11.2134-0.45937,0.18343-1.21422-0.47866-0.47002,1.03059z'/%3E %3Cpath d='m828.786,462.999c1.10133,0.90962,2.37746,1.60988,3.66831,2.04514,3.30819,1.11547,5.93074-0.10665,6.74176-2.74783,0.40203-1.30927,0.12479-2.72592-0.79298-3.94194-0.93036-1.24359-1.89776-1.93807-2.39314-2.57005-0.85035-1.06996-1.21179-1.92674-0.89833-2.94757,0.37514-1.22168,1.55506-1.80204,3.02713-1.30568,0.64543,0.21763,1.07577,0.48438,1.37702,0.80593l0.18745,0.4065-0.36563,2.42474,1.45141,0.48939,1.10408-3.59557c-1.11994-0.91756-2.30851-1.61162-3.55962-2.03348-2.88374-0.97235-5.34572,0.30391-6.10202,2.7669-0.33434,1.08879-0.18493,2.33902,0.47776,3.51735,0.6348,1.1206,1.46794,1.81814,2.13759,2.53387,1.18703,1.28181,1.66823,2.32562,1.30052,3.52314-0.37514,1.22168-1.61594,1.78318-3.25016,1.23214-0.62476-0.21066-1.17546-0.51966-1.6786-0.90929l-0.16029-0.42066,0.49527-2.77265-1.53408-0.51727-1.23345,4.01689z'/%3E %3Cpath d='m839.509,467.153,6.02979,2.03315,0.33386-1.08727-1.3174-0.56586-0.21374-0.46369,3.63266-11.8302,0.41824-0.20227,1.38557,0.34388,0.33387-1.08728-6.02979-2.03316-0.33387,1.08728,1.29628,0.56041,0.22719,0.41989-3.63267,11.8302-0.43168,0.24606-1.36444-0.33842-0.33387,1.08728z'/%3E %3Cpath d='m852.462,454.82-0.23018,1.11771,1.19889,0.38514,0.26548,0.39304-2.50447,12.1613-0.40647,0.29156-1.24589-0.15694-0.23018,1.11771,5.84014,1.29106,0.23018-1.11771-1.24001-0.39261-0.25622-0.43806,1.05723-5.1337c0.12405,0.0274,0.2481,0.0549,0.35256,0.0779,2.0909,0.46223,2.42749,1.5624,2.62266,3.87132,0.10596,1.16768,0.0804,2.23648,0.9697,3.38743,0.40864,0.54317,1.11789,0.98561,2.00909,1.18263,0.64147,0.14181,1.35903,0.22902,2.10708,0.27591l0.2257-1.09598c-0.10283-0.0227-0.18607-0.0411-0.26932-0.0595-1.3874-0.3067-1.93731-0.78534-2.11449-2.13756-0.15871-1.2264-0.0697-2.49543-0.50599-3.64198-0.32473-0.83462-0.94066-1.42361-1.8829-1.89485,2.43941,0.0378,3.93433-1.01461,4.36656-3.11342,0.52174-2.53347-0.85301-4.26891-4.06362-4.97867l-6.29553-1.39173zm3.97754,2.23942,0.95323,0.21072c2.00765,0.44383,2.84759,1.72669,2.46236,3.5973-0.43255,2.10036-1.68585,2.82472-3.9008,2.33507-0.22851-0.0505-0.47661-0.10536-0.74113-0.18819l1.22634-5.9549z'/%3E %3Cpath d='m865.586,473.888,11.3628,0.56256,0.18257-4.16851-1.43933-0.0713-0.4684,2.45157-0.2915,0.35885-4.90839-0.24301,0.26531-6.0578,2.75023,0.13616,0.28257,0.3412,0.13837,1.6874,1.24753,0.0618,0.23671-5.40479-1.24753-0.0618-0.28532,1.66801-0.3111,0.31022-2.75024-0.13616,0.24282-5.54426,4.21124,0.20849,0.26193,0.31636,0.22707,2.06665,1.48102,0.0733,0.16021-3.65813-10.664-0.52797-0.05,1.14119,1.28576,0.1812,0.32426,0.34327-0.5438,12.4168-0.35488,0.35571-1.29596,0.0518-0.05,1.14119z'/%3E %3Cpath d='m885.562,460.702-0.039,4.12848,1.49873,0.0179,0.37128-2.49165,0.35057-0.29889,2.60866,0.0312-0.11983,12.6869-0.3735,0.36844-1.41418,0.0989-0.0108,1.14239,6.49852,0.0777,0.0108-1.14239-1.412-0.13272-0.36645-0.37729,0.11983-12.6869,2.60866,0.0312,0.32257,0.30694,0.3464,2.50023,1.49874,0.0179,0.039-4.12847-12.538-0.14991z'/%3E %3Cpath d='m898.767,461.149,0.0199,1.1423,1.26256,0.0954,0.35417,0.36677,0.21614,12.3829-0.34115,0.3789-1.25849,0.13782,0.0199,1.14231,6.14838-0.10732-0.0199-1.14231-1.30534-0.0931-0.35417-0.36677-0.10258-5.87653,6.27854-0.1096,0.10257,5.87654-0.31889,0.37852-1.3013,0.13857,0.0199,1.1423,6.12782-0.10696-0.0199-1.14231-1.26252-0.0938-0.35417-0.36677-0.21615-12.3829,0.34116-0.37891,1.25845-0.1394-0.0199-1.14231-6.12782,0.10696,0.0199,1.14231,1.30537,0.0947,0.33191,0.36716,0.0891,5.10707-6.27853,0.10959-0.0892-5.10707,0.34116-0.3789,1.30127-0.14016-0.0199-1.1423-6.14838,0.10732z'/%3E %3Cpath d='m916.073,476.413,11.6241-1.06432-0.3543-4.15727-1.47242,0.13481-0.15864,2.4965-0.24986,0.39724-5.02124,0.45975-0.51488-6.04148,2.81346-0.2576,0.33145,0.29782,0.35921,1.65255,1.27621-0.11685-0.45938-5.39023-1.27621,0.11685-0.074,1.69382-0.27608,0.35185-2.81346,0.25761-0.47124-5.52933,4.30807-0.39446,0.30724,0.27614,0.4985,2.01576,1.51507-0.13872-0.31092-3.64828-10.9092,0.99887,0.097,1.13811,1.33054-0.004,0.37411,0.29391,1.05536,12.3833-0.3147,0.40318-1.31073,0.23631,0.097,1.13811z'/%3E %3Cpath d='m932.555,458.353,0.1778,1.12752,1.36566-0.11428,0.41605,0.26022,1.9346,12.2681-0.30714,0.4304-1.32936,0.34448,0.1778,1.12753,6.43651-1.09951-0.1778-1.12752-1.41039,0.12352-0.42321-0.30563-0.81666-5.17879c0.13672-0.0233,0.27523-0.047,0.38857-0.0664,2.3044-0.39365,3.05412,0.49466,4.10583,2.56004,0.53928,1.04166,0.90964,2.04302,2.24033,2.76132,0.61756,0.34319,1.50472,0.47469,2.48692,0.3069,0.70698-0.12076,1.47144-0.32211,2.25213-0.57287l-0.17434-1.1056c-0.11334,0.0194-0.20508,0.035-0.29683,0.0507-1.52907,0.2612-2.26699,0.0335-2.94708-1.1514-0.6148-1.07539-0.99257-2.28777-1.85931-3.18021-0.64135-0.64629-1.48738-0.95045-2.62113-1.01731,2.50154-0.92425,3.63852-2.48866,3.30465-4.6059-0.40302-2.55573-2.44673-3.62504-5.98519-3.02059l-6.93841,1.18524zm4.88592,0.51304,1.05056-0.17946c2.21267-0.37798,3.5435,0.48182,3.84107,2.36886,0.33413,2.11881-0.6774,3.28386-3.11853,3.70086-0.25185,0.043-0.52528,0.0897-0.82581,0.11695l-0.94729-6.00721z'/%3E %3Cpath d='m951.81,470.606,6.6025-2.07914-0.32891-1.09305-1.51294,0.35511-0.46072-0.24548-3.57863-11.893,0.25926-0.42401,1.44579-0.57827-0.3289-1.09304-6.60249,2.07913,0.3289,1.09305,1.49077-0.34646,0.44747,0.20145,3.57864,11.893-0.24602,0.46803-1.42362,0.56963,0.3289,1.09305z'/%3E %3Cpath d='m965.54,457.738,0.31433,1.09468,1.67193-0.3998,0.4444,0.20245,1.30881,4.55813c-0.56356,0.22413-0.97784,0.37842-1.1996,0.44771-3.41021,1.06553-6.16697-0.62955-7.32211-4.6525-1.12284-3.91044,0.24784-6.87029,3.54979-7.902,0.64258-0.20077,1.27163-0.27637,1.94128-0.21721l0.44702,0.29773,1.10098,2.23728,1.61693-0.50522-1.09053-3.79793c-1.78108,0.0197-3.42289,0.26594-4.88616,0.72314-4.91713,1.53637-7.20583,5.58661-5.89047,10.1676,1.33457,4.64783,5.40358,6.88389,10.0553,5.43045,1.61693-0.50521,3.16663-1.33072,4.69929-2.46735l-1.49479-5.20581,0.26454-0.42396,1.25285-0.51406-0.31432-1.09468-6.46946,2.0214z'/%3E %3Cpath d='m968.961,448.387,0.49355,1.02007,1.24791-0.52701,0.49129,0.15867,5.35021,11.0578-0.16911,0.50721-1.14714,0.73527,0.49355,1.02007,5.84114-3.08282-0.49355-1.02007-1.28951,0.55074-0.49129-0.15867-2.53904-5.24769,5.96476-3.14807,2.53904,5.24769-0.14796,0.49605-1.18944,0.75759,0.49355,1.02007,5.82-3.07166-0.49355-1.02007-1.24722,0.52842-0.49129-0.15867-5.35022-11.0578,0.16912-0.50721,1.14645-0.73669-0.49355-1.02007-5.81999,3.07167,0.49355,1.02007,1.2902-0.54933,0.47014,0.16983,2.20658,4.56056-5.96477,3.14807-2.20658-4.56056,0.16912-0.50721,1.18874-0.75901-0.49355-1.02007-5.84114,3.08283z'/%3E %3Cpath d='m983.583,439.937,2.02787,3.54597,1.36886-0.85444-0.90834-2.3419,0.16871-0.45852,2.38104-1.48624,6.23168,10.8968-0.1532,0.5302-1.23374,0.9051,0.56113,0.98121,5.93381-3.70388-0.56113-0.98121-1.34597,0.70516-0.52106-0.10933-6.23169-10.8969,2.3826-1.48721,0.44609,0.0747,1.56227,1.93372,1.37042-0.85542-2.02787-3.54597-11.4515,7.14802z'/%3E %3C/g%3E %3C/g%3E %3Cg%3E %3Cpath fill='%230072c4' stroke='%23fff' stroke-width='6' d='m900.011,448.344s-114.465-33.7349-113.798-162.077l0.88167-169.649h225.834l0.8847,168.675c0.6677,128.342-113.802,163.051-113.802,163.051z'/%3E %3Cg fill='%23bcbcbc'%3E %3Cpath d='m802.805,155.04c0.18817,0,1.57517-1.31703,2.84532-2.47855,1.77396-0.88859,3.41438-2.13739,5.21718-2.97521,1.34299-0.77752,3.99711-1.3805,5.21566-1.98347,1.59794-0.83623,2.90147-1.79941,4.26875-3.47187,0.16389-2.21832,0.47498-3.81145,0.47498-6.4455,1.88625-0.90763,3.56006-1.7883,5.21566-2.48013,2.37338-0.66804,2.88781-1.61693,5.21718-1.98348,1.4993-0.52363,3.97738-0.49666,6.16411-0.49666,2.35972,0,3.84839,1.67723,5.96834,2.07392,2.51299,1.01395,3.68602,1.71531,5.69065,3.47187,1.13206,1.43286,1.83618,2.59756,3.76645,3.67657,1.52812,0.78387,2.95913,1.97078,4.7422,2.47855,1.95758,1.13454,3.69512,1.79147,5.21566,3.47187,1.39307,0.99015,1.96821,2.46109,3.3203,3.47028,1.56607,1.29958,3.05171,2.46903,4.74221,3.47188,2.03194,1.36145,4.04567,2.39603,7.33713,2.0993,1.7421-0.10314,3.61774-0.30307,5.69065,0.0841,2.32026,0,4.58438-0.0412,6.63908,0.49666,2.41891,0,4.37649,0.32688,6.63909,0.49508,2.11995,0.39669,4.28088,0.49666,6.63908,0.49666,2.05622,0.53633,4.31882,0.49508,6.63909,0.49508h6.63908,6.63908c2.41587,0,4.86209,0.0984,6.63909,0.49666,2.3931,0,4.45084-0.22374,6.63908-0.49666,2.57521,0,4.53886-0.47128,7.11407-0.49508h8.0625c2.06988,0.56648,4.71489,0.95524,6.16411,1.98347,1.89839,0.5411,2.8438,1.4408,4.7422,1.98348,1.45377,0.74578,3.66174,1.92635,4.7422,3.47028,1.33844,1.39954,2.7133,3.40364,3.79376,5.45535,1.32023,1.90413,1.82253,4.08119,2.84533,6.44549,0.54175,2.26592,0.9196,4.42076,0.94844,6.94216,0.51443,2.15008,0.47498,4.51597,0.47498,6.94215-0.54175,2.26116-0.66012,4.77779-1.42342,6.94216-0.082,2.41984-0.56603,4.60959-0.94844,6.44708-0.42187,2.02949-0.91809,3.33541-0.94844,5.95042v6.94215c-0.16693,2.27703-0.66467,3.9495-0.94845,6.4455-1.14723,2.16595-2.2459,4.69845-3.31878,7.43882-1.5782,1.09963-2.94699,2.6642-3.79376,3.96694-1.01218,0.62519-1.59793,1.57409-1.42342,1.98348,1.89536,0.6601,1.42342,1.97871,1.42342,4.46202,0.24583,1.91206,0.43097,4.28271,0.94844,6.44708,0.17299,2.36747,0.67984,3.81461,1.4219,5.45376,0.74813,0.97745,0.89381,0.49666-0.94844,0.49666-1.37031,1.07425-2.75731,0.51253-3.31878-1.4884-1.10626-1.33448-1.47046-2.94982-1.89688-5.45376-0.26253-2.29607-0.62977-4.53343-1.42342-5.95042-0.2428-2.79432-0.98638-2.76575-3.79377-2.97521-1.3354-1.18373-3.09874-1.4884-5.69064-1.4884-2.58128,0-2.79828-0.2634-2.84532,2.48014v6.94215c-0.44615,2.01204-1.42494,3.64325-1.89688,5.45376-1.41432,1.03617-2.15031,2.77528-3.79377,3.96695-0.78303,2.25164-1.92116,2.64357-4.26874,2.97521-0.82097-1.02506-2.15941-2.36272-2.84532-3.47029,1.32782-2.22783,2.48719-2.56423,3.3203-4.95868,1.00763-1.97395,1.59945-3.25448,2.37035-4.95868-1.01218-1.55822-1.92117-2.26116-2.84533-4.46361-0.77999-1.1996-1.86046-3.78129-2.37034-5.45376-1.55696-0.54268-4.00925-0.62995-5.21718-1.4884-2.30054-0.53474-2.94396,1.98348-5.68913,1.98348h-6.63908c-2.93637,0-3.66933,1.63914-6.16563,1.4884-0.73295,0.23801-2.51147-0.10473-5.21718,0-1.98186,0.69024-4.36889,0.49507-6.63908,0.49507-2.40525-0.0301-4.37345-0.58393-6.16411-0.99174-2.17913-0.59662-4.34613-1.20119-6.63908-1.48681-2.78462,0-3.82108,0.22215-5.69065,1.48681-1.47956,0.87749-3.6238,2.88318-5.21718,3.96695-0.67377,1.64549-1.02431,4.43029-1.89688,6.44708-0.50381,1.93428-1.32326,3.16086-1.89688,4.95868-0.6419,1.67723-1.24891,3.40364-1.4219,5.95042-0.16086,3.34176-0.89078,2.93237-2.84532,1.98348-0.8149-1.38367-2.11389-2.9054-2.84533-4.46361,0.43098-2.52298,0.91658-3.77812,0.94844-6.4455-0.46132-1.92476-1.53875-1.86287-2.84532-0.49666,0,2.59597,0.11989,4.59849-0.94844,5.95042-0.53416,2.04853-1.39307,2.93396-2.84532,3.96695-0.71019,1.84066-2.28688,2.68324-3.79376,3.47187-0.24129-0.0841,0-0.66486,0-1.98347-1.13661-2.26751-0.082-4.14943-0.082-6.94216,0.0288-2.50394-0.11381-4.16371,0.61307-6.44708,0-2.40397-1.11536-4.69052-1.47956-6.44549-0.88167-1.84225-1.39004-2.75307-3.79377-3.47188-1.68898-0.6712-4.12306-1.57884-5.21718-2.97521-1.37637-1.78512-2.25501-2.5198-4.26722-3.47028-2.18217-0.79022-3.24139-1.51379-4.7422-2.48014-1.46591-1.61692-2.65716-2.31828-3.32031-4.46202-0.98941-1.52489-1.15937-4.35729-1.89688-6.44708-0.16085-2.17706-0.78455-4.2002-1.4219-5.95042-0.28225-2.17706-0.62521-3.77018-1.42342-5.95042-0.26404-2.03901-0.85284-4.17164-1.4219-6.44549,0-2.42618,0.0394-4.79366-0.47498-6.94216v-6.94215c-0.34144-2.0041-0.46739-4.93806-0.94844-6.44708,0-2.69753-0.28681-4.22083-0.94844-5.95042-1.08502-1.75181-1.17303-2.53726-2.84532-2.97521-1.20794,1.54076-3.1989,2.16912-5.69065,2.48013-1.74058-0.39669-4.19742-0.65534-6.16562-1.4884-1.90143-0.4681-3.20194-1.22023-4.7422-1.98347-0.84222-1.2964-1.84832-2.76417-2.84532-3.96695-0.2944-2.58962-0.85891-3.92251-0.94845-6.44549,0-1.89303,0.0455-0.8886,1.89689-3.47187z'/%3E %3Cpath fill='%23fefefe' d='m830.89,172.905c3.01016-0.99728,9.58467-5.8759,13.3643-9.00378,4.30335-2.72739,13.1109,0.10252,13.4622-7.28709-0.53305,2.22171-5.62641,7.74585-8.11654,11.089-5.48978,3.48825,2.68529,7.04297,4.00373,2.05723,2.84772-5.09972,6.46988-10.277,12.1601-12.2836-1.03729,3.67567-1.80247,7.24947,0.67074,10.5203,0.88987-1.60958,1.11142-8.21765,1.01654-2.77785-1.79843,3.09405,2.65737,12.1065,2.76993,5.09501,0.71142-4.43341,0.442,4.79493,1.79515,6.18455,2.83476,5.46966,2.58586-5.03246,3.21522-7.11238,0.47597-3.93153,0.67377-2.89436,0.0994-0.0538-0.57065,3.56033,0.61326-7.43531,0.82573-1.37487,0.39079,3.16821-0.0413,11.7806,3.02049,4.94723,2.45143-4.06247,3.03655-4.12345,0.36045-0.51803-0.87211,1.35908,4.0207-7.40192,2.08539-1.2911-0.12835,4.39044,0.0335,10.9195,2.41805,13.7864,1.83004-2.2556,0.7635-13.983,2.60342-5.92305,0.70504,2.27261,0.021,8.59829,2.99262,3.74338,3.2098-3.78269,4.97961-7.06438,4.63014-12.2524,0.40126-2.64755,2.01363-6.90493,3.43146-2.21596-0.97348,6.11645,5.39407,10.007,4.61587,15.8908,2.85773-4.49568,1.57127-11.1875-0.33184-15.4883-0.40174-5.09276,7.74442-2.0564,5.71932,2.43583-0.2315,3.22891,4.39599,11.5246,4.76657,3.84607,0.62156-3.6492,2.63103-3.9712,2.19105,0.10944,0.83861,2.63565,4.4214,10.3898,4.03435,3.63695,0.31893-3.67806-0.59578-7.55212,1.0582-11.0187,1.17289,2.21486,1.29679,5.61678,2.68143,1.40272,2.83045-0.0846,1.11836,7.78332,4.69516,9.46672,1.43727,2.82372,5.01505,7.43827,4.01209,1.35967,0.55544-3.29147-2.39218-10.095-1.11413-10.9712,3.74549,4.75485,5.12978,11.0333,10.1799,14.8701,4.80966,2.44003,0.59783-6.74784,0.33537-9.11604-2.867-1.57623-5.20908-7.70196-1.15198-2.91591,2.34206,4.25118,9.46311,7.97131,11.6877,8.89564-2.12213-1.56996-4.05621-2.15463-0.45716,0.018,2.66474,1.09269-1.58101-6.64142-3.12753-7.95206-1.37513-2.47279-8.07162-6.07864-6.17271-7.7839,5.23969,1.13266,6.77331,6.86107,9.95197,10.4396,1.98126,1.65983,6.75982,5.18605,4.09075-0.0764,1.49352-0.62278,8.86655,7.55936,7.10936,0.99791-1.21487-2.82231-7.67666-7.91561-6.96393-8.22312,2.20398,3.19048,0.87344,0.90986-0.8825-0.76238,6.38867,0.70949,10.1398,7.08678,14.1572,11.1402,0.50039,1.92977,1.96129,11.3292-0.0119,5.16368-4.15457-1.77377,1.603,8.43181-2.93355,7.10807-0.20511-2.26067-4.20708-7.00283-2.27102-2.31615,3.33625,6.84409,0.82153,14.361,1.11885,21.5783,0.0883,3.55373-0.082,7.08496-0.33537,10.6211,0.24069-2.60941,0.4433-6.95281,0.0161-1.25452-0.14842,3.95896-1.6073-5.71316-3.58581-6.2059-0.41055-1.80097-1.96739-10.901-3.2803-5.47185,0.0104,5.32009,5.14076,10.9028,1.04345,15.5915-1.38269,1.28818-2.11236,4.99701-2.85006,1.1098-2.01798-4.59595-3.30949-9.46095-6.84794-13.2155-1.49315-2.92571-6.61967-10.0186-5.19949-2.5725,0.88879,3.36447,1.4857,6.77784,1.25569,10.2672-1.99097-5.1616-4.70684-9.96075-7.37811-14.7269,0.3869,2.22649,3.09039,11.7834,0.73938,5.58987-1.62661-5.08029-4.24819-10.1509-9.31077-12.4046-1.39782-0.17335,3.40031,8.93365,1.55009,8.99929-0.44381-2.93678-3.10484-9.47314-5.7487-8.28005,0.1185,5.24793,2.25357,10.1348,1.03362,15.4864,0.26607,5.219-3.21916-5.18977-4.3598-6.58553-5.12431-3.13598,0.37497,8.83935-3.68753,4.20655-3.26935-2.29695-5.01393-4.83396-4.69516-9.11605-6.08182-1.03487-3.73498,5.39502-4.02291,9.05002-0.51339,2.77358-2.01069,8.04045-3.70171,8.85003-0.70603-4.00858-0.14054-8.20487-0.32271-12.2908,0.97716-2.34563-0.0982-8.37465-2.94714-5.50964-0.48257,5.29352,2.9743,12.0158-0.95631,16.3378-2.0801,2.3795-5.9375-3.71409-9.57596-2.08571-4.62086-2.36747-2.72652-9.7724-5.86328-13.6612-3.11725-3.26284-1.65536,13.0789-3.7059,5.3359,1.47374-4.93096-7.51607-6.85911-5.75896-1.60077,2.20795,2.23726,2.60646,5.04299,2.31646,8.01757,0.62655,3.49911-1.97233,4.5372-2.57748,0.60989-0.24863-4.3276-7.65601-6.12206-6.14058-0.43021-3.88245-2.49914-0.23824,9.85086-4.99598,6.05452-5.36181-3.7405-8.80139,3.31203-14.6754,1.92791-3.33986,0.55613-11.3287,1.42615-6.48435-3.42362,4.52943-2.7321,6.44443-10.9898,12.7568-6.76537,4.82565-0.28129,9.95052-3.67983,13.8907-6.84495,3.22258-2.17258,1.7812-7.6997-2.16866-4.27267-3.27934,4.92682-12.6992,4.92224-15.524,4.53229,2.79931-2.65078,11.3625-3.04043,9.23663-7.68244-3.14315,0.25665-8.66152,4.96533-10.4304,2.22426,1.09847-1.20979,4.70733-4.56024,0.54478-3.09798-5.27085,1.71677-10.9218,1.29897-16.3532,0.86776-5.4353-5.32188,7.928-3.86431,7.73453-7.36265-1.31761-0.10864-6.52147,0.59403-4.24666-1.31787,4.39919,0.0865,8.83744,0.42098,11.992-3.75434,1.90848-1.98275,8.54789-6.5335,6.92454-8.13266-4.8995,2.82138-10.0443,7.60914-16.1838,4.81979,5.27508-3.93443-2.03747-4.27138-5.37085-3.88706-2.42534,0.74896-9.16747-2.00823-3.40053-1.83108,3.92909,0.83158,7.83231-4.61133,1.78491-3.56902-1.26541-0.38878-2.62461-0.14135-3.92934-0.21075z'/%3E %3Cpath fill='%23fefefe' d='m801.857,164.957c-0.23136-2.56198-1.26283-5.10739-0.83642-7.69477,1.26199-1.84481,3.00745-3.18724,4.63018-4.70114,2.90484-1.61981,5.66804-3.59092,8.95369-4.38807,2.28115-0.69646,4.25854-2.20213,5.7479-4.04248,0.73309-2.21398-0.56236-5.75944,1.51487-6.95213,2.55642-1.39969,5.32409-2.30112,7.92882-3.58637,2.84468-0.91895,5.92331-1.06205,8.87362-0.70987,2.36179,1.01464,4.75592,1.93853,7.09929,2.99747,2.11924,1.03086,3.67999,2.77694,5.11286,4.5868,1.67465,1.52753,3.77083,2.51915,5.7413,3.60912,1.6371,0.11322,1.09701,2.23527,0.058,2.15219-0.6743,3.14003-4.59158,0.47595-5.33677-1.37364,0.65699-1.21901,0.38844,2.78457-0.86509,2.83893-2.20894,0.97651-2.14283-2.78465-2.46626-4.2221,0.28044-1.2152-0.67864-2.65619-1.17917-0.74693-1.48609,1.6347,1.60134,5.13888-1.62587,4.173-2.39804-0.31622-5.07777-0.81085-7.16045,0.77882-1.74322,1.81824,1.88708,2.56492,3.01891,3.44643,1.52572,1.43611,3.56554,0.0173,5.34179-0.15924,2.4299-0.83935,5.16356-0.40458,7.41596,0.72101,1.041,2.24835-1.04678,4.48315-3.03758,5.39487-1.85974,1.00879-3.93569,1.44558-6.00856,1.69755-3.03896,0.13471-2.44922,3.90074-5.40932,4.20221-1.89031,0.80048-4.01961,0.9837-6.03641,0.7181-0.39697-1.08631,2.00358-2.80708,2.25276-4.46644,2.17427-2.58539-3.11509-2.11424-2.34758,0.35068,0.36642,1.67133-3.29636,4.13969-2.05854,1.29917,0.0586-1.52756,1.6414-3.89874-1.0236-2.7979-1.45836-0.0133-4.44773-0.0666-3.62523,2.20009-1.80834,0.38287-4.12631,0.42325-5.67717-0.47586-0.9259-2.4702-3.81144-3.5558-5.62049-1.31137-1.8025,2.38467-4.30551-0.74156-6.09503,0.49461-0.0237,2.23527,2.28093,3.40462,4.32116,3.38734,2.06562-0.18234,4.18492-0.56558,6.26763-0.22477,1.91711,2.28659-1.83037,3.00321-3.60897,2.6894-2.39695-0.0867-4.54102-1.45657-6.97935-1.26693-1.16492-0.16461-3.8206,1.28459-1.31556,1.4787,1.85975,0.37786,5.66791,0.25128,4.81789,3.16927-1.45811,0.67958-3.26393-0.0665-4.91285,0.63698-0.96797-0.25022-3.87338,0.5347-2.25582-0.29811-0.85609-1.48198-2.51249-2.32067-3.61455-3.60462z'/%3E %3Cpath d='m812.447,153.269c-0.11078,0-1.11233,0.6966-2.01221,1.40272-1.4735,0.78863-3.04715,2.13104-4.02442,2.80542-0.76938,0.61567-0.76482,0.88384-1.67533,1.05204,1.59794-0.22691,2.30964-0.63313,3.68754-1.40272,1.7421-0.20945,3.42956-0.57917,4.35979-1.40271,0.87257-0.30466-0.0652-1.70261-0.33537-2.45475z'/%3E %3Cpath d='m827.873,136.789c0.19272,0,0.58576,1.09647,1.33996,1.75339,0.48256,1.34559,0.92719,2.29607,1.0061,3.85746,0.41125-1.71372,1.11385-3.09104,1.34148-4.90949-0.52202-0.92351-0.55693-1.3567-2.01221-1.40271,0,0.9473,0.11077,0.32846-1.67533,0.70135z'/%3E %3Cpath d='m833.908,137.14v0.35068c0-0.94572-0.0213-0.46334,0.33537,1.40271,0.55389,1.1758,0.67073,2.43729,0.67073,4.20814,0.88016-0.65693,1.61463-1.96761,2.01222-3.1561,0-2.76893-0.37483-2.6055-3.01832-2.80543z'/%3E %3Cpath d='m846.315,177.463h0.33537c-0.98638,0-0.43097,0.0603,1.34147-1.05204,1.14724-0.79973,2.08657-1.98188,3.68906-2.45474,1.5524-1.27419,2.74668-1.87082,4.35827-2.45316,0.78607-0.37766,1.47957-1.033,2.34758-0.35068-0.24887,1.72959-0.53568,2.38334-2.01221,3.15451-0.76331,0.99967-1.96517,1.58361-3.0168,2.10407-1.09109,0.50142-2.29143,0.52681-2.68295,1.75339-1.82404,0.83941-2.04863,0.69818-4.35979-0.70135z'/%3E %3Cpath d='m852.687,187.631c0.5979-0.47286,2.69813-2.66261,3.68754-3.50519,1.11992-1.54394,2.25198-2.7245,3.35369-3.50678,0.97727-1.50427,2.22921-2.51187,3.01831-3.85746,0.93175-1.17898,1.61766-2.17706,2.68295-3.50519,0,1.53282-0.13961,3.56549,0.33385,4.55722,0,2.11835-0.23369,2.69753-1.00458,4.20814-0.76179,1.24086-1.32934,2.06281-3.01832,2.80543-1.52358,0.84416-2.43712,1.14089-3.68906,2.10248-0.95451,0.61408-1.94847,1.22499-3.01831,1.75339-0.95907,0.43001-0.51899,0.24277-2.34607-1.05204z'/%3E %3Cpath d='m842.291,195.696h0.33536c-0.98637,0-0.43248,0.0603,1.34148-1.05204,1.43101-1.49633,2.57065-2.01679,4.35979-2.80542,1.3612-0.10949,3.0077-0.46334,4.02442-1.05203,0.81035-0.14916,1.37486-0.66487,2.0107,0,1.05315,1.48839,1.34299,1.90889-0.33537,2.80542-0.80276,0.71246-2.21859,1.42969-3.35217,1.75339-0.83766,0.72198-2.49478,0.76641-4.02442,1.05203-1.37031,0-2.1321,0.16186-2.68295-0.70135l2.68295,0.70135c-1.37031,0-2.1321,0.16186-4.35979-0.70135z'/%3E %3Cpath d='m856.71,195.696v-0.35068c0,0.97904-0.041,0.46017,0.67074-1.40271,1.25649-1.96126,1.72995-3.04344,3.35368-3.50678,0.76027-0.96159,2.07747-1.21071,3.68906-1.75339,0.60396,1.05362,0.13961,2.28178,0,3.50678-0.43856,1.30909-1.63436,2.23259-2.34758,3.1561-1.04556,0.74261-1.47198,1.45666-3.01832,1.75339-1.27926,0-0.60093-0.0333-2.34758-1.40271z'/%3E %3Cpath fill='%23c4c4c2' stroke='%23000' stroke-width='1.3578' d='m817.476,151.165c-0.74964,0,1.32175-0.7807,2.01222-1.05204,0.55237-1.21706,0.99093-2.07868,2.01221-2.80384,1.67988,0.13488,2.50388,0.64106,3.35368,1.75181,1.41128,0.40304,1.91965,1.10598,3.68906,1.40271,0.65708,0.58076,1.54634,0.64741,0,1.05203-1.05163,0.58077-2.37338,0.70136-4.02443,0.70136-1.72995,0.13012-2.9652,0.5284-4.02442,1.05203-2.24439,0-1.88474,0.0778-3.01832-2.10406z'/%3E %3Cellipse fill='%23000' cx='138.108' cy='302.603' rx='1.10487' ry='1.10489' transform='matrix(1.517505,0,0,1.5867785,612.59226,-330.0498)'/%3E %3C/g%3E %3Cg fill='%23005121' stroke='%23002b0e' stroke-width='1.9397'%3E %3Cpath d='m827.872,247.944h1.34148c-4.20501,0-1.69202-0.29355,5.36438,5.60927,2.95611-2.57535,2.9212-2.92285,5.36591,1.40271,1.41128,2.46268,1.82556-0.25071,4.0229-2.80384,1.05922,5.09515,1.73755,10.4378,5.36591,5.60926,4.14431,0,8.48286-0.36019,10.7303,1.40272,2.71634,5.27604,1.82708-0.89495,4.02443,1.40271,5.90613,0.74103,5.79384-5.29667,12.2266-6.85806,3.99863,5.22526,5.74983,1.20437,10.7318-1.40113,3.69968,1.08219,7.18691,6.95168,7.89103,1.24563,3.02894-5.16656,3.29299-4.72702,5.3659,0,2.94548,2.77369,4.1868-1.38685,6.70586-2.80384,4.49031,2.74671,9.49808,3.12754,16.0962,1.40271,1.11689,4.67148,3.93338,2.64516,6.70586,1.40113,5.93345,2.60707,8.00333,3.40522,14.7547,0,3.34458-4.13198,1.45073,0.11583,4.0229,2.80542,5.0017-1.62327,3.62077-1.9676,9.39033-1.40271,5.79839,0,6.2673-0.14598,8.04734-4.20655,2.91361,3.04661,3.96676,5.24272,8.04733,1.40271,6.25213,0.192,4.31883,0.82513,8.04886-1.40271,2.75882,6.38837,3.4068,1.77243,6.70586,4.20655-2.17307,5.76159-5.51159,8.46388-9.38881,11.2201-2.57977,4.46837-4.19287,9.29377-9.38882,11.2217-3.79073,4.04311-7.83033,6.38678-12.0718,9.8174-5.81508,1.52013-12.2159,1.40271-18.7791,1.40271h-18.7776-18.7791-18.7776c-4.00622,2.09296-10.5588,3.09105-16.0962,4.20655-6.18384,0-13.1932,0.0762-17.4361-1.40271-2.87568-3.00536-7.91987-6.36457-10.7303-9.8174-2.84381-2.39762-2.92575-7.07704-5.3659-9.8174-2.24439-4.01297-2.93789-10.2918-5.36439-14.0256v-9.8174z'/%3E %3Cpath d='m957.978,260.567v1.40271c0-3.92093,0.16541-1.83749-2.68295,5.60927-0.57665,1.80893-1.83922,2.23418-4.02442,2.80542'/%3E %3Cpath d='m945.906,266.177h1.34148c-4.9668,4.90474-8.30987,7.16431-9.39033,12.6228l9.39033-12.6228c-4.9668,4.90474-8.30987,7.16431-9.39033,12.6228'/%3E %3Cpath d='m927.127,259.165c0,0.12535-0.18817,5.00311-1.34147,7.01197'/%3E %3Cpath d='m921.763,268.982v1.40271-1.40271z'/%3E %3Cpath d='m911.032,260.567h1.34148-1.34148z'/%3E %3Cpath d='m835.919,260.567c0.64039,0,3.27933,4.4525,6.70586,7.01198-0.85284,4.10341-2.16396,8.85105,0,12.6228'/%3E %3Cpath d='m846.649,268.982c0.64038,0,3.27933,4.45409,6.70737,7.01356l-6.70737-7.01356c0.64038,0,3.27933,4.45409,6.70737,7.01356v1.40272c0-4.3335-0.34447-8.87169,1.33996-11.2217,1.49171,2.63882,3.37493,6.88187,4.02443,2.80543,7.55414-0.28245,11.2007-2.50076,16.0962-4.20655,0,2.06281-0.31716,1.07107,1.34147,2.80384'/%3E %3Cpath d='m967.367,261.97h1.34148c-2.52968,2.20404-4.47057,6.69938-6.70738,9.81741'/%3E %3Cpath d='m912.374,257.762h10.7303'/%3E %3C/g%3E %3Cg fill='%23fff'%3E %3Cpath d='m824.718,268.429c-16.1311,0-21.4775,16.8577-37.6086,16.8577-0.31034,0-0.6046-0.0255-0.90714-0.0377v1.02053c-0.0608,11.6854,0.85765,22.57,2.53244,32.7327,14.8808-1.08684,20.4088-16.8577,35.9833-16.8577,16.1311,0,21.5153,16.8955,37.6464,16.8955,16.131,0,21.5153-16.8955,37.6464-16.8955s21.5153,16.8955,37.6464,16.8955,21.5153-16.8955,37.6464-16.8955c15.5338,0,21.0768,15.6596,35.8699,16.8199,1.7721-10.4347,2.7084-21.6456,2.6458-33.6777v-0.0377c-0.3025,0.0122-0.5968,0.0377-0.9071,0.0377-16.1311,0-21.4776-16.8577-37.6086-16.8577-16.1311,0-21.5153,16.8577-37.6464,16.8577s-21.5154-16.8577-37.6464-16.8577c-16.1311,0-21.5153,16.8577-37.6464,16.8577s-21.5154-16.8577-37.6464-16.8577z'/%3E %3Cpath d='m824.718,334.234c-12.5486-0.00001-18.585,10.1721-28.2348,14.7033,3.37126,9.2945,7.44582,17.7549,11.9818,25.5134,4.58242-3.46521,9.4537-6.46339,16.253-6.46339,16.1311-0.00001,21.5153,16.8577,37.6464,16.8577,16.131,0,21.5153-16.8577,37.6464-16.8577,16.1311-0.00001,21.5153,16.8577,37.6464,16.8577s21.5153-16.8577,37.6464-16.8577c6.64925,0,11.4555,2.86935,15.9506,6.23661,4.53503-7.72309,8.62643-16.1692,12.0196-25.4-9.49735-4.59095-15.5359-14.5899-27.9702-14.5899-16.1311-0.00001-21.5153,16.8577-37.6464,16.8577s-21.5154-16.8577-37.6464-16.8577c-16.1311-0.00001-21.5153,16.8577-37.6464,16.8577s-21.5154-16.8577-37.6464-16.8577z'/%3E %3Cpath d='m900.011,400.04c-16.1311-0.00001-21.5153,16.8955-37.6464,16.8955-15.2555,0-20.902-15.1039-35.114-16.7444,18.9944,21.1594,40.5334,33.9695,55.2223,41.0104,4.96772-3.85569,10.1124,4.68691,17.5381,4.68691,7.37272,0,12.4898-8.58651,17.4247-4.7625,14.5266-7.07257,35.8026-19.9033,54.6932-40.8592-13.7469,2.00976-19.4462,16.6688-34.4714,16.6688-16.1311,0-21.5154-16.8955-37.6464-16.8955z'/%3E %3C/g%3E %3Cg stroke='%23522108'%3E %3Cg fill='none'%3E %3Cpath stroke-width='0.7371' d='m800.148,342.754c2.64653-0.92192,15.4376-5.07293,15.8792-4.61277,0.44159,0.46176,24.702,24.9077,24.702,24.9077l-20.2906,4.15101-20.2906-24.4459z'/%3E %3Cg stroke-width='0.7513'%3E %3Cpath d='m848.358,374.785c0.37408-5.78836,11.2095-38.709,11.2095-38.709'/%3E %3Cpath d='m852.095,375.177c0-0.36216,8.59483-38.7388,8.59483-38.7388'/%3E %3Cpath d='m855.039,375.237c0.37279-2.17048,7.14479-38.7986,7.14479-38.7986'/%3E %3Cpath d='m851.349,364.293c1.86783,0,5.60476-1.44741,5.60476-1.44741'/%3E %3Cpath d='m852.47,359.952c0-0.36216,5.60477-1.4474,5.60477-1.4474'/%3E %3Cpath d='m853.216,354.526,5.97884-1.08524'/%3E %3Cpath d='m855.832,349.823c0,0.36216,4.10973,0.36216,4.10973,0.36216'/%3E %3C/g%3E %3Cg stroke-width='0.7371'%3E %3Cpath d='m914.897,400.376c-0.44159-9.91194-13.2326-66.2848-13.2326-66.2848'/%3E %3Cpath d='m910.485,398.517c0-0.62016-10.146-63.8063-10.146-63.8063'/%3E %3Cpath d='m906.074,393.56c-0.44007-3.71671-7.498-58.8493-7.498-58.8493'/%3E %3Cpath d='m914.455,392.322c-2.20494-1.85836-8.82126-4.33687-8.82126-4.33687'/%3E %3Cpath d='m911.367,382.41c-2.20493,0-6.61632-2.47852-6.61632-2.47852'/%3E %3Cpath d='m910.044,374.977c0-0.62016-6.61633-2.47852-6.61633-2.47852'/%3E %3Cpath d='m909.162,365.685-7.05792-1.85835'/%3E %3Cpath d='m906.074,357.631c0,0.62016-4.85147,0.62016-4.85147,0.62016'/%3E %3Cpath d='m904.75,350.198c-0.88167,0-4.85147,1.23819-4.85147,1.23819'/%3E %3C/g%3E %3Cg stroke-width='0.7371'%3E %3Cpath d='m948.797,372.677c-2.20493,0-6.61632-1.84543-6.61632-1.84543'/%3E %3Cpath d='m952.326,386.053c-0.44159-7.38011-13.2326-49.3536-13.2326-49.3536'/%3E %3Cpath d='m947.915,384.67c0-0.46175-10.146-47.5082-10.146-47.5082'/%3E %3Cpath d='m943.504,380.979c-0.44007-2.76734-7.498-43.8173-7.498-43.8173'/%3E %3Cpath d='m947.473,367.142c0-0.46175-6.61633-1.84542-6.61633-1.84542'/%3E %3Cpath d='m946.592,360.224-7.05792-1.38367'/%3E %3Cpath d='m943.504,354.227c0,0.46176-4.85147,0.46176-4.85147,0.46176'/%3E %3Cpath d='m942.18,348.693c-0.88167,0-4.85147,0.92192-4.85147,0.92192'/%3E %3C/g%3E %3C/g%3E %3Cg fill='%23dd8b59' stroke-width='0.7371'%3E %3Cpath d='m895.426,391.646c0-0.46175,1.32326-115.771,1.32326-115.771s3.9698-0.46175,3.9698,0-0.44008,115.31-0.88167,115.771c-0.4416,0.46175-4.85299,0.92192-4.41139,0z'/%3E %3Cpath d='m938.656,280.947c0,0.92351-0.88319,97.3219-0.88319,97.3219l-3.08813,3.69085,0.88319-101.013h3.08813z'/%3E %3Cpath d='m861.903,369.507c0.44007-2.76893,0.44007-86.2526,0.44007-86.2526l-2.64653-0.46175-0.44007,85.3306,2.64653,1.38367z'/%3E %3Cpath d='m845.141,338.141c1.76486,0,31.7599-5.07293,31.7599-5.07293l-0.44159,5.07293-29.5534,3.2291-1.76486-3.2291z'/%3E %3Cpath d='m845.581,311.389c1.76486,0.46176,36.1713-9.6857,36.1713-9.6857s0,3.2291-0.4416,3.2291c-0.44007,0-35.7297,9.6857-35.7297,9.6857v-3.2291z'/%3E %3Cpath d='m846.906,298.013c-0.44159,1.84543,0.44008,4.1526,0.44008,4.1526l28.6718-10.1474s1.32327-2.30718,0-2.30718c-1.32326,0-29.5534,9.22554-29.1118,8.30203z'/%3E %3Cpath d='m884.84,291.556c0.88167,0,29.5534-9.6857,29.5534-9.6857s0.44159,4.15101,0,4.15101c-0.44008,0-26.9069,8.30203-26.9069,8.30203l-2.64653-2.76734z'/%3E %3Cpath d='m882.634,303.549s-0.88167,4.15101-0.44008,4.15101c0.44008,0,37.493-10.1474,37.493-10.1474v-2.76735l-37.053,8.76379z'/%3E %3Cpath d='m883.957,336.297,0,3.2275,31.7599-4.61118-0.88167-2.30717-30.8782,3.69085z'/%3E %3Cpath d='m920.57,338.603,0.44007,2.76734s31.7599-4.15102,31.7599-4.61277c0-0.46016,0-3.22751-0.44008-3.22751-0.44159,0-31.3198,5.53469-31.7599,5.07294z'/%3E %3Cpath d='m920.128,309.084,0.4416,3.22751,37.493-10.6076s0.88319-2.76734,0.4416-2.76734c-0.4416,0-37.4946,11.5311-38.3762,10.1474z'/%3E %3Cpath d='m924.098,294.324s-0.44008,2.76734,0,2.76734c0.44159,0,27.7901-6.91835,27.7901-7.38011,0-0.46016,2.64653-3.22909,0.44159-2.76734-2.20645,0.46175-27.3485,8.76378-28.2317,7.38011z'/%3E %3C/g%3E %3Cg fill='%23fecf3e' stroke-width='0.7371'%3E %3Cpath d='m864.108,303.549c3.9698-1.38367,1.32327-4.61277,2.20494-4.61277,0.88319,0,3.9698,2.30559,5.73466,0.46017,1.76486-1.84384,3.08812-7.37853,2.20645-6.91836-0.79468,0.41547-19.8018,7.55232-23.9258,7.63379,2.58255,0.99754,10.3417,4.63553,13.7798,3.43717z'/%3E %3Cpath d='m925.421,297.091s2.20646,5.53469,4.41139,4.61277c2.20494-0.92192,4.41139-2.76734,4.41139-2.76734s1.76486,4.61277,4.85147,3.68926c3.08813-0.92192,4.85299-5.99644,4.85299-5.99644s3.0866,0.92351,4.40987,0.46175c1.32478-0.46175,3.08812-7.84027,3.08812-7.84027l-26.0252,7.84027z'/%3E %3Cpath d='m922.775,341.832c-0.44159,0.92192,2.20646,3.2291,4.41139,3.2291,2.20494,0,3.08813-3.2291,3.52821-2.30718,0.44159,0.92351,0.44159,5.07452,6.17625,3.69085,5.73465-1.38367,5.73465-5.53469,5.73465-5.53469s-1.76486,1.38367,2.20494,1.84384c3.96979,0.46175,7.93959-5.99644,7.49951-5.99644-0.44159,0-28.6718,5.53627-29.555,5.07452z'/%3E %3Cpath d='m922.775,311.851s-4.41139,5.07293-3.08812,11.9913c1.32326,6.91994,3.08812,12.9148,3.52972,12.9148,0.44159,0,5.29306-9.22395,10.5861-9.6857,5.29306-0.46175,14.9975,5.07452,14.9975,5.07452s-1.32326-11.071-0.88167-16.1439c0.44008-5.07452,7.9396-13.8367,7.9396-13.8367l-33.0832,9.68571z'/%3E %3Cpath d='m846.464,341.832c0.44159,0,0,4.15102,3.5282,3.2291,3.52972-0.92351,4.41139-3.2291,4.41139-3.2291s0.88167,5.07293,5.73466,4.61277c4.85146-0.46175,7.49799-5.99644,7.49799-5.99644s0.4416,4.15101,3.52972,2.76734c3.08813-1.38367,3.9698-4.61276,3.9698-4.61276l-27.7901,4.15101-0.88167-0.92192z'/%3E %3Cpath d='m846.464,314.619s-3.9698,1.38367-2.64653,9.6857c1.32326,8.30203,4.41139,12.9148,4.85146,12.9148,0.4416,0,3.9698-7.84027,9.26286-9.22394,5.29458-1.38526,14.5574,4.15101,14.5574,4.15101s-0.88319-7.38011,0.44159-14.2985c1.32327-6.91994,5.73314-11.9929,5.73314-11.9929s-30.8767,8.76378-32.2,8.76378z'/%3E %3Cpath d='m885.722,292.94c1.76486,0.46175,4.85299,5.07293,6.61633,4.15101,1.76486-0.92191,4.41139-3.68926,4.41139-3.68926s-0.44159,5.53469,3.08813,4.61118c3.5282-0.92192,3.96979-4.61118,3.96979-4.61118s2.64653,1.38367,4.85147,0c2.20645-1.38367,4.41139-8.30361,3.52972-8.30361s-25.5836,8.30361-26.4668,7.84186z'/%3E %3Cpath d='m884.84,306.317c0,0.92192-4.41139,8.30203-3.08812,15.2204,1.32326,6.91835,3.96979,13.3765,4.41139,13.3765,0.44159,0,7.05792-7.38011,12.7926-8.76378,5.73313-1.38367,14.1143,4.61277,13.6742,4.61277-0.44159,0-2.20645-6.91994-2.20645-11.9929,0-5.07452,6.61633-20.7567,6.61633-20.7567l-32.2,8.30362z'/%3E %3Cpath d='m884.84,339.525c0,0.46176,1.32327,3.69085,4.41139,3.69085,3.08661,0,3.52821-3.22909,3.52821-3.22909s-0.4416,5.53468,4.41139,5.07452c4.85146-0.46176,6.61632-5.53628,6.61632-5.53628s0.4416,2.76893,4.41139,1.38526c3.9698-1.38526,9.26286-5.99644,8.82127-5.99644-0.44008,0-31.7584,5.99644-32.2,4.61118z'/%3E %3C/g%3E %3Cg fill='%23dd8b59' stroke-width='0.7371'%3E %3Cpath d='m846.464,372.734s4.41139,47.5082,55.1386,46.1245c50.7272-1.38367,64.8415-47.9683,64.8415-47.9683s-21.6138-0.92351-22.0554-0.92351c-0.44007,0-17.644,22.1403-39.6995,21.6786-22.0554-0.46175-29.1118-5.99644-33.9648-10.6076-4.85147-4.61277-9.26286-11.5311-9.26286-11.5311l-25.5836-10.6092,1.32326,10.1474,9.26286,3.68927z'/%3E %3Cpath d='m983.411,367.799c-0.4416-1.38367-1.52813-6.13449-1.52813-6.13449v-5.53468l2.44166-5.60451s-38.3762,5.74891-38.3762,6.21066c0-0.53157-0.23673,10.925-0.23673,10.925l37.6994,0.13805z'/%3E %3Cpath d='m976.149,356.13-0.88167,9.6857,6.17473,0-0.44007-9.6857-4.85299,0z'/%3E %3Cpath d='m969.532,356.592-0.44159,10.1459,3.9698-0.46017,0.44159-9.6857-3.9698,0z'/%3E %3Cpath d='m962.916,366.738,0-7.84028,3.96979-1.38367,0.4416,7.84028-4.41139,1.38367z'/%3E %3Cpath d='m955.416,366.278,0.88319-6.91836,4.40987,0.46017,0.4416,7.38011-5.73466-0.92192z'/%3E %3Cpath d='m947.035,366.278,0.4416-5.99644,4.41139-0.46175,0,6.91836-4.85299-0.46017z'/%3E %3Cpath d='m942.625,369.967,41.9044,0.92351,0.44159-3.2291-43.2292-0.46175,0.88319,2.76734z'/%3E %3Cpath d='m944.389,358.436c4.85299,0,41.4643-7.38011,41.4643-7.38011s1.32327-4.61118,0-4.61118c-1.32326,0-41.4643,8.76378-41.4643,8.76378v3.22751z'/%3E %3Cpath d='m798.825,342.294,33.5232,17.0658-0.88168,2.30559s-32.2015-15.6821-32.2015-16.1439c0-0.46016,0.4416-2.30559-0.44007-3.22751z'/%3E %3Cpath d='m814.263,337.219c0,1.38368,4.85298,29.5189,4.85298,29.5189s3.08813,0.46175,3.08813,0c0-0.46017-5.29458-29.0571-5.29458-29.0571l-2.64653-0.46176z'/%3E %3C/g%3E %3Cg fill='none'%3E %3Cg stroke-width='0.7513'%3E %3Cpath d='m882.044,389.315c0.44159-7.66848,13.2326-51.282,13.2326-51.282'/%3E %3Cpath d='m886.456,389.834c0-0.47979,10.146-51.3216,10.146-51.3216'/%3E %3Cpath d='m889.931,389.913c0.44007-2.87547,8.4343-51.4007,8.4343-51.4007'/%3E %3Cpath d='m882.486,383.084c2.20494-1.43773,8.82126-3.35527,8.82126-3.35527'/%3E %3Cpath d='m885.574,375.416c2.20493,0,6.61632-1.91753,6.61632-1.91753'/%3E %3Cpath d='m886.897,369.665c0-0.4798,6.61633-1.91753,6.61633-1.91753'/%3E %3Cpath d='M887.779,362.476,894.837,361.038'/%3E %3Cpath d='m890.867,356.245c0,0.4798,4.85147,0.4798,4.85147,0.4798'/%3E %3Cpath d='m892.19,350.494c0.88167,0,4.85147,0.95794,4.85147,0.95794'/%3E %3C/g%3E %3Cg stroke-width='0.7371'%3E %3Cpath d='m919.474,388.989c0.44159-7.38011,13.2326-49.3536,13.2326-49.3536'/%3E %3Cpath d='m923.885,387.605c0-0.46175,10.146-47.5082,10.146-47.5082'/%3E %3Cpath d='m928.296,383.914c0.44007-2.76734,7.498-43.8173,7.498-43.8173'/%3E %3Cpath d='m919.915,382.992c2.20494-1.38368,8.82126-3.2291,8.82126-3.2291'/%3E %3Cpath d='m923.003,375.612c2.20493,0,6.61632-1.84543,6.61632-1.84543'/%3E %3Cpath d='m924.326,370.077c0-0.46175,6.61633-1.84542,6.61633-1.84542'/%3E %3Cpath d='m925.208,363.159,7.05792-1.38367'/%3E %3Cpath d='m928.296,357.162c0,0.46176,4.85147,0.46176,4.85147,0.46176'/%3E %3Cpath d='m929.62,351.628c0.88167,0,4.85147,0.92192,4.85147,0.92192'/%3E %3C/g%3E %3Cg stroke-width='0.7371'%3E %3Cpath d='m877.156,384.068c-0.44159-7.42463-13.2326-49.6514-13.2326-49.6514'/%3E %3Cpath d='m872.744,382.676c0-0.46454-10.146-47.7948-10.146-47.7948'/%3E %3Cpath d='m868.333,378.963c-0.44007-2.78404-7.498-44.0817-7.498-44.0817'/%3E %3Cpath d='m876.714,378.036c-2.20494-1.39202-8.82126-3.24858-8.82126-3.24858'/%3E %3Cpath d='m873.626,370.611c-2.20493,0-6.61632-1.85656-6.61632-1.85656'/%3E %3Cpath d='m872.303,365.043c0-0.46454-6.61633-1.85656-6.61633-1.85656'/%3E %3Cpath d='m871.421,358.083-7.05792-1.39202'/%3E %3Cpath d='m868.333,352.05c0,0.46454-4.85147,0.46454-4.85147,0.46454'/%3E %3Cpath d='m867.01,346.482c-0.88167,0-4.85147,0.92748-4.85147,0.92748'/%3E %3C/g%3E %3C/g%3E %3Cpath fill='%23b6b6b4' stroke-width='0.73708421' d='m834.995,359.359s-8.82127-1.38367-8.38119,0.92192c0.44159,2.30559,4.41139,4.61277,4.85298,5.99644,0.44008,1.38367-1.32326,6.45661,1.32327,5.99644,2.64653-0.46175,5.29306-2.30718,5.29306-3.69085s-0.44159-7.84027-0.44159-7.84027l-2.64653-1.38368z'/%3E %3Cg fill='none' stroke-width='0.7371'%3E %3Cpath d='m844.699,372.274c1.32326,0,11.4693,2.30559,11.4693,2.30559l10.5861,14.7602'/%3E %3Cpath d='m852.199,374.118c0.44008,0.46175,9.26286,31.3643,51.6089,31.3643s52.4921-35.0535,52.4921-35.0535'/%3E %3Cpath d='m962.916,371.351s-20.2906,46.1245-59.1084,42.8954c-38.8178-3.22751-44.9925-18.4495-48.0807-26.2898-3.08813-7.84186-4.85147-14.2985-4.85147-14.2985'/%3E %3Cg%3E %3Cpath d='m951.888,333.99c0.44159-1.38367,1.76486-29.0571,1.76486-29.0571'/%3E %3Cpath d='m982.765,347.828-27.3485-45.2026'/%3E %3Cpath d='m899.838,277.258c0-0.46175,13.6742,5.99644,13.6742,6.45661,0,0.46175,48.5208,67.8031,48.9623,67.8031'/%3E %3Cpath d='m938.214,283.714,12.351,5.53627,3.9698,10.1459'/%3E %3Cpath d='m861.462,282.793c-0.44159,0,13.6742,11.0694,13.6742,11.0694l1.76486,9.22553'/%3E %3Cpath d='m813.381,350.134c6.17473-2.76734,48.9623-41.9735,48.9623-41.9735'/%3E %3Cpath d='m801.912,342.754c5.29458-4.61277,48.0807-42.4336,48.0807-42.4336'/%3E %3Cpath d='m882.194,306.777,45.4341,78.8724'/%3E %3Cpath d='m922.268,339.393s5.35983,18.5828,10.6529,21.3501c5.29306,2.76734,11.4678,7.38011,11.4678,7.38011'/%3E %3Cpath d='m921.656,339.779s3.76493,21.8864,9.058,26.0375c5.29306,4.15101,10.5876,8.76378,10.5876,8.76378'/%3E %3Cpath d='m885.067,338.251s5.29306,30.4424,15.8807,37.3607c10.5861,6.91835,19.4074,12.9148,19.4074,12.9148'/%3E %3Cpath d='m884.627,337.79s11.4678,23.9858,21.1722,31.3659c9.70445,7.37852,22.9371,14.2985,22.9371,14.2985'/%3E %3Cpath d='m847.574,339.635c3.08661,5.53469,2.64653,16.1439,6.17474,19.8332,3.5282,3.69085,8.82278,11.9929,8.82278,11.9929'/%3E %3Cpath d='m848.456,340.097c1.76486,2.76735,6.68614,16.5469,9.70446,20.7551,2.20645,3.69084,24.702,27.2133,24.702,27.2133'/%3E %3C/g%3E %3C/g%3E %3Cg fill='%23000' stroke-width='0.475'%3E %3Cellipse rx='3.308315' ry='3.45929' cx='872.054473' cy='389.218617'/%3E %3Cellipse rx='2.867176' ry='2.998061' cx='888.816847' cy='396.598727'/%3E %3Cellipse rx='2.867176' ry='2.998061' cx='909.549017' cy='398.444151'/%3E %3Cellipse rx='2.646652' ry='2.536816' cx='928.074732' cy='391.294124'/%3E %3Cellipse rx='2.426128' ry='2.998045' cx='942.190575' cy='382.30026'/%3E %3C/g%3E %3Cg fill='%23ff0101' stroke-width='0.7371'%3E %3Cpath d='m859.483,283.363c-1.32326,0.92351-23.3787,6.45819-20.2906,5.99644,3.0866-0.46017,20.7322,4.61277,20.2906,3.22909-0.44159-1.38367,0-8.30202,0-9.22553z'/%3E %3Cpath d='m896.978,276.445c-0.88319,0-13.6758,5.07452-13.2342,5.07452s14.5574,4.15102,14.1158,3.22751c-0.4416-0.92192-0.4416-6.91836-0.88167-8.30203z'/%3E %3Cpath d='m935.354,281.057c-0.88319,0.46175-15.8807,4.15101-13.2342,4.61277,2.64653,0.46175,12.7926,4.15101,12.7926,3.22909,0-0.9235,0-7.38011,0.44159-7.84186z'/%3E %3C/g%3E %3Cg fill='%23be1017' stroke-width='0.5813' transform='matrix(0.04915326,-1.2962189,1.2382477,0.05145445,0,0)'%3E %3Ccircle r='1.8894' cx='-216.002142' cy='726.376815'/%3E %3Ccircle r='1.8894' cx='-212.21777' cy='739.051036'/%3E %3Ccircle r='1.8894' cx='-219.249357' cy='732.917906'/%3E %3Ccircle r='1.8894' cx='-208.970565' cy='732.509881'/%3E %3Ccircle r='1.8894' cx='-214.109961' cy='732.713893'/%3E %3C/g%3E %3C/g%3E %3C/g%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='-19 -10 38 20'%3E %3Crect x='-19' y='-10' width='38' height='20' fill='%2375b2dd'/%3E %3Cg id='star' transform='translate(0,-6)' fill='%23fff'%3E %3Cg id='c'%3E %3Cpath id='t' d='M 0,-2 V 0 H 1' transform='rotate(18 0,-2)'/%3E %3Cuse xlink:href='%23t' transform='scale(-1,1)'/%3E %3C/g%3E %3Cuse xlink:href='%23c' transform='rotate(72)'/%3E %3Cuse xlink:href='%23c' transform='rotate(144)'/%3E %3Cuse xlink:href='%23c' transform='rotate(216)'/%3E %3Cuse xlink:href='%23c' transform='rotate(288)'/%3E %3C/g%3E %3Cuse xlink:href='%23star' transform='rotate(90)'/%3E %3Cuse xlink:href='%23star' transform='rotate(180)'/%3E %3Cuse xlink:href='%23star' transform='rotate(270)'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 22 16'%3E %3Crect fill='%23FFF' width='22' height='16'/%3E %3Cg fill='%230065BD'%3E %3Crect x='6' width='4' height='16'/%3E %3Crect y='6' width='22' height='4'/%3E %3C/g%3E %3Cg fill='%23ED2939'%3E %3Crect x='7' width='2' height='16'/%3E %3Crect y='7' width='22' height='2'/%3E %3C/g%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 3 2'%3E %3Crect width='3' height='2' fill='%23ED2939'/%3E %3Crect width='2' height='2' fill='%23fff'/%3E %3Crect width='1' height='2' fill='%23002395'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 400 300'%3E %3Crect fill='%233a75c4' width='400' height='300'/%3E %3Crect fill='%23fcd116' width='400' height='200'/%3E %3Crect fill='%23009e60' width='400' height='100'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 25 15'%3E %3Crect width='25' height='15' fill='%23FFF'/%3E %3Cg fill='%23CE1124'%3E %3Crect width='3' height='15' x='11'/%3E %3Crect width='25' height='3' y='6'/%3E %3C/g%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 60 30'%3E %3CclipPath id='t'%3E %3Cpath d='M30,15 h30 v15 z v15 h-30 z h-30 v-15 z v-15 h30 z'/%3E %3C/clipPath%3E %3Cpath d='M0,0 v30 h60 v-30 z' fill='%2300247d'/%3E %3Cpath d='M0,0 L60,30 M60,0 L0,30' stroke='%23fff' stroke-width='6'/%3E %3Cpath d='M0,0 L60,30 M60,0 L0,30' clip-path='url(%23t)' stroke='%23cf142b' stroke-width='4'/%3E %3Cpath d='M30,0 v30 M0,15 h60' stroke='%23fff' stroke-width='10'/%3E %3Cpath d='M30,0 v30 M0,15 h60' stroke='%23cf142b' stroke-width='6'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 5 3'%3E %3Cdefs%3E %3CclipPath id='a'%3E %3Crect width='5' height='3'/%3E %3C/clipPath%3E %3C/defs%3E %3Cg clip-path='url(%23a)'%3E %3Crect width='50' height='30' fill='%230065BD'/%3E %3Cpath d='M 0,0 L 5,3 M 0,3 L 5,0' fill='none' stroke='white' stroke-width='0.6'/%3E %3C/g%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 830 498'%3E %3Crect width='830' height='249' y='249' fill='%2300ab39'/%3E %3Crect width='830' height='249' fill='%23fff'/%3E %3Cg transform='translate(1.72,0.97)' stroke='%23000' stroke-width='1.8'%3E %3Cpath d='M541.562,28.5625c-0.011,0.0194-0.019,0.0431-0.031,0.0625,0.033-0.0182,0.061-0.0443,0.094-0.0625h-0.063zm-0.031,0.0625c-52.242,28.8873-99.003,58.9451-144.969,97.25-22.06,19.27-15.833,34.631-16.687,51.937,0.711,11.618-2.511,22.426-9.656,28.938-16.35,3.306-32.715,6.632-49.063,9.938-1.566-4.524-3.121-9.042-4.687-13.563,1.495-6.94,7.232-10.352,19.312-6,0.952-8.923-6.227-12.555-14.625-15.656-2.885-2.246-6.468-3.971-6-11.688-1.412-17.467,26.615,1.25,26.875,1.25,0.261,0-0.934-17.627-13.812-21.156-7.022-2.485-9.994-9.892-7.313-15.375,5.618-11.209,16.194,0.878,24.282,1.312-0.304-7.316-2.387-12.531-8.688-18.437-3.392-2.087-11.722-3.657-11.938-7.156-0.176-4.752,7.808-6.784,18.782-5.469-2.288-6.6597-9.668-10.9678-19.813-14.0938-2-3.4786-4-6.9582-6-10.4374-2.841-5.26-4.115-5.4018,2.469-15.375,5.915-3.8266,13.774-9.2366,19.688-13.0626-2.176-0.261-4.357-0.5203-6.532-0.7812,0.869-7.1313,0.969-9.5307,2.625-21.375-6.346,8.6716-14.275,7.1213-21.406,10.6875,0,0-20.33,3.6092-26.875,12.25-0.261,0-51.125-2.5937-51.125-2.5937-10.84,1.5094-20.099,4.5822-21.906,15.125-24.792,2.5024-50.755,0.2888-69.657,24,12.87-0.6088,24.136-3.6738,38.594-1.8126,0,0,12.321,0.233,14.875,13.2808,0.261,0.522,4.188,0.532,4.188,0.532,1.566,1.217,3.121,2.439,4.687,3.656,0.609-1.652,1.204-3.317,1.813-4.9688,1.392,0.9568,2.795,1.9178,4.187,2.8748,0.434-1.826,0.879-3.6423,1.313-5.4685,1.392,0.9565,2.764,1.9184,4.156,2.8745,0.087-2.1736,0.195-4.3568,0.281-6.5308,1.827,1.3044,3.643,2.6019,5.469,3.9063v-8.5937s20.192-0.0472,26.344,12.7812c0.262,0.261-56.665,10.463-111.657,5.75,5.306-2.609,10.602-5.235,15.907-7.8438-20.05-4.0762-38.901-7.7612-56.594-21.6562,6.677,25.137,41.181,54.663,48.25,54.531,0,0.261-6.781-12.25-6.781-12.25,19.916,0.87,39.835,1.725,59.75,2.594,2.175,6.61,1.213,14.02,6.531,19.844,0,0-3.299,10.925,4.031,15.375,0.262,0.521,8.75-22.157,8.75-22.157s2.6,6.101,5.219,10.157c3.795-19.508,25.031-22.688,25.031-22.688s4.438,10.176,4.438,10.438c-6.636,0.96-14.89,14.486-10.438,21.906-4.45,0.085-12.351,13.186-9.906,20.344-3.741,3.723-13.058,8.686-10.688,24.281-7.334,1.572-11.676,14.991-9.406,29.219-11.349,10.564-8.563,29.956,1.563,37.812-4.203,3.74-6.791,6.616-6.781,11.219-3.996-1.485-7.68-0.244-9.407,2.375-4.898-5.021-11.931-9.418-16.937-4.719-1.296-5.94-9.032-12.474-17.5-11.718,0.496-6.264-2.755-14.018-11.719-16.719,0,0-1.814-29.358-10.719-38.875-0.873-5.326,0.51-8.948,7.844-13.313,7.323-3.906,8.879-6.935,8.344-18,2.887-7.396,5.08-14.936-3.906-20.062,0.27,8.795-2.43,13.031-6,16.937-4.266-0.621-5.756,4.358-8.626,6.532-4.016-5.414,8.472-13.799-0.781-25.844-0.521-0.523-6.459-15.723-21.125-15.375,6.971,4.082,9.92,10.951,9.906,18-4.624,13.045-6.973,23.127-2.343,38.093-6.093-9.128-9.549-26.482-14.594-29.5-4.422-0.862-6.582-11.321-23.75-8.343,7.4057,1.992,9.7571,7.647,11.75,12.781-4.541,2.342-2.285,8.519,1.0312,12.781-0.6296,10.015,5.3698,15.866,14.3438,19.594-1.478,13.653-2.96,27.283-4.438,40.937-3.564-0.454-9.05,13.425-11.2182,13.844-3.4888,2.171-9.5812,8.01-2.5938,9.656-2.0758,7.492-4.0012,12.009-15.1562,13.563,0,0,11.7874,6.991,21.5622-4.969,10.474-0.262,7.03-12.752,12.094-18.25,0-0.26,2.874-2.066,7.062-13.062,1.832,9.819,11.908,39.888,34.688,54.812,19.856,21.256,36.175,41.33,36,69.656,7.75-7.208,12.378-18.624,15.938-29.5,10.776-3.748,26.191-5.179,39.937-4.562-2.358,4.961-4.997,9.721-1.594,12.938-9.593,3.294-11.695,10.256-7.843,17.218-10.112,6.867-10.778,11.28-10.938,22.688-18.708,23.985-30.249,23.188-48.781,16.968-6.086-3.572-15.505-8.714-19.844-6-8.004-5.334-19.512-6.126-21.406,6,6.006-4.978,9.592-4.018,14.375,0.782-0.962,2.436-1.766,4.862,1.812,6.25-1.566,1.739-3.121,3.48-4.687,5.218-8.613-1.324-20.194-1.25-23.219,11.219,4.424-3.665,14.24-4.525,22.156-1.031,1.479,0.522,2.959,1.04,4.438,1.562,0.174,2,0.358,4,0.531,6,0,0-11.732-1.811-14.875,17.219,11-11.702,18.781-8.625,18.781-8.625,4.239,6.205,19.841,5.271,31.063-4.937,15.762-8.812,20.357,3.851,30.531-4.438,8.436-6.292,18.417-2.108,25.281,5.219,7.915,2.969,16.2,5.413,22.719,0,0,0,7.963-5.081,15.906,3.125,0.087-9.253-6.47-14.169-15.375-14.344l-2.625-2.625c-8.349-1.74-17.73-1.034-25.031-5.218,3.442-13.066,8.457-24.904,18.25-34.969,12.088-12.958,20.987-18.85,36.25-38.688-0.589,11.211,8.003,23.677,12.531,35.063,0,0,9.116-14.555,10.438-26.375,0.26,0,11.423-5.81,16.187-10.75,10.056,6.237,26.446-4.994,37.032-14.281,6.524,2.47,11.478,2.292,19.062,0-6.088,12.39,3.521,23.883,18.781,28.687,1.411,10.938,12.459,13.229,29.219,13.313,0.706,6.436,10.688,7.312,10.688,7.312-6.308,2.94-9.596,5.886-9.376,12.531-6.464,0.044-11.36,1.671-13.062,9.125-8.876,0.152-17.922,0.833-25.562,5.219-8.176-1.269-18.122-4.657-24.532-11.219-3.306-2.783-4.131-6.796-9.906-8.344-3.66-4.326-8.039-3.36-9.406,0.782-3.783-2.955-17.972-4.328-20.344,9.125,6.624-4.848,12.564-6.696,16.719-0.781-2.264,4.106,5.516,6.455,12.25,8.093,4.776,0.296,13.247,4.647,15.906,12-6.16,1.869-15.496,1.253-21.656-3.406-5.476-4.582-12.872-4.036-16.938-1.031-5.64-3.596-19.071,3.193-19.593,14.062,5.658-5.184,10.807-7.691,15.937-4.406-2.553,0.606-1.583,0.855-1.313,2.344,4.348,2.522,8.684,5.04,13.032,7.562-6.394,1.687-12.405,4.238-9.625,16.156,0,0,5.208-10.296,16.937-6.5,0.261-0.26,1.617,3.678,4.969,1.032,5.076-5.776,16.682-8.362,26.875-9.375,8.18-0.977,16.347-3.387,23.469,1.281,6.341-3.262,13.401-5.456,20.625-0.25,8.523,2.696,14.746,12.631,25.562,8.094,5.379-3.723,11.99-3.912,18.782,3.656,0.082-9.543-7.069-12.742-17.219-14.875-2.349-1.393-4.683-2.795-7.031-4.187-6.522-0.958-13.072,0.198-19.594-2.876,34.134-8.824,58.062-27.859,74.906-55.031,5.392,1.913,10.764,3.805,16.156,5.719,3.825,0.245,4.117,1.574,12,3.938,0.297-11.614-4.689-23.578-25.562-24.782l-27.406-10.437c-5.818-6.135-8.447-19.152-1.032-26.875,7.258-6.463,8.525-5.689,13.313-13.563,5.822-0.53,11.309,5.469,16.687,5.469,2.554,7.587,17.274,14.294,26.625,12,5.859,5.187,17.008,8.07,29.219,3.906,6.93,6.067,15.959,8.6,26.594,3.906,2.823,2.824,8.783,5.069,15.656,3.657,0.522,0,3.473,7.541,10.969,10.187-3.268,3.176-1.259,16.966,2.093,21.906-2.288,5.302-3.008,10.958-1.062,16.438-7.559,4.86-9.098,8.475-5.719,16.688-9.899,15.906-21.741,17.724-32.875,12.812-4.002-2.522-7.998-5.071-12-7.594-4.261-4.175-8.52-8.325-12.781-12.5-2.17-2.037-6.66-2.677-7.594,1.813,0,0-16.399-3.658-17.719,10.187,6.798-6.62,16.438-0.792,16.438-0.531s-2.296,1.823-0.531,4.469c0.397-0.331,11.973,4.32,22.281,8.75,5.6,2.122,6.831,2.786,9.281,4.094-2.685-1.23-5.858-2.623-9.281-4.094-6.275-2.379-12.388-4.279-14.188-3.813-5.84-0.545-12.034-1.27-14.874,3.125-6.278,2.656-16.084,4.783-15.657,16.438,4.239-6.94,10.055-6.647,17.469-6-0.174,0.522-0.326,1.04-0.5,1.562,8.05,3.667,6.523-0.998,14.031-1.687,6.277-0.576,15.174,1.672,19.875,3.25-5.913,1.739-13.954,1.009-17.75,5.219-0.696,1.392-3.131,0.823-2.062,4.156,0,0-11.534-0.298-14.625,15.656,11.728-7.509,20.615-7.281,20.875-7.281,0.261,0,3.656,0.781,3.656,0.781s14.084-9.406,14.344-9.406c0.262,0,13.638-5.923,19.812,0.781,5.389,2.649,11.153,2.818,16.719-0.531,10.966-4.77,21.231-5.104,31.313,1.594l9.124,5.468c1.304-0.869,2.603-1.755,3.907-2.625,0,0,10.329-2.917,17.906,6.281-3.132-15.914-14.5-16.437-14.5-16.437-0.87-0.783-1.756-1.561-2.625-2.344-5.392-2.087-10.764-4.194-16.156-6.281-2.354-5.826-8.268-10.465-2.375-17.469,6.02-29.926,13.218-52.401,1.562-82.719,10.871,4.696,19.005,19.217,32.625,14.094,0-12.176-44.822-35.294-79.062-53.875,56.094-2.87,123.51-44.277,97.594-96.906,4.088-12.697,8.162-25.397,12.25-38.094,5.77,11.623,17.453,20.483,27.937,24.25-8.641-16.496-13.6-66.93-8.625-101.75-22.603,27.922-47.563,52.7018-74.094,77.8748,13.05,3.05,24.453,0.904,37.063-0.656-3.566,7.305-7.029,14.632-10.594,21.938-34.473-20.188-74.947-5.038-75.25,21.906,1.179,31.42,40.027,35.885,62.437,24.937-4.442,28.647-70.281,18.094-70.281,18.094-23.394-8.064-45.613-6.683-70.187-6.5,5.106-15.71,33.46-29.652,55.062-23.5-30.243-33.909,4.275-76.008,45.906-88.969-45.376-14.9658-6.304-49.5575,27.657-74.3435,0,0-97.663,41.1007-106.563,40.9687-27.779-2.0867-20.207-34.9672-9.625-52.6562zm-306.531,39.4688c2.273,0.0119,4.945,0.2339,7.062,0.75,4.404,1.073,9.763,1.6886,9.688,3-2.039,3.4124-7.047,7.5288-11.969,7.2812-4.921-0.2476-7.766-3.1984-9.406-10.5938,0.503-0.2725,2.352-0.4494,4.625-0.4374zm411.094,115.875c6.403-0.088,14.074,2.621,21.562,10.562-3.6,10.371-34.842,15.697-36.937,0.344-0.633-4.641,6.016-10.779,15.375-10.906z' fill='%23d21034'/%3E %3Cpath d='m 267.26,158.74l4.737,6.891 m -0.215,0.217 c 0,0 0,9.259 1.938,9.476 m -4.307,4.952 c 0.215,0.216 4.954,8.184 4.954,8.184 m -13.569,2.153 c 0.215,0 6.031,6.677 6.031,6.677 m 5.051,-5.18 c 0,0.215 5.501,10.565 5.932,10.565 m -13.136,-3.447 c 0,0 1.938,12.491 3.66,12.061 m -11.801,10.828 5.556,8.339 m 4.738,-17.229 c 0,0 3.015,11.845 5.383,10.767 m 2.364,-17.879 c 0.216,0.215 5.606,7.974 7.112,6.897 m -1.291,3.014 5.168,10.338 m -13.783,-2.37 c 0.215,0.432 4.307,12.277 4.307,12.277 m -14.214,-6.03 c 0,0 3.877,13.137 7.323,10.982 m -8.83,6.462 c 0,0 0.215,6.891 3.661,7.321 m 2.37,-10.767 c 0,0.215 3.445,4.954 3.445,4.954 m 6.398,-13.149 2.862,4.534 m 6.246,-12.921 4.308,5.383 m -24.293,-67.137 c 0.215,5.815 9.437,-2.048 13.098,-7.002 m -17.018,27.19 c 0,0 10.122,-7.107 17.875,-17.875 m -21.106,34.889 c 7.107,-1.938 20.183,-17.753 22.767,-26.152 m -24.275,41.873 c 1.94,0.861 26.367,-16.732 27.014,-29.653 m -27.659,43.221 c 0,-0.215 22.33,-5.693 31.591,-30.244 m -32.79,48.826 c 0,0 35.657,-21.381 37.595,-37.102 m 240.77,73.006 c 0,0 -2.299,18.453 -20.82,21.252 m 26.635,11.699 c 0.215,-0.216 17.659,-19.383 13.137,-25.198 m 27.351,6.676 c 0,0 -0.215,13.353 -11.199,22.613 m 32.95,-18.735 c 0,0 0.432,16.151 -6.46,22.612 m 26.488,-12.922 c 0,0 -7.727,15.126 -10.526,16.634 m 10.191,10.173 c 0,0 10.167,2.534 13.397,-4.143 m -10.761,26.084 c 0,0 9.399,1.697 13.706,-7.347 m -14.714,24.284 c 0,0 7.607,6.391 12.776,-2.007 m -121.95,-122.44 c 0,0 -0.862,32.735 45.225,39.41 51.472,14.215 75.807,6.677 78.823,64.394 -1.938,21.967 -4.668,46.778 -20.604,37.301 M 464.552,286.27 c 0,0 7.323,13.136 16.152,12.275 11.629,-3.446 15.936,3.661 15.936,3.661 m -63.53,-2.8 c 0,0 19.383,9.476 35.964,-5.815 m -33.811,-7.753 c 1.722,22.613 -26.059,35.535 -37.043,33.382 m 38.36,53.27 c 0.216,0 15.05,-8.905 12.036,-15.152 m -41.566,1.94 c 0.431,-0.432 24.982,-2.801 29.505,-11.631 m -40.919,-24.552 c 0,-0.215 34.845,0.097 37.213,6.557 m 9.09,-27.231 c 0,0 -34.028,58.148 28.858,58.148 m -64.824,-59.01 c 0,0 -7.323,21.753 -17.66,29.074 m -18.52,-36.61 c 0,0 12.636,24.449 -0.071,36.509 m -32.879,-29.618 c 0.215,0.43 4.091,34.673 -4.524,44.364 m -11.843,-43.287 c 0,0 1.291,21.751 -5.169,29.504 -6.462,7.753 1.513,23.856 1.513,23.856 m -78.5,10.457 c 0,0 4.624,8.114 11.086,5.313 m -3.231,-23.042 c 0,0 10.337,4.522 13.783,2.799 m -2.584,-39.411 c 0,0 -15.291,4.307 -9.476,22.397 8.829,7.108 17.444,6.03 17.444,6.03 m -38.119,48.456 c -0.215,0 1.723,14.215 11.63,3.446 6.891,-14.428 28.643,-55.132 33.597,-69.131 m 10.121,-6.675 c 0,0 -10.553,-8.184 -10.121,3.23 -0.217,7.106 3.229,8.829 3.229,8.829 0.43,5.169 4.954,12.49 8.614,5.815 1.508,-6.461 -1.076,-9.261 -1.076,-9.261 m 6.03,-11.63 c -9.476,-0.646 -14.644,20.245 3.662,7.11 m 6.245,-14.216 c 0,0 -2.368,3.232 -6.03,-0.215 -1.939,-3.445 -8.829,15.507 3.231,16.152 2.153,-5.6 8.83,-7.107 8.83,-7.107 m 5.6,-17.875 c 0,0 -5.385,2.584 -7.323,2.153 -6.461,1.508 -5.17,16.584 3.014,15.722 2.799,-3.23 5.815,-7.753 5.815,-7.753 m -52.29,-29.83 c -0.216,0 -21.372,33.268 11.794,42.098 m 256.71,-92.175 c 0,0 -12.922,10.984 -0.862,28.643 -40.058,-0.645 -61.592,17.875 -63.315,30.365 -51.041,-3.66 -41.78,11.416 -58.364,16.368 -22.182,-18.521 -54.702,-8.183 -52.548,10.337 -14.861,-20.89 -37.688,-10.767 -40.487,-5.599 -2.8,5.169 -1.723,-25.628 -1.723,-25.628 0,0 -14.86,6.677 -25.199,18.952 0.217,-8.183 0,-21.536 0,-25.843 -12.418,2.512 -24.407,2.654 -37.257,2.369 m -33.596,-9.476 c 0,0 18.52,10.337 41.349,-3.661 m -42.857,-33.596 c 0,0 14.43,12.92 41.566,8.829 m -32.52,-38.55 c 0,0 3.229,10.553 34.243,11.199 m -23.74,-35.604 c 0,0 11.679,14.283 27.4,12.13 m -17.443,-32.52 c 0,0 4.522,7.753 21.751,9.045 m -11.631,-31.658 c 0,0 9.046,9.907 19.384,8.184 m 34.431,-88.698 c 0,0 4.006,-4.0053 10.682,-2.0026 m -13.573,23.142 c 0,0 -12.463,-0.4451 -11.573,-5.3405 0.892,-5.563 13.13,-9.5684 13.13,-9.5684 0,0 16.243,-10.458 18.691,-14.019 m -73.432,56.966 15.8,30.263 7.565,-11.349 4.006,7.788 6.453,-11.348 11.126,7.12 -4.228,-13.796 9.345,-0.667 c 0,0 -2.448,-6.676 -10.904,-8.011 2.226,-1.7803 10.014,-6.8983 10.014,-6.8983 0,0 -4.449,-5.118 -11.348,-5.3406 2.225,-2.4476 5.34,-8.4558 5.118,-8.4558 -0.222,0 -6.899,-1.5576 -6.899,-1.5576 0,0 15.8,5.1179 28.038,-2.0027 m -30.25,-24.467 c 0.222,0.2225 -0.891,6.2305 -4.229,9.791 m -56.742,6.8981 c 0,0 9.7742,-2.6898 17.088,-1.165 7.245,1.4888 16.958,4.0578 16.958,4.0578 0,0 11.57,-1.5576 15.354,-4.2279 m -73.656,7.7882 c 0,0 -1.334,4.6728 -1.779,7.7883 0,2.2252 -7.122,5.1181 -7.122,5.1181 m 13.353,-22.475 c 0,0 6.23,7.7881 6.452,12.238 0.223,4.4505 -4.672,7.7885 -4.672,7.7885 m -66.089,33.156 -6.454,-10.458 5.786,-2.003 m 117.2,156.72 c -5.168,-6.676 3.876,-109.19 23.044,-135.89 -6.676,48.241 15.506,97.558 21.105,97.343 m -102.4,-125.99 c 0,0 8.722,3.3378 26.812,-10.984 m 24.443,34.676 12.975,0.161 m 389.49,-80.51 c 0,0 -216.19,101.02 -219.34,106.37 36.505,-11.016 191.33,-36.82 195.11,-34.617 -9.126,2.203 -197,45.315 -205.81,55.701 46.889,-1.574 145.08,15.105 160.49,31.154 -33.358,-7.552 -133.12,-22.343 -163.64,-15.735 22.344,5.351 107.94,60.737 107.94,69.548 -12.902,-12.272 -115.81,-54.757 -119.9,-50.665 23.6,14.161 56.96,66.714 56.958,79.617 -6.923,-11.014 -66.4,-74.898 -69.861,-70.807 6.294,8.813 18.766,84.222 12.39,87.717 0,-9.126 -23.09,-75.129 -24.978,-77.017 -4.721,1.258 -34.152,80.528 -28.321,87.899 -3.776,-26.433 0.628,-81.604 7.866,-79.402 -12.901,1.888 -54.078,56.18 -49.673,64.677 1.259,-13.532 3.1,-22.507 26.386,-67.509 -25.805,1.572 -79.302,35.246 -88.43,47.204 7.239,-21.398 52.555,-57.59 72.381,-60.107 m 93.316,-78.747 c 22.85,-12.68 93.46,-38.557 140.56,-57.543 m -184.91,125.78 c 0,0 15.576,-0.222 31.153,-42.501 15.35,-57.85 137.07,-122.38 139.52,-134.4 m -376.67,235.07 c 0,0 -3.615,7.703 -8.066,9.929 m 25.525,1.744 c 0,0 -4.829,9.382 -5.942,13.832 m 22.65,-9.243 c 0,0 4.052,12.803 0.714,18.812 m -47.239,-52.053 c -12.238,6.899 6.964,50.494 65.041,54.722 m -9.346,-23.587 c 0,0 -1.557,7.788 9.346,23.365 -3.115,17.356 13.195,30.996 19.649,33.221 m -33.67,-213.01 c 0,-0.223 1.78,-4.673 1.78,-4.673 l 1.9836,5.1444 3.1933,-0.0834 2.1072,-5.1575 1.7301,5.1769 3.1729,0 1.9573,-5.7483 2.9571,5.4428 2.5111,0.12743 1.9776,-6.6295 4.0772,4.7487 1.4806,-0.57339 1.2699,-6.6313 4.0277,4.6378 1.1554,-0.67754 1.8676,-6.5354 3.3459,4.8596 1.6845,-0.54918 1.5632,-5.4927 3.1098,5.0477 m -50.532,8.149 24.274,-0.361 c 7.723,-0.115 20.442,-10.819 34.684,-7.481 m -110.12,59.774 c 0,0 4.005,8.679 9.569,3.783 m -18.914,2.003 c 0,0 -7.789,20.917 1.557,25.811 m -12.684,-48.954 c 0,0 0,4.895 10.236,-2.67 m -42.073,112.59 c 0,0 8.2332,2.448 6.8982,8.679 m -3.788,-104.81 c 0,0 5.1179,2.448 10.014,-5.117 m 44.282,245.89 c 8.01,-0.445 9.735,3.172 17.023,3.172 8.396,0.256 16.577,-3.172 27.259,-6.065 m 68.758,19.36 c -0.223,0 -3.783,7.565 -0.667,11.347 m -113.49,-10.68 c 0,0 12.685,-10.459 19.36,-4.005 6.454,2.226 10.013,1.78 10.013,1.78 m -22.69,-27.59 c 0,0 3.115,8.01 -7.344,6.898 m -3.115,11.571 c 0,0 6.675,4.229 -0.89,9.791 m 4.895,7.566 c 0,0 9.123,1.336 3.782,8.678 m 290.91,-64.115 c 0,0 24.776,2.564 25.915,4.415 2.849,-2.991 24.972,-20.911 -2.225,-23.473 -4.555,18.654 -23.263,19.343 -23.69,19.058 z m -8.828,12.388 c 9.255,7.404 5.463,11.841 34.513,-7.666 m -47.756,16.923 c 0,0 13.669,14.667 23.637,-3.134 m -49.695,8.402 -18.511,9.682 m -33.321,13.671 c 0,0 11.249,-9.683 16.518,-4.557 5.268,5.126 27.624,-4.413 27.624,-4.413 m -35.741,-33.037 c 0,0 3.846,7.689 -3.56,8.686 m -11.106,15.379 c 0,0 3.901,7.23 -3.646,9.223 m 12.332,10.428 c 0,0 11.677,0.569 7.547,9.397 m 101.67,-10.964 c 0,0 -6.408,5.411 -1.708,11.535 m 94.691,-50.408 c 0,0 7.404,3.559 -1.424,9.683 m -7.404,12.815 c 0,0 5.553,5.839 1.851,10.679 m 13.67,11.676 c 0,0 7.688,2.136 6.835,8.544 m 100.81,-14.239 c 0,0 -6.408,4.698 -2.99,10.822 M 551.9922,243.2931 c 15.38,-1.851 37.449,32.323 48.698,39.016 m 67.272,-87.425 c 0,0 7.7898,6.7994 0.9361,23.205 m 13.505,-49.366 c 2.167,1.686 10.539,6.154 16.069,16.496 m 5.312,-67.659 c 0,0.142 -10.822,29.191 -10.822,29.191 m 22.925,-30.615 c 0,0 -2.136,25.915 -5.268,31.184 m -42.957,47.223 c -3.6,10.371 -34.84,15.678 -36.935,0.32544 -1.0657,-7.8158 18.503,-19.872 36.935,-0.32544 z' fill='none' stroke-linejoin='round'/%3E %3Cpath d='m 234.76,68.178 12.02,2.225 c 0,0 -8.46,11.349 -12.02,-2.225 z' fill='%23000' stroke-linejoin='round'/%3E %3C/g%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 60 30'%3E %3CclipPath id='t'%3E %3Cpath d='M30,15 h30 v15 z v15 h-30 z h-30 v-15 z v-15 h30 z'/%3E %3C/clipPath%3E %3Cpath d='M0,0 v30 h60 v-30 z' fill='%2300247d'/%3E %3Cpath d='M0,0 L60,30 M60,0 L0,30' stroke='%23fff' stroke-width='6'/%3E %3Cpath d='M0,0 L60,30 M60,0 L0,30' clip-path='url(%23t)' stroke='%23cf142b' stroke-width='4'/%3E %3Cpath d='M30,0 v30 M0,15 h60' stroke='%23fff' stroke-width='10'/%3E %3Cpath d='M30,0 v30 M0,15 h60' stroke='%23cf142b' stroke-width='6'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 500 300'%3E %3Cdefs%3E %3Cg id='s'%3E %3Cg id='c'%3E %3Cpath id='t' d='M 0,-1 v 1 h .5' transform='rotate(18 0,-1)' fill='%23fcd116'/%3E %3Cuse xlink:href='%23t' transform='scale(-1,1)'/%3E %3C/g%3E %3Cuse xlink:href='%23c' transform='rotate(72)'/%3E %3Cuse xlink:href='%23c' transform='rotate(144)'/%3E %3Cuse xlink:href='%23c' transform='rotate(216)'/%3E %3Cuse xlink:href='%23c' transform='rotate(288)'/%3E %3C/g%3E %3C/defs%3E %3Crect width='500' height='300' fill='%23ce1126'/%3E %3Crect x='42' y='42' width='416' height='216' fill='%23007a5e'/%3E %3Cpath d='M 42,42 h 416 l -416,216 h 416 z' fill='%23fcd116'/%3E %3Ccircle cx='250' cy='150' r='36' fill='%23ce1126'/%3E %3Cuse xlink:href='%23s' transform='translate(250,150) scale(33)'/%3E %3Cuse xlink:href='%23s2' x='-100'/%3E %3Cuse id='s2' xlink:href='%23s' transform='translate(250,21) scale(19.5)'/%3E %3Cuse xlink:href='%23s2' x='100'/%3E %3Cuse xlink:href='%23s2' x='-100' y='258'/%3E %3Cuse xlink:href='%23s2' y='258'/%3E %3Cuse xlink:href='%23s2' x='100' y='258'/%3E %3Cpath d='M 67.749,150.41 c 4.504,8.39 13.265,17.52 20.916,20.73 c .123,-8.52 -2.9,-19.44 -7.034,-28.14 l -13.882,7.41 z' fill='%23ce1126'/%3E %3Cpath d='M 60.112,121.63 c 6.529,13.61 -16.933,46.08 22.156,53.69 c -4.822,-6.58 -7.931,-17.44 -6.755,-26.16 c 8.201,3.12 16.83,12.25 20.317,19.23 c 10.23,-37.15 -26.24,-34.89 -35.718,-46.76 z' fill='%23fcd116'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 300 200'%3E %3Cdefs%3E %3Cg id='smallcross'%3E %3CclipPath id='vclip'%3E %3Cpath d='M-109,104 a104,104 0 0,0 0,-208 H109 a104,104 0 0,0 0,208 z'/%3E %3C/clipPath%3E %3Cpath id='varm' d='M-55,74 a55,55 0 0,1 110,0 V-74 a55,55 0 0,1 -110,0 z' clip-path='url(%23vclip)'/%3E %3Cuse xlink:href='%23varm' transform='rotate(90)'/%3E %3C/g%3E %3C/defs%3E %3Crect width='300' height='200' style='fill:%23fff'/%3E %3Cpath d='m 130,0 0,80 -130,0 L 0,120 l 130,0 0,80 40,0 0,-80 130,0 0,-40 -130,0 L 170,0 130,0 z' style='fill:%23ff0000'/%3E %3Cuse xlink:href='%23smallcross' transform='translate(64.45,39.45)' fill='%23f00'/%3E %3Cuse xlink:href='%23smallcross' transform='translate(235.55,160.55)' fill='%23f00'/%3E %3Cuse xlink:href='%23smallcross' transform='translate(235.55,39.45)' fill='%23f00'/%3E %3Cuse xlink:href='%23smallcross' transform='translate(64.45,160.55)' fill='%23f00'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 3 2'%3E %3Crect width='3' height='2' fill='%23ED2939'/%3E %3Crect width='2' height='2' fill='%23fff'/%3E %3Crect width='1' height='2' fill='%23002395'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='-18 -12 36 24'%3E %3Crect x='-18' y='-12' width='36' height='24' fill='white'/%3E %3Cpath d='M 0,-12 v 24 M -18,0 h 36' stroke='%23e8112d' stroke-width='6' fill='none'/%3E %3Cpath id='arm' d='M -9,2 l 1,-1 h 9 v -2 h -9 l -1,-1 z' fill='%23f9dd16'/%3E %3Cuse xlink:href='%23arm' transform='rotate(90)'/%3E %3Cuse xlink:href='%23arm' transform='rotate(-90)'/%3E %3Cuse xlink:href='%23arm' transform='rotate(180)'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 450 300'%3E %3Crect width='450' height='300' fill='%23006b3f'/%3E %3Crect width='450' height='200' fill='%23fcd116'/%3E %3Crect width='450' height='100' fill='%23ce1126'/%3E %3Cpath d='M225,100 257.492,200 172.427,138.197H277.573L192.508,200z' fill='%23000'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 512 256'%3E %3Crect fill='%23da000c' width='512' height='256'/%3E %3Crect fill='%23fff' width='512' height='171.5'/%3E %3Cg stroke='%23000'%3E %3Cg id='castle_half' fill='%23da000c' stroke-linecap='square'%3E %3Crect fill='%23000' stroke='none' width='64' height='43.992859' x='196.57106' y='116.30338'/%3E %3Cpath d='M229.81889,153.86465H190.75L182.08989,159.56444V165.60411H229.81889'/%3E %3Cpath d='M213.46875,128.59375C219.09357,128.59375 223.6875,133.28303 223.6875,139.0625V153.84375H231.03125V97.84375H190.75V153.84375H203.25V139.0625C203.24999,133.50878 207.76491,128.59375 213.46875,128.59375z'/%3E %3Crect fill='%23000' stroke='none' width='18.523308' height='33.9594' x='204.5282' y='59.961655'/%3E %3Cpath d='M223,88.65625H206.79108V82.90625H194.90625V88.65625H186.84375V82.90625H182.03125V93.34375H223M186.84375,93.306038H221.81414V97.843752H186.84375z'/%3E %3Cpath d='M200.71875,47.625V82.90625H206.79108V73.21875C206.79108,69.589448 209.35314,66.619386 212.9375,66.4375C213.05312,66.431633 213.16418,66.4375 213.28125,66.4375C217.02763,66.437497 220.0625,69.472374 220.0625,73.21875V82.90625H225.84375V47.625z'/%3E %3Cpath d='M198.53125,42.84375V47.625H227.78125V42.84375z'/%3E %3Cpath d='M194.78125,33.6875V42.84375H229.875V33.6875H224.46875V38.34375H217.9375V33.6875H207.96875V38.34375H201.4375V33.6875z'/%3E %3Cpath d='M182.08989,159.56444H230'/%3E %3Cpath d='M261,156.8125H228.5625L218.78125,161.53125V168.5625H261'/%3E %3Cpath stroke-linecap='butt' d='M218.771,161.51923H262'/%3E %3C/g%3E %3Cuse xlink:href='%23castle_half' transform='matrix(-1,0,0,1,512,0)'/%3E %3Cg fill='%23f8d80e'%3E %3Cg stroke-linecap='round'%3E %3Cpath stroke-width='0.768' d='m273.297,150.031c-2.65428,0.88339-5.05329,2.369-7.46888,3.75283-3.1004,1.83163-6.10683,3.82731-8.90451,6.09885-0.98462,0.64912-1.92929,1.36065-2.68911,2.27332-1.02583,0.8776-2.06486,2.05478-1.86885,3.51297,0.0518,0.64315,0.87359-0.75523,1.41401-0.82297,0.94235-0.54095,2.0838-0.7154,3.14219-0.4713,1.27117-1.33857,2.90994-2.23563,4.3249-3.40609,3.00467-2.24222,6.23664-4.16769,9.52502-5.96082,1.1481-0.58838,2.30104-1.18568,3.52508-1.60184-0.33328-1.12498-0.66657-2.24997-0.99985-3.37495z'/%3E %3Cpath d='M260.40041,157.3913V161.3032'/%3E %3Cpath d='M262.81691,155.68544V159.56821'/%3E %3Cpath d='M265.23339,154.17984V158.03797'/%3E %3Cpath d='M267.64986,152.69367V156.67498'/%3E %3Cpath stroke-width='0.768' d='m238.891,150.156c-0.39583,1.10417-0.79167,2.20833-1.1875,3.3125,5.53699,2.10036,10.8089,4.87874,15.7978,8.06036,1.69067,1.15075,3.46718,2.26632,4.79593,3.84589,0.2927,0.81098-0.51392,1.48903-1.31413,1.24403-0.73225-0.24871-1.45351-0.53169-2.22629-0.004-1.10637,0.50311-2.10598,2.1416-0.42575,2.69112,2.31528,1.55489,6.08158,0.87915,7.19454-1.84522,0.58146-1.40134,0.61878-3.19523-0.50753-4.34456-2.06261-2.36404-4.79728-4.00804-7.4215-5.67182-4.68917-2.82023-9.57283-5.37389-14.7055-7.28801z'/%3E %3Cpath d='M254.04985,158.03521 253.73747,161.37469'/%3E %3Cpath d='M256.8319,159.73914 255.96991,163.00882'/%3E %3Cpath d='M259.80442,162.01152 257.99552,164.54884'/%3E %3Cpath d='M260.71528,168.18078 258.10512,166.78032'/%3E %3Cpath d='M261.52792,165.42898 258.53251,165.70943'/%3E %3Cpath d='M257.66497,169.7646 257.45987,167.13228'/%3E %3Cpath d='M256.56809,166.75559 254.09509,168.57779'/%3E %3Cpath d='M244.67669,152.9368V156.05184'/%3E %3Cpath d='M250.96338,156.24386V159.77805'/%3E %3Cpath d='M247.82004,154.59318V157.9121'/%3E %3C/g%3E %3Cpath d='M235.78125,227.5625V235.59375H240.8125V231.5625H247.65625V235.59375H253.0625V227.5625zM235.78125,238.625V246.6875H253.0625V238.625H247.65625V242.65625H240.8125V238.625z'/%3E %3Crect width='4.9902272' height='58.115017' x='253.05186' y='193.65144'/%3E %3Crect width='4.9902272' height='50.060368' x='253.05186' y='198.6788'/%3E %3Cpath stroke-width='1.024' d='M255.54688,179.40625 266.17188,185.59375 255.54688,191.75 244.92188,185.59375zM241.32813,183.375H238.54688V187.8125H241.32813L255.54688,196.0625 269.76563,187.8125H272.54688V183.375H269.76563L255.54688,175.125z'/%3E %3Cpath stroke-width='1.024' d='m255.344,164.281c-2.41872,0.33922-4.22593,2.73018-4.09375,5.13412,0.009,3.73773-0.0185,7.47634,0.0141,11.2135,0.12824,2.40829,2.23219,4.56615,4.6744,4.58823,1.98493,0.18804,3.97892-0.97232,4.81154-2.77961-0.57292-0.34375-1.14583-0.6875-1.71875-1.03125-0.44378,1.18388-1.72345,1.91762-2.96875,1.78125-1.63507,0.046-2.95917-1.54398-2.8125-3.13412,0.01-3.71344-0.0192-7.42801,0.0146-11.1407,0.0899-1.5151,1.53488-2.75487,3.04795-2.60016,0.6265-0.17973,1.48748,0.67715,1.8747-0.0623,0.5838-0.82944-0.41442-1.47737-0.96875-1.9374-0.61348-0.0841-1.25418-0.008-1.8747-0.0316zm5.78125,3.90625c-0.39638,0.7459-1.21626,1.18923-1.875,1.58041v7.51334c0.66667,0.38542,1.33333,0.77083,2,1.15625-0.008-3.20377,0.0153-6.40813-0.0117-9.61152-0.0315-0.19722-0.008-0.4984-0.11328-0.63848z'/%3E %3C/g%3E %3Cg fill='%23da000c'%3E %3Crect fill='%23000' stroke='none' width='29.328571' height='53.254513' x='240.80301' y='38.351128'/%3E %3Cpath d='M238.75,38.375V82.9375H248.0625V69.71875C248.0625,66.669822 250.01501,62.4375 256,62.4375C261.98499,62.4375 263.9375,66.669822 263.9375,69.71875V82.9375H273.25V38.375zM254.5625,43.375H257.4375V58.625H254.5625zM246.3125,46.375H249.21875V57.53125H246.3125zM262.78125,46.375H265.6875V57.53125H262.78125z'/%3E %3Cpath d='M235.59375,31.96875V38.3125H276.40625V31.96875z'/%3E %3Cpath d='M231.75,24.59375V31.96875H280.25V24.59375H274.15625V28.65625H267.28125V24.59375H259.4375V28.65625H252.5625V24.59375H244.71875V28.65625H237.84375V24.59375z'/%3E %3Cpath d='M222.75,97.84375V102.4375H289.25V97.84375z'/%3E %3Cpath d='M220.03125,82.90625V97.84375H291.96875V82.90625H285.15625V88.65625H276.09375V82.90625H263.9375V88.65625H248.0625V82.90625H235.90625V88.65625H226.84375V82.90625z'/%3E %3Cpath stroke-linejoin='round' d='M228.6875,102.4375V156.78125H241.53125V136.4375C241.53125,126.85477 247.92755,122.34375 256,122.34375C263.75894,122.34375 270.46875,126.85477 270.46875,136.4375V156.78125H283.3125V102.4375z'/%3E %3C/g%3E %3C/g%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 18 12'%3E %3Crect width='18' height='12' fill='%23fff'/%3E %3Cpath fill='%23d00c33' d='m0,6h18v6H0zm3,0a4,4 0 0,0 8,0a4,4 0 0,0-8,0'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 27 18'%3E %3Ctitle%3EFlag of The Gambia%3C/title%3E %3Cpath d='m0,0h27v18H0' fill='%233A7728'/%3E %3Cpath d='m0,0h27v11H0' fill='%230C1C8C'/%3E %3Cpath d='m0,0h27v6H0' fill='%23CE1126'/%3E %3Cpath d='m0,6.5h27m0,5H0' stroke='%23FFF'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 3 2'%3E %3Crect width='1' height='2' fill='%23ce1126'/%3E %3Crect width='1' height='2' x='1' fill='%23fcd116'/%3E %3Crect width='1' height='2' x='2' fill='%23009460'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 900 600'%3E %3Crect width='900' height='600' fill='%23ED2939'/%3E %3Crect width='600' height='600' fill='%23fff'/%3E %3Crect width='300' height='600' fill='%23002395'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 3600 2400'%3E %3Ctitle%3EFlag of Equatorial Guinea%3C/title%3E %3Crect width='3600' height='2400' fill='%23e32118'/%3E %3Crect width='3600' height='1600' fill='%23fff'/%3E %3Crect width='3600' height='800' fill='%233e9a00'/%3E %3Cpath d='M0,0V2400L900,1200z' fill='%230073ce'/%3E %3Cg stroke='%23000'%3E %3Cg id='shield'%3E %3Cpath fill='%23fff' stroke-width='4.8' d='M1608,958.8H1991V1360C1991,1495 1815,1391 1800,1463C1774,1389 1609,1496 1609,1352C1609,1212 1608,958.8 1608,958.8z'/%3E %3Cpath fill='%2373452b' d='M1827,1399C1827,1399 1822,1404 1813,1400C1804,1396 1803,1143 1803,1143C1823,1121 1839,1114 1839,1114C1839,1114 1851,1124 1851,1124C1806,1147 1810,1180 1814,1237C1815,1258 1815,1285 1820,1311C1827,1344 1841,1372 1842,1393C1843,1406 1827,1399 1827,1399z'/%3E %3Cpath fill='%2373452b' d='M1796,1108H1814C1799,1253 1812,1339 1812,1381C1812,1395 1820,1400 1819,1400C1801,1420 1792,1399 1792,1399z'/%3E %3Cpath fill='%23a36629' d='M1768,1399C1751,1407 1749,1391 1750,1389C1787,1314 1803,1149 1769,1131C1769,1131 1771,1115 1771,1115C1784,1119 1796,1136 1796,1136C1801,1321 1796,1397 1793,1400C1775,1419 1768,1397 1767,1395'/%3E %3Cpath fill='none' d='M1767,1396C1764,1380 1793,1339 1791,1296'/%3E %3Cpath fill='none' d='M1816,1331C1825,1356 1829,1378 1827,1399'/%3E %3Cpath fill='%23009a3b' d='M1855,1040C1861,1033 1861,1033 1872,1033C1874,1018 1899,1018 1901,1037C1921,1033 1925,1045 1917,1057C1936,1052 1953,1057 1948,1079C1982,1088 1969,1112 1954,1117C1952,1132 1938,1137 1919,1131C1895,1148 1881,1142 1870,1125C1843,1129 1841,1123 1829,1108C1808,1117 1804,1117 1786,1106C1785,1120 1780,1116 1771,1115C1772,1133 1765,1141 1749,1135C1761,1160 1730,1171 1715,1150C1701,1151 1700,1147 1693,1142C1687,1162 1665,1159 1661,1148C1633,1144 1636,1129 1659,1128C1661,1112 1675,1115 1684,1117C1685,1107 1691,1109 1696,1111C1693,1104 1695,1100 1704,1098C1691,1081 1699,1075 1712,1069C1705,1053 1717,1054 1726,1053C1725,1036 1730,1033 1748,1031C1746,1025 1749,1020 1759,1020C1753,1003 1761,999.1 1779,1002C1782,977.3 1835,989 1831,1023C1846,1025 1851,1028 1855,1040z'/%3E %3Cg fill='none' stroke='%23000'%3E %3Cpath d='M1748,1031C1752,1033 1757,1031 1758,1042C1766,1028 1776,1036 1776,1052'/%3E %3Cpath d='M1831,1023C1827,1029 1812,1029 1814,1045C1809,1038 1799,1036 1795,1043'/%3E %3Cpath d='M1855,1040C1855,1044 1854,1056 1850,1062'/%3E %3Cpath d='M1917,1057C1918,1058 1903,1057 1896,1062'/%3E %3Cpath d='M1954,1117C1950,1115 1942,1110 1936,1118C1936,1114 1936,1103 1925,1103'/%3E %3Cpath d='M1919,1131C1919,1121 1917,1118 1915,1115'/%3E %3Cpath d='M1886,1117C1878,1111 1870,1120 1870,1125'/%3E %3Cpath d='M1828,1108C1828,1104 1825,1096 1832,1093'/%3E %3Cpath d='M1714,1150C1716,1140 1723,1140 1722,1135C1721,1127 1712,1120 1701,1131'/%3E %3Cpath d='M1722,1135C1728,1133 1734,1134 1736,1137'/%3E %3Cpath d='M1705,1098C1709,1094 1719,1095 1725,1098'/%3E %3Cpath d='M1725,1074C1730,1074 1739,1072 1742,1081C1753,1064 1761,1066 1763,1070'/%3E %3Cpath d='M1783,1068C1791,1065 1805,1073 1813,1087C1817,1076 1823,1078 1829,1077'/%3E %3Cpath d='M1867,1087C1880,1081 1888,1093 1892,1098C1898,1090 1903,1090 1909,1090'/%3E %3Cpath d='M1746,1111C1749,1106 1756,1105 1761,1108C1760,1099 1766,1095 1770,1097'/%3E %3C/g%3E %3C/g%3E %3Cg id='stars' fill='%23ffd700' stroke-width='3.5'%3E %3Cpath d='M1787,902.6 1765,903.6 1754,923.3 1742,904.5 1720,905.4 1730,885.6 1718,866.8 1741,865.8 1751,846.1 1763,864.9 1785,864 1775,883.8z'/%3E %3Cpath d='M1693,909.9 1671,915.3 1665,936.6 1649,920.6 1628,925.8 1634,904.5 1619,888.3 1640,883 1646,861.6 1662,877.6 1684,872.4 1677,893.8z'/%3E %3Cpath d='M1602,928.6 1582,938.5 1581,960.7 1562,948.5 1542,958.3 1544,936.1 1525,923.8 1545,913.8 1547,891.6 1565,903.8 1585,894 1584,916.2z'/%3E %3Cpath d='M1816,902.6 1838,903.6 1848,923.3 1860,904.5 1882,905.4 1872,885.6 1884,866.8 1862,865.8 1851,846.1 1839,864.9 1817,864 1827,883.8z'/%3E %3Cpath d='M1910,909.9 1931,915.3 1937,936.6 1953,920.6 1974,925.8 1968,904.5 1984,888.3 1962,883 1956,861.6 1940,877.6 1919,872.4 1925,893.8z'/%3E %3Cpath d='M2000,928.6 2020,938.5 2021,960.7 2040,948.5 2060,958.3 2059,936.1 2077,923.8 2057,913.8 2056,891.6 2037,903.8 2017,894 2019,916.2z'/%3E %3C/g%3E %3Cg id='motto'%3E %3Cg fill='%23fff' stroke-width='3.5'%3E %3Cpath d='M2027,1352 2052,1388 2075,1354 2059,1325z'/%3E %3Cpath d='M1868,1457 1870,1493C1870,1493 1880,1493 1889,1490C1897,1487 1904,1481 1904,1481L1903,1462z'/%3E %3Cpath d='M1734,1457 1732,1492C1732,1492 1723,1492 1714,1490C1706,1488 1699,1483 1699,1483L1689,1459z'/%3E %3Cpath d='M1573,1352 1547,1388 1519,1342 1540,1320z'/%3E %3Cpath d='M1698,1529C1698,1563 1904,1563 1904,1529V1481C1904,1506 1698,1501 1698,1481z'/%3E %3Cpath d='M1514,1418C1532,1510 1698,1512 1698,1512C1698,1512 1698,1481 1698,1481C1694,1469 1701,1465 1728,1461C1739,1460 1734,1444 1734,1444C1734,1444 1662,1457 1611,1437C1542,1409 1532,1355 1532,1355C1532,1355 1527,1397 1514,1418z'/%3E %3Cpath d='M2087,1418C2070,1510 1904,1512 1904,1512C1904,1512 1904,1481 1904,1481C1907,1469 1900,1465 1873,1461C1862,1460 1868,1444 1868,1444C1868,1444 1940,1457 1991,1437C2059,1409 2067,1355 2067,1355C2067,1355 2074,1397 2087,1418z'/%3E %3Cpath d='M1527,1383C1481,1358 1517,1332 1521,1258C1528,1303 1579,1322 1573,1351C1552,1352 1542,1320 1532,1355C1532,1355 1527,1383 1527,1383z'/%3E %3Cpath d='M2074,1383C2120,1357 2082,1332 2078,1258C2071,1303 2021,1322 2027,1351C2047,1352 2057,1320 2067,1355C2067,1355 2074,1382 2074,1382z'/%3E %3C/g%3E %3Cg fill='%23000' stroke='none'%3E %3Cpath d='m1555,1417,5,4-11,12c-4.4031,4.8033-5.4674,7.9808-2.4093,10.905,3.7958,3.6295,6.4648,2.3682,10.409-1.905l12-13,4,4-11.989,13.989c-6.5084,7.5942-12.55,5.8563-17.618,1.1231-4.4158-4.1237-6.9466-10.102-0.4536-17.454l12.1-13.6z'/%3E %3Cpath d='m1575,1434,5,3-1,24,11-17,5,3-16,26-6-3,1-24-11,17-5-3z'/%3E %3Cpath d='m1584,1476,14-28,5,3-13,27z'/%3E %3Cpath d='m1606,1452-11.04,28.98,11.04,4.02c10.29,3.75,15.12-0.78,18.39-9.48,3.3-8.85,1.86-15.36-8.43-19.5l-9.96-4.02zm3.96,7.02c10.35,3.6,10.98,7.53,8.16,14.64-2.73,6.75-5.28,9.39-15.12,4.32l6.96-18.96z'/%3E %3Cpath d='m1639,1463-18,27,6.96,2.04,4.02-7.02,12,3,1.02,7.02,6.96,0.96-6.96-31.98-6-1.02zm1.98,7.02,1.98,12-7.98-1.02,6-10.98z'/%3E %3Cpath d='m1656.1,1465.6-1.0838,30.99,11.772,0.2309c10.941,0.2072,14.051-5.6204,14.318-14.91,0.2713-9.4506-3.2083-15.154-14.298-15.716l-10.708-0.5955zm6.0026,5.3771c10.964,0.044,12.838,3.5434,12.453,11.195-0.3657,7.273-1.9548,10.588-12.884,8.9686l0.4302-20.164z'/%3E %3Cpath d='m1761,1509v31.98h7.02v-12s6,0.36,10.98-0.96c3.93-1.02,6.66-3.54,6.75-9.75,0.09-6.09-3.45-9.27-9.57-9.27h-15.2zm7.02,4.98,7.05,0.09c5.88,0,4.77,8.91,0.18,8.91h-7.23v-9z'/%3E %3Cpath d='m1797,1509-13.02,31.98h7.02l3-7.98h13.02l3,7.98h6.96l-13-32h-7zm3,7.02,4.98,12h-9l4.02-12z'/%3E %3Cpath d='m1817,1535,17-21-15,0,0-5,24,0,0,5-18,21,18,0,0,6-26,0z'/%3E %3Cpath d='m1918,1473,6-1,3,18c1.0669,6.4013-1.8581,10.764-6.4144,12.445-5.1887,1.9138-11.806,0.1639-12.586-8.4449l5-1c1.1649,5.1523,3.2378,5.5985,5.6366,4.791,1.9038-0.6409,2.8885-3.6406,2.3634-6.791z'/%3E %3Cpath d='m1928,1471.2,5.9209-1.1228,2.7393,14.979c1.1722,6.4098,3.1827,9.1354,7.3509,8.4077,5.1735-0.9034,5.741-3.8003,4.6402-9.5106l-3.6807-15.98,6.0571-0.9143,4.0192,16.623c2.3505,9.7215-2.7285,13.578-9.5455,14.851-5.9392,1.1094-12.253-0.3988-14.322-9.9873z'/%3E %3Cpath d='m1959,1485,5-2c2.4529,4.4051,6.2799,4.1782,9.2549,2.8632,4.133-1.8269,4.6059-5.4402,2.5625-6.6628-2.9146-1.7438-9.8689,0.7328-13.615-0.6341-4.482-1.6353-6.4062-4.1562-6.1771-8.0319,0.2759-4.6664,4.3807-7.231,8.8456-8.6157,4.996-1.5495,9.9262-1.0022,13.129,5.0813l-6,2c-1.9531-3.2866-4.4662-3.1313-6.6964-2.0777-1.8668,0.882-4.784,2.5382-3.222,5.2058,1.2767,2.1802,8.6258,0.7645,12.498,0.9228,4.0034,0.1636,7.2389,2.8362,7.7805,6.6867,0.7551,5.3683-1.2338,8.2764-7.4407,10.697-7.6662,2.9898-14.582-0.3597-15.919-5.4346z'/%3E %3Cpath d='m1986,1460-8,4-2-5,22-9,2,4-8,4,9,22-5,3z'/%3E %3Cpath d='m1999,1449,5-3,14,26-5,3z'/%3E %3Cpath d='m2033,1451,6-2c2.8215,5.9317-1.4152,16.715-11.775,16.493-15.164-0.3249-16.805-17.027-14.421-22.536,4.0051-9.252,15.224-9.0747,20.196-3.957l-5,4c-3.1698-4.0667-10.212-1.5041-10.688,2.2374-0.7756,6.1053,1.9122,11.788,7.371,14.483,4.6287,2.2846,11.761-3.4602,8.3165-8.7202z'/%3E %3Cpath d='m2030,1430,5-4,18,24-5,4z'/%3E %3Cpath d='m2049,1415-4.98,4.02,10.98,30,4.98-4.98-3-6,9-8.04,6,3,5.04-3.96-28.02-14.04zm1.98,7.02,10.02,4.98-6,6-4.02-10.98z'/%3E %3C/g%3E %3C/g%3E %3C/g%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 27 18'%3E %3Crect fill='%230D5EAF' width='27' height='18'/%3E %3Cpath fill='none' stroke-width='2' stroke='%23FFF' d='M5,0V11 M0,5H10 M10,3H27 M10,7H27 M0,11H27 M0,15H27'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 750 375'%3E %3Cdefs%3E %3ClinearGradient id='linearGradient795'%3E %3Cstop stop-color='%23d5dfff' offset='0'/%3E %3Cstop stop-color='%23FFF' offset='1'/%3E %3C/linearGradient%3E %3ClinearGradient id='linearGradient783'%3E %3Cstop stop-color='%23474747' offset='0'/%3E %3Cstop stop-color='%23f50' offset='1'/%3E %3C/linearGradient%3E %3ClinearGradient id='linearGradient746' y2='102.99' xlink:href='%23linearGradient783' gradientUnits='userSpaceOnUse' x2='228.97' gradientTransform='matrix(.74087 0 0 1.3286 40.513 .0061069)' y1='102.99' x1='215.83'/%3E %3ClinearGradient id='linearGradient747' y2='173.45' xlink:href='%23linearGradient783' gradientUnits='userSpaceOnUse' y1='218.47' gradientTransform='matrix(1.5101 0 0 .65184 40.513 .0061069)' x2='110.94' x1='109.34'/%3E %3ClinearGradient id='linearGradient748' y2='337.23' gradientUnits='userSpaceOnUse' y1='316.38' gradientTransform='matrix(1.2315 0 0 .79928 40.513 .0061069)' x2='126.02' x1='125.91'%3E %3Cstop stop-color='%23b50000' offset='0'/%3E %3Cstop stop-color='%23ffc500' offset='1'/%3E %3C/linearGradient%3E %3ClinearGradient id='linearGradient794' y2='1003.7' xlink:href='%23linearGradient795' gradientUnits='userSpaceOnUse' y1='1040.4' gradientTransform='matrix(2.5627 0 0 .38409 40.513 .0061069)' x2='78.221' x1='117.6'/%3E %3ClinearGradient id='linearGradient800' y2='226.38' xlink:href='%23linearGradient795' gradientUnits='userSpaceOnUse' y1='245.98' gradientTransform='matrix(.88634 0 0 1.1105 40.513 .0061069)' x2='255.03' x1='264.72'/%3E %3ClinearGradient id='linearGradient801' y2='147.35' xlink:href='%23linearGradient795' gradientUnits='userSpaceOnUse' y1='149.38' gradientTransform='matrix(.55904 0 0 1.7607 40.513 .0061069)' x2='456.4' x1='407.87'/%3E %3C/defs%3E %3Crect width='750' height='375' fill='%2300247d'/%3E %3Cg transform='matrix(.75595 0 0 .75595 0 -.000017730)'%3E %3Cg transform='matrix(8.2677 0 0 8.2677 0 .000022888)'%3E %3Cpath d='m0 0v3.3541l53.292 26.646h6.708v-3.354l-53.292-26.646h-6.708zm60 0v3.354l-53.292 26.646h-6.708v-3.354l53.292-26.646h6.708z' fill='%23FFF'/%3E %3Cpath d='m25 0v30h10v-30h-10zm-25 10v10h60v-10h-60z' fill='%23FFF'/%3E %3Cpath d='m0 12v6h60v-6h-60zm27-12v30h6v-30h-6z' fill='%23cf142b'/%3E %3Cpath d='m0 30l20-10h4.472l-20 10h-4.472zm0-30l20 10h-4.472l-15.528-7.7639v-2.2361zm35.528 10l20-10h4.472l-20 10h-4.472zm24.472 20l-20-10h4.472l15.528 7.764v2.236z' fill='%23cf142b'/%3E %3C/g%3E %3C/g%3E %3Cg transform='matrix(0.621 0 0 0.621 461.4 21.482)'%3E %3Cpath d='m146.97 393.04s-3.35 8.84-5.26 8.84-8.84-3.82-8.84-3.82-5.02 8.13-7.65 8.6c-2.63 0.48-9.56-1.19-9.56-1.19s-6.69 0-6.93-0.96c-0.24-0.95 0.24-2.86 0.24-2.86s-9.558 7.64-11.709 7.16c-2.151-0.47-9.32-9.55-9.32-9.55l-1.195 4.78-13.621-0.48-11.949-7.65s-6.691 10.99-6.93 10.75-11.709 2.63-11.709 2.63l-0.717-2.15-7.647-4.54s5.974-8.36 5.974-8.6-2.868-1.2-2.868-1.2l-4.301 3.59-8.842 5.73-8.842-4.06 3.824-7.17 0.478-5.26 6.93-10.51 84.834-82.45 41.82 77.19-6.21 23.18z' stroke='%23000' stroke-width='1pt' fill='%236a4c2d'/%3E %3Cpath d='m207.24 398.04l22.08-0.8-9.4-4.64 84.14-3.17-11.89-4.53-10.53-14.27-43.6-3.28s-3.28-2.49-8.61-1.25c-0.22-3.39-4.3-7.81-4.3-7.81l-26.84-2.04-16.76 11.44 11.32 28.99 14.39 1.36z' stroke='%23000' stroke-width='1pt' fill='%23FFF'/%3E %3Cpath d='m121.32 150.76l2.22-7.56s3.89-6.56 3.89-9.46c0-2.89 2.9-6.33 2.9-6.33s8.89-2.56 10.78 2.89c9.57-14.46 20.8-0.67 20.8-0.67l3.11-3.67 6.34-7.78s9.01 8.45 9.12 9.89c0.11 1.45 1.55 0.45 1.55 0.45l9.79-0.78s4.64 3.64 3.67 10.56c3.45 2.04 6.56 14.01 6.56 14.01l-80.73-1.55z' stroke='%23000' stroke-width='1pt' fill='url(%23linearGradient747)'/%3E %3Cpath d='m207.25 240.72c1.69-1.03 7.01-2.72 6.36-10.5s-7.39-8.69-11.15-8.43c-3.77 0.26-7.14 3.5-7.14 3.5l-12.45-7.91s6.23-39.3 12.84-41.76c6.28-4.53 7.39-6.49 7.39-7.52 0-1.04-2.33-3.64-2.33-3.64l-40.6-4.8-38.39 4.54s-2.98 4.54-2.59 6.36c0.39 1.81 0.52 3.76 7.39 9.08 7.61 5.85 12.84 39.43 12.84 39.43s-10.76 5.31-11.41 4.66c-0.65-0.64-3.89-1.29-5.58-1.03-1.68 0.26-7.26 3.11-7.26 10.5 0 7.4 5.58 11.68 5.58 11.68s36.7-4.28 42.15 5.83c5.32-12.19 40.2-7.91 44.35-9.99z' stroke='%23000' stroke-width='1pt' fill='%23656263'/%3E %3Cpath stroke-linejoin='round' d='m246.79 199.87s0.41-4.27 3.45-6.3c3.05-2.03 23.36-3.05 28.24 0 4.87 3.05 6.7 18.08 6.7 18.08s3.05 5.28 3.25 9.14 0.61 6.5 0.61 6.5 16.25 21.13 16.45 40.22c1.83 13 1.42 47.73-3.65 60.93-0.21 16.46-7.11 27.22-7.11 27.22s1.62 2.84 1.42 5.89c-0.21 3.05-1.83 5.89-1.83 5.89l23.76 11.78-8.73-3.25s8.94 7.52 8.73 7.32c-0.2-0.21-9.95-4.68-9.95-4.68l5.89 5.89c-0.2-0.2-14.42-6.5-14.42-6.5s6.7 6.3 6.3 6.1c-0.41-0.2-10.77-5.08-10.77-5.08s6.5 6.91 6.3 6.5-9.34-4.06-9.34-4.06l0.4 3.45s-7.31-0.41-7.31-5.89c-3.66-2.03-6.09-4.88-6.09-4.88l-16.86-2.84-19.1-57.08 4.47-96.48 1.22-4.87-2.03-13z' stroke-opacity='.97854' stroke='%23000' stroke-width='1.25'/%3E %3Cpath stroke-width='.99323pt' d='m234.03 508.2s-9.78-20.57-14.65-20.86c-4.4-8.39 15.29-76.96 53.38-80.87 20.94 1.72 1.72 24.14-12.05 17.24 1.72 6.03 8.6 14.66 8.6 14.66s-27.25 11.78-35.28 69.83z' stroke='%23000' fill='%23fb0'/%3E %3Cpath d='m102.91 511.2s8.1-23.42 13.01-23.71c4.92-0.29-13.01-78.05-52.032-78.63-21.104 1.74-1.735 24.28 12.141 17.34-1.734 6.08-8.672 14.75-8.672 14.75s27.463 11.85 35.553 70.25z' stroke='%23000' stroke-width='1pt' fill='%23fb0'/%3E %3Cpath d='m138.71 364.93c-0.1-0.19-9.69 3.01-3.48 13.45 0.47-4.04 4.79-6.49 4.79-6.49s-6.58 7.81 0.38 14.39c0.85-6.21 4.8-8.18 4.8-8.18s-4.89 14.39 0.09 17.3c0.57-5.74 4.23-8.27 4.23-8.27s-4.42 12.88-0.47 15.79c0.47-4.88 3.76-7.05 3.76-7.05s-1.97 13.36 3.2 14.3c0.1-4.71 3.86-9.31 3.86-9.31s-1.7 10.9 6.39 11.38c0.1-4.14 1.6-8.84 1.6-8.84s3.67 11.56 9.03 9.68c-0.09-3.38 0.09-9.78 0-9.78-0.1 0 3.38 11 9.78 8.94-0.94-3.11 0.37-6.78 0.37-6.78s3.39 6.87 9.5 4.61c1.04-2.07-0.28-6.11-0.28-6.11s8.93 9.22 11.66 3.67-7.15-7.43-7.15-7.43h6.68s-2.16-5.64-11.19-6.87c3.1-1.41 6.3-0.37 6.3-0.37s-1.88-7.06-11.1-7.81c3.58-1.22 7.53-0.37 7.53-0.37s-1.23-6.68-11.38-8.56c1.6-1.79 5.92-1.22 5.92-1.22s-4.04-6.3-8.65-5.93c-4.61 0.38-46.27-4.23-46.17-4.14z' stroke='%23000' stroke-width='1pt' fill='%2300713d'/%3E %3Cg stroke-width='1.25' stroke-linecap='round' stroke='%233ec26d' fill='none'%3E %3Cg%3E %3Cpath d='m179.8 398.88s3.67 1.79 3.58 3.39'/%3E %3Cpath d='m181.97 395.97s4.7 3.29 4.61 5.73'/%3E %3Cpath d='m186.1 394.27s3.77 2.35 3.95 6.02'/%3E %3Cpath d='m192.4 395.78s1.89 4.04 1.23 4.79'/%3E %3Cpath d='m196.17 397.94c0.28 3.2-0.29 3.48-0.29 3.48'/%3E %3C/g%3E %3Cpath d='m149.8 377.72s4.42 2.82 4.05 6.77'/%3E %3Cpath d='m149.52 381.11s2.07 1.97 1.6 3.29'/%3E %3Cpath d='m154.98 377.82s2.91 4.04 1.97 6.86'/%3E %3Cpath d='m159.96 380.45s1.32 2.54 0.1 3.95'/%3E %3Cpath d='m162.31 381.67s1.6 2.54 0.19 3.39'/%3E %3Cpath d='m160.53 390.04s4.13 0.94 4.7 4.04'/%3E %3Cpath d='m162.97 387.22s4.33 0.28 4.8 4.89'/%3E %3Cpath d='m168.71 385.62c0.09 0 2.91 4.99 2.44 6.58'/%3E %3Cpath d='m174.26 386.09s1.12 4.8 0.28 6.3'/%3E %3Cpath d='m177.83 387.97c0 0.1 0.09 5.55 0.09 5.55'/%3E %3Cpath d='m172.38 380.45s2.72 1.03 2.53 3.67'/%3E %3Cpath d='m174.91 378s3.48 1.98 3.11 5.74'/%3E %3Cpath d='m178.96 376.41s3.01 3.57 1.88 7.52'/%3E %3Cpath d='m184.22 377.25s-1.12 4.42-0.66 6.21'/%3E %3Cpath d='m187.42 380.26s-1.97 1.51-0.94 3.39'/%3E %3Cpath d='m170.31 397.47s0.65 3.39 0 3.95'/%3E %3Cpath d='m165.98 395.5s2.16 3.76 1.41 5.64'/%3E %3Cpath d='m161.37 395.31s2.45 2.82 2.35 5.08'/%3E %3Cpath d='m157.61 395.87s2.26 2.17 2.07 3.39'/%3E %3Cpath d='m155.64 399.16s2.16 2.26 2.06 2.73'/%3E %3C/g%3E %3Cpath d='m108.86 244.78c10.37-0.19 20.74-0.37 31.11-0.56 0 0 20.55 0 22.77 6.67 3.89-8.89 21.66-8.33 21.66-8.33 10.74-0.37 21.48-0.74 32.21-1.11 0.19 25.92 0.37 51.84 0.56 77.76-6.29 30.17-28.14 51.47-52.21 60.54-28.7-9.26-46.84-33.51-52.76-61.1-1.12-24.62-2.23-49.25-3.34-73.87z' stroke='%23000' stroke-width='1pt' fill='%23FFF'/%3E %3Cpath d='m119.94 244.49l45.31 120.74 40.93-123.37c-12.7 0.82-39.94-2-43.32 9.58-5.24-10.36-33.9-6.18-42.92-6.95z' stroke='%23000' stroke-width='1pt' fill='%23006b00'/%3E %3Cpath d='m150.78 309.86c1.75 0.91 1.7-32.77 3.99-33.81 0.65-2.79 0.98-4.01 1.8-6.97-1.97-3.49-10.79-3.32-14.06-0.35 1.47 4.7 2.12 6.27 2.12 6.27 4.42 7.15 3.54 35.62 6.15 34.86z' stroke='%23006b00' stroke-linecap='round' stroke-width='.68918' fill='%23ffc900'/%3E %3Cpath stroke-linejoin='round' d='m138.64 49.548s3.21-3.638 3.35-4.51c0.15-0.873 14.55-1.455 23.13-17.458 4.8-8.438 0-3.492 0-3.492l-0.29-4.074s5.97-5.673 3.79-8.729c-2.19-3.0546-1.46 3.929-4.95 3.783s-1.6-7.565-1.6-7.565-0.29-0.873-1.31-1.3094c-1.46 0.1455-1.02 2.7642-2.33 3.0551-1.31 0.291-2.47-6.1103-2.47-6.1103s-2.18-2.9096-4.08 6.2558c1.02 9.7478 7.28 7.8558 7.28 14.258 0 6.401-5.53 11.347-7.13 11.493-1.6 0.145-1.02-5.383-1.02-5.383s-0.87-2.619-1.45-2.619 3.2-0.582 2.62-7.856c-1.31-8.729-2.33 2.037-4.66 1.6-2.33-0.436-0.58-8.001 0.29-8.874s-1.02-4.51-6.11 4.801c-0.44 4.51-1.02-1.164-2.04-0.873-1.74 3.637-1.45 6.256 1.02 9.602 3.64 3.346 5.97 6.692 5.82 8.438-0.14 1.746-2.04 5.674-4.65 5.674-2.62 0 0.14-4.801 0-6.402-0.15-1.6-4.51-7.419-4.51-7.419s-3.06-4.947-2.77-5.092c0.29-0.146-0.29-0.873-1.74 4.219-1.46 5.092-3.21-3.346-3.21-3.346s-2.03 6.255 2.33 10.038c-3.34-0.436-3.63 0.873-3.63 0.873 0 1.746 4.51 2.473 5.09 5.528 0.58 3.056-4.66 4.801-4.66 4.801s2.19 3.055 8.29-2.909c0.15 3.782-2.32 6.401-2.32 6.401 2.03 0.921 3.63 0.824 3.92 3.201z' stroke='%23000' stroke-width='1.25' fill='%23cdad56'/%3E %3Cpath stroke-linejoin='round' d='m118.68 49.548s-2.72-4.037-2.84-4.832c-0.13-0.794-13.38 1.004-19.648-15.158-4.078-7.678 0-3.177 0-3.177l0.247-3.707s-4.339-5.308-2.486-8.088 1.09 3.574 3.474 3.587c2.963-0.132 1.359-6.884 1.359-6.884s0.246-0.794 1.112-1.191c1.232 0.132 1.742 4.115 2.852 4.38s3.41-4.687 4.13-5.7054c1.02-0.1457 0.98-4.1023 2.59 4.2374-0.86 8.87-8.21 7.149-8.21 12.974 0 5.824 4.69 10.325 6.05 10.458 1.36 0.132 0.87-4.898 0.87-4.898s0.74-2.383 1.23-2.383c0.5 0-4.32 0.925-3.82-5.694 1.11-6.197 3.57 0.399 5.55 0.001 1.98-0.397-0.23-6.553 0.34-7.493 0.13-0.94 3.04-4.977 4.17 3.932 0.37 4.104 2.61-3.532 3.47-3.267 1.49 3.309-0.65 7.729-2.75 10.774-3.09 3.044-4.49 6.38-4.36 7.969 0.12 1.588 0.85 3.562 3.08 3.562 2.22 0 0.75-2.768 0.87-4.224s3.83-6.17 3.83-6.17c0.73-1.163 0.12-3.337 0.89-4.342 1.21 0.013 1.71-1.667 2.94 2.966 1.24 4.633 2.72-3.045 2.72-3.045s1.73 5.693-1.98 9.135c2.84-0.397 3.09 0.794 3.09 0.794 0 1.589-1.35 2.25-1.85 5.03s1.48 4.369 1.48 4.369-1.85 2.78-7.04-2.648c-0.13 3.442 1.98 5.825 1.98 5.825-1.74 0.839-3.09 0.75-3.34 2.913z' stroke='%23000' stroke-width='1.0989' fill='%23cdad56'/%3E %3Cpath stroke-width='1pt' d='m198.62 262.5c-2.71-2.46-3.03-0.31-4.36-0.86-0.66-0.27-1.17-0.88-1.74-1.44-0.49-0.51-1.08-0.72-1.73-0.99-0.25 0.73-0.49 1.45-0.74 2.18s0.69 1.94 0.67 3.03c-0.19 1.62-0.85 2.97-2.89 3.52 0.58-1.15 0.91-1.2 0.73-2.61-0.08-0.7-2.05-1.95-1.81-2.61 0.36-1.07 0.98-2.3 0.52-3.37-0.83 0.57-1.93 0.27-2.76 0.62-0.71 0.31-0.75 1.62-1.73 2.16-1 0.47-3.21 0.24-5.06-0.81 1.13-0.85 2.06-0.28 3.19-1.13 0.56-0.43 0.54-2.26 1.1-2.69 0.57-0.43 1.92-0.88 2.48-1.31-0.51-0.58-0.48-1.49-0.99-2.07-0.5-0.58-2.75-0.46-3.26-1.03-1.02-1.16-0.82-2.68-1.84-3.83 2.63 0.94 2.25 2.22 2.91 2.12 1.24-0.6 2.48-0.71 3.13-0.44 0.66 0.28 1.9 1.9 2.55 2.17 0.25-0.73 0.61-1.65 0.85-2.38 0.25-0.73-1.1-1.99-0.86-2.72 0.5-1.45 1.72-2.74 2.21-4.2 0.18 1.41 0.41 2.59 0.59 3.99 0.09 0.7 1.47 1.07 1.56 1.77 0.09 0.71-0.72 2.33-0.64 3.04 0.76-0.15 1.85-0.05 2.6-0.2 0.76-0.15 1.26-1.9 2.01-2.05 1.51-0.3 2.6-0.21 4.13 0.08-1.13 1.05-2 0.98-2.71 1.94-0.56 0.43 0.22 1.84-1.41 2.83-0.61 0.36-2.22-0.07-2.79 0.36 0.51 0.58 1.02 1.15 1.53 1.73 0.5 0.58 2.78 0.85 3.29 1.43 1.01 1.15 1.55 2.53 1.27 3.77z' fill='%23ffc900'/%3E %3Cpath stroke-width='1pt' d='m128.95 263.69c2.71-2.46 3.03-0.31 4.37-0.86 0.65-0.28 1.16-0.89 1.73-1.44 0.49-0.51 1.08-0.72 1.73-1 0.25 0.73 0.5 1.46 0.74 2.19 0.25 0.73-0.68 1.93-0.66 3.02 0.18 1.63 0.84 2.97 2.88 3.53-0.58-1.15-0.91-1.21-0.73-2.61 0.09-0.7 2.05-1.95 1.81-2.62-0.36-1.06-0.98-2.3-0.52-3.37 0.84 0.58 1.93 0.28 2.77 0.62 0.7 0.32 0.75 1.63 1.72 2.17 1.01 0.47 3.22 0.24 5.06-0.81-1.13-0.86-2.06-0.28-3.19-1.14-0.56-0.42-0.53-2.26-1.1-2.68-0.56-0.43-1.91-0.89-2.48-1.32 0.51-0.57 0.48-1.49 0.99-2.07 0.51-0.57 2.76-0.45 3.26-1.03 1.02-1.15 0.83-2.67 1.84-3.83-2.63 0.94-2.24 2.22-2.9 2.13-1.25-0.6-2.49-0.72-3.14-0.44-0.65 0.27-1.9 1.89-2.55 2.17-0.25-0.73-0.6-1.65-0.85-2.38s1.11-1.99 0.86-2.72c-0.49-1.46-1.72-2.74-2.21-4.2-0.18 1.4-0.41 2.58-0.59 3.99-0.09 0.7-1.47 1.07-1.56 1.77-0.08 0.7 0.73 2.33 0.64 3.03-0.76-0.15-1.85-0.05-2.6-0.19-0.75-0.16-1.25-1.91-2.01-2.06-1.51-0.3-2.59-0.21-4.13 0.08 1.13 1.06 2 0.98 2.71 1.95 0.56 0.43-0.22 1.84 1.41 2.83 0.61 0.36 2.23-0.07 2.79 0.36-0.51 0.57-1.02 1.15-1.52 1.73-0.51 0.58-2.79 0.85-3.29 1.42-1.02 1.16-1.56 2.54-1.28 3.78z' fill='%23ffc900'/%3E %3Cpath stroke-linejoin='round' d='m196.19 270.28c-2.46 1.91-18.31 5.92-18.48 19.69-0.16 13.77 2.78 16.91-0.16 17.26-5.72 0-6.54-15.34-6.38-22.14 0.17-6.8 0.33-5.75 0.33-5.75s3.92 1.04 3.6 4.36c-0.33 3.31 3.92-8.2 2.45-11.33 2.61 2.61 6.05 1.57 6.05 1.39 0-0.17-1.96-2.26-2.78-3.83s2.94 0.87 2.94 0.87 0.16-2.62-3.11-2.44c-4.25 0 0.66-1.4 0.66-1.4s2.45 2.27 4.09-0.17c-1.8-1.92-4.42-2.97-4.42-2.97s-2.29-4.35-5.39-5.22c-3.6-0.88-3.11 1.56-7.2 1.22-0.81 1.56-0.81 1.74 0.82 2.26-2.78 1.92-1.31 5.75-1.31 5.75s4.42-1.91 4.25 1.22c-0.16 3.14-2.61 2.62-4.25 0.7-1.47-0.87-1.96 0.87-1.96 0.87l2.29 2.44s-4.41-0.17-5.56 2.79c2.45-0.17 3.76 0.53 3.76 0.53s-5.07 2.26-5.56 3.48-0.65-1.39-0.81-1.39c-0.17 0-4.91-1.75-4.91-1.75l-1.64 7.54s3.28 3.27 5.07 2.22c1.8-1.04 5.07-4.18 7.03-3.31-5.72 4.36-11.44 10.63-14.55 11.51-0.81-0.7-3.59-3.49-4.74-2.1-1.14 1.4-0.32 3.14 1.15 2.97 1.47-0.18-4.74 1.39-3.44 4.01 1.31 2.61 1.15 2.44 2.29 1.74 1.15-0.7-0.98-0.87 3.27-2.09s4.09-2.44 4.09-2.44-0.82 1.91-3.11 2.44c-2.29 0.52-4.08 0.52-3.59 1.22 0.49 0.69 1.47 1.91 1.14 2.61s4.74-3.66 6.05-0.17c3.43-0.18 5.72-4.36 4.09-6.8 0.16 2.61 1.8 3.49 0.81 4.71-0.98 1.22 7.69-4.01 3.44-7.15 1.14 2.61 1.31 4.71 1.31 4.71s1.96-0.18 2.45-0.88c0.49-0.69-0.98 1.92-0.33 2.44 0.65 0.53 3.76 3.49 2.45 5.58-0.81-1.22-0.98-3.14-1.96-2.96-0.98 0.17-5.07 3.14-7.52 3.31s2.94 9.07 2.94 9.07-3.76-0.53-4.25-0.18-2.94-3.14-3.43-1.04c-0.82 2.61 0.82 1.56 0.82 1.56s-2.13-1.04-3.27 0.18c-1.15 1.22-2.29 2.44-1.47 2.96 0.81 0.52 4.41 0.52 4.9 0.35s-4.09 0.35-4.41 0.87c-0.33 0.52-0.98 2.44 0 3.14s3.43-0.35 3.59-0.87c0.17-0.53 0.33 1.91 0.33 1.91s4.25 0.35 4.25-4c0-4.36 0.33 3.13 0.33 3.13s4.25 0.7 4.41-3.66c0.17-4.35 0.49 2.97 0.49 2.97s2.78-0.88 2.78-1.57c0-0.7-0.16 8.71-2.12 11.33-3.11-2.1-5.07 1.39-5.07 1.39s0.16 5.05-0.17 6.27c-0.32 1.22 2.13-0.69 2.29-1.22 0.17-0.52 3.11-1.91 3.27-2.26 0.17-0.35 0.98-2.09 0.98-2.09s-0.65 2.44-1.79 2.79c-1.15 0.34-2.29 1.56-1.8 2.61s2.29 1.74 2.94 2.79c0.65 1.04 2.94-6.1 2.94-6.1l0.17 1.57s2.94-0.7 3.27-2.09c0.32-1.4-3.11-2.62-0.33-4.88 2.78-2.27 0 2.09 0 2.09s0.98 3.31 1.63 3.31c0.66 0 2.29-6.28 0.66-7.84-1.64-1.57 2.45 1.91 2.45 1.91s2.29-6.45-0.16-7.32c-2.46-0.87-3.6-1.22-3.6-1.22s1.31-1.74 0.65-1.91c-0.65-0.18 3.44 3.83 4.09 2.78 0.66-1.04 1.64-4.18-3.1-5.92-4.75-1.74-0.17-6.63-0.17-6.63s2.95 3.49 5.07 1.57c2.12-1.91-0.16-1.91-0.16-1.91s6.04-3.84 6.21-5.76c-1.15-0.17-3.11 0.18-3.11 0.18s3.44-2.27 2.62-5.93c-1.31 1.92-3.11 1.92-3.11 1.92s2.95-2.96 2.45-5.75c-1.79 1.39-1.63 2.44-2.78 2.09-1.14-0.35-3.1-11.33 1.48-12.03 4.57-0.69 2.12 5.41 2.28 5.41 0.17 0 6.87-2.79 0-7.32 1.64-0.53 5.07 2.61 5.07 2.61s-1.47-7.67-8.83-2.96c1.8-1.92 2.95-3.14 4.42-2.79s6.7-0.18 6.7-1.74c-1.3-1.05-4.08 0.52-5.56 0-1.47-0.53 10.47-1.4 9.49-7.32z' stroke='%23006b00' stroke-linecap='round' stroke-width='.68918' fill='%23ffc900'/%3E %3Cpath d='m481.3 118.54s12.25-6.43 18.37 1.54' transform='matrix(.53397 0 0 .56928 -112.64 207.32)' stroke='%23006b00' stroke-linecap='round' stroke-width='1.25' fill='none'/%3E %3Cpath d='m504.57 132.32c-0.31 0-4.29 3.98-5.21 3.98' transform='matrix(.53397 0 0 .56928 -112.64 207.32)' stroke='%23006b00' stroke-linecap='round' stroke-width='1.25' fill='none'/%3E %3Cpath d='m512.84 145.18s11.32 0.92 18.67-10.41' transform='matrix(.53397 0 0 .56928 -112.64 207.32)' stroke='%23006b00' stroke-linecap='round' stroke-width='1.25' fill='none'/%3E %3Cpath d='m525.08 141.81s0.92 6.13 2.76 6.13c1.83 0-3.06 1.53-4.9 0.3 2.14 2.76 3.37 7.66 0 9.49' transform='matrix(.53397 0 0 .56928 -112.64 207.32)' stroke='%23006b00' stroke-linecap='round' stroke-width='1.25' fill='none'/%3E %3Cpath d='m519.26 218.97s-3.98 4.28-8.88 4.59' transform='matrix(.53397 0 0 .56928 -112.64 207.32)' stroke='%23006b00' stroke-linecap='round' stroke-width='1.25' fill='%23e80000'/%3E %3Cpath d='m523.86 199.37s-2.45-12.24-0.92-15.31c0.92-3.98 4.9-5.51 7.96-10.71' transform='matrix(.53397 0 0 .56928 -112.64 207.32)' stroke='%23006b00' stroke-linecap='round' stroke-width='1.25' fill='none'/%3E %3Cpath d='m522.63 190.49s-3.06 7.35-16.53 4.9' transform='matrix(.53397 0 0 .56928 -112.64 207.32)' stroke='%23006b00' stroke-linecap='round' stroke-width='1.25' fill='none'/%3E %3Cpath d='m526.31 172.12s0.91 9.8-11.33 6.13' transform='matrix(.53397 0 0 .56928 -112.64 207.32)' stroke='%23006b00' stroke-linecap='round' stroke-width='1.25' fill='none'/%3E %3Cpath d='m511.3 128.04s-4.9 4.28-3.06 10.1' transform='matrix(.53397 0 0 .56928 -112.64 207.32)' stroke='%23006b00' stroke-linecap='round' stroke-width='1.25' fill='none'/%3E %3Cpath d='m529.67 117.32s6.43-2.45 7.66-3.68c1.22-1.22 3.37-3.67 3.98-5.51 0.61-1.83-4.29-4.59-1.84-8.569 1.53-1.837 3.67-2.143 7.35 0 3.67 2.139-3.37-6.735-7.04-7.041-3.68-0.307-6.13 2.449-7.04 1.836-0.92-0.612 0.3 2.45-1.23 2.45s3.06 2.449 2.76 3.984c-0.31 1.53 4.89 6.73 4.59 7.96-0.31 1.22-7.66 8.26-9.19 8.57z' transform='matrix(.53397 0 0 .56928 -112.64 207.32)' stroke-linecap='round' stroke-width='1.25' fill='%23006b00'/%3E %3Cpath stroke-linejoin='round' d='m534.27 97.112c2.79-0.636 3.24 0.07 2.75 2.449-1.31-0.66-1.79-1.217-2.75-2.449z' transform='matrix(.53397 0 0 .56928 -112.64 207.32)' stroke='%23ffc900' stroke-linecap='round' stroke-width='1.25' fill='%23ffc900'/%3E %3Cpath stroke-linejoin='round' d='m514.71 233.52s-1.03 6.41 1.49 6.94c-0.13-2.48 0.54-4.17 1.16-4.83-0.54-0.25-2.53-2.07-2.65-2.11z' transform='matrix(.53397 0 0 .56928 -112.64 207.32)' stroke='%23006b00' stroke-width='1.25' fill='%23e80000'/%3E %3Cpath stroke-linejoin='round' d='m509.03 225.63c-2.32-0.33-6.23 1.59-5.11 3.91 1.89-1.62 3.63 0.13 4.95-1.52 0.4-0.46 0.29-1.81 0.16-2.39z' transform='matrix(.53397 0 0 .56928 -112.64 207.32)' stroke='%23006b00' stroke-width='1.25' fill='%23e80000'/%3E %3Cpath stroke-linejoin='round' d='m509.01 221.05s-3.65-0.58-4.16 1.95c2.52-0.32 3.27-0.59 4.11-0.06 0.24-0.54 0.01-1.76 0.05-1.89z' transform='matrix(.53397 0 0 .56928 -112.64 207.32)' stroke='%23006b00' stroke-width='1.25' fill='%23e80000'/%3E %3Cpath stroke-linejoin='round' d='m493.54 184.94s2.19 0.82 2.81 3.06c1.74-1.08 2.57-5.83-2.81-3.06z' transform='matrix(.53397 0 0 .56928 -112.64 207.32)' stroke='%23006b00' stroke-width='1pt' fill='%23e80000'/%3E %3Cpath stroke-linejoin='round' d='m488.12 190.39c0.09-0.04 4.59-2.77 5.05-0.16-0.95 0.95-1.37 1.57-2.11 1.78-0.58 0-1.74-1.78-2.94-1.62z' transform='matrix(.53397 0 0 .56928 -112.64 207.32)' stroke='%23006b00' stroke-width='1pt' fill='%23e80000'/%3E %3Cpath stroke-linejoin='round' d='m487.67 199.24c0.08-0.04 2.89-2.52 3.97-0.87 1.07 1.66-0.87 1.57-0.87 1.57s-0.99-0.45-3.1-0.7z' transform='matrix(.53397 0 0 .56928 -112.64 207.32)' stroke='%23006b00' stroke-width='1pt' fill='%23e80000'/%3E %3Cpath stroke-linejoin='round' d='m483.7 149.96c-0.04 0-3.6-1.37-5.09 1.11 2.36 0.29 3.19 1.12 4.26 1.95-0.29-1.04-0.78-2.61 0.83-3.06z' transform='matrix(.53397 0 0 .56928 -112.64 207.32)' stroke='%23006b00' stroke-width='1pt' fill='%23e80000'/%3E %3Cpath stroke-linejoin='round' d='m476.8 168.52s0.16-4.17 2.14-5.87c1.12 0.62 1.45 1.61 2.2 2.85-1.49 0.33-3.48 0.42-4.34 3.02z' transform='matrix(.53397 0 0 .56928 -112.64 207.32)' stroke='%23006b00' stroke-width='1pt' fill='%23e80000'/%3E %3Cpath stroke-linejoin='round' d='m486.3 165.54s-3.92 1.82-2.64 3.81c1.28-1.37 2.69-0.95 2.69-0.99s0-2.77-0.05-2.82z' transform='matrix(.53397 0 0 .56928 -112.64 207.32)' stroke='%23006b00' stroke-width='1pt' fill='%23e80000'/%3E %3Cpath stroke-linejoin='round' d='m480.64 125.6c-1.41 1.58 1.74 5.01 5.04 4.51 0.83-3.72-4.21-5.66-5.04-4.51z' transform='matrix(.53397 0 0 .56928 -112.64 207.32)' stroke='%23006b00' stroke-width='1pt' fill='%23ffc900'/%3E %3Cpath stroke-linejoin='round' d='m480.6 118.41c-0.69 1.75 2.05 4.21 3.64 3.52 0.64-1.8-2.92-4.91-3.64-3.52z' transform='matrix(.53397 0 0 .56928 -112.64 207.32)' stroke-width='1pt' fill='none'/%3E %3Cpath stroke-linejoin='round' d='m484.28 122.75s0.62 2.94 3.47 2.15c-0.45-2.27-2.44-3.97-2.44-3.97-0.12 0.67 0.41 1.7-1.03 1.82z' transform='matrix(.53397 0 0 .56928 -112.64 207.32)' stroke='%23006b00' stroke-width='1pt' fill='%23e80000'/%3E %3Cpath stroke-linejoin='round' d='m486.18 131.27s1.57 1.69 4.67-1.78c-1.4 0.41-3.88-0.83-3.88-0.83s0 2.4-0.79 2.61z' transform='matrix(.53397 0 0 .56928 -112.64 207.32)' stroke='%23006b00' stroke-width='1pt' fill='%23e80000'/%3E %3Cpath stroke-linejoin='round' d='m480.46 118.86c-1.4 1.57 0.59 3.76 3.89 3.27 0.83-3.72-3.06-4.42-3.89-3.27z' transform='matrix(.53397 0 0 .56928 -112.64 207.32)' stroke='%23006b00' stroke-width='1pt' fill='%23ffc900'/%3E %3Cpath d='m144.62 266.62s7.04-2.01 10.78 1.01c3.73 3.01 3.73 0.28 3.73 0.28s5.46 2.01 7.04 1.58-1.15 0.15 1-1.15c2.16-1.29-4.31 0.29-4.88-2.44-1.01-1.72 0.14-3.88-2.15-3.16-1.58-2.01 1-3.44 0.43-5.6-1.58 1.15-2.45-0.43-3.74 2.44-3.01-0.57-0.43-4.74-3.73-5.17 0 3.02-2.44 3.16-2.59 4.89-1.43 1-7.75 4.74-5.89 7.32z' fill='url(%23linearGradient748)'/%3E %3Cpath d='m63.624 495.58c4.566-1.1 29.306 5.47 38.846 15.69-2.03-18.21-7.072-32.16-7.072-32.16s-14.743-4.21-16.767-2.18c-2.968 3.12-11.883 12.49-15.007 18.65z' stroke='%23000' stroke-width='1pt' fill='%23c01500'/%3E %3Cpath d='m56.082 411.46c-1.734 0.29-3.469 1.45-5.203 4.34-2.024 4.91-3.469 17.34-6.36 20.23s-5.493 3.18-5.493 5.79c0 2.6 0.29 8.67 8.095 10.98 7.805 0.29 20.236-12.43 20.236-12.43s6.36-6.94 8.961-14.45c-15.032 5.2-25.728-8.68-20.236-14.46z' stroke='%23000' stroke-width='1pt' fill='%23c01500'/%3E %3Cpath stroke-width='.99323pt' d='m273.49 492.68c-4.53-1.09-29.55 5.44-39.02 15.6 2.01-18.1 7.02-31.98 7.02-31.98 1.75-0.47 14.47-4.18 16.48-2.16 2.94 3.1 12.42 12.42 15.52 18.54z' stroke='%23000' fill='%23c01500'/%3E %3Cpath stroke-width='.99323pt' d='m280.5 409.05c1.72 0.29 2.33 2.55 3.74 5.43 2 4.88 4.07 12 6.94 14.87 2.87 2.88 5.45 7.13 5.45 9.72s-0.6 6.08-8.35 8.38c-7.74 0.29-18.97-9.66-18.97-9.66s-6.31-6.89-8.89-14.37c14.92 5.18 24.58-8.14 20.08-14.37z' stroke='%23000' fill='%23c01500'/%3E %3Cpath d='m47.41 479.69s15.61 10.69 15.9 15.61c41.92-62.16 148.88-81.53 209.87-4.34 8.1-10.7 16.48-14.16 16.48-14.16-64.17-83.84-191.95-73.43-242.25 2.89z' stroke='%23000' stroke-width='1pt' fill='%23fb0'/%3E %3Cg stroke-width='1pt' transform='translate(-.0000071526 .000045776)' stroke='%23000' fill='%231e5aa6'%3E %3Cpath d='m206.44 241.88l6.11-0.15-10.91 13.82 13.09 15.28-25.75 32.44 24.3 29.24c-2.67 6.55-5.77 12.51-9.9 17.9l-13.96-15.43 25.31-31.56-20.8-23.57 12.51-37.97z'/%3E %3Cpath d='m119.15 244.64l-6.55 0.15 12.22 13.23-12.94 16.15 26.91 29.25-22.26 29.82c2.67 6.55 6.5 13.82 10.62 19.2l13.24-16.73-27.2-30.26 19.93-25.31-13.97-35.5z'/%3E %3Cpath d='m149.41 323.2l-9.6 12.8 34.33 39.72c6.06-3.06 10.82-6.55 16.01-10.76l-17.9-20.66 7.28-21.39 10.47 12.07-32.73 41.76c-5.48-2.33-11.54-5.97-17.02-10.48l17.31-21.96-8.15-21.1z'/%3E %3Cpath d='m138.79 303.27l6.26 7.86-4.08-10.62-2.18 2.76z'/%3E %3Cpath stroke-width='.96849pt' d='m183.6 310.22c0.13-0.15 5.05-6.7 5.05-6.7l-1.91-2.61-3.14 9.31z'/%3E %3C/g%3E %3Cg font-family='Timmons' font-size='14px' font-weight='bold' line-height='100%25'%3E %3Ctext y='362.39716' x='-328.34363' transform='rotate(-49.557)'%3E %3Ctspan y='362.39716' x='-328.34363'%3EL%3C/tspan%3E %3C/text%3E %3Ctext y='384.26642' x='-292.33514' transform='rotate(-45.392)'%3E %3Ctspan y='384.26642' x='-292.33514'%3EE%3C/tspan%3E %3C/text%3E %3Ctext y='451.6806' x='-239.78038' transform='matrix(.76280 -.54464 .56769 .75422 0 0)'%3E %3Ctspan y='451.6806' x='-239.78038'%3EO%3C/tspan%3E %3C/text%3E %3Ctext y='429.95776' x='-188.5262' transform='matrix(.82844 -.56007 .56007 .82844 0 0)'%3E %3Ctspan y='429.95776' x='-188.5262'%3ET%3C/tspan%3E %3C/text%3E %3Ctext y='451.47876' x='-115.42612' transform='rotate(-25.549)'%3E %3Ctspan y='451.47876' x='-115.42612'%3EE%3C/tspan%3E %3C/text%3E %3Ctext y='453.04584' x='-94.110794' transform='rotate(-23.988)'%3E %3Ctspan y='453.04584' x='-94.110794'%3ER%3C/tspan%3E %3C/text%3E %3Ctext y='454.98212' x='-68.37056' transform='rotate(-21.911)'%3E %3Ctspan y='454.98212' x='-68.37056'%3ER%3C/tspan%3E %3C/text%3E %3Ctext y='445.66595' x='112.01579' transform='rotate(-4.7626)'%3E %3Ctspan y='445.66595' x='112.01579'%3ER%3C/tspan%3E %3C/text%3E %3Ctext y='430.7926' x='180.22531' transform='rotate(.85649)'%3E %3Ctspan y='430.7926' x='180.22531'%3ER%3C/tspan%3E %3C/text%3E %3Ctext y='275.21735' x='414.75919' transform='rotate(29.645)'%3E %3Ctspan y='275.21735' x='414.75919'%3ER%3C/tspan%3E %3C/text%3E %3Ctext y='193.05025' x='483.87762' transform='rotate(39.802)'%3E %3Ctspan y='193.05025' x='483.87762'%3EE%3C/tspan%3E %3C/text%3E %3Ctext y='414.02829' x='309.11557' transform='matrix(.96356 .18112 -.15531 .95184 0 0)'%3E %3Ctspan y='414.02829' x='309.11557'%3EO%3C/tspan%3E %3C/text%3E %3Ctext y='459.27182' x='105.05786' transform='matrix(.90188 -.13160 .13648 0.975 0 0)'%3E %3Ctspan y='459.27182' x='105.05786'%3EO%3C/tspan%3E %3C/text%3E %3Ctext y='455.83463' x='-45.707756' transform='rotate(-20.292)'%3E %3Ctspan y='455.83463' x='-45.707756'%3EA%3C/tspan%3E %3C/text%3E %3Ctext y='144.72449' x='518.34955' transform='matrix(.70468 .70952 -.70952 .70468 0 0)'%3E %3Ctspan y='144.72449' x='518.34955'%3EA%3C/tspan%3E %3C/text%3E %3Ctext y='388.29758' x='271.18784' transform='matrix(.98042 .19691 -.19691 .98042 0 0)'%3E %3Ctspan y='388.29758' x='271.18784'%3EA%3C/tspan%3E %3C/text%3E %3Ctext y='455.1676' x='40.321587' transform='rotate(-10.645)'%3E %3Ctspan y='455.1676' x='40.321587'%3EM%3C/tspan%3E %3C/text%3E %3Ctext y='448.07883' x='94.428757' transform='rotate(-5.9402)'%3E %3Ctspan y='448.07883' x='94.428757'%3EP%3C/tspan%3E %3C/text%3E %3Ctext y='437.60687' x='155.08846' transform='rotate(-1.4626)'%3E %3Ctspan y='437.60687' x='155.08846'%3EP%3C/tspan%3E %3C/text%3E %3Ctext y='276.66531' x='405.13382' transform='rotate(29.499)'%3E %3Ctspan y='276.66531' x='405.13382'%3EP%3C/tspan%3E %3C/text%3E %3Ctext y='409.79309' x='232.09538' transform='matrix(.99340 .11468 -.11468 .99340 0 0)'%3E %3Ctspan y='409.79309' x='232.09538'%3EI%3C/tspan%3E %3C/text%3E %3Ctext y='132.08934' x='530.39215' transform='rotate(46.586)'%3E %3Ctspan y='132.08934' x='530.39215'%3ET%3C/tspan%3E %3C/text%3E %3Ctext y='218.51869' x='464.15771' transform='rotate(36.816)'%3E %3Ctspan y='218.51869' x='464.15771'%3ET%3C/tspan%3E %3C/text%3E %3Ctext y='361.96112' x='313.72498' transform='rotate(16.412)'%3E %3Ctspan y='361.96112' x='313.72498'%3EM%3C/tspan%3E %3C/text%3E %3Ctext y='123.24773' x='513.7041' transform='rotate(47.66)'%3E %3Ctspan y='123.24773' x='513.7041'%3EG%3C/tspan%3E %3C/text%3E %3C/g%3E %3Cg stroke='%23fff700' stroke-linecap='round' stroke-width='1pt' fill='none'%3E %3Cpath d='m255.94 200.94s6.04-5.17 10.34-5.32'/%3E %3Cpath d='m256.81 200.22c0.14-0.14 36.05-5.17 37.19-6.32'/%3E %3Cpath d='m256.95 200.51c0.14-0.15 40.21-3.45 40.21-3.45'/%3E %3Cpath d='m256.81 200.65s42.65-2.01 45.24 0.15'/%3E %3Cpath d='m256.66 200.51s41.8 0.29 42.52 1.29'/%3E %3Cpath d='m256.81 200.51l40.21 3.3'/%3E %3Cpath d='m256.38 200.8c0.14 0 40.93 3.59 44.95 8.76'/%3E %3Cpath d='m303.48 216.88c-0.14-0.14-13.93-16.52-47.25-16.23'/%3E %3Cpath d='m256.38 200.94s23.12 1.58 30.44 9.62'/%3E %3Cpath d='m256.81 200.65s14.93-2.87 30.59 15.95'/%3E %3C/g%3E %3Cpath d='m247.4 217.74s20.72 0.82 20.72 2.85-15.44 5.89-15.64 14.42 11.78 9.14 12.59 19.9c0.81 10.77-9.34 12.39-11.37 15.24-2.04 1.42-6.91 16.65-6.3 25.59s3.25 39.2 7.92 45.3c3.66 2.84 9.14 11.98 15.03 9.14 5.89-2.85 1.83-13.2 1.22-16.05-0.61-2.84 2.44-7.51 2.44-11.78s-2.24-7.72-2.03-8.73c0.2-1.02 16.45 3.86 15.43 19.9-1.01 16.05-7.51 11.17-7.51 11.17s2.03 19.71-3.05 22.35c-9.14 4.87-15.84-1.02-15.84-1.02l0.86 4.01-6.95-3.6s-8.94-12.8-10.97-18.49c-2.03-5.68-4.47-31.07-3.66-36.56 0.81-5.48 1.42-37.58 1.02-39.2-0.41-1.63-2.03-28.44-1.02-32.5 1.02-4.06 7.31-21.94 7.11-21.94z' stroke='%23000' stroke-width='1pt' fill='url(%23linearGradient801)'/%3E %3Cpath d='m225.06 212.46s14.42-14.01 22.75-12.39c4.26 0 0.2 3.05 0.2 3.05s7.31 0.61 8.33 3.86c0.2 1.42-3.46 1.83-3.46 1.83s3.05 0.61 3.25 3.25c0.21 2.64-30.87 0.6-31.07 0.4z' stroke='%23000' stroke-width='1pt' fill='%23ff7000'/%3E %3Cpath d='m225.87 211.85s15.44-2.03 21.94-8.53' stroke='%23000' stroke-width='1pt' fill='none'/%3E %3Cpath d='m241.51 207.59s11.37-0.41 11.37 1.22' stroke='%23000' stroke-width='1pt' fill='none'/%3E %3Cpath stroke-linejoin='round' d='m281.93 373.74s9.75-2.24 12.39-5.69c1.63-1.22 10.16 12.8-12.39 5.69z' stroke='%23000' stroke-width='1.25' fill='%23FFF'/%3E %3Cpath d='m279.29 293.1s1.22 7.52-2.23 12.59c-1.83 2.03-7.32 5.49-7.32 7.93 0 2.43 2.03 5.68 1.63 8.53-0.41 2.84-3.45 5.69-3.25 8.12 0 2.44 3.45 15.44 3.04 15.64' stroke='%23FFF' stroke-linecap='round' stroke-width='1.25' fill='none'/%3E %3Cpath d='m261.42 268.73s-7.72 2.64-9.35 10.36' stroke='%23FFF' stroke-linecap='round' stroke-width='1.25' fill='none'/%3E %3Cpath d='m258.16 207.59s2.65 7.31 11.18 0.4c-5.49-7.51-11.18-0.2-11.18-0.4z' stroke='%23000' stroke-width='1pt' fill='%23c75b00'/%3E %3Cpath d='m264.87 206.47c0 0.39265-0.40924 0.71095-0.91405 0.71095s-0.91405-0.3183-0.91405-0.71095c0-0.39264 0.40924-0.71094 0.91405-0.71094s0.91405 0.3183 0.91405 0.71094z' transform='translate(-.40625 .8125)'/%3E %3Cpath d='m188.41 190.62s16.18 17.51 26.65 17.32c1.9 5.14-4.76 9.92-7.42 12.2-5.33-1.71-10.15 0.31-22.52-14.91 0.77-9.71 3.48-14.23 3.29-14.61z' stroke='%23000' stroke-width='1pt' fill='%23FFF'/%3E %3Cpath d='m210.3 149.89c2.09-6.47 6.28-11.61 9.89-12.18-0.95-4.95 7.62-26.83 32.55-35.21 1.52 11.23-10.66 22.27-10.66 22.27s36.73-6.28 44.15-15.61c-0.76 4.19-8.18 30.26-47.39 30.07 14.85 14.09-4.75 25.32-13.13 21.89 15.42-11.8-4.37-18.84-15.41-11.23z' stroke='%23000' stroke-width='1pt' fill='%23FFF'/%3E %3Cpath d='m222.86 140.76c7.42-4.76 10.08-4.76 16.18-3.81-4.38 0.57-4.38 0.76-4.38 0.76s-0.38 0.57 2.28 3.05c-3.04-0.77-5.71-2.48-14.08 0z' stroke='%23CCC' stroke-width='1pt' fill='%23cccccd'/%3E %3Cpath d='m220 137.71s14.66-7.8 22.84-13.13' stroke='%23000' stroke-width='1pt' fill='none'/%3E %3Cpath d='m207.44 220.12s20.18 5.52 22.46-23.41c-4.38-12.56-10.47-39.59-1.14-47.39-8.57-5.9-17.89 0.19-17.89 0.19-0.57 1.33-8.19 12.18 2.09 31.21-24.36-6.47-14.46 16.56-14.46 16.56 0.95-3.62 13.89-7.04 17.13 11.42 1.33 4.57-8.76 11.61-8.19 11.42z' stroke='%23000' stroke-width='1pt' fill='%2300F'/%3E %3Cpath d='m230.09 196.9s21.32-11.42 20.74-38.25c-18.08 0.38-24.55 23.78-24.55 23.78l3.81 14.47z' stroke='%23000' stroke-width='1pt' fill='%2300F'/%3E %3Cpath d='m134.55 195.57s-15.79 13.7-24.74 9.32c-6.66 4-14.462-3.04-14.462-3.04s9.132 33.68 41.872 9.32c-0.57-7.42-2.29-15.03-2.67-15.6z' stroke='%23000' stroke-width='1pt' fill='%23FFF'/%3E %3Cpath d='m109.62 204.32c1.33-7.04 6.85-10.47 11.23-3.81 5.9 1.15 11.8-23.02-9.14-19.03 5.9-31.59-11.795-43.39-11.795-43.39s-6.28 35.02-3.426 41.49c2.855 6.47-4.186-11.99-26.834-17.13-0.381 26.46 25.312 38.83 25.312 38.83s7.233 6.66 14.653 3.04z' stroke='%23000' stroke-width='1pt' fill='%2300F'/%3E %3Cpath d='m111.71 181.29s-9.89 8.38-7.61 19.8' stroke='%23000' stroke-width='1pt' fill='none'/%3E %3Cpath d='m96.68 180.15s-2.284 8.18 2.664 19.79' stroke='%23000' stroke-width='1pt' fill='none'/%3E %3Cpath d='m95.157 202.61s4.568-7.42 14.463 2.09' stroke='%23000' stroke-width='1pt' fill='none'/%3E %3Cpath d='m97.06 151.22c0-0.19-15.034 0-6.09 15.23-6.661 2.09-21.505-7.61-11.228-20.56-33.686-0.76-47.389-16.93-47.389-31.78 9.897 10.28 33.496 6.09 41.87 12.37-10.277-9.51-8.184-22.65-8.184-22.65s28.738 8.57 33.876 34.07c-1.713 4.95-2.474 13.7-2.855 13.32z' stroke='%23000' stroke-width='1pt' fill='%23FFF'/%3E %3Cpath d='m73.942 125.82c5.546 5.64 19.795 7.33 27.028 13.61' stroke='%23000' stroke-width='1pt' fill='none'/%3E %3Cpath stroke-width='.94781' d='m80.503 142.47s11.797-1.52 15.216 2.66c-4.616 0-6.155-1.14-12.822 1.34 1.88-0.96 1.367-2.67 2.393-2.67s-4.274-1.33-4.787-1.33z' stroke='%23CCC' fill='%23cccccd'/%3E %3Cpath d='m139.31 50.166s6.47-5.71 13.51-0.571c-3.18 9.507-14.65 5.9-14.65 5.9s0.38 4.758-0.76 7.041c2.29 1.727 4.18 7.423 4.18 7.423s11.8-2.855 14.28 2.284c4.52-0.624 7.8 0 7.8 0s9.14-2.284 12.37-2.284c3.24 0 13.51 2.664 14.46 4.567 0.96 1.903 4.38 14.655 6.67 14.464 2.28-0.19-5.52 3.045-7.62-0.19-2.09-3.236-1.52 4.187-1.52 4.187s6.47 6.851 7.23 8.373c0.76 1.52-3.99 13.89-0.38 22.46-3.17 0.29-3.42 3.61-3.42 3.61-0.18 3.77-4.95 4.76-4.95 4.76l-1.14-5.14-3.24 1.91 1.33-4s4.38-10.66 4.76-14.08c0.38-3.43-4-9.52-7.42-9.52-3.43 0-5.9 10.85-5.9 10.85s-1.71 8.18-1.14 8.94-2.29-2.66-2.29-2.66-1.52 4.95-2.66 6.47-3.62 2.09-3.62 2.09-1.71-4.95-1.14-6.85 9.33-9.32 8.57-14.65c-0.77-5.33 0-4-0.2-4.19-0.19-0.19-4.56-3.996-4.75-6.089-0.19-2.094-5.71 2.664-12.94 1.141-2.22 3.868-2.48 13.508-2.48 13.508s-0.76 11.61 0.76 12.95c1.53 1.33-3.8 4.18-3.8 4.18l-3.81 5.14s-1.33-3.23-1.33-3.04-2.67 1.9-2.67 1.9l1.53-3.81c-0.1-2.88 3.7-10.75 3.7-17.41s0.48-13.798 0.48-13.798-7.04-0.381-6.85 6.848c0.19 7.24-1.71 7.62-1.33 9.71s2.28 7.99 1.71 9.71c-0.57 1.71-2.85 2.28-2.85 2.28l-0.57 0.95s-7.04 3.24-6.85 4.57-0.19-3.81-0.19-3.81l-0.39-5.52s4.19-2.66 4.19-9.32-0.96-7.61-0.77-9.13c0.19-1.53 1.15-7.05 0.96-7.62-0.19-0.571-3.99 1.522-5.14 1.522-1.14 0 2.1-3.996 2.48-6.851s-3.81 2.664-7.23-0.571c1.59-3.514 3.99-4.568 4.37-7.232s-2.66 2.284-5.33 0.381c0.22-2.554 2.86-4.758 2.86-4.758s-2.17-0.266-3.05 0c-1.71-0.571 1.91-3.236 2.1-7.042s-2.1-5.329-2.1-5.519-3.8-3.426-4.37-4.758-0.57-2.855-0.57-2.855-6.29 4.568-13.71-5.138c6.8-5.803 14.09-1.523 14.09-1.523s1.9-5.329 10.65-4.948c8.76 0.381 10.47 5.329 10.09 4.758z' stroke='%23000' stroke-width='1pt' fill='%23923f00'/%3E %3Cpath d='m187.19 148.61c0.15 0 16.16 0.48 16.32 9.04 0.16 8.55-4.91 6.34-5.07 6.34s-11.73-1.43-11.73-1.43l0.48-13.95z' stroke='%23000' stroke-width='1pt' fill='%2300F'/%3E %3Cpath d='m171.65 146.23s19.97-0.15 18.86 8.56c-1.11 8.72-6.18 6.98-6.18 6.98l-9.67-0.8-3.01-14.74z' stroke='%23000' stroke-width='1pt' fill='%23fffeff'/%3E %3Cpath d='m160.4 145.28l11.57 0.95s6.97 0.95 6.66 7.61c-0.32 6.66-7.14 6.82-7.14 6.82l-11.25-0.64 0.16-14.74z' stroke='%23000' stroke-width='1pt' fill='%2300F'/%3E %3Cpath d='m133.3 148.61c-0.16 0-16.17 0.48-16.33 9.04-0.15 8.55 4.92 6.34 5.08 6.34s11.73-1.43 11.73-1.43l-0.48-13.95z' stroke='%23000' stroke-width='1pt' fill='%23FFF'/%3E %3Cpath d='m148.83 146.23s-19.97-0.15-18.86 8.56c1.11 8.72 6.18 6.98 6.18 6.98l9.67-0.8 3.01-14.74z' stroke='%23000' stroke-width='1pt' fill='%2300F'/%3E %3Cpath d='m160.09 145.28l-11.57 0.95s-6.98 0.95-6.66 7.61 7.13 6.82 7.13 6.82l11.25-0.64-0.15-14.74z' stroke='%23000' stroke-width='1pt' fill='%23FFF'/%3E %3Cpath d='m191.07 241.51s8.32-12.26 11.83-10.95c3.06 1.02 0.73 10.51-0.73 11.39l-11.1-0.44z' stroke='%23000' stroke-width='1pt' fill='%235e0043'/%3E %3Cpath d='m134.04 243.7c-2.62-3.65-6.42-13.72-9.92-10.95-3.07 1.02-0.73 10.51 0.73 11.39l9.19-0.44z' stroke='%23000' stroke-width='1pt' fill='%235e0043'/%3E %3Cpath d='m139.55 219.45s16.21 9.99 21.53 10.25 22.18-12.97 22.18-12.97' stroke='%23000' stroke-width='1pt' fill='none'/%3E %3Cpath d='m141.11 180.29l3.11-3.89 15.57 7.91 15.82-7.01 3.11 3.25-17.64 12.45-19.97-12.71z' stroke='%23000' stroke-width='1pt' fill='%235e0043'/%3E %3Cpath stroke-linejoin='round' d='m128.75 180.08c1.26 1.59 11.32 13.82 13.14 23.94 1.81 10.12-1.04-13.88-1.04-13.88s12.45 6.1 12.84 9.99 5.95-0.26 6.22-0.93l-36.05-23.41 4.89 4.29z' stroke='%23474747' stroke-width='1.25' fill='%23474747'/%3E %3Cpath stroke-linejoin='round' d='m190.26 179.38s-13.1 17.25-11.54 36.05c-2.7-9-0.52-23.86-0.52-23.86l-2.85 1.82s-2.98 12.71-6.75 14.65c-0.63-1.51-0.51-2.07-0.51-2.07s-4.02 5.18-4.8 5.7 0.26 17.51 0.26 17.51 1.35 12.32 2.9 12.19c-1.77 0.86-3.94 2.21-3.94 2.21l-1.61-32.88 3.68-3.7s4.93-5.96 5.32-11.8c-2.14 1.82-4.54 2.34-4.54 2.34s-0.65 8.3-2.59 9.46c-1.95 1.17-2 3.34-2 3.34l-0.46-10.85 29.95-20.11z' stroke='%23474747' stroke-width='1.25' fill='%23474747'/%3E %3Cpath d='m160.3 199.35l2.54 51.87' stroke='%23000' stroke-linecap='round' stroke-width='1.25' fill='none'/%3E %3Cpath d='m128.4 224.12s5.96 3.51 8.17 14.14c19.45-1.43 25.55 5.45 25.55 5.45s15.95-7.65 23.35-6.23c2.59-5.44 9.98-12.45 9.98-12.45' stroke='%23000' stroke-width='1pt' fill='none'/%3E %3Cpath d='m120.26 173.28l40.04 26.2 36.06-24.25s7.52-4.15 6.87-7.13c-0.64-2.99-3.24-1.82-4.54-1.3-1.29 0.52-37.74 26.33-37.74 26.33l-38.78-24.52s-2.85-0.9-3.37 0.91c-0.52 1.82 1.07 2.85 1.46 3.76z' stroke='%23000' stroke-width='1pt' fill='%23b4b6b9'/%3E %3Cpath stroke-linejoin='round' d='m191.87 166.48s-10.25-4.35-10.25-0.58c0 3.76 0.29 4.15 1.94 6.57 1.64 2.41-1.26 3.96-1.26 3.96s-0.39-1.06-0.97-2.71c-0.58-1.64-6.09-2.8-6.57-4.73-0.48-1.94 1.16-5.03-2.13-5.41-3.28-0.39-6.47 1.35-7.15 5.12s-4.93 12.56-4.93 12.56l0.58-20c7.22 0.51 20.62 2.09 30.93 3.28-3.09-0.48 1.16 0.2 1.07 1.26-0.29 0.87-1.36 0.96-1.26 0.68z' stroke='%23474747' stroke-width='1.25' fill='%23474747'/%3E %3Cpath stroke-linejoin='round' d='m155.62 161.45c-1.83 0-11.02 1.06-13.34 2.42-2.32 1.35 3.77 3.47 3 5.31s-0.87 5.51-3.77 4.74c-2.9-0.78-12.66-5.61-12.95-7.25s-2.32-1.74-2.32-1.74 28.03-3.77 29.38-3.48z' stroke='%23474747' stroke-width='1.25' fill='%23474747'/%3E %3Cpath d='m160.04 159.15l-0.07 24.58' stroke='%23000' stroke-width='1pt' fill='none'/%3E %3Cpath d='m141.11 130.19s-11.23 18.23-11.45 18.79' stroke='%23000' stroke-width='1pt' fill='none'/%3E %3Cpath d='m161.8 129.74s4.89 6.67 4.33 8.56c2 1.56 4.23 7.79 4.23 7.79' stroke='%23000' stroke-width='1pt' fill='url(%23linearGradient746)'/%3E %3Cpath d='m180.7 128.63s-10.56 14.9-10.23 16.01' stroke='%23000' stroke-width='1pt' fill='none'/%3E %3Cpath d='m126.5 56.748c0 0.79388-1.1339 1.4375-2.5327 1.4375s-2.5327-0.64357-2.5327-1.4375c0-0.79388 1.1339-1.4375 2.5327-1.4375s2.5327 0.64357 2.5327 1.4375z' transform='matrix(1.0161 .31118 -.30126 1.0495 15.15 -41.141)'/%3E %3Cpath d='m126.5 56.748c0 0.79388-1.1339 1.4375-2.5327 1.4375s-2.5327-0.64357-2.5327-1.4375c0-0.79388 1.1339-1.4375 2.5327-1.4375s2.5327 0.64357 2.5327 1.4375z' transform='matrix(-1.0161 .31118 .30126 1.0495 242.3 -41.435)'/%3E %3Cpath stroke-linejoin='round' d='m254.49 366.13s-3.92 0.74-3.79 1.1c0.12 0.37-11.39 0.74-11.63 0.37-0.25-0.37-1.72 1.96-1.72 1.96l1.84-1.1s2.81 2.93 3.67 2.69-0.37 1.1-0.12 1.35c0.24 0.24 1.1-0.49 1.1-0.49l19.02-0.32-8.37-5.56z' stroke='%23000' stroke-width='1pt' fill='%23ff7000'/%3E %3Cpath stroke-linejoin='round' d='m261.58 372.05l-15.54 0.45s-3.91 3.55-4.16 4.4c-0.24 0.86 2.57 1.1 2.57 1.1l0.86 2.94 1.96-0.73s13.21 1.96 25.34-0.74c6.12-2.14 7.19-4.71 2.9-6.27-4.28-1.56-13.81-1.09-13.93-1.15z' stroke='%23000' stroke-width='1.25' fill='%23ff7000'/%3E %3Cpath d='m208.37 403.93l27.97-1.25-5.21-4.42 75.65-3.05-2.61-6.01-84.7 3.4 10.19 4.76-22.88 0.68 0.68 2.38-6-0.23s6.68 2.6 6.91 3.74z' stroke='%23000' stroke-width='1pt' fill='url(%23linearGradient794)'/%3E %3Cpath d='m239.73 249.42c-2.23-1.11-12-2.44-22.89 4.67l0.45 25.11s15.99-8.67 23.77-6.67c-0.45-7.78-0.45-17.77-1.33-23.11z' stroke='%23000' stroke-width='1pt' fill='url(%23linearGradient800)'/%3E %3Cg stroke='%23000' stroke-width='1pt' fill='none'%3E %3Cpath d='m85.074 325.65l-65.956 65.48'/%3E %3Cpath d='m114.47 326.13l-53.532 70.5'/%3E %3Cpath d='m112.08 307.73l-71.455 86.51'/%3E %3Cpath d='m38.474 393.04l6.93-8.12'/%3E %3Cpath d='m125.7 351.22l-27.722 38.24'/%3E %3Cpath d='m96.783 394.48l0.717 14.57'/%3E %3Cpath d='m138.36 364.6l-29.39 36.81'/%3E %3Cpath d='m133.11 398.54l11.95-19.6'/%3E %3Cpath d='m137.65 375.12l-14.34 16.25'/%3E %3Cpath d='m133.35 359.83l-9.8 11.94'/%3E %3Cpath d='m120.68 342.38s-29.871 43.73-29.393 47.32'/%3E %3Cpath d='m117.57 336.65c-0.71 0.47-25.805 33.69-25.805 33.69'/%3E %3Cpath d='m90.331 380.85l-4.541 5.5'/%3E %3Cpath d='m80.055 394.72l-6.93 9.08'/%3E %3C/g%3E %3Cpath d='m81.811 225s-2.024 6.36 0 9.54c2.023 3.18 14.743 28.91 14.743 28.91s8.676-10.7 11.856-10.99c3.18-0.28 1.73 27.76 1.73 27.76s-5.2 4.91-8.38 4.62c-3.182-0.29 7.8 10.99 7.51 20.53s-14.45 56.95-19.654 57.81c-5.203 0.87 2.313-8.67 2.024-11.27s-1.735-0.87-2.891-3.76 1.735-7.23 1.156-10.12c-0.578-2.89-3.18-2.31-3.469-4.33-0.289-2.03 1.735-2.6 1.446-4.92-0.289-2.31-3.469-1.73-3.18-3.76 0.289-2.02 0.578-1.15 0.289-4.91s-0.867 2.6-4.047 2.89-5.782 7.52-5.782 7.52-6.36 8.96-12.72 4.91c3.758 8.1 0.868 11.57-0.578 11.85-1.445 0.29 1.156 6.36-2.313 6.65s2.602 13.59-1.445 14.75c4.336 2.02 0.867 4.62 0.867 4.62s-10.02 0.84-7.805 13.88c-29.487-10.41-43.941-28.33-43.652-46.54 0.2893-18.22 6.071-34.69 20.236-40.76 4.047-15.04 10.985-31.23 10.985-31.23s-1.156-6.65-0.289-10.98c0.868-4.34 4.915-8.67 4.915-8.67s-0.579-10.41-0.289-15.61c0.289-5.21 2.312-7.52 2.601-10.41s-0.867-17.64 2.024-20.24 8.383-2.31 11.274-4.04c2.891-1.74 6.649-4.92 10.407-4.63s6.938 2.89 6.938 2.89 14.166 0 15.033 5.49c0.867 5.5-2.891 7.52-2.891 7.52s2.024 7.81-6.649 15.03z' stroke='%232b2b2b' stroke-width='1pt' fill='%238a9396'/%3E %3Cpath d='m69.666 206.45c0 0.95295-1.5933 1.7255-3.5588 1.7255s-3.5588-0.77251-3.5588-1.7255c0-0.95295 1.5933-1.7255 3.5588-1.7255s3.5588 0.77251 3.5588 1.7255z' transform='matrix(.87942 -.47604 .47604 .87942 -90.31 56.579)' stroke='%232b2b2b' stroke-width='1pt' fill='%23cecfcf'/%3E %3Cpath d='m66.68 206.44c0 0.35596-0.44597 0.64453-0.99609 0.64453-0.55013 0-0.99609-0.28857-0.99609-0.64453 0-0.35597 0.44597-0.64453 0.99609-0.64453 0.55013 0 0.99609 0.28856 0.99609 0.64453z' transform='matrix(1.0784 0 0 1.4848 -5.0735 -100.09)'/%3E %3Cpath d='m87.971 216s3.511 15.68-0.687 26.5' stroke='%232b2b2b' stroke-width='.625' fill='none'/%3E %3Cpath d='m89.051 209.14s6.85 9.06 5.966 20.33' stroke='%232b2b2b' stroke-width='.625' fill='none'/%3E %3Cpath d='m89.714 207.15c0.221 0 5.745 4.86 5.524 8.17' stroke='%232b2b2b' stroke-width='.625' fill='none'/%3E %3Cpath d='m91.04 205.16s3.757 2.65 4.64 5.3' stroke='%232b2b2b' stroke-width='.625' fill='none'/%3E %3Cpath d='m89.272 203.61s-13.479 21.88-11.711 35.58' stroke='%23000' stroke-width='1pt' fill='none'/%3E %3Cpath d='m90.156 202.95s-17.899 10.61-21.213 45.3' stroke='%232b2b2b' stroke-width='.625' fill='none'/%3E %3Cpath d='m88.167 209.36l-7.071 5.3' stroke='%23000' stroke-width='1pt' fill='none'/%3E %3Cpath d='m62.314 250.24s9.943-41.32 27.621-47.29' stroke='%232b2b2b' stroke-width='.625' fill='none'/%3E %3Cpath d='m96.785 264.16s9.505-11.93 11.715-11.49 1.54 27.62 1.54 27.62-7.07 5.3-8.61 5.08c-1.551-0.22 7.95 12.82 7.73 17.68s-0.44 4.86-0.44 4.86 0-2.87-2.21-7.51-0.89-9.95-15.249-21.66c-3.536-7.29 7.071 4.42 9.279 2.65 2.21-1.76-3.976-17.01-3.755-17.23z' stroke='%232b2b2b' stroke-width='1pt' fill='%232b2b2b'/%3E %3Cpath d='m79.893 196.96s-3.994 1.09-4.539 2.72c-0.545 1.64-2.905 3.27-4.176 2.72-1.271-0.54-3.632-2.54-3.632-2.54' stroke='%232b2b2b' stroke-width='1pt' fill='none'/%3E %3Cpath stroke-linejoin='round' d='m57.196 210.94s-5.992 5.99-3.086 6.72c2.905 0.72 5.992-4.72 5.992-4.72s0 9.26 2.542 7.8c2.542-1.45 9.986-6.71 9.986-6.71s2.542-0.19 3.087 0c0.545 0.18 6.9 5.62 11.076 3.63-2.36 6.17-5.084 6.9-5.084 6.9s-4.358 5.63-9.986 4.35c-5.629-1.27-7.082-3.63-7.082-3.63s-4.721 0.37-6.174-1.81c-1.452-2.18-1.997-3.45-1.997-3.45s-2.723 2.72-3.45 1.45c-0.726-1.27 0-8.72 4.176-10.53z' stroke='%232b2b2b' stroke-width='1.25' fill='%232b2b2b'/%3E %3Cpath d='m91.151 202.59s-11.076-3.27-14.889 2.18c-3.813 5.44-2.905 8.53-0.908 9.07' stroke='%232b2b2b' stroke-width='1pt' fill='none'/%3E %3Cpath d='m92.86 202.28c0 1.3059-0.93488 2.3645-2.0881 2.3645s-2.0881-1.0586-2.0881-2.3645 0.93488-2.3645 2.0881-2.3645 2.0881 1.0586 2.0881 2.3645z'/%3E %3Cpath d='m60.624 230.54s4.517 6.95 9.902 8.86-3.735 3.56-9.12-0.08c-3.908-5.3-2.866-9.12-2.866-9.12s1.042-1.05 2.084 0.34z' stroke='%232b2b2b' stroke-width='1pt' fill='%232b2b2b'/%3E %3Cpath d='m99.275 271.54s-12.681-17.63-16.329-18.59c-3.648-0.95 2.779-1.73 6.688 2 3.908 3.73-1.042-6.08-1.042-6.08l10.683 22.67z' stroke='%232b2b2b' stroke-width='1pt' fill='%232b2b2b'/%3E %3Cpath stroke-linejoin='round' d='m59.409 373.42c4.863-1.3 26.056 12.16 30.833 15.55 4.777 3.38 14.768 1.21 14.768 1.21s-4.61 2.78-7.472 3.48c-2.866 0.69 8.512 0.69 8.512 0.69s-27.099 7.47-54.632-7.03c-2.519-11.29 5.906-13.81 7.991-13.9z' stroke='%232b2b2b' stroke-width='1.25' fill='%232b2b2b'/%3E %3Cpath d='m90.416 275.88s-3.561-0.69-5.385-2.78c-1.824-2.08-4.43-7.21-7.122-9.38-2.693-2.17-16.155-9.55-21.019-9.03s-6.341-0.52-6.949-1.13-2.605 0.26-2.258 2.78c0.348 2.52-3.735 8.08-2.258 10.68 1.476 2.61 8.425 13.2 9.815 13.55 1.389 0.35 0.521 6.17 0.521 6.17s6.166 6.25 7.73 6.6c1.563 0.35 3.126 1.48 2.953 2.95-0.174 1.48-6.775 9.56-6.775 9.56s-7.122 3.73-7.209 5.82c-0.087 2.08 1.737 6.42 7.383 7.81 5.645 1.39 20.845 0.26 21.627-1.04 0.781-1.3 1.997-9.12 1.476-9.9s-4.256-3.13-6.167-2.78c-1.91 0.35-3.647 1.91-3.474 2.26 0.174 0.35-2.692 1.82-2.692 0.43s5.645-7.64 6.166-7.12c0.522 0.52 8.512 1.3 9.989 5.3 1.476 3.99 1.476 6.86 5.645 6.43 4.169-0.44 9.987-4.26 10.507-12.25s-4.687-13.38-5.99-14.16-5.646-3.39-5.993-4.6c-0.348-1.22-1.216-5.21-0.521-6.17z' stroke='%232b2b2b' stroke-width='1pt' fill='%232b2b2b'/%3E %3Cpath d='m15.286 311.15s13.463-3.48 16.937-3.39c3.474 0.08 16.589 6.16 20.411 9.9 3.821 3.73 11.638 12.59 16.763 11.81 5.124-0.78 6.601-1.82 6.601-1.82l-1.998 3.82s-4.169 1.13-6.253 0.61c-2.085-0.52-6.167-1.83-10.249-5.82-4.082-4-16.676-14.77-27.359-13.99-10.684 0.79-16.85 11.3-16.85 11.3s0.087-5.13 0.521-6.26-2.258 2.43-2.258 2.43l3.734-8.59z' stroke='%232b2b2b' stroke-width='1pt' fill='%232b2b2b'/%3E %3Cpath d='m64.88 321.57c0.087 0.08 3.388 0.95 8.946 0.95 5.559 0 8.512-2.43 8.512-2.43l-0.347-2.17 0.868-3.04s4.256 4.34 4.169 5.21-1.737 1.22-1.737 1.22l-0.608-2.09-1.476 1.83s-8.078 6.42-12.507 5.47c-4.43-0.96-8.512-3.82-7.383-4.52 1.129-0.69 1.737-0.43 1.563-0.43z' stroke='%232b2b2b' stroke-width='1pt' fill='%232b2b2b'/%3E %3Cpath d='m45.251 332.95s-4.864-0.09-7.035 0.95-2.953 2.35-4.43 2.17c-1.476-0.17-2.605-2.08-2.171-2.86 0.608-1.22 3.474-2.78 8.946-2.35 5.472 0.44 4.69 2.09 4.69 2.09z' stroke='%232b2b2b' stroke-width='1pt' fill='%232b2b2b'/%3E %3Cpath d='m62.275 346.15c0-0.26-0.348-7.12-3.04-9.9-2.693-2.78-5.993-2.78-7.47-2.44-1.476 0.35 5.472 3.39 6.167 5.39s2.953 7.56 2.345 8.95c-0.608 1.38-1.737-3.91-5.993-5.39s-10.162-0.69-8.946 1.22 5.993 0.17 8.425 4.25 4.256 8.43 4.256 8.43l0.782-2.96 2.171-0.6 0.26-5.65 1.043-1.3z' stroke='%232b2b2b' stroke-width='1pt' fill='%232b2b2b'/%3E %3Cpath stroke-linejoin='round' d='m58.801 368.38l-4.43-8.86s-1.39-5.64-5.124-7.21c-3.735-1.56-8.686-1.3-8.773 0.61s7.991 4.34 8.512 5.39c0.521 1.04 0.261 2.78-0.434 2.86-0.695 0.09-4.256-1.3-6.08-0.87-1.824 0.44-2.866 2.78-5.559 2.09-2.692-0.7-4.951-9.29-3.908-10.16 1.042-0.87-1.998 1.56-2.606-0.7s0.869-9.29-0.174-10.16c-1.042-0.87-6.079-3.91-6.166-4.52-0.087-0.6 0.26-34.56 28.662-6.42-12.16-14.42-16.937-12.86-19.195-12.94-1.65 0-12.681 0.95-15.46 15.02-2.78 14.07-6.08 5.3-6.08 5.3s-0.608 6.08 2.345 7.82c2.953 1.73-1.39 6.77-1.39 6.77s-5.2978-12.94-4.5161-18.59c-1.0423 4.52-0.9554 15.72 5.7321 27.97 7.817 8.25 15.2 15.9 34.829 24.49 10.336-15.8 9.815-17.71 9.815-17.89z' stroke='%232b2b2b' stroke-width='1.25' fill='%232b2b2b'/%3E %3Cpath stroke-linejoin='round' d='m40.214 368.47s5.732 0.69 7.295 3.65c1.564 2.95 2.259 7.47 2.259 7.47 0.955-1.91 1.389-3.56 3.3-4.95s3.301-1.57 3.214-2.61-6.08-7.38-9.12-7.73-8.338 3.3-8.338 3.3-0.955 1.39 1.39 0.87z' stroke='%232b2b2b' stroke-width='1.25' fill='%238a9396'/%3E %3Cg stroke-width='1.25' stroke-linecap='round' fill='none'%3E %3Cpath d='m53.307 383.41s14.856 6.77 39.324 7.21' stroke='%238a9396'/%3E %3Cpath d='m102.9 314.45s-1.27 12.47-10.861 37.07' stroke='%232b2b2b'/%3E %3Cpath d='m100.99 322.12s-2.879 8.95-10.869 15.66' stroke='%232b2b2b' stroke-linecap='butt' stroke-width='1pt'/%3E %3C/g%3E %3C/g%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 960 600'%3E %3Cdefs%3E %3CradialGradient id='a'%3E %3Cstop stop-color='%23f9f0aa' offset='.22'/%3E %3Cstop stop-color='%23b07e09' offset='1'/%3E %3C/radialGradient%3E %3CradialGradient id='d' xlink:href='%23a' gradientUnits='userSpaceOnUse' cx='447.42' cy='308.27' r='16.53'/%3E %3CradialGradient id='e' xlink:href='%23a' gradientUnits='userSpaceOnUse' cx='451.56' cy='313' r='10.91'/%3E %3CradialGradient id='f' xlink:href='%23a' gradientUnits='userSpaceOnUse' cx='454.11' cy='308.64' r='9.78'/%3E %3CradialGradient id='g' xlink:href='%23a' gradientUnits='userSpaceOnUse' cx='458.39' cy='307.06' r='17.35'/%3E %3CradialGradient id='j' xlink:href='%23a' gradientUnits='userSpaceOnUse' cx='445.98' cy='252.36' r='13.02'/%3E %3CradialGradient id='m' gradientUnits='userSpaceOnUse' cx='477.86' cy='215.27' r='.34'%3E %3Cstop stop-color='%23a50a0a' offset='.26'/%3E %3Cstop stop-color='%234c0505' offset='1'/%3E %3C/radialGradient%3E %3CradialGradient id='n'%3E %3Cstop stop-color='%23fff' offset='0'/%3E %3Cstop stop-color='%23fff' stop-opacity='0' offset='1'/%3E %3C/radialGradient%3E %3ClinearGradient id='h' gradientUnits='userSpaceOnUse' x1='473.91' y1='259.17' x2='472.36' y2='231.96'%3E %3Cstop stop-color='%23b07e09' stop-opacity='0' offset='.22'/%3E %3Cstop stop-color='%23b07e09' offset='1'/%3E %3C/linearGradient%3E %3ClinearGradient id='i' gradientUnits='userSpaceOnUse' x1='483.13' y1='296.66' x2='485.49' y2='326.58'%3E %3Cstop stop-color='%23b07e09' stop-opacity='0' offset='.22'/%3E %3Cstop stop-color='%23b07e09' offset='1'/%3E %3C/linearGradient%3E %3ClinearGradient id='k' gradientUnits='userSpaceOnUse' x1='451.54' y1='249.52' x2='455.37' y2='240.58'%3E %3Cstop stop-color='%23f9f0aa' offset='.22'/%3E %3Cstop stop-color='%23b07e09' offset='1'/%3E %3C/linearGradient%3E %3ClinearGradient id='l' gradientUnits='userSpaceOnUse' x1='473.31' y1='237.25' x2='475.93' y2='270.45'%3E %3Cstop stop-color='%23f9f0aa' offset='.22'/%3E %3Cstop stop-color='%23b07e09' offset='1'/%3E %3C/linearGradient%3E %3C/defs%3E %3Cpath fill='%234997d0' d='M0 0h960v600H0z'/%3E %3Cpath fill='%23fff' d='M320 0h320v600H320z'/%3E %3Cg stroke='%2324420e'%3E %3Cg fill='none' stroke-width='.44'%3E %3Cpath d='M452.12 377.48c2.67-.4 4.2-1.14 6.04-1.79M460.37 371.64a13.03 13.03 0 0 1 3 4.64M455.25 371.2a15.4 15.4 0 0 1 3.14 4.15M408.81 238.77c-1.04 1.6-3.1 2.73-4.78 3.43M403.69 242c.04-1.37-.24-3.03.05-4.4M401.76 242.63c.11.37.44 1.4.68 2.03M404.46 245.58c-.38.08-1.52.26-2.03.34M398.48 245.04c-.01 2.52.29 5.55.53 7.82M397.22 251.9c.47.76.95 1.5 1.54 1.88M394.18 260.25c.49.94.94 2.12 1.3 3.96M399.2 259.58c-.41.2-1.21.93-1.93 1.54M398.86 265.52c-.98.87-2.2 1.5-3.43 2.12M391.62 308.05a15.98 15.98 0 0 0 3.96 4.68M396.16 314.42a8 8 0 0 1-2.95-.97M397.61 321.86l1.69.97M398.86 326.3c1.25.82 2.51 2.28 3.77 3.86M401.18 333.01c1.39.3 2.5.64 3.23 1.06M403.35 336.49l2.12.07M406.68 331.18c-.1 1.53-.25 2.97-.48 4.25M407.21 337.02l.43-1.64M412.33 341.37l-.15 3.24M451.39 372.51l-1.16 1.6M447.82 370.19l-.68-1.83'/%3E %3C/g%3E %3Cg stroke-width='.16'%3E %3Cpath fill='%23406325' d='M486.11 384.93c-.8-1.26-2.1-2.03-3.28-2.66-7.72-4.05-15.4-5.84-24.11-7.24-2.02-.34-4.03-2.22-6.09-3.19-4.96-2.36-10.49-3.28-15.31-5.7a7.78 7.78 0 0 1-2.1-1.54c-1.93-2.22-5.4-2.9-7.55-4.97-8.33-7.87-17.18-15.12-21.77-25.55-5.57-12.7-12.5-25.79-11.57-40.23.61-9.12-.75-18.35 1.5-27.04 3.33-12.9 7.59-25.64 15.4-36.31l-1.3.82c-7.87 10.67-12.13 23.42-15.46 36.31-2.24 8.7-.89 17.92-1.5 27.04-.93 14.44 6 27.53 11.57 40.28 4.59 10.38 13.49 17.62 21.78 25.55 2.15 2.02 5.62 2.7 7.53 4.97.57.63 1.83 1.4 2.11 1.54 4.83 2.42 10.35 3.34 15.31 5.65 2.06 1.02 4.08 2.85 6.1 3.2 8.7 1.4 16.38 3.23 24.1 7.23a8.02 8.02 0 0 1 3.28 2.66l1.36-.82'/%3E %3Cg fill='%2367923d'%3E %3Cpath d='M406.34 331.62c-2.8-6.3-1.36-21.6-.2-23.53 6.63 13 4.43 23.74.2 23.53zM452.2 377.01c-7.1.36-20.61 9.3-21.86 11.4 15.08.11 24.02-7.32 21.86-11.4zM459.66 372.72c-6.85-5.45-14.19-23.66-14.03-26.5 15.1 10.83 18.93 24.28 14.03 26.5z'/%3E %3Cpath d='M454.61 372.78c-6.95-4.24-15.79-20.11-15.94-22.75 15.2 8.19 20.2 20.12 15.94 22.75zM439.05 366c.98-7.82-5.67-24.24-7.59-25.98-2.95 16.47 3 27.57 7.59 25.98zM411.74 341.72c-2.3-5.65-.61-19.32.47-21 5.52 11.7 3.26 21.22-.47 21zM398.03 264.89c3.59-6.65 18.38-15.71 20.99-15.93-6.77 14.57-18.04 19.83-20.99 15.93z'/%3E %3Cpath d='M398.74 259.33c2.15-7.28 14.87-19.27 17.36-20.03-3.73 15.67-13.68 23.17-17.36 20.03zM426.55 358.48c-5-6.18-8.01-23.86-7.29-26.36 11.27 12.51 12.03 25.23 7.29 26.36zM397.9 322.02c-6.9 1.09-21.36-4.64-22.92-6.34 14.53-3.15 24.29 2.07 22.92 6.34zM395.68 312.34c.82-5.58 8.67-15.8 10.36-16.66-1.1 11.96-7.45 18.6-10.36 16.66zM447.01 370.88c-8.48.43-24.63 11.1-26.13 13.62 18.03.14 28.7-8.74 26.13-13.62z'/%3E %3C/g%3E %3Cg fill='%23406325'%3E %3Cpath d='M406.41 331.47c4.23.21 6.4-10.4-.27-23.38 1.21 12.32 1.2 22.31.27 23.38zM417.59 351.46c-4.47-5.47-19.38-11.33-21.71-11.14 8.88 12.08 19.88 15.1 21.71 11.14zM393.17 298.48c-1.15-8.04-12.33-22.71-14.74-23.97 1.51 17.18 10.55 26.7 14.74 23.97zM401.56 332.77c-5-3.68-18.97-5.34-20.94-4.72 10.14 8.3 20.21 8.46 20.94 4.72zM392.2 307.94c-2.89-5.69-14.81-13.48-16.9-13.7 5.53 12.39 14.57 16.94 16.9 13.7zM394.93 260.4c.9-7.57-5.53-23.45-7.34-25.16-2.87 15.93 2.91 26.67 7.34 25.16zM399.4 245.48c2.66-6.5.76-22.43-.52-24.42-6.4 13.51-3.83 24.65.52 24.42z'/%3E %3Cpath d='M404.42 237.83c3.14-4.77 4.16-17.68 3.48-19.47-7.23 9.71-6.95 18.94-3.48 19.47zM410.37 231.69c4.4-3.48 9.22-15.5 9.08-17.43-9.74 6.95-12.22 15.84-9.08 17.43zM394.32 274.89c.1.87-.98-8.18-10.05-18.31.4 14.81 6.25 20.42 10.05 18.31zM426.88 360.67c-6.18-4.56-23.39-6.73-25.77-5.93 12.56 10.36 24.88 10.55 25.77 5.93zM438.95 365.91c-4.54 1.6-10.44-9.42-7.54-25.88 2.81 13.95 6.18 25.06 7.54 25.88zM452.25 377.06c2.12 4.08-6.7 11.44-21.79 11.31 11.96-4.89 21.24-9.86 21.79-11.31zM459.64 372.59c4.86-2.25 1.1-15.54-14-26.37 8.59 13.21 14.45 24.61 14 26.37z'/%3E %3Cpath d='M454.57 372.67c4.28-2.67-.69-14.44-15.9-22.64 9.41 11.18 16.1 20.97 15.9 22.64zM411.78 341.68c3.73.22 5.96-9.26.48-20.92.72 10.97.42 19.97-.48 20.92zM398.02 264.94c2.95 3.9 14.05-1.3 20.84-15.92-10.17 9.34-19.23 16.06-20.84 15.92z'/%3E %3Cpath d='M398.86 259.33c3.68 3.14 13.54-4.3 17.27-19.98-8.1 11.25-15.64 19.74-17.27 19.98zM426.58 358.42c4.74-1.12 3.95-13.78-7.25-26.27 5 13.41 8.01 24.75 7.25 26.27zM397.71 321.96c1.4-4.24-8.3-9.37-22.8-6.26 12.26 2.2 22.04 5.04 22.8 6.26zM395.77 312.35c2.9 1.89 9.18-4.66 10.29-16.62-4.68 9.18-9.17 16.27-10.29 16.62zM446.97 371.03c2.58 4.88-7.96 13.67-26.04 13.52 14.29-5.84 25.38-11.78 26.04-13.52z'/%3E %3Cpath d='M399.36 326.3c-2.66-6.26-14.8-15.46-16.98-15.84 4.94 13.64 14.25 19.15 16.98 15.84z'/%3E %3C/g%3E %3Cg fill='%2367923d'%3E %3Cpath d='M392.42 273.92c4.07-4.67 17.47-9.13 19.6-8.86-8.04 10.4-17.94 12.51-19.6 8.86zM417.49 351.51c-1.8 3.92-12.7.92-21.65-11.15 10.89 6.83 20.25 11.5 21.65 11.15zM393.1 298.46c-4.2 2.73-13.13-6.74-14.69-23.88 6.63 13.2 13.04 23.38 14.69 23.88zM401.52 332.8c-.77 3.73-10.69 3.59-20.86-4.72 10.72 3.4 19.73 5.34 20.86 4.72zM392.07 307.85c-2.33 3.24-11.29-1.27-16.8-13.66 8.19 7.97 15.48 13.75 16.8 13.66zM394.83 260.3c-4.43 1.56-10.16-9.08-7.3-25 2.67 13.48 5.94 24.17 7.3 25zM399.3 245.44c-4.3.23-6.87-10.81-.47-24.32-.82 12.8-.5 23.23.47 24.32zM404.34 237.77c-3.47-.53-3.72-9.66 3.52-19.37-2.74 9.98-4.15 18.37-3.52 19.37zM410.32 231.69c-3.14-1.64-.7-10.43 9.04-17.34-5.53 8.65-9.32 16.18-9.04 17.34z'/%3E %3Cpath d='M394.25 274.9c-3.8 2.1-9.58-3.5-9.99-18.32 5.1 11.68 8.6 17.8 9.99 18.32zM426.82 360.7c-.89 4.63-13.14 4.4-25.68-5.9 13.17 4.28 24.25 6.7 25.68 5.9zM418.65 351.22c-4.02-4.34-7.16-17.35-6.75-19.24 9.01 8.74 10.22 18.16 6.75 19.24zM401.77 326.23c-3.57-5.79-3.88-20.9-2.92-22.96 8.26 11.81 7.25 22.59 2.92 22.96zM399.14 326.32c-2.74 3.3-11.93-2.16-16.87-15.83 8.13 9.1 15.47 15.8 16.87 15.83z'/%3E %3C/g%3E %3Cg fill='%23406325'%3E %3Cpath d='M392.37 274c1.62 3.62 11.45 1.53 19.5-8.88-11.98 6.8-16.72 9.74-19.5 8.88zM401.71 326.07c4.33-.37 5.33-11.04-2.93-22.85 2.66 11.86 3.79 21.68 2.93 22.85zM418.67 351.18c3.47-1.07 2.25-10.45-6.71-19.18 4.4 9.73 7.2 18.01 6.71 19.18z'/%3E %3Cpath d='M394.23 291.77c2.06-8.39-1.7-22.6-4.3-25.56-4.72 15.43-.24 26.6 4.3 25.56z'/%3E %3C/g%3E %3Cpath fill='%2367923d' d='M393.93 293.77c-5.9 1.34-8.64-12.03-4.08-27.08 1.07 13.55 2.83 26.15 4.08 27.08z'/%3E %3Cpath fill='%2367923d' d='M392.73 293.72c-.56-7.53 6.93-23.09 8.91-24.7 2.02 15.8-4.46 26.3-8.91 24.7z'/%3E %3Cpath fill='%23406325' d='M392.84 293.61c4.41 1.64 10.85-8.76 8.83-24.56-3.5 13.26-7.44 23.76-8.83 24.56z'/%3E %3Cpath fill='%2367923d' d='M394.13 303.26c0-7.6 8.47-22.23 10.56-23.62.84 16.16-6.33 25.83-10.56 23.62z'/%3E %3Cpath fill='%23406325' d='M394.21 303.41c4.23 2.21 11.3-7.36 10.47-23.52-4.4 12.85-9.05 22.9-10.47 23.52z'/%3E %3C/g%3E %3Cg fill='%23ba1f3e' stroke='%23511124' stroke-width='.22'%3E %3Ccircle stroke-width='.19' cx='396.83' cy='251.27' r='1.08'/%3E %3Ccircle stroke-width='.19' cx='405.2' cy='245.07' r='1.08'/%3E %3Ccircle stroke-width='.19' cx='401.56' cy='241.71' r='1.09'/%3E %3Ccircle cx='392.5' cy='313.12' r='1.28'/%3E %3Ccircle cx='395.03' cy='297.13' r='1.28'/%3E %3Ccircle cx='408.21' cy='334.46' r='1.28'/%3E %3Ccircle cx='402.39' cy='336.43' r='1.28'/%3E %3Ccircle cx='446.7' cy='367.63' r='1.28'/%3E %3Ccircle cx='449.61' cy='374.71' r='1.28'/%3E %3C/g%3E %3C/g%3E %3Cg stroke='%2324420e'%3E %3Cg fill='none' stroke-width='.44'%3E %3Cpath d='M561.15 258.97c.62.62 1.17.8 2.3 1.9M556.82 241.92c-.04-1.37-.63-3.6-.92-4.97M559.35 239.93c.06 1.95-.22 3.8-1.06 5.5M554.13 244.9c1.75 1.58 3.5 3.08 5.26 3.9M563.21 250.02a18.7 18.7 0 0 1-.68 5.94M562.85 257.47l1.31-2.26M562.3 267.43c1.4.3 2.81 1.95 3.5 3.48M566.28 269.62l1.64-2.19M569.63 298.16a23.98 23.98 0 0 1-2.46 3.48M563.21 301.57c.79 1.46 1.56 2.95 2.6 4.03M568.26 311.47a13.19 13.19 0 0 1-4.44 4.03M563.96 320c-1.1.75-2.43 2.95-3.69 4.71M568.71 304.53l-2.12.87M565.19 297.91l1.26 1.11M557.15 336.41c-.84-.1-1.46 0-2.12.07M553.03 334.55l.61 1.64M545.93 341.31c-.26 1.87-.07 3.73.2 5.6M550.44 337.89l1.02 2.25M555.29 339.94l-2.53.41M521.91 365.62l-.92 1.74M532.89 363.43c-1.5.19-2.78-.04-4.1-.2M523.33 369.17a27.28 27.28 0 0 0-2.94-.96M505.65 370.87c-.9.77-1.99 2.44-3.07 4.1M502.03 370.4c-2.43 1.25-3.18 3.71-4.44 5.8M500.39 379.07a52.47 52.47 0 0 1-5.33-2.05M511.83 376.34c-2.32-1.2-4.75-1.09-7.14-1.47M515.45 374.53c-3.63-.7-7.01-.61-10.28-.14M512.95 371.79l-1.4-.58M506.02 376.71l-2.32-1.3M561.64 326.22c-1.26.82-2.51 2.28-3.77 3.86M559.7 250.46l-2.15-.72'/%3E %3C/g%3E %3Cg stroke-width='.16'%3E %3Cpath fill='%23406325' d='M474.39 384.85c.8-1.26 2.1-2.03 3.28-2.66 7.72-4.05 15.4-5.84 24.11-7.24 2.02-.34 4.03-2.22 6.1-3.19 4.95-2.36 10.48-3.28 15.3-5.7a7.78 7.78 0 0 0 2.11-1.54c1.92-2.22 5.38-2.9 7.54-4.97 8.33-7.87 17.18-15.12 21.77-25.55 5.57-12.7 12.5-25.79 11.57-40.22-.61-9.13.75-18.35-1.5-27.05-3.33-12.9-7.59-25.64-15.4-36.31l1.3.82c7.87 10.67 12.13 23.42 15.46 36.31 2.24 8.7.89 17.92 1.5 27.05.93 14.43-6 27.52-11.57 40.27-4.6 10.38-13.49 17.63-21.78 25.55-2.15 2.02-5.62 2.7-7.54 4.97a9.98 9.98 0 0 1-2.1 1.54c-4.83 2.42-10.35 3.34-15.31 5.66-2.06 1-4.08 2.84-6.1 3.18-8.7 1.4-16.38 3.24-24.1 7.25a8.02 8.02 0 0 0-3.28 2.65l-1.36-.82'/%3E %3Cg fill='%23406325'%3E %3Cpath d='M553.65 334.6c2.74-7.42 0-24.84-1.49-26.95-6.65 15.37-3.34 27.5 1.49 26.95z'/%3E %3Cpath d='M546.54 341.64c2.3-5.65.61-19.32-.47-21-5.52 11.7-3.26 21.22.47 21zM563.35 267.49c-3.3-6.1-16.87-14.42-19.26-14.62 6.21 13.37 16.55 18.2 19.26 14.62z'/%3E %3Cpath d='M561.76 259.47c-1.8-6.07-12.4-16.05-14.47-16.7 3.1 13.07 11.4 19.32 14.47 16.7zM566.5 274.43c-3.54-4.05-15.16-7.93-17.01-7.7 6.98 9.04 15.57 10.87 17.01 7.7zM563.7 320.76c6.13.97 18.96-4.12 20.34-5.63-12.9-2.8-21.55 1.84-20.34 5.63zM563.55 315.12c-.04-5.64-6.4-16.86-7.96-17.93-.55 12 4.8 19.45 7.96 17.93z'/%3E %3Cpath d='M563.96 301.44c0-7.6-8.47-22.23-10.56-23.62-.84 16.16 6.33 25.83 10.56 23.62zM511.07 376.71c4.48 5.5 19.65 11.13 22.09 10.9-8.8-12.23-20.07-15.05-22.09-10.9z'/%3E %3C/g%3E %3Cg fill='%2367923d'%3E %3Cpath d='M553.56 334.43c-4.82.55-8.09-11.44-1.4-26.79-.49 14.2.24 25.63 1.4 26.79zM500.19 378.09c7.1.36 20.61 9.3 21.86 11.4-15.08.11-24.02-7.32-21.86-11.4zM500.19 370.15c2.1-7.97 15-21.21 17.51-22.15-3.6 17.13-13.74 25.53-17.51 22.15zM521.46 365.92c-.98-7.82 5.67-24.24 7.58-25.98 2.96 16.47-3 27.58-7.58 25.98zM542.92 351.38c4.47-5.47 19.38-11.33 21.71-11.14-8.88 12.08-19.88 15.1-21.71 11.14zM568.71 298.12c.9-6.33 9.71-17.88 11.6-18.87-1.19 13.52-8.3 21.02-11.6 18.87z'/%3E %3Cpath d='M557.02 336.18c5.82-4.29 22.1-6.23 24.4-5.5-11.81 9.67-23.55 9.85-24.4 5.5zM567.29 311.66c3.03-5.98 15.57-14.17 17.75-14.4-5.8 13.02-15.3 17.8-17.75 14.4zM565.81 266.1c-.1-7.63 7.98-22.73 9.97-24.24 1.16 16.14-5.73 26.2-9.97 24.24zM558.88 240.18c-2.32-5.28-1.1-18.41-.1-20.07 5.56 10.96 3.68 20.17.1 20.07zM554.65 238c-5.27-4.68-10.64-19.76-10.41-22.1 11.75 9.26 14.39 20.36 10.41 22.1z'/%3E %3Cpath d='M566.28 272.54c-.32.82 2.94-7.7 14.22-15.3-4.01 14.26-11.04 18.27-14.22 15.3zM532.18 362.44c7-5.17 26.53-7.63 29.23-6.72-14.25 11.74-28.22 11.97-29.23 6.72zM546.51 341.6c-3.73.22-5.96-9.26-.48-20.92-.72 10.97-.42 19.97.48 20.92zM563.36 267.53c-2.7 3.58-12.9-1.2-19.12-14.61 9.33 8.57 17.64 14.74 19.12 14.61zM561.66 259.47c-3.07 2.62-11.29-3.58-14.4-16.65 6.76 9.37 13.05 16.45 14.4 16.65zM566.55 274.5c-1.4 3.15-9.94 1.33-16.92-7.7 10.39 5.89 14.5 8.45 16.92 7.7zM563.86 320.71c-1.25-3.76 7.36-8.32 20.24-5.56-10.88 1.95-19.57 4.48-20.24 5.56zM563.46 315.11c-3.14 1.47-8.45-5.88-7.89-17.88 3.36 9.74 6.83 17.38 7.89 17.88z'/%3E %3Cpath d='M563.88 301.59c-4.23 2.2-11.3-7.36-10.47-23.52 4.4 12.85 9.05 22.9 10.47 23.52zM511.19 376.66c2.02-4.15 13.15-1.38 21.98 10.89-11-6.75-20.49-11.3-21.98-10.89z'/%3E %3C/g%3E %3Cg fill='%23406325'%3E %3Cpath d='M521.55 365.83c4.54 1.6 10.44-9.42 7.54-25.88-2.81 13.95-6.18 25.06-7.54 25.88z'/%3E %3Cpath d='M531.83 360.59c4.34-6.65 5.55-24.55 4.58-26.97-9.94 13.6-9.41 26.33-4.58 26.97zM500.14 378.13c-2.12 4.08 6.7 11.44 21.79 11.31-11.95-4.88-21.24-9.86-21.79-11.31zM500.3 370.08c3.79 3.34 13.8-4.95 17.4-22.08-8.12 12.42-15.71 21.8-17.4 22.08zM543.01 351.43c1.8 3.92 12.7.92 21.65-11.15-10.89 6.83-20.25 11.51-21.65 11.15zM568.76 298.1c3.3 2.15 10.34-5.3 11.56-18.8-5.21 10.4-10.26 18.4-11.56 18.8zM557.07 336.21c.9 4.35 12.45 4.18 24.31-5.5-12.5 3.97-23 6.22-24.31 5.5zM567.43 311.57c2.45 3.4 11.87-1.33 17.66-14.35-8.6 8.37-16.28 14.44-17.66 14.35zM565.92 266.01c4.24 2.02 11.06-7.95 9.9-24.1-4.08 13.14-8.46 23.42-9.9 24.1zM558.96 240.14c3.54.1 5.41-9.03-.13-20 .95 10.5.9 19.08.13 20zM554.73 237.9c3.97-1.74 1.33-12.71-10.42-21.97 6.47 11.02 10.85 20.57 10.42 21.97zM566.34 272.57c3.17 2.97 10.14-1.06 14.15-15.33-7.8 10.08-12.68 15.17-14.15 15.33zM532.25 362.48c1 5.25 14.91 5 29.13-6.69-14.94 4.85-27.5 7.6-29.13 6.69z'/%3E %3Cpath d='M539.14 354.75c3.27-4.93 4.27-18.27 3.56-20.08-7.48 10.08-7.16 19.57-3.56 20.08zM558.74 326.14c3.57-5.79 3.88-20.9 2.92-22.96-8.26 11.81-7.25 22.59-2.92 22.96z'/%3E %3C/g%3E %3Cg fill='%2367923d'%3E %3Cpath d='M531.79 360.54c-4.83-.64-5.33-13.31 4.55-26.87-3.62 13.85-5.46 25.44-4.55 26.87zM566.95 292.21c-.94-7.76 3.98-20.14 6.63-22.52 2.58 14.38-2.66 23.95-6.63 22.52zM539.11 354.7c-3.6-.5-3.9-9.95 3.54-20-2.78 10.3-4.21 18.93-3.54 20zM562.47 250.46c-2.17-5.88.03-20.04 1.24-21.77 5.28 12.25 2.63 22.11-1.24 21.77zM504.39 370.61c2.47-8.1 16.2-21.08 18.8-21.91-4.33 17.42-15.06 25.52-18.8 21.91zM558.92 329.02c2.66-6.26 14.8-15.46 16.98-15.84-4.94 13.64-14.25 19.14-16.98 15.84zM558.8 325.99c-4.33-.37-5.33-11.04 2.93-22.85-2.66 11.86-3.79 21.68-2.93 22.85z'/%3E %3C/g%3E %3Cpath fill='%23406325' d='M567 294.04c5.16 1.84 9.08-9.89 6.6-23.91-2.43 12.06-5.38 23.2-6.6 23.91z'/%3E %3Cpath fill='%23406325' d='M567.77 293.64c.56-7.53-6.93-23.09-8.92-24.7-2.01 15.8 4.47 26.3 8.92 24.7zM562.55 250.42c3.83.34 6.47-9.43 1.19-21.69.33 11.45-.29 20.75-1.19 21.69zM504.5 370.53c3.79 3.62 14.37-4.42 18.7-21.84-8.84 12.35-16.96 21.61-18.7 21.84zM559.14 329.04c2.74 3.3 11.93-2.16 16.87-15.83-8.13 9.1-15.47 15.8-16.87 15.83z'/%3E %3Cpath fill='%2367923d' d='M567.66 293.53c-4.41 1.64-10.85-8.76-8.83-24.56 3.5 13.26 7.44 23.76 8.83 24.56z'/%3E %3C/g%3E %3Cg fill='%23ba1f3e' stroke='%23511124' stroke-width='.22'%3E %3Ccircle cx='564.63' cy='254.9' r='1.08'/%3E %3Ccircle cx='568.41' cy='266.82' r='1.08'/%3E %3Ccircle cx='569.76' cy='304.3' r='1.28'/%3E %3Ccircle cx='564.65' cy='297.29' r='1.28'/%3E %3Ccircle cx='549.91' cy='337.17' r='1.28'/%3E %3Ccircle cx='556.2' cy='339.9' r='1.28'/%3E %3Ccircle cx='513.8' cy='372.26' r='1.28'/%3E %3Ccircle cx='506.8' cy='377.29' r='1.28'/%3E %3Ccircle cx='557.05' cy='249.25' r='1.08'/%3E %3C/g%3E %3C/g%3E %3Cg id='b' fill='%238c959d' stroke='%23485654' stroke-width='.11'%3E %3Cpath d='M434.25 336.27c-.13 1.07.84 2.34 2.13 2.07.38-.08.62-.58.13-.49-.43.1-.88-.07-1.2-.37a1.68 1.68 0 0 1-.4-1.92l-.66.7v.01z'/%3E %3Cpath stroke='none' d='M437.24 338.34c-1.02 1.17-2.57 1.68-3.43.83-.57-.56-.77-1.2-.47-1.9l-1.12 1.22c.05.1.72 1.31 1.71 1.76 1.22.55 2.97-.28 4.02-1.56.74-.91 1.56-2.43.97-3.61a3.98 3.98 0 0 0-1.97-1.7l-1.03 1.1c.51-.24 1.15-.13 1.7.31 1.27 1.04.53 2.5-.38 3.55z'/%3E %3Cpath fill='%23485654' stroke='none' d='M437.24 338.34a4 4 0 0 1-1.16.96c-.45.23-.96.39-1.47.31-.26-.03-.51-.13-.72-.3-.2-.16-.37-.35-.5-.57a1.61 1.61 0 0 1-.25-.74c-.02-.26.04-.53.14-.77l.12.08-1.11 1.24.01-.1c.28.48.63.94 1.05 1.3a1.99 1.99 0 0 0 1.5.57c.53-.01 1.07-.2 1.56-.47a5.1 5.1 0 0 0 1.3-1.05c.37-.41.69-.88.93-1.38.24-.5.41-1.05.38-1.6a1.83 1.83 0 0 0-.23-.77c-.13-.24-.3-.46-.5-.66-.39-.4-.86-.72-1.37-.93l.1-.02-1.04 1.09-.09-.12c.24-.1.5-.14.76-.11.25.02.5.11.71.24.43.26.8.65.93 1.14.13.5 0 1.01-.21 1.45a5.1 5.1 0 0 1-.84 1.2v.01zm0 0c.31-.38.6-.78.8-1.23.19-.44.3-.94.16-1.4-.13-.46-.5-.83-.9-1.06-.4-.24-.92-.3-1.34-.1l-.09-.12 1.02-1.11.04-.04.05.02a4.17 4.17 0 0 1 1.98 1.66c.15.25.23.55.25.85.05.6-.13 1.17-.38 1.7-.25.52-.58 1-.96 1.44-.4.43-.85.8-1.36 1.08a3.7 3.7 0 0 1-1.67.5 2.2 2.2 0 0 1-1.62-.63 5 5 0 0 1-1.07-1.37l-.03-.05.04-.05 1.13-1.22.12.08c-.1.22-.15.46-.14.7.01.24.1.48.22.68.12.21.29.4.47.56.19.16.42.25.66.3.49.08 1-.06 1.43-.28.45-.22.85-.54 1.19-.91z'/%3E %3Cpath fill='%236c301e' stroke='%23351710' stroke-width='.22' stroke-linejoin='round' d='M515.24 249.25l-40.14 39.52c-3.05 3.03-37.96 36.37-41.1 39.38-1.1 1.32-4.23 4.86-4.56 5.35-2.13 2.31-4.44 5.33-7.2 8.03-.5.62-1.14.4-1.73.74a23.38 23.38 0 0 0-5.06 4.37l-12.2 13.5c-.8.86-1 1.39-.47 1.88l6.62 8.85c1.23 1.2 2.65 1.83 3.2.81 3.15-5.44 10.96-13.75 13.91-20.33 1.77-3.93 3.98-11.06 5.56-12.78 1.94-2.16 7.17-7.73 11.8-12.7l.94-1 .94-1.02c23.51-23.95 50.72-53.05 70.53-73.56-.78-.78-.29-.31-1.04-1.04z'/%3E %3Cpath d='M431.89 328.11c-1.23.04-2.02-.7-2.85-1.4 1.17.35 2.35.8 3.45.34l-.6 1.06z'/%3E %3Cpath fill='%23b2b6ba' stroke-width='.22' d='M557.05 220.1l-31.8 26.22c-.31.37-.63.27-.93 0l-2.9-2.42.02-.1c0-.17-.04-.33-.09-.47l1.42-1.45c.18-.22.12-.3-.12-.55l-.59-.6c-.22-.17-.41-.03-.64.18L520 242.4c-.74.03-1.33.63-1.35 1.36-19.24 18.73-35.8 35.44-54.94 53.87l-22.57 21.55c-.81 1.05-4.3 2.91-6.6 4.41a5.63 5.63 0 0 0-1.82 1.55l-1.84 5.43c-.58 1.2-2.43 4-2.51 4.2 2.36 2.38 2.24 2.2 3.86 3.72 1.82-2.02 6.7-7.1 11.12-11.85.35-.38.38-.42.83-.97a13.32 13.32 0 0 0-2.6-2.74l-.62-.55c-.17-.16.24-.44.42-.64 26.47-25.58 54.96-53.7 78.28-76.6a1.41 1.41 0 0 0 1.02-.1l2.79 3.22c.65.65 1.2.63 1.73.4l31.86-28.55z'/%3E %3Cpath fill='%23485654' stroke='none' d='M430.95 330.39c.2.03.4.05.6.03.2-.02.4-.07.58-.16l-.02.02a139.62 139.62 0 0 1 1.47-4.74l.01.02c-.2-.22-.43-.42-.73-.5.3.06.56.25.77.46l.01.02v.01l-.71 2.38-.75 2.37v.01h-.02c-.19.1-.4.15-.6.15-.2 0-.41-.03-.61-.07z'/%3E %3Ccircle fill='none' stroke-width='.16' cx='438.18' cy='328.13' r='.62'/%3E %3Ccircle fill='none' stroke-width='.16' cx='434.44' cy='331.88' r='.62'/%3E %3Cpath fill='%23485654' stroke='none' d='M440.97 322.38a11.74 11.74 0 0 1-1.74-1.63 11.63 11.63 0 0 1 1.74 1.63z'/%3E %3Cpath d='M502.17 259.06l3.49 3.41.64-.59-3.48-3.4-.65.58z'/%3E %3C/g%3E %3Cuse xlink:href='%23b' transform='scale(-1 1) rotate(-2.84 -9.26 19640.24)'/%3E %3Cg stroke='%2324420e' stroke-width='.16'%3E %3Cpath fill='%2367923d' d='M433.91 365.36c-7.87-3.32-26.89-.67-29.22.93 16.29 8.01 29.54 4.58 29.22-.93zM522.93 368.68c7.87-3.32 26.89-.67 29.22.93-16.29 7.98-29.54 4.58-29.22-.93z'/%3E %3Cpath fill='%23406325' d='M433.76 365.48c.32 5.5-12.79 8.89-29.07.9 15.29.94 27.79.38 29.07-.9zM523.08 368.77c-.32 5.5 12.79 8.89 29.07.9-15.29.94-27.79.41-29.07-.9z'/%3E %3C/g%3E %3Cg id='c'%3E %3Cpath fill='%23b2b6ba' stroke='%23485654' stroke-width='.22' d='M508.49 359.99c-20.73-30.12-52-54.61-76.1-68 3.55-.16 11.46 3.89 14.67 5.96 23.94 15.42 44.3 35.8 65.66 59.82a35.2 35.2 0 0 1-3.44 3.05l-.79-.83z'/%3E %3Cpath fill='%238c959d' d='M510.55 359.75l-1.45 1.4C486.09 331.51 454 303.2 432.43 292c30.08 13.86 55.4 41.77 78.03 67.65l.09.09z'/%3E %3Cpath fill='%23485654' d='M510.56 359.75l-1.45 1.4a302.96 302.96 0 0 0-16.87-19.73 336.02 336.02 0 0 0-18.37-18.34 284.92 284.92 0 0 0-19.8-16.76 195.86 195.86 0 0 0-10.55-7.56c-3.6-2.4-7.3-4.66-11.13-6.65l.1-.2c7.89 3.65 15.33 8.2 22.37 13.29a210.61 210.61 0 0 1 20.03 16.63 359.99 359.99 0 0 1 18.33 18.5c5.9 6.36 11.63 12.89 17.34 19.42za897.45 897.45 0 0 0-17.42-19.35c-5.92-6.35-12-12.56-18.35-18.47-6.36-5.9-13-11.51-20.04-16.59a134.67 134.67 0 0 0-22.36-13.23l.1-.2c3.84 2 7.54 4.28 11.14 6.68 3.6 2.4 7.11 4.95 10.55 7.58a284.86 284.86 0 0 1 19.8 16.8 336.06 336.06 0 0 1 18.34 18.37 302.66 302.66 0 0 1 16.8 19.8h-.01l1.45-1.39z'/%3E %3Cg fill='%23fab81c' stroke='%236c301e' stroke-width='.11'%3E %3Cpath stroke-width='.22' d='M517.5 355.07a18.32 18.32 0 0 0-5.26 2.23c-.23 1.4-1.95 2.95-3.58 3.3l-.6-.76a.13.13 0 0 0-.17-.04 6.9 6.9 0 0 0-.57.34c-.6-.1-1.34.2-1.66.97-.38.97.39 2.25 1.23 3.09.92.73 1.38 1.07 2.45.92 1.09-.23 1.68-1.22 1.93-1.53 3.72 4.5 6.52 6.93 11.23 10.64 2.1.02 3.22-1.3 2.52-2.8-.23-.5-.84-.84-1.33-.66.04-.15.02-.3 0-.45 2.46-2.26 3.5-5.08.91-9.87-2.22-4.03-4.71-5.4-7.09-5.38h-.01zm6.25 4.53c.43.74.69 1.38 1.02 2.05 1.48 3 .2 6.6-2.33 7.71-.13 0-.09-.02-.22.02.42-.69-.82-2.15-1.46-1.64.3-.76-.67-2.02-1.46-1.7.42-.7-.53-1.9-1.42-1.5.46-.77-.32-1.87-1.24-1.67.27-.82-.42-1.76-1.35-1.6.07-.72-.16-1.12-.51-1.45 1.11-.85 2.35-2.15 3.44-2.74 2.72-1.18 4.4 1.07 5.52 2.52z'/%3E %3Cpath d='M524.89 362.77c-.52-.25-.76-.76-.59-1.1.17-.35.7-.44 1.22-.18.52.25.8.74.63 1.09-.17.34-.74.45-1.26.2v-.01z'/%3E %3Cpath d='M524.59 361.75c-.52-.25-.76-.76-.59-1.1.17-.35.7-.44 1.22-.18.52.25.8.74.63 1.09-.17.34-.74.45-1.26.2v-.01z'/%3E %3Cpath d='M523.97 360.62c-.52-.25-.76-.76-.59-1.1.17-.35.7-.44 1.22-.18.52.25.8.74.63 1.09-.17.34-.74.45-1.26.2v-.01z'/%3E %3Cpath d='M523.19 359.6c-.52-.25-.76-.76-.59-1.1.17-.35.7-.44 1.22-.18.52.25.8.74.63 1.09-.17.34-.74.44-1.26.2v-.01z'/%3E %3Cpath d='M522.16 358.61c-.52-.25-.76-.76-.59-1.1.03-.05.01-.14.06-.12.2.1.64.19.6-.14-.07-.1-.15-.22-.07-.14.14 0 .46.14.63.22.52.26.8.75.63 1.1-.17.33-.74.44-1.26.19v-.01z'/%3E %3C/g%3E %3Cg fill='%23fab81c'%3E %3Cpath d='M511.27 363.6c.68-1.77 2.05-3.41 3.5-3.8M511.5 363.85c1.26.26 3.3-1.24 3.8-2.59M512.69 365.3c1.66.38 3.3-1.22 3.93-2.4M514.18 366.88c1.96.06 3.16-1.33 3.74-2.39M515.69 368.41c1.66.01 3.17-1.36 3.65-2.42M517.15 369.81c1.8-.07 3.08-.9 3.62-2.07M518.79 371.23c1.66.1 3-.9 3.44-1.86M520.57 372.68c1.66.1 2.7-.93 3.14-1.9'/%3E %3C/g%3E %3Cg fill='%236c301e'%3E %3Cpath d='M511.27 363.6a7.03 7.03 0 0 1 2.3-3.24c.36-.26.77-.47 1.2-.57-.42.14-.8.37-1.16.63-.35.27-.66.58-.95.92a9.24 9.24 0 0 0-1.39 2.26zM511.5 363.85c.4.06.8-.04 1.18-.2a5.65 5.65 0 0 0 1.95-1.4c.27-.29.51-.62.68-.99-.13.4-.36.74-.62 1.06a5.26 5.26 0 0 1-1.98 1.42 2.1 2.1 0 0 1-1.21.11zM512.69 365.3c.4.07.82.04 1.2-.09.39-.12.75-.3 1.08-.54a6.24 6.24 0 0 0 1.65-1.77 5.2 5.2 0 0 1-1.6 1.86c-.33.23-.7.43-1.1.53-.4.11-.84.13-1.23.01zM514.18 366.88a3.83 3.83 0 0 0 2.18-.69c.32-.21.6-.48.86-.76.26-.3.5-.6.7-.94-.33.7-.85 1.34-1.5 1.79a3.37 3.37 0 0 1-2.24.6zM515.69 368.41a4.1 4.1 0 0 0 2.11-.77 5.16 5.16 0 0 0 1.54-1.65c-.14.36-.36.68-.61.97a4.25 4.25 0 0 1-1.9 1.29c-.37.12-.76.18-1.14.16zM517.15 369.81c.36-.04.73-.1 1.08-.19a4.63 4.63 0 0 0 1.89-1.01c.26-.26.48-.55.65-.87-.13.34-.34.65-.6.93a3.5 3.5 0 0 1-.88.66c-.66.34-1.4.5-2.14.48zM518.79 371.23a4.54 4.54 0 0 0 1.97-.48c.3-.15.58-.35.84-.58s.47-.5.63-.8c-.12.32-.33.61-.58.86a3.58 3.58 0 0 1-2.86 1zM520.57 372.68c.33 0 .65-.04.96-.12a3.3 3.3 0 0 0 1.62-.99c.22-.23.4-.5.56-.79a2.96 2.96 0 0 1-3.14 1.9z'/%3E %3C/g%3E %3C/g%3E %3Cuse xlink:href='%23c' transform='scale(-1 1) rotate(-3.41 -13.8 16470.84)'/%3E %3Cg stroke='%2324420e' stroke-width='.16'%3E %3Cpath fill='%23406325' d='M409.24 240.02c7.21-2.37 18.73-15.45 19.48-17.92-15.6 4.16-22.76 14.35-19.48 17.92zM554.98 244.72c-1.7-7.04-13.28-19.01-15.57-19.91 2.77 15.16 11.92 22.76 15.57 19.91z'/%3E %3Cpath fill='%2367923d' d='M409.24 240.02c-3.32-3.57 3.8-13.67 19.34-17.82-10.96 8.4-19.2 16.18-19.34 17.82zM554.98 244.72c-3.66 2.9-12.72-4.65-15.49-19.77 7.17 11.07 13.94 19.51 15.49 19.77z'/%3E %3C/g%3E %3Cg stroke='%23999270' stroke-width='.16'%3E %3Cpath fill='url(%23d)' d='M452.21 318.1s-6.16.66-7.88-7.83c-1.85-9.09 5.3-10.06 5.3-10.06s8.1-.78 13.15-.9l2.24 17.95-12.81.84z'/%3E %3Cpath fill='url(%23e)' d='M453.02 315.36s-3.98.76-4.8-5.55c-.59-4.48 2.18-5.11 2.18-5.11l9.23 1.56.05 8.24-6.66.86z'/%3E %3Cpath fill='url(%23f)' d='M450.4 304.7s5.9-.43 8.99-.83l1.28 5.71-7.1.45s-.49-5.16-3.17-5.33z'/%3E %3Cpath fill='url(%23g)' d='M449.16 300.36s7.58-1.86 8.52 6.49c.24 2.18-.94 7.17-4.66 8.51l13.88-1.45-1.26-15.01-4.68.39s-9.92.34-11.8 1.07z'/%3E %3Cpath fill='%23f9f0aa' d='M452.2 318.1c.05 0 51.9-3.5 57.22-3.27 15.74-8.64-.08-42.56-13.35-61.54 1.52-4.27-29.85-13.89-44.04-13.02-1.78.1-3.5.23-5.16.35-7.7.82-7.77 10.7-4.63 16.93 3.04 6.04 30.31 55.12 11.14 60.31l-1.18.24z'/%3E %3Cpath fill='url(%23h)' d='M507.79 273.34a148.36 148.36 0 0 0-11.72-20.05c1.52-4.27-29.86-13.89-44.04-13.02-1.79.1-3.51.23-5.16.35-7.7.82-7.77 10.7-4.64 16.93.96 1.9 4.3 8.04 7.85 15.73'/%3E %3Cpath fill='url(%23i)' d='M455.04 284.95c5.55 14.65 8.66 30.12-1.64 32.9l-1.18.24c.05 0 51.9-3.49 57.22-3.27 8.54-4.68 7.8-16.8 3.2-29.94'/%3E %3Cpath fill='url(%23j)' d='M447.4 243.49c-3.7 0-4.66 3.56-4.6 5.82.13 5.9 4.6 6.19 4.6 6.19l5.96-.33 2.86-12.17-8.82.49z'/%3E %3Cpath fill='url(%23k)' d='M447.4 243.53l8.82-.49.91 9.09-7.7.34s2.5-7.28-2.03-8.94z'/%3E %3Cpath fill='url(%23l)' d='M496.12 253.29c6.69-1.07 6.6-10.07 2.03-13.67-15.5-.57-35.9-.15-50.63.96 1.67-.05 6.33.37 6.85 6.5a8.2 8.2 0 0 1-3.06 7 6.93 6.93 0 0 1-3.9 1.45c.24.1 2.16.01 3.6-.08.73-.05 2.54-.27 3.05-.33 21.01-2.76 41.99-1.83 41.99-1.83h.07z'/%3E %3Cg fill='%23b07e09' stroke='none'%3E %3Cpath d='M458.47 267.42c-.14-.33-.32-.75-.73-.8-.25 0-.65-.06-.57-.4.24-.11.54-.04.8-.06.56 0 1.11-.12 1.67-.15.34.1.26.54-.1.46-.41.1-.18.57-.08.81.44 1.04.87 2.08 1.33 3.1.12.31.38.58.72.61.36.04.75.05 1.09-.11.3-.2.24-.63.2-.94-.13-.36.54-.28.5.04.12.43.27.86.44 1.27-.02.2-.28.15-.42.17-1 .08-1.99.13-2.98.22-.32-.01-.8.28-.99-.1-.12-.38.51-.16.6-.45 0-.33-.2-.62-.31-.92l-1.17-2.75zM463.3 267.08c-.14-.32-.3-.72-.69-.8-.24-.02-.65-.01-.61-.37.15-.16.45-.06.67-.1.59.03 1.17-.08 1.76-.14.29-.02.4.52.02.45-.35.01-.38.4-.23.65.47 1.14.96 2.28 1.44 3.41.1.25.24.55.54.59.25.05.65-.03.7.32-.04.26-.43.11-.63.16a6.58 6.58 0 0 0-1.55.12c-.23.06-.55.02-.56-.27.05-.28.58-.07.6-.4-.03-.33-.2-.62-.32-.93l-1.14-2.69zM467.76 267.79c.09.23.4.06.59.08.26-.03.54-.22.51-.51-.04-.45-.26-.91-.63-1.19-.34-.24-.78-.21-1.17-.16-.02.16.1.3.15.45l.55 1.33zm.67 1.6c.16.35.28.74.56 1.01.25.17.57.1.85.07.3-.02.48-.33.38-.61-.14-.64-.55-1.3-1.24-1.44-.3-.05-.61-.06-.91 0-.02.15.09.3.13.43l.23.54zm-2.04-2.38c-.15-.34-.3-.76-.68-.92-.25-.08-.65.03-.7-.32.06-.3.56-.1.8-.16.86-.03 1.74-.27 2.6 0 .73.17 1.39.8 1.44 1.58.03.38-.26.68-.58.84-.04-.14.37.06.5.08.6.19 1.13.58 1.39 1.14.2.4.35.93.04 1.32-.36.4-.94.41-1.44.43-.75.02-1.5.03-2.25.18-.26.04-.45-.48-.08-.45.37-.02.4-.42.24-.67l-1.28-3.05zM473.81 265.11c.33-.05.36.32.46.53.1.29.27.54.35.83-.28.28-.5-.14-.63-.36-.14-.24-.38-.47-.69-.45-.4 0-.81.02-1.22.07-.14.16.07.4.12.58.19.45.36.9.56 1.34.27-.02.62.02.81-.2.08-.24-.27-.75.21-.65.3.17.26.6.42.89.12.38.38.72.49 1.11-.26.29-.53-.13-.62-.36-.19-.35-.63-.3-.96-.3-.24-.05-.08.17-.04.28.21.5.38 1.01.66 1.48.2.34.65.3 1 .28.32-.02.72-.03.92-.34.21-.25-.28-.75.13-.83.35-.03.34.38.43.6.07.29.18.56.28.83-.02.2-.28.14-.42.16-1.02.07-2.04.11-3.06.2-.3 0-.8.23-.9-.2.02-.3.64-.14.55-.55-.07-.35-.25-.66-.37-1-.38-.89-.73-1.8-1.12-2.68-.14-.3-.37-.62-.73-.63-.24.04-.6-.13-.47-.41.35-.07.72-.02 1.07-.06l2.77-.16zM476.12 266.43c-.15-.35-.3-.77-.68-.93-.26-.08-.72.01-.7-.4.25-.18.66-.03.97-.08.8-.01 1.62-.24 2.41 0 .82.23 1.52.97 1.57 1.84.03.41-.3.75-.68.86-.3.02.23.1.3.2.64.3 1.08.87 1.41 1.47.08.23.52.7.59.25-.03-.5.64-.08.49.26 0 .36-.35.59-.68.58-.47.04-.9-.23-1.14-.62-.42-.55-.71-1.22-1.27-1.66-.23-.17-.56-.27-.83-.15-.05.14.07.28.1.41.19.41.31.85.55 1.22.2.31.6.36.94.36.36.09.25.58-.13.43-.58 0-1.17-.04-1.75.08-.27.13-.87.01-.65-.37.28-.02.67-.17.48-.53-.33-.87-.7-1.73-1.05-2.6l-.25-.62zm1.4.9c.14.32.6.14.87.1.35-.07.34-.5.23-.77-.16-.47-.37-1.03-.9-1.2-.25-.03-.84-.2-.88.16.2.53.43 1.05.63 1.58l.05.12zM484.74 269.04c.1.26.21.61.54.66.25.05.66-.03.71.33-.04.26-.43.1-.63.14a7.1 7.1 0 0 0-1.6.08c-.24.07-.56-.03-.53-.32.13-.2.65-.03.62-.4-.08-.4-.27-.77-.41-1.15l-1.15-2.88c-.1-.31-.45-.3-.7-.28-.28 0-.69.06-.69.41-.08.23.22.62-.04.74-.3.06-.36-.28-.43-.5-.1-.31-.26-.6-.38-.92.03-.21.32-.17.49-.2l4.13-.16c.3-.05.5.19.52.47.1.34.27.66.41.98-.11.33-.5.04-.55-.2-.2-.35-.51-.7-.94-.7-.26 0-.64-.1-.82.14.01.24.15.45.22.67l1.23 3.09zM488.47 268.13c-.2 0-.1.24-.12.37.01.28-.02.57.03.85.13.3.53.23.79.31.23.13.17.5-.14.4-.42-.03-.85-.08-1.27.02-.25.14-.71-.12-.49-.39.2-.03.45-.1.5-.33.07-.42.03-.84.04-1.26l.02-3.71c.12-.28.52-.05.6.16 1.2 1.52 2.38 3.05 3.6 4.54.2.23.46.4.77.42.26 0 .4.53.03.42-.52-.03-1.03-.06-1.54.03-.23 0-.5.1-.7-.03-.24-.17-.07-.43.2-.4.35-.1 0-.48-.12-.65-.19-.26-.38-.52-.59-.75-.17-.09-.37-.03-.55-.04l-1.06.04zm1.17-.51c.19.01-.05-.16-.08-.24l-1.28-1.66c.09-.01.02.18.04.26v1.68l1.32-.04zM492.7 265.77c-.15-.4-.35-.89-.82-.98-.24.04-.7-.18-.45-.44.55 0 1.1.03 1.65-.02.7-.06 1.42-.04 2.08.2a4.35 4.35 0 0 1 2.92 3.33c.1.6-.08 1.3-.63 1.64-.73.47-1.64.38-2.47.33-.47-.02-.94.04-1.4.09-.3-.04-.34-.51.02-.46.37 0 .37-.42.23-.66l-1.13-3.03zm1.97 2.5c.15.33.24.75.56.97.3.14.66.12.98.08.44-.06.72-.5.72-.91a4.27 4.27 0 0 0-.63-2.13 2.65 2.65 0 0 0-1.84-1.37c-.33-.05-.67-.1-1-.05-.07.13.06.27.1.4l1.11 3zM473.56 280.68c.12.35.44.6.8.63.26.05.7-.01.72.36-.14.23-.53.07-.77.12-.52 0-1.04 0-1.55.1-.28 0-.57.12-.84.04-.24-.12-.2-.47.1-.43.26-.05.61-.13.63-.44-.02-.29-.18-.54-.28-.8l-1.15-2.75c-.09-.33-.45-.34-.71-.29-.25.05-.62.13-.68-.22.03-.29.5-.24.7-.39.31-.12.62-.25.94-.35.22-.05.32.15.38.32l1.71 4.1zM474.31 276.17c.68-.03 1.37.08 2.05 0 .3-.03.1-.5.38-.47.37.02.31.48.33.74a.52.52 0 0 1-.56.58c-.54.03-1.07-.05-1.6-.02.12.42.29.81.44 1.21.03-.13.46-.15.64-.18a2.78 2.78 0 0 1 2.61 1.54c.22.48.33 1.1-.02 1.55-.4.45-1.03.54-1.6.55-.49 0-1.06-.11-1.35-.55-.17-.22-.14-.68.22-.64.3 0 .66.26.6.6.17.22.53.14.78.13.3 0 .59-.24.57-.55 0-.49-.18-.97-.45-1.36-.3-.43-.78-.71-1.3-.7-.3-.05-.55.15-.83.15-.29-.04-.34-.37-.44-.58-.23-.6-.46-1.2-.65-1.82-.02-.1.08-.2.18-.18zM481.16 277.19c-.16-.4-.37-.88-.84-.97-.24.06-.7-.17-.46-.43.55-.02 1.11 0 1.67-.07.7-.08 1.43-.07 2.1.18 1.5.5 2.71 1.82 2.94 3.39.09.58-.11 1.24-.63 1.56-.72.47-1.61.4-2.43.38-.45 0-.9.07-1.34.13-.3-.04-.36-.5 0-.46.38-.03.35-.45.2-.69l-1.21-3.02zm2.03 2.46c.16.34.26.75.59.97.3.14.65.1.97.05.44-.07.69-.52.68-.94 0-.76-.32-1.48-.7-2.13a2.64 2.64 0 0 0-1.86-1.33 3 3 0 0 0-.98-.02c-.07.13.06.27.1.4l1.2 3zM489.63 275.39c.31-.05.35.3.44.5.1.29.24.55.34.84-.19.3-.5-.06-.59-.29-.14-.24-.35-.52-.67-.5-.41-.03-.82 0-1.23.03-.23.1.01.39.05.56.18.45.35.92.54 1.36.27 0 .58.01.8-.15.18-.21-.27-.74.21-.68.33.12.28.57.42.84.12.4.35.74.49 1.14-.18.33-.54-.06-.6-.3-.14-.33-.51-.37-.82-.36-.2-.03-.37.01-.23.22.22.51.38 1.05.66 1.54.2.35.65.3 1 .3.32-.01.73 0 .93-.32.2-.24-.2-.66.08-.8.34-.1.42.27.47.51.08.31.18.6.29.9-.03.2-.28.14-.43.16-1.03.04-2.06.06-3.09.12-.28-.01-.69.21-.87-.1-.18-.4.5-.19.53-.53.03-.3-.15-.58-.25-.86-.38-.96-.75-1.94-1.14-2.9-.14-.31-.36-.66-.74-.68-.24.04-.6-.13-.46-.4.36-.07.73-.01 1.1-.04l2.77-.11zM462.35 289.67c.15.49.67.69 1.11.82.77.26 1.6.52 2.15 1.16.3.37.52.85.5 1.34-.04.5-.47.87-.93.99-.57.18-1.2.13-1.73-.1-.27-.11-.17.47-.5.27-.24-.18-.16-.56-.3-.81-.1-.33-.24-.65-.38-.97.01-.32.48-.15.5.1.32.6.92 1.12 1.63 1.13.36 0 .8-.18.83-.59.01-.53-.41-.95-.86-1.18-.64-.33-1.38-.44-2-.81a1.94 1.94 0 0 1-.94-1.61c.01-.44.37-.78.77-.9.5-.17 1.05-.2 1.56-.06.24.13.34-.27.6-.07.11.2.08.46.2.67.07.29.26.54.33.82-.16.25-.47.02-.52-.2-.22-.36-.52-.77-.98-.8-.35-.03-.79-.03-1.01.29-.1.15-.1.35-.03.51zM469.04 288.02c.33-.06.34.31.42.53.08.27.2.53.29.8-.14.28-.5.02-.54-.21-.14-.26-.34-.58-.67-.56-.41 0-.82.03-1.23.08-.23.1 0 .39.03.57l.46 1.36c.27-.02.58-.01.8-.18.2-.2-.19-.6.14-.7.38-.05.35.44.44.68.1.45.33.85.46 1.29-.14.32-.53.01-.55-.25-.1-.33-.48-.4-.79-.37-.17 0-.42 0-.27.22.18.5.32 1.02.55 1.5.12.3.45.35.73.33.39-.03.84.01 1.15-.28.24-.24.04-.59.1-.85.24-.2.52.06.5.34.06.34.15.68.26 1.02-.04.2-.3.14-.44.17-1.02.08-2.04.13-3.06.23-.28-.02-.68.23-.85-.1-.16-.37.45-.2.53-.5.09-.29-.1-.57-.17-.85-.33-.98-.65-1.96-1-2.94-.12-.3-.33-.66-.7-.66-.24.06-.6-.13-.43-.4.35-.07.71-.03 1.07-.07l2.77-.2zM473.22 292.16c.1.3.27.64.61.7.25.09.67-.07.73.29 0 .32-.49.15-.7.2-.52-.03-1.03 0-1.53.1-.22.04-.55.11-.6-.18-.06-.34.45-.15.56-.4.08-.26-.06-.52-.13-.77-.34-1-.66-2.01-1.01-3.01-.11-.3-.27-.68-.63-.71-.23-.01-.63-.03-.56-.37.18-.16.49-.05.71-.08.74.01 1.45-.2 2.19-.15.75.03 1.48.51 1.73 1.23.17.4.22.92-.08 1.28-.39.45-1.02.55-1.58.62-.21-.03-.04.2-.03.3l.32.95zm-.57-1.72c.2.03.46-.03.67-.08.32-.07.48-.4.4-.7a2.24 2.24 0 0 0-.54-1.17c-.3-.26-.75-.26-1.12-.17-.13.12 0 .32.04.47l.55 1.65zM478.8 291.87c.09.25.17.61.5.65.24.06.65-.03.68.32-.06.27-.44.12-.64.16a7.09 7.09 0 0 0-1.6.1c-.23.09-.55-.01-.5-.3.14-.22.65-.05.64-.42-.05-.39-.21-.75-.33-1.13l-.95-2.9c-.07-.31-.43-.3-.68-.27-.25.02-.62.05-.69.35-.08.25.04.53-.01.78-.24.16-.47-.1-.46-.33-.08-.35-.2-.68-.34-1-.01-.24.3-.22.47-.24l4.15-.25c.3-.05.49.19.48.47.08.34.22.66.34.98-.06.28-.48.13-.5-.12-.17-.36-.44-.74-.87-.76-.28 0-.63-.06-.86.12-.05.2.08.4.13.6l1.04 3.19zM480.9 288.58c-.1-.3-.22-.7-.57-.79-.24-.06-.65.01-.63-.35.1-.22.42-.09.61-.12.6.02 1.2-.06 1.79-.12.26-.12.48.42.15.42-.25 0-.55.19-.44.47.13.53.32 1.05.48 1.57.24.73.47 1.47.72 2.2.07.23.25.43.5.44.24 0 .66.04.59.38-.18.16-.48.06-.71.08-.54-.04-1.07.05-1.6.11-.24.1-.54-.13-.4-.37.2-.1.65-.05.62-.39-.08-.4-.24-.8-.36-1.2l-.75-2.33zM486.66 286.98c.32-.06.33.3.4.52.08.27.2.54.28.81-.14.29-.5.02-.53-.22-.13-.26-.33-.57-.67-.56-.4-.01-.82.02-1.23.05-.23.1-.01.4.02.57.14.45.28.91.44 1.36.27-.01.58 0 .8-.16.2-.2-.18-.61.16-.7.37-.03.34.45.42.7.09.45.32.85.44 1.29-.11.29-.52.04-.52-.22-.1-.32-.43-.45-.74-.42-.15.02-.5-.07-.36.17.17.52.3 1.05.53 1.55.12.28.45.35.73.33.4-.02.85.03 1.16-.26.25-.22.05-.58.11-.84.26-.2.53.07.5.35.06.34.15.68.25 1.02-.05.2-.28.14-.43.16-1.03.05-2.07.1-3.1.17-.27-.02-.64.2-.83-.07-.22-.39.38-.25.5-.48.14-.27-.04-.55-.1-.81l-.96-3c-.12-.31-.32-.7-.7-.7-.25.05-.6-.15-.43-.41.34-.07.7-.02 1.05-.05l2.81-.15zM488.66 287.94c-.07-.36-.34-.68-.73-.62-.38.1-.5-.57-.04-.43.51 0 1.03-.08 1.53.03.25.27.44.58.66.86l2.17 2.9c-.15.04-.03-.18-.05-.3l.36-3.54c.27-.22.73-.13 1.07-.2.29-.04.93-.13.75.35-.34.06-.77.22-.54.65.36 1.2.74 2.39 1.12 3.58.07.41.49.54.86.52.31.02.33.57-.05.43-.6 0-1.2-.04-1.78.07-.27.09-.82.06-.64-.36.3-.05.8-.14.58-.57-.31-1.06-.65-2.11-.98-3.17.07.1-.01.25 0 .38-.1.99-.23 1.97-.3 2.97-.04.26.05.57-.07.8-.24.1-.39-.12-.5-.28l-2.86-3.7c.1-.04.09.2.14.3.3.95.59 1.92.91 2.87.1.39.5.5.85.5.38.2.1.55-.23.41-.5-.07-1 .03-1.5.08-.3 0-.32-.5.03-.44.47 0 .33-.53.22-.8l-1.02-3.28.04-.01zM497.4 288.79c.06.22.36.07.53.1.28-.02.62-.18.63-.5.01-.44-.16-.9-.5-1.19-.33-.25-.77-.23-1.16-.2-.04.15.06.31.1.46l.4 1.33zm.49 1.6c.12.35.19.74.45 1.02.24.18.56.1.84.09.26-.02.49-.23.46-.5-.03-.6-.31-1.26-.9-1.5a2.4 2.4 0 0 0-1.07-.09c-.12.1.03.3.05.43l.17.55zm-1.78-2.4c-.11-.35-.22-.77-.58-.94-.23-.09-.64.02-.66-.34.08-.28.54-.07.77-.13.89 0 1.8-.23 2.66.06.7.18 1.28.82 1.28 1.56 0 .4-.33.71-.69.86-.02-.13.36.07.5.1.53.19 1.02.55 1.23 1.1.17.4.28.94-.04 1.32-.36.4-.95.43-1.45.44-.8 0-1.59-.01-2.37.12-.29.03-.4-.5-.04-.45.36 0 .46-.38.32-.66l-.93-3.04zM501.12 287.81c-.11-.35-.22-.77-.58-.94-.24-.09-.69.02-.66-.37.19-.25.65-.04.95-.1.68 0 1.36-.13 2.04-.05.79.1 1.54.65 1.74 1.45.14.42.05.95-.36 1.19-.09.1-.52.2-.45.19.6.24 1.12.69 1.41 1.27.16.26.25.58.47.8.27.2.3-.17.34-.33.35-.18.53.32.39.58-.15.42-.68.5-1.06.4-.34-.07-.6-.34-.76-.64-.34-.54-.55-1.17-1.03-1.61-.22-.2-.56-.31-.85-.2-.07.14.04.29.06.43.13.4.21.8.39 1.17.16.33.54.41.87.41.32 0 .35.56-.03.43-.6 0-1.22-.07-1.83.03-.22 0-.53.14-.67-.1-.22-.42.41-.22.55-.46.1-.28-.06-.56-.12-.84l-.81-2.71zm1.31.92c.1.32.56.15.8.14.3-.03.47-.32.4-.6-.07-.45-.19-.94-.54-1.25-.3-.23-.72-.23-1.08-.16-.16.12-.01.34.02.5l.4 1.37zM509.32 286.19c.31-.05.33.3.38.51.08.28.2.55.26.83-.13.26-.49.03-.51-.2-.13-.26-.3-.6-.63-.6a9.5 9.5 0 0 0-1.28 0c-.24.08-.03.38-.01.56.13.45.25.91.4 1.36.25 0 .53 0 .77-.1.29-.16-.1-.6.2-.7.36-.09.36.39.42.63.06.47.3.9.4 1.35-.12.28-.52.02-.52-.23-.08-.3-.37-.46-.66-.44-.15.02-.56-.12-.44.13.16.53.27 1.07.49 1.57.1.3.44.36.72.36.4-.01.85.06 1.18-.22.26-.22.07-.58.14-.84.26-.18.53.1.49.37.05.34.12.68.21 1.02-.05.2-.3.12-.45.14-1.04.02-2.07.03-3.11.07-.27-.03-.6.15-.82-.06-.26-.38.3-.3.47-.47.2-.22.04-.5-.02-.75-.3-1.03-.58-2.06-.89-3.08-.1-.3-.27-.68-.63-.72-.24.01-.61-.1-.49-.4.3-.1.66 0 .98-.04l2.95-.05zM476.5 299.32c-.1-.37-.22-.85-.64-.95-.24 0-.65-.06-.5-.4.3-.12.67-.02 1-.07.82-.04 1.65-.24 2.46-.02a3.54 3.54 0 0 1 2.59 2.36c.22.73.26 1.6-.23 2.24-.52.67-1.42.85-2.22.86-.61 0-1.23 0-1.84.12-.24.14-.63-.1-.42-.36.25-.07.67-.15.59-.52-.1-.51-.25-1.01-.36-1.52l-.43-1.74zm1.64 2.44c.1.32.14.7.4.94.28.17.62.1.92.08.47-.07.82-.48.9-.94a3.91 3.91 0 0 0-.39-2.22c-.26-.6-.8-1.08-1.44-1.22a2.98 2.98 0 0 0-1.16-.04c-.08.12.02.27.04.4l.73 3zM485.2 297.33c.32-.06.31.3.36.51.06.28.16.54.22.82-.13.26-.5.06-.5-.19-.12-.25-.27-.58-.6-.58-.42-.02-.85.02-1.27.06-.24.08-.05.38-.04.57.12.45.21.9.34 1.35.27-.01.58 0 .82-.17.21-.19-.13-.61.2-.69.38-.04.3.45.37.69.05.44.25.85.34 1.29-.12.28-.53.05-.5-.21-.08-.33-.41-.46-.71-.42-.15.02-.5-.07-.37.17.13.52.22 1.05.4 1.55.1.3.44.35.7.33.42-.02.9.02 1.22-.3.25-.23.02-.61.17-.84.3-.17.49.14.45.4.03.34.09.66.16.99-.06.2-.3.14-.47.16-1.02.07-2.05.12-3.07.2-.26-.01-.56.15-.78.01-.26-.27.1-.4.32-.44.3-.1.26-.44.19-.68-.27-1.08-.51-2.16-.79-3.24-.08-.3-.23-.67-.6-.7-.23.03-.6-.08-.46-.39.3-.12.65-.03.97-.07l2.93-.18zM491.69 301.43c.04.3.28.57.6.62.23.1.6-.04.73.24.1.35-.39.24-.6.25-.56 0-1.14-.02-1.7.07-.3.02-.58.1-.87.07-.27-.12-.15-.5.15-.45.27-.06.63-.13.7-.44.04-.27-.07-.53-.12-.79l-.64-2.76c-.03-.33-.39-.34-.64-.3-.22.01-.58.17-.66-.16-.03-.34.47-.27.67-.4.37-.13.74-.28 1.11-.38.21-.05.3.15.32.32l.95 4.11zM495.38 298.11c-.07-.36-.28-.79-.69-.84-.3-.05-.67.03-.78.34-.1.38.04.81.37 1.03.28.2.6.3.9.45.06-.12.24-.35.23-.56.02-.14 0-.29-.03-.42zm.84 2.9c-.1-.5-.57-.78-1-.96-.18-.03-.44-.27-.56-.17-.3.27-.46.71-.32 1.1.12.49.48.97 1 1 .35.05.77-.1.87-.47a.96.96 0 0 0 0-.5zm.89-.22a1.2 1.2 0 0 1-.47 1.3 2.4 2.4 0 0 1-2.02.24 1.67 1.67 0 0 1-1.19-1.28c-.12-.49.08-1.04.52-1.31.1-.1.49-.14.17-.22-.5-.24-.99-.64-1.09-1.22-.12-.49.1-1.03.55-1.27.86-.47 2.09-.2 2.59.67.21.37.25.86 0 1.22-.15.2-.33.4-.57.45.49.1.93.4 1.22.79.14.19.24.4.29.63zM500.37 301.35c.24 0 .5-.14.54-.4.09-.19-.08-.6.26-.58.3.02.27.37.3.6.03.4 0 .87-.34 1.13-.25.16-.56.1-.84.1-.56-.02-1.12-.14-1.68-.07-.24.02-.5.28-.72.1-.19-.23-.07-.52 0-.77.2-.61.62-1.12 1.1-1.54.33-.3.7-.65.76-1.13.04-.41-.08-.84-.3-1.19-.28-.45-.94-.6-1.4-.32-.22.15-.4.5-.22.75.21.16.6.01.7.35.13.23 0 .6-.3.6-.44.06-.84-.28-.95-.7a1.2 1.2 0 0 1 .5-1.4c.5-.3 1.13-.3 1.68-.17.57.14 1.04.58 1.22 1.14.15.43.16.93-.08 1.34-.38.72-1.15 1.07-1.66 1.67-.14.16-.25.38-.19.59.08-.2.4-.13.58-.17.35-.01.7.08 1.04.07zM504.31 300.93c.04.31.27.58.58.63.23.1.57-.01.72.23.14.34-.33.28-.54.27-.59-.02-1.18-.05-1.77.02-.29.02-.58.09-.86.05-.28-.13-.13-.5.16-.44.27-.05.63-.11.72-.42.03-.27-.07-.53-.11-.79l-.58-2.77c-.02-.28-.32-.34-.55-.3-.24-.03-.56.16-.71-.1-.18-.35.34-.35.55-.44.4-.12.8-.28 1.22-.38.21-.05.3.15.31.32l.86 4.12z'/%3E %3C/g%3E %3C/g%3E %3Cg fill='%23448127' stroke='%2334541f' stroke-width='.22'%3E %3Cpath fill='url(%23m)' stroke='%234c0505' d='M475.8 219.41l-3.77 4.48c-1.2 5.24 1.78 9.19 7.65 12.62 4.75 2.95 13.55 3.69 16.33 1.3l-13.72-13.06-6.49-5.34z'/%3E %3Cpath d='M503.58 354.27c-.67-.81-1.35-1.62-2.04-2.42-8.55 11.3-19.24 21.42-32.61 28.57 15.07-4.27 24.94-15.26 34.65-26.15zM488.14 389.98c5.32-10.77 11.73-21.54 18.2-32.32-.7-.88-1.42-1.76-2.14-2.63-7.35 12.18-15.98 26.68-16.06 34.95zM529.87 275.48c-.98-4.25-2.27-8.84-4.3-13.05-2.67-5.44-6.63-10.84-11.84-16.8-9.38-10.18-18.77-20-31.93-27.26l.07-.14.08.05h.16l-.16-.2h.47l-.25-.26h.43l-.35-.4h.46l-.32-.33h.49l-.28-.36.4.03-.37-.39.55-.1-.45-.28.48-.1-.4-.27.59-.19-.52-.3.65-.3-.63-.45.67-.23-.73-.3.62-.31-.73-.13.5-.57-.7.04.31-.6-.67.05-.04-.05.37-.45-.68.12.3-.61-.65.32.18-.7-.62.43.1-.72-.59.5.06-.7-.5.54.04-.72-.5.6-.06-.7-.4.55-.2-.67-.34.67-.17-.71-.32.71-.15-.71-.27.71-.2-.67-.22.67-.16-.6-.24.72-.23-.67-.24.77-.29-.69-.13.82-.35-.67-.04.8-.38-.6-.03.78-.4-.57.03.7-.44-.37.22.74-.53-.3.2.65-.43-.24.15.63-.4-.13.21.47-.03.07-.3-.06.17.36a9.03 9.03 0 0 0-.35 3.52c.02.23.6.46.69.6.28.44.23.67.23.67-1.6 2.58-3.02 4.57-3.18 7.53 1.28-1.62 2.6-3.6 4.46-3.6-.92 1.54-1.35 6.17-.32 6.88l.77-1.36c.03 1.08.18 1.8.39 2.33.32-.65.64-1.28.96-1.75.07 1.51.27 2.72.7 3.32.43-.74 1.01-1.2 1.62-1.57-.2.86-.52 1.67-.39 2.7.65-1.1 1.3-1.75 1.94-2.51-.38 1.58-.04 2.77.41 4.52.4-2.08.56-2.3 1.52-3.17.1 1.9-.26 3.63.14 4.7.88-1.68 1.46-1.44 1.98-2.53-.1 1.58-.41 3.3-.01 4.7a4.48 4.48 0 0 1 1.94-2.67c.06 2.2.57 1.84-.8 3.7.58.27 2.54-.37 3.6-.83-.5 1.18-.35 2.1-.87 2.94 1.08-.54 2-1.42 2.9-2.32-.42 1.35-1.52 2.7-.97 4.05.25-1.26 1.28-2.3 2.24-2.49-.15.7-.25 2.17-1.27 2.88 2.44.25 3.4-1.4 4.64-2.7-.16 1.36-.12 2.44 1.55 4.35-.34-2.43.24-1.93 1.34-3.39.54 2.15 1.15 4.43 3.39 6.02-.93-2.27-1.1-3.44-.58-4.87.29 1.48 1.69 3.25 2.02 4.65.2-1.55.44-3.05.96-4.06.65 1.76 1.2 3.57 1.36 5.6.48-1 .88-2.03 1.16-3.08 19.73 20.62 24.13 46.84 2.5 74.54 7.78-5.25 9.78-13.57 14.1-20.67-4.21 9.3-6.09 19.74-13.51 27.43 7.19-6.2 8.71-11.89 13.03-17.87-4.6 12.5-10.98 26.2-19.82 38.75 1.57 1.7 3.14 3.44 4.72 5.18l4.1-6.84c9.37-15.44 24.65-37.5 16.91-71.15z'/%3E %3C/g%3E %3Cpath fill='%23eac102' stroke='%23a08307' stroke-width='.22' d='M473.16 215.29c-1 .23-1.4.64-2.11 1.44.92.2 1.7.25 2.52.27.26-.03.34-.35.29-.59l-.13-.95c-.02-.22-.6-.2-.87-.09l.3-.08z'/%3E %3Cpath fill='%23a08307' d='M471.04 216.73a9.89 9.89 0 0 1 2.13-.49 9.82 9.82 0 0 1-2.13.49z'/%3E %3Cellipse stroke='%23000' stroke-width='.1' cx='477.68' cy='215.42' rx='.78' ry='.81'/%3E %3Cellipse fill='url(%23n)' cx='477.86' cy='215.26' rx='.34' ry='.35'/%3E %3Cg fill='%2334541f'%3E %3Cpath d='M488.18 389.69a83.38 83.38 0 0 1 3.31-8.79c1.26-2.86 2.66-5.67 4.14-8.43a199.58 199.58 0 0 1 7.11-12.16l2.51-3.97-2.42 4.03-2.4 4.03c-1.58 2.7-3.14 5.41-4.61 8.17a133.67 133.67 0 0 0-4.18 8.4 98.1 98.1 0 0 0-3.46 8.72zM469.34 380.23a75.8 75.8 0 0 0 26.08-19.07 153.49 153.49 0 0 0 6.95-8.34 111.9 111.9 0 0 1-6.83 8.45 81.9 81.9 0 0 1-7.74 7.63 69.95 69.95 0 0 1-18.46 11.33zM506.62 350.89a136.2 136.2 0 0 0 4.3-6.66c1.37-2.26 2.69-4.55 3.96-6.86a331.1 331.1 0 0 0 3.75-6.99l3.68-7.03-1.75 3.57-1.78 3.54c-1.2 2.35-2.44 4.7-3.71 7.01-1.29 2.31-2.6 4.6-4 6.85a93.84 93.84 0 0 1-4.45 6.57zM512.51 325.78a60.2 60.2 0 0 0 8.5-13.4 72.56 72.56 0 0 0 4.98-15.06l.41-1.95a61.14 61.14 0 0 0 .7-5.91c.17-2.65.17-5.3-.04-7.95a53.36 53.36 0 0 0-3.64-15.42 50.47 50.47 0 0 1 3.79 15.41 54.3 54.3 0 0 1-.32 11.94c-.08.66-.17 1.3-.28 1.97l-.41 1.95a72.68 72.68 0 0 1-5.06 15.09 58.22 58.22 0 0 1-8.63 13.33z'/%3E %3Cpath d='M510.87 320.07a35.91 35.91 0 0 0 4.9-5.85 52.06 52.06 0 0 0 3.8-6.62c1.1-2.3 2.1-4.65 3.02-7.02.46-1.18.92-2.38 1.36-3.57l.33-.9.3-.9c.18-.6.35-1.22.58-1.83v.02c.5-2.53.77-5.1.8-7.67.03-2.58-.17-5.16-.57-7.7-.4-2.55-1-5.06-1.73-7.53-.73-2.48-1.6-4.91-2.56-7.3 1 2.38 1.9 4.8 2.66 7.27a57.63 57.63 0 0 1 1.77 7.54c.42 2.55.63 5.13.61 7.72a41.44 41.44 0 0 1-.78 7.71v.02c-.22.59-.4 1.2-.58 1.81l-.3.91-.34.9c-.45 1.2-.91 2.38-1.38 3.57a96.55 96.55 0 0 1-3.07 7.01 51.58 51.58 0 0 1-3.84 6.62 35.96 35.96 0 0 1-4.98 5.79z'/%3E %3Cpath d='M505.05 349.23c1.2-1.66 2.39-3.33 3.57-5l1.78-2.5c.59-.84 1.2-1.66 1.73-2.54a68.5 68.5 0 0 0 2.9-5.4c.9-1.85 1.82-3.68 2.71-5.52 1.78-3.69 3.5-7.4 4.97-11.23a75.28 75.28 0 0 0 3.45-11.76c.85-4 1.41-8.06 1.88-12.13.43-4.06.48-8.18.04-12.25a52.36 52.36 0 0 0-2.72-11.94 72.65 72.65 0 0 0-5.1-11.16 72.6 72.6 0 0 1 5.2 11.13 52.4 52.4 0 0 1 2.77 11.96c.44 4.08.41 8.2 0 12.28-.46 4.07-1.02 8.14-1.86 12.15a75.52 75.52 0 0 1-3.5 11.79 145.12 145.12 0 0 1-5 11.22c-.9 1.85-1.82 3.67-2.73 5.51a67.34 67.34 0 0 1-2.92 5.4c-.53.89-1.16 1.7-1.75 2.53l-1.8 2.5c-1.2 1.65-2.4 3.31-3.62 4.96z'/%3E %3Cpath d='M507.81 352.25c2.36-3.84 4.71-7.68 6.95-11.58 2.25-3.9 4.49-7.82 6.47-11.86a81.9 81.9 0 0 0 5-12.52 74.15 74.15 0 0 0 2.71-13.2c.59-4.46.93-8.96.93-13.46s-.37-9-1.2-13.42a57.58 57.58 0 0 0-3.98-12.87 54 54 0 0 0-6.96-11.53 54.08 54.08 0 0 1 7.06 11.49 57.58 57.58 0 0 1 4.02 12.88 73.26 73.26 0 0 1 1.24 13.45 102.9 102.9 0 0 1-1.37 16.83 74.24 74.24 0 0 1-2.28 9.88 82.1 82.1 0 0 1-5.04 12.53c-2 4.05-4.24 7.96-6.5 11.85a442.64 442.64 0 0 1-7.05 11.53zM480 220.77c.47-.01.95.04 1.42.11a18.85 18.85 0 0 1 4.08 1.25c1.74.77 3.37 1.77 4.9 2.9a35.81 35.81 0 0 1 6.16 5.9c.6.74 1.2 1.48 1.76 2.24a60.86 60.86 0 0 0-3.78-4.23 37.82 37.82 0 0 0-4.27-3.73 26.78 26.78 0 0 0-4.84-2.93c-.86-.4-1.74-.74-2.65-1-.9-.27-1.83-.47-2.78-.51z'/%3E %3C/g%3E %3Cg fill='%23448127'%3E %3Cpath d='M496.38 231.57s3.06 1.8 4.73 4.44c0 0-4.72-.88-8.07-4.65'/%3E %3Cpath fill='%2334541f' d='M496.38 231.57a14.43 14.43 0 0 1 2.66 1.9 13.11 13.11 0 0 1 2.16 2.48l.13.22-.24-.06a15.7 15.7 0 0 1-4.41-1.75c-1.37-.79-2.63-1.8-3.64-3a15.17 15.17 0 0 0 3.72 2.86c.68.38 1.4.72 2.12 1 .73.28 1.49.52 2.25.68l-.12.17c-.28-.46-.6-.9-.96-1.3a16.08 16.08 0 0 0-2.36-2.23c-.42-.34-.86-.67-1.31-.97z'/%3E %3Cpath d='M489.58 230.69s7.23 4.61 8.27 4.98c0 0-1.6-3.48-5.05-4.97'/%3E %3Cpath fill='%2334541f' d='M489.58 230.69l4.14 2.49a156.88 156.88 0 0 0 3.11 1.84c.35.2.7.4 1.06.55l-.13.14a12.91 12.91 0 0 0-2.07-2.9 10.73 10.73 0 0 0-2.89-2.11c.56.22 1.1.5 1.6.85a11.03 11.03 0 0 1 3.55 4.08l.12.24-.25-.1c-.77-.33-1.44-.76-2.14-1.17l-2.06-1.27c-1.36-.86-2.7-1.73-4.04-2.64z'/%3E %3Cpath d='M492.46 228.36s3.76 1.6 4.61 4.38c0 0-6.75-2.84-7.96-4.35'/%3E %3Cpath fill='%2334541f' d='M492.46 228.36a10.67 10.67 0 0 1 2.8 1.68c.43.35.81.75 1.14 1.2.33.44.61.93.77 1.47l.07.22-.21-.1a77.2 77.2 0 0 1-4.13-1.93c-.68-.35-1.35-.71-2-1.11-.32-.2-.64-.4-.95-.63-.3-.23-.6-.47-.84-.77.25.29.56.5.87.72.32.21.65.4.98.6a84.15 84.15 0 0 0 6.16 2.94l-.15.12c-.16-.5-.41-.98-.73-1.42a7.8 7.8 0 0 0-1.09-1.18 12.7 12.7 0 0 0-2.7-1.81z'/%3E %3Cpath d='M486.76 231.25s6.65 4.76 8.61 4.76c0 0-1.95-3.26-5.39-4.75'/%3E %3Cpath fill='%2334541f' d='M486.76 231.25a124.04 124.04 0 0 0 4.18 2.65c.7.42 1.42.83 2.16 1.2.37.18.74.36 1.12.5.37.15.77.3 1.15.3l-.09.16a15.68 15.68 0 0 0-2.32-2.76 12.98 12.98 0 0 0-2.98-2.04c1.13.45 2.17 1.13 3.09 1.93a12.97 12.97 0 0 1 2.4 2.76l.1.17h-.2a3.76 3.76 0 0 1-1.23-.31c-.39-.16-.77-.34-1.13-.53-.74-.38-1.46-.8-2.16-1.22a63.89 63.89 0 0 1-4.09-2.81z'/%3E %3Cpath d='M486.76 232.74s3.46 2.92 5.43 2.92c0 0-1.95-3.26-5.4-4.75'/%3E %3Cpath fill='%2334541f' d='M486.76 232.74a32.06 32.06 0 0 0 2.59 1.74c.44.26.9.5 1.37.7.24.1.48.2.73.26.24.07.49.11.74.12l-.1.15c-.3-.5-.67-.99-1.06-1.45a13 13 0 0 0-4.23-3.35c1.13.45 2.16 1.13 3.08 1.93a12.95 12.95 0 0 1 2.4 2.77l.1.15h-.2c-.54 0-1.06-.18-1.54-.39-.48-.2-.94-.46-1.39-.74a20.06 20.06 0 0 1-2.49-1.89z'/%3E %3Cpath d='M485.03 226.18s7.2 5.12 8.06 7.9c0 0-6.52-3-7.73-4.5'/%3E %3Cpath fill='%2334541f' d='M485.03 226.18a51.63 51.63 0 0 1 4.5 3.49c.73.62 1.42 1.28 2.06 1.99.32.35.63.71.91 1.1.28.4.55.8.7 1.28l.06.24-.22-.1a79.6 79.6 0 0 1-4-2.04c-.66-.37-1.31-.74-1.94-1.15-.32-.2-.62-.42-.92-.65-.3-.23-.6-.47-.82-.77.25.29.55.5.85.73.3.21.62.4.94.6.64.39 1.3.75 1.96 1.1 1.33.69 2.66 1.36 4.02 1.98l-.14.13a4.68 4.68 0 0 0-.66-1.22c-.27-.39-.57-.75-.89-1.1-.63-.7-1.32-1.35-2.02-2a71.2 71.2 0 0 0-4.4-3.62z'/%3E %3C/g%3E %3Cg stroke='%2324420e' stroke-width='.16'%3E %3Cpath fill='%23406325' d='M445.02 370.33c-4.89 3.64-18.55 5.43-20.45 4.8 9.94-8.27 19.73-8.47 20.45-4.8zM514.78 374.77c5.25 4.77 21.1 8.05 23.48 7.46-10.55-10.77-22.1-11.86-23.48-7.46z'/%3E %3Cpath fill='%2367923d' d='M444.98 370.3c-.72-3.67-10.46-3.45-20.38 4.78 10.45-3.45 19.24-5.41 20.38-4.78zM514.89 374.71c1.37-4.4 12.8-3.34 23.36 7.46-11.88-5.02-21.94-8.1-23.36-7.46z'/%3E %3C/g%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 820 440'%3E %3Crect fill='%23c62139' width='820' height='440'/%3E %3Crect fill='%2300297b' width='780' height='400' x='20' y='20'/%3E %3Cg%3E %3Cpath fill='%23c62139' d='M410.25782,100.00041C410.25782,100.00041 330.00038,154.71073 330.00038,219.22153C330.00038,283.74266 410.25782,340.00123 410.25782,340.00123C410.25782,340.00123 490.00057,288.38227 490.00057,219.22153C490.00057,150.06596 410.25782,100.00041 410.25782,100.00041'/%3E %3Cpath fill='%2366afeb' d='M477.92277,240.56171C479.68326,233.69776 480.68341,226.5706 480.68341,219.22153C480.68341,157.29117 410.25782,111.35948 410.25782,111.35948C410.25782,111.35948 338.80284,158.84459 338.80284,219.22153C338.80284,226.47255 339.82054,233.53777 341.61613,240.38108L477.92277,240.56171'/%3E %3Cpath fill='%23007bde' d='M409.67295,328.12609C409.67295,328.12609 464.90916,291.54588 477.89938,240.38108L341.56349,240.38108C354.75257,290.56016 409.67295,328.12609 409.67295,328.12609'/%3E %3Cpath fill='%239c8431' d='M480.33833,226.4519C468.25468,235.06023 400.2505,230.92637 400.2505,230.92637L396.44877,240.56171L477.91692,240.56171C478.25615,239.24053 478.56615,237.91934 478.84689,236.58268L480.33833,226.4519'/%3E %3Cg fill='%23fff100'%3E %3Cpath d='M406.07592,287.35526C405.04068,280.14553 373.23483,272.42488 356.35514,273.05967C361.62492,281.32737 367.59656,288.8932 373.6033,295.6178C382.17767,286.41598 406.41515,289.73442 406.07592,287.35526'/%3E %3Cpath d='M470.45384,260.54973C466.4123,260.69424 459.07789,261.33935 454.05376,263.9559C446.80708,267.73882 430.58246,271.87267 423.32993,269.80316C416.08324,267.73882 404.68975,274.27763 406.07592,275.65042C408.3745,277.94701 425.05533,275.3098 425.05533,290.106C425.05533,302.49207 405.73084,296.99059 398.13323,302.15146C393.5536,305.25314 390.36015,308.62318 388.54703,310.79074C400.40842,321.7679 409.69634,328.12609 409.69634,328.12609C409.69634,328.12609 431.71713,313.54148 451.21708,289.92537L460.38802,277.75605C464.08448,272.34231 467.51188,266.59827 470.45384,260.54973'/%3E %3C/g%3E %3Cg fill='%23009270'%3E %3Cpath d='M405.85951,165.16664C405.85951,165.16664 394.85205,158.71556 379.83814,161.80692C364.82422,164.90344 361.58399,174.31686 361.58399,174.31686L366.63151,171.99963L366.76019,174.06397L371.29302,171.2255L371.42169,173.28984L375.3053,169.6824L375.94283,171.99963L379.44041,168.90311L379.70361,170.58039L385.39451,166.96779L385.39451,169.29017L389.92734,167.22067L389.54132,169.4192L398.08645,167.8761C398.08645,167.8761 377.89048,174.58006 375.3053,190.70776L379.18307,186.0733L379.57494,188.25635L382.03144,183.35869L382.68066,185.29401L384.87981,180.77826L385.52319,183.48255L388.88626,178.57973L389.14946,181.42337L393.02722,176.13348L393.02722,178.70359L397.17403,174.18783L397.04535,177.55272C397.04535,177.55272 401.05764,174.18783 402.34438,174.18783L397.56005,180.38603L399.11584,180.90212C399.11584,180.90212 395.74692,183.61157 395.48957,184.12766C395.23222,184.63858 397.69457,184.12766 397.69457,184.12766C397.69457,184.12766 394.71168,187.21902 394.583,188.12733C394.45433,189.03564 396.5248,188.12733 396.5248,188.12733C396.5248,188.12733 393.80511,191.60575 393.41909,192.90629C393.02722,194.1965 394.84034,193.15917 394.84034,193.15917C394.84034,193.15917 393.16174,197.28786 393.02722,198.44906C392.89854,199.59993 394.96902,198.18585 394.96902,198.18585L396.13879,205.28204L398.20926,196.77694L399.50185,198.71226L399.50185,192.64308L400.66576,193.6701L400.5371,189.68075L402.08704,191.22385L401.31499,186.32103L402.9936,188.24603L402.73625,184.12766L404.41486,185.8101L404.41486,180.38603L405.97065,181.79495L406.228,178.0688L408.04112,178.96679C408.04112,178.96679 408.29847,174.45104 410.3748,174.58006C412.43943,174.69876 415.03046,176.89729 413.99522,177.9243L415.80835,177.4237L415.42233,181.79495L417.10094,180.76794L416.84359,183.99348L418.26485,183.34837L417.75016,187.4719L419.43462,186.45521L419.55744,191.47157L421.4934,190.06265L421.36472,195.98732L423.30653,194.44939L423.30653,199.34705L425.11967,198.06715L427.06732,202.83579L426.67546,195.7396L428.10257,196.89564L425.50568,191.86895L427.45334,191.60575L425.37701,188.24603L427.31882,188.39053L424.4763,185.03081L426.41226,184.64891L422.13676,181.54723L424.47045,180.64924L420.06629,177.8056L421.75075,177.16049L418.65088,173.93495L421.88527,175.22517L422.91466,173.16082L426.79827,176.2625L426.79827,173.16082L430.16134,177.8056L430.55322,174.96196L433.14424,178.57973L433.65894,176.90761L435.47207,180.51505L436.37279,177.81592L438.18591,181.68657L438.70061,178.96679L440.38507,183.22967L441.94086,181.54723L442.71875,185.93912L444.26284,184.25668L445.6841,188.12733L447.49723,186.70809L449.05302,191.09999C449.05302,191.09999 453.32265,167.61289 416.69152,167.22067L405.81858,165.16664'/%3E %3Cpath d='M389.03248,144.25998L391.0971,146.83009L390.06187,147.61455L393.55946,149.54987L392.78156,150.96395L396.27916,152.25416L394.98072,153.2915L398.09228,155.08748L396.02181,155.74291L399.7709,157.54405L399.25621,159.21617L402.49059,159.99546L401.06933,161.15149L404.81843,164.12931L409.09391,167.09165L412.07096,166.06463L410.9012,160.37736C410.9012,160.37736 398.60698,143.60455 389.03248,144.24966'/%3E %3Cpath d='M400.29144,128.00326L401.71855,131.3475L399.7709,131.73973L404.17505,136.12646L400.67747,136.25548L404.95295,139.60489L402.87662,140.26031L406.76609,144.13096L404.68975,145.15797L408.70204,149.15764L405.98819,150.18466L410.52102,154.31851L407.93,154.45269L410.64385,157.92595L408.18735,158.70524C408.18735,158.70524 411.1644,164.24801 411.02986,166.57556L416.0774,166.82844C416.0774,166.82844 416.85528,151.86194 416.21192,149.92661L414.91348,150.82976L415.29951,145.41086L413.3577,146.57721L412.97752,140.12613L411.02986,142.18532L410.52102,135.86326L409.09391,138.06179L407.6668,131.86359L406.11686,133.79891L404.68975,129.8044L403.52584,131.3475L400.29144,127.99294'/%3E %3Cpath d='M413.36355,165.67757C414.79066,156.64606 424.24235,143.48585 441.97595,142.96977L437.95781,145.03411L440.2915,146.06629L435.62999,147.74873L437.95781,149.15764L432.39559,149.54987L435.23812,151.48519L431.103,152.00128L427.86276,152.64639L430.19058,154.83459L425.52909,155.34552L428.51198,156.89894C428.51198,156.89894 421.13078,159.47937 420.61608,160.25866C420.61608,160.25866 445.47354,153.9366 451.55631,165.66725L446.76028,163.6029L447.15216,165.80143L443.78908,163.35002L444.30378,165.15632L440.81204,163.35002L441.32674,165.53823L437.70046,163.47388L438.47836,165.41953L433.81685,163.221L434.59474,165.28534L430.58246,163.99513L430.97433,166.18333L426.9562,165.93045L427.34806,168.51088L414.91933,168.24768L413.36355,165.66725'/%3E %3C/g%3E %3Cg fill='%237b4800'%3E %3Cpath d='M409.56767,173.46015L412.15869,173.28984C410.94798,197.89684 412.08262,233.17651 415.43403,246.23866C421.12493,268.42521 437.71802,276.9716 441.66597,279.09788C443.90606,280.2952 443.04628,285.28575 438.5544,284.94514C434.0742,284.59936 418.41693,273.06999 413.01262,252.42653C405.77178,224.72818 409.28692,176.34508 409.56767,173.46015'/%3E %3Ccircle cx='413.755' cy='168.129' r='2.926'/%3E %3Ccircle cx='409.094' cy='167.092' r='2.739'/%3E %3Ccircle cx='409.094' cy='171.871' r='2.558'/%3E %3Ccircle cx='412.586' cy='170.58' r='2.739'/%3E %3C/g%3E %3Cg fill='%237b4800'%3E %3Cpath fill='%23000' d='M384.64001,257.16421L387.56442,257.16421L387.56442,225.68294L384.64001,225.68294L384.64001,257.16421z'/%3E %3Cpath d='M394.13849,263.0992C394.13849,263.0992 392.93949,263.3108 391.03277,263.55336L391.03277,261.09678L389.09097,261.09678L389.09097,263.76495C387.10236,263.96623 384.69266,264.13137 382.16596,264.13137C379.48136,264.13137 376.77336,263.93526 374.53911,263.70818L374.53911,261.16388L372.39844,261.16388L372.39844,263.46562C370.55022,263.23338 369.35706,263.03211 369.35706,263.03211C369.35706,263.03211 368.77218,266.25765 381.97881,266.25765C395.17957,266.25765 394.14434,263.0992 394.14434,263.0992'/%3E %3Cpath d='M381.60448,257.07131C392.30781,257.07131 401.28575,255.3579 401.28575,255.3579C401.28575,255.3579 402.66021,262.23217 381.60448,262.23217C360.54874,262.23217 362.27415,256.39008 362.27415,256.39008C362.27415,256.39008 370.90699,257.07131 381.60448,257.07131'/%3E %3Cpath fill='%23fff' d='M372.62655,227.47892C372.62655,227.47892 389.19624,233.67711 395.75861,255.3579C395.75861,255.3579 380.56924,252.26655 371.93638,255.70368L367.10526,255.70368C367.10526,255.69293 375.39303,243.65823 372.62655,227.47892'/%3E %3C/g%3E %3Cg fill='%23c62139'%3E %3Cpath d='M374.97192,211.16026L371.90129,211.16026C371.66149,209.83908 371.08246,208.91013 370.16419,208.3992C369.6495,208.10503 369.08216,207.96569 368.45634,207.96569C367.24564,207.96569 366.26304,208.53855 365.49099,209.72038C364.7131,210.88674 364.32708,212.66208 364.32708,215.01027C364.32708,217.38943 364.74819,219.06155 365.58458,220.06276C366.42095,221.03816 367.37431,221.5336 368.44465,221.5336C369.49158,221.5336 370.34551,221.14654 371.01812,220.36209C371.68489,219.58796 372.09431,218.56094 372.25807,217.28621L368.79557,217.28621L368.79557,214.07099L375.01871,214.07099L375.01871,224.42369L372.95408,224.42369L372.63825,222.01356C372.03582,222.9322 371.49773,223.5773 371.01812,223.95921C370.19344,224.61464 369.1816,224.93977 367.97674,224.93977C365.99984,224.93977 364.37387,224.0521 363.11637,222.27677C361.80039,220.50143 361.13947,218.0655 361.13947,214.9793C361.13947,211.85698 361.80624,209.34364 363.13977,207.45993C364.4616,205.57621 366.22209,204.63693 368.41541,204.63693C370.31041,204.63693 371.83696,205.2614 372.98917,206.50517C374.13554,207.74377 374.80231,209.29719 374.97192,211.16026'/%3E %3Cpath d='M389.58811,216.9972L389.58811,205.13238L392.75817,205.13238L392.75817,216.9972C392.75817,218.31838 392.88685,219.28346 393.12664,219.89761C393.50682,220.97623 394.32565,221.52328 395.6007,221.52328C396.85819,221.52328 397.68288,220.97623 398.06304,219.89761C398.3087,219.28346 398.41982,218.31838 398.41982,216.9972L398.41982,205.13238L401.59573,205.13238L401.59573,216.9972C401.59573,219.0409 401.35008,220.63561 400.85878,221.78648C399.93467,223.87147 398.18587,224.91913 395.59485,224.91913C393.00966,224.91913 391.24918,223.88179 390.32506,221.78648C389.83377,220.64593 389.58811,219.0409 389.58811,216.9972'/%3E %3Cpath d='M423.125 205.125L417.78125 224.4375L421.0625 224.4375L422.09375 220.46875L427.59375 220.46875L428.5625 224.4375L431.9375 224.4375L426.625 205.125L423.125 205.125z M424.84375 209.53125L426.71875 217.125L422.9375 217.125L424.84375 209.53125z'/%3E %3Cpath d='M451.65574,220.30015L454.35204,205.13238L458.83808,205.13238L458.83808,224.42369L455.93122,224.42369L455.93122,211.38218C455.93122,211.00028 455.93704,210.47387 455.94297,209.7978C455.94879,209.12172 455.95472,208.60048 455.95472,208.23922L453.12389,224.42369L450.09422,224.42369L447.28678,208.23922C447.28678,208.60048 447.2926,209.12172 447.29853,209.7978C447.30435,210.47387 447.31028,211.00028 447.31028,211.38218L447.31028,224.42369L444.40342,224.42369L444.40342,205.13238L448.9421,205.13238L451.65595,220.30015'/%3E %3C/g%3E %3C/g%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='-2 -3 12 6'%3E %3Crect x='-2' y='-3' width='4' height='6' fill='%23ce1126'/%3E %3Crect x='2' y='-3' width='8' height='3' fill='%23fcd116'/%3E %3Crect x='2' width='8' height='3' fill='%23009e49'/%3E %3Cg id='c'%3E %3Cpath id='t' d='M 0,-1 v 1 h .5' transform='rotate(18 0,-1)' fill='%23000'/%3E %3Cuse xlink:href='%23t' transform='scale(-1,1)'/%3E %3C/g%3E %3Cuse xlink:href='%23c' transform='rotate(72)'/%3E %3Cuse xlink:href='%23c' transform='rotate(144)'/%3E %3Cuse xlink:href='%23c' transform='rotate(216)'/%3E %3Cuse xlink:href='%23c' transform='rotate(288)'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 500 300'%3E %3Crect width='500' height='300' fill='%23009e49'/%3E %3Cpath d='M 0,0 L 500,150 L 0,300 z' fill='%23fff'/%3E %3Cpath d='M 0,13.05 L 456,150 L 0,286.95 z' fill='%23fcd116'/%3E %3Cpath d='M 0,0 L 250,150 L 0,300 z' fill='%23000'/%3E %3Cpath d='M 0,17.5 L 220.85,150 L 0,282.5 z' fill='%23ce1126'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 900 600'%3E %3Crect width='900' height='600' fill='%23de2910'/%3E %3Cg id='petal'%3E %3Cpath d='m 449.96406,299.9134 c -105.26305,-44.48626 -58.60174,-181.58185 42.06956,-174.6907 -20.36609,10.46694 -23.31775,29.99772 -11.68704,48.09021 13.02444,20.2558 -1.19897,52.84856 -18.80577,60.7674 -28.93485,13.02443 -34.72791,47.74999 -11.57675,65.83309 z' fill='%23fff'/%3E %3Cpath d='m 444.27188,200.91974 -5.91976,9.29378 -2.14454,-10.8142 -10.67812,-2.75928 9.62461,-5.3895 -0.67104,-10.99955 8.08542,7.48945 10.25578,-4.04271 -4.61053,10.00942 7.00143,8.50541 z' fill='%23de2910'/%3E %3Cpath d='m 450.56002,298.75902 c -12.73114,-6.53451 -22.9963,-20.15491 -27.46839,-36.43134 -5.11498,-18.66969 -2.17269,-38.74247 8.08308,-55.03768 l -2.20789,-1.39371 c -10.64057,16.92871 -13.69313,37.74293 -8.38575,57.11886 4.72784,17.22201 15.21355,31.09815 28.78703,38.06438 z' fill='%23de2910'/%3E %3C/g%3E %3Cuse xlink:href='%23petal' transform='rotate(72 450,300)'/%3E %3Cuse xlink:href='%23petal' transform='rotate(144 450,300)'/%3E %3Cuse xlink:href='%23petal' transform='rotate(216 450,300)'/%3E %3Cuse xlink:href='%23petal' transform='rotate(288 450,300)'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 10080 5040'%3E %3Cdefs%3E %3CclipPath id='c'%3E %3Cpath d='M0,0V1.5H7V3H6zM6,0H3V3.5H0V3z'/%3E %3C/clipPath%3E %3Cpath id='Star7' d='M0,-360 69.421398,-144.155019 281.459334,-224.456329 155.988466,-35.603349 350.974048,80.107536 125.093037,99.758368 156.198146,324.348792 0,160 -156.198146,324.348792 -125.093037,99.758368 -350.974048,80.107536 -155.988466,-35.603349 -281.459334,-224.456329 -69.421398,-144.155019z'/%3E %3Cpath id='Star5' d='M0,-210 54.859957,-75.508253 199.721868,-64.893569 88.765275,28.841586 123.434903,169.893569 0,93.333333 -123.434903,169.893569 -88.765275,28.841586 -199.721868,-64.893569 -54.859957,-75.508253z'/%3E %3Cuse id='Cstar' xlink:href='%23Star7' transform='scale(2.1)'/%3E %3C/defs%3E %3Cg transform='scale(840)'%3E %3Crect width='12' height='6' fill='%2300008b'/%3E %3Cpath d='M0,0 6,3M6,0 0,3' stroke='%23fff' stroke-width='0.6'/%3E %3Cpath d='M0,0 6,3M6,0 0,3' stroke='%23f00' stroke-width='0.4' clip-path='url(%23c)'/%3E %3Cpath d='M3,0V3.5M0,1.5H7' stroke='%23fff'/%3E %3Cpath d='M3,0V3.5M0,1.5H7' stroke='%23f00' stroke-width='0.6'/%3E %3Cpath d='M0,3H6V0H8V4H0z' fill='%2300008b'/%3E %3C/g%3E %3Cg fill='%23fff'%3E %3Cuse id='Comwlth' xlink:href='%23Cstar' x='2520' y='3780'/%3E %3Cuse id='&%23x3B1;Crucis' xlink:href='%23Star7' x='7560' y='4200'/%3E %3Cuse id='&%23x3B2;Crucis' xlink:href='%23Star7' x='6300' y='2205'/%3E %3Cuse id='&%23x3B3;Crucis' xlink:href='%23Star7' x='7560' y='840'/%3E %3Cuse id='&%23x3B4;Crucis' xlink:href='%23Star7' x='8680' y='1869'/%3E %3Cuse id='&%23x3B5;Crucis' xlink:href='%23Star5' x='8064' y='2730'/%3E %3C/g%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 72 36'%3E %3Crect width='72' height='36' style='fill:%230073cf'/%3E %3Crect width='72' height='12' y='12' style='fill:%23fff'/%3E %3Cg id='star' transform='translate(36,18) scale(2)' fill='%230073cf'%3E %3Cg id='cone'%3E %3Cpolygon id='triangle' points='0,0 0,1 .5,1' transform='translate(0,-1) rotate(18)'/%3E %3Cuse xlink:href='%23triangle' transform='scale(-1,1)' id='use12'/%3E %3C/g%3E %3Cuse xlink:href='%23cone' transform='rotate(72)' id='use14'/%3E %3Cuse xlink:href='%23cone' transform='rotate(-72)' id='use16'/%3E %3Cuse xlink:href='%23cone' transform='rotate(144)' id='use18'/%3E %3Cuse xlink:href='%23cone' transform='rotate(-144)' id='use20'/%3E %3C/g%3E %3Cuse xlink:href='%23star' transform='translate(10,-3.2)'/%3E %3Cuse xlink:href='%23star' transform='translate(10,2.8)'/%3E %3Cuse xlink:href='%23star' transform='translate(-10,-3.2)'/%3E %3Cuse xlink:href='%23star' transform='translate(-10,2.8)'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 1200 600'%3E %3Crect fill='%23171796' width='1200' height='600'/%3E %3Crect fill='%23fff' width='1200' height='400'/%3E %3Crect fill='%23f00' width='1200' height='200'/%3E %3Cg transform='scale(0.00296202)'%3E %3Cg%3E %3Cpath fill='%23f00' d='m202577,153674,0,0c21658,0,39377-17720,39377-39377v-46791h-78755v46791c0,21658,17720,39377,39377,39377z'/%3E %3Cpath fill='%23fff' d='m202577,153043,0,0c21245,0,38626-17382,38626-38626v-46153h-77253v46153c0,21245,17382,38626,38627,38626z'/%3E %3Cg fill='%23f00'%3E %3Cpath d='m180254,69716-14865,0,0,16332,14865,0z'/%3E %3Cpath d='m180254,102379,14865,0,0-16331-14865,0z'/%3E %3Cpath d='m165389,114326c0,1483,92,2946,263,4385h14602v-16332h-14865v11947z'/%3E %3Cpath d='m209985,102379-14866,0,0,16332,14866,0z'/%3E %3Cpath d='m209985,135042,14865,0,0-16331-14865,0z'/%3E %3Cpath d='m224850,143976c3296-2488,6169-5509,8487-8933h-8487v8933z'/%3E %3Cpath d='m180255,135042,14865,0,0-16331-14865,0z'/%3E %3Cpath d='m171754,135042c2321,3429,5199,6454,8501,8944v-8944h-8501z'/%3E %3Cpath d='m205141,151374c1645-115,3262-337,4843-661v-15671h-14865v15673c1576,323,3189,544,4829,658,1731,107,3462,101,5192,0z'/%3E %3Cpath d='m239437,118711c172-1444,264-2912,264-4400v-11931h-14852v16332h14588z'/%3E %3Cpath d='m209985,102379,14865,0,0-16331-14865,0z'/%3E %3Cpath d='m209985,69716-14865,0,0,16332,14865,0z'/%3E %3Cpath d='m239701,86048,0-16332-14851,0,0,16332z'/%3E %3C/g%3E %3C/g%3E %3Cg%3E %3Cpath fill='%23fff' d='m240533,67027,9217-20893-7022-11339-11634,4307-8168-9337-10763,6168-9597-7860-9597,7860-10763-6168-8169,9336-11634-4307-7024,11342,9205,20897c11599-5250,24460-8175,37983-8175,13517,0,26372,2923,37968,8169z'/%3E %3Cg%3E %3Cpath fill='%230093dd' d='m174293,40024-17,20-11537-4272-6456,10424,2473,5623,6265,14222c4678-2068,9555-3764,14594-5048l-5321-20968z'/%3E %3Cpath fill='%23fff' stroke='%23000' stroke-width='118.162625' d='m173629,50332c413,783,647,1674,647,2617,0,3106-2533,5639-5639,5639-2737,0-5029-1968-5535-4561,974,1722,2823,2888,4935,2888,3121,0,5667-2545,5667-5667,0-312-26-618-75-917z'/%3E %3Cpolygon fill='%23000' points='168461,42530,168442,42623,168049,44647,169602,46004,169673,46066,169583,46097,167634,46769,167235,48792,167216,48885,167145,48822,165589,47470,163638,48136,163547,48167,163566,48073,163959,46050,162407,44693,162335,44630,162425,44599,164374,43928,164773,41905,164792,41812,164863,41874,166419,43227,168370,42561'/%3E %3Cg fill='%23f7db17'%3E %3Cpath d='m166119,45404,1455,1269,1821-627z'/%3E %3Cpath d='m166131,45340,3277,641-1450-1268z'/%3E %3Cpath d='m162613,44651,3276,641-1455-1268z'/%3E %3Cpath d='m165877,45357-3277-641,1450,1267z'/%3E %3Cpath d='m166060,45234,2194-2517-1823,622z'/%3E %3Cpath d='m163704,47937,2194-2517-1826,626z'/%3E %3Cpath d='m165948,45463-2194,2517,1823-622z'/%3E %3Cpath d='m168304,42760-2194,2517,1826-626z'/%3E %3Cpath d='m165933,45242-1083-3158-373,1890z'/%3E %3Cpath d='m167096,48634-1083-3158-371,1894z'/%3E %3Cpath d='m166075,45454,1083,3159,373-1890z'/%3E %3Cpath d='m164912,42062,1083,3159,371-1895z'/%3E %3C/g%3E %3C/g%3E %3Cg%3E %3Cpath fill='%23171796' d='m193069,36886-20,16-10673-6116-8083,9238,5321,20968c4938-1257,10031-2115,15242-2546l-1788-21560z'/%3E %3Cg fill='%23f00'%3E %3Cpath d='m178294,55788c5221-1329,10608-2237,16119-2692l-452-5450c-5816,481-11502,1439-17013,2841l1345,5301z'/%3E %3Cpath d='m175619,45250c5797-1476,11777-2483,17895-2989l-444-5350c-6418,530-12691,1588-18772,3135l1321,5204z'/%3E %3C/g%3E %3C/g%3E %3Cg%3E %3Cpath fill='%230093dd' d='m212105,36890-23,13-9517-7794-9497,7778,1788,21560c2543-210,5113-322,7709-322,2608,0,5190,113,7744,325l1795-21560z'/%3E %3Cg id='lion'%3E %3Cpath fill='%23000' d='m202545,46585c-18-2-44,10-69,45-186,250-359,469-545,720-195,61-242,180-167,348-261-26-291,193-302,432-250-379-522-482-814-307-11-230-187-338-439-392-180-10-319-65-436-145-60-42-110-64-170-106-126-88-226-5-172,74,267,434,535,868,802,1302-14,80,6,151,88,204,47,133,93,265,140,397-11,38-21,75-32,113-221-105-443-118-664-133-170-8-287-50-361-137-54-63-91-26-92,82-3,534,162,1014,599,1492-231,4-462,11-694,21-79,6-95,39-73,104,126,304,339,579,822,766-208,112-327,285-357,520-9,224-75,382-212,455-60,32-81,65-24,106,253,185,565,193,895,112-157,270-226,553-198,850,208,56,412,15,614-52-29,61-44,175-52,309-7,115-41,229-104,343-32,33-65,84,4,102,336,91,648,52,915-47,0,243,2,487,76,727,18,58,70,102,125,26,155-214,322-396,527-517,31,90,75,168,156,215,96,55,147,170,153,343,0,30-2,60,35,90,149,7,514-380,589-597,206,121,284,246,439,461,55,76,99,29,128-25,62-243,67-481,66-724,267,99,579,138,915,47,69-19,36-70,4-102-62-114-105-250-113-365-9-133-14-226-43-287,202,68,405,108,614,52,29-297-53-579-211-850,330,80,655,73,908-112,57-41,35-74-24-106-136-73-203-231-212-455-30-235-149-409-357-520,483-187,696-463,822-766,22-66,6-99-73-104-231-10-480-24-711-27,437-478,606-961,604-1495-1-108-38-146-92-82-74,87-179,137-348,146-222,15-435,24-656,128-11-38-21-75-32-113,46-132,106-260,153-393,82-53,102-123,88-204,267-434,513-868,781-1302,54-79-46-162-171-74-60,42-110,64-170,106-117,80-257,134-437,145-251,54-417,167-428,397-293-175-564-73-814,307-11-239-41-457-302-432,75-168,17-291-178-352-186-250-458-470-644-720-31-35-51-47-69-45z'/%3E %3Cg fill='%23f7db17'%3E %3Cpath d='m205075,47978c-51-26-124,17-162,95s-33,170,19,196c40,20,84-6,119-56l22-36c2-3,4-6,5-9,38-78,49-163-2-188z'/%3E %3Cpath d='m200067,47978c52-26,124,17,162,95s39,165-13,191-103-24-141-102-60-158-9-184z'/%3E %3Cpath d='m204606,48883c-32,0-59,27-59,59s26,59,59,59,59-26,59-59c0-32-26-59-59-59z'/%3E %3Cpath d='m200574,48883c-32,0-59,26-59,59,0,32,26,59,59,59s59-26,59-59-26-59-59-59z'/%3E %3Cpath d='m204868,48579c-754-91-1506-133-2260-133s-1509,41-2269,115c-26,8-21,90,14,86,756-73,1507-113,2256-113,743,0,1485,40,2228,129,39,4,54-80,32-84z'/%3E %3Cpath d='m200319,48495c768-75,1530-117,2289-116,754,0,1507,42,2261,133l111-184c-32,10-62,9-90-5-76-38-92-161-36-274,56-114,164-175,240-138,39,19,62,62,68,114l446-739c-204,130-328,214-581,252-281,41-409,139-368,307,38,156-57,133-201,54-314-171-541,71-652,353-73,186-159,181-168-13-4-70,0-131-7-200-21-223-89-286-216-224-161,78-175,25-137-58,28-60,86-128,66-221-9-67-66-92-151-98-182-244-467-483-649-727-182,244-374,483-556,727-86,5-142,30-152,98-20,93,52,157,80,217,38,82,23,135-137,57-127-61-186-3-207,220-7,69-10,139-13,209-9,194-95,199-168,13-111-282-352-524-667-353-145,79-203,102-182-54,23-172-107-266-388-307-253-37-377-122-581-252l419,682c12-25,29-45,53-57,76-38,184,24,240,138,56,113,40,237-36,274-10,5-21,8-32,10l100,163z'/%3E %3Cpath d='m204708,49406c-7,3-7,4-24,11-46,19-80,66-134,124-57,60-128,125-211,188-12,10-25,19-44-6s-7-35,6-44c80-62,149-124,204-182,30-32,56-63,77-92-95-11-190-21-284-30-79,24-157,55-222,95-59,35-107,77-137,125-8,14-16,27-44,11-27-16-19-30-11-44,35-58,91-107,158-147,33-20,69-38,106-54-107-9-214-18-321-25-22,13-42,29-61,47-20,19-39,42-56,67-9,13-18,26-44,8s-18-31-8-44c19-29,41-54,64-77,3-3,6-6,9-9-80-5-161-10-241-14-2,2-5,5-8,7-21,18-40,38-55,59s-28,43-38,67c-6,15-12,29-41,18-29-12-23-26-17-41,12-29,27-55,45-81,8-11,18-22,27-33-115-5-230-9-344-12-4,5-9,8-14,11-25,15-47,32-66,51s-35,40-48,63c-8,14-16,28-43,12-28-16-20-29-12-43,16-28,35-54,59-77,7-7,14-13,21-19-122-2-244-4-365-4-120,0-240,1-360,3,8,7,15,13,22,20,23,23,42,49,59,77,8,14,16,27-12,43s-35,2-44-12c-13-23-29-44-48-63s-41-36-66-51c-6-3-12-7-15-12-115,2-230,6-345,11,11,11,20,23,29,35,19,25,33,52,45,81,6,15,12,29-17,41s-35-3-41-18c-9-24-22-46-38-67-15-21-34-41-55-59-4-3-7-6-10-10-81,4-162,8-243,13,4,4,9,8,13,12,24,23,45,48,64,77,9,13,18,26-8,44s-35,5-44-8c-18-26-36-48-56-67s-41-35-64-49c-1-1-3-2-5-3-110,7-220,14-330,23,43,18,85,38,122,61,67,40,124,89,158,147,8,14,16,27-11,44-27,16-35,3-44-11-29-48-78-90-137-125-72-44-159-77-246-102h-2c-90,7-179,15-268,24,22,33,51,68,86,106,55,58,124,120,204,182,13,9,25,19,6,44s-32,15-44,6c-83-64-155-128-211-188-37-38-99-111-135-140-196-90-354-127-575-147-153-14-318-9-458-79,36,85,75,164,126,229,53,68,120,121,209,147,8,2,21,16,22,25,28,157,84,286,169,386,52,60,114,110,188,149-75-81-132-166-172-251-67-142-90-286-77-420,1-16,3-32,34-29,32,3,30,19,29,35-11,123,9,256,72,387,56,118,159,237,291,346,24,19,0,63-29,55-154-44-290-123-383-231-89-104-149-237-180-397-94-32-165-90-222-164-47-60-85-131-118-205,28,428,182,801,456,1137,61,75,165,182,255,216,92,35,95,100-20,101-34,1-69,1-105,1,84,31,164,66,233,105,127,73,217,162,224,273,1,16,2,32-29,34-32,2-33-14-34-29-6-86-82-160-192-223-113-65-259-117-402-160-154,0-312-1-459,3,39,28,80,57,131,84,82,44,188,86,343,122,89,21,166,52,233,91,71,42,130,93,177,150,10,12,20,25-5,45s-34,8-45-5c-42-52-95-98-159-135-61-36-133-64-216-84-161-38-272-81-358-128-75-40-131-82-184-123,180,393,450,573,835,689,23,7,43,13,61,19,3,1,6,1,9,2,86,21,175,40,266,55,92,15,166,28,261,37,16,1,32,3,29,34-3,32-19,30-34,29-99-9-174-22-266-38-58-10-115-21-171-33-26,6-64,9-107,12-232,14-420,225-435,494,0,5,0,11-1,16,88-80,179-157,273-212,117-68,239-103,364-69,15,4,31,8,22,39-8,31-23,27-39,22-106-28-212,3-316,63-108,63-213,158-315,253-24,147-82,285-205,377,61,34,104,65,163,45,86-39,172-78,261-108,91-31,184-52,282-57,16-1,32-1,33,31s-14,32-31,33c-91,4-179,24-264,53-75,26-149,58-222,91,221,47,460-1,667-79,60-22,105-42,133-41,51-30,112-53,172-79,66-28,132-51,182-57,16-2,32-4,35,28,4,32-12,33-28,35-112,13-127,21-222,79,0,21-66,57-126,96-36,24-70,52-87,67-95,86-144,181-188,287-29,70-52,145-68,224,55-108,121-211,201-303,94-108,208-201,345-265,14-7,29-13,42,15,13,29-1,35-15,42-129,60-236,147-324,250-90,103-161,222-219,345-31,64-8,1-42,86,110-122,212-224,323-307,132-100,283-157,418-133,15,3,31,6,26,37s-21,28-37,26c-116-21-250,32-369,121-121,92-244,223-366,361,184,26,366-26,542-85,91-30,183-135,239-152,19-24,38-46,57-67,33-37,67-71,102-100,12-10,24-20,45,4s8,34-4,45c-33,28-65,60-96,94-32,35-62,73-92,113-6,8-13,17-24,16-60,70-151,162-172,240-57,210-25,370-122,576,71-38,128-81,175-134,53-60,94-135,128-230,37-104,95-195,167-270,75-77,165-136,261-172,15-5,30-11,41,19s-4,35-19,41c-87,32-169,86-238,157-66,68-119,151-153,247-37,102-81,183-141,250-44,50-95,91-156,127,52-3,78-10,121-7,79-6,211-66,279-119,66-51,116-120,154-206,6-15,13-29,42-16s23,27,16,42c-42,96-99,174-173,231-56,43-121,75-196,93,161-5,311-42,467-100,65-24,87-168,127-208,32-58,66-112,105-158,47-56,101-101,164-127,15-6,29-12,41,18,12,29-3,35-17,41-52,21-98,60-139,108-36,42-68,93-98,147,10,73-51,228-53,305-7,205-2,409,53,612,53-71,107-134,162-192,0-5,0-10,1-15,18-106,33-219,40-332,7-112,7-223-6-329-2-16-4-32,27-35,32-4,34,12,35,28,14,111,14,226,7,340-6,90-16,180-30,269,54-51,53-51,77-103,37-80,59-159,67-237,9-80,5-157-13-230-4-15-7-31,24-38s35,8,38,24c19,80,25,165,14,252-8,65-24,132-49,199,56-42,114-82,178-122-4-75-5-153-3-227,2-68,7-134,18-190,4-20,7-40,47-33s37,27,33,48c-9,50-14,111-16,177-2,78,0,162,4,243,5,82,49,185,125,230,103,62,158,163,186,274,16-145,17-280,3-400-17-143-55-267-114-368-8-14-16-27,12-44,27-16,35-2,43,12,63,110,104,241,122,393,17,146,13,310-13,488,102-82,381-258,352-594-7-27-16-52-28-75-7-14-14-28,14-42s35,0,42,14c17,33,30,69,39,110,5,24,8,49,11,76,13-7,45-43,51-39,24,16,58,38,80,54-21-60-35-120-42-178-10-87-5-172,14-252,4-15,7-31,38-24s27,23,24,38c-18,73-22,151-13,230,9,77,31,157,67,237,4,8,8,16,5,25,24,21,47,42,70,65-13-84-22-170-28-255-8-115-7-230,7-341,2-16,4-32,35-28s29,20,27,35c-13,106-13,217-6,329,7,113,22,225,40,332,1,2,1,5,1,7,54,59,95,120,152,196,55-203,73-407,66-612-2-76-69-227-65-302-30-55-63-107-100-151-41-49-87-87-139-108-15-6-29-12-18-41,12-29,27-24,41-18,62,26,117,71,164,127,38,45,72,98,103,154,57,7,78,179,143,212,154,57,298,94,453,100-75-19-140-50-195-93-74-57-131-135-173-231-6-15-13-29,16-42s35,2,42,16c38,86,88,156,154,206,85,66,289,124,400,127-61-37-113-78-157-128-59-67-104-148-141-250-34-95-87-179-153-247-68-71-150-124-238-157-15-6-29-11-19-41,11-29,26-24,41-19,96,36,186,94,261,172,72,74,130,166,167,270,34,95,75,169,128,230,47,54,105,98,177,135-98-207-66-367-122-577-35-129-232-277-193-320,45-51,133,88,248,127,175,59,357,111,540,85-122-138-244-269-366-361-119-90-237-140-352-120-16,3-31,6-37-26-5-31,10-34,26-37,135-24,269,32,401,132,111,84,201,175,311,298-18-47,0-14-30-77-59-123-130-241-220-345-89-102-196-189-324-250-14-7-28-13-15-42,13-28,28-22,42-15,137,65,251,157,345,265,81,93,147,198,203,307-15-81-39-157-68-227-44-106-93-201-188-287-62-56-209-140-208-179-29-15-33-11-63-24-61-26-121-46-164-52-16-2-32-4-28-35,4-32,19-30,35-28,50,6,115,28,182,56,33,14,66,43,98,60,53,4,139,47,208,74,206,78,446,126,666,79-73-33-147-65-223-91-85-29-172-49-264-53-16-1-32-1-31-33s17-31,33-31c98,4,191,26,282,57,89,30,175,69,261,108,59,27,101-7,163-45-123-92-181-230-205-376l-2-2c-102-95-207-190-315-253-104-60-210-91-316-63-15,4-31,8-39-22-8-31,7-35,22-39,125-33,247,1,364,69,94,55,186,132,274,213,0-6-1-11-1-17-15-270-203-480-435-494-78-5-189,21-186-32,4-59,97-44,234-86,385-116,655-296,836-690-54,41-110,83-186,124-86,47-198,91-358,128-82,19-154,48-216,84-64,38-117,84-159,135-10,12-20,25-45,5s-14-32-5-45c47-57,106-108,177-150,67-39,145-70,233-91,155-36,261-78,343-122,51-27,92-55,131-84-148-4-305-3-459-3-143,44-289,96-402,160-110,63-186,136-192,223-1,16-2,32-34,29-32-2-31-18-29-34,8-111,97-200,224-273,69-39,149-74,233-105-35,0-70,0-104-1-116-2-112-66-20-101,90-34,190-141,251-216,271-334,412-714,456-1130-33,72-69,140-115,198-57,73-128,131-222,164-31,160-91,293-180,397-92,108-216,185-369,230-29,8-52-35-29-55,132-109,221-226,278-344,62-131,83-264,72-387-1-16-3-32,29-35,31-3,33,13,34,29,12,134-10,278-78,420-40,85-97,170-172,251,73-39,136-89,187-149,85-100,141-229,170-386,1-8,14-22,22-25,89-27,155-79,209-147,51-65,90-143,126-228-140,69-304,64-457,78-213,19-369,68-554,152z'/%3E %3Cpath d='m204649,49231c-680-88-1359-113-2041-114-684,0-1369,40-2058,112-20,6-15,33-14,46,2,28,37,35,121,27,643-60,1285-93,1932-93,674,0,1351,21,2038,102,33,9,77-85,22-81z'/%3E %3Cpath fill-rule='evenodd' d='m200570,49160c683-71,1362-110,2038-110,675,0,1349,40,2025,127l31-127c-17,9-37,15-58,15-67,0-123-55-123-123s55-123,123-123c51,0,94,31,113,75l60-170c-724-84-1446-122-2171-122-729,0-1459,38-2193,107l58,164c22-32,59-54,101-54,68,0,123,55,123,123s-55,123-123,123c-12,0-25-2-36-6l33,94-2,7zm3067-416c-68,0-123,55-123,123s55,123,123,123,123-55,123-123-55-123-123-123zm0,64c-33,0-59,27-59,59s26,59,59,59c32,0,59-27,59-59s-26-59-59-59zm-1082-91c-67,0-123,55-123,123s55,123,123,123,123-55,123-123-55-123-123-123zm0,64c-32,0-59,26-59,59s26,59,59,59,59-26,59-59c0-32-26-59-59-59zm-1064-40c-68,0-123,55-123,123s55,123,123,123c67,0,123-55,123-123s-55-123-123-123zm0,64c-33,0-59,26-59,59s26,59,59,59c32,0,59-26,59-59,0-32-26-59-59-59z'/%3E %3C/g%3E %3Cg fill='%23000'%3E %3Cpath d='m202601,47974c-14-68-49-129-100-175-51-47-116-78-187-88-33-4-39-58-7-68,60-20,114-67,157-133,45-69,79-157,95-256,5-34,64-35,69-1,15,84,51,153,97,208,55,66,125,112,193,138,31,12,25,63-8,68-59,9-105,42-141,87-50,62-81,145-100,221-8,33-62,31-69-2zm33-118c20-52,47-103,81-146,28-34,60-64,99-84-51-30-100-70-143-120-28-34-53-73-73-116-19,59-45,112-75,158-31,47-67,86-108,116,50,19,95,47,134,82,34,31,63,68,85,110z'/%3E %3Cpath d='m203433,52971-515,206c-17,7-35,14-48-21-14-34,4-41,21-48l515-206c17-7,35-14,48,21,14,34-4,41-21,48zm59-326-604,328c-16,9-33,18-51-15s-1-42,15-51l604-328c16-9,33-18,51,15s1,42-15,51zm-1826-65,604,328c16,9,33,18,15,51s-34,24-51,15l-604-328c-16-9-33-18-15-51s34-24,51-15zm51,322,515,206c18,7,35,14,21,48-14,35-31,28-49,21l-515-206c-17-7-34-14-21-48,14-35,31-28,48-21zm224,434c137,33,261,48,358,31,88-16,155-60,191-146v-493c-107-1-212-15-303-41-109-31-170-98-201-178-41-107-27-235-4-329,5-18,9-36,45-27s32,27,27,45c-20,82-33,194,1,284,23,60,69,110,152,133,91,25,198,38,307,38,107,0,214-13,304-40,82-24,148-69,192-123s65-117,57-176c-5-36-24-62-49-80-34-24-82-35-128-37-47-2-94,7-142,16-25,5-50,9-77,13-19,2-37,5-42-32s14-40,32-42c23-3,48-8,73-12,52-10,105-20,159-18,60,2,121,18,168,51,42,29,72,72,80,131,11,80-16,163-73,233-53,65-131,119-229,147-83,24-178,38-274,42v483c3,5,3,11,2,16,37,82,102,125,188,141,97,18,221,2,358-31,18-5,36-9,45,27,8,37-9,41-28,45-146,35-279,51-388,32-92-17-165-58-215-132-49,74-124,115-215,132-109,20-242,4-388-32-18-4-37-8-28-45,8-36,27-32,45-27zm356,210,402-9c19,0,38-1,38,37,1,38-18,38-37,38l-402,9c-19,0-37,1-38-37s18-38,37-38z'/%3E %3Cpath d='m202890,50464c151-125,293-227,423-297,133-72,254-111,359-106,19,1,37,1,36,39-1,37-20,37-39,36-92-4-200,32-322,97-125,67-263,166-410,289-14,12-29,24-53-5s-9-41,5-53zm-605,56c-141-130-298-240-445-314-139-71-268-108-363-100-19,2-37,4-40-34-4-37,15-39,34-40,110-10,252,31,404,107,152,77,315,191,461,325,14,13,28,25,2,53-25,27-39,15-53,2zm-213,1004c37-83,83-155,136-219,53-63,112-119,174-170,14-12,29-24,52,5,24,29,9,41-5,53-59,48-114,101-164,160-49,59-91,125-125,201-8,17-15,34-49,19s-27-32-19-49zm371-1734c49,66,88,139,114,223,26,82,40,175,39,279,5,80,6,165-7,249-13,86-42,170-97,246-43,60-101,97-165,113-53,13-109,10-164-7,29,100,51,208,6,308-8,18-33,27-51,18-43-22-86-43-128-62s-84-36-127-51l-1-1c-95-37-173-73-236-112-65-39-115-80-150-124l1,2c-44-49-72-106-88-170-14-55-20-114-22-174-72-39-138-78-194-116-64-43-118-87-161-131-13-14-26-27,1-53s40-12,53,1c39,40,89,80,150,121,60,40,128,81,204,121,124,13,247,51,370,109,106,50,211,115,317,192,13,7,19,16,27,20,8,6,16,13,25,19,51,22,104,28,152,16,47-11,90-39,122-84,48-66,72-139,84-214,12-77,11-157,6-234v-2c1-97-12-183-35-258-24-76-58-142-102-201-11-15-22-30,7-52s41-7,52,7zm-375,1047c-104-77-207-141-311-190-105-49-210-83-314-98,2,48,8,93,18,135,13,52,35,99,71,138l1,1c30,37,73,72,130,107,60,36,134,71,225,106l-1-1c45,16,89,34,133,54,31,14,61,28,93,44,19-83-10-179-37-267-2-8-5-15-9-29zm776-1003c-44,59-79,125-102,201-24,76-36,161-35,258v2c-5,77-6,158,6,234,12,75,37,148,84,214,32,45,75,72,122,84,48,12,101,6,152-16,8-6,17-13,25-19,6-4,13-12,27-20,105-77,211-143,317-192,123-58,246-95,370-109,75-40,144-80,204-121s111-81,149-121c13-13,26-27,53-1s14,39,0,53c-43,44-97,88-161,131-57,38-122,77-194,116-2,61-8,119-22,174-16,63-44,121-88,170l1-2c-35,44-85,85-150,124-63,38-141,75-237,112l-1,1c-43,15-85,32-127,51-43,19-85,40-128,62-18,9-43,0-51-18-45-100-23-208,6-308-55,18-111,20-164,7-64-15-122-53-165-113-55-76-84-160-97-246-13-85-12-169-7-249-1-104,13-196,39-279,26-84,65-158,114-223,11-15,22-30,52-7,30,22,19,37,7,52zm940,715c-105,15-209,49-314,98-104,49-207,113-311,190-4,13-6,21-8,29-27,88-56,184-37,267,31-15,62-30,93-44,44-20,87-38,133-54l-1,1c91-35,165-70,225-106,58-34,100-70,131-107,0,0,1-1,1-1,35-39,57-86,71-138,11-42,16-87,19-135z'/%3E %3Cpath fill-rule='evenodd' d='m203459,50602c-119,0-216,97-216,216s97,217,216,217,216-97,216-217c0-119-97-216-216-216zm0,69c-81,0-147,66-147,147s66,147,147,147,147-66,147-147-66-147-147-147zm0,60c-48,0-87,39-87,87s39,87,87,87,87-39,87-87-39-87-87-87zm-1697-124c119,0,217,97,217,216s-97,217-217,217c-119,0-216-97-216-217,0-119,97-216,216-216zm0,69c81,0,147,66,147,147s-66,147-147,147-147-66-147-147,66-147,147-147zm0,60c48,0,87,39,87,87s-39,87-87,87-87-39-87-87,39-87,87-87z'/%3E %3C/g%3E %3C/g%3E %3Cuse xlink:href='%23lion' transform='matrix(0.99928092,-0.03791625,0.03791625,0.99928092,-5965.3264,-1993.2203)'/%3E %3Cuse xlink:href='%23lion' transform='matrix(0.99927613,0.03804216,-0.03804216,0.99927613,6277.9506,-17381.167)'/%3E %3C/g%3E %3Cg%3E %3Cpath fill='%23171796' d='m230880,40035-25,9-8100-9258-10650,6104-1796,21560c5212,432,10304,1293,15241,2551l5329-20965z'/%3E %3Cpath fill='%23000' d='m214206,41363c370-90,735-109,1089,108,155,64,272,146,344,251,164-127,331-246,504-348,243-180,491-339,758-428,382-194,763-309,1145-344,404-69,810-73,1214-49,337,20,663,113,974,292,282,140,563,281,845,421,298,166,596,316,894,442,378,149,803,199,1256,216,222,8,440,8,654-49,173-46,281,64,90,181-1400,859-2497,95-3433-247,343,232,645,472,900,717,356,343,754,691,1458,1012,427,194,892,347,1489,352,202,2,420-6,656-45,119-19,170-8,172,54,2,42-9,126-80,173-361,242-701,306-1080,330-722,46-1494-191-2200-570-565-304-946-674-1396-1006-449-331-837-515-1254-603-411-88-856-78-1231,38,112,22,207,75,265,142,193,114,441,164,800,205,187,22,129,151-159,306-173,223-398,343-697,314-412,273-559,108-697-71-17,113-50,224-99,331,18,58,20,122-6,180,66,102,98,201,76,310,11,58,30,114,92,166,86,78,141,168,152,278,1,73,41,133,99,187,84,69,169,130,253,233,249,90,364,281,405,528,188,61,266,197,303,359,107,45,205,99,261,194,384,1,759,1,1110,38,329,35,597,240,837,506,162,25,326,33,494-5,173-76,356-134,555-151,329-28,659-45,973,30,213,51,379,164,515,318,196,223,498,193,756,83,350-149,641-144,999,13,153-59,306-87,459-71,131-142,270-177,413-181,233-8,402,28,358,327-12,81-60,159-121,187-107,231-311,299-570,277-28,159-93,277-197,353,119,367,5,514-267,509-57,106-142,172-287,151-106,129-231,195-368,217,16,96,57,141,125,244,185,280-93,393-347,397,65,185,73,370,50,555,259,157,294,322,55,485,175,306,107,531-221,695-5,171-22,343-136,439-78,66-190,78-116,202,133,220,104,498-93,506-42-4-80,2-83,69,0,23-20,46-59,69-236,127-457,272-660,439-30,20-60,34-90,7-148,322-424,649-729,978-47,242-184,406-411,491-16,75-64,119-135,138,127,141,175,277,52,411-151,165-350,326-549,377-423,108-688,88-858-74-150-143-91-251,4-296-261,21-314-117-307-301,15-92,46-80,138-77,142,4,270-73,404-117,52-88,120-164,204-228,47-296,234-460,488-557,205-78,401-276,591-532,117-202,235-403,352-605-82-107-104-214-107-321-108-60-183-134-235-218-184-13-260-96-287-211-42,1-88-3-138-18-90,58-181,109-294,104-149,153-303,278-460,384-55,152-164,213-297,232-378,45-604,516-812,708-84,62-136,172-173,304-18,248-61,442-197,446-122-5-141-18-145-31-53-5-106-5-159,7,102,112,118,253,24,377-94,122-229,160-359,169-269,18-487-6-689-88-193-79-216-194-210-306-139-66-167-132-152-197,19-84,96-127,193-100,84-40,168-67,252-83,244-263,495-489,771-594,81-98,174-186,287-259,32-236,187-422,377-595,17-85,45-171,93-256-11-51,3-75,4-123-77-143-123-315-66-458-23-69-30-159-21-228-454,270-594,178-646-41-166,139-321,204-432,4-161,48-323,102-484,38-105,41-211,78-332,86-49,97-115,194-204,291-5,204-76,408-207,612-76,218-170,435-294,653,2,70-8,140-45,211,35,251-49,373-187,435-37,101-92,203-176,304-4,33-7,67-11,100,55,148,64,295-86,443-121,76-250,156-378,219-151,74-291,39-418-7-223-80-206-158-177-234-70,28-150,31-220-3-54-34-88-69-142-104-48-87-65-166,52-228,147-65,247-113,363-232,40-90,91-158,163-176,70-164,156-275,273-305,86-203,178-427,287-621,38-59,66-120,48-187-2-55,2-107,48-138,26-22,72-42,14-73-53-181-20-354,69-487,118-178,250-608,125-819-23-118-46-253-31-364-43-2-75,4-118-26-96-59-176-3-249,104-53,134-106,252-159,252-50,346-220,615-397,684-41,159-67,318-45,477,18,173,0,291-80,311-88,22-170,73-221,214-14,39-30,86-31,142,122,126,85,283-32,399-264,260-592,222-939,120-251-99-312-204-287-311-356-30-285-303,10-385,317-89,574-292,785-582,19-344,98-578,283-615,18-211,84-401,173-581,93-163,150-342,117-560-197-123-205-250-24-380,60-35,53-71-21-107-120-12-105-127-97-235-5-56-34-85-87-86-266-39-200-148-86-266,48-54,80-134,30-166-41-26-69-117-78-197-163-123-93-249,0-370-92-78-135-192-148-325-303-13-416-167-252-391,69-95,158-186,266-273,70-113,137-226,104-339-87-221,191-388,429-560-33-58-50-115-52-173-134-129-100-249,48-363-33-59-49-118-55-176-333,66-331-133-176-453-193-111-139-308,211-608,5-69,18-122,38-159-166,4-303,53-422,128-133,87-265,76-398,21-41-66-104-122-176-173-91-80-112-170-93-266-392,22-467-268-232-439,131-104,227-213,263-332,106-269,331-452,550-640,0-77,17-154,41-232-97-65-199-112-311-121-40-100-115-208-242-269-73-44-97-85-52-184-208-186-156-299-103-406z'/%3E %3Cg fill='%23f7db17'%3E %3Cpath d='m221318,51461c-23,2-47,4-74,3-101,103-222,206-334,294-97-112-241,11-100,79-24,17-48,34-72,50-46,122-88,174-224,195-21,3-42,7-63,12-1-52,1-102,6-151,6-61,16-120,29-178,2-11,5-21-16-26s-24,6-26,17c-13,60-24,121-31,183-6,55-8,111-6,167-343,110-541,467-775,721-101,87-152,207-189,333-20,67-27,374-96,379-33,1-68,0-105,0-37-56-87-57-150-4-143-3-295-4-422,16-87,94,152,59,279,137,58,35,83,104,60,200-117,279-770,189-987,74-101-53-105-114-101-201,45,0,91-3,137-10,78-11,155-34,231-77,21-12,43-24,19-67s-46-31-67-19c-64,37-130,56-196,65-68,10-138,10-205,7-6,0-12-1-17,0-38-22-67-48-51-71,16-22,79,2,91,6,101-47,189-77,298-98,230-246,464-477,781-604,95-114,198-204,322-286,44-274,177-420,376-602,24-113,52-194,108-293-12-63-3-103,0-167-76-144-121-269-61-430-37-117-32-196-18-304,4-28,3-48-1-61,62-49,125-95,187-137,57-38,114-73,171-105-9,108-5,221,16,339,0,0-1,1-1,1-34,37-63,73-83,111-21,39-33,78-31,117,0,11,0,22,22,21,22,0,22-11,21-22-1-31,8-63,26-95,18-33,45-67,77-101,3-3,6-7,8-11,105-3,208-59,311-142,93-76,186-174,278-277-1,150-2,300-4,450-90,80-167,178-227,297-5,10-10,19,9,29,20,10,25,0,29-10,55-109,125-199,206-274h4c22,0,22-11,22-22v-1c14-12,29-24,44-35,102-79,218-139,343-187-19,132-28,261-5,385,25,136,89,264,219,376,2,2,5,3,8,4z'/%3E %3Cpath d='m214786,47657c17-31,60-71,74-68,3-1,5-1,8-2,47-88,96-170,147-244,66-96,136-181,210-253,8-8,16-15,31,0,15,16,7,23,0,31-72,70-140,152-205,246-50,73-98,153-144,240,15,20,22,51,14,73,15,137,33,214,94,293,7-6,14-11,21-14,25-61,59-115,101-163,52-58,115-107,191-148,52-43,94-87,128-133,34-45,61-91,80-138,4-10,8-20,29-12,20,8,16,19,12,29-21,51-49,100-85,148-37,48-82,95-138,141,0,0-3,2-4,2-71,39-132,85-180,139-37,41-66,87-89,138,32,23,46,86,16,126-91,131-199,208-29,320-6,88,22,155,80,216,39,41,35,184-61,287-90,91-21,67,72,78,7,2,14,5,21,7v-1c34-66,74-125,118-180,43-54,90-105,138-153,67-66,120-138,158-211,37-71,59-144,63-214,1-11,1-22,24-20,22,1,21,12,20,23-5,76-28,154-68,232-40,77-96,152-166,221-47,47-92,95-134,149-42,53-80,110-113,173,112,68,76,190,93,302,22,3,41,8,58,16,1-2,2-4,4-6,22-34,44-69,66-104l104-165c6-9,12-19,30-7,19,12,13,21,7,30l-104,165c-22,35-44,69-66,104-1,2-2,4-3,5,69,56,74,158-11,236-167,126-120,165,36,265,20,147,21,265-11,390,1,3,1,7,2,11,4,41,7,83,10,124l10,125c1,11,2,22-20,24s-23-9-24-20l-10-125c-1-11-2-21-2-32-8,19-16,39-26,60-112,245-228,445-253,720-269,64-229,329-244,563-212,286-458,515-799,629-64,21-219,59-234,140-2,29,104,92,172,55,188-180,282-80,66,104-17,35-3,74,34,107,195,175,678,232,898,93,163-102,248-214,106-369,9-220,95-435,327-497,27-50,19-143,7-194-22-191,8-361,55-545,8-23,25-42,63-52,88-18,257-273,310-518,13-53,21-108,31-163,14-85,47-100,90-50,41-55,40-88,65-151,90-131,220-236,372-162-39-107-66-228-74-351-11-146,3-297,48-435,6-21,13-41,46-36,44-104,87-207,131-311s88-209,132-313c4-10,8-20,28-12s16,19,12,29c-44,104-88,208-132,313-44,104-87,207-131,310,19,14,13,32,7,50-40,125-53,263-43,398,10,146,46,287,100,402,5,11,11,22,9,33,72,42,71,52,68,148-2,75,8,149,26,239,143,264-6,706-145,927-67,107-85,229-57,352,86,83,30,169-46,227-6,20,0,43,1,63,8,86-23,158-68,229-117,211-207,436-301,657-170,47-205,146-273,305-99,28-109,57-151,148-114,115-223,184-369,250-121,55-4,108,81,166,77,57,178-67,241-161,69-104,139-73,94,8-50,89-86,217-91,284-26,72,248,127,295,129,167,8,377-155,508-238,109-111,92-208,44-343l1-9c-70,2-136-6-201-20-79-18-157-45-236-78-10-4-20-8-12-29,8-20,19-16,29-12,78,32,153,59,229,75,63,14,128,21,197,19l11-105c87-107,147-212,194-340,185-87,186-177,161-375,41-80,50-127,47-218,122-217,222-439,305-674,146-194,216-377,199-608,13-90,46-141,112-138,48-67,91-136,130-213,8,1,16,2,24,2-2-5-1-11,0-16,12-53,26-100,44-139,17-39,37-70,60-95,27-66,37-130,30-192-7-64-29-126-65-187-22-25-42-51-49-78-9-31-3-62,28-93,8-8,16-15,31,0,15,16,8,24,0,31-18,17-21,33-16,49,6,20,22,41,41,63,0,0,2,4,2,4,39,67,65,136,72,207s-3,144-35,217c0,1-4,6-4,7-21,22-39,50-55,85-16,37-30,80-41,130-1,3-1,6-2,8,103,0,194-32,293-81,2-2,4-4,6-6,50-40,103-101,147-181,37-67,67-149,84-243,2-11,4-21,26-18,21,4,19,15,18,25-18,100-50,185-89,257-34,63-74,114-114,154,160,48,299,1,451-46-22-214-19-377,4-505,25-139,72-237,131-311,7-9,13-17,31-4,17,14,11,22,4,31-55,69-99,161-122,292-22,122-26,278-5,484,2-1,5-1,8-2,64,109,98,188,229,103,48-32,98-64,138-106,15-16,10-25,22-38,125-133,251-257,376-367,126-111,252-206,378-283,9-6,19-12,30,7s2,24-7,30c-124,75-248,170-372,278-107,94-214,198-321,310,6,19,9,52,12,102,11,148,38,237,249,156,118-45,130-50,239-115,53-32,98-59,129-66,69-54,137-105,206-151,67-45,135-86,202-122,11-80,29-158,55-233,65-192,174-370,311-538,1-1,6-5,7-6,114-62,207-135,281-218,75-83,131-176,173-277,4-10,8-20,29-12,20,8,16,19,12,29-44,105-103,202-180,289-77,86-172,162-290,226-133,164-239,336-301,521-22,65-39,131-49,200,4,1,8,5,12,13,10,20,0,25-9,29-3,1-6,3-9,5-13,108-10,222,10,340,93-3,187-55,282-132,101-82,204-195,306-310,1-3,1-5,4-7,25-82,57-154,99-212,45-62,100-109,168-138,10-4,20-9,29,12,8,20-1,24-12,29-60,26-110,68-150,123-40,56-71,126-95,206-1,156-3,312-4,468,5-4,11-8,16-13,115-89,247-155,390-207,15-6,32,8,29,24-22,140-34,279-11,407,22,120,76,232,184,332,41-74,89-140,141-200,18-21,37-41,56-60,1-2,2-4,5-5,41-41,83-79,127-115,32-29,64-59,95-89,32-29,64-59,96-89,8-8,16-15,31,1s7,24-1,31c-32,30-64,59-96,89-32,29-64,59-96,89,0,0-1,1-1,1-41,33-81,68-118,106,1,41,3,81,5,122,1,22,1,44,2,66,92,25,147,26,241,24,31,185,47,214,208,218-2-66-1-130,6-193,8-72,23-142,48-208,4-10,8-20,28-13,21,8,17,18,13,28-24,62-38,128-46,197-7,61-8,124-6,189h13c64,132,140,197,276,256,38-60,66-120,84-180,20-67,28-134,24-201-1-11-1-22,20-23,22-1,23,9,24,20,5,72-4,144-26,216s-57,143-105,214c-4,6-8,12-15,12,6,77,19,134,46,192,20-43,41-86,65-126,33-58,71-110,117-156,8-8,15-15,31,0,15,15,8,23,0,31-43,42-78,93-110,147-28,48-53,100-77,153,15,26,34,52,56,82-256,439-530,1047-1035,1247-261,103-375,236-427,515-98,76-168,153-232,259-170,57-322,142-506,134,0,119,39,171,158,172,227-114,278-135,298-119,28,24-32,187-220,319-29,18-28,29-11,59,159,249,576,160,800,101,160-42,449-232,529-392,31-74-39-169-109-247-320,49-259-258,16-130,93-28,105-29,131-132,245-95,347-198,403-461,247-266,495-540,673-859,49-60,78-166,64-221,44-52,68-118,84-178,16-64,26-127,24-191,0-11-1-22,21-23s22,10,23,21c2,68-8,135-25,203-14,52-32,104-51,156,16,40,24,67,59,57,214-172,430-293,661-436,16-98,79-146,176-150,39,1,53-11,67-47,54-135-14-228-79-340-60-167,47-207,154-287,112-83,104-303,108-430h1c-4-21-8-43-13-65-9-44-22-88-38-135-4-10-7-21,13-28,21-7,24,3,28,14,17,49,30,95,40,140,4,18,7,36,11,53,107-55,219-119,261-238,37-132-35-257-99-369-27,13-55,26-84,38-52,23-108,47-167,70-10,4-20,8-28-12s2-25,12-28c57-23,112-46,165-70,44-19,86-39,125-58,48-32,97-66,132-111,77-111-130-211-202-256,0-3,1-6,1-9-104-95-207-191-311-286-8-7-16-15-1-31s23-9,31-1c96,88,192,176,288,264,16-163,18-319-33-481-16-52-35-103-53-154-4,0-8-2-12-5-88-45-150-100-190-163-41-63-61-133-67-209-1-11-1-22,21-24,22-1,22,10,24,21,5,68,22,132,59,188,37,57,93,107,174,148,87,45,270,22,376-29,147-83-45-251-90-350-32-71-40-144-54-220,13-2,26-5,40-7-19-24-39-45-59-62-25-22-52-38-79-48-10-4-21-7-13-28,7-21,18-17,28-13,33,12,64,31,93,56,28,24,54,53,79,87,14-2,29-5,43-8,145-29,225-110,313-214-48-58-101-112-158-163-59-53-119-103-180-152-8-7-17-14-3-31s22-10,31-3c62,50,124,101,182,154,59,54,115,111,166,173,5,6,10,12,6,20,133,12,155-15,222-134-17-61-45-118-80-173-37-57-82-111-133-163-8-8-15-16,0-31,16-15,24-7,31,0,52,54,100,111,138,170,38,58,67,118,85,183,62,1,129,4,182-28,116-69,18-317-12-413,2-1,3-2,5-4-15-10-31-20-46-29-27-17-55-34-82-52-9-6-18-12-7-30,12-19,21-13,30-7,27,17,55,35,82,52,20,13,40,25,60,38,9-7,18-14,27-21,85-68,115-158,141-252,40-144,48-80,216-105,181-28,279-48,386-260,56-28,85-52,95-121,18-125,8-189-135-200-200-16-322,24-457,156,18,27,36,55,54,82,6,9,12,18-6,31-18,12-24,3-30-6-17-26-34-52-51-78-182-18-328,11-498,75-17-7-34-14-51-21,36,48,64,94,85,139,29,64,44,125,46,183,0,11,1,22-21,23s-22-10-23-21c-2-53-15-108-42-167s-68-121-126-187l-1-1c-142-51-272-77-405-74,22,22,45,44,67,65,29,28,58,56,86,84,8,8,16,15,0,31-15,16-23,8-31,0-29-28-58-56-86-84-29-28-58-56-86-84-3-3-6-6-8-9-113,9-230,39-359,93-81,34-164,60-245,75,60,58,111,123,151,197,42,76,74,160,95,253,2,11,5,21-16,26s-24-6-26-16c-20-89-51-170-91-242s-90-136-149-192c-6-5-11-11-9-19-75,11-150,12-222,1l89,147c5,10,9,20-10,29-20,9-25,0-29-10l-82-172c-69-14-137-40-200-79,21,79,37,164,49,254,16,119,26,246,29,380,0,11,1,22-21,22s-22-11-22-21c-3-133-12-259-28-375-15-107-35-208-63-300-31-24-61-52-90-84-72-79-152-140-240-187,5,37,5,73,0,109-9,66-36,133-88,198-7,9-13,17-31,4-17-14-11-22-4-31,47-59,71-118,79-177,6-42,4-85-5-127-137-63-288-94-444-107,42,55,82,110,118,167,42,66,80,133,114,201,62,51,95,113,114,181,18,67,22,139,25,212,0,11,1,22-21,23s-22-10-23-21c-2-70-6-139-23-202-17-61-47-117-102-161-1-1-6-6-6-7-34-68-72-135-113-201-42-66-88-130-139-192l-2-2c-53-3-106-4-159-3,9,12,18,24,26,37,19,31,32,65,36,104,1,11,2,22-20,24s-23-9-24-20c-4-32-14-60-30-86-13-21-28-40-47-58-110,3-219,12-324,21,110,141,198,287,266,437,76,167,127,339,156,517,2,11,4,22-18,25-21,4-23-7-25-18-29-174-79-343-153-506-71-155-163-306-279-451-5,0-11,1-16,1-85,8-171,26-253,49,37,23,69,46,97,69,38,31,68,62,94,93,7,9,14,17-3,31s-24,6-31-3c-24-29-53-59-88-88-35-28-76-57-126-86-44,14-87,30-130,47-24,9-47,18-71,25,74,53,145,111,213,176,82,79,159,168,228,271,6,9,12,18-6,30s-24,3-31-6c-67-100-141-187-221-264-75-72-155-135-238-193-90,20-181,25-272,22,56,111,105,223,142,336,40,122,68,245,77,370,1,11,2,22-20,24s-23-9-24-20c-9-122-36-241-75-360-40-119-92-236-151-352-55-4-111-11-167-18,32,102,60,207,84,314,28,126,51,255,68,386,1,11,2,22-19,25-22,3-23-8-25-19-16-130-39-258-67-382-26-116-57-230-93-342-158-171-333-338-547-427,44,56,79,114,104,175,39,94,57,194,54,299,0,11-1,22-22,21-22,0-22-12-21-22,2-99-14-193-51-282-33-79-81-153-148-222-48-14-99-25-151-30-140-14-281-23-422-28,108,98,193,188,185,297-1,11-2,22-24,20s-21-13-20-24c7-101-93-192-210-296-84-3-169-4-253-5,46,47,86,94,118,141,44,64,75,128,90,192v3c9,99,33,186,77,258,43,71,105,126,190,165,10,5,20,9,11,29s-19,16-29,11c-93-42-161-104-209-182-47-77-73-169-83-274-14-58-42-117-83-176-38-55-87-111-145-167-94,0-187-1-281-1,39,111,66,225,85,341,22,142,32,287,35,434,0,11,0,22-22,22s-22-11-22-21c-2-145-12-289-34-428-19-119-47-235-88-348h-26c-61-100-118-144-206-185-1,10-2,20-5,29-7,30-19,60-40,90-6,9-13,18-31,6s-12-21-6-30c17-25,28-50,33-74,3-13,5-26,5-40-14-6-29-12-45-19-45-188-87-266-237-330-1,52-4,106-14,161-12,68-34,137-75,203-6,9-12,19-30,7-19-12-13-21-7-30,38-61,58-124,69-187,10-57,13-115,13-171-8-3-17-6-26-9-40-263-88-410-361-514,3,34,4,69,2,104-3,59-14,119-38,181-4,10-8,21-28,13s-16-18-13-28c22-57,32-113,35-168,3-52-1-104-8-155-58-66-141-129-212-199,2,97-11,193-38,290-33,117-87,235-163,352-6,9-12,19-30,7-19-12-13-21-7-30,73-113,126-227,158-340,31-108,42-217,34-326-31-34-57-71-75-110-2,5-4,10-6,14-11,24-21,48-32,72-5,10-9,20-29,12-20-9-16-19-12-29,11-24,21-48,32-72,8-19,17-39,25-58-2-12-4-24-5-37-9-84-54-149-115-204l-1-1c-8,26-18,53-30,79-19,41-44,81-76,122-7,9-13,17-31,4-17-14-10-22-4-31,30-38,53-76,71-113,15-32,26-64,34-97-28-33-48-67-64-104-10,24-24,48-42,72-21,28-48,55-82,83-8,7-17,14-31-3s-5-24,3-31c31-25,55-50,74-75s32-49,41-74c14-39,19-14,6-77,23-124-23-198-89-301,1-3,2-5,4-8-39,1-84,14-133,35-59,26-124,65-192,112-9,6-18,12-30-6-13-18-4-24,6-30,71-48,138-88,199-115,62-27,119-42,168-39,12-33,13-58,5-96-200,74-358,109-485,117-133,8-235-13-320-49-10-5-20-9-11-29,8-20,19-16,29-12,79,34,174,54,300,46,125-8,279-42,477-116-1-2-1-4-2-6,36-80,65-158,85-236-71,19-141,18-211,16h-14c-11,0-22-1-22-22,0-22,12-22,22-22h14c74,1,148,3,221-21,5-26,9-52,13-78,11-87,113-108,185-30,60,64,115,132,174,160,120,57,255,6,352-72-29-9-59-19-89-29-11-3-21-7-14-27,7-21,17-18,27-14,38,12,76,24,114,37,9-9,18-18,26-27,248,21,409-31,568-191-141,3-267-1-376-13-120-14-219-38-292-74-10-5-20-10-10-29,10-20,20-15,29-10,68,34,163,57,278,70,117,13,255,17,412,12h2c14-16,28-33,43-51,68-28,136-59,186-115-289-31-564-88-823-223-67-75-173-117-286-146-210-26-396,26-567,115-45-42-80-80-124-121-66-8-128-43-194-51-88-10-180,7-268-3-11-1-22-2-19-24,2-22,13-21,24-19,88,10,180-7,268,3,85,10,166,47,251,57,284-107,519-166,722-157,237-69,483-98,729-92-3-2-6-5-9-8-29-29-15-44,0-58,133-135,164-259,121-371-44-116-164-225-331-325-178,20-349-28-538-7-118,13-234,39-348,77,95,34,178,90,246,170,84,99,144,234,176,404,4,20,7,41-33,48-40,8-44-13-48-33-29-155-83-277-158-366-79-113-260-157-317-180-189,19-375,40-537,82-122,31-229,74-311,138,122-26,249-21,359,34,105,52,194,150,250,309,7,19,13,39-26,52s-46-6-52-26c-47-137-121-219-208-262-173-86-530-11-681,101-88,66-176,151-263,250-16,19-33,37-70,5-37-33-21-51-4-69,91-103,183-194,278-264,92-68,187-117,285-140,100-111,248-178,419-222,167-43,358-65,552-84-57-115-130-184-214-221-90-40-193-46-305-35-233,80-440,205-639,346,18,0,36,0,53,1,59,4,112-5,161,14,19,7,39,14,25,53-17,47-146,18-191,15-51-3-107,1-169,16-9,2-19,5-28,2-243,150-417,302-619,473l-34,12c-180-7-304,18-378,74-67,51-72,131-59,239-31,101-70,212-80,330-211,181-446,362-555,626-24,77-65,145-116,206,43,7,78,20,105,41,10,8,19,16,27,26,5-45,12-90,23-133,15-62,37-119,66-165,6-9,12-18,30-6,19,12,13,21,7,30-27,41-47,94-61,152-17,69-26,145-28,215-1,22-41,24-44,2-5-37-21-66-47-85-27-20-65-32-114-36-45,49-96,93-147,134-42,34-82,71-91,126-6,96,112,113,224,120,255,15,52,160,192,287,68,47,131,102,179,169,97,35,157,27,223-3,13-173-2-261,74-261h8c4-22,9-44,18-66,13-32,32-65,58-97,7-8,14-17,31-3s10,22,3,31c-23,29-40,58-51,86-9,24-15,48-18,72,13,26,10,77,9,168,145-71,277-89,425-96,277-324,395-242,152-6-14,27-27,51-39,74-42,81-69,144-78,254-71,62-419,348-289,454,91-13,148-9,113,59-43,91-173,280-130,384,16,38,72,34,127,21,4-4,8-7,12-11,91-74,187-159,277-258,89-97,172-208,239-335,9-18,18-35,44-29,27-100,59-199,95-299,37-103,79-207,124-311,7-15,28-18,38-4,38,55,75,95,112,121,33,24,66,35,98,35s65-11,98-33c36-25,72-63,109-115,6-9,13-18,31-5s12,21,5,31c-40,56-79,97-120,125s-81,42-123,41c-41,0-82-15-123-44-33-24-67-57-100-101-39,91-75,182-108,273-37,101-69,203-97,304,23,19,13,37,4,55-72,135-160,252-254,355-76,84-157,158-236,225,11,74,30,144,64,216,151-130,292-262,416-398,124-137,232-278,317-425,6-9,11-19,30-8s13,21,8,30c-44,76-94,150-148,223,10,15,2,21-6,28-16,13-25,65-29,132-6,91,0,204,10,285,1,11,3,22-19,25s-23-8-25-19c-11-85-16-201-11-293,1-24,4-46,7-66-33,39-67,78-102,117-126,139-270,273-424,405-1,1-3,2-4,3,4,8,9,16,14,24-134,97-243,131-93,261,50-36,100-72,150-108l160-115c9-6,18-13,31,5s4,24-5,31l-161,115c-52,37-103,74-155,111-3,61,11,105,38,153,13-2,24-3,33-3,112-81,224-163,336-244,9-7,18-13,31,5s4,24-5,31c-108,79-217,158-326,237-7,13-21,30-39,50-110,79-494,316-453,480v1c92-26,184-58,272-103,91-47,180-110,264-196,8-8,15-15,31,0,15,15,8,23,0,31-87,89-179,153-274,203v4c-1,15-1,30-2,45s-1,30-2,45c-1,11-1,22-23,21s-21-12-21-23c1-15,1-30,2-45,1-8,1-17,1-25-78,36-157,63-237,85,33,155-48,288-131,421-47,38-431,349-271,442,43,21,91,31,139,36z'/%3E %3Cpath d='m214960,42248c-80-48-183-107-283-127-51-98-120-177-213-237-74-48-74-44-46-97,84-9,119-32,120-55,44,1,82,7,114,18,37,13,65,32,85,59,7,9,13,18,31,4,18-13,11-22,4-31-26-33-61-58-106-74-43-15-95-22-156-20-5,0-9,0-13,2-32-15-80-25-140-23-57-54-105-117-82-195,3,3,8,4,13,5,45,13,87,26,123,43,35,15,64,34,84,56,7,8,15,16,31,1s9-23,2-31c-25-27-58-48-98-67-29-13-61-25-95-35,330-67,625-62,920,113,155,64,228,138,312,252-28,24-56,47-84,71-193-5-335,22-424,90-80,60-96,168-99,276z'/%3E %3C/g%3E %3Cg fill='%23000'%3E %3Cpath d='m221520,51380c-65,40-118,68-185,79,3-2,6-5,8-8,43-81,93-152,149-216,7-8,15-17,22-25,1,27,2,53,3,80,1,30,2,61,3,91z'/%3E %3Cpath d='m222347,53150c-44,66-98,126-159,181-60,54-128,105-201,153-9,6-19,12-31-6s-3-24,6-30c70-46,136-96,196-149,59-53,111-110,152-173,6-9,12-18,31-6,18,12,12,21,6,30z'/%3E %3Cpath d='m222894,52498c-28,42-55,84-83,127-6,9-12,18-31,6-18-12-12-21-6-30,28-42,55-85,83-127,6-9,12-18,31-6,18,12,12,21,6,31z'/%3E %3Cpath d='m222596,52456c-14,63-37,123-77,178s-99,104-184,143c-10,5-20,9-29-11s1-25,11-29c78-36,131-80,167-129,37-49,57-104,70-162,2-11,5-21,26-16s19,15,16,26z'/%3E %3Cpath d='m223132,51802c-22,22-41,47-58,75-16,28-31,58-42,92-4,10-7,21-28,14s-18-18-14-28c12-36,27-69,46-100s40-58,64-83c8-8,15-15,31,0,15,15,8,23,0,31z'/%3E %3Cpath d='m223570,51845c-19,62-37,125-60,187-23,64-51,127-87,190-6,9-11,19-30,8s-14-21-8-30c35-61,61-122,84-182,22-61,40-123,59-185,3-11,6-21,27-15s18,16,15,27z'/%3E %3Cpath d='m223371,49282c136,200,166,406,171,613,15-75,32-151,53-226,0-1,3-7,3-7,57-80,93-160,111-239s18-159,4-238c-2-11-4-21,18-25,21-4,24,7,26,18,15,85,15,171-4,256-19,84-56,168-115,252-37,139-64,279-90,419l-5,26c-4,21-44,18-44-4,0-16,0-31,1-47,3-261,6-523-163-771-6-9-13-18,6-31,18-12,25-3,31,6z'/%3E %3Cpath d='m223038,49711c-2,17-3,34-5,50-1,17-3,34-4,51-1,11-2,22-24,20s-21-13-20-24c1-17,3-34,4-50,1-17,3-34,5-51,1-11,2-22,24-20s21,13,20,24z'/%3E %3Cpath d='m222945,50293c34,111,60,224,79,340,13,79,21,159,25,241,9-15,19-29,30-43,36-45,84-84,141-117,9-6,19-11,30,8s2,25-8,30c-53,31-96,66-128,107-32,40-53,85-62,136-4,22-44,18-44-4,1-120-9-237-27-351s-44-225-77-334c-3-11-7-21,14-27s24,4,27,14z'/%3E %3Cpath d='m223409,50501c19,90,31,176,35,259s1,164-8,243c-1,11-3,22-25,19s-20-14-19-25c9-75,12-153,8-235-4-81-15-166-34-252-2-11-5-21,17-26,21-5,24,6,26,17z'/%3E %3Cpath d='m223807,50427c15,82,23,162,19,239-4,78-19,152-51,224-27,82-29,164-15,246,14,84,46,168,84,253,5,10,9,20-11,29s-25-1-29-11c-40-87-73-175-88-263-15-90-13-179,17-269,0,0,1-2,1-2,29-66,44-136,47-209,4-74-4-151-19-229-2-11-4-21,18-25s24,7,26,18z'/%3E %3Cpath d='m223999,49767c-10,41-20,83-31,125-10,41-20,83-31,125-2,11-5,21-26,16s-19-16-16-27c10-41,20-83,31-125,10-41,20-83,31-125,3-11,5-21,27-16,21,5,19,16,16,27z'/%3E %3Cpath d='m223802,48671c12,38,23,76,35,114,3,11,6,21-15,27-21,7-24-4-27-14-12-38-23-76-35-114-4-11-7-21,14-27s24,4,27,14z'/%3E %3Cpath d='m223903,47838c1,52,1,104-3,327-47,42-81,95-99,161-18,67-20,149-3,247,2,11,4,22-18,26s-24-7-26-18c-19-105-16-193,4-266,20-75,59-135,112-182l-9-139c-1-52-1-104-2-155,0-11,0-22,22-22s22,11,22,22z'/%3E %3Cpath d='m223076,47548c128,84,238,177,314,287,77,111,121,238,116,388-1,15-17,25-31,19-72-31-145-62-217-93,48,311,36,559-32,749-72,201-205,338-395,416-17,7-35-9-29-27,37-118,59-236,68-354s4-236-16-353c-2-11-4-22,18-25,22-4,24,7,25,18,20,121,26,243,16,364-8,106-26,211-56,318,155-76,265-198,327-371,68-191,78-445,24-767-3-17,15-31,30-24,74,32,149,64,223,96-2-126-42-234-108-329-73-105-178-194-302-275-9-6-18-12-6-31,12-18,21-12,30-6z'/%3E %3Cpath d='m225241,47122c-6,14-12,29-18,43s-11,29-17,43c-4,10-8,20-28,12s-16-18-12-28c6-14,12-29,18-43s11-29,17-43c4-10,8-20,28-12s16,18,12,28z'/%3E %3Cpath d='m224732,47111c42,17,76,40,104,68,28,27,49,59,67,94,5,10,10,20-9,29-20,10-25,0-29-9-16-31-35-59-59-83s-53-44-90-58c-10-4-20-8-12-28s18-16,28-12z'/%3E %3Cpath d='m223976,47328c55,61,91,132,110,213,19,79,22,167,12,261-1,11-2,22-24,20s-21-13-19-24c9-90,7-173-11-247-18-73-50-138-100-193-7-8-15-16,2-31,16-15,24-6,31,2z'/%3E %3Cpath d='m221421,47574c-3,29-6,58-9,86-3,29-6,58-8,86-1,11-2,22-24,20s-21-13-19-24c3-29,6-58,8-86,3-29,6-58,9-86,1-11,2-22,24-20s21,13,20,24z'/%3E %3Cpath d='m221895,47324c12,41,24,82,37,123l11,37c3,11,6,21-15,27s-24-4-27-15l-11-37c-12-41-24-82-37-123-3-10-6-21,15-27s24,4,27,15z'/%3E %3Cpath d='m222867,47977c5,18,8,36,9,53,1,18,1,35,0,53-1,11-2,22-24,20s-21-13-20-24c1-15,1-31,0-46-1-16-4-31-8-46-3-11-6-21,15-27s24,5,27,16z'/%3E %3Cpath d='m223202,47237c21,21,35,44,40,66,6,24,2,48-10,71-5,10-11,20-30,9-19-10-14-20-9-30,7-14,9-27,6-41s-13-30-28-46c-8-8-15-15,0-31,15-15,23-8,31,0z'/%3E %3Cpath d='m220882,47354c0,52,8,102,25,148,17,47,44,91,82,132,51,58,77,115,91,173,14,57,15,113,18,168,0,11,1,22-21,23s-22-10-23-21c-2-54-4-108-16-160-13-52-36-103-81-155-42-45-71-94-91-146-19-52-28-107-28-164,0-11,0-22,22-22s22,11,22,22z'/%3E %3Cpath d='m221821,47986c52,97,81,192,92,288,12,95,6,192-11,293-19,117,6,231,70,338,59,100,152,195,272,283-37-129-59-256-54-379,6-144,50-283,151-414,43-56,72-114,92-173,21-59,32-119,40-177,1-11,3-22,24-19,22,2,20,13,19,24-8,62-20,124-41,186s-53,125-99,185c-95,124-136,254-142,389-6,137,24,279,70,425,6,19-17,35-33,25-151-102-266-214-337-333-69-117-97-240-75-367,16-97,21-190,10-281s-38-180-87-272c-5-9-11-19,9-29,19-11,25-1,30,9z'/%3E %3Cpath d='m221444,48563c0,104-29,208-81,312-41,82-95,163-159,244,33-13,67-26,100-42,58-27,116-59,174-103,40-30,81-65,121-107,41-42,82-91,124-149,6-9,13-18,31-5s11,22,5,31c-43,59-86,110-128,154-38,39-76,73-114,102,6,27,10,47,14,68,5,25,10,50,15,76,2,11,5,21-17,26-21,5-24-6-26-17-7-31-11-54-16-77-3-16-6-32-10-48-52,37-105,65-156,89-60,28-119,49-178,71-19,7-37-19-24-35,84-100,155-199,204-298,49-98,77-195,77-292,0-11,0-22,22-22s22,11,22,22z'/%3E %3Cpath d='m220985,48526v99c0,11,0,22-22,22s-22-11-22-22v-99c0-11,0-22,22-22s22,11,22,22z'/%3E %3Cpath d='m220697,47964c60,147,76,284,53,412-22,128-83,247-174,359,0,0-3,3-3,3-87,75-152,165-200,266-33,68-58,141-77,218,24-33,48-64,77-93,57-58,125-103,215-128,92-51,179-107,260-170,82-64,158-134,228-213,7-8,15-16,31-2s9,22,2,31c-72,81-150,153-234,218s-173,123-268,175c0,0-5,2-5,2-82,22-145,64-198,117s-95,119-136,187c-11,18-44,6-40-15,22-124,55-241,105-347s118-200,210-279c86-106,143-218,164-338s6-249-51-388c-4-10-8-20,12-29,20-8,25,2,29,12z'/%3E %3Cpath d='m221630,49460c-14,40,15,77,74,153,13,17,27,35,40,52,79,105,108,224,110,349,2,122-21,249-45,372-4,21-40,20-43-1-20-136-78-256-163-363-86-108-201-204-333-292-9-6-18-12-6-31,12-18,21-12,30-6,136,91,254,190,343,302,68,85,119,177,149,278,15-87,26-174,25-258-2-116-29-226-101-323-15-21-28-37-39-51-69-89-102-132-81-194,4-10,7-21,28-14s17,18,14,28z'/%3E %3Cpath d='m222028,49434c16,17,33,34,49,52,16,17,33,34,49,52,8,8,15,16-1,31s-24,7-31-1c-16-17-33-34-49-52-16-17-33-34-49-52-7-8-15-16,1-31s24-7,31,1z'/%3E %3Cpath d='m222516,49591c-31,98-61,195-91,293-31,98-61,195-92,293-3,11-6,21-27,14-21-6-18-17-14-27,31-98,61-195,91-293,31-98,61-195,92-293,3-11,6-21,27-15,21,7,18,17,14,28z'/%3E %3Cpath d='m222792,51228c-9,25-9,49,0,73,4,10,8,21-13,28-20,8-24-2-28-13-13-35-13-70,0-105,4-11,8-21,28-13,21,8,17,18,13,28z'/%3E %3Cpath d='m222502,50747c-13,51-27,103-40,154-13,52-26,103-40,155-3,11-6,21-27,16-21-6-19-16-16-27,13-52,27-103,40-155,13-51,27-103,40-154,3-11,5-21,27-16,21,5,19,16,16,27z'/%3E %3Cpath d='m222084,50745,38,38c8,8,15,15,0,31-16,15-24,8-31,0l-38-38c-8-8-15-15,0-31,16-15,24-8,31,0z'/%3E %3Cpath d='m221593,50510c-10,29-20,58-31,87-10,29-20,58-31,87-4,10-7,21-28,13-20-7-17-18-13-28,10-29,20-58,31-87,10-29,20-58,31-87,4-11,7-21,28-14s17,18,14,28z'/%3E %3Cpath d='m220890,51253c-27,29-45,61-58,94-13,34-20,69-26,106-2,11-4,22-25,18-22-4-20-14-18-25,7-39,15-77,29-114,14-38,35-74,66-108,7-8,15-16,31-1s9,23,1,31z'/%3E %3Cpath d='m218878,53224c-10,22-24,45-43,67-18,22-40,43-67,65-8,7-17,14-31-4-14-17-5-24,3-31,25-19,45-39,61-59,16-19,28-38,36-56,5-10,9-20,29-12,20,9,15,19,11,29z'/%3E %3Cpath d='m219193,53057c-9,22-24,41-43,57-18,15-41,28-68,39-11,4-21,8-28-13-8-21,3-25,13-28,22-8,41-19,55-31s24-26,31-41c4-10,9-20,29-11s15,19,11,29z'/%3E %3Cpath d='m219611,52802c-7,12-15,24-26,36s-26,24-45,36c-9,6-19,12-30-7s-2-25,8-30c16-9,27-19,36-28,8-9,15-19,21-28s11-19,30-7c19,11,13,20,8,30z'/%3E %3Cpath d='m220240,51166c-20,59-34,117-39,175s-2,116,10,173c2,11,5,21-16,26s-24-6-26-17c-14-62-17-125-11-187s20-124,41-185c4-11,7-21,28-14s17,18,14,28z'/%3E %3Cpath d='m220668,46813c-2,49-15,97-38,145s-56,95-99,142c-7,8-15,16-31,1s-9-23-1-31c40-44,71-88,92-131,20-43,32-86,33-128,0-11,1-22,23-21s21,12,21,23z'/%3E %3Cpath d='m220231,46427c38,66,61,133,74,200,13,66,16,133,12,199,0,11-1,22-23,21s-21-12-21-23c4-63,1-125-11-188-12-62-34-125-69-187-5-9-11-19,8-30s25-1,30,8z'/%3E %3Cpath d='m219652,47145c-79-58-135-117-171-176-36-61-49-122-40-184,2-11,4-21,25-18,22,4,20,14,18,25-8,52,4,103,34,155,32,54,85,108,159,163,9,6,18,13,5,31s-22,11-31,5z'/%3E %3Cpath d='m220293,48234v48,47c0,11,0,22-22,22s-22-11-22-22v-47-48c0-11,0-22,22-22s22,11,22,22z'/%3E %3Cpath d='m219474,47409c129,122,206,269,247,432,26,101,37,208,39,320,1,0,3-1,5-1,58-20,103-72,134-155,33-88,50-210,53-365,0-1,2-10,3-11,46-75,74-151,93-226s28-152,35-229c2-19,28-27,40-11,75,106,141,216,192,334s85,243,98,379c1,11,2,22-20,24s-23-9-24-20c-12-130-46-251-94-365-41-97-93-188-153-277-6,58-15,117-30,176-19,78-48,155-95,233-3,158-21,283-55,374-36,97-90,157-161,181-7,2-13,4-19,1-1,54-4,109-8,165-1,11-2,22-24,20s-21-13-20-24c15-182,11-355-29-511-39-155-113-295-235-411-8-7-16-15-1-31s23-8,31-1z'/%3E %3Cpath d='m219954,49462c-9,58-18,115-27,173-9,57-18,115-27,172-1,11-3,22-25,18-21-3-20-14-18-25,9-58,18-115,27-172,9-58,18-115,27-173,2-11,3-21,25-18,21,4,20,14,18,25z'/%3E %3Cpath d='m219032,49853c8,44,16,87,24,131,2,11,4,21-18,25-21,4-24-7-26-18-8-44-16-87-24-131-2-11-4-21,18-25,21-4,24,7,25,18z'/%3E %3Cpath d='m219829,48795c-11,87-33,171-67,252-35,81-83,160-146,235l-1,1c-79,86-117,175-129,268s1,190,27,289c3,11,5,21-16,27-21,5-24-5-27-16-27-103-41-205-28-305,13-101,55-199,140-292,60-71,106-146,139-223,33-78,54-158,64-241,1-11,3-22,24-19,22,3,20,14,19,25z'/%3E %3Cpath d='m219621,48485c15,84,2,167-33,251-35,81-91,163-163,244,0,0-2,2-2,2-75,63-128,132-170,203-42,72-73,147-104,223-4,10-8,20-29,12-20-8-16-18-12-28,31-77,63-154,107-229s100-147,178-213c68-77,121-154,154-231,32-75,44-151,30-225-2-11-4-21,18-26,21-4,24,7,26,18z'/%3E %3Cpath d='m218604,48968c24,168-2,312-65,438-62,126-161,234-282,331-8,7-17,14-31-4-14-17-5-24,4-31,116-93,211-197,270-316s84-254,61-413c-1-11-3-22,19-25s23,8,25,19z'/%3E %3Cpath d='m217305,49687c13,26,25,52,37,78,14,28,27,55,40,83,5,10,9,20-10,29-20,9-25,0-29-10-13-28-27-55-40-83-12-26-25-52-37-77-5-10-9-20,10-29,20-9,25,0,29,10z'/%3E %3Cpath d='m216790,49697c-1,99,7,197,31,291,25,94,65,185,131,272,0,0,2,4,2,4,33,67,52,134,65,202,9,50,15,100,18,150,63-67,111-135,146-206,40-82,61-167,63-255,0-11,0-22,22-21,22,0,22,11,21,22-2,94-25,185-67,273-43,88-106,172-189,253-13,13-36,4-37-15-3-65-8-130-20-193s-30-126-60-189c-68-91-111-187-137-286s-34-200-33-303c0-11,0-22,22-22s22,11,22,22z'/%3E %3Cpath d='m216860,51456c4-54,12-107,25-162,13-54,29-107,51-161,4-10,8-20,28-12,21,8,16,18,13,28-21,52-37,104-49,155s-20,103-24,154c-1,11-1,22-24,20-22-1-21-12-20-23z'/%3E %3Cpath d='m216800,51946c9-65,18-130,27-195,1-11,3-22,25-19s20,14,19,25c-9,65-18,130-27,195-1,11-3,22-25,19s-20-14-19-25z'/%3E %3Cpath d='m216463,52767c32-32,63-70,92-112,30-43,58-90,86-139,5-10,11-19,30-9,19,11,14,20,8,30-28,51-58,99-88,143-31,44-63,84-98,118-8,8-16,15-31,0s-7-23,0-31z'/%3E %3Cpath d='m215976,50012v81c0,11,0,22-22,22s-22-11-22-22v-81c0-11,0-22,22-22s22,11,22,22z'/%3E %3Cpath d='m215152,51910c-1-20-2-40-4-60l-4-61c0-11-1-22,21-23s23,9,23,21l4,60c1,20,2,40,4,60,0,11,1,22-21,23s-23-9-23-21z'/%3E %3Cpath d='m217221,48534c-42,145-75,296-72,425,2,125,37,229,127,287,105,68,151,170,195,269,3,6,5,12,8,18,13-49,24-101,29-153,7-64,7-126-2-182-2-11-4-22,18-26,21-4,24,7,25,18,10,60,10,127,3,194-8,75-25,151-47,217-6,18-32,20-40,3-11-23-22-47-33-72-41-93-84-189-179-250-104-67-145-184-148-323-2-134,31-289,74-438,3-11,6-21,27-15s18,16,15,27z'/%3E %3Cpath d='m217076,47981c14,113,10,217-9,322-19,104-53,208-98,321-53,135-77,278-70,422,7,143,44,285,110,420,5,10,10,20-10,29-20,10-25,0-29-10-70-140-108-289-115-437-7-150,18-299,73-440,44-110,77-212,95-313,19-100,23-200,9-308-1-11-3-22,19-25,21-3,23,8,25,19z'/%3E %3Cpath d='m216115,49349c-30,66-36,132-25,198,12,67,41,135,82,203,6,9,11,19-7,30-19,11-25,2-30-8-43-72-75-145-87-218-13-74-6-149,28-223,5-10,9-20,29-11s15,19,11,29z'/%3E %3Cpath d='m215696,49199c7,39,9,85,5,131-4,40-14,79-30,114v1c-19,37-23,74-16,111,8,39,28,78,55,118,6,9,12,18-6,31s-24,4-31-6c-31-44-53-89-62-134-9-47-5-93,20-140,14-30,22-64,26-99,4-41,2-83-4-119-2-11-4-22,18-25,22-4,24,7,25,18z'/%3E %3Cpath d='m218146,45570c-13,115-7,223,16,326,23,102,62,200,116,293,6,9,11,19-8,30s-24,1-30-8c-55-96-97-198-121-305s-31-220-16-340c1-11,2-22,24-19,22,2,21,13,19,24z'/%3E %3Cpath d='m217839,45867c57,101,106,210,143,329s62,250,71,395c1,11,1,22-21,23s-22-10-23-21c-8-141-33-268-69-384s-84-221-139-320c-5-10-11-19,8-30s25-1,30,8z'/%3E %3Cpath d='m216317,45914c-147,209-211,379-223,526-12,146,27,268,85,381,0,0,1,3,1,3,40,116,58,231,55,347-2,115-26,231-67,346-4,11-7,21-28,13-21-7-17-18-13-28,40-111,62-221,65-332,2-110-14-220-52-330-61-119-102-249-89-403s79-332,231-548c6-9,13-18,31-6,18,13,12,22,5,31z'/%3E %3Cpath d='m217736,45312c13,63,7,129-22,193-26,59-71,115-138,168-68,53-108,122-126,205-19,85-15,184,6,295,2,11,4,22-18,26-21,4-24-7-26-18-21-117-25-221-5-312,20-92,65-170,142-230,61-48,101-99,125-151,25-55,30-112,19-166-2-11-5-21,17-26,21-4,24,7,26,17z'/%3E %3Cpath d='m216233,45441c29,93,30,184,3,275-26,90-80,179-162,266,0,0-2,2-2,2-79,66-127,150-157,243-31,95-42,201-48,311-1,11-1,22-23,21s-21-12-21-23c6-113,18-222,50-322s84-190,169-262c77-82,127-165,152-248,24-82,23-166-3-250-3-11-7-21,14-27s24,4,27,15z'/%3E %3Cpath d='m217093,45486c-5,34-5,66,0,98,5,31,17,61,37,90,6,9,12,18-6,31-18,12-24,4-31-6-24-35-38-71-44-107-6-37-6-74,0-111,1-11,3-22,25-19s20,14,19,25z'/%3E %3Cpath d='m217052,45260c-79,33-139,89-182,169-42,79-67,181-75,306,5,6,8,11,8,15,42,57,71,125,89,201,20,83,27,177,24,279,0,11-1,22-23,21s-21-12-21-22c3-99-4-189-23-268-16-67-41-127-76-177-163,152-243,320-248,503-6,191,69,399,213,621,6,9,12,19-6,31s-24,2-30-7c-149-230-226-446-220-646,6-197,92-377,269-539v-1c7-137,34-249,81-337,48-89,115-152,204-189,10-4,20-8,29,12,8,20-2,25-12,29z'/%3E %3Cpath d='m216808,44944c-2,18-4,32-5,47-11,104-22,221-101,292-44,39-72,85-92,134-20,51-30,106-37,164-1,11-2,22-24,19-22-2-20-13-19-25,7-61,19-120,40-175,22-56,54-107,103-151,66-59,78-168,87-263,2-18,4-35,5-48,1-11,3-22,25-19s20,14,19,25z'/%3E %3Cpath d='m219197,47493c26,54,47,110,61,167s21,116,18,177c0,11-1,22-23,21s-21-12-21-23c3-57-4-111-16-165-13-53-34-106-59-158-5-10-9-20,11-29s24,0,29,10z'/%3E %3Cpath d='m219204,48277c19,90,20,182,4,274s-50,186-100,281c-34,79-67,158-101,237-5,10-9,20-29,12s-16-19-12-29c34-79,67-159,101-238,0,0,1-2,1-2,49-91,81-180,97-268,15-87,14-174-4-258-2-11-4-22,17-26,21-5,24,6,26,17z'/%3E %3Cpath d='m218706,47547c143,159,236,327,280,504,45,177,40,363-14,557-3,11-6,21-27,15s-18-16-15-27c52-187,57-365,14-535s-133-332-271-486c-7-8-14-16,2-31s24-6,31,2z'/%3E %3Cpath d='m218662,48427c-44,93-93,186-153,279s-130,186-213,279c-48,53-92,112-130,177-38,66-71,138-97,219-6,20-44,13-42-8,4-66-4-132-22-198s-48-133-88-199v1c-80-118-114-237-108-355,7-118,54-235,138-352,48-82,82-165,106-247s36-165,39-248c0-11,1-22,23-21s21,12,21,23c-4,86-16,172-41,258s-61,172-111,258c0,0-1,2-1,2-79,111-124,221-130,330-6,110,27,219,101,329l1,1c42,70,73,140,93,211,9,33,16,66,20,99,19-43,39-84,62-122,40-68,86-130,136-185,82-91,151-183,209-274,59-92,108-183,150-274,5-10,9-20,29-11s15,19,11,29z'/%3E %3Cpath d='m217357,48007c-3,109,7,211,29,307,22,95,58,184,108,266,6,9,11,19-7,30-19,12-24,2-30-7-52-86-90-179-113-278-23-100-33-206-30-318,0-11,1-22,22-21,22,1,22,12,21,22z'/%3E %3Cpath d='m216614,48405v64,64c0,11,0,22-22,22s-22-11-22-22v-64-64c0-11,0-22,22-22s22,11,22,22z'/%3E %3Cpath d='m216860,47726c2,75-8,148-31,218-24,70-61,137-115,200-7,8-14,17-31,2-17-14-9-22-2-31,50-59,85-121,106-186,22-65,31-133,29-203,0-11-1-22,21-22s22,11,22,21z'/%3E %3Cpath d='m216191,49044c-120-299-149-536-119-729,30-195,120-343,238-464,79-81,148-161,193-261s66-220,50-382c-1-11-2-22,20-24s22,9,24,20c16,170-6,297-54,404-47,106-119,190-201,274-112,114-197,256-226,440-29,186,0,416,117,707,4,10,8,20-12,28s-25-2-29-12z'/%3E %3Cpath d='m215805,48553c-18,48-25,97-19,145,5,48,23,97,53,146,6,9,12,19-7,30-19,12-24,2-30-7-33-54-53-109-59-164s1-110,22-165c4-10,8-20,28-13,21,8,16,18,13,28z'/%3E %3Cpath d='m217703,47205c79,111,125,226,134,346s-18,244-86,373c-5,9-10,19-29,9-20-10-14-20-9-29,64-121,90-237,81-349-8-112-52-220-126-324-7-9-13-18,5-31s24-4,31,5z'/%3E %3Cpath d='m218296,46741c48,115,73,232,78,350,5,117-12,236-48,355-6,20-42,16-43-6-4-110-27-209-68-296s-102-162-181-226c-8-7-17-14-3-31s22-10,31-3c85,68,149,148,193,241,27,57,47,119,59,185,13-73,19-146,16-219-4-112-28-224-74-334-4-10-8-20,12-29,20-8,25,2,29,12z'/%3E %3Cpath d='m218648,46260c78,77,133,179,167,305,33,124,45,270,39,437v1c-8,71-11,140-3,204,7,63,25,121,58,173,6,9,12,19-6,31-19,12-25,2-31-7-37-58-57-123-65-192-8-68-5-140,3-214v1c6-163-6-305-37-424-32-118-83-213-155-285-8-8-16-15,0-31,15-16,23-8,31,0z'/%3E %3Cpath d='m217714,46167c-51,62-82,135-97,216-15,82-13,172,2,270,2,11,4,21-18,25-21,4-23-7-25-18-16-102-18-198-2-285,16-88,51-167,106-236,7-8,14-17,31-3s10,22,3,31z'/%3E %3Cpath d='m215883,47400c-8,182-61,330-146,452-85,121-201,217-338,297-9,6-19,11-30-8s-2-24,8-30c131-77,243-169,324-285,81-115,131-255,139-428,0-11,1-22,23-21s21,12,21,23z'/%3E %3Cpath d='m215836,46770c10,68,6,134-9,200-15,65-41,130-74,197-5,10-10,19-29,10-20-10-15-20-10-29,32-64,57-126,71-187s18-121,9-184c-1-11-3-22,19-25s24,8,25,19z'/%3E %3Cpath d='m217076,46679v62c7,107,14,215,21,322l2,29c1,11,1,22-20,24h-7c-3,4-8,6-18,6-22,0-22-11-22-22v-356c-2-29-4-58-6-87-1-11-2-22,20-24,22-1,23,9,24,20v7c5,4,5,11,5,18z'/%3E %3Cpath d='m217375,46126c-88,107-123,210-125,311s29,202,75,302c104,167,138,333,127,500-10,166-65,331-138,496-5,10-9,20-29,11s-15-19-11-29c72-160,124-321,134-481,10-159-22-317-121-476,0,0-1-2-1-2-49-106-82-213-80-323,2-111,41-223,135-338,7-8,14-17,31-3s10,22,3,31z'/%3E %3Cpath d='m215452,42697c145-111,287-174,436-190,148-15,301,17,467,95,55-1,110-1,165-2,56-1,113-2,169-2,11,0,22,0,22,22s-11,22-22,22c-57,1-113,2-169,2-51,1-101,1-152,2-1,1-2,2-3,3-178,157-330,243-465,271-139,29-259-2-368-80-11-8-22-16-7-38s27-15,38-7c98,68,204,96,326,71,118-25,252-98,409-231-144-63-276-88-403-75-138,14-272,74-409,179-11,8-22,16-38-5-16-22-6-30,5-38z'/%3E %3Cpath d='m215882,42613c61,0,110,49,110,110,0,60-49,110-110,110-60,0-110-49-110-110s49-110,110-110z'/%3E %3Cpath d='m216639,43278c79-41,140-85,191-130,50-45,90-91,124-137,6-9,13-18,31-5s11,22,5,31c-36,49-78,98-130,145-53,47-117,92-200,135-10,5-20,10-29-9-10-19-1-25,9-29z'/%3E %3Cpath d='m218200,42632c41-11,81-11,122,1,40,11,79,33,118,65,8,7,17,14,3,31s-22,10-31,3c-34-28-69-47-102-56s-66-9-99-1c-11,3-21,6-27-16-6-21,5-24,15-27z'/%3E %3Cpath d='m217307,42668c35-80,88-141,161-180,72-38,163-54,274-44,11,1,22,2,20,24s-13,21-24,20c-103-9-186,5-250,39-64,33-110,87-141,159-4,10-9,20-29,11s-16-19-11-29z'/%3E %3Cpath d='m217409,42814c6-39,22-74,49-101,26-28,63-48,113-62,11-3,21-6,27,15s-5,24-15,27c-41,11-72,28-92,50-20,21-32,48-37,78-2,11-4,21-25,18s-20-14-18-25z'/%3E %3Cpath d='m215923,43308c-24,38-46,77-62,119-15,42-23,87-20,140,1,11,2,22-20,23s-23-9-24-20c-4-59,6-111,22-158,16-46,40-88,66-128,6-9,12-19,30-7,19,12,13,21,7,30z'/%3E %3Cpath d='m216349,43499v66c0,11,0,22-22,22s-22-11-22-22v-66c0-11,0-22,22-22s22,11,22,22z'/%3E %3Cpath d='m216072,43023c44,16,87,24,131,25,44,0,89-6,133-16,11-2,21-5,26,16s-6,24-16,27c-48,11-96,18-144,17-49-1-97-9-146-28-11-4-21-8-13-28,8-21,18-16,28-13z'/%3E %3Cpath d='m216346,42224c-37-1-66,10-88,27-29,22-47,53-55,80-3,11-6,21-27,15s-18-17-15-27c11-35,34-74,71-102,29-22,68-37,115-36,11,0,22,1,22,22,0,22-11,22-22,22z'/%3E %3Cpath d='m215903,42269c-33,14-59,30-79,46-18,15-30,32-35,48-4,11-7,21-28,14s-17-17-14-28c8-25,25-47,49-68,23-19,53-37,91-53,10-4,20-8,28,12,9,20-1,25-12,29z'/%3E %3Cpath d='m215630,42277c-27,19-50,39-69,62s-34,49-45,77c-4,10-7,21-28,13-20-7-17-18-13-28,12-33,30-63,52-90s48-50,78-71c9-6,18-12,31,6s4,24-6,31z'/%3E %3Cpath d='m215279,42558c-29,22-57,46-84,74s-52,58-76,91c-6,9-13,18-31,5s-11-22-5-31c25-35,52-67,80-96s58-55,89-78c9-7,18-13,31,4,13,18,4,24-5,31z'/%3E %3Cpath d='m215314,42945c-21,23-42,46-63,68l-64,68c-7,8-15,16-31,1s-9-23-1-31l63-68c21-22,42-45,64-68,7-8,15-16,31-1s9,23,1,31z'/%3E %3Cpath d='m214959,43048v136c0,11,0,22-22,22s-22-11-22-22v-136c0-11,0-22,22-22s22,11,22,22z'/%3E %3Cpath d='m215414,43646c-7,74-14,148-21,223-1,7-1,14-2,21-1,11-2,22-24,20s-21-13-20-24c1-7,1-14,2-21,7-74,14-149,21-223,1-11,2-22,24-20s21,13,20,24z'/%3E %3Cpath d='m215147,43448c-1,48-3,97-5,145,0,11-1,22-23,21s-21-12-21-22c1-49,3-97,5-146,0-11,1-22,23-21s21,12,21,23z'/%3E %3Cpath d='m214899,41554c46,17,87,41,120,73,34,33,60,74,77,124,4,11,7,21-14,28s-24-4-28-14c-15-44-38-79-66-107-29-28-64-49-105-64-10-4-20-8-13-28,8-21,18-17,28-13z'/%3E %3Cpath d='m217077,44394c42,95,65,190,66,284,2,95-17,190-57,285-4,10-8,20-28,12s-16-19-12-29c37-89,55-178,53-267-1-89-22-178-62-267-5-10-9-20,11-29s25,1,29,11z'/%3E %3Cpath d='m216367,45215c31-107,76-200,128-285s111-162,170-238c68-88,113-184,137-282,26-106,27-216,8-320-2-11-4-21,18-25,21-4,24,7,25,18,20,110,19,225-8,338-25,104-72,206-145,299-58,75-116,151-167,234-50,82-94,172-123,274-3,11-6,21-27,15s-18-16-15-27z'/%3E %3Cpath d='m215454,44974c15-40,37-75,67-106s67-57,111-78c10-5,20-9,29,10,9,20,0,25-11,29-40,19-73,42-99,69-26,26-45,57-57,91-4,10-8,21-28,13-20-7-17-18-13-28z'/%3E %3Cpath d='m215277,44910c34-44,68-85,107-121,40-37,85-68,137-89,10-4,20-8,28,12,8,21-2,25-13,28-47,19-87,47-123,80-37,34-70,75-102,116-7,9-13,18-31,4-18-13-11-22-4-31z'/%3E %3Cpath d='m216223,43972c38,17,74,25,109,26s69-4,102-13c11-3,21-6,27,15s-5,24-15,27c-37,11-75,16-115,15s-81-11-125-30c-10-5-20-9-11-29s19-15,29-11z'/%3E %3Cpath d='m215752,43911c11-13,22-25,33-38l4-5c7-8,15-16,31-2,16,15,9,23,2,31l-4,5c-11,13-22,25-34,38-7,8-14,16-31,2-16-14-9-23-2-31z'/%3E %3Cpath d='m225936,46849c21,23,39,47,55,73,15,26,27,53,37,82,4,11,7,21-14,27-21,7-24-4-28-14-8-26-19-50-33-73-13-23-30-45-49-65-7-8-15-16,1-31s24-7,31,1z'/%3E %3Cpath d='m214630,52155c48,44,98,84,153,112,54,27,114,44,182,44,11,0,22,0,22,22s-11,22-22,22c-75,0-141-19-202-49-59-30-113-72-163-118-8-7-16-15-1-31s23-9,31-1z'/%3E %3C/g%3E %3Cg fill='%23f00'%3E %3Cpath d='m223164,42025c251,11,493,1,699-33-220,159-501,266-804,316,59-46,97-94,114-143,16-47,13-94-9-140z'/%3E %3Cpath d='m222565,41963c163,27,332,46,499,57,2,4,5,7,7,11,27,37,35,73,23,108-14,40-52,82-114,125-17,12-34,24-10,57-111,14-224,20-339,18-58-1-115-4-173-9,6-3,12-9,17-14,61-64,100-130,111-199,8-51,2-102-21-153z'/%3E %3Cpath d='m218139,40691c282-37,569-46,861-39,96,39,167,96,211,171,48,84,65,194,45,331-3,20-6,41,35,46,41,6,44-15,46-35,22-156,2-283-55-383-28-48-64-89-108-124,26,1,52,2,78,4,336,18,597,114,889,259,2,2,5,5,7,8,62,65,83,132,73,201-11,73-55,152-125,233-13,16-27,31,5,58,31,27,45,11,58-5,79-93,131-185,144-275,7-51,3-99-15-147,246,122,496,239,739,367,5,3,10,5,15,8,0,5,2,11,4,16,20,69,12,128-22,179-37,53-104,99-201,135-19,7-38,14-24,53,14,38,34,31,53,24,114-43,194-98,240-166,39-57,54-120,45-191,161,87,322,177,487,256l1,1c29,58,34,110,11,158-24,51-80,99-169,143-18,9-37,18-19,55s37,28,55,19c107-53,175-114,207-182,22-47,28-95,18-146,57,25,115,49,174,71,159,59,351,110,557,148,1,2,3,4,5,6,38,53,51,104,42,153-9,51-40,103-90,155-14,15-28,29,1,58,5,5,9,8,13,11-625-64-1181-363-1763-588-69-27-139-53-208-80-215-81-432-191-648-279-7-7-18-11-28-14-15-5-29-10-44-14-9-4-19-7-28-11,1,1,3,2,4,3-197-63-396-112-598-140-224-31-452-37-686-7-13-2-25-4-38-6,20-123,4-231-57-325-43-67-108-126-198-175z'/%3E %3Cpath d='m217116,40966c287-125,578-205,875-254,136,54,226,120,277,198,49,77,61,167,44,271-126-12-251-11-373,2-137,15-271,46-403,93-66-139-155-223-259-269-51-23-105-36-161-42z'/%3E %3Cpath d='m220263,42558c-77-49-155-97-236-141-389-214-835-346-1282-363,4-3,7-7,11-10,159-162,194-315,140-458-42-111-139-214-273-307,150-8,289,1,445,23,220,31,505,105,765,210,64,140,82,263,54,367-29,109-111,200-243,275-18,10-36,20-16,56s38,26,56,15c153-86,247-194,282-326,27-102,19-216-26-343,176,79,335,173,446,276,145,100,288,201,428,307,1,178-51,279-137,332-91,55-221,62-369,47-20-2-41-4-45,37v2z'/%3E %3Cpath d='m221119,43202c-260-203-514-415-787-598,151,12,286,0,388-61,99-61,164-167,175-340,163,126,320,259,469,402,75,71,150,141,227,210,0,1,1,2,1,4,18,64,24,119,19,165-5,45-21,82-47,111-27,30-66,52-115,65-73,21-168,25-285,12-19-2-39-4-44,31z'/%3E %3Cpath d='m222016,43793c-90-46-176-94-259-143-199-118-386-253-569-394,112,9,206,3,282-18,65-18,117-48,154-89,38-42,61-94,68-158,3-28,3-58-1-90,179,153,367,295,570,419,106,65,213,126,319,183-1,7,0,14,1,22,13,82-33,134-117,167-98,39-244,55-411,65-19,1-37,2-39,34z'/%3E %3Cpath d='m222974,44169c-304-83-598-199-867-330,154-11,290-29,388-68,111-44,175-112,171-221,178,90,356,168,537,232,32,71,34,129,4,178-36,60-115,110-213,153-19,8-38,17-21,54v1z'/%3E %3Cpath d='m224970,43966c26-4,186-46,103,15-588,385-1334,384-2037,203,109-49,198-108,243-182,34-55,40-118,24-187,224,73,451,125,685,155,1,36-9,72-37,107-37,46-100,91-203,136-19,8-38,16-21,54,16,38,35,29,54,21,116-51,191-105,235-160,39-49,55-98,55-149,289,31,588,27,900-14z'/%3E %3Cpath d='m220904,54095c-44,46-81,97-117,157-171,57-322,142-506,134,0,119,39,171,158,172,227-114,278-135,298-119,28,24-32,187-220,319-29,18-28,29-11,59,159,249,576,160,800,101,160-42,449-232,529-392,31-73-39-169-109-247-177,27-238-55-210-112-187-66-395-80-612-72z'/%3E %3Cpath d='m214511,52080c-130,106-275,190-444,246-64,21-219,59-234,140-2,29,104,92,172,55,188-180,282-80,66,104-17,35-3,74,34,107,195,175,678,232,898,93,163-102,248-214,106-369,1-35,5-69,11-104l-269-27-165-96-175-149z'/%3E %3Cpath d='m218719,53544c-16,2-33,4-49,7-87,94,152,59,279,137,58,35,83,104,60,200-117,279-770,189-987,74-101-53-105-114-101-201,45,0,91-3,137-10,78-11,155-34,231-77,21-12,43-25,19-67-24-43-46-31-67-19-64,36-130,56-196,65-68,10-138,10-205,7h-17c-38-22-67-48-51-71,16-22,79,2,91,6,101-47,189-77,298-98,15-15,29-31,44-46,199,17,389,47,515,93z'/%3E %3Cpath d='m215700,53373c-40,24-54,58-83,121-114,115-223,184-369,250-121,55-4,108,81,166,77,57,178-67,241-161,69-104,139-73,94,8-50,89-86,217-91,284-26,72,248,127,295,129,167,8,377-155,508-238,109-111,92-208,44-343l1-9c-70,2-136-6-201-20-79-18-157-45-236-78-10-4-20-8-12-29,5-13,11-16,18-15l-288-66z'/%3E %3Cpath d='m216869,42243c46-2,92-4,137,1,85,10,166,47,251,57,284-107,519-166,722-157,237-69,483-98,729-92-3-2-6-5-9-8-29-29-15-44,0-58,133-135,164-259,121-371-44-116-164-225-331-325-178,20-349-28-538-7-118,13-234,39-348,77,95,34,178,90,246,170,84,99,144,234,176,404,4,20,7,40-33,48s-44-13-48-33c-29-155-83-277-158-366-79-113-260-157-317-180-189,19-375,40-537,82-122,31-229,74-311,138,122-26,249-21,359,34,105,52,194,150,250,309,7,19,13,39-26,52s-46-6-52-26c-47-137-121-219-208-262-173-86-530-11-681,101-88,66-176,151-263,250-9,11-19,21-31,22,324,22,650,39,902,140zm-961-183c-7-18,5-31,16-44,91-103,183-194,278-264,92-68,187-117,285-140,100-111,248-178,420-222,167-43,358-65,551-84-57-115-130-184-214-221-90-40-194-46-305-35-233,80-440,205-639,346,18,0,36,0,53,1,59,4,112-5,161,14,20,7,39,14,25,53-17,47-146,18-191,15-51-3-107,1-169,16-10,2-19,5-28,2-209,129-367,260-536,403,128,45,228,98,293,160z'/%3E %3C/g%3E %3C/g%3E %3Cg%3E %3Cpath fill='%230093dd' d='m240096,66034,8752-19837-6456-10424-11513,4263-5329,20965c5022,1281,9882,2973,14545,5034z'/%3E %3Cpath fill='%23fff' d='m228935,47685c5767,1471,11350,3414,16705,5782l-3377,7657c-4934-2181-10076-3971-15390-5326z'/%3E %3Cpath fill='%23f00' d='m242806,59894,2256-5113c-5283-2336-10790-4252-16479-5704l-1330,5231c5396,1377,10620,3195,15631,5410l-78,176z'/%3E %3Cpath fill='%23000' d='m230207,53061c151-95,312-72,474-46,131-49,282-66,446-60,70-38,151-65,243-82,49-38,51-79,7-123-41-50-64-99-67-149-260-151-356-381-455-609-148-39-217-89-233-145-72-7-143-14-214-22-337,37-424-72-544-161-100-33-187-88-243-193-37-47-74-93-111-140-92-117-64-272,75-263,98,11,195,11,285-28,105-47,262-46,381-36,141-8,230-99,367-227-1-55-1-109-2-164-22-59,6-85,84-77,183,6,292,92,366,214,213,37,381,139,494,318,283,1,474,108,497,213,17,77-66,165-194,259,1,19,2,39,2,58,76,66,126,132,152,197,159,61,311,143,453,263,405-47,1088,247,2011,836,599,107,1180,273,1738,514,118,4,236,7,353,11,1001-148,1971-34,2871,654,340,41,645,148,940,270,219,90,442,125,667,146,364,35,733,125,1099,295,411,92,795,221,1033,509,169,204,128,392-87,470-130,274-389,286-777,151-267,49-561-165-828-366-371-119-712-333-1049-561-175-131-352-214-524-251-135-29-256-48-337,0-40,24-35,38,0,67,94,79,160,197,181,339,19,125-1,269,6,422,8,161,105,278,267,378,111,68,243,140,434,167,91,18,117,71,114,140,51,244,98,490,187,711,25,63,73,93,145,146,247,178,119,377-106,420-197,174-367,291-569,337-161,54-227-12-281-91-97-2-146-41-187-104-197-145-29-397,442-289,10-55,50-72,90-71-28-122-44-258,9-385-42-27-78-61-139-81-170-54-331-132-458-251-241-227-618-417-981-608-300-15-523-153-758-270-106-1-212-3-318-4-93-31-169,1-225,68-94,114-203,95-332,80-148-17-298-6-446-8-73,18-145,41-224,42-167-9-330-11-441,82-92,97-184,90-276,54-69-32-119-66-148-102-116-24-191-53-216-88-195-55-250-110-241-165-259-62-136-266,32-273,198-8,379,30,573,57,163,46,364,19,497-101,86-78,118-145,223-203-335-22-582-81-764-196-490-309-882-384-1194-122-83,47-148,66-237,32-75-29-171-29-246-12-177,40-352,18-529-46-259,65-517,79-776,26-219,115-379,128-481,40-96-54-187-109-273-168-139-21-199-56-205-102-178-20-200-85-199-156-74-85-46-150,28-205,132-55,269-75,421,3,91,43,158,85,213,128,101-12,188,0,264,28,56-88,215-92,389-82,87-58,191-99,324-111-4-21-8-42-11-62-175-46-265-173-352-301-269-5-462-118-654-236-158,13-285-39-408-113-100,8-211,12-316-15-208,57-405,53-591,0-131,12-236-1-344-11-123,141-261,166-412,94-83-105-201-174-350-213-113-37-148-86-168-139-138-85-110-169,23-233,100-48,225-57,415,37,62,23,131,39,209,45z'/%3E %3Cpath fill='%23fff' d='m236801,55071c-13-23-41-81-142-23-313-17-663-13-926-168-274-161-556-329-859-317,90-85,202-143,332-178,174-46,380-49,608-12,320,52,602,114,820,196,210,79,358,177,423,303,2,3,15,18,18,20,84,54,157,109,218,167,46,43,86,88,120,136-99,9-201,2-301-18-110-22-216-59-312-108z'/%3E %3Cpath fill='%23000' d='m237521,39962,18,94,394,2040-1567,1366-72,63,91,32,1964,679,399,2040,19,94,72-63,1570-1361,1967,674,91,31-18-94-394-2041,1567-1366,72-63-91-31-1964-680-399-2040-19-94-72,63-1571,1362-1966-675z'/%3E %3Cg fill='%23f7db17'%3E %3Cpath d='m236561,43439,1464-1276,1841,634z'/%3E %3Cpath d='m240110,42750,1469-1277,1835,635z'/%3E %3Cpath d='m243427,42173-1464,1276-1841-634z'/%3E %3Cpath d='m239878,42863-1469,1276-1835-634z'/%3E %3Cpath d='m237729,40150,1837,630,372,1911z'/%3E %3Cpath d='m240101,42878,1840,634,368,1907z'/%3E %3Cpath d='m242259,45462-1837-629-372-1911z'/%3E %3Cpath d='m239887,42734-1840-633-368-1907z'/%3E %3Cpath d='m241162,39516,373,1906-1469,1277z'/%3E %3Cpath d='m239985,42934,371,1911-1467,1273z'/%3E %3Cpath d='m238826,46096-373-1906,1469-1277z'/%3E %3Cpath d='m240003,42678-371-1911,1467-1272z'/%3E %3C/g%3E %3C/g%3E %3C/g%3E %3C/g%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 500 300'%3E %3Ctitle%3EFlag of Haiti%3C/title%3E %3Crect width='500' height='300' fill='%23d21034'/%3E %3Crect width='500' height='150' fill='%2300209f'/%3E %3Cg id='coa' fill='%23f1b517' stroke='%23000' stroke-width='0.1826'%3E %3Crect fill='%23fff' stroke='none' width='94.6416' height='75.3413' x='202.679' y='112.284'/%3E %3Cpath fill='%23016a16' stroke='%23016a16' d='m269.047,166.766-19.3141,0.56058-19.227,0.21862s-9.8781,3.65352-13.9162,4.4734c-4.02618,0.81746-3.50263,2.14025-6.61818,2.83651-2.49547,0.55768-2.78328,0.73353-4.24748,0.82965-0.88604,0.0582-1.97735,0.73987-3.04471,1.49113v10.4491h94.6416v-9.939c-1.02588-0.55902-2.0035-0.94359-3.00404-1.28372-1.39031-0.47263-2.32725-0.9895-4.82272-1.54718-3.11555-0.69626-2.592-2.01905-6.61818-2.83651-4.03807-0.81988-13.829-5.2526-13.829-5.2526z'/%3E %3Cg id='flags'%3E %3Cg id='flags_half'%3E %3Cg%3E %3Cpath d='m244.529,143.512,1.39696-0.0329,2.55541,10.749-0.54516,3.38576-3.40721-14.1018z'/%3E %3Cpath fill='%23fff' d='m243.064,136.346,0.95402,8.2836,1.02216-0.0657-1.97618-8.21786z'/%3E %3Cpath d='m245.722,154.589-4.29308-11.5379,1.60139-0.0986,5.0086,14.1018-2.31691-2.46536z'/%3E %3Cpath fill='%23fff' d='m239.419,136.477,1.77175,8.02063,1.43103,0-3.20278-8.02063z'/%3E %3Cpath d='m241.906,150.546-2.52134-5.42379,1.09031-0.2301,4.59973,9.00677-3.1687-3.35288z'/%3E %3Cpath fill='%23fff' d='m236.08,138.778,2.79391,7.62618,1.43103,0-4.22494-7.62618z'/%3E %3C/g%3E %3Cg%3E %3Cpath fill='%230a328c' d='m242.249,151.364-11.4356-12.4841c-3.57164,2.82814-2.90807,8.02116-2.90807,8.02116l12.957,10.1661,1.38665-5.70318z'/%3E %3Cpath fill='%23d20014' d='m248.861,158.235-8.4834-8.59356c-3.5866,0.12446-0.74067,5.47902-0.56005,6.15114l9.04345,7.73433v-5.29191z'/%3E %3Cpath d='m248.139,156.757-17.5394-18.7806-0.6845,0.48355,18.5612,20.6216-0.3373-2.32459z'/%3E %3Cpath d='m229.586,136.772-0.38503-0.44575,0.0385-0.89151-3.61925-2.30304,1.61711,3.6403,1.23209,0.22287,0.38503,0.44575,0.73155-0.66862z'/%3E %3Cpath d='m227.738,138.11c0.61604-0.74292,1.34759-1.48584,2.65668-2.19161l1.00107,1.44869-2.15615,1.82015-1.5016-1.07723z'/%3E %3Cpath fill='%230a328c' stroke='%230a328c' d='m225.811,141.278s0.5879,1.02632,0.5879,1.02632c0.36393-0.13504,4.03128-3.45709,4.03128-3.45709l2.63154-0.081,0.75587-0.83726c-1.93166-2.07966-3.75134,0.29709-3.75134,0.29709l-4.25525,3.05196z'/%3E %3Cpath fill='%23d20014' stroke='%23d20014' d='m227.911,143.007c0.13998-0.91829,1.87567-3.21402,2.12762-3.29504,1.30317,0.39117,2.51537,1.14116,3.83533-1.83658-1.1478,1.45846-3.47139-0.027-3.47139-0.027l-1.00782,0.83726,0.028,0.40513-3.05146,2.8359,1.53973,1.08034z'/%3E %3C/g%3E %3Cg%3E %3Cpath fill='%230a328c' d='m237.252,154.672-14.367-11.4113c-2.45972,2.50307-0.41467,10.2317-0.41467,10.2317l14.0422,7.6072,0.73945-6.42753z'/%3E %3Cpath fill='%23d20014' d='m249.166,163.917-11.8183-9.46696c-4.03608,0.56639-0.86322,6.50618-0.62257,7.16056l12.481,6.76847-0.0402-4.46207z'/%3E %3Cpath d='m248.697,162.005-25.5539-19.1816-0.58707,0.59088,26.8371,20.9549-0.69613-2.36409z'/%3E %3Cpath d='m221.928,141.807-0.45941-0.37447-0.12254-0.88441-3.97879-1.66173,2.24776,3.31408,1.25348,0.0131,0.45941,0.37447,0.60009-0.78102z'/%3E %3Cpath d='m220.349,143.433c0.47297-0.83483,1.05969-1.68902,2.22186-2.60338l1.24661,1.25897-1.79578,2.15371-1.67269-0.8093z'/%3E %3Cpath fill='%230a328c' stroke='%230a328c' d='m218.925,146.641s0.15919,1.06,0.15919,1.06c0.33756-0.1883,3.56107-3.72584,3.56107-3.72584l2.58599-0.47719,0.52682-0.83299c-1.79717-2.11364-3.71297,0.69754-3.71297,0.69754l-3.1201,3.27848z'/%3E %3Cpath fill='%23d20014' stroke='%23d20014' d='m220.971,148.545c-0.12263-0.98212,1.21945-3.86265,1.45516-3.9807,1.54652,0.45977,2.8934,1.15261,3.46231-2.0687-0.89718,1.61373-3.46102,0.36219-3.46102,0.36219l-0.85966,0.97906,0.12134,0.53096-2.61004,3.36954,1.89191,0.80765z'/%3E %3C/g%3E %3Cg%3E %3Cpath fill='%230a328c' d='m236.224,161.651c-0.19061-0.046-18.5172-10.4422-18.5172-10.4422-1.33424,2.25264-0.12758,5.52064,0.45732,6.02891,0.0339,1.4999-0.60253,2.30652,0.7066,5.43903,0.38609,2.03671,1.32844,3.91312,2.70015,5.02765,1.67114,6.41674,8.22234,6.84773,10.7458,1.62404l3.90743-7.67738z'/%3E %3Cpath fill='%23d20014' d='m248.352,168.512-12.5481-7.35467c-4.03608,0.56638,0.0855,8.05519,0.32619,8.70957l12.1161,4.30413,0.10579-5.65903z'/%3E %3Cpath d='m246.243,165.846-28.3496-15.0889-0.48403,0.67221,29.9045,16.6466-1.07089-2.22992z'/%3E %3Cpath d='m216.528,149.937-0.51447-0.30053-0.26444-0.85502-4.19926-1.04078,2.75747,2.93404,1.24017-0.17626,0.51447,0.30053,0.46606-0.86198z'/%3E %3Cpath d='m215.232,151.782c0.33178-0.89594,0.77277-1.82816,1.77237-2.90666l1.4354,1.05533-1.42445,2.39822-1.78332-0.54689z'/%3E %3Cpath fill='%230a328c' stroke='%230a328c' d='m214.1,155.181s0.59329,1.16676,0.59329,1.16676c0.3071-0.2318,3.00342-4.57817,3.00342-4.57817l2.492-0.81976,0.4691-1.01389c-2.00158-1.84905-3.49738,1.34225-3.49738,1.34225l-3.06043,3.90281z'/%3E %3Cpath fill='%23d20014' stroke='%23d20014' d='m216.772,156.836c-0.20042-0.99867,0.48376-4.19683,0.70015-4.34538,1.56074,0.46564,2.86327,0.59786,3.22314-2.62209-0.90761,1.52943-3.32789,0.95334-3.32789,0.95334l-0.71005,1.08496,0.14955,0.37953-2.05871,3.95082,2.02381,0.59882z'/%3E %3C/g%3E %3C/g%3E %3Cuse xlink:href='%23flags_half' transform='matrix(-1,0,0,1,499.85852,0)'/%3E %3C/g%3E %3Cg id='tree'%3E %3Cpath fill='%23016a16' stroke='%23016a16' d='m248.757,125.603-0.46484,9.07011,2.89945,0-0.42417-8.99163,3.02233-0.42447-0.33476-3.58228-7.51056,0.28993,0.042,3.25311,2.77054,0.38523z'/%3E %3Cg id='tree_half' fill='%23016a16'%3E %3Cpath d='m249.817,121.898c-7.76384-7.77113-13.8779-3.97919-15.3336-2.90247,0.96228,0.18793,1.82599-0.41145,2.27298-0.48045-0.28013,0.35359-0.86579,1.22948-0.86579,1.22948s2.40063-1.13341,2.66882-1.02991c-0.34602,0.27599-0.72786,0.93628-0.72786,0.93628,0.1788,0.069,1.52885-1.05714,1.79539-1.07672-0.41123,0.46573-0.53888,1.52761-0.53888,1.52761l1.16969-0.54452c0.30396,0.21562-0.0845,0.63021,0.1798,0.60852,1.94414-0.15959,4.67774,1.77726,5.05322,2.37237'/%3E %3Cpath d='m247.895,123.321c-0.80914-1.85399-15.5878-5.00514-18.5596,0.24395,1.16313,0.29273,2.2757-0.97579,2.2757-0.97579l-0.10114,1.17094,1.97228-1.51246-0.708,1.56125,1.56771-1.26852-0.0506,1.26852,1.92171-2.09793-0.25285,1.21973,1.71942-0.73184-0.20229,1.02457'/%3E %3Cpath d='m247.238,123.614c-3.79284-2.53704-9.6591-0.82942-9.6591-0.82942-3.74227,2.09793-5.73699,1.71946-6.22027,5.61075,0.354-0.14637,1.36543-1.3661,1.36543-1.3661l0.75857,1.51247,0.25285-2.14673,0.60686,1.65883,0.91028-2.73219,0.20228,1.85399,1.416-1.85399,0.65742,0.53668,0.60686-1.41488,0.55628,0.92699s0.96085-0.58547,1.51714-0.24394l1.06199-1.21973,0.25286,0.8782,0.91028-1.07336,0.354,0.78063,0.91028-0.82942-0.0506,0.58547,3.13541,0.0488'/%3E %3Cpath d='m246.38,124.053c-2.64328-0.0494-10.2265,2.81155-12.1877,5.8059,0.78094-0.43617,1.26251-0.63483,1.26251-0.63483l0.38693,1.20328,0.47279-1.20328,0.10114,0.927c0.28991-0.72391,0.61743-0.80561,1.16314-0.0488,0,0,0.20228-1.12215,0.20228-1.12215l0.30343,1.07336,0.50571-1.17094s0.31812,1.26908,0.50571,1.21973c0,0,0.83854-2.19438,1.21371-2.29309l0.10114,1.36609,0.50571-1.36609,0.45515,1.02457,0.10114-1.46367,0.50571,1.12215s0.2652-1.10343,0.65743-1.31731l0.75856,0.68305,3.37743-2.42674'/%3E %3Cpath d='m246.888,124.678c-3.52111,1.34951-6.67031,6.17871-6.42914,8.22623,1.56462-1.94163,1.22764-1.67427,1.92704,0.55939,0,0,0.26458-1.95434,0.52987-2.18701l0.45923,1.44665,0.17053-1.89204,0.46972,0.0217-0.12058-1.18663,0.69939,0.53515c-0.16335-0.6785-0.33764-0.90743,0.38588-1.48911,0,0-0.91645,0.11634-0.19294-1.53564l0.67528,0.65148s-0.12058-0.72128,0.12059-1.00049l2.48407-0.86089'/%3E %3Cpath d='m247.229,125.04-1.33017,2.53368,0.68214,0.19743-1.53481,1.15167,1.29606-0.13162s-1.9782,0.72391-2.21694,2.6653l2.0123-0.88844s-1.70534,1.74397-1.94409,2.79692l1.15963-1.02005s-1.12552,1.21748-0.95499,3.06016l0.85267-0.95424c-0.20464,2.23753-0.13642,2.43496,0.88678,4.14602,0,0-0.27285-2.6324,0.0341-2.96145l2.25105,2.33625-1.26195-3.32339s1.39837,2.10591,2.25105,1.90848l-1.77356-2.6982,1.73945,1.41491-1.9782-2.96144,1.84177,0.55938s-1.33016-1.67815-1.22784-2.73111l1.26195,1.38201s-0.4775-1.57944-0.34107-2.04011l0.64803,0.13162-1.26195-1.44782,0.85267-0.16452-0.10232-0.95424,0.61392-0.19743-0.0341-1.05296'/%3E %3Cpath d='m248.559,125.797c-2.18283,2.96144-1.05731,7.53523-2.35337,9.87148'/%3E %3C/g%3E %3Cuse xlink:href='%23tree_half' transform='matrix(-1,0,0,1,499.85867,0)'/%3E %3Cg id='trunk'%3E %3Cpath d='m250.945,166.535s1.18865-9.94478,1.18579-14.2254c-0.002-3.36865-0.81392-10.8349-0.81392-10.8349h-3.41702s-0.52001,7.42903-0.44204,10.7889c0.0994,4.28179,1.18578,14.2713,1.18578,14.2713h2.30141z'/%3E %3Cpath d='m247.674,141.953,3.95963,0-0.46487-2.6659-2.87012,0-0.62464,2.6659z'/%3E %3Cpath d='m247.927,139.816,3.53853,0-0.667-2.6659-2.17951,0-0.69202,2.6659z'/%3E %3Cpath d='m248.155,137.655,2.94897,0-0.49856-2.6659-1.87631,0-0.5741,2.6659z'/%3E %3Cpath d='m250.709,134.673-2.06274,0-0.20917,0.96419,2.44041,0-0.1685-0.96419z'/%3E %3Cpath d='m251.132,164.367h-2.62035'/%3E %3Cpath d='m251.275,162.42h-2.9404'/%3E %3Cpath d='m251.664,160.444h-3.72683'/%3E %3Cpath d='m251.856,158.291h-3.90057'/%3E %3Cpath d='m251.883,156.139h-4.10175'/%3E %3Cpath d='m252.043,154.171h-4.44923'/%3E %3Cpath d='m252.053,152.38h-4.65041'/%3E %3Cpath d='m252.025,150.219h-4.65042'/%3E %3Cpath d='m251.87,148.084h-4.49496'/%3E %3Cpath d='m251.664,145.914h-4.06517'/%3E %3Cpath d='m251.467,143.955h-3.67197'/%3E %3C/g%3E %3Cg id='cap'%3E %3Cpath fill='%230a328c' stroke='%230a328c' d='m249.909,119.044c-0.68827-0.32391-2.24539-1.3126-1.78345-1.90279,0,0,0.71338-1.21454,0.71338-1.21454,1.01062-2.27664-0.0184-1.39459-0.12589-2.10521-0.10324-0.68238,3.86451-0.1495,3.92359,1.39673,0.0163,0.42592-0.2943,0.17596-0.25178,2.61126,0,0-0.75534,1.45746-0.75534,1.45746-0.56496,0.0526-1.23395-0.0139-1.72051-0.24291z'/%3E %3Cpath d='m250.392,124.934-0.98614-0.82994,0.27276-7.10507,0.96516,0.28339-0.25178,7.65162z'/%3E %3Cpath fill='%23d20014' stroke='%23d20014' d='m251.672,119.246c0.61915-0.36236,1.02443-1.44301,0.65043-2.08496-1.01607-1.28744-1.6737-0.7562-3.37806-1.336-0.3399,0.36203-1.05561,1.05866-0.90222,1.5789,2.24222,1.05562,1.37162,0.15654,2.1135,0.28804,0.39994,0.0709,0.65837,0.54508,1.51635,1.55402z'/%3E %3C/g%3E %3C/g%3E %3Cg id='items'%3E %3Cg id='i1'%3E %3Cuse xlink:href='%23ip' transform='matrix(1,0,0,-1,-0.00226132,320.36968)'/%3E %3Cpath fill='%23016a16' stroke='%23fff' stroke-width='0.1811' stroke-linecap='round' d='m238.358,161.75c0,1.29873-0.81458,2.35278-1.81827,2.35278s-1.81827-1.05405-1.81827-2.35278v-1.27647h3.63654v1.27647z'/%3E %3Cellipse fill='%23fff' stroke='none' cx='236.539' cy='160.063' rx='1.806' ry='0.898'/%3E %3Cpath fill='%23016a16' stroke='%23f1b517' d='m236.126,161.075-0.31022-3.29722,1.38188,0-0.22561,3.29722-0.84605,0z'/%3E %3Cpath id='ip' fill='%23016a16' stroke='%23fff' stroke-width='0.2373' stroke-linecap='round' d='m238.538,160.118c-0.26498,0.49319-1.06061,0.85208-1.99881,0.85208-0.9382-0.00001-1.72802-0.35889-1.99301-0.85208-0.0611,0.11381-0.0988,0.23335-0.0988,0.35877,0,0.66892,0.93708,1.21084,2.09179,1.21084s2.09178-0.54192,2.09178-1.21084c0-0.12542-0.0318-0.24496-0.093-0.35877z'/%3E %3C/g%3E %3Cg id='items_half'%3E %3Cpath id='cannon_base' d='m246.035,172.786-7.06013-2.18936-3.0762-5.25446-10.8928-0.53517,0.3783,3.94069,9.27903,1.77619,0.88243,1.58127,10.6659,2.96795-0.17658-2.28711z'/%3E %3Cg id='i2'%3E %3Cpath fill='%23503200' d='m238.662,174.254-11.1485-16.3982-0.54716,0.41156,11.0604,16.4667,0.63525-0.48015z'/%3E %3Cpath fill='%23fff' d='m228.551,158.5-1.19022-1.99181c-0.22281-0.36812-0.56118-0.49033-1.05837-0.22832-0.48411,0.25512-0.43705,0.75928-0.23987,1.12295l1.10042,1.85207,1.38804-0.75489z'/%3E %3C/g%3E %3Cg id='cannon'%3E %3Cpath d='m239.986,164.127-22.4964-2.28644-0.54691,3.27137,22.387,2.25127,0.6563-3.2362z'/%3E %3Cpath d='m217.089,160.997-0.58337,4.5377,0.94798,0,0.6563-4.15077-1.02091-0.38693z'/%3E %3Cpath d='m220.844,161.735-0.25522,4.08042,0.58337,0.0704,0.47399-3.62314-0.80214-0.52764z'/%3E %3Cpath d='m236.085,163.494-0.54691,3.83419,1.09382-0.0352,0.43753-3.79901-0.98444,0z'/%3E %3Cpath d='m239.436,163.599-0.77861,4.43415,1.23764,0.17939,0.35444-2.33199c0.0995,0.46856,0.53095,0.82404,1.04589,0.82404,0.58851,0,1.06914-0.46369,1.06914-1.03146s-0.48063-1.02585-1.06914-1.02585c-0.40919,0-0.78043,0.23995-0.9413,0.68697l0.23242-1.66237-1.15048-0.0729z'/%3E %3Cpath d='m231.317,164.319-3.09381,3.48224,0.36095,0.42285,3.97038-2.71118-1.23752-1.19391z'/%3E %3Cpath d='m224.124,173,3.09381-3.48225-0.36094-0.42284-3.97039,2.71118,1.23752,1.19391z'/%3E %3Cpath d='m232.22,172.129-3.76413-2.91016-0.38673,0.2736,2.9649,3.75585,1.18596-1.11929z'/%3E %3Cpath d='m222.938,165.413,3.8157,2.81067,0.46407-0.34823-2.99068-3.75585-1.28909,1.29341z'/%3E %3Cpath d='m227.09,163.094,0.36461,4.57288,0.51357-0.0219,1.2071-4.45153-2.08528-0.0995z'/%3E %3Cpath d='m228.341,174.189-0.3646-4.57289-0.56515-0.0528-0.69146,4.62565,1.62121,0z'/%3E %3Cpath d='m233.401,168.026-4.79461,0.51005-0.0729,0.45729,4.84929,0.63317,0.0182-1.60051z'/%3E %3Cpath d='m221.993,169.609,4.6808-0.73994,0.0987-0.36384-4.84175-0.54096,0.0622,1.64474z'/%3E %3Cellipse cx='227.693' cy='168.548' rx='1.27' ry='1.225'/%3E %3Cpath fill-rule='evenodd' stroke-linecap='round' d='m234.438,168.548c0,3.59202-3.02175,6.50727-6.74495,6.50727-3.72321,0-6.74496-2.91525-6.74496-6.50727,0-3.592,3.02175-6.50726,6.74496-6.50726,3.7232,0,6.74495,2.91526,6.74495,6.50726zm-1.34742,0.00001c0,2.87446-2.41811,5.20734-5.39755,5.20734s-5.39754-2.33288-5.39754-5.20734c0-2.87445,2.4181-5.20734,5.39754-5.20734s5.39755,2.33289,5.39755,5.20734z'/%3E %3Cpath d='m223.48,165.264-1.05705-0.79595'/%3E %3Cpath d='m231.034,164.493,0.90236-0.92031'/%3E %3Cpath d='m232.967,172.701-1.10862-0.87056'/%3E %3Cpath d='m223.48,173.696,0.95392-1.0198'/%3E %3C/g%3E %3Cg id='axe'%3E %3Cpath d='m246.196,162.122,1.15496,5.8864-0.94208,0.4962-1.01348-6.29841,0.8006-0.0842z'/%3E %3Cpath fill='%23fff' d='m245.592,161.364c-0.53548-0.22387-1.2316,0.15498-2.37396-1.29153-1.87831,1.72203-0.10709,1.98034,0.17849,3.68515,0.53115,0.21828,0.85836-1.32283,2.30256-1.48095,0.1785-0.0172,2.29785-0.20311,2.29785-0.20311s-0.53201-0.72513-0.53201-0.72513-1.47399,0.0387-1.87293,0.0156z'/%3E %3Cpath fill='%23fff' d='m246.359,162.518-0.21419-1.75647c-0.23204-0.61993-0.99956-0.0861-0.99956,0.27552l0.19634,1.61871,1.01741-0.13776z'/%3E %3C/g%3E %3Cpath id='bugle' fill-rule='evenodd' d='m240.765,167.372,0.0188,1.63686c-0.53573,0.18339-0.454,0.58498-0.43672,1.16852l0.0188,4.77113c-0.1901,0.31678-0.77767,0.33153-1.05418,0.5797-0.2765,0.24817-0.24194,0.72975,1.01961,1.04653l0.97557,0.0349c1.48622-0.32512,1.79297-0.81731,1.0477-1.09485-0.39645-0.14764-0.91809-0.32374-1.11682-0.55716l0.033-1.1367,0.96456,0.0349c0.25923,0,0.7525-0.65168,0.76978-1.1852l0.005-2.47044c-0.0346-1.4005-1.08551-1.55803-1.3793-1.54136l0.0204-1.28978-0.88602,0.003zm1.63059,2.73012c0.0173-0.40014-0.5556-0.75694-0.78631-0.76694s-0.73447,0.46683-0.75175,0.86697v1.00036c0.0346,0.3668,0.32755,1.60924,0.91592,1.7006,0.27872,0.0433,0.63942-0.40014,0.63942-0.76694l-0.0173-2.03405z'/%3E %3Cg id='i3' fill='%23fff'%3E %3Cpath d='m234.275,172.328c-0.63643-0.25722-0.63028,1.17186-0.63028,1.17186l1.00278,0.0105c0.43862,0.19913,0.79146,0.84264,0.51178,1.1585-0.23124,0.26115-2.17731-0.44106-2.30792-0.0372,0.34401,1.94159,2.91678,2.68867,3.84773,1.83931,0.91051-0.83072,1.14108-3.04781-1.81748-3.62862l-0.60661-0.51433z'/%3E %3Cpath d='m234.87,172.856-0.29241,0.63889'/%3E %3C/g%3E %3Cg id='small_flag'%3E %3Cpath d='m214.943,173.055-0.96325-4.04912'/%3E %3Cpath d='m216.112,172.822-1.47928-3.15301'/%3E %3Cpath d='m218.658,171.993-3.33698-1.79223'/%3E %3Cpath d='m220.103,171.628-6.19232-2.68836'/%3E %3Cpath fill='%23d20014' stroke='%23d20014' d='m210.215,166.013s-2.25377-0.0356-2.65571,0.122c-0.16218,0.0636,0.56688,0.82456,0.41552,1.11549-0.56308,1.08226-4.3943,0.93396-4.69718,0.69717-0.51817-0.4051,3.56833-0.75265,3.59515-1.02833,0.0308-0.31645-0.60433-1.14672-0.50585-1.6558,0.12777-0.66051,1.78854-0.90633,1.78854-0.90633l2.05953,1.6558z'/%3E %3Cpath fill='%23503200' d='m213.233,168.05-5.10223-4.22211s-0.22478-0.2382-0.41282-0.0332c-0.18413,0.20074,0.0688,0.43146,0.0688,0.43146l5.26348,4.34783,0.18277-0.52399z'/%3E %3Cpath d='m218.146,172.217c-0.0903-0.0871-4.1552-3.60789-4.1552-3.60789l-0.27099-1.02833s-0.6278,0.42527-0.85814,0.64488-0.58715,0.81919-0.58715,0.81919l1.13817,0.0523,3.59515,3.29416,1.13816-0.1743z'/%3E %3C/g%3E %3Cg id='cannonballs'%3E %3Cellipse cx='232.534' cy='177.056' rx='0.740' ry='0.715'/%3E %3Cellipse cx='230.641' cy='175.716' rx='0.740' ry='0.715'/%3E %3Cellipse cx='228.091' cy='176.593' rx='0.740' ry='0.715'/%3E %3Cellipse cx='224.153' cy='177.445' rx='0.740' ry='0.715'/%3E %3Cellipse cx='222.487' cy='177.64' rx='0.740' ry='0.715'/%3E %3Cellipse cx='220.846' cy='177.64' rx='0.740' ry='0.715'/%3E %3Cellipse cx='219.18' cy='177.591' rx='0.740' ry='0.715'/%3E %3Cellipse cx='219.988' cy='176.325' rx='0.740' ry='0.715'/%3E %3Cellipse cx='221.604' cy='176.398' rx='0.740' ry='0.715'/%3E %3Cellipse cx='223.144' cy='176.203' rx='0.740' ry='0.715'/%3E %3Cellipse cx='222.361' cy='174.961' rx='0.740' ry='0.715'/%3E %3Cellipse cx='220.846' cy='174.937' rx='0.740' ry='0.715'/%3E %3C/g%3E %3Cpath id='chain' fill-rule='evenodd' d='m236.47,177.991c0-0.31649-0.76859-0.18036-0.76859-0.55072,0-0.41154,1.17217-0.10903,1.33411,0.25303,0.65964-0.59607,0.94402-0.16037,1.34812,0.0197,0.57546-0.85539,1.28698-0.82343,1.98133-0.19706,0.40146-0.44287,1.40966-0.29647,1.75664,0.19706,0.66466-0.6591,1.25491-0.49671,1.71579-0.0197,0.18538-0.34652,0.45745-0.2707,0.65363-0.0197,0.35414-0.62828,1.24209-0.43967,1.61583-0.0249,0.33231-0.36526,0.67271-0.08,1.11376,0.18982,0.29784-0.2787,0.77827-0.22616,0.77827,0.0509,0,0.28889-0.62779,0.18719-0.62779,0.4739,0,0.25579,0.45796,0.12646,0.45796,0.45,0,0.25469-0.67973,0.35017-0.78477-0.0559-0.23021,0.43971-1.06186,0.27088-1.14386-0.13794-0.27669,0.33403-0.89704,0.43568-1.24599-0.0591-0.28657,0.23315-0.6295,0.26652-0.78695,0.0311-0.51709,0.55594-1.3887,0.4417-1.68895-0.17117,0,0-0.29346,0.0125-0.29346,0.0125-0.50794,0.68971-1.30179,0.37107-1.52011-0.0104-0.8527,0.61519-1.36211,0.42145-1.83835,0.0197-0.54713,0.66665-1.38081,0.62012-1.57281,0-0.36819,0.26829-1.13636,0.33144-1.13636,0.0176,0-0.30068,0.65255-0.19137,0.65255-0.46876zm1.65458,0.14977c0,0.1432-0.19492,0.25942-0.43509,0.25942s-0.43508-0.11622-0.43508-0.25942,0.19491-0.25943,0.43508-0.25943,0.43509,0.11623,0.43509,0.25943zm1.82033-0.21792c0,0.17238-0.23462,0.31227-0.52371,0.31227-0.28908,0-0.52371-0.13989-0.52371-0.31227,0-0.17236,0.23463-0.31226,0.52371-0.31226,0.28909,0,0.52371,0.1399,0.52371,0.31226zm3.57497,0.19716c0,0.1745-0.21232,0.31611-0.47392,0.31611s-0.47392-0.14161-0.47392-0.31611c0-0.17449,0.21232-0.31611,0.47392-0.31611s0.47392,0.14162,0.47392,0.31611zm-1.90344-0.083c0,0.22051-0.20766,0.39948-0.46353,0.39948s-0.46353-0.17897-0.46353-0.39948,0.20766-0.39948,0.46353-0.39948,0.46353,0.17897,0.46353,0.39948zm4.05961,0.0104c0,0.19712-0.18564,0.35711-0.41437,0.35711s-0.41436-0.15999-0.41436-0.35711c0-0.19713,0.18563-0.35711,0.41436-0.35711s0.41437,0.15998,0.41437,0.35711zm-1.24369,0.083c0,0.12739-0.11997,0.23078-0.26778,0.23078-0.14782,0-0.26778-0.10339-0.26778-0.23078s0.11996-0.23078,0.26778-0.23078c0.14781,0,0.26778,0.10339,0.26778,0.23078zm2.42185,0.0934c0,0.183-0.13521,0.33153-0.30181,0.33153s-0.30181-0.14853-0.30181-0.33153c0-0.18301,0.13521-0.33154,0.30181-0.33154s0.30181,0.14853,0.30181,0.33154z'/%3E %3C/g%3E %3Cuse xlink:href='%23items_half' transform='matrix(-1,0,0,1,499.85853,0)'/%3E %3Cg id='drum' stroke-width='0.231'%3E %3Cpath fill='%230a328c' stroke='%230a328c' d='m249.837,165.718c-2.5116,0-4.54963,0.94401-4.54963,2.10216,0,0.19861,0.0565,0.38965,0.1685,0.57178,0.54316,0.62909,2.30675,1.08752,4.39856,1.08752,1.95672,0,3.6243-0.40275,4.27654-0.9698,0.16439-0.21675,0.25566-0.44698,0.25566-0.6895,0-1.15816-2.03804-2.10216-4.54963-2.10216z'/%3E %3Cpath stroke-width='0.1869' d='m254.427,167.981v7.05811c0,0.82757-2.04845,1.49922-4.57243,1.49922-2.52399,0-4.57244-0.67165-4.57244-1.49922v-7.05811c0,0.82757,2.04845,1.49922,4.57244,1.49922,2.52398,0,4.57243-0.67165,4.57243-1.49922z'/%3E %3Cpath fill='%23d20014' stroke='%23d20014' stroke-width='0.1826' d='m245.282,167.982v1.08191l2.21961,6.84463,1.77221-5.2638,1.94652,5.46561,1.42429-5.15885,1.78311,3.46807v-1.91933l-1.65599-3.36345c-0.18576,0.0506-0.38384,0.094-0.59268,0.13454l-1.02846,3.81191-1.44681-3.6045c-0.24229-0.003-0.48334-0.008-0.7147-0.0224l-1.45263,3.62692-1.6618-4.36688c-0.37558-0.21764-0.59267-0.46661-0.59267-0.73436z'/%3E %3Cpath fill='%230a328c' stroke='%230a328c' stroke-width='0.1869' d='m254.427,173.721v1.31782c0,0.82757-2.04845,1.49922-4.57243,1.49922-2.52399,0-4.57244-0.67165-4.57244-1.49922v-1.31782c0,0.82757,2.04845,1.49922,4.57244,1.49922,2.52398,0,4.57243-0.67165,4.57243-1.49922z'/%3E %3Cpath stroke-width='0.1869' d='m251.737,175.085c-0.37176,0.0553-0.76859,0.0967-1.18535,0.11772l0.0116,1.31736c0.41688-0.0214,0.81373-0.062,1.18535-0.11773l-0.0116-1.31735z'/%3E %3Cpath stroke-width='0.1869' d='m246.868,174.855-0.0116,1.31174c0.35286,0.10094,0.74975,0.18477,1.18534,0.24666v-1.31736c-0.43047-0.0611-0.82391-0.1417-1.17372-0.24104z'/%3E %3Cpath stroke-width='0.1869' d='m245.282,173.723v1.31736c0,0.24576,0.18539,0.47354,0.50551,0.67829l0.0232-1.30053c-0.33594-0.20864-0.52875-0.44293-0.52875-0.69512z'/%3E %3Cpath stroke-width='0.1869' d='m254.428,173.863-0.0232,0.006c-0.0801,0.26749-0.37874,0.51556-0.8309,0.72315l0.006,1.31174c0.53035-0.2448,0.84834-0.54036,0.84834-0.86328v-1.17721z'/%3E %3Cpath fill='none' stroke-width='0.1869' d='m254.427,168.027v7.01203c0,0.82757-2.04845,1.49922-4.57243,1.49922-2.52399,0-4.57244-0.67165-4.57244-1.49922v-7.01203'/%3E %3Cpath fill='%23fff' stroke='%23fff' stroke-width='0.1916' d='m253.392,167.52c0,0.50111-1.58376,0.90734-3.53741,0.90734-1.95366,0-3.53741-0.40623-3.53741-0.90734s1.58375-0.90734,3.53741-0.90734c1.95365,0,3.53741,0.40623,3.53741,0.90734z'/%3E %3Cpath d='m248.698,168.19,0.15688,1.25008c0.30701,0.0223,0.62606,0.0382,0.95293,0.0392l0.23242-1.28932h-1.34223z'/%3E %3Cpath d='m252.801,167.887-0.91225,0.24665,0.0581,1.17721c0.3102-0.0525,0.60208-0.11708,0.86576-0.1906l-0.0116-1.23326z'/%3E %3Cpath d='m247.397,165.979c-0.25878,0.0764-0.50082,0.16525-0.7205,0.26347l0.12783,0.94417,0.58105-0.18499,0.0116-1.02265z'/%3E %3Cpath d='m249.837,165.606c-0.12168,0-0.24098,0.007-0.36025,0.0112l0.19756,1.18249,0.60429-0.0112,0.23823-1.15447c-0.22219-0.0155-0.44837-0.028-0.67983-0.028z'/%3E %3Cpath d='m252.51,166.024-0.12203,1.0337,0.69146,0.24441,0.0755-1.01464c-0.19636-0.0968-0.41236-0.18511-0.64496-0.26347z'/%3E %3Cpath stroke-width='0.1826' d='m245.993,168.8,0.18421-1.28763-0.93496-0.50634,0.0278,1.46536,0.72294,0.32861z'/%3E %3Cpath stroke-width='0.1826' d='m254.396,168.522,0.0417-1.28759-0.87584,0.26154,0.83413,1.02605z'/%3E %3C/g%3E %3Cg id='helmet'%3E %3Cpath d='m263.686,160.029c0.83083-0.11451,2.06245,1.02446,2.13643,2.4333,0.0587,1.11791-1.69134,1.0592-1.69134,1.0592-0.089,0.45803-1.0541,0.88186-1.83971,0.91606-0.76216,0.0332,0.20771-1.43135,0.20771-1.43135-0.47476-1.25959,0.14836-2.74819,0.14836-2.74819l1.03855-0.22902z'/%3E %3Cpath d='m262.499,162.948,0.80116-0.0286s0.0613,0.41314,0.20771,0.42941c0.15745,0.0175,0.3264-0.40078,0.3264-0.40078l1.21658-0.0286'/%3E %3Cpath fill='%23d20014' stroke='%23f1b517' d='m264.131,160.859c0.67974-0.49144,0.084-1.48026-0.38575-1.4886,0,0-1.09789,0.0286-1.09789,0.0286-0.51741,0.0107-1.39215,0.57267-1.27592,1.05921,0.10134,0.42425,0.38608,0.61772,0.83083,0.54391,0.20197-0.0335,0.62612-0.56336,0.83084-0.57254,0.27465-0.0123,0.87787,0.58848,1.09789,0.4294z'/%3E %3C/g%3E %3Cpath id='anchor' fill-rule='evenodd' d='m214.242,174.855c-0.61672,0.078-0.73098,0.78846-0.4997,1.44067-2.68636,0.7552-5.08627,1.73945-7.45489,2.40487-0.0953-0.4735,1.17372-1.84429,1.17372-1.84429,0.33571,0.16194,0.58686,0.93056,0.58686,0.93056,0.0839-1.57891,1.63857-2.6291,1.63857-2.6291-0.9232-0.12146-3.73165,0.96732-4.06736,1.41265,0,0,1.08722-0.12146,1.25507,0,0,0-2.14094,2.31168-2.23705,2.99907,0.33303,0.75114,4.02669,1.31175,4.02669,1.31175-0.0583,0.19445-1.08657,0.93056-1.08657,0.93056,1.4691,0.32268,3.68473-0.71797,4.34627-1.35099,0,0-1.72808-0.14248-3.07377-1.23327,0,0,0.2775,0.67919,0.1104,1.00343,0,0-2.09936-0.60528-2.31839-0.95297,0.006-0.0301,4.96602-1.31472,7.36773-2.00126,0.0889,0.42909,0.56583,1.23978,1.13886,1.04828,0.37379-0.12492,0.25537-0.8657,0.11621-1.39023,0.13517,0.11606,0.31047,0.18499,0.50551,0.18499,0.42228,0,0.76699-0.32696,0.76699-0.73435,0-0.4074-0.34471-0.73996-0.76699-0.73996-0.33769,0-0.61915,0.21145-0.7205,0.50452-0.0956-0.45275-0.34512-1.35347-0.80766-1.29493zm1.8887,1.52779c0,0.19057-0.16032,0.34523-0.35785,0.34523s-0.35784-0.15466-0.35784-0.34523,0.16031-0.34524,0.35784-0.34524,0.35785,0.15467,0.35785,0.34524z'/%3E %3Cg id='i4'%3E %3Cpath d='m293.068,177.884c0.18296-0.36659-0.16181-2.21178-0.16181-2.21178-0.37288,0.0414-0.88217,0.68114-0.88217,0.68114,0.48088-1.51138-0.86509-4.03755-0.86509-4.03755,0.91058,0.1905,3.94542,3.12828,4.103,3.65753,0,0-1.32902-0.47414-1.52981-0.4154,0.21676,1.50571,1.25802,2.20544,1.64916,2.98821,0,0-1.7257,0.37897-1.55229,1.82194l-1.12718,0.0209c-0.39017-0.48099,0.15174-1.27567,0.15174-1.27567l-7.73851-3.24146c-0.49856-0.20913-1.6204-0.71815-1.45233-1.3175,0.16946-0.6043,2.01592,0.25096,2.47112,0.39734l6.93417,2.93229z'/%3E %3Cpath d='m285.635,176.541,0.91042-1.67302c0.32514-0.43916-0.34683-0.92015-0.82371-0.35551l-1.0188,1.52662c-0.4552,0.83651,0.49856,1.06655,0.93209,0.50191z'/%3E %3C/g%3E %3C/g%3E %3Cg id='motto'%3E %3Cg fill='%23fff'%3E %3Cpath d='m231.367,180.366-0.0631-1.82484-2.20675,0.12166-0.1261,1.98705,2.3959-0.28387z'/%3E %3Cpath d='m215.237,182.924-2.9508-1.65512c12.1686,1.11518,14.6537-3.12916,17.5942-3.35618,1.80755-0.14118,2.0898,2.0019-1.41275,0.98242l0.90579,2.24135s-8.6385,4.85952-17.1292,2.85219l2.99283-1.06466z'/%3E %3Cpath d='m268.249,180.366,0.063-1.82484,2.6992,0.0623,0.1261,1.98705-2.88835-0.22448z'/%3E %3Cpath d='m284.939,182.477,2.77669-1.51514c-13.9388,0.41529-10.7652-2.28929-17.7392-3.04823-1.80213-0.1953-3.15679,2.12067,1.41275,0.98242l-0.90579,2.24135s2.1922,0.002,2.1922,0.002c4.74805,3.12663,11.156,3.40575,15.4013,2.40209l-3.13793-1.06466z'/%3E %3Cpath d='m228.418,178.908,0,3.15421s7.728,2.86747,21.5188,2.86747c13.8501,0,21.5188-2.86747,21.5188-2.86747v-3.15421s-5.84903,2.69542-21.5188,2.69542c-15.6103,0-21.5188-2.69542-21.5188-2.69542z'/%3E %3C/g%3E %3Cpath fill='%23000' stroke='none' d='m229.573,182.08,0.68194-2.30932,0.31676,0.0871-0.60146,2.0368,1.17887,0.32402-0.0805,0.27252-1.49564-0.41108zm2.23639-1.01549,0.0381-0.45359,0.10174-0.38911,0.33747,0.0821-0.10174,0.38911-0.1928,0.41593-0.18273-0.0445zm3.32525-0.15591,0.32275,0.0634-0.28686,1.35944c-0.0499,0.23647-0.11725,0.41881-0.20205,0.54702s-0.20878,0.22171-0.37192,0.28049c-0.16314,0.0588-0.36227,0.0651-0.5974,0.0189-0.22847-0.0449-0.40734-0.11956-0.5366-0.22407-0.12926-0.1045-0.20976-0.23481-0.2415-0.39093-0.0317-0.15611-0.0213-0.35882,0.0313-0.60813l0.28685-1.35945,0.32275,0.0634-0.28652,1.35784c-0.0431,0.20437-0.0552,0.35884-0.0363,0.46341s0.0708,0.19249,0.15571,0.26376c0.0849,0.0713,0.19663,0.12052,0.33527,0.14775,0.23734,0.0466,0.41743,0.0279,0.54026-0.056,0.12283-0.084,0.2154-0.27362,0.27771-0.56894l0.28652-1.35784zm0.36326,2.51013,0.40178-2.36971,0.33342,0.0526,0.97468,2.06413,0.31545-1.86053,0.31164,0.0492-0.40178,2.36971-0.33342-0.0526-0.9744-2.06574-0.31573,1.86215-0.31164-0.0492zm2.54115,0.38367,0.34172-2.37847,0.32625,0.0436-0.34173,2.37846-0.32624-0.0436zm0.9374-1.04907c0.0469-0.39598,0.19381-0.69384,0.44075-0.89358,0.24694-0.19973,0.54471-0.28038,0.89332-0.24196,0.22827,0.0252,0.42783,0.10047,0.59866,0.22591,0.17084,0.12544,0.29318,0.28758,0.36704,0.4864,0.0739,0.19883,0.0966,0.41759,0.0684,0.65626-0.0286,0.24193-0.10489,0.45279-0.22871,0.63258-0.12382,0.17978-0.28432,0.30854-0.48149,0.38627-0.19718,0.0777-0.40316,0.10475-0.61794,0.0811-0.23278-0.0257-0.43439-0.10284-0.60484-0.23154-0.17044-0.12869-0.29178-0.29209-0.36402-0.49019-0.0722-0.1981-0.0959-0.40184-0.0711-0.61123zm0.33678,0.0421c-0.0341,0.28749,0.0192,0.5228,0.15989,0.70591,0.14065,0.18311,0.33186,0.28799,0.57364,0.31464,0.24627,0.0272,0.45885-0.034,0.63776-0.18358,0.17891-0.14953,0.28654-0.37781,0.32291-0.68483,0.023-0.1942,0.009-0.36746-0.0418-0.5198-0.0509-0.15233-0.13711-0.27559-0.25867-0.36977-0.12156-0.0942-0.26387-0.15026-0.42692-0.16823-0.23166-0.0255-0.44007,0.0293-0.62524,0.16435-0.18517,0.1351-0.29903,0.38221-0.34155,0.74131zm2.30844,1.41617,0.2028-2.39322,0.33674,0.0266,1.1437,1.98175,0.15922-1.87899,0.31474,0.0248-0.20281,2.39322-0.33673-0.0266-1.14356-1.98339-0.15937,1.88062-0.31473-0.0248zm3.48923,0.24265,0.10868-2.39892,1.67748,0.0707-0.0128,0.28309-1.34843-0.0569-0.0336,0.74292,1.16694,0.0492-0.0128,0.28309-1.16694-0.0492-0.0494,1.08982-0.32905-0.0139zm1.83353,0.0783,1.00383-2.38291,0.35477,0.007,0.97029,2.41977-0.37513-0.007-0.27567-0.73253-1.04054-0.0194-0.28787,0.722-0.34968-0.007zm0.7378-0.97244,0.84363,0.0157-0.24637-0.66973c-0.0752-0.20345-0.13067-0.3705-0.16654-0.50113-0.0348,0.15334-0.0825,0.30535-0.1433,0.45603l-0.28742,0.69907zm1.9137,1.01069,0.005-2.4012,0.32936,0.00054-0.005,2.4012-0.32937-0.00054zm1.54203-0.007-0.0313-2.11763-0.81994,0.0113-0.004-0.28333,1.97259-0.0271,0.004,0.28333-0.82333,0.0113,0.0313,2.11763-0.32933,0.005zm2.44223-0.0577-0.1164-2.39858,0.32901-0.0148,0.10266,2.11553,1.22444-0.0553,0.0137,0.28305-1.55345,0.0702zm1.67472-0.073,0.77655-2.46067,0.35394-0.0243,1.19294,2.3253-0.37425,0.0257-0.34315-0.7055-1.0381,0.0714-0.21908,0.74414-0.34885,0.024zm0.6437-1.03278,0.84166-0.0579-0.30809-0.64551c-0.0939-0.19606-0.16484-0.35758-0.21279-0.48456-0.0203,0.15575-0.0536,0.3113-0.10001,0.46665l-0.22077,0.72127zm2.92174,0.75811-0.27296-2.38673,1.66896-0.17765,0.0322,0.28165-1.34158,0.14281,0.0845,0.73913,1.16102-0.12358,0.0322,0.28165-1.16101,0.12359,0.124,1.08428-0.32738,0.0349zm1.82509-1.37024c-0.0584-0.39457,0.006-0.71858,0.19234-0.97205,0.18659-0.25346,0.45356-0.40411,0.80091-0.45194,0.22746-0.0313,0.44026-0.007,0.63841,0.0726,0.19815,0.0797,0.359,0.20675,0.48255,0.38111,0.12354,0.17436,0.20291,0.38045,0.23809,0.61827,0.0357,0.24107,0.0171,0.46367-0.0556,0.66781s-0.19425,0.36785-0.36465,0.49114c-0.17041,0.12329-0.36262,0.19966-0.57664,0.22913-0.23194,0.0319-0.44722,0.006-0.64585-0.0765-0.19863-0.083-0.35884-0.21146-0.48063-0.38551-0.12178-0.17406-0.19811-0.3654-0.22897-0.57403zm0.33686-0.0414c0.0424,0.28646,0.1556,0.50113,0.33965,0.644,0.18406,0.14286,0.39654,0.19771,0.63745,0.16454,0.24538-0.0338,0.43503-0.14483,0.56896-0.33314,0.13392-0.1883,0.17825-0.43541,0.133-0.74134-0.0286-0.19349-0.0875-0.35773-0.17665-0.49271-0.0891-0.13498-0.20485-0.23321-0.34714-0.29469-0.14229-0.0615-0.29467-0.081-0.45714-0.0587-0.23082,0.0318-0.41811,0.13561-0.56188,0.31148-0.14376,0.17588-0.18918,0.44272-0.13625,0.80053zm2.61378,0.80601-0.4445-2.3626,1.0858-0.19014c0.21827-0.0382,0.38819-0.0461,0.50977-0.0235,0.12158,0.0225,0.22644,0.0816,0.31458,0.17713,0.0881,0.0956,0.14445,0.20832,0.16891,0.33832,0.0315,0.16761,0.002,0.31874-0.089,0.4534-0.0909,0.13466-0.25083,0.23814-0.47995,0.31044,0.0932,0.0247,0.16576,0.0525,0.21758,0.0834,0.11042,0.0672,0.21978,0.15629,0.32807,0.26717l0.54695,0.56843-0.40759,0.0714-0.41655-0.43479c-0.12135-0.12524-0.21972-0.2201-0.29512-0.28459-0.0754-0.0645-0.14015-0.10752-0.19425-0.12912s-0.10733-0.0339-0.15966-0.037c-0.0382-0.001-0.099,0.006-0.18254,0.0203l-0.37585,0.0658,0.19739,1.04915-0.32407,0.0568zm0.0757-1.37664,0.69658-0.12199c0.14812-0.0259,0.26116-0.061,0.33912-0.10516,0.078-0.0442,0.13255-0.10256,0.16375-0.17517,0.0312-0.0726,0.0396-0.14705,0.0253-0.22333-0.021-0.11174-0.0804-0.19624-0.17797-0.2535-0.0976-0.0573-0.2372-0.07-0.41872-0.0382l-0.7751,0.13573,0.14706,0.78163zm3.93115-0.26168,0.33959,0.009c-0.008,0.26923-0.0838,0.4897-0.22765,0.66141-0.14382,0.17171-0.34216,0.28502-0.59502,0.33993-0.2617,0.0568-0.48653,0.0517-0.67449-0.0155s-0.34748-0.18896-0.47854-0.36533c-0.13107-0.17636-0.2227-0.3764-0.2749-0.60011-0.0569-0.24395-0.0583-0.46723-0.004-0.66985,0.0542-0.20262,0.15952-0.37043,0.31585-0.50344s0.3416-0.22278,0.55582-0.2693c0.24293-0.0528,0.46112-0.0375,0.6546,0.0459,0.19347,0.0833,0.34801,0.22607,0.46362,0.42817l-0.29958,0.14061c-0.0961-0.15821-0.20676-0.26457-0.33201-0.31908-0.12525-0.0545-0.26904-0.0641-0.43136-0.0289-0.18661,0.0405-0.33251,0.11755-0.4377,0.23105-0.1052,0.11351-0.16622,0.24849-0.18309,0.40493-0.0169,0.15644-0.007,0.3119,0.0288,0.46637,0.0465,0.19921,0.11715,0.36658,0.212,0.50212,0.0949,0.13554,0.21436,0.22627,0.35849,0.2722,0.14414,0.0459,0.29018,0.0528,0.43815,0.0207,0.17998-0.0391,0.32068-0.12225,0.42209-0.24949,0.10141-0.12723,0.1512-0.29419,0.14939-0.50086zm0.91487,0.65288-0.66928-2.31277,1.73334-0.46687,0.079,0.27293-1.4161,0.38142,0.20498,0.70835,1.32617-0.3572,0.0785,0.27134-1.32617,0.3572,0.22781,0.78723,1.47171-0.3964,0.079,0.27292-1.78894,0.48185z'/%3E %3C/g%3E %3C/g%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 3'%3E %3Crect fill='%23436F4D' width='6' height='3'/%3E %3Crect fill='%23FFF' width='6' height='2'/%3E %3Crect fill='%23CD2A3E' width='6' height='1'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 3 2'%3E %3Crect fill='%23FFF' width='3' height='2'/%3E %3Crect fill='%23CE1126' width='3' height='1'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns:dc='http://purl.org/dc/elements/1.1/' xmlns:cc='http://creativecommons.org/ns%23' xmlns:rdf='http://www.w3.org/1999/02/22-rdf-syntax-ns%23' xmlns:svg='http://www.w3.org/2000/svg' xmlns='http://www.w3.org/2000/svg' xmlns:sodipodi='http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd' xmlns:inkscape='http://www.inkscape.org/namespaces/inkscape' viewBox='0 0 600 300' id='svg2' inkscape:version='0.91 r13725' sodipodi:docname='Ireland.svg'%3E %3Cdefs id='defs4'/%3E %3Csodipodi:namedview id='base' pagecolor='%23ffffff' bordercolor='%23666666' borderopacity='1.0' inkscape:pageopacity='0.0' inkscape:pageshadow='2' inkscape:zoom='1.348785' inkscape:cx='187.47867' inkscape:cy='143.80555' inkscape:document-units='px' inkscape:current-layer='layer1' showgrid='false' units='px' inkscape:window-width='1440' inkscape:window-height='837' inkscape:window-x='-8' inkscape:window-y='-8' inkscape:window-maximized='1'/%3E %3Cg inkscape:label='Layer 1' inkscape:groupmode='layer' id='layer1' transform='translate(0,-752.36216)'%3E %3Crect style='fill:%23169b62;fill-opacity:1;stroke:none' id='rect4148' width='200' height='300' x='0' y='752.36218'/%3E %3Crect style='fill:%23ffffff;fill-opacity:1;stroke:none' id='rect4150' width='200' height='300' x='200' y='752.36212'/%3E %3Crect style='fill:%23ff883e;fill-opacity:1;stroke:none' id='rect4152' width='200' height='300' x='400' y='752.36218'/%3E %3C/g%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 220 160'%3E %3Cdesc%3EFlag of Israel%3C/desc%3E %3Cdefs%3E %3Cpolygon id='triangle' points='0,-29.1410161513775421 -25.2368602791855814, 14.5705080756887710 25.2368602791855814, 14.5705080756887710' stroke='%230038b8' stroke-width='5.5' fill-opacity='0'/%3E %3C/defs%3E %3Crect width='220' height='160' fill='white'/%3E %3Crect width='220' height='25' fill='%230038b8' y='15'/%3E %3Crect width='220' height='25' fill='%230038b8' y='120'/%3E %3Cuse xlink:href='%23triangle' transform='translate(110,80)'/%3E %3Cuse xlink:href='%23triangle' transform='translate(110,80) rotate(180)'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns:dc='http://purl.org/dc/elements/1.1/' xmlns:cc='http://creativecommons.org/ns%23' xmlns:rdf='http://www.w3.org/1999/02/22-rdf-syntax-ns%23' xmlns:svg='http://www.w3.org/2000/svg' xmlns='http://www.w3.org/2000/svg' xmlns:sodipodi='http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd' xmlns:inkscape='http://www.inkscape.org/namespaces/inkscape' x='0' y='0' viewBox='0 0 600 300'%3E %3Csodipodi:namedview id='base' showguides='true' inkscape:guide-bbox='true' inkscape:zoom='1' inkscape:cx='207.11039' inkscape:cy='66.341622' inkscape:window-width='1280' inkscape:window-height='1004' inkscape:window-x='-8' inkscape:window-y='-8' inkscape:current-layer='svg378' inkscape:showpageshadow='false' showgrid='false' fit-margin-top='0' fit-margin-left='0' fit-margin-right='0' fit-margin-bottom='0' inkscape:window-maximized='1'%3E %3C/sodipodi:namedview%3E %3Cdefs id='defs380'/%3E %3Cpath style='fill:%23cf142b;fill-opacity:1;fill-rule:nonzero;stroke:none' d='m 0,0 600,0 0,300 -600,0 z' id='rect2489' inkscape:connector-curvature='0' sodipodi:nodetypes='ccccc'/%3E %3Cg id='g4408' transform='matrix(0.3498026,0,0,0.3498026,163.24255,23.83426)'%3E %3Cpath id='path4410' d='m 419.10237,546.46443 c 0.2907,-0.8793 0.87689,-9.94616 0.58379,-9.94616 -0.29309,0 -13.74684,-15.79373 -13.45374,-15.79373 0.2931,0 17.25683,3.80308 17.25683,3.21688 0,-0.58379 6.72687,-16.67062 6.72687,-16.96372 0,-0.2907 8.18997,19.59681 8.18997,19.59681 l 16.67062,7.31307 -11.69995,9.65066 c 0,0 2.63309,18.71992 2.63309,19.01302 0,0.2907 -11.69995,-11.11615 -11.69995,-11.11615 l -12.86994,1.46309 c 0,0 -1.7538,-5.84997 -2.33759,-6.43377 z' style='font-size:12px;fill:%23f9dd16;fill-opacity:0.98823499;fill-rule:evenodd;stroke:%23000000;stroke-width:2.40245399pt' inkscape:connector-curvature='0'/%3E %3Cpath sodipodi:nodetypes='ccccccccccccccccccccccccccc' id='path4412' d='m 328.4794,300.67417 c -11.11375,5.72264 -53.76692,54.47804 -59.6169,62.08181 -4.901,11.03928 -14.48679,25.00474 -24.36088,33.99472 -10.53956,7.97375 -16.39675,18.86648 -14.94567,29.18021 -0.11772,12.83391 7.07763,21.57163 12.80989,30.60246 3.39226,4.12501 7.95693,6.79174 12.80988,7.11607 9.95577,1.31414 10.83988,4.37967 15.82257,6.27761 19.62805,26.7249 48.90915,46.43223 69.9979,62.04337 13.44173,7.08484 22.78967,14.16968 25.99215,18.03763 6.1743,11.78884 5.03794,23.28458 4.19228,28.93275 -5.21813,19.69052 -10.43866,39.38103 -15.65679,59.07154 -2.63309,16.08683 11.34679,12.46874 12.09875,9.25185 6.30885,-8.18996 15.72407,-2.43849 29.17781,-49.81969 6.1671,-8.30288 12.3366,-16.60576 18.5037,-24.90864 0,0 7.11847,-2.84691 7.11847,-3.55803 10.82305,-12.99488 2.58264,-20.43288 -3.56044,-22.77287 -4.507,-1.66009 -9.014,-3.32259 -13.52101,-4.98268 0,0 -15.65679,-15.6568 -16.36792,-15.6568 -7.4404,-21.64371 -43.9601,-67.8501 -52.44317,-74.28388 -5.87159,-6.11905 -8.66565,-8.72571 -14.23934,-12.12999 -8.56955,-4.09858 -11.33478,-5.43194 -16.58414,-7.52688 -4.37006,-1.7538 -1.25889,-6.5515 1.52075,-8.74494 28.92555,-15.74568 51.85457,-33.24515 79.61012,-51.03773 1.42225,-0.94897 2.84691,-1.89794 4.26916,-2.84691 -3.32019,-18.97698 -6.64278,-37.95637 -9.96297,-56.93335 -15.41895,-5.45598 -30.84031,-10.91435 -46.25926,-16.37032 -2.42648,1.66009 -4.26916,3.32259 -6.40494,4.98269 z' style='font-size:12px;fill:%23ffffff;fill-rule:evenodd;stroke:%23000000;stroke-width:3.71638179;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' inkscape:connector-curvature='0'/%3E %3Cpath inkscape:export-ydpi='90.000000' inkscape:export-xdpi='90.000000' sodipodi:nodetypes='ccccc' id='path4414' d='m 367.18534,600.42835 c 0.14655,-0.58379 28.95437,-5.84997 28.95437,-5.84997 0,0 -3.36343,10.6765 -3.50998,10.6765 l -28.66128,8.62721 3.21689,-13.45374 z' style='font-size:12px;fill:%23f9dd16;fill-opacity:1;fill-rule:evenodd;stroke-width:1pt' inkscape:connector-curvature='0'/%3E %3Cpath sodipodi:nodetypes='cs' id='path4416' d='m 292.11345,491.95755 c 5.55688,-14.77028 20.98304,-26.46543 31.34482,-29.69193' style='font-size:12px;fill:none;stroke:%23000000;stroke-width:2.40245399pt' inkscape:connector-curvature='0'/%3E %3Cpath sodipodi:nodetypes='ccccccccccc' id='path4418' d='m 366.14988,600.68782 c 1.8595,-0.52374 10.11673,-2.9334 12.52159,-3.30818 2.56582,-0.60062 5.11963,-1.2733 7.58695,-2.06852 2.84691,-0.58139 4.62953,-1.11714 7.58695,-1.65529 2.31596,-0.8841 4.6055,-1.48952 7.08243,-2.06851 m -39.99365,26.91229 c 0.24025,-0.32193 2.20305,-2.0565 3.61329,-2.89496 1.6601,-0.52373 7.3371,-2.93339 9.48489,-3.30818 2.29194,-0.60061 4.57187,-1.2733 6.77492,-2.06851 2.5442,-0.58139 4.13462,-1.11714 6.77732,-1.65529 2.06852,-0.8841 4.11301,-1.48952 6.32326,-2.06851' style='font-size:12px;fill:none;stroke:%23000000;stroke-width:2.65663357pt' inkscape:connector-curvature='0'/%3E %3Cpath sodipodi:nodetypes='cccccc' id='path4420' d='m 372.6317,496.13782 c -0.13934,0 -0.27628,0 -0.41322,0 1.29492,0 0.49971,-0.10811 -1.24207,2.06852 -0.61983,1.6721 -5.92926,5.37669 -9.92694,5.37669 -1.92917,0.20661 -4.8938,0.41322 -6.82537,0.41322 -0.55016,0 -1.30934,-0.41322 -1.8619,-0.41322' style='font-size:12px;fill:none;stroke:%23000000;stroke-width:2.40245399pt' inkscape:connector-curvature='0'/%3E %3Cpath sodipodi:nodetypes='cccccccccc' id='path4422' d='m 372.21848,581.34806 c 0.13694,0 0.27388,0 0.41322,0 -0.55256,0 1.10273,0 1.65289,0 2.14539,0 4.29799,0.38199 6.20554,0.41322 2.06851,0 4.13702,0.5862 6.20554,0.5862 2.08773,0.2955 4.6031,0.19941 6.7629,0.50692 2.42168,0.0817 4.36526,0.55977 6.88544,0.55977 2.03247,0.0769 3.12799,0.41563 5.37909,0.41563 l -5.37909,-0.41563 c 2.03247,0.0769 3.12799,0.41563 5.37909,0.41563' style='font-size:12px;fill:none;stroke:%23000000;stroke-width:2.40245399pt' inkscape:connector-curvature='0'/%3E %3Cpath sodipodi:nodetypes='cccccc' id='path4424' d='m 358.15451,631.80921 c 0.22103,-0.32193 2.01806,-2.0565 3.30818,-2.89496 1.52076,-0.52374 6.71967,-2.9334 8.68728,-3.30818 2.09734,-0.60061 4.18507,-1.2733 6.20313,-2.06851 2.33038,-0.5814 3.78627,-1.11714 6.20554,-1.65529 1.89554,-0.88411 3.76705,-1.48953 5.78991,-2.06852' style='font-size:12px;fill:none;stroke:%23000000;stroke-width:2.40245399pt' inkscape:connector-curvature='0'/%3E %3Cpath sodipodi:nodetypes='ccccc' id='path4426' d='m 396.88928,559.91337 c -1.17,3.39707 0.34595,4.24994 0.97299,5.71544 1.09072,1.41985 3.87516,3.58446 8.27405,4.96347 1.69614,0.45646 3.00067,0.90332 4.96347,1.65529 1.29973,0.12012 1.93878,0.44445 2.89496,0.82644' style='font-size:12px;fill:none;stroke:%23000000;stroke-width:2.40245399pt' inkscape:connector-curvature='0'/%3E %3Cpath id='path4428' d='m 233.23651,435.33412 c 0.13694,0 0.27629,0 0.41323,0 -1.29733,0 -0.51893,0.0841 1.65529,-1.6553 1.34297,-1.50153 2.46492,-2.18142 3.7214,-3.7214' style='font-size:12px;fill:none;stroke:%23000000;stroke-width:2.40245399pt' inkscape:connector-curvature='0'/%3E %3Cpath sodipodi:nodetypes='ccccccc' id='path4430' d='m 260.01907,464.80021 c 0.27628,0 24.06298,-11.98824 26.60237,-14.54926 1.79944,-1.30453 3.16163,-2.68114 5.35027,-4.16345 1.40303,-0.73275 2.40966,-1.67211 3.7238,-2.48174 1.09312,-1.58321 2.52018,-2.53939 3.30818,-3.98807 1.46069,-1.26609 0.83365,-2.63789 2.01806,-4.16345 0.55978,-1.5616 1.60725,-4.19228 1.94839,-5.62174' style='font-size:12px;fill:none;stroke:%23000000;stroke-width:2.40245399pt' inkscape:connector-curvature='0'/%3E %3Cpath sodipodi:nodetypes='ccc' id='path4432' d='m 333.26509,447.62267 c 0.12973,0.85527 -0.37959,3.49076 -0.34355,5.49681 -0.0817,2.32558 -3.07274,9.50892 -6.68843,11.65431' style='font-size:12px;fill:none;stroke:%23000000;stroke-width:2.40245399pt' inkscape:connector-curvature='0'/%3E %3Cpath sodipodi:nodetypes='cccccccccccccccccc' id='path4434' d='m 290.53024,447.35599 c 0.13934,0 3.75984,1.17721 9.81162,3.03911 7.28424,2.61867 22.43412,12.16603 23.93805,13.48017 1.53517,1.20843 4.28117,2.28713 5.33345,3.7214 1.64568,1.42225 2.85171,3.06313 4.13702,4.55025 1.51115,1.84268 2.79886,3.40187 3.72141,4.96347 4.6007,3.73101 16.97574,29.5646 17.37214,31.02289 0.69431,1.36459 1.55439,3.26493 2.06851,4.55024 0.91774,1.05708 1.53998,2.55141 2.48174,4.13703 0.86488,2.0565 1.83307,2.99346 2.89736,4.55025 1.3694,0.95137 3.21448,2.75801 4.96347,3.7214 1.8643,1.59523 3.61329,2.24389 4.96347,3.31058 1.95079,0.82885 23.75066,14.60932 24.76209,15.29883 1.99164,1.60003 8.07225,7.90167 3.80309,12.48555 -1.81145,1.54958 -3.44272,3.60128 -4.9899,4.47818 -1.57601,1.57841 -3.76945,2.28473 -5.5809,3.10156 -9.82123,2.90217 -14.82314,1.86191 -16.75472,1.86191 -0.6895,0 -1.379,0 -2.06851,0' style='font-size:12px;fill:none;stroke:%23000000;stroke-width:2.40245399pt' inkscape:connector-curvature='0'/%3E %3Cpath sodipodi:nodetypes='ccccccccccc' id='path4436' d='m 242.38266,398.62222 c 2.79165,1.09311 1.6649,0.28589 4.17786,1.42946 1.68893,0.73995 2.80127,0.75917 4.46136,1.36459 1.761,0.56458 6.68123,1.45108 9.04524,3.82471 1.73457,1.5664 3.05832,2.89015 4.96347,4.03372 2.2535,1.55438 3.87996,2.24629 6.67402,3.41148 2.35681,0.8817 4.9923,1.8595 7.37553,1.94359 2.47693,0.14414 3.07034,0.0216 5.44636,0.0216 1.93158,0 3.86075,0 5.79232,0 l -5.79232,0 c 1.93158,0 3.86075,0 5.79232,0' style='font-size:12px;fill:none;stroke:%23000000;stroke-width:2.40245399pt' inkscape:connector-curvature='0'/%3E %3Cpath sodipodi:nodetypes='cccccccccccccc' id='path4438' d='m 241.71718,426.23362 c 6.20313,-0.41322 16.5433,1.44868 16.74991,1.44868 0.002,0 13.65074,-0.20661 13.65074,-0.20661 7.17133,-0.69191 8.75454,-3.44752 9.92694,-5.3791 2.68835,-4.13462 4.55025,-5.5833 6.61876,-8.68487 3.30818,-2.48173 7.86083,3.30818 8.06744,3.30818 11.57983,10.9624 2.27272,24.40413 1.65289,24.81735 -5.78991,5.30942 -7.03198,5.65298 -10.54677,2.27513 -3.5172,-4.13703 -4.55025,-5.99653 -7.44521,-7.44521 -5.5833,-2.68835 -17.16553,-0.61983 -17.37455,-0.61983 -0.20661,0 -5.99652,2.27512 -5.99652,2.27512 -2.82769,1.03306 -4.61992,3.51719 -9.51372,4.34124 -4.96347,0.34595 -6.61876,-0.13694 -9.10049,-4.13463 -3.30818,-5.17008 -1.6553,-11.37562 3.31058,-11.99545 z' style='font-size:12px;fill:%23ffe606;fill-rule:evenodd;stroke:%23000000;stroke-width:2.40245399pt' inkscape:connector-curvature='0'/%3E %3Cpath id='path4440' d='m 565.56641,175.3593 c -0.90893,0.17754 -9.09957,4.11011 -8.95592,4.36559 0.14364,0.25549 -7.02986,19.72306 -7.1735,19.46758 -0.14365,-0.25549 -5.14228,-16.90618 -5.65326,-16.61889 -0.50888,0.28611 -17.8281,2.3064 -18.08358,2.45004 -0.2534,0.14247 13.06825,-16.74311 13.06825,-16.74311 l -1.79543,-18.11539 14.14621,5.46889 c 0,0 15.02723,-11.46956 15.28272,-11.61321 0.25339,-0.14247 -3.95568,15.64642 -3.95568,15.64642 l 7.58272,10.50136 c 0,0 -4.23976,4.39573 -4.46253,5.19072 z' style='font-size:12px;fill:%23f9dd16;fill-opacity:0.98823499;fill-rule:evenodd;stroke:%23000000;stroke-width:2.40245457pt' inkscape:connector-curvature='0'/%3E %3Cpath sodipodi:nodetypes='ccccccccccccccccccccccccccc' id='path4442' d='m 395.73044,374.8114 c 10.43497,6.88298 73.83751,20.16833 83.33251,21.5411 12.02457,-1.13811 28.89576,0.3733 41.57125,4.57443 12.1158,5.27925 24.48123,5.04643 32.76029,-1.27306 11.24468,-6.1871 15.33479,-16.74134 20.39743,-26.16388 1.93317,-4.97857 2.0206,-10.26439 -0.0751,-14.65354 -3.73368,-9.32223 -1.49482,-11.59526 -2.28239,-16.86869 13.67598,-30.20677 16.50408,-65.38866 19.77662,-91.42198 -0.41193,-15.18899 1.18244,-26.80954 2.98454,-31.49668 7.25009,-11.15953 17.82755,-15.8029 23.16536,-17.83384 19.72104,-5.10154 39.44326,-10.20098 59.1643,-15.30251 15.31292,-5.58873 5.30778,-16.00146 2.13517,-15.08038 -10.23086,-1.48547 -9.83171,-12.51119 -57.72617,-1.01762 -10.25981,-1.30658 -20.5208,-2.61525 -30.78062,-3.92183 0,0 -5.97024,-4.80976 -6.59011,-4.46124 -16.63152,-3.06558 -19.07652,7.76264 -18.10559,14.2642 0.76175,4.74223 1.52142,9.48564 2.28317,14.22787 0,0 -5.97444,21.3208 -5.62593,21.94067 -15.21982,17.09288 -37.87596,71.98059 -39.32668,82.52817 -0.6867,9.9113 -4.42988,8.12142 -3.42621,17.75484 0.0376,7.52791 -0.83827,2.8278 1.67498,18.33746 0.61297,4.66878 -5.0938,4.30813 -8.36803,2.96016 -27.90111,-17.49692 -54.39214,-28.90732 -83.50407,-44.38123 -1.52422,-0.77467 -3.04962,-1.55143 -4.57384,-2.32609 -14.91456,12.19448 -29.83005,24.39223 -44.74461,36.58671 2.80078,16.1142 5.60064,32.23167 8.40142,48.34588 2.63625,1.30151 4.98848,2.09296 7.48226,3.14108 z' style='font-size:12px;fill:%23ffffff;fill-rule:evenodd;stroke:%23000000;stroke-width:3.71638179;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' inkscape:connector-curvature='0'/%3E %3Cpath sodipodi:nodetypes='ccccc' id='path4444' d='m 638.04917,194.1671 c -0.5807,0.15836 -19.28941,-22.37181 -19.28941,-22.37181 0,0 10.95481,-2.30058 11.02663,-2.17284 l 21.56661,20.75523 -13.30383,3.78942 z' style='font-size:12px;fill:%23f9dd16;fill-opacity:1;fill-rule:evenodd;stroke-width:1pt' inkscape:connector-curvature='0'/%3E %3Cpath sodipodi:nodetypes='cs' id='path4446' d='m 580.28966,312.76536 c -15.59823,2.39492 -33.35273,-5.32004 -41.24335,-12.77088' style='font-size:12px;fill:none;stroke:%23000000;stroke-width:2.40245457pt' inkscape:connector-curvature='0'/%3E %3Cpath sodipodi:nodetypes='ccccccccccc' id='path4448' d='m 638.7828,194.94252 c -1.36784,-1.36421 -7.51503,-7.38089 -9.02031,-9.29346 -1.78101,-1.94221 -3.61896,-3.83863 -5.52133,-5.5996 -1.90201,-2.19665 -3.24265,-3.48795 -5.16113,-5.80212 -1.90567,-1.58548 -3.55547,-3.28451 -5.27407,-5.15983 m 43.05908,21.67211 c -0.39836,-0.0516 -2.87229,-0.91248 -4.29429,-1.73083 -1.27011,-1.19039 -6.15277,-4.95794 -7.53206,-6.64645 -1.64679,-1.70347 -3.35051,-3.36115 -5.12336,-4.89177 -1.75367,-1.93278 -3.00011,-3.05655 -4.76435,-5.09639 -1.7844,-1.36978 -3.3141,-2.8552 -4.90201,-4.49807' style='font-size:12px;fill:none;stroke:%23000000;stroke-width:2.65663414pt' inkscape:connector-curvature='0'/%3E %3Cpath sodipodi:nodetypes='cccccc' id='path4450' d='m 544.47263,240.53096 c 0.0683,0.12146 0.1354,0.24083 0.20251,0.3602 -0.63462,-1.12875 -0.33914,-0.3826 2.41179,0.0689 1.76131,-0.27918 7.59257,2.53334 9.55178,6.01802 1.12556,1.58035 2.75858,4.06328 3.70521,5.74699 0.26963,0.47956 0.2815,1.34383 0.5523,1.82548' style='font-size:12px;fill:none;stroke:%23000000;stroke-width:2.40245457pt' inkscape:connector-curvature='0'/%3E %3Cpath sodipodi:nodetypes='cccccccccc' id='path4452' d='m 618.9507,199.13082 c -0.0671,-0.11937 -0.13422,-0.23874 -0.20251,-0.3602 0.2708,0.48166 -0.54043,-0.96122 -0.81006,-1.44078 -1.05143,-1.87008 -1.77341,-3.93366 -2.68105,-5.61172 -1.01375,-1.80307 -1.51653,-3.89343 -2.53028,-5.6965 -0.76558,-1.96465 -2.0821,-4.11013 -2.87253,-6.14349 -1.11563,-2.15094 -1.65142,-4.07942 -2.88652,-6.27619 -0.92908,-1.80934 -1.1707,-2.93029 -2.27393,-4.89251 l 2.27393,4.89251 c -0.92908,-1.80934 -1.1707,-2.93029 -2.27393,-4.89251' style='font-size:12px;fill:none;stroke:%23000000;stroke-width:2.40245457pt' inkscape:connector-curvature='0'/%3E %3Cpath sodipodi:nodetypes='cccccc' id='path4454' d='m 669.82893,186.65972 c -0.38894,-0.0349 -2.78162,-0.75123 -4.14475,-1.46488 -1.20183,-1.06893 -5.85018,-4.41974 -7.14117,-5.95118 -1.55142,-1.53385 -3.16095,-3.024 -4.84314,-4.39337 -1.64887,-1.7464 -2.82938,-2.7529 -4.48412,-4.59797 -1.69963,-1.21901 -3.14455,-2.55365 -4.64062,-4.03318' style='font-size:12px;fill:none;stroke:%23000000;stroke-width:2.40245457pt' inkscape:connector-curvature='0'/%3E %3Cpath sodipodi:nodetypes='ccccc' id='path4456' d='m 588.17582,188.13075 c 3.53454,-0.645 3.53502,-2.38439 4.50515,-3.64919 0.7031,-1.6466 1.22532,-5.13457 0.27153,-9.64481 -0.43336,-1.70218 -0.68318,-3.05831 -0.98965,-5.13776 -0.53227,-1.19181 -0.56275,-1.90781 -0.69839,-2.92849' style='font-size:12px;fill:none;stroke:%23000000;stroke-width:2.40245457pt' inkscape:connector-curvature='0'/%3E %3Cpath id='path4458' d='m 559.78723,391.83724 c -0.0671,-0.11936 -0.1354,-0.24082 -0.20251,-0.36019 0.6358,1.13084 0.32761,0.41113 -2.25411,-0.63164 -1.96702,-0.43476 -3.10952,-1.07952 -5.06766,-1.42005' style='font-size:12px;fill:none;stroke:%23000000;stroke-width:2.40245457pt' inkscape:connector-curvature='0'/%3E %3Cpath sodipodi:nodetypes='ccccccc' id='path4460' d='m 572.34631,354.05065 c -0.1354,-0.24083 -22.24277,-15.09982 -25.71966,-16.05822 -2.01901,-0.9292 -3.88655,-1.44193 -6.25127,-2.62324 -1.32632,-0.86388 -2.63847,-1.28097 -3.98824,-2.02969 -1.91577,-0.17692 -3.44863,-0.95225 -5.0976,-0.92915 -1.81948,-0.65276 -2.70794,0.56612 -4.61819,0.28136 -1.63554,0.27737 -4.442,0.65358 -5.85521,1.05677' style='font-size:12px;fill:none;stroke:%23000000;stroke-width:2.40245457pt' inkscape:connector-curvature='0'/%3E %3Cpath sodipodi:nodetypes='ccc' id='path4462' d='m 521.47624,298.62243 c 0.68194,-0.53224 3.22885,-1.37989 4.9598,-2.39444 2.06718,-1.06853 9.79458,-1.98176 13.43667,0.11852' style='font-size:12px;fill:none;stroke:%23000000;stroke-width:2.40245457pt' inkscape:connector-curvature='0'/%3E %3Cpath sodipodi:nodetypes='cccccccccccccccccc' id='path4464' d='m 542.18754,336.00401 c -0.0683,-0.12146 -0.8165,-3.85429 -2.15943,-10.04196 -1.28727,-7.63287 -0.38983,-25.51765 0.0186,-27.47264 0.30099,-1.9304 -0.10451,-4.85268 0.63,-6.47283 0.43321,-2.13153 1.27246,-3.98697 1.93883,-5.83616 0.86563,-2.2203 1.59365,-4.1069 2.50272,-5.67637 0.99749,-5.83883 17.45113,-29.28652 18.52801,-30.34674 0.84921,-1.27398 2.08417,-2.95502 2.95258,-4.03309 0.47166,-1.31802 1.46928,-2.59276 2.38988,-4.19076 1.36873,-1.76176 1.71095,-3.06489 2.54638,-4.75557 0.15816,-1.65992 0.82872,-4.15365 0.81132,-6.15033 0.47685,-2.40687 0.18512,-4.24932 0.45322,-5.949 -0.23357,-2.10667 1.0947,-27.86267 1.20004,-29.08223 0.41863,-2.52021 2.93159,-10.90887 9.01949,-9.43405 2.2385,0.81957 4.82637,1.23599 6.34899,2.15488 2.14824,0.60021 3.8389,2.16602 5.43868,3.34469 7.34299,7.13861 8.88758,12.00846 9.83422,13.69217 0.33792,0.60102 0.67583,1.20204 1.01375,1.80307' style='font-size:12px;fill:none;stroke:%23000000;stroke-width:2.40245457pt' inkscape:connector-curvature='0'/%3E %3Cpath id='path4466' d='m 523.19361,401.02311 c -0.0671,-0.11937 -0.13541,-0.24083 -0.20252,-0.3602 0.5475,0.97378 0.24424,0.48833 -0.45104,-1.64539 -0.18272,-1.83483 -0.74862,-4.3169 -1.03448,-6.06067 -0.37092,-1.81171 -1.21985,-3.87557 -0.98966,-5.13776 -0.64874,-1.84017 -0.24065,-3.35949 -0.0667,-5.1826 0.5153,-2.27965 0.74819,-3.92922 0.81133,-6.15034 0.25051,-2.7261 0.0491,-4.65792 0.20469,-7.23419 -0.71831,-2.12077 -0.86479,-3.89605 -1.95948,-6.01466 -0.97405,-2.02659 -1.71911,-3.9008 -2.88357,-5.97192 -0.94664,-1.6837 -1.8921,-3.36531 -2.83873,-5.04902 l 2.83873,5.04902 c -0.94664,-1.6837 -1.8921,-3.36531 -2.83873,-5.04902' style='font-size:12px;fill:none;stroke:%23000000;stroke-width:2.40245457pt' inkscape:connector-curvature='0'/%3E %3Cpath sodipodi:nodetypes='cccccccccccccc' id='path4468' d='m 547.69831,388.90489 c -3.40026,-5.2046 -6.84486,-15.13035 -6.94612,-15.31045 -0.001,-0.002 -6.87013,-11.79774 -6.87013,-11.79774 -4.11769,-5.91197 -7.2956,-5.94153 -9.55387,-6.01685 -4.92157,-0.31704 -7.09684,-1.23003 -10.81414,-1.51307 -3.78456,-1.66739 -0.96883,-8.47338 -1.07009,-8.65347 3.88053,-15.46636 20.15862,-13.9412 20.82259,-13.60342 7.46564,2.44485 8.37382,3.35916 7.15199,8.07835 -1.88241,5.09334 -2.99701,6.90515 -2.841,10.13858 0.39293,6.18435 7.87229,15.26653 7.97473,15.44873 0.10125,0.18009 4.92197,4.11201 4.92197,4.11201 2.2863,1.95854 5.33001,2.30334 8.44669,6.16529 2.73408,4.15698 3.12439,5.83651 0.85598,9.95899 -2.88534,5.41744 -9.1046,7.0179 -12.0786,2.99305 z' style='font-size:12px;fill:%23f9dd16;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.40245457pt' inkscape:connector-curvature='0'/%3E %3Cg transform='matrix(-1.107009,2.132209,-2.132209,-1.10701,906.73765,-15.62964)' id='g4470'%3E %3Cpath id='path4472' d='m 238.862,224.504 c 0.121,-0.366 0.365,-4.14 0.243,-4.14 -0.122,0 -5.722,-6.574 -5.6,-6.574 0.122,0 7.183,1.583 7.183,1.339 0,-0.243 2.8,-6.939 2.8,-7.061 0,-0.121 3.409,8.157 3.409,8.157 l 6.939,3.044 -4.87,4.017 c 0,0 1.096,7.792 1.096,7.914 0,0.121 -4.87,-4.627 -4.87,-4.627 l -5.357,0.609 c 0,0 -0.73,-2.435 -0.973,-2.678 z' style='fill:%23f9dd16;fill-opacity:0.98823499;fill-rule:evenodd;stroke:%23000000;stroke-width:1pt;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1' inkscape:connector-curvature='0'/%3E %3Cpath sodipodi:nodetypes='ccccccccccccccccccccccccccc' id='path4474' d='m 201.141,122.196 c -4.626,2.382 -22.38,22.676 -24.815,25.841 -2.04,4.595 -6.03,10.408 -10.14,14.15 -4.387,3.319 -6.825,7.853 -6.221,12.146 -0.049,5.342 2.946,8.979 5.332,12.738 1.412,1.717 3.312,2.827 5.332,2.962 4.144,0.547 4.512,1.823 6.586,2.613 8.17,11.124 20.358,19.327 29.136,25.825 5.595,2.949 9.486,5.898 10.819,7.508 2.57,4.907 2.097,9.692 1.745,12.043 -2.172,8.196 -4.345,16.392 -6.517,24.588 -1.096,6.696 4.723,5.19 5.036,3.851 2.626,-3.409 6.545,-1.015 12.145,-20.737 2.567,-3.456 5.135,-6.912 7.702,-10.368 0,0 2.963,-1.185 2.963,-1.481 4.505,-5.409 1.075,-8.505 -1.482,-9.479 -1.876,-0.691 -3.752,-1.383 -5.628,-2.074 0,0 -6.517,-6.517 -6.813,-6.517 -3.097,-9.009 -18.39,-28.426 -21.921,-31.104 -3.456,-2.271 -2.043,-3.264 -5.743,-4.865 -2.739,-1.522 -0.855,-0.881 -6.995,-3.133 -1.819,-0.73 -0.524,-2.727 0.633,-3.64 12.04,-6.554 21.584,-13.838 33.137,-21.244 0.592,-0.395 1.185,-0.79 1.777,-1.185 -1.382,-7.899 -2.765,-15.799 -4.147,-23.698 -6.418,-2.271 -12.837,-4.543 -19.255,-6.814 -1.01,0.691 -1.777,1.383 -2.666,2.074 z' style='fill:%23ffffff;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:1.54691064;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' inkscape:connector-curvature='0'/%3E %3Cpath sodipodi:nodetypes='ccccc' id='path4476' d='m 217.252,246.966 c 0.061,-0.243 12.052,-2.435 12.052,-2.435 0,0 -1.4,4.444 -1.461,4.444 l -11.93,3.591 1.339,-5.6 z' style='fill:%23f9dd16;fill-opacity:1;fill-rule:evenodd;stroke:none' inkscape:connector-curvature='0'/%3E %3Cpath sodipodi:nodetypes='cs' id='path4478' d='m 186.004,201.816 c 2.313,-6.148 8.734,-11.016 13.047,-12.359' style='fill:none;stroke:%23000000;stroke-width:1pt;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1' inkscape:connector-curvature='0'/%3E %3Cpath sodipodi:nodetypes='ccccccccccc' id='path4480' d='m 216.821,247.074 c 0.774,-0.218 4.211,-1.221 5.212,-1.377 1.068,-0.25 2.131,-0.53 3.158,-0.861 1.185,-0.242 1.927,-0.465 3.158,-0.689 0.964,-0.368 1.917,-0.62 2.948,-0.861 m -16.647,11.202 c 0.1,-0.134 0.917,-0.856 1.504,-1.205 0.691,-0.218 3.054,-1.221 3.948,-1.377 0.954,-0.25 1.903,-0.53 2.82,-0.861 1.059,-0.242 1.721,-0.465 2.821,-0.689 0.861,-0.368 1.712,-0.62 2.632,-0.861' style='font-size:12px;fill:none;stroke:%23000000;stroke-width:1.10579996pt' inkscape:connector-curvature='0'/%3E %3Cpath sodipodi:nodetypes='cccccc' id='path4482' d='m 219.519,203.556 c -0.058,0 -0.115,0 -0.172,0 0.539,0 0.208,-0.045 -0.517,0.861 -0.258,0.696 -2.468,2.238 -4.132,2.238 -0.803,0.086 -2.037,0.172 -2.841,0.172 -0.229,0 -0.545,-0.172 -0.775,-0.172' style='fill:none;stroke:%23000000;stroke-width:1pt;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1' inkscape:connector-curvature='0'/%3E %3Cpath sodipodi:nodetypes='cccccccccc' id='path4484' d='m 219.347,239.024 c 0.057,0 0.114,0 0.172,0 -0.23,0 0.459,0 0.688,0 0.893,0 1.789,0.159 2.583,0.172 0.861,0 1.722,0.244 2.583,0.244 0.869,0.123 1.916,0.083 2.815,0.211 1.008,0.034 1.817,0.233 2.866,0.233 0.846,0.032 1.302,0.173 2.239,0.173 l -2.239,-0.173 c 0.846,0.032 1.302,0.173 2.239,0.173' style='fill:none;stroke:%23000000;stroke-width:1pt;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1' inkscape:connector-curvature='0'/%3E %3Cpath sodipodi:nodetypes='cccccc' id='path4486' d='m 213.493,260.028 c 0.092,-0.134 0.84,-0.856 1.377,-1.205 0.633,-0.218 2.797,-1.221 3.616,-1.377 0.873,-0.25 1.742,-0.53 2.582,-0.861 0.97,-0.242 1.576,-0.465 2.583,-0.689 0.789,-0.368 1.568,-0.62 2.41,-0.861' style='fill:none;stroke:%23000000;stroke-width:1pt;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1' inkscape:connector-curvature='0'/%3E %3Cpath sodipodi:nodetypes='ccccc' id='path4488' d='m 229.616,230.102 c -0.487,1.414 0.144,1.769 0.405,2.379 0.454,0.591 1.613,1.492 3.444,2.066 0.706,0.19 1.249,0.376 2.066,0.689 0.541,0.05 0.807,0.185 1.205,0.344' style='fill:none;stroke:%23000000;stroke-width:1pt;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1' inkscape:connector-curvature='0'/%3E %3Cpath id='path4490' d='m 161.497,178.247 c 0.057,0 0.115,0 0.172,0 -0.54,0 -0.216,0.035 0.689,-0.689 0.559,-0.625 1.026,-0.908 1.549,-1.549' style='fill:none;stroke:%23000000;stroke-width:1pt;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1' inkscape:connector-curvature='0'/%3E %3Cpath sodipodi:nodetypes='ccccccc' id='path4492' d='m 172.645,190.512 c 0.115,0 10.016,-4.99 11.073,-6.056 0.749,-0.543 1.316,-1.116 2.227,-1.733 0.584,-0.305 1.003,-0.696 1.55,-1.033 0.455,-0.659 1.049,-1.057 1.377,-1.66 0.608,-0.527 0.347,-1.098 0.84,-1.733 0.233,-0.65 0.669,-1.745 0.811,-2.34' style='fill:none;stroke:%23000000;stroke-width:1pt;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1' inkscape:connector-curvature='0'/%3E %3Cpath sodipodi:nodetypes='ccc' id='path4494' d='m 203.133,183.362 c 0.054,0.356 -0.158,1.453 -0.143,2.288 -0.034,0.968 -1.279,3.958 -2.784,4.851' style='fill:none;stroke:%23000000;stroke-width:1pt;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1' inkscape:connector-curvature='0'/%3E %3Cpath sodipodi:nodetypes='cccccccccccccccccc' id='path4496' d='m 185.345,183.251 c 0.058,0 1.565,0.49 4.084,1.265 3.032,1.09 9.338,5.064 9.964,5.611 0.639,0.503 1.782,0.952 2.22,1.549 0.685,0.592 1.187,1.275 1.722,1.894 0.629,0.767 1.165,1.416 1.549,2.066 1.915,1.553 7.066,12.306 7.231,12.913 0.289,0.568 0.647,1.359 0.861,1.894 0.382,0.44 0.641,1.062 1.033,1.722 0.36,0.856 0.763,1.246 1.206,1.894 0.57,0.396 1.338,1.148 2.066,1.549 0.776,0.664 1.504,0.934 2.066,1.378 0.812,0.345 9.886,6.081 10.307,6.368 0.829,0.666 3.36,3.289 1.583,5.197 -0.754,0.645 -1.433,1.499 -2.077,1.864 -0.656,0.657 -1.569,0.951 -2.323,1.291 -4.088,1.208 -6.17,0.775 -6.974,0.775 -0.287,0 -0.574,0 -0.861,0' style='fill:none;stroke:%23000000;stroke-width:1pt;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1' inkscape:connector-curvature='0'/%3E %3Cpath id='path4498' d='m 165.629,163.096 c 0.057,0 0.115,0 0.172,0 -0.465,0 -0.227,-0.011 0.689,0.172 0.703,0.308 1.719,0.609 2.41,0.861 0.733,0.235 1.655,0.348 2.066,0.689 0.8,0.14 1.268,0.598 1.894,1.033 0.722,0.652 1.273,1.073 2.066,1.549 0.938,0.647 1.68,0.968 2.583,1.55 0.916,0.172 1.59,0.481 2.582,0.516 0.934,0.06 1.766,0.172 2.755,0.172 0.804,0 1.607,0 2.411,0 l -2.411,0 c 0.804,0 1.607,0 2.411,0' style='fill:none;stroke:%23000000;stroke-width:1pt;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1' inkscape:connector-curvature='0'/%3E %3Cpath id='path4500' d='m 221.241,142.952 c -0.115,0 -0.23,0 -0.345,0 0.637,0 0.458,-0.023 -0.516,0.172 -1.017,0.525 -2.371,0.922 -3.272,1.377 -1.028,0.34 -2.133,0.717 -3.099,1.206 -1.094,0.641 -2.102,1.162 -3.099,1.893 -0.991,0.531 -1.965,1.185 -2.927,1.722 -0.959,0.521 -1.751,1.024 -2.582,1.722 -0.694,0.385 -1.637,0.93 -2.411,1.549 -0.727,0.261 -1.252,0.779 -1.721,1.206 -0.911,0.807 -1.469,1.226 -2.411,2.066 -0.495,0.468 -1.153,1.018 -1.894,1.721 -0.778,0.519 -1.62,1.517 -2.238,2.066 -0.396,0.517 -0.976,1.132 -1.549,1.55 -0.441,0.555 -0.952,1.285 -1.55,1.722 -0.355,0.528 -0.976,1.216 -1.55,1.894 -0.465,0.569 -1.105,1.142 -1.549,1.721 -0.598,0.662 -1.056,1.329 -1.722,1.894 -0.119,0.398 -0.369,0.604 -0.516,0.861' style='fill:none;stroke:%23000000;stroke-width:1pt;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1' inkscape:connector-curvature='0'/%3E %3Cpath sodipodi:nodetypes='cccccccccccccc' id='path4502' d='m 165.027,174.459 c 2.582,-0.172 6.886,0.603 6.972,0.603 0.001,0 5.682,-0.086 5.682,-0.086 2.985,-0.288 3.644,-1.435 4.132,-2.239 1.119,-1.721 1.894,-2.324 2.755,-3.615 1.377,-1.033 3.272,1.377 3.358,1.377 4.82,4.563 0.946,10.158 0.688,10.33 -2.41,2.21 -2.927,2.353 -4.39,0.947 -1.464,-1.722 -1.894,-2.496 -3.099,-3.099 -2.324,-1.119 -7.145,-0.258 -7.232,-0.258 -0.086,0 -2.496,0.947 -2.496,0.947 -1.177,0.43 -1.923,1.464 -3.96,1.807 -2.066,0.144 -2.755,-0.057 -3.788,-1.721 -1.377,-2.152 -0.689,-4.735 1.378,-4.993 z' style='fill:%23f9dd16;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:1pt;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1' inkscape:connector-curvature='0'/%3E %3C/g%3E %3Cpath sodipodi:nodetypes='cccccccccc' id='path4504' d='m 332.30165,290.148 c -2.276,-2.067 42.811,16.337 49.014,16.546 8.481,-3.102 43.433,-32.676 43.433,-32.676 0.345,2.895 1.584,10.409 4.961,11.996 -13.51,10.962 -25.782,21.508 -39.293,32.468 0.966,17.373 -2.205,35.78 6.618,55.221 0,0 -10.546,0.205 -10.546,0 -9.307,-9.307 -12.618,-54.185 -12.618,-54.185 -14.821,-6.619 -29.644,-13.029 -44.465,-19.648 2.138,-1.38 3.861,-5.652 2.896,-9.722 z' style='font-size:12px;fill:%23f9dd16;fill-opacity:0.98742095;fill-rule:evenodd;stroke:%23000000;stroke-width:2.40244999pt' inkscape:connector-curvature='0'/%3E %3Cpath sodipodi:nodetypes='ccccccc' id='path4506' d='m 375.19865,336.153 c 0.721,-0.523 -8.133,4.113 -10.407,5.277 -40.961,21.85 -62.04,53.634 -63.354,54.835 -0.708,1.354 -2.011,3.16 -3.204,4.929 -0.96,1.483 -2.338,3.018 -3.246,4.518 -1.255,1.738 -3.893,5.17 -5.334,6.694 -0.18,0.982 0.683,-0.336 0.401,0.317' style='font-size:12px;fill:none;stroke:%23000000;stroke-width:2.40244999pt' inkscape:connector-curvature='0'/%3E %3Cpath sodipodi:nodetypes='ccccccc' id='path4508' d='m 403.18665,310.185 c -0.795,-0.402 7.378,5.351 9.453,6.84 38.166,26.431 76.072,30.638 77.741,31.257 1.528,0.01 3.73,0.343 5.848,0.595 1.759,0.175 3.753,0.698 5.503,0.82 2.119,0.32 6.378,1.096 8.393,1.681 0.954,-0.29 -0.611,-0.453 0.098,-0.502' style='font-size:12px;fill:none;stroke:%23000000;stroke-width:2.40244999pt' inkscape:connector-curvature='0'/%3E %3C/g%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 225 150'%3E %3Crect width='225' height='150' fill='%23f93'/%3E %3Crect width='225' height='50' y='50' fill='%23fff'/%3E %3Crect width='225' height='50' y='100' fill='%23128807'/%3E %3Cg transform='translate(112.5,75)'%3E %3Ccircle r='20' fill='%23008'/%3E %3Ccircle r='17.5' fill='%23fff'/%3E %3Ccircle r='3.5' fill='%23008'/%3E %3Cg id='d'%3E %3Cg id='c'%3E %3Cg id='b'%3E %3Cg id='a'%3E %3Ccircle r='0.875' fill='%23008' transform='rotate(7.5) translate(17.5)'/%3E %3Cpath fill='%23008' d='M 0,17.5 0.6,7 C 0.6,7 0,2 0,2 0,2 -0.6,7 -0.6,7 L 0,17.5 z'/%3E %3C/g%3E %3Cuse xlink:href='%23a' transform='rotate(15)'/%3E %3C/g%3E %3Cuse xlink:href='%23b' transform='rotate(30)'/%3E %3C/g%3E %3Cuse xlink:href='%23c' transform='rotate(60)'/%3E %3C/g%3E %3Cuse xlink:href='%23d' transform='rotate(120)'/%3E %3Cuse xlink:href='%23d' transform='rotate(-120)'/%3E %3C/g%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns:svg='http://www.w3.org/2000/svg' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 600 300'%3E %3Cdefs%3E %3CclipPath id='cp'%3E %3Cpath d='M0 0V75H350V150H300zM300 0H150V200H0V150z'/%3E %3C/clipPath%3E %3CclipPath id='cp2'%3E %3Crect width='300' height='150'/%3E %3C/clipPath%3E %3C/defs%3E %3Crect fill='%23FFF' width='600' height='300'/%3E %3Cpath id='wave' fill='%23002b7f' d='M600 260.881C593.277 264.926 587.501 274.379 569.64 274.379 533.929 274.379 524.999 254.477 498.213 254.477 480.357 254.477 471.428 274.379 453.572 274.379 417.857 274.379 408.929 254.477 382.143 254.477 364.286 254.477 355.357 274.379 337.5 274.379 301.786 274.379 292.857 254.477 266.072 254.477 248.214 254.477 239.286 274.379 221.429 274.379 185.715 274.379 176.786 254.477 150 254.477 132.142 254.477 123.214 274.379 105.357 274.379 69.643 274.379 60.714 254.477 33.929 254.477 16.071 254.477 10.714 268.659 0 268.659L0 294.28C10.714 294.28 16.071 280.099 33.929 280.099 60.714 280.099 69.643 300 105.357 300 123.214 300 132.142 280.099 150 280.099 176.785 280.099 185.715 300 221.429 300 239.286 300 248.214 280.099 266.072 280.099 292.857 280.099 301.786 300 337.5 300 355.357 300 364.286 280.099 382.143 280.099 408.929 280.099 417.857 300 453.572 300 471.428 300 480.357 280.099 498.213 280.099 524.999 280.099 533.929 300 569.64 300 587.501 300 593.277 294.36 600 290.316L600 260.881z'/%3E %3Cuse transform='translate(0,-49.75348)' xlink:href='%23wave'/%3E %3Cuse transform='translate(0,-99.50701)' xlink:href='%23wave'/%3E %3Cuse transform='translate(0,-149.26056)' xlink:href='%23wave'/%3E %3Cuse transform='translate(0,-199.01404)' xlink:href='%23wave'/%3E %3Cuse transform='translate(0,-248.76752)' xlink:href='%23wave'/%3E %3Crect fill='%23FFF' width='300' height='152'/%3E %3Cg clip-path='url(%23cp2)'%3E %3Crect width='300' height='150' fill='%2300247d'/%3E %3Cpath d='M0 0L300 150M300 0L0 150' stroke='%23fff' stroke-width='30'/%3E %3Cpath d='M0 0L300 150M300 0L0 150' stroke='%23cf142b' stroke-width='20' clip-path='url(%23cp)'/%3E %3Cpath d='M150 0V200M0 75H350' stroke='%23fff' stroke-width='50'/%3E %3Cpath d='M150 0V200M0 75H350' stroke='%23cf142b' stroke-width='30'/%3E %3C/g%3E %3Cg%3E %3Cg transform='matrix(0.604762,0,0,0.604762,0,-1.160721e-4)'%3E %3Cpath d='M814.961-301.181L797.244 407.48C797.244 444.778 877.341 444.778 885.827 407.48L868.11-301.181 814.961-301.181z' transform='matrix(0.200004,0,0,0.475,575.1662,274.5648)' style='fill:%23a24300;stroke-width:6.935;stroke:%23fff'/%3E %3Cg transform='matrix(0.725195,0,0,0.6231,202.0636,41.43416)'%3E %3Cg transform='matrix(-0.314512,0.10485,-0.138292,-0.303235,1046.472,373.319)'%3E %3Cg id='t3' style='fill:none;stroke-width:1;stroke:%23000'%3E %3Cpath d='M496.063 549.213L513.78 620.079 549.213 566.929 531.496 655.512 566.929 620.079 531.496 708.661 566.929 673.228 531.496 761.811 566.929 726.378 531.496 832.677 566.929 797.244 531.496 903.543 566.929 868.11 531.496 974.409 513.78 1027.56 496.063 1045.28 478.346 1027.56 460.63 974.409 425.197 868.11 460.63 903.543 425.197 797.244 460.63 832.677 425.197 726.378 460.63 761.811 425.197 673.228 460.63 708.661 425.197 620.079 460.63 655.512 442.913 566.929 478.346 620.079 496.063 549.213z' transform='translate(177.1655,-224.0517)' style='fill:%23006d00;stroke-width:8.25;stroke:%23fff'/%3E %3Cpath d='M496.063 549.213L496.063 1045.28' transform='translate(177.1655,-224.0517)'/%3E %3Cpath d='M425.197 868.11L496.063 974.409 566.929 868.11' transform='translate(177.1655,-224.0517)'/%3E %3Cpath d='M425.197 797.244L496.063 903.543 566.929 797.244' transform='translate(177.1655,-224.0517)'/%3E %3Cpath d='M425.197 726.378L496.063 832.677 566.929 726.378' transform='translate(177.1655,-224.0517)'/%3E %3Cpath d='M425.197 673.228L496.063 761.811 566.929 673.228' transform='translate(177.1655,-224.0517)'/%3E %3Cpath d='M425.197 620.079L496.063 708.661 566.929 620.079' transform='translate(177.1655,-224.0517)'/%3E %3Cpath d='M442.913 566.929L496.063 673.228 549.213 566.929' transform='translate(177.1655,-224.0517)'/%3E %3C/g%3E %3C/g%3E %3Cuse xlink:href='%23t3' transform='matrix(0.236516,-0.281856,0.294964,0.227618,354.5673,204.654)'/%3E %3Cuse xlink:href='%23t3' transform='matrix(0.15164,0.335243,-0.332899,0.167308,907.5388,-153.4696)'/%3E %3Cuse xlink:href='%23t3' transform='matrix(-0.209517,0.302465,-0.314697,-0.199448,1141.363,167.5798)'/%3E %3Cuse xlink:href='%23t3' transform='matrix(-0.207724,-0.258384,0.236176,-0.235153,689.9856,567.2772)'/%3E %3Cg transform='matrix(-0.362184,-9.947167e-2,-0.209809,0.317733,1222.415,-24.22945)'%3E %3Cg id='t2' style='fill:none;stroke-width:1;stroke:%23000'%3E %3Cpath d='M460.63 549.213L489.273 620.079 531.496 566.929 521.312 655.512 549.212 620.079 531.496 708.661 556.745 673.228 531.496 761.811 566.929 726.378 531.496 832.677 566.929 797.244 531.496 903.543 566.929 868.11 531.496 974.409 513.78 1027.56 496.063 1045.28 478.346 1027.56 460.63 974.409 425.197 868.11 460.63 903.543 425.197 797.244 460.63 832.677 425.197 726.378 460.63 761.811 415.013 673.228 460.63 708.661 407.48 620.079 450.446 655.512 425.196 566.929 460.629 620.079 460.63 549.213z' transform='translate(283.4647,-124.0162)' style='fill:%23006d00;stroke-width:8.25;stroke:%23fff'/%3E %3Cpath d='M467.208 584.646L496.063 708.662 496.063 1045.28' transform='translate(283.4647,-124.0162)'/%3E %3Cpath d='M436.23 885.827L496.063 974.409 556.745 885.827' transform='translate(283.4647,-124.0162)'/%3E %3Cpath d='M434.533 814.961L496.063 903.543 556.745 814.961' transform='translate(283.4647,-124.0162)'/%3E %3Cpath d='M435.381 744.095L496.063 832.677 555.896 744.095' transform='translate(283.4647,-124.0162)'/%3E %3Cpath d='M432.835 690.945L496.063 761.811 549.212 690.945' transform='translate(283.4647,-124.0162)'/%3E %3Cpath d='M425.197 637.796L496.063 708.661 541.469 637.796' transform='translate(283.4647,-124.0162)'/%3E %3Cpath d='M436.124 593.238L489.274 680.124 524.601 584.646' transform='translate(283.4647,-124.0162)'/%3E %3C/g%3E %3C/g%3E %3Cuse xlink:href='%23t2' transform='matrix(0.360878,0.10411,1.321056e-2,0.380525,452.7614,-239.2657)'/%3E %3Cg transform='matrix(4.613187e-2,-0.364743,0.326017,6.479648e-2,379.5799,479.5432)' style='fill:none;stroke-width:1;stroke:%23000'%3E %3Cpath d='M354.331 531.496L442.914 620.079 460.63 566.93 460.63 655.512 496.063 620.079 478.347 708.662 513.779 673.228 496.063 761.812 531.496 726.379 513.78 832.678 549.213 797.245 513.78 903.544 549.213 868.111 531.496 974.409 513.78 1027.56 496.063 1045.28 478.346 1027.56 460.63 974.409 407.48 892.115 442.914 903.544 407.481 797.245 442.914 832.678 389.764 726.379 425.197 761.812 372.047 673.228 425.197 708.662 354.331 620.079 407.48 655.512 336.614 584.646 407.48 620.079 354.331 531.496z' transform='translate(442.9136,-42.96583)' style='fill:%23006d00;stroke-width:8.25;stroke:%23fff'/%3E %3Cpath d='M378.962 560.015L442.914 655.512 460.63 708.662 469.489 753.867 478.347 832.678 487.662 903.544 496.063 1045.28' transform='translate(442.9136,-42.96583)'/%3E %3Cpath d='M425.197 903.544L488.862 974.41 539.611 885.827' transform='translate(442.9136,-42.96583)'/%3E %3Cpath d='M417.082 814.961L487.661 903.544 538.411 814.961' transform='translate(442.9136,-42.96583)'/%3E %3Cpath d='M407.48 752.443L478.347 832.678 524.295 744.095' transform='translate(442.9136,-42.96583)'/%3E %3Cpath d='M372.047 637.796L460.63 708.662 486.461 637.796' transform='translate(442.9136,-42.96583)'/%3E %3Cpath d='M360.618 602.363L442.914 655.512 453.429 602.363' transform='translate(442.9136,-42.96583)'/%3E %3Cpath d='M389.764 690.945L470.859 761.811 504.805 690.945' transform='translate(442.9136,-42.96583)'/%3E %3C/g%3E %3C/g%3E %3C/g%3E %3Cg transform='matrix(0.253333,0,0,0.253333,412,157.1807)'%3E %3Cpath d='M52.504 257.674L151.04 239.994 253.682 257.674 206.056 277.475 118.195 278.89 52.504 257.674z' style='fill:%239d9d9d;stroke-width:1.008;stroke:%23000'/%3E %3Cpath d='M151.789 98.445C134.566 104.432 115.487 90.02 84.43 113.539 84.43 113.539 30.286 90.376 26.173 143.91 26.008 146.077 34.743 159.133 35.959 158.2 42.763 152.976 32.729 163.272 32.729 164.76 32.729 166.26 33.727 167.093 34.064 167.754 34.395 168.421 35.227 169.419 35.393 172.248 35.558 175.076 29.256 182.792 31.919 185.62 34.576 188.449 34.741 196.604 34.741 198.931 34.741 201.257 36.407 207.747 37.57 209.082 38.733 210.41 40.729 213.735 40.729 216.563 40.729 219.392 41.892 227.21 41.39 229.2 40.894 231.196 44.384 233.694 47.55 234.692 50.709 235.69 91.485 236.398 148.712 235.4 205.945 234.402 225.04 243.457 248.686 234.857 252.341 233.529 253.008 230.535 252.678 228.869 252.341 227.21 252.678 221.89 253.676 220.555 254.674 219.227 261.329 208.58 259.994 206.584 261.25 205.45 270.583 211.974 264.639 206.148 263.115 204.655 265.492 188.932 266.312 185.62 267.139 182.302 268.408 176.071 269.933 174.914 271.465 173.757 267.335 169.426 267.628 168.644 267.926 167.856 269.039 165.415 270.59 164.303 270.59 164.303 273.475 150.776 271.696 144.127 269.929 137.472 263.426 107.544 222.834 113.539 222.834 113.539 168.494 92.639 151.789 98.445z' style='fill:%23c00;stroke-width:1.629;stroke:%23000'/%3E %3Cg transform='translate(0,-2.600445e-4)'%3E %3Cg transform='matrix(1.085779,0,0,1.085779,6.91471,26.11235)'%3E %3Cg transform='matrix(0.496967,-4.459677e-2,8.946727e-2,0.726775,44.70009,100.5425)' stroke-width='1.241'%3E %3Cg id='t4'%3E %3Cpath d='M49.75 0.125C44.657 1.015 34.594 29.37 37.141 38.875 38.904 45.455 41.639 49.995 43.188 52.781 39.783 48.096 31.805 39.031 20.938 39.031 7.274 39.031 5.507 68.979 5.844 70.906 5.845 70.913 5.842 70.932 5.844 70.938 5.845 70.942 5.873 70.965 5.875 70.969 5.877 70.968 5.904 70.97 5.906 70.969 6.519 70.254 12.048 57.875 25.563 57.875 34.459 57.875 41.392 64.91 43.938 67.906 43.937 68.851 43.96 69.764 43.969 70.688 41.965 73.516 40.687 80.219 34.5 88.656 27.023 98.852 4.128 99.897 0.281 100 1.252 100 37.806 100 49.813 100 49.86 100 49.922 100.003 49.969 100 49.991 100.002 50.009 99.999 50.031 100 50.078 100.003 50.14 100 50.188 100 62.194 100 98.748 100 99.719 100 95.872 99.897 72.539 98.852 65.063 88.656 58.875 80.219 58.035 73.516 56.031 70.688 56.04 69.764 56.063 68.851 56.063 67.906 58.608 64.91 65.541 57.875 74.438 57.875 87.952 57.875 93.481 70.254 94.094 70.969 94.096 70.97 94.123 70.968 94.125 70.969 94.127 70.965 94.155 70.942 94.156 70.938 94.158 70.932 94.155 70.913 94.156 70.906 94.493 68.979 92.726 39.031 79.063 39.031 68.195 39.031 60.217 48.096 56.813 52.781 58.361 49.995 61.103 44.206 62.531 38.875 65.118 29.219 55.091 0.132 50 0.125 49.92 0.125 49.831 0.111 49.75 0.125zM43.313 52.969C43.665 53.459 43.975 53.881 44.219 54.25 44.224 54.258 44.76 57.227 44.766 57.234 44.763 57.298 47.393 67.42 47.39 67.484 47.126 67.092 43.653 53.569 43.313 52.969zM56.688 52.969C56.347 53.569 52.655 67.092 52.391 67.484 52.388 67.42 55.784 54.345 55.781 54.281 55.781 54.271 55.344 57.245 55.344 57.234 55.588 56.865 56.335 53.459 56.688 52.969z' style='fill:%23f7d917;stroke-width:1.241;stroke:%23000'/%3E %3Cpath d='M42 67.578C42 67.578 46 65.719 50 65.719 54 65.719 58 67.578 58 67.578L58 72.531C58 72.531 54 70.672 50 70.672 46 70.672 42 72.531 42 72.531L42 67.578z' style='fill:%23f7d917;stroke-width:1.241;stroke:%23000'/%3E %3C/g%3E %3C/g%3E %3Cuse xlink:href='%23t4' transform='matrix(0.495379,5.970303e-2,-6.359282e-2,0.729495,168.9189,96.59048)'/%3E %3Cg style='fill:%23f7d917;stroke-width:0.715;stroke:%23000'%3E %3Cpath d='M24.308 134.56L33.998 122.746C33.998 122.746 34.901 123.914 33.998 122.746 14.132 97.065 13.127 82.331 15.363 74.87 17.599 67.409 22.072 59.326 33.998 49.377 45.924 39.429 54.154 44.958 65.334 44.958 76.515 44.958 79.497 47.445 89.186 48.689 98.876 49.932 124.964 51.176 124.964 51.176L124.964 44.336C124.964 44.336 125.993 44.528 124.964 44.336 113.446 42.189 98.876 44.336 89.186 41.849 79.497 39.362 71.297 38.741 60.862 38.741 50.427 38.741 42.942 35.698 36.234 40.051 29.525 44.403 21.326 51.864 15.363 58.082 9.4 64.3 6.419 76.735 7.164 84.818 7.91 92.901 10.891 99.741 15.363 105.958 19.836 112.176 19.09 117.15 20.581 121.502 22.072 125.855 24.308 135.181 24.308 134.56z'/%3E %3Cpath d='M239.255 134.56L229.565 122.746C229.565 122.746 228.661 123.914 229.565 122.746 249.43 97.065 250.435 82.331 248.199 74.87 245.963 67.409 241.491 59.326 229.565 49.377 217.639 39.429 209.409 44.958 198.228 44.958 187.047 44.958 184.066 47.445 174.376 48.689 164.686 49.932 138.598 51.176 138.598 51.176L138.598 44.336C138.598 44.336 137.569 44.528 138.598 44.336 150.117 42.189 164.686 44.336 174.376 41.849 184.066 39.362 192.265 38.741 202.7 38.741 213.136 38.741 220.62 35.698 227.329 40.051 234.037 44.403 242.236 51.864 248.199 58.082 254.162 64.3 257.144 76.735 256.398 84.818 255.653 92.901 252.671 99.741 248.199 105.958 243.727 112.176 244.472 117.15 242.982 121.502 241.491 125.855 239.255 135.181 239.255 134.56z'/%3E %3Crect width='34.563' height='70.894' x='115.553' y='38.701' style='stroke-width:0.835'/%3E %3C/g%3E %3Cg transform='translate(0,-8)' style='fill:%23f7d917;stroke-width:0.5;stroke:%23000'%3E %3Cpath d='M119.684-15.799C119.684-15.799 123.404-12.771 126.259-8.877 129.115-4.984 131.105-0.225 131.105-0.225 131.105-0.225 126.346-2.215 122.453-5.071 118.559-7.926 115.531-11.646 115.531-11.646L115.531 14.656C115.531 14.656 118.559 10.936 122.453 8.081 126.346 5.225 131.105 3.235 131.105 3.235 131.105 3.235 129.571 7.162 128.581 11.888 127.69 16.138 120.398 25.952 120.398 25.952L141.701 27.381C141.701 27.381 138.159 16.138 136.732 11.888 135.196 7.31 134.565 3.235 134.565 3.235 134.565 3.235 139.324 5.225 143.218 8.081 147.111 10.936 150.139 14.656 150.139 14.656L150.139-11.646C150.139-11.646 147.111-7.926 143.218-5.071 139.324-2.215 134.565-0.225 134.565-0.225 134.565-0.225 136.555-4.984 139.411-8.877 142.266-12.771 145.986-15.799 145.986-15.799L119.684-15.799z'/%3E %3Cpath d='M150 23.076A17.143 17.143 0 1 1 115.714 23.076 17.143 17.143 0 1 1 150 23.076z' transform='translate(-2.209282e-2,8)'/%3E %3Cpath d='M116.074 33.535L150.176 33.535C150.176 33.535 150.67 26.939 148.202 24.471 145.823 24.471 137.608 24.471 137.608 24.471L137.429 14.583 133.484 14.583 127.387 14.583 127.208 24.471C127.208 24.471 120.081 24.828 116.798 24.828 115.309 28.869 115.538 29.209 115.538 29.209L116.074 33.535z'/%3E %3C/g%3E %3Cg style='fill:%23f7d917;stroke-width:0.75;stroke:%23000'%3E %3Cpath d='M110.877 107.221C110.877 107.221 117.089 112.277 121.856 118.778 126.623 125.279 129.946 133.224 129.946 133.224 129.946 133.224 122 129.901 115.5 125.134 108.999 120.367 103.943 114.155 103.943 114.155L103.943 158.071C103.943 158.071 108.999 151.86 115.5 147.092 122 142.325 129.946 139.002 129.946 139.002 129.946 139.002 126.623 146.948 121.856 153.449 117.089 159.949 110.877 165.006 110.877 165.006L154.793 165.006C154.793 165.006 148.581 159.949 143.814 153.449 139.047 146.948 135.724 139.002 135.724 139.002 135.724 139.002 143.67 142.325 150.17 147.092 156.671 151.86 161.727 158.071 161.727 158.071L161.727 114.155C161.727 114.155 156.671 120.367 150.17 125.134 143.67 129.901 135.724 133.224 135.724 133.224 135.724 133.224 139.047 125.279 143.814 118.778 148.581 112.277 154.793 107.221 154.793 107.221L110.877 107.221z'/%3E %3Cpath d='M27.24 181.78L48.865 177.967C48.865 177.967 41.87 174.066 36.046 168.492 30.222 162.918 25.57 155.67 25.57 155.67 25.57 155.67 33.972 157.562 41.202 161.128 48.432 164.694 54.49 169.934 54.49 169.934L46.864 126.685C46.864 126.685 42.963 133.68 37.389 139.504 31.815 145.328 24.567 149.979 24.567 149.979 24.567 149.979 26.459 141.578 30.025 134.348 33.591 127.118 38.831 121.06 38.831 121.06L17.206 124.873 27.24 181.78z'/%3E %3Cpath d='M226.839 121.06C226.839 121.06 232.079 127.118 235.645 134.348 239.211 141.578 241.103 149.979 241.103 149.979 241.103 149.979 233.855 145.328 228.281 139.504 222.707 133.68 218.806 126.685 218.806 126.685L211.18 169.934C211.18 169.934 217.238 164.694 224.468 161.128 231.698 157.562 240.1 155.67 240.1 155.67 240.1 155.67 235.448 162.918 229.624 168.492 223.801 174.066 216.805 177.967 216.805 177.967L238.43 181.78 248.464 124.873 226.839 121.06z'/%3E %3Cpath d='M27.464 179.533L27.614 211.039C27.614 211.039 80.262 193.111 132.91 193.111 185.558 193.111 238.206 211.039 238.206 211.039L238.206 179.533C238.206 179.533 185.521 161.604 132.835 161.604 80.149 161.604 27.464 179.533 27.464 179.533z'/%3E %3C/g%3E %3Cg fill='%23FFF' store-width='1.5' stroke='%23000'%3E %3Cg transform='matrix(0.661234,0,0,0.661234,21.24618,-360.3206)'%3E %3Cpath id='c3' d='M2.02 723.052A12.122 12.122 0 1 1-22.223 723.052 12.122 12.122 0 1 1 2.02 723.052z'/%3E %3C/g%3E %3Cuse xlink:href='%23c3' transform='matrix(0.661234,0,0,0.661234,10.96519,-378.6019)'/%3E %3Cuse xlink:href='%23c3' transform='matrix(0.661234,0,0,0.661234,8.822333,-400.0304)'/%3E %3Cuse xlink:href='%23c3' transform='matrix(0.661234,0,0,0.661234,15.25091,-420.0304)'/%3E %3Cuse xlink:href='%23c3' transform='matrix(0.661234,0,0,0.661234,28.82233,-436.459)'/%3E %3Cuse xlink:href='%23c3' transform='matrix(0.661234,0,0,0.661234,47.39376,-447.8875)'/%3E %3Cuse xlink:href='%23c3' transform='matrix(0.661234,0,0,0.661234,68.10805,-446.459)'/%3E %3Cuse xlink:href='%23c3' transform='matrix(0.661234,0,0,0.661234,88.82233,-443.0304)'/%3E %3Cuse xlink:href='%23c3' transform='matrix(0.661234,0,0,0.661234,109.5366,-440.8875)'/%3E %3Cuse xlink:href='%23c3' transform='matrix(-0.661234,0,0,0.661234,242.3163,-360.3206)'/%3E %3Cuse xlink:href='%23c3' transform='matrix(-0.661234,0,0,0.661234,252.5973,-378.6019)'/%3E %3Cuse xlink:href='%23c3' transform='matrix(-0.661234,0,0,0.661234,254.7402,-400.0304)'/%3E %3Cuse xlink:href='%23c3' transform='matrix(-0.661234,0,0,0.661234,248.3116,-420.0304)'/%3E %3Cuse xlink:href='%23c3' transform='matrix(-0.661234,0,0,0.661234,234.7402,-436.459)'/%3E %3Cuse xlink:href='%23c3' transform='matrix(-0.661234,0,0,0.661234,216.1687,-447.8875)'/%3E %3Cuse xlink:href='%23c3' transform='matrix(-0.661234,0,0,0.661234,195.4544,-446.459)'/%3E %3Cuse xlink:href='%23c3' transform='matrix(-0.661234,0,0,0.661234,174.7402,-443.0304)'/%3E %3Cuse xlink:href='%23c3' transform='matrix(-0.661234,0,0,0.661234,154.0259,-440.8875)'/%3E %3Cg transform='translate(1.040326,0)'%3E %3Cuse xlink:href='%23c3' transform='matrix(0.661234,0,0,0.661234,138.4742,-378.3206)'/%3E %3Cuse xlink:href='%23c3' transform='matrix(0.661234,0,0,0.661234,138.4742,-392.6019)'/%3E %3Cuse xlink:href='%23c3' transform='matrix(0.661234,0,0,0.661234,138.4742,-404.0304)'/%3E %3Cuse xlink:href='%23c3' transform='matrix(0.661234,0,0,0.661234,138.4742,-414.459)'/%3E %3Cuse xlink:href='%23c3' transform='matrix(0.661234,0,0,0.661234,138.4742,-447.8875)'/%3E %3Cuse xlink:href='%23c3' transform='matrix(0.661234,0,0,0.661234,138.4742,-446.459)'/%3E %3Cuse xlink:href='%23c3' transform='matrix(0.661234,0,0,0.661234,138.4742,-439.0304)'/%3E %3Cuse xlink:href='%23c3' transform='matrix(0.661234,0,0,0.661234,138.4742,-428.8875)'/%3E %3C/g%3E %3C/g%3E %3Cg fill='%23FFF' stroke='%23000'%3E %3Cg transform='translate(-0.457137,-2)'%3E %3Cpath id='circle1' d='M143.571 136.291A10.357 10.357 0 1 1 122.857 136.291 10.357 10.357 0 1 1 143.571 136.291z'/%3E %3C/g%3E %3Cuse xlink:href='%23circle1' transform='translate(-108.7143,16.78571)'/%3E %3Cuse xlink:href='%23circle1' transform='translate(107.2857,16.78571)'/%3E %3C/g%3E %3C/g%3E %3Crect width='34.762' height='15.153' x='134.791' y='210.096' style='fill:%23002b7f;stroke-width:0.841;stroke:%23000'/%3E %3Cpath d='M16.043 233.111A22.995 8.556 0 1 1-29.947 233.111 22.995 8.556 0 1 1 16.043 233.111z' transform='matrix(-0.678154,-6.882792e-2,2.382547e-2,0.957698,195.4766,-0.830297)' style='fill:%233e8225;stroke-width:1.5;stroke:%23000'/%3E %3Cpath d='M36.937 229.285L28.228 237.994 38.329 243.826 61.822 237.532 57.635 224.228 36.937 229.285z' style='fill:%23c00;stroke-width:1.086;stroke:%23000'/%3E %3Cpath d='M267.406 229.285L276.116 237.994 266.014 243.826 242.521 237.532 246.708 224.228 267.406 229.285z' style='fill:%23c00;stroke-width:1.086;stroke:%23000'/%3E %3Cpath d='M16.043 233.111A22.995 8.556 0 1 1-29.947 233.111 22.995 8.556 0 1 1 16.043 233.111z' transform='matrix(0.678154,-6.882792e-2,-2.382547e-2,0.957698,108.8665,-0.830297)' style='fill:%233e8225;stroke-width:1.5;stroke:%23000'/%3E %3Cg fill='%23FFF' store-width='0.7' stroke='%23000'%3E %3Cg transform='translate(1.069518,-3.475935)'%3E %3Cpath id='c2' d='M126.203 214.704A4.278 4.278 0 1 1 117.647 214.704 4.278 4.278 0 1 1 126.203 214.704z'/%3E %3C/g%3E %3Cuse xlink:href='%23c2' transform='translate(2.406416,10.16042)'/%3E %3Cuse xlink:href='%23c2' transform='translate(-52.40642,6.149728)'/%3E %3Cuse xlink:href='%23c2' transform='translate(-47.05882,18.98396)'/%3E %3Cuse xlink:href='%23c2' transform='matrix(-1,0,0,1,303.0748,-3.475943)'/%3E %3Cuse xlink:href='%23c2' transform='matrix(-1,0,0,1,301.7379,10.16041)'/%3E %3Cuse xlink:href='%23c2' transform='matrix(-1,0,0,1,356.5507,6.14972)'/%3E %3Cuse xlink:href='%23c2' transform='matrix(-1,0,0,1,351.2031,18.98395)'/%3E %3C/g%3E %3C/g%3E %3Cg transform='translate(0,-2.600445e-4)'%3E %3Cpath d='M238.538 280.603C241.805 280.036 261.515 275.35 265.665 272.843 262.987 268.015 258.181 264.238 261.921 265.825 263.935 266.68 265.528 260.026 259.682 254.94 242.709 260.507 202.002 270.679 150.853 270.679 98.509 270.679 57.291 259.972 40.318 254.406 34.472 259.492 36.293 265.27 35.94 267.429 35.937 267.446 35.943 270.154 37.009 272.308 42.763 278.559 61.403 281.64 64.671 282.208 80.023 284.874 95.376 288.905 150.819 288.905 202.108 288.905 223.185 283.27 238.538 280.603z' style='fill:%23fff;stroke-width:1.714;stroke:%23000'/%3E %3Cg transform='matrix(1.085779,0,0,1.085779,-81.34112,-69.11104)'%3E %3Cpath d='M132.906 289.655C129.897 290.178 110.759 296.956 106.938 299.265 106.941 299.279 106.935 299.31 106.938 299.326 107.263 301.314 103.616 310.577 109 315.261 124.632 310.134 168.525 294.855 215.634 294.855 263.843 294.855 303.774 310.134 319.406 315.261 324.79 310.577 321.143 301.314 321.469 299.326 321.472 299.31 321.465 299.279 321.469 299.265 317.647 296.956 298.509 290.178 295.5 289.655 281.36 287.2 266.728 278.069 215.665 278.069 168.428 278.069 147.046 287.2 132.906 289.655z' style='fill:%23fff;stroke-width:1.578;stroke:%23000'/%3E %3Cg transform='matrix(1.384389,-0.143242,0.15642,1.267764,-86.62648,-64.7552)'%3E %3Cg id='t1' fill='%23000' store-width='1.6' stroke='%23000'%3E %3Cg transform='matrix(0.4996,0,0,0.4996,56.86367,150.9007)'%3E %3Cpath id='a1' d='M115.508 301.56A1.872 1.872 0 1 1 111.765 301.56 1.872 1.872 0 1 1 115.508 301.56z'/%3E %3C/g%3E %3Cuse xlink:href='%23a1' transform='matrix(0.4996,0,0,0.4996,55.52674,153.307)'/%3E %3Cuse xlink:href='%23a1' transform='matrix(0.4996,0,0,0.4996,57.3984,154.9114)'/%3E %3Cpath stroke-width='1' d='M113.518 303.669L122.044 300.503 117.859 302.895 120.545 302.812 118.053 303.98 122.054 304.255 113.518 303.669z'/%3E %3C/g%3E %3C/g%3E %3Cuse xlink:href='%23t1' transform='matrix(1.384389,-0.143242,0.15642,1.267764,-45.03159,-76.65847)'/%3E %3Cuse xlink:href='%23t1' transform='matrix(1.378425,0.192343,-0.151629,1.268346,100.1696,-120.8592)'/%3E %3Cuse xlink:href='%23t1' transform='matrix(1.384389,0.143242,0.15642,-1.267764,54.4337,659.4577)'/%3E %3Cuse xlink:href='%23t1' transform='matrix(1.384389,0.143242,0.15642,-1.267764,96.41226,670.4203)'/%3E %3C/g%3E %3C/g%3E %3C/g%3E %3C/g%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns:dc='http://purl.org/dc/elements/1.1/' xmlns:cc='http://creativecommons.org/ns%23' xmlns:rdf='http://www.w3.org/1999/02/22-rdf-syntax-ns%23' xmlns:svg='http://www.w3.org/2000/svg' xmlns='http://www.w3.org/2000/svg' xmlns:sodipodi='http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd' xmlns:inkscape='http://www.inkscape.org/namespaces/inkscape' id='Layer_1' x='0px' y='0px' width='411px' height='274px' viewBox='79.461 52.641 411 274' enable-background='new 79.461 52.641 411 274' xml:space='preserve' inkscape:version='0.48.1 ' sodipodi:docname='Flag of Iraq.svg'%3E%3Cdefs id='defs32'/%3E%3Csodipodi:namedview pagecolor='%23ffffff' bordercolor='%23666666' borderopacity='1' objecttolerance='10' gridtolerance='10' guidetolerance='10' inkscape:pageopacity='0' inkscape:pageshadow='2' inkscape:window-width='1440' inkscape:window-height='838' id='namedview30' showgrid='false' inkscape:zoom='0.95255474' inkscape:cx='205.5' inkscape:cy='137' inkscape:window-x='-8' inkscape:window-y='-8' inkscape:window-maximized='1' inkscape:current-layer='Layer_1'/%3E %3Crect id='rect7_1_' x='79.501' y='139.356' fill='%23FFFFFF' width='410.998' height='101.287'/%3E %3Crect id='rect3' x='79.5' y='53' fill='%23CF2029' width='410.998' height='91.288' style='fill:%23ce1126;fill-opacity:1'/%3E %3Crect id='rect7' x='79.5' y='235.713' fill='%23020202' width='410.998' height='91.287' style='fill:%23000000;fill-opacity:1'/%3E %3Cg id='g6' style='fill:%23007a3d;fill-opacity:1'%3E %3Cg id='g8' style='fill:%23007a3d;fill-opacity:1'%3E %3Cg id='g10' style='fill:%23007a3d;fill-opacity:1'%3E %3Cpath fill='%23119B4A' d='M325.525,173.177c-0.558-0.294-1.186-0.767-1.395-1.053c-0.314-0.439-0.131-0.456,1.163-0.105 c2.319,0.629,3.815,0.384,5.298-0.872l1.308-1.103l1.54,0.784c0.848,0.428,1.748,0.724,2.008,0.656 c0.667-0.176,2.05-1.95,2.005-2.564c-0.054-0.759,0.587-0.569,0.896,0.263c0.615,1.631-0.281,3.503-1.865,3.918 c-0.774,0.202-1.488,0.127-2.659-0.28c-1.439-0.502-1.684-0.495-2.406,0.057C329.801,174.118,327.549,174.234,325.525,173.177z' id='path12' style='fill:%23007a3d;fill-opacity:1'/%3E %3Cpath fill='%23119B4A' d='M331.258,167.935c-0.563-0.716-1.239-3.423-1.02-4.088c0.192-0.575,0.39-0.69,0.914-0.526 c0.918,0.287,1.13,0.92,0.993,3.063C332.038,168.132,331.779,168.591,331.258,167.935z' id='path14' style='fill:%23007a3d;fill-opacity:1'/%3E %3C/g%3E %3Cpath fill='%23119B4A' d='M263.743,165.991c-0.185,1.31,2.325,4.567,3.458,5.157c-0.77,0.345-1.728,0.189-2.434,0.577 c-3.948,3.948-18.367,18.005-21,21.366c7.799,0.154,16.449-0.106,23.761-0.44c-0.007-5.299,5.018-5.573,8.381-7.503 c1.73,2.725,6.075,2.516,6.618,6.618c0,4.91,0.009,12.306,0.009,17.646c-22.059,0-44.566,0-66.625,0 c-1.172,5.176-5.844,9.125-12.354,7.5c2.014-2.103,5.406-2.827,6.619-5.734c1.025-6.365-2.045-10.296-4.031-13.907 c3.284-1.195,3.782-1.493,7.121-3.737c-2.343,7.12,6.091,6.338,12.353,6.175c0.211-2.417,0.089-5.271-1.766-5.624 c2.396-0.87,2.794-1.168,6.619-4.412c0,2.942,0,6.652,0,9.592c14.886,0,30.943-0.111,46.139-0.111 c0-3.002,0.795-7.824-1.581-7.824c-2.269,0-0.107,6.173-1.87,6.173s-23.719,0-35.63,0c0-1.328-0.034-4.104-0.034-6.104 c1.51-1.511,1.331-1.38,11.648-11.698C250.172,178.672,257.41,172.134,263.743,165.991z' id='path16' style='fill:%23007a3d;fill-opacity:1'/%3E %3Cpath fill='%23119B4A' d='M352.803,165.737c2.488,1.338,4.457,3.191,7.502,3.971c-0.353,1.26-1.475,1.759-1.769,3.087 c0,8.97,0,17.941,0,26.91c3.402,0.75,4.118-1.178,5.737-2.205c0.442,4.307,3.185,8.53,3.088,11.91c-4.851,0-9.706,0-14.559,0 C352.803,194.855,352.803,180.296,352.803,165.737z' id='path18' style='fill:%23007a3d;fill-opacity:1'/%3E %3Cpath fill='%23119B4A' d='M333.391,180.149c0,0,5.296-4.471,5.296-4.643c0,7.646,0,15.837,0,23.485l3.814-0.006 c0-8.948-0.118-18.023-0.118-26.338c1.548-1.549,4.58-3.792,5.338-5.359c0,15.987,0,29.519,0,42.059 c-10.746,0-30.793,0.013-33.443,0.013c-0.493-8.73-0.577-17.771,9.599-15.827c0-1.488,0-2.369,0-3.562 c-0.31-0.609-0.868,0.147-0.998-0.645c1.616-1.617,2.163-2.029,6.538-5.851c0,4.612,0.081,15.499,0.081,15.499 c1.07,0,3.153,0.004,3.857,0.004C333.356,198.979,333.391,180.75,333.391,180.149z M320.837,198.751 c0.716,1.075,3.155,1.056,3.04-0.755C323.466,196.503,320.262,197.072,320.837,198.751z' id='path20' style='fill:%23007a3d;fill-opacity:1'/%3E %3Ccircle fill='%23119B4A' cx='224.026' cy='214.369' r='2.042' id='circle22' style='fill:%23007a3d;fill-opacity:1'/%3E %3Cpath fill='%23119B4A' d='M341.175,199.295' id='path24' style='fill:%23007a3d;fill-opacity:1'/%3E %3Cpath fill='%23119B4A' d='M329.451,199.295' id='path26' style='fill:%23007a3d;fill-opacity:1'/%3E %3Cpath fill='%23119B4A' d='M287.048,165.779c2.488,1.339,4.457,3.191,7.502,3.971c-0.353,1.26-1.476,1.759-1.768,3.087 c0,8.97,0,17.94,0,26.911c3.401,0.749,4.117-1.179,5.736-2.206c0.441,4.307,3.185,8.529,3.088,11.91c-4.851,0-9.706,0-14.559,0 C287.048,194.897,287.048,180.338,287.048,165.779z' id='path28' style='fill:%23007a3d;fill-opacity:1'/%3E %3C/g%3E %3C/g%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 630 360'%3E %3Crect width='630' height='360' fill='%23da0000'/%3E %3Crect width='630' height='240' fill='%23fff'/%3E %3Crect width='630' height='120' fill='%23239f40'/%3E %3Cg transform='translate(8.4,100.4)'%3E %3Cg id='tb4'%3E %3Cg id='tb1' fill='none' stroke='%23fff' stroke-width='2'%3E %3Cpath id='tbp1' d='M0,1H26M1,10V5H9V9H17V5H12M4,9H6M26,9H21V5H29M29,0V9H37V0M33,0V9' transform='scale(1.4)'/%3E %3Cpath id='tbp2' d='M0,7H9M10,7H19' transform='scale(2.8)'/%3E %3Cuse xlink:href='%23tbp2' y='120'/%3E %3Cuse xlink:href='%23tbp1' y='145.2'/%3E %3C/g%3E %3Cg id='tb3'%3E %3Cuse xlink:href='%23tb1' x='56'/%3E %3Cuse xlink:href='%23tb1' x='112'/%3E %3Cuse xlink:href='%23tb1' x='168'/%3E %3C/g%3E %3C/g%3E %3Cuse xlink:href='%23tb3' x='168'/%3E %3Cuse xlink:href='%23tb4' x='392'/%3E %3C/g%3E %3Cg fill='%23da0000' transform='matrix(45,0,0,45,315,180)'%3E %3Cg id='emblem_half'%3E %3Cpath d='M-0.54815,0.83638A0.912046,0.912046 0 0,0 0.328544,-0.722384A1,1 0 0,1 -0.54815,0.83638'/%3E %3Cpath d='M0.618339,0.661409A0.763932,0.763932 0 0,0 0.421644,-0.741049A1,1 0 0,1 0.618339,0.661409'/%3E %3Cpath d='M0,1 -0.05,0 0,-0.787278A0.309995,0.309995 0 0,0 0.118034,-0.688191V-0.100406L0.077809,0.892905z'/%3E %3Cpath d='M-0.02,-0.85 0,-0.831217A0.14431,0.14431 0 0,0 0.252075,-0.967708A0.136408,0.136408 0 0,1 0,-0.924634'/%3E %3C/g%3E %3Cuse xlink:href='%23emblem_half' transform='scale(-1,1)'/%3E %3C/g%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 2500 1800'%3E %3Cpath d='M0,0H2500V1800H0' fill='%23003897'/%3E %3Cpath d='M700,0h400V1800h-400M0,700H2500v400H0' fill='%23fff'/%3E %3Cpath d='M800,0h200V1800h-200M0,800H2500v200H0' fill='%23d72828'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 3 2'%3E %3Crect width='1' height='2' fill='%23009246'/%3E %3Crect width='1' height='2' x='1' fill='%23fff'/%3E %3Crect width='1' height='2' x='2' fill='%23ce2b37'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 30 18'%3E %3Crect width='30' height='18' fill='%23fff'/%3E %3Cpath d='M0,0 30,18M0,18 30,0' stroke='%23df112d' stroke-width='2'/%3E %3Cg stroke='%23000' stroke-width='0.0153'%3E %3Cpath fill='%23e8112d' d='M16.5698,2.69297c0.3855,1.56106,0.1741,3.48906-1.5673,4.55878-1.7415-1.06972-1.9529-2.99772-1.5673-4.55878,0.410478-0.373168,2.2762-0.60328,3.13453,0z'/%3E %3Cpath fill='%23f9dd16' d='m15,2.37955c0.638439,0,1.23302,0.16898,1.58351,0.388048,0.06878-0.538251,0.312867-1.07649,0.600812-1.4833-0.300406-0.00627-0.435033,0.15333-0.438087,0.319183-0.07513-0.212788-0.369307-0.200279-0.460077-0.08449,0.328627,0.222183,0.07513,0.616473-0.222097,0.535123-0.139636-0.038201-0.213424-0.135568-0.239567-0.276926a0.161537,0.161537 0 1,0 -0.068908,-0.010714c-0.09395,0.153343-0.262412,0.199375-0.383112,0.165584-0.156495-0.043809-0.22222-0.184629-0.22222-0.3098,0-0.32545,0.312867-0.375514,0.406812-0.319183-0.0061-0.21905-0.3504-0.394295-0.4568-0.21279,0.1189-0.212791,0.1127-0.513211-0.1002-0.713486-0.2127,0.200275-0.219,0.500695-0.1,0.713486-0.106406-0.181501-0.45067-0.00625-0.4569,0.2128,0.09382-0.056331,0.406812-0.00627,0.406812,0.319183,0,0.125171-0.06572,0.265992-0.22222,0.3098-0.120699,0.033791-0.289166-0.012241-0.383234-0.165584a0.161537,0.161537 0 1,0 -0.068908,0.010714c-0.0262,0.14136-0.1001,0.23872-0.2396,0.27692-0.2972,0.08135-0.5507-0.31294-0.2222-0.53512-0.0907-0.11579-0.3848-0.1283-0.46,0.08449-0.0032-0.16585-0.1377-0.32545-0.4381-0.31918,0.287823,0.406812,0.53191,0.945051,0.600812,1.4833,0.350494-0.219068,0.945075-0.388048,1.58339-0.388048z'/%3E %3Cg id='leopard'%3E %3Cg fill='%23f9dd16'%3E %3Cpath d='m16.3243,3.91058c-0.03848,0.00917-0.03848,0.058762-0.05864,0.058762,0.100054-0.00276,0.148676-0.030297,0.178973-0.080801-0.02199,0.020194-0.0028,0.058762-0.01014,0.067937,0.07342-0.025704,0.108361-0.088131,0.08271-0.130363,0.01649,0.023859,0.06426,0.036723,0.07892,0.038556-0.05143-0.0404-0.01466-0.132208-0.09737-0.179938,0.02761-0.00184,0.08087,0.029369,0.09553,0.066104-0.01283-0.082633-0.02578-0.135885-0.0937-0.181783,0.0073,0.00826,0.04593,0.015601,0.06243,0-0.04398-0.027548-0.05693-0.073446-0.05314-0.102827,0.0051-0.041109-0.02211-0.049587-0.07354-0.036723-0.0463,0.011569-0.15234,0.018362-0.214767,0.018362-0.128519,0-0.240545,0-0.347073-0.073446,0.159793,0.066092,0.363565-0.073446,0.363565-0.189125,0-0.128543-0.15796-0.233202-0.477424-0.163421-0.319464,0.069769-0.708684,0.040388-0.708684-0.066104,0-0.106504,0.279027-0.121189,0.422327-0.09915,0.143179,0.022027,0.24592,0.036723,0.514074-0.058762-0.06609,0.025704-0.279149,0.033046-0.447982-0.014684-0.168956-0.047742-0.583953-0.047742-0.587618,0.176273-0.0037,0.224003,0.441874,0.203602,0.82633,0.146892,0.22393-0.033058,0.341454-0.011019,0.341454,0.062427,0,0.069769-0.205606,0.09915-0.363566,0.080788-0.157838-0.018349-0.319464-0.014684-0.506744,0.0404-0.156372,0.045983-0.264367,0-0.436987,0.029381-0.08368,0.01422-0.286479,0-0.386533-0.165266-0.06157,0.044078-0.24702,0.136337-0.278172,0.226312-0.0441,0.082621-0.01466,0.164802,0.04398,0.24559,0.07403,0.101679-0.03665,0.086298-0.115569,0.089975-0.108239,0.00503-0.253128-0.011496-0.328749-0.097317-0.06695-0.076048-0.156128-0.136997-0.22735-0.08063-0.03665,0.029014-0.0015,0.067204,0.02749,0.056514,0.02871-0.010567,0.06267,0.01069,0.09333,0.024116-0.04899-0.021061-0.102864-0.00472-0.123876,0.014061-0.02895,0.02596,0.0062,0.075547,0.04129,0.058029,0.02749-0.013744,0.08393-0.022906,0.120577,0.010689-0.0397-0.00764-0.081-0.00602-0.100786,0.015271-0.01979,0.021294-0.0045,0.052299,0.03824,0.050393,0.06866-0.00305,0.08625,0.045055,0.155029,0.035172-0.04227,0.00551-0.06621,0.027536-0.07721,0.044065,0.06426-0.029381,0.135238,0.049819,0.218555,0.031213-0.0325,0.013377-0.08491,0.045324-0.08442,0.069781,0.04948-0.056929,0.381891,0.044065,0.389221-0.080788,0.0092,0.025704,0.0073,0.064259-0.01832,0.097317,0.04251-0.025716,0.17995-0.03489,0.222097-0.134053,0.0037,0.029381-0.0018,0.067949-0.02749,0.077123,0.0441,0.014416,0.102131-0.018423,0.161503-0.106492,0.02358-0.034939,0.0292-0.058163,0.02517-0.084429,0.05888,0.00222,0.101519-0.012559,0.147454-0.051456,0.04777-0.040388,0.0992,0.033058,0.17995-0.018362,0.08087-0.051407,0.150631-0.00734,0.19461-0.033046,0.0441-0.025704,0.104697,0.00917,0.152463-0.020194,0.04777-0.029381,0.1218,0.014379,0.200841-0.048048,0.124365,0.045556,0.269498,0.129972,0.625489,0.064565,0.204017-0.037493,0.268032,0.031213,0.268032,0.124866,0,0.064259-0.03763,0.069854-0.06609,0.071614-0.113493,0.00698-0.162237-0.042489-0.207072-0.026632-0.03005,0.010702-0.04838,0.059568-0.0049,0.076366-0.03592,0.018325-0.03128,0.05269-0.01295,0.065285,0.01832,0.012595,0.0656,0.00115,0.09773-0.013744-0.04129,0.018704-0.08405,0.052299-0.05962,0.087422,0.01478,0.021318,0.05216,0.039386,0.0871-0.0061,0.03506-0.045824,0.0992-0.084001,0.140002-0.077942z'/%3E %3Cpath d='m14.0632,2.94108c-0.102864-0.04222-0.137559-0.043381-0.113859,0.0404,0.01014,0.035807,0.03482,0.086298,0.05962,0.109253,0.000978-0.034878,0.0138-0.131279,0.05424-0.149653z'/%3E %3Cpath d='m14.3845,2.94108c0.102864-0.04222,0.137559-0.043381,0.113859,0.0404-0.01014,0.035807-0.03494,0.086298-0.05974,0.109253-0.000855-0.034878-0.01368-0.131279-0.05412-0.149653z'/%3E %3Cpath d='m14.2243,2.88464c0.19461,0,0.218921,0.091343,0.217944,0.205178-0.000855,0.123021-0.06695,0.080788-0.104574,0.2387-0.01466,0.061743-0.06389,0.065188-0.11337,0.065188-0.0496,0-0.09871-0.00345-0.113492-0.065188-0.0374-0.15792-0.1036-0.11569-0.1045-0.23871-0.0009-0.11383,0.0234-0.20517,0.2181-0.20517z'/%3E %3Cpath d='m13.7226,3.33585c-0.0496-0.029381-0.08161-0.00905-0.101765-0.00353,0.06426,0.016517,0.06682,0.099015,0.213791,0.137571-0.03311-0.00917-0.05143,0.00919-0.08271-0.00734,0.06059,0.047742,0.128519,0.103022,0.271819,0.10466,0.0799,0.0009162,0.02468,0.042233-0.02761,0.018361,0.05424,0.056001,0.161625,0.010103,0.22955,0.112014,0.01283-0.078956-0.126686-0.203822-0.06243-0.293784-0.198153-0.00844-0.214401-0.118269-0.328626-0.205654-0.09297-0.071052-0.101276-0.143276-0.142324-0.278502-0.01869-0.06123-0.0904-0.099406-0.130106-0.084905-0.03469,0.012681-0.0474,0.04277-0.01759,0.065285,0.02981,0.022527,0.06792,0.025582,0.07611,0.082657-0.03873-0.046386-0.09675-0.063184-0.124609-0.03417-0.01698,0.017665-0.01014,0.058884,0.02639,0.062622,0.0595,0.00611,0.01674,0.064137,0.08442,0.120908-0.05998-0.06746-0.111903-0.073568-0.144033-0.036919-0.01918,0.021953,0,0.061083,0.04129,0.056893,0.05974-0.00608,0.129007,0.145463,0.218433,0.183835z'/%3E %3Cpath d='m15.32,3.90323c-0.03127,0.00551-0.02199,0.056929-0.06426,0.060606,0.101032,0,0.152341-0.023883,0.200108-0.062439-0.02199,0.012852-0.03115,0.04591-0.03299,0.064259,0.05326-0.045898,0.179951-0.049563,0.246042-0.036711,0.06609,0.012852,0.07709-0.018362,0.100909-0.060594,0.02395-0.042233-0.0092-0.066104-0.04215-0.09915-0.03311-0.033058-0.04044-0.078956-0.03311-0.156079-0.176285-0.235023-0.492084-0.121188-0.495749-0.018362,0.113859,0.132196,0.128519,0.117511,0.224052,0.135873,0.09541,0.018361,0.153929,0.018313,0.08991,0.071614-0.02199,0.018362-0.113858,0.00974-0.185447,0.012852-0.16016,0.00696-0.233459-0.110633-0.280738-0.049551-0.03897,0.050235,0.0012,0.07242,0.08063,0.069745-0.05498,0.0003909-0.127908-0.00258-0.115447,0.048622,0.02101,0.086274,0.103475-0.01604,0.135604,0.019461-0.02749-0.00649-0.07024,0.010311-0.07183,0.036271-0.0015,0.025972,0.06108,0.059556,0.129862,0.00496,0.03763-0.029931,0.08564-0.041133,0.114592-0.041377z'/%3E %3Cpath d='m15.4566,3.54488c-0.0573-0.020964-0.109827-0.033779-0.177018-0.019901'/%3E %3Cpath d='m14.5929,3.51764c-0.04716,0.101324-0.01857,0.151339-0.0116,0.198348'/%3E %3Cpath d='m14.0908,3.03734c0.03237,0.016187,0.05058-0.029564,0.0981,0.019009-0.01307-0.014171-0.02932,0.037664-0.06573,0.00326'/%3E %3Cpath d='m14.355,3.03734c-0.03237,0.016187-0.05058-0.029564-0.0981,0.019009,0.01307-0.014171,0.02932,0.037664,0.06572,0.00326'/%3E %3Cpath d='m14.2569,3.05635c-0.01112,0.00917-0.01222-0.00732-0.0038,0.036014,0.01564,0.079567,0.03408,0.116791-0.0303,0.116791-0.06573,0-0.04581-0.037224-0.0303-0.116791,0.0086-0.043332,0.0075-0.02684-0.0037-0.036014'/%3E %3C/g%3E %3Cg fill='%23ff0016' stroke-width='0.00765'%3E %3Cpath d='m14.2238,3.36157c0.05229,0,0.08258-0.0009163,0.0744-0.074362-0.0034-0.029479,0.03579-0.041219,0.02199-0.089059,0.01466,0.058749-0.09639,0.053142-0.09639,0.02651,0,0.026632-0.111049,0.032239-0.09639-0.02651-0.0138,0.04784,0.02529,0.05958,0.02199,0.089059-0.0082,0.073446,0.02211,0.074362,0.0744,0.074362z'/%3E %3Cpath d='M14.1768,3.21299,14.0512,3.17796'/%3E %3Cpath d='m14.1768,3.21952-0.140246-0.00117'/%3E %3Cpath d='m14.1781,3.2267-0.1196,0.032044'/%3E %3Cpath d='m14.2709,3.21299,0.125587-0.035037'/%3E %3Cpath d='m14.2709,3.21952,0.140246-0.00117'/%3E %3Cpath d='m14.2695,3.2267,0.119601,0.032044'/%3E %3C/g%3E %3Cg fill='%230051ba' stroke-width='0.00159'%3E %3Cpath d='m13.5733,2.83723c-0.03653-0.045482-0.12803-0.00707-0.129862,0.049355,0.03091-0.036576,0.08136,0.016114,0.108849,0.00503,0.01906-0.00767,0.0358-0.03588,0.02101-0.054388z'/%3E %3Cpath d='m13.5259,2.9449c-0.03653-0.045482-0.127908-0.00707-0.129741,0.049355,0.03079-0.036576,0.08124,0.016114,0.10885,0.00503,0.01906-0.00766,0.0358-0.03588,0.02089-0.054388z'/%3E %3Cpath d='m13.5021,3.08953c-0.04141-0.041084-0.127908,0.00737-0.123387,0.063636,0.02663-0.039814,0.08258,0.00688,0.108727-0.00724,0.01808-0.00976,0.03152-0.039667,0.01466-0.056392z'/%3E %3Cpath d='m13.5457,3.53777c-0.04593-0.036039-0.126197,0.022026-0.115324,0.077416,0.02187-0.042599,0.08283-0.00268,0.107139-0.019693,0.01686-0.011789,0.02688-0.043039,0.0082-0.057723z'/%3E %3Cpath d='m13.5434,3.63587c-0.05473-0.020182-0.11337,0.059788-0.08588,0.109131,0.0076-0.047254,0.07794-0.028025,0.0959-0.051725,0.01246-0.016395,0.01222-0.049184-0.01002-0.057406z'/%3E %3Cpath d='m13.6136,3.70918c-0.05473-0.020194-0.11337,0.059776-0.08601,0.109131,0.0077-0.047266,0.07806-0.028037,0.09602-0.051737,0.01246-0.016395,0.01222-0.049184-0.01002-0.057393z'/%3E %3Cpath d='m15.0476,3.8512c-0.05473-0.020182-0.11337,0.059788-0.08588,0.109131,0.0077-0.047254,0.07794-0.028025,0.0959-0.051725,0.01246-0.016395,0.01222-0.049184-0.01002-0.057406z'/%3E %3Cpath d='m15.1215,3.91773c-0.05669-0.013829-0.105796,0.072298-0.07293,0.118196,0.0022-0.047828,0.07428-0.036723,0.08943-0.062317,0.01051-0.017702,0.0066-0.050259-0.01649-0.055879z'/%3E %3Cpath d='m15.0695,3.75701c-0.05058-0.029198-0.121921,0.039643-0.10323,0.092932,0.01564-0.045262,0.08161-0.014355,0.103353-0.034646,0.01503-0.014049,0.0204-0.046399-0.000123-0.058285z'/%3E %3Cpath d='m16.0897,3.87191c-0.05669-0.013817-0.105796,0.072298-0.07293,0.118208,0.0023-0.047828,0.0744-0.036723,0.08943-0.062317,0.01051-0.017702,0.0066-0.050259-0.01649-0.055891z'/%3E %3Cpath d='m16.0914,3.78185c-0.05143-0.027438-0.120333,0.043821-0.09993,0.096438,0.01405-0.045776,0.08112-0.017152,0.102131-0.038189,0.01454-0.014562,0.01881-0.04707-0.0022-0.058249z'/%3E %3Cpath d='m16.1312,3.9524c-0.05717-0.011337-0.102497,0.076855-0.06768,0.121274,0.000245-0.047877,0.07269-0.039948,0.08662-0.066165,0.0098-0.018154,0.0044-0.050503-0.01894-0.055109z'/%3E %3Cpath d='m14.228,3.31754c0.03592,0,0.05045,0.010482,0.05045,0.075364,0,0.137461-0.0016,0.196565-0.04581,0.196565-0.04435,0-0.04129-0.05616-0.04129-0.157081,0-0.052653,0-0.07898-0.01063-0.074594,0-0.034353,0.01527-0.040254,0.04728-0.040254z'/%3E %3C/g%3E %3C/g%3E %3Cuse xlink:href='%23leopard' transform='matrix(0.9,0,0,0.9,1.45342,1.67136)'/%3E %3Cuse xlink:href='%23leopard' transform='matrix(0.67,0,0,0.75,4.90869,3.35378)'/%3E %3C/g%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 6'%3E %3Cpath fill='%23009B3A' d='m0,0h12v6H0'/%3E %3Cpath stroke='%23FED100' d='m-6,9 24-12v12L-6-3'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 840 420'%3E %3Crect width='840' height='420' fill='%23007a3d'/%3E %3Crect width='840' height='280' fill='%23fff'/%3E %3Crect width='840' height='140' fill='%23000'/%3E %3Cpath d='M0,0V420L420,210z' fill='%23ce1126'/%3E %3Cpath d='M129.787138,180 136.295394,196.485467 153.242082,191.295306 144.411056,206.662186 159.034975,216.675628 141.51461,219.352347 142.80365,237.029066 129.787138,225 116.770625,237.029066 118.059665,219.352347 100.5393,216.675628 115.163219,206.662186 106.332193,191.295306 123.278882,196.485467 129.787138,180z' fill='%23fff'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 900 600'%3E %3Crect fill='%23fff' height='600' width='900'/%3E %3Ccircle fill='%23bc002d' cx='450' cy='300' r='180'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='-120 -80 240 160'%3E %3Cdefs%3E %3Cpath id='spearshape' d='M -1,55.4256258422040733928782829281879157421699 h 2 V -38 C 3,-40 3,-43 3,-46 C 3,-48 3,-56 0,-64.6632301492380856250246634162192350325315 C -3,-56 -3,-48 -3,-46 C -3,-43 -3,-40 -1,-38 z' stroke-miterlimit='10' transform='rotate(30)'/%3E %3C/defs%3E %3Crect x='-120' y='-80' width='240' height='160' fill='%23fff'/%3E %3Crect x='-120' y='-80' width='240' height='48'/%3E %3Crect x='-120' y='32' width='240' height='48' fill='%23060'/%3E %3Cg id='spear'%3E %3Cuse xlink:href='%23spearshape' stroke='%23000'/%3E %3Cuse xlink:href='%23spearshape' fill='%23fff'/%3E %3C/g%3E %3Cuse xlink:href='%23spear' transform='scale(-1,1)'/%3E %3Cpath fill='%23b00' d='M -120,-24 V 24 H -19 c 3,8 13,24 19,24 s 16,-16 19,-24 H 120 V -24 H 19 c -3,-8 -13,-24 -19,-24 s -16,16 -19,24 z'/%3E %3Cpath id='deco_r' d='M 19,24 c 3,-8 5,-16 5,-24 s -2,-16 -5,-24 c -3,8 -5,16 -5,24 s 2,16 5,24'/%3E %3Cuse xlink:href='%23deco_r' transform='scale(-1,1)'/%3E %3Cg fill='%23fff'%3E %3Cellipse rx='4' ry='6'/%3E %3Cpath id='deco_br' d='M 1,5.85 c 0,0 4,8 4,21 s -4,21 -4,21 z'/%3E %3Cuse xlink:href='%23deco_br' transform='scale(-1)'/%3E %3Cuse xlink:href='%23deco_br' transform='scale(-1,1)'/%3E %3Cuse xlink:href='%23deco_br' transform='scale(1,-1)'/%3E %3C/g%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 250 150'%3E %3CclipPath id='c'%3E %3Ccircle r='25'/%3E %3C/clipPath%3E %3Crect width='250' height='150' fill='%23e8112d'/%3E %3Cg transform='translate(125,75)'%3E %3Cg id='r20' transform='scale(0.25)'%3E %3Cg id='r4'%3E %3Cpath id='r1' d='m-8.4,108c8.4,22 -9.6,56 8.4,72c-6,-24 14-50 8.4,-72s-25.2,-22 -16.8,0z' fill='%23ffef00'/%3E %3Cuse xlink:href='%23r1' transform='rotate(90)'/%3E %3Cuse xlink:href='%23r1' transform='rotate(180)'/%3E %3Cuse xlink:href='%23r1' transform='rotate(270)'/%3E %3C/g%3E %3Cuse xlink:href='%23r4' transform='rotate(18)'/%3E %3Cuse xlink:href='%23r4' transform='rotate(36)'/%3E %3Cuse xlink:href='%23r4' transform='rotate(54)'/%3E %3Cuse xlink:href='%23r4' transform='rotate(72)'/%3E %3C/g%3E %3Cuse xlink:href='%23r20' transform='rotate(9)'/%3E %3Ccircle r='27' fill='%23e8112d'/%3E %3Ccircle cy='-1.5' r='22.5' fill='%23ffef00'/%3E %3Cg id='x' fill='%23e8112d' clip-path='url(%23c)'%3E %3Cpath d='M-23.055236,18a37.755236,37.755236 0 1,1 75.510472,0H52.760449a36.260449,36.260449 0 1,0 -72.520898,0z'/%3E %3Cpath d='M-17.601203,18a35.301203,35.301203 0 1,1 70.602406,0H53.424578a33.924578,33.924578 0 1,0 -67.849156,0z'/%3E %3Cpath d='M20.7,-15.052356a33.052356,33.052356 0 1,0 0,66.104712L22.5,49.819805a31.819805,31.819805 0 1,1 0,-63.63961z'/%3E %3C/g%3E %3Cuse xlink:href='%23x' transform='scale(-1,1)'/%3E %3C/g%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 625 400'%3E %3Crect width='625' height='400' fill='%23032ea1'/%3E %3Crect width='625' height='200' y='100' fill='%23e00025'/%3E %3Cg fill='%23fff' stroke='%23000' stroke-width='0.96' transform='translate(117.14286,-434.9336)'%3E %3Cg stroke-linejoin='bevel'%3E %3Cpath d='m139.02,623.46,113.8,0,0,43.788-113.8,0z'/%3E %3Crect width='3.5864' height='16.495' x='246.95' y='647.64'/%3E %3Crect width='113.8' height='5.0903' x='139.02' y='639.49'/%3E %3Crect width='113.8' height='4.489' x='139.02' y='632.59'/%3E %3Crect stroke-width='0.94545' width='113.8' height='4.354' x='139.02' y='625.7'/%3E %3Crect width='3.5864' height='16.495' x='168.98' y='647.64'/%3E %3Crect width='3.5864' height='16.495' x='217.97' y='647.64'/%3E %3Crect width='3.5864' height='16.495' x='139.92' y='647.64'/%3E %3Crect width='3.5864' height='16.495' x='146.95' y='647.64'/%3E %3Crect width='3.5864' height='16.495' x='154.45' y='647.64'/%3E %3Crect width='3.5864' height='16.495' x='161.95' y='647.64'/%3E %3Crect width='3.5864' height='16.495' x='224.77' y='647.64'/%3E %3Crect width='3.5864' height='16.495' x='232.27' y='647.64'/%3E %3Crect width='3.5864' height='16.495' x='239.77' y='647.64'/%3E %3Cpath stroke-linejoin='miter' d='m94.509,669.55c1.7604-0.89672,3.7684-2.9836,4.425-5.319h193.07c0.65665,2.3354,2.6647,4.4222,4.425,5.319z'/%3E %3C/g%3E %3Cg%3E %3Cg%3E %3Cpath d='m193,556.8s-0.14437-4.1125,2.2507-4.1572c2.3951,0.0447,2.2507,4.1572,2.2507,4.1572z'/%3E %3Cpath d='m180.51,611.34,0-5.5357c-0.0789-2.768-2.7591-2.9681-2.838-4.9862,0,0-0.34606-3.0266,0.45159-4.4082,1.0845,4.0474,3.0561,3.3039,3.0561,1.6397,0-1.4526-1.117-2.8031-3.408-6.3302-0.73206-1.127-0.27901-4.6597,0.74692-5.9224,0.39808,3.0709,0.85311,4.5398,2.1717,4.5398,0.80428,0,1.4612-0.52417,1.4612-2.0621,0-1.9565-1.325-2.9445-1.9762-4.725-0.76004-2.0777-0.23675-4.1957,1.0259-5.3795,0.54129,3.0293,0.38028,4.2372,1.7255,4.2372,2.7133-0.8584,0.00063-4.7866-0.57911-5.7773-0.667-1.1553,0.89682-3.4598,0.89682-3.4598,0.86209,2.6898,1.1394,2.909,2.0699,2.6597,1.1738-0.31452,1.0224-2.056-0.40996-3.4633-0.90449-0.88866-0.80857-2.2116,0.16248-3.274,0.97489,1.9056,2.2229,1.7898,2.343,0.65821l-0.78373-4.3931h17.255l-0.85683,4.2488c-0.24526,1.2162,1.396,1.4801,2.4162-0.51392,0.97105,1.0624,1.067,2.3854,0.16248,3.274-1.4323,1.4073-1.5837,3.1488-0.40996,3.4633,0.93041,0.2493,1.2078,0.0302,2.0699-2.6597,0,0,1.403,1.5708,0.89682,3.4598-0.57974,0.99071-3.2924,4.9189-0.57911,5.7773,1.3453,0,1.1842-1.2079,1.7255-4.2372,1.2627,1.1838,1.786,3.3017,1.0259,5.3795-0.65127,1.7804-1.9762,2.7685-1.9762,4.725,0,1.538,0.65688,2.0621,1.4612,2.0621,1.3186,0,1.7736-1.4689,2.1717-4.5398,1.0259,1.2627,1.479,4.7953,0.74692,5.9224-2.291,3.527-3.408,4.8776-3.408,6.3302,0,1.6641,1.9716,2.4076,3.0561-1.6397,0.79765,1.3816,0.4516,4.4082,0.4516,4.4082-0.0789,2.018-2.7591,2.2182-2.838,4.9862v5.5357z'/%3E %3Cpath d='m187.73,565.32-0.39721-3.125,15.838,0-0.39721,3.125z'/%3E %3Cpath d='m188.79,562.13-0.34117-2.5686,13.604,0-0.34117,2.5686z'/%3E %3Cpath d='m190.95,559.47-0.22717-2.5686,9.0585,0-0.22718,2.5686z'/%3E %3Cpath d='m223.97,669.55c-2.0266-0.78125-4.9773-2.9188-4.9773-5.0695v-24.297l2.6385-3.3588-52.776,0.00008,2.5293,3.3588v24.297c0,2.1508-2.0264,4.2883-4.0529,5.0695z'/%3E %3Crect stroke-linejoin='bevel' width='3.5864' height='16.495' x='178.24' y='647.64'/%3E %3Crect stroke-linejoin='bevel' width='3.5864' height='16.495' x='208.56' y='647.64'/%3E %3Cpath d='m167.91,609.17,0,14.648,0,7.0117,0,5.9961,54.023,0,0-5.957,0.0783-21.699c-2.2097,0.8681-2.5976,2.8711-2.5976,2.8711v11.777h-48.75v-11.777s-0.5442-2.003-2.7539-2.8711z'/%3E %3Cpath d='m214.6,669.55c-1.7655-0.78125-5.6118-2.9188-5.6118-5.0695v-27.192c0.37751-1.518,2.436-2.414,3.761-3.3588h-35.823c1.7049,0.90271,3.6054,1.6522,4.2846,3.3588v27.192c0,2.1508-3.041,4.2883-4.8065,5.0695z'/%3E %3Cpath d='m219.41,634.22-0.00027-19.587-4.9104-0.00008,0-1.9085-38.839,0,0,1.9085-4.9109-0.00018,0.00017,19.587z'/%3E %3Cpath d='m206.86,669.55c-1.7299-0.78125-4.2489-2.9186-4.2489-5.0694v-23.215l1.4205-2.1088h-17.691l1.4205,2.109v23.215c0,2.1508-2.5189,4.2883-4.2488,5.0695z'/%3E %3Cpath stroke-width='0.981' d='m190.71,639.16,8.9655-0.00005,0,30.377-8.9655,0z'/%3E %3Cpath stroke-linejoin='bevel' d='m204.38,632.48c0.0215-2.0012,5.8375-2.091,8.8318-3.7949h-35.952c2.9943,1.7039,8.6755,1.8441,8.6755,3.7949l1.2166,3.8818,14.883,0.59776z'/%3E %3Cpath d='m211.41,611.34c0-4.8986,0.20532-6.7857,1.7103-6.7857l0.00001,15.58c-3.6912,1.3393-6.3254,6.0491-6.3254,6.0491l-23.211-0.00027s-2.6342-4.7096-6.3254-6.0488v-15.58c1.856,0,1.8682,1.9717,1.8682,6.7857z'/%3E %3Cpath d='m213.12,609.33c0-5.6184,4.8512-6.2503,4.8512-6.2503v5c-1.8465-0.0789-2.7368,1.578-2.7368,4.0444,0,2.4663,1.4868,2.5056,1.4868,2.5056v14.19h-3.6012z'/%3E %3Cpath d='m177.28,609.33c0-5.6184-4.8512-6.2503-4.8512-6.2503v5c1.8465-0.0789,2.7368,1.578,2.7368,4.0444,0,2.4663-1.4868,2.5056-1.4868,2.5056v14.19h3.6012z'/%3E %3C/g%3E %3Cg fill='none' stroke-width='0.8'%3E %3Cpath d='m186.84,570.62h17.128'/%3E %3Cpath d='m184.81,575.97h20.921'/%3E %3Cpath d='m182.78,582.46h24.904'/%3E %3Cpath d='m180.66,590.39h29.536'/%3E %3Cpath d='m179.98,599.43h30.426'/%3E %3Cpath stroke-width='0.96' d='m170.75,628.92h48.661'/%3E %3Crect stroke-width='0.96' width='18.036' height='6.6291' x='186.19' y='628.93'/%3E %3C/g%3E %3Cg%3E %3Cpath d='m183.93,614.24c2.9903,3.59,2.7128,9.6801,2.6786,13.27h17.343c-0.0342-3.59-0.31172-9.68,2.6786-13.27z'/%3E %3Cpath d='m193.68,573.11-2.3764-1.2239,0-3.4974c0.97149,0.29214,2.062,0.41142,2.1686,1.9595,0.33824-2.2099,0.94822-2.1018,1.9064-2.963,0.95814,0.86127,1.5681,0.75315,1.9064,2.963,0.10661-1.5481,1.1971-1.6674,2.1686-1.9595v3.4974l-2.3764,1.2239z'/%3E %3Cpath d='m193.52,578.85-3.9464-2.7128,0-3.2231c1.3836,0.32035,2.9366,0.45115,3.0885,2.1488,0.48172-2.4232,1.3504-3.6754,2.715-4.6198,1.3646,0.94444,2.2332,2.1966,2.715,4.6198,0.15183-1.6976,1.7049-1.8284,3.0885-2.1488v3.2231l-3.9464,2.7128z'/%3E %3Cpath d='m193.24,587.8-4.5378-3.9854,0-4.7351c1.5909,0.47062,3.3767,0.66279,3.5513,3.1567,0.55391-3.56,1.5528-5.3995,3.1218-6.787,1.569,1.3875,2.5679,3.227,3.1218,6.787,0.17458-2.4939,1.9604-2.6861,3.5513-3.1567v4.7351l-4.5378,3.9854z'/%3E %3Cpath d='m201.61,593.09-4.1037,5.6759-4.6463,0-4.1037-5.6759z'/%3E %3Cpath d='m186.39,602.62c2.0526,1.1219,2.8106,3.3568,3.0299,7.5527h11.55c0.21927-4.1959,0.97728-6.4308,3.0298-7.5527z'/%3E %3Cpath stroke-linejoin='bevel' d='m204.17,593.09,0-5.7018c-1.9498,0.53675-3.2129,1.6912-3.7755,3.2577,0-1.8927-2.4906-6.2573-5.2071-8.4294-2.7242,2.4314-5.2575,6.3801-5.2066,8.4294-0.46332-1.4918-1.8258-2.7209-3.7755-3.2577v5.702z'/%3E %3Cpath stroke-linejoin='bevel' d='m205.04,602.62-0.00021-5.7022c-2.1373,0.53675-3.522,1.6912-4.1387,3.2577,0-1.8927-2.7299-6.2573-5.7077-8.4294-2.9863,2.4314-5.7635,6.3801-5.7077,8.4294-0.50788-1.4918-2.0014-2.7209-4.1387-3.2577v5.702z'/%3E %3Cpath stroke-linejoin='bevel' d='m207.44,614.32,0-6.5765c-2.6591,0.68624-4.3124,2.653-5.1491,3.7996,0-3.5614-4.0212-8.9902-7.1011-10.768-3.1599,1.8244-7.1011,7.435-7.1011,10.768-0.85883-1.1395-2.49-3.1134-5.1491-3.7996v6.5765z'/%3E %3Cpath stroke-linejoin='bevel' d='m206,628.92,0-6.7617c-2.3465,0.9193-3.0479,3.1802-3.7862,4.7163,0.28981-6.8584-3.8614-14.23-7.0239-16.1-3.1624,1.8699-7.3926,9.3996-7.0239,16.1-0.75787-1.5265-1.4397-3.797-3.7862-4.7163v6.7618z'/%3E %3Cpath d='m204.36,639.16,0-6.7618c-2.4581,0.58449-2.61,1.491-3.3916,3.0055,0.28981-4.0963-2.6114-8.7695-5.7739-10.639-3.1624,1.8699-6.0637,6.5431-5.7739,10.639-0.78168-1.5145-0.87771-2.421-3.3916-3.0055v6.7618z'/%3E %3C/g%3E %3C/g%3E %3Cg id='tower'%3E %3Cg%3E %3Cpath d='m98.935,664.23,0-20.44c-0.66964-2.6026-2.8793-4.9052-4.5407-5.3664v-17.993l3.7418,2.0232,4.2712,18.811v22.965z'/%3E %3Cpath d='m98.935,664.31,0-20.519c-0.66964-2.6026-2.8793-4.9052-4.5407-5.3664v-19.243c2.5118,0,3.7418,3.2732,3.7418,3.2732l4.2712,18.811v22.886z'/%3E %3Cpath d='m96.275,669.55c1.7299-0.78125,4.2487-2.9188,4.2487-5.0695v-25.547l-1.1852-2.1088h43.522l-1.6983,2.1088v25.547c0,2.1508,1.7297,4.2883,3.4596,5.0695z'/%3E %3Cpath d='m135.84,669.55c-1.7299-0.78125-4.2487-2.9188-4.2487-5.0695v-24.297l3.619-3.359-29.588,0.00008,3.6191,3.3589v24.297c0,2.1508-2.5189,4.2883-4.2488,5.0695z'/%3E %3Cpath d='m131.69,669.55c-1.7299-0.78125-4.2487-2.9188-4.2487-5.0695v-21.965l2.369-3.359h-18.798l2.3688,3.359v21.965c0,2.1508-2.5189,4.2883-4.2488,5.0695z'/%3E %3Cpath d='m115.92,639.16,8.9819-0.00004-0.00002,30.393-8.9818,0z'/%3E %3Crect stroke-linejoin='bevel' width='3.5864' height='16.495' x='103.7' y='647.64'/%3E %3Crect stroke-linejoin='bevel' width='3.5864' height='16.495' x='134.45' y='647.64'/%3E %3Cpath stroke-linejoin='bevel' d='m100.64,619.82h4.3202v16.909h-4.3202z'/%3E %3Cpath stroke-linejoin='bevel' d='m100.64,616.64h4.2946v3.1387h-4.2946z'/%3E %3Cpath stroke-width='1.0337' stroke-linejoin='bevel' d='m136.17,623.46h6.1594v13.054h-6.1594z'/%3E %3Cpath d='m104.89,636.6,0-28.941c1.2321,0,1.4222,4.2418,4.249,4.2418,1.4716,0,1.3152-1.757,0.4889-3.1882-0.73168-1.2673-1.6372-3.0176-0.40702-6.2783,0.84298,2.4949,3.1119,3.2866,2.6927,1.722-0.72042-2.6886-2.7945-3.1298-1.2383-7.3021,0.54049,3.4806,2.7732,3.3273,2.2309,1.3034-0.61083-2.2796-1.8732-3.2139-0.3157-6.4275,0.87209,3.6492,2.0519,3.4352,2.0519,1.1711,0-3.347-0.1285-6.9568,4.2027-8.296,0,0,0.25002-3.0682,1.8123-3.0682s1.8123,3.0682,1.8123,3.0682c4.3312,1.3393,4.2027,4.949,4.2027,8.296,0,2.264,1.1798,2.4781,2.0519-1.1711,1.5574,3.2136,0.29513,4.1479-0.3157,6.4275-0.54227,2.0238,1.6904,2.1772,2.2309-1.3034,1.5562,4.1722-0.5179,4.6134-1.2383,7.3021-0.41923,1.5646,1.8497,0.77297,2.6927-1.722,1.2302,3.2606,0.32466,5.011-0.40702,6.2783-0.82627,1.4311-0.98274,3.1882,0.4889,3.1882,2.8268,0,3.0168-4.2418,4.249-4.2418v28.941z'/%3E %3Cpath d='m98.124,614.74,0.000081,22.079,2.5111,0-0.00019-22.135c-0.90498-0.45686-1.7546-0.5274-2.511,0.0558z'/%3E %3Cpath d='m98.203,629.03c3.1124,1.5914,6.1949,3.4325,6.9754,7.7931h-6.9754z'/%3E %3Cpath d='m141.37,622.42,0.00006,14.407,2.0354,0,0-14.443c-0.63587-0.2981-1.5039-0.34413-2.0354,0.0364z'/%3E %3Cpath d='m143.41,628.92c-3.1124,1.5914-6.1949,3.4325-6.9754,7.7931h6.9754z'/%3E %3C/g%3E %3Cg%3E %3Cpath d='m122.83,595.27,1.8142-1.5247,0-1.9528c-0.6637,0.0645-1.0258,0.29275-1.516,0.93531-0.41694-1.2944-1.3337-2.3051-2.5624-2.9327-1.2287,0.6276-2.1454,1.5924-2.5624,2.8867-0.49022-0.64256-0.8523-0.8249-1.516-0.88935v1.9528l1.8142,1.5247z'/%3E %3Cpath d='m123.8,600.16,0.8432-1.8253,0-2.5384c-0.6637,0.0654-1.0258,0.29688-1.516,0.94855-0.41694-1.3127-1.3337-2.3377-2.5624-2.9742-1.2287,0.63649-2.1454,1.6149-2.5624,2.9276-0.49022-0.65166-0.8523-0.83658-1.516-0.90194v2.5384l0.8432,1.8253z'/%3E %3Cpath d='m123.93,606.79,2.6948-3.2865,0-3.2432c-0.98588,0.11068-1.5237,0.50272-2.2519,1.6061-0.61934-2.2227-1.9811-2.7084-3.8062-3.7861-1.8251,1.0777-3.1869,1.4845-3.8062,3.7072-0.72818-1.1034-1.266-1.4165-2.2519-1.5272v3.2432l2.6949,3.2865z'/%3E %3Cpath d='m124.72,613.3s3.1405-2.7397,3.3269-4.2436v-3.4672c-1.2171,0.14291-2.3682,0.45834-3.2672,1.8831-0.76458-2.8701-1.9586-3.6704-4.2117-5.0621-2.2532,1.3916-3.4471,2.192-4.2117,5.0621-0.89895-1.4248-2.0501-1.7402-3.2672-1.8831v3.4672c0.3965,1.5039,3.3269,4.2436,3.3269,4.2436z'/%3E %3Cpath d='m126.06,625.32s4.3013-4.7614,4.3999-6.6164v-5.4059c-1.6097,0.22281-3.1321,1.3298-4.321,3.5513-1.0112-4.4748-2.5903-7.5949-5.5702-9.7647-2.9799,2.1698-4.559,5.2898-5.5702,9.7647-1.1889-2.2215-2.7113-3.3285-4.321-3.5513v5.4059c0.30884,1.8551,4.3999,6.6164,4.3999,6.6164z'/%3E %3Cpath d='m126.06,632.43s3.6763-3.7418,4.3999-5.3664v-5.4059c-1.6097,0.22281-3.1321,1.3299-4.321,3.5513-1.0112-4.4748-2.5903-7.0369-5.5702-9.2067-2.9799,2.1698-4.559,4.7318-5.5702,9.2067-1.1889-2.2215-2.7113-3.3285-4.321-3.5513v5.4059c0.93384,1.6247,4.3999,5.3664,4.3999,5.3664z'/%3E %3Cpath d='m127.54,636.56c-1.0733-4.6678-1.9959-8.1303-7.163-11.641-5.167,3.5104-6.0894,6.9728-7.1627,11.641z'/%3E %3Cpath d='m130.2,639.16,0-6.7618c-2.3465,0.91931-4.467,2.2802-5.2487,3.7947-0.87376-3.754-2.5569-5.4078-4.6536-7.6786-2.0967,2.2708-3.5008,3.9245-4.3746,7.6786-0.78168-1.5145-2.9024-2.8754-5.2489-3.7946l0.00022,6.7618z'/%3E %3C/g%3E %3C/g%3E %3Cuse xlink:href='%23tower' transform='matrix(-1,0,0,1,390.73979,0)'/%3E %3Cg%3E %3Cpath d='m72.694,694.25,245.33,0,0.00018,12.531-245.33,0.00001z'/%3E %3Cpath d='m66.228,706.76,258.26,0,0.00018,12.512-258.26,0.00002z'/%3E %3Cpath d='m85.576,675.51,219.56,0,0.00015,8.1093-219.56,0.00001z'/%3E %3Cpath d='m79.157,683.56,232.4,0,0.00017,10.622-232.4,0.00001z'/%3E %3Cpath d='m89.412,669.28,211.89,0,0.00015,6.174-211.89,0z'/%3E %3Cpath d='m112.41,669.31h16.005v49.935h-16.005z' stroke-width='1.0446'/%3E %3Cpath d='m115.95,669.31h8.9171v49.936h-8.917z' stroke-width='1.0429'/%3E %3Cpath d='m187.08,669.31h16.006v49.935h-16.005z' stroke-width='1.0446'/%3E %3Cpath d='m190.73,669.31h8.9171v49.936h-8.917z' stroke-width='1.0429'/%3E %3Cpath d='m262.19,669.31h16.005v49.935h-16.005z' stroke-width='1.0446'/%3E %3Cpath d='m265.73,669.31h8.9171v49.936h-8.917z' stroke-width='1.0429'/%3E %3C/g%3E %3Cg fill='none'%3E %3Cpath d='m98.935,664.23h193.07'/%3E %3Cpath d='m115.79,712.97h9.2438m-9.2438,-6.25h9.2438m-9.2438,-6.25h9.2438m-9.2438,-6.25h9.2438m-9.2438,-6.25h9.2438m-9.2438,-6.25h9.2438m-9.2438,-6.25h9.2438'/%3E %3Cpath d='m190.77,712.98h8.6071m-8.6071,-6.2533h8.6071m-8.6071,-6.2533h8.6071m-8.6071,-6.2533h8.6071m-8.6071,-6.2533h8.6071m-8.6071,-6.2533h8.6071m-8.6071,-6.2533h8.6071'/%3E %3Cpath d='m265.57,712.97h9.2438m-9.2438,-6.25h9.2438m-9.2438,-6.25h9.2438m-9.2438,-6.25h9.2438m-9.2438,-6.25h9.2438m-9.2438,-6.25h9.2438m-9.2438,-6.25h9.2438'/%3E %3C/g%3E %3C/g%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 600 300'%3E %3Crect width='600' height='300' fill='%23ce1126'/%3E %3Cg fill='%23fcd116' stroke='%23bd9c08' stroke-width='1.2'%3E %3Cpath stroke-width='1.5' d='M349.39,141.29c8.76,2.35,22.01,1.76,27.96,8.71-8.75-2.35-19.55,11.81-27.96,8.71,7.43,5.2-108.04,0-98.78,0-8.76-2.35-22.01-1.76-27.96-8.71,8.75,2.35,19.55-11.81,27.96-8.71-7.43-5.2-20.31-9.23-23.3-17.75,7.43,5.2,22.54-4.44,29.26,1.38-5.2-7.42-16.07-15.57-15.83-24.64,5.2,7.43,22.71,3.45,27.02,11.3-2.34-8.76-9.41-20.05-6.44-28.57,2.35,8.758,19.98,10.933,21.53,19.86,0.79-9.031-2.4-22.103,3.72-29.049-0.79,9.033,15.13,17.097,13.43,26.026,3.83-8.217,5.95-21.492,13.43-26.026-3.83,8.218,8.67,21.199,3.72,29.049,6.41-6.409,12.6-18.286,21.53-19.86-6.41,6.411,0.42,22.74-6.44,28.57,8.21-3.83,17.91-12.877,27.02-11.3-8.22,3.83-7.41,21.54-15.83,24.64,9.04-0.79,21.17-5.91,29.26-1.38-9.03,0.79-14.04,17.75-23.3,17.75z'/%3E %3Cpath stroke-width='1.5' stroke-linejoin='round' d='M258.36,150l-31.59-12.91,34.1-1.33-25.27-22.94,32.5,10.42-15.9-30.198,26.98,20.898-4.61-33.809,18.2,28.869,7.23-33.353,7.23,33.353,18.2-28.869-4.61,33.809,26.97-20.898-15.89,30.198,32.49-10.42-25.26,22.94,34.09,1.33-31.58,12.91,31.58,12.91h-146.45l31.59-12.91z'/%3E %3Ccircle stroke-width='1.8' cx='300' cy='150' r='41.358'/%3E %3Cpath d='M313.6,49.862l22.18,0.147c0.14-0.938-1.9-2.805-3.65-3.078-5.61-0.882-9.82,0.936-16.64,1.006l-1.89,1.925z'/%3E %3Cpath d='M269.43,44.643c5.21,6.58,15.31,11.153,24.95,11.213,13,0.08,27.42-10.441,44.85-13.662l-56.91-1.172c-7.37-5.045-12.96-4.405-16.77-1.277l-10.88,0.329c-1.54,0.839,1.27,4.343,3.55,4.471l11.21,0.098z'/%3E %3Cpath d='M295.16,40.868c-2.07-9.518-9.71-13.62-18.89-14.837-10.61-1.406-35.02-2.847-51.24-7.505,7.02,6.901,21.71,10.346,31.92,11.904,10.81,1.65,21.33,4.054,29.67,10.351l8.54,0.087z'/%3E %3Cpath stroke-linecap='round' d='M288.27,47.221c3.39,4.354,8.65,4.108,14.31,0.309,5.64-3.786,11.77-14.447,14.73-14.622,20.69-1.202,45.72-9.936,57.66-16.681-15.14,2.143-30.14,4.573-45.41,4.633-26.05,0.104-29.13,11.968-39.75,20.286'/%3E %3Cpath fill='none' stroke-linecap='round' d='M292.31,42.103c5.55-3.536,10.06-8.151,15.26-12.006,8.61-6.382,18.55-6.569,29.23-6.701,9.46-0.116,26.04-4.069,35.04-6.178'/%3E %3Cpath fill='none' d='M286.53,40.436c-1.63-8.511-9.6-11.065-19.66-12.594-10.95-1.663-22.12-2.589-33.04-5.607-2.71-0.748-5.23-2.07-7.85-3.105'/%3E %3Cpath fill='none' stroke-linecap='round' d='M290.02,52.983c10.28,0.754,17.91-2.336,26.68-6.706'/%3E %3Cpath fill='none' stroke-linecap='round' d='M254.63,41.831h12.96'/%3E %3Ccircle fill='%23bd9c08' stroke='none' cx='271.75' cy='40.437' r='1.62'/%3E %3C/g%3E %3Crect fill='%23003f87' width='600' height='135' y='165'/%3E %3Cpath id='w' fill='%23fff' d='M0,257.14c20,0,40,12.86,60,12.86s40-12.86,60-12.86,40,12.86,60,12.86,40-12.86,60-12.86,40,12.86,60,12.86,40-12.86,60-12.86,40,12.86,60,12.86,40-12.86,60-12.86,40,12.86,60,12.86,40-12.86,60-12.86v-21.43c-20,0-40,12.86-60,12.86s-40-12.86-60-12.86-40,12.86-60,12.86-40-12.86-60-12.86-40,12.86-60,12.86-40-12.86-60-12.86-40,12.86-60,12.86-40-12.86-60-12.86-40,12.86-60,12.86-40-12.86-60-12.86v21.43z'/%3E %3Cuse xlink:href='%23w' y='-42.8571'/%3E %3Cuse xlink:href='%23w' y='-85.7142'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 500 300'%3E %3Crect fill='%233A75C4' width='500' height='300'/%3E %3Crect fill='%23CE1126' width='500' height='225'/%3E %3Crect fill='%23FFF' width='500' height='150'/%3E %3Crect fill='%23FFC61E' width='500' height='75'/%3E %3Cpath fill='%233D8E33' d='M0,300l250-150L0,0V300z'/%3E %3Ccircle fill='%23FFF' cx='85' cy='150' r='67.5'/%3E %3Ccircle fill='%233D8E33' cx='115' cy='150' r='67.5'/%3E %3Cpath id='star' fill='%23FFF' d='M100.0104,89.1996l7.3594,22.5883L88.1125,97.8394h23.775l-19.2573,13.9486L100.0104,89.1996z'/%3E %3Cuse xlink:href='%23star' y='32.2083'/%3E %3Cuse xlink:href='%23star' y='64.4166'/%3E %3Cuse xlink:href='%23star' y='96.625'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 750 500'%3E %3Cdefs%3E %3C/defs%3E %3Cpath d='M750,0H0V500' fill='%23009e49'/%3E %3Cpath d='M0,500H750V0' fill='%23ce1126'/%3E %3Cpath d='M0,500 750,0' stroke='%23fcd116' stroke-width='210'/%3E %3Cpath d='M0,500 750,0' stroke='%23000' stroke-width='150'/%3E %3Cg id='star' transform='translate(517.5,155) rotate(-33.69)' fill='%23fff'%3E %3Cg id='c'%3E %3Cpath id='t' d='M0,-70V0H35' transform='rotate(18,0,-70)'/%3E %3Cuse xlink:href='%23t' transform='scale(-1,1)'/%3E %3C/g%3E %3Cuse xlink:href='%23c' transform='rotate(72)'/%3E %3Cuse xlink:href='%23c' transform='rotate(144)'/%3E %3Cuse xlink:href='%23c' transform='rotate(216)'/%3E %3Cuse xlink:href='%23c' transform='rotate(288)'/%3E %3C/g%3E %3Cuse xlink:href='%23star' transform='translate(-285,190)'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 72 36'%3E %3Crect fill='%23024FA2' width='72' height='36'/%3E %3Crect fill='%23fff' y='6' width='72' height='24'/%3E %3Crect fill='%23ED1C27' y='7' width='72' height='22'/%3E %3Ccircle fill='%23fff' cx='24' cy='18' r='8'/%3E %3Cg id='star' transform='translate(24,18) scale(7.75)' fill='%23ED1C27'%3E %3Cg id='cone'%3E %3Cpolygon id='triangle' points='0,0 0,1 .5,1' transform='translate(0,-1) rotate(18)'/%3E %3Cuse xlink:href='%23triangle' transform='scale(-1,1)' id='use12'/%3E %3C/g%3E %3Cuse xlink:href='%23cone' transform='rotate(72)' id='use14'/%3E %3Cuse xlink:href='%23cone' transform='rotate(-72)' id='use16'/%3E %3Cuse xlink:href='%23cone' transform='rotate(144)' id='use18'/%3E %3Cuse xlink:href='%23cone' transform='rotate(-144)' id='use20'/%3E %3C/g%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='-36 -24 72 48'%3E %3Ctitle%3EFlag of South Korea%3C/title%3E %3Crect fill='%23fff' x='-36' y='-24' width='72' height='48'/%3E %3Cg transform='rotate(-56.3099325)'%3E %3Cg id='b2'%3E %3Cpath id='b' d='M-6-25H6M-6-22H6M-6-19H6' stroke='%23000' stroke-width='2'/%3E %3Cuse xlink:href='%23b' y='44'/%3E %3C/g%3E %3Cpath stroke='%23fff' stroke-width='1' d='M0,17v10'/%3E %3Ccircle fill='%23c60c30' r='12'/%3E %3Cpath fill='%23003478' d='M0-12A6,6 0 0 0 0,0A6,6 0 0 1 0,12A12,12 0 0,1 0-12Z'/%3E %3C/g%3E %3Cg transform='rotate(-123.6900675)'%3E %3Cuse xlink:href='%23b2'/%3E %3Cpath stroke='%23fff' stroke-width='1' d='M0-23.5v3M0,17v3.5M0,23.5v3'/%3E %3C/g%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 6'%3E %3Crect width='12' height='2' fill='%23007a3d'/%3E %3Crect width='12' height='2' y='2' fill='%23fff'/%3E %3Crect width='12' height='2' y='4' fill='%23ce1126'/%3E %3Cpolygon points='0,0 3,2 3,4 0,6'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 1200 600'%3E %3CclipPath id='c'%3E %3Cpath d='M0,0V150H700V300H600zM600,0H300V350H0V300z'/%3E %3C/clipPath%3E %3Crect width='1200' height='600' fill='%2300247d'/%3E %3Cpath d='M0,0 600,300M600,0 0,300' stroke='%23fff' stroke-width='60'/%3E %3Cpath d='M0,0 600,300M600,0 0,300' stroke='%23cf142b' stroke-width='40' clip-path='url(%23c)'/%3E %3Cpath d='M300,0V350M0,150H700' stroke='%23fff' stroke-width='100'/%3E %3Cpath d='M300,0V350M0,150H700' stroke='%23cf142b' stroke-width='60'/%3E %3Cpath d='M0,300H600V0H1200V600H0z' fill='%2300247d'/%3E %3Cg stroke='%23000' stroke-width='1.4377'%3E %3Cg id='border' stroke='%23fff' stroke-width='9.6' stroke-linejoin='round'%3E %3Cuse xlink:href='%23shield'/%3E %3Cuse xlink:href='%23motto1'/%3E %3Cuse xlink:href='%23motto2'/%3E %3Cuse xlink:href='%23rope'/%3E %3Cuse xlink:href='%23turtle'/%3E %3Cuse xlink:href='%23pineapple1'/%3E %3Cuse xlink:href='%23pineapple2'/%3E %3C/g%3E %3Cg id='motto'%3E %3Cg id='motto1' fill='%23fcea83'%3E %3Cpath d='m754.417,449.563c2.87535,7.66776,23.4825,17.7317,47.4443,4.79235,16.294-9.10547,26.8372-22.0448,36.9011-45.0481,2.87534-5.75082,4.31301-12.9394-2.39625-17.2525-5.27159-3.83388-13.8978-8.14701-17.7317-11.9809-1.91689-1.91694-3.83392-3.35465-5.27159-4.79236,0.95845,0.95848,1.9169,1.91695,2.87535,3.35465,9.58473,11.5016-0.47923,28.2749-11.0224,38.3388-7.66771,7.18852-21.5656,24.9202-41.6934,8.14699-4.31314-3.83388-14.3771,11.9809-9.10551,24.441z'/%3E %3Cpath d='m1045.79,449.563c-3.3547,7.66776-23.9618,17.7317-47.4443,4.79235-16.294-9.10547-26.8372-22.0448-37.3804-45.0481-2.39625-5.75082-3.83392-12.9394,2.87534-17.2525,5.27159-3.83388,13.8979-8.14701,17.7317-11.9809,1.91702-1.91694,3.35469-3.35465,5.27159-4.79236-0.95845,0.95848-1.9169,1.91695-2.87535,3.35465-9.58473,11.5016,0.47923,28.2749,10.5432,38.3388,7.66769,7.18852,22.0448,24.9202,42.1727,8.14699,4.3132-3.83388,13.8978,11.9809,9.1055,24.441z'/%3E %3Cpath d='m900.105,490.778c38.3388,0,97.2848-17.2525,128.914-77.6361,5.2716-10.0639,0-15.3355-6.23-18.6902-6.7093-2.87541-14.8564-9.58471-19.1694-13.8978,7.6677,7.66778,6.2301,12.9394,0.9585,21.5656-24.4411,40.735-57.9875,61.3421-104.473,61.3421-46.4859,0-80.0323-20.6071-104.473-61.3421-5.27159-8.62625-6.70939-13.8978,0.47922-21.5656-3.83392,4.31312-12.4602,11.0224-19.1695,13.8978-6.23004,3.35465-11.5016,8.62623-6.23004,18.6902,31.6295,60.3837,91.0547,77.6361,129.394,77.6361z'/%3E %3C/g%3E %3Cg id='motto2' fill='%23db161c'%3E %3Cpath d='m811.446,409.787c-0.95847-4.79235-7.18853-2.87541-9.10547,2.87541-2.39617-3.35464-4.79235-6.70929-6.70929-10.5432-5.75083-8.62623-6.7093-14.3771,1.4377-22.5241,3.83389-3.83388,11.5016-8.147,16.7732-3.35464,11.0224,9.10547,5.27159,23.9618-2.39618,33.5465z'/%3E %3Cpath d='m988.284,409.787c0.95847-4.79235,7.66776-2.87541,9.5847,2.87541,2.39616-3.35464,4.79236-6.70929,6.70926-10.5432,5.7509-8.62623,6.7093-14.3771-1.9169-22.5241-3.35465-3.83388-11.0224-8.147-16.7732-3.35464-10.5432,9.10547-5.27159,23.9618,2.39618,33.5465z'/%3E %3Cpath d='m754.417,449.563c-4.79236-7.18853-8.62624-25.8787-9.58471-30.6711-1.43771-4.31312-1.91694-8.147,3.35465-10.0639,5.27159-1.91694,10.0639,4.79235,12.4601,10.5432,2.39617,5.75082,6.23006,14.3771,10.5432,24.9202-10.5432-6.23006-19.1694-1.91695-16.7732,5.27158z'/%3E %3Cpath d='m1045.79,449.563c4.3131-7.18853,8.147-25.8787,9.5847-30.6711,0.9585-4.31312,1.9169-8.147-3.3547-10.0639-5.2715-1.91694-10.0639,4.79235-12.4601,10.5432-2.3962,5.75082-6.23,14.3771-10.5432,24.9202,10.5432-6.23006,18.6902-1.91695,16.7733,5.27158z'/%3E %3C/g%3E %3Cg fill='%2300493d' stroke='none'%3E %3Cpath d='m782.213,406.432-3.83389,1.91694c-0.95847,0.47924-0.95847,1.43771-0.95847,1.91695h-0.47923l-1.91694-4.31312h0.47923c0,0.47923,0.47924,0.95847,1.43771,0.47923l8.147-4.31312c0.95847-0.47923,0.95847-0.95847,0.47923-1.4377l0.47924-0.47924,2.39618,4.79236h-0.47924c-0.47923-0.47924-0.95847-0.95847-1.91694-0.47924l-3.35465,1.91694,1.43771,2.87542,3.83388-1.43771c0.95847-0.47924,0.47924-1.43771,0.47924-1.91694h0.47923l1.91694,4.31312c-0.47923-0.47924-0.95847-0.95847-1.91694-0.47924l-8.147,4.31312c-0.95847,0.47923-0.95847,0.95847-0.47923,1.4377l-0.47924,0.47924-2.39618-4.31312,0.47924-0.47923c0.47923,0.47923,0.95847,0.95847,1.91694,0.47923l3.83388-1.91694-1.4377-3.35465z'/%3E %3Cpath d='m790.36,412.662c0.95847-0.47923,0.95847-0.95847,0.47923-1.91694h0.47924l4.79235,7.18853-3.35465,2.39618v-0.47924c1.91695-1.4377,1.91695-3.35464,1.43771-3.83388-0.47923-0.47924-0.95847-0.95847-0.95847-1.43771-0.47924,0-0.47924-0.47923-1.43771,0.47924-0.47923,0.47923-3.35464,2.39618-3.35464,2.39618,0.47923,0.47923,0.95847,1.91694,3.35464,0.47923h0.47924l-5.27159,3.83388v-0.47923c2.39618-1.91694,1.43771-3.35465,0.95847-3.83388l-3.35465,2.39617c-0.95847,0.47924-0.95847,0.95847-0.95847,1.43771,0.47924,0,0.47924,0.47923,0.95847,0.95847,0.47924,0.95847,1.91695,1.91694,4.31312,0.95847l0.47924,0.47924-3.83389,1.4377-4.79235-7.66776h0.47924c0.47923,0.47923,0.95847,0.95847,1.91694,0.47923l7.18853-5.27159z'/%3E %3Cpath d='m798.027,430.873-3.35464,2.87541c-0.47924,0.47923-0.47924,1.4377,0,1.91694h-0.47924l-3.35465-3.35465,0.47924-0.47923c0.47923,0.47923,0.95847,0.95847,1.91694,0l6.23006-6.23006c0.95847-0.47924,0.95847-0.95847,0.47924-1.91694l3.35464,3.83388c-0.47923-0.47924-1.4377-0.47924-1.91694,0l-2.87541,2.87541,2.39618,2.39618,2.87541-2.39618c0.95847-0.95847,0.47923-1.43771,0-1.91694l0.47923-0.47924,3.35465,3.83389h-0.47923c-0.47924,0-0.95848-0.47924-1.91695,0.47923l-6.23006,5.75083c-0.95847,0.95847-0.95847,1.4377-0.47923,1.91694v0.47923l-3.35465-3.83388c0.47924,0,1.43771,0.47924,1.91694,0l3.35465-3.35465-2.39618-2.39617z'/%3E %3Cpath d='m805.216,440.937,1.43771,1.4377c1.91694-4.31311,1.91694-4.31311,1.91694-4.31311s-1.4377,0.47923-3.83388,1.91694l0.47923,0.95847-0.47923,0.47923-0.95847-0.95847c-0.47924,0.47924-0.95847,0.47924-1.43771,0.95847-1.4377,0.95847-0.95847,1.43771-0.47923,1.91694v0.47924l-2.39618-2.39618h0.47924l1.91694-0.47923c9.5847-5.27159,9.5847-5.27159,9.5847-5.27159l0.47924,0.47923s-0.47924,0.47924-4.79235,10.064c0,0.95847-0.47924,1.4377,0,2.39617l-3.83389-3.35464,0.47924-0.47924c0.47923,0.95847,1.4377,0.95847,1.91694,0,0-0.47923,0.47923-1.43771,0.47923-1.91694l-1.4377-1.43771,0.47923-0.47923z'/%3E %3Cpath d='m809.05,450.522,0.47923-0.47924c0.47924,0.47924,0.95847,0.47924,1.91694,0l6.23006-8.147-0.47923-0.47924c-0.95847-0.47923-2.39618-0.47923-3.83388,0.95847v-0.47923l1.91694-2.39618,7.18853,5.27159-2.39618,2.87541h-0.47924c1.43771-1.4377,0.95848-3.35464,0-3.83388v-0.47924l-6.23005,8.14701c-0.95848,0.47923-0.47924,1.4377,0,1.91694h-0.47924l-3.83388-2.87541z'/%3E %3Cpath d='m821.51,452.439-2.39618,3.35464c-0.47924,0.95847,0,1.43771,0.47923,1.91695l-0.47923,0.47923-3.83388-2.87541v-0.47924c0.95847,0.47924,1.4377,0.47924,1.91694-0.47923l5.27159-7.18853c0.47923-0.95847,0-1.43771-0.47924-1.91694l0.47924-0.47924,3.83388,2.87541v0.47924c-0.95847-0.47924-1.43771-0.47924-1.91694,0.47923l-2.39618,3.35465,2.87541,1.91694,2.39618-3.35464c0.47924-0.95848,0-1.43771-0.47924-1.91695l0.47924-0.47923,3.83388,2.87541v0.47924c-0.47923-0.47924-1.4377-0.47924-1.91694,0.47923l-4.79235,7.66777c-0.95847,0.47923-0.47924,0.95847,0,1.4377v0.47924l-4.31312-2.87541h0.47924c0.47923,0,0.95847,0,1.4377-0.47924l2.39618-3.83388-2.87541-1.91694z'/%3E %3Cpath d='m831.095,465.857,0.47924-0.47924c0.47923,0.47924,1.4377,0.47924,1.91694-0.47923l3.83388-8.14701c0.47924-0.95847,0-1.4377-0.47923-1.91694l8.147,3.83389-1.91694,3.83388-0.47924-0.47924c1.43771-1.91694,0-3.83388-0.47923-4.31311-0.47924,0-0.95847-0.47924-1.43771-0.47924s-0.47924,0-0.95847,0.95847c-0.47924,0.47924-1.91694,3.35465-1.91694,3.35465,0.47923,0.47923,1.4377,1.4377,3.35465-0.95847h0.47923l-2.87541,5.75082-0.47924-0.47923c1.43771-2.87542-0.47923-3.35465-0.95847-3.35465l-1.91694,3.83388c-0.47923,0.95847,0,1.43771,0.47924,1.43771v0.47923l-4.79236-2.39617z'/%3E %3Cpath d='m844.992,472.567c-1.43771-0.95847-1.43771-3.83388,0-6.70929,0.95847-2.87542,2.87541-5.27159,4.79235-4.31312,1.43771,0.47923,0.95847,3.35465,0,6.23006-1.4377,3.35465-3.35465,5.27159-4.79235,4.79235h-0.47924c3.35465,1.43771,5.75083-0.47923,7.18853-3.83388,1.43771-2.87541,0.95847-6.23006-1.91694-7.66777-2.87541-1.4377-5.75082,0.47924-7.18853,3.83389-1.4377,3.35464-0.95847,6.70929,1.91694,7.66776h0.47924z'/%3E %3Cpath d='m859.849,473.525,1.91695-5.75082c0.47923-0.95847,0-1.43771-0.47924-1.91694l2.39618,0.47923v0.47924c-0.47924,0-0.95847,0-1.43771,0.95847l-1.91694,5.75082c-0.95847,2.39618-2.39618,4.31312-5.27159,3.35465-1.91694-0.47924-3.35465-2.87541-2.39618-5.27159l2.39618-6.23006c0.47924-0.95847,0-1.4377-0.47923-1.91694v-0.47924l4.31311,1.91695v0.47923c-0.47923-0.47923-1.4377-0.47923-1.4377,0.47924l-2.39618,6.23006c-0.47923,1.91694-0.47923,3.83388,0.95847,4.31311,1.43771,0.47924,2.87541-0.47923,3.83388-2.87541z'/%3E %3Cpath d='m864.162,467.295c0-0.47923,0-0.47923-0.47923-0.47923l3.35464,0.47923,2.87542,9.10547,1.4377-5.75082c0.47924-0.95847,0-1.43771-0.47923-1.91694l2.87541,0.47923-0.47924,0.47924c-0.47923,0-0.95847,0-1.4377,0.95847l-2.39618,10.5432h-0.47923l-3.83389-11.5016-2.39617,7.66776c0,1.43771,0.47923,1.43771,0.95847,1.91695v0.47923l-2.87542-0.95847v-0.47923c0.47924,0.47923,1.43771,0,1.43771-0.95848l2.39618-8.62623-0.47924-1.43771z'/%3E %3Cpath d='m880.456,476.88c-0.95847,4.31312-2.87541,5.27159-3.83388,5.27159h-0.95847s-0.47923-0.47924,0-0.95847l1.43771-9.58471c0.47923-0.47923,0.47923-0.95847,0.95847-0.47923h0.95847c0.95847,0,1.91694,1.91694,1.4377,5.75082l1.43771,0.47923c0.95847-4.79235-0.95847-6.70929-3.35465-7.18853-1.91694-0.47923-4.79235-0.95847-4.79235-0.95847v0.47924c0.47923,0.47923,1.43771,0.47923,0.95847,1.91694l-1.43771,8.62624c-0.47923,0.95847-0.95847,1.4377-1.4377,1.4377h-0.47924l4.79236,0.95847c2.39617,0.47924,4.79235,0,5.75082-5.27159l-1.43771-0.47923z'/%3E %3Cpath d='m884.769,473.046c0-0.95847-0.95847-1.43771-1.4377-1.43771v-0.47923l8.62623,0.95847-0.47923,3.83388c0-2.39618-1.43771-3.35465-2.39618-3.35465-0.47923-0.47923-0.95847-0.47923-1.43771-0.47923-0.47923,0-0.47923,0-0.47923,1.4377,0,0.47924-0.47924,3.83388-0.47924,3.83388,0.47924,0,1.91695,0.47924,2.87542-2.39617l-0.47924,6.23006h-0.47923c0-2.87541-1.43771-2.87541-1.91695-2.87541l-0.47923,4.31311c0,0.95847,0,0.95847,0.47923,0.95847l0.95847,0.47924c1.43771,0,2.87542-0.47924,3.83389-3.35465h0.47923l-0.95847,3.83389-9.10547-0.95848c0.95847,0,1.43771-0.47923,1.91694-1.4377l0.95847-9.10547z'/%3E %3Cpath d='m900.584,478.797c0,4.31312-1.43771,5.75083-2.87541,5.75083-0.47924-0.47924-0.47924-0.47924-0.95847-0.47924l-0.47924-0.47924,0.47924-10.0639c0-0.47923,0-0.47923,0.47923-0.47923h0.95847c0.95847,0,2.39618,1.4377,2.39618,5.75082h1.91694c0-4.79235-2.39618-6.23006-4.79235-6.23006-1.91694-0.47923-4.79236-0.47923-4.79236-0.47923v0.47923c0.47924,0,1.43771,0.47924,1.43771,1.43771l-0.47924,9.10547c0,0.95847-0.47923,1.43771-0.95847,1.43771v0.47923h4.31312c2.39618,0,4.79235-0.95847,5.27159-6.23006h-1.91694z'/%3E %3Cpath d='m914.482,482.631c0,0.95847,0.47924,0.95847,1.43771,0.95847v0.47924l-5.27159,0.47924c0.47924-0.47924,1.43771-0.95848,1.43771-1.91695l-0.95847-9.10547c-0.47924-0.95847-0.95847-0.95847-1.91694-0.95847v-0.47923l5.27158-0.47924c-0.47923,0.47924-1.4377,0.95847-0.95847,1.91694l0.95847,9.10547z'/%3E %3Cpath d='m919.274,483.589,0-0.47923c0.47923,0,0.95847-0.47924,0.95847-1.43771l-1.91694-10.0639h-0.47924c-0.95847,0.47924-1.91694,1.43771-1.4377,3.35465h-0.47924l-0.47924-3.35465,8.62624-1.43771,0.47924,3.35465h-0.47924c0-1.91694-1.43771-2.39617-2.87541-2.39617h-0.47924l1.91694,10.0639c0,0.95847,0.47924,1.4377,1.43771,1.4377v0.47924l-4.79235,0.47923z'/%3E %3Cpath d='m939.881,474.004-1.91694-5.75083c0-0.95847-0.95847-0.95847-1.43771-0.95847v-0.47923l2.39618-0.95847v0.47923c-0.47924,0.47924-0.47924,0.47924-0.47924,1.43771l1.91694,6.23006c0.47924,1.91694,0.47924,4.79235-2.39617,5.75082-1.91695,0.47924-4.31312-0.47923-4.79236-3.35465l-1.91694-6.23006c-0.47923-0.95847-0.95847-0.95847-1.4377-0.95847l-0.47924-0.47923,4.79235-1.43771v0.47924c-0.47923,0.47923-0.95847,0.95847-0.47923,1.91694l1.4377,6.23006c0.47924,1.91694,1.91695,2.87541,3.35465,2.87541,1.43771-0.47923,1.91694-2.39618,1.43771-4.79235z'/%3E %3Cpath d='m945.153,470.65c2.39617-0.95847,1.91694-2.39618,1.4377-3.83388-0.47923-1.43771-1.4377-2.39618-2.39617-1.91694-0.47924,0-0.95848,0.47923-0.47924,0.95847l1.43771,4.79235,0.47923,0.47924,0.95847,3.83388c0.47924,0.95847,1.43771,0.95847,1.91694,0.47923v0.47924l-4.31311,1.91694-0.47924-0.47924c0.95847-0.47923,0.95847-0.95847,0.95847-1.91694l-3.35465-8.147c-0.47923-1.4377-0.95847-0.95847-1.91694-0.95847v-0.47923l4.79236-1.91694c1.91694-0.47924,3.83388,0,4.79235,1.91694,0.47923,2.39617-0.47924,3.83388-2.39618,4.79235-0.47923,0-0.95847,0.47924-0.95847,0.47924l-0.47923-0.47924z'/%3E %3Cpath d='m957.134,472.087c-1.43771,0.47923-3.35465-1.43771-4.79235-4.79236-1.43771-2.87541-1.43771-5.75082,0-6.23006,1.4377-0.47923,3.35464,1.43771,4.79235,4.31312s1.43771,5.75083,0,6.7093c2.87541-0.95847,3.83388-4.31312,2.39618-7.66777-1.43771-2.87541-4.31312-4.79235-7.18853-3.83388-2.87542,1.4377-3.83389,4.79235-2.39618,7.66776,1.43771,3.35465,4.31312,5.27159,7.18853,3.83389z'/%3E %3Cpath d='m957.613,458.669h-0.47924-0.47924l2.87542-1.91695,8.62623,4.79236-2.87541-5.27159c-0.47923-0.95847-1.43771-0.95847-1.91694-0.95847v-0.47924l2.39618-0.95847c-0.47924,0.47924-0.95847,0.95847,0,1.91694l4.79235,9.58471-0.47924,0.47924-10.5432-5.75083,3.83388,7.18853c0.47923,0.95847,1.43771,0.95847,1.91694,0.47924v0.47923l-2.39618,1.43771v-0.47924c0.47924-0.47923,0.47924-0.95847,0-1.91694l-3.83388-7.66776-1.4377-0.95847z'/%3E %3Cpath d='m979.178,460.107,0-0.47923c0-0.47924,0.47923-0.95847,0-1.91694l-5.75083-8.14701h-0.47923c-0.95847,0.47924-1.43771,2.39618,0,3.83389l-0.47924,0.47923-1.91694-3.35464,7.18853-4.79236,1.91694,2.87541c-1.4377-1.4377-2.87541-1.4377-3.83388-0.95847l-0.47924,0.47924,5.75083,8.147c0.47923,0.95847,1.4377,0.95847,1.91694,0.47923v0.47924l-3.83388,2.87541z'/%3E %3Cpath d='m984.45,448.605,2.87541,3.35465c0.47923,0.47924,1.4377,0.47924,1.91694,0v0.47924l-3.83388,3.35464v-0.47923c0.47923-0.47924,0.47923-0.95847,0-1.91694l-5.75083-7.18853c-0.47923-0.95847-0.95847-0.47924-1.91694-0.47924l3.83388-3.35465v0.47924c0,0.47923-0.47923,0.95847,0,1.91694l2.39618,2.87541,2.87541-1.91694-2.39617-3.35465c-0.47924-0.95847-1.43771-0.47923-1.91695-0.47923l3.83389-3.35465v0.47924c-0.47924,0.47923-0.47924,0.95847,0,1.91694l5.75082,7.18853c0.47924,0.47923,0.95847,0.47923,1.43771,0l0.47923,0.47923-3.83388,3.35465-0.47924-0.47923c0.47924-0.47924,0.95847-0.95847,0.47924-1.91695l-2.87541-3.35464-2.87541,2.39617z'/%3E %3Cpath d='m988.763,438.541c-0.47923-0.47923-1.4377-0.47923-1.91694,0v-0.47923l6.23006-5.75083,2.87541,2.87541h-0.47923c-1.43771-1.91694-3.35465-0.95847-4.31312-0.47923,0,0.47923-0.47924,0.47923-0.95847,0.95847,0,0,0,0.47923,0.47923,1.43771,0.47924,0.47923,2.87542,2.87541,2.87542,2.87541,0.47923-0.47924,1.91694-1.43771,0-3.83389h0.47923l3.83388,4.31312v0.47924c-2.39617-2.39618-3.35464-0.95847-3.83388-0.47924l2.87541,2.87541c0.47924,0.95848,0.95847,0.95848,0.95847,0.95848,0.47924-0.47924,0.95848-0.95848,1.43771-1.43771,0.47924-0.47924,0.95845-1.91694,0-4.79235h0.47924l1.91691,3.35464-6.23003,6.23006-0.47924-0.47923c0.47924-0.47924,0.95847-0.95847,0-1.91694l-6.23006-6.7093z'/%3E %3Cpath d='m1000.26,425.122c-0.47921,0.47924-0.47921,1.43771,0.4793,1.91694,0.9584,0.95847,1.9169,0.95847,3.8338,0,0.9585-0.47923,2.8755-0.95847,4.3132,0.47924,2.3961,2.39618,1.4377,4.31312,0.9584,5.27159-0.4792,0.47923-1.4377,0.95847-1.9169,1.4377-0.4792,0-0.4792,0-0.4792,0.47924v0.47923l-3.3547-2.87541h0.4792c1.917,0.95847,3.8339,1.43771,4.7924,0,0.9585-0.95847,0-1.91694-0.4792-2.39617-0.9585-0.95848-1.917-0.95848-3.3547,0-1.4377,0.47923-3.3546,0.47923-4.7923-0.47924-1.91698-1.91694-1.91698-3.35465-0.95851-4.79235,0.47921-0.47924,1.43771-0.95847,1.91691-1.43771,0.4793,0,0.4793,0,0-0.95847l3.3547,2.39618h-0.4793c-2.3961-0.95847-3.8338-0.47924-4.3131,0.47923z'/%3E %3Cpath d='m1004.58,421.288c-0.9584-0.47924-1.4377,0-1.9169,0.47923h-0.4792l5.2716-7.66776,3.3546,2.39618-0.4792,0.47923c-1.917-1.43771-3.8339-0.47923-4.3132,0,0,0.47924-0.4792,0.95847-0.4792,1.43771-0.4792,0-0.4792,0.47923,0.4792,0.95847,0.4793,0.47923,3.3547,2.39617,3.3547,2.39617,0.4792-0.47923,1.4377-1.4377-0.4792-3.35464v-0.47924l4.7923,3.83388c-2.8754-1.4377-3.3546,0-3.8339,0.47924l3.3547,2.39618c0.9584,0.47923,1.4377,0.47923,1.4377,0.47923,0-0.47923,0.4792-0.95847,0.9585-1.4377,0.4792-0.95848,0.9584-2.39618-0.9585-4.31312l0.4792-0.47924,2.3962,2.87541-4.7924,7.18853h-0.4792c0.4792-0.95847,0.4792-1.4377-0.4792-2.39617l-7.1886-5.27159z'/%3E %3Cpath d='m1017.52,412.662-1.4377,2.39618c-1.917-1.91694-2.8754-3.35465-2.8754-3.35465l4.3131,0.95847h0.9585c0.4792,0,1.4377,0.47924,1.9169,0.47924,1.4377,0.47923,0.9585,0.95847,0.4792,1.91694h0.4793l2.3962-4.31312c-0.9585,0.95847-1.4378,0.47924-2.3962,0.47924-10.064-1.91694-11.0224-2.39618-11.0224-2.39618v0.47924l7.6677,8.62623c0.4793,0.47924,0.4793,1.43771,0.4793,1.91694h0.4792l1.4377-2.39617-0.4792-0.47924c-0.4793,0.95847-0.9585,1.43771-1.917,0-0.4792-0.47923-0.9584-0.95847-0.9584-0.95847l1.4377-3.35465h-0.9585z'/%3E %3Cpath d='m1014.64,402.119c-0.4793,0.47924-0.4793,1.43771,0.9585,1.91695,1.4377,0.47923,1.9169,0,3.3546-0.95847,1.4377-0.95848,2.8754-1.91695,4.7924-0.95848,2.8754,1.43771,2.3961,3.83389,1.9169,4.79236-0.4792,0.47923-0.9585,1.4377-1.4377,1.91694v0.47924,0.47923l-3.8339-1.91694c2.3962,0.47923,4.3131,0,4.7924-1.43771,0.4792-0.95847-0.4793-1.91694-0.9585-2.39617-0.9585-0.47924-1.917,0-3.3547,0.95847-1.4377,1.4377-2.8754,1.91694-4.7923,0.95847-1.917-0.95847-2.8754-2.39618-1.917-3.83389,0-0.95847,0.9585-1.4377,1.4378-1.91694,0-0.47923,0-0.47923-0.4793-0.95847v-0.47923l3.8339,1.91694h-0.4792c-2.3962-0.47924-3.8339,0.47923-3.8339,1.4377z'/%3E %3C/g%3E %3C/g%3E %3Cg id='crest'%3E %3Cg id='rope' fill='%23073163'%3E %3Cpath fill='%23fff' d='m863.203,232.47c-6.23006,1.43771-10.5432,1.91694-16.294-3.35465-3.83388-3.83388-2.87541-10.5432,0.95847-12.9394,4.31312-2.87541,8.147-4.79235,13.4186-3.35465,5.27159,1.43771,19.1694,14.3771,15.8148,14.8563-3.35465,0-8.62624,3.35464-13.8978,4.79235z'/%3E %3Cpath fill='%23fff' d='m878.06,209.466c1.91694-1.4377,4.31312-2.39617,10.5432-2.87541,5.75082-0.47923,10.0639-0.47923,11.5016,3.83388,1.91694,5.27159,3.35465,11.5016,7.18853,14.3771-2.39617,1.4377-14.3771,2.87541-18.6902,0.47923-5.75083-2.87541-7.18854-13.8978-10.5432-15.8148z'/%3E %3Cpath fill='%23fff' d='m919.274,209.946c1.91694-1.43771,4.31312-1.43771,10.5432-0.95847,6.23005,0.47923,8.62623,0.95847,10.0639,5.27159,1.4377,4.79235,0,11.0224,2.87541,15.3355-2.87541,0.95847-12.4601,0.95847-15.8148-2.39618-5.27159-3.83388-4.79235-14.8563-7.66776-17.2525z'/%3E %3Cpath d='m948.028,212.821c-4.31312-0.95847-7.18853-1.4377-9.10547,0,2.39617,2.87541,0.47923,14.3771,5.27159,18.2109,3.35464,2.39618,11.9809,2.87542,13.8978-2.39617,2.39618-4.79236,2.39618-11.9809-10.0639-15.8148z'/%3E %3Cpath d='m898.667,208.029c1.4377-1.43771,4.31312-1.91694,10.0639-1.91694,6.23006,0,10.0639,0.95847,11.9809,4.79235,1.91694,4.79235,1.43771,11.0224,4.79236,14.8563-1.43771,1.91694-14.3771,1.91694-18.211-0.95847-5.27159-3.35465-5.75082-14.3771-8.62623-16.7732z'/%3E %3Cpath d='m857.932,212.342c0-2.39618,3.35465-2.87542,11.9809-3.35465,8.62623-0.95847,9.10547-0.47924,11.9809,5.75082,1.43771,3.35465,3.35465,9.10547,7.18853,11.0224-10.5432,2.39617-13.8978,3.83388-19.6486,0.47923-4.31312-2.39618-9.10547-8.147-10.0639-10.5432-0.47924-1.4377-0.47924-2.87541-1.43771-3.35464z'/%3E %3C/g%3E %3Cg fill='%23f9d050' stroke-width='0.6469'%3E %3Cg id='pineapple1'%3E %3Cpath d='m880.935,163.46c-10.0639-7.66777-22.0448-14.8563-33.0672-16.294,7.18853,4.31312,27.3164,20.1279,32.588,25.3995'/%3E %3Cpath d='m886.686,156.271c-11.9809-8.147-25.8787-17.2525-39.2973-18.2109,10.064,5.27159,24.9202,17.7317,33.0672,27.7956'/%3E %3Cpath d='m902.021,142.853c6.7093-14.8563,13.8978-23.0033,23.4825-32.1088-4.79236,10.0639-10.064,30.6711-12.4601,38.8181'/%3E %3Cpath d='m912.565,140.457c4.79236-10.5432,11.9809-19.6486,24.441-25.3995-6.23006,6.23006-15.8148,24.9202-18.211,34.9842'/%3E %3Cpath d='m916.878,150.041c5.75082-8.147,17.2525-23.4825,37.8596-31.6295-11.9809,11.9809-29.7126,34.0257-34.0257,42.6519'/%3E %3Cpath d='m923.587,160.584c8.62623-4.79236,25.8787-12.4601,38.3388-10.0639-7.66776,2.87541-30.6711,13.4186-40.735,23.0033'/%3E %3Cpath d='m921.67,157.23c8.14701-8.62624,23.0033-21.5656,38.8181-26.8372-11.5016,11.0224-35.9426,35.9426-39.2973,39.7765'/%3E %3Cpath d='m898.667,151.958c-5.75083-17.7317-14.3771-34.5049-27.3164-39.7765,7.18853,10.5432,16.294,25.8787,21.0864,48.882'/%3E %3Cpath d='m887.644,151.479c-9.5847-11.5016-22.5241-23.0033-37.3804-25.3995,10.0639,5.75083,26.8372,22.5241,33.0672,38.8181'/%3E %3Cpath d='m892.916,151c-11.9809-21.5656-21.0864-25.3995-26.3579-29.7126,4.31312,8.147,14.8563,29.7126,21.0864,38.8181'/%3E %3Cpath fill='none' d='m868.954,149.562c5.75082,3.35464,14.3771,11.5016,17.2525,16.7732'/%3E %3Cpath d='m868.954,159.626c2.87541,2.39617,8.147,5.27159,12.9394,9.5847'/%3E %3Cpath d='m925.983,166.814c4.79236-3.83388,15.3355-10.0639,20.6071-11.9809'/%3E %3Cpath d='m922.629,163.46c4.79236-6.23006,14.3771-14.8563,17.7317-17.7317'/%3E %3Cpath d='m936.047,133.747c-4.31311,4.79235-14.3771,16.7732-18.2109,22.5241'/%3E %3Cpath d='m923.587,129.434c-3.35465,4.31312-10.064,16.7732-11.9809,21.0864'/%3E %3Cpath d='m885.727,130.393c2.87542,7.66777,8.147,20.6071,10.064,25.8787'/%3E %3Cpath d='m881.414,138.54c1.91695,2.87541,5.75083,9.58471,7.18854,14.3771'/%3E %3C/g%3E %3Cg id='pineapple2'%3E %3Cpath d='m897.708,136.143c0-4.31312,2.87541-9.10548,5.75082-9.10548,3.35465,0,5.75083,5.75083,5.75083,9.10548,0,3.83388-2.87542,7.18853-5.75083,7.18853s-5.75082-2.87542-5.75082-7.18853z'/%3E %3Cpath d='m891.478,139.977c0.47923-4.79236,3.83388-8.62624,6.70929-8.147,2.87541,0.47923,4.31312,6.23006,3.83388,9.5847-0.47923,3.83389-3.83388,6.7093-6.23005,6.23006-2.39618,0-4.79236-3.35464-4.31312-7.66776z'/%3E %3Cpath d='m904.418,141.415c-0.95847-4.31311,0.95847-9.10547,3.83388-9.5847,2.87542-0.47924,5.75083,4.31312,6.23006,8.147,0.95847,3.83388-1.4377,7.66776-3.83388,7.66776-2.39618,0.47924-5.75082-1.91694-6.23006-6.23006z'/%3E %3Cpath d='m897.229,145.249c0-4.79236,2.87541-9.10547,5.75083-9.10547,3.35464,0,5.75082,5.27158,5.75082,9.10547,0,3.83388-2.87541,7.18853-5.75082,7.18853-2.87542,0-5.75083-2.87541-5.75083-7.18853z'/%3E %3Cpath d='m888.603,147.645c0-4.31311,3.35464-9.10547,6.23005-9.10547,2.87542,0,5.75083,5.75083,5.75083,9.10547,0,3.83389-3.35465,7.18853-5.75083,7.18853-2.87541,0-6.23005-2.87541-6.23005-7.18853z'/%3E %3Cpath d='m906.335,145.728c0-4.31312,2.87542-9.10547,5.75083-9.10547,3.35464,0,5.75082,5.75083,5.75082,9.10547,0,3.83389-2.87541,7.18853-5.75082,7.18853s-5.75083-2.87541-5.75083-7.18853z'/%3E %3Cpath d='m904.418,149.562c0-4.79236,3.35465-9.10548,6.23006-9.10548s5.75083,5.27159,5.75083,9.10548c0,3.83388-2.87542,7.18853-5.75083,7.18853s-6.23006-2.87542-6.23006-7.18853z'/%3E %3Cpath d='m896.75,153.875c0-4.79235,2.87541-9.10547,5.75082-9.10547,3.35465,0,5.75082,5.75083,5.75082,9.10547,0,3.83389-2.87541,7.18853-5.75082,7.18853s-5.75082-2.87541-5.75082-7.18853z'/%3E %3Cpath d='m884.769,153.875c0-4.79235,2.39618-9.10547,4.79236-9.10547,2.39617,0,4.31311,5.75083,4.31311,9.10547,0,3.83389-2.39617,7.18853-4.31311,7.18853-2.39618,0-4.79236-2.87541-4.79236-7.18853z'/%3E %3Cpath d='m911.606,152.917c0-4.31312,2.39618-8.62623,4.79236-8.62623,2.39617,0,4.79235,5.27159,4.79235,8.62623,0,4.31312-2.87541,7.18853-4.79235,7.18853-2.39618,0-4.79236-2.87541-4.79236-7.18853z'/%3E %3Cpath d='m914.482,161.064c0.95847-4.79235,3.83389-8.62623,5.75083-8.147,1.91694,0.47924,2.39617,6.23006,1.4377,9.58471-0.47923,4.31312-3.35464,6.70929-5.27158,6.23006-1.91695-0.47924-2.87542-3.83388-1.91695-7.66777z'/%3E %3Cpath d='m905.376,159.626c0.47924-4.31312,3.35465-8.62624,5.75083-8.147,2.87541,0,4.31311,5.75082,3.83388,9.10547-0.47924,4.31312-2.87541,7.18853-5.27159,6.70929-2.39618,0-4.79235-3.35464-4.31312-7.66776z'/%3E %3Cpath d='m891.958,161.064c-1.4377-4.79235-4.31312-8.147-6.23006-7.66776-1.91694,0.47923-2.39617,6.23006-1.4377,9.58471,0.95847,3.83388,3.83388,6.23005,5.75082,5.75082,1.43771-0.47924,2.87541-3.83388,1.91694-7.66777z'/%3E %3Cpath d='m888.603,160.105c0-4.31312,2.39617-8.62623,4.79235-8.62623,2.87541,0,4.79235,5.27159,4.79235,8.62623,0,4.31312-2.39617,7.18853-4.79235,7.18853-1.91694,0-4.79235-2.87541-4.79235-7.18853z'/%3E %3Cpath d='m895.791,162.022c0-4.79235,2.87541-9.10547,5.75082-9.10547,3.35465,0,5.75082,5.27159,5.75082,9.10547,0,3.83389-2.87541,7.18853-5.75082,7.18853s-5.75082-2.87541-5.75082-7.18853z'/%3E %3Cpath d='m898.188,109.306c-0.95847,3.83388-4.31312,7.18853-1.91694,12.4601-4.31312-1.43771-8.147-1.91695-11.5016,1.91694,4.31312-0.47924,8.147,0.95847,10.0639,3.83388-3.83388-0.47924-5.75082,1.43771-6.70929,3.83388,3.35465-0.95847,6.70929-1.91694,8.147-1.4377-1.43771,1.4377-3.83388,3.83388-4.31312,5.75082,2.87541-2.39618,6.23006-1.91694,8.147-3.35465-1.4377,3.35465,1.43771,6.7093,3.83389,10.064-0.47924-4.79236,2.39617-8.14701,0.95847-10.5432,4.31312,0.95847,4.79235,4.79235,11.0224,4.79235-2.39618-1.43771-3.83388-6.23006-6.70929-6.23006,1.4377-0.47923,7.18853-0.95847,8.147,0-0.95847-1.91694-4.31312-3.83388-6.23006-3.83388,1.91694-1.91694,5.27159-5.75083,7.66776-6.7093-3.35465,0.47924-8.62623,0.95847-10.5432,3.83389,4.79236-3.83389,3.83389-11.0224,9.10548-11.9809-2.87542-0.47923-7.18853,1.43771-10.5432,4.79236,1.4377-2.87542,1.4377-6.7093,3.35465-7.66777-3.83389,0.95847-8.14701,5.75082-9.58471,8.147,0-2.39618-1.43771-6.23006-2.39618-7.66776z'/%3E %3Cpath d='m900.584,116.974c0,1.43771,0,4.31312-0.47924,5.27159'/%3E %3Cpath d='m906.814,116.495c-0.95847,0.95847-2.87541,4.31311-2.87541,7.18853'/%3E %3Cpath fill='none' d='m909.689,122.246c-1.43771,0.95847-2.87541,2.39618-3.35465,4.31312'/%3E %3C/g%3E %3C/g%3E %3Cg id='turtle' fill='%23059334'%3E %3Cpath d='m858.89,169.69c-3.35464,0-6.23006-1.43771-8.147-3.83388-3.35465-4.31312-12.4601-6.23006-16.294-2.39618-1.43771,0.95847-3.35465,0.95847-4.79235,1.43771-2.39618,0-5.27159,2.39617-4.31312,7.18853,1.91694-1.43771,2.39618,0,3.83388,0,0.95847-0.47924,0.47924,0.47923,0.47924,1.4377,0,2.39618,5.27159,7.18853,10.0639,6.7093,5.27159,0,7.66776,1.91694,8.62624,2.87541,1.4377,1.43771,0.47923,0.95847,1.4377,3.35465,1.43771,1.4377,1.91694,1.91694-0.47923,3.83388-3.35465,2.87541-5.75083,9.58471,0,14.8563,6.23006,4.79235,22.0448,11.9809,39.7765-1.91695,17.2525-13.4186,44.0896-5.75082,46.0066-0.95847,2.39618,4.79236,3.35465,7.66777,3.83389,10.064,0.47923,1.91694,2.87541,3.83388,6.23006,3.35464,3.35464,0,7.18853,1.43771,9.10547,2.87542,2.39617,1.4377,5.75082,0.95847,4.79235-3.35465-1.91694-13.4186-10.0639-15.3355-11.0224-21.5656,4.79235,0.47923,8.147,0.47923,10.0639-1.43771,1.43771-1.91694,3.35465-5.27159,5.27159-6.23006,1.43771-0.95847,1.43771-1.91694-0.47924-1.4377-2.39617,0.47923-3.83388,1.4377-8.147,0.95847-22.0448-2.39618-83.8662-19.1694-95.8471-15.8148z'/%3E %3Cpath fill='%23000' d='m956.654,185.984c-2.39617,1.43771-4.79235,3.83388-9.10547,9.58471-4.79235,6.23006-19.1694,12.4601-36.9011,12.4601-17.2525,0-27.7956-2.87541-35.4634-9.10547-4.31312-3.35465-7.66777-5.27159-10.5432-6.7093-5.27159-2.39618-6.23006-7.66776-4.79236-11.9809-1.4377,2.39617-2.39617,4.79235-5.27158,4.31312-1.91695,0-5.75083,0-4.79236,1.91694-0.47923-0.95847-0.47923-2.39618-0.95847-2.87541-0.47923-0.47924-0.95847-0.95848-0.95847-0.95848,1.43771,0.95848,4.79235-1.91694,7.18853-1.91694,1.91694,0.47924,4.31312-1.91694,3.83388-4.79235-0.47923-2.39618-0.95847-4.31312-1.4377-6.23006,3.83388-1.91694,54.1536,7.18853,64.2175,8.147,10.064,0.47924,38.8181,4.79235,34.9842,8.147z'/%3E %3Cpath d='m865.6,167.773c4.79235-4.79235,10.5432-7.18853,16.294-5.75083h1.43771c2.87541-2.39617,9.5847-2.87541,13.4186-0.95847h1.91694c5.75082-1.91694,16.7732,0,20.6071,3.83389l1.4377,0.95847c12.9394-0.95847,20.6071,4.79235,29.7126,13.8978,0.95847,0.95847,2.39617,2.87541,4.79235,3.35465,2.87541,0.47924,3.35465,1.91694,0.95847,3.35465-2.87541,1.4377-5.27159,3.83388-10.0639,9.10547-4.31312,5.75082-18.211,11.5016-35.4634,11.5016-16.7732,0-26.8372-2.87541-34.5049-8.62624-4.31312-3.35465-7.66777-5.27159-10.064-6.70929-2.87541-0.95847-6.70929-4.79236-5.27159-8.62624,0.95848-3.83388-1.4377-8.62624-3.35464-13.4186,1.4377-0.95847,5.27159-2.39618,7.18853-1.43771l0.95847-0.47923z'/%3E %3Cg fill='%2300493d'%3E %3Cpath d='m950.424,179.754c-9.10548-9.10547-16.7732-14.8563-29.7126-13.8978,0,0.47923,0,1.91694-0.47923,2.87541,7.66776,2.87541,18.6902,11.5016,23.4825,17.7317,1.91694-1.91694,5.27159-4.31312,6.7093-6.7093z'/%3E %3Cpath d='m919.274,164.898c-3.83389-3.83389-14.8563-5.75083-20.6071-3.83389,0,1.91695,0,4.79236-0.95847,6.7093,3.35464,1.4377,6.23006,4.79235,9.10547,8.147,1.91694-0.47924,6.70929-1.91694,9.10547-2.39618,0.95847-1.91694,2.87541-6.23006,3.35465-8.62623z'/%3E %3Cpath d='m896.75,161.064c-3.83389-1.91694-10.5432-1.4377-13.4186,0.95847-0.95847,1.91695-1.43771,5.75083-1.43771,7.66777,1.91694,0,4.79235,1.43771,5.75082,2.39618,2.87542-0.95847,6.7093-2.87542,8.14701-4.31312,0.47923-1.91694,1.4377-4.79235,0.95847-6.7093z'/%3E %3Cpath d='m865.6,167.773c4.79235-4.79235,10.5432-7.18853,16.294-5.75083-0.95847,1.43771-1.43771,4.31312-1.43771,7.18853-5.27158-0.47923-11.9809,0.95848-14.8563,2.87542v-4.31312z'/%3E %3Cpath d='m941.798,187.422c-4.31312-6.23006-14.8563-13.4186-22.0448-16.7732,0,0.47924-0.95847,2.39618-1.4377,3.83388,2.87541,4.31312,8.62623,13.8978,11.0224,19.1694,2.39618-0.95847,9.10547-3.83389,12.4601-6.23006z'/%3E %3Cpath d='m905.376,197.965c0.95847-6.7093,1.43771-16.294,1.43771-19.6486,2.39618-0.47924,7.18853-1.91694,9.10547-2.39618,2.39618,3.83388,8.147,13.8978,10.5432,18.6902-5.75083,1.4377-15.3355,3.83388-21.0864,3.35465z'/%3E %3Cpath d='m888.603,174.961c2.39617-0.95847,5.75082-2.87541,8.147-4.79235,1.91694,1.4377,5.75082,4.79235,7.18853,6.70929,0,4.31312-1.43771,16.7732-1.91695,21.0864-3.83388,0-10.0639-0.95847-13.4186-2.87542,0.47923-7.18853,0.95847-15.3355,0-20.1279z'/%3E %3Cpath d='m864.641,180.712c0.47923-0.95847,0.95847-4.31311,0.95847-5.75082,3.83388-2.39618,13.4186-4.79235,20.6071-0.95847,0.47923,4.79235,0,16.7732-0.47924,19.6486-6.23006-4.79236-16.294-11.5016-21.0864-12.9394z'/%3E %3C/g%3E %3Cg fill='none'%3E %3Cpath fill='%23000' stroke='none' d='m840.679,172.086c-0.95847,0-1.43771-2.87542-3.35465-2.87542-0.47923,0-1.91694,0.47924-2.39617,0,0,0.95848,0.47923,1.91695,0.95847,2.39618,0.47923,1.43771,2.87541,0.47924,4.79235,0.47924z'/%3E %3Cpath d='m840.679,180.233c5.75082,0,6.70929-7.18853,9.58471-7.66777'/%3E %3Cpath d='m844.034,180.712c4.31312,1.91694,7.66776-8.147,11.0224-7.66776'/%3E %3Cpath d='m835.408,168.252c1.43771,0,2.39618-1.91694,4.79235,0.47924,0.95848,0.95847,2.39618,1.43771,3.35465,1.43771'/%3E %3Cpath d='m842.596,175.441c-1.91694,2.87542-5.27159,4.79236-7.18853,3.83389'/%3E %3Cpath d='m834.449,163.46c-1.43771,0.95847-2.39618,2.87541-3.35465,4.31312'/%3E %3Cpath d='m829.657,170.648v2.39618'/%3E %3C/g%3E %3C/g%3E %3C/g%3E %3Cg stroke='none'%3E %3Cpath id='shield' fill='%23fff' d='m989.722,232.949v93.4509c0,80.9908-38.3388,108.786-89.617,130.831-51.2781-22.0448-90.0962-49.8405-90.0962-130.831v-93.4509h179.713z'/%3E %3Cpath fill='%23cf142b' d='m900.105,312.023c4.31315,0,11.0224-3.83388,16.7732-9.5847,6.23004-6.70929,16.7732-9.10547,27.7958,0,11.0224,9.10548,17.7317,5.27159,23.4825,0,5.75082-5.27158,10.5432-7.18853,21.5656-7.18853v-62.3006h-179.713v62.3006c11.0224,0,15.8148,1.91695,21.5656,7.18853,5.75082,5.27159,12.4602,9.10548,23.4826,0,11.5016-9.10547,21.5656-6.70929,28.2748,0,5.27159,5.75082,11.9808,9.5847,16.7732,9.5847z'/%3E %3Cg fill='%230b50a0'%3E %3Cpath d='m900.105,359.946c5.75083,0,17.2525-6.23006,20.1279-7.66776,10.5432-6.23006,18.2109-0.47924,24.441,2.39618,6.7093,2.87541,19.1694,6.23005,26.8372,0,7.66777-6.23006,11.9809-5.75083,17.2525-5.75083,0.95847-7.18853,0.95847-14.3771,0.95847-22.5241v-5.75082c-6.70929-1.43771-10.0639,0.47923-17.2525,6.70929-7.18853,6.23006-15.3355,4.79235-25.8787,0.95847-10.0639-4.31312-20.1279-11.9809-30.1918,0-2.87542,3.35465-9.58471,8.147-16.294,8.147-7.18853,0-13.4186-4.79235-16.294-8.147-10.5432-11.9809-20.1279-4.31312-30.1918,0-10.5432,3.83388-19.1694,5.27159-26.3579-0.95847-6.70929-6.23006-10.0639-8.147-17.2525-6.70929v5.75082c0,8.147,0.47923,15.3355,1.4377,22.5241,5.27159,0,9.10548-0.47923,16.7732,5.75083,7.66777,6.23005,20.6071,2.87541,26.8372,0,6.7093-2.87542,14.3771-8.62624,24.9202-2.39618,2.87541,1.4377,13.8978,7.66776,20.1279,7.66776z'/%3E %3Cpath d='m900.105,380.553c7.18853,0,15.8148-2.87541,23.4825-7.18853,9.5847-5.27158,16.294-2.87541,25.8787,1.91695,10.064,4.79235,18.211,3.35464,23.9618,0,2.87541-1.91695,5.27159-5.75083,11.5016-4.31312-2.87541,11.9809-7.18853,22.5241-12.4601,31.1503-9.58471,2.39618-14.8563,2.39618-24.9202-1.91694-10.0639-4.79235-22.5241-7.66776-29.2334-3.35464-6.23006,3.83388-12.9394,5.75082-18.211,5.75082-5.27159,0-11.9809-1.91694-18.2109-5.75082-6.70929-4.31312-19.1694-1.43771-29.2334,3.35464-10.0639,4.31312-15.3355,4.31312-24.9202,1.91694-5.27159-8.62623-9.58471-19.1694-12.4601-31.1503,6.23006-1.43771,8.62623,2.39617,11.5016,4.31312,5.27159,3.35464,13.8978,4.79235,23.4825,0,10.0639-4.79236,16.7732-7.18853,26.3579-1.91695,7.66777,4.31312,16.294,7.18853,23.4825,7.18853z'/%3E %3Cpath d='m900.105,457.231c19.1694-8.147,36.9011-17.2525,51.2782-29.7126-3.83389-1.43771-6.23006-0.47924-9.58471-2.87541-3.35465-2.39618-13.4186-3.35465-22.0448,1.4377-9.10547,4.31312-12.9394,5.27159-19.6486,5.27159-6.70929,0-10.5432-0.95847-19.6486-5.27159-8.62623-4.79235-18.6902-3.83388-22.0448-1.4377-3.35465,2.39617-5.75083,1.4377-9.58471,2.87541,14.3771,12.4601,31.6295,21.5656,51.2782,29.7126z'/%3E %3C/g%3E %3Cg id='lion' stroke='%23000' stroke-width='1.4377'%3E %3Cpath fill='%23f9d050' d='m887.644,256.432c0.47924,0.95847-0.47923,3.35465,0,4.31312,0.95848,1.91694,0.95848,2.87541,2.39618,3.83388h3.35465c10.5432,0,23.0033-4.31312,33.5465-4.31312,10.064,0,16.294,3.35465,22.0448,3.35465,3.35465,0,6.23006-2.39618,6.23006-4.79235,0-2.39618-3.83388-3.83389-11.9809-3.83389-11.5016,0-17.7317,2.87541-27.3164,2.87541-14.3771,0-16.7732-5.27158-16.7732-7.66776s2.39618-5.75083,10.064-5.75083c2.39617,0,4.31311-0.47923,5.27158-1.4377,0.47924-0.95847,1.91695-2.87541,4.79236-4.31312,3.35464-1.91694,10.0639,0,13.4186-2.39618,0,1.91695-2.87541,4.79236-5.27159,5.75083,4.79235-1.43771,10.0639-1.43771,11.0224,2.39617-2.39618-1.4377-6.23006-0.47923-7.66776,0-1.91695,0.47924-2.87542,0.95848-4.79236,1.43771,1.91694-0.47923,2.87541,3.35465,5.75083,3.35465-2.87542,2.39617-7.66777,2.39617-12.4601,0.47923-1.43771-0.47923-5.27159-1.91694-7.66777-1.91694-4.79235,0-7.66776,0.95847-7.66776,2.87541,0,2.39618,2.87541,3.83389,11.5016,3.83389,8.62624,0,13.4186-2.39618,26.358-2.39618-0.95847-1.43771,0.47923-2.87541-1.43771-4.31312,4.79236,0,10.064,1.43771,11.9809,4.79236-0.47924-3.35465,2.39617-6.23006,1.4377-9.10548,2.87541,0.47924,5.27159,3.35465,5.75083,5.75083,0-1.43771,1.91694-1.43771,1.91694-2.87541,2.87541,1.4377,4.31312,4.79235,3.83388,7.66776,1.43771-2.39618,2.87541-1.4377,3.83388-4.31312,0.95847,1.91694,0.47924,7.66777-2.87541,9.58471,2.87541-1.91694,7.18853-1.91694,10.0639,1.43771-2.87541-0.47924-4.31311,0.95847-5.75082,1.4377-5.75082,3.35465-15.3355,5.27159-22.5241,4.79236-7.66777-0.47924-8.62624-1.91695-13.4186-1.91695,2.87541,0.47924,8.62623,6.23006,13.8978,6.23006,3.35465,0,5.75083,0,7.18853-0.47923,1.43771-0.47924,3.83389,0,5.75083,0.95847,1.4377,1.43771,4.31312,2.87541,6.23006,2.39618-0.47924,1.91694-1.43771,2.87541-2.87541,3.35464,2.39617,1.43771,0.95847,2.39618,3.35464,4.31312-0.95847,0-1.91694,0.95847-3.35464,0.47924,1.4377,1.4377,1.4377,3.35464,2.87541,4.31312-0.47924,0-1.91694,0.47923-2.87541,0,1.4377,1.91694,0,4.31311,1.4377,5.27158,1.43771,1.91695-1.4377,4.31312-3.83388,2.39618,0.47923,1.43771-0.95847,2.87541-2.39618,2.39618-1.4377-0.47924-2.39617-1.91694-1.91694-2.39618,0-0.47923,0-0.47923,0.47924-0.95847-0.95847,1.43771-2.87542,1.43771-3.83389,0.95847-0.47923-0.47923-0.95847-0.95847-0.95847-1.4377-3.35464,0.95847-4.79235-1.91695-4.31312-3.35465,0.47924-1.43771,3.35465-1.91694,4.31312-1.43771,0.95847,0.47924,1.91694,0.95847,2.87541,0,0.95848-0.47923,1.43771-1.4377,1.43771-2.39618,0-1.4377-1.43771-5.75082-7.66776-5.27158-7.18854,0.47923-18.6902-1.43771-24.441-3.35465-0.47923-0.47924-0.95847-0.47924-1.4377-0.95847,0,1.91694-1.91695,2.87541-1.91695,4.79235,0,2.39618,0.95848,4.31312,3.83389,5.27159-1.43771,2.39618-3.83389,1.91694-4.79236,0.47924,0,1.4377-1.91694,2.39617-1.91694,4.31311-0.47923-0.95847-0.95847-1.4377-1.4377-2.39617-1.43771,3.35464-5.27159,5.27159-7.18853,4.31312-2.39618,1.91694-5.27159,1.4377-6.23006-0.47924-1.43771,0.95847-3.35465,0.95847-4.31312,0,0,1.43771-0.95847,0.95847-1.43771,2.87541,0,0.95847-1.91694,1.43771-2.87541,0.95847-0.95847-0.47923-1.43771-2.39617-0.47923-3.35464-1.43771,0.95847-2.87542,0.95847-3.83389,0,0-0.95848,0-2.39618,0.95847-2.87542h0.95847c-0.95847-0.47923-2.39617,0-3.35464-0.47923-0.95847-0.95847-0.95847-1.91694-0.47924-2.87541,0.47924-0.47924,1.91694-1.43771,2.87541-0.47924l0.47924,0.47924c0-0.95848,0.47923-1.91695,0.95847-1.91695,0.95847-0.47923,2.39618-0.47923,3.83388,0.95847,0.95847,1.43771,1.91694,1.43771,4.79236,0.95848,2.39617,0,6.23006-2.39618,9.10547-4.79236-8.147-1.4377-3.35465-6.70929-0.95847-8.62623-1.91694-0.47924-4.79236-0.47924-6.7093,0.47923-10.0639,5.27159-20.6071,11.5016-27.3164,9.58471,0,0.95847,0.47923,1.91694,0.95847,2.87541-1.43771,0-4.31312,0-5.27159-1.43771-0.47924,0.95847-1.43771,3.35465-0.47924,5.27159-0.95847-0.95847-3.83388-1.91694-5.27159-2.39617,0.95847,0.95847,0,2.87541,0.47924,4.31311-1.43771-1.4377-3.83388-2.39617-4.79235-1.4377s-2.87542,1.4377-4.31312,0.95847c-0.95847,1.43771-2.39618,2.39618-3.83388,2.87541,0-0.95847,0-2.39618-0.47924-2.87541-0.47924,1.43771-1.91694,3.35465-3.83388,4.31312,0-0.95847,0-2.39618-0.47924-3.35465,0,1.91694-3.83388,2.87541-4.31312,4.31312,0.47924-1.43771,0.47924-2.87541,0.47924-3.83388-0.95847,1.4377-2.39618,2.87541-4.79235,3.35464,0.47923-0.95847,0.95847-1.91694,0.47923-2.87541-0.47923,1.91694-3.35465,2.87541-5.75082,2.39618,0,0.95847-1.91694,2.39617-4.31312,0.95847-1.43771-0.47924-2.39618-1.91694-1.43771-2.87541-1.91694,0-3.83388-1.91695-2.87541-3.35465,0-0.47924,0.47924-0.95847,0.47924-1.43771-1.43771-0.95847-1.91695-2.87541-0.47924-4.31312,0.47924-0.47923,1.91694-0.47923,2.87541-0.47923,0-3.83388,3.35465-3.83388,4.79236-0.95847,0.95847,1.4377,3.83388,3.83388,6.23006,3.35465,0.95847,0,1.4377-0.47924,2.39617-0.47924,2.87541-0.95847,8.62624-3.35465,11.9809-6.23006,0.47923-1.43771,0.47923-2.39618,0.47923-3.35465-1.91694,0.95847-3.83388,1.91694-4.79235,3.35465v-1.43771c-1.43771,0-3.83389-0.47923-4.79236-0.47923,0.47924-0.47924,0.95847-2.87541,1.91695-3.35465-2.39618,0.47924-4.79236,0-6.7093-0.47923,0.95847-0.95847,0.95847-2.39618,1.43771-3.83389-0.95847,0.47924-3.35465-0.47923-5.27159,0,0.47923-1.4377,0.95847-3.35464,2.39617-3.83388-1.91694,0.47924-4.31311,0-6.70929-0.95847,1.91694,0,2.87541-2.39618,4.31312-2.39618-3.83388,0-4.79236-1.91694-6.7093-2.87541,1.43771,0.47924,2.39618-0.95847,3.83389-0.95847-1.43771-0.47923-3.83389-2.87541-2.87542-4.31312-0.47923,0.47924-0.95847,1.43771-1.91694,1.91694-0.95847,0.47924-2.87541,0-4.31312-1.4377-0.95847-1.91694-0.47923-4.31312,1.43771-4.79236-2.39618-0.47923-2.39618-2.87541-1.43771-3.83388,0.47924-0.95847,2.39618-2.39618,3.35465-0.95847,0.47924,0.47924,0.95847,1.43771,1.43771,1.91694-0.47924-0.95847-0.47924-2.87541-0.47924-4.31312,0.47924-1.4377,1.43771-1.4377,2.87541-1.91694,1.43771,0,2.39618,1.43771,2.39618,2.87541,0,1.43771,0.47924,2.39618,0.95847,4.31312,0-0.47923,0.47924-1.4377,0.47924-1.91694,0-1.91694,2.39617-1.4377,3.83388-0.95847,1.43771,0.47924,1.91694,3.35465,0,4.79235-0.95847,0.95847-0.47924,2.39618,0.47924,3.35465,3.35464,5.27159,9.10547,9.58471,13.8978,10.0639,0-1.91694,0.95847-3.83388,2.39618-5.27158,0-0.95848,0.47923-2.39618,0.95847-3.35465,0.47923-2.87541,1.91694-4.31312,3.83388-3.35465-0.47923-0.47924-0.95847-0.95847-0.95847-1.43771-1.43771-1.4377-2.87541-3.83388-1.91694-5.75082s3.83388-1.43771,4.79235-0.47924c-0.47923-2.87541,2.87541-5.27158,2.87541-6.70929,0.47924,1.43771,1.43771,3.35465,0.95847,4.79235,0.47924-1.91694,3.83389-4.31311,6.23006-5.27159-0.95847,1.43771,1.91695,3.83389,1.43771,5.27159,0.95847-2.39617,4.79235-3.83388,7.66777-3.83388-0.95847,0.95847-0.95847,2.87541-0.95847,3.83388,1.4377,0,3.83388-0.47923,4.79235-1.91694,0,1.91694-0.95847,3.83388-1.91694,4.79236,0.47923-0.47924,2.39617-0.47924,3.83388-0.47924-1.43771,1.43771-0.95847,2.87541-2.39618,3.83388,1.91695-0.95847,4.31312-0.95847,4.79236,0.95847,0.95847,1.43771-0.47924,3.83389-1.43771,5.27159-0.95847,0.47924-1.91694,1.43771-2.39618,1.43771z'/%3E %3Cg fill='none'%3E %3Cpath d='m857.932,262.182c-3.35464,1.43771-4.31312,4.79236-4.79235,6.7093'/%3E %3Cpath d='m857.453,265.537c-4.79236,2.87541-6.7093,5.27159-5.75083,10.5432'/%3E %3Cpath d='m859.849,279.914c2.87542-0.95847,4.79236-1.91694,7.18853-6.23006'/%3E %3Cpath d='m865.6,275.601c-0.95847,1.91694,0,5.27159-1.43771,6.7093,2.39618-1.43771,4.31312-3.35465,4.79236-6.7093'/%3E %3Cpath d='m866.558,280.872c1.91694-0.95847,4.79235-3.83388,6.23006-7.18853-0.47924,1.43771,0,3.83388-0.95847,5.27159,2.39617-2.39618,3.35465-3.83388,3.83388-6.23006,0,0.47924,0.47924,1.43771,0.47924,1.91694,0.95847-0.95847,1.91694-1.91694,1.91694-3.83388'/%3E %3Cpath d='m878.06,272.246v2.39617c1.91694-1.4377,2.39617-3.35465,2.39617-5.75082'/%3E %3Cpath d='m879.977,271.767c2.87541-1.91694,3.35465-4.79235,3.35465-9.10547'/%3E %3Cpath d='m883.331,267.454c1.91694-1.4377,2.39617-2.39618,2.39617-6.70929'/%3E %3Cpath d='m879.497,247.805c-0.95847,0-1.91694,0.47924-1.91694,1.91694,0,0.95847-1.4377,2.39618-1.4377,3.83389-0.47924,1.91694-1.43771,2.39617-2.87542,1.91694-1.4377-0.95847-1.4377-0.95847-1.4377-2.39618,0-1.91694,2.39617-2.39618,2.39617-4.31312,0.47924-0.95847,0.95848-2.39617,1.43771-2.39617-2.39618,1.4377-5.75082,0.47923-6.23006-2.39618'/%3E %3Cpath d='m883.811,249.243c-0.95847,0.47923-1.91694-0.95847-3.35465-0.47924-0.47923,0-1.91694,0.47924-2.39617,0'/%3E %3Cpath d='m877.101,251.639c0.47923,0.47924,2.87541,1.43771,5.27159,0.47924-1.91695,0.47924-3.35465-1.91694-1.43771-3.35465'/%3E %3Cpath d='m872.788,246.847c-1.91694,0-3.35465,1.43771-2.87541,2.87541,0.47923,1.43771,2.39617,1.43771,3.83388,0.47924'/%3E %3Cpath d='m869.433,270.809c0.47924-0.47924,0.95847-1.43771,0.95847-1.91694,0.95847,0,1.91694-0.47924,2.39618-0.95847,1.91694,0,3.35465-1.43771,3.83388-2.87542,0.95847,0,1.43771-2.39617,1.91694-3.35464,0.47924,0.47923,1.43771,0,1.91694-1.91694,0.95847,0.47923,2.39618,0,2.87542-1.43771'/%3E %3Cpath d='m863.683,254.994c0,0.47924-0.95847,1.43771-1.91694,1.91694,0.47923,0.95847,0,3.35465-0.95848,3.83389,0.47924,0.95847,0,2.39617-0.47923,3.35464,0,0.47924,0.47923,1.91695,0.47923,2.39618'/%3E %3Cpath d='m865.6,245.409c-0.95847,2.39617-0.47924,5.27158,1.4377,5.75082'/%3E %3Cpath d='m866.558,253.077c-0.47924,2.39618-0.47924,5.75083-0.95847,7.18853-0.47924,0.95847-1.43771,4.31312,2.39617,5.27159,4.31312,0.95847,6.7093,0.47924,9.10548-6.70929'/%3E %3Cpath d='m884.29,277.518c0,0.47924-0.47924,1.43771-1.43771,1.43771'/%3E %3Cpath d='m887.644,276.559c0,0.95847-0.95847,2.39618-1.4377,2.87542'/%3E %3Cpath d='m890.999,275.601c0,0.95847,0,2.39618-0.95847,2.87541'/%3E %3Cpath d='m861.766,245.888c0.47923,0,0.95847,0.95847,1.4377,1.91694-1.4377-0.95847-2.87541,1.43771-1.91694,2.87541'/%3E %3Cpath d='m860.328,254.035c-0.47924,0.47924-1.43771,0.95847-1.91694,1.43771'/%3E %3Cpath d='m858.89,258.348c-0.47923,0-0.95847,0.47924-1.4377,0.47924'/%3E %3Cpath d='m835.887,249.722c0-0.47923,0-0.47923,0.47923-0.95847'/%3E %3Cpath d='m831.574,248.284c-0.47924,0-0.47924,0-0.95847-0.47924'/%3E %3Cpath d='m832.053,254.994h0.95847'/%3E %3Cpath d='m830.136,252.118c-0.95847-0.95847-2.39617-1.43771-2.87541-1.43771'/%3E %3Cpath d='m856.494,269.85c-3.35465,2.87541-4.79236,5.27159-5.27159,8.62623'/%3E %3Cpath d='m859.849,272.246c-0.95847,1.91694-2.39617,3.35464-3.83388,4.31311'/%3E %3Cpath d='m841.159,286.623c-3.83389,0.95847-6.7093,0.47923-9.58471-1.43771-0.47924-0.47924-0.95847-0.47924-1.43771-0.95847'/%3E %3Cpath d='m855.536,279.914c-0.47924,1.91694-0.95847,4.31312-1.91695,4.79235,3.83389-1.91694,7.18853-4.79235,7.66777-9.10547'/%3E %3Cpath d='m827.74,289.02c1.4377-0.47923,2.87541,0.47924,3.83388-0.47923'/%3E %3Cpath d='m911.127,273.205c0.95847,0.47923,2.39617,0.95847,2.87541,1.4377,0.47923-0.95847,2.39618-2.39617,3.83388-2.87541'/%3E %3Cpath d='m877.101,283.269c-0.47924-1.91694,0.47923-4.31312,3.35464-5.27159'/%3E %3Cpath d='m858.411,291.416c0.47923-0.95847,0.47923-2.39618,0.95847-3.35465'/%3E %3Cpath d='m837.325,292.853c-0.47923,0.95847-1.4377,1.91694-1.4377,2.87541'/%3E %3Cpath d='m830.136,293.812s0-0.47924,0.47924-0.47924c0.95847-0.47923,2.39617-1.43771,2.87541-2.39618'/%3E %3Cpath d='m895.312,287.103c-0.95847,0.47924-1.43771,0-1.91694-0.47923'/%3E %3Cpath d='m894.833,289.499s-0.47923,0.47923-0.95847,0.47923'/%3E %3Cpath d='m897.229,291.895c-0.47923,0.47924-0.95847,0.95848-1.4377,0.95848'/%3E %3Cpath d='m911.127,292.853c0.95847-0.47924,1.4377-1.43771,1.91694-3.35465'/%3E %3Cpath d='m904.897,292.374c1.4377-0.47924,2.39617-1.43771,3.83388-2.87541'/%3E %3Cpath d='m918.315,288.54c0-0.95847,0-1.91694,0.47923-2.87542'/%3E %3Cpath d='m953.779,292.853c-0.95847-0.95848-0.95847-2.39618,0.47924-3.35465,0.95847-0.47924,1.4377-0.95847,2.39617-1.43771'/%3E %3Cpath d='m924.546,276.08c-7.66777-3.35465-7.18853-7.66777-13.4186-7.18853'/%3E %3Cpath d='m958.571,290.936c0.47923,0.47924,0,1.91695,0,2.39618'/%3E %3Cpath d='m962.884,290.936c-0.47923,1.43771-0.47923,1.91695-0.47923,3.35465'/%3E %3Cpath d='m925.983,245.888h-3.83388'/%3E %3Cpath d='m885.727,262.182c0,0.95847,1.43771,2.87541,5.27159,2.87541-0.47923,0-0.95847-0.47923-0.95847-0.47923'/%3E %3Cpath d='m887.644,256.432c-0.47923,0.47923-0.95847,0-0.95847,0-0.95847-0.95847,0.47924-2.87541,1.91695-3.83388-1.43771,0.47923-2.39618,0.47923-3.35465,0.47923-0.95847,2.87541-3.83389,4.31312-5.75083,2.39618-0.47923,1.91694-2.87541,4.31312-4.79235,3.83388-1.91694-0.95847-2.39618-2.39618-1.91694-3.83388-2.39618,2.87541-5.27159,0.95847-6.23006,0-0.47924-0.95847,0-3.35465,0.95847-6.23006'/%3E %3C/g%3E %3Cpath fill='%23000' stroke='none' d='m918.315,274.642c-1.43771,0.95847-2.87542,0-4.31312,1.43771-0.95847,0.95847,0.47923,1.4377,1.4377,1.4377-0.47923,1.43771-0.47923,1.91695,1.91695,1.91695-0.95847,1.4377,1.91694,1.91694,1.4377,3.83388,1.43771-1.43771,1.43771-3.35465,0.95847-4.79236-0.47923-1.4377-2.87541-2.39617-1.4377-3.83388z'/%3E %3Cg fill='%23073163' stroke='none'%3E %3Cpath d='m874.705,259.307c-1.91694-0.95847-2.39618-2.39618-1.91694-3.83388-0.47924,0.95847-1.43771,1.4377-2.39618,1.4377-1.91694,4.31312-4.31312,8.147-7.18853,8.147-3.35465,0.47924-2.87541,3.83389-0.47923,3.83389,5.27158,0.95847,7.66776-0.95847,11.9809-9.58471z'/%3E %3Cpath d='m827.261,247.805c1.43771-1.4377,0.47924-2.87541-0.47924-3.35465-1.4377-0.47923-4.31311,0-5.75082,2.39618,1.43771-0.47923,2.87541-0.47923,3.35465,0.47924,0.47923,0.95847,1.4377,1.91694,2.87541,0.47923z'/%3E %3Cpath d='m829.657,239.179c3.35464,0,4.31312,0.47923,4.79235,1.91694,0.47924,0.95847-0.47923,2.39617-1.43771,2.39617-1.4377,0-2.87541-0.95847-2.39617-1.4377,0.47923-0.95847,0.47923-2.39618-0.95847-2.87541z'/%3E %3Cpath d='m839.242,246.847c2.39618,0.47924,3.35465-0.95847,1.91695-2.87541-0.47924-1.43771-1.91695-2.39618-4.31312-1.91694,2.39617,1.4377,0,3.83388,2.39617,4.79235z'/%3E %3Cpath d='m821.51,254.994c1.4377,2.39618,3.83388,2.39618,4.79235,1.91694,1.43771-0.47923,1.91694-1.91694,1.43771-2.87541-0.95848-1.4377-2.39618-1.91694-2.87542,0-0.95847,1.91694-2.39617,1.43771-3.35464,0.95847z'/%3E %3Cpath d='m828.698,284.227c-0.95847-1.91694-3.83389-1.91694-6.23006,0,0.95847-0.47924,2.87541,0,3.35464,0.95847,0.47924,0.95847,1.43771,0.95847,1.91695,0.95847,0.47923-0.47924,1.4377-0.95847,0.95847-1.91694z'/%3E %3Cpath d='m832.532,281.352c0-2.39618-3.35465-2.87542-5.27159-1.91694,0.95847,0,2.39618,0.95847,2.39618,1.91694,0.47923,0.95847,1.4377,1.4377,1.91694,1.4377,0.95847-0.47923,1.4377-0.95847,0.95847-1.4377z'/%3E %3Cpath d='m827.74,289.978c-2.87542-0.47923-4.31312,2.87542-4.31312,5.27159,0.47923-1.4377,1.91694-2.39617,3.35464-1.91694,1.43771,0,1.91695-0.47923,1.91695-1.43771,0.47923-0.95847,0-1.4377-0.95847-1.91694z'/%3E %3Cpath d='m828.219,298.125c0.95847,0.47924,1.91694-0.47923,2.39618-1.91694,0-0.95847,1.91694-0.95847,2.39617-0.47923,0.95848,0.47923,0.95848,2.39617-0.47923,3.35464-0.95847,0.47924-3.35465,0.95848-4.31312-0.95847z'/%3E %3Cpath d='m894.833,283.748c-0.95847-0.47923-3.35464-1.4377-5.27158,0,1.4377-0.47923,2.39617,0.47924,2.87541,1.43771,0,0.95847,1.4377,1.43771,1.91694,0.47923,0.47923-0.47923,0.95847-1.4377,0.47923-1.91694z'/%3E %3Cpath d='m890.52,287.103c-1.91694-0.95847-4.31312,1.43771-4.79236,3.35465,0.47924-0.47924,2.39618-1.43771,3.35465-1.43771,0.95847,0.47924,1.91694,0,1.91694-0.95847,0.47924-0.47923,0.47924-0.95847-0.47923-0.95847z'/%3E %3Cpath d='m892.916,290.936c-1.4377,0-3.35464,1.91695-3.35464,3.83389,0.47923-0.95847,1.4377-1.43771,2.39617-0.95847,0.95847,0,2.39618-0.47924,2.39618-1.43771s-0.47924-1.43771-1.43771-1.43771z'/%3E %3Cpath d='m897.229,294.77c-0.95847-0.47924-2.39618,0-2.39618,1.4377,0,1.43771,0,2.87541-0.47923,3.35465,0.95847-0.95847,1.91694-1.43771,2.87541-1.91694,0.47924-0.47924,0.95847-1.91694,0-2.87541z'/%3E %3Cpath d='m951.383,290.457c-0.95847-0.95847-2.39618-0.47924-2.87542,0.47923-0.47923,0.95847-0.95847,3.35465,0,5.27159,0-0.95847,0.95847-2.39617,1.91695-2.39617,1.4377-0.47924,1.91694-2.39618,0.95847-3.35465z'/%3E %3Cpath d='m954.258,292.374c-1.91694,0.95847-1.91694,4.31312-0.47924,6.23006,0-0.95847,0.47924-2.39618,1.43771-2.87541,1.4377,0,1.91694-1.91694,1.4377-2.87541-0.95847-0.95848-1.91694-0.47924-2.39617-0.47924z'/%3E %3Cpath d='m960.009,294.291c-0.95847-0.47923-1.91694,0.47924-1.91694,1.43771-0.47923,1.4377,0.47924,3.35464,1.91694,4.31312,0-0.95848,0.47924-1.91695,0.95847-2.39618,1.43771-0.95847,0.95847-2.87541-0.95847-3.35465z'/%3E %3Cpath d='m964.322,293.812c-0.95847,0-1.91694,1.4377-0.95847,2.87541,0.47923,0.95847,1.43771,1.4377,3.35465,0.95847-0.47924,0-1.43771-1.43771-0.95847-1.91694,0.47923-0.95847,0-1.91694-1.43771-1.91694z'/%3E %3C/g%3E %3C/g%3E %3Cg id='star'%3E %3Cpath fill='%23f9d050' d='m831.095,383.429,23.9618-73.8022,23.9618,73.8022-62.7798-45.5274,77.6361,0z'/%3E %3Cpath fill='%23024919' d='m835.887,376.72,49.8405-36.4219-61.3421,0,49.3612,36.4219-18.6902-58.4667z'/%3E %3C/g%3E %3Cuse xlink:href='%23star' x='90.09665'/%3E %3Cuse xlink:href='%23star' x='45.04765' y='52.23713'/%3E %3Cpath fill='none' stroke='%23000' stroke-width='1.4377' d='m989.722,232.949v93.4509c0,80.9908-38.3388,108.786-89.617,130.831-51.2781-22.0448-90.0962-49.8405-90.0962-130.831v-93.4509h179.713z'/%3E %3C/g%3E %3C/g%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 2000 1000'%3E %3Ctitle%3EFlag of Kazakhstan%3C/title%3E %3Crect width='2000' height='1000' fill='%2300afca'/%3E %3Cg id='sun' fill='%23fec50c' transform='translate(1080.4716,420)'%3E %3Ccircle r='134.5497'/%3E %3Cg id='r16'%3E %3Cg id='r4'%3E %3Cpath id='r' d='m0,-152.9c8,-0.1 11,-5.1 11,-11.1c0,-8 -11,-46.1 -11,-46.1s-11,38.1 -11,46.1c0,6 3,11.1 11,11.1z'/%3E %3Cuse xlink:href='%23r' transform='rotate(90)'/%3E %3Cuse xlink:href='%23r' transform='rotate(180)'/%3E %3Cuse xlink:href='%23r' transform='rotate(270)'/%3E %3C/g%3E %3Cuse xlink:href='%23r4' transform='rotate(22.5)'/%3E %3Cuse xlink:href='%23r4' transform='rotate(45)'/%3E %3Cuse xlink:href='%23r4' transform='rotate(67.5)'/%3E %3C/g%3E %3Cuse xlink:href='%23r16' transform='rotate(11.25)'/%3E %3C/g%3E %3Cg id='bird' fill='%23fec50c'%3E %3Cpath d='M316.94,213.44c-1.08,0.06-2.13,0.2-3.16,0.53-1.41,0.19-2.76,0.68-4.16,0.91l-0.56,0.09-0.94,0.09c0.06,0.26,0.1,0.52,0.1,0.78,0,0.27-0.03,0.53-0.1,0.75-0.06,0.21-0.25,0.47-0.4,0.63-0.2,0.22-0.41,0.41-0.66,0.53-0.24,0.12-0.51,0.17-0.78,0.19-0.27,0.01-0.55,0-0.81-0.1-0.27-0.09-0.52-0.26-0.75-0.46-0.28,0.07-0.57,0.12-0.84,0.15-0.28,0.03-0.54,0.03-0.79,0-0.28-0.08-0.57-0.17-0.84-0.28s-0.53-0.25-0.78-0.41c-1.02,0.6-2.16,1.17-2.78,2.22-0.35,0.48-0.42,1.03-0.5,1.6-0.05,0.7,0.13,1.44,0.43,2.09,0.11,0.19,0.2-0.69,0.54-0.81,0.57-0.47,1.28-0.81,2-1,0.61-0.31,0.53,0.02,0.28,0.5-0.06,0.25-0.4,1.2,0.06,0.72,2.03-0.9,4.28-1.08,6.47-1.25,3.18-0.33,6.37-0.4,9.56-0.44,3,0.04,6,0.08,9,0.19,1.43,0.04,2.87,0.36,4.28,0.12,0.34-0.09,0.87-0.11,1.07-0.31-0.64-0.37-1.39-0.38-2.1-0.47h-5.72c-1.59-0.16-3.25-0.18-4.75-0.78-0.4-0.16-0.77-0.54-1.15-0.13-0.57,0.2-1.18,0.34-1.78,0.38-1.05,0.08-2.1-0.14-3.07-0.53,0.7-0.97,1.54-1.82,2.31-2.72-0.62-0.1-1.22-0.23-1.84-0.38,1.09-0.75,2.1-1.6,3.16-2.4z' transform='scale(3.3333333,3.3333333)'/%3E %3Cpath d='m1212.2,746.01c-7.2452,4.3503-12.775-3.3623-18.831-5.6752-4.3249,2.3488-4.7288,10.208-8.7706,13.93-4.8342,5.5019-10.76-1.5363-10.318-6.9649-5.7825,4.8741-8.7067,15.922-18.057,14.446-4.4308-3.6151-7.7219-11.201-11.106-2.5636-2.7613,4.2221-10.11,10.229-13.916,3.8533-1.1784-5.6287-4.0008-12.25-7.0634-3.3078-2.1024,6.3247-8.8507,10.978-15.379,8.2088-3.5737-2.9216,2.8649-13.727-1.6841-12.958-6.7998,4.4958-10.753,15.658-20.242,14.764-3.6847-4.1359,2.236-11.144-1.8057-15.735-4.7711,6.1235-10.063,15.089-18.315,15.735-3.9884-3.2319,0.1571-12.501-2.3893-13.873-8.4677,5.0781-17.402,14.128-28.05,11.294,4.1497-15.873,21.49-21.442,36.072-22.68,25.089-3.0835,51.484,2.5863,75.624-6.469,3.9004-2.3734,13.35-5.7392,9.9847-11.244-2.9805-4.3463,7.7529-2.647,8.7855-7.7238-0.639-6.4302,4.9265-5.5452,10.364-6.108,24.376-1.0516,48.455,4.0818,72.758,4.9546,1.8358,11.842-11.301,20.157-21.876,16.5-5.0519,0.81828-12.627-11.615-11.142-2.5698-1.0183,4.7472-0.3056,11.017-4.6433,14.188m-207.4-24.248c5.6435,5.1653,9.6005-0.97254,14.875-3.2155,17.692-6.085,33.128-16.719,48.346-27.344,9.221-7.6305,17.214-17.525,29.597-20,24.155-7.303,49.832-6.4173,74.081-13.157,18.464-25.281,49.825-34.299,76.096-48.831,5.8991-1.8316,8.1781-6.6867,10.062-12.047,10.028-15.83,23.689-29.857,39.845-39.439,7.6441-4.1767,16.764-6.5825,25.418-4.6718-0.6201,10.307-6.5329,19.442-13.672,26.57,5.842-0.12861,10.863-3.8191,16.767-3.6114,2.0233,10.578-9.4007,16.114-15.478,22.7,3.3855,0.78754,16.353,1.7684,9.2865,5.1591-9.0054,6.2497-19.289,10.541-27.602,17.799,7.6694,1.3778,8.5436,3.0082,0.7445,5.782-4.2215,2.8617-12.341,3.8616-13.126,9.4374,5.7939,3.5608-2.6685,7.0964-5.933,8.2546-6.2414,1.4535-12.798,4.1652-4.5067,8.9071-3.1365,4.7384-9.8653,5.7486-15.356,5.2805,1.6661,5.3701,4.0776,11.378-2.8919,13.747-15.624,11.811-33.96,20.402-53.601,22.367,24.536,1.8866,49.807-2.668,70.773-16.011,2.768-3.2727,17.282-6.7896,9.1636-9.5419-3.822-1.5904-12.016-3.3567-12.57-6.2707,11.355-7.006,25.664-4.514,37.88-8.6758,0.3163-3.9551-9.2914-2.8547-12.874-3.7554-8.5427-0.69975-8.0417-2.8803,0.1954-3.6882,10.422-2.759,22.226-3.3028,30.993-10.098-7.1383-3.3066-16.116-0.39512-23.732-3.0955,12.911-5.6498,28.142-6.2167,39.726-14.704,5.2763-5.871-6.7598-4.0356-10.267-3.8931-7.1509,1.2447-10.456-2.1779-2.3324-5.1489,13.871-10.227,31.433-16.871,41.176-31.697,2.3078-3.3186,5.4328-13.319-1.9277-9.7216-9.681,3.2185-18.198,14.101-29.228,10.735,21.733-16.844,42.413-36.02,57.267-59.33,0.7674-6.7232-9.7852-7.4509-12.532-2.172-13.963,13.454-26.6,29.335-44.477,37.77,17.121-16.525,31.276-36.092,43.626-56.372,2.6476-6.0321,9.7642-13.286,5.9021-19.983-6.2255-5.1532-14.013-0.43606-17.248,5.7304-10.854,14.169-19.096,30.708-33.054,42.25,12.219-23.322,24.871-48.148,25.179-75.047-0.037-5.5382-1.1493-13.694-8.6693-12.659-5.9622,1.0681-4.5464,9.9912-7.0042,14.504-5.4111,18.377-7.9508,38.279-19.05,54.371,2.4971-14.934,6.8661-30.5,3.512-45.58-1.5667-6.7396-12.45-3.8412-11.048,2.8288-13.002,65.86-57.194,123.46-114.99,156.78-26.464,14.973-56.023,24.626-86.096,29.002-8.0899,1.7718-16.839,0.73198-24.572,3.4906-18.736,14.367-30.079,38.407-53.802,45.935-10.632,5.2835-24.496,6.3556-32.098,16.233-0.658,1.2632-0.7991,2.7266-0.7739,4.1273'/%3E %3Cpath d='m1075.8,654.95c-3.5006,6.354-5.5592,13.658-10.06,19.347-13.541-12.321-33.171-11.914-50.347-12.734-14.177-0.75657-29.594-2.0646-40.563-12.176-11.539-9.452-20.958-21.724-33.852-29.393-11.769-3.2001-23.633-7.2042-33.095-15.271-20.22-16.482-31.8-40.937-51.558-57.933-3.7669-3.7078-8.209-6.5812-12.429-9.7268-4.0096,0.97695-2.1955,9.6311-7.1022,5.2194-2.6694-1.8995-9.348-2.0844-9.9492,0.56937,6.0404,7.96,12.087,17.049,12.924,27.23-4.1198,0.4224-11.445-0.87064-13.487,0.66378,5.4715,8.2003,12.484,15.473,20.452,21.263-3.8217,0.61454-11.353,0.27988-12.818,1.8198,7.9092,6.4462,16.391,13.034,26.747,14.69,2.12,2.7948-3.099,8.1901,1.2898,10.576,2.5458,1.0399,10.945,2.7801,5.1592,5.6751-3.9705,2.6755-2.4971,8.9111,2.5797,8.7706,3.2101,1.6391,10.418,2.0412,10.982,4.879-2.8453,2.8956-11.698,6.3288-4.1637,9.0409,7.039,3.904,15.067,6.4384,23.105,6.7168-4.0336,3.3936-9.004,5.3206-13.156,8.5127,18.55,10.877,39.113,18.03,59.433,24.919,8.0909,2.7031,16.274,5.2237,24.661,6.8102-24.369-1.4066-47.922-8.6212-70.116-18.495-11.503-5.0452-23.084-9.9197-34.873-14.265,5.1692-2.6897,11.148-3.3471,16.509-5.6751-11.128-2.2291-23.285-2.9605-33.067-9.0768,1.4997-2.6758,7.1829-2.8021,10.326-4.1642,5.9114-1.416,9.5779-3.1339,1.2438-3.6475-8.4057-2.2812-18.045-1.2576-25.452-6.3278,0.4769-3.04,8.2283-1.9813,11.386-3.2934,3.9751-0.683,8.3958-1.2548,11.573-3.9294-12.994-5.388-29.99-1.5707-40.168-13.046-2.3476-4.3712,7.2884-0.85006,10.033-1.5782,6.9723,0.00003,14.467,2.2158,21.107-0.59559-18.934-8.3124-39.215-16.095-53.655-31.471-1.6039-2.4716-6.4071-9.2249-2.5317-10.06,11.239,1.4869,19.374,13.753,31.396,11.844,1.5973-2.1526-6.9835-5.6809-9.1254-8.7582-17.528-15.041-34.541-31.364-46.825-51.066-0.84492-6.5792,9.4971-7.565,12.22-2.4832,13.405,12.911,25.514,27.977,42.209,36.791,5.9247,2.8724-3.4012-3.4-4.6433-5.6751-15.427-17.914-30.113-36.834-40.895-57.932-1.9299-3.8028-5.1284-10.686,0.64643-12.71,5.7722-2.8919,11.501,1.0476,14.428,6.0066,11.342,14.305,19.688,31.307,33.817,43.225-12.037-23.359-24.889-47.948-25.2-74.828,0.28226-5.2109,0.61728-13.092,7.6832-12.878,5.9331-0.89942,4.9962,6.696,6.941,10.318,5.845,19.747,8.3946,41.121,20.121,58.556-2.5904-14.649-6.4022-29.735-3.8694-44.627,0.58422-4.8898,6.0884-6.37,9.6818-3.4138,2.9046,7.11,3.5106,15.889,6.1574,23.491,15.06,51.519,48.875,96.832,92.941,127.24,36.292,24.891,79.362,39.749,123.32,42.341,3.9698,0.346,7.9556,0.46548,11.932,0.70954'/%3E %3Ccircle cx='1020' cy='720.887' r='2.367'/%3E %3Ccircle cx='1019.8' cy='720.507' r='0.965' stroke='%2300afca' stroke-width='0.38127393'/%3E %3C/g%3E %3Cg id='ornament' fill='%23fec50c'%3E %3Cg id='oh'%3E %3Cg id='oq'%3E %3Cpath d='m120,72.922s-9.6109-8.0762-12.874-4.0253c-5.2494,6.5154,16.14,38.968,16.14,50.396,0,18.759-12.517,23.861-27.973,26.539-10.371,1.7981-27.259-0.752-27.259-0.752,3.1796-4.2726,5.2478-5.5316,10.606-5.8731-5.9648-3.0968-12.039-9.8188-12.039-20.284,0-16.138,6.6434-22.789,6.6434-40.983,0-10.093-8.2759-22.941-8.2759-22.941,14.628,1.464,21.878,15.009,17.753,25.834,2.3286,0.33542,4.4428-0.18873,6.2586-1.9094,1.0706,3.0005-0.61945,6.4832-2.8834,9.4837,1.8233,0.97432,3.1624,0.39003,6.0661-0.20942-0.27536,3.0915-2.1278,6.3758-6.6597,9.4671,13.151-3.4144,21.243,5.7517,21.243,15.347,0,7.248-5.0791,12.443-10.044,12.443-1.6044,0-3.9611-0.66078-5.2908-1.6532-0.93725,1.9948-0.45429,4.6646,0.51121,6.6596-3.6388-0.96187-5.9484-3.1229-4.3043-7.6212-2.7948-0.25675-5.0181-1.2011-6.5305-3.0005,1.5323-1.9624,3.8568-3.0927,6.5305-3.0005-2.035-4.1994,0.23284-6.5505,3.5373-8.456,0,0-2.1015,8.4558,3.2654,8.4558,2.4133,0,4.6122-0.78561,4.6122-4.3421,0-3.097-2.7075-7.387-8.9659-7.1142-6.2586,0.27277-11.332,4.3152-11.332,14.306,0,9.2162,7.4334,13.8,17.229,14.096,8.8338,0.27277,15.501-4.5126,15.501-13.625,0-12.128-17.508-39.773-17.508-50.581,0-8.109,7.2922-12.635,14.427-12.635,9.2518,0,17.058,9.1612,17.058,9.1612l-5.4352,6.8146z'/%3E %3Cpath id='op' d='m122.02,292.14c0,20.27-18.198,30.688-32.498,30.688-19.266,0-29.524-11.519-29.524-26.598,0-8.5475,1.5661-13.911,5.5074-22.092,0,0,31.78-66.091,44.153-91.653,1.543-3.1882,2.0408-6.8175,2.0408-12.138,0-8.2171-7.97-14.933-16.327-15.139-7.618-0.19053-15.918,7.1022-15.918,15.412,0,10.093,5.2358,14.593,10.612,14.593,6.6157,0,9.2518-2.7198,9.2518-7.3649,0-3.2366-1.5632-4.6371-3.8095-4.6371-5.6744,0-4.0817,7.6376-4.0817,7.6376-2.8183-0.617-5.1335-3.4965-3.8095-7.0921-2.0617-0.45904-3.9929-1.5413-5.5102-3.2733,1.5211-1.4747,3.266-2.6132,5.5102-3.0005-1.3289-4.3872,0.44687-6.5308,4.2857-7.433-0.77466,1.6876-0.80131,3.2401-0.54421,4.7054,6.0436-1.7186,15.306,1.0163,15.306,11.456,0,10.365-7.1935,19.093-20.681,16.912,3.2087,1.5341,4.8407,4.6732,5.1701,8.1832-2.4491-0.9547-5.1701-1.0911-5.1701-1.0911,1.577,2.7808,3.7672,5.1776,3.6734,10.638-2.5006-1.1368-4.8227-3.2419-8.0272-1.9094,5.0294,9.8968-1.1497,23.511-16.871,26.732,5.7537-6.7443,8.5714-14.027,8.5714-21.277,0-23.496-6.5305-27.445-6.5305-43.78,0-6.8343,3.5133-14.215,10.476-19.231v0.27276c-4.6021-1.2324-7.5502-3.4985-9.2447-6.5775,10.515-2.9816,25.799-2.9269,34.006,0.30202,9.434,1.0925,16.019,8.3308,17.959,12.004,1.9406,3.6708,5.7096,16.953,0,28.912-6.2487,13.088-35.711,75.559-44.897,95.198-1.9484,4.1654-3.1293,8.5827-3.1293,13.366,0,12.03,11.02,16.23,17.279,16.23,7.4829,0,15.102-5.7008,15.102-12.82,0-4.5112-2.4491-7.2285-5.9864-7.2285-8.4587,0-7.9449,7.1957-6.2586,11.729-5.2643-2.3667-8.3243-6.5917-7.4829-11.047-2.9805-0.40822-5.8174-1.822-8.4353-4.7735,2.0598-2.601,4.5722-4.5671,8.4353-4.6371-1.6873-6.9119,2.9406-9.8352,7.4829-11.456-1.437,5.0729-2.3803,10.911,6.2586,10.911,6.2986,0,11.258,1.0911,14.15,5.1827,0.17007-5.4553,0.68027-27.005,0.68027-27.005,0.36281-8.0977-10.839-7.8662-17.959-5.4554,2.6871-9.3276,8.1979-14.371,20.952-13.093-3.0953-1.2957-6.3946-4.2084-6.3946-9.8198,0.002-7.593,6.1621-16.005,10.206-18.492l2.022,79.051z'/%3E %3Cuse xlink:href='%23op' transform='matrix(1,0,0,-1,0,645.08)'/%3E %3C/g%3E %3Cuse xlink:href='%23oq' transform='matrix(-1,0,0,1,240,0)'/%3E %3C/g%3E %3Cuse xlink:href='%23oh' transform='matrix(1,0,0,-1,0,1000)'/%3E %3C/g%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 600 400'%3E %3Crect fill='%23ce1126' width='600' height='400'/%3E %3Crect fill='%23002868' y='100' width='600' height='200'/%3E %3Ccircle fill='%23fff' cx='300' cy='200' r='80'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 750 500'%3E %3Crect fill='%23ed1c24' width='750' height='500'/%3E %3Crect fill='%23fff' y='125' width='750' height='250'/%3E %3Cpath fill='%2300a651' d='M 371.5894,125 C 366.22315,136.2997 356.11736,144.19789 346.45832,151.67157 C 344.86925,153.05938 340.91845,155.74726 343.78458,157.79271 C 346.24017,155.04836 352.97951,158.68259 349.06268,161.63346 C 345.55402,164.9176 340.72308,166.12 336.82746,168.82984 C 333.37726,170.7043 329.87796,172.66173 327.14196,175.53105 C 326.95559,180.0135 332.70358,177.53219 335.03612,179.3996 C 338.07363,182.64705 333.74816,188.12133 329.76182,186.86927 C 324.66471,187.02546 321.14438,191.51029 319.21689,195.78908 C 315.22977,201.95458 307.67448,203.78032 301.65953,207.28899 C 298.21778,209.29528 294.87854,211.51505 291.6746,213.85608 C 287.54383,216.68042 291.13754,222.27234 295.53278,220.89972 C 300.27728,220.4267 304.54592,216.69896 309.45786,217.77316 C 313.91254,219.33833 315.16278,225.16012 313.64459,229.22483 C 312.52055,232.47922 309.79569,234.77154 307.6125,237.31372 C 304.06844,240.90414 299.43359,243.23508 294.54641,244.34656 C 289.82305,245.93241 285.57789,248.826 282.47971,252.73228 C 278.88376,256.35224 275.30219,260.03085 271.1692,263.04934 C 269.86365,266.38067 273.54807,269.21835 276.6199,269.12991 C 283.09222,268.72234 287.57797,263.42506 293.09028,260.70292 C 297.66461,258.64703 303.04806,263.57727 301.92906,268.34281 C 301.57508,272.97905 297.23424,275.33164 293.37475,276.75816 C 282.02885,282.4619 272.1777,290.73284 263.43076,299.85875 C 261.62169,303.54889 256.64826,302.46257 253.97025,305.03499 C 252.22562,308.29039 256.60402,310.00685 259.21608,309.67223 C 270.44112,308.32214 280.91539,303.57761 290.83812,298.3575 C 294.52819,296.59322 297.99323,294.27138 301.82962,292.86533 C 305.43319,291.97509 310.45809,293.54159 311.10283,297.64287 C 311.09773,301.97233 306.80857,304.37035 303.4117,306.06172 C 292.93651,311.56524 281.44052,314.60765 270.24434,318.24607 C 266.05289,317.07424 262.89523,324.53141 267.49329,325.87225 C 272.3554,327.53952 277.52429,326.20279 282.49779,325.98426 C 297.87642,323.62817 311.32634,315.30653 325.70163,309.9273 C 331.67794,307.97923 338.73226,310.6978 341.68165,316.29776 C 344.64481,321.28931 344.37398,327.85334 341.24819,332.70293 C 336.30834,343.27146 328.79833,352.98464 318.7165,359.0613 C 312.38812,362.19434 305.00126,363.39297 299.57757,368.18972 C 294.56146,369.8432 302.09226,376.62136 303.18084,371.24168 C 306.19505,367.13063 311.51128,365.90189 316.33356,365.73205 C 323.58078,364.94312 331.27713,363.60631 336.9083,358.58922 C 341.95671,354.66896 346.93162,349.26076 353.78678,349.17636 C 357.57531,349.62563 361.32238,352.66984 365.17025,350.81231 C 368.53626,349.27162 373.81755,350.17444 374.69678,354.31369 C 376.30415,359.15581 381.29505,361.35894 385.25295,363.95016 C 386.68557,365.96192 391.44596,371.15043 392.54374,366.57601 C 391.65792,363.31338 392.92361,358.32091 397.20351,359.41116 C 400.94191,359.57808 404.50446,360.95653 408.23564,361.18262 C 413.20452,362.21183 417.34927,365.6135 420.17071,369.72085 C 422.11167,372.40126 426.36333,377.00677 429.52222,373.45251 C 431.48249,369.77666 427.74062,366.71103 424.69446,365.39845 C 420.25243,362.64573 416.45462,358.97987 412.57076,355.50887 C 406.84653,350.16275 401.90235,343.36292 400.99374,335.37635 C 399.76199,327.41308 400.4102,319.29095 401.44945,311.34932 C 402.75741,306.23638 409.29554,303.44506 413.86725,306.16167 C 420.30003,309.09681 426.68843,313.29666 434.06328,312.84127 C 444.72,313.07089 455.67072,311.03044 466.08536,314.11859 C 476.21984,317.31095 483.46556,325.86344 493.33765,329.56419 C 495.54761,330.90725 498.37484,329.62908 499.18462,327.26866 C 500.16303,325.1476 499.47268,322.43378 497.42896,321.22499 C 485.98778,309.67613 470.35146,304.06569 457.11353,295.04126 C 452.94587,293.98288 452.18706,287.27769 456.03973,285.34185 C 461.10528,281.66065 468.2721,283.37428 472.76607,287.16972 C 476.56118,289.39278 480.8368,291.05827 485.2894,291.06224 C 489.85029,289.63448 487.63912,283.03469 483.55544,282.53841 C 476.15622,278.36058 470.8569,271.50481 464.44632,266.0718 C 460.75559,262.94683 456.716,259.78287 451.7557,259.17634 C 449.04451,258.68263 446.27094,258.57459 443.52394,258.75896 C 440.9476,255.95914 444.38123,251.67208 447.71241,252.02262 C 451.1308,252.25288 454.52965,252.50697 457.94359,252.03127 C 461.75876,251.75176 465.57064,251.35683 469.39939,251.33063 C 472.48995,253.43534 478.66583,249.7996 475.87651,246.17083 C 472.82951,243.50085 468.42334,243.73277 464.78211,242.36257 C 458.38547,240.26395 451.87572,238.56782 445.28454,237.23756 C 440.67325,236.9626 441.242,230.89376 445.29497,230.22441 C 447.94739,229.23496 450.25279,231.27278 452.79892,231.5887 C 457.14735,232.52313 461.63683,232.51113 465.9831,233.45849 C 469.66816,231.63935 466.81948,226.2555 463.48593,225.94179 C 455.62045,223.12924 448.82304,218.05295 442.17788,213.11487 C 434.84116,207.59721 428.18494,201.21633 420.75826,195.82617 C 418.06357,194.15628 413.64683,193.67534 412.93795,189.97462 C 412.68795,186.57015 416.69529,185.01965 419.53592,185.81559 C 423.56634,187.00583 427.32195,189.07846 431.42972,190.09605 C 434.65252,190.64375 437.97545,191.59738 441.08179,191.19126 C 445.02496,188.71371 439.39058,187.13019 437.35122,186.27058 C 432.0938,183.43513 427.42242,179.65733 422.69107,176.0548 C 418.69278,172.64193 426.08234,171.13414 428.62427,172.44822 C 432.87417,174.22617 433.35847,168.03333 430.18167,166.47498 C 426.43855,164.88338 423.2196,162.24124 419.82552,159.93707 C 413.69304,155.57159 406.74727,152.1159 399.20847,151.156 C 390.75634,150.3067 382.86721,145.44628 378.38327,138.21818 C 375.60269,134.09908 373.56207,129.54384 371.5894,125 z M 343.8321,172.41771 C 348.18843,172.54695 347.51872,180.39793 343.22983,179.87413 C 339.06481,179.60609 339.31972,171.57429 343.8321,172.41771 z M 384.92234,176.64564 C 389.16127,175.88738 390.05889,183.62274 385.82379,183.98589 C 381.41121,184.77575 379.7758,176.15615 384.92234,176.64564 z M 372.88731,177.65384 C 377.18466,178.49924 376.42021,185.98556 372.08328,186.05098 C 368.91022,186.75752 365.49025,188.92314 362.28008,187.30008 C 359.66952,184.53908 363.44271,180.45635 366.35676,179.55883 C 368.59191,179.10829 370.64832,178.09344 372.88731,177.65384 z M 400.58563,177.68637 C 404.72688,179.19709 403.26629,186.50778 398.8981,186.41459 C 394.76724,186.96811 392.84357,180.07706 396.6956,178.44266 C 397.9426,178.00052 399.24903,177.62794 400.58563,177.68637 z M 353.8613,185.97958 C 356.90649,188.87754 355.10789,194.47009 351.35311,195.80715 C 348.64664,197.31266 344.95682,200.87381 342.00892,197.94369 C 340.40943,194.36455 344.42423,191.66946 346.78572,189.68283 C 348.89329,188.04409 351.21909,186.55653 353.8613,185.97958 z M 388.63905,202.14325 C 392.99893,204.2019 390.78574,212.05909 386.00062,211.57069 C 382.07061,210.57486 382.58371,203.83444 386.54227,203.29678 C 387.29055,203.01039 387.9769,202.58881 388.63905,202.14325 z M 374.80463,202.92376 C 378.88224,204.83283 375.76886,211.63754 371.6618,210.657 C 367.40345,210.15691 367.48196,202.67024 372.17815,203.34611 C 373.06305,203.30222 373.97688,203.27971 374.80463,202.92376 z M 404.62678,206.82647 C 409.096,205.43963 414.4766,210.04402 413.02612,214.71319 C 411.03543,218.33295 406.10946,218.79124 402.58121,217.43842 C 398.52983,217.23842 395.80478,211.1478 399.41404,208.56875 C 400.90756,207.44072 402.79022,206.97715 404.62678,206.82647 z M 338.611,207.99725 C 342.30631,205.98682 346.22984,212.02929 343.08717,214.69451 C 341.00551,217.75492 335.66012,219.00525 333.30317,215.60189 C 331.34505,212.27783 334.51104,206.69321 338.611,207.99725 z M 321.56135,210.85925 C 325.75319,211.43274 328.48457,215.24015 330.03376,218.86551 C 330.41193,223.28362 323.89286,225.70783 321.04899,222.49331 C 317.85114,220.48713 315.05191,216.36132 316.72839,212.53213 C 317.76131,211.0116 319.81909,210.38426 321.56135,210.85925 z M 423.56431,226.82777 C 428.11364,225.62888 431.41652,232.89939 427.51018,235.52953 C 423.93847,238.77373 416.99376,234.47573 418.85644,229.84687 C 419.78218,228.1308 421.63401,226.99026 423.56431,226.82777 z M 365.66037,235.121 C 369.47498,235.6068 368.2391,242.21814 364.71192,241.99623 C 360.92636,241.29454 361.79307,234.74813 365.66037,235.121 z M 346.3099,238.6334 C 349.42124,236.43197 353.434,241.80509 350.84595,244.3089 C 347.74396,246.49354 343.72032,241.20565 346.3099,238.6334 z M 377.07598,239.28385 C 380.68235,241.47514 382.82338,245.56095 383.27166,249.68389 C 381.54334,253.53578 374.86866,252.60724 374.11615,248.50531 C 372.79639,245.26124 374.01269,241.08758 377.07598,239.28385 z M 387.81313,245.65826 C 392.46055,244.49084 390.79279,254.20485 386.91238,250.83545 C 385.62285,249.30414 386.31349,246.78444 387.81313,245.65826 z M 320.38146,252.42293 C 323.45884,251.52156 327.94465,252.46899 328.7941,256.00085 C 329.15292,259.32013 325.5028,261.04696 322.8282,261.86956 C 318.54137,263.19231 314.34875,265.36394 309.73883,265.07221 C 306.28351,263.09729 305.04323,259.05585 303.81128,255.53103 C 307.14601,252.40445 312.05643,253.32163 316.19018,252.53906 C 317.58613,252.4675 318.98379,252.43346 320.38146,252.42293 z M 424.98018,267.64343 C 428.90575,265.71883 433.12728,271.9498 429.84137,274.86023 C 425.73054,279.59171 417.81599,280.47093 412.90065,276.49605 C 412.30974,272.3088 416.49236,269.26764 420.20768,268.66669 C 421.77056,268.22519 423.32385,267.56559 424.98018,267.64343 z M 447.04443,272.42422 C 451.50464,271.6566 455.01805,278.01951 451.83272,281.3126 C 448.81821,285.85801 441.62942,287.05014 437.51912,283.32422 C 435.91659,279.55585 439.16741,275.62934 442.62728,274.42031 C 444.11438,273.78742 445.52241,272.97626 447.04443,272.42422 z M 336.10372,279.1889 C 340.23431,278.78128 344.01843,282.87955 343.47633,286.95187 C 346.46651,289.89444 341.17144,295.37643 338.19238,292.32933 C 335.56714,289.14836 335.58095,284.83298 334.56407,281.02604 C 334.51857,280.18042 335.14459,279.08508 336.10372,279.1889 z M 367.81369,281.56305 C 372.08402,279.7168 377.60876,284.82551 375.28387,289.15052 C 373.6236,292.67309 367.14833,291.4924 367.3635,287.41217 C 367.35245,285.46035 367.19489,283.45856 367.81369,281.56305 z M 352.38642,284.32743 C 356.66836,283.34572 360.59695,288.89644 358.21743,292.60021 C 353.94846,292.97974 351.73219,287.9133 352.38642,284.32743 z'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 600 300'%3E %3Crect fill='%236Cf' width='600' height='300'/%3E %3Cpolygon fill='%23FFF' points='200,274 300,260 400,274 300,27'/%3E %3Cpolygon points='213.5,274 300,260 386.5,274 300,60'/%3E %3Cpolygon fill='%23FCD116' points='200,274 400,274 300,150'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' xmlns:sodipodi='http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd' viewBox='0 0 1000 600'%3E %3Crect width='1000' height='600' fill='%23002b7f'/%3E %3Crect y='300' width='1000' height='300' fill='%23ce1126'/%3E %3Cg fill='%23ffd83d' stroke='%23000' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E %3Cg id='half'%3E %3Cpath d='M 216.37706,122.2886 L 214.53882,184.7886 L 151.1197,184.7886 C 143.31716,169.62032 136.87338,156.73735 136.87338,139.29228 C 136.87338,124.69269 148.35647,113.09742 164.90647,113.09742 C 182.42619,113.09742 201.67512,119.001 216.37706,122.2886 z' stroke='none'/%3E %3Cg stroke-width='1.5'%3E %3Cpath d='M 144.45611,125.16084 V 161.23621'/%3E %3Cpath d='M 149.54956,121.47933 V 169.51333'/%3E %3Cpath d='M 154.64301,118.95176 V 176.17693'/%3E %3Cpath d='M 159.73645,117.77081 V 162.65201'/%3E %3Cpath d='M 164.82989,117.54815 V 162.87466'/%3E %3Cpath d='M 169.92335,115.96463 V 162.84973'/%3E %3Cpath d='M 175.01679,115.96463 V 162.84973'/%3E %3Cpath d='M 180.11024,116.42419 V 163.30929'/%3E %3Cpath d='M 185.20367,116.88375 V 163.76885'/%3E %3Cpath d='M 190.29712,119.87088 V 166.75598'/%3E %3Cpath d='M 195.39057,120.33044 V 173.1898'/%3E %3Cpath d='M 200.48402,120.33044 V 167.21554'/%3E %3Cpath d='M 205.57747,120.33044 V 167.21554'/%3E %3Cpath d='M 176.39544,117.92279 C 187.15891,119.69824 210.80151,130.75993 208.105,145.72611 C 204.28366,166.93537 191.89725,158.42373 175.47632,155.37684 L 163.06823,159.51287 C 158.62839,164.04466 152.09048,168.19641 147.67301,162.72978 L 140.32007,162.72978 L 140.32007,191.4522 L 221.66198,191.4522 L 221.66198,122.05882 z' fill='%23000'/%3E %3C/g%3E %3Ccircle cx='212.81549' cy='112.98255' r='4.94026'/%3E %3Ccircle cx='201.713' cy='110.31052' r='4.94026'/%3E %3Ccircle cx='190.44973' cy='107.48178' r='4.94026'/%3E %3Ccircle cx='179.14295' cy='105.59596' r='4.94026'/%3E %3Ccircle cx='167.83617' cy='104.48071' r='4.94026'/%3E %3Ccircle cx='156.74931' cy='105.11261' r='4.94026'/%3E %3Ccircle cx='146.17946' cy='108.73163' r='4.94026'/%3E %3Ccircle cx='137.27551' cy='115.28035' r='4.94026'/%3E %3Ccircle cx='130.95657' cy='124.41408' r='4.94026'/%3E %3Ccircle cx='127.912' cy='135.15627' r='4.94026'/%3E %3Ccircle cx='128.02689' cy='146.30057' r='4.94026'/%3E %3Ccircle cx='130.15236' cy='157.21509' r='4.94026'/%3E %3Cpath d='M 214.99838,119.53125 L 214.53882,125.96507 C 202.24782,124.08194 184.82391,117.23346 168.58294,117.23346 C 153.57656,117.23346 141.92853,123.23616 141.92853,138.37316 C 141.92853,153.29163 148.24631,166.85838 156.63441,180.65257 L 147.90279,184.7886 C 140.10025,169.62032 133.65647,156.73735 133.65647,139.29228 C 133.65647,124.69269 145.13956,110.34007 164.90647,110.34007 C 182.42619,110.34007 200.29644,116.24365 214.99838,119.53125 z'/%3E %3C/g%3E %3Cuse xlink:href='%23half' transform='translate(443.9375) scale(-1,1)'/%3E %3Cpath d='M 221.96875,53.125 L 216.8125,62.78125 L 221.96875,72.40625 L 227.125,62.78125 L 221.96875,53.125 z M 221.96875,77.5 L 216.8125,87.125 L 221.96875,96.78125 L 227.125,87.125 L 221.96875,77.5 z'/%3E %3Cpath d='M 203.58731,74.953125 L 211.71883,80.109375 L 219.82403,74.953125 L 211.71883,69.796875 L 203.58731,74.953125 z M 224.11347,74.953125 L 232.21867,80.109375 L 240.35019,74.953125 L 232.21867,69.796875 L 224.11347,74.953125 z'/%3E %3Ccircle cx='221.96875' cy='75.06893' r='3.90625'/%3E %3Ccircle cx='221.96875' cy='100' r='10.45496'/%3E %3Cpath d='M 219.34375,89.875 C 219.34375,92.989438 219.32163,94.799139 219.3125,96.5 C 216.79207,96.611865 214.30676,96.876712 211.875,97.28125 M 232.0625,97.28125 C 229.63074,96.876712 227.14543,96.611865 224.625,96.5 C 224.625,94.801655 224.625,92.997132 224.625,89.875 M 211.84375,102.5625 C 215.13846,102.01215 218.51788,101.71875 221.96875,101.71875 C 225.41962,101.71875 228.79904,102.01215 232.09375,102.5625' fill='none' stroke-width='1.5'/%3E %3Cpath d='M 211.75,117.6875 C 210.75812,134.76968 208.74143,152.16667 202.09375,164.8125 L 212.90625,160.4375 C 216.68272,146.10873 217.47609,127.59492 218.625,118.84375 L 211.75,117.6875 z M 232.1875,117.6875 L 225.3125,118.84375 C 226.4614,127.59492 227.25478,146.10873 231.03125,160.4375 L 241.84375,164.8125 C 235.19607,152.16667 233.17938,134.76968 232.1875,117.6875 z'/%3E %3Cpath d='M 221.95313,154.6875 C 209.03974,154.6875 199.55398,160.77412 198.98438,176.28125 C 195.82773,170.72636 182.4742,153.25552 170.01563,155.59375 C 162.60576,156.98444 156.05854,167.25962 157.17188,179.03125 C 151.037,161.40135 133.06509,158.51225 119.95313,168.9375 C 131.59529,178.51001 136.77421,206.77225 146.57813,219.03125 L 221.95313,219.03125 L 297.32813,219.03125 C 307.13204,206.77225 312.34222,178.51001 323.98438,168.9375 C 310.87241,158.51225 292.90051,161.40135 286.76563,179.03125 C 287.87896,167.25962 281.3005,156.98444 273.89063,155.59375 C 261.43205,153.25552 248.10978,170.72636 244.95313,176.28125 C 244.38354,160.77412 234.86652,154.6875 221.95313,154.6875 z'/%3E %3Cg stroke-width='1.5'%3E %3Cpath d='M 297.10662,219.02573 C 297.10662,224.60663 263.44486,230.74447 221.96875,230.74447 C 180.49265,230.74447 146.83089,224.60663 146.83089,219.02573 C 146.83089,213.44487 180.49265,210.5239 221.96875,210.5239 C 263.44486,210.5239 297.10662,213.44487 297.10662,219.02573 z' fill='%23000'/%3E %3Ccircle cx='221.96875' cy='114.44459' r='3.50414'/%3E %3Ccircle cx='221.96875' cy='122.02731' r='3.73392'/%3E %3Ccircle cx='221.96875' cy='130.18447' r='4.07859'/%3E %3Ccircle cx='221.96875' cy='139.26075' r='4.65303'/%3E %3Ccircle cx='221.96875' cy='149.37105' r='5.11259'/%3E %3Cpath d='M 219.93751,159.20588 C 219.38456,159.19901 218.86165,159.6649 219.00001,160.54963 C 219.16297,161.59315 219.36706,163.54482 219.56251,164.86213 C 219.78339,166.35532 220.65373,165.99233 220.87501,164.83088 C 221.09631,163.66986 221.00709,162.925 221.06251,160.76838 C 221.09024,159.69029 220.49047,159.21276 219.93751,159.20588 z M 224.00001,159.20588 C 223.44705,159.21276 222.8473,159.69029 222.87501,160.76838 C 222.93043,162.925 222.84123,163.66986 223.06251,164.83088 C 223.28379,165.99233 224.15415,166.35532 224.37501,164.86213 C 224.57046,163.54482 224.77457,161.59315 224.93751,160.54963 C 225.07587,159.6649 224.55298,159.19901 224.00001,159.20588 z M 216.31251,159.76838 C 215.80668,159.83874 215.2822,160.34892 215.31251,160.89338 C 215.36753,161.88856 215.64291,163.0823 215.75001,164.58088 C 215.86046,166.12907 216.95166,165.52771 217.06251,164.64338 C 217.17296,163.75866 217.29793,162.45118 217.18751,160.73713 C 217.1461,160.09422 216.8653,159.8115 216.53126,159.76838 C 216.46168,159.75941 216.38477,159.75833 216.31251,159.76838 z M 227.40626,159.76838 C 227.07222,159.8115 226.79144,160.09422 226.75001,160.73713 C 226.63959,162.45118 226.76458,163.75866 226.87501,164.64338 C 226.98586,165.52771 228.07708,166.12907 228.18751,164.58088 C 228.29461,163.0823 228.57001,161.88856 228.62501,160.89338 C 228.65532,160.34892 228.13086,159.83874 227.62501,159.76838 C 227.55275,159.75833 227.47586,159.75941 227.40626,159.76838 z M 211.96876,161.51838 C 211.50567,161.63805 211.0804,162.19494 211.21876,162.83088 C 211.49507,164.10277 211.75001,165.50899 211.75001,166.79963 C 211.75002,167.90566 212.69459,167.511 212.75001,166.73713 C 212.80503,165.96284 212.90626,164.32364 212.90626,162.83088 C 212.90627,161.71632 212.43186,161.39872 211.96876,161.51838 z M 231.65626,161.51838 C 231.32747,161.60947 231.03126,161.99496 231.03126,162.83088 C 231.03126,164.32364 231.13251,165.96284 231.18751,166.73713 C 231.24293,167.511 232.18752,167.90566 232.18751,166.79963 C 232.18751,165.50899 232.44247,164.10277 232.71876,162.83088 C 232.85712,162.19494 232.43187,161.63805 231.96876,161.51838 C 231.85299,161.48846 231.76586,161.48802 231.65626,161.51838 z M 172.56251,161.68934 C 172.00845,161.67094 171.61973,162.42254 172.00001,163.25184 C 172.60804,164.57916 173.25407,165.41659 173.87501,166.84559 C 174.42803,168.11748 175.2763,167.32448 175.00001,166.43934 C 174.7233,165.55461 174.42308,164.56923 173.59376,162.68934 C 173.28263,161.98423 172.89495,161.70039 172.56251,161.68934 z M 271.37501,161.68934 C 271.04257,161.70039 270.65489,161.98423 270.34376,162.68934 C 269.51444,164.56923 269.21422,165.55461 268.93751,166.43934 C 268.66122,167.32448 269.50949,168.11748 270.06251,166.84559 C 270.68345,165.41659 271.32948,164.57916 271.93751,163.25184 C 272.31779,162.42254 271.92907,161.67094 271.37501,161.68934 z M 176.56251,161.75184 C 176.15469,161.8763 175.90747,162.39361 176.15626,163.00184 C 176.65427,164.21831 177.37284,165.46536 177.87501,166.78309 C 178.31718,167.94413 179.3009,167.61494 178.96876,166.56434 C 178.63704,165.51375 178.53846,164.89884 177.87501,162.90809 C 177.54309,161.91293 176.97034,161.62739 176.56251,161.75184 z M 267.06251,161.75184 C 266.71381,161.82629 266.31145,162.16172 266.06251,162.90809 C 265.39906,164.89884 265.30048,165.51375 264.96876,166.56434 C 264.63662,167.61494 265.62034,167.94413 266.06251,166.78309 C 266.56468,165.46536 267.28325,164.21831 267.78126,163.00184 C 268.03005,162.39361 267.78283,161.8763 267.37501,161.75184 C 267.27305,161.72073 267.17874,161.72702 267.06251,161.75184 z M 181.56251,162.72059 C 181.04838,162.81843 180.65026,163.60277 181.00001,164.56434 C 181.4426,165.78081 182.072,166.93202 182.62501,168.31434 C 183.17803,169.69667 184.0963,169.41781 183.87501,168.53309 C 183.65374,167.64836 183.38263,166.18221 182.71876,163.97059 C 182.42851,163.00283 181.9624,162.6445 181.56251,162.72059 z M 262.37501,162.72059 C 261.97512,162.6445 261.50901,163.00283 261.21876,163.97059 C 260.55489,166.18221 260.28378,167.64836 260.06251,168.53309 C 259.84122,169.41781 260.75949,169.69667 261.31251,168.31434 C 261.86552,166.93202 262.49492,165.78081 262.93751,164.56434 C 263.28726,163.60277 262.88914,162.81843 262.37501,162.72059 z M 169.18751,163.40809 C 168.63064,163.46496 168.12339,164.37333 168.46876,165.06434 C 169.0222,166.17037 169.37242,166.54665 169.90626,167.72059 C 170.45928,168.93706 171.06504,167.99489 170.84376,167.22059 C 170.62248,166.4463 170.33882,165.54493 170.06251,164.43934 C 169.85999,163.62937 169.52164,163.37397 169.18751,163.40809 z M 274.75001,163.40809 C 274.41588,163.37397 274.07753,163.62937 273.87501,164.43934 C 273.5987,165.54493 273.31504,166.4463 273.09376,167.22059 C 272.87248,167.99489 273.47824,168.93706 274.03126,167.72059 C 274.5651,166.54665 274.91532,166.17037 275.46876,165.06434 C 275.81413,164.37333 275.30688,163.46496 274.75001,163.40809 z M 207.71876,166.20588 C 207.13501,166.20536 206.51143,166.98024 206.71876,167.70588 C 207.05049,168.86734 207.56328,169.89687 207.93751,171.39338 C 208.26924,172.72029 209.21168,172.05937 209.15626,171.17463 C 209.10085,170.28991 208.94926,169.0862 208.56251,167.20588 C 208.41734,166.50092 208.06902,166.2062 207.71876,166.20588 z M 236.21876,166.20588 C 235.8685,166.2062 235.5202,166.50092 235.37501,167.20588 C 234.98826,169.0862 234.83669,170.28991 234.78126,171.17463 C 234.72584,172.05937 235.6683,172.72029 236.00001,171.39338 C 236.37424,169.89687 236.88705,168.86734 237.21876,167.70588 C 237.42609,166.98024 236.80253,166.20536 236.21876,166.20588 z M 221.96876,167.39338 C 221.24958,167.39339 221.15023,168.35899 221.12501,169.14338 C 221.04236,171.71466 219.97517,174.21192 219.06251,175.45588 C 218.15028,176.70025 216.80689,176.36933 215.56251,175.70588 C 214.31815,175.04245 213.5769,174.54522 212.25001,173.54963 C 210.9227,172.55448 209.91641,173.13633 211.50001,175.39338 C 216.11747,181.97369 221.12501,187.5982 221.12501,198.33088 C 221.12502,199.71862 221.36747,200.14338 221.96876,200.14338 C 222.57005,200.14338 222.84374,199.71862 222.84376,198.33088 C 222.84376,187.5982 227.82007,181.97369 232.43751,175.39338 C 234.02111,173.13633 233.01484,172.55448 231.68751,173.54963 C 230.36062,174.54522 229.61939,175.04245 228.37501,175.70588 C 227.13063,176.36933 225.78726,176.70025 224.87501,175.45588 C 223.96235,174.21192 222.89518,171.71466 222.81251,169.14338 C 222.78729,168.35899 222.68796,167.39339 221.96876,167.39338 z M 186.68751,165.78309 C 186.62459,165.78137 186.55597,165.79672 186.50001,165.81434 C 186.23143,165.89895 186.05249,166.22315 186.15626,166.78309 C 186.34172,167.78535 187.03621,169.7496 187.31251,170.68934 C 187.58924,171.62952 188.74506,171.42956 188.46876,170.15809 C 188.19206,168.88621 188.20674,168.50208 187.87501,167.06434 C 187.69361,166.27808 187.12805,165.79517 186.68751,165.78309 z M 257.25001,165.78309 C 256.80947,165.79517 256.24393,166.27808 256.06251,167.06434 C 255.73078,168.50208 255.74548,168.88621 255.46876,170.15809 C 255.19246,171.42956 256.3483,171.62952 256.62501,170.68934 C 256.90131,169.7496 257.5958,167.78535 257.78126,166.78309 C 257.88503,166.22315 257.70609,165.89895 257.43751,165.81434 C 257.38155,165.79672 257.31295,165.78137 257.25001,165.78309 z M 165.71876,166.18934 C 165.13997,166.23465 164.72491,166.96181 165.31251,168.03309 C 165.94637,169.18996 167.03368,170.64128 167.53126,171.47059 C 168.02886,172.29991 168.88969,171.74036 168.28126,170.68934 C 167.67324,169.63877 167.46889,168.4321 166.75001,166.93934 C 166.48045,166.37941 166.06604,166.16216 165.71876,166.18934 z M 278.21876,166.18934 C 277.87148,166.16216 277.45707,166.37941 277.18751,166.93934 C 276.46863,168.4321 276.26428,169.63877 275.65626,170.68934 C 275.04783,171.74036 275.90866,172.29991 276.40626,171.47059 C 276.90384,170.64128 277.99115,169.18996 278.62501,168.03309 C 279.21261,166.96181 278.79755,166.23465 278.21876,166.18934 z M 134.03126,169.51838 C 133.36345,169.4829 133.15409,170.68863 133.78126,171.48713 C 134.69393,172.64817 135.32901,173.26405 136.37501,174.20588 C 137.20474,174.95227 137.44592,173.98351 137.03126,173.23713 C 136.61662,172.49076 136.01682,171.7315 135.18751,170.48713 C 134.73288,169.80512 134.33481,169.53451 134.03126,169.51838 z M 309.90626,169.51838 C 309.60271,169.53451 309.20464,169.80512 308.75001,170.48713 C 307.9207,171.7315 307.3209,172.49076 306.90626,173.23713 C 306.4916,173.98351 306.73278,174.95227 307.56251,174.20588 C 308.60851,173.26405 309.24359,172.64817 310.15626,171.48713 C 310.78343,170.68863 310.57407,169.4829 309.90626,169.51838 z M 139.06251,170.51838 C 138.53029,170.52532 138.17911,170.91843 138.59376,171.83088 C 139.18763,173.13695 139.97076,174.61654 140.46876,175.61213 C 140.96636,176.60732 142.48303,176.94156 141.87501,175.39338 C 141.26659,173.84521 141.14677,173.04988 140.59376,171.61213 C 140.31726,170.89327 139.59474,170.51145 139.06251,170.51838 z M 304.87501,170.51838 C 304.34278,170.51145 303.62026,170.89327 303.34376,171.61213 C 302.79075,173.04988 302.67093,173.84521 302.06251,175.39338 C 301.45449,176.94156 302.97116,176.60732 303.46876,175.61213 C 303.96676,174.61654 304.74989,173.13695 305.34376,171.83088 C 305.75841,170.91843 305.40723,170.52532 304.87501,170.51838 z M 129.31251,170.86213 C 128.53874,170.87003 128.47208,171.6458 129.15626,172.14338 C 130.06892,172.80684 131.15649,173.54322 132.21876,174.39338 C 133.46273,175.38856 133.9447,174.4731 133.28126,173.64338 C 132.61782,172.81408 131.97153,171.9731 130.31251,171.14338 C 129.89776,170.93606 129.57043,170.8595 129.31251,170.86213 z M 314.62501,170.86213 C 314.36709,170.8595 314.03976,170.93606 313.62501,171.14338 C 311.96599,171.9731 311.3197,172.81408 310.65626,173.64338 C 309.99282,174.4731 310.47479,175.38856 311.71876,174.39338 C 312.78103,173.54322 313.86859,172.80684 314.78126,172.14338 C 315.46544,171.6458 315.39877,170.87003 314.62501,170.86213 z M 204.96876,171.58088 C 204.5358,171.64145 204.16235,172.13322 204.34376,172.76838 C 204.67549,173.92942 205.05205,175.15983 205.28126,176.36213 C 205.50256,177.52359 206.8463,177.53773 206.62501,176.48713 C 206.40415,175.43655 206.29299,174.12199 205.90626,172.51838 C 205.76109,171.91704 205.45795,171.62817 205.15626,171.58088 C 205.09342,171.57104 205.03061,171.57223 204.96876,171.58088 z M 238.78126,171.58088 C 238.47957,171.62817 238.17645,171.91704 238.03126,172.51838 C 237.64453,174.12199 237.53339,175.43655 237.31251,176.48713 C 237.09122,177.53773 238.43498,177.52359 238.65626,176.36213 C 238.88547,175.15983 239.26205,173.92942 239.59376,172.76838 C 239.77517,172.13322 239.40174,171.64145 238.96876,171.58088 C 238.90691,171.57223 238.84412,171.57104 238.78126,171.58088 z M 174.87501,169.59559 C 174.53504,169.68956 174.33942,170.33955 174.59376,171.25184 C 176.004,176.31148 176.4363,178.97621 176.18751,180.22059 C 175.93873,181.46457 175.256,181.63524 174.34376,181.22059 C 173.43153,180.80594 172.36056,180.20736 171.53126,179.62684 C 170.70196,179.04592 169.83939,179.74084 171.03126,180.72059 C 177.08606,185.69729 181.28306,191.38482 182.90626,198.28309 C 183.238,199.69294 184.12381,199.85878 183.87501,198.28309 C 182.5027,189.59329 182.23882,182.44969 184.31251,177.97059 C 185.09182,176.28738 184.30689,174.67095 183.06251,177.40809 C 182.23321,179.23301 180.89102,179.95295 179.81251,178.37684 C 178.7344,176.80116 176.5072,172.59717 175.84376,170.68934 C 175.59482,169.97391 175.28778,169.64292 175.03126,169.59559 C 174.97783,169.58574 174.92358,169.58217 174.87501,169.59559 z M 268.90626,169.59559 C 268.64974,169.64292 268.3427,169.97391 268.09376,170.68934 C 267.43032,172.59717 265.20312,176.80116 264.12501,178.37684 C 263.0465,179.95295 261.70431,179.23301 260.87501,177.40809 C 259.63063,174.67095 258.8457,176.28738 259.62501,177.97059 C 261.6987,182.44969 261.43482,189.59329 260.06251,198.28309 C 259.81371,199.85878 260.69952,199.69294 261.03126,198.28309 C 262.65446,191.38482 266.85146,185.69729 272.90626,180.72059 C 274.09813,179.74084 273.23556,179.04592 272.40626,179.62684 C 271.57696,180.20736 270.50599,180.80594 269.59376,181.22059 C 268.68152,181.63524 267.99879,181.46457 267.75001,180.22059 C 267.50122,178.97621 267.93352,176.31148 269.34376,171.25184 C 269.5981,170.33955 269.40248,169.68956 269.06251,169.59559 C 269.01394,169.58217 268.95969,169.58574 268.90626,169.59559 z M 144.43751,172.01838 C 143.89144,172.02532 143.43872,172.40782 143.68751,173.23713 C 144.08634,174.5657 144.91121,176.00157 145.18751,176.83088 C 145.46423,177.66021 146.35337,177.27317 146.18751,176.11213 C 146.02167,174.95111 145.94005,174.25902 145.71876,172.98713 C 145.60813,172.35141 144.98359,172.01145 144.43751,172.01838 z M 299.50001,172.01838 C 298.95393,172.01145 298.32939,172.35141 298.21876,172.98713 C 297.99747,174.25902 297.91585,174.95111 297.75001,176.11213 C 297.58415,177.27317 298.47329,177.66021 298.75001,176.83088 C 299.02631,176.00157 299.85118,174.5657 300.25001,173.23713 C 300.4988,172.40782 300.04608,172.02532 299.50001,172.01838 z M 163.21876,170.28309 C 162.58372,170.16913 162.49242,171.80734 163.03126,172.47059 C 163.75015,173.35576 164.74859,174.42538 165.75001,175.62684 C 166.57933,176.62244 167.09175,175.73741 166.59376,174.90809 C 166.09619,174.07837 165.35814,173.19678 164.03126,171.09559 C 163.69944,170.5703 163.43044,170.32108 163.21876,170.28309 z M 280.71876,170.28309 C 280.50708,170.32108 280.23808,170.5703 279.90626,171.09559 C 278.57938,173.19678 277.84133,174.07837 277.34376,174.90809 C 276.84577,175.73741 277.35819,176.62244 278.18751,175.62684 C 279.18893,174.42538 280.18737,173.35576 280.90626,172.47059 C 281.4451,171.80734 281.3538,170.16913 280.71876,170.28309 z M 148.71876,174.23713 C 148.32474,174.20948 147.9904,174.52908 148.15626,175.33088 C 148.38756,176.44733 148.7233,177.37403 149.00001,178.42463 C 149.27633,179.47524 150.00001,179.29522 150.00001,178.29963 C 150.00002,177.30446 149.82212,176.19398 149.65626,175.14338 C 149.57334,174.61809 149.11279,174.26479 148.71876,174.23713 z M 295.21876,174.23713 C 294.82473,174.26479 294.36418,174.61809 294.28126,175.14338 C 294.1154,176.19398 293.9375,177.30446 293.93751,178.29963 C 293.93751,179.29522 294.66119,179.47524 294.93751,178.42463 C 295.21422,177.37403 295.54996,176.44733 295.78126,175.33088 C 295.94712,174.52908 295.61278,174.20948 295.21876,174.23713 z M 161.81251,175.65809 C 161.19365,175.75159 160.6491,176.34985 161.37501,177.28309 C 162.53607,178.77584 163.80743,179.82383 164.25001,180.37684 C 164.69218,180.92987 165.81263,180.72579 165.09376,179.56434 C 164.35906,178.37789 163.2476,176.94908 162.75001,176.06434 C 162.56343,175.73257 162.18383,175.602 161.81251,175.65809 z M 281.87501,175.65809 C 281.60285,175.6867 281.32745,175.81551 281.18751,176.06434 C 280.68992,176.94908 279.57846,178.37789 278.84376,179.56434 C 278.12489,180.72579 279.24534,180.92987 279.68751,180.37684 C 280.13009,179.82383 281.40145,178.77584 282.56251,177.28309 C 283.28842,176.34985 282.74387,175.75159 282.12501,175.65809 C 282.03218,175.64407 281.96573,175.64855 281.87501,175.65809 z M 141.15626,179.83088 C 140.668,179.78654 140.49938,180.18047 141.15626,181.08088 C 142.64903,183.12666 144.29582,186.22273 144.40626,187.54963 C 144.51713,188.87695 143.86095,188.86213 143.25001,188.86213 C 141.42512,188.86215 140.53363,187.53012 138.87501,187.14338 C 137.21599,186.75625 136.97522,187.62865 138.15626,188.48713 C 144.23856,192.91082 150.33501,197.84636 152.78126,202.33088 C 153.77645,204.15578 155.12181,204.82284 154.37501,203.08088 C 152.08795,197.74371 151.53367,193.22426 152.03126,190.48713 C 152.52926,187.75001 153.20794,185.90698 153.12501,184.33088 C 153.0421,182.7552 152.1484,182.86271 151.78126,184.33088 C 151.53247,185.32648 151.05048,186.64538 150.71876,187.14338 C 150.38705,187.64099 149.05314,187.91993 147.78126,186.20588 C 146.50937,184.49186 143.30061,181.19144 142.25001,180.36213 C 141.85605,180.05115 141.44922,179.85749 141.15626,179.83088 z M 302.78126,179.83088 C 302.4883,179.85749 302.08147,180.05115 301.68751,180.36213 C 300.63691,181.19144 297.42815,184.49186 296.15626,186.20588 C 294.88438,187.91993 293.55047,187.64099 293.21876,187.14338 C 292.88704,186.64538 292.40505,185.32648 292.15626,184.33088 C 291.78912,182.86271 290.89542,182.7552 290.81251,184.33088 C 290.72958,185.90698 291.40826,187.75001 291.90626,190.48713 C 292.40385,193.22426 291.84957,197.74371 289.56251,203.08088 C 288.81571,204.82284 290.16107,204.15578 291.15626,202.33088 C 293.60251,197.84636 299.69896,192.91082 305.78126,188.48713 C 306.9623,187.62865 306.72153,186.75625 305.06251,187.14338 C 303.40389,187.53012 302.5124,188.86215 300.68751,188.86213 C 300.07657,188.86213 299.42039,188.87695 299.53126,187.54963 C 299.6417,186.22273 301.28849,183.12666 302.78126,181.08088 C 303.43814,180.18047 303.26952,179.78654 302.78126,179.83088 z' fill='%23000' stroke='none'/%3E %3Cpath d='M 150.12687,212.65106 152.07661,218.82525 M 154.13742,211.48082 155.86506,217.72081 M 158.46968,210.7684 159.65672,217.1334 M 162.48993,209.96408 163.7604,216.31295 M 167.64553,209.45517 168.67848,215.84698 M 173.13007,209.46186 174.24249,215.84031 M 178.48383,207.65149 179.28735,214.07616 M 183.52067,207.97645 184.32419,214.40112 M 188.39503,207.32654 189.19855,213.75121 M 193.28767,206.82164 193.72967,213.28125 M 198.51623,206.81977 198.89973,213.28312 M 203.25656,206.49325 203.58317,212.95973 M 208.48353,206.16701 208.75481,212.63605 M 214.49524,206.00453 214.76652,212.47357 M 293.81064,212.65106 291.8609,218.82525 M 289.80009,211.48082 288.07245,217.72081 M 285.46783,210.7684 284.28079,217.1334 M 281.44758,209.96408 280.17711,216.31295 M 276.29198,209.45517 275.25903,215.84698 M 270.80744,209.46186 269.69502,215.84031 M 265.45368,207.65149 264.65016,214.07616 M 260.41684,207.97645 259.61332,214.40112 M 255.54248,207.32654 254.73896,213.75121 M 250.64984,206.82164 250.20784,213.28125 M 245.42128,206.81977 245.03778,213.28312 M 240.68095,206.49325 240.35434,212.95973 M 235.45398,206.16701 235.1827,212.63605 M 229.44227,206.00453 229.17099,212.47357 M 221.96876,205.58364 221.96876,212.7068'/%3E %3C/g%3E %3C/g%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 1200 600'%3E %3Crect width='1200' height='600' fill='%23ffb700'/%3E %3Cpath d='M50,300 215,50H380V550H215z' fill='%23ff5b00'/%3E %3Crect width='165' height='500' x='50' y='50' fill='%23005641'/%3E %3Crect width='725' height='500' x='430' y='50' fill='%238d2029'/%3E %3Cpath id='leaf' d='m1086.1,466.06s6.7982,13.841,14.309,19.48c11.128,8.3556,33.945,7.752,43.629,17.5,11.604,11.495-0.9004,26.682-0.7959,28l0.6363,8.0206s-7.8245,0.0943-11.119,0.60793c-4.9538,0.7724-6.886,4.8032-16.109,4.2045-23.189-1.5052-22.254-22.397-23.566-40.25-1.1646-6.7983-3.8594-15.662-5.3908-22.458-1.313-5.8277-1.5933-15.105-1.5933-15.105z' fill='%23ffb700' stroke='%23000' stroke-width='2.12575722'/%3E %3Cuse xlink:href='%23leaf' transform='matrix(-1,0,0,1,1585,0)'/%3E %3Cuse xlink:href='%23leaf' transform='matrix(1,0,0,-1,0,600)'/%3E %3Cuse xlink:href='%23leaf' transform='matrix(-1,0,0,-1,1585,600)'/%3E %3Cuse xlink:href='%23lion' stroke='%23000' stroke-width='5.5598'/%3E %3Cg id='lion' fill='%23ffb700'%3E %3Cpath d='m681.54,479.56,4.3593-2.517,1.8649,2.5215c2.4846,3.3595,9.3595,3.3215,13.921-0.0773l3.4882-2.5985,2.9208,2.5985c3.8402,3.4168,11.012,3.4213,15.591,0.0122,3.206-2.3882,3.653-2.4362,5.7728-0.61944,1.2637,1.0831,4.9702,2.3162,8.2366,2.7402,5.8828,0.76367,5.9719,0.72173,9.4138-4.442,2.8826-4.3245,3.3335-6.0748,2.6456-10.269-0.45593-2.7807-0.9471-7.2562-1.0915-9.9454-0.26119-4.8694-0.23309-4.8997,6.8598-7.3695,3.9171-1.364,8.4514-3.1933,10.076-4.0653,2.8328-1.5202,10.643-10.699,10.643-12.508,0-0.47938-3.0511-1.2137-6.7801-1.632-14.833-1.6637-17.345-9.6288-7.7022-24.423,15.725-24.128,25.215-47.625,25.278-62.593,0.0285-6.6906,0.40945-8.937,1.2692-7.482,3.5135,5.9459-2.7808,30.877-12.316,48.78l-3.8392,7.2089,3.6635-0.84337c2.0149-0.46382,13.861-5.4619,26.325-11.107,34.115-15.451,45.833-18.479,67.911-17.549,18.497,0.77911,26.374,4.3927,39.434,18.09,6.9185,7.2565,13.583,12.449,25.775,20.08,25.975,16.259,27.058,17.667,28.293,36.788,1.2515,19.373,0.62869,20.424-14.024,23.661-12.524,2.7669-20.375,8.6054-22.481,16.717-1.1245,4.3318,1.242,4.4565,7.5561,0.39845l4.6275-2.9741,2.0576,2.9741c2.7051,3.91,8.455,3.9256,13.23,0.0356l3.6067-2.9381,3.6869,2.9381c5.7286,4.565,13.347,3.458,15.497-2.252,0.41335-1.0975,1.5164-0.74587,3.75,1.1953,4.1852,3.6374,14.914,5.1976,16.072,2.3376,0.44221-1.0912-0.3978-3.7862-1.8666-5.9887-6.2419-9.3596-8.1945-13.823-8.2758-18.918-0.11266-7.0863,2.0014-10.505,10.061-16.268,9.7908-7.0008,12.816-16.033,5.3706-16.033-4.5972,0-9.2317-4.0634-12.187-10.686-6.0079-13.461-4.8304-28.552,4.1866-53.657,9.1588-25.5,10.175-30.202,10.211-47.256,0.03-13.789-0.3175-16.174-3.4548-23.734-1.9182-4.6223-5.8102-11.505-8.6489-15.294l-5.1614-6.8903,6.6267-5.49c20.234-16.763,16.095-44.198-8.263-54.769-7.4516-3.2338-9.3134-3.5194-22.372-3.4316-7.8342,0.0527-19.78,1.0836-26.546,2.2911-6.8986,1.2311-18.575,2.2205-26.585,2.2526-12.725,0.0512-14.885-0.26249-19.789-2.8727-5.1132-2.7217-5.9899-4.0139-6.991-10.305-0.20575-1.2931-1.1099-2.5831-2.0089-2.8666-1.7392-0.54841-9.771,6.4223-10.958,9.51-0.58543,1.5235-1.0633,1.4182-2.7808-0.61319-1.1407-1.349-2.7333-4.4487-3.5393-6.8883-2.0267-6.1353,0.46204-10.735,7.6738-14.181l5.5952-2.6741-3.2993-2.0474c-6.8083-4.2248-18.385-1.3347-22.572,5.635-1.1843,1.9715-2.4761,3.5881-2.8706,3.5924-0.39444,0.003-2.6455-1.8765-5.0025-4.1795-8.7904-8.5893-5.7666-21.297,5.9908-25.177,6.2696-2.0689,11.818-0.49068,12.972,3.69,1.7624,6.3826,7.2409-2.0071,6.2584-9.584-0.6533-5.0374-0.55514-5.212,2.9305-5.212,4.8473,0,15.165,6.3619,18.356,11.319,3.7064,5.7573,3.4367,14.823-0.64203,21.58l-3.2027,5.3055,4.1894-0.83896c6.1434-1.2302,12.112-5.0453,15.131-9.6721,3.192-4.8914,3.5352-14.416,0.70469-19.555-2.7429-4.981-2.4284-5.7717,1.6267-4.0885,6.8969,2.8628,10.584,6.0201,13.35,11.431,2.4908,4.8729,2.6298,6.0838,1.2814,11.156-0.83198,3.1291-2.6831,7.246-4.1137,9.1486-2.2274,2.9626-2.3034,3.4593-0.52871,3.4593,3.3052,0,10.206-3.1281,12.658-5.7373,1.2383-1.3182,3.0437-4.564,4.012-7.2129l1.7607-4.8162,2.023,3.6712c2.8609,5.1912,8.4225,9.8627,15.204,12.77,7.293,3.1265,10.33,3.3027,6.5164,0.37792-2.5718-1.9723-7.3109-15.878-5.8747-17.238,0.84508-0.80031,10.747,6.8186,22.053,16.968,10.695,9.6009,17.415,12.746,27.238,12.746,12.548,0.00008,19.854-10.923,14.214-21.251-3.288-6.0216-10.613-6.8581-14.896-1.7011-1.9696,2.3714-2.5103,4.2577-1.9334,6.745,0.7066,3.047,0.4309,3.453-2.3451,3.453-3.6473,0-10.837-4.6664-23.606-15.321-19.471-16.248-43.13-30.02-60.214-35.05-10.963-3.2285-34.383-4.4883-45.528-2.4492-12.062,2.207-26.329,9.1099-34.101,16.499-13.772,13.094-13.991,30.518-0.58141,46.385l3.8411,4.5452-2.6005,4.0394c-3.7831,5.8765-3.4591,13.785,0.80339,19.61,1.8774,2.5656,3.7712,4.6637,4.2085,4.6623,0.43728-0.001,0.91679-1.6508,1.0654-3.6654,0.37644-5.0966,2.5638-8.5113,6.3183-9.8632,3.3816-1.2176,5.5676-0.64252,21.051,5.5376,16.289,6.5015,43.077,6.9484,71.561,1.1938,13.964-2.8211,30.43-2.6552,37.674,0.37962,13.279,5.5631,16.357,20.036,6.5955,31.022-4.2256,4.7559-8.3008,6.6927-21.983,10.448-10.412,2.8575-12.878,3.0472-36.543,2.8109-20.218-0.20184-27.484,0.18642-35.737,1.9096-8.9598,1.8707-14.471,2.0594-40.79,1.3961l-30.431-0.76685,3.3746,2.7943c1.856,1.5368,4.4782,3.4277,5.8271,4.202,2.2952,1.3174,2.2187,1.4944-1.1927,2.7593-2.0049,0.7434-6.4548,1.3516-9.8886,1.3516h-6.2432l-0.84015,5.3057c-0.46215,2.9182-0.42705,6.3252,0.0776,7.5711,0.74459,1.8377,0.46708,2.1016-1.4696,1.3977-1.313-0.47719-4.97-1.4158-8.1265-2.0857-3.1565-0.66995-7.4054-2.0342-9.442-3.0316-3.4248-1.6773-3.8054-1.6322-5.0669,0.60016-1.1264,1.9935-11.702,9.8644-13.254,9.8644-0.25046,0-0.57378-1.5176-0.71843-3.3725-0.14464-1.8549-1.6703-6.6837-3.3904-10.731-1.7202-4.047-3.5162-8.4619-3.9913-9.8109-0.71672-2.035-1.0412-2.1394-1.9056-0.61319-0.573,1.0118-1.4096,3.7711-1.8591,6.1318-0.44947,2.3607-2.043,6.1958-3.5412,8.5224l-2.724,4.2301-1.7374-3.617c-1.8651-3.8828-4.9615-7.9092-6.0825-7.9092-0.37837,0-1.0228,1.2417-1.432,2.7593-0.85453,3.1692-8.197,11.957-9.9903,11.957-0.66041,0-1.2007-2.4834-1.2007-5.5186s-0.5827-5.5186-1.2949-5.5186-1.2949,0.78545-1.2949,1.7454c0,2.3335-6.2706,9.2918-8.3736,9.2918-0.91771,0-2.394,0.82779-3.2807,1.8395-2.3118,2.638-4.2029,2.2678-3.231-0.63242,0.45568-1.3596,0.15939-4.5328-0.65846-7.0516-0.81788-2.5188-1.6875-5.1996-1.9325-5.9573-0.30871-0.95429-2.5558-0.70116-7.3116,0.82362-7.6852,2.4639-10.261,2.028-6.3087-1.0676,1.4449-1.1316,3.6425-5.0514,4.8838-8.7107,1.2412-3.6592,3.0726-6.9061,4.0698-7.2151,1.3963-0.43282,1.322,0.10204-0.32373,2.3272-1.1753,1.5891-2.1404,3.7321-2.1448,4.7624,0,1.0303-0.88884,3.473-1.9656,5.4282-1.0766,1.9552-1.7534,3.7483-1.5039,3.9845,0.24941,0.23626,3.1735-0.87452,6.4978-2.4684l6.0442-2.8979,0.0246,2.5925c0.0142,1.4259,0.74212,5.1875,1.6186,8.3592l1.5937,5.7666,4.1143-1.891c4.2049-1.9326,8.1874-8.8222,8.1874-14.164,0-2.6406,1.5126-2.2353,2.132,0.57128,0.18181,0.8236,1.1312,3.9147,2.1099,6.8692l1.7795,5.3717,2.817-3.3916c1.5494-1.8654,3.4917-5.5244,4.3163-8.131,1.4315-4.5251,3.6793-6.4706,3.6793-3.1845,0,2.368,6.4622,10.861,7.7088,10.131,0.60253-0.35262,1.8023-3.5401,2.6661-7.0833,1.7967-7.3686,4.6952-12.38,6.537-11.302,0.69252,0.40535,0.96225,1.192,0.59929,1.7482-0.36297,0.55613,1.1254,5.3468,3.3075,10.646,2.1821,5.2991,4.3732,10.634,4.8693,11.856,0.797,1.9632,1.5174,1.678,6.1947-2.4527,2.911-2.5708,5.5531-5.4487,5.8713-6.3953,0.48094-1.431,1.1303-1.3786,3.8524,0.31056,3.8067,2.3622,16.605,6.1683,17.593,5.2321,0.37021-0.35059,0.74975-3.7118,0.8435-7.4694l0.17042-6.8319,3.6804,0.76323c2.0242,0.41978,6.2805,0.39398,9.4584-0.0575l5.7779-0.82057-5.1492-3.5327c-2.8322-1.943-5.6958-4.4574-6.3636-5.5875-0.71142-1.204-3.232-2.2263-6.0873-2.469-7.7147-0.65558-21.388-8.3244-21.388-11.996,0-0.68925,1.8938,0.48271,4.2085,2.6043,5.1349,4.7067,12.269,7.6609,18.499,7.6609h4.6621l-2.884-3.8358c-1.6567-2.2034-3.1425-6.3832-3.4914-9.8218-0.55604-5.481-1.1346-6.3525-6.8578-10.331-3.4376-2.3899-7.6957-5.972-9.4622-7.9603l-3.2119-3.615-1.6387,4.2921c-0.90139,2.3607-2.003,4.2921-2.4479,4.2921-0.44494,0-2.1777-1.3797-3.8503-3.0659-1.6728-1.6862-3.3768-3.0596-3.7867-3.0518-0.4101,0.007-1.8919,2.2791-3.2929,5.0474l-2.5474,5.0333-1.9684-2.9012c-1.0827-1.5957-3.64-4.4189-5.6829-6.2738s-3.1174-3.3725-2.3877-3.3725c0.72956,0,3.251,1.9323,5.6033,4.294l4.2765,4.294,1.7405-3.146c1.0328-1.8669,1.4199-4.7346,0.95201-7.0533-0.68203-3.3797-0.5862-3.5761,0.70963-1.4546,0.82408,1.349,3.3259,3.9353,5.5597,5.7473l4.0616,3.2946,2.8028-5.1341c2.7895-5.1094,2.8091-5.1194,4.0782-2.0682,1.6972,4.0805,13.98,14.149,24.437,20.032,1.6118,0.9067,0.9322-2.2112-2.0444-9.3809-0.78834-1.8988-1.4333-5.3219-1.4333-7.607,0-3.39-0.97793-4.8988-5.3136-8.1981-6.2592-4.7632-8.2835-8.1504-9.463-15.835-0.47783-3.1128-1.5732-6.5749-2.4343-7.6935-1.2773-1.6596-1.4884-0.73081-1.1466,5.0465,0.23036,3.8942-0.27608,8.7359-1.1256,10.759l-1.5443,3.6791-1.1938-3.0659c-0.65653-1.6862-3.5605-4.6187-6.4535-6.5166-2.8929-1.8979-4.9233-3.7694-4.5119-4.1589,0.41126-0.38953,3.3874,1.3402,6.6134,3.8437,4.9147,3.814,5.9973,4.227,6.678,2.5471,0.79975-1.9739-0.001-10.562-1.5461-16.563-0.77113-2.9968-0.70366-2.9807,2.9932,0.71559,2.7266,2.7261,4.2342,5.9776,5.4023,11.65,1.4838,7.2068,2.2324,8.4066,8.8962,14.258,4.0018,3.5138,7.4844,6.1913,7.7391,5.9502,0.25458-0.24116,0.75961-9.3307,1.1222-20.199,0.69536-20.841-0.0906-25.8-5.1098-32.239l-2.5788-3.3085,4.054-4.3729c5.2886-5.7045,7.7168-10.277,8.7701-16.515l0.85683-5.0748-4.5751,4.3329c-3.7462,3.5479-5.5352,4.3329-9.8743,4.3329-4.2965,0-5.9749-0.72001-8.8702-3.8052-3.4739-3.7017-9.6295-7.2634-15.549-8.9969-2.1867-0.64031-2.9136-0.3614-2.9136,1.1179,0,1.0841-1.2079,4.2133-2.6842,6.9538l-2.6841,4.9828-5.6238-5.5587c-3.4497-3.4096-7.5436-6.0635-10.589-6.8644-7.7808-2.0462-8.2022-1.843-8.2022,3.954,0,8.7932-3.7543,10.431-10.511,4.5868-5.1508-4.4554-9.4235-5.4241-19.191-4.3505l-7.5435,0.82916,1.3573,3.4054c1.1337,2.8446,0.8782,4.0425-1.5508,7.2732-3.9398,5.2399-9.0624,7.5098-16.948,7.5098-3.6319,0-8.1768,0.75156-10.1,1.6701-1.9232,0.91856-6.7016,1.9768-10.619,2.3517-3.9171,0.37491-8.0922,1.044-9.2778,1.4869-1.8554,0.69306-2.059,0.12189-1.4614-4.098,0.91472-6.4581-3.5965-11.222-10.627-11.222-9.1217,0-13.329,8.1592-9.7568,18.922,0.68749,2.0714,1.5871,5.3381,1.999,7.2593,0.42746,1.9932,4.5362,7.2825,9.5688,12.318,4.8509,4.8537,9.4354,9.9041,10.188,11.223,0.75262,1.3191,3.2407,3.4359,5.529,4.704l4.1608,2.3058-0.5488-4.4519c-0.60318-4.8928,0.46295-5.6604,3.0662-2.2077,0.93053,1.2343,3.2945,3.2293,5.2531,4.4333,3.0853,1.8967,3.561,1.9353,3.561,0.28842,0-1.0454,0.62895-3.4543,1.3976-5.3531l1.3977-3.4523,2.4251,4.6972c1.3338,2.5835,5.6714,8.455,9.639,13.048,7.6986,8.9118,12.389,18.871,9.9683,21.163-0.98194,0.92988-3.6363,0.85791-9.1376-0.24774-4.2646-0.85709-9.5394-1.3101-11.722-1.0068-4.4571,0.61953-4.8082,0.0441-2.067-3.3881,2.8931-3.6226,2.4329-4.2201-3.2508-4.2201-6.5757,0-22.901-3.1522-29.168-5.6319-6.0934-2.4112-7.4993-1.8108-9.2928,3.9686-0.80725,2.601-2.2853,7.3142-3.2844,10.474l-1.8166,5.7444,6.5927-0.6349c3.626-0.3492,8.2897-1.1431,10.364-1.7642,2.0741-0.62112,3.9591-0.95122,4.1889-0.73356,0.22985,0.21769-0.6946,2.4623-2.0543,4.988l-2.4721,4.5922,4.1103-0.8379c2.2608-0.46085,5.662-1.5885,7.5584-2.5059,3.2998-1.5963,3.5648-1.4804,6.1676,2.6973,3.2006,5.1376,5.7611,4.9265,6.3292-0.52181,0.58738-5.6325,2.4401-4.7994,5.9255,2.6645,3.3515,7.1772,6.8385,9.7112,7.5085,5.4565,0.22232-1.4126,2.0278-3.7122,4.012-5.1101,4.0136-2.8276,7.0382-1.9792,8.7723,2.4603,1.795,4.5955-2.2084,9.3323-13.853,16.391-23.327,14.14-36.886,33.479-40.757,58.128-3.4915,22.233,7.4134,45.207,29.29,61.708,10.469,7.8966,27.1,16.231,26.043,13.051-4.4882-13.505-4.3404-39.274,0.2503-43.621,0.68891-0.65244,0.45194,2.0364-0.52663,5.9752-3.645,14.672-2.0615,26.363,7.282,53.763,8.4506,24.782,7.2809,35.373-4.6794,42.374-3.8414,2.2484-6.3146,2.6189-16.643,2.4936-11.207-0.13613-12.428,0.0895-16.026,2.9564-3.4881,2.7798-8.0108,11.906-8.0108,16.165,0,2.3072,2.562,2.0018,7.5966-0.90506z'/%3E %3Cpath d='m863.45,479.06,4.7011-3.0213,3.1903,3.0213c4.1796,3.9583,9.0759,3.8698,13.094-0.23669,1.7536-1.792,3.3283-3.0336,3.4993-2.7593,0.17093,0.27434,0.95293,1.6025,1.7376,2.9515,0.99334,1.7076,3.0357,2.5662,6.7222,2.8263,4.4417,0.31334,5.6344-0.1165,7.3993-2.6674l2.1038-3.041,4.6277,2.9741c12.669,8.1426,19.42-0.40017,13.758-17.411-2.879-8.6495-1.296-13.512,7.983-24.521,3.9128-4.6423,7.1176-9.5973,7.1215-11.011,0-2.2539-0.72386-2.5559-5.9314-2.4527-4.9834,0.0994-6.4413-0.43585-9.0644-3.3233-4.2665-4.6965-4.013-10.075,0.75623-16.044l3.81-4.7681-6.7596-4.5873c-3.7178-2.5231-10.422-8.4924-14.899-13.265-10.054-10.719-19.939-15.802-32.975-16.955l-8.7404-0.77298,0.0129,6.6158c0.0168,8.5168,4.0137,16.71,14.924,30.588,12.405,15.779,13.271,18.222,13.774,38.846l0.42473,17.442-3.5896,3.4057c-3.2436,3.0773-4.7062,3.47-15.173,4.0736-9.9645,0.57467-12.058,1.0888-14.982,3.6791-3.8836,3.4404-5.0449,5.3118-6.244,10.063-0.69887,2.7688-0.41568,3.3725,1.5825,3.3725,1.3386,0,4.5493-1.3597,7.1349-3.0214z'/%3E %3Cpath d='m596.82,433.98c1.1086-1.4991,2.0158-3.9198,2.0158-5.3794,0-2.2052,0.98543-2.7937,5.8314-3.4819l5.8314-0.82816-3.889-3.0993c-4.6204-3.6819-5.0478-6.5584-0.97546-6.5647,4.056,0,10.925-4.2118,11.969-7.3279,0.48536-1.4483,0.18013-3.3834-0.69044-4.3769-2.2738-2.5946-6.5486-2.2034-7.3427,0.67204-0.85348,3.091-2.2824,3.0992-5.5219,0.0306-4.8732-4.6153-4.9826-14.169-0.22595-19.732,2.2418-2.6218,2.2218-2.7938-0.6362-5.5005-3.0745-2.9118-5.2702-8.6748-3.826-10.043,0.45957-0.43524,2.8886-0.0884,5.3979,0.77114,3.5656,1.2211,4.9732,1.2396,6.4421,0.0846,4.4496-3.4973-0.37114-7.9944-7.5068-7.0025-2.8718,0.3992-4.0582,0-4.4706-1.4897-0.31195-1.1298-2.8238-2.605-5.6539-3.3204-5.0569-1.2784-5.0926-1.2628-5.0926,2.2213,0,3.8179-2.1794,4.5382-6.3206,2.0889-3.365-1.9903-6.6286-0.44518-6.6286,3.1383,0,3.3434,3.3623,4.9923,9.3882,4.604,4.6219-0.29789,4.7939,3.1391,0.40427,8.0796l-3.1567,3.5529,2.5008,3.5928c3.7037,5.321,3.3919,14.158-0.65433,18.547l-3.1721,3.4409-2.081-2.7593c-2.8919-3.8346-6.8476-3.5776-7.9323,0.51543-0.71028,2.6802-0.12315,3.905,3.2331,6.745,2.2555,1.9086,5.5485,3.4702,7.3178,3.4702,4.3784,0,4.2072,3.4433-0.34417,6.9217l-3.561,2.7216,5.5034,0.85366c3.0269,0.46958,5.5034,1.3529,5.5034,1.9628,0,2.339,3.8141,9.6148,5.0401,9.6148,0.70818,0,2.1948-1.2265,3.3034-2.7256z'/%3E %3Cpath d='m668.48,402.92c5.0001-1.9709,15.821-11.134,15.821-13.398,0-0.71202-2.9869-3.997-6.6374-7.3001-7.6824-6.9509-16.039-18.657-18.204-25.501-1.1289-3.5687-6.5843-9.6779-21.951-24.581l-20.448-19.832-5.8934,1.4927c-3.2414,0.82104-7.1962,1.5127-8.7885,1.537-2.7441,0.0417-2.6943,0.19928,0.95383,3.0226l3.8489,2.9786,5.3959-2.9948c5.2303-2.9029,5.4165-2.9208,6.0615-0.58461,0.37773,1.3676-0.43704,3.7378-1.8831,5.479-1.4019,1.6877-2.2004,3.6023-1.7748,4.2546,0.42564,0.65216-0.92107,2.016-2.9927,3.0306-3.8397,1.8805-6.5048,8.0707-3.4747,8.0707,2.7261,0,8.7373-7.4169,8.0447-9.9256-0.35481-1.2846-0.18323-2.6059,0.38121-2.9363,2.3412-1.3703,2.1949,4.4528-0.18374,7.3168-1.4019,1.6877-2.2004,3.6023-1.7748,4.2546,0.42564,0.65218-0.92107,2.016-2.9927,3.0306-3.8148,1.8683-6.5067,8.0707-3.5029,8.0707,2.944,0,8.8566-7.0875,8.1244-9.7388-0.38303-1.3874-0.23476-2.7927,0.32968-3.1231,1.5768-0.92296,2.4275,3.6741,1.0964,5.9264-0.71298,1.2066-0.70651,2.8536,0.0168,4.1598,1.3096,2.3663-0.0182,6.9107-2.4316,8.3233-1.0345,0.60546-0.33394,1.7936,2.1753,3.6885,3.631,2.7423,3.7014,3.0302,3.7014,15.13,0,10.112,0.40827,12.722,2.2661,14.482,2.0848,1.9754,2.2661,1.9825,2.2661,0.0884,0-2.069,3.6318-4.5981,6.6028-4.5981,0.8764,0,6.3518,4.6402,12.167,10.312,5.8509,5.7058,11.973,10.561,13.707,10.87,1.7232,0.30733,3.5888,0.63391,4.1458,0.72575,0.55695,0.092,3.1792-0.68688,5.8271-1.7306z'/%3E %3Cpath d='m605.96,354c0-3.2598-6.7241-6.7394-14.767-7.6415-6.4933-0.72835-6.5996-0.68714-6.5996,2.5565,0,2.685,1.0211,3.7413,5.5034,5.6928,7.2024,3.1357,15.863,2.804,15.863-0.60778z'/%3E %3Cpath d='m613.33,353.7c3.2799-2.976,4.8339-6.5156,2.8606-6.5156-2.2695,0-8.293,5.4052-8.293,7.4417,0,3.1786,1.1188,2.9878,5.4324-0.92616z'/%3E %3Cpath d='m606.34,344.06c0.27788-1.8392-0.8597-3.0666-4.2697-4.6066-7.3558-3.3221-16.15-4.8607-18.268-3.196-3.901,3.0662-1.3018,7.1829,5.0028,7.9235,2.5382,0.29812,5.98,1.0722,7.6482,1.7202,4.8456,1.882,9.4537,1.0239,9.8867-1.8411z'/%3E %3Cpath d='m606.34,334.21c0.39598-2.6237-1.2816-3.5626-14.978-8.3834-10.225-3.5989-14.752-1.9018-11.484,4.3058,1.1384,2.1624,3.049,3.1503,7.3339,3.7919,3.187,0.4773,7.5427,1.4104,9.6793,2.0738,5.7081,1.772,9.0058,1.148,9.4489-1.788z'/%3E %3Cpath d='m613.2,324.98c2.0666-2.0947,3.7572-4.567,3.7572-5.4936,0-3.0061-8.1614,2.3121-9.2017,5.9959-1.2478,4.4187,0.77501,4.2322,5.4449-0.50233z'/%3E %3Cpath d='m606.34,324.36c0.45051-2.9886-4.5198-5.6876-14.294-7.7622-7.1711-1.522-10.334-0.6588-9.7971,2.6736,0.29315,1.8191,2.6814,3.1481,9.4566,5.2626,10.843,3.3836,14.104,3.3449,14.634-0.17403z'/%3E %3Cpath d='m615.9,310.45c12.525-5.5755,13.608-19.635,1.7976-23.326-4.9037-1.5327-8.0341-0.70686-9.9112,2.6147-1.4372,2.5434-0.476,7.1676,1.4899,7.1676,0.66417,0,1.2076,0.85596,1.2076,1.9021,0,4.8819-19.123,7.0939-26.965,3.119-2.7551-1.3964-3.9546-5.0211-1.6616-5.0211,1.7134,0,2.8981-3.6935,2.0226-6.3059-1.1928-3.5592-4.7799-4.7922-9.9831-3.4317-11.74,3.0699-11.41,16.865,0.54277,22.719,9.8013,4.8001,31.287,5.0919,41.46,0.56291z'/%3E %3Cpath d='m608.11,299.64c0.72529-0.68694,0.41011-1.7425-0.80582-2.6982-2.6627-2.0928-2.5207-5.2056,0.4-8.7689,2.1933-2.6759,2.4673-6.6804,3.2223-47.074,1.3008-69.611,6.4773-121.97,13.3-134.53,2.7163-5.0009,2.3354-5.0208-4.6839-0.24499-9.0418,6.1522-15.926,14.163-22.026,25.631-11.516,21.651-15.518,50.78-15.518,112.96,0,35.305,0.24051,39.924,2.2515,43.243,1.9103,3.1523,2.0118,4.3165,0.66998,7.6833-0.86981,2.1824-1.2645,4.2682-0.87709,4.6351,2.5711,2.435,21.302,1.789,24.067-0.82993z'/%3E %3Cpath d='m713.34,233.26c0.39236-0.6012-0.47458-3.6364-1.9264-6.745-2.2635-4.8468-3.1753-5.6519-6.4-5.6519-10.102,0-26.341-4.5144-43.083-11.976-9.6677-4.3091-13.007-5.2994-14.166-4.2013-2.958,2.8014,1.9582,9.4508,9.5715,12.946,6.754,3.1007,25.635,6.9107,34.248,6.9107,4.9966,0,5.1147,0.22548,2.2713,4.3354l-2.0914,3.0228,5.6524,0.14508c3.1087,0.0799,7.4004,0.56638,9.5371,1.0813,5.5493,1.3373,5.6012,1.3384,6.3876,0.13328z'/%3E %3Cpath fill='%23000' d='m772.35,264.63c0-1.7992-5.2837-6.6752-10.638-9.817-4.2046-2.4674-4.8992-2.5424-4.9086-0.52996-0.0143,3.0552-2.7311,10.731-3.798,10.731-0.60162,0-1.4912-1.4999-1.9771-3.3332-0.48587-1.8332-2.5241-5.4462-4.5295-8.0287l-3.6462-4.6956-2.8391,4.3506c-2.6467,4.0557-7.2315,8.0278-9.2662,8.0278-0.48599,0-0.58103-2.1359-0.21134-4.7465,0.40169-2.8364,0.092-5.0863-0.77073-5.591-0.79353-0.4645-1.4428-0.30245-1.4428,0.3601,0,1.5283-6.367,8.751-7.7142,8.751-0.55513,0-1.3322-2.0695-1.727-4.5989-0.39469-2.5294-1.0656-6.5304-1.4908-8.8911-0.42526-2.3608,0.48144-0.75983,2.015,3.5576l2.7884,7.8498,3.0577-4.7839c1.6817-2.6312,3.0607-5.5063,3.0643-6.3893,0-0.88294,0.57248-1.2741,1.2641-0.86936,0.69149,0.40477,1.654,3.5676,2.1387,7.0284l0.88145,6.2925,3.3646-3.689c1.8506-2.0289,4.019-4.7452,4.8188-6.0363,1.427-2.3036,1.5078-2.3017,4.3463,0.10554,1.5907,1.349,4.0363,4.5757,5.4345,7.1704,1.3984,2.5947,2.7296,4.5262,2.9584,4.2923,0.22868-0.23399,0.74108-2.9088,1.1388-5.9441,0.39754-3.0352,0.75248-5.6312,0.7886-5.7688,0.19786-0.7521,10.135,5.7072,13.812,8.9778,2.3631,2.1022,4.6074,3.5278,4.9873,3.1681,0.37993-0.35979,0.69071-3.4612,0.69071-6.8921,0-5.3167-0.56355-6.7417-3.8155-9.6485-3.7391-3.3422-3.8437-3.3606-5.2252-0.91579-1.7931,3.173-3.9084,3.2188-3.9084,0.0846,0-2.2875-7.0659-11.08-8.9041-11.08-0.47653,0-1.9646,1.9315-3.3071,4.2923-1.3424,2.3607-2.786,4.29-3.208,4.2874-1.8125-0.0111-11.774-11.117-11.769-13.122,0-1.5945,0.67129-1.1868,2.4176,1.4761,1.3269,2.0235,3.9777,5.0443,5.8904,6.7129,3.8731,3.3787,5.2811,2.5571,6.7757-3.9536,0.42577-1.8549,1.1658-3.3725,1.6444-3.3725,1.6558,0,10.327,9.2097,11.547,12.264l1.2244,3.0659,0.92741-3.3725c1.134-4.124,2.3852-4.2774,4.1958-0.51425,0.75626,1.572,4.4918,4.8404,8.3011,7.263l6.926,4.4047,1.39-4.4303c0.76451-2.4366,1.7773-3.8368,2.2506-3.1116,0.70585,1.0815-1.0945,8.4227-2.4528,10.002-0.20356,0.23674-2.4479-1.0705-4.9875-2.9049l-4.6172-3.3353-0.0182,5.9708c-0.0129,3.2839-0.36905,7.2125-0.79856,8.7301-0.83976,2.9674-3.0686,3.8021-3.0686,1.1492z'/%3E %3Cpath fill='%23000' d='m737.82,217.03c-8.2314-6.8725-9.481-8.4451-9.2987-11.702l0.19399-3.4668,0.537,3.3485c0.31363,1.9552,2.5058,4.8853,5.2686,7.0422l4.7318,3.6937,2.9076-3.3631c1.5993-1.8497,2.9287-4.0529,2.9544-4.896,0.0673-2.1985,0.46176-2.0139,6.0347,2.8216,4.9515,4.2963,5.0287,4.3168,5.7651,1.533,0.41049-1.5519,0.26481-4.4736-0.32372-6.4926-1.6179-5.5499-1.3009-6.3875,1.1507-3.0403,1.2214,1.6677,3.1854,4.0253,4.3644,5.239,2.0523,2.1129,2.1775,2.0868,2.9412-0.6132,0.43872-1.551,0.80557-4.3898,0.81528-6.3085l0.0182-3.4885,4.4645,5.0607c4.1702,4.7272,4.5544,4.9018,5.8272,2.6494,0.7495-1.3262,1.3716-4.5171,1.3824-7.0908,0.0142-3.3248,0.36439-4.1637,1.21-2.8977,1.4121,2.114,0.43172,7.87-2.1758,12.775l-1.8712,3.5199-2.4571-3.8264c-3.1417-4.8928-4.1876-4.8142-6.2036,0.46582-1.9052,4.9898-3.1441,5.3696-5.0005,1.533-1.2013-2.4829-1.43-2.1787-2.2827,3.0374l-0.94776,5.7967-5.6785-4.4068-5.6786-4.4068-2.5528,2.9023c-1.4041,1.5963-2.5722,3.5922-2.5959,4.4353-0.0517,1.8274-1.4176,1.8844-3.4995,0.14622z'/%3E %3Cpath fill='%23000' d='m811.04,191.43c-2.9962-2.6993-5.0602-5.2746-4.5867-5.723,0.47342-0.44838,1.0065-0.57681,1.1846-0.28542,0.17806,0.29139,2.6271,2.8668,5.4424,5.723,6.4822,6.5765,5.1496,6.7629-2.0403,0.28543z'/%3E %3Cpath fill='%23000' d='m713.51,181.35c-2.7255-3.6852-2.5373-6.1267,0.7803-10.121,2.3974-2.8864,3.4925-3.2781,7.6788-2.7463,2.6854,0.34111,8.4638,2.7138,12.841,5.2725,5.0555,2.9552,10.285,4.9349,14.335,5.427,3.5069,0.42609,6.3763,0.58673,6.3763,0.35699,0-0.22973-1.4568-2.6032-3.2373-5.2744-4.2283-6.3433-4.0835-7.0241,0.68552-3.2237,4.8954,3.9012,10.751,5.0421,23.836,4.6444l6.393-0.19431-3.7088-3.6663c-5.1869-5.1273-3.5906-5.587,2.1375-0.61554,5.3722,4.6626,5.0358,4.991-6.2715,6.1196-4.8048,0.47958-9.9719,0.1317-14.267-0.96048-6.4256-1.6342-6.675-1.6093-5.4578,0.54471,0.70158,1.2414,1.8378,2.2571,2.5248,2.2571,0.68721,0,1.2495,0.62908,1.2495,1.3979,0,2.3644-13.879,0.28524-20.511-3.0727-15.151-7.6712-17.058-8.3355-20.664-7.1991-2.0067,0.63235-4.0153,2.4833-4.7074,4.3381-2.3091,6.1873,6.4658,10.997,10.085,5.5273,1.049-1.5853,0.804-2.6696-1.0397-4.5988-2.5248-2.6423-2.288-3.0188,1.1205-1.7801,2.4199,0.87945,2.7455,6.6892,0.49439,8.8212-2.5757,2.4393-8.4536,1.7488-10.674-1.254z'/%3E %3Cpath fill='%23000' d='m773.19,166.07c-1.8946-1.7944-0.40932-2.2338,8.0847-2.3922,10.508-0.19593,16.89-1.947,24.42-6.7006,6.0333-3.8088,7.669-3.0593,1.9424,0.88996-5.2242,3.6027-13.372,6.3723-21.239,7.2191-3.8093,0.41006-8.1505,0.9781-9.6473,1.2623-1.4967,0.28421-3.0991,0.15887-3.561-0.27852z'/%3E %3C/g%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 209 110'%3E %3Crect fill='%23bf0a30' width='209' height='110'/%3E %3Cpath d='M0,15H209 M0,35H209 M0,55H209 M0,75H209 M0,95H209' stroke='%23fff' stroke-width='10'/%3E %3Crect fill='%23002868' width='50' height='50'/%3E %3Cg transform='translate(25,25) scale(15)'%3E %3Cg id='B'%3E %3Cpolygon id='A' fill='%23fff' points='0,0 0,1 .5,1' transform='translate(0,-1) rotate(18)'/%3E %3Cuse xlink:href='%23A' transform='scale(-1,1)'/%3E %3C/g%3E %3Cuse xlink:href='%23B' transform='rotate(72)'/%3E %3Cuse xlink:href='%23B' transform='rotate(-72)'/%3E %3Cuse xlink:href='%23B' transform='rotate(144)'/%3E %3Cuse xlink:href='%23B' transform='rotate(-144)'/%3E %3C/g%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 450 300'%3E %3Crect width='450' height='300' fill='%23009543'/%3E %3Crect width='450' height='210' fill='%23fff'/%3E %3Crect width='450' height='90' fill='%2300209f'/%3E %3Cg fill='%23fff'%3E %3Cpath fill='%23000' stroke='%23000' d='m224.76,95.569c-1.7098,0.03684-3.3781,1.9308-3.3781,1.9308l0.14732,20.233-6.3878,6.692h5.1711l-0.0437,11.603-30.591,41.193-4.5222-1.563-7.9041,16.861s19.55,12.242,47.925,11.907c31.144-0.37035,48.064-12.471,48.064-12.471l-8.1677-16.644-3.9996,1.7393-30.983-40.979-0.0437-11.949h5.1711l-7.0378-6.6088,0.0416-20.159s-1.7514-1.8203-3.4613-1.7835z'/%3E %3Cpath fill='none' stroke='%23000' stroke-width='5' d='m235.43,144.01-21.153,0s-7.6776-16.176-6.4331-27.485c1.2672-11.515,7.8483-16.963,16.598-17.059,10.345-0.11526,15.767,5.0691,17.405,16.598,1.6231,11.424-6.4172,27.947-6.4172,27.947z'/%3E %3Cpath d='m187.79,182.57c-0.3458,0.46106-2.8816,5.5326-2.8816,5.5326l4.38-0.92211-1.4984-4.6105z'/%3E %3Cpath d='m190.32,189.14-4.6105,1.4984,5.5327,2.19-0.92212-3.6884z'/%3E %3Cpath d='m192.4,182.68,2.3053,6.8006,5.6479-1.6137-1.4984-3.2274-6.4548-1.9595z'/%3E %3Cpath d='m195.97,191.91,0.80685,2.7663,7.4921,1.8442-2.9968-6.3395-5.3021,1.729z'/%3E %3Cpath d='m204.27,186.14,2.6511,6.3395,5.6479-2.19-1.8442-2.7663-6.4548-1.3832z'/%3E %3Cpath d='m207.96,194.79,0.92211,2.4205,8.76,1.2679-3.6884-5.7632-5.9937,2.0747z'/%3E %3Cpath d='m216.37,187.99,3.2274,5.6479,8.1837-2.9969-0.9221-2.19-10.489-0.46106z'/%3E %3Cpath d='m221.1,195.71,1.729,2.9969,10.143-0.3458-3.8037-5.6479-8.0684,2.9968z'/%3E %3Cpath d='m231.82,188.22,2.7663,4.7258,6.4548-3.1121-1.729-2.5358-7.4921,0.92212z'/%3E %3Cpath d='m242.42,191.79-6.4548,3.2274,1.729,2.7663,8.6448-1.3832-3.919-4.6106z'/%3E %3Cpath d='m244.5,186.83,3.3426,4.1495,5.4174-4.2648-1.8442-1.9595-6.9158,2.0748z'/%3E %3Cpath d='m254.41,189.02-5.1869,3.919,1.3832,2.4205,7.1464-1.8442-3.3426-4.4953z'/%3E %3Cpath d='m261.56,180.84,1.2679,1.8442-3.5732,5.3021-3.6884-4.7258,5.9937-2.4205z'/%3E %3Cpath d='m263.98,185.45,2.19,4.38-4.38,1.4984-0.34579-2.0748,2.5358-3.8037z'/%3E %3C/g%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 5 3'%3E %3Crect fill='%23C1272D' width='5' height='3'/%3E %3Crect fill='%23006A44' width='5' height='2'/%3E %3Crect fill='%23FDB913' width='5' height='1'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1000 600'%3E %3Crect width='1000' height='300' y='300' fill='%2300A1DE '/%3E %3Crect width='1000' height='300' fill='%23ed2939'/%3E %3Crect width='1000' height='200' y='200' fill='%23fff'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1200 600'%3E %3Cpath fill='%239E3039' d='m0,0h1200v600H0'/%3E %3Cpath fill='%23FFF' d='m0,240h1200v120H0'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 960 480'%3E %3Crect width='960' height='480' fill='%23239e46'/%3E %3Crect width='960' height='360' fill='%23000'/%3E %3Crect width='960' height='120' fill='%23e70013'/%3E %3Ccircle cx='480' cy='240' r='60' fill='%23fff'/%3E %3Ccircle cx='492.132034' cy='240' r='52.132034' fill='%23000'/%3E %3Cpath d='M509.175411,240 589.875233,213.779039 540,282.426407V197.573593L589.875233,266.220961z' fill='%23fff'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns:dc='http://purl.org/dc/elements/1.1/' xmlns:cc='http://creativecommons.org/ns%23' xmlns:rdf='http://www.w3.org/1999/02/22-rdf-syntax-ns%23' xmlns:svg='http://www.w3.org/2000/svg' xmlns='http://www.w3.org/2000/svg' xmlns:sodipodi='http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd' xmlns:inkscape='http://www.inkscape.org/namespaces/inkscape' viewBox='0 0 900 600'%3E %3Cdefs id='defs10'/%3E %3Csodipodi:namedview pagecolor='%23ffffff' bordercolor='%23666666' borderopacity='1' objecttolerance='10' gridtolerance='10' guidetolerance='10' inkscape:pageopacity='0' inkscape:pageshadow='2' inkscape:window-width='1920' inkscape:window-height='1057' id='namedview8' showgrid='false' fit-margin-top='0' fit-margin-left='0' fit-margin-right='0' fit-margin-bottom='0' inkscape:zoom='0.63555556' inkscape:cx='455.8698' inkscape:cy='278.86414' inkscape:window-x='-8' inkscape:window-y='-8' inkscape:window-maximized='1' inkscape:current-layer='svg2'/%3E %3Crect width='900' height='600' id='rect4' x='-900' y='0' transform='scale(-1,1)' style='fill:%23c1272d;fill-opacity:1;stroke:none'/%3E %3Cpath d='m 449.99991,224.31497 -44.4674,136.87006 116.40181,-84.55895 H 378.06451 l 116.4028,84.55895 z' id='path6' inkscape:connector-curvature='0' style='fill:none;stroke:%23006233;stroke-width:14.62993431;stroke-miterlimit:4;stroke-dasharray:none'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 750 600'%3E %3Crect fill='%23FFF' width='750' height='600'/%3E %3Crect fill='%23CE1126' width='750' height='300'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 1800 900'%3E %3Crect width='1800' height='900' fill='%23cc092f'/%3E %3Crect width='1200' height='900' fill='%23ffd200'/%3E %3Crect width='600' height='900' fill='%230046ae'/%3E %3Cg%3E %3Cg%3E %3Cpath fill='%23000' d='m847.69 183.24c-3.223 0-6.038 0.822-7.68 2.1 2.609 0.76 4.506 3.166 4.506 6.092v7.423h-7.422c-2.907 0-5.315-1.87-6.093-4.454-1.278 1.642-2.099 4.457-2.099 7.679 0 3.223 0.821 6.039 2.099 7.679 0.761-2.61 3.166-4.506 6.093-4.506h7.422v35.681c0 2.805-1.754 5.132-4.198 5.989 3.541 0.482 6.588 5.234 7.423 7.833 0.837-2.593 3.884-7.351 7.424-7.833-2.47-0.842-4.251-3.166-4.251-5.989v-35.683h7.424c2.908 0 5.315 1.87 6.093 4.456 1.277-1.642 2.098-4.459 2.098-7.68 0-3.223-0.82-6.038-2.098-7.679-0.761 2.609-3.167 4.504-6.093 4.504h-7.424v-7.422c0-2.908 1.869-5.315 4.455-6.093-1.64-1.276-4.457-2.098-7.679-2.098z'/%3E %3Cpath fill='%23f5d402' d='m847.69 184.78c-1.678 0-3.156 0.314-4.402 0.716 1.664 1.447 2.765 3.544 2.765 5.939v7.423c0 0.106-0.031 0.207-0.052 0.308v1.177h-1.178c-0.1 0.021-0.202 0.051-0.307 0.052h-7.424c-2.367 0-4.439-1.083-5.886-2.713-0.416 1.259-0.768 2.697-0.768 4.403 0 1.678 0.314 3.156 0.716 4.402 1.447-1.664 3.543-2.763 5.938-2.763h8.959c-0.01 0.154-0.052 0.303-0.052 0.459v0.768c0.021 0.1 0.051 0.201 0.052 0.307v35.681c0 2.317-1.195 4.139-2.765 5.58 1.123 0.693 2.09 1.565 2.918 2.561 0.737 0.885 1.03 1.751 1.536 2.661 0.507-0.908 0.799-1.776 1.536-2.661 0.815-0.978 1.768-1.82 2.867-2.509-1.584-1.437-2.765-3.305-2.765-5.631v-37.168h1.229c0.1-0.02 0.201-0.05 0.307-0.05h7.423c2.366 0 4.438 1.083 5.886 2.712 0.415-1.258 0.769-2.695 0.769-4.402 0-1.677-0.315-3.156-0.717-4.402-1.447 1.664-3.543 2.763-5.938 2.763h-7.423c-0.105 0-0.207-0.031-0.307-0.052h-1.178v-1.177c-0.021-0.099-0.051-0.201-0.052-0.308v-7.422c0-2.367 1.084-4.438 2.713-5.887-1.259-0.414-2.696-0.768-4.402-0.768'/%3E %3Cpath fill='%23000' d='m940.609,313.987c-4.535-3.221-8.258-6.862-10.904-11.11-6.372-10.223-9.061-22.773-9.061-35.527,0-5.391,6.04-11.46,6.04-15.82,0-6.59-0.614-10.544-0.614-10.544,2.143,0.292,5.887,4.095,5.887,4.095s-0.129-10.938-3.585-12.849c0,0,1.398-1.438,6.451-1.587-1.42-3.596-8.446-7.986-8.446-7.986,0.351-0.629,1-1.173,1.842-1.638,1.765-0.976,4.245-1.62,6.142-1.997-2.022-0.419-4.352-1.061-6.91-1.895-5.842-1.903-12.719-4.697-19.146-7.78-11.732-5.628-20.669-5.99-25.596-5.9895-3.575,0.0005-8.84,0.0985-11.927,2.1515-2.825,1.875-2.595,4.314-3.584,5.17-2.33,2.016-6.321,1.945-8.243,1.945-12.44,0-12.901,13.311-12.901,13.311s3.181-4.813,8.805-4.813c9.351,0,16.433,5.094,16.433,7.013,0,0.777-0.964,0.921-1.023,0.921-6.108,0-15.326-3.516-20.223-3.686v2.406c10.931,3.803,22.013,9.187,22.013,32.917,0,14.943-1.789,30.19-9.265,42.183-2.648,4.247-6.418,7.881-10.955,11.11l44.385,7.9995z'/%3E %3Cg id='eagle_half'%3E %3Cpath fill='%23000' d='m896.222,303.988-44.383,10.0005c-2.019-0.61-11.513-3.56-18.174-7.269-11.726-6.532-17.806-13.031-31.74-13.669v-10.598c0-5.662,2.049-10.763,2.049-16.177-5.874-1.575-22.178-21.51-37.218-30.358-22.13,14.334-39.265,37.865-39.265,48.686,0,0,0.665,232.51,0,313.51,0,4.668-2.815,11.263-2.815,11.263,8.079-3.418,22.888-23.68,26.006-31.382v3.687c12.201-5.564,21.135-20.184,25.136-27.747,0.071,1.093,0.257,3.838,0.257,3.838,10.9-9.555,24.776-66.038,24.776-66.038l23.124,22.7255s-8.363,16.9755-11.621,20.0155c0,0,2.184,0.277,4.658,0.256-1.522,2.188-13.147,18.925-16.791,25.238-3.41,5.906-5.816,3.277-11.058,3.277-4.347,0-14.2,6.925-15.818,9.727-1.701,2.945-2.968,6.523-2.968,9.471,0,3.24,3.43,7.679,3.43,7.679,0.369-1.551,1.023-2.099,1.023-2.099s9.013,11.228,10.341,12.695c1.034,1.143,5.645,1.886,7.27,0.411,4.066-3.697,8.002-6.282,11.621-11.621,1.863-2.751,2.005-5.904,4.146-8.858,7.162-9.88,21.415-28.799,24.675-33.121,0.218,1.203,0.405,2.205,0.612,3.43,3.694-7.457,21.451-21.706,21.451-21.706l18.578,8.55s-34.687,79.735-65.476,91.995c0,0,13.395,5.691,29.845,14.232,2.4,1.246,4.871,2.584,7.372,3.943,2.071-2.494,4.251-5.265,6.399-8.141,9.836-13.16,19.455-28.412,19.455-28.412,0.67,3.961-4.524,16.194-13.31,31.281-1.728,2.964-3.53,6.064-5.529,9.213,2.229,1.273,4.441,2.559,6.655,3.892,16.295,9.805,31.598,21.077,37.267,31.432l4,-10.009 -4,-10.009v-349.957l2,-5z'/%3E %3Cg fill='%23b07f55'%3E %3Cpath d='m896.202,667.221c-5.749-6.236-17.769-13.855-31.278-20.886,16.334-29.316,24.428-75.655,20.63-84.88,0,0-6.705,24.033-14.898,37.729-7.586,12.684-16.925,26.95-25.954,37.526-7.428-3.169-14.631-5.828-20.785-7.68,27.058-20.843,54.726-89.742,54.726-89.742l-28.612-13.26s-10.704,12.479-14.18,14.796c0,0-1.485-6.206-2.355-8.396,0,0-4.101,3.102-6.346,3.176,0,0-0.671-4.212-1.178-6.964-2.825,1.883-7.525,1.485-7.525,1.485,4.127-1.954,9.01-13.925,9.01-13.925l-27.322-36.343s-9.597,46.116-20.528,55.596v-198.58l8.652,8.036,13.105-12.235v-9.317l-11.621,10.852v-28.105c1.751-2.649,2.912-4.626,3.788-6.194,1.881,3.279,7.96,13.329,15.101,19.505,1.175-4.778,8.908-9.318,8.908-9.318s2.771,7.508,7.012,9.368c1.492-2.628,10.394-8.446,10.394-8.446s-7.616,1.157-10.7,4.045c-2.649-0.593-3.328-11.058-3.328-11.058s-11.207,5.459-13.156,9.368c-2.137-0.578-5.464-8.988-6.759-12.44,1.955-0.213,4.716-0.46,8.345-0.46,3.196,0,7.285,1.514,11.569,3.532,4.707,2.216,9.631,5.022,14.028,7.014,5.632,2.55,14.153,3.068,16.637,3.174-2.845,2-5.973,3.826-9.367,5.529,0,0,13.411-0.124,22.832-4.813,3.361-2.162,6.849-4.316,9.829-6.86-1.293,3.593-3.306,7.839-6.452,11.467,13.836-1.171,20.726-9.072,22.679-11.723,0.918,2.375,2.553,6.187,5.119,9.47h5v340z'/%3E %3Cpath d='m794.247,267.298,0.255,6.348,0,18.687c-5.019-1.727-11.326-9.973-14.384-14.334v-2.56c0-2.408,1.417-4.167,2.457-5.119l-3.02-1.074c-1.152,1.313-2.406,3.263-2.406,5.784v1.485l-9.009,9.676-8.856-13.413v-3.276c0-2.208,1.698-4.67,3.123-6.348l-2.97-1.075c-1.499,1.942-3.072,4.559-3.072,7.013v2.661c-2.083,2.156-10.187,10.496-10.187,10.496s-4.066-8.737-5.17-11.109c6.205-8.595,16.266-18.219,25.7488-25.1245,0,0,20.5642,18.8805,27.4902,21.2825z'/%3E %3Cpath d='m742.127,285.421,0,15.411-7.167,6.654,0-22.883c0-2.191,0.918-4.831,2.4565-7.731z'/%3E %3Cpath d='m764.447,291.359,0,9.522-8.241,7.731,0-29.794z'/%3E %3Cpath d='m753.286,308.561-8.243-7.679,0-11.159,8.243-8.652z'/%3E %3Cpath d='m790.913,296.991c-1.914,2.705-6.927,9.321-12.337,12.236v-26.1605c1.241,2.0645,6.934,11.2745,12.337,13.9245z'/%3E %3Cpath d='m775.656,284.397,0,24.163-8.243-7.679,0-8.549z'/%3E %3Cpath d='m742.126,310.147,0,24.113-7.167-6.707,0-10.7z'/%3E %3Cpath d='m753.28,317.878,0,8.651-8.244,7.678,0-24.0085z'/%3E %3Cpath d='m764.438,310.2,0,24.01-8.241-7.731,0-8.549z'/%3E %3Cpath d='m775.651,317.93,0,8.549-8.243,7.73,0-24.0095z'/%3E %3Cpath d='m786.81,334.26-8.244-7.731,0-8.036c2.843-1.735,5.702-4.924,8.2435-8.2935z'/%3E %3Cpath d='m765.925,344.908,8.703-8.089,0,198.63s0.607,9.856,1.024,16.279c-3.87,3.912-18.429,18.634-18.429,18.634v-233.596z'/%3E %3Cpath d='m752.253,562.94c0,6.385-11.659,21.273-17.303,24.675v-250.74l8.6,8.036,8.703-8.0895z'/%3E %3C/g%3E %3Cg fill='%23d10429'%3E %3Cpath d='m824.535,541.388,6.348-4.352s0.423,2.1,0.972,4.967c-2.718,3.716-18.331,25.024-26.057,35.425-1.921,2.584-3.534,9.163-3.534,9.163s-2.814-1.331-2.814-3.736c0-2.362,0.308-5.171,0.308-5.171s-2.101,2.406-5.735,2.406c0-2.903,5.614-6.052,5.836-10.186-4.281,3.174-7.999,1.545-12.951,3.072-5.393,1.661-6.895,3.927-8.549,3.84-0.974-0.053-1.856-1.733-1.484-2.765,0.644-1.787,7.314-6.733,11.977-7.627,1.117-0.214,9.903,1.912,11.673-0.819,7.292-11.252,19.13-29.518,20.272-31.278,0.752-0.18,1.444-0.371,1.9955-0.719,0,0-0.0675,5.751,1.7425,7.78z'/%3E %3Cpath d='m783.72,576.452c0.353,0.408,0.322,1.006-0.053,1.33l-2.866,2.508c-0.375,0.324-0.977,0.255-1.33-0.154-0.354-0.408-0.324-1.006,0.052-1.331l2.866-2.508c0.187-0.163,0.428-0.233,0.6655-0.204,0.2375,0.027,0.4875,0.154,0.6655,0.359z'/%3E %3Cpath d='m788.071,579.472c0.857,0.988,0.802,2.388-0.103,3.175l-6.962,6.091c-0.906,0.788-2.367,0.63-3.226-0.357-0.857-0.988-0.803-2.439,0.103-3.225l6.962-6.041c0.339-0.296,0.802-0.477,1.229-0.5125,0.712-0.0585,1.46,0.2535,1.997,0.8695z'/%3E %3Cpath d='m792.061,584.182c0.857,0.988,0.803,2.387-0.103,3.174l-7.012,6.092c-0.906,0.787-2.316,0.63-3.175-0.358-0.858-0.987-0.803-2.438,0.104-3.224l6.961-6.041c0.339-0.295,0.75-0.476,1.178-0.5125,0.711-0.0585,1.51,0.2515,2.047,0.8695z'/%3E %3Cpath d='m794.464,587.919c0.713-0.058,1.461,0.201,1.997,0.819,0.858,0.988,0.803,2.439-0.102,3.225l-6.963,6.042c-0.906,0.787-2.316,0.629-3.174-0.359s-0.854-2.388,0.051-3.175l7.014-6.091c0.338-0.296,0.749-0.427,1.177-0.461z'/%3E %3C/g%3E %3C/g%3E %3Cuse xlink:href='%23eagle_half' transform='matrix(-1,0,0,1,1792.404,0)'/%3E %3Cpath fill='%23b07f55' d='m885.934,206.637c11.458,0,19.517,5.224,30.359,10.033,2.841,1.26,5.45,2.281,7.779,3.071-1.459,1.293-2.594,2.592-2.918,3.687,0,0,4.859,0.9,7.064,4.967,0,0-4.62,0.524-5.375,3.224,2.588,0.195,5.159,3.457,5.171,6.605l-6.553-2.049s1.587,7.358,1.587,15.358c0,4.086-5.886,8.894-5.886,15.819,0,21.734,5.475,30.088,9.369,36.807,1.523,2.629,2.761,5.654,5.324,7.935-11.218-5.973-19.556-13.439-19.556-20.374v-26.262h-2.918v26.262c0,5.029,1.228,7.372,1.228,7.372,1.761,5.564,5.321,14.152,7.526,17.61-10.321-5.578-15.564-12.563-15.564-15.153v-36.092h-2.918v36.603l0.563,2.508c-1.251,1.88-2.877,4.106-3.993,4.863-1.113-0.756-2.69-2.986-3.943-4.863l0.564-2.508v-36.603h-2.918v36.092c0,2.589-5.243,9.575-15.563,15.153,2.205-3.459,5.764-12.046,7.524-17.61,0,0,1.229-2.342,1.229-7.372v-26.262h-2.918v26.262c0,6.927-8.307,14.405-19.505,20.374,2.537-2.283,3.757-5.321,5.272-7.935,4.258-7.348,9.522-16.683,9.522-43.258,0-9.974-1.475-16.755-4.044-21.501-0.781-1.566-1.833-5.734,4.146-5.734,3.097,0,10.188,5.478,10.188,5.478s-0.292-4.371-3.891-6.86c-0.597-0.413-1.586-1.712-1.586-2.919,0-0.904,1.551-3.135,2.763-3.686,0.833-0.378-12.183-2.646-12.183-8.549,0-1.229,0.773-2.048,3.479-2.048,3.545,0,9.312,4.249,14.438,4.249,3.789,0,5.283-0.922,9.163-0.922,4.742,0,14.635,8.979,18.019,8.651-3.783-2.375-9.894-11.365-19.145-11.365-3.211,0-6.117,0.717-9.114,0.717-3.841,0-7.623-3.533-11.774-3.533-2.782,0-5.889,0.155-6.349-0.564-0.805-1.255-0.08-1.983,0.666-3.02,1.409-1.957,5.366-2.525,9.267-2.661,1.17-0.041,2.338-0.061,3.4325-0.0505,1.0905,0.0115,2.0995,0.0535,2.9715,0.0535z'/%3E %3Cpath fill='%23cc092f' d='m848.73 220.69s2.419-4.581 8.534-4.581c2.556 0 10.992-0.177 10.992-0.177 1.124 2.921 6.249 7.802 6.249 12.878 0 0-5.202-9.377-19.723-9.377-3.649 0-6.054 1.256-6.054 1.256z'/%3E %3Cpath fill='%23d10429' d='m872.34 230.6s-3.093 3.258-3.765 4.997c-3.061-1.16-8.399-6.661-8.399-6.661s4.525 2.642 12.163 1.664z'/%3E %3Cpath fill='%23000' d='m867.44 221.97s-3.568-1.144-3.568-2.342c0-1.526 1.733-1.526 2.769-0.337 0.713 0.819 0.798 2.68 0.798 2.68z'/%3E %3Cellipse fill='%23000' cx='882.798' cy='222.06' rx='5.112' ry='4.043'/%3E %3Ccircle fill='%23f5d402' cx='882.8' cy='222.06' r='3.56'/%3E %3Ccircle fill='%23000' cx='882.799' cy='222.06' r='1.511'/%3E %3C/g%3E %3Cg%3E %3Cg fill='%23000'%3E %3Crect width='20.503' height='20.503' x='1052.3' y='157.29' transform='matrix(0.7902,0.4311,-0.1917,0.8793,0,0)'/%3E %3Cpath d='m725.9 418.73-5.836 2.663 65.936 144.42h7.014zm77.762 170.32-4.76 4.915 2.969 6.553 5.784-2.662z'/%3E %3Cpath d='m746.39 532.6s5.554 11.472 9.775 13.045c-2.183-0.595-9.271 2.006-9.271 2.006s12.499 11.165 23.1 11.898c8.99 0.619 13.355-3.868 13.355-3.868l-1.801-9.524s-5.5-6.642-14.302-9.707c-8.894-3.098-20.857-3.848-20.857-3.848z'/%3E %3Cpath d='m788.26 512.05s-7.669 6.565-9.768 14.169c-2.1 7.605 1.368 16.247 1.368 16.247l6.444 12.021s8.931-4.753 12.73-11.86c3.799-7.108 2.406-16.698 2.406-16.698s-7.075 2.634-7.975 3.8c1.493-7.884-5.206-17.679-5.206-17.679z'/%3E %3Cpath d='m763.61 508.98s-8.722 2.948-17.192 2.438c-8.068-0.487-14.777-7.262-14.777-7.262s6.688-4.526 9.989-3.923c-3.631-1.327-8.896-10.423-8.896-10.423s7.482-2.261 14.116 0.24c6.634 2.503 12.419 9.77 12.419 9.77l4.342 9.16z'/%3E %3Cpath d='m766.61 466.38s4.362 9.032 3.328 12.171c1.353-2.09 6.474-5.345 6.474-5.345s3.096 14.624 0.135 23.656c-2.96 9.031-11.974 12.47-11.974 12.47l-9.943-19.337s-1.48-7.164 1.62-12.837c3.101-5.673 10.36-10.779 10.36-10.779z'/%3E %3Cpath d='m709.86 442.47s9.427-0.99 18.051 2.583c7.21 2.993 9.42 8.433 9.42 8.433l3.551 9.52s-10.261 3.848-18.368 0.906c-8.108-2.945-14.065-12.68-14.065-12.68s5.666-2.149 7.823-1.343c-3.142-1.39-6.41-7.419-6.41-7.419v0.001z'/%3E %3Cpath d='m739.51 424.8s4.137 5.313 4.261 11.424c1.103-3.249 6.268-6.84 6.268-6.84s5.312 12.855 4.146 21.982c-1.166 9.128-8.809 14.527-8.809 14.527l-9.531-18.092s-3.106-7.415-2.191-13.167c0.916-5.75 5.856-9.836 5.856-9.836z'/%3E %3Cpath d='m706.86 390.2s-1.709 9.854 1.199 15.53c2.598 5.065 4.252 6.176 4.252 6.176-4.954-3.269-12.444-3.551-12.444-3.551s2.666 10.721 9.037 15.612 16.195 3.748 16.195 3.748 6.46-8.6 6.01-17.865c-0.449-9.265-7.808-19.197-7.808-19.197s-2.902 6.02-3.158 10.514c-1.878-4.633-13.285-10.966-13.285-10.966z'/%3E %3Cpath d='m783.86 555.27 0.265 3.537c5.875 0.055 6.75-0.53 8.256 1.322 1.003 1.234 3.389 2.311 5.787 1.215 2.4-1.095 3.475-3.977 2.38-6.376s-3.326-2.92-5.475-2.496c-1.319 0.26-2.187 1.313-3.306 1.891-2.128 1.102-7.909 0.908-7.909 0.908z'/%3E %3Cpath d='m783.35 552.57 2.859 2.095c-3.067 5.014-4.024 5.446-3.251 7.705 0.515 1.504 0.166 4.097-2.035 5.553-2.2 1.455-5.214 0.841-6.669-1.358-1.454-2.2-0.715-4.366 0.783-5.965 0.92-0.982 2.27-1.16 3.353-1.803 2.062-1.223 4.959-6.228 4.959-6.228z'/%3E %3Cpath d='m763.45 510.57 0.264 3.537c5.876 0.054 6.75-0.53 8.256 1.321 1.002 1.233 3.389 2.311 5.787 1.215 2.401-1.095 3.476-3.976 2.379-6.375-1.095-2.4-3.325-2.92-5.474-2.496-1.32 0.261-2.187 1.313-3.305 1.891-2.129 1.101-7.909 0.908-7.909 0.908z'/%3E %3Cpath d='m764.64 511.82 2.5 2.517c-3.809 4.474-4.824 4.753-4.411 7.104 0.276 1.567-0.473 4.075-2.874 5.17-2.399 1.095-5.279 0.021-6.376-2.379-1.095-2.399-0.028-4.425 1.701-5.771 1.061-0.825 2.425-0.793 3.593-1.258 2.227-0.887 5.867-5.382 5.867-5.382z'/%3E %3Cpath d='m743.67 468.72 0.265 3.537c5.876 0.054 6.75-0.53 8.257 1.323 1.003 1.231 3.388 2.309 5.788 1.213 2.398-1.095 3.474-3.975 2.379-6.377-1.097-2.399-3.326-2.919-5.476-2.495-1.32 0.261-2.187 1.313-3.306 1.891-2.128 1.102-7.908 0.907-7.908 0.907z'/%3E %3Cpath d='m745.3 467.98 2.499 2.516c-3.809 4.475-4.822 4.754-4.411 7.105 0.276 1.566-0.473 4.074-2.873 5.169-2.399 1.094-5.28 0.02-6.376-2.379-1.094-2.4-0.027-4.426 1.701-5.771 1.061-0.827 2.424-0.793 3.594-1.26 2.227-0.887 5.866-5.38 5.866-5.38z'/%3E %3Cpath d='m722.6 424.54 0.264 3.536c5.876 0.055 6.751-0.53 8.256 1.321 1.004 1.234 3.39 2.311 5.788 1.217 2.4-1.097 3.475-3.977 2.38-6.377s-3.326-2.921-5.476-2.496c-1.318 0.261-2.186 1.314-3.305 1.891-2.128 1.101-7.909 0.908-7.909 0.908z'/%3E %3Cpath d='m724.23 423.8 2.498 2.517c-3.808 4.475-4.823 4.753-4.41 7.105 0.276 1.566-0.474 4.074-2.873 5.169-2.4 1.095-5.28 0.021-6.375-2.379-1.096-2.399-0.028-4.427 1.699-5.771 1.062-0.825 2.425-0.793 3.594-1.26 2.226-0.886 5.866-5.38 5.866-5.38z'/%3E %3C/g%3E %3Cg fill='%23f5d402'%3E %3Crect width='12.717' height='12.718' x='1056.2' y='161.19' transform='matrix(0.7902,0.4311,-0.1917,0.8793,0,0)'/%3E %3Cpath d='m759.72 500.09c-2.106 0.874-5.23-8.295-7.524-13.318-2.353-5.155-7.131-13.1-5.774-13.72 1.489-0.68 3.451 3.492 5.859 8.767 2.408 5.273 9.412 17.449 7.439 18.269z'/%3E %3Cpath d='m738.09 451.8c-2.105 0.877-4.41-5.127-6.703-10.151-2.353-5.154-4.645-8.795-3.288-9.415 1.49-0.68 3.69 3.837 5.616 8.055 1.866 4.088 6.348 10.69 4.374 11.512z'/%3E %3Cpath d='m788.13 561.29c-1.653 0.442-8.869-14.662-14.703-27.442-5.833-12.779-10.177-23.119-8.82-23.736 1.49-0.681 6.213 11.391 12.049 24.172 5.835 12.781 12.713 26.673 11.475 27.006z'/%3E %3C/g%3E %3Cg fill='%23097754'%3E %3Cpath d='m709.76 396.19s-0.255 7.201 2.127 11.285c2.383 4.086 7.704 5.715 7.704 5.715s0.254-7.199-2.128-11.283c-2.383-4.086-7.703-5.717-7.703-5.717z'/%3E %3Cpath d='m704.78 412.48s6.255 0.368 9.868 3.136c3.61 2.768 5.009 8.535 5.009 8.535s-4.146 0.421-7.756-2.347c-3.611-2.769-7.121-9.324-7.121-9.324z'/%3E %3Cpath d='m724.41 397.94s-2.08 4.77-1.84 9.912c0.239 5.143 3.24 10.937 3.24 10.937s2.713-6.174 2.474-11.318c-0.238-5.143-3.147-8.075-3.874-9.531z'/%3E %3Cpath d='m713.88 444.3s3.071 4.288 7.799 6.626c4.728 2.337 11.773 2.424 11.773 2.424s-3.516-4.562-8.245-6.9c-4.728-2.337-11.327-2.152-11.327-2.152z'/%3E %3Cpath d='m715.4 454.26s2.257 4.421 6.384 6.316c4.129 1.896 12.574 1.74 12.574 1.74s-3.24-4.131-7.368-6.027c-4.128-1.897-11.591-2.029-11.591-2.029z'/%3E %3Cpath d='m739.17 430.68s-2.495 4.123-2.251 8.666c0.245 4.545 3.227 9.511 3.227 9.511s2.097-5.693 1.852-10.237c-0.244-4.545-2.829-7.94-2.829-7.94z'/%3E %3Cpath d='m748.36 436.51s-4.269 5.73-4.882 11.621c-0.613 5.89 2.428 11.942 2.428 11.942s5.157-5.178 5.77-11.068c0.613-5.892-3.316-12.493-3.316-12.493z'/%3E %3Cpath d='m736.59 490.91s0.513 2.118 2.297 4.367c1.783 2.251 4.836 4.632 4.836 4.632s2.949-0.948 6.615-0.155c3.665 0.795 8.54 4.06 8.54 4.06s-5.247-7.831-10.695-10.876c-5.448-3.043-11.591-2.029-11.591-2.029z'/%3E %3Cpath d='m736.05 504.37s6.793-2.902 12.387-2.153c5.595 0.749 10.639 5.171 10.639 5.171s-7.561 2.616-13.155 1.868c-5.596-0.749-9.872-4.886-9.872-4.886z'/%3E %3Cpath d='m764.76 472.79s-6.007 6.364-6.511 11.887c-0.503 5.522 4.871 10.669 4.871 10.669s-0.264-3.542 0.661-5.874c0.926-2.332 2.893-4.822 2.893-4.822s0.838-2.843 0.514-5.123c-0.453-3.186-2.428-6.737-2.428-6.737z'/%3E %3Cpath d='m773.38 480.16s-5.662 5.729-7.158 11.864c-1.497 6.135 1.17 12.676 1.17 12.676s5.149-4.062 6.646-10.196c1.497-6.135-0.659-14.344-0.659-14.344z'/%3E %3Cpath d='m787.56 517.14s2.565 5.355 3.215 9.833c0.652 4.477 0.048 6.027 0.048 6.027s-2.652 2.607-3.841 4.14c-1.528 1.97-1.752 5.576-1.752 5.576s-5.325-7.916-4.504-13.703c0.82-5.786 6.834-11.874 6.834-11.874z'/%3E %3Cpath d='m798.78 529.53s-6.818 4.503-9.523 9.123c-2.708 4.617-1.304 9.349-1.304 9.349s4.858-0.428 7.566-5.046c2.706-4.618 3.26-13.427 3.26-13.427z'/%3E %3Cpath d='m753.98 548.55s9.826-0.268 15.832 1.209c6.006 1.475 8.192 4.695 8.192 4.695s-6.753 3.162-12.759 1.686c-6.006-1.475-11.266-7.591-11.266-7.591z'/%3E %3Cpath d='m752.32 536.89s4.433 6.873 10.164 9.367c7.898 3.435 17.043 1.77 17.043 1.77s-4.968-6.089-11.804-8.777c-6.838-2.687-15.403-2.359-15.403-2.359z'/%3E %3C/g%3E %3Cpath fill='%23000' d='m1088.74,401.944,1.281,2.712s-2.08,0.714-3.022,2.559c-0.94,1.847,0.615,4.455,0.615,4.455s-10.804-0.943-12.491,0.154c-1.528,0.99,0.647,8.474-0.359,14.795-1.402,8.81-4.875,8.07-5.017,9.777-0.138,1.659,1.331,4.249,1.331,4.249s-2.026,0.638-2.458,1.485c-0.695,1.362,0.484,3.875-0.358,5.528-4.7,9.223-11.64,22.836-16.228,31.843-0.641,1.257-2.363,1.737-3.226,3.43-0.796,1.562-0.153,3.839-0.153,3.839s-3.041,0.182-4.096,2.253c-1.121,2.2-0.461,5.17-0.461,5.17s-1.923,0.246-2.868,2.099c-1.009,1.981,0.7,3.02,0.259,3.891-6.169,12.102-13.434,26.368-17.867,35.068-1.631,3.199-7.338,3.84-10.65,10.341-3.214,6.306,1.382,10.955,1.382,10.955s-4.772,0.432-6.04,2.919c-1.292,2.535-0.27,6.384,3.174,8.139,3.444,1.754,7.207,0.334,8.5-2.201,1.267-2.487-1.281-6.604-1.281-6.604s6.463,0.931,9.675-5.376c3.313-6.501,0.52-11.441,2.15-14.641,4.434-8.7,11.7-22.965,17.867-35.068,0.445-0.871,2.267-0.117,3.276-2.098,0.944-1.853,0-3.532,0-3.532s2.822-1.23,3.943-3.431c1.056-2.071-0.563-4.658-0.563-4.658s2.223-0.792,3.02-2.354c0.862-1.693,0.228-3.35,0.869-4.609,4.59-9.006,11.531-22.62,16.229-31.841,0.843-1.655,3.555-2.221,4.249-3.585,0.432-0.846-0.255-2.866-0.255-2.866s2.988-0.296,4.248-1.383c1.298-1.118-1.337-3.516,4.967-9.829,4.522-4.528,11.817-7.192,11.722-9.01-0.105-2.01-7.218-10.187-7.218-10.187s3.001-0.253,3.942-2.098c0.941-1.846,0.308-3.994,0.308-3.994l2.968-0.512,0.0005-14.078zm-98.136,196.074c-0.448,0.877-0.53,2.076,0,3.121,0,0-3.583-1.12-4.812-0.512-1.158,0.573,0,17.458,0,17.458s14.295-9.018,14.077-10.29c-0.23-1.352-3.225-3.635-3.225-3.635,1.158-0.186,2.061-0.912,2.509-1.791,0.47-0.925,0.533-3.568-2.714-5.223-1.216-0.62-2.299-0.804-3.1745-0.716-1.4555,0.147-2.3655,1.01-2.6605,1.588z'/%3E %3Cg fill='%23f5d402'%3E %3Cpath d='m1091.34,402.51,6.757,3.431-0.101-8.1405z'/%3E %3Cpath d='m1088.73,407.425c-0.868,1.704-0.025,3.886,1.894,4.863,1.92,0.977,4.148,0.373,5.018-1.33,0.868-1.704,0.023-3.885-1.895-4.863-0.72-0.367-1.476-0.511-2.2015-0.4615-1.2075,0.0825-2.2725,0.7265-2.8155,1.7915z'/%3E %3Cpath d='m1077.11,413.62c-0.711,0.46,0.256,6.545,0.051,11.722-0.194,4.882-1.756,6.257-2.611,7.935-0.789,1.549-3.634,3.379-3.634,3.379l2.354,2.355s1.532-2.386,3.942-7.118c2.843-5.579,2.751-15.688,3.585-16.227,0.725-0.469,6.655-1.946,6.655-1.946-0.001,0-5.442-0.294-8.447-0.2545-1.003,0.0125-1.73,0.0475-1.895,0.1545z'/%3E %3Cpath d='m1077.73,441.725s0.787-2.188,3.533-7.577c3.311-6.499,10.379-11.213,10.544-12.389,0.172-1.212-2.4565-6.9105-2.4565-6.9105s-6.2355,1.1955-7.1175,2.0485c-0.852,0.823-0.476,9.267-3.788,15.767-2.744,5.388-4.094,7.372-4.094,7.372z'/%3E %3Cpath d='m1093.65,422.22c0.052,0.989-8.163,6.861-11.007,12.439-2.41,4.731-3.43,7.373-3.43,7.373l3.277,0.512s-0.226-3.367,0.563-4.915c0.854-1.677,1.079-3.731,4.915-6.757,4.068-3.209,9.567-6.014,9.522-6.861-0.041-0.782-6.1435-8.344-6.1435-8.344s2.2565,5.692,2.3035,6.553z'/%3E %3Cpath d='m1069.59,458.72c4.936-9.688,6.444-10.348,7.065-11.569,0.669-1.312,0.509-3.078-1.689-4.199-0.824-0.419-1.531-0.526-2.1495-0.459-1.0335,0.111-1.7845,0.767-2.2015,1.586-0.622,1.222-0.285,2.855-5.223,12.544l-11.212,21.961s-1.175,2.156,1.024,3.276c2.199,1.119,3.174-1.127,3.174-1.127z'/%3E %3Cpath d='m1049.78,483.908c-0.611,1.201,0.436,2.964,2.355,3.943,1.919,0.976,3.996,0.791,4.607-0.41,0.611-1.2-0.486-2.964-2.406-3.943-0.959-0.489-1.935-0.687-2.7645-0.613-0.8295,0.072-1.4855,0.424-1.7915,1.023z'/%3E %3Cpath d='m1045.63,490.153c-0.792,1.553,0.443,3.783,2.765,4.968,2.322,1.183,4.84,0.886,5.631-0.667,0.792-1.554-0.444-3.782-2.765-4.967-0.871-0.442-1.733-0.677-2.5595-0.716-1.3745-0.065-2.5765,0.411-3.0715,1.382z'/%3E %3Cpath d='m1043.02,497.117c-0.611,1.199,0.437,2.963,2.355,3.941,1.919,0.978,3.995,0.791,4.608-0.409,0.611-1.2-0.437-2.964-2.355-3.942-0.96-0.49-1.986-0.688-2.8155-0.615-0.8285,0.073-1.4855,0.424-1.7925,1.025z'/%3E %3Cpath d='m1041.33,503.772s-12.448,24.5-16.84,33.121c-1.404,2.754-7.312,4.47-9.625,9.011-2.33,4.568-0.686,8.844,2.354,10.392,3.039,1.549,7.502,0.423,9.83-4.146,2.313-4.54,0.235-10.353,1.637-13.106,4.393-8.624,16.843-33.122,16.843-33.122s1.226-2.156-0.973-3.276c-0.55-0.28-1.028-0.308-1.433-0.2555-1.212,0.1555-1.793,1.3815-1.793,1.3815z'/%3E %3Cpath d='m1009.84,560.646c-0.933,1.83,0.134,4.269,2.405,5.426,2.272,1.158,4.904,0.601,5.837-1.228,0.933-1.83-0.186-4.27-2.457-5.427-0.852-0.435-1.721-0.637-2.56-0.6135-1.399,0.0395-2.643,0.6995-3.225,1.8425z'/%3E %3Cpath d='m993.257,598.069c-0.71,0.024-1.298,0.249-1.535,0.717-0.477,0.935,0.508,2.413,2.201,3.276,1.693,0.862,3.464,0.782,3.942-0.154,0.477-0.937-0.51-2.414-2.201-3.276-0.847-0.432-1.695-0.588-2.407-0.564z'/%3E %3Cpath d='m987.421,602.675v12.082l9.83-7.065s-1.333-2.354-4.25-3.84c-2.917-1.485-5.58-1.178-5.58-1.178z'/%3E %3C/g%3E %3C/g%3E %3Cg%3E %3Cpath fill='%23f5d402' d='m993.643,333.597c0-6.626,8.703-13.157,8.703-13.157h-212.246s8.703,6.53,8.703,13.157v157.986c0,4.162,1.286,6.872,3.328,9.521,2.041,2.853,6.39,6.795,10.903,9.727,13.94,9.053,37.246,18.599,54.88,26.621,14.694,6.684,20.671,9.381,28.309,18.839,7.639-9.458,13.667-12.154,28.361-18.839,17.631-8.021,40.938-17.568,54.879-26.621,4.515-2.932,8.864-6.873,10.904-9.727,2.042-2.649,3.276-5.359,3.276-9.521z'/%3E %3Cpath fill='%23d10429' d='m803.82,422.981,0-89.385c0-5.059-2.5605-8.139-2.5605-8.139h189.928s-2.56,3.081-2.56,8.139l0.054,89.385-92.4305,28z'/%3E %3Cpath fill='%230b45bb' d='m988.681,422.981-57.234-1.075-70.393,0-57.234,1.075,0,68.601c0,3.448,3.578,11.525,24.215,21.807,34.111,16.998,60.33,24.934,68.189,34.607,7.858-9.673,34.077-17.61,68.189-34.607,20.636-10.282,24.214-18.359,24.214-21.807z'/%3E %3Cg fill='%23000'%3E %3Cpath d='m930.063,419.401s33.019-8.326,33.019-43.617c0-27.563-33.103-41.237-34.044-47.814-3.235,11.381,11.058,27.1,11.058,45.715,0,24.086-17.764,25.239-17.764,25.239-4.157,0-5.841,2.968-7.475,2.968-3.497-0.365-5.143-4.813-8.601-4.813-3.247,0-5.74,5.017-10.033,5.017-4.292,0-6.735-5.017-9.983-5.017-3.456,0-5.103,4.448-8.6,4.813-1.634,0-3.319-2.968-7.476-2.968,0,0-17.763-1.153-17.763-25.239,0-18.615,14.295-34.336,11.058-45.715-0.938,6.577-34.041,20.25-34.041,47.814,0,35.291,33.019,43.617,33.019,43.617l-9.42,17.149s13.645,0.683,20.887,6.861c8.733,7.448,7.883,23.229,7.883,34.709,0,9.045-1.143,18.59-5.784,22.524-6.232,5.284-10.445,5.675-10.445,11.878,0,5.174,3.977,6.211,10.445,9.625,8.287,4.373,7.901,10.238,20.22,10.238,12.321,0,11.985-5.864,20.273-10.238,6.468-3.414,10.444-4.451,10.444-9.625,0-6.203-4.214-6.594-10.444-11.878-4.641-3.936-5.784-13.48-5.784-22.524,0-11.48-0.849-27.261,7.883-34.709,7.243-6.177,20.886-6.861,20.887-6.861z'/%3E %3Cpath d='m896.22,330.42-5.735,16.281-15.614-7.424,7.423,15.615-16.279,5.784,16.279,5.785-7.423,15.563,15.614-7.423,5.735,16.279,5.785-16.279,15.614,7.423-7.422-15.563,16.279-5.785-16.279-5.784,7.422-15.615-15.614,7.424-5.785-16.281z'/%3E %3Cpath d='m861.05,421.91s-20.387-4.984-28.002-15.051c-13.313,11.976-29.232,16.126-29.232,16.126s16.607,7.498,29.232,17.048c5.817-8.336,28.002-18.123,28.002-18.123z'/%3E %3Cpath d='m931.44,421.91s22.186,9.786,28.004,18.123c12.623-9.55,29.229-17.048,29.229-17.048s-15.917-4.151-29.229-16.126c-7.615,10.066-28.004,15.051-28.004,15.051z'/%3E %3Cpath d='m869.4,443.61-7.935,7.934,7.935,7.935,7.935-7.935-7.935-7.934z'/%3E %3Cpath d='m923.1,443.61-7.934,7.934,7.934,7.935,7.935-7.935-7.935-7.934z'/%3E %3Cpath d='m867.403,489.94c0,10.025-0.972,15.307-0.972,15.307s11.186-3.293,13.414-14.641c1.044-5.32,2.207-24.918-3.175-28.259l-14.5895-2.867c1.5755,3.899,5.3225,15.977,5.3225,30.46z'/%3E %3Cpath d='m915.829,462.348c-5.381,3.34-4.218,22.938-3.174,28.259,2.227,11.348,13.413,14.641,13.413,14.641s-0.972-5.282-0.972-15.307c0-14.483,3.747-26.562,5.3245-30.4605z'/%3E %3Cpath d='m833.005,462.915c-5.031,1.262-8.071,6.385-6.808,11.416,0.193,0.77,0.511,1.481,0.87,2.15-0.733-0.244-1.498-0.406-2.304-0.461-0.323-0.022-0.655-0.011-0.972,0-4.761,0.16-8.73,3.903-9.061,8.755-0.354,5.174,3.579,9.629,8.755,9.983,0.772,0.052,1.523,0.024,2.251-0.103-0.445,0.611-0.83,1.263-1.125,1.996-1.937,4.813,0.409,10.351,5.222,12.288,4.812,1.935,10.298-0.461,12.234-5.273,0.296-0.735,0.461-1.452,0.564-2.202,0.443,0.615,0.976,1.179,1.586,1.689,3.979,3.328,9.931,2.801,13.259-1.177,3.329-3.978,2.801-9.881-1.178-13.208-0.602-0.504-1.27-0.9-1.945-1.228,0.723-0.232,1.426-0.552,2.098-0.972,4.395-2.755,5.725-8.609,2.969-13.004-1.894-3.021-5.222-4.574-8.549-4.351-1.513,0.101-3.029,0.572-4.403,1.434-0.671,0.421-1.267,0.888-1.791,1.433,0.001-0.756-0.064-1.534-0.256-2.303-1.104-4.403-5.151-7.305-9.5215-7.117-0.6245,0.027-1.2655,0.098-1.8945,0.255z'/%3E %3Cpath d='m932.825,490.25c1.017,9.587,8.808,17.619,18.429,19.914-1.643-2.687-2.735-5.682-3.072-8.856-1.205-11.37,7.588-20.581,19.607-20.581,1.894,0,3.729,0.234,5.528,0.667-4.237-6.947-12.215-11.775-20.887-11.7745-12.018,0.0005-20.813,9.2625-19.605,20.6305z'/%3E %3C/g%3E %3Cg fill='%23ffd200'%3E %3Cpath d='m847.592,373.684c0,18.128,9.667,28.821,22.576,28.821,2.462,0,5.155,3.328,7.475,3.328,3.782,0,6.298-4.198,8.601-4.198,2.927,0,4.9,4.607,9.982,4.607,5.083,0,7.107-4.607,10.034-4.607,2.302,0,4.818,4.198,8.6,4.198,2.321,0,5.012-3.328,7.475-3.328,12.909,0,22.577-10.693,22.577-28.821,0-14.784-12.416-32.81-11.058-35.734,0,0,24.214,17.369,24.214,37.832,0,32.963-33.429,41.109-33.429,41.109l7.525,16.944s-10.362,1.554-16.689,6.656c-8.439,6.805-8.55,25.191-8.55,37.626,0,14.648,0.545,20.855,5.837,24.829,5.58,4.193,9.777,5.096,9.777,9.369,0,3.723-4.345,5.246-9.983,7.73-6.413,2.827-7.052,7.731-16.33,7.731-9.279,0-9.867-4.904-16.28-7.731-5.637-2.484-9.983-4.006-9.983-7.73,0-4.273,4.197-5.176,9.777-9.369,5.292-3.974,5.836-10.181,5.836-24.829,0-12.435-0.11-30.821-8.549-37.626-6.328-5.104-16.689-6.656-16.689-6.656l7.524-16.944s-33.428-8.145-33.428-41.109c0-20.463,24.215-37.832,24.215-37.832,1.358,2.924-11.057,20.95-11.057,35.734zm35.988,136.126c-6.567,0-10.75,1.386-10.75,3.379,0,1.994,4.184,3.328,10.75,3.328,1.75,0,3.737-1.019,3.737-3.328s-1.988-3.379-3.737-3.379zm25.34,0c-1.75,0-3.737,1.071-3.737,3.379-0.001,2.309,1.987,3.328,3.737,3.328,6.568,0,10.75-1.333,10.75-3.328,0-1.994-4.183-3.379-10.75-3.379z'/%3E %3Cpath d='m896.28,341.38,3.686,10.394,9.931-4.761-4.71,9.982,10.342,3.687-10.342,3.686,4.71,9.931-9.931-4.71-3.737,10.341-3.686-10.341-9.931,4.71,4.71-9.931-10.341-3.686,10.341-3.687-4.71-9.982,9.931,4.761,3.737-10.394z'/%3E %3Cpath d='m850.147,422.528c-0.002,0-17.099,12.696-17.099,12.696l-0.206,0.255-0.358-0.307-18.941-11.877s12.087-4.167,19.1975-11.4155c6.7285,7.7035,17.4065,10.6485,17.4065,10.6485z'/%3E %3Cpath d='m978.948,423.295s-12.609,6.28-18.943,11.877l-0.357,0.307-0.204-0.255c-5.986-6.871-17.098-12.696-17.098-12.696s10.676-2.945,17.4045-10.648c7.1115,7.248,19.1975,11.415,19.1975,11.415z'/%3E %3Cpath d='m869.4,447.4,4.147,4.145-4.147,4.199-4.198-4.199,4.198-4.145z'/%3E %3Cpath d='m923.1,447.4,4.199,4.145-4.199,4.199-4.146-4.199,4.146-4.145z'/%3E %3Cpath d='m875.033,465.519c2.897,3.998,2.405,10.462,2.405,19.455,0,9.067-6.808,12.541-6.808,12.541,0-21.794-2.247-27.034-3.43-33.6345z'/%3E %3Cpath d='m925.3,463.88c-1.185,6.602-3.429,11.841-3.429,33.634,0,0-6.809-3.474-6.809-12.541,0-8.993-0.492-15.455,2.406-19.454l7.832-1.639z'/%3E %3Cpath id='leaf' d='m842.832,472.128c0.204,0.816,0.226,1.618,0.153,2.407-0.06,0.654-0.234,1.248-0.46,1.842-1.133-0.414-2.359-0.615-3.635-0.615-3.159,0-5.987,1.39-7.935,3.585-0.511-0.452-0.955-0.952-1.33-1.536-0.42-0.649-0.775-1.359-0.973-2.15-0.982-3.913,1.411-7.876,5.324-8.857,0.488-0.124,1-0.185,1.4845-0.2045,3.3925-0.1455,6.5115,2.1055,7.3715,5.5285z'/%3E %3Cuse xlink:href='%23leaf' transform='rotate(72,838.89,486.468)'/%3E %3Cuse xlink:href='%23leaf' transform='rotate(144,838.89,486.468)'/%3E %3Cuse xlink:href='%23leaf' transform='rotate(216,838.89,486.468)'/%3E %3Cuse xlink:href='%23leaf' transform='rotate(288,838.89,486.468)'/%3E %3Ccircle cx='838.890' cy='486.468' r='7.065'/%3E %3Cpath d='m962.925,476.942c-11.729,2.268-20.17,12.628-18.942,24.727-3.738-3.096-6.473-7.266-6.962-11.877-0.951-8.979,5.571-15.922,15.4095-15.922,3.7615,0,7.3755,1.152,10.4945,3.072z'/%3E %3C/g%3E %3C/g%3E %3C/g%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 640 320'%3E %3Cpath fill='%23d3ae3b' d='M0 0h640v320H0z'/%3E %3Cpath fill='%23c40308' d='M16 16h608v288H16z'/%3E %3Cpath fill='%23B96B29' d='M389.64 157.4c1.87-.53 8.39-2.43 12.98-6.16 4.6-3.72 5.49-6.7 5.86-8.32.37-1.61.53-2.88-.66-1.96-1.19.93-4.75 3.73-7.18 5.08a26.85 26.85 0 0 1-5.99 2.35c-1.32.37-2.37.6-1.1.1 1.26-.5 5.4-1.95 8.6-5.15 3.19-3.2 5.71-7.99 5.76-10.93.06-2.94-.15-2.73-1.1-2-.94.74-4.3 4.9-6.2 6.47a60.01 60.01 0 0 1-6.46 4.57c-1.52.9-3.67 1.89-.68-.16 3-2.05 8.67-6.88 10.98-13.13 2.31-6.25 1.89-9.93 1.84-10.56-.06-.63-.58-1.9-1.1-.73-.53 1.15-4.32 8.72-7.36 11.97-3.05 3.26-2.31 2.63-3 3.15-.68.53-1.83 1.47-.36-.37 1.47-1.83 4.52-6.09 6.1-10.29 1.57-4.2 1.99-8.4 2.04-10.82.05-2.42-1-5.78-1.47-6.78s-.95-1.73-1.1-.58c-.16 1.16-2.58 8.62-3.9 12.24a47.14 47.14 0 0 1-4.46 8.51c-.52.8-1.89 2.42-.42-.31s4.31-10.77 4.68-18.39c.37-7.61-.68-11.81-1.74-13.92-1.05-2.1-1.96-2.84-1.96-2.84s.18 5.2-1.37 12.67-3.82 11.41-3.82 11.41-.95 1.08-.3-.71a31.8 31.8 0 0 0 1.77-8.36c.44-4.72.5-10.1-.88-14.66-1.5-4.98-4.1-7.52-4.1-7.52-.73 7.14-.59 16.34-3.2 23.8-.5-.44-1.14-1.25-1.4.4a42.09 42.09 0 0 1-4.66 12.9c-3.22 5.87-4.53 6.64-4.53 6.64s-.6-1.43-1.02-2.2c-.41-.78-.65-1.2-1.19-.13-.54 1.08-2.33 5.2-6.27 9.74-3.93 4.55-6.14 6.76-6.02 10.16.12 3.41 1.9 5.14 4.3 6.7 2.38 1.55 2.8 2.39 2.44 4.24-.36 1.85-2.5 2.51-4.35 2.57-1.86.06-4.18-.12-5.02.36-.83.48-.9 1.67-1.73 2.5-.83.84-1.2 1.32-1.97 1.44l-.67.09c-.17-8.99 3.31-13 3.31-13l-9.73-11.42-1.5.7a2.72 2.72 0 0 0-.29-.44 7.46 7.46 0 0 1-1.72-5.18c.48.05 1.46.4 2.34.22.88-.17.22-1.06-.05-1.9-.26-.84-.53-3.76-.35-4.86l.26-1.55s1.42 1.55 2.3 1.55c.88 0 .8-.89.92-1.86.2-1.47.9-3.32 2.03-4.34 0 0 1.55 1.07 3.31 1.07a8.7 8.7 0 0 0 6.04-2.3c1.9-1.82 1.85-2.26 1.85-2.26s3.53 1.24 6.22 1.37c2.7.14 5.56-.3 6.93-3.14 1.36-2.83-.4-5.44-.7-5.88-.32-.44-1.2-.8-1.2 0s.05 2.92-1.59 3.98c-1.63 1.06-2.9 1.02-4.45.53a13.68 13.68 0 0 0-8.73-.23c.12-.11 2.13-2.18 4.1-2.78 2.03-.62 3.22.22 3.88 1.02s1.23 2.08 1.76.22a6.9 6.9 0 0 0-.66-5.35 5.05 5.05 0 0 0-4.76-2.04c-1.98.23-2.69.53-2.69.53s-1.01-2.87-3.57-3.4c-3.12-.65-6.56.52-9.26 2.03 0 0-2.12.5-4.28-.13a13.96 13.96 0 0 1-3.64-1.81l.73-2.35 1.27-.43c.64-.25.5-.46.59-1 .08-.54-1.22-1.48-1.22-1.48s-.18-1.61 1.94-2.72c2.13-1.11 1.9-.93 1.9-.93s1.25.24 1.76-.13c.5-.37.5-.6.5-.6s.94-.31 1.3-.88c.34-.57.4-1.39.15-2.05-.25-.66-.57-.8-.22-1.1.34-.32.66-1.08.69-1.61l.03-.67s.72-.25.7-1.35c-.04-1.1-.64-1.55-.99-1.65-.34-.09-.56-.09-.56-.09s-.06-.66-.63-1.54c-.57-.89-.94-1.27-.94-1.27s.4-.31.19-1.04a1.94 1.94 0 0 0-1.23-1.32c-.5-.16-1.04 0-1.04 0s-1.67-1.01-2.45-1.42l-.98-.5s-.03-.7-.31-1.08-.95-.54-1.3-.54-.71.2-.71.2-2.84-.73-4-.92c-1.16-.2-1.23-.29-1.23-.29s-2.51-1.2-3.49-1.38c-.97-.2-1.25-.29-1.25-.29s1.01-1.23 1.08-2.65a3.95 3.95 0 0 0-1.89-3.36c-.57-.33-.87-.39-1.06-.5l-.02-.98 1.9.19.15-3.04-1.84.23.28-1.83-3.86-.05.29 1.83-1.86-.12.16 3 1.95-.26-.19 1.14s-.71.12-1.32.56c-1 .6-1.86 1.77-1.8 3.2.07 1.41.92 2.67.92 2.67s-.25.07-1.23.25c-.97.2-3.49 1.4-3.49 1.4s-.06.09-1.23.28c-1.16.19-4 .91-4 .91s-.37-.19-.72-.19c-.34 0-1 .16-1.28.54-.29.38-.32 1.07-.32 1.07l-.97.5c-.8.42-2.46 1.43-2.46 1.43s-.53-.16-1.04 0c-.5.16-1 .6-1.22 1.32s.19 1.04.19 1.04-.38.38-.95 1.26c-.56.89-.63 1.55-.63 1.55s-.22 0-.56.1c-.35.09-.95.53-.98 1.64-.03 1.1.7 1.35.7 1.35l.03.66c.03.54.34 1.3.69 1.61.34.32.03.44-.22 1.1-.25.67-.2 1.49.15 2.06.35.56 1.3.87 1.3.87s0 .23.5.6 1.76.14 1.76.14-.23-.18 1.9.93c2.12 1.1 1.93 2.72 1.93 2.72s-1.3.94-1.21 1.48c.08.54-.06.75.59 1 .65.24 1.26.43 1.26.43l.73 2.35c-.8.54-2.22 1.4-3.63 1.81-2.16.62-4.28.13-4.28.13-2.7-1.5-6.14-2.68-9.26-2.03-2.56.53-3.58 3.4-3.58 3.4s-.7-.3-2.68-.53a5.06 5.06 0 0 0-4.77 2.04 6.9 6.9 0 0 0-.66 5.35c.53 1.86 1.1.57 1.76-.22.67-.8 1.86-1.64 3.89-1.02 1.97.6 3.98 2.66 4.1 2.78a13.68 13.68 0 0 0-8.73.23 4.67 4.67 0 0 1-4.46-.53c-1.63-1.06-1.59-3.19-1.59-3.98s-.88-.44-1.19 0-2.07 3.05-.7 5.88c1.36 2.83 4.23 3.27 6.92 3.14 2.7-.13 6.22-1.37 6.22-1.37s-.04.44 1.85 2.26c1.9 1.8 4.28 2.3 6.04 2.3s3.31-1.07 3.31-1.07c1.14 1.02 1.83 2.87 2.03 4.34.13.97.04 1.86.93 1.86.88 0 2.29-1.55 2.29-1.55s.09.44.26 1.55c.18 1.1-.08 4.02-.35 4.86-.26.84-.93 1.73-.04 1.9.88.18 1.85-.17 2.33-.22 0 2.12-.42 3.52-1.72 5.18l-.27.4c-.48-.2-.96-.43-1.44-.67l-9.73 11.44s3.5 4.02 3.3 13.06v-.07c-.17-.01-.4-.04-.7-.09-.78-.12-1.14-.6-1.97-1.43-.84-.84-.9-2.03-1.73-2.51s-3.17-.3-5.02-.36c-1.85-.06-4-.72-4.35-2.57-.36-1.85.06-2.69 2.44-4.24 2.4-1.56 4.18-3.29 4.3-6.7.12-3.4-2.09-5.61-6.03-10.16-3.94-4.54-5.73-8.66-6.26-9.74s-.78-.65-1.2.12c-.41.78-1.01 2.21-1.01 2.21s-1.31-.77-4.54-6.63a42 42 0 0 1-4.65-12.91c-.26-1.65-.9-.84-1.4-.4-2.62-7.46-2.47-16.66-3.2-23.8 0 0-2.6 2.54-4.1 7.52-1.38 4.57-1.33 9.94-.89 14.66.42 4.5 1.33 7.15 1.77 8.36.66 1.79-.3.71-.3.71s-2.26-3.94-3.81-11.41c-1.56-7.47-1.38-12.67-1.38-12.67s-.9.74-1.96 2.84c-1.05 2.1-2.1 6.3-1.73 13.92.37 7.62 3.2 15.66 4.68 18.39 1.47 2.73.1 1.1-.43.31a47.3 47.3 0 0 1-4.46-8.5c-1.31-3.63-3.73-11.09-3.89-12.25-.16-1.15-.63-.42-1.1.58-.47 1-1.52 4.36-1.47 6.78a34.3 34.3 0 0 0 2.05 10.82c1.57 4.2 4.62 8.46 6.09 10.3 1.47 1.83.31.89-.37.36s.05.1-3-3.15-6.82-10.82-7.35-11.97c-.52-1.16-1.05.1-1.1.73-.05.63-.47 4.3 1.84 10.56 2.31 6.25 7.98 11.08 10.98 13.13 3 2.05.84 1.05-.69.16-1.52-.9-4.57-3-6.46-4.57-1.89-1.58-5.25-5.73-6.2-6.46-.94-.74-1.15-.95-1.1 2s2.58 7.72 5.77 10.92c3.2 3.2 7.33 4.65 8.6 5.15 1.27.5.21.27-1.1-.1a26.8 26.8 0 0 1-6-2.35c-2.42-1.35-5.98-4.15-7.17-5.08-1.19-.92-1.03.35-.66 1.96.37 1.61 1.26 4.6 5.85 8.32 4.6 3.73 11.11 5.63 12.99 6.16 1.87.53.55.53.55.53s-.74-.1-4.54-.95-9.55-3.86-11.1-4.84c-1.56-.98-1.8-1.35-1.59.71.21 2.06 2.4 6.48 5.91 8.54s9.84 3.12 11.48 3.2c1.63.08 1.21.31.47.37-.74.05-2.56.05-5.54-.3-2.44-.28-6.07-1.46-7.3-1.88-.14-.53-.27-1.04-.33-1.35-.14-.79-.55-.67-.8-.5-.27.18-.42.32-1.28.76-.88.44-.9-.09-.93-.35-.03-.26-.2-1.4-.24-1.98-.03-.58-.35-.61-.75-.44l-3.08 1.32c-.72.32-.06.9.32 1.6.38.7.96 1.71.96 1.71l-2.41.65c-.58.14-.4.55-.26.96.14.4 1.04 2.44 1.28 3.02s.75.24.75.24l1.83-1.08.64 2.44c-.03.04-.85.2-1.77.85-.93.65-.7 1.48.41 1.8 1.11.33 2.4.89 3.84 3.48 1.43 2.6 1.8 7.28 2.68 14.65.88 7.36 5.59 11.12 6.24 11.58s.27.84.27.84-.64.93-.37 2.36a3.55 3.55 0 0 0 2.17 2.5c.65.24.47.89.47.89s-.33 1.57 0 4.45c.32 2.87 2.68 6.11 3.32 6.67.65.55.7.83.6 1.07-.09.23-.5.04-1.29.64a8.15 8.15 0 0 0-2.22 2.46c-.55 1.02-.37 1.62-.18 3.01.18 1.4 2.22 2.65 2.22 2.65s-.37.09-.47 1.1c-.09 1.03.65 2.19 1.58 2.93.92.74 2.68 1.1 2.68 1.1l.23 1.5c.09.6 1.24 1.2 1.98 1.61.74.42 2.17.19 2.78-.09.6-.28 1.01.05 1.38.65.37.6.23 2.92.23 3.85 0 .92-.55 1.9-.23 2.36.32.46 1.2.14 2.08-.37.88-.51 1.11-.14 1.9.37a6 6 0 0 0 2.35.93c.33-.05.19-.88.19-1.58s.12-2.27.45-2.5c.15-.1 1.5-.21 2.55-.65.49-.2 1.11-.42 1.16-.88.04-.46-.65-.46-2.18-1.25-1.52-.79-1.8-1.25-2.77-1.9-.97-.65-.5-.88-.5-1.16 0-.28.46-.6.64-.97s.1-1.2.1-1.2.78-.8 1.15-1.21c.37-.42.83-1.07 1.34-1.49s1.3-2.4 1.8-3.06c.5-.64 1.66-1.34 2.36-2.22.69-.88 2.54-2.32 3.6-3.01 1.06-.7 3.93-2.04 3.93-2.04s-.05 1.71.7 2.55c.73.83 1.7-.65 4.98-2.97 3.28-2.32 5.78-3.15 5.78-3.15s.69 1.06 1.57 2.18c.87 1.1 1.66-.05 5.68-5.61a72.84 72.84 0 0 1 8.97-9.9l.9.4c-.09.22-.17.46-.25.72-.37 1.16-.97 1.9-1.75 3.5-.79 1.62-1.98 1.98-3.36 4.15-1.39 2.16-1.57 3.64-1.7 5.85-.15 2.2 1.1 2.67 1.1 2.67s-2.03 1.98-2.63 3.45c-.6 1.47-.92 4.47-.92 4.47s-.32.13-1.06 1.65c-.74 1.53-2.07 1.75-4 3.69-1.94 1.93-4.1 2.76-5.12 3.36-1 .6-.73 1.2-.46 1.98.28.78 1.66 1.56 3.27 2.16 1.62.6 2.17.37 3.27.32 1.1-.04.23.83-.23 1.3-.46.45-1.06 2.06-.96 3.86.09 1.8 1.42 1.38 3.08 1.1 1.66-.27 3.6-1.1 3.6-1.1l-.19.5c-.18.51-.28.88-.28 2.31 0 1.43.23 2.12.65 2.49.41.36 1.24-.42 1.84-.6.6-.19 1.61-.78 3.09-1.1 1.47-.33 2.02-.97 2.02-.97s-.37.46-.46 1.47c-.1 1.01-.05 2.53.19 3.4.22.88.87 1.94 1.88 2.86 1.02.92 1.25.5 1.98-.64.74-1.15 2.26-2.63 2.26-2.63s.09.37 1.1 3.64c1.02 3.27 4.33 5.99 4.33 5.99s3.32-2.72 4.33-6c1.01-3.26 1.1-3.63 1.1-3.63s1.52 1.48 2.26 2.63c.74 1.15.97 1.56 1.98.64a6.29 6.29 0 0 0 1.89-2.85c.23-.88.27-2.4.18-3.41-.09-1.01-.46-1.47-.46-1.47s.55.64 2.03.96c1.47.33 2.48.92 3.08 1.1.6.2 1.43.97 1.84.6.42-.36.65-1.05.65-2.48s-.1-1.8-.28-2.3l-.18-.51s1.93.83 3.6 1.1 2.98.7 3.08-1.1c.09-1.8-.51-3.4-.97-3.87-.46-.46-1.34-1.33-.23-1.29 1.1.05 1.66.28 3.27-.32 1.6-.6 3-1.38 3.27-2.16.27-.78.55-1.38-.46-1.98-1.02-.6-3.18-1.43-5.11-3.36-1.94-1.94-3.27-2.16-4.01-3.69-.74-1.52-1.06-1.65-1.06-1.65s-.32-3-.92-4.47c-.6-1.47-2.62-3.45-2.62-3.45s1.24-.46 1.1-2.67c-.14-2.21-.32-3.69-1.7-5.85-1.38-2.17-2.58-2.53-3.37-4.15-.78-1.6-1.38-2.34-1.74-3.5a21.1 21.1 0 0 0-.24-.7l1.19-.51a72.7 72.7 0 0 1 8.99 9.9c4.02 5.57 4.8 6.73 5.68 5.62.88-1.11 1.57-2.18 1.57-2.18s2.5.83 5.78 3.15c3.28 2.32 4.25 3.8 4.99 2.97.39-.44.47-1.17.52-1.73a69.7 69.7 0 0 1 7.84 2.78c2.85 1.2 3.16 1.83 5.42 3.61s5.48 1.62 8.53.69c3.04-.93 11.16-3.6 14.42-5.02 3.25-1.4 5.58-2.64 5.92-3.3.34-.65.72-2.47.72-3.12 0-.65-.72-1.62-.96-1.79-.24-.17-.13-.69-.07-1.1a3.45 3.45 0 0 0-.65-2.2c-.5-.55-.44-.75-.37-2.33.14-3.36-2.25-7.58-5.64-8.93 0 0-.09-.39-.36-.62-.28-.22-.73-.43-.73-.43s.06-1.93.04-2.34c-.02-.41.16-.37.4-.25.22.11.58.57 1.13.7.55.15.9-.25 1.01-.86.11-.62.57-1.86.78-2.48.2-.62-.05-.71-.3-.78-.25-.07-1.07-.16-1.46-.25-.4-.1-.4-.12-.3-.32.1-.21.23-.53.73-1.31s.05-.8-.44-.96c-.48-.17-2.65-.83-3.24-.92-.6-.1-.73.4-.73.66s.02 1.36.04 1.77-.36.3-.6.18a8.45 8.45 0 0 1-1.16-.76c-.41-.32-.7-.02-.87.44-.16.46-.66 2.34-.82 2.9-.16.54-.12.98.11 1.07.23.1 1.3 0 1.95 0 .64 0 .27.37.27.37s-.69 1.12-.91 1.56c-.23.43-.62.5-1.15.5h-1.4s-3.52.13-6.1 2.05c-2.6 1.92-3.32 3.52-3.72 4.44-.4.93-.86.73-1.26 1.06-.4.34-1.52 1.53-1.52 2.26 0 .73.26 1.13-.87 1.86-1.12.73-2.05 3.9-.53 5.57 1.53 1.65 2.13 3.3 2.6 4.1.45.8 0 1.13-.4 1.13s-1.24-.67-1.93-1.2c-.7-.5-4.2-3.24-5.7-4.37-1.5-1.12-.4-1-.4-1s.38.04 1.26-.33 1.02-.83.14-1.1a11.14 11.14 0 0 1-3.05-1.72c-.46-.47-.7-.98.19-1.44.87-.46 2.81-1.71 1.29-2.13-1.53-.42-3.33-.74-4.8-1.16-1.49-.42-1.63-.83-1.63-.83l.98-1.4s.78-1.1-.14-1.25-3.14-.41-5.18-1.3c-4.06-1.75-6.6-4.74-7.55-8.38l.07-.09c.76 1.5 2.53 4.3 5.19 4.4 3.64.12 4.06-1.02 3.22-2.22s-1.79-2.27-2.03-2.62c-.24-.36-.3-.84.66.06s2.77 3.94 8.26 3.58c5.5-.36 5.46-1.43 5.46-1.73 0-1.06-1.11-1.22-1.77-1.88-.35-.35-.56-.85.55-.43s3.83.93 7.52.13c1.46-.3 5.33-2 5.7-3.96 0 0-2.45-.13-4.17-.87-1.71-.74-2.74-1.35-.92-.98 1.82.37 5.36 1.11 8.47.06 1.82-.62 4.17-2.1 4.17-4.79 0 0-3.38-.71-4.62-1.16-1.24-.45-1.64-.8-1.64-.8s4.83 1.54 9.21-.68c4.38-2.22 4.57-5.26 4.57-5.97s-.1-.93-.1-.93-4 .98-6.97.95c-2.99-.02-3.9-.29-3.9-.29s8.33-.23 12.52-2.8c4.2-2.56 4.44-7.6 4.44-7.6s-4.75 1.68-7.73 2.03c-2.98.34-4.8.34-5.54.29-.74-.06-1.16-.3.47-.37 1.64-.08 7.97-1.14 11.48-3.2 3.5-2.06 5.7-6.48 5.91-8.53.21-2.07-.03-1.7-1.58-.72-1.56.98-7.31 4-11.11 4.84-3.8.84-4.54.95-4.54.95s-1.46-.07.42-.6zm-150.1 9.58l-1.68.96s-.67-1.37-.85-1.77c-.17-.41-.08-.59.15-.59.23 0 .93-.2 1.48-.26.08 0 .15-.02.21-.03.19.52.43 1.09.75 1.66l-.06.04zm51.18 29.97c-1.02 1.9-3.79 3.9-5.82 4.78s-4.25 1.15-5.18 1.3c-.92.13-.14 1.24-.14 1.24l.97 1.4s-.13.41-1.61.83-3.28.74-4.8 1.16c-1.53.41.4 1.67 1.28 2.13.88.46.65.97.19 1.44-.46.46-2.17 1.43-3.05 1.71s-.74.75.14 1.12c.88.36 3.28.83 3.28.83s-.05.1-1.52 1.2a12.1 12.1 0 0 1-5.78 1.95c-1.71.1-4.41.2-7.84.05-3.43-.16-3.82-.24-3.82-.24s-.12-1.14-.36-2.84c-.23-1.69-1.26-4.1-2.05-5.2-.78-1.1-2.44-3.3-2.44-3.3s.04-.48.16-1.03.04-1.14-.36-2.18c-.4-1.05-2.4-2.57-2.4-2.57s-.09-1.12-.09-2.16-.72-5.13-1.36-7.05c-.64-1.92-3.76-6.97-5.2-9.37-1.45-2.4-2.3-5.96-2.74-8.73-.43-2.76-.26-3.67-.11-4.4.06-.31.2-.6.32-.86a8.6 8.6 0 0 0 2.32 2.08c4.2 2.56 12.54 2.8 12.54 2.8s-.93.27-3.9.3c-2.99.02-6.97-.96-6.97-.96s-.11.21-.11.93.19 3.75 4.56 5.97c4.38 2.22 9.21.69 9.21.69s-.4.34-1.63.79c-1.24.45-4.62 1.16-4.62 1.16 0 2.7 2.35 4.17 4.17 4.78 3.11 1.06 6.65.32 8.47-.05 1.82-.37.8.24-.93.98-1.7.74-4.16.87-4.16.87.37 1.96 4.24 3.65 5.7 3.96 3.69.8 6.4.3 7.52-.13s.9.08.55.42c-.66.67-1.78.83-1.78 1.89 0 .3-.03 1.37 5.46 1.73s7.31-2.69 8.27-3.59c.95-.9.9-.42.65-.06-.23.36-1.19 1.44-2.02 2.63-.84 1.2-.42 2.33 3.22 2.21 2.68-.08 4.45-2.93 5.2-4.42l.05.07.15.2c-.34.88-.93 2.32-1.58 3.54zM335 78.19c-.5-.94-.76-1.39-.76-1.39s2.07.97 3.3 2.36c1.23 1.4 1.2 2.13 1.39 2.81.18.69 0 1.94-.19 3.13-.18 1.18-.18 1.89.06 2.3.23.43.44.64.44.64s-.92.23-1.78.57c-.86.35-1.99.66-2.62.14-.63-.53-.78-.9-.39-1.24.4-.34 1.86-.76 2.04-3.28.18-2.52-.99-5.1-1.49-6.04zm-11.28 6.86c.47-1.2.67-2.34.3-4.8-.3-2.06-.7-3.82-.8-6.04 0 0 1.53.33 3.72 2.34 2.2 2 2.7 4.07 2.7 5.07s-.53 2.23-.61 3.2c-.09.98.27 1.85.27 1.85s-.8.33-1.52.83c-.73.5-1.23.8-2.34.75-1.1-.05-1.78-.55-2.42-.89s-1.05-.39-1.05-.39 1.27-.72 1.74-1.92zm-10.7-8.5c2.2-2 3.72-2.34 3.72-2.34-.1 2.22-.5 3.98-.8 6.05-.36 2.45-.17 3.59.3 4.79.48 1.2 1.75 1.92 1.75 1.92s-.41.06-1.05.39c-.64.33-1.3.84-2.42.9-1.11.05-1.61-.26-2.33-.76-.73-.5-1.53-.83-1.53-.83s.36-.87.27-1.84c-.08-.98-.6-2.2-.6-3.2 0-1.01.5-3.07 2.7-5.08zm-7.91 12.2c-.63.52-1.75.2-2.62-.13-.86-.35-1.78-.58-1.78-.58s.21-.21.45-.63c.23-.42.23-1.13.05-2.31-.18-1.19-.37-2.44-.18-3.13.18-.68.15-1.42 1.38-2.8 1.23-1.4 3.3-2.37 3.3-2.37s-.26.45-.76 1.39c-.5.95-1.67 3.52-1.49 6.04.18 2.52 1.65 2.94 2.04 3.28.4.34.23.71-.4 1.24zm29.24 21.07c-2.16 1.2-3.4.93-3.3 1.82.08.88 2.02 1.55 2.02 1.55s-1.98 2.12-3.53 3.1c-1.54.97-3.35 1.59-3.35 1.59s-.62.08-.27 1.06c.36.97.97 1.63 1.46 1.9.48.26.75.35.75.35s-2.69 2.88-3.88 3.8c-1.2.94-1.85 1.25-2.82 1.64-.97.4-.49 2-.27 2.7.22.7 1.06 1.68 1.55 1.82.48.13.66.48.04 1.46-.46.72-2 2.65-2.74 3.72l-.04.02c-.73-1.06-2.29-3.01-2.75-3.74-.62-.98-.44-1.33.04-1.46s1.32-1.11 1.54-1.82c.22-.7.71-2.3-.26-2.7-.97-.4-1.63-.7-2.82-1.63-1.2-.93-3.88-3.8-3.88-3.8s.26-.1.75-.36a3.6 3.6 0 0 0 1.45-1.9c.35-.98-.26-1.06-.26-1.06s-1.81-.62-3.36-1.6c-1.54-.97-3.52-3.1-3.52-3.1s1.94-.66 2.03-1.54c.08-.89-1.15-.62-3.31-1.82s-2.87-2.7-2.87-2.7 2.51-.83 3.75-3.36c.44-.89.54-1.7.5-2.39l.1.04c4 1.3 8.7 1.83 12.9 1.83 4.18 0 8.87-.53 12.87-1.83l.1-.04c-.05.69.06 1.5.5 2.4 1.23 2.52 3.74 3.36 3.74 3.36s-.7 1.5-2.86 2.7z'/%3E %3Cpath fill='%23D4AF3A' d='M347.47 158.5c0-6.79 3.12-11.08 3.12-11.08l-8.5-9.73c-8.08 3.13-15.5 3.32-22.09-.04-6.6 3.36-14 3.17-22.1.04l-8.5 9.73s3.13 4.3 3.13 11.08c0 6.79-1.31 11.82-2.08 15.1-.76 3.29-1.42 9.41.33 13.8 1.75 4.37 3.61 8.2 11.16 11.37s11.5 4.82 14.12 7c2.63 2.2 3.94 3.95 3.94 3.95s1.31-1.76 3.94-3.94c2.63-2.2 6.57-3.83 14.12-7 7.55-3.18 9.4-7.01 11.16-11.39 1.75-4.38 1.1-10.5.33-13.79-.76-3.28-2.07-8.3-2.07-15.1z'/%3E %3Cpath fill='%23B96B29' d='M344.8 161.3c-1.06-6.48 2.67-12.19 2.67-12.19l-7.27-8.5c-5.6 3.15-13.4 2.72-20.17-.4-6.78 3.12-14.58 3.55-20.18.4l-7.27 8.5s3.74 5.7 2.67 12.19c-1.07 6.48-3.36 16.74-2.79 20.92.58 4.18 3.53 9.02 6.57 11.57s7.54 4.67 10.74 5.82a30.98 30.98 0 0 1 7.8 4.51c1.47 1.15 2.46 2.14 2.46 2.14s.98-.99 2.46-2.14 4.6-3.36 7.79-4.5c3.2-1.16 7.71-3.3 10.75-5.83 3.03-2.55 5.98-7.39 6.56-11.57.57-4.2-1.73-14.45-2.8-20.93z'/%3E %3Cpath fill='%231D5E91' d='M344.1 162.07c-1.05-7 2.1-12.63 2.1-12.63l-6.56-7.31c-5.55 2.85-12.29 2.11-19.63-.44-7.35 2.55-14.09 3.29-19.64.44l-6.56 7.3s3.16 5.64 2.1 12.64-2.66 14.92-2.35 19.57c.02.32.06.64.1.97h5.98s.35-.4 1.01-.69c.67-.28.86-.47.86-.47s.12-1.21.85-1.46c.73-.26 1.05-.26 1.33-.26s.5-.06.86-.41c.35-.35 1.3-1.2 1.7-2.42s.67-1.68.67-2.47c0-.8.29-2.07.29-2.07s-.16-.38-.76-.15c-.6.22-.7-.39-.76-.99-.07-.6-.03-1.84.31-2.41s.48-.77.48-.77l-.25-.95s-3.8.76-4.47-2.19c-.66-2.95-.79-4.38-.88-4.7-.1-.32-.2-.48-.7-.44-.5.03-1.59-.32-2.35-1.85-.76-1.52-.82-2.15-.6-2.76.22-.6.64-.38.76-.19.13.2 1.14 1.65 1.55 1.24.42-.41.2-.41-.38-1.56s-.38-1.52-.31-2.1c.06-.56-.2-1.33-.2-1.64 0-.32.36-.58.7-.42.35.16.67.42.83.6.16.2.22.48.54.3s.12-1.25.12-1.6c0-.34.41-.6.92-.31.5.28.76.82.76 1.2 0 .39.03.73.22.73s.41-.57.45-.95c.03-.38.25-.95.6-.47.35.47.47 1.17.35 1.9-.13.73.12.35-.13 1.62s-.38 1.84-.35 2.8c.03.95.06 1.49.54 2.66.47 1.18.85 2.54 1.74 2.57l1.14.04s.98-1.9 1.74-2.35c.76-.45 1.84-.51 2.6-.6.76-.1 1.07-.33 1.07-.52s-.25-.25-1.17-.38c-.91-.12-1.67-.35-1.7-1.05-.04-.7.15-1.3-.45-1.33-.6-.03-2.09-.51-2.63-1.5-.53-.98-.4-1.2-.34-1.74s.76-1.62 1.2-.6.73 1.14 1.1 1.36c.39.23.9.29.64-.41-.25-.7-.41-1.14-.35-1.65.07-.5.41-.73.83-.83.4-.1 1.64-.47 2.28-.6.63-.13.66-.19.66-.19s.06-.44.89-.7a5.96 5.96 0 0 1 1.96-.28c.6 0 1.04.1 1.84-.29.79-.38 1.42-.44 1.93-.41.5.03.88.22 1.26.47.38.26.26.6.26.96 0 .35.06.54.6.54s1.01 0 1.52.19c.5.19 1.2.47.76 1.01-.44.54-.47 1.15-.76 1.12-.28-.04-.25.28-.38.47-.13.2-.22.35.1.54.31.2.34.38.79.8.44.4 1.1.85.44 1.52-.66.67-1.84 1.2-1.84 1.2s-.66.32.1.77c.76.44 1.1 1.37 1.4 1.52.28.16.56.42.75.51.2.1.16.73.16.73s-.41.29-.98.51c-.57.22-1.17.48-1.71.48s-.82 0-.6.5c.22.51.6 1.05.7 1.34.09.28.22.8.22.8s.88.18 1.67.18c.8 0 1.14.03 2.88-.16 1.75-.18 2.25-.25 3.93-.06 1.68.2 1.93.13 2.38.29.44.16.88.38.88.38s2.38-.03 3.68-.32c1.3-.28 1.61-1.11 1.42-1.55-.19-.45-.16-1.12-2.44-1.43-2.28-.32-3.2-.2-5-.55-1.8-.34-4.62-1.27-5.13-3.52-.5-2.25 1.33-3.2 2.25-3.65.92-.45 2.91-1.14 3.83-1.52.92-.39 2.6-.77 4.37-.51 1.77.25 2.79.73 3.48.31.7-.4 1.27-.1 1.14.54-.12.64-.82 1.94-2.82 2.54-1.99.6-4.4.67-5.7.32-1.3-.35-2.27-.86-3.06-.57-.8.29-1.68 1.27-.83 2.44.86 1.18 5.23 1.53 6.4 1.66 1.17.12 5.5-.2 6.74 1.96 1.24 2.17.25 4.58-1.2 5.12-1.46.54-2.7.89-3.8 1.05l-1.1.15s.5 1.15.5 1.63c0 .47-.07 1.36.47 1.7.54.36 1.3.61 2.22.52.92-.1 2.03.54 2.09 1.36.06.83.32 1.97.41 3.62.1 1.65 0 3.02 0 3.02s-.06.64-.28 1.24c-.23.6-1.37 2.94-1.37 2.94h6.38c.05-.33.08-.65.1-.97.26-4.71-1.35-12.63-2.4-19.63z'/%3E %3Cpath fill='%236D8C3E' d='M294.42 185.72a18.27 18.27 0 0 0 7.75 9.55c5.45 3.28 7.8 2.85 12.94 6.2 5.14 3.34 4.83 3.9 4.9 3.9s-.25-.57 4.89-3.9c5.14-3.35 7.5-2.92 12.94-6.2a18.25 18.25 0 0 0 7.75-9.55h-51.16z'/%3E %3Cpath fill='%23D4AF3A' d='M298.88 158.13c.58.61 1.02.8 1.91.71.9-.1 1.1.56 1.26 1.26.16.71.16 2.38.8 3.92.65 1.54 2.8 1.63 2.8 1.63a9.6 9.6 0 0 1 .65-2.56c.06-.14.34-.83-.43-.83s-.74-.31-1.2-1.05a14.44 14.44 0 0 1-1.57-3.97c-.21-1.27.19-3.14.4-3.82.22-.68.25-1.14 0-1.26-.25-.13-.74 0-.74 0s.19.58-.03.67c-.22.1-.4-.3-.55-.74-.16-.43-.34-.37-.65-.34-.3.04-.3.31-.1.62.22.3.1.86.1.86s-.68-.49-.95-.61c-.28-.13-.93.12-1 .49-.05.37.26 1.32.84 1.82.59.49.59 1.5.4 1.97-.18.46-1.05.4-1.23.18a.53.53 0 0 0-.8 0c-.25.28-.5.44.09 1.05zM298.54 156.5s-.34-.28-.46-.43l-.37-.5s-.06.16-.06.53.4.77.4.77l.49-.37zM299.83 152.22c.28-.12.5-.19.28-.5-.22-.3-.4-.64-.62-.7-.22-.06-.4-.03-.4-.03s.25.55.3.9c.07.33.17.45.44.33zM301.44 150.92c-.03.28.03.4.28.28.24-.13.34-.47.21-.71-.12-.25-.4-.43-.4-.43l-.18-.13c-.02 0 .1.71.08.98zM303.74 151.29c.03-.3-.1-.65-.1-.65s0 .37-.15.59c-.15.22-.12.15.03.34.15.19.18.03.21-.28zM307.36 166.95c.45 1.05 1.6-.6 2.65-1.93 1.04-1.32 1.01-.3.87.77a5.1 5.1 0 0 0 .7 2.98c.42.73.77.31.94-.21.17-.52.31-1.6.66-2.13s.7-.07.73.38.6 1.47 1.12 2.06c.52.6.77-.2.94-.94s.38-1.85.52-2.31c.14-.45.63-.07.63-.07l1.05 1.01c.7.67.76-.38.83-.9.07-.53-.1-1.68.1-1.86.22-.17.8.25 1.72.7.9.46.87-.42.76-.9-.1-.5-.62-1.62-1.36-2.24-.73-.63-.83-1.37-.59-1.68.25-.32 1.12-.04 1.67-.1.56-.08.84-.15 1.26-.22.42-.07.42-.49.42-.49s-.32-.52-.9-1.05c-.6-.52-.95-.94-1.68-1.12-.73-.17-1.74 0-1.74 0l-.1-.2c-.11-.21-.32-.21-.46 0-.14.2-.49.48-.77.73-.28.24-.45.38-.63.28-.17-.1.14-.35.14-.35s.39-.28.74-.98c.34-.7.45-1.37.17-1.68-.28-.32-1.05 0-1.46 0-.42 0-.67.07-.7-.14-.04-.21.42-.1.94-.18.52-.07.84-.7 1.01-1.22s.31-.46.63-.14c.31.31.6.24.66.03.07-.2.35-.73.7-1.26.35-.52.56-1.25.17-1.74-.38-.5-1.32-.42-1.7-.1-.39.3-.63.62-.74 1.4-.1.76-.31.34-.31.1s-.32-.64-.18-.95c.14-.31 0-.66 0-.66s-.07-.67-.8-.8-1.57.03-2.3.2-.6.8-.6.8-.55.04-1.14.11c-.6.07-1.3.32-1.85.46-.56.14-.77.2-.77.48 0 .29.1.74.1.74s.46 0 .7.14c.25.14.1.38-.17.49-.28.1-.39.14-.39.49s.14.42.42.42.87 0 1.57.31c.7.32.87.95.8 1.3-.07.35-1.04.8-1.53.8s-.63.1-.63.42c0 .32.6.28.6.28s.59.04 1.74.17c1.15.15 1.32.39 1.85.84.52.46.14.56-.1.7-.25.14-.64.46-1.02.6-.38.14-.63.42-.98.49s-1.22.03-2.82.66c-1.6.63-2.16 2.73-2.16 2.73s.2-.07.94-.45c.73-.39 1.64-.8 2.47-1.33.84-.53.84.24.42.98-.42.73.39.59.63.38.24-.21.56-.42 1.36-.84s.52.25.52.25-.24.49-.31 1.64c-.07 1.16 1.15.07 1.7-.66s.81 0 .4.84c-.43.84-1.23 1.5-1.68 1.5-.46 0-.8-.49-.84-.77s.14-1.12-.14-1.33c-.28-.2-1.08.04-1.67.39-.6.35-.74.07-.87-.25-.14-.31.2-.42.07-.63-.14-.2-.46 0-.7.1-.25.11-.8.43-1.88.99-1.09.55-1.02.87-1.02 1.67s.2 1 .65 2.04z'/%3E %3Cpath fill='%23D4AF3A' d='M317.82 149.44c.23-.14.64-.3.64-.3s.51-.13.99-.2c.47-.06.39-.33.28-.55-.1-.23-.28-.31-.9-.31s-1.01.31-1.36.45c-.35.15-.76.25-.76.25l.3.43c.23.35.58.4.8.24zM320.34 151.94c.25 0 .52-.14.52-.14s.45-.23.86-.38c.41-.14.58-.2.82-.7.25-.49-.27-.49-.99-.67-.72-.2-1.07.06-1.15.32-.08.27-.06.58-.35 1.1-.29.5.04.47.3.47zM320.11 152.57c-.7 0-1.48 1.05-1.77 1.24s-.12.37-.12.37.2.43.28.84c.09.41.1 1.11.1 1.11s.11.04.52.04c.41 0 .66-.2 1.05-.5s.7-.38 1.26-.49c.55-.1.82-.2 1.44-.53s-.33-.9-.99-1.44a2.46 2.46 0 0 0-1.77-.62zM310.8 154.99c.55-.06.8-.34.8-.65s-.28-.64-.99-.58c-1.73.15-3.41-.47-3.72-2.19 0 0-.59 1.08.5 2.28 1.08 1.2 2.86 1.2 3.42 1.14zM304.89 182.31c.09.15.2.25.3.3h2.66c.46-.12.46-.54.48-.83.03-.34.3-1.31.66-3.08.37-1.77 1-3.03 1.26-3.74s-.26-.95-.45-1.4c-.18-.44-.47-1.23-.55-1.63-.08-.4-.7-.34-1.05-.32s-.4.58-.45 1.11c-.05.53-.29 2.08-.55 3.42-.26 1.35-1.78 3.14-2.2 3.54-.43.4-.77.55-1.06.55s-.91 0-1.23.18c-.31.19-.63.69-.66 1.08-.02.4.6.61.6.61s.5-.29.7-.53c.17-.23.6-.29 1.01-.36.42-.08.48.07.32.28-.16.2-.11.25.21.81zM300.82 182.17c-.2.07-.35.27-.44.44h1.74a.93.93 0 0 0-.17-.44c-.21-.26-.77-.13-1.13 0z'/%3E %3Cpath fill='%23D4AF3A' d='M303.18 182.12c-.21.12-.47.3-.6.49h1.87c.07-.18.09-.4-.14-.6-.42-.34-.84-.05-1.13.1zM319.4 181.35c-.2 0-.39.18-.68.39-.3.2-.38.52-.43.77l.01.1h.8a.14.14 0 0 0 .05-.1c0-.23.1-.44.43-.73.35-.3.03-.43-.17-.43zM320.96 182.21c0-.25-.1-.47-.27-.45s-.48.34-.72.52c-.14.1-.24.23-.32.33h1.17c.07-.14.14-.29.14-.4z'/%3E %3Cpath fill='%23D4AF3A' d='M328.18 173.58c.56-.4.47-.52.5-.95.02-.43.02-.57-.2-.72-.23-.16-1.07-.53-1.86-.53s-2.28.19-2.84.57c-.57.39-.84 1.77-.84 2.49s.11.84.32.84.54-.52.54-.52.74.97 1.2 1.65c.45.68.24.95.04 1.47-.2.52-.95 1.9-1.53 2.2-.6.3-1.04.02-1.74-.1-.7-.1-1.09.1-1.5.5s-.01.73.23.73c.25 0 .6-.02.86.32.19.23.06.77-.03 1.08h3.46c.59-.26 1-1.07 1.15-1.52.18-.5.93-1.15 1.3-1.49.35-.34.4-.56.4-1.31s-.2-1.18-.48-1.7a3.1 3.1 0 0 1-.38-1.7c.06-.46.8-.93 1.37-1.34z'/%3E %3Cpath fill='%23D4AF3A' d='M322.49 164.95c.35.56.17.67-.32.78-.5.1-1.04.19-1.81.13-.78-.07-.76.04-.78.43a3.4 3.4 0 0 1-.54 1.8c-.45.61-1.01.38-1.36.14s-.54-.18-.67.26-.36.73-.73 1.38c-.37.64-.6.67-.86.6s-.5-.45-.76-.47-.67-.54-1.05-1.17c-.4-.62-.59.07-.84.6-.26.54-.52.93-1.02.87-.5-.07-1.05-1-1.33-1.56s-.46-1.1-.89-1.07c-.43.02-1.14.92-1.62 1.16-.47.24-.6.15-.81-.15-.22-.3-.5.1-.78.82-.28.71.02 1.31.4 1.5.4.2 1.17-.36 1.7-.7.5-.35.75-.26 1.29-.26.53 0 .5.88.73 2.18.24 1.29.99 1.46.99 1.46s.26.22.84-.77c.58-1 .65-1.97 1.2-1.97.57 0 .61.13 1.17.91.56.78 1.04 1.36 1.36.78.32-.59.6-1.45.97-1.75.37-.3.71-.39.33.17-.4.56-.57 1.17.23.93s3.84-1.47 5.07-1.7c0 0 1.44-.24 3.1-.33 1.66-.08 2.07-.2 2.72-.2.65 0 .67-.06.71-.49.05-.43-.3-.34-1.5-.34-1.21 0-2.06.15-2.9.28-.84.13-1.22.1-1.08-.1.16-.23.4-.38 1.36-.53a39.7 39.7 0 0 1 4-.28c1.03-.02.7.3.62 1-.09.68.08 1.7.15 2.35.06.64.08.84.65 1.74s2.5 1.47 3.06 1.77c.56.3.47 0 .45-.54-.02-.54.43-.52.93-.24.5.29 1.31.52 1.9.67.58.15.66.26.66.56s.07.97.13 1.6c.07.63.05.82-.21 1.2s-1.36 1.52-1.36 1.52-.5 0-1.55.26c-1.06.26-1.39.75-1.5 1.18s.2.56.25.74c.02.1 0 .32 0 .51h.24c.09-.15.22-.35.38-.56.37-.47 1.3-.58 1.9-.3.4.18.4.6.36.86h2.41a86.8 86.8 0 0 0 1.3-2.59c.26-.58.41-.94.43-1.74s.11-3.88-.04-4.06c-.15-.17.04-.69 0-1.55-.04-.86 0-1.5-1.6-1.66-1.6-.15-2.09-.82-2.63-1.36-.54-.54-.4-1.79-.84-3.3-.43-1.5-1.48-1.74-3.36-2.11-1.88-.37-3.26-.4-4.66-.28s-3.14.32-4.12.24c-.95-.12-.8.16-.45.72z'/%3E %3Cpath fill='%23D4AF3A' d='M331.55 182.27c-.16.1-.27.23-.35.34h1.63c.01-.14-.01-.3-.16-.47-.24-.3-.72-.13-1.12.13zM334.47 182.16c-.27.13-.44.3-.54.45h1.65v-.19c-.06-.26-.56-.54-1.1-.26zM293.75 183.19c.1.51.21 1.03.36 1.55h51.79c.14-.52.27-1.04.36-1.55h-52.51zM328.65 158.45c1.64 1.09 6.83 1.15 9.27 1.64 2.44.48 2.27 2.35 1.52 3.32-.75.98-4.18 1.1-4.8 1.18.34.23.84.95.84.95l1.4-.12c1.04-.08 2.85-.34 4.08-1.38 1.24-1.03 1.15-2.7.06-3.81-1.1-1.12-2.9-1.23-4.74-1.44-1.83-.2-3.27-.34-5.33-.68-2.07-.35-3.07-1.18-3.07-2.39 0-1.2 1.12-1.83 1.92-2.06.8-.23 2.1-.57 3.24-.15 1.15.43 2.5.5 4.77.2 2.26-.28 2.78-1.86 2.78-1.86s-.29.14-1.44.17c-1.14.03-1.98-.49-4.07-.52-2.1-.02-2.84.72-3.82 1.07-.97.34-3.58.6-4.36 2.3-.77 1.7.12 2.5 1.76 3.58z'/%3E %3Cellipse rx='.98' ry='.96' cy='150.64' cx='315.04' fill='%23B96B29'/%3E %3Cpath fill='%23B96B29' d='M336.02 152.28c-1.3-.11-2.99.23-2.99.23s.32.26.75.23 1.2-.06 2.47.17c1.26.23 2.18-.37 2.18-.37s-1.12-.14-2.41-.26z'/%3E %3Cpath fill='%231D5E91' d='M323.74 176.38c-.32-.5-.4-.45-.77-.14-.36.32-.72-.77-.77-1.44-.04-.68.27-2.76.27-2.76s-1.76.36-2.71.68c-.95.31-1.86.4-2.63.59s-1.17.36-1.58.27c-.4-.1-1.27-.14-1.94-.14s-.64.14-1.32.81c-.67.68-.85 1.04-1.4 2.31a13.45 13.45 0 0 0-.9 3.98c-.12 1-.32 1.7-.44 2.06h8.11l.33-.83c.22-.46.66-.76.98-.9s.6-.16.74-.52c.15-.36.56-.66.98-.85s1.17-.08 1.85.1c.68.2.91-.27 1.1-.52.2-.26.28-.62.64-1.09.36-.46.1-.89.1-.89s-.34-.22-.66-.72zM336.75 176.6c-.1-.47-.06-.53-.34-.6-.28-.06-.74-.14-1.15-.31-.4-.17-.36.91-.36.91s-.95.1-2.04-.02c-1.08-.13-2.35-1.1-2.8-1.43-.44-.31-.93-1.04-.93-1.04s-.34.32-.68.51-.54.88-.6 1.56c-.06.68.79 1.5.85 2.18.06.68-.74 2.04-1.15 2.6-.27.37-.63 1.18-.83 1.65h3.92a2 2 0 0 1 .42-.66c.4-.4 1.08-.48 1.08-.48s0-.17.15-.53c.15-.37.55-.8 1.53-1.17.98-.39 2.14-.45 2.14-.45s.47-.38.81-.91c.34-.53.1-1.33-.02-1.8z'/%3E %3Cg%3E %3Cpath fill='%23D4AF3A' d='M304.15 219.77c.73.24 2.1-.3 2.77-1.12.68-.82.93-2.1 1.41-2.82l.84-1.27s-.1 1.2-.75 2.81a10.31 10.31 0 0 0-.57 4.54c.29 1.8 1.45 2.1 2.14 1.85.51-.19 1.3-.98 2.01-2.18.23-.38.4-.9.61-1.32.46-.88.88-2.31 1.08-2.27.45.09.16 1.1 0 1.78-.35 1.36-1.03 3.36-1.08 4.57s.1 3.4 1.32 3.5c1.21.1 1.84-.97 2.52-3.45.69-2.48.83-3.26 1.12-3.26.3 0 .3 1.7.3 2.43 0 .25 0 .94.1 1.64.2 1.33.58 2.92.97 3.28.58.53 1.07.43 1.07.43s.48.1 1.07-.43c.58-.54 1.06-4.19 1.06-4.92s0-2.43.3-2.43c.29 0 .43.78 1.11 3.26.69 2.48 1.32 3.55 2.53 3.45 1.22-.1 1.37-2.28 1.32-3.5s-.73-3.21-1.07-4.57c-.34-1.36.14-1.27 1.07.49.29.54.59 1.21.88 1.68.65 1.03 1.28 1.65 1.74 1.82.68.24 1.85-.05 2.14-1.85.3-1.8-1.07-6.96-1.07-6.96l.59.88c.48.73.73 2 1.4 2.82.69.83 2.05 1.36 2.78 1.12s.83-1.6.3-4.04c-.54-2.43-2.73-3.8-4.29-5.74-1.43-1.79-2.53-4.93-2.7-5.43a17.96 17.96 0 0 0-5.23 3.7c-3.22 3.35-3.92 4.2-3.92 4.2s-.7-.85-3.91-4.2a18.03 18.03 0 0 0-5.27-3.71c-.18.41-1.52 3.42-2.96 5.23-.72.9-1.71 1.57-2.42 2.44-.82 1-1.31 2.2-1.6 3.5-.52 2.43-.42 3.79.3 4.04z'/%3E %3Cpath fill='%23D4AF3A' d='M304.06 228.01c.94-.83 1.43-1.29 1.43-1.29s.68-.57.51.52c-.17 1.08-.54 3.31-.31 4.28.23.97.34 1.8 1.54 1.08 1.2-.71 1.48-1.14 2.05-1.74.57-.6 1.17-.85 1.03.09-.14.94-.57 2.37-.37 4.28.2 1.91 1.14 2.2 2.37.57a21.5 21.5 0 0 0 2.34-3.91c.37-.8 1.11-1.48 1.11 0 0 3.2.73 7.83 4.25 9.07 3.52-1.24 4.25-5.88 4.25-9.07 0-1.48.74-.8 1.11 0 .38.8 1.12 2.28 2.34 3.9 1.23 1.63 2.17 1.35 2.37-.56.2-1.91-.23-3.34-.37-4.28s.46-.69 1.03-.09c.57.6.85 1.03 2.05 1.74 1.2.72 1.32-.11 1.54-1.08.23-.97-.14-3.2-.3-4.28-.18-1.09.5-.52.5-.52s.49.46 1.43 1.29a4 4 0 0 0 2.24.88s.6-3.35-.8-5.35-1.9-2.66-1.9-2.66-.8-.04-1.4-.27c-.6-.24-1.2-.67-1.2-.67v1.85s1.72 1.63 2.12 2.11c.4.48 1.2 1.31.03.51s-2.14-1.6-2.14-1.6-.23 1.69-.72 2.12c-.48.42-1.17.48-1.45.37l-.29-.12-.08.66s1.05 1.97 1.2 2.77c.14.8-.09.71-.57-.32-.49-1.02-1.43-2.34-1.86-3.05s-1.05-1.2-1-.28c.06.9-.31 2.56-.63 3.16-.3.6-.5.8-.5.8s.65 2.31.73 2.74c.09.43.03.91-.34.37s-1.43-2.82-1.43-2.82-1.4-.06-1.8-.46c-.4-.4-1.02-1.94-1.02-1.94s-.57 1.97-1.05 2.6c-.47.63-1.57 1.26-1.57 1.26s-.08 3.41-.16 4.02c-.08.6-.1.86-.36.86-.25 0-.28-.26-.36-.86-.08-.6-.16-4.02-.16-4.02s-1.1-.63-1.57-1.26c-.48-.63-1.05-2.6-1.05-2.6s-.63 1.54-1.03 1.94c-.4.4-1.8.46-1.8.46s-1.05 2.28-1.42 2.82c-.37.54-.43.06-.34-.37s.74-2.74.74-2.74-.2-.2-.51-.8a8.2 8.2 0 0 1-.63-3.16c.06-.92-.57-.43-1 .28s-1.37 2.03-1.85 3.05c-.49 1.03-.72 1.12-.57.32s1.2-2.77 1.2-2.77l-.1-.66-.28.12c-.28.11-.97.05-1.45-.37-.49-.43-.72-2.12-.72-2.12s-.97.8-2.14 1.6c-1.17.8-.37-.03.03-.51s2.11-2.11 2.11-2.11v-1.85s-.58.43-1.19.67c-.6.23-1.4.27-1.4.27s-.5.65-1.9 2.66c-1.4 2-.8 5.35-.8 5.35s1.3-.04 2.25-.86zM321.23 250.32c-.9-1.05-1.2-1.58-1.2-1.58s-.3.52-1.2 1.58c-.9 1.05-3.01 2.7-3.01 2.7s.18 2.8 1.2 4.3c.86 1.27 1.67 2.43 3 3.3a10.97 10.97 0 0 0 3.02-3.3c1.01-1.5 1.2-4.3 1.2-4.3s-2.11-1.65-3.01-2.7z'/%3E %3Cpath fill='%23B96B29' d='M319.57 253.73c.08.65.03 2.28.42 2.28s.34-1.63.42-2.28c.08-.65.11-2.2.11-2.2h-1.06s.04 1.55.12 2.2z'/%3E %3Cpath fill='%23D4AF3A' d='M319.98 100.87c-3.77.06-8.18-.46-10.62-1.36l-2.59.57c4.01 1.5 7.36 2.1 13.21 2.15 5.85-.06 9.2-.64 13.2-2.15l-2.59-.57c-2.43.9-6.85 1.42-10.62 1.36zM333.68 97.73c-.3-.25-2.01-1.47-2.46-1.7-.45-.22-.1-.82-.02-1.07.07-.25 2-.8 3.08-1.07 1.06-.27.9-.5.9-.5s-.63-.72-4.5-1.14c-3.88-.43-10.69-.33-10.69-.33s-6.8-.1-10.68.33c-3.87.42-4.5 1.14-4.5 1.14s-.17.23.9.5 3 .82 3.08 1.07c.07.25.42.85-.02 1.07a27.9 27.9 0 0 0-2.46 1.7c-.3.25-.33.64.15.67.47.02.48.02 1.8-.25 4-.8 7.75-1.01 11.74-1.07 3.98.06 7.73.28 11.72 1.07 1.33.27 1.34.27 1.81.25.47-.03.45-.42.15-.67z'/%3E %3Cpath fill='%23D4AF3A' d='M329.27 99.37c-2.66-.31-4.35-.66-9.27-.61-4.92.04-6.6.3-9.27.61 1.68.68 4.38 1.01 9.27 1.01s7.6-.34 9.27-1zM319.18 62.89l2.03-.16-.19-1.78 2.18.3.09-1.75-2.29.21.4-1.89-2.52-.02.44 1.91-2.22-.2v1.74l2.2-.25zM323.61 65.76h-2.73v-2.33a4.02 4.02 0 0 0-1.51-.01v2.34h-2.82a3.05 3.05 0 0 0-.12 1.33h7.3a2.9 2.9 0 0 0-.14-1.33z'/%3E %3Cpath fill='%231D5E91' d='M320.08 70.03c1.62 0 3-.95 3.48-2.27h-6.97a3.67 3.67 0 0 0 3.5 2.27zM321.58 63.65v1.6h1.8a3.5 3.5 0 0 0-1.8-1.6zM318.57 63.65c-.8.32-1.43.89-1.8 1.6h1.8v-1.6z'/%3E %3Cpath fill='%23B96B29' d='M322.17 93.31c-.69-.32-2.19-.96-2.19-.96l-2.2 1.09c-.77.39-.67.27-.91.84s.02.76.36.91c.34.15 2.79 1.4 2.79 1.4l3.01-1.4c.6-.27.48-.55.32-.98-.16-.42-.5-.57-1.17-.9z'/%3E %3Cpath fill='%23D4AF3A' d='M317.64 94.03l2.4 1.22 2.37-1.22-2.43-1.14zM319.98 84.65s-.2.84-.47 1.2c-.27.36-.48.69-.4 1.12.08.44.58.73.87.73.3 0 .8-.29.87-.73.08-.43-.13-.76-.4-1.12-.26-.35-.47-1.2-.47-1.2z'/%3E %3Ccircle cy='88.56' cx='320' r='.45' fill='%23D4AF3A'/%3E %3Cpath fill='%23D4AF3A' d='M318.39 86.24s.78-.87 1.07-1.42c.29-.54.52-1.03.52-1.03s.24.49.52 1.03c.3.55 1.07 1.42 1.07 1.42s1.1-.58 1.73-2.68c.64-2.11-.14-4.33-.43-6.73s-.52-6.52-.52-6.52c-.83.48-1.62.68-2.37.7a4.89 4.89 0 0 1-2.37-.7s-.23 4.13-.52 6.52c-.29 2.4-1.07 4.62-.43 6.73.64 2.1 1.73 2.68 1.73 2.68z'/%3E %3Cellipse rx='1.89' ry='1.83' cy='81.51' cx='319.98' fill='%23B96B29'/%3E %3Cellipse rx='1.82' ry='1.76' cy='77.22' cx='319.98' fill='%23B96B29'/%3E %3Cellipse rx='1.74' ry='1.68' cy='73.12' cx='319.98' fill='%23B96B29'/%3E %3Cellipse rx='1' ry='.97' cy='81.18' cx='319.98' fill='%23D4AF3A'/%3E %3Cellipse rx='.97' ry='.93' cy='76.91' cx='319.98' fill='%23D4AF3A'/%3E %3Cellipse rx='.85' ry='.82' cy='72.82' cx='319.98' fill='%23D4AF3A'/%3E %3Cpath fill='%23b96b29' d='M319.93 224.04c.12.02.14-.28.16-.83.03-.56.1-1.9.23-2.7.14-.78-.2-.73-.41-.69-.21.05-.33.65-.33 1s.1 2.34.1 2.76.13.44.25.46z'/%3E %3C/g%3E %3Cg id='a'%3E %3Cpath fill='%23d4af3a' d='M300.28 239.41c.84-.53 1.57-1.13 3.48-2.4 1.9-1.26 2.6-2.66 2.6-2.66h-.67c-.36 0-.67-.51-.7-1.02-.03-.5 0-1.55.14-2.76.14-1.2-.2-2.19-.2-2.19s-.8.76-2.04 1.4c-1.24.65-1.74.34-1.74.34l-.31-1.23s-.53 1.12-1.29 2.44c-.76 1.33-2.8 2.79-4.26 3.89s-3.06 2.25-4.27 2.67c-1.2.42-.5.99-.5.99s1.2 1.2 4.32 1.77 4.6-.7 5.44-1.24z'/%3E %3Cpath fill='%23d4af3a' d='M311.17 238.2c-1.11-.12-1.78-.54-2-1.75-.13-.78.06-3.8.06-3.8s-.36.32-.78.82c-.42.5-1.38.62-1.38.62s-.14.42-.56 1.1c-.42.67-.95 1.5-2.02 2.16-1.06.68-2.3 1.47-3.11 2.14-.81.68-1.77 1.47-2.83 2.06a4.66 4.66 0 0 0-2.39 3.12c-.36 1.58-.08 2.08 1.15 2 1.24-.09 1.38.03 3.37-.48 1.99-.5 4.82-2.73 6.9-4.05 2.08-1.32 3.59-3.94 3.59-3.94z'/%3E %3Cpath fill='%23d4af3a' d='M316.69 240.02s-.84-1.07-1.15-2.28l-.9-3.6s-.28.76-.95 2.2c-.67 1.43-1.82 1.77-1.82 1.77s-.06.62-1.01 1.83a14.03 14.03 0 0 1-3.8 3.18c-1.42.84-3.27 2-4.28 3.43-1.01 1.43-1.1 2.92-.62 3.57.48.65 1.15-.09 2.1-.56s3.68-.9 7.44-2.93c3.76-2.02 4.99-6.61 4.99-6.61z'/%3E %3Cpath fill='%23d4af3a' d='M318.32 248.44c1.04-1.55 1.2-5.32 1.2-5.32s-.36-.25-.86-.67c-.5-.42-1.49-1.91-1.49-1.91s-.62 1.29-1.29 2.5a9.4 9.4 0 0 1-2.41 2.92c-1.4 1.3-3.31 2.57-4.13 3.94-.8 1.38-.36 4.14.17 5.07.54.93 1.3.61 2.08-.14.78-.76 1.04-.96 2.41-2.14s3.28-2.7 4.32-4.25z'/%3E %3Cpath fill='%23b96b29' d='M305.98 216.89c.55-1.13 1.18-2.5 1.68-3.19.5-.7.86-1.49.86-1.49s-1.34 1.22-1.87 2.09c-.53.86-.86 1.7-1.1 2.64-.24.93-.12 1.08.43-.05zM311.31 217.85c.22-.74.34-1.24.34-1.24s.21-.72.1-.77c-.13-.05-.68.45-1.06 1.67-.39 1.23-.96 3-.84 3.07.12.08 1.24-1.99 1.46-2.73zM315.51 221.23l.24-.55s.43-1.4.43-1.68c0-.29-.14-.62-.5.1s-.38 1.41-.46 1.72c-.07.32-.48 1.4-.36 1.5.12.09.41-.56.65-1.09zM302.47 234.03l-.56-.34s-.34.45-.82.96c-.47.5-1 .7-1.37 1.18-.36.48-.93 1.07-1.8 1.52s-1.2.6-1.03.73c.17.14.76-.2.76-.2s.25-.02 1.29-.64 1.29-.96 1.96-1.55 1.57-1.66 1.57-1.66zM307.02 239.41c.4-.42.81-.7.59-.93-.23-.22-.5-.2-.87.11s-1.4 1.3-1.88 1.72c-.48.42-.87.67-1.35 1.04-.47.37-1.51.93-2.02 1.2-.5.3-.02.32-.02.32s.39-.2.81-.34c.42-.14 1.63-.67 1.63-.67s.47-.23 1.12-.68c.64-.45 1.6-1.35 1.99-1.77zM312.26 243.04c.34-.67-.03-.48-.59-.25-.56.22-1.82 1.6-2.55 2.1s-1.35.71-1.96 1.02c-.62.31-.62.48-.6.62.03.14.29.14.54.03.25-.12 1.12-.62 1.12-.62s.37-.11.7-.14c.34-.03.82-.4 1.57-1.04.76-.65 1.43-1.04 1.77-1.72zM314.7 247.85c-.93.56-2.52 1.83-2.94 2.67-.43.85-.7 1.44-.57 1.58.14.14.6-.14.79-.48.2-.34.62-.85.62-.85s1.6-1.57 2.18-1.94 1.55-1.4 1.77-2.02c.22-.62.06-.96.06-.96s-.99 1.44-1.91 2z'/%3E %3Cpath fill='%23c52126' d='M289.99 113.28c-.85-.5-3.13-1.47-5.56-1.68-2.42-.2-4.3.16-6.31.7a6.98 6.98 0 0 1-3.77.14 5.23 5.23 0 0 1-3.54-3.95s-1.6 2.06.03 4.29a4.8 4.8 0 0 0 2.86 1.95c3.4.68 6.73-1.4 9.56-1.57 2.72-.18 4.86 1.55 4.86 1.55s.64.53 1.55 0c.9-.53 1.17-.93.32-1.43z'/%3E %3Cpath fill='%23d4af3a' d='M280.2 211.66l-.8-.1c-.47-.07-1.47-.4-1.77-.54-.3-.13-.77-.17-1.07.17-.3.34-2.75 1.78-2.75 1.78h4.05c1.4 0 2.34-1.31 2.34-1.31z'/%3E %3Cpath fill='%23d4af3a' d='M291.59 210.97v-.4l-.54-1.16s-.63.39-1.24 1.02c-.79.82-1.64 1.97-2.02 2.46-.67.86-1.61 1.68-.8.3.8-1.38 1.07-1.98 1.72-2.9.64-.91 1.13-1.32 1.05-1.37-.08-.06-.6-.14-2.3-.35-1.69-.22-2.74-.87-3.52-1.33-.78-.46-2.18-1.21-2.18-1.21s-2.88 1.21-3.96 1.48-1.73.43-.68.95c1.06.51 1.94.67 2.46 1 .5.32 2.1.83 3.07.83.97 0 2.6.03 1.96.7-.64.68-1.37 1.98-2.07 3.95-.7 1.97-.73 3.73-.73 4.6s.1 1.72.1 1.72 1.2-1.32 4.37-3.32a56.1 56.1 0 0 1 4.96-2.94c.59-.27.89-.27.78-1.03-.1-.76-.43-2.62-.43-3z'/%3E %3Cpath fill='%23d4af3a' d='M303.73 201.31l-.59-.27a.7.7 0 0 0-.15.05c-.37.2-2.3 1.5-3.1 2.76-.77 1.27-1.56 1.38-.7 0a11.94 11.94 0 0 1 2.84-3.32 35.56 35.56 0 0 1-4.9-2.8 7.49 7.49 0 0 1-1.07 1.65c-.67.7-2.17 1.3-2.17 1.3s1.2-1.22 1.6-2.16c.27-.6.44-1.23.53-1.62a21.1 21.1 0 0 1-3.21-3.06c-.2.8-.84 2.77-2.76 4.9-2.5 2.8-7.5 4.22-7.5 4.22s-1.74.19-.33.56 2.43 1 5.19.52c2.76-.48 2.94-.6 3.32-.7.37-.12 1.38-.04 0 .48s-4.6 1-5.82.9c-1.23-.12-2.91-.38-1.16.55s2.5 1.3 3.58 1.3 1.53.35 2.58.35c1.04 0 1.34-.2 2.08-.34.75-.15 1.23.11 1.23.4 0 .3-1 1.13-.96 3.18.03 2.05.18 3.4.37 3.99.19.6.63 1.56.93 2.13.3.55.41 1.11.7-.08.3-1.2.98-2.9 1.24-4.06.26-1.16.4-1.2.52-1.8.11-.6.75-1.04.45.04s-.64 2.46-.86 3.43c-.22.97-.74 2.76.15 1.35.9-1.42 4.25-5.19 4.8-5.86s1.02-1.3 1.43-1.86c.4-.56 1.56-1.3 2.12-2.13.5-.74 1.99-2.18 2.63-2.7-.95-.4-1.95-.83-3.01-1.3zM257.37 115.23c.09 2.06 2.36 5.99 3.66 8.09 1.3 2.1 1.65 2.94 1.43 3.08-.23.13-.76-.94-1.48-1.88-.71-.93-2.1-3.12-3.25-4.78s-2.86-5.58-3.08-5.94c-.22-.36-.31-.58-.9-.13-.57.44-1.69 4.78-.35 7.73 1.34 2.94 3.35 5.09 4.2 6.12.84 1.02 1.96 2.63 1.78 2.77-.18.13-.5-.27-1.52-1.34s-2.72-2.9-3.84-4.25a31.7 31.7 0 0 1-2.56-4.09c-.16-.3-.37-.21-.53-.06-.37.37-.95 1.23-.7 3.57.36 3.26 2.05 5.14 3.57 6.8 1.52 1.64 3.03 3.03 2.81 3.25s-1.78-1.16-2.85-2.19a95.4 95.4 0 0 1-4.29-4.29c-.58-.7-1.42-.35-1.38 2.46s3.17 5.68 4.46 7.24c1.3 1.56 2.9 2.5 2.77 2.81-.14.32-1.43-.49-2.28-1.07-.84-.58-4.01-2.64-4.64-3.08-.62-.45-.93.4-.13 3.08s3.12 4.82 4.5 5.8c1.39.99 3.62 2.2 3.48 2.51-.13.31-1.07-.09-2.36-.72-1.3-.62-2.85-1.2-3.97-1.51-1.12-.32-1.11.49-1.11.49s-.23 2.27 1.42 4.1 3.53 2.55 5.31 2.86c1.78.32 2.05.4 2 .68-.04.26-.22.3-.62.3s-2.05.19-3.57.19-2.31.35-2.31 1.02-.05 1.57 2.23 3.09c2.27 1.52 4.81 1.74 5.88 1.96 1.07.23 1.12.32.9.63-.23.31-.72.27-2.41.45-1.7.17-2.72.84-2.95 1.29-.22.45.14 1.79 1.52 2.73 1.38.93 3.17 1.25 5.84 1.07 2.68-.18 3.35-.23 3.44.22.09.45-.8.58-2.14.8-1.34.23-2.37.23-3.13.86-.75.62-.17 1.92 1.12 2.85s4.5.94 5.84.85 3.4-.58 3.53-.22-.98.9-2.37 1.38c-1.38.5-1.78.8-2.05 1.39-.27.58-.04 1.12 1.6 1.74 1.66.63 4.07.63 5.32.05s1.91-.8 2.14-.58c.22.22 0 .44-.27.76-.27.3-1.34 1.16-2.72 1.52s-1.52.35-2 1.47c-.5 1.12.75 2.01 3.25 2.1 2.5.09 5.84-.9 6.91-1.52 1.07-.63 1.47-.76 1.65-.54.18.23.14.36-.4.76s-2.23 1.61-3.08 1.84c-.84.22-.93.84-.93 1.43 0 .58-.23 1.74 2 2.27 2.23.54 4.86.14 7.27-1.56a5.5 5.5 0 0 0 1.48-1.39c-.19-2.28-.09-3.85.19-5.3a8.81 8.81 0 0 1-2.3-.55c-1.33-.53-1.86-1.78-2.18-2.45-.31-.67-.76-.67-1.3-.5-.53.18-1.06.4-1.82.36s-2.36-.44-3.52-1.83c-1.16-1.39-.94-2.72-.99-3.4-.04-.67-1.11-.17-1.65-.17-.53 0-2.1-.23-3.52-1.21-1.43-.98-1.43-2.32-1.56-2.86-.14-.54-.72-.9-1.16-1.07-.45-.18-1.16-.36-2.14-1.16-.98-.8-1.34-2.37-1.39-2.9-.04-.54-.62-.59-2.63-1.61s-1.83-3.18-1.74-4.02c.1-.85 1.03-1.57 1.03-1.88 0-.32-.67-.4-1.34-.8s-2.36-1.08-2.4-3.58c-.05-2.5 1.6-2.77 1.6-2.77s-.31-.13-.98-.54c-.67-.4-2.5-1.65-2.5-3.12 0-1.48.67-2.15 1.16-2.5.49-.36 1.83-.72 1.83-.72s-.85-.54-1.2-1.7c-.36-1.16-.5-2.59.35-3.62.85-1.02 2.27-1.02 3.03-1.02s1.43.4 1.7.18c.27-.23.31-.4.04-.99a4.38 4.38 0 0 1-.09-2.5c.23-.49.27-1.47 2.19-2.1 1.92-.62 3.92.67 4.55 1.03s.36-.5.36-1.12c0-.62-1.3-2.19-2.77-4.42s-2.14-3.4-3.8-6.8-2.71-7.76-2.94-8.88c-.22-1.12-.67-.58-.67-.58s-.44.18-1.47 2.77a16.66 16.66 0 0 0-1.11 7.01z'/%3E %3Cpath fill='%23d4af3a' d='M291.02 160.92a5.02 5.02 0 0 1-3.8-2.36c-1.14-1.67-2.87-2.07-5.85-2.01-3 .05-4.37-1.38-5.12-3.46-.74-2.07.12-4.43 3.16-5.92s4.43-3.17 4.54-5.76c.12-2.59-3.04-5.81-6.2-9.43s-5.63-8.75-5.63-8.75-.92 1.2-.92 2.41.46 2.48 0 2.82c-.46.35-.63-.51-2.47-1.32-1.84-.8-3.34-.92-4.48.4s0 3.63 1.03 4.72c1.03 1.1 1.9 1.9 1.6 2.3s-1.83-.63-2.35-.97-1.72-1.67-3.5-1.5-2.42.69-2.59 2.19c-.17 1.5 1.61 2.82 2.76 3.4 1.15.57 1.6 1.09 1.32 1.31-.29.24-.57 0-1.1-.17a5.35 5.35 0 0 0-2.86 0c-.92.35-2.42 1.61-1.04 3.17 1.38 1.55 4.25 2.13 4.83 2.24.57.12.86-.06.92.4.05.47-1.21.47-2.76.52s-2.01 1.56-1.78 2.7 2.81 2.42 4.25 2.65c1.44.23 1.95 0 2.07.4.11.4-.17.58-.98.81-.8.23-2.35.4-2.64 1.67-.29 1.27-.35 1.84.86 2.94 1.2 1.09 3.16.92 3.73.8.58-.11 1.27-.75 1.84-.17.58.57-.51 1.04-1.5 1.73-.97.69-.91 2.01.76 2.93 1.66.92 3.33.58 4.02.35s1.6-1.33 2.07-.64c.46.7-1.44.93-2.24 1.9-.8.98-.52 2.6 1.09 3.57 1.6.98 4.25.29 4.7-.11.47-.4 1.04-.58 1.39-.23.34.34-.17 1.26-.52 2.07-.34.8-.98 3.16 1.44 4.08 2.41.92 4.6-1.15 5-1.55.4-.4.8-.46 1.15-.29.34.17.17.52-.12.92-.29.4-.92 2.13.8 3.34 1.18.82 2.47.76 3.16.64.36-1.34.83-2.78 1.3-4.8H290c-.23 0-.27.34-.27.48s.07.25-.14.25c-.2 0-.23.12-.53.33-.3.2-.58.46-.74.34-.16-.11.62-.53.83-.78.2-.25.62-.65.65-.92.02-.28.16-.44.57-.78.13-.11.23-.24.31-.36.28-1.34.55-2.92.8-4.82.16-1.29.26-2.5.3-3.64l-.76-.04zM241.91 125.05c2.57 5.2 6.2 8.12 6.2 8.12s-.48-1.3-.7-2.18c-.2-.89-.04-1.9-.04-1.9s-.91-1.16-2.6-3.75-2.56-6.42-2.56-6.42 1.56 3.83 2.78 5.86c1.21 2.03 2.61 3.69 2.61 3.69s.5-1.8.84-1.9c.35-.08.61.2.91.6.3.39.57.35.57.35s-.42-.85-1.06-1.88c-.29-.47-.71-.97-1-1.45-.97-1.5-3.03-4.38-4.09-7.25-1.06-2.88-3.37-10.09-3.77-12.2-.4-2.12-.8-.96-1.21.6-.4 1.56-.96 3.78-.6 7.1s1.15 7.42 3.72 12.61zM245.23 139.07c.96.7 2.37 1.66 2.37 1.66s-.23-.52-.37-1.14-.2-1.91-.2-1.91l-1.9-1.68a27.83 27.83 0 0 1-3.73-3.98c-1.95-2.42-.38-.97 1.2.76s4.63 4.25 4.63 4.25l.02-.56c.02-.53.18-.9.47-1.27.28-.36.13-.41-1.58-1.72-1.71-1.32-6.15-6.3-7.96-9.28-1.81-2.98-3.77-7.01-3.77-7.01s-.96 5.95 2.66 12.5c3.63 6.56 7.2 8.67 8.16 9.38zM264.25 176.6c1.99-.77 1.44-2.73 1.44-2.76s-1.22.38-2.34.8c-1.12.42-3.87 1.22-4.96 1.25-1.09.03-1.09-.12-1.12-.29-.03-.16.83 0 2.4-.28 1.57-.3 4.32-1.74 4.8-2.06.48-.32.42-.38-.28-.45a3.02 3.02 0 0 1-1.57-.6c-.26-.23-1 .1-2.79.5-1.8.42-5.51 1.07-8.36 1.07s-5.51-.48-5.96-.58c-.45-.1-.93.16.45 2.47 1.38 2.31 6.21 3.56 9.58 3.53 3.36-.04 6.72-1.83 8.71-2.6zM255.31 171.83c3.47.03 4.76-1 4.76-1s0-.18-.47-.89c-.47-.7-.38-1.9-.38-1.9s-.82.14-2.26.35c-1.44.2-3.12.4-4.97.08s-1.06-.53.4-.35c1.48.18 4.3-.36 5.21-.68.91-.32.53-.62-.08-.82-.62-.2-2.3-1.27-2.3-1.27s-4.2.53-8.11.09c-3.91-.44-6.39-1.44-7.18-1.56s-.76.2-.76.2-.21.36 1.14 2.48c1.35 2.12 4 3.5 6.24 4.15 2.23.65 5.29 1.1 8.76 1.12zM254.42 163.7s-.15-.2-.35-.91c-.2-.71.38-1.24.38-1.24s-.8-.23-3.38-.56c-2.6-.32-2.74-.53-4.33-.88-1.58-.36-2.64-.83-2.61-1s.53.08 1.47.44c.94.35 4.9.76 6.58 1 1.68.23 2.62.41 2.91.23.3-.17 1.33-.44 1.33-.44s-.7-.2-1.59-.35a5.6 5.6 0 0 1-2.15-.86c-.47-.32-.61-.41-2.73-.64-2.12-.24-3.82-.92-7.62-2.3-3.79-1.39-6.64-3.03-7.4-3.65-.77-.62-.71-.18-.5.62.2.8.17 1.8 2.08 4.03 1.91 2.24 2.85 3.21 7.67 4.98 4.83 1.77 10.24 1.53 10.24 1.53zM240.16 151.95c4.26 3 9.26 4.1 10.32 4.24.24-.28-.26-1.28-.03-1.89.28-.72.74-.73 1.77-.79 1.02-.06.35-.27.11-.27s-.29-.02-2-.47c-1.7-.44-3.44-.7-5.79-1.59-2.35-.88-3.06-1.53-3-1.7.06-.18 1.09.56 3.27 1.38 2.17.82 4.7 1.15 6.08 1.44 1.39.3.18-.3-.47-.68-.64-.38-1.56-1.8-1.56-1.8s-1.53-.26-4.02-1.02a32.52 32.52 0 0 1-6.68-2.8c-.72-.4-1.41-.93-2.16-1.47-1.43-1.02-2.87-2.07-3.43-2.48-.85-.62-.58-.12-.5.27s.68 2.15 2.03 4.1c1.35 1.94 1.8 2.52 6.06 5.53zM239.46 143.5c4.2 3.33 7.82 4.36 8.44 4.62.62.27.56-.09.44-.44-.12-.35-.2-1.5-.2-1.5l-3.18-1.83c-1.68-.97-3.53-2.3-4.77-3.15-1.23-.85-.5-.8-.11-.47.38.32 2.08 1.33 3.79 2.39 1.7 1.06 4.3 2.59 4.3 2.59s.05-.56.4-.91 1.24-.27 1.24-.27-.44-.44-.7-.85c-.27-.42-1.65-.86-3.21-1.6-1.56-.73-4.36-2.79-6.41-4.53a83.89 83.89 0 0 1-6.33-6.45c-.26-.35-.44-.3-.47.15-.03.44-.17.73.27 2.74.44 2 2.3 6.18 6.5 9.51zM254.34 112.03c.48.99 1 1.74 1.38 2.38.56.98.88 1.6.88 1.6s.12-.34.03-.92-.18-1.4-.02-2.36c.08-.52.19-1.04.16-1.5-.03-.52-.2-.97-.28-1.27-.13-.56-.74-3.02-1.03-4.75-.3-1.73-.6-4.2-.59-6.39.03-2.18.34-1.08.34-.02s.11 2.68.45 5.17c.34 2.5 1.4 6.3 1.4 6.3s.06-.58.38-1.41.83-1.78 1.23-2.82c.4-1.03.26-1.2.26-1.2s-1.47-7.07-1.86-10.41a427.64 427.64 0 0 1-1.01-12.12c-2.16 2.18-3.77 7.9-4.05 13.3-.22 4.08.44 7.85.63 9.38.38 3.03.9 5.4 1.7 7.04zM249.55 123.18c.07-1.6.43-2.81 1.47-3.17 0 0-.92-1.6-1.71-3.88-.55-1.56-1-3.57-1.23-5.1-.56-3.8-1.01-7.7.11-1.3 1.13 6.38 2.49 8.64 2.49 8.64l1.63 2.66c-.24-1.17-.28-1.99-.21-3.26s.22-3 .6-4.37c0 0-1.97-3.96-3.2-8.7s-1.96-9.08-1.98-11.65l-.17-3.45s-2.03 1.53-2.71 9.27c-.68 7.75 1.35 15.15 2.37 17.98 1.02 2.82 2.54 6.33 2.54 6.33zM271.71 182.24s-.32-.22-1.28-.83-.67-2.44-.67-2.44-.26.19-.97.67c-.7.48-1.5 1.03-2.46 1.41s-1.44.65-2.05.84c-.61.19-.45-.07.06-.36.51-.28.68-.44 1.96-.96 1.28-.51 3.84-2.76 3.84-2.76s-.6-.06-1.67-.1-2.4-.57-2.4-.57-1.05.96-5.32 2.79c-4.26 1.83-7.88 2.3-7.88 2.3s.45 2.2 2.5 2.93c1.7.74 4.04 1.19 8.62.1 4.58-1.1 7.72-3.02 7.72-3.02zM277.32 186.61c.35-1.8-.67-3.05-.67-3.05s-.23.13-.87.7c-.64.58-1.57 1.68-3.36 2.57s-2.44.84-.7-.1 4.26-3.56 4.26-3.56l-.68-.25c-.67-.26-1.82.19-6.63 3.08-4.8 2.88-7.62 2.98-7.62 2.98s2.14 2.6 7.97 2.4c5.83-.18 7.95-2.97 8.3-4.77zM288.34 184.52s-.64.9-1.5 1.48-3.18.93-3.18.93-.1.25-.54.83c-.45.58-1.44 1.96-2.47 2.7-1.02.73-2.62 1.21-2.72 1.02s.93-.58 1.92-1.19c1-.6 1.9-1.73 2.56-2.5.68-.77-.28-.64-.28-.64s-1.22.03-2.34-.06c-1.12-.1-.9 0-1.22.54s-.77 1.03-1.6 2c-1.02 1.17-1.98 2.23-2.95 3.39-.64.77-.16 1-.16 1s.29.48 2.88.77c1.6.17 3.34-.03 5.17-1.08 1.13-.66 2.3-1.7 3.49-3 3.1-3.4 2.94-6.19 2.94-6.19zM289.72 191.54c-.64.83-1 1.19-1 1.19s.45-1.38.84-2.02c.2-.35.43-.67.6-.9-.44-.96-.79-2-1.05-3.12-.28.93-1.17 3.64-2.27 5.4-1.35 2.14-2.53 2.92-1.77 3.5.77.57 2.28.7 3.98-.14 1.64-.8 2.11-2.2 2.34-3.34-.28-.45-.55-.91-.8-1.4-.22.13-.52.38-.87.83z'/%3E %3Cellipse rx='1.19' ry='1.09' cy='105.75' cx='289.34' fill='%23d4af3a'/%3E %3Cpath fill='%23d4af3a' d='M286.83 103.69c1.09-.03 1.67-.54 2.87-.42 1.42.13 3.34.96 5.67 2.2a9.7 9.7 0 0 0 6.55.57c.65-.19 1.3-.54 1.91-.9 2.84-1.6 2.15-4.76 2.15-4.76a11.12 11.12 0 0 1-7.09 2.15s.19.14.6.55c.41.42 1.16.9.91 1.1-.24.21-1.28-.78-2.14-1.42a12.92 12.92 0 0 0-4.35-2.15c-2.2-.65-4.66-.7-6.3.22-1.66.92-1.8 2.07-1.56 2.53.12.26.43.34.78.33zM317.64 126.8c-.5-.14-1.37-.28-2.51-1.33a47.76 47.76 0 0 1-4.21-4.63c-.32-.55-.19-1.06.6-1.38.77-.32 1.32-1.33 1.32-1.33s-1.7-.64-2.83-1.47c-1.15-.82-3.8-3.2-4.17-3.8s-.18-.7.37-.87c.55-.19.69-.56.69-.56s-1.24-.77-2.38-1.7c-1.14-.9-2.7-2.42-2.7-2.42-1.71.69-4.4.4-5.85.14-2.56-.46-4.44-1.52-4.44-1.52s-.09.41-.4 1.2c-.33.77-1.52 1.23-2.7.45-1.2-.78-.92-2.47-.92-2.47s-.96-.6-2.93-1.33-3.56-.83-5.16-.1c-1.6.74-2.38 2.94-2.38 4.6 0 1.64.87.95 1.05.72.18-.23.55-1.42 2.56-1.74 2.01-.32 3.84.64 6.13 2.52 2.28 1.88 2.79 2.02 3.93 3.21 1.14 1.2.23 1.84-1.74 2.48s-4.48-.64-4.57-.6c-.38.2.85 1.94 2.54 2.6 1.7.66 3.87.24 5.55-.44 1.15-.46 1.36.02 1.7.37 1.85 1.95 2.33 3.78 2.65 6a2.7 2.7 0 0 0 1.73-2.01c.07-.37.19-1.2.83-.6.64.6 1.14 3.9 1.14 5.41s-.46 3.54-.46 3.54l.46-.05c.28-.05.82-.37 1.55-.78.74-.41.78.05.78.87s.28 2.39 1.37 5.18 2.7 3.72 2.7 3.72.32-.55.64-1.65c.32-1.1.55-3.26.55-5.14s-.5-5.92-.5-5.92 2.29 2.8 4.66 3.5c2.38.68 4.76.27 5.76-.88s.1-1.65-.41-1.79z'/%3E %3Cpath fill='%23d4af3a' d='M302 134.04s-.72 1.6-1.12 2.17-.56.65-.56.65.72.62 1.77.94c1.05.33 1.99.53 1.99.53s-1.18-1.62-1.6-2.76c-.41-1.14-.48-1.53-.48-1.53zM316.28 133.1c-.35-.9-.57-1.4-.57-1.4-1.46.3-4.23-.4-5.43-1.12 0 0 1.1 2.23 2.2 3 1.09.77 1.24.81 1.24.81s-1.1.18-2.56-1.27c-1.47-1.44-2.13-3.1-2.13-3.1s.33 3.85-.26 6.2-.72 2.68-.72 2.68 3.1.55 6.57-.42c3.45-.96 3.72-1.27 3.72-1.27s.41-.1-.13-.83a18.68 18.68 0 0 1-1.93-3.28z'/%3E %3Cpath fill='%23b96b29' d='M310 124.64c-1.06-1.22-1.17-1.52-1.17-1.52s-.37.38-.05.9a11.1 11.1 0 0 0 2.87 2.45 7.4 7.4 0 0 0 2.07.77l-.05-.2s-2.6-1.18-3.67-2.4zM305.78 132.67s-.27-4.84-.27-5.56-.45-.53-.45-.53l-.53.24 1.04 7.08c.11.76.49.7.68.66-.38-.2-.45-1.67-.47-1.89zM299.25 111.72c-.4-.4-1.28-.69-.43.26.86.96 1.98 2.14 2.3 3.13.34.99.53 2.2-.03 1.94-.56-.26-.95-.26-1.54-.75a9.86 9.86 0 0 0-2.18-1.45c-.46-.13-1.28 0-.62.72.66.73 1.38 1.42 2.63 2.34 1.25.92 1.98 1.31 2.64 1.78.65.46 1.31.85 1.31.85s-.6-3.95-1.68-5.7-2-2.72-2.4-3.12zM277.91 177.87c-.8.6-1.85.86-1.85.86s-.5-.03-.5.16.58 0 1.19-.1c.6-.12 1.44-.73 1.74-.95.3-.22.75-.5.6-.88-.13-.4-.38.3-1.18.91zM284.8 181.56c-.17.2-1.5 1.19-1.5 1.19s-.4.28-.85.44c-.44.17-.55.42-.55.42s.08.1.55-.03c.47-.14 1.85-1.1 2.3-1.5.44-.38.63-.5.47-.66-.17-.16-.25-.05-.42.14zM256.87 131.93c.25.3.55.71.69.58.14-.14-.03-.28-.36-.66-.33-.39-.52-.58-.52-.58s-.47-.75-.75-1.02c-.27-.28-.68-.42-.16.22.52.63.85 1.16 1.1 1.46zM254.75 136.58c.3.28.58.52.9.88s.59.74.78.55c.19-.2-.5-.6-.8-.99-.3-.39-.55-.63-.94-.94s-.85-.55-.85-.55.6.78.91 1.05zM255.54 144.09c.53.55 1.3.72 1.41.5.11-.22-.06-.4-.5-.62-.43-.22-1.15-.69-1.5-.94a7.61 7.61 0 0 1-.97-.77c-.25-.25-.54-.47-.63-.38-.1.08.73.96.97 1.1.25.14.7.56 1.22 1.11zM257.06 150.1c0-.22.05-.33-.39-.36-.44-.03-1.05-.1-1.05-.1s-.86-.34-.91-.18c-.06.17.72.5 1.05.56.33.05.75.16.94.27.2.11.36.03.36-.19zM257.72 156.63c-.94 0-1.74-.22-1.8-.08s.45.36.92.52c.47.17 1.35.22 1.96.25s.72-.1.7-.41c-.04-.3-.84-.28-1.78-.28zM265.08 163.78c-.14-.14-.47-.03-1 .08-.52.11-1.38.28-1.88.25s-1.57-.05-1.57-.05l-.61.14c0 .14.8.1 1.96.25 1.16.13 1.94-.11 2.5-.2.54-.08.74-.33.6-.47zM268.12 168.87c-.58.22-1 .28-1.44.28-.44 0-1.5.19-1.5.19s-.49.06-.4.25c.08.2.24 0 .68-.06.45-.05.78 0 1.55-.02.78-.03 1.22-.23 1.69-.3.47-.1 1-.34.75-.65-.25-.3-.75.09-1.33.31zM274.04 172.72c-.33.33-1.6 1.2-1.6 1.2s-.25.19-.75.43-.47.37-.39.5.39-.2.67-.3 1.18-.72 1.65-1.1c.47-.4 1.08-.7.97-.98-.1-.28-.22-.08-.55.25zM264.19 122.87s.11.25 1.13 1.53c1.02 1.28.48.07.22-.25-.26-.33-1.75-2.45-2.26-3.03-.51-.59-.59-.3-.33.07.26.37 1.24 1.68 1.24 1.68zM262.04 129.43c.15-.15-.18-.3-.77-1.02l-1.75-2.23s-.33-.69-.43-.62c-.11.08.4 1.17.87 1.65.48.47 1.1 1.38 1.42 1.78s.51.59.66.44zM264.87 141.73c0-.36-1.16-.3-1.68-.41l-1.46-.3s-1.1-.2-1.12-.06c-.03.13.22.27.82.38.6.11 1.51.39 2.2.5s1.24.25 1.24-.11zM262.04 135.09c.77.62 1.28.91 1.68 1.13.4.22.73.55.95.3.22-.26-.19-.45-.84-.74-.66-.29-.99-.54-.99-.54l-.7-.37c-.32-.18-.87-.4-.1.22zM268.64 130.71c-.47-.4-.88-.62-.88-.62s-.58-.55-.69-.37c-.1.19.66.73 1.02 1.06.37.33 1.02 1.28 1.35 1.1.33-.19-.33-.77-.8-1.17zM264.33 147.85l-1.05.28c-.41.1-.44.3.3.3s1.06-.2 1.8-.33c.75-.14 1-.22.89-.47-.11-.25-.5-.17-.8-.08l-1.14.3zM265.49 154.06c-.06.14.53 0 .91-.14.39-.14 1.2-.55 1.66-.69.47-.14.47-.22.47-.5 0-.27-.5-.05-1.1.14-.61.2-1.39.8-1.39.8s-.5.25-.55.39zM273.48 157.82c.55-.33.67-.58.47-.75-.2-.16-.36-.14-.8.22-.44.36-1.3.97-1.3.97s-.44.17-.77.34-.75.44-.64.6c.1.17.8 0 1.16-.3.36-.3 1.33-.75 1.88-1.08zM277.25 162.81c.22-.2.88-.41 1.19-.64.3-.22.5-.88.25-.97s-.39.28-.91.67c-.53.39-2.33 1.58-2.33 1.58l-.47.19c-.5.2-.27.33.14.28.42-.06.7-.06 1.19-.44.5-.4.72-.48.94-.67zM282.83 167.54c.47-.2 1.16-.8 1.5-1.1.33-.31.74-.7.5-.9-.26-.19-.53.06-.92.42s-1.41 1.44-1.41 1.44-.14.03-.7.47c-.55.44.04.36.23.17.2-.2.33-.3.8-.5z'/%3E %3Cpath fill='%23d4af3a' d='M305.58 96.59l2.25-1.6-2.65-.68-1.7 1.36z'/%3E %3Cellipse rx='2.15' ry='2.07' cy='94.72' cx='312.78' fill='%23b96b29'/%3E %3Cellipse cx='312.78' rx='1.29' cy='94.28' ry='1.24' fill='%23d4af3a'/%3E %3Cpath fill='%23d4af3a' d='M308.3 87.6c.55.21 1.27.12 1.27.12s.22-.95-.3-1.41c-.53-.47-1-.8-1.32-1.1l-.38-.42s0 .82-.04 1.34c-.04.51.22 1.27.77 1.48z'/%3E %3Cellipse cx='309.44' rx='.39' cy='88.65' ry='.37' fill='%23d4af3a'/%3E %3Cpath fill='%23d4af3a' d='M306.51 88.25c-.17.23-.53.6-.53.6s.44.02.8.27c.36.26.82.48 1.24.43.43-.05.6-.45.52-.74-.1-.28-.3-.57-.99-.83-.7-.26-.87.04-1.04.27z'/%3E %3Cpath fill='%23d4af3a' d='M308.01 90.76c-1.35.12-3.13-1.37-3.13-1.37-.17 1.2-.9 1.81-2.04 2.04l.1.05s1.06.54 2.3.73c.57.09 1.07 0 1.67-.13a7.06 7.06 0 0 0 2-.63c.81-.5.57-1.8.57-1.8s-.12.98-1.47 1.1zM302.76 89.4c-.55-.2-1.38-.6-1.73-.62-.34-.02-.85-.1-.76.54.09.64.74.95 1.38.97.64.02.97-.23 1.35-.42.38-.19.31-.26-.24-.47zM298.54 87.11c-.6-.43-1.14-.55-1.14-.55s-.4 1.04-.17 1.68c.22.65.69.82 1.26.8.57-.02 1.42-.31 1.17-.75a3.38 3.38 0 0 0-1.12-1.18z'/%3E %3Cellipse cx='299.09' rx='.47' cy='90.04' ry='.34' fill='%23d4af3a'/%3E %3Cpath fill='%23d4af3a' d='M300.38 84.86c-.37-1.77-.31-3.7 1.37-6.16 1.68-2.46 4.6-3.45 4.6-3.45s.1-.2 1.03-1.19c.94-1 2.84-2.24 2.84-2.24s-2.2.55-3.46.95v.06c0 .85-.67 1.54-1.5 1.54-.33 0-.62-.1-.87-.27-.68.13-2.94 1.49-3.52 1.97.14.23.23.51.23.81 0 .85-.68 1.54-1.51 1.54-.25 0-.49-.06-.7-.17l-.19.33c-.47.87-.82 1.7-1.08 2.48.38.26.64.76.64 1.33 0 .85-.57 1.53-1.28 1.54-.05.5-.04.85-.02 1 .06.5.25.8 1.12 1.06.87.24 2.05 1.77 2.05 1.77.09 0 .7-1.12.25-2.9z'/%3E %3Cpath fill='%23d4af3a' d='M305.74 73.5c.32-.25.37-.65.12-.87-.25-.23-.71-.2-1.03.06-.31.26-.37.65-.12.88.25.22.71.2 1.03-.06zM300.1 77.32c.36-.33.42-.82.14-1.1-.29-.3-.8-.26-1.17.07-.35.32-.41.82-.13 1.1.28.29.8.25 1.16-.07z'/%3E %3Cellipse cx='296.74' rx='.87' cy='82.11' ry='.86' fill='%23d4af3a'/%3E %3Cpath fill='%23d4af3a' d='M315.54 70.02c-.45.1-1.29.37-2.54 1.02h.02c.87 0 1.55.56 1.55 1.28s-.8 1.5-1.66 1.5-1.46-.75-1.46-1.47c0-.17.04-.34.11-.49l-1.19.77c-2.77 1.87-3.42 2.77-4.8 5.33-1.36 2.55-1.86 5.35-1.27 7 .6 1.65 2.77 2 2.8 2s-.25-.26-.28-.57c-.03-.31.07-.47.16-1.09.1-.62.03-1.37.03-1.37s.5-.06.78.28c.28.35.68.75.96 1.1.28.33 1.03.99 1.03.99s.44-.63.44-1.37c0-.75-.5-1.56-.6-2.87s.6-3.64 1.87-5.35a15.05 15.05 0 0 1 4.39-3.61c.72-.34.84-.87.87-1.18.03-.32.1-.53.16-1.31s-.65-.75-1.37-.6z'/%3E %3Cpath fill='%23d4af3a' d='M312.79 72.97c.49 0 .94-.44.94-.84 0-.4-.39-.72-.88-.72s-.88.33-.88.73.33.83.82.83zM316.91 89.25c.67.27 1.42.12 1.78-.12.35-.24.47-.84.05-1.19a1.34 1.34 0 0 0-1.43-.12c-.39.22-1.26.84-1.26.84s.2.32.86.59z'/%3E %3Cpath fill='%23d4af3a' d='M319.05 90c-.24.37-.42.6-1.16.63s-1.55-.02-2.03-.5c-.49-.49-.82-1.17-.82-1.17l-.84-.01s-.28 1.16-.65 1.48c-.37.33-1.66.38-2.22-.04s-1.08-.94-1.18-.88 0 .49.58.99.98.8 1.92.8h5.32s1.08.07 1.39-.58c.3-.64.32-1.05.17-1.2-.14-.17-.24.1-.48.48z'/%3E %3Cpath fill='%23d4af3a' d='M310.96 89.1c.8.44 1.24.17 1.53-.19.3-.35.34-.51.34-.51s-.75-.28-1.12-.5c-.36-.2-.61-.41-.98-.37-.36.05-.42.1-.42.1s-.15 1.02.65 1.47z'/%3E %3Cellipse cx='307.11' rx='1.77' cy='81.24' ry='1.76' fill='%23b96b29'/%3E %3Cpath fill='%23b96b29' d='M310.19 75.14c-.71-.47-1.75-.28-2.33.43-.58.72-.47 1.68.24 2.16.71.48 1.76.29 2.34-.43.57-.7.46-1.68-.25-2.16z'/%3E %3Cellipse cx='307.04' rx='1.03' cy='81.01' ry='.98' fill='%23d4af3a'/%3E %3Cpath fill='%23d4af3a' d='M309.45 75.34c-.46-.13-1.02.1-1.26.5s.01.83.62.96c1.12.22 1.66-1.18.64-1.46z'/%3E %3C/g%3E %3Cg%3E %3Cpath fill='%23D4AF3A' d='M282.34 212.67s-2.74 1.31-3.61 1.54c-.87.24-1.07.24-1.07.24s-1.87 1.7-3.25 2.51c-1.44.85-3.09 1.47-4.74 1.65-2.14.23-8.03.16-10.67.06s-4.28.54-5.42 1.82c-1.13 1.27-1.4 3.11.04 4.52s3.04.7 3.57-.16c.54-.88.27-1.98.04-2.49-.24-.5.47-.67 1.2-.7.74-.03 1.98.07 3.11.23 1.14.17 3.15.84 4.02 1.31.87.47.36.54-.24.44s-1.27-.34-2.34-.74a9.28 9.28 0 0 0-2.64-.64c-.67-.03-.44.34-.3.57.13.24.5.8.6 1.08.1.27-.2 1.27-.2 1.27l.33.64s.4-.64.54-.97c.13-.34-.04-.98.1-1.28s.7-.3 1.14.2c.43.5.93 1.11 1.17 2.38.23 1.28-.2 2.18-.2 2.18s.53.44.63.74c.1.3-.13 1.51-.13 1.51s.36.24.7-.47c.33-.7.73-1.94.83-2.38.1-.44.4-1.24.94-.64s.9 1.34 1 1.71c.1.37.1.67.1.67s1.2-1.17 1.6-1.84 1.25-1.68 2.38-2.62c1.14-.94 3.11-2.81 4.08-3.45.97-.64 3.45-1.98 4.22-2.45s.9-.5 1.03-1.81c.14-1.31.77-2.48 1.07-3.39.3-.9.36-1.24.36-1.24zM238.49 163.52c-.02-.22-.47-1-.58-1.4-.11-.4-.51-.16-.51-.16s-.87.49-1.52.67-.73-.07-.8-.4c-.07-.34-.22-1.4-.34-2.13-.1-.74-.26-.7-.53-.58-.27.11-1.07.4-1.63.65-.55.24-.38.51-.2.82.18.32.83 1.64 1.12 2.1.29.48.02.68-.32.83-.33.16-.82.23-1.49.45s-.62.38-.56.6c.07.23.52 1.15.76 1.57.25.42.47.13.47.13s.71-.64 1.31-.94c.6-.28.65-.2.8.25.16.45.85 2.8.99 3.24.13.45.35.4.67.27.3-.13.73-.2 1.09-.31.35-.11.49-.83.49-.83s-1.32-2.37-1.67-2.97c-.36-.6 0-.74.26-.78.27-.05 1.05-.16 1.72-.32.66-.17.48-.55.46-.78zM253.35 227.9c-.1-.57 0-1.14-.43-1.58a5.4 5.4 0 0 1-1.17-2c-.2-.71.16-1.05.1-1.45-.07-.4-.6-.4-1.14.03-.54.44-1.24.84-1.24 2.11 0 1.28.47 2.79 2.24 3.32 1.77.54 1.74.14 1.64-.43zM255.15 227.29s-.37-.23-.54.1-.13.5.34 1.24.77.9 1.3 1.24c.54.34.17-.33.1-.53-.06-.2 0-.47-.13-.64-.13-.17-.2-.37-.2-.9 0-.54-.87-.5-.87-.5z'/%3E %3Cpath fill='%23D4AF3A' d='M257.32 233.33c.33-.5.64-.64 1.44-1s2.27-.58 2.77-.61c.5-.03 1.64-1 1.47-2.01-.16-1.01-.9-1.41-1.54-1.55s-1.2-.13-1.4.17c-.2.3-.57.7-1.27.94s-.8.47-1.24.6c-.43.14-.1.4-.47.7-.36.31-.86 0-1.43-.16-.57-.17-.6-.27-1.24-.3l-2.3-.14s-.07-.03-.44-.03-.4.07-.57.47c-.17.4.03 1.41.44 1.91.4.5 1.7.74 2.57 1 .87.28 1.3.38 2.04.51.76.13.86 0 1.2-.5zM265.45 234.13c.7-.47.3-1.27.13-1.78-.16-.5-1.13-.6-1.63-.6s-.77 0-1.04.23c-.27.24-.64.57-1.37.8-.74.24-1.3.51-2.31.91-1 .4-1.3 1.08-1.74 1.35-.43.26-1.27 0-1.27 0s-.6-.17-.8 0c-.2.16 0 .5.4.93.4.44 1.17.4 2.04.68.87.26 1.04.06 1.37-.17.33-.24.6-.74 1.2-1.1.6-.38 1.91-.44 2.55-.51a6.15 6.15 0 0 0 2.49-.74zM265.45 231.08c.3.27.64.64.9.2.27-.43.7-1.34.4-1.88-.3-.53-.66-1-.66-1s-.5 1.54-.74 1.94c-.22.41-.19.47.11.74zM262.74 226.45c0-.87-.6-1.95-.6-1.95s-.2.8-.57 1.51c-.37.7-.74 1.08-.74 1.08s.87.23 1.2.23.72.01.72-.86zM257.73 228.3c.94-.2 1.44-.57 1.84-.9s.64-1.25.37-1.71c-.27-.48-.94-.98-1.2-.98h-.5s-.28.87-.64 1.31c-.37.44-.8.74-.77 1.3.03.57-.04 1.17.9.97zM259.63 224.04a1.6 1.6 0 0 0-.43-1.2l-.5-.5s-.07.66-.14 1.03-.1.44-.1.44.27.27.5.37c.23.09.63.3.66-.14zM248.07 200.25l.63-3.95c-.47-3.95-2.53-7.7-4.16-10.28a49.03 49.03 0 0 1-4.06-8.8 24.93 24.93 0 0 1-1.23-6.66c0-1.55.66-2.35.66-2.35s.29-.42.02-.69c-.26-.26-.68-.02-1.1.4s-.86 1.2-1.04 1.75c-.17.56-.17.75-.17.75s-.84-.2-2.19-.08c-1.34.1-1.98.22-2.03.5-.04.3.18.51 1.15.93.97.42 1.59.6 2.07 1.18.49.57 1.73 3.46 2.1 4.86.39 1.4 1.2 5.18 1.53 8.15s1.33 6.57 2.73 9.57c.46.99 2.97 5.67 5.09 4.73zM250.52 207.21c-.92.51-.88 4.25-.47 6.19.4 1.94 2.3 4.35 2.88 5 .57.64.7.64 1.01.47.31-.17.44-.17.44-.17s.82-.27 1.43-.74c.6-.48.37-1.67.27-2.73-.1-1.05-.92-3.16-2.4-5.6-1.49-2.46-2.24-2.94-3.15-2.43zM251.53 204.18c0-1.22-1.06-2.14-2.27-2.14a2.1 2.1 0 0 0-1.4.43c-1.23 1.1-.49 3.89 1.3 3.89.64 0 1.4-.11 1.86-.56.42-.39.51-1.04.51-1.62zM269.21 239.32c-.49-.09-.77-.28-1.5-.77-.7-.49-1.86-1.5-2.06-1.98-.2-.5-.2-.52-.89-.29-.69.23-1.66.2-2.4.23-.75.03.08.86.6 1.64.51.77.34 3.38.34 3.38s0 .23-.12.6c-.11.38-.03.64.17.72.2.09.32-.08.84-.69.51-.6 1.46-2.18 1.46-2.18l.95.23c.8.2 2.1.09 2.75-.11.68-.2.36-.7-.13-.78z'/%3E %3Cpath fill='%23D4AF3A' d='M266.14 241.34c-.34-.06-.49-.09-.66.14-.17.23-.32.66-.4.9-.09.22-.06.42.14.6.2.17.5.37.5.37s.28.31.57.46c.28.14.34-.29.34-.6 0-.32.17-.9.17-1.27s-.3-.55-.65-.6z'/%3E %3Cpath fill='%231D5E91' d='M396.62 216.11c-.84-.2-1.2-.52-1.2-.52s-.35-.04-.64.48c-.27.52-1.35 1.2-1.35 1.2s-1.51.4-1.72 1.43c-.2 1.04.52 1.4 1.24 1.28.72-.12 2.48-.48 3.23-1.4.76-.91.88-1.43 1.04-1.8.14-.34.23-.46-.61-.66zM398.97 207.85c-.55-2.3-2.03-5.16-4.9-6.58 0 0-1.08 3.79-1.4 4.98-.32 1.2-.32 1.16.6 1.4.91.24 3.86.88 4.46 1.04s1.6.67 1.24-.85zM385.29 205.7c.68.12.6-.16.84-1.08l1.43-5.46s-3.03-.12-5.66 1.16c-2.63 1.27-3.79 3.62-3.79 3.62s.68.28 2.48.68c1.8.4 4.03.95 4.7 1.07zM378.27 211.96c-1.07-.2-1.48-.32-1.48-.32s.68 2.6 1.8 4.03c1.12 1.44 2.35 2.15 4.67 2.2 2.3.03 4.06-1.24 4.34-2.24.28-1 .76-1.75.76-1.75s-4.19-.56-5.9-.96c-1.74-.4-3.13-.76-4.21-.96z'/%3E %3Cpath fill='%23D4AF3A' d='M377.55 210.32c1.04.24 9.57 1.87 10.29 2.03.72.16 1.32.32 1.52.12.2-.2.32-.32 1.07-.6.76-.27.72-1.03.72-1.03s.2-.72.28-1.44c.08-.72.48-.96 1.32-.08.83.88 1 2.15 1.15 3.4.16 1.23 2.12 1.55 2.87 1.67.76.12 1.12-.12 1.56-.84.44-.72.68-2.15.8-3.07.12-.92.04-.84-.92-1.08-.96-.24-5.38-1.23-6.18-1.44-.8-.2-.64-.71-.52-1.27s1.87-6.18 1.87-6.18c-1.25-.78-3-1.24-5.1-1.48 0 0-1.28 5.74-1.52 6.62-.24.88-.8.88-1.71.72-.92-.16-7.54-1.71-7.54-1.71l-.52 1.23c-.52 1.24-.76 2.71-.76 3.47s.27.74 1.3.97z'/%3E %3Cpath fill='%23D4AF3A' d='M400.2 215.51c-.88-.57-1.53-.73-1.99.34-.45 1.07-.5 2.64-1.64 3.75-1.14 1.11-2.75 2.26-4.35 2.14-1.6-.11-2.52-.5-2.14-2.33.38-1.83 2.83-2.4 3.4-3.36s.42-2.07-.42-2.8c-.84-.72-2.06-.88-2.4-.65a5.29 5.29 0 0 0-1.84 2.45c-.5 1.38-.8 2.49-1.87 3.37a8.1 8.1 0 0 1-5.96 1.26c-2.13-.5-2.9-1.15-3.7-3.25-.8-2.1-1.76-5.58-2.18-5.97-.42-.38-.95-.69-1.87-.04-.91.65-.99 1.61-1.1 2.38-.12.76 0 1.64.91 2.75.92 1.1 1.87 2.22 2.22 3.36.34 1.15 1.37 2.91-.08 2.99-1.45.07-2.1.11-3.2-.96-1.11-1.07-5.43-4.02-6.61-4.97-1.19-.96-1.68-1.26-1.68-1.26-2-.04-4-.86-6-2.22 0 0 1.15 2.94 1.38 4.05.23 1.11.19 1.72.19 1.72s4.35 2.22 6.07 3.06c1.72.84 5.2 2.83 6.87 3.86 1.68 1.04 3.1 2.64 6.07 2.03 2.98-.61 9.01-2.45 10.96-3.02 1.95-.57 7.33-1.91 9.32-3.29s2.17-1.3 2.52-2.68c.34-1.35 0-2.1-.88-2.69zM388.71 194.92c.33-.04.46-.09 1.48-.22 1.02-.14.64.84.46 1.21-.17.38-.48 1.13-.9 1.84-.42.7.13.82.42.93.28.11.7.15 1.52.38.82.22.66-.38.69-.69.02-.31.06-1.93.15-2.5.09-.57.62-.42.82-.3l1.12.6c.42.23.62-.01.7-.26s.3-.68.47-1.32c.18-.64-.22-.51-.62-.51s-.97 0-1.63-.02c-.66-.02-.24-.67-.24-.67L394 192c.37-.6.24-.68-.14-.8l-1.87-.46c-.33-.09-.49-.04-.49.18s-.04 1.37-.04 1.81c0 .44-.04.7-.62.73-.57.02-.93-.31-1.39-.82-.46-.5-.66-.3-.7-.1-.05.19-.43 1.65-.52 2.05-.1.39.11.37.44.32zM391.91 209.41s-.04 1.16-.16 1.55c-.12.4-.4 1 .08 1.16.48.16.92.36 1.2.28.28-.08.15-.64 0-1.11a4.27 4.27 0 0 0-.76-1.48l-.35-.4zM398.93 214.03c.16.36.48.44.72.52.24.08.56.08.56-.36s.08-1-.28-1.48c-.36-.48-.55-.82-.76-.12-.2.72-.4 1.1-.24 1.44zM374.48 209.37c.2.04.96.28.96.28s0-1.12.16-1.88c.15-.75.47-1.27.2-1.27s-.44.24-.64.56c-.2.31-.76.4-.96 1.31-.2.91.08.95.28 1z'/%3E %3Ccircle cy='207.45' cx='379.27' r='1.56' fill='%23B96B29'/%3E %3Ccircle cy='208.53' cx='383.65' r='1.59' fill='%23B96B29'/%3E %3Ccircle cy='211.24' cx='396.42' r='1.6' fill='%23B96B29'/%3E %3Ccircle cy='209.57' cx='388.04' r='1.6' fill='%23B96B29'/%3E %3Ccircle cy='205.74' cx='389.2' r='1.6' fill='%23B96B29'/%3E %3Ccircle cy='201.91' cx='390.32' r='1.6' fill='%23B96B29'/%3E %3Ccircle cy='207.3' cx='379.38' r='.78' fill='%23D4AF3A'/%3E %3Ccircle cy='208.37' cx='383.77' r='.8' fill='%23D4AF3A'/%3E %3Ccircle cy='211.08' cx='396.54' r='.8' fill='%23D4AF3A'/%3E %3Ccircle cy='209.41' cx='388.16' r='.8' fill='%23D4AF3A'/%3E %3Ccircle cy='205.58' cx='389.32' r='.8' fill='%23D4AF3A'/%3E %3Ccircle cy='201.75' cx='390.44' r='.8' fill='%23D4AF3A'/%3E %3C/g%3E %3Cuse xlink:href='%23a' transform='matrix(-1 0 0 1 639.97 0)' height='320' width='640'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 900 600'%3E %3Crect width='900' height='600' fill='%23ED2939'/%3E %3Crect width='600' height='600' fill='%23fff'/%3E %3Crect width='300' height='600' fill='%23002395'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 900 600'%3E %3Crect fill='%23007E3A' width='900' height='600'/%3E %3Crect fill='%23FC3D32' width='900' height='300'/%3E %3Crect fill='%23FFF' width='300' height='600'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 570 300'%3E %3Ctitle%3EFlag of the Marshall Islands%3C/title%3E %3Crect height='300' width='570' fill='%23003893'/%3E %3Cpath d='M0,295.2V288L570,35V122.4z' fill='%23fff'/%3E %3Cpath d='M0,290.4V285.6L570,4.8V63.6z' fill='%23dd7500'/%3E %3Cg fill='%23fff' transform='translate(109.536,109.536)'%3E %3Cg id='r6'%3E %3Cpath d='M0,-93 5.59,0H-5.59z'/%3E %3Cpath id='r1' d='M0,-66.588 6.824,0H-6.824z' transform='rotate(15)'/%3E %3Cuse xlink:href='%23r1' transform='rotate(15)'/%3E %3Cuse xlink:href='%23r1' transform='rotate(30)'/%3E %3Cuse xlink:href='%23r1' transform='rotate(45)'/%3E %3Cuse xlink:href='%23r1' transform='rotate(60)'/%3E %3C/g%3E %3Cuse xlink:href='%23r6' transform='rotate(90)'/%3E %3Cuse xlink:href='%23r6' transform='rotate(180)'/%3E %3Cuse xlink:href='%23r6' transform='rotate(270)'/%3E %3C/g%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 56 28'%3E %3Crect width='56' height='28' fill='%23d20000'/%3E %3Cg fill='%23ffe600'%3E %3Cpath d='M 0,0 8.4,0 28,13.5 47.6,0 56,0 0,28 8.4,28 28,14.5 47.6,28 56,28 z M 56,11.2 56,16.8 0,11.2 0,11.2 0,16.8 z M 25.2,0 28,12 30.8,0 z M 25.2,28 28,16 30.8,28 z'/%3E %3Ccircle cx='28' cy='14' r='4.5' stroke='%23d20000'/%3E %3C/g%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 450 300'%3E %3Crect fill='%23CE1126' width='450' height='300'/%3E %3Crect fill='%23FCD116' width='300' height='300'/%3E %3Crect fill='%2314B53A' width='150' height='300'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 18 12'%3E %3Crect width='18' height='6' fill='%23FECB00'/%3E %3Crect width='18' height='6' y='6' fill='%23EA2839'/%3E %3Crect width='18' height='4' y='4' fill='%2334B233'/%3E %3Cg transform='translate(9,6.422)scale(4.422)'%3E %3Cpolygon id='pt' points='-0.3249196962329062,0 0,-1 0.3249196962329062,0' fill='%23FFF'/%3E %3Cuse xlink:href='%23pt' transform='rotate(-144)'/%3E %3Cuse xlink:href='%23pt' transform='rotate(-72)'/%3E %3Cuse xlink:href='%23pt' transform='rotate(72)'/%3E %3Cuse xlink:href='%23pt' transform='rotate(144)'/%3E %3C/g%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4800 2400'%3E %3Cg fill='%23f9cf02'%3E %3Cg transform='scale(5)'%3E %3Crect width='960' height='480' fill='%23c4272f'/%3E %3Crect x='320' width='320' height='480' fill='%23015197'/%3E %3Ccircle cx='160' cy='164' r='44'/%3E %3Ccircle cx='160' cy='144' r='48' fill='%23c4272f'/%3E %3Ccircle cx='160' cy='152' r='32'/%3E %3Cpath d='M140,92a20,20 0 0,0 40,0c0-8-5-9-5-12 0-3,3-7-3-12 3,5-2,6-2,11 0,5,2,5,2,9a4,4 0 0,1-8,0c0-4,4-8,4-14 0-6-1-8-4-13-3-5-8-9-4-13-6,2-3,10-3,15 0,5-4,8-4,14 0,6,3,7,3,11a4,4 0 0,1-8,0c0-4,2-4,2-9 0-5-5-6-2-11-6,5-3,9-3,12 0,3-5,4-5,12Z'/%3E %3Cpath d='M72,216V408H112V216ZM208,216V408H248V216ZM120,248V264H200V248ZM120,360V376H200V360ZM120,216H200L160,240ZM120,384H200L160,408Z'/%3E %3C/g%3E %3Cg stroke='%23c4272f' stroke-width='24'%3E %3Ccircle cx='800' cy='1560' r='212'/%3E %3Cpath fill='none' d='M800,1348A106,106 0 0,1 800,1560A106,106 0 0,0 800,1772'/%3E %3C/g%3E %3C/g%3E %3Cg fill='%23c4272f'%3E %3Ccircle cx='800' cy='1454' r='40'/%3E %3Ccircle cx='800' cy='1666' r='40'/%3E %3C/g%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 660 440'%3E %3Crect fill='%2300785E' width='660' height='440'/%3E %3Cpolygon fill='%23FBD116' points='330 82.958 315.792 126.693 352.995 99.666 307.005 99.666 344.208 126.693 '/%3E %3Cg id='h'%3E %3Cpath fill='%23FFF' d='M330 303.99h-93.937c-1.184-1.2-2.35-2.423-3.488-3.667H330c0.751 0.269 1.267 0.958 1.306 1.736C331.348 302.903 330.818 303.694 330 303.99zM330 275.265c0.545-1.114 1.607-3.694 1.125-6.921 -0.218-1.463-0.692-2.644-1.125-3.492 -5.271 4.988-15.175 12.981-29.785 17.401 -6.821 2.064-14.055 3.173-21.548 3.173h-57.872c1.706 2.507 3.494 4.954 5.364 7.333h55.945C300.346 292.76 317.058 286.179 330 275.265zM229.539 252.628c-2.785 1.072-5.772 1.741-8.887 1.926 13.629 15.415 33.545 25.144 55.723 25.144 21.066 0 40.091-8.775 53.625-22.867 2.297-15.839 3.968-33.969 4.167-53.998 0.232-23.321-1.581-44.2-4.167-62.032 -6.045 5.419-17.371 17.128-22.71 35.079 -1.998 6.72-3.072 13.837-3.072 21.203 0 15.291 4.623 29.506 12.547 41.329 -9.731-12.57-15.526-28.338-15.526-45.454 0-11.369 2.558-22.144 7.126-31.783 -3.154-3.334-5.551-7.392-6.904-11.902 -6.121 10.804-9.618 23.284-9.618 36.581 0 16.539 5.409 31.819 14.552 44.172 -15.923-16.693-38.377-27.099-63.25-27.099 -1.336 0-2.667 0.034-3.989 0.093 2.503 2.333 4.604 5.089 6.188 8.157 24.742 0.038 47.078 10.377 62.964 26.949 -15.171-12.672-34.698-20.303-55.995-20.303 -11.902 0-23.25 2.382-33.594 6.696 10.629 28.085 37.78 48.075 69.574 48.075 2.059 0 4.1-0.093 6.116-0.258 -4.29 0.771-8.709 1.174-13.22 1.174C261.128 273.51 242.92 265.554 229.539 252.628zM330 334.01h-48.684c15.067 5.988 31.492 9.281 48.684 9.281 0.414-0.788 1.125-2.395 1.146-4.542C331.168 336.492 330.417 334.804 330 334.01zM330 311.552h-85.83c2.322 1.99 4.711 3.902 7.169 5.729H330c0.197-0.201 1.167-1.236 1.167-2.865S330.197 311.753 330 311.552zM330 323.01h-70.304c4.257 2.686 8.675 5.139 13.242 7.333H330c0.33-0.523 1.112-1.917 1.063-3.844C331.018 324.78 330.335 323.54 330 323.01z'/%3E %3Cpolygon fill='%23FBD116' points='237.639 150.67 224.197 179.509 252.019 164.076 220.444 160.202 243.712 181.901'/%3E %3Cpolygon fill='%23FBD116' points='260.663 112.27 269.966 142.699 280.328 112.607 254.26 130.861 286.079 131.413'/%3E %3C/g%3E %3Cuse xlink:href='%23h' transform='matrix(-1,0,0,1,660,0)'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1000 500'%3E %3Crect width='1000' height='500' fill='%230071bc'/%3E %3Cg%3E %3Cg fill='none' stroke='%23000' stroke-width='1.93488'%3E %3Cpath fill='%23fff' d='m557.8173,395.54368c0,0 17.63179,-18.64915 34.58541,-15.08878 5.08623,-19.66633 24.24388,-21.19218 24.24388,-21.19218 0,0 -1.86484,-21.70066 22.71782,-26.4477 0.67818,-14.74979 15.59747,-26.95637 15.59747,-26.95637 0,0 -3.05169,-22.88732 12.54577,-28.14305 -9.49408,-18.14048 3.22119,-31.36461 3.05169,-31.7036 -0.1695,-0.33899 -16.10595,-28.65192 -1.86503,-36.78945 -15.08878,-12.71528 -10.17206,-27.12593 -10.17206,-27.12593 0,0 -16.44513,-4.23859 -10.51143,-23.9048 -13.56294,-2.37343 -16.27545,-24.24373 -16.27545,-24.24373 0,0 -20.85318,4.23831 -23.39619,-13.90209 -13.73244,2.20413 -15.25829,-11.35889 -15.42778,-11.35889 -0.1695,0 -27.29557,7.29005 -32.72077,-13.22393 -10.51106,5.42533 -15.08879,-4.238455 -15.08879,-4.238455 0,0 -15.08879,7.459663 -24.07418,-6.950964 -17.9708,11.189419 -27.97355,-0.508699 -27.97355,-0.508699 0,0 -23.56569,15.597348 -31.36442,3.560296 -13.90213,14.071702 -26.27819,7.968364 -26.27819,7.968364 0,0 -10.51132,18.648948 -27.46502,13.901928 -3.89937,17.29277 -23.3961,17.63186 -23.3961,17.63186 0,0 2.03443,15.25841 -21.36167,19.32726 -3.05166,17.97078 -15.25832,21.02252 -15.25832,21.02252 0,0 1.18674,17.46223 -9.83316,23.05701 3.89936,9.83336 -6.27287,21.87026 -6.27287,21.87026 0,0 10.85037,13.56293 -3.89935,28.82141 14.24112,3.72968 3.89935,28.31272 3.89935,28.31272 0,0 19.66631,8.81591 7.29011,25.09135 14.07156,4.57755 9.66359,15.76715 9.83315,22.37904 8.98545,4.06866 16.9537,2.03432 13.05435,20.1748 27.6345,3.0517 14.58016,18.30999 14.58016,18.30999 0,0 12.88483,0.50867 7.79872,10.68093 23.56565,-0.5085 26.95637,17.63179 26.95637,17.63179 0,0 21.87032,-5.7644 24.7524,2.71251 2.88214,8.47692 -9.49405,65.61086 -9.49405,65.61086 0,0 -18.47953,0 -32.21204,-14.7496 -32.21203,-0.84767 -25.09149,-22.04004 -25.60009,-22.04004 -0.5086,0 -10.68084,3.89937 -15.93648,-13.73243 -21.5312,4.40805 -20.85307,-13.73224 -21.0226,-13.90193 -0.16953,-0.1695 -9.66358,-4.40804 -6.10333,-13.39345 -22.20934,2.03415 -20.51398,-19.66632 -20.51398,-19.66632 -4.86006,-1.97802 -6.66845,-6.49888 -5.93379,-11.01992 -2.88212,-1.01736 -22.54842,-1.35635 -12.3762,-27.29537 -18.81862,-11.35911 -7.12056,-24.41336 -7.12056,-24.41336 0,0 -25.93915,-13.39344 -5.9338,-28.82141 -14.91924,-22.03986 1.18676,-33.05959 1.18676,-33.05959 0,0 -20.68351,-21.02267 0.33909,-35.94194 -3.39074,-31.87287 15.59741,-39.50199 15.59741,-39.50199 0,0 -10.00268,-25.93931 17.12324,-36.78964 1.69536,-26.278245 20.68351,-26.956402 20.68351,-26.956402 0,0 0.5086,-20.853066 30.34712,-18.818577 5.76424,-18.648947 26.10869,-14.919173 26.10869,-14.919173 0,0 6.27289,-22.548468 33.90742,-11.698137 14.07148,-27.464941 34.9247,-13.393384 34.9247,-13.393384 0,0 13.22375,-8.646532 19.83582,-5.933874 8.39584,-14.428497 26.26988,-0.559337 37.82654,2.23289 4.18844,-1.628821 19.13791,-12.913767 30.66633,1.327406 15.25847,-10.002714 28.31272,7.968209 28.31272,7.968209 0,0 21.02249,-10.680583 30.85575,13.732627 44.58818,-4.068997 38.1458,25.091366 38.1458,25.091366 0,0 35.0941,-7.968209 27.46506,26.956399 31.87291,2.20396 28.65172,23.22664 28.65172,23.22664 0,0 20.17481,15.25811 11.35892,28.99074 17.97098,0.84778 11.35891,18.14056 11.35891,18.14056 0,0 13.73263,5.25569 2.37351,26.61721 26.27821,21.02248 5.08623,41.87586 4.91673,41.70616 -0.16969,-0.16949 14.07162,16.95363 1.18666,36.61996 3.89938,31.19493 -11.86759,39.16296 -11.86759,39.16296 0,0 4.06887,20.17501 -13.56294,25.93922 -0.33899,23.73519 -22.71802,26.61738 -22.71802,26.61738 0,0 5.93389,10.31001 -16.27544,21.16045 -0.87593,15.88188 -24.07437,17.15485 -24.07437,17.15485 0,0 -2.20384,29.1602 -31.70343,21.36167 -7.15963,23.39658 -41.70597,16.44513 -42.38415,16.10614 -0.67817,-0.33918 -6.61187,-50.18288 -6.61187,-50.35258 z'/%3E %3Cpath d='m599.01,420.07s-2.6164,5.0315,7.8492,9.4592'/%3E %3Cpath d='m619.94,408.19s11.673-2.8176,19.522,0'/%3E %3Cpath d='m654.76,378.81c0,0.20143-1.61,5.2329,7.648,12.478'/%3E %3Cpath d='m661.4,365.73s6.8427,5.0315,18.315,4.8302'/%3E %3Cpath d='m592.37,380.42s0.40246,13.283-6.4402,19.522'/%3E %3Cpath d='m615.31,359.89s11.27,2.8176,20.529-1.8112'/%3E %3Cpath d='m687.56,340.37s2.4151,3.4214,14.893,2.8178'/%3E %3Cpath d='m638.86,332.52c0.40246,0.20122,14.692,4.8302,23.749,0.60388'/%3E %3Cpath d='m667.43,277.77s0.60368-0.8051,5.0315,14.692'/%3E %3Cpath d='m678.5,234.1s-0.60388,8.2515-7.2454,11.874'/%3E %3Cpath d='m720.97,200.29s-9.6605,7.849-7.849,11.069'/%3E %3Cpath d='m672.87,194.65s5.0315,8.4528-3.22,14.289'/%3E %3Cpath d='m648.52,158.43s8.6542-0.4027,12.478,7.044'/%3E %3Cpath d='m666.63,103.69c0,0.20119,1.8112,1.8112-1.61,5.2327'/%3E %3Cpath d='m604.84,104.49s4.629,7.2453,3.8239,16.101'/%3E %3Cpath d='m631.61,79.937c2.0125-0.20119,8.8554-3.2202,8.8554-3.2202'/%3E %3Cpath d='m601.82,51.157c-0.20124,0-2.6164,9.0566,1.8114,12.277'/%3E %3Cpath d='m590.75,92.415c0,9.6605,7.648,7.2452,2.4153,16.503'/%3E %3Cpath d='m572.04,84.365c-0.20123,0-12.075,9.258-12.075,10.868'/%3E %3Cpath d='m541.04,79.333s5.0315,5.0313,3.8239,11.874'/%3E %3Cpath d='m499.58,73.295c-0.20123,0.40257-4.2266,9.0566-7.0441,10.667'/%3E %3Cpath d='m462.96,73.497c0.20122,0,4.0251,8.0504-1.0063,13.887'/%3E %3Cpath d='m397.75,106.91c0.20126,0.40242,10.264,2.0125,10.264,2.0125'/%3E %3Cpath d='m372.59,130.25c0.20126-0.20136,12.277-3.8239,12.277-3.8239'/%3E %3Cpath d='m353.07,145.35c0.40253,0,8.4529,1.4089,10.465,0.40255'/%3E %3Cpath d='m347.43,152.79s2.6164,1.4089,0.40252,14.893'/%3E %3Cpath d='m308.19,117.37,4.8302,7.2453'/%3E %3Cpath d='m291.68,154.6c0-0.20134,4.8302,7.2452,11.271,8.6541'/%3E %3Cpath d='m329.72,192.44c0.20127,0,7.8491-1.6102,9.0567-2.4152'/%3E %3Cpath d='m326.3,219.81c0.20127,0-0.20125-5.0315,6.0378-8.4529'/%3E %3Cpath d='m318.05,232.29c0,0.20124,5.8365,7.4466,9.8617,8.4529'/%3E %3Cpath d='m314.63,246.18c0.60377-0.20143,6.8428-5.6356,14.088-5.2329'/%3E %3Cpath d='m312.61,264.89s0.20125,6.2392,18.717,4.6292'/%3E %3Cpath d='m314.43,286.83c0-0.20122,5.434-12.478,16.503-17.107'/%3E %3Cpath d='m329.32,302.53s1.6101-5.2329,10.868-8.8554'/%3E %3Cpath d='m339.58,323.26s6.6416-5.4339,9.0567-6.2388'/%3E %3Cpath d='m347.84,339.36s4.0252,4.2264,14.088-3.019'/%3E %3Cpath d='m299.33,342.78c1.2076-0.20123,15.899-3.6225,20.931,4.0253'/%3E %3Cpath d='m305.17,354.86s15.497-2.0127,17.51-0.40246'/%3E %3Cpath d='m360.51,358.08s-2.0126,4.2266,17.107-2.8176'/%3E %3Cpath d='m384.26,365.73c-3.4214,5.8364,0.80503,10.465-3.6227,13.082'/%3E %3Cpath d='m326.1,373.78c0.60378-0.40226,7.0441-2.6162,6.0378-11.874'/%3E %3Cpath d='m331.94,387.66c0.80505-0.20122,11.472-4.8302,13.686-2.4151'/%3E %3Cpath d='m352.87,401.15s1.4088-9.4592,4.4277-10.465'/%3E %3Cpath d='m368.97,415.44s8.8554-0.20122,12.679-3.0188'/%3E %3Cpath d='m386.07,383.44c0.20127,0.20123,8.2517,4.4276,25.359,0.20123'/%3E %3Cpath d='m392.51,421.88s2.4151,12.277,2.2139,15.094'/%3E %3Cpath d='m632.21,133.87,6.6417-0.00015'/%3E %3Cpath d='m526.35,75.308s-2.6163,7.6477-6.0376,9.6604'/%3E %3Cpath d='m454.5,31.836c0.20122,0.20119,0.80511,6.2389-3.0188,11.472'/%3E %3Cpath d='m418.28,45.522c0,0.20134,1.6101,6.8431-9.0566,9.0568'/%3E %3C/g%3E %3Cg%3E %3Cg fill='%23f7df73' stroke='%23000' stroke-linejoin='round' fill-rule='evenodd'%3E %3Cpath d='m561.72,423.68s100.53-28.397,130.89-151.78c-17.626,126.65-127.63,166.79-127.63,166.79l-3.264-15.015z' stroke-width='2.4186'/%3E %3Cpath d='m429.95,421.01s-99.612-28.908-129.69-154.51c17.464,128.92,126.46,169.79,126.46,169.79l3.234-15.285z' stroke-width='2.429'/%3E %3C/g%3E %3Cg fill='%238c1800'%3E %3Cpath d='m572.03,431.37c3.1074,0,10.794-8.5048,15.21-9.486,4.416-0.98118,4.9065-5.3974-0.1635-5.5607-5.07-0.1635-9.4858,5.7242-9.4858,5.7242s-4.416,3.7618-8.9953,4.2525c-4.5795,0.49068-1.6356,6.2146,3.4344,5.07z'/%3E %3Cpath d='m593.45,415.67s-3.1076-1.1449,4.9065-4.2523c8.0139-3.1074,7.5232-6.7055,10.14-8.1776,2.6167-1.4719,8.1774-5.3972,9.3223-3.1074,1.1449,2.2897-5.8878,6.8692-7.5232,7.3599-1.6356,0.49069-9.6496,7.8504-11.939,8.5046-2.2897,0.65418-3.9253,0.32719-4.9065-0.32719z'/%3E %3Cpath d='m419.74,428.84c-3.079,0-10.695-8.6576-15.071-9.6565-4.3755-0.99882-4.8615-5.4944,0.162-5.6606,5.0235-0.16644,9.3988,5.827,9.3988,5.827s4.3755,3.8294,8.9128,4.3289c4.5375,0.49951,1.6206,6.3264-3.4029,5.1611z'/%3E %3Cpath d='m398.51,412.86s3.0791-1.1654-4.8615-4.3287c-7.9405-3.1633-7.4543-6.8261-10.047-8.3246-2.5928-1.4983-8.1024-5.4942-9.2368-3.1633s5.8339,6.9927,7.4543,7.4922c1.6206,0.4995,9.5612,7.9915,11.83,8.6574,2.2688,0.66595,3.8893,0.33307,4.8615-0.33307z'/%3E %3Cpath stroke='%238c1800' stroke-width='2.4186' d='m629.92,388.19s-10.467,6.0511-8.9953,7.5232c1.4721,1.4721,10.794-5.7242,10.958-5.8876,0.1635-0.16369,3.9253-4.743-1.9626-1.6356z'/%3E %3Cpath stroke='%238c1800' stroke-width='2.429' d='m362.37,384.89s10.371,6.1599,8.9128,7.6584c-1.4586,1.4985-10.695-5.827-10.857-5.9935-0.162-0.16663-3.8893-4.8282,1.9446-1.665z'/%3E %3C/g%3E %3Cg fill='none' stroke='%238c1800' stroke-linecap='round'%3E %3Cpath stroke-width='3.14418' d='m645.46,372.82c-6.869,7.6869-6.869,7.5234-6.869,7.5234'/%3E %3Cpath stroke-width='2.90232' d='m655.76,360.23-6.542,8.0141'/%3E %3Cpath stroke-width='2.66046' d='m666.07,343.87-7.3599,11.776'/%3E %3Cpath stroke-width='2.4186' d='m674.74,327.19-6.0513,12.103'/%3E %3Cpath stroke-width='2.4186' d='m678.66,318.36-1.9626,4.2523'/%3E %3Cpath stroke-width='1.45116' d='m683.08,306.75-1.6356,5.07'/%3E %3Cpath stroke-width='3.15775' d='m346.98,369.24c6.8061,7.8251,6.8061,7.6586,6.8061,7.6586'/%3E %3Cpath stroke-width='2.914845' d='m336.77,356.42,6.4821,8.1582'/%3E %3Cpath stroke-width='2.67194' d='m326.56,339.77,7.2925,11.987'/%3E %3Cpath stroke-width='2.429' d='m317.97,322.79,5.9959,12.32'/%3E %3Cpath stroke-width='2.429' d='m314.08,313.8,1.9446,4.3287'/%3E %3Cpath stroke-width='1.4574' d='m309.71,301.98,1.6206,5.1611'/%3E %3C/g%3E %3C/g%3E %3Cg%3E %3Cg fill='%23217900' stroke='%23000' stroke-width='1.93488133' stroke-linejoin='round'%3E %3Cpath d='m343.56,115.74c0.0863,0,7.4767,6.4097,6.0965,16.07-1.38,9.6605-6.9591,23.09-5.8378,33.095,0.68549,4.011,0.42592,11.198,0.42592,11.198s-6.6997-9.5198-6.786-19.698,7.2549-19.842,7.2549-27.346c0-7.5041-1.3261-13.492-1.1535-13.319z'/%3E %3Cpath d='m339.9,118.62s-9.6981,9.258-10.947,18.255c-0.92216,4.6376-1.2801,26.247-1.3891,35.839-0.21797,2.9426-1.4376,14.558-1.6965,18.785-0.25868,4.2264,7.1339-7.2146,7.5566-16.53-0.23134-9.6425-0.23191-29.953,0.74897-33.005,0.87192-3.9237,0.68199-8.2587,2.0308-12.194,1.7845-5.4608,3.7826-11.064,3.6963-11.15z'/%3E %3C/g%3E %3Cg fill='none' stroke='%236b18b5' stroke-linejoin='round'%3E %3Cpath stroke-width='1.9349' d='m276.41,180.31s6.574,9.1024,7.7539,14.328c1.18,5.2254,3.3713,15.508,6.2368,19.722,2.8656,4.214,19.216,27.644,20.059,37.421,0.16855,6.4052-6.7425,17.362-17.025,17.53-6.4054-0.16833-22.924-4.3823-23.599-18.542-0.67426-14.159,5.0569-14.497,5.7311-23.093,0.67425-8.5967,0.84282-47.197,0.84282-47.366z'/%3E %3Cpath d='m389.35,56.361s-6.8061,0.48536-12.046,3.326c-4.0599,2.5035-10.937,6.1054-15.743,12.769-12.223,9.5289-30.612,13.975-36.412,21.891-3.4716,5.3855-3.2583,18.338,5.4402,23.823,5.5606,3.1839,21.865,8.1648,29.797-3.5835,7.9319-11.748,3.21-15.014,7.0999-22.71,6.4183-17.641,21.776-35.372,21.864-35.517z'/%3E %3Cpath d='m554.44,39.166s-5.0831-4.5518-10.769-6.3401c-4.6226-1.1752-12.322-0.66401-20.288-1.4458-15.348-2.1526-31.171-13.253-40.892-11.912-6.2839,1.2523-15.441,10.416-13.331,20.481,1.5808,6.2095,8.5255,18.768,22.483,16.294,13.958-2.4741,13.837-5.5188,22.072-8.0777,20.085-11.262,40.56-8.9616,40.724-8.9991z'/%3E %3Cpath d='m718.18,198.3c1.1458-2.6191-0.96454-7.5419-2.4637-13.311-1.4552-4.5424-3.6275-11.592-8.9417-17.858-6.3145-14.154-5.2323-33.564-11.524-41.094-4.3941-4.6633-17.019-7.5668-24.433-0.44034-4.4262,4.6333-13.177,19.264-3.6774,29.785,9.4995,10.521,13.64,6.558,20.176,12.182,15.583,10.467,23.215,28.816,30.863,30.736z'/%3E %3Cpath d='m712.59,321.94c2.128-2.9464,5.9383-8.6249,5.4852-13.354-0.35873-3.7457,1.7166-15.101,1.9434-20.055,1.4084-15.434,11.069-27.962,8.4423-41.372-1.5543-6.216-10.658-15.083-20.61-12.489-6.126,1.879-19.765,9.3842-16.62,23.206,3.1459,13.822,7.6118,13.593,10.566,21.694,8.4798,16.748,3.054,36.642,10.793,42.37z'/%3E %3C/g%3E %3Cg fill='%236b18b5'%3E %3Cpath d='m491.8,26.96c0.00082-2.1778-2.449-3.9435-5.4712-3.9435s-5.472,1.7657-5.4712,3.9435c-0.00082,2.1778,2.449,3.9435,5.4712,3.9435s5.472-1.7657,5.4712-3.9435z'/%3E %3Cpath d='m494.14,36.133c0-2.0885-2.5216-3.7816-5.6321-3.7816s-5.6321,1.6931-5.6321,3.7816,2.5216,3.7816,5.6321,3.7816,5.6321-1.6931,5.6321-3.7816z'/%3E %3Cpath d='m501.14,25.271s-6.4368,4.8276-3.7815,6.7586c2.655,1.931,9.9768-4.1838,9.9768-4.1838l-6.1953-2.5748z'/%3E %3Cpath d='m690.31,135.8c0.002-1.3724-0.6414-2.6413-1.687-3.3281-1.0455-0.68677-2.3342-0.68677-3.3798,0-1.0456,0.68678-1.6888,1.9558-1.687,3.3281-0.002,1.3723,0.6414,2.6413,1.687,3.3281,1.0456,0.68677,2.3342,0.68677,3.3798,0s1.6888-1.9558,1.687-3.3281z'/%3E %3Cpath d='m687.86,126.59c0-2.2888-1.5806-4.1443-3.5303-4.1443-1.9498,0-3.5303,1.8554-3.5303,4.1443,0,2.2888,1.5806,4.1443,3.5303,4.1443s3.5303-1.8555,3.5303-4.1443z'/%3E %3Cpath d='m689.55,145.32c0-1.1868-0.61848-2.1489-1.3814-2.1489-0.76294,0-1.3814,0.9621-1.3814,2.1489s0.61849,2.1489,1.3814,2.1489c0.76295,0,1.3814-0.96211,1.3814-2.1489z'/%3E %3Cpath d='m695.23,128.59c0-1.3564-0.61849-2.456-1.3814-2.456-0.76295,0-1.3814,1.0996-1.3814,2.456s0.61848,2.456,1.3814,2.456c0.76294,0,1.3814-1.0996,1.3814-2.456z'/%3E %3Cpath d='m679.72,130.28c0-1.102-0.61849-1.9954-1.3814-1.9954-0.76295,0-1.3814,0.89336-1.3814,1.9954s0.61848,1.9954,1.3814,1.9954c0.76294,0,1.3814-0.89335,1.3814-1.9954z'/%3E %3Cpath d='m682.18,143.48c0.00057-1.7807-1.3053-3.2246-2.9163-3.2246-1.6111,0-2.9169,1.4439-2.9163,3.2246-0.00058,1.7807,1.3053,3.2246,2.9163,3.2246,1.6111,0,2.9169-1.4439,2.9163-3.2246z'/%3E %3Cpath d='m674.5,137.64c0-1.5259-1.0995-2.7628-2.4559-2.7628-1.3563,0-2.4559,1.237-2.4559,2.7628,0,1.5259,1.0995,2.7628,2.4559,2.7628s2.4559-1.237,2.4559-2.7628z'/%3E %3Cpath d='m673.28,129.82c0.001-0.82331-0.40833-1.5846-1.0736-1.9965-0.6653-0.41197-1.4853-0.41197-2.1506,0-0.66529,0.41198-1.0746,1.1732-1.0736,1.9965-0.001,0.82331,0.40831,1.5846,1.0736,1.9965,0.66531,0.41198,1.4853,0.41198,2.1506,0,0.66529-0.41197,1.0746-1.1732,1.0736-1.9965z'/%3E %3Cpath d='m708.27,169.62c-3.1705-4.1843-8.2462-5.9474-11.337-3.9381-3.0907,2.0094-3.0261,7.0303,0.14438,11.215,3.1705,4.1843,8.2462,5.9474,11.337,3.9381,3.0907-2.0094,3.0261-7.0303-0.1444-11.215z'/%3E %3Cpath d='m717.28,246.81c0.61438-5.1345-1.8899-9.656-5.5934-10.099-3.7035-0.44315-7.2039,3.3599-7.8183,8.4944-0.61437,5.1345,1.8899,9.656,5.5934,10.099,3.7036,0.44316,7.2039-3.3599,7.8183-8.4944z'/%3E %3Cpath d='m719.18,291.75c1.0554-5.0622-1.049-9.7831-4.7005-10.544-3.6514-0.76131-7.4671,2.7253-8.5226,7.7875-1.0554,5.0622,1.049,9.7832,4.7004,10.544,3.6514,0.76132,7.4672-2.7253,8.5226-7.7875z'/%3E %3Cpath d='m727.84,249.69c0-2.0345-1.3744-3.6838-3.0699-3.6838-1.6954,0-3.0699,1.6493-3.0699,3.6838s1.3744,3.6839,3.0699,3.6839c1.6954,0,3.0699-1.6493,3.0699-3.6839z'/%3E %3Cpath d='m720.32,258.13-6.2932,7.1374s-5.9093,0.15343-5.6024,2.0721c0.30705,1.9186,8.1352,7.6747,8.0584,9.977-0.0768,2.3025,5.2188-0.53712,5.2188-0.53712s4.2209-12.817,4.2209-12.893c0-0.0768-0.23025-8.9028-2.5326-8.7491-2.3025,0.15343-2.9263,2.8303-3.0699,2.9933z'/%3E %3Cpath d='m306.38,255.31c0-1.6541-1.341-2.9951-2.9951-2.9951-1.6542,0-2.9952,1.3409-2.9952,2.9951,0,1.6541,1.341,2.9951,2.9952,2.9951s2.9951-1.3409,2.9951-2.9951z'/%3E %3Cpath d='m309.21,246.16c0-1.7461-1.341-3.1616-2.9951-3.1616-1.6542,0-2.9951,1.4155-2.9951,3.1616s1.341,3.1616,2.9951,3.1616c1.6542,0,2.9951-1.4155,2.9951-3.1616z'/%3E %3Cpath d='m284.61,202.63c-1.1233-2.5177-3.4627-3.9213-5.2251-3.135-1.7624,0.78632-2.2805,3.4648-1.1572,5.9825s3.4627,3.9213,5.2251,3.135c1.7624-0.78632,2.2805-3.4648,1.1572-5.9825z'/%3E %3Cpath d='m292.04,229.75c-1.5431-3.2632-4.7567-5.0823-7.1777-4.0632s-3.1327,4.4906-1.5896,7.7538,4.7567,5.0823,7.1777,4.0632,3.1327-4.4906,1.5896-7.7538z'/%3E %3Cpath d='m299.99,249.63c0.49995-4.0758-1.1889-7.8199-3.7722-8.3627-2.5833-0.54278-5.0828,2.3213-5.5827,6.3971-0.49995,4.0758,1.1889,7.8199,3.7722,8.3627,2.5833,0.54278,5.0828-2.3213,5.5827-6.3971z'/%3E %3Cpath d='m287.23,252.54c1.5978-3.7828,0.99957-7.8464-1.3361-9.0763s-5.5243,0.83956-7.1221,4.6223c-1.5978,3.7828-0.99957,7.8464,1.3361,9.0763s5.5243-0.83957,7.1221-4.6223z'/%3E %3Cpath d='m281.42,243.99c0-1.9299-1.49-3.4944-3.3279-3.4944-1.838,0-3.3279,1.5645-3.3279,3.4944s1.49,3.4945,3.3279,3.4945c1.838,0,3.3279-1.5645,3.3279-3.4945z'/%3E %3Cpath d='m278.76,235.34c0-1.7461-1.341-3.1616-2.9952-3.1616s-2.9951,1.4155-2.9951,3.1616,1.341,3.1616,2.9951,3.1616c1.6542,0,2.9952-1.4155,2.9952-3.1616z'/%3E %3Cpath d='m281.58,218.7c0-2.9408-1.3037-5.3248-2.912-5.3248-1.6082,0-2.9119,2.384-2.9119,5.3248s1.3037,5.3248,2.9119,5.3248,2.912-2.384,2.912-5.3248z'/%3E %3Cpath d='m290.54,217.42c0.38801-2.9151-0.58979-5.4502-2.184-5.6624-1.5942-0.21218-3.201,1.979-3.589,4.8941-0.38799,2.9151,0.5898,5.4502,2.184,5.6624,1.5942,0.21218,3.201-1.979,3.589-4.8941z'/%3E %3Cpath d='m354.39,90.042c1.1868-4.1283-0.0372-8.2775-2.7339-9.2673-2.6967-0.98984-5.845,1.5544-7.0318,5.6828-1.1868,4.1283,0.0372,8.2775,2.7339,9.2673,2.6967,0.98984,5.845-1.5544,7.0318-5.6828z'/%3E %3Cpath d='m342.27,108.42c3.5565-3.0269,5.0759-7.2124,3.3936-9.3486-1.6823-2.1361-5.9293-1.414-9.4858,1.6129s-5.0759,7.2124-3.3936,9.3486,5.9293,1.414,9.4858-1.6129z'/%3E %3Cpath d='m335.19,98.217c3.517-2.5985,5.0195-6.1916,3.3559-8.0255-1.6636-1.8338-5.8634-1.2139-9.3805,1.3846-3.517,2.5985-5.0195,6.1916-3.3559,8.0255,1.6636,1.8338,5.8634,1.2139,9.3805-1.3846z'/%3E %3Cpath d='m362.46,80.281c2.3718-1.8131,3.385-4.3202,2.2631-5.5997s-3.9541-0.84699-6.3258,0.96612c-2.3718,1.8131-3.385,4.3202-2.2631,5.5997s3.954,0.84699,6.3258-0.96612z'/%3E %3Cpath d='m348.25,97.659c1.6219-2.5064,1.7308-5.2083,0.24334-6.0348-1.4875-0.82655-4.0082,0.53523-5.6301,3.0416s-1.7308,5.2083-0.24334,6.0348c1.4875,0.82655,4.0082-0.53523,5.6301-3.0416z'/%3E %3Cpath d='m368.76,86.92c2.5506-2.1495,3.5444-4.9969,2.2197-6.3598s-4.4663-0.72518-7.017,1.4244c-2.5506,2.1495-3.5444,4.9969-2.2197,6.3598s4.4663,0.72518,7.017-1.4244z'/%3E %3Cpath d='m331.69,111.97c2.3843-0.11899,4.1842-1.3067,4.02-2.6528-0.16412-1.3461-2.23-2.3409-4.6144-2.2219-2.3843,0.11898-4.1841,1.3067-4.02,2.6528,0.16411,1.3461,2.23,2.3409,4.6143,2.222z'/%3E %3Cpath d='m376.57,73.606c1.6219-2.5064,1.7308-5.2083,0.24334-6.0348-1.4875-0.82655-4.0082,0.53523-5.6301,3.0416s-1.7308,5.2083-0.24334,6.0348c1.4875,0.82655,4.0082-0.53523,5.6301-3.0416z'/%3E %3C/g%3E %3Cg fill='%23ffd200' stroke='%23ef8a10' stroke-width='1.93488133'%3E %3Cpath d='m553.24,88.375s12.574-5.8004,16.169-16.603c3.5942-10.802-10.882-10.906-12.795-7.4727-1.9124,3.4337,1.6313,11.983,0.71862,14.243-0.91288,2.26-6.0283,7.7162-4.0925,9.8326z'/%3E %3Cpath stroke-width='2.4186' d='m441.8,92.316s8.1629-11.186,6.0466-22.372c-2.1164-11.186-14.814-4.2327-14.814-0.30232s7.2558,9.6746,7.5582,12.093c0.30223,2.4186-1.5117,9.6744,1.2093,10.581z'/%3E %3Cpath stroke-width='2.4186' d='m419.73,98.967s8.1629-11.186,6.0465-22.372-14.814-4.2327-14.814-0.30232,7.2558,9.6746,7.5582,12.093c0.30223,2.4186-1.5117,9.6744,1.2093,10.581z'/%3E %3Cpath stroke-width='2.4186' d='m395.24,106.53s8.1629-11.186,6.0466-22.372c-2.1164-11.186-14.814-4.2327-14.814-0.30232s7.2558,9.6746,7.5582,12.093c0.30223,2.4186-1.5117,9.6744,1.2093,10.581z'/%3E %3Cpath stroke-width='2.4186' d='m378.01,123.76s8.1629-11.186,6.0465-22.372-14.814-4.2327-14.814-0.30232,7.2558,9.6746,7.5582,12.093c0.30223,2.4186-1.5117,9.6744,1.2093,10.581z'/%3E %3Cpath stroke-width='2.4186' d='m359.87,140.39s8.1629-11.186,6.0465-22.372-14.814-4.2327-14.814-0.30232,7.2558,9.6746,7.5582,12.093c0.30223,2.4186-1.5117,9.6744,1.2093,10.581z'/%3E %3Cpath d='m401.57,43.519s-10.87,8.5789-11.84,19.922c-0.9698,11.343,13.13,8.0606,14.187,4.2751,1.057-3.7856-4.3868-11.269-4.0276-13.68,0.35932-2.4108,4.0577-8.9115,1.6809-10.517z'/%3E %3Cpath d='m437.85,32.333s-10.87,8.5789-11.84,19.922c-0.96981,11.343,13.13,8.0606,14.187,4.2751,1.057-3.7856-4.3868-11.269-4.0276-13.68,0.35933-2.4108,4.0577-8.9115,1.6809-10.517z'/%3E %3Cpath d='m302.66,130.27s2.2963,13.656,11.776,19.96c9.48,6.3037,13.38-7.6378,10.569-10.385-2.8112-2.7468-11.991-1.5714-13.932-3.0453-1.9412-1.4741-5.8632-7.8423-8.4136-6.53z'/%3E %3Cpath d='m284.54,176.64s0.11238,13.847,8.4788,21.568c8.3664,7.7207,14.418-5.4306,12.076-8.5865-2.3425-3.156-11.592-3.444-13.277-5.2058-1.6842-1.762-4.5521-8.6694-7.2776-7.7759z'/%3E %3Cpath d='m326.34,228.44s-4.9424-12.936-15.479-17.248c-10.536-4.3119-11.613,10.125-8.3155,12.264,3.2974,2.1388,12.065-0.82252,14.259,0.24011,2.1936,1.0626,7.2936,6.5329,9.5354,4.744z'/%3E %3Cpath d='m317.66,206.05s8.3793-11.025,6.481-22.25-14.729-4.5203-14.805-0.59063c-0.0764,3.9296,7.0662,9.8139,7.3214,12.238,0.25509,2.424-1.6996,9.643,1.003,10.603z'/%3E %3Cpath d='m578.94,99.561s12.574-5.8004,16.169-16.603c3.5942-10.802-10.882-10.906-12.795-7.4727-1.9124,3.4337,1.6313,11.983,0.71862,14.243-0.91288,2.26-6.0283,7.7162-4.0925,9.8326z'/%3E %3Cpath d='m616.97,118.53s7.3965-11.707,4.5367-22.726-15.064-3.2326-14.801,0.68905c0.26295,3.9215,7.8866,9.1676,8.3502,11.561,0.46321,2.393-0.86141,9.7539,1.9142,10.477z'/%3E %3Cpath d='m720.74,226.27s-4.9601-12.929-15.502-17.226c-10.542-4.2976-11.599,10.141-8.2989,12.275,3.3005,2.1342,12.064-0.83896,14.259,0.22038,2.1951,1.0597,7.3024,6.5233,9.5419,4.7308z'/%3E %3Cpath d='m670,234.3s0.28772-13.845,8.7511-21.459c8.4636-7.6145,14.348,5.6121,11.966,8.7385-2.3824,3.126-11.635,3.2968-13.342,5.0373-1.7064,1.7406-4.6611,8.6112-7.3754,7.6832z'/%3E %3Cpath d='m661.83,87.484s-12.945-4.9172-23.175,0.07937c-10.23,4.9968-0.16872,15.406,3.6223,14.367,3.7906-1.0386,7.4135-9.5536,9.6665-10.485,2.253-0.93052,9.7301-1.0977,9.8859-3.962z'/%3E %3Cpath d='m632.21,62.693s-12.945-4.9172-23.175,0.07937c-10.23,4.9968-0.16872,15.406,3.6223,14.367,3.7906-1.0385,7.4135-9.5537,9.6665-10.485,2.253-0.93052,9.7301-1.0977,9.8859-3.962z'/%3E %3Cpath d='m588.02,39.053s-10.975,8.4448-12.084,19.775c-1.1087,11.331,13.03,8.2212,14.133,4.4487,1.1033-3.7723-4.248-11.322-3.8595-13.729,0.38891-2.4064,4.167-8.861,1.8097-10.495z'/%3E %3Cpath d='m559.27,32.131s-5.0048,12.912-0.0772,23.175,15.404,0.27293,14.391-3.525c-1.0127-3.7976-9.5034-7.4779-10.419-9.7372-0.9154-2.2592-1.0321-9.7372-3.8953-9.9123z'/%3E %3Cpath d='m477.66,81.887s8.9517-10.565,7.6509-21.875c-1.3006-11.31-14.468-5.295-14.753-1.3747-0.28481,3.92,6.5356,10.174,6.6622,12.609,0.12635,2.4343-2.2087,9.5394,0.4398,10.641z'/%3E %3C/g%3E %3Cg fill='%23de2010' stroke='%23000' stroke-width='2.38277'%3E %3Cpath d='m701.62,233.11c-0.50236-4.0492-2.4537-7.607-5.117-9.3315-2.6632-1.7245-5.6335-1.3532-7.7903,0.97376s-3.172,6.2556-2.6626,10.304c0.50235,4.0492,2.4537,7.607,5.117,9.3315,2.6632,1.7245,5.6335,1.3532,7.7902-0.97377,2.1568-2.327,3.172-6.2556,2.6626-10.304z'/%3E %3Cpath d='m699.95,212.66c-0.50236-4.0492-2.4537-7.607-5.117-9.3315-2.6632-1.7245-5.6335-1.3532-7.7903,0.97377s-3.172,6.2556-2.6626,10.304c0.50235,4.0492,2.4537,7.607,5.117,9.3315,2.6632,1.7245,5.6335,1.3532,7.7902-0.97377,2.1568-2.327,3.172-6.2556,2.6626-10.304z'/%3E %3Cpath d='m695.8,190.82c-0.85624-3.9894-3.1127-7.362-5.9172-8.8458s-5.7306-0.85294-7.6745,1.6546c-1.944,2.5076-2.61,6.5102-1.7468,10.498,0.85624,3.9894,3.1127,7.362,5.9172,8.8458s5.7306,0.85294,7.6746-1.6546c1.944-2.5076,2.61-6.5102,1.7468-10.498z'/%3E %3Cpath d='m688.23,168c-1.8449-3.6393-4.8866-6.3252-7.9767-7.0451-3.0901-0.71985-5.7587,0.63609-6.9992,3.5563-1.2405,2.9203-0.86415,6.9604,0.98712,10.597,1.8449,3.6393,4.8866,6.3252,7.9767,7.0451,3.09,0.71985,5.7587-0.6361,6.9992-3.5563,1.2405-2.9203,0.86415-6.9604-0.98712-10.597z'/%3E %3Cpath d='m680.14,149.69c-1.8449-3.6393-4.8866-6.3252-7.9767-7.0451-3.0901-0.71985-5.7587,0.63609-6.9992,3.5563-1.2405,2.9203-0.86415,6.9604,0.98712,10.597,1.8449,3.6393,4.8866,6.3252,7.9767,7.0451,3.09,0.71985,5.7587-0.6361,6.9992-3.5563,1.2405-2.9203,0.86415-6.9604-0.98712-10.597z'/%3E %3Cpath d='m668.64,131.28c-2.1465-3.47-5.4047-5.8887-8.5446-6.3443s-5.6841,1.1215-6.6729,4.1363c-0.98876,3.0148-0.27162,7.0086,1.8809,10.475,2.1465,3.47,5.4047,5.8887,8.5446,6.3443,3.1399,0.45559,5.6841-1.1215,6.6729-4.1363,0.98877-3.0148,0.27162-7.0086-1.8809-10.475z'/%3E %3Cpath d='m655.85,113.54c-2.4719-3.2462-5.9486-5.3386-9.1179-5.4885-3.1692-0.14991-5.5491,1.6657-6.2418,4.762-0.69268,3.0963,0.40721,7.002,2.8848,10.244,2.4719,3.2462,5.9486,5.3386,9.1179,5.4885,3.1693,0.14991,5.5491-1.6657,6.2418-4.762,0.69268-3.0963-0.40721-7.002-2.8848-10.244z'/%3E %3Cpath d='m640.59,96.996c-2.9164-2.8536-6.6597-4.4199-9.8172-4.1088-3.1575,0.31109-5.249,2.4525-5.4856,5.6165-0.23652,3.164,1.4179,6.8691,4.3393,9.7176,2.9164,2.8536,6.6597,4.4199,9.8172,4.1088,3.1575-0.31109,5.249-2.4525,5.4855-5.6165,0.23652-3.164-1.4179-6.8691-4.3393-9.7176z'/%3E %3Cpath d='m623.41,81.776c-3.1665-2.5733-7.038-3.7886-10.154-3.1884-3.1155,0.60021-5.0012,2.925-4.9457,6.0973s2.0438,6.7095,5.2147,9.2772c3.1665,2.5733,7.038,3.7886,10.154,3.1884,3.1155-0.60021,5.0012-2.925,4.9457-6.0973s-2.0438-6.7095-5.2147-9.2772z'/%3E %3Cpath d='m605.21,69.628c-3.5497-2.0119-7.5693-2.5676-10.542-1.4585-2.9726,1.1091-4.4462,3.7146-3.8648,6.8337s3.1293,6.2771,6.6825,8.2828c3.5497,2.0119,7.5693,2.5676,10.542,1.4585,2.9726-1.1091,4.4462-3.7146,3.8648-6.8337s-3.1293-6.2771-6.6825-8.2828z'/%3E %3Cpath d='m584.84,58.844c-3.7181-1.6805-7.7716-1.8681-10.631-0.49302-2.8594,1.375-4.0897,4.1039-3.2268,7.1571,0.86286,3.0532,3.6876,5.9663,7.4086,7.6402,3.7181,1.6805,7.7716,1.8681,10.631,0.49302,2.8594-1.375,4.0897-4.1039,3.2268-7.1571-0.86285-3.0532-3.6876-5.9663-7.4086-7.6402z'/%3E %3Cpath d='m564.86,50.799c-3.8224-1.4274-7.8794-1.3428-10.64,0.22081-2.7607,1.5636-3.8053,4.3688-2.7397,7.3573s4.0793,5.7056,7.9042,7.1263c3.8224,1.4274,7.8794,1.3428,10.64-0.22081,2.7607-1.5636,3.8053-4.3688,2.7397-7.3573s-4.0793-5.7056-7.9042-7.1263z'/%3E %3Cpath d='m544.56,44.43c-3.9202-1.1315-7.9588-0.73759-10.592,1.0322-2.6334,1.7698-3.4608,4.6465-2.1702,7.5449,1.2906,2.8985,4.5028,5.3777,8.425,6.5023,3.9202,1.1315,7.9588,0.73759,10.592-1.0322,2.6334-1.7698,3.4608-4.6465,2.1702-7.5449-1.2906-2.8985-4.5028-5.3777-8.425-6.5023z'/%3E %3Cpath d='m522.21,40.62c-4.0477-0.51427-7.9775,0.49696-10.307,2.6512-2.3294,2.1542-2.7039,5.1241-0.98236,7.7892,1.7216,2.6651,5.2773,4.62,9.3259,5.1272,4.0477,0.51427,7.9775-0.49696,10.307-2.6512,2.3294-2.1542,2.7039-5.1241,0.98236-7.7892-1.7216-2.6651-5.2773-4.62-9.3259-5.1272z'/%3E %3Cpath d='m500.15,39.375c-4.0768-0.16747-7.9061,1.175-10.043,3.5199-2.1373,2.3449-2.2574,5.3358-0.31502,7.8446,1.9424,2.5087,5.6518,4.1535,9.7289,4.3139,4.0768,0.16747,7.9061-1.175,10.043-3.5199,2.1373-2.3449,2.2574-5.3358,0.31501-7.8446-1.9424-2.5087-5.6518-4.1535-9.7289-4.3139z'/%3E %3Cpath d='m479.94,40.089c-4.0768-0.16747-7.9061,1.175-10.043,3.5199-2.1373,2.3449-2.2574,5.3358-0.31502,7.8446,1.9424,2.5087,5.6518,4.1535,9.7289,4.3139,4.0768,0.16747,7.9061-1.175,10.043-3.5199,2.1373-2.3449,2.2574-5.3358,0.31501-7.8446-1.9424-2.5087-5.6518-4.1535-9.7289-4.3139z'/%3E %3Cpath d='m456.25,42.895c-3.9785,0.90558-7.3229,3.2036-8.7718,6.0263-1.449,2.8226-0.78191,5.7407,1.7495,7.6535s6.542,2.5291,10.519,1.6166c3.9785-0.90558,7.3228-3.2036,8.7718-6.0263,1.449-2.8226,0.78192-5.7407-1.7495-7.6535s-6.542-2.5291-10.519-1.6166z'/%3E %3Cpath d='m434.7,48.296c-3.8902,1.2306-7.0337,3.7967-8.2449,6.7292s-0.30576,5.7856,2.3748,7.4831,6.7283,1.9809,10.616,0.74352c3.8902-1.2306,7.0337-3.7967,8.2449-6.7292s0.30576-5.7856-2.3748-7.4831-6.7283-1.9809-10.616-0.74352z'/%3E %3Cpath d='m415.04,56.715c-3.7159,1.6852-6.5314,4.6075-7.3847,7.6634-0.85329,3.0559,0.38555,5.7809,3.2492,7.147,2.8637,1.3661,6.9164,1.1654,10.629-0.5263,3.7159-1.6852,6.5314-4.6075,7.3847-7.6634s-0.38555-5.7809-3.2492-7.147c-2.8637-1.3661-6.9164-1.1654-10.629,0.5263z'/%3E %3Cpath d='m395.43,66.766c-3.5586,1.9961-6.1145,5.1479-6.704,8.2654-0.58948,3.1176,0.87731,5.7269,3.8471,6.8437s6.9906,0.57113,10.546-1.4312c3.5586-1.9961,6.1145-5.1479,6.704-8.2654,0.58948-3.1176-0.87731-5.7269-3.8471-6.8437s-6.9906-0.57113-10.546,1.4312z'/%3E %3Cpath d='m376.88,79.349c-3.3206,2.371-5.5189,5.7818-5.7661,8.945-0.24721,3.1632,1.4944,5.5977,4.568,6.3851,3.0736,0.78747,7.0113-0.19191,10.328-2.5687,3.3206-2.371,5.5189-5.7818,5.7661-8.945,0.24721-3.1632-1.4944-5.5977-4.568-6.3851-3.0736-0.78747-7.0112,0.19191-10.328,2.5687z'/%3E %3Cpath d='m359.71,92.358c-3.1081,2.6435-5.0099,6.2281-4.9886,9.4008s1.9627,5.4511,5.0919,5.9757c3.1292,0.52459,6.9699-0.78445,10.073-3.4333,3.1081-2.6435,5.0099-6.2281,4.9885-9.4008-0.0213-3.1727-1.9627-5.4511-5.0918-5.9757-3.1292-0.52459-6.9699,0.78446-10.073,3.4333z'/%3E %3Cpath d='m344.56,108.19c-2.9106,2.8595-4.5504,6.5713-4.3016,9.7343,0.24877,3.163,2.3486,5.2964,5.5072,5.5952,3.1587,0.29886,6.8957-1.2822,9.8012-4.1468,2.9106-2.8595,4.5504-6.5713,4.3016-9.7343-0.24876-3.163-2.3485-5.2964-5.5072-5.5952-3.1587-0.29885-6.8957,1.2822-9.8012,4.1468z'/%3E %3Cpath d='m331.51,125.79c-2.661,3.0931-3.9844,6.9291-3.4718,10.06,0.51264,3.1311,2.7836,5.0812,5.9562,5.1146s6.7642-1.8549,9.4198-4.9526c2.661-3.0931,3.9844-6.9291,3.4718-10.06-0.51264-3.1311-2.7836-5.0812-5.9562-5.1146s-6.7642,1.8549-9.4198,4.9526z'/%3E %3Cpath d='m319.58,143.81c-2.316,3.3593-3.2227,7.3145-2.3791,10.373,0.84363,3.0586,3.3096,4.7554,6.4677,4.4503,3.1581-0.30511,6.5278-2.5657,8.8379-5.929,2.316-3.3593,3.2227-7.3145,2.3791-10.373-0.84363-3.0586-3.3096-4.7554-6.4677-4.4503-3.1581,0.30511-6.5278,2.5657-8.8379,5.929z'/%3E %3Cpath d='m309.64,164.24c-1.7045,3.7072-1.9183,7.7594-0.56184,10.628,1.3565,2.8682,4.0773,4.1162,7.136,3.2731,3.0588-0.84308,5.99-3.6489,7.688-7.359,1.7045-3.7072,1.9183-7.7594,0.56184-10.628-1.3565-2.8682-4.0773-4.1162-7.136-3.2731-3.0588,0.84308-5.99,3.6489-7.688,7.359z'/%3E %3Cpath d='m301.77,185.59c-1.3614,3.8464-1.207,7.9013,0.40393,10.635,1.6109,2.7334,4.4337,3.7296,7.4034,2.6127s5.6346-4.1769,6.9892-8.0257c1.3614-3.8464,1.207-7.9013-0.40393-10.635-1.6109-2.7334-4.4337-3.7296-7.4034-2.6127s-5.6346,4.1769-6.9892,8.0257z'/%3E %3Cpath stroke-width='2.1334' d='m294.94,226.01c-0.38059,3.2566,0.75959,6.3785,2.9894,8.1879s5.2104,2.031,7.8173,0.58131c2.607-1.4498,4.4436-4.3503,4.8171-7.6074,0.3806-3.2566-0.75959-6.3785-2.9894-8.1879s-5.2104-2.031-7.8173-0.5813c-2.607,1.4498-4.4436,4.3503-4.8171,7.6074z'/%3E %3Cpath d='m296.76,207.14c-0.91046,3.9774-0.29124,7.9877,1.6231,10.518,1.9143,2.5302,4.8328,3.1955,7.6545,1.7448,2.8218-1.4507,5.1174-4.7966,6.0209-8.7755,0.91046-3.9774,0.29123-7.9876-1.6231-10.518-1.9143-2.5302-4.8328-3.1955-7.6545-1.7448-2.8218,1.4507-5.1174,4.7966-6.0209,8.7755z'/%3E %3C/g%3E %3Cg fill='%23ffe300'%3E %3Cpath d='m685.33,197.47c2.4854-2.6607,4.7977-3.413,7.7239-2.4427-1.0319-7.0192-3.2529-9.4006-5.9587-8.5554-2.7057,0.84519-3.9303,4.4536-1.7652,10.998z'/%3E %3Cpath d='m689.13,218.66c2.6788-2.4658,5.0415-3.0416,7.8862-1.8536-0.49998-7.077-2.5355-9.6191-5.2971-8.9802-2.7617,0.6389-4.2546,4.1447-2.5891,10.834z'/%3E %3Cpath d='m680.14,178.14c1.7282-3.2047,3.7738-4.5196,6.8502-4.3242-2.7806-6.527-5.5336-8.2663-7.9361-6.7616-2.4024,1.5046-2.6703,5.3057,1.0859,11.086z'/%3E %3Cpath d='m670.71,158.86c1.7282-3.2047,3.7738-4.5196,6.8502-4.3242-2.7806-6.527-5.5336-8.2663-7.9361-6.7616-2.4024,1.5046-2.6703,5.3057,1.0859,11.086z'/%3E %3Cpath d='m648.1,123.54c1.1907-3.4408,2.9985-5.0674,6.0662-5.369-3.7935-5.9952-6.7903-7.2694-8.9196-5.3982s-1.783,5.6659,2.8534,10.767z'/%3E %3Cpath d='m633.32,108.15c1.0599-3.4833,2.8048-5.1771,5.859-5.5945-4.0174-5.8476-7.0602-7.0076-9.1172-5.0572-2.0572,1.9503-1.5676,5.7293,3.2582,10.652z'/%3E %3Cpath d='m602.26,81.935c-0.0644-3.6404,1.074-5.7893,3.8512-7.127-5.6232-4.326-8.8753-4.4925-10.231-2.0035-1.3565,2.4891,0.27302,5.9336,6.3803,9.1305z'/%3E %3Cpath d='m618.42,94.057c0.56691-3.5966,2.0602-5.5159,5.027-6.3525-4.789-5.2344-7.9632-5.9615-9.7299-3.7449-1.7671,2.2166-0.75848,5.8912,4.7029,10.097z'/%3E %3Cpath d='m583.81,71.756c-0.4396-3.6144,0.47096-5.8692,3.0952-7.4863-6.0394-3.7227-9.2915-3.5528-10.384-0.93706-1.0924,2.6158,0.88386,5.8737,7.2883,8.4234z'/%3E %3Cpath d='m564.96,63.528c-0.95234-3.5143-0.37382-5.8762,1.992-7.8522-6.5099-2.8202-9.7042-2.1866-10.411,0.55846-0.70701,2.7452,1.7153,5.6868,8.4187,7.2938z'/%3E %3Cpath d='m544.65,57.235c-1.2464-3.421-0.86992-5.8235,1.32-7.9927-6.7252-2.259-9.8544-1.3572-10.326,1.4378-0.47212,2.7952,2.1905,5.5212,9.0059,6.5549z'/%3E %3Cpath d='m524.7,53.373c-1.4906-3.3219-1.2888-5.7453,0.73855-8.0672-6.8711-1.7667-9.9267-0.64101-10.195,2.1808-0.26875,2.8221,2.584,5.3483,9.4563,5.8864z'/%3E %3Cpath d='m503.57,51.753c-1.8271-3.1494-1.8776-5.5807-0.10196-8.1003-7.0172-1.0447-9.9397,0.39174-9.9138,3.2261,0.0253,2.8347,3.1246,5.0515,10.016,4.8742z'/%3E %3Cpath d='m462.21,54.869c-2.5324-2.616-3.1674-4.9634-2.0518-7.8368-7.0621,0.67789-9.5519,2.7765-8.8436,5.521,0.70797,2.745,4.2504,4.1492,10.895,2.3157z'/%3E %3Cpath d='m482.57,52.189c-2.1551-2.9348-2.4666-5.3465-0.97229-8.0424-7.0888-0.28422-9.8398,1.4581-9.5094,4.2733,0.32989,2.8155,3.6496,4.6863,10.482,3.7691z'/%3E %3Cpath d='m442.23,59.185c-2.8813-2.2259-3.8463-4.458-3.1541-7.4616-6.892,1.6834-9.0552,4.1173-7.9606,6.7319,1.0942,2.6151,4.8013,3.4969,11.115,0.7297z'/%3E %3Cpath d='m403.98,76.772c-3.2521-1.6372-4.6241-3.645-4.5159-6.7254-6.4459,2.9637-8.1066,5.7647-6.5347,8.1233,1.5717,2.3592,5.3788,2.5197,11.051-1.398z'/%3E %3Cpath d='m422.42,67.35c-3.0292-2.02-4.1472-4.1796-3.6657-7.224-6.7581,2.1589-8.7467,4.7375-7.4729,7.2696,1.2735,2.5326,5.033,3.1543,11.139-0.04555z'/%3E %3Cpath d='m369.67,100.66c-3.5219-0.92352-5.2822-2.6013-5.8183-5.6366-5.6867,4.242-6.7272,7.3275-4.6983,9.3068,2.0288,1.9798,5.7859,1.3434,10.517-3.6703z'/%3E %3Cpath d='m386.04,87.263c-3.4388-1.1964-5.0623-3.0068-5.3592-6.0747-6.0013,3.7838-7.2802,6.7784-5.4124,8.9105,1.8676,2.1326,5.6629,1.7922,10.772-2.8358z'/%3E %3Cpath d='m355.13,114.99c-3.5912-0.59954-5.4968-2.1103-6.3066-5.0843-5.2776,4.7413-6.0333,7.9087-3.8328,9.6954,2.2004,1.7872,5.884,0.8119,10.139-4.6111z'/%3E %3Cpath d='m342.09,131.9c-3.6308-0.27111-5.6656-1.6027-6.7421-4.4909-4.8254,5.2008-5.2905,8.4237-2.9369,10.003,2.3535,1.5801,5.9334,0.27444,9.679-5.5124z'/%3E %3Cpath d='m331.19,149.2c-3.6295,0.2881-5.8442-0.71618-7.3503-3.4054-3.9721,5.8784-3.9381,9.1345-1.3704,10.335,2.5678,1.2011,5.9055-0.63741,8.7207-6.9296z'/%3E %3Cpath d='m321.61,167.67c-3.5615,0.75666-5.8878,0.0483-7.73-2.4229-3.1757,6.3441-2.7195,9.5683-0.0177,10.425,2.7019,0.85774,5.7728-1.3983,7.7478-8.0026z'/%3E %3Cpath d='m313.95,186.62c-3.3966,1.3114-5.8058,0.98047-8.0163-1.1675-2.1304,6.7671-1.1692,9.8783,1.6342,10.297,2.8037,0.41883,5.4784-2.2953,6.382-9.1291z'/%3E %3Cpath d='m308.82,207.75c-3.3012,1.5359-5.7271,1.3668-8.0764-0.62825-1.6727,6.8946-0.50531,9.9344,2.3199,10.164,2.8254,0.23006,5.3124-2.657,5.7566-9.5359z'/%3E %3Cpath d='m306.73,225.33c-3.1078,1.646-5.5296,1.8405-8.0697,0.59614-0.92446,5.6189,0.55546,7.8398,3.3793,7.6391,2.8241-0.20045,4.9816-2.794,4.6904-8.2352z'/%3E %3Cpath d='m662.3,141.68c1.2428-3.4223,3.0749-5.0212,6.1469-5.2762-3.702-6.0522-6.679-7.3718-8.8366-5.5331-2.1574,1.8386-1.8687,5.6382,2.6897,10.809z'/%3E %3Cpath d='m691.45,240.12c2.6788-2.4658,5.0415-3.0416,7.8862-1.8536-0.49997-7.077-2.5355-9.6191-5.2971-8.9802-2.7617,0.6389-4.2546,4.1447-2.5891,10.834z'/%3E %3C/g%3E %3Cpath d='m646.9,149.66s7.3965-11.707,4.5367-22.726-15.064-3.2326-14.801,0.68906c0.26295,3.9215,7.8866,9.1676,8.3502,11.561,0.4632,2.393-0.86142,9.7539,1.9142,10.477z' fill='%23ffd200' stroke='%23ef8a10' stroke-width='1.008'/%3E %3Cg fill='%23217900' stroke='%23000' stroke-width='2.4186' stroke-linejoin='round'%3E %3Cpath stroke-width='1.9349' d='m663.67,124.92c-0.0863,0-8.0216,7.9354-6.6415,17.596,1.38,9.6605,7.504,21.564,6.3828,31.569-1.1215,10.006-2.9327,16.647-2.9327,16.647s9.3155-10.609,9.4018-20.787-6.383-23.548-6.383-31.052c0-7.5041,0.34519-14.146,0.17259-13.973z'/%3E %3Cpath stroke-width='1.9349' d='m678.42,157.35s-6.2104,4.5715-5.6065,15.095c0.60369,10.523,11.472,29.844,11.472,29.844s7.9355,16.302,7.6766,20.529c-0.25869,4.2264,1.4664-4.0538,0.69017-13.369-0.77627-9.3155-12.766-29.844-12.766-29.844s-2.5877-4.2263-2.3288-11.213c0.25869-6.9867,0.94886-10.954,0.86257-11.041z'/%3E %3Cpath d='m505.65,52.293s26.653,1.0353,26.825,18.286c-0.0863,2.674-0.00019,5.8651-0.94886,13.542,5.2615-2.8462,8.7981-10.782,8.1079-15.871,0.0863-17.51-23.806-29.499-33.984-15.957z'/%3E %3Cpath d='m488.75,51.517s21.477-4.4853,21.65,12.766c0.17259,17.251-6.8141,20.011-6.8141,20.011s16.475-3.5365,16.561-21.046c0.0863-17.51-21.218-25.272-31.397-11.731z'/%3E %3Cpath d='m697.38,249.19c0.49396,7.7393,8.0686,15.149,5.1048,28.652-3.7873,15.314-17.125,51.705-14.82,58.127-3.952-5.4341-3.2934-10.539-3.6227-18.113-0.32931-7.5745,11.032-35.732,12.021-45.283-0.00019-8.5624,0.82311-20.254,1.3171-23.382z'/%3E %3Cpath d='m697.38,249.36s12.35,15.643,11.691,27.993c-0.65862,12.35-7.5747,26.84-5.2693,33.262-3.952-5.4341-4.9399-8.8921-5.2693-16.467-0.32931-7.5745,6.0926-15.973,4.7753-24.206-1.3175-8.2333-6.0928-20.583-5.9281-20.583z'/%3E %3Cpath d='m292.82,252.81c-0.49397,7.7393-6.2574,14.655-3.2936,28.158,3.7873,15.314,17.29,34.744,15.149,56.974,3.952-5.4343,5.1048-11.527,5.4341-19.102,0.32931-7.5745-14.984-33.098-15.973-42.648,0.00019-8.5624-0.8231-20.254-1.3171-23.382z'/%3E %3Cpath d='m292.82,252.98s-12.021,15.149-11.362,27.499c0.16465,8.2331,15.314,42.648,13.009,49.07,3.952-5.4339,5.1046-4.7755,4.9398-13.009-4.446-21.077-12.35-34.58-11.032-42.813,1.3175-8.2333,4.6108-20.748,4.4462-20.748z'/%3E %3C/g%3E %3C/g%3E %3Cg fill='none' stroke='%23000' stroke-width='1.9349'%3E %3Cpath fill='%238c8a8c' d='m526.38,104.56s21.457,1.3504,22.508,13.655c1.0502,12.304-5.1017,19.807-5.1017,19.807s2.7009,26.559-18.306,34.361c-22.508,2.701-57.769,0.60024-57.769,0.60024s-10.354,2.551-14.555-18.906c-4.2014-21.457-5.4018-36.612-5.4018-36.612s2.1007-12.004,17.256-12.754c15.155-0.75019,61.22,0.15013,61.371-0.14998z'/%3E %3Cpath stroke-linecap='round' d='m543.63,137.87s-11.554,14.405-10.353,20.257'/%3E %3Cpath fill='%238c8a8c' d='m528.18,171.63c2.851,2.4008,5.5518,5.1016,6.152,13.955,0.6002,8.853,1.2004,17.706,1.2004,17.706l15.005,135.05,13.204,97.683,0.9003,15.155s-3.151,11.104-12.004,12.004c-6.452,13.504-41.414,17.406-44.865,17.256-3.151-0.14996-14.255-4.8016-21.007-4.2014-6.7524,0.60001-18.456,5.1015-23.708,4.3514-5.2516-0.75015-17.106-4.8016-19.206-13.354-14.705-4.6516-17.106-15.905-17.106-15.905l15.905-112.99,15.455-142.85s1.8006-19.056,9.4531-21.907c7.9527-0.7502,49.066,0.7502,60.62-1.9506z'/%3E %3Cpath d='m447.15,367.15-3.151,99.934'/%3E %3Cpath d='m544.23,380.35,8.853,82.378'/%3E %3Cpath fill='%23fff' stroke-width='2.0159' stroke-linejoin='round' d='m498.19,114.45,29.923,92.093,96.82,0.004-78.327,56.92,29.916,92.095-78.331-56.915-78.331,56.914,29.916-92.095-78.327-56.92,96.82-0.004z'/%3E %3C/g%3E %3C/g%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 750 500'%3E %3Crect width='750' height='500' fill='%2321428e'/%3E %3Cpath d='M 375,0 V 500 M 0,250 H 750' stroke='%23fff' stroke-width='72.5'/%3E %3Cpath id='path8' d='M 62.3,11.9 C 59.9,13 58,14.6 58,15.4 C 58,16.3 59.4,16.3 57.6,16.9 C 55.9,17.5 51.3,18.3 48.1,18.2 C 47,18.2 44.4,17.5 43.7,17.5 C 42.9,17.6 47.1,19.3 45.5,18.9 C 43.3,18.3 42,18.1 43.7,19.2 C 45,20 47.9,20 52,19.5 C 53.6,19.3 57.8,18.4 59.3,18.2 C 60.3,18.1 60.3,19 60.9,19 C 66.3,19.3 75.9,19.1 80.1,18.5 C 83.6,18 84.9,18.2 85.9,19.4 C 87.9,21.7 85.8,23.7 80.1,24.9 C 73.1,26.4 70.2,27.7 67.5,30.6 C 61,37.6 68.6,45.5 82.8,46.6 C 91.1,47.3 96.5,48.9 95.2,50.2 C 94.7,50.7 89.2,51.5 82.9,52 C 69.2,53.1 63.1,55 57.9,60 C 55,62.8 54,64.5 54,66.8 C 54,70 54,70 48.7,70 C 45.9,70 42,69.6 40.2,69 C 37.4,68.3 37,68.3 38,69.5 C 40,71.9 45.7,74 50.4,74 C 54,74 56,74.7 59.2,77 C 65.6,81.7 72.9,83.5 85,83.4 C 100.9,83.3 110,79.1 110,72 C 110,66.7 104,63.6 91.5,62.5 C 85.2,61.9 72.8,62.9 67.4,64.5 C 66.4,64.8 67.5,64.1 69.9,62.9 C 72.8,61.5 77.6,60.5 84.1,59.9 C 98.5,58.7 105,55.5 105,49.5 C 105,43.7 98.6,40.4 84.9,39.1 C 71.4,37.9 70.4,35.5 81.8,32 C 89.9,29.6 94,26 94,21.1 C 94,13.6 89.9,11.1 76.2,10.4 C 67.9,10 65.9,10.2 62.3,11.9 z M 69.5,14 C 69.2,14.5 68.4,15 67.9,15 C 67.3,15 67.2,14.5 67.5,14 C 67.8,13.4 68.6,13 69.1,13 C 69.7,13 69.8,13.4 69.5,14 z M 98.4,70 C 100.3,70.7 101,71.4 100.4,72 C 98.7,73.7 87.7,75.2 81,74.7 C 73.6,74 65.6,71.6 68,70.6 C 74.7,68 92.3,67.7 98.4,70 z' transform='scale(2.3)' fill='%23fff'/%3E %3Cuse xlink:href='%23path8' x='411.25'/%3E %3Cuse xlink:href='%23path8' y='286.25'/%3E %3Cuse xlink:href='%23path8' x='411.25' y='286.25'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns:rdf='http://www.w3.org/1999/02/22-rdf-syntax-ns%23' xmlns='http://www.w3.org/2000/svg' xmlns:cc='http://creativecommons.org/ns%23' xmlns:dc='http://purl.org/dc/elements/1.1/' viewBox='-72 -28 144 96'%3E %3Cpath fill='%23cd2a3e' d='m-72-28h144v96h-144z'/%3E %3Cpath fill='%23006233' d='M-72,-13.6H72V53.6H-72Z'/%3E %3Cpath d='m29.999999 2.9199999c-0.08 16.4960001-13.488 29.8400001-29.99999952 29.8400001-16.51200048 0-29.91999948-13.344-29.99999948-29.8400001-0.656 2.512-1.008 5.1360001-1.008 7.8400001 0 17.12 13.871999 31.008 31.00799948 31.008 17.13599952 0 31.00799952-13.872 31.00799952-31.008 0-2.704-0.352-5.3440001-1.008-7.8400001z' class='st1' fill='%23ffc400'/%3E %3Cpath d='m-0.000001-9.2399582-2.694398 8.291438-8.718241 0.000318 7.053009 5.12472l-2.693771 8.2916412 7.053401-5.1241852 7.0534 5.1241862-2.693771-8.2916422 7.053012-5.12472-8.718243-0.000318z' fill='%23ffc400'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1200 600'%3E %3CclipPath id='c'%3E %3Cpath d='M0,0V150H700V300H600zM600,0H300V350H0V300z'/%3E %3C/clipPath%3E %3Crect width='1200' height='600' fill='%2300247d'/%3E %3Cpath d='M0,0 600,300M600,0 0,300' stroke='%23fff' stroke-width='60'/%3E %3Cpath d='M0,0 600,300M600,0 0,300' stroke='%23cf142b' stroke-width='40' clip-path='url(%23c)'/%3E %3Cpath d='M300,0V350M0,150H700' stroke='%23fff' stroke-width='100'/%3E %3Cpath d='M300,0V350M0,150H700' stroke='%23cf142b' stroke-width='60'/%3E %3Cpath d='M0,300H600V0H1200V600H0z' fill='%2300247d'/%3E %3Cg%3E %3Cpath fill='%23fff' d='m769.466,147.526,256.879,0-0.306,182.787c2.1373,73.4798-43.6616,119.076-127.931,139.634-59.834-14.86-128.837-45.596-128.939-137.549l0.30537-184.872z'/%3E %3Cpath fill='%2300a2bd' stroke='%23000' stroke-width='1.8125' d='m775.152,153.036,245.493,0-0.2914,175.155c2.0416,70.4101-41.7273,114.102-122.261,133.802-57.188-14.237-123.132-43.692-123.229-131.805l0.29189-177.152z'/%3E %3Cpath fill='%23a53d08' d='m1018.74,348.938c-8.9307,67.2099-60.6921,96.5757-120.655,112.162-53.073-14.238-110.174-36.968-121.243-111.824l241.901-0.33785z'/%3E %3Cpath fill='%23000' d='m888.365,185.664-0.34221-22.0753,17.4554,0.17111,0.17111,21.9042,47.7434,0,0.17109,17.1126-47.9145,0.17111-0.38281,201.815-17.0262,0.10728-0.2175-202.093-47.5824,0.17125,0.0101-17.4548z'/%3E %3Cg fill='%23ff9a08' stroke='%23000' stroke-width='0.9676'%3E %3Cpath d='m849.714,357.267,43.703,45.3378c15.1121-16.61,4.62991-78.6955-15.247-90.1304-2.3824,7.35162-6.43375,16.1663-10.7403,19.0083-9.47444,6.45695-32.6922,14.0058-24.9316,18.8401,1.76989-2.45053,6.39893-4.76476,8.5773,0.68151,2.58684,8.57687-9.66655,9.12208-9.66655,9.12208s-7.76038-0.95411-9.12194-8.85092c-1.36144-7.89537,11.5591-15.1049,12.6619-15.6559,1.08911-0.40891,17.9714-4.90107,20.8308-19.8783,3.53951-14.7047,7.21531-12.5253,7.89681-12.7979,22.0548,2.17794,36.4869,41.662,37.3047,69.4357,0.81634,27.7737-11.3,46.1542-13.4794,47.3794-2.17793,1.22527-52.553-59.7684-52.553-59.7684l4.76521-2.72313z' fill-rule='evenodd'/%3E %3Cpath d='m881.573,315.061,0.27116,81.8247'/%3E %3Cpath d='m876.672,316.558c0,0.13629,0.27116,74.3382,0.27116,74.3382'/%3E %3Cpath d='m871.362,327.314,0.27115,59.0884'/%3E %3Cpath d='m867.005,331.534,0.27261,48.8788'/%3E %3Cpath d='m862.376,333.713v41.2531'/%3E %3Cpath d='m857.338,336.981v32.6748'/%3E %3Cpath d='m852.982,339.568v25.0506'/%3E %3Cg fill='none' stroke='%23ffdf00' stroke-width='1.8125' stroke-linecap='round'%3E %3Cpath stroke-width='0.9676' d='m849.033,362.441,45.0653,51.6004'/%3E %3Cpath d='m896.276,329.901s20.4236,44.6578,1.49788,81.4172'/%3E %3Cpath d='m843.723,353.046s1.49772-3.94841,3.40377-2.31424'/%3E %3Cpath d='m840.184,341.61s-8.16898,7.2153-3.67594,11.8452'/%3E %3C/g%3E %3C/g%3E %3Cg stroke='%23000' stroke-width='0.3987'%3E %3Cpath fill='%23008021' d='m905.779,228.044c3.02538-2.59499,4.59503-4.18109,6.46848-3.89248,1.87346,0.28798,4.42414,0.14367,6.2976-0.43292,1.87978-0.57723,11.1774-1.73042,15.0003-0.43292,1.2975,0.14431,3.02538,0.86584,5.68999,3.10069,2.67094,2.23422,6.56342,6.12797,5.26592,16.9415-1.29749,10.8135-0.87343,15.4389-1.44306,21.4833-1.00635,10.6698-3.37349,19.4554-7.63939,18.744,5.76593,10.0932,6.34189,18.744,10.0888,25.6651,3.75324,6.92102,6.05708,21.051,4.61402,36.3349-1.43674,15.2838-5.47479,49.5991,6.63304,72.6692-2.01903,1.4418-6.91786,0-11.2471-4.61402-4.32287-4.61401-6.22164-4.46275-9.80399-1.73041-10.9559,8.36282-21.2156,18.4421-36.3298,8.36282-3.46209-2.30701-4.55705-5.07415-2.01902-12.1116,6.34189-17.5902,9.42423-41.7249,8.42421-53.0599v-127.027z'/%3E %3Cg fill='%23ffe1cf'%3E %3Cpath d='m916.171,217.23c0.79116,2.45131,1.22155,5.62289-0.076,8.50649-1.29749,2.8836-1.58231,6.34443,0.57596,10.5255,3.4621-4.902,8.36726-3.89249,11.2471-6.77609,2.88613-2.88423,3.46209-5.62352,5.62669-6.20075-2.1646-1.87409-5.48112-3.89248-4.75959-9.3717,0.72154-5.47923,8.36093-9.9483,1.44307-18.3118-4.46844-5.39821-10.9622-3.89248-13.7724-1.80193-1.32281,0.9823-2.44942,2.37853-2.87981,3.31589-0.43671,0.93736,0.1076,3.07031-0.94305,4.32603-0.71521,0.86457-1.58864,1.72472-2.59499,2.45068-0.64558,0.469-1.05065,1.15192-0.36077,1.94688,0.27849,0.31772,0.78483,0.38545,1.3418,0.57849-0.32279,0.64875-0.68988,1.29559-1.05065,1.76459-0.34178,0.43988-0.19621,0.85951,0.21519,1.21775-0.54431,1.72978,0.50634,1.91775-0.21519,3.21588-0.6266,1.12218-1.47471,2.45005,0.8671,3.74881,0.64559,0.36013,3.71527,1.07217,5.33555,0.86521z'/%3E %3Cpath d='m888.126,245.923c-4.03806,1.00952-10.5255-0.72026-15.4307-0.1443-2.1646,0.2557-3.89248-0.86458-3.60133-3.02728,0.28481-2.16333,0.57596-5.47922,0.13924-8.50713-0.6709-4.71845,1.58864-11.2464,4.75959-18.4561,3.17095-7.209,4.75958-11.2458,4.75958-14.6345,0-2.23486,0.2152-4.75832,2.23423-6.05582,1.4937-0.95888,1.77851-1.88991,2.31017-2.66714,1.22154-1.80257,2.37346-2.23485,2.51903-1.15319,0.0886,0.64305-0.14557,1.22534-0.72153,2.09055,1.2975-1.08167,3.50007-2.34372,4.00008-2.70385,0.50634-0.36013,3.06968-2.1627,3.20892-0.46836,1.01268-0.50444,1.69624-0.469,1.94941,0.0715,0.27216,0.58482,0.1076,0.82976-0.39874,1.26205,0.72153-0.14431,1.55066,1.11774,0.10759,2.23485,0.75951-0.25254,1.51269,1.00952,0.18355,2.1627-1.37977,1.19053-2.95575,2.01903-3.46209,2.95576-0.50634,0.93736-3.93046,3.56905-5.29757,4.14565-1.37345,0.57659-1.44307,1.36775-1.44307,3.38804,0,22.2042-2.66461,20.4004-2.66461,25.7372,0,1.44181-0.29114,2.7393,1.15192,2.30638,1.44307-0.43229,3.53172-1.08103,5.69632-1.08103v12.5439z'/%3E %3Cpath d='m888.987,293.792c6.51912-3.25829,13.9876-4.46971,17.8801-5.47859,3.89248-1.00951,10.0951-4.03679,13.1205-5.62289,3.03171-1.58674,5.48112-3.74945,7.20901-4.32604,1.73421-0.57659,3.67095-1.76965,4.75958-3.89248,5.62037-10.9584,8.65207-19.7523,8.65207-27.3955,0-5.0463-1.29749-10.6698-6.20265-6.63241-4.60769,3.79502-9.62677,11.1104-10.9559,16.437-2.01903,8.07421-3.74691,9.80462-4.18363,11.3901-0.43039,1.58674-2.06333,1.58485-4.03805,2.01903-8.5065,1.87472-10.5255,3.17158-16.8674,7.9299-6.3419,4.75833-13.2661,8.94005-17.8801,11.535-4.61402,2.59562-5.47479,2.8836-6.48747,4.97415-1.00635,2.09055-1.94308,3.67665-2.81018,4.61465-0.86711,0.93673-1.11395,2.03232-0.93673,3.17158,0.14557,0.93736-0.29115,5.26276-0.36077,6.70456-0.076,1.4418,0.28482,1.80257,0.86711,1.87409,0.57596,0.0728,1.36711-0.21583,1.65826-1.94624-0.29115,1.73041,2.08865,1.15319,2.23422-0.14368-0.076,1.87409,2.44941,0.79306,2.59499-0.93736,0,1.22534,1.91143,0.37786,2.08865-0.21646,0.43038-1.4418,0.79115-3.0279,1.36711-4.18109,0.84179-1.67408,1.74054-3.84248,3.39247-5.04694,1.87346-1.36964,1.00635-2.8836,4.89883-4.83047z'/%3E %3Cpath d='m935.703,411.88c0.43672,1.5861,1.22787,3.38867,1.51269,4.47034,0.29115,1.08103-0.21519,1.41838-0.50001,2.01839-1.51269,3.17222-3.1393,8.22865-3.39247,10.9578-0.13924,1.58611-1.22154,3.10006-1.72788,4.03742-0.55698,1.03357-0.34178,1.83105,0.93672,2.81145,0.61394,0.46837,2.59499-0.1443,2.81019-1.15319,0.72153,0.72027,2.01902,0.43229,2.59498-0.64938,0.65192,0.64938,1.73422,0.21646,2.45575-0.86457,0.64558,0.43229,1.58231-0.43292,1.94307-1.01015,1.01268,0.50508,2.09498-0.10759,2.12663-2.08991,0.006-0.39811,0.25317-1.08167,0.54431-1.55003,0.28482-0.469,0.39242-1.36965,0.36077-2.16333-0.038-0.79306,0.46836-2.37853,1.15192-3.49628,0.68356-1.11774,1.87346-3.10006,1.36712-4.97414-0.46837-1.74624-1.22155-1.58611-1.87346-4.10895-1.58231-1.65889-3.74691-3.9659-5.98113-4.1102-2.23422-0.14368-3.53171,1.37028-4.3292,1.87472z'/%3E %3Cpath d='m894.683,424.28c2.01902,2.0184,6.56342,2.09055,9.73437-1.29813-1.15192-0.50444-3.67729-1.65826-4.82921-2.59498-1.58864,1.5861-3.39247,3.38804-4.90516,3.89311z'/%3E %3C/g%3E %3Cpath fill='%23870f00' d='m915.089,195.026c0.79116-5.11846,4.41781-4.99757,6.70267-4.46971,0.93672,0.21646,3.2469,0.43229,5.40517-0.14431,4.27856-1.13989,7.50014,0.36077,7.06976,4.47035,1.15192,0.86457,2.37346,2.88296,2.15827,4.61401-0.2152,1.72978,0.14557,2.45068,1.73421,2.66651,1.58231,0.21709,4.97478,2.16333,2.73423,4.90263,2.1646,1.29812,3.82286,4.61401,2.67094,6.84887-1.15192,2.23485-4.61402,2.59562-6.05708,0.57659-1.58231,0.7209-4.18363,0.86521-5.76594-0.79242-1.0823,1.29686-3.82286,1.15319-4.3292,0-0.50001-1.15382-1.35446-1.77092-2.37346-2.09118-1.15825-0.36014-1.22788-3.53235,0.50001-3.89312-0.2152-0.93736-0.13925-2.01839,0.29114-2.52283s0.0696-1.4418-0.93673-2.23549c-1.01267-0.79305-1.87345-3.82096-0.8671-5.47859-1.72788,0.5766-5.55074-1.08166-6.3419-2.23485-0.79748-1.15382-1.87345-1.22534-2.59499-0.21646z'/%3E %3Cg fill='none'%3E %3Cpath d='m916.171,217.23c2.81018-0.36077,3.74691-2.09055,5.83556-1.94688'/%3E %3Cpath d='m910.184,209.401c0.18355,0.16202,0.41773,0.2943,0.68356,0.44051,0.56963,0.3076,1.1899,0.34305,1.76586,0.41457'/%3E %3Cpath d='m911.019,206.418c0.39242,0.13544,0.81014,0.33292,1.18357,0.719'/%3E %3Cpath d='m917.538,195.026c-1.65826-1.58611,2.81018-4.82984,7.50015-0.21646,0.87343,0.86141,3.09499,0.86584,3.7469,0.64875'/%3E %3Cpath d='m924.026,197.477c2.1646-0.50507,5.40517-0.50507,6.34189,1.94624,0.94306,2.45132,2.81652,0.86521,4.3292,3.74944,1.51269,2.88361,3.89249,6.12734,6.19633,3.89249'/%3E %3Cpath d='m931.741,213.698c-0.65191-0.86521-0.93673-2.73993-0.50634-4.03806-0.86711-1.00888-0.50634-3.09942,0-4.10894'/%3E %3Cpath d='m925.539,207.714c0.076,0.86521,1.22787,2.45132,3.0317,2.7393'/%3E %3Cpath d='m937.507,214.491c-1.00635-1.2975-0.86711-2.45068-0.64559-4.03742'/%3E %3Cpath d='m926.982,200.145c-0.0696,1.29749,0.72154,3.0279,2.08865,3.6045,0.29115,0.72027,1.73421,2.73929,4.61402,2.45131'/%3E %3Cpath d='m934.267,194.882c-1.58231-1.22788-3.72793-2.74057-6.56342-3.11462'/%3E %3Cpath d='m916.671,236.262c-2.44941,3.31652-4.03805,7.9299-2.8798,14.4186,1.15192,6.48874,3.02537,16.0048-1.73421,20.3302'/%3E %3Cpath d='m935.418,283.555c-3.31652-0.72027-8.07611-0.72027-10.6711,1.15382s-6.92419,2.01839-9.80399,0.57659'/%3E %3Cpath d='m928.425,283.339c-2.88613,0.50444-4.25325,2.52284-4.25325,7.85775,0,5.33492-1.15192,13.1205-0.14557,20.7624'/%3E %3Cpath d='m923.159,285.574c-1.87345,0.50444-3.81653,0.57596-3.45576,5.62289'/%3E %3Cpath d='m913.431,291.341c0.0696-3.10006,1.15192-5.98366,3.17095-5.47922'/%3E %3Cpath d='m934.191,291.918c0.14558-6.84887-1.36711-8.79511-3.38614-8.72295,2.74056,0.0721,4.60769,0.40697,5.76594,11.6066,0.8671,8.36283,2.61397,11.323,4.61401,17.8795,5.18998,17.0136,2.59499,43.2553,5.18998,52.4833'/%3E %3Cpath d='m930.228,293.936c5.47479,15.8611,8.36093,33.4513-0.57596,61.7113,6.05075,16.7256,12.1078,28.8366,13.2598,35.7583'/%3E %3Cpath d='m912.924,331.424c1.00635-3.60387-2.59498-4.03679,0.57596-16.725,1.37345-5.49631,1.58864-8.79511,0.72154-10.5255'/%3E %3Cpath d='m914.222,311.672c-1.2975,5.62352,4.18362,16.149,1.44306,23.7903'/%3E %3Cpath d='m908.886,336.904c0,4.90199,1.15192,11.2464,0.8671,16.149-0.29114,4.902,1.7089,7.17356,4.03806,11.823,8.36092,16.7256,14.0509,28.6588,13.2598,44.4091-0.13924,2.8836,0.86711,8.93942-2.15827,10.6692'/%3E %3Cpath d='m909.101,424.208c0.86711,0.0721,1.80384-0.36014,2.88614-2.95576s4.54439-18.1674,3.10132-28.8373'/%3E %3Cpath d='m916.817,404.527c0.43039,3.31589,0.43039,10.0926-1.72788,15.4275'/%3E %3Cpath d='m922.298,394.578c1.29749,7.06533,1.15192,13.4098,0.14557,17.8788'/%3E %3Cpath d='m919.412,412.456c0.14558,2.8836,1.44307,10.0932-0.72153,10.6705'/%3E %3Cpath d='m930.228,379.006c5.32922,8.36283,9.51285,28.9816,13.9813,33.3064'/%3E %3Cpath d='m934.842,408.996c-0.14558-2.30701-0.29115-5.47859-1.58864-6.92103'/%3E %3Cpath d='m877.24,308.067c0.0696-1.58674-0.2152-3.10069,1.51268-5.55137'/%3E %3Cpath d='m874.645,309.004c0.21519-5.55137,0.13924-6.05644,1.72788-7.5704'/%3E %3Cpath d='m872.411,309.148c0.0696-3.96464-0.43672-5.33492,1.15192-7.85838'/%3E %3Cpath d='m892.304,190.196c-0.61393,0.39621-4.21527,3.1355-5.72796,4.28932'/%3E %3Cpath d='m893.854,191.529c-0.68356,0.10759-2.66461,1.73041-6.19633,4.46971'/%3E %3Cpath d='m893.962,193.764c-1.11394,0.50444-3.24057,2.55955-5.18997,3.92919'/%3E %3Cpath d='m885.095,193.368c-0.53798,0.39621-1.58231,1.55003-2.08865,1.94624'/%3E %3Cpath d='m935.343,435.022c-0.3228-0.36076-0.3228-1.62281,0.25317-3.0279'/%3E %3Cpath d='m937.937,434.373c-0.39241-0.39621,0-2.12662,0.39875-3.24436'/%3E %3Cpath d='m940.393,433.508c-0.46837-0.21646-0.61394-1.22597,0.0696-2.59562'/%3E %3Cpath d='m942.336,432.498c-0.32279-0.10759-0.46836-0.64874,0.1076-2.23422'/%3E %3C/g%3E %3Cg fill='%23000' stroke='none'%3E %3Cpath d='m913.969,199.567c1.04432,1.36965,2.12662,1.22471,2.3165,2.10764,0.18988,0.88419,0.32912,0.94685,0.53165,1.20888,0.20254,0.2614-0.49368,0.20887-0.83545,0.0677-0.33545-0.14114-1.18357-0.12658-1.70257-0.11899-0.51267,0.008-1.1266-0.59874-0.74052-0.67026,0.37975-0.0709,0.32912-0.19051,0.27216-0.4595-0.057-0.26836,0.21519-0.69306,0.37342-0.77091,0.16456-0.0779,0.0506-0.0633-0.0949-0.42342-0.1519-0.36077-0.34178-1.2361-0.12025-0.94116z'/%3E %3Cpath d='m914.602,198.313c1.17091,0.13734,3.18994,0.76963,4.2849,1.98168,0.86077,0.95318,0.15823,0.70065-0.27849,0.73609-0.43672,0.0367-1.29117-0.27279-1.72155-0.81457-0.42406-0.54115-1.69624-1.22724-2.37347-1.40573-0.4114-0.10633-0.79748-0.60191,0.0886-0.49747z'/%3E %3C/g%3E %3C/g%3E %3C/g%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 900 600'%3E %3Crect width='900' height='600' fill='%23cf142b'/%3E %3Crect width='450' height='600' fill='%23fff'/%3E %3Cg%3E %3Cpath fill='%23e60d2e' d='m22.222,82.828,0,45.457,45.455,0c0,7.5741,7.5762,15.151,15.152,15.151v45.454h45.452v-45.454c7.5762,0,15.152-7.5766,15.152-15.151h45.455v-45.457h-45.455c0-7.5741-7.5762-15.151-15.152-15.151v-45.454h-45.452v45.454c-7.5762,0-15.152,7.5766-15.152,15.151h-45.455z'/%3E %3Cpath fill='%2396877d' d='m25.254,85.857,0,39.397,45.452,0c0,7.5738,7.5762,15.15,15.152,15.15v45.454h39.392v-45.454c7.5762,0,15.152-7.5766,15.152-15.15h45.452v-39.397h-45.452c0-7.5741-7.5762-15.151-15.152-15.151v-45.454h-39.392v45.454c-7.5762,0-15.152,7.5766-15.152,15.151h-45.452z'/%3E %3Cpath fill='%23ccc' d='m26.77,87.373,0,36.364,45.452,0c0,7.5741,7.5762,15.153,15.152,15.153v45.454h36.362v-45.454c7.5762,0,15.152-7.5791,15.152-15.153h45.452v-36.364h-45.452c0-7.5738-7.5762-15.15-15.152-15.15v-45.454h-36.362v45.454c-7.5762,0-15.152,7.5766-15.152,15.15h-45.452z'/%3E %3Cg id='vi' fill='%23d0d0d0'%3E %3Cpath fill='%2396877d' d='m84.536,71.681c2.6626,2.6628,1.9431,7.6994-1.6071,11.25-3.5502,3.5503-8.5867,4.2698-11.249,1.6072-2.6626-2.6626-1.9431-7.6994,1.6071-11.25,3.5502-3.5501,8.5867-4.2698,11.249-1.6072z'/%3E %3Cpath d='m71.143,79.715,1.0712-1.0722,4.2856,2.1422-2.143-4.2853,1.0714-1.0722,4.2855,8.5711-8.5708-4.2856z'/%3E %3Cpath d='m77.572,73.287,1.0714-1.0714,6.4282,6.4283-1.0714,1.0714z'/%3E %3C/g%3E %3Cuse xlink:href='%23vi' transform='rotate(90,105.555,105.557)'/%3E %3Cuse xlink:href='%23vi' transform='rotate(180,105.555,105.557)'/%3E %3Cuse xlink:href='%23vi' transform='rotate(270,105.555,105.557)'/%3E %3Cg fill='none' stroke='%2396877d' stroke-width='0.514'%3E %3Ccircle cx='105.555' cy='105.557' r='31.822'/%3E %3Ccircle cx='105.555' cy='105.557' r='24.245'/%3E %3C/g%3E %3Cg fill='%23000'%3E %3Ccircle cx='93.434' cy='131.31' r='1.515'/%3E %3Ccircle cx='117.675' cy='131.31' r='1.515'/%3E %3Cpath d='m104.55,131.31,0,1.5798-2.0203,0c-2.0203,0-2.0203,1.5798,0,1.5798h2.0203v1.5798c0.007,1.637,1.7632,1.8358,1.8917,0.13718l0.12826-1.7078h2.0203c2.02,0,2.02-1.5798,0-1.5798h-2.0203v-1.5798c0-1.5798-2.02-1.5798-2.02,0z'/%3E %3Cpath d='m75.954,113.4,2.0836-0.49669-0.23018-0.96558c-0.05274-0.22154-0.14029-0.37212-0.26261-0.45176-0.12227-0.0796-0.33208-0.10192-0.62945-0.0669l-0.03456-0.14462,1.7943-0.42772,0.03456,0.14462c-0.20528,0.0516-0.35004,0.11445-0.43437,0.18823-0.08431,0.0738-0.13986,0.16141-0.16664,0.26283-0.02678,0.10141-0.01904,0.24072,0.02319,0.41794l0.23018,0.96558,1.6653-0.39698c0.26844-0.064,0.44162-0.12317,0.51955-0.17754,0.05893-0.0416,0.10192-0.10968,0.12895-0.20426,0.03521-0.12958,0.0379-0.25691,0.0081-0.38202l-0.04572-0.19152,0.14462-0.0346,0.54235,2.2752-0.14462,0.0346-0.04465-0.18767c-0.05228-0.21889-0.15392-0.36268-0.30524-0.43127-0.0983-0.0427-0.30644-0.0261-0.62439,0.0497l-3.4245,0.81632c-0.26844,0.064-0.44161,0.12317-0.51955,0.17753-0.05893,0.0416-0.10222,0.10838-0.1299,0.20035-0.03582,0.12697-0.03853,0.25431-0.0081,0.38201l0.04465,0.18768-0.14462,0.0346-0.94026-3.9444,1.1528-0.32851,0.03261,0.13683c-0.23143,0.12678-0.39442,0.24896-0.48896,0.3665-0.09453,0.11756-0.15218,0.24837-0.17294,0.39239-0.02075,0.14403,0.0018,0.35418,0.06766,0.63043l0.27863,1.1689zm-1.3422-9.402c0.03979-0.70618,0.34243-1.303,0.90792-1.7904,0.56549-0.48738,1.2495-0.70846,2.052-0.66326,0.82656,0.0466,1.498,0.34604,2.0143,0.89839,0.5163,0.55236,0.75358,1.199,0.71183,1.94-0.0422,0.74898-0.34381,1.3633-0.90484,1.8428-0.56102,0.47958-1.2642,0.69556-2.1095,0.64794-0.864-0.0487-1.5523-0.38264-2.0648-1.0019-0.44467-0.53759-0.64696-1.1622-0.6069-1.8737zm0.28861,0.0927c-0.02742,0.48684,0.13113,0.88756,0.47566,1.2021,0.42874,0.39179,1.0765,0.6121,1.9431,0.66093,0.88808,0.05,1.5822-0.10137,2.0824-0.45424,0.38022-0.27106,0.58382-0.64601,0.6108-1.1248,0.02878-0.51091-0.14672-0.94411-0.52652-1.2996-0.3798-0.35548-0.99903-0.55741-1.8577-0.6058-0.93088-0.0524-1.6353,0.0917-2.1134,0.43237-0.38036,0.27376-0.58517,0.67009-0.61441,1.189zm7.894-9.9511-0.5176,1.3596-3.0375,0.8174c-0.04359,0.12962-0.08066,0.23448-0.11117,0.3146-0.0124,0.03256-0.02636,0.06738-0.04191,0.10444-0.01555,0.03709-0.03221,0.07518-0.04997,0.11428l1.4798,0.56335c0.3205,0.12201,0.5329,0.16274,0.63721,0.12218,0.14641-0.05317,0.25581-0.17496,0.32826-0.36525l0.07577-0.19905,0.13896,0.0529-0.83073,2.1821-0.13896-0.0529,0.07293-0.19155c0.08198-0.21532,0.07048-0.39601-0.03445-0.54204-0.05761-0.08213-0.23164-0.17848-0.52208-0.28906l-3.2901-1.2525c-0.32049-0.12201-0.5329-0.16274-0.63721-0.12218-0.14736,0.05566-0.25771,0.17998-0.33112,0.37276l-0.07293,0.19155-0.13896-0.0529,0.70634-1.8554c0.2059-0.54083,0.39713-0.92456,0.57371-1.1512,0.17658-0.22662,0.40474-0.38916,0.68447-0.48765s0.56608-0.09195,0.85903,0.01957c0.31299,0.11916,0.54581,0.32462,0.69848,0.61637,0.15267,0.29177,0.19508,0.66984,0.12722,1.1342l1.8614-0.49542c0.42703-0.11264,0.72853-0.23431,0.90446-0.36521,0.17594-0.13082,0.33184-0.32948,0.46769-0.59598l0.13896,0.0529zm-3.9947,2.6203c0.01811-0.04758,0.03447-0.08865,0.04906-0.12322,0.01461-0.03458,0.02618-0.06313,0.03477-0.08567,0.18493-0.48575,0.21917-0.89198,0.10274-1.2187-0.1164-0.32671-0.3374-0.55201-0.66291-0.67593-0.31799-0.12105-0.6144-0.11994-0.88925,0.0033-0.27484,0.12328-0.47469,0.34893-0.59956,0.67693-0.05529,0.14523-0.10632,0.35084-0.15312,0.61683l2.1183,0.80642zm11.596-18.053,1.0531,1.3672-0.11806,0.07646c-0.35222-0.2826-0.68176-0.4538-0.98862-0.51362-0.4425-0.08686-0.87738,0.0081-1.3046,0.28477-0.58242,0.37723-0.87613,0.89464-0.88114,1.5522-0.0021,0.55362,0.17083,1.0991,0.51894,1.6366,0.28254,0.43626,0.62467,0.77966,1.0264,1.0302,0.40168,0.25056,0.79339,0.37113,1.1751,0.3617,0.38172-0.0094,0.71651-0.10735,1.0043-0.29378,0.16864-0.10923,0.31785-0.23619,0.44759-0.38087,0.12973-0.14467,0.24074-0.30595,0.33302-0.48382l-0.85639-1.3223c-0.14856-0.22936-0.26321-0.36818-0.34394-0.41644-0.08075-0.04825-0.16966-0.06726-0.26677-0.05704-0.09711,0.01023-0.23785,0.07513-0.42227,0.19448l-0.08302-0.12817,1.7709-1.147,0.08302,0.12817-0.08432,0.05462c-0.1754,0.1136-0.25784,0.25-0.24732,0.40916,0.0089,0.11233,0.09274,0.29106,0.2515,0.53617l0.90664,1.3998c-0.16831,0.30692-0.35727,0.57454-0.56689,0.80287-0.20962,0.22834-0.46847,0.44227-0.77654,0.6418-0.88375,0.57238-1.7385,0.7238-2.5643,0.45423-0.61932-0.20217-1.1089-0.58098-1.4686-1.1364-0.26069-0.40252-0.41379-0.8508-0.45924-1.3449-0.05463-0.58706,0.04172-1.1283,0.28906-1.6236,0.20835-0.41264,0.54077-0.7668,0.99726-1.0625,0.1664-0.10776,0.32637-0.19222,0.4799-0.25335,0.15351-0.0612,0.38497-0.12637,0.69427-0.1959,0.15647-0.03441,0.25611-0.0654,0.29888-0.09297,0.04269-0.02776,0.06653-0.071,0.07138-0.13003,0.0049-0.059-0.02647-0.14805-0.09404-0.26709l0.1248-0.08083zm8.8735,0.61442-2.039,0.5422-0.1363,0.92615c-0.03364,0.22797-0.03703,0.39242-0.01019,0.4934,0.02126,0.08029,0.07829,0.14067,0.17086,0.1812s0.26812,0.03612,0.52668-0.01322l0.03817,0.14372-1.6584,0.44098-0.03817-0.14372c0.20976-0.09736,0.33873-0.18572,0.38694-0.26507,0.099-0.1594,0.17816-0.45074,0.23748-0.87404l0.70002-4.827,0.13591-0.0362,2.9981,3.8935c0.24122,0.31289,0.43597,0.50576,0.58426,0.5786,0.14827,0.07285,0.33159,0.08718,0.54994,0.04297l0.0382,0.14372-2.0778,0.55252-0.03817-0.14372c0.20698-0.06609,0.33943-0.13878,0.39738-0.21796,0.058-0.07918,0.0756-0.16149,0.0529-0.24693-0.0303-0.11391-0.12993-0.2801-0.2989-0.49854l-0.51986-0.67266zm-0.18516-0.25849-1.4592-1.8908-0.35063,2.3721,1.8099-0.48127zm9.6209-0.02828,0.13143,0.03327-0.52332,1.4597-4.2165-0.16404,0.006-0.14858,0.20481,0.008c0.23023,0.009,0.39779-0.0596,0.50268-0.20567,0.0596-0.08349,0.0954-0.28049,0.10745-0.59105l0.1367-3.5138c0.0132-0.34-0.016-0.55428-0.0876-0.64287-0.0998-0.12186-0.25281-0.18679-0.45895-0.19481l-0.20481-0.008,0.006-0.14858,2.4657,0.09592-0.006,0.14858c-0.28903-0.01392-0.49287,0.005-0.61151,0.05664-0.11865,0.05169-0.20105,0.11954-0.24721,0.20354-0.0462,0.08402-0.0756,0.28798-0.0882,0.61191l-0.1331,3.4214c-0.009,0.2222,0.007,0.37563,0.0465,0.46029,0.0299,0.05749,0.0778,0.10089,0.14374,0.13026,0.0659,0.02938,0.27418,0.05088,0.62489,0.06453l0.39756,0.01547c0.41764,0.01626,0.71198-0.0031,0.88304-0.05815,0.17109-0.05493,0.32924-0.15811,0.47454-0.30932,0.1453-0.15119,0.29412-0.39275,0.44646-0.72466zm7.2573,1.942,0.11707,0.06835-0.90692,1.2578-4.0064-1.3248,0.0467-0.14118,0.1946,0.06436c0.21875,0.07234,0.39874,0.05284,0.53997-0.05847,0.0803-0.06374,0.16929-0.24314,0.26686-0.53821l1.104-3.3386c0.10682-0.32305,0.13808-0.53705,0.0938-0.642-0.0622-0.14473-0.19123-0.24947-0.38709-0.31424l-0.1946-0.06436,0.0467-0.14118,2.3428,0.7747-0.0467,0.14118c-0.27388-0.09339-0.47498-0.13166-0.60329-0.11484-0.12831,0.01684-0.22625,0.05931-0.2939,0.12715-0.0676,0.06794-0.15231,0.25582-0.25409,0.56359l-1.075,3.2509c-0.0698,0.21112-0.0974,0.36285-0.0828,0.45516,0.0128,0.06352,0.0469,0.11852,0.10206,0.16497,0.0552,0.04647,0.24939,0.12479,0.58261,0.23499l0.37774,0.12491c0.39682,0.13122,0.68503,0.19407,0.86463,0.18856,0.17959-0.0055,0.36014-0.06081,0.54163-0.16584,0.18148-0.10507,0.39135-0.29599,0.62961-0.57275zm5.8487,3.0973-1.7221-1.2189-0.79864,0.48837c-0.19664,0.12013-0.32513,0.22285-0.38549,0.30813-0.048,0.06779-0.0579,0.15021-0.0298,0.24726,0.0282,0.09704,0.14395,0.22907,0.34742,0.39607l-0.0859,0.12138-1.4007-0.99138,0.0859-0.12137c0.2091,0.09875,0.35956,0.14125,0.45138,0.12746,0.18582-0.02604,0.46028-0.15182,0.82341-0.37729l4.1557-2.5533,0.11481,0.08126-1.0706,4.796c-0.0858,0.38563-0.10928,0.65872-0.0703,0.81927,0.039,0.16053,0.14539,0.31051,0.31915,0.44992l-0.0859,0.12138-1.7549-1.2421,0.0859-0.12138c0.18331,0.11663,0.32394,0.17185,0.42187,0.16566,0.0979-0.0062,0.17241-0.04539,0.22351-0.11752,0.0681-0.09623,0.13193-0.27916,0.19151-0.54882l0.18376-0.83003zm0.08-0.30775,0.51785-2.3316-2.0464,1.2496,1.5286,1.0819zm6.4627,1.191,0.88066,1.1881-1.2996,5.1103,2.5247-1.8714c0.26904-0.19942,0.41459-0.35399,0.43665-0.46372,0.0314-0.14663-0.0168-0.30606-0.14439-0.47825l-0.11246-0.15174,0.11946-0.08854,1.1295,1.5239-0.11946,0.08854-0.11487-0.15497c-0.13721-0.18511-0.29049-0.27492-0.45985-0.26945-0.10398,0.0037-0.27868,0.0964-0.52401,0.27837l-3.6903,2.7353-0.0862-0.11622,1.3862-5.4996-2.6959,1.9982c-0.26905,0.19942-0.41539,0.35292-0.43904,0.4605-0.0298,0.14879,0.0183,0.30822,0.14439,0.47825l0.11487,0.15497-0.11946,0.08854-1.1295-1.5239,0.11946-0.08854,0.11247,0.15174c0.13879,0.18726,0.29287,0.27815,0.46223,0.27267,0.10397-0.0037,0.27868-0.0964,0.52402-0.27835l3.0445-2.2567c0.0544-0.23707,0.0809-0.40598,0.0796-0.50673-0.001-0.10075-0.0286-0.22977-0.0818-0.38707-0.0269-0.07677-0.0874-0.17867-0.18154-0.30565l0.11946-0.08854zm6.871,12.662-1.1847,0.48309-0.0508-0.144c0.20233-0.10285,0.34047-0.19436,0.41442-0.27451,0.11879-0.13013,0.1899-0.27253,0.21334-0.42717,0.0234-0.15465-0.002-0.33806-0.0774-0.55022l-0.2561-0.72361-3.925,1.3887c-0.31574,0.11164-0.50066,0.2155-0.55483,0.3114-0.0721,0.13351-0.0729,0.30003-0.002,0.49957l0.0629,0.17808-0.14018,0.04957-0.77076-2.1785,0.14019-0.04957,0.0644,0.18184c0.0769,0.2172,0.19703,0.34805,0.36054,0.39251,0.10048,0.02697,0.2947-0.01047,0.58263-0.11236l3.925-1.3887-0.2184-0.61758c-0.0849-0.23993-0.16291-0.40418-0.23401-0.4927-0.0944-0.11436-0.22643-0.19414-0.39587-0.23933-0.16946-0.0452-0.3735-0.03554-0.61212,0.029l-0.0508-0.144,1.2262-0.36564,1.4839,4.194zm-4.3136,9.6659-0.0755-1.4528,2.4487-1.9744c-0.0125-0.13618-0.0209-0.24707-0.0254-0.33268-0.002-0.0348-0.003-0.0722-0.004-0.11247-0.00067-0.0402-0.00091-0.0818-0.00045-0.12474l-1.5813,0.0822c-0.34247,0.0178-0.55323,0.0663-0.63228,0.14555-0.11245,0.10779-0.16337,0.26336-0.1528,0.46671l0.0111,0.21271-0.14849,0.008-0.12122-2.3318,0.14849-0.008,0.0106,0.20469c0.012,0.2301,0.0954,0.39075,0.25042,0.48195,0.0859,0.0519,0.28397,0.0697,0.59434,0.0536l3.5157-0.18276c0.34247-0.0178,0.55323-0.0663,0.63229-0.14554,0.11228-0.11047,0.16309-0.26871,0.15238-0.47473l-0.0106-0.20467,0.14849-0.008,0.10307,1.9826c0.03,0.57792,0.01,1.0062-0.06,1.2848-0.07,0.27863-0.21311,0.51947-0.42924,0.72253-0.21615,0.20305-0.48074,0.31272-0.79378,0.32899-0.33444,0.0174-0.63041-0.0765-0.8879-0.28181-0.25749-0.20526-0.44896-0.53401-0.57442-0.98625l-1.5028,1.2049c-0.34518,0.27549-0.57183,0.50861-0.67995,0.69934s-0.17053,0.43543-0.1872,0.73409l-0.14849,0.008zm2.5964-4.0103c0.003,0.0508,0.004,0.095,0.005,0.13254,0.00064,0.0375,0.002,0.0683,0.003,0.0924,0.027,0.51906,0.1597,0.90452,0.39806,1.1564,0.23845,0.25186,0.53158,0.36875,0.87941,0.35067,0.33979-0.0177,0.61052-0.13838,0.81217-0.36215,0.20164-0.22378,0.29336-0.5109,0.27514-0.8614-0.008-0.15519-0.0444-0.3639-0.10902-0.62613l-2.2635,0.11767zm1.4941,11.21-0.48239,1.8386-0.14382-0.0377,0.0265-0.10106c0.0177-0.0674,0.0137-0.17368-0.0119-0.31889s-0.0803-0.28555-0.16376-0.42104c-0.0836-0.1355-0.23063-0.31396-0.4412-0.53539l-1.6684-1.7964-1.3216-0.34676c-0.32394-0.085-0.53559-0.10174-0.63496-0.0503-0.13468,0.0699-0.2299,0.21113-0.28565,0.42363l-0.0449,0.17104-0.14382-0.0377,0.58744-2.239,0.14382,0.0377-0.049,0.1866c-0.0585,0.22285-0.0326,0.39862,0.0777,0.52727,0.068,0.0788,0.24967,0.15691,0.54509,0.23442l1.2478,0.32737,2.5873-0.86676c0.30401-0.10305,0.49641-0.17651,0.57717-0.22043,0.0807-0.044,0.19165-0.14983,0.33267-0.31782,0.0395-0.045,0.0722-0.11677,0.098-0.21525l0.14383,0.0378-0.59152,2.2546-0.14382-0.0377,0.0306-0.11662c0.0319-0.12181,0.0328-0.24136,0.003-0.35868-0.0302-0.11731-0.10225-0.19095-0.21628-0.22086-0.0933-0.0245-0.28248,0.0104-0.56755,0.10454l-1.9874,0.65431,1.3536,1.4603c0.20279,0.21939,0.3638,0.34473,0.48301,0.37601,0.0726,0.019,0.14227,0.0172,0.20915-0.005,0.0669-0.0226,0.12568-0.0647,0.17643-0.12614,0.0508-0.0615,0.0945-0.16218,0.1312-0.30212l0.14382,0.0377z'/%3E %3C/g%3E %3Cg fill='%2396877d' stroke='%23000' stroke-width='0.203'%3E %3Cpath d='m122.85,110.19c0.53163-0.13451,1.4092-0.0256,1.4092-0.0256s0.0769,0.3651-0.15373,0.4868c0.25621,0.14732,1.1786,0.10248,1.1786,0.10248s-0.3587,0.27543-0.53804,0.38431c0.33307,0.032,0.743,0.46118,0.743,0.46118s-0.76862,0.1281-1.1017-0.0512c0.20497,0.40993,0.17935,0.76863,0.17935,0.76863s-1.2426-0.30745-1.691-1.1273'/%3E %3Cpath d='m120.77,109.49c-0.30104,0.74301-2.5108-0.64052-2.5108-0.64052s0.9736,1.5437,2.434,1.7166'/%3E %3Cpath d='m93.181,123.66,25.877,0,1.9984-1.5885-3.3307-1.7935-5.1242-1.7422-2.0497-1.1273-3.7919,0.20497-3.177,1.691-4.3556,0.51242-1.0248,1.1786-3.2282,0.25621-5.0729-0.10248,8.4549,1.3323-6.9689-0.3587,1.7935,1.5373z'/%3E %3Cpath d='m107.12,116.23c-3.241-1.7422-4.189,2.5493-5.5854,3.5869,1.8831,0.32026,3.3051-1.4476,4.9192-2.3059,1.224,3.333,3.1514,1.1273,3.1514,1.1273s2.0112,3.1898,4.6886,1.7422c0.73019,0.55085,1.5372,0.0512,1.5372,0.0512s0.9736,0.17935,1.1786-0.25621c0.51241,0.17935,1.0761-0.46117,1.0761-0.46117s1.1145,0.0128,1.3323-0.56366c1.6526,0.29464,3.8431-3.382,3.8431-3.382l0.66615-1.281,0.97359-0.20497s0.0641-0.64052-0.46118-0.6149c-0.0128-0.38432-0.34588-0.58929-0.81986-0.51242,0.0897-0.23059-0.25621-0.40994-0.25621-0.40994-0.92236,0.23059-0.9736,2.5621-0.9736,2.5621s-1.6141,1.2298-2.2034,1.5372c-0.0256-1.3323-2.2546-3.1386-1.7935-3.9969,0.46117-0.8583,1.9088,1.3195,3.177,0.92235,1.2682-0.39712,1.8914-2.0468,1.9472-3.3307-0.35869-0.87111-1.2298-2.3059-1.2298-2.3059l-0.81987-0.0512-0.71739-1.7422s-1.5116,0.98641-1.486,1.8447c0.0256,0.8583,1.5885,1.5885,1.5885,1.5885s-0.90121,0.56325-1.7422,0.30745c-0.0769,0.87111,1.0248,0.70457,1.4348,0.71738,0.20497,0.62771,0.81987,0.9736,0.81987,0.9736s0.38432,0.96078-0.6149,0.87111c-0.99922-0.0897-2.1781-2.3919-3.5869-1.3323-1.4988,1.1273,0.66614,3.177,0.66614,3.177s-1.3195,0.69176-2.1009,2.4596c-3.1898-2.6902-5.0601-1.4348-8.6086-0.71739z'/%3E %3Cpath d='m102.46,111.67c1.3323,1.2554,0.40316,3.3422,0.92235,3.7407,0.55085,0.42274,1.3323-0.20497,1.3323-0.20497,1.3963,0.37151,3.8944-0.40993,3.8944-0.40993,1.0994,0.61473,0.66541-0.29241,1.3323-0.25621,0.58928,1.5116,2.5621,1.2298,2.5621,1.2298s-1.8063-1.8447-2.9208-2.3571c-0.8583,0.51242-3.3564,0.58928-3.7919,0.51242-0.48533-0.0857-0.17935-0.67896-0.40994-1.0248,0.91849-0.89406,0.19216-3.1129-0.30745-3.9456-2.036-1.3563-4.4684,0.96777-2.6133,2.7158z'/%3E %3Cpath d='m93.599,107.92c-1.6758,0.45291-4.5835-2.165-5.9423-1.1595s-0.72467,3.4784,0.18117,4.7104c0.885,1.2036-1.2953,1.6396-1.8841,2.3552-0.55353,0.67276,0.18117,1.4493,0.18117,1.4493l0.61597,0.39857-0.1087,0.90583,0.3261,1.087s0.29892,0.26269,0.39857-0.0725c0.28081,0.28081,0.02966,1.0928,0.72467,1.1957-0.24887-0.52003,0.18117-1.9566,0.18117-1.9566s1.2138,0.0906,1.5218-0.4348c0.30798-0.52539-0.28987-1.6667-0.28987-1.6667h0.36233c-0.40763-0.28081-0.5435-1.1232-0.5435-1.1232s1.6849-0.53444,1.6667-1.8117c-0.01812-1.2772-2.7356-2.636-1.7392-3.2972,1.1051-0.73373,3.0255,1.9023,4.6741,0.68844,1.6315-1.2012,0.57974-0.0362,0.57974-0.0362s0.74569-1.6783-0.90584-1.2319z'/%3E %3Cpath d='m102.25,89.971c-2.2418-0.93516-6.8216-0.99281-9.3773-2.2546-1.1209,0.07046-1.6205,0.95438-1.6654,1.3067-1.1722-0.05765-1.9664,1.7871-1.7935,2.1522-2.1329-0.86471-3.1258,2.5108-2.434,3.2026-1.8191,0.07686-1.5949,2.402-1.7678,3.0489-0.58288,1.4156,0.1298,1.8919,1.281,1.3835,0.17294,0.6149-0.06911,0.95934-0.58928,1.0761,3.1575,3.6133,4.9421-2.2236,7.7119-2.2034,3.4583-1.0124,4.8167-2.7158,4.8167-2.7158l1.3579,0.17934s2.4596-5.1754,2.4596-5.1754z'/%3E %3Ccircle cx='105.145' cy='87.384' r='3.305'/%3E %3Cpath d='m99.33,113.41c-2.0497-0.37151-5.4444-2.498-5.7903-5.2779,1.9088-7.4941,11.755-3.5807,12.604-9.2173-0.21639-3.7187,0.44951-7.3999,2.5119-10.511,0.96079-1.217,2.2034-1.5373,2.2034-1.5373s0.22257,0.79372-0.10248,1.3323c1.6269-0.17935,3.856,0.7302,5.3804,0.81987,0.44837,0.90954,0.40994,1.2426,0.30745,1.7935-0.10248,0.55085-0.71738,0.40993-0.71738,0.40993-0.39767,0.37723-0.87565,0.76105-1.9472,0.56366-0.80706,0.6149-2.5108,0.76863-2.5108,0.76863s3.5613,3.7535,2.972,4.9192c0.74301,0.34588,1.8447,1.9984,1.8447,1.9984s2.434-1.281,3.2282-2.4596c1.4092,0,3.715,1.4732,4.868,1.6397,1.4092,1.1401,2.8183,2.3059,2.8183,2.3059s-1.6782,1.1017-2.4084-0.3587c-0.88392,0.0769-2.7927-2.0369-5.4316-1.3835-0.0769,2.3443-2.6646,3.9969-2.6646,3.9969s2.4153-0.33802,3.7406,0.46117c1.3707,1.153,3.382,2.7158,3.382,2.7158l1.7935,3.0745s-1.6397,0.28183-2.2546-1.8447c-0.61491,1.7166-0.64052-1.0633-3.0745-2.3571-0.74301,0.0897-1.1145,0.14092-1.7422-0.35869-1.755,0.47399-3.8303,1.4988-6.3028,1.2298-1.755,0.55085-3.0361,2.0112-4.8167,2.8183-1.7807,0.80706-2.3059,0.40993-2.3059,0.40993l-1.4348,0.0512c-0.20699,0.86376-0.0897,2.1778-0.87111,2.4084,0.49961,0.53804-0.35869,2.8311-1.2298,3.2282,0.40993,1.4732,1.6108,1.9242,2.8695,2.6646,0,0,1.1145-0.51241,1.8447,0.15373,0.73019,0.66614,1.486,2.5621,1.486,2.5621s-1.5197,0.10268-1.9984-0.10248c-0.47871-0.20516-0.52523-0.70458-1.0761-0.56366-3.4716-3.0873-5.3024-1.8593-5.6366-2.5621-0.34252-0.72035,0.81987-2.6005,0.46118-3.7919z'/%3E %3Cpath d='m90.99,99.655c0.18117-0.22646,1.4493,0.25363,1.4493,0.25363l2.3189,1.4493,4.7104,3.0436,1.6667,2.4276-3.0074-0.9783-4.1668-3.5871-2.2465-1.4493s-0.90584-0.93301-0.72467-1.1595z'/%3E %3Cpath d='m118.85,107.37c-1.6269-0.40994-5.6366,4.458-5.6366,4.458l3.0233,3.2795s0.0897-5.5854,2.6133-7.7375z'/%3E %3Cpath d='m99.023,93.789c-0.88723,1.1368-0.96662,3.4287,0.18756,4.3531,0.10881,1.3911,1.2915,4.1971,2.2208,4.4605,1.0153,0.28784,5.0729,1.2298,6.6614,0.97359-0.30381,2.5745,1.7164,4.641,3.5869,5.9953-0.0136,0.23103-0.0168,0.51306,0.19928,0.79864,0.20936,0.27664,1.1923,0.32734,1.2355,0.17495,0.43591,0.6126,2.5473,0.88157,2.7003,0.60869,0.14884-0.26552-3.1056-2.5307-3.8276-3.222-0.6133-1.1442-1.7749-3.6938-2.0497-5.7391-1.5973-1.9003-4.3395-1.8623-4.3395-1.8623l0.0864-3.7231,0.15373-4.2018-1.486-0.76863s0.29956-0.13652,0.46117-0.30745c0.36089,0.15517,1.0391-0.56988,1.1273-0.77484,0.34187,0.12113,0.65138,0.11952,0.71117-0.06314,0.0528-0.16132,0.11399-0.87942,0.23863-1.2505,1.1211-0.98705-0.16365-3.08-1.8778-3.1144-1.6961-0.03441-2.0765,2.0232-2.044,2.1796,0.15932,0.64556,0.12499,0.97102,0,1.1273-0.12777,0.15976-0.71739,0.51242-0.71739,0.51242s-0.94797-0.44837-2.1009,0-2.4468,1.0505-2.5108,1.7935c-0.52523,0.07686-1.3835,0.75582-1.5373,1.3323-0.46118-0.08967-1.0633,0.29464-2.0497,1.8959-1.7678,0.78144-1.8703,4.5605-1.8703,4.5605s-0.47719,0.69496-0.49961,1.0633c-0.02242,0.3683,0.16654,0.70458,0.39712,0.64053,0.02562,0.24339,0.34588,0.46117,0.4868,0.38431,0.05124,0.2434,0.40298,0.37952,0.6149,0.34588,0.01922,0.16654,0.70137,0.12491,0.75582-0.0256,0.06008-0.16611-0.0675-0.99692,0.0128-1.0633,0.07366-0.0609,0.64052,0.37151,0.79425,0.25621,0.15373-0.11529-0.02936-0.48449-0.11529-0.62771-0.07686-0.12811-0.56366-0.26902-0.67895-0.87111s0.30745-1.4348,0.30745-1.4348,1.9216-1.5116,2.1393-2.8055c1.4476,0.14092,2.213-1.1241,2.6261-1.6013z'/%3E %3Cpath d='m95.679,88.37c0.43876-1.0729,2.0241-0.97359,2.0241-0.97359s0.56686-1.4924,2.703-0.60209c0.80386-0.62131,2.9208,0.26902,2.9208,0.26902s0.7927-1.0562,1.8319-0.93516c1.9248,0.22418,2.245,1.9888,2.1265,2.2931-1.0537,0.26582-2.879-0.85629-4.2659-0.53804-0.81026,0.45797-2.1233,0.94157-2.6133,1.6013-1.2842,0.13451-2.655-1.1818-4.7271-1.1145z'/%3E %3Cpath d='m99.689,90.151c0.4804-0.29464,1.6588-0.81262,2.4596-0.17935,0.83908,0.90314,2.1265,1.7422,2.1265,1.7422l1.4604,0.6149,0.66614,0.40994-0.43556,6.6871c-1.3518-1.3831-2.6186-1.6253-3.5869-3.2539-0.51883-0.69817-0.1217-2.3763-1.0248-3.4844-0.90314-1.1081-1.8639-1.8575-1.6654-2.5365z'/%3E %3Cpath d='m103.2,92.082s0.76544-0.14493,0.97831,0.03623c0.26722,0.09058,0.52538,0.16758,0.59785,0.39857,0.28987,0.08605,0.48915,0.23552,0.48915,0.45292,0.27175,0.07247,0.38045,0.56162,0.38045,0.56162l-0.25363,0.38045s-0.28987-0.27175-0.3261-0.56162c-0.1834-0.09031-0.5888-0.1857-0.68844-0.45292-0.31704-0.0317-0.52085-0.19476-0.57973-0.47104-0.2944,0.06794-0.59786-0.34422-0.59786-0.34422z'/%3E %3Cpath d='m109.68,87.717c-0.43556-0.4868-1.2042-0.1281-1.2042-0.1281l-2.0497,3.5357-0.89673,0.74301-0.0769,2.7671,0.743,2.5877-0.25621,1.9984s1.0322-0.96837,1.153-1.5116c0.11529-0.51882-0.38432-2.2034-0.38432-2.2034s-0.6149-1.0505,0.12811-2.9976c0.743-1.9472,2.434-3.5613,2.8439-4.7911z'/%3E %3Cpath d='m114.74,90.868s-3.2003,4.5733-8.4398,6.2003c-1.4476,0.34588-0.92236-3.382-0.92236-3.382l-0.35869,0.10248s-0.80706,3.651,1.1273,3.6894c5.2651-1.0376,9.2156-6.5806,9.2156-6.5806l-0.63-0.028z'/%3E %3Cpath d='m116.91,117.16s-0.4868,0.3587-1.1273,0c-0.33307-0.76862-1.2298-0.81987-1.2298-0.81987s-0.57758-1.6593-1.486-1.1786c-0.14091-0.8583-1.1273-0.40993-1.1273-0.40993s-0.0256-1.2426-1.1786-1.0761c0.38431-1.422-1.5885-1.3323-1.5885-1.3323s-0.064-1.6013-2.972-1.281c6.2643-2.8055,11.222,4.4068,11.222,4.4068'/%3E %3Cpath d='m119.88,117.77s1.4476,1.6269,2.2034,1.6397c0.75582,0.0128,0.81987-1.5885,0.81987-1.5885s0.2434,0.69176,0.6149,0.51242c-0.0384,0.48679,0.46118,0.6149,0.46118,0.6149s-1.3067,3.0361-5.0217,0.15372'/%3E %3Cpath d='m108.55,118.39-0.51242,2.1009s-0.65333,0.58928-0.46118,0.71739c0.19216,0.1281,1.2298-0.20497,1.2298-0.20497s1.6141-0.19215,2.1009-0.66614c0.33308,0.75582,1.0761,0.81987,1.0761,0.81987s0.0512-0.32026-0.0512-0.51242c0.35869,0.0641,0.66615-0.0512,0.66615-0.0512s0.20496-0.58929-0.25621-0.81987c0.0512-0.43556,0.26901-0.81987-0.51242-0.76863-0.57647,0.6149-1.9984,1.3195-2.3571,1.0761-0.35869-0.2434,1.4092-1.0248,0.92236-2.0497'/%3E %3C/g%3E %3C/g%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 4'%3E %3Crect fill='%2300A551' width='6' height='4'/%3E %3Crect fill='%23FFD500' width='6' height='3'/%3E %3Crect fill='%231A206D' width='6' height='2'/%3E %3Crect fill='%23EA2839' width='6' height='1'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 720 480'%3E %3Crect fill='%23D21034' width='720' height='480'/%3E %3Cg fill='%23007E3A'%3E %3Crect width='480' height='240' x='120' y='120'/%3E %3Ccircle fill='%23FFF' cx='390' cy='240' r='80'/%3E %3Ccircle cx='420' cy='240' r='80'/%3E %3C/g%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='-225 -114 450 300'%3E %3Ctitle%3EFlag of Malawi%3C/title%3E %3Crect x='-225' y='-114' width='450' height='300'/%3E %3Cg fill='%23CE1126'%3E %3Ccircle r='64.5'/%3E %3Crect x='-225' y='-14' width='450' height='100'/%3E %3Cg id='r16'%3E %3Cg id='r8'%3E %3Cg id='r4'%3E %3Cg id='r2'%3E %3Cpath id='r' d='M0-102c-2.2,0-3,3.3-3,6.5 0,8 1,12 3,23.5 2.04-11.5 3-15.6 3-23.5 0-3.3-1-6.5-3-6.5'/%3E %3Cuse transform='rotate(5)' xlink:href='%23r'/%3E %3C/g%3E %3Cuse transform='rotate(10)' xlink:href='%23r2'/%3E %3C/g%3E %3Cuse transform='rotate(20)' xlink:href='%23r4'/%3E %3C/g%3E %3Cuse transform='rotate(40)' xlink:href='%23r8'/%3E %3C/g%3E %3Cuse transform='rotate(-80)' xlink:href='%23r16'/%3E %3C/g%3E %3Crect x='-225' y='-21.5' width='450' height='7.5'/%3E %3Crect x='-225' y='86' width='450' height='100' fill='%23339E35'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 840 480'%3E %3Cdefs%3E %3ClinearGradient id='a'%3E %3Cstop stop-color='%23fff' offset='0'/%3E %3Cstop stop-color='%23f15770' offset='1'/%3E %3C/linearGradient%3E %3CradialGradient id='b' xlink:href='%23a' gradientUnits='userSpaceOnUse' cx='842.31' cy='103.66' r='25.86' gradientTransform='matrix(.18574 .04718 -.04532 .18635 233.8 198.77)'/%3E %3CradialGradient id='c' xlink:href='%23a' gradientUnits='userSpaceOnUse' cx='651.52' cy='550.46' r='25.86' gradientTransform='matrix(-.17642 -.07067 .06515 -.16392 430.54 377.88)'/%3E %3CradialGradient id='d' xlink:href='%23a' gradientUnits='userSpaceOnUse' cx='380.84' cy='740.37' r='25.86' gradientTransform='matrix(.0989 .0037 -.0045 .1943 442.36 123.3)'/%3E %3C/defs%3E %3Cpath fill='%23ce1126' d='M0 0h840v480H0z'/%3E %3Cpath fill='%23fff' d='M0 0h560v480H0z'/%3E %3Cpath fill='%23006847' d='M0 0h280v480H0z'/%3E %3Cg fill='%23fcca3e' stroke='%23aa8c30'%3E %3Cpath stroke-width='.35' d='M466.96 303.53l.3 5.88 2.21-1.47-1.7-4.84z'/%3E %3Ccircle stroke-width='.3' cx='466.7' cy='301.93' r='1.89'/%3E %3Cpath stroke-width='.35' d='M474 312.69l-4.3-4.12-1.93 1.55 5.84 3.4z'/%3E %3Cpath stroke-width='.3' d='M473.63 315.01c-.6-.81-.4-2 .45-2.66a1.87 1.87 0 0 1 2.64.29c.6.81.4 2-.45 2.66-.85.65-2.03.52-2.64-.29z'/%3E %3Cpath stroke-width='.35' d='M507.04 251.22l4.4 4.38.52-2.22-4.03-2.7z'/%3E %3Ccircle stroke-width='.3' cx='506.45' cy='250.09' r='1.84'/%3E %3Cpath stroke-width='.35' d='M518.65 253.82l-6.73 1.92.55-2.22 5.79-.57z'/%3E %3Ccircle stroke-width='.3' cx='519.74' cy='252.89' r='1.8'/%3E %3Cpath stroke-width='.35' d='M496.03 287l-4.1-6.4.65-.33 4.65 5.5z'/%3E %3Ccircle stroke-width='.3' cx='491.52' cy='279.12' r='1.91'/%3E %3Cpath stroke-width='.35' d='M496.29 287.17l5.22.95.19-.71-4.37-1.73z'/%3E %3Ccircle stroke-width='.3' cx='503.1' cy='288.18' r='1.89'/%3E %3Cpath stroke-width='.3' d='M373.59 301.72c0 .91-.71 1.56-1.4 1.56-.66 0-1.21-.74-1.21-1.64 0-.91.55-1.65 1.22-1.65.68 0 1.39.83 1.39 1.73z'/%3E %3Cpath stroke-width='.35' d='M373.56 304.65l1.2 6.57-1.6-.63-.57-5.7z'/%3E %3Cpath stroke-width='.3' d='M375.01 302.42c.77 1-.53 2.51-1.9 2.89-1.39.37-3.1-.26-3.09-1.52.02-1.44 2.01-.69 2.54-.86.83-.26 1.63-1.58 2.45-.51z'/%3E %3Cellipse stroke-width='.3' cx='363.57' cy='312.49' rx='2.04' ry='1.48'/%3E %3Cpath stroke-width='.35' d='M367.03 312.14l6.3-.31-1.06-1.26-5.18.56z'/%3E %3Cpath stroke-width='.3' d='M367.56 311.41c.53 1.6.57 3.77-1.22 3.54-1.79-.23-1.45-1.83-1.59-2.44-.26-1.13-1.3-2.14-.23-3.23 1.08-1.1 2.51.53 3.04 2.13z'/%3E %3Cellipse stroke-width='.3' cx='347.01' cy='276.95' rx='1.24' ry='1.88'/%3E %3Cpath stroke-width='.35' d='M347.03 281.12l.14 6.11-1.59-1.44.12-4.87z'/%3E %3Cpath stroke-width='.3' d='M349.39 279.26c.32 1.41-1.75 2.2-3.15 1.94-1.4-.26-2.47-1-2.26-2.29.21-1.3 1.96-1 2.56-.64.6.35 2.4-.99 2.85.99z'/%3E %3Cellipse stroke-width='.3' cx='336.23' cy='286.5' rx='2.13' ry='.97'/%3E %3Cpath stroke-width='.35' d='M340.06 286.5l4.8-.32 2.04 1.58-6.91-.26z'/%3E %3Cpath stroke-width='.3' d='M338.3 283.93c1.3.04 2.19 1.47 2 2.98-.18 1.51-1.35 2.74-2.54 2.55-1.2-.19-1.1-1.2-1.08-1.5.03-.3.7-.85.77-1.34.07-.48-.34-1.57-.19-2.07.16-.5.46-.64 1.04-.62zM334.43 246.74c-.54.85-1.55 1.5-2.07 1.17-.52-.34-.33-1.52.2-2.38.53-.85 1.39-1.27 1.9-.94.52.34.5 1.3-.03 2.15z'/%3E %3Cpath stroke-width='.35' d='M329.08 256.35l2.68-6.31-.4-.35-3.04 4.44z'/%3E %3Cpath stroke-width='.3' d='M331.27 250.05c-1.33-.97-1.62-1.96-1.2-2.94.43-.98 1.43-.35 1.43-.35s.65.73 1.13.98c.49.26 1.25-.08 1.82.72.57.8.23 1.61-.23 1.82-.45.2-1.84.57-2.95-.23zM320.14 249.22c.95.54 1.46 1.46 1.13 2.06-.33.59-1.37.63-2.32.09-.95-.54-1.45-1.46-1.12-2.06.32-.6 1.36-.63 2.31-.09z'/%3E %3Cpath stroke-width='.35' d='M322.92 251.99l4.95 2.97-.15 2.33-5.37-4.61z'/%3E %3Cpath stroke-width='.3' d='M322.88 252.55c-1.1 1.23-2.1 1.41-3.01.87-.92-.54-.18-1.47-.18-1.47s.78-.58 1.09-1.04c.3-.45.06-1.27.91-1.75.86-.47 1.6-.04 1.76.44.14.48.35 1.93-.57 2.95z'/%3E %3C/g%3E %3Cg fill='%23aa8c30'%3E %3Cpath d='M468.03 303.97s-.36.24-.56.63c-.19.38-.4 1.16-.4 1.16l.02-1.9.64-.37.3.48z'/%3E %3Cpath d='M468.31 302.78s-.44.75-1.5.7c-1.04-.07-1.55-.55-1.68-1.09-.13-.53-.13-.92.21-1.54.34-.62-.5.59-.5.59v1.18l.77.91.65.2.65.04.82-.27.55-.42.03-.3zM473.84 312.44s-.53.28-.93.13a21.72 21.72 0 0 1-4.57-2.34l4.99 3.1.51-.89zM476.94 313.85s-.06.87-1.02 1.3c-.96.44-1.64.24-1.99-.18a1.87 1.87 0 0 1-.5-1.47c.03-.7-.18.75-.18.75l.53 1.06 1.09.45.68-.12.58-.26.61-.62.31-.63-.11-.28zM508.79 251.4s-.13.2-.13.52l-.02.9-1.08-1.2.55-.71.68.49zM508.21 249.83c.06.86-1.2 2.1-2.13 1.7-.94-.38-1.62-1.36-1.1-2.33.5-.97-.26.37-.26.37l.13 1.43.89.81 1.11.07.87-.5.54-.97-.05-.58zM521.38 252.18s-.21-.6-.1.07c.1.68-.76 2.11-1.76 1.98-1-.13-1.46-1-1.38-1.81.09-.81-.16.28-.16.28l.15 1.08.54.5.77.46.89-.15.8-.52.37-.76v-.55l-.12-.58z'/%3E %3Cpath d='M516.87 253.18s.03.45-.56.78c-.6.32-1.73 1-1.73 1l3.7-1.09-.3-.9-1.11.21zM494.43 282.57s-.2.22-.21.68c-.01.47.1 1.02.1 1.02l-2.08-3.29.61-.39 1.58 1.98zM493.29 279.48c-.37.87-1.88 1.42-2.6 1-.73-.43-1.35-2-.46-2.69l-.46.4-.24.9.33.94.73.82.67.2 1.06-.2.78-.62s.56-1.61.19-.75zM500.61 287.01s.02.39-.66.39l-2.1.02 3.44.67.17-.7-.85-.38z'/%3E %3Cpath d='M504.85 287.82c.3 1.15-.71 2.26-2.03 1.87-1.32-.39-1.68-1.7-1.26-2.4l-.33.82.24 1.1.8.7.84.18.84-.21.86-.82.21-.98-.17-.26zM374.92 302.46c.36.4-.2 1.9-1.69 2.5-1.49.6-2.23.03-2.63-.47-.4-.5-.37-1.04-.37-1.04l-.2.28.2.78.74.64 1.32.29.99-.19.96-.51.5-.52.42-.64.06-.77-.24-.4h-.06l-.02.04.02.01z'/%3E %3Cpath d='M373.59 305.73s-.26.08-.48.46c-.23.37-.31 1.04-.31 1.04l-.12-1.76.77-.4.14.66zM368.62 311.01s-.14.38.26.58c.4.2 1.33.43 1.33.43l-2.44.08-.26-.94 1.11-.15zM367.79 312.53s.03.09.02.25c0 .16-.05.4-.19.7-.29.6-.4 1.3-1.28 1.12a1.62 1.62 0 0 1-1.33-1.4c-.09-.58-.29-.81-.29-.81v.77l.54 1.3.88.4h.77l.6-.23.28-.78.14-.63-.14-.69z'/%3E %3Cpath d='M361.63 312.36s.29 1.12 1.53 1.15c1.25.03 1.57-.35 1.57-.35l.14.44-.46.23-1.08.12-.96-.19-.44-.33-.34-.59.04-.48zM349.24 279.02s.04.13-.04.54c-.09.4-.85 1.38-2.28 1.4-1.43.03-2.02-.45-2.4-.93-.4-.47-.46-1.14-.46-1.14l-.04.71.55.89 1.41.66h1.34l1.37-.4.6-.65.13-.73-.18-.35zM346.98 282.05s-.51.04-.77.27c-.25.23-.48.5-.48.5l-.02-1.69 1.27.1v.82zM340.84 286.53s-.1.1.64.43c.74.33 4.1.7 4.1.7l-5.4-.15.2-.92.46-.06zM340.23 286.63s-.01.2-.28.75-.95 2-2.09 1.8c-1.14-.2-1-1-1-1.12v-.4l-.2.82.26.57.47.3.92.1.63-.27.68-.65.35-.69.29-.73-.03-.48zM337.32 286.77s-.03.26-.92.29c-.9.02-2.18-.36-2.18-.36l.43.53.74.19.92.01.72-.07.29-.59zM334.57 248.86s.2.58-.31.95-1.62.6-2.33.2c-.71-.4-2-1.7-2-1.7l.6 1.07.94.78 1.3.37 1.26-.2.57-.5.17-.4-.2-.57z'/%3E %3Cpath d='M330.76 250.59s.03.15 0 .72c-.03.58-.26 1.53-.26 1.53l1.14-2.54-.45-.4-.43.69zM323.72 252.58s-.17-.17.17.58 3.12 3.42 3.12 3.42l-4.43-3.74.51-.72.63.46zM322.24 253.01s-.57.35-1.08.38c-.51.03-1.36-.03-1.48-.64-.1-.6.17-.86.17-.86l-.36.83.14.46.65.38.91.09.82-.4.23-.24zM320.45 251.11s.06.17-.77.06c-.82-.12-1.81-1.07-1.81-1.07l.65 1.04 1.39.57.54-.6z'/%3E %3C/g%3E %3Cg fill='%239ca168'%3E %3Cpath d='M524.81 238.85c-.4 5.03-5.37 7.6-7.96 9.48-2.6 1.89-3.86 4.22-3.86 4.22l-.88 2.93-.42 1.88-.09.65c.17.53.4 1.43.43 2.8.07 2.28-.15 5.54-.15 5.54l3.5-2.5 2.53-.95.76-.13s-2.8 2.8-3.91 5.82c-1.1 3.03-3.16 9.45-6.99 11.53-3.83 2.07-6.22 1.21-7.5 2.33-1.27 1.12-1.32 1.43-1.32 1.43l-1.63 2.23-1.3 1.67-1.2.84-.76.62c-.03.62-.1 1.43-.31 2.17-.42 1.48-.92 3.12-.92 3.12s.76-.47 1.7-.58c.92-.12 1.78-.11 1.78-.11s-.72.89-.98 1.75c-.25.87.17 6.05-4.77 9.16-4.94 3.11-17.52 2.62-17.52 2.62l-2.38.95-2.25 1.68-2.05 2.24-.15.6s-1.55 1.9-2.66 2.63l-3.66 2.42s2.17-.09 2.9.17c.72.26 4.6 1.99 4.6 1.99s-2.84-.06-4.77.69c-1.94.75-10.74 5.73-15 5.59-4.25-.14-10.33-6.37-10.33-6.37l-2.76-1.93-4.57-.89-5.65-.32.08-.74.1-.91s1.92-.22 5 .14c2.65.32 3.52 1.2 5.74 1.45a9.45 9.45 0 0 0 4.66-.43c.81-.37 7.65-6.16 7.65-6.16l7.69-2.7 2.93.44 1.3.34 1.2.35s-.4.63-1.26 1.42c-.85.8-1.92 1.35-1.92 1.35l.94.75 4.86-.78 1.58.41s.13.03.46.24c.07-.35.27-1.07.7-1.64.6-.78 3.33-3 4.5-3.78 1.17-.78 1.43-.89 1.81-1.3.38-.41 1.96-4.47 1.96-4.47l.21-2.07 5.37-5.17 3.62-3.85 1.58-4.38-.17-.89s1.3 1.34 1.06 4.06c-.23 2.73-.83 3.68-.83 3.68s3.66-2.53 5.62-3.4a6.28 6.28 0 0 1 3.14-.6 8.82 8.82 0 0 0 2.78-2.42c1.07-1.55 1.35-2.01 1.35-2.64 0-.62.17-3.65.17-3.65l-.34-9.27 3.15-6.98 4.58-4.1.87-.52s-.36.97-.43 1.64c-.06.67-.06 1.86-.06 1.86s2.32-3.18 3.51-3.76l.74-.35c.25-.44.68-1.33.94-2.56.37-1.76.43-4.12.43-4.12l.07-3.84-.75-2.98-2.13-5.73-.08-7.54-1.6-2.15s1.51-.12 3.39 2.59c1.87 2.7 2.43 6.5 2.43 6.5l4.35-13.35s1.16 1.57 1.99 4.21c.83 2.64 1.09 4.43 1.09 4.43l1.71-3.7c-.01.03-.05.25.2 1.3.3 1.23 2.96 2.77 2.56 7.8zm-88.33 85.35s-.81-2.05-5-4.12c-4.19-2.08-7.31-2.48-7.31-2.48l-.05 1.54 6.58 2.87 3.28 2.68 2.5-.5z'/%3E %3Cpath fill='%23717732' d='M466.42 311.65c.4-.54 3.94-3.7 5.75-4.62 1.81-.93 4.22-1.1 4.22-1.1 2.5-.46 2.9-.1 8.65-3.27s7.03-6.83 8.13-7.71c1.11-.89 3.13-1.1 3.13-1.1s-2.4 2.83-4.51 5.14c-2.1 2.31-4.37 3.78-7.6 5.96-3.24 2.19-9.97 2.3-9.97 2.3-2.84.64-3.8 1.33-5.37 2.71-1.58 1.39-2.65 2.9-2.65 2.9s-.18-.67.22-1.21zm15.87-16.66c-5.32 4.86-7.07 9.38-7.07 9.38s4.73-4.06 7.16-6.4c2.42-2.33 5.83-3.45 7.36-4.88 1.54-1.43 1.62-2.63 2.6-3.54.98-.9 1.7-1.34 1.7-1.34s-2.34-1.82-11.75 6.78zm-11.23 11.25s2.28-1 3.14-3.04c.64-1.51.3-1.9 1.28-3.63 0 0 5.53-5.34 7.49-7.65 3.5-4.1 1.92-7.47 1.92-7.47s.38 1.73-1.07 3.54c-1.45 1.81-8.59 6.7-9.45 9.51-.87 2.8-.39 2.91-.77 4.4-.89 3.45-2.54 4.35-2.54 4.35zm-3.68 13.82s-2.79-1.87-5.9-1.67c-6.37.4-11.75 4.32-15.95 4.43-4.2.12-5.86-2-9.1-4.2-3.47-2.36-12.04-2.02-12.04-2.02l-.06.2-.06.25s5.9.06 8.41.76c4.8 1.33 7.4 6.33 12.85 6 7.08-.41 12.88-4.72 15.77-4.7 4.97.03 6.08.95 6.08.95zm-31.56-3.22s4.94.89 8.77-1.93c3.84-2.8 8.4-6.6 10.9-6.78 2.52-.17 5.16.48 5.16.48s-3.2-1.43-5.75-1.39c-2.56.05-5.15.4-7.54 1.82-2.39 1.43-3.54 4.01-6.13 5.66a16.79 16.79 0 0 1-5.4 2.14zm-.88 6.63c-.66 0-1.42.43-1.68.39-.25-.04-1.77-1.6-3.88-2.72-2.1-1.12-5.25-1.8-5.25-1.8s-.39.1.31.33c.7.24 3.3 1.12 4.96 1.9 1.67.78 3.35 2.55 3.5 2.83.15.28.74 1.08 1.98 1.04 1.23-.05 1.73-.76 1.6-1.23-.13-.48-.88-.74-1.54-.74zm3.47-4.8s1.96 1.12 5.2 1.04c6.9-.17 11.25-4.9 15.77-6.62 4.5-1.73 6.82-.24 6.82-.24s.12-.24-.02-.35a9.23 9.23 0 0 0-5.05-1.58c-7.58.12-14.68 4.9-17.77 6.2-3 1.25-4.94 1.56-4.94 1.56zm73.4-52.26c-2.33 2.4-5.8 10.07-7.33 12.16-1.53 2.1-3.45 2.72-4.28 3.57-.73.74-3.51 4.49-4.15 5.4-.64.9-.84.65-1.28 1.04-.45.38-.68.4.06.21.75-.2.98-.65 2.13-1.94 1.15-1.3 1.09-1.88 2.92-3.52 1.83-1.65 5.15-3.52 6.8-5.54 1.64-2.01 5-9.82 6.76-11.72 1.9-2.06 5.22-3.29 5.22-3.29s-2.62-.76-6.85 3.63zM500 280.95s-.09-1.38 1.62-3.42c1.7-2.03 2.3-1.77 3.66-4.75 1.36-2.98 1.96-5.88 3.07-9.03 1.1-3.16 3.02-6.27 3.02-6.27s-1.79.17-3.62 2.64c-1.83 2.46-4.73 6.96-6.22 11.36-1.5 4.41-1.53 9.47-1.53 9.47zm-2.17 2.89s.63-.34.72-4.19c.09-3.84-.21-9.24.9-11.92 1.1-2.68 6.98-9.12 6.98-9.12s-2.43.6-5.84 3.32c-3.4 2.72-4.85 6.14-4.68 8.73.17 2.6 1.62 5.53 1.75 8.09.12 2.54.17 5.09.17 5.09zm13.84-26.47s1.45-5.22 2.04-6.48c.6-1.27.63-2.02 3.58-5.33 1.7-1.9 3.35-3.12 4.06-5.77.71-2.65.69-10.05.69-10.05s-.77.69-1.4 1.99c-.62 1.3-.17 6.1-1.28 8.32-1.1 2.22-3.6 7.44-4.85 8.56 0 0-.26-3.75.2-7.52.45-3.77 1.73-4.92 2.3-7.4.57-2.48.22-8.88.22-8.88s-2.01 2.08-3 4.47c-1 2.39-1.6 6.68-1.62 9.9-.03 3.24.74 5.86.85 7.7.1 1.84.25 2.7-.49 4.73-.73 2.01-.36.63-.82 2.59a45.72 45.72 0 0 1-.93 3.43l.45-.26zm-4.6-28.3s1.76 2.23 1.47 4.76c-.28 2.54-1.25 5.88-.25 8.53 1 2.65 2.47 2.9 2.87 4.43.4 1.53.42 4.51.42 4.51s.83-5.66.26-7.22c-.57-1.55-.82-.83-1.65-2.47-.82-1.64.03-6.14-.6-8.76-.62-2.62-2.52-3.77-2.52-3.77z'/%3E %3Cpath d='M402.55 323.75s.53-1.49 4.11-3.24c3.58-1.75 8.97-4.1 9.48-3.8.5.3-.28 2.25-.28 2.25l-3.47 1.05-2.77 1.63-3.24 2.1-3.83.01z'/%3E %3Cpath d='M411.67 314.34c-4.57.17-7.07 1.3-7.94 1.47-.3.06-.97.53-1.53.25-1.07-.53-2-2-2-2l-.97-.81-.23 3.28-6.67-5.79-.71 3.83-.85 1.76-6.62-6.25.31 4.84s-1.73.23-1.81.17l-4.72-3.28-1.39.46 1.54 2.85-5.97.46s-.48.26-1.3 1c-.8.76-1.25 1.46-1.25 1.46s-.18.3.03.44c.22.14 1.85.1 2.36-.09.5-.2.84-.9.99-.61.15.29.34 1.6 1.13 1.47.79-.13 3.56-2.23 5.53-1.31 2.2 1.03-2.85 2.52-2.33 4.08s4.17.9 5.1.4c.92-.5 3.68-3.94 4.82-2.63 1.57 1.82-3.31 3.24-2.41 5.06.87 1.76 3.6 1.37 4.92.6 1.32-.75 4.39-5.47 5.07-4.45 1.18 1.77-2.59 3.45-1.64 4.82.95 1.38 3.03-.05 4.42-1.02 1.38-.97 1.94-3.29 3.85-4.37 1.92-1.08 1.79-.63 2.32-.64.53-.03 2-1.5 2-1.5l4.51-1.9 2.2.15 1.15.54 2.25.32.27-1.9s-2.61-1.23-4.43-1.16zm-36.05.04l.95-1.7-.54-.82s-1.59-.89-3.04-2.36c-1.45-1.47-1.98-1.8-2.64-2.14-.66-.33-2.9-1.78-2.9-1.78l-1-3.72-.6-1.07-1.72.67-2.26-7.98-.45-1.43-.93-.06-1.86 4.84-2.08-3.02-.53-6.62-1.3 1.45-1.66 1.7-2.97-6s-.24-.16-.39.34c-.15.49-.4 2.38-.22 3.5-.8-.49-2.15-1.42-3.98-3-3-2.59-3.73-3.92-3.73-3.92l-1.4-3.17 1.31-2.8.66-3.32-2.9 1.19-.5-7.52-.45-2.38-3.5 5s-1.36-1.93-1.36-2.15l.07-4.75-.94-.28-1.43 2.68s-1.37-2.77-1.98-3.35c.1-1.07.26-3.78-.39-5.87-.81-2.67-1.77-4.09-1.43-6.26.34-2.18 1.23-2.39 1.13-3.36-.1-.96-1.54.63-1.06-.65s5.04-4.18 4.09-5.7c-.96-1.53-5.35 2.38-4.33-.24 1.02-2.63 5.25-2.67 5.49-6.33.15-2.28-3.99 1.42-4.36.27-.38-1.14 2.55-3.49 2.52-4.97-.04-1.49.54-1.66-.28-2.46-.81-.8-3.33 3.11-3.33 3.11l-2.76-1.04-.96 3.95-.85 3.35-3.4-2 .91 4.08.82 3.97-3.55-.9 1.88 3.39 2.44 2.48 1.51 2.05 1.1.58 1.46 1.46.5 2.18s.86 2.38.86 2.49l.14 2.34.03 1.56-.07 1.2-.06.46-.07.52-.03 1.42c-.67.07-1.75-1.02-2.15-.34-.42.73 2.05 2.63 1.58 3.1-.47.49-4.09-.73-4.3.44-.22 1.17.34 2.8 2.43 3.33 2.08.52 6.94 1.64 6.13 2.59-.8.95-6.09-2.9-5.88-.08a4.96 4.96 0 0 0 3.41 4.49c1.36.52 6.69-.09 6.39 1.17-.3 1.25-4.34-.4-4.73 1.42-.38 1.82 2.81 2.07 3.5 2.07.68 0 2.9-.08 3.74.57.86.65 3.84 3.8 5.71 5.4a98.67 98.67 0 0 0 6.03 4.43h-.05c-1-.1-3.1-.32-3.43.43-.42.97 8.01 3.98 5.59 4.91-2.42.93-5.03-2.57-5.73-.43-.7 2.14 1.6 3.95 2.92 4.73 1.31.78 8.79.16 7.32 1.85-1.46 1.7-6.88-1.14-6.93.87-.05 2 3.61 5.18 5.49 5.1 1.87-.09 3.93-3.1 4.78-1.47.86 1.62-1.44 2.28.36 2.71 1.8.43 3.09-1.85 5.18-1.44 2.1.42 5.39 1.75 7.23 3.42 1.84 1.68 3.73 3.62 3.73 3.62z'/%3E %3Cpath fill='%23717732' d='M404.74 322.82c1.28.02 1.45.71 1.62.7.17-.03 2.32-1.87 4.37-2.99 2.04-1.12 5.15-1.8 5.15-1.8l.2.29s-3.71.92-5.5 2.18c-2.22 1.56-3.96 2.53-4.07 2.8-.1.29-.92.83-2.17.85-1.26.02-1.8-.73-1.8-1.1 0-.37.92-.95 2.2-.93zm11.16-5.65s-1.1.11-1.73-.44a5.67 5.67 0 0 0-3.35-1.03c-1.34 0-3.47.73-5.17 2.36-.14.13-.48.75-1.93 1.73.5.1 1.48-.58 2.55-1.44 1.54-1.25 3.47-1.59 4.83-1.79 1.36-.2 2.22.58 2.84 1 .63.44 1.9.32 1.9.32l.06-.71zm-66.25-27.08c.14-.06.12-.36.03-.88-.2-.08-1.03-.43-2.89-1.53-2.17-1.3-6.68-4.89-6.68-4.89s1.87 1.82 3.75 3.5c1.87 1.69 5.24 3.76 5.24 3.76l.01.02c.3.03.5.04.54.02zm46.77 33.13s.68-.9 1.9-2.84c1.21-1.96 2.32-2.58 2.49-2.82.17-.24-.47-1.19-.83-1.92-.36-.74-.3-1.51-.3-1.58 0-.06.45 1.15 1.34 1.82.9.66 1.43 1.23 1.43 1.23s1.79-.24 1.83-.59c.04-.34-.04-.58-.34-.7-.3-.14-.64.26-1.45-.1-1.68-.73-2.36-3.28-3.37-3.37-1-.08-.28 2.7-.72 2.75-1.55.15-2.77-5.66-6.5-5.9-2.62-.17-3.08.32-3.21.9-.13.59 3.17 4.07 2.06 4.56-1.1.5-4.62-5.46-7.17-5.53-2.56-.06-2.77.91-2.58 1.47.19.56 2.83 1.06 2.21 2.92-.6 1.8-3.17-2.78-5.53-2.53-2.37.26-2.62.43-2.73 1.1-.1.67.83 1.65.5 1.88-.35.24-1.84.17-3.03 1-1.2.82-2.86 3.07-2.86 3.07s1.56-2.2 3.62-2.45c2.07-.23 7.29.03 7.29.03s-.7-.44-1.47-1.13-1.43-2.1-1.43-2.1 1.15 1.09 2.26 2c1.1.9 2.49 1.6 2.49 1.6s2.22.21 2.36.47c.15.26-.06.78-.97 1.77-.92 1-2.24 2.16-2.24 2.16s2.21-1.68 2.64-2.05c.43-.37 1.96-1.53 1.96-1.53s1.62.21 1.79.17c.17-.04.09-.6-1-2.2-1.08-1.6-2.11-3.33-2.11-3.33s1.33 1.22 2.68 3 1.15 2.6 1.7 2.69c.56.08 1.45.2 1.86.19.54-.03.4.77-.54 2.2-.93 1.42-1.48 3.26-1.48 3.26s.95-1.54 1.97-2.6c1.03-1.05 1.56-2.3 1.96-2.37.41-.06 1.78.1 1.97.02.2-.08-.33-.65-1.05-2.12-.72-1.47-.96-3.5-.96-3.5s.7 1.9 1.81 3.29c1.11 1.38 1.54 2.5 1.78 2.5.24.02 1.1-.1 1.72-.08.3 0 .34-.07.38.13.1.6-.15.97-.9 2.37-.74 1.4-1.23 2.8-1.23 2.8zm-28.28-16.4c1.6.54 2.21.54 2.21.54s-2.2-1.3-2.77-3.13c-.57-1.84-.06-5.7-1-5.66-.94.04-1.47 2.85-2.4 2.29-.94-.56.31-5.73-.7-7.93-1.03-2.2-3.44-3.74-4-2.94-.54.8-.42 5.55-1.9 4.52-1.5-1.04.12-5.1-.33-6.96-.44-1.86-1.57-3.2-2.42-2.75-.86.46.33 3.94-1 3.98-1.35.04-1.16-2.44-1.73-2.68-.58-.24-.77.5-1.09.03-.32-.48-.15-2.25-.85-2.08-.7.17-.57 1.53-.38 2.29.19.75.61 1.84.91 2.33.3.5 1.37 1.12 1.28 1.54-.08.4-.64.76-1.36.78-.73.02-2.37-.05-2.37-.05s1.75.54 2.4.6c.67.07 1.95-.27 2.27.31.32.58 1.85 2.66 1.85 2.66s.36-1.08.55-2.99c.2-1.9.1-3.56.1-3.56s.52 2.2.46 3.52c-.07 1.32-.56 3.89-.56 3.89s1.45 1.21 1.03 1.53c-.43.33-1.94.29-3.71.27-1.77-.03-4.28-.63-4.28-.63s2.26 1.08 3.83 1.34c1.58.26 5 .34 5 .34l2.35 2.66s1.12-1.93 1.28-3.84c.16-1.92-.04-4.15-.04-4.15s.49 2 .57 3.71c.09 1.71-.55 4.74-.77 5-.2.25-1.4 1-2.46 1.26-1.55.4-4.65.79-4.65.79s2.86.38 4.92-.11 2.3-1.06 2.88-.72c.57.35 1.08.98 1.08.98s1.24.96 1.8 1.2c.08.2-.96.63-1.49.96-.52.33-1.9.97-1.9.97s2.02-.73 2.91-.97c.45-.12 1.54-.52 1.54-.52l.6.32s.04-.43-.13-1.64c-.17-1.2-.43-2.38-.43-2.38s.7 1.1.92 2.15c.2 1.03.2 2.09.2 2.09s.18.3 1.78.84zm-40.81-46.75s.45-2.2.45-4.73c0-2.54-1.76-6.46-2.04-6.86-.29-.4-.46-.75-.46-.75l1.2-1.84-1.54 1.2s-.85-.17-1.59-.62c-.74-.46-1.1-1.15-1.1-1.15s.78.57 1.53.89c.75.3.94.2.94.2l-.6-2.56s-.78-.31-2.52-1.28-3.3-2.49-3.3-2.49 2.35 1.42 3.68 1.97c1.33.56 2.08.6 2.08.6s1.4-.43 2.11-.84 2.18-1.52 2.18-1.52-1.4.8-2.32 1c-.92.21-2.08.34-2.08.34l-.4-3.1-1.47-1.52c-1.16-1.53-2.05-3.7-2.05-3.7s1.2 1.52 2.15 2.24c.96.73 1.84 1.9 1.84 1.9s1.1-.58 2.15-1.3c1.05-.73 3.68-2.64 3.68-2.64s-1.5.8-3.58 1.77c-2.08.96-2.15.86-2.15.86s-.17-1.35.14-1.94c.3-.58.96-1.55.85-2.14-.1-.59-.54-.38-.71-.86-.17-.49.54-3.46.54-3.46s.17 1.07.2 1.62c.04.56-.26 1.32.49 1.32s4.26-3.53 4.7-4.18c.44-.66 1.09-2.46-.75-1.73-1.84.72-1.4 2.3-2.93 2.17-.45-.03-.96-2-1.54-1.52-.58.5-1.87 1.7-2.11 3.08-.24 1.38.3 3.5-.48 4.11-.78.63-1.46-2.38-3-1.97-1.53.42-1.87 2.53-1.63 3.36.24.83 3.58 4.7 2.52 5.18-1.06.49-3.65-3.28-5.04-.72-1.4 2.55 4.4 5.18 5.1 5.8.72.63.08.8 1.1 2.08s2.38 1.59 3.1 2.46c.71.86 2.83 4.97 2.83 7.63s-.17 3.64-.17 3.64zm15.39 22.43s-1.42-1.65-.95-4.37 2.34-7.52 1.7-8.13c-.64-.6-2.64 2.94-3.15 2.12-.51-.82 1.15-5.62.3-7.6-.85-2-.94-3.25-2.64-3.07-1.7.17-2.43 5.79-3.24 4.8-.81-1 .47-3.5-.08-4.84-.56-1.34-.86-1.82-1.7-1.6-.86.21-1.24 2.8-1.84 2.76-.6-.04-1.58-3.11-2.81-2.68-1.24.43 2.94 5.88 2.94 5.88s.74-.65 1.13-1.58c.38-.93.76-1.94.76-1.94s.34 1.77.05 2.46c-.3.69-.54 2.31-.54 2.31s-1.02.33-2.7.07c-1.68-.26-3.07-.95-3.07-.95s1.13.75 2.85 1.2c1.73.46 3.56 1.02 3.56 1.02s.45.56 1.22 1.58l1.42 1.88s.5-1.04.98-2.75c.5-1.7 1.66-4.51 1.66-4.51s-.36 3.4-.76 5.05c-.4 1.67-.83 4.02-.83 4.02s-1.5-.15-3.5-.51c-2-.37-4.72-1.06-4.72-1.06s2.38.95 4.7 1.57l3.77 1.02 1.83 2.41s.5-.88 1.22-1.89c.72-1.02 1.28-2.4 1.28-2.4s-.32 1.88-.88 3c-.55 1.13-.93 1.8-.93 1.8s-1.18.28-2.26.25l-3.3-.04s1.85.63 3.32.87c1.47.24 2.53.39 2.53.39s.11.66.9 1.8a6.01 6.01 0 0 0 1.78 1.66z'/%3E %3C/g%3E %3Cpath fill='%23fff' d='M412.7 331.62s-.83-.9-1.94-1.48c-1.1-.58-1.48-.4-1.48-.4l-.51-.19.97-2.53 7.3-6.97 1.12-7h.27l4.23-.05-.05 9.56 1.34.6 8.15 4.89-.03 2.12-1.19.46c-.79.31-.98.54-.98.54l-3.07.29-5.37-3.9-2.21-2.32-4.05 5.18-2.5 1.2z'/%3E %3Cpath fill='%23016848' d='M418.44 313.04s-.12.37-.17 1.45c-.06 1.07.07 6.72-.2 7.5-.28.76-4.2 2.38-6.45 4.34s-2.33 3.4-2.33 3.4-.74.06-2.13.58c-1.4.51-2.02 1.3-2.02 1.3s.83-3.5 4.46-6.72c3.64-3.23 5.4-3.5 5.8-4.04.4-.54 0-6.72.09-7.22.08-.5.52-.54.82-.58.3-.05 2.13 0 2.13 0zM427.71 333.68s.57-1.12.94-1.5c.37-.37 1.25-1 1.25-1s.14-.15-1.85-1.01c-1.99-.87-3-.58-4.43-1.59-1.42-1-2.84-2.73-2.84-2.73l-1.9 1.7s1.14 1.6 2.22 2.65c1.07 1.03 3.51 1.38 4.6 1.98 1.07.6 2.01 1.5 2.01 1.5z'/%3E %3Cpath fill='%23cd202a' d='M422 313s2.15-.13 2.45.2c.3.34.25.7.27.82 0 .1.1 5.22-.27 6.9-.4 1.76-1.3 3.51-1.82 4.03-.51.52-3.75 3.35-5.28 4.84-1.53 1.5-3.1 3.63-3.1 3.63s-.56-.63-1.05-1.24c-.48-.6-.96-.8-.85-1.2.11-.4 1.73-2.83 4.32-4.53 2.58-1.7 4.74-3.63 5.22-6.4.49-2.76.11-7.05.11-7.05z'/%3E %3Cpath fill='%23cd202a' d='M436.38 330.48s-.52-.52-2.34-.55c-1.82-.03-1.97.24-1.97.24s-1-1.26-2.62-2.3c-1.6-1.06-2.82-.9-4.55-2.04-1.73-1.14-2.64-2.8-2.64-2.8l1.33-2.72s1.5 2.1 3.04 3.24c1.55 1.14 4.98 2.25 6.08 3.2 1.09.96 3.67 3.73 3.67 3.73z'/%3E %3Cg%3E %3Cpath fill='%2330c2dc' stroke='%230872a7' stroke-width='.7' d='M452.73 299.48s-4.69-1.82-4.35-3.46c.34-1.64 10.83-4.4 10.83-4.4l.16-2.77s-1.53-.09-4.17.78a37.32 37.32 0 0 1-11.33 1.98c-2.74 0-4.23-.28-4.97-.5-.48-.15-36.95-2.3-38.14-2.28-.51 0-1.16-.01-1.99-.07-4.85-.34-7.98-7.78-7.98-7.78l-2.3.4s.7 3.66-.51 3.98c-2.38.64-18.23-7.84-18.23-7.84l-.87 3.44s9.68 5.18 9.4 7.11c-.3 1.93-3.17 1.78-3.17 1.78l1.23 2.31c.43.04 15.95.79 16.21 5.45.11 1.88-3.8 3-3.8 3l1.3 1.59v.79s8.62.05 11 1.38c2.4 1.34 3.6 3.26 6.53 4.94 2.92 1.68 22.75 1.27 25.85.4 3.5-.99 5.65-4.96 11.35-6.69 5.7-1.72 7.53-1.81 7.53-1.81z'/%3E %3Ccircle fill='%23fff' stroke='%230872a7' stroke-width='1.37' cx='373.42' cy='292.05' r='2.75'/%3E %3Ccircle fill='%23fff' stroke='%230872a7' stroke-width='1.37' cx='389.1' cy='279.26' r='2.75'/%3E %3Ccircle fill='%23fff' stroke='%230872a7' stroke-width='1.37' cx='454.82' cy='299.74' r='2.82'/%3E %3Cpath fill='%23f8c83c' d='M361.11 275.15c-.9 2.07 2.64 6 5.1 6.44 2.48.43 3.84-.17 4.27-1.39.43-1.2.1-2.52-.47-3.28-1.57-2.12-8-3.84-8.9-1.77z'/%3E %3Cpath fill='%23fff' d='M368.9 278.31c-.07-1.25-2.13-2.47-3.45-2.47-1.32 0-2.64-.04-2.43.66.21.68 3.62 1.6 3.7 1.98.1.4-1.01.86-.46 1.38.55.52 1.23.14 1.79-.25.55-.4.9-.52.85-1.3z'/%3E %3Cpath fill='%23f8c83c' d='M390.71 301.99c.57 1.83-.85 2.72-2.68 3.54-1.84.82-5.58.34-6.43-1.12-.86-1.47 1.36-3.85 3.62-4.41 2.25-.56 4.98.35 5.49 1.99z'/%3E %3Cpath fill='%23fff' d='M386.92 303.07c.72-.12.73 1.08 1.36 1 .64-.1 1.2-1.13 1.03-1.82-.17-.7-1.37-1.64-2.39-1.56-1.02.1-4.05 2.64-3.7 3.33.33.69 1.02.6 1.57.35.56-.26 1.36-1.17 2.13-1.3z'/%3E %3Cpath fill='%23f8c83c' d='M458.35 292.53c1.66 2.2 4.66.17 5.45-.69.8-.86 3.24-2.27 2.24-3.72-1-1.44-2.7-1.32-3.83-1.27-1.14.06-3.47 1.74-3.86 2.51-.4.78-.74 2.2 0 3.17z'/%3E %3Cpath fill='%23fff' d='M458.89 291.07s.14-2.4 2.39-2.5c1.28-.06 1.33.34 2.3.89.96.54 1.33-.72 1.33-.72s.06 1.7-1.5 1.75c-1.56.06-1-.69-2.53-.92-1.35-.2-1.99 1.5-1.99 1.5z'/%3E %3C/g%3E %3Cg fill='%23f9aa51' stroke='%23953220' stroke-width='.7' stroke-linecap='round' stroke-linejoin='round'%3E %3Cpath d='M422.43 286.4l-1.1-.72s-2.22-.11-3.73-.08c-1.5.02-4.48.17-4.48.17l4.45 12.93 5.34 7.7 2.05.73 4.14-.27.7-2.02-1.55-12.47-5.82-5.97z'/%3E %3Cpath d='M407.71 287.21l.21-1.47s1.01-.13 2.42-.17c1.4-.05 2.63.1 2.78.2.15.11 3.11 3.73 4.13 6.1 1.02 2.39 2.22 6.36 3.54 8.78 1.32 2.42 4.17 6.48 4.17 6.48s-1.43.09-2.68.09c-1.26 0-2.66.04-2.66.04l-2.4-.93-7.5-11.68-2.01-7.44z'/%3E %3Cpath d='M404.57 285.62s3.07-.06 3.35.12c.29.17 3.7 3.2 5.05 6.94 1.37 3.74.69 4.26 2.45 8.12 1.76 3.86 4.2 6.46 4.2 6.46s-5.11.28-8-.24c-2.9-.51-3.93-.46-4.6-1.26-.69-.81-2.28-1.79-2.28-1.79h-2.9l.68-4.03-.79-9.05.17-4.67 2.67-.6zM435.24 288.01l-4.88-2.02-9.1-.46s.35 2.43.69 4.67c.34 2.25 1.93 7.55 3.4 10.14 1.48 2.6 2.96 5.76 3.76 6.51.8.75 6.02-1.41 6.02-1.41l3.4-.52-.45-3.72-.48-1.15.8-10.57-.75-1.64-2.41.17z'/%3E %3Cpath d='M403.09 288.07c0 1.15 1.22 1.21 1.53 1.15.32-.05 1.37-.46 1.37-2.02 0-1.55-.97-2.76-2.87-2.87-1.9-.12-3.35 2.27-3.35 3.88 0 1.62 1.62 2.45 1.62 3.06 0 0-1.62 1.5-1.54 4.12.09 2.62 2.22 4.64 2.22 4.64s-2.27 1.81-2.27 3.63c0 1.81 1.73 3.02 3.35 3.02s3.69-1.04 3.69-2.42-1.22-2.21-2.24-2.21c-1.03 0-1.45.6-1.45 1.06M436.8 288.8c0 1.12-.73 1.17-1.37 1.17-.63 0-1.49-.35-1.49-1.78 0-1.42 1.88-2.2 3.07-2.2 1.2 0 3.24 1.64 3.24 3.63s-1.45 3.33-1.45 3.33.9.43.9 2.94c0 2.5-1.62 4.32-1.62 4.32s2.1.82 2.1 3.41c0 2.6-1.78 3.44-3.02 3.44s-3.39-.74-3.39-2.5c0-1.78 1.11-2.4 1.96-2.4.85 0 1.69.99 1.69 1.96'/%3E %3Cpath fill='%23953220' d='M406.22 302.5s.32.2.56.72c.24.5.41 1.33.97 1.83 1.11 1 9.54 1.3 12.1 1.3 2.56 0 10.22.34 11.67-.52 1.45-.87 1.62-2.3 2.52-2.94.89-.65 1.15-.6 1.15-.6l-1.11.94-.08 1.82.65 1s-.14.51-1.04 1.07c-.9.57-1.7.74-2.94.87-1.23.13-17.38.08-19.98-.35-2.6-.43-2.42-.39-3.2-.95a5.65 5.65 0 0 1-1.18-1.16l.34-1.17-.43-1.86zM432.41 287.01l1.45.63s-1.24.39-2.17 2.94c-.94 2.55-.17 3.37-.81 3.63-.64.26-7.63.05-7.63.05l-1.2-2.9 10.36-4.35z' stroke='none'/%3E %3C/g%3E %3Cg fill='%23231f20'%3E %3Cpath d='M454.69 286s-1.2-.43-1.75-1.43-1.02-2.24-.6-2.5c.44-.26 1.33.6 1.24 1.38-.08.78 1.11 2.55 1.11 2.55zM468.34 282.23s.85 1.55 1.15 1.73c.3.17 1.66.78 1.66.78s-1.92 0-2.51-.52c-.6-.52-1.45-1.95-1.45-1.95l1.15-.04z'/%3E %3Cpath d='M472.46 283.49s-1.15.69-2.13.3c-.98-.39-1.74-.95-1.36-1.38.38-.43.63-.26 1.15.3.5.57 2.34.78 2.34.78zM479.4 277.61s-.94.83-1.62.83-2.05-.27-2.05-.57c0-.3 1.8-.47 2.1-.43l1.57.17zM469 263.83s-1.54.47-2.04 1.25c-.51.78-.39 1.65.25 1.6.64-.04.81-.9.81-1.16 0-.26.98-1.69.98-1.69zM462.15 267.59s-1.15.73-1.45 1.38c-.3.65-.55 2.03.13 2.08.68.04.9-1.04.93-1.6.05-.57.39-1.86.39-1.86z'/%3E %3Cpath fill='%238cbebf' stroke='%2304534e' stroke-width='.7' d='M449.89 275.88l-3.76 3.98s8.65 4.84 15.3 4.63c6.64-.22 14.22-5.4 14.73-6.49.51-1.07.09-5.7-.77-7.17-.85-1.47-5.45-5.06-7.2-4.88-1.74.17-4.81 2.5-7.66 5.27-2.86 2.76-2.56 5.1-6.52 4.88l-4.12-.22z'/%3E %3Cpath fill='%230c8489' d='M448.93 277.47s9.26 1.39 11.92-.98c2.68-2.36 5.57-6.97 7.45-8s2.72-1.05 2.72-1.05 1.38.88 2.02 1.43c.64.55 2.35 1.96 2.35 1.96l.74 4.4.06 2.41-2.9 2.37-5.3 2.45-5.09 1.58-4.32-.12-8.74-2.53-2.22-1.57-.57-.5 1.88-1.85z'/%3E %3Cpath fill='%2304534e' d='M463.04 272.14c0-.79.52-.75 1.22-.75s1.48.13 1.48.92c0 .8-.77 1.93-1.48 1.93-.7 0-1.22-1.31-1.22-2.1zM466.76 274.47c0-.71.54-1.1 1.39-1.1.85 0 1.62.95 1.62 1.66s-.69 1.28-1.53 1.28c-.85 0-1.48-1.13-1.48-1.84zM465.48 280.01c0-.89.54-1.07 1.4-1.07.84 0 1.36.4 1.36 1.28s-.7 1.6-1.54 1.6c-.85 0-1.22-.93-1.22-1.81zM460.6 278.31c0-.95.9-1.24 1.66-1.24.76 0 1.38.77 1.38 1.72 0 .94-.62 1.7-1.38 1.7-.76 0-1.66-1.23-1.66-2.18zM452.87 279.25a1.89 1.89 0 1 1 3.78 0 1.89 1.89 0 0 1-3.78 0z'/%3E %3Cpath fill='%238cbebf' d='M466.76 274.47c0-.64.87-1.1 1.39-1.1.52 0 .94.52.94 1.16 0 .63-.42 1.15-.94 1.15s-1.39-.58-1.39-1.21zM465.51 279.78c0-.73.68-1.04 1.45-1.04.77 0 1.36.3 1.36 1.04 0 .73-.63 1.32-1.4 1.32-.78 0-1.41-.59-1.41-1.32zM460.63 278.16c0-.8 1.33-1.18 1.88-1.18.55 0 .45.54.45 1.35 0 .82-.45 1.47-1 1.47-.54 0-1.33-.82-1.33-1.64zM462.93 272.05c0-.74.58-.78 1.05-.78.48 0 .83.22.83.97 0 .74-.4 1.34-.87 1.34-.48 0-1.01-.79-1.01-1.53zM452.85 278.68c0-.86.75-1.67 1.85-1.67s2.21.38 2.21 1.24-1.34 2.33-2.44 2.33c-1.1 0-1.62-1.04-1.62-1.9z'/%3E %3Cpath d='M456.39 277.18s-1.28.22-1.96.87c-.68.64-.77 1.38-.38 1.6.38.21.85-.48.98-.78a16.5 16.5 0 0 1 1.36-1.69zM462.53 275.84s-1.23.87-1.36 1.73c-.13.87 0 1.3.34 1.34.34.04.55-1.12.43-1.56-.13-.42.59-1.51.59-1.51z'/%3E %3Cpath d='M463.55 277.14s-.8.04-1.36.56c-.55.52-1.07 1.17-.68 1.21.38.04.98-.26 1.02-.6.04-.35 1.02-1.17 1.02-1.17zM464.87 270.01s-.64.52-.98.82c-.34.3-.77 1.17-.34 1.39.43.21.72-.18 1.02-.78.3-.61.3-1.43.3-1.43zM469.52 272.99s-1.2.17-1.58.69c-.38.52-.64 1.12-.12 1.12.5 0 .63-.26.85-.73.21-.47.85-1.08.85-1.08zM468.79 278.48s-.25.82-.98 1.2c-.72.4-.93.75-1.23.23-.3-.52.08-.78.46-.91.39-.13 1.75-.52 1.75-.52z'/%3E %3Cpath fill='%2304534e' d='M476.2 274.76s.51 2.55-1.7 3.8c-2.22 1.26-8.44 5.66-14.31 5.14-5.88-.52-12.57-3.88-12.57-3.88l-.94.43 1.5.64 4.55 1.9 5.2 1.52 3.24.21 2.8-.34 5.2-1.73 4.4-2.25 2.29-1.81.61-.75-.06-1.07v-1.47l-.21-.34z'/%3E %3Cpath d='M360.78 241.54s1.36 1.17 1.24 2.16c-.13 1-.47 1.39-.86 1.21-.38-.17-.38-1.21-.3-1.64a9.11 9.11 0 0 0-.08-1.73zM370.86 250.91s-.38 1.73-1.07 1.9c-.68.17-1.19-.56-1.06-.86.13-.3.68-.05.98-.3.3-.26 1.15-.74 1.15-.74zM348.92 252.25s.47 1 1.36 1.17c.9.17 1.32-.44 1.2-.74-.13-.3-.52-.22-.98-.22-.47 0-1.58-.21-1.58-.21zM352.84 259.94s.81.95 1.92 1.08c1.1.13 1.66-.73 1.74-1 .09-.25-1.27-.21-1.7.14-.43.34-1.96-.22-1.96-.22zM359.78 265.86s1.79-.35 2.09-.82c.3-.48.76-1.3.38-1.77-.38-.48-.68.73-.9 1.2-.2.48-1.57 1.39-1.57 1.39z'/%3E %3Cpath fill='%238cbebf' stroke='%2304534e' stroke-width='.7' d='M370.95 261.16s1.2-8.01-5.28-13.66c-6.48-5.64-10.68-4.26-12.9-2.18-2.21 2.07-4.14 8.87 2.73 14.8 6.87 5.94 15.34 4.1 15.34 4.1l.1-3.06z'/%3E %3Cpath fill='%230c8489' d='M351.2 252.68s-.12-4.4 1.96-5.71c2.07-1.32 8.92-2.46 12.3 4.04 3.37 6.5 3.44 9.75 2.59 13.04l-3.62-.04-5.59-2.28-4.63-3.42-3.01-5.63z'/%3E %3Cpath fill='%2304534e' d='M370.09 262.31s-1.13 1.27-3.46 1.15c-2.33-.11-13.18-2.94-15.9-12.67l.16 2.13.12.7.71 1.95 2.28 3.32 2.87 2.45 3.61 1.87 2.6.76 3.36.59h1.95l1.7-2.25z'/%3E %3Cpath fill='%2304534e' d='M364.44 259.5c0-.87.44-.9 1.14-.9.69 0 1.22-.3 1.22.57 0 .86-.48 2.11-1.17 2.11s-1.19-.92-1.19-1.78zM364.9 254.35c0-.6.55-1.08 1.22-1.08.68 0 1.22.48 1.22 1.08 0 .6-.54 1.08-1.22 1.08-.67 0-1.22-.48-1.22-1.08zM359.98 260.03c0-.47.62-.85 1.38-.85.76 0 1.37.38 1.37.85s-1.36 1.1-2.13 1.1c-.75 0-.62-.63-.62-1.1zM359.53 253.96c0-.76.37-.52 1.04-.52s1.49.22 1.49.98c0 .77-.83 1.79-1.5 1.79-.66 0-1.03-1.49-1.03-2.25zM354.96 254.98c0-.64.43-1.54 1.25-1.54.81 0 1.7.9 1.7 1.54s-.66 1.17-1.48 1.17c-.8 0-1.47-.53-1.47-1.17zM355.78 249.61c0-.67.45-.63 1.3-.63.83 0 1.51.34 1.51 1 0 .68-.98 1.5-1.82 1.5-.84 0-.99-1.2-.99-1.87zM360.73 249.09c0-.65.55-.43 1.33-.43.8 0 1.43.52 1.43 1.16 0 .65-1 1.37-1.8 1.37-.78 0-.96-1.46-.96-2.1z'/%3E %3Cpath fill='%238cbebf' d='M355.78 249.47c.11-.46.43-.78 1.02-.78.59 0 1.1.11 1.1.78s-.47 1.21-1.06 1.21c-.58 0-1.22-.56-1.06-1.21zM354.87 254.74c0-.65.33-1.27 1-1.27.66 0 1.19.07 1.19.72 0 .66-.59 1.42-1.25 1.42-.67 0-.94-.22-.94-.87zM360.69 249.18c0-.52.44-.58 1.08-.58.63 0 1.05.14 1.05.65 0 .52-.52.94-1.15.94-.64 0-.98-.5-.98-1.01zM359.56 254.23c0 .7.52 1.29 1.16 1.29.65 0 1.34-.57 1.34-1.27 0-.72-.72-1.39-1.36-1.39-.65 0-1.14.66-1.14 1.37zM365.1 253.49c0 .64.56 1.17 1.25 1.17s1.25-.53 1.25-1.17c0-.65-.56-1.17-1.25-1.17-.7 0-1.25.52-1.25 1.17zM359.76 259.97c0-.56.59-1.1 1.17-1.1.57 0 1.13.35 1.13.91 0 .57-1 1.33-1.59 1.33-.58 0-.71-.58-.71-1.14zM364.47 259.14c0-.7.53-.75 1.25-.75s1.08.07 1.08.76c0 .7-.59 1.26-1.3 1.26-.73 0-1.03-.58-1.03-1.27z'/%3E %3Cpath d='M365.75 251.04s.72.9.85 1.6c.13.69.13 1.47-.13 1.55-.25.09-.68-.43-.8-1.08-.13-.65.08-2.07.08-2.07zM361.62 246.63s.47.74.47 1.39c0 .64-.09 1.33-.43 1.33-.34 0-.34-.64-.34-1.12 0-.47.3-1.6.3-1.6zM356.76 247.28s.47.74.47 1.39c0 .64-.09 1.33-.43 1.33-.34 0-.34-.64-.34-1.12 0-.48.3-1.6.3-1.6z'/%3E %3Cpath d='M355.06 248.19s.64.17 1.2.6c.55.44.76.95.55 1.21-.22.26-.73-.12-.86-.43-.12-.3-.89-1.38-.89-1.38zM358.76 253.28s.94.04 1.45.52c.51.48.93.87.64 1.21-.3.35-1.03-.26-1.32-.6-.3-.35-.77-1.13-.77-1.13zM354.25 253.11s.85.21 1.28.52c.42.3.55.9.34 1.04-.21.12-.51-.1-.9-.48-.38-.4-.72-1.08-.72-1.08zM365.15 256.53s.3 1.04.3 1.77c0 .74.08 1.38-.26 1.38s-.5-.9-.5-1.47c0-.56.46-1.68.46-1.68z'/%3E %3Cpath d='M363.92 258.21s.77.3 1.1.6c.35.3.43.78.18.87-.26.09-.43-.48-.64-.7-.21-.2-.64-.77-.64-.77zM359.06 258.51s.82.1 1.18.34c.35.25.39 1.37.35 1.51-.03.15-.57.05-.78-.49-.21-.53-.75-1.36-.75-1.36z'/%3E %3Cpath fill='%2304534e' d='M357.18 243.69s-4.3.93-5.07 3.7a25.71 25.71 0 0 0-.82 5.84l-.62-3.52.86-2.29 1.24-2.1 1.9-1.18 1.7-.59.81.14zM370.57 260.1s.44-1.07-.82-4.46c-1.26-3.39-3.85-7.81-3.85-7.81l2.01 2.28 1.6 2.6.79 2.38.58 2.18-.04 2.14-.27.69z'/%3E %3Cpath d='M374.91 254.62s1.49.98 1.64 1.51c.15.55.21.72-.17.87-.38.15-1-.45-1.17-.87a8.59 8.59 0 0 1-.3-1.51zM368.62 271.52s.7-1.32 1.64-1.81c.94-.5 1.64-.44 1.9-.13.25.3-.62.99-1.26 1.23s-2.28.71-2.28.71zM379.19 275.56s1.04-.5 1.73-1.23c.68-.73.76-1.25.5-1.51-.25-.26-1.1.17-1.48.75-.39.58-.75 1.99-.75 1.99zM378.04 274.57s.36-1.36.73-1.8c.36-.43.87-.66 1.25-.43.39.24.15.85-.13 1.17-.27.33-1.85 1.06-1.85 1.06z'/%3E %3Cpath fill='%238cbebf' stroke='%2304534e' stroke-width='.7' d='M395.71 266.52s-6.58-9.52-16.81-10.03c-8.18-.4-10.76 6.9-10.47 9.1.3 2.18 3.37 6.94 14.27 7.74 10.9.8 12.67-5.14 13.12-5.43.46-.29-.11-1.38-.11-1.38z'/%3E %3Cpath fill='%230c8489' d='M387.94 259.98s2.73 2.08 3.88 3.72c1.15 1.64 1.4 2.85.72 3.07-.68.2-6.6-5.28-11.46-6.44-4.85-1.17-9.07-.09-10 2.25-.94 2.33-.6 5.83 1.61 7.25 2.22 1.43 12.61 3.12 12.61 3.12s4.73-.65 4.9-.74c.17-.08 3.02-1.68 3.02-1.68l.64-1.65.77-2.16.34-.86-2.51-2.77-4.52-3.11z'/%3E %3Cpath fill='%2304534e' d='M379.59 261.32c0 .61-.64.91-1.28.91-.63 0-1.17-.32-1.17-.93 0-.6.52-1.1 1.15-1.1.64 0 1.3.51 1.3 1.12zM373.59 263.48c0-.61.69-.6 1.38-.6.68 0 1.24.5 1.24 1.11 0 .61-1.08 1.45-1.7 1.16-.77-.37-.92-1.05-.92-1.67zM380.04 267.01c0-.78.66-1.4 1.47-1.4.81 0 1.47.62 1.47 1.4 0 .77-1.1 1.62-1.92 1.62-.8 0-1.02-.85-1.02-1.62z'/%3E %3Cpath fill='%238cbebf' d='M375.16 268.45c0-.68.7-.82 1.3-.82.6 0 1.36.64 1.36 1.32s-.76 1.14-1.36 1.14c-.6 0-1.3-.96-1.3-1.64z'/%3E %3Cpath fill='%2304534e' d='M383.89 270.82c0-.55.33-1.05.9-1.05.56 0 1.25.33 1.25.89 0 .55-.56 1.16-1.13 1.16-.56 0-1.02-.44-1.02-1zM387.81 267.83c0-.7.4-.63 1.09-.63.69 0 1.38.4 1.38 1.1 0 .7-.86 1.08-1.55 1.08-.7 0-.92-.85-.92-1.55z'/%3E %3Cpath fill='%238cbebf' d='M379.21 260.76c0 .55-.23.84-.77.84s-1.2-.3-1.2-.84c0-.55.26-.72.8-.72s1.17.17 1.17.72zM376.08 263.31c0 .6-.9.97-1.47.97s-.94-.37-.94-.97.44-.78 1-.78c.57 0 1.41.18 1.41.78zM377.47 268.35c0 .52-.2.93-.8.93-.62 0-1.42-.4-1.42-.93 0-.52.23-.89.84-.89.6 0 1.38.37 1.38.89zM382.68 266.64c0 .55-1.07 1.17-1.64 1.17-.57 0-.81-1.01-.81-1.56a1 1 0 0 1 1.02-.99c.57 0 1.43.83 1.43 1.38zM390.24 268.26c0 .57-.9.54-1.43.54-.51 0-.98-.64-.98-1.2 0-.58.17-1.11 1.45-.96.52.06.96 1.05.96 1.62zM385.77 270.57c0 .57-.44 1.04-.98 1.04s-.98-.47-.98-1.04c0-.57.44-.8.98-.8s.98.23.98.8z'/%3E %3Cpath d='M386.45 267.42s1.06-.35 1.87-.26c.81.09.86.39.86.52s-.64.39-.94.3a113 113 0 0 1-1.79-.56zM382.02 271.17s.85-.52 1.5-.65c.63-.12 1.14.09 1.1.48-.04.39-.26.48-.9.48-.63 0-1.7-.31-1.7-.31zM379.17 264.61s1.83.78 2.22 1.51c.38.74.55.91.16 1.13-.38.21-.8-.27-1.06-.6a71.74 71.74 0 0 1-1.32-2.04z'/%3E %3Cpath d='M378.7 266.94s1.4-.39 2.04-.39c.64 0 .82.05.9.35.09.3-.14.43-.67.4-.52-.03-2.27-.36-2.27-.36zM374.21 267.03s1.53.2 1.92.6c.38.4.38.77.22 1-.15.23-.88.09-1.1-.15-.23-.23-1.04-1.45-1.04-1.45z'/%3E %3Cpath d='M373.99 269.24c.07-.07.6-.87 1.15-1.05.55-.19 1.2-.16 1.3.13.12.29-.48.72-.87.8-.4.09-1.58.12-1.58.12zM372.83 262.53l1.52.42c.55.42.68.75.55.9-.13.16-.66.25-1.12-.05a2.82 2.82 0 0 1-.95-1.27zM376.16 258.66s1.55.43 2.06 1.14c.51.7.44 1.12.18 1.27-.25.14-.85-.22-1.19-.53-.34-.32-1.05-1.88-1.05-1.88z'/%3E %3Cpath fill='%2304534e' d='M393.86 269.79s-3.15 2.68-10.26 2.42c-7.12-.26-13.55-3.28-15.17-6.61l.64 1.64 1.58 2.12 4.98 2.55 5.58 1.25 4.43.26 4.18-.73 3.23-1.56c.17-.08.51-.82.51-.82l.3-.52zM394.8 266.42s-1.2-1.47-2.85-3.03c-1.67-1.55-8.14-5.75-8.14-5.75l5.24 2.38 3.45 2.9 2.47 2.72-.17.78z'/%3E %3Cpath d='M395.1 260.11s1.79.7 2.09 1.12c.3.43.68.83.68.83s-.47 1.16-.9.69c-.42-.48-.5-.48-.98-1.13-.46-.65-.89-1.51-.89-1.51zM400.42 257.26s1.66.7 2.26 1.51c.6.83.47 1.52.21 1.6-.25.1-1.36-.86-1.53-1.25-.17-.39-.94-1.86-.94-1.86z'/%3E %3Cpath d='M402.09 256.92s1.57 1.17 1.83 1.69c.26.51.77 1.2.26 1.38-.52.17-1.24-.6-1.45-1.08-.22-.48-.64-1.99-.64-1.99zM411.07 259.03s1.24.43 1.36 1.47c.13 1.04-.12 1.77-.12 1.77s-.86-.73-.86-.95c0-.21.13-.39 0-.86l-.38-1.43zM413.46 259.86s.98 1 1.1 1.64c.14.65.26 1.08-.29 1.17-.55.09-.85-.56-.85-1.12 0-.57.04-1.69.04-1.69zM397.36 279.48s.77.34 1.49.09c.72-.26 1.32-.91 1.2-1.34-.13-.44-.52-.83-1.07-.26-.56.56-.26.82-.68 1.03l-.94.48zM406.22 281.89s1.2-.17 2-1.04c.81-.86 1.15-1.47.6-1.68-.55-.22-1.28 0-1.4.69-.13.69-1.2 2.03-1.2 2.03zM413.5 282.15s.9-.52 1.58-1.17c.68-.64 1.06-1.03.6-1.5-.47-.49-.82-.14-1.03.08-.21.22 0 .22-.25.9-.26.7-.9 1.69-.9 1.69z'/%3E %3Cpath d='M415.72 282.11s.96-1.17 1.18-1.82c.22-.64.34-1.38-.1-1.34-.43.04-.96.65-.98 1.13-.04.47-.1 2.03-.1 2.03z'/%3E %3Cpath fill='%238cbebf' stroke='%2304534e' stroke-width='.7' d='M393.56 270.31c.06-3.2 4.6-10.59 9.84-10.5 2.18.04 6.46 1.17 9.92 2.72 2.9 1.3 3.84 2.73 5.76 3.2 1.91.47 4.8.13 4.8.13l6.53-.74-5.12 7.48-1.82 1.64s-1.63 3.16-6.27 4.97c-4.64 1.82-12.48.48-16.02-.39-3.53-.86-7.7-4.23-7.62-8.51z'/%3E %3Cpath fill='%2304534e' d='M393.56 270.31h.34c.01-.71.29-1.74.79-2.84.74-1.66 1.98-3.5 3.5-4.93 1.51-1.41 3.3-2.39 5.12-2.39h.08c1.04.02 2.64.3 4.4.78 1.76.48 3.68 1.15 5.4 1.91 1.41.64 2.34 1.3 3.18 1.88a7.8 7.8 0 0 0 2.62 1.34c.83.2 1.8.27 2.66.27 1.24 0 2.27-.13 2.28-.13l5.77-.65-4.66 6.82-1.85 1.66-.03.05v.01c-.08.14-1.68 3.08-6.08 4.8-1.63.64-3.7.88-5.85.88-3.76 0-7.74-.74-9.97-1.28a11.04 11.04 0 0 1-4.96-2.85 7.42 7.42 0 0 1-2.4-5.2v-.12l-.34-.01-.34-.01v.14c0 2.23 1.09 4.2 2.6 5.7a11.72 11.72 0 0 0 5.28 3.02 45.9 45.9 0 0 0 10.13 1.3c2.2 0 4.34-.24 6.1-.93 4.74-1.85 6.41-5.08 6.43-5.13l-.3-.16.23.26 1.86-1.67 5.56-8.13-7.26.82-.17.01c-.34.04-1.13.1-2.04.1-.83 0-1.75-.05-2.49-.24a7.16 7.16 0 0 1-2.4-1.24c-.83-.57-1.81-1.28-3.3-1.93a38 38 0 0 0-5.49-1.95c-1.79-.49-3.42-.79-4.56-.81h-.1c-1.37 0-2.69.49-3.88 1.25a14.74 14.74 0 0 0-4.41 4.7c-1.1 1.79-1.76 3.6-1.8 4.9h.35z'/%3E %3Cpath fill='%230c8489' d='M425.21 271.31c-.55.43-1.15.43-1.83.43-.69 0-15.2-8.86-19.72-8.47-4.52.39-8.82 2.34-8.95 6.96-.13 4.62 1.02 4.67 1.96 5.96.94 1.3 9.8 3.25 9.8 3.25l5.4-.1 4.36-.47 3.83-2.07 2.09-1.69 1.4-1.72 1.66-2.08z'/%3E %3Cpath fill='%2304534e' d='M402.26 268.95c0 .9-.35 1.54-1.23 1.54s-1.54-.4-1.54-1.3.5-1.25 1.38-1.25c.88 0 1.39.1 1.39 1.01zM403.78 264.91c0-.75.73-1.08 1.56-1.08.84 0 1.48.3 1.48 1.05s-.66 1.33-1.5 1.33c-.83 0-1.54-.55-1.54-1.3zM412.48 267.27c0-.65.56-1.19 1.26-1.19.69 0 1.25.54 1.25 1.19 0 .66-.56 1.19-1.25 1.19-.7 0-1.26-.53-1.26-1.19zM414.23 272.6c0-.84.6-1.51 1.36-1.51.76 0 1.46.35 1.46 1.18 0 .84-.27 1.65-1.03 1.65-.75 0-1.79-.49-1.79-1.32zM410.01 276.01c0-.72.64-1.3 1.43-1.3.79 0 1.42.58 1.42 1.3 0 .72-.56 1.18-1.35 1.18s-1.5-.46-1.5-1.18zM402.04 274.63c0-.7.56-1.25 1.26-1.25a1.25 1.25 0 1 1 0 2.5c-.7 0-1.26-.56-1.26-1.25z'/%3E %3Cpath fill='%238cbebf' d='M402.21 268.76c0 .71-.61 1.3-1.36 1.3-.76 0-1.37-.59-1.37-1.3 0-.72.6-1 1.36-1 .75 0 1.37.28 1.37 1zM406.43 264.65c0 .7-.22 1.14-.95 1.14-.72 0-1.7-.45-1.7-1.14 0-.7.6-1.25 1.33-1.25.73 0 1.32.56 1.32 1.25zM414.86 266.9c0 .6-.55 1.08-1.24 1.08-.68 0-1.23-.49-1.23-1.08 0-.6.55-1.08 1.23-1.08.69 0 1.24.48 1.24 1.08z'/%3E %3Cpath fill='%2304534e' d='M410.39 270.46c0 .91-.35 1.55-1.23 1.55-.89 0-1.54-.4-1.54-1.31s.5-1.24 1.38-1.24c.88 0 1.39.1 1.39 1z'/%3E %3Cpath fill='%238cbebf' d='M404.3 274.33c0 .72-.61 1.3-1.36 1.3-.76 0-1.37-.58-1.37-1.3 0-.71.87-1.08 1.62-1.08.75 0 1.11.37 1.11 1.08zM410.13 270.31c0 .72-.6 1.3-1.32 1.3a1.3 1.3 0 0 1-1.32-1.3c0-.71.6-1.3 1.32-1.3.73 0 1.32.59 1.32 1.3zM417.02 272.09c0 .79-.48 1.42-1.3 1.42-.83 0-1.5-.64-1.5-1.43 0-.78.25-1.05 1.07-1.05.82 0 1.73.27 1.73 1.06zM412.61 275.71c0 .74-.5 1.16-1.25 1.16-.76 0-1.48-.42-1.48-1.16s.65-1.04 1.4-1.04c.75 0 1.33.3 1.33 1.04z'/%3E %3Cpath d='M413.12 271.39s2.17-.22 2.55.17c.39.4.34.95.17 1.13-.17.17-1.02.21-1.23-.09-.21-.3-1.49-1.21-1.49-1.21zM410.99 264.39s1.66.43 2.34 1.12c.68.7.56 1.39.43 1.51-.13.13-.73.27-1.2-.25-.46-.52-1.57-2.38-1.57-2.38zM406.05 267.76s1.94 1.06 2.36 1.66c.43.6.54 1.08.35 1.34-.2.26-1.16-.07-1.3-.39-.15-.32-1.41-2.61-1.41-2.61z'/%3E %3Cpath d='M405.2 269.25s2.17.28 2.7.7c.54.4.92.42.88.75-.04.32-.28.56-.62.52a4.72 4.72 0 0 1-1.49-.65l-1.47-1.32zM402.7 262.89s2.22.35 2.67.7c.46.34.57 1.32.06 1.61-.51.28-1.08-.29-1.25-.7-.17-.4-1.48-1.61-1.48-1.61zM397.92 266.24s2.04.97 2.67 1.87c.34.49.64.9 0 1.13-.58.19-1.2-.87-1.2-1.13 0-.26-1.47-1.87-1.47-1.87z'/%3E %3Cpath d='M397.47 268.89s1.3-.29 1.93-.29c.62 0 1.52-.22 1.53.29.01.5-.76.6-1.22.46-.46-.16-2.24-.46-2.24-.46zM408.75 276.17s1.43-.89 2.13-.74c.7.16.94.1.94.52 0 .43-.83.35-1.1.35-.25 0-1.97-.13-1.97-.13zM400.85 275.02s.55-.82 1.15-.9c.6-.1.85-.05.94.2.08.27-.51.74-.77.74l-1.32-.04z'/%3E %3Cpath fill='%2304534e' d='M423.43 273.58s-2.17 2.61-5.2 3.91c-3.02 1.3-5.32 1.73-9.54 1.47-4.21-.26-6.26-.9-9.11-2.38-2.86-1.47-5.12-3.58-5.54-4.49-.43-.91.47 1.51.47 1.51l2.6 3.41 3.1 1.39 4.56 1.12 4.3.52 3.28-.08 3.92-.61 2.52-.9 1.7-1.05 1.32-1.08 1.62-2.74zM419.37 265.86s-1.18.4-3.78-1.21c-2.6-1.6-5.7-3.68-11.59-3.72-5.87-.04-7.75 3.98-8.13 4.28-.39.3 2.64-3.5 2.64-3.5l2.68-1.42 2.09-.35 2 .09 2.6.69 2.34.73 2.73.9 2.38 1.31 2.88 1.5 1.16.7zM427.26 267.59s-3.45-.04-4.43.04c-.98.09-1.02.26-1.15.52-.13.26-.39.6-.39.6l-1.06-2.29 4.69-.65 2.55.96-.21.82z'/%3E %3Cpath fill='%230c8489' stroke='%2304534e' stroke-width='.7' d='M420.91 291.7c.24.63.78 1.2 1.47 1.22.69.02 2.13-.03 2.13-.03l4.67-.28 1.64-1.88 1-4.22s1.26-1.53 1.26-1.6 4.34-2.4 4.34-2.4l3.75-1.07 2.4-.26 3.33-1.1 2.45-1.28 1.06-1.58 1.04-2.4-1.04-3.24-2.6-3.47-4.4-1.8h-3.65l-4.09 1.5-7.2 1.7s-3.96 1.73-5.6 4.82c-1.63 3.09-1.62 3.89-1.9 7.97-.27 4.09-.06 9.4-.06 9.4z'/%3E %3Cpath fill='%238cbebf' d='M422.86 290.09c1.38 0 .31-2.28 1.88-4.99 1.56-2.7 3.46-6 3.94-6 .49 0 .57.5 1.14.33a3.79 3.79 0 0 0 1.59-1.27c.06-.23.06-1.76 1.25-2.74 1.2-.98 2.87-2.36 3.66-2.53.8-.17 1.17-.32 1.3.06.15.37-.45.89.1 1.06.53.18 1.78.12 2.1-.69.3-.8.22-1.24.22-1.24s.83-.8 2.39-.46c1.56.35 1.76.26 1.9.87.14.6-.71.69-.54 1.12.17.43-.12.38.04.71.16.33.41 1.25 1.46 1.22 1.06-.03 1.5-.64 1.5-.64l.32-.55s.29-.65-.11-.91c-.4-.26-.26-.58.14-.4.4.17 1.99 2.38 2.53 1.46.54-.92.6-2.22.31-2.53-.28-.32-2.53-3.7-2.53-3.7l-4-1.35-5.31.44-5.14 2.94-4.72 2.5s-.25 3.86-1.1 3.17c-.86-.7-2.08-2.6-2.44-1.96-.38.64-1.2 3.46-1.68 4.87-.48 1.41-1.87 5.76-1.74 7.38.15 1.61 1.03 3.83 1.54 3.83z'/%3E %3Cpath fill='%238cbebf' d='M427.6 283.85a2 2 0 0 0-1.08.62c-.17.22-.41.68-.26 1.18.16.5.9 1 .96 1.05l.59-.01 1.28-.38s.4-.46.43-1.06c.02-.6-.35-.77-.53-.82-.19-.06-1.39-.58-1.39-.58zM435.72 277.14c-.73-.26-1.05.24-1.17.45-.13.22-.07.75-.07.75s.15 1 .54 1.19c.38.18 1.38.53 1.7.18.32-.34.64-.58.62-1.23-.01-.65-.92-.97-.92-.97l-.7-.37zM442.26 278.71c-.03-.25-.67-.42-1.1-.34-.42.07-1 .61-.79 1.43.2.82.98.9 1.6.74.6-.16.49-1.03.49-1.15 0-.13-.2-.68-.2-.68zM423.37 280.03c0 .37.68 1.15 1.6 1.1.9-.06 1.46-.75 1.55-1.3.09-.55-.48.46-1.16.63-.68.17-1.08.35-1.4-.03-.3-.37-.59-.4-.59-.4z'/%3E %3Cpath fill='%2304534e' d='M429.52 285.25s.1.83-.5 1.27c-.6.43-.99.38-1.34.38-.34 0-.72-.07-.97-.41-.26-.35-.44-.84-.44-.84s.66 1.1 1.7.8c1.05-.28 1.55-1.2 1.55-1.2zM447.11 274.35s0 .84-.66 1.19c-.65.35-.95.45-1.3.4-.34-.04-.82-.18-1.04-.55-.78-1.2-.32-1.99-.32-1.99s.56 2.1 1.63 1.95c1.07-.15 1.69-1 1.69-1zM431.43 278.1s-.54 1.64-1.62 1.64-.99-.31-.9-.52c.08-.2.48.2.96.06s1.56-1.18 1.56-1.18zM434.47 277.81s-.11 1.19.29 1.59c.4.4.85.61 1.3.61.46 0 .8-.12 1.14-.58.34-.46.14-.95.14-.95s0 .25-.33.6c-.34.34-.62.4-.96.4-.34 0-.93-.05-1.1-.45-.17-.4-.48-1.22-.48-1.22zM440.04 272.09s.34.89-.34 1.61c-.68.72-1.99.32-1.99.32s1.05.26 1.57-.32c.5-.57.76-1.61.76-1.61z'/%3E %3Cpath fill='%2304534e' d='M422.26 292.59s6.91-.12 7.47-1.07c.55-.95-.6-4.66 3.58-7.6 4.17-2.94 7.4-2.9 9.62-3.07 2.22-.17 7-1.66 7.84-5.92.5-2.6-2.98-2.77-4.3-5.23-1.32-2.46-4.73-1.47-4.9-1.47-.17 0-3.95-.1-5.75 1.64-1.07 1.04-.94 2.34-1.45 2.94-.51.6-5.07 0-5.58.74-.51.73.13 2.28-.22 2.63-.33.35-1.44-1-1.44-1l.38-3.67 5.84-3.4 6.64-3.68s4.35.21 4.52.13c.17-.1 4.47 2.24 4.6 2.29.12.04 2.25 2.6 2.25 2.6s.42 1.03.6 3.06c.09.96 0 1.79-.2 2.54-1.08 3.83-4.82 6.4-8.77 6.6-3.94.2-7.5 1.97-9.3 3.28-1.8 1.3-2.7 7.06-2.72 7.76-.03.69-8.6.22-8.6.22l-.11-.32z'/%3E %3Cpath d='M425.17 279.13c-.35.28-.87.27-.98-.13-.32-1.13.35-2.8.35-2.8s-.01 1.75.12 2.04c.13.28.48.22.63.46.06.08.16.2-.12.43zM429.52 278.24c-.33-.1-.28-1.17-.02-1.62.25-.45 2.2-1.88 2.2-1.88l-.86 1.95c-.23.51-.9 1.68-1.32 1.55zM427.81 285.26c-.27.06-.36-.54-.36-1.3 0-.75 1.32-2.14 1.32-2.14s-.4 1.22-.45 1.6c-.04.4.22.74.17 1.2-.04.44-.38.58-.68.64z'/%3E %3Cpath d='M431.03 283.32s-.62.71-1.32 1.1c-.7.39-1.47.97-1.9.85-.42-.14.28-1.06.51-1.15 1.2-.48 2.71-.8 2.71-.8zM436.95 274.87s-.79.65-1.17 1.58c-.38.93-.55 1.68-.17 1.86.39.17.96-1.06 1-1.47.04-.41.34-1.97.34-1.97z'/%3E %3Cpath d='M439.12 277.83s-.55-.52-1.53-.75c-.98-.24-1.43-.03-1.54.26-.1.27-.83.72-.46.93.36.22.78-.37 1.08-.44.3-.06.64-.28 1.17-.2.53.1 1.28.2 1.28.2zM437.85 272.03c.35.3.88-.26 1.37-.8.48-.56.85-1.56.85-1.56s-1 .52-1.42.86c-.43.35-1 1.33-.8 1.5zM446.88 271.82s-1.16.55-1.56 1.07c-.4.52-.91 1.09-.51 1.38.4.29.76-.26 1.08-.69.3-.43.99-1.76.99-1.76zM444.3 277.87s-.4.8-1.13 1.3c-.74.49-1.62.72-1.76.46-.15-.26.11-.81.4-.95.28-.15.45-.12 1.1-.29a9.58 9.58 0 0 0 1.39-.52z'/%3E %3C/g%3E %3Cg%3E %3Cellipse fill='url(%23b)' cx='385.55' cy='257.83' rx='3.77' ry='5.63' transform='rotate(8.67 385.55 257.83)'/%3E %3Cg fill='%23fcca3e' stroke='%23aa8c30'%3E %3Cpath stroke-width='.35' d='M387.66 247.73l-2.24 5.6 1.83-.25 1.06-4.93z'/%3E %3Cpath stroke-width='.3' d='M388.7 245.35c-.8-.1-1.53.5-1.63 1.36-.1.85.45 1.62 1.25 1.72.8.1 1.53-.5 1.64-1.36.1-.85-.46-1.62-1.26-1.72z'/%3E %3Cpath stroke-width='.35' d='M485.22 259.35l-5.52 5.18 2.28.58 3.78-5z'/%3E %3Cpath stroke-width='.3' d='M487.68 257.21a2 2 0 0 0-2.62.74c-.56.9-.3 2.02.58 2.5a2 2 0 0 0 2.62-.73c.56-.9.3-2.02-.58-2.51z'/%3E %3Cpath stroke-width='.35' d='M344.88 229.45l2.91 6.42 1.26-1.79-3.3-4.86z'/%3E %3Cpath stroke-width='.3' d='M343.71 226.65a1.8 1.8 0 0 0-.17 2.5c.63.78 1.73.9 2.46.3.72-.61.8-1.74.16-2.5a1.73 1.73 0 0 0-2.45-.3z'/%3E %3C/g%3E %3Cg fill='%23aa8c30'%3E %3Cpath d='M389.25 245.56s.45.24-.07.08c-.52-.15-1.76.45-1.76 1.32 0 .87.65 1.36 1.3 1.36.66 0-.24.12-.24.12l-.84-.25-.35-.5-.28-.7.21-.76.5-.65.65-.23.43.05.45.16z'/%3E %3Cpath d='M387.99 249.33s-.36-.07-.68.4c-.32.49-.97 1.4-.97 1.4l1.25-3.09.68.36-.28.93zM488.22 257.69s.4.48-.13.06-2.28-.34-2.74.63c-.46.98.06 1.82.82 2.13.76.32-.35.02-.35.02l-.86-.67-.14-.73.03-.92.65-.73.92-.49.88.05.47.26.45.39z'/%3E %3Cpath d='M484.78 261.3s-.38-.25-1.01.13c-.62.39-1.86 1.08-1.86 1.08l3.06-2.84.62.72-.81.91zM344.33 226.33s.56-.2.01.13c-.55.32-1.04 1.87-.3 2.57.73.7 1.66.53 2.19-.03s-.1.3-.1.3l-.88.54-.7-.11-.82-.32-.47-.79-.14-.95.32-.75.4-.33.49-.26z'/%3E %3Cpath d='M346.49 230.45s-.35.25-.2.91c.15.67.38 1.95.38 1.95l-1.59-3.54.85-.31.56.99z'/%3E %3C/g%3E %3Cellipse fill='url(%23c)' cx='351.47' cy='241.61' rx='6.06' ry='4.08' transform='rotate(62.9 351.47 241.6)'/%3E %3Cg fill='%23e92736'%3E %3Cpath d='M344.65 240.24s1.25.29 1.93-.06c.68-.34.8-.86.96-1.03.18-.17.35-.8.29-1.21a4.99 4.99 0 0 0-1.25-1.9c-.28-.12-1.25 0-1.42-.18-.17-.17.14-.55-.23-.63-.37-.09-2.27 2.08-1.93 2.42.34.34.54-.17.65.12.12.28.03 1.09.03 1.43 0 .35.97 1.04.97 1.04z'/%3E %3Cpath d='M346.5 236.2c.15.3.85 1.24 1.14 1.35.28.12 1.13.15 1.42.04.28-.12 1.19-.99 1.22-1.36.03-.38 0-.66-.17-1.04-.17-.37-.07-1.38-.41-1.44-.35-.06-.5-.1-.66-.3-.17-.2.1-.56-.15-.94-.26-.37-3.3 1.42-3.07 1.76.23.35.54-.03.65.2.11.23-.14 1.38.03 1.73z'/%3E %3Cpath d='M353.37 235.43c.17-.46.11-1.96-.2-2.28-.31-.31-.82-.34-.85-.54-.03-.2.37-.3.37-.64s-3.38.12-3.15.5c.22.37.8.17.76.4-.03.22-.57.51-.62.8-.06.3.17 1.24.31 1.47.14.24-.05.52.34.66.4.15.34.15.71.26.37.12 1.7.06 1.88-.08.17-.15.28-.09.45-.55zM382.1 252.31s.55.96 1.17 1.19c.6.23 1 0 1.2 0 .2 0 .7-.25.9-.53.22-.27.54-1.65.44-1.9-.1-.25-.73-.8-.72-1 0-.21.42-.23.25-.51-.16-.29-2.6-.23-2.61.2-.01.41.42.23.31.47-.11.25-.65.66-.87.86-.21.2-.07 1.22-.07 1.22z'/%3E %3Cpath d='M385.66 251.11c-.1.27-.26 1.26-.17 1.51.1.25.58.8.82.91.23.12 1.3.19 1.54-.02.25-.2.41-.38.54-.71.13-.33.8-.86.64-1.1-.16-.25-.22-.37-.2-.6.03-.23.41-.26.49-.64.08-.38-2.8-1.26-2.87-.91-.08.35.33.32.25.53-.07.2-.93.72-1.04 1.03z'/%3E %3Cpath d='M390.16 255c.38-.16 1.27-1.07 1.28-1.46.01-.38-.27-.72-.16-.86.1-.13.4.07.6-.14.22-.2-2.04-2.06-2.14-1.7-.1.36.36.6.2.72-.16.12-.65-.05-.86.08-.21.13-.66.83-.72 1.06-.06.22-.35.27-.2.6.14.34.1.3.25.6.14.3.96 1.11 1.15 1.13.19.03.22.14.6-.03zM476.9 262.25s.05 1.07.46 1.55c.42.48.84.47 1.01.57.17.1.7.11 1-.01a4.03 4.03 0 0 0 1.19-1.4c.03-.25-.27-1.01-.17-1.19.1-.17.45 0 .43-.3-.01-.32-2.08-1.42-2.28-1.08-.19.35.25.4.06.56-.2.15-.85.24-1.1.3-.28.08-.6 1-.6 1z'/%3E %3Cpath d='M480.26 262.95c-.21.16-.84.82-.9 1.05-.04.23.06.86.2 1.05.12.2.93.73 1.23.69.3-.04.52-.1.78-.29.27-.19 1.07-.27 1.07-.53s0-.38.14-.54c.13-.15.46 0 .7-.25.26-.25-1.57-2.21-1.8-1.99-.25.22.09.4-.07.51-.17.12-1.1.12-1.35.3z'/%3E %3Cpath d='M480.96 267.83c.36.14 1.56.14 1.82-.1.26-.22.3-.6.46-.62.16-.01.22.29.5.3.27 0 0-2.55-.3-2.39-.31.17-.18.6-.35.57-.19-.03-.4-.44-.63-.49a3.1 3.1 0 0 0-1.18.2c-.18.1-.4-.06-.53.24s-.13.25-.23.53c-.1.27-.1 1.27.02 1.4.1.14.06.22.42.36z'/%3E %3C/g%3E %3Cg fill='%23f7e204'%3E %3Cpath d='M346.72 237.45c.28.42-.09 1.42-.32 1.7-.22.29-1.74-.12-1.76-.4-.02-.29-.13-.76.07-1.03.2-.26.7-.87 1.09-.8.38.07.82.39.92.53zM347.13 235.57c-.18.38.08.8.27 1.02.2.2 1.29.48 1.58.3.3-.19.75-1.87.54-2.13-.2-.26-.79-.3-.99-.28-.2.04-1.28.83-1.4 1.09zM350.75 233.85c-.15.34-.1.82.03.97.12.15.83.64 1.24.62.42-.03.62-1.2.62-1.42 0-.22-.13-.32-.42-.45-.3-.12-1.47.28-1.47.28zM385.02 251.98c-.1.42-.93.78-1.23.8-.31.02-.94-1.18-.78-1.36.16-.18.38-.53.66-.55.28-.03.96-.07 1.13.22.18.28.25.74.22.89zM386.42 251.14c-.34.1-.45.52-.47.77-.01.24.46 1.09.74 1.17.29.08 1.6-.62 1.63-.9.03-.29-.28-.68-.42-.79a3.9 3.9 0 0 0-1.48-.25zM389.59 252.43c-.3.1-.56.42-.58.58-.02.17.09.9.35 1.15.26.25 1.09-.3 1.23-.44.13-.13.12-.26.03-.52-.1-.26-1.03-.77-1.03-.77zM479.57 263.19c-.26.31-1.11.22-1.38.09-.27-.13-.28-1.43-.07-1.5.21-.08.56-.27.8-.16.25.1.83.4.86.72.02.32-.12.74-.21.85zM480.84 263.31c-.32-.07-.62.19-.76.36-.13.18-.18 1.02 0 1.2.18.2 1.57.27 1.74.07.17-.2.12-.63.07-.77a3.5 3.5 0 0 0-1.05-.86zM482.29 265.9c-.27-.11-.65-.1-.77 0-.12.09-.54.6-.53.92 0 .32.93.49 1.1.5.19 0 .27-.09.38-.3.1-.22-.18-1.12-.18-1.12z'/%3E %3C/g%3E %3Cellipse fill='url(%23d)' cx='476.69' cy='268.57' rx='2.94' ry='5.86' transform='rotate(47.85 476.7 268.57)'/%3E %3C/g%3E %3Cg%3E %3Cg fill='%2378732e'%3E %3Cpath fill='%23a8ac71' d='M375.12 185.22s-5.03.43-8.52-.17c-3.5-.6-2.73-9.51-2.81-9.77-.09-.26-2.13-2.42-1.8-4.4.35-2 6.8-7.24 7.68-7.52.6-.2 1.87.34 1.87.34s1.63-1.58 2.12-1.58c.5 0 1.18.91 1 1.3-.2.39-2.42 1.68-2.59 2.68-.17 1 .03 1.99-.62 2.96-.63.97-1.87 2.29-2.02 3.11-.15.82-.5 1.54.1 1.84.63.3 2.74.04 4.55-.78 1.8-.82 2.55-1.92 2.8-1.82.26.11-1.04 2.27-3.04 3.12-2 .84-3.32 1.81-4.32 1.66 0 0-1.11 2.66 2.32 2.8 3.43.16 5.32-.75 5.32-.75l-2.04 6.98zM355.48 206.18s2.64 1.04 2.64 3.98c0 2.93-2.9 5.4-2.81 10.58.09 5.19.9 5.24 7.75 10.8a7.45 7.45 0 0 1 2.05 3.34c.38 1.68 1.62 11.62 8.22 11.57 6.6-.04 7.5-4.23 7.5-4.23l-2.82-4.15s-2.3.7-3.53.4a4.51 4.51 0 0 1-3.07-2.73c-.72-1.6-.92-5.4-2.04-7.09-2.77-4.15-7.71-4.84-7.76-9.2-.04-4.37 3.03-4.84 2.18-10.03-.85-5.18-7.03-7.7-7.03-7.7l-2.51-1-.88 5.2 2.11.26z'/%3E %3Cpath fill='%23f1a720' d='M373.67 169.89c2.21-.52.94-6.29.94-6.29l-1.54 1.28s.95 1.23.95 2.56c0 1.32-.35 2.45-.35 2.45z'/%3E %3Cpath fill='%23a8ac71' d='M377.71 227.47s-1.03-.84-1.13-.91c-.79-.53-4.26-3.33-3.7-11.66.63-9.42 14.32-14.38 15.22-18.12 1-4.15 4.1-5.96-6.82-14.5l-2.55 3 4.47 3.36s.99-.55 1.05.72c.06 1.26-1.2 2.35-1.5 3.34-.29.9-7.09 5.64-7.6 6.1-.51.46-3.9 3.1-3.9 3.1s-1.78 1.74-3.42 5.4c-1.65 3.66-.8 8.35-.8 8.35s.05 10 10.68 11.82z'/%3E %3Cpath d='M371.03 232.74l.77 3.54-2.17.8-.94-.04-.68.3-1.69 1.62-.42-.13s-.26.09-.34-.95c-.09-1.03-.24-1.94-.24-1.94l2.05.84.72.04.51-.17.9-1.94 1.53-1.97zM364.68 233.39s-.68-.82-1.02-1.32c-.3-.42-.44-.52-1.2-1.12l1.5-.84 1.6.02-.24 1.92-.64 1.34zM368.31 227.7s1 .5 1.32 1.25c.32.76.79 1.69.79 1.69l-2.54-.2-1.93-.6 1.25-1.75 1.11-.39zM367.32 243.37s-.51-.32-.81-1.14c-.3-.82-.53-2.14-.53-2.14l1.68-.32 1.98.8.56.04s-.47 1-.54 1.04l-1.91 1.66-.43.06zM374.04 237.94s-1.49-.47-1.72-1.17c-.26-.75-.45-.6-.45-.6l-.47 2-.6 1.89s.13.32.2.32c.06 0 1.42-.35 1.51-.39.08-.04 1.13-1.12 1.15-1.18l.38-.87zM367.77 244.25s.75.41 1.79 1.02c1.04.6 1.66.6 1.66.6l.79-.84.8-1.6.11-.2-4.02.37-1.13.65zM373.59 242.7l3.43-2.05.23-1.86-.68-.52s.13.06-.8.06h-1.18l-.62 2.27-.38 2.1zM371.14 245.94s2.4 1.04 6.56-.48c1.88-.68 2.24-1.6 2.24-1.6l-1.67-.64-1.57 1.4-5.56 1.32zM367.86 219.31s-.24-.78-.48-1.79c-.23-1.01-.21-1.45-.21-1.45l1.22.64 1.77 1.31-1.26 1-1.04.29zM370.75 224.2s-.6-.6-1.1-1.38c-.52-.78-.87-1.5-.87-1.5l1.3.27 1.5.73-.66 1.95-.17-.07z'/%3E %3Cpath fill='%23c6c7a6' d='M363.02 169.18c-.23.84-.54 2.36.62 2.65.64.16 3.13-.05 5.97-3.28 1.36-1.56 1.39-3.09 1.39-3.09l.54-1.75s-1.1-.81-2.9.31c-1.6 1.01-5.62 5.16-5.62 5.16z'/%3E %3Cellipse fill='%231c242f' cx='370.77' cy='164.64' rx='.5' ry='.53'/%3E %3Cpath fill='%23a8ac71' d='M367.16 165.17c-1.21.95-2.34 2.16-2.34 2.16s1.91-.54 3.44-1.92a4.52 4.52 0 0 1 3.44-.89c.46.1.3-.49.08-.66-.5-.4-1.88-.59-2.18-.36-.05.03-1.22.72-2.44 1.67z'/%3E %3Cpath d='M372.92 218.3s-.08-.4-.14-1.4c-.05-.99.06-1.49.06-1.49l-1.13.99-1.09 1.51 1.68.6.62-.21zM367.04 214.94s-.16-1.55-.07-3.01c.08-1.47.68-4.14.68-4.14l.72 1.83 2.06 3.21.66.48-1.74 1.28-1.8.58-.51-.23zM372.96 214.12s.1-.73.29-1.41c.17-.67.7-1.73.7-1.73s.02.1-.07.13a33.73 33.73 0 0 0-2.66 2.24l1.09.83.7-.04M368.19 206.48s.26-.96 1.18-2.13l1.82-2.36.78 3.13.46 2.68.09.56s-.64.28-.9.26c-.25-.02-2.17-.13-2.4-.45a42.79 42.79 0 0 1-1.03-1.69zM374.4 210.13s.58-.62 1.1-1.1c.5-.47 1.32-1.39 1.32-1.39l-4.21.77.6 1.43 1.19.29zM371.86 201.43s.39-.14 1.52-1.28c1.13-1.15 1.7-1.01 1.7-1.01l.47 4.52-2.21-.65-1.48-1.58z'/%3E %3Cpath d='M377.1 207.36l2.53-2.57-4.21-1.2.77 2.95zM378.87 200.56l.26-4.36s-.86.4-1.95 1.3a13 13 0 0 1-1.59 1.2l.51.78 1.5.97 1.27.11zM382.62 196.33v-3.44l-.14.07s-.6.93-1.3 1.51c-.71.59-1.03 1-1.03 1l1.13.73 1.34.13zM384.19 200.93s1.19-.99 2.06-1.67c1.3-1.03 1.94-2.15 1.94-2.15l-5.45-.42.22 2.19 1.23 2.05zM371.51 182.88l-.17 2.4 4.55-.03-1.11-1.53-1.4-.87-1.3-1.32zM380.29 204.19c.24-.18 1.42-1.07 1.98-1.63.62-.63 1.59-1.26 1.59-1.26l-4.33-.47.09 2.85.67.51zM388.52 196.4s.46-1.74.42-3.4c-.04-1.67-.31-2.41-.31-2.41l-3.24 2.2.47 1.64 1.23 1.35 1.43.62z'/%3E %3Cpath d='M382.98 192.4s.96-1.16 1.02-1.83c.07-.67.06-.46.06-.46l2.56.04 1.53.13.19.15-1.15 1.36-1.58.91-2.02.24-.61-.54zM388.16 189.85l-1.57-2.67a5.64 5.64 0 0 0-1.11-1.4l-1.25 3.71-.13.36h4.06z'/%3E %3Cpath fill='%23fff' d='M356.53 215.28l-.49 1.03s1.7-.88 3.03-.84c1.31.05 2.79 1.7 2.79 1.7l.31-1.2s-1.74-1.7-2.9-1.79c-1.14-.09-2.74 1.1-2.74 1.1zm.85-7.63s.36.43.45.56c.08.13.13-1.27 1.85-2 1.73-.74 2.67-.16 2.67-.16s-.35-1-1.11-1.2c-.77-.22-1.51-.07-2.45.6-.94.67-1.4 2.2-1.4 2.2zm5.86 5.75s-.81-1.73-2.21-2.07c-1.41-.35-3.2.73-3.2.73l-.3.9s1.92-1.08 3.32-.51c1.41.56 1.96 2.16 1.96 2.16l.43-1.21zm-6.58-6.7c.08.3.42.69.42.69s-.19-1.85.66-2.8c.86-.96 1.5-1.3 1.5-1.3l-.8-.41s-1.12.75-1.5 1.57a4.18 4.18 0 0 0-.28 2.25zm-.76-3.04c.4-.92 1.57-1.32 1.57-1.32s-.12-.2-.39-.35c-.26-.14-.54.01-.54.01s-.75.4-1.21 1.43c-.45 1.04-.4 2.54-.4 2.54l.7.39s-.13-1.78.27-2.7zm10.34-25.06c1.08-.58 1.87-.46 1.87-.46s-1.6 1.68-.83 3.76c-.9 1.76-1.18 3.09-1.18 3.09h.85s.28-1.37.62-2.44c.92 1.78 2.47 2.79 2.47 2.79l1.3-.06s0-1.74.68-3.25l.12.14a6.64 6.64 0 0 0 2.62 1.85l.01-.45s-1.5-.88-2.34-2.03l-.09-.13.03-.05c1.02-1.6 2.39-2.13 2.39-2.13l.9.75.23-.29-.68-.86-.79.02s-1.41 1.18-2.32 2.2a12.01 12.01 0 0 1-1.04-2.05l-.58-.21s-1.41.16-2.68 2.2c-.16-1.5 1.57-3.13 1.57-3.13l-.08-.63s-1.75.33-3.11.73c-1.36.4-2.2 1.7-2.2 1.7l-.05.91s1.23-1.4 2.3-1.97zm1.87 2.76c.8-1.15 2.56-1.9 2.56-1.9s.04.94 1.01 2.18c-.66 1.16-.96 2.95-.96 2.95s-1.36-.86-2.55-2.6a2.12 2.12 0 0 1-.21-.38l.15-.25zm-9.94 27.76l.06 1.01s1.05-1.14 2.62-1.18c1.58-.05 2.92 1.18 2.92 1.18s.02-1.35-.19-1.48a5.95 5.95 0 0 0-2.68-.87c-1.2 0-2.73 1.34-2.73 1.34zm28.12-14.74c-.21-.37-.44-.9-.62-1.35.24-.09.48-.2.7-.37 1.32-1 2.26-2.08 2.26-2.08l-.47-.73h-2.13c-.42 0-1.3-.1-1.8-.17.09-.33.35-1.24.66-2.2.38-1.19.73-1.82.73-1.82l-.73-.74s.17.68-1.1.85c-1.28.17-3.64-1.03-3.64-1.03v.51s2.07.67 3.27.84c.7.1 1.25-.14 1.59-.35-.19.38-.52 1.11-.7 1.77-.16.57-.38.94-.37 1.18.01.16.24.3.24.3l-.1 1.12s1.27.17 1.86.17c.6 0 2.22.13 2.22.13s-1.15 1.34-2.26 1.86c-.14.07-.3.12-.46.17a59.15 59.15 0 0 0-1.32-2.09l-.13.72s.9 1.24 1 1.5c-.82.1-2-.17-2-.17l-.5.56s-.05 1.6 0 3.26c-1.1-.3-2.34-.75-2.34-.75l-.46.34.03-.08-.6.47s-.5 1.94-.37 4.15v.11c-2.1-.52-3.16-1.75-3.16-1.75l-.5.43s-.35 1.9.12 4.2a7.73 7.73 0 0 1-3.35-1.9l-.67.55s.4 3.72.83 5.75c.03.17.08.32.13.48-.36.03-.7.05-.99.04-1.83-.09-2.96-1.77-2.96-1.77l-.54 1.3s.7 3.58 2.7 5.18l.45.36a7.95 7.95 0 0 1-3.76 1.61l.12 1.13s1.22.96 2.42 1.78l.37.23c-.95.84-2.12 1.19-2.12 1.19l.32.75s1.58-1.1 2.31-1.7c1.06.42 2.46.6 2.46.6v-.62s-1.03-.09-1.98-.4l.14-.12c.6-.58 1.76-2.36 1.76-2.36l.11-1.3s-.73-.1-1.52-.73c2.41-1.66 2.5-2.4 2.5-2.4l.46-.86s-.82-.35-1.42-1.54a28.4 28.4 0 0 0 3.84-.95c.04-.13.28-.27.28-.27s-.92-1.52-1.32-3.38c1.9.5 3.86.81 3.86.81l.6-.52s-.46-1.55-.61-3.23c2.26.15 4.18.32 4.18.32l.39-.44s-1.28-2.44-1.24-3.82v-.13c.44.08.88.14 1.28.13 1.87-.05 3.96 0 3.96 0l.32-.71s-1.81-1.24-2.23-2.02zm-13.8 20.33s-.6 1.24-1.84 2.67l-.3.3a6.05 6.05 0 0 1-.64-.3c-1.44-.83-1.81-1.76-1.81-1.76s.8-.4 3.23-2.03c1.3 1.02 1.37 1.12 1.37 1.12zm1.14-4.12s-.76.9-2.53 2.49a5.42 5.42 0 0 1-.55-.6c-1.13-1.47-2.55-2.74-2.41-4.96 0 0 .88 1.59 2.84 1.38.4-.03.86-.1 1.34-.19a4.36 4.36 0 0 0 1.31 1.88zm2.64-3.33s-1.81.6-3.5.87a6.96 6.96 0 0 1-.2-.56c-.64-2.08-.64-5.23-.64-5.23s1.42.98 3.4 1.53c.58 2.35.94 3.4.94 3.4zm-.6-3.83c-.3-1.94.1-3.86.1-3.86s1.05 1.06 3.02 1.39c.13 1.78.34 2.67.34 2.67s-1.5.09-3.46-.2zm7.63-2.95s-1.27.5-3.7.15l-.05-.71c-.08-2.2.11-3.99.11-3.99l.01-.03c.35.16 1.65.69 2.86.98v.14c.18 1.99.77 3.46.77 3.46zm-.17-4.1l-.13-.04c.08-1.4.08-3.47.08-3.47s1.18.32 2.1.2c.24.6.08.75.68 1.66.6.91 1.49 1.65 1.49 1.65s-3.02.25-4.22 0zm-9.88 24.44l-.17-.71s-1.2.89-1.53 1.8a2.16 2.16 0 0 1-.37-.1c-.8-.29-2.67-1.02-2.67-1.02l.27.53s1.94.9 2.45 1.01l.17.03a72.1 72.1 0 0 1-.65 1.84l.31.44s.18-1.32.68-2.24c.67.07 1.6.1 1.6.1s-.12.52-.29 1.1c-.17.57-.51 1.93-.51 1.93l.58.36 2.72.06-.46-.54s-.09-.14-.97-.17-1.42.12-1.42.12.12-.55.46-1.65c.34-1.1.35-1.03.35-1.03l-.34-.95s-.87.24-1.44.22c.5-.74 1.23-1.13 1.23-1.13zm-14.82-1.72a5.57 5.57 0 0 1 3.06 1.13l-.06-.8s-1.3-1.75-2.79-1.75c-1.5 0-3.26 1.53-3.26 1.53v1.64s1.38-1.75 3.05-1.75zm17.5 25.5c-1.7.73-3.62.73-3.62.73s.52-.74 1.03-2.02c3.33-.94 4-3.16 4-3.16l-.21-.82s-.81 2.03-3.5 3.15c.5-1.57 1-4.23 1-4.23l-.91-.24s-1.31 1.65-2.55 2.06c.84-1.63.95-3.5.95-3.5l-.4-.72s-.9.8-2.3 1.06c-.22.04-.45.03-.7 0h.01c.77-1.08 2.24-4.2 2.24-4.2l-.26-.58s-1.12 2.75-2.27 4.13l-.44.5c-1.18-.33-2.86-1.34-2.86-1.34l.19.52s.95.73 2.35 1.17c-.85.9-1.78 1.72-1.78 1.72l.09 1.25s2.15.41 3.93.6a9.63 9.63 0 0 1-2.6 2.69l.58.86s1.76 0 4.9-.78c-.89 1.69-1.57 2.43-1.57 2.43s2.87.2 4.83-.8 2.56-2.03 2.56-2.03l-.56-.61s-.42 1.43-2.13 2.16zm-9.07-5.4s.85-.94 1.57-1.89l.1.02c2 .44 2.55-.17 2.55-.17s.38 1.09-.84 3.04c-1.44-.06-3.38-1-3.38-1zm1.79 4.01l1.79-2.07c.13-.15.24-.3.34-.44 1.96-.07 3.07-1.68 3.07-1.68s.23 1.63-.65 3.63c-2.5.9-4.55.56-4.55.56zm-2.43-12.87c1.88.12 4.3 1 4.3 1l-.3-.98s-2.3-.57-3.74-.75c.64-1.44 2.06-2.13 2.06-2.13l-.64-.34s-.78.13-1.85 1.94l-.24.45a5.48 5.48 0 0 0-3.53.93l.26.52s1.48-.64 2.94-.66c-.53 1.47-.92 3.15-.92 3.15l.38.89 1.27-4.02h.01zm-3.94-8.04l-.4-1.04s-2-.71-3.54.02c-1.53.74-2.68 2.5-2.68 2.5l.64 1.22s1.06-1.97 2.47-2.44c1.4-.48 3.51-.26 3.51-.26zm3.9 3.04l-1.32-.69s-2.17.63-2.94 1.4c-.77.79-1.39 2.77-1.17 3.33.21.56.9.93.9.93s.35-2.1 1.42-3.09c1.07-.99 3.1-1.88 3.1-1.88zm-5.07-.62a5.9 5.9 0 0 1 2.51-1.2l-.8-.73s-1.97.24-2.99 1.15c-1.02.9-2.34 2.79-2.34 2.79l1.15 1.12s1.58-2.27 2.47-3.13zm6.75-58.72l.07-.09c1.03-1.33 2.03-1.33 2.42-1.22.17.05.39.03.59 0h-.01l.03-.01.14-.03c.05 0 .1.02.12.07-.33.52-.8 1.94-1.04 3.13-.3 1.47-.93 1.64-1.4 2.55-.47.9-1.45 2.42-1.5 3.71-.03 1.3.3 2 .65 2.16.34.18.96-.56.93-.86-.04-.43-.38 0-.63 0s-.22-.43-.35-1.2c-.12-.79.94-2.95 1.33-3.64.38-.7 1.19-1.51 1.36-2.68.15-1.04.9-3.32.9-3.33 0-.06-.57-.22-1.7-.3-.84-.06-1.97.68-2.5 1.5-.54.82-2.22 1.48-2.22 1.48s1.84.01 2.8-1.24z'/%3E %3Cpath d='M374.33 178.91l-3.27.09.94 2.44zM370.48 178.78s-.48-.3-.7-.56c-.23-.26-.4-.37-.4-.37l-1.19.74-.68 2.42.34.35 2.63-2.58zM370.04 185.34l-2.39-3.52-1.36 2.94.65.23s.66.06 1.65.2c1 .15 1.45.15 1.45.15zM379.74 244.06l-.12.08c-.57.38-3.07 1.9-6.14 1.9a8.76 8.76 0 0 1-4.54-1.24 5.14 5.14 0 0 1-2-2.35c-.7-1.47-1-3.33-1.31-5.14-.32-1.8-.65-3.55-1.44-4.83-1.08-1.71-3.1-2.78-4.9-4.3a9.62 9.62 0 0 1-3.81-7.9c0-2.26.72-4.23 1.46-5.95.73-1.73 1.49-3.2 1.5-4.53 0-.22-.03-.44-.08-.65-.24-1.02-1.13-1.88-1.94-2.52-.81-.63-1.57-1.01-1.57-1.02h-.02l-1.27-.36-.1.4 1.24.35.05-.2-.09.18.12.07c.29.15 1 .57 1.69 1.15.68.57 1.33 1.31 1.5 2.04.03.18.05.37.05.56 0 1.17-.71 2.63-1.46 4.36a15.42 15.42 0 0 0-1.5 6.12c0 .35.02.7.06 1.06.34 3.56 2.05 5.61 3.9 7.16 1.86 1.55 3.84 2.63 4.82 4.2.98 1.57 1.24 4.09 1.71 6.5.24 1.2.54 2.4 1.02 3.43a5.53 5.53 0 0 0 2.17 2.53 9.17 9.17 0 0 0 4.74 1.3c3.66 0 6.48-2.05 6.5-2.06l-.24-.34z'/%3E %3Cpath d='M376.91 237.6l-.03.02c-.14.08-.8.45-1.64.45-.67 0-1.47-.23-2.28-1.02a5.32 5.32 0 0 1-1.52-3.03c-.25-1.14-.44-2.53-1.22-4.34-.8-1.86-2.78-3.35-4.62-4.82-1.85-1.45-3.55-2.88-3.85-4.44a4.3 4.3 0 0 1-.09-.88c0-1.31.56-2.64 1.15-4.15a14 14 0 0 0 1.18-5.22c0-.34-.01-.7-.05-1.05-.27-2.61-2.26-4.55-4.15-5.84a18.5 18.5 0 0 0-3.73-1.96l-.13.4.3.11c.68.28 2.41 1.05 4.02 2.3 1.6 1.23 3.07 2.92 3.28 5.03.04.35.05.69.05 1.01 0 1.94-.57 3.56-1.15 5.07-.58 1.5-1.18 2.87-1.18 4.3 0 .32.03.64.1.96.37 1.79 2.15 3.22 4 4.7 1.85 1.45 3.77 2.94 4.5 4.65.76 1.76.94 3.09 1.19 4.26.24 1.17.58 2.2 1.64 3.24a3.58 3.58 0 0 0 4.46.6l-.23-.35z'/%3E %3Cpath fill='%23a8ac71' d='M388.97 227.59s2.29.54 2.2 2.4a17.5 17.5 0 0 1-1.1 4.45l-3.16-2.86 1.78-1.57.65-.93-.37-1.49z'/%3E %3Cpath fill='%23f8c83c' stroke='%23977c2e' stroke-width='.35' d='M349.61 205.23s-2.26.78-2.73-.22c-.46-.99-.25-1.77-.3-1.98-.04-.22-1.36-.3-1.23-1.6.13-1.3 1.79-1.21 2.13-1.21.34 0 .43-2 1.58-1.9 1.15.08 1.7 1.42 1.7 1.42l-1.15 5.49z'/%3E %3Cpath fill='%23f8c83c' stroke='%23977c2e' stroke-width='.35' d='M352.12 205.84s-1.92 1-2.51.04c-.6-.95 0-2.16-.22-2.37-.21-.22-1.36-.6-1.15-1.73.22-1.13 1.4-.78 1.84-1 .42-.21.72-1.9 1.91-1.6 1.2.3 1.4 1.26 1.4 1.26s-.93 4.5-1.27 5.4z'/%3E %3Cpath fill='%23f8c83c' stroke='%23977c2e' stroke-width='.35' d='M355.36 206.27s-.55 1.21-1.92.95c-1.36-.26-.93-2.25-1.15-2.6-.21-.34-1.19-.6-1.02-1.85.17-1.25 1.4-1.08 1.87-1.25.47-.18.98-2.12 1.88-1.82.9.3 1.74 1.43 1.57 1.95 0 0-1.91.6-2.17 1.9-.25 1.3.94 2.72.94 2.72z'/%3E %3Cpath fill='%23af7029' d='M385.51 227.14s-1.7-1.87-2.9-3.51a37.44 37.44 0 0 0-3.04-3.52l-2.92-1.47-1.84-3.08-.23-3.63.8-2.1 1.1-1.62s-6.06 2.17-2.98 13.77c1.3 4.93 4.65 5.65 4.65 5.65l5.57-.34 1.79-.15z'/%3E %3Cpath fill='%23816c2a' d='M382.71 188.39c.58.02.86.2 1.03.45.18.24.23.57.23.85 0 .15-.01.29-.03.39l-.02.1v.04l.2.06-.2-.09c-2 4.44-6.25 6.51-10.07 9.28a18.1 18.1 0 0 0-5 5.08c-1.32 2.13-2.15 4.83-2.15 8.46v.56c.16 6.68 2.68 10.27 5.46 12.15a12.7 12.7 0 0 0 6.9 2.07h.48v-.01c.01 0 .79-.1 1.9-.2 1.12-.1 2.57-.2 3.9-.2.86 0 1.67.04 2.31.14.64.1 1.1.3 1.24.49.18.22.25.44.25.67 0 .5-.37 1.09-.82 1.55-.44.47-.96.83-1.15.91l.18.38c.26-.13.78-.5 1.27-1 .48-.5.92-1.14.93-1.84 0-.32-.1-.65-.34-.94-.3-.34-.82-.5-1.5-.63-.67-.1-1.5-.15-2.36-.15-2.72 0-5.85.4-5.85.4l.02.21-.01-.2h-.44c-1.1 0-4.02-.19-6.69-2-2.66-1.81-5.1-5.23-5.26-11.8V213c0-3.57.8-6.18 2.07-8.24 1.9-3.1 4.88-4.99 7.79-6.95 2.9-1.96 5.75-4 7.31-7.46l.01-.01v-.02c0-.01.08-.28.08-.64 0-.33-.06-.74-.3-1.1-.25-.35-.7-.6-1.36-.62l-.01.42z'/%3E %3Cpath fill='%23fff' d='M390.88 229.04s-1.44 2.63-1.8 2.66c-.37.02 1.24.41 1.6 1.03l-.34.65s-1.59-1.13-2.58-1.18l-.1-.97s.82-.28 1.5-.9a5.27 5.27 0 0 0 1.14-2.24l.58.95z'/%3E %3Cpath fill='%23fcca3d' d='M396.48 230.77l-3.58.98-1.82-1.14s.15-1.49-.66-2.13c-.84-.66-1.33-.85-2.06-1.16-.72-.3-3.28-.35-3.28-.35l-6.46-7 2.41.25 3.82-.47 3.55-.3 1.88.27 2 .62 1.05.9 1.09.96 1.1 1.8.7 2.03.27 2.19-.01 2.55z'/%3E %3Cpath fill='%23af7029' d='M396.62 230.54s-1.28.38-2.9.34c-1.62-.02-2.65-.27-2.65-.27s.1.1-.24 1.17a15.07 15.07 0 0 1-.66 1.73l.06 4.2 3.4.67 1.8-.7.9-4.58.29-2.56z'/%3E %3Cpath fill='%23fcca3d' d='M395.67 228.76l.15 1.63.67.2-.01-1.47zM392.46 189.47l-.4-2.87-1.12-1.9-1.42-1.94-1.52-1.67-.85-.76-.36-.57-3.73.18-1.96 2.33s5.1 3.6 7.02 7.53a9.26 9.26 0 0 1 3.67 2.26l.17-.31.5-2.28z'/%3E %3Cpath fill='%23af7029' d='M388.84 192.63c-.05 2.92-.55 4.3-.94 4.95l2.26-2.59 1.63-2.93a9.26 9.26 0 0 0-3.67-2.25c.46.93.74 1.89.72 2.82z'/%3E %3Cpath fill='%23816c2a' d='M394.11 235.87s-1.05-1.31-1.83-2.08c-.8-.78-1.73-1.2-1.74-1.2l-.17.37.15.07c.28.15.92.52 1.47 1.06a22 22 0 0 1 1.8 2.04l.32-.26z'/%3E %3Cpath fill='%236f5b24' d='M396.31 232.73s-.34 1.26-1.62 2.42c-1.28 1.15-2.9 1.93-2.9 1.93l3.67 1.35 2.44-2.27-1.59-3.43z'/%3E %3Cpath fill='%23404118' d='M396.85 235.77l-.22.43-.7.67-.53.57.91-3.8.65 1.12.09.6z'/%3E %3Cpath fill='none' stroke='%2378732e' stroke-width='.3' d='M375.12 185.22s-5.03.43-8.52-.17c-3.5-.6-2.73-9.51-2.81-9.77-.09-.26-2.13-2.42-1.8-4.4.35-2 6.8-7.24 7.68-7.52.6-.2 1.87.34 1.87.34s1.63-1.58 2.12-1.58c.5 0 1.18.91 1 1.3-.2.39-2.42 1.68-2.59 2.68-.17 1 .03 1.99-.62 2.96-.63.97-1.87 2.29-2.02 3.11-.15.82-.5 1.54.1 1.84.63.3 2.74.04 4.55-.78 1.8-.82 2.55-1.92 2.8-1.82.26.11-1.04 2.27-3.04 3.12-2 .84-3.32 1.81-4.32 1.66 0 0-1.11 2.66 2.32 2.8 3.43.16 5.32-.75 5.32-.75l-2.04 6.98z'/%3E %3C/g%3E %3Cg fill='%23d2a567'%3E %3Cpath fill='%23ab6d29' stroke='%234d2a15' stroke-width='.51' d='M418.24 147.56s-9.2-1.74-9.05 5.93c.04 2.42.58 3.25 2.53 3.8 1.94.54 5.84.74 9.15 3.7 3.3 2.97 3.55 5.14 3.55 6.92 0 1.77-.82 3.4-.82 3.4l2.09 10.13 2.1 7.5 6.22-3.6 3.66-11.11-4.68-20-14.75-6.67z'/%3E %3Cpath fill='%234d2a15' d='M427.38 186.09s3.2-1.21 4.03-3.8c.23-.72-3.24-3.83-3.32-3.83-.08 0 1.76.89 2.61 1.67.85.78 1.5 1.1 1.76.98.26-.12 1.74-3.55 1.17-4.3-.57-.75-1.45-2.5-2.79-3.4-1.33-.89-3.1-.77-3.1-.77s2.45-.78 3.67-.09c1.22.7 1.34 1.5 1.48 1.21.14-.29-.26-3.72-.81-4.87s-1.12-1.7-2.6-1.99c-1.47-.29-3.07-.17-3.07-.17s2.13-1.18 3.75-.78c1.62.4 1.6 1.21 1.73 1.04.15-.17-.8-3.14-1.17-3.9a8.75 8.75 0 0 0-2.86-2.41c-.54-.17-2.3-.23-2.3-.23l-.85.01s1.22-.85 2.79-.7c1.55.14 1.64.66 1.86.57.23-.08-.17-.28-1.11-.95-.96-.66-5.56-2.62-5.56-2.62l-4.2-.06s-.05-1.06 1.18-1.26c1.22-.2 1.57.15 1.49-.16-.09-.32-3.55-1.08-3.55-1.08l-2.84.09c-.85.02-3.95.38-3.95.38s.27-.68.88-1.2c.46-.41 1.17-.67 1.76-.83 1.36-.37-.76-1.44-.76-1.44l1.13-1.73 5.12.43 10.79 6.31 5.05 4.36 3.21 8.18-.97 14.06-7.21 5.96s-3.18.5-3.18.35c0-.15.74-3.03.74-3.03z'/%3E %3Cpath d='M417.97 151.17s-.34-1-.34-2.25.21-1.2.21-1.2-3.45-.48-5.96 1.5c-2.51 2-1.07 5.45-1.07 5.45s1.1-1.08 2.5-1.6 3.94-.43 3.94-.43c.2-.22-.56-1.21-1.5-1.43-.93-.21-2.76-.21-2.76-.21s1.06-.74 2.9-.56c1.83.17 2.08.73 2.08.73z'/%3E %3Cpath fill='%238f4620' d='M428.76 187.3l-2.33.8 1.42 9.8 9.31 15.96 4.89-.86 1.65-2.94 1.3.58c.57.57 2.39 3.68 3.92 4.32 1.53.63 2.33.4 3.7 1.5 1.36 1.1 6.34 8.51 6.6 8.8.25.28-.29-3.19-.29-3.19l-1.52-4.43-1.88-3.1-.29-.83 2.59.02 1.6.99 2.46 2.05 1.27 1.51.67 1.56.28 1.37.66 2.12 1.36 2.94 1.64 2.8.52-1.15-.8-3.28-2.5-7.97-1.53-2.68s2.02 1.45 2.56 1.64c.54.2 2.37 2.93 2.37 2.93l1.16 2.82.84 2.62.58 2.3.84 2.44 1.45-.83-.26-1.77-1.25-5.47-.54-5.92s.7-.01 1.55.92c.85.94 1.62 3.06 1.62 3.06l.63 5.36.85 4.91 1.59 5.01 1.66 3.16 1.08 1.77s.05-2.5.04-2.62l-2.03-20.97.27-.88s.24-.13.94.86c.7 1 1.39 2.55 1.39 2.55l.6 3.27.3 2.26.43 4.26.57 4.63 2.13 4.96 1.15 2.67.64-3.18-1.01-22.43.47-.65s1.2.98 1.59 1.68a7 7 0 0 0 1.14 1.36l.7 4.95.62 14.14.5 3.64 4.16-37.04 2.56-.57.3-.7-1.87-1.44-4.22-6.54-2.84-6.33-4.98-9.18-8.65-10.54s-5.37-4.58-6.73-5.62a26.34 26.34 0 0 0-2.5-1.69l.43-1.31 1.43-2.32-.23-.1-1.11.06-2.9.41-2.92-.86-5.72-4-6.14-2.92-3.6-1.27-8.69-2.2-8.64-1.17-3.88-.06-3.54.66s-1.8.74-2.36 1.85c-.56 1.11-.6 1.89-.43 3.51.17 1.62 1.15 2.46 3.58 3.46s8.14 4.8 8.14 4.8l2.75 2.76 1.02 1.32.14 1.02 1.86 14.58-3.67 7.93-2.62 1.36z'/%3E %3Cpath fill='%23ab6d29' d='M438.11 210.03s1.56 2.65 3.78.6c2.21-2.04-.97-7.86-.94-8.2.03-.35 1.02-.47 1.02-.47l1.62 3s.97 1.61.6 4.18c-.37 2.56-2.84 4.78-2.84 4.78l-2.81-.64-.43-3.25z'/%3E %3Cpath fill='%234d2a15' d='M492.51 244.21l-2-5.92s-.6-3.8-.6-4.58c0-.78-.38-10.42-.55-12.23-.17-1.82-.08-3.9-.28-4.15l-2.17-2.87-.85-.9.6-.42s.74.8.94.37c.2-.43-.03-2.53-.85-5.82-.83-3.28-5.03-10.97-5.03-10.97l.45.37 1.17 1.18 2.47 1.99 5.34 1.96 2.9.46 1.87 3.75s1.33 6.45 1.25 9.7c-.09 3.26-.29 5.9-1.53 9.16-1.25 3.26-1.56 13.57-1.73 15.21-.18 1.65-.8 3.26-.8 3.26l-.6.45z'/%3E %3Cpath fill='%238f4620' d='M492.53 227.08s1.12-1.33 1.6-3.16c.5-1.83.69-16.2-1.01-17.98-1.7-1.78-5.19-3.18-5.36-3.06-.17.12 1.4 4.68 1.4 4.68s.51.67 1.05 1.86c.3.66.7 1.86.77 2.3.19 1.23 1.2 4.15 1.36 7.9.14 3.76.19 7.46.19 7.46z'/%3E %3Cpath fill='%234d2a15' d='M484.68 236.1s.73-6.8.39-11.78c-.34-4.98-.75-5.6-1.22-6.5-.48-.9-2.19-4.15-3.35-8.3-1.15-4.14-1.9-7.32-2.65-8.15-.75-.83-2.26-2.63-2.6-2.15-.34.49-.34 1.52-.34 1.52l-2.04-.55-.48-1.31.66-2.12-.13-.9-.24-1.5 2.64 2.1 5.43 3.71 2.72 11.25 2.53 7 .35 11.86-.25 10.44-1.42-4.62zM487.87 203.66s1.42 1.34 2.25 1.8c.83.47 2.4 1.43 2.08 1.54-.3.1-1.77-.47-2.69-.99-.92-.51-1.54-1.15-1.54-1.15l-.1-1.2z'/%3E %3Cpath fill='%234d2a15' d='M477.3 233.42s1.08-2.39.91-5.41c-.17-3.03-1.62-10.32-2.07-11.24-.46-.93-2.61-2.3-4.55-6.4-1.93-4.09-1.73-4.92-3-6.42-1.28-1.5-2.62-3.2-2.62-3.2l.4-4.38 4.71 2.4 2.02 1 2.39 11.47 2.13 3.2.9 4.58 1.14 10.68.62 8.5-.34.75-2.64-5.53zM471.86 228.57s.13-3.37-.73-6.4c-.85-3.02-1.44-5.27-2.38-6.22a45.79 45.79 0 0 1-5.45-6.61c-2.13-3.2-5.08-6.57-5.08-6.57l.08-4.29s1.42 1.33 2.62 1.92c1.2.58 3.01 1.6 3.01 1.6l1.26 4.91 1.63 3.54 2.38 3.17 1.53 1.4.97 5.3.52 2.98 1.25 4.25-.41 2.13-1.2-1.11zM467.94 228.61l-1.3-1.25s.7-.85.36-2.53c-.34-1.69-.79-3.3-1.55-4.9-.77-1.6-1-2.58-1.47-3.05-.47-.48-4.45-4.24-5.84-5.38-1.38-1.15-3.5-3.33-4.83-4.17-1.32-.84-2.28-1.06-2.28-1.06l-.75-5.28s1.75 2.34 2.8 2.73c1.04.39 2.74.93 2.74.93l3.7 6.54 1.26 1.67 3.43 2.74 1.4 2.83 1.05 3.27 1.3 4.5.24 2.71-.26-.3zM460.66 227.14s-2.19-2.5-2.53-4.12c-.34-1.61.23-1.61-.45-3.46-.69-1.84-2.96-4.55-4.83-6.05-1.88-1.5-4.54-3.68-4.37-4.9.17-1.2.5-1.26.5-1.26l1.14.97 5.85 6.23 1.8 3.26 1.36 4.06.9 1.9.88 2.42-.25.95zM481.76 196.6s4.03 5 5.05.4c.46-2.04-1.4-5.94-1.4-5.94s-3.74-6.56-5.01-8.14c-1.28-1.59-7.53-9.6-7.53-9.6l-4.57-2.13 1.56 2.68s3.4 3.4 7.76 10.92c4.34 7.52 3.49 11.67 3.49 11.67l.65.14zM458.35 166.47s8 6.83 13.16 14.22c5.16 7.39 7.2 12.32 6.05 13.3-1.15 1-4.39-.55-5.7-2.63-1.33-2.07-2.44-5.7-7.3-11.24-4.85-5.53-7.19-6.35-7.19-6.35l-3.5-5.66 4.48-1.64z'/%3E %3Cpath fill='%234d2a15' d='M454.18 182.84s4.73 3.93 7.7 7.13a49.06 49.06 0 0 1 4.53 5.49l1.91 1.9s-1.15-2.03-.5-2.72c.63-.7 1.4-.35 1.4-.35l-15.04-15.77v4.32zM453.2 183.28s1.53 2.94 4.05 5.4c2.51 2.46 5.28 5.1 5.28 5.1l1.07 3.85s-6.86-5.27-6.9-3.98c-.05 1.3 1.66 3.98 1.66 3.98l-2.1-1.13-2.89-4.19-1.75-3.63-1.96-5.01 3.54-.39z'/%3E %3Cpath fill='%234d2a15' d='M432.46 199.53s3.58 3.2 5.54.09c1.96-3.12.43-6.7.43-6.7s5.05 7.45 6.47.47c.26-1.25-3.07-6.1-3.07-6.1l1.2-1.11 2.55 4.32s2.39-1.08 2.39-4.06c0-2.99-2.47-6.83-2.47-6.83l2.35 2.62s4.67.1 4.76-2.75c.08-2.85-3.92-5.84-3.92-5.84s3.2.22 3.15-1.64c-.04-1.86-4.34-3.15-4.43-4.32-.08-1.17 1.28-3.16 3.24-2.07 1.96 1.08 4.69 1.94 5.8-.18 1.1-2.12-.1-2.55-.1-2.55s-2.5-.51-2.76-.6c-.26-.09-4.48-2.38-4.48-2.38l-3.54-1.34-3.65-.47 1.36 2.72.94 7.47.04 3.46.68 7.52-1.8 6.27-.92 1.13-.66.84-1.56 3.3-2.18 2.38-2.8 3.58-2.56 2.77z'/%3E %3Cpath fill='%23ab6d29' d='M457.82 213.57s-.9-2.24-2.83-3.74c-1.94-1.5-5-1.62-5-1.62l5.25 5.56 2.58-.2zM465.17 214.84s-1.7-3.4-3.69-5.47c-1.99-2.08-3.3-4.76-3.84-4.76-.53 0-.93.12-.93.12l.51 4.29 3.63 3.52s3.41 2.53 4.32 2.3zM471.22 214.58s-.85-3.95-2.87-7.75c-2-3.8-4.14-5.36-4.14-5.36l.48 4.06 1.65 3.92 2.67 3.86 2.21 1.27zM476.16 212.36s1.42-8.12.14-10.37c-1.27-2.25-3.69-2.68-3.69-2.68l-.77 1.18.77 5.79 1.93 4.43 1.62 1.65zM481.02 198.82s1.2.6 2.64 3.34c1.45 2.74 3.5 10.84 3.46 11.27-.03.42-.76.33-.96.23-.2-.1-5.11-7.78-5.11-7.78l-.78-7.18.75.12z'/%3E %3Cpath d='M446.72 208.26s2.6-.56 2.6-1.47c0-.9-3.1-2.72-2.85-4.2.12-.73 2.64.14 2.81-.38.17-.52-2.6-4.84-1.75-5.83.85-1 3.2 4.66 3.2 4.66s1.4 2.67.9 4.2c-1.59 4.7-4.91 3.02-4.91 3.02zM452.81 202.38c.13-.38 4.1.52 4.13.26.16-.93-3.57-3.8-3.57-3.8s-.86-1.64-.6-1.9c.25-.26 2.64.26 2.77-.09.13-.35-2.73-4.1-2.73-4.8 0-.69.77-.08.77-.08s2.26 2.33 3.45 4.23c1.2 1.9 2.31 3.46 1.92 6.48-.43 3.24-6.48.74-6.14-.3zM470.71 196.42s-.64-2.68-.26-3.03c.39-.34 1.41-.64 1.41-.64s-2.11-1.32-3.11-1.34c-1-.03-1.15-.32-1.4.1-.26.42 1.8 3.03 1.8 3.03l1.56 1.88z'/%3E %3Cpath d='M458.65 198.49s6.1 1.51 6.35 1.08c.25-.43-4.86-5.19-4.86-5.19s-.34-.86-.25-1.16c.08-.3 2.2-.35 2.85.17.64.52 0 1.51.21 1.9.21.4 2.13 3.33 2.48 2.85.34-.47-.4-4.06-.22-4.32.17-.26 2.34 2.03 2.94 2.42.6.4 4 3.07 4.34 1.82.35-1.25.56-1.47.43-2.2-.13-.74 1.14 3.45-.46 3.97-1.59.52-3.42-.56-3.42-.56l-1.4-1.08-.83-.87s.91 3.25-.15 3.59c-1.07.35-2.3.17-2.3.17l-2.56-.26-3.15-2.33zM472.64 194.33s6.5 3.9 7.14 3.21c.65-.69-1.7-9.85-1.32-10.8.3-.76 5.28 10.4 2.86 11.93-1.86 1.16-2.77.34-2.77.34l-3.2-1.68-2.71-3zM490.73 210.76s.59.44 1.42.67c.26.08 1.04.31.83.34-.22.01-1.74.2-1.85.24-.1.04-.4-1.25-.4-1.25zM484.42 189.27s.62.35 1 .46c.39.11.88.35.88.41 0 .07-.48.27-.82.23-.34-.04-.56-.14-.56-.14l-.5-.96zM482.55 186.07s.67.3 1.52-.3.9-1 .84-1.33c-.07-.31-1.4-.31-1.86-.62-.46-.3-.43-.85-.43-.85l-1.46-.02-.54.2 1.93 2.92zM488.29 204.93s1.99 1.17 2.55 1.28c.55.1 1.49.62 1.36.8-.13.17-1.6.3-2.34-.13-.75-.44-1-.17-1-.17l-.57-1.78zM477.58 175.32l.03.01c.11.03.48.13.8.1.38-.05.7-.28.82-.13.27.3.06 1.68-.48 2.07-.54.4-1.2.72-1.29.7-.1-.03-2.1-2.9-2.1-2.9l2.22.15zM468.26 166.98s1.3-.08 1.95-.07c.65 0 1.4.47 2 .84.58.37 1.16 4.3.84 5.03-.31.75-4.7-2.54-4.81-2.83-.13-.3-2.03-3.24-2.03-3.24l2.05.27zM464.15 165.2s3.19.2 2.9-1.83a4.21 4.21 0 0 0-1.76-2.91l-3.82 2.72 2.68 2.02zM455.6 161.47s.85.47 1.8.1c.95-.37 3.46-3.63 5.28-4.03 1.83-.4 2.2-.37 2.54.05.34.42.17 2.28-.25 2.8-.4.51-5.72 2.76-5.72 2.76s-1.1-.07-1.96-.27c-.86-.2-1.74-.57-1.74-.57l.05-.84zM454.61 155.6c-.8-1.88-2.24-2.65-2.78-2.53-.53.13 1.83 2 2.17 4.6.34 2.59.31 4.33.27 4.48-.05.14 1.1.16 1.1.16l.21-.99.14-.7-.01-.64-.16-1.35-.28-1.05-.23-.81s-.02-.2-.43-1.17zM447.06 152.92a20.19 20.19 0 0 0-7.17-4.88c-.3 0 5.15 3.28 6.39 5.4 1.23 2.12 1.27 4.97 1.83 5.36.55.39 1.06-.2 1.1-.26.05-.07.45-.65.39-.82a30.4 30.4 0 0 1-.34-1.36l-.85-1.43-.51-.89-.84-1.12zM439.82 149.94c-3.1-2.72-8.7-4.02-13.23-4.08-4.54-.07-6.86.34-6.2 2.83.66 2.48 2.7 3.56 6.54 3.56s4.75-.4 6.82.24c2.07.65 3.96 1.81 4.7 2.6.75.77-1.42-1.9-3.38-3.38-1.96-1.47-3.25-2.24-3.25-2.24s-.37-.8 2.27-.44c2.64.37 6.17 2.08 7.13 4.28s.81 3.42.8 3.9c-.03.47.9-.27.9-.27l.4-1.08s.14-.86-.37-1.84c-.51-.97-.6-1.3-1.79-2.7-1.2-1.4-1.34-1.38-1.34-1.38zM427.23 187.35c1.93-.06 6.25-3.74 6.88-8.87.62-5.13-2.56-15.56-3.3-16.65-.74-1.1 1.19-.52 2.24.57s3.21 8.53 3.21 13.95c0 5.41-1.08 6.97-3.97 9.73-2.9 2.77-5.23 2.48-5.23 2.48l.17-1.21zM433.94 202.57s.96 1.21 2.04.8c1.99-.74 5.06-2.2 5.06-5.06 0-1.85-2.39-3.46-2.5-4.15-.11-.7 0-1.27 0-1.27l2.1.46.6 2.94s.82.86 1.67.52c.86-.35 3.3-2.13 2.95-3.86-.33-1.73-2.66-3.86-2.89-4.73-.23-.86.06-1.61.06-1.61l1.99.34.6 2.53s.53.87 1.67.64c1.13-.23 3.12-2.3 2.67-3.28-.46-.98-1.93-3.29-2.05-3.52-.11-.23-.05-1.1-.05-1.1l.8.46s.76.3 2.3-.15c1.53-.46 3.02-1.5 3-2.55-.03-1.06-1.16-2.08-1.24-2.66-.09-.58-.02-.82-.02-.82l1 .15 1.23 1.53.3 1.84-.45 1.57-1.87 2.04-1.85.78-.51-.05 1.13 1.97-.37 2.61-1.64 1.51-2.2 1.32-.16 2.44-1.22 2.64-2.8 1.66h-.84l-.32 1.6-1.76 2.51-3.05 2.03-2.22.41-1.27-1.86.11-.63z'/%3E %3Cpath d='M450.74 174.88s5.1 1.44 4.94-1.79c-.09-1.81-5-5.99-5.3-6.68-.32-.7-.23-1.64-.23-1.64l2.54 2.32s3.24.78 4.16-1.1c.92-1.87.18-3.04.02-3.09-.16-.04.74-.16.74-.16l1.5.3-.18 2.9-1.66 7.25s.44 2.85-1.8 3.05c-2.25.2-4.73-1.36-4.73-1.36zM455.57 213.55s.09-1.47-1.05-2.5c-1.14-1.02-3.32-1.98-3.68-2.2-.35-.21 3.65 4.55 3.65 4.55l1.08.15zM462.96 213.79s-2.56-3.15-3.1-4.24c-.56-1.07-1.89-3.45-2.95-3.56-1.06-.11 1 3.93 1 3.93l4.15 3.78.9.09zM469.96 213.72s-2.2-4.15-2.73-5.36c-.53-1.21-1.68-4.52-2.98-5.42-1.3-.91.17 1.5.17 1.5l1.39 4.3 2.43 3.75 1.72 1.23zM475.12 210.71s-.15-3.54-.58-6c-.42-2.47-2.34-4.52-2.47-4.43-.13.08.15 4.38.15 4.38l2.9 6.05zM485.77 213.38s-1.79-4.26-2.51-6.27c-.73-2-2.52-5.38-2.7-5.42-.2-.04.53 3.87.53 3.87l2.17 6.22 2.51 1.6zM495.01 202.23s-1.64-1.69-5.18-3.07c-3.53-1.38-7.07-1.53-7.07-1.53l.43.45 1.6 1.36 3.7 1.9 4.83 1.17 1.69-.28z'/%3E %3Cpath fill='%23202020' d='M457.05 204.32s.03 3.08 1.62 4.96c1.59 1.87 5.34 5.3 6.08 5.99.74.69 1.36 4.5 2.47 7.66 1.1 3.17 1.36 5.77 1.84 6.66.49.89 1.48 2.33.74 2.19-.74-.15-1.42-1.01-1.87-2.16-.46-1.16-.32-1.16-.26-2.74.06-1.59-2.41-9.71-3.55-10.6-1.14-.9-6.36-5.25-8.38-8.24-2.01-3-1.59-3.7-1.59-3.7l2.9-.02z'/%3E %3Cpath fill='%23202020' d='M465.48 224.63c-1.1-2.28-1.3-4.3-1.65-5.65-.34-1.35-4.74-5.04-5.8-5.53-.79-.37-2.45.1-3.11-.4-.67-.5-4.83-5.23-4.83-5.23s-.63.6-.43.76c.2.18 4.52 4.84 6.08 6.34 1.56 1.5 2.41 4.84 3.55 7.43 1.14 2.6.68 2.08.8 3.34.1 1.27.9 2 1.7 2 .8 0 1-.38.7-.6-.3-.21-1.93-2.11-2.86-4.58-.86-2.25-1.96-6.4-3.32-7.95l-.31-.35c.32-.04.86-.14 1.7-.18 1.05-.06 5.4 3.94 5.77 5.13.36 1.18-.04 1.64 1.78 5.59 1.82 3.94 2.67 4.86 2.67 4.86h.32s-1.65-2.7-2.76-4.98zM458.65 198.49s3.15 1.99 4.09 2.25c.93.26 1.62.34 1.62.34s.47 5.75 2.77 9c2.3 3.23 4.17 4.4 4.17 4.4s.08 6.26 1.79 10.59c1.7 4.32 2.04 9.55 1.66 10.37-.38.82-1.83-2.55-2.77-5.53-.94-2.99-1.83-6.22-2.47-8.21-.64-2-2.39-4.98-3.36-5.8-.99-.82-.2-.73.38-.21.57.52 2.23 2.57 3.3 5.88 1.06 3.3 1.49 6.65 2.06 6.67.58.02 1.03-.54 1-1.2-.02-.67-.74-2.4-1.27-5.5-.53-3.08-1.07-5.2-1.58-6.07-.51-.86-1.26-1.01-3.23-4.47-1.99-3.46-2.86-5.38-3.2-6.98-.34-1.6.06-1.44-.28-1.68s-.6.02-2.1-.82c-1.52-.85-2.58-3.03-2.58-3.03zM466.82 197.32s1.93 1.5 3 1.96c1.09.46 2.65.54 2.65.54s-.4 5.45 1.74 9c2.12 3.54 4.34 5.61 4.34 5.61s.34 1.33 1.02 8.93c.68 7.61.71 7.75.91 10.8.2 3.06.3 13.88-.14 13.55-1.65-1.27-.29-7.15-1.1-9.57-.83-2.42-2.14-2.82-3.73-9.68-1.59-6.85-.57-8.41-1.7-10.97-1.14-2.57-2.64-2.8-2.64-2.8s2.1.4 2.98 2.57c.88 2.16 1.01 7.9 1.73 10.74 1.62 6.43 3.84 9.68 3.84 9.68s-.49-8.07-1.11-12.65c-.63-4.58-.6-8.4-1.45-10.16-.85-1.77-2.7-3.18-3.8-5.51-1.11-2.33-1.51-6.91-2.05-8.1-.54-1.18-.85-.8-1.62-1.12-2.5-1-2.87-2.82-2.87-2.82z'/%3E %3Cpath fill='%23202020' d='M472.64 194.33s1.7 1.9 4.09 3.31c2.39 1.41 3.58.98 3.95 1.27.37.29-.49 5.13 2.01 9.6 2.5 4.46 3.41 4.55 3.47 5.15.05.6.5 13.77.82 18.24.31 4.46.65 19.44-1.2 19.44-1.84 0-.16-11.06-1.07-13.65-.91-2.6-.88-1.85-1.76-3.92-.88-2.08-.87-10.28-2.27-15.13-1.05-3.63-2.13-4.2-2.13-4.2s1.76.95 2.58 3.94c.82 3 1.08 13.06 2.05 14.67.96 1.61 2.35 3.6 2.67 5.1.3 1.5-.2-19.1-.63-20.34-.42-1.24-4.57-8.7-4.89-12.82-.3-4.12-.45-4.53-.82-4.84-.37-.32-1.56-.06-3.52-1.9a25.79 25.79 0 0 1-3.35-3.92zM482.01 196.7c.12-.4 1.3 2.21 5 3.69 3.71 1.46 7.25 1.2 7.72 1.6.47.38 2.81 5.96 2.9 13.39.08 7.43-1.29 6.74-2.43 13.14-1.15 6.4-1.2 19.4-1.92 21.39-.34.73-.73 1.03-1.11 2.29-.38 1.25.3 3.63-.85 3.67-1.15.04-1.28-1.81-1.28-2.8 0-1 1.2-4.54 1.2-8.09 0-3.54-.77-3.97-1.29-8.21-.5-4.23-.55-17.72-1.02-19.01-.47-1.3-2.78-4.1-2.78-4.1s2.49 1.59 3.08 3.4c.6 1.82.66 16.8 1.32 19.8.68 3.06.47-.7.73-2.42.25-1.73 1.15-9.08 1.02-13.01-.13-3.93-1.8-12.44-3.16-13.87 0 0 .71.82 1.5 2.7.01.05.5.54 1.05.86.6.34 1.27.52 1.29.58.02.04-.75-.07-1.35-.33-.45-.2-.78-.56-.76-.52.84 2.22 1.68 5.66 1.76 10.58.12 6.7-.97 21.44.1 21.6 1.06.18.85-8.03 1.95-14.68 1.1-6.66 2.6-7.61 2.13-13.06-.47-5.44-1.91-11.32-3.06-12.05-1.15-.74-4.43-.48-7.33-2.34-2.9-1.85-4.53-3.8-4.41-4.2z'/%3E %3Cpath fill='%23202020' d='M435.05 204.2s1.07.47 2.3-.13c1.24-.6 4.52-3.2 4.52-4.28s.04-2.16.04-2.16.04.48.98.6c.94.14 3.62-1.9 3.83-3.19.22-1.3.22-3.59-.08-4.06-.3-.48.8.47 1.36-.05.56-.51 3.15-2.2 3.11-3.93-.04-1.73-1.45-3.33-1.45-3.33s1.28.18 2.05 0c.77-.17 3.32-1.68 3.24-3.24-.1-1.55-.98-3.93-2.99-4.1 0 0 1.5.34 2.94-.17 1.45-.52 1.96-1.34 1.96-2.99 0-1.64-2.94-5.18-3.45-5.48-.5-.3 3.15 1.03 4.1-.44.92-1.47 1.05-2.5.8-3.32-.26-.83-1.02-1.04-1.02-1.04s1.58.43 3.7-.65c2.14-1.08 4-2.5 4.99-2.46.98.04-3.11 2.2-3.33 3.41-.08.5 1.12 1.36 2.97 2.71.12.09.17.17.36.26.83.46 4.02.59 4.23.75.27.2-3.07.12-2.79.34a44.74 44.74 0 0 1 7.49 7.06c.1.12.62.58 1.23.75.75.21 1.6.15 1.7.29.09.1-2.15-.06-2.07.05 1.6 2.09 3.05 4.2 4.3 6.16.08.14.6.75 1.2 1 .65.29 1.39.22 1.48.37.16.26-1.83 0-1.67.26 2.48 4.09 4.33 7.89 4.33 7.89s-4.01-7.06-8.91-12.55c-4.9-5.49-6.05-6.22-6.3-5.7-.26.52 3.66 5.36 5.75 8.77 2.08 3.42 3.98 7.66 3.98 7.66s-4.92-10.2-11.82-16.48c-6.9-6.26-7.62-7.3-8.4-7.04-.76.26-1.35 4.88-.89 5.83.47.96 5.5 4.76 9.8 9.81 4.3 5.06 9.75 13.75 9.75 13.75s-3.87-6.27-10.43-13.23c-6.56-6.95-9.07-8.55-9.58-8.51-.52.04-.56 1.3-1.32 2.33-.77 1.04-2.35.91-2.4 1.39-.03.47 5.55 5.61 6.65 6.22 1.11.6 1.7.3 2.56.78.85.47 1.77 1.26 1.77 1.26s-1.17-.44-2.03-.7c-.85-.26-1.7-.3-1.7-.04 0 .25 4.52 5.78 5.28 6.13.77.35 1.2.17 2.22.56 1.02.4 2.47 1.43 2.47 1.43s-1.58-.9-2.69-1.12c-1.1-.22-1.57 0-1.53.3.04.3 3.45 4.67 3.28 4.75-.17.09-5.28-6.05-9.63-9.9-4.34-3.84-6.3-4.66-6.52-4.53-.2.13-.08 1.25-1.15 1.64-1.06.39-2.04.52-2.04.9 0 .4 3.92 4.07 6.69 7.14 2.77 3.07 5.15 5.96 5.15 5.96s-2.8-2.8-5.88-5.7c-3.06-2.9-4.64-4.02-4.94-3.85-.3.17-.34 1.64-.04 2.03.3.4 5.97 7.1 5.8 7.26-.18.18-6.7-8.03-7.12-8.03-.43 0-.68 1.03-1.1 1.5-.44.48-2.27.48-2.27 1.13 0 .65 9.2 9.68 8.95 9.9 0 0-7.62-6.57-7.88-6.18-.26.39 3.2 6.7 2.98 6.82-.21.14-4.47-6.6-4.86-6.56-.38.04-.34.77-1.44 1.77-1.11 1-2.52.56-2.56 1-.04.42 6.35 7.51 6.18 7.64-.17.13-6.48-6.74-6.65-6.35-.04.1-.38.4-.2 1 .46 1.65 1.88 4.66 1.7 4.92 0 0-2.05-4.2-2.6-4.02-.56.17-.56 1-1.5 1.6-.93.6-1.7.47-1.79.9-.08.44 1.11 1.17 1.63 2.17.5 1 .93 3.15.93 3.15s-.64-1.81-1.53-2.98c-.9-1.17-1.7-1.95-2.39-1.95-.68 0-1.15.65-1.15.65l-.64-1.51z'/%3E %3Cpath fill='%23202020' d='M494.74 201.99s2.09-.13 2.34-.56c.26-.43-.77-.13-2.64-2.16-1.87-2.03-6.66-15.89-11.88-22.86-8.56-11.41-16.57-16.64-16.57-16.64s9.53 5.52 16.91 16.3c7.5 10.94 9.31 19.53 11.41 21.77 2.1 2.25 4.15 2.65 4.04 3.29-.12.63-.46 1.1-1.26 1.2-.79.12-2.72.3-2.72.3l.37-.64zM431.77 198.97s.06.17.44.21c.4.05 2.98-2.53 2.84-3.28 0 0-1.15-.43-2.08-1.38-.94-.95-1.16-2.46-1.16-2.46s.86 1.68 1.58 2.16c.72.47 1.87.73 2.3.39.43-.35 4.24-3.17 4-4.28 0 0-1.19.04-2.3-.78-1.1-.82-1.3-2.51-1.3-2.51s.71 1.36 1.85 1.9c1.13.55 2.24.32 2.55-.08.31-.4 2.81-3.84 2.53-4.84 0 0-1.28.14-2.42-.66-1.13-.81-1.73-2.83-1.73-2.83s.82 1.7 2.27 1.99c1.45.29 2.64-.58 2.87-1.61.23-1.04 1.02-4.9-.2-5.88 0 0-1.87.6-3.2-.09-1.34-.69-1.82-2.39-1.82-2.39s1.13 1.56 2.63 1.76c1.51.2 2.17-.6 2.42-1.21.26-.6.31-2.8-.14-4-.45-1.22-1.4-1.13-1.62-2.94 0 0-.48.72-2.41.72-1.93 0-2.96-2.2-2.96-2.2s1.54 1.42 3.07 1.3c1.53-.11 2.1-1.38 2.13-2.36.03-.98-.77-1.84-1.2-2.85-.42-1.01-.45-2.22-.73-2.08-.29.15-.65 1.07-2.64.75-1.99-.31-2.42-1.67-2.42-1.67s1.45 1.01 2.56.92c1.11-.08 1.82-.6 1.82-1.35 0-.75-.43-2.13-2.93-4.27-2.5-2.13-4.54-3.6-4.54-3.6s3.24 1.8 5.34 3.55c2.1 1.76 3.29 3.46 3.29 3.46s2.3.75 2.56-.03c.25-.78.21-1.75-.51-3.14-.71-1.35-2.68-3.37-2.68-3.37s2.06 1.71 3.04 3.48.53 3 .62 3.44c.08.43 4.38 2.1 5.34 1.51.96-.58.51-1.84-.3-3.11l-1.47-2.34s1 1.1 1.73 2.36c.72 1.25 1.32 2.25 1.04 2.83-.27.58-.87.84-.8 1.08.06.24 1.48 1 2.93 1.75 1.45.76 3.13 1.43 3.35 1.02a6 6 0 0 0 .23-2.81c-.13-1.4-.93-3.55-.93-3.55s.95 2.08 1.12 3.55c.17 1.47-.19 2.57.15 3.09.34.52 1.4.65 1.4.65s-.85.6-2.74.04c-1.9-.56-10.03-4.67-10.42-4.28-.38.39 3.8 2.92 5.71 4.73 1.92 1.82 2.86 3.72 2.86 3.72s-1.5-1.26-2.94-2.05c-1.45-.8-5.8-3.03-6.07-2.73-.28.3 1.64.7 1.78 1.04.15.35-1.36 1.7-1.36 2.27 0 .56 6.2 4.86 6 5.34-.18.47-1.57 1.6-1.82 1.53-.26-.07-3.32-2.42-3.32-2.05 0 .37 1.76 1.86 1.74 2.18-.02.32-1.17 1.1-.96 1.84.22.73 3.46 3.39 3.43 4.3-.02.9-1.85 1.68-1.5 2.26.33.59 2 2.64 2 2.64s-1.8-1.19-2.37-1.81c-.58-.63-1.73-2-1.94-1.78-.21.22-1.36 2.75-1.26 3.31.11.56 1.56 1.43 1.84 2.96.27 1.53-.22 3.13-.33 3.13-.1 0-2.14-2.63-2.55-2.68-.4-.04-.91.13-1.26.8-.34.67-1.53 2.77-1.38 3.16.15.39 2.15.84 2.2 2.44a4.46 4.46 0 0 1-1.4 3.09c-.12 0-2.48-3.18-2.72-3.18-.23 0-2.92 2.99-2.98 3.35-.06.37 1.83 1.71 1.5 2.23-.35.52-1.63-.2-2.35.21-.73.42-2 .93-2.26.93-.25 0-.64-.86-.64-.86z'/%3E %3Cpath fill='%23202020' d='M465.92 159.9s.21-.84.62-1.27c.4-.44 2.05-2.25 1.43-2.62-.62-.36-2.7.3-4.03.2-1.32-.11-2.19.21-6.02-2.97 0 0-12.16-8.5-31-9.59-5.96-.34-8.63 1.79-8.91 2.91-.03.26 1.56-2.42 7.55-2.33 2.64.03 21.6 1.56 31.44 9.27.51.4 3.77 3.53 6.81 3.18 3.05-.35 3.69-.7 3.63-.26-.07.43-1.03 1.56-1.24 2.07a12.1 12.1 0 0 0-.42 1.47l.14-.06zM433.06 162.41l-.05-.15c-.17-.52-1.38-2.21-3.44-4.13-2.47-2.29-10.14-5.49-10.53-5.62-.38-.13 7.88 3.8 10.19 6.01 3.7 3.54 3.83 3.89 3.83 3.89z'/%3E %3Cpath d='M433.04 175.94s-.5-.83-2.12-1.87-3.24-1.47-3.24-1.47l3.75.95a6.28 6.28 0 0 1 1.61 2.39zM432.07 168.89s-.51-.73-2.81-1.47c-2.3-.73-2.85-.7-2.85-.7s2.13-.9 3.74-.08a3.6 3.6 0 0 1 1.92 2.25zM430.71 163.1s-.47-1.04-2.51-1.77c-2.05-.74-3.5-.87-3.5-.87s2.13-.6 4.18.22c2.04.82 1.83 2.42 1.83 2.42zM428.24 159.38s-.6-.82-4.43-1.73c-3.84-.9-5.33-.95-5.33-.95s5.46-.43 6.9.18c1.45.6 2.86 2.5 2.86 2.5zM421.21 155.36s-2.34-.65-4.6-.82c-2.26-.17-5.8.13-5.8.13s6.57-1.04 8.31-.65c1.75.39 2.09 1.34 2.09 1.34z'/%3E %3C/g%3E %3Cg fill='%23f8c83c' stroke='%23977c2e' stroke-width='.35'%3E %3Cpath d='M399.63 236.56s1.16 2.05 3.46 2.13c2.3.09 4.1 3.37 4.1 3.37l-2.53 2.48-6.08.29-1.96-3.14 3.01-5.13zM399.77 234.46c.2-.4-1.79-4.32-3.21-4.98-1.42-.66.48 1.27.17 2.07-.31.8-.52 1.8-.4 1.95.1.14 1.17 1.8.6 2.55-.57.75 2.84-1.59 2.84-1.59z'/%3E %3Cpath d='M398.68 240.44s1.08.54 1.93.29a4.15 4.15 0 0 0 1.61-1.12M397.58 238.92s3.41-2.48 3.13-3.8c-.29-1.33-.97-1.27-1.43-1.15-.45.11-2.55 1.84-2.66 2.24-.12.4.96 2.71.96 2.71z'/%3E %3Cpath d='M395.17 240.62s.62 1.64 1.73 1.64c1.11 0 2.7-.89 2.73-1.55.03-.67-1.11-1.88-1.85-2.22-.74-.34-2.44.55-2.44.55l-.17 1.58z'/%3E %3Cpath d='M398.27 238.38c-.17.51-2.33 1.52-3.04 1.58-.7.06-2.16-1.75-1.56-2.02.6-.25 1.34-.23 1.87-.51.54-.3.69-1.01 1-1.04.31-.03 1.2.2 1.42.75.23.55.48.72.31 1.24z'/%3E %3Cpath d='M396.05 239.81s-3.35 4.53-4.74 4.3c-1.4-.23.57-6.43.57-6.43s.54.35 1.64.7c1.11.34 2.22.74 2.53 1.43z'/%3E %3Cpath d='M390.09 236.59s4.32.75 4.52 1.44c.2.7-2.08 1.61-3.3 1.61-1.22 0-1.22-3.05-1.22-3.05z'/%3E %3Cpath fill='%23202220' d='M379.35 243.13s.57 2.08 2.44 2.2c1.88.1 3.64-1.97 3.64-1.97l-4.43-1.73-1.65 1.5z' stroke='none'/%3E %3Cpath fill='%234b4139' d='M379.35 243.13l-.1.03s.15.53.54 1.08a2.61 2.61 0 0 0 2 1.18l.16.01c1.88-.01 3.55-2 3.56-2l.09-.11-4.62-1.8-1.75 1.58.02.06.1-.03.07.08 1.6-1.46 4.37 1.7.04-.09-.08-.07-.28.3c-.55.55-1.82 1.63-3.12 1.63h-.15a2.4 2.4 0 0 1-1.85-1.1 3.72 3.72 0 0 1-.39-.7l-.08-.23-.03-.09-.1.03.07.08-.07-.08z' stroke='none'/%3E %3Cpath fill='%23202220' d='M380.6 242.55s.74 1.56 3.18 1.62c2.44.05 4.37-1.96 4.37-1.96l-3.86-3.06-3.69 3.4z' stroke='none'/%3E %3Cpath fill='%234b4139' d='M380.6 242.55l-.09.05c0 .01.78 1.61 3.27 1.67h.1c2.45 0 4.34-1.99 4.35-1.99l.08-.08-4.02-3.18-3.81 3.5.03.08.09-.05.07.08 3.63-3.34 3.8 3 .05-.08-.07-.08-.08.09c-.39.36-2.07 1.85-4.12 1.84h-.1a3.93 3.93 0 0 1-2.44-.8 2.89 2.89 0 0 1-.62-.7l-.03-.05-.09.04.07.08-.07-.08z' stroke='none'/%3E %3Cpath fill='%234b4139' d='M380.93 242.91s1.08.9 2.36.96c1.28.08 2.87-.33 2.87-.33l-1.47.53-1.05.12-1-.16-.89-.33-.7-.52-.12-.27z' stroke='none'/%3E %3Cpath fill='%23202220' d='M383.78 240.76s1.08 2.65 3.35 2.36c2.27-.29 2.33-1.6 2.33-1.6l-2.56-3.7-3.12 2.94z' stroke='none'/%3E %3Cpath fill='%234b4139' d='M383.78 240.76l-.1.04c0 .01.25.61.76 1.22.5.61 1.29 1.23 2.35 1.23.11 0 .23 0 .35-.02 1.16-.15 1.77-.56 2.08-.95.32-.4.34-.75.34-.76v-.04l-2.64-3.81-3.26 3.06.03.07.09-.04.07.08 3.04-2.86 2.49 3.6.08-.07h-.1v.04c-.05.23-.29 1.21-2.24 1.47-.12.02-.23.02-.33.02-.98 0-1.7-.57-2.2-1.15a5.23 5.23 0 0 1-.54-.8l-.13-.27-.04-.1-.1.04.07.08-.07-.08z' stroke='none'/%3E %3Cpath fill='%234b4139' d='M384.1 241.28s1.36 1.66 2.56 1.63c1.19-.03 1.94-.48 1.94-.48l.06.2-.63.3-1.08.23-1.1-.15-.91-.55-.84-1.18zM379.79 243.94s1.05 1.08 2.02 1.12c.96.05 2.44-.78 2.44-.78l.18-.05-.25.23-1 .54-1.2.35-.95-.17-.73-.45-.44-.56-.07-.23z' stroke='none'/%3E %3Cpath d='M389.83 236.36c1.02-.14 3.15 2.77 3.15 4.2 0 1.45-.62 3.6-1.67 3.55-1.06-.06-3.44-2.19-3.98-3.28-.54-1.1-1.08-1.85-.68-2.43.4-.57 3.18-2.04 3.18-2.04zM379.24 236.62s-1.7-1.32-2.39-.63c-.68.69-.45 3 0 3.45.46.47 2.5-1.1 2.5-1.1l-.11-1.72z'/%3E %3Cpath d='M379.01 238.23s-2.27.23-2.27 1.27 1.08 2.13 1.3 2.36c.23.23 2.28-.92 2.28-.92l-1.31-2.71z'/%3E %3Cpath d='M379.92 240.13s-2.33.7-2.33 1.5 1.02 2.3 1.76 2.3 1.3-1.44 1.59-1.73c.29-.29-1.02-2.07-1.02-2.07zM381.06 233.39s-.45-.63-1.42-.23-2.05 1.38-1.87 2.94c.17 1.55.73 2.6.73 2.6l3.53-1.22-.97-4.09z'/%3E %3Cpath d='M381.34 236.1s-3 .98-3.12 2.13c-.12 1.15.68 2.3 1.47 2.53.8.24 3.35-2.24 3.35-2.24l-1.7-2.42z'/%3E %3Cpath d='M383.95 240.89s-2.95 1.95-3.35 1.95c-.4 0-1.48-1.55-1.25-2.59.23-1.03 2.21-1.78 3-2.07.8-.3 1.6 2.71 1.6 2.71zM386.54 230.17s-.94-.78-2.73-.65-3.1 2.46-3.32 3.63c-.21 1.17-.04 3.37.64 3.72.68.34 4.39-2.64 4.39-2.64l1.02-4.06z'/%3E %3Cpath d='M382.92 239.02c-1.24-.13-2.34-1.9-2.13-2.98.21-1.08 2.64-2.94 3.92-2.72 1.28.21 1.02 3.41 1.02 3.41s-1.58 2.42-2.81 2.29z'/%3E %3Cpath d='M386.85 238.75s-.62 1.44-1.87 2.08c-1.25.63-2 .1-2.73-.93-.74-1.03.34-1.5.9-2.02.58-.51 2.22-.92 2.22-.92l1.48 1.79z'/%3E %3Cpath d='M384.86 234.95s-1.4 1.12-.6 2.42c.8 1.3 1.42 1.76 2.42 1.93 1 .17 1.64-.23 2.44-1.18s1.96-1.38 1.85-2.57c-.12-1.18-.57-2.1-1.28-2.45-.71-.34-2.87.03-4.83 1.85z'/%3E %3Cpath fill='%23202220' d='M388.82 229.39s-1.44-.55-2.54.1a4.04 4.04 0 0 0-1.92 3.17c-.04 1.22.22 2.91.22 2.91s1.52-.43 2.5-1.25c.97-.82 1.3-1.05 1.16-1.47-.08-.26-.48-.54-.48-1.56 0-1.77 1.06-1.9 1.06-1.9z' stroke='none'/%3E %3Cpath fill='%234b4139' d='M388.82 229.39s-1.66-.28-2.49.26a4.22 4.22 0 0 0-1.83 2.42c-.3 1.08-.09 1.36-.09 1.36s-.15-.94.14-1.84c.34-1.03 1.19-2.06 2.01-2.3 1.01-.3 2.26.1 2.26.1z' stroke='none'/%3E %3Cpath d='M431.58 260.88s1.2-.5 2.03-.96c.83-.46 2.62-1.62 2.62-1.62l.58 2.98-2.3 1.77-2 .02-1.22-.88.29-1.31z'/%3E %3Cpath d='M428.37 261.18s.03.04 1.43.07c1.4.04 1.53-.49 1.78-.37s.64 1.61.64 1.61l-.51.94-2.01 1.14-1.7-.93-.14-2.35.51-.11zM444.32 260.22s-.4-.67-1.2-1.36l-2.84-2.48-.01 6.47 2.98-.07 1.42-2-.35-.56z'/%3E %3Cpath d='M428.37 261.18s-.44-.65-1.7-.52c-1.26.14-2.6 1.17-2.73 2.04-.14.87 0 3.4.68 3.88s1.53.72 2.9.38c1.36-.35 8.31-4.64 8.31-4.64l-1.77.39c-.95.2-1.84-.22-1.84-.22s-.95 1.08-2.04 1.25c-1.1.17-1.4-.52-1.6-1.03-.21-.52-.21-1.53-.21-1.53z'/%3E %3Cpath d='M433.01 263.42s-1.02.4-1.41.67c-.38.28-1.76.77-1.76.77l.53 2.1 2.96.76 1.85-1.53.02-2.12-2.19-.65zM446.77 261.93s-.47-.43-1.02-1.06c-.55-.62-1.24-.75-1.43-.65-.2.11-1.6 1.92-1.6 1.92l-.1 1.37 1.64.89 1.15.2 1.51-.99-.15-1.68z'/%3E %3Cpath d='M436.61 260.89s-1.32.6-1.96 1.14c-.64.55-1.64 1.15-1.64 1.39 0 .23 1.5 1.78 1.5 1.78l1.5.12 3.28-2.3-.21-2.09-2.47-.04zM449.07 263.61s-.25-.52-.76-1c-.52-.47-1.15-.73-1.54-.68-.38.04-1.66 1.94-1.66 1.94l-.16.54 1.18 1.37 2.1.51 1.45-1.46-.61-1.22z'/%3E %3Cpath stroke-linecap='round' stroke-linejoin='round' d='M443.66 265.9l1.5.26s-.05.39.38.74c.42.34.47.08.47.08s.21 1.43 1.78 2.64c0 0 1.84.6 2.77.08.94-.52.81.16.81.16l2.64-3.27s0-.65-.64-.69c0 0 .47-2.03-1.23-2.46-1.7-.44-3.07.17-3.07.17s-1.3 2.4-2.08 2.07a3.1 3.1 0 0 1-.94-.64c-.72-.78-.94-1.17-.94-1.17s-.55.17-1.2-.26c-.63-.43-1.18-1.47-1.18-1.47s-.98-.17-1.32-.52c-.34-.34-.7-1.03-.7-1.03l-2.44 1.76s-.07.77-1.5 1.8c-1.41 1.05-2.26 1.05-2.26 1.05s-.4 2.13-2 1.78c-1.58-.34-2.66-2.13-2.66-2.13s-1.14-.17-1.88.8c-.74.99-1.08 1.33-1.08 2.31s.63 2.36 1.14 2.82c.51.46 2.1 1.73 3.97.75 1.88-.98 1.26-2.59 1.26-2.59s-.06.12 1.07-.63c1.14-.75 2.39-1.9 3.24-2.25'/%3E %3Cpath d='M440.75 252.87l.01 4.18s.51 3.72-.3 4.88c-.8 1.17-3.75.91-4.17-.08-.43-1-.21-4.24-.21-4.24l4.67-4.74z'/%3E %3Cpath stroke-linecap='round' stroke-linejoin='round' d='M437.45 265.54s-.63 1.1 1.3 1.27c.56.04.92-.15 1.17-.43.5-.58.39-1.06.39-1.06s-.17 1.54 1.57 1.6c1.93.07 1.76-1.78 1.76-1.78'/%3E %3Cpath fill='%23202220' d='M421.55 268.97s-1.08-1.82.2-2.48c1.28-.66 1.96.03 2.72.06.77.03.52-1.97.35-2.37a4.88 4.88 0 0 0-.88-1.49c-.32-.23-4.54.2-4.5 3.03.02 2.72 2.11 3.25 2.11 3.25zM428.17 275.74s-1.36-1.93-.62-3.08c.74-1.16 1.3-.46 1.67-.5.37-.02.54-.86-.08-2.12-.63-1.27-1.4-1.9-1.85-1.97-.46-.05-3 1.82-2.5 4.21a4.56 4.56 0 0 0 3.38 3.46zM452 273.41s4.6 1.93 4.91-2.7c.17-2.49-2.04-4.2-2.75-4.18-.49 0-.85.28-1.68 1.26-.82.98-1.45 1.7-1.1 2.08.33.37 1.7-.4 2.3 1.06 1.02 2.51-1.68 2.48-1.68 2.48z' stroke='none'/%3E %3Cpath fill='%234b4139' d='M428.17 275.74s-3.58-.79-3.55-4.29c.02-2.33 2.62-3.37 2.62-3.37s-2.4 1.28-2.45 3.33c-.07 3.56 3.38 4.33 3.38 4.33zM421.6 268.97s-2.06-.46-2.29-3.43c-.22-2.97 4.68-2.85 4.68-2.85s-4.7.23-4.46 3.07c.26 2.94 2.07 3.21 2.07 3.21zM452 273.41s.92.45 1.98.4c1.05-.04 2.31-.31 2.75-2.07.44-1.76.26-2.59-.9-4.14-.81-1.08-1.56-1.06-1.56-1.06s.8.16 1.42 1.14c.62.98 1.53 2.07.9 4.05-.62 1.97-2.52 2.01-3.21 1.95-.7-.05-1.38-.27-1.38-.27z' stroke='none'/%3E %3C/g%3E %3Cg fill='%234d2a15'%3E %3Cpath fill='%23904720' d='M397.2 176.12l-.86-.18.62-1.44 2.42-.89 2.4-.1 2.55-.1 1.17.81 1.3 3.01-4.81 2.87-.78.26-.3-1.19-.74-1.94z'/%3E %3Cpath fill='%23202020' d='M442.21 245.84l-.3-7.22-19.47 6 7.71 7.22z'/%3E %3Cpath fill='%23d2a567' d='M406.16 233.27l-1.64-1.28s-1.17-.83-1.83-1.04c-.65-.2-1.49-.04-1.49-.04l-.27.39.26.66 1.78 2.07 2.96 1.53c.07.03 1.05 1.01 1.05 1.01l.68.3-1.5-3.6zM405.7 236.33l1.11.15 1.11 1.27.69 1.36.9 1.8.3 1.04-2.18-.48-6.3-1.95.54-1.5 1.1-1.01.92-.4 1.28-.2z'/%3E %3Cpath fill='%23d2a567' d='M409.8 241.52l1.04-.09.7-.6-.33-2.36.39-7.56-5.12-6.06-1.05 3.5 1.5 6.12 1.11 3.67z'/%3E %3Cpath fill='%23ab6d29' d='M406.13 227.69s-.34.63.09 2.62c.42 1.98 1.16 6.43 2.92 9.45 1.76 3.02-1.7-2.39-1.7-2.39s-2.73-6.14-2.3-10.78c.42-4.63.99 1.1.99 1.1z'/%3E %3Cpath fill='%23ab6d29' d='M409.85 231.52s-1.1 1.44-1.28 2.5c-.17 1.07.09 2.89.09 2.89s-.17-1.38.96-1.7c1.14-.32 1 3.11 1.05 3.43.06.31.66-6.14.66-6.14l-1.48-.98zM410.42 244.19l-5.77-1.32c-2.98-1.33-4.55-2.37-4.5-3.09.06-.72 5.3.18 6.06.35.77.17 3.12 1.35 3.12 1.35h1.34l2.45-1.08.34 2.6-3.04 1.19zM400.79 243.1s1.42 1 .74 1.44c-.68.43-2.5.49-3.07.35-.57-.15 5.57 1.35 5.57 1.35s1.19-1.01 1.1-1.07c-.08-.06-4.34-2.07-4.34-2.07z'/%3E %3Cpath fill='%23d2a567' d='M399.27 241.58c.21-.35.38.8 2.37 1.07 2 .25 2.9-.35 2.9-.35l.88.58 1.05.23-.97 1.44-3.63-1.07-1.96-1.1-.64-.8z'/%3E %3Cpath fill='%23ab6d29' d='M412.22 238.97l1.02 1.47.64-3.2-.04-3.33-2.09-1.38z'/%3E %3Cpath d='M406.47 233.58l-1.7-2.85-2.22-4.06 1.36-2.34 1.67 2.42s-.47 1.64-.17 3.2c.3 1.56 1.06 3.63 1.06 3.63z'/%3E %3Cpath fill='%23d2a567' d='M394.8 243.95s.74-1.23 2.47-1.37c1.73-.15 3.12.23 3.12.23l3.52 1.84.72 1.16-6.65-.9-3.18-.96z'/%3E %3Cpath fill='%238f4620' d='M412.09 232.2s.13 3.97.25 5.23c.13 1.25.9 2.46.77 2.98s-.38.78-1.24 1.08c-.85.3-2.55 0-2.55 0s1.66-.22 1.75-.56c.08-.35-.51-1.86-.6-3.24-.09-1.39.09-2.9-.38-2.9s-.98.6-1.07.78c-.08.17.47-4.93 1.02-5.49.56-.56 2.05 2.12 2.05 2.12z'/%3E %3Cpath fill='%23ab6d29' d='M399.94 242.64s-.68-.63-.67-1.07c.02-.43.8 2.09 4.45 1.95 3.65-.14 3.43-.2 3.43-.2h1.7s-.37 1.58-.67 1.72c-.3.15-2.84 1.86-2.89 1.9l-.9.5.07-.25-.17.01-.3-2.8-3.15-1.21-.9-.55z'/%3E %3Cpath fill='%238f4620' d='M406.47 233.58s-4.22-4.37-5.62-7.26c-1.4-2.9-.56-6.87-.56-6.87l3.97 5.18s-.52 1-.35 2.64c.17 1.64 2.56 6.31 2.56 6.31z'/%3E %3Cpath fill='%23ab6d29' d='M403.77 249.48c-.14-.3-.3-1.26.51-2.28 2.5-3.12 8.85-5.37 8.85-5.37v3.83l-8.13 3.9-1.23-.08z'/%3E %3Cpath fill='%238f4620' d='M404.25 246.59c.35-.25 1.77-1.3 1.82-1.76.06-.52-.96-.6-2.8-.98-1.85-.37-3.36-1.2-3.36-1.2s2.27 1.75 3.15 2.1c.88.34.8.69.69.92-.12.23.45.96.5.92zM415.14 247.48s-1.17-1.75-1.55-2.82c-.37-1.07-.39-2.8-.46-2.82-.07-.02-.78.57-1.3.81-.54.24-2.41.85-2.51.92-.1.07 2.58-.06 2.57.88-.02.93-3.87 1.33-3.89 1.4-.01.07 3.1-.69 2.92.07-.2.76-1.57.83-3.24 1.52-1.67.7-2.4 1.04-3.02 1.4-.62.35-.92.63-.92.63s.75.42 1.93.38c1.18-.05 3.8-.7 3.8-.7l5.03-1.9.64.23z'/%3E %3Cpath fill='%23ab6d29' d='M415.14 247.48s-1.4-.49-2.4-6.35c-1-5.85-.7-7.43-.7-7.43l2.36 1.66 2.12 3.86-1.38 8.26z'/%3E %3Cpath fill='%238f4620' d='M415.9 237.74s-1.1 3.28-1.1 5.19c0 1.9-.2 3.19.34 4.54.55 1.35 2.4 3.03 2.4 3.03l.86-.9.38-2.65.22-4.4-3.1-4.81z'/%3E %3Cpath fill='%23202020' d='M419.23 242.2s.54 8.27-1.56 8.5c-1 .1-2.5-3.12-2.53-3.23-.02-.1 1.82 3 2.51 2.72 1.32-.54.92-8.6.92-8.6l.66.61zM415.14 247.48s-.35-.15-.93-1.1c-.57-.93-.07.84-4.48 2.4-4.4 1.55-5.98.69-5.98.69s1.46 1.14 5.91-.16c4.46-1.3 4.05-1.57 4.65-1.7.6-.13.83-.13.83-.13z'/%3E %3Cpath fill='%23ab6d29' d='M406.94 236.95s.7.6 1.49 2.2l1.36 2.74.2-.2s-.54-1.55-1.28-2.77c-.73-1.2-2.87-4.14-2.87-4.14l1.1 2.17z'/%3E %3Cpath fill='%238f4620' d='M404.26 247.21s.45-1.55 0-1.83c-.46-.3-.88.02-3.89-.35-3.01-.38-5.57-1.08-5.57-1.08s2.05 1.25 4 1.77c1.97.52 4.52 1.1 4.52 1.1l.68.11.26.28z'/%3E %3Cpath fill='%23202020' d='M404.26 247.21s.06-.36-.28-.74c-.34-.36-.96.18-4.6-.84-3.64-1-4.58-1.68-4.58-1.68s1.3 1.14 4.52 1.97c3.21.82 4.94 1.29 4.94 1.29z'/%3E %3Cpath fill='%23ab6d29' d='M405.9 236.32s-2.76.15-3.64.86c-.89.71-2.1 2.6-2.1 2.6l1.79.21s-.22-1.66.63-2.5c.85-.83 2.14-.9 3.32-1.17z'/%3E %3Cpath fill='%238f4620' d='M400.68 231.08s1.1 1.47 2.26 1.99c1.15.52 2.3.95 2.85 1.5.55.57 1.15 2.38 1.15 2.38s-3.96-1.76-4.72-2.63c-.77-.87-1.54-3.24-1.54-3.24z'/%3E %3Cpath fill='%238f4620' d='M404.52 231.99s-.36-.6-1.45-1.09c-1.08-.5-1.88-.42-2.2-.2-.3.23-.2.38-.2.38l1.45 2.18.81-.2s-2.15-1.35-1.65-1.78c1.06-.9 3.24.71 3.24.71z'/%3E %3Cpath fill='%23202020' d='M415.2 227l22.17-11.45 10.5 14.6-19.17 5.14-10.14.87-4.94-3.58z'/%3E %3Cpath d='M444.93 233.26l27.64 23.94-3.06 2.1-6.48-1.84-13.46-13.3-4.98-5.02z'/%3E %3Cpath d='M480.33 252.46s-6.87-5.41-15.79-12.04c-8.92-6.63-19.95-14.98-19.95-14.98l.51 7.14 22.82 20.98 7.53 3.62 3.8-1.15 1.93-2.01-.85-1.56z'/%3E %3Cpath fill='%23803f1d' d='M444.85 235.53s7.96 8.99 14.02 13.57c6.04 4.58 11.84 9.59 13.03 8.9 1.19-.7.76-1.47.76-1.47l-27.98-22.82.17 1.82z'/%3E %3Cpath d='M464.4 258.5l-2.81 2.19-3.24-1.32-17-17.38.86-3.2 2.38.35z'/%3E %3Cpath fill='%23202020' d='M480.33 252.46s-2.08 4.91-6.51 3.76c-4.43-1.15-28.83-24.33-28.83-24.33l-.06 2.42s24.73 22.65 29.5 23.57c4.77.92 8.68-3.22 8.18-3.69-.34-.31-2.28-1.73-2.28-1.73z'/%3E %3Cpath fill='%23803f1d' d='M442.12 239.16s7.88 10.11 12.06 13.83c4.17 3.72 7.75 6.65 9.45 6.3 1.7-.34-1.02-2.24-1.02-2.24l-11.93-11.75-6.09-6.14s-2.38-.95-2.47 0z'/%3E %3Cpath fill='%23202020' d='M444.08 239.16s20.01 20.4 21.6 20.86c3.35.98 8.12-2.48 8.12-2.48l-1.76-1.04-.23.64s-.85 2.07-5.17 1.15c-4.32-.92-21.88-19.82-21.88-19.82l-.68.69z'/%3E %3Cpath d='M451.62 258.68l-7.28-8.38-1.62-2.77-.43-3.55 14.53 14.61-2.05 1.38-1.79-.6z'/%3E %3Cpath fill='%23202020' d='M464.78 258.97s-1.76 2.6-4.15 2.07a7.04 7.04 0 0 1-3.75-2.24l-13.93-13.64-.34-2.08s15.28 16.17 18.02 16.88c1.99.52 3.47-1.9 3.47-1.9l.68.92z'/%3E %3Cpath fill='%23202020' d='M457.05 258.51s-.68 2.02-2.72 1.73c-2.05-.29-2.68-1.1-2.68-1.1L443.12 249l-.17-2.7s8.87 12.27 10.92 12.96c2.05.7 2.56-1.38 2.56-1.38l.62.63z'/%3E %3Cpath fill='%23b07229' d='M447.93 231.92s8.26 7.09 8.95 7.43c.68.35 3.57.44 3.74.87.17.43-1.87 0-2.04.43-.17.43 4.17 3.98 4.86 4.06.68.09 4.17.09 4.09.52-.09.44-2.39 0-2.47.52-.09.52 3.75 3.54 4.43 3.63.68.09 5.1.09 5.1.52 0 .43-3.57-.09-3.48.69.08.78 6.04 4.5 5.79 5.01-.26.52-7.16-4.67-7.33-4.4-.17.25-.42 1.9-.85 2.15-.43.26 0-2.16-.35-3.2-.34-1.03-4.34-4.06-4.76-3.7-.43.34-.09 2.15-.51 2.15-.43 0 .08-2.25-.35-3.02-.42-.78-4.17-3.9-4.68-3.9-.51 0-.17 1.65-.51 1.9-.35.27-.26-1.9-.77-2.59-.5-.68-9.2-8.55-8.86-9.07z'/%3E %3Cpath d='M433.76 254.86s.07 3.13-1.34 3.59c-1.4.45-4.07-5.75-4.07-5.75l-.62-5.79 4.14 3.84 1.89 4.11zM444.84 253.27s.06-.92-.05-1.67c-.1-.76-.34-1.9-.34-1.9l-.27-3.22-.77-2.16-.62-1.37-.9.07-2.17 1.54-.74 2.1 1.15 3.9 1.06 3.57 1.62.52 2.03-1.38z'/%3E %3Cpath d='M441.99 258.74c.49-.15-.45-4.44-.45-4.44l-2.56-6.34-.68-2.24-2.07-.78-1.37 1.56.32 2.5s1.98 4.18 2.95 5.65c.97 1.47 3.01 4.35 3.86 4.09z'/%3E %3Cpath fill='%23202020' d='M439.7 245.29c.74.52 1.6 2.22 1.79 3.37 0 0 1.7 4.66 1.48 5.13-.23.46-1.25.52-1.25.52s2.27 2.36 2.95 2.07c.68-.29.4-2.6.17-3.11-.23-.52-.97-.17-1.25-.7a20.2 20.2 0 0 1-1.2-5.47c-.05-1.84-.1-3.1.12-3.57.23-.46 1.93 3.86 1.93 6.17l.74.86s-.45-3.17-.74-4.15c-.28-.98-.9-2.65-.9-3 0-.34.34-1.15.34-1.95s-.06-1.33-.06-1.33.9.63 1.25.58c.34-.06.85-.52 1.08-2.54.22-2.01-.23-7.88-.23-7.88l-8.86 11.69 2.64 3.31z'/%3E %3Cpath fill='%23202020' d='M439.7 244.28s-.34 3.14.82 6.37c1.17 3.22 1.48 3.34 1.7 3.8.23.46.21 3.86-.22 4.3 0 0-2.27-5.8-3.03-8.65-.77-2.85-.97-3.95-1.37-4.18-.4-.23-1.05-.29-1.05-.29l3.15-1.35z'/%3E %3Cpath d='M438.86 261c.25-.05.1-1.33.1-1.33l-.37-3.03-3.11-6.38-3.41-3.07-1.79-2.77-.25 5.28s2.47 5.27 4.09 6.78c1.61 1.51 4.29 4.63 4.74 4.52z'/%3E %3Cpath fill='%23202020' d='M426.13 246.61s.53 1.41.53 2.34v1.79s1.25 2.53 2.39 4.55c1.14 2.01 2.21 4.09 3.18 3.63.97-.46 1.3-1.96 1.36-2.14.06-.17-1.08 1.73-1.65 1.44-.56-.28-3.12-8.52-3.06-8.7.06-.17-.68-.51-1.25-1.09-.57-.58-1.5-1.82-1.5-1.82zM435.41 253.79s-1.76-2.88-2.33-4.15c-.57-1.27-1.54-2.25-1.82-2.25s-.65-2.58-.65-2.58.93 1.72 2.13 2.3c1.2.57 1.93 1.03 2.5.8 0 0 .34 1.33.34 2.65s-.17 3.23-.17 3.23z'/%3E %3Cpath fill='%235c3a1d' d='M429.73 249.55s.6 1.81 1.76 3.54c1.16 1.73 3.07 3.8 3.07 3.8s-2.1-2.07-3.21-3.68c-1.1-1.62-1.85-3.72-1.85-3.72l.23.06z'/%3E %3Cpath fill='%23202020' d='M435.8 247.4s.56-1.57 1.05-1.64c.49-.08 1.51-.38 1.51-.38s-.88-.22-1.58-1.04c-.74-.88-.9-.81-1.71-1.74 0 0 .45 1.74.6 2.56.13.82.13 2.24.13 2.24zM435.24 247.91s2.53 5.41 3.18 7.23c.65 1.82.54 4.53.54 4.53s-.32-1.93-.88-3.52c-.57-1.58-2.87-6-3.07-6.5-.2-.53.23-1.74.23-1.74z'/%3E %3Cpath d='M438.68 244.39l.6-7.96-.6-2.8-3.58-7.95s-.17 1.16-1.07 1.12c-.89-.05-3.27-1.3-4.09-2.38 0 0 .47 1.86.3 3.63-.17 1.77-.46 2.72-.46 2.72l6.9 12.97 2 .65z'/%3E %3Cpath fill='%238b441f' d='M424.96 249.61s1.08 1.3 1.7 1.13c.63-.18.4-2.66-.4-4.04s-9.2-12.62-10.45-13.3c-1.24-.7 9.15 16.21 9.15 16.21z'/%3E %3Cpath fill='%238b441f' stroke='%235c3a1d' stroke-width='.07' d='M430.7 244.97c.17.52.77 4.1-.68 4.44-2 .46-11.24-12.3-12.67-14.05 0 0-5.8-3.63-5.91-4.55-.12-.92 6.25 1.25 6.25 1.25l12.38 11.84s.46.55.63 1.07z'/%3E %3Cpath fill='%23202020' d='M424.96 249.61s-1.02-1.81-1.11-3.1c-.08-1.3-.51-2-.6-2.43-.08-.43-6.81-10.2-7.5-10.8-.67-.6-2.97-1.9-2.97-1.9s.26 1.55.26 2.24c0 .7.08.89.08.89s2.13 4.04 5.2 7.59c3.06 3.54 6.64 7.51 6.64 7.51z'/%3E %3Cpath d='M435.24 247.91c.9-.52.5-3.63.17-4.61-.34-.98-5.85-12.44-5.85-12.44l-1.65.63-3.12-2.45-1.76-1.9s.62 2.74.56 4.07c-.05 1.32-.1 2.12-.1 2.12l4.36 7.67 7.39 6.91zM441.43 241l1.31-1.73-.68-5.7-3.64-12.44s-.9.22-1.82-.35c-.9-.58-1.84-1.67-1.84-1.67l.88 7.43 3.75 10.43.23 3.11 1.81.92z'/%3E %3Cpath fill='%23202020' d='M430.07 243.91s-3.66-3.98-4.86-5.96c-1.2-2-2.21-3.9-2.21-3.9s-1.02.44-2.3-.08c-1.28-.52-2.98-2.33-2.98-2.33s-1.02 1.98 4.26 7.34c6.05 6.14 8.09 4.93 8.09 4.93z'/%3E %3Cpath fill='%238b441f' d='M438.89 245.25c1.54-.62 1.5-7.09.05-11.45-1.46-4.37-3.84-8.13-3.84-8.13s2.98 7 3.62 9.86c.64 2.85 0 4.88-.51 4.7-.51-.17-.51-1.68-1.7-4.45-1.2-2.76-2-3.45-2-3.45s4.21 11.54 3.02 11.32c-1.2-.22-7.07-13-7.33-13.35-.26-.35-.42.47-.42.47s5.23 16.03 9.11 14.48z'/%3E %3Cpath d='M442.31 214.09l2.59 5.5.82 5.8.2 4.9s.17 9.67-1.02 9.9c-1.2.23-1.76-.92-1.82-1.15-.06-.23-2.22-10.9-2.22-10.9l-2.27-11.11.8-.78.28-1.64 1.76-.12.88-.4z'/%3E %3Cpath fill='%238b441f' d='M435.24 247.91c1.03-.14 0-2.76 0-2.76s-.85 1.26-1.54.4c-.68-.86-1.76-4.06-1.76-4.06l-.68-1.93s-.74 2.13-1.7 2.13c-.97 0-5.97-8.47-5.97-8.47l-.6.83s7.05 14.58 12.25 13.86z'/%3E %3Cpath fill='%23202020' d='M431.94 241.49s.85-2.07.51-3.97c-.34-1.9-2.9-6.66-2.9-6.66s-.76.18-1.78-.17-2.98-1.64-2.98-1.64 1.36 3.54 2.9 6.13c1.53 2.6 4.25 6.31 4.25 6.31zM436.03 238.55s-.64-4.5-2.68-8.65c-2.05-4.14-3.41-5.49-3.41-5.49s.17.91.13 2.6c-.04 1.68 0 2.03 0 2.03s1.87.7 3.28 3.2c1.4 2.5 2.68 6.31 2.68 6.31zM441.6 230.86s-.28-4.84-1.05-7.61c-.77-2.76-1.57-6.44-1.57-6.44s.1-.37.42-.56c.19-.12.47-.17.85-.04 1.02.34 1.45 2.9 1.45 2.9s-.13-3.94-.21-4.11c-.08-.17-.35-.65-.35-.65s-.33.17-.8.13l-1.03-.13s.32 1.2-.19 1.77c-.37.41-.72-.37-.93-.47-.08-.04-.2.56-.2.56s.39 1.38.47 2.6c.09 1.2-.12 2.2-.12 2.2s.75 2.89 1.56 4.66c.8 1.77 1.7 5.19 1.7 5.19zM445.92 230.3s.85-6.96-.72-11.4c-1.58-4.46-2.9-5.63-2.9-5.63l-.72.87s2.37 3.78 3.06 7.3c.73 3.67 1.28 8.86 1.28 8.86zM438.93 233.8s-.77-5.44-1.75-8.94c-.98-3.5-1.26-4.76-1.26-4.76l-1.49-1.38s.88 3.71.8 4.8l-.18 1.81s.73 1.86 1.7 3.41c.98 1.56 2.18 5.06 2.18 5.06z'/%3E %3Cpath fill='%23904720' d='M442.57 242.44c1.39.04.17-7.83-.4-9.85-.57-2.01-3.8-11.48-3.8-11.48s3.89 13.46 3.57 14.13c-.46 1-1.98-4.09-2.26-4.03-.29.05 2.89 9.1 1.75 9.22-1.13.11-1.7-1.9-1.7-1.9l.11 1.96s.74 1.9 2.73 1.95z'/%3E %3Cpath fill='%23904720' d='M444.27 238.46c.95 0-.27-7.43-.94-10.72-.68-3.28-2.58-9.85-2.58-9.85s1.93 4.55 3 9.8c1.08 5.24 1.82 11.98.8 12.1-1.02.11-1.53-.99-1.53-.99l-.17-1.2s.45.86 1.42.86z'/%3E %3Cpath fill='%23312317' d='M431.48 247.19c.15.53.12 3.08-1.23 2.9-1.36-.19-3.83-2.47-4.34-3.97 0 0 2.94 3.25 3.95 3.23 1.01-.02 1-3.35.84-4.22-.17-.86.78 2.06.78 2.06z'/%3E %3Cpath fill='%23d2a567' d='M438.55 211.8s1.75 1.12 3.15.3a5.16 5.16 0 0 0 2.3-3.89c-.04-1.08-.08-2.03-.94-3.15-.85-1.13 1.37.95 1.33 3.02-.05 2.08.12 5.66-3.2 6.44-3.32.78-1.87-.17-1.87-.17l-.77-2.55z'/%3E %3Cpath fill='%238f4620' d='M435.92 205.45s2.1 3.44 2.9 6.53c.81 3.09.66 4.27.15 4.34-.5.06-.7-.37-.83-1.14-.12-.79-2.22-9.73-2.22-9.73z'/%3E %3Cpath fill='%231e2121' d='M399.14 209.67l13.88 20.14 17.39-19.62-11-11.32z'/%3E %3Cpath d='M416.69 197.31l-.8 3.16 1.7 5.35 2.9 2.99 3.35 2.24.77-2.5.81-2.94.85-.3 2.13.82 1.41-2.03 2.26-4.07-.47-1.57-.54-1.12-3.52-6.13-1.18 2.32-1.1.67-2.06-1.17-2.47 3.24-3.02-1.4z'/%3E %3Cpath fill='%235c3818' d='M423.85 211.06s.6-.43.86-2.03c.25-1.6.3-6.48-.13-8.43-.43-1.94-1.7-5.79-1.96-5.48-.26.3 2 4.23 1.66 9.03-.34 4.8-.17 6.14-1.2 6.61-1.02.47.77.3.77.3z'/%3E %3Cpath fill='%235c3818' d='M424.66 202.98s2.3 3.28 3.41 2.12c1.1-1.17.55-5.36-.17-7a49.94 49.94 0 0 1-1.5-4.02l.7-.7s.76 2.77 1.18 4.5c.43 1.73 1.7 6.83.17 7.74-1.53.9-3.75-1.86-3.75-1.86l-.04-.78z'/%3E %3Cpath fill='%238f4620' d='M417.23 205.24s.77-1.12 1.82-1.24c1.05-.11 1.25.35 1.25.35l.94 2.7 1.56 2.8 1.39 1.38-.83.78-1.1.2s-3.3-1.73-3.35-1.84c-.06-.12-.91-1.21-.91-1.21l-.77-3.92z'/%3E %3Cpath fill='%23d2a567' d='M422.69 233.84c-1.08.56-3.57-.68-4.98-1.92-1.4-1.24-8.82-8.8-8.82-8.8l-1.03-4.2 2.86.79 5.03-2.16.94-1.78 6.05-3.15 3.37-1.81 7.32-.13 1.75-3.6s2.45 4.26 2.86 6c.42 1.74.33 7.1-.3 7.45-.65.34-3.03-1.6-3.37-1.73-.34-.13 1.79 7.52 0 7.82-1.8.3-4.77-2.85-4.77-2.85s1.19 6.82-.22 6.87c-1.4.04-5.04-1.71-6.58-3.39 0 0 1.72 5.64-.11 6.59z'/%3E %3Cpath fill='%238f4620' d='M421.25 224.98l1.55 2.28c.37.54-.07 3.78-.29 4.37-.45 1.25-2.13-1.46-3.04-3.85 0 0-2.66-4.44-2.84-5.02-.17-.57 4.62 2.22 4.62 2.22zM435.52 208.07s2.58 10.66 1.34 11.03c-1.26.38-4.8-3.37-5.2-3.92-.4-.54-5.34-8.4-5.34-8.4l-1.05-1.07.31-.55 2.1.8 7.84 2.1z'/%3E %3Cpath fill='%238f4620' d='M417.23 228.55c-.58.37-1.67-1.38-2.19-1.84-.5-.46-2.24-2.6-3.94-4.33-1.7-1.72-2.96-3-2.96-3.34 0-.34-1.02-1.44-1.02-1.44l.91-1.15 1.2-.17s7.04 5.61 7.52 6.5c.48.9.8 5.57.48 5.77zM427.83 228.64c-.33.26-5-3.11-6.96-5.9-1.96-2.8-4-5.25-4.49-6.55-.48-1.3-.88-2.47-.88-2.47l1.42.31s11.45 14.17 10.91 14.61zM429.5 223.71c-.26.32-2.3-1.2-3.55-2.85-1.25-1.64-.6-3.69-.6-3.69s4.4 6.23 4.15 6.54zM432.11 223.08c-.63.3-3.3-2.93-5.54-6.57-1.64-2.69-2.05-3.1-2.4-3.3-.62-.38-1.77-.56-1.77-.56l-.23-.34 1.2-.3.88-1.03 1.39-1.78 5.54 11.18s1.36 2.5.93 2.7z'/%3E %3Cpath fill='%23ab6d29' d='M417.72 231.92c.04.4-.02.82-1.53.66-1.51-.15-9.42-4.36-12.97-10.17a2863.2 2863.2 0 0 1-4.03-6.6l1.58-1.79 12.54 14.3 4.41 3.6z'/%3E %3Cpath fill='%238f4620' d='M417.72 231.92c.17.66-.62.84-1.42.63-.8-.2-3.95-1.32-8.97-6.91-5.03-5.59-6.99-9.6-6.99-9.68l-.25-2.4 1.47-.62 8.64 13.16 7.52 5.82z'/%3E %3Cpath d='M426.11 226.27s-2.6-1.86-4.26-3.85c-1.66-1.99-5.03-6.6-4.94-7.52.08-.9 1.49-.9 1.49-.9l-.09-2.33.43-.79 2.43 1 3.06 3.76 1.13 1.53s1.98 4.78 1.6 5.21c-.38.43-3.2-2.68-3.54-2.29-.34.4 3.2 5.83 2.69 6.18zM421.25 224.98s.85 1.3.46 2.2c-.37.91-.72 1.39-2-.51-1.27-1.9-2.82-4.04-2.96-3.88-.14.16.15 2.92-.48 2.92-.65 0-2.65-2.37-3.93-4.27-1.27-1.9-3.23-5.06-3.23-5.06s.17-.65.09-2.8c-.09-2.17-.26-3.3-.26-3.3s.18.68.41 1.19c.23.5.57.86.57.86l4.68 5.52 1.32-.91 2.78 5.4 2.55 2.64zM403.49 216.94s3.62 6.35 6.99 9.9a22.83 22.83 0 0 0 7.24 5.08l-10.95-12.95-3.28-2.03zM431.26 220.7c-.19.13-2.43-2.3-3.83-4.45-1.41-2.16-2.51-5.19-2.43-6.53.09-1.34.47-4.58.47-4.58s3.75 3.9 4.47 5.7c.72 1.82 2.27 4.3 1.93 4.6-.34.3-2.87-1.7-3.17-1.22-.3.47 2.94 6.22 2.56 6.48zM435.52 216.64c-.46.23-2.34-1.99-2.85-3.37-.52-1.39-.69-4.1-.69-4.1l-1.66-3.94.17-4.36 1.66-.26 2.51 3.46s.99 2.02.94 4.96c-.04 2.94.43 7.35-.08 7.61zM406 227.32c-3.37-4.15-5.41-8.04-5.41-8.04l-1.1-3.72.59.48s.98 4.28 6.17 9.38c5.2 5.1 6.35 5.53 6.35 5.53s1.02 2.81.51 3.8c0 0-3.74-3.28-7.11-7.43z'/%3E %3Cpath fill='%23202020' d='M411.61 233.27s-4.43-3.91-7.95-8.35c-3.52-4.44-5.74-8.7-5.74-8.7l1.54-1.44s2.92 6.82 5.02 9.53c2.1 2.71 7.13 8.96 7.13 8.96zM417.72 231.92s-5.14-5.1-7.75-7.98c-2.61-2.88-4.06-5.79-4.06-5.79l2.16.84s.85 2.24 2.72 4.58c1.88 2.33 6.93 8.35 6.93 8.35zM416.75 222.78s-2.81-3.43-4.15-5.59c-1.33-2.16-2.7-4.92-2.7-4.92s3.78 4.32 4.89 4.6c1.1.3 1.08-.02 1.08-.02s-.46 1.55-.09 2.85.97 3.08.97 3.08zM417.89 208.88s.46 2.42.14 3.83c-.3 1.41-1.06 1.4-1.06 1.4s1.46 2.06 2.31 2.92c.85.87 2.99 2.36 2.99 2.36s-1.71-2.36-2.4-3.57c-.67-1.2-1.67-2.56-1.24-3.74.42-1.19 2.73.8 3.38 1.35.65.55 3.35 3.74 3.35 3.74s-1-3.31-2.33-4.52c-1.33-1.2-5.14-3.77-5.14-3.77z'/%3E %3Cpath fill='%23202020' d='M429.22 216.13s-1.45-3.48-2.28-5.61c-.82-2.14-2.1-6.76-2.1-6.76s.09 2.12-.03 3.67c-.1 1.56-.66 3.94-1.34 4.28-.68.34-.84.41-2.1.07-1.25-.35.88.58.88.58s1.28-.04 1.84-.67c.55-.63.67-1.97 1.27-1.77.6.2 1.24 2.22 1.73 3.1.49.9 2.13 3.11 2.13 3.11z'/%3E %3Cpath fill='%23202020' d='M424.81 203.72s2.7 3.03 3.87 1.66c1.17-1.36.5-5.2.5-5.2s1.63.62 2.14.21c.52-.4.28-1.92.28-1.92s2.91 4.26 4.32 6.98c1.4 2.72 2.13 7.64 2.13 7.64s-2.42-3.92-3.64-7.64c-1.11-3.38-2.74-4.93-3.05-4.6-.3.32-.74 2.7-.38 3.93.37 1.23 1.36 2.83 2.05 4.58.68 1.75 1.44 4.5 1.44 4.5s-1.38-2.1-2.19-3.25c-.8-1.14-1.66-1.6-2.21-2.13-.56-.55-1.39-1.54-2.2-1.86-.8-.33-2.4-1.13-2.4-.5 0 .63-.32-1.23-.32-1.23l-.34-1.17z'/%3E %3Cpath fill='%23171717' d='M415.76 216.68s1.5 2.98 2.68 4.54c1.2 1.55 2.82 3.76 2.82 3.76s-2.56-2.33-3.58-3.8c-1.03-1.47-1.92-4.5-1.92-4.5z'/%3E %3Cpath fill='%238f4620' d='M433.35 217.46c-.38.15-1.62-.3-1.75.15-.13.45.7 2.23 1.62 3.16.91.93 1.3.97 1.51.86.22-.1-.1-.93-.24-1.88-.15-.95-.03-1.97-.14-2.27-.1-.3-1-.02-1-.02z'/%3E %3Cpath fill='%23d2a567' d='M401.52 198.44l-1.55 1.02-1.87 3.8.5 6.97s1.74 2.45 2.8 4c1.07 1.54 4.59 5.51 5.5 5.28.9-.23 1.87-3 1.99-4.5.11-1.5.22-4.26.22-4.26s.86 1.5 2.33 3.11c1.48 1.62 2.73 3.11 3.41 3 .68-.12 2.72-4.2 2.78-4.72.06-.52-5.11-13.2-5.11-13.2l-2.3-1.2-8.7.7z'/%3E %3Cpath fill='%23ab6d29' d='M413.12 208.99s.9 3.24 1.45 4.84c.55 1.6-.02 2.98.28 3.02.3.04 3-3.58 3.04-5.22.04-1.64.04-3.33-.68-8.35-.73-5 .23-6.47.23-6.47l-1.55-1.26-2.69 5.4-.08 8.04zM404.04 206.14s.6 4.88.94 6.48c.34 1.6 1.27 4.32 1.79 4.28.5-.04 2.13-4.32 2.17-5.8 0 0-1.1-2.06-1.07-7.3.05-5.22-.5-5.74-.5-5.74l-3.33 8.08z'/%3E %3Cpath fill='%2345392d' d='M397.04 196.05s-4.09 5.93-4 9.19c.08 3.25.62 2.53 1.56 5.47.93 2.95 1.45 7.3 1.5 7.67.06.37.66-.2.74-.64.09-.43.2-21.7.2-21.7z'/%3E %3Cpath fill='%23ab6d29' d='M397.02 196.75s-3.58 5.53-3.32 8.59c.25 3.05.74 2.96 1.76 5.7s1.1 7.2 1.1 7.2 1.14-.34 2.42-1.25c1.28-.91 2.43-2.77 2.43-2.77s-.44-1-1.27-2.78c-.82-1.78-.9-2.48-.9-2.48l-1.06-1.5.32-5.3.93-3.83v-1.44l-2.41-.14z'/%3E %3Cpath fill='%23dbad6c' d='M416.35 206.27s-1.79-.39-2.51-.82c-.72-.43-1.02-1.47-1.02-1.47l.42-1.04 3.11 3.33z'/%3E %3Cpath fill='%23d2a567' d='M397.75 197.35s-2.58 5.56-2.27 9.4c.31 3.83 2.41 8.72 2.61 8.78.2.06.11-.37.17-1.24.06-.86-.11-11.44-.11-11.44l1.25-3.71.05-1.93-1.7.14z'/%3E %3Cpath fill='%238f4620' d='M404 198.59s.34 1.67.11 2.36c-.22.7-1.59 1.56-2.15 2.65-.57 1.1-1.37 3.63-1.37 3.63s.63-1.44 1.48-2.36c.85-.92 1.2-1.55 1.36-1.04.17.52.46 2.71.29 3.12-.17.4-.86 1.06-1.3 2.59-.5 1.63.05 3.11.05 3.11s.3-1.86.57-2.82c.23-.86.96-1.27.96-1.27l1.42 3.06s0-1.45.23-2.54c.23-1.1 1.42-2.64 1.8-2.64.39 0 .98-.21-.47-.95-.47-.3-.17-5.62.21-5.83.39-.22 2.39-.3 2.18-1.03-.21-.73-1.95-2.71-2.12-2.88-.17-.18-3.25 2.84-3.25 2.84z'/%3E %3Cpath fill='%23dbad6c' d='M416.06 209.9l-1.92-.35c-.68-.13-.77-.77-.77-.77l.22-.82 1.57.86.9 1.08z'/%3E %3Cpath fill='%238f4620' d='M399.59 210.53c-.03.57-.46 1.15-.73 1.95-.33.97-.53 2.11-.53 2.11s-.38-2.55-.5-4.34c-.14-1.8-.26-2.96-.47-3.07-.22-.1-.84.84-.84.84s0-2 .39-2.98c.38-.97.7-2.35.36-2.57-.34-.22-1.06.39-1.38.9-.33.53-.92 1.65-.92 1.65s.38-1.7.79-2.4c.4-.7 2.34-2.92 2.7-3.78.36-.86.36-1.8.36-1.8l1.35-.06s1.4 1.1 1.41 2.04c.01.54-1.34 1.14-1.37 1.2-.09.18-1.13-.09-1.39 4.37-.25 4.45.89 4.08.77 5.94zM411.84 199.14s.3 2.42.04 3.15c-.25.74-.98 1.34-1.49 2.3-.51.95-.47 3.24-.47 3.24s.26-1.13.69-1.82c.42-.69.76-1.3.93-1.3.17 0 .68.87 1.02 2.12.35 1.25 1.03 3.37 1.03 3.37s-.3-1.64.12-1.64c.43 0 .6-.13 1.15.3.56.43 1.2 1.04 1.2 1.04s-.05-.6-.85-1.47c-.81-.86-1.28-.82-1.54-1.99a8.16 8.16 0 0 1-.25-2.8c.12-.48.68.3 1.15.86.46.56 1.96 1.86 1.96 1.86s-.64-1-.81-1.3c-.17-.3-.05-2.6 0-3.9.04-1.29-.05-2.5.42-2.84.47-.35.56-2.03.34-2.34-.21-.3-4.64 3.16-4.64 3.16z'/%3E %3Cpath fill='%231e2121' d='M426.09 194.16s.12 2.74.48 4.32c.37 1.59 1.42 5.04 1.42 5.04s-1.42-2.56-2.04-4.78c-.63-2.22-1.2-4.6-1.76-4.78-.57-.17-1.22 1.06-1.22 1.99 0 .92.6 4.38 1.36 5.59.77 1.2-1.22-1.59-1.7-3.09-.48-1.5-.97-2.82-.97-2.82s-.48 1.27-.28 2.68c.2 1.41 1.4 3.43 1.4 3.43s-.78-.67-1.26-1.24c-.48-.58-.91-.92-.91-.92s.08 1.93.6 2.76c.5.84 1.5 2.16 1.5 2.16s-1.19-.89-1.65-1.4c-.45-.53-.59-.9-.59-.9s.25 2.76.85 4.23c.6 1.47 1.9 3.9 1.9 3.9s-1.56-1.25-2.61-3.66c-1.05-2.43-1.56-9.64-1.3-10.74 0 0 .8-1.36 1.53-2.43.74-1.06 1.68-6.15 1.68-6.15s1.16 4.7 1.95 5.6c.8.9 1.62 1.21 1.62 1.21zM414.82 192.74s.6 1.26.98 1.83c.39.56.77 1.28.77 1.28s-1.4 1.51-2.98 2.72c-1.58 1.21-3.67 2.55-4.13 1.86-.47-.7-.45-1.28-.45-1.28s1.73-1.04 3.1-2.42c1.36-1.39 1.83-2.11 2.13-2.84.3-.74.58-1.15.58-1.15zM400.48 197.41s.24 2.94 1.48 2.9c1.24-.05 4.9-3.76 5.15-3.94.26-.17.5-1.08.5-1.38 0-.3-.22-1-.22-1s-3.94 4.05-5.34 4.18c-1.03.1-1.57-.76-1.57-.76zM400.6 193.55s-.47 2.07-.4 2.65c.06.58.24 1.04.24 1.04s-2.82.99-3.29.13c-.47-.87-.16-2.1-.16-2.1s1.31 0 2.03-.16c.73-.18 1.58-1.56 1.58-1.56zM427.27 189.4s1.15 3.03 1.9 4.24a50 50 0 0 1 1.9 3.72s-1.9-2.22-2.5-2.71l-1.57-1.3s.28-.82.28-1.45l-.01-2.5z'/%3E %3Cpath fill='%23dbad6c' d='M396.55 195.29s1.05.13 1.7.1c.64-.04 1.07-.3 1.07-.3l1.07-1.6s-.54 1.9-.17 3.24c.38 1.35 1.16 1.56 1.47 1.56.3 0 1.8-.31 2.96-1.52s2.76-2.47 2.76-2.47-.37 1.74.24 3.47c.62 1.73 1.6 1.7 2.93.62 1.33-1.07 2.7-2.9 3.42-3.72.4-.44.91-1.37.91-1.37l1.46-1.16 1.26-7.13-.68-.93-1.84.88-2.21-.88-.65-.9-1.26 2.14-1.33.87-.67.11-1.54.3-.69-1.38-.4-1.07-.76-.35-3.17 3.2-1.8-.08-1.8 2.83-1.3 1.8-1.33 3.14.35.6z'/%3E %3Cpath fill='%238f4620' d='M411.97 188.08s.26 1.77-.64 4.75c-.9 2.99-2.13 5.1-2.13 5.1s3.2-1.94 4.73-5.44c1.53-3.5 1.18-7.52 1.18-7.52l-3.14 3.11zM415.84 184.83s.39.52.04 3.2c-.34 2.68-.97 5.27-.97 5.27s.37.65.8 1.51c.43.87 1.5 2.38 2.26 2.12.77-.26 1.96-1.17 2.77-2.94.8-1.77 1.53-3.5 1.83-3.76.3-.26.43.17.56.3.12.13.37 1.65 1.13 2.3.77.64 1.77 1.66 2.24 1.36.47-.3.93-1.2.84-1.63-.08-.43-1.7-5.27-1.7-5.27l-2.04-5.23-1.31-2.03-3.72.35-2.73 4.45z'/%3E %3Cpath fill='%23ab6d29' d='M422.29 180.03s1.05 2.25 1.11 4.67c.06 2.42-.48 4.95-.48 4.95s.22-3.02-.12-4.84c-.34-1.81-.88-3-.82-3.51.06-.52.31-1.27.31-1.27z'/%3E %3Cpath d='M427.34 189.49s.21 2.09 0 3.08c-.21 1-1.66-.65-2.55-3.93-.9-3.29-.73-4.02-1.41-5.62-.69-1.6-1.1-2.98-1.1-2.98l1.86-.26 3.2 9.71zM418.23 195.59s3.55-2.01 4-8.08c.22-2.85-1.61-7.48-1.61-7.48s0 4.93-1.32 8.1c-1.33 3.18-2.41 5.3-2.41 5.3s.85-.37 1.28-.89c.42-.52 1.02-1.4 1.02-1.4s.19.9-.13 2.1c-.32 1.18-.83 2.35-.83 2.35zM415.1 184.96s-.11 1.34-1.6 2.55c-1.5 1.21-4.18 2.55-4.18 2.55s1.96-1.81 2.68-3.41c.73-1.6.17-2.64.17-2.64s-.25.86-1.1 1.51c-.85.65-2.09.78-2.09.78s.1-.82.87-1.68c.16-.18.13-.59.24-.92.42-1.3 1.53-3.1 1.53-3.1s.85 1.9 1.7 2.72c.86.82 1.78 1.64 1.78 1.64z'/%3E %3Cpath fill='%231e2121' d='M426.21 177.79s.85 2.2 1.2 5.19c.33 3-.06 6.5-.06 6.5s-1.82-2.82-2.28-3.97c-.45-1.15-.45-2.88-.85-3.74a4.2 4.2 0 0 0-1.37-1.37c-.32-.22-1.33-.18-1.33-.18s1.05-.5 1.14-1.42c.08-.92 0-1.41 0-1.41s.68.34 1.79.49c1.1.14 1.76-.09 1.76-.09zM418.25 190.58s1.94-2.7 2.45-6.05c.5-3.34-.09-4.5-.09-4.5s-.8-.11-1.44-.74c-.66-.64-1.68-2.28-1.68-2.28s.28 1.73-.09 3.83c-.36 2.1-2.3 4.12-2.3 4.12s1.03.35 1.94-.17c1.92-1.13 1.78-3.26 1.78-3.26s.43.26.37 2.91c-.06 2.65-.94 6.14-.94 6.14z'/%3E %3Cpath fill='%238f4620' d='M395.31 195.2c-.41-.06 1.28-2.68 2.43-4.5l2.77-4.36s.3.3.98.26a4.76 4.76 0 0 0 3.15-2.16c.72-1.34 1.28-2.81 1.32-3.24.04-.43-.13 2.33 1.2 3.84 1.31 1.51 1.27 1.39 1.83 1.26 0 0-.05 1.9-.56 3.67s-1.02 4.32-1.02 4.32.21-3.32-.34-4.28c-.55-.95-.85.09-1.32 1.3-.47 1.2-1.5 2.07-1.5 2.07s.77-1.46 1.28-3.02c.52-1.56.26-1.6.13-1.64-.13-.05-.38-.09-.93.56-.56.65-1.11.82-1.11.82s.68-.56.9-1.34c.2-.78.85-1.9 1.23-2.33.38-.44.64-.96.64-1.26 0-.3-.09-.95-.35-.95-.25 0-.6.4-1.82 1.56-1.24 1.16-1.45 1.25-1.67 1.68-.21.43-.38 1-1.15 3.42a20.74 20.74 0 0 1-1.4 3.63c-.13.21-.68.57-.68.57s.42-1.35 1.06-3.12c.64-1.77 1.5-4.1 1.28-4.5-.21-.38-.77-.34-.94 0-.17.35-1.4 1.86-2.64 3.68-1.23 1.81-1.23 4.06-1.53 4.15 0 0-.83-.03-1.24-.09z'/%3E %3Cpath fill='%23874f20' d='M427.43 175.83c-.02.2.11 1.5-1.22 1.96a4.55 4.55 0 0 1-3.13-.24c-.16-.15-.16-1.86-.16-1.86l4.51.14z'/%3E %3Cpath fill='%23b27129' d='M401.59 180.06s-.24 1.24-.97 2.76c-.73 1.54-1.95 2.81-1.8 3 .15.2.84.91 1.9.9 1.06-.03 1.45-6.39 1.45-6.39l-.19-.22-.39-.05z'/%3E %3Cpath fill='%23dbad6c' d='M417.95 176.56s-.48 8.42-2.85 8.4c-2.36 0-3.43-4.25-3.43-4.25s-.2 5.68-3.21 5.68c-1.36 0-2.8-4.39-2.5-5.18 0 0-.56 3.02-1.98 4.14-2.82 2.22-4.63 1.14-4.72.79-.1-.34 2.38-2.71 2.72-6.02 0 0 .44.14 1.12-.84.68-1 1.07-2.08 1.76-1.88.68.2 4.08-1.38 4.08-1.38l1.8-2.27s.2.74 1.51-.15a4.8 4.8 0 0 0 1.76-2.23l3.5 2.97.44 2.22z'/%3E %3Cpath fill='%23b27129' d='M408.73 168.56s2.12 3.2 3.54 5c.08.1.77-.68.77-.68.47.64.73 1.2.59 1.54-.55 1.3-1.7 3.07-.77 4.92 0 0-.3-1.03.22-2.37.5-1.34.89-1.82 1.19-1.78.3.05.8 7.7 1.32 7.65.5-.04 1.2-3.45 1.2-5.87 0-2.43.48-.44.7.04.23.47 2.32 3.89 4.1 3.37 1.8-.52 1.54-3.67 1.5-4.36-.04-.7-1.28-4.89-1.28-4.89l-8.01-5.04s-.23.63-.66 2.06c-.43 1.43-4.41.41-4.41.41z'/%3E %3Cpath fill='%238f4620' d='M420.1 167.81s.47.43 1.24 2.42c.76 1.99.85 8.43-.17 8.38-1.03-.04-3.07-1.2-3.41-2.07-.34-.87.12-4.06-.56-4.93-.68-.86-1.49-3.02-1.53-3.63-.04-.6.13-2.55.13-2.55l1.79-.65 2.51 3.03z'/%3E %3Cpath d='M419.53 165.81l3.4 5.07 3.02 4.35s1.52.5 1.48.6a3.24 3.24 0 0 1-4.11.65c-1.18-.66-.58-2.7-2.07-5.99-1.5-3.28-4.17-4.71-4.17-4.71l.93-.9 1.52.93z'/%3E %3Cpath fill='%231e2121' d='M417.65 163.04s3.04 2.01 4.12 4.2c1.08 2.2 1.71 3.52 3.02 5.65 1.3 2.13 2.7 2.8 2.64 2.94-.06.14-.94.34-1.6-.15a6.22 6.22 0 0 1-1.87-2.04c-.54-.98-2.44-4.55-3.15-5.48-.71-.92-2.98-2.65-3.04-2.47-.05.17.71.69 2.02 2.8 1.3 2.1 1.62 4 1.53 4.02-.08.03-.37-.77-1.5-2.67-1.14-1.9-3.61-4.36-3.75-4.01-.15.35 1.22 2.6 1.9 3.89.68 1.3 1.82 4.32 1.7 4.32-.1 0-.9-1.7-2.27-3.8-1.36-2.1-1.62-1.85-2.19-2.54-.56-.69-1.78-2.28-1.78-2.28s1.22.38 2.4-.4c1.2-.77 1.82-1.98 1.82-1.98z'/%3E %3Cpath fill='%238f4620' d='M409.9 168.65s1.96.45 3.02.32c1.07-.13 1.43-.08 1.43-.08s.64.86.64 1.85c0 1-.68 2.86-.98 2.9-.3.04-.25-1.69-.72-2.3-.47-.6-3.39-2.69-3.39-2.69z'/%3E %3Cpath fill='%23b27129' d='M410.94 173.79s.63 2.13.15 5.09c-.49 2.96-2.2 6.02-2.63 6.02-.44 0-.3-3.36-.49-5.13l-.06-.55c-.03-.24-.67 2.24-.7 2.03-.02-.23.57-3.15.55-3.34l-.14-1.11 2.2-2.61 1.12-.4z'/%3E %3Cpath fill='%238f4620' d='M407.21 176c-.6.74-1.51.54-2.36.8-.79.25-1.07 1.45-1.07 1.45s.64-.47.94-.34c.3.13.65.1.05 1.57s-2.92 3.96-2.81 3.99c.11.03 2.6-2.1 3.4-3.31.82-1.21.75-1.93.92-2.37.17-.43 1.13-.95 1.34-.99.22-.04.69.04.9.9.21.87.55 3.33.72 3.42.17.09.77-2.25 1.03-3.41.25-1.17.24-3.74.24-3.74s-.16-.07-.76-.2-2.02-1.15-2.02-1.15.28 2.4-.52 3.38z'/%3E %3Cpath fill='%23dbad6c' d='M417.72 160.94s.8 2.01-.85 3.42c-.5.4-.97.69-1.85.73-.88.04-2.29-.71-2.29-.71l-5.09-2.12-2.68-.84-1.32-.37.19-1.47 3.98.17 3.94 1.51 1.73.57 1.47.25h1.1l.92-.25s.43-.18.55-.41c.13-.24.2-.48.2-.48z'/%3E %3Cpath fill='%23ab6d29' d='M417.72 160.94c.17.35-.3 1.47-.68 1.64-.39.18-1.07.48-2.6.13-1.53-.34-3.11-1.34-4.82-1.81-1.7-.48-2.98-.91-4.3-.87-1.32.05-.68-.56-.68-.56s3.03-.34 5.67.65c2.64 1 3.78 1.67 5.11 1.64 2-.04 2.3-.82 2.3-.82z'/%3E %3Cpath d='M403.79 159.34s.6.13 1.1.04c.52-.08.9-.39.9-.39s.09.7-.25.91c-.34.22-1.37.13-1.54.13-.17 0-.21-.69-.21-.69z'/%3E %3Cpath fill='%23dbad6c' d='M413.8 165.63s1.78 1.74 1.3 3.25l-3.43-1.57-5.6-2.34-3.04-.9-.37-.48s.58-.54.85-1.06c.28-.52.2-1.01.2-1.01l3.7.5 3.88 1.18 2.51 2.43z'/%3E %3Cpath fill='%23dbad6c' d='M409.99 168.13s3.2 4.13 2.45 5.49l-7.46-4.71-2.62 4.33-6.14-3.03s4.95-3.8 5.53-4.52c.57-.72.61-.97.61-.97l2.77.53 4.37 1.39.49 1.49z'/%3E %3Cpath fill='%23ab6d29' d='M408.26 162.03s2.61.63 4.29 1.5c1.67.86 4.02 1.06 4.02 1.06s-.94.99-2.77 1.04c-.54.02-1.85-1.04-2.7-1.64-.85-.6-3.31-1.33-3.31-1.33l.47-.63z'/%3E %3Cpath d='M403.66 160.63s1.88.39 3.03.9c1.15.53 1.23.4 1.53.27.3-.13.34-.26.34-.26s.24 1.12-.66 1.12-1.26-.3-2.4-.82c-1.16-.52-1.92 0-1.92 0l.08-1.21z'/%3E %3Cpath fill='%23ab6d29' d='M414.02 167.88s1.34.84 1.08 1c-.25.18-.92.5-2.09.57a4.52 4.52 0 0 1-2.54-.45c-.82-.37-1.33-1.81-3.32-2.59-1.99-.78-2.33-.9-3.7-1.24-1.36-.34-1.67-.32-1.67-.32l1.25-.52 4.29.87 3.66 1.07 2.22 1.06.82.55zM406.82 170.4l.85 3.37-.47 2.03-1.15.74-1.06-.43-.3-.61s.47-.78 0-1.47-2.64-1.55-2.64-1.55.85-1.65 1.83-2.04c.98-.38.51-1.64.51-1.64l2.43 1.6z'/%3E %3Cpath d='M402.64 163.53s.68.58 2.08.72a16 16 0 0 1 2.83.62c.38.12 1.32-.4 1.4-.38l-.81.49c1.23.35 2.79.9 3.33 1.14a7.61 7.61 0 0 1 2.56 1.76c-.05.02-.84-.46-2.56-1.18a22.88 22.88 0 0 0-3.97-1.24c-2.56-.5-5.12-.34-5.65-.52-.55-.17.22-.2.5-.49.29-.29.29-.92.29-.92z'/%3E %3Cpath fill='%23ab6d29' d='M412.18 172.78s.81.86-.04 1.17c-.85.3-3.18.24-4.28-.92 0 0-.28-1.11-.7-1.63-.43-.52-2.13-1.6-3.12-2.2-.97-.61.34-.7.34-.7s3.5 1.34 4.78 2.03c1.28.7 3.02 2.25 3.02 2.25z'/%3E %3Cpath d='M412.23 172.86s-1.72-2.38-6.5-4.26c-.13-.05 1.62-.3 1.49-.35-.2-.08-2.3.04-2.53-.04l-1.12-.36c-2.51-.77-2.7-.7-2.87-1.04-.17-.34-.48.06-.74.49-.25.43-.96 1.37-.9 1.28.05-.09 1.84-.5 3.26-.16 1.42.35 1.36.87 1.25 1.42-.11.54-1.84 2.65-1.65 2.7.2.06 1.2-1.99 2.5-1.7 1.3.3 1.74 1.01 1.74 1.01s-.03-.75-.29-1.07c-.25-.31-1.7-1.67-1.3-1.67.4 0 2.01.38 4.34 1.56 2.27 1.15 2.64 1.5 3.32 2.19z'/%3E %3Cpath fill='%23dbad6c' d='M404.43 169.12s3.67 1.04 3.5 4.93c-.18 3.88-3.02 3.17-3.27 1.75-.26-1.4.34.68 1.36.5 1.12-.21 1.35-1.33 1.28-2.83-.07-1.44-.37-2.16-1.25-3a15.72 15.72 0 0 0-1.62-1.35z'/%3E %3Cpath fill='%236c3f18' d='M388.58 159.75s.38.3-.66 3.04c-1.05 2.74-1.61 3.72-3.2 5.47-2.96 3.26-4.25 3.28-3.94 4.66.32 1.39 1.47 1.02 1.73 1.06.26.05 5.58-7.8 5.58-7.8l1.17-4.7-.28-1.33-.4-.4z'/%3E %3Cpath fill='%23dbad6c' d='M401.79 154.14s1.53 2.3 1.05 6.65c-.48 4.35-6.22 8.16-6.22 8.16l-8.37 5.79-3.5-.21s-.55.08-1.06-.06c-.55-.14-1.06-.71-1.18-.71-.23 0-.66-1.47-.66-1.47l1.11-1.35 3.04-3.03 1.9-2.74s.86-1.58.97-3.1c.11-1.54-.28-2.31-.28-2.31l.7 1.1.4 2.3-.3 2.56 2.18-1.47 2.9-1.3s.8-.11 1.36-1.72a20.37 20.37 0 0 0 1.05-5.05c.01-1.06-.12-2.33-.12-2.33s.19-.01.37.1c.18.1.94 1.45.94 2.21 0 .77.5 3.59.5 3.59l1.34-1.36s.99-1.24 1.25-1.9c.27-.64.64-1.66.63-2.35z'/%3E %3Cpath fill='%23904720' d='M402.72 175.91s.58.47.36 2.05c-.21 1.58-1.51 2.44-2.15 2.47l.06-2.2-1.85-1.48-1.98-.6s.13-.11.36-.35c.24-.23 2.28-1.08 2.28-1.08l2.92 1.19z'/%3E %3Cpath fill='%23ab6d29' d='M401.27 175.93s.58.56 1.5.32c.9-.23 1.3-1.7.8-2.29-.49-.58-.28 1.4-.87 1.62-.6.22-1.24-1.49-2.05-1.66-.8-.17-2.08.39-2.4.93-.32.54 1.3.1 1.3.1l.87.24.64.16.21.58z'/%3E %3Cpath fill='%23904720' d='M389.17 169.89s1.09.33 2.27.17 4.07-1.37 4.07-1.37 1.34-.75 2.32-1.7c.98-.95 4.07-2.88 4.41-6.74.34-3.86-.45-6.1-.45-6.1s4.58 5 .57 10.74c-2.61 3.74-4.89 4.84-4.89 4.84s4.43-1.3 4.83-.23c.4 1.06-.2 2.72-.32 2.98 0 0 2.51.58 2.88 1.86.21.76-2.86-.89-5.18-.33s-3.34 1.95-3.34 1.95-.43-.67-2.5-.7c-2.06-.02-3 .96-4.17.91-1.17-.04-4.85-.83-5.56-1.83 0 0 .87-1.1 2.43-2.88 1.07-2.05 2.63-1.57 2.63-1.57z'/%3E %3Cpath fill='%23ab6d29' d='M398.69 159.53s1.79-1.76 2.38-3.05c.6-1.3.72-2.34.72-2.34s.2 1.41-.85 3a16.93 16.93 0 0 1-2.22 2.68l-.03-.29z'/%3E %3Cpath fill='%23904720' d='M398.2 155.61s1.46 5.68-.1 8c-1.56 2.34-8.36 5.36-8.36 5.36s5.15-2.79 6.77-6c1.62-3.21 1.5-5.9 1.5-5.9l.2-1.46z'/%3E %3Cpath fill='%231e2121' d='M391.44 170.05s2.17-.04 3.4-.78c1.24-.73 3-2.29 3-2.29s-1.63 1.43-2.1 1.43c-.47 0-.85-.74-.64-1.3 0 0-.38 1.08-1.36 1.82-.98.73-2.3 1.12-2.3 1.12zM396.5 162.97s1.83-1.9 1.79-5.88c-.04-3.97-1.54-3.24-1.54-3.24s1.24.9.98 3.93a17.32 17.32 0 0 1-1.23 5.19zM398.72 163.36s2.06-.5 2.79-1.7c.72-1.22.7-3.53.7-3.53s-.21 2.12-.8 2.9c-.6.77-2.69 2.33-2.69 2.33zM397.52 175.8s1.02-1.99 2.39-1.47c1.36.52 1.36 1.6 1.36 1.6s-.55-.86-1.58-.9c-1.02-.05-2.17.77-2.17.77zM393.65 172.22s3.02-.74 4.81-1.3c1.8-.56 3.84-1.42 3.84-1.42s-1.5 1.85-3.71 3.1c-2.22 1.26-4.05 1.35-4.05 1.35s4.18-1.82 4.52-2.55c0 0-4 1.08-5.41.82z'/%3E %3Cpath fill='%23fff' d='M388.81 167.55a3.46 3.53 67.76 0 1-3.98 5.72'/%3E %3Cpath fill='%23f16e16' d='M388.63 167.94a3.05 3.1 67.77 0 1-3.57 4.97'/%3E %3Cpath fill='%23000' d='M387.28 169.62a1.23 1.23 0 1 1-1.2 1.85'/%3E %3Cpath fill='%23d5d3ca' d='M387.45 171.18a.4.4 0 1 1-.77-.13.39.39 0 0 1 .45-.33.4.4 0 0 1 .32.46z'/%3E %3Cpath fill='%23ab6d29' d='M389.58 165.4s2.02-1.99 2.47-4.61c.46-2.62.18-4.11.18-4.11l1.1 1.14.42 2-.7 3.3 2.21-1c.74-1.01 1.9-5.5 1.5-8.27 0 0 .6 1.21-.2 4.98-.79 3.78-1.44 4.22-4.28 5.78-1.46.8-3.3 2.34-4.97 5.54a24.7 24.7 0 0 1-3.06 4c-.06.05 1.42-2.01 2.14-3.56 1.08-2.3 2.25-3.6 2.25-3.6l.94-1.59z'/%3E %3Cpath fill='%23904720' d='M388.64 166.99s.88-2.65.88-4.1-.94-3.13-.94-3.13 1.28-.18 1.4 2.96c.1 3.15-.57 3.32-1.34 4.27z'/%3E %3Cpath d='M392.69 163.61s.94-2.33.87-3.89c-.06-1.56-1.34-3.05-1.34-3.05s1.58.3 1.7 3.14c.13 2.83-.36 2.85-1.23 3.8z'/%3E %3Cpath fill='%23ab6d29' d='M383.39 174.25s-.73-.94-.64-1.67c.08-.73.02-.9 1.83-2.8s2.82-3.07 3.26-4.09c.45-1.01 1.92-3.78.75-5.93 0 0 .8 3.13-1 5.61-1.81 2.48-2.86 3.78-4.35 4.88-1.49 1.1-1.64 1.62-1.6 2.25.05.63.2 1.25.45 1.4.46.27 1.3.35 1.3.35z'/%3E %3Cpath fill='%236c4119' d='M400.94 180.42s.4.04.66-.43c.25-.48.25-1.28-.38-2.08a4.33 4.33 0 0 0-2.26-1.53c-.9-.26-2.62-.43-2.62-.43s.59 1 1.74 1.66c.57.32 1.54-.09 2.16.52.61.6.7 2.29.7 2.29z'/%3E %3Cpath fill='%236c4119' d='M400.94 180.42s2.01-.65 2.15-2.6c.09-1.2-.17-1.61-.17-1.61s.3.62 1.1.86l.73-.28s-1.2 3.76-3.81 3.63z'/%3E %3C/g%3E %3Cg fill='%23f9c83a'%3E %3Cpath fill='%23bf802d' d='M386.9 180.05s.4.16 1.14 1.03c.75.86 1.1 1.14 1.1 1.14l4.87-1.25 1.58-1.56-1.32-2.09h-3.5l-3.87 2.73z'/%3E %3Cpath stroke='%238f4620' stroke-width='.48' d='M398.72 178.39l-.94-1.27s-.2-.49-.9-.86c-.72-.37-3.67-.35-3.67-.35l-2.13.44s-.6.54-1.68.31c-1.08-.23-3.46-1.2-3.46-1.2l-2.39-1.05s-1.79-.74-2.18-.6c-.4.14-1.88 1.76-1.88 1.76s-.25.86.31.89c.57.03-.85.29-.85.29s-3.7 2.03-4.3 5.66c-.6 3.63 6.1 8.99 8.56 6.27 0 0-3.62-2.68-2.9-4.93.73-2.25 2.4-3.63 5.24-3.8 2.86-.17 3.03-.52 4.26-1.39 1.24-.86 3.54-1.38 5.24.4 1.7 1.76-6.47 3.45-6.47 3.45l.9 1.3s10.1-3.46 9.24-5.32z'/%3E %3Cpath fill='%23fcf3d8' d='M379.85 187s-4.09-1-3.75-4.75c.34-3.76 3.75-5.14 4.35-5.32.6-.17.47-2.07 1.15-2.29.68-.21 1.99 0 2.58.56.6.57 1.87 1.1 1.87 1.1s-7.24 3.22-7.3 7.37c-.05 2.77 1.1 3.33 1.1 3.33z'/%3E %3Cpath fill='%23fdeaaf' d='M398.7 177.99s-.5.3-.63.05c-.76-1.42-2.55-1.8-4-1.78-1.85.03-3.1.72-4.35.72-1.25 0-.9-.2-2.39-.26-1.47-.06-4.62-2.4-5.34-2.16-.7.23-.99 1.1-.9 1.54.08.43-1.29.46-1.48.14-.2-.32 1.08-2.36 2.36-2.36 3.44 0 5.99 2.32 7.64 2.32 1.64 0 2.21-.95 4.43-.95 2.21 0 4.6.98 4.66 2.74z'/%3E %3Cpath fill='%23513625' d='M387.45 180.66s1.64-.32 2.87-.86c1.24-.54 2.89-.97 2.89-.97s-1.51 1-2.56 1.5c-1.04.49-2.73.76-2.73.76l-.47-.43z'/%3E %3Cpath d='M381.66 189.16c-.3.12-1.73.06-4.02-1.47-2.28-1.53-2.88-4.12-2.88-4.12s-.52-2.48 1.85-5 2.76-1.8 2.88-1.68c.11.1-.12.23-.12.23l-2.08 1.7-1.04 1.74-.92 1.57.07 1.86 1.06 1.86 3.27 2.04 1.93 1.27z'/%3E %3Cpath fill='%238b5122' d='M380.41 174.93l-.13-.31v.34c.1 0 .12-.03.13-.03l-.13-.31v.34-.35l-.24.25c.09.08.19.1.24.1v-.35l-.24.25.24-.25h-.34c0 .06.02.17.1.25l.24-.25h-.34.34l-.31-.14c0 .03-.03.05-.03.14h.34l-.31-.14.27.12-.24-.17-.03.05.27.12-.24-.17.06.04-.06-.04.06.04-.06-.04-.18.2c-.14.17-.33.4-.48.64-.16.25-.3.5-.31.82v.12c.05.33.27.6.52.7.24.13.5.16.75.16.54 0 1.05-.16 1.07-.16a.35.35 0 0 0 .22-.44.34.34 0 0 0-.42-.23h-.02c-.08.03-.49.14-.85.14-.19 0-.36-.03-.45-.08-.1-.06-.12-.08-.14-.2 0-.04.03-.16.1-.3a3.95 3.95 0 0 1 .64-.84l.07-.08.03-.04.03-.04.02-.05c0-.03.02-.06.02-.13a.34.34 0 0 0-.34-.35c-.1.01-.12.03-.13.03a.35.35 0 0 0-.19.46c.08.17.28.25.45.18z'/%3E %3Cpath d='M387.36 178.44s-4.89 1.37-5.01 1.46c-.36.26 1.56-.04 3.07-.09 1-.03 1.76.22 1.76.22s.59-.01 1.18-.24c1.88-.74 5.83-2.2 6.2-.48.3 1.45-5.46 2.71-5.46 2.71l-.05.57 4.63-1.15 2.38-1.26.77-1.23-2.3-1.64h-3.37l-1.55.43-2.25.7z'/%3E %3Cpath fill='%238f4620' d='M380.21 185.51c.36 1.02 1.18 2.5 2.1 2.97 0 0 .16.01.1.11s-.74.52-2.3.12c-1.56-.4-3.95-1.04-5.4-5.42l.05.97.85 1.71 1.53 1.59 2.4 1.5 1.65.41 1.4-.36.62-.47-1.44-1.3-1.76-3s-.07.42.2 1.17z'/%3E %3C/g%3E %3Cg fill='%23816c2a'%3E %3Cpath fill='%23fcca3d' d='M396.5 228.99l-.07 1.59-.88-.1.16-1.98zM390.37 183.78l-1.62-1.82-1.05.16 1.6 2.28z'/%3E %3Cpath d='M396.42 232.7s-.98-.64-2.24-1.22c-1.3-.6-3.1-.87-3.12-.87l-.06.4.3.06c.56.1 1.8.37 2.71.78a18.72 18.72 0 0 1 2.02 1.1l.17.1.22-.35zM396.28 228.65s-.9-.06-1.85-.06c-.66 0-1.34.03-1.8.14-1.1.27-1.81.82-1.83.83l.25.33.03-.02a4.99 4.99 0 0 1 3.35-.87 29.74 29.74 0 0 1 1.82.06l.03-.41zM395.81 225.17s-2.26 1.06-3.3 1.76c-1.04.68-2.12 1.57-2.13 1.58l.26.32.67-.53c.39-.3.91-.7 1.42-1.03a48.85 48.85 0 0 1 3.25-1.72l-.17-.38zM393.64 221.59c0 .08-.02.92-.42 1.56-.1.16-.42.54-.83 1-.6.69-1.43 1.57-2.1 2.29l-1.18 1.24.3.3 1.89-2.01 1.4-1.54c.41-.47.73-.84.86-1.06.48-.77.49-1.66.49-1.77v-.01h-.41zM390.81 219.99l.02.07c.03.16.1.53.1 1.03 0 .51-.08 1.16-.31 1.83a27 27 0 0 1-1.29 2.85l-.6 1.17-.26.48.35.2s1.6-2.91 2.18-4.56a5.95 5.95 0 0 0 .2-3.18l-.39.11zM388.07 219.66a11.6 11.6 0 0 0 .07 1.5 7.4 7.4 0 0 1-.29 2.3 144.64 144.64 0 0 1-1.34 3.65l.38.15s.85-2.26 1.35-3.66c.25-.72.3-1.65.31-2.45 0-.85-.07-1.53-.07-1.53l-.41.04zM385.96 219.65s0 .7-.05 1.56c-.04.87-.12 1.9-.27 2.54-.32 1.35-.65 3.3-.65 3.3l.4.07.2-1.14c.13-.65.3-1.47.45-2.13.32-1.39.33-4.19.33-4.2h-.41zM383.68 220.02l.06.65c.02.4.05.92.05 1.45a7.2 7.2 0 0 1-.15 1.66c-.33 1.26-.53 3.25-.53 3.25l.4.05a30.33 30.33 0 0 1 .53-3.2 7.4 7.4 0 0 0 .16-1.76c0-1.1-.11-2.14-.11-2.15l-.41.05zM381.89 220.26v.23c0 .5-.04 1.67-.37 2.89l-.72 2.52c-.2.76-.36 1.3-.36 1.3l.39.12 1.08-3.83c.35-1.27.4-2.49.4-3l-.01-.25-.41.02zM379.89 220.28a10.26 10.26 0 0 0 .05.9c0 .76-.1 1.87-.58 2.74a7.2 7.2 0 0 1-1.81 1.96c-.33.26-.63.47-.85.62l-.26.17-.09.05.2.36c.02-.01 2.27-1.33 3.17-2.97a6.3 6.3 0 0 0 .63-2.93c0-.57-.05-.95-.05-.95l-.41.05zM378.66 219.89l-.09.28a8.78 8.78 0 0 1-1.25 2.46 8.7 8.7 0 0 1-1.68 1.46l-.74.49-.3.18.2.36s1.91-1.09 2.84-2.23a9.53 9.53 0 0 0 1.41-2.88l-.39-.12zM376.71 218.91l-.11.22c-.12.22-.3.54-.5.86a4 4 0 0 1-.62.79c-.27.23-.8.56-1.25.83l-.83.48.2.36s.38-.2.84-.48c.46-.28 1-.61 1.3-.88.34-.29.65-.78.9-1.2.26-.43.43-.8.43-.8l-.36-.18zM375.76 217.69l-.32.37c-.3.34-.77.85-1.23 1.3a8.5 8.5 0 0 1-.67.59c-.2.16-.4.26-.5.3l.11.4c.27-.09.55-.3.86-.56.94-.79 2.06-2.13 2.06-2.13l-.31-.27zM375.29 216.87l-.3.23c-.27.22-.7.53-1.14.8-.42.25-.87.45-1.1.45v.41c.27 0 .56-.11.86-.26.9-.44 1.93-1.3 1.94-1.3l-.26-.33zM374.93 215.99s-.45.26-.98.53l-.78.38c-.25.1-.47.18-.57.19l.04.4c.2-.01.42-.1.69-.2.77-.34 1.8-.94 1.8-.94l-.2-.36zM374.5 214.17l-.04.05c-.1.1-.36.37-.7.6a2.1 2.1 0 0 1-1.14.46v.41a2.74 2.74 0 0 0 1.52-.63c.4-.3.66-.61.66-.62l-.3-.27zM374.65 211.31s-.37.3-.78.68c-.4.38-.84.84-1 1.27 0 0-.06.1-.12.16l-.09.07-.03.02v.02-.02.02-.02.41c.2 0 .32-.12.41-.21.1-.11.17-.2.2-.3.1-.29.53-.75.92-1.12.19-.19.38-.35.52-.47.13-.12.22-.18.22-.18l-.25-.33zM388.69 194.52h2l.03-.01.05-.02.05-.05.04-.13-.04-.12-.07-.06-.06-.02h-.03l-.02.41v-.16.16-.16.16l.01-.2-.04.2h.02l.02-.2-.04.2.04-.2-.07.19h.03l.05-.2-.08.2.08-.2-.13.17.05.03.07-.2-.12.17-.04-.05.16-.12h-.2l.04.12.17-.12h-.2l.03-.12.08-.07.08.2-.02-.21-.06.01.08.19-.02-.2.01.13v-.13h-.01l.01.13v-.13h-1.95v.41zM388.74 193.29h.13c.29 0 .58-.11.88-.27.44-.23.9-.58 1.3-.86.21-.14.4-.26.58-.35.16-.08.31-.13.4-.13v-.42c-.27.01-.52.13-.79.3-.4.23-.84.57-1.27.85-.42.28-.84.48-1.1.47h-.08l-.05.41zM388.57 191.32c.3-.04.63-.19.97-.38.5-.3 1.06-.69 1.57-1 .5-.33.98-.56 1.23-.56v-.42c-.3.01-.6.14-.93.32-.5.27-1.05.66-1.57.99a3.9 3.9 0 0 1-1.32.64l.05.41zM387.84 189.49c.5-.26 1.24-.84 2.01-1.43.77-.6 1.57-1.22 2.1-1.55l-.21-.35c-.57.35-1.37.97-2.14 1.57-.76.6-1.52 1.16-1.95 1.4l.19.36zM386.46 187.4c.98-.7 3.37-2.4 4.27-2.98l-.21-.35c-.92.59-3.31 2.3-4.3 3l.24.33zM384.63 185.39c.65-.55 1.56-1.16 2.4-1.7.85-.55 1.62-1.02 2-1.3l-.23-.34c-.36.27-1.14.74-1.98 1.28a24.4 24.4 0 0 0-2.45 1.74l.26.32zM383.19 184.15a173.4 173.4 0 0 1 3.54-2.5c.46-.31.83-.55.97-.61l-.17-.38c-.2.1-.56.33-1.02.64-1.38.93-3.56 2.51-3.56 2.51l.24.34z'/%3E %3Cpath fill='%2378732e' d='M386.48 180.09l.25.2c.56.46 1.96 1.67 3.23 3.25 1.26 1.58 2.36 3.53 2.36 5.43 0 .18-.01.37-.03.55-.29 2.48-1.53 4.66-3.25 6.67-2.59 3.03-6.25 5.66-9.27 8.33a23.72 23.72 0 0 0-3.86 4.1 8 8 0 0 0-1.6 4.56l.01.22c.05 1.5.54 3.14 1.47 4.46a5.74 5.74 0 0 0 5.1 2.55c2.35 0 4.93-.75 7.38-.75 2.07 0 4.03.51 5.77 2.42 1.67 1.82 2.18 4.75 2.18 7.57a31.9 31.9 0 0 1-.87 7.17l-.16.65.4.12c0-.02 1.04-3.84 1.04-7.94 0-2.87-.5-5.9-2.29-7.85a7.68 7.68 0 0 0-6.07-2.55c-2.53 0-5.1.75-7.39.75-.3 0-.6-.02-.88-.05-1.71-.17-3-1.09-3.88-2.33a8 8 0 0 1-1.4-4.23v-.2c0-2.04 1.02-3.89 2.6-5.69 2.37-2.7 5.97-5.26 9.11-8.09 3.14-2.83 5.82-5.96 6.26-9.84.03-.2.04-.4.04-.6 0-2.36-1.52-4.65-3.02-6.36a22.61 22.61 0 0 0-2.98-2.85l-.25.33z'/%3E %3Cpath fill='%23a8ac71' d='M383.38 184.11l-.5-.42-.41.15.8.65zM384.7 185.36l-.37-.38-.19.1.3.41z'/%3E %3Cpath fill='%2378732e' d='M386.54 187.39l-.31-.4-.2.25.32.37zM387.92 189.45l-.23-.41-.37.06.48.52zM388.7 191.39l-.18-.56-.05.1-.04.42zM388.79 193.34l.02-.54-.24-.15.03.74zM388.71 194.59l.05-.6-.16-.11.01.79zM372.77 213.96s.04-.5.18-.93c.14-.43-.4.2-.4.2l-.06.6.28.13z'/%3E %3Cpath fill='%23fff' d='M372.64 215.2l-.23.1.08.59.13-.18.02-.51z'/%3E %3Cpath fill='%2378732e' d='M372.68 217.51l-.03-.57-.17-.06v.92z'/%3E %3Cpath fill='%23fff' d='M372.83 218.8l-.05-.51-.18.02-.02.49zM373.18 220.66l-.1-.5-.12.12.1.5zM373.67 222.57l-.2-.67-.15.06.2.65z'/%3E %3Cpath fill='%23a8ac71' d='M374.91 225.13l-.28-.42-.26-.04.34.5zM376.8 227s-.26-.15-.63-.45c-.37-.3-.15.28-.15.28l.54.28.24-.11zM389.63 227.96s-.3-.2-.51-.3c-.21-.1.11.02.3.44.18.42.21-.14.21-.14z'/%3E %3Cpath fill='%23fff' d='M390.73 228.85s-.25-.31-.4-.42c-.17-.1-.11.32-.11.32l.33.14.18-.04z'/%3E %3Cpath fill='%23a8ac71' d='M390.95 229.36c-.14-.18-.29.27-.29.27l.4.37s.03-.45-.11-.64zM391.01 231.13s.09-.38.06-.62c-.02-.23-.2.09-.2.09l.01.53h.13z'/%3E %3Cpath fill='%23fff' d='M390.39 233l.15-.47-.2.01-.11.48zM370.86 164.65s.73-.15.18.68c-.55.83.37-.74.37-.74l-.3-.1-.25.16z'/%3E %3C/g%3E %3Cg%3E %3Cpath fill='%23f9c83a' d='M386.69 179.57l.45.46s-.42-.11-.6-.14c-.18-.02.15-.32.15-.32z'/%3E %3Cpath fill='%238f4620' d='M387.13 180.03l-.85.12c-.23.03.25-.25.25-.25l.6.13z'/%3E %3Cpath fill='%23977c2e' d='M394.97 237.46s.53-.06.77-.38c.24-.33-.15.5-.15.5l-.34.14-.28-.26z'/%3E %3C/g%3E %3C/g%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 2800 1400'%3E %3Crect width='2800' height='1400' id='red' style='fill:%23cc0001'/%3E %3Crect width='2800' height='100' y='1300' id='white' style='fill:%23fff'/%3E %3Cuse transform='translate(0,-200)' id='use3035' xlink:href='%23white'/%3E %3Cuse transform='translate(0,-400)' id='use3038' xlink:href='%23white'/%3E %3Cuse transform='translate(0,-600)' id='use3062' xlink:href='%23white'/%3E %3Cuse transform='translate(0,-800)' id='use3064' xlink:href='%23white'/%3E %3Cuse transform='translate(0,-1000)' id='use3066' xlink:href='%23white'/%3E %3Cuse transform='translate(0,-1200)' id='use3068' xlink:href='%23white'/%3E %3Crect width='1400' height='800' id='blue' style='fill:%23010066'/%3E %3Cpath d='M 576,100 C 409.85356,100 275,234.40553 275,400 C 275,565.59446 409.85356,699.99999 576,700 C 636.02725,700 691.95466,682.43566 738.92693,652.21675 C 711.57383,661.65623 682.2175,666.81914 651.65599,666.81914 C 504.3291,666.81915 384.75944,547.64674 384.75944,400.80929 C 384.75944,253.97184 504.32908,134.79944 651.65599,134.79944 C 684.21403,134.79944 715.40185,140.61419 744.2578,151.26671 C 696.21698,118.90999 638.30493,100 576,100 z' id='path4945' style='fill:%23fc0'/%3E %3Cpath d='M 914.28574,471.42858 L 814.74817,418.17806 L 844.17832,527.16068 L 777.60261,435.99589 L 756.83247,546.9551 L 736.40474,435.93234 L 669.5481,526.89131 L 699.31432,418.00001 L 599.61295,470.94319 L 673.67755,385.75059 L 560.87853,390.19195 L 664.57212,345.5715 L 561.01668,300.63137 L 673.80146,305.42069 L 600.00003,220.00001 L 699.53759,273.25053 L 670.10745,164.26791 L 736.68316,255.4327 L 757.4533,144.47349 L 777.88103,255.49624 L 844.73767,164.53728 L 814.97145,273.42858 L 914.67282,220.4854 L 840.60822,305.67799 L 953.40723,301.23664 L 849.71365,345.85709 L 953.26909,390.79722 L 840.48431,386.0079 z' transform='matrix(1.2737922,0,0,1.2422928,-89.4427,-29.478379)' id='path4959' style='fill:%23fc0'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 900 600'%3E %3Crect width='900' height='600' fill='%23000'/%3E %3Crect width='900' height='206.25' fill='%23fff'/%3E %3Crect width='900' height='187.5' fill='%23007168'/%3E %3Crect y='393.5' width='900' height='206.5' fill='%23fff'/%3E %3Crect y='412.5' width='900' height='187.5' fill='%23fce100'/%3E %3Cpath d='M 0,0 V 600 L 393.75,300 z' fill='%23d21034'/%3E %3Cpath d='M 189.54603,214.56867 L 128.78569,171.99623 L 69.930531,217.0706 L 91.643351,146.12847 L 30.587837,104.08263 L 104.76744,102.81043 L 125.88822,31.750306 L 150.02091,101.90617 L 224.12978,100.03443 L 164.86501,144.66535 z' transform='matrix(1.221793,2.542786e-2,-2.542786e-2,1.221793,-21.7604,145.5065)' fill='%23fce100'/%3E %3Cpath d='M 77.1122,167.913 L 118.946,167.913 C 122.312,171.689 129.822,173.229 136.975,167.868 C 150.087,160.688 175.454,167.913 175.454,167.913 L 180.449,162.606 L 168.273,122.645 L 163.902,117.962 C 163.902,117.962 154.537,112.343 136.741,114.216 C 118.946,116.089 112.702,113.592 112.702,113.592 C 112.702,113.592 97.0927,115.465 92.7219,117.65 C 92.2414,118.039 87.7268,122.645 87.7268,122.645 z' transform='matrix(1.259719,0,0,1.259719,-29.41569,140.9042)' fill='%23fff' fill-rule='evenodd' stroke='%23000' stroke-width='1.25' stroke-linecap='round' stroke-linejoin='round'/%3E %3Cpath d='M 85.5415,157.611 C 85.5415,157.611 125.502,152.616 137.054,167.913 C 130.53,172.377 124.786,172.745 118.634,168.226 C 119.614,166.593 132.995,152.616 167.024,157.299' transform='matrix(1.259719,0,0,1.259719,-29.41569,140.9042)' fill='none' stroke='%23000' stroke-width='1.25' stroke-linecap='round' stroke-linejoin='round'/%3E %3Cpath d='M 128.312,117.65 L 128,161.67 M 163.902,118.274 L 171.395,153.24 M 93.1339,117.725 L 88.9756,135.757' transform='matrix(1.259719,0,0,1.259719,-29.41569,140.9042)' stroke='%23000' stroke-width='1.25' stroke-linecap='round' stroke-linejoin='round'/%3E %3Cpath d='M 49.9417,172.706 L 59.7799,184.241 C 60.9352,184.93 61.9614,184.886 62.9876,184.241 L 77.5681,166.745 L 83.6919,159.163 C 84.6401,158.04 84.9428,156.787 84.8583,155.664 L 96.5657,145.261 C 97.5234,145.327 98.0938,145.435 99.0515,145.5 C 97.92,145.207 97.0898,144.656 97.9807,143.416 L 100.605,141.375 L 102.646,143.999 C 102.646,143.999 99.7304,147.79 99.4388,147.79 C 99.1472,147.79 96.2311,147.79 96.2311,147.79 L 90.1073,153.331 L 92.7843,155.697 L 96.8143,166.745 L 101.772,163.245 L 98.5639,151.873 L 105.563,144.291 L 102.938,140.208 L 104.688,137.875 C 104.688,137.875 128.91,153.125 138.242,149.043 C 138.494,149.134 138.806,138.167 138.806,138.167 C 138.806,138.167 113.728,135.543 113.144,130.585 C 112.561,125.628 118.685,125.045 118.685,125.045 L 116.06,121.254 L 116.644,119.212 L 121.018,124.753 L 130.933,116.296 L 189.254,182.783 C 192.438,181.492 193.118,180.713 193.337,177.534 C 193.255,177.454 136.182,111.922 136.182,111.922 L 140.556,107.257 C 141.418,106.285 141.721,105.872 141.722,104.34 L 148.429,98.5082 C 150.446,99.2011 151.732,100.41 152.803,102.007 L 171.242,86.3801 C 171.728,86.8661 173.204,87.3521 174.206,86.8055 L 204.691,57.5442 L 171.466,81.0116 L 170.3,80.1368 C 170.3,79.1647 171.505,78.9243 170.3,77.2207 C 169.009,75.6716 167.092,78.6788 166.801,78.6788 C 166.509,78.6788 161.992,77.0824 161.002,75.06 L 160.677,80.4284 L 152.22,88.3019 L 145.805,88.0103 L 136.473,97.0501 L 135.307,100.549 L 136.765,103.466 C 136.765,103.466 131.807,107.84 131.807,107.548 C 131.807,107.257 130.805,106.259 130.762,106.13 L 135.015,102.299 L 135.598,99.6747 L 134.179,97.4589 C 133.749,97.7714 128.308,103.466 128.016,102.882 C 127.53,102.338 112.27,85.0942 112.27,85.0942 L 113.144,81.8865 L 103.23,71.0969 C 99.6155,69.849 93.8982,69.6389 92.7318,77.5123 C 91.8235,79.3616 84.2751,77.8039 84.2751,77.8039 L 80.1926,78.6788 L 57.1554,111.339 L 69.9862,126.794 L 96.2311,93.5508 L 97.0102,84.1332 L 102.517,90.2905 C 104.353,90.5264 106.102,90.5471 107.766,89.7073 L 123.315,107.063 L 120.726,109.589 C 121.601,110.561 122.203,111.182 123.078,112.154 C 123.953,111.571 124.788,110.871 125.663,110.287 C 125.955,110.677 126.441,111.416 126.733,111.805 C 125.43,112.514 124.516,113.458 123.213,114.167 C 121.128,112.808 119.115,111.116 119.268,108.423 L 110.52,115.713 L 110.228,117.171 L 84.2751,138.75 L 81.9422,139.042 L 81.359,145.749 L 98.2723,131.752 L 98.2723,129.71 L 100.022,131.168 L 113.144,120.671 C 113.144,120.671 114.019,121.837 113.728,121.837 C 113.436,121.837 102.063,132.335 102.063,132.335 L 101.772,133.501 L 99.7304,135.251 L 98.5639,134.376 L 82.817,148.373 L 80.4842,148.373 L 71.7359,157.122 C 69.4795,157.318 67.5243,157.557 65.6121,158.871 z' transform='matrix(1.259719,0,0,1.259719,-29.41569,140.9042)' fill='%23000' fill-rule='evenodd' stroke='%23000' stroke-width='1.25' stroke-linecap='round' stroke-linejoin='round'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 90 60'%3E %3Cpath d='M90,0H0V60z' fill='%23003580'/%3E %3Cpath d='M0,60H90V0z' fill='%23009543'/%3E %3Cpath d='M0,60 90,0' stroke='%23fff' stroke-width='20'/%3E %3Cpath d='M0,60 90,0' stroke='%23d21034' stroke-width='15'/%3E %3Cg fill='%23ffce00' transform='translate(18,16.34148)'%3E %3Cg id='r4'%3E %3Cpath id='r' d='M0,10 1.552914,5.795555H-1.552914z'/%3E %3Cuse xlink:href='%23r' transform='rotate(90)'/%3E %3Cuse xlink:href='%23r' transform='rotate(180)'/%3E %3Cuse xlink:href='%23r' transform='rotate(270)'/%3E %3C/g%3E %3Cuse xlink:href='%23r4' transform='rotate(30)'/%3E %3Cuse xlink:href='%23r4' transform='rotate(60)'/%3E %3Ccircle r='5.5' stroke='%23003580'/%3E %3C/g%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 900 450'%3E %3Ctitle%3EFlag of New Caledonia%3C/title%3E %3Crect fill='%23009543' width='900' height='450'/%3E %3Crect fill='%23ed4135' width='900' height='300'/%3E %3Crect fill='%230035ad' width='900' height='150'/%3E %3Ccircle stroke='%23000' stroke-width='5' fill='%23fae600' cx='300' cy='225' r='147.48'/%3E %3Cpath stroke='%23000' stroke-width='6' d='M275,247h50 M275,210h50 M300,78V330'/%3E %3Cpath d='M240.62,360.419 C300.811,384.999,357.228,361.929,357.228,361.929 C357.228,361.929,335.931,338.881,325.014,329.882 C314.361,321.104,283.023,321.451,272.329,329.882 C263.405,336.92,237.809,362.852,240.62,360.419Z'/%3E %3Cellipse cx='300' cy='293' rx='16.5' ry='24'/%3E %3Cellipse cx='300' cy='228.5' rx='20' ry='12.66'/%3E %3Cellipse cx='300' cy='170' rx='20' ry='20'/%3E %3Cpath d='M324,95.5 C323.994,95.4866,325.733,98.3708,322.087,104.936 C304.661,136.319,287.174,136.997,283.855,139.7 C280.197,142.678,278.653,142.474,278.653,142.474 C278.914,139.786,279.157,128.795,279.348,127.736 C281.993,113.073,304.144,113.275,321.48,98.2605 C324.188,95.915,323.994,95.4866,323.994,95.4866Z'/%3E %3Cg id='leaf'%3E %3Cpath d='m 265.5,163 c0,0 3.91436,11.22974 4.5,22.5 c0.93516,17.99657 18.18031,18.5 30,18.5 l0,-10 c-8.85851,0 -16.55267,-1.31658 -23,-14.5 c-3.18045,-6.50336 -11.5,-16.5 -11.5,-16.5z'/%3E %3Cpath d='m 265,308 c0,0 6.29638,-7.76543 13.6619,-25.97461 C282.5048,272.5249 291.6115,267 300,267 l0,-14 c-19.02757,0 -28.1503,7.0552 -29.11281,17.36332 C268.90975,291.54089 265,308 265,308z'/%3E %3C/g%3E %3Cuse xlink:href='%23leaf' transform='translate(600,0)scale(-1,1)'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 700 600'%3E %3Crect width='700' height='600' fill='%230DB02B'/%3E %3Crect width='700' height='400' fill='%23FFF'/%3E %3Crect width='700' height='200' fill='%23e05206'/%3E %3Ccircle cx='350' cy='300' r='85' fill='%23e05206'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 920 460'%3E %3Crect width='920' height='460' fill='%23007934'/%3E %3Crect width='360' height='460' x='280' fill='%23fff'/%3E %3Cpath fill='%23007934' d='m463.32,30.575c-0.80416,8.7038-1.61,17.412-2.4141,26.116-2.9476,0.44414-5.8944,0.88632-8.842,1.3304-0.00002,0,6.141,3.4483,7.2132,6.9121,0.1716,0.55476,0.103,1.0139-0.1454,1.3593-0.0816,0.10798-0.20658,0.22795-0.31994,0.31813-1.7789,1.3671-7.0388,0.72303-7.0388,0.72303,0-0.00002,6.968,5.8794,7.5041,8.0111,0.012,0.0499,0.028,0.0964,0.029,0.14472-0.00068,0.03992,0.008,0.1058,0,0.14452-0.008,0.03074-0.0458,0.08562-0.0582,0.11576-0.0476,0.1046-0.1334,0.2225-0.23268,0.31813-1.6382,1.5132-9.3656,1.9377-9.3656,1.9377s8.5677,6.1091,9.1038,9.5728c0.48584,3.1391,0.0784,4.9777,0,5.2925-0.59872-0.51141-14.415-12.122-23.327-8.7341-0.44388,0.2306-0.70656,0.45033-0.8144,0.66518-0.0474,0.10718-0.0574,0.24076-0.029,0.34705,0.62434,1.9313,13.227,3.9097,22.018,11.511-0.21806,1.9022-25.055-6.0507-25.973-1.0701,0.77684,1.4044,26.729,5.145,28.649,8.5317-9.5578,0.3554-29.303-2.1035-28.649,1.0412-1.9974,3.6306,18.649,1.58,27.311,4.5406,2.5391,2.869,2.294,5.2791-2.1233,5.5817-8.3488-3.9693-27.034-6.9188-27.079-1.8509,0.00044,0.006-0.00092,0.0238,0,0.0289,0.002,0.006,0.027,0.024,0.029,0.0289,0.008,0.016,0.016,0.0433,0.0292,0.0579,0.0298,0.0285,0.0962,0.0603,0.1454,0.0868,2.11,1.0525,19.51,0.53911,26.061,4.8587-9.2879,2.1008-40.782-4.2618-40.982-1.1568,0.89722,1.4502,5.8807,7.8149,14.456,7.5483,8.5749-0.26653,28.414,3.4668,29.755,6.1312,0.0418,0.0832,0.0414,0.16866,0.029,0.23138-0.58064,1.8582-26.126-5.6683-35.95-1.0412-10.182,4.7967,29.198,1.8889,35.63,7.7508,6.4314,5.8619-12.856-0.54949-12.856-0.54949,0.00002,0-26.783-3.7157-30.802-1.8509-4.0199,1.8657-8.5803,6.1312-8.5803,6.1312s2.6722,5.3166,5.3518,4.2514c0.40822-0.16248,0.68724-0.19562,0.8435-0.14452,0.004,0.002,0.0254-0.002,0.0292,0,0.004,0.002,0.0256,0.0269,0.0292,0.0289,0.006,0.004,0.0238,0.024,0.0292,0.0289,0.004,0.006,0.0244,0.0234,0.029,0.0289,0.002,0.002,0.0274,0.0257,0.0292,0.0289,0.012,0.0267,0.0246,0.083,0.029,0.11578,0.0632,0.79931-1.8324,3.1235-1.8324,3.1235s37.532,9.0411,45.839,17.034c8.3068,7.9942-47.7-12.523-47.7-12.523,0-0.00002-22.51,8.2588,1.3379,8.7919-2.6581,3.8668,1.101,6.2468,1.3379,6.3915,0,0,39.668,8.2679,43.687,14.663,4.0199,6.395-27.063-6.1386-34.03-9.6017-6.7217-3.3423-25.432,1.7676-26.497,3.3259-0.008,0.012-0.0238,0.0459-0.029,0.0579-0.002,0.006,0.002,0.0232,0,0.0289-0.002,0.012-0.00088,0.0473,0,0.0579,0.00092,0.006-0.00094,0.0238,0,0.0289,0.002,0.006-0.002,0.0238,0,0.0289,0.002,0.006,0.0266,0.0236,0.029,0.0289,0.002,0.006-0.002,0.0236,0,0.0289,0.012,0.0214,0.0414,0.0653,0.0582,0.0868,0.004,0.006,0.0242,0.0236,0.029,0.0289,1.1986,1.3133,9.5504,3.1219,9.8019,5.3793,0.00092,0.01-0.00068,0.02,0,0.0289,0.004,0.12056-0.0334,0.2632-0.0874,0.37598-1.052,2.0283-11.016,2.8911-11.431,4.8009-0.006,0.0327-0.029,0.0824-0.029,0.11578-0.00002,2.1323,50.125,12.524,63.523,23.715s-39.382-13.333-39.382-13.333,2.9477,3.995,0,5.0612c-2.9477,1.0652-13.419-14.92-30.569-5.0612-3.1236,4.0563,14.974,7.2758,19.575,7.7218-1.5711,4.0166-2.9411,5.3453,3.4903,9.3415,0.70332,0.43718,1.0982,0.7013,1.2507,0.83872,0.004,0.004,0.025,0.0248,0.0292,0.029l0.029,0.029c0.002,0.002-0.00092,0.0264,0,0.029-0.00058,0.002,0.00092,0.0276,0,0.029-0.002,0.0004-0.0256-0.00012-0.029,0-0.004-0.0002-0.0246,0.00048-0.0292,0-0.99616-0.155-12.55-6.0591-13.758-6.3048-0.012-0.002-0.0492,0.00072-0.0582,0-0.004,0.00022-0.0262-0.00054-0.029,0,0,0.53304,1.3379,6.941,1.3379,6.941-5.9372-4.7958-13.114-6.2418-19.836-1.3303-0.01,0.28412-0.0592,4.8825,6.6897,7.7219-3.8039,7.7286,4.2986,5.329,17.161,12.523-19.116-4.9679-20.647,4.2602-6.9805,6.3915s51.19,3.4668,60.033,14.923c1.8653,2.4168,2.3715,3.632,2.0069,4.02-1.4749,1.3291-15.044-8.4295-17.015-8.7919-0.004,0.002-0.025-0.004-0.0292,0-0.004,0.004-0.025,0.0244-0.0292,0.029-0.025,0.0312-0.0624,0.093-0.0874,0.1446-0.48156,1.06-0.93074,5.6685-0.93074,5.6685-5.7166-3.2901-10.962-6.2414-17.8-7.6351-0.5361,1.0652-0.42372,2.5788-0.95982,3.644-6.2053-4.4496-11.611-7.578-20.622-8.0111-0.3574,1.4215-0.71878,2.8588-1.0762,4.2803,0.00002-0.00002-7.5122-9.3259-22.251,0-8.2296,5.8665,31.089,2.1242,37.52,9.0522,6.4314,6.9271,1.338,7.9822,1.338,7.9822-5.3592-1.9537-10.696-3.8883-16.055-5.842,0,0-19.044-3.4819-24.403,0.78086-5.3592,4.2636,78.243,14.658,80.654,26.116,1.626,6.2136-19.642-6.5065-38.044-11.973-0.7118,2.0339-1.4405,4.0684-2.1523,6.1023-0.43642-0.4293-7.5548-7.3139-15.532-8.5027-0.002,0.004-0.027,0.0222-0.0292,0.029-0.00094,0.01,0.00024,0.0448,0,0.058,0.012,0.87446,1.6288,7.1145,1.6288,7.1145-0.00002,0.00002-20.613-9.6029-31.063-4.5406-10.451,5.0623,36.433,7.726,40.72,12.523,0.46888,0.52454,0.66404,0.90692,0.63988,1.1569-0.008,0.0432-0.0374,0.109-0.0582,0.1444-1.0356,1.5081-15.017-4.0618-16.404-1.3014-1.6083,3.1975-24.38-5.8533-24.112-1.5907,0.26804,4.2636,3.2285,6.6518,3.2285,6.6518-0.00002,0,47.43,4.5269,49.038,10.122,1.6074,5.5954-26.264-3.1813-26.264-3.1813s-2.6961,3.9772-0.55262,5.842c0.0838,0.0728,0.1506,0.1426,0.1744,0.1734,0.0007,0.002-0.00016,0.0274,0,0.029-0.002-0.00064-0.0254,0.00092-0.0292,0-0.96878-0.31776-16.07-10.153-14.601-2.6029-5.9093-2.3396-21.166-9.5864-19.022-3.9911,2.112,5.5131,41.905,13.363,43.076,13.593-1.0523,0.0824-17.881,1.4824-17.102,5.871-22.555-13.663-22.502-5.4696-21.989-4.8298,0.00092,0.00088-0.00094,0.0282,0,0.029-1.2671-0.1992-29.016-7.073-6.9515,4.8009,11.833,6.3674,14.717,8.8497,14.776,9.8042,0.00038,0.021,0.002,0.0672,0,0.0868-0.004,0.0254-0.0202,0.064-0.029,0.0868-0.002,0.006-0.0262,0.0236-0.0292,0.029-0.01,0.016-0.018,0.0434-0.029,0.0578-0.004,0.004-0.025,0.0244-0.0292,0.029-0.004,0.004-0.0244,0.0248-0.0292,0.029-0.004,0.004-0.024,0.025-0.029,0.029-0.006,0.004-0.0236,0.0252-0.0292,0.029-0.45872,0.2918-1.5672,0.1696-1.8906,0.1734-0.014,0.0005-0.0482-0.00092-0.0582,0-0.006,0.002-0.028,0.026-0.029,0.029l0.029,0.029c0.3148,0.46536,2.046,5.1646,1.9487,5.9866-0.002,0.014-0.0256,0.0472-0.0292,0.0578-0.002,0.004,0.002,0.0248,0,0.029-0.00092,0.002-0.0276-0.002-0.0292,0-0.002,0.00092,0.002,0.028,0,0.029-0.002,0.00052-0.027-0.00036-0.0292,0-0.002-0.00024-0.026,0.00048-0.0292,0-0.96696-0.24222-15.581-8.0078-20.593-8.5316-5.0921-0.5331-29.215,6.6534-3.4903,17.844s41.526-2.6693,55.728-1.0701c14.202,1.5983,20.914,4.0015,19.575,8.5317-1.3403,4.5293-14.528-14.85-28.388,1.9088-15.766-3.1022-26.462-4.8974-18.324,6.6229-25.747-9.5675-41.47,2.9189-9.0456,7.9822,31.862,0.93378,51.452-7.7219,51.452-7.7219,0,0.00002,5.375,9.878,13.147,2.9499,7.4065-6.6024,7.9891,1.8005,8.2603,2.6029,0.004,0.012,0.025,0.0222,0.0292,0.029,0.002,0.002-0.002,0.0278,0,0.029,0.002,0,0.026,0.0004,0.029,0,0.57222-0.143,7.475-3.2102,7.475-3.2102,0.62546,0.00002,1.2651,0,1.8906,0v63.944c8.6643,0.0888,17.309,0.1714,25.973,0.2603,0,0-8.3071-55.674-3.752-63.134,4.4136-7.2271,8.5863-6.447,8.842-6.3915,0,0,16.885,5.051,18.76,4.2514,0.0218-0.01,0.0664-0.018,0.0874-0.029,0.014-0.008,0.045-0.021,0.0582-0.029,0.0326-0.0206,0.0866-0.0628,0.1164-0.0868,0.006-0.004,0.0232-0.024,0.0292-0.029,1.3722-1.2456-0.0258-6.1609,8.5512-5.4082,2.6483-0.95788,1.6378-5.1559,3.3448-6.1891,0.0302-0.018,0.0846-0.0424,0.1164-0.0578,0.0644-0.0302,0.161-0.065,0.23268-0.0868,0.1-0.0286,0.23388-0.0462,0.34902-0.0578,2.6796-0.26652,54.392,14.376,65.646,0.52058-2.9477-7.7267-13.143-0.52682-15.823-0.2603-2.4116,0.00002-12.602-4.7958-18.498,0-5.3592-3.9962-29.726-6.6518-29.726-6.6518-3.2157-3.1975,58.149,1.5881,61.632-0.80978,7.2347-7.1946-13.392-6.389-16.608-3.9911-5.7166-3.464-12.9-3.2077-17.277-0.80976-2.0988-4.992-22.024-2.8299-33.099-4.2514-3.5452-2.0675-2.9549-3.2542-0.55262-4.5406,23.134,0.97728,46.151,3.9809,69.398,2.9499,6.2834-8.145-7.9101-11.217-16.608-4.2803-5.1061-8.3496-15.545-0.2714-22.512-1.0701-6.9666-0.79962-3.7521-9.3139,5.09-7.9822,8.843,1.3327,24.655-0.5435,27.602-4.5406,2.9467-3.9962-1.7596-8.0449-16.346-4.2514-4.9367-4.7976-15.792-0.008-20.884,1.5907-6.7739-3.7574-22.534-0.52288-27.893,0.80978-5.2466-3.2428,27.602-8.5316,27.602-8.5316,12.679-0.22304,19.831-2.4044,23.85-3.4705,19.168-10.215-0.26688-11.3-10.325-3.8754-6.2434-4.8467-12.173,0.41904-17.8,2.2848-5.2756,1.7483-15.032,3.0217-16.23,2.5161-0.014-0.006-0.0468-0.0218-0.0582-0.029-0.002-0.002-0.0262-0.0264-0.0292-0.029l-0.029-0.029c-0.00092-0.002,0.00064-0.026,0-0.029,0-0.002-0.00046-0.0256,0-0.029,0.004-0.012,0.0208-0.044,0.029-0.0578,0.79028-1.2183,15.241-10.036,15.241-10.036,0-0.00002,18.76-1.3468,22.512-1.8798,2.2862-0.32486,10.299-4.0965,10.296-5.495-0.0672-0.86806-3.4056-0.78834-13.525,1.7642-9.111,0.79958-14.462,0.28294-17.946,0.54946-5.6028-0.57596-7.9633-1.1632-8.4348-1.6774-0.018-0.0218-0.047-0.0652-0.0582-0.0868-0.0392-0.0928-0.014-0.20012,0.0582-0.28922,0.018-0.0206,0.0634-0.0664,0.0874-0.0868,1.3734-1.0907,10.238-1.8799,10.238-1.8799,0,0.00002,27.063-2.4678,28.853-3.8754,0.006-0.006,0.0234-0.0234,0.029-0.029,0.01-0.012,0.0228-0.0468,0.029-0.0578,0.002-0.006,0.0276-0.0236,0.0292-0.029,0.55686-11.002-22.959-5.9217-23.588-5.842,0.0672-7.7363-21.224-0.1136-22.221,0-0.002-0.00028-0.0278,0.00052-0.0292,0-0.91604-0.53664-1.3153-1.1029-1.3961-1.6196-0.0262-0.197-0.00092-0.41868,0.0582-0.60734,0.53332-1.5952,3.752-2.8342,3.752-2.8342,5.8953-1.4206,14.71-1.8641,17.015-3.7308,0,0,16.639-0.1456,18.615-4.5406-4.0831-11.201-35.213,1.9828-39.382,3.9911-0.8353,0-1.3468-0.20866-1.5997-0.5495-1.3688-1.9886,5.3863-8.5371,5.6135-8.763,0.002-0.002,0.0238-0.0268,0.029-0.029,1.0295-0.29038,25.884-1.5549,37.753-17.555,0.83768-9.8933-14.194,5.5817-14.194,5.5817-1.1225-12.831-16.345,0.81374-25.188,1.8799-8.8421,1.0652-9.101-4.0012-2.9377-4.8009,6.1624-0.79868,13.124-0.2758,16.608-9.6017,3.4829-9.3259,13.947,0.54304,15.823-2.921,1.8169-3.3558-3.4237-6.2163-3.752-6.3915,0.00002,0,7.7656-8.0173-4.8282-7.7508-12.467,0.26386-28.585-1.5536-28.911-1.5906,0.78186-0.29674,13.48-5.0591,25.421-4.8009,12.327,0.26652,5.6245-8.792-6.1662-8.792-11.79,0-17.946-3.9911-17.946-3.9911,6.6995-2.4867,13.399-4.9749,20.098-7.4616-0.44678-1.8648-0.89122-3.7169-1.338-5.5817,0,0,11.786-9.3326-4.8282-7.2013-16.614,2.1323-18.498,2.4004-18.498,2.4004-0.00002,0-32.705,4.9833-33.478,5.0612-0.002,0-0.026,0.00034-0.0292,0-0.31656-0.0493-3.5559-1.0501-4.1592-2.2848-0.018-0.0405-0.0456-0.1036-0.0582-0.14452-0.014-0.0493-0.0244-0.12356-0.0292-0.17346-0.004-0.0583-0.01-0.14332,0-0.20244,0.135-0.65065,1.1438-1.3542,3.723-1.9955,8.5749-2.1314,38.87-8.251,43.425-6.6518,0.58728,0.20602,1.016,0.15948,1.2798-0.0579,1.708-1.5368-3.9744-11.338-17.917-12.725-16.078-1.5983-25.973,3.9911-25.973,3.9911s-10.462-3.7435-0.8144-6.941c9.6462-3.1966,24.926,1.0701,24.926,1.0701-0.00002,0,17.14-5.07,2.9376-7.2013-14.202-2.1323-18.68,1.9171-25.188,2.1402-2.5977-3.2243,22.297-3.9855,23.85-6.6518-2.6256-4.7976-18.028,0-27.05,0-3.8374-1.6186-4.0913-4.2523,0.26178-5.8709,9.2004-0.35538,17.849,0.18184,27.05-0.17346-0.26804-4.8846,0.006-10.675-0.26176-15.559-11.67-2.1203-25.355,1.5527-31.907,1.2436,1.7526-5.3298,26.949-6.7055,29.755-8.1557,5.7892-7.1953-24.167-0.11118-24.897,0-5.3173-0.78111-4.9953-4.123-1.6288-6.1312,7.7707-0.88844,25.197,1.1323,23.879-4.1068-1.0098-4.9093-12.082-2.2808-16.637-1.2147-4.555,1.0652-11.256,0.26028-11.256,0.26028-2.917-3.905,26.27-2.3089,26.003-5.3214-0.38064-3.4587-18.501-1.0763-24.665-0.8098-4.7404-3.2522,22.286-5.4145,23.559-5.842,0.006-0.004,0.0256-0.02594,0.0292-0.02894,1.0099-8.8575-18.76,0-22.512,0-0.64484,0-1.1329-0.16008-1.4834-0.43382-0.0782-0.06328-0.167-0.1577-0.2327-0.23136-1.288-1.4941-0.1454-4.9166-0.1454-4.9166s7.0453-3.1479,7.475-3.9043c0.002-0.006,0.027-0.02316,0.0292-0.02894,0.00086-0.002-0.00062-0.02616,0-0.02894-0.00008-0.002,0.00032-0.02654,0-0.02894-0.002-0.004-0.0262-0.02456-0.0292-0.02894-0.016-0.02236-0.0552-0.06068-0.0874-0.08682-0.82702-0.63325-5.673-2.2317-6.3115-2.2848-0.004-0.00022-0.025,0-0.0292,0-0.004-0.0015-0.0252-0.02674-0.029-0.02894-0.008-0.006-0.0222-0.02036-0.0292-0.02894-0.004-0.004-0.0258-0.02336-0.0292-0.02894-0.365-0.74486,0.0874-6.0445,0.0874-6.0445s5.5825-4.1597,5.9335-5.8131c0.002-0.014-0.002-0.04452,0-0.05788,0.002-0.014-0.00068-0.04512,0-0.05788,0.0003-0.012,0.0005-0.0455,0-0.05788-0.00088-0.012,0.002-0.0461,0-0.05788-0.00092-0.006,0.00092-0.02336,0-0.02894-0.004-0.016-0.0228-0.04232-0.0292-0.05788-0.002-0.006,0.002-0.02376,0-0.02894-0.002-0.004-0.0264-0.02396-0.0292-0.02894-0.006-0.01-0.0226-0.02-0.0292-0.02894-0.01-0.014-0.018-0.0455-0.029-0.05788-0.004-0.004-0.0246-0.02496-0.0292-0.02894-0.0224-0.018-0.0604-0.04152-0.0874-0.05788-0.012-0.006-0.0464-0.02296-0.0582-0.02894-1.4099-0.67313-7.2423,1.3304-7.2423,1.3304-0.00002-1.7763,0-3.5451,0-5.3215-0.00002,0,5.1065-0.55195,5.6426-2.9499,0.0314-0.14052,0.016-0.27865,0-0.4049-0.008-0.0501-0.014-0.12556-0.0292-0.17346-0.0332-0.103-0.0834-0.22493-0.1456-0.31813-0.01-0.014-0.0476-0.04392-0.0582-0.05788-1.1684-1.4997-5.9335-1.7063-5.9335-1.7063-0.89348-9.3256-1.7823-18.641-2.6759-27.966zm-4.77,91.332,0,3.673c0.00002,0-6.0093-0.30606-7.126-1.2436-0.006-0.004-0.0244-0.0244-0.0292-0.0289-0.004-0.004-0.0246-0.0242-0.0292-0.0289-0.004-0.004-0.025-0.0242-0.0292-0.0289-0.004-0.004-0.0254-0.0242-0.0292-0.0289-0.01-0.014-0.0216-0.0431-0.0292-0.0579-0.002-0.004,0.002-0.024,0-0.0289-0.002-0.004-0.0276-0.024-0.029-0.0289-0.00092-0.004,0.00088-0.024,0-0.0289-0.00092-0.01,0.0001-0.0475,0-0.0579,0.00022-0.006-0.0005-0.0238,0-0.0289,0.0008-0.006-0.00092-0.0236,0-0.0289,0.006-0.0214,0.018-0.0649,0.029-0.0868,0.002-0.006,0.026-0.0234,0.0292-0.0289,0.014-0.0224,0.0392-0.0641,0.0582-0.0868,0.006-0.006,0.0236-0.0232,0.0292-0.0289,0.012-0.012,0.0454-0.0461,0.0582-0.0579,0.0402-0.0353,0.0928-0.079,0.1454-0.11578,2.0161-1.4035,6.0415-1.3704,6.8351-1.5906,0.006-0.002,0.023,0.002,0.0292,0,0.006-0.002,0.024-0.0267,0.029-0.0289,0.004-0.002,0.0254,0.002,0.0292,0,0.004-0.002,0.0262-0.0265,0.0292-0.0289zm8.5221,4.8876c0.20764,0,11.97,0.1006,13.001,1.6196,0.008,0.012,0.0226,0.0447,0.0292,0.0579,0.008,0.02,0.0242,0.0665,0.0292,0.0868,0.002,0.014-0.00072,0.0439,0,0.0579-0.00014,0.021,0.004,0.0655,0,0.0868-0.006,0.0216-0.02,0.0647-0.0292,0.0868-0.89816,1.8972-12.798,3.0367-12.798,3.0367l-0.23268-5.0322zm-0.66898,7.2591c0.004,0.002,0.0248-0.002,0.029,0,0.004,0.002,0.0232-0.002,0.0292,0,0.69832,0.18344,5.5701,0.34048,6.1662,1.1568,0.006,0.008,0.0246,0.0212,0.0292,0.0289,0.002,0.004-0.002,0.025,0,0.0289,0.004,0.008,0.0264,0.0208,0.0292,0.0289,0.00092,0.004-0.00086,0.025,0,0.0289,0.00044,0.004-0.00026,0.0248,0,0.0289,0.00002,0.004,0.00016,0.0247,0,0.0289-0.0004,0.004,0.00058,0.0246,0,0.0289-0.0008,0.004,0.00092,0.0246,0,0.0289-0.002,0.004-0.0276,0.0244-0.0292,0.0289-0.002,0.004,0.002,0.0244,0,0.0289-0.008,0.014-0.02,0.0439-0.0292,0.0579-0.004,0.004-0.0256,0.0242-0.0292,0.0289-0.004,0.004,0.004,0.0242,0,0.0289-1.0099,1.2272-5.5056,1.5618-5.7299,1.5618-0.002-0.0004-0.0274,0.00074-0.0292,0-0.002-0.00092,0.002-0.0275,0-0.0289-0.004-0.006-0.0254-0.0226-0.029-0.0289-0.20552-0.4149-0.40722-3.0656-0.40722-3.0656zm-35.863,9.6596c3.8405-0.1984,11.462,0.70093,25.77,4.6274,0,0.30278,0.28972,3.9918,0.1744,4.5984-0.00092,0.004-0.0278,0.0246-0.0292,0.0289-0.00092,0.004,0.00094,0.0261,0,0.0289-0.002,0.002-0.0258,0.0285-0.0292,0.0289-0.2243-0.11198-26.031-7.4859-28.388-7.3748-0.0644,0.002-0.1424,0.006-0.2036,0-0.052-0.006-0.1256-0.018-0.1744-0.0289-0.0642-0.016-0.1472-0.0611-0.20358-0.0868-0.0208-0.01-0.0678-0.018-0.0874-0.0289-0.006-0.004-0.0228-0.025-0.0292-0.0289-0.0784-0.0529-0.1562-0.13314-0.20358-0.20244-0.004-0.006-0.0258-0.0234-0.0292-0.0289-0.006-0.012-0.0238-0.0465-0.029-0.0579-0.002-0.006,0.002-0.023,0-0.0289-0.004-0.012-0.0264-0.0459-0.0292-0.0579-0.00092-0.006,0.00092-0.0228,0-0.0289-0.00092-0.012,0.0003-0.0453,0-0.0579,0.00024-0.012-0.00092-0.0451,0-0.0579,0.004-0.0321,0.018-0.0828,0.0292-0.11578,0.0318-0.079,0.097-0.18084,0.1744-0.26028,0.39462-0.38378,1.3829-0.76932,3.2867-0.86764zm13.379,10.903c4.1136-0.14672,13.969,2.211,14.514,2.0823-0.00002,0.78143,0.4361,4.475-0.0582,5.2347-0.004,0.006-0.0242,0.023-0.0292,0.0289-0.004,0.006-0.024,0.024-0.0292,0.0289-0.006,0.004-0.0238,0.0251-0.0292,0.0289-0.01,0.006-0.0466,0.0244-0.0582,0.0289-0.006,0.002-0.0228-0.00092-0.0292,0-0.012,0.00092-0.045,0.00092-0.0582,0-0.006-0.00092-0.022,0.002-0.0292,0-0.83768-0.20822-15.382-4.8016-15.939-6.6807-0.008-0.0309-0.00066-0.0862,0-0.11578,0.006-0.0655,0.038-0.14552,0.0874-0.20244,0.006-0.006,0.0224-0.023,0.0292-0.0289,0.006-0.006,0.022-0.023,0.0292-0.0289,0.27922-0.22006,0.85536-0.34943,1.5997-0.37597zm40.487,10.122c3.9283-0.0764,6.7017,0.25803,5.6717,1.446-2.8052,3.2354-22.192,5.8999-22.192,5.8999l-0.34902-5.8999c0.41636-0.0609,10.267-1.3177,16.87-1.446zm-55.495,18.394c3.2967-0.17446,10.974,1.6257,28.068,8.8209l0.1164,4.2514c0.00002,0-28.948-8.73-29.958-10.18-0.49704-0.71379-1.421-2.7229,1.7742-2.8921zm56.717,6.3337c0.88072-0.0445,1.5006,0.0441,1.716,0.26028,0.006,0.006,0.0244,0.0228,0.029,0.0289,0.012,0.02,0.0222,0.0657,0.0292,0.0868,0.004,0.0218,0.0296,0.0631,0.0292,0.0868-0.012,0.12196-0.104,0.28623-0.26178,0.46274-2.6936,3.0133-17.161,6.0155-17.161,6.0155s-0.00002-3.7923,0-3.9043c0.002,0.0002,0.026-0.00004,0.0292,0,0.65948-0.0224,11.279-2.8188,15.59-3.0367zm-63.465,0.52057c4.3217-0.22785,14.08,2.0514,35.95,12.349-0.00002,0.1068,0.1948,3.6583,0.1162,3.9911-0.002-0.00042-0.0262,0.00082-0.0292,0-1.2966-0.41556-39.353-13.708-39.353-13.708-0.0406-0.14572-0.61308-2.4246,3.3158-2.6318zm72.452,16.63c1.1059-0.0462,1.8315,0.049,2.0069,0.2892,0.016,0.0278,0.027,0.0836,0.0292,0.1158-0.004,0.1156-0.1006,0.26294-0.29088,0.4338-3.451,3.099-25.453,6.8535-26.235,6.9121-0.004,0-0.0258,0.00044-0.0292,0-0.002-0.00092-0.026,0.002-0.029,0-0.002-0.002-0.0264-0.0262-0.0292-0.029-0.008-0.01-0.023-0.0438-0.0292-0.0578-0.002-0.006,0.002-0.0236,0-0.029-0.004-0.012-0.0262-0.0448-0.0292-0.0578-0.1398-0.7183,0.31564-3.2338,0.34902-3.5862,0.00032-0.006,0-0.0254,0-0.029,0.00092,0.00092,0.027-0.00092,0.0292,0,0.004,0.00068,0.0242,0.0286,0.029,0.029,0.006,0.00028,0.0226-0.00008,0.0292,0,1.4083-0.0234,18.27-3.7446,24.199-3.9911zm-64.686,9.6885c6.5501-0.33646,26.397,8.7127,27.37,8.9944,0.002,0.0005,0.0272-0.00006,0.0292,0-0.102,0.40426-0.1188,3.6714-0.20358,4.1935-0.002,0.014,0.002,0.0502,0,0.0578-0.0008,0.002-0.0284-0.0009-0.0292,0-0.53504-0.28494-27.736-11.51-28.94-10.614-0.75036-1.7681,0.0276-2.5421,1.7742-2.6318zm58.52,2.3715c1.3629-0.0596,2.3605,0.00064,2.6759,0.1734,0.0382,0.024,0.0732,0.0576,0.0874,0.0868,0.002,0.004-0.00092,0.0238,0,0.029,0.00024,0.006,0.00048,0.0236,0,0.029-0.002,0.012,0.006,0.0462,0,0.0578-0.004,0.006-0.0248,0.0228-0.0292,0.029-0.02,0.0254-0.0556,0.0588-0.0874,0.0868-2.0197,1.7852-20.767,5.466-20.767,5.466s-0.0874-3.4536-0.0874-3.7886c0.53248-0.1132,12.635-1.9246,18.208-2.1691zm-1.5125,11.944c1.3191-0.0436,2.2543,0.0312,2.4723,0.26028l0.029,0.029c0.006,0.01-0.002,0.0472,0,0.0578,0.0009,0.006,0.0288,0.0234,0.0292,0.029-0.00028,0.006-0.0282,0.0232-0.0292,0.029-0.002,0.012,0.006,0.0452,0,0.0578-0.004,0.006-0.0252,0.0224-0.029,0.029-0.016,0.0262-0.0348,0.0596-0.0582,0.0868-0.018,0.0206-0.064,0.0658-0.0874,0.0868-2.0235,1.7366-17.917,5.0611-17.917,5.0611s-0.43628-3.7923-0.43628-3.9043c0.44088,0.01,11.067-1.6583,16.026-1.822zm-67.071,0.95438c3.8347-0.24108,13.337,1.3301,36.793,9.8042l0.78532,4.5695c0,0.00002-39.055-12.536-40.167-12.928,0.002,0-0.00084-0.0258,0-0.029,0.00092-0.0242-0.006-0.0828,0-0.1448,0.014-0.1148,0.0724-0.2955,0.20358-0.46276,0.27524-0.33548,0.90404-0.71664,2.385-0.80976zm51.452,9.9199c0.47064,0.1,7.0193,0.31614,8.2312,1.3304,0.006,0.004,0.0238,0.0242,0.0292,0.029,0.004,0.004,0.0242,0.024,0.0292,0.029,0.004,0.004,0.025,0.024,0.0292,0.029,0.012,0.016,0.02,0.0426,0.0292,0.0578,0.002,0.006,0.0264,0.0238,0.029,0.029,0.01,0.021,0.0238,0.0652,0.0292,0.0868,0.00092,0.006-0.00082,0.0234,0,0.029,0.00054,0.006-0.00024,0.0234,0,0.029-0.00004,0.012,0.00092,0.0466,0,0.0578-0.0009,0.006,0.00092,0.0232,0,0.029-0.002,0.012-0.025,0.046-0.0292,0.0578-0.002,0.006,0.002,0.023,0,0.029-0.006,0.012-0.0218,0.0458-0.029,0.0578-1.0099,1.5622-7.8531,2.1402-7.8531,2.1402s-0.33622-3.0612-0.49446-4.02zm15.852,8.9076c1.5249-0.0364,2.6194,0.1372,2.8504,0.5784,0.13,0.29904-0.1202,0.74078-0.84346,1.3304-5.6105,4.5746-17.83,5.466-17.83,5.466v-5.0322c0.002,0.00024,0.0234,0.00038,0.0292,0,0.69412-0.082,10.731-2.2219,15.794-2.3426zm15.561,4.6852c1.9368-0.073,2.7713,0.24986,3.0249,0.6941,0.0204,0.0394,0.0464,0.1032,0.0582,0.1448,0.018,0.0752,0.0354,0.18,0.0292,0.26032-0.0624,0.57318-0.68666,1.26-1.1634,1.7063-1.908,1.7852-32.314,11.366-32.314,11.366s-0.22894-6.355-0.1164-6.9121c17.777-5.357,26.472-7.1081,30.482-7.2591zm-19.662,17.989c1.9331-0.0716,3.4447,0.042,3.8975,0.49162,0.0278,0.0298,0.0688,0.0828,0.0874,0.1158,0.01,0.0202,0.0224,0.0654,0.029,0.0868,0.006,0.0216-0.002,0.064,0,0.0868,0.00094,0.0386,0.01,0.1026,0,0.1448-0.022,0.0852-0.0806,0.19-0.1456,0.28922-2.6014,2.5386-15.241,2.921-15.241,2.921v-3.1524c2.3735-0.0796,7.6569-0.84556,11.372-0.9833zm12.652,5.1768c0.60092-0.014,0.96738,0.083,1.018,0.2603,0.002,0.014,0.002,0.043,0,0.0578-0.0304,0.1476-0.20694,0.37124-0.58172,0.63624-5.0493,3.5695-24.025,7.2302-24.025,7.2302s0.23512-2.4946,0.34902-3.0945c0.5278-0.008,18.699-4.9795,23.239-5.0901zm10.645,3.9622c2.236-0.021,3.9426,0.30708,4.9155,1.0122,0.002,0,0.0274-0.00048,0.0292,0,0.00072,0.002-0.00054,0.0258,0,0.029,0.00034,0.004-0.00016,0.025,0,0.029-0.00046,0.01,0.00092,0.0464,0,0.0578-0.0952,0.69158-1.5167,3.945-6.5152,5.3504-6.2343-0.5537-32.693,7.2241-33.216,7.3459-0.002-0.002-0.0278,0.002-0.029,0-0.002-0.01,0.00092-0.0434,0-0.0578-0.014-0.49822,0.34904-3.1813,0.34902-3.1813,9.1205-5.4234,25.695-10.503,34.466-10.585zm-67.74,15.27c0.0584-0.00092,0.1124-0.0002,0.1744,0,11.445,1.2272,15.72,5.4873,16.928,7.2013-2.2821,3.982-20.37-4.9484-18.469-6.8542,0.21758-0.1932,0.6654-0.33254,1.367-0.34706zm65.588,0.75196c0.45456-0.018,0.8697,0.0752,1.1634,0.26028,0.12,0.0798,0.2384,0.1944,0.31996,0.31812,0.1102,0.1776,0.1836,0.41798,0.2036,0.6941-1.1956,1.837-7.3791,1.0351-7.7659,0.9833,0.3115-0.1104,3.8818-2.1726,6.0789-2.2558zm-24.519,12.378c0.84862-0.0348,1.5537,0.0504,1.9487,0.28918,0.0478,0.0308,0.1076,0.0794,0.1454,0.1158,0.012,0.012,0.0474,0.0446,0.0582,0.0578,0.016,0.02,0.0454,0.0652,0.0582,0.0868,0.012,0.022,0.02,0.0632,0.0292,0.0868,0.072,0.21614,0.044,0.51458-0.1454,0.86762-1.7954,3.3474-9.6564,2.1112-9.6564,2.1112v-2.3426c0.002,0.00066,0.0272-0.00054,0.029,0,0.44278,0.0374,4.7752-1.1598,7.5332-1.2725zm-46.304,8.8209c2.4185-0.1214,4.5324,1.4562,6.7479,2.7185,4.9367-1.0041,15.066,0.78088,15.066,0.78088v4.4538c0,0.004-0.0228,0.0258-0.0292,0.029-0.004,0.002-0.023-0.002-0.029,0-0.92204,0.1596-12.793-0.3561-15.444-2.0244-2.1624,0-8.284-3.2125-8.7548-4.8587-0.004-0.014-0.0262-0.0442-0.0292-0.0578-0.004-0.0204,0.002-0.0668,0-0.0868-0.00066-0.014-0.00026-0.045,0-0.058,0.00068-0.012-0.002-0.0456,0-0.0578,0.00092-0.006-0.00094-0.0228,0-0.029,0.002-0.012,0.0252-0.0462,0.0292-0.0578,0.002-0.006-0.002-0.0232,0-0.029,0.84598-0.44826,1.6703-0.68424,2.4432-0.72302zm51.918,2.198c1.8569-0.0994,2.6442,0.47132,1.1925,2.5161-4.0394,5.6898-14.485,3.3548-14.485,3.3548l-0.43628-3.5284c3.6843,0.143,10.418-2.1652,13.728-2.3426zm-39.033,11.539c4.2236-0.1958,8.8129,1.475,8.8129,1.475,0.1082,0.21432,2.27,4.4517,0.34904,5.8709-0.0714,0.0512-0.1498,0.1014-0.23268,0.1446-2.3567,1.2272-13.62-0.95902-14.281-5.466,1.3254-1.3911,3.289-1.9289,5.3517-2.0245zm-43.541,2.198c3.8627-0.23048,8.1774,2.1356,8.6675,2.3715,0.006,0.002,0.0254-0.00092,0.029,0,0,0.1334-0.1454,4.2803-0.1454,4.2803s-7.6465-2.1195-10.064-6.3915c0.48468-0.1314,1.0023-0.22986,1.5125-0.2603zm73.558,0.57842c4.3081-0.0272,9.5129,0.97916,10.267,2.4294,0.1426,0.2966,0.1002,0.62358-0.1744,0.9544-2.1323,2.5654-14.252,0.23136-14.252,0.23136v-3.1234c1.0783-0.31364,2.5636-0.4816,4.1592-0.49168z'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 3'%3E %3Crect width='6' height='3' fill='%23008751'/%3E %3Crect x='2' width='2' height='3' fill='%23FFF'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 1000 600'%3E %3Cdefs%3E %3ClinearGradient id='cap1' gradientUnits='userSpaceOnUse' x1='498.738' y1='289.055' x2='500.626' y2='283.42'%3E %3Cstop stop-color='%23510000' offset='0'/%3E %3Cstop stop-color='%238a0000' offset='0.3'/%3E %3Cstop stop-color='%23a00' offset='1'/%3E %3C/linearGradient%3E %3ClinearGradient id='cap2' gradientUnits='userSpaceOnUse' x1='501.444' y1='291.373' x2='502.927' y2='287.449'%3E %3Cstop stop-color='%23ff2a2a' offset='0'/%3E %3Cstop stop-color='%23f00' offset='1'/%3E %3C/linearGradient%3E %3ClinearGradient id='mountain' gradientUnits='userSpaceOnUse' x1='484.764' y1='311.709' x2='484.764' y2='317.647'%3E %3Cstop stop-color='%23F5F549' offset='0'/%3E %3Cstop stop-color='%2397C924' offset='1'/%3E %3C/linearGradient%3E %3ClinearGradient id='seafgrad'%3E %3Cstop stop-color='%23025' offset='0'/%3E %3Cstop stop-color='%2304a' offset='0.5'/%3E %3Cstop stop-color='%23025' offset='1'/%3E %3C/linearGradient%3E %3ClinearGradient id='seabgrad' xlink:href='%23seafgrad' gradientUnits='userSpaceOnUse' x1='444.509' y1='317.486' x2='634.411' y2='317.486'/%3E %3CclipPath id='shield'%3E %3Cpath fill='%23000' d='m500,226.375 -63.7015,110.332h127.401z'/%3E %3C/clipPath%3E %3C/defs%3E %3Crect width='1000' height='600' fill='%230067C6'/%3E %3Crect width='1000' height='200' y='200' fill='%23fff'/%3E %3Cg id='text' fill='%23c8a400'%3E %3Cpath d='m410,299.329c3.32634,0.22223,6.65268,0.44445,9.97902,0.66668,0.0329-0.48587,0.064-0.97205,0.0981-1.45773-1.30824-0.0873-2.61644-0.17511-3.92471-0.26198,0.0986-1.60327,0.23297-3.20473,0.3036-4.80942,1.38833-1.00412,2.77759-2.00697,4.16149-3.01719,0.0412-0.61599,0.0823-1.23197,0.12346-1.84796-1.46281,1.06196-2.92562,2.12393-4.38843,3.18589-0.14757-1.03794-0.72165-2.10727-1.76463-2.46788-0.91323-0.33059-2.03168-0.3884-2.82311,0.26424-1.00326,0.738-1.18359,2.05857-1.31388,3.20783-0.17463,2.17695-0.29658,4.35998-0.45091,6.53752zm1.51943-1.36222c0.12006-1.63759,0.19451-3.27916,0.35147-4.91355,0.12284-0.80837,0.27116-1.7421,0.97877-2.25692,0.63951-0.42451,1.58455-0.10865,1.84624,0.61403,0.52201,1.24667,0.29033,2.62159,0.22338,3.93021-0.0632,0.94689-0.12655,1.89378-0.18977,2.84068-1.06985-0.0707-2.14151-0.14232-3.21009-0.21445z'/%3E %3Cpath d='m411.299,284.006c3.24602,0.75791,6.49205,1.51582,9.73807,2.27373,0.73769-3.1594,1.47537-6.31879,2.21306-9.47819-0.4612-0.10769-0.92241-0.21537-1.38361-0.32306-0.62753,2.68761-1.25507,5.37521-1.8826,8.06282-0.98811-0.2308-1.97626-0.4614-2.96437-0.69221,0.56551-2.42194,1.13101-4.84387,1.69651-7.26581-0.45886-0.10714-0.91773-0.21428-1.37659-0.32142-0.5655,2.42194-1.13099,4.84388-1.69649,7.26582-0.87427-0.20424-1.7486-0.40821-2.62286-0.61249,0.60401-2.58683,1.208-5.17367,1.812-7.7605-0.46355-0.10824-0.92711-0.21647-1.39066-0.32471-0.71415,3.05867-1.42831,6.11735-2.14246,9.17602z'/%3E %3Cpath d='m414.807,270.929c3.14837,1.09493,6.29675,2.18986,9.44512,3.28479,0.15992-0.45982,0.31983-0.91964,0.47975-1.37946-1.2384-0.4307-2.47682-0.86135-3.71521-1.29209,0.48491-1.42877,1.01619-2.8425,1.46212-4.28396,0.31982-1.1769,0.56684-2.55272-0.12567-3.64707-0.56233-0.80874-1.56218-1.32766-2.54938-1.29642-1.08858,0.0466-1.97544,0.84759-2.45833,1.77548-0.71429,1.34208-1.11369,2.81798-1.63458,4.23987-0.30127,0.86629-0.60255,1.73257-0.90382,2.59886zm1.82516-0.91156c0.50573-1.41719,0.96234-2.85276,1.50949-4.25451,0.34032-0.74874,0.75526-1.63711,1.61685-1.87541,0.70884-0.16219,1.45167,0.38249,1.5132,1.10855,0.17309,1.3358-0.4107,2.59669-0.82087,3.83664-0.25986,0.74722-0.51973,1.49444-0.77958,2.24166-1.01301-0.35237-2.02604-0.70467-3.03909-1.05693z'/%3E %3Cpath d='m420.024,258.833c1.78079,1.03286,3.54652,2.09256,5.33751,3.10726,1.01015,0.54316,2.29139,0.85386,3.34732,0.24536,1.44062-0.79757,2.34305-2.27069,3.05103-3.70714,0.55788-1.21033,0.96223-2.71397,0.25161-3.95061-0.76525-1.23498-2.15613-1.80264-3.34366-2.54015-1.15241-0.67405-2.30482-1.34811-3.45723-2.02216-0.2446,0.4182-0.4892,0.83639-0.7338,1.25459,1.69411,0.99759,3.40038,1.97522,5.08648,2.98594,0.80638,0.49107,1.47446,1.38051,1.33556,2.36857-0.15909,1.178-0.83235,2.21182-1.50327,3.1639-0.5532,0.77126-1.48261,1.39382-2.46901,1.18523-1.02907-0.19727-1.86511-0.87054-2.7694-1.35707-1.13311-0.66277-2.26623-1.32553-3.39934-1.9883-0.24459,0.41819-0.48923,0.83643-0.7338,1.25458z'/%3E %3Cpath d='m427.227,247.062c2.64728,2.02559,5.29456,4.05117,7.94184,6.07676,1.2324-1.60897,2.45998-3.22252,3.70139-4.82374,0.71204-1.0218,1.36783-2.35063,0.88541-3.60415-0.43852-0.99742-1.46605-1.76954-2.56718-1.82076-0.49731-0.0682-1.14581,0.30822-1.41493,0.47419,0.28305-1.06581-0.58942-2.0679-1.57186-2.35041-1.18182-0.42013-2.38052,0.33763-3.16221,1.17835-0.9204,1.00107-1.68892,2.12852-2.53072,3.19463-0.42725,0.55838-0.85449,1.11675-1.28174,1.67513zm2.01433-0.29772c0.92943-1.19063,1.80918-2.42176,2.78303-3.57628,0.45282-0.50395,1.17935-1.07479,1.88161-0.70532,0.64009,0.27772,0.79787,1.08511,0.49233,1.66627-0.48521,1.03983-1.28618,1.88276-1.95401,2.80542-0.36367,0.47529-0.72737,0.95057-1.09102,1.42588-0.70398-0.53866-1.40796-1.07732-2.11194-1.61597zm3.23588,2.47597c0.96434-1.2336,1.87255-2.51286,2.89009-3.70336,0.51954-0.54354,1.17239-1.22856,1.99705-1.07233,0.70444,0.16212,1.21664,0.92689,0.97341,1.63628-0.39626,1.30911-1.37599,2.31142-2.16426,3.39599-0.4137,0.54068-0.82742,1.08134-1.2411,1.62203-0.81839-0.62621-1.6368-1.2524-2.45519-1.87861z'/%3E %3Cpath d='m436.231,236.455,6.8675,7.26894,5.88255-5.55767-0.97575-1.03279-4.70554,4.44565-0.12052,0.11387-0.0869-0.092-5.80486-6.14418z'/%3E %3Cpath d='m445.035,228.752,6.09535,7.92761,1.18915-0.91429-6.09535-7.92762z'/%3E %3Cpath d='m453.991,222.67c-0.98774,0.61544-1.78425,1.33504-2.39782,2.17554-0.6112,0.83726-0.94122,1.71049-0.98884,2.62241-0.0476,0.91165,0.19536,1.79452,0.73286,2.6572,0.49251,0.79046,1.15266,1.40385,1.97619,1.84418,0.82023,0.43856,1.70565,0.60098,2.67598,0.49235,0.96511-0.10804,2.05508-0.53501,3.26884-1.29126,1.16547-0.72616,1.99135-1.56229,2.50028-2.52478,0.48822-0.92337,0.62578-1.90365,0.41645-2.94732l-1.38296,0.5422c0.36225,1.99857-0.92658,2.9588-2.36991,3.87479-2.2587,1.37399-4.45973,1.27451-5.80828-0.78982-1.39827-2.32778,0.12974-4.25089,2.05166-5.49964,1.36386-0.85119,2.70794-1.43321,3.98724-0.61857l1.08262-0.9642c-0.74564-0.51452-1.59209-0.75257-2.55559-0.6994-1.01162,0.0558-2.06822,0.42819-3.18872,1.12632z'/%3E %3Cpath d='m465.808,216.773-1.047,11.2056,1.55741-0.62791,0.31478-3.47417,0.006-0.003,5.05831-2.03938,2.63645,2.28431,1.5574-0.62791-8.52648-7.34584-1.5574,0.62791zm1.36835,1.14857,3.32461,2.87791-3.72338,1.50118,0.39877-4.37909z'/%3E %3Cpath d='m487.726,210.591c0.20805,3.32683,0.41609,6.65367,0.62414,9.9805,1.80444-0.12174,3.6118-0.20647,5.41405-0.35597,1.4176-0.16233,2.93884-0.53067,3.9077-1.65878,1.2513-1.3881,1.42875-3.46194,0.88129-5.18861-0.4596-1.52076-1.82744-2.6711-3.37555-2.9629-1.52435-0.29289-3.07841-0.0617-4.61381,0.008-0.94594,0.0591-1.89188,0.11841-2.83782,0.1774zm1.5393,1.32733c1.43646-0.0757,2.87074-0.21585,4.30969-0.22392,0.81646-0.0241,1.62864,0.21461,2.28786,0.70072,1.00072,0.68405,1.58799,1.91553,1.45667,3.12503-0.0712,1.38985-1.09329,2.66855-2.44413,3.02043-0.77283,0.19999-1.57593,0.25601-2.36712,0.34365-0.93214,0.0583-1.86428,0.11665-2.79643,0.17483-0.14939-2.38021-0.29825-4.76046-0.44654-7.14074z'/%3E %3Cpath d='m501.664,210c-0.19023,3.3279-0.38046,6.6558-0.57069,9.9837,3.23909,0.18516,6.47818,0.37031,9.71727,0.55547,0.027-0.47284,0.0541-0.94567,0.0811-1.41851-2.75541-0.1572-5.51074-0.31562-8.26619-0.47205,0.0573-1.01308,0.11603-2.02606,0.17328-3.03914,2.48308,0.14086,4.96605,0.28372,7.44909,0.42535,0.0269-0.47043,0.0538-0.94086,0.0807-1.41129-2.48304-0.14163-4.966-0.28449-7.44908-0.42535,0.0507-0.89637,0.10241-1.79268,0.15347-2.68903,2.65213,0.15053,5.30416,0.30305,7.95625,0.45434,0.0272-0.47524,0.0543-0.95049,0.0815-1.42573-3.13557-0.17925-6.27113-0.35851-9.4067-0.53776z'/%3E %3Cpath d='m527.774,214.166-3.61612,9.3233,1.28604,0.4988,2.86698-7.3919,0.14904-0.38427,0.15998,0.42657,3.44815,9.91881,1.68397,0.65315,3.61613-9.3233-1.28934-0.50007-2.86569,7.38853-0.1464,0.37752-0.158-0.42191-3.45405-9.91335z'/%3E %3Cpath d='m541.208,219.937-4.54582,8.90705-1.33607-0.68187,4.54582-8.90705z'/%3E %3Cpath d='m548.751,224.356c-0.97142-0.64089-1.95772-1.06453-2.97756-1.27147-1.01591-0.20614-1.9472-0.14174-2.79583,0.19546-0.84836,0.3371-1.54936,0.92626-2.1091,1.77467-0.51289,0.77738-0.79492,1.63325-0.85151,2.56539-0.0563,0.92841,0.16547,1.80086,0.66904,2.63737,0.50084,0.83202,1.34364,1.64445,2.53733,2.432,1.14619,0.75621,2.25064,1.15792,3.33769,1.21888,1.04287,0.0584,1.99114-0.22553,2.85229-0.85122l-1.06975-1.03062c-1.66517,1.16306-3.07555,0.39239-4.5102-0.53714-2.19107-1.47947-3.01898-3.52128-1.70555-5.60813,1.53212-2.24195,3.91737-1.65565,5.8541-0.43,1.3426,0.88435,2.43232,1.86302,2.22572,3.36554l1.32796,0.58161c0.15651-0.89231,0.0197-1.76089-0.43062-2.61434-0.47283-0.89607-1.25205-1.70096-2.35401-2.428z'/%3E %3Cpath d='m558.272,231.538-10.4535,4.16977,1.26814,1.10073,3.2365-1.30154,0.005,0.005,4.1188,3.57507-0.83343,3.38738,1.26814,1.10073,2.65816-10.936-1.26815-1.10073zm-0.39961,1.74123-1.0486,4.27035-3.03182-2.63158,4.08042-1.63877z'/%3E %3Cpath d='m565.825,238.486c-2.572,2.12101-5.14401,4.24201-7.71601,6.36302,0.30955,0.37576,0.6199,0.75094,0.92896,1.12706,1.01157-0.83421,2.02316-1.66839,3.03473-2.50261,1.02878,1.23361,2.02924,2.49136,3.07954,3.70663-0.32075,1.6831-0.6431,3.36591-0.95647,5.05041,0.39278,0.4763,0.78555,0.95259,1.17833,1.42889,0.33526-1.77628,0.67051-3.55257,1.00577-5.32885,0.86447,0.70788,2.1276,1.06331,3.16016,0.50203,0.88803-0.42012,1.67042-1.22768,1.7162-2.25661,0.10773-1.37866-0.87542-2.49623-1.66235-3.51871-1.25571-1.5241-2.5136-3.04745-3.76886-4.57126zm-0.17038,2.03353c1.08022,1.33434,2.21438,2.62669,3.24602,3.99893,0.47574,0.70741,1.06859,1.70139,0.52294,2.52797-0.44979,0.70689-1.43474,0.64494-2.03913,0.18646-1.2247-0.82376-2.0334-2.08693-2.9893-3.18371-0.40756-0.49424-0.81514-0.98846-1.2227-1.4827,0.82739-0.68229,1.6549-1.36466,2.48217-2.04695z'/%3E %3Cpath d='m577.523,254.401-11.2426,0.51528,0.83758,1.45542,3.48429-0.16949,0.003,0.006,2.72039,4.72706-1.89709,2.92745,0.83758,1.45542,6.09396-9.46182-0.83758-1.45542zm-0.94796,1.51425-2.38965,3.69121-2.00246-3.47954,4.39211-0.21167z'/%3E %3Cpath d='m583.939,267.638c-0.62517-1.69658-1.61122-3.43366-3.27989-4.28241-1.85658-0.93284-4.32804-0.47908-5.6446,1.15572-1.14698,1.35925-1.20561,3.28116-0.89925,4.9518,0.36199,1.91793,1.24128,3.74411,2.56297,5.18542-0.24899,0.0895-0.49798,0.17897-0.74697,0.26846,0.15949,0.44375,0.31898,0.88751,0.47847,1.33126,1.56145-0.56118,3.12289-1.12237,4.68434-1.68356-0.60724-1.6861-1.21448-3.37219-1.82172-5.05829-0.36076,0.12966-0.72152,0.25931-1.08228,0.38897,0.44666,1.24274,0.89326,2.4855,1.33997,3.72822-0.52894,0.19019-1.05794,0.38024-1.5869,0.57038-1.39993-1.20263-2.18095-2.98027-2.58642-4.74823-0.30073-1.32658-0.3127-2.91664,0.69375-3.96056,1.15449-1.20086,3.20117-1.57383,4.58696-0.54964,1.36679,1.00022,2.13826,2.6215,2.52811,4.233,0.26694,1.05995,0.22329,2.32-0.58098,3.14709-0.22477,0.16883,0.13155,0.40385,0.19251,0.60544,0.12747,0.21048,0.25493,0.42097,0.3824,0.63145,0.84766-0.66844,1.36007-1.71422,1.34362-2.79667,0.0283-1.06426-0.20642-2.12058-0.56409-3.11785z'/%3E %3Cpath d='m586.811,275.447-5.59255,1.08792c-1.03793,0.20191-1.81583,0.53072-2.3346,0.96809-0.51784,0.43655-0.84913,1.05225-1.00889,1.87102-0.15808,0.81019-0.13548,1.80286,0.0969,3.01081,0.002,0.009,0.004,0.0182,0.005,0.0277,0.23733,1.207,0.58855,2.13574,1.03883,2.82758,0.45504,0.69917,0.99299,1.14578,1.63672,1.35637,0.64489,0.21099,1.48934,0.2242,2.52725,0.0223l5.59255-1.08792-0.27754-1.42669-5.45747,1.06164c-2.44995,0.47659-3.27516-0.81293-3.69596-3.01869-0.002-0.009-0.003-0.0183-0.005-0.0277-0.43677-2.20264-0.15514-3.70748,2.2948-4.18408l5.45748-1.06164-0.27752-1.4267z'/%3E %3Cpath d='m589.879,292.467-10.3479-4.42525,0.12129,1.67483,3.21126,1.36264,0.00051,0.007,0.39395,5.43971-2.98142,1.8111,0.1213,1.67484,9.60233-5.87006-0.1213-1.67483zm-1.51216,0.95131-3.75709,2.28466-0.28998-4.00412,4.04707,1.71946z'/%3E %3Crect width='1.5' height='6.3' x='-322.944' y='414.199' transform='scale(-1,1) rotate(14.748924)'/%3E %3Crect width='1.5' height='6.3' x='644.14' y='159.606' transform='rotate(14.748924)'/%3E %3Cpath d='m433.217,343.989-11.1807,1.28621,0.93557,1.39445,3.46441-0.40839,0.004,0.006,3.03863,4.52906-1.69156,3.05083,0.93557,1.39445,5.42972-9.85801-0.93556-1.39445zm-0.84172,1.57578-2.13049,3.84662-2.23671-3.33381,4.3672-0.51281z'/%3E %3Cpath d='m437.497,350.098-7.12714,6.66478,0.95177,1.0178,6.00626-5.61661-3.15096,8.66999,1.09151,1.16724,8.61117-2.61405-5.89802,5.51541,0.95176,1.0178,7.12714-6.66478-1.44571-1.54602-8.75099,2.61438,3.27652-8.46862z'/%3E %3Cpath d='m447.878,360.689c-2.00517,2.66278-4.01035,5.32555-6.01552,7.98833,2.59171,1.95166,5.18343,3.90333,7.77514,5.85499,0.2849-0.37833,0.5698-0.75667,0.8547-1.135-2.2047-1.6602-4.40935-3.32047-6.61409-4.98063,0.61036-0.8106,1.2208-1.62113,1.83116-2.43173,1.98679,1.49606,3.97352,2.9922,5.96029,4.48829,0.28345-0.37641,0.5669-0.75281,0.85035-1.12922-1.98677-1.49609-3.9735-2.99224-5.96029-4.4883,0.54002-0.71722,1.08018-1.43435,1.62017-2.1516,2.12207,1.59791,4.24406,3.19593,6.3661,4.79388,0.28635-0.38026,0.5727-0.76052,0.85905-1.14078-2.50902-1.88941-5.01804-3.77882-7.52706-5.66823z'/%3E %3Cpath d='m457.662,367.85c-1.56999,2.94092-3.13997,5.88185-4.70996,8.82277,0.42937,0.22948,0.85923,0.45816,1.2883,0.68814,0.61751-1.15665,1.23489-2.31336,1.85248-3.46997,1.42112,0.74871,2.82545,1.53016,4.25943,2.25383,0.34467,1.67837,0.68772,3.35708,1.03974,5.03393,0.54461,0.29074,1.08923,0.58147,1.63384,0.87221-0.36674-1.77005-0.73349-3.5401-1.10023-5.31015,1.06896,0.32516,2.37225,0.17258,3.11309-0.73977,0.62944-0.70484,1.05797-1.69332,0.75635-2.63927-0.35132-1.30341-1.63425-1.98592-2.71701-2.61729-1.80294-0.96908-3.61175-1.92868-5.41603-2.89443zm0.61719,1.94509c1.50709,0.8222,3.04815,1.58484,4.52472,2.46067,0.68458,0.46205,1.55319,1.0947,1.46717,2.02654-0.0761,0.81768-0.95762,1.2541-1.70343,1.08062-1.45923-0.24188-2.68995-1.11223-3.9896-1.76124-0.60467-0.32278-1.20931-0.64561-1.814-0.96836,0.50503-0.94608,1.01013-1.89215,1.51514-2.83823z'/%3E %3Cpath d='m468.957,373.756-3.77856,9.25864,1.38879,0.5668,3.77856-9.25864z'/%3E %3Cpath d='m477.975,376.871c-1.1045-0.36671-2.16696-0.51975-3.20557-0.45482-1.03459,0.0647-1.91722,0.36866-2.6492,0.91462-0.73176,0.5458-1.25576,1.29675-1.57605,2.26139-0.29347,0.88389-0.34361,1.78363-0.15626,2.6985,0.18663,0.9112,0.62734,1.69614,1.33082,2.37323,0.69968,0.67346,1.72451,1.23922,3.08173,1.68985,1.30322,0.43271,2.4741,0.5339,3.5397,0.31054,1.02228-0.21431,1.8643-0.73475,2.53348-1.56255l-1.30064-0.71755c-1.30612,1.5555-2.86822,1.17743-4.495,0.65224-2.50004-0.85988-3.82967-2.61674-3.10307-4.97303,0.89751-2.56285,3.35319-2.61592,5.54172-1.93512,1.52616,0.50545,2.8326,1.16765,3.02317,2.67228l1.43343,0.2169c-0.0805-0.90234-0.43816-1.70562-1.09461-2.41289-0.68925-0.74259-1.65072-1.31757-2.90365-1.73359z'/%3E %3Cpath d='m488.029,379.122-6.54019,9.15906,1.66192,0.24047,2.01921-2.8446,0.007,0.001,5.39774,0.78104,1.13004,3.30029,1.66192,0.24048-3.6757-10.6373-1.66191-0.24047zm0.60512,1.6809,1.42636,4.15944-3.97323-0.57492,2.54687-3.58452z'/%3E %3Cpath d='m511.47,379.193c-1.14266,0.22076-2.14408,0.60727-3.01802,1.1722-0.87056,0.56274-1.4915,1.25979-1.86263,2.09414-0.37102,0.83409-0.46045,1.74541-0.26766,2.74338,0.17666,0.91443,0.57327,1.7236,1.1844,2.42972,0.6087,0.70328,1.37718,1.1721,2.32202,1.41827,0.93976,0.24486,2.11036,0.23669,3.51447-0.0346,1.34825-0.26047,2.41884-0.74526,3.23879-1.46156,0.7866-0.6872,1.26619-1.55314,1.44461-2.60254l-1.4854,0.0108c-0.37773,1.99571-1.925,2.43052-3.60068,2.76868-2.601,0.47368-4.62033-0.40766-5.13988-2.81808-0.47161-2.67419,1.64391-3.9223,3.88562-4.3997,1.57827-0.30613,3.04163-0.36804,3.94421,0.85082l1.35617-0.51239c-0.51183-0.74748-1.21684-1.27295-2.13544-1.56846-0.96449-0.31025-2.08436-0.34112-3.38058-0.0907z'/%3E %3Cpath d='m518.148,378.01c0.94813,3.19565,1.89626,6.39129,2.84439,9.58694,3.11037-0.92283,6.22073-1.84565,9.3311-2.76848-0.13471-0.45405-0.26943-0.90809-0.40414-1.36214-2.64589,0.78505-5.29182,1.57-7.93769,2.35511-0.28864-0.97278-0.57724-1.94559-0.86588-2.91837,2.38433-0.70751,4.7687-1.41486,7.15305-2.12231-0.13403-0.45173-0.26805-0.90347-0.40208-1.3552-2.38435,0.70745-4.76872,1.4148-7.15305,2.12231-0.25541-0.86072-0.51069-1.72147-0.76615-2.58217,2.54667-0.75567,5.09338-1.51119,7.64007-2.2668-0.1354-0.45636-0.27079-0.91271-0.40619-1.36907-3.01114,0.89339-6.02229,1.78679-9.03343,2.68018z'/%3E %3Cpath d='m528.966,374.61c1.39945,3.02534,2.79891,6.05067,4.19836,9.07601,0.41731-0.19304,0.83461-0.38607,1.25192-0.57911-1.16723-2.5233-2.33445-5.04661-3.50169-7.5699,3.2371,1.46816,6.45494,2.97935,9.68455,4.46424,0.21532,0.18677,0.43059,0.0619,0.64586-0.0532,0.41968-0.19414,0.83935-0.38827,1.25903-0.5824-1.39945-3.02534-2.79891-6.05067-4.19836-9.07601-0.41837,0.19353-0.83673,0.38706-1.2551,0.58059,1.16571,2.52002,2.33141,5.04004,3.49712,7.56005-3.32359-1.50694-6.62903-3.05445-9.94557-4.57714-0.54537,0.25228-1.09075,0.50455-1.63612,0.75683z'/%3E %3Cpath d='m539.947,369.452,0.7834,1.1903,3.57155-2.3506,0.13556-0.0892,0.0676,0.10271,4.64663,7.0602,1.2141-0.79904-4.64663-7.06021-0.0676-0.10271,0.13849-0.0912,3.58924-2.36224-0.7834-1.1903z'/%3E %3Cpath d='m550.009,362.562c2.25912,2.45158,4.51825,4.90315,6.77737,7.35473,0.35826-0.32963,0.71559-0.66044,1.07443-0.98933-0.88853-0.9642-1.77701-1.92843-2.66556-2.89261,1.17531-1.0949,2.3759-2.16325,3.53179-3.27856,1.69818,0.22782,3.39617,0.45717,5.09534,0.67753,0.45399-0.41836,0.90799-0.83671,1.36198-1.25507-1.79202-0.23715-3.58403-0.4743-5.37605-0.71145,0.65931-0.90206,0.94479-2.18281,0.32762-3.18296-0.46831-0.86361-1.31769-1.60043-2.34759-1.58963-1.38249-0.0318-2.44436,1.01126-3.42205,1.85319-1.45278,1.3374-2.90492,2.6777-4.35728,4.01416zm2.0398,0.0584c1.27303-1.15184,2.50096-2.35547,3.81453-3.46086,0.6802-0.51389,1.64011-1.16046,2.49542-0.66105,0.73053,0.41027,0.7228,1.39714,0.29822,2.02581-0.75622,1.26942-1.97455,2.14713-3.01826,3.16305-0.46989,0.433-0.93977,0.866-1.40966,1.299-0.72675-0.78859-1.45368-1.57749-2.18025-2.36595z'/%3E %3Cpath d='m561.643,350.918,4.47337,10.3272,1.06321-1.29975-1.39553-3.1971,0.004-0.005,3.45322-4.22148,3.41028,0.73412,1.06321-1.29976-11.009-2.33754-1.06322,1.29975zm1.75217,0.34857,4.29916,0.9234-2.54189,3.1074-1.75727-4.0308z'/%3E %3Cpath d='m565.998,345.253,8.39039,5.44074,4.40302-6.79009-1.19211-0.77303-3.52205,5.43147-0.0902,0.13913-0.10617-0.0688-7.09208-4.59886z'/%3E %3C/g%3E %3Cg clip-path='url(%23shield)'%3E %3Cg id='rays'%3E %3Cpath fill='%23fff' d='m500.001,226.408 -31.4786,54.5355 -15.42,26.7015h93.7971l-14.7145,-25.4844 -32.1841,-55.7526z'/%3E %3Cg id='rays5'%3E %3Cg id='ray'%3E %3Cpath fill='%2317c0eb' stroke='%2317c0eb' stroke-width='0.12869333' opacity='0.62040818' d='m500.001,226.408-2.35655,4.08164,2.35655,54.9769,2.35656-54.9769z'/%3E %3Cpath fill='%23fff' d='m500.001,277.475c-0.044,0 -0.0891,0.002 -0.1335,0.003l0.1335,3.11123 0.13351-3.11123c-0.0443,-0.00097 -0.0892,-0.003 -0.13351,-0.003z'/%3E %3C/g%3E %3Cuse xlink:href='%23ray' transform='rotate(72,500.001,285.46654)'/%3E %3Cuse xlink:href='%23ray' transform='rotate(144,500.001,285.46654)'/%3E %3Cuse xlink:href='%23ray' transform='rotate(216,500.001,285.46654)'/%3E %3Cuse xlink:href='%23ray' transform='rotate(288,500.001,285.46654)'/%3E %3C/g%3E %3Cuse xlink:href='%23rays5' transform='rotate(8,500.001,285.46654)'/%3E %3Cuse xlink:href='%23rays5' transform='rotate(16,500.001,285.46654)'/%3E %3Cuse xlink:href='%23rays5' transform='rotate(24,500.001,285.46654)'/%3E %3Cuse xlink:href='%23rays5' transform='rotate(32,500.001,285.46654)'/%3E %3Cuse xlink:href='%23rays5' transform='rotate(40,500.001,285.46654)'/%3E %3Cuse xlink:href='%23rays5' transform='rotate(48,500.001,285.46654)'/%3E %3Cuse xlink:href='%23rays5' transform='rotate(56,500.001,285.46654)'/%3E %3Cuse xlink:href='%23rays5' transform='rotate(64,500.001,285.46654)'/%3E %3C/g%3E %3Cg id='rainbow'%3E %3Cpath fill='%23f00' d='m500,265.844c-11.0666,0-21.1953,4.05143-28.9688,10.75l-14.656,25.406c-0.50136,2.67038-0.75,5.43402-0.75,8.25h5.03125c0-21.7264,17.6173-39.3438,39.3438-39.3438,21.7264,0,39.3438,17.6173,39.3438,39.3438h5.03125c0-2.81337-0.24954-5.58193-0.75-8.25l-14.6562-25.4062c-7.77293-6.69663-17.904-10.75-28.9688-10.75z'/%3E %3Cpath fill='%23f60' d='m500,266.656c-11.764,0-22.4393,4.67488-30.2812,12.25l-12.031,20.844c-0.83351,3.36611-1.28125,6.87625-1.28125,10.5h4.25c0-21.7264,17.6173-39.3438,39.3438-39.3438,21.7264,0,39.3438,17.6173,39.3438,39.3438h4.25c0-3.62494-0.44735-7.16414-1.28125-10.5312l-12.0312-20.8125c-7.841-7.57455-18.5177-12.25-30.2812-12.25z'/%3E %3Cpath fill='%23ff0' d='m500,267.469c-12.7024,0-24.1008,5.52218-31.9375,14.3125l-8.71875,15.0938c-1.38396,4.20847-2.125,8.70346-2.125,13.375h3.4375c0-21.7264,17.6173-39.3438,39.3438-39.3438,21.7264,0,39.3438,17.6173,39.3438,39.3438h3.4375c0-4.67311-0.74037-9.16532-2.125-13.375l-8.719-15.095c-7.836-8.788-19.237-14.312-31.938-14.312z'/%3E %3Cpath fill='%230f0' d='m500,268.25c-14.5495,0-27.3723,7.41414-34.9062,18.6562l-2.8125,4.875c-2.735,5.574-4.282,11.842-4.282,18.469h2.65625c0-21.7264,17.6173-39.3438,39.3438-39.3438,21.7264,0,39.3438,17.6173,39.3438,39.3438h2.6562c0-6.61555-1.55577-12.8712-4.28125-18.4375l-2.844-4.937c-7.536-11.227-20.337-18.625-34.875-18.625z'/%3E %3Cpath fill='%230cf' d='m500,269.062c-22.7472,0-41.1875,18.4403-41.1875,41.1875h1.84375c0-21.7264,17.6173-39.3438,39.3438-39.3438,21.7264,0,39.3438,17.6173,39.3438,39.3438h1.84375c0-22.7472-18.4403-41.1875-41.1875-41.1875z'/%3E %3Cpath fill='%2300f' d='m500,269.844c-22.3058,0-40.375,18.1004-40.375,40.4062h1.34375c0-21.5594,17.4718-39.0312,39.0312-39.0312s39.0312,17.4718,39.0312,39.0312h1.375c0-22.3058-18.1004-40.4062-40.4062-40.4062z'/%3E %3Cpath fill='%23800080' d='m500.001,270.657c-21.8638,0-39.5887,17.7249-39.5887,39.5887,0,0.24501,0.003,0.48981,0.007,0.73377h0.8008c-0.005-0.24405-0.007-0.48864-0.007-0.73377,0-21.4222,17.3658-38.7879,38.7879-38.7879,21.4222,0,38.7879,17.3658,38.7879,38.7879,0,0.24513-0.002,0.48972-0.007,0.73377h0.79727c0.004-0.24396,0.007-0.48876,0.007-0.73377,0-21.8638-17.7214-39.5887-39.5852-39.5887z'/%3E %3C/g%3E %3Cg id='cap'%3E %3Cpath fill='%23510000' d='m500.395,288.134c-0.64444-0.12422-1.22556-0.48362-1.77526-0.60947-0.75553,0.72433-0.83505,1.45617-0.73118,2.07933,0.26291,0.13958,0.31133,0.353,0.87825,0.86011s0.49599,0.7732,0.46178,1.96543c-0.0144,0.50237,0.0702,1.58063,0.57906,1.682,0.54856,0.1093,0.93237-0.34645,1.08988-1.16049,0.15297-0.79058,0.4179-1.2158,0.69822-1.70182,0.30651-1.85224-0.19317-2.50796-1.20075-3.11509z'/%3E %3Cpath fill='%23f00' d='m497.168,283.524c-0.5954,0.015-1.52849,1.01222-1.94312,0.4754-0.2385-0.30879-0.2787-0.90191-0.037-1.40011,0.55866-1.15143,1.12448-1.71603,2.16738-2.33046,2.37772-1.40083,3.8889-0.95056,5.07395,1.06271,1.0982,1.77292,2.15196,3.72986,2.24612,5.37194,0.0291,0.50093,0.28239,1.40776-0.15623,1.85983-1.34779,1.38922-4.59607-1.43513-6.49718-0.9882-0.63913,0.15025-1.37729,0.6166-1.98048,0.21781-0.46922-0.31025-0.0771-0.99697,0.27265-1.29413,0.61215-0.52003,1.50103-2.36524,1.38013-3.16441-0.0677-0.44682-0.08,0.17838-0.52586,0.18962z'/%3E %3Cpath fill='url(%23cap1)' d='m496.927,282.548c-1.08326,0.4452-0.96582,1.07615-1.50945,1.59022,0.15386,0.0578,0.7653,0.31056,1.36345-0.30126,0.25817-0.21386,0.54788-0.29339,0.67713-0.36245-0.30513,0.22158-0.52326,0.55469-0.68366,0.68484-0.40495,0.32861-1.03464,1.08239-1.34095,1.84608-0.30631,0.76368-0.43013,1.67294-0.37506,1.78203,0.0551,0.1091,0.42587,0.77878,1.5653,1.23156,2.03098,0.80708,2.41713,2.43864,4.47768,2.43864,1.61336,0,1.35441-1.05575,2.64581-0.83159,1.1192,0.19425,1.71404-0.69654,0.63574-1.23178-1.371-0.46864-4.09192-0.19196-5.37247,0.0332-0.41337-4.08361-0.0551-2.64985-0.15181-4.40521-0.0968-1.75536-0.62285-1.86055,0.0724-3.28125-0.57778,0.87239-1.27677,0.73447-2.004,0.807z'/%3E %3Cpath fill='%23ff2a2a' d='m500.938,279.795c-0.0401,0.22319-0.0767,0.51644-0.0555,0.6,0.087,0.33854,0.17464,0.69288,0.27745,0.99375,0.11493,0.33621,0.16173,0.57942,0.24047,0.92812,0.0812,0.35981,0.40101,0.50003,0.69364,0.72188,0.36987,0.28044,0.0839,1.03755,0.31445,1.06875,0.18399,0.025,0.48828-1.07134,0.49017-1.24688,0-0.23637-0.001-0.42692-0.037-0.64687-0.1351-0.29493-0.27167-0.58548-0.42543-0.87188-0.002-0.004-0.007-0.006-0.009-0.009-0.0604-0.11211-0.12197-0.22206-0.19422-0.32812-0.21674-0.3182-0.48469-0.61247-0.78613-0.8625-0.0186-0.0154-0.0367-0.0318-0.0555-0.0469-0.0843-0.0645-0.17013-0.13028-0.25896-0.1875-0.0629-0.0405-0.12933-0.0758-0.19422-0.1125z'/%3E %3Cpath fill='url(%23cap2)' d='m501.249,287.398c-0.71834-0.18768-1.42584-0.54264-2.03712-0.72519-1.20046-0.3585-2.47993-1.13407-3.3655-0.81346-0.31696,0.14032-0.28927,0.45588-0.39018,0.90946-0.0419,0.53363-0.59621,1.31951-0.13634,1.06243,0.68545-0.38318,2.49069,0.73271,3.09544,1.10617,0.28651,0.17693,0.89218,0.52377,1.08153,1.02169,0.18934,0.49792,0.092,1.75593,0.0412,2.29553-0.0533,0.56606,0.11902,1.83505,0.68594,1.98695,0.61122,0.16378,1.07804-0.32245,1.31579-1.2298,0.23091-0.8812,0.40519-1.38725,0.75742-1.91526s0.75591-0.75584,1.31984-0.86236c0.56393-0.10651,1.38228,0.46186,1.38228-0.20334,0-0.43694-0.38382-0.85479-0.22071-1.45374,0.12846-0.47174-0.40137-0.37766-0.84179-0.57224-1.03591-0.31872-1.96945-0.41916-2.6878-0.60684z'/%3E %3Cpath fill='%23910000' d='m498.363,288.902c-0.32675-0.17761-2.3152-1.4778-3.04281-1.07105-0.22993,0.12854-0.31747-0.0162-0.32062-0.25731-0.004-0.24106,0.10913-0.59399,0.18399-0.86612,0.0749-0.27214,0.19591-0.79179,0.5164-1.06192,0.68731-0.5793,2.2686,0.57503,3.1082,0.88679-0.0717,0.4352-0.47012,2.35517-0.44516,2.36961z'/%3E %3Cpath fill='%23ff3a3a' d='m501.763,291.361c0.91566-1.60289,1.50762-1.39687,2.61336-1.37357,0.36843,0.008,0.47628-0.32925,0.39238-0.66749-0.278,0.62397-1.66206-0.069-2.41497,0.26261-1.57249,0.69255-1.28027,3.76979-2.02634,4.07028,0.77552,0.65117,1.1236-1.74573,1.43557-2.29183z'/%3E %3C/g%3E %3Cg id='seab' fill='url(%23seabgrad)'%3E %3Cpath fill='%23fff' d='m453.103,307.645-9.95545,17.2366,113.708,0-9.95545-17.2366-93.7972,0z'/%3E %3Cg id='wavesb3'%3E %3Cpath id='waveb1' d='m449.705,321.364c-1.65776,0-3.19731,0.16736-4.70961,0.35278l-0.48684,0.84666c2.43344-0.21658,4.69724-0.64924,7.14027-0.70908,3.29349,0.0801,6.2835,0.82902,9.78611,0.82902,1.51792,0.0147,3.02697-0.0297,4.5262,0,3.49923,0,6.48854-0.74896,9.78259-0.82902,3.29576,0.0801,6.30397,0.82902,9.80375,0.82902,1.51769,0.005,3.17747-0.0238,4.52973,0,3.49922,0,6.47429-0.74896,9.76495-0.82902,3.29293,0.0801,6.26925,0.82902,9.76848,0.82902,1.53042,0.0148,3.03299-0.0299,4.54381,0,3.49923,0,6.49037-0.74896,9.78612-0.82902,3.29632,0.0795,6.28114,0.82902,9.78258,0.82902,1.51624,0.0145,3.03114-0.0297,4.52976,0,3.49867,0,6.47485-0.74896,9.76495-0.82902,2.55081,0.062,4.92094,0.51761,7.48601,0.72319l-0.51507-0.89252c-1.40293-0.16829-2.8346-0.32103-4.36741-0.32103-1.52925-0.0208-3.03636,0.0308-4.54734,0-3.4992,0-6.47369,0.74842-9.76495,0.82902-3.29632-0.0801-6.28347-0.82902-9.78612-0.82902-1.51274-0.0209-3.0301,0.0312-4.52617,0-3.49921,0-6.49263,0.74897-9.7861,0.82902-3.29407-0.0801-6.28337-0.82902-9.7826-0.82902-1.52189-0.0207-3.04194,0.0308-4.54734,0-3.49922,0-6.4754,0.74897-9.76495,0.82902-3.29404-0.0801-6.26924-0.82902-9.76847-0.82902-1.52279-0.0213-3.02634,0.0313-4.52618,0-3.5026,0-6.48979,0.74897-9.78611,0.82902-3.29405-0.0806-6.28335-0.82902-9.78259-0.82902-1.52022-0.0209-3.04332,0.0313-4.54733,0z'/%3E %3Cuse xlink:href='%23waveb1' y='-1.1132812'/%3E %3Cuse xlink:href='%23waveb1' y='-2.2304687'/%3E %3C/g%3E %3Cuse xlink:href='%23wavesb3' y='-3.34375'/%3E %3Cuse xlink:href='%23wavesb3' y='-6.6914063'/%3E %3Cpath d='m453.23,307.458 -0.12347,0.21519h93.7901l-0.12348,-0.21519h-93.5432zm-0.21872,0.37746 -0.127,0.21873h94.2346l-0.127,-0.21873h-93.9806zm-0.20109,0.34572 -0.20461,0.35631h94.792l-0.2046,-0.35631h-94.3828zm-0.3175,0.55033 -0.25047,0.43392h95.5187l-0.25048,-0.43392h-95.0178zm-0.39864,0.69144 -0.25047,0.43392h96.316l-0.25047,-0.43392h-95.815zm-0.39864,0.69144 -0.24695,0.43039h97.1062l-0.24693,-0.43039h-96.6123zm-0.39864,0.69144 -0.25048,0.43039h97.9106l-0.25048,-0.43039h-97.4096zm-0.43039,0.74436 -0.30339,0.52916h98.8772l-0.30339,-0.52916h-98.2704z'/%3E %3Cpath d='m457.357,312.287c3.45019,0.6621 3.7818,0 3.7818,0zm81.5028,0s0.3316,0.6621 3.7818,0z'/%3E %3C/g%3E %3Cg id='mountains' fill='%23ccd11e'%3E %3Cg id='mountain1'%3E %3Cpath fill='url(%23mountain)' d='m530.631,297.043c-1.70879,0-2.23164,0.86208-2.23164,0.86208-2.73683,10.5758-11.8078,21.3327-22.6008,21.3327h-8.08019v10.7684c0,0.003,0.0112,0,0.017,0h61.4976l-6.18652-10.9539c-9.70777-1.44879-17.6397-11.3728-20.1666-21.1472-0.0003,0-0.54017-0.86208-2.24897-0.86208z'/%3E %3Cpath fill='%2397c924' d='m530.631,297.465c-0.78411,0-1.26009,0.18069-1.53836,0.35499-0.26383,0.16497-0.31454,0.2757-0.32096,0.28758,0,0.007-0.0151,0.01-0.0176,0.0168-1.39971,5.32242-4.35191,10.6683-8.33374,14.7065-4.01201,4.06971-9.06971,6.82929-14.605,6.82929h-7.67481v9.92268h60.8557l-5.68004-10.0578c-4.68763-0.61173-8.97309-3.16302-12.4584-6.69417-3.98569-4.03827-6.93211-9.38349-8.33374-14.7065,0,0-0.0164-0.0165-0.017-0.0168-0.007-0.012-0.0696-0.10431-0.33797-0.27057-0.28308-0.17556-0.75393-0.372-1.53804-0.372z'/%3E %3Cpath fill='%23ede71f' d='m530.63,297.465c0.14713,0,0.27966,0.0211,0.4057,0.0341,0.0238,3.01731,0,8.10909,0,10.8013-0.0287,2.34006-0.83034,4.2225-2.01175,6.44085-0.54742,1.5541-0.98612,0.96232-2.34929,2.85666-1.83161,0.65398-3.18666,0.90876-5.13836,1.21655-2.51753,0.39758-8.12164,0.75027-10.8869,0.13523,3.64106-1.06725,6.96079-3.26938,9.77096-6.11954,0.74649-0.7573,1.45945-1.5595,2.12967-2.40011,1.11812-1.40047,2.12751-2.91291,3.00924-4.47944,0.35269-0.6264,0.68645-1.24901,0.99749-1.89326,0.46683-0.9661,0.88335-1.95059,1.25119-2.94104,0.12279-0.3305,0.24396-0.66588,0.35485-0.99747,0.22233-0.66372,0.41706-1.32961,0.59179-1.99495,0.002-0.006,0.0151-0.0103,0.0168-0.0168,0.006-0.0119,0.0579-0.12225,0.32077-0.28724,0.13578-0.0849,0.3316-0.17039,0.57502-0.23692,0.005-0.001,0.0124,0.001,0.0168,0,0.25153-0.0665,0.55446-0.11793,0.9461-0.11793z'/%3E %3Cpath fill='%23c6cb24' d='m529.938,298.902c-0.41166,6.03407-2.27735,13.1917-6.64434,17.8107-1.60658,1.33664-3.65998,2.54995-5.64577,2.2546,6.77038-5.51045,10.8853-13.9468,12.2901-20.0653z'/%3E %3Cpath fill='%239ecb34' d='m524.494,309.281c-1.00181,2.72142-4.78784,6.74649-8.84,10.0451-1.15058,0.0352-1.75967,0.10115-2.80422,0.0379,2.46776-0.22502,8.22171-5.08258,11.6442-10.0829z'/%3E %3C/g%3E %3Cuse xlink:href='%23mountain1' x='-15.340665'/%3E %3Cg id='mountain3' fill='%23c6cb24'%3E %3Cpath fill='url(%23mountain)' d='m502.218,297.911c2.73458,10.5755,11.7902,21.3327,22.5831,21.3327h8.08853v10.7681c0,0.003-0.0144,0-0.017,0h-65.7947c-0.006,0-0.0167,0.003-0.0167,0v-10.7681h8.07151c10.7926,0,19.863-10.7575,22.6001-21.3327,0,0,0.53408-0.86562,2.24287-0.86562s2.24287,0.86562,2.24287,0.86562z'/%3E %3Cpath fill='%2397c924' d='m499.975,297.465c0.78378,0,1.25463,0.19644,1.53836,0.372,0.26865,0.16626,0.33123,0.25869,0.33829,0.27057,0,0,0.017,0.0168,0.017,0.0168,1.40164,5.32275,4.34806,10.6683,8.33375,14.7065,4.0165,4.06971,9.08671,6.82929,14.6226,6.82929h7.64046v9.92238h-64.9804v-9.92238h7.67448c5.53561,0,10.593-2.75991,14.6053-6.82929,3.98184-4.03827,6.93371-9.38379,8.33374-14.7065,0.003-0.007,0.0151-0.01,0.017-0.0168,0.006-0.012,0.0575-0.12228,0.32096-0.28758,0.2786-0.1743,0.75458-0.35499,1.53837-0.35499z'/%3E %3Cpath fill='%23ede71f' d='m499.263,297.53c-0.0864,0.0162-0.16714,0.0347-0.24243,0.0546-0.004,0.001-0.0128-0.001-0.0176,0-0.24288,0.0665-0.43572,0.15144-0.5715,0.23636-0.26398,0.16499-0.31454,0.27385-0.32103,0.28575-0.002,0.006-0.016,0.0111-0.0176,0.0176-0.17526,0.66535-0.37034,1.333-0.59266,1.99672-0.11089,0.33159-0.23352,0.66433-0.35631,0.99484-0.36838,0.99044-0.782,1.97606-1.24883,2.94216-0.31158,0.64425-0.64567,1.26802-0.99836,1.89442-0.88173,1.56653-1.89108,3.07628-3.0092,4.47675-0.67076,0.84061-1.38428,1.64511-2.13077,2.40242-2.80963,2.85016-6.12791,5.04991-9.76842,6.11716,2.76473,0.61504,4.03154-0.056,6.54853-0.45356,1.95224-0.30779,4.21092-0.5631,6.04308-1.21708,1.3637-1.89434,0.89896-1.29988,1.44639-2.85397,1.18086-2.21836,2.90542-4.22182,3.33375-6.68161,1.61858-3.02147,1.90301-8.6137,1.90304-10.2126z'/%3E %3Cpath d='m499.275,298.902c-0.41166,6.03407-2.27681,13.1917-6.6438,17.8107-1.60658,1.33664-3.65998,2.54995-5.64577,2.2546,6.77038-5.51045,10.8848-13.9468,12.2896-20.0653z'/%3E %3Cpath fill='%239ecb34' d='m493.832,309.281c-1.00204,2.72139-4.78809,6.74682-8.84021,10.0453-1.15033,0.035-1.75951,0.10077-2.80424,0.0375,2.46787-0.2253,8.22237-5.08266,11.6444-10.0828z'/%3E %3Cpath fill='%23ede71f' d='m500.951,297.584c0.004,0.001,0.0128-0.001,0.0176,0,0.24288,0.0665,0.43572,0.15144,0.5715,0.23636,0.26398,0.16499,0.31454,0.27385,0.32103,0.28575,0.002,0.006,0.016,0.0111,0.0176,0.0176,0.17526,0.66535,0.37034,1.333,0.59266,1.99672,0.11089,0.33159,0.23352,0.66433,0.35631,0.99484,0.36838,0.99044,0.782,1.97606,1.24883,2.94216,0.31158,0.64425,0.64567,1.26802,0.99836,1.89442,0.88173,1.56653,1.89108,3.07628,3.0092,4.47675,0.67076,0.84061,1.38428,1.64511,2.13077,2.40242,2.80963,2.85016,6.12791,5.44502,9.76842,6.51227-7.24491,0.0274-10.3888-0.63-13.022-4.01661-2.63318-3.38661-3.60599-4.86816-4.1405-6.93644-0.53451-2.06829-2.02539-6.57045-1.86986-10.8063z'/%3E %3Cpath d='m501.476,298.902c0.41166,6.03407,2.2209,12.0063,6.58735,16.6253,1.60659,1.33664,3.65999,2.54994,5.64577,2.2546-7.33482-5.00192-10.8288-12.7615-12.2331-18.8799z'/%3E %3C/g%3E %3Cg id='mountain4'%3E %3Cpath fill='url(%23mountain)' d='m484.749,297.043c-1.70911,0-2.24833,0.86208-2.24833,0.86208-2.52242,9.74649-11.825,22.3182-21.4962,23.8113l-4.78983,8.28981h49.0144v-11.3486c-8.82472-2.37071-15.8893-11.6292-18.2484-20.7525-0.00034,0-0.52284-0.86208-2.23164-0.86208z'/%3E %3Cpath fill='%2397c924' d='m484.749,297.465c-0.7841,0-1.25495,0.19644-1.53836,0.372-0.26864,0.16626-0.33123,0.25869-0.33797,0.27057-0.00033,0-0.017,0.0168-0.017,0.0168-1.40164,5.32275-4.67746,10.7045-8.07974,14.9888-3.40228,4.28421-9.71968,8.61825-14.0417,9.07638l-4.28272,7.39371h48.0605v-10.6937c-3.55405-1.09062-6.79917-3.26637-9.5523-6.05864-3.98183-4.03827-6.93371-9.38379-8.33374-14.7065-0.002-0.007-0.0154-0.01-0.017-0.0168-0.006-0.012-0.0578-0.12228-0.32128-0.28758-0.27891-0.1743-0.7549-0.35499-1.53868-0.35499z'/%3E %3Cpath fill='%2393bc30' d='m483.445,298.903c-0.61721,9.04327-5.65334,20.4536-11.3402,22.4194-1.85433,0.64154-5.09834,0.86441-6.22727,1.00883,9.94892-4.73151,15.8284-15.8536,17.5675-23.4282z'/%3E %3Cpath fill='%23ede71f' d='m484.746,297.465c-0.14713,0-0.27966,0.0211-0.4057,0.0341-0.0233,3.01731,0,8.10909,0,10.8013,0.0292,2.34006,0.83088,4.2225,2.01175,6.44085,0.0687,0.1942,0.13577,0.35377,0.20285,0.49009,0.41003,1.08564,0.7135,1.46267,2.28222,2.6538,4.9869,3.78651,11.1698,4.35287,14.8082,4.04021-1.13975-0.89849-2.35794-1.71529-3.4317-2.46772,1.71152-0.0552,3.3511-0.24883,4.51358-0.5074-3.64051-1.06725-6.96079-3.26938-9.77042-6.11954-0.48955-0.49658-0.94501-1.02182-1.40319-1.55518-0.20826-0.29156-0.50091-0.69725-0.59178-0.81139-1.11812-1.40047-2.26275-2.94699-3.14448-4.51352-0.35269-0.6264-0.6859-1.24901-0.99748-1.89326-0.46683-0.9661-0.88282-1.95059-1.25119-2.94104-0.1228-0.3305-0.24397-0.66588-0.35486-0.99747-0.22232-0.66372-0.41652-1.32961-0.59178-1.99495-0.002-0.006-0.0152-0.0103-0.0168-0.0168-0.006-0.0119-0.0573-0.12225-0.32132-0.28724-0.13578-0.0849-0.3316-0.17039-0.57502-0.23692-0.005-0.001-0.0124,0.001-0.0168,0-0.25153-0.0665-0.55446-0.11793-0.9461-0.11793z'/%3E %3Cpath d='m485.446,298.902c0.41166,6.03407,2.27735,13.1917,6.6438,17.8107,1.60658,1.33664,3.65998,2.54995,5.64577,2.2546-6.77038-5.50991-10.8853-13.9468-12.2896-20.0653z'/%3E %3Cpath fill='%239ecb34' d='m489.613,307.247c2.36901,5.83689,8.37001,11.2893,14.5434,14.9536,1.15032,0.035,1.49118,0.003,2.53623-0.06-4.41834-2.3709-11.5382-5.75379-17.0796-14.8936z'/%3E %3C/g%3E %3Cuse xlink:href='%23mountain4' x='-15.429624' fill='%23c6cb24'/%3E %3C/g%3E %3Cg id='seaf'%3E %3Cpath fill='%23fff' d='m556.5,324.692c-0.57438,0.20274-4.4212-0.18918-6.43291-0.0441l-1.27942,0.33561c-1.12352-0.008-2.2382,0.0249-3.33025,0-3.60215,0-6.64947,0.94833-10.0754,0.94896-3.43268,0-6.47005-0.94896-10.0754-0.94896-1.11911-0.008-2.23365,0.025-3.33025,0-3.6015,0-6.64626,0.94896-10.0754,0.94896-3.42915,0-6.47326-0.94896-10.0754-0.94896-1.13086-0.007-2.24155,0.0238-3.34789,0-3.60182,0-6.63215,0.94896-10.0578,0.94896-3.42883,0-6.45594-0.94896-10.0578-0.94896-0.26736,0-0.51646,0.009-0.77612,0.0177-0.17781-0.004-0.37669-0.0177-0.55739-0.0177-0.11972,0-0.22152-0.003-0.33867,0-0.11714-0.003-0.23659,0-0.35631,0-0.18069,0-0.3443,0.0138-0.52212,0.0177-0.25964-0.008-0.51195-0.0177-0.77963-0.0177-3.60535,0-6.64241,0.94929-10.0754,0.94896-3.42914,0-6.47358-0.94896-10.0754-0.94896-0.2619,0-0.52159,0.01-0.77611,0.0177-0.1807-0.004-0.33885-0.0177-0.52212-0.0177-0.12421,0-0.25198-0.003-0.37394,0-0.11715-0.003-0.23659,0-0.35631,0-0.1807,0-0.36162,0.0138-0.53975,0.0177-0.25902-0.008-0.50844-0.0177-0.77612-0.0177-2.87883,0-6.21806,0.60744-8.93592,0.8502l-6.27243,10.8584,62.9712-0.007,64.3753,0.007z'/%3E %3Cpath fill='url(%23seafgrad)' d='m547.993,323.111c-0.19914,0-0.3979,0-0.5962,0.007-3.24025,0.0945-5.56407,1.1148-11.2007,1.1148-5.63662,0-6.21814-1.01862-12.5836-0.87843-5.9467,0.13098-8.44224,1.2612-11.6699,1.21707-3.22765-0.0441-8.47272-0.69756-12.5095-0.27513-4.03677,0.4224-8.8283,1.28394-11.9733,1.29114-3.90833-0.0174-7.81956-0.73101-11.9062-0.32454-4.08669,0.40647-5.99703,1.49994-11.0631,1.48518-4.35525-0.0126-9.08294-0.69768-12.7459-0.69498-3.43476,0.003-7.26655,0.95724-10.0859,1.44288l-0.84314,1.46403c2.24704-0.26058,8.55148-1.21821,10.802-1.27707,2.34423-0.0613,10.717,0.48306,15.3352,0.32457,4.61831-0.15849,5.15872-1.17123,10.6186-1.17123,3.80095,0,6.66602,0.39864,10.5657,0.39864,2.43414,0,4.64322-1.24179,8.34319-1.24179,0.93595-0.0267,1.86447-0.0608,2.794-0.0914,3.11857-0.51522,8.38344,0.0449,12.0474,0.23274,3.31532,0.17289,5.45733-0.61554,8.9147-0.73023,1.49575-0.0682,2.99739-0.0659,4.47322-0.1483,3.46061-0.11481,6.42225,0.64053,9.68022,0.62442,3.24998-0.20046,6.40346-0.9225,9.86013-1.03716,1.51123-0.0717,2.99793-0.0723,4.49087-0.1482,2.28616-0.0758,5.83581,0.0784,8.27264,0.50094l-0.83962-1.4499c-2.37954-0.0756-5.31192-0.63528-8.18091-0.63501z'/%3E %3Cg id='wavesf3'%3E %3Cpath id='wavef1' fill='url(%23seafgrad)' d='m450.312,334.748c-3.4571,0-6.40225,0.85314-9.65206,0.94542-1.21068-0.0338-2.36647-0.18372-3.53485-0.34572l-0.49037,0.8502c0.48641,0.0323,0.97518,0.0635,1.48873,0.0635,1.50121,0.0181,2.99033-0.0362,4.47333,0,3.4571,0,6.38201-0.85251,9.63442-0.94545,3.25403,0.0923,6.20548,0.94545,9.66617,0.94545,1.5011,0.0185,2.99216-0.0362,4.47329,0,3.45743,0,6.41213-0.85317,9.66616-0.94545,3.25601,0.0923,6.23024,0.94545,9.68735,0.94545,1.49515,0.018,2.99325-0.0361,4.46979,0,3.45745,0,6.40128-0.85317,9.65206-0.94545,3.25339,0.0923,6.19143,0.94545,9.64853,0.94545,1.51281,0.0184,2.99932-0.0362,4.49089,0,3.45713,0,6.41051-0.85317,9.66617-0.94545,3.25762,0.0917,6.21,0.94545,9.66971,0.94545,1.49537,0.018,2.99209-0.0361,4.46978,0,3.45709,0,6.40095-0.85317,9.65206-0.94545,3.25303,0.0923,6.20903,0.94545,9.66616,0.94545,1.49931,0.0181,2.99554-0.0361,4.47325,0,0.60565,0,1.19636-0.0342,1.77801-0.0776l-0.46213-0.79728c-1.06409,0.14412-2.13376,0.27615-3.235,0.3069-3.25439-0.0923-6.19497-0.94542-9.65207-0.94542-1.51059-0.0196-2.99775,0.0292-4.49089,0-3.4571,0-6.39678,0.85314-9.64853,0.94542-3.25694-0.0916-6.2058-0.94542-9.66617-0.94542-1.49604-0.0198-2.99286,0.0297-4.47325,0-3.45713,0-6.41243,0.85314-9.66617,0.94542-3.25435-0.0923-6.20904-0.94542-9.66617-0.94542-1.50326-0.0196-3.00351,0.0292-4.4909,0-3.45712,0-6.39874,0.85314-9.64852,0.94542-3.25406-0.0923-6.19497-0.94542-9.65206-0.94542-1.5058-0.02-2.98967,0.0296-4.47325,0-3.46037,0-6.40921,0.8538-9.66618,0.94542-3.25436-0.0923-6.20873-0.94542-9.66617-0.94542-1.50222-0.0201-3.00578,0.0298-4.49089,0z'/%3E %3Cuse xlink:href='%23wavef1' y='-1.2894435'/%3E %3Cuse xlink:href='%23wavef1' y='-2.5745998'/%3E %3C/g%3E %3Cuse xlink:href='%23wavesf3' y='-3.8671875'/%3E %3Cuse xlink:href='%23wavesf3' y='-7.7286534'/%3E %3C/g%3E %3Cpath fill='%2397c924' d='m443.846,324.705-2.42711,4.191c2.83897-0.47073,7.10222-1.70307,10.6345-1.70568,3.66291-0.003,8.08192,0.90279,12.4372,0.91545,5.06609,0.0147,6.97643-1.07871,11.0631-1.48521,4.08668-0.40644,7.99791,0.52761,11.9062,0.54507,3.14498-0.007,7.93651-1.08924,11.9733-1.51167,4.03678-0.42243,7.73721,0.29346,12.603,0.3687,4.86583,0.0753,5.62964-1.17963,11.5763-1.31061,6.36544-0.14022,6.94696,0.8784,12.5836,0.8784,4.24149,0.22824,7.88284-0.8541,11.6664-1.12182,3.78351-0.26772,5.53834,0.043,8.3044,0.10938l-1.83798-3.25263c-0.0306,0-0.0608,0.003-0.0917,0.004l-101.246,2.2256z'/%3E %3Cpath fill='%23fff' d='m550.067,324.648s2.71009,0.1485,3.84748,0.27558c1.13739,0.12711,2.95452,0.25356,2.95452,0.25356l-0.36909-0.48504c-0.57438,0.20274-4.4212-0.18918-6.43291-0.0441z'/%3E %3C/g%3E %3Cpath fill='%23c8a400' d='m500,224.874 -32.1418,55.6856 -32.8579,56.8991 64.2977,-0.007 65.7018,0.007 -32.153,-55.683 -32.847,-56.902zm0,3.00212 31.5491,54.652 30.8506,53.4278 -63.1018,-0.004 -61.7012,0.004 31.5597,-54.6448z'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 9 6'%3E %3Crect fill='%2321468B' width='9' height='6'/%3E %3Crect fill='%23FFF' width='9' height='4'/%3E %3Crect fill='%23AE1C28' width='9' height='2'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1100 800'%3E %3Crect width='1100' height='800' fill='%23ef2b2d'/%3E %3Crect width='200' height='800' x='300' fill='%23fff'/%3E %3Crect width='1100' height='200' y='300' fill='%23fff'/%3E %3Crect width='100' height='800' x='350' fill='%23002868'/%3E %3Crect width='1100' height='100' y='350' fill='%23002868'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns:xlink='http://www.w3.org/1999/xlink' xmlns='http://www.w3.org/2000/svg' viewBox='-17.582 -4.664 71.571 87.246'%3E %3Ctitle%3EFlag of Nepal%3C/title%3E %3Cdesc%3ECoding according to the official construction in 'Constitution of the Kingdom of Nepal, Article 5, Shedule 1', adopted in November 1990%3C/desc%3E %3Cuse xlink:href='%23b' stroke='%23003893' stroke-width='5.1646754223'/%3E %3Cpath id='b' d='M -15,37.5735931288 h 60 L -15,0 v 80 h 60 L -15,20 z' fill='%23DC143C'/%3E %3Cg fill='%23fff'%3E %3Cpath d='M -11.9502769431,23.4834957055 A 12.8400974233,12.8400974233 0 0,0 11.9502769431,23.4834957055 A 11.9502769431 11.9502769431 0 0,1 -11.9502769431,23.4834957055'/%3E %3Cg transform='translate(0,29.0445562765) scale(5.5610605710)'%3E %3Ccircle r='1'/%3E %3Cg id='jags6'%3E %3Cg id='jags3'%3E %3Cpath id='jag' d='M 0.195090322016,-0.980785280403 L 0,-1.388784109750 L -0.195090322016,-0.980785280403' transform='rotate(11.25)'/%3E %3Cuse xlink:href='%23jag' transform='rotate(22.5)'/%3E %3Cuse xlink:href='%23jag' transform='rotate(45)'/%3E %3C/g%3E %3Cuse xlink:href='%23jags3' transform='rotate(67.5)'/%3E %3C/g%3E %3Cuse xlink:href='%23jags6' transform='scale(-1, 1)'/%3E %3C/g%3E %3Cg transform='translate(0,58.7867965644) scale(8.1433982822)'%3E %3Ccircle r='1'/%3E %3Cg id='rays4'%3E %3Cg id='rays2'%3E %3Cpath id='ray' d='M 0.258819045103,0.965925826289 L 0,1.576749285537 L -0.258819045103,0.965925826289'/%3E %3Cuse xlink:href='%23ray' transform='rotate(180)'/%3E %3C/g%3E %3Cuse xlink:href='%23rays2' transform='rotate(90)'/%3E %3C/g%3E %3Cuse xlink:href='%23rays4' transform='rotate(30)'/%3E %3Cuse xlink:href='%23rays4' transform='rotate(60)'/%3E %3C/g%3E %3C/g%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 600 300'%3E %3Crect fill='%23002b7f' width='600' height='300'/%3E %3Crect fill='%23ffc61e' y='137.5' width='600' height='25'/%3E %3Cpath fill='%23fff' d='M 150,262.5 L 143.5295,236.6481 L 125,255.8012 L 132.3223,230.1777 L 106.6987,237.5 L 125.8519,218.9705 L 100,212.5 L 125.8519,206.0295 L 106.6987,187.5 L 132.3223,194.8223 L 125,169.1988 L 143.5295,188.3519 L 150,162.5 L 156.4705,188.3519 L 175,169.1988 L 167.6777,194.8223 L 193.3013,187.5 L 174.1481,206.0295 L 200,212.5 L 174.1481,218.9705 L 193.3013,237.5 L 167.6777,230.1777 L 175,255.8012 L 156.4705,236.6481 L 150,262.5 z'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 120 60'%3E %3CclipPath id='t'%3E %3Cpath d='M0,0V15H70V30H60zM0,30V40H30V0H60z'/%3E %3C/clipPath%3E %3Ctitle%3EFlag of Niue%3C/title%3E %3Crect width='120' height='60' fill='%23002868'/%3E %3Cg stroke='%23cf142b' stroke-width='6'%3E %3Cpath d='M0,0L60,30M60,0L0,30' stroke='%23fff'/%3E %3Cpath d='M0,0L60,30M60,0L0,30' clip-path='url(%23t)' stroke-width='4'/%3E %3Cpath d='M30,0V40M0,15H70' stroke='%23fff' stroke-width='10'/%3E %3Cpath d='M30,0V40M0,15H70'/%3E %3C/g%3E %3Cpath d='M60,0h60V60H0V30H60z' fill='%23fcd116'/%3E %3Cg transform='translate(30,15)'%3E %3Cg transform='scale(5.10390485)'%3E %3Ccircle r='1' fill='%23002868'/%3E %3Cpath id='s' d='M0,-513674 301930,415571 -488533,-158734H488533L-301930,415571' fill='%23fcd116' transform='scale(0.00000194676)'/%3E %3C/g%3E %3Cuse xlink:href='%23s' transform='translate(-17.5,0.29) scale(3)'/%3E %3Cuse xlink:href='%23s' transform='translate(17.5,0.29) scale(3)'/%3E %3Cuse xlink:href='%23s' transform='translate(0,10.29) scale(3)'/%3E %3Cuse xlink:href='%23s' transform='translate(0,-9.71) scale(3)'/%3E %3C/g%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 1200 600'%3E %3Cdefs%3E %3CclipPath id='Canton'%3E %3Cpath d='M 0,0 L 600,0 L 600,300 L 0,300 z'/%3E %3C/clipPath%3E %3CclipPath id='Diagonals'%3E %3Cpath d='M 0,0 L 300,150 L 0,150 z M 300,0 L 600,0 L 300,150 z M 300,150 L 600,150 L 600,300 z M 300,150 L 300,300 L 0,300 z'/%3E %3C/clipPath%3E %3Cg id='Pentagram'%3E %3Cg id='Arm' transform='translate(0,-0.324925)'%3E %3Cpath d='M 0,0 L 0,0.5 L 1,0 z'/%3E %3Cpath d='M 0,0 L 0,-0.5 L 1,0 z' transform='rotate(-36,1,0)'/%3E %3C/g%3E %3Cuse xlink:href='%23Arm' transform='scale(-1,1)'/%3E %3Cuse xlink:href='%23Arm' transform='rotate(72,0,0)'/%3E %3Cuse xlink:href='%23Arm' transform='rotate(-72,0,0)'/%3E %3Cuse xlink:href='%23Arm' transform='rotate(-72,0,0) scale(-1,1)'/%3E %3C/g%3E %3C/defs%3E %3Crect fill='%2300247d' x='0' y='0' width='1200' height='600'/%3E %3Cg id='Flag_of_the_United_Kingdom'%3E %3Cpath id='Saint_Andrews_Cross' stroke='%23ffffff' d='M 0,0 L 600,300 M 0,300 L 600,0' stroke-width='60' clip-path='url(%23Canton)'/%3E %3Cpath id='Saint_Patricks_Cross' stroke='%23cc142b' d='M 0,0 L 600,300 M 0,300 L 600,0' stroke-width='40' clip-path='url(%23Diagonals)'/%3E %3Cg id='Saint_Georges_Cross'%3E %3Cpath stroke='%23ffffff' d='M 300,0 L 300,300 M 0,150 L 600,150' stroke-width='100' clip-path='url(%23Canton)'/%3E %3Cpath stroke='%23cc142b' d='M 300,0 L 300,300 M 0,150 L 600,150' stroke-width='60' clip-path='url(%23Canton)'/%3E %3C/g%3E %3C/g%3E %3Cg id='Southern_Cross'%3E %3Cg id='Gamma_Crucis'%3E %3Cuse xlink:href='%23Pentagram' fill='%23ffffff' transform='translate(900,120) scale(45.4)'/%3E %3Cuse xlink:href='%23Pentagram' fill='%23cc142b' transform='translate(900,120) scale(30)'/%3E %3C/g%3E %3Cg transform='rotate(82,900,240)'%3E %3Cg id='Delta_Crucis'%3E %3Cuse xlink:href='%23Pentagram' fill='%23ffffff' transform='translate(900,120) rotate(-82) scale(40.4)'/%3E %3Cuse xlink:href='%23Pentagram' fill='%23cc142b' transform='translate(900,120) rotate(-82) scale(25)'/%3E %3C/g%3E %3Cg id='Beta_Crucis'%3E %3Cuse xlink:href='%23Pentagram' fill='%23ffffff' transform='translate(900,380) rotate(-82) scale(45.4)'/%3E %3Cuse xlink:href='%23Pentagram' fill='%23cc142b' transform='translate(900,380) rotate(-82) scale(30)'/%3E %3C/g%3E %3C/g%3E %3Cg id='Alpha_Crucis'%3E %3Cuse xlink:href='%23Pentagram' fill='%23ffffff' transform='translate(900,480) scale(50.4)'/%3E %3Cuse xlink:href='%23Pentagram' fill='%23cc142b' transform='translate(900,480) scale(35)'/%3E %3C/g%3E %3C/g%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 1200 600'%3E %3Ctitle%3EFlag of Oman%3C/title%3E %3Crect width='1200' fill='%23db161b' height='600'/%3E %3Crect height='200' width='900' x='300' fill='%23fff'/%3E %3Crect height='200' width='900' y='400' x='300' fill='%23008000'/%3E %3Cg id='a' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.26422498pt' fill='%23fff'%3E %3Crect rx='3.2154' ry='3.0152' height='21.217' width='38.669' y='102.64' x='65.854' stroke-width='0.28333pt'/%3E %3Crect rx='3.0505' ry='2.764' height='19.449' width='36.686' y='103.52' x='66.846' stroke-width='0.26422pt'/%3E %3Cpath d='M83.904,108.83l1.853,0.06,0.084,0.84,1.516,0.77,1.18-0.96,1.431,0.77-1.347,0.84,0.337,1.16,1.684-0.06v1.55l-1.347-0.07-0.674,0.97,1.516,1.1-1.179,0.9-1.264-0.97-1.853,0.39,0.084,1.42-2.021,0.13-0.253-1.36-1.684-0.71-0.927,0.97-1.432-0.71,0.843-1.1-1.011-0.71h-1.432l-0.084-2,1.432,0.13,1.01-1.16-1.179-0.9,1.516-1.04,1.095,0.84,1.853-0.25,0.253-0.84z' stroke-width='0.16681166pt'/%3E %3Cellipse cx='68.944' cy='426.78' rx='11.049' ry='9.9439' transform='matrix(0.1841806,0,0,0.1752043,71.76647,38.246478)' stroke-width='1pt'/%3E %3Cpath d='M71.803,104.41l-2.974,2.65'/%3E %3Cpath d='M73.786,104.41l-2.974,2.65'/%3E %3Cpath d='M75.769,104.41l-2.974,2.65'/%3E %3Cpath d='M77.752,104.41l-2.974,2.65'/%3E %3Cpath d='M79.735,104.41l-2.974,2.65'/%3E %3Cpath d='M81.718,104.41l-2.974,2.65'/%3E %3Cpath d='M83.702,104.41l-2.975,2.65'/%3E %3Cpath d='M85.685,104.41l-2.975,2.65'/%3E %3Cpath d='M87.668,104.41l-2.975,2.65'/%3E %3Cpath d='M89.651,104.41l-2.975,2.65'/%3E %3Cpath d='M91.634,104.41l-2.975,2.65'/%3E %3Cpath d='M93.617,104.41l-2.975,2.65'/%3E %3Cpath d='M85.685,104.41l-2.975,2.65'/%3E %3Cpath d='M95.6,104.41l-2.975,2.65'/%3E %3Cpath d='M97.583,104.41l-2.975,2.65'/%3E %3Cpath d='M99.566,104.41l-2.975,2.65'/%3E %3Cpath d='M101.55,104.41l-2.976,2.65'/%3E %3Cpath d='M98.574,104.41l2.976,2.65'/%3E %3Cpath d='M96.591,104.41l2.975,2.65'/%3E %3Cpath d='M94.608,104.41l2.975,2.65'/%3E %3Cpath d='M92.625,104.41l2.975,2.65'/%3E %3Cpath d='M90.642,104.41l2.975,2.65'/%3E %3Cpath d='M88.659,104.41l2.975,2.65'/%3E %3Cpath d='M86.676,104.41l2.975,2.65'/%3E %3Cpath d='M84.693,104.41l2.975,2.65'/%3E %3Cpath d='M82.71,104.41l2.975,2.65'/%3E %3Cpath d='M80.727,104.41l2.975,2.65'/%3E %3Cpath d='M78.744,104.41l2.975,2.65'/%3E %3Cpath d='M76.761,104.41l2.974,2.65'/%3E %3Cpath d='M84.693,104.41l2.975,2.65'/%3E %3Cpath d='M74.778,104.41l2.974,2.65'/%3E %3Cpath d='M72.795,104.41l2.974,2.65'/%3E %3Cpath d='M70.812,104.41l2.974,2.65'/%3E %3Cpath d='M68.829,104.41l2.974,2.65'/%3E %3Cpath d='M71.803,119.43l-2.974,2.66'/%3E %3Cpath d='M73.786,119.43l-2.974,2.66'/%3E %3Cpath d='M75.769,119.43l-2.974,2.66'/%3E %3Cpath d='M77.752,119.43l-2.974,2.66'/%3E %3Cpath d='M79.735,119.43l-2.974,2.66'/%3E %3Cpath d='M81.718,119.43l-2.974,2.66'/%3E %3Cpath d='M83.702,119.43l-2.975,2.66'/%3E %3Cpath d='M85.685,119.43l-2.975,2.66'/%3E %3Cpath d='M87.668,119.43l-2.975,2.66'/%3E %3Cpath d='M89.651,119.43l-2.975,2.66'/%3E %3Cpath d='M91.634,119.43l-2.975,2.66'/%3E %3Cpath d='M93.617,119.43l-2.975,2.66'/%3E %3Cpath d='M85.685,119.43l-2.975,2.66'/%3E %3Cpath d='M95.6,119.43l-2.975,2.66'/%3E %3Cpath d='M97.583,119.43l-2.975,2.66'/%3E %3Cpath d='M99.566,119.43l-2.975,2.66'/%3E %3Cpath d='M101.55,119.43l-2.976,2.66'/%3E %3Cpath d='M98.574,119.43l2.976,2.66'/%3E %3Cpath d='M96.591,119.43l2.975,2.66'/%3E %3Cpath d='M94.608,119.43l2.975,2.66'/%3E %3Cpath d='M92.625,119.43l2.975,2.66'/%3E %3Cpath d='M90.642,119.43l2.975,2.66'/%3E %3Cpath d='M88.659,119.43l2.975,2.66'/%3E %3Cpath d='M86.676,119.43l2.975,2.66'/%3E %3Cpath d='M84.693,119.43l2.975,2.66'/%3E %3Cpath d='M82.71,119.43l2.975,2.66'/%3E %3Cpath d='M80.727,119.43l2.975,2.66'/%3E %3Cpath d='M78.744,119.43l2.975,2.66'/%3E %3Cpath d='M76.761,119.43l2.974,2.66'/%3E %3Cpath d='M84.693,119.43l2.975,2.66'/%3E %3Cpath d='M74.778,119.43l2.974,2.66'/%3E %3Cpath d='M72.795,119.43l2.974,2.66'/%3E %3Cpath d='M70.812,119.43l2.974,2.66'/%3E %3Cpath d='M68.829,119.43l2.974,2.66'/%3E %3C/g%3E %3Cuse xlink:href='%23a' x='-300' transform='scale(-1,1)'/%3E %3Cg id='b'%3E %3Cpath d='M126.51,147.12c-48.114,47.05-68.638,53-59.006,56.79s40.616-20.49,72.856-52.75c32.24-32.25,51.98-60.956,42.35-64.747-9.63-3.792-5.03,10.662-56.2,60.707z' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.42368097pt' fill='%23fff'/%3E %3Cpath d='M86.008,181.31l16.852,4.42c-15.861,15.03-33.708,21.22-38.665,18.57-4.958-2.65,8.923-8.84,21.813-22.99z' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.33028123' fill='%23fff'/%3E %3Cpath d='M86.008,183.08l13.881,3.54c-15.453,14.45-30.737,18.56-34.692,16.8-3.977-1.77,8.255-6.74,20.811-20.34z' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.33028045' fill='%23fff'/%3E %3Cpath d='M137.79,145.06c-0.04,0.23-0.15,1.24-0.25,1.64,0,0.56-0.06,0.98-0.12,1.42-0.16,0.38-0.13,0.73-0.62,0.87-0.33,0.46-0.54,0.58-0.98,0.77-0.3,0.23-0.76,0.46-1.24,0.65-0.49,0.19-0.94,0.21-1.47,0.11-0.44-0.27-0.75-0.54-1.11-0.76-0.09-0.35-0.16-0.86-0.25-1.2,0.13,0.35,0.23,0.91,0.25,1.41-0.05,0.55-0.25,0.79-0.49,1.2' stroke='%23db161b' stroke-width='0.33028081' fill='none'/%3E %3Cpath d='M133.23,152.37c-0.04-0.03-0.08-0.07-0.12-0.11,0.29,0.26,0.17,0.14-0.5-0.21-0.47-0.22-0.98-0.34-1.6-0.44h-1.72c-0.67,0-1.12,0.09-1.6,0.22-0.35,0.31-0.87,0.48-1.23,0.76-0.38,0.23-0.54,0.5-0.74,0.87-0.34,0.3-0.56,0.76-0.87,0.99-0.13,0.5-0.42,0.48-0.61,0.87,0.58,0.04,1.05,0.11,1.35,0.43,0.52,0.24-0.43-0.23-0.61-0.43-0.41-0.11-0.51-0.22-1.11-0.22-0.56-0.16-0.9,0.13-1.48,0.22-0.33,0.17-0.43,0.22-0.86,0.22' stroke='%23db161b' stroke-width='0.33028081' fill='none'/%3E %3Cpath d='M126.58,157.83c-0.25,0.01-1.4,0.2-1.85,0-0.5-0.12-0.8-0.36-1.11-0.77-0.15-0.29,0,0.53,0,0.88-0.05,0.64-0.27,0.65-0.61,1.09-0.36,0.2-0.74,0.49-1.11,0.65-0.31,0.24-0.69,0.4-1.11,0.55-0.37,0.15-0.81,0.31-1.11,0.54-0.41,0.26-0.37,0.58-0.61,0.98,0.04,0.54,0.14,0.84,0.49,1.1,0.14,0.36,0.47,0.73,0.74,0.98,0.3,0.5,0.64,0.73-0.13,0.87-0.42,0.16-0.65,0.03-1.1,0' stroke='%23db161b' stroke-width='0.33028081' fill='none'/%3E %3Cpath d='M118.82,165.46c-0.3-0.06-1.38-0.38-1.85-0.54h-1.72c-0.67,0.04-0.8,0.22-1.36,0.43-0.36,0.33-0.61,0.56-1.11,0.77-0.26,0.3-0.78,0.81-0.98,1.2-0.15,0.37-0.25,0.87-0.25,1.42,0.01,0.63,0.2,0.74,0.25,1.31,0.14,0.46,0.36,0.89,0.74,1.3,0.05,0.14,0.09,0.18,0.24,0.22' stroke='%23db161b' stroke-width='0.33028081' fill='none'/%3E %3Cpath d='M112.95,173c-0.05,0-0.17,0.28-0.35,0.52-0.39,0.4-0.44,0.43-1.05,0.43-0.54-0.02-0.49-0.21-0.87-0.35-0.18-0.27-0.41-0.49-0.61-0.86-0.14-0.22-0.27-0.57-0.44-0.77-0.16-0.26-0.36-0.45-0.53-0.69-0.16-0.07-0.22-0.14-0.43-0.17,0.5,0.08,0.54,0.25,0.87,0.51,0.15,0.25,0.31,0.5,0.44,0.78,0.05,0.37,0.17,0.66,0.17,1.12,0,0.47,0,0.81-0.17,1.2-0.21,0.22-0.36,0.44-0.61,0.61-0.21,0.19-0.46,0.45-0.62,0.68-0.27,0.17-0.47,0.31-0.78,0.52-0.27,0.15-0.55,0.31-0.96,0.35-0.52-0.04-0.67-0.18-1.05-0.35-0.33-0.24-0.59-0.39-0.88-0.6-0.23-0.16-0.46-0.47-0.61-0.69-0.47-0.12-0.77-0.07-1.05,0.17-0.24,0.16-0.45,0.37-0.61,0.6-0.15,0.07-0.38,0.28-0.53,0.35' stroke='%23db161b' stroke-width='0.33028191' fill='none'/%3E %3Cpath d='M103.32,176.56c0.14,0.06,0.64,0.41,0.87,0.54,0.14,0.45,0.36,0.7,0.43,1.18,0.12,0.47,0.11,0.98,0.11,1.51-0.12,0.55-0.35,0.95-0.54,1.39-0.35,0.24-0.52,0.4-0.98,0.65-0.43,0.06-0.86,0.11-1.41,0.11-0.34,0.11-0.98,0.16-1.31,0-0.48-0.07-0.843-0.26-1.194-0.43-0.402-0.23-0.649-0.44-1.088-0.65-0.213-0.31-0.544-0.59-0.869-0.97-0.271-0.36-0.47-0.56-0.653-0.96,0.161,0.46,0.405,0.86,0.544,1.29,0.247,0.45,0.391,0.62,0.435,1.18,0.151,0.45,0.109,0.99,0.109,1.5-0.048,0.35-0.073,1.01-0.218,1.29v0.33' stroke='%23db161b' stroke-width='0.33028162' fill='none'/%3E %3Cpath d='M87.242,186.23v0.16c0-0.42-0.011-0.21,0.175,0.62,0.33,0.37,1.104,0.47,1.749,0.31,0.566-0.41,0.548-0.73,1.574-0.93,0.991,0.06,1.369,0.32,1.924,0.62,0.658,0.29,0.962,0.44,1.399,1.09,0.217,0.53,0.338,0.89-0.35,1.09-0.547,0.35-1.197,0.54-1.924,0.63-0.808,0-1.39-0.09-1.749,0.31-0.555,0.51-0.524,0.82-0.524,1.71-0.187,0.28-0.224,1.1-0.35,1.41-0.486,0.2-0.771,0.31-1.574,0.31-0.189-0.48-0.398-1.35-0.525-1.87-0.137-0.56-0.179-1.34-0.525-1.72-0.326-0.42-0.743-0.8-1.224-1.09-0.214-0.27-0.622-0.49-1.049-0.62,0.686,0.31,0.784,0.65,0.874,1.4-0.603,0.27-0.764,0.46-1.749,0.47-0.968-0.07-1.202-0.29-1.574-0.78-0.067,0.78-0.348,1.04-0.524,1.72-0.36,0.47-0.513,0.95-0.875,1.55,0.154,0.76,0.486,0.79,0.525,1.72,0.227,0.61,0.202,1.19,0.699,1.56,0.222,0.24,0.388,0.29,0.875,0.31-1.013,0-1.603-0.1-2.274-0.47-0.519-0.28-0.911-0.64-1.399-0.93-0.619-0.4-1.384-0.77-2.099-0.94-0.808,0-1.39-0.08-1.749,0.31-0.495,0.32-0.828,0.86-1.049,1.56-0.162,0.81-0.224,1.35,0.175,1.87,0.296,0.61,0.363,0.84,0,1.56-0.407,0.51-1.012,0.57-1.924,0.78-0.666-0.03-1.306-0.16-1.749-0.31' stroke='%23db161b' stroke-width='0.33028123' fill='none'/%3E %3Cpath d='M181.41,104.66c21.35-36.858,35.52-68.222,31.62-70.014-3.89-1.791-24.37,26.665-45.72,63.518l14.1,6.496z' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.33520904pt' fill='%23fff'/%3E %3Cpath d='M180,104.01c20.59-35.557,34.78-65.574,31.67-67.007s-22.35,26.258-42.95,61.81' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.29448283pt' fill='%23fff'/%3E %3Cpath d='M176.46,85.461c-2.51,4.157-5.16,8.908-7.74,13.352l11.28,5.197c2.57-4.448,5.38-9.13,7.73-13.356l-11.27-5.193z' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.33422136pt' fill='%23fff'/%3E %3Cpath d='M177.41,86.895c-2.5,4.157-4.25,7.338-6.82,11.782l8.45,3.893c2.58-4.442,4.48-7.554,6.83-11.78l-8.46-3.895z' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.33422136pt' fill='%23fff'/%3E %3Crect transform='matrix(-0.9083207,-0.4182743,-0.5012544,0.8653,0,0)' height='9.9849' width='6.2072' stroke='%23db161b' y='6.5585' x='-205.69' stroke-width='0.33495pt' fill='%23fff'/%3E %3Cpath d='M183.55,91.712l-10.64,6.043' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.33422136pt' fill='%23fff'/%3E %3Cpath d='M178.54,100.35l-0.63-11.235' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.33422136pt' fill='%23fff'/%3E %3Cpath d='M209.03,47.727l-5.64-2.597' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.33422136pt' fill='%23fff'/%3E %3Cellipse rx='3.5433' ry='3.5433' stroke='%23db161b' transform='matrix(-0.4490005,0.1132067,0.1013394,0.3938715,444.34717,-55.797864)' cy='92.126' cx='545.67' stroke-width='1pt' fill='%23db161b'/%3E %3C/g%3E %3Cuse xlink:href='%23b' x='-300' transform='scale(-1,1)'/%3E %3Cpath d='M135.26,84.958c0,30.942,0.18,42.602-2.1,44.202-2.16,1.71-62.348,0-62.348,8.84s49.578,17.68,64.448,17.68c19.83,0,29.75-8.84,29.75-26.52v-44.202h-29.75z' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.30510197pt' fill='%23fff'/%3E %3Cpath d='M135.26,93.798v4.42c9.92,1.474,19.83,1.474,29.75,0v-4.42c-9.92,1.474-19.83,1.474-29.75,0z' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.26422367pt' fill='%23fff'/%3E %3Cpath d='M135.26,84.958v4.42c9.92,1.473,19.83,1.473,29.75,0v-4.42c-9.92,1.473-19.83,1.473-29.75,0z' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.26422367pt' fill='%23fff'/%3E %3Cpath d='M135.26,89.378v4.42c9.92,1.474,19.83,1.474,29.75,0v-4.42c-9.92,1.473-19.83,1.473-29.75,0z' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.26422367pt' fill='%23fff'/%3E %3Cpath d='M135.26,98.218v4.422c9.92,1.47,19.83,1.47,29.75,0v-4.422c-9.92,1.474-19.83,1.474-29.75,0z' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.26422367pt' fill='%23fff'/%3E %3Cellipse rx='8.8583' ry='26.575' stroke='%23db161b' transform='matrix(0.1526333,0,0,3.5883686e-2,97.402506,84.325604)' cy='210.83' cx='256.89' stroke-width='4.4628' fill='%23fff'/%3E %3Cellipse rx='8.8583' ry='26.575' stroke='%23db161b' transform='matrix(0.1526333,0,0,3.5883686e-2,97.40259,83.530922)' cy='246.26' cx='292.32' stroke-width='4.4628' fill='%23fff'/%3E %3Cellipse rx='8.8583' ry='26.575' stroke='%23db161b' transform='matrix(0.1526333,0,0,3.5883436e-2,97.40259,83.372046)' cy='263.98' cx='327.76' stroke-width='4.4629' fill='%23fff'/%3E %3Cellipse rx='8.8583' ry='26.575' stroke='%23db161b' transform='matrix(0.1526333,0,0,3.5883436e-2,97.40259,83.372046)' cy='263.98' cx='363.19' stroke-width='4.4629' fill='%23fff'/%3E %3Cellipse rx='8.8583' ry='26.575' stroke='%23db161b' transform='matrix(0.1526333,0,0,3.5883686e-2,97.40259,83.530922)' cy='246.26' cx='398.62' stroke-width='4.4628' fill='%23fff'/%3E %3Cellipse rx='8.8583' ry='26.575' stroke='%23db161b' transform='matrix(0.1526333,0,0,3.5883686e-2,97.402534,84.325604)' cy='210.83' cx='434.06' stroke-width='4.4628' fill='%23fff'/%3E %3Cg fill-rule='evenodd' stroke='%23db161b' stroke-width='0.26422498pt' fill='%23fff'%3E %3Cpath d='M135.26,107.06l29.75,23.87'/%3E %3Cpath d='M138.23,107.06l26.78,21.21'/%3E %3Cpath d='M142.2,107.94l22.81,17.68'/%3E %3Cpath d='M145.18,107.94l19.83,15.03'/%3E %3Cpath d='M148.15,107.94l16.86,12.38'/%3E %3Cpath d='M151.12,107.94l13.89,9.73'/%3E %3Cpath d='M154.1,107.94l10.91,7.07'/%3E %3Cpath d='M157.07,107.94l7.94,5.31'/%3E %3Cpath d='M160.05,107.94l4.96,3.54'/%3E %3Cpath d='M163.02,107.94l1.99,1.77'/%3E %3Cpath d='M135.26,109.71l29.75,23.87'/%3E %3Cpath d='M165.01,107.06l-32.72,26.52'/%3E %3Cpath d='M162.03,107.06l-28.75,22.98'/%3E %3Cpath d='M158.07,107.94l-22.81,17.68'/%3E %3Cpath d='M155.09,107.94l-19.83,15.03'/%3E %3Cpath d='M152.12,107.94l-16.86,12.38'/%3E %3Cpath d='M149.14,107.94l-13.88,9.73'/%3E %3Cpath d='M146.17,107.94l-10.91,7.07'/%3E %3Cpath d='M143.19,107.94l-7.93,5.31'/%3E %3Cpath d='M140.22,107.94l-4.96,3.54'/%3E %3Cpath d='M137.24,107.94l-1.98,1.77'/%3E %3Cpath d='M165.01,109.71l-32.72,26.52'/%3E %3Cpath d='M165.01,112.36l-32.72,26.52'/%3E %3Cpath d='M165.01,115.01l-32.72,26.53'/%3E %3Cpath d='M165.01,117.67l-32.72,26.52'/%3E %3Cpath d='M165.01,120.32l-32.72,26.52'/%3E %3Cpath d='M165.01,122.97l-32.72,26.52'/%3E %3Cpath d='M165.01,125.62l-32.72,26.52'/%3E %3Cpath d='M165.01,128.28l-32.72,26.52'/%3E %3Cpath d='M165.01,130.93l-30.74,24.75'/%3E %3Cpath d='M165.01,133.58l-27.77,22.1'/%3E %3Cpath d='M164.01,137.12l-21.81,17.68'/%3E %3Cpath d='M163.02,140.65l-17.84,14.15'/%3E %3Cpath d='M161.04,145.07l-8.92,7.07'/%3E %3Cpath d='M135.26,112.36l28.75,22.99'/%3E %3Cpath d='M135.26,115.01l28.75,22.99'/%3E %3Cpath d='M135.26,117.67l27.76,22.1'/%3E %3Cpath d='M135.26,120.32l27.76,22.1'/%3E %3Cpath d='M135.26,122.97l26.77,21.22'/%3E %3Cpath d='M134.27,124.74l26.77,21.22'/%3E %3Cpath d='M134.27,127.39l24.79,19.45'/%3E %3Cpath d='M133.28,129.16l24.79,19.45'/%3E %3Cpath d='M132.29,130.93l23.79,18.56'/%3E %3Cpath d='M132.29,133.58l22.8,17.68'/%3E %3Cpath d='M132.29,136.23l19.83,15.91'/%3E %3C/g%3E %3Cpath d='M135.26,102.64v4.42c9.92,1.47,19.83,1.47,29.75,0v-4.42c-9.92,1.47-19.83,1.47-29.75,0z' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.26422367pt' fill='%23fff'/%3E %3Cpath d='M132.29,138.88l17.84,14.15' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.26422498pt' fill='%23fff'/%3E %3Cpath d='M132.29,141.54l15.86,12.37' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.26422498pt' fill='%23fff'/%3E %3Cpath d='M132.29,144.19l13.88,10.61' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.26422498pt' fill='%23fff'/%3E %3Cpath d='M132.29,146.84l9.91,7.96' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.26422498pt' fill='%23fff'/%3E %3Cpath d='M132.29,149.49l7.93,6.19' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.26422498pt' fill='%23fff'/%3E %3Cpath d='M132.29,152.14l4.95,3.54' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.26422498pt' fill='%23fff'/%3E %3Cellipse rx='8.8583' ry='26.575' stroke='%23db161b' transform='matrix(0.1526333,0,0,3.5883686e-2,97.402506,97.586004)' cy='210.83' cx='256.89' stroke-width='4.4628' fill='%23fff'/%3E %3Cellipse rx='8.8583' ry='26.575' stroke='%23db161b' transform='matrix(0.1526333,0,0,3.5883686e-2,97.40259,96.791347)' cy='246.26' cx='292.32' stroke-width='4.4628' fill='%23fff'/%3E %3Cellipse rx='8.8583' ry='26.575' stroke='%23db161b' transform='matrix(0.1526333,0,0,3.5883436e-2,97.40259,96.632446)' cy='263.98' cx='327.76' stroke-width='4.4629' fill='%23fff'/%3E %3Cellipse rx='8.8583' ry='26.575' stroke='%23db161b' transform='matrix(0.1526333,0,0,3.5883436e-2,97.40259,96.632446)' cy='263.98' cx='363.19' stroke-width='4.4629' fill='%23fff'/%3E %3Cellipse rx='8.8583' ry='26.575' stroke='%23db161b' transform='matrix(0.1526333,0,0,3.5883686e-2,97.40259,96.791347)' cy='246.26' cx='398.62' stroke-width='4.4628' fill='%23fff'/%3E %3Cellipse rx='8.8583' ry='26.575' stroke='%23db161b' transform='matrix(0.1526333,0,0,3.5883686e-2,97.402534,97.586004)' cy='210.83' cx='434.06' stroke-width='4.4628' fill='%23fff'/%3E %3Cg fill-rule='evenodd' stroke='%23db161b' stroke-width='0.26422498pt' fill='%23fff'%3E %3Cpath d='M92.625,148.61l35.695-18.57'/%3E %3Cpath d='M90.642,147.72l33.708-17.68'/%3E %3Cpath d='M89.651,145.96l30.739-15.92'/%3E %3Cpath d='M88.659,144.19l26.771-14.15'/%3E %3Cpath d='M86.676,142.42l24.784-12.38'/%3E %3Cpath d='M87.668,139.77l16.852-8.84'/%3E %3Cpath d='M86.676,138l12.89-7.07'/%3E %3Cpath d='M86.676,135.35l8.924-4.42'/%3E %3Cpath d='M95.6,149.49l33.71-17.68'/%3E %3Cpath d='M98.574,150.38l31.726-16.8'/%3E %3Cpath d='M101.55,151.26l29.74-15.91'/%3E %3Cpath d='M104.52,152.14l24.79-13.26'/%3E %3Cpath d='M108.49,152.14l21.81-11.49'/%3E %3Cpath d='M111.46,153.03l18.84-9.73'/%3E %3Cpath d='M114.44,153.91l14.87-7.95'/%3E %3Cpath d='M118.4,153.91l11.9-6.19'/%3E %3Cpath d='M122.37,154.8l7.93-4.42'/%3E %3Cpath d='M126.34,154.8l4.95-2.66'/%3E %3C/g%3E %3Cpath d='M133.28,129.16h-4.96c-1.65,8.84-1.65,17.68,0,26.52h4.96c-1.66-8.84-1.66-17.68,0-26.52z' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.26422367pt' fill='%23fff'/%3E %3Cpath d='M74.778,141.54l11.898-8.84' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.26422498pt' fill='%23fff'/%3E %3Cpath d='M74.778,135.35l11.898,10.61' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.26422498pt' fill='%23fff'/%3E %3Cpath d='M92.625,130.93l-5.949,0.88c-1.322,5.6-1.322,10.31,0,15.91l5.949,1.77c-1.322-5.6-1.322-12.96,0-18.56z' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.18807621pt' fill='%23fff'/%3E %3Cpath d='M164.97,86.726v-4.457c-4.45,0.037-7.43-2.615-7.43-5.305l-14.85,0.037c0,2.653-2.97,5.305-7.43,5.305v4.42h29.71z' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.32342911pt' fill='%23fff'/%3E %3Crect height='5.3041' width='12.734' stroke='%23db161b' y='71.697' x='143.75' stroke-width='0.27335pt' fill='%23fff'/%3E %3Crect height='5.3042' width='10.612' stroke='%23db161b' y='66.393' x='144.81' stroke-width='0.27335pt' fill='%23fff'/%3E %3Crect height='5.3042' width='10.612' stroke='%23db161b' y='61.089' x='144.81' stroke-width='0.27335pt' fill='%23fff'/%3E %3Crect height='7.0722' width='8.4893' stroke='%23db161b' y='54.017' x='145.87' stroke-width='0.27335pt' fill='%23fff'/%3E %3Crect height='6.1882' width='9.2211' stroke='%23db161b' y='47.829' x='145.51' stroke-width='0.28488pt' fill='%23fff'/%3E %3Cellipse rx='42.52' ry='33.661' stroke='%23db161b' transform='matrix(0.2891558,0,0,0.249492,81.982856,1.8592021)' cy='161.22' cx='237.4' stroke-width='1pt' fill='%23fff'/%3E %3Cpath d='M156.78,41.64c0,2.319,3.07,6.189,3.07,6.189-2.23,1.52-5.83,2.652-9.22,2.652s-7.62-0.631-9.22-2.652c0,0,3.07-3.87,3.07-6.189,0-2.318-3.07-5.304-3.07-5.304,2.22-1.52,5.83-2.652,9.22-2.652s6.99,1.132,9.22,2.652c0,0-3.07,2.986-3.07,5.304z' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.26859274pt' fill='%23fff'/%3E %3Cpath d='M154.73,41.64c0,2.319,3.07,7.073,3.07,7.073-2.22,1.52-3.78,1.768-7.17,1.768s-5.57,0.253-7.17-1.768c0,0,3.07-4.754,3.07-7.073,0-2.318-3.07-6.188-3.07-6.188,2.22-1.52,3.78-1.768,7.17-1.768s4.95,0.248,7.17,1.768c0,0-3.07,3.87-3.07,6.188z' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.26859274pt' fill='%23fff'/%3E %3Cellipse rx='10.63' ry='10.63' stroke='%23db161b' transform='matrix(0.2891558,0,0,0.249492,81.982856,0.9751721)' cy='166.54' cx='194.88' stroke-width='1pt' fill='%23fff'/%3E %3Cellipse rx='10.63' ry='10.63' stroke='%23db161b' transform='matrix(0.2891558,0,0,0.249492,106.57247,0.9751721)' cy='166.54' cx='194.88' stroke-width='1pt' fill='%23fff'/%3E %3Cellipse rx='10.63' ry='10.63' stroke='%23db161b' transform='matrix(0.2891558,0,0,0.249492,94.277639,0.9751721)' cy='166.54' cx='194.88' stroke-width='1pt' fill='%23fff'/%3E %3Cellipse rx='10.63' ry='10.63' stroke='%23db161b' transform='matrix(0.2891558,0,0,0.249492,94.277639,-7.8650879)' cy='166.54' cx='194.88' stroke-width='1pt' fill='%23fff'/%3E %3Cellipse rx='10.63' ry='10.63' stroke='%23db161b' transform='matrix(0.2994823,0,0,0.249492,83.263631,42.524442)' cy='166.54' cx='194.88' stroke-width='1pt' fill='%23fff'/%3E %3Cellipse rx='10.63' ry='10.63' stroke='%23db161b' transform='matrix(0.2994823,0,0,0.249492,100.24214,42.524442)' cy='166.54' cx='194.88' stroke-width='1pt' fill='%23fff'/%3E %3Cpath d='M142.69,77.001h14.85l-7.42,7.957-7.43-7.957z' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.27334673pt' fill='%23fff'/%3E %3Cellipse rx='10.63' ry='10.63' stroke='%23db161b' transform='matrix(0.3993101,0,0,0.3326564,72.298311,27.790617)' cy='166.54' cx='194.88' stroke-width='1pt' fill='%23fff'/%3E %3Crect rx='1.2377' ry='0.93811' height='5.3042' width='22.805' stroke='%23db161b' y='109.72' x='133.77' stroke-width='0.33028' fill='%23fff'/%3E %3Cpath d='M163.52,105.3c-2.75,0-4.96,2.06-4.96,4.62v4.02c0,2.56,2.21,4.62,4.96,4.62s4.96-2.06,4.96-4.62v-4.02c0-2.56-2.21-4.62-4.96-4.62zm0,1.77c-1.65,0-2.98,1.65-2.98,3.7v2.33c0,2.05,1.33,3.69,2.98,3.69s2.97-1.64,2.97-3.69v-2.33c0-2.05-1.32-3.7-2.97-3.7z' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.33028123' fill='%23fff'/%3E %3Cpath d='M137.74,106.19c-1.65,0-2.97,1.64-2.97,3.69v4.1c0,2.05,1.32,3.7,2.97,3.7s2.97-1.65,2.97-3.7v-4.1c0-2.05-1.32-3.69-2.97-3.69zm0-1.77c-2.75,0-4.96,2.06-4.96,4.62v5.79c0,2.56,2.21,4.62,4.96,4.62s4.96-2.06,4.96-4.62v-5.79c0-2.56-2.21-4.62-4.96-4.62z' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.33028123' fill='%23fff'/%3E %3Cpath d='M129.81,107.95c-1.65,0-2.98,1.65-2.98,3.7v0.96c0,2.05,1.33,3.7,2.98,3.7s2.97-1.65,2.97-3.7v-0.96c0-2.05-1.32-3.7-2.97-3.7zm0-1.76c-2.75,0-4.96,2.06-4.96,4.62v2.65c0,2.56,2.21,4.62,4.96,4.62,2.74,0,4.96-2.06,4.96-4.62v-2.65c0-2.56-2.22-4.62-4.96-4.62z' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.33028123' fill='%23fff'/%3E %3Cpath d='M117.91,105.51c-2.97,0-5.35,1.84-5.35,4.13v4.58c0,2.29,2.38,4.13,5.35,4.13s5.35-1.84,5.35-4.13v-4.58c0-2.29-2.38-4.13-5.35-4.13zm0-1.98c-4.94,0-8.92,2.31-8.92,5.17v6.47c0,2.86,3.98,5.16,8.92,5.16s8.92-2.3,8.92-5.16v-6.47c0-2.86-3.98-5.17-8.92-5.17z' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.33028102' fill='%23fff'/%3E %3Cpath d='M182.36,106.39c-2.97,0-5.36,1.85-5.36,4.14v4.58c0,2.29,2.39,4.13,5.36,4.13,2.96,0,5.35-1.84,5.35-4.13v-4.58c0-2.29-2.39-4.14-5.35-4.14zm0-1.97c-4.95,0-8.93,2.3-8.93,5.16v6.47c0,2.86,3.98,5.16,8.93,5.16,4.94,0,8.92-2.3,8.92-5.16v-6.47c0-2.86-3.98-5.16-8.92-5.16z' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.33028102' fill='%23fff'/%3E %3Crect rx='0.64577' ry='0.93811' height='5.3042' width='11.898' stroke='%23db161b' y='109.72' x='165.5' stroke-width='0.33028' fill='%23fff'/%3E %3Crect rx='0.3767' ry='1.2508' height='7.0722' width='6.9406' stroke='%23db161b' y='108.84' x='154.6' stroke-width='0.33028' fill='%23fff'/%3E %3Crect rx='0.3767' ry='1.2508' height='7.0722' width='6.9406' stroke='%23db161b' y='108.84' x='121.88' stroke-width='0.33028' fill='%23fff'/%3E %3Crect rx='0.7534' ry='1.5635' height='8.8403' width='13.881' stroke='%23db161b' y='107.95' x='100.06' stroke-width='0.33028' fill='%23fff'/%3E %3Crect rx='0.69959' ry='1.5635' height='8.8403' width='12.89' stroke='%23db161b' y='108.84' x='186.32' stroke-width='0.33028' fill='%23fff'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 36 24'%3E %3Crect width='36' height='24' fill='%23fff'/%3E %3Cg fill='%23005293'%3E %3Cg id='star' transform='translate(9,6)'%3E %3Cg id='c'%3E %3Cpath id='t' d='M 0,-3 v 3 h 1.5 z' transform='rotate(18 0,-3)'/%3E %3Cuse xlink:href='%23t' transform='scale(-1,1)'/%3E %3C/g%3E %3Cuse xlink:href='%23c' transform='rotate(72)'/%3E %3Cuse xlink:href='%23c' transform='rotate(144)'/%3E %3Cuse xlink:href='%23c' transform='rotate(216)'/%3E %3Cuse xlink:href='%23c' transform='rotate(288)'/%3E %3C/g%3E %3Crect y='12' width='18' height='12'/%3E %3C/g%3E %3Cg fill='%23d21034'%3E %3Crect x='18' width='18' height='12'/%3E %3Cuse xlink:href='%23star' x='18' y='12'/%3E %3C/g%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 900 600'%3E %3Cpath fill='%23d91023' d='M0 0h900v600H0z'/%3E %3Cpath fill='%23fff' d='M300 0h300v600H300z'/%3E %3Cg transform='matrix(.25 0 0 .25 345 179.188)' stroke='%23d4af37' stroke-width='2' fill='%2300a854'%3E %3Cg transform='matrix(.44722 -.20656 .2582 .35777 89.404 -67.294)' id='g' stroke-width='4.33'%3E %3Cpath d='M480.212 566.87c31.28 33.04 62.37 68.152 78.925 111.21 25.21 69.711 18.346 151.527-22.518 213.983-34.388 51.789-85.32 91.514-141.97 116.401-51.945 21.524-112.113 23.773-164.827 3.54-20.114-7.373-38.889-17.914-57.51-28.315-8.441-1.44-13.874 8.648-6.988 13.292 62.35 40.624 130.86 42.249 202.053 28.197 36.106-9.534 69.76-27.273 98.991-50.401 44.36-33.229 82.625-77.439 99.76-130.902 26.131-78.994 9.286-171.344-45.167-234.649-13.723-16.785-28.875-32.351-44.687-47.168l3.938 4.813z'/%3E %3Cpath d='M170.57 983.29c-8.079-.843-12.167 11.815-5.077 13.643 4.182-1.01 10.665-12.011 5.076-13.642zM474.835 552.405c-4.503-5.593-14.062-2.886-17.759-7.3-3.94-4.706 2.887-6.51-.226-9.991-3.113-3.48-7.746-1.747-11.998-6.498-4.251-4.75-.422-8.776-4.09-12.099-3.667-3.322-4.171.887-8.372-3.724-4.2-4.612-1.717-12.71-6.304-18.558-4.481-5.712-2.984-12.5 2.496-11.257 3.644.826 5.064 4.385 10.468 5.756 5.404 1.372 7.577-2.577 11.118.904 3.542 3.481.308 9.122 4.105 13.971 3.798 4.85 5.83 1.303 8.515 5.626 2.686 4.323.5 6.61 2.228 11.666 1.729 5.056 8.377 3.105 10.869 10.748 2.492 7.643-1.05 20.756-1.05 20.756z'/%3E %3Cpath d='M478.146 564.793c-5.561-26.182-26.97-56.915-52.595-79.474 15.222 11.956 44.848 40.53 54.361 79.28l-1.766.194z'/%3E %3Cpath d='M460.18 524.426c-4.162-2.885-7.254-2.85-10.507-3.257 2.963-.163 5.873-.472 9.492 1.156l1.014 2.101zM445.001 505.477c-4.502-1.455-7.443-.392-10.62.29 2.794-1.147 5.51-2.419 9.262-2.021l1.358 1.73zM449.378 508.855c-2.195-5.54-2.198-9.678-2.533-14.028-.094 3.967-.298 7.863.952 12.69l1.58 1.338zM462.899 527.04c-2.195-5.54-2.198-9.677-2.533-14.027-.094 3.966-.298 7.863.953 12.69l1.58 1.338zM555.176 682.062c-8.257-3.177-17.17-.031-23.877-2.453-7.148-2.582 1.14-8.575-4.41-10.366-5.548-1.79-10.208 5.644-17.785 3.202-7.578-2.442-6.322-10.125-12.54-11.417-6.218-1.291-6.37 7.191-13.822 4.865-7.453-2.327-7.5-12.33-15.974-15.724-8.276-3.314-9.088-11.348-1.33-13.33 5.16-1.318 10.29 1.936 18.002.135s6.976-8.643 13.093-7.11c6.116 1.535 4.355 10.427 11.373 13.246 7.017 2.818 11.366-4.905 16.697-1.972 5.33 2.932.26 9.424 4.625 13.701 4.367 4.277 7.736-2.34 14.176 4.2 6.44 6.538 11.772 23.023 11.772 23.023z'/%3E %3Cpath d='M563.504 691.584c-22.904-25.577-58.656-41.392-101.83-49.728 25.052 3.433 76.71 14.954 105.234 49.976l-3.404-.248z'/%3E %3Cpath d='M524.282 661.447c-6.69-.536-10.766 1.355-15.236 2.88 3.851-1.95 7.573-4.02 13.029-4.48l2.207 1.6zM496.411 650.636c-6.554 1.172-10.006 4.054-13.927 6.677 3.224-2.882 6.292-5.848 11.419-7.682l2.508 1.005zM503.589 651.561c-5.183-4.507-6.89-8.854-9.121-13.225 1.507 4.226 2.841 8.443 6.48 12.767l2.64.458zM528.954 662.563c-5.183-4.507-6.89-8.854-9.121-13.225 1.507 4.226 2.84 8.443 6.48 12.767l2.64.458zM554.74 885.605c6.924-5.379 9.128-14.933 14.625-19.391 5.859-4.753 6.268 5.877 10.646 2.066 4.377-3.81.889-12.104 6.864-17.31 5.974-5.206 11.467.264 15.799-4.413 4.332-4.678-2.387-9.643 3.43-14.807 5.815-5.163 13.859.495 21.071-4.949 7.045-5.317 13.915-1.447 11.39 6.438-1.679 5.243-7.007 7.856-9.652 15.597-2.645 7.74 3.23 10.999-1.243 15.45-4.472 4.452-10.667-2.148-16.646 2.356-5.98 4.504-2.095 12.69-7.272 15.661-5.177 2.97-7.692-5.144-13.435-3.78-5.743 1.366-2.226 8.069-10.882 9.95-8.655 1.883-24.696-2.868-24.696-2.868z'/%3E %3Cpath d='M542.691 887.43c32.645-5.369 64.277-27.486 93.849-60.328-16.034 19.857-52.657 58.27-95.853 63.151l2.004-2.822z'/%3E %3Cpath d='M587.643 870.452c3.977-5.52 4.621-10.146 5.77-14.907-.48 4.464-.794 8.885-3.317 13.897l-2.453 1.01zM611.085 852.345c2.535-6.374 2.056-11.022 2.032-15.93.6 4.448 1.352 8.81.103 14.318l-2.135 1.612zM606.538 858.067c6.36-1.944 10.75-.953 15.437-.406-4.187-1.095-8.275-2.337-13.67-1.631l-1.767 2.037zM584.271 873.884c6.36-1.945 10.75-.954 15.437-.406-4.187-1.096-8.275-2.337-13.67-1.632l-1.767 2.038zM586.501 789.94c5.85-6.618 6.32-16.43 10.93-21.87 4.915-5.797 7.205 4.57 10.83-.016 3.626-4.587-1.275-12.066 3.673-18.331 4.947-6.266 11.317-1.946 14.743-7.376 3.427-5.43-4.058-9.018.742-15.21 4.799-6.194 13.709-2.18 19.83-8.917 5.98-6.58 13.42-4.098 12.338 4.136-.72 5.476-5.492 9.068-6.717 17.184-1.225 8.116 5.127 10.189 1.522 15.423-3.605 5.235-10.865-.06-15.942 5.517-5.077 5.576.195 12.875-4.366 16.79-4.56 3.914-8.473-3.577-13.875-1.13-5.402 2.445-.755 8.356-8.927 11.87-8.173 3.514-24.78 1.93-24.78 1.93z'/%3E %3Cpath d='M574.984 794.051c31.13-11.555 58.291-39.374 81.522-77.336-12.232 22.597-41.404 67.391-82.99 80.496l1.468-3.16z'/%3E %3Cpath d='M616.148 768.72c2.928-6.189 2.74-10.86 3.023-15.759.322 4.48.798 8.884-.792 14.296l-2.23 1.463zM635.972 746.418c1.36-6.752.063-11.227-.832-16.047 1.38 4.257 2.893 8.4 2.644 14.052l-1.812 1.995zM632.52 752.916c5.905-3.134 10.394-3.004 15.098-3.368-4.309-.271-8.547-.705-13.724 1.025l-1.375 2.343zM613.444 772.742c5.905-3.135 10.395-3.005 15.099-3.368-4.309-.272-8.547-.706-13.724 1.025l-1.375 2.343zM567.287 741.198c-7.882-5.63-18.267-4.844-24.713-9.25-6.871-4.697 3.657-8.628-1.737-12.051-5.395-3.424-12.475 3.027-19.843-1.644-7.368-4.672-3.841-12.336-10.09-15.426-6.25-3.09-8.83 5.718-16.099 1.202s-4.466-14.966-12.516-20.881c-7.863-5.778-6.436-14.388 2.386-14.282 5.868.07 10.4 4.904 19.12 5.186 8.722.281 5.015-4.332 11.087-1.017 6.073 3.314 4.839 12.095 11.504 17.002 6.665 4.907 15.195-4.66 20.032-.107 4.837 4.554-2.411 9.907 1.016 15.593s8.9-.273 13.89 8.353c4.99 8.627 5.963 27.322 5.963 27.322z'/%3E %3Cpath d='M573.434 753.467c-17.083-33.105-50.623-59.625-94.197-80.421 25.684 10.602 77.379 37.099 97.75 81.634l-3.553-1.213z'/%3E %3Cpath d='M540.285 711.031c-6.968-2.434-11.845-1.602-17.038-1.264 4.656-.955 9.207-2.073 15.145-1.024l1.893 2.288zM513.705 691.94c-7.31-.612-11.806 1.427-16.727 3.065 4.253-2.103 8.365-4.339 14.344-4.815l2.383 1.75zM521.08 694.918c-4.23-6.155-4.807-11.169-5.936-16.355.4 4.831.616 9.606 3.257 15.137l2.68 1.218zM544.939 713.505c-4.23-6.155-4.807-11.169-5.936-16.355.399 4.831.616 9.606 3.256 15.137l2.68 1.218zM588.02 750.362c4.442-7.713 2.994-17.422 6.451-23.72 3.685-6.712 7.945 2.959 10.603-2.297 2.659-5.256-3.596-11.547.03-18.725 3.628-7.177 10.705-4.289 13.005-10.328 2.3-6.04-5.728-7.976-2.232-15.052 3.495-7.076 13.002-5.022 17.686-12.908 4.577-7.704 12.345-6.84 12.887 1.45.361 5.515-3.615 10.038-3.236 18.244.38 8.205 7.003 8.897 4.49 14.783-2.512 5.886-10.651 2.23-14.539 8.76-3.887 6.53 2.695 12.567-1.01 17.361-3.704 4.795-8.993-1.717-13.808 1.816-4.815 3.533.886 8.343-6.434 13.506-7.32 5.162-23.893 7.11-23.893 7.11z'/%3E %3Cpath d='M577.541 756.813c28.24-17.872 49.428-50.836 64.795-92.905-7.584 24.705-27.44 74.716-65.618 96.309l.823-3.404z'/%3E %3Cpath d='M612.927 723.337c1.664-6.678.572-11.212-.104-16.07 1.186 4.32 2.51 8.532 2.005 14.166l-1.9 1.904zM628.003 697.32c.019-6.898-2.122-11.007-3.936-15.538 2.18 3.877 4.467 7.615 5.323 13.203l-1.387 2.335zM625.886 704.411c5.174-4.313 9.596-5.132 14.132-6.478-4.273.641-8.508 1.11-13.241 3.895l-.891 2.583zM611.06 727.844c5.175-4.313 9.597-5.132 14.133-6.478-4.273.641-8.508 1.11-13.241 3.895l-.891 2.583z'/%3E %3Cg%3E %3Cpath d='M557.393 638.911c3.616-8.648.844-18.542 3.621-25.58 2.96-7.5 8.651 1.957 10.732-3.884 2.081-5.842-5.245-11.503-2.407-19.48s10.578-5.97 12.184-12.576c1.606-6.606-6.999-7.488-4.284-15.34 2.715-7.853 12.873-7.057 16.72-15.92 3.757-8.658 11.951-8.855 13.596-.309 1.094 5.685-2.453 10.95-.99 19.43 1.463 8.482 8.444 8.267 6.597 14.743-1.847 6.476-10.791 3.821-13.985 11.162-3.194 7.34 4.44 12.69 1.211 18.2-3.23 5.508-9.58-.518-14.13 3.835-4.548 4.354 2.01 8.552-4.934 14.954-6.943 6.403-23.931 10.765-23.931 10.765z'/%3E %3Cpath d='M547.331 647.1c27.05-22.572 44.8-59.846 55.309-105.768-4.672 26.765-18.816 81.581-55.722 109.423l.413-3.656z'/%3E %3Cpath d='M579.785 607.29c.86-7.18-.866-11.741-2.202-16.699 1.796 4.326 3.722 8.52 3.931 14.452l-1.73 2.247zM592.08 578.105c-.879-7.177-3.64-11.15-6.118-15.606 2.772 3.725 5.64 7.29 7.257 12.982l-1.138 2.624zM590.801 585.779c4.821-5.216 9.315-6.69 13.859-8.731-4.361 1.27-8.707 2.353-13.268 5.918l-.59 2.813zM578.43 612.242c4.821-5.216 9.315-6.691 13.859-8.731-4.362 1.27-8.707 2.353-13.269 5.918l-.59 2.813z'/%3E %3C/g%3E %3Cg%3E %3Cpath d='M533.383 605.314c4.26-6.586-1.069-18.724 2.254-24.109 3.541-5.739 7.22 2.947 9.785-1.556 2.564-4.504-.434-10.335 3.065-16.486 3.5-6.15 8.534-1.658 10.788-6.866 2.254-5.208-2.035-5.336 1.341-11.402 3.377-6.067 12.051-3.846 16.538-10.574 4.383-6.571 11.49-5.472 11.791 1.839.2 4.863-2.913 7.166-2.76 14.395.152 7.229 4.65 9.567 2.204 14.63-2.446 5.064-8.907 1.554-12.63 7.124-3.723 5.57.338 7.774-3.175 11.827-3.514 4.052-6.377 1.487-10.88 4.382-4.502 2.895-.728 11.329-7.568 15.547s-20.753 1.249-20.753 1.249z'/%3E %3Cpath d='M522.094 611.2c24.26-10.566 48.596-42.396 63.7-78.703-7.548 21.385-27.469 63.674-63.017 80.985l-.683-2.282z'/%3E %3Cpath d='M556.883 582.647c1.686-5.797.792-9.83.287-14.13.986 3.85 2.1 7.61 1.503 12.54l-1.79 1.59zM571.338 560.438c.18-6.063-1.686-9.768-3.242-13.83 1.908 3.503 3.918 6.889 4.57 11.838l-1.328 1.992zM569.226 566.578c4.85-3.565 8.928-4.091 13.122-5.077-3.936.378-7.833.604-12.243 2.845l-.88 2.232zM555.063 586.528c4.85-3.566 8.928-4.092 13.123-5.077-3.936.377-7.834.603-12.244 2.845l-.879 2.232z'/%3E %3C/g%3E %3Cg%3E %3Cpath d='M381.788 1012.273c3.569-9.036.931-19.718 3.674-27.08 2.923-7.845 8.403 2.52 10.462-3.601 2.06-6.121-5.034-12.523-2.226-20.882 2.808-8.358 10.325-5.832 11.926-12.792 1.601-6.959-6.764-8.331-4.076-16.563 2.687-8.233 12.564-6.875 16.358-16.128 3.706-9.039 11.678-8.837 13.227.354 1.03 6.113-2.451 11.546-1.078 20.658 1.374 9.112 8.166 9.234 6.33 16.043-1.834 6.81-10.52 3.53-13.67 11.194-3.15 7.662 4.245 13.748 1.071 19.457-3.174 5.709-9.316-1.033-13.767 3.379-4.45 4.411 1.903 9.215-4.888 15.69-6.792 6.474-23.343 10.271-23.343 10.271z'/%3E %3Cpath d='M375.216 1016.418c26.447-22.698 40.67-57.455 51.163-105.87-4.703 28.292-15.521 81.925-51.587 109.746l.424-3.876z'/%3E %3Cpath d='M403.757 979.697c.88-7.61-.773-12.557-2.044-17.907 1.722 4.7 3.57 9.266 3.739 15.598l-1.695 2.309zM415.89 949.21c-.813-7.694-3.476-12.066-5.86-16.94 2.675 4.11 5.443 8.053 6.983 14.2l-1.123 2.74zM414.6 957.324c4.72-5.317 9.1-6.663 13.533-8.61-4.25 1.135-8.484 2.072-12.942 5.642l-.591 2.968zM402.41 984.906c4.72-5.317 9.1-6.663 13.532-8.61-4.25 1.135-8.483 2.072-12.942 5.642l-.59 2.968z'/%3E %3C/g%3E %3Cg%3E %3Cpath d='M561.082 832.168c-7.131-7.46-19.244-10.076-25.142-16.004-6.287-6.318 7.034-6.423 2.01-11.151-5.023-4.73-15.242-1.31-22.104-7.764-6.862-6.454-.297-12.072-6.405-16.78-6.11-4.707-11.974 2.218-18.774-4.068-6.8-6.286-.138-14.585-7.367-22.35-7.06-7.585-2.579-14.703 7.456-11.801 6.675 1.93 10.246 7.624 20.107 10.648 9.861 3.025 13.63-3.063 19.462 1.785 5.833 4.849-2.112 11.171 3.87 17.609 5.98 6.438 16.044 2.598 20.056 8.142 4.013 5.545-6.035 7.945-4.007 14.037 2.027 6.092 10.249 2.594 13.085 11.77 2.837 9.176-2.247 25.927-2.247 25.927z'/%3E %3Cpath d='M540.258 797.04c-7.147-4.36-12.989-5.181-19.028-6.537 5.63.643 11.196 1.109 17.626 3.922l1.402 2.614zM516.245 771.787c-8.14-2.867-13.947-2.505-20.108-2.63 5.552-.496 10.986-1.153 17.968.331l2.14 2.299zM523.677 776.753c-2.79-6.76-1.786-11.353-1.355-16.274-1.146 4.376-2.48 8.645-1.3 14.35l2.655 1.924zM544.75 800.697c-2.789-6.76-1.785-11.353-1.355-16.274-1.146 4.376-2.48 8.645-1.3 14.35l2.655 1.924z'/%3E %3Cpath d='M561.704 840.054c-8.529-34.554-35.695-63.696-78.54-95.86 25.804 17.503 73.699 52.404 82.193 98.058l-3.653-2.198z'/%3E %3C/g%3E %3Cg id='d'%3E %3Cpath d='M527.296 890.544c-3.353-8.85-19.798-13.112-22.673-20.186-3.064-7.54 9.126-5.225 6.542-10.926-2.584-5.701-13.345-4.096-16.877-11.879-3.532-7.782 4.826-12.277 1.244-18.154-3.583-5.876-11.854.07-15.4-7.532-3.547-7.6 6.031-14.792 2.719-23.969-3.235-8.964 3.857-15.356 11.781-10.593 5.271 3.167 6.123 9.582 13.838 14.436 7.715 4.855 13.721-.624 16.993 5.346 3.271 5.97-6.643 10.926-3.907 18.532 2.736 7.606 13.533 5.547 14.85 11.89 1.318 6.344-8.857 6.948-9.58 13.485-.724 6.537 8.25 4.488 6.962 14.295-1.288 9.807-6.492 25.255-6.492 25.255z'/%3E %3Cpath d='M520.011 853.111c-4.675-5.713-13.031-8.939-17.965-11.41 4.862 1.675 13.116 4.49 17.792 8.508l.173 2.902zM510.082 828.225c.311-7.352 3.166-11.82 5.636-16.725-2.893 4.223-5.912 8.302-7.244 14.293l1.608 2.432zM522.503 854.289c.311-7.352-.15-9.81 2.32-14.714-2.892 4.222-2.596 6.292-3.928 12.283l1.608 2.431z'/%3E %3Cpath d='M525.2 906.633c6.813-36.538-12.825-78.385-38.311-118.74 16.138 22.413 52.245 73.859 40.713 121.63l-2.402-2.89z'/%3E %3Cpath d='M505.403 821.845c-6.213-4.382-11.66-5.071-17.225-6.319 5.271.507 10.504.83 16.244 3.602l.98 2.717z'/%3E %3C/g%3E %3Cg%3E %3Cpath d='M493.56 566.123c-1.927-7.016-11.717-8.589-13.368-14.187-1.76-5.967 5.18-4.726 3.698-9.223-1.483-4.498-6.394-4.876-8.42-11.015-2.028-6.14 3.044-8.197.993-12.785-2.052-4.588-4.158-.956-6.193-6.947-2.035-5.99 3.4-12.339 1.494-19.622-1.861-7.115 2.16-12.683 6.68-9.229 3.006 2.298 2.912 6.15 7.313 9.69 4.4 3.541 7.928.853 9.803 5.533 1.875 4.68-3.284 8.464-1.71 14.502 1.573 6.037 4.815 3.657 5.578 8.743.764 5.087-2.126 6.251-2.523 11.602-.398 5.35 6.438 6.382 5.727 14.42-.71 8.037-9.071 18.518-9.071 18.518z'/%3E %3Cpath d='M491.743 578.842c5.153-26.274-2.39-63.414-16.983-94.87 9.233 17.366 25.128 56.012 18.673 95.44l-1.69-.57z'/%3E %3Cpath d='M491.108 534.358c-2.673-4.397-5.511-5.675-8.324-7.424 2.77 1.106 5.55 2.055 8.219 5.074l.105 2.35zM484.65 510.62c-3.545-3.235-6.647-3.508-9.815-4.23 3 .135 5.978.123 9.25 2.074l.565 2.157zM487.327 515.56c.16-5.991 1.774-9.773 3.169-13.888-1.636 3.584-3.345 7.057-4.09 11.996l.92 1.892zM492.57 537.898c.16-5.991 1.775-9.773 3.17-13.888-1.637 3.583-3.346 7.057-4.09 11.996l.92 1.892z'/%3E %3C/g%3E %3Cg%3E %3Cpath d='M509.672 575.22c-.207-6.888-6.92-11.393-7.205-16.889-.304-5.858 14.644-4.381 14.25-8.797-.392-4.416-5.461-4.804-6.001-10.832-.54-6.028 5.332-8.027 4.364-12.534-.968-4.506-4.128-.952-4.714-6.834-.586-5.883 1.959-12.396 1.845-19.545-.112-6.984 5.565-12.43 9.425-9.027 2.567 2.264 1.468 6.042 5.18 9.53 3.712 3.486 8.359.996 11.29 4.523 2.915 3.507 2.309 6.345 2.397 12.272.09 5.926 4.118 3.603 3.602 8.594-.517 4.99-3.861 6.123-5.668 11.368-1.807 5.246 5.12 6.282 2.285 14.161-2.835 7.88-31.05 24.01-31.05 24.01z'/%3E %3Cpath d='M499.22 585.584c24.422-21.57 36.501-63.212 18.317-93.996 8.18 15.13 12.468 31.125 8.112 50.275-3.15 13.846-10.823 30.446-24.8 44.286l-1.63-.565z'/%3E %3Cpath d='M522.267 550.763c-1.672-4.322-6.172-9.786-8.678-11.51 2.628 1.093 7.152 6.235 9.177 9.205l-.499 2.305zM526.287 523.946c-2.89-3.185-6.084-3.465-9.23-4.183 3.121.143 6.259.14 9.196 2.066l.034 2.117zM527.441 524.146c1.724-5.874 4.405-9.577 6.94-13.608-2.652 3.509-5.352 6.91-7.417 11.75l.477 1.858zM523.17 551.67c1.723-5.874 7.855-3.776 12.463-5.225-3.495.052-10.876-1.474-12.942 3.368l.478 1.857z'/%3E %3C/g%3E %3Cg%3E %3Cpath d='M478.903 575.873c-6.493-4.618-4.563-15.69-9.703-19.496-5.479-4.057-6.718 3.84-10.79.614-4.074-3.225-2.685-8.63-8.243-13.035-5.56-4.406-9.503.287-13.463-3.581-3.96-3.868.525-4.807-4.88-9.168-5.403-4.36-13.875-.838-20.651-5.53-6.62-4.581-13.78-2.292-11.875 3.812 1.267 4.06 5.25 5.359 7.286 11.366 2.037 6.006-1.995 8.813 2.123 12.525 4.118 3.712 9.864-.446 15.482 3.436 5.619 3.882 2.006 6.494 6.943 9.162 4.937 2.668 7.176-.009 12.804 1.51 5.627 1.519 4.21 9.225 12.706 11.384 8.495 2.16 22.261-2.999 22.261-2.999z'/%3E %3Cpath d='M492.596 578.547c-28.791-4.023-64.127-25.614-91.088-52.699 14.459 16.215 48.316 47.311 91.062 54.718l.026-2.02z'/%3E %3Cpath d='M447.235 561.697c-3.54-4.466-3.822-7.974-4.597-11.627.13 3.374.099 6.7 2.227 10.66l2.37.967zM425.243 546.142c-2.033-4.978-1.192-8.404-.785-12.065-.947 3.267-2.037 6.457-1.22 10.676l2.005 1.389zM429.337 550.809c-6.199-2.006-10.658-1.649-15.38-1.649 4.264-.452 8.443-1.023 13.774-.026l1.606 1.675zM450.334 564.552c-6.199-2.005-10.658-1.648-15.38-1.648 4.264-.453 8.443-1.023 13.774-.027l1.606 1.675z'/%3E %3C/g%3E %3Cg%3E %3Cpath d='M500.517 605.577c-8.06-3.492-6.615-15.421-13.007-18.344-6.814-3.114-7.68 5.366-12.762 2.833-5.082-2.534-3.845-8.447-10.78-11.909-6.936-3.461-11.258 2.23-16.254-.997-4.996-3.226.255-5.115-6.493-8.56-6.748-3.446-16.535 1.944-24.936-1.567-8.207-3.43-16.533.41-13.805 6.384 1.815 3.972 6.641 4.517 9.518 10.363 2.876 5.845-1.695 9.59 3.476 12.62 5.172 3.032 11.675-2.469 18.64.435 6.966 2.905 2.878 6.36 8.942 8.137 6.064 1.777 8.517-1.468 15.313-1.028 6.796.44 5.704 8.758 15.953 9.281 10.248.524 26.195-7.648 26.195-7.648z'/%3E %3Cpath d='M516.976 605.581c-34.484 1.658-78.077-13.661-112.15-36.407 18.4 13.96 60.967 39.483 112.273 38.517l-.123-2.11z'/%3E %3Cpath d='M461.843 597.24c-4.542-3.935-5.146-7.533-6.345-11.182.413 3.488.63 6.96 3.458 10.655l2.887.527zM434.55 585.499c-2.794-4.774-2.057-8.516-1.853-12.413-.875 3.597-1.925 7.142-.634 11.373l2.487 1.04zM439.766 589.53c-7.51-.83-12.777.447-18.383 1.407 5.028-1.338 9.945-2.782 16.35-2.826l2.033 1.419zM465.74 599.585c-7.511-.83-12.777.447-18.383 1.407 5.028-1.338 9.944-2.781 16.35-2.826l2.033 1.419z'/%3E %3C/g%3E %3Cg%3E %3Cpath d='M517.502 629.672c-8.279-2.962-7.618-14.951-14.193-17.452-7.009-2.666-7.318 5.846-12.559 3.648-5.24-2.198-4.393-8.174-11.546-11.178-7.152-3.004-11.095 2.95-16.296.055-5.2-2.894-.08-5.117-7.045-8.117-6.965-3-16.384 3.007-25.005.048-8.42-2.89-16.482 1.477-13.366 7.257 2.073 3.844 6.928 4.076 10.184 9.72 3.255 5.643-1.063 9.67 4.3 12.36 5.363 2.688 11.496-3.216 18.642-.77 7.147 2.446 3.291 6.155 9.463 7.536 6.172 1.38 8.409-2.014 15.224-2.014 6.816-.001 6.27 8.364 16.539 8.225 10.269-.14 25.658-9.318 25.658-9.318z'/%3E %3Cpath d='M533.937 628.613c-34.327 3.88-78.864-8.58-114.381-29.062 19.291 12.731 63.471 35.434 114.642 31.158l-.261-2.096z'/%3E %3Cpath d='M478.335 623.855c-4.795-3.63-5.633-7.179-7.07-10.74.641 3.452 1.085 6.9 4.152 10.402l2.918.338zM450.31 613.91c-3.104-4.58-2.613-8.359-2.666-12.258-.637 3.643-1.453 7.247.114 11.382l2.552.876zM455.782 617.593c-7.554-.344-12.73 1.271-18.264 2.59 4.933-1.66 9.748-3.416 16.14-3.874l2.124 1.284zM482.38 625.942c-7.555-.343-12.73 1.271-18.265 2.59 4.933-1.659 9.748-3.415 16.14-3.874l2.124 1.284z'/%3E %3C/g%3E %3Cg id='a'%3E %3Cpath d='M207.197 997.382c6.594-4.258 15.187-3.229 20.577-6.552 5.746-3.542-2.93-7.124 1.577-9.691 4.508-2.568 10.299 2.924 16.456-.579s3.323-9.842 8.535-12.107c5.212-2.265 7.249 4.965 13.322 1.584 6.072-3.38 3.87-11.948 10.607-16.432 6.58-4.38 5.496-11.406-1.813-11.654-4.862-.166-8.671 3.576-15.899 3.473-7.227-.103-8.111-6.094-13.18-3.641-5.068 2.453-1.515 9.734-7.092 13.454-5.577 3.72-11.157-2.076-15.216 1.427-4.06 3.503 1.884 8.112-1.02 12.586s-7.37-.559-11.601 6.237c-4.233 6.796-5.253 21.895-5.253 21.895z'/%3E %3Cpath d='M201.964 1007.083c14.53-26.156 42.618-46.357 78.95-61.542-21.397 7.61-64.522 27.103-81.906 62.39l2.956-.848z'/%3E %3Cpath d='M229.91 973.981c5.8-1.706 9.83-.848 14.128-.377-3.846-.95-7.603-2.027-12.534-1.404l-1.594 1.781zM252.146 959.533c6.062-.22 9.763 1.602 13.82 3.115-3.498-1.864-6.878-3.83-11.826-4.443l-1.994 1.327zM246.003 961.663c3.575-4.823 4.11-8.86 5.104-13.017-.386 3.897-.62 7.754-2.87 12.133l-2.234.884zM226.026 975.808c3.575-4.823 4.11-8.86 5.105-13.017-.386 3.896-.62 7.754-2.871 12.132l-2.234.885z'/%3E %3C/g%3E %3Cg id='b'%3E %3Cpath d='M210.31 1024.483c9.07 3.59 19.283 0 26.659 2.74 7.86 2.916-1.833 9.73 4.283 11.752 6.117 2.023 11.83-6.42 20.182-3.663 8.353 2.757 6.447 11.475 13.346 12.93 6.9 1.455 7.619-8.17 15.839-5.544 8.22 2.627 7.627 13.976 16.924 17.811 9.081 3.746 9.475 12.86.633 15.122-5.88 1.505-11.432-2.178-20.209-.12-8.777 2.057-8.393 9.818-15.164 8.089-6.77-1.73-4.218-11.822-11.918-15.007-7.7-3.185-13.082 5.584-18.88 2.267-5.797-3.318.317-10.693-4.31-15.538-4.628-4.844-8.839 2.668-15.65-4.738-6.81-7.407-11.734-26.101-11.734-26.101z'/%3E %3Cpath d='M201.572 1013.693c24.073 28.978 63.205 46.859 111.156 56.24-27.914-3.851-85.188-16.83-114.963-56.515l3.807.275z'/%3E %3Cpath d='M243.677 1047.816c7.48.597 12.179-1.557 17.298-3.294-4.452 2.218-8.765 4.574-14.923 5.107l-2.375-1.812zM274.281 1060.033c7.437-1.342 11.5-4.618 16.073-7.601-3.807 3.275-7.445 6.647-13.32 8.736l-2.753-1.135zM266.28 1058.996c5.53 5.104 7.165 10.033 9.39 14.989-1.42-4.792-2.646-9.575-6.455-14.474l-2.935-.515zM238.502 1046.558c5.53 5.104 7.166 10.034 9.39 14.99-1.42-4.793-2.646-9.575-6.454-14.475l-2.936-.515z'/%3E %3C/g%3E %3Cuse transform='translate(43.941 17.372)' width='744.094' height='1052.362' xlink:href='%23a'/%3E %3Cuse transform='translate(59.27 11.24)' width='744.094' height='1052.362' xlink:href='%23b'/%3E %3Cg id='e'%3E %3Cpath d='M353.525 1034.119c9.75.938 18.788-5.287 26.67-4.699 8.403.627.695 9.792 7.17 10.044 6.474.252 9.888-9.375 18.729-9.035 8.84.34 9.205 9.186 16.298 8.681 7.093-.504 5.34-9.89 14.018-9.638 8.679.252 10.993 11.25 21.029 12.36 9.802 1.084 12.508 9.676 4.47 14.262-5.345 3.05-11.693 1.057-19.72 5.43-8.027 4.371-5.676 11.676-12.713 11.882-7.037.207-7.122-10.128-15.435-11.056-8.314-.928-11.323 8.921-17.817 7.345-6.494-1.576-2.416-10.294-8.16-13.65-5.743-3.355-7.93 4.972-16.454-.23-8.524-5.202-18.085-21.696-18.085-21.696z'/%3E %3Cpath d='M342.262 1026.217c30.838 21.058 73.521 27.39 122.63 23.187-28.178 3.984-87.287 7.308-126.41-22.406l3.78-.781z'/%3E %3Cpath d='M391.98 1047.238c7.44-1.483 11.469-4.828 16.014-7.891-3.772 3.34-7.374 6.772-13.238 8.97l-2.776-1.078zM424.91 1050.503c6.904-3.321 10.028-7.563 13.723-11.666-2.874 4.171-5.56 8.388-10.751 11.995l-2.971-.329zM416.85 1051.709c6.689 3.355 9.539 7.612 12.969 11.732-2.605-4.185-5.018-8.414-9.977-12.046l-2.992.314zM386.618 1047.457c6.688 3.355 9.538 7.612 12.968 11.733-2.605-4.185-5.018-8.415-9.977-12.046l-2.991.313z'/%3E %3C/g%3E %3Cg%3E %3Cpath d='M292.72 1024.547c4.983-5.068 13.172-6.262 17.286-10.274 4.385-4.277-4.539-5.162-1.043-8.344 3.495-3.182 10.25-.04 15.024-4.383 4.775-4.342.528-8.882 4.75-11.982 4.222-3.1 7.963 2.36 12.692-1.861 4.728-4.222.49-10.745 5.546-16.031 4.939-5.164 2.13-10.684-4.674-9.153-4.526 1.019-7.074 5-13.765 6.632-6.69 1.631-9.05-3.085-13.09.136-4.042 3.22 1.11 8.363-3.074 12.747-4.184 4.383-10.823.942-13.663 4.787-2.84 3.844 3.828 6.223 2.303 10.591-1.525 4.369-6.939 1.29-9.09 7.884-2.152 6.593.798 19.25.798 19.25z'/%3E %3Cpath d='M292.089 1030.323c6.657-24.958 25.657-44.795 55.246-65.91-17.769 11.34-50.817 34.166-57.754 67.31l2.508-1.4z'/%3E %3Cpath d='M307.634 999.911c4.908-2.78 8.845-3.032 12.929-3.665-3.79.132-7.533.139-11.919 1.822l-1.01 1.843zM324.414 982.75c5.533-1.62 9.415-1 13.547-.72-3.707-.702-7.33-1.516-12.05-.845l-1.497 1.565zM319.298 985.96c2.054-4.814 1.507-8.261 1.352-11.915.649 3.296 1.427 6.523.48 10.658l-1.832 1.258zM304.523 1002.335c2.054-4.814 1.507-8.262 1.353-11.915.648 3.295 1.426 6.523.479 10.658l-1.832 1.257z'/%3E %3C/g%3E %3Cg%3E %3Cpath d='M345.42 1017.313c4.024-6.249 12.081-9.145 15.439-14.127 3.579-5.31-5.644-4.413-2.745-8.41 2.898-3.998 10.379-2.124 14.34-7.58 3.96-5.457-1.262-9.286 2.39-13.347 3.651-4.06 8.547.823 12.485-4.5 3.938-5.323-1.676-11.202 2.378-17.692 3.96-6.34-.004-11.472-6.59-8.508-4.38 1.971-6.157 6.603-12.608 9.647-6.45 3.045-9.795-1.35-13.24 2.8-3.443 4.148 2.819 8.416-.534 13.795-3.354 5.38-10.778 3.172-12.879 7.721-2.1 4.55 5.138 5.654 4.477 10.478-.662 4.823-6.771 2.742-7.618 9.992-.846 7.25 4.705 19.73 4.705 19.73z'/%3E %3Cpath d='M345.948 1023.41c1.698-27.142 16.94-51.5 42.655-79.326-15.714 15.325-44.589 45.623-44.914 81.28l2.259-1.954z'/%3E %3Cpath d='M355.549 988.827c4.412-3.87 8.351-4.929 12.362-6.413-3.815.907-7.606 1.673-11.71 4.304l-.652 2.109zM369.083 967.686c5.28-2.797 9.34-2.946 13.584-3.495-3.899.027-7.736-.078-12.383 1.574l-1.2 1.921zM364.548 972.043c1.107-5.392-.145-8.843-1.04-12.588 1.324 3.274 2.765 6.451 2.642 10.916l-1.602 1.672zM352.887 991.964c1.108-5.393-.144-8.844-1.04-12.588 1.324 3.274 2.765 6.451 2.642 10.916l-1.602 1.672z'/%3E %3C/g%3E %3Cg id='f'%3E %3Cpath d='M505.882 948.746c7.671-4.14 11.335-13.195 17.453-16.668 6.522-3.7 5.27 6.858 10.184 3.836 4.913-3.022 2.763-11.794 9.47-15.923 6.706-4.129 11.274 2.196 16.277-1.689 5.003-3.884-.853-9.918 5.69-14.032 6.545-4.114 13.6 2.827 21.565-1.327 7.78-4.059 13.956.92 10.236 8.274-2.474 4.891-8.14 6.57-11.955 13.762-3.816 7.192 1.473 11.399-3.634 15.037-5.106 3.638-10.19-3.92-16.792-.485-6.603 3.436-4.045 12.17-9.616 14.227-5.571 2.058-6.789-6.374-12.668-5.996-5.88.377-3.454 7.585-12.288 7.982-8.834.396-23.922-6.998-23.922-6.998z' transform='translate(9.389 -7.87)'/%3E %3Cpath d='M493.71 948.513c33.048.211 67.707-16.276 102.004-43.693-18.915 16.888-61.038 48.614-104.421 46.14l2.417-2.447z' transform='translate(9.389 -7.87)'/%3E %3Cpath d='M540.711 939.345c4.784-4.776 6.14-9.232 8.016-13.736-1.17 4.324-2.167 8.633-5.438 13.154l-2.578.582zM566.664 925.434c3.495-5.863 3.745-10.53 4.487-15.378-.1 4.492-.04 8.923-2.13 14.148l-2.357 1.23zM561.285 930.313c6.58-.846 10.756.873 15.296 2.204-3.96-1.787-7.8-3.702-13.234-3.917l-2.062 1.713zM536.85 942.163c6.578-.846 10.755.873 15.294 2.204-3.96-1.788-7.8-3.703-13.234-3.917l-2.06 1.713z' transform='translate(9.389 -7.87)'/%3E %3C/g%3E %3Cg%3E %3Cpath d='M582.995 716.21c3.617-8.648.845-18.541 3.621-25.579 2.96-7.501 8.651 1.956 10.732-3.885 2.082-5.841-5.245-11.503-2.407-19.48s10.578-5.97 12.184-12.576c1.606-6.606-6.999-7.488-4.284-15.34 2.716-7.853 12.873-7.057 16.72-15.92 3.757-8.658 11.952-8.855 13.596-.308 1.094 5.684-2.453 10.95-.99 19.43 1.464 8.481 8.445 8.267 6.598 14.743-1.847 6.475-10.792 3.82-13.986 11.16-3.193 7.341 4.44 12.692 1.211 18.2-3.23 5.51-9.58-.517-14.13 3.837-4.548 4.353 2.01 8.552-4.934 14.954-6.943 6.402-23.931 10.764-23.931 10.764z'/%3E %3Cpath d='M572.933 724.398c27.051-22.571 44.801-59.844 55.31-105.767-4.673 26.766-18.817 81.581-55.723 109.423l.413-3.656z'/%3E %3Cpath d='M605.387 684.59c.861-7.18-.866-11.742-2.202-16.7 1.797 4.326 3.722 8.52 3.931 14.452l-1.729 2.248zM617.683 655.404c-.88-7.177-3.642-11.15-6.12-15.606 2.774 3.725 5.64 7.29 7.259 12.982l-1.139 2.624zM616.404 663.078c4.82-5.216 9.315-6.69 13.858-8.731-4.361 1.27-8.706 2.354-13.268 5.918l-.59 2.813zM604.032 689.54c4.821-5.215 9.315-6.69 13.86-8.73-4.362 1.27-8.708 2.354-13.27 5.918l-.59 2.813z'/%3E %3C/g%3E %3Cg%3E %3Cpath d='M572.265 672.078c4.442-7.713 2.993-17.421 6.45-23.719 3.686-6.712 7.945 2.958 10.604-2.298 2.658-5.255-3.596-11.547.03-18.725 3.627-7.177 10.705-4.289 13.005-10.328 2.3-6.04-5.728-7.976-2.233-15.052 3.496-7.076 13.002-5.021 17.687-12.908 4.576-7.704 12.345-6.84 12.887 1.45.361 5.515-3.615 10.038-3.236 18.244.38 8.205 7.003 8.897 4.49 14.783-2.512 5.886-10.652 2.23-14.539 8.76-3.887 6.53 2.695 12.567-1.01 17.361-3.704 4.795-8.993-1.717-13.808 1.816-4.815 3.533.886 8.343-6.434 13.506s-23.893 7.11-23.893 7.11z'/%3E %3Cpath d='M561.786 678.53c28.239-17.873 49.427-50.837 64.795-92.906-7.584 24.705-27.44 74.716-65.619 96.309l.824-3.404z'/%3E %3Cpath d='M597.172 645.053c1.664-6.678.571-11.212-.105-16.07 1.186 4.32 2.51 8.532 2.005 14.166l-1.9 1.904zM612.248 619.036c.018-6.898-2.122-11.007-3.936-15.538 2.18 3.877 4.467 7.615 5.323 13.203l-1.387 2.335zM610.13 626.127c5.174-4.313 9.597-5.132 14.132-6.478-4.272.642-8.507 1.11-13.24 3.895l-.891 2.583zM595.305 649.56c5.174-4.313 9.597-5.132 14.132-6.478-4.272.642-8.507 1.11-13.24 3.895l-.892 2.583z'/%3E %3C/g%3E %3Cg%3E %3Cpath d='M566.742 775.935c-7.882-5.63-18.266-4.844-24.713-9.25-6.871-4.697 3.658-8.628-1.737-12.051-5.395-3.424-12.475 3.027-19.843-1.644-7.368-4.672-3.84-12.336-10.09-15.426-6.249-3.09-8.83 5.718-16.099 1.202-7.268-4.516-4.466-14.966-12.516-20.881-7.863-5.778-6.436-14.388 2.386-14.282 5.868.07 10.4 4.904 19.121 5.186 8.721.281 5.014-4.332 11.087-1.017 6.072 3.314 4.838 12.095 11.503 17.002 6.665 4.907 15.195-4.66 20.033-.107 4.837 4.554-2.412 9.907 1.015 15.593 3.427 5.686 8.9-.273 13.89 8.353 4.99 8.627 5.963 27.322 5.963 27.322z'/%3E %3Cpath d='M572.89 788.204c-17.083-33.105-50.624-59.625-94.197-80.421 25.684 10.602 77.378 37.099 97.749 81.634l-3.552-1.213z'/%3E %3Cpath d='M539.74 745.768c-6.968-2.434-11.845-1.602-17.037-1.264 4.655-.955 9.207-2.073 15.145-1.024l1.892 2.288zM513.16 726.678c-7.31-.613-11.805 1.426-16.727 3.064 4.253-2.103 8.365-4.339 14.344-4.815l2.383 1.75zM520.536 729.655c-4.231-6.155-4.808-11.169-5.936-16.355.399 4.831.616 9.606 3.256 15.137l2.68 1.218zM544.394 748.242c-4.23-6.155-4.807-11.169-5.936-16.355.4 4.831.616 9.606 3.257 15.137l2.679 1.218z'/%3E %3C/g%3E %3Cg%3E %3Cpath d='M574.693 843.39c5.85-6.617 6.32-16.43 10.93-21.87 4.915-5.796 7.205 4.571 10.83-.016 3.626-4.587-1.275-12.066 3.673-18.331 4.947-6.265 11.317-1.946 14.743-7.376 3.427-5.43-4.058-9.018.741-15.21 4.8-6.194 13.71-2.18 19.831-8.916 5.98-6.581 13.42-4.099 12.338 4.135-.72 5.476-5.492 9.069-6.717 17.184-1.225 8.116 5.127 10.189 1.522 15.424-3.605 5.235-10.865-.06-15.942 5.516s.195 12.875-4.366 16.79c-4.56 3.915-8.473-3.576-13.875-1.13-5.402 2.445-.755 8.356-8.927 11.87-8.173 3.515-24.78 1.93-24.78 1.93z'/%3E %3Cpath d='M563.176 847.501c31.13-11.554 58.29-39.374 81.522-77.336-12.232 22.598-41.404 67.392-82.99 80.496l1.468-3.16z'/%3E %3Cpath d='M604.34 822.17c2.928-6.189 2.74-10.859 3.023-15.759.322 4.48.798 8.884-.792 14.296l-2.23 1.464zM624.164 799.868c1.36-6.752.063-11.227-.832-16.046 1.38 4.256 2.893 8.399 2.644 14.051l-1.812 1.995zM620.711 806.366c5.906-3.134 10.395-3.004 15.1-3.368-4.31-.271-8.548-.705-13.725 1.026l-1.375 2.342zM601.635 826.192c5.906-3.134 10.396-3.004 15.1-3.368-4.31-.271-8.547-.705-13.725 1.025l-1.375 2.343z'/%3E %3C/g%3E %3Cuse transform='rotate(15 310.012 758.36)' width='744.094' height='1052.362' xlink:href='%23c'/%3E %3Cuse transform='rotate(5 93.23 577.125)' id='c' width='744.094' height='1052.362' xlink:href='%23d'/%3E %3Cuse transform='rotate(-10 274.952 690.264)' width='744.094' height='1052.362' xlink:href='%23e'/%3E %3Cuse transform='rotate(10 225.439 653.89)' width='744.094' height='1052.362' xlink:href='%23f'/%3E %3C/g%3E %3Cuse transform='matrix(-1 0 0 1 840 .113)' width='1' height='1' xlink:href='%23g'/%3E %3C/g%3E %3Cg stroke='%23d4af37' stroke-width='3'%3E %3Cpath d='M409.242 237.563l-19.765 24.609c6.548 6.237 10.26 16.668 10.273 25.148.016 10.607-1.723 17.955-3.867 24.657-.023.07-.048.14-.07.21H450v-74.124c-11.935 7.409-28.331 10.36-40.758-.5z' fill='%23007ea8' stroke-width='.75'/%3E %3Cpath d='M490.758 237.563c-12.427 10.86-28.823 7.909-40.758.5v74.125h54.188c-.023-.071-.048-.14-.07-.211-2.145-6.702-3.884-14.05-3.868-24.657.013-8.48 3.725-18.911 10.273-25.148l-19.765-24.61z' fill='%23fff' stroke-width='.75'/%3E %3Cpath d='M395.813 312.188c-2.952 9.169-6.658 17.15-7.813 30.414-1.705 19.584 14.046 30.306 20.555 33.375 10.034 4.731 20.518 3.095 31.25 4.468 4.98.638 7.766 3.789 10.195 6.368 2.429-2.58 5.215-5.73 10.195-6.368 10.732-1.373 21.216.263 31.25-4.468 6.509-3.07 22.26-13.791 20.555-33.375-1.155-13.264-4.861-21.245-7.813-30.414H395.813z' fill='%23d91023' stroke-width='.75'/%3E %3C/g%3E %3Cg stroke='%23d4af37' stroke-width='3'%3E %3Cg transform='matrix(.119 0 0 .125 327.413 310.562)' fill='%2300a854' stroke-width='6.156'%3E %3Cg id='j' stroke-width='3.078'%3E %3Cg stroke-width='9.649'%3E %3Cpath d='M1074.733-201.404s5.849-20.366 17.932-29.304c12.084-8.938 25.212-5.671 33.195-8.854-5.322 6.748-5.925 20.263-17.932 29.305-12.006 9.041-33.195 8.853-33.195 8.853zM1123.432-237.75c-8.333 2.219-13.523-.31-24.954 3.897M1115.763-232.026c-8.333 2.219-14.117-1.33-25.335 3.386M1106.56-225.157c-7.912 2.781-11.632-1.2-22.466 4.03M1097.357-218.289c-7.912 2.782-9.57-1.713-17.49 4.297M1089.177-212.184c-5.168 1.667-7.531-.17-12.134 5.076M1123.432-237.75c-4.497 7.358-3.55 13.053-10.835 22.815M1115.763-232.026c-4.497 7.358-2.742 13.912-10.454 23.325M1106.56-225.157c-4.918 6.794-2.159 11.492-10.256 20.39M1097.357-218.289c-4.918 6.794-1.08 9.663-9.096 15.545M1089.177-212.184c-3.068 4.48-1.98 7.268-8.318 10.188' stroke-width='3.0778380199999997'/%3E %3Cpath d='M1130.782-243.633s-13.538 10.037-24.157 18.03c-10.62 7.992-31.636 24.008-31.636 24.008s21.334-15.59 32.017-23.497c10.684-7.907 24.158-18.03 24.158-18.03' stroke-width='3.0778380199999997'/%3E %3C/g%3E %3Cg stroke-width='9.649'%3E %3Cpath d='M1108.115-316.994s16.753 12.975 20.58 27.51c3.828 14.534-4.068 25.52-4.068 34.113-4.297-7.442-16.628-13.007-20.58-27.509-3.953-14.501 4.068-34.114 4.068-34.114zM1123.843-258.298c1.025-8.562 5.296-12.446 5.62-24.622M1121.366-267.541c1.025-8.562 6.463-12.621 6.237-24.788M1118.394-278.633c.346-8.38 5.422-10.36 4.576-22.362M1115.422-289.725c.346-8.38 5.135-8.257 2.485-17.839M1112.78-299.585c.366-5.418 2.946-6.933-.222-13.15M1123.843-258.298c-5.17-6.902-10.81-8.13-17.18-18.513M1121.366-267.541c-5.17-6.902-11.908-7.699-17.796-18.348M1118.394-278.633c-4.49-7.084-9.877-6.262-15.144-17.078M1115.422-289.725c-4.49-7.084-8.576-4.583-11.072-14.206M1112.78-299.585c-3.026-4.509-6.019-4.53-6.384-11.499' stroke-width='3.0778380199999997'/%3E %3Cpath d='M1126.586-249.291s-4.31-16.293-7.802-29.117c-3.491-12.824-10.586-38.277-10.586-38.277s6.581 25.59 9.97 38.442a5074.411 5074.411 0 0 0 7.802 29.117' stroke-width='3.0778380199999997'/%3E %3C/g%3E %3Cg id='h' stroke-width='9.649'%3E %3Cpath d='M1206.423-261.845s16.752 12.975 20.58 27.51c3.828 14.534-4.069 25.519-4.069 34.113-4.297-7.443-16.628-13.008-20.58-27.509-3.952-14.501 4.069-34.114 4.069-34.114zM1222.15-203.15c1.025-8.56 5.296-12.445 5.621-24.622M1219.673-212.393c1.026-8.561 6.464-12.62 6.238-24.787M1216.701-223.485c.347-8.38 5.423-10.36 4.576-22.36M1213.73-234.577c.345-8.38 5.135-8.256 2.485-17.838M1211.087-244.436c.366-5.418 2.947-6.933-.221-13.15M1222.15-203.15c-5.169-6.901-10.81-8.13-17.18-18.512M1219.673-212.393c-5.168-6.902-11.907-7.698-17.795-18.348M1216.701-223.485c-4.49-7.084-9.876-6.26-15.143-17.077M1213.73-234.577c-4.49-7.084-8.576-4.582-11.072-14.205M1211.087-244.436c-3.025-4.51-6.018-4.53-6.383-11.5' stroke-width='3.0778380199999997'/%3E %3Cpath d='M1224.894-194.142s-4.31-16.293-7.802-29.117c-3.491-12.825-10.587-38.278-10.587-38.278s6.582 25.59 9.97 38.443c3.39 12.852 7.803 29.117 7.803 29.117' stroke-width='3.0778380199999997'/%3E %3Cg%3E %3Cpath d='M1170.504-136.72s2.86-20.996 13.533-31.579c10.673-10.582 24.135-9.236 31.578-13.533-4.297 7.443-2.951 20.904-13.534 31.578-10.582 10.673-31.577 13.533-31.577 13.533zM1213.472-179.69c-7.928 3.394-13.427 1.637-24.135 7.444M1206.705-172.923c-7.927 3.393-14.161.714-24.585 6.993M1198.585-164.803c-7.43 3.89-11.684.485-21.653 7.218M1190.465-156.683c-7.43 3.89-9.718-.319-16.69 6.767M1183.247-149.465c-4.874 2.392-7.477.915-11.277 6.767M1213.472-179.69c-3.393 7.928-1.637 13.428-7.444 24.135M1206.705-172.923c-3.393 7.928-.713 14.162-6.992 24.586M1198.585-164.803c-3.89 7.43-.484 11.684-7.218 21.654M1190.465-156.683c-3.89 7.43.32 9.718-6.767 16.692M1183.247-149.465c-2.391 4.875-.914 7.477-6.766 11.278' stroke-width='3.0778380199999997'/%3E %3Cpath d='M1219.9-186.569s-11.954 11.88-21.315 21.315c-9.36 9.436-27.856 28.308-27.856 28.308s18.871-18.496 28.307-27.857a5074.411 5074.411 0 0 0 21.315-21.315' stroke-width='3.0778380199999997'/%3E %3C/g%3E %3C/g%3E %3Cg stroke-width='9.649'%3E %3Cpath d='M1057.073-278.588s20.562-5.119 34.344.877c13.783 5.996 17.517 18.999 24.265 24.321-8.505-1.235-20.511 5-34.344-.877-13.834-5.878-24.265-24.321-24.265-24.321zM1112.898-254.587c-6.087-6.107-6.492-11.866-15.851-19.662M1104.107-258.366c-6.088-6.108-5.907-12.891-15.6-20.249M1093.557-262.902c-6.365-5.462-4.777-10.674-14.723-17.441M1083.007-267.438c-6.365-5.462-3.302-9.145-12.466-12.999M1073.63-271.47c-4.027-3.642-3.619-6.607-10.462-7.97M1112.898-254.587c-8.62-.216-13.078 3.452-25.175 2.024M1104.107-258.366c-8.62-.217-13.42 4.581-25.427 2.609M1093.557-262.902c-8.343-.862-11.032 3.877-22.787 1.314M1083.007-267.438c-8.342-.862-8.908 3.895-18.01-.105M1073.63-271.47c-5.414-.416-7.284 1.92-12.982-2.109' stroke-width='3.0778380199999997'/%3E %3Cpath d='M1121.669-251.163s-15.462-6.705-27.693-11.906c-12.232-5.201-36.61-15.393-36.61-15.393s24.168 10.68 36.358 15.979c12.19 5.298 27.693 11.906 27.693 11.906' stroke-width='3.0778380199999997'/%3E %3C/g%3E %3Cg stroke-width='9.649'%3E %3Cpath d='M1072.283-383.91s14.687-15.274 29.546-17.531c14.86-2.257 24.941 6.766 33.486 7.682-7.858 3.479-14.706 15.147-29.546 17.53-14.84 2.385-33.486-7.681-33.486-7.681zM1132.321-393.291c-8.404-1.933-11.81-6.593-23.883-8.214M1122.866-391.814c-8.403-1.932-11.86-7.772-23.981-8.844M1111.52-390.041c-8.295-1.238-9.723-6.496-21.745-6.934M1100.175-388.268c-8.295-1.238-7.662-5.987-17.472-4.373M1090.09-386.692c-5.348-.942-6.58-3.67-13.099-1.182M1132.321-393.291c-7.414 4.403-9.237 9.881-20.239 15.108M1122.866-391.814c-7.413 4.404-8.923 11.02-20.14 15.738M1111.52-390.041c-7.522 3.709-7.278 9.152-18.594 13.237M1100.175-388.268c-7.522 3.709-5.47 8.038-15.305 9.494M1090.09-386.692c-4.806 2.527-5.146 5.5-12.114 5.121' stroke-width='3.0778380199999997'/%3E %3Cpath d='M1141.57-395.06s-16.66 2.55-29.783 4.654c-13.124 2.105-39.188 6.447-39.188 6.447s26.146-3.817 39.286-5.816c13.14-2 29.783-4.654 29.783-4.654' stroke-width='3.0778380199999997'/%3E %3C/g%3E %3Cg stroke-width='9.649'%3E %3Cpath d='M1102.133-454.901s19.984 7.045 28.19 19.637c8.207 12.592 4.168 25.504 6.872 33.661-6.42-5.713-19.876-7.115-28.19-19.637-8.314-12.52-6.872-33.661-6.872-33.661zM1135.53-404.135c-1.721-8.45 1.11-13.48-2.412-25.14M1130.27-412.13c-1.72-8.449 2.164-14.013-1.878-25.49M1123.96-421.723c-2.309-8.063 1.887-11.54-2.693-22.665M1117.648-431.317c-2.308-8.063 2.277-9.452-3.253-17.714M1112.038-439.844c-1.357-5.258.616-7.508-4.347-12.413M1135.53-404.135c-7.078-4.925-12.82-4.316-22.132-12.167M1130.27-412.13c-7.078-4.925-13.725-3.56-22.664-11.817M1123.96-421.723c-6.491-5.312-11.345-2.836-19.748-11.445M1117.648-431.317c-6.49-5.311-9.582-1.651-14.979-10M1112.038-439.844c-4.29-3.328-7.138-2.407-9.677-8.907' stroke-width='3.0778380199999997'/%3E %3Cpath d='M1140.968-396.448s-9.218-14.11-16.567-25.184c-7.349-11.075-22.092-33.003-22.092-33.003s14.299 22.22 21.56 33.354c7.26 11.133 16.566 25.183 16.566 25.183' stroke-width='3.0778380199999997'/%3E %3C/g%3E %3Cg id='i' stroke-width='9.649'%3E %3Cpath d='M1213.668-401.795s16.753 12.975 20.58 27.51c3.828 14.534-4.068 25.519-4.068 34.113-4.297-7.443-16.628-13.008-20.58-27.51-3.953-14.5 4.068-34.113 4.068-34.113zM1229.395-343.1c1.026-8.561 5.297-12.446 5.622-24.622M1226.919-352.343c1.025-8.561 6.463-12.62 6.237-24.787M1223.947-363.435c.346-8.38 5.422-10.36 4.575-22.36M1220.974-374.527c.347-8.38 5.136-8.256 2.486-17.838M1218.333-384.386c.365-5.418 2.946-6.933-.222-13.15M1229.395-343.1c-5.168-6.901-10.81-8.13-17.179-18.512M1226.919-352.343c-5.17-6.902-11.908-7.698-17.796-18.348M1223.947-363.435c-4.49-7.084-9.877-6.26-15.144-17.077M1220.974-374.527c-4.49-7.084-8.575-4.582-11.071-14.205M1218.333-384.386c-3.026-4.51-6.019-4.531-6.384-11.5' stroke-width='3.0778380199999997'/%3E %3Cpath d='M1232.139-334.092s-4.31-16.293-7.802-29.117c-3.491-12.825-10.587-38.278-10.587-38.278s6.582 25.59 9.971 38.443a5074.411 5074.411 0 0 0 7.802 29.117' stroke-width='3.0778380199999997'/%3E %3Cg%3E %3Cpath d='M1167.114-294.907s8.197-19.54 21.245-27c13.05-7.458 25.704-2.674 34.005-4.899-6.077 6.077-8.261 19.429-21.245 27-12.984 7.57-34.005 4.899-34.005 4.899zM1219.74-325.29c-8.536 1.225-13.393-1.895-25.239.943M1211.452-320.506c-8.535 1.226-13.863-2.976-25.557.391M1201.507-314.764c-8.184 1.834-11.41-2.556-22.783 1.368M1191.562-309.022c-8.184 1.834-9.304-2.824-17.873 2.216M1182.722-303.918c-5.327 1.048-7.459-1.052-12.644 3.617M1219.74-325.29c-5.33 6.779-5.056 12.546-13.437 21.385M1211.452-320.506c-5.329 6.78-4.354 13.495-13.117 21.938M1201.507-314.764c-5.68 6.17-3.492 11.16-12.576 19.047M1191.562-309.022c-5.68 6.17-2.206 9.47-10.856 14.37M1182.722-303.918c-3.572 4.089-2.818 6.985-9.455 9.142' stroke-width='3.0778380199999997'/%3E %3Cpath d='M1227.73-330.272s-14.622 8.38-26.106 15.072c-11.484 6.692-34.233 20.133-34.233 20.133s23.015-12.98 34.552-19.58a5074.411 5074.411 0 0 0 26.105-15.072' stroke-width='3.0778380199999997'/%3E %3C/g%3E %3C/g%3E %3Cg stroke-width='9.649'%3E %3Cpath d='M1182.237-442.008s19.633-7.97 34.124-3.98c14.49 3.991 20.024 16.337 27.455 20.653-8.594-.022-19.6 7.845-34.124 3.98-14.525-3.867-27.455-20.653-27.455-20.653zM1240.89-426.127c-6.888-5.187-8.102-10.83-18.467-17.228M1231.654-428.628c-6.888-5.187-7.667-11.928-18.301-17.843M1220.57-431.629c-7.072-4.508-6.236-9.893-17.038-15.188M1209.485-434.63c-7.072-4.509-4.56-8.588-14.176-11.11M1199.633-437.298c-4.5-3.037-4.515-6.03-11.482-6.414M1240.89-426.127c-8.564 1.003-12.46 5.264-24.636 5.557M1231.654-428.628c-8.564 1.003-12.638 6.43-24.804 6.172M1220.57-431.629c-8.381.324-10.375 5.395-22.373 4.517M1209.485-434.63c-8.38.324-8.27 5.113-17.844 2.438M1199.633-437.298c-5.419.352-6.94 2.928-13.15-.256' stroke-width='3.0778380199999997'/%3E %3Cpath d='M1250.057-423.975s-16.253-4.456-29.096-7.879c-12.843-3.422-38.416-10.07-38.416-10.07s25.434 7.161 38.25 10.686a5074.41 5074.41 0 0 0 29.095 7.878' stroke-width='3.0778380199999997'/%3E %3C/g%3E %3Cg stroke-width='9.649'%3E %3Cpath d='M1215.135-497.138s19.518 8.248 26.943 21.316c7.425 13.068 2.608 25.71 4.81 34.017-6.06-6.093-19.406-8.312-26.943-21.316-7.537-13.004-4.81-34.017-4.81-34.017zM1245.38-444.433c-1.203-8.539 1.93-13.388-.877-25.241M1240.617-452.733c-1.203-8.539 3.013-13.856-.324-25.558M1234.902-462.693c-1.813-8.189 2.586-11.404-1.308-22.787M1229.186-472.653c-1.813-8.189 2.848-9.297-2.17-17.88M1224.105-481.506c-1.034-5.33 1.072-7.456-3.584-12.654M1245.38-444.433c-6.765-5.347-12.532-5.089-21.35-13.492M1240.617-452.733c-6.765-5.347-13.483-4.39-21.903-13.175M1234.902-462.693c-6.156-5.697-11.151-3.521-19.015-12.626M1229.186-472.653c-6.155-5.697-9.464-2.232-14.342-10.894M1224.105-481.506c-4.08-3.583-6.978-2.837-9.117-9.48' stroke-width='3.0778380199999997'/%3E %3Cpath d='M1250.34-436.43s-8.342-14.644-15.003-26.145c-6.662-11.502-20.043-34.286-20.043-34.286s12.92 23.049 19.49 34.603c6.569 11.555 15.003 26.145 15.003 26.145' stroke-width='3.0778380199999997'/%3E %3C/g%3E %3Cuse transform='translate(-32 -18)' width='744.094' height='1052.362' xlink:href='%23h'/%3E %3Cg stroke-width='9.649'%3E %3Cpath d='M1142.423-297.845s16.752 12.975 20.58 27.51c3.828 14.534-4.069 25.519-4.069 34.113-4.297-7.443-16.628-13.008-20.58-27.509-3.952-14.501 4.069-34.114 4.069-34.114zM1158.15-239.15c1.025-8.56 5.296-12.445 5.621-24.622M1155.673-248.393c1.026-8.561 6.464-12.62 6.238-24.787M1152.701-259.485c.347-8.38 5.423-10.36 4.576-22.36M1149.73-270.577c.345-8.38 5.135-8.256 2.485-17.838M1147.087-280.436c.366-5.418 2.947-6.933-.221-13.15M1158.15-239.15c-5.169-6.901-10.81-8.13-17.18-18.512M1155.673-248.393c-5.168-6.902-11.907-7.698-17.795-18.348M1152.701-259.485c-4.49-7.084-9.876-6.26-15.143-17.077M1149.73-270.577c-4.49-7.084-8.576-4.582-11.072-14.205M1147.087-280.436c-3.025-4.51-6.018-4.53-6.383-11.5' stroke-width='3.0778380199999997'/%3E %3Cpath d='M1160.894-230.142s-4.31-16.293-7.802-29.117c-3.491-12.825-10.587-38.278-10.587-38.278s6.582 25.59 9.97 38.443c3.39 12.852 7.803 29.117 7.803 29.117' stroke-width='3.0778380199999997'/%3E %3Cg%3E %3Cpath d='M1106.504-172.72s2.86-20.996 13.533-31.579c10.673-10.582 24.135-9.236 31.578-13.533-4.297 7.443-2.951 20.904-13.534 31.578-10.582 10.673-31.577 13.533-31.577 13.533zM1149.472-215.69c-7.928 3.394-13.427 1.637-24.135 7.444M1142.705-208.923c-7.927 3.393-14.161.714-24.585 6.993M1134.585-200.803c-7.43 3.89-11.684.485-21.653 7.218M1126.465-192.683c-7.43 3.89-9.718-.319-16.69 6.767M1119.247-185.465c-4.874 2.392-7.477.915-11.277 6.767M1149.472-215.69c-3.393 7.928-1.637 13.428-7.444 24.135M1142.705-208.923c-3.393 7.928-.713 14.162-6.992 24.586M1134.585-200.803c-3.89 7.43-.484 11.684-7.218 21.654M1126.465-192.683c-3.89 7.43.32 9.718-6.767 16.692M1119.247-185.465c-2.391 4.875-.914 7.477-6.766 11.278' stroke-width='3.0778380199999997'/%3E %3Cpath d='M1155.9-222.569s-11.954 11.88-21.315 21.315c-9.36 9.436-27.856 28.308-27.856 28.308s18.871-18.496 28.307-27.857a5074.411 5074.411 0 0 0 21.315-21.315' stroke-width='3.0778380199999997'/%3E %3C/g%3E %3C/g%3E %3Cuse transform='translate(-62 -40)' width='744.094' height='1052.362' xlink:href='%23i'/%3E %3Cuse transform='translate(-31 -20)' width='744.094' height='1052.362' xlink:href='%23i'/%3E %3C/g%3E %3Cuse transform='matrix(-1 0 0 1 2501 0)' width='744.094' height='1052.362' xlink:href='%23j'/%3E %3Cpath d='M1250.5-437.125c-8.62 41.666-8.594 79.156-8.594 79.156-.505 13.948-7.41 23.678-13.781 20-54.887-31.689-60.291-37.57-89.125-59.669 24.306 26.461 31.231 38.23 86.719 70.266 10.728 6.193 12.062 16.378 11.625 29.469l-1.688 61.716c-.302 9.035 5.747 50.084-22.562 34.218-65.373-36.637-63.772-33.585-95.094-51.669 38.074 32.327 24.373 23.468 90.594 61.7 11.943 6.896 24.531 24.497 24.531 32.844 0 124.331 1.865 101.486-12.813 139.096h60.376c-14.678-37.61-12.813-14.765-12.813-139.096 0-8.347 12.588-25.948 24.531-32.844 66.221-38.232 51.52-29.373 89.594-61.7-31.322 18.084-28.72 15.032-94.094 51.67-28.309 15.865-22.26-25.184-22.562-34.22l-1.688-61.715c-.437-13.09.897-23.276 11.625-29.47 55.488-32.035 62.413-43.804 86.719-70.265-28.834 22.099-34.238 27.98-89.125 59.67-6.37 3.677-13.276-6.053-13.781-20 0 0 .027-37.49-8.594-79.157z' fill='%23947245'/%3E %3C/g%3E %3Cg stroke-width='2.727'%3E %3Cpath d='M264.452 424.637c-.25.946 1.503 12.373.546 15.66-.508 4.54-.635 5.238-1.704 11.12-1.069 5.881-2.364 17.308-4.391 24.163-.17.576-.408 1.358-.452 2.042-.567 3.502-.584 5.981-.211 10.35l3.512 19.415s1.634 1.918 1.881 2.722c.247.804-.172 2.006-.006 2.25.927 1.362 1.074 2.702 2.177 3.848.173.18.92.107 1.118.356.171.216 1.485.3 1.74.466.784.74.646 1.276 1.049 2.404l-6.321.026c.162-2.822-2.057-3.938-2.057-3.938-.244-.308-2.823-1.017-3.121-2.683-.413-2.392-.068-2.869-.068-2.869s-2.115-9.062-2.996-11.33c-.504-1.758-.605-2.592-.855-4.127-.76-4.24-1.017-6.075-3.32-12.405-.547-1.097-1.987-1.453-1.869-2.898.154-.557.427-.979.701-1.462l.072-1.11c.336-5.183.625-10.384 1.056-15.547a1.85 1.85 0 0 0 .236-.741c.602-8.797-4.079-17.02-7.1-24.897-.548-1.43-.075-2.995-.696-4.423-3.214-1.108-5.415-6.475-6.563-9.854-1.122-3.303-1.617-8.284-.764-11.589.278-1.077.434-1.814.964-2.522M300.323 443.746c1.026-.24 1.416-.319 2.51-.308 0 0 .74 1.02.959 1.499 1.529 2.753 3.371 15.341 4.434 21.193.33 1.814 1.094 5.943 1.434 7.866 0 0-.377 2.066.288 4.345.203.695.426 1.387.609 2.085.803 3.062 1.716 3.813 1.716 3.813.214.733 1.468 6.751 1.681 7.484 1.842 8.241 2.741 13.212 2.623 16.652-.115 4.714-.09 4.254.284 4.639 1.037 1.068 1.567.406 3.787 6.085.133.454.265-.217.505.234.287.538.78.477 1.18.53.73.096.59.23 1.181.307a6.248 6.248 0 0 0 1.58.015l5.461.037c-.67-1.992-2.887-3.369-4.828-3.386-.857-.528-1.85-1.282-2.155-2.287-1.251-2.003-1.608-2.427-2.262-3.335.108-.722-.414-1.692-.64-2.47l-1.958-23.232s.403-2.328.372-4.745c-.164-12.768.578-25.616 1.05-38.434.16-1.074 4.04-4.71 4.04-4.71' fill='%23e3e4e5' stroke-linecap='square' transform='matrix(.27413 0 0 .2759 340.815 162.125)'/%3E %3Cpath d='M356.761 323.788a7.326 7.326 0 0 0-5.446 2.507c-1.794 2.469-2.968 7.56-3.099 10.618-.034.807.3 1.426.045 2.149-.871 2.471-1.585 4.615-1.643 4.946-.757 4.317-.911 19.802-2 25.736-1.09 5.933-6.098 14.56-7.965 17.344-1.227 1.365-3.757 2.059-4.535 2.236-.779.177-7.197-.484-7.197-.484-8.468-.595-21.063-5.268-29.51-6.407-8.447-1.14-18.667-.597-26.626-1.443 0 0-9.95-3.678-19.116-1.016-9.031 2.623-14.11 7.479-21.957 19.542 0 0-3.37 4.117-3.41 5.468-.134 4.435 1.779 10.02 5.205 12.835 1.104 1.07.809.112.714-.165.01.019.011.014.027.048.304.659.664 2.389 1.099 2.991 1.166 1.62 2.383 3.41 3.312 5.198.778 1.498.373 3.254 1.072 4.762 3.846 8.304 2.058 16.825 2.024 26.49a2.067 2.067 0 0 1-.206.833c-.105 5.681-5.654 13.287-5.654 18.98v1.22c-.265.554-.532 1.042-.66 1.664-.028 1.591-2.167 1.838-1.493 2.982 2.955 6.687 3.364 8.665 4.491 13.22.381 1.653.55 2.554 1.223 4.424 1.12 2.39 4.063 12.08 4.063 12.08s-.342.554.277 3.126c.442 1.79 3.302 2.311 3.59 2.623 0 0 2.664 1.635 2.687 4.733 0 .394 2.52.222 2.857.222 1.02 0 1.998-.155 3.018-.155-.124-1.296-.45-2.056-1.357-2.787-.29-.157-1.46-.537-1.661-.755-.234-.254-.423-.769-.625-.949-1.283-1.143-1.538-2.591-2.643-3.987-.198-.25.174-1.605-.152-2.459-.325-.854-2.24-2.787-2.24-2.787l-5.198-20.858c-.714-4.734 2.864-7.443 3.234-11.325 0-.75 4.58-12.156 4.812-12.776 3.32-8.9 8.794-22.846 8.68-28.717-.126-6.571-.255 1.27.342-3.706.45-3.747-1.757-13.77-1.552-14.829 12.43 20.753 24.519 28.246 44.457 26.269 1.088-.098 1.498-.124 2.58.029 0 0 .44 1.085.518 1.578.72 2.868-1.1 15.308-1.74 21.119-.2 1.801-.638 5.903-.858 7.81 0 0-.973 1.955-.973 4.25 0 .7.02 1.4 0 2.1-.09 3.073.598 3.92.598 3.92 0 .737-.5 6.735-.5 7.472-.56 8.229-1.153 12.11-2.268 15.428-.198.591-.694 1.442-1.303 1.607-.574.43-1.53 1.332-1.634 2.11 0 .671.066 1.276.205 1.878.103.446.565 1.177.821 1.548.381 1.768.197 3.614.197 5.42 0 .458.204 1.187.312 1.656.13.559.637.564 1.018.667.696.189.454.622 1.018.775.467.126 1.008.106 1.536.106l5.402.03c-.088-2.019-2.06-3.058-3.429-4.027-.697-.623-.632-.767-.643-1.781 0-1.29-.143-2.736-.143-4.027 0-.695.298-.964.563-1.539.316-.686.08-1.694.08-2.477 1.006-6.872 2.164-13.925 3.992-20.616 1.465-1.898 2.108-4.32 2.544-6.708 0 0 1.177-3.191.777-4.888l4.964-30.15c.471-1.02 1.293-1.93 2.384-2.225 6.187-2.727 12.294-4.578 18.117-8.624 6.305-4.382 10.088-11.538 14.58-17.984.987-1.913 2.142-3.583 3.26-5.371 3.857-5.536 8.702-20.028 10-27.217 1.533-8.488.92-16.881 3.384-26.937.529-2.157 2.354-3.884 2.777-6.117l-.044-.406 1.232-.165c1.317-.155 2.943-.421 3.875-.445.979-.12 2.985-.107 3.16-.107.175 0 1.224.223 1.84.223.51 0 1.347.542 1.857.542.544 0 .95-.094 1.304-.542.65-.821.724-.563.893-1.297.056-.244.312.005.437-.039.471-.165.849-.777 1.411-.929.376-.102.662-.241.732-.62.088-.476.098-1.008.098-1.548 0-.791-.032-.831-.607-.987-.074-.02-.137-.08-.205-.116-.595-.161.098-1.33.098-1.994 0-.677-.018-1.162-.196-1.549-.232-.502-.334-.707-.822-1.103-.359-.292-.54-.676-.92-.88-2.81-2.42-4.042-4.224-6.018-6.089.33-.412.273-.616.152-1.297-.902-2.728-2.637-3.233-5.562-5.45-2.733-1.578-6.308-3.295-10.099-3.648h-1.634a6.64 6.64 0 0 0-.402-.01z' fill='%23fff' stroke-linecap='square' transform='matrix(.27413 0 0 .2759 340.815 162.125)'/%3E %3Cpath d='M438.616 251.458a2.003 2.003 0 0 0-1.493.691c-.491.682-.813 2.086-.849 2.93-.01.223.082.393.012.593-.239.682-.434 1.273-.45 1.364-.208 1.191-.25 5.464-.548 7.101-.299 1.637-1.638 4.049-2.184 4.785-.302.408-1.03.568-1.243.617-.214.05-1.973-.133-1.973-.133-2.321-.164-5.774-1.454-8.09-1.768-2.315-.314-5.117-.165-7.299-.398 0 0-2.728-1.015-5.24-.28-2.476.723-3.868 2.063-6.02 5.391 0 0-.923 1.136-.934 1.51-.036 1.2.467 2.705 1.373 3.495.017.014.296.194.313.208.04-1.935.353-2.857.353-2.857-.021.972.16 1.915.47 2.809.203.588.699 1.131 1.013 1.693.486 1.314.851 5.16 1.095 6.762.126.825-.494 3.606-.906 4.853-.799 2.419-1.15 4.591-.21 2.954.42-.73 2.02-3.79 2.842-6.64.822-2.85 1.624-4.5 1.374-5.08-.081-.188-.314-4.142-.367-4.296a2.36 2.36 0 0 1-.07-.24c-.022-.091-.078-.165-.018-.479l.39-2.024c4.024 7.526 10.439 8.46 14.79 3.202-.655 2.134-.683 5.237-.606 6.545.076 1.309.066.749.044 1.207l-.769 7.184-.068.141s-.174.395-.174.767c0 .175.007.376 0 .606-.01.337-.003.525.04.577l.124.154c.007.257-.006.512-.025.767-.005.086-.014.197-.022.296l.096-.12c.269-.338.418-.858.529-1.469 0 0 .008-.054.014-.077a4.054 4.054 0 0 0 .144-.473c.054-.222.064-.422.064-.422l-.041-.179.03-.181s1.358-8.274 1.36-8.319a.773.773 0 0 1 .071-.232c.26-.365.842-.773 1.057-1.023.221-.255 1.022-3.622.901-5.722-.278-4.815 6.057-6.183 8.178-3.806.796-.431 1.462-1.051 2.03-1.8.537-.709.98-1.538 1.355-2.44.05-.181.112-.377.157-.548.117-.454.21-.87.274-1.223.052-.293.095-.586.132-.878.037-.293.069-.587.096-.882.053-.59.092-1.185.14-1.794.047-.61.102-1.231.188-1.875a20.739 20.739 0 0 1 .372-2.003c.036-.149.094-.289.164-.427.069-.138.148-.273.227-.409.08-.135.157-.27.223-.41.065-.141.118-.287.147-.441l-.012-.113.217-.029c.002-.006.002-.015.003-.021-1.025.215-.564.05-1.554.181-.293 0-.541-.017-.776-.12-.5-.351-.921-.813-1.136-1.42 0-.68.221-1.975.407-2.324.617-1.156 1.122-.28 2.349.06 1.166.325 2.907 1.238 3.564 1.87.076.074.962.116 1.05.068.065-.036.136-.025.203-.048.001-.018.011-.038.015-.057.003-.016 0-.027.005-.045.027-.109.073-.237.073-.328a2.39 2.39 0 0 0-.01-.238.646.646 0 0 0-.044-.192c-.024-.053-.044-.087-.066-.123a.639.639 0 0 0-.159-.182c-.098-.08-.148-.186-.252-.243-.77-.667-1.108-1.165-1.65-1.68.09-.113.075-.17.042-.357-.248-.753-.723-.892-1.525-1.504-.75-.435-1.73-.91-2.768-1.007h-.448a1.832 1.832 0 0 0-.11-.002z' fill='%23d18219' stroke='none'/%3E %3Cpath d='M356.761 323.788a7.326 7.326 0 0 0-5.446 2.507c-1.794 2.469-2.968 7.56-3.099 10.618-.034.807.3 1.426.045 2.149-.871 2.471-1.585 4.615-1.643 4.946-.757 4.317-.911 19.802-2 25.736-1.09 5.933-6.098 14.56-7.965 17.344-1.227 1.365-3.757 2.059-4.535 2.236-.779.177-7.197-.484-7.197-.484-8.468-.595-21.063-5.268-29.51-6.407-8.447-1.14-18.667-.597-26.626-1.443 0 0-9.95-3.678-19.116-1.016-9.031 2.623-14.11 7.479-21.957 19.542 0 0-3.37 4.117-3.41 5.468-.134 4.435 1.779 10.02 5.205 12.835 1.104 1.07.809.112.714-.165.01.019.011.014.027.048.304.659.664 2.389 1.099 2.991 1.166 1.62 2.383 3.41 3.312 5.198.778 1.498.373 3.254 1.072 4.762 3.846 8.304 2.058 16.825 2.024 26.49a2.067 2.067 0 0 1-.206.833c-.105 5.681-5.654 13.287-5.654 18.98v1.22c-.265.554-.532 1.042-.66 1.664-.028 1.591-2.167 1.838-1.493 2.982 2.955 6.687 3.364 8.665 4.491 13.22.381 1.653.55 2.554 1.223 4.424 1.12 2.39 4.063 12.08 4.063 12.08s-.342.554.277 3.126c.442 1.79 3.302 2.311 3.59 2.623 0 0 2.664 1.635 2.687 4.733 0 .394 2.52.222 2.857.222 1.02 0 1.998-.155 3.018-.155-.124-1.296-.45-2.056-1.357-2.787-.29-.157-1.46-.537-1.661-.755-.234-.254-.423-.769-.625-.949-1.283-1.143-1.538-2.591-2.643-3.987-.198-.25.174-1.605-.152-2.459-.325-.854-2.24-2.787-2.24-2.787l-5.198-20.858c-.714-4.734 2.864-7.443 3.234-11.325 0-.75 4.58-12.156 4.812-12.776 3.32-8.9 8.794-22.846 8.68-28.717-.126-6.571-.255 1.27.342-3.706.45-3.747-1.757-13.77-1.552-14.829 12.43 20.753 24.519 28.246 44.457 26.269 1.088-.098 1.498-.124 2.58.029 0 0 .44 1.085.518 1.578.72 2.868-1.1 15.308-1.74 21.119-.2 1.801-.638 5.903-.858 7.81 0 0-.973 1.955-.973 4.25 0 .7.02 1.4 0 2.1-.09 3.073.598 3.92.598 3.92 0 .737-.5 6.735-.5 7.472-.56 8.229-1.153 12.11-2.268 15.428-.198.591-.694 1.442-1.303 1.607-.574.43-1.53 1.332-1.634 2.11 0 .671.066 1.276.205 1.878.103.446.565 1.177.821 1.548.381 1.768.197 3.614.197 5.42 0 .458.204 1.187.312 1.656.13.559.637.564 1.018.667.696.189.454.622 1.018.775.467.126 1.008.106 1.536.106l5.402.03c-.088-2.019-2.06-3.058-3.429-4.027-.697-.623-.632-.767-.643-1.781 0-1.29-.143-2.736-.143-4.027 0-.695.298-.964.563-1.539.316-.686.08-1.694.08-2.477 1.006-6.872 2.164-13.925 3.992-20.616 1.465-1.898 2.108-4.32 2.544-6.708 0 0 1.177-3.191.777-4.888l4.964-30.15c.471-1.02 1.293-1.93 2.384-2.225 6.187-2.727 12.294-4.578 18.117-8.624 6.305-4.382 10.088-11.538 14.58-17.984.987-1.913 2.142-3.583 3.26-5.371 3.857-5.536 8.702-20.028 10-27.217 1.533-8.488.92-16.881 3.384-26.937.529-2.157 2.354-3.884 2.777-6.117l-.044-.406 1.232-.165c1.317-.155 2.943-.421 3.875-.445.979-.12 2.985-.107 3.16-.107.175 0 1.224.223 1.84.223.51 0 1.347.542 1.857.542.544 0 .95-.094 1.304-.542.65-.821.724-.563.893-1.297.056-.244.312.005.437-.039.471-.165.849-.777 1.411-.929.376-.102.662-.241.732-.62.088-.476.098-1.008.098-1.548 0-.791-.032-.831-.607-.987-.074-.02-.137-.08-.205-.116-.595-.161.098-1.33.098-1.994 0-.677-.018-1.162-.196-1.549-.232-.502-.334-.707-.822-1.103-.359-.292-.54-.676-.92-.88-2.81-2.42-4.042-4.224-6.018-6.089.33-.412.273-.616.152-1.297-.902-2.728-2.637-3.233-5.562-5.45-2.733-1.578-6.308-3.295-10.099-3.648h-1.634a6.64 6.64 0 0 0-.402-.01z' fill='none' stroke-linecap='square' transform='matrix(.27413 0 0 .2759 340.815 162.125)'/%3E %3Cpath d='M382.265 343.818c0 .332-.169.795-.268 1.19-.015.064-.007.106-.017.165.083-.398.294-.837.294-1.22 0-.048-.009-.088-.009-.135z' fill='%23d39044' stroke-linecap='square' transform='matrix(.27413 0 0 .2759 340.815 162.125)'/%3E %3Cpath d='M334.948 432.87c-2.059 8.327-7.182 10.024-3.42 17.087 0 0-1.618-.118-2.592-2.837-.487-1.36-.813-3.37-.696-6.343.059-1.486.228-3.212.544-5.218.158-1.002.352-2.075.587-3.222' fill='%23fff' fill-rule='evenodd' transform='matrix(.27413 0 0 .2759 340.815 162.125)'/%3E %3Cpath d='M338.745 429.429c-2.058 8.327-7.182 10.024-3.42 17.087 0 0-2.025-.03-2.999-2.75-.487-1.359-.838-3.642-.858-5.371-.02-1.73.45-4.684.788-5.924.337-1.24 1.238-3.31 1.238-3.31' fill='%23fff' fill-rule='evenodd' transform='matrix(.27413 0 0 .2759 340.815 162.125)'/%3E %3Cpath d='M345.773 418.39c-2.934 5.509-5.297 10.213-6.52 14.3-1.225 4.089-1.996 6.272.31 10.602 0 0-1.567-.817-3.628-4.632-.65-1.204-1.086-3.867-.789-6.592a30.55 30.55 0 0 1 .776-4.396c.207-.808.465-1.662.79-2.58' fill='%23fff' fill-rule='evenodd' transform='matrix(.27413 0 0 .2759 340.815 162.125)'/%3E %3Cpath d='M348.502 414.884c-1.818 2.792-2.406 5.465-3.414 7.733-2.016 4.537-3.085 7.944-3.085 10.44 0 2.029-.357 3.709 1.905 7.156 0 0-1.061-.124-1.753-.543-.692-.419-1.56-1.194-2.269-2.62-.708-1.427-1.255-3.504-1.303-6.527-.024-1.511.478-3.745.89-5.217.413-1.473 1.807-4.55 1.807-4.55' fill='%23fff' fill-rule='evenodd' transform='matrix(.27413 0 0 .2759 340.815 162.125)'/%3E %3Cpath d='M353.27 334.537c.119-.233-11.574-3.636-13.242-13.858 2.275-2.15 14.25 5.702 14.438 12.987' fill='%23d18219' fill-rule='evenodd' stroke-width='1.364' transform='matrix(.27413 0 0 .2759 340.815 162.125)'/%3E %3Cpath d='M340.423 320.825c.093.205 6.265.184 11.133 10.596-1.095-1.244-6.04 1.675-11.092-10.204' fill-opacity='.502' fill-rule='evenodd' stroke-width='1.364' transform='matrix(.27413 0 0 .2759 340.815 162.125)'/%3E %3Cpath d='M368.707 335.545c.165-.134.396-.452.122-.75-5.102-3.192-4.857.706-8.443.706 1.71 0 1.706.234 2.345.926 2.32 2.515 3.917 2.265 5.976-.176' fill-rule='evenodd' stroke-width='1.364' transform='matrix(.27413 0 0 .2759 340.815 162.125)'/%3E %3Cpath d='M381.193 349.763c-.565.67-2.538-.793-3.984-.967' fill='none' stroke-linecap='square' transform='matrix(.27413 0 0 .2759 340.815 162.125)'/%3E %3Cpath d='M382.326 345.923s-.54-.438-4.32-.932c.004.07 2.605-2.673 2.835.29' fill-rule='evenodd' stroke-linecap='square' transform='matrix(.27413 0 0 .2759 340.815 162.125)'/%3E %3Cpath d='M302.663 436.88a33.59 33.59 0 0 0-.914 1.815c-1.068 2.348-1.409 4.538.472 8.069 0 0-1.617-.117-2.591-2.837-.487-1.36-.813-3.37-.696-6.343.03-.743.086-1.546.175-2.414' fill='%23fff' fill-rule='evenodd' transform='matrix(.27413 0 0 .2759 340.815 162.125)'/%3E %3Cpath d='M230.708 419.108s-1.55-6.161 2.09-13.014' fill='none' transform='matrix(.27413 0 0 .2759 340.815 162.125)'/%3E %3C/g%3E %3Cg fill='%23e7ca00' stroke-width='2.294'%3E %3Cpath d='M401.415 879.458c-2.045-1.515-4.023-6.243-3.27-8.842-2.694-2.22-9.659 2.184-6.276 8.588 3.354 6.388 7.986 5.85 9.57.267l-.024-.013zM420.519 885.467c.56-3.612-.686-9.663-6.934-10.747-6.235-1.067-8.153 4.548-6.958 10.324 4.5-3.395 11.623-1.683 13.892.423z' transform='matrix(.02666 -.34238 .30978 .02947 204.1 441.756)'/%3E %3Cpath d='M407.416 882.052c1.063-4.786 5.835-6.083 10.57-5.594-2.96-3.38-6.044-8.823-10.264-5.651-3.317 2.504-5.617 6.151-.299 11.225l-.008.02z' transform='matrix(.02666 -.34238 .30978 .02947 204.1 441.756)'/%3E %3Cpath d='M404.77 879.344c.56-3.612 2.025-8.456 5.93-10.433-3.367-3.054-11.69-2.136-12.302 4.1-.632 6.231 3.047 7.49 6.383 6.307l-.01.026zM388.887 919.375c5.28.85 12.283-1.796 10.307-13.708-1.878-11.299-10.192-14.04-10.816-11.348 4.77 1.667 4.154 17.65.475 25.103l.034-.047z' transform='matrix(.02666 -.34238 .30978 .02947 204.1 441.756)'/%3E %3Cpath d='M396.765 918.122c5.294.946 13.706-2.13 9.908-13.822-3.71-11.462-12.224-10.052-12.808-7.164 4.779 1.845 6.512 13.045 2.871 21.008l.03-.022z' transform='matrix(.02666 -.34238 .30978 .02947 204.1 441.756)'/%3E %3Cpath d='M376.728 918.168c3.859 3.455 13.822 4.688 17.015-6.829 3.011-10.905.276-14.41-3.62-16.18 1.943 5.672-5.07 21.665-13.412 22.991l.018.018zM402.151 917.195c3.263-1.816 10.612-5.074 5.805-16.066-3.936-8.966-10.087-5.15-11.753-3.603 4.31 1.812 8.14 11.493 5.948 19.67z' transform='matrix(.02666 -.34238 .30978 .02947 204.1 441.756)'/%3E %3Cpath d='M409.224 914.63c3.051-2.059 10.717-7.101 4.569-17.83-6.09-10.543-14.194-3.537-14.215-.648 3.563.888 9.641 9.955 9.673 18.46l-.027.017z' transform='matrix(.02666 -.34238 .30978 .02947 204.1 441.756)'/%3E %3Cpath d='M416.718 907.263c2.017-2.81 7.176-9.719-.7-16.792-7.758-6.967-12.759 1.783-12.047 4.285 3.199-.447 10.595 5.25 12.77 12.52l-.023-.013z' transform='matrix(.02666 -.34238 .30978 .02947 204.1 441.756)'/%3E %3Cpath d='M421.176 896.276c.56-3.612 2.045-12.624-7.034-14.705-8.902-2.034-9.573 8.603-8.069 10.431 2.395-2.185 10.557-1.078 15.103 4.274zM370.892 914.922c3.375 4.144 13.412 7.063 18.657-4.145 4.966-10.665 2.772-14.71-.953-17.146 1.016 6.117-8.907 21.318-17.712 21.318l.009-.027z' transform='matrix(.02666 -.34238 .30978 .02947 204.1 441.756)'/%3E %3Cpath d='M360.848 906.698c3.225 6.56 19.288 14.058 25.522 1.927 5.916-11.504 1.012-22.081-3.9-26.14 2.33 11.768-12.11 29.737-21.626 24.184l.004.029z' transform='matrix(.02666 -.34238 .30978 .02947 204.1 441.756)'/%3E %3Cpath d='M352.366 898.402c7.864 17.16 24.132 14.152 29.643 1.691 5.229-11.823 3.75-18.756-2.177-24.424-4.094 15.2-12.2 23.738-27.49 22.705l.024.028z' transform='matrix(.02666 -.34238 .30978 .02947 204.1 441.756)'/%3E %3Cpath d='M341.921 884.056c5.964 21.484 27.137 18.887 36.131 6.547 6.355-8.705 4.117-15.146.905-18.94-6.961 8.212-18.98 15.534-37.069 12.368l.033.025z' transform='matrix(.02666 -.34238 .30978 .02947 204.1 441.756)'/%3E %3Cpath d='M337.98 870.931c.633 21.914 26.07 24.33 37.372 11.791 7.983-8.845 7.368-15.426 5.227-19.305-8.432 8.338-25.238 18.384-42.626 7.488l.026.026z' transform='matrix(.02666 -.34238 .30978 .02947 204.1 441.756)'/%3E %3Cpath d='M332.703 850.203c-3.87 28.348 29.128 37.617 43.467 20.689 7.698-9.07 7.333-15.432 5.2-19.31-14.3 10.02-39.159 11.185-48.688-1.376l.021-.003z' transform='matrix(.02666 -.34238 .30978 .02947 204.1 441.756)'/%3E %3Cpath d='M329.46 823.53c-9.486 30.632 19.29 41.583 38.047 38.528 14.855-2.403 23.204-19.886 21.094-23.738-18.552 13.087-55.366 1.82-59.157-14.759l.016-.032z' transform='matrix(.02666 -.34238 .30978 .02947 204.1 441.756)'/%3E %3Cpath d='M329.06 799.67c-12.676 29.897 15.364 47.446 38.583 45.69 15.216-1.153 27.753-7.06 27.202-19.552-22.745 8.013-58.219-5.432-65.807-26.134l.021-.004z' transform='matrix(.02666 -.34238 .30978 .02947 204.1 441.756)'/%3E %3Cpath d='M329.966 774.93c-12.693 30.576 14.747 55.711 43.465 56.342 14.648.316 21.34-3.593 27.196-13.299-20.73 3.532-64.889-27.938-70.661-43.044z' transform='matrix(.02666 -.34238 .30978 .02947 204.1 441.756)'/%3E %3Cpath d='M329.57 765.272c-11.333 35.923 80.312 80.423 84.993 33.705-21.913 11.482-81.753-20.668-84.992-33.705z' transform='matrix(.02666 -.34238 .30978 .02947 204.1 441.756)'/%3E %3Cpath d='M327.523 755.606c-15.379 19.757 93.055 78.167 95.506 28.363-9.762 5.009-29.87.684-49.265-8.106-19.38-8.787-33.155-22.855-46.237-20.233l-.005-.024z' transform='matrix(.02666 -.34238 .30978 .02947 204.1 441.756)'/%3E %3Cpath d='M310.962 751.12c19.613.483 61.382 30.938 89.302 36.03 17.874 3.25 32.459-4.197 24.146-35.544-28.487 29.115-82.917-17.824-111.77-6.766-2.968-1.407.62 8.346-1.655 6.276l-.023.004z' transform='matrix(.02666 -.34238 .30978 .02947 204.1 441.756)'/%3E %3Cpath d='M314.738 755.54c19.01-11.796 58.328 10.083 86.15 11.273 17.08.697 38.39-18.62 24.406-47.052-21.874 37.6-82.887 7.493-108.6 27.333-1.927 4.301-.85 9.998-1.984 8.422l.028.025z' transform='matrix(.02666 -.34238 .30978 .02947 204.1 441.756)'/%3E %3Cpath d='M307.104 756.761c20.232-14.78 61.569-6.196 88.05-8.343 17.572-1.444 43.746-32.009 19.805-57.475-14.86 53.842-64.483 27.223-107.269 58.258-2.12 5.473.796 8.86-.59 7.531l.005.03z' transform='matrix(.02666 -.34238 .30978 .02947 204.1 441.756)'/%3E %3Cpath d='M314.385 751.966c16.663-15.72 57.604-14.669 81.93-27.066 16.32-8.304 32.874-43.645 4.386-61.42-2.962 56.707-55.186 38.963-87.452 80.94-.782 6.006 2.732 8.47 1.112 7.55l.025-.003z' transform='matrix(.02666 -.34238 .30978 .02947 204.1 441.756)'/%3E %3Cpath d='M316.126 744.463c12.345-22.09 50.302-27.61 70.82-45.993 18.351-16.443 23.318-46.355-7.626-55.908-2.63 59.192-43.855 46.685-60.74 82.265-3.214 7.812-1.534 20.485-2.45 19.665l-.004-.029z' transform='matrix(.02666 -.34238 .30978 .02947 204.1 441.756)'/%3E %3Cpath d='M325.504 721.914c12.654-20.094 22.161-13.181 42.356-33.822 17.383-17.772 22.62-60.366-7.793-61.346 4.545 51.455-15.245 51.997-29.134 79.625.503 6.14-3.665 15.957-5.404 15.54l-.025.003z' transform='matrix(.02666 -.34238 .30978 .02947 204.1 441.756)'/%3E %3Cg stroke-width='3.041'%3E %3Cpath d='M310.424 602.663l-10.497 5.67-49.929 153.76 18.14 40.066 17.139 2.478 20.712-1.52 30.737-138.479 8.666-56.418-21.061-12.406-13.907 6.85z' fill-rule='evenodd' transform='matrix(.01816 -.28057 .21499 .02864 268.014 416.628)'/%3E %3Cpath d='M309.263 597.474c.415 2.04.853 4.105 1.293 6.14 9.833-6.845 20.436-.176 23.345 15.636 2.902 15.806-3.027 38.861-13.668 56.633-6.681 14.63-14.639 32.223-16.986 56.246-1.823 18.767 1.856 41.713-2.283 62.595-2.528 10.013-7.857 9.093-18.2 8.451 4.162 6.833 9.334 10.587 16.036 10.365 14.42-3.208 24.74-16.165 28.494-44.84-4.283-23.95-3.188-47.936 9.852-72.08 11.634-11.987 22.336-25.543 26.268-49.987 1.883-12.145-.47-25.209-9.616-39.046-11.482-17.358-20.812-17.994-29.61-16.439-4.964 2.075-9.942 4.22-14.925 6.326z' transform='matrix(.01816 -.28057 .21499 .02864 268.014 416.628)'/%3E %3C/g%3E %3Cpath d='M-325.656 629.664c.001-3.088 2.01-5.59 4.489-5.59 2.478 0 4.487 2.502 4.488 5.59h-8.977z' transform='matrix(1.42023 .479 .59921 -1.38227 519.312 1387.444)' fill-rule='evenodd' stroke-width='.5'/%3E %3Cpath d='M295.504 723.041c-3.802 7.233-11.304 10.594-16.734 7.42-5.396-3.156-6.684-11.681-2.921-18.968 3.798-7.261 11.303-10.593 16.734-7.42 5.395 3.156 6.683 11.682 2.921 18.968zM276.557 641.066c-2.604-3.571-6.329-5.807-10.315-5.098-2.38.416-4.722 1.872-6.674 3.928-.077-.335-.154-.67-.206-1.009-1.39-7.709 4.797-16.772 11.401-17.96 2.956-.504 5.787.562 8.115 2.677-1.25 2.797-1.784 5.89-1.26 8.804a15.217 15.217 0 0 0 1.071 3.588 18.318 18.318 0 0 0-2.107 5.066l-.025.003z' transform='matrix(.02666 -.34324 .30978 .01956 205.666 443.535)'/%3E %3Cpath d='M300.305 632.437c-2.852-3.625-6.749-5.866-11.004-5.267-4.033.568-7.999 3.659-10.677 7.768a18.765 18.765 0 0 1-1.132-4.147c-1.379-8.954 6.038-19.14 13.72-20.221 1.936-.273 3.81.037 5.537.831-.14 1.345-.13 2.69.075 4.016.624 4.048 2.48 7.614 5.04 10.154-.948 2.18-1.497 4.524-1.564 6.837l.004.029zM258.047 677.375c-.141.19-.302.418-.445.637-3.207-.469-6.187-2.176-8.529-4.746 2.477 2.462 5.648 3.974 8.97 4.08l.004.029zM264.755 663.75c-4.083-2.303-7.247-6.804-8.091-12.286-1.336-8.673 5.853-18.57 13.294-19.617a9.12 9.12 0 0 1 2.192-.044c-2.664 3.71-4.224 8.47-3.54 12.915.442 2.867 1.507 5.478 3.055 7.652-3.307 2.732-5.946 6.931-6.89 11.347l-.02.033z' transform='matrix(.02666 -.34324 .30978 .01956 205.666 443.535)'/%3E %3Cpath d='M258.333 689.203c-2.006.599-4.083.405-5.87-.778-4.37-2.896-5.54-10.496-2.61-16.944 2.96-6.423 8.955-9.313 13.354-6.392 1.681 1.11 2.896 2.926 3.583 5.133a7.544 7.544 0 0 0-5.375.382c-4.698 2.155-7.138 8.593-5.42 14.328a11.05 11.05 0 0 0 2.343 4.3l-.004-.03z' transform='matrix(.02666 -.34324 .30978 .01956 205.666 443.535)'/%3E %3Cpath d='M262.393 693.964c-3.06-.953-5.817-3.465-7.408-7.237-2.952-6.974-.85-15.61 4.763-19.248 2.876-1.84 6.1-2.036 8.974-.859-.526 3.151-.222 6.56 1.094 9.65 1.357 3.231 3.617 5.555 6.195 6.745-2.549-.671-5.28-.316-7.754 1.269-3.12 2.021-5.157 5.613-5.848 9.619l-.016.061zM257.279 743.409c-7.009-4.475-11.336-13.985-9.674-21.123 1.4-5.975 6.675-8.44 12.495-6.39-2.556 5.19-3.25 11.933-1.444 18.2 1.494 5.228 4.476 9.203 8.076 11.404-2.763.647-6.115.052-9.429-2.095l-.024.003z' transform='matrix(.02666 -.34324 .30978 .01956 205.666 443.535)'/%3E %3Cpath d='M251.674 769.938a12.338 12.338 0 0 1-.917-.99c-5.64-6.455-7.08-16.8-3.218-22.981 3.619-5.802 10.678-5.957 16.217-.642-2.971 6.512-2.259 15.325 1.637 22.195-3.235-1.473-6.876-1.563-10.343.132a14.099 14.099 0 0 0-3.352 2.282l-.024.003z' transform='matrix(.02666 -.34324 .30978 .01956 205.666 443.535)'/%3E %3Cpath d='M268.083 783.814c-5.381-.309-10.723-6.313-12.475-14.487-1.953-9.153 1.305-17.664 7.28-18.91l.266-.037c2.876 4.717 7.182 7.526 11.73 7.725.033.047.066.1.105.184-6.72 4.626-9.86 15.335-7.062 25.003.05.162.101.332.156.522zM265.208 717.594c-6.588 2.105-14.435-2.685-17.468-10.685-3.008-7.997-.113-16.28 6.5-18.396 1.694-.526 3.484-.6 5.256-.335 1.523 4.76 4.285 8.457 7.625 10.57-1.374 4.536-1.511 9.759-.05 14.727.264.942.58 1.847.956 2.685-.853.576-1.786 1.082-2.823 1.405l.004.029z' transform='matrix(.02666 -.34324 .30978 .01956 205.666 443.535)'/%3E %3Cpath d='M269.946 727.884c-7.013-4.51-11.361-13.99-9.673-21.123 1.673-7.11 8.767-9.257 15.78-4.754 2.025 1.297 3.856 3.048 5.367 5.022-4.177 5.416-5.767 13.84-3.536 21.6.128.504.303 1.023.48 1.514-2.54.328-5.486-.376-8.418-2.26z' transform='matrix(.02666 -.34324 .30978 .01956 205.666 443.535)'/%3E %3Cpath d='M284.7 750.888c-3.681 7.63-11.189 10.503-16.705 6.352-5.491-4.115-6.942-13.723-3.283-21.381 3.681-7.63 11.188-10.503 16.704-6.352 5.486 4.115 6.941 13.715 3.284 21.381zM275.434 703.142c-3.779 1.886-7.908 2.151-11.274.358-6.168-3.363-7.576-12.505-3.14-20.38 3.15-5.529 8.39-8.998 13.392-9.385 2.208 1.985 5.027 2.972 7.878 2.57.168.146.341.328.495.505-7.94 3.422-12.165 13.327-9.413 22.051a16.01 16.01 0 0 0 2.034 4.263l.028.018z' transform='matrix(.02666 -.34324 .30978 .01956 205.666 443.535)'/%3E %3Cpath d='M284.18 666.044c1.218 7.903-4.118 15.27-10.446 16.162-6.308.888-12.472-4.831-13.693-12.763-.864-5.605 1.874-11.709 5.799-15.11 2.616 4.35 6.942 6.957 11.389 6.33 1.595-.224 3.156-.841 4.56-1.82a23.142 23.142 0 0 1 2.367 7.204l.024-.003z' transform='matrix(.02666 -.34324 .30978 .01956 205.666 443.535)'/%3E %3Cpath d='M287.201 705.726c-5.672 2.926-12.188-1.39-14.474-9.664-2.285-8.275.45-17.434 6.142-20.392 1.763-.903 3.602-1.11 5.392-.73a25.498 25.498 0 0 0-1.654 3.538c-3.388 9.103-1.72 20.056 3.749 24.342.9.713 1.867 1.21 2.867 1.466a9.937 9.937 0 0 1-2.001 1.408l-.02.032z' transform='matrix(.02666 -.34324 .30978 .01956 205.666 443.535)'/%3E %3Cpath d='M304.5 667.948c.426 2.76-.017 5.464-1.083 7.859-5.203-3.176-12.142.017-15.889 7.242-4.182-1.796-7.535-6.13-8.367-11.533-1.183-7.679 5.123-16.42 11.7-17.457.027.342.078.674.13 1.012 1.146 7.435 7.098 12.89 13.466 12.427l.064.418-.02.032z' transform='matrix(.02666 -.34324 .30978 .01956 205.666 443.535)'/%3E %3Cpath d='M303.513 696.658c-4.26 9.226-12.873 13.369-19.195 9.203-6.288-4.15-7.974-15.092-3.725-24.346 4.26-9.226 12.872-13.375 19.196-9.202 6.288 4.15 7.974 15.092 3.724 24.345zM289.382 655.22c-1.417 2.99-3.648 5.49-6.347 6.878-6.282 3.152-13.95-.31-17.067-7.746-3.098-7.44.944-18.534 7.22-21.721 2.655-1.353 5.524-1.146 8.18.055-.028.151-.056.295-.079.475-1.667 9.692 1.944 19.186 8.093 22.06zM320.61 614.137c.4 2.594.033 5.177-.908 7.437-2.47-3.075-5.82-4.959-9.444-4.448-4.329.61-8.583 4.542-10.675 9.378-2.219-2.219-3.83-5.297-4.372-8.812-1.197-7.774 5.22-16.611 11.888-17.55 6.643-.935 12.326 6.176 13.526 13.97l-.015.025z' transform='matrix(.02666 -.34324 .30978 .01956 205.666 443.535)'/%3E %3Cpath d='M322.452 630.627c1.01 6.556-3.192 12.756-8.577 14.633-2.38-3.426-5.837-5.648-9.628-5.114a9.624 9.624 0 0 0-2.845.894c-1.484-1.919-2.569-4.327-2.985-7.028-1.13-7.341 4.957-15.736 11.26-16.623 6.308-.888 11.69 5.862 12.824 13.231l-.05.007z' transform='matrix(.02666 -.34324 .30978 .01956 205.666 443.535)'/%3E %3Cpath d='M293.229 654.4c-3.093 1.87-6.583 2.104-9.461.235-5.117-3.394-6.486-12.284-3.047-19.782 3.457-7.501 10.464-10.872 15.58-7.486 2.723 1.802 4.368 5.14 4.824 9.044-5.169 3.775-8.978 11.09-7.955 17.732l.04.259.019-.003zM256.479 798.67c-5.803 2.083-12.089-2.383-14.383-10.509-2.41-8.633.555-18.22 6.643-21.323 5.695-2.9 12.154.88 14.95 8.45-6.2 4.464-9.267 14.214-7.215 23.353l.004.03z' transform='matrix(.02666 -.34324 .30978 .01956 205.666 443.535)'/%3E %3Cpath d='M270.605 803.782c-6.263 2.781-13.224-1.096-15.517-8.766-2.294-7.67.943-16.318 7.258-19.217 5.442-2.496 11.415.057 14.436 5.725-5.846 4.71-8.578 13.89-6.18 22.237l.003.021z' transform='matrix(.02666 -.34324 .30978 .01956 205.666 443.535)'/%3E %3Cpath d='M267.557 817.92c-5.657 2.577-11.968-.899-14.041-7.797-1.382-4.663-.507-9.733 1.976-13.306 3.978 3.385 9.068 4.39 13.799 2.083a14.505 14.505 0 0 0 3-1.976 14.325 14.325 0 0 1 1.746 3.78c.713 2.373.828 4.889.445 7.24-2.093 2.252-3.666 5.204-4.587 8.498-.7.585-1.49 1.071-2.338 1.478zM276.083 847.28c-6.371 2.907-13.464-1.01-15.799-8.786-2.325-7.754.966-16.497 7.33-19.403.46-.212.951-.391 1.45-.52-.24 3.08.033 6.288.932 9.415 2.072 7.178 6.908 11.988 12.306 13.068-1.376 2.755-3.518 5.014-6.215 6.255l-.004-.028z' transform='matrix(.02666 -.34324 .30978 .01956 205.666 443.535)'/%3E %3Cpath d='M285.171 848.437c-6.135 2.792-12.96-.987-15.2-8.466a17.692 17.692 0 0 1-.001-9.943c4.011 3.6 9.243 4.704 14.112 2.348 2.663-1.295 4.898-3.48 6.55-6.207a16.606 16.606 0 0 1 1.591 3.596c2.239 7.479-.92 15.858-7.051 18.672z' transform='matrix(.02666 -.34324 .30978 .01956 205.666 443.535)'/%3E %3Cpath d='M293.142 863.357c-6.142 2.793-12.968-.993-15.207-8.472-.611-2.041-.808-4.14-.683-6.197 2.383.415 4.88.086 7.294-1.056 4.181-2.024 7.283-6.259 8.816-11.362 3.03 1.414 5.585 4.388 6.8 8.42 2.238 7.471-.914 15.85-7.045 18.67l.025-.003zM272.959 786.054c-2.764-1.739-5.05-4.729-6.214-8.59-2.452-8.252 1.007-17.505 7.788-20.616 6.75-3.108 14.31 1.09 16.794 9.337 1.87 6.236.33 13.062-3.474 17.366-3.14-1.972-6.987-2.409-10.58-.754-1.641.753-3.098 1.878-4.314 3.257zM319.823 651.64c1.07 6.56-5.47 16.885-12.166 18.31-6.695 1.424-10.884-1.834-13.949-6.191-3.064-4.357-4.273-10.017-2.61-15.188 1.663-5.171 6.083-10.364 10.441-12.278 4.358-1.915 7.371-1.174 10.919 1.74 3.547 2.914 6.296 7.046 7.365 13.606z' transform='matrix(.02666 -.34324 .30978 .01956 205.666 443.535)'/%3E %3Cpath d='M285.163 808.599c-6.136 2.785-12.968-.993-15.207-8.472-2.231-7.473.92-15.851 7.052-18.673 6.135-2.792 12.961.994 15.195 8.438 2.239 7.479-.913 15.857-7.044 18.678l.004.029z' transform='matrix(.02666 -.34324 .30978 .01956 205.666 443.535)'/%3E %3Cpath d='M283.132 834.193c-6.042 2.742-12.815-.985-15.011-8.352-2.197-7.368.9-15.657 6.962-18.432 6.043-2.779 12.81.956 15.01 8.345 2.197 7.368-.893 15.656-6.96 18.439z' transform='matrix(.02666 -.34324 .30978 .01956 205.666 443.535)'/%3E %3C/g%3E %3C/g%3E %3Cpath d='M409.148 236.484l-.492.61-19.765 24.61-.43.538.5.477c6.348 6.046 10.027 16.339 10.039 24.601.016 10.524-1.697 17.768-3.828 24.43-2.945 9.203-6.749 17.31-7.922 30.79-.87 10.002 2.735 17.795 7.367 23.42 4.632 5.627 10.27 9.118 13.617 10.696 10.277 4.846 20.881 3.175 31.477 4.531 4.707.603 7.3 3.549 9.742 6.141l.547.578.547-.578c2.442-2.592 5.035-5.538 9.742-6.14 10.596-1.357 21.2.314 31.477-4.532 3.347-1.578 8.985-5.07 13.617-10.695 4.632-5.626 8.238-13.42 7.367-23.422-1.173-13.479-4.977-21.586-7.922-30.789-2.131-6.662-3.844-13.906-3.828-24.43.012-8.262 3.69-18.555 10.04-24.601l.5-.477-.43-.539-19.766-24.61-.492-.609-.586.516c-6.065 5.3-13.055 7.214-20.04 6.914-6.984-.3-13.953-2.845-19.828-6.492l-.398-.242-.398.242c-5.875 3.647-12.844 6.193-19.829 6.492-6.984.3-13.974-1.614-20.039-6.914l-.586-.516zm.211 2.125c6.226 5.172 13.403 7.108 20.477 6.805 6.851-.294 13.601-2.637 19.414-6.031v72.054h-52.414c2.045-6.542 3.68-13.83 3.664-24.117-.013-8.482-3.597-18.715-10.031-25.18l18.89-23.53zm81.282 0l18.89 23.532c-6.434 6.464-10.018 16.697-10.031 25.18-.016 10.286 1.619 17.574 3.664 24.116H450.75v-72.054c5.813 3.394 12.563 5.737 19.414 6.031 7.074.303 14.251-1.633 20.477-6.805zm-94.29 74.328h107.297c2.937 9 6.479 16.826 7.602 29.727.834 9.582-2.579 16.945-7.023 22.344-4.445 5.398-9.941 8.799-13.102 10.289-9.792 4.617-20.157 3.015-31.023 4.406-4.884.625-7.775 3.551-10.102 6.024-2.327-2.473-5.218-5.399-10.102-6.024-10.866-1.39-21.231.21-31.023-4.406-3.16-1.49-8.657-4.89-13.102-10.29-4.444-5.398-7.857-12.761-7.023-22.343 1.123-12.901 4.665-20.727 7.602-29.726z' fill='%23e7ca00' stroke='%23d4af37' stroke-width='.75'/%3E %3Cg fill='%23008f4c'%3E %3Cpath d='M524.96 203.558c-.109.012-.18.051-.211.13-.143.495-.574 3.182-.86 5.936-.214 2.753-.569 5.01-.64 5.01-.071 0-1.575-.634-3.36-1.41-4.354-1.907-13.421-2.968-13.921-1.627-.357.847.647 5.646 2.289 11.153.357 1.2-.07 1.56-2.64 2.336-1.714.494-3.646 1.339-4.36 1.904-1.214.847-1.07 1.13 2 3.954l3.36 3.037-1.579 1.272c-1.499 1.2-1.496 1.197 3.93 6.351 5.997 5.649 9.118 7.377 13.187 7.377 1.25 0 2.637.234 3.64-.054 1.336-.23 2.382-.68 5.665-1.033 3.548.312 7.041 2.05 8.445 2.82.345.76.639 1.446.86 2.013-2.539-2.755-8.164-3.851-9.336-3.893-1.173-.042-1.768.271-3.024.655s-1.735.964-2.93 2.621c-.856 2.189.844 4.466 2.914 4.748 2.57.353 4.493-1.061 4.493-3.391 0-1.907-1.094-3.283-.196-3.215 3.132.238 7.838 2.72 8.766 5.897 1.07 3.954.857 4.17-1.07 1.488-1.785-2.33-4.573-4.809-5.43-4.88-.643 0-2.07 3.464-2.07 5.088 0 1.059-.283 1.27-1.211.917-.714-.353-2.287-.707-3.5-.848l-2.211-.354.57 3.53c.286 1.906 1.215 4.806 2 6.359l1.5 2.89-3.43-1.056c-7.353-2.259-6.85-2.334-6.351 1.55.214 1.906.645 4.028.86 4.663.428 1.06.068 1.272-2.43 1.272-1.642 0-2.93.212-2.93.424 0 1.624 5.785 9.318 8.64 11.577 3.499 2.683 10.14 5.65 12.782 5.65.785 0 3.138.633 5.351 1.48l3.93 1.41v4.24c0 4.66-1.434 14.052-2.219 14.052-.214 0-1.496-1.977-2.781-4.448-2.927-5.366-2.785-5.294-3.57-4.024-.572.848-.711.777-.711-.423 0-2.048-3.29-8.19-5.36-10.167l-1.71-1.627-.86 1.904-.852 1.835-3.859-4.232c-2.142-2.33-4.136-4.097-4.422-3.885-.357.141-.784 2.052-1.07 4.17-.714 6.143-1.003 6.491-3.36 4.232l-2-1.904-.5 1.904c-.856 3.389.22 15.32 1.72 19.486.785 2.188 1.781 6.218 2.28 8.972.857 5.295 3.928 11.364 7.712 15.177 1.356 1.412 1.567 1.973.71 1.973-.57 0-1.568.566-2.21 1.272-2.785 3.036-.213 6.989 4 6.212 2.07-.353 2.496-.212 3.21 1.342 1.071 2.259 1.14 6.359.141 8.124-.714 1.341-4.927 3.103-5.64 2.397-.215-.212-.353-2.612-.282-5.295l.07-4.872-3.64 1.912c-8.781 4.66-16.167 16.664-18.047 25.914-.627 3.087-2.402 3.427-4.632 7.083-2.182 1.236-4.308 2.859-6.375 4.988-3.57 3.46-4.505 3.953-9.86 5.295-6.567 1.624-20.628 3.882-31.194 4.94-9.21.919-38.191 5.575-39.976 6.352-.785.353-2.643 1.131-4.07 1.696-1.428.565-3.146 1.839-3.86 2.898-1 1.553-1.066 2.048-.28 3.53 1.927 3.53 5.637 3.457 13.561-.285 3.499-1.694 7.78-3.105 10.922-3.6 2.784-.423 6.928-1.27 9.07-1.765 2.142-.565 8.134-1.627 13.203-2.474 28.842-4.59 39.407-6.85 51.187-10.945 7.853-2.754 7.789-2.749 15-2.043 8.138.777 18.412-1.768 22.624-5.58.928-.848 3.358-3.813 5.5-6.637 2.07-2.824 4.641-5.647 5.64-6.282 2.713-1.765 1.146-2.405-5.85-2.405h-5.86l2-4.37c2.284-5.084 4.639-11.794 4.21-12.217-.142-.142-2.207.136-4.491.701-2.356.494-4.359.85-4.43.779-.143-.142.142-1.197.57-2.398.571-1.553 1.356-2.4 2.64-2.682 1.072-.212 2.36-.568 2.93-.71.5-.14 2.142.001 3.641.425 2.642.706 2.716.848 2.36 3.037-.429 2.753 1.07 4.732 3.64 4.732 1.856 0 3.992-2.051 3.992-3.746 0-1.906-2.779-4.162-4.492-3.738-.857.141-3.288-.211-5.43-.917l-3.851-1.341 3.71-.779c5.64-1.2 7.497-.987 8.282.779.5 1.13 1.43 1.693 3 1.834 4.497.424 5.924-5.935 1.64-7.276-1.57-.494-5 1.203-5 2.474 0 .424-1.212.701-2.64.701-2.966.031-5.852.6-8.39 1.573l5.46-2.698c3.284-.988 7.573-2.543 9.5-3.46 6.354-2.966 12.636-10.308 14.992-17.297 1.5-4.449 3.784-18.36 3.07-18.36-.357 0-2.712.92-5.21 2.05-4.57 2.118-4.641 2.115-4.641.562.071-2.895 1.281-11.44 1.781-12.71.357-.777.213-1.195-.43-1.195-2.141 0-9.063 3.813-13.632 7.484-4.426 3.53-4.86 3.742-4.86 2.259 0-.918.645-2.683 1.43-3.954 1.285-2.118 1.641-2.258 4.211-1.835 2.499.424 2.93.206 4-1.418 1.5-2.26.646-4.943-1.781-5.72-1.357-.423-1.219-.632 1.351-1.903 3.213-1.554 6.641-5.153 9.211-9.812l1.711-2.899-2.57.286c-1.428.14-2.563.209-2.563.138 0-.07.5-1.482 1.07-3.106.572-1.624 1.07-4.305 1.07-5.858 0-2.966-2.64-13.77-3.64-14.9-.357-.423-1.787.216-3.43 1.557l-2.78 2.19-2.649-5.79c-1.428-3.176-2.779-5.932-2.922-6.073-.143-.212-1.07.423-2.07 1.341-2.213 2.048-2.357.92-.43-3.245 1.714-3.671 2.501-4.17 4.5-2.829 2.428 1.554 5.136.075 5.422-2.89.143-1.765-.144-2.474-1.5-3.392-.928-.565-2.211-.92-2.71-.709-.643.212-1.29-.354-1.86-1.696-.5-1.341-1.427-2.252-2.64-2.605-3.713-.918-6.284 3.738-3.571 6.42 1.07.99 1.074 1.768.289 6.923-1.285 8.33-1.711 9.106-2.71 5.364-1.143-4.165-.649-15.742.85-19.13 2.57-5.861 1.073-15.117-3.21-19.918-3.547-3.972-13.366-10.978-14.992-10.791zm-4.961 19.323c.62.021 3.29 2.277 7.625 7.4 3.622 4.298 7.933 11.711 10.726 17.235-.98-1.142-1.64-1.204-4.484-5.118-2.356-3.248-6.18-10.402-9.82-14.144-3.28-3.31-4.546-5.253-4.102-5.365a.196.196 0 0 1 .055-.008z' fill='%2300a854'/%3E %3Cpath d='M537.86 298.711c-.68 2.67-1.233 3.15.195 5.197.642.989 1.856 1.554 3.07 1.554 1.927 0 2.998 1.412 4.64 6.354.214.777.357.777.357-.212.072-.706-.571-2.47-1.356-4.024-.857-1.695-1.143-2.895-.714-3.177 1.356-.848.785-4.448-.857-5.578-2.213-1.553-2.932-1.139-5.336-.114z'/%3E %3C/g%3E %3Cpath d='M405.906 414.495c-1.499 1.209-1.888 3.13-.777 4.23 1.61 1.592 7.219.164 7.83-2.033.777-3.075-3.998-4.558-7.053-2.197z' fill='%239eab05'/%3E %3Cg fill='%2375b52b'%3E %3Cpath d='M526.632 209.418c.571 3.53 3.998 10.732 6.568 13.698 1.071 1.27 2.07 2.189 2.285 2.047.143-.212-1.856-4.448-4.498-9.39-3.712-7.06-4.712-8.473-4.355-6.355zM502.859 228.411c.785.847 11.422 3.883 11.422 3.248 0-1.27-3.426-2.754-7.496-3.177-2.356-.283-4.14-.283-3.926-.07zM507.285 237.025c.857.847 13.35 6.566 16.777 7.696 2.07.706 4.783 1.13 6.068.988 2.142-.211 1.928-.353-2.57-1.835-2.713-.918-6.425-2.401-8.21-3.319-4.355-2.189-13.35-4.801-12.065-3.53zM547.907 255.17c-1.07 3.248-2.784 14.121-3.284 21.182-.357 4.59-.286 6.142.571 7.202.928 1.27 1.07.706 1.856-5.649 1.071-8.967 2.213-24.5 1.928-24.853-.143-.141-.643.848-1.071 2.118zM535.913 261.03c.357 5.649 2.784 11.721 3.641 9.038.286-.847-.428-3.954-1.713-7.696l-2.213-6.284.285 4.943zM527.917 261.172c.5.706 1.714 2.189 2.57 3.248l1.642 2.047v-1.836c0-1.059-.714-2.33-1.856-3.177-2.284-1.836-3.64-1.906-2.356-.282zM517.85 278.611c0 .353 7.783 6.284 10.353 7.908 2.07 1.27 2.07 1.27-.571-1.836-2.713-3.177-7.14-6.354-8.853-6.354-.5 0-.928.141-.928.282zM521.777 293.862c1.857 7.837 3.285 12.285 4.07 12.78.5.282 1 .494 1.07.352.358-.353-3.355-11.085-4.497-13.062l-1.07-1.835.427 1.765zM529.988 300.004c0 1.06.642 3.248 1.427 4.802.786 1.553 1.285 2.33 1.143 1.694-.143-.635-.571-2.612-.786-4.448-.57-3.671-1.784-5.084-1.784-2.048zM515.495 305.3c1.356 4.519 4.855 11.65 9.78 19.628 3.642 6.001 3.642 6.001 3.856 3.53.143-1.977-.571-3.742-3.213-8.19-1.856-3.107-4.997-8.614-6.996-12.144-1.928-3.6-3.784-6.496-4.07-6.496-.285 0 0 1.695.643 3.672zM559.83 306.359c-3.142 3.389-9.424 12.144-11.495 16.168-.714 1.413-.928 2.825-.642 3.954.428 1.624 1.428.353 8.495-10.802 4.355-6.99 7.71-12.638 7.425-12.638-.357 0-1.999 1.482-3.784 3.318zM548.55 358.818c-1.071 1.977.285 4.237 2.57 4.237 2.07 0 3.355-2.472 2.284-4.448-.857-1.624-3.926-1.554-4.855.211z'/%3E %3C/g%3E %3Cg fill='%23d91023'%3E %3Cpath d='M527.56 251.005c-2.713 1.906.143 6.707 2.999 5.013 1.713-1.13 1.999-3.884.428-5.013-.714-.495-1.5-.918-1.713-.918-.215 0-1 .423-1.714.918zM546.265 235.754c-1.642.424-2.285 2.612-1.285 4.448 1.428 2.613 4.997 1.553 4.997-1.483 0-2.118-1.642-3.389-3.712-2.965zM550.977 241.19c-.214.565-.286 1.766-.143 2.684.143 1.27.643 1.624 2.285 1.624 2.57 0 3.997-1.907 2.855-3.743-1-1.553-4.426-1.976-4.997-.564zM524.205 346.745c-2.642 2.118-.143 5.86 3.141 4.59 1.5-.566 2.07-2.26 1.214-3.813-1-1.907-2.57-2.19-4.355-.777zM538.731 299.412c-.785.777-.57 3.389.357 4.307 2.142 2.118 5.355 0 4.57-3.036-.357-1.342-.929-1.765-2.5-1.765-1.07 0-2.212.212-2.427.494zM551.967 299.317c-.5 2.047.714 3.883 2.57 3.883 1.713 0 2.999-1.694 2.713-3.671-.143-1.271-.714-1.695-2.499-1.836-1.999-.212-2.356.07-2.784 1.624zM553.832 351.405c-.5 2.047.714 3.883 2.57 3.883 1.714 0 2.999-1.694 2.713-3.671-.142-1.271-.713-1.695-2.498-1.836-2-.212-2.356.07-2.785 1.624zM549.489 357.94c-2.642 2.118-.143 5.86 3.141 4.59 1.5-.565 2.07-2.26 1.214-3.813-1-1.907-2.57-2.19-4.355-.777z'/%3E %3C/g%3E %3Cpath d='M519.886 223.47c.288.456 1.667 2.076 3.047 3.61 2.644 2.872 4.8 5.857 8.795 12.082 2.817 4.406 6.381 8.897 6.381 8.073 0-.853-6.323-11.456-8.824-14.81-3.305-4.378-8.565-9.807-9.571-9.807-.201 0-.144.313.172.853z' fill='%2375b52b'/%3E %3Cpath d='M538.141 312.72c-.086.483-.822 5.236-1.138 10.808-.747 12.905-1.408 19.846-2.874 28.175-.633 3.667-1.236 7.249-1.322 7.96l.19 1.182 1.178-1.649c1.264-1.734 2.586-2.985 4.483-4.264.633-.455 2.673-2.36 4.484-4.292 9.083-9.58 11.612-12.564 19.43-22.911 7.243-9.637 8.997-12.053 8.853-12.223-.287-.256-2.54 1.887-11.566 13.059-2.5 3.098-6.737 7.959-9.295 10.801-6.295 6.936-13.327 13.385-15.182 15.879-.17.229.258-1.62.603-2.985 1.61-6.794 2.271-14.27 2.472-28.88.086-6.368.115-11.57.029-11.57-.086 0-.23.398-.345.91zM520.508 359.377c-.546.91-2.242 3.894-3.794 6.623-4.83 8.642-10.405 16.459-14.63 20.524-1.524 1.478-1.09 1.605-1.409 1.933-1.668 1.717 5.059 2.928 10.175 3.44 6.898.681 10.721-.683 29.145-10.405 4.312-2.274 5.461-2.984 4.599-2.842-1.696.284-4.369.91-12.36 4.719-7.817 3.695-11.312 5.31-14.848 6.106-2.76.625-6.806.682-9.192.113l-1.627-.108.863-.284c.718-.17 1.833-.21 2.207-.523.374-.342 1.84-1.388 3.248-2.098 3.19-1.62 6.703-4.542 11.532-8.863 3.707-3.298 10.836-10.49 10.836-10.944 0-.313-3.334 2.416-7.617 6.197-8.853 7.845-17.533 13.672-21.241 14.27l-1.092.17 1.15-1.023c.373-.54 1.77-2.604 3.207-4.708 3.45-5.031 4.771-7.43 7.99-13.997 2.96-6.054 4.18-9.664 3.979-9.835-.058-.057-.575.626-1.121 1.535zM520.722 268.268c-.087.484 3.69 5.047 8.042 10.035 4.449 5.1 7.062 7.11 10.604 11.563 3.54 4.452 3.906 4.78 7.858 8.345 4.928-6.48 7.952-15.308 10.037-20.922 2.062-5.549 3.723-10.314 3.774-17.632-2.826 6.119-2.911 8.318-5.12 14.99-2.228 6.733-7.19 18.392-9.046 20.886-.17.229-10.422-12.355-14.895-17.57-4.749-5.54-11.273-10.272-11.254-9.695z' fill='%23eac102' fill-opacity='.502'/%3E %3Cpath d='M524.08 208.323l-.859 6.377-2.579-1.276c-2.722-1.275-9.743-2.763-13.11-2.763-1.863 0-1.935.142-1.577 2.267.43 2.268 2.221 8.715 2.866 10.132.143.425-1.075 1.134-2.723 1.63-1.719.496-3.653 1.346-4.37 1.913-1.29.921-1.146 1.134 1.576 3.543 3.224 2.905 3.51 3.684 1.72 4.96-1.075.779-.645 1.416 4.084 5.951 2.937 2.834 6.59 5.74 8.024 6.448 3.653 1.913 10.746 1.913 14.543 0 2.65-1.347 2.866-1.347 4.585-.213 1.72 1.063 1.791 1.063.86-.07-.573-.638-3.94-2.693-7.45-4.464-9.888-5.102-17.983-14.03-21.422-23.878-1.72-4.889-1.72-7.51.071-7.51 2.938 0 9.17 1.558 12.681 3.117 5.23 2.41 14.544 11.337 17.123 16.509 1.863 3.613 2.078 4.889 2.15 10.274 0 6.235 1.002 8.856 1.146 3.188.286-7.156.501-8.786 1.576-11.478 2.149-5.243 1.074-13.25-2.365-17.997-1.146-1.488-4.871-4.747-8.382-7.227-3.439-2.409-6.52-4.676-6.734-5.101-.287-.355-.932 2.196-1.433 5.668zm9.171 1.063c4.8 3.33 6.162 4.747 7.666 7.793 2.293 4.748 3.01 10.487 1.72 14.738l-1.004 3.188-1.862-3.967c-1.218-2.693-3.797-5.881-8.024-10.062-3.367-3.4-6.52-6.164-6.95-6.164-.788 0-.501-4.818.573-8.998.43-1.842 0-2.055 7.881 3.472zm-22.997 17.359c.645 1.133 1.79 2.338 2.436 2.834.716.496 1.433 1.559 1.647 2.338.359 1.275 0 1.417-3.367 1.417s-3.94-.213-6.52-2.834c-1.504-1.559-2.65-2.976-2.435-3.118.573-.566 5.23-2.48 6.09-2.55.501 0 1.432.85 2.149 1.913zm9.528 10.982c4.156 3.826 5.374 4.605 10.389 6.59 2.65 1.062 2.794 1.204 1.647 2.267-1.576 1.558-9.457 2.125-13.039.92-3.08-.991-14.257-11.052-13.11-11.761 1.218-.78 4.943-1.559 7.665-1.63 1.935-.07 3.153.638 6.448 3.614zM540.487 250.764c-.286.354 0 1.913.573 3.472 1.29 3.613 1.218 4.676-.071 7.156-.573 1.134-1.075 3.33-1.075 4.818 0 1.559-.358 3.826-.86 5.101l-.788 2.268-2.364-1.488c-1.29-.85-2.507-2.197-2.722-2.976-.645-2.126-.359-6.66.501-10.982.645-3.047 1.146-3.897 2.15-3.826 1.074.141 1.146-.071.358-.921-.717-.922-1.003-.922-1.791.212-.502.709-1.147 2.267-1.362 3.543-.43 2.338-.43 2.338-2.507 1.346-3.08-1.63-4.227-1.346-4.227.992s1.218 6.093 2.722 8.431c1.648 2.48 1.72 1.418.072-1.77-1.934-3.898-2.58-8.007-1.29-8.007.574 0 1.72.496 2.58 1.062 1.29.922 1.504 1.701 1.36 5.881-.07 5.669-.572 5.952-7.307 3.685-2.22-.78-4.227-1.276-4.442-1.134-.286.354.86 6.306 1.648 8.219.287.85-.215 1.063-2.937.78l-3.368-.213 2.006 3.4c4.442 7.724 10.89 12.33 19.774 14.171 2.794.567 6.161 1.56 7.38 2.197 1.719.921 2.005.921 1.36.142-.43-.567-2.077-1.488-3.582-1.984-4.083-1.488-8.024-4.322-13.182-9.778-5.158-5.456-7.81-10.061-7.81-13.604 0-1.842.216-2.267 1.075-1.913.645.213 3.081.921 5.517 1.559 6.018 1.488 7.594 2.409 11.463 6.518 4.084 4.322 5.445 6.873 6.663 12.683.573 2.55 1.146 4.747 1.36 4.96.932.992 1.219-2.267.43-5.03-1.289-4.677.646-13.746 4.73-21.753 1.79-3.542 7.307-8.927 8.167-7.935.286.283 1.217 3.33 2.149 6.73 1.934 7.228 1.648 9.353-1.791 16.51-2.508 5.101-4.872 8.077-8.597 10.77-2.794 1.983-2.006 2.62 1.862 1.629 3.44-.921 8.956-5.952 11.965-10.911l1.576-2.693-2.794.496-2.723.425 1.29-3.755c1.648-4.818 1.648-6.731 0-12.47-.788-2.622-1.576-5.668-1.863-6.731l-.43-1.984-2.292 1.63c-1.29.85-2.508 1.842-2.723 2.196-.86 1.204-1.862-.142-4.298-5.527-1.29-2.905-2.58-5.314-2.866-5.314-.358 0-1.433.85-2.507 1.913l-1.863 1.984.43-1.984c.358-1.346.215-1.842-.287-1.558-.358.212-.716 1.133-.716 1.984 0 3.4-1.218 3.4-2.293.07-.573-1.842-1.218-3.046-1.433-2.692zm10.388 17.855c-2.077 4.11-3.51 8.36-4.083 11.62l-.86 5.101-1.146-2.834c-.645-1.63-2.078-3.897-3.08-5.172-1.935-2.197-1.935-2.338-1.147-7.369 1.218-8.006 2.794-12.328 5.66-15.446l2.579-2.905 2.65 5.243 2.651 5.173-3.224 6.589zm-27.152 11.69c8.74 9.07 11.75 12.613 10.245 12.117-6.52-1.913-11.105-5.314-14.544-10.628-1.361-2.055-2.436-3.968-2.436-4.18 0-.213.86-.355 1.863-.355 1.29 0 2.866.992 4.872 3.047zm40.765 5.598c-2.866 4.535-4.586 6.235-7.738 7.794l-2.866 1.488 2.866-3.118c1.576-1.7 3.654-4.322 4.514-5.739 1.433-2.267 2.436-2.976 4.657-3.33.286 0-.359 1.276-1.433 2.905z' fill='%23cab313' fill-opacity='.502'/%3E %3Cpath d='M538.41 256.361c1.003 2.126 2.865 4.322 2.937 3.543 0-.425-.86-1.7-1.863-2.834-1.003-1.205-1.504-1.488-1.074-.709z' fill='%23005000'/%3E %3Cpath d='M519.496 293.347c-.287 1.488-.788 3.897-1.218 5.455l-.645 2.693-2.078-1.913-2.006-1.913-.573 3.33c-.645 4.605.144 11.478 2.15 17.926.93 2.976 1.934 7.014 2.22 8.998.86 6.519 6.233 14.17 13.183 18.918 1.29.921 1.79 2.126 2.22 5.314l.574 4.11-.143-3.897c-.072-2.126-.932-7.37-1.863-11.691-2.221-10.274-1.576-14.596 3.582-25.082l3.725-7.51 3.798 7.58c5.086 10.133 5.588 13.534 2.865 21.823-1.074 3.33-2.292 6.377-2.65 6.873-.359.496-.502 1.134-.359 1.488.215.283.072.992-.358 1.559-.573.85-.645.78-.287-.354.287-.78-.716-.071-2.364 1.77-1.576 1.772-3.009 3.827-3.224 4.606-.358 1.276-.286 1.276.86-.141a225.01 225.01 0 0 0 2.508-3.401c.716-.992 1.576-1.63 1.862-1.417 1.075.566 2.078-1.276 4.442-7.865 3.296-9.211 5.373-12.825 9.887-17.36 3.009-2.975 5.946-4.888 10.961-7.297 3.797-1.771 7.021-3.26 7.165-3.26.573 0-1.577 12.33-2.794 15.943-1.362 4.322-5.23 10.415-8.311 13.25-3.01 2.763-9.027 5.738-14.687 7.297-2.436.709-4.657 1.488-4.872 1.842-.358.638 5.302-.92 10.532-2.905 7.594-2.763 14.758-10.132 17.696-17.925 1.29-3.401 4.083-18.139 3.51-18.635-.143-.142-2.507.85-5.373 2.197l-5.087 2.409.43-4.748c.215-2.621.788-6.235 1.29-8.148.86-3.259.86-3.33-.645-2.905-3.582 1.063-10.03 4.96-13.899 8.503l-4.227 3.755.215-6.519c.215-4.393.072-6.093-.358-5.101-.358.78-.716 2.834-.716 4.605-.072 3.614-1.577 10.628-2.293 10.628-.287 0-1.576-2.054-2.866-4.605-2.364-4.393-3.439-5.597-3.582-3.755 0 .496-.716-.992-1.648-3.401-.86-2.338-2.507-5.456-3.653-6.944l-2.078-2.692-1.146 2.196-1.147 2.197-2.722-3.543c-1.505-1.984-3.367-3.897-4.084-4.251-1.146-.638-1.361-.355-1.72 1.913zm4.871 2.196c2.723 3.33 8.67 14.525 9.457 17.855l.43 1.772-1.29-1.772c-2.292-3.259-8.525-8.856-12.322-11.053-1.863-1.063-1.934-1.417-1.433-3.755.287-1.417.717-3.401 1.003-4.535.215-1.062.645-1.913.932-1.913.286.071 1.719 1.559 3.223 3.401zm9.959 6.873c2.078 4.322 2.507 7.014 1.361 8.786-.931 1.488-6.806-10.84-6.233-13.108.43-1.559.645-1.7 1.648-.85.645.496 2.078 2.834 3.224 5.172zm-12.681 2.267c4.585 3.047 9.242 7.652 10.46 10.416.645 1.275.43 2.267-.716 4.534-1.935 3.756-3.01 11.479-2.293 16.58.287 2.267.287 4.11 0 4.11-.931 0-6.09-6.59-8.454-10.7-4.728-8.29-8.096-21.822-6.95-27.845l.502-2.692 1.576 1.346c.86.78 3.51 2.693 5.875 4.251zm43.273 0c-.359 1.913-.789 5.173-1.003 7.298-.43 3.826-.502 3.968-4.657 6.519-2.365 1.488-5.588 4.322-7.308 6.518-1.648 2.126-3.224 3.755-3.51 3.543-.359-.142-.788-1.842-1.075-3.684-.215-1.843-.931-4.393-1.433-5.74-.931-2.125-.86-2.55.502-4.463 3.009-4.18 15.761-13.32 18.627-13.32.215 0 .143 1.487-.143 3.33zm-38.473 34.648c2.65 2.692 4.227 4.818 4.012 5.597-.143.992-.931.567-3.869-2.196-3.94-3.685-7.092-8.503-7.809-11.975-.43-1.842-.215-1.7 1.433 1.063 1.003 1.771 3.797 5.172 6.233 7.51z' fill='%23cab313' fill-opacity='.502'/%3E %3Cpath d='M519.424 356.902c-7.737 5.172-14.263 15.949-16.256 24.587-.144 2.196-2.485 4.037-2.127 3.825.287 1.06 2.49-.047 3.484-3.542 1.881-6.616 7.09-18.493 13.896-23.24 2.078-1.417 4.155-2.622 4.514-2.622.358 0 .501 2.693.358 6.164-.143 4.748-.645 7.015-1.935 9.637-2.149 4.322-7.952 10.698-12.036 13.037-3.438 1.983-3.725 2.834-.573 1.63 3.51-1.347 11.821-9.92 14.042-14.526 1.147-2.338 2.078-4.676 2.078-5.172 0-.496.86-1.275 2.006-1.7 2.58-.992 15.403-4.18 15.69-3.827.573.567-4.898 12.04-6.689 14.378-2.722 3.471-9.242 8.431-12.466 9.423-1.504.425-4.744 2.17-7.138 2.615-2.605.483-3.387.522-6.428.85l-2.528 1.5 2.508-.424c1.361-.213 4.8-.638 7.522-.921 7.887-2.737 10.917-4.444 16.081-8.4l3.355-2.84 6.428.328 5.23.425-2.436 2.905a676.904 676.904 0 0 0-5.588 6.802c-1.648 2.126-4.012 4.393-5.23 5.102-3.44 1.984-10.962 3.613-17.266 3.613-5.732.071-5.875 0-8.74-2.55-2.938-2.622-4.085-3.118-4.514-1.984-.072.354-2.58 1.417-5.374 2.48-5.588 1.912-6.806 1.417-3.582-1.56 1.218-1.133 2.496-1.128 5.075-1.27 0 0 5.419 1.208 5.473.095.054-1.107-5.4-1.02-5.4-1.02-2.546.15-3.137.065-1.135-2.537 2.351-1.477 3.28-4.36 2-3.73-3.132 3.784-5.16 5.283-9.881 9.88-4.508 3.122-5.08 3.335-11.248 5.034-3.94.92-10.46 1.983-14.328 2.48-7.51.848-10.697 2.735-3.44 1.413 3.672-.669 8.38-1.2 14.4-2.264 8.681-2.126 9.258-2.27 13.54-4.538 3.5-3.6 4.072-4.023 2.222-1.062-.645 2.196.43 2.125 7.307-.496 5.445-2.126 5.589-2.126 6.95-.78 1.361 1.346 1.29 1.417-1.433 2.55-5.803 2.41-17.123 5.527-28.657 7.795-6.592 1.346-12.18 2.621-12.395 2.905-.573.567 7.81-.355 9.6-1.134.789-.283 6.735-1.842 13.255-3.33 6.52-1.559 13.97-3.684 16.62-4.747 4.443-1.772 5.16-1.842 8.956-1.134 4.8.85 12.753.071 18.556-1.842 4.442-1.417 7.522-4.039 12.036-10.345 1.863-2.621 4.227-5.384 5.23-6.093l1.862-1.346-6.304-.425c-3.439-.213-6.448-.567-6.591-.78-.144-.141.215-1.275.86-2.48.573-1.204 2.077-4.818 3.223-7.935l2.15-5.81-2.508.496c-1.361.212-3.654.638-5.015.85l-2.507.496 1.074-2.621c.573-1.418.932-2.551.717-2.551-.144 0-.788 1.133-1.362 2.48-1.217 2.763-2.65 3.33-2.149.85.215-1.134 0-.921-.86.708-.716 1.276-2.077 2.551-3.08 2.976-1.003.355-2.436.85-3.224 1.134-1.218.567-1.29.212-1.003-4.818.143-3.472 0-5.456-.502-5.456-.43 0-2.364 1.063-4.37 2.41z' fill='%23cab313' fill-opacity='.502'/%3E %3Cpath d='M452.51 403.878c-4.156.354-12.538 1.63-26.509 3.897-7.307 1.134-13.612 2.125-14.113 2.196-.502 0-.717.284-.573.567.215.284-.788.709-2.15.921-3.152.638-6.806 3.614-6.806 5.669 0 2.054 2.364 4.18 4.084 3.755 1.146-.284 1.075-.355-.143-.425-3.153-.142-4.37-3.826-1.935-5.952 2.006-1.842 11.463-4.606 16.836-5.03 6.806-.567 26.437-3.26 27.296-3.827.43-.212 3.01-.78 5.803-1.275 4.729-.78 3.798-1.063-1.79-.496z' fill='%23cab313' fill-opacity='.502'/%3E %3Cpath d='M440.688 410.75c-12.895 2.48-20.92 4.535-24.788 6.52-5.015 2.48-4.299 2.692 1.074.283 2.508-1.134 6.807-2.41 9.529-2.835 2.65-.425 8.597-1.558 13.11-2.48 4.514-.92 10.03-1.983 12.18-2.338l3.94-.637-3.224-.071c-1.79 0-7.092.708-11.82 1.559z' fill='%23cab313' fill-opacity='.502'/%3E %3Cpath d='M497.182 391.946c-2.24 1.348-4.552 4.011-2.046 3.609 1.901-.168 9.019-2.331 9.574-3.735-2.724.24-4.962-.417-7.528.126z' fill='%23fff'/%3E %3Cg stroke='%23d4af37' stroke-width='.904'%3E %3Cpath d='M367.709 432.44c-1.503.459-2.482.902-9.093.441-4.507-.307-10.173-1.117-13.102-1.194-5.56-.077-5.603.349-15.52 7.111-6.986 4.764-16 4.41-22.667 2.93-4.057-1.844-5.8-2.26-5.199-1.261 1.127 1.844 9.01 4.402 13.368 4.402 7.061 0 12.245-1.768 20.734-7.07 6.535-4.15 9.465-4.534 18.48-2.459 10.621 2.102 12.195 1.195 20.868-2.706-2.588-.073-3.194-.001-4.064.351 1.494-1.625 1.555-3.144 1.85-4.183.43-.566-.721.19-2.11 1.164-1.39.974-3.02 2.166-3.545 2.474z' fill='%23fff' transform='matrix(.83739 0 0 .82218 198.784 50.956)'/%3E %3Cpath d='M354.025 429.835c-4.883-.768-8.23-1.435-11.29-1.092-3.41.38-5.839 2.075-9.895 4.61-4.057 2.613-7.708 4.495-8.159 4.495-.526 0-5.764 1.22-9.746 1.22-1.878 0-5.913-1.245-8.617-2.244-5.71-2.151-7.794 1.329-1.86 3.865 5.276 1.8 10.625 2.506 15.617 1.763 4.991-.743 9.625-2.935 13.47-5.77 7.627-5.624 3.166-2.918 6.206-4.207 3.04-1.288 5.848-.851 5.848-.851 3.982.153 11.88 1.466 15.862 1.543 7.287-.658 6.037-.672 8.441-2.05.838-.48 3.488-2.234 3.65-2.63.16-.398 1.39-2.702 1.154-2.793-7.452 5.131-11.202 5.12-20.681 4.141z' fill='%23d91023' transform='matrix(.83739 0 0 .82218 198.784 50.956)'/%3E %3Cpath d='M341.028 435.395c-1.052.461-4.207 2.306-7.137 3.996-6.16 3.765-11.96 5.57-18.748 5.647-3.08.463-13.072-3.606-11.57-3.145 1.608 3.033 3.952 3.425 9.676 4.508 3.993.756 6.582.13 11.062-.826 5.02-.615 7.078-2.888 8.956-4.271 4.357-3.228 11.893-5.37 13.996-5.37.977 0 4.757 2.065 8.902 2.962 4.145.896 6.145 1.127 10.443.444s8.724-4.2 12.84-6.924c-.669.21-2.132.214-4.14.276-5.895 3.474-15.88 4.783-21.134 2.425-5.333-1.306-10.517-.951-13.146.278z' fill='%23d91023' transform='matrix(.83739 0 0 .82218 198.784 50.956)'/%3E %3C/g%3E %3Cg%3E %3Cpath d='M388.708 210.486c-9.086 2.995-18.677 10.198-24.662 18.471-1.298 1.783-2.452 3.138-2.596 2.996-.072-.143.577-3.78 1.586-8.06 1.01-4.278 1.803-8.557 1.731-9.556 0-1.64-.144-1.569-2.884 1.427-3.462 3.85-8.005 12.337-9.736 18.186-.937 3.137-1.298 6.632-1.298 13.122l.072 8.915-1.73-6.276c-1.803-6.704-3.678-11.268-5.553-13.622-.937-1.212-1.226-1.284-1.875-.357-1.37 2.069-.433 10.912 1.875 17.473.216.785-.649-.356-1.947-2.496-1.37-2.14-2.812-3.78-3.173-3.566-.865.428-.937 7.417-.072 10.341.649 2.069.649 2.069-1.803-.713-4.038-4.635-4.976-4.992-4.976-1.783 0 1.213.505 3.352 1.082 4.779.577 1.355 1.082 2.638 1.082 2.71 0 .07-1.01.356-2.308.641-3.173.642-4.182 1.64-4.182 4.28 0 2.852 1.947 9.485 2.956 10.127 1.082.641 1.442 0 2.38-4.137l.865-3.708 2.668 3.423c3.822 4.992 9.52 16.403 12.404 24.89 3.029 9.057 3.173 10.84.36 5.277-1.153-2.21-3.173-5.563-4.398-7.417-2.74-3.85-17.812-19.47-18.822-19.47-1.082 0 0 4.85 1.947 8.915.938 1.997 3.75 5.92 6.13 8.772 2.452 2.782 4.254 5.135 4.038 5.135-.216 0-1.947-1.14-3.75-2.496-3.678-2.781-7.427-4.92-7.932-4.493-.144.214 1.298 3.21 3.245 6.775l3.461 6.49-2.307-.356c-1.298-.214-3.03 0-3.894.427-1.298.714-1.515 1.498-1.515 4.921 0 4.565 1.154 9.414 2.236 9.414 1.01 0 2.812-4.493 2.812-6.918 0-1.925.072-1.854 3.678 1.57 5.12 4.992 11.97 13.478 18.75 23.32l5.696 8.344-6.706-4.992c-6.418-4.707-19.615-12.052-21.778-12.052-.577 0-1.082.285-1.082.641 0 .357 4.254 4.636 9.447 9.557l9.374 8.915-4.903-1.64c-2.669-.856-6.058-1.784-7.428-2.069-2.452-.499-2.452-.356 3.029 4.707 3.028 2.853 8.509 7.06 12.259 9.414 3.678 2.282 6.057 3.923 5.264 3.709-6.562-1.855-16.225-3.424-16.225-2.568 0 .999 4.976 4.921 8.509 6.704 1.947.927 6.85 2.924 10.961 4.28 8.365 2.923 13.413 5.562 17.668 9.27l2.884 2.568-5.048-2.211c-5.769-2.567-21.417-7.774-23.22-7.774-1.803 0 5.409 7.06 12.403 12.267 6.419 4.778 18.606 10.84 27.403 13.693 7.356 2.353 13.558 3.566 25.24 5.064 5.192.641 10.096 1.426 11.033 1.782.865.428 7.211 1.355 14.062 2.14 20.047 2.353 34.686 5.777 43.268 10.127 2.307 1.141 4.831 1.57 10.095 1.854 7.789.357 8.15.143 5.914-4.136-1.875-3.566-5.192-5.42-12.26-6.704-3.533-.713-9.374-1.854-12.98-2.567-7.572-1.57-22.138-4.137-40.6-7.06-19.83-3.21-28.412-6.633-37.714-14.978-13.774-12.266-20.985-32.164-18.75-51.847.505-4.208.794-7.703.65-7.845-.65-.57-5.265 8.914-6.49 13.193l-1.299 4.707.289-7.56c.505-11.767 4.903-22.75 11.538-29.097 1.442-1.355 2.596-2.71 2.596-2.995 0-.286-1.37-.143-3.029.285-2.163.5-4.255 1.854-6.85 4.493l-3.75 3.709 1.73-3.352c2.668-5.278 7.284-10.555 11.683-13.48l4.11-2.638-2.38-.214c-4.76-.5-13.34 5.705-18.1 13.122-2.74 4.35-2.74 2.996.072-3.637 2.668-6.49 6.779-12.837 11.25-17.544 2.524-2.639 2.956-3.495 2.019-3.495-3.75 0-10.096 4.85-15.36 11.768-1.515 2.068-1.515 1.925.216-2.14 2.164-4.85 5.48-10.27 8.582-13.693 2.235-2.567 1.586-2.924-2.164-1.212-3.39 1.64-8.87 7.702-12.043 13.55-1.514 2.71-2.596 4.28-2.38 3.495.217-.785.722-2.853 1.082-4.636 2.668-11.839 9.159-23.392 17.956-31.879 3.39-3.21 4.255-4.493 3.318-4.493-2.74 0-9.159 3.637-13.413 7.631-4.4 4.137-4.471 4.137-2.74 1.284 6.057-10.199 15.143-19.47 25.6-26.102 3.317-2.14 6.057-4.065 6.129-4.28 0-1.07-10.961 2.211-15.937 4.708-1.154.641-3.894 2.567-6.202 4.421-3.461 2.782-3.822 2.996-2.524 1.141 2.452-3.423 10.745-10.769 14.062-12.48 2.452-1.284 2.74-1.64 1.515-1.855-3.317-.499-12.548 4.35-19.76 10.342l-3.172 2.71 1.73-2.853c5.625-9.2 12.548-16.546 20.697-21.823 2.884-1.855 5.697-3.495 6.202-3.709.432-.142.72-.5.504-.713-.216-.214-2.812.357-5.697 1.355zm108.386 203.968c1.01 1.07 1.875 2.211 1.875 2.497 0 .356-1.587.641-3.606.641-3.461 0-3.605-.07-3.605-1.996 0-3.638 2.307-4.066 5.336-1.142z' fill='%2300a854'/%3E %3Cpath d='M492.543 413.18c-1.731 1.64-1.443 4.35.505 4.85 3.028.784 6.994.498 6.994-.571 0-1.07-4.615-5.42-5.769-5.42-.36 0-1.153.499-1.73 1.14z' fill='%239eab05'/%3E %3Cpath d='M392.463 209.25c-7.627 1.33-14.279 5.866-20.117 10.72-.815.751-1.259 1.178-1.29 1.286-.43.489-4.3 3.934-6.68 7.252-1.156 1.334-2.76 3.613-3.593 4.99.179-1.354 1.193-5.411 2.227-9.98 1.158-5.44 1.668-9.844 1.523-10.058-.724-.645-5.95 6.198-8.555 11.422-3.835 7.515-4.96 12.695-4.96 23.43l-.079 8.928-1.757-6.784c-1.882-7.085-5.121-14.463-6.64-14.892-.507-.143-1.079.875-1.368 2.378-.434 2.362-.032 4.636 3.008 16.803.217 1.002-.567.08-1.797-2.067-2.75-4.795-3.696-5.88-4.492-5.38l1.953 2.807c1.085 1.575 3.033 5.298 4.336 8.304 3.546 8.374 8.837 26.119 7.968 26.978-.217.143-.653-.434-1.015-1.365-.362-.93-1.358-3.642-2.227-6.003-.868-2.362-2.816-6.605-4.336-9.396-3.4-6.226-5.86-13.092-6.367-17.816l-.39-3.47c-1.002.779-.597 4.921.82 9.474.724 2.433 1.283 4.366 1.21 4.366-.144 0-1.711-2.004-3.593-4.366-2.605-3.292-3.634-4.147-4.14-3.43-.652 1.073-.27 3.203 1.25 7.211l.976 2.73h-2.383c-1.302 0-2.948.434-3.672.935-1.23.859-1.31 1.43-.586 5.224.833 4.688 1.998 8.13 2.891 8.187 1.43.09 1.388-1.412 2.11-5.497.29-1.171.787-1.894.898-2.573.306.43.747.953 1.367 1.598 6.089 8.285 11.569 19.632 14.101 27.29 2.027 6.083 5.786 22.104 5.352 22.533-.145.215-1.04-2.497-1.836-6.004-2.895-12.166-6.984-19.358-19.648-31.811 0 0-4.347-5.2-7.852-7.213.058 2.933.664 3.431.664 3.431.869 4.437 3.108 8.3 9.766 16.1 2.967 3.508 5.351 6.615 5.351 6.901 0 .215-1.65-1.102-3.75-2.963-3.835-3.363-9.772-7.2-10.351-6.627-.217.143 1.21 3.29 3.164 6.94 2.46 4.58 3.218 6.445 2.422 6.159-2.822-1.145-3.855-1.145-5.664 0-1.882 1.217-1.88 1.332-1.445 6.198.217 2.72.815 5.652 1.25 6.51.868 1.432.85 1.446 1.718-.272.507-.93 1.078-2.941 1.367-4.444.29-1.432.72-2.651.938-2.651.244 0 3.916 3.822 5.703 5.575.714.93 1.548 1.943 2.422 3.001 4.27 5.225 16.062 20.273 19.101 25.068l1.524 2.495-2.461-1.91c-8.178-7.002-21.575-14.832-26.64-16.335-1.419-.42-1.8-.016-1.133.74-.025.003-.064-.013-.079 0 3.477 4.695 13.69 13.262 16.368 15.517 2.677 2.254 2.65 3.092 2.578 3.235-.145.072-2.012-.797-5.196-1.87-8.177-2.864-10.304-2.927-9.218-1.638.506.572 1.732.98 2.89 1.052 4.198.072 14.845 4.73 22.227 9.669 4.776 3.22 16.214 14.095 17.734 16.958.796 1.575.512 1.426-2.383-.936-3.908-3.149-14.756-9.311-15.625-8.81-.29.215-2.836-.26-5.586-.975-2.822-.716-7.026-1.507-9.414-1.793l-4.257-.507 2.539 2.3c3.328 3.006 8.9 5.707 18.164 8.928 4.124 1.431 8.837 3.358 10.43 4.288 3.473 2.004 10.634 7.595 10.272 7.953-.144.143-2.78-.862-5.82-2.222-5.138-2.362-17.857-6.795-22.343-7.797-1.665-.358-1.1.345 3.242 4.64 2.894 2.719 7.831 6.74 11.015 8.888 15.342 10.09 29.249 14.537 55.156 17.543 4.125.5 7.21 1.123 6.992 1.481-.217.358 6.3 1.318 13.32 2.106 18.816 2.218 30.546 4.789 41.328 9.083 4.704 1.932 7.468 2.56 12.461 2.846 4.776.286 6.406.215 6.406-.429 0-1.646-2.07-4.87-4.531-7.017-2.171-1.861-3.61-2.974-12.148-4.406-5.355-.858-10.17-2.02-10.82-2.378-.652-.357-11.403-1.855-23.633-3.86-26.848-4.293-35.101-6.232-42.265-9.667-17.73-8.589-29.807-27.28-30.82-48.965-.218-4.366-.083-10.074.351-12.866.434-2.72.73-5.08.586-5.224-.651-.644-6.124 10.241-6.992 14.464l-.352 2.729-.273-4.912c-.072-11.165 3.525-20.885 9.531-29.044 0 0 4.009-3.943 4.57-4.99.039-.03.037-.08.04-.117.018-.055.019-.095 0-.117-.022-.024-.028-.054-.079-.039-.015-.015-.019-.024-.039-.039-2.863-.895-5.953 1.458-10.117 5.185-2.587 2.61-2.941 3.256-3.086 3.041.164-1.874 7.66-13.255 9.18-13.255.29 0 2.134-2.163 2.812-2.807.869-2.218-4.479 2.696-8.242 7.992-8.438 11.243-10.356 22.604-9.922 37.777.145 4.652-.2 8.303-.273 8.303-.362 0-2.547-5.42-3.633-8.927-2.75-8.875 1.469-27.387 8.633-36.763 1.23-1.574 4.22-4.987 4.687-5.77 1.014-1.932-4.938 4.778-7.109 8.07-.491.992-1.171 1.6-1.289 1.365-.118-.235.256-1.3.82-3.041 2.678-7.801 7.303-15.846 13.164-22.144 2.171-2.361 2.24-2.333.43-1.832-4.27 1.217-8.127 4.51-12.305 9.278-1.013 1.575-1.93 2.416-3.086 3.743.4-1.951 4.16-9.87 7.344-14.307 1.954-2.649 3.828-4.442 3.75-5.03-.078-.588-2.108.044-5.039 2.223-4.414 3.22-6.922 6.621-10.703 12.787-1.737 3.507-1.484 2.521-2.07 3.157 1.954-9.876 3.345-14.532 6.601-20.973 2.967-5.798 5.873-9.72 11.445-15.516 3.908-4.008 4.696-5.147 3.32-4.718-4.269 1.289-8.804 4.147-12.929 8.226-2.388 2.434-3.36 3.165-3.36 2.807 0-.358 1.167-2.354 3.556-6.004 5.065-7.729 12.39-15.762 19.843-20.7 3.69-2.506 9.519-5.263 8.867-5.692a.685.685 0 0 0-.312-.078c.388-.633-1.658-.19-6.836 1.403-5.138 1.575-10.639 4.634-16.211 8.928-2.154 2.015-1.728.351 3.555-4.873 2.822-2.863 7.165-6.347 9.336-7.564 3.618-2.147 3.33-2.645 1.015-2.144-5.427 1.074-15.867 7.006-18.906 10.8-.017.02-.022.017-.039.038-.13.05-.245.067-.43.156-1.643 1.01-3.231 3.275-2.851 2.3.38-.975 1.207-1.799 3.125-4.912 5.862-9.447 13.64-16.353 23.554-22.221 2.443-1.477 2.54-2.2.82-2.028zm-54.648 38.087c.021-.017.055-.025.078-.038l-.078-.078v.116zm48.944-35.398a.312.312 0 0 1 .196.078c.145.215-.774 1.006-2.149 1.793-2.677 1.718-11.714 10.6-14.609 14.464-3.69 4.795-7.997 12.584-10.312 18.596-1.303 3.363-2.305 5.562-2.305 4.99-.072-1.575 1.977-12.14 2.773-14.932a10.75 10.75 0 0 0 .43-2.027c.363-.227.931-.858 1.875-2.339a59.077 59.077 0 0 1 3.672-4.951c1.62-2.003 6.658-7.274 6.523-7.407-.02-.02-.094.025-.156.039.495-.354 1.01-.732 1.758-1.287 4.749-3.489 11.002-7.058 12.304-7.017zm-23.788 3.86c.052-.004.099.02.117.078.144.429-.758 6.65-2.422 13.878-3.329 15.244-5.76 27.2-6.484 35.36-.507 5.01-.66 5.454-1.094 3.235-.362-1.36-.765-8.313-1.055-15.399-.506-14.027.054-18.124 3.672-25.925 2.035-4.495 6.478-11.174 7.266-11.227zm19.492 11.734c.217 0-1.725 1.933-4.258 4.366-10.349 9.59-17.885 22.5-22.227 38.245l-1.367 4.99.43-4.64c.217-2.576.743-6.604 1.25-8.966.651-2.863 2.186-7.585 3.75-11.812 1.564-4.228 3.038-7.824 6.21-10.994.69-.728 2.145-2.032 2.5-2.612.76-.537 1.897-1.365 3.946-2.963 2.895-2.29 8.68-5.614 9.766-5.614zm8.554 3.626c.34-.017.508.037.508.234 0 .143-1.897 1.46-4.14 2.962-5.5 3.579-15.696 14.112-19.532 19.766-3.473 5.153-8.733 15.273-10.976 21.714-2.026 5.94-1.898 2.747.273-5.77 1.954-7.514 6.815-18.705 10.469-24.131.678-.984 1.083-1.598 2.07-2.924.98-1.107 1.28-1.657 1.64-1.442.363.214 2.014-.791 3.75-2.222 3.8-3.194 13.566-8.069 15.938-8.187zm-48.476 5.34c.181-.062.425.25.86.858.506.716 1.894 4.005 3.124 7.368 3.33 9.304 7.743 34.195 6.368 35.555-.218.286-.43-.188-.43-.975 0-.787-1.6-6.47-3.555-12.553-5.644-17.32-7.598-25.888-6.875-28.966.217-.787.327-1.224.508-1.286zm37.265 15.36c.145 0-1.456 1.74-3.554 3.743-9.697 9.805-16.05 23.123-18.438 38.868-.579 3.937-1.396 7.44-1.757 7.797-.29.287-.844-1.296-1.133-3.586-.941-7.443 1.595-19.546 5.937-28.42.941-1.933 1.035-2.772 1.797-3.977.51-.432.989-1.439 1.875-2.612 3.237-3.555 8.558-8.873 12.031-10.448 1.665-.716 3.098-1.364 3.242-1.364zm-46.913 1.794l1.445 1.793c.796 1.002 2.822 3.72 4.414 6.082 3.04 4.437 11 20.125 11.797 23.274.29 1.002-.707-.568-2.227-3.43-1.52-2.863-4.855-7.943-7.46-11.306-5.862-7.73-7.97-11.478-7.97-14.269v-2.144zm-1.64 10.409c.223-.023.49 0 .78 0 2.099 0 6.528 3.91 10.508 9.278 4.56 6.155 9.85 19.108 12.383 30.058 1.23 5.582 3.32 19.897 3.32 23.118v2.3l-1.172-2.144c-.651-1.217-1.57-4.817-2.148-8.109-1.665-9.447-4.277-18.585-7.461-26.744-3.184-8.087-10.007-19.566-13.047-22.572-.456-.445-.82-.69-1.054-.78-.49-.804-1.539-1.64-2.032-2.066-1.583-1.44-1.646-2.18-.078-2.339zm-3.556 1.209l1.72 1.052c2.406 1.703 3.33 2.382 2.773 4.561-.307 2.137-.66 4.19-1.094 4.834-.507 1.002-1.1.263-1.68-2.027-.434-1.574-.921-4.15-1.21-5.653l-.509-2.767zm47.54 9.55c.206.02.17.268-.157.78-.666.551-2.296 2.682-3.164 3.899-4.632 6.227-11.354 23.417-12.656 33.293-.724 5.153-1.608 2.797-1.68-4.288-.145-10.234 4.426-21.686 11.445-28.771 2.877-2.952 5.59-4.968 6.211-4.912zm-48.282 4.484c.673.141 2.713 2.118 7.54 6.94 4.486 4.58 9.288 10.067 10.663 12.358 2.75 4.652 5.644 11.463 6.367 14.97.362 2.004-.367 1.21-4.492-4.444-2.75-3.722-6.606-8.71-8.632-11.072-7.816-9.018-10.7-13.457-11.641-17.894-.136-.582-.11-.922.195-.858zm53.515 1.91c.145 0-1.618 2.147-3.789 4.796-2.17 2.72-5.115 7.15-6.562 9.94-2.895 5.726-7.191 18.696-8.71 26.783-1.593 8.302-1.73 8.141-1.368-1.091.651-17.75 7.039-32.102 16.953-38.4 1.81-1.074 3.332-2.028 3.476-2.028zm-52.773 12.748l2.188 1.131c1.23.644 4.169 2.746 6.484 4.678 2.388 2.004 4.555 3.366 4.844 3.08.362-.286.451-.234.234.195-.217.358 1.608 3.452 4.141 6.744 4.849 6.298 10.196 16.222 12.656 23.235.796 2.362 1.356 4.373 1.211 4.445-.072.143-2.233-3.14-4.766-7.29-5.5-9.09-12.009-17.168-16.64-20.818-2.533-2.004-4.42-4.465-6.953-9.045l-3.399-6.355zm57.031 9.435c.05 0 .073.002.117 0-1.287 1.066-4.023 4.171-4.023 4.171-3.618 3.936-7.738 11.304-9.258 17.816-1.664 7.443-1.116 26.564 1.055 34.58.796 2.934 1.395 5.425 1.25 5.497-.507.5-4.79-11.437-5.586-15.516-1.23-6.227-1.158-20.83 0-25.77 1.375-5.582 4.482-12.093 7.305-15.242 2.46-2.791 6.97-5.536 9.14-5.536zm-55.39 2.456c1.092.05 2.367.622 4.375 1.91 7.743 4.867 17.5 17.744 28.789 37.855 9.046 16.246 14.256 28.494 6.875 16.256-10.493-17.32-27.567-40.43-34.297-47.444-.705-.734-1.058-1.012-1.133-.975l-.117-.195c-.94-1.145-3.736-3.423-5.039-4.21-2.894-1.79-2.968-2.508-.508-3.08a3.5 3.5 0 0 1 1.055-.117zm-2.734 3.275c.579 0 1.44.44 1.875 1.013.868 1.074.382 6.568-.703 7.212-.796.573-1.18-.26-1.758-4.483-.434-3.006-.283-3.742.586-3.742zm50.741 19.336s-.083 3.769-.156 8.42c-.651 19.897 6.245 36.643 19.922 48.81 8.177 7.229 17.424 11.179 32.187 13.684 4.921.859 9.421 1.578 10 1.793.579.215 7.387.922 6.953 1.637-.217.287.432.45 1.445.234 2.895-.5 11.87 1.45 14.258 1.52 3.69.072 27.772 5.072 33.36 7.057 1.953.787 6.21 5.71 6.21 7.212 0 .43-2.236.592-6.289.234-4.92-.358-7.466-.998-11.953-3.002-9.335-4.15-22.354-7.106-38.203-8.537-8.177-.716-34.672-5.359-42.343-6.862-9.48-1.932-16.277-4.237-24.96-8.46-9.264-4.508-14.485-8.01-20.274-13.45l-4.688-4.483 3.985 1.131c11.65 3.364 21.061 7.599 32.93 14.97 9.334 5.797 12.433 7.289 17.499 8.577 4.631 1.217 6.016 1.294 6.016.507 0-.287-2.385-1.286-5.352-2.144-20.19-6.227-35.39-27.06-35.39-48.459 0-3.578.353-7.879.86-9.668.723-2.791 3.694-10.72 3.983-10.72zm-46.952 2.3c.363.154.729.293 1.054.351 4.27.644 21.437 11.512 27.227 17.31 2.026 2.003 4.79 5.669 6.093 8.03l2.305 4.367-3.984-3.236c-2.244-1.79-6.307-4.585-8.984-6.16-2.823-1.646-8.813-6.952-14.024-11.89-3.682-3.434-7.625-7.14-9.687-8.772zm11.836 30.136c.303-.013.814.06 1.601.195 1.375.214 5.058 1.006 8.242 1.793 11.434 2.648 25.123 11.287 32.07 20.233l3.125 4.016-3.203-1.638c-1.737-.859-3.113-1.78-2.969-2.066.435-.716-6.795-6.735-10.703-8.81-1.953-1.074-7.456-3.28-12.304-5.069-8.829-3.149-14.044-5.754-15.781-7.758-.498-.626-.584-.875-.078-.896z' fill='%23cab313' fill-opacity='.502'/%3E %3Cpath d='M382.785 291.842c-1.583.548-4.01 2.864-5.592 4.038-3.166 2.349-3.591 3.201-.584 1.088 2.217-1.565 5.972-4.38 9.335-4.795.314-.038-1.335 1.61-2.206 2.55-1.187 1.33-.87 1.253 1.9-.548 1.82-1.174 3.324-2.27 3.324-2.426 0-.626-3.407-.925-6.177.093zM333.983 345.218c0 1.79 22.196 18.156 23.21 17.154.144-.143-2.75-2.147-6.514-4.437-3.69-2.219-8.472-6.08-10.933-8.227-2.388-2.147-5.408-5.617-5.763-4.49z' fill='%23cab313' fill-opacity='.502'/%3E %3C/g%3E %3Cg stroke='%23d4af37' stroke-width='.904'%3E %3Cpath d='M246.162 432.318c-5.483 1.69-12.845 1.998-16.376.691-1.277-.46-5.204-.206-6.18-.052 3.564 2.386 2.118 1.386 2.83 1.881 1.291.76.754.603 3.064 1.633-.395.45-.589.627-2.405 1.29 2.412.567 5.403.8 8.302.67a37.042 37.042 0 0 0 8.747-1.455c3.756-1.076 7.803-1.777 9.005-1.777 1.127 0 5.333 1.259 9.39 3.41 8.545 4.735 14.518 5.95 20.528 5.95 4.131 0 8.44-.922 13.329-4.113 3.613-2.36.568-2.302-3.027-.722-4.958 1.998-15.13 2.89-26.924-3.18-7.136-3.688-12.695-5.84-14.648-5.686-.376 0-2.93.691-5.635 1.46z' fill='%23fff' transform='matrix(.83739 0 0 .82218 198.784 50.956)'/%3E %3Cpath d='M219.856 429.486c1.465 1.23 1.25 1.471 3.79 3.53 3.558.349 10.643 1.11 13.273 1.11 2.328 0 6.826-.404 9.906-1.25 6.233-1.314 9.223-.93 20.567 4.056 13.146 6.763 20.53 5.524 27.29 2.22 9.43-3.586.254-2.04-3.165-3.031-1.127.384-2.568 1.84-5.253 2.817-3.754 1.367-5.765 1.324-10.272-.981-2.855-1.46-5.387-2.152-7.946-3.552-2.52-1.46-3.15-1.289-7.358-2.672l-6.196-1.22-9.38-.496c-8.113 1.69-16.09.4-21.5-1.29-5.408-1.69-6.385-1.393-3.756.759z' fill='%23d91023' transform='matrix(.83739 0 0 .82218 198.784 50.956)'/%3E %3Cpath d='M244.35 436.83c-6.46 1.921-14.34 2.016-17.27.94-1.532.62-.008-.018-3.84 1.365-5.033 1.69-5.108 1.768-2.93 2.382 1.278.385 6.311.692 11.27.615 8.563 0 9.314-.153 14.047-2.459 2.78-1.383 5.86-2.459 6.911-2.459.977 0 4.602 2.067 7.757 3.68 8.79 4.61 12.134 5.969 19.42 5.892 7.287-.077 16.694-5.291 17.862-7.074-5.596 3.396-10.23 5.156-17.312 4.87-7.082-.287-12.552-2.834-19.764-6.907-5.784-3.227-7.812-3.304-16.151-.845z' fill='%23d91023' transform='matrix(.83739 0 0 .82218 198.784 50.956)'/%3E %3Cg stroke-width='.807'%3E %3Cpath d='M293.47 417.689c1.216-1.4.855-1.915-2.49-2.381-8.288-1.323-18.856-6.3-23.113-10.888-2.129-2.334-3.117-2.567-3.117-.7 0 1.944 6.766 8.088 11.632 10.577 4.258 2.255 11.67 4.724 14.483 4.724.836 0 1.92-.477 2.604-1.332z' fill='%23fff' transform='matrix(-.29524 -.60606 -1.27207 .31586 1043.346 433.948)'/%3E %3Cpath d='M290.67 421.403c.238-.407-.408-2.4-3.112-2.97-6.682-1.384-14.159-5.289-18.931-9.845-3.58-3.5-5.332-3.843-4.139-.67 1.62 4.575 14.327 11.001 19.259 12.547 5.011 1.628 6.206 2.077 6.922.938z' fill='%23d91023' transform='matrix(-.29524 -.60606 -1.27207 .31586 1043.346 433.948)'/%3E %3Cpath d='M295.457 415.365l.827-1.39-4.033-2.547c-4.601-.588-12.942-3.604-18.55-6.766-2.517-1.398-5.249-2.575-6.112-2.575-1.51 0-1.61 0 .116 1.913 3.954 4.34 14.336 9.397 21.742 10.427 2.373.367 4.788 2.042 6.01.938z' fill='%23ed1c24' transform='matrix(-.29524 -.60606 -1.27207 .31586 1043.346 433.948)'/%3E %3Cpath d='M293.47 417.689c1.216-1.4.855-1.915-2.49-2.381-8.288-1.323-18.856-6.3-23.113-10.888-2.129-2.334-3.117-2.567-3.117-.7 0 1.944 6.766 8.088 11.632 10.577 4.258 2.255 11.67 4.724 14.483 4.724.836 0 1.92-.477 2.604-1.332z' fill='%23fff' transform='matrix(.33397 -.58616 1.24895 .39558 -143.25 396.105)'/%3E %3Cpath d='M288.923 420.615c.146-.251 1.314-1.57-1.365-2.182-6.682-1.384-14.159-5.289-18.931-9.845-4.24-4.604-6.35-5.55-4.139-.67 1.62 4.575 14.327 11.001 19.259 12.547 5.011 1.628 4.46 1.289 5.176.15z' fill='%23d91023' transform='matrix(.33397 -.58616 1.24895 .39558 -143.25 396.105)'/%3E %3Cpath d='M295.457 415.365l.827-1.39-4.033-2.547c-4.601-.588-12.942-3.604-18.55-6.766-2.517-1.398-5.249-2.575-6.112-2.575-1.51 0-1.61 0 .116 1.913 3.954 4.34 14.336 9.397 21.742 10.427 2.373.367 4.788 2.042 6.01.938z' fill='%23ed1c24' transform='matrix(.33397 -.58616 1.24895 .39558 -143.25 396.105)'/%3E %3C/g%3E %3Cpath d='M319.677 402.697c-6.356 1.817-11.424 5.84-16.665 13.131-2.07 2.879-4.032 4.339-2.635 5.038 1.538.77 2.898-1.393 5.658-4.15 6.96-6.955 12.479-9.89 19.997-9.972h5.969l-1.783-2.478c-2.17-2.973-4.573-3.303-10.541-1.569zM269.234 405.082c-1.273 1.465-.895 2.003 2.604 2.491 8.67 1.384 19.727 6.591 24.181 11.392 2.227 2.44 3.261 2.685 3.261.732 0-2.034-7.079-8.462-12.17-11.066-4.454-2.36-12.208-4.942-15.152-4.942-.874 0-2.008.498-2.724 1.393z' fill='%23fff' transform='matrix(.83696 .02647 -.0267 .82176 210.874 47.246)'/%3E %3Cpath d='M318.582 399.536c-1.706.578-4.108 1.651-5.426 2.312-3.566 1.982-9.02 8.373-9.834 9.58-.87 1.29-2.14 2.793-3.002 4.19-1.274 2.068-1.482 3.204-.845 3.33.637.126 2.12-.758 3.527-2.73 6.022-8.443 11.55-12.223 19.765-13.874 4.263-.826 4.883-.826 6.356.66 1.162 1.074-.337-.236-.57-.979-.542-1.817-1.91-2.737-4.546-3.233-1.24-.165-3.72.083-5.425.744z' fill='%23d91023' transform='matrix(.83696 .02647 -.0267 .82176 210.874 47.246)'/%3E %3Cpath d='M271.987 403.32c-.238.406 1.83 1.139 4.534 1.708 6.682 1.383 14.159 5.289 18.931 9.845 3.58 3.499 5.332 3.843 4.139.67-1.62-4.575-14.327-11.002-19.259-12.548-5.011-1.627-7.629-.815-8.345.324zM320.52 407.381c-4.884 1.734-9.767 4.79-13.642 8.506-3.953 3.882-5.738 6.35-4.188 6.35.31 0 2.715-1.89 4.343-3.294 7.053-6.029 19.763-9.425 25.421-7.36 2.713.99 1.436-2.011-.424-4.736-1.162-1.735-8.023-.705-11.51.534zM267.423 407.115l-3.307 3.14 4.928.794c5.091.651 14.318 3.987 20.522 7.486 2.784 1.546 5.807 2.847 6.761 2.847 1.67 0 1.782 0-.127-2.115-4.375-4.8-15.86-10.396-24.053-11.535-2.625-.407-3.372-1.837-4.724-.617z' fill='%23d91023' transform='matrix(.83696 .02647 -.0267 .82176 210.874 47.246)'/%3E %3Cg%3E %3Cpath d='M304.493 422.389c-1.651 5.417-1.432 10.396-.97 14.138 1.605-.193 2.662-.24 5.27-.725.273-2.198.686-4.745.573-7.435.338-3.7-.019-1.771 2.183-4.736-2.375-1.526-3.013-1.66-7.056-1.242z' fill='%23d91023' transform='matrix(.83739 0 0 .82218 197.926 53.423)'/%3E %3Cpath d='M296.203 428.628c-.084 4.215.317 5.13.27 7.137 2.355.385 7.422 1.07 7.121.225.02.922-.076-4.911-.002-7.985l.854-5.533-3.587-.549-3.23.405-1.426 6.3z' fill='%23fff' transform='matrix(.83739 0 0 .82218 197.926 53.423)'/%3E %3Cpath d='M291.002 428.828c.15 3.343-.53 4.487-.13 6.445 1.05.318 5.047.184 6.286.568-.176-4.355-.176-.547-.598-6.234l1.266-7.28-3.595.287s-2.221-.69-3.732-.72c1.303 2.274.503 6.934.503 6.934z' fill='%23d91023' transform='matrix(.83739 0 0 .82218 197.926 53.423)'/%3E %3C/g%3E %3C/g%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 600 400'%3E %3CclipPath id='c'%3E %3Cellipse cx='300' cy='201' rx='85.849' ry='88.189'/%3E %3C/clipPath%3E %3Crect width='600' height='400' fill='%23ce1126'/%3E %3Crect width='600' height='200' y='100' fill='%23fff'/%3E %3Cg clip-path='url(%23c)'%3E %3Cg fill='%23ff9c10'%3E %3Cpath d='m277.29,191.02-14.575-0.41947,0-5.7622,14.575,6.1816z'/%3E %3Cpath d='m277.23,189.34-14.515-7.3829v-9.6023s-1.7009,0.23946-1.4578-1.681c0.0802-4.0011,10.667,7.3028,16.093,10.984l-0.12114,7.6826z'/%3E %3Cpath d='m214.37,214.37,30.606,0.24025,0-18.966l-34.98-1.67,4.3734,20.405z'/%3E %3Cpath d='m212.91,188.2,32.551,3.1209-0.2423-13.444-31.822-12.484-0.48701,22.807z'/%3E %3Cpath d='m219.47,161.32,25.021,12.003,3.5727-3.6863s-2.301-1.5668-2.1871-3.0084c0.0433-1.4582,2.3147-1.6794,2.358-3.2621,0.0417-1.4582-2.573-1.6334-2.6011-3.0924-0.17088-1.5811,2.0154-3.2764,2.0154-3.2764l-22.591-19.446-5.5881,23.768z'/%3E %3Cpath d='m383.68,214.61-32.307,0-0.2423-18.485,35.464-2.6412-2.9148,21.127z'/%3E %3Cpath d='m384.47,187.91c-0.40794-3.001-0.83573-5.9945-1.5312-8.9375-0.93116-3.9401-2.1206-7.8167-3.5625-11.594-0.10645-0.27883-0.26579-0.53476-0.375-0.8125l-27.625,11.562,0.25,13.688,32.844-3.9062z'/%3E %3Cpath d='m365.59,143.47c-5.5104,4.1667-11.021,8.3333-16.531,12.5,0.0273,1.1959,1.2194,2.1156,1.5482,3.2604,0.76317,1.6063-0.75368,3.0262-1.6924,4.1613-0.76068,1.047,0.87892,1.5806,1.4239,2.1993,1.1999,1.2319,0.15476,3.1621-1.1234,3.8787,1.5397,0.9212,2.3175,2.6452,2.6562,4.3438,8.25-4.2917,16.5-8.5833,24.75-12.875-2.9604-6.2356-6.6513-12.132-11.031-17.468z'/%3E %3Cpath d='m319.56,191.44,13.845-0.59944,0.2423-5.5235-14.088,6.1229z'/%3E %3Cpath d='m319.55,188.44-0.0594-6.2411s13.115-11.703,15.909-13.864c0,2.401-1.5172,4.2604-1.5172,4.2604v9.1234l-14.332,6.7216z'/%3E %3Cpath d='m234.54,135.87c0.24229,0.24026,14.718,16.14,14.718,16.14,0.40598-1.5066,3.7436-1.7357,7.1437-1.4954,3.4018,0.23946,6.1128-0.22519,6.1128,2.1758,0,2.4002-1.7258,2.0592-1.7258,3.7402s2.5858,1.5399,2.5858,3.6982c0,2.1607-1.875,1.7198-1.8846,3.3929-0.006,1.3829,1.956,1.4566,1.956,1.4566l13.785,13.205,0.0602-14.105-28.42-44.052-14.331,15.845z'/%3E %3Cpath d='m257.28,119.19c0.21581,0.64069,19.25,38.906,19.25,38.906s0.21583-35.913,3.4604-37.837l-5.4068-9.8338-17.303,8.765z'/%3E %3Cpath d='m319.41,115.06c-2.3958,8.2812-4.7917,16.562-7.1875,24.844,2.2408,0.26667,4.5038,0.33859,6.7557,0.21383,2.0248,0.17376,0.4475,2.0722,0.55535,3.1952-0.01,5.0928-0.0199,10.186-0.0298,15.278,6.7708-11.958,13.542-23.917,20.312-35.875-4.6702-2.4376-9.627-4.2482-14.616-5.9053-1.9021-0.67149-3.8355-1.2533-5.7902-1.7509z'/%3E %3Cpath d='m344.69,125.44c-8.375,12.875-16.75,25.75-25.125,38.625-0.0104,4.9583-0.0208,9.9167-0.0312,14.875,5.5944-5.3224,11.217-10.617,16.794-15.957,1.0585-1.4987-3.3598-2.2326-1.1513-4.0588,2.0005-0.63097,2.3398-3.8629,0.233-4.4839-1.7358-2.5486,1.5703-3.8992,3.6531-3.6202,2.9008,0.13241,5.8889-0.63149,8.725,0.17415,1.5616,1.4931,3-2.2551,4.532-3.0989,3.0298-3.0477,6.0632-6.0921,9.0586-9.1737-4.937-5.1457-10.573-9.615-16.688-13.282z'/%3E %3C/g%3E %3Cg fill='%23083d9c' stroke='%23083d9c' stroke-width='1.932'%3E %3Cpath stroke-width='2.057' d='m279.88,275.41c-6.1779,0.34881-12.334,4.5177-15.219,6.75,5.1802,2.2672,10.71,4.037,16.594,5.25,9.3748,1.574,18.75,1.5625,28.125,1.5625,1.5304-0.1927,3.0449-0.41052,4.5312-0.65625l19.75-6.6562s-9.5008-6.2714-17.031-6c-7.5312,0.27137-12.615,7.6383-18.688,7.0938-6.0727-0.54364-8.5049-7.3438-17.25-7.3438-0.27329,0-0.53902-0.0154-0.8125,0z'/%3E %3Cpath d='m244.01,270.31,112.23,0.4805s-9.7159-10.323-21.134-10.563c-11.417-0.24185-8.2581,4.8012-17.003,5.5203-8.7444,0.72076-10.932-5.2809-18.948-5.0414-8.015,0.23947-12.632,5.0414-18.703,5.2824-6.0726,0.23947-13.846-6.0032-18.462-5.7614-4.6157,0.23946-21.134,7.2013-21.134,7.2013l3.1579,2.8807z'/%3E %3Cpath d='m229.68,257.1,138.46,0.4813c2.1855-3.1209-6.802-10.563-15.06-11.284-6.8036,0.23946-11.66,6.9619-17.247,7.2029-5.5873,0.23947-11.902-6.9634-18.219-6.7216-6.315,0.23946-12.874,6.7216-19.19,6.7216-6.315,0-10.931-6.9634-18.946-6.9634-8.0158,0-11.66,7.6826-17.733,7.2029-6.0743-0.4805-11.418-7.6818-17.247-7.6818-5.8296,0-15.546,8.6421-17.489,8.1616-1.9432-0.47972,2.4278,3.6014,2.6725,2.8807z'/%3E %3Cpath d='m283.21,243.86,30.908-0.0182c0.2407-0.24025-6.9199-10.55-15.449-9.8227-9.5017,0.24581-15.956,9.841-15.459,9.841z'/%3E %3Cpath d='m381.77,243.12-42.294,0s5.4741-3.1971,6.9664-6.1475c2.7359,1.4756,1.9897,2.9505,7.4639,3.1963,5.4725,0.24582,10.697-6.1459,15.923-5.9001,5.2238,0.2458,11.941,9.0972,11.941,8.8514z'/%3E %3Cpath d='m215.1,243.12,42.294,0s-5.4741-3.1971-6.9664-6.1475c-2.7359,1.4756-1.9897,2.9505-7.4638,3.1963-5.4717,0.24582-10.697-6.1459-15.923-5.9001-5.2238,0.2458-11.941,9.0972-11.941,8.8514z'/%3E %3Cpath d='m218.26,229.98,30.121,0.23947s-1.9432-4.0804-2.1855-9.1218c-7.7752-2.6396-14.09,5.7614-19.677,6.0016-5.5856,0.23946-11.415-6.0016-11.415-6.0016l3.1571,8.8823z'/%3E %3Cpath d='m379.07,229.98-30.122,0.23947s1.944-4.0804,2.1863-9.1218c7.7744-2.6396,14.089,5.7614,19.677,6.0016,5.5865,0.23946,11.416-6.0016,11.416-6.0016l-3.1571,8.8823z'/%3E %3Cpath d='m290.89,230.22,15.302-0.47893s0.24389-4.5617-7.7728-4.5617c-8.0158,0-7.2866,5.2817-7.5296,5.0406z'/%3E %3C/g%3E %3Cg fill='%23ce1126' stroke='%23630810' stroke-width='1.9319' stroke-linejoin='round'%3E %3Cpath d='m282.87,181,31.823,8.4034,0-44.895c-14.576,0.72077-26.72-27.368-0.97161-29.288-25.263-3.6015-28.179,2.8807-31.093,9.8426l0.2423,55.937z'/%3E %3Cpath d='m289.94,221.58c-6.9215,11.33-25.425,7.9697-29.752,0.0603-1.2965-0.36317-0.52953-48.8-0.52953-48.8s-2.0675-0.93089-2.163-2.42c-0.0947-1.5042,2.8113-1.6406,2.8113-3.5658,0-1.9236-2.9677-1.1696-3.0271-3.1059,0.0128-1.8515,3.1683-1.5962,3.0271-3.3073-0.16688-1.9284-3.5342-1.6429-3.677-3.4207-0.1091-1.4122,2.4085-2.6436,3.1082-3.2787-0.45251,0.0222-2.3387-0.0278-2.3508-0.0341-1.7667,0.0357-3.5342,0.0714-5.3,0.10704-3.7652,0.004,0.065,0.81116,0.01,2.9584-0.0345,1.4027-1.9095,2.336-2.0772,3.5555-0.0594,1.252,2.6829,2.1314,2.7174,3.634,0.0313,1.3408-2.6941,1.432-2.5963,2.6777,0.16929,2.1084,2.4141,2.5722,2.3804,3.8488-0.0345,1.275-3.0207,1.7611-3.0287,2.7784,0.10429,1.968,0.43244,49.807,0.43244,49.807,4.7585,24.37,32.228,30.569,40.015-1.4955z'/%3E %3Cpath d='m308.05,221.58c6.9215,11.33,25.424,7.9697,29.751,0.0603,1.2965-0.36317,0.53034-48.8,0.53034-48.8s2.0675-0.93089,2.1622-2.42c0.0947-1.5042-2.6292-1.6406-2.6292-3.5658,0-1.9236,2.7864-1.1696,2.845-3.1059-0.012-1.8515-2.9252-1.7159-2.784-3.4278,0.16608-1.9276,2.4534-1.7024,2.5834-3.4801,0.10911-1.5311-1.4361-2.4636-2.1357-3.0987,0.45249,0.0222,2.2168-0.0278,2.2296-0.0341,1.7659,0.0357,3.5334,0.0714,5.2992,0.10704,3.766,0.004-0.065,0.81116-0.009,2.9584,0.0337,1.4027,1.9087,2.336,2.0772,3.5555,0.0586,1.252-2.6837,2.1314-2.7182,3.634-0.0305,1.3408,2.695,1.432,2.5963,2.6777-0.16928,2.1084-2.4141,2.5722-2.3796,3.8488,0.0337,1.275,3.0207,1.7611,3.0279,2.7784-0.10349,1.968-0.43164,49.807-0.43164,49.807-4.7593,24.37-32.228,30.569-40.015-1.4955z'/%3E %3C/g%3E %3Cg fill='%23630810' stroke='%23630810' stroke-width='2.7916' stroke-linecap='round'%3E %3Cpath d='m281.66,223.73c2.6725-1.4415,5.1011-2.8807,6.802-6.2427l-10.446,0.23947s-4.8564,2.8823-7.2866,6.0032h10.931z'/%3E %3Cpath d='m315.42,223.73c-2.6725-1.4415-5.1003-2.8807-6.8012-6.2427l10.445,0.23947s4.8572,2.8823,7.2866,6.0032h-10.931z'/%3E %3Cpath d='m262.71,213.65 71.903,0.23946'/%3E %3Cg id='x'%3E %3Cpath d='m266.11,196.61 8.5023,11.284'/%3E %3Cpath d='m266.11,207.89 9.2315,-11.043'/%3E %3Cpath d='m270.97,195.88 -0.24252,6.9617'/%3E %3C/g%3E %3Cuse xlink:href='%23x' x='13.603532'/%3E %3Cuse xlink:href='%23x' x='27.449532'/%3E %3Cuse xlink:href='%23x' x='41.781532'/%3E %3Cuse xlink:href='%23x' x='55.627532'/%3E %3C/g%3E %3C/g%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 768 576'%3E %3Ctitle%3EFlag of Papua New Guinea%3C/title%3E %3Crect width='768' height='576' fill='%23000'/%3E %3Cpath d='M0,0H768V576z' fill='%23ce1126'/%3E %3Cpath d='M475.48467,167.35351C469.81245,174.67996 456.38967,159.98385 440.30967,159.64818C424.22967,159.31251 412.839,175.05784 408.14967,180.41851C403.46034,185.77918 388.38534,213.91818 388.72,216.93318C389.05467,219.94818 398.10067,208.55851 401.45034,206.54851C401.785,210.56851 397.765,215.25885 398.77,216.59851C399.775,217.93818 410.49433,208.55851 414.17967,208.22385C415.18467,210.90418 412.16967,213.58351 413.17467,217.60351C414.51534,218.94318 420.54534,210.90318 424.56534,209.22885C425.23467,212.24385 420.88,217.93918 423.22467,221.62351C424.9,221.95818 434.949,210.23385 438.29967,208.89318C441.65034,207.55251 436.62433,219.94818 438.29967,220.95318C441.31467,218.94318 450.69534,208.22284 453.71034,206.88318C456.72534,205.54351 453.37567,220.61851 454.71534,220.61851C458.39967,217.93818 467.78034,205.20885 468.78534,203.19885C469.79034,201.18885 467.78034,222.62851 478.165,234.01918C488.54967,245.40985 504.29601,258.47385 505.97034,258.47385C507.98034,254.78851 505.30101,247.08418 506.97534,247.41885C511.66467,252.44385 520.375,259.81351 522.385,259.81351C524.395,259.81351 521.04433,251.77351 523.72467,251.77351C529.08534,256.79851 544.495,276.56385 574.645,285.60885C572.635,279.91351 568.27933,274.88851 567.94467,272.20918C569.95467,272.54385 576.99067,275.89452 578.33034,275.55885C579.67,275.22318 563.59,255.45885 564.595,252.77851C568.28034,252.44385 569.95567,254.78851 571.29534,253.11318C569.62,250.43385 555.55,234.68851 555.55,231.00318C555.55,227.31784 559.90567,231.67351 561.24534,231.00318C562.585,230.33284 555.88567,216.26284 557.22534,214.58851C558.565,212.91418 573.30433,223.63351 576.98967,223.63351C580.675,223.63351 577.99467,210.56851 579.67,209.89818C581.34534,209.22784 593.74101,216.93318 596.42034,216.93318C599.09967,216.93318 598.765,211.23784 599.77,211.90818C600.775,212.57851 629.92,241.72351 619.87,275.89351C609.82,300.34918 589.72101,313.41418 560.24034,302.69385C561.91467,305.37418 577.66,318.43918 594.745,313.74885C611.83,309.05851 632.59933,295.65885 630.25467,262.15918C627.91,228.65952 616.854,223.96918 615.17967,218.94418C613.50534,213.91918 617.86101,220.28385 621.54534,221.62452C625.22967,222.96519 620.875,214.58851 619.87,210.90318C618.865,207.21784 630.925,218.60851 633.94,219.61351C636.955,220.61851 626.905,192.14385 623.89,190.13385C620.875,188.12385 626.905,190.80318 628.915,191.47351C630.925,192.14385 610.48933,160.31851 606.13467,160.31851C601.78,160.31851 609.819,158.64318 612.16467,158.64318C614.51034,158.64318 588.71601,137.87284 584.36034,137.87284C580.00467,137.87284 593.739,132.51217 595.07967,132.17751C597.42534,132.51217 565.26534,115.09251 536.455,132.51217C534.77967,131.17351 550.02351,120.62101 550.525,116.09851C550.69284,114.92568 545.50101,112.41318 545.16534,111.07351C544.82967,109.73385 553.20534,105.71386 553.54,102.69886C551.53,100.01853 547.84467,101.02352 545.83467,100.3542C545.33317,97.841696 552.87067,91.643861 552.20034,88.964531C551.69784,87.457031 546.16933,86.954531 544.82967,87.959531C543.49,88.964531 548.34817,80.924531 547.51,78.579866C546.84067,77.574866 544.16034,78.245201 541.48,78.914531C539.80467,78.579866 550.19034,64.174196 548.18034,62.164196C546.17034,60.154196 518.02933,76.903526 507.64467,95.663861C497.26,114.42418 505.30101,129.49918 503.96034,135.86385C502.61967,142.22851 500.94433,148.59418 496.58967,148.59418C492.235,148.59418 482.18601,141.89385 478.83534,138.54418C475.48467,135.19452 474.81534,132.84885 470.125,131.50918C465.43467,130.16952 454.71534,134.18952 450.69534,134.52418C446.67534,134.85885 430.93,131.50918 429.925,132.51418C428.92,133.51918 445.33467,139.54918 449.02,141.55918C452.70534,143.56918 453.04101,146.24952 455.72034,147.92385C458.39967,149.59818 483.52467,156.96885 475.48467,167.35351zM573.64,214.58851C581.68,222.62851 635.95,258.80851 635.95,303.02851C635.95,347.24851 596.41933,345.90985 585.02967,344.56918C597.76,355.28851 646,353.27851 646,303.02851C646,258.80851 583.69,214.58851 575.65,210.56851C567.61,206.54851 565.6,206.54851 573.64,214.58851z' fill='%23fcd116'/%3E %3Cg fill='%23fff'%3E %3Cpath d='M220.254,418.599,231.709,381.748,243.164,419,213,396.168h37.418z'/%3E %3Cpath id='sl' d='m192.418,178.496 -22.909,73.702 60.327,-44.862h-74.836l60.327,45.664z'/%3E %3Cuse xlink:href='%23sl' x='-88' y='112.504'/%3E %3Cuse xlink:href='%23sl' x='87.582' y='104.504'/%3E %3Cuse xlink:href='%23sl' y='264.504'/%3E %3C/g%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 180 90'%3E %3Ctitle%3EFlag of the Philippines%3C/title%3E %3Cdesc%3ECoding according to the official 'description and specification of the FILIPINO flag' in Executive Order No. 23 from 1936%3C/desc%3E %3Crect width='180' height='90' fill='%230038a8'/%3E %3Crect y='45' width='180' height='45' fill='%23ce1126'/%3E %3Cpath d='M 77.942286,45 0,90 0,0' fill='%23fff'/%3E %3Cg transform='translate(28,45)' fill='%23fcd116'%3E %3Ccircle r='9'/%3E %3Cg id='j'%3E %3Cg id='i'%3E %3Cg id='h'%3E %3Cpath d='M -1,0 L -0.93848823,0.06151177 L 0,0 L -0.93848823,-0.06151177 z' transform='scale(19)'/%3E %3Cpath id='g' d='M -0.88366349,0.11633651 L -0.83408932,0.16591068 L 0,0 z' transform='scale(19.238092)'/%3E %3Cuse xlink:href='%23g' transform='scale(1,-1)'/%3E %3C/g%3E %3Cuse xlink:href='%23h' transform='rotate(45)'/%3E %3C/g%3E %3Cuse xlink:href='%23i' transform='rotate(90)'/%3E %3C/g%3E %3Cuse xlink:href='%23j' transform='rotate(180)'/%3E %3Cg transform='translate(-2.019238)'%3E %3Cg id='s' transform='translate(37.961524,0)'%3E %3Cpath id='t' d='M 5,0 L 1.618034,1.175571 1.545085,4.755283 -0.618034,1.902113 -4.045085,2.938926 -2,0 z'/%3E %3Cuse xlink:href='%23t' transform='scale(1,-1)'/%3E %3C/g%3E %3Cuse xlink:href='%23s' transform='rotate(120)'/%3E %3Cuse xlink:href='%23s' transform='rotate(-120)'/%3E %3C/g%3E %3C/g%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='-75 -40 120 80'%3E %3Ctitle%3EFlag of Pakistan%3C/title%3E %3Crect x='-75' y='-40' width='120' height='80' fill='%23fff'/%3E %3Crect x='-45' y='-40' width='90' height='80' fill='%2301411C'/%3E %3Ccircle r='24' fill='%23fff'/%3E %3Ccircle r='22' cx='-7' cy='-40' fill='%2301411C' transform='rotate(-41.63354, 45, -40)'/%3E %3Cpolygon points='0,-513674 301930,415571 -488533,-158734 488533,-158734 -301930,415571' fill='%23fff' transform='rotate(-41.63354) translate(16) rotate(18) scale(0.00001557408)'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' id='Flag of Poland' viewBox='0 0 16 10'%3E %3Crect width='16' height='10' fill='%23fff'/%3E %3Crect width='16' height='5' fill='%23dc143c' y='5'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 900 600'%3E %3Crect width='900' height='600' fill='%23ED2939'/%3E %3Crect width='600' height='600' fill='%23fff'/%3E %3Crect width='300' height='600' fill='%23002395'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 15'%3E %3CclipPath id='cp'%3E %3Cpath d='M0,0V75H350V150H300zM300,0H150V200H0V150z'/%3E %3C/clipPath%3E %3Crect fill='%2300247D' width='30' height='15'/%3E %3Cg transform='scale(0.05)'%3E %3Cpath d='M0,0L300,150M300,0L0,150' stroke='%23fff' stroke-width='30'/%3E %3Cpath d='M0,0L300,150M300,0L0,150' stroke='%23cf142b' stroke-width='20' clip-path='url(%23cp)'/%3E %3Cpath d='M150,0V200M0,75H350' stroke='%23fff' stroke-width='50'/%3E %3Cpath d='M150,0V200M0,75H350' stroke='%23cf142b' stroke-width='30'/%3E %3Cpath d='M300,0V150H0V300H600V0z' fill='%2300247d'/%3E %3C/g%3E %3Cg fill='%23F7E017' stroke='%23000000' stroke-width='0.015'%3E %3Cpath d='M20.018 7.954c-0.32 0.271-0.625 0.667-0.7 1.025 -0.211 1.007-0.491 1.231-0.923 1.015 0 0.541 0.474 0.582 0.682 0.266 0 0.507 0.184 0.947 0.599 1.322 0.175 0.158 0.208 0.05 0.125-0.125 -0.083-0.175-0.083-0.74-0.249-1.064 0.266 0.191 0.657 0.083 0.624-0.441 -0.341 0.2-0.68 0.192-0.715-0.283C19.418 9.112 19.635 8.303 20.018 7.954z'/%3E %3Cpath d='M19.613 3.949c0.023-0.2-0.02-0.405-0.166-0.534 -0.282-0.248-0.558-0.166-0.764 0.034 -0.308-0.166-0.471 0.423-0.82 0.324 0.058 0.191 0.15 0.274 0.324 0.208 -0.183 0.166 0 0.366-0.216 0.565 0.391 0.125 0.599-0.091 0.582-0.466 0.15 0.133 0.382 0.125 0.507-0.025 -0.208-0.067-0.209-0.247-0.125-0.416C19.06 3.39 19.646 3.4 19.613 3.949z'/%3E %3Cpath fill='%23337321' d='M20.515 6.842c-0.441 0.233-1.247 0.133-1.322-0.441 -0.075-0.574 0.482-0.832 0.632-0.906 0.233-0.117 0.416 0.091 0.341 0.333 0.258-0.091 0.316-0.391 0.191-0.565 0.341 0.025 0.657-0.233 0.79-0.599 -0.12 0.114-0.446 0.037-0.714 0.02 0.083-0.091 0.082-0.269 0.057-0.361C20.208 4.613 19.8 4.48 19.26 5.32c0.083-0.291 0.241-0.873 0.333-1.256 0.009-0.038 0.016-0.076 0.021-0.115C19.646 3.4 19.061 3.39 18.936 3.64c0.137 0.154 0.065 0.334 0.016 0.607 -0.058 0.324-0.183 1.073-0.291 1.322 -0.033-0.391-0.291-0.416-0.341-0.607 -0.075 0.05-0.116 0.183-0.1 0.274 -0.092-0.1-0.408 0.025-0.524-0.125 -0.125 0.249 0.075 0.499 0.283 0.607 -0.121 0.008-0.15 0.154-0.283 0.154 0.179 0.208 0.362 0.291 0.574 0.308 0.212 0.017 0.37 0.096 0.499 0.353C18.977 6.95 19.769 7.22 20.515 6.842z'/%3E %3Cpath d='M21.613 6.334c-0.249 0.69-0.931 1.181-1.239 1.256 -0.524 0.127-1.592 0.646-1.878 0.913 -0.045-0.01-0.087-0.026-0.118-0.048 -0.141-0.1-0.258-0.424-0.008-0.699 0.782-0.732 1.622-0.416 2.146-0.915 -0.441 0.233-1.247 0.133-1.322-0.441 0.474 0.125 1.331 0.133 2.012-0.599C21.297 5.902 21.563 6.218 21.613 6.334z'/%3E %3Cpath fill='%23337321' d='M20.018 7.954c-0.395 0.335-0.6 1.158-0.558 1.715 0.012 0.155 0.055 0.26 0.121 0.324 0.029-0.316 0.249-1.133 0.81-1.497 0.474-0.308 1.214-0.998 1.489-1.788 -0.05-0.141-0.133-0.241-0.291-0.341C21.316 7.113 20.587 7.471 20.018 7.954z'/%3E %3Cpath fill='%23316D3A' d='M21.359 6.014c-0.141 0.212-0.462 0.503-0.769 0.62 0.066-0.075 0.087-0.17 0.091-0.249 -0.391 0.15-1.173 0.133-1.489 0.017 0.474 0.125 1.331 0.133 2.012-0.599C21.272 5.877 21.33 5.943 21.359 6.014z'/%3E %3Cpath fill='%23337321' d='M18.37 7.756c-0.636 0.595-0.216 1.114 0.033 1.231 -0.066 0.416 0.324 0.366 0.316 0.715 0.158-0.091 0.2-0.333 0.175-0.524 0.2 0.216 0.707-0.025 0.815 0.374 0.067-0.441-0.274-0.881-0.698-0.84 0.175-0.158 0.075-0.416-0.091-0.482 -0.033 0.324-0.399 0.324-0.541 0.225C18.237 8.355 18.12 8.031 18.37 7.756z'/%3E %3Cpath d='M19.746 11.54c-0.069 0.04-0.064 0.129-0.021 0.187 0.087 0.116-0.062 0.38 0.22 0.437 0.083 0.017 0.147-0.034 0.179-0.129 0.087-0.262-0.191-0.291-0.216-0.416C19.883 11.494 19.804 11.507 19.746 11.54z'/%3E %3Cpath d='M19.983 12.031c-0.093 0.043-0.175 0.104-0.137 0.403 0.015 0.124 0.008 0.424-0.1 0.428 0.066 0.033 0.208 0.069 0.266-0.008 0.056 0.094 0.183 0.067 0.233-0.05 0.066 0.054 0.158-0.037 0.158-0.116 0.058 0.037 0.175-0.017 0.145-0.195 0.071 0.025 0.162-0.025 0.195-0.071 -0.104-0.021-0.366-0.162-0.428-0.274C20.253 12.035 20.091 11.981 19.983 12.031z'/%3E %3Cg fill='none'%3E %3Cpath d='M18.542 3.62c0.042-0.062 0.089-0.12 0.141-0.171'/%3E %3Cpath d='M20.124 4.721c0.073-0.042 0.185-0.047 0.309-0.039'/%3E %3Cpath d='M20.012 12.854c-0.029-0.042-0.04-0.216-0.019-0.322'/%3E %3Cpath d='M20.245 12.804c-0.046-0.035-0.133-0.156-0.148-0.262'/%3E %3Cpath d='M20.403 12.688c-0.058-0.027-0.2-0.21-0.231-0.328'/%3E %3Cpath d='M20.548 12.492c-0.069-0.015-0.279-0.152-0.366-0.297'/%3E %3C/g%3E %3Cpath d='M24.382 7.765c1.023 0.857 1.089 1.538 0.931 1.938 -0.083-0.374-0.507-0.956-0.948-1.106L24.382 7.765z'/%3E %3Cpath fill='%23337321' d='M22.553 7.282h1.896c0 0 0 0.499 0 2.245 0 1.913-1.064 3.044-2.146 3.642 -1.081-0.599-2.146-1.73-2.146-3.642 0-1.746 0-2.245 0-2.245h1.331c0.002 0.116 0.013 0.291 0.15 0.466C21.952 7.717 22.307 7.482 22.553 7.282z'/%3E %3Cpath fill='%23006EC7' d='M24.449 7.282c0 0 0 0.499 0 2.245 0 0.577-0.097 1.084-0.262 1.525l-1.883-3.455 -1.883 3.455c-0.165-0.442-0.262-0.948-0.262-1.525 0-1.746 0-2.245 0-2.245H24.449z'/%3E %3Cpath stroke='none' d='M24.244 10.887c-0.033 0.102-0.094 0.267-0.14 0.369l-1.8-3.346 -1.8 3.346c-0.047-0.102-0.107-0.267-0.14-0.369l1.941-3.598L24.244 10.887z'/%3E %3Cpath d='M23.159 12.118c0.05 0.025 0.142 0.071 0.183 0.088 0.1-0.2 0.116-0.482 0.083-0.732 -0.108 0.275-0.474 0.266-0.574 0.432 0.061 0.031 0.118 0.071 0.167 0.106 -0.125 0.125-0.417 0.334-0.583 0.384v-1.784c0-0.125-0.042-0.229-0.042-0.333 0 0 0-0.286 0-0.369 0-0.083-0.017-0.204-0.091-0.204 -0.075 0-0.091 0.121-0.091 0.204 0 0.083 0 0.369 0 0.369 0 0.104-0.042 0.225-0.042 0.333v1.784c-0.091-0.266-0.45-0.175-0.616-0.441 0.065-0.016 0.134-0.021 0.2-0.008 -0.125-0.424-0.466-0.457-0.532-0.582 0 0.175-0.075 0.582 0.042 0.757 0.026-0.031 0.065-0.064 0.113-0.092 0.141 0.308 0.777 0.309 0.927 0.816C22.423 12.659 22.856 12.443 23.159 12.118z'/%3E %3Cpath d='M22.303 10.634c0.141 0 0.59-0.046 0.753-0.046 0.042 0 0.077-0.063 0.077-0.141s-0.034-0.141-0.077-0.141c-0.162 0-0.611-0.046-0.753-0.046 -0.141 0-0.59 0.046-0.753 0.046 -0.042 0-0.077 0.063-0.077 0.141s0.034 0.141 0.077 0.141C21.713 10.588 22.162 10.634 22.303 10.634z'/%3E %3Cpath d='M22.212 9.903c-0.03-0.024-0.069-0.039-0.113-0.039 -0.094 0-0.171 0.07-0.171 0.156 0 0.086 0.076 0.156 0.171 0.156 0.094 0 0.17-0.07 0.17-0.156 0-0.067 0.097-0.067 0.097 0 0 0.135-0.12 0.244-0.267 0.244 -0.148 0-0.267-0.109-0.267-0.244 0-0.135 0.12-0.244 0.267-0.244 0.044 0 0.086 0.01 0.123 0.027C22.219 9.825 22.212 9.867 22.212 9.903z'/%3E %3Cpath d='M21.551 10.588c0.042 0 0.076-0.063 0.076-0.141s-0.034-0.141-0.076-0.141'/%3E %3Cpath d='M21.613 10.588c0.042 0 0.076-0.063 0.076-0.141s-0.034-0.141-0.076-0.141'/%3E %3Cpath d='M22.024 10.617c0.051 0 0.092-0.076 0.092-0.17 0-0.094-0.041-0.17-0.092-0.17'/%3E %3Cpath d='M22.119 10.624c0.053 0 0.096-0.08 0.096-0.178 0-0.098-0.043-0.178-0.096-0.178'/%3E %3Cpath d='M22.439 10.626c0.054 0 0.097-0.081 0.097-0.18 0-0.099-0.044-0.18-0.097-0.18'/%3E %3Cpath d='M22.539 10.621c0.053 0 0.096-0.078 0.096-0.174 0-0.096-0.043-0.174-0.096-0.174'/%3E %3Cpath d='M22.986 10.59c0.043 0 0.078-0.064 0.078-0.144s-0.035-0.144-0.078-0.144'/%3E %3Cpath d='M21.376 12.03c0.051-0.031 0.113-0.059 0.178-0.074'/%3E %3Cpath d='M23.068 12.047c-0.015-0.011-0.032-0.022-0.049-0.035'/%3E %3Cpath d='M23.159 12.118c0.116-0.125 0.213-0.266 0.267-0.428'/%3E %3Cpath fill='%23FFF' d='M21.922 8.87c0-0.041 0.033-0.058 0.072-0.087 0.047-0.035 0.066-0.052 0.108-0.052h0.546c0.04 0 0.05 0.01 0.05 0.048V9.52c0 0.037-0.009 0.048-0.05 0.048h-0.726V8.862'/%3E %3Cpath fill='%23E5E5E5' d='M22.513 9.633c0.072 0 0.059-0.002 0.109-0.052 0.053-0.052 0.048-0.048 0.048-0.096V8.806c0-0.035-0.009-0.045-0.046-0.045h-0.505c-0.04 0-0.057 0.016-0.1 0.049 -0.036 0.027-0.066 0.044-0.066 0.082v0.741H22.513z'/%3E %3Cpath fill='%23FFF' d='M22.567 9.617c0 0.037-0.009 0.048-0.05 0.048h-0.546c-0.041 0-0.049-0.01-0.049-0.048V8.875c0-0.037 0.009-0.048 0.049-0.048h0.546c0.041 0 0.05 0.01 0.05 0.048V9.617z'/%3E %3Cpath fill='%2396877D' d='M23.625 6.847c0.106 0.119 0.141 0.278 0.083 0.434h-0.158c0.066-0.2 0.025-0.39-0.258-0.415 -0.423-0.037-0.915 0.782-1.655 0.881 -0.216-0.258-0.205-0.749 0.07-0.982 -0.142-0.409-0.441-0.859-0.649-1.053 -0.136-0.022-0.293-0.033-0.394-0.027 0.108-0.233 0.416-0.478 0.666-0.578 0.04-0.059 0.084-0.116 0.124-0.167 0.025-0.32 1.547-0.17 1.871 0.029C23.326 5.328 23.467 6.523 23.625 6.847z'/%3E %3Cg fill='%23000' stroke='none'%3E %3Cpath d='M21.781 7.066c-0.036-0.554-0.26-1.011-0.575-1.322 0.15 0.042 0.457 0.042 0.665-0.108 0.274-0.183 0.99-0.503 1.252-0.366 0.021 0.046 0.033 0.15 0.017 0.216 -0.062-0.166-0.753 0.091-0.948 0.17 -0.187 0.087-0.27 0.204-0.204 0.466 -0.108-0.091-0.071-0.179-0.183-0.245C21.85 5.985 21.887 6.18 21.9 6.338c-0.042-0.112-0.116-0.353-0.279-0.495 0.141 0.274 0.264 0.933 0.206 1.283 0.112 0 0.36-0.11 0.459-0.189 -0.087 0.125-0.339 0.212-0.501 0.245 -0.073 0.087-0.123 0.312-0.119 0.437C21.655 7.465 21.703 7.09 21.781 7.066z'/%3E %3Cpath d='M23.625 6.847c-0.138-0.153-0.395-0.236-0.723-0.147 0.05-0.025 0.158-0.067 0.254-0.083 -0.012-0.087-0.091-0.462-0.104-0.553l0.092-0.037c0.046 0.225 0.104 0.482 0.141 0.586 0.029 0.008 0.096 0.021 0.154 0.05 -0.025-0.087-0.166-0.715-0.162-0.782l0.125-0.067C23.451 6.155 23.53 6.65 23.625 6.847z'/%3E %3C/g%3E %3Cpath fill='%2396877D' d='M23.551 7.282c0.066-0.2 0.025-0.39-0.258-0.415 -0.219-0.019-0.457 0.194-0.738 0.415H23.551z'/%3E %3Cpath fill='%2396877D' d='M21.713 5.49c-0.125 0.017-0.403-0.008-0.545-0.054 0.008-0.038 0.023-0.076 0.041-0.118 -0.087 0.058-0.253 0.172-0.316 0.251C21.093 5.611 21.505 5.632 21.713 5.49z'/%3E %3Cpath fill='none' d='M21.708 6.766c0.046 0.133 0.076 0.261 0.08 0.375'/%3E %3Cpath fill='none' d='M21.331 5.108c-0.075 0.11-0.141 0.228-0.163 0.328 0.141 0.046 0.42 0.071 0.545 0.054'/%3E %3Cpath fill='none' d='M21.059 5.713c0.054 0.009 0.104 0.019 0.147 0.031 0.15 0.042 0.457 0.042 0.665-0.108 0.208-0.15 0.773-0.615 1.414-0.665'/%3E %3Cpath fill='none' d='M20.894 5.569c0.2 0.042 0.612 0.062 0.819-0.079 0.482-0.328 0.948-0.52 1.414-0.545'/%3E %3Cpath fill='%23337321' d='M24.382 7.765c0.698 0.482 1.214 0.948 1.364 1.696 0.15 0.748 0.433 0.948 0.782 0.748 -0.083 0.432-0.516 0.482-0.881 0.15 0.033 0.499-0.166 1.098-0.682 1.314 -0.033-0.299 0.165-0.536 0.108-0.782 -0.025-0.108-0.033-0.358 0.108-0.474 -0.274 0.091-0.707-0.083-0.748-0.491 0.316 0.15 0.723 0.175 0.881-0.225C25.471 9.303 25.405 8.621 24.382 7.765z'/%3E %3Cpath fill='%23337321' d='M25.264 3.873c0.216-0.565 0.782-0.507 0.973-0.266 0.557-0.316 0.632 0.399 1.106 0.258 -0.008 0.133-0.166 0.258-0.341 0.249 0.183 0.166-0.075 0.416 0.316 0.565 -0.333 0.166-0.798-0.008-0.923-0.466 -0.108 0.216-0.499 0.216-0.657 0.042 0.341-0.091 0.316-0.407 0.125-0.532C25.67 3.597 25.33 3.648 25.264 3.873z'/%3E %3Cpath fill='%23337321' d='M23.577 5.118c0.155 0.5 0.476 0.966 0.822 1.283 0.399 0.366 1.002 0.274 1.339-0.075 0.008 0.696-0.713 0.75-1.114 0.532 -0.177-0.096-0.32-0.046-0.15 0.108 0.258 0.233 0.822 0.406 1.488 0.549 1.164 0.249 0.749 1.173 0.408 1.164 0.098-0.002 0.178-0.104 0.037-0.231 -1.01-0.909-3.064-0.551-3.031-2.58 -0.216 0.532-1.106 0.324-0.69-0.308 0.133 0.108 0.366 0.116 0.433-0.05 0.052-0.129 0.018-0.354-0.215-0.548 0.038-0.003 0.121 0 0.112-0.096 0.01 0.056 0.061 0.139 0.192 0.111 0.037 0.059 0.077 0.098 0.13 0.077 0.01-0.004 0.042-0.02 0.029-0.079C23.377 5.087 23.508 5.126 23.577 5.118z'/%3E %3Cpath d='M24.623 6.858c0.482 0.316 1.028 0.316 1.53-0.266 0.158-0.183 0.407-0.341 0.582-0.358 0.175-0.017 0.166-0.183 0.299-0.216 -0.083-0.025-0.116-0.125-0.241-0.112 0.312-0.108 0.22-0.358 0.374-0.478 -0.125 0.046-0.32-0.141-0.499 0.096 0.046-0.108-0.017-0.237-0.062-0.287 0.017 0.125-0.245 0.15-0.295 0.466 -0.028 0.177-0.125 0.166-0.141-0.108 -0.012-0.201-0.108-0.757-0.224-1.039 -0.116-0.283-0.143-0.671 0.015-0.729 -0.024-0.04-0.057-0.076-0.098-0.102 -0.193-0.126-0.532-0.075-0.599 0.15 -0.216 0.565 0.391 0.89 0.341 1.505 -0.091-0.457-0.832-0.574-0.823-1.023 -0.241 0.108-0.208 0.308-0.116 0.466 -0.15-0.233-0.491 0.15-0.782-0.166 -0.033 0.416 0.333 0.574 0.632 0.59 -0.15 0.266 0.05 0.491 0.249 0.565 0.008-0.466 0.963-0.275 0.973 0.524C25.746 7.016 25.014 7.074 24.623 6.858z'/%3E %3Cpath d='M25.962 7.515c1.164 0.249 0.749 1.173 0.408 1.164 -0.217-0.005-0.424-0.187-0.437-0.345 -0.249 0.133-0.183 0.395 0.008 0.499 -0.524-0.062-0.744 0.283-0.757 0.661 0.096-0.175 0.387-0.187 0.495-0.15 0.108 0.037 0.387 0.058 0.499-0.067 -0.092 0.079 0.058 0.262-0.071 0.403 0.437-0.017 0.628-0.424 0.553-0.603C27.226 8.563 27.118 7.723 25.962 7.515z'/%3E %3Cpath d='M25.076 11.466c0.076 0.047 0.066 0.147 0.015 0.21 -0.103 0.126 0.052 0.427-0.265 0.478 -0.094 0.015-0.163-0.045-0.194-0.152 -0.086-0.296 0.226-0.316 0.259-0.455C24.925 11.409 25.012 11.426 25.076 11.466z'/%3E %3Cpath d='M24.79 12.003c0.102 0.052 0.19 0.124 0.136 0.456 -0.023 0.138-0.028 0.473 0.093 0.482 -0.076 0.034-0.235 0.067-0.297-0.021 -0.067 0.102-0.207 0.066-0.258-0.066 -0.077 0.057-0.175-0.049-0.171-0.137 -0.067 0.039-0.194-0.026-0.154-0.224 -0.08 0.025-0.18-0.035-0.215-0.087 0.117-0.019 0.415-0.165 0.49-0.288C24.488 11.996 24.671 11.943 24.79 12.003z'/%3E %3Cpath fill='none' d='M24.721 12.921c0.034-0.045 0.054-0.24 0.035-0.359'/%3E %3Cpath fill='none' d='M24.464 12.855c0.053-0.037 0.155-0.168 0.176-0.286'/%3E %3Cpath fill='none' d='M24.292 12.718c0.066-0.028 0.232-0.226 0.272-0.357'/%3E %3Cpath fill='none' d='M24.138 12.494c0.077-0.013 0.318-0.157 0.421-0.316'/%3E %3Cpath d='M23.376 5.869c-0.014 0.852 0.34 1.284 0.831 1.564 -0.182-0.109-0.103-0.483-0.349-0.604 0.058-0.004 0.15 0.079 0.295 0.046 -0.071-0.158-0.187-0.399-0.457-0.432 0.071-0.008 0.225 0.017 0.324-0.021C23.879 6.205 23.505 6.309 23.376 5.869z'/%3E %3Cpath d='M23.288 5.058c-0.03-0.01-0.055-0.04-0.08-0.079 -0.131 0.028-0.182-0.055-0.192-0.111 0.008 0.096-0.074 0.092-0.113 0.095 0.234 0.194 0.268 0.419 0.216 0.548 -0.067 0.166-0.299 0.158-0.433 0.05 -0.017 0.353 0.441 0.47 0.607 0.025 0 0.075 0.096 0.067 0.121 0.166C23.532 5.561 23.442 5.286 23.288 5.058z'/%3E %3Cpath fill='%23337321' d='M22.557 3.37c-0.208-0.191-0.304-0.511-0.295-0.694 0.008-0.183 0.083-0.383 0.349-0.299 -0.083 0-0.025 0.166-0.112 0.183 0.071 0.025 0.166-0.033 0.179-0.071 0.017 0.058 0.125 0.042 0.133 0.108 0.042-0.033-0.004-0.195-0.066-0.229 0.046-0.025 0.071-0.154 0.05-0.216 -0.042 0.008-0.104 0.067-0.116 0.15 0.021-0.067-0.004-0.233-0.121-0.258 -0.033 0.046-0.042 0.158 0.004 0.22 -0.108-0.025-0.266 0.046-0.304 0.137 0.008-0.11 0.024-0.267 0.092-0.366 0.023-0.033-0.033-0.091-0.077-0.012 -0.081-0.158-0.297-0.241-0.393-0.162s-0.224-0.037-0.303 0.087c-0.079 0.125-0.347 0.138-0.333 0.27 0.008 0.079-0.011 0.201-0.05 0.245 -0.096 0.108 0.046 0.187 0.071 0.283 -0.017-0.316 0.486-0.931 0.99-0.69 -0.046 0.079-0.086 0.237-0.1 0.428 -0.021 0.283 0.021 0.682 0.295 0.915L22.557 3.37z'/%3E %3Cpath fill='%23CF142B' d='M22.706 2.38c-0.003-0.075 0.127-0.172 0.301-0.17 0.21 0.002 0.372 0.193 0.54 0.175 0.168-0.019 0.085 0.075 0.05 0.1 -0.035 0.025-0.056 0.062-0.044 0.108 0.012 0.046-0.009 0.076-0.077 0.033 -0.15-0.094-0.299 0.037-0.497-0.035C22.81 2.527 22.711 2.492 22.706 2.38z'/%3E %3Cpath fill='%2396877D' d='M21.85 4.343c-0.083-0.262-0.399-0.549-0.553-0.615l-0.008-0.141c0.083-0.033 0.283-0.191 0.374-0.279 0.624 0.299 1.472-0.125 1.863-0.565l0.15 0.091 -0.075 0.1 -0.079-0.042c-0.096 0.116-0.453 0.452-0.561 0.523 0.145 0.037 0.344 0.062 0.399 0.059C23.709 3.224 23.983 3 24.116 2.983l0.112 0.15 -0.1 0.071 -0.079-0.046c-0.374 0.308-0.798 0.981-0.965 1.43C22.852 4.538 22.02 4.571 21.85 4.343z'/%3E %3Cpath fill='none' d='M22.961 3.415c-0.054-0.014-0.1-0.029-0.129-0.045 -0.067 0.062-0.233 0.116-0.445 0.125'/%3E %3Cpath fill='none' d='M21.883 4.251c-0.056-0.31 0.033-0.653 0.191-0.757 0.345 0.229 0.936 0.229 1.285-0.021'/%3E %3Cpath fill='none' d='M21.883 4.089c0.266-0.008 0.844 0.037 0.985 0.058 0.141 0.021 0.378 0.079 0.345 0.15'/%3E %3Cpath fill='none' d='M22.006 4.045l0.077-0.076 -0.077-0.076L21.93 3.968 22.006 4.045z'/%3E %3Cpath fill='%23337321' d='M22.187 2.497c-0.096-0.133-0.359-0.175-0.416 0.004 -0.025 0.079-0.062 0.162-0.125 0.2 -0.062 0.037-0.048 0.151-0.021 0.2 0.066 0.121 0.008 0.237 0.137 0.316 0-0.096 0.141-0.195 0.262-0.22 0.121-0.025 0.303-0.133 0.328-0.254C22.378 2.621 22.42 2.521 22.187 2.497z'/%3E %3Cpath fill='%2396877D' d='M21.588 3.694h0.033l0.001 0.227c0.007 0.002 0.014 0.006 0.02 0.01l0.196-0.113 0.017 0.029 -0.197 0.114c0.001 0.007 0.002 0.015 0.001 0.022l0.196 0.113 -0.017 0.029L21.64 4.013c-0.005 0.005-0.012 0.01-0.019 0.012l0 0.226h-0.033l0-0.227c-0.007-0.002-0.014-0.006-0.02-0.01l-0.196 0.113 -0.017-0.029 0.197-0.114c-0.001-0.007-0.002-0.015-0.001-0.022l-0.196-0.113 0.017-0.029 0.197 0.113c0.005-0.005 0.012-0.01 0.019-0.012L21.588 3.694 21.588 3.694z'/%3E %3Cpath fill='%2396877D' d='M21.884 4.25c-0.071 0.072-0.17 0.116-0.28 0.116 -0.218 0-0.394-0.176-0.394-0.394 0-0.218 0.176-0.394 0.394-0.394 0.128 0 0.241 0.061 0.313 0.155 -0.02 0.05-0.044 0.161-0.046 0.211 -0.014-0.136-0.128-0.242-0.268-0.242 -0.149 0-0.269 0.121-0.269 0.269 0 0.149 0.121 0.269 0.269 0.269 0.124 0 0.232-0.087 0.263-0.202C21.867 4.09 21.869 4.209 21.884 4.25z'/%3E %3Cpath fill='%23337321' d='M21.438 4.625c-0.025-0.029-0.071-0.108-0.066-0.166 0.037-0.004 0.108 0.021 0.141 0.054 -0.004-0.042-0.021-0.133-0.012-0.175 0.046 0.017 0.141 0.071 0.175 0.133 -0.008-0.042-0.025-0.15-0.008-0.216 0.05 0.029 0.133 0.108 0.15 0.162 0.004-0.083 0.033-0.22 0.058-0.254 0.037 0.037 0.096 0.071 0.133 0.121 0.008-0.067 0.042-0.146 0.091-0.166 0.037 0.042 0.096 0.137 0.108 0.245 0.037-0.012 0.087-0.075 0.108-0.108 0.021 0.033 0.042 0.091 0.029 0.162 0.046-0.042 0.1-0.1 0.112-0.15 0.033 0.025 0.096 0.087 0.112 0.154 -0.008-0.054-0.004-0.15-0.021-0.204 0.062 0.033 0.112 0.091 0.125 0.154 0.017-0.058 0.054-0.162 0.087-0.187 0.033 0.067 0.067 0.146 0.062 0.212 0.021-0.042 0.054-0.116 0.087-0.133 0.029 0.046 0.025 0.146 0.017 0.2 0.029-0.042 0.083-0.091 0.116-0.108 0.004 0.025 0.008 0.075 0 0.112 0.037-0.021 0.1-0.133 0.121-0.191 0.058 0.029 0.116 0.129 0.121 0.179 0.042-0.017 0.125-0.091 0.15-0.133 0 0.029 0.013 0.108-0.004 0.17 0.025-0.025 0.05-0.075 0.062-0.096 0.017 0.042 0.004 0.141-0.013 0.195 0.037-0.033 0.092-0.054 0.125-0.054 0.004 0.071-0.046 0.195-0.092 0.287C23.114 4.713 22.278 4.671 21.438 4.625z'/%3E %3Cpath stroke='none' d='M22.83 2.423c-0.002-0.031 0.066-0.1 0.189-0.099 0.147 0.001 0.283 0.109 0.4 0.101 0.118-0.008 0.06 0.031 0.035 0.041 -0.025 0.01-0.039 0.026-0.031 0.044 0.009 0.019-0.006 0.031-0.054 0.014 -0.105-0.038-0.21 0.015-0.348-0.014C22.902 2.483 22.833 2.469 22.83 2.423z'/%3E %3Cpath d='M21.567 4.875C21.442 5.025 21.318 5 21.293 4.904c-0.025-0.096 0.067-0.141 0.033-0.225 -0.033-0.083 0.054-0.121 0.096-0.083 0.042 0.037 0.175-0.083 0.233 0.042 0.058 0.125 0.104 0.212 0.071 0.262C21.692 4.95 21.592 4.925 21.567 4.875z'/%3E %3Cpath d='M22.103 4.65c-0.023-0.055 0.106-0.16 0.173-0.085 0.067 0.075 0.171-0.081 0.229 0.037 0.058 0.119 0.077 0.181 0.106 0.247 0.029 0.067-0.158 0.102-0.216 0.044 0.008 0.039-0.162 0.07-0.208-0.042C22.162 4.792 22.135 4.723 22.103 4.65z'/%3E %3Cpath d='M22.968 4.719c-0.031-0.058 0.121-0.141 0.2-0.035 0.021-0.044 0.171-0.052 0.181 0.075 0.01 0.127 0.015 0.202 0.019 0.252 0.004 0.05-0.091 0.096-0.16-0.031 -0.123 0.025-0.179-0.044-0.193-0.116C23 4.79 22.985 4.754 22.968 4.719z'/%3E %3Cpath fill='%23337321' d='M21.648 4.636c-0.019-0.042 0.106-0.125 0.191-0.062 0.085 0.062 0.203-0.054 0.254 0.058 0.102 0.227 0.108 0.243 0.077 0.287 -0.031 0.044-0.164 0.027-0.198-0.033 -0.006 0.042-0.121 0.035-0.181 0.002C21.723 4.85 21.675 4.711 21.648 4.636z'/%3E %3Cpath fill='%23337321' d='M22.523 4.646c-0.029-0.064 0.166-0.121 0.252-0.008 0.044-0.04 0.139-0.042 0.193 0.081 0.054 0.123 0.062 0.191 0.023 0.222 -0.028 0.022-0.129 0.039-0.162-0.017 -0.046 0.029-0.187 0.004-0.218-0.075C22.58 4.771 22.553 4.702 22.523 4.646z'/%3E %3Cpath fill='%23337321' d='M23.351 4.769c-0.004-0.058 0.102-0.085 0.141 0 0.04 0.085 0.166 0.008 0.177 0.15 0.002 0.027-0.015 0.131-0.054 0.181s-0.233 0-0.245-0.106C23.357 4.887 23.353 4.827 23.351 4.769z'/%3E %3Cg fill='none'%3E %3Cpath d='M21.567 4.875c-0.046-0.062-0.108-0.162-0.187-0.054'/%3E %3Cpath d='M21.973 4.885c-0.027-0.035-0.062-0.094-0.075-0.139'/%3E %3Cpath d='M22.395 4.894c-0.029-0.021-0.073-0.062-0.096-0.106'/%3E %3Cpath d='M22.357 4.675c0.073 0.008 0.123 0.077 0.145 0.108 0.023 0.031 0.071 0.087 0.108 0.094'/%3E %3Cpath d='M22.829 4.925c-0.025-0.04-0.05-0.075-0.056-0.104'/%3E %3Cpath d='M22.775 4.638c0.025 0.035 0.044 0.064 0.058 0.098'/%3E %3Cpath d='M23.207 4.979c-0.033-0.062-0.085-0.123-0.129-0.143'/%3E %3Cpath d='M23.191 4.75c0.004 0.123 0.168 0.131 0.175 0.218'/%3E %3Cpath d='M23.492 4.769c0.017 0.031 0.023 0.062 0.025 0.114'/%3E %3C/g%3E %3C/g%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 45 30'%3E %3Crect fill='%23ED0000' width='45' height='30'/%3E %3Cpath stroke='%23FFF' stroke-width='6' d='M0,9 h 45 m -45,12 h 45'/%3E %3Cpath fill='%230050F0' d='M0,0L25.98076,15L0,30z'/%3E %3Ccomment%3Ethe star is in the center of gravity of the triangle, so the x-pos is irrational (tan(30 deg) * 15)%3C/comment%3E %3Cg fill='%23FFF' transform='translate(8.6602540378443864676372317075294,15) scale(5)'%3E %3Cg id='cone'%3E %3Cpolygon id='triangle' points='0,0 0,1 .5,1' transform='translate(0,-1) rotate(18)'/%3E %3Cuse xlink:href='%23triangle' transform='scale(-1,1)'/%3E %3C/g%3E %3Cuse xlink:href='%23cone' transform='rotate(72)'/%3E %3Cuse xlink:href='%23cone' transform='rotate(-72)'/%3E %3Cuse xlink:href='%23cone' transform='rotate(144)'/%3E %3Cuse xlink:href='%23cone' transform='rotate(-144)'/%3E %3C/g%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 3'%3E %3Crect fill='%23007A3D' width='6' height='3'/%3E %3Crect fill='%23FFF' width='6' height='2'/%3E %3Crect width='6' height='1'/%3E %3Cpath fill='%23CE1126' d='M0,0l2,1.5L0,3Z'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 600 400'%3E %3Crect width='600' height='400' fill='%23f00'/%3E %3Crect width='240' height='400' fill='%23060'/%3E %3Cg fill='%23ff0' fill-rule='evenodd' stroke='%23000' stroke-width='0.573' stroke-linecap='round' stroke-linejoin='round'%3E %3Cpath d='m318.24,262.04c-30.21-0.91-168.74-87.38-169.69-101.15l7.6496-12.757c13.741,19.966,155.36,104.06,169.27,101.08l-7.2299,12.823'/%3E %3Cpath d='m154.59,146.4c-2.7101,7.2937,36.149,31.318,82.903,59.754,46.752,28.434,87.065,46.006,90.053,43.486,0.18256-0.32544,1.4701-2.5409,1.352-2.5232-0.56001,0.84402-1.9234,1.1104-4.0506,0.49741-12.631-3.6433-45.575-18.765-86.374-43.506-40.798-24.743-76.294-47.544-81.811-57.232-0.38363-0.67116-0.65702-1.8962-0.60146-2.8487l-0.13405-0.002-1.1747,2.0532-0.16139,0.32191h-0.00088zm164.36,116.04c-0.51238,0.92957-1.4675,0.96044-3.2816,0.76112-11.3-1.2506-45.589-17.925-86.162-42.213-47.21-28.26-86.2-54.01-81.97-60.74l1.1509-2.0346,0.22665,0.0706c-3.8037,11.405,76.948,57.578,81.702,60.522,46.724,28.947,86.115,45.851,89.601,41.458l-1.2682,2.181v-0.002z'/%3E %3Cpath d='m240.17,169.23c30.237-0.23901,67.55-4.1319,89.023-12.69l-4.6265-7.5168c-12.692,7.0247-50.21,11.644-84.652,12.335-40.736-0.37483-69.49-4.1681-83.897-13.835l-4.3672,8.0045c26.484,11.207,53.623,13.587,88.52,13.703'/%3E %3Cpath d='m330.44,156.71c-0.73904,1.1818-14.743,6.0113-35.373,9.5753-13.988,2.1325-32.234,3.9555-55.004,3.9776-21.633,0.0203-39.305-1.5196-52.684-3.3329-21.656-3.3955-32.833-8.1201-36.965-9.7896,0.39509-0.78581,0.64908-1.337,1.0301-2.0708,11.895,4.736,23.124,7.5918,36.279,9.6158,13.291,1.8,30.75,3.362,52.276,3.3417,22.664-0.0229,40.709-1.9844,54.616-4.0534,21.155-3.4122,32.711-7.8034,34.334-9.8425l1.494,2.5788h-0.002zm-4.0603-7.6226c-2.293,1.8415-13.718,5.8932-33.819,9.1034-13.415,1.9226-30.472,3.6433-52.265,3.6645-20.704,0.0203-37.619-1.375-50.485-3.2491-20.414-2.6661-31.279-7.4754-35.196-8.8776,0.3898-0.67381,0.78666-1.3423,1.1941-2.0135,3.0479,1.5346,13.533,5.7909,34.226,8.7224,12.72,1.8036,29.661,3.1477,50.262,3.1265,21.69-0.0221,38.553-1.7762,51.883-3.6883,20.205-2.7799,31.077-7.9472,32.728-9.241l1.4728,2.4509v0.002z'/%3E %3Cpath d='m140.88,205.66c18.598,10.003,59.905,15.044,98.994,15.391,35.591,0.0564,81.958-5.5016,99.297-14.69l-0.47712-10.012c-5.4246,8.4773-55.113,16.609-99.206,16.276-44.093-0.3325-85.038-7.1429-98.687-15.959l0.0794,8.9914'/%3E %3Cpath d='m340.12,204.22,0.00088,2.3874c-2.606,3.1159-18.946,7.8255-39.437,11.142-15.595,2.391-35.927,4.1945-61.262,4.1945-24.069,0-43.263-1.7163-58.148-4.0014-23.529-3.4264-38.579-9.4262-41.6-11.217l0.0132-2.7852c9.0748,6.0334,33.661,10.447,41.917,11.798,14.788,2.2701,33.868,3.9732,57.817,3.9732,25.216,0,45.434-1.7912,60.931-4.1663,14.701-2.1237,35.644-7.6465,39.767-11.324h0.00088zm0.01-8.4922,0.00088,2.3874c-2.606,3.1142-18.946,7.8237-39.437,11.14-15.595,2.391-35.927,4.1945-61.262,4.1945-24.069,0-43.263-1.7145-58.148-4.0014-23.529-3.4246-38.579-9.4245-41.6-11.216l0.0132-2.7852c9.0748,6.0325,33.661,10.447,41.917,11.796,14.788,2.2719,33.868,3.9758,57.817,3.9758,25.216,0,45.434-1.7921,60.931-4.169,14.701-2.1237,35.644-7.6465,39.767-11.324l0.00088,0.002z'/%3E %3Cpath d='m239.79,260.32c-42.772-0.25489-79.421-11.659-87.16-13.544l5.6433,8.8344c13.67,5.7503,49.424,14.32,81.927,13.371,32.504-0.94809,60.91-3.466,80.928-13.211l5.7862-9.1555c-13.642,6.425-60.068,13.639-87.125,13.705'/%3E %3Cpath stroke-width='0.55' d='m323.3,253.72c-0.85016,1.2991-1.7171,2.5823-2.5963,3.8294-9.4417,3.3293-24.319,6.8245-30.597,7.844-12.824,2.6423-32.665,4.594-50.274,4.6029-37.89-0.55474-68.905-7.9719-83.496-14.299l-1.1773-2.0241,0.19225-0.30427,1.9966,0.77435c25.948,9.2834,55.091,12.987,82.698,13.652,17.538,0.0617,35.095-2.01,49.292-4.5491,21.771-4.3621,30.574-7.65,33.275-9.1405l0.68701-0.38541h-0.00088zm5.0172-8.2753c0.022,0.0256,0.0441,0.0503,0.0653,0.0776-0.63585,1.0733-1.2911,2.1652-1.9622,3.2623-5.0357,1.8-18.702,5.7988-38.659,8.5893-13.149,1.7912-21.322,3.526-47.479,4.034-49.015-1.2471-80.75-10.831-88.289-13.195l-1.1174-2.1431c28.406,7.4154,57.422,12.592,89.408,13.121,23.931-0.50976,34.112-2.2719,47.152-4.0499,23.271-3.6186,34.996-7.4498,38.515-8.5558-0.0441-0.0635-0.0961-0.13053-0.15433-0.19932l2.5231-0.9428-0.002,0.002z'/%3E %3Cpath d='m328.83,197.76c0.13873,28.137-14.26,53.386-25.858,64.525-16.408,15.759-38.163,25.896-63.569,26.363-28.37,0.52117-55.12-17.974-62.295-26.099-14.028-15.885-25.449-36.057-25.815-63.243,1.7376-30.709,13.793-52.1,31.268-66.769s40.743-21.813,60.121-21.302c22.358,0.59003,48.475,11.558,66.521,33.332,11.823,14.266,16.943,29.748,19.627,53.193zm-89.186-96.342c54.485,0,99.296,44.338,99.296,98.703,0,54.364-44.811,98.704-99.296,98.704s-98.924-44.339-98.924-98.704,44.439-98.703,98.924-98.703'/%3E %3Cpath d='m239.91,101.08c54.534,0,99.011,44.483,99.011,99.022,0,54.538-44.478,99.02-99.011,99.02-54.534,0-99.011-44.481-99.011-99.02s44.478-99.022,99.011-99.022zm-96.832,99.0224c0,53.26,43.736,96.842,96.832,96.842,53.097,0,96.833-43.582,96.833-96.842,0-53.262-43.737-96.844-96.833-96.844s-96.832,43.584-96.832,96.844z'/%3E %3Cpath d='m239.99,109.31c49.731,0,90.693,40.821,90.693,90.704,0,49.884-40.963,90.703-90.693,90.703s-90.693-40.819-90.693-90.703c0-49.883,40.964-90.704,90.693-90.704zm-88.515,90.7034c0,48.685,39.979,88.524,88.515,88.524s88.515-39.839,88.515-88.524c0-48.686-39.978-88.525-88.515-88.525-48.536,0-88.515,39.839-88.515,88.525z'/%3E %3Cpath d='m243.98,100.68-8.48545,0,0.01,198.96,8.51455,0z'/%3E %3Cpath d='m243.13,99.546h2.1598l0.0185,201.25h-2.1616l-0.0159-201.25zm-8.4213,0.0018h2.1766l0.003,201.25h-2.1783v-201.25z'/%3E %3Cpath d='m338.99,203.935,0-7.3554-5.99-5.58-34-9-49-5-59,3-42,10-8.48,6.28,0,7.3572l21.48-9.637,51-8h49l36,4,25,6z'/%3E %3Cpath d='m239.95,184.77c23.383-0.0432,46.07,2.2154,64.065,5.7194,18.569,3.7121,31.637,8.3556,36.105,13.571l-0.005,2.5823c-5.3884-6.4902-22.973-11.248-36.518-13.968-17.858-3.474-40.393-5.7168-63.647-5.6736-24.538,0.0459-47.387,2.3698-64.984,5.8032-14.12,2.8019-32.951,8.3679-35.302,13.858v-2.689c1.2911-3.8003,15.313-9.4792,34.984-13.417,17.729-3.4572,40.62-5.7415,65.302-5.7864zm0.01-8.4922c23.383-0.0423,46.07,2.2172,64.065,5.7194,18.569,3.7139,31.637,8.3556,36.105,13.571l-0.005,2.5823c-5.3884-6.4885-22.973-11.247-36.518-13.966-17.858-3.4757-40.393-5.7185-63.647-5.6736-24.538,0.0441-47.276,2.3698-64.875,5.8014-13.626,2.5832-33.226,8.3696-35.412,13.86v-2.6908c1.2911-3.7588,15.597-9.6414,34.985-13.417,17.729-3.4572,40.62-5.7397,65.302-5.7864z'/%3E %3Cpath d='m239.48,132.96c36.849-0.18433,68.99,5.1523,83.695,12.685l5.3638,9.279c-12.781-6.888-47.456-14.05-89.005-12.979-33.854,0.20814-70.027,3.7271-88.176,13.41l6.4035-10.709c14.895-7.7241,50.022-11.643,81.72-11.684'/%3E %3Cpath d='m239.97,140.62c21.017-0.0556,41.325,1.1298,57.476,4.0437,15.041,2.7993,29.385,7.0009,31.436,9.2604l1.5901,2.8099c-4.9881-3.257-17.401-6.8836-33.339-9.906-16.006-3.0083-36.3-4.0049-57.2-3.9502-23.722-0.0811-42.152,1.1712-57.969,3.9291-16.728,3.13-28.334,7.6015-31.197,9.7261l1.5583-2.9704c5.5631-2.8381,14.39-6.2592,29.223-8.9297,16.357-2.988,34.983-3.8841,58.423-4.0128h-0.00088zm-0.009-8.4843c20.113-0.0529,39.972,1.068,55.452,3.8506,12.209,2.3768,24.283,6.0872,28.704,9.3892l2.3256,3.6954c-3.9536-4.3947-18.836-8.5593-31.974-10.892-15.361-2.6494-34.395-3.698-54.508-3.8656-21.108,0.0591-40.615,1.352-55.752,4.1081-14.441,2.7481-23.76,6.0016-27.703,8.5425l2.0451-3.0868c5.4414-2.8646,14.232-5.4954,25.303-7.6465,15.249-2.7764,34.876-4.0358,56.108-4.0949z'/%3E %3Cpath d='m289.15,241.26c-18.218-3.4008-36.469-3.8947-49.217-3.7447-61.407,0.71967-81.244,12.609-83.665,16.209l-4.5894-7.4815c15.634-11.332,49.073-17.687,88.587-17.037,20.518,0.33602,38.224,1.6986,53.119,4.5835l-4.2358,7.4727'/%3E %3Cpath stroke-width='0.55' d='m239.58,236.46c17.082,0.25488,33.849,0.96044,50.033,3.9784l-1.172,2.069c-15.031-2.7746-31.055-3.8365-48.803-3.75-22.663-0.17727-45.585,1.9394-65.541,7.6668-6.2968,1.7524-16.721,5.8006-17.784,9.1458l-1.1659-1.9226c0.33601-1.9773,6.6363-6.081,18.414-9.3901,22.858-6.5458,44.239-7.6491,66.019-7.799v0.002zm0.77519-8.5963c17.698,0.33073,35.975,1.1492,53.74,4.6681l-1.2206,2.1537c-16.042-3.1847-31.369-4.2466-52.415-4.5702-22.735,0.0414-46.851,1.6625-68.778,8.0372-7.0791,2.062-19.297,6.5202-19.704,10.05l-1.1659-2.0655c0.26545-3.2059,10.842-7.388,20.358-10.156,22.096-6.4241,46.275-8.076,69.186-8.1174z'/%3E %3Cpath d='M327.58,247.38,320.201,258.829,299,240,244,203,182,169,149.81,157.99,156.67,145.27,159,144l20,5,66,34,38,24,32,23,13,15z'/%3E %3Cpath d='m148.65,158.29c5.646-3.8294,47.139,14.655,90.555,40.834,43.301,26.254,84.677,55.921,80.942,61.473l-1.2285,1.9323-0.56354,0.4445c0.12083-0.0864,0.74345-0.84755-0.0609-2.906-1.8449-6.0704-31.195-29.491-79.894-58.895-47.475-28.309-87.041-45.371-90.997-40.494l1.247-2.3892h-0.00089zm180.44,88.927c3.57-7.052-34.916-36.044-82.632-64.272-48.813-27.666-83.994-43.951-90.42-39.095l-1.4278,2.5991c-0.0124,0.14287,0.052-0.17727,0.35364-0.4101,1.1685-1.0195,3.1052-0.95074,3.9792-0.96662,11.065,0.16581,42.667,14.709,87.006,40.128,19.428,11.315,82.071,51.491,81.832,62.789,0.0168,0.97102,0.0803,1.1712-0.28485,1.6519l1.5936-2.4236v-0.002z'/%3E %3C/g%3E %3Cg%3E %3Cpath fill='%23fff' stroke='%23000' stroke-width='0.67037' d='m180.6,211.01c0,16.271,6.6628,30.987,17.457,41.742,10.815,10.778,25.512,17.579,41.809,17.579,16.381,0,31.247-6.6525,42.016-17.389,10.769-10.735,17.443-25.552,17.446-41.88h-0.002v-79.189l-118.74-0.14111,0.0123,79.278h0.002z'/%3E %3Cpath fill='%23f00' stroke='%23000' stroke-width='0.50734' d='m182.82,211.12v0.045c0,15.557,6.4414,29.724,16.775,40.009,10.354,10.305,24.614,16.712,40.214,16.712,15.681,0,29.912-6.3606,40.222-16.626,10.308-10.265,16.697-24.433,16.699-40.044h-0.002v-76.826l-113.84-0.0185-0.0697,76.748m91.022-53.747,0.004,48.891-0.0414,5.1717h0.00088c0,1.3608-0.082,2.9122-0.24076,4.2333-0.92512,7.7294-4.4801,14.467-9.7451,19.708-6.1636,6.1357-14.671,9.9413-24.047,9.9413-9.327,0-17.639-3.9379-23.829-10.1-6.3497-6.32-10.03-14.986-10.03-23.947l-0.0132-54.023,67.94,0.12259,0.002,0.002z'/%3E %3Cg id='castle3'%3E %3Cg id='castle' fill='%23ff0' stroke='%23000' stroke-width='0.5'%3E %3Cpath stroke='none' d='m190.19,154.43c0.13493-5.521,4.0524-6.828,4.0806-6.8474,0.0282-0.0185,4.2314,1.4076,4.2173,6.8986l-8.2978-0.0512'/%3E %3Cpath d='m186.81,147.69-0.68172,6.3447,4.1406,0.009c0.0397-5.2493,3.9739-6.1225,4.0691-6.1031,0.0891-0.005,3.9889,1.1606,4.0929,6.1031h4.1511l-0.74962-6.3932-15.022,0.0379v0.002z'/%3E %3Cpath d='m185.85,154.06h16.946c0.35717,0,0.64908,0.35277,0.64908,0.78404,0,0.43039-0.29191,0.78141-0.64908,0.78141h-16.946c-0.35717,0-0.64908-0.35102-0.64908-0.78141,0-0.43127,0.29191-0.78404,0.64908-0.78404z'/%3E %3Cpath d='m192.01,154.03c0.0185-3.3126,2.2621-4.2501,2.2736-4.2483,0.00088,0,2.3423,0.96661,2.3609,4.2483h-4.6344'/%3E %3Cpath d='m186.21,145.05h16.245c0.34218,0,0.62263,0.31839,0.62263,0.70468,0,0.38717-0.28045,0.70467-0.62263,0.70467h-16.245c-0.34218,0-0.62263-0.31573-0.62263-0.70467,0-0.38629,0.28045-0.70468,0.62263-0.70468z'/%3E %3Cpath d='m186.55,146.47h15.538c0.32719,0,0.59529,0.31662,0.59529,0.70379,0,0.38805-0.2681,0.70467-0.59529,0.70467h-15.538c-0.32719,0-0.59529-0.31662-0.59529-0.70467,0-0.38717,0.2681-0.70379,0.59529-0.70379z'/%3E %3Cpath d='m191.57,135.88,1.2267,0.002v0.87136h0.89513v-0.89076l1.2567,0.004v0.88723h0.89778v-0.89076h1.2576l-0.002,2.0117c0,0.31574-0.25398,0.52035-0.54854,0.52035h-4.4113c-0.29633,0-0.56972-0.23724-0.5706-0.52652l-0.003-1.9879h0.00088z'/%3E %3Cpath d='m196.19,138.57,0.27691,6.4514-4.3028-0.0159,0.28486-6.4523,3.741,0.0168'/%3E %3Cpath id='cp1' d='m190.94,141.56,0.13141,3.4775-4.1256,0.002,0.11641-3.4793h3.8786-0.00089z'/%3E %3Cuse xlink:href='%23cp1' x='10.609'/%3E %3Cpath id='cp2' d='m186.3,139.04,1.1994,0.003v0.87224h0.8775v-0.89253l1.2294,0.004v0.889h0.87926v-0.89253l1.2302,0.002-0.002,2.0117c0,0.31398-0.2487,0.51859-0.5362,0.51859h-4.3169c-0.28926,0-0.55824-0.23548-0.55913-0.52564l-0.003-1.9888h0.00088z'/%3E %3Cuse xlink:href='%23cp2' x='10.609'/%3E %3Cpath fill='%23000' stroke='none' d='m193.9,140.61c-0.0265-0.62706,0.87661-0.63411,0.86603,0v1.5364h-0.866v-1.536'/%3E %3Cpath id='cp3' fill='%23000' stroke='none' d='m188.57,142.84c-0.003-0.6059,0.83693-0.61824,0.82635,0v1.1871h-0.826v-1.187'/%3E %3Cuse xlink:href='%23cp3' x='10.641'/%3E %3C/g%3E %3Cuse xlink:href='%23castle' y='46.3198'/%3E %3Cuse xlink:href='%23castle' transform='matrix(0.70460892,-0.70959585,0.70959585,0.70460892,-35.341459,275.10898)'/%3E %3C/g%3E %3Cuse xlink:href='%23castle' x='45.7138'/%3E %3Cuse xlink:href='%23castle3' transform='matrix(-1,0,0,1,479.79195,0)'/%3E %3Cg id='quina' fill='%23fff'%3E %3Cpath fill='%23039' d='m232.636,202.406v0.005c0,2.2119,0.84927,4.2272,2.2118,5.6894,1.3652,1.4667,3.2454,2.3777,5.302,2.3777,2.0672,0,3.9439-0.90487,5.3029-2.3654,1.3581-1.4587,2.2021-3.47219,2.2021-5.693v-10.768l-14.992-0.0123-0.0273,10.766'/%3E %3Ccircle cx='236.074' cy='195.735' r='1.486'/%3E %3Ccircle cx='244.392' cy='195.742' r='1.486'/%3E %3Ccircle cx='240.225' cy='199.735' r='1.486'/%3E %3Ccircle cx='236.074' cy='203.916' r='1.486'/%3E %3Ccircle cx='244.383' cy='203.905' r='1.486'/%3E %3C/g%3E %3Cuse xlink:href='%23quina' y='-26.016'/%3E %3Cuse xlink:href='%23quina' x='-20.799'/%3E %3Cuse xlink:href='%23quina' x='20.745'/%3E %3Cuse xlink:href='%23quina' y='25.784'/%3E %3C/g%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 800 500'%3E %3Crect fill='%234AADD6' width='800' height='500'/%3E %3Ccircle fill='%23FFDE00' cx='350' cy='250' r='150'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 600 330'%3E %3Crect width='600' height='330' fill='%230038a8'/%3E %3Crect width='600' height='220' fill='%23fff'/%3E %3Crect width='600' height='110' fill='%23d52b1e'/%3E %3Cg%3E %3Cg fill='none' stroke='%23000'%3E %3Ccircle stroke-width='1.07585' cx='300' cy='165' r='42.2'/%3E %3Ccircle stroke-width='0.47815' cx='300' cy='165' r='34.67'/%3E %3Ccircle stroke-width='0.43816' cx='300' cy='165' r='26.56'/%3E %3C/g%3E %3Cg fill='%23000'%3E %3Cpath d='m277.53,181.28-4.8927,2.9054-1.4963-2.5198c-0.27744-0.46724-0.44945-0.84813-0.51601-1.1427-0.0666-0.29453-0.0363-0.58185,0.0908-0.86197,0.12709-0.28011,0.34638-0.51266,0.65787-0.69763,0.27145-0.16118,0.53998-0.24239,0.80558-0.24363,0.26562-0.001,0.51973,0.0631,0.76232,0.19286,0.15451,0.0828,0.32407,0.22138,0.50868,0.41571-0.0469-0.21589-0.0648-0.38284-0.0536-0.50084,0.007-0.0794,0.0448-0.21092,0.1133-0.39456,0.0685-0.18363,0.12781-0.31439,0.17786-0.39227l0.98439-1.5732,1.0147,1.7088-1.0156,1.6955c-0.13279,0.2173-0.20433,0.38317-0.21461,0.49762-0.0109,0.15394,0.0246,0.29989,0.10651,0.43783l0.0793,0.1335,1.9858-1.1792zm-3.812,0.20962-0.37853-0.63744c-0.041-0.069-0.14247-0.18926-0.30456-0.36086-0.0795-0.0882-0.17921-0.13961-0.29919-0.15414-0.11997-0.0145-0.23336,0.01-0.34016,0.0734-0.15797,0.0938-0.2495,0.21587-0.2746,0.3662s0.0443,0.36344,0.20811,0.63933l0.39438,0.66415z'/%3E %3Cpath d='m269.11,177.71-1.4871-4.4713,1.1528-0.38341,0.93096,2.7992,0.85817-0.28541-0.86358-2.5966,1.1013-0.36626,0.86358,2.5966,1.0644-0.35401-0.9579-2.8802,1.2228-0.40668,1.514,4.5524z'/%3E %3Cpath d='m267.16,171.06-0.3323-2.9038c-0.0724-0.63243,0.0238-1.1233,0.28857-1.4727,0.26476-0.34935,0.67479-0.5558,1.2301-0.61935,0.57074-0.0653,1.0364,0.0553,1.3971,0.36169,0.36064,0.30644,0.58127,0.81187,0.66188,1.5163l0.10944,0.95637,2.0978-0.24007,0.2008,1.7546zm2.2094-2.0304-0.049-0.42806c-0.0385-0.33678-0.1241-0.56661-0.25667-0.68948-0.13256-0.12287-0.29011-0.17386-0.47265-0.15298-0.17739,0.0203-0.32102,0.0967-0.43089,0.22903-0.10986,0.13238-0.14612,0.36183-0.10876,0.68833l0.0569,0.49746z'/%3E %3Cpath d='m266.98,160.38,0.18811-1.7443,3.3729,0.36373c0.33446,0.0361,0.64465,0.12223,0.93056,0.25847,0.28592,0.13625,0.52815,0.32764,0.72669,0.57418s0.32966,0.49688,0.39335,0.75099c0.0894,0.3532,0.10849,0.76778,0.0572,1.2437-0.0297,0.27528-0.0814,0.57357-0.15507,0.89486-0.0737,0.32129-0.17957,0.58511-0.31764,0.79144-0.13807,0.20634-0.32237,0.38882-0.55289,0.54745-0.23053,0.15863-0.46131,0.25932-0.69235,0.30207-0.37184,0.0692-0.69669,0.0888-0.97455,0.0589l-3.3729-0.36374,0.18811-1.7443,3.4539,0.37248c0.30873,0.0333,0.55915-0.0262,0.75126-0.1786,0.19211-0.15236,0.30454-0.38033,0.33727-0.68392,0.0325-0.301-0.0276-0.54628-0.18026-0.73582-0.15263-0.18954-0.38589-0.30123-0.69977-0.33508z'/%3E %3Cpath d='m267.74,156.21,1.0861-3.1072c0.18101-0.51785,0.44822-0.87058,0.80162-1.0582,0.3534-0.18759,0.71941-0.21522,1.098-0.0829,0.31756,0.111,0.55534,0.30514,0.71335,0.5824,0.10535,0.18485,0.15759,0.41967,0.15673,0.70444,0.22773-0.3535,0.48638-0.58175,0.77594-0.68476,0.28956-0.103,0.60534-0.0947,0.94732,0.0248,0.27847,0.0973,0.50623,0.2496,0.68326,0.45675,0.17704,0.20718,0.29101,0.44575,0.34192,0.71573,0.0319,0.16742,0.0171,0.39799-0.0444,0.6917-0.0818,0.39082-0.14402,0.6473-0.18672,0.76943l-1.0016,2.8653zm2.6922-0.93805,0.25231-0.72183c0.0905-0.25893,0.1089-0.45466,0.0552-0.58721-0.0537-0.13253-0.16486-0.22826-0.33341-0.28718-0.15633-0.0546-0.29619-0.0466-0.41956,0.024s-0.22903,0.23176-0.31698,0.48335l-0.25615,0.73282zm2.1105,0.73772,0.29586-0.84641c0.0999-0.2858,0.11965-0.50504,0.0593-0.65773-0.0604-0.15268-0.17608-0.25891-0.34708-0.31868-0.15877-0.0555-0.30668-0.0421-0.44373,0.0402s-0.25637,0.2688-0.35798,0.55948l-0.29458,0.84275z'/%3E %3Cpath d='m270.43,149.37,0.90849-1.5054,3.6722,2.2161,1.4179-2.3495,1.1997,0.72398-2.3264,3.855z'/%3E %3Cpath d='m273.87,144.16,1.1282-1.3537,4.3712,3.643-1.1282,1.3537z'/%3E %3Cpath d='m281.52,141.22,1.4723-0.65101c0.20313,0.39522,0.31475,0.77525,0.33485,1.1401,0.0201,0.36486-0.0469,0.71073-0.20101,1.0376-0.15411,0.32689-0.42448,0.65645-0.81111,0.98868-0.46907,0.40307-0.91088,0.66415-1.3254,0.78324-0.41455,0.1191-0.87733,0.0997-1.3884-0.0583-0.51102-0.15794-0.99673-0.50481-1.4571-1.0406-0.61387-0.71439-0.89577-1.4266-0.84571-2.1366,0.0501-0.71001,0.42249-1.3635,1.1172-1.9605,0.54365-0.46714,1.0654-0.72446,1.5654-0.77195,0.49996-0.0475,1.0211,0.0915,1.5635,0.41697l-0.95243,1.2739c-0.1542-0.0961-0.28002-0.15514-0.37744-0.1772-0.16227-0.038-0.32099-0.038-0.47616-0.00025-0.15516,0.0378-0.29947,0.11405-0.43293,0.22872-0.30224,0.25972-0.42927,0.5804-0.38109,0.96205,0.0335,0.28513,0.21632,0.62101,0.54856,1.0076,0.41149,0.47888,0.76617,0.74473,1.064,0.79755,0.29785,0.0528,0.57828-0.0338,0.84127-0.25975,0.25514-0.21924,0.38641-0.45657,0.39382-0.71199,0.007-0.25542-0.0767-0.54483-0.25221-0.86823z'/%3E %3Cpath d='m287.58,139.04-1.7674,0.94226,0.19872,0.95853-1.5858,0.84547-0.78977-6.0274,1.692-0.90208,4.5643,4.0151-1.6235,0.86556zm-0.90425-0.91228-1.5172-1.5092,0.41089,2.099z'/%3E %3Cpath d='m292.05,132.3,2.5741-0.44458c0.50743-0.0876,0.92922-0.0896,1.2654-0.006,0.33614,0.0838,0.62845,0.23678,0.87693,0.45908,0.24847,0.22232,0.44811,0.49639,0.59892,0.82222,0.15081,0.32584,0.25924,0.68,0.32531,1.0625,0.10349,0.59923,0.11554,1.0757,0.0362,1.4295-0.0794,0.35377-0.22095,0.66314-0.42465,0.92809-0.20371,0.26496-0.43815,0.45841-0.70331,0.58036-0.36233,0.16762-0.69776,0.27807-1.0063,0.33136l-2.5741,0.44458zm1.952,0.97061,0.52914,3.0637,0.42456-0.0733c0.36208-0.0625,0.61269-0.14717,0.75181-0.25392s0.23474-0.26769,0.28687-0.48283c0.0521-0.21514,0.0394-0.54711-0.0381-0.99589-0.10262-0.59413-0.26976-0.98411-0.50142-1.1699-0.23167-0.18582-0.5719-0.23998-1.0207-0.16247z'/%3E %3Cpath d='m299.36,131.32,4.7078,0.2013-0.0519,1.2138-2.9472-0.12602-0.0386,0.90356,2.734,0.11691-0.0496,1.1595-2.734-0.11691-0.0479,1.1207,3.0326,0.12967-0.055,1.2875-4.7932-0.20495z'/%3E %3Cpath d='m306.21,131.86,1.7079,0.41801-1.0197,4.1661,2.6655,0.6524-0.33312,1.361-4.3734-1.0704z'/%3E %3Cpath d='m315.34,134.89,2.516,1.4873c0.54797,0.32393,0.88136,0.69687,1.0002,1.1188,0.1188,0.42194,0.036,0.87348-0.24843,1.3546-0.29234,0.49452-0.6695,0.7931-1.1315,0.89575-0.46199,0.10265-0.99815-0.0264-1.6085-0.38723l-0.82865-0.48985-1.0745,1.8177-1.5203-0.89873zm0.2858,2.9871,0.37089,0.21925c0.2918,0.1725,0.52669,0.24297,0.70467,0.21141,0.17798-0.0316,0.31371-0.12642,0.40721-0.28458,0.0909-0.1537,0.11665-0.3143,0.0774-0.4818-0.0393-0.16749-0.20035-0.33486-0.48325-0.5021l-0.43103-0.2548z'/%3E %3Cpath d='m320.56,144.51-1.4666-1.364-0.8415,0.50015-1.316-1.2239,5.4413-2.7102,1.4041,1.3058-2.3091,5.6233-1.3472-1.253zm0.56794-1.1521,0.93263-1.9261-1.8507,1.0723z'/%3E %3Cpath d='m321.81,147.14,4.692-3.2194,1.658,2.4164c0.30744,0.44807,0.504,0.81689,0.5897,1.1064,0.0857,0.28955,0.0743,0.57824-0.0342,0.86607-0.10849,0.28783-0.31209,0.53423-0.6108,0.73919-0.26032,0.17861-0.52295,0.27722-0.78791,0.29583-0.26497,0.0186-0.52274-0.0289-0.77331-0.14255-0.1596-0.0725-0.33786-0.19969-0.5348-0.38152,0.061,0.21236,0.0897,0.37777,0.0863,0.49625-0.002,0.0797-0.0309,0.2134-0.0872,0.40113-0.0564,0.18773-0.10695,0.32208-0.1518,0.40308l-0.87931,1.6342-1.1244-1.6387,0.90241-1.7584c0.11829-0.22552,0.17882-0.39572,0.18159-0.5106,0.00081-0.15433-0.0442-0.29763-0.13493-0.42992l-0.0878-0.12802-1.9043,1.3066zm3.7901-0.45867,0.41944,0.61131c0.0454,0.0661,0.15455,0.17952,0.32753,0.34014,0.0851,0.0828,0.18796,0.12758,0.30863,0.13423,0.12067,0.007,0.23221-0.0252,0.33464-0.0954,0.15148-0.10394,0.23483-0.23174,0.25004-0.38339,0.0152-0.15165-0.068-0.35976-0.24951-0.62434l-0.437-0.63691z'/%3E %3Cpath d='m327.36,155.2-0.74229-1.8602-0.97457,0.0922-0.66605-1.6692,6.0777-0.12252,0.71065,1.7809-4.4924,4.0953-0.68188-1.7088zm1.0062-0.7985,1.6668-1.3421-2.1315,0.1777z'/%3E %3Cpath d='m329.85,160.62,1.1708-0.17519,0.40208,2.6871-2.3992,0.359c-0.42757-0.46194-0.73428-0.88112-0.92012-1.2576-0.18585-0.37645-0.31936-0.83594-0.40054-1.3785-0.0999-0.66794-0.0675-1.2294,0.0973-1.6845,0.16477-0.45507,0.45504-0.8321,0.8708-1.1311,0.41575-0.299,0.91538-0.49216,1.4989-0.57947,0.6142-0.0919,1.1674-0.0452,1.6596,0.14023,0.49216,0.18539,0.89253,0.50487,1.2011,0.95844,0.23876,0.35413,0.40638,0.85365,0.50289,1.4986,0.093,0.62188,0.10634,1.0954,0.0399,1.4207-0.0665,0.32522-0.20284,0.60727-0.40911,0.84615-0.20629,0.23888-0.48347,0.43668-0.83156,0.59343l-0.55043-1.6327c0.20207-0.10089,0.34706-0.24229,0.43497-0.4242,0.0879-0.18192,0.1127-0.40083,0.0744-0.65675-0.0571-0.38132-0.23497-0.6654-0.53373-0.85225-0.29877-0.18686-0.73477-0.2374-1.308-0.15162-0.60908,0.0911-1.027,0.27076-1.2538,0.53886-0.22676,0.26811-0.30951,0.60689-0.24824,1.0164,0.0291,0.1945,0.085,0.37583,0.16774,0.54399,0.0827,0.16815,0.20894,0.35597,0.37866,0.56344l0.52975-0.0793z'/%3E %3Cpath d='m333.57,168.88-0.15576,1.7475-3.379-0.30119c-0.33507-0.0299-0.6468-0.11026-0.93519-0.24118-0.28839-0.13093-0.53412-0.3178-0.7372-0.56061-0.20307-0.24283-0.3388-0.49069-0.40719-0.74358-0.096-0.35149-0.1227-0.76564-0.0802-1.2425,0.0246-0.27579,0.0707-0.57499,0.13846-0.89759,0.0677-0.3226,0.16869-0.58833,0.30292-0.79719,0.13422-0.20886,0.31511-0.39472,0.54265-0.55759,0.22755-0.16288,0.45643-0.26782,0.68664-0.31485,0.37049-0.0761,0.69492-0.10173,0.97328-0.0769l3.379,0.30119-0.15576,1.7475-3.4602-0.30842c-0.30929-0.0276-0.55857,0.0366-0.74782,0.19248-0.18926,0.15589-0.29744,0.38591-0.32455,0.69005-0.0269,0.30156,0.0378,0.54568,0.19387,0.73236,0.15612,0.18667,0.39141,0.29402,0.70586,0.32206z'/%3E %3Cpath d='m327.28,174.9,0.62561-1.9026-0.80624-0.5552,0.56134-1.7072,4.7375,3.8091-0.59893,1.8215-6.0736,0.2543,0.57468-1.7478zm1.284,0.034,2.1396,0.0416-1.748-1.2326z'/%3E %3Cpath d='m330.6,179.56-1.0037,1.6746-2.2386-0.002,1.0574,1.9732-0.9977,1.6647-1.6992-3.5978-2.0442-1.2252,0.90591-1.5115,2.0442,1.2252z'/%3E %3C/g%3E %3Cg fill='%23009b3a' stroke='%23000' stroke-width='0.1'%3E %3Cpath d='m305.58,145.3s16.052,6.9159,13.249,21.207-11.74,14.195-15.244,15.775c-3.5043,1.5793-5.9218,3.8396-7.3046,3.5235-1.3827-0.31613-3.2104-1.3832-3.2104-1.3832s-0.14627,2.3471,2.6684,2.7742,6.5145-3.7042,8.2916-4.1636c1.7771-0.45933,12.688-1.6436,15.343-16.185,3.0983-15.522-13.693-21.092-13.792-21.548z'/%3E %3Cpath d='m313.68,148.34a2.2037,0.52177,75.104,0,1,-1.0572,0.0811,2.2037,0.52177,75.104,1,1,1.0572,-0.0811z'/%3E %3Cpath d='m313.13,148.49a2.2707,0.50636,63.335,1,1,-0.95726,0.34968,2.2707,0.50636,63.335,0,1,0.95726,-0.34968z'/%3E %3Cpath d='m311.52,149.55a2.1502,0.53476,17.053,0,1,-0.10032,1.0864,2.1502,0.53476,17.053,0,1,0.10032,-1.0864z'/%3E %3Cpath d='m311.76,148.96a2.2609,0.50857,34.225,1,1,-0.46166,0.91557,2.2609,0.50857,34.225,1,1,0.46166,-0.91557z'/%3E %3Cpath d='m312.44,148.68a2.299,0.50014,46.194,1,1,-0.6989,0.71633,2.299,0.50014,46.194,0,1,0.6989,-0.71633z'/%3E %3Cpath d='m313.56,150.7c0.009,0.01-0.61928,0.34913-0.76157,0.39979-0.14231,0.0506-0.3352-0.18953-0.74445,0.0205-0.40924,0.21003-0.69016,0.59314-0.7795,0.81798-0.0893,0.22483,0.11595,0.31904,0.61058,0.0786,0.49463-0.24042,0.62481-0.62134,0.8633-0.77059,0.23847-0.14922,0.6385-0.36885,0.86618-0.44991,0.0986-0.21524,0.41874-0.67667,0.58423-0.94149,0.16549-0.2648,0.81483-0.70186,1.0512-1.2107,0.20634-0.42091,0.12886-0.77938-0.14731-0.6296-0.27617,0.14979-0.63323,0.57288-0.79951,0.87657-0.16629,0.30371-0.0235,0.69038-0.2082,0.97494-0.14547,0.2062-0.49727,0.83331-0.53495,0.83386z'/%3E %3Cpath d='m318.53,152.34a3.3048,0.7416,88.415,1,1,-1.491,-0.357,3.3048,0.7416,88.415,1,1,1.491,0.357z'/%3E %3Cpath d='m317.7,152.31a3.4427,0.71192,77.49,1,1,-1.4415,0.0724,3.4427,0.71192,77.49,1,1,1.4415,-0.0724z'/%3E %3Cpath d='m315.13,153.11a3.2071,0.7642,34.91,1,1,-0.4987,1.511,3.2071,0.7642,34.91,1,1,0.4987,-1.511z'/%3E %3Cpath d='m315.65,152.38a3.4298,0.71459,50.904,0,1,-0.94257,1.1046,3.4298,0.71459,50.904,1,1,0.94257,-1.1046z'/%3E %3Cpath d='m316.69,152.28a3.5036,0.69953,61.837,1,1,-1.2051,0.71311,3.5036,0.69953,61.837,1,1,1.2051,-0.71311z'/%3E %3Cpath d='m317.57,155.67c0.01,0.0178-0.97325,0.22286-1.1871,0.23175-0.21385,0.009-0.40144-0.42144-1.0378-0.30379-0.63631,0.11765-1.1522,0.54061-1.3504,0.82262-0.19818,0.28203,0.0549,0.50882,0.81953,0.38586,0.76463-0.12297,1.0711-0.61026,1.4508-0.71727,0.37968-0.107,1.0064-0.24252,1.3486-0.25671,0.20777-0.26415,0.80398-0.78171,1.1209-1.0869,0.31688-0.30518,1.3609-0.64054,1.8567-1.2634,0.42514-0.51046,0.43655-1.0585,0.005-0.9676-0.43208,0.0909-1.0667,0.53707-1.3975,0.89759-0.33087,0.36054-0.26112,0.97825-0.6112,1.3031-0.26974,0.23022-0.96462,0.97091-1.017,0.95483z'/%3E %3Cpath d='m321.14,159a0.73839,3.3192,8.7402,1,1,-1.3929,-0.63898,0.73839,3.3192,8.7402,1,1,1.3929,0.63898z'/%3E %3Cpath d='m320.35,158.8a3.4648,0.70737,87.95,1,1,-1.422,-0.20538,3.4648,0.70737,87.95,1,1,1.422,0.20538z'/%3E %3Cpath d='m317.69,159.1a3.2231,0.76041,46.026,1,1,-0.76003,1.3966,3.2231,0.76041,46.026,1,1,0.76003,-1.3966z'/%3E %3Cpath d='m318.33,158.48a3.4552,0.70935,61.791,1,1,-1.1206,0.90994,3.4552,0.70935,61.791,1,1,1.1206,-0.90994z'/%3E %3Cpath d='m319.35,158.58a3.5309,0.69413,72.543,1,1,-1.3065,0.47282,3.5309,0.69413,72.543,1,1,1.3065,-0.47282z'/%3E %3Cpath d='m319.61,162.09c0.006,0.0195-0.99148,0.0332-1.2021,0.00066-0.21062-0.0323-0.31635-0.49335-0.95952-0.49937-0.64317-0.006-1.2237,0.3126-1.4683,0.55307-0.24457,0.24047-0.0381,0.51308,0.73143,0.5385,0.76954,0.0255,1.157-0.39697,1.5474-0.42973,0.39042-0.0327,1.0274-0.0462,1.3644,0.005,0.25074-0.22097,0.92685-0.61761,1.2916-0.85817,0.36477-0.24055,1.4457-0.37122,2.0427-0.8912,0.50763-0.42249,0.61765-0.9616,0.17894-0.95479-0.43872,0.007-1.1395,0.32554-1.5279,0.61807-0.38843,0.29252-0.43169,0.916-0.83247,1.1696-0.30518,0.17556-1.118,0.77363-1.1663,0.74768'/%3E %3Cpath d='m321.34,166.42a0.73814,3.3203,31.311,0,1,-1.0129,-1.1684,0.73814,3.3203,31.311,0,1,1.0129,1.1684'/%3E %3Cpath d='m320.69,165.91a0.70283,3.4872,20.618,0,1,-1.2076,-0.77836,0.70283,3.4872,20.618,0,1,1.2076,0.77836'/%3E %3Cpath d='m318.17,165.09a3.2755,0.74824,69.934,0,1,-1.2303,0.98083,3.2755,0.74824,69.934,0,1,1.2303,-0.98083'/%3E %3Cpath d='m318.99,164.78a3.5112,0.69802,85.137,0,1,-1.3677,0.38052,3.5112,0.69802,85.137,1,1,1.3677,-0.38052'/%3E %3Cpath d='m319.88,165.3a0.68491,3.5784,5.5508,1,1,-1.3664,-0.10172,0.68491,3.5784,5.5508,1,1,1.3664,0.10172'/%3E %3Cpath d='m318.75,168.66c-0.002,0.0206-0.91045-0.37916-1.0886-0.4962-0.17812-0.11705-0.0948-0.58827-0.67475-0.85977-0.57992-0.2715-1.2292-0.21605-1.544-0.0942-0.31478,0.12187-0.23372,0.46002,0.45307,0.80175,0.68677,0.34174,1.2015,0.11022,1.5677,0.24126,0.36615,0.13105,0.94806,0.38192,1.2331,0.5692,0.31278-0.10125,1.0789-0.18952,1.5025-0.26178,0.42362-0.0722,1.4529,0.25346,2.1953,0.0181,0.62359-0.18191,0.93252-0.63634,0.53272-0.8114-0.39982-0.17507-1.158-0.16922-1.6232-0.0586-0.46522,0.11067-0.74646,0.67093-1.2077,0.74038-0.34444,0.0366-1.3125,0.25518-1.3461,0.21116'/%3E %3Cpath d='m319.34,173.95a0.86442,3.782,48.457,1,1,-0.73094,-1.6561,0.86442,3.782,48.457,1,1,0.73094,1.6561'/%3E %3Cpath d='m318.79,173.16a0.82109,3.9816,37.466,1,1,-1.0735,-1.296,0.82109,3.9816,37.466,1,1,1.0735,1.296'/%3E %3Cpath d='m316.29,171.34a3.8093,0.85822,86.522,1,1,-1.6766,0.63757,3.8093,0.85822,86.522,1,1,1.6766,-0.63757'/%3E %3Cpath d='m317.29,171.29a0.80649,4.0537,11.633,0,1,-1.6306,-0.0747,0.80649,4.0537,11.633,1,1,1.6306,0.0747'/%3E %3Cpath d='m318.1,172.18a0.79539,4.1102,22.119,1,1,-1.4706,-0.60655,0.79539,4.1102,22.119,1,1,1.4706,0.60655'/%3E %3Cpath d='m315.75,175.49c-0.009,0.022-0.87758-0.74786-1.0352-0.94149-0.15759-0.19362,0.089-0.68363-0.46017-1.1931-0.54912-0.50946-1.282-0.68314-1.6686-0.66249-0.38655,0.0207-0.40846,0.42323,0.23521,1.0489,0.64368,0.62564,1.2864,0.5563,1.6464,0.8334,0.35997,0.2771,0.91807,0.76453,1.1702,1.0743,0.37758,0.001,1.2499,0.18108,1.7399,0.25458,0.49005,0.0735,1.516,0.80535,2.4105,0.81412,0.74621,0.0248,1.2356-0.36504,0.85306-0.7029-0.38257-0.33788-1.219-0.60568-1.7675-0.6518-0.54847-0.0462-1.0422,0.47055-1.5728,0.38034-0.39119-0.0842-1.5286-0.19313-1.5511-0.25388'/%3E %3Cpath d='m314.17,180.54a0.96734,4.1698,79.752,1,1,0.19909,-1.9977,0.96734,4.1698,79.752,1,1,-0.19909,1.9977'/%3E %3Cpath d='m314.09,179.47a0.92321,4.3692,68.504,0,1,-0.32819,-1.8534,0.92321,4.3692,68.504,0,1,0.32819,1.8534'/%3E %3Cpath d='m312.66,176.29a0.96428,4.1831,26.238,0,1,-1.9665,-0.36332,0.96428,4.1831,26.238,1,1,1.9665,0.36332'/%3E %3Cpath d='m313.66,176.83a0.90974,4.4339,41.823,0,1,-1.533,-1.0142,0.90974,4.4339,41.823,0,1,1.533,1.0142'/%3E %3Cpath d='m313.95,178.15a0.89742,4.4948,52.671,1,1,-1.0881,-1.4274,0.89742,4.4948,52.671,0,1,1.0881,1.4274'/%3E %3Cpath d='m309.87,179.93c-0.0207,0.0157-0.43852-1.2188-0.48489-1.4941-0.0464-0.27531,0.45926-0.59874,0.20755-1.4008-0.25172-0.8021-0.86427-1.3912-1.2486-1.5951-0.38437-0.20393-0.6254,0.16627-0.34588,1.1336,0.27952,0.96728,0.9377,1.273,1.1338,1.7448,0.19607,0.47173,0.4685,1.2581,0.54266,1.6986,0.36367,0.2197,1.1074,0.89507,1.5403,1.2484,0.43283,0.35332,1.0233,1.6427,1.8819,2.1684,0.70667,0.45515,1.392,0.36743,1.2073-0.17513-0.18469-0.54259-0.84572-1.281-1.3499-1.6421-0.50418-0.36109-1.2629-0.15524-1.7257-0.54789-0.33158-0.3063-1.3698-1.0677-1.3584-1.1386'/%3E %3Cpath d='m307.4,184.24a1.2121,4.2194,89.068,0,1,0.007,-2.4245,1.2121,4.2194,89.068,0,1,-0.007,2.4245'/%3E %3Cpath d='m306.84,180.45a1.1714,4.3658,37.587,0,1,-1.7986,-1.5041,1.1714,4.3658,37.587,1,1,1.7986,1.5041'/%3E %3Cpath d='m307.43,182.38a1.1973,4.2713,66.472,0,1,-0.8567,-2.2386,1.1973,4.2713,66.472,0,1,0.8567,2.2386'/%3E %3Cpath d='m308.58,145.66a2.6209,0.53282,41.126,0,1,-0.99489,0.54201,2.6209,0.53282,41.126,1,1,0.99489,-0.54201'/%3E %3Cpath d='m307.29,146.75a2.6543,0.52611,8.1634,0,1,0.202,1.0896,2.6543,0.52611,8.1634,1,1,-0.202,-1.0896'/%3E %3Cpath d='m307.81,146.06a2.776,0.50303,26.817,1,1,-0.52645,0.86106,2.776,0.50303,26.817,0,1,0.52645,-0.86106'/%3E %3Cpath d='m288.79,180.13s3.5359,0.75834,6.6097,1.8755c3.0739,1.1172,7.7443,4.9517,8.9996,5.1689,1.4081,0.0641,3.3608-0.41654,4.1019-2.4496-2.1685,0.57838-3.4689,1.457-5.539,0.31964-0.73141-0.27703-3.1265-2.4578-5.752-3.625s-7.9208-2.4978-7.9208-2.4978l-0.49937,1.2083'/%3E %3Cpath d='m292.56,148.16c-0.0127-0.0303,4.0701-2.1474,4.0701-2.1474l-4.4882,1.1477-0.52144,0.78964,0.93955,0.21005'/%3E %3Cpath d='m296.42,149.15c-1.5758-0.28645-3.9992-0.81633-5.5421-0.9399,1.0665-1.1813,2.536-3.1789,3.4417-4.4051-0.59804,1.1695-1.5368,2.7117-1.9073,3.8312,1.0862,0.5863,2.7936,1.0454,4.0078,1.5138'/%3E %3Cpath d='m291.83,148.41c-0.0177-0.0279,3.6168-2.8004,3.6168-2.8004l-4.2006,1.8792-0.37387,0.86847,0.95766,0.0527'/%3E %3Cpath d='m295.69,149.11c-1.5867-0.30167-4.0287-0.85794-5.5794-0.99119,1.0478-1.2168,2.4844-3.2756,3.3699-4.5394-0.57788,1.2063-1.4906,2.7965-1.8411,3.952,1.1012,0.60975,2.8232,1.0903,4.0506,1.5786'/%3E %3Cpath d='m291.23,148.64c-0.01-0.0311,4.2591-1.7838,4.2591-1.7838l-4.5864,0.75479-0.59212,0.73968,0.91942,0.28937'/%3E %3Cpath d='m295.21,149.15c-1.6049-0.13379-4.0856-0.43321-5.635-0.39973,0.89323-1.351,2.0721-3.6004,2.7993-4.9815-0.42971,1.2892-1.1454,3.0051-1.3563,4.2178,1.1608,0.49985,2.9206,0.80072,4.192,1.1634'/%3E %3Cpath d='m290.79,148.66c-0.0233-0.0237,2.8854-3.5159,2.8854-3.5159l-3.6561,2.7338-0.16967,0.93251,0.9404-0.1504'/%3E %3Cpath d='m295.19,149.38c-1.7196-0.0327-4.3869-0.18429-6.0307-0.0383,0.81363-1.5376,1.8405-4.0759,2.4746-5.6347-0.32708,1.4374-0.91528,3.3608-1.0174,4.6992,1.2844,0.46358,3.1854,0.66769,4.5735,0.97377'/%3E %3Cpath d='m290.21,149.49c-0.0223-0.0308,3.5039-3.3619,3.5039-3.3619l-4.2398,2.3458-0.29039,1.0048,1.0262,0.0113'/%3E %3Cpath d='m294.42,149.49c-1.848,0.007-4.6936-0.0933-6.4968,0.10867,1.1962-1.7142,2.8298-4.536,3.8367-6.269-0.65065,1.5916-1.6836,3.725-2.0711,5.2021,1.2892,0.47854,3.2974,0.65581,4.7312,0.95826'/%3E %3Cpath d='m289.03,149.74c-0.0176-0.0333,4.476-3.7911,4.476-3.7911l-5.0591,2.6902-0.52142,1.1141,1.1046-0.0132'/%3E %3Cpath d='m293.75,149.6c-1.83,0.26391-4.6638,0.56204-6.4216,1.0097,0.93966-1.8374,2.154-4.8155,2.9034-6.6449-0.41668,1.6421-1.1346,3.8655-1.3069,5.3593,1.346,0.28713,3.3611,0.18057,4.8251,0.27594'/%3E %3Cpath d='m288.43,150.49c-0.0259-0.0268,3.4487-4.7769,3.4487-4.7769l-4.3038,3.8915-0.23064,1.1922,1.0858-0.3068'/%3E %3Cpath d='m292.74,150.17c-1.8426,0.17159-4.6899,0.32693-6.4707,0.68564,1.0418-1.7872,2.4221-4.6995,3.2735-6.4883-0.50848,1.6185-1.3505,3.8022-1.6066,5.2848,1.3282,0.35426,3.347,0.34906,4.8038,0.51778'/%3E %3Cpath d='m287.81,150.99c-0.0179-0.0338,4.3902-3.7991,4.3902-3.7991l-4.981,2.6844-0.50347,1.1213,1.0943-0.007'/%3E %3Cpath d='m292.2,150.36c-1.837,0.38744-4.6873,0.87846-6.4421,1.442,0.85827-1.8764,1.9372-4.8962,2.6036-6.7515-0.33926,1.6475-0.95401,3.8889-1.0536,5.3732,1.3752,0.18936,3.4073-0.0559,4.8922-0.0637'/%3E %3Cpath d='m287.08,151.19c-0.03-0.0213,2.8045-5.2073,2.8045-5.2073l-3.7959,4.5028-0.0628,1.1897,1.0542-0.48522'/%3E %3Cpath d='m292.2,150.66c-1.9709,0.51269-5.0424,1.1852-6.9015,1.891,0.71391-2.1333,1.5308-5.5533,2.0364-7.6546-0.17164,1.855-0.57348,4.3854-0.5018,6.0476,1.534,0.1517,3.7366-0.21064,5.367-0.28402'/%3E %3Cpath d='m286.53,152.39c-0.0298-0.0303,3.5334-5.2185,3.5334-5.2185l-4.5179,4.2179-0.1906,1.3165,1.1751-0.31589'/%3E %3Cpath d='m291.42,151.25c-1.9374,0.61271-4.9624,1.4426-6.7795,2.2401,0.61082-2.1464,1.264-5.5698,1.669-7.6734-0.0842,1.8422-0.36592,4.3642-0.21696,6.0029,1.5335,0.0673,3.7084-0.40931,5.3275-0.56959'/%3E %3Cpath d='m285.82,153.16c-0.0343-0.0242,2.6855-5.7607,2.6855-5.7607l-3.8184,4.9613,0.0173,1.3246,1.1156-0.52521'/%3E %3Cpath d='m290.68,152.04c-1.9847,0.45234-5.0722,1.0322-6.9539,1.6786,0.80306-2.0896,1.7642-5.4488,2.3585-7.5126-0.25108,1.8295-0.76055,4.3205-0.76099,5.9662,1.5208,0.19251,3.7297-0.10474,5.3564-0.13211'/%3E %3Cpath d='m285.18,153.71c-0.0238-0.0354,4.3881-4.5082,4.3881-4.5082l-5.173,3.338-0.42128,1.2662,1.2062-0.0961'/%3E %3Cpath d='m289.8,152.82c-1.966,0.26388-5.0168,0.54834-6.8942,1.02,0.91275-2.0472,2.058-5.3709,2.7652-7.4125-0.3577,1.8371-1.0084,4.3219-1.1101,5.9967,1.4734,0.34649,3.6488,0.26266,5.239,0.39584'/%3E %3Cpath d='m284.31,153.26c-0.0323-0.0271,2.9857-5.6409,2.9857-5.6409l-4.0499,4.7466-0.0631,1.3441,1.1273-0.44976'/%3E %3Cpath d='m290.04,152.15c-2.1381,0.87557-5.4778,2.0958-7.4812,3.1751,0.65695-2.5384,1.3495-6.5596,1.7791-9.0308-0.077,2.141-0.36647,5.0863-0.18727,6.9715,1.6973-0.0533,4.0995-0.7916,5.8893-1.1159'/%3E %3Cpath d='m283.9,154.97c-0.0346-0.0302,3.5737-6.4733,3.5737-6.4733l-4.7176,5.4774-0.13032,1.5296,1.2742-0.53369'/%3E %3Cpath d='m289.22,152.95c-2.0951,0.9847-5.3742,2.3775-7.3258,3.5553,0.5427-2.5381,1.0549-6.539,1.3737-8.998,0.0186,2.1135-0.13932,5.0315,0.1235,6.8784,1.6918-0.14952,4.0566-1.014,5.8286-1.4358'/%3E %3Cpath d='m283.17,155.95c-0.0392-0.0225,2.6078-6.9665,2.6078-6.9665l-3.9029,6.222,0.099,1.5082,1.1961-0.76364'/%3E %3Cpath d='m288.3,153.53c-2.0902,1.0013-5.3626,2.4201-7.3079,3.6131,0.5268-2.5408,1.0138-6.543,1.317-9.0029,0.0321,2.1119-0.10721,5.0291,0.1676,6.8726,1.6919-0.16336,4.0527-1.0468,5.8233-1.4828'/%3E %3Cpath d='m282.58,156.78c-0.0319-0.0338,4.0345-6.1433,4.0345-6.1433l-5.0869,5.0282-0.24792,1.5233,1.3003-0.40818'/%3E %3Cpath d='m288.11,153.21c-1.8636,1.4877-4.8118,3.6746-6.4923,5.3092-0.003-2.5647-0.34635-6.5176-0.55367-8.9482,0.46762,2.0126,0.93175,4.8392,1.5844,6.5336,1.642-0.58507,3.7979-2.0286,5.4615-2.8945'/%3E %3Cpath d='m282.78,157.07c-0.0447-0.006,0.46739-7.3613,0.46739-7.3613l-1.9438,7.1568,0.54238,1.3482,0.934-1.1436'/%3E %3Cpath d='m287.58,153.89c-1.869,1.4782-4.8251,3.6499-6.5118,5.2759,0.008-2.5657-0.3191-6.522-0.51623-8.9546,0.45907,2.0159,0.91126,4.8461,1.5566,6.5446,1.6438-0.57637,3.8048-2.0088,5.4714-2.866'/%3E %3Cpath d='m282.31,158.32c-0.0416-0.0175,1.8801-7.1926,1.8801-7.1926l-3.2533,6.6145,0.2567,1.4768,1.1165-0.89863'/%3E %3Cpath d='m287.37,154.06c-1.7662,1.74-4.5782,4.3217-6.1396,6.1914-0.27684-2.6316-1.0544-6.6488-1.5284-9.1194,0.6982,2.0118,1.4798,4.8594,2.3351,6.5234,1.6338-0.78834,3.7067-2.5165,5.3328-3.5955'/%3E %3Cpath d='m282.32,159.24c-0.0462-0.007,0.35192-7.6498,0.35192-7.6498l-1.8789,7.4327,0.58349,1.4029,0.94347-1.1858'/%3E %3Cpath d='m286.81,155.33c-1.8902,1.5628-4.8841,3.862-6.5822,5.5756-0.0591-2.665-0.50061-6.7694-0.76796-9.2932,0.52674,2.0871,1.0678,5.0201,1.7784,6.7748,1.6814-0.62281,3.8742-2.1423,5.5718-3.0572'/%3E %3Cpath d='m281.76,160.11c-0.0403-0.0248,2.6632-7.1952,2.6632-7.1952l-3.9937,6.3751,0.10446,1.5793,1.226-0.75915'/%3E %3Cpath d='m286.78,155.36c-1.6729,1.7696-4.3365,4.3957-5.8152,6.2962-0.2642-2.6676-1.004-6.7388-1.4549-9.2426,0.66316,2.038,1.406,4.9231,2.2178,6.6079,1.5481-0.80419,3.5117-2.5626,5.0523-3.6616'/%3E %3Cpath d='m281.86,160.48c-0.0468-0.00066-0.31503-7.607-0.31503-7.607l-1.2318,7.5764,0.70623,1.3169,0.84065-1.2864'/%3E %3Cpath d='m285.96,155.93c-1.6186,1.7855-4.2014,4.4366-5.6223,6.3515-0.34233-2.6683-1.2009-6.7377-1.7249-9.2404,0.72226,2.0346,1.549,4.9167,2.4093,6.5966,1.5223-0.81796,3.4317-2.5947,4.9379-3.7076'/%3E %3Cpath d='m281.43,161.24c-0.0429-0.0127,0.84948-7.7276,0.84948-7.7276l-2.2658,7.3094,0.45158,1.5011,0.96479-1.0828'/%3E %3Cpath d='m285.61,156.23c-1.4798,1.9335-3.8561,4.822-5.1287,6.865-0.54421-2.6206-1.71-6.5845-2.4229-9.0227,0.87524,1.9534,1.919,4.7394,2.9052,6.3264,1.4572-0.96185,3.2278-2.915,4.6464-4.1687'/%3E %3Cpath d='m281.4,161.96c-0.0443-0.002-0.49032-7.737-0.49032-7.737l-0.97414,7.6757,0.70154,1.3522,0.76292-1.2909'/%3E %3Cpath d='m285.46,156.67c-1.3891,2.0246-3.6307,5.0578-4.806,7.1817-0.67929-2.6103-2.051-6.5406-2.8906-8.9584,0.97816,1.921,2.1678,4.6717,3.2389,6.218,1.4155-1.045,3.0957-3.1045,4.4578-4.4413'/%3E %3Cpath d='m281.88,162.68c-0.0433-0.0142,0.78724-7.7718,0.78724-7.7718l-2.2149,7.3052,0.46702,1.529,0.96068-1.0624'/%3E %3Cpath d='m285.18,157.39c-1.1974,2.206-3.1506,5.5334-4.1267,7.8084-0.90975-2.5008-2.6261-6.2176-3.6778-8.5047,1.1445,1.7739,2.5738,4.3433,3.7769,5.7318,1.3118-1.2357,2.7952-3.517,4.0276-5.0355'/%3E %3Cpath d='m281.61,163.32c-0.0435,0.0121-2.172-7.3702-2.172-7.3702l0.73403,7.7686,0.97861,1.0955,0.45931-1.4939'/%3E %3Cpath d='m285.13,158.25c-1.2476,2.1993-3.2806,5.5166-4.3014,7.7848-0.91524-2.4932-2.6498-6.1988-3.7125-8.479,1.1622,1.7686,2.6107,4.3302,3.836,5.7144,1.3575-1.232,2.8996-3.5064,4.1778-5.0202'/%3E %3Cpath d='m281.71,164.71c-0.0459,0.00002-0.79743-7.7496-0.79743-7.7496l-0.71779,7.7504,0.77557,1.3281,0.73965-1.329'/%3E %3Cpath d='m285.26,158.93c-1.2828,2.1698-3.3689,5.4389-4.4262,7.6828-0.87461-2.5145-2.5487-6.2606-3.5741-8.5656,1.1332,1.7957,2.5398,4.3912,3.7424,5.8042,1.3771-1.1999,2.9555-3.4378,4.2579-4.9214'/%3E %3Cpath d='m281.64,165.33c-0.0457,0.005-1.438-7.6104-1.438-7.6104l-0.0703,7.7943,0.88248,1.2271,0.62581-1.411'/%3E %3Cpath d='m284.71,160.03c-1.3837,2.078-3.6216,5.1981-4.7836,7.3658-0.7531-2.5716-2.2454-6.4286-3.1591-8.8014,1.0454,1.8718,2.3257,4.5611,3.4586,6.0554,1.4316-1.1029,3.1136-3.2284,4.4842-4.6198'/%3E %3Cpath d='m280.97,166.18c-0.0447-0.0122,0.64352-7.779,0.64352-7.779l-2.1198,7.3762,0.51212,1.5034,0.96413-1.1006'/%3E %3Cpath d='m284.79,160.22c-1.1829,2.2504-3.1184,5.6512-4.0726,7.9608-0.98749-2.4525-2.8292-6.0817-3.9579-8.315,1.2132,1.7179,2.7357,4.2162,4.0008,5.5474,1.321-1.2885,2.7961-3.6264,4.0297-5.1932'/%3E %3Cpath d='m280.71,166.83c-0.0445,0.0139-2.3872-7.25-2.3872-7.25l0.91887,7.7096,1.0284,1.0491,0.44002-1.5087'/%3E %3Cpath d='m284.47,160.8c-0.82599,2.4697-2.2198,6.234-2.8118,8.7118-1.3408-2.1938-3.6994-5.3571-5.1462-7.3047,1.4525,1.4228,3.3268,3.5446,4.7723,4.5761,1.1066-1.5547,2.207-4.1742,3.1857-5.9832'/%3E %3Cpath d='m282.83,167.42c-0.0441,0.0157-2.5849-7.1499-2.5849-7.1499l1.1296,7.6676,1.0567,1.0074,0.39853-1.5251'/%3E %3Cpath d='m284.45,161.56c-0.80817,2.4781-2.1748,6.2568-2.7489,8.7406-1.3566-2.1795-3.7381-5.3178-5.199-7.2501,1.4628,1.4074,3.3524,3.5094,4.8054,4.5256,1.0954-1.5662,2.1769-4.197,3.1425-6.0161'/%3E %3Cpath d='m282.85,168.64c-0.0421,0.0224-3.3258-6.6866-3.3258-6.6866l1.9368,7.4247,1.1558,0.83503,0.23325-1.5732'/%3E %3Cpath d='m284.2,162.18c-0.5167,2.5726-1.4378,6.5146-1.7217,9.0594-1.5966-1.9663-4.3201-4.7362-5.9916-6.4424,1.613,1.1856,3.7295,2.9986,5.2878,3.7978,0.90653-1.7097,1.6769-4.4729,2.4255-6.4148'/%3E %3Cpath d='m283.07,169.69c-0.0454,0.009-1.7934-7.4979-1.7934-7.4979l0.29571,7.7844,0.9389,1.1646,0.55876-1.451'/%3E %3Cpath d='m284.21,162.98c-0.27334,2.6303-0.82051,6.6781-0.86543,9.2492-1.7668-1.7422-4.7264-4.1325-6.5433-5.6057,1.7105,0.96289,3.9788,2.4825,5.5991,3.0682,0.74032-1.8239,1.2476-4.678,1.8097-6.7117'/%3E %3Cpath d='m283.16,170.24c-0.0354,0.0346-4.7406-5.413-4.7406-5.413l3.5722,6.556,1.3053,0.44601-0.1369-1.589'/%3E %3Cpath d='m284.31,163.9c-0.2837,2.6285-0.84683,6.6728-0.90187,9.2435-1.76-1.7521-4.7104-4.1591-6.5216-5.6425,1.7068,0.97255,3.9692,2.505,5.5873,3.0998,0.74754-1.8195,1.266-4.6705,1.8362-6.7008'/%3E %3Cpath d='m283.69,171.49c-0.041,0.0242-3.6411-6.525-3.6411-6.525l2.2874,7.3243,1.195,0.78156,0.15873-1.5808'/%3E %3Cpath d='m284.52,164.98c-0.17301,2.6443-0.56557,6.7207-0.5128,9.2934-1.8299-1.6444-4.8751-3.8712-6.7449-5.244,1.7442,0.8685,4.0662,2.2628,5.7059,2.7592,0.66981-1.8639,1.0678-4.7448,1.5518-6.8086'/%3E %3Cpath d='m284.15,172.69c-0.0369,0.0323-4.4987-5.7041-4.4987-5.7041l3.2806,6.7699,1.2848,0.52845-0.0667-1.5943'/%3E %3Cpath d='m284.57,166.2c-0.15709,2.646-0.52509,6.7261-0.45686,9.2986-1.8395-1.6286-4.8978-3.829-6.7755-5.1857,1.7491,0.8534,4.0793,2.2276,5.7218,2.7098,0.65851-1.8699,1.0392-4.7545,1.5106-6.8227'/%3E %3Cpath d='m284.56,173.66c-0.0427,0.0197-3.1543-6.877-3.1543-6.877l1.7456,7.5287,1.1347,0.90411,0.274-1.5558'/%3E %3Cpath d='m284.69,166.99c0.0903,2.655,0.10463,6.7657,0.41156,9.317-1.9764-1.3734-5.215-3.1518-7.2041-4.2492,1.8146,0.6139,4.2541,1.668,5.9284,1.9268,0.4794-1.9499,0.58873-4.8724,0.86412-6.9945'/%3E %3Cpath d='m285.11,173.39c-0.0266,0.0435-5.7616-3.9448-5.7616-3.9448l4.8844,5.3824,1.3575,0.0701-0.4804-1.5077'/%3E %3Cpath d='m284.87,167.27c0.22922,2.6428,0.45861,6.7394,0.89939,9.2707-2.0509-1.2942-5.3868-2.9444-7.4359-3.9631,1.8492,0.54333,4.347,1.5018,6.0371,1.6964,0.37805-1.9616,0.3347-4.8786,0.49945-7.0041'/%3E %3Cpath d='m285.73,174.86c-0.0353,0.0336-4.8006-5.5183-4.8006-5.5183l3.636,6.6258,1.314,0.47899-0.14944-1.5865'/%3E %3Cpath d='m285.29,168.28c0.34006,2.6317,0.74172,6.7188,1.2879,9.2262-2.0982-1.1719-5.4919-2.6228-7.5767-3.5191,1.8655,0.43245,4.3949,1.2414,6.0871,1.3344,0.29381-1.9864,0.12737-4.9038,0.20173-7.0415'/%3E %3Cpath d='m286.69,175.79c-0.0271,0.0431-5.7175-4.0403-5.7175-4.0403l4.8227,5.4618,1.3574,0.0933-0.4626-1.5148'/%3E %3Cpath d='m285.47,169.4c0.51244,2.6008,1.1827,6.6519,1.8915,9.1088-2.1618-0.97386-5.6288-2.1041-7.7589-2.8035,1.8815,0.25605,4.4475,0.82589,6.1344,0.75872,0.15996-2.0152-0.19901-4.9183-0.26704-7.0641'/%3E %3Cpath d='m287.32,176.59c-0.0357,0.0328-4.729-5.6059-4.729-5.6059l3.5489,6.6901,1.3083,0.50387-0.12812-1.588'/%3E %3Cpath d='m285.78,170.12c0.75054,2.5293,1.7931,6.4861,2.7243,8.8454-2.2284-0.68355-5.7618-1.3487-7.9333-1.7623,1.8841,0.004,4.4741,0.22995,6.1355-0.0628-0.0309-2.0343-0.65805-4.8861-0.92656-7.0203'/%3E %3Cpath d='m287.57,176.6c-0.01,0.0517-6.6064-1.4152-6.6064-1.4152l6.2826,3.1233,1.2691-0.47761-0.94521-1.2305'/%3E %3Cpath d='m286.21,170.91c0.74065,2.533,1.7677,6.4948,2.6898,8.8588-2.2262-0.696-5.7576-1.381-7.9279-1.8067,1.8844,0.0147,4.4742,0.25521,6.137-0.0281-0.0228-2.034-0.63878-4.8887-0.89888-7.024'/%3E %3Cpath d='m288.65,177.3c-0.0197,0.0468-6.3209-3.0528-6.3209-3.0528l5.6692,4.5959,1.3583-0.12728-0.70667-1.4158'/%3E %3Cpath d='m285.88,171.35c1.2554,2.3082,3.0909,5.9481,4.4875,8.0501-2.3158-0.17673-5.9011-0.0474-8.1055,0.0273,1.8392-0.41187,4.4133-0.76254,5.9739-1.4156-0.45081-1.9829-1.6525-4.6337-2.3559-6.6618'/%3E %3Cpath d='m289.65,177.99c-0.0123,0.0508-6.5681-1.814-6.5681-1.814l6.1642,3.4904,1.2962-0.39585-0.89236-1.2805'/%3E %3Cpath d='m286.56,172.33c1.2689,2.2992,3.1258,5.9263,4.5345,8.0181-2.3151-0.15736-5.8968,0.002-8.099,0.0956,1.8352-0.42766,4.4051-0.80025,5.9604-1.4669-0.4629-1.9805-1.6803-4.6231-2.3958-6.6467'/%3E %3Cpath d='m290.48,178.53c-0.0234,0.0441-6.1205-3.6614-6.1205-3.6614l5.3476,5.1176,1.3751,0.0136-0.60219-1.4699'/%3E %3Cpath d='m287.07,172.91c1.4696,2.146,3.6456,5.55,5.2323,7.4692-2.2891,0.14354-5.7916,0.77074-7.9455,1.1516,1.761-0.66908,4.2489-1.3786,5.7118-2.2514-0.64696-1.9306-2.0993-4.4284-2.9986-6.3694'/%3E %3Cpath d='m290.93,179.07c-0.002,0.0538-6.6066-0.15568-6.6066-0.15568l6.5361,1.9315,1.1622-0.72207-1.0918-1.0538'/%3E %3Cpath d='m294.76,147.06c0.00065-0.0206,4.7533-0.79299,4.7533-0.79299l-4.7291,0.11031-0.82503,0.42379,0.80086,0.25889'/%3E %3Cpath d='m297.37,148.07c-1.3791-0.41674-3.4631-1.1148-4.8787-1.4225,1.5043-0.59791,3.7307-1.6585,5.1008-2.309-1.0541,0.65981-2.5868,1.5076-3.4038,2.1691,0.78925,0.5361,2.2218,1.0828,3.1818,1.5624'/%3E %3Cpath d='m294.55,147.22c-0.005-0.0199,4.5986-1.2633,4.5986-1.2633l-4.7642,0.6073-0.7185,0.49317,0.88409,0.16283'/%3E %3Cpath d='m297.59,148.41c-1.6114-0.15181-4.0828-0.46088-5.6728-0.47676,1.198-1.0608,2.8775-2.8356,3.9121-3.9252-0.71132,1.024-1.805,2.3829-2.2765,3.3514,1.0804,0.43367,2.8148,0.724,4.0372,1.0505'/%3E %3Cpath d='m292.84,147.55c0.004-0.0209,4.7795-0.53969,4.7795-0.53969l-4.657-0.14908-0.87096,0.38293,0.74852,0.30584'/%3E %3Cpath d='m296.38,148.59c-1.4653-0.28018-3.6918-0.76832-5.174-0.94216,1.4082-0.69122,3.4606-1.8807,4.7239-2.6105-0.94322,0.71246-2.3349,1.6427-3.0389,2.3371,0.89228,0.44221,2.4349,0.84107,3.489,1.2156'/%3E %3Cpath d='m292.43,147.5c-0.0121-0.018,4.207-1.8106,4.207-1.8106l-4.6079,1.2163-0.55216,0.56093,0.95306,0.0333'/%3E %3Cpath d='m296.24,149.12c-1.2194-0.5036-3.0876-1.3567-4.294-1.7117,0.93412-0.86906,2.2505-2.3921,3.0614-3.3263-0.56395,0.93353-1.4259,2.1406-1.8066,3.0664,0.80976,0.68926,2.1192,1.3658,3.0392,1.9717'/%3E %3Cpath d='m292.67,147.81c-0.009-0.0282,3.2732-1.4184,3.2732-1.4184l-3.5645,0.48835-0.43827,0.63528,0.72961,0.29475'/%3E %3Cpath d='m289.93,178.46c0.003,0.0524-6.7834,0.0512-6.7834,0.0512l6.8687,1.6793,1.1269-0.73842-1.2122-0.99207'/%3E %3Cpath d='m291.15,178.9c-0.008,0.0497-6.8895-1.6024-6.8895-1.6024l6.6159,3.2432,1.2964-0.41713-1.0228-1.2237'/%3E %3Cpath d='m292.28,179.36c-0.00001,0.052-6.8397-0.34479-6.8397-0.34479l6.8394,2.0617,1.1727-0.66479-1.1723-1.0521'/%3E %3Cpath d='m287.94,174.53c1.7794,1.9611,4.4452,5.086,6.3123,6.8152-2.2976,0.34709-5.7574,1.2758-7.8858,1.8423,1.6915-0.81215,4.1133-1.7294,5.4752-2.7134-0.91749-1.8253-2.7273-4.1313-3.9017-5.944'/%3E %3Cpath d='m293.22,179.71c-0.0125,0.0479-6.8369-2.2373-6.8369-2.2373l6.4245,3.8199,1.3459-0.28376-0.9335-1.2989'/%3E %3Cpath d='m288.57,174.98c1.9393,1.7687,4.8642,4.6079,6.8646,6.1309-2.2015,0.63398-5.474,2.0002-7.4877,2.8357,1.5623-1.0308,3.8248-2.2579,5.0481-3.4224-1.0855-1.737-3.0907-3.8515-4.425-5.5442'/%3E %3Cpath d='m293.78,180.13c0.0106,0.0527-6.4875,1.2757-6.4875,1.2757l6.8362,0.46588,0.96514-0.95299-1.3138-0.78855'/%3E %3Cpath d='m292.43,179.72c0.007,0.0521-6.7667,0.51919-6.7667,0.51919l6.9817,1.1997,1.0693-0.81376-1.2844-0.90516'/%3E %3Cpath d='m293.68,180.08c-0.005,0.0501-6.9968-1.1217-6.9968-1.1217l6.8468,2.776,1.2626-0.50524-1.1127-1.1491z'/%3E %3Cpath d='m294.84,180.46c0.004,0.0518-6.8526,0.12836-6.8526,0.12836l6.9812,1.5829,1.1205-0.74354-1.2491-0.96772z'/%3E %3Cpath d='m290.14,175.94c1.9233,1.8319,4.8186,4.7625,6.812,6.3572-2.2671,0.5045-5.6507,1.669-7.7325,2.3804,1.6273-0.92621,3.9756-2.0076,5.261-3.0824-1.0528-1.756-3.0324-3.9295-4.3406-5.6552z'/%3E %3Cpath d='m295.81,180.74c-0.009,0.0487-6.9919-1.7581-6.9919-1.7581l6.6991,3.364,1.3221-0.37572-1.0293-1.2302z'/%3E %3Cpath d='m290.81,176.34c2.0685,1.6291,5.201,4.2571,7.3119,5.637-2.1497,0.78383-5.3134,2.3714-7.2605,3.3431,1.4819-1.1352,3.648-2.5144,4.7815-3.7595-1.2138-1.6564-3.374-3.6256-4.8329-5.2206z'/%3E %3Cpath d='m296.4,181.12c0.0145,0.0519-6.3794,1.7192-6.3794,1.7192l6.8581-0.007,0.89174-1.0165-1.3705-0.6953z'/%3E %3C/g%3E %3Cpath d='m305.21,171.52-5.2112-3.6015-5.2113,3.6015,1.9542-5.7624-4.5599-3.6016,5.8626,0,1.9542-5.7624,1.9542,5.7624,5.8626,0-4.5598,3.6016,1.9542,5.7624z' fill='%23fedf00' stroke='%23000' stroke-width='0.298846'/%3E %3C/g%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 75 18' preserveAspectRatio='none'%3E %3Crect width='75' height='18' fill='%238d1b3d'/%3E %3Cpath d='M22,18H0V0H22l6,1 -6,1 6,1 -6,1 6,1 -6,1 6,1 -6,1 6,1 -6,1 6,1 -6,1 6,1 -6,1 6,1 -6,1 6,1z' fill='%23fff'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 900 600'%3E %3Crect width='900' height='600' fill='%23ED2939'/%3E %3Crect width='600' height='600' fill='%23fff'/%3E %3Crect width='300' height='600' fill='%23002395'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 3 2'%3E %3Crect width='1' height='2' x='0' y='0' fill='%23002B7F'/%3E %3Crect width='1' height='2' x='1' y='0' fill='%23FCD116'/%3E %3Crect width='1' height='2' x='2' y='0' fill='%23CE1126'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 1350 900'%3E %3Cpath fill='%23fff' d='M0 0h1350v900H0z'/%3E %3Cpath fill='%230c4076' d='M0 0h1350v600H0z'/%3E %3Cpath fill='%23c6363c' d='M0 0h1350v300H0z'/%3E %3Cg transform='matrix(1 0 0 1.00437 0 -.33)'%3E %3Cpath fill='%2321231e' d='M473.38 259.35zm1.01.03zm-93.13 5.25c-2.31-.26 3.48-.78 4.86-.75 29.24-1.82 58.48-3.65 87.74-5.02 0 2.15-3.95.67-5.64 1.28a6448 6448 0 0 0-87.42 5.1l.24-.33.22-.28zm-1 .2zm6.54 31.06l-6.53-31.05c2.25-.16 1.38 4.47 2.35 6.27l5.17 24.57c-.4.52-.44.87-.99.21zm.51.4zm94.85-4.08c.04 2.3-4.1.53-5.78 1.2-29.7.92-59.38 2.04-89.07 2.88.2-2.23 4.52-.57 6.42-1.2 29.48-.88 58.95-1.99 88.43-2.88zm-.03 0zm94.37 3.47c2.17 1.02-3.86.39-5.14.45-29.75-.88-59.49-2-89.23-2.9.26-2.2 4.35-.33 6.22-.83 29.55.93 59.1 2.03 88.65 2.87l-.32.26-.18.15zm.98.21zm6.54-31.05l-6.54 31.05c-2.11-.77.54-4.65.38-6.7l5.17-24.56c.52-.61.64-.33.99.2zm-.46-.62zm-93.66-4.84c.85-.7 3.25-.4 5.62-.28 29.36 1.44 58.7 3.27 88.04 5.12-.34 2.2-4.38.2-6.28.63-28.96-1.81-57.92-3.62-86.9-4.97l-.29-.3-.2-.2zm.48.5zm.52-.7zm-1 .03zm-7.78.33c-.26-2.1 3.14-.64 4.55-1.14 1.47.3 4.04-.8 4.73.78-1.25 1.64-1.02-2.07-.7.28-2.85-.18-5.72.03-8.58.08zm.04 0zm-8.27.16c1.01-.99-2.16.39-.12-1.29 2.8-.11 5.6.04 8.4.12.09 2.04-3.19.47-4.64.88-1.05-.12-3.4.15-3.78-.06-.19-1.12.33-1.12.14.35zm0-1.02zm-.5.5z'/%3E %3Cpath fill='%2321231e' d='M595.05 245.94c.04-1.75-1.12 2.5-2.62 3.5-3.3 4.72-5.97 9.85-8.53 15-1.91-1 1.3-3.69 1.6-5.38 2.56-4.86 5.38-9.6 8.86-13.85l.69.73zm-19.26-3.89c1.12-2.16.75 3.65 1.7 4.68 1 4.16 6 4.87 9.3 3a38.01 38.01 0 0 0 7.66-4.61c1.1 2-3.51 3.1-4.96 4.43-3.69 2.33-9.93 3.71-12.32-1.08-1.14-2.1-1.52-4.5-1.71-6.86l.27.36.06.08zm.34-.96zm-2.32.51c-1.86-1.07 1.12-.83 2-.6.85.63-.33 1.29-1.08.86-.29-.1-2.06.15-.92-.26zm-.85-.55zm-25.3-5.27c-1.12-1.84 2.27 3.42 2.86 4.86 2.78 4.64 7.31 10.9 13.54 8.97 3.98-1.52 6.62-5.14 8.9-8.56 1.75 1.36-2 3.86-2.86 5.44-3.19 4.15-9.57 6.3-13.89 2.54-4.38-3.38-7.04-8.43-9.44-13.3l.46.03.42.02zm-.86-.54zm-28.4-.53c-1-1.98 2.04 3.38 2.51 4.73 2.43 4.83 7.24 10.87 13.37 8.53 5.68-2.37 9.24-7.8 12.52-12.73 1.74 1.46-2.18 4.15-2.94 5.96-3.59 4.7-9.6 10.43-15.96 7.49-5.4-2.82-8.05-8.78-10.37-14.1l.45.06.42.06zm-.8-.63zm-33.75.67c2.09-.5 2.52 3.57 4.36 4.98 3.49 5.15 10.38 8.69 16.37 5.64 5.34-2.4 9.4-6.84 13.03-11.3 1.56 1.65-2.62 3.88-3.57 5.6-4.93 5.29-12.95 10.37-20.16 6.41-4.51-2.44-7.7-6.89-10.03-11.33zm.06.25zm.95-2.34zm-1.01 0zm-.98.37c1.2-.5.16-.85 1.53-.66-.68.75.1 1.27.16-.17 1.74 1.2-1.12 1.57-1.69.83zm.38.27zm.33-1.12zm-.55-.27zm-.98 1.2c-.16-1.12.06-1.04.98-1.2.75 1.28-.24 1.05-.98 1.2zm.19 0zm-.63-.46c-2.47-.76 1.96-1.22.41.45-.36-.13-1.64-.1-.4-.45zm-.9-.47zm-.2.38zm.9.47zm-.97-.37c-2.17-.42.62 1.35-.52-.28.93-.54 1.75 1.18.35 1-1.6.4-1.1-2.14.17-.72zm-.71-.46zm-.3 2.55zm1.01 0zm-33.68-.16c-1.53-1.62 2.78 2.5 3.58 3.72 4.7 5.08 12.08 10.54 19.23 7.07 4.5-2.28 7.5-6.6 9.92-10.88 1.85 1.34-1.92 4.19-2.68 5.95-3.75 5.45-11.1 9.06-17.45 5.87-5.52-2.43-9.72-7-13.47-11.6l.46-.07.4-.06zm-.94-.39zm-28.3 1.53c-1.39-1.7 2.5 2.8 3.15 4.14 3.45 4.45 8.65 10.35 14.93 8.07 5.4-2.6 7.94-8.55 10.22-13.74 1.94 1.2-1.47 4.57-1.98 6.52-2.58 5.02-7.96 10.66-14.13 8.23-5.93-2.42-9.68-8.03-13.07-13.17l.45-.03.43-.02zm-.91-.44zm-25.7 6.54c.26-2.42 2.48 3.01 3.72 3.65 2.9 3.87 8.79 6.35 12.88 2.7 4.23-3.28 6.77-8.18 9.1-12.9 1.9 1.3-1.74 4.5-2.3 6.45-2.95 4.87-7.98 10.97-14.4 8.85-4.21-1.58-7.03-5.36-9.43-8.98l.4.22.03.01zm0-1.02zm-2.08.8c-2.21-.32.87-1 1.81-.8 1.1.98-.44 1.15-1.3 1.07-.36-.06-1.38.52-.5-.27zm-1-.08zm-17.9 3.68c-1.67-.03 3.14 1.52 4.4 2.92 3.42 2.18 9.45 4.5 11.91-.16 1.06-1.97 1.4-4.23 1.58-6.44 2.2.33.06 4.34-.24 5.98-1.44 4.64-7.2 5.12-10.88 2.98a40.12 40.12 0 0 1-7.46-4.55l.7-.73zm10.89 18.5c-.18 2.44-1.9-2.65-2.61-3.57-2.6-5-5.48-9.9-9.06-14.29 1.68-1.37 2.77 2.7 4.05 3.75 3.1 4.56 5.65 9.45 8.1 14.38l-.4-.23-.08-.05zm.04 1.01zm101.31-5.97c-.19 2.39-4.82.6-6.78 1.37-31.5 1.66-63.01 3.28-94.53 4.6.36-2.32 5.1-.6 7.21-1.33 31.38-1.35 62.74-3 94.1-4.64zm-.05 0zm101.33 4.95c-.22 2.39-4.9.13-6.83.73-31.5-1.36-63-3-94.5-4.67.56-2.27 5.12-.12 7.28-.63 31.33 1.64 62.78 3.27 94.05 4.57zm0 1.02zm0 0zm.45-.28z'/%3E %3Cpath d='M583.45 264.21c3.27-6.6 6.7-13.07 11.3-18.68-11.75 8.74-17.93 7.42-18.8-3.96-.69-.25-1.63-.25-2.57-.25-8.96 13.98-17.68 12.04-26.16-5.81-11.54 18.35-21.44 18.02-29.22-1.12-13.31 16.73-24.53 16.77-33.65.36v-2.09c.51.23.16.3-1.03.13l-.2-.38-.98.2-.98-.2-.2.38c-1.19.17-1.53.1-1.03-.13v2.09c-9.12 16.41-20.33 16.37-33.64-.36-7.78 19.14-17.69 19.47-29.23 1.12-8.47 17.85-17.2 19.79-26.15 5.81-.95 0-1.89 0-2.58.25-.86 11.38-7.04 12.7-18.79 3.96 4.59 5.6 8.02 12.08 11.3 18.68 33.84-1.41 67.58-3.18 101.3-4.96 33.73 1.78 67.46 3.55 101.32 4.96z' fill='%23edb92e'/%3E %3Cpath fill='%23EDB92E' d='M504.88 276.18l-22.74 11.45-22.74-11.45 22.74-11.46z'/%3E %3Cpath fill='%23edb92e' d='M473.89 259.19v.18c-17.5.78-48.48 2.52-93.13 5.36l6.54 31.05c29.65-.83 64.25-2.14 94.84-3.06 30.59.92 65.2 2.23 94.85 3.06l6.53-31.05c-44.64-2.86-75.63-4.6-93.12-5.38v-.18c1.76-.34-.98-.4-8.26-.15-7.27-.25-10.01-.2-8.25.16z'/%3E %3Cpath fill='%23edb92e' d='M597.33 236.74l-3.68-.62c-7.08 17.4-13.42 17.81-14.61 1.27 1.58-.57.95-3.33 2.74-2.23.94.58 2.14-1.07 1.36-1.98-2-1.48-3.79-1.25-5.54.4-.83-2.64-2.85-3.87-5.38-2.76-1.09.48-.71 2.46.38 2.35 1.77-.19 1.06 1.66 1.6 2.9-12.54 16.48-18.95 14.52-17.4-7.12-2.98-.62-6.46-1.24-9.57-2.36-11.55 23.35-19.76 24.35-26.42 3.4 1.43-1.06 1.02-3.75 3.1-2.89 1.18.49 2.16-1.6 1.12-2.49-2.44-2.06-5.08-1.36-6.84 1.29-1.42-2.85-3.95-3.88-6.62-2.15-1.16.75-.44 2.94.78 2.61 2.36-.64 1.3 2.47 3.08 3.54-5.1 19.7-30.87 21.02-26.65-8.13l-6.63.24-6.63-.24c4.22 29.15-21.55 27.83-26.65 8.13 1.78-1.07.72-4.17 3.07-3.54 1.23.33 1.95-1.86.8-2.61-2.68-1.73-5.2-.7-6.63 2.15-1.77-2.65-4.4-3.35-6.84-1.29-1.05.9-.06 2.98 1.11 2.5 2.09-.87 1.68 1.82 3.1 2.88-6.65 20.95-14.86 19.95-26.41-3.4-3.11 1.12-6.59 1.74-9.58 2.36 1.56 21.64-4.85 23.6-17.4 7.12.55-1.24-.16-3.09 1.61-2.9 1.1.11 1.47-1.87.38-2.35-2.53-1.11-4.55.12-5.38 2.76-1.75-1.65-3.53-1.88-5.54-.4-.78.91.42 2.56 1.36 1.98 1.79-1.1 1.16 1.66 2.74 2.23-1.19 16.54-7.53 16.12-14.6-1.27l-3.69.62a18.6 18.6 0 0 0 3.8 11.63c10.62 13.55 18.5 10.48 18.8-4.7 13.89 16.4 24.39 14.32 26.27-2.97 11.69 21.8 30.44 11.37 30.82-1.86 5.15 19.23 33.67 19.1 35.5-3 1.82 22.1 30.33 22.23 35.48 3 .39 13.23 19.14 23.67 30.82 1.86 1.89 17.29 12.39 19.36 26.28 2.97.29 15.18 8.18 18.25 18.79 4.7a18.6 18.6 0 0 0 3.8-11.63z'/%3E %3Cpath fill='%2321231e' d='M593.72 235.62c4.42.05 4.1 2.48-.17 1-.24-.55-.74-.76.17-1zm-.55.3zm-14.31 1c1.16.8.75 3.84 1.44 6.24.45 2.4 1.82 7.19 5.1 5.32 3.95-3.12 5.78-8.08 7.77-12.55 1.99 1.06-1.31 4.29-1.7 6.15-1.9 3.11-4.05 8.36-8.46 7.76-4.07-2.5-3.89-8.18-4.49-12.41l.26-.4.08-.12zm-.34.51zm3.52-2.7c-.24 1.18-1.38.21-1.46 1.61-.08 1.42-2.4 1.82-1.4.37.75-1 1.07-3.23 2.86-1.98zm.79-1.13c1.4-2.17 1.4 2.38-.44 2.18-1.69-.01-.03-1 .42-1.6.2-.13-.11-.81.02-.58zm.6-.82zm-6.32.96c.83-.13.38-1.67 2.72-1.98 1.17-.28 4.43.43 3 1.84a3.44 3.44 0 0 0-4.9.36l-.45-.12-.37-.1zm.82.22zm-5.51-2.67c-1.1-1.94 3-1.63 3.93-.56 1.47.51 2.07 4.24.51 2.36a3.14 3.14 0 0 0-4.44-1.8zm.12 1.37c.49 2.56-2.62-.54-1.22-1.7.92-1.27 1.1.4.76 1.17.04.23.19.56.46.53zm2.06 3.72c-1.14-.33-1.04-.34-1.21-2 .08-.9-1.57-.9-.66-1.73 2.01-.12 1.69 2.45 1.87 3.73zm.06-.52zm-17.96-6.41c1.04-2.15.2 4.21.38 5.54.26 3.8-.25 8.93 3.3 11.34 4.48.55 7.56-3.98 10.38-6.8.87-1.8 5.23-5.6 2.7-1.67-3.5 3.86-7.04 9.44-12.76 9.6-4.65-1.61-4.34-7.7-4.63-11.77.2-1.36-.4-7.1.63-6.24zm.2-1zm-9.23-1.63c-1.97-1.45 2.82.35 3.89.5 1.58.68 4.56.36 5.25 1.59-.87 1.12-3.6-.53-5.17-.53-.76-.32-5.49-1.02-3.97-1.56zm-.9-.45zm-26.27 3.22c1.44.48 1.68 3.74 2.87 5.95 1.74 3.83 4.34 9.74 9.49 8.7 6.47-2.86 9.49-9.96 12.84-15.76 2.04-4.36 1.87.24.02 2.13-3.32 5.54-6.48 12.54-13.05 14.71-5.87.77-8.68-5.8-10.6-10.25-.46-1.75-1.84-3.7-1.57-5.48zm-.18.56zm3.78-3.51c-.29 1.1-1.9.73-1.97 2.4-.27 1.77-2.37 1.05-1.05-.17.53-1.28 1.24-3.13 3.02-2.23zm.59-1.63c1.53-2.09 1.8 2.68-.15 2.65-1.6.08-.14-1.02.33-1.57.13-.36.13-.83-.18-1.08zm-6.96 1.12c.6-.24.55-2.36 3.02-3 1.38-.6 4.46.09 4.3 1.46-.86.72-2.4-1.39-3.79-.55-1.59.12-2.08 2.4-3.53 2.09zm.87.06zm-6.77-2.01c-1.52-1.63 2.34-2.02 3.43-1.63 1.34.33 4.3 2.69 2.54 3.54-1.05-2.17-3.71-3.65-5.97-1.91zm.38 1.7c.9 2.26-2.41.23-1.73-1.17-.13-1.63 1.9-1.3 1.03-.06-.11.44.1 1.32.7 1.22zm3.7 4.15c-1.1.41-1.67-.25-2.2-2.08.09-1.47-1.63-.8-1.5-2.08 2.76-.77 2.23 2.96 3.7 4.16zm-.23-.56zm-26.9-7.19c.7-2.22-.03 4.13.05 5.55-.31 6.6 2.68 15.25 10.3 15.85 7.94.48 14.1-6.72 15.8-13.9 2.11.97-1.03 4.8-1.7 6.62-3.66 6.67-13.23 11.3-19.88 6.07-5.97-4.98-6.04-13.68-5.08-20.77l.31.35.2.23zm-.03-1.02zm-6.63 1.26c-.43-1.97 2.46-.7 3.64-1.15 1.07-.15 4.2-.27 2.59.93l-6.23.22zm.04 0zm-6.15-.82c-2.37-.09 1.54-.68 2.5-.33 1.2.38 4.01-.73 3.61 1.14l-6.63-.23.31-.35.2-.23zm-1 .15zm-26.41 7.62c1.33.6 1.58 3.93 3.11 6.05 3.3 6.35 12.3 11.09 18.63 6.12 5.62-4.8 5.55-13.06 4.67-19.8 2.31.09 1.02 4.89 1.44 6.9.14 6.85-3.4 15.38-11.17 15.95-8.45.58-15.1-7-16.91-14.66l.18-.43.05-.13zm-.23.56zm3.7-4.16c.17 1.35-1.61.57-1.5 2.09.07 1.23-1.98 3.35-1.74 1.34 1.12-1.2.7-4.22 3.24-3.43zm.38-1.69c1.26-2.27 2.13 2.44.18 2.65-1.58.29-.26-.99.13-1.6.1-.37.03-.83-.31-1.05zm-6.77 2c.56-.31.26-2.4 2.62-3.36 1.3-.78 4.44-.48 4.44.9-.75.82-2.55-1.07-3.82-.06-1.56.32-1.76 2.64-3.24 2.53zm.88-.05zm-6.97-1.12c-1.6-1.49 2.21-2.4 3.44-2.02 1.3.27 4.47 2.2 2.65 3.2-1.2-2.21-4.2-3.11-6.09-1.18zm.6 1.63c1.17 2.13-2.38.54-1.87-.94-.34-1.6 1.72-1.52 1.01-.2-.05.47.27 1.31.85 1.14zm3.77 3.51c-1.13.24-1.4-.16-2.13-1.85-.07-1.27-2.18-.53-1.43-1.75 2.28-.77 2.52 2.4 3.56 3.6zm-.18-.56zm-26.55-2.51c-.2-2.4 2.31 3.55 3.08 4.61 3.03 4.84 5.95 11.05 11.86 12.71 5.32 0 7.46-6.07 9.27-10.16.19-2.16 3.16-6.73 1.89-2.18-2.03 5.04-4 11.98-10 13.35-6.13-.03-9.5-6.36-12.52-10.84a110.81 110.81 0 0 1-4.2-7.75l.43.18.19.08zm-.34-.96zm-8.9 2.8c-2.45-.26 2.49-1.12 3.52-1.32 1.8-.07 4.29-1.7 5.54-1.04-.23 1.47-3.55 1.31-5.02 1.96-.8-.04-5.12 1.57-4.05.4zm-1.01.07zm-17.36 6.87c1.62-.26 2.72 2.83 4.52 4.37 2.65 2.61 5.6 6.69 9.75 6.1 3.68-2.52 3.04-7.87 3.32-11.81-.23-1.58-.3-8.21.86-4.21.03 5.39.96 11.72-2.62 16.22-3.99 2.9-8.26-1.74-10.95-4.4-1.64-1.99-3.9-3.93-4.88-6.27zm.06.52zm2.06-3.72c.06 1.11-1.3 1.28-.96 2.75-.02 1.54-1.66.42-.94-.65-.01-1.14.54-2.34 1.9-2.1zm.12-1.37c.8-2.42 2.3 1.77.52 2.24-1.54.47-.16-1.02-.18-1.75-.02-.2-.14-.4-.34-.49zm-5.51 2.67c.52-.5-.3-2.05 1.76-3.37 1-.94 4.8-1.15 3.75.7-1.95-1.12-4.29.38-4.69 2.45l-.45.12-.37.1zm.82-.22zm-5.64-.22c-1.87-1.15 1.86-2.1 2.92-1.76 1.26-.07 3.59 2.13 1.59 1.92-1.24-1.35-3.53-1.08-4.5-.16zm-.76-.67zm1.47 1.88c1.44 2.19-2.71.5-1.81-1.18.56-1.47 1.03.3 1.25 1 .14.14.36.3.56.18zm3.52 2.7c-1.02.43-1.4.35-2.17-1.34-.02-1.12-1.7-.37-1.16-1.47 2.09-1.07 2 2.07 3.33 2.81zm-.34-.52zm-14.7-.28c.13-2.42 1.95 3.46 2.76 4.55 1.76 2.89 3.35 7.2 7.1 7.79 3.7-1.84 3.45-7.02 4.08-10.6 1.43-3.12.96 2.89.46 4.23-.49 3.05-2.05 8.63-6.19 7.07-4.65-2.96-6.56-8.56-8.75-13.35l.4.23.15.08zm-.16-1.01zm-3.68.62c4.2-1.4 4.67 1 .16 1-.45-.44-.9-.47-.16-1zm-.43.49zm4.71 11.33c-1.96 1.27-2.9-3.48-3.76-5.01-.27-1.81-2.18-6.03.06-6.3a18.02 18.02 0 0 0 3.7 11.3zm18.78-4.72c-.58.1.6 3.23-.34 5.53-.42 4.37-3.71 10.06-8.86 8.35-4.4-1.4-7.55-5.07-10.37-8.53 1.93-1.14 3.27 3.4 5.27 4.26 2.7 2.84 8.33 5.52 10.99 1.2 1.98-3.1 2.29-6.9 2.42-10.49l.89-.32zm-.9.32zm27.24-3.2c-.74-.13.33 3.14-.83 5.27-.93 5.16-5.2 10.9-11.09 9.5-6.34-1.5-11.03-6.52-15.2-11.23 1.97-1.15 3.55 3.44 5.58 4.4 3.94 3.59 9.95 8.12 15.32 4.74 3.75-2.96 4.7-8.01 5.27-12.5l.95-.18zm-.95.18zm31.81-1.93c-.85-.53.5 3.54-1.16 5.52-2.98 8.15-13.67 12.4-21.1 7.44-4.2-2.47-7.2-6.51-9.5-10.73 2.13-.8 2.7 3.93 4.6 5.1 4.3 5.96 13.16 9.1 19.55 4.53a14.87 14.87 0 0 0 6.62-11.74l.99-.12zm35.5-2.91c-.9-.78.37 3.46-1.06 5.4-2.7 9.73-14.41 14.68-23.54 10.98a19.15 19.15 0 0 1-11.88-13.2c2.23-.26 1.9 4.47 3.83 5.86 6.2 9.32 21.7 10.25 28.23.83a19.81 19.81 0 0 0 3.42-9.87h1zm35.5 3.03c-.76-.72-.25 3.5-2.1 5.17-5.62 10.4-21.74 12.76-29.63 3.7-2.93-3.23-4.42-7.53-4.77-11.82 2.22.1.96 4.6 2.5 6.3 3.53 9.7 16.5 12.99 24.86 7.54a18.16 18.16 0 0 0 8.14-11l1 .1zm30.81 1.81c-.55-.32-1.23 3.58-3.2 5.2-4.32 6.41-13.33 10.45-20.5 6.22a15.88 15.88 0 0 1-8.13-13.2c2.14.17.9 4.48 2.61 6.06 3.35 7.35 13.47 10.37 20.02 5.35 3.58-2.45 6.2-6.04 8.25-9.81l.95.18zm-.95-.18zm27.23 3.2c-.5-.29-1.64 2.9-3.69 4.22-4.35 4.22-10.72 9.59-17.12 6.59-4.66-2.82-5.84-8.7-6.47-13.71 2.2-.03 1 4.31 2.23 6 1.02 4.62 5.47 9.12 10.49 7.24 5.64-1.83 9.86-6.33 13.67-10.66l.9.32zm-.89-.32zm18.78 4.72c1.6 1.56-2.43 3.74-3.44 5.3-3.06 3.27-9.2 6.32-12.56 1.8-2.39-3.3-2.76-7.53-2.9-11.48 2.24.25.6 4.66 1.79 6.54.48 3.72 4 7.8 8 5.77 3.78-1.58 6.59-4.83 9.1-7.93zm4.2-10.8c.7-2.34.53 3.82-.2 5.02-.75 2.03-1.77 5.65-3.57 6.12-.34-1.59 2.34-3.87 2.48-6.03.87-1.04.33-6.15 1.3-5.12zm0-1.03zm0 0zm0 1.02z'/%3E %3Cpath fill='%23edb92e' d='M482.14 262.87c-33.98 0-67.97 1.7-101.77 5.22-7.83-.17-1.9-8.29 3.26-6.3a987.52 987.52 0 0 1 201.3.5c7.56 3.1-1.56 8.07-5.92 5.3a984.52 984.52 0 0 0-96.87-4.72z'/%3E %3Cpath fill='%230c4076' d='M482.14 105.07c9.48 0 17.17 7.74 17.17 17.3 0 9.55-7.69 17.3-17.17 17.3a17.23 17.23 0 0 1-17.17-17.3c0-9.56 7.69-17.3 17.17-17.3z'/%3E %3Cpath fill='%23edb92e' d='M485.26 84.9a3.12 3.12 0 0 0 3.03-3.14c0-1.7-1.35-3.09-3.03-3.13-.01-1.73-1.4-3.12-3.12-3.12-1.7 0-3.1 1.4-3.1 3.12a3.12 3.12 0 0 0-3.04 3.13c0 1.7 1.35 3.09 3.03 3.13v6.43h-5.5c0-1.72-1.39-3.12-3.1-3.12a3.13 3.13 0 0 0-3.11 3.06c-1.71 0-3.1 1.4-3.1 3.13a3.12 3.12 0 0 0 3.1 3.13 3.12 3.12 0 0 0 3.1 3.06 3.12 3.12 0 0 0 3.12-2.98h5.49v21.37h6.23V97.6h5.5a3.12 3.12 0 0 0 3.1 2.98c1.7 0 3.07-1.36 3.11-3.06 1.71 0 3.1-1.4 3.1-3.13a3.12 3.12 0 0 0-3.1-3.13 3.12 3.12 0 0 0-3.1-3.06c-1.72 0-3.1 1.4-3.12 3.12h-5.49v-6.43z'/%3E %3Cpath fill='%2321231e' d='M487.78 81.76c.78-.16 1.27.07.9.9a3.64 3.64 0 0 1-3.4 2.74c-.06-.6-.16-1.17.6-1.11a2.63 2.63 0 0 0 1.9-2.53zm-3.03-3.13c.95.14.97-.12.63-.5a3.65 3.65 0 0 1 3.41 3.63c-.62.05-1.17.12-1.09-.64a2.63 2.63 0 0 0-2.46-1.98l-.5-.51zm.5.5zm-3.1-3.11c-.16-.78.06-1.28.9-.9a3.66 3.66 0 0 1 2.71 3.5c-.62.06-1.17.12-1.1-.64a2.62 2.62 0 0 0-2.52-1.96zm-3.1 3.12c.12-.95-.14-.98-.52-.63a3.65 3.65 0 0 1 3.61-3.51c.05.62.12 1.18-.65 1.1a2.63 2.63 0 0 0-1.95 2.53l-.5.5zm.49-.51zm-3.03 3.13c-.79.16-1.27-.07-.9-.9a3.64 3.64 0 0 1 3.41-2.74c.06.61.15 1.18-.6 1.11a2.63 2.63 0 0 0-1.91 2.53zm3.03 3.13c-.95-.14-.97.12-.64.5a3.65 3.65 0 0 1-3.4-3.63c.62-.04 1.17-.11 1.09.65a2.63 2.63 0 0 0 2.45 1.98l.5.5zm-.5-.5zm-.52 6.93v-6.43c.98-.25 1.17.28 1.02 1.16v5.27c-.5.58-.51.6-1.02 0zm1.02 0zm-6-.51h5.49c.25.98-.27 1.17-1.16 1.02h-4.33c-.58-.5-.59-.52 0-1.02zm0 1.02zm-3.11-3.12c-.16-.78.07-1.28.9-.9a3.66 3.66 0 0 1 2.72 3.5c-.63.06-1.18.12-1.1-.64a2.62 2.62 0 0 0-2.52-1.96zm-3.11 3.06c.14-.95-.12-.98-.5-.64a3.65 3.65 0 0 1 3.6-3.44c.05.62.13 1.18-.63 1.1a2.64 2.64 0 0 0-1.97 2.48l-.5.5zm.5-.5zm-3.09 3.12c-.8.16-1.27-.08-.9-.9a3.64 3.64 0 0 1 3.49-2.74c.04.62.12 1.18-.65 1.1a2.63 2.63 0 0 0-1.94 2.54zm3.1 3.12c-.96-.12-.97.14-.63.52a3.65 3.65 0 0 1-3.48-3.64c.63-.05 1.17-.1 1.1.66a2.62 2.62 0 0 0 2.5 1.96l.5.5zm-.5-.5zm3.1 3.06c.15.78-.07 1.28-.9.9a3.65 3.65 0 0 1-2.72-3.43c.62-.06 1.17-.15 1.11.61a2.62 2.62 0 0 0 2.5 1.92zm3.1-2.98c-.14.93.12.98.5.65a3.65 3.65 0 0 1-3.6 3.35c-.04-.61-.13-1.18.63-1.1a2.64 2.64 0 0 0 1.97-2.42l.5-.48zm-.5.48zm6 .54h-5.5c-.25-.98.28-1.18 1.16-1.02h4.34c.58.5.59.51 0 1.02zm0-1.02zm-.5 21.88V97.6c.97-.26 1.16.28 1 1.15v20.22c-.49.58-.5.6-1 0zm.5.5zm6.23 0h-6.23c-.25-.97.27-1.17 1.15-1.01h5.08c.58.5.59.52 0 1.02zm.5-.5zm0-21.37v21.37c-.97.25-1.16-.28-1-1.16V97.6c.49-.59.5-.6 1 0zm-1 0zm6 .5h-5.5c-.25-.97.27-1.17 1.16-1.01h4.33c.62.48.56.5 0 1.02zm0-1.01zm3.1 2.98c.15.77-.05 1.28-.88.91a3.66 3.66 0 0 1-2.73-3.36c.6-.07 1.16-.18 1.12.58a2.62 2.62 0 0 0 2.5 1.87zm3.1-3.06c-.13.95.13.98.51.64a3.64 3.64 0 0 1-3.6 3.44c-.05-.62-.13-1.18.63-1.1a2.63 2.63 0 0 0 1.97-2.48l.5-.5zm-.5.5zm3.1-3.12c.79-.16 1.27.08.9.9a3.64 3.64 0 0 1-3.49 2.74c-.05-.62-.12-1.18.65-1.1a2.63 2.63 0 0 0 1.94-2.54zm-3.1-3.12c.96.12.97-.14.63-.52a3.65 3.65 0 0 1 3.48 3.64c-.63.05-1.17.1-1.1-.66a2.62 2.62 0 0 0-2.5-1.96l-.5-.5zm.5.5zm-3.1-3.06c-.15-.77.06-1.28.9-.9a3.65 3.65 0 0 1 2.72 3.43c-.62.07-1.17.15-1.1-.61a2.62 2.62 0 0 0-2.52-1.92zm-3.11 3.12c.14-.96-.11-.98-.5-.63a3.65 3.65 0 0 1 3.61-3.5c.05.62.11 1.17-.65 1.1a2.63 2.63 0 0 0-1.95 2.52l-.51.5zm.5-.5zm-5.99-.52h5.49c.25.98-.27 1.17-1.16 1.02h-4.33c-.58-.5-.59-.52 0-1.02zm0 1.02zm.5-6.94v6.43c-.97.25-1.16-.28-1-1.16V84.9c.48-.6.5-.57 1 0zm-1 0zm.5 0zm-.5 0z'/%3E %3Cpath fill='%2321231e' d='M499.82 122.37c-.7.1-1.26.06-1.03-.8a16.85 16.85 0 0 0-9.33-14.28 16.6 16.6 0 0 0-7.32-1.7c-.09-.71-.05-1.28.8-1a17.71 17.71 0 0 1 16.88 17.78zm-17.68 17.8c-.09-.69-.05-1.26.8-1.03a16.7 16.7 0 0 0 15.87-16.77c.7-.1 1.26-.05.99.8a17.86 17.86 0 0 1-9.76 15.13 17.6 17.6 0 0 1-7.9 1.88zm-17.67-17.8c.7-.1 1.26-.06 1.03.8a16.85 16.85 0 0 0 9.33 14.28 16.6 16.6 0 0 0 7.31 1.7c.1.71.06 1.28-.8 1a17.71 17.71 0 0 1-14.96-9.74 17.92 17.92 0 0 1-1.9-8.04zm17.67-17.8c.1.69.06 1.26-.8 1.03a16.7 16.7 0 0 0-15.86 16.77c-.7.1-1.26.05-.99-.8a17.86 17.86 0 0 1 9.77-15.13 17.6 17.6 0 0 1 7.89-1.88z'/%3E %3Cpath fill='%23edb92e' d='M498.96 118.85a17.57 17.57 0 0 1 .18 5.96c-5.64-.2-11.3-.33-17-.33-5.69 0-11.34.14-16.99.33a17.47 17.47 0 0 1 .18-5.96c5.59-.2 11.19-.32 16.82-.32 5.63 0 11.23.13 16.8.32z'/%3E %3Cpath fill='%2321231e' d='M499.82 122.37c-.3-.11-1.06.24-1.01-.22a16.92 16.92 0 0 0-.34-3.2c.31.06 1-.45 1.03.02.22 1.12.32 2.26.32 3.4zm-.7 2.96c-.07-.26.25-1.31-.18-.83-.4.47-.27 0-.23-.34.06-.6.1-1.2.1-1.8.28.1.98-.2 1 .17 0 .79-.06 1.58-.17 2.36l-.52.44zm.52-.44c.26.58-.9.57-.24.2l.24-.2zm-17.5.1c.12-.32-.26-1.13.3-1.01 5.57 0 11.15.13 16.72.33-.12.32.23 1.15-.33 1-5.56-.19-11.12-.3-16.68-.31zm-17.49-.1c.24-.12 1.33.01.78-.33-.66-.39.28-.22.6-.28 5.36-.18 10.74-.3 16.12-.3-.11.33.26 1.14-.3 1.02-5.56 0-11.12.13-16.68.33l-.52-.44zm.52.44c-.53.36-.71-.8-.24-.2l.24.2zm-.7-2.96c.3.1.97-.2 1.01.15 0 .75.07 1.5.17 2.23-.3-.06-.95.34-1.02-.01-.1-.79-.16-1.58-.16-2.37zm.85-4.02c.1.25-.17 1.3.25.83.43-.5.13.23.12.5-.14.9-.2 1.8-.2 2.69-.3-.11-1.09.25-1.02-.23.02-1.14.14-2.27.37-3.39l.48-.4zm-.48.4c-.06-.61.83-.43.1-.08l-.06.05-.04.03zm17.3-.73c-.1.33.27 1.14-.28 1.02-5.5 0-11 .13-16.51.32.1-.33-.3-1.13.25-1.03 5.52-.18 11.03-.3 16.55-.3zm17.32.73c-.24.14-1.32.06-.78.4.61.38-.42.14-.7.18-5.27-.17-10.55-.28-15.83-.28.1-.33-.27-1.14.29-1.02 5.51 0 11.02.13 16.54.32l.48.4zm-.48-.4c.6-.16.56.75.1.08l-.06-.05-.04-.03z'/%3E %3Cpath fill='%23edb92e' d='M468.82 133.18c-3.63-2.26-4.27 1.24-4.18 4.75.35 13.23 2.87 25.83-.67 42.03-1.42 6.49-3.7 10.13-1.48 11.38 5.67 3.19 8.27 6.1 7.37 7.67 1.68 3.22 5.86 2.6 12.28 1.57 6.42 1.03 10.6 1.65 12.28-1.57-.9-1.57 1.7-4.48 7.37-7.67 2.22-1.25-.06-4.9-1.48-11.38-3.53-16.2-1.01-28.8-.67-42.03.1-3.51-.54-7-4.18-4.75-7.15 4.45-19.4 4.5-26.64 0z'/%3E %3Cpath fill='%2321231e' d='M465.15 137.91c-1.13.4-1.1-.46-1-1.31.07-1.72.33-4.28 2.42-4.64.9-.08 1.76.32 2.52.78-.32 1.37-1.14.39-2.03.25-1.57-.13-1.75 1.9-1.87 3.04-.05.62-.05 1.25-.04 1.88zm-.69 42.15c-1.49.15-.72-1.14-.61-2.03 2.1-10.35 1.56-20.98.74-31.43-.2-2.89-.37-5.77-.45-8.66 1.43-.52.96.97 1.08 1.86.53 11.15 1.97 22.38.41 33.52a80.3 80.3 0 0 1-1.17 6.74zm-1.72 10.83c-.24 1.4-1.28.55-1.53-.35-.48-2.41.79-4.73 1.32-7.03.36-1.21.68-2.43.95-3.66 1.47-.15.74 1.1.56 1.98-.57 2.7-1.88 5.27-1.95 8.05.04.42.26.82.65 1.01zm7.57 7.88c-1.23.98-.69-.15-.89-.99-1.39-2.62-4.14-4.13-6.58-5.66-1.23-.4.16-1.83.85-.68 2.5 1.6 5.32 3.21 6.67 5.97.43.4-.05 2.49-.05 1.36zm-.9.47zm12.81.83c.16 1.34-.52 1.05-1.66 1.27-3.07.37-6.43 1.22-9.35-.21a4.5 4.5 0 0 1-1.8-1.89c.97-1.01 1.2.28 1.96.78 2.4 1.47 5.38.74 8.02.46.95-.12 1.89-.32 2.83-.41zm-.16 0zm11.93-.8c1.11-1.07 1.03.22.3.85-2.02 2.3-5.42 1.85-8.14 1.56-1.37-.17-2.73-.39-4.09-.6-.23-1.44 1.02-.84 1.9-.74 2.84.33 5.94 1.16 8.65-.12.66-.04 1.45-2 1.38-.96zm.87-.52zm6.69-7.86c1.05.98-.27 1.28-1 1.77-2.15 1.43-4.63 2.84-5.73 5.28.35.74-.93 1.9-1.04.73-.13-2.2 1.92-3.68 3.43-4.96a35.82 35.82 0 0 1 4.34-2.82zm-1.73-10.83c1.26-.74 1.14.67 1.4 1.52.6 2.82 2.01 5.5 1.98 8.43.02.64-.95 2.32-1.4 1.34-.57-.64.8-1.16.4-2.05-.46-3.15-1.79-6.1-2.38-9.24zm-.68-42.15c1.46-.44.9 1.03.94 1.92-.51 11.05-1.96 22.17-.44 33.2.29 2.29.69 4.56 1.17 6.82-1.3.76-1.13-.76-1.36-1.63-2.13-10.43-1.58-21.15-.76-31.7.2-2.86.37-5.74.45-8.61zm-3.4-4.3c-1-.84-.04-1.27.8-1.51 1.62-.68 3.15.76 3.34 2.32.26 1.15.3 2.34.27 3.52-1.45.43-.9-1.02-1.05-1.91-.13-1.14-.28-3.12-1.83-3.05a4.1 4.1 0 0 0-1.54.63zm-27.18 0c.35-1.48 1.34-.28 2.2.04 6.28 2.87 13.66 3.06 20.21 1.02 1.48-.48 2.9-1.11 4.23-1.93 1.07.9-.13 1.27-.9 1.67-6.57 3.13-14.35 3.38-21.25 1.25a20.93 20.93 0 0 1-4.5-2.05z'/%3E %3Cg id='a'%3E %3Cpath d='M363.03 212.12c-1.9-4.14-.37-9.93.25-11.23.32-.67-.61-2.12-1.02-2.7-12.9-18.27-13.12-19.9-4.23-26.75 8.03-6.18 26.16-12.19 39.14-16.23 2.7-2.06 4.42-4.87 6.87-7.18-24.93 1.8-51.94 11.92-65.57 23.76-7.2 6.25 1.56 18.89 12.28 38.1 6.63 4.79 9.74 7.01 12.28 2.23z' fill='%23edb92e'/%3E %3Cpath fill='%2321231e' d='M362.83 200.67c1.42.16.52 1.2.38 2.07-.71 2.99-.97 6.29.28 9.17-1.16 1.09-1.29-.63-1.55-1.47-.67-3.22-.28-6.71.89-9.77zm-.98-2.17c.7-.98 1.16-.3 1.5.48.32.64.7 1.41.4 2.13-.67-.18-1.02-.45-1.05-1.12a7.78 7.78 0 0 0-.85-1.5zm-4.12-27.46c1.4 1-.63 1.53-1.24 2.28-2.2 1.75-4.73 4.22-3.98 7.33 1.16 4.64 4.24 8.48 6.8 12.43 1.11 1.62 2.24 3.22 3.37 4.83-1.05 1.37-1.52-.73-2.22-1.4-3.14-4.7-6.79-9.22-8.68-14.6-1.06-2.8.08-5.9 2.28-7.78 1.14-1.12 2.4-2.1 3.67-3.09zm39.13-16.23c1.5 1.18-.9 1.14-1.7 1.57-11.1 3.59-22.32 7.14-32.6 12.73a37.37 37.37 0 0 0-4.22 2.74c-1.36-.96.51-1.47 1.2-2.09 8.35-5.23 17.76-8.43 27.01-11.66a498.7 498.7 0 0 1 10.47-3.37l-.16.08zm.61.81zm6.61-7.07c-.28-2.03.76.33-.56.73-2 2.12-3.7 4.56-6.05 6.34-1.3-.9.35-1.4.92-2.14 1.87-1.84 3.39-4.02 5.31-5.82l.38.89zm-.07-1.02c2.15-.96.72 1.46.15.34l-.08-.18-.07-.16zm-65.2 24.65c-1.49-.95.64-1.63 1.28-2.37 10.32-7.95 22.54-13.06 34.92-16.84a137.29 137.29 0 0 1 29-5.44c.63 1.65-1.5.92-2.46 1.23a137.37 137.37 0 0 0-48.52 14.05 74.54 74.54 0 0 0-14.23 9.37zm12.24 37.3c-.69 1.77-1.22-.42-1.74-1.11-4.35-7.96-9.37-15.61-12.62-24.1-1.4-3.8-2.35-8.66.59-11.99.57-1.53 2.25-.12.8.61-2.76 3.12-1.68 7.65-.39 11.17 3.3 8.5 8.34 16.17 12.7 24.14.04.16 1.08 1.8.66 1.28zm-.6.83zm12.58 1.3c.03 1.33.67.76-.45 2.14-1.35 1.98-4.08 1.8-5.93.67-2.2-1.16-4.17-2.68-6.2-4.11.55-1.63 1.65.16 2.53.56 2.17 1.38 4.32 3.42 7.04 3.38 1.55-.14 1.96-1.88 3.01-2.64zm-.45.27zm.45.75zm.46-.72z'/%3E %3Cpath d='M359.11 213.58a33.86 33.86 0 0 1-1.25-4.72c-.54-2.7-.3-5.52.6-8.15-2.98-4.21-6.32-8.78-8.73-13.33-1.72-3.24-3.04-6.86-2.03-10.56 1.08-3.94 4.5-6.63 7.58-9 3.7-2.85 8.62-5.35 13.61-7.47 11.17-4.64 20.05-6.9 26.56-7.11l-4.13 3.83c-12.11 3.92-26.4 9.09-33.28 14.38-8.9 6.85-8.68 8.47 4.23 26.76.4.57 1.33 2.02 1.02 2.68-.62 1.31-1.76 7.34.13 11.49-1.11 2.1-2.73 1-4.31 1.2z' fill='%23edb92e'/%3E %3Cpath fill='%2321231e' d='M357.37 208.96c1.2-.7 1.12.5 1.32 1.35.25 1.05.55 2.08.9 3.1-.77.51-1.16.24-1.26-.6-.4-1.26-.72-2.58-.96-3.85zm1-.2zm-.33-7.76c1.08-1.17.92.16.56 1-.59 2.2-.69 4.52-.24 6.76-1.18.67-1.15-.51-1.22-1.39-.22-2.3.09-4.64.84-6.83l.06.46zm.83-.59zm-9.58-12.79c.88-.9 1.2.01 1.59.79 2.37 4.18 5.22 8.08 7.99 12-.76 1.02-1.2.13-1.67-.6-2.8-3.95-5.63-7.9-7.91-12.19zm-2.08-10.93c1.2-.04.9.75.72 1.58-.39 3.12.81 6.16 2.25 8.87-.86.89-1.2.03-1.52-.77-1.44-2.97-2.37-6.41-1.45-9.68zm7.76-9.28c1.04.73.16 1.2-.55 1.7-2.62 2.08-5.31 4.5-6.24 7.85-1.34.06-.8-.97-.44-1.77 1.49-3.31 4.43-5.62 7.23-7.78zm13.73-7.54c.86 1-.17 1.21-.98 1.54-4.24 1.89-8.43 3.99-12.13 6.8-1.2-.83.13-1.33.84-1.87a71.08 71.08 0 0 1 12.27-6.47zm0 0zm27.1-6.26c-1.33-1.57.38.52-1.1.17-8.9.63-17.4 3.71-25.62 7.04-.93-1.1.44-1.25 1.25-1.61 8.05-3.16 16.4-6.06 25.1-6.48l.37.88zm-.36-.88c1.59-.45 1.23.54.3.73l-.3-.73zm-4.46 3.97l4.13-3.84c1.31.75-.09 1.38-.7 2.05-1 .87-1.9 1.84-2.93 2.65l-.5-.86zm.69.75zm-33.32 14.4c-1.17-.8.06-1.3.78-1.81 7.13-4.63 15.18-7.56 23.13-10.45 2.96-1.04 5.93-2.04 8.9-3 .87 1.2-.59 1.2-1.42 1.54-9.46 3.17-19 6.39-27.72 11.3-1.26.74-2.5 1.53-3.67 2.43zm4.33 26.06c-.86 1.2-1.29-.13-1.83-.84-3.13-4.63-6.65-9.12-8.8-14.33-1.05-2.44-.88-5.45.97-7.47 1.35-1.63 3.05-2.92 4.71-4.22 1.2.83-.14 1.33-.8 1.92-2.15 1.76-4.84 3.95-4.5 7.05.56 3.8 2.95 6.98 4.93 10.16 1.72 2.61 3.52 5.17 5.32 7.73zm1.07 3.2c-.57-.21-1.04-.37-1.01-1.03a7.45 7.45 0 0 0-.88-1.58c.65-.85 1.12-.43 1.44.38.34.67.76 1.48.45 2.23zm.12 11.5c-1.12-.67-.96.26-1.38-1.3-.95-3.46-.81-7.25.34-10.64 1.22.16.72.98.51 1.8-.69 3.25-.67 6.74.54 9.85V212.62zm.02-.45zm-4.78.9c.26 1.87-.58-.07.44-.02 1.19.06 2.86.56 3.43-.9 1.14.2.81.97.1 1.5-1.11.97-2.62.34-3.9.44l-.07-1.01zm0 1.03c-.43-1.42.94-.87 0 0zm.48-.68z'/%3E %3Cpath d='M468.14 132.2c.11-2.32-.04-1.92-.39 1.65-.37-.72-.86-1.05-1.45-1.03-1.05.01-1.68 1.61-1.79 5.22l.2 2.76c-33.07-.74-52.67 4.28-57.72 13.92-4.16 7.93 2.91 21.06 13.58 36.05 1.3 1.82 1.25 1.66 0 3.16-1.8 2.16-3.75 5.82-2.29 9.04-6.46 3.56-14.16 4.43-20.87 1.48-1.11-2.96-3.53-4.37-5.49-5.71-.4-.28-1.83-.98-1.98-1.44-3.52-11.35-7.06-21.85-10.1-31.62-9.54-30.68 75.24-33.5 88.3-33.48z' fill='%23edb92e'/%3E %3Cpath fill='%2321231e' d='M467.31 134.09c1.79-.7-.88.09.1-1.72.1-.7-.02-2.45 1.08-1.93.62.77-.01 2.58-.84 1.53-.18-1.4.15-.73.96-.99-.3.93 0 2.34-.58 2.97l-.72.14zm.95-.19c.63 2.82-1.74.42-.25.05l.23-.04h.02zm-1.95-.57c-.33-.92.17-1.28.9-.8.53.3 1.51 1.23.37 1.42-.43.36-.62-.8-1.27-.62zm0 0zm-1.28 4.68c-1.6.63-.84-1.2-.87-2.08.2-1.36.44-3.43 2.13-3.62.35.91-.3 1.03-.65 1.69-.51 1.23-.56 2.85-.61 4zm-1.01.06zm.68 3.24c.38-1.77-.75.25-.55-1.33.11-.71-.65-2.2.57-1.95.65.02.24 1.25.43 1.8.05.62.2 1.07-.45 1.48zm.51-.54zm-57.77 14.2c-1.86-.47.38-2.14.87-3.04 5.18-5.62 12.95-7.71 20.18-9.27 11.92-2.32 24.12-2.59 36.23-2.37.41 1.9-2.2.64-3.31.97-13.43-.03-27.1.35-40.05 4.27-5.32 1.76-11.07 4.3-13.92 9.43zM421 190.47c-1.23 1.47-1.76-1.29-2.62-1.97-5.12-7.61-10.47-15.44-12.64-24.48-.68-3.15-.71-6.62.82-9.55 1.77.4-.19 2.02-.03 3.19-.97 6.4 2.12 12.5 4.98 18 2.82 5.15 6.1 10.03 9.49 14.81zm-.02 3.78c-1.33-.52-.22-1.07.05-1.83-.33-.8-1.36-1.51-.03-1.95.83.89 1.57 2.34.4 3.29-.15.16-.29.33-.42.5zm-2.44 9.16c-.6-1.17-1.05-.04-1.22-2.14-.27-2.84 1.13-5.54 2.88-7.68 1.44.57.02 1.39-.35 2.22-1.27 2.01-2.13 4.64-1.09 6.94l-.22.66zm.22-.66zm-21.8 1.88c1.03-1 1.51-.12 3.17.26 5.98 1.74 12.54.62 17.93-2.38 1.3 1.45-1.6 1.65-2.48 2.3-5.82 2.38-12.81 2.78-18.52-.07l-.1-.11zm.27.28zm-5.57-5.75c.48-1.62 1.63.05 2.49.48a10.14 10.14 0 0 1 3.75 4.63c-1.16.96-1.2-.6-1.79-1.27-1.11-1.66-2.83-2.75-4.45-3.84zm-2.18-1.71c.74-.55 1.14-.24 1.72.25.79.32 1.38.82.42 1.44-.73-.5-1.74-.84-2.14-1.7zm-10.1-31.62c1.54-1 1.24 1.55 1.82 2.44 3.04 9.63 6.25 19.22 9.24 28.87-1.62 1-1.28-1.79-1.9-2.71-3-9.55-6.19-19.04-9.17-28.6zm88.27-33.66c2.32.15-.97.8-1.86.56-18.49.47-37.05 2.06-55.08 6.32-8.9 2.29-18.1 5.02-25.34 10.94-3.7 3.04-6.31 7.75-5.64 12.64.1 1.03 1.21 3.66-.4 2.97a14.3 14.3 0 0 1 2.82-13.75c5.03-5.87 12.48-8.89 19.64-11.33 16.13-5.13 33.09-7.03 49.91-8.22 5.48-.34 10.97-.6 16.46-.61l-.5.48zm1.01.05zm-.5-.02zm.5.02z'/%3E %3Cpath d='M404.99 190.16a6.4 6.4 0 0 1 6.37 6.41c0 3.55-2.85 6.42-6.37 6.42s-6.37-2.87-6.37-6.42a6.4 6.4 0 0 1 6.37-6.41z' fill='%23FFF'/%3E %3Cpath d='M411.87 196.57h-1.01a5.93 5.93 0 0 0-5.86-5.9v-1.02a6.88 6.88 0 0 1 6.87 6.92zM405 203.5v-1.02a5.87 5.87 0 0 0 5.86-5.91h1.01a6.96 6.96 0 0 1-3.26 5.9 6.85 6.85 0 0 1-3.61 1.03zm-6.88-6.93h1.02a5.93 5.93 0 0 0 5.86 5.9v1.03a6.88 6.88 0 0 1-6.88-6.93zm6.88-6.92v1.01a5.87 5.87 0 0 0-5.86 5.91h-1.02a6.96 6.96 0 0 1 3.26-5.89 6.85 6.85 0 0 1 3.62-1.03z' fill='%2321231e'/%3E %3Cpath d='M350.75 203.61a5.93 5.93 0 0 1 5.91 5.96c0 3.29-2.65 5.95-5.91 5.95a5.94 5.94 0 0 1-5.91-5.95 5.93 5.93 0 0 1 5.91-5.96z' fill='%23FFF'/%3E %3Cpath d='M357.17 209.56h-1.01a5.47 5.47 0 0 0-5.4-5.45v-1.02a6.43 6.43 0 0 1 6.41 6.47zm-6.42 6.47V215a5.42 5.42 0 0 0 5.4-5.45h1.02a6.5 6.5 0 0 1-6.42 6.47zm-6.42-6.47h1.01a5.47 5.47 0 0 0 5.41 5.45v1.02a6.43 6.43 0 0 1-6.42-6.47zm6.42-6.47v1.02a5.42 5.42 0 0 0-5.4 5.45h-1.02a6.4 6.4 0 0 1 6.42-6.47z' fill='%2321231e'/%3E %3Cpath d='M345.1 192.72a5.94 5.94 0 0 1 5.91 5.96 5.94 5.94 0 0 1-5.91 5.95 5.93 5.93 0 0 1-5.91-5.95 5.93 5.93 0 0 1 5.91-5.96z' fill='%23FFF'/%3E %3Cpath d='M351.52 198.68h-1.01a5.47 5.47 0 0 0-5.4-5.45v-1.02a6.43 6.43 0 0 1 6.41 6.47zm-6.42 6.47v-1.02a5.42 5.42 0 0 0 5.4-5.45h1.02a6.5 6.5 0 0 1-3.04 5.5 6.4 6.4 0 0 1-3.38.97zm-6.42-6.47h1.02a5.47 5.47 0 0 0 5.4 5.45v1.02a6.42 6.42 0 0 1-6.42-6.47zm6.42-6.47v1.02a5.41 5.41 0 0 0-5.4 5.45h-1.02a6.42 6.42 0 0 1 6.42-6.47z' fill='%2321231e'/%3E %3Cpath d='M339.79 181.71a5.93 5.93 0 0 1 5.91 5.96 5.93 5.93 0 0 1-5.91 5.95 5.94 5.94 0 0 1-5.91-5.95 5.93 5.93 0 0 1 5.91-5.96z' fill='%23FFF'/%3E %3Cpath d='M346.21 187.66h-1.01a5.47 5.47 0 0 0-5.4-5.45v-1.02a6.42 6.42 0 0 1 6.41 6.47zm-6.42 6.47v-1.02a5.41 5.41 0 0 0 5.4-5.45h1.02a6.5 6.5 0 0 1-3.01 5.48 6.4 6.4 0 0 1-3.4.99zm-6.42-6.47h1.02a5.47 5.47 0 0 0 5.4 5.45v1.02a6.43 6.43 0 0 1-6.42-6.47zm6.42-6.47v1.02a5.42 5.42 0 0 0-5.4 5.45h-1.02a6.5 6.5 0 0 1 6.42-6.47z' fill='%2321231e'/%3E %3Cpath d='M444.27 202.15c3.42-.23 2.57 5.9 1.9 7.26-.88 1.78-1.7 1.84-2.81.19-.85-1.26-2.5-7.22.91-7.45z' fill='%23edb92e'/%3E %3Cpath fill='%2321231e' d='M446.62 209.63l-.9-.45c.32-.78.44-1.63.52-2.46a6.72 6.72 0 0 0-.35-3.08c-.2-.46-.58-.88-1.1-.96a2.1 2.1 0 0 0-.48-.03l-.07-1.01c.64-.05 1.32.12 1.81.55.71.6 1.02 1.54 1.15 2.44.18 1.32.06 2.67-.24 3.97-.08.35-.19.7-.34 1.03zm-3.68.25l.84-.57c.25.35.5.74.9.94.26.1.45-.17.6-.34.17-.23.3-.48.44-.73l.9.45c-.31.61-.68 1.28-1.34 1.57-.52.23-1.12.02-1.52-.35a4.97 4.97 0 0 1-.82-.97zm1.3-8.25l.07 1.02c-.5.03-.99.26-1.23.7-.38.66-.4 1.47-.35 2.22.1 1.15.37 2.3.84 3.36l.2.38-.83.57a8.71 8.71 0 0 1-.95-2.51 8.16 8.16 0 0 1-.16-3.58c.17-.76.6-1.5 1.32-1.86.33-.18.71-.26 1.09-.3z'/%3E %3Cpath d='M444.49 205.46c8.03-.55 6.04 13.85 4.46 17.05-2.07 4.2-4 4.32-6.6.45-2-2.96-5.89-16.95 2.14-17.5z' fill='%23FFF'/%3E %3Cpath fill='%2321231e' d='M449.4 222.74l-.9-.45c.74-1.73 1.03-3.61 1.25-5.46.23-2.54.24-5.19-.62-7.62-.47-1.31-1.37-2.58-2.75-3.03-.6-.2-1.23-.24-1.86-.21l-.07-1.02c1.36-.1 2.78.25 3.81 1.15 1.5 1.3 2.13 3.29 2.42 5.19.43 3.03.17 6.14-.5 9.12-.2.8-.43 1.59-.78 2.33zm-7.47.5l.84-.56c.67.94 1.37 1.97 2.45 2.47.74.33 1.5-.2 1.96-.75.54-.64.94-1.37 1.32-2.11l.9.45c-.64 1.23-1.35 2.57-2.6 3.26-.94.53-2.1.2-2.88-.45a10.3 10.3 0 0 1-1.99-2.3zm2.56-17.27v-1.02l.03 1.02c-1.23.07-2.49.6-3.2 1.66-1.04 1.48-1.2 3.37-1.18 5.13.1 2.89.78 5.75 1.86 8.42.22.51.46 1.02.77 1.5l-.84.57a19.76 19.76 0 0 1-2.1-5.53c-.62-2.64-.99-5.43-.43-8.13.35-1.62 1.23-3.23 2.75-4.01.7-.39 1.5-.56 2.3-.63l.04 1.02zm0-1.02v1.02l-.04-1.02h.04z'/%3E %3Cpath d='M379.74 210.81c3.26-1.05 3.9 5.1 3.56 6.6-.43 1.94-1.21 2.19-2.68.85-1.13-1.02-4.14-6.4-.88-7.45z' fill='%23edb92e'/%3E %3Cpath fill='%2321231e' d='M383.79 217.51l-.99-.22c.13-.77.06-1.56-.04-2.33-.16-1.01-.4-2.04-.96-2.9-.3-.47-.8-.9-1.38-.86a2 2 0 0 0-.53.09l-.3-.97c.6-.2 1.29-.2 1.87.09.83.4 1.35 1.23 1.7 2.06.5 1.27.7 2.64.72 4 0 .35-.02.7-.09 1.04zm-3.51 1.13l.67-.76c.34.28.69.62 1.13.7.26.01.38-.28.47-.47.12-.26.19-.54.25-.82l.99.22c-.16.67-.36 1.4-.93 1.85-.45.34-1.07.29-1.54.03-.39-.2-.72-.47-1.04-.75zm-.7-8.32l.31.97c-.48.14-.9.5-1.03 1a4.1 4.1 0 0 0 .22 2.3c.37 1.07.9 2.1 1.6 2.99l.27.3-.67.76a8.77 8.77 0 0 1-1.53-2.24 8.18 8.18 0 0 1-.99-3.38c-.02-.8.23-1.63.84-2.15.28-.26.63-.43.98-.55z'/%3E %3Cpath d='M380.74 213.97c7.67-2.46 9.14 12 8.36 15.5-1.02 4.56-2.85 5.14-6.3 2.01-2.64-2.4-9.73-15.05-2.06-17.51z' fill='%23FFF'/%3E %3Cpath fill='%2321231e' d='M389.6 229.58l-.99-.22c.32-1.86.16-3.75-.07-5.6-.38-2.53-1-5.1-2.4-7.25-.79-1.2-2.04-2.25-3.53-2.3a5.16 5.16 0 0 0-1.71.25l-.3-.97a5.23 5.23 0 0 1 3.97.2c1.77.92 2.86 2.72 3.59 4.5 1.12 2.84 1.59 5.9 1.64 8.94 0 .82-.03 1.65-.2 2.45zm-7.14 2.29l.68-.76c.87.76 1.8 1.59 2.97 1.81.8.15 1.41-.54 1.72-1.2.38-.74.6-1.55.78-2.36l.99.22c-.33 1.35-.7 2.82-1.76 3.8-.78.73-1.99.7-2.9.24a10.26 10.26 0 0 1-2.48-1.75zm-1.87-18.38l.3.97a4.15 4.15 0 0 0-2.74 2.43c-.66 1.78-.32 3.73.18 5.5.8 2.7 2.11 5.26 3.78 7.53.31.42.65.83 1.03 1.2l-.68.75a19.73 19.73 0 0 1-3.34-4.86c-1.23-2.43-2.25-5.05-2.34-7.8-.05-1.66.43-3.44 1.72-4.56a5.9 5.9 0 0 1 2.09-1.16zm.15.49c-.11-.37-.2-.64-.03-.12l.03.12z'/%3E %3Cpath d='M464.2 137.77c-17.23-1.57-34.85.2-52.3 7.17-14.7 5.88-13.26 23.06 4.67 46.9-1.62 3.01-2.55 6.77-2.7 11.1 1.9-.1 3.23-.05 4.9-.1-1.3-2.88.16-6.42 1.8-8.91 1.07-1.63 1.3-1.34 0-3.16-10.67-15-17.74-28.12-13.58-36.05 5.05-9.64 24.66-14.66 57.71-13.92l-.18-2.67-.32-.36z' fill='%23edb92e'/%3E %3Cpath fill='%2321231e' d='M412.09 145.42c-1.04-1.31.96-1.3 1.79-1.78 15.99-6.06 33.39-7.97 50.37-6.37.35 1.66-1.47.72-2.44.82-16.86-1.28-34 1-49.72 7.33zm4.93 46.66c-1.2-.55-.95.17-1.95-1.42-5.67-7.88-11.01-16.38-13.12-25.97-1.2-5.52-.66-11.96 3.52-16.15a17.8 17.8 0 0 1 6.25-4.07c1.05 1.32-.99 1.31-1.75 1.95a13.8 13.8 0 0 0-7.52 11.77c-.35 7.5 2.87 14.6 6.4 21.04 2.4 4.3 5.18 8.36 8.12 12.3l.05.55zm-.05-.55zm-3.12 10.9c.37 1.81-.87.28-.42-.69a25.1 25.1 0 0 1 2.7-10.15c1.56.3.21 1.47 0 2.39a26.6 26.6 0 0 0-1.75 8.98l-.53-.52zm.06 1.02zm4.4-.4c1.66-.99.34.84-.73.32-1.23 0-2.45 0-3.67.08-.57-1.5 1.14-.96 2.06-1.09.93 0 1.86 0 2.8-.02l-.45.72zm.93-.41zm.91-8.99c1.45.4.23 1.34-.1 2.18-1.04 2.06-1.78 4.58-.8 6.8-1.2 1.1-1.33-.7-1.45-1.59-.2-2.65.95-5.21 2.35-7.39zm.01-2.58c.8-1.12 1.33.02 1.7.8.4.9-.44 1.64-.86 2.34-1.24-.36-.51-1.04-.06-1.76.01-.51-.57-.95-.78-1.38zm-13.62-36.59c1.58.29.2 1.5.13 2.48-1.25 5.38.99 10.79 3.22 15.6 3.1 6.32 7.04 12.18 11.1 17.92-1 1.33-1.47-.58-2.14-1.27-5-7.32-10.09-14.84-12.7-23.41-1.02-3.67-1.43-7.82.4-11.32zm57.66-13.65c1.96-.31-.03.92-.98.45-13-.14-26.16.19-38.83 3.36-5.86 1.62-12.12 3.82-15.98 8.79-.28.96-1.7 2.15-1.68.73 3.17-5.4 9.3-8.01 15.01-9.83 12.14-3.54 24.9-4.05 37.48-4.1 1.83 0 3.66.03 5.5.06l-.52.54zm1.01-.07zm-1.07-2.29c.73-1.05 1.02-.34.95.55-.07.55.33 1.5-.06 1.76-.99.42-.88-.43-.9-1.1 0-.37-.18-1.55-.04-1.34l.05.13zm.76-.67zm-1.06-.39c.67 1.07.67.25.83.13.55.32-.37.8-.58.88-.22-.15-.38-.54-.25-1zm0 .71zm.72.01zm-.31-.86z'/%3E %3Cpath d='M380.59 142.66c3.4 0 6.14 2.77 6.14 6.19s-2.75 6.18-6.14 6.18-6.14-2.77-6.14-6.18 2.75-6.19 6.14-6.19z' fill='%23FFF'/%3E %3Cpath d='M387.24 148.84h-1.01a5.7 5.7 0 0 0-5.64-5.67v-1.02a6.65 6.65 0 0 1 6.65 6.69zm-6.65 6.7v-1.02a5.64 5.64 0 0 0 5.64-5.68h1.01a6.72 6.72 0 0 1-3.15 5.7 6.6 6.6 0 0 1-3.5 1zm-6.64-6.7h1a5.7 5.7 0 0 0 5.64 5.68v1.02a6.65 6.65 0 0 1-6.64-6.7zm6.64-6.7v1.02a5.64 5.64 0 0 0-5.63 5.68h-1.01a6.72 6.72 0 0 1 3.12-5.67 6.6 6.6 0 0 1 3.52-1.03z' fill='%2321231e'/%3E %3Cpath d='M392.62 138.7c3.4 0 6.14 2.77 6.14 6.19a6.16 6.16 0 0 1-6.14 6.18 6.16 6.16 0 0 1-6.14-6.18 6.16 6.16 0 0 1 6.14-6.19z' fill='%23FFF'/%3E %3Cpath d='M399.27 144.88h-1.01a5.7 5.7 0 0 0-5.64-5.67v-1.02a6.65 6.65 0 0 1 6.65 6.69zm-6.65 6.7v-1.02a5.64 5.64 0 0 0 5.64-5.68h1.01a6.73 6.73 0 0 1-3.15 5.7c-1.04.65-2.27 1-3.5 1zm-6.64-6.7h1.01a5.7 5.7 0 0 0 5.63 5.68v1.02a6.65 6.65 0 0 1-6.64-6.7zm6.64-6.7v1.02a5.64 5.64 0 0 0-5.63 5.68h-1.01a6.73 6.73 0 0 1 3.18-5.71 6.62 6.62 0 0 1 3.46-.99z' fill='%2321231e'/%3E %3Cpath d='M394.22 143.97c.6.82 1.22 1.64 1.84 2.46-9.7 5.36-13.72 11.01-12.77 16.7.16.97 3.1 11.38 9.7 31.55 4.5 3.13 7.86 5.93 10.07 8.4-.25.3.7 1.17.42 1.4.68 3.09-2.77 2.46-5.09 1.7-1.11-2.96-4.51-6.1-6.47-7.44-.4-.28-1.83-.98-1.98-1.44-3.52-11.35-7.07-21.85-10.1-31.62-3.06-9.82 3.56-16.78 14.38-21.71z' fill='%23edb92e'/%3E %3Cpath fill='%2321231e' d='M396.31 146.88c-.46-1.35-.47-.23-.82-.37l-1.67-2.23c.6-.76 1.06-.54 1.44.24.36.59 1 1.11 1.18 1.74l-.13.62zm.16-.76zm-12.68 16.93c-.94.45-1.2-.06-1.12-.95-.28-4.56 2.7-8.52 6.03-11.3a43.31 43.31 0 0 1 7.12-4.81c.9.86.03 1.2-.75 1.6-4.2 2.52-8.53 5.56-10.61 10.17a9.43 9.43 0 0 0-.67 5.3zm0 0zm9.5 31.22c-.5 1.28-.95.47-1.12-.47-3.23-10.05-6.52-20.07-9.3-30.25-.19-.7 1.39-.67 1.1.25 2.88 10.33 6.2 20.53 9.5 30.73l-.19-.26zm-.58.84zm10.73 8.33c-.92-1.32-.53.43-1.17-.46-2.85-3-6.18-5.5-9.56-7.87.37-1.2 1.06-.58 1.74-.02 3.2 2.3 6.34 4.74 9 7.67v.68zm0-.68zm.54 1.63c-.9.63-.96-.46-.94.02-.24-.5-.8-1.1-.35-1.65.36.56.8.47.92.6.28.43.7 1.09.2 1.53l.17-.5zm-.98.22zm-5.07 1.76c1.28-.14.26-.95 1.42-.43 1.12.23 2.57.76 3.55-.07.38-.65-.23-1.56.9-1.44.49.17.28 1.35.04 1.84-1 1.55-3.16 1.05-4.66.68-.44-.14-.96-.17-1.25-.58zm.31.3zm-6.6-7.5c.34-1.13.98-.72 1.61-.07 2.29 1.9 4.48 4.12 5.62 6.91-.83.62-1.15.13-1.42-.67a20.37 20.37 0 0 0-5.8-6.17zm.57-.85zm-2.74-.86c.5-.07.95-.59 1.29-.03.46.33.98.58 1.45.9-.3.63-.63 1.06-1.22.45-.55-.36-1.26-.68-1.52-1.32zm-10.1-31.62c1.05-.74 1.18.29 1.4 1.14 3.17 10.08 6.54 20.09 9.66 30.17-1 .7-1.18-.16-1.38-1.02-3.15-10.12-6.53-20.17-9.69-30.29zm15.26-22.17c-1.47.64.43.73-.94 1.12-5 2.42-10.12 5.56-12.76 10.65-1.6 3.1-1.66 6.81-.6 10.1-1 .7-1.2-.17-1.32-1.04a14.11 14.11 0 0 1 2.92-12.46c3.18-3.87 7.6-6.45 12.09-8.53l.61.16zm-.61-.16z'/%3E %3Cpath d='M355.95 216.87l-.37 1.98c-2.82.66-5.24.82-7.24.5 3.35-3.3 5.85-4 7.61-2.48z' fill='%23edb92e'/%3E %3Cpath fill='%2321231e' d='M355.08 218.76l.37-1.98 1 .19-.38 1.98-.38.4-.61-.59zm1 .19c-.05.1-.01.28-.1.34-.08 0-.37.12-.23 0l.32-.34zm-8.1.03l.7.73-.27-.86c2.09.33 4.22.1 6.28-.32l.77-.17.23.99c-2.21.51-4.5.83-6.78.59a12.2 12.2 0 0 1-.66-.09l-.27-.87zm.27.87l-.99-.16.72-.7.27.86zm8.2-2.88l-1-.19.16.48a2.52 2.52 0 0 0-1.98-.63 6.23 6.23 0 0 0-2.77 1.23c-.78.55-1.5 1.19-2.18 1.85l-.7-.73a15 15 0 0 1 3.69-2.8c.97-.47 2.1-.76 3.18-.47.53.15 1.01.42 1.42.78l.17.48zm-.18-.48c.07.09.26.14.21.27-.02.16-.04.27-.1.05l-.1-.32zm-.33.38l.5.1-.5-.1zm.33-.38c.07.09.26.14.21.27-.02.16-.04.27-.1.05l-.1-.32z'/%3E %3Cpath d='M355.64 212.34c1.77.4 1.93.7 2.7.83 1 .17 2.36.1 3.3-.73 3.84-2.32 3.93 1.86 2.43 4.99-1.08 2.26-.52 4.82.51 6.76 1.22 2.3.96 3.34.1 3.96l-1.68 1.1c-1.03 1.22-1.82 1.01-1.96-.6-3.84-1.59-5.1-5.29-6.25-8.55-1.68-4.76-7.77-5.9.85-7.76z' fill='%23edb92e'/%3E %3Cpath fill='%2321231e' d='M358.43 212.66l-.17 1c-.83-.17-1.59-.6-2.43-.76-.43.03-.24-.32-.19-.6.03-.34.12-.57.48-.38.77.15 1.48.52 2.24.73l.07.01zm2.95-.66l.52.87c.1-.06-.39.32-.56.39-.94.5-2.05.58-3.08.4l.17-1c1.01.17 2.16.05 2.95-.66zm-.07.05zm3.22 5.59l-.91-.44c.56-1.26 1-2.66.78-4.05-.05-.49-.46-.99-1-.87a3.9 3.9 0 0 0-1.5.59l-.52-.87c.88-.52 2.02-1.04 3.02-.54.96.52 1.13 1.75 1.07 2.74a9.68 9.68 0 0 1-.94 3.44zm.5 6.3l-.9.49c-1.14-2.13-1.6-4.78-.6-7.05.08-.39.48.09.7.12.44.06.2.36.1.62-.7 1.92-.24 4.07.7 5.82zm-.08 4.63c-.19-.27-.37-.62-.57-.84.62-.38.6-1.2.4-1.8a8.2 8.2 0 0 0-.65-1.5l.9-.49c.54 1.08 1.14 2.32.76 3.54a2.2 2.2 0 0 1-.84 1.1zm.02-.01l-.02.01.02-.01zm-1.59 1l-.77-.65c.57-.43 1.2-.78 1.79-1.2l.55.86-1.68 1.1.11-.1zm-.77-.65zm-1.77.2l.39-.94c.19.24.36.48.36.8.05.18.07.44.25.54.33-.08.55-.37.77-.6l.77.65c-.46.56-1.19 1.2-1.96.89-.66-.31-.83-1.1-.9-1.76l.32.43zm.39-.94c.34-.07.4.7.16.23l-.16-.23zm-6.92-7.9l.95-.35c.86 2.43 1.74 5 3.68 6.8.67.61 1.45 1.1 2.29 1.45l-.39.95a9.53 9.53 0 0 1-4.76-4.55c-.74-1.37-1.26-2.84-1.77-4.3zm1.33-8.45v1.02c.19-.01-.5.12-.65.16-1.07.29-2.22.5-3.14 1.14-.42.24-.1.72.1.99 1.01 1.25 2.2 2.39 2.91 3.85.15.3.28.62.4.94l-.95.34c-.58-1.7-1.88-2.99-3.01-4.33-.48-.57-.93-1.41-.49-2.12.55-.83 1.58-1.1 2.46-1.4.78-.24 1.57-.44 2.37-.59zm-.1.01zm.1 1.01v-1.02c.24.08-.02.56.02.8l-.02.22zm0-1.02z'/%3E %3Cpath d='M357.15 212.5c3.34 1.2 3.7-.67 5.96-.57-.89 5.14-1.78 7.8-7.11 5.04-2.94-1.52-6.7.7-7.42 2.36-.26.6-1.97-.65-2.6-2.02-2.6-5.76 6.7-6.42 11.17-4.81z' fill='%23edb92e'/%3E %3Cpath fill='%2321231e' d='M363.61 212.02l-1-.18.48.6c-1.24-.1-2.23.83-3.43.94-.91.12-1.82-.1-2.68-.4l.34-.96c.99.37 2.12.56 3.12.1a5.65 5.65 0 0 1 2.7-.7l.47.6zm-.48-.6c.2.06.7-.11.54.23 0 .38-.1.4-.3.08l-.24-.3zm-7.36 6l.46-.9c1.1.54 2.29 1.12 3.55 1.04.9-.07 1.51-.87 1.82-1.65.54-1.3.76-2.7 1.01-4.07l1 .18c-.3 1.64-.55 3.35-1.35 4.84a3.05 3.05 0 0 1-2.54 1.72c-1.4.07-2.73-.54-3.95-1.15zm-6.72 2.12c-.3-.14-.62-.27-.93-.4a5.82 5.82 0 0 1 2.87-2.53 6.02 6.02 0 0 1 5.24-.09l-.46.9c-1.55-.8-3.43-.44-4.9.4-.71.42-1.44.95-1.82 1.72zm-3.52-2.02l.92-.42c.39.77 1 1.47 1.78 1.85.26 0-.36.2.04.25l.78.34c-.21.52-.89.55-1.32.3a5.15 5.15 0 0 1-2.2-2.32zm11.8-5.5l-.35.96c-2.09-.7-4.34-.86-6.53-.61-1.3.18-2.69.5-3.68 1.42-.71.62-.88 1.67-.6 2.54.07.27.18.51.28.77l-.92.42c-.49-1.07-.72-2.36-.2-3.47.64-1.3 2.02-2 3.35-2.37a15.83 15.83 0 0 1 8.64.34zm-.18.48c.07-.18.25-.7.09-.24l-.09.24z'/%3E %3Cpath d='M458.84 124.49c3.38 0 6.11 2.76 6.11 6.16s-2.73 6.16-6.11 6.16c-3.38 0-6.11-2.76-6.11-6.16s2.73-6.16 6.11-6.16z' fill='%23FFF'/%3E %3Cpath d='M465.46 130.64h-1.01a5.67 5.67 0 0 0-5.6-5.65v-1.02a6.62 6.62 0 0 1 6.61 6.67zm-6.62 6.67v-1.02a5.61 5.61 0 0 0 5.6-5.65h1.02a6.7 6.7 0 0 1-3.14 5.67c-1.03.65-2.25 1-3.48 1zm-6.62-6.67h1.02a5.67 5.67 0 0 0 5.6 5.65v1.02a6.63 6.63 0 0 1-6.62-6.67zm6.62-6.67V125a5.62 5.62 0 0 0-5.6 5.65h-1.02a6.7 6.7 0 0 1 3.14-5.67c1.04-.65 2.26-1 3.48-1z' fill='%2321231e'/%3E %3Cpath d='M446.31 124.49c3.38 0 6.11 2.76 6.11 6.16s-2.73 6.16-6.11 6.16-6.11-2.76-6.11-6.16 2.73-6.16 6.11-6.16z' fill='%23FFF'/%3E %3Cpath d='M452.93 130.64h-1.01a5.67 5.67 0 0 0-5.6-5.65v-1.02a6.63 6.63 0 0 1 6.61 6.67zm-6.62 6.67v-1.02a5.62 5.62 0 0 0 5.6-5.65h1.02a6.7 6.7 0 0 1-3.14 5.67c-1.04.65-2.26 1-3.48 1zm-6.62-6.67h1.01a5.67 5.67 0 0 0 5.61 5.65v1.02a6.63 6.63 0 0 1-6.62-6.67zm6.62-6.67V125a5.62 5.62 0 0 0-5.6 5.65h-1.02a6.7 6.7 0 0 1 3.14-5.67c1.04-.65 2.26-1 3.48-1z' fill='%2321231e'/%3E %3Cpath d='M433.79 125.48a6.14 6.14 0 0 1 6.11 6.16c0 3.4-2.73 6.16-6.11 6.16s-6.11-2.76-6.11-6.16c0-3.4 2.73-6.16 6.11-6.16z' fill='%23FFF'/%3E %3Cpath d='M440.41 131.63h-1.01a5.67 5.67 0 0 0-5.6-5.65v-1.02a6.63 6.63 0 0 1 6.61 6.67zm-6.62 6.67v-1.02a5.62 5.62 0 0 0 5.6-5.65h1.02a6.7 6.7 0 0 1-3.14 5.67c-1.04.65-2.26 1-3.48 1zm-6.62-6.67h1.02a5.67 5.67 0 0 0 5.6 5.65v1.02a6.62 6.62 0 0 1-6.62-6.67zm6.62-6.67v1.02a5.61 5.61 0 0 0-5.6 5.65h-1.02a6.7 6.7 0 0 1 6.62-6.67z' fill='%2321231e'/%3E %3Cpath d='M422.25 127.7a6.13 6.13 0 0 1 6.11 6.16c0 3.4-2.73 6.16-6.11 6.16a6.14 6.14 0 0 1-6.11-6.16c0-3.4 2.73-6.16 6.11-6.16z' fill='%23FFF'/%3E %3Cpath d='M428.87 133.86h-1.01a5.67 5.67 0 0 0-5.6-5.65v-1.02a6.63 6.63 0 0 1 6.61 6.67zm-6.62 6.67v-1.02a5.62 5.62 0 0 0 5.6-5.65h1.02a6.7 6.7 0 0 1-3.14 5.67c-1.03.65-2.25 1-3.48 1zm-6.62-6.67h1.02a5.67 5.67 0 0 0 5.6 5.65v1.02a6.62 6.62 0 0 1-6.62-6.67zm6.62-6.67v1.02a5.62 5.62 0 0 0-5.6 5.65h-1.02a6.7 6.7 0 0 1 6.62-6.67z' fill='%2321231e'/%3E %3Cpath d='M346.3 159.43c3.4 0 6.14 2.77 6.14 6.19a6.16 6.16 0 0 1-6.14 6.18 6.16 6.16 0 0 1-6.14-6.18 6.16 6.16 0 0 1 6.14-6.19z' fill='%23FFF'/%3E %3Cpath d='M352.94 165.62h-1.01a5.7 5.7 0 0 0-5.64-5.68v-1.02a6.65 6.65 0 0 1 6.65 6.7zm-6.65 6.7v-1.02a5.64 5.64 0 0 0 5.64-5.68h1.01a6.72 6.72 0 0 1-3.12 5.67 6.6 6.6 0 0 1-3.53 1.03zm-6.64-6.7h1a5.7 5.7 0 0 0 5.64 5.67v1.02a6.65 6.65 0 0 1-6.64-6.69zm6.64-6.7v1.02a5.64 5.64 0 0 0-5.63 5.68h-1.01a6.73 6.73 0 0 1 3.15-5.7c1.04-.65 2.26-1 3.5-1z' fill='%2321231e'/%3E %3Cpath d='M356.82 152.75a6.16 6.16 0 0 1 6.14 6.19c0 3.41-2.75 6.18-6.14 6.18s-6.14-2.77-6.14-6.18 2.75-6.19 6.14-6.19z' fill='%23FFF'/%3E %3Cpath d='M363.47 158.94h-1.01a5.7 5.7 0 0 0-5.64-5.68v-1.02a6.65 6.65 0 0 1 6.65 6.7zm-6.65 6.7v-1.02a5.64 5.64 0 0 0 5.64-5.68h1.01a6.72 6.72 0 0 1-3.12 5.67 6.6 6.6 0 0 1-3.53 1.03zm-6.64-6.7h1.01a5.7 5.7 0 0 0 5.63 5.67v1.02a6.65 6.65 0 0 1-6.64-6.69zm6.64-6.7v1.02a5.64 5.64 0 0 0-5.63 5.68h-1.01a6.72 6.72 0 0 1 3.15-5.7 6.6 6.6 0 0 1 3.5-1z' fill='%2321231e'/%3E %3Cpath d='M368.79 147.09c3.4 0 6.14 2.77 6.14 6.19a6.16 6.16 0 0 1-6.14 6.18 6.16 6.16 0 0 1-6.14-6.18 6.16 6.16 0 0 1 6.14-6.19z' fill='%23FFF'/%3E %3Cpath d='M375.43 153.28h-1.01a5.7 5.7 0 0 0-5.64-5.68v-1.02a6.65 6.65 0 0 1 6.65 6.7zm-6.65 6.7v-1.02a5.64 5.64 0 0 0 5.64-5.68h1.01a6.72 6.72 0 0 1-3.15 5.7c-1.04.65-2.27 1-3.5 1zm-6.64-6.7h1.01a5.7 5.7 0 0 0 5.63 5.68v1.01a6.65 6.65 0 0 1-6.64-6.69zm6.64-6.7v1.02a5.64 5.64 0 0 0-5.63 5.68h-1.01a6.73 6.73 0 0 1 3.15-5.7c1.04-.65 2.26-1 3.5-1z' fill='%2321231e'/%3E %3Cpath d='M338.16 169.49c3.4 0 6.14 2.77 6.14 6.19a6.16 6.16 0 0 1-6.14 6.18 6.16 6.16 0 0 1-6.14-6.18 6.16 6.16 0 0 1 6.14-6.19z' fill='%23FFF'/%3E %3Cpath d='M344.8 175.68h-1.01a5.7 5.7 0 0 0-5.64-5.68v-1.02a6.65 6.65 0 0 1 6.65 6.7zm-6.65 6.7v-1.02a5.65 5.65 0 0 0 5.64-5.68h1.01a6.72 6.72 0 0 1-3.15 5.7 6.6 6.6 0 0 1-3.5 1zm-6.64-6.7h1.01a5.7 5.7 0 0 0 5.63 5.68v1.01a6.65 6.65 0 0 1-6.64-6.69zm6.64-6.7V170a5.64 5.64 0 0 0-5.63 5.68h-1.01a6.73 6.73 0 0 1 3.15-5.7c1.04-.65 2.26-1 3.5-1z' fill='%2321231e'/%3E %3Cpath transform='matrix(1.01066 0 0 1.01824 -5.13 -6.2)' fill='%23edb92e' d='M409.61 280.14l21.77-12.6 23.15 9.85L432.76 290z'/%3E %3Cpath d='M431.11 266.67l-22 12.83-.5-.88 22-12.83.45-.03.05.91zm-.5-.88l.21-.13.24.1-.46.03zm23.44 10.94l-23.4-10.03.4-.94 23.4 10.03.05.91-.45.03zm.4-.94l.93.4-.88.51-.05-.9zm-22.46 12.87l22-12.84.51.88-22 12.84-.45.03-.06-.91zm.5.88l-.21.13-.23-.1.45-.03zm-23.44-10.95l23.4 10.04-.4.94-23.4-10.04-.05-.91.45-.03zm-.4.94l-.93-.4.88-.51.06.9z' fill='%2321231e'/%3E %3Cpath d='M431.13 270.65c5.64-.35 10.4 2.44 10.63 6.23.23 3.8-4.16 7.14-9.8 7.5-5.64.34-10.4-2.45-10.63-6.24-.23-3.79 4.16-7.14 9.8-7.49z' fill='%23c6363c'/%3E %3Cpath fill='%2321231e' d='M442.26 276.85l-1.01.06c-.11-1.9-1.54-3.42-3.13-4.3a12.7 12.7 0 0 0-6.96-1.45l-.07-1.02c3.07-.17 6.33.48 8.78 2.43a6.07 6.07 0 0 1 2.39 4.28zm-10.27 8.03l-.06-1.02c2.8-.18 5.7-1.12 7.72-3.15.99-1 1.7-2.36 1.6-3.8l1.01-.06c.14 2.1-1.08 4.04-2.68 5.3a13.52 13.52 0 0 1-7.6 2.73zm-11.17-6.7l1.01-.07c.11 1.88 1.51 3.4 3.08 4.28 2.12 1.2 4.6 1.61 7.02 1.47l.06 1.02c-3.07.18-6.33-.48-8.78-2.43a6.07 6.07 0 0 1-2.39-4.28zm10.27-8.04l.07 1.02c-2.81.19-5.7 1.12-7.73 3.15-.99 1-1.7 2.37-1.6 3.8l-1 .06c-.15-2.11 1.1-4.07 2.71-5.33a13.54 13.54 0 0 1 7.55-2.7z'/%3E %3Cpath d='M382.38 269.85l23.78 9.07-19.63 13.23c-5.09-1.7-9.12-19.12-4.15-22.3z' fill='%23edb92e'/%3E %3Cpath fill='%2321231e' d='M405.98 279.4l-23.78-9.07c.22-.27.15-1.17.63-.85l23.5 8.97c0 .4.35 1.08-.32.95h-.03zm.36-.95c.26.18 1.3.26.61.55-.49.5-.6.21-.6-.37l-.01-.18zm-20.09 13.27l19.63-13.22c.09.33.85.8.32 1l-19.39 13.07c-.62.3-.46-.41-.55-.8l-.01-.05zm.56.85zm-4.25-23.2c0 .3-.67 1.1-.07.93.31-.01-.56.46-.63.74-1.18 1.74-1.25 3.94-1.23 5.97a27.45 27.45 0 0 0 2.89 11.2c.76 1.36 1.66 2.84 3.17 3.45-.2.27-.11 1.2-.59.86-1.77-.82-2.84-2.6-3.7-4.28a28.55 28.55 0 0 1-2.78-11.48c-.02-2.24.17-4.7 1.6-6.53.37-.38.75-.9 1.34-.86zm-.45.05c.4-.26.55.06 0 0zm.27.43zm-.27-.43c.4-.26.55.06 0 0z'/%3E %3Cpath d='M382.83 274.26c5.62-.58 10.49 2.02 10.87 5.8.38 3.77-3.87 7.3-9.49 7.88-3.65.37-5.92-2.85-6.32-6.26-.4-3.42 1.09-7.02 4.94-7.42z' fill='%230c4076'/%3E %3Cpath fill='%2321231e' d='M394.21 280l-1 .1c-.18-1.77-1.52-3.2-3.03-4.02a12.53 12.53 0 0 0-7.3-1.31l-.1-1.02c2.94-.29 6.06.18 8.55 1.84 1.5 1 2.7 2.57 2.88 4.41zm-9.94 8.44l-.1-1.01c2.7-.3 5.45-1.28 7.39-3.25a5.2 5.2 0 0 0 1.65-4.08l1-.1c.2 1.96-.79 3.85-2.2 5.16-2.08 1.96-4.92 2.98-7.74 3.28zm-6.88-6.7l1-.12c.25 1.99 1.14 4.04 2.88 5.16.85.55 1.9.76 2.9.65l.1 1.01c-1.72.2-3.5-.46-4.68-1.73a8.68 8.68 0 0 1-2.2-4.98zm5.4-7.99l.1 1.02a4.66 4.66 0 0 0-3.63 2.25 7.36 7.36 0 0 0-.86 4.6l-1 .11c-.26-2.22.22-4.68 1.83-6.33a5.71 5.71 0 0 1 3.55-1.65z'/%3E %3Cpath d='M457.46 280.42a3.2 3.2 0 0 1 3.2 3.22c0 1.77-1.44 3.21-3.2 3.21s-3.2-1.44-3.2-3.21a3.2 3.2 0 0 1 3.2-3.22z' fill='%23FFF'/%3E %3Cpath fill='%2321231e' d='M461.16 283.63h-1.01a2.71 2.71 0 0 0-2.69-2.7v-1.03a3.7 3.7 0 0 1 3.7 3.73zm-3.7 3.73v-1.02a2.7 2.7 0 0 0 2.69-2.7h1a3.74 3.74 0 0 1-3.69 3.72zm-3.7-3.73h1.01a2.71 2.71 0 0 0 2.69 2.7v1.03a3.7 3.7 0 0 1-3.7-3.73zm3.7-3.73v1.02a2.7 2.7 0 0 0-2.68 2.7h-1.02a3.75 3.75 0 0 1 3.7-3.72z'/%3E %3Cpath d='M408.71 283.14a3.2 3.2 0 0 1 3.2 3.22c0 1.77-1.44 3.21-3.2 3.21s-3.2-1.44-3.2-3.21a3.2 3.2 0 0 1 3.2-3.22z' fill='%23FFF'/%3E %3Cpath fill='%2321231e' d='M412.41 286.36h-1.01a2.71 2.71 0 0 0-2.69-2.7v-1.03a3.7 3.7 0 0 1 3.7 3.73zm-3.7 3.73v-1.02a2.7 2.7 0 0 0 2.69-2.7h1a3.74 3.74 0 0 1-3.69 3.72zm-3.7-3.73h1.01a2.71 2.71 0 0 0 2.69 2.7v1.03a3.7 3.7 0 0 1-3.7-3.73zm3.7-3.73v1.02a2.7 2.7 0 0 0-2.68 2.7H405a3.75 3.75 0 0 1 3.7-3.72z'/%3E %3Cpath d='M406.99 268.29c1.76 0 3.2 1.44 3.2 3.22s-1.44 3.21-3.2 3.21-3.2-1.44-3.2-3.21 1.44-3.22 3.2-3.22z' fill='%23FFF'/%3E %3Cpath fill='%2321231e' d='M410.69 271.51h-1.01a2.71 2.71 0 0 0-2.69-2.7v-1.03a3.7 3.7 0 0 1 3.7 3.73zm-3.7 3.73v-1.02a2.7 2.7 0 0 0 2.69-2.7h1a3.74 3.74 0 0 1-3.69 3.72zm-3.7-3.73h1.01a2.71 2.71 0 0 0 2.69 2.7v1.03a3.7 3.7 0 0 1-3.7-3.73zm3.7-3.73v1.02a2.7 2.7 0 0 0-2.68 2.7h-1.02a3.75 3.75 0 0 1 3.7-3.72z'/%3E %3Cpath d='M457.34 266.19a3.2 3.2 0 0 1 3.2 3.22 3.2 3.2 0 0 1-3.2 3.21 3.2 3.2 0 0 1-3.2-3.21 3.2 3.2 0 0 1 3.2-3.22z' fill='%23FFF'/%3E %3Cpath fill='%2321231e' d='M461.04 269.41h-1.01a2.71 2.71 0 0 0-2.69-2.7v-1.02a3.7 3.7 0 0 1 3.7 3.72zm-3.7 3.73v-1.02a2.7 2.7 0 0 0 2.69-2.7h1a3.75 3.75 0 0 1-3.69 3.72zm-3.7-3.73h1.01a2.71 2.71 0 0 0 2.7 2.7v1.03a3.7 3.7 0 0 1-3.7-3.73zm3.7-3.73v1.02a2.7 2.7 0 0 0-2.68 2.7h-1.02a3.74 3.74 0 0 1 3.7-3.72z'/%3E %3Cpath d='M370.93 237.39c2.42-.74 6.2 4.64 7.1 4.54 1.18-3.07-1.24-10.43-5.54-16.25-2.92-.96-3.18-2.85-3.78-7.23-.18-1.31-2.68-.41-2.73 1.82-.05 2.39-.23 3.71.3 5.76.2.8.1 1.57-.8 2.3 4.55 1.82 5.67 4.05 5.45 9.06z' fill='%23edb92e'/%3E %3Cpath fill='%2321231e' d='M377.56 241.75c.26.14.8.24.9.4-.24.27-.57.39-.88.18-1.07-.65-1.85-1.65-2.79-2.46-.94-.82-1.92-1.78-3.2-2.03-.4.07-.62 0-.66-.46-.25-.4-.05-.6.4-.56 1.41 0 2.58.97 3.62 1.83 1.04.87 1.92 1.93 3.01 2.74.23 0-.37.27-.4.36zm.94.37c-.04.45-.69.35-.1.08l.1-.08zm-6.16-15.96c.13-.28.18-.8.36-.93.5.4.78 1 1.16 1.51a31.9 31.9 0 0 1 4.7 10.7c.28 1.53.48 3.17-.06 4.68-.28-.15-.76-.21-.92-.42.5-1.62.15-3.34-.22-4.95a32.58 32.58 0 0 0-5.27-10.77l.25.18zm.32-.97zm-4.45-6.67c.32 0 .78-.2 1.02-.09.26 1.68.36 3.45 1.11 5a3.71 3.71 0 0 0 2.31 1.76c-.13.3-.17.79-.36.95a4.64 4.64 0 0 1-3.06-2.7c-.62-1.56-.76-3.27-1.02-4.92zm-1.71 1.76c-.32-.05-.8.06-1.01-.08.01-1.4 1.12-2.86 2.59-2.87.57 0 1.08.48 1.14 1.05-.33 0-.76.18-1.02.09-.15-.26-.56-.04-.76.07-.6.36-.94 1.05-.94 1.74zm.28 5.62c-.32.04-.75.28-1 .2-.53-1.9-.34-3.9-.3-5.84.32.05.8-.06 1.02.08-.04 1.86-.24 3.74.28 5.56zm-1.1 1.96c-.13.26-.28.82-.39.9.03-.3-.27-.73.01-.93.49-.4.7-1.08.5-1.68.31-.04.75-.28 1-.2a2.61 2.61 0 0 1-1 2.78l-.12-.87zm-.38.95c-.19-.16-1.03-.21-.62-.47.3-.3.6-.55.56.06l.06.41zm5.13 8.58h.96c-.29-.08-.87.13-.95-.14.06-2 .03-4.22-1.25-5.88-.98-1.25-2.45-1.97-3.89-2.56.16-.28.22-.77.43-.92 1.98.78 4.01 1.95 4.94 3.97.82 1.72.84 3.69.77 5.56l-1-.03zm1.01 0h-1c.2-.35.4-.63.72-.2l.28.2zm-1 0c-.27-.39.62-.68.18-.25l-.19.25z'/%3E %3Cpath d='M368.78 218.51c-.42 1-.54 1.84-.64 3.37a4.77 4.77 0 0 0 1.09 3.23 10.3 10.3 0 0 0 3 2.52c.75.43 1.6 1.63 2.27 2.98a10.6 10.6 0 0 1 1.19 3.96c.1 3.58.79 6.7 2.42 7.32 1.06.4 1.49.34 2.31.15-.23-.64-.14-1.55-.72-2.45-.73-1.15-1.38-2.48-1.44-3.64-.05-.9-.48-1.51-.13-3.3.23-1.15.98-1.59.84-2.65-.25-2.06-1.87-6.02-4.24-6.02-2.35 0-3.44-.25-4.65-3.37-.41-1.06-.95-1.57-1.3-2.1z' fill='%23edb92e'/%3E %3Cpath fill='%2321231e' d='M368.64 221.91c-.31-.06-.8.03-1-.12.07-1.18.2-2.38.67-3.48.28.16.76.24.91.45-.42 1-.52 2.08-.58 3.15zm.99 2.88c-.28.17-.58.55-.84.58a5.27 5.27 0 0 1-1.16-3.53c.31.06.8-.02 1 .13a4.32 4.32 0 0 0 1 2.82zm2.86 2.4c-.2.26-.33.73-.56.85a10.74 10.74 0 0 1-3.1-2.62c.27-.17.57-.55.83-.58a9.84 9.84 0 0 0 2.83 2.35zm2.46 3.2c-.3.1-.67.42-.93.4-.53-1-1.1-2.06-2.04-2.72.2-.26.33-.73.56-.85 1.1.76 1.8 2 2.41 3.16zm1.24 4.16c-.31-.03-.78.1-1-.03-.1-1.3-.59-2.52-1.14-3.68.3-.1.67-.43.93-.4a10.96 10.96 0 0 1 1.21 4.11zm2.1 6.86c-.15.29-.21.78-.41.93-1.3-.56-1.82-2.01-2.16-3.28a21 21 0 0 1-.54-4.48c.32.03.8-.1 1.02.03.08 1.96.2 4 1.09 5.78.23.42.53.84 1 1.02zm1.66.8c.28-.07.78-.34.92-.3-.18.27-.23.72-.64.7-.77.2-1.58.06-2.3-.24.15-.29.2-.77.4-.93a2.8 2.8 0 0 0 1.98.1l-.36.67zm.95-.34c.19.36.27.67-.25.64-.27.13.25-.56.25-.64zm-1.62-2l.85-.55c.52.75.54 1.69.77 2.55-.31.07-.72.34-.97.29-.24-.76-.2-1.61-.65-2.3zm-1.53-3.9l1.01-.05c.1 1.24.72 2.36 1.37 3.4-.29.14-.62.5-.88.5a8.57 8.57 0 0 1-1.5-3.85zm1.01-.05zm-1.12-3.36c.3.1.79.07.98.25-.21.9-.1 1.84.1 2.73.2.47-.26.4-.59.41-.37.13-.42-.08-.43-.4-.24-.98-.28-2-.06-3zm.83-2.5c.32 0 .78-.17 1.01-.07.17 1.03-.66 1.81-.85 2.76-.3-.1-.8-.07-.98-.25.1-.78.72-1.39.83-2.16v-.28zm-3.75-5.57c.04-.32-.07-.8.06-1.02 1.54.05 2.65 1.35 3.35 2.59a11.2 11.2 0 0 1 1.34 3.88c-.32 0-.77.17-1 .07a9.29 9.29 0 0 0-2.12-4.7c-.43-.44-.99-.82-1.63-.82zm-5.11-3.7l.94-.37c.45 1.1.96 2.4 2.16 2.83.65.22 1.34.21 2.01.22-.03.32.08.8-.05 1.02-1.27.02-2.7-.12-3.6-1.13a7.9 7.9 0 0 1-1.46-2.57zm-.36-2.08c-.26-.13-.81-.3-.88-.4.31.04.78-.26.95.1.49.62.96 1.27 1.23 2.01-.31.08-.7.37-.96.32-.27-.73-.79-1.32-1.23-1.95l.89-.08zm-.94-.4c.15-.2.25-.9.43-.78.06.23.72.75.23.72l-.66.06zm.47.2zm-.47-.2c.15-.2.25-.9.43-.78.06.23.72.75.23.72l-.66.06z'/%3E %3Cpath d='M359.96 227.08c.64-.5 1.4-.85 2.13-1.14a5.77 5.77 0 0 1 3.81-.17c5.61 1.7 8.07 11.67 1.92 14.07-1.21.15-2.33-.95-3.42-3.36-1.28-3.18-2.64-5.4-4.1-6.74-.9-1.13-.93-2.09-.34-2.66z' fill='%23edb92e'/%3E %3Cpath fill='%2321231e' d='M361.91 225.47l.37.95c-.7.28-1.4.6-2 1.06l-.62-.8c.67-.53 1.46-.9 2.25-1.21zm4.14-.18l-.3.97a5.28 5.28 0 0 0-3.47.16l-.37-.95a6.3 6.3 0 0 1 4.14-.18zm1.84 15.05l-.13-1c-.28.06.33-.16.42-.22a4.95 4.95 0 0 0 2.54-3.3 8.73 8.73 0 0 0-1.19-6.43 6.98 6.98 0 0 0-3.77-3.13l.29-.97a8.26 8.26 0 0 1 4.73 4.25 9.4 9.4 0 0 1 .77 7.06 5.88 5.88 0 0 1-3.31 3.61c-.12.05-.23.11-.35.13zm.12-.03zm-4.07-3.64c.3-.13.68-.24.93-.4.48 1.02 1 2.1 1.91 2.79.29.2.64.32.98.27l.13 1.01c-1.1.15-2.07-.6-2.69-1.45-.51-.68-.91-1.44-1.26-2.22zm0 .03zm-4.03-6.65l.79-.63.38.37c1.73 1.85 2.84 4.18 3.8 6.5l-.94.38c-.9-2.2-1.96-4.41-3.6-6.18-.13-.15-.3-.29-.43-.44zm.05.06zm0-3.54v1.02c.2-.08.46-.23.21.03-.28.6.13 1.26.48 1.74.07.18-.34.3-.45.46-.2.22-.37.28-.49-.03-.55-.75-.91-1.83-.4-2.7a.99.99 0 0 1 .65-.52zm-.35.14c.16-.23.53-.13.1-.03-.04 0-.07.02-.1.03zm.35.88v-1.02l.31.91-.3.11zm.31-.1z'/%3E %3Cpath d='M362.79 227.74c5.4-2.1 9.36 8.23 4.32 10.19-2.7 1.05-2.96-2.33-3.49-4.21-.7-2.54-6-3.96-.83-5.98z' fill='%23edb92e'/%3E %3Cpath fill='%2321231e' d='M367.29 238.4l-.37-.95c.8-.3 1.46-.97 1.73-1.78a5.82 5.82 0 0 0-.15-3.86 6.35 6.35 0 0 0-2.5-3.32 3.3 3.3 0 0 0-2.91-.32c-.21.13-.18-.24-.28-.36l-.2-.55c.81-.3 1.72-.4 2.57-.2a5.72 5.72 0 0 1 3.3 2.47 8.1 8.1 0 0 1 1.4 5.33 4.34 4.34 0 0 1-1.54 2.93c-.31.26-.68.45-1.05.61zm-4.16-4.55l.98-.27c.32 1.14.44 2.36 1.05 3.4.23.4.68.7 1.16.63.2-.02.4-.09.6-.16l.37.95c-.74.3-1.65.36-2.31-.15-.82-.6-1.14-1.62-1.4-2.55-.16-.61-.28-1.24-.45-1.85zm-.53-6.59l.37.95c-.65.28-1.36.53-1.83 1.08-.24.32.06.69.26.94.88.99 2.05 1.76 2.59 3.01.07.18.2.4-.09.4l-.77.21c-.3-.9-1.06-1.52-1.72-2.16-.56-.56-1.24-1.14-1.36-1.98-.09-.68.38-1.27.92-1.62.5-.35 1.07-.6 1.63-.83z'/%3E %3Cpath d='M363.35 229.27c2.63-1.02 6.24 5.14 2.95 6.54-2.22.94-3.98-.3-4.7-2.16-.7-1.86-.1-3.66 1.75-4.38z' fill='%230c4076'/%3E %3Cpath fill='%2321231e' d='M366.5 236.28l-.4-.94c.47-.19.84-.59.95-1.08a3.67 3.67 0 0 0-.46-2.41 4.55 4.55 0 0 0-1.93-2.02 1.46 1.46 0 0 0-1.12-.08l-.37-.95a2.42 2.42 0 0 1 1.82.07c.93.4 1.67 1.17 2.2 2.01.57.9.97 1.95.93 3.02a2.63 2.63 0 0 1-1.62 2.38zm-5.36-2.44l.94-.37a3.26 3.26 0 0 0 2.03 2.06c.66.2 1.37.08 2-.19l.39.94c-.96.42-2.1.51-3.08.08a4.39 4.39 0 0 1-2.28-2.52zm2.03-5.04l.37.95c-.75.28-1.4.89-1.61 1.68-.2.67-.1 1.4.15 2.04l-.94.37a4.05 4.05 0 0 1 .1-3.4 3.66 3.66 0 0 1 1.93-1.64zm.18.47l-.18-.47.18.47z'/%3E %3Cpath d='M400.08 179.66a6.4 6.4 0 0 1 6.37 6.41 6.4 6.4 0 0 1-6.37 6.42c-3.52 0-6.37-2.87-6.37-6.42s2.85-6.41 6.37-6.41z' fill='%23FFF'/%3E %3Cpath d='M406.95 186.07h-1.01a5.93 5.93 0 0 0-5.86-5.9v-1.02a6.88 6.88 0 0 1 6.87 6.92zm-6.87 6.92v-1.02a5.87 5.87 0 0 0 5.86-5.9h1.01a6.96 6.96 0 0 1-3.26 5.89 6.85 6.85 0 0 1-3.61 1.03zm-6.88-6.92h1.02a5.93 5.93 0 0 0 5.86 5.9V193a6.88 6.88 0 0 1-6.88-6.92zm6.88-6.92v1.01a5.87 5.87 0 0 0-5.86 5.9h-1.02a6.96 6.96 0 0 1 3.26-5.88 6.85 6.85 0 0 1 3.62-1.04z' fill='%2321231e'/%3E %3Cpath d='M395.43 169a6.4 6.4 0 0 1 6.37 6.42 6.4 6.4 0 0 1-6.37 6.41 6.4 6.4 0 0 1-6.37-6.41 6.4 6.4 0 0 1 6.37-6.42z' fill='%23FFF'/%3E %3Cpath d='M402.31 175.42h-1.01a5.93 5.93 0 0 0-5.86-5.9v-1.03a6.88 6.88 0 0 1 6.87 6.93zm-6.87 6.92v-1.01a5.87 5.87 0 0 0 5.86-5.91h1.01a6.96 6.96 0 0 1-3.26 5.89 6.85 6.85 0 0 1-3.61 1.04zm-6.88-6.92h1.02a5.93 5.93 0 0 0 5.86 5.9v1.02a6.88 6.88 0 0 1-6.88-6.92zm6.88-6.93v1.02a5.87 5.87 0 0 0-5.86 5.91h-1.02a6.96 6.96 0 0 1 3.26-5.9 6.85 6.85 0 0 1 3.62-1.03z' fill='%2321231e'/%3E %3Cpath d='M410.68 131.46c3.4 0 6.14 2.77 6.14 6.19s-2.75 6.18-6.14 6.18c-3.39 0-6.14-2.77-6.14-6.18s2.75-6.19 6.14-6.19z' fill='%23FFF'/%3E %3Cpath d='M417.32 137.65h-1.01a5.7 5.7 0 0 0-5.64-5.68v-1.01a6.65 6.65 0 0 1 6.65 6.69zm-6.65 6.7v-1.02a5.64 5.64 0 0 0 5.64-5.68h1.01a6.72 6.72 0 0 1-3.15 5.7 6.6 6.6 0 0 1-3.5 1zm-6.64-6.7h1a5.7 5.7 0 0 0 5.64 5.68v1.02a6.65 6.65 0 0 1-6.64-6.7zm6.64-6.7v1.02a5.64 5.64 0 0 0-5.63 5.68h-1.01a6.72 6.72 0 0 1 3.12-5.67 6.6 6.6 0 0 1 3.52-1.03z' fill='%2321231e'/%3E %3Cpath d='M400.36 136.18a6.4 6.4 0 0 1 6.37 6.41 6.4 6.4 0 0 1-6.37 6.42 6.4 6.4 0 0 1-6.37-6.42 6.4 6.4 0 0 1 6.37-6.41z' fill='%23FFF'/%3E %3Cpath d='M407.23 142.59h-1.01a5.93 5.93 0 0 0-5.86-5.9v-1.02a6.88 6.88 0 0 1 6.87 6.92zm-6.87 6.93v-1.02a5.87 5.87 0 0 0 5.86-5.91h1.01a6.96 6.96 0 0 1-3.26 5.9 6.85 6.85 0 0 1-3.61 1.03zm-6.88-6.93h1.02a5.93 5.93 0 0 0 5.86 5.9v1.03a6.88 6.88 0 0 1-6.88-6.93zm6.88-6.92v1.01a5.87 5.87 0 0 0-5.86 5.91h-1.02a6.96 6.96 0 0 1 3.26-5.89 6.85 6.85 0 0 1 3.62-1.04z' fill='%2321231e'/%3E %3Cpath d='M392.77 145.25a6.4 6.4 0 0 1 6.37 6.42 6.4 6.4 0 0 1-6.37 6.41 6.4 6.4 0 0 1-6.37-6.41 6.4 6.4 0 0 1 6.37-6.42z' fill='%23FFF'/%3E %3Cpath d='M399.64 151.66h-1.01a5.93 5.93 0 0 0-5.86-5.9v-1.03a6.88 6.88 0 0 1 6.87 6.93zm-6.87 6.92v-1.01a5.87 5.87 0 0 0 5.86-5.9h1a6.96 6.96 0 0 1-3.25 5.88 6.85 6.85 0 0 1-3.61 1.04zm-6.88-6.92h1.02a5.93 5.93 0 0 0 5.86 5.9v1.02a6.88 6.88 0 0 1-6.88-6.92zm6.88-6.93v1.02a5.87 5.87 0 0 0-5.86 5.91h-1.02a6.96 6.96 0 0 1 3.26-5.9 6.85 6.85 0 0 1 3.62-1.03z' fill='%2321231e'/%3E %3Cpath d='M391.54 156.66c3.52 0 6.37 2.87 6.37 6.41s-2.85 6.42-6.37 6.42-6.37-2.87-6.37-6.42 2.85-6.41 6.37-6.41z' fill='%23FFF'/%3E %3Cpath d='M398.41 163.08h-1.01a5.93 5.93 0 0 0-5.86-5.9v-1.02a6.88 6.88 0 0 1 6.87 6.92zm-6.87 6.92V169a5.87 5.87 0 0 0 5.86-5.91h1.01a6.95 6.95 0 0 1-6.87 6.92zm-6.88-6.92h1.02a5.93 5.93 0 0 0 5.86 5.9V170a6.88 6.88 0 0 1-6.88-6.92zm6.88-6.92v1.01a5.87 5.87 0 0 0-5.86 5.91h-1.02a6.96 6.96 0 0 1 3.26-5.89 6.85 6.85 0 0 1 3.62-1.04z' fill='%2321231e'/%3E %3Cpath d='M474.41 198.02c-2.7-5.03-5.57-8.25-8.6-9.65 4.18-13.16 5.16-30.15 2.7-51.1-.24-3.13-1.01-4.47-2.2-4.45-1.05.02-1.68 1.61-1.79 5.22.76 11.52 1.7 21.6 1.17 30.16-.47 7.65-2.26 14-4.24 21.16-.27 1 .44 1.77 3.87 3.71 2.54 1.44 4.14 3.22 4.67 5.07.74-.3 1.2-.2 1.47-.13 2.55.74 3.62.54 2.95 0v.01z' fill='%23edb92e'/%3E %3Cpath fill='%2321231e' d='M465.33 188.22c1.38.84.31-.67 1.29-.01 3.76 2.12 6.2 5.88 8.23 9.57-.87.9-1.2.01-1.6-.78-1.9-3.21-4.2-6.49-7.65-8.16l-.27-.62zm.27.62zm2.41-51.52c1.13-.45 1.14.35 1.16 1.26 1.57 14.52 1.95 29.38-1.2 43.72a75.51 75.51 0 0 1-1.68 6.23c-1.23-.01-.86-.85-.54-1.68 3.9-13.53 4.09-27.82 3.03-41.78-.21-2.58-.47-5.17-.77-7.75zm0 .02zm-1.7-4c-.2-.77.05-1.33.83-.85 1.6.96 1.67 3.1 1.88 4.75-1.08.41-1.13-.34-1.16-1.22-.22-.9-.36-2.58-1.55-2.69zm-1.29 4.67c-1.02.36-1.15-.23-.95-1.1.17-1.51.17-3.41 1.52-4.4.74-.6.86.3.67.82-.93.47-.9 1.8-1.1 2.7-.08.6-.12 1.52-.14 1.98zm-1 .07zm2.17 30.16c-1.23.3-1.02-.67-.93-1.55.33-9.55-.66-19.09-1.25-28.61 1.2-.46 1.1.53 1.11 1.41.6 9.57 1.6 19.16 1.07 28.75zm-4.25 21.26c-1.2.03-.9-.78-.6-1.6 1.8-6.46 3.47-13 3.84-19.72 1.2-.3 1.05.6.91 1.46-.53 6.77-2.34 13.34-4.15 19.86zm3.63 3.13c-.24 1.06-.83.86-1.52.3-1.2-.83-3-1.55-3.16-3.2-.25-.79 1.26-.46 1.03.14.76 1.34 2.4 1.95 3.65 2.76zm0 0zm4.23 5.04c.77 1.02-.16 1.12-.45.18-.78-1.94-2.51-3.31-4.28-4.33.25-1.07.88-.83 1.55-.24 1.7 1.15 3.26 2.71 3.85 4.73l-.67-.34zm.37.95zm1.43-1.1c-.19.39-.06 1.17-.66.93-.38-.06-.89.42-.92-.21-.56-.66.24-.76.76-.8.27-.02.56 0 .82.09zm3.31.5c-1.5.4-.52-.77.11-.06.42.92-.86 1.21-1.52 1.02-.74-.09-1.47-.27-2.18-.47 0-1.1.65-.98 1.46-.68.45.1 1.14.18 1.47.15-.58 1.02.29.09.66.04zm-1 0c-.64-1.45 1.17-.7.44-.22l-.45.22zm0 0c1.32-.2.8.3.02.11l-.03-.1z'/%3E %3Cpath d='M458.4 214.56c1.56-.99 1.87-.72 2.37-1.37.65-.83.66-2.2.46-3.5-.82-5.3 2.33-4.56 5.88-2.22 1.77 1.17 3.56 3.88 5.08 5.3 1.53 1.41 2.79 1.54 3.17 2.1.05 2.02.06 3.78.04 4.57.02.8 0 2.55-.04 4.57-.38.56-1.64.68-3.17 2.1-1.52 1.42-3.3 4.13-5.08 5.3-3.55 2.33-6.7 3.07-5.88-2.21.2-1.31.2-2.68-.46-3.51-.5-.65-.8-.39-2.37-1.37a6.96 6.96 0 0 1-2.28-2.25c-.51-.83-.24-1.73-.24-2.63 0-.9-.27-1.8.24-2.64.5-.83 1.26-1.6 2.28-2.24z' fill='%23edb92e'/%3E %3Cpath fill='%2321231e' d='M460.37 212.87c1.19.43.47 1.23-.4 1.44-.7.32-1.65 1.06-1.79-.22.67-.52 1.58-.65 2.19-1.22zm.35-3.12c1.66-.73 1.09 1.77.96 2.69-.04.98-.97 1.26-1.22.3.51-.9.39-2 .26-2.99zm6.66-2.71c-.62 1.8-2.14-.6-3.31-.6-1.4-.85-2.82.38-2.47 1.87.22.82.12 1.75-.9 1.33-.2-1.46-.34-3.47 1.2-4.26 1.7-.62 3.4.43 4.84 1.25l.64.4zm5.15 5.35c-.83 1.6-1.77-.63-2.5-1.23-.98-1.17-1.95-2.38-3.2-3.27.56-1.72 1.84.37 2.55.95 1.07 1.17 2 2.45 3.15 3.55zm3.33 2.46c-.45-.08-1.04.08-1.06.2-.97-.6-2.08-1.02-2.87-1.85.46-1.56 1.54.22 2.43.43.52.34 1.35.53 1.5 1.22zm-.09-.28zm.13 4.86c-1.77.46-.73-1.92-1.02-2.9-.1-.87-.2-2.19.98-1.57.04 1.49.05 2.98.04 4.47zm-1.01 0zm0 0c.62 0 1.16.01.21.01h-.21zm0 .02v-.01zm.88 4.85c-.31-.46-1.06-.39-.91-.6.02-1.41.04-2.83.03-4.25 1.79-.48.75 1.96 1 2.95-.04.63.04 1.29-.12 1.9zm.09-.28zm-3.33 2.46c-1.49-.92.64-1.7 1.41-2.18.5-.59 1.72-.61 1.7.13-.94.82-2.25 1.08-3.11 2.05zm-5.15 5.35c-1.29-1.1.9-1.69 1.37-2.62 1.04-1.15 1.96-2.41 3.1-3.48 1.47.92-.72 1.83-1.15 2.77-1.01 1.2-2.02 2.43-3.32 3.33zm-6.66-2.72c1.64-.23.57 1.55.95 2.47.15 1.32 1.71 1.25 2.61.76.91-.22 1.9-1.17 2.6-1.23 1.15.93-.73 1.33-1.35 1.8-1.17.57-2.7 1.17-3.92.42-1.3-.98-1.07-2.8-.89-4.22zm-.35-3.11c1.18-1.53 1.58 1.17 1.47 2.07.35.94-.64 1.66-1.09.8.1-.96.2-2.04-.38-2.87zm-2.24-1.26c.39-1.5 1.66-.09 2.55.18 1.04.44-.5 1.52-.9.66-.59-.2-1.13-.5-1.65-.84zm.53-.86zm-2.98-1.55c1.1-1.22 1.55.88 2.54 1.25.94.27-.28 1.73-.78.68a7.12 7.12 0 0 1-1.76-1.93zm-.3-2.9c1.71-.47.51 1.54 1.16 2.37-1.1 1.23-1.4-.64-1.22-1.51l.05-.86zm.3-2.9c1.42.37.3 1.87.7 2.9-1.52.47-1.09-1.53-.93-2.42.06-.16.13-.33.23-.48zm2.44-2.4c1.2 1-.58 1.42-1.06 2.22-.2.83-1.19.73-1.28.01a7.59 7.59 0 0 1 2.34-2.24zm.54.86z'/%3E %3Cpath d='M475.52 220.24l-.13.89a17.42 17.42 0 0 0-9.56 4.35c1.8-2.66 5.63-4.65 9.69-5.24zM475.52 218.64l-.13-.89a17.43 17.43 0 0 1-9.56-4.35c1.8 2.66 5.63 4.65 9.69 5.24z' fill='%2321231e'/%3E %3Cpath d='M461.16 207.28c1.14.47 2.38.97 3.44 2 1.6 1.55.56 4.12-1.5 6.62-.66.78-.97 2.17-.97 3.56 0 1.38.33 2.76.96 3.52 2.07 2.5 3.1 5.07 1.5 6.63-1.04 1.02-2.29 1.52-3.43 1.99-.1-.6-.1-1.39.06-2.4.2-1.31.2-2.68-.45-3.51-.5-.65-.81-.38-2.38-1.37a7 7 0 0 1-2.28-2.24c-.5-.84-.23-1.74-.23-2.64 0-.9-.28-1.8.23-2.63.5-.84 1.27-1.6 2.28-2.25 1.57-.98 1.87-.72 2.38-1.37.65-.83.65-2.2.45-3.5a7.44 7.44 0 0 1-.06-2.41z' fill='%23edb92e'/%3E %3Cpath fill='%2321231e' d='M464.95 208.9l-.7.73a9.7 9.7 0 0 0-3.28-1.89l.38-.94c1.3.52 2.6 1.11 3.6 2.1zm-1.47 7.32l-.77-.66c.98-1.23 1.98-2.6 2.16-4.2a2.09 2.09 0 0 0-.62-1.73l.7-.73c.99.9 1.13 2.4.71 3.62a11.37 11.37 0 0 1-2.18 3.7zm-.84 3.23h-1.01c.01-1.35.22-2.8 1.08-3.89l.77.66c-.68.9-.82 2.13-.84 3.23zm.84 3.2l-.77.65c-.85-1.08-1.06-2.51-1.08-3.85h1c.03 1.1.18 2.3.85 3.2zm1.47 7.32l-.7-.74c.84-.77.7-2.05.3-3a11.48 11.48 0 0 0-1.84-2.93l.77-.65c1.15 1.42 2.27 3.03 2.4 4.9.05.9-.28 1.8-.93 2.42zm-4.28 1.72l1-.19c-.14-.15-.9-.33-.54-.44a9.27 9.27 0 0 0 3.12-1.83l.7.74c-1 .99-2.3 1.58-3.6 2.1l-.68-.38zm.68.37c-.31.14-.7.41-.64-.14-.17-.49.42.1.64.14zm-.63-2.95l1 .16c-.1.74-.18 1.5-.06 2.23l-1 .19a8.25 8.25 0 0 1 .06-2.58zm-.35-3.11l.8-.63c.82 1.11.74 2.6.55 3.9l-1-.16c.14-1.02.27-2.22-.35-3.11zm-2.24-1.26l.53-.86c.64.45 1.4.67 2.07 1.06.16.15.63.4.26.57-.23.08-.51.63-.72.37-.48-.38-1.12-.5-1.64-.83l-.5-.3zm0 0l-.08-.05c-.06 0 .11.05.08.05zm-2.45-2.4l.86-.54a6.53 6.53 0 0 0 2.12 2.08l-.53.86a7.52 7.52 0 0 1-2.45-2.4zm0 0c.18.3.43.71.1.18l-.1-.18zm-.3-2.9h1c.03.78-.27 1.64.16 2.36l-.86.53c-.57-.87-.34-1.93-.3-2.9zm.3-2.9l.86.53c-.42.72-.14 1.58-.16 2.36h-1c-.03-.97-.27-2.02.3-2.9zm2.45-2.42l.53.87a6.53 6.53 0 0 0-2.12 2.07l-.86-.53a7.5 7.5 0 0 1 2.45-2.4zm2.24-1.25l.8.63c-.53.73-1.51.8-2.21 1.3-.34.39-.46-.12-.65-.38-.38-.32.07-.45.34-.6.5-.35 1.14-.46 1.62-.83l.1-.12zm.35-3.12l1-.15c.19 1.3.27 2.78-.55 3.9l-.8-.63c.62-.9.49-2.1.35-3.12zm.44-1.97v-1.02c.16.29.6.5.46.86-.06.66 0 1.33.1 1.98l-1 .15a8.22 8.22 0 0 1-.05-2.57l.5.6zm0-1.02c.4-.03.77-.05.53.44.03.45-.41-.4-.53-.44zm0 0v1.02c-.4-.03 0-.58-.03-.85l.03-.17zM361 226.26l.68-.3c-1.54-2.14-1.88-4.2-1.29-6.26-1.3 1.64-.99 4.21.61 6.56z'/%3E %3Cpath d='M410.74 199.91c1.33 1.69 1.17 2.09 1.89 2.57.94.63 2.22.41 3.4-.04 4.86-1.86 4.86 2 3.45 6.43-.68 2.14-2.76 4.47-3.68 6.3-.91 1.78-.71 3.12-1.12 3.57-1.76.3-3.28.51-3.97.59-.67.1-2.18.3-3.9.49-.57-.32-1.01-1.6-2.62-2.99-1.61-1.4-4.4-2.92-5.9-4.63-3.05-3.47-4.66-6.81.12-6.7 1.2.04 2.38-.18 2.92-1.04.42-.67.1-.97.51-2.93.27-1.28.74-2.3 1.35-3.04.61-.75 1.5-.58 2.33-.74.83-.15 1.59-.64 2.5-.18a8.35 8.35 0 0 1 2.72 2.34z' fill='%23edb92e'/%3E %3Cpath fill='%2321231e' d='M412.91 202.06c-.24.18-.37.97-.7.75-.74-.6-1.01-1.58-1.64-2.29-.5-.37.25-.58.49-.86.27-.03.47.55.7.77.41.52.6 1.24 1.15 1.63zm-.56.85zm3.5-.95c.02.34.62.94.12 1.04-1.15.42-2.54.62-3.62-.09.25-.2.37-.92.7-.77.88.45 1.93.14 2.8-.18zm4.11 7.06c-.28-.2-1.14-.1-.88-.58.45-1.6.98-3.32.55-4.98-.2-.85-1.17-1.12-1.93-.95-.51.07-1 .23-1.49.4-.02-.34-.64-.96-.1-1.04 1.23-.45 2.84-.75 3.88.26 1.06 1.17.87 2.9.63 4.33-.16.87-.4 1.72-.66 2.56zm-3.7 6.38c-.25-.25-1.12-.29-.78-.71 1.11-2.03 2.75-3.77 3.52-5.98.26.2 1.09.1.89.53-.83 2.26-2.52 4.06-3.64 6.16zm-1.5 3.85c-.14-.27.05-1.23-.4-.87-.06-.02.14-.47.13-.66.16-.96.4-1.92.86-2.79.23.24 1.07.28.8.68-.51.98-.56 2.1-.88 3.12a.84.84 0 0 1-.5.52zm.3-.16zm-4.34.75c.07-.31-.13-1.01.08-1.03 1.27-.16 2.54-.36 3.8-.56-.05.32.41 1.02-.07 1.04-1.27.2-2.54.41-3.81.55zm.05 0zm.02 0l-.11-.73c.06.7.02-.76.04-.08v.6c-.03-.68.02-.01.07.2zm-.16-1.01zm-4.07 1.43c.05-.3.8-.92.22-.94.29-.05.83-.1 1.21-.15.89-.1 1.77-.2 2.64-.34-.05.32.4 1-.05 1.04-1.26.17-2.53.36-3.79.44l-.23-.05zm.3.07zm-3-3.11c.28-.15.51-.97.82-.64.92.78 1.55 1.82 2.3 2.74.07.22-.31.81-.48.9-.8-.63-1.2-1.62-1.94-2.33a8.93 8.93 0 0 0-.7-.67zm-5.95-4.68c.31-.14.66-.92.94-.47 1.68 1.72 3.85 2.83 5.67 4.38-.29.17-.52 1-.86.6-1.89-1.54-4.1-2.69-5.75-4.51zm.52-7.54c-.12.3.21 1.06-.24 1.02-.75.03-1.72 0-2.2.7-.3.9.3 1.8.73 2.58.56.91 1.25 1.75 1.95 2.57-.31.13-.67.93-.94.46-1.17-1.42-2.44-2.9-2.81-4.74a2.02 2.02 0 0 1 1.45-2.35 6.17 6.17 0 0 1 2.06-.24zm2.47-.81c.19.25 1.01.38.75.7-.75.98-2.1 1.16-3.25 1.13.11-.31-.2-1.05.24-1.02.79-.02 1.78-.09 2.26-.81zm0 0zm.45-2.76c.26.17 1.04 0 .96.39-.24.85-.1 1.77-.39 2.6-.1.57-.52.04-.8-.1-.4-.12.07-.5-.04-.8.04-.7.12-1.4.27-2.09zm1.45-3.26c.16.26.88.47.69.77-.6.79-.94 1.74-1.15 2.7-.28-.17-1.12.02-.93-.46a7.43 7.43 0 0 1 1.39-3.01zm.78.65l.34-.42-.34.42zm1.85-1.56c-.05.3.4.94.03 1.02-.64.12-1.42-.02-1.88.53-.17-.27-.98-.5-.63-.81.65-.69 1.63-.63 2.48-.74zm.19 1l-.35.06.35-.06zm2.64-1.14c-.23.23-.26 1.02-.64.83-.68-.21-1.34.2-2 .3.04-.34-.46-1.03.08-1.06.83-.26 1.74-.53 2.56-.07zm2.99 2.8c-.3.09-1.2-.25-.92.25-.11-.07-.46-.54-.7-.75a7.14 7.14 0 0 0-1.83-1.4c.23-.22.27-1.04.65-.8 1.06.6 2 1.45 2.71 2.44l.09.25zm-.11-.33zm-.9.32c.2.03 1.14-.06.88.05-.34.02-.85.55-.88-.05zm.1.32z'/%3E %3Cpath d='M410.05 219.43l-.8-.03a23.54 23.54 0 0 0-6.3-9.54c2.82 1.57 5.56 5.42 7.1 9.57zM411.43 219.24l.74-.24c-.5-4 .07-7.54 1.54-10.88-1.96 2.37-2.76 6.8-2.28 11.12z' fill='%2321231e'/%3E %3Cpath d='M418.3 201.97c-.18 1.42-.37 2.95-1.07 4.32-1.07 2.05-3.69 1.26-6.48-.7a4.82 4.82 0 0 0-3.48-.54c-1.24.22-2.38.79-2.88 1.61-1.6 2.64-3.51 4.12-5.31 2.61-1.2-1-2-2.29-2.75-3.47a5.03 5.03 0 0 1 2.09-.3c1.19.04 2.38-.18 2.91-1.04.43-.67.11-.97.52-2.92.27-1.29.74-2.31 1.34-3.05.62-.75 1.51-.58 2.34-.73.83-.16 1.59-.65 2.5-.19a8.35 8.35 0 0 1 2.72 2.34c1.32 1.68 1.16 2.09 1.89 2.58.94.62 2.21.4 3.4-.05a5.9 5.9 0 0 1 2.26-.47z' fill='%23edb92e'/%3E %3Cpath fill='%2321231e' d='M417.68 206.53l-.9-.47c.67-1.28.84-2.74 1.02-4.15l1 .13c-.18 1.53-.4 3.1-1.12 4.49zm-7.22-.52l.58-.83c1.25.84 2.6 1.72 4.15 1.81.66.05 1.32-.32 1.6-.93l.89.47a2.68 2.68 0 0 1-2.7 1.47c-1.67-.15-3.17-1.06-4.52-1.99zm-3.1-.45l-.18-1a5.3 5.3 0 0 1 3.86.62l-.58.83c-.9-.6-2.07-.62-3.1-.45zm-2.54 1.37l-.86-.53c.7-1.1 2-1.62 3.22-1.85l.18 1c-.94.19-1.98.55-2.54 1.38zm-6.06 2.74l.65-.78c.58.57 1.53.63 2.2.17a7.84 7.84 0 0 0 2.35-2.66l.86.53c-.83 1.33-1.83 2.74-3.36 3.31-.93.35-1.97.08-2.7-.57zm-2.63-4.33l.4.93c.11-.16.14-.95.33-.58.73 1.15 1.49 2.31 2.55 3.2l-.65.78a14.78 14.78 0 0 1-2.86-3.6l.23-.73zm-.23.74c-.18-.28-.5-.6.03-.66.41-.26-.02.44-.02.64v.02zm2.53-1.08l-.02 1.02c-.63 0-1.29 0-1.88.25l-.4-.94c.72-.3 1.53-.34 2.3-.33zm2.48-.8c.29.17.57.37.86.54-.7 1.09-2.1 1.3-3.3 1.28-.15-.17 0-.63-.04-.92.1-.22.61-.04.88-.13.59-.07 1.26-.24 1.6-.78zm0 0zm.45-2.76l.99.21c-.22.83-.18 1.7-.33 2.53-.09.19-.17.73-.44.45-.17-.21-.8-.3-.58-.6.18-.7.1-1.46.28-2.17l.08-.42zm1.45-3.27l.78.65a6.66 6.66 0 0 0-1.24 2.83l-.99-.21a7.62 7.62 0 0 1 1.45-3.27zm0 0c.21-.27.5-.6.11-.14l-.11.14zm2.63-.91l.18 1c-.67.16-1.53-.04-2.03.56l-.78-.65c.57-.75 1.56-.82 2.42-.88.07 0 .14-.02.2-.03zm0 0c.26-.05.89-.17.29-.05l-.3.05zm2.82-.14l-.45.91c-.72-.37-1.47.12-2.19.23l-.18-1c.86-.21 1.79-.62 2.66-.21l.16.07zm-.45.91zm3.34 1.57l-.8.63a7.92 7.92 0 0 0-2.54-2.2l.45-.9a8.91 8.91 0 0 1 2.89 2.47zm1.77 2.47l-.56.85c-.8-.53-1.06-1.51-1.65-2.22-.15-.24-.55-.5-.1-.67.25-.15.55-.65.72-.19.52.63.87 1.37 1.34 2.03.07.07.17.15.25.2zm-.56.85zm3.5-.96l.36.96c-1.21.46-2.7.75-3.86 0l.56-.86c.9.56 2.03.24 2.94-.1zm2.95.08l-1-.13c.09.2.74.66.22.58-.62.03-1.23.2-1.81.43l-.36-.96c.79-.29 1.62-.53 2.47-.5.15.2.32.4.48.58zm-.48-.57c.38-.04.68 0 .5.45.02.33-.4-.4-.5-.45z'/%3E %3Cpath d='M391.76 221.18c.77-.94 1.08-.73 1.22-1.32.18-.77-.27-1.97-.85-3.1-2.33-4.58.15-4.2 3.51-2.4.86.47 1.84 1.28 2.83 2.11.99.85 1.97 1.73 2.8 2.32 1.66 1.2 2.7 1.24 3.18 1.72a141.54 141.54 0 0 1 1.6 4.2c.3.72.89 2.32 1.55 4.17-.1.52-1.07.66-1.78 1.98-.7 1.3-1.26 3.66-2.12 4.8-1.27 1.66-2.42 2.65-3.32 2.49-.9-.16-1.54-1.48-1.78-4.38a5.08 5.08 0 0 0-1.48-3.03c-.58-.55-.71-.32-2.15-1.13a9.26 9.26 0 0 1-2.34-1.87c-.63-.7-.72-1.47-1.02-2.24-.29-.78-.77-1.54-.7-2.27.08-.74.35-1.45.85-2.05z' fill='%23edb92e'/%3E %3Cpath fill='%2321231e' d='M392.49 219.74c.28.12.83.09.97.3-.16.7-.95.9-1.31 1.47-.18-.26-.81-.47-.7-.75.27-.38.7-.61 1.02-.94l.02-.08zm.98.23zm-1.8-2.98c.3-.07.75-.58.96-.36.49 1.03 1.05 2.17.84 3.34-.28-.14-.87-.06-.97-.33.05-.94-.43-1.83-.82-2.65zm4.2-3.07c-.2.23-.28.9-.58.84-1.03-.5-2.09-1.13-3.26-1.13-.5.06-.27.73-.2 1.06.17.64.45 1.24.75 1.83-.3.06-.75.58-.96.35-.48-1.04-1.1-2.2-.83-3.38.27-.89 1.35-1.02 2.13-.8 1.04.25 2.02.73 2.96 1.23zm2.92 2.16c-.25.18-.47.81-.74.7-.85-.7-1.68-1.42-2.65-1.96.2-.23.3-.85.57-.85 1.02.58 1.92 1.36 2.82 2.11zm2.77 2.3c-.24.2-.4.8-.67.77-.96-.71-1.84-1.52-2.75-2.29.25-.17.47-.81.74-.7.89.75 1.74 1.53 2.68 2.22zm3.35 1.94c-.23.18-.95.2-.87.49.06.09-.4-.24-.57-.27-.88-.34-1.73-.77-2.5-1.33.24-.2.4-.86.69-.76.86.66 1.9.97 2.85 1.47.16.1.31.23.4.4zm-.11-.17zm1.73 4.39c-.3.05-.77.34-.98.27-.5-1.38-1.03-2.75-1.57-4.1.3-.04.8-.51.98-.27.54 1.36 1.08 2.72 1.57 4.1zm0-.01zm0-.01c-.23.17-.97.2-.87.47-.04.11.69.37.17 0a62 62 0 0 1-.22-.23c-.1 0 .22.57-.07-.06.1.34.69-.15.99-.16.07.37-.27-.61.02.15-.09-.07-.75-.75-.32-.32a46.5 46.5 0 0 1 .2.2c-.46-.37-.3-.36-.07-.27l.17.22zm-.17-.22zm1.73 4.69c-.28.02-.92-.36-.98-.08 0 .29-.22-.58-.31-.76-.4-1.09-.8-2.18-1.22-3.26.31-.06.74-.4.97-.3.53 1.39 1.06 2.78 1.53 4.18l.01.22zm-.02-.28zm-1.81 2.4c-.22-.22-.9-.3-.83-.6.38-.73 1.08-1.25 1.67-1.73.28.13.9.04.97.3-.3.74-1.18.97-1.57 1.64-.09.12-.17.25-.24.39zm-2.16 4.86c-.2-.25-.82-.43-.74-.72.91-1.43 1.22-3.14 2.01-4.63.22.21.9.3.83.6-.77 1.55-1.1 3.32-2.1 4.75zm-3.81 2.68c.12-.3.02-.87.27-1 .9-.1 1.51-.9 2.1-1.52.26-.19.45-.8.73-.7.15.23.88.4.59.7-.84 1.01-1.73 2.18-3.07 2.52-.2.04-.42.04-.62 0zm-2.2-4.84c.31.03.81-.17 1.02-.02.14 1.23.21 2.57.95 3.6.31.22.5.34.32.76.03.45-.2.61-.57.33-1.06-.65-1.3-2-1.53-3.12-.09-.51-.14-1.04-.19-1.55zm-1.32-2.7c.26-.17.5-.76.77-.66a5.56 5.56 0 0 1 1.56 3.28c-.3-.04-.85.2-1.01 0a4.55 4.55 0 0 0-1.32-2.62zm-2.05-1.05c.22-.22.31-.9.6-.83.69.44 1.56.55 2.14 1.14-.26.16-.5.78-.78.66-.55-.4-1.25-.52-1.82-.9l-.14-.07zm-2.47-1.97c.27-.16.55-.66.8-.62a8.77 8.77 0 0 0 2.17 1.7c-.21.22-.31.85-.59.83a9.75 9.75 0 0 1-2.38-1.91zm-1.11-2.41c.3-.05.75-.42.97-.28.25.68.38 1.45.89 2-.27.15-.56.71-.82.6-.58-.65-.76-1.52-1.04-2.32zm-.73-2.5c.3.07.77.01 1 .15 0 .72.44 1.33.67 1.99-.3.06-.73.38-.97.3-.3-.79-.8-1.57-.7-2.44zm1 .1zm.35-1.59c.03-.22-.07-1.08.05-.9.07.3.5.65.18.92a3.28 3.28 0 0 0-.58 1.57c-.3-.09-.85.03-1-.18.1-.82.43-1.6.96-2.24l.39.83zm0-1.02c.3.04.9-.07 1.03.05-.22.16-.52.87-.7.67l-.33-.72zm0 0v1.02c-.04-.3-.64-.82-.16-.94l.16-.08zm0 1.02c-.3-.04-.91.07-1.04-.05.23-.15.52-.87.7-.67l.34.72z'/%3E %3Cpath d='M406.51 226.13l.22.94a8.8 8.8 0 0 0-3.64 1.76c-1 .81-1.8 1.86-2.42 3.12.22-1.4.91-2.64 1.93-3.64a8.82 8.82 0 0 1 3.9-2.18h.01zM405.92 224.45l-.43-.93c-1.61-.14-3.17-.55-4.69-1.2a21.44 21.44 0 0 1-4.45-2.68 15.81 15.81 0 0 0 9.56 4.8h.01z' fill='%2321231e'/%3E %3Cpath d='M391.36 213.8c1 .37 1.66.82 2.8 1.77a4.53 4.53 0 0 1 1.52 2.94c.17 1.2.03 2.55-.3 3.89-.2.83.05 2.25.54 3.64a10.03 10.03 0 0 0 1.95 3.5c2.45 2.45 4.16 5.04 3.48 6.65a3.31 3.31 0 0 1-1.48 1.8c-.3-.6-.99-1.14-1.22-2.16-.3-1.31-.8-2.67-1.57-3.49-.6-.63-.73-1.35-2.22-2.27-.96-.6-1.78-.35-2.44-1.15-1.27-1.56-2.93-5.38-1.3-7.12 1.6-1.72 2.17-2.69.82-5.65-.46-1-.45-1.74-.58-2.35z' fill='%23edb92e'/%3E %3Cpath fill='%2321231e' d='M394.49 215.17l-.64.79a8.8 8.8 0 0 0-2.66-1.68l.35-.96a9.66 9.66 0 0 1 2.95 1.85zm1.7 3.27c-.33 0-.77.18-1.02.09a4.03 4.03 0 0 0-1.32-2.57l.64-.79c.98.8 1.53 2.03 1.7 3.27zm-.31 4.08l-.98-.25c.3-1.2.45-2.45.28-3.69.32 0 .77-.18 1.01-.09a11 11 0 0 1-.31 4.03zm-.98-.25zm1.5 3.6c-.31.07-.72.33-.97.29-.4-1.25-.79-2.58-.53-3.89.3.12.78.12.97.3-.16 1.12.2 2.25.53 3.3zm1.84 3.31c-.25.2-.5.61-.76.68a10.6 10.6 0 0 1-2.03-3.65c.31-.07.71-.33.97-.29a9.56 9.56 0 0 0 1.82 3.26zm3.58 7.2c-.28-.16-.75-.24-.9-.45.3-1-.28-2-.78-2.85a18.87 18.87 0 0 0-2.62-3.18c.25-.2.5-.61.76-.68 1.43 1.48 2.87 3.07 3.55 5.05.21.68.28 1.45 0 2.11zm-2.4 1.82c.25-.15.78-.32.85-.46-.17-.1-.92-.1-.5-.3.54-.33.9-.88 1.12-1.46.28.16.76.25.91.46a3.9 3.9 0 0 1-1.64 1.96l-.74-.2zm.74.2c-.3.27-.59.44-.68-.08-.18-.27.53.1.68.08zm-2-2.46c.32-.03.75-.25 1-.17.18.77.82 1.3 1.17 1.99-.3.11-.66.39-.93.4-.46-.71-1.07-1.35-1.24-2.22zm-1.44-3.25l.73-.7c.94 1.03 1.38 2.4 1.7 3.72-.32.04-.75.25-1 .18a7.3 7.3 0 0 0-1.43-3.2zm0 0zm-2.12-2.2l.53-.86a6.5 6.5 0 0 1 2.15 2.16c.36.23-.11.42-.27.63-.24.4-.45.15-.63-.14a5.26 5.26 0 0 0-1.78-1.79zm-2.56-1.25l.78-.65c.53.62 1.45.5 2.1.92.44.12-.1.5-.17.74-.1.43-.39.06-.64 0-.74-.22-1.58-.34-2.07-1.01zm-1.29-7.8l.74.7c-.79.92-.56 2.25-.26 3.31.34 1.13.86 2.21 1.6 3.14l-.8.65a9.86 9.86 0 0 1-2.08-5.32c-.04-.89.19-1.82.8-2.47zm.74-5.08c.3-.1.68-.4.94-.38.6 1.33 1.14 2.92.45 4.32-.34.7-.87 1.28-1.39 1.84l-.74-.7c.75-.78 1.61-1.74 1.43-2.91a7.53 7.53 0 0 0-.7-2.17zm-.12-3.07v1.02c.15-.1.45-.78.52-.5.1.73.19 1.46.51 2.12-.3.1-.68.4-.94.38-.36-.76-.46-1.6-.59-2.4l.5-.62zm-.5.62c-.08-.34-.28-.78.26-.62.51-.08-.18.41-.26.61zm.5.4v-1.02c.37.03-.02.6.02.86l-.02.16zm0-1.02z'/%3E %3Cpath d='M434.07 226.22c-1.28 1.1-1.6.88-1.96 1.55-.45.84-.24 2.13.15 3.33 1.54 4.76-1.36 4.34-4.84 2.52-1.73-.9-3.75-3.22-5.33-4.38-1.57-1.16-2.68-1.15-3.11-1.63-.44-1.88-.8-3.52-.94-4.28-.18-.75-.53-2.43-.9-4.41.22-.59 1.3-.86 2.38-2.46 1.08-1.62 2.16-4.64 3.57-6.1 2.87-3.02 5.76-4.31 5.92 1.47.04 1.4.29 2.82 1.04 3.59.59.6.83.3 2.47 1.1a7.21 7.21 0 0 1 2.53 2c.62.8.5 1.73.63 2.64.13.9.53 1.76.18 2.64-.36.87-.95 1.7-1.79 2.42z' fill='%23edb92e'/%3E %3Cpath fill='%2321231e' d='M432.56 228.01c-.22-.22-.97-.3-.8-.63.46-.7 1.36-.9 1.92-1.5.18.04.77.62.61.82-.48.47-1.13.74-1.64 1.17-.04.04-.06.1-.09.14zm.18 2.93c-.33 0-.95.57-1.03.08-.33-1.12-.59-2.4-.04-3.5.25.26 1.06.3.79.74-.24.89.03 1.83.28 2.68zm-5.55 3.13c.24-.24.28-1.1.7-.78 1.14.53 2.35 1.19 3.63 1.06.77-.15.7-1.11.6-1.7-.07-.47-.2-.93-.34-1.4.34 0 .98-.58 1.04-.04.33 1.15.7 2.56-.12 3.6-.9.93-2.33.57-3.4.2-.73-.26-1.43-.59-2.11-.94zm-5.4-4.42c.27-.17.43-.98.76-.7 1.75 1.35 3.17 3.11 5.1 4.22-.24.24-.29 1.1-.7.77-1.92-1.16-3.38-2.94-5.15-4.29zm.6-.82zm-3.9-1.1c.26-.17 1.17-.04.86-.46.74.44 1.63.61 2.36 1.1.25.21.94.39.48.74-.22.38-.44.69-.8.26-.8-.58-1.8-.73-2.62-1.26a.82.82 0 0 1-.28-.38zm.11.22zm-.56-4.1c.08-.27-.2-1.28.21-.85.47.25.34.86.5 1.3l.72 3.2c-.33-.03-1 .48-1.04-.02-.31-1.34-.62-2.7-.89-4.05l.5.41zm0-1.03c.49-.31.68.76.23.2l-.23-.2zm-.5.62c.3 0 .86-.35 1-.11.07-.22-.53-.73-.5-.37-.1.2.23 1.07-.2.8-.2.12-.36-.72-.3-.32zm.99-.23zm-1.86-4.47c.31.01 1.02.64.97.08.28 1.47.56 2.94.89 4.4-.31-.03-.9.4-1.02.07-.3-1.44-.63-2.9-.86-4.34l.02-.2zm-.02.27zm2.45-2.84c.2.27 1.04.42.69.79-.55.84-1.39 1.41-2.13 2.07-.26.12-.67-.24-.99-.29.38-.82 1.34-1.15 1.88-1.85.2-.23.38-.46.55-.72zm3.62-6.17c.16.3.93.57.57.89-1.43 1.76-2.12 3.97-3.35 5.85-.21-.26-1.02-.4-.71-.77 1.2-1.96 1.93-4.24 3.5-5.97zm6.8 1.82c-.33-.1-1.1.28-1.02-.25-.09-1.04-.12-2.21-.85-3.03-.7-.56-1.6.02-2.22.42-.73.5-1.37 1.11-1.98 1.75-.16-.3-.97-.6-.53-.9 1.1-1.08 2.3-2.27 3.89-2.52 1.1-.15 2.02.77 2.3 1.77.3.89.38 1.83.4 2.76zm.89 3.24c-.28.13-.58.9-.85.57-.85-1.05-1-2.47-1.05-3.78.32.1 1.08-.28 1.02.22.07 1.03.17 2.2.88 3zm0 0zm2.33 1c-.23.24-.25 1.06-.65.82-.76-.45-1.78-.41-2.4-1.1.3-.15.57-.89.88-.58.64.32 1.38.43 2.02.79l.15.07zm2.71 2.15c-.29.1-.64.77-.89.5a6.82 6.82 0 0 0-2.26-1.73c.23-.24.26-1.07.65-.8.96.5 1.84 1.18 2.5 2.03zm-.8.63c.35.44.5.63.06.07l-.04-.05-.01-.02zm1.53 2.24c-.3-.06-.96.36-1.02 0-.1-.76 0-1.6-.5-2.24.3-.11.7-.85.93-.45.54.8.48 1.78.59 2.69zm.15 2.91c-.27-.22-1.08-.18-.87-.63.13-.72-.19-1.42-.28-2.13.3.04.92-.33 1.02 0 .2.9.5 1.86.13 2.76zm-1.93 2.62c-.12-.3-.83-.64-.51-.9a5.8 5.8 0 0 0 1.5-2.1c.24.2 1.03.19.86.56a6.93 6.93 0 0 1-1.85 2.44z'/%3E %3Cpath d='M417.9 222.59l-.07-.87c3.2-.88 5.7-2.72 7.72-5.43-1.14 2.9-4.2 5.28-7.65 6.3zM418.22 224.11l.3.83a16.3 16.3 0 0 1 9.18 3.14c-2.06-2.34-5.82-3.83-9.48-3.97z' fill='%2321231e'/%3E %3Cpath d='M432.69 233.31c-1.09-.34-2.27-.69-3.36-1.53-1.67-1.29-1.18-3.78.24-6.35.46-.83.52-2.21.28-3.57-.24-1.36-.77-2.7-1.5-3.39-2.34-2.26-3.77-4.75-2.58-6.58.8-1.22 1.88-1.94 2.87-2.6.22.62.36 1.46.38 2.55.04 1.4.29 2.82 1.04 3.58.59.6.83.3 2.47 1.1a7.21 7.21 0 0 1 2.53 2c.62.8.49 1.74.63 2.64.13.9.53 1.76.17 2.64-.35.87-.94 1.7-1.78 2.42-1.28 1.1-1.6.89-1.96 1.55-.45.85-.24 2.13.15 3.34.3.91.43 1.64.42 2.2z' fill='%23edb92e'/%3E %3Cpath fill='%2321231e' d='M429.01 232.18l.62-.8a9.51 9.51 0 0 0 3.2 1.44l-.3.97c-1.24-.37-2.49-.8-3.52-1.61zm.11-7l.89.5c-.7 1.32-1.41 2.81-1.19 4.36.1.52.38 1.01.8 1.33l-.61.81c-1.14-.84-1.43-2.4-1.15-3.71.2-1.17.7-2.27 1.26-3.3zm.22-3.23l1-.18c.2 1.29.28 2.7-.33 3.9l-.89-.5c.49-.99.38-2.17.22-3.22zm-1.34-3.11l.7-.74c.96.98 1.39 2.35 1.64 3.67l-1 .18a6.1 6.1 0 0 0-1.34-3.11zm0 0zm-2.66-7.24l.84.56c-.7 1.07-.2 2.4.4 3.39.58.95 1.33 1.78 2.12 2.55l-.7.74c-1.36-1.35-2.72-2.9-3.11-4.83-.16-.82-.01-1.7.45-2.4zm3.77-2.48l-.95.32c.16.13.94.17.62.36a8.53 8.53 0 0 0-2.6 2.36l-.84-.56c.74-1.16 1.88-2 3.01-2.74l.76.26zm-.76-.26c.3-.2.65-.58.68 0 .27.49-.42.02-.66 0h-.02zm1.17 2.96c-.32-.03-.78.1-1.01-.03-.03-.79-.1-1.59-.35-2.35l.96-.32c.29.87.37 1.79.4 2.7zm.89 3.24l-.72.72c-.97-1.05-1.12-2.57-1.18-3.93.32.03.78-.1 1.01.03.06 1.09.13 2.33.89 3.18zm2.33 1l-.44.92c-.68-.39-1.45-.51-2.15-.83-.2-.15-.66-.37-.26-.57.23-.11.44-.71.68-.37.57.3 1.25.38 1.83.7.11.04.23.1.34.16zm2.71 2.15l-.8.63a6.76 6.76 0 0 0-2.35-1.86l.44-.91c1.04.5 2 1.23 2.71 2.14zm-.8.63c.17.22.59.75.2.24l-.2-.24zm1.53 2.24l-1 .15c-.14-.8 0-1.7-.52-2.39l.8-.63c.66.81.6 1.9.72 2.87zm.14 2.91l-.93-.38c.3-.79-.12-1.6-.21-2.38l1-.15c.17.96.55 1.96.14 2.91zm-1.92 2.62l-.66-.78c.7-.6 1.3-1.36 1.65-2.22l.93.38a6.87 6.87 0 0 1-1.92 2.62zm-1.84 1.4l-.9-.48c.4-.78 1.33-.97 1.9-1.55.28-.34.46.3.69.45.35.25-.25.43-.4.62-.38.35-.96.48-1.27.92l-.02.04zm.18 2.94l-.96.31c-.36-1.19-.7-2.56-.11-3.73l.89.48c-.42.93-.09 2.01.18 2.94zm-.2 2.84l.29-.97c-.2.06-.7.7-.66.29a7.44 7.44 0 0 0-.39-1.85l.96-.31c.25.76.46 1.56.45 2.37l-.66.47zm.65-.47c-.04.29.14.89-.34.57-.61-.06.07-.33.27-.53l.05-.03.02-.01zm-.5-.01c-.17.51-.17.52 0 0zm.5 0c-.04.3.14.9-.34.58-.61-.06.07-.33.27-.53l.05-.03.02-.01z'/%3E %3Cpath d='M410.55 216.45c4.03-.2 7.91 3.32 8.49 7.63.57 4.31-2.25 7.66-6.1 7.7-3.87.05-7.45-3.1-8.19-7.27-.74-4.16 1.77-7.86 5.8-8.06z' fill='%23edb92e'/%3E %3Cpath fill='%2321231e' d='M419.54 224.02l-1 .13a8.48 8.48 0 0 0-6.37-7.06 6.48 6.48 0 0 0-1.6-.13c0-.34-.03-.68-.04-1.02 2.85-.13 5.57 1.46 7.22 3.72a9.5 9.5 0 0 1 1.79 4.36zm-6.6 8.28l-.01-1.02a5.59 5.59 0 0 0 4.8-2.75c.78-1.3 1-2.88.8-4.38l1.01-.13a7.48 7.48 0 0 1-2.11 6.5 6.62 6.62 0 0 1-4.49 1.78zm-8.69-7.7l1-.17c.55 3.18 3.04 6.03 6.25 6.7.47.1.95.15 1.43.15l.01 1.02c-2.97.04-5.77-1.74-7.33-4.22a9.61 9.61 0 0 1-1.36-3.47zm6.28-8.66l.05 1.02a5.52 5.52 0 0 0-4.57 2.75 6.92 6.92 0 0 0-.76 4.72l-1 .18a7.64 7.64 0 0 1 1.97-6.8 6.54 6.54 0 0 1 4.3-1.87z'/%3E %3Cpath d='M410.89 218.57c2.94-.13 5.77 2.42 6.2 5.57.44 3.16-1.58 5.65-4.46 5.7-2.83.05-5.52-2.34-6.03-5.38-.54-3.1 1.35-5.76 4.29-5.89z' fill='%23edb92e'/%3E %3Cpath fill='%2321231e' d='M417.59 224.07l-1 .14a6.06 6.06 0 0 0-4.7-5.07 4.87 4.87 0 0 0-.98-.07l-.05-1.01a6.56 6.56 0 0 1 5.5 2.91 7.1 7.1 0 0 1 1.23 3.1zm-4.95 6.28l-.02-1.02c1.39 0 2.75-.78 3.42-2 .55-.93.7-2.06.55-3.12l1-.14a5.7 5.7 0 0 1-1.43 4.78 5 5 0 0 1-3.52 1.5zm-6.55-5.8l1-.18a6.04 6.04 0 0 0 4.62 4.88c.3.05.6.08.91.08l.02 1.02a6.61 6.61 0 0 1-5.5-3.14 7.1 7.1 0 0 1-1.05-2.66zm4.77-6.5l.05 1.02a3.94 3.94 0 0 0-3.28 1.95c-.59 1-.74 2.22-.54 3.35l-1 .17a5.73 5.73 0 0 1 1.44-5.04c.88-.89 2.1-1.4 3.33-1.44z'/%3E %3Cpath d='M411.22 220.72c1.84-.07 3.6 1.51 3.89 3.49.28 1.97-.99 3.57-2.8 3.6-1.8.04-3.5-1.46-3.81-3.4-.32-1.94.88-3.62 2.72-3.69z' fill='%230c4076'/%3E %3Cpath fill='%2321231e' d='M415.6 224.13l-1 .15a3.63 3.63 0 0 0-2.8-3.01 2.89 2.89 0 0 0-.57-.05l-.04-1.01a4.33 4.33 0 0 1 3.63 1.96c.4.58.68 1.26.78 1.96zm-3.28 4.19l-.02-1.02c.86 0 1.69-.53 2.05-1.3.27-.53.33-1.14.25-1.72l1-.15a3.73 3.73 0 0 1-1.12 3.35c-.58.53-1.37.82-2.16.84zm-4.33-3.83l1-.17a3.58 3.58 0 0 0 2.81 2.94c.17.03.33.04.5.04l.02 1.02a4.34 4.34 0 0 1-3.64-2.06 4.69 4.69 0 0 1-.69-1.77zm2.72-3.77h1l-.48.5a2.3 2.3 0 0 0-1.99 1.27 2.96 2.96 0 0 0-.25 1.83l-1 .17a3.78 3.78 0 0 1 1.05-3.4 3.3 3.3 0 0 1 2.15-.88l-.48.5zm1 0v.49l-.48.01.49-.5zm0 0h-1l.48-.51.53.5zm-1 0v-.5l.48-.01-.48.5z'/%3E %3C/g%3E %3Cg%3E %3Cpath d='M482.14 182.98a6.85 6.85 0 0 1 6.82 6.87c0 3.8-3.05 6.88-6.82 6.88a6.85 6.85 0 0 1-6.82-6.88c0-3.8 3.05-6.87 6.82-6.87z' fill='%23FFF'/%3E %3Cpath d='M489.47 189.85h-1.01a6.39 6.39 0 0 0-6.32-6.36v-1.02a7.34 7.34 0 0 1 7.33 7.38zm-7.33 7.38v-1.02a6.33 6.33 0 0 0 6.32-6.36h1.01a7.41 7.41 0 0 1-3.7 6.42c-1.1.63-2.36.96-3.63.96zm-7.33-7.38h1.02a6.38 6.38 0 0 0 6.31 6.36v1.02a7.34 7.34 0 0 1-7.33-7.38zm7.33-7.38v1.02a6.33 6.33 0 0 0-6.31 6.36h-1.02a7.42 7.42 0 0 1 3.48-6.28 7.3 7.3 0 0 1 3.85-1.1z' fill='%2321231e'/%3E %3Cpath d='M482.14 171.07a6.85 6.85 0 0 1 6.82 6.87c0 3.8-3.05 6.88-6.82 6.88a6.85 6.85 0 0 1-6.82-6.88c0-3.8 3.05-6.87 6.82-6.87z' fill='%23FFF'/%3E %3Cpath d='M489.47 177.94h-1.01a6.39 6.39 0 0 0-6.32-6.36v-1.02a7.33 7.33 0 0 1 7.33 7.38zm-7.33 7.38v-1.02a6.33 6.33 0 0 0 6.32-6.36h1.01a7.41 7.41 0 0 1-3.7 6.42c-1.1.63-2.36.96-3.63.96zm-7.33-7.38h1.02a6.38 6.38 0 0 0 6.31 6.36v1.02a7.34 7.34 0 0 1-7.33-7.38zm7.33-7.38v1.02a6.33 6.33 0 0 0-6.31 6.36h-1.02a7.42 7.42 0 0 1 3.48-6.28 7.3 7.3 0 0 1 3.85-1.1z' fill='%2321231e'/%3E %3Cpath d='M482.14 159.61c3.77 0 6.82 3.08 6.82 6.87s-3.05 6.88-6.82 6.88a6.85 6.85 0 0 1-6.82-6.88c0-3.8 3.05-6.87 6.82-6.87z' fill='%23FFF'/%3E %3Cpath d='M489.47 166.49h-1.01a6.39 6.39 0 0 0-6.32-6.36v-1.02a7.33 7.33 0 0 1 7.33 7.38zm-7.33 7.38v-1.02a6.32 6.32 0 0 0 6.32-6.36h1.01a7.31 7.31 0 0 1-7.33 7.38zm-7.33-7.38h1.02a6.39 6.39 0 0 0 6.31 6.36v1.02a7.34 7.34 0 0 1-7.33-7.38zm7.33-7.38v1.02a6.33 6.33 0 0 0-6.31 6.36h-1.02a7.42 7.42 0 0 1 3.48-6.28 7.3 7.3 0 0 1 3.85-1.1z' fill='%2321231e'/%3E %3Cpath d='M482.14 127.08a6.85 6.85 0 0 1 6.82 6.87c0 3.8-3.05 6.88-6.82 6.88a6.85 6.85 0 0 1-6.82-6.88c0-3.8 3.05-6.87 6.82-6.87z' fill='%23FFF'/%3E %3Cpath d='M489.47 133.95h-1.01a6.39 6.39 0 0 0-6.32-6.36v-1.02a7.33 7.33 0 0 1 7.33 7.38zm-7.33 7.38v-1.02a6.33 6.33 0 0 0 6.32-6.36h1a7.41 7.41 0 0 1-3.66 6.4 7.3 7.3 0 0 1-3.66.98zm-7.33-7.38h1.02a6.39 6.39 0 0 0 6.31 6.36v1.02a7.33 7.33 0 0 1-7.33-7.38zm7.33-7.38v1.02a6.33 6.33 0 0 0-6.31 6.36h-1.02a7.42 7.42 0 0 1 3.48-6.28 7.3 7.3 0 0 1 3.85-1.1z' fill='%2321231e'/%3E %3Cpath d='M482.14 137.16a6.85 6.85 0 0 1 6.82 6.87c0 3.8-3.05 6.88-6.82 6.88a6.85 6.85 0 0 1-6.82-6.88c0-3.8 3.05-6.87 6.82-6.87z' fill='%23FFF'/%3E %3Cpath d='M489.47 144.03h-1.01a6.39 6.39 0 0 0-6.32-6.36v-1.02a7.34 7.34 0 0 1 7.33 7.38zm-7.33 7.38v-1.02a6.33 6.33 0 0 0 6.32-6.36h1a7.41 7.41 0 0 1-3.66 6.4 7.3 7.3 0 0 1-3.66.98zm-7.33-7.38h1.02a6.39 6.39 0 0 0 6.31 6.36v1.02a7.34 7.34 0 0 1-7.33-7.38zm7.33-7.38v1.02a6.33 6.33 0 0 0-6.31 6.36h-1.02a7.41 7.41 0 0 1 3.48-6.28 7.3 7.3 0 0 1 3.85-1.1z' fill='%2321231e'/%3E %3Cpath d='M482.14 148.16a6.85 6.85 0 0 1 6.82 6.87c0 3.8-3.05 6.88-6.82 6.88a6.85 6.85 0 0 1-6.82-6.88c0-3.8 3.05-6.87 6.82-6.87z' fill='%23FFF'/%3E %3Cpath d='M489.47 155.03h-1.01a6.39 6.39 0 0 0-6.32-6.36v-1.02a7.33 7.33 0 0 1 7.33 7.38zm-7.33 7.38v-1.02a6.33 6.33 0 0 0 6.32-6.36h1a7.41 7.41 0 0 1-3.66 6.4 7.3 7.3 0 0 1-3.66.98zm-7.33-7.38h1.02a6.39 6.39 0 0 0 6.31 6.36v1.02a7.33 7.33 0 0 1-7.33-7.38zm7.33-7.38v1.02a6.33 6.33 0 0 0-6.31 6.36h-1.02a7.42 7.42 0 0 1 3.48-6.28 7.3 7.3 0 0 1 3.85-1.1z' fill='%2321231e'/%3E %3Cpath d='M486.99 195.51c.98 1.58.72 1.89 1.36 2.4.83.65 2.18.65 3.48.45 5.25-.83 4.52 2.35 2.2 5.93-1.16 1.78-3.86 3.58-5.26 5.12-1.4 1.53-1.53 2.8-2.08 3.19-2.02.05-3.75.06-4.54.04-.8.02-2.53 0-4.54-.04-.56-.38-.68-1.66-2.08-3.2-1.4-1.53-4.1-3.33-5.26-5.11-2.32-3.58-3.05-6.76 2.2-5.93 1.3.2 2.65.2 3.47-.46.65-.5.39-.81 1.37-2.39a7 7 0 0 1 2.22-2.3c.83-.51 1.72-.23 2.62-.23.9 0 1.78-.28 2.61.23a7 7 0 0 1 2.23 2.3z' fill='%23EDB92E'/%3E %3Cpath fill='%2321231e' d='M488.66 197.51c-.26.16-.45.92-.75.7-.65-.61-.74-1.58-1.26-2.28-.16-.28.63-.6.8-.62.46.64.66 1.41 1.07 2.07l.14.13zm-.62.8zm3.71-.45c-.05.33.42 1.05-.1 1.05-1.21.15-2.59.18-3.61-.6.25-.18.43-.87.74-.71.89.52 2 .4 2.97.26zm2.7 6.71c-.22-.27-1.08-.4-.7-.8.71-1.2 1.54-2.47 1.53-3.91-.04-.91-1.1-1.12-1.84-1.11a9.2 9.2 0 0 0-1.53.12c.05-.34-.43-1.08.12-1.05 1.28-.15 2.85-.26 3.8.8.87 1.13.35 2.65-.18 3.82-.34.74-.76 1.45-1.2 2.13zm-5.31 5.19c-.17-.3-1-.58-.55-.9 1.62-1.66 3.66-2.92 5.01-4.85.2.26 1.02.4.72.74-1.42 1.96-3.53 3.26-5.18 5zm-2.44 3.36c-.11-.3.22-1.2-.3-.94.51-.68.78-1.6 1.33-2.28.23-.23.48-.87.77-.74.2.29.9.54.4.87-.74.8-1.05 1.88-1.68 2.77a.84.84 0 0 1-.52.32zm.27-.1zm-4.82.14c.1-.29-.2-.99.15-1.02 1.46.01 2.92 0 4.37-.04-.1.32.28 1.1-.23 1.02-1.42.04-2.9.05-4.3.04zm0-1.02zm0 0v.88c0-.29-.03-.6 0-.88zm-.02 0h.01zm-4.81.89c.08-.3.88-.85.3-.93 1.48.03 3.02.06 4.51.04-.08.3.22.98-.14 1.02-1.48 0-2.98.02-4.46-.07l-.21-.06zm.27.09zm-2.44-3.36c.31-.14.65-.95.93-.49.77.82 1.18 1.88 1.73 2.84.14.27-.38.61-.49.92-.74-.63-.9-1.68-1.5-2.43-.2-.3-.43-.58-.67-.84zm-5.3-5.19c.32-.09.77-.8.99-.35 1.42 1.88 3.46 3.14 5.06 4.85-.3.14-.63.93-.92.5-1.68-1.7-3.77-3-5.14-5zm2.69-6.7c-.15.3.08 1.14-.43.96-.94-.09-2.05-.26-2.83.39-.57.74-.13 1.75.17 2.53.34.8.78 1.54 1.24 2.26-.33.1-.8.84-1 .32-.83-1.4-1.77-2.91-1.67-4.6.06-1.17 1.2-1.92 2.29-1.97.74-.08 1.5 0 2.23.1zm3.1-.36c.1.3.86.72.42.94-1.1.68-2.46.6-3.68.42.16-.3-.07-1.1.4-.97.94.1 2.04.2 2.85-.39zm1.24-2.26c.19.24.95.35.77.68-.56.74-.63 1.8-1.4 2.38-.1-.3-.8-.66-.47-.93.4-.65.6-1.41 1.04-2.04 0-.04.05-.06.06-.1zm0 0zm2.39-2.47c.07.3.69.74.38.96a6.62 6.62 0 0 0-1.92 2.05c-.2-.26-1.04-.37-.73-.74a7.4 7.4 0 0 1 2.27-2.27zm2.88-.3c-.1.3.2 1.01-.18 1-.73 0-1.51-.23-2.17.17-.07-.31-.77-.8-.33-.98.83-.44 1.78-.21 2.68-.2zm2.88.3c-.25.2-.34 1-.7.78-.7-.29-1.46-.05-2.18-.07.09-.3-.2-.97.15-1.02.92-.05 1.9-.23 2.73.31zm0 0zm1.96 3.25c-.05-.24.12-1.35-.13-.78-.18.48-.36.63-.59.1a6.25 6.25 0 0 0-1.77-1.7c.24-.2.35-1 .7-.76.9.6 1.65 1.43 2.22 2.36l-.43.78zm.43-.78c.1.28.83.93.13.78-.68.15-.53-.19-.22-.62l.09-.16zm-.43-.24c-.08.24.17 1.06-.12.95-.6-.13.03-.62.12-.95zm-.43.78c-.1-.3-.83-.93-.13-.78.72-.16.47.24.19.67l-.04.06-.02.05z'/%3E %3Cpath d='M481.35 212.77l-.88-.13a17.67 17.67 0 0 0-4.33-9.63c2.65 1.8 4.62 5.67 5.21 9.76z' fill='%2321231E'/%3E %3Cpath d='M494.21 198.3c-.47 1.15-.96 2.4-1.98 3.46-1.54 1.61-4.1.57-6.57-1.51-.78-.66-2.16-.98-3.54-.97-1.37 0-2.74.33-3.5.97-2.47 2.08-5.03 3.12-6.57 1.51-1.02-1.06-1.51-2.31-1.98-3.46.6-.11 1.38-.1 2.38.06 1.3.2 2.66.2 3.49-.45.64-.51.38-.82 1.36-2.4a6.97 6.97 0 0 1 2.22-2.3c.83-.51 1.73-.23 2.62-.23.9 0 1.79-.28 2.62.23a7 7 0 0 1 2.22 2.3c.98 1.58.72 1.89 1.36 2.4.83.65 2.18.65 3.48.45 1-.16 1.8-.17 2.39-.06z' fill='%23EDB92E'/%3E %3Cpath fill='%2321231e' d='M492.6 202.12l-.73-.7c.9-.93 1.4-2.13 1.88-3.3l.93.38a10.7 10.7 0 0 1-2.08 3.62zm-7.26-1.48l.65-.78c1.21.99 2.57 2 4.18 2.17.62.06 1.27-.15 1.7-.62l.73.71c-.9 1-2.39 1.14-3.6.72a11.24 11.24 0 0 1-3.66-2.2zm.64-.78l.4.33-.4-.33zm-3.85-.07v-1.02c1.34.02 2.78.23 3.85 1.09l-.64.78c-.9-.69-2.12-.83-3.21-.85zm-3.18.85l-.64-.78c1.07-.85 2.49-1.06 3.82-1.09v1.02c-1.1.02-2.29.17-3.18.85zm-7.26 1.48l.73-.7c.76.84 2.04.7 2.99.3a11.31 11.31 0 0 0 2.9-1.86l.64.78c-1.4 1.15-3 2.29-4.86 2.42a3.05 3.05 0 0 1-2.4-.94zm-1.7-4.32l.18 1c.14-.13.32-.9.44-.53a9.36 9.36 0 0 0 1.8 3.14c-.23.24-.48.47-.72.7a10.65 10.65 0 0 1-2.08-3.61l.38-.7zm-.38.7c-.13-.32-.4-.71.14-.65.49-.18-.1.42-.13.63l-.01.02zm2.93-.64l-.16 1a7.06 7.06 0 0 0-2.21-.05l-.18-1a8.11 8.11 0 0 1 2.55.05zm3.1-.35l.61.8c-1.1.83-2.58.74-3.87.56l.16-1.01c1.01.13 2.2.27 3.1-.35zm.61.8l-.15.12.15-.12zm.62-3.06l.86.54c-.46.64-.66 1.42-1.06 2.1-.16.18-.43.62-.59.2-.08-.24-.64-.51-.3-.71.36-.54.5-1.2.87-1.75l.22-.38zm2.4-2.47l.52.87a6.53 6.53 0 0 0-2.06 2.14l-.86-.54a7.5 7.5 0 0 1 2.4-2.47zm2.87-.3v1.01c-.77.02-1.63-.27-2.35.16l-.52-.87c.86-.57 1.91-.34 2.87-.3zm2.89.3l-.53.87c-.72-.43-1.58-.14-2.36-.16v-1.02c.97-.03 2.02-.26 2.89.3zm0 0zm2.39 2.47l-.86.54a6.53 6.53 0 0 0-2.06-2.14c.17-.3.35-.58.53-.87a7.52 7.52 0 0 1 2.39 2.47zm1.24 2.26l-.62.8c-.73-.54-.8-1.52-1.3-2.23-.38-.33.13-.46.38-.65.3-.36.43.03.58.3.35.52.46 1.18.84 1.68l.12.1zm-.62.8c-.39-.3-.38-.3 0 0zm3.71-.45l.16 1c-1.3.2-2.77.28-3.87-.55l.62-.8c.88.62 2.08.49 3.1.35zm2.93.64l-.93-.39c.03.2.6.8.17.66-.67-.07-1.35 0-2.01.1l-.16-1.01a8.1 8.1 0 0 1 2.56-.06l.37.7zm-.37-.7c.33.06.8.04.46.48-.11.5-.3-.3-.45-.46l-.01-.02zm-.1.5c.5.2.51.21.01 0zm.1-.5c.33.06.8.04.46.48-.11.5-.3-.3-.45-.46l-.01-.02z'/%3E %3Cpath d='M482.14 211.65c4.27 0 7.73 3.49 7.73 7.79s-3.46 7.79-7.73 7.79c-4.27 0-7.73-3.49-7.73-7.79s3.46-7.79 7.73-7.79z' fill='%23EDB92E'/%3E %3Cpath d='M482.94 212.77l.88-.13c.47-3.78 1.97-6.9 4.33-9.63-2.65 1.8-4.62 5.67-5.21 9.76z' fill='%2321231e'/%3E %3C/g%3E %3Cuse xlink:href='%23a' transform='matrix(-1 0 0 1 964.29 0)'/%3E %3Cg%3E %3Cpath stroke='%2321231e' stroke-width='1.01' fill='%23edb92e' d='M576.93 293.58c2 .3 3.06 1.57 3 2.86.06 1.3-1 2.56-3 2.86-.46.13-.97.22-1.53.27a1109.04 1109.04 0 0 1-186.51 0 8.72 8.72 0 0 1-1.53-.27c-2-.3-3.07-1.56-3-2.86-.07-1.3 1-2.56 3-2.86.45-.13.96-.22 1.53-.27a1109.17 1109.17 0 0 1 186.5 0 8.6 8.6 0 0 1 1.54.27z'/%3E %3Cpath fill='%2321231e' d='M412.13 298.41c-.77-.03-.76-1.36 0-1.39.6.02 2.72-.21 3.92-.24 6.46-.38 12.93-.71 19.4-.98.66 2.12-2.21.98-3.43 1.36-3.7.17-7.39.35-11.08.56 4.85.26 9.7.5 14.56.7.56 2.14-2.08.8-3.25 1.07-6.7-.3-13.42-.65-20.12-1.08.07-.52-.04.05 0 0zm.04-.7zm46.62-2.63c.61 2.13-2.23.93-3.46 1.3-6.61.15-13.22.36-19.83.64-.66-2.12 2.21-.98 3.43-1.35 6.62-.26 13.24-.45 19.86-.59zm23.35-.22c.57 2.14-2.25.88-3.48 1.21-6.62.02-13.23.1-19.85.22-.61-2.12 2.24-.92 3.46-1.27 6.62-.11 13.25-.16 19.87-.16zm23.35.26c.52 2.15-2.27.83-3.5 1.14-6.62-.12-13.24-.18-19.85-.18-.58-2.14 2.25-.88 3.48-1.2 6.62.02 13.25.1 19.87.24zm23.34.74c.48 2.16-2.29.78-3.53 1.07-6.61-.26-13.23-.45-19.84-.6-.53-2.15 2.27-.83 3.5-1.13 6.63.16 13.25.38 19.87.66zm23.32 1.2c.35-.15.96.98.2 1.25-2.37.23-5.54.35-8.22.52-5.1.28-10.2.53-15.3.74-.67-2.1 2.2-.97 3.42-1.36 3.36-.15 6.72-.32 10.08-.5a1149 1149 0 0 0-13.56-.64c-.48-2.16 2.29-.78 3.53-1.06 6.62.3 13.24.65 19.85 1.06zm-.04.65zm-116.61.7c.78 0 .73 1.29-.05 1.22l.05-1.22zm93.33 1.16c-.78.07-.84-1.21-.06-1.2l.06 1.2zM482.37 265.18l-22.74 11.46-.45-.92 22.74-11.45h.45v.91zm-.45-.91l.22-.11.23.1h-.45zm22.74 12.37l-22.74-11.46.45-.91 22.74 11.45v.92h-.45zm.45-.92l.9.46-.9.46v-.92zm-23.2 11.46l22.75-11.46.45.92-22.74 11.45h-.45v-.91zm.46.91l-.23.11-.22-.11h.45zm-22.74-12.37l22.74 11.46-.45.91-22.74-11.46v-.9h.45zm-.45.91l-.9-.45.9-.46v.91z'/%3E %3Cpath fill='%230c4076' d='M482.14 269.15c5.65 0 10.23 3.08 10.23 6.87 0 3.8-4.58 6.88-10.23 6.88s-10.23-3.08-10.23-6.88 4.58-6.87 10.23-6.87z'/%3E %3Cpath fill='%2321231e' d='M492.88 276.02c-.4-.08-1.17.25-1.03-.4-.24-2.32-2.25-3.98-4.27-4.87-1.7-.75-3.58-1.09-5.44-1.1.1-.37-.28-1.22.4-1 3.3.09 6.8 1.17 8.99 3.77a5.75 5.75 0 0 1 1.35 3.6zm-10.74 7.38c.1-.37-.28-1.21.4-1.02 3-.1 6.2-1.04 8.2-3.4a4.71 4.71 0 0 0 1.13-2.96c.38.08 1.2-.26 1 .4-.21 2.64-2.37 4.65-4.66 5.7a14.4 14.4 0 0 1-6.07 1.28zm-10.74-7.38c.4.08 1.18-.25 1.03.4.25 2.32 2.25 3.98 4.27 4.87 1.7.75 3.58 1.1 5.44 1.1-.1.37.28 1.22-.39 1-3.3-.09-6.81-1.17-9-3.77a5.75 5.75 0 0 1-1.35-3.6zm10.74-7.38c-.1.37.28 1.21-.4 1.02-3 .1-6.2 1.04-8.2 3.4a4.71 4.71 0 0 0-1.13 2.96c-.38-.08-1.2.26-1-.4.21-2.64 2.37-4.65 4.66-5.7a14.42 14.42 0 0 1 6.07-1.28z'/%3E %3Cpath fill='%23edb92e' d='M482.14 211.65c4.27 0 7.73 3.49 7.73 7.79s-3.46 7.79-7.73 7.79c-4.27 0-7.73-3.49-7.73-7.79s3.46-7.79 7.73-7.79z'/%3E %3Cpath fill='%2321231e' d='M490.38 219.44h-1.01a7.3 7.3 0 0 0-4-6.5c-.99-.52-2.1-.78-3.23-.78v-1.02a8.25 8.25 0 0 1 8.24 8.3zm-8.24 8.3v-1.02a7.24 7.24 0 0 0 7.23-7.28h1.01a8.33 8.33 0 0 1-4.09 7.17 8.17 8.17 0 0 1-4.15 1.13zm-8.23-8.3h1a7.3 7.3 0 0 0 4 6.5c1 .52 2.11.78 3.23.78v1.02a8.25 8.25 0 0 1-8.23-8.3zm8.23-8.3v1.02a7.24 7.24 0 0 0-7.22 7.28h-1.01a8.34 8.34 0 0 1 3.9-7.06 8.19 8.19 0 0 1 4.33-1.24z'/%3E %3Cpath fill='%23edb92e' d='M482.14 213.71a5.7 5.7 0 0 1 5.68 5.73c0 3.16-2.54 5.73-5.68 5.73s-5.68-2.57-5.68-5.73a5.7 5.7 0 0 1 5.68-5.73z'/%3E %3Cpath fill='%2321231e' d='M488.33 219.44h-1.01a5.24 5.24 0 0 0-5.18-5.22v-1.02a6.2 6.2 0 0 1 6.19 6.24zm-6.19 6.24v-1.02a5.19 5.19 0 0 0 5.18-5.22h1.01a6.27 6.27 0 0 1-2.9 5.29c-.98.62-2.13.95-3.29.95zm-6.2-6.24h1.02a5.24 5.24 0 0 0 5.18 5.22v1.02a6.2 6.2 0 0 1-6.2-6.24zm6.2-6.24v1.02a5.19 5.19 0 0 0-5.18 5.22h-1.01a6.18 6.18 0 0 1 6.2-6.24z'/%3E %3Cpath fill='%230c4076' d='M482.14 215.83a3.6 3.6 0 0 1 3.58 3.6c0 2-1.6 3.61-3.58 3.61a3.6 3.6 0 0 1-3.58-3.6c0-2 1.6-3.61 3.58-3.61z'/%3E %3Cpath fill='%2321231e' d='M486.23 219.44h-1.01a3.1 3.1 0 0 0-3.08-3.1v-1.02a4.09 4.09 0 0 1 4.09 4.12zm-4.08 4.12v-1.02a3.08 3.08 0 0 0 3.07-3.1h1.01a4.14 4.14 0 0 1-4.08 4.12zm-4.09-4.12h1.01a3.1 3.1 0 0 0 3.08 3.1v1.02a4.09 4.09 0 0 1-4.09-4.12zm4.09-4.12v1.02a3.08 3.08 0 0 0-3.08 3.1h-1.01a4.14 4.14 0 0 1 4.09-4.12zM482.16 256.3c-43.82.22-67.8 2.12-101.63 5.29-2.02.19-3.09.9-3.5 1.21a3.4 3.4 0 0 0-1.22 3c.1.95 1.12 3.15 4.9 2.76 23.59-2.41 63.74-5.43 101.35-5.2 33.73.21 66.84 1.66 100.88 5.14 3 .3 4.78-.36 5.4-2.3.54-1.69-.43-3.15-1.9-3.86-2-.97-4.65-.95-8.4-1.28-31.18-2.76-67.33-4.9-95.88-4.76zm.12 1.09c28.75-.19 65.2 1.72 95.75 4.64 3.75.35 7.13.62 8 1.2 1.03.71 1.85 1.35 1.31 2.78-.33.9-1.04 1.8-4.28 1.46-33.25-3.55-67.8-4.95-100.9-5.13a951.23 951.23 0 0 0-101 5.13c-3.79.42-4.15-1.06-4.32-1.8-.2-.95.12-1.56 1.1-2.28.44-.32.76-.57 2.78-.77 30.67-3.07 57.72-4.94 101.56-5.23z'/%3E %3C/g%3E %3C/g%3E %3Cpath d='M314.58 301.17v271.32c0 48.56 18.82 92.64 49.17 124.58s72.25 51.75 118.4 51.75c46.14 0 88.04-19.8 118.39-51.74 30.36-31.95 49.17-76.03 49.17-124.58V301.19H314.57z' fill='%23C6363C'/%3E %3Cpath fill='%23FFF' d='M313.39 300c.2 94.24-.38 188.5.29 282.73 2.19 42.57 19.72 84.27 49.2 115.14 3.19-4.32-7.18-9.2-9.02-14.05-27.63-34.67-40.25-79.69-38.11-123.7V302.37h332.78c-.2 93.41.38 186.84-.29 280.25-2.85 67.34-47.2 132-111.11 155.15a158.13 158.13 0 0 1-55 9.88c1.15 5.44 12.2.64 17.23 1.43 63.88-6.28 119.6-53.78 140.58-113.74 11.26-28.96 11.56-60.35 10.95-90.95V300h-337.5z'/%3E %3Cg stroke='%2321231e' stroke-width='.99' fill='%23FFF'%3E %3Cpath d='M483.67 734.79c1.46-.24 3.91.07 5.77-1.4 2.47-1.94 1.49-9.78 1.27-14.74-1.14-25.36-2.18-68.04-3.47-127.97a16.7 16.7 0 0 0-5.1.07 16.68 16.68 0 0 0-5.08-.07c-1.3 59.93-2.33 102.62-3.47 127.97-.22 4.96-1.2 12.8 1.27 14.75 1.86 1.46 4.31 1.15 5.77 1.39h3.04z'/%3E %3Cpath d='M499.55 734.06c-1.47-.1-3.89.42-5.87-.86-2.64-1.71-2.85-9.74-3.08-14.7-1.16-25.35-3.51-67.83-7.65-127.64 2.08-.48 3.62-.47 5.08-.38l.7-.16c9.52 59.16 13.12 101.14 19.64 126.46.9 3.5 2.84 12.25-.17 15.1-1.72 1.62-4.2 1.54-5.62 1.9l-3.03.28z'/%3E %3Cpath d='M518.2 731.39c-1.48.03-3.84.77-5.93-.33-2.78-1.46-2.66-9.47-3.9-14.28-6.53-25.32-10.12-67.3-19.65-126.5 2.02-.66 3.56-.8 5.02-.84l.2-.07c15.16 57.54 19.7 98.1 31.46 123.15 1.09 3.47 4.05 12.7 1.22 15.9-1.57 1.78-4.04 1.92-5.43 2.42l-2.99.55z'/%3E %3Cpath d='M536.98 726.08c-1.46.17-3.93 1.54-6.12.65-2.91-1.18-3.37-9.75-5.46-14.2-11.82-25.18-16.35-65.99-31.66-123.95a16.73 16.73 0 0 1 4.91-1.34c1.33-.6 1.08-.92 3.19-1.23 17.8 57.24 23.58 97.06 40.37 121.76 2.7 3.99 4.69 11.98 2.85 14.53-1.38 1.92-3.83 2.3-5.16 2.94l-2.92.84zM464.75 734.06c1.47-.1 3.89.42 5.87-.86 2.64-1.71 2.85-9.74 3.08-14.7 1.17-25.35 3.51-67.83 7.65-127.64a16.72 16.72 0 0 0-5.08-.38l-.7-.16c-9.52 59.16-13.12 101.14-19.64 126.46-.9 3.5-2.84 12.25.17 15.1 1.72 1.62 4.2 1.54 5.62 1.9l3.03.28z'/%3E %3Cpath d='M446.09 731.39c1.47.03 3.84.77 5.93-.33 2.77-1.46 2.66-9.47 3.9-14.28 6.53-25.32 10.12-67.3 19.66-126.5-2.03-.66-3.57-.8-5.03-.84l-.2-.07c-15.16 57.54-19.7 98.1-31.46 123.15-1.08 3.47-4.05 12.7-1.21 15.9 1.56 1.78 4.03 1.92 5.42 2.42l2.99.55z'/%3E %3Cpath d='M427.31 726.08c1.46.17 3.93 1.54 6.12.65 2.91-1.18 3.37-9.75 5.47-14.2 11.8-25.18 16.34-65.99 31.65-123.95a16.73 16.73 0 0 0-4.91-1.34c-1.33-.6-1.08-.92-3.19-1.23-17.8 57.24-23.58 97.06-40.36 121.76-2.71 3.99-4.7 11.98-2.86 14.53 1.38 1.92 3.83 2.3 5.16 2.94l2.92.84zM527.05 682.84c-1.34.08-3.36.9-5.46-.1-2.8-1.34-4.63-9.07-6.13-13.88-11.92-23.54-22.8-65.34-40.63-123.45 1.73-.73 3.1-.91 4.43-1.01 1.18-.52 2.45-.99 4.38-1.16 19.21 57.5 27.84 99.07 46.62 121.97 3.1 3.78 5.4 12.02 3.93 14.41-1.1 1.8-3.33 2.03-4.51 2.57l-2.63.65z'/%3E %3Cpath d='M511.85 685.82c-1.34-.03-3.45.63-5.43-.54-2.63-1.55-3.56-9.4-4.5-14.3-4.8-25.05-13.66-67.1-26.24-126.12 1.8-.59 3.2-.66 4.53-.65 1.23-.42 2.55-.8 4.49-.81 14.87 58.66 18.3 102.58 32.37 125.13 2.57 4.1 4 12.4 2.26 14.66-1.3 1.7-3.56 1.75-4.79 2.2l-2.7.43z'/%3E %3Cpath d='M496.38 687.58c-1.33-.13-3.5.35-5.34-.97-2.44-1.76-2.46-9.64-2.83-14.6-1.9-25.31-5.88-67.87-11.62-127.63 1.86-.44 3.26-.4 4.58-.3a13.5 13.5 0 0 1 4.57-.44c8.05 59.58 12.73 102.71 17.83 127.14 1.02 4.88 2.55 12.67.56 14.78-1.5 1.59-3.74 1.46-5.02 1.8l-2.73.22z'/%3E %3Cpath d='M437.24 682.84c1.34.08 3.36.9 5.46-.1 2.8-1.34 4.63-9.07 6.13-13.88 11.92-23.54 22.8-65.34 40.63-123.45-1.73-.73-3.1-.91-4.43-1.01a13 13 0 0 0-4.38-1.16c-19.21 57.5-27.84 99.07-46.62 121.97-3.1 3.78-5.4 12.02-3.93 14.41 1.1 1.8 3.33 2.03 4.51 2.57l2.63.65z'/%3E %3Cpath d='M452.44 685.82c1.34-.03 3.45.63 5.43-.54 2.63-1.55 3.56-9.4 4.5-14.3 4.8-25.05 13.66-67.1 26.24-126.12-1.8-.59-3.2-.66-4.53-.65a13.31 13.31 0 0 0-4.49-.81c-14.87 58.66-18.3 102.58-32.38 125.13-2.56 4.1-4 12.4-2.25 14.66 1.3 1.7 3.55 1.75 4.79 2.2l2.69.43z'/%3E %3Cpath d='M467.92 687.58c1.33-.13 3.5.35 5.34-.97 2.44-1.76 2.46-9.64 2.84-14.6 1.9-25.31 5.87-67.87 11.61-127.63-1.86-.44-3.26-.4-4.58-.3a13.51 13.51 0 0 0-4.57-.44c-8.05 59.58-12.73 102.71-17.83 127.14-1.02 4.88-2.55 12.67-.56 14.78 1.5 1.59 3.74 1.46 5.02 1.8l2.73.22z'/%3E %3Cpath d='M483.52 688.09c1.31-.24 3.53.07 5.2-1.4 2.23-1.93 1.35-9.78 1.15-14.74-1.03-25.36-1.96-68.04-3.13-127.98a13.6 13.6 0 0 0-4.6.07c-1.3-.21-2.68-.36-4.59-.07-1.16 59.94-2.1 102.62-3.12 127.98-.2 4.96-1.08 12.8 1.14 14.75 1.68 1.46 3.9 1.15 5.2 1.39h2.75z'/%3E %3Cpath d='M516.54 647.97c-1.03.08-2.57.9-4.19-.1-2.14-1.34-3.54-9.07-4.69-13.88-9.12-23.54-17.45-65.34-31.12-123.45a8.18 8.18 0 0 1 3.4-1c.9-.53 1.87-1 3.35-1.17 14.72 57.5 21.33 99.07 35.7 121.97 2.38 3.78 4.15 12.02 3.02 14.41-.85 1.8-2.56 2.03-3.46 2.57l-2.01.65z'/%3E %3Cpath d='M504.9 650.96c-1.03-.03-2.64.63-4.16-.54-2.01-1.55-2.72-9.4-3.44-14.3-3.68-25.05-10.47-67.1-20.1-126.12a8.1 8.1 0 0 1 3.46-.65 8.13 8.13 0 0 1 3.44-.81c11.4 58.66 14.03 102.58 24.8 125.13 1.97 4.1 3.06 12.4 1.73 14.66-1 1.7-2.72 1.75-3.67 2.2l-2.06.43z'/%3E %3Cpath d='M493.05 652.72c-1.02-.14-2.68.35-4.09-.97-1.87-1.76-1.89-9.64-2.17-14.6-1.45-25.31-4.5-67.87-8.9-127.63 1.43-.44 2.5-.4 3.51-.3a8.06 8.06 0 0 1 3.5-.44c6.17 59.58 9.75 102.71 13.66 127.14.78 4.88 1.95 12.67.43 14.78-1.15 1.59-2.87 1.46-3.85 1.8l-2.09.22z'/%3E %3Cpath d='M447.75 647.97c1.03.08 2.57.9 4.19-.1 2.14-1.34 3.54-9.07 4.69-13.88 9.12-23.54 17.45-65.34 31.12-123.45a8.18 8.18 0 0 0-3.4-1 8.25 8.25 0 0 0-3.35-1.17c-14.72 57.5-21.33 99.07-35.7 121.97-2.38 3.78-4.15 12.02-3.02 14.41.85 1.8 2.56 2.03 3.46 2.57l2.01.65z'/%3E %3Cpath d='M459.39 650.96c1.03-.03 2.64.63 4.16-.54 2.01-1.55 2.72-9.4 3.44-14.3 3.68-25.05 10.47-67.1 20.1-126.12a8.09 8.09 0 0 0-3.46-.65 8.13 8.13 0 0 0-3.44-.81c-11.4 58.66-14.03 102.58-24.8 125.13-1.97 4.1-3.07 12.4-1.73 14.66 1 1.7 2.72 1.75 3.67 2.2l2.06.43z'/%3E %3Cpath d='M471.25 652.72c1.02-.14 2.68.35 4.09-.97 1.87-1.76 1.89-9.64 2.17-14.6 1.46-25.31 4.5-67.87 8.9-127.63a8.05 8.05 0 0 0-3.51-.3 8.05 8.05 0 0 0-3.5-.44c-6.17 59.58-9.75 102.71-13.66 127.14-.78 4.88-1.95 12.67-.43 14.78 1.15 1.59 2.87 1.46 3.85 1.8l2.09.22z'/%3E %3Cpath d='M483.2 653.23c1-.24 2.7.07 3.99-1.4 1.7-1.93 1.03-9.78.87-14.74-.78-25.36-1.5-68.04-2.4-127.98a8.02 8.02 0 0 0-3.51.08c-1-.22-2.06-.37-3.52-.08-.9 59.94-1.6 102.62-2.4 127.98-.15 4.96-.82 12.8.88 14.75 1.29 1.46 2.98 1.15 3.99 1.39h2.1z'/%3E %3Cpath d='M474.88 559.13c-.08 4.25-.13 9.02-.16 13.91l-.05.02-10.59 2.2c-.02 4.83 11.92 55.43 18.07 55.43s18.08-50.63 18.06-55.46l-10.59-2.17-.05-.02c-.03-4.9-.08-9.66-.16-13.91-2.22 1.85-4.68 5.07-7.26 7.98-2.6-2.9-5.04-6.13-7.27-7.98z'/%3E %3C/g%3E %3Cg id='c'%3E %3Cpath stroke='%2321231E' stroke-width='.99' d='M412.13 584.52c-3.2.14-7.13 1.97-18.6 11.94-5.02 10.24-10.06 20.53-17.03 29.41-2.37 1.57-4.23 2.67-6.12 3.3-1.96.64-16.43.16-16.79-.45-4.5-4.09-11.38-1.17-9.08 3.14-1.79 1.7 2.14 7.9 5.3 5.32 2.9-2.36 12.98-.13 16.34-1.35-1.27 3.03-10.38 5-16.75 5.47-5.82.25-5.44 6.06-3.04 10.52 2.73 1.74.5-.46 1.48.82 2.6 3.87 8.18 3.36 8.37-.42.2-3.92 13.79-9.01 15.83-12.02-2.5 5.95-8.24 11.5-11.1 17.31-3.06 3.09-4.93 3.7-.96 9.92 4.4-.5 4.65-1.68 7.36.89 6.01-.66 6.98-2.45 6.01-7.21-1.03-5.04 3.18-14.14 4.58-16.71 1.29-2.38 1.6-4.84 2.86-6.33 2.18-2.58 12.57-7.75 15.23-6.33 4.9 2.61 8.64 1.03 9.25-3.72-1.58-1.22-.4-7.97-3.78-8.25-2.77-.24-4.41.62-6.96 2.7-4 3.28-6.07 5.03-7.39 4.66-3.12-.86 5.67-5.18 13.66-15.68 11.08-14.55 11.84-21.95 11.33-26.93z' fill='%23EDB92E'/%3E %3Cuse xlink:href='%23b' transform='matrix(-1 0 0 1 801.63 0)'/%3E %3Cpath stroke='%2321231E' stroke-width='.99' d='M345.18 634.54c-4.01-2.35-6.32-2.26-7.87-.5-.86.95-1.95.46-1.31-1.06 2.66-6.3 6.92-7.1 10.74-4.14 1.07 1 1.93 1.85 2.79 2.7-.64.94-3.83 2.27-4.35 3zM402.64 628.89c4.26-2.9 8.25-3.47 10.44-1.84 1.2.9 2.39.25 1.33-1.23-4.42-6.22-9.6-6.54-13.5-3.03-1.06 1.15-1.9 2.13-2.75 3.1 1.34 1.47 4.3 3.12 4.48 3zM369.09 664.55c.13-.26-.98-5.44-2.71-7.06-1.35 1.08-2.86 2.04-4.29 3.52-4.26 4.46-4.24 11.01 2.42 16.73 1.64 1.41 2.39-.07 1.72-1.7-1.13-2.77.25-6.32 2.86-11.5zM352.47 650.93c-3.96 1.64-5.32 3.73-5.18 6.46.08 1.5-.9 2.07-1.46.32-4.84-11.24.18-13.35 7.43-12.94.41 1.96-.62 6.09-.8 6.16h.01z' fill='%23EDB92E'/%3E %3Cpath fill='%2321231e' d='M383.95 621.26l1.01.61c-.32.51-.34 1.18-.06 1.71a4.8 4.8 0 0 0 1.93 1.8l-.6 1.03a5.9 5.9 0 0 1-2.39-2.3 2.9 2.9 0 0 1 .11-2.85zm6.5.82l-.74.92c-.81-.65-1.6-1.34-2.5-1.85-.4-.2-.87-.43-1.31-.26-.43.2-.7.6-.94.98l-1.01-.6c.4-.66.93-1.31 1.69-1.54.7-.22 1.43 0 2.05.33.95.52 1.77 1.23 2.62 1.9l.15.12z'/%3E %3Cpath fill='%2321231e' d='M387.33 617.58l1.01.61c-.32.51-.34 1.18-.06 1.71.41.8 1.17 1.35 1.93 1.8l-.6 1.03a5.9 5.9 0 0 1-2.39-2.3 2.9 2.9 0 0 1 .11-2.85zm6.5.82l-.74.92c-.81-.65-1.6-1.34-2.5-1.85-.4-.2-.87-.43-1.31-.26-.43.2-.7.6-.94.98l-1.01-.6c.4-.66.92-1.3 1.67-1.53.7-.23 1.46 0 2.08.33.97.53 1.8 1.25 2.67 1.94l.09.07z'/%3E %3Cpath fill='%2321231e' d='M390.88 612.83l1.06.55c-.43.8-.4 1.8 0 2.61a6.08 6.08 0 0 0 2.1 2.26l-.68.98a6.8 6.8 0 0 1-2.68-3.17 4.07 4.07 0 0 1 .2-3.23zm7.14 1.1l-.82.87c-.89-.83-1.74-1.72-2.76-2.4-.38-.25-.84-.52-1.31-.4-.52.2-.81.71-1.08 1.16-.06.15-.12.28-.27.14l-.9-.47c.4-.75.89-1.52 1.68-1.89a2.3 2.3 0 0 1 1.99.14c.97.5 1.76 1.25 2.55 1.98l.92.87z'/%3E %3Cpath fill='%2321231e' d='M394.82 607.72l1.07.52c-.49 1-.43 2.22.07 3.2.49 1 1.3 1.78 2.18 2.43l-.7.97a7.46 7.46 0 0 1-2.87-3.67 4.72 4.72 0 0 1 .25-3.45zm7.55 1.27l-.85.84c-.95-.95-1.86-1.95-2.95-2.74-.4-.26-.89-.57-1.39-.42-.53.22-.84.76-1.11 1.24-.08.08-.1.33-.22.31l-1.03-.5c.4-.82.91-1.68 1.76-2.1a2.3 2.3 0 0 1 2.09.14c1.03.55 1.86 1.4 2.69 2.2l1.01 1.03z'/%3E %3Cpath fill='%2321231e' d='M399.15 602.61l1 .63a2.98 2.98 0 0 0-.37 2.48 7.24 7.24 0 0 0 2.23 3.13l.45.4-.76.9a9.51 9.51 0 0 1-2.94-3.75 4.19 4.19 0 0 1 .39-3.79zm7.53 1.43l-.87.8c-.88-.92-1.72-1.89-2.73-2.67-.42-.3-.93-.63-1.46-.46-.6.25-.99.82-1.35 1.34-.07.21-.19.19-.33.06l-.8-.5a4.84 4.84 0 0 1 1.94-1.95c.72-.34 1.57-.17 2.22.24 1.03.62 1.84 1.53 2.67 2.39l.7.75z'/%3E %3Cpath stroke='%2321231E' stroke-width='.99' d='M462.62 580.6l-9.49-5.38c-4 2.87-6.95 13.52-.12 22.22 8.5 10.84 11.94 18.7 14.02 27.48 6.2-7.93 8.32-16.27 4.39-24.4-5.3-10.98-8.75-17.17-8.8-19.92z' fill='%23FFF'/%3E %3Cpath stroke='%2321231E' stroke-width='.99' d='M470.37 573.01l-9.49-5.38c-4 2.87-12.33 13.18-5.51 21.88 8.5 10.84 17.33 19.05 19.41 27.82 6.2-7.93 8.83-16.27 4.9-24.4-5.3-10.98-9.26-17.17-9.31-19.92z' fill='%23FFF'/%3E %3Cpath stroke='%2321231E' stroke-width='.99' d='M449.43 569.16l-9.49-5.38c-4 2.87-6.95 13.52-.12 22.22 8.5 10.84 11.94 18.7 14.02 27.48 6.2-7.93 8.32-16.27 4.4-24.4-5.31-10.98-8.76-17.17-8.81-19.92z' fill='%23FFF'/%3E %3Cpath d='M405.49 468.99c.18 8.68-1.36 66.56-1.84 74.74-.48 8.14-4.1 13.7-7.94 16.88-3.52-4.85-5.63-11.4-6.13-19.16-.26-3.96.47-58.73.78-70 6.48-17.15 11.29-17.8 15.13-2.46z' fill='%23FFF'/%3E %3Cpath fill='%2321231e' d='M404.14 543.76c-1.71.36-.66-1.76-.86-2.77.8-23.27 1.45-46.54 1.72-69.82-.46-1.1.48-3.37.99-1.56-.15 21.32-.82 42.63-1.45 63.93-.12 3.4-.22 6.82-.4 10.22zm-8.84 17.14c1.2-.72-.38-.73 1.29-1.76 4.12-4.02 6.25-9.75 6.56-15.44 1.72-.36.65 1.74.7 2.74-.8 5.56-3.46 10.94-7.83 14.55l-.72-.09zm.72.1zm-6.94-19.52c1.6-.56.88 1.54 1.22 2.49.66 5.78 2.36 11.58 5.8 16.35-1.1 1.38-1.62-.98-2.29-1.71-3-5.2-4.34-11.19-4.73-17.13zm.8-70.2c1.64-.01.7 1.54.9 2.79-.37 22.16-.76 44.32-.74 66.48.16 1.88-1.66.54-1-.83.02-22.76.37-45.52.81-68.27l.04-.16zm-.03.17zm16.13-2.47c-1.6.63-1.1-1.41-1.68-2.46-.97-2.76-1.69-6.08-4.24-7.82-2.2-.75-3.66 1.74-4.73 3.25-1.89 3.03-3.23 6.36-4.52 9.69-1.8-.2.01-2.04.15-3.1 1.66-3.68 3.14-7.78 6.4-10.37 1.85-1.5 4.33-.12 5.27 1.75 1.7 2.76 2.56 5.95 3.35 9.06zm-.01-.1z'/%3E %3Cpath d='M367.87 454.83l-2.46 79.58c-.77 7.06 8.42 49.08 13.45 57.36 12.43-5.31 15.06-33.82 12.72-61.59-2.34-27.77.39-51.76 2.29-56.75.16-6.28-.9-12.84-.96-19.38-7.92.47-17.12.3-25.04.78z' fill='%23FFF'/%3E %3Cpath fill='%2321231e' d='M364.91 534.4l2.46-79.58c2-.2.46 2.96.86 4.28l-2.33 75.37-.99-.07zm1 .03zm12.74 56.89c.72 2.28-1.44-1.1-1.58-2.06-4.5-11.78-7.16-24.19-9.73-36.52-1.07-6.07-2.51-12.18-2.43-18.38 1.9-.1.5 2.75 1.12 4 1.78 14.12 5.06 28.04 8.94 41.72 1.22 3.88 2.34 7.85 4.3 11.44l-.62-.2zm.4.91zm12.02-62c1.94-.46.81 2.7 1.3 3.94.82 14.43.94 29.2-2.94 43.25-1.78 5.79-4.55 12.14-10.39 14.82-1.04-1.58 2.04-1.67 2.72-2.92 5.79-5.65 7.46-14.02 8.77-21.69 1.79-12.37 1.54-24.97.54-37.4zm2.3-56.81c2.04-.3-.2 2.5.07 3.68-2.58 15.62-2.63 31.57-1.79 47.34.12 1.9.26 3.8.41 5.7-1.93.46-.8-2.7-1.29-3.93-.99-16.22-.97-32.62 1.58-48.71.23-1.3.61-3.11 1.01-4.08zm.98.02zm-1.42-18.89c.03-2.28.78 1.04.54 1.94.23 5.65 1.02 11.29.88 16.95-1.75.4-.67-1.92-1-2.96-.14-5.48-.9-10.93-.94-16.42l.52.5zm-.05-1zm-24.52 1.3c-2.37-.3 1.6-.81 2.5-.66 7.34-.3 14.69-.2 22.02-.63.44 1.9-2.56.75-3.75 1.17-7.08.26-14.17.19-21.24.6l.47-.48zm-1-.03zm.5.01zm-.5-.01z'/%3E %3Cpath d='M353.13 467.85l1.69 79.6c-.4 7.1 10.96 48.54 16.4 56.54 12.62-9.78 10.08-49.8 8.15-61.91-3.85-24.13-3.2-52.08-1.87-56.62-.16-6.29-.32-13.8-.72-20.34l-23.65 2.73z' fill='%23FFF'/%3E %3Cpath fill='%2321231e' d='M354.32 547.47l-1.69-79.6c2-.3.62 2.96 1.09 4.27l1.6 75.35-1-.02zm1-.02zm15.6 56.16c1.16 2.08-1.5-.97-1.6-2.03-5.18-11.7-8.52-24.13-11.75-36.49-1.34-5.82-3.03-11.66-3.25-17.66 1.9-.2.65 2.72 1.33 3.95 2.52 14.03 6.52 27.76 11.12 41.24 1.42 3.78 2.73 7.65 4.87 11.1l-.72-.11zm.61.78zm7.35-62.23c1.9-.59.98 2.68 1.52 3.87 1.41 14.25 1.82 28.83-1.07 42.93-1.3 5.62-3.2 11.62-7.8 15.44-1.41-1.3 1.64-2.18 2-3.58 4.88-7.28 5.82-16.33 6.6-24.84.71-11.27.33-22.64-1.25-33.82zM377 485.48c1.95-.45.16 2.24.48 3.35-1.13 15.63-.34 31.36 1.49 46.9.26 2.1.56 4.19.89 6.28-1.9.6-1-2.65-1.57-3.83-2.1-16.23-2.93-32.68-1.84-49.02.08-1.12.35-3.11.55-3.68zm1-.03zm-1.17-19.83c-.08-2.3.85 1.06.58 1.97.3 5.95.43 11.9.59 17.86-1.76.48-.76-1.96-1.07-3-.15-5.77-.3-11.53-.65-17.29l.55.46zm-.11-.99zm-23.6 3.72c-.5-1.88 2.32-.87 3.48-1.4l20.12-2.31c.56 1.86-2.44.9-3.58 1.41l-20.01 2.3zm.07 0zm-.06-1zm-.5.52z'/%3E %3Cpath d='M342.19 486.7l20.91-.53c-1.78 8.68-.35 35.65 3.25 56.21 3.39 19.28 8.11 69.27-11.96 81.28-12.44-26.38-2.97-52.02-9.24-74.92-4.9-24.35-5.86-44.68-2.96-62.04z' fill='%23FFF'/%3E %3Cpath fill='%2321231e' d='M363.12 486.66l-20.91.53c-.3-2 2.93-.63 4.23-1.1l16.65-.42c.39.5.77.55.03.99zm-.03-1zm3.76 56.63c-1.89.65-1.04-2.6-1.63-3.76-2.29-15.57-3.8-31.33-3.21-47.08.11-1.8.26-3.61.61-5.39 1.9.06.16 2.63.49 3.9-.82 14.52.55 29.07 2.37 43.46.4 2.97.85 5.93 1.37 8.87zm-12.9 81.58c.67-.58 1.03-1.43 2.82-2.59 6.99-6.34 9.4-16.03 10.84-25.02 2.42-17.32 1.17-34.96-1.47-52.19-.8-2.82 1.52-1.46 1.12.68 2.6 17.53 3.82 35.49 1.12 53.08-1.62 9.1-4.39 18.92-11.87 24.98-.84.37-1.6 1.65-2.56 1.06zm.7.21zm-9.98-75.25c1.88-.83 1.22 2.5 1.87 3.61 3.48 18.27-.6 37.09 3.2 55.33a67.5 67.5 0 0 0 5.1 15.67c-1.66 1.1-1.7-2.35-2.53-3.38-5.9-14.45-5.48-30.33-5.24-45.65.06-8.57-.13-17.26-2.4-25.58zm0 .04zm-2.49-62.67c.52.9.38 1.83.01 3.85-2.6 19.54-.36 39.36 3.46 58.59-1.88.68-1.1-2.6-1.74-3.76-3.54-19.15-5.37-38.93-2.2-58.27l.47-.41zm-.47.41zm.49.09zm-.5-.09z'/%3E %3Cpath d='M422.15 454.38c-.08 8.68-3.37 66.48-4.1 74.64-.73 8.13-4.5 13.56-8.45 16.62-3.38-4.96-5.28-11.57-5.55-19.34-.13-3.97 2.25-58.7 2.9-69.94 7-16.94 11.82-17.44 15.2-1.98z' fill='%23FFF'/%3E %3Cpath fill='%2321231e' d='M418.54 529.07c-1.72.3-.6-1.78-.78-2.8 1.51-23.23 2.87-46.47 3.84-69.72-.42-1.13.58-3.36 1.03-1.53-.8 21.44-2.12 42.86-3.4 64.27-.22 3.26-.42 6.52-.69 9.78zm-9.35 16.85c1.22-.68-.37-.74 1.33-1.72 4.25-3.89 6.56-9.55 7.03-15.22 1.73-.3.6 1.76.63 2.76-.98 5.52-3.8 10.83-8.28 14.3l-.71-.12zm.71.11zm-6.35-19.72c1.62-.57.85 1.4 1.13 2.32.47 5.87 2 11.8 5.33 16.73-1.16 1.35-1.6-1.02-2.24-1.78-2.85-5.28-4-11.32-4.22-17.27zm2.94-70.14c1.64.04.65 1.56.81 2.82-1.05 22.06-2.1 44.13-2.75 66.21.39 1.86-1.7 1.1-.99-.44.71-22.81 1.76-45.62 2.89-68.42l.04-.17zm-.04.17zm16.2-1.95c-1.63.57-1.07-1.45-1.61-2.52-.89-2.8-1.5-6.12-4-7.95-2.17-.82-3.72 1.62-4.83 3.1-1.98 2.97-3.42 6.25-4.8 9.54-1.8-.27.07-2.04.24-3.09 1.76-3.63 3.37-7.68 6.7-10.16 1.9-1.45 4.34.02 5.22 1.91 1.6 2.81 2.38 6.03 3.08 9.17zm-.02-.11zm-.48.1zm.48-.1z'/%3E %3Cpath d='M384.99 407.23c-.56 18.65-.87 59.1-.76 62.55.27 7.77 3.33 17.67 6.71 22.63 3.94-3.06 7.72-8.5 8.45-16.62.6-6.68.8-39.48.9-55.92a70.63 70.63 0 0 1-12.07-9.72s-3.1-2.76-3.23-2.92z' fill='%23FFF'/%3E %3Cpath fill='%2321231e' d='M384.72 469.76c-1.49.52-.9-1.15-1.02-2.05.06-20.17.27-40.34.79-60.5 1.53-.42.82 1.27.93 2.2-.46 20.03-.71 40.07-.7 60.1v.25zm5.9 22.25c1.3 1.26-.56.7-.74-.33-3.54-6.28-5.45-13.41-6.08-20.56-.71-1.16 1.03-2.11.95-.65a50.6 50.6 0 0 0 5.76 20.33c.1.54 1.63 1.74.12 1.21zm.62.8zm7.64-17.06c1.53-.34.78 1.23.74 2.13-.88 5.75-3.73 11.32-8.38 14.92-1.28-.88.38-1.4.94-2.14 4.05-3.88 6.23-9.38 6.7-14.91zm1.14-55.46c.8-1.78.85.5.76 1.35-.16 17.33-.13 34.67-.76 52-.22.82.41 2.7-1.03 2.12-.15-1.14.13-2.69.11-3.99.54-17.3.55-34.6.7-51.9l.22.42zm.54-.84zm-12.35-9.8c-.17 1.94.32-.77 1.14.94a71.3 71.3 0 0 0 11.2 8.86c-.4 1.52-1.46.1-2.27-.32a69.35 69.35 0 0 1-10.43-8.63l.36-.85zm-.36.85c-1.9-.95 1.09-1.4.01-.03v.03zm-2.37-3.26c-1.67.34-.24-.8.29.05l2.75 2.47c-.52 1.95-.09-1.14-.68.73-1.08-.98-2.2-1.93-3.25-2.95l.89-.3zm-1-.03c-.65-2.06 1.4-.63.39-.12l-.38.12z'/%3E %3Cpath d='M399.93 419.25c-.37 20.09-.15 51.74-.07 54.3.27 7.78 2.18 14.4 5.55 19.35 3.95-3.06 8.1-8.68 8.84-16.8.44-5 1.83-26.46 1.96-42.92-5.3-1.67-11.99-10.37-16.28-13.93z' fill='%23FFF'/%3E %3Cpath fill='%2321231e' d='M400.36 473.54c-1.2.42-1.05-.58-1.02-1.43-.16-17.63-.19-35.25.1-52.87 1.4-.43.9.99.96 1.87-.24 17.48-.24 34.96-.04 52.43zm4.75 18.97c1.27 1.14-.43.82-.67-.2-3.47-5.6-4.84-12.23-5.07-18.74 1.33-.48.98.84 1.08 1.7.41 6.09 1.92 12.25 5.37 17.35l-.71-.11zm.6.78zm8.04-17.24c1.43-.33.85 1.03.76 1.91a24.17 24.17 0 0 1-8.8 15.33c-1.09-.75-.04-1.22.6-1.8a23.62 23.62 0 0 0 7.44-15.44zm2.31-42.4c.23-1.71.89-.15.64.77-.22 13.92-.9 27.83-1.96 41.71-1.38.32-.88-.95-.85-1.82.98-13.7 1.67-27.41 1.83-41.14l.34.48zm.3-.95zm-15.93-13.44c-1.78.28-.09-.88.47.17 4.61 4.15 8.4 9.31 13.79 12.53.57.53 2.18.41 1.44 1.48-.54.38-1.66-.56-2.34-.84-5.48-3.44-9.34-8.78-14.18-12.97l.82-.37zm-1-.02c-.62-1.72 1.61-.31.11-.05l-.1.05z'/%3E %3Cpath d='M387.08 405.55l-14.24-20.52c-2.88 10.12-6.39 82.77-2.27 88.72a36.53 36.53 0 0 0 6.45 19.32c3.94-3.06 9.82-8.56 8.13-16.78-1.7-8.23.2-62.26 1.93-70.73z' fill='%23FFF'/%3E %3Cpath fill='%2321231e' d='M373.25 384.74l14.24 20.53c-1.24 1.4-1.74-1.31-2.6-2l-12.46-17.96c-.31-.72.42-.38.82-.57zm-.89.15zm-1.29 88.84c-1.41.69-1.25-.68-1.7-1.95-1.39-8.26-1.12-16.68-1.15-25.02.27-18.27 1.03-36.56 2.97-54.73.3-2.4.58-4.8 1.17-7.14 1.78.02.25 1.97.4 3.04-1.9 13.6-2.48 27.34-3.1 41.04-.4 12.95-.91 25.95.13 38.89.23 1.99.41 4.04 1.28 5.87zm-.09-.26zm5.74 19.2c1.32 1.71-1.03.02-1.17-.97a36.76 36.76 0 0 1-5.47-17.93c1.64-.53.82 1.58 1.18 2.53.63 5.9 2.84 11.6 6.17 16.48l-.71-.11zm.6.79zm7.34-17.07c1.6-.82 1.08 1.6 1.28 2.56.16 6.03-4.03 11.08-8.61 14.5-1.37-.98.68-1.53 1.26-2.32 4.26-3.6 7.4-9 6.07-14.74zm2.42-70.34c.08-2.2.7.77.17 1.61-1.45 14.27-1.8 28.62-2.16 42.95-.05 8.38-.42 16.8.47 25.15-.64 1.7-1.37-.65-1.2-1.7-.75-12.66-.23-25.34.14-38 .45-10.04.7-20.12 2-30.1.03-.93.2-.26.58.1zm0-1zm0 0zm0 1z'/%3E %3Cpath d='M357.88 451.24c-.65 11.24-1.1 18.85-.97 22.81.27 7.78 2.18 14.39 5.55 19.35 3.95-3.06 8.96-8.48 8.45-16.62-2-31.46 1.45-61.09 5.45-89.57-3.38-2.48-9.07-5.16-12.45-7.64-6.75 38.36-9 62.16-6.03 71.67z' fill='%23FFF'/%3E %3Cpath fill='%2321231e' d='M357.41 474.03c-1.72.6-.79-1.64-1.01-2.58.14-6.76.62-13.5.98-20.24 1.82-.36.58 2 .82 3.05-.33 6.59-.87 13.18-.79 19.77zm4.75 18.97c1.33 1.73-1.06 0-1.15-1-3.12-5.43-4.37-11.73-4.6-17.93 1.67-.55.83 1.6 1.16 2.56.5 5.79 2.02 11.63 5.3 16.48l-.71-.11zm.6.79zm7.65-16.98c1.7-.6.85 1.71.96 2.68-.44 5.8-4.08 10.86-8.6 14.3-1.4-1 .71-1.55 1.26-2.37 4.1-3.68 6.84-9 6.38-14.61zm5.66-89.2c1.23-1.94.54 1.41.43 2.21-4.05 28.76-6.98 57.86-5.1 86.92-1.8.57-.79-2.07-1.17-3.12-1.55-28.94 1.57-57.87 5.64-86.49l.2.47zm.59-.81zm-12.26-7.15c-2.13-.56 1-.36 1.51.67 3.53 2.24 7.34 4.04 10.75 6.48-.67 1.7-2-.56-3.06-.83-3.3-2.03-6.82-3.74-9.98-6l.78-.32zm-.98-.17zm-5.9 71.4c1.43 1.69-1.04-.28-.62-1.5-1.59-9.29-.52-18.77.32-28.1 1.5-14 3.78-27.92 6.2-41.8 1.91-.1.26 2.28.42 3.4-2.97 17.72-6 35.5-6.71 53.48-.07 4.92-.14 9.95 1.22 14.73l-.82-.2zm.71.7zm0 0zm-.7-.7z'/%3E %3Cpath d='M343.64 471.82l3.86 14.63c.27 7.78 5.07 14.2 8.45 19.16 3.94-3.06 7.52-8.1 6.51-16.18-5.78-46.47-3.71-77.2 6.03-115.07-22.03 15.04-32.25 46.78-24.85 97.46z' fill='%23FFF'/%3E %3Cpath fill='%2321231e' d='M347.02 486.58l-3.86-14.63c1.83-.77 1.27 2.57 2 3.7.94 3.6 1.92 7.18 2.84 10.79l-.98.14zm.96-.25zm7.66 18.89c1.26 1.86-1.17-.34-1.42-1.26-3.61-5.2-7-11-7.22-17.49 1.83-.43.77 2.32 1.42 3.43 1.2 5.76 4.65 10.67 7.94 15.43l-.72-.11zm.61.78zm5.72-16.51c1.86-.58.9 2.39 1.14 3.53a17 17 0 0 1-6.86 12.98c-1.42-1.25 1.5-2 2-3.23 3.23-3.56 4.38-8.59 3.72-13.28zm6.8-114.72c-.54-2.06.49 1.56-.53 2.62-6 23.5-9.08 47.77-8.41 72.03.3 13.36 1.49 26.69 3.12 39.94-1.92.52-.9-2.71-1.47-3.93-3.31-27.64-4.08-55.8.6-83.34a318.5 318.5 0 0 1 5.93-27.86l.77.54zm-.56-.82zm-24.09 97.74c-1.88.88-.91-2.5-1.49-3.58-2.6-20.5-3.22-41.8 2.87-61.76 3.93-12.8 11.49-24.83 22.71-32.4 1.36 1.42-1.8 2-2.51 3.11-12.5 9.87-19.23 25.28-21.95 40.64-3.22 17.81-2.15 36.25.37 54zm-.96.26zm.48-.13zm-.48.13z'/%3E %3Cpath d='M344.77 486.22l-20.22-6.72c-2.58 20.22 1.38 45.62 6.83 79.12 4.67 28.76 2.21 51.52-1.36 66.12 21.57-2.96 30.7-30.77 19.88-83.1a234.62 234.62 0 0 1-5.13-55.42z' fill='%23FFF'/%3E %3Cpath fill='%2321231e' d='M324.71 479.03l20.22 6.72c-.43 2.01-3.14-.5-4.58-.48l-15.95-5.3c-.6-.66-.25-.54.31-.94zm-.65.4zm7.81 79.1c-1.96.57-1.02-2.88-1.67-4.13-3.3-21.25-7.2-42.58-6.91-64.16.08-3.61.32-7.22.77-10.8 2.02-.03.2 2.93.56 4.26-1.44 20.22 1.95 40.37 4.92 60.31.76 4.85 1.55 9.69 2.33 14.53zm-1.91 65.71c-.27 2.38-.26-2.1.36-3.03 4.3-20.54 3.9-41.86.57-62.51 1.94-.6 1.02 2.78 1.61 4 2.89 20.61 2.86 41.84-2 62.16l-.54-.62zm.13 1zm19.33-83.5c1.96-.62 1.12 2.98 1.84 4.22 3.18 17.46 5.42 35.58 1.97 53.18-1.97 9.49-6.59 19.5-15.76 23.9a25.32 25.32 0 0 1-7.38 2.2c-.54-1.95 2.82-1.01 3.97-1.92 9.15-2.75 14.81-11.59 17.18-20.39 4.2-15.36 2.87-31.57.7-47.14-.72-4.7-1.57-9.38-2.52-14.04zm-4.8-55.05c.92-2.26.57 2.35.6 3.29a234.43 234.43 0 0 0 5.17 51.56c-1.87.7-1.11-2.61-1.77-3.75a235.03 235.03 0 0 1-4.34-51.58l.17.24.17.24zm.31-.94z'/%3E %3Cpath fill='%2321231e' d='M343.56 584.05c.43 0 1.63-.12.95.49-.38.31-.98 0-.95-.49zm-4.3-40.2c1.48-.85 1.32.82 1.57 1.83 2.5 12.64 4.32 25.5 3.91 38.41-1.67.48-1.07-1.16-1.13-2.21.14-12.8-1.8-25.53-4.35-38.03zm-5.41-50.21c1.63-.55 1.12 1.08 1.2 2.13.22 16.07 2.1 32.1 5.37 47.84-1.51.86-1.32-.87-1.6-1.89a251.66 251.66 0 0 1-4.97-48.08zm1.18-.01c-.44.01-1.63.18-.97-.45.37-.33.98-.04.97.45z'/%3E %3Cpath d='M343.96 367.25l13.27 2.23c-.65 2.85-4.02 20.32-4.63 23.3-4.96 24.27-8.24 52.87-4.48 84.25 1.39 11.64 3.86 21.16 7.48 28.51-14.56-1.65-23.9-15.87-22.69-40.67-2.53-28.96-1.41-51.99 3.27-69.3 1.38-5.08 5.8-24.22 7.78-28.32z' fill='%23FFF'/%3E %3Cpath fill='%2321231e' d='M357.15 369.98l-13.27-2.23c.08-2.02 3-.06 4.36-.28l9.07 1.53c.45.58.54.6-.16.98zm.16-.98zm-4.22 23.88c-1.88.02-.22-2.32-.32-3.48 1.32-6.68 2.58-13.36 3.98-20.02 1.86 0 .2 2.28.3 3.44-1.35 6.68-2.63 13.38-3.96 20.06zm-4.48 84.1c-1.92.5-.9-2.72-1.43-3.96-2.76-26.82-.5-53.98 4.93-80.34 2 .1.02 2.84.2 4.16-5.13 26.34-6.93 53.44-3.7 80.13zm6.93 29.07c.3-.88-1.26-.69-1.6-2.95-3.5-8.26-5.23-17.14-6.32-26 1.93-.52.92 2.71 1.53 3.92 1.26 8.34 3.19 16.69 6.9 24.31l-.5.72zm.5-.72zm-23.62-40.4c2-.57.47 2.54.9 3.68-.02 10.42 1.68 21.76 8.95 29.75a21.38 21.38 0 0 0 13.38 6.7c.05 2.02-2.88.18-4.15.17-8.95-2.5-14.83-10.9-17.1-19.55-1.9-6.72-2.3-13.86-1.98-20.76zm.99-.1zm2.3-69.4c1.95.23-.12 2.78 0 4.12-4.73 21.41-4.08 43.57-2.3 65.29-1.95.45-.81-2.79-1.33-4.03-1.54-21.77-1.91-44.1 3.63-65.37zm8.33-28.66c.3 1 .05 1.58-.64 3.37-2.62 8.42-4.5 17.04-6.74 25.56-1.92-.16.05-2.59-.04-3.83 2.2-8.3 3.84-16.79 6.9-24.83.17-.1.35-.18.52-.27zm-.53.27zm.45.22zm-.45-.22z'/%3E %3Cpath d='M335.92 370.39l6.52 7.44c-1.85 1.32 1.28 7.03-.4 18.1-1.1 6.3-4.84 13.7-5.61 21.73-2.57 26.6-2.58 59.9 5.42 81.19-14.56-1.65-19.56-14.85-20.03-39.68-.4-20.52-.46-44.72 4.69-72.66 1.04-6.53 4.18-11.74 9.41-16.12z' fill='%23FFF'/%3E %3Cpath fill='%2321231e' d='M342.06 378.16l-6.52-7.44c1.27-1.5 2.23 1.64 3.35 2.31 1.22 1.6 3 3.03 3.89 4.74.05.72-.23.4-.72.39zm.75-.66zm-.29 18.52c-1.96.11-.26-2.44-.59-3.63.5-4.48-.44-8.94-.57-13.4-.23-1.34 1.62-2 1.13-.46-.44 3.16.67 6.36.54 9.56a45 45 0 0 1-.5 7.93zm0-.01zm-5.6 21.7c-1.96.13-.32-2.63-.42-3.86 1.17-6.14 3.86-11.86 5.04-18 1.85-.1.3 2.16.29 3.24-1.71 6.19-4.3 12.18-4.9 18.62zm4.87 81.63c.23-.9-1.1-.66-1.3-2.86-5.26-16.46-6.12-33.93-6.07-51.1.1-9.26.63-18.53 1.51-27.76 1.95-.13.36 2.65.65 3.91-1.65 20.8-2.02 41.9 1.75 62.5a91.4 91.4 0 0 0 3.98 14.64l-.52.67zm.52-.67zm-21-39.49c1.93-.35.67 2.63 1.12 3.85.51 9.18 1.17 18.87 5.94 26.98 2.8 4.8 8.03 7.87 13.53 8.35.14 1.89-2.4.37-3.55.33-6.86-1.62-11.6-7.7-13.62-14.18-2.71-8.14-3.18-16.82-3.41-25.33zm4.7-72.75c1.97-.12.22 2.39.39 3.55-4 22.82-4.64 46.07-4.09 69.18-1.91.37-.65-2.56-1.06-3.76-.46-23.06.52-46.3 4.77-68.97zm.99.16zm9.3-16.53c-.66.8-.26 1.18-1.9 2.37a24.78 24.78 0 0 0-7.4 14.16c-1.83.12-.36-2.1-.33-3.18 1.42-5.29 4.73-9.94 8.93-13.4l.7.05zm-.7-.05z'/%3E %3Cpath d='M372.29 389.97l-13.44-1.57c-2.46 12.7-4.35 21.69-4.81 26.21-.9 8.88 1.8 17.02 4.87 23.08 4.95-2.99 7.25-9.51 9.34-18.66 2.09-9.19 2.6-19.2 4.04-29.06z' fill='%23FFF'/%3E %3Cpath fill='%2321231e' d='M358.91 387.91l13.44 1.57c.09.86-.26 1.18-1.09.87l-12.46-1.45c-.45-.54-.55-.61.11-.99zm-.55.4zm-3.83 26.36c-.79.07-1.2-.17-.89-.98 1.02-7.23 2.61-14.37 3.97-21.54l.75-3.84c.87-.02 1.16.34.8 1.15-1.5 7.88-3.23 15.71-4.44 23.64l-.19 1.57zm4.12 22.6c.66.67.4 1.16-.28.45-3.59-7.1-5.64-15.17-4.83-23.15.83-.1 1.2.2.91 1.02-.56 7.58 1.48 15.16 4.9 21.88l-.7-.2zm.51.85zm8.6-19.2c.78.04 1.19.3.77 1.08-1.24 5.07-2.52 10.34-5.62 14.65a13.24 13.24 0 0 1-3.75 3.47c-.58-.62-.52-1.07.28-1.38 3.6-2.68 5.29-7.06 6.6-11.2.67-2.18 1.21-4.4 1.72-6.62zm4.53-28.45c-.23-.95.28-1.18.46-.21-1.4 9.62-1.88 19.38-4.02 28.88-.78-.03-1.19-.3-.78-1.08 1.98-9.28 2.47-18.79 3.85-28.16l.49.57zm0-1c.97-.25.45 1.11 0 0zm0 0c.04.62-.07 1.49-.02.35l.02-.35zm0 1z'/%3E %3Cpath d='M407.15 418.58l-11.92.12c-.41 10.97-.7 18.38-.51 22.25.38 7.57 2.27 13.99 5.5 18.8 3.63-3.03 7.05-8.36 7.6-16.28.54-7.96-.6-16.43-.67-24.89z' fill='%23FFF'/%3E %3Cpath fill='%2321231e' d='M395.23 418.2l11.92-.12c.02.54.19 1.25-.61 1l-11.3.12c-.54-.5-.61-.52-.01-1zm-.5.48c-.17-.77.94-.5.05-.04l-.04.04zm.5 22.23c-.5.01-1.24.27-1.02-.5-.14-6.28.22-12.56.42-18.83l.1-2.9c.56.01 1.27-.13.98.66-.22 6.9-.62 13.78-.52 20.68l.03.9zm4.68 18.44c.36.42.98 1 .02.68-.44-.31-.66-.96-.99-1.41-3.1-5.34-4.4-11.54-4.71-17.66.55-.03 1.24-.23 1.03.58.4 6.26 1.86 12.64 5.38 17.92l-.73-.1zm.64.77c-.3.8-1.14-.39-.29-.04l.29.04zm6.78-16.7c.54.04 1.26-.08.94.7-.5 6.02-3.01 12.07-7.72 16-.35-.42-.93-.85-.17-1.17 4.38-3.91 6.58-9.76 6.95-15.52zm-.17-24.35c0-.55-.13-1.38.44-.56.14 1.09.06 2.27.13 3.4.26 7.19 1.06 14.38.59 21.58-.55-.03-1.27.1-.96-.69.44-8.08-.64-16.14-.7-24.22l.5.5zm0-1c.78-.23.54.95.05.06l-.05-.06z'/%3E %3Cpath d='M419.99 424.24l-11.91.54c-.03 10.97-.07 18.4.26 22.25.65 7.55 2.76 13.9 6.16 18.59 3.51-3.15 6.75-8.6 7.02-16.53.26-7.97-1.16-16.4-1.53-24.85z' fill='%23FFF'/%3E %3Cpath fill='%2321231e' d='M408.06 424.28l11.91-.54c.04.55.23 1.25-.58 1.02l-11.29.51c-.52-.39-.59-.57-.04-.99zm-.48.5c-.2-.77.92-.53.04-.05l-.04.05zm1.26 22.2c-.5.03-1.22.3-1.03-.47-.36-6.42-.21-12.86-.23-19.28v-2.45c.55-.01 1.26-.18 1 .63.02 6.83-.13 13.67.18 20.5l.08 1.07zm5.33 18.26c.38.42 1.01.96.04.68-.45-.3-.7-.95-1.05-1.4-3.28-5.22-4.78-11.36-5.3-17.45.54-.06 1.23-.28 1.04.54.61 6.24 2.3 12.56 6 17.71l-.73-.08zm.66.75c-.27.8-1.16-.35-.28-.04l.28.04zm6.2-16.92c.55 0 1.26-.13.96.66-.28 6.04-2.59 12.17-7.16 16.26-.36-.4-.96-.81-.2-1.17 4.23-4.06 6.23-9.98 6.4-15.75zm-1.04-25.33c0 .56-.12 1.38.44.54.16.2.07 1.06.14 1.51.44 7.77 1.69 15.51 1.45 23.31-.55 0-1.26.13-.98-.66.16-8.1-1.2-16.11-1.54-24.18l.5-.52zm-.5.52c-.27-.8.96-.58.07-.07l-.06.07zm.5.47c0-.32 0-1.52.01-.54-.01.16.05.42 0 .54z'/%3E %3Cpath d='M395 412.42l-11.9-.84c-1.29 10.89-2.18 18.26-2.3 22.12-.24 7.58 1.13 14.14 3.96 19.18 3.86-2.71 7.7-7.75 8.89-15.6 1.18-7.89.74-16.42 1.35-24.86z' fill='%23FFF'/%3E %3Cpath fill='%2321231e' d='M383.14 411.08l11.9.84c-.03.56.08 1.27-.7.95l-11.27-.8c-.48-.45-.53-.64.07-.99zm-.53.44c-.11-.8.97-.42.04-.04l-.04.04zm-1.32 22.2c-.58.02-1.22.08-.96-.68.4-6.45 1.29-12.85 2.01-19.27l.27-2.25c.64.01 1.23.06.9.83-.77 6.8-1.7 13.57-2.17 20.38l-.05.99zm3.19 18.76c.33.45.9 1.07-.05.67-.4-.36-.58-1.02-.87-1.5-2.66-5.58-3.44-11.85-3.26-17.96.61-.03 1.23-.07.98.73-.1 6.25.84 12.7 3.92 18.22l-.72-.16zm.57.81c-.37.78-1.11-.48-.28-.06l.28.06zm8.1-16.08c.64.03 1.24.1.87.86-1 5.93-3.99 11.7-8.97 15.22-.32-.44-.87-.91-.08-1.18 4.68-3.54 7.35-9.19 8.18-14.9zm1.81-24.3c.04-.55-.02-1.38.49-.5.02 1.3-.15 2.66-.17 4-.3 6.98-.12 14-1.14 20.95-.64-.04-1.23-.1-.88-.87 1.07-7.99.65-16.08 1.24-24.1l.46.53zm.08-.99c.8-.16.45 1 .04.06l-.04-.06z'/%3E %3Cpath d='M383.86 399.58l-13.05-5.42c-2.22 8.82-5.23 37.87.12 50.13 4.34-2.95 8.72-8.49 10.18-17.22 1.47-8.77 1.91-18.1 2.75-27.49z' fill='%23FFF'/%3E %3Cpath fill='%2321231e' d='M371 393.7l13.05 5.42c-.15.86-.57 1.06-1.29.54l-12.14-5.04c-.43-.58-.21-.68.38-.92zm-.67.34c0-1 1.18-.17 0 0zm.31 49.84c.62.62.57 1.1-.21.51-2.17-5.34-2.64-11.17-2.91-16.87-.3-9.57.36-19.16 1.84-28.6.27-1.64.57-3.27.97-4.88.8.04 1.17.34.75 1.11-1.57 7.61-2.25 15.38-2.57 23.13-.2 7.36-.12 14.83 1.6 22.03.34 1.29.75 2.56 1.27 3.78l-.74-.21zm.56.82c-.68.79-1-.69 0 0zm9.42-17.72c.84-.03 1.17.3.81 1.1-1.23 6.52-4.66 12.84-10.23 16.62-.6-.57-.6-1.03.19-1.35 5.18-3.9 8.2-10.07 9.23-16.37zm3.05-26.94c.12-.87.7-1.1.65-.1-.81 9.08-1.23 18.2-2.72 27.2-.84.05-1.17-.27-.83-1.08 1.38-8.79 1.8-17.68 2.6-26.53l.3.5zm.38-.92zm-.2.46zm.2-.46z'/%3E %3Cpath id='b' d='M387.75 701.16c7.96 6.38 15.25-8.22 8.19-27.51-5.23-14.28-30.77-8.74-16.54 10.47.67.9 1.62.49 1.49-.55-.81-3.94 1.7-6.23 5.57-5.5 10.58 1.98 10.91 22.07-.6 17.5-2.09-.14-.21 3.9 1.89 5.59z' stroke='%2321231E' stroke-width='.99' fill='%23EDB92E'/%3E %3Cpath stroke='%2321231E' stroke-width='.99' d='M400.05 639.16v.13c-1.04 3.35-4.91 7.54-7.92 10.68-4.67 4.87-3.57 12.24-.34 16.16 3.53 4.28 5.1 9.1 5.8 12.84.53 2.3 1.48 7.47.8 15.5-.35 3.96-2.74 6-4.98 7.77-1.14.9.49 3.05 4.25 5.88.4.3 1.54 1.08 2.08 3.04.2.47 1.95.47 2.16 0 .54-1.96 1.67-2.73 2.09-3.04 3.76-2.83 5.38-4.98 4.24-5.88-2.24-1.77-4.63-3.81-4.97-7.77-.69-8.03.26-13.2.79-15.5.7-3.75 2.28-8.56 5.8-12.84 3.23-3.92 4.33-11.3-.33-16.16-3.01-3.14-6.88-7.33-7.92-10.68v-.13c-.06-.65-.42-.98-.78-.98-.36 0-.72.33-.77.98z' fill='%23EDB92E'/%3E %3Cpath d='M395.06 685.47h11.51c1.98 0 3.6 1.6 3.6 3.54a3.58 3.58 0 0 1-3.6 3.54h-11.51c-1.98 0-3.6-1.6-3.6-3.54a3.58 3.58 0 0 1 3.6-3.54z' fill='%23EDB92E'/%3E %3Cpath fill='%2321231e' d='M406.57 685.97h-11.51v-1h11.51v1zm4.1 3.04h-1a3.09 3.09 0 0 0-2.75-3.02c-.36.07-.4-.14-.35-.45.05-.2-.15-.67.21-.56a4.1 4.1 0 0 1 3.89 4.03zm-1 0h1-1zm-3.1 4.04v-1a3.1 3.1 0 0 0 3.1-2.77c-.1-.38.27-.25.52-.27.25 0 .6-.09.47.3a4.09 4.09 0 0 1-4.09 3.74zm-11.51-1h11.51v1h-11.51v-1zm-4.1-3.04h1a3.09 3.09 0 0 0 2.75 3.02c.36-.07.4.14.35.45-.05.2.15.67-.21.56a4.1 4.1 0 0 1-3.89-4.03zm1 0h-1 1zm3.1-4.04v1a3.1 3.1 0 0 0-3.1 2.77c.1.38-.27.25-.52.27-.25 0-.6.09-.47-.3a4.09 4.09 0 0 1 4.09-3.74z'/%3E %3Cpath d='M417.13 579.19l.38-10.91c-4.38-2.23-15.17.06-19.73 10.13-5.68 12.56-11.06 19.25-17.87 25.14 9.88 1.85 18.25-.1 23.64-7.35 7.28-9.78 11.17-15.7 13.58-17.01z' fill='%23FFF'/%3E %3Cpath fill='%2321231e' d='M418.01 568.3l-.38 10.91c-.86.17-1.2-.16-.96-1.01l.35-9.94c.48-.22.74-.73.99.04zm-.27-.46zm-19.5 10.78c-.86-.17-1.04-.6-.48-1.29 3-6.02 9.4-10.38 16.2-10.32a9 9 0 0 1 3.78.83c-.22.76-.57 1.05-1.27.55-3.67-1.01-7.61.09-10.84 1.93a18.27 18.27 0 0 0-7.4 8.3zM380 603.07c-.1.91-.23 1.16-.42.11A60.46 60.46 0 0 0 393.44 586a105.5 105.5 0 0 0 3.89-7.79c.85.18 1.04.6.5 1.3-3.7 8.07-8.38 15.82-14.87 21.94-.88.86-1.8 1.68-2.73 2.49l-.23-.87zm-.18.98c-.97-.04-1.16-.3-.28-.83.14.07.18.6.28.83zm23.33-8.14c.79.35.9.8.2 1.35a19.95 19.95 0 0 1-13.4 7.24c-3.37.42-6.8.16-10.13-.45-.02-.82.29-1.18 1.1-.82 5.73.96 12 .66 17.06-2.5a19.04 19.04 0 0 0 5.17-4.82zm13.49-16.73c.76-.14 1.32.16.44.63-2.3 1.8-3.91 4.3-5.7 6.57-2.48 3.37-4.93 6.76-7.43 10.12-.8-.35-.89-.81-.21-1.38 3.52-4.66 6.78-9.54 10.55-14.02.78-.87 1.58-1.75 2.6-2.34l-.25.42zm.99.03z'/%3E %3Cpath d='M425.16 580.63l-11.79-4.97c-4.83 9.86-8.12 16.52-9.5 20.13-2.68 7.1-3.41 13.77-2.17 19.54 4.79-1.22 10.31-4.64 14.05-11.66 3.75-7.04 6.06-15.27 9.41-23.04z' fill='%23FFF'/%3E %3Cpath fill='%2321231e' d='M413.56 575.2l11.79 4.97c-.18.65-.42 1.16-1.1.61l-11.07-4.66c-.3-.6-.31-.78.38-.92zm-.64.24zm-8.58 20.52c-.65-.16-1.19-.38-.65-1.06 2.6-6.18 5.68-12.14 8.6-18.17.31-.33.36-1.45.9-1.16.85.13.48.69.18 1.22-2.95 6.1-6.07 12.12-8.7 18.36l-.33.81zm-2.77 18.88c.2.63.4 1.26-.36.58-1.41-6.63-.17-13.55 2.2-19.81.6.17 1.2.33.69 1-2.14 5.91-3.24 12.4-1.92 18.6l-.6-.37zm.25.96c-.76.43-.73-.83-.04-.02l.04.02zm13.49-12.36c.61.24 1.13.51.51 1.12-2.97 5.36-7.99 9.73-14 11.24-.23-.61-.38-1.17.47-1.16 5.7-1.67 10.3-6.01 13.02-11.2zm9.65-22.36c.22-.62.45-1.25.65-.26-3.3 7.63-5.53 15.71-9.42 23.08-.6-.24-1.14-.5-.54-1.12 3.66-7.18 5.86-14.98 9.05-22.35l.26.65zm.39-.92c.85.13.09 1.1.01.04l-.01-.04z'/%3E %3Cpath d='M428.55 580.62l-12.64-1.93c-2.29 10.73-3.86 18-4.3 21.84-.88 7.53.03 14.18 2.65 19.48 4.34-2.36 8.87-7.02 10.78-14.74 1.92-7.75 2.16-16.3 3.51-24.65z' fill='%23FFF'/%3E %3Cpath fill='%2321231e' d='M415.98 578.2l12.64 1.93c-.03.65-.1 1.24-.88.87-3.97-.6-7.94-1.2-11.91-1.82-.42-.56-.54-.6.15-.98zm-.56.39c-.03-.8 1-.32.03-.02l-.03.02zm-3.32 22c-.6-.03-1.23-.02-.9-.77.96-6.42 2.45-12.76 3.77-19.12l.45-2.11c.65.07 1.22.18.82.93-1.38 6.66-2.94 13.29-4 20l-.14 1.07zm1.92 18.98c.35.57.68 1.12-.21.66-2.99-6.09-3.47-13.1-2.7-19.76.62.03 1.24.04.91.82-.63 6.24-.12 12.8 2.68 18.5l-.68-.22zm.47.88c-.61.6-.93-.62-.06-.02l.06.02zm10.07-15.3c.64.1 1.21.23.77.96-1.57 5.93-5.38 11.4-10.84 14.34-.36-.54-.65-1.04.16-1.24 5.13-3.02 8.54-8.35 9.9-14.06zm3.99-25.02c-.1.78.05 1.09.47.66-1.33 8.18-1.53 16.53-3.5 24.6-.64-.09-1.21-.22-.79-.96 1.8-7.85 2.03-15.95 3.33-23.89l.49-.41zm-.5.41zm.5.58c-.05-.4.06-1.53.04-.53l-.04.53z'/%3E %3Cpath d='M430.43 563.41l7.54-.06c4.4 2.18 9.02 12.22 3.68 21.9-6.65 12.07-8.8 20.39-9.44 29.38-7.38-6.83-10.81-14.72-8.24-23.38 3.48-11.69 6.85-25.12 6.46-27.84z' fill='%23FFF'/%3E %3Cpath fill='%2321231e' d='M437.97 563.85l-7.54.06c-.26-.96.27-1.14 1.14-1 2.2.01 4.42-.11 6.62 0l-.22.94zm0-1zm4.11 22.65c-.94-.24-.88-.78-.36-1.47 2.85-5.79 2.42-13.27-1.7-18.35a7.72 7.72 0 0 0-2.27-1.88c.2-.9.7-.97 1.33-.35 3.3 2.54 4.93 6.73 5.37 10.78a19.3 19.3 0 0 1-2.37 11.27zm-10.2 29.5c1.01-.98.24-.35-.15-.62a62 62 0 0 1 5.86-22.21c1.11-2.43 2.33-4.81 3.62-7.15.97.24.87.8.33 1.48-4.23 7.75-7.58 16.13-8.53 24.96a70.2 70.2 0 0 0-.3 3.21l-.84.33zm.83-.33c.08 1.04-.19 1.16-.83.34.26-.12.55-.22.83-.34zm-9.22-23.56c.94.05 1.04.53.68 1.3-1.32 5.07-.2 10.57 2.58 14.96a33.2 33.2 0 0 0 5.8 6.9c-.45.83-.94.72-1.45 0-4.41-4.25-8.05-9.81-8.43-16.09-.17-2.38.15-4.78.82-7.07zm6.93-28.2c-.12 1 .12.92.5.55.06 2.85-.72 5.63-1.28 8.4a319.4 319.4 0 0 1-5.2 19.54c-1-.03-1.01-.6-.62-1.38 2.2-7.66 4.38-15.33 5.82-23.17.16-1.11.38-2.24.3-3.36l.48-.57zm-.49.58zm.5-.07zm-.5.07z'/%3E %3Cpath d='M433.79 558.16l-12.05-4.28c-4.27 10.11-7.17 16.95-8.33 20.64-2.28 7.23-2.63 13.94-1.06 19.63 4.71-1.5 10.68-4.58 14-11.8 3.35-7.25 4.54-16.24 7.44-24.19z' fill='%23FFF'/%3E %3Cpath fill='%2321231e' d='M421.9 553.41l12.05 4.28c-.14.66-.35 1.19-1.05.68l-11.33-4.02c-.34-.57-.35-.76.33-.94zm-.62.27zm-7.4 20.99c-.65-.13-1.2-.31-.7-1.02 2.23-6.32 4.97-12.44 7.54-18.63.3-.36.28-1.47.82-1.22.87.08.53.66.26 1.21-2.6 6.26-5.36 12.45-7.64 18.82l-.28.84zm-1.68 19c.24.63.47 1.24-.33.61-1.79-6.54-.94-13.52 1.07-19.91.6.14 1.22.26.74.97-1.8 6.01-2.52 12.55-.85 18.67l-.63-.34zm.3.95c-.73.47-.78-.79-.04-.02l.04.02zm13.4-12.48c.64.21 1.16.46.58 1.1a21.82 21.82 0 0 1-11.26 10.38c-.89.38-1.8.7-2.72 1-.27-.6-.44-1.15.41-1.18 4.93-1.63 9.42-4.87 12.02-9.42.35-.6.68-1.24.98-1.88zm7.72-23.51c.19-.63.37-1.28.63-.3-2.9 7.95-3.94 16.49-7.44 24.23-.62-.2-1.16-.44-.6-1.1 3.23-7.54 4.3-15.78 7.11-23.47l.3.64zm.33-.94c.85.07.16 1.08.02.03l-.02-.03zm-.16.47zm.16-.47c.85.07.16 1.08.02.03l-.02-.03z'/%3E %3Cpath d='M425.6 549.74l-2.64-16.4c-2.77-.76-6.45 5.72-10.05 9.5-.83.88-1.79 1.7-2.51 2.77a23.32 23.32 0 0 0-3.42 7.96c-3.01 13.45-7.4 20.45-12.87 27.61 10.04-.2 17.84-3.83 21.65-12.02 5.14-11.06 7.74-17.65 9.84-19.42z' fill='%23FFF'/%3E %3Cpath fill='%2321231e' d='M423.44 533.25l2.64 16.4c-.94.44-1.16-.13-1.16-1l-2.46-15.24c.45-.31.57-.9.98-.16zm-.36-.4zm-9.82 10.33c-.76-.44-.78-.9-.07-1.39 2.45-2.7 4.35-5.95 7.24-8.23.76-.54 1.7-.96 2.65-.71 0 .95-.52.95-1.29 1.07-2.19 1.16-3.57 3.35-5.13 5.2-1.1 1.38-2.18 2.78-3.4 4.06zm-2.46 2.7c-.5-.28-1.08-.58-.44-1.07.65-.83 1.45-1.55 2.18-2.31.9.48.62 1-.09 1.5-.6.59-1.18 1.2-1.65 1.88zm-3.34 7.8c-.9 0-1.11-.43-.73-1.2a23.78 23.78 0 0 1 3.25-7.15c.73.3.95.7.35 1.28a22.88 22.88 0 0 0-2.87 7.06zm-13.37 27c.3 1.22-.41.87-.24 0 4.24-5.43 7.81-11.44 10.04-17.99a82.13 82.13 0 0 0 2.6-9.24c1.04-.05 1.03.56.7 1.37-1.8 7.87-4.8 15.53-9.44 22.18a99.22 99.22 0 0 1-3.25 4.48l-.4-.8zm.02 1c-1.14.35-1-.46-.35-.7l.35.7zm21.2-12.74c.96.18.94.71.4 1.4-2.48 4.9-7.17 8.47-12.41 9.98a34.1 34.1 0 0 1-9.19 1.35c-.29-.98.28-1.14 1.14-1.03 5.96-.26 12.21-2 16.45-6.41a19.2 19.2 0 0 0 3.6-5.29zm9.8-19.13c.86-.36 1.25.05.45.65-2.03 2.56-3.21 5.66-4.63 8.58-1.58 3.44-3.13 6.9-4.73 10.32-.97-.17-.92-.72-.42-1.44 2.5-5.3 4.7-10.75 7.5-15.9.57-.96 1.16-1.93 2-2.67l-.18.46zm.98-.16z'/%3E %3C/g%3E %3Cuse xlink:href='%23c' transform='matrix(-1 0 0 1 964.3 0)'/%3E %3Cpath stroke='%2321231E' d='M536.38 414.88c1.59-.33 3.2-.79 4.86-1.37-7.63-4.79-13.96-10.57-21.49-22.12-7.7-11.83 3.38-32.95 7.93-44.16 9.5-7.04 18.45-17.37 21.29-31 1.12-7.34-19.1-4.7-33 1.88-17 8.03-19.31 5.8-25.37 7.16-2.15 10.42 2.36 11.3 6.7 10.8-9.37 15.02-13.28 29.98-15.15 51.49-1.87-21.51-5.78-36.47-15.14-51.5 4.34.51 8.85-.37 6.7-10.79-6.07-1.36-8.38.87-25.38-7.16-13.9-6.57-34.12-9.22-33-1.89 2.85 13.63 11.8 23.97 21.3 31.01 4.54 11.2 15.63 32.33 7.92 44.16-7.52 11.55-13.85 17.34-21.48 22.12 1.65.58 3.27 1.04 4.85 1.37-1.15 1.58-11.04 4.66-12.2 3.84-7.58-5.36-14.96-17.95-21.4-25.26-18.25-20.72-27.35-36.7-24.13-49.6 4.58-13.89 20.93-29.48-.72-26.78-21.66 2.7-39.6 32.42-45.37 68.2-2.14 13.27-3.38 24.38-4.83 33.47 11.82-4.22 17.06-8.43 20.2-13.62a119.35 119.35 0 0 0-3.18 14.09c9.67-1.72 16.68-6.47 19.2-15.14a45.4 45.4 0 0 1 3.56-8.85c2.97 1.05 6.82 1 11.5-.16 1.79 4.25 15.1 19.1 22.26 30.01 8.09 12.33 20.23 21.75 24.24 22.26 2 .26 2.61-4.2 2.17-10.32 21.12.15 42.23.27 62.93-.43 20.7.7 41.82.58 62.94.43-.45 6.13.17 10.58 2.17 10.32 4-.51 16.15-9.93 24.23-22.26 7.16-10.9 20.48-25.76 22.26-30 4.68 1.14 8.54 1.2 11.5.15a45.4 45.4 0 0 1 3.57 8.85c2.51 8.67 9.53 13.42 19.2 15.14-.71-4.47-1.77-9.16-3.19-14.09 3.15 5.19 8.38 9.4 20.2 13.62-1.45-9.1-2.69-20.2-4.82-33.48-5.77-35.77-23.72-65.5-45.37-68.2-21.65-2.68-5.3 12.9-.72 26.79 3.21 12.9-5.89 28.88-24.13 49.6-6.44 7.3-13.82 19.9-21.4 25.26-1.16.82-11.05-2.26-12.2-3.84z' fill='%23FFF'/%3E %3Cg id='d'%3E %3Cpath d='M440.58 356.77c-2.04 1.78-8.76 1.8-17.96 2.4-14.81.52-23.4-3.96-25.3-13.45 5.56 6.63 12.2 9.9 19.73 8.04 10.16-2.52 15.98-4.32 18.3-3.87 1.56.55 3.84 3.38 5.23 6.88z' fill='%23EDB92E'/%3E %3Cpath fill='%2321231e' d='M422.64 359.67c-.03-.58-.23-1.25.6-1.04 4.68-.33 9.4-.35 14.03-1.12 1.04-.22 2.13-.44 2.98-1.1.38.4.94.85.15 1.1-2.18 1.15-4.72 1.24-7.12 1.5-3.54.29-7.1.43-10.64.66zm.01 0zm-24.95-14.26c-.56.45-1.01.83-.09.31.46-.14.3.95.54 1.3 1 3.74 3.68 6.92 7.1 8.69 4.9 2.56 10.56 3.04 16 3 .44.13 1.48-.38 1.37.34.3.84-.54.6-1.1.65-5.68.07-11.59-.43-16.7-3.1a15.03 15.03 0 0 1-7.5-8.87c-.2-.62-.35-1.26-.48-1.9l.86-.42zm19.23 7.88c.22.6.37 1.18-.49 1.13-4.38.96-9.07 0-12.84-2.42a28.56 28.56 0 0 1-6.66-5.95c.45-.48.9-.86 1.25-.08 3.28 3.78 7.6 7.03 12.7 7.69 2.01.27 4.07.11 6.04-.37zm18.58-3.87c-.28.5-.1 1.19-.77.9-2.7.05-5.31.88-7.93 1.48-3.22.81-6.42 1.66-9.64 2.45-.23-.61-.38-1.18.48-1.14 4.86-1.17 9.66-2.6 14.57-3.54 1.08-.17 2.2-.36 3.29-.15zm-.07-.02zm5.47 7.75c-.4-.61-.77-.8-.83-.28-.99-2.32-2.27-4.66-4.32-6.2-.73-.17-.52-.64-.27-1.19.43 0 .96.46 1.35.76 1.93 1.7 3.23 4 4.2 6.35l-.13.56zm.13-.56zM419.53 321.15l.09 1.58c-.68.07-1.11-.84-.63-1.32a.79.79 0 0 1 .54-.26zm15.27 3.91l-.54 1.49c-3.55-1.26-7.04-2.76-10.75-3.51a15.86 15.86 0 0 0-3.9-.31l-.08-1.58c3.81-.2 7.48 1.1 11.02 2.35l4.25 1.56zm8.86 2.6l.24 1.56c-1.4.12-2.77-.36-4.1-.73-1.87-.57-3.7-1.26-5.53-1.94l.53-1.49c2.59.94 5.16 2 7.86 2.53.33.05.68.1 1 .06zm.24 1.55l-.24-1.56c.67-.13 1.19.73.76 1.25a.78.78 0 0 1-.52.31zM467.17 336.71l.2-1.17c.39.05.62.54.41.88a.6.6 0 0 1-.61.29zm-9.86-2.07l.32-1.14c3.2.9 6.46 1.5 9.73 2.04l-.2 1.17a91.54 91.54 0 0 1-9.85-2.07zm.32-1.14l-.32 1.14c-.4-.1-.57-.63-.3-.94a.6.6 0 0 1 .62-.2z'/%3E %3Cpath fill='%2321231e' d='M431.54 331.89l-.77 1.38c-2.69-1.52-4.6-4.05-6.16-6.66-.77-1.3-1.47-2.64-2.19-3.97l1.38-.75c1.61 2.95 3.14 6.06 5.6 8.41.65.61 1.37 1.16 2.14 1.59zm7.6-5.16l1.4.74c-1.17 2.13-2.61 4.23-4.7 5.54a4.94 4.94 0 0 1-4.44.55c-.17-.11-.63-.17-.59-.37l.73-1.3c.96.58 2.18.5 3.14-.04 1.68-.9 2.87-2.48 3.86-4.06.21-.35.42-.71.6-1.06z'/%3E %3Cpath d='M429.59 330.91l-2.19-2.2c-1.07-1.34-.45-3.14 1.85-5.4 1.69.74 3.04 1.3 4.38 1.86-.9 3.04-2.24 4.95-4.04 5.74z' fill='%2321231E'/%3E %3Cpath fill='%2321231e' d='M423.26 412.95c-.15.36-.24.82-.42 1.1-.57-.19-.42-1.13.19-1.13.08 0 .15 0 .23.03zm23.87-3.53l.83.85a19.68 19.68 0 0 1-10.57 5.49c-4.88.84-9.9-.07-14.52-1.69l.4-1.12c4.67 1.64 9.79 2.54 14.7 1.49a18.48 18.48 0 0 0 9.16-5.02zm2.9-2.87l.83.84-2.9 2.88-.83-.85 2.9-2.87zm.83.84c-.26-.28-.64-.57-.82-.86.4-.4 1.16.07.96.61a.6.6 0 0 1-.14.25z'/%3E %3Cpath fill='%2321231e' d='M452.17 401.28l-1.17-.16c.04-.54.83-.7 1.09-.23.07.12.1.26.08.39zm-5.5 15.93l.29 1.14-.69-.81a58.6 58.6 0 0 0 4.73-16.42l1.17.16a59.5 59.5 0 0 1-4.37 15.7c-.14.35-.3.7-.45 1.04l-.69-.81zm-.4.33l1.08.48c-.19.52-1.03.43-1.11-.11a.6.6 0 0 1 .03-.37zm15.25-9.54l.97.68c-2.54 3.66-6.34 6.28-10.42 7.97-1.66.7-3.37 1.25-5.11 1.7l-.3-1.14c4.52-1.18 8.97-3.11 12.4-6.35a18.6 18.6 0 0 0 2.46-2.86zm.97.68l-.97-.68c.28-.45 1.06-.24 1.07.3a.6.6 0 0 1-.1.38z'/%3E %3Cpath fill='%2321231e' d='M461.29 400.2l-1.18.1c-.07-.5.62-.85.99-.48.1.1.17.24.19.38zm4.43 15.72l.72.94c-.28-.06-.62-.05-.87-.17-3.16-4.55-4.76-10.02-5.37-15.49l-.09-.9 1.18-.1c.49 5.31 1.9 10.65 4.82 15.17l.46.68c-.28-.05-.57-.1-.85-.13zm-.12.81l.97-.68c.32.42-.14 1.08-.65.91a.6.6 0 0 1-.32-.23zm7.67-12.6l1.14.28a22.28 22.28 0 0 1-7.87 12.38c-.22.15-.35-.37-.54-.5-.22-.23-.37-.44 0-.6a21.13 21.13 0 0 0 7.27-11.57zm1.14.28l-1.14-.29c.1-.5.87-.6 1.1-.13a.6.6 0 0 1 .04.42z'/%3E %3Cpath d='M405.91 317.77c-16.62 1.8-15.83 12.67-.29 28.04 2.97 2.94 4 2.85 4.63-.2 1.1-5.35 7.02-8.5 10.12-4.44 2.11 2.77 1.64 4.36 8.68 3.38 8.89 7.46 16.12 12.7 4.5 12.26-5.12-.19-9.07 2.8-15.73 2.54 1.97 3.82 2.32 4.27 3.39 4.6 6.46 1.27 13.27-2.77 19.79-1.57 14.28 2.64-22.89-38.63-22.43-40.26 1.18-4.15-8.93-11.6-12.66-4.35z' fill='%23EDB92E'/%3E %3Cpath fill='%2321231e' d='M405.97 345.46c-.64 1.24-1.28.09-1.92-.52-4.06-4.28-8.13-8.88-10.15-14.52-1.12-3.03-1-6.84 1.47-9.18 2.77-2.71 6.77-3.5 10.49-3.96.53 1.22-.65 1.08-1.53 1.2-3.4.58-7.26 1.6-9.22 4.7-1.82 3.1-.55 6.9 1 9.84 2.5 4.7 6.13 8.69 9.86 12.44zm3.8.04c1.23-.12.92.82.56 1.63a1.73 1.73 0 0 1-2.69.99c-.89-.52-1.63-1.24-2.37-1.95.56-1.05 1.1-.38 1.7.23.59.4 1.32 1.31 2.08.94.45-.5.56-1.21.71-1.84zm11-4.63c-.76 1.08-1.2 0-1.95-.47-3.6-2-7.5 1.82-8.08 5.3-1.32.13-.86-.91-.52-1.72 1.17-3.04 4.37-5.8 7.8-5 1.1.27 2.06 1 2.75 1.9zm8.6 3.3c-.83.9-.03.97-1.47 1.02-2.21.23-5.05.5-6.48-1.61-.5-.69-.92-1.43-1.44-2.1.7-.97 1.16-.23 1.58.52.65 1.25 1.78 2.37 3.3 2.31 1.47.18 2.96-.25 4.4-.18l.1.04zm-.4-.12zm4.55 13.26c-.35-1.27.77-.96 1.64-.97 1.29-.1 2.86.06 3.85-.91.2-1.26-1.04-2.2-1.76-3.1-2.66-2.67-5.66-4.96-8.52-7.4.52-1.25 1.23-.25 1.9.3 3.01 2.61 6.34 4.95 8.77 8.14.83.97 1 2.75-.38 3.32-1.7.77-3.68.64-5.5.62zm-15.26 1.8c-1.27 1.04-.72-.54.32-.25 4.56.16 8.73-1.99 13.18-2.49.61.1 2.07-.52 1.78.53.04.8-1.24.22-1.82.48-4.28.54-8.3 2.52-12.68 2.48-.75-.08-1.74.32-.78-.74zm-.89.46zm3.93 3.88c.14 1.2-.74 1.01-1.37.35-1.14-1.21-1.76-2.8-2.55-4.23.87-.85 1.19.05 1.54.83.7 1.07 1.1 2.63 2.43 3.07l-.05-.02zm-.19.98zm19.98-2.54c.15 1.25-.8.9-1.65.8-6.19-.38-12.12 2.93-18.33 1.74-.13-1.24.8-.88 1.65-.78 6.2.43 12.12-2.88 18.33-1.76zm-23-39.9c1 .04 1.28.6 1.76 1.4 7.28 9.72 15.32 18.91 21.69 29.29 1.4 2.52 3.07 5.1 3.22 8.07 0 1.35-1.22 2.3-2.52 2.25-1 .33-1.85-.69-.86-1.08.95.23 2.43.06 2.4-1.22-.27-3.04-2.07-5.67-3.55-8.25-6.25-9.99-14-18.9-21.06-28.31-.43-.67-1.07-1.31-1.08-2.15zm-12.13-3.72c.07-1.28-.86-.47.07-1.64 1.48-2.35 4.67-2.93 7.13-1.9 2.71 1.07 5.37 3.23 5.97 6.21.35.96-.4 1.76-1 .9.2-2.25-1.72-4.03-3.42-5.22-2.1-1.47-5.4-2.15-7.35-.05-.59.47-.74 1.33-1.4 1.7zm.4-.27zm-.45-.23zm.44.23z'/%3E %3Cpath fill='%2321231e' d='M406.86 317.22l-1.13.4c-.17-.44.3-.94.74-.77.18.05.33.2.39.37zm7.7 10.54l-.77.9c-3.08-2.6-5.78-5.74-7.42-9.45-.24-.52-.45-1.06-.64-1.6l1.13-.39a23.66 23.66 0 0 0 6.27 9.26c.46.44.94.86 1.43 1.28zm-.77.9l.77-.9c.38.29.22.96-.25 1.04a.59.59 0 0 1-.52-.13z'/%3E %3Cpath fill='%2321231E' d='M.9 0C.9.44.5.79 0 .79S-.9.44-.9 0s.4-.79.9-.79.9.35.9.79z' transform='matrix(.21422 -1.51084 1.7589 .184 404.14 325.55)'/%3E %3Cpath fill='%2321231e' d='M358.42 362.56c.6-.47 1.33.54.69.96l-.69-.96zm-22.68 56.14c1.47-10.11 5.01-19.79 8.48-29.35 3.4-8.53 6.68-17.31 12.16-24.75.46-1.33 3.24-2.74 2.3-.73-4.49 4.66-6.9 10.86-9.6 16.64-4.92 11.7-9.35 23.7-11.87 36.17-.45 1.13.44 2.66-1.47 2.02zm5.55 80.36c-5.79-16.16-6.83-33.54-6.97-50.56 0-9.95.5-19.9 1.42-29.8 2.25-.32.53 2.67.84 3.99-1.59 21-1.9 42.36 2.2 63.12a89.33 89.33 0 0 0 3.62 12.84l-1.1.41zm1.11-.41c.3.7-.87 1.13-1.1.41l1.1-.41z'/%3E %3C/g%3E %3Cuse xlink:href='%23d' transform='matrix(-1 0 0 1 964.3 0)'/%3E %3Cpath fill='%2321231e' d='M473.11 398.36c-.37.11-.52.44-.45.86a36.34 36.34 0 0 0 5.92 17.89 49 49 0 0 0 3.03 4.16c.22.19.67.2.93.1.54-.51.97-1.17 1.44-1.76a39.12 39.12 0 0 0 5.96-11.3 34.9 34.9 0 0 0 1.7-9.48c-.08-.37-.54-.6-.87-.4-.45.2-.28.87-.35 1.35a37.09 37.09 0 0 1-.84 5.48 36.31 36.31 0 0 1-4.77 11.1 51.75 51.75 0 0 1-2.67 3.7 49.32 49.32 0 0 1-2.93-4.16 37.2 37.2 0 0 1-3.35-6.81 35.87 35.87 0 0 1-1.69-6.62c-.19-1.24-.24-2.54-.38-3.77-.12-.24-.35-.38-.68-.34z'/%3E %3Cg%3E %3Cpath d='M549.18 422.03v108.56a72.16 72.16 0 0 1-19.67 49.81c-12.14 12.77-28.9 20.7-47.36 20.7s-35.22-7.92-47.36-20.7a72.15 72.15 0 0 1-19.67-49.8V422.02h134.06z' fill='%23C6363C'/%3E %3Cuse xlink:href='%23e' transform='matrix(-1 0 0 1 964.3 -90.09)'/%3E %3Cpath stroke='%2321231E' stroke-width='.99' d='M549.18 488.62v27.98h-53.06v82.94a63.64 63.64 0 0 1-27.93 0V516.6h-53.07v-27.98h53.07v-66.59h27.93v66.59h53.06z' fill='%23FFF'/%3E %3Cuse xlink:href='%23e' y='-90.09'/%3E %3Cpath id='e' d='M459.14 567.32v-39.33c-8.56-2.3-29.4-10.62-30.49 7.61-.5 8.43 10.44 13.99 13.4 6.54 1.4-3.52-.13-6.01-2.19-6.82-2.22-.87-4.43.93-3.84 3.61-8.86-4.64 7.92-14.48 15.5-1.67 2.2 3.74-3.73 7.63-3.74 10.4 0 2.76 5.83 6.9 3.73 10.39-7.67 12.75-24.35 2.96-15.49-1.67-.59 2.68 1.62 4.48 3.84 3.6 2.06-.8 3.58-3.3 2.18-6.82-2.95-7.44-13.89-1.88-13.39 6.55 1.09 18.23 21.93 9.91 30.49 7.6z' stroke='%2321231E' stroke-width='.99' fill='%23FFF'/%3E %3Cuse xlink:href='%23e' transform='matrix(-1 0 0 1 964.3 0)'/%3E %3Cpath fill='%2321231e' d='M414 420.86c.08 37.95-.15 75.9.12 113.85 1.2 27.86 19.67 54.5 46.21 63.77 22.43 8.32 49 2.59 66.38-13.74 16.2-14.52 24.65-36.69 23.58-58.24V420.86H414zm2.27 2.36h131.79c-.08 37.12.15 74.25-.12 111.37-1.13 26.66-18.72 52.26-44.03 61.41-21.59 8.29-47.34 3.04-64.31-12.57-16.02-14.08-24.42-35.74-23.34-56.92V423.22z'/%3E %3C/g%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 9 6'%3E %3Crect fill='%23fff' width='9' height='3'/%3E %3Crect fill='%23d52b1e' y='3' width='9' height='3'/%3E %3Crect fill='%230039a6' y='2' width='9' height='2'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 1080 720'%3E %3Crect width='1080' height='720' fill='%2320603D'/%3E %3Crect width='1080' height='540' fill='%23FAD201'/%3E %3Crect width='1080' height='360' fill='%2300A1DE'/%3E %3Cg transform='translate(886.5,188.1)'%3E %3Cg id='h'%3E %3Cpath id='q' fill='%23E5BE01' d='M 116.10000,0.00000 L 35.69202,4.69894 112.14399,30.04889 33.25966,13.77660 100.54555,58.05000 28.56072,21.91541 82.09510,82.09510 21.91541,28.56072 58.05000,100.54555 13.77660,33.25966 30.04889,112.14399 4.69894,35.69202 0.00000,116.10000 -1,-1 z'/%3E %3Cuse xlink:href='%23q' transform='scale(1,-1)'/%3E %3C/g%3E %3Cuse xlink:href='%23h' transform='scale(-1,1)'/%3E %3Ccircle r='34.3' fill='%23E5BE01' stroke='%2300A1DE' stroke-width='3.4'/%3E %3C/g%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 750 500'%3E %3Crect width='750' fill='%23006c35' height='500'/%3E %3Cpath fill-rule='evenodd' d='m323.28 118.09c-0.3878-0.0115-0.96797 0.20495-1.7812 0.6875-1.8284 1.2256-5.4516 5.0006-5.5625 9.3438-0.11087 2.4503-0.57338 2.4407 1.0312 4 1.1591 1.6712 2.3168 1.5069 4.6562 0.28125 1.3436-0.98979 1.7974-1.6212 2.25-3.2812 0.55738-2.7839-2.9295 1.3172-3.375-1.7812-0.77915-2.8766 1.4468-4.0598 3.5625-6.8438 0.0485-1.3111 0.0719-2.381-0.78125-2.4062zm34.062 0.1875c-0.65345 0.088-1.4528 0.92515-2.5625 2.9375-0.79526 2.1076-4.2255 5.2972-1.75 11.875 2.0249 4.1708 2.8567 10.949 1.9375 18.5-1.403 2.1459-1.723 2.8854-3.5625 5.0312-2.5843 2.7789-5.3833 2.0684-7.5312 1.0312-2.0068-1.3526-3.5838-2.0469-4.5-6.3438 0.16531-6.8489 0.56436-18.059-0.6875-20.438-1.8455-3.684-4.8873-2.3628-6.1875-1.25-6.2472 5.712-9.3329 15.357-11.219 23.031-1.7326 5.593-3.5788 3.9755-4.875 1.7188-3.1558-2.9573-3.3775-26.083-7.1875-22.281-6.1021 17.44 3.5018 36.545 10.156 34.688 4.8008 1.9876 7.847-7.1505 9.8125-17.156 1.3446-2.8081 2.3721-3.1309 3.0625-1.6875-0.17741 13.306 0.95406 16.274 4.375 20.312 7.6311 5.8874 13.943 0.7459 14.438 0.25 0.49491-0.4949 5.9375-5.9375 5.9375-5.9375 1.3224-1.391 3.0698-1.4756 4.9375-0.25 1.8153 1.65 1.5822 4.4922 5.4688 6.4688 3.2708 1.3083 10.255 0.31819 11.875-2.5 2.1802-3.7364 2.7088-5.0203 3.7188-6.4375 1.5562-2.0713 4.2188-1.1542 4.2188-0.5-0.24796 1.1551-1.8124 2.2946-0.75 4.375 1.8506 1.3879 2.2804 0.49593 3.375 0.1875 3.8715-1.8506 6.7812-10.25 6.7812-10.25 0.17134-3.1327-1.611-2.8951-2.75-2.25-1.4857 0.90815-1.5768 1.2168-3.0625 2.125-1.8929 0.28122-5.5597 1.5299-7.375-1.2812-1.8536-3.3796-1.8641-8.0912-3.2812-11.5 0-0.24795-2.4765-5.3599-0.1875-5.6875 1.1551 0.21469 3.6392 0.85659 4.0312-1.2188 1.2116-2.0229-2.6142-7.7615-5.2188-10.656-2.2608-2.4815-5.3824-2.784-8.4062-0.25-2.1177 1.9483-1.8035 4.1242-2.2188 6.1875-0.53925 2.3697-0.43618 5.3048 1.9688 8.4375 2.1136 4.1678 5.9535 9.5151 4.6875 17.062 0 0-2.2313 3.5917-6.1562 3.125-1.6359-0.35681-4.3016-1.0648-5.7188-11.531-1.0724-7.9224 0.26872-19.022-3.0938-24.219-0.75911-1.9611-1.4109-3.8654-2.5-3.7188zm-10.78 0.84c-1.0171 0.0888-2.1438 1.2735-3.0625 3.5625-0.78821 1.7407-1.751 10.844-1.5938 10.844-0.62896 2.7093 2.8308 3.8574 4.4062 0.375 2.3616-6.3843 2.373-9.1042 2.5312-11.812-0.3679-2.0627-1.2641-3.0576-2.2812-2.9688zm39.812 0.71875c-1.0447 0.0947-1.8768 0.70635-2.1875 2.25-0.41629 3.6296-0.20355 5.6032 0.40625 8.625 0.46769 2.0149 3.4004 5.3884 4.8438 7.3438 6.896 9.2694 13.531 18.583 19.938 28.219 1.0072 7.155 1.7452 14.154 2.2188 21.125 1.0382 15.284 1.3537 34.31 0.40625 50.406 2.8636 0.1129 7.4518-4.6239 9.0625-11.562 1.0472-9.5976-0.37299-29.18-0.46875-34.844-0.0675-2.3514-0.21224-5.157-0.375-8.0938 7.4527 12.179 14.683 25.082 21.781 39.25 2.5874-1.2297 2.0139-15.798 0.5-17.844-5.6807-12.227-13.529-24.296-16.031-28.938-0.90311-1.6763-3.9793-6.3547-7.625-11.75-0.67122-7.6985-1.4006-14.219-1.875-16.188-1.1722-8.1381 3.3447 0.91775 2.7188-3.8125-1.4656-8.127-5.9513-13.65-11.25-21.094-1.7085-2.4211-1.6747-2.9149-4.3125 0.59375-1.5766 3.5768-1.5553 6.5526-1.0938 9.3438-0.69381-1.0083-1.5514-2.2039-2.7812-3.6875-4.576-3.9259-4.8583-4.1405-8.6562-7.3438-1.1976-0.84982-3.4776-2.1579-5.2188-2zm118 1.2188c-0.50876-0.0791-1.0631 0.17099-1.6875 1.0938-1.1934 1.0462-2.4768 2.9408-2.4375 5.375 0.29027 4.2888 1.0535 8.68 1.3438 12.969 0.10229 0.57392 0.2102 1.1448 0.3125 1.7188-0.46081-0.58803-0.86314-1.0469-1.0938-1.2812-8.3598-8.7822 3.841-1.4353-1.5938-8.2188-4.5962-5.0467-5.941-6.6526-9.875-9.6875-1.9726-1.275-3.1644-3.7112-3.8125 0.4375-0.25802 3.6447-0.52618 7.8653-0.28125 10.938-0.0141 1.7074 1.7542 4.9216 3.2812 6.8125 5.5768 6.8517 11.273 14.142 17 21.75 1.2052 15.516 1.5266 29.739 2.75 45.281-0.17335 6.6473-2.218 15.476-4.1562 16.312 0 0-2.9599 1.7004-4.9375-0.1875-1.4383-0.57755-7.1875-9.5938-7.1875-9.5938-2.9432-2.6982-4.9055-1.9272-7 0-5.7755 5.5769-8.3876 16.023-12.312 23.219-1.012 1.6056-3.8623 2.9724-7.0312-0.125-8.0484-10.996-3.3419-26.648-4.3438-22.625-7.1685 8.0786-3.9938 21.465-2.375 24.344 2.3636 4.7282 4.2758 7.7553 8.875 10.094 4.189 3.0833 7.4508 1.159 9.25-1 4.2152-4.3684 4.2714-15.54 6.25-17.75 1.3879-4.06 4.8662-3.3617 6.5625-1.5625 1.644 2.3636 3.585 3.9014 6 5.1875 3.9319 3.4683 8.6246 4.0984 13.25 0.9375 3.1609-1.773 5.2119-4.0772 7.0625-8.625 1.9856-5.3106 1.0038-33.142 0.5625-48.625 2.9696 4.1831 5.9006 8.4568 8.8125 12.781 1.2782 13.591 1.8582 26.976 1.4375 39.812-0.30139 2.5521 8.9062-7.6196 8.8438-12.438-0.0415-4.2158 0.008-8.0366 0-11.594 4.466 7.1306 8.789 14.38 12.875 21.719 2.532-1.3416 1.6641-15.678 0.0625-17.656-4.2781-7.1786-9.7567-14.936-14-20.938-0.83864-7.5749-1.9805-16.512-2.5-19.25-0.8094-4.2696-1.6201-10.683-2.8438-15.75-0.33567-1.9786-1.3488-8.2985-1.0312-8.9062 0.49893-1.4141 2.3842 0.0452 3.3125-1.5938 1.3899-1.5149-4.8179-17.598-7.9688-22.188-1.1329-2.0572-3.1818-1.3453-5.7188 2-2.3526 2.2013-1.4918 7.2234-0.59375 12 2.3327 12.174 4.4149 24.572 6.0625 36.938-3.0501-4.5343-6.7725-10.021-10.438-15.312-0.0985-0.51026-0.46875-2.3803-0.46875-2.4062-0.00002-0.21873-0.50509-9.959-0.9375-12.281-0.0756-0.94243-0.30028-1.2137 0.6875-1.0938 1.0473 0.88094 1.1896 0.92846 1.8438 1.2188 1.0573 0.19352 1.9818-1.594 1.3438-3.25-3.2708-6.0325-6.5418-12.092-9.8125-18.125-0.3936-0.38756-0.83499-0.79588-1.3438-0.875zm-304.53 0.3125c-1.8123-0.0518-3.8118 1.0716-3.0312 3.25-0.45458 1.1873 3.5475 5.2009 4.25 7.4062 0.62996 1.5704-0.62483 6.6271 0.6875 7.0938 1.2065 0.52312 2.868-3.5005 3.5-7.2188 0.34975-2.037 0.0851-9.0082-4.6562-10.438-0.24291-0.0549-0.4911-0.0863-0.75-0.0937zm346.91 0.04c-0.41312 0.041-0.91624 0.70862-1.6875 2.3438-1.8546 3.0379-2.4928 8.4774-1.75 13.281 4.4652 30.203 7.7834 59.449 8.4688 86.219-0.38402 2.541-0.49612 3.8926-1.6875 7.0938-2.6358 3.3786-5.5427 7.6142-8.2812 9.6562-2.7376 2.0411-8.5638 3.9871-10.469 5.5-6.0436 3.4935-6.074 7.5111-1.1875 7.6562 8.4213-0.97769 18.386-1.6686 25.25-12.031 1.8365-2.9038 3.999-10.776 4.0938-15.594 0.64204-28.247-0.36143-55.866-4.5938-76.281-0.27113-1.9887-1.1492-6.5596-0.8125-7.1562 0.54529-1.398 3.3005 0.13992 4.2812-1.4688 1.4394-1.4696-7.1254-12.436-10.125-17.125-0.59928-1.1776-0.96885-2.1465-1.5-2.0938zm-88.312 0.46875c-0.34774 0.06-0.86114 0.58925-1.8125 1.8438-2.3525 7.6916-3.1793 13.973-2.2812 18.75 6.0426 31.534 12.234 60.263 11.25 90.281 2.8656 0.0191 6.1786-6.5553 7.5938-13.062 0.7751-8.9636-0.51716-14.419-0.75-19.688-0.23181-5.2685-5.9639-48.014-7.125-52-1.401-7.5374 5.5735-0.99148 4.8125-5.375-2.411-5.5265-8.4287-13.574-10.312-18.375-0.70808-1.2858-0.79543-2.475-1.375-2.375zm-215.03 0.59375c-0.7426 0.12864-1.4592 0.74056-1.7188 1.75-0.16329 0.66121 0.28622 1.7611-0.3125 2.0938-0.3437 0.34673-1.6482 0.11368-1.5938-1.7188 0-0.58359-0.42846-1.1926-0.6875-1.5625-0.26005-0.17034-0.43554-0.21875-0.90625-0.21875-0.57352 0.0232-0.56052 0.17445-0.875 0.65625-0.14 0.49-0.32 0.97-0.32 1.53-0.0716 0.65214-0.33273 0.873-0.8125 0.96875-0.53623 0-0.40932 0.0584-0.84375-0.21875-0.25803-0.28222-0.5625-0.3932-0.5625-0.875 0-0.49892-0.13107-1.2954-0.28125-1.625-0.22778-0.30036-0.58775-0.45667-1-0.5625-2.2467 0.008-2.4103 2.5898-2.2812 3.5625-0.16832 0.18344-0.25163 4.7592 2.8125 6.0312 4.1134 1.9614 11.827 1.1322 11.5-5.5 0.00001-0.58662-0.12904-2.5565-0.1875-3.0938-0.41981-0.9777-1.1949-1.3474-1.9375-1.2188zm55.188 0.0625c-1.4216 0.0725-2.6766 0.47991-3.75 1.0312-2.7265 2.6106-3.3657 6.7957-1.2188 9.4062 2.0895 0.98677 4.1742 3.0899 2.7812 4.25-5.9087 6.3111-21.287 16.857-22.062 18.781-0.006 0.0157-0.0279 0.0481-0.0312 0.0625-0.002 0.0138 0.00015 0.05 0 0.0625 0.00047 0.006-0.001 0.0256 0 0.0312 0.005 0.0159 0.0214 0.0496 0.0312 0.0625 0.004 0.004 0.0268 0.0276 0.0312 0.0312 0.005 0.003 0.0257-0.003 0.0312 0 0.006 0.003 0.0245 0.029 0.0312 0.0312 0.007 0.002 0.0233-0.002 0.0312 0 0.002 0.002 0.0286 0.029 0.0312 0.0312 0.78147 0.52416 10.404 0.51176 11.469 0.0312 0.008-0.004 0.0248-0.0271 0.0312-0.0312 0.003-0.002 0.0286 0.002 0.0312 0 0.002-0.002-0.002-0.0291 0-0.0312 3.307-1.2186 19-19.156 19-19.156-0.81342-0.69647-1.5626-1.2098-2.375-1.9062-0.87086-0.75393-0.78317-1.4951 0-2.25 3.8866-2.2618 2.655-7.2382 0.625-9.5-1.6828-0.75445-3.2659-1.01-4.6875-0.9375zm144.25 0.0625c-0.41312 0.041-0.91624 0.67737-1.6875 2.3125-1.8546 3.0379-3.1149 8.3282-2.9688 13.281 4.0176 27.814 5.2493 52.154 7.875 79.969 0.21369 2.6902-0.18067 6.598-1.9688 8.1562-6.6141 6.9064-16.151 15.424-26.531 19.344-1.1168 1.2539 2.7768 6.5988 7.8125 6.5938 8.4213-0.9777 15.823-5.7042 22.688-18.156 1.8355-2.9039 5.0615-9.1196 5.1562-13.938 0.64205-28.247-1.4239-50.209-5.6562-70.625-0.27114-1.9886-0.0867-4.3408 0.25-4.9375 0.54529-0.65112 2.3943 0.0149 3.375-1.5938 1.4393-1.4696-3.8441-13.655-6.8438-18.344-0.59928-1.1776-0.96885-2.1152-1.5-2.0625zm-223.47 0.85c-1.1623 0.1359-2.2557 1.0822-2.7812 2.3438-0.19454 4.4611-0.2207 8.9199 0.28125 13.031 2.029 7.2108 2.6715 13.553 3.6562 20.938 0.27314 9.8909-5.7117 4.2786-5.4375-0.625 1.3819-6.3692 1.0089-16.396-0.21875-18.938-0.97367-2.541-2.1011-3.1683-4.4688-2.75-1.8798-0.1149-6.7361 5.1765-8.0938 13.938 0.00001-0.00001-1.1311 4.4965-1.625 8.5-0.66423 4.5246-3.6616 7.7288-5.75-0.625-1.8052-6.0718-2.9147-21.032-5.9375-17.531-0.86582 11.681-1.8939 32.235 8.0312 34.344 12.005 1.1541 5.3735-20.294 9.7188-24.188 0.82147-1.9242 2.3438-1.9584 2.4688 0.46875v18.219c-0.10986 5.9226 3.7877 7.6826 6.8125 8.9062 3.1478-0.24292 5.235-0.15687 6.4688 2.9062 0.49188 10.502 1.0081 21.03 1.5 31.531 0 0 7.2773 2.0912 7.625-17.719 0.34876-11.632-2.3163-21.393-0.75-23.656 0.0554-2.2235 2.9055-2.3335 4.875-1.25 3.1377 2.2134 4.5298 4.9374 9.4062 3.8438 7.4204-2.0441 11.89-5.6459 12-11.344-0.43342-5.4146-1.0598-10.835-3.4062-16.25 0.32759-0.98475-1.4203-3.5465-1.0938-4.5312 1.3335 2.0884 3.3509 1.9151 3.8125 0-1.263-4.1618-3.2292-8.1494-6.4062-9.875-2.6257-2.3132-6.4679-1.824-7.875 3-0.65214 5.5588 2.0146 12.147 6.0625 17.531 0.85977 2.1036 2.0624 5.6022 1.5312 8.75-2.154 1.2287-4.2896 0.7175-6.0938-1.1875 0.00001-0.00001-5.9062-4.4215-5.9062-5.4062 1.5673-10.035 0.33759-11.184-0.53125-13.969-0.60677-3.8443-2.4286-5.0618-3.9062-7.6875-1.4776-1.5663-3.482-1.5663-4.4375 0-2.6106 4.5256-1.3858 14.242 0.5 18.594 1.3627 4.0025 3.4525 6.5 2.4688 6.5-0.81038 2.2618-2.5002 1.7356-3.7188-0.875-1.7397-5.3955-2.0938-13.437-2.0938-17.062-0.52212-4.4944-1.1042-14.095-4.0625-16.531-0.78934-1.0751-1.721-1.4494-2.625-1.3438zm42.156 0.0625c-0.59574 0.0753-1.2543 0.41445-2.0312 0.59375-2.5521 0.8124-4.9414 3.0187-4.1875 7.3125 3.0168 18.332 4.9832 32.323 8 50.656 0.46368 2.1469-1.336 4.9768-3.6562 4.6875-3.9451-2.669-4.9242-8.0746-11.656-7.8438-4.8734 0.0585-10.431 5.3615-11.125 10.469-0.81239 4.059-1.1017 8.4601 0 12 3.425 4.1184 7.5277 3.6793 11.125 2.75 2.9583-1.2176 5.3923-4.133 6.4375-3.4375 0.003 0.003 0.0286-0.004 0.0312 0 0.003 0.004-0.003 0.027 0 0.0312 0.64509 1.1276-0.0608 10.663-13.938 18.031-8.5281 3.8292-15.316 4.7441-18.969-2.2188-2.2628-4.3513 0.16462-20.924-5.4062-17.094-16.475 42.467 38.598 48.395 44.75 1.75 0.39844-1.3159 1.6121-2.6362 2.4688-2.3125 0.3759 0.16008 0.71998 0.67052 0.84375 1.625-1.2771 42.235-42.606 45.13-49.625 31.844-1.7397-3.1317-2.2631-10.103-2.4375-14.281-0.31817-2.5275-0.95237-3.9854-1.6875-4.5625-1.6745-1.2582-3.9247 2.023-4.4062 7.7188-0.69647 4.5831-0.5 5.8413-0.5 10.25 2.2044 33.359 55.388 19.026 64.031-8.5312 4.2787-14.246-0.0871-24.993 1.3438-26.312 0.0124-0.0104 0.0493-0.0222 0.0625-0.0312 0.0136-0.008 0.048-0.0242 0.0625-0.0312 0.0149-0.006 0.0467-0.0262 0.0625-0.0312 0.0487-0.013 0.13046-0.0305 0.1875-0.0312 5.2796 5.6868 12.688 0.72253 14.312-1.25 0.69648-0.98677 2.4387-1.6198 3.6562-0.34375 4.1184 2.9603 11.337 1.5649 12.844-3.6562 0.87085-5.1052 1.6069-10.361 1.7812-15.812-2.6827 0.83292-4.8475 1.4566-5.7188 2.375-0.20749 0.22659-0.36097 0.47794-0.40625 0.75-0.23283 1.5089-0.45467 3.0224-0.6875 4.5312-0.0249 0.12473-0.065 0.23996-0.125 0.34375-0.11434 0.18521-0.30336 0.35601-0.5 0.46875-0.94842 0.51783-2.6022 0.22171-2.6875-1.1562-1.276-5.8017-6.5276-6.5563-9.7188 2.4375-2.1469 1.7397-6.0616 2.0793-6.4688-0.53125 0.52213-6.0335-1.9089-6.8434-6.7812-4-1.5664-11.951-3.1202-23.361-4.6875-35.312 2.031-0.0585 3.8934 1.414 5.75-0.90625-2.0092-6.2487-6.2607-18.963-8.6562-20.156-0.0188-0.009-0.0439-0.024-0.0625-0.0312-0.10876-0.1305-0.23745-0.25071-0.34375-0.34375-0.0442-0.0375-0.1123-0.0933-0.15625-0.125-0.0439-0.0305-0.11251-0.0687-0.15625-0.0937-0.0962-0.0528-0.21644-0.0958-0.3125-0.125-0.2184-0.0619-0.43059-0.091-0.65625-0.0625zm164.34 0.0937c-2.1076-0.0625-4.4397 1.2657-3.5312 3.9062-0.52916 1.4403 4.5283 6.326 5.3438 9 1.4676 4.1084-1.1208 8.0273 0.40625 8.5938 1.4051 0.63399 3.36-4.2415 4.0938-8.75 0.84767-3.6447-1.7525-11.114-5.4375-12.656-0.28247-0.0665-0.57391-0.0848-0.875-0.0937zm-128.03 4.5c0.95979-0.0978 2.1195 0.78407 2.6875 2.0312 0.60588 1.3303 0.30199 2.6014-0.6875 2.8438-0.98948 0.24236-2.2691-0.63842-2.875-1.9688-0.60586-1.3303-0.30199-2.6326 0.6875-2.875 0.0618-0.0152 0.12351-0.0247 0.1875-0.0312zm237.5 6.1562c-1.9215-0.0673-4.0156 1.3916-3.1875 4.25-0.4818 1.5593 4.1009 6.8552 4.8438 9.75 0.66826 2.0602-1.017 8.6997 0.375 9.3125 1.2811 0.6864 3.0818-4.5873 3.75-9.4688 0.37092-2.672-1.6093-12.049-4.9688-13.719-0.25753-0.0719-0.538-0.11538-0.8125-0.125zm-131.31 3.25c0.17575 0.78356 0.3514 1.5724 0.46875 2.375 0.39382 1.7317 0.73331 3.4518 1.0938 5.1562-1.5169-2.0887-2.7725-3.7763-3.3125-4.375-3.4323-4.079 0.0773-2.6786 1.75-3.1562zm30.25 14.875c-0.7426 0.12864-1.4592 0.7718-1.7188 1.7812-0.16329 0.6612 0.31746 1.7299-0.28125 2.0625-0.3437 0.34673-1.6794 0.14492-1.625-1.6875-0.00001-0.5836-0.42846-1.2238-0.6875-1.5938-0.26003-0.17035-0.43554-0.21875-0.90625-0.21875-0.57353 0.0232-0.56053 0.17446-0.875 0.65625-0.13304 0.49087-0.3125 0.97487-0.3125 1.5312-0.0716 0.65214-0.30147 0.87299-0.78125 0.96875-0.53622 0-0.44058 0.0584-0.875-0.21875-0.25804-0.28221-0.5625-0.39321-0.5625-0.875 0.00001-0.49893-0.13107-1.2954-0.28125-1.625-0.2278-0.30037-0.58776-0.42541-1-0.53125-2.2467 0.008-2.379 2.5586-2.25 3.5312-0.16834 0.18344-0.28288 4.7905 2.7812 6.0625 4.1134 1.9614 11.858 1.101 11.531-5.5312 0.00001-0.58662-0.16029-2.5565-0.21875-3.0938-0.41981-0.9777-1.1949-1.3474-1.9375-1.2188zm-138.12 1.375c-0.5072-0.0517-1.1721 0.13451-1.9375 0.59375-3.6376 1.9675-5.0461 7.8039-2.7812 11.219 2.1157 3.0077 5.4607 1.9062 5.9062 1.9062 3.564 0.4455 5.6875-6.6875 5.6875-6.6875-0.00001 0 0.10732-2.0056-4.125 1.7812-1.781 0.33363-2.0232-0.3096-2.4688-1.3125-0.37093-1.8556-0.29122-3.7371 0.5625-5.5938 0.39436-1.1131 0.002-1.8201-0.84375-1.9062zm195.25 0.90625c-2.0194-0.0982-4.1688 1.2095-4.7188 3.9688 0.008 1.6278 0.73488 2.5224 0.59375 4-0.21065 0.84465-1.0809 1.4001-3.1562 0.40625 0.32455-0.29835-1.3438-2.6562-1.3438-2.6562-1.6188-0.98576-3.7804 0.0535-5.1875 0.96875-0.7741 1.4071-1.3467 3.8189-0.46875 6.2812 2.3233 4.2928 10.293 11.618 14.094 11.688 0.0706-3.8705 0.4466-9.0175 0.65625-12.219 0.0897-1.2085 0.37315-2.5404 1.5312-2.8438 1.1571-0.30238 3.1653 1.1642 3.1875-0.0937-0.21066-2.4624-0.70279-6.096-2.0938-7.8125-0.71249-1.0557-1.8821-1.6286-3.0938-1.6875zm-161.62 13.469c-0.0537 0.0197-0.10688 0.0656-0.15625 0.0937-0.0242 0.0147-0.0693 0.0449-0.0937 0.0625-0.40219 0.30193-0.87679 0.99874-1.9375 1.75-1.7891 2.035-2.1098 3.4521-2 7.5312 0.10179 0.43147 3.3965 9.5919 6.1875 16.031 1.8818 6.6927 3.6228 14.356 2.3438 21.594-4.4057 9.5684-13.263 18.15-21.812 22.812-4.3557 1.395-8.1174 0.91994-9.125-0.0312-0.008-0.008-0.024-0.0236-0.0312-0.0312-2.5014-1.6818-2.5588-4.6756-2.4062-5.1875-0.00005-0.003 0.00017-0.0277 0-0.0312 0.006-0.006 0.0255-0.0258 0.0312-0.0312 7.2138-5.0246 15.454-9.0914 21.906-22.656 1.905-5.1838 2.4866-8.2964 0.59375-16.312-0.73791-2.9868-1.6494-5.4446-3.6875-7.5625 0.005-0.006 0.0259-0.0257 0.0312-0.0312 1.228-0.58751 4.4141 1.7597 4.9062 0.28125-0.75393-3.8271-3.3461-8.965-6.2812-11.594-2.5702-2.3344-5.3662-2.6046-7.7188-0.46875-2.6499 1.4746-3.2135 6.7707-1.9375 11.406 1.4172 3.4895 5.2433 4.1017 7.9688 11.125-0.00005 0.007-0.00024 0.0289 0 0.0312 0.0568 0.44036 0.93536 5.2424-0.4375 7.1875-1.1141 3.4742-15.424 14.759-16.438 15.438-0.0112 0.0112-0.0829 0.0519-0.0937 0.0625-0.006 0.006-0.0259 0.026-0.0312 0.0312-0.003 0.002-0.0246 0.0245-0.0312 0.0312-0.003 0.003-0.0284 0.028-0.0312 0.0312-0.003 0-0.0278 0.00017-0.0312 0-0.002-0.00007-0.0241-0.00011-0.0312 0-0.006-0.005-0.0257-0.0254-0.0312-0.0312 0.00024-0.003-0.00007-0.0284 0-0.0312-0.006-0.0108-0.0256-0.0512-0.0312-0.0625-0.0431-0.28175 0.0326-0.99908 0-2.1562-0.094-2.1144 0.78114-6.8979 0.71875-7.7188 0.00003-0.003-0.00009-0.0281 0-0.0312-0.006-0.006-0.0254-0.0257-0.0312-0.0312 0.00004-0.003-0.00016-0.0278 0-0.0312-0.007 0.00014-0.0302 0.00009-0.0312 0-4.7302 3.0541-6.2924 12.416-7.1562 15.188-11.975 8.2741-25.574 14.43-33.406 22.812-4.0791 6.3702 28.104-7.3147 31.844-8.9688 0.0321 0.0241 0.0641 0.063 0.0937 0.0937 0.71089 0.78237 0.77161 3.5103 2.9062 5.9688 3.3453 4.5317 10.456 7.3224 17.375 5.5938 11.603-4.194 18.288-12.102 25.094-20.875 0.97266-1.4151 2.4972-2.5301 3.9062-1.4375 4.6768 10.47 18.161 17.92 35.594 18.688 4.0338-4.9056 2.1046-7.3177 0.46875-8.3438-0.50391-0.33487-8.6698-3.5184-9.9375-6.6875-0.79829-2.9492 1.1426-5.5648 5.0312-7.5312 11.193-1.3537 22.196-2.8573 32.844-6.2812 0.10784-3.5772 2.2149-8.9267 3.625-11.25 0.97909-1.612 1.6086-1.7716 1.8438-2 0.008-0.008 0.0246-0.023 0.0312-0.0312 0.003-0.004 0.0284-0.0269 0.0312-0.0312 0.006-0.005 0.0256-0.0257 0.0312-0.0312 0.00002-0.0107 0.00042-0.0514 0-0.0625 0.006-0.0708-0.00049-0.19272-0.0312-0.3125l-1.8125-1.0625-35.719-0.15625c-0.44124-0.16987-0.76931-0.34037-0.96875-0.5-0.0152-0.0127-0.0489-0.0499-0.0625-0.0625-0.006-0.006-0.0253-0.025-0.0312-0.0312-0.006-0.006-0.0261-0.0251-0.0312-0.0312-0.005-0.0109-0.0263-0.0516-0.0312-0.0625-0.003-0.003-0.0277-0.0279-0.0312-0.0312 0.00006-0.003-0.00029-0.0279 0-0.0312-0.003-0.003-0.0276-0.0279-0.0312-0.0312 0.00002-0.003-0.00018-0.0279 0-0.0312 0.00001-0.003-0.00013-0.0279 0-0.0312 0-0.003-0.00008-0.0279 0-0.0312-0.00033-0.005 0.00012-0.0265 0-0.0312 0.00013-0.002 0.00009-0.0246 0-0.0312-0.00005-0.003 0.0001-0.0279 0-0.0312-0.00006-0.003 0.00014-0.0279 0-0.0312-0.00007-0.003 0.00019-0.0279 0-0.0312 0.006-0.006 0.0254-0.0256 0.0312-0.0312 0.008-0.0165 0.0204-0.0462 0.0312-0.0625 0.17439-0.23501 0.59702-0.45652 1.125-0.65625 8.5292-1.1621 23.682-3.646 24.688-18.219-0.15724-7.5908-3.2482-12.561-12.562-13.938-6.8439 0.52918-11.725 7.1491-10.938 14.438-0.32757 1.9624 0.66406 5.8136-1.3438 6.25-13.128 1.1994-27.457 9.4251-27.938 15.312-0.003-0.00052-0.0285 0.00014-0.0312 0-0.005 0.006-0.0258 0.0256-0.0312 0.0312-0.0101 0.005-0.046 0.0231-0.0625 0.0312-0.0109-0.00015-0.0515 0.0004-0.0625 0-0.0211 0.007-0.0722 0.0257-0.0937 0.0312-0.006 0.00054-0.0232-0.00011-0.0312 0-0.0178-0.00028-0.0507 0-0.0625 0-0.006-0.00019-0.0232-0.0002-0.0312 0-0.0132 0.00033-0.0516 0.00053-0.0625 0-0.0339-0.007-0.0956-0.0238-0.125-0.0312-0.85384-0.23714-1.9538-1.6462-1.7812-3.625-0.49994-10.177-3.8122-21.693-9-30.562-1.8513-1.8508-2.6579-2.6008-3.1875-2.6875-0.0171-0.002-0.0459 0.0008-0.0625 0-0.0218-0.00009-0.0656 0.00025-0.0937 0-0.005 0.00014-0.0264-0.0004-0.0312 0-0.003-0.00009-0.0283 0.00025-0.0312 0-0.004 0.001-0.0274-0.001-0.0312 0zm34.188 5.375c-0.7426 0.12864-1.4592 0.74055-1.7188 1.75-0.16327 0.66121 0.31746 1.7611-0.28125 2.0938-0.34371 0.34673-1.6794 0.14493-1.625-1.6875 0-0.58359-0.42846-1.2238-0.6875-1.5938-0.26004-0.17034-0.40429-0.21875-0.875-0.21875-0.57352 0.0232-0.59178 0.17445-0.90625 0.65625-0.13306 0.49085-0.3125 0.97487-0.3125 1.5312-0.0716 0.65214-0.30147 0.873-0.78125 0.96875-0.53623 0-0.40933 0.0584-0.84375-0.21875-0.25803-0.28222-0.59375-0.3932-0.59375-0.875-0.00001-0.49893-0.0998-1.2954-0.25-1.625-0.22779-0.30036-0.61901-0.42542-1.0312-0.53125-2.2467 0.008-2.379 2.5586-2.25 3.5312-0.16833 0.18345-0.28288 4.7905 2.7812 6.0625 4.1134 1.9614 13.916 0.80665 11.531-5.5312-0.00001-0.58662-0.16029-2.5565-0.21875-3.0938-0.4198-0.9777-1.1949-1.3474-1.9375-1.2188zm137.97 5.6562c-0.1034-0.0186-0.22236-0.0114-0.34375 0.0312 0 0-19.059 13.559-19.531 14.031-1.8899 1.6802-0.94442 7.5886 0 6.9062 1.3658 0.52513 20.554-12.478 20.188-14 0.83627 0.0491 1.2385-6.6892-0.3125-6.9688zm-119.96 2.01c0.77787-0.0825 1.7982 0.18143 2.7812 0.75 1.4228 0.82293 2.2998 2.0657 2.1875 2.9688-0.004 0.0245 0.005 0.0698 0 0.0937-0.006 0.0238-0.0554 0.0705-0.0625 0.0937-0.008 0.023-0.0221 0.0713-0.0312 0.0937-0.006 0.0148-0.0241 0.048-0.0312 0.0625-0.007 0.0144-0.0231 0.0484-0.0312 0.0625-0.0466 0.0763-0.12358 0.15638-0.1875 0.21875-0.68395 0.63877-2.2626 0.54784-3.75-0.3125-1.4098-0.81544-2.281-2.068-2.1875-2.9688 0.003-0.0246 0.0267-0.0696 0.0312-0.0937 0.0236-0.11178 0.0679-0.21374 0.125-0.3125 0.0204-0.0353 0.0384-0.0926 0.0625-0.125 0.005-0.006 0.0261-0.025 0.0312-0.0312 0.042-0.049 0.10547-0.11459 0.15625-0.15625 0.22671-0.17829 0.54802-0.30575 0.90625-0.34375zm-166.91 3.4375c-9.8758 0.18043-24.338 12.945-24.719 20.031 10.421-5.0044 20.657-9.8212 31.25-15-1.7095-2.5521-0.10363-4.8518-6.5312-5.0312zm32 4.4375c0.96809 0.0109 1.9891 0.48893 2.5312 1.8438 0.48784 1.2428 0.0231 2.5424-0.5625 3.1875-0.003 0.005 0.003 0.0263 0 0.0312-0.009 0.0144-0.0215 0.049-0.0312 0.0625-0.4145 0.53404-1.8697 0.3125-2.9062 0.3125-1.2539-0.0554-1.8721-0.26122-2.625-1.2812-0.35982-1.1339 0.73594-2.2481 1.2188-3.0938 0.005-0.008 0.0263-0.0234 0.0312-0.0312 0.0524-0.0788 0.13801-0.17326 0.21875-0.25 0.375-0.34347 1.0235-0.66453 1.7188-0.75 0.13519-0.0166 0.26795-0.0328 0.40625-0.0312zm251.16 3.93c-1.756 0.21654-3.4252 1.877-2.6562 4.5312-0.4818 1.5593 2.3822 7.0115 3.125 9.9062 0.66827 2.0602-0.86071 7.8872 0.53125 8.5 1.2811 0.68641 4.6502-3.4593 4.5312-8.6562 0.37092-2.672-0.95304-12.517-4.3125-14.188-0.38629-0.10791-0.81353-0.14372-1.2188-0.0937zm-213.31 9.625c-1.552 0.10848-2.9369 0.93803-2.3125 3.125-0.0937 1.5865 4.3851 3.5156 4.6562 7.1875 0.64004 1.5139-0.9575 6.362 0.375 6.8125 1.2236 0.50396 2.9215-3.3513 3.5625-6.9375 0.35479-1.9645-1.5367-8.8358-4.75-10.062-0.49313-0.10609-1.0139-0.16116-1.5312-0.125zm63.844 8.7188c0.11777-0.008 0.22161 0.00072 0.34375 0 0.0205-0.00013 0.0419-0.00009 0.0625 0 3.9793 1.0815 9.8454 1.1936 14.938 1.7188 4.1477 0.26307 6.1971 3.5103 2.3125 4.875-3.8322 1.3124-7.5141 2.3374-7.5312 7.875 0.50376 2.7431 0.39705 4.1826-0.0312 4.8438-0.0335 0.0496-0.0878 0.11552-0.125 0.15625-0.005 0.006-0.0258 0.0258-0.0312 0.0312-0.006 0.005-0.0256 0.0261-0.0312 0.0312-0.006 0.005-0.0255 0.0265-0.0312 0.0312l-0.0312 0.0312c-0.011 0.005-0.0514 0.0259-0.0625 0.0312-0.0557 0.0346-0.12681 0.0715-0.1875 0.0937-0.0536 0.0182-0.1305 0.0217-0.1875 0.0312-0.91095 0.1336-2.234-0.73511-3.2188-1.25-2.3626-1.6964-8.9931-5.8056-9.9375-14.625-0.13438-1.9902 1.3554-3.7064 3.75-3.875zm-155.94 6.7812c-0.24858 0.008-0.74605 0.75061-1.4062 1.5938-5.8753 9.3597-6.3978 23.331-3.1562 27.5 1.7226 1.9695 4.5628 2.8356 6.6562 2.2188 3.6911-1.6006 5.3134-9.077 4.4375-11.812-1.2317-1.9282-2.2078-2.2337-3.4375-0.59375-2.5974 5.2735-3.6784 1.666-3.9062-1.2812-0.39814-5.589 0.14322-10.736 0.75-14.812 0.32304-2.089 0.31108-2.8203 0.0625-2.8125zm200.16 12.29c-0.43689-0.0234-0.90278 0.0449-1.375 0.28125-0.0927 0-4.2058 2.7815-5.5312 4.7188-0.80837 0.61485-0.71671 1.1493-0.46875 2.2188 0.62996 1.4484 1.7401 0.99386 3 0.3125 1.6722-0.2278 2.4808 0.8672 2.3438 2.875-0.77208 2.5037 0.34374 3.4365 0.34375 3.5938 0 0.15724 1.6101 1.5392 3.5 0.4375 3.9894-1.523 6.4755-3.0042 12.062-4.2188 1.4666-0.0292 1.3818-3.9536-0.9375-4.0938-3.0258 0.1522-5.8179 0.30676-8.8438 2.6875-1.8617 0.43039-2.1805-0.70275-2.5938-1.7188-0.47272-2.5208 1.0645-4.2976 0.75-6.1875 0.0839 0.0831-0.93932-0.83604-2.25-0.90625zm128.16 4.7812c-0.74222 0.0232-1.5238 0.12602-2.6562 0.21875-1.2246 0.26006-1.6522 0.79656-1.875 2.2812 0.0877 2.2517 1.4649 2.1402 2.875 3.0312 0.81645 1.0392 1.3476 1.98-0.0625 3.6875-1.3365 1.2246-2.2885 1.9004-3.625 3.125-0.631 1.0765-1.024 2.7299 0.90625 3.25 3.564 1.0019 11.812-4.3569 11.812-4.4688 1.3365-1.0019 0.89313-2.9062 0.78125-2.9062-0.77912-0.89102-2.5374-0.35586-3.7188-0.5-0.56244 0-2.4092-0.27339-1.5312-1.9062 0.73278-1.016 1.0031-1.6232 1.5-2.875 0.55638-1.2246 0.0673-2.0505-1.9375-2.7188-1.021-0.18546-1.7265-0.24193-2.4688-0.21875zm-53.54 108.4c-0.008 0.004-0.0234 0.0258-0.0312 0.0312-5.9277 1.521-5.7433 7.6749-1.9375 10.375-62.594 0-158.65-1.0625-179.25-1.0625-11.525 0-47.987-1.375-48.688-1.375 7.8196 11.437 19.147 13.766 33.969 14 27.802 0 156.62-0.34375 193.28-0.34375-2.6062 4.6275 0.23645 12.074 2.2812 13.438 0.0434 0.0279 0.11369 0.0715 0.15625 0.0937 0.0763 0.038 0.17693 0.0749 0.25 0.0937 0.0242 0.006 0.07-0.003 0.0937 0 2.4271 0.5725 3.4951-1.1846 4.3125-2.4688 3.9372 0.34703 26.097 0.66757 28.125-0.0312 0.007-0.003 0.0245-0.0284 0.0312-0.0312 1.3718 2.0189 2.7332 3.9264 5.3438 3.5938 4.569-0.97972 8.1674-1.477 8.2812-10.75 0 0-0.46704-15.802-10.844-14.812-2.4553 0.37092-9.3438 1.0625-9.3438 1.0625-7.9718-0.94847-13.819-1.0454-22.781-1.375 0.82723-1.0502 2.2878-5.3034 0.5-6.8438-0.46622-0.38767-1.1617-0.60352-2.125-0.53125-0.007 0.0005-0.0244-0.00008-0.0312 0-0.0136-0.00068-0.0492 0.002-0.0625 0-0.007-0.002-0.0248-0.0293-0.0312-0.0312-0.0257-0.009-0.0692-0.0161-0.0937-0.0312-0.0486-0.033-0.11173-0.10294-0.15625-0.15625-0.011-0.0139-0.0517-0.0475-0.0625-0.0625-0.45322-0.65987-0.70068-2.2777-1-2.6875-0.004-0.004-0.0277-0.0271-0.0312-0.0312-0.004-0.003-0.0276-0.0282-0.0312-0.0312-0.0109-0.007-0.0514-0.0277-0.0625-0.0312-0.004-0.00036-0.0275-0.00006-0.0312 0-0.004 0.00091-0.0274-0.001-0.0312 0zm4.25 22.594c0.0109-0.005 0.0202 0.005 0.0312 0 9.1319 0.44551 17.712 0.0857 26.844 0.53125 1.4473 1.2303 0.72345 4.0484-0.21875 4.5625-0.0422 0.0211-0.11339 0.051-0.15625 0.0625-0.0344 0.008-0.0905-0.001-0.125 0-0.0345-0.0007-0.0905 0.008-0.125 0-2.9694-0.0746-4.6869-0.14417-7.6562-0.21875-0.005-0.14772-0.0215-0.30707-0.0625-0.4375-0.70371-2.0856-5.8008-1.9461-7-0.3125-0.0166 0.0235-0.0475 0.0696-0.0625 0.0937-0.0192 0.0325-0.0463 0.0915-0.0625 0.125-0.0193 0.0422-0.0482 0.11238-0.0625 0.15625-0.0187 0.0619-0.0229 0.15372-0.0312 0.21875-0.008 0.0748-0.0379 0.17113-0.0312 0.25-4.0086 0.4818-7.6164-0.13309-11.625-0.28125-1.1761-1.4641-1.0388-4.1134 0.34375-4.75z' fill='%23fff'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 800 400'%3E %3Cpath d='M0,400V0H800z' fill='%230051ba'/%3E %3Cpath d='M0,400H800V0z' fill='%23215b33'/%3E %3Cpath d='M0,400 800,0' stroke='%23fcd116' stroke-width='36'/%3E %3Cg transform='translate(140,120)'%3E %3Cg id='s' fill='%23fff'%3E %3Cg id='f'%3E %3Cg id='t'%3E %3Cpath id='o' d='M0,-40V0H20z' transform='rotate(18,0,-40)'/%3E %3Cuse xlink:href='%23o' transform='scale(-1,1)'/%3E %3C/g%3E %3Cuse xlink:href='%23t' transform='rotate(72)'/%3E %3C/g%3E %3Cuse xlink:href='%23t' transform='rotate(-72)'/%3E %3Cuse xlink:href='%23f' transform='rotate(144)'/%3E %3C/g%3E %3Cg id='s2' transform='rotate(40.6)'%3E %3Cuse id='s1' xlink:href='%23s' x='-104' transform='rotate(-40.6,-104,0)'/%3E %3Cuse xlink:href='%23s1' x='208'/%3E %3C/g%3E %3Cuse xlink:href='%23s2' transform='scale(-1,1)'/%3E %3C/g%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 900 450'%3E %3Cpath d='M0,450H900V0H0z' fill='%23d62828'/%3E %3Cpath d='M0,450V0H600z' fill='%23fcd856'/%3E %3Cpath d='M0,450V0H300z' fill='%23003f87'/%3E %3Cpath d='M0,450H900V150z' fill='%23fff'/%3E %3Cpath d='M0,450H900V300z' fill='%23007a3d'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 6'%3E %3Crect width='12' height='6'/%3E %3Crect fill='%23FFF' width='12' height='4'/%3E %3Crect fill='%23D21034' width='12' height='2'/%3E %3Cpolygon fill='%23007229' points='0,0 4,3 0,6'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 10'%3E %3Crect width='16' height='10' fill='%23006aa7'/%3E %3Crect width='2' height='10' x='5' fill='%23fecc00'/%3E %3Crect width='16' height='2' y='4' fill='%23fecc00'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 4320 2880'%3E %3Crect fill='%23ed2939' width='4320' height='1440'/%3E %3Crect fill='%23fff' y='1440' width='4320' height='1440'/%3E %3Cpath fill='%23fff' d='M 1481.678,720 A 541.5,541.5 0 1 1 398.67798,720 A 541.5,541.5 0 1 1 1481.678,720 z'/%3E %3Cpath fill='%23ed2939' d='M 1651.835,720 A 511.73499,511.73499 0 1 1 628.36499,720 A 511.73499,511.73499 0 1 1 1651.835,720 z'/%3E %3Cpath fill='%23fff' id='star' d='M 1007.1951,733.06439 L 933.63466,676.63425 L 860.09279,733.09117 L 888.40587,642.09687 L 814.61147,586.0053 L 905.6704,586.1981 L 933.6049,495.07467 L 961.56934,586.18798 L 1052.6282,585.96246 L 978.8522,642.0808 L 1007.1951,733.06439 z'/%3E %3Cuse xlink:href='%23star' transform='translate(577.18853,0)'/%3E %3Cuse xlink:href='%23star' transform='translate(288.88853,-214.21117)'/%3E %3Cuse xlink:href='%23star' transform='translate(107.99953,342.74883)'/%3E %3Cuse xlink:href='%23star' transform='translate(469.18853,342.74883)'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 60 30'%3E %3CclipPath id='t'%3E %3Cpath d='M30,15 h30 v15 z v15 h-30 z h-30 v-15 z v-15 h30 z'/%3E %3C/clipPath%3E %3Cpath d='M0,0 v30 h60 v-30 z' fill='%2300247d'/%3E %3Cpath d='M0,0 L60,30 M60,0 L0,30' stroke='%23fff' stroke-width='6'/%3E %3Cpath d='M0,0 L60,30 M60,0 L0,30' clip-path='url(%23t)' stroke='%23cf142b' stroke-width='4'/%3E %3Cpath d='M30,0 v30 M0,15 h60' stroke='%23fff' stroke-width='10'/%3E %3Cpath d='M30,0 v30 M0,15 h60' stroke='%23cf142b' stroke-width='6'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 12 6'%3E %3Ctitle%3EFlag of Slovenia%3C/title%3E %3Crect width='12' fill='%23ed1c24' height='6'/%3E %3Crect width='12' fill='%23005da4' height='4'/%3E %3Crect width='12' fill='%23fff' height='2'/%3E %3Cg transform='translate(2.2238 1) scale(.12937)'%3E %3Csvg width='12' viewBox='-120 -190.223125 240 309.188274' height='15.459'%3E %3Cpath d='m110.26-19.478l9.74-143.75a280.22 280.22 0 0 0 -240 0l9.74 143.75a155.61 155.61 0 0 0 110.26 138.45 155.61 155.61 0 0 0 110.26 -138.45' fill='%23005da4'/%3E %3Cpath d='m-90 0a138.29 138.29 0 0 0 90 100.77 138.29 138.29 0 0 0 90 -100.77l-45-60-18 24-27-54-27 54-18-24-45 60' fill='%23fff'/%3E %3Cg id='wave' fill='%23005da4' transform='scale(5) translate(0 5.1962)'%3E %3Cpath d='m-17.196-2.1962a6 6 0 0 0 8.1962 2.1962 6 6 0 0 1 6 0 6 6 0 0 0 6 0 6 6 0 0 1 6 0 6 6 0 0 0 8.1962 -2.1962v1.732a6 6 0 0 1 -8.1962 2.1962 6 6 0 0 0 -6 0 6 6 0 0 1 -6 0 6 6 0 0 0 -6 0 6 6 0 0 1 -8.1962 -2.1962z'/%3E %3C/g%3E %3Cuse xlink:href='%23wave' transform='translate(0 17.321)'/%3E %3Cg id='s' transform='translate(0,-120) scale(2.25)'%3E %3Cpath stroke-width='.2' d='m0-5l1 3.2679 3.3301-0.7679-2.3301 2.5 2.3301 2.5-3.3301-0.7679-1 3.2679-1-3.2679-3.3301 0.7679 2.3301-2.5-2.3301-2.5 3.3301 0.7679z' fill='%23fd0'/%3E %3C/g%3E %3Cuse xlink:href='%23s' transform='translate(-33.75,-45)'/%3E %3Cuse xlink:href='%23s' transform='translate(33.75,-45)'/%3E %3Cpath d='m-111.58-167.05l9.96 146.99a146.95 146.95 0 0 0 101.62 129.95 146.95 146.95 0 0 0 101.62 -129.95l9.96-146.99a280.22 280.22 0 0 0 8.42 3.82l-9.74 143.75a155.61 155.61 0 0 1 -110.26 138.45 155.61 155.61 0 0 1 -110.26 -138.45l-9.74-143.75a280.22 280.22 0 0 0 8.42 -3.82' fill='%23ed1c24'/%3E %3C/svg%3E %3C/g%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1100 800'%3E %3Crect width='1100' height='800' fill='%23ef2b2d'/%3E %3Crect width='200' height='800' x='300' fill='%23fff'/%3E %3Crect width='1100' height='200' y='300' fill='%23fff'/%3E %3Crect width='100' height='800' x='350' fill='%23002868'/%3E %3Crect width='1100' height='100' y='350' fill='%23002868'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 9 6'%3E %3Ctitle%3EFlag of Slovakia%3C/title%3E %3Crect width='9' height='6' fill='%23ee1c25'/%3E %3Crect width='9' height='4' fill='%230b4ea2'/%3E %3Crect width='9' height='2' fill='%23fff'/%3E %3Cg%3E %3Cpath fill='%23fff' d='M3.16255,4.635c-0.53781-0.25905-1.3071-0.77323-1.3071-1.79033,0-1.01711,0.04863-1.47967,0.04863-1.47967h1.25847,1.2585s0.04864,0.46256,0.04864,1.47967c0,1.0171-0.76929,1.53128-1.30714,1.79033z'/%3E %3Cpath fill='%23ee1c25' d='M3.16255,4.5c-0.4934-0.23766-1.19917-0.70938-1.19917-1.64251,0-0.933128,0.044612-1.35749,0.044612-1.35749h1.15456,1.15459s0.044626,0.424365,0.044626,1.35749c0,0.933128-0.705776,1.40485-1.19921,1.64251z'/%3E %3Cpath fill='%23fff' d='m3.26808,2.61284c0.133599,0.00216,0.394255,0.00739,0.626352-0.070273,0,0-0.00613,0.083055-0.00613,0.179805,0,0.096773,0.00613,0.179822,0.00613,0.179822-0.21289-0.07125-0.4758-0.07273-0.62635-0.07082v0.515391h-0.211033v-0.515391c-0.150545-0.00191-0.41345-0.0004252-0.626352,0.070815,0,0,0.00613-0.083049,0.00613-0.179822,0-0.09675-0.00613-0.179805-0.00613-0.179805,0.2321,0.077665,0.492753,0.072432,0.626352,0.070273v-0.323676c-0.121766-0.00108-0.297234,0.00473-0.49563,0.071126,0,0,0.00613-0.083055,0.00613-0.179822,0-0.096756-0.00613-0.179811-0.00613-0.179811,0.198103,0.066283,0.373356,0.072192,0.495088,0.071137-0.00626-0.20498-0.06597-0.46332-0.06597-0.46332s0.12289,0.00959,0.172016,0.00959c0.049178,0,0.172031-0.00959,0.172031-0.00959s-0.059695,0.258346-0.065964,0.463301c0.121741,0.00106,0.296989-0.00485,0.495086-0.071137,0,0-0.00613,0.083055-0.00613,0.179811,0,0.096767,0.00613,0.179822,0.00613,0.179822-0.198388-0.066392-0.373863-0.072207-0.495627-0.071126v0.323676z'/%3E %3Cpath fill='%230b4ea2' d='m3.1625,3.29094c-0.24847,0-0.381562,0.344688-0.381562,0.344688s-0.073834-0.163438-0.276562-0.163438c-0.137161,0-0.238243,0.12201-0.3025,0.235,0.24954,0.39705,0.64768,0.64207,0.96062,0.79281,0.31299-0.15075,0.71139-0.39571,0.96094-0.79281-0.064256-0.11299-0.165339-0.235-0.3025-0.235-0.202734,0-0.276875,0.163438-0.276875,0.163438s-0.133073-0.344688-0.381562-0.344688z'/%3E %3C/g%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 450 300'%3E %3Crect fill='%230072C6' width='450' height='300'/%3E %3Crect fill='%23FFF' width='450' height='200'/%3E %3Crect fill='%231EB53A' width='450' height='100'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 800 600'%3E %3Cpath fill='%235eb6e4' d='M0 0h800v600H0z'/%3E %3Cpath fill='%23fff' d='M0 0h800v300H0z'/%3E %3Cg fill='none' stroke='%23000' stroke-width='.93'%3E %3Cg fill='%23fff'%3E %3Ccircle cx='459.44' cy='171.23' r='4.04'/%3E %3Ccircle cx='461.69' cy='157.02' r='5.08'/%3E %3Ccircle cx='376.39' cy='141.72' r='3.91'/%3E %3Ccircle cx='338.47' cy='157.02' r='5.08'/%3E %3Ccircle cx='361.67' cy='143.37' r='4.22'/%3E %3Ccircle cx='340.72' cy='171.23' r='4.04'/%3E %3Ccircle cx='346.87' cy='147.12' r='4.88'/%3E %3Ccircle cx='423.77' cy='141.72' r='3.91'/%3E %3Ccircle cx='438.49' cy='143.37' r='4.22'/%3E %3Ccircle cx='453.29' cy='147.12' r='4.89'/%3E %3C/g%3E %3Cg stroke-width='1.09'%3E %3Ccircle cx='459.44' cy='171.23' r='4.46'/%3E %3Ccircle cx='461.69' cy='157.03' r='5.6'/%3E %3Ccircle cx='376.39' cy='141.72' r='4.31'/%3E %3Ccircle cx='338.47' cy='157.03' r='5.6'/%3E %3Ccircle cx='361.67' cy='143.37' r='4.65'/%3E %3Ccircle cx='340.72' cy='171.23' r='4.46'/%3E %3Ccircle cx='346.87' cy='147.12' r='5.39'/%3E %3Ccircle cx='423.77' cy='141.72' r='4.31'/%3E %3Ccircle cx='438.49' cy='143.37' r='4.65'/%3E %3Ccircle cx='453.29' cy='147.12' r='5.39'/%3E %3C/g%3E %3Cg fill='%23000' stroke-linecap='round' stroke-linejoin='round'%3E %3Cpath d='M392.49 132.02c-13.49 15.53-37.16 7.94-47.95 14-18.79 10.52 1.64 35.48 5.5 40.25l20.46-5.34c-7.51-6.01-22.59-16.23-18.05-24.53 4.66-8.5 29.37.13 40.18-18.04 2.28-3.82.53-7.12-.14-6.34z'/%3E %3Cpath fill='%23f1bf31' d='M392.49 132.48c-13.49 15.54-36.4 8.1-47.19 14.15-18.78 10.52 2.43 34.87 6.28 39.64l17.68-5.34c-7.52-6.01-21.8-16.54-17.26-24.83 4.65-8.51 29.82-.04 40.63-18.2 2.28-3.82.53-6.2-.14-5.42z'/%3E %3Cpath stroke-width='.63' d='M393.71 133.68c-14.6 19.71-36.52 9.76-45.94 17.45-10.64 8.7 4.86 25.8 12.34 32.57l1.17-.43c-6.07-5.76-24.06-22.84-12.63-32.07 8.22-6.64 31.33 2.02 45.11-17.05z'/%3E %3Cpath fill='%23d99f31' d='M357.83 171.3c-.36.68-.9 1.86-1.26 3.34-6.24-7.44-10.91-15.14-6-21.5 4.48-5.8 15.46-3.18 26.88-7.2a29.75 29.75 0 0 0 14.75-9.49c-.42 1.14-.86 2.5-1.34 3.88-11.6 14.77-34.75 7.7-39.17 15.76-2.6 4.77 1.1 10.26 6.14 15.22z' stroke='none'/%3E %3Cpath d='M352.11 169.98a5.25 5.25 0 0 0 2.7-1.94c.29.36.6.71.91 1.07a5.77 5.77 0 0 1-1.92 1.75 6.86 6.86 0 0 1-3.23.69c-.36-.48-.7-.96-1.04-1.45.86.09 1.83.1 2.58-.12zm-2.81-5.77a6 6 0 0 0 2.5-.8c.15.34.32.69.5 1.03-.75.44-1.37.7-2.42.92a8.63 8.63 0 0 1-3.12-.01c-.2-.44-.4-.89-.58-1.33.95.18 2.18.34 3.12.19zm1.54-4.81a8.77 8.77 0 0 1-5.5-2.83c.1-.41.23-.82.4-1.22.8 1.01 2.56 2.77 5.18 3-.05.34-.08.7-.08 1.05zm1.8-4.56a8.94 8.94 0 0 1-3.45-3.77c.27-.2.56-.38.86-.55a7.64 7.64 0 0 0 3.4 3.65c-.3.2-.56.43-.8.67zm3.99-6.15c.24 1.4.99 2.6 2.14 3.45l-1.11.26a6.26 6.26 0 0 1-1.94-3.58l.9-.13zm7.1-.62a5.94 5.94 0 0 0 2.09 2.7c.1.1.16.2.18.3l-1.1.13c-1-.84-1.75-1.89-2.11-3.06l.93-.07zm6.92-.69a8.14 8.14 0 0 0 2.68 2.56l-1.28.24a8.9 8.9 0 0 1-2.4-2.66l1-.14zm6.18-1.25c.9.86 2.03 1.5 3.25 1.92l-1.3.46a8.97 8.97 0 0 1-2.95-2.12l1-.26zm6.23-2.4c.83.6 1.93 1 2.9 1.24-.33.23-.66.45-1 .66-1-.31-2.02-.78-2.8-1.46l.9-.44zm4.6-2.9c.66.32 1.43.56 2.18.72l-.73.77c-.79-.21-1.58-.5-2.25-.9l.8-.6z' stroke='none'/%3E %3Cpath fill='none' stroke-width='.6' d='M393.76 134.46c.04.95-.23 1.77-1.13 3.28-10.8 18.17-36.29 9.85-40.94 18.36-4.47 8.17 9.64 18.51 17.24 24.57-1.33.48-2.74.9-4.22 1.26l-1.32.72-1.97.62c-6.07-5.76-24.04-22.69-12.61-31.91 8.22-6.64 31.17 2.17 44.95-16.9z'/%3E %3Cpath d='M407.52 132.02c13.49 15.53 37.16 7.94 47.95 14 18.79 10.52-1.64 35.48-5.49 40.25l-20.47-5.34c7.52-6.01 22.59-16.23 18.05-24.53-4.65-8.5-29.37.13-40.18-18.04-2.28-3.82-.53-7.12.14-6.34z'/%3E %3Cpath fill='%23f1bf31' d='M407.67 132.48c13.48 15.54 36.4 8.1 47.19 14.15 18.78 10.52-2.43 34.87-6.28 39.64l-17.68-5.34c7.52-6.01 21.8-16.54 17.26-24.83-4.65-8.51-29.83-.04-40.63-18.2-2.28-3.82-.54-6.2.14-5.42z'/%3E %3Cpath stroke-width='.63' d='M438.88 183.27c6.07-5.76 24.06-22.84 12.63-32.07-8.22-6.64-31.33 2.02-45.11-17.05l.05-.47c14.6 19.71 36.52 9.76 45.94 17.45 10.63 8.68-4.95 25.74-12.46 32.53z'/%3E %3Cpath fill='%23d99f31' d='M442.33 171.3c.36.68.9 1.86 1.25 3.34 6.25-7.44 10.92-15.14 6-21.5-4.47-5.8-15.45-3.18-26.88-7.2a29.75 29.75 0 0 1-14.74-9.49c.42 1.13.86 2.5 1.34 3.88 11.6 14.77 34.76 7.7 39.17 15.76 2.6 4.77-1.1 10.26-6.14 15.22z' stroke='none'/%3E %3Cpath d='M448.05 170.6c-1.5-.37-2.25-1.03-3.23-1.93-.3.35-.6.69-.92 1.02a8.3 8.3 0 0 0 2.46 1.8c.92.4 1.9.56 2.82.6.34-.45.68-.9 1-1.36a7.4 7.4 0 0 1-2.13-.13zm2.81-6.4a5.99 5.99 0 0 1-2.5-.8c-.15.35-.32.7-.51 1.04.76.44 1.38.7 2.43.92 1.05.22 2.15.15 3.12-.01l.58-1.34c-.95.19-2.18.35-3.12.2zm-1.54-4.8a8.77 8.77 0 0 0 5.5-2.83 8.6 8.6 0 0 0-.4-1.22c-.8 1.01-2.57 2.77-5.18 3 .05.34.08.7.08 1.04zm-1.8-4.56a8.94 8.94 0 0 0 3.45-3.77c-.27-.2-.56-.38-.86-.55a7.64 7.64 0 0 1-3.4 3.65c.3.2.56.43.8.67zm-3.99-6.15c-.24 1.4-.99 2.6-2.14 3.45l1.11.26a6.26 6.26 0 0 0 1.93-3.58l-.9-.13zm-7.1-.62a5.93 5.93 0 0 1-2.09 2.7.44.44 0 0 0-.18.3l1.1.13c1-.84 1.75-1.89 2.11-3.06l-.94-.07zm-6.92-.69a8.14 8.14 0 0 1-2.68 2.55l1.27.25a8.9 8.9 0 0 0 2.4-2.67l-.99-.13zm-6.19-1.26c-.9.87-2.03 1.51-3.24 1.92.43.17.87.32 1.3.47a8.96 8.96 0 0 0 2.95-2.12c-.34-.08-.67-.17-1-.27zm-6.23-2.39c-.82.6-1.92 1-2.9 1.24.34.23.67.45 1.01.66 1-.32 2.02-.79 2.8-1.46l-.9-.44zm-4.59-2.9a9.3 9.3 0 0 1-2.18.72c.24.26.48.52.73.76a8.8 8.8 0 0 0 2.25-.9c-.27-.18-.53-.38-.8-.59z' stroke='none'/%3E %3Cpath fill='none' stroke-width='.6' d='M406.4 134.46c-.04.95.23 1.77 1.13 3.28 10.8 18.17 36.29 9.85 40.94 18.36 4.47 8.17-9.64 18.51-17.24 24.57 1.33.48 2.74.9 4.22 1.26l1.32.72 1.97.62c6.07-5.76 24.04-22.69 12.61-31.91-8.22-6.64-31.17 2.17-44.95-16.9z'/%3E %3C/g%3E %3Cpath fill='%23000' d='M400.08 166.7h-6.84s.8-6.52-.1-10.94c-.75-3.58-3.6-7.68-3.6-10.68s3.26-11.46 3.26-11.46h14.56s3.1 8.45 3.1 11.46c0 3-2.7 7.1-3.43 10.68-.92 4.42-.1 10.94-.1 10.94h-6.85z'/%3E %3Cpath fill='%23f1bf31' d='M400.08 166.7h-6.84s1.05-6.51.2-10.94c-.69-3.6-3.12-6.4-3.45-10.06-.45-5.16 4.05-12.08 4.05-12.08h12.08s4.35 6.92 3.89 12.08c-.32 3.66-2.6 6.45-3.3 10.06-.84 4.43.21 10.94.21 10.94h-6.84z' stroke='none'/%3E %3Cpath fill='%23d99f31' d='M389.98 144.4c.43-.14.88-.25 1.32-.25 1.5 0 2.09.98 2.09.98s3.93-.9 6.69-.9c2.76 0 6.69.9 6.69.9s.6-.98 2.1-.98c.38 0 .77.08 1.16.2.02.46.02.91-.02 1.35-.32 3.66-2.6 6.45-3.3 10.06a29.12 29.12 0 0 0-.22 7.05l-6.41 3.05-6.42-3.05c.16-2.17.2-4.86-.22-7.05-.69-3.6-3.12-6.4-3.45-10.06a9.12 9.12 0 0 1-.01-1.3z' stroke='none'/%3E %3Cpath fill='%23000' d='M407.1 146.81c-.3.95-.79 2.46-1.2 3.98a21.98 21.98 0 0 0-.82 4.04c-.19 3.87.47 8.07 1.24 11.87h-.27c-1.1-3.32-2.35-8.43-2.3-11.87.03-2.1 1.35-6.15 2.03-8.1.98-2.8.78-4.7.09-6.57-.7-1.88-1.87-3.75-2.84-6.5v-.04h1.3c.99 2.7 2.1 4.59 2.76 6.5a9.8 9.8 0 0 1 0 6.7zm-13.26 19.89c.78-3.83 1.42-7.97 1.25-11.86-.05-1-.4-2.53-.82-4.05-.42-1.52-.9-3.03-1.2-3.97-.88-2.81-.18-6.14.75-8.75.8-2.27 1.77-4.02 2.02-4.45h1.34c-.4.68-4.64 7.83-2.8 13.12.68 1.94 2 6 2.04 8.09.04 3.43-1.22 8.55-2.3 11.87h-.28z' stroke='none'/%3E %3Cpath d='M400.08 166.7h-6.84s1.05-6.51.2-10.94c-.69-3.6-3.12-6.4-3.45-10.06-.45-5.16 4.05-12.08 4.05-12.08h12.08s4.35 6.92 3.89 12.08c-.32 3.66-2.6 6.45-3.3 10.06-.84 4.43.21 10.94.21 10.94h-6.84z'/%3E %3Cellipse fill='%23fff' stroke-width='.92' cx='400' cy='140.64' rx='3.41' ry='2.51'/%3E %3Cellipse stroke-width='1.03' cx='400' cy='140.49' rx='3.83' ry='2.73'/%3E %3Ccircle fill='%23fff' stroke-width='.92' cx='400' cy='148.23' r='3.68'/%3E %3Ccircle stroke-width='1.03' cx='400' cy='148.23' r='4.14'/%3E %3Cg%3E %3Cpath stroke-width='.9' d='M360.41 204.28s-1.05-1.06-1.37-1.93c-.26-.69-.28-1.86-.28-1.86l-3.79-6.07 8.5-8.09 16.18-4.64 20.4-1.46h.03l20.4 1.46 16.17 4.64 8.5 8.1-3.78 6.06s-.02 1.17-.28 1.86a7.2 7.2 0 0 1-1.38 1.93l-18.97-6.41-20.66-.93-20.7.93-18.97 6.41z'/%3E %3Cpath fill='%23f1bf31' d='M360.87 203.6s-.75-.95-1.04-1.66c-.42-1.02-.37-2.81-.37-2.81l-4.49-4.7 8.5-8.1 16.18-4.64 20.43-1.45 20.43 1.45 16.17 4.64 8.5 8.1-4.48 4.7s.05 1.79-.37 2.81c-.28.71-1.04 1.66-1.04 1.66l-18.52-5.73-20.69-.93-20.7.93-18.5 5.73z'/%3E %3Cpath fill='%23000' d='M358.83 207.29a41.17 12.78 0 1 1 82.34 0 41.17 10.82 0 1 1-82.34 0z'/%3E %3Cpath fill='%23f1bf31' d='M360.2 207.29a39.8 12.31 0 1 1 79.6 0 39.8 10.52 0 1 1-79.6 0z'/%3E %3Cellipse fill='%23d99f31' cx='400' cy='208.41' rx='36.78' ry='9.39'/%3E %3Cpath stroke-width='1.09' d='M436.52 209.68c-6.89 2.94-20.43 4.52-36.47 4.52s-29.58-1.58-36.47-4.52'/%3E %3Cpath stroke-width='1.01' d='M435.9 206.26c-7.05 2.69-20.27 4.03-35.85 4.03-15.58 0-28.8-1.34-35.86-4.03'/%3E %3Cpath d='M432.46 203.88c-7.5 2.18-19.1 3.4-32.41 3.4-13.32 0-24.91-1.22-32.4-3.4'/%3E %3Cpath d='M427.48 202.07c-7.23 1.43-16.78 2.21-27.43 2.21s-20.2-.78-27.43-2.21M419.1 200.32c-5.67.62-12.13.95-19.05.95s-13.38-.33-19.04-.95'/%3E %3Cellipse cx='400' cy='208.41' rx='36.48' ry='9.09'/%3E %3Cpath fill='%23000' stroke-linejoin='round' d='M354.76 192.76c-3.61-4.8-6.83-8.07-14.65-10.83a13.45 13.45 0 0 1 4.8-2.1c2.97-.73 6-.33 7.96.69-1.55-5.55 1.43-11.1 1.43-11.1s4.82-.27 9.7 3.65c.16-6.73 2.13-9.92 2.13-9.92s5.07.24 10.26 5.4c.99-6.96 4.74-10.74 4.74-10.74s6.23 1.95 9.8 8.53c2.37-9.53 9.15-13.26 9.15-13.26s6.78 3.73 9.16 13.26c3.56-6.58 9.79-8.53 9.79-8.53s3.73 3.64 4.74 10.74c5.19-5.16 10.26-5.4 10.26-5.4s1.97 3.2 2.13 9.92c4.88-3.92 10.18-2.46 10.18-2.46s2.5 4.36.95 9.91c1.95-1.02 5-1.42 7.97-.69 1.82.45 3.72 1.23 4.8 2.1-7.01 2.54-11.2 6.03-14.81 10.83-3.38-6.9-21.46-14.5-45.17-14.5s-41.95 7.6-45.32 14.5z'/%3E %3Cpath fill='%23f1bf31' stroke-linejoin='round' d='M354.76 191.99a25.8 25.8 0 0 0-12.17-10.18c1.07-.86 2.96-1.19 4.95-1.33 2.35-.16 4.3.17 5.95.95-1.55-5.55.97-11.23.97-11.23s4.96.02 9.85 3.94c.16-6.72 2.29-10.06 2.29-10.06s4.75.53 9.94 5.68c1.11-6.94 4.75-10.86 4.75-10.86s6.23 1.93 9.79 8.5c2.37-9.52 9-12.92 9-12.92s6.63 3.4 9 12.92c3.56-6.57 9.8-8.5 9.8-8.5s3.74 3.5 4.74 10.86c5.19-5.15 9.94-5.68 9.94-5.68s2.13 3.33 2.3 10.06c4.88-3.92 10.46-2.86 10.46-2.86s1.9 4.6.35 10.15c1.65-.78 3.6-1.11 5.94-.95 2 .14 3.89.47 4.96 1.33A25.8 25.8 0 0 0 445.4 192c-3.38-6.9-21.6-13.86-45.32-13.86-23.71 0-41.94 6.95-45.32 13.86z'/%3E %3Cpath fill='%23000' d='M353 194.16c0-8.76 20.9-16.19 47.05-16.19s46.28 7.73 46.28 15.41c0 1.84-1.63 3.43-3.77 4.77.2-.58.31-1.17.31-1.76 0-7.68-16.67-13.9-42.82-13.9s-42.82 6.22-42.82 13.9c0 .6.1 1.18.31 1.76-2.14-1.34-4.54-2.15-4.54-4z'/%3E %3Cpath fill='%23f1bf31' stroke-width='.9' d='M354.22 193.38c0-6.64 19.68-14.94 45.83-14.94s45.83 8.3 45.83 14.94c0 1.84-2.05 2.03-2.23 1.46-2.2-6.73-17.45-12.67-43.6-12.67-26.15 0-41.4 5.94-43.6 12.67-.18.57-2.23.38-2.23-1.46z'/%3E %3Cpath fill='%23000' stroke-width='.45' stroke-linejoin='round' d='M399.58 172.1l.46-7.57c0-.06.07-.83.08-.78l.43 8.34c.14 2.34.3 6.01.3 6.01 0 .03-.02.04-.05.04l-1.5.01a.04.04 0 0 1-.04-.04s.17-3.67.32-6.02zm38.45 13.54c.41-.8.92-1.84 1.3-2.65.74-1.66 2.1-4.3 2.1-4.3.02-.06-.04-.08-.07-.04 0 0-1.7 2.4-2.65 3.9-.5.78-1.19 1.78-1.73 2.56zm-12.8-4.64a76.5 76.5 0 0 1 2.12-4.42c.98-1.81 2.76-4.5 2.76-4.5.03-.05.1-.02.07.03 0 0-1.28 2.73-2.01 4.51-.72 1.74-1.72 4.51-1.72 4.51l-.66.01zm-11.6-2.09a103.3 103.3 0 0 1 3.1-10.59.04.04 0 0 1 .07.02 300.78 300.78 0 0 0-1.83 10.74zm-39.32 2.25h-.57c-.04-.03-1.03-2.8-1.75-4.54-.73-1.78-2.01-4.51-2.01-4.51-.03-.05.03-.08.06-.04 0 0 1.79 2.7 2.77 4.51.83 1.53 1.9 3.9 2.13 4.42zm10.88-2.08l-.8-4.95c-.38-2.26-.61-3.53-1.03-5.79-.01-.05.05-.07.07-.02.75 2.18 1.15 3.42 1.79 5.64.46 1.58 1.03 3.83 1.32 4.95zm-23.18 6.62c-.41-.82-.94-1.88-1.32-2.71-.75-1.66-2.1-4.3-2.1-4.3-.03-.06.04-.08.06-.04 0 0 1.7 2.4 2.65 3.9.52.8 1.22 1.83 1.76 2.62z'/%3E %3C/g%3E %3Cg stroke-width='.78' stroke-linecap='round' stroke-linejoin='round'%3E %3Cpath fill='%23d99f31' stroke-width='.72' d='M361.6 197.42c-.33-1.9-1.98-3.44-3.25-3.21-1.27.22-3.07 2.12-2.74 4.02.34 1.9 2.72 3.3 4 3.07 1.26-.22 2.33-1.97 2-3.88z'/%3E %3Cpath fill='%23f1bf31' d='M359.49 195.08a2.39 2.39 0 0 1-3.03 3.62 2.87 2.87 0 0 1-.14-.53c-.3-1.65.97-3.14 2.07-3.34l.24-.02c.3 0 .59.1.86.27z' stroke='none'/%3E %3Cpath d='M360.9 197.47c-.29-1.65-1.41-2.83-2.51-2.64-1.1.2-2.36 1.69-2.08 3.34.3 1.65 2.06 2.85 3.16 2.65 1.1-.19 1.72-1.7 1.43-3.35z'/%3E %3Cpath fill='%23d99f31' d='M375.4 192.85l-.6-3.59-2.41-1.21s-2.6.7-4.21 1.27c-1.67.6-4.21 1.74-4.21 1.74l-.6 1.05.75 4.05 1.35 1.2 9.02-2.7.91-1.81z'/%3E %3Cpath fill='%23f1bf31' d='M365.46 195.44l7.23-2.29.45-.74-.62-3.76-.26-.25-8.03 2.94.61 3.4z' stroke='none'/%3E %3Cpath stroke-width='1.09' d='M365.46 195.44l7.23-2.29.45-.74-.47-3m2.55 3.44l-2.08-.45'/%3E %3Cpath fill='%23f1bf31' d='M385.72 189a1.5 1.5 0 1 1 3-.26 1.5 1.5 0 0 1-3 .26zm-3.48 3.33a1.5 1.5 0 1 1 3-.26 1.5 1.5 0 0 1-3 .26zm-3.55-2.67a1.5 1.5 0 0 1 1.36-1.63c.83-.07 1.41.54 1.48 1.37.07.82-.39 1.55-1.21 1.63a1.5 1.5 0 0 1-1.63-1.37zm3.03-3.33a1.5 1.5 0 1 1 3-.25 1.5 1.5 0 0 1-3 .25z' stroke='none'/%3E %3Cpath fill='%23d99f31' d='M385.81 189.4a1.5 1.5 0 0 1 2.82 0 1.5 1.5 0 0 1-2.82 0zm-4-2.67a1.5 1.5 0 0 0 2.81 0 1.5 1.5 0 0 0-2.81 0zm-3.03 3.32a1.5 1.5 0 0 0 1.54.98 1.3 1.3 0 0 0 1.14-.95c-.18-.63-.7-1.06-1.4-1a1.5 1.5 0 0 0-1.28.97zm3.55 2.67a1.5 1.5 0 0 0 2.82 0 1.5 1.5 0 0 0-2.82 0z' stroke='none'/%3E %3Cpath stroke-width='.93' d='M385.72 189a1.5 1.5 0 1 1 3-.26 1.5 1.5 0 0 1-3 .26zm-3.48 3.33a1.5 1.5 0 1 1 3-.26 1.5 1.5 0 0 1-3 .26zm-3.55-2.67a1.5 1.5 0 0 1 1.36-1.63c.83-.07 1.41.54 1.48 1.37.07.82-.39 1.55-1.21 1.63a1.5 1.5 0 0 1-1.63-1.37zm3.03-3.33a1.5 1.5 0 1 1 3-.25 1.5 1.5 0 0 1-3 .25z'/%3E %3Cpath fill='%23d99f31' d='M392.85 190.4v-3.9l2.27-2.11h9.92l2.27 2.11v3.9l-2.27 1.96h-9.92z' stroke='none'/%3E %3Cpath fill='%23f1bf31' d='M405.24 184.85l-.8.81v3.72l-.63.62-7.51-.05-.63-.63v-3.56l-.67-.91z' stroke='none'/%3E %3Cpath d='M392.85 190.4v-3.9l2.27-2.11h9.92l2.27 2.11v3.9l-2.27 1.96h-9.92z'/%3E %3Cpath stroke-width='1.09' d='M393.46 190.23l2.21-.85m11 .91l-2.23-.91m-9.05 2.72l.9-2.1m8.42 2.1l-.9-2.1m.63-4.34v3.72l-.63.62-7.51-.05-.63-.63v-3.71'/%3E %3Cpath fill='%23f1bf31' d='M414.37 189a1.5 1.5 0 1 0-2.99-.26 1.5 1.5 0 0 0 3 .26zm3.49 3.33a1.5 1.5 0 1 0-3-.26 1.5 1.5 0 0 0 3 .26zm3.55-2.67a1.5 1.5 0 0 0-1.36-1.63c-.83-.07-1.41.54-1.48 1.37-.08.82.39 1.55 1.21 1.63a1.5 1.5 0 0 0 1.63-1.37zm-3.03-3.33a1.5 1.5 0 1 0-3-.25 1.5 1.5 0 0 0 3 .25z' stroke='none'/%3E %3Cpath fill='%23d99f31' d='M414.29 189.4a1.5 1.5 0 0 0-2.82 0 1.5 1.5 0 0 0 2.81 0zm1.18-2.67a1.5 1.5 0 0 0 2.82 0 1.5 1.5 0 0 0-2.82 0zm3.17 3.35c.15.51.56.9 1.14.95a1.5 1.5 0 0 0 1.54-.98 1.5 1.5 0 0 0-1.28-.97c-.7-.06-1.21.37-1.4 1zm-3.7 2.64a1.5 1.5 0 0 0 2.83 0 1.5 1.5 0 0 0-2.82 0z' stroke='none'/%3E %3Cpath stroke-width='.93' d='M414.37 189a1.5 1.5 0 1 0-2.99-.26 1.5 1.5 0 0 0 3 .26zm3.49 3.33a1.5 1.5 0 1 0-3-.26 1.5 1.5 0 0 0 3 .26zm3.55-2.67a1.5 1.5 0 0 0-1.36-1.63c-.83-.07-1.41.54-1.48 1.37-.08.82.39 1.55 1.21 1.63a1.5 1.5 0 0 0 1.63-1.37zm-3.03-3.33a1.5 1.5 0 1 0-3-.25 1.5 1.5 0 0 0 3 .25z'/%3E %3Cpath fill='%23d99f31' d='M424.7 192.85l.6-3.59 2.41-1.21s2.6.7 4.2 1.27c1.68.6 4.22 1.74 4.22 1.74l.6 1.05-.75 4.05-1.35 1.2-9.02-2.7-.91-1.81z'/%3E %3Cpath fill='%23f1bf31' d='M434.63 195.44l-7.22-2.29-.45-.74.63-3.76.25-.25 8.03 2.94-.61 3.4z' stroke='none'/%3E %3Cpath stroke-width='1.09' d='M434.63 195.44l-7.22-2.29-.45-.74.47-3m-1.88 4.95l1.86-1.2'/%3E %3Cpath fill='%23d99f31' stroke-width='.72' d='M438.4 197.42c.34-1.9 1.99-3.44 3.26-3.21 1.27.22 3.07 2.12 2.74 4.02-.34 1.9-2.72 3.3-4 3.07-1.26-.22-2.33-1.97-2-3.88z'/%3E %3Cpath fill='%23f1bf31' d='M439.95 196.63c0-.6.22-1.13.57-1.55a1.62 1.62 0 0 1 1.1-.25c1.1.2 2.36 1.69 2.07 3.34-.03.18-.08.36-.14.53a2.39 2.39 0 0 1-3.6-2.07z' stroke='none'/%3E %3Cpath d='M439.1 197.47c.3-1.65 1.42-2.83 2.52-2.64 1.1.2 2.37 1.69 2.08 3.34-.3 1.65-2.06 2.85-3.16 2.65-1.1-.19-1.72-1.7-1.43-3.35z'/%3E %3Cpath stroke-width='.83' d='M424.28 192.88l.65-3.9 2.56-1.27s2.78.76 4.51 1.37c1.79.64 4.5 1.85 4.5 1.85l.65 1.13-.8 4.35-1.45 1.29-9.66-2.9-.96-1.92zm-31.9-6.53l2.39-2.25h10.62l2.4 2.25v4.2l-2.4 2.09h-10.62l-2.4-2.08v-4.21zm-16.56 6.53l-.65-3.9-2.56-1.27s-2.78.76-4.51 1.37c-1.8.64-4.5 1.85-4.5 1.85l-.65 1.13.8 4.35 1.45 1.29 9.66-2.9.96-1.92z'/%3E %3C/g%3E %3Cg stroke-linejoin='round' stroke-linecap='round'%3E %3Cpath fill='%23d99f31' stroke-width='.95' d='M408.13 95.85c1.77 0 3.07 1.58 3.07 3.36 0 1.78-1.3 3.53-3.07 3.53-2.32 0-5.69-2.75-5.57-.56l.05 1.1 1.23 10.15c3.03.68-10.55.68-7.53 0l1.24-10.2.05-1.05c.11-2.18-3.34.56-5.57.56-1.78 0-3.07-1.75-3.07-3.53 0-1.78 1.3-3.36 3.07-3.36 1.75 0 3.68 1.63 4.92.86 1.95-1.2-.4-3.9-.4-5.73 0-1.77 1.75-3.22 3.53-3.22 1.78 0 3.52 1.45 3.52 3.22 0 1.83-2.36 4.45-.4 5.73 1.18.77 3.12-.86 4.93-.86z'/%3E %3Cpath fill='%23f1bf31' d='M397.49 91.5c-.2-.24-.36-.51-.46-.8a3.3 3.3 0 0 1 3.05-2.37c.61 0 1.2.2 1.7.54-.1.36-.92.43-1.68 1.08-1.1.91-1.69 2.66-2.61 1.56zm.5 5.1c.15.2.22.41.22.64 0 1.1-1.9 1.98-4.24 1.98-1.96 0-3.62-.62-4.1-1.47a3.25 3.25 0 0 1 2.7-1.47c1.63 0 3.87 1.39 5.03.67.16-.1.3-.22.4-.35zm3.27.17c0-.51.25-1 .67-1.4-.1.63.02 1.18.64 1.58 1.1.72 3.33-.67 5.03-.67 1.07 0 2.09.57 2.66 1.43-.65 1.04-2.36 1.78-4.36 1.78-2.56 0-4.64-1.22-4.64-2.72z' stroke='none'/%3E %3Cpath d='M407.6 96.28c1.65 0 3.15 1.35 3.15 3.01 0 1.66-1.5 3.02-3.15 3.02s-5.74-2.9-5.64-.7l.05 1.19.7 9.78c2.82.64-8.08.64-5.26 0l.7-9.82.05-1.14c.1-2.21-4.1.69-5.64.69-1.66 0-3.15-1.36-3.15-3.02s1.5-3.01 3.15-3.01c1.64 0 3.88 1.39 5.04.68 1.82-1.13-.69-3.78-.69-5.48 0-1.65 1.5-3.15 3.17-3.15 1.66 0 3.17 1.5 3.17 3.15 0 1.7-2.52 4.28-.68 5.48 1.1.7 3.33-.68 5.03-.68z'/%3E %3Ccircle fill='%23f1f1f2' stroke-width='1.7' cx='400' cy='116.29' r='7.9'/%3E %3Cpath fill='%23000' d='M401.46 121.28a7.7 7.7 0 0 0 1.36-2.29c.18-.57.77-.3.64.19a7.97 7.97 0 0 1-1.25 2.45zm-8.7-4.65l.48-.4c.18-.16.4-.31.66-.46.33-.22.1-.74-.3-.55-.44.21-.79.43-1.02.59zm-.05 1.17l.42.74c.57-.61 1.54-1.5 1.7-1.65.35-.33-.11-.73-.42-.5a13.95 13.95 0 0 0-1.7 1.41zm.6 1.76l.52.6a23.2 23.2 0 0 0 2.46-2.27c.34-.37-.05-.88-.46-.5-.2.2-1.77 1.6-2.5 2.17h-.02zm10.78 1.34c.39-.44.8-1.04.94-1.74.05-.25.23-.36.4-.33.17.04.3.22.26.45a4.3 4.3 0 0 1-1 2.04zm-6.05.77a23.92 23.92 0 0 0 2.64-3.57c.11-.18.31-.22.46-.15.15.07.23.26.12.48-.46.93-1.07 1.9-1.62 2.6-.54.68-.95 1.16-.95 1.16zm-2.24-1.38a24.5 24.5 0 0 0 2.06-2.12c.27-.34.88-.08.53.43-.44.65-1.12 1.46-1.76 2.04z' stroke='none'/%3E %3Cpath fill='%23d99f31' d='M406.13 133.63h-12.09c-1.02 1.72-4.25 2.9-6.9 1.52-1.88-.99-2.26-3.22-2.26-3.22s5.06.19 5.09-4.29c0-4.54 2.6-7.5 6.35-7.06a6.56 6.56 0 0 1 3.76 1.94 6.57 6.57 0 0 1 3.76-1.94c3.75-.44 6.35 2.52 6.35 7.02 0 4.52 5.09 4.34 5.09 4.34s-.39 2.22-2.26 3.2c-2.66 1.4-5.91.2-6.88-1.51z'/%3E %3Cpath fill='%23d99f31' d='M406.14 133.62h-.42c-1.12 1.04-2.88 2.1-5.64 2.7-2.76-.6-4.52-1.66-5.64-2.7h-.4s-4.24 3.01-7.2.76c-1.1-.84-1.34-1.98-1.34-1.98s5.09-.28 5.09-4.8c0-4.5 2.44-6.4 5.73-6.4 1.44 0 2.75.71 3.76 1.63a5.7 5.7 0 0 1 3.76-1.63c3.29 0 5.73 1.9 5.73 6.4 0 4.52 5.09 4.8 5.09 4.8s-.24 1.14-1.33 1.98c-2.98 2.25-7.2-.76-7.2-.76z' stroke='none'/%3E %3Cpath stroke='%23f1bf31' stroke-width='.9' d='M391.16 125.03c-.26.64.16 2.87.16 2.87s.14 2.02-1.45 3.55c-1.11 1.08-3.65 1.55-3.65 1.55m22.78-7.96c.27.63-.15 2.86-.15 2.86s-.14 2.02 1.45 3.55c1.1 1.08 3.64 1.55 3.64 1.55'/%3E %3Cpath fill='%23f1bf31' d='M399.98 135.87c-6.3-1.43-7.11-5.33-6.94-5.29.42.1 1.87 2.95 7.04 4.39 5.17-1.44 6.62-4.29 7.03-4.39.18-.04-.64 3.86-6.93 5.29h-.2zm-7.73-11.12c0-1.53 2.52-2.8 5.93-3.15.7.3 1.35.73 1.9 1.23.55-.5 1.2-.94 1.9-1.23 3.4.35 5.91 1.63 5.91 3.15 0 3.6-4.12 5.35-7.82 5.35s-7.82-1.74-7.82-5.35z' stroke='none'/%3E %3Cpath d='M406.14 133.62h-.42c-1.12 1.04-2.88 2.1-5.64 2.7-2.76-.6-4.52-1.66-5.64-2.7h-.4s-4.24 3.01-7.2.76c-1.1-.84-1.34-1.98-1.34-1.98s5.09-.28 5.09-4.8c0-4.5 2.44-6.4 5.73-6.4 1.44 0 2.75.71 3.76 1.63a5.7 5.7 0 0 1 3.76-1.63c3.29 0 5.73 1.9 5.73 6.4 0 4.52 5.09 4.8 5.09 4.8s-.24 1.14-1.33 1.98c-2.98 2.25-7.2-.76-7.2-.76z'/%3E %3Cpath fill='%23000' d='M407.63 130.62s-.76 5.05-7.55 6.55c-6.8-1.5-7.55-6.55-7.55-6.55s.75 4.2 7.55 5.71c6.8-1.5 7.55-5.71 7.55-5.71z'/%3E %3C/g%3E %3C/g%3E %3Cg stroke-width='.93' stroke-linejoin='round' stroke-linecap='round'%3E %3Cpath fill='%23a0cfeb' d='M398.8 227.5c13.53-.25 71.81-10.02 71.81 70.92 0 77.3-70.56 108.04-70.56 108.04s-70.56-29.78-70.56-113.9c0-75.08 69.3-65.07 69.3-65.07z'/%3E %3Cpath fill='%2394bb79' d='M421.68 348.39a28.54 28.54 0 0 1 13.95-3.62c8.24 0 15.66 3.47 20.9 9.03-20.6 37.02-56.48 52.66-56.48 52.66s-34.96-14.75-55.66-52.83a28.59 28.59 0 0 1 20.73-8.86c5.67 0 10.97 1.65 15.42 4.5a28.59 28.59 0 0 1 21-9.15c7.85 0 14.96 3.15 20.14 8.27z'/%3E %3Cpath fill='%23658d5c' d='M433.97 345.16c3.55.41 9.77 3.76 12.78 8.27-2.34 3.86-6.83 10-9.3 13.37-5.5-8.06-16.89-18.86-16.1-18.08.12.1.6-.28.73-.36a52.1 52.1 0 0 1 3.13-1.64 28.48 28.48 0 0 1 6.35-1.67c.76-.02 1.56.01 2.4.11zm-24.18 50.77c-4.5 2.37-8 3.9-9.74 4.63-1.75-.73-5.25-2.26-9.74-4.63-8.7-7.05-26.64-23.5-39.27-47.43a28.09 28.09 0 0 1 13.77-3.58c.4 0 2.1.5 3.34 1.08 7.94 3.73 17.76 14.43 14.14 16.48-2.66 1.5-10.25-.96-10.65 1.98-.15 1.11 14.1 8.94 22.19 15.83 6.63 5.65 17 14.8 15.96 15.64zm17.3-7.03c-9.07-8.9-29.45-27-46.5-39.68a28.58 28.58 0 0 1 18.57-9l.39.05c9.84 1.4 18.76 11.96 15.14 14-2.66 1.5-10.26-.95-10.66 1.99-.13.98 10.2 7.22 16.24 12.41 5.93 5.1 9.82 8.77 14.22 13.58-2.5 2.4-4.98 4.62-7.4 6.65z'/%3E %3Cpath d='M422.07 347.94c1.89 1.78 2.7 3.26 2.72 3.28.18.3-.03.99-.57.48 0 0-.75-.71-2.95-2.86-2.96-2.9-8.1-6.55-12.34-7.26-.4-.07-.58-.27-.53-.57a.6.6 0 0 1 .7-.5c.09 0 6.35 1.18 12.97 7.43zm-34.87 5.56c.2.17.24.41.14.6-.12.18-.36.22-.56.07-3.59-2.55-5.34-3.61-7.42-4.92-.16-.1-.27-.27-.15-.46.08-.12.25-.2.41-.24.33-.1.82-.11 1.14.08a58.08 58.08 0 0 1 6.44 4.87z'/%3E %3Cpath fill='none' stroke='%23000' stroke-width='1.24' d='M421.68 348.39c4.13-2.3 8.89-4.09 13.95-4.09 8.28 0 15.74 3.64 20.97 9.37m-112.31-.23a28.28 28.28 0 0 1 20.83-9.3c5.68 0 10.97 2.28 15.42 5.13 5.24-5.63 12.7-9.77 21-9.77 7.85 0 14.96 3.77 20.14 8.89'/%3E %3Cpath fill='none' stroke='%234c819a' stroke-width='.78' d='M367.91 230.52h66.97m-75.92 3.71h84.13m-90.26 3.72h95.8m-100.45 3.71h104.64m-108.33 3.71h111.64m-114.66 3.71h117.38m-119.86 3.72h122.1m-124.17 3.7h126.05m-127.75 3.72h129.33m-130.75 3.72h132.08m-133.25 3.7h134.36m-135.3 3.72H467.9m-50.24 3.71h51m-137.72 0h51.35m51.99 3.71h35m-138.92 0h35.44m74.94 3.72h29.02m-139.83 0h29.24m87.87 3.71h23.08m-140.45 0h22.99m100.6 3.71h17.12m-140.86 0h17.1m111.11 3.71h12.8m-141.03 0h13.03m119.3 3.72h8.77m-141.03 0h8.49'/%3E %3Cg fill='none'%3E %3Cpath fill='%23000' d='M356.65 300.4l-.01-7.23 7.75-3.02 7.75 2.1.01 8.15z'/%3E %3Cpath fill='%23fff' d='M373.24 333.22l3.4 13.95a28.59 28.59 0 0 0-11.52-2.4l-.73-57.57 3.1.9v6.05l3.87 1v-6l5.27 1.38v9.85l-3.4 5.03v27.81z'/%3E %3Cpath fill='%23bdbfc1' d='M364.39 332.15V287.2l-3.1 1.35v5.96l-3.88 1.55v-6l-5.27 2.25v9.53l3.79 4.54.09 27.4-3.88 14.08a28.53 28.53 0 0 1 12.25-3.1v-12.62z'/%3E %3Cpath stroke='%23000' stroke-width='1.09' d='M364.25 332.04l-8.23 1.74m-1.74 8.67l10.05-2.12 10.86 1.17m-11.22-5.23l-8.87 1.81m17.65-24.68l-8.36-1.74-8.49 2.59m16.85 3.1l-8.36-1.6-8.49 2.45m0-7.86l8.49-2.74 8.36 1.77m-16.85 12.72l8.49-2.26 8.36 1.49m-16.77 4.66l8.4-2.08 8.45 1.39m-16.85 4.6l8.4-1.9 8.53 1.28m-3.1-24.42v3.84m-3.1-.58v3.91m3.1.83v3.92m-7.9-4.28v3.9m0 4.12v3.91m-3.72 1.36v3.6m0-19.41v3.6m3.72-9.1v3.91m2.5-10.98l12.22 2.98m-12.23-2.98l-12.26 4.45'/%3E %3Cpath stroke='%23000' stroke-width='1.24' d='M364.39 344.78V287.2'/%3E %3Cpath fill='%23000' d='M370.59 334.68l-3.73-.52v-11.78c0-1.45.89-2.33 1.68-2.33 1.4 0 2.05 1.58 2.05 2.95z'/%3E %3Cpath stroke='%23000' d='M373.24 333.23l3.4 13.94a28.59 28.59 0 0 0-11.52-2.4c-4.67 0-9.08 1.11-12.98 3.1l3.88-14.08-.1-27.4-3.78-4.54v-9.53l5.27-2.24v5.99l3.88-1.55v-5.96l3.1-1.36 3.1.9v6.05l3.87 1v-6l5.27 1.39v9.84l-3.4 5.03v27.81zm3.1 13.42a29.68 29.68 0 0 0-11.22-2.2c-4.48 0-8.87 1.02-12.65 2.83l3.85-13.41-.08-27.48a.98.98 0 0 0-.07-.2l-3.72-4.45v-9.22l4.65-1.97v5.52c0 .25.2.38.43.28l3.87-1.54c.08-.03.2-.2.2-.28v-5.77l2.8-1.23 2.78.8v5.82c0 .1.12.27.23.3l3.87 1c.22.05.39-.08.39-.3v-5.6l4.65 1.22v9.51l-3.34 4.96-.05.17v27.81l3.4 13.42zm1.21.45c.08.3-.75.02-1.04-.1a28.26 28.26 0 0 0-11.4-2.39c-4.61 0-8.97 1.1-12.83 3.06-.3.16-1.15.43-1.06.11l4.49-14.04-.09-27.24-3.71-4.45a.93.93 0 0 1-.08-.2v-9.53c0-.09.12-.25.2-.29l5.26-2.24c.24-.1.43.03.43.29v5.53l3.26-1.3v-5.75c0-.08.1-.25.18-.28l3.1-1.36a.85.85 0 0 1 .21-.01l3.1.89c.1.03.23.19.23.3v5.8l3.25.84v-5.59c0-.23.17-.36.39-.3l5.27 1.39c.1.02.23.19.23.3v9.84l-.05.17-3.34 4.96v27.68l4 13.91zm-13.15-43.58l8.37 1.9m-8.37-1.9l-8.47 2.87'/%3E %3C/g%3E %3Cg fill='none'%3E %3Cpath fill='%23000' d='M391.53 294.98l-.02-7.39 7.75-2.79 7.75 2.4.01 7.77z'/%3E %3Cpath fill='%23fff' d='M408.1 328.1l3.4 13.8a28.58 28.58 0 0 0-12.38-1.68l.14-58.44 3.1 1.04v6.06l3.87 1.07v-5.92l5.27 1.7v9.81l-3.4 4.84v27.73z'/%3E %3Cpath fill='%23bdbfc1' d='M399.26 340.19v-58.41l-3.1 1.2v6.04l-3.88 1.39v-5.99l-5.27 2.08v9.64l3.8 4.64.08 27.58-3.88 15.7c3.65-2.14 7.8-3.5 12.25-3.85v-.02z'/%3E %3Cpath stroke='%23000' stroke-width='1.09' d='M398.8 330.83l-8.57 1.65m19.48 3.87l-10.5-1.32-10.36 1.97m4.22-21.02v3.76m3.72 3.4v3.92m0-28.17v3.91m-3.72 1.43V308m3.72-1v3.9m7.9-3.3v3.9m-3.1-8.65v3.91m3.1-7.09v3.84m-13.82 20.88l8.4-1.8 8.52 1.57m-17-7.64l8.49-2.1 8.36 1.8m-16.85-3.59l8.49-2.3 8.36 1.91m-16.85-3.56l8.49-2.43 8.36 2.04m-16.85-3.58l8.49-2.54 8.36 2.15m.08 15.86l-8.44-1.69-8.41 2m8.39 6.17l-8.37 1.71m20.61-32.82l-12.24-3.56-12.25 4.16m20.63 4.22l-8.36-2.25-8.48 2.67'/%3E %3Cpath stroke='%23000' stroke-width='1.24' d='M399.26 340.19v-58.41'/%3E %3Cpath fill='%23000' d='M405.46 329.4l-3.73-.58v-11.78c0-1.45.89-2.26 1.68-2.26 1.4 0 2.05 1.58 2.05 2.27z'/%3E %3Cpath stroke='%23000' d='M411.22 341.41a29.86 29.86 0 0 0-23.89 2.02l3.86-15-.08-27.65a.94.94 0 0 0-.07-.2l-3.71-4.55v-9.31l4.65-1.84v5.53c0 .25.18.37.41.3l3.87-1.4c.1-.03.21-.2.21-.29v-5.83l2.8-1.08 2.78.93v5.84c0 .1.12.26.22.3l3.88 1.07c.22.06.4-.07.4-.3v-5.5l4.64 1.5v9.5l-3.34 4.75-.05.18v27.73l3.42 13.3zm1.2.41c.08.3-.74 0-1.03-.1a28.3 28.3 0 0 0-9.85-1.76 28.23 28.23 0 0 0-14.37 3.9c-.3.18-1.16.46-1.08.13l4.49-15.67-.09-27.43-3.72-4.55a.9.9 0 0 1-.07-.2v-9.64c0-.08.12-.25.2-.28l5.27-2.09c.24-.09.42.04.42.3v5.54l3.26-1.16v-5.83c0-.09.11-.26.2-.29l3.1-1.2h.2l3.1 1.04c.1.03.21.2.21.3v5.81l3.26.9v-5.5c0-.24.18-.37.4-.3l5.28 1.7c.1.03.21.19.21.29v9.81l-.05.18-3.34 4.75v27.6l4 13.75zm-4.31-13.71l3.4 13.79a28.58 28.58 0 0 0-9.97-1.78c-5.3 0-10.27 1.44-14.52 3.94l3.87-15.7-.09-27.58-3.78-4.64v-9.64l5.27-2.08v6l3.87-1.4v-6.04l3.1-1.2 3.1 1.04v6.06l3.87 1.07v-5.92l5.27 1.7v9.81l-3.4 4.84v27.73z'/%3E %3C/g%3E %3Cg fill='none'%3E %3Cpath fill='%23000' d='M426.4 300.55l-.02-8.15 7.75-2.17 7.75 2.55.02 7.77z'/%3E %3Cpath fill='%23fff' d='M442.98 333.53l3.4 13.32A28.59 28.59 0 0 0 434 344.8l.13-57.6 3.1 1.04v6.05l3.87 1.3v-5.91l5.27 1.77v9.7l-3.4 4.8v27.57z'/%3E %3Cpath fill='%23bdbfc1' d='M434.13 332.15V287.2l-3.1.96v6.05l-3.87 1.15v-5.99l-5.27 1.7v9.76l3.78 4.85.1 27.55-3.88 15.03a28.5 28.5 0 0 1 12.24-3.46v-12.66z'/%3E %3Cpath stroke='%23000' stroke-width='1.09' d='M423.57 342l10.5-1.63 10.7 1.41m-11.09-5.56l-8.85 1.36m6.82-33.42v3.91m-3.72 1.28v3.76m0 12.13V329m3.72-8.65v3.92m0-12.02v3.92m7.9-3.09V317m-3.1-8.74v3.92m3.1-7.02V309m-13.82 20.42l8.4-1.42 8.52 1.58m-17-12l8.48-1.83 8.37 1.99m0 3.96l-8.37-1.87-8.48 1.72m16.85-7.77l-8.37-2.12-8.48 1.97m16.85-3.81l-8.37-2.23-8.48 2.07m16.86-3.7l-8.36-2.44-8.48 2.17m-3.78-4.85l12.26-3.44 12.22 3.75m-12.22 30.89l-8.39 1.36m-.03-7.88l8.4-1.62 8.44 1.77'/%3E %3Cpath stroke='%23000' stroke-width='1.24' d='M434.13 344.8v-57.6'/%3E %3Cpath fill='%23000' d='M440.33 334.9l-3.72-.58v-11.78c0-1.45.88-2.26 1.67-2.26 1.4 0 2.05 1.58 2.05 2.27z'/%3E %3Cpath stroke='%23000' d='M446.08 346.34a29.77 29.77 0 0 0-23.87 1.33l3.85-14.35-.08-27.63a.86.86 0 0 0-.06-.19l-3.72-4.76v-9.44l4.65-1.5v5.57c0 .23.17.36.4.3l3.87-1.16c.1-.03.22-.19.22-.3v-5.81l2.79-.87 2.79.94v5.83c0 .1.12.26.2.3l3.88 1.3c.23.08.41-.05.41-.3v-5.48l4.65 1.57v9.36l-3.33 4.73-.06.18v27.57l3.4 12.8zm-3.1-12.8l3.4 13.3a28.59 28.59 0 0 0-10.75-2.07c-4.98 0-9.66 1.27-13.74 3.5l3.87-15.03-.09-27.55-3.78-4.85v-9.76l5.27-1.7v5.99l3.87-1.16v-6.04l3.1-.97 3.1 1.05v6.05l3.87 1.3v-5.91l5.27 1.77v9.7l-3.4 4.8v27.57zm4.31 13.23c.08.3-.74.02-1.03-.1a28.31 28.31 0 0 0-10.63-2.06c-4.92 0-9.56 1.26-13.6 3.47-.3.16-1-.18-.9-.5l4.32-14.38-.09-27.4-3.72-4.77a.89.89 0 0 1-.06-.19v-9.76c0-.1.12-.27.21-.3l5.27-1.7c.23-.07.4.06.4.3v5.57l3.26-.97v-5.8c0-.11.12-.27.22-.3l3.1-.97h.19l3.1 1.04c.1.03.2.2.2.3v5.83l3.26 1.1v-5.49c0-.24.18-.37.41-.3l5.27 1.78c.1.03.21.2.21.3v9.68l-.05.18-3.34 4.72v27.45l4 13.27z'/%3E %3C/g%3E %3Cg id='a' stroke='%23000'%3E %3Cpath d='M369.42 268.7c-.28-2.57-1.28-6.73-4.72-6.2.18 4.47 5.86 21.3-.64 22.46l-.21-.24c.08-7.64-7.55-15.97-6.07-22.62.98-4.38 4.3-6.75 8.7-6.75 8.05 0 9.17 10 3.29 13.5l-.35-.15z'/%3E %3Cpath fill='%23fff' d='M369.85 267.53c-.65-2.87-2.23-6.61-5.84-5.97l-.24.31c.17 4.8 6.2 19.42.46 22-.15-8.37-7.7-13.8-5.76-21.64.54-2.18 2.7-4.88 4.81-5.67a8.85 8.85 0 0 1 3.2-.66c7.25.15 9.14 7.67 3.37 11.63z'/%3E %3Cpath stroke='none' d='M359.57 264.71c.62-1.7 2.66-3.42 4.47-3.63.38-.05.68.29.83.7h-.17c-.21 0-.42.03-.62.08.01.31.04.63.08.97-.85.05-2.33.4-3.83 2.23-.7.86-1.07.5-.76-.35z'/%3E %3Cpath stroke-width='1.09' d='M360 265.23l4.25-1.73m-3.93 3.26l4.2-1.8m-3.86 3.42l4.2-1.98m-3.4 3.53l3.79-1.96m-2.52 3.39l2.95-1.68m-.82 2.7l1.3-.72'/%3E %3Cpath stroke='none' d='M369.14 259.6c-2.23-3.3-7.83-1.44-9.28.64-.1.15-.47-.08-.68-.16a.47.47 0 0 1-.08-.04c.39-.65.87-1.3 1.43-1.88 2.71-1.74 7.43-2.09 9.33.98.15.24.05.48-.13.58-.18.11-.44.1-.6-.13z'/%3E %3C/g%3E %3Cuse xlink:href='%23a' x='35.34' y='-5.42'/%3E %3Cuse xlink:href='%23a' x='70.67'/%3E %3Cg stroke='%23000'%3E %3Cpath d='M446.26 240.53c3.26 2.16 14.8 8.65 16.52 45.64 3.33 72.1-58.02 114.16-58.02 114.16s77.62-33.05 77.62-114.23c0-34.17-13.56-71.19-40.47-71.19l-14.8.05L405.64 225a6.78 6.78 0 0 0-5.35-2.6 6.79 6.79 0 0 0-5.35 2.6l-21.48-10.05-15.26-.05c-26.9 0-40.48 37.02-40.48 71.2 0 81.17 77.63 114.22 77.63 114.22s-61.35-42.07-58.02-114.16c1.7-37 13.25-43.48 16.52-45.64l18.13 6.05 22.91-13.41c1.5 1.6 3.04 2.73 5.4 2.73 2.36 0 3.68-.93 5.4-2.73l22.76 13.57z'/%3E %3Cpath fill='%23d99f31' d='M431.45 214.14l-31.17 13.55-31.17-13.55-10.92.77c-26.9 0-40.48 37.02-40.48 71.2 0 81.17 77.62 114.22 77.62 114.22s-62.12-42.07-58.79-114.16c1.71-37 13.57-44.42 16.83-46.57l19.98 5.56 26.93-15.92 26.93 15.92 19.51-5.56c3.27 2.15 15.13 9.58 16.83 46.57 3.34 72.1-58.79 114.16-58.79 114.16s77.62-33.05 77.62-114.23c0-34.17-13.56-71.19-40.47-71.19z'/%3E %3Cpath d='M437.34 228.91c-3.72.44-6.32 2.93-6.45 6.74-.08 2.04.9 5.06 2.3 6.34l-.84.92c-1.65-1.51-2.87-4.89-2.78-7.31.15-4.27 3.14-7.24 7.61-7.76zm-74.51-1.07c4.47.52 7.46 3.5 7.61 7.76.09 2.42-1.13 5.8-2.78 7.3l-.84-.9c1.4-1.29 2.38-4.31 2.3-6.35-.13-3.8-2.73-6.3-6.45-6.74zm-8.74 7.44c-5.4 3.49-10.3 10.1-13.03 16.93-.16.35-.39.46-.62.38-.22-.08-.3-.39-.2-.69a39.72 39.72 0 0 1 13.53-18.18l.32 1.56zm7.2-12.85c-13.21 0-23.02 9.3-29.64 26.47-.15.32-.45.56-.78.45-.26-.1-.3-.47-.17-.8 6.62-17.5 16.72-27.2 30.6-27.2 6.03 0 11.22 1.48 15.66 4.75l.24 1.6c-4.45-3.62-9.73-5.27-15.9-5.27zm0 3.56c-11.53 0-20.52 9.72-26.18 24.02-.16.34-.4.53-.71.4-.25-.1-.27-.47-.15-.77 5.38-14.46 14.82-24.73 27.04-24.73 6.13 0 11.39 1.94 15.81 6.2l-.2 1.38c-4.34-4.46-9.53-6.5-15.6-6.5zm13.22 12.6c-2.3-6.87-6.06-9.52-13.38-9.52-9.65 0-17.6 8.77-22.85 22.04-.13.3-.36.48-.64.38-.25-.08-.3-.42-.18-.73 5.11-13.48 13.32-23.08 23.67-23.08 7.69 0 11.8 3.16 14.02 9.84l-.64 1.07zm51.05.09l-.67-.96c2.2-6.8 6.29-10.02 14-10.04 12.43.05 21.97 14.05 26.93 32.33.1.36.03.75-.3.81-.3.06-.56-.18-.65-.52-4.97-18.03-14.44-31.17-25.9-31.23-7.39.02-11.12 2.7-13.41 9.6zm43.38 21.76c.1.41.07.76-.3.85-.29.07-.55-.15-.65-.59-4.77-20.38-14.98-34.36-29.18-34.36-6.11 0-11.33 1.52-15.64 5.97l-.2-1.43c4.43-4.28 9.7-5.7 15.84-5.7 15.12 0 25.64 14.94 30.13 35.26zm3.83.54c.08.38-.05.75-.39.8-.31.05-.57-.22-.64-.6-4.7-22.3-15.8-38.71-33.15-38.71a24 24 0 0 0-15.73 5.75l.17-1.6a24.87 24.87 0 0 1 15.56-5.32c18.29 0 29.68 17.3 34.18 39.68zm-31.65-28.23c9.51 1.17 18.06 12.3 21.67 26.99.09.37 0 .74-.32.83-.3.08-.58-.12-.71-.6-4.12-15.82-12.27-24.67-20.76-25.75l.12-1.47z' stroke='none'/%3E %3Cpath fill='none' d='M419.35 240.51c-.73-.86-2.93-3.99-2.93-10.27m-.3 8.37c-.68-.92-2.32-3.61-2.32-8.37m-.86 6.48a11.9 11.9 0 0 1-1.76-6.48m-1.35 4.65c-.4-.8-1.11-2.53-1.11-4.65m-27.5 10.27c.72-.86 2.92-3.99 2.92-10.27m.3 8.37c.68-.92 2.32-3.61 2.32-8.37m.86 6.48c.59-.9 1.76-3.11 1.76-6.48m1.35 4.65c.4-.8 1.12-2.53 1.12-4.65'/%3E %3Ccircle fill='%23d99f31' cx='400.28' cy='229.24' r='6.2' stroke='none'/%3E %3Cpath fill='none' d='M394.13 227.78a6.31 6.31 0 0 1 12-1.02m.33 4.06a6.38 6.38 0 0 1-12.1.7m7.55 1.62a4.23 4.23 0 0 1-5.86-3.74m7.87 2a4.24 4.24 0 0 1-2 1.74m-1.2-1.9a2.05 2.05 0 0 1-2.48-1.8m-2.12-1.23c.13-.56.37-.9.47-1.05'/%3E %3Cpath fill='none' d='M394.13 227.78c0-2.92 2.56-5.36 6.15-5.36 2.74 0 5.85 1.92 5.85 4.34m.33 4.06c0 2.7-3.22 5.08-6.18 5.08-2.7 0-5.93-1.97-5.93-4.38'/%3E %3Cpath d='M423.35 242.22a17.45 17.45 0 0 0 13.96 7.07c7.4 0 13.03-4.6 13.03-11.94-.17-3.9-2.8-8.7-9.02-8.7-4.04 0-7.47 3.89-7.47 7.93 0 2.23.43 3.58 1.8 5.26-5.53-1.78-9.2-4.73-9.2-11 0-6.45 4.28-11.06 11.27-11.64 23.39-1.95 37.68 24.01 40.43 59.9 3.93 51.17-23.68 91.97-65.64 115.26-5.85 3.25-10.45 5.85-12.43 6.7l-.03 6.36c15.97-6.1 34.5-17.9 46.05-28.44 21.99-20.1 42.97-54.08 39.79-99.85-2.02-28.91-11.02-48.3-22.07-57.87-18.89-16.39-44.65-9.84-44.65 9.57a18.5 18.5 0 0 0 4.18 11.39zm-46.6 0a17.45 17.45 0 0 1-13.96 7.07c-7.4 0-13.03-4.6-13.03-11.94.17-3.9 2.8-8.7 9.01-8.7 4.04 0 7.47 3.89 7.47 7.93 0 2.23-.42 3.58-1.8 5.26 5.54-1.78 9.2-4.73 9.2-11 0-6.45-4.27-11.06-11.27-11.64-23.38-1.95-37.67 24.01-40.42 59.9-3.93 51.17 23.67 91.97 65.63 115.26 5.86 3.25 10.45 5.85 12.44 6.7l.03 6.36c-15.98-6.1-34.5-17.9-46.05-28.44-21.99-20.1-42.97-54.08-39.79-99.85 2.01-28.91 11.02-48.3 22.06-57.87 18.9-16.39 44.66-9.84 44.66 9.57a18.5 18.5 0 0 1-4.18 11.39z'/%3E %3Cpath fill='%23f1bf31' d='M400.05 406.96c-15.98-6.11-34.5-18.67-46.05-29.22-22-20.1-41.58-53.3-38.4-99.08 2.02-28.9 10.56-47.2 21.6-56.79 18.9-16.37 43.26-8.92 43.26 8.96 0 9.84-7.98 17.84-17.83 17.84-5.96 0-12.25-4.83-11.63-12.1a7.32 7.32 0 0 1 14.62.32c0 2.23-1.46 4.39-3.03 5.73 6.22-.22 11.67-5.5 11.67-11.79 0-6.44-4.89-11.82-11.89-12.4-23.38-1.95-38.5 24.63-41.04 60.66-3.63 51.2 24.3 92.6 66.25 115.9a126.8 126.8 0 0 0 12.47 6.08c1.97-.83 6.58-2.82 12.46-6.09 41.96-23.3 69.88-64.68 66.26-115.89-2.55-36.03-17.66-62.6-41.05-60.67-7 .59-11.88 5.97-11.88 12.41 0 6.29 5.45 11.57 11.67 11.8-1.57-1.35-3.04-3.5-3.04-5.74a7.32 7.32 0 0 1 14.63-.32c.62 7.27-5.67 12.1-11.63 12.1-9.85 0-17.83-8-17.83-17.84 0-17.88 24.36-25.33 43.25-8.96 11.05 9.58 19.59 27.89 21.6 56.79 3.18 45.77-16.4 78.99-38.4 99.08-11.55 10.55-30.07 23.1-46.04 29.22z'/%3E %3C/g%3E %3C/g%3E %3Cg stroke='%23000' stroke-width='.93' stroke-linejoin='round' stroke-linecap='round'%3E %3Cpath d='M302.44 357.77s-3.28-1.33-4.74-2.06c-2.52-1.26-8.21-8.26-14.57-11.95-9.76-5.66-19.2-4.2-27.83-7.9 1.93 9.03 8.02 17.19 18.1 21.51 8.28 3.55 21.64.5 23.1.62 1.45.12 6.06 1.9 6.06 1.9l-.12-2.12zM267.22 369.04l.09-.26a138.2 138.2 0 0 0 15.53-3.25c11.5-2.92 16.9-.55 26.22 5.83.58.4 1.27.96 1.94 1.2 1.51.58 2.48.18 3.94.18l.14.03 2.18 1.7c.17.14.07.25-.09.28-1.9.4-4.5.39-6.5.21-3-.27-9.19 6.85-18 6.85-11.16 0-18.5-4.94-25.45-12.77z'/%3E %3Cpath fill='%23658d5c' d='M316.3 374.32c-1.74.06-3.6.06-5.31.35-5.14.86-10.22 6.45-18.02 6.68-10.39.3-16.95-4.6-24.04-11.58 10.32-1.55 18.3-7.51 28.96-4.16 5.47 1.72 11.89 8.6 17.02 7.61l1.4 1.1z'/%3E %3Cpath stroke-width='.45' d='M309.88 372.95s-9.11 1.5-14.79 1.5c-9.16.03-23.19-3.8-23.19-3.8s13.99 4.24 23.2 4.43c5.66.11 14.78-1.2 14.78-1.2v-.93z'/%3E %3Cpath fill='none' stroke-width='.78' d='M284.54 262.68c.07-.3.02-.64-.16-1.07-.18-.44-.47-.92-.77-1.42-.3-.52-.64-1.08-.9-1.65a5.41 5.41 0 0 1-.5-1.87l1.4-.4a6.8 6.8 0 0 0 2.17 3.74l.43.45-1.18 2.62c-.08.2-.6 0-.5-.4z'/%3E %3Cpath stroke-width='.78' d='M338.06 388.95c-.04-1.9.34-1.2 2.38-.36.44.18.12.6-.26.84-1.22.76-2.3 2.38-2.82 2.02-1.4-.99-.52-1.02.7-2.5z'/%3E %3Cpath d='M289.16 254.94c-6.03 15.31-8.06 42.44-5.98 54.76 6.41 37.86 37.6 73.37 66.15 79.1 24.83 5 39.97 16.12 49.85 27.98 6.46 7.76 9.91 11.28 19.19 26.72 3.39 5.65-2.41 6.79-4.8 2.11-6.53-12.76-10.05-18.44-19.04-28.47-9.66-10.78-23.87-20.45-47.06-25.08-27.65-5.52-60.05-41.09-66.46-78.95-2.08-12.32-.26-41.73 6.07-57.28l2.08-.9'/%3E %3Cpath d='M330.29 387.33c-4.3.48-7.21 6.72-11.53 10.65-7.95 7.24-20.68 7.96-28.8 3.13-.34-.2-.52-.66-.13-.75 10.1-2.29 11.41-16.07 32.46-14.71 2.47.16 3.5.66 5.99.66l2.01 1.02zM314.3 323.27l.15.07c.1 6.15 4.77 14.55 5.91 21.32 1 5.83-.43 10.7-2.67 16.13-.55 1.35-1.87 4.07-1.92 5.4-.04 1.25.73 2.4 1.4 3.42.22.37 1.62 2.2 1.47 2.55-5.57-4.83-2.3-1.68-4.61-6.13-1.2-2.3-2.63-4.38-3.81-6.7-6.26-12.2-6.38-26.06 4.09-36.06zM354.56 389.97c-2.74-.88-5.53-1.98-7.03-4.78-2.53-4.7-1.99-8.5-4.58-13.38-4.91-9.23-14.37-10.23-19.14-18.8-.97 7.89-2.03 19.66 10.24 28.08 4.32 2.96 10.9 3.64 12.5 4.83 1.58 1.2 2.54 2.9 2.54 2.9l5.47 1.15z'/%3E %3Cpath fill='%23658d5c' d='M349.24 388.53c-.9-.96-1.9-1.92-2.98-2.7-2.5-1.8-7.92-1.98-12.02-4.98-5.71-4.2-8.67-8.09-10.26-15-.97-4.19-.22-7.54-.03-11.02 5.15 7.48 14.1 8.18 18.88 17.13 2.91 5.44 2.53 13.7 8.49 17l-2.08-.43z'/%3E %3Cpath stroke-width='.78' d='M300.36 347.4s-.35.4-.83 1.77c-.2.62 1.14 2.47 1.03 1.83-.28-1.57.5-2.68.5-2.68l-.7-.92z'/%3E %3Cpath fill='%23658d5c' d='M302.44 357.77s-3.28-.7-4.74-1.43c-2.52-1.27-8.11-8.6-14.57-12.27-9.26-5.26-17.33-4.16-26.44-6.82 2.59 9.72 7.53 15.54 16.7 19.66 8.23 3.69 21.65.5 23.1.62 1.46.12 6.07 2.06 6.07 2.06l-.12-1.82z'/%3E %3Cpath fill='%23466343' d='M315.48 368.9c-.4-2.88-3.7-7.05-5.07-9.74a36.3 36.3 0 0 1-3.98-12.68c-.97-9.54 1.21-14.68 7.5-21.75.04 2.07.31 2.8.94 4.72 2.63 8.1 6.3 14.78 5.11 23.58-.59 4.33-4.12 10.5-4.28 13.14-.09 1.38.69 2.98 1.37 4.14l-1.6-1.4z'/%3E %3Cpath d='M291.92 343.12c-6.73-11.2-22.53-6.18-32.89-15.58-5.02-4.57-7.27-11.44-8.27-17.97-.3-1.94-1.13-9.66-.67-11.15.08-.28.36-.35.57-.14 3.44 3.36 6.88 5.53 10.85 8.22 9.44 6.39 13.31 12.38 18.18 22.35 6.37 13.04 12.14 5.6 12.23 14.27z'/%3E %3Cpath stroke-width='.45' d='M312.93 328.1s-2.14 11.2-1.81 18.4c.33 7.37 3.6 18.56 3.6 18.56h-.63s-3.38-11.18-3.6-18.55c-.2-7.24 2.44-18.4 2.44-18.4z'/%3E %3Cpath fill='%23658d5c' d='M281.96 336.01c-3.62-1.15-7.78-1.85-12.2-2.91-4.14-1-7.52-3.26-10.68-6.1-4.9-4.42-6.51-10.35-7.47-16.7a48.74 48.74 0 0 1-.44-10.62c.4.7.9 1.38 1.55 1.85 3.21 2.3 6.56 3.9 9.78 6.23 2.81 2.04 4.81 3.38 7.12 5.98a54.2 54.2 0 0 1 7.4 10.73c1.62 3.07 3 6.66 5.1 9.44z'/%3E %3Cpath fill='%23a48253' d='M282.12 333.91c1.08 1.45 5.45 3.32 7.05 3.53l1.54 3.85c-2.27-2.65-5.26-4.17-8.75-5.28z'/%3E %3Ccircle fill='%23d99f31' cx='271.96' cy='304.79' r='4.42'/%3E %3Cpath fill='%23f1bf31' d='M272.47 300.88a4.54 4.54 0 0 0-.36 1.78c0 1.94 1.15 3.53 2.56 3.53.4 0 .76-.13 1.1-.35a3.95 3.95 0 0 0-3.3-4.97z' stroke='none'/%3E %3Ccircle fill='none' stroke-width='1.24' cx='271.96' cy='304.79' r='4.72'/%3E %3Cpath d='M285.01 302.83s2.06-7.68 4-12.43c4.6-11.24 12.56-11.67 16.61-20.57 2.33 6.01 4.18 13.74.12 22.41-4.68 10.02-16.66 15.9-16.66 15.9l-4.07-5.31z'/%3E %3Cpath fill='%23466343' d='M305.59 271.85c5.98 16.33-1.92 28.09-16.42 36.2l-3.82-5.29c2.49-10.48 4.28-15.65 12.3-23.1 3.16-2.95 5.94-3.9 7.94-7.81z'/%3E %3Cpath fill='%23a48253' d='M288.71 255.67c-5.97 15.7-7.73 41.94-5.68 54.08 6.43 37.96 37.53 73.59 66.24 79.36 24.75 4.97 39.55 16.12 49.75 27.64 4.76 5.39 8.6 10.64 11.76 15.6 2.72 4.25 5.05 8.9 7.34 12.58.37.59-2.72 1.87-3.05 1.34-2.42-3.91-4.64-8.84-7.43-13.36-3.17-5.13-8.61-10.39-13.35-15.98-10.08-11.9-23.5-20.84-46.76-25.48-27.5-5.5-59.51-40.62-65.9-78.4-2.08-12.27-.55-40.74 4.92-55.78l2.16-1.6z'/%3E %3Cpath d='M285.72 329.93c-1.23-1.18-3.01-2.3-4.2-3.54-11.02-11.44-8.13-31.44 3.97-41.2.41-.33.72-.18.78.31a51.95 51.95 0 0 0 2.73 12.26c3.69 10.13 4.29 15.94.94 24.57-2.05 5.26 0 9.9 0 9.9l-4.22-2.3z'/%3E %3Cpath stroke-width='.62' d='M324.6 379.21c-7.05-2.41-14.34-1.76-20.2-7.85-6.78-7.03-8.24-17.9-6.47-24.17.08-.3.32-.55.51-.32 1.5 1.84 2.3 3.17 4.28 4.63 7.07 5.21 15.74 7.82 18.74 15.79.6 1.58.8 3.24 1.35 4.84 1.91 5.47 5.04 7.12 9.58 10.11l-7.79-3.03z'/%3E %3Cpath fill='%23658d5c' d='M330.12 382.12c-6.6-5.6-18.5-3.6-25.58-11.18-5.2-5.58-7.4-14.37-6.1-22 6.28 5.6 13.59 7.15 19.3 13.43 6.74 7.4 1 12.38 13.68 19.58l-1.3.17z'/%3E %3Cpath d='M294.87 341.94l.01-.17c1.64-1.95.5-7.82-.03-10.17a28.63 28.63 0 0 1-.37-11.68c.78-4.76 3.4-9.07 6.07-13.02 1.2-1.76 5.07-7.26 5.47-9.25.03-.17.21-.16.29 0 1.48 3.23 2.25 7.16 2.85 10.64.83 4.88 1.1 9.31-.6 14.86a27.2 27.2 0 0 1-6.68 11.52c-1.32 1.42-4.42 4.53-4.88 6.2-.08.32-.6 2.56-.5 4.2l-1.63-3.13z'/%3E %3Cpath stroke-width='.95' d='M283.94 277.75s.2.03 1.1-.56a6.28 6.28 0 0 0 2.4-2.89c.46-1.27 3.65-11.86 7.9-18.41 4.98-7.66 10.14-11.1 16.4-16.72.98 6.07 1.13 15.96-4 23.9-4.7 7.27-16.61 12.44-18 12.98-1.38.54-3.74.94-5.1 2.75-.77 1.02-1.3 3-1.3 3l.6-4.05z'/%3E %3Cpath d='M282.44 278.76s-.52-.02-1.18-.97a7.13 7.13 0 0 1-1.34-3.9c0-3.16 3-12.64 1.51-19.81-2.84-13.7-7.14-19.18-7.8-24.26-.27-2.03-11.45 13.83-8.05 28.54 1.69 7.3 10.16 15.45 11.35 16.52 1.2 1.07 2.81 2.46 3.6 4.6.8 2.2.62 4.72.62 4.72l1.3-5.44zM289 255.21c.8-1.96 2.14-4.28 3.37-5.3 3.02-2.53 11.49-8.82 14.38-13.4 6.44-10.21 5.14-22.79 4.46-24.98-5.58 4.86-10.67 8.06-16.37 16.1-4.96 7.01-6.05 20.73-6.43 23.33-.42 2.83-1.68 5.9-1.68 5.9l2.27-1.65z'/%3E %3Cpath fill='%23658d5c' stroke-width='.95' d='M284 279.97l.22-1.97a6.82 6.82 0 0 0 3.52-3.6c2.66-6.38 4.29-12.87 8.04-18.76 4.86-7.66 10.07-10.64 15.33-14.84.25 6.76 1.44 13.89-3.95 22.76-3.06 5.03-11.98 10.02-17.53 12.2-2.48.99-4.26 1.78-5.63 4.21z'/%3E %3Cpath d='M261.12 266.48c8.5 7.09 10.93 10.4 13.44 21.37.29 1.28 1.92 6.83 2.26 7.52.82 1.63 2.52 2.4 3.57 3.74.1.15.4 3.04.44 3.42.02.23-.15.22-.28.1-1.33-1.2-2.02-3.1-3.57-4.24-1.33-.97-5.82-1.93-7.75-2.73-4.95-2.04-8.99-5.86-11.85-10.33-3.78-5.9-4.2-13.94-3.3-20.7.21-1.56.42-3.43.97-4.9.08-.2.2-.16.3 0 2.02 3.15 3.31 4.7 5.77 6.75z'/%3E %3Cpath fill='%23658d5c' d='M280 299.39l.23 2c-4.04-5.46-5.4-3.85-10.98-6.16-4.86-2.01-8.81-5.76-11.64-10.16-4.22-6.56-4.14-16.27-2.36-23.66 2.27 4.46 11.13 8.94 14.54 14.52 2.18 3.58 3.54 7.84 4.63 11.88.54 2.02 1.15 6.1 1.99 7.76.62 1.25 2.5 2.92 3.58 3.82zM295.37 342.05c1.5-2.3.18-8.13-.3-10.78-.74-4.08-.8-7.61-.13-11.74 1.09-6.74 5.36-11.25 9.12-16.72a27.63 27.63 0 0 0 2.07-3.34c4.33 12.2 5.55 24.65-3.9 34.89-1.42 1.54-4.84 4.52-5.37 6.4-.28 1-.38 2.07-.46 3.1l-1.03-1.8z'/%3E %3Cpath fill='%23a48253' d='M331.31 385.46s-.53.85-3.04.85l1.25 1.22.77-.2c2.4-.49 3.13-.42 4.7.19'/%3E %3Cpath fill='%23466343' d='M328.27 386.31c-2.5 0-10.34-1.3-16.61.34-9.45 2.47-13.36 11.32-20.47 14.46 10.8 4.65 18.7 3.5 27.69-3.68 3.62-2.9 5.92-8.42 10.64-9.9z'/%3E %3Cpath fill='none' d='M405.4 431s.1-1.38 1.7-1.93c1.37-.48 2.08.61 2.08.61'/%3E %3Cpath fill='%23a48253' stroke-width='.78' d='M340.48 388.88s-.85.5-1.1.72c-.58.52-1.35.9-1.58 1.32l-.93-.08c.58-.48 1.18-1.3 1.51-1.7.2-.22 0-1.1 0-1.1l2.1.84z'/%3E %3Cpath fill='%23658d5c' d='M287.56 255.57c1.7-4.8 1.66-10.15 2.6-15.13 2-10.52 5-13.94 12.6-20.97 2.41-2.25 4.9-3.88 7.53-5.86.42 3.02.62 5.56.31 8.6-1.5 14.86-7.82 18.37-18.43 27.45-2.06 1.76-2.6 4.23-4.61 5.91z' stroke='none'/%3E %3Cpath fill='%23a48253' d='M287.96 254.32c.28-.4.54-.64.69-.57.11.05.13.29.06.62-.33.43-.7.83-1.15 1.2.14-.41.28-.83.4-1.25z' stroke='none'/%3E %3Cpath fill='none' d='M287.56 255.57c1.7-4.8 1.66-10.15 2.6-15.13 2-10.52 5-13.94 12.6-20.97 2.41-2.25 4.9-3.88 7.53-5.86.42 3.02.62 5.56.31 8.6-1.5 14.86-7.82 18.37-18.43 27.45-2.06 1.76-2.6 4.23-4.61 5.91z'/%3E %3Cpath d='M288.22 256.12s.39-1.17.96-2.66c.58-1.48.43.4.43.4l-.34 1.62-1.05.64z' stroke='none'/%3E %3Cpath fill='%23658d5c' d='M282.06 278.96l-.78 2.5c-.44-3.25-1.8-4.7-4.14-6.81-10.18-9.21-14.53-20.05-10.26-32.73a25.31 25.31 0 0 1 6.08-10.33 50.61 50.61 0 0 1 4.34 9.15c3.49 9.38 4.88 14.69 3.5 25.44-.5 3.8-2.32 8.42.2 11.8.28.36.62.8 1.06.98z' stroke='none'/%3E %3Cpath fill='none' d='M282.06 278.96l-.78 2.5c-.44-3.25-1.8-4.7-4.14-6.81-10.18-9.21-14.53-20.05-10.26-32.73a25.31 25.31 0 0 1 6.08-10.33 50.61 50.61 0 0 1 4.34 9.15c3.49 9.38 4.88 14.69 3.5 25.44-.5 3.8-2.32 8.42.2 11.8.28.36.62.8 1.06.98z'/%3E %3Cpath fill='%23a48253' d='M281.76 284.47s.25-2.46-.13-3.96c-.19-.75-.68-1.85-.68-1.85s1.22.62 1.5.57c.28-.05-.68 5.24-.68 5.24zM285.92 260.33c-.59.24-2.39-2.3-2.6-4.02-.22-1.64-.89-.96-.8.34.14 2.42 3.03 5 2.63 6.54.54-1.32.8-2.27.77-2.86z' stroke='none'/%3E %3Cpath fill='none' stroke-width='.78' d='M285.92 260.33c-.59.24-2.39-2.3-2.6-4.02-.22-1.64-.89-.96-.8.34.14 2.42 2.72 4.57 2.32 6.1'/%3E %3Ccircle fill='%23d99f31' cx='281.44' cy='253.51' r='4.42' stroke='none'/%3E %3Cpath fill='%23f1bf31' d='M281.7 253.09c-1.19-.84-1.72-2.16-1.17-2.94.55-.79 1.97-.75 3.17.1 1.2.83 1.72 2.15 1.17 2.93-.55.79-1.97.74-3.16-.1z' stroke='none'/%3E %3Ccircle fill='none' stroke-width='1.31' cx='281.4' cy='253.64' r='4.61'/%3E %3Ccircle fill='%23d99f31' cx='303.96' cy='344.42' r='4.57' stroke='none'/%3E %3Cpath fill='%23f1bf31' d='M303.43 343.97c-.98-1.34-1-2.98-.07-3.66.93-.68 2.48-.14 3.45 1.2.98 1.35 1.01 2.98.08 3.66-.94.68-2.48.14-3.46-1.2z' stroke='none'/%3E %3Ccircle fill='none' stroke-width='1.4' cx='303.96' cy='344.42' r='4.8'/%3E %3Cpath fill='none' d='M406.8 432.55s.05-1.39 1.69-1.78a1.8 1.8 0 0 1 2.08.93m7.23 15.61c-2.99.62-4.81-3.13-3.79-4.05.67-.6 2.32-.48 3.54.12 2.16 1.05 1.58 3.66.25 3.93z'/%3E %3Cpath fill='%23a48253' d='M417.8 447.31c-2.48.63-4.43-2.7-3.79-3.43.6-.68 1.85-.72 3.06-.13 2.17 1.06 2.05 3.23.73 3.56z' stroke='none'/%3E %3Cpath fill='none' d='M417.8 447.31c-2.48.63-4.43-2.7-3.79-3.43.6-.68 1.85-.72 3.06-.13 2.17 1.06 2.05 3.23.73 3.56z'/%3E %3Cpath stroke-width='.45' d='M287.44 256.18c3.14-9.16 4.9-15.6 10.1-24.55 3.54-6.08 10.48-14.7 10.48-14.7s-6.54 8.84-9.93 14.97c-4.8 8.66-5.87 12.39-9.7 23.46l-.95.82zM272.55 235.82s-1.15 14.39.66 23.3c1.63 8 7.27 19.63 7.27 19.63s.32.23-1.32-4.08c-1.68-4.43-3.82-9.32-5.18-15.58-1.93-8.88-1.43-23.27-1.43-23.27zM259.1 273.2s1.9 4.98 3.54 7.96c4.48 8.17 8.32 12.44 15.97 17.77l.22-.69c-7.37-5.23-10.84-9.41-15.58-17.08-1.83-2.98-4.15-7.96-4.15-7.96zM286.48 276.54s9.16-8.45 13.84-15.06c4.14-5.85 9.1-16.21 9.1-16.21s-4.53 10.49-8.55 16.37c-4.5 6.6-13.15 14.9-13.15 14.9h-1.24zM295.45 342.8c1.75-4.2 4.37-9.98 6.32-16.64 2.46-8.35 3.91-12.42 4.2-21.93-.15 9.5-1.16 12.78-3.17 20.68a122.42 122.42 0 0 1-5.8 16.83l-1.55 1.05zM290.24 300.67s6.9-6.03 9.98-11.43c4.06-7.12 4.74-12.83 4.74-12.83s-.06 5.74-4.12 12.86c-3.08 5.4-10.33 12.29-10.33 12.29l-.27-.9zM282.38 334.88s-5.95-3.77-9.21-6.51c-12.66-10.67-20.59-25.04-20.59-25.04s7.25 15.18 20.12 25.66c3.42 2.78 9.68 6.67 9.68 6.67v-.77z'/%3E %3Cpath fill='none' d='M283.2 336.41s-1.14-.48-.55-1.57'/%3E %3Cpath stroke-width='.45' d='M328.64 380c-5.59-3.52-13.44-8.75-20.53-16.02a151 151 0 0 1-5.91-6.67s2.83 4.42 5.14 6.82c6.31 6.58 14.99 12.74 20.57 16.25l.73-.39zM347.97 386.7s-10.5-7.53-15.23-14.11a44.67 44.67 0 0 1-5.56-9.83 51.9 51.9 0 0 0 6.33 9.83c4.73 5.99 14.46 13.18 14.46 13.18v.93zM295.95 400.21c15.45-2.15 21.46-11.17 34.61-13.22-1.38.07-1.13-.47-2.39-.2-11.6 2.44-18.7 11.22-32.22 13.42z'/%3E %3Ccircle fill='%23d99f31' cx='314.8' cy='382.21' r='4.57' stroke='none'/%3E %3Cpath fill='%23f1bf31' d='M319.29 381.34c-.04.15-.1.3-.18.43-.67 1.16-2.5 1.35-4.1.43-1.6-.92-2.34-2.6-1.67-3.76.19-.34.47-.59.82-.76a4.57 4.57 0 0 1 5.12 3.66z' stroke='none'/%3E %3Ccircle fill='none' stroke-width='1.4' cx='314.8' cy='382.21' r='4.8'/%3E %3Cpath fill='%23a48253' d='M330.8 384.33s.43.24.7.54c.26.3.36.66.17.89 0 0 .1.26.45.5.46.34 1.06.32 1.73.42.85.14 1.45.25 2.05.43.6.18 1.36.49 1.36.49l-3.43-1.7-3.03-1.57z' stroke='none'/%3E %3Cpath stroke-width='.45' d='M297.76 357.55s-8.53-2.24-19.42-6.3c-10.9-4.07-18.24-10.87-18.24-10.87s7.34 6.18 18.24 10.25c10.9 4.06 19.42 5.99 19.42 5.99v.93z'/%3E %3Ccircle fill='%23d99f31' stroke-width='1.24' cx='334.69' cy='394.97' r='4.88'/%3E %3Cpath fill='%23f1bf31' d='M338.15 397.95c-1.46.56-3.39-.4-4.47-2.27-1.17-2.03-.92-4.37.57-5.23l.06-.03.37-.02a4.57 4.57 0 0 1 3.47 7.55z' stroke='none'/%3E %3Ccircle fill='none' cx='334.68' cy='394.97' r='4.57'/%3E %3Cpath fill='%23a48253' d='M289.6 332.55s.51 1.59.92 2.58c.3.73.84 1.85.84 1.85s-1.12.24-1.12.11c0-.12-.88-4.52-.88-4.52l.24-.02z' stroke='none'/%3E %3Cpath fill='%23658d5c' d='M289 333.47c-1.65-2.52-5.16-5.34-7.14-7.4a22.64 22.64 0 0 1-6.31-12.5c-1.84-11.54 1.52-19.3 9.94-27.1.54 8.1 5.17 14.8 6.15 22.9 1.4 11.6-5.98 13.79-.85 25.14l-1.78-1.04z' stroke='none'/%3E %3Cpath fill='%23a48253' d='M287.89 331.17l.23 1.12c.33.4.63.8.88 1.18l1.47.85-.78-2.66-1.8-.49z' stroke='none'/%3E %3Cpath fill='none' d='M289 333.47c-1.65-2.52-5.16-5.34-7.14-7.4a22.64 22.64 0 0 1-6.31-12.5c-1.84-11.54 1.52-19.3 9.94-27.1.54 8.1 5.17 14.8 6.15 22.9 1.4 11.6-5.98 13.79-.85 25.14'/%3E %3Cpath stroke-width='.45' d='M289 331.08c-3.36-5.05-4.02-7.52-5.43-12.72-2.67-9.77-2.69-21.63-.18-25.97-2.5 4.34-3.03 16.14-.6 25.98 1.37 5.54 2.46 8.44 5.57 13.54l.64-.83z'/%3E %3Cpath fill='none' d='M288.59 332.89c-.82-.96.23-2.53 1.17-1.15'/%3E %3C/g%3E %3Cg stroke='%23000' stroke-width='.93' stroke-linejoin='round' stroke-linecap='round'%3E %3Cpath stroke-width='.78' d='M514.67 257.68a.63.63 0 0 1 .04-.27s.3-.43.6-1.14c.3-.73.61-1.73.63-2.84l1.66.34c-1.39 4.94-1.44 6.7-1.44 6.7-.01.4-.49.47-.6.08l-.9-2.87z'/%3E %3Cpath d='M519.12 275.31c1.33-.87 1.77-3.1 1.85-4.56.15-2.6-2.02-4.9-2.13-7.32-.07-1.55 1.27-1.7 1.52-2.91.22-1.08-3.96-4.86-2.83-7.84.8-2.13 2.5-1.08 3.15-3.3.68-2.36-1.44-5.73 1.29-7.31 1.32-.77 3.26.35 3.84-1.72.58-2.1.12-6.27 3.14-6.56 4.01-.4 4.63 7.82 5.37 8.4.76.6 1.8-.5 2.88-.07 2.95 1.17-.2 6.6-1.22 8.42 7.47.3.64 4.95-.5 7.02.31.75 2.22 1.03 2.54 2.18.2.76-.36 1.42-.89 1.88-1.67 1.48-4.17 2.04-5.99 3.23l-.25.18c-.06.68 1.84 2.68-.72 3.53-4.76 1.59-7.8 2.63-9.63 7.44-.5 1.3-.67 5.25-.76 4.85l-.66-5.54z'/%3E %3Cpath fill='%23658d5c' d='M519.85 279.07l-.83-3.63c.22-.12.41-.3.6-.48.97-.93 1.43-3.5 1.5-4.8.17-2.81-1.87-4.42-1.97-6.76-.06-1.21 1.29-1.65 1.5-2.8.28-1.45-3.75-4.99-2.7-7.75.73-1.88 2.47-.9 3.17-3.35.62-2.12-1.22-5.91 1.08-7.19 1.38-.76 3.38.47 4.05-2 .51-1.85.12-5.02 2.74-5.29 3.58-.35 4.11 6.82 5.04 7.53 1.03.79 1.85-.23 2.84.15 1.5.59 1.12 2.65.79 3.83-.4 1.38-1.06 2.52-1.64 3.8-.1.26-.11.5.2.62.93.35 1.73.2 2.06 1.43.44 1.67-2.13 3.5-2.7 4.83-.44 1.03 1.3 1.29 1.52 2.66.32 1.92-6.15 4.09-6.65 5-.06 1.26 1.62 2.56-.42 3.25-5.12 1.71-10.24 4.94-10.18 10.95z'/%3E %3Cpath stroke-width='.45' d='M519.4 275.86s6.53-11.62 8.41-19.87c1.3-5.72 1.88-14.96 1.88-14.96s-.28 9.21-1.41 14.94c-1.72 8.7-8.47 20.98-8.47 20.98l-.41-1.09z'/%3E %3Cpath stroke-width='.78' d='M519.6 286.9c0-.05.06-.23.09-.27 0 0 1.27-1.34 2.03-2.2.3-.33.48-.73.6-1.06.1-.32.13-.55.13-.55.03-.2.2-.32.4-.25l2.18.72c.3.1.33.36.08.54-.02.01-1.67 1.18-2.27 1.9a9.15 9.15 0 0 0-2.2 3.8c-.12.37-.53.34-.6-.06l-.43-2.57z'/%3E %3Cpath fill='%23a48253' stroke-width='.78' d='M520.35 289.42c.54-1.67.91-2.3 2.25-3.9.63-.74 2.33-1.94 2.33-1.94l-2.17-.72s-.14 1.03-.8 1.78c-.77.86-2.05 2.2-2.05 2.2l.44 2.58z'/%3E %3Cpath d='M511.7 247.35s2.72 5.43 5.07 13.79c4.83 17.25 5.46 39.65 3.38 51.97-6.41 37.86-40.67 73.27-68.32 78.8-23.2 4.62-36.87 14.5-46.6 25.23-7.55 8.73-10.47 13.94-17.33 27.9-2.1 4.3-9.01 5.15-6.04-.9 5.37-9.5 10.47-18.26 18.35-27.6 10.23-11.56 24.93-22.9 49.76-27.9 28.55-5.73 61.44-41.08 67.85-78.94 2.09-12.32 1.44-39.17-5.52-56.44l-.6-5.91'/%3E %3Cpath stroke-width='.85' d='M497.25 240.33s-8.04-.3-4.17-6.4c-3.69-1.8-8.13-5.1-3.37-7.8-.22-.92-3.03-1.81-2.82-3.99.13-1.25 1.71-1.82 1.85-2.36-.53-.99-4.2-5.7-2.93-7.11 1.96-2.16 6.18.44 8.1 1.6.48-.3 1.19-.89 1.66-1.2 2.8-1.86 3 2.63 3.76 4.07.36.66 2.57-1.13 4.06-.33 2.59 1.36 1.45 4.7 2.1 6.95.65-.07 1.58-.6 2.22-.64 4.2-.28 1.92 7.1 1.75 9.41 6.66-.96 1.53 5.88 1.9 11.75.1 1.62-.4 5.2-1.65 3.82-3.94-4.34-14.9-3.15-12.45-7.77z'/%3E %3Cpath stroke-width='.98' d='M496.32 264.53c-1.44-.12-4.56-.56-5.18-1.93-.97-2.17 1.56-2.91 1.43-3.07-.88-1.18-5-1.94-5.01-3.6-.02-1.15 1.92-1.98 1.58-3.04-.47-1.45-3.24-3.65-2.17-5.26 1.3-1.94 4.04.67 5.35.65.63 0 1.52-1.4 2.72-1.41 1.77-.03 2.85 3.4 3.52 3.32.74-.1 1.19-1.12 1.91-1.34 2.22-.67 2.85 1.73 3.38 3.3 1.03 3.08 2.14-.59 3.8.14 4.22 1.84 2.49 10.1 3.71 11.08.74.6 2.12.53 2.66 1.37 1.15 1.8-.43 5.42.46 8.66.36 1.31 4.45 5.13 4.45 5.13s.64 3.81.54 3.61c-1.85-3.55-2.25-4.39-5.55-6.91-3.18-2.43-8-.5-9.12-1.78-1.23-1.41.2-2.7-.45-3.33-.24-.23-3.97.16-4.53.1-2.65-.27-5.08-2.68-3.5-5.7z'/%3E %3Cpath fill='%23658d5c' stroke-width='.98' d='M518.51 278.2l.43 2.37c-6.8-9.72-12.34-5.85-13.8-7.43-1.1-1.2.3-2.07-.6-3.01-.95-1-6.67 1.11-8.36-3.32-.36-.93.9-2.45.27-2.58-1.45-.28-3.4-.24-4.39-1.55-.41-.54-.77-1.29-.23-1.88.28-.3.61-.56.85-.91.88-1.31-4.49-2.33-4.5-4.28-.02-1.12 1.46-1.52.92-2.9-.47-1.21-2.1-3.2-1.27-4.52 1-1.59 3.27.41 4.53.56.62.07 1.67-1.39 2.7-1.42 1.62-.05 2.31 2.97 3.55 2.85 1.22-.12 2.6-2 3.92-.37.92 1.15.9 4.48 3.07 3.52.52-.24 1.29-.87 1.87-.61 3.46 1.5 2.58 7.06 3.44 10.03.46 1.59 2.11 1.24 2.7 2.22.3.48.53 1.03.58 1.59.04.48-.03.95-.1 1.43-.27 1.92-.09 3.64.4 5.52.39 1.5 2.5 4.28 4.02 4.69z'/%3E %3Cpath d='M520.09 307.84l.34-.28c1.2-.02 2.02-2.5 2.39-3.45 1.5-3.93-1.2-10.46 3.34-10.44.24-1.62.57-5.62 2.05-6.69 1.07-.77 2.12.2 3.15-.1.76-1.53 1.12-4.44 3.3-4.85.7-.13 2.15 1 2.39.87.6-.3 1.3-3.42 3.05-3.89 1.07-.29 2.09.82 2.48.57.64-.4 1.26-1.07 1.79-1.64 2.28-2.43 5.12-2.48 5.04.77-.03 1.16-.76 2.79-1.18 3.84-.14.36 1.43 1.1 1.67 1.57.8 1.53-2.02 3.35-2.66 4.56.05.2 1.5.5 1.72.8 1.89 2.64-3.57 5.53-4.95 7.15-.54.64 1.32 2.06 1.06 3.16-1.04 4.43-7.86 2.8-9.37 3.49-.53.24-.69 2.6-1.13 3.21-1.92 2.6-9.53-.57-11.25 1.05-1.58 1.48-2.1 4.01-3.1 5.81-.22.4-.64.27-.6-.13l.47-5.38z'/%3E %3Cpath fill='%23658d5c' d='M520.54 308.03c1.4-.07 2.28-2.63 2.7-3.75.56-1.45.81-2.9.87-4.45.08-2.25-1.53-6.2 1.97-5.67 0 0 .73-5.27 2.25-6.49.98-.8 2.74-.34 3.16-.66 1.01-.74.62-3.96 2.8-4.37.84-.16 2.35.68 2.99.36.8-.4 1.09-2.82 2.63-3.23.96-.25 2.23.78 2.86.4 1.33-.83 2.33-3.45 4.2-2.93 2.12.6 1.38 3.8.84 5.12-.39.94.68 1.28 1.06 1.97.71 1.3-1.65 3.36-1.94 4.5-.11.43.93.95 1.19 1.23 1.57 1.68-2.48 4.65-3.57 5.58-.32.27-1.03.82-1.06 1.27-.09.94.93 1.63.67 2.78-.9 3.9-6.32 2.74-8.45 3.46-.86.28-.99 2.03-1.52 2.76-1.7 2.34-9.18.08-11.2 1.91-1.2 1.1-2.16 2.98-2.82 4.46l.37-4.25z'/%3E %3Cpath stroke-width='.45' d='M521.66 307.03c.23-.07 9.06-7.1 14.02-12.49 4.07-4.4 9.46-12.12 9.46-12.12s-5.33 7.86-9.3 12.43a144.33 144.33 0 0 1-14.18 13.57c-.24.07-.24-1.33 0-1.4z'/%3E %3Cpath d='M523.7 284.44c-2.08-1.2-1.78-7.67 1.26-10.6 2.56-2.47 9.71 4.8 7.5 7.8-1.24 1.67-6.58 4.08-8.77 2.8z'/%3E %3Cpath d='M532.5 280.53c-1.29 1.06-4.27-.32-5.79-1.84-1.39-1.4-2.23-3.52-1.4-4.5 1.64-1.95 6.2-4.74 8.4-2.9 2.18 1.83-.05 8.28-1.21 9.24z'/%3E %3Cpath fill='%23a48253' d='M532.08 281.37c-1.17 1.58-6.26 3.61-8.15 2.52-1.64-.96-1.62-6.84 1.36-9.72 1.88-1.82 8.89 4.35 6.79 7.2z'/%3E %3Cpath fill='%23d99f31' stroke-width='1.09' d='M533.25 271.8c1.82 1.53.06 7.46-1.05 8.37-.94.77-3.61-.26-5.16-1.8-1.4-1.42-2.08-3.39-1.53-4.04 1.68-2 5.92-4.05 7.74-2.52z'/%3E %3Cpath fill='%23f1bf31' d='M531.9 271.84a3.83 3.83 0 0 0-.88 2.6c0 1.68.84 3.06 1.89 3.1.14-.45.27-.93.37-1.43.17-.86.26-1.73.19-2.44-.07-.7-.29-1.2-.58-1.45l-.01-.02a1.8 1.8 0 0 0-.97-.36h-.02z' stroke='none'/%3E %3Cpath stroke-width='.86' d='M493.75 286.8c-.58-1.8-3.34-3.03-3.63-5.19-.13-.98.94-2.65.85-2.94-.48-1.55-3.07-3.56-1.74-5.5 1.72-2.5 4.16.08 6.2.67.33-.12.44-1.24 1.24-1.45 3.11-.83 5.83 4.23 6.65 4.54 2.41.91 4.3-3.36 5.62 5.98 1.04-.25 2.44-.5 3.07.56 2.57 4.4 1.06 13.9 6.2 16.44l.17.34c-.07.37-.24 3.18-1 2.26-1.3-1.57-2.31-3.8-4.57-4.2-2.39-.42-12.8 3.35-13.09-1.39-.03-.55.73-1.32.48-1.86-.6-1.3-6.86-.85-7.51-4.35-.26-1.37.7-2.62 1.06-3.91z'/%3E %3Cpath fill='%23658d5c' stroke-width='.86' d='M517.58 301.94c-3.83-5.95-5.55-3.7-11.36-3.27-1.33.1-5.8.29-5.73-1.95.03-.64.51-.8.11-1.58-.84-1.64-6.08-1.34-6.87-4.38-.41-1.58.45-3.7.23-4.3-.73-1.98-3.98-3.83-3.02-6.42.13-.34.32-.66.39-1.03.2-1.14-2.15-3.77-1.1-5.45 1.2-1.97 3.31-.42 4.92.31 1.15.52.86-.5 1.62-.75 1.33-.44 2.98.83 3.87 1.68.5.48 2.08 2.36 2.48 2.55.94.44 2.53-.06 3.62.32.98.35 1.64 4.45 1.79 5.5l.19.13c.89-.2 2.2-.19 2.73.68 2.43 3.96 1.24 13.42 6.45 16.3l-.32 1.66z'/%3E %3Cpath stroke-width='.45' d='M517.28 301.66s-6.92-11.44-12.9-17.43c-3.8-3.81-10.63-8.82-10.63-8.82s6.9 5.23 10.64 9.26c5.45 5.86 11.5 17 11.5 17h1.39z'/%3E %3Cpath d='M509.88 319.28c.31.15.97.03 1.38.14 3.05.84-1.31 9.68-1.56 11.62-.06.51.27 2.19.24 2.3l-.67 3.76c-.12.4.07-3.74-.53-4.77-1.06-1.83-4.41-.84-6.13-1.1-2.85-.45-.63-2.88-1.86-3.37-2.04-.82-6.3.34-6.8-2.7-.2-1.13.55-2.34.47-3.31-1.46-1.7-5.22-2.07-4.78-5.05.15-1.03 1.65-2.12 1.6-2.8-.04-.8-3.14-3.07-2.4-4.73.45-1 1.32-1.01 1.4-1.6.1-.61-2.5-4.51-.32-5.57 2.62-1.26 4.79 1.7 6.68 1.83.96.07 1.8-1.5 3.25-1.17 1.53.34 1.7 2.38 2.4 3.52.67.02 1.33-.7 2.08-.77 3.2-.34 2.7 4.78 3.52 6.55.1.21 1.06-.37 1.46-.22.67.26.92 1 1.01 1.66.28 1.92-.74 3.97-.44 5.78zM530.14 326.96c.6 6.03-7.58.09-12.08 2.49-1.35.7-4.49 3.11-4.26 2.54l1.13-2.86c.38-.31 1.59-.32 2-.5.98-.45 2.32-2 3.21-3.67 1.24-2.33.4-4.95 1.15-6.66 1.16-2.61 2.96-.21 3.74-.77 1.44-1.05 1.69-6.33 5.2-6.38.93-.02.92.16 1.56.47.73-1.06.97-2.38 2.39-2.82 1.03-.32 1.73.6 2.68.58.68-.53 3.32-4.95 5.48-4.43 2.43.58.97 4.9.78 6.49.27.3.6.29 1.03.86 1.68 2.24-.95 4.63-1.85 6.4.24.52.92.49 1.06 1.16.6 2.74-4.59 3.07-5.13 3.8 0 .26.4.55.36 1.12-.26 3.35-8.03 2.46-8.45 2.18zM477.59 346.87c.15-1.14-2.24-2.88-1.24-4.45.82-1.28 2.68-.62 3.43-1.27.65-2.03-.43-4.76 2.39-5.4 1.42-.31 2.2 1.14 2.67 2.24.18.4.8 2.93 1.05 3.02.53.19 1.93-.8 2.63-.71 1.9.27.4 3.84.98 4.85.4.7 1.42.15 2.07.37 1.92.66.43 3.86.43 5.23 0 .83 1.39 1.09 1.5 2.5.2 2.55-1.95 2.83-3.17 4.47-.17.24-.21.35-.02.58 2.1 2.57.91 3.82-1.42 5.52-2.75 2-6.98 3.26-5.42 7.53 0 0-1.4 2.85-1.54 1.9-.22-1.4.46-2.82.07-4.34-.41-1.62-5.36-3.74-5.56-5.49-.14-1.23 1.29-1.42 1.4-2.52.13-1.26-4.3-2.43-3.78-4.93.28-1.35 1.72-1.74 2.35-2.83-.1-1.06-5.04-4.83-.7-5.81.54-.13 1.4-.12 1.88-.46z'/%3E %3Cpath fill='%23658d5c' d='M481.75 372.92c.17-1.23.32-2.9 0-4.1-.45-1.75-4.3-3.94-4.46-5.45-.11-.96.62-1.22.78-2.42.2-1.62-3.8-2.66-3.32-4.9.29-1.36 2-2.02 1.84-3.23-.1-.68-2.12-2.35-1.69-4.09.35-1.4 1.88-.84 2.76-1.55.97-.78-1.9-3.13-.98-4.55.72-1.13 2.71-.63 3.27-1.43.59-.83-.46-4.27 2.3-4.91 2.2-.5 2.64 4.2 3.57 4.87.88.65 1.27-.5 2.65-.32 1.35.18.3 3.5.84 4.49.58 1.08 1.5.22 2.44.55 1.51.54.02 3.75.02 4.86 0 1.17 1.23 1.17 1.34 2.55.18 2.24-1.95 2.8-3.08 4.18-.31.38-.34.74 0 1.1 2.04 2.2.6 3.5-1.37 4.93-3.06 2.22-6.66 3.44-5.12 7.9l-1.79 1.52z'/%3E %3Cpath d='M531.06 337.06c1.52-.39 3.62-1.87 5.09-.7 2.79 2.23-2.07 6.14-2.97 8.22-.02.77 1.55 1.02 1.45 2.56-.18 2.7-3.77 2.12-5.46 3.08-.13.5.62.91.62 1.4 0 3.81-5.77 2.37-7.97 3.08-.7.23.48 2.25-2.02 3.2-1.08.4-2.62-.02-3.72-.22-1.32-.23-2.67-.5-4.03-.43-.56.03-1.13.18-1.7.13-.23-.02-.4-.14-.32-.41l6.3-18.59c.14-.4 2.88.64 3.49.64.68 0 1.34-1.42 1.82-1.86 1.64-1.5 2.43.64 3.8.64 1 0 3.82-5.58 5.62-.73z'/%3E %3Cpath stroke-width='.78' d='M499.83 340.1c-.05-.8-1.63 1.6-1.63 1.6s1.12 1.1 1.89 1.76c.94.81 2.52 1.95 2.52 1.95l.15-1.17s-2.79-1.95-2.93-4.15z'/%3E %3Cpath d='M498.15 332.52c.43.6.16 1.42-.13 2.03-.32.67-.51 1.07-.95 1.66-1.44 1.9-4.63 3.6-6.07 2.61-1.31-.9-4-8.78-1.9-10.14 2-1.29 7.18 1.2 9.05 3.84z'/%3E %3Cpath d='M490.57 336.03a10.1 10.1 0 0 1 2.42-2.34c1.27-.96 4.48-2.68 5.9-1.3 1.86 1.8 2.76 7.23.6 9.12-2.85 2.5-7.47-.37-9.26-2.84-.62-.85-.17-1.87.34-2.64z'/%3E %3Cpath fill='%23a48253' d='M493.3 334.18c1.94-1.44 4.15-2.25 4.99-1.37 2.25 2.37 2.36 6.9.8 8.23-1.57 1.34-5.23 1.23-8.38-2.75-.66-.84.62-2.64 2.58-4.1z'/%3E %3Cpath fill='%23d99f31' stroke-width='1.09' d='M497.65 332.26c1.05 1.93-4.7 7.33-6.6 6.05-1.34-.88-3.15-7.68-1.84-8.85 1.84-1.67 7.52 1.11 8.44 2.8z'/%3E %3Cpath fill='%23f1bf31' d='M490.64 329.5c-.47.03-.84.16-1.06.36a.83.83 0 0 0-.11.23c.78.39 2.18.74 3.6 1.38 2.05.9 3.47 2.1 4.07 1.76.1-.33.1-.59.03-.71a4.58 4.58 0 0 0-1.28-1.2c-.65-.44-1.47-.88-2.31-1.21a8.5 8.5 0 0 0-2.44-.61 3.77 3.77 0 0 0-.5 0z' stroke='none'/%3E %3Cpath fill='%23466343' d='M512.04 356.94c2.87-.14 5.61 1.14 7.35.5 2.59-.92 1-2.93 2.25-3.05 1.25-.11 7.54.35 7.53-2.78 0-.6-.5-.83-.28-1.51.23-.68 4.96-.45 5.13-2.98.1-1.61-1.36-1.63-1.14-2.6.23-.98 5.3-5.77 2.77-7.76-1.74-1.37-4.59 1.02-4.85.32-.36-.9-.43-1.67-1.59-1.77-1.66-.16-2.67 2.5-3.76 2.5-1.09 0-1.58-1.1-2.7-1-1.46.13-1.68 2.37-2.93 2.37-1.25 0-3.19-.7-3.19-.7l-6.3 18.59s1.04-.1 1.7-.13z'/%3E %3Cpath fill='none' stroke-width='.62' d='M515.12 349.61s5.92-2.24 9.4-4.26c3.32-1.94 8-5.72 8-5.72m-17.4 9.98s5.92-1.93 9.4-3.95c3.32-1.94 8-6.03 8-6.03'/%3E %3Cpath stroke-width='.78' d='M477.3 379.03s2.34-.57 3.28-.57 1.49.46 1.49.46l1.07-1.96s-3.19.38-4.13.29l-1.71 1.78z'/%3E %3Cpath fill='none' d='M463.17 400.05c-1.86-2.27 4.3-8.16 6.6-6.5 1.65 1.2 3.72 6.32 2.08 7.85-1.83 1.7-7.2.45-8.68-1.35z'/%3E %3Cpath stroke-width='.78' d='M460.32 392.57l-.68-.05c-1.2-1.5-1.64-1.56-3.4-2.04-.57-.16-.65-.75-.04-.91l2.13-.56c.34-.09 1.25.72 1.5.91.41.3 2.48.75 1.72 1.48l-1.23 1.17z'/%3E %3Cpath fill='none' d='M459.86 391.23c.87-1.31 6.28-1.63 9.44 1.16 1.94 1.71.38 4.13-1.47 5.69-1.82 1.54-4.58 2.82-5.71 1.82-3.22-2.8-3.31-7.1-2.27-8.67z'/%3E %3Cpath fill='%23658d5c' d='M513.1 333.13s2.62-2.72 4.73-3.78c4.1-2.06 10.75 1.25 11.73-.61.5-.95-.25-1.65.38-1.9.64-.26 7.9 1.18 8.18-2.1.06-.59-.75-.89-.13-1.52.64-.63 5.22-.94 4.76-3.1-.15-.7-1.14-.9-.89-1.59.26-.7 3.7-3.96 2.22-5.96-.42-.58-1.5-.47-1.42-1.18.25-2.22 1-5.65-.83-5.83-1.97-.19-4.27 3.82-5.04 3.97-.95.2-1.52-.75-2.47-.44-1.59.5-1.84 2.85-2.47 2.85-.64 0-.59-.66-1.6-.64-3.12.07-3.38 5.06-4.93 6.28-.89.7-1.41-.24-2.29-.06-2.15.44-1.51 5.83-2.66 7.54a17.64 17.64 0 0 1-4.12 4c-.5.25-1.5.25-1.5.25l-1.64 3.82z'/%3E %3Cpath fill='%23a48253' stroke-width='.78' d='M455.15 390s1.98.66 3.28.73c.88.05 2.26-.13 2.26-.13s-.54.12-1.12-.3c-.2-.13-1.55-1.33-1.55-1.33l-2.87 1.02z'/%3E %3Cpath fill='%23a48253' d='M460.4 391.64c1.45-1.65 5.66-1.47 8.74 1.25 1.54 1.35.52 3.38-1.3 4.99-1.83 1.62-4.16 2.52-4.95 1.83-3.08-2.7-3.56-6.86-2.5-8.07z'/%3E %3Cpath fill='%23d99f31' stroke-width='1.09' d='M463.52 399.9c-.7-.8.41-3.21 1.88-4.54 1.3-1.17 3.42-1.97 3.88-1.48 1.8 1.93 3.64 5.36 2.21 7.07-1.43 1.7-6.42.73-7.97-1.05z'/%3E %3Cpath fill='%23f1bf31' d='M469.06 394.48l-.14.04c-1.5.31-2.34 2.27-1.89 4.39.2.94.63 1.76 1.17 2.34h.02c1.3.1 2.44-.15 2.86-.66.52-.62.49-1.68.01-2.9a11.36 11.36 0 0 0-2.03-3.2z' stroke='none'/%3E %3Cpath fill='%23a48253' stroke-width='.78' d='M515.85 260.45s.05-1.77 1.45-6.76c.24-.87.9-1.35.9-1.35l-2.6-.36s.66.63.65 1.46a8.31 8.31 0 0 1-1.29 4.15l.89 2.86z'/%3E %3Cpath fill='%23658d5c' stroke-width='.85' d='M512.96 255.11s-1.7-4.95-3.14-6.75c-1.54-1.92-2.64-2.32-5.42-3.21-2.46-.79-6.3-1.42-6.46-3.35-.17-1.93.06-1.57-.64-1.75-2.26-.6-5.09-1.34-4.55-3.58s1.38-2.58.4-3.05c-1.42-.7-5.18-2.88-4.73-4.8.45-1.91 2.12-1.94 1.42-3.11-.51-.84-2.32-1.76-2.18-3.3.1-1.04 1.43-1.38 1.39-2.3-.04-.94-3.6-5.07-1.5-6.8 1.9-1.57 5.26 1.24 6.12 1.6.86.35 1.85-1.47 3.11-1.17 1.62.38 1.7 2.8 2.19 3.67.87 1.56 2.66-.48 4.06.28 2.33 1.25 1.52 5.56 2.15 6.44.62.87 2.35-.53 3.57.15 1.9 1.05.27 7.34.4 8.38.12 1.03 1.5.14 2.3.76 2.1 1.63-.46 6.6-.06 10.79.14 1.44.49 3.7.49 3.7l1.08 7.4z'/%3E %3Cpath d='M496.9 399.13c.65 1.13 1.85 1.91 2.41 3.08.79 1.64.05 3.3-1.93 3.19-.86-.06-1.65-.72-2.47-.78-.66-.06-2.57 2.49-4.4 2.4-2.52-.1-3.72-3.17-5.25-4.74-1.22-.26-2.12 1.54-3.48 1.3-2.78-.5-2.65-4.93-3.6-6.88-.78-.57-1.94.64-3.48-.45-2.39-1.69-1.14-6.99-3.7-8.47-2.25-1.3-7.02-.44-6.6-.66l2.65-1.38c.17-.09.67.16.84.2 4.36.86 10.19.14 14.65.14 2.14 0 1.8 1.73 2.14 2.09l.18.02c2.22.16 4.87 0 6.77 1.4 2.3 1.7.12 3.22.11 3.6l.1.05.5.17 1.49.44c1.16.37 2.46.88 3.24 1.87 1.13 1.44-.14 2.12-.18 3.4z'/%3E %3Cpath fill='%23466343' d='M467.2 386.2c.95.6 13.78.2 15.5.2 1.86 0 1.25 1.47 1.89 2.02.77.35 9.58.06 7.57 3.39-.23.38-.53.73-.72 1.13l.04.37c.9.74 4.02.8 5.38 2.55.81 1.05-1.33 2.73-.41 3.39 1.76 1.27 5.7 6.91-1.46 5.22-1.72-.4-3.76 4.4-7.5.1-.46-.53-1.52-2.05-1.95-2.35-1.05-.73-2.38.95-3.67.74-2.36-.38-2.5-4.52-3.35-6.26-1.17-.82-2.15.16-3.55-.83-3.17-2.24.71-9.9-9.54-8.76l1.76-.92z'/%3E %3Cpath stroke-width='.45' d='M466.26 386.4s9.65 1.96 15.2 4.76c5.09 2.56 11.92 8.46 11.92 8.46s-6.66-6.27-11.77-8.93c-5.28-2.75-14.58-4.6-14.58-4.6l-.77.32z'/%3E %3Cpath d='M491.11 376.21c2.5 2.32-1.28 10.05-4.12 9.56-4.53-.77-7.02-5.89-6.17-8.07.91-2.33 7.59-4 10.3-1.49z'/%3E %3Cpath fill='none' d='M486.6 384.99c-1.28-.92-.79-4.17.34-6.14 1.04-1.8 2.52-2.92 3.65-2.57 3.2 1 6.33 5.23 5.13 7.8-1.18 2.54-7.85 1.82-9.12.9z'/%3E %3Cpath fill='%23a48253' d='M490.9 376.44c2.3 2.13-1.35 9.15-3.86 8.72-4.32-.74-5.87-5.18-5.35-7.01.54-1.9 6.66-4.08 9.21-1.71z'/%3E %3Cpath d='M505.92 381.75c-.4.54-1.27 1.55-2.17 1.55-3.85-.04-3.58-3.32-5.6-5.5-.67-.17-1.17.63-2.5.33-1.73-.4-1.84-4.81-4.43-5.72-1.32-.45-4.97-.47-7 1.43l3.63-2.82c3.51 1.38 6.68-6.1 10.7-5.1 1.14.28 1.18 1.02 2.5.9 2.93-.26 5.92-2.18 9.45-1.02 2.12.7-.63 3.53 2.04 3.21 1.72-.2 4.28-.2 4.8 1.94.28 1.17-.33 1.7-.2 2.55.35.27 6.8 2.51 3.38 4.24.54 1.52 3.14 2.53 1.77 4.4-1.3 1.74-4.03-.2-4.8.52-.3.3-.3 1.14-.57 1.48-1.14 1.42-4.13-1.45-5.41-1.72-1.27 4.3-3.57 2.28-5.59-.67z'/%3E %3Cpath fill='%23658d5c' d='M491.45 372.43c2.67.75 2.74 4.86 4.28 5.24 1.54.39 1.5-.42 2.46-.2.89.2 1.78 5.39 6.08 4.85 1.1-.13 1.64-1.3 1.64-1.3s1.58 2.58 3.23 2.81c2.38.34 1.7-1.8 2.3-1.88.97-.1 2.74 1.94 4.52 1.94 1 0 .85-1.7 1.91-1.7s3.14 1 4-.24c1.13-1.61-1.49-3.5-1.68-4.08-.2-.58.74-.6.65-1.15-.37-2.05-3.7-2.38-4-3.1-.28-.73.47-1.47.2-2.6-.48-1.91-3.2-1.98-4.43-1.7-2.85.63-.27-2.41-2.3-3.27-3.49-1.47-8.57 1.32-9.86.77a7.38 7.38 0 0 0-1.95-.6c-3.15-.55-6.05 4.04-8.04 5l1 1.2z'/%3E %3Cpath stroke-width='.45' d='M490.47 371s9.65-.6 15.3 1.37c4.9 1.7 11.37 6.91 11.37 6.91s-6.97-5.12-12.15-6.63c-5.57-1.61-14.86-.73-14.86-.73l.34-.93zM481.94 371.67s1.85-12.28 1.7-20.17c-.1-4.75-1.01-12.12-1.01-12.12s1.27 7.64 1.47 12.58c.29 7.34-1.38 18.78-1.38 18.78l-.78.93z'/%3E %3Cpath d='M472.62 371.22c.18.53 1.96 1.04 1.8 3.03-.2 2.44-3.87 1.69-5.58 2.84-.64.43.77 2.52.03 3.52-1.33 1.77-5.84.71-6.16 1.15-.6.81 1.47 3.04-.72 4.27-3.04 1.7-9.45-1-12.91 2.07-.2.19-1.55 1.7-1.6 1.71-1.98.52-7.22 1.6-6.61 1.35 3.08-1.3 8.02-2.57 9-4.69.82-1.8.2-5.2.53-7.15.5-2.91 2.64-1.74 3.35-2.66.57-.75-.5-4.8 1.8-6.72 1.62-1.34 3.36-.42 4.83-1.48 1.54-1.11-.79-4.82 2.26-5.87 1.83-.63 3.74 1.41 4.15 1.32 1.14-.24 2.48-3.68 4.79-3.21 2.3.45 1.27 3.49 1.17 4.9 3.86.47 1.78 3.34-.13 5.62z'/%3E %3Cpath fill='%23658d5c' d='M441.42 390.86s8.2-3.43 8.87-5.15c1.04-2.64-.09-6.63 1.35-7.59.93-.62 1.87-.31 2.49-1.2.61-.89-.19-5.2 2.03-6.93 1.4-1.1 2.64-.12 4.34-1.3 1.82-1.3-.48-4.47 2.3-5.5 1.64-.62 3.3 1.38 4.11 1.17 1.57-.4 2.4-3.54 4.7-3.2 1.86.27.95 2.15.84 3.94-.07 1.02 1.54.55 2.01 1.99.35 1.04-1.08 3.3-2.03 4.13-.55.48 1.66 1.31 1.53 2.8-.2 2.14-4.32 2.29-5.27 2.63-1.24.44-.13 2.29-.96 3.36-1.35 1.72-4.78.65-5.4 1.47-.56.75.69 2.68-.89 3.87-1.64 1.23-8.01.45-9.05.83a77.2 77.2 0 0 0-5.57 2.31l-5.4 2.37z'/%3E %3Cpath stroke-width='.45' d='M450.2 386.04s8.98-6.45 13.57-12.22c2.53-3.18 5.87-8.02 5.87-8.02s-3.23 5.01-5.72 8.33c-4.53 6.04-13.56 12.95-13.56 12.95l-.15-1.04zM517.26 328.63c3.45-1.86 9.72-5.1 14.83-9.76 3.44-3.14 7.92-8.93 7.92-8.93s-4.45 6.1-7.92 9.4c-5.22 4.97-11.84 8.5-15.3 10.37l.47-1.08z'/%3E %3Cpath fill='%23466343' d='M509.94 333.26l-.8 2.64c0-3.64-.14-5.37-4.44-5.14-.67.03-1.36.1-2.02 0-2.19-.34-.5-1.66-1.2-2.66-.85-1.22-6.6-.12-7.08-3-.18-1.12 1.07-2.45.15-3.33-1.38-1.32-4.82-2.47-4.46-4.9.16-1 1.5-1.72 1.3-2.65-.26-1.24-2.73-3.4-2.13-4.76.49-1.09 1.37-.73 1.45-1.76.1-1.14-1.9-4-.12-4.87 2.35-1.14 3.95 1.1 5.97 1.26 1.17.09 1.96-1.3 3.19-1.03 1.58.35 1.59 2.9 2.6 3.42.38.19 1.5-.76 2.03-.82 2.83-.33 2.19 5.17 3.16 6.46.35.46 1.1 0 1.6.16 1.77.55-.13 6.56.6 7.36.25.28 1.15.12 1.55.23 1.48.42.45 4.24.2 5.18-.55 2.1-2.45 6.25-1.55 8.21z'/%3E %3Cpath stroke-width='.45' d='M509.83 332.84s-2.75-10.94-6.65-16.81c-3.23-4.87-10.3-10.87-10.3-10.87s6.77 6.05 9.84 10.87c3.76 5.9 6.33 16.81 6.33 16.81h.78zM515.8 275.7s-6.5-10.55-12.08-16.04c-4.56-4.48-12.98-9.99-12.98-9.99s8.03 5.67 12.36 10.17c5.3 5.49 11.45 15.85 11.45 15.85h1.24z'/%3E %3Cpath fill='%23a48253' d='M512.96 250.46c1.09 2.7 2.64 6.9 3.67 10.8 4.84 18.34 5.28 39.53 3.21 51.77-6.38 37.7-40.66 72.78-68.1 78.26-23.3 4.65-37.07 14.75-46.85 25.54a92.49 92.49 0 0 0-11.2 15.07c-2.84 4.82-4.7 8.96-7.23 13.1l-.14.06c-.17.07-.4.12-.66.17-.55.1-1.26.18-1.92.21a6.6 6.6 0 0 1-1.65-.09l-.08-.02 1.05-1.65c2.4-3.97 4.5-7.84 7.25-12.43a94.37 94.37 0 0 1 10.4-14.4c10.18-11.5 24.64-22.62 49.35-27.6 28.78-5.77 61.63-41.45 68.07-79.47 2.09-12.39 2.04-33.76-5.82-56.93l.65-2.4z'/%3E %3Cpath stroke-width='.45' d='M511.84 248.25a78.38 78.38 0 0 0-7.52-14.97c-4.46-7.16-13.52-16.88-13.52-16.88s8.57 9.76 12.8 16.85a80.72 80.72 0 0 1 9.06 20.47l-.82-5.47z'/%3E %3Cpath fill='%23a48253' d='M513.23 254.08s-.36-.9-.55-1.5c-.4-1.24-.71-3.27-.71-3.27l.98 2.35a51 51 0 0 1 .9 2.46l-.62-.04z' stroke='none'/%3E %3Cpath d='M514.38 317c-1.78-1.47-6.65-5.97-6.65-8.26 0-2.74 2.55-2.27 3.17-2.67-.11-1.1-3.86-3.85-2.36-6.31 1-1.63 3.24-1.17 4.08-1.84.64-1.74-1.84-6.27.15-8.72 1.17-1.46 2.08-.37 2.63-.5.11-.77.1-1.55.18-2.31.15-1.35.64-2.7 2.21-2.78 2.2-.11 3.7 2.71 4.75 4.27.23-.14 1.38-.3 1.63-.42 2.7-1.32 1.72 7.08 1.8 8.38.63-.02 1.91-.38 2.47-.05 2.9 1.72-2.86 10.72-3.48 12.84-.25.88 3.05.17.51 3.37-1.47 1.87-3.36 3.52-5 5.25l-6.1-.25z'/%3E %3Cpath fill='%23658d5c' d='M515.3 323.97c1.1-2.9.7-5.73-1.48-7.32-2.35-1.7-5.48-5.73-5.47-8.07 0-2.76 2.75-1.08 2.87-2.38.1-.98-3.6-3.9-2.28-6.05.86-1.4 3.15-1.23 3.73-1.93.96-1.16-1.43-6.33.46-8.74 1.04-1.32 1.85.09 2.54-.4.67-.48-.4-4.42 2.14-4.54 2.46-.1 4.26 4 4.65 3.88.8-.26 1.74-1.09 2.63-.24.87.83.6 7.85.6 7.85s1.67-.17 2.2.16c2.22 1.37-1.77 9.33-2.89 11.52-.95 1.86 1.85 2.1.41 4.01-2.36 3.16-7.09 6.94-7.84 11.58'/%3E %3Cpath stroke-width='.45' d='M518.03 321.92s1.77-11.42 2.27-17.44c.4-4.94-.7-13.08-.7-13.08s.63 7.83.23 12.77c-.5 6.02-3.14 20.36-3.14 20.36l1.34-2.6z'/%3E %3Cpath d='M492.06 364.37c1-2.56-1.93-10.05.28-11.36 1.26-.75 2.06.66 3.29-.55 1.57-1.55-.9-7.4 1.98-9.25 1.67-1.08 3 .47 4.6-.99 1.07-.97 1.12-4.88 3.83-5.56 1.8-.45 2.63.78 4.22 1 1.36.18 5.95-6.22 8.81-4.7 3 1.61.34 5-.26 7.28-.31 1.2 2.23 1.03 2 3.02-.22 1.82-2.3 3.65-2.3 4.41 0 .82 2.1 1.37 2.18 2.9.17 2.96-4.6 3.37-6.21 4.63-.84.66 1.08 2.8-.1 4.75-1.26 2.09-6.62.62-7.51 1.07-.73.37-.02 3.9-.92 5.15-1.47 2.03-8.47.12-11.06.55-3.47.56-4.98 1.27-7.17 3.87l4.34-6.22z'/%3E %3Cpath fill='%23658d5c' d='M487.66 368.46s2.73-1.42 3.72-3c.97-1.56 1.1-2.12 1.05-4.58-.02-1.5-1.32-6.65.14-7.47 1.21-.68 1.88.64 3.38-.78 1.84-1.73-.85-7.72 1.76-9.34 1.57-.97 3 .75 4.81-.88 1.24-1.1 1.03-4.84 3.48-5.46 1.53-.38 2.75.81 4.2 1 1.77.25 5.8-5.64 8.34-4.26 1.1.6 1.43 1.45 1.23 2.67-.22 1.3-.96 2.47-1.25 3.75-.36 1.65 1.87 1.5 1.67 3.25-.2 1.65-2.15 3.24-2.15 4.31 0 1.18 1.76 1.94 1.88 3.38.21 2.74-5.52 2.8-5.98 4.3-.46 1.5.66 2.6-.43 4.36-1.17 1.9-5.2.22-6.78.87-1.31.53-.51 3.5-1.31 4.7-2.2 3.27-12.85-1.34-17.23 4.68l-.53-1.5z'/%3E %3Cpath stroke-width='.45' d='M487.98 368.84s11.32-9.64 17.53-16.78c4.78-5.5 11.25-14.91 11.25-14.91s-6.04 9.53-10.63 15.07c-5.61 6.76-15.99 15.86-15.99 15.86l-2.16.76z'/%3E %3Cpath fill='%23a48253' d='M486.96 369.1l1.86-.55s-.68.8-.96 1.05l-.84.78-.06-1.29z' stroke='none'/%3E %3Cpath fill='%23d99f31' stroke-width='1.09' d='M486.87 384.76c-.92-.65-.68-3.67.48-5.67 1.05-1.82 2.68-2.7 3.35-2.4 2.48 1.17 5.59 5.07 4.6 7.2-.99 2.1-7.22 1.74-8.43.87z'/%3E %3Cpath fill='%23f1bf31' d='M491.36 377.72c-.28.12-.53.27-.74.5-1.02 1.13-.54 3.23 1.07 4.67a4.8 4.8 0 0 0 2.64 1.25h.01c.22-.15.38-.32.46-.48.35-.75-.03-2.1-.94-3.41-.68-.98-1.61-1.9-2.5-2.53z' stroke='none'/%3E %3Cpath d='M516.64 254.59c-2.35-.82-3.96-5.17-2.98-9.03.97-3.82 10.73-2.27 9.68 2.29-.83 3.59-4.7 7.43-6.7 6.74z'/%3E %3Cpath d='M523.07 246.46c-.34 2.3-3.36 2.55-4.76 2.27-1.49-.3-4.3-1.88-3.96-3.78.7-4.03 3.94-7.13 5.86-6.83 2.1.33 3.42 4.65 2.86 8.34z'/%3E %3Cpath fill='%23a48253' d='M516.85 253.84c-1.99-.3-3.54-4.4-2.59-8.13.9-3.5 9.24-1.29 8.48 2-.83 3.59-3.95 6.43-5.9 6.13z'/%3E %3Cpath fill='%23d99f31' stroke-width='1.09' d='M520.13 238.73c1.63.26 3.36 3.93 2.8 7.66-.28 1.8-3.1 1.7-4.53 1.42-1.55-.32-4.15-1.35-3.9-2.78.68-3.98 4.14-6.54 5.63-6.3z'/%3E %3Cpath fill='%23f1bf31' d='M519.86 239.27c-.07 0-.16.02-.25.04.1.66.51 1.62.7 2.72.25 1.46.22 3.85 1.24 3.67.63-.1.9-.6.9-1.57v-.02a9.46 9.46 0 0 0-.6-2.64c-.53-1.32-1.35-2.13-1.8-2.2h-.2z' stroke='none'/%3E %3Cpath fill='none' d='M382.27 446.7c-.77-1.13.99-4.61 4.68-4.2 1.62.2.83 2.53-1.17 3.94-1.41.98-2.74 1.4-3.51.26z'/%3E %3Cpath fill='%23a48253' d='M382.27 446.7c-.77-1.13.35-3.57 4.06-3.73 1.33-.05 1.45 2.06-.55 3.47-1.41.98-2.74 1.4-3.51.26z'/%3E %3Cpath fill='none' d='M394.92 431s-.1-1.38-1.7-1.93a2.06 2.06 0 0 0-2.23.61m2.38 3.18s-.05-1.4-1.7-1.78a1.8 1.8 0 0 0-2.08.93'/%3E %3C/g%3E %3Cpath fill='%23fff' d='M401.7 427.16c7.7-.09 13.48-.82 20.05-2.12-1.55 5.28-4.65 15.3 7.75 15.3 9.02 0 18.6-5.42 27.9-.65 20.3 10.42 35.64 2.98 48.04-10.96 0 0-9.17 1.95-18.6 1.54 0 0 7.06-6.02 7.75-13.94-6.2 4.64-12.4 5.32-18.6 5.32-6.2 0-10.16-3.74-18.28-5.02.46-2.8.95-5.66 1.68-9.6.8-4.3-.39-7.8-6.65-8.53-13.61-1.6-26.8 6.26-50.89 6.64-24.25-.38-40.88-8.24-54.5-6.64-6.25.74-7.44 4.23-6.64 8.53.73 3.94 1.22 6.8 1.67 9.6-8.1 1.28-12.07 5.02-18.27 5.02-6.2 0-12.4-.68-18.6-5.32.68 7.92 7.75 13.94 7.75 13.94-9.43.41-18.6-1.54-18.6-1.54 12.4 13.94 27.73 21.38 48.05 10.96 9.3-4.77 18.87.66 27.9.66 12.39 0 9.29-10.03 7.74-15.3a120.66 120.66 0 0 0 23.35 2.15v-.04z'/%3E %3Cpath d='M337.7 427.3c-.9.42-1.36-.16-.34-.68.72-.37 3.83-1.72 6.08-2.17.08-.01.17.05.18.14l.08.6c.01.07-.05.16-.13.17a30.84 30.84 0 0 0-5.86 1.94zm.52 2.95c-.9.41-1.36-.16-.34-.68.71-.37 3.98-1.98 6.23-2.42.06-.01.15.04.18.1l.22.6c.04.1-.01.18-.11.2-2.12.38-5.42 1.85-6.18 2.2zm32.32 5.39c-3.87-.4-8.43-1.57-13.27-2.25-6.14-.85-11.47-.53-17.86 2.36-.35.16-.53.18-.67.18-.12 0-.3-.03-.34-.2-.03-.14.07-.27.15-.35.1-.1.25-.2.42-.28 5.95-3.04 12.16-3.59 18.4-2.74 4.84.66 9.45 1.67 13.3 2.07 2.17.23 4.65-.14 5.46-1.44.22-.35.83.4.63.71-1.23 1.98-4.12 2.16-6.22 1.94zm-33.6-11.04c-.17.06-.33.1-.44.1-.1 0-.26-.03-.3-.17-.05-.14.04-.25.1-.32.08-.08.2-.16.35-.23 2.34-1.08 2.94-1.27 6.37-2.18.29-.07.5.1.55.32a.44.44 0 0 1-.35.53 40.73 40.73 0 0 0-6.29 1.95zm-.54-3c-.15.06-.3.1-.4.09-.11 0-.24-.05-.3-.18-.04-.12.02-.24.08-.32a.9.9 0 0 1 .32-.23 23.6 23.6 0 0 1 6.6-2c.27-.05.5.1.57.3.08.22-.03.47-.32.52-3.21.61-4.35.94-6.55 1.82zm34.15 9c-2.64-.27-5.64-.86-8.82-1.38a.5.5 0 0 1-.42-.58.5.5 0 0 1 .58-.41c3.16.51 6.14 1.1 8.76 1.37a6.26 6.26 0 0 0 2.93-.38c.31-.12.56.06.65.29.1.22.03.53-.28.65a7.2 7.2 0 0 1-3.4.44zm-13.88 5.25a29.54 29.54 0 0 0-16.78 2.58c-.22.1-.42.14-.57.16-.12 0-.3 0-.38-.14a.25.25 0 0 1-.01-.22.51.51 0 0 1 .12-.17c.1-.1.26-.21.47-.33 7.41-3.59 13.07-3.35 17.47-2.85 4.73.54 8.87 1.56 13.39 1.9.4.03.5.39.6.7.1.27.27.79-1.15.64-4.47-.48-8.56-1.55-13.16-2.27zm13.83-2.98c-5-.52-11.64-2.22-18-2.5-.33-.02-.54-.24-.54-.5 0-.25.21-.46.55-.45 6.38.29 13.1 1.8 18.12 2.33 1.85.19 3.88-.18 4.85-1.05.3-.26 1.05.73.77.97-1.3 1.16-3.74 1.41-5.75 1.2zm-31.73.11c-.9.42-1.36-.16-.35-.68.82-.42 5.34-2.56 7.76-2.72.33-.02.57.18.64.42.08.26-.07.53-.42.55-2.17.15-6.76 2.03-7.63 2.43zM462.4 427.3c.9.42 1.36-.16.34-.68a30.38 30.38 0 0 0-6.08-2.17.16.16 0 0 0-.18.14l-.08.6c-.01.07.05.16.12.17 2.12.38 5.12 1.59 5.87 1.94zm-.53 2.95c.9.41 1.37-.16.35-.68-.72-.37-3.99-1.98-6.23-2.42-.07-.01-.16.04-.18.1l-.23.6c-.03.1.02.18.12.2 2.12.38 5.42 1.85 6.17 2.2zm-32.31 5.39c3.86-.4 8.43-1.57 13.27-2.25 6.13-.85 11.47-.53 17.85 2.36.35.16.54.18.68.18.12 0 .3-.03.33-.2.03-.14-.06-.27-.14-.35-.1-.1-.25-.2-.43-.28-5.94-3.04-12.16-3.59-18.4-2.74-4.83.66-9.44 1.67-13.3 2.07-2.16.23-4.64-.14-5.46-1.44-.21-.35-.83.4-.62.71 1.23 1.98 4.11 2.16 6.22 1.94zm33.6-11.04c.17.06.32.1.44.1.1 0 .25-.03.3-.17.05-.14-.04-.25-.1-.32-.08-.08-.2-.16-.35-.23-2.34-1.08-2.95-1.27-6.37-2.18-.3-.07-.5.1-.55.32-.05.21.06.46.35.53 2.67.64 3.98 1.05 6.29 1.95zm.53-3c.16.06.3.1.41.09.11 0 .24-.05.3-.18.04-.12-.02-.24-.09-.32a.89.89 0 0 0-.31-.23 23.6 23.6 0 0 0-6.6-2 .5.5 0 0 0-.57.3c-.09.22.02.47.32.52 3.21.61 4.35.94 6.54 1.82zm-34.14 9c2.64-.27 5.64-.86 8.82-1.38.33-.05.46-.34.42-.58a.5.5 0 0 0-.58-.41c-3.16.51-6.14 1.1-8.76 1.37a6.25 6.25 0 0 1-2.93-.38.49.49 0 0 0-.65.29.49.49 0 0 0 .28.65 7.2 7.2 0 0 0 3.4.44zm13.88 5.25c5.26-.82 11.75.07 16.78 2.58.22.1.42.14.57.16.12 0 .3 0 .38-.14a.26.26 0 0 0 0-.22.53.53 0 0 0-.1-.17c-.1-.1-.27-.21-.48-.33-7.41-3.59-13.07-3.35-17.48-2.85-4.72.54-8.86 1.56-13.38 1.9-.4.03-.5.39-.6.7-.1.27-.27.79 1.14.64 4.48-.48 8.57-1.55 13.17-2.27zm-13.84-2.98c5-.52 11.64-2.22 18-2.5.34-.02.54-.24.55-.5 0-.25-.22-.46-.55-.45-6.39.29-13.1 1.8-18.12 2.33-1.86.19-3.88-.18-4.86-1.05-.29-.26-1.04.73-.76.97 1.29 1.16 3.74 1.41 5.74 1.2zm31.74.11c.9.42 1.36-.16.35-.68-.83-.42-5.35-2.56-7.76-2.72a.61.61 0 0 0-.64.42c-.08.26.06.53.42.55 2.17.15 6.76 2.03 7.63 2.43z'/%3E %3Cg stroke='%23000' stroke-linejoin='round' stroke-linecap='round'%3E %3Cpath stroke-width='.93' d='M400.04 427.33c-10.34 0-17.1-1.58-26.35-3.25-21.51-3.9-26.19-.94-26.19 2.78 0 1.2 1.1 1.55 1.9 1.2.41-.2.75-.88.75-.88-.76 0-1.26-.3-1.1-1.25.46-2.71 6.05-3.95 24.64-.92 9.27 1.5 16.01 2.78 26.36 2.78l-.01-.46zm.02 0c10.34 0 17.1-1.58 26.34-3.25 21.52-3.9 26.2-.94 26.2 2.78 0 1.2-1.1 1.55-1.9 1.2-.41-.2-.75-.88-.75-.88.76 0 1.26-.3 1.1-1.25-.46-2.71-6.05-3.95-24.65-.92-9.27 1.5-16 2.78-26.35 2.78v-.46z'/%3E %3Cpath d='M342.37 416.79c-3.4.55-6.53 1.71-9.73 2.97-8.7 3.41-18.7 2.9-26.43-2.61a20.17 20.17 0 0 0 4.76 10.3c.61.73 2.49 2.59 2.49 2.59.31.32.26.53-.19.54-5.93.26-11.3.18-17.14-.9 13.76 15.13 27.59 18.9 46.43 9.74 9.9-4.81 18.15.62 28.04.62 10.5 0 9.5-6.87 7.2-14.63l1.25.14c1.7 4.77 4.34 16.52-8.45 15.57-9.86-.73-17.75-5.75-27.68-1.01-15.3 7.3-26.35 7.19-39.66-2.69-2.7-2-7.08-5.63-8.95-8.39-.45-.67 0-1.07.69-.86 5.05 1.57 12.7 1.57 16.6 1.47-3.16-3.17-6.7-9.05-6.55-13.27.02-.55.28-.65.74-.42 7.2 3.74 9.91 5.24 18.32 5.24 4.95 0 15.06-5.6 18.08-5.01l.18.61z'/%3E %3Cpath stroke-width='.93' d='M457.72 416.79c3.41.55 6.54 1.71 9.73 2.97 8.71 3.41 18.7 2.9 26.44-2.61a20.17 20.17 0 0 1-4.76 10.3c-.61.73-2.5 2.59-2.5 2.59-.3.32-.25.53.2.54 5.92.26 11.3.18 17.13-.9-13.76 15.13-27.58 18.9-46.43 9.74-9.9-4.81-18.15.62-28.03.62-10.5 0-9.5-6.87-7.2-14.63l-1.25.14c-1.7 4.77-4.34 16.52 8.45 15.57 9.85-.73 17.75-5.75 27.68-1.01 15.3 7.3 26.35 7.19 39.65-2.69 2.72-2 7.09-5.63 8.95-8.39.46-.67 0-1.07-.68-.86-5.05 1.57-12.7 1.57-16.6 1.47 3.16-3.17 6.7-9.05 6.55-13.27-.02-.55-.28-.65-.74-.42-7.21 3.74-9.92 5.24-18.32 5.24-4.96 0-15.07-5.6-18.08-5.01l-.19.61z'/%3E %3Cpath d='M399.47 405.15c-11.82.09-21.8-2.07-30.12-3.94-6.9-1.56-14.94-3.34-22.01-2.4-5.15.69-7.26 2.96-6.38 8.16 1.1 6.46 2.06 12.97 3.24 19.4.67 3.72 2.65 4.22 6.14 3.6 5.03-.89 21.15-4.5 24.77.09 3.48 4.39.09 7.55-4.75 7.63-.68.01-.46-.46-.23-.46 4.63 0 7.89-2.67 4.9-6.78-3.15-4.33-18.23-1.16-24.38.28-3.9.91-6.5.4-7.22-4.39-.99-6.6-1.6-11.15-3.7-19.7-3.53-14.44 22.25-7.75 29.67-6.02 10.13 2.35 18.58 3.86 30.59 4.22 12.03-.36 20.48-1.87 30.6-4.22 7.43-1.73 33.21-8.42 29.67 6.03-2.1 8.54-2.7 13.08-3.7 19.7-.71 4.79-3.31 5.29-7.22 4.38-6.14-1.44-21.22-4.6-24.37-.28-3 4.1.27 6.78 4.9 6.78.22 0 .44.47-.24.46-4.83-.08-8.22-3.24-4.74-7.63 3.62-4.58 19.74-.98 24.76-.09 3.5.62 5.47.12 6.15-3.6 1.17-6.43 2.14-12.94 3.23-19.4.88-5.2-1.22-7.47-6.38-8.16-7.07-.94-15.1.84-22 2.4-8.33 1.87-18.3 4.03-30.13 3.94h-1.05z'/%3E %3C/g%3E %3Cpath d='M361.53 417.23c-1.62-.14-4.22-.29-4.22-.29l-.95-12.88 3.13.37.65 10.06c.32.01 1.73.1 2.66.21 1.07.12 2.79.39 2.79.39l.2 2.58s-2.63-.3-4.26-.44zM368.29 417.95l-.7-12.43 3.15.49.7 12.42zM377.81 412.18l1.07.18c1.6.27 1.72-.28 1.71-.95-.02-.8-.4-1.3-2-1.58l-.83-.14.05 2.49zm.11 4.94l1.5.25c1.73.3 2.16-.02 2.14-.9-.02-1-.62-1.6-2.5-1.92l-1.19-.2.05 2.77zm1.84 2.76l-5-.85-.23-12.27 4.5.76c3.08.53 4.75 1.88 4.8 4.21 0 .98-.54 1.63-1.14 1.98.86.48 2.1 1.59 2.13 3.21.04 2.28-1.34 3.6-5.06 2.96zM391.53 421.57a127 127 0 0 1-4.34-.53l-.12-6.19-.12-6.2 7.12.74.02 1.22.03 1.24-3.99-.42.05 2.55 4.2.43.04 2.31-4.19-.43.05 2.62c.32.05 1.75.27 2.71.35 1.08.1 2.86.14 2.86.14l.05 2.46s-2.7-.14-4.37-.3zM401.92 415.23c1.66-.03 2.39-.74 2.37-1.87-.02-1.19-.54-1.69-2.04-1.66l-1.4.02.06 3.52 1-.01zm6.96 6.42c-2.46-.09-3.78-1.32-5.07-2.77l-1.38-1.54c-.19.02-.4.02-.61.03l-.81.01.07 4.33-3.08.05-.21-12.38 4.78-.09c2.74-.04 4.77 1.19 4.82 3.94a3.7 3.7 0 0 1-1.85 3.31l1.19 1.25a5.1 5.1 0 0 0 2.72 1.47l-.57 2.39zM409 411.68l-.02-2.45 10.95-1.5.01 2.44-3.9.54.06 9.89-3.15.43-.06-9.88zM426.62 409.2c-.37 1.34-.77 2.68-1.18 4.02.86-.09 1.76-.24 2.59-.49-.37-1.2-.74-2.39-1.08-3.6l-.33.06zm3.35 9l-1.21-3.33c-.65.23-1.34.37-2.04.48l-2.1.28-1.32 3.82-3.19.6 3.85-10.63-1.35.25-.02-2.45c2.85-.46 5.6-.98 8.36-1.57l.11 2.43-1.36.26 3.55 9.24-3.28.61zM438.3 417.4c-2.02.04-3.1-.31-4.01-.8l.86-2.3c1.15.38 1.81.54 3.16.52 1.47-.03 2.2-.5 2.2-1.16.01-.45-.33-.76-.91-1.05-.59-.28-1.36-.52-2.14-.82-1.56-.6-3.17-1.5-3.13-3.64.04-2.43 2.75-3.66 4.92-3.7a8.84 8.84 0 0 1 4 .77l-.79 2.22c-.96-.26-1.92-.48-3.16-.46-1.22.02-1.93.65-1.94 1.1 0 .36.34.64.94.92.59.28 1.38.54 2.17.87 1.59.66 3.22 1.63 3.18 3.64-.05 2.75-2.82 3.85-5.35 3.89z'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 900 600'%3E %3Crect width='300' height='600' fill='%2300853f'/%3E %3Crect x='300' width='300' height='600' fill='%23fdef42'/%3E %3Crect x='600' width='300' height='600' fill='%23e31b23'/%3E %3Cg transform='translate(450,300)' fill='%2300853f'%3E %3Cg id='c'%3E %3Cpath id='t' d='M 0,-100 v 100 h 50 z' transform='rotate(18 0,-100)'/%3E %3Cuse xlink:href='%23t' transform='scale(-1,1)'/%3E %3C/g%3E %3Cuse xlink:href='%23c' transform='rotate(72)'/%3E %3Cuse xlink:href='%23c' transform='rotate(144)'/%3E %3Cuse xlink:href='%23c' transform='rotate(216)'/%3E %3Cuse xlink:href='%23c' transform='rotate(288)'/%3E %3C/g%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 81 54'%3E %3Crect fill='%234189DD' width='81' height='54'/%3E %3Cg transform='translate(40.5 27) scale(13)'%3E %3Cg id='t'%3E %3Cpolygon id='w' fill='%23FFF' points='0,0 0,1 .5,1' transform='translate(0 -1) rotate(18)'/%3E %3Cuse xlink:href='%23w' transform='scale(-1 1)'/%3E %3C/g%3E %3Cuse xlink:href='%23t' transform='rotate(72)'/%3E %3Cuse xlink:href='%23t' transform='rotate(-72)'/%3E %3Cuse xlink:href='%23t' transform='rotate(144)'/%3E %3Cuse xlink:href='%23t' transform='rotate(-144)'/%3E %3C/g%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 900 600'%3E %3Crect width='900' height='600' fill='%23377e3f'/%3E %3Crect y='120' width='900' height='360' fill='%23fff'/%3E %3Crect y='180' width='900' height='240' fill='%23b40a2d'/%3E %3Cpath d='M 450,191.459 520.534,408.541 335.873,274.377 564.127,274.377 379.466,408.541 z' fill='%23ecc81d'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 10'%3E %3Crect fill='%23078930' width='20' height='10'/%3E %3Crect fill='%23FFF' width='20' height='7'/%3E %3Crect width='20' height='3'/%3E %3Crect fill='%23DA121A' y='3.5' width='20' height='3'/%3E %3Cpolygon fill='%230F47AF' points='0,0 8.660254,5 0,10'/%3E %3Cpolygon fill='%23FCDD09' points='-513674,0 415571,301930 -158734,-488533 -158734,488533 415571,-301930' transform='translate(2.88675,5) scale(0.000003114816)'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 2800 1400'%3E %3Crect width='2800' height='1400' fill='%2312ad2b'/%3E %3Crect y='400' width='2800' height='600' fill='%23ffce00'/%3E %3Cpath d='M 0,0 V 1400 L 700,700' fill='%23d21034'/%3E %3Cg id='star' transform='translate(1400,700)' fill='%23000'%3E %3Cg id='c'%3E %3Cpath id='t' d='M 0,-200 v 200 h 100' transform='rotate(18 0,-200)'/%3E %3Cuse xlink:href='%23t' transform='scale(-1,1)'/%3E %3C/g%3E %3Cuse xlink:href='%23c' transform='rotate(72)'/%3E %3Cuse xlink:href='%23c' transform='rotate(144)'/%3E %3Cuse xlink:href='%23c' transform='rotate(216)'/%3E %3Cuse xlink:href='%23c' transform='rotate(288)'/%3E %3C/g%3E %3Cuse xlink:href='%23star' x='700'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 1064 600'%3E %3Cpath fill='%230f47af' d='M0 0h1064v600H0z'/%3E %3Cpath fill='%23fff' d='M0 200h1064v200H0z'/%3E %3Cg transform='translate(16.13)'%3E %3Cg fill-rule='evenodd' stroke='%23000' stroke-width='.3' fill='%23fff'%3E %3Cpath d='M515.01 353.35c1.52 0 3.17 0 10.11-1.7 6.94-1.64 12.67-5.85 14.02-6.46 1.34-.6 3.3-.43 3.3-.43-.75-.78-2.87-2.74-5.87-2.74-3.03 0-1.82 0-4.38 1.09-2.56 1.04-7.9 4.3-16.92 4.3h-.17c-9.03 0-14.67-3.26-17.23-4.3-2.56-1.09-1.39-1.09-4.38-1.09-3.04 0-5.12 1.96-5.9 2.74 0 0 2-.17 3.34.43 1.35.61 7.07 4.82 14.02 6.47 6.9 1.69 8.59 1.69 10.06 1.69z'/%3E %3Cpath d='M488.37 347.44c.74-.43-.17-1.65-.17-1.65l2.73-.6c-1.35-.61-3.34-.44-3.34-.44-.52.43-.43.96-.52 1.34-.05.4-.05 1 .26 1.3.26.27 1.04.05 1.04.05z'/%3E %3Cpath d='M490.92 345.19l-2.73.6s.9 1.22.17 1.66l4.82-.91s-.74-.53-2.26-1.35zM541.69 347.44c-.74-.43.13-1.65.13-1.65l-2.69-.6c1.35-.61 3.3-.44 3.3-.44.56.43.47.96.56 1.34.04.4.04 1-.26 1.3-.3.27-1.04.05-1.04.05z'/%3E %3Cpath d='M539.13 345.19l2.69.6s-.87 1.22-.13 1.66l-4.82-.91s.74-.53 2.26-1.35z'/%3E %3C/g%3E %3Cpath d='M495.84 343.31l-1.22 3.03.57.22c.9.4 1.81.19 2.25-.81.39-1.04-.14-1.81-1-2.16l-.6-.28zm.25.63l.1.03c.69.3 1.11.8.8 1.62-.34.78-1.03.8-1.68.5l-.12-.03.9-2.13z'/%3E %3Cpath fill-rule='evenodd' d='M497.22 347.48l1.34-2.98.35.13-1.35 2.99z'/%3E %3Cpath d='M500.21 345.28c-.63.02-1.24.44-1.53 1.1-.39.86-.01 1.79.81 2.18.83.35 1.8-.03 2.2-.94a1.74 1.74 0 0 0-.85-2.22 1.5 1.5 0 0 0-.63-.12zm-.03.5c.15 0 .32.03.47.1.65.25.82.95.56 1.56-.26.6-.96.91-1.53.65-.52-.26-.8-.9-.5-1.56.2-.46.56-.75 1-.75z'/%3E %3Cpath fill-rule='evenodd' d='M503.81 347.36c-.04-.22-.13-.39-.35-.48-.21-.08-.56 0-.65.26-.08.26.09.48.22.61l.22.17c.34.3.56.66.34 1.18-.21.56-.78.78-1.3.6-.43-.17-.7-.69-.56-1.21l.39.09c-.13.3.04.65.34.78.3.13.66-.1.79-.4.13-.34-.09-.56-.3-.78l-.18-.17c-.26-.26-.48-.56-.3-1 .17-.47.7-.65 1.12-.47.35.13.53.39.57.73l-.35.09zM506.2 347.53l-.52 1.82c-.13.52-.13 1.04.43 1.22.61.17.87-.26 1.04-.78l.52-1.87.35.13-.56 1.95c-.18.7-.74 1.13-1.43.92-.7-.18-.96-.83-.74-1.52l.56-2 .35.13zM510.58 352.04l-1.82-2.99-.48 2.38-.35-.04.65-3.38 1.78 2.95.48-2.34.35.04zM511.4 351.96l.4-3.22.34.05-.39 3.25z'/%3E %3Cpath d='M514.18 348.88a1.63 1.63 0 0 0-1.68 1.6c-.05 1 .65 1.73 1.56 1.77.87.05 1.64-.62 1.69-1.62.04-.91-.7-1.75-1.57-1.75zm-.06.47c.7.04 1.14.63 1.1 1.28 0 .7-.56 1.16-1.16 1.16-.61-.05-1.1-.6-1.1-1.25.05-.65.51-1.2 1.16-1.2z'/%3E %3Cpath fill-rule='evenodd' d='M519.08 352.14l-2.51-2.35.17 2.43h-.4l-.25-3.38 2.52 2.33-.18-2.38.4-.05zM521.12 351.65l-.6-3.2.39-.05.56 2.82.91-.17.09.38zM522.86 351.3l-.74-3.17.4-.08.73 3.17z'/%3E %3Cpath d='M523.87 347.72c-.13 0-.26.03-.4.06l-.35.13.88 3.12.69-.15c.52-.18.95-.57.78-1.22-.09-.35-.42-.64-.82-.6.18-.17.2-.5.16-.72-.16-.52-.53-.64-.94-.62zm.07.4c.2-.03.4.06.5.38.13.4-.14.5-.44.6l-.1.03-.3-.94h.12a.94.94 0 0 1 .22-.06zm.5 1.32c.25-.03.52.02.59.34.13.4-.17.57-.47.66l-.28.1-.25-1 .19-.04c.07-.02.13-.05.22-.06z'/%3E %3Cpath fill-rule='evenodd' d='M527.24 347.97l.13.34-1.17.4.39 1.16 1.21-.43.13.39-1.56.53-1.08-3.08 1.6-.57.09.34-1.21.43.3.87z'/%3E %3Cpath d='M528.62 346.19c-.3-.04-.55.03-.8.16l-.45.18 1.22 3.03.35-.12-.47-1.31.12-.03 1.35.9.46-.15-1.46-.97c.39-.22.51-.7.34-1.13a.87.87 0 0 0-.66-.56zm-.1.4c.18.02.33.13.42.35.17.43-.19.65-.54.78l-.06.03-.4-1 .09-.03c.15-.06.33-.14.5-.12z'/%3E %3Cpath fill-rule='evenodd' d='M529.24 345.76l1.7-.75.16.31-.7.3 1.23 2.65-.36.17-1.2-2.64-.66.3z'/%3E %3Cpath d='M532.21 344.19l.22 3.72.4-.22-.05-.84 1.28-.66.68.56.35-.22-2.88-2.34zm.44.88l1 .8-.9.48-.1-1.28zM535.31 342.88c-.32.02-.66.12-.97.31l-.56.31 1.72 2.82.5-.28c.87-.52 1.25-1.4.69-2.35-.35-.6-.85-.84-1.38-.81zm.16.5c.3.03.6.2.84.56.44.74.03 1.3-.62 1.69l-.06.03-1.2-1.94.1-.09c.33-.17.64-.28.94-.25z'/%3E %3Cg id='a' stroke='%23000' stroke-miterlimit='2.61'%3E %3Cg fill-rule='evenodd' stroke-width='.13' fill='%23e60000'%3E %3Cpath d='M485.07 355.17c.52 0 .91-.4.91-.91a.88.88 0 0 0-.91-.87c-.48 0-.91.39-.91.87 0 .52.43.91.91.91zM479.95 361.5c.52 0 .91-.39.91-.91a.92.92 0 0 0-.91-.91.95.95 0 0 0-.91.9c0 .53.43.92.91.92zM468.06 341.63c.48 0 .91-.43.91-.91a.92.92 0 0 0-.91-.91c-.52 0-.91.39-.91.9 0 .49.39.92.91.92zM460.68 345.32c.52 0 1-.43 1-1 0-.52-.48-1-1-1a1 1 0 0 0-1 1c0 .57.44 1 1 1zM459.34 323.02a1 1 0 0 0 1-1c0-.52-.48-1-1-1a1 1 0 0 0-1 1c0 .57.44 1 1 1zM453.13 324.84c.56 0 1-.43 1-1 0-.56-.44-1-1-1a1 1 0 0 0-1 1 1 1 0 0 0 1 1zM456.3 304.97a1 1 0 0 0 1-1c0-.56-.44-1-1-1s-1 .44-1 1a1 1 0 0 0 1 1zM450.75 286.7c.52 0 1-.43 1-.95a1 1 0 0 0-1-1c-.56 0-1 .43-1 1 0 .52.44.95 1 .95zM457.82 288.52c.56 0 1-.43 1-1 0-.52-.44-1-1-1a1 1 0 0 0-1 1c0 .57.44 1 1 1zM464.76 273.3a1 1 0 0 0 1-1c0-.52-.48-.95-1-.95-.56 0-1 .43-1 .95 0 .57.44 1 1 1zM459.47 269.09c.56 0 1-.43 1-1a1 1 0 0 0-1-1 1 1 0 0 0-1 1c0 .57.44 1 1 1zM470.01 258.85c.56 0 1-.43 1-1s-.44-1-1-1-1 .44-1 1c0 .57.44 1 1 1zM448.49 305.1c.56 0 1-.43 1-.95a.97.97 0 0 0-1-.96.96.96 0 0 0-.95.96c0 .52.43.95.95.95z'/%3E %3C/g%3E %3Cg stroke-width='.26' fill='none'%3E %3Cpath d='M485.93 358.9s-.74-3.17-.6-3.9l.77-.61M484.72 360.11s-2.82.13-3.73.43c0 0 0 .18-.3.79M467.28 345.8s-.17-3.77.6-4.08c0 0 .75-.3 1.18-.91M464.41 344.58s-2.13-.3-2.73 0c0 0-.13.6-.61.78M460.34 322.45l-.74.43c-.78.3-2.25 3.95-2.25 3.95s-2.43-1.82-3.47-2h-1.09M447.97 304.66s.6.6 1.21.3c0 0 3 1.96 3.17 2.74 0 0 3.17-3.17 3.78-2.87 0 0 .3.44.9-.17M451.31 286.14s.3.43.87.74c0 0 1.39 2 1.39 3.47 0 0 2.56-2.26 3.3-2.08 0 0 .9.3 1.51 0M458.69 268.83s.6.74 1.04.13c0 0 1.82 2.26.74 3.95 0 0 2.56-.6 3.34-.17 0 0 .3 1.04 1.21.43'/%3E %3C/g%3E %3Cg fill-rule='evenodd' stroke-width='.26' fill='%231f601a'%3E %3Cpath d='M532.79 378.34s-3.9-.3-4.51-.3c-.61 0-1.96-2.7-2.56-3.17-.61-.43-10.85-5.42-17.49-6.46-6.64-1.05-16.83-5-18.96-6.04-11.02-5.29-23.34-15.1-26.08-19.13-2.86-4.2-5.9-14.02-7.24-19.26-.61-2.44-3.9-12.37-3.9-19.14 0-7.85.9-14.32 2.12-19.44 1.17-5.12 9.98-20.13 15.36-26.81 0 0-12.1 18.74-14.19 25.9-2.08 7.38-2.69 16.36-2.56 21.48.13 4.2 3.64 19.61 8.76 30.93 4.08 9.07 7.64 10.16 14.02 15.23a90.9 90.9 0 0 0 13.54 8.6c4.81 2.38 15.05 5.42 17.79 5.85 2.69.48 16.4 4.51 18.22 5.43 1.82.9 6.47 4.99 7.68 6.33z'/%3E %3Cpath d='M464.11 343.41c.3-1.39.43-2.43.91-2.86.43-.48 1.95-2.3 2.26-3.47.3-1.22 0-2.13 0-2.74 0-.6.43-2.69.43-2.69s-.74-2.56-1.35-3.04c-.6-.43-2.12-2.56-2.42-3.16 0 0 .17 1.21-.3 1.82-.44.6-.62 2.13-.62 3 0 .9.3 3.03 0 4.07-.3 1.17-.73 2.13-.43 3.47.26 1.09 1.52 5.6 1.52 5.6zM463.63 341.89s-3.43-4.38-3.43-6.2c0-1.78-.3-2.87-.6-3.3-.3-.44-2.26-2.74-.48-5.56.78-1.21.91-1.12 1.34-2.43.61-1.64 1.83-1.64 2-3.3 0 0 .43 1.96.56 3.6.18 1.66-.13 2.27-.26 3.18-.17.9.44 1.95.44 3.3 0 1.38-.18 1.9-.18 2.73 0 .43-.56 6.16.61 7.98zM502.25 365.41s-2.9-.3-4-.48c-.77-.08-2.55-.52-3.55-.9a11.3 11.3 0 0 1-4.03-2.79c-2.78-2.95-2.52-4.5-3-4.64-1-.17 1.56-.43 2.78-.26 1.17.13 2.82 1 3.9 2.04 1.13 1.04 2.87 2.21 3.47 2.65.61.47 1.05.65 1.7 1.52.65.86.6 1.43 2.73 2.86z'/%3E %3Cpath d='M506.24 367.53s-7.29-3.25-8.03-3.86c-.78-.57-2-1.74-2.77-2.56-.74-.83-3.82-2.39-4.34-3.39-.35-.7-2.26-3.34-3.39-5.42-.56-1.08 4.86.35 4.86.35 4.43 1.78 2.43.52 4.86 2.34 1.48 1.13 2.48 2.08 2.87 2.9.56 1.31 1.21 3.57 1.86 4.74.6 1.17 1.78 2.69 4.08 4.9z'/%3E %3Cpath d='M510.19 368.45s-6.03-1.56-8.76-5.3c-1.96-2.55-1.96-1.77-2.78-2.64-1-1.09-2.56-2.26-3.86-4.47.13.22-1.74-5.9-1.65-6.64.04-.43 2.3.3 4.12 1.09 1.56.65 2.47 1.9 3.82 2.73 1.6 1.04 1.82 3.64 2.56 4.86 1.04 1.78 1.17 2.7 1.17 3.56-.04 1.34.74 1.78 1.17 2.9.52 1.35 2.13 1.13 4.21 3.91zM500.56 366.45s-5.12-2.26-5.86-2.43c-.78-.13-1.08-.6-2.12-.91-.87-.22-1.65-.87-3.78-.43-.91.21-4.64 1.04-5.55.6-.91-.48 1.34 2.56 2.38 3.17 1.09.6 2.87.91 4.39.74 1.51-.13 3.6 0 4.38 0 .74 0 1.17.17 2.25-.13 1.05-.3 1.35-.78 3.91-.61z'/%3E %3Cpath d='M504.03 366.45s-5.73-1.43-6.68-1.43c-.96 0-3.69.17-4.82.39-1.08.17-4.51-.17-5.5.35-1.05.47-5.6 1.12-6.82.82-1.22-.26 2.43 3.25 3.86 3.64 4.64 1.3 3.25 1.13 6.25.35 1.82-.48 4.43-.6 5.34-.74.9-.17.73-.7 1.95-1.21 1.21-.52 3.25-1.82 6.42-2.17z'/%3E %3Cpath d='M508.71 368.84s-5.73-2.39-10.2-1.17c-3.08.87-3 .74-4.2.95-1.44.22-2.65-.52-5 .44-1.17.47-6.16 2.51-7.54 2.43-1.26-.09 3.99 3.34 5.42 3.12 4.6-.65 8.94.91 11.06.04 1.91-.73 3.04-1.25 4-1.56.95-.35 1.47-1.21 2.08-1.65.6-.47 1-1.65 4.38-2.6zM478.13 355.69s-3.3-3.64-3.95-4.12c-.6-.48-2.17-1.6-3-2.35-.69-.6-1.38-1.95-3.5-2.47-.92-.22-3.13-.65-3.78-1.43-.6-.83.13 2.9.82 3.9a8.1 8.1 0 0 0 3.6 2.56c1.44.52 3.26 1.57 3.9 1.91.7.3 1.05.65 2.14.83 1.08.22 1.56-.09 3.77 1.17z'/%3E %3Cpath d='M481.25 357.21s-5.6-3.95-6.47-4.38a46.3 46.3 0 0 0-3.5-1.3c-1.1-.3-3.91-2.35-5.04-2.35s-3.26-.08-4.21-.82c-1-.78-.13 2.73.95 3.73 3.6 3.2 1.13 2.26 4.12 2.86 1.83.4 4.26 1.4 5.12 1.65.92.26 1-.3 2.3-.21 1.3.04 3.74-.22 6.73.82z'/%3E %3Cpath d='M482.59 358.25s-2.3-1.52-6.85-2.3c-3.13-.57-3-.7-4.17-1-1.39-.43-1.7-.43-4.25-.56-1.26-.09-6.2 1.52-7.38.82-1.08-.6 1.22 1.52 2.6 2.04 2 .74 1.74 2.04 3.91 2.73 2.3.74 4.73 1.65 6.07 1.4 1.05-.22 1.83-.7 3.3-.83 1.43-.18 3.95-2.26 6.77-2.3zM483.07 357.08s1.13-5.47.17-6.77a5.2 5.2 0 0 1-1.21-2.86 10.92 10.92 0 0 0-1.65-4.34c-.6-.78-1.82-4.25-1.52-5.12 0 0-3.17 3.12-3 5.12.14 1.95.14 1.48 0 2.39-.17.9.74 3.9 1.35 4.81.6.91.3 3.65.91 4.21.61.6 4.21 3.04 4.95 2.56z'/%3E %3Cpath d='M482.59 358.25c.35.17-1.9-1.74-3-2.21-1.04-.44-5.24-1.65-5.55-2.7-.3-1.08-3.77-4.68-3.9-5.6-.13-.69-.78-2.12-.61-2.86.13-.73.43-2.56.91-3.6.43-1.08 1.48-3.6 2.56-4.07 0 0 .87 2.86 1.17 3.9.3 1.09.6 2.3 1.09 2.86.43.61 1.95 3.47 2.08 4.56.17 1.04.91 4.51 1.08 5.25.13.74 2.96 3.82 4.17 4.47zM464.11 343.41c.13.78-2.26-.78-3.47-.78s-4.82.48-5.73-.43c-.9-.92-2.25-2.56-2.73-2.87-.44-.3-2.08-3.04-2.56-4.51-.44-1.52-3.6-4.25-4.04-4.56 0 0 4.34-.86 7.08.91 2.69 1.83 2.86 1.4 3.47 1.65.6.3 5.25 4.26 5.55 5.73.3 1.52 2.26 4.08 2.43 4.86z'/%3E %3Cpath d='M464.11 343.41s-3.9-2.73-4.82-2.6c-.9.17-5.16-3-5.42-4.95-.17-1.04-2.21-2.52-2.56-3.17-1.08-1.82-1.7-5.85-3.17-6.94 0 0 4.08 1.04 5.12 1.22 1.96.3 3.6.6 4.34 2.25.78 1.65 1.4 3.04 2 3.17.6.17 1.47 2.26 1.78 4.38.3 2.08 2.73 6.64 2.73 6.64zM456.73 322.89c.65 1.04.6-6.03.87-6.77.3-.74 1.08-2.26 1.69-2.86.6-.61.6-2.7.91-3.3.26-.6.13-4.69-.3-5.73 0 0-1.22.91-1.83 1.65-.6.74-1.64 1.04-1.95 1.95-.3.92-.9.92-1.34 1.83a5.57 5.57 0 0 0-.61 3.6c.3 1.21.13 1.65.13 2.73 0 1.04 1.52 5.55 2.43 6.9z'/%3E %3Cpath d='M456.86 323.49s-.3-1.95.48-2.69c.73-.78 1.47-.78 1.78-1.22.3-.47.17-1.04.47-1.64.3-.61.96-1.61 1.04-2.13.3-1.65 1.22-3.47.44-5.25 0 0-1.65.56-2.08.87-.48.3-1.83 1.52-1.96 2.73-.17 1.35-.3 1.52-.78 2.26-.43.74-1.04 3-.3 4.38a7.4 7.4 0 0 1 .91 2.69zM452.48 300.46s-.3-4.38.91-5.73c1.22-1.34 1.52-3.9 4.21-5.3 0 0-.13 1.1 0 1.83.17.74.48 2.87 0 3.6-.43.78-1.95 2.13-1.95 2.74 0 .6-1.04 2.12-1.78 2.43-.78.26-1.39.43-1.39.43z'/%3E %3Cpath d='M452.48 302.84s0-3.12.91-4.03c.91-.92 1.39-1.4 1.82-1.96.44-.6.91-2.12 1.96-2.73 1.04-.6 2.86-2.13 3.03-2.7 0 0 .44 3.74-.6 5.74-1.09 1.95-1.09 3-2.26 3.42-1.21.48-1.39.79-1.82 1.09-.48.3-1.22.74-1.82.74-.61 0-1.22.43-1.22.43zM455.95 323.36c.17.87.78-1.95-2.39-1.95s-5.72-1.22-6.8-2.3c-1.05-1.04-1.66-1.78-2.1-2.26a8.94 8.94 0 0 1-1.81-3.17c-.13-.86-1.04-4.2-.91-4.81 0 0 1.69.3 2.43.9.73.62 2.12.62 2.86 1.1.74.43 1.34 1.64 1.82 2.08.44.47 1.78.47 2.39 1.34.6.91 1.65 2.87 1.82 3.78.13.9 1.22 1.82 1.95 2.25.74.48.61 2.26.74 3.04z'/%3E %3Cpath d='M455.65 322.15s-2.08-2.56-3.17-2.56c-1.04 0-3.73-2.73-3.9-3.9-.13-1.22-1.04-3.48-1.65-3.95a3.63 3.63 0 0 1-1.52-3.3c.17-1.82.17-4.82.17-4.82s.61 1.83 1.48 2.26c.91.43 2.56 1.04 2.86 1.65.3.6 1.52.6 2 2.43.43 1.78.43 1.65.74 2.26.3.6 1.04 1.34 1.34 2.56.3 1.2 1.95 4.33 1.65 7.37zM452.53 305.53c-.09.82 1.21-1.6-1.65-2.47-2.9-.87-4.9-2.7-5.55-3.95-.65-1.22-1-2.08-1.3-2.6-.26-.57-.87-2.52-.74-3.39.09-.87.22-4.12.52-4.64 0 0 1.43.74 1.9 1.47.53.78 1.79 1.17 2.35 1.78.52.6.74 1.87 1.04 2.43.3.52 1.52.91 1.83 1.87.3 1 .69 3.08.56 3.95-.09.86.6 1.95 1.17 2.6.56.6-.09 2.21-.13 2.95z'/%3E %3Cpath d='M452.57 304.32s-1.21-2.9-2.17-3.17c-.95-.3-2.52-2.77-2.6-3.9-.13-1.3-.3-3.47-.74-4.04-.43-.56-1.21-2.43-.6-4.03.64-1.6 1.64-3.73 1.64-3.73s.87 1.34 1.35 2.17c.78 1.56 1.56 1.69 1.69 2.3.09.65 1.04 1.04 1.39 2.3.48 1.69-.04 1.6.04 2.25.13.6.6 1.52.52 2.7-.04 1.16.6 4.5-.52 7.15zM454.91 286.14c.13-.43 1.04-.91 2.13-1.21 1.04-.3 2.69-2.7 3.42-3.3.7-.65 1.09-1.6 2-2.13.9-.52 1.47-2.39 1.78-4.2 0 0-2.56.6-3.3.73a7.14 7.14 0 0 0-2.86 1.82c-.61.74-1.22 1.96-1.83 2.26-.6.3-1.34 2.12-1.34 3.34v2.69z'/%3E %3Cpath d='M454.78 284.79s-.17-1.78-.17-2.56c0-.91-.57-3.34.73-5.3.92-1.34 4.26-3.9 5.12-4.03 0 0 .61 2.39.48 3.12-.17.79-.95 3.78-1.65 4.08-.7.3-2.43 3.9-4.51 4.69z'/%3E %3Cpath d='M454 286.14c-.39.65-.13-2.26-1.04-3-.91-.77-1.04-1.82-1.04-3.03 0-1.22.26-2.08.43-2.86.13-.74 2.43-3.91 2.26-4.82l1.65 3.77c.47 1.05-.3 2.13-.13 3 .13.9.86 2.56.3 3.47-.48.78-1.82 2.43-2.43 3.47zM461.98 270.61s.17-.43 1.52-.43 3.3-.13 3.9-.74c.61-.6 1.65-1.4 2.26-1.7a5.15 5.15 0 0 0 1.82-2.25c.13-.6 1.22-1.78 1.65-1.78 0 0-1.65-.17-3.47.3-1.78.44-4.34 1.35-4.95 2.56a49.55 49.55 0 0 1-2.73 4.04z'/%3E %3Cpath d='M462.46 270.3c.35 1.04 2.86-1.04 3.43-1.78l1.52-1.95s1.43-1.74 1.82-2.43c.91-1.65.7-4.64.3-4.38-.47.3-2.12 1.21-2.56 1.39-.47.13-1.34.43-1.65 1.17-.3.78-.6 1.82-1.08 2.3-.43.43-3.17 1.95-1.78 5.68z'/%3E %3Cpath d='M461.55 270.3s2.08-1.48 2.86-2.26c.91-.86.44-2.08.91-2.69.4-.56 1.48-1.95 1.18-2.86-.3-.91-.87-3.47-.87-3.47s-1.09 1.04-1.82 1.82c-.78.74-.91 1.35-1.22 2.26-.3.9-.9 1.52-1.21 2.25-.3.74 0 2.26.17 3.17.13.91 0 1.78 0 1.78z'/%3E %3C/g%3E %3Cg stroke-width='.13' fill='none'%3E %3Cpath d='M494.83 365.23s-9.94-.13-10.85-1.35M500.56 366.45s-6.47 1.78-9.94 1.35c-3.47-.44-5.12.3-5.9.3-.73 0-4.51-1.52-4.51-1.52M507.19 368.84s-4.99.91-6.03 1.21c-1.04.3-6.16 2.26-7.68 2.26-1.22 0-4.17-.13-5 0-1.47.3-5.41 0-6.32-.43M488.37 356.95s3.77 2.26 4.38 3c.57.78 3.9 3.47 4.51 3.47M488.37 352.26s6.47 5.6 7.5 6.33c1.1.79 7.43 6.95 8.16 7.86M493.61 349.87s5.12 4.08 5.73 5.73c.6 1.65 2.12 3.6 2.12 3.6s2.13 4.2 2.87 4.81c.73.61 2.25 2.22 4.08 3.34M464.41 346.1s5.38 4.56 6.85 5.42M462.16 348.96s5.42 3.77 7.81 4.68c2.43.87 4.38 1.65 9.63 2.4M481.73 358.16s-6.03-.3-7.07 0-5.73-.78-6.94-1.09c-1.22-.26-6.04-1.17-6.64-1.34M472.53 337.81s-.3 3.3.17 4.69c.44 1.34 2.56 5.24 2.39 6.16-.13.9 1.21 4.99 2.43 5.72M478.73 338.42s-1.08 3.3-.6 4.38c.43 1.04 1.16 3 1.16 4.21s.79 3 1.09 3.77c.3.74-.17 3.3.6 4.04.74.78 1.66 2.13 1.66 2.13M446.49 330.74s4.82 1.82 5.42 3c.57 1.21 1.48 1.51 1.96 2.12M464.24 326.23s1.21 4.82.91 6.03c-.3 1.17-.3 3.6-.3 4.51 0 .91-1.35 4.51-1.22 5.12M462.29 322.15l-.6 4.08c-.14 1.17 0 3.16-.31 3.9-.3.74-.74 4.82 0 6.64M449.06 326.23s3.9 3.3 4.82 4.2c.9.92 4.94 5.26 5.12 6.34.13 1.05 2.99 4.34 3.9 5.12M442.42 309.35s3.9 3.9 4.2 4.82c.31.9 1.96 2.38 2.74 2.86M460.77 311s-1.48 2.26-1.48 3c0 .78-.6 2.73-1.21 3.47-.39.52-1.65 2.73-1.52 4.07M459.6 304.66s-.6 2.13-.91 3.6c-.3 1.52-1.09 3.04-1.35 3.95-.3.91-1.51 5.25-1.08 7.98M445.89 304.53s.43 2.08 1.48 3.17c1.08 1.04 2.73 2.56 2.86 3.42.17.92 1.52 5.43 3.04 6.95a5.4 5.4 0 0 1 1.65 3.03M444.37 289.18s.43 2.56.74 3.3c.3.74 1.52 4.08 2.73 5.12M457.34 289.91s-.78 2.08-.91 3c-.17.9-1.09 1.95-1.22 2.42l-.73 1.96M460.03 291.99c-.13.91-1.82 3.64-1.95 4.08-.18.48-1.04 2.56-1.96 3.17-.9.6-3.6 2.56-3.47 3.34M448.27 286.14s-.13 3.3.48 4.51c.6 1.22 1.34 3.04 1.65 3.95.3.87.3 2.39.43 3.43.17 1.08.6 3.04 1.21 3.77M463.81 275.9s-2.17 2.47-3.17 3.47-4.81 5.12-4.99 5.86M460.21 273.64s-2.13 4.64-2.6 5.38c-.44.78-.87 2-.87 2M454.78 273.47s.13 3.64 0 4.56a7.9 7.9 0 0 0 0 2.86c.13.43-.48 3.73-.6 4.51M472.22 264.14s-4.82 2.86-5.55 3.6'/%3E %3Cpath d='M469.36 260.37l-3.3 4.81-.73 1.39' stroke-width='.1344096'/%3E %3Cpath d='M465.63 259.93s-1.08 2.56-1.21 3.6c-.18 1.09-1.65 4.38-2.26 5.6'/%3E %3Cpath d='M469.23 257.98s-.48 1.04 1.35.74' stroke-width='.26'/%3E %3C/g%3E %3C/g%3E %3Cuse xlink:href='%23a' transform='matrix(-1 0 0 1 1030.05 0)'/%3E %3Cg%3E %3Cpath fill-rule='evenodd' fill='%2300209f' d='M514.57 366.14s.74-1.82 2.26-.17c0 0 1.82 4.25.43 4.38-1.35.17-2.7.43-2.82-.3-.17-.74.13-3.91.13-3.91z'/%3E %3Cpath fill-rule='evenodd' fill='%2300209f' d='M516.52 365.54s.48-6.47 1.35-6.77c.9-.3 3.64-1.82 5.29-.48 1.65 1.4.13 8.07-.48 8.68-.56.6-1.47 2.48-4.95 2.04l-.47-1.65s1.82-.17 3.03-.78c1.22-.6 1.61-1.17 1.52-1.78-.17-.9-.08-4.25-1-4.55-.9-.3-2.34-.74-2.34-.74s-1.34 5.03-1.65 6.46l-.3-.43z'/%3E %3Cpath d='M514.44 370.05s-6.2 3.6-3.04 9.03l-2.12-1.35s-1.17 2.13-.13 3.34c0 0-4.21-3.77-.91-8.29 3.34-4.55 6.03-4.25 6.03-4.25l.17 1.52z' fill-rule='evenodd' stroke='%23000' stroke-miterlimit='2.61' stroke-width='.17' fill='%2300209f'/%3E %3Cpath d='M514.44 367.06s-2.73-1.82-6.64-.78c0 0-1.73-5.6-1.08-7.38.3-.82.9-.9.9-.9s-1.95-1.18-1.34 4.07c.6 5.3 1.65 6.77 1.65 6.77s5.12.3 6.34-.3l.17-1.48z' fill-rule='evenodd' stroke='%23000' stroke-miterlimit='2.61' stroke-width='.17' fill='%2300209f'/%3E %3Cpath d='M514.44 367.06s-5.42-9.07-6.81-9.07c0 0-1.56-.22 1.95-.6 1.22-.14 3.17 0 4.08 1.69.91 1.65 1.65 5.55 1.95 6.16 0 0-1.04.3-1.17 1.82z' fill-rule='evenodd' stroke='%23000' stroke-miterlimit='2.61' stroke-width='.17' fill='%2300209f'/%3E %3Cpath d='M514.44 367.06s-3.64-1.7-4.08-2.13c-.48-.43-1.21-5.55-.78-5.25 0 0-1.47-1.69-1.95-1.69-.3 0-1.35.78-1.04 2.56.3 1.82.73 4.56 1.21 5.73 0 0 2.87-1.17 6.64.78z' fill-rule='evenodd' stroke='%23000' stroke-miterlimit='2.61' stroke-width='.17' fill='%23011322'/%3E %3Cpath d='M517.74 370.05s1.95 1.21 1.95 3.47.91 6.34 2.74 7.25c0 0 .43-1.7 1.04-2 0 0 1.82 2.13 2.39 2.13 0 0-1.05-1.96-1.05-2.87 0-.9-.9-4.38-1.82-5.25-.87-.9-2.69-3.03-5.25-3.77v1.04z' fill-rule='evenodd' stroke='%23000' stroke-miterlimit='2.61' stroke-width='.17' fill='%2300209f'/%3E %3Cpath d='M518.48 359.51l-1.65 6.46.44 1.4s.6-.18.9-.92c.31-.78 1.22-6.33 1.7-6.5l-1.39-.44z' fill-rule='evenodd' stroke='%23000' stroke-miterlimit='2.61' stroke-width='.17' fill='%23011322'/%3E %3Cpath fill-rule='evenodd' fill='%23011d33' d='M514.35 369.31s-2.95.91-4.08 3.21c0 0-.39-1.48 4-3.6l.08.39zM517.83 369.31s2.04.83 2.56 2.04c0 0-1.95-1.3-2.56-1.52v-.52zM514.35 367.58s-4.6.74-5.6.52c0 0 1.4.3 5.69-.09l-.09-.43zM521.82 364.8s.52 2.3.87 2.17c.39-.17 1.17-3.86 1.21-5.6.09-1.69-.73-2.08-1.43-2-.65.05-1.04 1.57-.95 2.26.04.65.21 2.78.3 3.17z'/%3E %3Cpath fill-rule='evenodd' fill='%23011d33' d='M516.83 365.97s1.87 4.17.43 4.38c-1.39.22.61.18-.34-2.69-.4-1.08-1-2.43-1.3-2.43 0 0 1.08.4 1.21.74z'/%3E %3Cpath d='M514.57 366.14s.74-1.82 2.26-.17c0 0 1.82 4.25.43 4.38-1.35.17-2.7.43-2.82-.3-.17-.74.13-3.91.13-3.91z' stroke='%23000' stroke-miterlimit='2.61' stroke-width='.17' fill='none'/%3E %3Cpath d='M516.52 365.54s.48-6.47 1.35-6.77c.9-.3 3.64-1.82 5.29-.48 1.65 1.4.13 8.07-.48 8.68-.56.6-1.47 2.48-4.95 2.04l-.47-1.65s1.82-.17 3.03-.78c1.22-.6 1.61-1.17 1.52-1.78-.17-.9-.08-4.25-1-4.55-.9-.3-2.34-.74-2.34-.74s-1.34 5.03-1.65 6.46l-.3-.43z' stroke='%23000' stroke-miterlimit='2.61' stroke-width='.17' fill='none'/%3E %3C/g%3E %3C/g%3E %3Cg transform='translate(16.13)'%3E %3Cpath fill-rule='evenodd' fill='%2300209f' d='M509.84 255.9c-.4-.95-.48-7.38-.4-8.37.14-1.74 3.13-10.24 3.74-11.24.65-1 .48-1.22.74-1.82l.87-1.18a10.88 10.88 0 0 1 1.25 4.13s-.56 4.08-1.04 5.9c-.43 1.82-1.6 4.34-1.82 4.86-.56 1.26-.52 2.43-.17 2.51l-3.17 5.21z'/%3E %3Cpath fill-rule='evenodd' fill='%23fff' d='M515.01 247.35l.48.52c1.34-1.43 1.43-4.43 1.43-4.43l-.87-6.03s-.56 4.08-1.04 5.9c-.43 1.83-1.6 4.34-1.82 4.86-.87 2.18-.22 2.43-.18 2.52l2-3.34z'/%3E %3Cpath fill-rule='evenodd' fill='%2300209f' d='M515.48 247.87c1.35-1.43 1.43-4.43 1.43-4.43s.96 4.9.44 5.95c-.52 1.04-.52.74-.44 1.26l-1.43-2.78z'/%3E %3Cpath d='M516.91 250.65c-.09-.52-.09-.22.43-1.26.53-1.04-.43-5.94-.43-5.94l-.87-6.03c-.13-1.35-.6-3.04-1.26-4.13l-.86 1.18c-.26.6-.09.82-.74 1.82-.6 1-3.6 9.5-3.73 11.24-.09 1 0 7.42.39 8.37' stroke='%23000' stroke-miterlimit='2.61' stroke-width='.26' fill='none'/%3E %3Cpath d='M515.01 234.11s-.09-.95-.17-1.3c-.05-.18.52.87 1 .74.86.26 1.82 1.43 2.08 1.73-.4.56-1.3 1.65-1.96 1.43-.56-.17-.43-1-.6-1.52-.1-.25-.4-.6-.35-1.08z' fill-rule='evenodd' stroke='%23000' stroke-miterlimit='2.61' stroke-width='.13' fill='%23FC0'/%3E %3Cpath d='M515.05 233.33l.35.4c.21.12.43 0 .7.16.64.44.86.83 1.55 1.52' stroke='%23000' stroke-miterlimit='2.61' stroke-width='.13' fill='none'/%3E %3Cpath d='M515.66 233.99c.82.39 1.26 1.04 1.82 1.73 0 0 .05-.08 0-.08' stroke='%23000' stroke-miterlimit='2.61' stroke-width='.13' fill='none'/%3E %3Cpath d='M514.09 233.42s.87-.43 1.17-.6c.18-.1-.65.77-.34 1.16.04.92-.7 2.22-.96 2.56-.65-.17-1.3-.17-1.82-1.17-.22-.34.39-.74.78-1.08.22-.18.7-.74 1.17-.87z' fill-rule='evenodd' stroke='%23000' stroke-miterlimit='2.61' stroke-width='.13' fill='%23FC0'/%3E %3Cpath d='M514.87 233.16c-.04.09-.26.39-.26.52-.04.22.13.4.09.7-.18.73-.48 1.08-.87 1.99' stroke='%23000' stroke-miterlimit='2.61' stroke-width='.13' fill='none'/%3E %3Cpath d='M514.44 233.99c-.09.91-.52 1.52-1 2.3 0-.04.13 0 .13 0' stroke='%23000' stroke-miterlimit='2.61' stroke-width='.13' fill='none'/%3E %3Cpath d='M515.44 232.81c.6-.74 1.7-1.39 2.21-.95.05.04.48.3.61.56.26.3.22.43.09.78-.4.78-1.44.4-2.09.04-.13-.08-.52-.43-.73-.34-.35.13-.22.13-.35.13.13.08.26.04.35.08.6.18 1.04.52 1.78.87.52.22 1.47-.48 1.43-.95 0-.57-.91-1.57-1.35-1.57-1 0-1.78.61-2.47 1.4.17-.14.39.12.52-.05z' fill-rule='evenodd' stroke='%23000' stroke-miterlimit='2.61' stroke-width='.13' fill='%23FC0'/%3E %3Cpath d='M514.87 232.81c-.56-.74-1.65-1.39-2.17-.95-.04.04-.48.3-.6.56-.27.26-.27.43-.1.78.35.78 1.44.4 2.05.04.17-.08.56-.43.78-.34.34.13.21.13.34.13-.13.08-.26.04-.39.08-.56.18-1 .52-1.78.87-.52.22-1.43-.48-1.43-.95.05-.61.96-1.57 1.4-1.57.99 0 1.77.61 2.42 1.4-.13-.14-.35.12-.52-.05z' fill-rule='evenodd' stroke='%23000' stroke-miterlimit='2.61' stroke-width='.13' fill='%23FC0'/%3E %3Cpath d='M515.09 232.38c-.26-.09-.56.17-.65.35-.09.21.09.56.35.6.34.13.82.05.9-.34.1-.35-.3-.44-.6-.61z' fill-rule='evenodd' stroke='%23000' stroke-miterlimit='2.61' stroke-width='.13' fill='%23FC0'/%3E %3Cpath fill-rule='evenodd' fill='%23FC0' d='M515.05 226.35s.4 2.34 1.56 4.04-1.43 1.47-1.6 2.08c0 0-.78-1.7-1.6-2.13 0 0 1.3-2.04 1.64-3.95v-.04z'/%3E %3Cpath d='M515.05 226.35s.4 2.34 1.56 4.04c0 0-1.43 1.47-1.6 2.08 0 0-.78-1.7-1.6-2.13 0 0 1.3-2.04 1.64-3.95' stroke='%23000' stroke-miterlimit='2.61' stroke-width='.13' fill='none'/%3E %3Cpath d='M515.01 228.82s.3 1.04.65 1.74c0 0-.56.43-.65.69 0 0-.3-.7-.6-.87 0 0 .56-.9.6-1.56z' stroke='%23000' stroke-miterlimit='2.61' stroke-width='.13' fill='none'/%3E %3Cg%3E %3Cpath fill-rule='evenodd' fill='%23fff' d='M515.01 344.54c-.09 0-.22-.17-.35-.22-.39-.26-1.12-.26-1.3-.47-1.04-1.18-.35-3.43.09-4.82.87-2.6 1-4.99 1.56-7.46h.04c.57 2.47.7 4.86 1.52 7.46.48 1.39 1.17 3.64.13 4.82-.21.21-.9.21-1.3.47-.13.05-.26.22-.39.22z'/%3E %3Cpath fill-rule='evenodd' fill='%2300209f' d='M515.01 331.48c.56 2.47.74 4.99 1.56 7.6.44 1.3 1.09 3.38.3 4.55v-.04c.4 0 .74-.14 1.1-.27.12-.04.25-.08.3-.21.12-.22.3-.4.47-.52.26-.18.57-.05.83-.22.08-.09.13-.17.17-.17.52-.26 1.04-.57 1.26-1.13.13-.4.17-.83.09-1.26-.05-.3-.18-.52-.27-.78l-.52-1.17c-.17-.4-.43-.74-.6-1.13a2.35 2.35 0 0 0-.3-.57c-.1-.17-.22-.34-.31-.52-.09-.17-.3-.3-.44-.47-.17-.18-.21-.18-.34-.3-.05-.05-.26-.1-.22-.18-.09 0-.22-.09-.26-.13-.35-.74-.65-1.13-1-1.87-.17-.3-.21-.86-.21-1.21H515z'/%3E %3Cpath fill-rule='evenodd' fill='%2300209f' d='M515.01 331.48c-.52 2.47-.7 4.99-1.56 7.6-.4 1.3-1.04 3.38-.26 4.55l-.05-.04h.05c-.4 0-.74-.14-1.13-.27-.09-.04-.22-.08-.3-.21a1.37 1.37 0 0 0-.48-.52c-.22-.18-.52-.05-.78-.22-.09-.09-.13-.17-.22-.17-.52-.26-1-.57-1.21-1.13-.13-.4-.18-.83-.09-1.26.04-.3.17-.52.26-.78l.52-1.17c.17-.4.4-.74.6-1.13.1-.22.18-.4.31-.57.09-.17.17-.34.3-.52.1-.17.3-.3.44-.47.17-.18.22-.18.35-.3.04-.05.26-.1.21-.18.09 0 .22-.09.22-.13.39-.74.7-1.13 1.04-1.87.17-.3.22-.86.22-1.21H515z'/%3E %3Cg id='b' stroke-width='.17' stroke-miterlimit='2.61' fill='none'%3E %3Cpath d='M514.27 331.57s-1 4.08-1.56 5.12c-.6 1.04-2.95 2.95-1.43 5.9' stroke='%23011322'/%3E %3Cpath d='M514.35 331.57s-.95 4.12-1.56 5.16c-.61 1.09-2.91 3.04-1.35 6' stroke='%23011d33'/%3E %3Cpath d='M514.48 331.57s-1 4.16-1.6 5.25c-.57 1.04-2.87 3.08-1.26 6.03' stroke='%23022743'/%3E %3Cpath d='M514.57 331.57s-.95 4.25-1.56 5.3c-.6 1.03-2.87 3.12-1.26 6.15' stroke='%23033054'/%3E %3Cpath d='M514.7 331.57s-1 4.3-1.6 5.38c-.61 1.04-2.83 3.17-1.18 6.2' stroke='%23053a65'/%3E %3Cpath d='M514.18 331.57s-.95 3.95-1.6 5.08c-.61 1.08-2.96 3-1.4 5.9' stroke='%23011d33'/%3E %3Cpath d='M514.05 331.61s-.91 3.77-1.6 5.03c-.61 1.04-2.96 2.95-1.4 5.86' stroke='%23022743'/%3E %3Cpath d='M513.96 331.61s-.91 3.64-1.65 4.99c-.56 1.04-2.95 2.95-1.39 5.9' stroke='%23033054'/%3E %3Cpath d='M513.83 331.61s-.82 3.56-1.65 4.95c-.56 1.08-2.9 2.95-1.39 5.9' stroke='%23053a65'/%3E %3Cpath d='M513.75 331.65s-.82 3.38-1.65 4.9c-.6 1.04-2.95 2.95-1.39 5.86' stroke='%2300209f'/%3E %3Cpath d='M514.79 331.57s-.95 4.38-1.56 5.42c-.6 1.05-2.78 3.26-1.17 6.34' stroke='%2300209f'/%3E %3C/g%3E %3Cuse xlink:href='%23b' transform='matrix(-1 0 0 1 1030.05 0)'/%3E %3Cpath d='M518.65 335.17c.13.17.35.3.43.48.1.17.22.35.3.52.14.17.23.35.31.56.17.4.44.74.6 1.13l.53 1.17c.09.26.22.48.26.78.09.44.04.87-.09 1.26-.21.57-.73.87-1.25 1.13-.05 0-.1.09-.18.17-.26.18-.56.05-.82.22-.18.13-.35.3-.48.52-.04.13-.17.18-.3.22-.35.13-.7.26-1.09.26v.04-.04c-.04.09-.13.17-.17.26-.22.22-.91.22-1.3.48-.13.04-.26.21-.4.21-.08 0-.21-.17-.34-.21-.4-.26-1.13-.26-1.3-.48-.09-.09-.13-.17-.18-.26v.04l-.04-.04h.04c-.39 0-.73-.13-1.12-.26-.1-.04-.22-.09-.3-.22a1.37 1.37 0 0 0-.49-.52c-.21-.17-.52-.04-.78-.22-.08-.08-.13-.17-.21-.17-.52-.26-1-.56-1.22-1.13-.13-.39-.17-.82-.08-1.26.04-.3.17-.52.26-.78l.52-1.17c.17-.39.39-.74.6-1.13.1-.21.18-.39.3-.56.1-.17.18-.35.31-.52.09-.18.3-.3.44-.48' stroke='%23000' stroke-miterlimit='2.61' stroke-width='.17' fill='none'/%3E %3C/g%3E %3Cg id='c'%3E %3Cg fill-rule='evenodd'%3E %3Cpath fill='%23fff' d='M487.37 293.56c-1.48-3.69-3.04-11.24-2.95-12.97.3-7.12.22-9.24.87-16.53l7.33 8.37c-.17 2.82-.22 3.69 0 5.47.09.65.48 3.86 1 5.12l-6.25 10.54z'/%3E %3Cpath fill='%2300209f' d='M493.61 283.01c-.52-1.26-.91-4.47-1-5.12-.21-1.78-.17-2.65 0-5.47l4.51 5-3.51 5.59zM474.96 289.91a75.47 75.47 0 0 1-.26-4.3c.04-5.11-.56-7.98 0-13.4.43-4.25 1.47-9.85 1.26-14.45-.09-1.3.17-2.6.21-3.86l9.12 10.15c-.65 7.3-.57 9.42-.87 16.53-.09 1.74 1.47 9.29 2.95 12.97l-1.9 3.21-10.51-6.85zM481.34 303.67c-.6-1-1.13-3.86-1.26-4.43-.3-1.51-.3-2.38-.21-4.98l5.03 3.3-3.56 6.11zM466.97 327.7a5.23 5.23 0 0 1-1.82-2.21c-.61-1.74-.48-1.7-.91-3.6-.26-1.09-.26-2.3-.52-3.43-.22-1.13-1.83-4.73-1.87-6.2-.17-4.73-1.74-7.95-1.35-13.1.27-4 1.18-9.42.74-13.59-.13-1.13.05-2.43.09-3.56l10.24 6.68c-.4 6.86-.22 8.77-.22 15.4-.04 1.61 1.39 8.12 3.13 11.03l-7.51 12.58zM483.98 331.48c1.91 1.74 5.42 2.65 5.99 3.04 1.26.9 3.12 2.25 6.29 2.43 2.34.17 3.38-.44 5.77-.74 2.73-.35-.35.09 2.3-.48 1.34-.34 1.34-.56 3.17-1 1.34-.3 2.69-.65 3.51-1.77.3-.44.57-.79.6-1.48h1.83c.17.52-.35 1.52-.52 1.87l-.48.65c-.26.56-.21.43-.7.87-.12.08-.68.56-.86.65-.34.26-.7.6-1.08.65-1.78.3-2.52.69-4.21 1.17-1.6.48-.74.39-1.95.7-.61.12-1.83.6-2.43.69-1.09.17-1.26.34-2.39.6-2.9.65-5.73.48-8.6.3-1.16-.08-4.03-.69-5.02-1.38-1.78-1.26-5.69-1.74-7.42-2.95-.26-.18-1.35-.7-1.56-.91-1.7-1.4-3.04-1.78-4.82-2.91h12.58z'/%3E %3Cpath fill='%2300209f' d='M497.74 331.48h13.88c-.04.7-.3 1.04-.6 1.48-.83 1.12-2.17 1.47-3.52 1.77-1.43.35-2.9-.43-4.42-.43-3.65-1.13-4.08-2.26-5.34-2.82z'/%3E %3Cpath fill='%23fff' d='M497.74 331.48c1.26.65 1.87 1.74 5.34 2.82 1.34 0 2.82.6 4.08.57-1.52.34-1.57.56-2.82.86-2.65.57.43.13-2.3.48-2.39.3-3.43.91-5.77.74a10.98 10.98 0 0 1-6.3-2.43c-.56-.4-4.07-1.3-5.98-3.04h13.75z'/%3E %3C/g%3E %3Cg fill='none' stroke-width='.17' stroke-miterlimit='2.61'%3E %3Cpath d='M476.65 259.71s1.7 14.97 7.5 14.4' stroke='%23022743'/%3E %3Cpath d='M484.16 274.03c-2.9.13-4.82-3.56-5.9-7.03a46.5 46.5 0 0 1-1.6-7.33' stroke='%23022847'/%3E %3Cpath d='M484.16 273.99c-2.9-.09-4.82-3.82-5.81-7.07a43.45 43.45 0 0 1-1.7-7.3' stroke='%23032b4c'/%3E %3Cpath d='M484.2 273.95c-2.9-.26-4.86-4.08-5.81-7.12-1.13-3.34-1.7-7.15-1.74-7.24' stroke='%23032d4f'/%3E %3Cpath d='M484.2 273.9c-2.9-.48-4.86-4.38-5.77-7.16-1.13-3.25-1.74-7.11-1.78-7.24' stroke='%23032f53'/%3E %3Cpath d='M484.24 273.82c-2.95-.6-4.9-4.6-5.73-7.16-1.12-3.17-1.82-7.07-1.86-7.2' stroke='%23043258'/%3E %3Cpath d='M484.24 273.77c-2.9-.82-4.9-4.86-5.68-7.2a45.91 45.91 0 0 1-1.87-7.16' stroke='%2304345b'/%3E %3Cpath d='M484.29 273.73c-2.95-1-4.95-5.12-5.68-7.29a48.7 48.7 0 0 1-1.91-7.07' stroke='%2304365e'/%3E %3Cpath d='M484.29 273.69c-2.95-1.21-4.95-5.38-5.6-7.33a47.62 47.62 0 0 1-2-7.07' stroke='%23043862'/%3E %3Cpath d='M484.29 273.6c-2.9-1.35-4.95-5.64-5.55-7.33-1.13-2.74-2-6.77-2.04-7.03' stroke='%23053b67'/%3E %3Cpath d='M484.33 273.55c-2.95-1.52-4.99-5.9-5.55-7.38a50.33 50.33 0 0 1-2.09-6.98' stroke='%23053d6a'/%3E %3Cpath d='M484.33 273.51c-2.95-1.74-4.99-6.16-5.47-7.42a45.61 45.61 0 0 1-2.17-6.94' stroke='%23053f6e'/%3E %3Cpath d='M484.37 273.47c-2.95-1.9-5.03-6.42-5.47-7.5-1.08-2.4-2.12-6.56-2.21-6.9' stroke='%23064172'/%3E %3Cpath d='M476.69 259.02c.09.39 1.17 4.56 2.26 6.85.39.83 2.47 5.43 5.42 7.51' stroke='%2300209f'/%3E %3Cg%3E %3Cpath d='M476.87 256.33s4.86 11.89 7.94 10.54' stroke='%23022743'/%3E %3Cpath d='M484.81 266.87c-1.35.56-3.34-1.82-4.95-4.6-1.73-3.04-3-5.99-3-5.99' stroke='%23022a49'/%3E %3Cpath d='M484.81 266.83c-1.17.52-3.25-1.78-4.9-4.64-1.78-3.17-3.04-5.95-3.04-5.95' stroke='%23032d4f'/%3E %3Cpath d='M484.81 266.79c-1 .43-3.17-1.74-4.86-4.69a91.75 91.75 0 0 1-3.04-5.9' stroke='%23033054'/%3E %3Cpath d='M484.81 266.79c-.82.35-3.12-1.74-4.77-4.77-1.95-3.47-3.13-5.86-3.13-5.86' stroke='%23043359'/%3E %3Cpath d='M484.85 266.74c-.7.3-3.08-1.7-4.77-4.82-2-3.64-3.13-5.85-3.13-5.85' stroke='%23043760'/%3E %3Cpath d='M484.85 266.74c-.52.22-3-1.7-4.73-4.9a749.46 749.46 0 0 0-3.17-5.82' stroke='%23053a65'/%3E %3Cpath d='M484.85 266.7c-.35.17-2.9-1.65-4.69-4.95-2.12-3.94-3.16-5.77-3.16-5.77' stroke='%23053d6a'/%3E %3Cpath d='M484.85 266.7c-.17.04-2.82-1.65-4.64-4.99-2.17-4.12-3.21-5.77-3.21-5.77' stroke='%23064171'/%3E %3Cpath d='M477 255.9s1.04 1.43 3.25 5.73c1.83 3.42 4.6 5.03 4.6 5.03' stroke='%2300209f'/%3E %3C/g%3E %3Cg%3E %3Cpath d='M492.88 278.72l3.77-.7M492.62 274.86l4.08 2.21' stroke='%2300209f'/%3E %3Cpath d='M492.53 275.03l4.17 2.04' stroke='%23064171'/%3E %3Cpath d='M492.53 275.2l4.21 1.91' stroke='%23053e6c'/%3E %3Cpath d='M492.53 275.42l4.21 1.74' stroke='%23053b67'/%3E %3Cpath d='M492.57 275.59l4.21 1.61' stroke='%23043862'/%3E %3Cpath d='M492.57 275.77l4.26 1.43' stroke='%2304355c'/%3E %3Cpath d='M492.57 275.94l4.3 1.3' stroke='%23043258'/%3E %3Cpath d='M492.57 276.11l4.34 1.18' stroke='%23032f53'/%3E %3Cpath d='M492.57 276.33l4.39 1' stroke='%23032c4d'/%3E %3Cpath d='M492.57 276.51l4.43.86' stroke='%23022a49'/%3E %3Cpath d='M492.83 278.54l3.87-.56' stroke='%23064171'/%3E %3Cpath d='M492.83 278.33l3.91-.44' stroke='%23053e6c'/%3E %3Cpath d='M492.79 278.11l3.99-.26' stroke='%23053b67'/%3E %3Cpath d='M492.79 277.94l4.04-.13' stroke='%23043862'/%3E %3Cpath d='M492.75 277.72h4.12' stroke='%2304355c'/%3E %3Cpath d='M492.75 277.5l4.16.18' stroke='%23043258'/%3E %3Cpath d='M492.75 277.33l4.21.26' stroke='%23032f53'/%3E %3Cpath d='M492.7 277.11l4.34.44' stroke='%23032c4d'/%3E %3Cpath d='M492.7 276.9l4.39.6' stroke='%23022a49'/%3E %3Cpath d='M492.66 276.72l4.47.7' stroke='%23022743'/%3E %3C/g%3E %3Cg%3E %3Cpath d='M474.96 277.81s.22 3.17.91 4.51c1 1.87 3.9 4.73 7.25 6.81' stroke='%23022743'/%3E %3Cpath d='M483.2 289.13a27.13 27.13 0 0 1-5.47-4.64c-.73-.78-1.34-1.6-1.73-2.26-.7-1.39-1-4.51-1-4.51' stroke='%23022847'/%3E %3Cpath d='M483.29 289.13a27.18 27.18 0 0 1-5.42-4.73 9.4 9.4 0 0 1-1.7-2.3c-.78-1.39-1.17-4.47-1.17-4.47' stroke='%23032b4c'/%3E %3Cpath d='M483.33 289.13a31.29 31.29 0 0 1-5.34-4.77c-.7-.78-1.3-1.6-1.69-2.35-.82-1.47-1.3-4.46-1.3-4.46' stroke='%23032d4f'/%3E %3Cpath d='M483.42 289.09a31.37 31.37 0 0 1-5.34-4.82 13.6 13.6 0 0 1-1.65-2.34c-.86-1.52-1.43-4.47-1.43-4.47' stroke='%23032f53'/%3E %3Cpath d='M483.5 289.09c-2.13-1.43-4.04-3.56-5.3-4.9a12.7 12.7 0 0 1-1.64-2.35c-.91-1.56-1.52-4.46-1.52-4.46' stroke='%23043258'/%3E %3Cpath d='M483.59 289.09c-2.13-1.48-4.04-3.69-5.25-4.99-.6-.7-1.17-1.52-1.65-2.34-.95-1.65-1.65-4.47-1.65-4.47' stroke='%2304345b'/%3E %3Cpath d='M483.63 289.09c-2.04-1.52-4-3.82-5.16-5.08a13.94 13.94 0 0 1-1.65-2.34c-1-1.7-1.78-4.47-1.78-4.47' stroke='%2304365e'/%3E %3Cpath d='M483.72 289.05c-2.04-1.48-4-3.86-5.12-5.12-.56-.6-1.13-1.48-1.65-2.34a25.88 25.88 0 0 1-1.9-4.47' stroke='%23043862'/%3E %3Cpath d='M483.81 289.05c-2.04-1.52-4-4-5.08-5.2a13.74 13.74 0 0 1-1.65-2.35c-1.08-1.82-2-4.47-2-4.47' stroke='%23053b67'/%3E %3Cpath d='M483.85 289.05c-2-1.52-3.9-4.12-4.99-5.3a16.7 16.7 0 0 1-1.65-2.34 40.98 40.98 0 0 1-2.12-4.47' stroke='%23053d6a'/%3E %3Cpath d='M483.94 289.05c-2-1.56-3.9-4.2-4.95-5.34a18.64 18.64 0 0 1-1.65-2.38 50.69 50.69 0 0 1-2.25-4.47' stroke='%23053f6e'/%3E %3Cpath d='M484.03 289c-2-1.56-3.9-4.3-4.9-5.38a16.03 16.03 0 0 1-1.6-2.39c-1.22-2-2.44-4.47-2.44-4.47' stroke='%23064172'/%3E %3Cpath d='M475.09 276.68s2.82 5.34 4.17 6.85c.95 1.05 2.86 3.91 4.86 5.47' stroke='%2300209f'/%3E %3C/g%3E %3Cg%3E %3Cpath d='M475.17 289.91c3.08 2.04 3.86 2.56 10.24 6.64l1.95-3s-.74-1.77-1.04-2.6' stroke='%23011d33'/%3E %3Cpath d='M475.22 289.87c2.95 2 3.95 2.65 10.2 6.55l.08-.08c0-.05 1.74-2.91 1.74-2.91s-.09-.35-.3-.78c-.22-.57-.48-1.22-.61-1.7' stroke='%23011e34'/%3E %3Cpath d='M475.22 289.87c2.86 1.91 4.12 2.73 10.2 6.47l.08-.14c0-.08 1.65-2.9 1.65-2.9s-.09-.3-.26-.74c-.22-.52-.43-1.17-.56-1.6' stroke='%23022037'/%3E %3Cpath d='M475.22 289.87a262.6 262.6 0 0 0 10.2 6.33l.08-.13c0-.08 1.56-2.86 1.52-2.86 0 0-.04-.3-.22-.7-.17-.51-.39-1.12-.52-1.56' stroke='%23022139'/%3E %3Cpath d='M475.22 289.83c2.69 1.78 4.47 2.86 10.2 6.25l.08-.13c0-.13 1.43-2.87 1.43-2.87s0-.26-.17-.65a8.23 8.23 0 0 1-.48-1.47' stroke='%2302223b'/%3E %3Cpath d='M475.26 289.83c2.56 1.7 4.6 2.95 10.15 6.12.05 0 .09-.13.09-.13 0-.18 1.34-2.82 1.34-2.87-.04 0 0-.21-.17-.6-.17-.48-.3-.96-.4-1.4' stroke='%2302233d'/%3E %3Cpath d='M475.26 289.78c2.47 1.65 4.77 3.04 10.2 6.03 0 0 .04-.13.08-.13 0-.22 1.22-2.82 1.18-2.82 0 0 .04-.22-.1-.6-.17-.44-.3-.87-.34-1.3' stroke='%23022540'/%3E %3Cpath d='M475.26 289.78c2.39 1.6 4.95 3.08 10.2 5.9l.08-.13c0-.22 1.09-2.78 1.09-2.82 0 0 .09-.17-.09-.52a4.8 4.8 0 0 1-.3-1.26' stroke='%23022541'/%3E %3Cpath d='M475.26 289.78c2.3 1.52 5.12 3.17 10.2 5.81 0-.04.08-.17.08-.17 0-.26 1-2.78.96-2.82 0 0 .13-.13 0-.48a4.1 4.1 0 0 1-.26-1.17' stroke='%23022743'/%3E %3Cpath d='M475.3 289.74a92.52 92.52 0 0 0 10.15 5.73c0-.05.09-.13.09-.18 0-.3.87-2.77.87-2.77s.13-.13 0-.48c-.18-.39-.18-.7-.18-1.08' stroke='%23022847'/%3E %3Cpath d='M475.3 289.74a80.65 80.65 0 0 0 10.15 5.6.33.33 0 0 0 .09-.18c0-.34.78-2.73.74-2.77 0 0 .21-.13.08-.44-.17-.39-.13-.6-.13-1' stroke='%23022a49'/%3E %3Cpath d='M475.3 289.74c2 1.3 5.55 3.38 10.15 5.47.05-.05.09-.13.13-.18-.04-.34.65-2.73.61-2.73 0-.04.22-.13.09-.43-.13-.35-.09-.52-.09-.91' stroke='%23032a4a'/%3E %3Cpath d='M475.35 289.7a67.74 67.74 0 0 0 10.11 5.38l.13-.17c0-.4.52-2.7.48-2.74 0 0 .26-.08.17-.34-.17-.35-.09-.48-.04-.87' stroke='%23032b4c'/%3E %3Cpath d='M475.35 289.7a62.3 62.3 0 0 0 10.11 5.25c.04 0 .13-.13.13-.17 0-.44.43-2.7.39-2.74 0 0 .3-.04.17-.3-.13-.35 0-.4.05-.78' stroke='%23032d4f'/%3E %3Cpath d='M475.35 289.7c1.7 1.08 6.03 3.6 10.15 5.16 0-.04.09-.17.09-.21 0-.44.35-2.65.3-2.7h-.04s.35-.04.26-.3c-.13-.3 0-.3.09-.7' stroke='%23032e50'/%3E %3Cpath d='M475.35 289.65c1.6 1.08 6.2 3.69 10.15 5.08a.46.46 0 0 0 .09-.22c0-.48.22-2.65.17-2.69l.26-.26c-.13-.26.05-.26.18-.6' stroke='%23032f53'/%3E %3Cpath d='M475.39 289.65c1.48 1 6.33 3.77 10.11 4.95a.46.46 0 0 0 .09-.22c0-.52.13-2.65.08-2.7 0 0 .4.05.3-.16-.12-.3.1-.22.18-.57' stroke='%23033156'/%3E %3Cpath d='M475.39 289.61c1.39.95 6.5 3.86 10.11 4.86.04-.04.09-.17.13-.22 0-.56-.04-2.6-.09-2.64 0 0 .44.04.35-.18-.09-.26.13-.13.26-.47' stroke='%23043258'/%3E %3Cpath d='M475.39 289.61c1.3.87 6.68 3.9 10.11 4.73.04-.04.09-.17.13-.22 0-.56-.13-2.6-.17-2.64 0 0 .43.08.39-.13-.13-.22.13-.05.3-.4' stroke='%23043359'/%3E %3Cpath d='M475.39 289.61c1.21.78 6.81 4 10.11 4.6.04-.04.13-.13.13-.22 0-.6-.22-2.56-.3-2.64 0 0 .52.13.43-.1-.09-.2.22.05.39-.3' stroke='%2304355c'/%3E %3Cpath d='M475.43 289.57c1.08.74 6.94 4.08 10.07 4.56.04-.09.13-.18.13-.26 0-.65-.35-2.56-.4-2.6 0 0 .53.08.44-.05-.04-.22.26.09.43-.26' stroke='%2304365e'/%3E %3Cpath d='M475.43 289.57c1 .65 7.12 4.17 10.07 4.43.08-.1.13-.18.13-.26 0-.65-.44-2.52-.52-2.6 0 0 .56.12.52 0-.1-.18.3.12.47-.18' stroke='%23043760'/%3E %3Cpath d='M475.43 289.57c.91.56 7.29 4.2 10.11 4.3l.13-.26c-.04-.7-.56-2.52-.65-2.6 0 0 .6.17.52.04-.04-.18.35.21.56-.09' stroke='%23043862'/%3E %3Cpath d='M475.48 289.52c.78.52 7.42 4.3 10.07 4.2.04-.03.08-.16.13-.25 0-.74-.7-2.52-.74-2.56h-.05s.66.17.61.04c-.04-.13.35.3.61 0' stroke='%23053a65'/%3E %3Cpath d='M475.48 289.52c.7.48 7.6 4.38 10.07 4.08.04-.04.13-.17.13-.26a7.8 7.8 0 0 0-.87-2.56s.65.21.6.13c-.04-.13.44.34.7.04' stroke='%23053b67'/%3E %3Cpath d='M475.48 289.52c.6.4 7.77 4.43 10.07 3.95.04-.04.13-.18.13-.26 0-.78-.87-2.47-.96-2.52v-.04s.7.26.65.17c-.04-.13.44.44.7.13' stroke='%23053c68'/%3E %3Cpath d='M475.48 289.48c.52.35 7.94 4.51 10.07 3.9a.47.47 0 0 0 .13-.3c0-.82-1-2.43-1.09-2.51 0 0 .74.26.7.17-.05-.09.47.52.78.22' stroke='%23053e6c'/%3E %3Cpath d='M475.52 289.48c.4.26 8.07 4.6 10.02 3.77.09-.08.13-.21.18-.3-.05-.87-1.13-2.43-1.22-2.52 0 0 .74.3.74.22-.05-.04.52.6.82.3' stroke='%23053f6e'/%3E %3Cpath d='M475.52 289.48c.3.17 8.2 4.64 10.02 3.64.09-.08.13-.21.18-.3 0-.87-1.26-2.43-1.35-2.47 0 0 .82.3.78.26 0-.09.56.6.91.35' stroke='%23053f6f'/%3E %3Cpath d='M475.52 289.43c.22.13 8.37 4.73 10.02 3.56a.7.7 0 0 0 .18-.3c0-.92-1.35-2.4-1.44-2.48 0 0 .83.35.83.3-.05-.04.6.7.9.44' stroke='%23064171'/%3E %3Cpath d='M475.52 289.43c.13.04 8.55 4.82 10.07 3.43.04-.09.13-.18.13-.3 0-.96-1.44-2.4-1.57-2.48l.87.35s.65.78 1 .52' stroke='%23064374'/%3E %3Cpath d='M475.57 289.39s9.72 5.47 10.15 3.04c0-1-1.65-2.43-1.65-2.43l.91.34s.66.87 1.05.61' stroke='%2300209f'/%3E %3C/g%3E %3Cg%3E %3Cpath d='M474.44 315.12l-7.55 12.58a5.23 5.23 0 0 1-1.82-2.21c-.57-1.74-.48-1.74-.91-3.6-.22-1.09-.26-2.3-.48-3.43-.26-1.13-1.87-4.73-1.91-6.2' stroke='%23011d33'/%3E %3Cpath d='M461.77 312.26c.04 1.48 1.65 4.99 1.91 6.12.22 1.13.26 2.34.48 3.43.43 1.86.34 1.82.95 3.55a5.15 5.15 0 0 0 1.78 2.22c.04 0 7.5-12.46 7.55-12.46' stroke='%23011d33'/%3E %3Cpath d='M461.77 312.26c.04 1.43 1.65 4.95 1.87 6.07.26 1.13.3 2.3.56 3.39.43 1.82.3 1.82.91 3.56.3.82 1.26 1.82 1.78 2.17.04 0 7.46-12.28 7.55-12.33' stroke='%23011e34'/%3E %3Cpath d='M461.77 312.26c.04 1.43 1.6 4.9 1.87 6.03.26 1.09.3 2.26.56 3.34.43 1.82.3 1.78.91 3.52.3.82 1.26 1.78 1.78 2.12.09.05 7.46-12.1 7.55-12.15' stroke='%23011e34'/%3E %3Cpath d='M461.77 312.26c.04 1.39 1.6 4.86 1.87 5.94.26 1.13.3 2.26.56 3.34.43 1.78.35 1.78.91 3.48a5.5 5.5 0 0 0 1.78 2.12c.13.05 7.42-11.97 7.55-12.02' stroke='%23011f36'/%3E %3Cpath d='M461.77 312.26c.04 1.39 1.6 4.82 1.87 5.9.26 1.09.3 2.26.56 3.3.43 1.78.35 1.73.95 3.43.3.82 1.22 1.77 1.78 2.12.09.05 7.34-11.84 7.51-11.89' stroke='%23011f36'/%3E %3Cpath d='M461.77 312.26c.04 1.39 1.56 4.73 1.87 5.81.26 1.09.3 2.26.56 3.3.43 1.74.35 1.74.95 3.38.3.83 1.22 1.78 1.78 2.13.13.05 7.34-11.71 7.51-11.76' stroke='%23022037'/%3E %3Cpath d='M461.77 312.26c.04 1.35 1.56 4.69 1.87 5.77.26 1.09.3 2.21.56 3.26.43 1.73.39 1.73.95 3.33.3.83 1.22 1.78 1.78 2.09.18.08 7.3-11.5 7.51-11.59' stroke='%23022037'/%3E %3Cpath d='M461.77 312.26c.04 1.35 1.56 4.64 1.87 5.73.26 1.04.3 2.17.56 3.2.43 1.7.39 1.7 1 3.35.3.78 1.21 1.69 1.73 2.04.18.04 7.3-11.37 7.51-11.46' stroke='%23022139'/%3E %3Cpath d='M461.77 312.26c.04 1.3 1.56 4.6 1.87 5.64.26 1.09.3 2.17.56 3.21.43 1.7.39 1.7 1 3.3.3.78 1.21 1.69 1.73 2.04.22.04 7.25-11.24 7.51-11.33' stroke='%23022139'/%3E %3Cpath d='M461.77 312.26c.04 1.3 1.52 4.56 1.87 5.6.26 1.04.3 2.12.6 3.16.44 1.7.35 1.65.96 3.26.3.78 1.21 1.7 1.73 2.04.26.04 7.2-11.11 7.51-11.2' stroke='%23022139'/%3E %3Cpath d='M461.77 312.26c.04 1.3 1.52 4.47 1.87 5.55.26 1 .3 2.13.6 3.08.44 1.7.4 1.7.96 3.26.3.78 1.21 1.69 1.73 2 .26.08 7.2-10.94 7.51-11.03' stroke='%2302223b'/%3E %3Cpath d='M461.77 312.26c.04 1.26 1.52 4.43 1.87 5.47.26 1.04.3 2.12.6 3.08.44 1.69.4 1.69 1 3.2.3.79 1.17 1.66 1.7 2 .3.09 7.15-10.76 7.5-10.89' stroke='%2302223b'/%3E %3Cpath d='M461.77 312.26c.04 1.26 1.52 4.38 1.87 5.42.26 1 .3 2.09.6 3.04.44 1.65.4 1.65 1 3.21.3.74 1.17 1.6 1.74 1.95.3.1 7.07-10.63 7.46-10.76' stroke='%2302233d'/%3E %3Cpath d='M461.77 312.26c.04 1.22 1.48 4.34 1.87 5.38.26 1 .3 2.04.6 3 .44 1.64.44 1.64 1 3.16.3.74 1.22 1.6 1.74 1.95.3.09 7.07-10.5 7.46-10.63' stroke='%2302233d'/%3E %3Cpath d='M461.77 312.26c.04 1.22 1.48 4.3 1.87 5.3.26 1 .34 2.03.6 2.99.44 1.6.44 1.6 1 3.12.35.74 1.22 1.6 1.74 1.91.34.13 7.03-10.33 7.46-10.46' stroke='%2302233e'/%3E %3Cpath d='M461.77 312.26c.04 1.17 1.48 4.2 1.87 5.25.26 1 .34 2 .6 2.95.44 1.6.44 1.6 1.04 3.08.3.74 1.18 1.6 1.7 1.91.39.13 7.03-10.2 7.46-10.33' stroke='%2302233e'/%3E %3Cpath d='M461.77 312.21c.04 1.22 1.48 4.2 1.82 5.25.3.95.4 2 .65 2.9.44 1.57.44 1.61 1.04 3.05a5.2 5.2 0 0 0 1.7 1.9c.39.14 6.98-10.02 7.46-10.19' stroke='%23022540'/%3E %3Cpath d='M461.77 312.21c.04 1.22 1.43 4.17 1.82 5.16.3.96.4 2 .65 2.91.48 1.56.48 1.56 1.04 3.04.3.7 1.18 1.52 1.7 1.82.43.13 6.94-9.85 7.46-10.02' stroke='%23022540'/%3E %3Cpath d='M461.77 312.21c.04 1.17 1.43 4.12 1.82 5.12.26.95.4 1.95.7 2.86.43 1.52.43 1.57 1.04 3 .3.7 1.13 1.52 1.65 1.82.47.13 6.94-9.72 7.46-9.9' stroke='%23022540'/%3E %3Cpath d='M461.77 312.21c.04 1.17 1.43 4.04 1.82 5.08.26.9.4 1.9.7 2.82.43 1.52.43 1.52 1.04 2.95a5.2 5.2 0 0 0 1.65 1.82c.47.13 6.9-9.59 7.46-9.76' stroke='%23022541'/%3E %3Cpath d='M461.77 312.21c.04 1.13 1.43 4 1.82 4.99.26.96.4 1.9.7 2.82.43 1.48.47 1.52 1.04 2.9.3.7 1.17 1.53 1.69 1.83.48.13 6.86-9.46 7.42-9.63' stroke='%23022541'/%3E %3Cpath d='M461.77 312.21c.04 1.13 1.39 3.95 1.82 4.95.26.9.4 1.86.7 2.77.43 1.48.47 1.48 1.04 2.87.34.7 1.17 1.47 1.69 1.78.52.17 6.81-9.24 7.42-9.46' stroke='%23022743'/%3E %3Cpath d='M461.77 312.21c.04 1.13 1.39 3.9 1.82 4.9.26.87.4 1.87.7 2.74.43 1.43.47 1.47 1.08 2.86.3.65 1.13 1.43 1.65 1.74.52.17 6.77-9.12 7.42-9.33' stroke='%23022743'/%3E %3Cpath d='M461.77 312.21c.04 1.09 1.39 3.86 1.82 4.82.26.9.4 1.86.7 2.73.43 1.43.47 1.48 1.08 2.82.3.65 1.13 1.43 1.65 1.74.56.17 6.77-8.99 7.42-9.2' stroke='%23022845'/%3E %3Cpath d='M461.77 312.21c.04 1.09 1.39 3.77 1.82 4.77.26.87.4 1.83.7 2.7.43 1.38.52 1.43 1.08 2.77a5.3 5.3 0 0 0 1.65 1.74c.6.17 6.72-8.86 7.42-9.07' stroke='%23022845'/%3E %3Cpath d='M461.77 312.21c.04 1.04 1.35 3.73 1.82 4.73.26.87.4 1.78.7 2.65.47 1.39.52 1.43 1.08 2.73a4.75 4.75 0 0 0 1.65 1.7c.6.21 6.68-8.69 7.42-8.9' stroke='%23022847'/%3E %3Cpath d='M461.77 312.21c.04 1.04 1.35 3.69 1.82 4.64.26.87.4 1.78.74 2.65.43 1.35.48 1.39 1.08 2.69.3.65 1.13 1.39 1.61 1.7.65.21 6.68-8.56 7.42-8.82' stroke='%23022847'/%3E %3Cpath d='M461.77 312.21c.04 1.04 1.35 3.64 1.82 4.6.26.87.4 1.73.74 2.56.43 1.39.52 1.43 1.08 2.69.3.65 1.13 1.39 1.61 1.7.7.17 6.64-8.38 7.42-8.69' stroke='%23022847'/%3E %3Cpath d='M461.77 312.21c.04 1 1.35 3.6 1.82 4.56.26.82.4 1.73.74 2.51.43 1.35.52 1.44 1.08 2.7.35.6 1.13 1.34 1.65 1.64.65.18 6.6-8.24 7.38-8.54' stroke='%23022a49'/%3E %3Cpath d='M461.77 312.21c.04 1 1.3 3.51 1.82 4.47.26.82.4 1.73.74 2.52.43 1.34.52 1.38 1.08 2.64.35.61 1.13 1.35 1.65 1.6.7.23 6.55-8.06 7.38-8.37' stroke='%23022a49'/%3E %3Cpath d='M461.77 312.21c.04.96 1.3 3.47 1.82 4.43.26.82.44 1.69.74 2.47.43 1.3.52 1.39 1.13 2.6.3.61 1.08 1.35 1.6 1.6.74.23 6.51-7.93 7.38-8.24' stroke='%23032a4a'/%3E %3Cpath d='M461.77 312.21c.04.96 1.3 3.43 1.78 4.38.3.78.48 1.65.78 2.43.43 1.3.56 1.35 1.13 2.56.35.61 1.08 1.3 1.6 1.6.74.23 6.51-7.8 7.38-8.1' stroke='%23032a4a'/%3E %3Cpath d='M461.81 312.21c0 .96 1.21 3.38 1.74 4.3.3.82.47 1.64.78 2.43.43 1.25.56 1.34 1.12 2.51.35.61 1.13 1.3 1.61 1.56.78.26 6.46-7.59 7.38-7.94' stroke='%23032b4c'/%3E %3Cpath d='M461.81 312.21c0 .91 1.21 3.34 1.74 4.25.3.78.47 1.6.78 2.39.47 1.26.56 1.34 1.17 2.52.3.56 1.08 1.25 1.56 1.52.82.25 6.42-7.47 7.38-7.81' stroke='%23032b4c'/%3E %3Cpath d='M461.81 312.21c0 .91 1.21 3.25 1.74 4.17.3.78.47 1.64.78 2.38.47 1.26.56 1.3 1.17 2.48.3.56 1.08 1.25 1.56 1.51.82.26 6.42-7.33 7.38-7.67' stroke='%23032c4d'/%3E %3Cpath d='M461.81 312.21c0 .87 1.21 3.21 1.74 4.12.3.78.47 1.6.82 2.35.43 1.21.56 1.3 1.13 2.43a5.19 5.19 0 0 0 1.56 1.51c.87.27 6.38-7.2 7.38-7.55' stroke='%23032c4d'/%3E %3Cpath d='M461.81 312.21c0 .87 1.17 3.17 1.74 4.08.3.74.47 1.56.82 2.3.43 1.21.56 1.26 1.13 2.39a4.71 4.71 0 0 0 1.6 1.47c.87.3 6.34-7.03 7.34-7.38' stroke='%23032c4d'/%3E %3Cpath d='M461.81 312.21c0 .87 1.17 3.12 1.74 4 .3.77.47 1.55.82 2.3.43 1.16.56 1.25 1.17 2.34.3.56 1.04 1.21 1.56 1.47.87.26 6.3-6.86 7.34-7.25' stroke='%23032d4f'/%3E %3Cpath d='M461.81 312.21c0 .83 1.17 3.08 1.74 3.95.3.74.47 1.52.82 2.25.43 1.18.6 1.22 1.17 2.35a4.9 4.9 0 0 0 1.56 1.43c.91.26 6.25-6.73 7.34-7.11' stroke='%23032d4f'/%3E %3Cpath d='M461.81 312.21c0 .83 1.17 3 1.74 3.9.3.74.47 1.48.82 2.22.43 1.13.6 1.21 1.17 2.3a5.4 5.4 0 0 0 1.56 1.43c.96.26 6.25-6.6 7.34-6.98' stroke='%23032e50'/%3E %3Cpath d='M461.81 312.21c0 .78 1.13 2.95 1.74 3.82.3.74.47 1.52.82 2.21.43 1.13.6 1.22 1.17 2.26a4.7 4.7 0 0 0 1.56 1.39c.96.3 6.2-6.43 7.34-6.81' stroke='%23032e50'/%3E %3Cpath d='M461.81 312.21c0 .78 1.13 2.9 1.74 3.77.3.7.47 1.48.82 2.17.43 1.09.6 1.18 1.21 2.22a5.09 5.09 0 0 0 1.52 1.39c1 .3 6.2-6.3 7.34-6.68' stroke='%23032f53'/%3E %3Cpath d='M461.81 312.21c0 .74 1.13 2.87 1.74 3.73.3.7.47 1.43.82 2.13.48 1.08.65 1.17 1.21 2.17a5.09 5.09 0 0 0 1.52 1.39c1.04.3 6.16-6.12 7.34-6.55' stroke='%23032f53'/%3E %3Cpath d='M461.81 312.21c0 .74 1.13 2.82 1.74 3.64.3.7.47 1.44.82 2.13.48 1.04.65 1.13 1.21 2.17a5.14 5.14 0 0 0 1.57 1.35c1 .3 6.07-6 7.29-6.42' stroke='%23033054'/%3E %3Cpath d='M461.81 312.21c0 .74 1.08 2.73 1.74 3.6.3.7.47 1.39.86 2.08.44 1.05.61 1.13 1.17 2.13a4.47 4.47 0 0 0 1.57 1.3c1.04.35 6.07-5.81 7.29-6.24' stroke='%23033054'/%3E %3Cpath d='M461.81 312.21c0 .7 1.08 2.7 1.74 3.56.26.65.52 1.34.86 2 .44 1.04.65 1.17 1.22 2.12a5.4 5.4 0 0 0 1.52 1.3c1.08.35 6.03-5.68 7.29-6.12' stroke='%23033054'/%3E %3Cpath d='M461.81 312.21c0 .7 1.08 2.65 1.7 3.47.3.65.56 1.39.9 2 .44 1.04.65 1.13 1.22 2.08a5.4 5.4 0 0 0 1.52 1.3c1.08.35 5.99-5.55 7.29-5.98' stroke='%23033156'/%3E %3Cpath d='M461.81 312.21c0 .65 1.08 2.6 1.7 3.43.3.65.56 1.34.9 1.95.44 1 .65 1.13 1.22 2.04a5.4 5.4 0 0 0 1.52 1.3c1.13.3 5.99-5.38 7.29-5.86' stroke='%23033156'/%3E %3Cpath d='M461.81 312.21c0 .65 1.04 2.56 1.7 3.38.3.61.56 1.3.9 1.91.44 1 .65 1.09 1.26 2.04.35.48 1 1 1.48 1.22 1.17.35 5.94-5.2 7.29-5.69' stroke='%23043258'/%3E %3Cpath d='M461.81 312.21c0 .65 1.04 2.47 1.7 3.3.3.65.56 1.3.9 1.9.44.96.7 1.1 1.26 2 .35.48 1 1 1.48 1.22 1.17.35 5.94-5.08 7.29-5.56' stroke='%23043258'/%3E %3Cpath d='M461.81 312.17c0 .65 1.04 2.47 1.7 3.3.3.6.56 1.26.9 1.86.48.96.7 1.09 1.26 1.96.35.47 1 .95 1.48 1.21 1.21.35 5.9-4.94 7.29-5.42' stroke='%23043359'/%3E %3Cpath d='M461.81 312.17c0 .65 1.04 2.43 1.7 3.25.3.61.56 1.22.9 1.83.48.9.7 1.04 1.26 1.9.4.48 1 .96 1.52 1.18 1.22.39 5.81-4.78 7.25-5.25' stroke='%23043359'/%3E %3Cpath d='M461.81 312.17c0 .6 1 2.39 1.7 3.17.3.6.56 1.26.95 1.82.43.91.7 1.04 1.26 1.87.34.47 1 .95 1.47 1.17 1.22.39 5.81-4.6 7.25-5.12' stroke='%2304345b'/%3E %3Cpath d='M461.81 312.17c0 .6 1 2.3 1.7 3.12.3.57.56 1.22.95 1.78.43.87.7 1 1.26 1.83.34.47 1 .95 1.47 1.17 1.26.39 5.77-4.47 7.25-5' stroke='%2304345b'/%3E %3Cpath d='M461.81 312.17c0 .6 1 2.26 1.7 3.08.3.56.56 1.17.95 1.74.43.86.7 1 1.26 1.82.34.43 1 .91 1.47 1.13 1.3.39 5.77-4.34 7.25-4.86' stroke='%2304345b'/%3E %3Cpath d='M461.81 312.17c0 .56.95 2.21 1.7 3 .3.56.56 1.17.95 1.73.43.83.7.96 1.26 1.78.39.43 1 .87 1.47 1.09 1.3.43 5.73-4.17 7.25-4.69' stroke='%2304355c'/%3E %3Cpath d='M461.81 312.17c0 .56.95 2.17 1.7 2.95.3.56.56 1.13.95 1.7.43.82.73.95 1.3 1.73.35.43.95.87 1.43 1.08 1.35.44 5.69-4.03 7.25-4.55' stroke='%2304355c'/%3E %3Cpath d='M461.81 312.17c0 .52.95 2.13 1.7 2.9.3.53.56 1.1.95 1.66.43.82.73.95 1.3 1.69.35.43.95.87 1.43 1.08 1.39.44 5.69-3.9 7.25-4.42' stroke='%2304365e'/%3E %3Cpath d='M461.81 312.17c0 .52.95 2.04 1.7 2.82.3.52.56 1.13.95 1.65.47.78.73.91 1.3 1.65.39.43 1 .87 1.43 1.08 1.39.4 5.64-3.73 7.25-4.3' stroke='%2304365e'/%3E %3Cpath d='M461.81 312.17c0 .52.91 2 1.7 2.78.3.52.56 1.08.95 1.6.47.78.78.91 1.3 1.65.39.4 1 .83 1.47 1 1.4.43 5.56-3.56 7.2-4.12' stroke='%23043760'/%3E %3Cpath d='M461.81 312.17c0 .48.91 1.95 1.7 2.73.3.48.56 1.05.95 1.57.47.73.78.86 1.34 1.6.35.4.96.78 1.43 1 1.44.43 5.56-3.43 7.2-4' stroke='%23043760'/%3E %3Cpath d='M461.81 312.17c0 .48.91 1.91 1.65 2.65.35.52.65 1.04 1.04 1.56.43.74.74.87 1.3 1.56.35.4.96.78 1.43 1 1.44.43 5.51-3.3 7.2-3.9' stroke='%23043862'/%3E %3Cpath d='M461.81 312.17c0 .43.91 1.87 1.65 2.6.35.48.65 1 1.04 1.48.43.74.74.91 1.3 1.56.4.4.96.78 1.43 1 1.48.43 5.51-3.17 7.2-3.77' stroke='%23043862'/%3E %3Cpath d='M461.81 312.17c0 .43.87 1.78 1.65 2.52.35.52.65 1 1.04 1.47.43.74.78.87 1.35 1.52.34.4.9.78 1.38.96 1.52.47 5.47-2.95 7.2-3.6' stroke='%23043862'/%3E %3Cpath d='M461.81 312.17c0 .43.87 1.74 1.65 2.47.35.48.65 1 1.04 1.44.43.69.78.86 1.35 1.52.34.34.9.73 1.38.9 1.52.48 5.43-2.81 7.2-3.46' stroke='%23043963'/%3E %3Cpath d='M461.81 312.17c0 .4.87 1.7 1.65 2.43.35.43.65.96 1.04 1.39.43.7.78.82 1.35 1.47.39.35.95.7 1.38.92 1.57.47 5.43-2.7 7.2-3.34' stroke='%23043963'/%3E %3Cpath d='M461.81 312.17c0 .4.87 1.65 1.65 2.34.35.48.65.96 1.04 1.4.48.64.83.82 1.35 1.42.39.35.95.7 1.38.92 1.61.47 5.38-2.56 7.2-3.21' stroke='%23053a65'/%3E %3Cpath d='M461.81 312.17c0 .35.82 1.6 1.65 2.3.35.43.65.91 1.04 1.35.48.65.83.82 1.39 1.38.35.35.91.7 1.39.87 1.6.52 5.3-2.38 7.16-3.04' stroke='%23053a65'/%3E %3Cpath d='M461.81 312.17c0 .35.82 1.52 1.65 2.26.35.43.65.86 1.04 1.3.48.6.83.78 1.39 1.34.39.35.91.7 1.39.87 1.6.48 5.3-2.21 7.16-2.9' stroke='%23053b67'/%3E %3Cpath d='M461.81 312.17c0 .35.82 1.48 1.65 2.17.35.43.65.87 1.08 1.3.44.61.79.78 1.35 1.35.39.3.91.65 1.39.82 1.65.48 5.25-2.08 7.16-2.78' stroke='%23053b67'/%3E %3Cpath d='M461.81 312.17c0 .3.82 1.43 1.65 2.13.35.39.65.86 1.08 1.26.44.56.83.73 1.35 1.3.39.3.91.6 1.39.78 1.69.52 5.25-1.91 7.16-2.6' stroke='%23053c68'/%3E %3Cpath d='M461.81 312.17c0 .3.78 1.39 1.65 2.08.35.4.65.83 1.08 1.22.44.56.83.74 1.4 1.26.34.3.9.6 1.34.78 1.69.52 5.2-1.78 7.16-2.47' stroke='%23053c68'/%3E %3Cpath d='M461.81 312.17c0 .26.78 1.35 1.65 2 .3.39.65.82 1.08 1.21.44.52.83.7 1.4 1.22.38.3.9.6 1.34.78 1.73.52 5.16-1.65 7.16-2.35' stroke='%23053c68'/%3E %3Cpath d='M461.81 312.17c0 .26.78 1.26 1.65 1.95.3.4.65.78 1.08 1.17.44.53.87.7 1.4 1.18.38.3.9.6 1.34.78 1.78.52 5.16-1.48 7.16-2.21' stroke='%23053d6a'/%3E %3Cpath d='M461.81 312.17c0 .22.78 1.22 1.65 1.91.3.35.65.74 1.08 1.13.48.48.87.7 1.4 1.13.38.3.9.6 1.34.73 1.78.57 5.12-1.3 7.16-2.04' stroke='%23053d6a'/%3E %3Cpath d='M461.81 312.17c0 .22.74 1.17 1.65 1.82.3.4.65.74 1.08 1.13.48.48.87.65 1.44 1.13.39.26.86.52 1.34.7 1.78.56 5.08-1.18 7.12-1.92' stroke='%23053e6c'/%3E %3Cpath d='M461.81 312.17c0 .22.74 1.13 1.6 1.78l1.13 1.09c.48.43.87.65 1.44 1.08.39.26.86.52 1.34.7 1.82.56 5.03-1.05 7.12-1.78' stroke='%23053e6c'/%3E %3Cpath d='M461.81 312.17c0 .17.74 1.09 1.6 1.74.35.3.74.7 1.13 1.04.48.43.91.6 1.44 1.04.39.26.86.52 1.34.7 1.82.56 5-.92 7.12-1.65' stroke='%23053f6e'/%3E %3Cpath d='M461.81 312.17c0 .17.74 1 1.6 1.65.35.35.74.7 1.18 1.04.43.4.86.6 1.43 1 .35.26.87.52 1.3.65 1.87.56 5-.7 7.12-1.48' stroke='%23053f6e'/%3E %3Cpath d='M461.81 312.17c0 .13.7.96 1.6 1.6.35.31.74.66 1.18.96.43.43.86.65 1.43 1 .39.26.87.48 1.3.65 1.91.56 4.95-.56 7.12-1.34' stroke='%23053f6f'/%3E %3Cpath d='M461.81 312.17c0 .13.7.91 1.6 1.56.35.3.74.61 1.18.91.43.4.86.61 1.43 1 .39.22.87.44 1.3.61 1.91.56 4.9-.43 7.12-1.22' stroke='%23053f6f'/%3E %3Cpath d='M461.81 312.17c0 .13.7.87 1.6 1.48.35.3.74.6 1.18.9.43.4.9.61 1.43.96.39.22.87.44 1.3.61 1.95.56 4.9-.3 7.12-1.09' stroke='%23053f6f'/%3E %3Cpath d='M461.81 312.17c0 .09.65.78 1.6 1.43.35.26.74.57 1.18.87.47.4.9.56 1.47.91.4.22.83.44 1.26.57 2 .6 4.86-.13 7.12-.92' stroke='%23064171'/%3E %3Cpath d='M461.81 312.17c0 .09.65.74 1.6 1.39.35.26.74.56 1.18.82.47.35.9.57 1.47.87.4.22.83.44 1.3.57 1.96.6 4.82 0 7.08-.79' stroke='%23064171'/%3E %3Cpath d='M461.81 312.17c0 .04.65.7 1.6 1.3.35.26.74.57 1.18.83.47.34.95.56 1.47.82.4.22.87.4 1.3.57 2 .6 4.78.17 7.08-.66' stroke='%23064172'/%3E %3Cpath d='M461.81 312.13c0 .09.65.7 1.6 1.3.35.26.74.52 1.18.78.47.3.95.52 1.47.83l1.3.52c2.04.6 4.73.3 7.08-.52' stroke='%23064172'/%3E %3Cpath d='M461.81 312.13c0 .09.6.65 1.6 1.26.35.22.74.48 1.18.74.47.3.95.52 1.52.78.39.17.82.34 1.25.47 2.04.66 4.73.48 7.08-.34' stroke='%23064374'/%3E %3Cpath d='M461.81 312.13c0 .04.6.56 1.6 1.17.35.26.74.48 1.22.74.43.26.91.48 1.48.74.39.17.82.35 1.25.47 2.09.66 4.69.61 7.08-.21' stroke='%23064374'/%3E %3Cpath d='M461.81 312.13c0 .04.6.52 1.6 1.13a23.33 23.33 0 0 0 2.7 1.39c.39.17.82.34 1.25.48 2.13.6 4.65.73 7.08-.1M461.81 312.13s6.47 5.08 12.63 2.9' stroke='%2300209f'/%3E %3C/g%3E %3Cg%3E %3Cpath d='M461.55 292.17s1.26 8.11 1.74 9.28c.43 1.05 2.99 5.69 6.9 6.77' stroke='%23022743'/%3E %3Cpath d='M461.55 292.17s1.35 8.03 1.87 9.2c.43 1.04 2.82 5.47 6.8 6.81' stroke='%23022a49'/%3E %3Cpath d='M461.59 292.13s1.39 7.98 1.91 9.2c.43 1.04 2.69 5.2 6.72 6.85' stroke='%23032b4c'/%3E %3Cpath d='M461.59 292.13s1.48 7.94 2 9.11c.47 1.04 2.51 5 6.63 6.9' stroke='%23032e50'/%3E %3Cpath d='M461.64 292.13s1.52 7.85 2.04 9.03a15.2 15.2 0 0 0 6.6 6.94' stroke='%23033054'/%3E %3Cpath d='M461.64 292.13s1.6 7.8 2.17 8.98a15.83 15.83 0 0 0 6.46 6.99' stroke='%23043359'/%3E %3Cpath d='M461.64 292.08s1.7 7.77 2.26 8.94c.52 1.08 2.04 4.25 6.37 7.03' stroke='%2304355c'/%3E %3Cpath d='M461.68 292.08s1.73 7.72 2.3 8.9c.52 1.08 1.9 3.99 6.29 7.07' stroke='%23043760'/%3E %3Cpath d='M461.68 292.08s1.82 7.64 2.39 8.8c.56 1.1 1.78 3.78 6.24 7.12' stroke='%23053a65'/%3E %3Cpath d='M461.72 292.04s1.87 7.64 2.47 8.76c.57 1.13 1.57 3.52 6.12 7.2' stroke='%23053c68'/%3E %3Cpath d='M461.72 292.04s2 7.55 2.56 8.72c.56 1.09 1.43 3.25 6.03 7.2' stroke='%23053f6e'/%3E %3Cpath d='M461.77 292.04s2.04 7.5 2.6 8.63c.61 1.13 1.3 3.04 6 7.25' stroke='%23064172'/%3E %3Cpath d='M461.77 291.99s2.13 7.46 2.69 8.6c.6 1.12 1.17 2.81 5.9 7.32' stroke='%2300209f'/%3E %3C/g%3E %3Cg%3E %3Cpath d='M462.07 287.18s1.04 11.46 9.2 14.62' stroke='%23022743'/%3E %3Cpath d='M462.07 287.18c.04.04.48 3.69 2.13 7.25 1.3 2.73 3.47 5.85 7.07 7.33' stroke='%23022a49'/%3E %3Cpath d='M462.11 287.18c0 .04.52 3.77 2.17 7.2 1.21 2.52 3.38 5.77 6.98 7.38' stroke='%23032b4c'/%3E %3Cpath d='M462.11 287.18c.04.09.65 3.9 2.26 7.12 1.17 2.34 3.3 5.72 6.9 7.41' stroke='%23032e50'/%3E %3Cpath d='M462.16 287.18c0 .09.74 4 2.34 7.07 1.04 2.17 3.17 5.64 6.77 7.42' stroke='%23033054'/%3E %3Cpath d='M462.16 287.18c.04.13.87 4.08 2.43 6.99.95 2 3.12 5.6 6.68 7.5' stroke='%23043359'/%3E %3Cpath d='M462.2 287.18c0 .13.95 4.17 2.47 6.94.91 1.78 3.04 5.51 6.6 7.5' stroke='%2304355c'/%3E %3Cpath d='M462.2 287.14c.04.22 1.08 4.34 2.56 6.94.82 1.56 2.95 5.43 6.5 7.5' stroke='%23043760'/%3E %3Cpath d='M462.2 287.14c.09.22 1.21 4.43 2.65 6.86.78 1.43 2.86 5.38 6.42 7.54' stroke='%23053a65'/%3E %3Cpath d='M462.25 287.14c.04.26 1.3 4.51 2.69 6.81.7 1.22 2.78 5.3 6.34 7.6' stroke='%23053c68'/%3E %3Cpath d='M462.25 287.14c.09.26 1.43 4.6 2.82 6.73.6 1.04 2.65 5.25 6.2 7.63' stroke='%23053f6e'/%3E %3Cpath d='M462.29 287.14c.04.3 1.52 4.73 2.86 6.68.52.83 2.56 5.17 6.12 7.64' stroke='%23064172'/%3E %3Cpath d='M462.29 287.14c.09.3 1.65 4.82 2.95 6.6.48.65 2.47 5.12 6.03 7.72' stroke='%2300209f'/%3E %3C/g%3E %3Cg%3E %3Cpath d='M462.16 284.01s2.39 9.2 9.03 11.46' stroke='%23022743'/%3E %3Cpath d='M462.16 284.01s.91 3.25 3.08 6.42c1.43 2.13 3.51 4.21 5.94 5.03' stroke='%23022847'/%3E %3Cpath d='M462.16 283.97s.95 3.21 3.12 6.38c1.52 2.17 3.65 4.34 5.9 5.12' stroke='%23032a4a'/%3E %3Cpath d='M462.16 283.93s1 3.17 3.21 6.33c1.56 2.22 3.73 4.47 5.81 5.17' stroke='%23032c4d'/%3E %3Cpath d='M462.2 283.88s1 3.12 3.25 6.33c1.61 2.22 3.87 4.56 5.73 5.21' stroke='%23032f53'/%3E %3Cpath d='M462.2 283.88s1.04 3.04 3.34 6.25c1.65 2.25 3.95 4.68 5.69 5.25' stroke='%23033156'/%3E %3Cpath d='M462.2 283.84s1.08 3.04 3.38 6.2c1.74 2.35 4.13 4.82 5.65 5.34' stroke='%23043359'/%3E %3Cpath d='M462.2 283.79s1.13 3 3.47 6.16c1.78 2.39 4.21 4.95 5.56 5.43' stroke='%2304355c'/%3E %3Cpath d='M462.25 283.79s1.08 2.9 3.51 6.12c1.83 2.38 4.34 5.03 5.47 5.42' stroke='%23043760'/%3E %3Cpath d='M462.25 283.75s1.13 2.86 3.6 6.07c1.87 2.43 4.43 5.21 5.38 5.52' stroke='%23043963'/%3E %3Cpath d='M462.25 283.71s1.17 2.82 3.64 6.03c1.91 2.47 4.6 5.34 5.34 5.6' stroke='%23053b67'/%3E %3Cpath d='M462.25 283.66s1.21 2.78 3.73 6.03c1.95 2.52 4.69 5.42 5.25 5.6' stroke='%23053e6c'/%3E %3Cpath d='M462.29 283.66s1.21 2.69 3.77 5.94c2 2.56 4.82 5.56 5.17 5.69' stroke='%23053f6f'/%3E %3Cpath d='M462.29 283.62s1.26 2.65 3.86 5.9c2.04 2.6 4.9 5.69 5.12 5.77' stroke='%23064172'/%3E %3Cpath d='M462.29 283.58s1.3 2.6 3.9 5.86c2.13 2.64 5.08 5.81 5.08 5.81' stroke='%2300209f'/%3E %3C/g%3E %3Cg%3E %3Cpath d='M479.9 296.55l4.56.83M480.38 300.02l4.08-1.73' stroke='%2300209f'/%3E %3Cpath d='M479.86 296.68l4.56.7' stroke='%23064171'/%3E %3Cpath d='M479.86 296.85l4.6.57' stroke='%23053e6c'/%3E %3Cpath d='M479.9 297.03l4.6.39' stroke='%23053b67'/%3E %3Cpath d='M479.9 297.2l4.65.26' stroke='%23043862'/%3E %3Cpath d='M479.9 297.38l4.69.08' stroke='%2304355c'/%3E %3Cpath d='M479.95 297.55l4.68-.04' stroke='%23043258'/%3E %3Cpath d='M479.95 297.68l4.73-.17' stroke='%23032f53'/%3E %3Cpath d='M479.95 297.85l4.77-.3' stroke='%23032c4d'/%3E %3Cpath d='M479.99 298.03l4.77-.48' stroke='%23022a49'/%3E %3Cpath d='M480.34 299.81l4.16-1.61' stroke='%23064171'/%3E %3Cpath d='M480.29 299.63l4.26-1.52' stroke='%23053e6c'/%3E %3Cpath d='M480.29 299.46l4.3-1.39' stroke='%23053b67'/%3E %3Cpath d='M480.25 299.28l4.38-1.3' stroke='%23043862'/%3E %3Cpath d='M480.21 299.11l4.47-1.17' stroke='%2304355c'/%3E %3Cpath d='M480.21 298.94l4.51-1.09' stroke='%23043258'/%3E %3Cpath d='M480.16 298.72l4.6-.91' stroke='%23032f53'/%3E %3Cpath d='M480.12 298.55l4.69-.83' stroke='%23032c4d'/%3E %3Cpath d='M480.12 298.37l4.73-.69' stroke='%23022a49'/%3E %3Cpath d='M480.08 298.2l4.81-.61' stroke='%23022743'/%3E %3C/g%3E %3Cg%3E %3Cpath d='M484.24 331.57s-2.43.13-2.65.22c-.26.04-9.89-.18-9.89-.18' stroke='%23032b4c'/%3E %3Cpath d='M484.29 331.61s-2.39.22-2.73.3c-.4.05-9.77-.26-9.77-.26' stroke='%23032e50'/%3E %3Cpath d='M484.29 331.65s-2.3.3-2.78.39c-.52.09-9.63-.35-9.63-.35' stroke='%23033054'/%3E %3Cpath d='M484.33 331.7s-2.26.35-2.86.48c-.65.13-9.55-.44-9.55-.44' stroke='%23043359'/%3E %3Cpath d='M484.33 331.7s-2.17.48-2.95.6c-.74.18-9.37-.51-9.37-.51' stroke='%2304355c'/%3E %3Cpath d='M484.33 331.74s-2.08.52-3 .7c-.86.21-9.24-.61-9.24-.61' stroke='%23043760'/%3E %3Cpath d='M484.37 331.78s-2.04.6-3.08.82c-1 .18-9.11-.73-9.11-.73' stroke='%23053a65'/%3E %3Cpath d='M484.37 331.83s-2 .7-3.12.91c-1.13.22-9.03-.78-9.03-.78' stroke='%23053c68'/%3E %3Cpath d='M484.42 331.87s-1.95.74-3.21 1-8.9-.87-8.9-.87' stroke='%23053f6e'/%3E %3Cpath d='M484.42 331.91s-1.87.82-3.25 1.08c-1.4.3-8.77-.95-8.77-.95' stroke='%23064172'/%3E %3Cpath d='M472.48 332.09s7.12 1.35 8.63 1.04c1.52-.3 3.34-1.17 3.34-1.17' stroke='%2300209f'/%3E %3C/g%3E %3Cg%3E %3Cpath d='M486.06 337.07s4.56.7 4.73.65l2.73-.17c.05 0 2.22-.52 2.22-.52' stroke='%23022a49'/%3E %3Cpath d='M485.8 336.99s4.69.74 5.03.65c.18-.04 2.52-.17 2.65-.17.13 0 2.08-.48 2.08-.48' stroke='%23032d4f'/%3E %3Cpath d='M485.54 336.86s4.82.83 5.3.7c.25-.05 2.38-.18 2.6-.18.17 0 1.9-.43 1.9-.43' stroke='%23033054'/%3E %3Cpath d='M485.28 336.73s4.9.87 5.6.74a56.9 56.9 0 0 1 2.51-.18l1.74-.34' stroke='%23043359'/%3E %3Cpath d='M485.02 336.64s5.03.91 5.86.74c.43-.09 2.17-.18 2.47-.22.3 0 1.56-.26 1.56-.26' stroke='%23043760'/%3E %3Cpath d='M484.76 336.51s5.16 1 6.16.78c.52-.09 2-.17 2.39-.22.34 0 1.39-.21 1.39-.21' stroke='%23053a65'/%3E %3Cpath d='M484.5 336.38s5.25 1.08 6.42.87c.65-.13 1.91-.22 2.34-.26.44-.05 1.22-.18 1.22-.18' stroke='%23053d6a'/%3E %3Cpath d='M484.24 336.29s5.38 1.13 6.72.87c.7-.18 1.74-.26 2.26-.26.48-.05 1.09-.09 1.09-.09' stroke='%23064171'/%3E %3Cpath stroke='%23022743' d='M486.33 337.2l4.42.62 2.82-.14 2.39-.6' stroke-width='.17576640000000002'/%3E %3Cpath d='M483.98 336.16s5.51 1.21 7.03.91c1.47-.3 3.08-.3 3.08-.3' stroke='%2300209f'/%3E %3C/g%3E %3Cg%3E %3Cpath d='M505.76 336.81l4.3-1.56c2.69-1 2.99-3.69 2.99-3.69' stroke='%2300209f'/%3E %3Cpath d='M505.46 335.95s1.74-.7 3.17-1.21c3.82-1.44 3.38-3.26 3.38-3.26' stroke='%2300209f'/%3E %3Cpath d='M505.2 336.12l3.43-1.3c.6-.22 1.39-.57 1.78-.83a4.7 4.7 0 0 0 1.34-1.21c.35-.52.35-1.26.35-1.26' stroke='%23053e6c'/%3E %3Cpath d='M504.94 336.34s2.82-1.08 3.69-1.39c.43-.17 1.47-.6 1.73-.78.4-.26 1.3-1 1.44-1.22a5.7 5.7 0 0 0 .43-1.43' stroke='%23043862'/%3E %3Cpath d='M504.68 336.51l3.95-1.48c.3-.08 1.52-.6 1.7-.69a16.7 16.7 0 0 0 1.51-1.26c.17-.26.48-1.56.48-1.56' stroke='%23043258'/%3E %3Cpath d='M504.42 336.73s3.9-1.47 4.2-1.56c.14-.09 1.61-.6 1.7-.7a15.2 15.2 0 0 0 1.56-1.25c.09-.13.57-1.65.57-1.65' stroke='%23032c4d'/%3E %3Cpath d='M505.46 336.86l4.64-1.74c.83-.3 1.7-1.04 2.08-1.56.57-.82.79-2 .79-2' stroke='%23053e6c'/%3E %3Cpath d='M505.11 336.86s4.17-1.52 5.03-1.87c.61-.21 1.7-1.08 1.96-1.47.43-.6.73-1.95.73-1.95' stroke='%23043862'/%3E %3Cpath d='M504.81 336.9s4.82-1.82 5.38-2a8.16 8.16 0 0 0 1.87-1.43c.3-.43.69-1.9.69-1.9' stroke='%23043258'/%3E %3Cpath d='M504.5 336.9s5.42-2.04 5.73-2.13c.21-.08 1.65-1.21 1.78-1.34.13-.22.65-1.87.65-1.87' stroke='%23032c4d'/%3E %3Cpath stroke='%23022743' d='M504.16 336.9l6.12-2.26 1.64-1.25.61-1.83' stroke-width='.17576640000000002'/%3E %3C/g%3E %3Cg%3E %3Cpath d='M511.27 331.57s-2.52.13-2.78.22c-.26.04-10.28-.18-10.28-.18' stroke='%23032b4c'/%3E %3Cpath d='M511.32 331.61s-2.47.22-2.86.3c-.4.05-10.16-.26-10.16-.26' stroke='%23032e50'/%3E %3Cpath d='M511.32 331.65s-2.39.3-2.9.39c-.53.09-10.03-.35-10.03-.35' stroke='%23033054'/%3E %3Cpath d='M511.32 331.7s-2.3.35-2.95.48c-.65.13-9.9-.44-9.9-.44' stroke='%23043359'/%3E %3Cpath d='M511.36 331.7s-2.26.48-3.04.6c-.78.18-9.76-.51-9.76-.51' stroke='%2304355c'/%3E %3Cpath d='M511.36 331.74s-2.17.52-3.08.7c-.91.21-9.68-.61-9.68-.61' stroke='%23043760'/%3E %3Cpath d='M511.4 331.78s-2.13.6-3.17.82c-1.08.18-9.54-.73-9.54-.73' stroke='%23053a65'/%3E %3Cpath d='M511.4 331.83s-2.04.7-3.25.91c-1.18.22-9.38-.78-9.38-.78' stroke='%23053c68'/%3E %3Cpath d='M511.45 331.87s-2.04.74-3.34 1c-1.3.26-9.24-.87-9.24-.87' stroke='%23053f6e'/%3E %3Cpath d='M511.45 331.91s-1.95.82-3.38 1.08c-1.44.3-9.12-.95-9.12-.95' stroke='%23064172'/%3E %3Cpath d='M498.99 332.09s7.46 1.35 9.03 1.04c1.56-.3 3.47-1.17 3.47-1.17' stroke='%2300209f'/%3E %3C/g%3E %3C/g%3E %3Cg stroke='%23000' stroke-width='.17' stroke-miterlimit='2.61' fill='none'%3E %3Cpath d='M474.96 289.91a34 34 0 0 1-.17-3.21c.04-5.16-.65-9.07-.1-14.5.44-4.24 1.48-9.84 1.27-14.44-.09-1.3.17-2.6.21-3.86l20.96 23.52M466.97 327.7a5.23 5.23 0 0 1-1.82-2.21c-.61-1.74-.48-1.7-.91-3.6-.26-1.09-.26-2.3-.52-3.43-.22-1.13-1.83-4.73-1.87-6.2-.17-4.73-1.74-7.95-1.35-13.1.27-4 1.18-9.42.74-13.59-.13-1.13.05-2.43.09-3.56l23.56 15.58M513.44 331.48c.17.52-.35 1.52-.52 1.87l-.48.65c-.26.56-.21.43-.7.87-.12.08-.69.56-.86.65-.35.26-.7.6-1.08.65-1.78.3-2.52.69-4.21 1.17-1.6.48-.74.39-1.95.7-.61.12-1.83.6-2.43.69-1.09.17-1.26.34-2.4.6-2.9.65-5.72.48-8.58.3-1.17-.08-4.04-.69-5.03-1.38-1.78-1.26-5.69-1.74-7.42-2.95-.26-.18-1.35-.7-1.57-.91-1.69-1.4-3.03-1.78-4.81-2.91'/%3E %3C/g%3E %3Cg stroke='%23000' stroke-miterlimit='2.61' stroke-width='.13'%3E %3Cpath fill-rule='evenodd' fill='%23FC0' d='M485.46 296.77l-23.91-15.62-.43.65 23.77 15.8z' stroke-width='.1344096'/%3E %3Cpath d='M461.16 280.89c-.17-.91.09-2.13.74-2.26.04 0 .52-.17.82-.08.4 0 .48.13.65.43.35.82-.65 1.35-1.34 1.6-.18.05-.65.14-.74.35-.13.35-.04.22-.13.35.13-.04.17-.17.3-.26.52-.3 1.04-.39 1.78-.74.57-.26.65-1.39.26-1.73-.43-.35-1.78-.3-2.08.04-.65.74-.7 1.74-.56 2.73 0-.21.34-.17.3-.43z' fill-rule='evenodd' fill='%23FC0'/%3E %3Cpath d='M460.77 281.32c-.91-.04-2.08.35-2.13 1 0 .08-.08.6 0 .87.05.39.18.47.52.56.87.26 1.26-.78 1.4-1.52.04-.17.04-.65.25-.78.35-.17.26-.09.35-.17-.04.13-.17.21-.22.3-.21.56-.26 1.13-.52 1.9-.17.57-1.3.79-1.65.44-.43-.34-.56-1.69-.26-2.04.65-.73 1.65-.9 2.65-.9-.17.04-.13.38-.39.34z' fill-rule='evenodd' fill='%23FC0'/%3E %3Cpath d='M460.6 280.93c-.26.13-.26.48-.13.7.09.21.48.25.65.17.35-.22.56-.6.35-.96-.22-.3-.57-.04-.87.09z' fill-rule='evenodd' fill='%23FC0'/%3E %3Cpath d='M455.56 277.76s2.52 1 4.56 1.04c0 0 .08 1.78.52 2.3 0 0-1.83-.35-2.65.09 0 0-1.08-2.48-2.43-3.43z' fill-rule='evenodd' fill='%23fc0'/%3E %3Cpath d='M457.6 279.02s1 .43 1.82.43c0 0 .05.7.22.92 0 0-.74-.14-1.04.04 0 0-.44-1-1-1.39z' fill='none'/%3E %3Cpath d='M460.77 282.88s.48-.82.6-1.13c.1-.17-.04 1 .4 1.13.56.74.69 2.26.69 2.65-.65.21-1.21.6-2.21.13-.35-.22-.09-.87.04-1.4.09-.25.18-.99.48-1.38z' fill-rule='evenodd' fill='%23FC0'/%3E %3Cpath d='M461.25 282.23c0 .13.09.65.04.56 0-.21.26.22.3.3.35.66.48 1.14.61 2.4M461.46 283.32c.22 1 .4.95.4 2.34l.08-.08M461.42 284.23c.17.7.13 1.04.17 1.39-.04 0-.26.17-.3.17' fill='none'/%3E %3Cg%3E %3Cpath fill-rule='evenodd' fill='%23fc0' d='M497.78 276.81l-21.35-23.73-.43.52 21.13 23.82z' stroke-width='.1344096'/%3E %3Cpath d='M476.61 253.08c.04-.95.56-2.08 1.21-2.04.05 0 .57-.04.83.09.39.08.43.26.52.6.17.87-.91 1.13-1.65 1.22-.17 0-.7-.04-.82.17-.22.3-.09.22-.22.3.13 0 .26-.12.35-.17.6-.17 1.13-.17 1.95-.3.56-.09.91-1.21.6-1.6-.3-.44-1.6-.74-1.99-.48-.82.56-1.08 1.52-1.17 2.56.04-.22.35-.13.39-.35z' fill-rule='evenodd' fill='%23fc0'/%3E %3Cpath d='M476.13 253.38c-.91-.26-2.13-.13-2.34.48 0 .04-.22.56-.18.82-.04.4.05.52.4.7.73.43 1.38-.48 1.69-1.18.08-.17.21-.6.43-.69.35-.09.26 0 .35-.09-.05.13-.18.18-.26.26-.35.52-.52 1-.96 1.74-.3.48-1.43.48-1.73.04-.3-.47-.09-1.78.26-2.04.78-.6 1.82-.56 2.77-.26-.17-.04-.21.3-.43.22z' fill-rule='evenodd' fill='%23fc0'/%3E %3Cpath d='M476.04 252.95c-.3.04-.35.43-.3.65.04.22.39.39.6.3.35-.13.7-.43.57-.82-.13-.35-.57-.17-.87-.13z' fill-rule='evenodd' fill='%23fc0'/%3E %3Cpath d='M471.92 248.69s2.17 1.56 4.12 2.08c0 0-.3 1.78 0 2.35 0 0-1.73-.74-2.6-.52 0 0-.44-2.65-1.52-3.91z' fill-rule='evenodd' fill='%23fc0'/%3E %3Cpath d='M473.57 250.43s.87.6 1.65.82c0 0-.13.7 0 .91 0 0-.7-.26-1.04-.17 0 0-.18-1.08-.61-1.56z' fill='none'/%3E %3Cpath d='M475.74 254.9s.65-.7.87-.95c.13-.18-.3.95.08 1.21.4.82.13 2.3.05 2.73-.7.05-1.3.26-2.13-.43-.3-.26.09-.82.35-1.3.13-.26.39-.96.78-1.26z' fill-rule='evenodd' fill='%23FC0'/%3E %3Cpath d='M476.35 254.42l-.04.52c.04.26.26.35.3.65.13.74-.04 1.22-.09 2.17' fill='none'/%3E %3Cpath d='M476.26 255.29c.22.91.04 1.65-.09 2.52-.04 0 .09 0 .09-.05M476.13 256.81c-.13.35-.13.56-.17.95-.05-.04-.22.13-.26.1' fill='none'/%3E %3C/g%3E %3C/g%3E %3C/g%3E %3Cuse xlink:href='%23c' transform='matrix(-1 0 0 1 1030.05 0)'/%3E %3C/g%3E %3Cpath d='M531.13 247.35l-50.29 84.13h100.62z' fill='%23fc0' stroke='%23000' stroke-miterlimit='2.61' stroke-width='.4342464'/%3E %3Cpath d='M531.13 252.82l-45.38 75.93h90.8z' fill='%23fff' stroke='%23fff' stroke-miterlimit='2.61' stroke-width='.1344096'/%3E %3Cpath d='M499.2 306.18l-13.45 22.57h90.8l-13.49-22.57z' fill='%23007e93' stroke='%23007e93' stroke-miterlimit='2.61' stroke-width='.25848'/%3E %3Cg stroke-width='.17' stroke-miterlimit='2.61' fill='none'%3E %3Cpath d='M523.24 266.09c2.12-1.91 4.73-2.69 7.76-2.73h.22c2.95.04 5.95.73 7.85 2.73' stroke='%23086aad'/%3E %3Cpath d='M523.19 266.18c2.08-1.95 4.77-2.69 7.8-2.73h.22c3.04 0 6.04.73 7.94 2.77' stroke='%230863aa'/%3E %3Cpath d='M523.15 266.31c2.08-2.04 4.81-2.78 7.9-2.82h.21c3.04.04 6.08.78 7.98 2.86' stroke='%23095fa8'/%3E %3Cpath d='M523.06 266.4c2.08-2.04 4.9-2.82 7.98-2.82h.26c3.08 0 6.12.78 8.03 2.95' stroke='%230a58a5'/%3E %3Cpath d='M523.02 266.48c2.04-2.08 4.94-2.82 8.07-2.86h.21c3.17.04 6.2.82 8.12 3.03' stroke='%230a52a2'/%3E %3Cpath d='M522.94 266.57c2.04-2.13 4.99-2.86 8.15-2.86h.26c3.21.04 6.25.82 8.2 3.08' stroke='%230b4d9f'/%3E %3Cpath d='M522.89 266.7c2.04-2.17 5.03-2.95 8.24-2.95h.22c3.3.04 6.29.87 8.28 3.17' stroke='%230c479d'/%3E %3Cpath d='M522.33 267.61c2.38-2.52 5.33-3.25 8.85-3.25h.21c3.87.04 7.16 1.34 9.07 4.03' stroke='%23270a7f'/%3E %3Cpath d='M522.37 267.48c2.34-2.43 5.3-3.17 8.8-3.21h.22c3.78.04 7.03 1.3 8.98 3.95' stroke='%23241183'/%3E %3Cpath d='M522.46 267.39c2.3-2.43 5.2-3.17 8.67-3.17h.22c3.73.05 6.99 1.22 8.94 3.86' stroke='%23221786'/%3E %3Cpath d='M522.5 267.31c2.25-2.39 5.2-3.12 8.59-3.17h.21c3.7.05 6.9 1.17 8.9 3.78' stroke='%231f1f8a'/%3E %3Cpath d='M522.59 267.18c2.17-2.3 5.12-3.08 8.5-3.08h.17c3.65 0 6.86 1.04 8.86 3.64' stroke='%231a258d'/%3E %3Cpath d='M522.63 267.09c2.12-2.3 5.12-3.04 8.41-3.08h.22c3.56.04 6.77 1 8.72 3.56' stroke='%23172d91'/%3E %3Cpath d='M522.67 267c2.08-2.26 5.07-3.04 8.33-3.04h.21c3.52 0 6.69.91 8.68 3.43' stroke='%23143393'/%3E %3Cpath d='M522.76 266.87c2.04-2.21 5.03-2.95 8.24-3h.17c3.47 0 6.64.87 8.64 3.39' stroke='%23113b97'/%3E %3Cpath d='M526.14 261.15c1.47-1.04 3.03-1.35 4.99-1.35 1.86 0 3.51.3 4.94 1.26' stroke='%23ff0a00'/%3E %3Cpath d='M526.1 261.23c1.47-1.04 3.08-1.35 5.03-1.35 1.87 0 3.56.3 4.99 1.26' stroke='%23F10'/%3E %3Cpath d='M526.06 261.32a8.46 8.46 0 0 1 5.07-1.39c1.87 0 3.6.35 5.08 1.3' stroke='%23ff1500'/%3E %3Cpath d='M526.02 261.45c1.52-1.08 3.12-1.43 5.12-1.43 1.9 0 3.64.34 5.12 1.3' stroke='%23ff1a00'/%3E %3Cpath d='M525.97 261.54c1.52-1.08 3.16-1.43 5.16-1.43 1.9 0 3.69.35 5.16 1.3' stroke='%23ff2000'/%3E %3Cpath d='M525.93 261.62a8.53 8.53 0 0 1 5.2-1.48c1.91 0 3.74.4 5.21 1.4' stroke='%23ff2700'/%3E %3Cpath d='M525.88 261.71a8.58 8.58 0 0 1 5.25-1.48c1.9 0 3.77.4 5.25 1.4' stroke='%23ff2f00'/%3E %3Cpath d='M525.84 261.8c1.52-1.13 3.25-1.48 5.3-1.48 1.94 0 3.8.4 5.33 1.4' stroke='%23F30'/%3E %3Cpath d='M525.8 261.88c1.52-1.13 3.3-1.52 5.33-1.52a9.8 9.8 0 0 1 5.38 1.43' stroke='%23ff3c00'/%3E %3Cpath d='M525.75 261.97a8.8 8.8 0 0 1 5.38-1.52c1.95 0 3.9.44 5.42 1.43' stroke='%23ff4100'/%3E %3Cpath d='M525.7 262.06c1.57-1.13 3.35-1.52 5.43-1.52 2 0 3.95.44 5.47 1.43' stroke='%23ff4600'/%3E %3Cpath d='M524.54 264.01c1.69-1.3 4.38-1.95 6.63-1.95 2.4 0 5 .65 6.69 2' stroke='%23fff500'/%3E %3Cpath d='M524.63 263.88c1.65-1.3 4.3-1.91 6.55-1.91 2.34 0 4.9.6 6.6 2' stroke='%23ffeb00'/%3E %3Cpath d='M524.67 263.79c1.69-1.3 4.25-1.91 6.5-1.91 2.3 0 4.86.6 6.56 1.95' stroke='%23ffe000'/%3E %3Cpath d='M524.76 263.66c1.65-1.26 4.16-1.87 6.42-1.87 2.3 0 4.81.61 6.46 1.91' stroke='%23ffd600'/%3E %3Cpath d='M524.8 263.58c1.65-1.26 4.12-1.87 6.38-1.87 2.25 0 4.73.61 6.42 1.87' stroke='%23ffcf00'/%3E %3Cpath d='M524.89 263.45c1.65-1.26 4.08-1.82 6.29-1.82 2.25 0 4.69.56 6.33 1.86' stroke='%23ffc400'/%3E %3Cpath d='M524.93 263.36c1.65-1.26 4.03-1.82 6.24-1.82s4.6.56 6.25 1.82' stroke='%23ffba00'/%3E %3Cpath d='M525.02 263.23c1.6-1.21 3.95-1.78 6.16-1.78s4.55.57 6.2 1.78' stroke='%23ffb000'/%3E %3Cpath d='M525.06 263.14c1.65-1.26 3.9-1.78 6.11-1.78 2.17 0 4.52.56 6.12 1.78' stroke='%23ffa600'/%3E %3Cpath d='M525.15 263.01c1.6-1.21 3.82-1.74 6.03-1.74 2.12 0 4.42.53 6.03 1.74' stroke='%23ff9c00'/%3E %3Cpath d='M525.19 262.93c1.6-1.21 3.82-1.74 5.98-1.74 2.13 0 4.39.53 6 1.7' stroke='%23ff9100'/%3E %3Cpath d='M525.28 262.79c1.6-1.17 3.73-1.7 5.9-1.7 2.08 0 4.34.53 5.9 1.66' stroke='%23ff8700'/%3E %3Cpath d='M525.32 262.71c1.6-1.21 3.68-1.7 5.85-1.7 2.09 0 4.26.53 5.86 1.66' stroke='%23ff7d00'/%3E %3Cpath d='M525.4 262.58c1.57-1.17 3.6-1.65 5.78-1.65 2.04 0 4.2.52 5.77 1.6' stroke='%23ff7500'/%3E %3Cpath d='M525.45 262.49a9.47 9.47 0 0 1 5.72-1.65c2.04 0 4.13.48 5.69 1.56' stroke='%23ff6b00'/%3E %3Cpath d='M525.54 262.36c1.56-1.17 3.51-1.6 5.64-1.6 2 0 4.08.47 5.64 1.56' stroke='%23ff6100'/%3E %3Cpath d='M525.58 262.27a9.14 9.14 0 0 1 5.6-1.6c1.95 0 4.03.47 5.55 1.51' stroke='%23ff5700'/%3E %3Cpath d='M524.32 264.23c1.78-1.39 4.5-2.04 6.85-2.04 2.43 0 5.08.7 6.81 2.08' stroke='%23ebf605'/%3E %3Cpath d='M524.28 264.36c1.86-1.48 4.5-2.08 6.9-2.08 2.42 0 5.16.7 6.9 2.12' stroke='%23d6ec09'/%3E %3Cpath d='M524.19 264.49c1.95-1.56 4.5-2.17 6.98-2.17 2.48 0 5.2.74 6.94 2.17' stroke='%23c2e30e'/%3E %3Cpath d='M524.1 264.62c2.09-1.65 4.56-2.21 7.08-2.21 2.47 0 5.25.73 6.98 2.21' stroke='%23add912'/%3E %3Cpath d='M524.06 264.75a10.94 10.94 0 0 1 7.07-2.26c2.56 0 5.34.74 7.11 2.22' stroke='%2399cf16'/%3E %3Cpath d='M523.98 264.88a10.85 10.85 0 0 1 7.16-2.34c2.6 0 5.42.78 7.15 2.3' stroke='%2385c61a'/%3E %3Cpath d='M523.93 265.01c2.3-1.87 4.55-2.39 7.2-2.39 2.6 0 5.47.78 7.24 2.3' stroke='%2370bc1f'/%3E %3Cpath d='M523.84 265.14a10.57 10.57 0 0 1 7.29-2.47c2.64 0 5.5.82 7.29 2.38' stroke='%235cb323'/%3E %3Cpath d='M523.76 265.22c2.51-2 4.6-2.47 7.37-2.47 2.65 0 5.56.82 7.38 2.38' stroke='%2347a928'/%3E %3Cpath d='M523.37 265.92c2.21-1.95 4.77-2.65 7.8-2.65 2.87 0 5.87.74 7.77 2.6' stroke='%230d74a4'/%3E %3Cpath d='M523.4 265.87c2.26-2 4.74-2.69 7.77-2.69 2.87 0 5.82.78 7.73 2.6' stroke='%23127a97'/%3E %3Cpath d='M523.46 265.79c2.3-2 4.73-2.65 7.72-2.65 2.82 0 5.82.78 7.68 2.56' stroke='%2317808b'/%3E %3Cpath d='M523.5 265.7c2.34-2 4.68-2.6 7.68-2.6 2.77 0 5.77.78 7.59 2.51' stroke='%231a847d'/%3E %3Cpath d='M523.54 265.66c2.38-2.04 4.68-2.65 7.59-2.65 2.82 0 5.77.83 7.6 2.52' stroke='%231e8a6d'/%3E %3Cpath d='M523.59 265.57c2.43-2.04 4.64-2.6 7.55-2.6 2.77 0 5.72.82 7.55 2.51' stroke='%23238f5e'/%3E %3Cpath d='M523.63 265.53c2.47-2.08 4.64-2.6 7.5-2.6 2.74 0 5.69.82 7.51 2.47' stroke='%232b944e'/%3E %3Cpath d='M523.67 265.44c2.51-2.08 4.6-2.56 7.46-2.56 2.69 0 5.68.82 7.46 2.43' stroke='%232f9b3e'/%3E %3Cpath d='M536.04 260.97a8.55 8.55 0 0 0-4.9-1.26c-1.96 0-3.48.35-4.95 1.35' stroke='red'/%3E %3Cpath d='M540.59 268.57c-2-2.82-5.38-4.17-9.37-4.17-3.6 0-6.51.78-8.99 3.3' stroke='%232a007c'/%3E %3Cpath d='M538.99 265.92c-1.91-1.87-4.9-2.6-7.81-2.6-3.08 0-5.69.73-7.85 2.69' stroke='%230671b0'/%3E %3Cpath d='M539.73 267.09c-2.04-2.47-5.17-3.25-8.6-3.25-3.2 0-6.29.73-8.32 2.95' stroke='%230c419a'/%3E %3Cpath d='M537.95 264.18c-1.74-1.39-4.38-2.04-6.77-2.04-2.3 0-5.08.65-6.77 1.95' stroke='%23FF0'/%3E %3Cpath d='M536.64 262.06c-1.52-1-3.52-1.48-5.51-1.48-2.09 0-3.9.44-5.47 1.61' stroke='%23ff4d00'/%3E %3Cpath d='M538.55 265.22c-1.78-1.56-4.73-2.43-7.42-2.43-2.82 0-4.86.48-7.42 2.56' stroke='%2333a02c'/%3E %3C/g%3E %3Cg stroke-width='.17' stroke-miterlimit='2.61' fill='none'%3E %3Cpath d='M521.94 268.13a20.3 20.3 0 0 1 9.2-2.26c3.25 0 6.72 1.22 9.45 2.7l9.64 16.1c0 10.53-8.6 19.26-19.1 19.26A19.17 19.17 0 0 1 512 284.75l9.94-16.62z' stroke='%23fef2ec'/%3E %3Cpath d='M531.14 266.09c3.2 0 6.63 1.26 9.32 2.69.05 0 9.5 15.84 9.5 15.88 0 10.37-8.45 19-18.82 19a18.9 18.9 0 0 1-18.88-18.91c0-.05 9.77-16.36 9.8-16.36a19.8 19.8 0 0 1 9.08-2.3z' stroke='%23fef2ea'/%3E %3Cpath d='M531.09 266.61c3.16 0 6.5 1.17 9.1 2.6.1.05 9.25 15.32 9.25 15.45 0 10.1-8.24 18.53-18.35 18.53a18.4 18.4 0 0 1-18.31-18.44c0-.13 9.41-15.88 9.5-15.93a19.47 19.47 0 0 1 8.8-2.2z' stroke='%23fef0e6'/%3E %3Cpath d='M531.09 267.13c3.08 0 6.33 1.13 8.85 2.52.17.08 9.02 14.84 9.02 15.05a18 18 0 0 1-17.87 17.97 17.9 17.9 0 0 1-17.84-17.92c0-.22 9.12-15.36 9.29-15.5a18.87 18.87 0 0 1 8.55-2.12z' stroke='%23feede3'/%3E %3Cpath d='M531.09 267.87c2.95 0 6.07 1.08 8.5 2.43.26.17 8.6 14.06 8.6 14.4 0 9.38-7.69 17.19-17.1 17.19-9.37 0-17.01-7.6-17.05-17.14 0-.35 8.54-14.67 8.85-14.8a18.08 18.08 0 0 1 8.2-2.08z' stroke='%23fee8dc'/%3E %3Cpath d='M531.09 268.39c2.86 0 5.9 1.04 8.24 2.34.35.22 8.33 13.54 8.33 13.97 0 9.12-7.46 16.7-16.57 16.7a16.6 16.6 0 0 1-16.53-16.65c0-.44 8.2-14.15 8.59-14.37a17.5 17.5 0 0 1 7.94-2z' stroke='%23fee6d5'/%3E %3Cpath d='M531.09 269.13c2.73 0 5.64 1.04 7.85 2.26.48.26 7.94 12.75 7.94 13.32a15.9 15.9 0 0 1-15.8 15.92 15.83 15.83 0 0 1-15.79-15.84c0-.6 7.73-13.45 8.2-13.75a16.68 16.68 0 0 1 7.6-1.91z' stroke='%23fee3cf'/%3E %3Cpath d='M531.09 269.65c2.69 0 5.42.95 7.63 2.17.52.3 7.68 12.23 7.68 12.89 0 8.41-6.9 15.4-15.31 15.4a15.3 15.3 0 0 1-15.27-15.32c0-.7 7.37-12.97 7.9-13.27a15.9 15.9 0 0 1 7.37-1.87z' stroke='%23fee0cc'/%3E %3Cpath d='M531.09 270.17c2.6 0 5.25.91 7.37 2.08.57.35 7.42 11.76 7.42 12.5 0 8.11-6.64 14.88-14.8 14.88-8.1 0-14.7-6.6-14.74-14.84 0-.78 7.02-12.5 7.63-12.84a15.7 15.7 0 0 1 7.12-1.78z' stroke='%23fedec6'/%3E %3Cpath d='M531.09 273.47c2.04 0 4.08.7 5.72 1.6 1.05.61 5.73 8.42 5.73 9.72a11.5 11.5 0 0 1-11.45 11.5 11.5 11.5 0 0 1-11.46-11.5c0-1.3 4.82-9.32 5.9-9.93 1.7-.87 3.52-1.39 5.56-1.39z' stroke='%23fdcdaa'/%3E %3Cpath d='M531.09 273.69c2 0 3.99.7 5.6 1.6 1.08.66 5.6 8.16 5.6 9.5 0 6.17-5.04 11.25-11.2 11.25a11.2 11.2 0 0 1-11.2-11.2c0-1.39 4.65-9.11 5.77-9.76a11.45 11.45 0 0 1 5.43-1.39z' stroke='%23fdcdaa'/%3E %3Cpath d='M531.09 274.94c1.78 0 3.55.6 4.99 1.43 1.26.74 4.94 6.86 4.94 8.42 0 5.47-4.47 9.98-9.93 9.98s-9.9-4.43-9.94-9.94c0-1.6 3.82-7.9 5.12-8.63a9.96 9.96 0 0 1 4.82-1.26z' stroke='%23fdc59e'/%3E %3Cpath d='M531.09 275.2c1.73 0 3.47.56 4.86 1.39 1.3.78 4.81 6.6 4.81 8.2a9.66 9.66 0 1 1-19.35.04c0-1.65 3.65-7.63 5-8.41a9.88 9.88 0 0 1 4.68-1.22z' stroke='%23fdc59e'/%3E %3Cpath d='M531.14 266.35c3.16 0 6.55 1.21 9.2 2.65.04.04 9.37 15.57 9.37 15.66 0 10.24-8.38 18.79-18.57 18.79a18.68 18.68 0 0 1-18.62-18.7c0-.09 9.6-16.1 9.64-16.14a19.54 19.54 0 0 1 8.98-2.26z' stroke='%23fef0e9'/%3E %3Cpath d='M531.09 266.87c3.12 0 6.42 1.17 8.98 2.56.13.09 9.15 15.1 9.15 15.27 0 9.94-8.15 18.23-18.13 18.23-9.94 0-18.01-8.07-18.1-18.18 0-.18 9.29-15.62 9.42-15.7a18.9 18.9 0 0 1 8.68-2.18z' stroke='%23feede3'/%3E %3Cpath d='M531.09 267.39c3.03 0 6.24 1.13 8.72 2.47.22.13 8.9 14.58 8.9 14.84 0 9.68-7.95 17.7-17.62 17.7a17.66 17.66 0 0 1-17.58-17.65c0-.26 8.9-15.15 9.12-15.28a18.61 18.61 0 0 1 8.46-2.08z' stroke='%23feebdf'/%3E %3Cpath d='M531.09 267.61c3 0 6.16 1.13 8.63 2.47.22.13 8.72 14.32 8.72 14.63 0 9.54-7.8 17.44-17.35 17.44a17.4 17.4 0 0 1-17.31-17.4c0-.3 8.72-14.88 8.98-15.06a18.5 18.5 0 0 1 8.33-2.08z' stroke='%23feebdd'/%3E %3Cpath d='M531.09 268.13c2.9 0 5.99 1.08 8.37 2.39.3.17 8.46 13.8 8.46 14.18 0 9.25-7.55 16.93-16.83 16.93a16.82 16.82 0 0 1-16.8-16.88c0-.4 8.38-14.4 8.73-14.58a17.5 17.5 0 0 1 8.07-2.04z' stroke='%23fee8d9'/%3E %3Cpath d='M531.09 268.65c2.82 0 5.81 1.04 8.11 2.3.4.22 8.2 13.28 8.2 13.75 0 8.99-7.33 16.45-16.31 16.45a16.42 16.42 0 0 1-16.32-16.36c0-.52 8.07-13.97 8.46-14.19a17.24 17.24 0 0 1 7.86-1.95z' stroke='%23fee6d3'/%3E %3Cpath d='M531.09 268.91c2.77 0 5.72 1 7.98 2.26.43.26 8.07 13.01 8.07 13.53 0 8.85-7.2 16.19-16.05 16.19-8.81 0-15.97-7.16-16.06-16.1 0-.56 7.9-13.71 8.33-13.97 2.39-1.17 4.9-1.91 7.73-1.91z' stroke='%23fee3d2'/%3E %3Cpath d='M531.09 269.39c2.73 0 5.5 1 7.72 2.21.52.3 7.85 12.5 7.85 13.1 0 8.6-7.03 15.67-15.57 15.67s-15.5-6.94-15.54-15.58c0-.65 7.55-13.23 8.07-13.49a16.14 16.14 0 0 1 7.47-1.91z' stroke='%23fee0cc'/%3E %3Cpath d='M531.09 269.91c2.64 0 5.33.95 7.5 2.13.52.34 7.55 12.01 7.55 12.7 0 8.25-6.77 15.1-15.05 15.1a15.06 15.06 0 0 1-15.02-15.05c0-.74 7.2-12.76 7.77-13.06a15.75 15.75 0 0 1 7.25-1.82z' stroke='%23fedec8'/%3E %3Cpath d='M531.09 270.43c2.56 0 5.16.91 7.24 2.04.61.39 7.3 11.5 7.3 12.28 0 7.98-6.56 14.62-14.54 14.62-7.99 0-14.45-6.5-14.5-14.58 0-.82 6.86-12.23 7.51-12.62a15.14 15.14 0 0 1 6.99-1.74z' stroke='%23fddbc5'/%3E %3Cpath d='M531.09 270.65c2.51 0 5.07.91 7.11 2.04.65.39 7.16 11.24 7.16 12.06 0 7.85-6.42 14.36-14.27 14.36a14.32 14.32 0 0 1-14.28-14.32c0-.86 6.73-12.01 7.42-12.4a15.12 15.12 0 0 1 6.86-1.74z' stroke='%23fddbc2'/%3E %3Cpath d='M531.09 270.91c2.47 0 4.99.87 6.98 2 .7.43 7.03 10.97 7.03 11.84 0 7.72-6.29 14.1-14.01 14.1a14.05 14.05 0 0 1-14.02-14.05c0-.91 6.55-11.76 7.25-12.2 2.08-1.04 4.3-1.69 6.77-1.69z' stroke='%23fdd9bf'/%3E %3Cpath d='M531.09 271.17c2.43 0 4.9.87 6.85 1.95.74.44 6.9 10.72 6.9 11.63 0 7.6-6.16 13.84-13.75 13.84a13.8 13.8 0 0 1-13.76-13.8c0-.95 6.38-11.5 7.12-11.93 2.04-1.04 4.2-1.69 6.64-1.69z' stroke='%23fdd9bf'/%3E %3Cpath d='M531.09 271.43c2.38 0 4.81.82 6.72 1.9.78.49 6.77 10.47 6.77 11.42 0 7.42-6.07 13.58-13.5 13.58a13.55 13.55 0 0 1-13.49-13.54c0-1 6.2-11.28 6.99-11.71a13.8 13.8 0 0 1 6.5-1.65z' stroke='%23fdd6bc'/%3E %3Cpath d='M531.09 271.69c2.34 0 4.73.82 6.6 1.87.82.47 6.63 10.2 6.63 11.19 0 7.29-5.94 13.32-13.23 13.32-7.3 0-13.2-5.9-13.24-13.28 0-1.04 6-11.02 6.86-11.5 1.95-1 4.03-1.6 6.38-1.6z' stroke='%23fdd6b9'/%3E %3Cpath d='M531.09 271.95c2.3 0 4.64.78 6.5 1.82.83.52 6.51 9.94 6.51 10.98 0 7.16-5.85 13.1-13.01 13.1a13.03 13.03 0 0 1-12.98-13.06c0-1.08 5.82-10.8 6.69-11.28 1.95-1 3.99-1.56 6.29-1.56z' stroke='%23fdd4b8'/%3E %3Cpath d='M531.09 272.17c2.25 0 4.55.82 6.37 1.82.87.52 6.38 9.68 6.38 10.76 0 7.03-5.72 12.84-12.75 12.84a12.72 12.72 0 0 1-12.71-12.8c0-1.12 5.64-10.54 6.55-11.06 1.9-.95 3.9-1.56 6.16-1.56z' stroke='%23fdd4b6'/%3E %3Cpath d='M531.09 272.43c2.21 0 4.47.78 6.24 1.78.92.52 6.25 9.41 6.25 10.54a12.6 12.6 0 0 1-12.5 12.58c-6.85 0-12.45-5.6-12.49-12.53 0-1.13 5.51-10.29 6.47-10.85a13.36 13.36 0 0 1 6.03-1.52z' stroke='%23fdd2b2'/%3E %3Cpath d='M531.09 272.69c2.17 0 4.38.74 6.11 1.74.96.56 6.12 9.15 6.12 10.37 0 6.72-5.5 12.27-12.23 12.27s-12.2-5.46-12.24-12.27c0-1.18 5.34-10.07 6.34-10.6a12.3 12.3 0 0 1 5.9-1.51z' stroke='%23fdd1b0'/%3E %3Cpath d='M531.09 272.95c2.12 0 4.25.74 5.99 1.7 1 .56 5.98 8.89 5.98 10.15 0 6.59-5.38 12.01-11.97 12.01a12 12 0 0 1-11.98-12.01c0-1.22 5.17-9.81 6.2-10.37a12.24 12.24 0 0 1 5.78-1.48z' stroke='%23fdd0b0'/%3E %3Cpath d='M531.09 273.21c2.08 0 4.16.7 5.86 1.65 1.04.6 5.85 8.68 5.85 9.93 0 6.42-5.25 11.76-11.71 11.76-6.47 0-11.67-5.2-11.72-11.76 0-1.25 5-9.54 6.03-10.15a12 12 0 0 1 5.69-1.43z' stroke='%23fdd0ad'/%3E %3Cpath d='M531.09 273.95c1.95 0 3.9.65 5.5 1.56 1.1.65 5.43 7.9 5.43 9.29 0 6.03-4.9 11.02-10.93 11.02-6.03 0-10.94-4.9-10.94-10.98 0-1.43 4.47-8.9 5.64-9.54a11.4 11.4 0 0 1 5.3-1.35z' stroke='%23fdcaa6'/%3E %3Cpath d='M531.09 274.21c1.9 0 3.82.65 5.38 1.52 1.13.7 5.3 7.64 5.3 9.07 0 5.9-4.78 10.76-10.68 10.76-5.9 0-10.68-4.78-10.72-10.72 0-1.48 4.34-8.63 5.51-9.33 1.6-.82 3.3-1.3 5.2-1.3z' stroke='%23fdcaa4'/%3E %3Cpath d='M531.09 274.47c1.86 0 3.73.6 5.25 1.48 1.17.69 5.2 7.37 5.2 8.85a10.5 10.5 0 0 1-10.45 10.5 10.49 10.49 0 0 1-10.46-10.46c0-1.52 4.17-8.37 5.38-9.07 1.56-.82 3.21-1.3 5.08-1.3z' stroke='%23fdc8a4'/%3E %3Cpath d='M531.09 274.73c1.82 0 3.64.6 5.12 1.43 1.21.74 5.07 7.12 5.07 8.64 0 5.64-4.6 10.24-10.2 10.24-5.59 0-10.15-4.56-10.19-10.2 0-1.56 4-8.16 5.25-8.85a10.6 10.6 0 0 1 4.95-1.26z' stroke='%23fdc8a1'/%3E %3Cpath d='M531.09 275.46c1.69 0 3.38.56 4.73 1.35 1.34.78 4.68 6.33 4.68 7.98a9.4 9.4 0 1 1-18.83.04c0-1.69 3.47-7.42 4.82-8.2a9.63 9.63 0 0 1 4.6-1.17z' stroke='%23fdc39b'/%3E %3Cpath d='M531.09 275.72c1.65 0 3.3.52 4.6 1.3 1.39.83 4.55 6.08 4.55 7.81 0 5.04-4.12 9.2-9.15 9.2a9.17 9.17 0 0 1-9.16-9.2c0-1.73 3.3-7.16 4.69-7.98a9.6 9.6 0 0 1 4.47-1.13z' stroke='%23fdc398'/%3E %3Cpath d='M531.09 275.98c1.6 0 3.2.52 4.51 1.26 1.39.82 4.38 5.81 4.38 7.59 0 4.9-3.99 8.94-8.9 8.94s-8.89-4-8.89-8.94c0-1.78 3.08-6.94 4.56-7.77a9.07 9.07 0 0 1 4.34-1.08z' stroke='%23fdc097'/%3E %3Cpath d='M531.09 276.25c1.56 0 3.12.48 4.38 1.21 1.43.87 4.25 5.6 4.25 7.38a8.67 8.67 0 0 1-8.63 8.68 8.7 8.7 0 0 1-8.68-8.68c0-1.82 2.95-6.68 4.47-7.5a8.56 8.56 0 0 1 4.2-1.09z' stroke='%23fdc095'/%3E %3Cpath d='M531.09 276.46c1.52 0 3 .52 4.25 1.21 1.47.87 4.12 5.34 4.12 7.16a8.39 8.39 0 1 1-16.79 0c0-1.86 2.78-6.42 4.3-7.29a8.84 8.84 0 0 1 4.12-1.08z' stroke='%23fdbe92'/%3E %3Cpath d='M531.09 276.72c1.47 0 2.9.48 4.12 1.17 1.47.91 3.99 5.08 3.99 6.94a8.17 8.17 0 0 1-8.11 8.16 8.15 8.15 0 0 1-8.16-8.16c0-1.9 2.6-6.2 4.16-7.07a8.28 8.28 0 0 1 4-1.04z' stroke='%23fdbe90'/%3E %3Cpath d='M531.09 276.98a7.9 7.9 0 0 1 3.99 1.13c1.52.9 3.9 4.81 3.9 6.72a7.9 7.9 0 1 1-15.8 0c.01-1.95 2.44-5.94 4.05-6.85 1.17-.6 2.43-1 3.86-1z' stroke='%23fdbb8f'/%3E %3Cpath d='M531.09 277.24c1.39 0 2.73.43 3.86 1.08 1.56.96 3.77 4.56 3.77 6.51a7.65 7.65 0 0 1-15.27 0c0-2 2.26-5.68 3.9-6.64a7.57 7.57 0 0 1 3.74-.95z' stroke='%23fdbb8d'/%3E %3Cpath d='M531.09 277.5a7.3 7.3 0 0 1 3.73 1.04c1.6.96 3.64 4.3 3.64 6.3 0 4.07-3.3 7.41-7.37 7.41s-7.38-3.34-7.38-7.42c0-2.04 2.08-5.46 3.78-6.42a7.5 7.5 0 0 1 3.6-.91z' stroke='%23fdb98a'/%3E %3Cpath d='M531.09 277.76c1.3 0 2.56.39 3.6 1 1.65 1 3.51 4.03 3.51 6.07a7.16 7.16 0 0 1-7.11 7.16 7.13 7.13 0 0 1-7.12-7.16c0-2.08 1.91-5.2 3.6-6.16a6.84 6.84 0 0 1 3.52-.91z' stroke='%23fdb98a'/%3E %3Cpath d='M531.09 277.98c1.26 0 2.47.4 3.51 1 1.65 1 3.34 3.77 3.34 5.85a6.88 6.88 0 1 1-13.75 0c0-2.12 1.78-4.98 3.51-5.94a6.8 6.8 0 0 1 3.39-.91z' stroke='%23fcb687'/%3E %3Cpath d='M531.09 278.24c1.21 0 2.38.35 3.38.95a7.37 7.37 0 0 1 3.21 5.64c0 3.7-2.95 6.64-6.6 6.64s-6.63-2.95-6.63-6.64c0-2.16 1.6-4.72 3.38-5.72a6.3 6.3 0 0 1 3.26-.87z' stroke='%23fcb685'/%3E %3Cpath d='M531.09 278.5c1.17 0 2.3.35 3.25.91a6.66 6.66 0 0 1 3.08 5.42 6.35 6.35 0 1 1-12.71.05 6.72 6.72 0 0 1 3.25-5.56 6.21 6.21 0 0 1 3.13-.82z' stroke='%23fcb485'/%3E %3Cpath d='M531.09 290.95a6.1 6.1 0 1 0-.04-12.18 6.1 6.1 0 0 0 .04 12.18z' stroke='%23fcb482'/%3E %3C/g%3E %3Cpath d='M531.14 291a6.1 6.1 0 1 0-.06-12.2 6.1 6.1 0 0 0 .06 12.2z' fill-rule='evenodd' stroke='%23fff' stroke-miterlimit='2.61' stroke-width='.13' fill='%23fff'/%3E %3Cg stroke='%23000' stroke-width='.13'%3E %3Cg fill='none'%3E %3Cpath d='M532.44 278.89l.69-3.25M531.79 278.81l.34-3.3M531.14 278.76v-3.3M530.53 278.81l-.35-3.3M529.88 278.89l-.7-3.25M529.27 279.07l-1.04-3.17M528.66 279.28l-1.34-3.03M528.1 279.54l-1.7-2.86M527.53 279.89l-1.95-2.65M527.06 280.32l-2.26-2.47M526.58 280.76l-2.47-2.22M526.19 281.28l-2.7-1.95M525.8 281.8l-2.86-1.65M525.54 282.36l-3.04-1.34M525.28 282.97l-3.13-1.04M525.1 283.58l-3.21-.7M525.02 284.23l-3.3-.35M524.97 284.88h-3.3M525.02 285.49l-3.3.34M525.1 286.14l-3.25.69M525.28 286.74l-3.17 1.05M525.5 287.35l-3.04 1.35M525.8 287.92l-3.52 2.17M526.14 288.48l-7.2 5.12M526.54 288.96l-7.68 6.81M526.97 289.43l-6.34 7.08M527.49 289.83l-4.82 6.46M528 290.22l-5.02 8.72M528.58 290.48l-2.78 6.33M529.18 290.74l-2.82 8.72M529.79 290.91l-1.21 5.86M530.44 291l-.87 9.02M531.7 291l.35 3.29M532.35 290.91l1.95 8.5M532.96 290.74l1.65 5.03M533.56 290.52l3.87 8.37M534.17 290.22l4.12 7.11M534.69 289.87l5.95 7.81M535.2 289.48l5.22 6.03M535.65 289.05l7.72 7.02M536.04 288.52l4.2 3.04M536.43 288l2.86 1.65M536.69 287.44l3.04 1.34M536.95 286.83l3.12 1.04M537.12 286.22l3.2.7M537.2 285.57l3.3.35M537.25 284.92h3.3M537.2 284.31l3.3-.34M537.12 283.66l3.26-.69M536.95 283.06l3.17-1.04M536.73 282.45l3.04-1.35M536.47 281.84l2.87-1.65M536.12 281.32l2.65-1.95M535.69 280.8l2.47-2.21M535.26 280.37l2.2-2.48M534.74 279.93l1.95-2.64M534.22 279.59l1.64-2.87M533.65 279.33l1.35-3.04M533.04 279.07l1.05-3.13M531.14 270.99v-2.56M528.27 271.3l-.52-2.52M525.5 272.17l-1.05-2.3M522.98 273.64l-1.52-2.08M520.8 275.55l-1.9-1.69M519.12 277.94l-2.26-1.3M517.9 280.58l-2.43-.82M517.29 283.4l-2.56-.26M517.29 286.31l-2.56.26M517.9 289.18l-2.47.78M543.15 291.87l2.22 1.3M544.32 289.22l2.43.78M544.93 286.4l2.56.26M544.93 283.49l2.56-.26M544.32 280.63l2.48-.78M543.15 277.98l2.22-1.3M541.46 275.64l1.9-1.74M539.34 273.69l1.47-2.09M536.82 272.21l1.04-2.34M534.04 271.3l.52-2.47'/%3E %3C/g%3E %3Cpath d='M534.69 287.74s-.87-.48-1.4-.48c-.51 0-2.81-.13-3.72.13-.52.18-.96.61-.96.61s.61.6 1.82.74c1.26.08 2.04 0 2.7-.22.73-.22 1.56-.78 1.56-.78z' fill-rule='evenodd' stroke-miterlimit='2.61' fill='%23e60000'/%3E %3Cpath d='M528.79 286.83s.08-1.7 1.26-3.82c0 0-.4.6-.61 1.13 0 0-.65.35-1.04-.13-.4-.39-.18-.56.13-1.17.26-.48.21-.96.56-1.26.3-.3.56-.35 1.39-.35.82 0 1.34.09 2.04 1.04.6.83.95 1.6 1.26 2.04.69 1.09.69 2.39.69 2.39l.22 1.04s-.87-.48-1.4-.48c-.51 0-2.81-.13-3.72.13-.52.18-.96.6-.96.6s-.34-.77.18-1.16z' fill-rule='evenodd' stroke-miterlimit='2.61' fill='%23e60000'/%3E %3Cpath d='M528.79 286.83s.65-.4 2.86-.35c2.56.05 2.65.22 2.82.4' stroke-miterlimit='2.61' fill='none'/%3E %3Cpath d='M531 296.38v-8.98s.3-.26 1 0v8.9s.21 6.8-.53 6.76c-.86 0-.47-1.56-.47-6.68z' fill-rule='evenodd' stroke-miterlimit='2.61' fill='%23FC0'/%3E %3C/g%3E %3Cg fill='%23e60000'%3E %3Cpath d='M521.72 288.83l.17.35-1.73.73.26.61-.26.09c-.18-.4-.3-.52-.74-.43l-.13-.27 2.43-1.08zM519.85 288.09a.77.77 0 0 1-.3-.48c-.1-.43.08-.9.64-1.04.26-.08.92-.08 1.13.74.09.35.05.78-.52 1l-.08-.35c.3-.09.39-.35.3-.65-.09-.35-.4-.48-.74-.39-.35.09-.48.39-.43.7.04.17.17.34.39.43l.04.26-1.47.13-.3-1.35.34-.04.26 1.08.74-.04zM519.16 283.23c-.44 0-.61.3-.61.6-.04.27 0 .66.39.7.26 0 .35-.17.4-.3l.25-.78c.09-.35.35-.57.74-.52.65.04.78.65.73 1.13-.04.47-.21.69-.3.78-.26.21-.48.26-.74.21l.05-.34c.47.04.65-.35.7-.7.03-.26 0-.7-.4-.74-.3-.04-.39.1-.52.53l-.17.56c-.09.17-.22.56-.7.52-.43-.04-.82-.35-.78-1 .09-.95.65-1 .96-1v.35zM519.03 281.54l.78.26.47-1.43.3.13-.47 1.39.87.3.52-1.56.3.08-.6 1.91-2.6-.82.6-1.91.35.13z' fill-rule='evenodd'/%3E %3Cpath d='M520.81 277.53a.9.9 0 0 0-.53.4l-.6 1.04 2.29 1.43.21-.28-1-.62.44-.72c.3-.52.1-.94-.25-1.16a.71.71 0 0 0-.56-.09zm.16.4c.06.02.12.06.18.1.26.17.27.4.1.66l-.35.56-.75-.44.41-.62c.1-.17.23-.28.4-.25z'/%3E %3Cpath d='M523.97 277.68l-.21.26-1.74-1.65-.65.65-.22-.22 1.52-1.6.26.21-.65.7zM524.88 276.9l-1.6-2.17.26-.22 1.65 2.17zM524.84 274.03l.39.74 1.35-.7.13.3-1.3.7.38.78 1.48-.73.13.26-1.78.95-1.26-2.43 1.78-.9.13.3zM529.88 274.77l-.35-1.56c0-.09-.04-.4-.13-.65l-.26 2.38-.35.1-1.26-2.1c.05.27.13.62.18.66l.34 1.6-.34.05-.61-2.65.52-.09 1.26 2.09.26-2.43.52-.13.56 2.69-.34.04z' fill-rule='evenodd'/%3E %3Cpath d='M530.78 272l-.13 2.72 1.16.03c.6.04.97-.28.97-.72.04-.48-.3-.6-.47-.69a.6.6 0 0 0 .38-.56c.04-.39-.2-.7-.72-.75l-1.2-.03zm.4.38l.6.06c.4 0 .53.11.53.37-.04.3-.21.39-.56.35h-.63l.07-.79zm-.06 1.12l.66.06c.26 0 .56.1.56.44 0 .26-.21.44-.56.44l-.69-.06.03-.88zM533.81 272.25l-.72 2.66.35.09.28-1.13.87.25c.44.13.4.38.35.6-.05.08-.17.48-.13.65l.44.13v-.03c-.09-.09-.07-.14-.03-.31l.06-.47c.13-.35 0-.48-.12-.56.17-.1.44-.15.53-.54.17-.56-.22-.8-.66-.93l-1.22-.41zm.35.47l.78.28c.17.04.44.11.31.5-.09.35-.33.32-.6.28l-.74-.22.25-.84z'/%3E %3Cpath d='M537.03 273.82l-.43.69 1.3.78-.17.26-1.3-.74-.44.78 1.39.83-.13.26-1.74-1 1.35-2.34 1.73 1-.17.3z' fill-rule='evenodd'/%3E %3Cpath d='M540.31 275.81l-2.06 1.72.68.87c.61.65 1.34.36 1.82-.03.6-.48.76-1.18.28-1.75l-.72-.81zm-.03.6l.4.5c.3.34.26.72-.21 1.15-.48.4-.92.38-1.22.03l-.4-.47 1.43-1.22z'/%3E %3Cpath d='M542.2 278.85l-.79.39.7 1.3-.3.17-.66-1.34-.82.39.74 1.47-.3.14-.92-1.78 2.43-1.22.91 1.78-.3.13zM541.24 283.71l-.05-.35 1.87-.26-.09-.6.26-.05c.13.44.18.57.61.61l.04.26-2.64.39z' fill-rule='evenodd'/%3E %3Cpath d='M542.09 284.53c-.13 0-.36-.01-.63.25-.17.22-.21.48-.21.66-.05.6.39.9.78.9.21.05.51-.03.69-.37.04.13.18.34.53.34.34.04.72-.17.72-.78.04-.6-.39-.84-.7-.84-.25 0-.44.11-.52.37-.1-.3-.31-.49-.66-.53zm0 .44c.22 0 .45.18.4.53 0 .26-.12.47-.46.47-.4 0-.44-.32-.44-.53 0-.4.28-.47.5-.47zm1.19.12c.17 0 .38.1.34.44 0 .35-.21.44-.34.44a.51.51 0 0 1-.4-.5c0-.22.18-.38.4-.38z'/%3E %3Cpath d='M542.89 286.92c.86.22.78.87.73 1.13-.13.43-.52.74-1 .6-.43-.08-.56-.43-.69-.9l-.08-.3c-.1-.4-.26-.53-.4-.57l-.34 1.43-.3-.09.43-1.78c.56.18.78.48.9.87l.1.4c.08.3.17.56.52.6.17.09.47 0 .56-.4.13-.47-.3-.6-.48-.64l.05-.35zM540.25 289.52l.17-.35 1.7.83.25-.57.26.09c-.17.43-.21.6.13.87l-.08.26-2.43-1.13z' fill-rule='evenodd'/%3E %3C/g%3E %3Cpath d='M531.13 252.82l-45.38 75.93h90.8z' stroke='%23000' stroke-miterlimit='2.61' stroke-width='.29983679999999996' fill='none'/%3E %3Cg stroke-miterlimit='2.61' fill='none'%3E %3Cpath d='M533.56 319.37c1.17.3 2.6.48 4.03.09 1.95-.48 3.78-1.6 6.08-1.4 1.64.18 3.9 1.61 6.63 1.61 2.7 0 3.6-.95 5.95-1.43 1.65-.35 2.47-.17 4.25.22 2.04.39 3.08 1.56 6.5 1.3' stroke='%23000' stroke-width='.13'/%3E %3Cpath d='M498.55 322.63c1.51-1.17 4.2-1.65 6.24-1.17 2.7.56 3.87 1.26 6.73 1.21 2.13-.04 3.95-1.47 6.12-1.47 3.6 0 3.73.74 6.9 1.34.82.18 1.86.18 2.69 0 1.17-.21 2.2-.6 3.16-1.08 1-.52 3.52-.44 4.78-.3 2.25.21 3.16 1.08 3.64 1.2 1.21.31 2.6.49 4.03.1 1.96-.57 3.78-1.83 6.12-1.57 1.65.18 3.9 1.78 6.6 1.78 2.69 0 3.64-1.08 5.94-1.6 1.7-.4 2.52-.18 4.3.21 2 .48 3.08 1.78 6.5 1.48' stroke='%23fff' stroke-width='.48'/%3E %3Cpath d='M493.43 320.07c1.52-1 4.2-1.43 6.24-1.04 2.7.52 3.87 1.17 6.73 1.13 2.13-.05 3.95-1.35 6.12-1.35 3.6 0 3.73.7 6.9 1.22a9.3 9.3 0 0 0 2.69 0c1.17-.18 2.2-.57 3.16-1 .96-.44 3.52-.35 4.78-.26 2.25.22 3.16.95 3.64 1.08 1.21.26 2.6.44 4.03.09 1.96-.52 3.78-1.6 6.12-1.39 1.65.17 3.9 1.6 6.6 1.56 2.69 0 3.64-.95 5.94-1.43 1.7-.35 2.52-.13 4.3.22 2 .43 3.08 1.6 6.5 1.3' stroke='%23fff' stroke-width='.35'/%3E %3Cpath d='M488.74 327.49c1.52-1.26 4.2-1.78 6.29-1.3 2.65.65 3.82 1.43 6.68 1.39 2.13-.05 4-1.65 6.12-1.65 3.64 0 3.73.82 6.9 1.52.82.17 1.86.17 2.73 0 1.17-.26 2.17-.7 3.12-1.26 1-.52 3.52-.43 4.82-.3 2.21.25 3.12 1.17 3.6 1.34 1.22.3 2.6.52 4.08.09 1.95-.65 3.77-2 6.07-1.74 1.65.22 3.9 2 6.64 2 2.65 0 3.6-1.22 5.9-1.83 1.7-.43 2.52-.17 4.3.27 2.04.52 3.08 2 6.5 1.64' stroke='%23fff' stroke-width='.61'/%3E %3Cpath d='M489.96 323.23c1.56-1.04 4.25-1.43 6.29-1.04 2.69.52 3.86 1.13 6.72 1.08.96 0 1.83-.26 2.74-.56' stroke='%23fff' stroke-width='.35'/%3E %3Cpath d='M503.7 318.81c.44-.13 1.7-.74 3.52-.74 3.65 0 1.35.05 4.51.61.83.13 3.13.17 3.78-.48M547.28 328.49a14.2 14.2 0 0 0 3.16-1c.96-.43 3.47-.39 4.78-.26 2.25.22 3.12.96 3.64 1.04 1.22.3 2.6.48 4.04.09 1.95-.48 3.77-1.6 6.11-1.39 1.65.17 3.9 1.6 6.6 1.6' stroke='%23000' stroke-width='.3'/%3E %3Cpath d='M552.87 318.46c2.69 0 3.6-.95 5.94-1.43 1.65-.35 2.48-.13 4.25.22 2.04.39 3.08 1.6 6.51 1.3' stroke='%23fff' stroke-width='.35'/%3E %3Cpath d='M488.87 327.75a9.63 9.63 0 0 1 6.29-1.04c2.69.52 3.86 1.17 6.72 1.13 2.13-.05 3.95-1.35 6.12-1.35 3.6 0 3.73.7 6.9 1.22a9.3 9.3 0 0 0 2.69 0c1.17-.18 2.17-.57 3.17-1 .95-.44 3.47-.35 4.77-.22 2.25.18 3.12.91 3.64 1.04' stroke='%23000' stroke-width='.13'/%3E %3Cpath d='M494.6 324.45c1.56-1.04 4.25-1.43 6.29-1.04 2.69.52 3.86 1.13 6.68 1.08 2.17-.04 3.99-1.34 6.12-1.3 3.64 0 3.77.65 6.94 1.22a9.3 9.3 0 0 0 2.69 0c1.17-.22 2.17-.57 3.17-1 .95-.44 3.47-.4 4.77-.26 2.21.22 3.12.95 3.64 1.04 1.17.3 2.6.48 4.04.09 1.95-.48 3.77-1.6 6.12-1.4 1.77.18 4.03 1.61 6.6 1.61 2.68 0 3.64-.95 5.93-1.43 1.65-.35 2.48-.17 4.3.22 2 .39 3.08 1.56 6.46 1.26' stroke='%23000' stroke-width='.61'/%3E %3C/g%3E %3Cg fill-rule='evenodd' stroke='%23000' stroke-width='.26' fill='%23fc0'%3E %3Cpath d='M495.82 311.82c.43.09 1.47-.74 1.78-.96.43-.26.65-.9 1-1.25.34-.4 1.38-.87 1.86-1.18 2.08-1.3 3.04-2.03 4.47-3.94a22.17 22.17 0 0 1 7.11-6.51c.91-.52 2.3-.35 3.3.08.3.14.7.48 1.04.74 1.22.96 2.87 1.65 4.86 2.26 1.91.56 2.34 1.82 3.86 3.17.74.65 1.57 1.21 2.48 1.64.08.05.3.4.39.44.86.65 1.82 1.17 2.56 1.82a83.7 83.7 0 0 1 3.99 3.86c.21.22.3.65.52.83 1 .95 1.95 1.95 3.16 2.51 1.22.61 2.3 1.4 3.43 2.09-11.54.43-22.17-.3-33.75.04-.3.04-.4 0-2.13 0-.87-.04-1.39.04-2.26.04-3.51-.04-6.85-.04-10.97-.08l3.3-5.6z'/%3E %3Cpath d='M541.16 317.12c-.96-.6-1.91-1.26-2.95-1.78-1.22-.56-2.17-1.56-3.17-2.52-.22-.17-.3-.6-.52-.82-1.3-1.35-2.6-2.6-4-3.86-.73-.65-1.69-1.17-2.55-1.82-.09-.05-.3-.4-.4-.44-.9-.43-1.73-1-2.47-1.65-1-.9-1.51-1.73-2.34-2.38l.04-.05c.48-.34 1-.7 1.57-.95.73-.44 1.9-.3 2.73.08.26.1.6.35.87.57 1 .82 2.38 1.39 4.03 1.9 1.6.49 2 1.53 3.26 2.61.6.57 1.26 1.04 2.04 1.4.04.03.21.3.3.38.74.52 1.52.96 2.17 1.52a77.03 77.03 0 0 1 3.3 3.21c.17.17.21.52.43.7.83.78 1.65 1.6 2.65 2.08 1 .47 1.86 1.13 2.82 1.69-2.6.13-5.16.13-7.72.13h-.1z'/%3E %3Cpath d='M530.87 303.06c.34.09.73.22 1.12.35 1.61.48 2 1.52 3.26 2.6.6.57 1.26 1.04 2.04 1.39.04.04.21.3.3.39.74.52 1.52.96 2.17 1.52a77.03 77.03 0 0 1 3.3 3.2c.17.18.22.53.43.7.83.78 1.65 1.61 2.65 2.09.87.39 1.6.95 2.39 1.43 2.12 0 4.25-.04 6.46-.13-.87-.52-1.65-1.13-2.6-1.56-.91-.44-1.6-1.18-2.39-1.91-.17-.13-.22-.44-.39-.61-1-1.04-2-1.95-3.04-2.9-.56-.53-1.26-.92-1.9-1.4-.1-.04-.27-.3-.3-.34a7.8 7.8 0 0 1-1.88-1.26c-1.12-1-1.47-1.96-2.95-2.39-1.47-.43-2.73-1-3.64-1.7-.26-.2-.56-.47-.78-.56-.78-.34-1.82-.47-2.52-.08-.6.35-1.21.74-1.73 1.17z'/%3E %3Cpath d='M541.46 305.53c.3.35.6.7 1.04 1.08a7.8 7.8 0 0 0 1.86 1.26c.05.05.22.3.3.35.66.48 1.35.87 1.92 1.39 1.04.95 2.04 1.87 3.03 2.9.18.18.22.48.4.61.78.74 1.47 1.48 2.38 1.91.6.3 1.13.65 1.7 1h-.05c2.52 0 5.03 0 7.6-.09-.7-.43-1.3-.9-2.09-1.25-.74-.4-1.3-1-1.95-1.57-.13-.13-.18-.34-.3-.52-.83-.82-1.61-1.56-2.44-2.34-.47-.43-1.04-.74-1.56-1.13-.09-.04-.22-.22-.26-.26a7.09 7.09 0 0 1-1.52-1c-.9-.82-1.17-1.6-2.34-1.95a9.11 9.11 0 0 1-3-1.39c-.21-.17-.43-.35-.6-.43-.65-.26-1.48-.4-2.04-.09-.78.43-1.43.91-2.09 1.48v.04z'/%3E %3Cpath d='M561.12 315.6a9.2 9.2 0 0 0-1.57-.91c-.73-.4-1.3-1-1.95-1.56-.13-.13-.17-.35-.3-.52-.83-.83-1.6-1.57-2.43-2.35-.48-.43-1.04-.74-1.56-1.13-.1-.04-.22-.21-.26-.26a7.09 7.09 0 0 1-1.52-1c-.78-.69-1.09-1.34-1.87-1.77l.04.04c.4-.3.83-.6 1.26-.82.52-.3 1.22-.18 1.78.04.13.04.35.26.52.39.65.48 1.48.87 2.56 1.17 1 .3 1.22.96 2 1.65.39.35.82.65 1.3.87.04.04.13.21.22.26.43.3.95.56 1.34.95.7.65 1.4 1.3 2.09 2 .13.13.13.35.26.43.52.48 1.04 1 1.65 1.3.65.35 1.21.74 1.82 1.09-1.82.09-3.6.09-5.38.09v.04z'/%3E %3C/g%3E %3Cg stroke='%2300633b' stroke-width='.13' fill='none'%3E %3Cpath d='M510.96 298.72c.56-.09.3-.22.82.13M509.92 299.41c.6-.09.82-.48 1.26.04M509.35 299.81c.26 0 .43-.3 1.26.17M508.75 300.5c.52-.13.82-.09 1.34.09M508.05 301.02c.6-.17.86.26 1.52.13M507.3 301.76c.4 0 .53-.13.87 0 .44.13.35.04.79.09M506.49 302.54c.43 0 .56-.09.95-.04.52.08.4.13.91.04M506 303.19a3.12 3.12 0 0 1 1.74.17M504.84 304.79c.73-.22 1.08-.22 1.73.04M492.78 317.2c2.38-.4 5.2.04 7.59-.3M505.19 304.01c.6-.22.47-.13 1.08-.09.61.09.87.18 1.04.09M504.23 305.4c.6-.3 1.34-.13 1.95.04M505.8 306.05c-.65-.17-1.35-.04-2.04 0M505.28 306.75c-.7-.22-1.44-.3-2.13-.09M502.19 307.27c.86 0 1.69-.22 2.56.09M501.46 307.96c.9-.3 1.82-.04 2.77.04M500.59 308.48c.95-.04 1.86-.04 2.82-.09.13 0 .43-.13.6.09M503.7 309c-1.43.3-2.86.09-4.29.13M502.93 309.74c-.48.04-1.22.22-1.87.17-.13-.04-.26-.13-.39-.13a5.22 5.22 0 0 0-2.17.22M498.2 310.52c.3-.17.65-.22.95-.13.91.13 1.78 0 2.65.22.22.08.43.21.7.21M497.68 310.87c.65 0 1.3-.09 1.95.04.82.22 1.6.4 2.47.44h-.08M497.07 311.35c.7 0 1.34.13 2.04.26.9.17 1.82-.09 2.69.17M496.25 311.78c.9.39 1.86.04 2.82.22.9.17 1.73.13 2.6.3M495.64 312.47c1.39.04 2.77 0 4.2.26.4.09 1 .26 1.52.17M495.17 313.08c1.34.26 2.73.04 4.07.4.61.12 1.26.25 1.91.25h-.08M494.6 314.12c.13-.04.3-.13.43-.13 1.08 0 2.13.17 3.25.04.87-.04 1.83-.13 2.7.18h-.1M494.12 314.82c2.17-.22 4.38.09 6.55 0M493.73 315.47c2.3.26 4.6.04 6.85.22M493.39 316.16c1 .22 2-.09 3 .13.73.13 1.38.26 2.12.13.65-.17 1.26.04 1.86-.04M509.66 306.88h.21M509.44 307.14c.08.04.21-.13.26.04M509.18 307.49h.47M508.96 307.79h.6M508.57 308.18c.34.04.65.09 1 .09h-.1M508.23 308.7c.39-.13.82 0 1.21-.13h-.09M507.7 309.31h1.66-.09M507.44 309.7c.6 0 1.17-.09 1.73.04h-.04M507.1 310.26c.65-.09 1.34 0 2.04.09M506.7 310.87c.44-.04.79.22 1.22.3.35.1.65 0 .96-.04M506.58 311.35c.65.22 1.34.26 2 .3M506.19 311.87a4.4 4.4 0 0 1 1.65.26c.26.09.52.04.73.04h-.04M505.45 312.69c.7-.3 1.52-.09 2.25.13.26.09.52-.04.83-.04h-.09M505.36 313.21c.82-.26 1.69-.26 2.47.09.13.04.3 0 .43 0M504.84 313.82c1.08.22 2.21-.13 3.3.17M504.54 314.3c.86.35 1.82 0 2.77.26.3.09.61.09.91-.04M503.93 314.95c.39-.13.78-.22 1.17-.13 1.04.26 2 .17 2.95.3M503.45 315.64c.21-.04.43.13.6.09 1.35-.22 2.7 0 4-.09M503.1 316.16c1.05.39 2.13 0 3.26.3.44.13 1 .18 1.48 0M502.72 316.9c1.6.04 3.12-.04 4.99.17M511.83 307.7c.17-.04.3.13.47.09M511.6 308.18c.22-.04.4-.13.61-.09M511.44 308.61c.3.04.56-.04.86.09M511.22 309.22c.34 0 .73 0 1.08.09M510.92 309.83c.47-.13.9.04 1.39-.09M510.87 310.26c.43.17.86.04 1.34.09v-.09M510.6 310.95c.44-.04.83-.09 1.22.09.13.04.3 0 .48-.09M510.57 311.56c.56-.22 1.12.13 1.73 0M510.3 312.3c.66-.04 1.27.09 1.92 0M510.09 312.86c.26-.09.56-.26.82-.13.4.17.87.09 1.3.13M509.96 313.52c.73-.26 1.52.17 2.25-.22M509.87 314.21c.34-.09.7-.09 1.08.04.4.09.87.05 1.35-.04M509.66 314.86c.86-.17 1.78 0 2.69-.04l-.05.04M509.14 315.47c1.12-.09 2.3-.22 3.42-.22M509.27 316.16c1.26-.22 2.56-.13 3.86-.17M509.05 316.86c1.26.17 1.52-.09 2.77-.13.22 0 1.3-.22 1.52-.26.18-.04.57 0 .74 0M509.05 317.2c1.9-.17 3.86.17 5.81-.3M500.76 316.99h1.51M508.14 317.2c.17.09.39-.09.52.09M515.39 317.07c1.56-.17 3.16.3 4.73 0M514.6 316.55c1-.3 1.9-.09 2.86.09.09 0 .09.21.17.26.87.13 1.7 0 2.56-.05M509.05 316.47h-1M502.85 316.25c-.7.04-1.4.04-2.09.13M515.9 301.63h.31M516.04 302.06c.13.04.26 0 .39-.04M516.12 302.76c.04-.04.04-.13.08-.13.13-.04.3-.04.44-.04M516.3 303.19c.21-.13.47-.04.73-.04M517.12 303.58c-.26-.04-.48.04-.7.13M516.73 304.32a.96.96 0 0 1 .7-.13M517.73 304.71h-1M517.03 305.23c.34 0 .7.09.95-.13M518.25 305.84c-.4 0-.74 0-1.09.09M517.42 306.57c.39.04.78-.04 1.17-.22M518.68 306.75c-.35.17-.74.22-1.13.3M517.77 307.7c.47-.26 1.04-.04 1.52-.22M519.42 308.09c-.4 0-.78-.09-1.17.04-.13.05-.22.13-.4.13M518.16 309.22c.3-.13.6-.35.95-.3.04-.22.26 0 .35-.13.08-.05.26 0 .43 0M520.1 309.44c-.56-.04-1.16.09-1.73.17M518.55 310.35c.65-.26 1.3-.26 2-.35M518.6 311.17c.74-.17 1.52-.13 2.21-.43M521.33 311.26c-.83.13-1.65 0-2.43.4M519.07 312.39c.13.04.21.13.34.09.79-.3 1.57-.57 2.35-.48M521.98 312.56c-.78.43-1.7.26-2.56.3-.09 0-.18.1-.3.13M519.42 313.52c.95-.13 1.86-.17 2.82-.3M522.85 313.82c-.78.13-1.52-.04-2.26.13-.35.04-.65.17-1 .26M519.72 314.82c.13 0 .3.04.39-.04.95-.57 2.04-.4 3.08-.44M523.5 314.95c-.87 0-1.78-.22-2.65.09-.3.13-.6.3-.95.3M520.2 315.99c.47-.09.9-.3 1.34-.4 1-.12 2-.03 3-.03M524.54 316.08a3.2 3.2 0 0 0-1.7 0c-.86.22-1.64.43-2.51.48M520.8 316.99c.7-.09 1.35-.3 2.05-.48.56-.13 1.12-.04 1.69-.04M520.85 317.38c1.04-.17 2.08 0 3.12-.35.35-.13.74.09 1.13.05M525.1 316.68c1.73.13 3.47-.22 5.16.17M525.45 317.2c.21.04.39-.13.52-.13 1.43 0 2.86.04 4.3.13M529.75 313.52h.21M529.83 313.99c.17.09.34-.22.52 0M529.96 314.51h.9M530.22 315.25c.3-.35.73 0 1.04-.22M530.44 315.95c.39-.35.95.04 1.34-.3M530.53 316.47c.56-.17 1.17.04 1.73-.3M530.74 316.99c.86-.39 1.86.17 2.69-.43M530.83 317.42c1.08-.35 2.21 0 3.3-.04M534.82 317.38c1.9-.09 3.86-.13 5.77 0M534 316.68c1.69.17 4.25 0 6.38.17M524.63 303.62c.13 0 1.3-.22 1.39-.22M525.02 303.93c.34.04 1.17.04 1.47-.22M525.58 304.49c0-.04 1-.22 1.04-.22.13-.04.3 0 .47-.04M526.02 304.79c.17-.13 1.56-.04 1.82-.09M528.18 305.1c-.26 0-1.4.04-1.57.17M527.58 305.88c.17-.13 1-.26 1.3-.26M529.53 306.1c-.35 0-1.09.09-1.48.09M528.79 306.75a3.6 3.6 0 0 0 1.3-.3M530.79 307.09c-.4 0-.91.04-1.44.09M530 307.7c.48 0 1.18 0 1.53-.13M532.05 307.87c-.3.17-.91.22-1.3.3M531.39 308.79c.39-.26 1.08-.09 1.56-.26M533.48 309.09c-.48 0-.96-.04-1.3.04-.13.05-.18.13-.4.13M535.04 310.26c-.7-.04-1.26.09-1.87.17M533.78 311.09c.6-.26 1.34-.22 2.04-.35M535.3 312.91c.13.04.78-.09.9-.13 1.05-.13 1.22-.35 2.18-.26M538.95 312.95a27 27 0 0 1-2.7.35c-.12 0-.43.08-.51.13M536.3 313.82c.95-.17 2.34-.13 3.3-.26M540.64 314.08c-.78.13-1.7 0-2.43.17-.35.05-1 .1-1.35.18M537.77 315.03c.13 0 .3 0 .39-.04.78-.52 2.04-.44 3.16-.44M542.03 315.08c-1.09 0-1.52.04-2.35.13-.3.04-.73.22-1.12.22M539.47 315.99c1-.17 2.9-.4 1.78-.3 1.04-.1 1.21-.1 2.34-.1M543.89 316.03a5.47 5.47 0 0 0-1.91.04c-.44.13-.3.26-1.78.3M540.8 316.68c.7-.09.79-.04 1.44-.22.52-.13 1.21-.08 1.87-.08M541.16 316.94c1.08-.13 1.21-.09 2.34-.04.3 0 .56 0 .96-.05M524.28 303.19c.26-.13.43-.22.9-.17-.12-.18.22 0 .31-.09 0-.09.26-.04.44-.04M523.76 302.67c.26-.13.52-.13.95-.09-.13-.21.26 0 .3-.13.05-.04.3 0 .48 0M532.39 309.96c.3-.13.26-.22.7-.13-.14-.22.47 0 .51-.13.05-.09.52-.04.7-.04M534.22 311.69c.7-.17 1.56-.17 2.17-.48M537.43 312c-.83.13-2.04.04-2.7.39M524.84 301.93c-.78-.04-.91.22-1.48.22M533.39 304.1c.13 0 1-.17 1.12-.17M533.74 304.45c.52-.13.9 0 1.21-.22M534.17 304.88c0-.04.82-.13.86-.13.13-.04.3-.04.44-.04M534.6 305.27c.18-.13 1.31-.09 1.57-.13M536.47 305.53c-.26-.04-1.3.13-1.48.22M535.56 306.23c.17-.13 1.3-.26 1.56-.22M537.73 306.44c-.35 0-1.3.09-1.65.13M536.64 307.01c.34 0 1.43-.09 1.6-.26M538.86 307.35c-.35 0-.96.04-1.44.09M537.86 307.92c.43 0 1.39 0 1.69-.17M540.03 308.05c-.26.17-1.09.26-1.44.35M539.38 308.87c.34-.22 1.04-.09 1.47-.22M541.33 309.18c-.4 0-.87-.04-1.17.04-.13.05-.18.13-.35.09M542.76 310.26c-.61-.04-1.13.09-1.7.17M541.63 311.04c.56-.26 1.26-.26 1.9-.35M543.15 312.73c.17.04.6-.13.7-.13.99-.13 1.12-.35 2.03-.3M546.36 312.73a14.2 14.2 0 0 1-2.43.3c-.13 0-.44.1-.52.13M543.93 313.52c.87-.13 2.17-.13 3.03-.22M547.93 313.78c-.7.09-1.52 0-2.22.13-.3.09-.95.09-1.25.17M545.32 314.64c.13 0 .26 0 .34-.04.7-.48 1.87-.4 2.96-.4M549.23 314.69c-1 0-1.44.04-2.17.13-.48.04-1.04.22-1.17.22M546.62 315.51c.9-.17 2.9-.35 1.86-.26.96-.09 1.13-.09 2.17-.09M550.92 315.6a4.64 4.64 0 0 0-1.74 0c-.35.09-.48.26-1.9.3M547.8 316.21c.65-.09 1.04-.09 1.6-.22.48-.13 1.13-.08 1.74-.08M548.45 316.55c.9-.13 1.04-.22 2.12-.17.3 0 .52-.05.87-.09M532.87 303.75c.26-.13.17-.22.56-.17.3-.09.52.04.56-.09 0-.04.26-.04.4-.04M532.26 303.41c.26-.13.3-.26.7-.22.38-.04.56 0 .6-.13.04-.04.26 0 .43 0M540.46 309.96c.26-.13.13-.17.52-.13-.09-.17.43 0 .48-.09.04-.08.47-.04.65-.04M542.03 311.56c.65-.17 1.43-.17 2-.4M544.98 311.87c-.74.13-1.7-.04-2.26.26M533.43 302.58c-.74-.04-1.35.3-1.78.6M542.33 306.4c.08 0 1.13-.17 1.17-.17M542.68 306.66c.39-.09.95-.04 1.17-.22M543.07 306.96l.86-.13c.1-.04.22 0 .35 0M543.4 307.27c.14-.09 1.22-.09 1.4-.13M545.06 307.44a3.35 3.35 0 0 0-1.18.17M544.5 307.96c.13-.09.82-.17 1.04-.17M545.97 308.14c-.22 0-1 .09-1.26.09M545.19 308.57c.26 0 1.04-.09 1.21-.22M546.88 308.83c-.3 0-.78.04-1.13.04M546.1 309.26c.34 0 1.04 0 1.3-.13M547.8 309.39c-.22.13-.87.17-1.13.22M547.06 310c.26-.17 1.04-.04 1.34-.13M548.79 310.22c-.35 0-.7-.04-.96.04-.08.05-.17.05-.3.05M549.88 311.09c-.48-.04-1.09.13-1.48.17M548.88 311.61c.39-.17 1.08-.13 1.56-.22M549.96 312.91c.08.04.65-.04.74-.04.73-.09.86-.26 1.56-.22M552.66 312.99c-.87.13-1.22.17-1.91.22l-.48.04M550.62 313.56c.7-.13 1.82-.09 2.51-.17M553.83 313.78c-.52.09-1.17 0-1.7.09-.43.08-1.04.13-1.08.13M551.6 314.47c.1 0 .7-.17.75-.17.86-.1 1.17-.18 2-.22M554.82 314.47c-.78 0-1.09.04-1.65.09-.4.04-1.04.26-1.13.26M552.7 315.16c.56-.13 2.25-.3 1.56-.26l1.65-.09M556.13 315.16c-.48-.04-.96-.09-1.35 0-.22.09-.47.17-1.56.26M553.65 315.64c.52-.09.86-.04 1.3-.17.39-.13.91-.05 1.34-.1M554.09 315.9c.7-.09.95-.17 1.78-.13.21 0 .39 0 .69-.04M542.1 306.1c.22-.09.31-.22.61-.17.22-.05.4.04.4-.05.04-.04.21-.04.34-.04M541.76 305.79c.21-.09.26-.17.56-.17.3 0 .43 0 .48-.05 0-.08.22-.04.3-.04M547.93 310.82c.21-.09.26-.13.6-.09-.13-.13.3 0 .35-.08 0-.05.35 0 .48 0M549.3 312.08c.48-.13 1.1-.13 1.53-.35M551.57 312.3c-.57.09-1.4-.04-1.87.22M542.68 305.18c-.57-.04-.7.17-1.04.43M550.44 306.75l1.08-.13M550.75 307.05c.34-.09.9-.09 1.08-.22M551.09 307.31l.82-.13c.09-.04.22 0 .3 0M551.48 307.74a5.5 5.5 0 0 1 1.21-.26M552.96 307.74a3.56 3.56 0 0 0-1.22.22M552.22 308.27c.08-.09.95-.22 1.17-.17M553.83 308.4c-.26 0-.96.04-1.3.13M552.96 308.79c.26 0 1.08-.09 1.21-.22M554.65 309c-.26 0-.91.09-1.26.13M553.9 309.44c.31 0 1 0 1.22-.13M555.48 309.52c-.22.13-.96.13-1.22.22M554.82 310.13c.21-.17.9-.09 1.21-.17M556.39 310.31c-.3 0-.61 0-.87.04-.04.05-.26.05-.35.05M557.39 311.09c-.44-.04-.96.13-1.35.17M556.39 311.65c.39-.17 1.08-.17 1.56-.26M557.47 312.82c.08 0 .6-.09.7-.09.69-.08.81-.21 1.42-.17M559.94 312.86c-.78.13-1.13.17-1.74.22-.09 0-.39 0-.43.04M558.04 313.47a47.1 47.1 0 0 1 2.34-.22M561.07 313.6c-.52.04-1.13 0-1.6.09-.4.08-.96.08-1 .13M558.99 314.21c.08 0 .65-.13.7-.13.77-.09 1.08-.17 1.86-.22M561.98 314.21c-.74.04-1 .04-1.52.09-.4.04-.96.26-1.09.26M559.99 314.86c.56-.09 2.12-.3 1.47-.22.65-.08.78-.08 1.52-.08M563.2 314.86c-.48-.04-.96-.09-1.26 0-.22.09-.44.17-1.43.22M560.9 315.29c.43-.04.78-.04 1.21-.17.35-.09.78-.05 1.22-.05M561.25 315.55c.7-.09.9-.13 1.69-.13.22 0 .35 0 .6-.04M550.27 306.49c.17-.09.21-.17.52-.13.22-.04.35 0 .39-.04 0-.05.17-.05.3-.05M549.92 306.23c.21-.09.21-.17.52-.13.26-.04.39 0 .43-.09 0-.04.17-.04.3-.04M555.6 310.87c.18-.09.27-.09.53-.09-.09-.13.3 0 .34-.04.05-.04.35-.04.44-.04M556.82 312c.43-.09 1.08-.09 1.47-.26M558.99 312.21c-.57.09-1.44-.04-1.87.17M550.79 305.66c-.52-.04-.7.17-1 .39'/%3E %3C/g%3E %3Cg fill='%23fc0'%3E %3Cpath d='M491.53 373.25l.75 5.56c-1.47-.48-2.82.38-3.47 1.6-1.04 2.08-.12 3.65 1.88 4.65l2.69 1.38 5-9.72-2-1-2 3.9h-.04l-.43-5.15-2.38-1.22zm.75 7.34c.32.03.67.17 1.03.35l.25.12-1.4 2.66-.25-.13c-.91-.47-1.52-1.04-1-2.12.35-.68.83-.92 1.37-.88z'/%3E %3Cpath fill-rule='evenodd' d='M482.28 372.87l2.9 1.95 1.65-2.43-3.03-2.04 1.04-1.56 4.86 3.3-6.08 9.03-4.86-3.26 1.04-1.52 3.04 2 1.35-2-2.95-1.95z'/%3E %3Cpath d='M480.84 365.62l-2.65 3.07-.85-.69c-1.73-1.52-3.48-1.45-5 .28-1.6 1.91-1.01 3.58.82 5.1l2.28 1.96 7.06-8.28-1.66-1.44zm-5.53 3.54c.38.03.8.29 1.25.68l.35.25-1.97 2.29-.32-.26c-.82-.69-1.29-1.34-.46-2.34.41-.48.77-.66 1.15-.62z'/%3E %3Cpath fill-rule='evenodd' d='M467.44 368.27l-1.48-1.65 4.51-4.12c1-.87 2.35-2.26 1.09-3.64-1.26-1.4-2.78-.22-3.78.69l-4.5 4.08-1.48-1.6 4.81-4.39c2-1.78 4.25-2.26 6.3-.04 2.03 2.25 1.34 4.5-.66 6.29l-4.81 4.38z'/%3E %3Cpath d='M463.44 347.66c-.62-.05-1.27.1-1.94.56-.95.69-1.69 1.93-1.12 3.19-.79-.35-1.67-.11-2.32.37-1.78 1.22-1.74 2.73-.53 4.47l1.56 2.25 9-6.16-1.97-2.84c-.73-1.06-1.65-1.76-2.68-1.84zm-.03 2.34c.65-.06 1.13.47 1.59 1.12l.28.35-2.31 1.56-.19-.25c-.56-.82-1.15-1.79-.06-2.53.26-.17.47-.23.69-.25zm-3.19 3.16c.4-.01.74.26 1.06.75l.16.21-2.13 1.47-.15-.21c-.48-.7-.62-1.35.25-1.91.31-.23.57-.31.81-.31z'/%3E %3Cpath fill-rule='evenodd' d='M458.59 340.33l1.6-.87 2.56 4.68-9.59 5.21-1.08-1.95 7.98-4.29zM458.41 335.39l.87 2.03-9.98 4.39-.87-2.04zM447.22 327.83c-.52.78-.61 1.82-.35 2.73.7 2 2.82 2.56 4.64 2 1.74-.56 3.08-2.34 2.43-4.3a3.46 3.46 0 0 0-1.86-2.03l2.38-.79c.65.7 1.18 1.4 1.44 2.26 1 3.04-.78 6.08-3.65 7.03-2.95.95-6.25-.35-7.29-3.51a5.88 5.88 0 0 1-.17-2.6l2.43-.79z'/%3E %3Cpath d='M452.44 313.25l-10.25 6.22.31 1.69 11.78 2.37-.44-2.28-2.4-.53-.72-3.88 2.16-1.28-.44-2.31zm-3.32 4.53l.47 2.63-4.12-.5v-.07l3.65-2.06zM446.69 292.88c-2.82.01-5.04 1.97-5.28 5.06l-.25 3.12 10.84.88.25-3.13a5.31 5.31 0 0 0-5-5.9c-.19-.02-.37-.04-.56-.03zm-.41 2.5c.24-.02.49-.03.75 0 1.95.13 3.22 1.21 3 3.68v.32l-6.53-.54.03-.31c.15-2.01 1.09-3.04 2.75-3.15z'/%3E %3Cpath fill-rule='evenodd' d='M449.6 284.31l-.69 3.43 2.9.61.75-3.56 1.77.35-1.17 5.77-10.67-2.26 1.17-5.72 1.82.39-.73 3.55 2.34.48.74-3.42zM454.16 270.82l-1.3 3.3 2.73 1.04 1.35-3.38 1.73.65-2.12 5.46-10.2-3.94 2.17-5.47 1.74.65-1.35 3.43 2.21.86 1.3-3.3zM460.71 264.18l1.65.83-2.43 4.77-9.72-4.99 1-1.95 8.07 4.12zM462.32 249.87c-.7.04-1.3.26-1.74.82-.43.61-.43 1.44.13 1.87 1.48 1.08 3.56-3 6.5-.78 1.74 1.3 2.13 3.34.75 5.2-.91 1.26-2.3 1.65-3.78 1.52l-.22-1.95c.87.26 1.91.09 2.48-.7.56-.69.3-1.6-.4-2.08-.9-.69-1.77 0-2.6.52-1.3.83-2.51 1.26-3.86.26a3.23 3.23 0 0 1-.7-4.6 4.81 4.81 0 0 1 2.83-1.77l.6 1.69z'/%3E %3Cpath d='M467.19 240.31l-1.22 1.22 4.97 10.97 1.62-1.69-1-2.25 2.72-2.81 2.28.94 1.63-1.69-11-4.69zm1.72 3.1l3.47 1.59-1.69 1.78-1.81-3.34.03-.03z'/%3E %3Cpath fill-rule='evenodd' d='M482.84 238.93l1.17 1.43-4.16 3.39-6.86-8.5 1.74-1.4 5.68 7.03zM485.49 226.3l2.04-1.25 2.25 11.8-1.08.7-9.68-7.12 2-1.3 6.25 4.77.04-.04z'/%3E %3Cpath d='M495.25 221l-1.56.75.56 12.03 2.13-.97-.1-2.53 3.56-1.59 1.75 1.75 2.16-.97-8.5-8.47zm.44 3.56l2.69 2.78-2.26 1-.43-3.72v-.06zM507.41 217.22c-.56 0-1.16.1-1.75.28l-3 .88 3.06 10.43 2.97-.84a5.32 5.32 0 0 0 3.78-6.78c-.71-2.44-2.65-3.99-5.06-3.97zm-.07 2.28c1.36.05 2.27.84 2.72 2.41.57 1.86-.02 3.4-2.4 4.09l-.32.12-1.81-6.28.31-.12a5.04 5.04 0 0 1 1.5-.22zM520.5 214.06l-.62.06a5.55 5.55 0 0 0-4.76 6.41 5.55 5.55 0 0 0 6.29 4.94 5.58 5.58 0 0 0 4.81-6.41 5.61 5.61 0 0 0-5.72-5zm-.25 2.44c1.73-.22 3.19 1.21 3.41 2.81.17 1.48-.87 3.52-2.57 3.78-1.69.22-3.25-1.52-3.47-3-.17-1.6.85-3.37 2.63-3.59zM529.53 213.56l-.12 10.91h2.21l.04-4.38h.03l2.69 4.44 2.68.03-3.15-4.62c1.52-.22 2.34-1.61 2.34-3 .04-2.35-1.51-3.3-3.72-3.35l-3-.03zm2.25 1.94h.31c1.04 0 1.86.25 1.82 1.47 0 1.21-.78 1.53-1.91 1.53h-.25l.03-3z'/%3E %3Cpath fill-rule='evenodd' d='M555.08 222.92l-3.43-.87-.7 2.87 3.56.9-.47 1.79-5.69-1.43 2.66-10.6 5.68 1.44-.44 1.82-3.56-.9-.55 2.33 3.38.83zM565.2 227.87l2.72-6.81 2.04.82-4.11 10.33-1.48-.61-2.73-9.29h-.05l-2.73 6.86-2.04-.78 4.17-10.42 1.46.57 2.7 9.33zM578.16 236.98l-1 1.56-4.51-2.82 5.82-9.24 1.86 1.17-4.82 7.68z'/%3E %3Cpath d='M588.72 233.25l-10.5 5.91 1.81 1.46 2.16-1.21 3.03 2.53-.75 2.34 1.84 1.47 3.75-11.41-1.34-1.09zm-1.63 3.16l-1.25 3.62-1.9-1.53 3.15-2.09zM605.06 250.31l-11.62 2.97 1.34 1.88 2.44-.57 2.28 3.16-1.34 2.09 1.4 1.91 6.53-10.06-1.03-1.38zm-2.34 2.63l-2.16 3.18-1.44-2 3.6-1.18z'/%3E %3Cpath fill-rule='evenodd' d='M605.8 273.82l-1-2 5.65-3.86-7.34.78-.34-.65 5.03-5.34v-.04l-6.51 2.17-1-2 10.85-3.34.74 1.39-5.16 5.73 7.59-.83.73 1.43zM612.88 279.93l-1.14-3.34-2.77.96 1.17 3.47-1.78.6-1.86-5.6 10.33-3.46 1.9 5.55-1.78.6-1.17-3.46-2.25.78 1.13 3.3z'/%3E %3Cpath d='M619.81 282.16l-10.62 2.25.43 2.15 4.29-.9h.06l-3.75 3.65.59 2.6 3.81-4.07c.57 1.44 2.07 1.9 3.41 1.6 2.3-.48 2.92-2.16 2.44-4.38l-.66-2.9zm-1.34 2.62l.06.28c.22 1.04.15 1.91-1.06 2.13-1.17.26-1.63-.45-1.85-1.53l-.06-.25 2.91-.63z'/%3E %3Cpath fill-rule='evenodd' d='M611.22 296.3l-.25-2.18 10.84-1.26.26 2.17zM619.69 306.83a3.26 3.26 0 0 0 1.12-2.52c-.04-2.12-1.95-3.3-3.81-3.25-1.83 0-3.65 1.3-3.6 3.38 0 .91.47 1.87 1.17 2.48l-2.52.04c-.39-.82-.7-1.65-.7-2.56a5.58 5.58 0 0 1 5.56-5.64c3.12-.04 5.86 2.17 5.94 5.51 0 .87-.21 1.78-.6 2.52l-2.56.04z'/%3E %3Cpath d='M611.66 308.88l-.25 2.31 2.15 1.19-.47 3.9-2.43.56-.25 2.35 11.62-2.85.22-1.75-10.59-5.71zm3.65 4.46l3.41 1.57v.03l-3.72.84.31-2.44z'/%3E %3Cpath fill-rule='evenodd' d='M612.05 340.16a3.46 3.46 0 0 0 2-1.91c.77-2-.53-3.82-2.26-4.51-1.7-.65-3.86-.17-4.65 1.73-.34.92-.26 1.96.18 2.78l-2.39-.9c-.04-.92 0-1.79.35-2.66a5.59 5.59 0 0 1 7.29-3.08c2.9 1.13 4.6 4.26 3.38 7.34a5.77 5.77 0 0 1-1.52 2.12l-2.38-.91zM604.85 347.1l1.65-3.08-2.6-1.44-1.74 3.26-1.6-.91 2.77-5.16 9.59 5.2-2.78 5.16-1.64-.91 1.77-3.2-2.13-1.13-1.68 3.08zM597.51 355.7l5.95 4.28-1.3 1.82-8.99-6.58.92-1.26 9.67-.36h.04l-5.99-4.38 1.3-1.78 9.03 6.6-.9 1.3-9.68.3zM596.82 364.88l1.6-1.64 1.3 1.26-4.68 4.9-1.3-1.26 1.56-1.65-6.55-6.29 1.52-1.6z'/%3E %3Cpath d='M585.53 363.41l-1.72 1.37 2.81 3.41v.03l-4.93-1.6-2.07 1.69 5.41 1.47c-1 1.17-.75 2.73.16 3.81 1.47 1.78 3.31 1.53 5 .1l2.28-1.91-6.94-8.37zm2.09 6.12l1.91 2.31-.22.16c-.82.69-1.56 1.01-2.34.09-.78-.95-.37-1.68.5-2.37l.15-.19zM578.72 369.06l-2 1.25.44 2.44-3.35 2.06-1.93-1.47-2 1.25 9.59 7.22 1.44-.9-2.19-11.85zm-1.25 5.72l.97 3.63h-.06l-3-2.32 2.09-1.31z'/%3E %3Cpath fill-rule='evenodd' d='M563.9 379.38l-.8-1.65 4.82-2.3 4.69 9.9-2 .9-3.85-8.15z'/%3E %3C/g%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns:svg='http://www.w3.org/2000/svg' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 675 450'%3E %3Cdefs%3E %3Cmarker markerWidth='691.235' markerHeight='1592.9' orient='auto'%3E %3Cg transform='translate(139.04186,-931.37552)'%3E %3Cg transform='matrix(0.3358457,0,0,0.3358462,22.073663,254.82087)'%3E %3Cpath d='m-1508.834 4385.729 0 0 0 0 0 0' fill='%23000'/%3E %3Cg transform='matrix(2.9999964,0,0,2.9994449,-746.32978,-2781.9855)'%3E %3Cpath d='m377.175 843.108 0.091-3.458c0 0-1.857-2.958 0.298-6.136 0 0-4.578-2.422-3.512-6.215 0 0-4.139-1.059-3.835-5.613 0 0-4.468-0.31-4.931-4.114 0 0-4.468 0.736-6.434-2.971 0 0-4.359 0.852-5.588-2.204 0 0-4.237 1.468-6.751-2.124 0 0-4.474 1.808-6.349-1.583-1.851 3.379-6.325 1.583-6.325 1.583-2.484 3.579-6.751 2.094-6.751 2.094-1.187 3.068-5.533 2.198-5.533 2.198-1.96 3.708-6.422 2.971-6.422 2.971-0.438 3.793-4.9 4.103-4.9 4.103 0.353 4.566-3.78 5.601-3.78 5.601 1.09 3.792-3.482 6.208-3.482 6.208 2.21 3.196 0.371 6.131 0.371 6.131l-0.103 3.189 73.949 0.342' fill='%23ff0'/%3E %3Cpath d='m377.175 843.108 0.091-3.458c0 0-1.857-2.958 0.298-6.136 0 0-4.578-2.422-3.512-6.215 0 0-4.139-1.059-3.835-5.613 0 0-4.468-0.31-4.931-4.114 0 0-4.468 0.736-6.434-2.971 0 0-4.359 0.852-5.588-2.204 0 0-4.237 1.468-6.751-2.124 0 0-4.474 1.808-6.349-1.583-1.851 3.379-6.325 1.583-6.325 1.583-2.484 3.579-6.751 2.094-6.751 2.094-1.187 3.068-5.533 2.198-5.533 2.198-1.96 3.708-6.422 2.971-6.422 2.971-0.438 3.793-4.9 4.103-4.9 4.103 0.353 4.566-3.78 5.601-3.78 5.601 1.09 3.792-3.482 6.208-3.482 6.208 2.21 3.196 0.371 6.131 0.371 6.131l-0.103 3.189 73.949 0.342-0.012 0z' style='fill:%23f9d90f;stroke-width:0.27124387;stroke:%23000'/%3E %3Cpath d='m375.446 838.791c-11.615-1.163-24.989-3.92-35.313 1.894-6.921-4.079-16.558-3.83-24.763-3.031-4.456 0.797-9.697 0.797-14.354 1.558l-0.73 0.103c-8.449 0.561-16.113-1.936-23.455-5.217 2.331 13.234 4.919 26.797 6.191 40.652 2.77 20.52-9.709 37.748-4.59 58.019 3.056 9.727 13.751 15.382 23.54 16.503 9.478 0.559 19.285 2.112 28.057 4.017 1.668 0.347 3.646 1.121 4.797 1.619 2.417 1.011 4.188 2.496 5.74 4.085 5.296-5.516 13.057-7.05 20.715-7.859 13.8-1.613 30.814-0.736 39.263-13.239l0-0.707c4.59-6.915 3.981-17.464 1.991-25.299-0.134-2.733-0.864-5.144-1.26-7.749-8.431-22.268-1.211-47.311 2.417-69.756-4.432 2.423-9.375 3.567-14.305 4.779-3.932 0.524-8.315 0.286-12.296 0.072l-1.65-0.444M392.795 902.697 392.795 902.697' fill='%23dc171d'/%3E %3Cpath d='m392.795 902.697c-0.055 1.466 0.737 2.618 1.023 3.974 1.613 9.734 3.172 22.627-6.848 28.666-11.085 7.049-25.622 4.03-38.448 7.761-2.563 0.712-6.093 3.069-7.895 4.736-1.157-0.761-2.319-1.93-3.811-2.617-10.555-5.613-24.276-3.732-36.189-6.764-5.984-1.893-12.223-6.555-13.739-12.68-3.896-16.07 5.436-29.767 4.334-45.709-0.712-12.175-2.758-23.862-5.57-35.276 9.314 4.34 20.094 5.064 30.565 2.983 7.755-1.084 16.783-1.108 24.051 2.173 4.005-1.723 8.693-2.496 13.009-2.971 8.206 0.798 17.026 2.283 25.476 2.222 5.643-0.293 10.769-1.924 15.675-4.097-2.91 18.865-8.498 38.625-1.637 57.599' fill='%2362afe1'/%3E %3Cpath d='m376.042 906.458-0.091-17.739 2.185 0-27.113-17.513-0.049-9.101 2.618 0-13.557-9.709-13.49 9.703 2.611 0 0.049 9.094-26.967 17.49 2.155 0.012 0.091 17.727 71.551 0.049' fill='%23fff'/%3E %3Cpath d='m376.042 906.458-0.091-17.739 2.185 0-27.113-17.513-0.049-9.101 2.618 0-13.557-9.709-13.49 9.703 2.611 0 0.049 9.094-26.967 17.49 2.155 0.012 0.091 17.727 71.551 0.049 0.006-0.013z' style='fill:none;stroke-width:1.16422367;stroke:%23000'/%3E %3Cpath d='m384.376 929.761 0.006 5.551-87.347-0.097-0.036-5.527 87.384 0.074' fill='%23fff'/%3E %3Cpath d='m384.376 929.761 0.006 5.551-87.347-0.097-0.036-5.527 87.384 0.074-0.006 0z' style='fill:none;stroke-width:1.16422367;stroke:%23000'/%3E %3Cpath d='m302.836 929.426-0.073-18.786 3.537-0.007-0.195 19.005 0.213-18.852-5.095-0.146 0-4.03 78.064 0.086 0.037 3.993-4.815 0 0.091 19.023-0.17-19.023 3.585 0 0.079 18.809' fill='%23fff'/%3E %3Cpath d='m302.836 929.426-0.073-18.786 3.537-0.007-0.195 19.005 0.213-18.852-5.095-0.146 0-4.03 78.064 0.086 0.037 3.993-4.815 0 0.091 19.023-0.17-19.023 3.585 0 0.079 18.809M319.619 924.8l-0.055-13.1-10.482 0 0.061 13.087 10.476 0.013M319.619 924.8l-0.055-13.1-10.482 0 0.061 13.087 10.476 0.013M319.619 924.8l-0.055-13.1-10.482 0 0.061 13.087 10.476 0.013M319.619 924.8l-0.055-13.1-10.482 0 0.061 13.087 10.476 0.013M319.619 924.8l-0.055-13.1-10.482 0 0.061 13.087 10.476 0.013M311.937 914.432l0.03 7.609 4.797 0-0.024-7.609-4.803 0M370.862 924.836l-0.061-13.087-10.446-0.012 0.049 13.099 10.458 0M363.18 914.481l0.055 7.585 4.791 0-0.043-7.585-4.803 0M370.783 903.506l-0.061-13.101-10.458 0 0.037 13.101 10.489 0-0.006 0zM363.101 893.163l0.03 7.597 4.791 0-0.006-7.597-4.815 0M319.534 903.458l-0.073-13.076-10.464-0.013 0.049 13.082 10.489 0 0 0.007zM311.851 893.115l0.024 7.585 4.803 0.012-0.036-7.597-4.791 0M338.502 903.481l-0.049-13.076-10.47-0.012 0.043 13.087 10.476 0M330.826 893.127l0.024 7.585 4.797 0.024-0.03-7.609-4.791 0M353.124 903.506l-0.073-13.101-10.464-0.012 0.049 13.087 10.489 0.025M345.435 893.14l0.037 7.609 4.797 0-0.024-7.609-4.809 0' style='fill:none;stroke-width:1.16422367;stroke:%23000'/%3E %3Cpath d='m355.717 899.488 0.116 30.199-30.333-0.049-0.11-30.174 30.321 0.024' fill='%23fff'/%3E %3Cpath d='m355.717 899.488 0.116 30.199-30.333-0.049-0.11-30.174 30.321 0.024 0.006 0zM325.207 908.108l30.54 0.024M325.207 908.108l30.54 0.024M325.207 908.108l30.54 0.024M325.207 908.108l30.54 0.024M325.207 908.108l30.54 0.024M329.018 929.675l-0.103-21.342M352.143 929.687l-0.103-21.329M366.79 886.626l-17.081-12.474-19.193-0.024-16.947 12.449 53.222 0.049M331.994 863.799l0.03 7.609 16.144 0.012-0.03-7.609-16.144-0.012M331.994 863.799l0.03 7.609 16.144 0.012-0.03-7.609-16.144-0.012' style='fill:none;stroke-width:1.16422367;stroke:%23000'/%3E %3Cpath d='m331.994 863.799 0.03 7.609 16.144 0.012-0.03-7.609-16.144-0.012' style='fill:none;stroke-width:1.16422367;stroke:%23000'/%3E %3Cpath d='m336.371 865.686 0.024 3.792 7.414 0-0.024-3.792-7.414 0M340.036 855.142l8.979 6.348-17.891-0.024 8.912-6.325M340.036 855.142l8.979 6.348-17.891-0.024 8.912-6.325M340.036 855.142l8.979 6.348-17.891-0.024 8.912-6.325M340.036 855.142l8.979 6.348-17.891-0.024 8.912-6.325M340.036 855.142l8.979 6.348-17.891-0.024 8.912-6.325' style='fill:none;stroke-width:1.16422367;stroke:%23000'/%3E %3Cpath d='m376.341 850.838c2.551-0.061 3.208 10.507 3.214 15.742 2.191 0.615 7.049 3.671 9.198 6.434l-24.642-0.036c2.118-2.727 6.94-5.795 9.113-6.409 0-5.242 0.536-15.803 3.117-15.742' fill='%23fff'/%3E %3Cpath d='m376.341 850.838c2.551-0.061 3.208 10.507 3.214 15.742 2.191 0.615 7.049 3.671 9.198 6.434l-24.642-0.036c2.118-2.727 6.94-5.795 9.113-6.409 0-5.242 0.536-15.803 3.117-15.742M326.808 900.335l2.21 0-0.645 1.186M326.808 900.335l2.21 0-0.645 1.186M326.808 900.335l2.21 0-0.645 1.186M326.808 900.335l2.21 0-0.645 1.186M326.808 900.335l2.21 0-0.645 1.186c0 0 1.065 1.37 0.018 2.94l0.578 1.09-2.131 0 0.578-1.035c0 0-1.09-1.82 0.049-2.995l-0.657-1.186M331.313 900.335l2.21 0-0.639 1.186c0 0 1.065 1.334 0.006 2.94l0.572 1.09-2.124 0 0.572-1.035c0 0-1.065-1.82 0.055-2.995l-0.651-1.186M336.225 900.335l2.204 0-0.657 1.186c0 0 1.077 1.37 0.018 2.94l0.578 1.114-2.112-0.024 0.566-1.035c0 0-1.077-1.808 0.043-2.995l-0.645-1.186 0.006 0zM341.771 900.346l2.222 0-0.651 1.199c0 0 1.065 1.346 0.006 2.922l0.597 1.108-2.143 0 0.572-1.035c0 0-1.065-1.832 0.073-2.995l-0.67-1.199-0.006 0zM346.701 900.346l2.204 0-0.651 1.199c0 0 1.071 1.346 0.012 2.916l0.584 1.114-2.124 0 0.554-1.035c0 0-1.071-1.82 0.085-2.995l-0.664-1.199M351.602 900.359l2.204-0.012-0.651 1.199c0 0 1.09 1.346 0.03 2.922l0.554 1.108-2.131 0 0.572-1.035c0 0-1.065-1.82 0.073-2.995l-0.651-1.187' style='fill:none;stroke-width:1.16422367;stroke:%23000'/%3E %3Cpath d='m340.699 968.397c11.359 0.037 25.329-2.283 31.873-5.667l14.372-1.273 0.286 17.538c-12.175 6.714-40.286 8.156-46.471 8.108-6.191 0.049-34.649-1.418-46.879-8.156l0.158-17.55 14.403 1.297c6.544 3.367 20.94 5.704 32.287 5.704l-0.03 0' fill='%23f9d90f'/%3E %3Cpath d='m340.699 968.397c11.359 0.037 25.329-2.283 31.873-5.667l14.372-1.273 0.286 17.538c-12.175 6.714-40.286 8.156-46.471 8.108-6.191 0.049-34.649-1.418-46.879-8.156l0.158-17.55 14.403 1.297c6.544 3.367 20.94 5.704 32.287 5.704l-0.03 0' style='fill:none;stroke-width:0.27124387;stroke:%23000'/%3E %3Cpath d='m256.883 893.589 12.662 4.03-3.829 20.503-11.986 1.862c0 0-2.021-10.781 3.153-26.407' fill='%23f9d90f'/%3E %3Cpath d='m256.883 893.589 12.662 4.03-3.829 20.503-11.986 1.862c0 0-2.021-10.781 3.153-26.407l0 0.012z' style='fill:none;stroke-width:0.27124387;stroke:%23000'/%3E %3Cpath d='m265.709 917.896-11.98 2.088 7.579-10.781 4.401 8.693' fill='%237e7e7e'/%3E %3Cpath d='m265.709 917.896-11.98 2.088 7.579-10.781 4.401 8.693' style='fill:%23f9b60f;stroke-width:0.27124387;stroke:%23000'/%3E %3Cpath d='m249.31 908.358 12.205 0.882c0.274 10.343 1.528 49.813 48.656 51.956l-1.467 14.36c-57.367 0.596-61.726-48.413-59.394-67.198' fill='%23f9d90f'/%3E %3Cpath d='m249.31 908.358 12.205 0.882c0.274 10.343 1.528 49.813 48.656 51.956l-1.467 14.36c-57.367 0.596-61.726-48.413-59.394-67.198zM294.107 978.496l14.384-3.141M294.107 978.496l14.384-3.141M294.107 978.496l14.384-3.141M294.107 978.496l14.384-3.141M294.107 978.496l14.384-3.141' style='fill:none;stroke-width:0.27124387;stroke:%23000'/%3E %3Cpath d='m423.518 893.735-12.613 3.993 3.999 20.472 12.01 1.929c0 0 1.93-10.774-3.397-26.406' fill='%23ff0'/%3E %3Cpath d='m423.518 893.735-12.613 3.993 3.999 20.472 12.01 1.929c0 0 1.93-10.774-3.397-26.406l0 0.012z' style='fill:%23f9d90f;stroke-width:0.27124387;stroke:%23000'/%3E %3Cpath d='m414.904 917.987 12.01 2.155-7.682-10.786-4.328 8.631' fill='%237e7e7e'/%3E %3Cpath d='m414.904 917.987 12.01 2.155-7.682-10.786-4.328 8.631' style='fill:%23f9b60f;stroke-width:0.27124387;stroke:%23000'/%3E %3Cpath d='m431.23 908.522-12.223 0.835c-0.177 10.33-1.077 49.818-48.206 51.912l1.601 14.348c57.355 0.663 61.3-48.322 58.828-67.101' fill='%23f9d90f'/%3E %3Cpath d='m431.23 908.522-12.223 0.835c-0.177 10.33-1.077 49.818-48.206 51.912l1.601 14.348c57.355 0.663 61.3-48.322 58.828-67.101l0 0.005zM387.036 978.575 372.615 975.416' style='fill:none;stroke-width:0.27124387;stroke:%23000'/%3E %3Cpath d='m333.072 977.041c-0.323 0.207-0.761 0.262-1.266 0.237l-2.277-0.116 0.195-2.842 2.258 0.121c0.444 0.03 0.797 0.116 1.017 0.25 0.457 0.237 0.657 0.676 0.615 1.284-0.03 0.524-0.213 0.865-0.548 1.065m-3.823 4.475 0.225-3.464 2.654 0.183c0.858 0.067 1.497-0.158 1.93-0.597 0.45-0.426 0.682-0.986 0.712-1.619 0.055-0.737-0.134-1.34-0.572-1.784-0.42-0.426-1.017-0.651-1.765-0.724l-3.792-0.237-0.524 8.156 1.126 0.074M337.497 974.691l2.776 0.03M337.497 974.691l2.776 0.03M337.497 974.691l2.776 0.03M337.497 974.691l2.776 0.03M337.497 974.691l2.776 0.03c0.402 0.037 0.718 0.085 0.95 0.195 0.426 0.201 0.627 0.603 0.627 1.187 0 0.548-0.158 0.914-0.469 1.133-0.298 0.2-0.73 0.292-1.248 0.292l-2.666-0.03 0.024-2.806m-0.043 7.226 0.024-3.482 2.605 0.037c0.463 0 0.804 0.036 1.041 0.152 0.384 0.177 0.572 0.548 0.59 1.059l0.067 1.37c0.018 0.329 0.024 0.53 0.043 0.664 0.037 0.097 0.055 0.201 0.103 0.275l1.4 0-0.024-0.177c-0.158-0.085-0.286-0.249-0.341-0.499-0.049-0.158-0.073-0.396-0.085-0.694l-0.024-1.09c-0.018-0.493-0.103-0.833-0.292-1.023-0.164-0.219-0.39-0.408-0.737-0.524 0.39-0.206 0.682-0.444 0.895-0.737 0.201-0.323 0.304-0.73 0.304-1.229 0-0.937-0.383-1.577-1.163-1.924-0.42-0.189-0.956-0.287-1.589-0.298l-3.914-0.037-0.03 8.181 1.126 0M346.135 980.206c-0.499-0.608-0.767-1.369-0.828-2.27-0.055-1.133 0.164-1.997 0.682-2.582 0.524-0.633 1.199-0.937 2.082-0.986 0.889-0.049 1.619 0.237 2.161 0.797 0.554 0.548 0.87 1.309 0.925 2.259 0.03 0.913-0.128 1.722-0.548 2.434-0.414 0.725-1.102 1.133-2.118 1.157-1.059 0.055-1.851-0.194-2.356-0.81m-1.339-5.15c-0.524 0.81-0.737 1.747-0.682 2.88 0.079 1.223 0.457 2.234 1.169 2.995 0.791 0.761 1.838 1.144 3.129 1.071 1.382-0.061 2.423-0.584 3.129-1.546 0.572-0.87 0.846-1.882 0.785-3.129-0.079-1.114-0.402-2.021-1.004-2.697-0.761-0.907-1.875-1.308-3.385-1.247-1.424 0.091-2.471 0.614-3.147 1.673M383.238 963.29c0.785-0.134 1.467-0.097 2.088 0.116 0.913 0.286 1.528 0.962 1.911 1.997l-1.126 0.158c-0.243-0.559-0.59-0.943-1.059-1.157-0.457-0.2-1.029-0.25-1.686-0.152-0.767 0.116-1.382 0.499-1.814 1.114-0.426 0.657-0.554 1.534-0.365 2.653 0.158 0.926 0.499 1.711 1.059 2.234 0.517 0.536 1.278 0.724 2.271 0.584 0.743-0.122 1.339-0.419 1.759-0.931 0.438-0.486 0.566-1.224 0.42-2.173l-2.624 0.402-0.134-0.901 3.652-0.561 0.712 4.328-0.724 0.11-0.45-0.998c-0.304 0.451-0.609 0.798-0.877 0.998-0.45 0.354-1.059 0.579-1.82 0.688-0.986 0.152-1.887-0.025-2.703-0.548-0.895-0.664-1.473-1.65-1.692-3.019-0.237-1.345-0.024-2.496 0.597-3.403 0.59-0.876 1.449-1.387 2.605-1.552M391.498 962.656l2.618-0.95c0.359-0.133 0.67-0.177 0.937-0.145 0.481 0.036 0.834 0.322 1.035 0.894 0.189 0.487 0.189 0.913-0.024 1.212-0.225 0.31-0.578 0.536-1.09 0.724l-2.459 0.883-1.017-2.618m2.618 6.764-1.278-3.281 2.435-0.877c0.457-0.146 0.773-0.225 1.011-0.2 0.432 0.054 0.761 0.317 0.98 0.815l0.554 1.249c0.122 0.31 0.219 0.499 0.298 0.584 0.037 0.11 0.116 0.177 0.177 0.249l1.321-0.486-0.073-0.177c-0.195 0-0.383-0.11-0.524-0.323-0.103-0.152-0.201-0.371-0.341-0.626l-0.432-1.023c-0.195-0.444-0.396-0.718-0.627-0.883-0.231-0.128-0.524-0.213-0.87-0.237 0.268-0.311 0.463-0.622 0.536-0.987 0.079-0.371 0.043-0.785-0.134-1.247-0.335-0.87-0.95-1.345-1.814-1.406-0.457-0.036-0.98 0.061-1.583 0.273l-3.677 1.309 2.971 7.694 1.077-0.396M403.691 965.366l-4.669-6.812 5.126-3.269 0.566 0.822-4.2 2.684 1.437 2.082 3.878-2.496 0.53 0.797-3.878 2.496 1.583 2.295 4.273-2.734 0.566 0.804-5.217 3.33M407.776 953.325l1.339-1.473c0.621-0.657 1.278-0.956 1.997-0.87 0.718 0.061 1.449 0.438 2.228 1.12 0.213 0.164 0.402 0.377 0.597 0.615 0.341 0.444 0.542 0.835 0.67 1.224 0.11 0.488 0.085 0.932-0.085 1.358-0.103 0.212-0.286 0.462-0.56 0.761l-1.345 1.461-4.839-4.206m7.074 3.207c0.95-1.046 1.157-2.173 0.603-3.445-0.323-0.688-0.816-1.358-1.497-1.942-0.858-0.761-1.753-1.151-2.697-1.223-1.047-0.08-1.936 0.298-2.709 1.144l-2.283 2.447 6.294 5.491 2.283-2.459M419.725 950.171l-7.244-4.255 0.59-0.937 7.256 4.231-0.597 0.973M422.568 945.229l-7.822-3.13 2.307-5.503 0.95 0.365-1.881 4.535 2.356 0.926 1.759-4.177 0.901 0.372-1.741 4.17 2.636 1.071 1.93-4.589 0.95 0.359-2.35 5.601M426.16 935.623l-8.23-1.82 0.274-1.272 7.603-2.569-6.678-1.473 0.244-0.998 8.23 1.771-0.262 1.236-7.615 2.624 6.678 1.443-0.237 1.059M425.508 925.171l0.103-1.035c0.475 0.013 0.877-0.061 1.181-0.225 0.597-0.323 0.944-0.937 1.035-1.845 0.037-0.425 0.018-0.797-0.079-1.151-0.177-0.681-0.56-1.059-1.175-1.12-0.457-0.049-0.785 0.061-1.023 0.311-0.213 0.286-0.438 0.699-0.609 1.284l-0.377 1.077c-0.243 0.706-0.469 1.193-0.712 1.466-0.39 0.512-0.937 0.688-1.637 0.64-0.749-0.079-1.357-0.377-1.79-0.95-0.444-0.524-0.627-1.272-0.517-2.198 0.073-0.846 0.353-1.558 0.852-2.13 0.463-0.524 1.181-0.774 2.1-0.676l-0.085 1.035c-0.45 0-0.81 0.079-1.071 0.262-0.475 0.262-0.737 0.816-0.816 1.625-0.067 0.67 0.024 1.12 0.28 1.462 0.256 0.286 0.578 0.468 0.956 0.499 0.402 0.037 0.718-0.091 0.937-0.401 0.158-0.214 0.347-0.676 0.603-1.425l0.371-1.132c0.183-0.524 0.402-0.925 0.657-1.211 0.457-0.475 1.053-0.676 1.802-0.62 0.913 0.097 1.564 0.475 1.899 1.169 0.329 0.7 0.457 1.473 0.377 2.35-0.103 0.992-0.426 1.771-1.023 2.295-0.597 0.535-1.339 0.718-2.24 0.645M254.898 924.672l0.189 1.022c-0.457 0.091-0.822 0.275-1.09 0.512-0.481 0.45-0.645 1.126-0.481 2.045 0.073 0.389 0.213 0.772 0.39 1.077 0.365 0.621 0.84 0.87 1.443 0.772 0.444-0.079 0.737-0.249 0.877-0.566 0.134-0.311 0.231-0.786 0.262-1.394l0.055-1.151c0.037-0.712 0.116-1.272 0.274-1.583 0.25-0.56 0.718-0.907 1.418-1.022 0.749-0.135 1.406 0.036 1.972 0.462 0.572 0.396 0.95 1.084 1.09 1.997 0.177 0.835 0.097 1.583-0.231 2.258-0.317 0.658-0.925 1.059-1.857 1.23l-0.183-1.034c0.432-0.158 0.755-0.311 0.968-0.524 0.365-0.408 0.475-0.998 0.335-1.808-0.11-0.658-0.335-1.084-0.676-1.297-0.335-0.25-0.67-0.348-1.035-0.286-0.408 0.061-0.676 0.286-0.804 0.651-0.079 0.243-0.14 0.748-0.195 1.522l-0.055 1.193c-0.03 0.56-0.116 1.023-0.304 1.34-0.298 0.584-0.804 0.943-1.54 1.059-0.931 0.158-1.65-0.055-2.161-0.651-0.524-0.584-0.846-1.284-1.01-2.155-0.183-1.035-0.049-1.838 0.365-2.483 0.42-0.664 1.084-1.047 1.984-1.175M254.381 935.465l8.047-2.423 1.875 5.667-0.98 0.31-1.534-4.657-2.447 0.737 1.418 4.303-0.937 0.298-1.406-4.315-2.727 0.815 1.558 4.76-0.962 0.275-1.905-5.771M257.948 945.289l7.402-3.926 0.791 1.381-5.089 5.381 7.433-1.272 0.767 1.37-7.384 3.902-0.524-0.908 4.359-2.294c0.158-0.092 0.402-0.226 0.755-0.414 0.347-0.158 0.737-0.372 1.126-0.573l-7.402 1.26-0.542-0.962 5.053-5.363-0.243 0.122c-0.158 0.091-0.432 0.225-0.804 0.438-0.365 0.226-0.639 0.365-0.816 0.438l-4.346 2.331-0.536-0.925M271.742 956.192c-0.371-0.085-0.737-0.298-1.096-0.67l-1.564-1.613 2.106-1.93 1.577 1.608c0.304 0.298 0.499 0.59 0.603 0.84 0.146 0.48 0 0.919-0.444 1.333-0.402 0.371-0.804 0.524-1.181 0.432m-5.947 0.749 2.581-2.368 1.832 1.857c0.59 0.603 1.193 0.877 1.826 0.865 0.645-0.037 1.199-0.275 1.686-0.737 0.548-0.487 0.81-1.059 0.81-1.673-0.006-0.597-0.28-1.157-0.785-1.68l-2.63-2.685-6.124 5.625 0.791 0.797M273.178 963.515l4.438-6.958 5.247 3.19-0.548 0.828-4.31-2.581-1.333 2.106 3.963 2.404-0.511 0.798-3.969-2.392-1.51 2.355 4.365 2.624-0.524 0.822-5.308-3.196M286.315 962.169l2.666 0.847c0.377 0.115 0.651 0.261 0.834 0.426 0.341 0.323 0.432 0.785 0.231 1.345-0.164 0.487-0.414 0.804-0.804 0.938-0.347 0.06-0.785 0.06-1.297-0.098l-2.514-0.803 0.883-2.655m-2.301 6.836 1.108-3.318 2.484 0.81c0.444 0.116 0.767 0.275 0.925 0.438 0.304 0.274 0.396 0.682 0.244 1.188l-0.371 1.32c-0.085 0.323-0.128 0.536-0.164 0.633 0 0.104 0 0.214 0.018 0.286l1.309 0.426 0.079-0.189c-0.14-0.11-0.219-0.31-0.213-0.559 0.03-0.153 0.073-0.396 0.158-0.676l0.317-1.059c0.128-0.463 0.177-0.81 0.061-1.059-0.097-0.262-0.262-0.5-0.536-0.724 0.414-0.074 0.773-0.201 1.077-0.427 0.286-0.25 0.53-0.597 0.676-1.083 0.298-0.883 0.134-1.62-0.524-2.18-0.329-0.292-0.797-0.542-1.412-0.773l-3.725-1.15-2.605 7.761 1.09 0.335M295.318 827.761 295.318 827.761' fill='%23012a87'/%3E %3Cpath d='m295.318 827.761c0.962-2.32 9.874-8.645 39.117-5.875 0 0 4.943 3.019 7.847 2.63 1.656-0.214-0.974 0.103-3.135-1.693-2.204-1.795-2.672-5.478 2.362-5.381 5.01 0.128 23.765 1.187 24.118 2.873 0.329 1.704-9.916 2.417-13.727 2.319-3.829-0.103-3.385 1.833 0.426 1.687 11.907-0.426 24.903-4.621 38.63 5.089 1.637 1.18-4.139 1.369-8.608-0.53 0 0-12.108 0.628-17.343-0.231 0 0-4.024 3.274-9.265 2.952 0.682 1.698-1.936 8.035-18.414 3.268-2.721 0.835-12.637 2.496-11.554-0.45-2.611 0-7.189 0.84-7.871-0.646-0.657-1.46 8.06-3.671 9.588-5.253 0 0-18.439 0.177-21.933-1.096 0 0-10.878 2.441-10.239 0.323' fill='%23bc715f'/%3E %3Cpath d='m301.229 853.583c0.396-0.535 0.554-1.497 1.394-1.473 1.826 0.486 3.068 3.828 5.314 1.661 0.797-0.177 1.102 0.908 1.759 1.035 0.42 1.857 1.911-0.377 3.025-0.25 2.38-1.059 5.326-1.309 8.145-0.785 0.085 1.82-1.339 3.829-3.129 4.864 0.037 1.833 1.698 3.008 1.668 4.852-0.286 0.688-0.049 1.771-1.09 1.997-1.321-0.237-2.624-0.377-3.719-1.114-0.134-0.134-0.243-0.396-0.524-0.31-0.134 0.615 0.828 1.224 1.205 1.851-0.664 1.132-1.765 0.097-2.691 0.11-0.274 0.651-0.012 1.473-0.682 1.893-1.169-0.036-1.406-1.308-2.124-1.942-0.737 0.797 0.517 1.272 0.694 1.905-0.45 2.398-0.39 4.742-2.788 6.313l-1.607 0.798c-0.438-1.205-0.164-3.032-0.457-4.292-0.95 1.546-1.692 2.898-3.086 4.206-1.631-0.536-2.581-2.459-2.94-4.054-0.682-1.857-0.292-4.079 1.175-5.424-0.499-0.974-2.21-0.749-2.453-2.136-2.563-1.669-3.981 2.922-5.637 0.535-0.536-2.227 0.103-4.998 1.717-6.66-0.359-0.912-1.552-0.675-2.258-1.199-1.613-1.37-3.939-2.818-3.823-5.291 4.413-1.667 9.691-0.444 12.899 2.91' fill='%23008830'/%3E %3Cpath d='m303.518 853.334c-0.103 2.02 1.364 0.547 2.453 1.771-0.852-0.335-1.473 1.473-2.307 0.438l-0.524 0.5c0.304 0.693 0.895 0.785 0.28 1.546-0.913 0.347-1.096-0.797-1.522-1.248-0.073-0.2 0.14-0.578-0.195-0.712-0.517 0.438-1.059 0.597-1.771 0.524-0.195-0.39-0.572-0.901-0.189-1.199 0.7-0.944 1.784 0.34 2.313-0.323 0.085-0.584-0.426-1.297 0.237-1.699 0.457 0.079 1.041-0.17 1.23 0.402M308.978 854.99 308.978 854.99 308.978 854.99 308.978 854.99 308.978 854.99c0.055 0.39-0.201 0.937 0.31 1.212 0.664-0.36 1.37-0.086 1.753 0.572-0.006 0.352 0.103 0.815-0.359 0.986l-1.035-0.194c0.073-0.201-0.256-0.329-0.384-0.524-0.457-0.14-0.724 0.231-1.065 0.456 0.256 0.39 0.846 0.603 0.706 1.102-0.609 0.608-0.907-0.524-1.577-0.238-0.457-0.176 0.164-1.126-0.554-1.412-0.852 0-0.286 1.399-1.376 0.852-0.39-0.439-0.773-1.029-0.353-1.522 0.457-0.305 1.23-0.226 1.619 0.17 0.664-0.736 0.73-3.579 2.319-1.461M302.179 857.924c0.444 0.64-0.097 1.51 0.469 2.222 0.889-1.661 1.747 0.359 2.806 0.201 0.323 0.396 0.11 0.944 0.17 1.394-1.309 0.347-2.885 0.761-4.042-0.286l-0.323 0.371c0.688 0.64 1.339 1.364 0.791 2.435-0.98 0.213-2.496 0.237-2.989-0.773-0.256-0.833 0.597-1.436-0.304-2.106-0.651 0.81-0.621 1.894-1.978 1.157-0.84-0.463-1.09-1.418-0.67-2.222 0.877-1.382 2.411 0.043 3.36-0.633 0.134-1.187-0.304-2.222 0.785-2.879 0.931-0.165 1.364 0.535 1.93 1.119' fill='%23f9d90f'/%3E %3Cpath d='m305.892 858.648c-0.438 2.021-1.96-0.103-2.672-0.189 0.95-1.686 1.546 0.548 2.672 0.189M310.634 860.846 310.634 860.846 310.634 860.846 310.634 860.846 310.634 860.846c-1.059 0.298-0.895-1.023-1.418-1.541l0.408-0.371c0.384 0.463 0.676 1.297 1.011 1.912' fill='%23fff'/%3E %3Cpath d='m309.197 860.444c0.304 0.7-0.688 1.261 0.158 1.771 0.268-0.225 0.597-0.536 0.737-0.664 0.724 0.214 1.564 0.342 2.07 1.059 0.542 1.486-0.962 1.449-1.814 1.863l-0.846-0.036c0.201-0.414-0.365-0.59-0.505-0.876-0.39-0.097-0.712 0.024-0.931 0.352 0.189 0.944 1.339 1.68 0.152 2.52-1.004-0.066-2.563 0.323-2.471-1.065-0.377-0.785 1.023-1.997-0.475-2.045-0.493 1.059-1.035 2.081-2.319 1.077l0.158-1.51c1.23 0.036 2.685 0.249 3.238-1.126 0.353-0.998-0.615-1.918 0.25-2.709 1.254-0.286 1.96 0.554 2.599 1.387' fill='%23f9d90f'/%3E %3Cpath d='m308.296 862.714c0.317 0.749-0.536 0.798-0.937 1.169-0.542 0.043-0.919-0.17-1.248-0.536-0.243-0.907 0.432-0.998 0.95-1.357 0.603-0.25 0.852 0.45 1.236 0.724' fill='%23000'/%3E %3Cpath d='m307.56 863.201c-0.134 0.177-0.323 0.122-0.524 0.17l-0.189-0.906c0.402 0.036 0.925 0.164 0.712 0.736' fill='%23fff'/%3E %3C/g%3E %3C/g%3E %3C/g%3E %3C/marker%3E %3C/defs%3E %3Cpath d='M0 0 298.571 225.241 675 225.241 675 0z' fill='%23dc171d'/%3E %3Cpath d='M0 0 299.005 225.746 0 450z' style='fill:%23fff;stroke:%23fff'/%3E %3Cpath d='M0 450 298.571 225.241 675 225.241 675 450z' fill='%23012a87'/%3E %3Cg transform='matrix(1.0075359,0,0,1.0073522,-229.18917,-679.02099)'%3E %3Cpath d='m377.175 843.108 0.091-3.458c0 0-1.857-2.958 0.298-6.136 0 0-4.578-2.422-3.512-6.215 0 0-4.139-1.059-3.835-5.613 0 0-4.468-0.31-4.931-4.114 0 0-4.468 0.736-6.434-2.971 0 0-4.359 0.852-5.588-2.204 0 0-4.237 1.468-6.751-2.124 0 0-4.474 1.808-6.349-1.583-1.851 3.379-6.325 1.583-6.325 1.583-2.484 3.579-6.751 2.094-6.751 2.094-1.187 3.068-5.533 2.198-5.533 2.198-1.96 3.708-6.422 2.971-6.422 2.971-0.438 3.793-4.9 4.103-4.9 4.103 0.353 4.566-3.78 5.601-3.78 5.601 1.09 3.792-3.482 6.208-3.482 6.208 2.21 3.196 0.371 6.131 0.371 6.131l-0.103 3.189 73.949 0.342' fill='%23ff0'/%3E %3Cpath d='m377.175 843.108 0.091-3.458c0 0-1.857-2.958 0.298-6.136 0 0-4.578-2.422-3.512-6.215 0 0-4.139-1.059-3.835-5.613 0 0-4.468-0.31-4.931-4.114 0 0-4.468 0.736-6.434-2.971 0 0-4.359 0.852-5.588-2.204 0 0-4.237 1.468-6.751-2.124 0 0-4.474 1.808-6.349-1.583-1.851 3.379-6.325 1.583-6.325 1.583-2.484 3.579-6.751 2.094-6.751 2.094-1.187 3.068-5.533 2.198-5.533 2.198-1.96 3.708-6.422 2.971-6.422 2.971-0.438 3.793-4.9 4.103-4.9 4.103 0.353 4.566-3.78 5.601-3.78 5.601 1.09 3.792-3.482 6.208-3.482 6.208 2.21 3.196 0.371 6.131 0.371 6.131l-0.103 3.189 73.949 0.342-0.012 0z' style='fill:%23f9d90f;stroke-width:0.27124387;stroke:%23000'/%3E %3Cpath d='m375.446 838.791c-11.615-1.163-24.989-3.92-35.313 1.894-6.921-4.079-16.558-3.83-24.763-3.031-4.456 0.797-9.697 0.797-14.354 1.558l-0.73 0.103c-8.449 0.561-16.113-1.936-23.455-5.217 2.331 13.234 4.919 26.797 6.191 40.652 2.77 20.52-9.709 37.748-4.59 58.019 3.056 9.727 13.751 15.382 23.54 16.503 9.478 0.559 19.285 2.112 28.057 4.017 1.668 0.347 3.646 1.121 4.797 1.619 2.417 1.011 4.188 2.496 5.74 4.085 5.296-5.516 13.057-7.05 20.715-7.859 13.8-1.613 30.814-0.736 39.263-13.239l0-0.707c4.59-6.915 3.981-17.464 1.991-25.299-0.134-2.733-0.864-5.144-1.26-7.749-8.431-22.268-1.211-47.311 2.417-69.756-4.432 2.423-9.375 3.567-14.305 4.779-3.932 0.524-8.315 0.286-12.296 0.072l-1.65-0.444M392.795 902.697 392.795 902.697' fill='%23dc171d'/%3E %3Cpath d='m392.795 902.697c-0.055 1.466 0.737 2.618 1.023 3.974 1.613 9.734 3.172 22.627-6.848 28.666-11.085 7.049-25.622 4.03-38.448 7.761-2.563 0.712-6.093 3.069-7.895 4.736-1.157-0.761-2.319-1.93-3.811-2.617-10.555-5.613-24.276-3.732-36.189-6.764-5.984-1.893-12.223-6.555-13.739-12.68-3.896-16.07 5.436-29.767 4.334-45.709-0.712-12.175-2.758-23.862-5.57-35.276 9.314 4.34 20.094 5.064 30.565 2.983 7.755-1.084 16.783-1.108 24.051 2.173 4.005-1.723 8.693-2.496 13.009-2.971 8.206 0.798 17.026 2.283 25.476 2.222 5.643-0.293 10.769-1.924 15.675-4.097-2.91 18.865-8.498 38.625-1.637 57.599' fill='%2362afe1'/%3E %3Cpath d='m376.042 906.458-0.091-17.739 2.185 0-27.113-17.513-0.049-9.101 2.618 0-13.557-9.709-13.49 9.703 2.611 0 0.049 9.094-26.967 17.49 2.155 0.012 0.091 17.727 71.551 0.049' fill='%23fff'/%3E %3Cpath d='m376.042 906.458-0.091-17.739 2.185 0-27.113-17.513-0.049-9.101 2.618 0-13.557-9.709-13.49 9.703 2.611 0 0.049 9.094-26.967 17.49 2.155 0.012 0.091 17.727 71.551 0.049 0.006-0.013z' style='fill:none;stroke-width:1.16422367;stroke:%23000'/%3E %3Cpath d='m384.376 929.761 0.006 5.551-87.347-0.097-0.036-5.527 87.384 0.074' fill='%23fff'/%3E %3Cpath d='m384.376 929.761 0.006 5.551-87.347-0.097-0.036-5.527 87.384 0.074-0.006 0z' style='fill:none;stroke-width:1.16422367;stroke:%23000'/%3E %3Cpath d='m302.836 929.426-0.073-18.786 3.537-0.007-0.195 19.005 0.213-18.852-5.095-0.146 0-4.03 78.064 0.086 0.037 3.993-4.815 0 0.091 19.023-0.17-19.023 3.585 0 0.079 18.809' fill='%23fff'/%3E %3Cpath d='m302.836 929.426-0.073-18.786 3.537-0.007-0.195 19.005 0.213-18.852-5.095-0.146 0-4.03 78.064 0.086 0.037 3.993-4.815 0 0.091 19.023-0.17-19.023 3.585 0 0.079 18.809M319.619 924.8l-0.055-13.1-10.482 0 0.061 13.087 10.476 0.013M319.619 924.8l-0.055-13.1-10.482 0 0.061 13.087 10.476 0.013M319.619 924.8l-0.055-13.1-10.482 0 0.061 13.087 10.476 0.013M319.619 924.8l-0.055-13.1-10.482 0 0.061 13.087 10.476 0.013M319.619 924.8l-0.055-13.1-10.482 0 0.061 13.087 10.476 0.013M311.937 914.432l0.03 7.609 4.797 0-0.024-7.609-4.803 0M370.862 924.836l-0.061-13.087-10.446-0.012 0.049 13.099 10.458 0M363.18 914.481l0.055 7.585 4.791 0-0.043-7.585-4.803 0M370.783 903.506l-0.061-13.101-10.458 0 0.037 13.101 10.489 0-0.006 0zM363.101 893.163l0.03 7.597 4.791 0-0.006-7.597-4.815 0M319.534 903.458l-0.073-13.076-10.464-0.013 0.049 13.082 10.489 0 0 0.007zM311.851 893.115l0.024 7.585 4.803 0.012-0.036-7.597-4.791 0M338.502 903.481l-0.049-13.076-10.47-0.012 0.043 13.087 10.476 0M330.826 893.127l0.024 7.585 4.797 0.024-0.03-7.609-4.791 0M353.124 903.506l-0.073-13.101-10.464-0.012 0.049 13.087 10.489 0.025M345.435 893.14l0.037 7.609 4.797 0-0.024-7.609-4.809 0' style='fill:none;stroke-width:1.16422367;stroke:%23000'/%3E %3Cpath d='m355.717 899.488 0.116 30.199-30.333-0.049-0.11-30.174 30.321 0.024' fill='%23fff'/%3E %3Cpath d='m355.717 899.488 0.116 30.199-30.333-0.049-0.11-30.174 30.321 0.024 0.006 0zM325.207 908.108l30.54 0.024M325.207 908.108l30.54 0.024M325.207 908.108l30.54 0.024M325.207 908.108l30.54 0.024M325.207 908.108l30.54 0.024M329.018 929.675l-0.103-21.342M352.143 929.687l-0.103-21.329M366.79 886.626l-17.081-12.474-19.193-0.024-16.947 12.449 53.222 0.049M331.994 863.799l0.03 7.609 16.144 0.012-0.03-7.609-16.144-0.012M331.994 863.799l0.03 7.609 16.144 0.012-0.03-7.609-16.144-0.012' style='fill:none;stroke-width:1.16422367;stroke:%23000'/%3E %3Cpath d='m331.994 863.799 0.03 7.609 16.144 0.012-0.03-7.609-16.144-0.012' style='fill:none;stroke-width:1.16422367;stroke:%23000'/%3E %3Cpath d='m336.371 865.686 0.024 3.792 7.414 0-0.024-3.792-7.414 0M340.036 855.142l8.979 6.348-17.891-0.024 8.912-6.325M340.036 855.142l8.979 6.348-17.891-0.024 8.912-6.325M340.036 855.142l8.979 6.348-17.891-0.024 8.912-6.325M340.036 855.142l8.979 6.348-17.891-0.024 8.912-6.325M340.036 855.142l8.979 6.348-17.891-0.024 8.912-6.325' style='fill:none;stroke-width:1.16422367;stroke:%23000'/%3E %3Cpath d='m376.341 850.838c2.551-0.061 3.208 10.507 3.214 15.742 2.191 0.615 7.049 3.671 9.198 6.434l-24.642-0.036c2.118-2.727 6.94-5.795 9.113-6.409 0-5.242 0.536-15.803 3.117-15.742' fill='%23fff'/%3E %3Cpath d='m376.341 850.838c2.551-0.061 3.208 10.507 3.214 15.742 2.191 0.615 7.049 3.671 9.198 6.434l-24.642-0.036c2.118-2.727 6.94-5.795 9.113-6.409 0-5.242 0.536-15.803 3.117-15.742M326.808 900.335l2.21 0-0.645 1.186M326.808 900.335l2.21 0-0.645 1.186M326.808 900.335l2.21 0-0.645 1.186M326.808 900.335l2.21 0-0.645 1.186M326.808 900.335l2.21 0-0.645 1.186c0 0 1.065 1.37 0.018 2.94l0.578 1.09-2.131 0 0.578-1.035c0 0-1.09-1.82 0.049-2.995l-0.657-1.186M331.313 900.335l2.21 0-0.639 1.186c0 0 1.065 1.334 0.006 2.94l0.572 1.09-2.124 0 0.572-1.035c0 0-1.065-1.82 0.055-2.995l-0.651-1.186M336.225 900.335l2.204 0-0.657 1.186c0 0 1.077 1.37 0.018 2.94l0.578 1.114-2.112-0.024 0.566-1.035c0 0-1.077-1.808 0.043-2.995l-0.645-1.186 0.006 0zM341.771 900.346l2.222 0-0.651 1.199c0 0 1.065 1.346 0.006 2.922l0.597 1.108-2.143 0 0.572-1.035c0 0-1.065-1.832 0.073-2.995l-0.67-1.199-0.006 0zM346.701 900.346l2.204 0-0.651 1.199c0 0 1.071 1.346 0.012 2.916l0.584 1.114-2.124 0 0.554-1.035c0 0-1.071-1.82 0.085-2.995l-0.664-1.199M351.602 900.359l2.204-0.012-0.651 1.199c0 0 1.09 1.346 0.03 2.922l0.554 1.108-2.131 0 0.572-1.035c0 0-1.065-1.82 0.073-2.995l-0.651-1.187' style='fill:none;stroke-width:1.16422367;stroke:%23000'/%3E %3Cpath d='m340.699 968.397c11.359 0.037 25.329-2.283 31.873-5.667l14.372-1.273 0.286 17.538c-12.175 6.714-40.286 8.156-46.471 8.108-6.191 0.049-34.649-1.418-46.879-8.156l0.158-17.55 14.403 1.297c6.544 3.367 20.94 5.704 32.287 5.704l-0.03 0' fill='%23f9d90f'/%3E %3Cpath d='m340.699 968.397c11.359 0.037 25.329-2.283 31.873-5.667l14.372-1.273 0.286 17.538c-12.175 6.714-40.286 8.156-46.471 8.108-6.191 0.049-34.649-1.418-46.879-8.156l0.158-17.55 14.403 1.297c6.544 3.367 20.94 5.704 32.287 5.704l-0.03 0' style='fill:none;stroke-width:0.27124387;stroke:%23000'/%3E %3Cpath d='m256.883 893.589 12.662 4.03-3.829 20.503-11.986 1.862c0 0-2.021-10.781 3.153-26.407' fill='%23f9d90f'/%3E %3Cpath d='m256.883 893.589 12.662 4.03-3.829 20.503-11.986 1.862c0 0-2.021-10.781 3.153-26.407l0 0.012z' style='fill:none;stroke-width:0.27124387;stroke:%23000'/%3E %3Cpath d='m265.709 917.896-11.98 2.088 7.579-10.781 4.401 8.693' fill='%237e7e7e'/%3E %3Cpath d='m265.709 917.896-11.98 2.088 7.579-10.781 4.401 8.693' style='fill:%23f9b60f;stroke-width:0.27124387;stroke:%23000'/%3E %3Cpath d='m249.31 908.358 12.205 0.882c0.274 10.343 1.528 49.813 48.656 51.956l-1.467 14.36c-57.367 0.596-61.726-48.413-59.394-67.198' fill='%23f9d90f'/%3E %3Cpath d='m249.31 908.358 12.205 0.882c0.274 10.343 1.528 49.813 48.656 51.956l-1.467 14.36c-57.367 0.596-61.726-48.413-59.394-67.198zM294.107 978.496l14.384-3.141M294.107 978.496l14.384-3.141M294.107 978.496l14.384-3.141M294.107 978.496l14.384-3.141M294.107 978.496l14.384-3.141' style='fill:none;stroke-width:0.27124387;stroke:%23000'/%3E %3Cpath d='m423.518 893.735-12.613 3.993 3.999 20.472 12.01 1.929c0 0 1.93-10.774-3.397-26.406' fill='%23ff0'/%3E %3Cpath d='m423.518 893.735-12.613 3.993 3.999 20.472 12.01 1.929c0 0 1.93-10.774-3.397-26.406l0 0.012z' style='fill:%23f9d90f;stroke-width:0.27124387;stroke:%23000'/%3E %3Cpath d='m414.904 917.987 12.01 2.155-7.682-10.786-4.328 8.631' fill='%237e7e7e'/%3E %3Cpath d='m414.904 917.987 12.01 2.155-7.682-10.786-4.328 8.631' style='fill:%23f9b60f;stroke-width:0.27124387;stroke:%23000'/%3E %3Cpath d='m431.23 908.522-12.223 0.835c-0.177 10.33-1.077 49.818-48.206 51.912l1.601 14.348c57.355 0.663 61.3-48.322 58.828-67.101' fill='%23f9d90f'/%3E %3Cpath d='m431.23 908.522-12.223 0.835c-0.177 10.33-1.077 49.818-48.206 51.912l1.601 14.348c57.355 0.663 61.3-48.322 58.828-67.101l0 0.005zM387.036 978.575 372.615 975.416' style='fill:none;stroke-width:0.27124387;stroke:%23000'/%3E %3Cpath d='m333.072 977.041c-0.323 0.207-0.761 0.262-1.266 0.237l-2.277-0.116 0.195-2.842 2.258 0.121c0.444 0.03 0.797 0.116 1.017 0.25 0.457 0.237 0.657 0.676 0.615 1.284-0.03 0.524-0.213 0.865-0.548 1.065m-3.823 4.475 0.225-3.464 2.654 0.183c0.858 0.067 1.497-0.158 1.93-0.597 0.45-0.426 0.682-0.986 0.712-1.619 0.055-0.737-0.134-1.34-0.572-1.784-0.42-0.426-1.017-0.651-1.765-0.724l-3.792-0.237-0.524 8.156 1.126 0.074M337.497 974.691l2.776 0.03M337.497 974.691l2.776 0.03M337.497 974.691l2.776 0.03M337.497 974.691l2.776 0.03M337.497 974.691l2.776 0.03c0.402 0.037 0.718 0.085 0.95 0.195 0.426 0.201 0.627 0.603 0.627 1.187 0 0.548-0.158 0.914-0.469 1.133-0.298 0.2-0.73 0.292-1.248 0.292l-2.666-0.03 0.024-2.806m-0.043 7.226 0.024-3.482 2.605 0.037c0.463 0 0.804 0.036 1.041 0.152 0.384 0.177 0.572 0.548 0.59 1.059l0.067 1.37c0.018 0.329 0.024 0.53 0.043 0.664 0.037 0.097 0.055 0.201 0.103 0.275l1.4 0-0.024-0.177c-0.158-0.085-0.286-0.249-0.341-0.499-0.049-0.158-0.073-0.396-0.085-0.694l-0.024-1.09c-0.018-0.493-0.103-0.833-0.292-1.023-0.164-0.219-0.39-0.408-0.737-0.524 0.39-0.206 0.682-0.444 0.895-0.737 0.201-0.323 0.304-0.73 0.304-1.229 0-0.937-0.383-1.577-1.163-1.924-0.42-0.189-0.956-0.287-1.589-0.298l-3.914-0.037-0.03 8.181 1.126 0M346.135 980.206c-0.499-0.608-0.767-1.369-0.828-2.27-0.055-1.133 0.164-1.997 0.682-2.582 0.524-0.633 1.199-0.937 2.082-0.986 0.889-0.049 1.619 0.237 2.161 0.797 0.554 0.548 0.87 1.309 0.925 2.259 0.03 0.913-0.128 1.722-0.548 2.434-0.414 0.725-1.102 1.133-2.118 1.157-1.059 0.055-1.851-0.194-2.356-0.81m-1.339-5.15c-0.524 0.81-0.737 1.747-0.682 2.88 0.079 1.223 0.457 2.234 1.169 2.995 0.791 0.761 1.838 1.144 3.129 1.071 1.382-0.061 2.423-0.584 3.129-1.546 0.572-0.87 0.846-1.882 0.785-3.129-0.079-1.114-0.402-2.021-1.004-2.697-0.761-0.907-1.875-1.308-3.385-1.247-1.424 0.091-2.471 0.614-3.147 1.673M383.238 963.29c0.785-0.134 1.467-0.097 2.088 0.116 0.913 0.286 1.528 0.962 1.911 1.997l-1.126 0.158c-0.243-0.559-0.59-0.943-1.059-1.157-0.457-0.2-1.029-0.25-1.686-0.152-0.767 0.116-1.382 0.499-1.814 1.114-0.426 0.657-0.554 1.534-0.365 2.653 0.158 0.926 0.499 1.711 1.059 2.234 0.517 0.536 1.278 0.724 2.271 0.584 0.743-0.122 1.339-0.419 1.759-0.931 0.438-0.486 0.566-1.224 0.42-2.173l-2.624 0.402-0.134-0.901 3.652-0.561 0.712 4.328-0.724 0.11-0.45-0.998c-0.304 0.451-0.609 0.798-0.877 0.998-0.45 0.354-1.059 0.579-1.82 0.688-0.986 0.152-1.887-0.025-2.703-0.548-0.895-0.664-1.473-1.65-1.692-3.019-0.237-1.345-0.024-2.496 0.597-3.403 0.59-0.876 1.449-1.387 2.605-1.552M391.498 962.656l2.618-0.95c0.359-0.133 0.67-0.177 0.937-0.145 0.481 0.036 0.834 0.322 1.035 0.894 0.189 0.487 0.189 0.913-0.024 1.212-0.225 0.31-0.578 0.536-1.09 0.724l-2.459 0.883-1.017-2.618m2.618 6.764-1.278-3.281 2.435-0.877c0.457-0.146 0.773-0.225 1.011-0.2 0.432 0.054 0.761 0.317 0.98 0.815l0.554 1.249c0.122 0.31 0.219 0.499 0.298 0.584 0.037 0.11 0.116 0.177 0.177 0.249l1.321-0.486-0.073-0.177c-0.195 0-0.383-0.11-0.524-0.323-0.103-0.152-0.201-0.371-0.341-0.626l-0.432-1.023c-0.195-0.444-0.396-0.718-0.627-0.883-0.231-0.128-0.524-0.213-0.87-0.237 0.268-0.311 0.463-0.622 0.536-0.987 0.079-0.371 0.043-0.785-0.134-1.247-0.335-0.87-0.95-1.345-1.814-1.406-0.457-0.036-0.98 0.061-1.583 0.273l-3.677 1.309 2.971 7.694 1.077-0.396M403.691 965.366l-4.669-6.812 5.126-3.269 0.566 0.822-4.2 2.684 1.437 2.082 3.878-2.496 0.53 0.797-3.878 2.496 1.583 2.295 4.273-2.734 0.566 0.804-5.217 3.33M407.776 953.325l1.339-1.473c0.621-0.657 1.278-0.956 1.997-0.87 0.718 0.061 1.449 0.438 2.228 1.12 0.213 0.164 0.402 0.377 0.597 0.615 0.341 0.444 0.542 0.835 0.67 1.224 0.11 0.488 0.085 0.932-0.085 1.358-0.103 0.212-0.286 0.462-0.56 0.761l-1.345 1.461-4.839-4.206m7.074 3.207c0.95-1.046 1.157-2.173 0.603-3.445-0.323-0.688-0.816-1.358-1.497-1.942-0.858-0.761-1.753-1.151-2.697-1.223-1.047-0.08-1.936 0.298-2.709 1.144l-2.283 2.447 6.294 5.491 2.283-2.459M419.725 950.171l-7.244-4.255 0.59-0.937 7.256 4.231-0.597 0.973M422.568 945.229l-7.822-3.13 2.307-5.503 0.95 0.365-1.881 4.535 2.356 0.926 1.759-4.177 0.901 0.372-1.741 4.17 2.636 1.071 1.93-4.589 0.95 0.359-2.35 5.601M426.16 935.623l-8.23-1.82 0.274-1.272 7.603-2.569-6.678-1.473 0.244-0.998 8.23 1.771-0.262 1.236-7.615 2.624 6.678 1.443-0.237 1.059M425.508 925.171l0.103-1.035c0.475 0.013 0.877-0.061 1.181-0.225 0.597-0.323 0.944-0.937 1.035-1.845 0.037-0.425 0.018-0.797-0.079-1.151-0.177-0.681-0.56-1.059-1.175-1.12-0.457-0.049-0.785 0.061-1.023 0.311-0.213 0.286-0.438 0.699-0.609 1.284l-0.377 1.077c-0.243 0.706-0.469 1.193-0.712 1.466-0.39 0.512-0.937 0.688-1.637 0.64-0.749-0.079-1.357-0.377-1.79-0.95-0.444-0.524-0.627-1.272-0.517-2.198 0.073-0.846 0.353-1.558 0.852-2.13 0.463-0.524 1.181-0.774 2.1-0.676l-0.085 1.035c-0.45 0-0.81 0.079-1.071 0.262-0.475 0.262-0.737 0.816-0.816 1.625-0.067 0.67 0.024 1.12 0.28 1.462 0.256 0.286 0.578 0.468 0.956 0.499 0.402 0.037 0.718-0.091 0.937-0.401 0.158-0.214 0.347-0.676 0.603-1.425l0.371-1.132c0.183-0.524 0.402-0.925 0.657-1.211 0.457-0.475 1.053-0.676 1.802-0.62 0.913 0.097 1.564 0.475 1.899 1.169 0.329 0.7 0.457 1.473 0.377 2.35-0.103 0.992-0.426 1.771-1.023 2.295-0.597 0.535-1.339 0.718-2.24 0.645M254.898 924.672l0.189 1.022c-0.457 0.091-0.822 0.275-1.09 0.512-0.481 0.45-0.645 1.126-0.481 2.045 0.073 0.389 0.213 0.772 0.39 1.077 0.365 0.621 0.84 0.87 1.443 0.772 0.444-0.079 0.737-0.249 0.877-0.566 0.134-0.311 0.231-0.786 0.262-1.394l0.055-1.151c0.037-0.712 0.116-1.272 0.274-1.583 0.25-0.56 0.718-0.907 1.418-1.022 0.749-0.135 1.406 0.036 1.972 0.462 0.572 0.396 0.95 1.084 1.09 1.997 0.177 0.835 0.097 1.583-0.231 2.258-0.317 0.658-0.925 1.059-1.857 1.23l-0.183-1.034c0.432-0.158 0.755-0.311 0.968-0.524 0.365-0.408 0.475-0.998 0.335-1.808-0.11-0.658-0.335-1.084-0.676-1.297-0.335-0.25-0.67-0.348-1.035-0.286-0.408 0.061-0.676 0.286-0.804 0.651-0.079 0.243-0.14 0.748-0.195 1.522l-0.055 1.193c-0.03 0.56-0.116 1.023-0.304 1.34-0.298 0.584-0.804 0.943-1.54 1.059-0.931 0.158-1.65-0.055-2.161-0.651-0.524-0.584-0.846-1.284-1.01-2.155-0.183-1.035-0.049-1.838 0.365-2.483 0.42-0.664 1.084-1.047 1.984-1.175M254.381 935.465l8.047-2.423 1.875 5.667-0.98 0.31-1.534-4.657-2.447 0.737 1.418 4.303-0.937 0.298-1.406-4.315-2.727 0.815 1.558 4.76-0.962 0.275-1.905-5.771M257.948 945.289l7.402-3.926 0.791 1.381-5.089 5.381 7.433-1.272 0.767 1.37-7.384 3.902-0.524-0.908 4.359-2.294c0.158-0.092 0.402-0.226 0.755-0.414 0.347-0.158 0.737-0.372 1.126-0.573l-7.402 1.26-0.542-0.962 5.053-5.363-0.243 0.122c-0.158 0.091-0.432 0.225-0.804 0.438-0.365 0.226-0.639 0.365-0.816 0.438l-4.346 2.331-0.536-0.925M271.742 956.192c-0.371-0.085-0.737-0.298-1.096-0.67l-1.564-1.613 2.106-1.93 1.577 1.608c0.304 0.298 0.499 0.59 0.603 0.84 0.146 0.48 0 0.919-0.444 1.333-0.402 0.371-0.804 0.524-1.181 0.432m-5.947 0.749 2.581-2.368 1.832 1.857c0.59 0.603 1.193 0.877 1.826 0.865 0.645-0.037 1.199-0.275 1.686-0.737 0.548-0.487 0.81-1.059 0.81-1.673-0.006-0.597-0.28-1.157-0.785-1.68l-2.63-2.685-6.124 5.625 0.791 0.797M273.178 963.515l4.438-6.958 5.247 3.19-0.548 0.828-4.31-2.581-1.333 2.106 3.963 2.404-0.511 0.798-3.969-2.392-1.51 2.355 4.365 2.624-0.524 0.822-5.308-3.196M286.315 962.169l2.666 0.847c0.377 0.115 0.651 0.261 0.834 0.426 0.341 0.323 0.432 0.785 0.231 1.345-0.164 0.487-0.414 0.804-0.804 0.938-0.347 0.06-0.785 0.06-1.297-0.098l-2.514-0.803 0.883-2.655m-2.301 6.836 1.108-3.318 2.484 0.81c0.444 0.116 0.767 0.275 0.925 0.438 0.304 0.274 0.396 0.682 0.244 1.188l-0.371 1.32c-0.085 0.323-0.128 0.536-0.164 0.633 0 0.104 0 0.214 0.018 0.286l1.309 0.426 0.079-0.189c-0.14-0.11-0.219-0.31-0.213-0.559 0.03-0.153 0.073-0.396 0.158-0.676l0.317-1.059c0.128-0.463 0.177-0.81 0.061-1.059-0.097-0.262-0.262-0.5-0.536-0.724 0.414-0.074 0.773-0.201 1.077-0.427 0.286-0.25 0.53-0.597 0.676-1.083 0.298-0.883 0.134-1.62-0.524-2.18-0.329-0.292-0.797-0.542-1.412-0.773l-3.725-1.15-2.605 7.761 1.09 0.335M295.318 827.761 295.318 827.761' fill='%23012a87'/%3E %3Cpath d='m295.318 827.761c0.962-2.32 9.874-8.645 39.117-5.875 0 0 4.943 3.019 7.847 2.63 1.656-0.214-0.974 0.103-3.135-1.693-2.204-1.795-2.672-5.478 2.362-5.381 5.01 0.128 23.765 1.187 24.118 2.873 0.329 1.704-9.916 2.417-13.727 2.319-3.829-0.103-3.385 1.833 0.426 1.687 11.907-0.426 24.903-4.621 38.63 5.089 1.637 1.18-4.139 1.369-8.608-0.53 0 0-12.108 0.628-17.343-0.231 0 0-4.024 3.274-9.265 2.952 0.682 1.698-1.936 8.035-18.414 3.268-2.721 0.835-12.637 2.496-11.554-0.45-2.611 0-7.189 0.84-7.871-0.646-0.657-1.46 8.06-3.671 9.588-5.253 0 0-18.439 0.177-21.933-1.096 0 0-10.878 2.441-10.239 0.323' fill='%23bc715f'/%3E %3Cpath d='m301.229 853.583c0.396-0.535 0.554-1.497 1.394-1.473 1.826 0.486 3.068 3.828 5.314 1.661 0.797-0.177 1.102 0.908 1.759 1.035 0.42 1.857 1.911-0.377 3.025-0.25 2.38-1.059 5.326-1.309 8.145-0.785 0.085 1.82-1.339 3.829-3.129 4.864 0.037 1.833 1.698 3.008 1.668 4.852-0.286 0.688-0.049 1.771-1.09 1.997-1.321-0.237-2.624-0.377-3.719-1.114-0.134-0.134-0.243-0.396-0.524-0.31-0.134 0.615 0.828 1.224 1.205 1.851-0.664 1.132-1.765 0.097-2.691 0.11-0.274 0.651-0.012 1.473-0.682 1.893-1.169-0.036-1.406-1.308-2.124-1.942-0.737 0.797 0.517 1.272 0.694 1.905-0.45 2.398-0.39 4.742-2.788 6.313l-1.607 0.798c-0.438-1.205-0.164-3.032-0.457-4.292-0.95 1.546-1.692 2.898-3.086 4.206-1.631-0.536-2.581-2.459-2.94-4.054-0.682-1.857-0.292-4.079 1.175-5.424-0.499-0.974-2.21-0.749-2.453-2.136-2.563-1.669-3.981 2.922-5.637 0.535-0.536-2.227 0.103-4.998 1.717-6.66-0.359-0.912-1.552-0.675-2.258-1.199-1.613-1.37-3.939-2.818-3.823-5.291 4.413-1.667 9.691-0.444 12.899 2.91' fill='%23008830'/%3E %3Cpath d='m303.518 853.334c-0.103 2.02 1.364 0.547 2.453 1.771-0.852-0.335-1.473 1.473-2.307 0.438l-0.524 0.5c0.304 0.693 0.895 0.785 0.28 1.546-0.913 0.347-1.096-0.797-1.522-1.248-0.073-0.2 0.14-0.578-0.195-0.712-0.517 0.438-1.059 0.597-1.771 0.524-0.195-0.39-0.572-0.901-0.189-1.199 0.7-0.944 1.784 0.34 2.313-0.323 0.085-0.584-0.426-1.297 0.237-1.699 0.457 0.079 1.041-0.17 1.23 0.402M308.978 854.99 308.978 854.99 308.978 854.99 308.978 854.99 308.978 854.99c0.055 0.39-0.201 0.937 0.31 1.212 0.664-0.36 1.37-0.086 1.753 0.572-0.006 0.352 0.103 0.815-0.359 0.986l-1.035-0.194c0.073-0.201-0.256-0.329-0.384-0.524-0.457-0.14-0.724 0.231-1.065 0.456 0.256 0.39 0.846 0.603 0.706 1.102-0.609 0.608-0.907-0.524-1.577-0.238-0.457-0.176 0.164-1.126-0.554-1.412-0.852 0-0.286 1.399-1.376 0.852-0.39-0.439-0.773-1.029-0.353-1.522 0.457-0.305 1.23-0.226 1.619 0.17 0.664-0.736 0.73-3.579 2.319-1.461M302.179 857.924c0.444 0.64-0.097 1.51 0.469 2.222 0.889-1.661 1.747 0.359 2.806 0.201 0.323 0.396 0.11 0.944 0.17 1.394-1.309 0.347-2.885 0.761-4.042-0.286l-0.323 0.371c0.688 0.64 1.339 1.364 0.791 2.435-0.98 0.213-2.496 0.237-2.989-0.773-0.256-0.833 0.597-1.436-0.304-2.106-0.651 0.81-0.621 1.894-1.978 1.157-0.84-0.463-1.09-1.418-0.67-2.222 0.877-1.382 2.411 0.043 3.36-0.633 0.134-1.187-0.304-2.222 0.785-2.879 0.931-0.165 1.364 0.535 1.93 1.119' fill='%23f9d90f'/%3E %3Cpath d='m305.892 858.648c-0.438 2.021-1.96-0.103-2.672-0.189 0.95-1.686 1.546 0.548 2.672 0.189M310.634 860.846 310.634 860.846 310.634 860.846 310.634 860.846 310.634 860.846c-1.059 0.298-0.895-1.023-1.418-1.541l0.408-0.371c0.384 0.463 0.676 1.297 1.011 1.912' fill='%23fff'/%3E %3Cpath d='m309.197 860.444c0.304 0.7-0.688 1.261 0.158 1.771 0.268-0.225 0.597-0.536 0.737-0.664 0.724 0.214 1.564 0.342 2.07 1.059 0.542 1.486-0.962 1.449-1.814 1.863l-0.846-0.036c0.201-0.414-0.365-0.59-0.505-0.876-0.39-0.097-0.712 0.024-0.931 0.352 0.189 0.944 1.339 1.68 0.152 2.52-1.004-0.066-2.563 0.323-2.471-1.065-0.377-0.785 1.023-1.997-0.475-2.045-0.493 1.059-1.035 2.081-2.319 1.077l0.158-1.51c1.23 0.036 2.685 0.249 3.238-1.126 0.353-0.998-0.615-1.918 0.25-2.709 1.254-0.286 1.96 0.554 2.599 1.387' fill='%23f9d90f'/%3E %3Cpath d='m308.296 862.714c0.317 0.749-0.536 0.798-0.937 1.169-0.542 0.043-0.919-0.17-1.248-0.536-0.243-0.907 0.432-0.998 0.95-1.357 0.603-0.25 0.852 0.45 1.236 0.724' fill='%23000'/%3E %3Cpath d='m307.56 863.201c-0.134 0.177-0.323 0.122-0.524 0.17l-0.189-0.906c0.402 0.036 0.925 0.164 0.712 0.736' fill='%23fff'/%3E %3C/g%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 180 120'%3E %3Crect width='180' height='120' fill='%23000'/%3E %3Crect width='180' height='80' fill='%23fff'/%3E %3Crect width='180' height='40' fill='%23ce1126'/%3E %3Cg id='s' fill='%23007a3d'%3E %3Cg id='f'%3E %3Cg id='t'%3E %3Cpath d='M54,47v13h8' transform='rotate(18,54,47)' id='o'/%3E %3Cuse xlink:href='%23o' x='-108' transform='scale(-1,1)'/%3E %3C/g%3E %3Cuse xlink:href='%23t' transform='rotate(72,54,60)'/%3E %3C/g%3E %3Cuse xlink:href='%23t' transform='rotate(-72,54,60)'/%3E %3Cuse xlink:href='%23f' transform='rotate(144,54,60)'/%3E %3C/g%3E %3Cuse xlink:href='%23s' x='72'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 600 400'%3E %3Crect width='600' height='400' fill='%233e5eb9'/%3E %3Crect width='600' height='250' y='75' fill='%23ffd900'/%3E %3Crect width='600' height='200' y='100' fill='%23b10c0c'/%3E %3Cg fill='%23ffd900' stroke='%23000' stroke-width='1.008'%3E %3Cg id='e'%3E %3Cpath fill='%23fff' d='m492.85 154.28-24.285 8.571 24.285 8.571 24.285-8.571-24.285-8.571z'/%3E %3Crect width='357.13' height='5.714' x='122.85' y='160' rx='3.106' ry='2.857'/%3E %3Cpath d='m471.44 165.71c1.427 0 2.859-1.429 2.859-2.857 0-1.428-1.431-2.857-2.858-2.857'/%3E %3Cpath d='m468.58 165.71c1.427 0 2.859-1.429 2.859-2.857 0-1.428-1.431-2.857-2.858-2.857'/%3E %3Cpath d='m465.72 165.71c1.427 0 2.859-1.429 2.859-2.857 0-1.428-1.431-2.857-2.858-2.857'/%3E %3C/g%3E %3Cuse xlink:href='%23e' x='-23.27' y='17.15'/%3E %3Crect stroke-width='1.08' width='485.7' height='8.571' x='59.812' y='195.72' rx='4.224' ry='4.286'/%3E %3C/g%3E %3Cpath fill='%23fff' stroke='%23000' stroke-width='1.008' d='m442.85 200c-28.571 28.569-66.668 85.711-142.86 85.711-66.668 0-114.28-57.142-142.86-85.711 28.571-28.574 76.188-85.716 142.86-85.716 76.188 0 114.28 57.142 142.86 85.716z'/%3E %3Cpath fill='%23000' d='m290.02 144.1c7.601 8.549 1.254 11.996 9.3 12.557 8.485 0.623 3.675 9.034 10.812 9.326 4.99 0.218-0.498 20.151 4.305 26.729 4.893 6.857 8.991 2.009 9.077 6.963 0.085 5.124-13.317 4.607-13.552 20.39-0.393 9.096-11.31 9.678-11.831 15.531-0.648 5.505 21.507 8.595 21.211 13.523-0.304 4.913-23.922 4.144-24.95 9.747-0.527 5.033 32.446 9.158 35.098 23.713-4.92 1.609-18.919 3.124-29.499 3.132-66.657 0.048-114.28-57.147-142.85-85.716 28.571-28.574 76.188-85.716 142.86-85.716 0 0-19.789 18.082-9.971 29.815z'/%3E %3Cg stroke='%23FFF'%3E %3Cg id='c' stroke-width='6.927'%3E %3Cg id='b'%3E %3Cpath id='a' stroke-width='6.927' d='M213.933 192.377V169.52M227.783 169.52v22.857M241.643 169.52v22.857'/%3E %3Cuse xlink:href='%23a' y='38.1'/%3E %3C/g%3E %3Cuse xlink:href='%23b' x='41.56'/%3E %3C/g%3E %3C/g%3E %3Cg stroke='%23000'%3E %3Cuse xlink:href='%23c' x='104.76'/%3E %3C/g%3E %3Cg fill='%23a70000'%3E %3Cpath fill='%233d5da7' stroke='%23000' stroke-width='0.855' d='m511.35 196.6c-4.328 7.496 3.321-2.493 21.985 10.056 3.459 2.331 6.481 8.489 6.481 12.759-0.878-0.587-1.53-1.894-2.497-2.743-1.354 1.357 1.293 7.577 1.68 10.517-2.918-1.633-2.637-2.406-3.606-4.413 0.193 2.426-0.501 9.107 0.66 11.68-2.3-0.657-2.147-2.508-3.348-2.88 0.817 2.912-0.712 6.081-0.306 9.355-1.344-1.33-2.776-2.372-3.4-2.909-0.105 1.559-2.585 5.656-2.641 7.13-1.14-0.689-1.45-1.763-1.64-2.486-1.417 1.781-6.454 8.358-6.777 10.364-3.881-3.428-13.823-11.775-15.117-16.206-1.144 2.515-2.8 3.364-6.073 5.2-1.293-7.022-6.13-14.915-3.543-20.934-1.833 1.087-3.342 2.174-5.174 3.511 1.736-10.17 10.587-22.095 23.319-28.001z'/%3E %3Cpath d='m495.21 233.72c1.797-3.592 3.452-4.731 4.613-7.044 2.051-4.065 2.344-7.299 4.131-6.825 1.787 0.474 1.785 2.139-0.53 6.136-2.315 3.997-3.416 4.851-8.214 7.733z'/%3E %3Cpath d='m507.36 242.28c-0.231-2.735 0.562-3.877 0.418-5.638-0.247-3.099-1.514-5.226 0.134-5.377 1.648-0.151 2.418 0.906 2.423 4.029 0.005 3.123-0.478 3.943-2.974 6.987z'/%3E %3Cpath d='m516.58 247.64c-0.72-3.818-0.181-5.511-0.642-7.971-0.802-4.328-2.389-7.177-0.862-7.573 1.527-0.396 2.449 1.004 3.027 5.393 0.578 4.389 0.273 5.595-1.523 10.151z'/%3E %3Cpath d='m526.17 220.89c-2.252-1.709-3.566-1.824-5.018-2.922-2.558-1.927-3.852-3.99-4.675-2.966-0.823 1.024-0.239 2.144 2.442 3.922 2.68 1.778 3.588 1.918 7.252 1.966z'/%3E %3Cpath d='m524.58 233.56c-1.187-2.465-2.436-3.09-3.204-4.676-1.357-2.787-1.359-5.198-2.831-4.58-1.472 0.618-1.59 1.88-0.016 4.578 1.574 2.697 2.398 3.186 6.051 4.678z'/%3E %3Cpath fill='%233d5da7' stroke='%23000' stroke-width='1.067' d='m80.783 203.82c-0.242-2.183 0.225-2.444-1.118-4.09 1.955 0.818 2.029 2.992 4.406 1.449 0.873-0.452 1.254-0.466 0.193-2.891 2.479 0.115 10.596 2.899 11.896 2.963 3.413 0.157 9.644-3.586 13.969 1.016 4.151 4.196 2.765 8.551 2.765 14.362-1.668-0.799-0.864-1.193-2.634-3.271 1.327 5.079-0.071 14.237-0.071 19.624-0.681-1.299-0.581-0.735-1.247-2.08-1.77 4.917-3.891 5.929-3.891 11.74-0.639-2.279-0.022-1.797-0.733-2.996-1.72 3.733-13.26 6.923-8.813 10.686-4.014-2.353-5.774-2.106-7.594-4.223-0.784 0.506-1.407 1.464-2.136 2.777-7.057-3.247-4.534-10.25-10.062-14.928-0.957 1.961-0.521 1.677-1.555 4.869-1.119-4.434-1.425-7.251-2.684-10.511-1.086 1.807-0.989 1.114-2.961 3.845-0.816-5.401-2.144-6.676-1.619-10.25-2.096 1.479-0.724 0.88-2.819 2.7 1.985-13.84 10.558-24.067 16.71-20.792z'/%3E %3Cpath d='m72.101 226.41c1.818-4.456 3.457-5.855 4.632-8.724 2.075-5.042 2.413-9.073 4.156-8.458 1.743 0.615 1.715 2.691-0.617 7.645-2.332 4.955-3.423 6.005-8.171 9.536z'/%3E %3Cpath d='m78.985 237.56c0.729-3.995 1.879-5.45 2.352-8.023 0.839-4.524 0.371-7.893 1.991-7.715 1.62 0.177 1.986 1.885 0.908 6.385-1.078 4.501-1.822 5.566-5.252 9.353z'/%3E %3Cpath d='m87.219 245.31c0.205-3.873 1.113-5.385 1.249-7.88 0.246-4.388-0.599-7.529 0.946-7.547 1.545-0.018 2.095 1.56 1.622 5.953-0.473 4.393-1.045 5.489-3.817 9.474z'/%3E %3Cpath d='m104.9 219.98c-3.381-3.368-5.425-3.997-7.606-6.163-3.842-3.804-5.698-7.376-7.066-6.11s-0.545 3.164 3.5 6.784c4.045 3.62 5.452 4.148 11.172 5.489z'/%3E %3Cpath d='m102.84 233c-2.202-3.382-3.818-4.258-5.24-6.434-2.507-3.824-3.369-7.11-4.79-6.296-1.422 0.814-1.104 2.531 1.613 6.238 2.717 3.706 3.81 4.388 8.417 6.493z'/%3E %3Cpath fill='%233d5da7' stroke='%23000' stroke-width='0.826' d='m253.8 129.5c-3.958 7.655 6.93-2.546 23.998 10.269 3.163 2.381 7.697 11.787 7.697 16.147-3.634-0.773-10.069-4.36-10.069-4.36s7.552 7.564 7.552 16.284c-2.668-1.668-4.003-1.418-4.89-3.466 0 2.823 2.373 4.622 2.373 8.982-1.926-1.537-3.557-2.561-5.186-3.46 2.517 4.36-4.587 12.818-1.032 15.641-6.218-0.899-12.58-4.872-15.097-9.232-1.334 0.899-1.479 2.311-1.531 3.816 0.196 0.163-9.465-7.171-8.577-9.988-1.296 1.818-1.478 2.817-1.774 4.866-3.549-3.5-6.802-7-7.986-11.525-1.577 2.049-1.676 2.049-3.253 4.098-1.183-7.171-1.183-6.915 1.183-13.061-1.676 1.11-3.056 2.22-4.732 3.586 1.587-10.385 9.682-22.563 21.325-28.594z'/%3E %3Cpath d='m244.04 166.9c0.633-5.275 2.012-7.262 2.424-10.659 0.735-5.974-0.137-10.341 1.98-10.23 2.117 0.11 2.727 2.314 1.68 8.276-1.046 5.961-1.929 7.409-6.084 12.614z'/%3E %3Cpath d='m255.09 176.56c-0.429-4.45 0.393-6.345 0.12-9.212-0.47-5.044-2.028-8.461-0.183-8.775 1.845-0.314 2.778 1.378 2.977 6.471 0.199 5.093-0.294 6.45-2.915 11.516z'/%3E %3Cpath d='m272.34 184.44c-1.876-3.851-3.488-4.999-4.699-7.478-2.139-4.356-2.586-7.913-4.236-7.269-1.65 0.645-1.559 2.485 0.824 6.749 2.383 4.264 3.46 5.134 8.111 7.998z'/%3E %3Cpath d='m278.31 149.95c-4.778-2.515-7.232-2.547-10.311-4.163-5.422-2.834-8.578-6.035-9.698-4.273-1.121 1.762 0.375 3.514 5.965 6.09 5.59 2.576 7.307 2.698 14.045 2.346z'/%3E %3Cpath d='m280.06 164.36c-3.479-2.894-5.536-3.32-7.78-5.182-3.953-3.267-5.92-6.476-7.241-5.175-1.32 1.301-0.438 3.019 3.711 6.097 4.149 3.078 5.568 3.46 11.31 4.26z'/%3E %3C/g%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1200 600'%3E %3CclipPath id='c'%3E %3Cpath d='M0,0V150H700V300H600zM600,0H300V350H0V300z'/%3E %3C/clipPath%3E %3Crect width='1200' height='600' fill='%2300247d'/%3E %3Cpath d='M0,0 600,300M600,0 0,300' stroke='%23fff' stroke-width='60'/%3E %3Cpath d='M0,0 600,300M600,0 0,300' stroke='%23cf142b' stroke-width='40' clip-path='url(%23c)'/%3E %3Cpath d='M300,0V350M0,150H700' stroke='%23fff' stroke-width='100'/%3E %3Cpath d='M300,0V350M0,150H700' stroke='%23cf142b' stroke-width='60'/%3E %3Cpath d='M0,300H600V0H1200V600H0z' fill='%2300247d'/%3E %3Cg%3E %3Cpath fill='%23fff' d='m1008.94,170.989v85.1747c0,69.9277-27.4673,133.94-108.953,172.848-81.488-38.909-108.956-102.921-108.956-172.849v-85.1747h217.907z'/%3E %3Cpath fill='%23fdc300' d='m1001.61,179.669v79.444c0,65.2229-25.6193,124.928-101.623,161.218-76.0036-36.2906-101.623-95.9956-101.623-161.219v-79.444h203.246z'/%3E %3Cg fill='%23ff9e3d' stroke='%23000' stroke-width='0.2604'%3E %3Cpath d='m852.667,214.487c-1.47074-1.10339-3.06648-1.77759-5.27051-1.83885,0.48747-5.39443-3.43312-7.72372-6.25377-8.7046-2.8165-0.98088-3.79977-2.08427-4.28724-4.29105-0.49163-2.20678-1.96238-3.55518-4.53722-4.29063-2.57484-0.73587-4.78303-3.31017-5.76214-4.53648-0.9791-1.22589-1.34991-0.98088-2.0832,1.10339-0.73746,2.08427-3.67894,6.00738-0.98327,6.13031-1.95822,1.59341-3.06231,3.43267-1.83739,5.88446-1.34992,1.10339-2.32902,2.69722-0.49164,3.31017,1.84156,0.61294,2.32903,1.10338,2.45402,1.59383-1.65407,0-2.08321,3.31016,1.83738,4.04562-0.85828,0.1225-1.22492,2.81972,0.37081,2.81972-2.20819,0-4.04974,3.31058-6.86624,3.31058-2.82065,0-4.2914,0.61253-4.41222,1.83885-0.12499,1.22589-1.59574,2.6968-2.32902,3.31016,2.0832,0.24501,3.42895,0,4.53305-0.85837,1.1041-0.85838,2.94148-1.10339,4.17057-0.12251,1.22493,0.98088,3.79977,1.47091,5.02469,1.22589-2.69567,1.83926-4.65804,4.29105-4.90386,6.62034-0.24582,2.3297-1.83739,5.0265-3.67894,5.76237-1.83739,0.73545-4.28723,2.69722-5.14551,5.0265,2.32902,5.76196,5.63298,7.18536,8.94527,8.70419,5.88714,2.69764,9.56191,4.65898,12.0159,7.3562,2.44985,2.69722,3.43312,0.73546,7.1079,5.39402,3.67893,4.65899,7.11205,13.4861,10.7868,14.9574,3.67893,1.47091,8.33698,0.49044,11.0326-4.16854,2.69983-4.65857,4.41639-51.7364-9.43692-59.583z'/%3E %3Cpath fill='%23ff927f' d='m858.921,194.871c-3.43312,3.6781-7.84951,7.3562-7.11206,13.9765,0.73746,6.62033,1.47074,17.4092-4.65804,21.0869-6.12879,3.6781-9.07027,12.9956-1.71656,18.3897,7.35371,5.39486,7.59952,12.0152,8.82445,18.1451,1.22909,6.12989,4.41639,11.0335,9.32025,6.86535,4.8997,0.73545,7.59953-1.2259,7.59953-5.14901,0-3.92312,0.24582-6.12989,3.92059-7.35621,3.67894-1.22589,4.65805-2.4522,6.37461-5.76195,1.71656-3.31017,2.69566-4.78149,1.71656-6.74326-0.97911-1.96135-1.34992-6.00697-0.61247-8.94961,0.73746-2.94224-0.9791-4.53607-1.96237-6.37491-0.97911-1.83884-1.34575-3.43267-0.85828-5.88488,0.49163-2.4522-0.73329-4.04562-2.44985-5.27193-1.71656-1.22589-2.45402-2.45179-2.08321-4.41355,0.36665-1.96135-1.22909-3.18725-3.06647-4.65857-1.83739-1.47132-3.1873-3.43267-3.1873-6.3749,0-2.94265-5.63715-9.80841-10.0494-11.5248z'/%3E %3Cpath fill='%23ff9ee1' d='m860.267,274.928c8.21199-2.08428,7.4787-15.57,6.25378-21.2094-1.22909-5.63987-4.3789-13.7174-1.96238-20.1064,3.43312-9.07212-4.17058-17.6542-2.2082-21.0869,1.96238-3.43309,1.71656-5.27193,1.47075-6.37532-0.24166-1.10339-2.08321-1.96135-2.20403,0.36793-0.125,2.32929-0.73746,3.18725-2.2082,4.65857s-1.1041,4.65857,0,8.21416c1.1041,3.55518,3.43312,8.95003-0.24582,16.0604-3.67477,7.11078-2.16236,10.2793-0.73329,13.6086,2.20403,5.14901,7.47871,23.0487,1.83739,25.8684z'/%3E %3Cpath d='m823.49,198.059c0.92077,0,2.69983-0.36835,2.69983,0.85796'/%3E %3Cpath d='m821.652,203.943c1.1041-0.79712,3.06648,0.12251,5.02469-1.04214'/%3E %3Cpath d='m823.615,208.847c1.47074,0,3.43312-0.0613,5.2705-1.53258'/%3E %3Cpath d='m825.452,212.893c1.34992,0,3.86226-0.85796,4.47473-2.63555'/%3E %3Cpath d='m825.823,215.713c2.63317-0.12251,6.12879,0.85838,6.61626-0.0613'/%3E %3Cpath d='m825.944,224.417c1.83739-1.71633,6.19128-2.88097,7.17039-4.65856'/%3E %3Cpath d='m830.602,197.078c3.06231,0.9813,1.79573,2.87556,3.30813,4.04603,2.69983,2.08428,0.24582,4.41356,2.45402,5.02651,2.20403,0.61294,2.16653,0.98546,1.59156,3.43267-0.67495,2.88139,2.08321,3.00348,1.1041,4.904'/%3E %3Cpath d='m847.397,212.648c-1.22492,0-4.84136,0.12251-6.3746,3.37142'/%3E %3Cpath d='m821.223,248.018c1.41241,0.24543,2.11653-0.55753,2.51234-1.3484,0.42914-0.85838,0.61247-1.47133,1.89989-1.53258,1.28742-0.0617,3.24979-0.42919,3.67893-1.41007,0.42914-0.98047,1.96238-0.0613,3.2498-2.63597,1.28742-2.57429,2.1457-5.63945,5.57466-6.74284'/%3E %3C/g%3E %3Cg stroke='%23000' stroke-width='0.2604'%3E %3Cg fill='%2300a728'%3E %3Cpath d='m918.475,301.589c1.38741,2.01594-0.05,4.19521,2.30402,5.06692,2.75816,1.02089,0.34998,4.64857,3.60394,5.92697,2.88316,1.13422,0.0208,4.60231,3.13731,6.15989,2.78732,1.39465-0.46664,4.64898,3.25396,6.50866,3.71644,1.85926-0.69995,6.04322,2.09154,7.67039,2.78733,1.62716-0.92911,5.81112,2.32485,7.43829,3.25397,1.62674-1.39574,4.88107,1.6249,7.20577,3.02065,2.32429-0.69579,5.81071,2.32486,7.9029,3.02064,2.09219-1.85405,4.88566,1.16243,7.90332,2.32485,2.32428-0.83745,4.60064,0.92911,8.1354,1.16242,2.32429-1.16243,11.6222-7.67036,10.6922-2.32486,3.95186-11.3868,7.43829-14.6408,6.27615-3.25396,2.32428-13.7116,5.57861-19.0613,0.46502-5.34133,5.11359-15.8032,1.85926-19.0572-0.46502-3.25396,1.16214-12.3159-2.32429-14.6408-6.27615-6.50793,0.93004-8.83279-8.36792-7.67036-10.6922,1.76656-3.53476-1.39575-5.81112,0.92911-8.1354,3.01648-3.01766-1.85822-5.81113,1.16243-7.90332,3.02064-2.09219-0.69579-5.57861,2.32485-7.9029,3.02065-2.3247-1.62906-5.57903,1.6249-7.20577,3.25397-1.62717-0.46247-5.81113,2.32486-7.43829,2.79149-1.62717-1.6249-5.81113,2.09153-7.67039,3.72061-1.85968,0.46664-5.11401,3.25397-6.50866,3.11647-1.55758,0.25415-5.02567,3.1373-6.15989,3.25397-1.2784,0.84578-4.90608,3.60395-5.92697,2.39151-0.88546,0.86661-3.12057,2.37485-5.16317,6.9204,2.72263,28.3441,4.67648,37.156,0.0962z'/%3E %3Cpath d='m887.544,302.239c-2.55817,2.5568,0.46664,4.41647-2.09153,7.43787-2.55818,3.02224-0.23332,4.64899-2.32486,7.43829-2.09154,2.78931,0.92911,4.18438-1.39575,7.20578-2.32069,3.02182,0.46664,4.8815-2.09153,7.43829-2.55401,2.5568,0.46663,4.8815-2.09154,7.67081-2.55401,2.7893,0.46664,4.64856-2.09154,7.20536-2.55401,2.55721,0.46664,5.34652-2.09153,7.90289-2.55401,2.55722,0.46663,5.81113-2.32486,8.83337-2.78733,3.0214,0.46664,5.34568-1.85822,7.67038-2.32485,2.32428-0.23332,4.64857-1.85822,6.27573-1.62906,1.62717-1.85821,3.89395-1.16242,4.8815'/%3E %3Cpath d='m892.423,303.169c-2.32069,3.02182,1.16242,4.41647-0.92911,6.97327-2.09154,2.55721,0.92911,3.48684-0.69579,6.50866s1.16242,3.71893-0.92911,6.74075c-2.09154,3.02182,1.16243,5.34611-1.16243,8.36792-2.32486,3.02182,1.16243,4.64857-0.92911,7.67081-2.09154,3.0214,0.92911,4.64856-0.92911,6.97326-1.86238,2.32429,1.39158,4.64857-0.92911,7.43788-2.32485,2.78972,0.92911,4.88149-0.93327,7.43829-1.85822,2.55679,0.69995,5.3461-0.92911,7.43787-1.6249,2.09219,1.16243,5.11401-1.16243,7.90331-2.32485,2.78931,0.46664,4.64899-0.92911,6.50866-1.39574,1.85926-2.49568,4.59065-1.16243,5.34611'/%3E %3Cpath d='m899.86,305.958c-1.15826,4.85983,1.62907,9.18004,0,13.2298-1.62489,4.0502,1.16243,5.67028,0.23332,8.91003-0.92911,3.24016,1.16243,5.67028-0.23332,9.18004-1.39158,3.51018,1.86239,6.2099,0,10.8001-1.85821,4.59023,1.19993,5.73279,0,10.2601-1.39158,5.26568,2.32486,8.05499,0,11.7743-2.32068,3.71894,2.09571,4.64898,0.23332,8.83253-1.85821,4.18437,1.16243,5.81112-0.23332,9.9955'/%3E %3Cpath d='m912.18,302.239c2.55818,2.5568-0.46663,4.41647,2.09154,7.43787,2.55817,3.02224,0.23332,4.64899,2.32486,7.43829,2.09153,2.78931-0.92911,4.18438,1.39574,7.20578,2.32069,3.02182-0.46664,4.8815,2.09154,7.43829,2.55401,2.5568-0.46664,4.8815,2.09154,7.67081,2.554,2.7893-0.46664,4.64856,2.09153,7.20536,2.55401,2.55721-0.46664,5.34652,2.09154,7.90289,2.55401,2.55722-0.46664,5.81113,2.32485,8.83337,2.78733,3.0214-0.46663,5.34568,1.85822,7.67038,2.32486,2.32428,0.23332,4.64857,1.85822,6.27573,1.62907,1.62717,1.86239,3.89395,1.16243,4.8815'/%3E %3Cpath d='m907.301,303.169c2.32069,3.02182-1.16243,4.41647,0.92911,6.97327,2.09153,2.55721-0.92911,3.48684,0.69579,6.50866,1.62906,3.02182-1.16243,3.71893,0.92911,6.74075,2.09153,3.02182-1.16243,5.34611,1.16242,8.36792,2.32486,3.02182-1.16242,4.64857,0.92911,7.67081,2.09154,3.0214-0.92911,4.64856,0.92911,6.97326,1.86239,2.32429-1.39158,4.64857,0.93328,7.43788,2.32069,2.78972-0.93328,4.88149,0.92911,7.43829,1.85822,2.55679-0.69996,5.3461,0.92911,7.43787,1.6249,2.09219-1.16243,5.11401,1.16242,7.90331,2.32486,2.78931-0.46663,4.64899,0.92911,6.50866,1.39575,1.85926,2.49985,4.59065,1.16243,5.34611'/%3E %3C/g%3E %3Cg fill='%23fcc300'%3E %3Cpath d='m884.115,313.745c0.004,1.0438-0.0208,2.08344-0.98744,3.37058-2.09154,2.78931,0.92911,4.18438-1.39575,7.20578-2.32069,3.02182,0.46664,4.8815-2.09153,7.43829-2.55401,2.5568,0.46663,4.8815-2.09154,7.67081-2.55401,2.7893,0.46664,4.64856-2.09154,7.20536-2.55401,2.55721,0.46664,5.34652-2.09153,7.90289-2.55401,2.55722,0.46663,5.81113-2.32486,8.83337-2.78733,3.0214,0.46664,5.34568-1.85822,7.67038-2.32485,2.32428-0.23332,4.64857-1.85822,6.27573,2.78733-2.09177,2.78733-5.34568,4.87887-6.97285,2.09153-1.62758-0.69579-3.95186,0.46664-5.114,1.16242-1.16215,0.23331-6.04364,2.32485-8.36793,2.09154-2.3247,0.23332-6.97326,2.09154-8.60043,1.85822-1.62716,0.46247-6.50824,2.78733-8.13541,2.32485-1.62716,0-5.57861,1.85821-7.6708,1.86239-2.09177,0-5.3461,1.86239-7.90289,1.85822-2.5568,0.0833-4.87817,1.39158-6.97327,0.58329-0.92963,0.58329-7.67039-0.87078-3.83561z'/%3E %3Cpath d='m890.798,316.651c-1.6249,3.02182,1.16242,3.71893-0.92911,6.74075-2.09154,3.02182,1.16243,5.34611-1.16243,8.36792-2.32486,3.02182,1.16243,4.64857-0.92911,7.67081-2.09154,3.0214,0.92911,4.64856-0.92911,6.97326-1.86238,2.32429,1.39158,4.64857-0.92911,7.43788-2.32485,2.78972,0.92911,4.88149-0.93327,7.43829-1.85822,2.55679,0.69995,5.3461-0.92911,7.43787-1.6249,2.09219,1.16243,5.11401-1.16243,7.90331-2.32485,2.78931,0.46664,4.64899-0.92911,6.50866,2.7915-0.93004,1.74573-4.76523,2.7915-5.57861,1.04576-0.81379-0.34998-6.15989,1.27492-7.55455,1.62906-1.39465-1.04577-5.69695,0.46663-7.55454,2.55818-3.13766,0.34998-5.22985,1.85822-7.67039,1.51241-2.44095-0.57496-5.57403,0.5833-7.20578,1.97488-2.7893-0.87495-5.3036,0.57913-7.32203,2.09154-2.90556-0.40414-5.29818,1.04577-7.20578,2.20819-2.90556-0.23332-5.81112,0.69995-7.32203,0.92911-1.51091,2.43735-8.01916-0.46663-9.06504z'/%3E %3Cpath d='m899.86,319.188c-1.62489,4.0502,1.16243,5.67028,0.23332,8.91003-0.92911,3.24016,1.16243,5.67028-0.23332,9.18004-1.39158,3.51018,1.86239,6.2099,0,10.8001-1.85821,4.59023,1.19993,5.73279,0,10.2601-1.39158,5.26568,2.32486,8.05499,0,11.7743-2.32068,3.71894,2.66234,4.95025,0.23332,8.83253-1.16242,1.85967,0.11666,6.62491,1.97488,0.93004,1.86238-5.69487-1.39158-6.39198,0.23332-8.71668,1.62906-2.3247-0.57913-8.48418,0.11666-11.7385,0.69996-3.25433-1.6249-7.6708-0.11666-11.1572,1.51241-3.48642-2.32486-7.20536-0.81245-10.2276,1.51241-3.02141-0.69579-6.74076,0.69579-9.1813,1.39575-2.44054-1.04577-5.69487-0.46247-7.08952,0.57913-1.39466-0.5833-6.547-1.86239-2.57638z'/%3E %3C/g%3E %3Cpath fill='%23ef072d' d='m917.292,304.331c0-26.2659-3.71644-35.3309-17.4323-35.3309-13.7116,0-17.4281,9.06504-17.4281,35.3309h34.8603z'/%3E %3Cpath fill='%23000' d='m882.432,304.331c0-26.2659,3.71644-35.3309,17.4281-35.3309-6.27461,0-10.1077,4.88066-11.1535,8.13499-1.04577,3.25433-0.46664,3.02182,0.92911,1.74342,1.39575-1.27839,0.69579,1.51091-0.46247,3.02182-1.16243,1.51091-2.32486,5.81113-0.69996,4.41647,1.62907-1.39465,2.90399,0.23252,1.16243,2.67306-1.74156,2.44053-3.25397,8.1354-1.51241,6.15989,1.74573-1.97593,2.09154,1.2784,1.04994,2.90556-1.04994,1.62717-0.93328,3.0214,0,2.32428,0.92911-0.69711,0.81245,2.67305-0.11666,3.95145h-6.62459z'/%3E %3Cpath fill='%23000' d='m914.622,302.82c0-20.571-2.55401-26.7309-7.66619-28.8227-2.89566-1.18631-2.97898-0.92963-1.59574,0.92963,1.38325,1.85926,1.17076,4.53272-0.10832,2.67305-1.27492-1.85926-1.6999-2.20803-2.2332-1.39424-0.5333,0.81337,1.48741,4.64857,2.97898,8.13541,1.19993,2.80431,0.42498,4.18354-1.38324,1.39423-1.80823-2.7893-1.80823-0.26251-0.22082,2.09219,2.03737,3.02182,1.97487,12.2031,1.97487,16.0383l8.25366-1.04589z'/%3E %3Cpath fill='%23ef072d' d='m899.86,308.166c5.46217,0,11.441-0.97338,15.4574-2.53304,4.76637-1.85051,5.02052-3.47643,3.37062-5.55236-1.16243-1.46133-3.7206-0.5842-6.15795,0.4871-2.44151,1.07131-9.18276,1.75342-12.67,1.75342-3.48311,0-10.2244-0.68211-12.6659-1.75342-2.43734-1.0713-4.99552-1.94843-6.15795-0.4871-1.64989,2.07593-1.39574,3.70185,3.37063,5.55236,4.01225,1.55966,9.99521,2.53304,15.4532,2.53304z'/%3E %3C/g%3E %3Cg fill='%23b95a1e' stroke='%23000' stroke-width='0.2976'%3E %3Cg%3E %3Cpath d='m952.855,273.393s3.57764,6.17649,6.20159,10.6787c2.62361,4.5016,4.74983,5.52721,6.64995,4.19194,1.89978-1.33586,0.28699-5.00496-1.23506-6.74599-1.52239-1.74163-9.89229-9.91172-9.89229-9.91172l-1.72419,1.78709z'/%3E %3Cpath d='m952.005,273.868s1.41757,7.08152,2.46606,12.2491c1.04835,5.16688,2.72803,6.88205,4.94181,6.29214,2.21365-0.59058,1.85465-4.61693,0.97094-6.79384-0.88385-2.1776-6.18786-12.8251-6.18786-12.8251l-2.19095,1.07774z'/%3E %3Cpath d='m950.499,274.091s-0.008,7.23757,0,12.5221c0.008,5.28383,1.31323,7.32945,3.59492,7.23723,2.28169-0.0929,2.72346-4.11011,2.28772-6.43309-0.43573-2.32368-3.52721-13.9007-3.52721-13.9007l-2.35543,0.57443z'/%3E %3Cpath d='m948.148,273.393s-3.57764,6.17649-6.20159,10.6787c-2.62361,4.5016-4.74983,5.52721-6.64995,4.19194-1.89978-1.33586-0.28699-5.00496,1.23506-6.74599,1.52239-1.74163,9.89229-9.91172,9.89229-9.91172l1.72419,1.78709z'/%3E %3Cpath d='m948.999,273.868s-1.41757,7.08152-2.46606,12.2491c-1.04835,5.16688-2.72803,6.88205-4.94181,6.29214-2.21365-0.59058-1.85465-4.61693-0.97094-6.79384,0.88385-2.1776,6.18786-12.8251,6.18786-12.8251l2.19095,1.07774z'/%3E %3Cpath d='m950.504,274.091s0.008,7.23757,0,12.5221c-0.008,5.28383-1.31323,7.32945-3.59492,7.23723-2.28169-0.0929-2.72346-4.11011-2.28772-6.43309,0.43573-2.32368,3.52721-13.9007,3.52721-13.9007l2.35543,0.57443z'/%3E %3C/g%3E %3Cg%3E %3Cpath d='m954.464,218.4s5.82657-6.18876,16.0232-12.3775c10.196-6.18874,17.5728-10.9492,18.936-9.90202,0,1.23779-8.73994,7.42652-16.023,12.3775-7.28309,4.95099-16.023,12.3775-16.023,12.3775l-2.91328-2.4755z'/%3E %3Cpath d='m955.14,223.351s5.75948-3.63469,16.8043-8.66425c10.8719-4.46556,26.219-3.71326,26.219-2.4755-1.45611,1.23774-14.566,1.23774-23.306,4.95099-8.34258,3.54434-16.804,8.66426-16.804,8.66426l-2.91328-2.4755z'/%3E %3Cpath d='m955.202,231.877s5.07089-2.45,16.8043-6.18876c11.6522-3.71325,27.1218-1.23775,27.1218,0-1.45611,1.23774-14.0127,0.48543-22.7526,2.47551-9.04357,1.93924-18.2601,6.18875-18.2601,6.18875l-2.91328-2.4755z'/%3E %3Cpath d='m955.756,240.535s5.84408-4.95866,18.2916-6.18876c12.5245-1.23774,22.7214,6.18876,22.7214,7.42648-1.4561,1.23778-13.1099-5.44762-21.8498-4.49146-9.25941,0.95395-16.2499,5.72924-16.2499,5.72924l-2.91328-2.4755z'/%3E %3Cpath d='m952.855,213.304s9.38996-6.18876,9.38996-11.1398c0-4.951-4.13967-9.90199-5.31344-12.3775,2.34754,0,7.66089,7.42649,7.66089,12.3775,0,5.41052-8.82413,13.6152-8.82413,13.6152l-2.91328-2.4755z'/%3E %3Cpath d='m952.855,213.304s-1.17377-3.71325-1.17377-11.1398c0-8.66428,5.17991-14.175,7.04243-16.0908,0.48494,1.91582-4.6949,8.66427-4.6949,16.0908,0,5.41053,1.73952,13.6152,1.73952,13.6152l-2.91328-2.4755z'/%3E %3Cpath d='m946.539,218.4s-5.82657-6.18876-16.0232-12.3775c-10.196-6.18874-17.5728-10.9492-18.936-9.90202,0,1.23779,8.73994,7.42652,16.023,12.3775,7.28309,4.95099,16.023,12.3775,16.023,12.3775l2.91328-2.4755z'/%3E %3Cpath d='m945.863,223.351s-5.75948-3.63469-16.8043-8.66425c-10.8719-4.46556-26.219-3.71326-26.219-2.4755,1.45611,1.23774,14.566,1.23774,23.306,4.95099,8.34258,3.54434,16.804,8.66426,16.804,8.66426l2.91328-2.4755z'/%3E %3Cpath d='m945.801,231.877s-5.07089-2.45-16.8043-6.18876c-11.6522-3.71325-27.1218-1.23775-27.1218,0,1.45611,1.23774,14.0127,0.48543,22.7526,2.47551,9.04357,1.93924,18.2601,6.18875,18.2601,6.18875l2.91328-2.4755z'/%3E %3Cpath d='m945.247,240.535s-5.84408-4.95866-18.2916-6.18876c-12.5245-1.23774-22.7214,6.18876-22.7214,7.42648,1.4561,1.23778,13.1099-5.44762,21.8498-4.49146,9.25941,0.95395,16.2499,5.72924,16.2499,5.72924l2.91328-2.4755z'/%3E %3Cpath d='m948.148,213.304s-9.38996-6.18876-9.38996-11.1398c0-4.951,4.13967-9.90199,5.31344-12.3775-2.34754,0-7.66089,7.42649-7.66089,12.3775,0,5.41052,8.82413,13.6152,8.82413,13.6152l2.91328-2.4755z'/%3E %3Cpath d='m948.148,213.304s1.17377-3.71325,1.17377-11.1398c0-8.66428-5.17991-14.175-7.04243-16.0908-0.48494,1.91582,4.6949,8.66427,4.6949,16.0908,0,5.41053-1.73952,13.6152-1.73952,13.6152l2.91328-2.4755z'/%3E %3C/g%3E %3Cg stroke='%23fdc301' stroke-width='0.7501'%3E %3Cpath d='m981.025,302.422c-3.64812-8.54578-4.69495-23.5172-4.69495-25.9927,0-6.97118,2.18284-40.8779,2.34748-54.461,0.16463-13.5831-8.21614-21.0417-16.4324-21.0417-7.04243,0-11.7374,4.95102-11.7374,12.3775h3.52125c0-4.951,3.52125-8.66425,8.2162-8.66425,7.04244,0,12.4548,5.85035,12.9112,17.3285,0.50384,13.2662-1.41221,47.7134-1.17377,56.9365,0.23844,9.22374,3.39431,17.4468,7.04243,23.5172z'/%3E %3Cpath d='m919.979,302.422c3.64812-8.54578,4.69495-23.5172,4.69495-25.9927,0-6.97118-2.18284-40.8779-2.34748-54.461-0.16463-13.5831,8.21614-21.0417,16.4324-21.0417,7.04243,0,11.7374,4.95102,11.7374,12.3775h-3.52125c0-4.951-3.52125-8.66425-8.2162-8.66425-7.04244,0-12.4548,5.85035-12.9112,17.3285-0.50384,13.2662,1.41221,47.7134,1.17377,56.9365-0.23844,9.22374-3.39431,17.4468-7.04243,23.5172z'/%3E %3C/g%3E %3Cg%3E %3Cpath d='m950.507,273.954c6.56043-0.0974,7.28391-2.47542,7.28391-2.47542s1.45666-4.95099,0.72837-6.18884c-0.72841-1.23772-8.01228-1.23772-8.01228-1.23772v9.90198z'/%3E %3Cpath d='m950.507,269.003c7.04244,0,8.21621-2.47542,8.21621-2.47542s2.34728-4.95099,1.1737-6.18884c-1.17377-1.23772-9.38991-1.23772-9.38991-1.23772v9.90198z'/%3E %3Cpath d='m950.507,264.052c5.86873,0,9.38998-2.47549,9.38998-2.47549s2.34728-4.95099,1.1737-6.18884c-1.17377-1.23772-10.5637-1.23765-10.5637-1.23765v9.90198z'/%3E %3Cpath d='m950.507,257.863c10.5716-0.0974,10.5637-3.17937,10.5637-3.17937s2.34728-4.95099,1.17371-6.18885c-1.17377-1.23771-11.7374-0.53376-11.7374-0.53376v9.90198z'/%3E %3Cpath d='m950.507,252.912c10.5716-0.0974,11.7374-2.47542,11.7374-2.47542s2.34728-4.95099,1.17371-6.18884c-1.17378-1.23772-12.9111-1.23772-12.9111-1.23772v9.90198z'/%3E %3Cpath d='m950.507,246.724c10.5716-0.0974,12.9112-2.47549,12.9112-2.47549s2.34728-4.95099,1.17371-6.18877c-1.17377-1.23772-14.0849-1.23772-14.0849-1.23772v9.90198z'/%3E %3Cpath d='m950.507,240.535c10.5716-0.0974,14.0849-2.47549,14.0849-2.47549s1.17357-4.95099,0-6.18877c-1.17377-1.23772-14.0849-1.23772-14.0849-1.23772v9.90198z'/%3E %3Cpath d='m950.507,234.346c10.5716-0.0974,14.0849-2.47549,14.0849-2.47549s0-4.95099-1.17371-6.18877c-1.17377-1.23772-12.9112-1.23772-12.9112-1.23772v9.90198z'/%3E %3Cpath d='m950.507,228.157c10.5716-0.0974,12.9111-2.47549,12.9111-2.47549s0-4.95099-1.17371-6.18877c-1.17377-1.23772-11.7374-1.23772-11.7374-1.23772v9.90198z'/%3E %3Cpath d='m950.507,212.631c8.22416,0.01,11.7773,7.15331,11.7573,7.00764l-2.36742,2.32976c-1.25778,1.23778-9.38991,1.23778-9.28894,1.23143l-0.10097-10.5688z'/%3E %3Cpath d='m950.496,273.954c-6.56043-0.0974-7.28391-2.47542-7.28391-2.47542s-1.45666-4.95099-0.72837-6.18884c0.72841-1.23772,8.01228-1.23772,8.01228-1.23772v9.90198z'/%3E %3Cpath d='m950.496,269.003c-7.04244,0-8.21621-2.47542-8.21621-2.47542s-2.34728-4.95099-1.1737-6.18884c1.17377-1.23772,9.38991-1.23772,9.38991-1.23772v9.90198z'/%3E %3Cpath d='m950.496,264.052c-5.86873,0-9.38998-2.47549-9.38998-2.47549s-2.34728-4.95099-1.1737-6.18884c1.17377-1.23772,10.5637-1.23765,10.5637-1.23765v9.90198z'/%3E %3Cpath d='m950.496,257.863c-10.5716-0.0974-10.5637-3.17937-10.5637-3.17937s-2.34728-4.95099-1.17371-6.18885c1.17377-1.23771,11.7374-0.53376,11.7374-0.53376v9.90198z'/%3E %3Cpath d='m950.496,252.912c-10.5716-0.0974-11.7374-2.47542-11.7374-2.47542s-2.34728-4.95099-1.17371-6.18884c1.17378-1.23772,12.9111-1.23772,12.9111-1.23772v9.90198z'/%3E %3Cpath d='m950.496,246.724c-10.5716-0.0974-12.9112-2.47549-12.9112-2.47549s-2.34728-4.95099-1.17371-6.18877c1.17377-1.23772,14.0849-1.23772,14.0849-1.23772v9.90198z'/%3E %3Cpath d='m950.496,240.535c-10.5716-0.0974-14.0849-2.47549-14.0849-2.47549s-1.17357-4.95099,0-6.18877c1.17377-1.23772,14.0849-1.23772,14.0849-1.23772v9.90198z'/%3E %3Cpath d='m950.496,234.346c-10.5716-0.0974-14.0849-2.47549-14.0849-2.47549s0-4.95099,1.17371-6.18877c1.17377-1.23772,12.9112-1.23772,12.9112-1.23772v9.90198z'/%3E %3Cpath d='m950.496,228.157c-10.5716-0.0974-12.9111-2.47549-12.9111-2.47549s0-4.95099,1.17371-6.18877c1.17377-1.23772,11.7374-1.23772,11.7374-1.23772v9.90198z'/%3E %3Cpath d='m950.496,212.631c-8.22416,0.01-11.7773,7.15331-11.7573,7.00764l2.36742,2.32976c1.25778,1.23778,9.38991,1.23778,9.28894,1.23143l0.10097-10.5688z'/%3E %3C/g%3E %3C/g%3E %3C/g%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 450 300'%3E %3Crect fill='%23C60C30' width='450' height='300'/%3E %3Crect fill='%23FECB00' width='300' height='300'/%3E %3Crect fill='%23002664' width='150' height='300'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 600 400'%3E %3Cdefs%3E %3Cpath id='s' transform='scale(21)' fill='%23fff' d='M0,-1 L0.58779,0.80902 L-0.95106,-0.30902 L0.95106,-0.30902 L-0.58779,0.80902z'/%3E %3C/defs%3E %3Crect fill='%23002395' height='400' width='600'/%3E %3Crect fill='%23fff' height='164' width='244'/%3E %3Crect fill='%23002395' height='160' width='80'/%3E %3Crect fill='%23ED2939' height='160' width='80' x='160'/%3E %3Cpath fill='%23fff' d='M355,183 l12.875,20.5 h36.625 v71.5 l-27.5,-43 -37,59 h18 l19,-34 39,70 39,-70 19,34 h18 l-37,-59 -27.5,43 v-39.5 h16.5 l12.25,-19.5 h-28.75 v-12.5 h36.625 l12.875,-20.5 h-122z M398,270.5h-40v14h40z M474,270.5h-40v14h40z'/%3E %3Cuse xlink:href='%23s' x='416' y='362'/%3E %3Cuse xlink:href='%23s' x='371' y='328'/%3E %3Cuse xlink:href='%23s' x='461' y='328'/%3E %3Cuse xlink:href='%23s' x='333' y='227'/%3E %3Cuse xlink:href='%23s' x='499' y='227'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 809 500'%3E %3Crect width='809' height='500' fill='%23006a4e'/%3E %3Crect y='100' width='809' height='100' fill='%23ffce00'/%3E %3Crect y='300' width='809' height='100' fill='%23ffce00'/%3E %3Crect width='300' height='300' fill='%23d21034'/%3E %3Cg transform='translate(150,150)' fill='%23fff'%3E %3Cg id='c'%3E %3Cpath id='t' d='M 0,-95 V 0 H 50' transform='rotate(18 0,-95)'/%3E %3Cuse xlink:href='%23t' transform='scale(-1,1)'/%3E %3C/g%3E %3Cuse xlink:href='%23c' transform='rotate(72)'/%3E %3Cuse xlink:href='%23c' transform='rotate(144)'/%3E %3Cuse xlink:href='%23c' transform='rotate(216)'/%3E %3Cuse xlink:href='%23c' transform='rotate(288)'/%3E %3C/g%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 900 600'%3E %3Crect fill='%23A51931' width='900' height='600'/%3E %3Crect fill='%23F4F5F8' y='100' width='900' height='400'/%3E %3Crect fill='%232D2A4A' y='200' width='900' height='200'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 1400 700'%3E %3Crect width='1400' fill='%23060' height='700'/%3E %3Crect width='1400' fill='%23fff' height='500'/%3E %3Crect width='1400' fill='%23c00' height='200'/%3E %3Cg fill='%23f8c300'%3E %3Cpath d='M 672.0,340.7 a 12.5,12.5 0,0,1 23.3,5.9 v 50 h 9.4 v -50 a 12.5,12.5 0,0,1 23.3,-5.9 a 29.5,29.5 0,1,0 -56,0'/%3E %3Cpath d='M 678.7,327.65 a 20,20 0,0,1 21.3,9.55 a 20,20 0,0,1 21.3,-9.55 a 21.5,21.5 0,0,0 -42.6,0' fill='%23fff'/%3E %3Cpath id='w' d='M 695.3,376.627 a 38,38 0 0 1 -63.845,24.316 a 39.5,39.5 0 0 1 -59.734,17.467 c 3.6496,36.426 58.252,28.989 62.32,-6.4288 17.154,30.115 54.873,21.49 65.91,-15.4 z'/%3E %3Cuse xlink:href='%23w' transform='translate(700,0) scale(-1,1) translate(-700,0)'/%3E %3Cpath id='r' d='M 658.84,441.31 c -7.6181,16.446 -22.845,19.271 -36.164,5.9953 0,0 5.3539,-3.7831 11.086,-4.826 -1.0748,-4.5744 1.1291,-10.902 4.2354,-14.324 3.2575,2.2264 7.8036,6.6886 8.9598,11.874 8.0291,-1.0394 11.883,1.2815 11.883,1.2815 z'/%3E %3Cuse xlink:href='%23r' transform='rotate(9.37, 700,804)'/%3E %3Cuse xlink:href='%23r' transform='rotate(18.74, 700,804)'/%3E %3Cpath d='M 603,478 a 340,340 0 0 1 194,0' fill='none' stroke-width='16' stroke='%23f8c300'/%3E %3Cg transform='translate(700,380)'%3E %3Cg transform='translate(0,-140)'%3E %3Cpolygon id='s' points='0,-513674 301930,415571 -488533,-158734 488533,-158734 -301930,415571' transform='scale(0.000048669)'/%3E %3C/g%3E %3Cg id='h'%3E %3Cuse xlink:href='%23s' transform='rotate(-30) translate(0,-140) rotate(30)'/%3E %3Cuse xlink:href='%23s' transform='rotate(-60) translate(0,-140) rotate(60)'/%3E %3Cuse xlink:href='%23s' transform='rotate(-90) translate(0,-140) rotate(90)'/%3E %3C/g%3E %3Cuse xlink:href='%23h' transform='scale(-1,1)'/%3E %3C/g%3E %3C/g%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 1800 900'%3E %3Cdefs%3E %3Cg id='star'%3E %3Cg id='arm' transform='translate(0,-0.324925)'%3E %3Cpath d='M1,0H0V0.5z'/%3E %3Cpath d='M1,0H0V-0.5z' transform='rotate(-36,1,0)'/%3E %3C/g%3E %3Cuse xlink:href='%23arm' transform='rotate(72)'/%3E %3Cuse xlink:href='%23arm' transform='rotate(144)'/%3E %3Cuse xlink:href='%23arm' transform='rotate(216)'/%3E %3Cuse xlink:href='%23arm' transform='rotate(288)'/%3E %3C/g%3E %3C/defs%3E %3Crect width='1800' height='900' fill='%2300247d'/%3E %3Cg fill='%23fed100'%3E %3Cpath d='M329.37609,777.2654C311.44173,777.11556 497.99952,677.83404 654.14523,550.66563C858.78891,383.99945 1299.541,117.15633 1429.1161,73.7954c13.5433,-4.53215 -27.7761,23.07308 -33.14,32.01541c-138.3415,163.74043 -27.925,472.72379 144.9726,628.04829c51.99,39.7632 49.3274,41.85082 145.7074,45.7463v9l-1357.28001,-11.34z'/%3E %3Cpath d='m318.12503,795.3246c0,0 -13.16343,9.4029 -13.12495,16.4061c0.043,7.7725 14.76557,18.0468 14.76557,18.0468l1338.74505,14.7656 24.6093,-16.4062 -34.453,-21.328 -1330.54197,-11.4843z'/%3E %3C/g%3E %3Cg fill='%23fff'%3E %3Cuse xlink:href='%23star' transform='translate(342.9565,112.5812) scale(45)'/%3E %3Cuse xlink:href='%23star' transform='translate(521.20459,267.53) scale(37.5)'/%3E %3Cuse xlink:href='%23star' transform='translate(135,321.8075) scale(45)'/%3E %3Cuse xlink:href='%23star' transform=' translate(342.9565,652.5812) scale(52.5)'/%3E %3C/g%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='-3 -6 24 12'%3E %3Cpath d='M21,6V-6H-3V6z' fill='%23dc241f'/%3E %3Cpath d='M-3,-6V6L9,0z' fill='%23ffc726'/%3E %3Cpath d='M-3,-6V6L5,0z'/%3E %3Cg transform='rotate(-26.565051)'%3E %3Cg id='f'%3E %3Cg id='t'%3E %3Cpath d='M0,-2.1V0H1z' fill='%23fff' transform='rotate(18,0,-2.1)' id='o'/%3E %3Cuse xlink:href='%23o' transform='scale(-1,1)'/%3E %3C/g%3E %3Cuse xlink:href='%23t' transform='rotate(72)'/%3E %3C/g%3E %3Cuse xlink:href='%23t' transform='rotate(-72)'/%3E %3Cuse xlink:href='%23f' transform='rotate(144)'/%3E %3C/g%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 900 600'%3E %3Cpath fill='%2328ae66' d='M0 0h900v600H0z'/%3E %3Cg fill='%23fff'%3E %3Cpath d='M446.821 66.543c26.6 11.42 45.236 37.85 45.236 68.627 0 41.225-33.43 74.655-74.654 74.655-18.455 0-35.345-6.704-48.377-17.805a74.443 74.443 0 0 0 26.15 5.951c41.185 1.798 76.042-30.142 77.84-71.327 1.044-23.91-9.287-45.687-26.195-60.101z'/%3E %3Cpath id='a' d='M375.616 121.42l8.458-26.033-22.145 16.09h27.373l-22.145-16.09z'/%3E %3Cuse xlink:href='%23a' y='-38.4' height='600'/%3E %3Cuse xlink:href='%23a' x='37.937' y='-18.722'/%3E %3Cuse xlink:href='%23a' x='-37.936' y='18.722'/%3E %3Cuse xlink:href='%23a' y='38.4' height='600'/%3E %3C/g%3E %3Cg fill='%23383739'%3E %3Cpath fill='%23ca3745' d='M107.998 0h162v600h-162z'/%3E %3Cg id='c'%3E %3Cg id='b'%3E %3Cpath d='M107.998-39.619v5.88l9.11 8.527-3.072 2.86 6.515 6.038-2.86 2.596v-3.761h-5.562v4.502l12.553 11.759h6.356l.689-4.132h-3.655l3.972-3.707L142.002 0l-9.958 9.11-3.972-3.708h3.655l-.689-4.184h-6.356L112.13 12.977v4.502h5.562v-3.76l2.86 2.594-6.515 6.039 3.072 2.913-9.11 8.474v5.88l15.413-14.354-3.072-2.913 6.462-6.039-5.562-5.19 3.708-3.39 7.097 6.568L147.617 0l-15.573-14.3-7.097 6.62-3.708-3.443 5.562-5.19-6.462-6.039 3.072-2.86-15.413-14.407zm0 28.549v22.14l3.602-3.655v-4.29h3.813L118.485 0l-3.072-3.072H111.6v-4.343l-3.602-3.655zm26.271 7.839l-.53 3.019.53 3.072 3.284-3.072-3.284-3.02z'/%3E %3Cpath fill='%23faae29' d='M107.998-38.983v4.66l9.746 9.11-3.072 2.861 6.514 6.038-3.919 3.655v-4.396h-4.714v3.92l12.341 11.493h5.72l.583-3.284h-4.237l5.084-4.767L142.638 0l-10.594 9.693-5.084-4.714h4.237l-.584-3.337h-5.72L112.55 13.135v3.92h4.715v-4.396l3.919 3.654-6.515 6.038 3.072 2.913-9.745 9.058v4.66l14.777-13.718-3.072-2.913 6.462-6.038-5.562-5.19 4.344-4.026 7.097 6.62L146.927 0l-14.884-13.718-7.097 6.62-4.344-4.025 5.562-5.19-6.462-6.039 3.072-2.86-14.777-13.771zm0 28.548v20.87l3.178-3.179V2.648h4.078L117.903 0l-2.649-2.648h-4.078v-4.609l-3.178-3.177zm26.589 8.051l-.37 2.172.37 2.172 2.33-2.172-2.33-2.172z'/%3E %3C/g%3E %3Cuse xlink:href='%23b' y='109.207'/%3E %3Cuse xlink:href='%23b' y='222.005'/%3E %3Cuse xlink:href='%23b' y='334.802'/%3E %3Cuse xlink:href='%23b' y='447.598'/%3E %3C/g%3E %3Cuse xlink:href='%23c' transform='matrix(-1 0 0 1 377.996 0)'/%3E %3Cpath id='d' fill='%23faae29' d='M121.14 530.824c.8 3.407 3.508 5.979 4.154 9.513 1.292-3.685 2.484-6.773 1.594-10.804-.637-2.883-3.062-4.94-3.343-7.902-2.644 2.377-3.213 5.749-2.405 9.193zm-.67 14.276c2.243 3.075 5.36 5.434 8.803 7.007-.678-2.694.594-4.722 2.006-6.86 1.7-2.574 2.53-5.103 1.143-8.067-.646 1.541-1.514 2.821-2.533 4.139-1.506 2.055-2.497 3.883-2.73 6.52-1.742-1.292-2.507-3.22-3.439-5.086-1.42-2.673-3.712-4.908-6.345-6.369.7 2.998 1.238 6.169 3.095 8.716zm12.578 9.166c-.48 1.708-.893 3.4-.8 5.186-1.482-1.597-3.45-2.799-5.206-4.085-2.39-1.934-5.178-3.298-7.133-5.76.292 3.624 1.843 6.578 4.788 8.783 3.113 2.33 6.867 3.583 9.933 6.03-.46-3.297.752-5.937 1.784-8.967.86-2.895.028-5.834-1.935-8.04.029 2.445-.743 4.545-1.43 6.853zm6.986 11.133c.645 2.5 2.437 4.534 3.66 6.764-3.299-1.023-6.21-2.812-9.191-4.495-3.552-1.934-7.41-3.165-10.625-5.719 1.6 5.924 5.567 9.359 11.369 11.11 3.967 1.198 7.31.6 12.124 2.546-.552-3.259-1.525-6.776-3.066-9.714-1.195-2.125-2.521-4.221-3.26-6.562-1.07 1.923-1.576 3.879-1.011 6.07zm12.139 9.065a15.21 15.21 0 0 0 4.494 4.875c-4.683.299-8.451-2.669-13.017-2.798-2.82-.08-5.497.796-8.373.533 3.413 2.303 6.986 4.314 11.141 4.851 5.401.699 10.382-.66 16.341-.129-2.785-1.965-4.178-4.595-5.914-7.423-2.26-3.533-4.393-6.05-8.789-6.618 1.765 1.983 2.792 4.44 4.117 6.71zm16.631 7.773c-8.25 1.403-16.156 3.218-24.581 3.301 9.431 3.288 18.318 3.883 27.672.488 5.055-1.835 8.93-2.817 12.748-2.544 5.58.401 12.36 2.603 19.865 10.517l2.95-2.36c-10.756-9.583-24.829-11.753-38.654-9.403z'/%3E %3Cuse xlink:href='%23d' transform='matrix(-1 0 0 1 378.036 0)'/%3E %3Cpath d='M128.266 70.34l-12.981-7.961V43.244l12.981-7.96V25.159l12.267-7.388h9.8l18.648-10.488h40.033l18.648 10.488h9.8l12.267 7.388v10.125l12.981 7.96v19.135l-12.98 7.96v10.125l-12.268 7.387h-9.8L209.014 98.34h-40.033l-18.648-10.489h-9.8l-12.267-7.387z'/%3E %3Cpath fill='%2328ae66' d='M169.068 7.733L150.424 18.22h-9.746l-11.97 7.203V35.54l-12.977 7.945v18.644l12.977 7.945v10.17l11.917 7.203h9.799l18.644 10.487h39.83l18.644-10.487h9.8l11.97-7.204v-10.17l12.976-7.944V43.485l-12.976-7.945V25.423l-11.97-7.203h-9.8L208.898 7.733h-39.83zm1.112 3.866h37.66l18.643 10.488h9.746l9.057 5.455V37.66l13.03 7.945V60.01l-13.03 7.945v10.117l-9.057 5.455h-9.746L207.84 94.015H170.18l-18.644-10.488h-9.745l-9.11-5.455V67.955l-12.977-7.945V45.604l12.976-7.945V27.542l9.11-5.455h9.746l18.644-10.488z'/%3E %3Cpath fill='%23faae29' d='M188.783 53.025V12.017h-18.506L151.63 22.505h-9.722l-8.795 5.296v10.1l-12.98 7.96v6.736h69.08v41.009h18.506l18.648-10.489h9.723l8.794-5.296v-10.1l12.98-7.96v-6.735z'/%3E %3Cpath fill='%23fff' d='M120.131 53.025v6.736l12.98 7.96v10.1l8.795 5.296h9.722l18.648 10.489h18.506v-41.01h69.081v-6.735l-12.98-7.96v-10.1l-8.795-5.296h-9.723l-18.648-10.488h-18.505v41.008z'/%3E %3Cg id='f'%3E %3Cg id='e'%3E %3Cpath d='M148.448 26.28l-3.196-2.978-3.166 1.952 3.201 2.985-4.11 2.546h8.969l7.73 7.29 2.472-2.61-7.515-7.09v-4.811z'/%3E %3Cpath d='M163.573 24.972l-3.196-2.978-3.166 1.952 3.201 2.984-4.11 2.547h8.969l7.73 7.29 2.472-2.61-7.515-7.09v-4.812zM147.339 34.836l-3.196-2.979-3.165 1.953 3.2 2.984-4.11 2.547h8.97l7.728 7.29 2.473-2.611-7.515-7.089v-4.812z'/%3E %3Cpath d='M188.997 11.589h-8.093l-4.235 4.081h-8.255l-6.1 3.166 1.422 3.467 5.44-2.858h2.383l8.341 9.647 9.097-5.54z'/%3E %3Cpath fill='%23ca3745' d='M145.199 23.838l2.872 2.676-2.406 1.49-2.876-2.68 2.41-1.486zm7.205.495v4.227l7.338 6.921-1.884 1.99-7.542-7.114h-7.635l9.723-6.024zM160.324 22.53l2.872 2.676-2.406 1.49-2.876-2.68 2.41-1.487zm7.205.494v4.227l7.338 6.922-1.884 1.99-7.542-7.114h-7.635l9.723-6.025z'/%3E %3Cpath fill='%23ca3745' d='M144.091 32.393l2.871 2.677-2.406 1.49-2.875-2.68 2.41-1.487zm7.205.495v4.227l7.337 6.922-1.883 1.99-7.542-7.114h-7.636l9.724-6.025zM188.783 12.017h-7.706l-4.235 4.08h-8.324l-5.66 2.938 1.095 2.67 5.117-2.688h2.685l8.232 9.521 8.796-5.356z'/%3E %3C/g%3E %3Cuse xlink:href='%23e' transform='matrix(1 0 0 -1 0 105.623)'/%3E %3Cpath d='M143.054 39.71l-3.859-1.441-.092.064-4.982 3.457v.93l-7.98 10.091 7.98 10.092v.93l5.074 3.52 3.859-1.441-2.355-1.56v-2.967l.936-1.12h4.181V45.358h-4.181l-.936-1.12V41.27z'/%3E %3Cpath fill='%23ca3745' d='M134.549 42.014l4.706-3.266 2.862 1.07-1.846 1.223v3.352l1.164 1.392h3.952v14.053h-3.952l-1.164 1.392v3.352l1.846 1.223-2.862 1.07-4.706-3.266v-.855l-7.862-9.943 7.863-9.943z'/%3E %3C/g%3E %3Cuse xlink:href='%23f' transform='matrix(-1 0 0 1 377.994 0)'/%3E %3Cpath d='M136.203 61.282l-2.173-1.88v-.906l-4.66-5.685 4.661-5.685v-.906l2.173-1.88 3.902 3.174-2.252-.017 3.328 3.378h7.605l5.98-4.677V33.863h14.96l17.372-10.66v-2.796l-2.657-1.771h-.842l-2.893 1.936-.448 1.444-2.264-3.09 4.399-3.695h.703l4.964-3.642h1.871l4.964 3.642h.703l4.399 3.695-2.263 3.09-.448-1.444-2.894-1.936h-.841l-2.657 1.77v2.797l17.372 10.66h14.959v12.335l5.98 4.677h7.606l3.328-3.378-2.253.017 3.903-3.173 2.172 1.88v.905l4.662 5.685-4.662 5.685v.906l-2.172 1.88-3.903-3.173 2.253.017-3.328-3.378h-7.605l-5.981 4.677V71.76h-14.959L190.895 82.42v2.796l2.657 1.77h.841l2.894-1.935.448-1.445 2.263 3.09-4.399 3.696h-.703l-4.964 3.642h-1.871l-4.964-3.642h-.703l-4.4-3.696 2.265-3.09.448 1.445 2.892 1.936h.842l2.658-1.77V82.42l-17.373-10.66h-14.958V59.424l-5.982-4.677h-7.604l-3.328 3.378 2.252-.017z'/%3E %3Cpath fill='%23faae29' d='M189.211 87.319l1.901 1.454-1.901 1.453V87.32zm-6.044 2.644h.07l4.964 3.643h.58v-2.842l-2.604-1.991 2.604-1.992v-5.337l-18.589-11.408H156.45V58.574l-7.095-5.55h-10.701l-2.69 3.042-2.69-3.041h-3.176l4.36 5.318v.863l1.727 1.5 2.774-2.16-1.628.013v-.54l3.629-3.7h7.974l6.262 4.898V71.33h14.651l17.68 10.85v3.264l-2.956 1.97h-1.103l-3.126-2.093-.24-.777-1.525 2.08 3.973 3.338h.617zm-47.2-39.76l2.117 2.394h-4.236l2.118-2.394zm52.815-34.807l-1.9 1.453 1.9 1.454v-2.907zm51.127 37.63l2.118 2.393 2.118-2.394h-4.236zm-45.154-37.367l-4.964-3.642h-.58v2.84l2.606 1.993-2.606 1.992v5.337l18.59 11.407h13.741V47.05l7.095 5.549h10.7l2.69-3.041 2.69 3.04h3.177l-4.36-5.317v-.864l-1.726-1.5-2.775 2.16 1.629-.013v.54l-3.63 3.7h-7.973l-6.262-4.898V34.29h-14.652l-17.679-10.85v-3.264l2.956-1.97h1.102l3.127 2.094.24.776 1.525-2.08-3.973-3.339h-.688z'/%3E %3Cpath fill='%23fff' d='M188.782 90.226l-1.9-1.453 1.9-1.453v2.906zm-50.698-37.2l-2.118 2.394-2.118-2.394h4.236zm56.741 36.937h-.07l-4.964 3.643h-.58v-2.84l2.606-1.993-2.606-1.993v-5.336l18.59-11.408h13.741V58.574l7.095-5.549h10.7l2.69 3.041 2.69-3.041h3.177l-4.36 5.318v.863l-1.726 1.5-2.775-2.16 1.629.013v-.54l-3.63-3.7h-7.973l-6.262 4.898v12.115h-14.652L190.466 82.18v3.264l2.956 1.97h1.102l3.127-2.093.24-.777 1.525 2.081-3.973 3.337h-.618zm47.202-39.76l-2.118 2.394h4.237l-2.119-2.394zM183.24 15.66l4.963-3.642h.58v2.84l-2.605 1.993 2.606 1.992v5.337l-18.59 11.408h-13.74v11.462l-7.096 5.549h-10.703l-2.69-3.041-2.69 3.04H130.1l4.36-5.317v-.863l1.727-1.5 2.773 2.16-1.628-.014v.541l3.63 3.698h7.973l6.262-4.897V34.291h14.651l17.68-10.849v-3.265l-2.956-1.969h-1.102l-3.127 2.093-.24.776-1.525-2.08 3.974-3.338h.687zm5.972 2.645l1.901-1.454-1.901-1.454v2.908z'/%3E %3Cpath fill='%2328ae66' d='M188.783 53.025V24.68l-18.469 11.334H156.88v11.243l-6.828 5.34h39.16v28.345l18.467-11.334h13.435V58.366l6.828-5.34z'/%3E %3Cpath fill='%23ca3745' d='M150.051 53.025l6.829 5.34v11.243h13.434l18.469 11.334V52.596l39.159.001-6.828-5.34V36.014h-13.435l-18.467-11.333v28.344z'/%3E %3Cpath d='M169.118 39.063l-3.195-2.978-3.166 1.952 3.2 2.984-4.11 2.547h8.97l7.729 7.29 2.472-2.61-7.515-7.09v-4.811zM208.873 66.56l3.196 2.978 3.165-1.953-3.2-2.984 4.11-2.546h-8.97l-7.728-7.291-2.473 2.611 7.515 7.09v4.811zM169.118 66.56l-3.196 2.978-3.165-1.953 3.2-2.984-4.11-2.546h8.97l7.728-7.291 2.473 2.611-7.515 7.09v4.811zM208.873 39.063l3.196-2.978 3.165 1.952-3.2 2.984 4.11 2.547h-8.97l-7.728 7.29-2.473-2.61 7.515-7.09v-4.811z'/%3E %3Cpath fill='%23ca3745' d='M212.122 69.002l-2.871-2.677 2.406-1.49 2.875 2.68-2.41 1.487zm-7.205-.495V64.28l-7.337-6.921 1.884-1.99 7.541 7.114h7.636l-9.724 6.024zM165.87 36.62l2.872 2.677-2.407 1.49-2.875-2.68 2.41-1.487zm7.206.496v4.226l7.337 6.922-1.884 1.99-7.541-7.114h-7.636l9.724-6.024z'/%3E %3Cpath fill='%2328ae66' d='M212.122 36.62l-2.871 2.677 2.406 1.49 2.875-2.68-2.41-1.487zm-7.205.496v4.226l-7.337 6.922 1.884 1.99 7.541-7.114h7.636l-9.724-6.024zM165.87 69.002l2.871-2.677-2.406-1.49-2.875 2.68 2.41 1.487zm7.205-.495V64.28l7.338-6.921-1.884-1.99-7.541 7.114h-7.636l9.723 6.024z'/%3E %3Cpath d='M208.856 52.812l-19.859 13.235-19.859-13.235 19.859-13.236z'/%3E %3Cpath fill='%23fff' d='M188.783 40.233l-18.551 12.364h37.531l-18.551-12.364V65.39l18.552-12.365h-37.533l18.552 12.365z'/%3E %3Cpath d='M194.308 57.363v3.639h-10.62v-3.64h-6.874V48.26h6.873v-3.64h10.621v3.64h6.873v9.103z'/%3E %3Cpath fill='%23ca3745' d='M184.116 45.048v3.64h-6.873v3.909h11.54v-7.549h-4.667zm5.096 7.549h11.54v-3.91h-6.872v-3.639h-4.668v7.549zm-11.969.428v3.91h6.873v3.639h4.667v-7.549h-11.54zm11.97 7.549h4.667v-3.639h6.873v-3.91h-11.54v7.55z'/%3E %3Cg%3E %3Cpath d='M222.877 203.61v-5.83h15.988v-5.83h15.988v-52.682h-15.988v-5.83h-15.988v-5.83h-15.988v-5.83h-35.782v5.83h-15.989v5.83H139.13v5.83H123.14v52.682h15.989v5.83h15.988v5.83h15.989v5.83h35.782v-5.83z'/%3E %3Cpath fill='%23ca3745' d='M171.558 122.193v5.826h-15.996v5.827h-15.996v5.826H123.57v51.854h15.996v5.827h15.996v5.825h15.996v5.826h34.903v-5.826h15.997v-5.825h15.997v-5.827h15.994v-51.854h-15.994v-5.826h-15.997v-5.827h-15.997v-5.826h-34.903zm4.237 4.237h26.43v5.826h15.996v5.827h15.996v5.826h15.995v43.38h-15.995v5.826h-15.996v5.826h-15.997v5.825h-26.429v-5.825H159.8v-5.826h-15.996v-5.827h-15.996v-43.38h15.996v-5.825H159.8v-5.827h15.996v-5.826z'/%3E %3Cpath fill='%23ca3745' d='M160.209 198.519v-5.83h-15.988v-5.83h-15.989v-42.5h15.989v-5.831h15.988v-5.83h15.988v-5.83h25.601v5.83h15.989v5.83h15.987v5.83h15.99v42.5h-15.99v5.83h-15.987v5.831h-15.989v5.83h-25.6v-5.83z'/%3E %3Cpath d='M163.921 137.014l-4.141-3.13v6.01l-3.966 2.52-.01-3.762-3.803 3.416-3.804-3.416-.01 3.763-4.394-2.793v5.573l-3.552 2.571-.01-3.417-4.219 3.056-4.219-3.056-.01 3.417-3.98-2.881v16.881h-4.662v7.685h4.662v16.881l3.98-2.882.01 3.418 4.22-3.056 4.218 3.056.01-3.418 3.551 2.571v5.574l4.395-2.793.01 3.763 3.803-3.416 3.804 3.416.01-3.763 3.965 2.52v6.011l4.142-3.13.009 4.198 4.058-3.63 4.059 3.63.009-4.198 3.713 2.806v6.411l5.551-5.06v5.946l7.678-4.936 7.678 4.936v-5.946l5.551 5.06v-6.41l3.712-2.807.01 4.198 4.058-3.63 4.06 3.63.008-4.198 4.14 3.13v-6.011l3.967-2.52.01 3.763 3.804-3.416 3.803 3.416.01-3.763 4.395 2.793v-5.574l3.552-2.57.01 3.417 4.218-3.056 4.22 3.056.01-3.418 3.98 2.882V169.45h4.661v-7.685h-4.662v-16.881l-3.98 2.881-.01-3.417-4.219 3.056-4.219-3.056-.009 3.417-3.551-2.571v-5.573l-4.395 2.793-.01-3.763-3.804 3.416-3.804-3.416-.01 3.763-3.966-2.521v-6.01l-4.14 3.13-.01-4.199-4.058 3.63-4.06-3.63-.008 4.199-3.713-2.807v-6.41l-5.55 5.06v-5.946l-7.679 4.936-7.678-4.936v5.946l-5.55-5.06v6.41l-3.714 2.807-.009-4.199-4.059 3.63-4.058-3.63z'/%3E %3Cg fill='%2328ae66'%3E %3Cpath d='M132.21 148.604l.01-3.418 3.793 2.748.127-.093 3.665-2.655.01 3.418 3.978-2.88v39.769l-3.978-2.88-.01 3.418-3.792-2.748-3.793 2.748-.01-3.418-3.978 2.88v-16.471h-4.662v-6.827h4.662v-16.47zM164.356 133.772l3.632 3.248 3.633-3.248.009 4.102 4.139-3.129v61.728l-4.14-3.13-.008 4.103-3.633-3.249-3.632 3.249-.008-4.102-4.139 3.129v-61.728l4.139 3.13zM213.64 133.772l-3.632 3.248-3.633-3.248-.009 4.102-4.138-3.129v61.728l4.138-3.13.01 4.103 3.632-3.249 3.632 3.249.009-4.102 4.139 3.129v-61.728l-4.139 3.13zM245.786 148.604l-.01-3.418-3.793 2.748-.128-.093-3.665-2.655-.01 3.418-3.977-2.88v39.769l3.977-2.88.01 3.418 3.793-2.748 3.793 2.748.01-3.418 3.977 2.88v-16.471h4.662v-6.827h-4.662v-16.47z'/%3E %3C/g%3E %3Cg fill='%23faae29'%3E %3Cpath d='M148.623 139.611l3.377 3.034 3.378-3.034.01 3.583 4.392-2.792v50.413l-4.392-2.791-.01 3.582-3.378-3.033-3.377 3.033-.01-3.582-4.393 2.791v-50.413l4.393 2.792zM181.748 133.827l-5.551-5.06v73.683l5.551-5.06v6.131l7.249-4.66 7.25 4.66v-6.131l5.55 5.06v-73.683l-5.55 5.06v-6.131l-7.25 4.66-7.249-4.66zM229.373 139.611l-3.377 3.034-3.378-3.034-.01 3.583-4.393-2.792v50.413l4.394-2.791.009 3.582 3.378-3.033 3.377 3.033.01-3.582 4.393 2.791v-50.413l-4.393 2.792z'/%3E %3C/g%3E %3Cg id='h'%3E %3Cg id='g'%3E %3Cpath d='M134.288 158.366c.485.49 1.066.737 1.724.737.659 0 1.239-.247 1.725-.737 1.518-1.53 1.57-4.297 1.554-6.289l-2.072 2.19-1.207-2.083s-.985 1.702-1.207 2.083l-2.072-2.19c-.015 1.992.036 4.759 1.555 6.289zM150.966 154.08l-1.28-1.278v-2.546l-2.937 2.722L152 158.23l5.252-5.252-2.938-2.722v2.546l-1.279 1.278v-4.511l2.265-1.945-3.3-2.834-3.3 2.834 2.266 1.945zM166.953 149.02l-1.279-1.279v-2.546l-2.937 2.723 5.251 5.251 5.251-5.251-2.937-2.723v2.546l-1.28 1.279v-4.512l2.266-1.945-3.3-2.833-3.3 2.833 2.265 1.945z'/%3E %3Cpath fill='%23fff' d='M136.013 153.039l1.123 1.94 1.709-1.806c-.06 2.25-.553 4.026-1.412 4.89-.402.406-.88.612-1.42.612-.54 0-1.018-.206-1.42-.611-.859-.865-1.353-2.642-1.412-4.89l1.708 1.805 1.124-1.94zM168.595 144.312v5.743l2.136-2.135v-1.743l1.891 1.754-4.633 4.633-4.634-4.633 1.891-1.754v1.743l2.136 2.135v-5.743l-2.035-1.748 2.642-2.268 2.642 2.268z'/%3E %3Cpath fill='%23ca3745' d='M152.607 149.372v5.743l2.136-2.136v-1.742l1.891 1.753-4.634 4.634-4.633-4.634 1.891-1.753v1.742l2.136 2.136v-5.743l-2.035-1.748 2.641-2.268 2.643 2.268z'/%3E %3C/g%3E %3Cuse xlink:href='%23g' transform='matrix(-1 0 0 1 377.996 0)'/%3E %3Cpath d='M195.282 150.937l-1.72-2.377 4.411-4.072-4.113-3.38v2.394l-1.72 1.472v-4.342l3.885-2.864-7.029-5.18-7.029 5.18 3.887 2.864v4.342l-1.72-1.472v-2.394l-4.114 3.38 4.412 4.072-1.72 2.377z'/%3E %3Cpath fill='%23ca3745' d='M183.552 150.509l1.45-2.006-4.328-3.996 3.032-2.491v1.684l2.577 2.206v-5.49l-3.592-2.647 6.307-4.649 6.306 4.649-3.591 2.647v5.49l2.577-2.206v-1.684l3.032 2.491-4.329 3.996 1.451 2.006z'/%3E %3Cpath d='M185.785 137.769l3.212 2.367 3.212-2.367-3.212-2.368-.127.095z'/%3E %3Cpath fill='%2328ae66' d='M188.997 135.934l2.49 1.835-2.49 1.835-2.49-1.835 2.49-1.835z'/%3E %3C/g%3E %3Cuse xlink:href='%23h' transform='matrix(1 0 0 -1 0 331.216)'/%3E %3Cpath d='M245.902 163.15h-7.037v-2.805h-21.511l-14.974-9.836h-26.765l-14.974 9.836h-21.51v2.805h-7.038v4.918h7.037v2.805h21.511l14.974 9.836h26.765l14.974-9.836h21.51v-2.805h7.038z'/%3E %3Cpath fill='%23ca3745' d='M175.742 150.953l-14.99 9.799h-21.186v2.807h-7.044v4.078h7.044v2.808h21.187l14.989 9.851h26.536l14.936-9.851h21.24v-2.808h7.044v-4.078h-7.044v-2.807h-21.24l-14.936-9.799zm.318 1.43h25.847l13.718 9.004v1.377h15.308v5.72h-15.308v1.378l-13.718 8.951H176.06l-13.665-8.951v-1.377h-15.36v-5.72h15.36v-1.378z'/%3E %3Cpath fill='%23ca3745' d='M201.799 152.826l13.379 8.783v1.56h15.332v4.88h-15.332v1.559l-13.379 8.783h-25.604l-13.38-8.783v-1.56h-15.331v-4.88h15.332v-1.559l13.379-8.783z'/%3E %3Cpath d='M169.551 170.598l5.793 4.349 3.81-2.862-2.215-1.663-1.595 1.198-1.362-1.022 21.815-16.379h-4.43zm12.645 6.4h4.43l21.816-16.378-5.792-4.348-3.811 2.86 2.215 1.663 1.596-1.198 1.362 1.023zm9.171 0h4.43l-21.815-16.378 1.362-1.023 1.595 1.198 2.216-1.662-3.811-2.861-5.793 4.348zm12.645-6.4l-1.362 1.022-1.596-1.198-2.215 1.663 3.811 2.862 5.792-4.349-21.816-16.379h-4.43zM165.164 165.609l3.893 2.586 3.894-2.586-3.894-2.586z'/%3E %3Cpath d='M185.104 165.609l3.893 2.586 3.894-2.586-3.894-2.586zM212.832 165.609l-3.893 2.586-3.894-2.586 3.894-2.586z'/%3E %3Cpath fill='%23faae29' d='M207.729 170.598l-5.078 3.813-3.098-2.326 1.502-1.127 1.596 1.198 2.075-1.558-21.245-15.95h3.003zm-13.216 5.972h-3.003l-21.244-15.95 5.079-3.813 3.096 2.326-1.501 1.126-1.595-1.198-2.076 1.559zm-8.029 0h-3.003l21.245-15.95-2.075-1.559-1.596 1.198-1.502-1.126 3.098-2.326 5.078 3.813zm5.026-21.922h3.003l-21.244 15.95 2.076 1.558 1.595-1.198 1.501 1.127-3.096 2.326-5.08-3.813z'/%3E %3Cpath fill='%2328ae66' d='M169.057 163.538l3.119 2.071-3.119 2.071-3.119-2.07zM188.998 163.538l3.119 2.071-3.119 2.071-3.118-2.07zM208.939 163.538l-3.119 2.071 3.119 2.071 3.118-2.07z'/%3E %3C/g%3E %3Cg%3E %3Cpath d='M120.514 274.151l-1.528 2.16 2.739 2.095-2.74 2.094 1.528 2.16 3.182.37 3.081-2.38 7.682 4.88v-4.053l-4.835-3.071 4.835-3.071v-4.053l-7.682 4.88-3.08-2.38z'/%3E %3Cpath d='M120.514 260.073l-1.528 2.161 2.739 2.094-2.74 2.094 1.528 2.161 3.182.37 3.081-2.381 7.682 4.88v-4.053l-4.835-3.07 4.835-3.072v-4.053l-7.682 4.88-3.08-2.38zM120.514 296.739l-1.528-2.16 2.739-2.095-2.74-2.094 1.528-2.16 3.182-.37 3.081 2.38 7.682-4.88v4.053l-4.835 3.071 4.835 3.071v4.053l-7.682-4.88-3.08 2.38zM257.482 274.151l1.528 2.16-2.739 2.095 2.739 2.094-1.528 2.16-3.181.37-3.081-2.38-7.683 4.88v-4.053l4.836-3.071-4.836-3.071v-4.053l7.683 4.88 3.08-2.38z'/%3E %3Cpath d='M257.482 260.073l1.528 2.161-2.739 2.094 2.739 2.094-1.528 2.161-3.181.37-3.081-2.381-7.683 4.88v-4.053l4.836-3.07-4.836-3.072v-4.053l7.683 4.88 3.08-2.38zM257.482 296.739l1.528-2.16-2.739-2.095 2.739-2.094-1.528-2.16-3.181-.37-3.081 2.38-7.683-4.88v4.053l4.836 3.071-4.836 3.071v4.053l7.683-4.88 3.08 2.38zM226.727 235.73v5.856h4.26v2.588h4.184v-4.713h-3.732v-3.731h-4.712zM239.283 244.965v5.855h4.255v2.589h4.189v-4.713h-3.732v-3.731h-4.712zM151.269 235.73v5.856h-4.26v2.588h-4.184v-4.713h3.732v-3.731h4.712zM226.727 321.083v-5.856h4.26v-2.588h4.184v4.712h-3.732v3.732h-4.712zM151.269 321.083v-5.856h-4.26v-2.588h-4.184v4.712h3.732v3.732h4.712zM239.283 311.848v-5.855h4.255v-2.589h4.189v4.712h-3.732v3.732h-4.712zM138.714 244.965v5.855h-4.256v2.589h-4.188v-4.713h3.732v-3.731h4.712zM138.714 311.848v-5.855h-4.256v-2.589h-4.188v4.712h3.732v3.732h4.712zM204.753 235.594l-3.25-3.156-3.194 2.959 2.783 2.701-3.592 3.488h5.334l1.919-1.863 1.92 1.863h5.333l-3.593-3.488 2.783-2.701-3.193-2.959c-1.085 1.05-2.167 2.104-3.25 3.156zM188.998 235.594l-3.25-3.156-3.193 2.959 2.783 2.701-3.593 3.488h5.334l1.919-1.863 1.92 1.863h5.333l-3.592-3.488 2.782-2.701-3.192-2.959c-1.085 1.05-2.167 2.104-3.251 3.156zM173.244 235.594l3.25-3.156 3.194 2.959-2.783 2.701 3.592 3.488h-5.334l-1.919-1.863-1.92 1.863h-5.333l3.593-3.488-2.783-2.701 3.193-2.959c1.085 1.05 2.167 2.104 3.25 3.156zM204.753 321.219l-3.25 3.155-3.194-2.958 2.783-2.701-3.592-3.488h5.334l1.919 1.863 1.92-1.863h5.333l-3.593 3.488 2.783 2.7-3.193 2.96c-1.085-1.051-2.167-2.104-3.25-3.156zM188.998 321.219l-3.25 3.155-3.193-2.958 2.783-2.701-3.593-3.488h5.334l1.919 1.863 1.92-1.863h5.333l-3.592 3.488 2.782 2.7-3.192 2.96c-1.085-1.051-2.167-2.104-3.251-3.156zM173.244 321.219l3.25 3.155 3.194-2.958-2.783-2.701 3.592-3.488h-5.334l-1.919 1.863-1.92-1.863h-5.333l3.593 3.488-2.783 2.7 3.193 2.96c1.085-1.051 2.167-2.104 3.25-3.156z'/%3E %3Cg fill='%2328ae66'%3E %3Cpath d='M134.029 281.713v3.037l-7.278-4.623-3.18 2.458-2.819-.327-1.178-1.668 2.856-2.184-2.856-2.184 1.179-1.667 2.817-.327 3.181 2.458 7.278-4.623v3.036l-5.206 3.307zM134.029 267.635v3.037l-7.278-4.623-3.18 2.458-2.819-.327-1.178-1.668 2.856-2.184-2.856-2.183 1.179-1.667 2.817-.328 3.181 2.458 7.278-4.623v3.037l-5.206 3.306zM134.029 289.178v-3.037l-7.278 4.623-3.18-2.458-2.819.327-1.178 1.668 2.856 2.184-2.856 2.184 1.179 1.667 2.817.327 3.181-2.458 7.278 4.623v-3.036l-5.206-3.307zM243.967 281.713v3.037l7.278-4.623 3.18 2.458 2.818-.327 1.179-1.668-2.856-2.184 2.856-2.184-1.179-1.667-2.818-.327-3.18 2.458-7.278-4.623v3.036l5.206 3.307zM243.967 267.635v3.037l7.278-4.623 3.18 2.458 2.818-.327 1.179-1.668-2.856-2.184 2.856-2.183-1.179-1.667-2.818-.328-3.18 2.458-7.278-4.623v3.037l5.206 3.306zM243.967 289.178v-3.037l7.278 4.623 3.18-2.458 2.818.327 1.179 1.668-2.856 2.184 2.856 2.184-1.179 1.667-2.818.327-3.18-2.458-7.278 4.623v-3.036l5.206-3.307zM231.011 236.159v3.732h3.731v3.855h-3.326v-2.588h-4.26v-4.999h3.855zM243.566 245.393v3.731h3.731v3.856h-3.327v-2.588h-4.259v-4.999h3.855zM146.985 236.159v3.732h-3.731v3.855h3.327v-2.588h4.259v-4.999h-3.855zM231.011 320.653v-3.731h3.731v-3.855h-3.326v2.587h-4.26v4.999h3.855zM146.985 320.653v-3.731h-3.732v-3.855h3.327v2.587h4.26v4.999h-3.855zM243.566 311.419v-3.731h3.731v-3.855h-3.327v2.587h-4.259v4.999h3.855zM134.43 245.393v3.731h-3.731v3.856h3.327v-2.588h4.259v-4.999h-3.855zM134.431 311.419v-3.731h-3.732v-3.855h3.327v2.587h4.26v4.999h-3.855zM201.496 233.029l3.257 3.162 3.257-3.162 2.564 2.375-2.776 2.694 3.151 3.06h-4.102l-2.094-2.033-2.094 2.033h-4.102l3.151-3.06-2.776-2.694 2.564-2.375zM185.741 233.029l3.257 3.162 3.257-3.162 2.563 2.375-2.775 2.694 3.151 3.06h-4.103l-2.093-2.033-2.094 2.033h-4.102l3.15-3.06-2.775-2.694 2.564-2.375zM176.502 233.029l-3.257 3.162-3.257-3.162-2.564 2.375 2.776 2.694-3.151 3.06h4.102l2.094-2.033 2.094 2.033h4.102l-3.151-3.06 2.776-2.694-2.564-2.375zM201.496 323.784l3.257-3.163 3.257 3.163 2.564-2.375-2.776-2.694 3.151-3.06h-4.102l-2.094 2.032-2.094-2.032h-4.102l3.151 3.06-2.776 2.694 2.564 2.375zM185.741 323.784l3.257-3.163 3.257 3.163 2.563-2.375-2.775-2.694 3.151-3.06h-4.103l-2.093 2.032-2.094-2.032h-4.102l3.15 3.06-2.775 2.694 2.564 2.375zM176.502 323.784l-3.257-3.163-3.257 3.163-2.564-2.375 2.776-2.694-3.151-3.06h4.102l2.094 2.032 2.094-2.032h4.102l-3.151 3.06 2.776 2.694-2.564 2.375z'/%3E %3C/g%3E %3Cpath d='M146.58 306.421v9.234h84.836v-9.234h12.55v-56.03h-12.55v-9.233H146.58v9.234h-12.55v56.029z'/%3E %3Cpath fill='%23ca3745' d='M147.034 241.578v9.217h-12.553v55.19h12.553v9.217h83.95v-9.217h12.555v-55.19h-12.554v-9.217h-83.951zm5.403 3.55h73.146v8.897l3.019 2.226h11.388v44.332h-11.44l-2.967 2.171v8.951h-73.146v-8.898l-3.02-2.224h-11.44v-44.332h11.388l3.072-2.226v-8.898z'/%3E %3Cpath fill='%23ca3745' d='M152.86 245.551v8.158l11.017-8.158H152.86zm61.228 0l11.017 8.158v-8.158h-11.017zm-75.635 11.124v7.627l10.382-7.627h-10.381zm90.679 0l10.434 7.68v-7.68h-10.434zm10.434 35.75l-10.434 7.734h10.434v-7.734zm-101.113.053v7.681h10.381l-10.381-7.681zm14.407 10.647v8.104h10.964l-10.964-8.104zm72.245 0l-10.963 8.104h10.963v-8.104z'/%3E %3Cpath fill='%2328ae66' d='M213.377 245.559l26.188 19.342v27.01l-26.188 19.342h-48.76l-26.187-19.342V264.9l26.187-19.342h48.76z'/%3E %3Cpath d='M144.667 295.021l-3.01-3.494 2.826-3.28-2.827-3.28 2.827-3.28-2.827-3.28 2.827-3.28-2.827-3.281 2.826-3.28-2.826-3.28 3.011-3.494h88.661l3.011 3.494-2.826 3.28 2.826 3.28-2.826 3.28 2.826 3.28-2.826 3.28 2.826 3.28-2.826 3.28 2.826 3.28-3.01 3.495zm60.946-45.236l-3.495-3.011-3.28 2.826-3.28-2.826-3.28 2.826-3.28-2.826-3.28 2.826-3.281-2.826-3.28 2.826-3.28-2.826-3.494 3.01v57.244l3.494 3.011 3.28-2.827 3.28 2.826 3.28-2.826 3.28 2.826 3.28-2.826 3.28 2.826 3.28-2.826 3.281 2.827 3.495-3.011z'/%3E %3Cg fill='%23faae29'%3E %3Cpath d='M198.623 249.981l-3.065-2.642-3.066 2.642v56.85l3.066 2.641 3.065-2.641zM185.503 249.981l-3.066-2.642-3.065 2.642v56.85l3.065 2.641 3.066-2.641z'/%3E %3Cpath d='M144.863 294.593l-2.641-3.066 2.641-3.066h88.269l2.641 3.066-2.641 3.066zM233.132 275.34l2.642 3.066-2.642 3.065h-88.268l-2.642-3.065 2.642-3.066zM233.132 268.352l2.641-3.066-2.641-3.065h-88.269l-2.641 3.065 2.641 3.066z'/%3E %3C/g%3E %3Cg fill='%23ca3745'%3E %3Cpath d='M205.184 249.981l-3.065-2.642-3.066 2.642v56.85l3.066 2.641 3.064-2.64zM178.943 249.981l-3.066-2.642-3.066 2.642v56.85l3.066 2.641 3.066-2.641z'/%3E %3Cpath d='M144.864 288.032l-2.642-3.066 2.642-3.066h88.268l2.642 3.066-2.642 3.066zM144.864 274.912l-2.642-3.066 2.642-3.066h88.268l2.642 3.066-2.642 3.066z'/%3E %3Cpath d='M192.064 306.831l-3.066 2.641-3.066-2.641v-56.85l3.066-2.642 3.066 2.642z'/%3E %3C/g%3E %3Cpath d='M218.631 251.09h-59.48v4.724h-7.602v45.185h7.602v4.723h59.694v-4.723h7.602v-45.185h-7.602v-4.724h-.214z'/%3E %3Cpath fill='%23ca3745' d='M159.587 251.535v4.715h-7.627v44.332h7.627v4.714h6.25l-12.447-10.434V261.97l12.447-10.434h-6.25zm52.596 0l12.393 10.434v32.893l-12.393 10.434h6.25v-4.714h7.574V256.25h-7.575v-4.715h-6.249z'/%3E %3Cg fill='%2328ae66'%3E %3Cpath d='M166.525 251.535l-12.712 10.646v32.468c.15.127 12.594 10.547 12.712 10.646h44.968l12.659-10.646v-32.468l-12.659-10.646zm.636 1.8h43.644l11.546 9.694v30.773l-11.546 9.64H167.16l-11.494-9.64v-30.773z'/%3E %3Cpath d='M178.72 294.289l1.954.844.359 2.282-2.46 2.164 3.573 3.454h-3.437l-2.458-2.366-2.458 2.366h-3.438l3.573-3.454-2.46-2.164.36-2.282 1.953-.844 2.47 1.975.134-.107zM191.468 294.289l1.953.844.36 2.282-2.46 2.164 3.573 3.454h-3.437l-2.459-2.366-2.457 2.366h-3.438l3.573-3.454-2.46-2.164.36-2.282 1.953-.844 2.47 1.975.133-.107zM199.277 294.289l-1.953.844-.36 2.282 2.46 2.164-3.573 3.454h3.437l2.459-2.366 2.457 2.366h3.438l-3.573-3.454 2.46-2.164-.36-2.282-1.953-.844-2.47 1.975-.134-.107zM178.72 262.523l1.954-.844.359-2.281-2.46-2.164 3.573-3.454h-3.437l-2.458 2.365-2.458-2.365h-3.438l3.573 3.454-2.46 2.163.36 2.282 1.953.844 2.47-1.974.134.107zM191.468 262.523l1.953-.844.36-2.281-2.46-2.164 3.573-3.454h-3.437l-2.459 2.365-2.457-2.365h-3.438l3.573 3.454-2.46 2.163.36 2.282 1.953.844 2.47-1.974.133.107zM199.277 262.523l-1.953-.844-.36-2.281 2.46-2.164-3.573-3.454h3.437l2.459 2.365 2.457-2.365h3.438l-3.573 3.454 2.46 2.163-.36 2.282-1.953.844-2.47-1.974-.134.107zM221.901 266.167l-1.95 1.615 1.95 1.614v2.676l-2.999-2.471-2.152 1.95-2.308-.29-.813-1.5 1.986-1.98-1.986-1.98.813-1.5c.192-.023 2.135-.268 2.308-.29l2.152 1.95 2.999-2.47v2.676zM221.901 276.792l-1.95 1.615 1.95 1.613v2.677l-2.999-2.471-2.152 1.95c-.173-.022-2.116-.267-2.308-.29l-.813-1.5 1.986-1.98-1.986-1.98.813-1.5c.192-.023 2.135-.268 2.308-.29l2.152 1.95 2.999-2.47v2.676zM221.901 290.646l-1.95-1.615 1.95-1.614v-2.676l-2.999 2.471-2.152-1.95-2.308.29-.813 1.5 1.986 1.98-1.986 1.98.813 1.5c.192.023 2.135.268 2.308.29l2.152-1.95 2.999 2.47v-2.676zM156.097 266.167l1.95 1.615-1.95 1.614v2.676l2.999-2.471 2.152 1.95 2.308-.29.813-1.5-1.986-1.98 1.986-1.98-.813-1.5c-.192-.023-2.136-.268-2.308-.29l-2.152 1.95-2.999-2.47v2.676zM156.097 276.792l1.95 1.615-1.95 1.613v2.677l2.999-2.471 2.152 1.95c.172-.022 2.116-.267 2.308-.29l.813-1.5-1.986-1.98 1.986-1.98-.813-1.5c-.192-.023-2.136-.268-2.308-.29l-2.152 1.95-2.999-2.47v2.676zM156.097 290.646l1.95-1.615-1.95-1.614v-2.676l2.999 2.471 2.152-1.95 2.308.29.813 1.5-1.986 1.98 1.986 1.98-.813 1.5c-.192.023-2.136.268-2.308.29l-2.152-1.95-2.999 2.47v-2.676z'/%3E %3C/g%3E %3Cpath fill='%23ca3745' d='M167.32 253.761c-.116.097-10.602 8.876-11.07 9.27.945.783 1.86 1.602 2.807 2.383.24-.217 2.066-1.855 2.066-1.855l2.701.371 1.06 1.96-1.907 1.907c.259.257 1.906 1.906 1.906 1.906l-1.059 1.96-2.701.318s-1.826-1.584-2.066-1.8l-2.966 2.488v.848c.998.826 1.965 1.664 2.966 2.49.24-.217 2.066-1.801 2.066-1.801l2.701.317 1.06 1.96-1.907 1.907c.259.257 1.906 1.907 1.906 1.907l-1.059 2.012-2.701.318s-1.826-1.636-2.066-1.854l-2.966 2.49v.9l2.966 2.49c.24-.217 2.066-1.854 2.066-1.854l2.701.37 1.06 1.96-1.907 1.907 1.906 1.907-1.059 1.96-2.701.37s-1.826-1.636-2.066-1.854c-.944.778-1.865 1.554-2.807 2.331l11.07 9.27h2.436l3.55-3.444-2.278-2.012.423-2.755 2.384-1.006 2.436 1.907 2.384-1.907 2.383 1.006.477 2.755-2.33 2.012 3.442 3.284 3.443-3.284-2.33-2.012.423-2.755 2.437-1.006 2.383 1.907 2.436-1.907 2.384 1.006.424 2.755-2.278 2.012 3.39 3.337 3.443-3.337-2.278-2.012.424-2.755 2.436-1.006 2.384 1.907 2.383-1.907 2.437 1.006.424 2.755-2.278 2.012 3.549 3.443h2.383l11.07-9.269c-.943-.777-1.862-1.551-2.807-2.33-.24.217-2.013 1.853-2.013 1.853l-2.701-.37-1.112-1.96 1.906-1.907-1.906-1.907 1.112-1.96 2.701-.37s1.773 1.637 2.013 1.854l2.966-2.49v-.9l-2.966-2.49c-.24.218-2.013 1.854-2.013 1.854l-2.701-.318-1.112-2.012 1.906-1.907-1.906-1.907 1.112-1.96 2.701-.317s1.773 1.584 2.013 1.8c.994-.819 1.974-1.62 2.966-2.436v-.953l-2.966-2.437c-.24.217-2.013 1.8-2.013 1.8l-2.701-.317-1.112-1.96 1.906-1.906-1.906-1.907 1.112-1.96 2.701-.37s1.773 1.637 2.013 1.853c.95-.782 1.911-1.548 2.86-2.33l-11.123-9.322h-2.383l-3.549 3.442 2.277 2.013-.423 2.754-2.437 1.06-2.383-1.907-2.384 1.907-2.436-1.06-.424-2.754 2.278-2.013-3.39-3.284-3.443 3.284 2.278 2.013-.424 2.754-2.384 1.06-2.436-1.907-2.383 1.907-2.437-1.06-.424-2.754 2.33-2.013-3.442-3.284-3.443 3.284 2.33 2.013-.476 2.754-2.383 1.06-2.384-1.907-2.436 1.907-2.384-1.06-.423-2.754 2.277-2.013-3.602-3.442zm-11.229 23.57v2.171l1.271-1.112z'/%3E %3Cg fill='%23fff'%3E %3Cpath d='M176.271 301.271l-1.854 1.747h3.654l-1.8-1.747zM188.983 301.271l-1.8 1.747h3.654l-1.854-1.747zM201.747 301.271l-1.853 1.747h3.707l-1.854-1.747zM174.364 253.761l1.907 1.8 1.854-1.8h-3.761zM187.129 253.761l1.854 1.8 1.907-1.8h-3.761zM199.895 253.761l1.853 1.8 1.854-1.8h-3.707zM221.875 266.737l-1.271 1.06 1.271 1.006v-2.066zM221.875 277.33l-1.271 1.06 1.271 1.059v-2.119zM221.875 287.976l-1.271 1.06 1.271 1.059v-2.119zM156.091 266.685v2.171l1.271-1.06-1.271-1.111zM156.091 277.33v2.171l1.271-1.112-1.271-1.059zM156.091 287.924v2.171l1.271-1.06-1.271-1.111z'/%3E %3C/g%3E %3Cg%3E %3Cpath d='M199.901 274.857v-3.791h-3.837v-4.157h-14.132v4.157h-3.837v3.791h-5.299v7.098h5.3v3.79h3.836v4.158h14.132v-4.157h3.837v-3.791h5.299v-7.098z'/%3E %3Cpath fill='%23faae29' d='M188.783 267.338v4.285l-6.074 3.453v3.116h-9.485v-2.906h5.299v-3.791h3.837v-4.157zM189.212 289.475v-4.285l6.074-3.453v-3.116h9.485v2.906h-5.299v3.791h-3.837v4.157z'/%3E %3Cpath fill='%23fff' d='M195.286 278.192v-3.116l-6.074-3.453v-4.285h6.423v4.157h3.837v3.79h5.299v2.907zM173.225 278.621h9.484v3.116l6.075 3.453v4.285h-6.423v-4.157h-3.837v-3.791h-5.299z'/%3E %3Cpath fill='%23ca3745' d='M183.138 278.621v2.888l5.645 3.21v-6.098z'/%3E %3Cpath fill='%2328ae66' d='M188.783 272.094l-5.645 3.21v2.888h5.645z'/%3E %3Cpath fill='%23ca3745' d='M194.858 278.192v-2.888l-5.645-3.21v6.098z'/%3E %3Cpath fill='%2328ae66' d='M189.212 284.719l5.645-3.21v-2.888h-5.645z'/%3E %3C/g%3E %3C/g%3E %3Cg%3E %3Cpath d='M137.647 353.73v11.717h-11.165v10.627h-11.317v30.259h11.317v10.627h11.165v11.717h40.598l7.14 4.29-3.432 2.06h-14.476l-1.248-1.408h13.119l-3.696-3.721h-18.767l8.503 8.851h17.598l6.011-3.612 6.012 3.612h17.599l8.502-8.851h-18.766l-3.696 3.721h13.12l-1.25 1.409h-14.477l-3.43-2.061 7.14-4.29h40.597V416.96h11.166v-10.627h11.316v-30.259h-11.316v-10.627h-11.166V353.73h-40.597l-7.14-4.29 3.43-2.061h14.477l1.25 1.408h-13.12l3.696 3.722h18.766l-8.502-8.852h-17.6l-6.01 3.612-6.012-3.612h-17.598l-8.503 8.852h18.767l3.696-3.722h-13.12l1.25-1.408h14.475l3.431 2.062-7.14 4.289z'/%3E %3Cpath fill='%23ca3745' d='M199.629 428.23h40.307v-11.706h11.123v-10.646h11.335v-29.396h-11.335v-10.593h-11.123v-11.706H199.63l-16.737-10.116h-17.32l-7.68 7.998h17.584l2.86-2.86h-13.082l2.013-2.278h14.83l18.962 11.44h34.64v11.706h11.176v10.646h11.335v20.975h-11.335v10.646h-11.176v11.706h-34.64l-18.962 11.387h-14.83l-2.013-2.224h13.083l-2.86-2.86h-17.585l7.68 7.998h17.32zm-22.722-4.184h-34.64V412.34h-11.123v-10.646h-11.335v-20.975h11.335v-10.646h11.123v-11.705h34.64l19.014-11.441H210.7l2.013 2.278h-13.03l2.86 2.86h17.585l-7.68-7.998h-17.32l-16.737 10.116h-40.307v11.706h-11.176v10.593h-11.335v29.396h11.335v10.647h11.176v11.705h40.307l16.737 10.117h17.32l7.68-7.998h-17.585l-2.86 2.86h13.03l-2.013 2.224h-14.777z'/%3E %3Cpath fill='%23faae29' d='M188.983 351.59l-11.97 7.203H142.69V370.5h-11.123v10.646h-11.335v20.127h11.335v10.646h11.123v11.706h34.322l11.97 7.15 11.97-7.15h34.322v-11.706h11.176v-10.646h11.335v-20.127H246.45V370.5h-11.176v-11.706h-34.322zm0 2.966l11.282 6.78h32.521v11.705h11.176v10.593h11.282v15.096h-11.282v10.646h-11.176v11.705h-32.521l-11.282 6.78-11.229-6.78h-32.521v-11.705h-11.176V398.73h-11.334v-15.096h11.334v-10.593h11.176v-11.705h32.521z'/%3E %3Cpath fill='%2328ae66' d='M232.342 408.954v11.717h-32.2l-11.145 6.696-11.144-6.696h-32.2v-11.717h-11.166v-10.628h-11.316V384.08h11.316v-10.627h11.166v-11.717h32.2l11.144-6.696 11.145 6.696h32.2v11.717h11.165v10.627h11.316v14.246h-11.316v10.628z'/%3E %3Cpath d='M149.869 404.849v11.34h17.7l-17.7-11.74zM149.869 377.558v-11.34h17.7l-17.7 11.739zM228.127 404.849v11.34h-17.7l17.7-11.74zM228.127 377.558v-11.34h-17.7l17.7 11.739z'/%3E %3Cpath fill='%23ca3745' d='M150.298 405.248l15.85 10.513h-15.85zM150.298 377.159c.616-.41 14.77-9.797 15.85-10.513h-15.85v10.513zM227.698 405.248l-15.85 10.513h15.85v-10.513zM227.698 377.159l-15.85-10.513h15.85v10.513z'/%3E %3Cg id='i'%3E %3Cpath d='M172.445 388.094v-5.791h-1.975l-9.477-5.925-.113.071-9.362 5.854h-1.976v5.791h-4.455v6.22h4.455v5.79h1.976l9.475 5.925 9.477-5.925h1.975v-5.79h6.782v-6.22z'/%3E %3Cpath fill='%23ca3745' d='M160.994 376.884l8.668 5.42h-17.335l8.667-5.42zm8.667 23.22l-8.667 5.42-8.666-5.42h17.333zM167.562 388.523v5.363h-10.809v-5.363z'/%3E %3Cg fill='%23faae29'%3E %3Cpath d='M172.017 394.313v5.363h-10.809v-5.363zM160.78 394.313v5.363h-10.809v-5.363zM178.799 388.523v5.363H167.99v-5.363zM156.325 388.523v5.363h-10.809v-5.363zM172.017 382.732v5.362h-10.809v-5.362zM160.78 382.732v5.362h-10.809v-5.362z'/%3E %3C/g%3E %3Cpath d='M153.349 389.714v2.98h-4.855v-2.98zM157.804 383.923v2.98h-4.855v-2.98zM169.04 383.923v2.98h-4.855v-2.98zM164.585 389.714v2.98h-4.855v-2.98zM175.822 389.714v2.98h-4.855v-2.98zM169.04 395.505v2.98h-4.855v-2.98zM157.804 395.505v2.98h-4.855v-2.98z'/%3E %3Cg fill='%23fff'%3E %3Cpath d='M152.891 390.171h-3.94v2.065h3.94zM157.346 384.38h-3.94v2.065h3.94zM168.583 384.38h-3.94v2.065h3.94zM164.128 390.171h-3.94v2.065h3.94zM175.365 390.171h-3.94v2.065h3.94zM168.583 395.962h-3.94v2.065h3.94zM157.346 395.962h-3.94v2.065h3.94z'/%3E %3C/g%3E %3C/g%3E %3Cuse xlink:href='%23i' transform='matrix(-1 0 0 1 377.995 0)'/%3E %3Cg id='j'%3E %3Cpath d='M200.449 378.42v5.79h-1.975l-9.477 5.926-.113-.071-9.362-5.854h-1.976v-5.791h-5.618v-6.22h5.618v-5.79h1.976l9.475-5.926 9.477 5.926h1.975v5.79h5.618v6.22z'/%3E %3Cpath fill='%23faae29' d='M188.998 389.63l8.668-5.42H180.33l8.667 5.42zm8.667-23.22l-8.667-5.42-8.666 5.42h17.333z'/%3E %3Cg fill='%23ca3745'%3E %3Cpath d='M200.021 372.2v-5.362h-10.809v5.362zM188.784 372.2v-5.362h-10.809v5.362zM205.639 377.991v-5.363H194.83v5.363zM194.402 377.991v-5.363h-10.809v5.363zM183.165 377.991v-5.363h-10.808v5.363zM200.021 383.782v-5.363h-10.809v5.363zM188.784 383.782v-5.363h-10.809v5.363z'/%3E %3C/g%3E %3Cpath d='M185.807 368.029v2.98h-4.855v-2.98zM197.044 368.029v2.98h-4.855v-2.98zM180.188 373.82v2.98h-4.855v-2.98zM191.426 373.82v2.98h-4.855v-2.98zM202.663 373.82v2.98h-4.855v-2.98zM185.807 379.611v2.98h-4.855v-2.98zM197.044 379.611v2.98h-4.855v-2.98z'/%3E %3Cg fill='%23fff'%3E %3Cpath d='M185.35 368.486h-3.94v2.065h3.94zM196.587 368.486h-3.94v2.065h3.94zM179.731 374.277h-3.94v2.065h3.94zM190.969 374.277h-3.94v2.065h3.94zM202.205 374.277h-3.94v2.065h3.94zM185.35 380.068h-3.94v2.065h3.94zM196.587 380.068h-3.94v2.065h3.94z'/%3E %3C/g%3E %3C/g%3E %3Cuse xlink:href='%23j' y='31.788'/%3E %3C/g%3E %3Cg%3E %3Cpath d='M127.676 479.354l42.052-22.631h38.539l42.051 22.631v37.29l-42.051 22.63h-38.54l-42.051-22.63z'/%3E %3Cpath fill='%2328ae66' d='M169.863 457.151l-41.738 22.458v36.757l41.738 22.458h38.293l41.74-22.458V479.61l-41.74-22.458h-38.293zm.74 3.019h36.812l39.514 21.239v33.21l-39.514 21.239h-36.834l-39.512-21.24v-33.21z'/%3E %3Cpath fill='%23faae29' d='M189.212 497.784v37.64h18.095l39.183-21.087v-16.124h-57.706v-37.64h-18.095l-39.184 21.086v16.125z'/%3E %3Cpath fill='%23fff' d='M188.783 497.784v37.64h-18.095l-39.183-21.087v-16.124h57.706v-37.64h18.096l39.183 21.086v16.125z'/%3E %3Cpath d='M192.514 533.317v-10.88l-3.517 2.232-3.518-2.231v10.879h-10.942l7.383-5.414v-7.723l-11.26-7.144h-7.867v-30.073h7.868l11.26-7.144v-7.723l-7.384-5.414h10.942v10.88l3.518-2.232 3.517 2.232v-10.88h10.942l-7.383 5.414v7.723l11.26 7.144h7.867v30.073h-7.868l-11.26 7.144v7.723l7.384 5.414z'/%3E %3Cpath fill='%23faae29' d='M192.956 463.135v11.229l-3.761-2.383v3.178l17.214 10.962h5.667v11.655h2.702v-14.407h-7.575l-11.545-7.31V467.9l6.513-4.766h-9.215zm-29.714 35.064v14.407h7.52l11.6 7.361v8.158l-6.514 4.766h9.216v-11.229l3.707 2.385v-3.285l-17.213-10.857h-5.615v-11.706h-2.701z'/%3E %3Cpath fill='%23fff' d='M175.847 463.135l6.515 4.766v8.158l-11.6 7.31h-7.52v14.407h2.7V486.12h5.615l17.214-10.91v-3.23l-3.707 2.383v-11.229h-9.217zm36.229 35.064v11.705h-5.668l-17.214 10.858v3.285l3.761-2.385v11.229h9.216l-6.514-4.766v-8.158l11.546-7.36h7.574v-14.408h-2.701z'/%3E %3Cpath fill='%23ca3745' d='M166.352 509.458h5.338l17.307 10.98 17.307-10.98h5.338v-22.916h-5.338l-17.307-10.981-17.307 10.98h-5.338z'/%3E %3Cpath d='M200.977 503.445h3.695v-1.748h-2.78v-3.179h5.942v8.106h-5.696v5.53h-11.724v-7.946h5.16v3.178h-1.999v1.59h5.402v-3.039l-21.961-13.383h-3.695v1.748h2.78v3.178h-5.942v-8.104h5.696v-5.53h11.724v7.945h-5.16v-3.178h1.999v-1.589h-5.402v3.038zm-2-13.383v-3.038h-5.402v1.589h1.999v3.178h-5.16v-7.945h11.725v5.53h5.695v8.104h-5.941v-3.178h2.78v-1.748h-3.696l-21.96 13.383v3.038h5.4v-1.59h-1.998v-3.177h5.16v7.945h-11.724v-5.53h-5.696v-8.105h5.942v3.179h-2.78v1.748h3.695z'/%3E %3Cpath fill='%23fff' d='M199.406 505.697v3.707h-6.26v-2.446h2v-2.321h-4.303v7.088h10.867v-5.53h5.696v-7.247h-5.085v2.32h2.78v2.606h-4.244l-22.27-13.571v-3.707h6.26v2.446h-1.999v2.321h4.303v-7.088h-10.867v5.53h-5.695v7.247h5.083v-2.321h-2.78v-2.605h4.244zm1.451-13.571h4.245v2.605h-2.78v2.321h5.084v-7.248h-5.695v-5.53h-10.868v7.089h4.303v-2.321h-1.999v-2.446h6.259v3.707l-22.27 13.57h-4.243v-2.605h2.78v-2.321h-5.084v7.248h5.695v5.53h10.867v-7.089h-4.303v2.322h1.999v2.445h-6.26v-3.707z'/%3E %3Cpath d='M238.042 499.884v11.762h-5.005v-4.154h-5.046v4.154h-5.005v-11.762h5.005v4.154h5.046v-4.154zM220.132 515.499v11.762h-5.005v-4.154h-5.046v4.154h-5.005v-11.762h5.005v4.154h5.046V515.5zM238.042 496.113v-11.762h-5.005v4.154h-5.046v-4.154h-5.005v11.762h5.005v-4.154h5.046v4.154zM139.953 499.884v11.762h5.005v-4.154h5.046v4.154h5.005v-11.762h-5.005v4.154h-5.046v-4.154zM139.953 496.113v-11.762h5.005v4.154h5.046v-4.154h5.005v11.762h-5.005v-4.154h-5.046v4.154zM220.132 480.499v-11.762h-5.005v4.154h-5.046v-4.154h-5.005V480.5h5.005v-4.154h5.046v4.154zM157.864 515.499v11.762h5.005v-4.154h5.046v4.154h5.005v-11.762h-5.005v4.154h-5.046V515.5zM157.864 480.499v-11.762h5.005v4.154h5.046v-4.154h5.005V480.5h-5.005v-4.154h-5.046v4.154zM223.118 472.256v8.932h16.597zM154.877 523.742v-8.932H138.28zM154.877 472.256v8.932H138.28zM223.118 523.742v-8.932h16.597z'/%3E %3Cg fill='%23ca3745'%3E %3Cpath d='M233.465 507.064v4.154h4.148v-10.905h-4.148v4.154h-5.903v-4.154h-4.148v10.905h4.148v-4.154zM215.555 522.678v4.154h4.148v-10.905h-4.148v4.154h-5.903v-4.154h-4.148v10.905h4.148v-4.154zM233.465 488.934v-4.154h4.148v10.905h-4.148v-4.155h-5.903v4.155h-4.148V484.78h4.148v4.154zM144.53 507.064v4.154h-4.148v-10.905h4.148v4.154h5.903v-4.154h4.148v10.905h-4.148v-4.154zM144.53 488.934v-4.154h-4.148v10.905h4.148v-4.155h5.903v4.155h4.148V484.78h-4.148v4.154zM215.555 473.32v-4.154h4.148v10.905h-4.148v-4.155h-5.903v4.155h-4.148v-10.905h4.148v4.154zM162.44 522.678v4.154h-4.148v-10.905h4.148v4.154h5.903v-4.154h4.148v10.905h-4.148v-4.154zM162.44 473.32v-4.154h-4.148v10.905h4.148v-4.155h5.903v4.155h4.148v-10.905h-4.148v4.154z'/%3E %3C/g%3E %3Cpath fill='%23faae29' d='M223.57 472.986v7.786h14.461l-14.461-7.786zm-83.58 42.268l14.46 7.786v-7.786h-14.46z'/%3E %3Cpath fill='%23fff' d='M154.449 472.986l-14.46 7.786h14.46v-7.786zm69.12 42.268v7.786l14.461-7.786h-14.46z'/%3E %3C/g%3E %3C/g%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='-60 -40 120 80'%3E %3Cg fill='%23E70013'%3E %3Crect x='-60' y='-40' width='120' height='80'/%3E %3Ccircle fill='%23FFF' r='20'/%3E %3Ccircle r='15'/%3E %3Ccircle fill='%23FFF' cx='4' r='12'/%3E %3Cpath transform='translate(4)scale(9)rotate(-90)' d='M0,-1 L0.58779,0.80902 L-0.95106,-0.30902 L0.95106,-0.30902 L-0.58779,0.80902z'/%3E %3C/g%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 96 48'%3E %3Cg fill='%23C10000'%3E %3Crect width='96' height='48'/%3E %3Crect width='40' fill='%23fff' height='24'/%3E %3Crect x='17' y='3' width='6' height='18'/%3E %3Crect x='11' y='9' width='18' height='6'/%3E %3C/g%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1200 800'%3E %3Crect width='1200' height='800' fill='%23E30A17'/%3E %3Ccircle cx='425' cy='400' r='200' style='fill:%23ffffff'/%3E %3Ccircle cx='475' cy='400' r='160' style='fill:%23E30A17'/%3E %3Cpolygon style='fill:%23ffffff' points='583.334,400 764.235,458.779 652.431,304.894 652.431,495.106 764.235,341.221'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 18'%3E %3Crect fill='%23CE1126' width='30' height='18'/%3E %3Cpolygon fill='%23FFF' points='0,0 20.824734,18 30,18 9.175266,0'/%3E %3Cpolygon points='1.52921,0 22.353945,18 28.470789,18 7.646055,0'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 1200 600'%3E %3Cdefs%3E %3CclipPath id='c'%3E %3Cpath d='M0,0V150H700V300H600zM0,300V400H300V0H600z'/%3E %3C/clipPath%3E %3Cpath id='star' fill='%23ffce00' d='M0,-50.0808 29.4368,40.5162 -47.6297,-15.4758H47.6297L-29.4368,40.5172z'/%3E %3Cuse id='rats' xlink:href='%23star' transform='rotate(36)'/%3E %3C/defs%3E %3Crect width='1200' height='600' fill='%2300247d'/%3E %3Cpath d='M0,0 600,300M0,300 600,0' stroke='%23fff' stroke-width='60'/%3E %3Cpath d='M0,0 600,300M0,300 600,0' stroke='%23cf142b' stroke-width='40' clip-path='url(%23c)'/%3E %3Cpath d='M300,0V400M0,150H700' stroke='%23fff' stroke-width='100'/%3E %3Cpath d='M300,0V400M0,150H700' stroke='%23cf142b' stroke-width='60'/%3E %3Cpath d='M0,300H600V0H1200V600H0z' fill='%235b97b1'/%3E %3Cuse xlink:href='%23star' x='645.3396' y='540.9936'/%3E %3Cuse xlink:href='%23rats' x='788.0256' y='504.516'/%3E %3Cuse xlink:href='%23rats' x='788.0256' y='382.5324'/%3E %3Cuse xlink:href='%23rats' x='914.0304' y='473.6844'/%3E %3Cuse xlink:href='%23rats' x='914.0304' y='208.2708'/%3E %3Cuse xlink:href='%23star' x='996.4416' y='390.0456'/%3E %3Cuse xlink:href='%23rats' x='1019.928' y='172.0776'/%3E %3Cuse xlink:href='%23star' x='1102.836' y='321.5544'/%3E %3Cuse xlink:href='%23star' x='1102.836' y='87.486'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='-60 -40 240 160'%3E %3Crect x='-60' y='-40' width='100%25' height='100%25' fill='%23fe0000'/%3E %3Crect x='-60' y='-40' width='50%25' height='50%25' fill='%23000095'/%3E %3Cpath id='four_rays' d='M 8,0 L 0,30 L -8,0 L 0,-30 M 0,8 L 30,0 L 0,-8 L -30,0' fill='%23fff'/%3E %3Cuse xlink:href='%23four_rays' transform='rotate(30)'/%3E %3Cuse xlink:href='%23four_rays' transform='rotate(60)'/%3E %3Ccircle r='17' fill='%23000095'/%3E %3Ccircle r='15' fill='%23fff'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 72 48'%3E %3Cpath d='M0,48V0H72z' fill='%231eb53a'/%3E %3Cpath d='M0,48H72V0z' fill='%2300a3dd'/%3E %3Cpath d='M0,48 72,0' stroke='%23fcd116' stroke-width='19'/%3E %3Cpath d='M0,48 72,0' stroke='%23000' stroke-width='13'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1200 800'%3E %3Crect width='1200' height='800' fill='%23005BBB'/%3E %3Crect width='1200' height='400' y='400' fill='%23FFD500'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 900 600'%3E %3Crect width='900' height='600'/%3E %3Crect y='100' width='900' height='100' fill='%23fcdc04'/%3E %3Crect y='200' width='900' height='100' fill='%23d90000'/%3E %3Crect y='400' width='900' height='100' fill='%23fcdc04'/%3E %3Crect y='500' width='900' height='100' fill='%23d90000'/%3E %3Ccircle cx='450' cy='300' r='93.5' fill='%23fff'/%3E %3Cg stroke='%23000'%3E %3Cpath d='M 433.52031,228.39062 L 427.45593,217.22033 C 429.79607,214.8802 433.73312,213.07128 440.0095,213.07128 C 440.0095,213.49691 439.37106,225.30563 439.37106,225.30563 z' fill='%23d90000'/%3E %3Cpath d='M 439.37106,225.41204 L 440.22231,213.07128 C 440.22231,213.07128 452.77588,212.32724 459.5843,220.51813 C 459.6907,220.41173 452.88229,230.09231 452.88229,230.09231 z' fill='%23fcdc04'/%3E %3Cpath d='M 453.0951,229.98591 L 459.26508,220.41173 C 463.41413,224.7736 465.11583,227.85858 465.75427,232.53967 C 465.86068,232.64608 455.96728,234.98622 455.96728,234.87981 C 455.96728,234.7734 453.20151,230.09231 453.0951,229.98591 z' fill='%23d90000'/%3E %3Cpath d='M 436.60529,388.07318 C 436.60529,388.07318 448.2012,374.77476 470.75458,377.64774 C 467.35037,372.1154 456.3929,372.75384 456.3929,372.75384 C 456.3929,372.75384 452.9887,346.90266 455.64806,345.62578 C 458.30741,344.3489 469.5841,345.73219 469.5841,345.73219 C 471.07299,345.73219 473.62675,341.68954 471.60583,339.13659 C 469.5841,336.58282 463.62694,326.79583 466.07349,324.88051 C 468.52085,322.966 481.81845,325.94457 481.81845,325.94457 L 444.26496,277.85924 C 444.26496,277.85924 440.43513,259.77414 448.09479,251.0504 C 457.35057,243.39073 456.3929,235.09262 456.07368,235.19903 C 454.7968,226.79451 442.03123,220.73014 433.4139,228.49702 C 428.30718,234.667 431.71139,239.34808 431.71139,239.34808 C 431.71139,239.34808 418.30738,242.9651 417.77534,245.30524 C 417.24331,247.64619 432.88186,244.88043 432.88186,244.88043 L 431.39217,255.62508 C 431.39217,255.62508 400.96631,283.28436 424.26453,307.22103 C 424.47735,307.11462 425.00938,306.15696 425.00938,306.15696 C 425.00938,306.15696 433.20108,316.26399 441.8176,318.49772 C 449.9029,326.79583 449.15886,325.51895 449.15886,325.51895 C 449.15886,325.51895 450.75415,338.60455 449.26527,341.1575 C 447.24354,340.51906 426.60548,339.77503 423.51969,340.94469 C 420.75392,341.79595 410.11567,341.26391 412.77503,358.60498 C 414.79595,353.92389 416.60487,349.77483 416.60487,349.77483 C 416.60487,349.77483 416.28565,356.05121 418.83941,358.28576 C 418.41378,351.68935 421.28595,347.22188 421.28595,347.22188 C 421.28595,347.22188 421.81799,354.45592 423.41328,355.51918 C 425.00938,356.58325 425.00938,343.81686 433.83953,344.88093 C 442.66886,345.945 449.05246,345.62578 449.05246,345.62578 C 449.05246,345.62578 452.03104,370.6257 451.07337,372.96665 C 444.68977,371.47696 429.47766,373.60509 428.52,377.43493 C 437.45573,376.90289 441.6056,377.96615 441.6056,377.96615 C 441.6056,377.96615 434.37156,384.34975 436.60529,388.07318 z'/%3E %3Cpath d='M 440.19145,251.66041 C 440.19145,251.66041 418.05232,276.06251 427.60376,294.73569 C 428.11224,292.13157 427.89049,290.49566 428.20971,290.60207 C 427.67768,290.28285 430.95517,292.8488 430.7058,292.34925 C 430.77566,290.99927 429.70753,288.10598 429.70753,288.10598 C 430.7058,288.35534 431.70489,288.60552 432.70317,288.85488 C 432.12077,287.77295 431.53756,286.69182 430.95517,285.60988 C 432.37014,285.7764 433.78429,285.9421 435.19926,286.10861 C 435.19926,286.10861 433.70144,282.1147 434.20098,282.1147 C 434.69972,282.1147 437.69535,282.36407 437.69535,282.36407 C 431.39948,271.06545 437.33877,261.68215 440.19145,251.66041 z' fill='%239ca69c' stroke='%239ca69c'/%3E %3Cpath d='M 447.88198,230.73075 C 447.88198,230.73075 449.05246,239.13527 444.47777,241.58182 C 443.73293,242.11385 440.86075,243.07151 441.28638,244.77402 C 441.81841,247.11416 443.09448,246.68853 444.9034,246.2629 C 449.69008,245.41165 455.22243,235.19903 447.88198,230.73075 z' fill='%239ca69c' stroke='%239ca69c'/%3E %3Ccircle cx='438' cy='238' r='1.8' fill='%23fff' stroke='none'/%3E %3Cpath d='M 432.56264,244.98602 C 431.39217,245.94368 425.2222,252.32728 431.28576,254.66742 C 437.56295,252.96491 435.86044,251.79525 437.24373,250.41196 C 437.27947,247.53979 434.12301,246.79494 432.56264,244.98602 z' fill='%23d90000'/%3E %3Cpath d='M 445.96666,305.30652 C 445.64744,306.68981 444.26496,311.79571 446.17947,315.73195 C 451.499,313.49822 453.94555,314.13585 455.75446,315.30633 C 451.39341,311.79571 449.6909,310.30602 445.96666,305.30652 z' fill='%239ca69c' stroke='%239ca69c'/%3E %3Cpath d='M 455.11602,329.45519 L 455.43524,341.37032 C 455.43524,341.37032 459.5843,342.11517 461.49881,341.37032 C 463.41413,340.62547 461.3924,333.07221 455.11602,329.45519 z' fill='%23fff' stroke='%23fff'/%3E %3Cpath d='M 485.22266,330.94488 C 485.22266,330.94488 477.56299,312.43415 457.98819,307.75307 C 438.4134,303.07198 440.96635,282.22111 442.56245,280.94423 C 443.41371,279.13531 444.05215,276.36954 449.69008,279.02971 C 455.32883,281.68907 481.28642,294.77387 485.00985,295.41231 C 488.73327,296.05075 485.54188,331.37051 485.22266,330.94488 z' fill='%239ca69c'/%3E %3Cpath d='M 466.60552,307.64666 C 466.2863,307.85947 492.77592,323.2844 484.79703,336.58282 C 492.35111,331.58251 489.90375,322.85959 489.90375,322.85959 C 489.90375,322.85959 496.07372,338.92377 481.07361,346.79626 C 482.66971,348.17954 483.73378,347.85951 483.73378,347.85951 L 481.18001,350.41328 C 481.18001,350.41328 480.00954,352.32779 490.11656,347.43388 C 487.34999,349.66843 487.13798,351.26372 487.13798,351.26372 C 487.13798,351.26372 487.88202,353.39185 494.47843,347.6467 C 489.1589,353.39185 487.98843,356.37043 487.98843,356.26403 C 502.3501,354.98715 533.62722,308.2851 478.09503,294.45465 C 481.07442,297.54044 480.64798,297.11482 480.64798,297.11482 z' fill='%23d90000'/%3E %3Cpath d='M 467.776,303.07198 C 471.39302,305.62493 472.66909,306.47618 473.09472,307.75307 C 469.79692,307.00903 466.81834,307.22103 466.81834,307.22103 C 466.81834,307.22103 459.6907,300.41262 458.41382,299.88058 C 457.45616,299.88058 451.92463,296.36997 451.92463,296.36997 C 449.15886,294.98668 446.60591,285.4125 456.81853,288.17827 C 467.34956,293.17776 468.83926,293.6042 468.83926,293.6042 C 473.02405,294.91601 477.20803,296.22864 481.39283,297.54044 C 483.80444,300.23554 486.21525,302.93064 488.62687,305.62574 C 488.62687,305.62574 475.75489,299.24214 474.15879,299.13574 C 477.6694,302.00791 479.69113,305.94415 479.69113,305.94415 C 475.61274,304.77367 472.0672,303.71042 467.776,303.07198 z' fill='%23fff'/%3E %3Cpath d='M 417.66893,245.94368 C 417.66893,245.94368 430.00969,242.9651 431.49858,243.39073' stroke='%23fff'/%3E %3C/g%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 7410 3900'%3E %3Crect width='7410' height='3900' fill='%23b22234'/%3E %3Cpath d='M0,450H7410m0,600H0m0,600H7410m0,600H0m0,600H7410m0,600H0' stroke='%23fff' stroke-width='300'/%3E %3Crect width='2964' height='2100' fill='%233c3b6e'/%3E %3Cg fill='%23fff'%3E %3Cg id='s18'%3E %3Cg id='s9'%3E %3Cg id='s5'%3E %3Cg id='s4'%3E %3Cpath id='s' d='M247,90 317.534230,307.082039 132.873218,172.917961H361.126782L176.465770,307.082039z'/%3E %3Cuse xlink:href='%23s' y='420'/%3E %3Cuse xlink:href='%23s' y='840'/%3E %3Cuse xlink:href='%23s' y='1260'/%3E %3C/g%3E %3Cuse xlink:href='%23s' y='1680'/%3E %3C/g%3E %3Cuse xlink:href='%23s4' x='247' y='210'/%3E %3C/g%3E %3Cuse xlink:href='%23s9' x='494'/%3E %3C/g%3E %3Cuse xlink:href='%23s18' x='988'/%3E %3Cuse xlink:href='%23s9' x='1976'/%3E %3Cuse xlink:href='%23s5' x='2470'/%3E %3C/g%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 7410 3900'%3E %3Crect width='7410' height='3900' fill='%23b22234'/%3E %3Cpath d='M0,450H7410m0,600H0m0,600H7410m0,600H0m0,600H7410m0,600H0' stroke='%23fff' stroke-width='300'/%3E %3Crect width='2964' height='2100' fill='%233c3b6e'/%3E %3Cg fill='%23fff'%3E %3Cg id='s18'%3E %3Cg id='s9'%3E %3Cg id='s5'%3E %3Cg id='s4'%3E %3Cpath id='s' d='M247,90 317.534230,307.082039 132.873218,172.917961H361.126782L176.465770,307.082039z'/%3E %3Cuse xlink:href='%23s' y='420'/%3E %3Cuse xlink:href='%23s' y='840'/%3E %3Cuse xlink:href='%23s' y='1260'/%3E %3C/g%3E %3Cuse xlink:href='%23s' y='1680'/%3E %3C/g%3E %3Cuse xlink:href='%23s4' x='247' y='210'/%3E %3C/g%3E %3Cuse xlink:href='%23s9' x='494'/%3E %3C/g%3E %3Cuse xlink:href='%23s18' x='988'/%3E %3Cuse xlink:href='%23s9' x='1976'/%3E %3Cuse xlink:href='%23s5' x='2470'/%3E %3C/g%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='-5 -5 27 18'%3E %3Ctitle%3EFlag of Uruguay%3C/title%3E %3Crect x='-5' y='-5' width='27' height='18' fill='%23fff'/%3E %3Cg fill='%230038a8'%3E %3Crect x='5' y='-3' width='17' height='2'/%3E %3Crect x='5' y='1' width='17' height='2'/%3E %3Crect x='-5' y='5' width='27' height='2'/%3E %3Crect x='-5' y='9' width='27' height='2'/%3E %3C/g%3E %3Cg transform='scale(0.11)' fill='%23fcd116' stroke='%23000' stroke-width='0.6' stroke-miterlimit='20'%3E %3Cg id='u'%3E %3Cg id='t'%3E %3Cg id='s'%3E %3Cg transform='rotate(22.5)'%3E %3Cpath d='M 1.5,9 6,12 C -2,25 7,27 0,33 3,26 -3,28 -3,16' stroke-linecap='square'/%3E %3Cpath d='M 0,11 C -2,24 4.5,28 0,33' fill='none'/%3E %3C/g%3E %3Cpath d='M 0,0 h 6 l -6,33 l -6,-33 h 6 v 33'/%3E %3C/g%3E %3Cuse xlink:href='%23s' transform='rotate(45)'/%3E %3C/g%3E %3Cuse xlink:href='%23t' transform='rotate(90)'/%3E %3C/g%3E %3Cuse xlink:href='%23u' transform='rotate(180)'/%3E %3Ccircle r='11'/%3E %3C/g%3E %3Cg transform='scale(0.011)'%3E %3Cg id='right'%3E %3Cpath d='M 81,-44 c -7,8 -11,-6 -36,-6 -25,0 -29,15 -33,12 -4,-3 21,-21 29,-22 8,-1 31,7 40,16 M 52,-35 c 7,6 1,19 -6,19 -7,0 -20,-12 -14,-20'/%3E %3Cpath d=' M 19,-26 c 1,-12 11,-14 27,-14 16,0 23,12 29,15 -7,0 -13,-10 -29,-10 -16,0 -16,0 -27,10 M 22,-23 c 4,-6 9,6 20,6 11,0 17,-3 24,-8 7,-5 -10,12 -21,12 -11,0 -26,-6 -23,-10'/%3E %3Cpath d='M 56,-17 c 13,-7 5,-17 0,-19 2,2 10,12 0,19 M 0,43 c 6,0 8,-2 16,-2 8,0 27,11 38,7 -23,9 -14,3 -54,3 h -5 M 58,57 c -4,-7 -3,-5 -11,-16 8,6 10,9 11,16 M 0,67 C 25,67 21,62 54,48 30,51 25,59 0,59 h -5 M 0,30 c 7,0 9,-5 17,-5 8,0 19,3 24,7 1,1 -3,-8 -11,-9 C 22,22 25,9 16,7 c 0,4 3,3 4,9 0,5 -9,5 -11,0 2,8 -4,8 -9,8'/%3E %3C/g%3E %3Cuse xlink:href='%23right' transform='scale(-1,1)'/%3E %3Cpath d='M 0,76 c -5,0 -18,3 0,3 18,0 5,-3 0,-3'/%3E %3C/g%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 500 250'%3E %3Crect width='500' height='250' fill='%231eb53a'/%3E %3Crect width='500' height='125' fill='%230099b5'/%3E %3Crect width='500' height='90' y='80' fill='%23ce1126'/%3E %3Crect width='500' height='80' y='85' fill='%23fff'/%3E %3Ccircle cx='70' cy='40' r='30' fill='%23fff'/%3E %3Ccircle cx='80' cy='40' r='30' fill='%230099b5'/%3E %3Cg fill='%23fff' transform='translate(136,64)'%3E %3Cg id='s3'%3E %3Cg id='s'%3E %3Cg id='f'%3E %3Cg id='t'%3E %3Cpath id='o' d='M0,-6V0H3' transform='rotate(18,0,-6)'/%3E %3Cuse xlink:href='%23o' transform='scale(-1,1)'/%3E %3C/g%3E %3Cuse xlink:href='%23t' transform='rotate(72)'/%3E %3C/g%3E %3Cuse xlink:href='%23t' transform='rotate(-72)'/%3E %3Cuse xlink:href='%23f' transform='rotate(144)'/%3E %3C/g%3E %3Cuse xlink:href='%23s' y='-24'/%3E %3Cuse xlink:href='%23s' y='-48'/%3E %3C/g%3E %3Cuse xlink:href='%23s3' x='24'/%3E %3Cuse xlink:href='%23s3' x='48'/%3E %3Cuse xlink:href='%23s' x='-48'/%3E %3Cuse xlink:href='%23s' x='-24'/%3E %3Cuse xlink:href='%23s' x='-24' y='-24'/%3E %3C/g%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 2500 2500'%3E %3Ctitle%3EFlag of Vatican City%3C/title%3E %3Crect width='2500' height='2500' fill='%23fff'/%3E %3Crect width='1250' height='2500' fill='%23ffe000'/%3E %3Cg id='coa' stroke='%23000' stroke-width='3.205' stroke-linejoin='round'%3E %3Cg id='tiara' fill='%23ce9d09' stroke-linecap='round'%3E %3Cg id='band'%3E %3Cpath fill='%23fff' d='m1781.07 990.292l16.1062 3.84122 25.6631 4.16908 11.7604 1.2926-2.0767 49.9158s-2.8084 33.1782-7.6882 48.9616c-3.6176 11.701-15.781 33.1806-15.781 33.1806l-7.6882 11.7346-45.3199-39.2502s7.7255-10.947 10.5207-16.995c3.5074-7.5891 7.6882-23.8739 7.6882-23.8739l4.451-25.897 2.4279-32.776zm-56.9911 151.477l41.2735 36.0131s-8.3454 7.4281-13.3532 9.7114c-9.8241 4.4794-20.7674 7.5168-31.5621 7.2836-7.7283-0.167-15.3195-2.9727-22.3505-6.1856-15.7215-7.1841-33.0314-14.7311-43.1678-28.7322-3.5868-4.9543-5.0026-11.5703-4.8894-17.6856 0.1281-6.9328 6.2807-19.8312 6.2807-19.8312s2.3909 8.636 5.1333 12.0223c4.513 5.5725 11.1176 9.3021 17.5966 12.3749 4.8475 2.2989 10.1441 4.0219 15.4999 4.336 6.9511 0.4078 14.1627-0.6737 20.6367-3.2371 3.3392-1.3222 8.9021-6.0696 8.9021-6.0696z'/%3E %3Cpath fill='%23fff' d='m1658.65 877.67s3.2943 6.60021 4.297 10.1276c1.7151 6.03329 2.9083 12.326 2.8613 18.5981-0.047 6.28734-1.4684 12.5389-3.1474 18.5982-2.5161 9.0802-6.3199 17.7833-10.3005 26.3235-2.5243 5.41581-6.054 10.3236-8.5837 15.7369-4.0792 8.72864-6.9937 17.956-10.5867 26.8957-2.9986 7.46093-6.8645 14.6102-9.156 22.3178-3.0437 10.2378-4.5617 20.8914-6.0086 31.4738-1.2447 9.103-2.2289 18.2805-2.289 27.468-0.071 10.8993 0.257 21.9099 2.289 32.6182 2.0132 10.6096 4.9766 21.2042 9.7283 30.9015 3.8299 7.8163 8.9314 15.1035 14.8784 21.4595 4.9155 5.2533 10.7063 9.7565 16.8814 13.4478 5.6111 3.3542 11.951 5.3107 18.0259 7.7254 8.392 3.3358 25.4328 9.3354 25.4328 9.3354s-23.527-11.5926-31.7275-21.3526c-6.7839-8.0741-10.5208-18.6192-12.8756-28.8986-2.7273-11.9056-2.3831-24.473-1.1445-36.6239 1.3326-13.0719 5.1794-25.8174 9.156-38.3408 4.1968-13.2172 10.0958-25.835 15.4508-38.6268 3.8591-9.2188 8.276-18.2009 12.0172-27.4681 4.4171-10.9412 8.7643-21.9345 12.3034-33.1905 2.1584-6.86471 4.8495-13.7214 5.4303-20.894 0.6311-7.79253-0.3834-15.7424-2.1702-23.3535-2.5031-10.6626-5.5983-21.6488-11.8358-30.6517-3.7541-5.41848-8.8987-10.1529-14.7694-13.1509-5.7326-2.92745-12.5435-5.40098-18.8584-4.1538-2.1092 0.41656-5.2985 3.6779-5.2985 3.6779z'/%3E %3Cpath fill='%23fff' d='m1711.59 945.594s4.4543-17.9908 5.2084-27.1872c0.6452-7.8667 0.2242-15.8223-0.6069-23.6716-0.9248-8.73396-1.4686-17.7937-4.8557-25.897-3.5136-8.40592-9.0243-16.1296-15.5787-22.4577-6.46-6.23687-14.2939-11.3052-22.6599-14.5671-8.8012-3.43152-18.4915-4.27873-27.9203-4.8557-8.0878-0.49492-16.2402 0.19161-24.2785 1.21393-4.6447 0.59072-9.3229 1.33124-13.7578 2.8325-4.1142 1.39268-11.7346 5.66498-11.7346 5.66498l29.9434 48.9616s9.3726-5.51792 14.5671-6.8789c5.494-1.43944 11.3253-1.54575 16.995-1.21393 5.757 0.33691 11.7257 0.89368 16.9949 3.23714 6.7067 2.98278 12.4901 7.98381 17.5468 13.3041 6.1021 6.41995 11.5485 13.7867 14.9589 21.9611 3.1668 7.59027 3.5823 16.072 4.7213 24.2172 0.2473 1.76811 0.4565 5.33646 0.4565 5.33646z'/%3E %3Cpath d='m1717.05 906.676s-5.3336-16.5594-10.3697-23.474c-5.8495-8.03107-13.3653-15.3911-22.2554-19.8275-9.4283-4.70495-30.9939-6.21691-30.9939-6.21691l11.4135 21.1281-19.9659-0.48705-10.4269-17.4343-19.2319 8.7057-9.5679-15.6448 20.4311-9.47347-9.4144-15.1852 20.4231-1.9427 8.8924 14.7s15.8737 0.0481 23.5878 1.66764c5.2383 1.09979 10.3852 2.90955 15.1204 5.40504 4.5315 2.38821 8.6981 5.52167 12.4464 9.01294 4.5081 4.199 8.7319 8.8641 11.8742 14.1632 3.0537 5.14968 6.5418 16.7274 6.5418 16.7274z'/%3E %3Cpath d='m1581.65 845.092l31.8993 46.5923m-17.9701-54.7363l-15.0315 8.78851-14.3063 10.8728 30.9015 47.2106 13.734-10.5866 14.1198-8.18363z'/%3E %3Cpath d='m1653.79 1035.87l17.8828-36.9101 19.1392 7.6135 7.7552-19.059-19.026-8.86935 9.8713-21.3164-14.0201-6.29475-10.5867 20.4578-19.1933-8.02412-8.4281 19.9631 18.6084 7.80376-17.1675 36.6241z'/%3E %3Cpath d='m1796.92 1024.83l18.2088-0.4047v21.0414l17.5333 0.8317-2.9826 21.3575-16.3572-1.0293s-2.6981 12.5748-5.1215 18.4951c-2.5132 6.1396-9.6623 17.3995-9.6623 17.3995l-19.4228-4.8557s7.0265-11.0483 9.7114-16.995c2.4047-5.3259 5.665-16.5903 5.665-16.5903l-19.9387-2.5165 3.4705-20.1921 18.0868 1.2625z'/%3E %3C/g%3E %3Cuse xlink:href='%23band' transform='matrix(-1,0,0,1,3717.75,0)'/%3E %3Cpath fill='%23fff' d='m1756.66 735.602l-27.4199 29.4458 16.8814 50.9303 9.6654 35.7948-27.723 25.8264 50.7288 71.0499-17.3653 19.8177c-1.8179 2.32887-2.4559 5.66203-2.1441 8.59991 0.2858 2.69342 1.5814 5.46434 3.5766 7.29618 4.5597 4.18658 11.3282 5.13314 17.3106 6.72397 21.0652 5.60173 42.9277 8.10234 64.6643 9.72824 4.6678 0.3492 14.0426 0 14.0426 0s9.3574 0.3505 14.0426 0c21.7366-1.62587 43.5991-4.12651 64.6643-9.72824 5.9824-1.59083 12.7509-2.53739 17.3106-6.72397 1.9952-1.83184 3.2908-4.60276 3.5766-7.29618 0.3118-2.93788-0.3262-6.27104-2.1441-8.59991l-16.3019-35.876 51.819-55.5208-19.7758-17.8337-0.4354-43.2583 16.8814-50.9303-25.4118-25.7241-22.9434-61.258s-4.8005-17.0806-8.8699-24.8929c-2.433-4.67074-5.832-8.79081-9.156-12.8757-3.9828-4.89437-8.0012-9.86994-12.8757-13.8771-4.4164-3.63059-9.5357-6.34555-14.5924-9.01295-5.4329-2.86583-10.8919-5.95625-16.8444-7.47197-6.1395-1.56334-18.9437-1.54098-18.9437-1.54098s-12.7871-0.026-18.9437 1.54098c-5.9526 1.51506-11.4115 4.60614-16.8444 7.47197-5.0567 2.6674-10.176 5.38236-14.5924 9.01295-4.8745 4.00714-8.8929 8.98271-12.8757 13.8771-3.324 4.08485-6.723 8.20492-9.156 12.8757-4.0694 7.81233-8.8699 24.8929-8.8699 24.8929z'/%3E %3Cpath d='m1963.27 933.128s-3.1773-2.84544-4.9603-3.99962c-3.7472-2.4257-7.7685-4.47267-11.9369-6.06964-5.6064-2.14787-11.5532-3.28842-17.3997-4.65339-6.6974-1.56366-13.4146-3.13944-20.2321-4.04642-7.9733-1.06074-16.0331-1.53775-24.0762-1.61857-8.6068-0.0865-25.7932 1.21392-25.7932 1.21392s-17.1689-1.30099-25.7932-1.21392c-8.0431 0.0812-16.1029 0.55783-24.0762 1.61857-6.8175 0.90698-13.5347 2.48276-20.2321 4.04642-5.8465 1.36497-11.7933 2.50552-17.3997 4.65339-4.1684 1.59697-8.1897 3.64394-11.9369 6.06964-1.783 1.15418-4.9603 3.99962-4.9603 3.99962m218.711-42.6925s-5.1828-5.26865-8.6021-5.91895c-2.2098-0.42027-4.7416 0.21473-6.5754 1.51741-2.372 1.68499-3.9554 4.56016-4.6534 7.38473-0.6248 2.52827-0.3529 5.36837 0.6069 7.78937 0.8132 2.05124 2.0996 4.33782 4.1476 5.15919 4.8004 1.92528 15.3837-2.02435 15.3837-2.02435zm5.1557-3.59224c5.8013 0.17064 7.9138 3.10789 9.4541 6.47428m-243.23-2.882l-0.3074 13.9074s10.5833 3.94958 15.3837 2.02435c2.048-0.82135 3.3344-3.10795 4.1476-5.15919 0.9598-2.421 1.2317-5.2611 0.6069-7.78937-0.698-2.82457-2.2814-5.69974-4.6534-7.38473-1.8338-1.30268-4.3681-1.95069-6.5754-1.51741-3.4449 0.67621-8.602 5.91895-8.602 5.91895zm-5.1558-3.59224c-5.8013 0.17064-7.9138 3.10789-9.4541 6.47428m198.167 1.34599l-8.4468-0.94606m-130.044 0.94606l8.4468-0.94606m75.9916 0.81471c-2.8651-0.42255-7.6006-4.2094-7.6006-4.2094m-22.7856 4.2094c2.8651-0.42255 7.6006-4.2094 7.6006-4.2094m140.936-19.3466s-4.2156 3.34715-7.2851 3.85745l-1.211 0.6445s-1.9472 5.72805-3.6621 8.17385c-1.7189 2.45145-6.4648 6.25-6.4648 6.25s-4.787-4.14415-7.7442-4.9512c-1.9395-0.52925-4.1634-0.54345-6.0253 0.21485-1.9759 0.8047-3.5479 2.53495-4.7364 4.30665-1.4037 2.09245-2.7058 4.58275-2.5879 7.0996 0.1411 3.01385 3.877 8.1836 3.877 8.1836l-2.5781 4.51175-3.6621 2.373c-6.3145-1.9131-12.631-3.93545-18.9454-7.53905-1.7321-1.88775-3.3581-4.30185-4.5214-9.0332 0 0 4.5436-2.69345 5.5957-4.95115 1.1824-2.5374 1.6683-6.00595 0.2148-8.39845-1.6161-2.66045-5.2762-4.0421-8.3887-4.0918-2.2801-0.0364-4.6888 1.14055-6.25 2.80275-1.6788 1.7875-2.9748 4.46475-2.5781 6.88475 0.4042 2.4662 4.7363 5.81055 4.7363 5.81055s-1.8003 4.55785-3.8379 5.4297c-6.0115 2.57205-9.9784 4.0405-15.2441 4.8535-5.2104 0.80445-11.0723 1.4648-16.2988-0.0195-3.376-0.95875-6.845-2.7304-8.9649-5.5273-0.6311-0.83265-0.8593-3.00785-0.8593-3.00785s6.4664-1.67915 9.0429-3.6621c2.5589-1.9694 5.2823-4.56845 5.8106-7.7539 0.531-3.20115-1.1709-6.58965-3.0176-9.2578-1.8303-2.6446-4.582-4.73805-7.5293-6.0254-1.3298-0.5809-4.3066-0.64455-4.3066-0.64455s-0.6294 0.5709-0.9375 0.8594c-1.2438 1.59805-2.9535 2.8626-4.7657 3.8086-0.032 0.0185-0.076 0.0508-0.1074 0.0684-0.044 0.0245-0.1285 0.0438-0.1758 0.0684-0.3793 0.18905-0.7491 0.41-1.1328 0.5664-0.1998 0.0815-0.51 0.0933-0.7422 0.15625-1.269 0.42885-2.4707 0.78125-2.4707 0.78125s3.8635 1.19585 4.9512 2.7344c0.6719 0.95035 0.9629 2.10935 1.084 3.31055 0.1485 0.7129 0.2344 1.43385 0.2051 2.1289-0.047 1.10925-0.3223 2.23315-0.7032 3.33005-0.3486 1.27815-0.8392 2.5073-1.6699 3.4961-0.4512 0.53715-1.0035 0.98495-1.5918 1.38675-0.028 0.0227-0.049 0.0558-0.078 0.0781-0.03 0.0231-0.086 0.0362-0.1172 0.0586-1.0379 0.67075-2.2093 1.1684-3.3789 1.49415-1.3714 0.3819-4.186 0.0793-4.2871 0.0684 0.1034 0.0002 5.51-0.01 7.666-1.5625 0.067-0.0431 0.1299-0.092 0.1953-0.1367 1.5102-1.205 2.5998-2.97625 3.2617-4.88285 0.2091-0.7666 0.415-1.54335 0.4883-2.31445 0.096-1.01385 0.1157-2.0935 0.01-3.1445-0.3302-1.5845-1.0609-3.1235-2.2168-4.1504-2.4174-2.1477-9.3244-2.40865-9.4141-2.4121-0.1069 0.004-6.99 0.2671-9.4043 2.4121-1.1559 1.0269-1.8866 2.5659-2.2168 4.1504-0.1059 1.051-0.087 2.13065 0.01 3.1445 0.073 0.7711 0.2792 1.54785 0.4883 2.31445 0.6619 1.9066 1.7515 3.67785 3.2617 4.88285 0.065 0.0447 0.1286 0.0936 0.1953 0.1367 2.1559 1.5529 7.5623 1.5627 7.666 1.5625-0.1011 0.0109-2.9156 0.31355-4.2871-0.0684-1.1696-0.32575-2.341-0.8234-3.3789-1.49415-0.031-0.0224-0.087-0.0355-0.1172-0.0586-0.029-0.0223-0.05-0.0554-0.078-0.0781-0.5883-0.4018-1.1406-0.8496-1.5918-1.38675-0.8306-0.9888-1.3213-2.21795-1.6699-3.4961-0.3809-1.0969-0.6563-2.2208-0.7031-3.33005-0.029-0.69505 0.057-1.416 0.205-2.1289 0.1211-1.2012 0.4219-2.3602 1.0938-3.31055 1.0878-1.53855 4.9414-2.7344 4.9414-2.7344s-1.2009-0.352-2.4707-0.78125c-0.2299-0.0625-0.5344-0.0755-0.7324-0.15625-0.3891-0.15855-0.7679-0.38405-1.1524-0.57615-0.042-0.0218-0.1172-0.0368-0.1562-0.0586-0.026-0.0145-0.062-0.0435-0.088-0.0586-1.8212-0.94695-3.5456-2.2132-4.7949-3.81835-0.3082-0.2885-0.9375-0.8594-0.9375-0.8594s-2.967 0.0637-4.2969 0.64455c-2.9473 1.28735-5.7088 3.3808-7.5391 6.0254-1.8467 2.66815-3.5486 6.05665-3.0176 9.2578 0.5283 3.18545 3.2615 5.7845 5.8204 7.7539 2.5765 1.98295 9.0332 3.6621 9.0332 3.6621s-0.2283 2.1752-0.8594 3.00785c-2.1199 2.7969-5.5889 4.56855-8.9649 5.5273-5.2265 1.48435-11.0884 0.824-16.2988 0.0195-5.2657-0.813-9.2326-2.28145-15.2441-4.8535-2.0376-0.87185-3.8379-5.4297-3.8379-5.4297s4.3321-3.34435 4.7363-5.81055c0.3967-2.42-0.8993-5.09725-2.5781-6.88475-1.5612-1.6622-3.9602-2.83915-6.2403-2.80275-3.1125 0.0497-6.7823 1.43135-8.3984 4.0918-1.4535 2.3925-0.9675 5.86105 0.2149 8.39845 1.0521 2.2577 5.5957 4.95115 5.5957 4.95115-1.1633 4.73135-2.7894 7.14545-4.5215 9.0332-6.3144 3.6036-12.6308 5.62595-18.9453 7.53905l-3.6524-2.373-2.5879-4.51175s3.7359-5.16975 3.877-8.1836c0.1179-2.51685-1.1842-5.00715-2.5879-7.0996-1.1885-1.7717-2.7604-3.50195-4.7363-4.30665-1.8619-0.7583-4.0859-0.7441-6.0254-0.21485-2.9572 0.80705-7.7442 4.9512-7.7442 4.9512s-4.7459-3.79855-6.4648-6.25c-1.7149-2.4458-3.6524-8.17385-3.6524-8.17385l-1.2109-0.6445c-3.0703-0.50455-7.2949-3.85745-7.2949-3.85745l-4.4434 0.9375s-4.1014 2.19525-4.1504 4.1504c-0.067 2.70015 3.7256 3.9183 5.4395 6.00585 1.4706 1.7913 2.8406 3.6673 4.1406 5.58595 1.225 1.80785 2.8428 3.47495 3.4375 5.57615 0.6494 2.29425-0.9739 4.97205 0 7.14845 1.2278 2.74365 3.7734 5.4157 6.7188 6.01565 2.6155 0.53275 7.5879-2.57815 7.5879-2.57815l-0.1465 19.8828 10.3027 9.30665 9.7266 20.3125-3.8575 5.1465 1.1426 10c7.4813-9.58415 20.5018-13.7912 32.1875-17.1484 15.7316-4.5196 44.5698-4.8416 58.0078-4.7168 4.4794 0.0416 7.2559 0.13675 7.2559 0.13675s44.2954-1.44185 65.2539 4.58005c11.6856 3.3576 24.7062 7.5643 32.1875 17.1484l1.1426-10-3.8574-5.1465 9.7265-20.3125 10.3028-9.30665-0.1465-19.8828s4.9724 3.1109 7.5879 2.57815c2.9454-0.59995 5.4909-3.272 6.7187-6.01565 0.9739-2.1764-0.6494-4.8542 0-7.14845 0.5947-2.1012 2.2125-3.7683 3.4375-5.57615 1.3-1.91865 2.6798-3.79465 4.1504-5.58595 1.7139-2.08755 5.4967-3.3057 5.4297-6.00585-0.049-1.95515-4.1504-4.1504-4.1504-4.1504l-4.4434-0.9375zm-148.33-2.6074c1.0489 0.98195 3.1026 2.8469 4.7949 3.81835 0.08 0.0418 0.1633 0.0768 0.2441 0.1172 0.5048 0.26415 1.2018 0.50155 1.8848 0.7324 2.913 0.7925 7.9353 0.26675 8.0469 0.2539h0.01 0.02c0.1114 0.0128 5.1327 0.53605 8.0468-0.2539 0.6767-0.22865 1.3711-0.46095 1.875-0.72265 0.094-0.047 0.1896-0.0878 0.2832-0.1367 1.692-0.9767 3.7202-2.82985 4.7657-3.8086 0.5223-0.6711 0.9659-1.39145 1.2988-2.1582 1.1552-2.6608 1.1017-6.11155-0.2051-8.7012-1.5377-3.0469-5.1755-4.49675-8.0859-6.2793-2.5063-1.53495-7.9125-3.72505-7.9981-3.75975-0.1 0.0405-5.4757 2.22685-7.9785 3.75975-2.9104 1.78255-6.558 3.2324-8.0957 6.2793-1.3068 2.58965-1.3603 6.0404-0.2051 8.7012 0.3329 0.76675 0.7765 1.4871 1.2989 2.1582z'/%3E %3Cpath d='m1980.77 829.789s-10.8864-5.06097-16.5904-6.87893c-10.4126-3.31869-21.2354-5.21582-31.9667-7.28356-12.4669-2.40215-25.2596-3.0515-37.6221-5.94324-3.8919-0.91037-7.5305-2.76907-11.445-3.57657-5.4002-1.11395-11.0611-2.8737-16.4523-1.71675-2.9678 0.6369-7.8193 4.578-7.8193 4.578s-4.8672-3.93997-7.8193-4.578c-5.3894-1.16479-11.0521 0.6028-16.4523 1.71675-3.9145 0.8075-7.5531 2.6662-11.445 3.57657-12.3625 2.89174-25.1552 3.54109-37.6221 5.94324-10.7313 2.06774-21.5541 3.96487-31.9667 7.28356-5.704 1.81796-16.5904 6.87893-16.5904 6.87893m197.457-45.1211s5.3501-2.82415 7.2852-5.05855c1.2834-1.48195 2.5069-3.2978 2.6367-5.25395 0.1511-2.277-0.6209-4.853-2.2266-6.4746-1.5608-1.57635-4.061-2.21855-6.2793-2.22655-1.8556-0.006-3.842 0.6124-5.2539 1.8164-1.63 1.39005-2.7809 3.5372-3.0371 5.66405-0.2186 1.81445 0.5096 3.6987 1.3672 5.3125 1.3002 2.44695 5.5078 6.2207 5.5078 6.2207zm-151.123 0s4.2076-3.77375 5.5078-6.2207c0.8576-1.6138 1.5858-3.49805 1.3672-5.3125-0.2562-2.12685-1.4071-4.274-3.0371-5.66405-1.4119-1.204-3.3983-1.8224-5.2539-1.8164-2.2183 0.008-4.7088 0.6502-6.2696 2.22655-1.6057 1.6216-2.3776 4.1976-2.2265 6.4746 0.1298 1.95615 1.3435 3.772 2.6269 5.25395 1.9351 2.2344 7.2852 5.05855 7.2852 5.05855zm-41.0742 18.0078l-11.9336 15.5762s-0.084 4.10895 0.8105 5.86915c1.2312 2.4238 5.8594 5.66405 5.8594 5.66405l0.8496 21.3868-11.3086 19.5996-0.9863 0.20505 7.2949 3.85745c0.342 0.0562 0.6808 0.11165 0.9863 0.0879 4.3781-0.34225 7.0688-5.2579 10.8789-7.44145 4.8491-2.779 10.0115-4.98805 15.1661-7.1484 7.1244-2.9859 14.3588-5.7335 21.7382-8.0176 9.3031-2.87955 18.6911-5.75975 28.3301-7.14845 7.298-1.0514 14.7122-1.54535 22.0996-1.4453 2.4625 0.0333 4.9209 0.12695 7.3731 0.29295 6.5689 0.44475 19.3704 3.40415 19.4726 3.42775 0.086-0.0198 12.9093-2.9827 19.4824-3.42775 9.8085-0.66405 19.7421-0.2495 29.4727 1.15235 9.639 1.3887 19.027 4.2689 28.3301 7.14845 7.3794 2.2841 14.6139 5.0317 21.7383 8.0176 5.1546 2.16035 10.3169 4.3694 15.166 7.1484 3.8101 2.18355 6.5008 7.0992 10.8789 7.44145 0.3085 0.024 0.6505-0.0304 0.9961-0.0879l7.2851-3.85745-0.9863-0.20505-11.3086-19.5996 0.8496-21.3868s4.638-3.24025 5.8692-5.66405c0.8943-1.7602 0.8007-5.86915 0.8007-5.86915l-11.9335-15.5762c-0.0001 0-6.0157 6.00765-9.9122 7.28515-2.0507 0.67235-4.4136 0.6401-6.4746 0-2.501-0.7768-4.4344-2.81105-6.4746-4.45315-4.6088-3.70965-9.2257-7.54105-12.9492-12.1386-2.1328-2.6335-5.2637-8.7012-5.2637-8.7012s-12.9078 10.1416-20.6347 12.1387c-7.5767 1.95835-15.96 1.6057-23.4668-0.6055-1.8839-0.5549-5.0293-3.0664-5.0293-3.0664-8.8263-5.6214-17.652-8.69745-26.4258-7.85155-8.7738-0.8459-17.5995 2.23015-26.4258 7.85155 0 0-3.1552 2.5115-5.0391 3.0664-7.5068 2.2112-15.89 2.56385-23.4667 0.6055-7.727-1.99715-20.6348-12.1387-20.6348-12.1387s-3.1309 6.0677-5.2637 8.7012c-3.7235 4.5976-8.3404 8.429-12.9492 12.1386-2.0402 1.6421-3.9736 3.67635-6.4746 4.45315-2.061 0.6401-4.4239 0.67235-6.4746 0-3.8965-1.2775-9.9121-7.28515-9.9121-7.28515z'/%3E %3Cpath d='m1985.89 796.364s0.4479-5.70292-0.1618-8.45505c-0.5584-2.5204-1.694-4.94002-3.136-7.08123-1.5129-2.2464-5.6473-5.84156-5.6473-5.84156m-1.4343 27.6901c-0.0001 0 3.3941 0.1231 4.8535-0.6055 2.6029-1.2996 6.0742-6.2695 6.0742-6.2695s6.6614 4.60745 10.3125 4.04295c1.8007-0.2784 3.2946-1.88475 4.248-3.4375 1.0106-1.6457 1.6515-3.78155 1.2207-5.66405-0.3431-1.49915-1.6576-2.6497-2.832-3.6426-2.2813-1.92865-6.3955-1.66185-7.8906-4.24805-1.1818-2.04435-0.4569-4.8105 0.1953-7.08005 1.3607-4.7357 4.7512-8.64825 7.4902-12.7442 1.7395-2.60125 5.2931-4.38305 5.6641-7.49025 0.2006-1.67945-2.0215-4.6582-2.0215-4.6582s-5.2216-0.11815-7.6855 0.61525c-4.0775 1.21385-8.3071 2.99495-11.2012 6.11325-2.4056 2.5919-3.1206 6.36555-4.3848 9.668-0.9609 2.50985-2.4219 7.68555-2.4219 7.68555s-6.0411-0.013-8.7011 1.21095c-3.5158 1.6175-7.1107 4.1574-8.7012 7.6855-1.2473 2.7667-1.0733 6.27265 0 9.11135 1.0815 2.86035 3.4928 5.23565 6.0742 6.875 2.8465 1.80775 9.7071 2.83205 9.7071 2.83205zm-234.71-27.69s-4.1344 3.59516-5.6473 5.84156c-1.442 2.14121-2.5776 4.56083-3.136 7.08123-0.6097 2.75213-0.1618 8.45505-0.1618 8.45505m-16.9364-45.4847s-2.2221 2.97875-2.0215 4.6582c0.371 3.1072 3.9246 4.889 5.6641 7.49025 2.739 4.0959 6.1295 8.00845 7.4902 12.7442 0.6522 2.26955 1.3771 5.0357 0.1953 7.08005-1.4951 2.5862-5.6093 2.3194-7.8906 4.24805-1.1744 0.9929-2.4889 2.14345-2.832 3.6426-0.4308 1.8825 0.2101 4.01835 1.2207 5.66405 0.9534 1.55275 2.4473 3.1591 4.248 3.4375 3.6511 0.5645 10.3125-4.04295 10.3125-4.04295s3.4713 4.9699 6.0743 6.2695c1.4594 0.7286 4.8535 0.6055 4.8535 0.6055s6.8703-1.0243 9.7168-2.83205c2.5814-1.63935 4.9829-4.01465 6.0644-6.875 1.0733-2.8387 1.2473-6.34465 0-9.11135-1.5905-3.5281-5.1854-6.068-8.7012-7.6855-2.66-1.22395-8.7011-1.21095-8.7011-1.21095s-1.461-5.1757-2.4219-7.68555c-1.2642-3.30245-1.9792-7.0761-4.3848-9.668-2.8941-3.1183-7.1236-4.8994-11.2011-6.11325-2.4639-0.7334-7.6856-0.61525-7.6856-0.61525zm135.626 14.3174l8.3246-2.43757 8.3246 2.43757m-14.4926 20.0821s-6.481-5.90993-7.6882-9.91375c-0.5271-1.74815-0.45-3.84915 0.4046-5.46267 1.1684-2.20587 5.8673-4.65339 5.8673-4.65339s-7.0852-3.44282-8.9021-6.67661c-1.0288-1.83119-1.1579-4.24509-0.607-6.27195 0.8741-3.21533 3.2994-5.96975 5.8673-8.09287 3.185-2.63316 11.2261-5.26034 11.2261-5.26034s8.0266 2.61995 11.2261 5.26034c2.5698 2.12081 4.9932 4.87754 5.8673 8.09287 0.5509 2.02686 0.4218 4.44076-0.607 6.27195-1.8169 3.23379-8.9021 6.67661-8.9021 6.67661s4.6989 2.44752 5.8673 4.65339c0.8546 1.61352 0.9317 3.71452 0.4046 5.46267-1.2072 4.00382-7.6882 9.91375-7.6882 9.91375l-6.168 0.40463zm22.6719-26.8875s13.4369 5.72681 17.9891 11.1064c1.2701 1.50095 2.3519 3.50054 2.2255 5.46267-0.4485 6.96199-10.3184 18.2089-10.3184 18.2089l-19.9282-8.28243h-12.9438l-19.9282 8.28243s-9.8699-11.2469-10.3184-18.2089c-0.1264-1.96213 0.9554-3.96172 2.2255-5.46267 4.5522-5.37958 17.9891-11.1064 17.9891-11.1064'/%3E %3Cpath d='m1844.36 669.248l8.0562-6.20056 6.5065 0.13988-6.6557-0.14309s-3.591-2.44764-4.578-4.29188c-0.958-1.79023-1.4152-4.02072-1.0015-6.00863 0.5525-2.65484 2.0852-5.45855 4.4277-6.82475 2.2371-1.30479 7.7551-0.47145 7.7551-0.47145s5.5027-0.84166 7.7551 0.47145c2.3428 1.36572 3.8752 4.16991 4.4277 6.82475 0.4137 1.98791-0.043 4.2184-1.0015 6.00863-0.987 1.84424-4.578 4.29188-4.578 4.29188l-6.6557 0.14309 6.5065-0.13988 8.0562 6.20056m52.5845 5.06845l-2.6798 4.65503m32.6326-20.0046l-7.5149 0.98202m8.513 8.80375l-11.5169 0.60428m-1.4979-13.7479c1.4677 0.93659 4.1545 2.86005 4.5946 4.63497 0.7761 3.12938-0.6743 7.07048-3.1391 9.14891-2.3885 2.01406-9.252 1.50107-9.252 1.50107m-181.69 33.5875s11.2946-2.8202 16.9546-4.17785c8.0811-1.93833 16.0993-4.19579 24.2786-5.665 9.2622-1.66374 18.6201-2.88431 28.0067-3.55413 11.7104-0.83564 35.2159-0.57225 35.2159-0.57225s23.488-0.26449 35.2159 0.57225c9.3866 0.66969 18.7445 1.89039 28.0067 3.55413 8.1793 1.46921 16.1975 3.72667 24.2786 5.665 5.66 1.35765 16.9546 4.17785 16.9546 4.17785m-171.551-30.1651l2.6798 4.65503m-32.6326-20.0046l7.5149 0.98202m-8.513 8.80375l11.5169 0.60428m-6.4754 16.0764s12.5425-3.18763 18.8753-4.50628c6.9234-1.44166 13.8728-2.81916 20.8871-3.71964 8.0675-1.03566 16.1997-1.55541 24.3248-1.92859 9.6296-0.44228 28.917-0.36651 28.917-0.36651s19.2699-0.0764 28.917 0.36651c8.1252 0.37308 16.2573 0.89293 24.3248 1.92859 7.0143 0.90048 13.9637 2.27798 20.8871 3.71964 6.3328 1.31865 18.8753 4.50628 18.8753 4.50628m-170.239-14.5393s-6.8635 0.51299-9.252-1.50107c-2.4648-2.07843-3.9152-6.01953-3.1391-9.14891 0.6108-2.46349 5.5498-5.21314 5.5498-5.21314m63.1382 74.0024c-11.9767 0.7232-24.0098 1.474-35.8108 3.6418-12.2927 2.25809-24.4854 5.39728-36.2155 9.71141-11.113 4.08716-22.8689 22.6434-32.0955 15.2222-1.983-1.59501 0.7525-5.08407 1.7168-7.43927 1.8655-4.55651 4.429-8.93224 7.7254-12.5895 2.4138-2.67809 7.9759-3.02712 8.5837-6.58089 0.4416-2.58142-3.4743-4.09285-4.2918-6.58088-1.0439-3.17647-1.5387-6.81352-0.5723-10.0144 1.2405-4.10872 6.5254-6.17981 7.7254-10.3005 1.043-3.58184-2.5475-7.83256-0.8584-11.1589 2.133-4.20065 11.3369-2.77746 12.0173-7.43927 0.3317-2.27285-3.8251-2.9802-4.578-5.15025-0.5324-1.53446 0.3091-3.24011 0.2861-4.86414-0.031-2.20169 0.392-4.60137-0.5723-6.58088-0.857-1.7593-3.702-2.13985-4.2918-4.00576-0.5582-1.76572-0.1716-4.13356 1.1445-5.43639 1.0368-1.02642 3.6319 0.44281 4.2918-0.85837 1.3318-2.62589-2.5388-5.31434-3.7196-8.01151-1.4064-3.21256-3.2072-6.31351-4.0057-9.72827-0.6313-2.69961-2.9585-6.88614-0.5723-8.29764 2.7325-1.61631 5.4768 3.23869 8.0115 5.15025 3.3453 2.52289 7.1094 4.81707 9.4422 8.29764 1.6831 2.51135 0.7428 6.50932 2.9483 8.57708 2.6468 2.48143 7.7583 0.49134 10.4996 2.86794 2.3561 2.04271 4.4414 5.55009 3.7196 8.58376-0.6897 2.89871-7.5314 2.81792-6.867 5.72252 0.7892 3.45006 6.8133 3.17917 10.3005 2.57514 2.033-0.35214 3.4624-2.24683 5.1503-3.43351 1.3108-0.92157 2.389-2.23216 3.8627-2.86127 1.6908-0.72182 5.4363-0.9299 5.4363-0.9299l-2.1459-0.50072s-3.1717-2.52782-3.505-4.36342c-0.3139-1.72858 0.4369-3.73179 1.6452-5.00719 1.3551-1.43043 3.5376-2.16034 5.5079-2.14594 1.6471 0.0118 3.4459 0.66342 4.578 1.85981 1.1609 1.22684 1.8244 3.11308 1.6452 4.7926-0.1565 1.46787-1.1275 2.87998-2.289 3.79116-1.2578 0.98685-4.578 1.43063-4.578 1.43063l2.289 0.64379 6.1517 8.4407 26.5387-1.45409s3.2734-3.3392 2.6302-5.1592c-0.6891-1.94976-2.503-2.66777-5.665-2.52901-8.5812 0.37659-10.3395-6.82843-10.015-12.0381 0.27-4.33353 5.4839-7.27436 9.5092-8.90214 3.8768-1.56776 10.7873 3.59271 12.5439-0.20233 1.5397-3.32652-5.8181-5.02096-6.9801-8.49749-0.5029-1.50446-0.5077-3.33604 0.2023-4.75454 1.8128-3.62158 5.7132-6.02963 9.408-7.68822 1.5569-0.69888 5.0552-0.80928 5.0552-0.80928s3.4821 0.10463 5.0552 0.80928c3.6961 1.65563 7.5952 4.06664 9.408 7.68822 0.71 1.4185 0.7052 3.25008 0.2023 4.75454-1.162 3.47653-8.5198 5.17097-6.9801 8.49749 1.7566 3.79504 8.6671-1.36543 12.5439 0.20233 4.0253 1.62778 9.2392 4.56861 9.5092 8.90214 0.3245 5.20968-1.4338 12.4147-10.015 12.0381-3.162-0.13876-4.9759 0.57925-5.665 2.52901-0.6432 1.82 2.6302 5.1592 2.6302 5.1592l26.5387 1.45409 6.1517-8.4407 2.289-0.64379s-3.3202-0.44378-4.578-1.43063c-1.1615-0.91118-2.1325-2.32329-2.289-3.79116-0.1792-1.67952 0.4843-3.56576 1.6452-4.7926 1.1321-1.19639 2.9309-1.84798 4.578-1.85981 1.9703-0.0144 4.1528 0.71551 5.5079 2.14594 1.2083 1.2754 1.9591 3.27861 1.6452 5.00719-0.3333 1.8356-3.505 4.36342-3.505 4.36342l-2.1459 0.50072s3.7455 0.20808 5.4363 0.9299c1.4737 0.62911 2.5519 1.9397 3.8627 2.86127 1.6879 1.18668 3.1173 3.08137 5.1503 3.43351 3.4872 0.60403 9.5113 0.87492 10.3005-2.57514 0.6644-2.9046-6.1773-2.82381-6.867-5.72252-0.7218-3.03367 1.3635-6.54105 3.7196-8.58376 2.7413-2.3766 7.8528-0.38651 10.4996-2.86794 2.2055-2.06776 1.2652-6.06573 2.9483-8.57708 2.3328-3.48057 6.0969-5.77475 9.4422-8.29764 2.5347-1.91156 5.279-6.76656 8.0115-5.15025 2.3862 1.4115 0.059 5.59803-0.5723 8.29764-0.7985 3.41476-2.5993 6.51571-4.0057 9.72827-1.1808 2.69717-5.0514 5.38562-3.7196 8.01151 0.6599 1.30118 3.255-0.16805 4.2918 0.85837 1.3161 1.30283 1.7027 3.67067 1.1445 5.43639-0.5898 1.86591-3.4348 2.24646-4.2918 4.00576-0.9643 1.97951-0.5415 4.37919-0.5723 6.58088-0.023 1.62403 0.8185 3.32968 0.2861 4.86414-0.7529 2.17005-4.9097 2.8774-4.578 5.15025 0.6804 4.66181 9.8843 3.23862 12.0173 7.43927 1.6891 3.32633-1.9014 7.57705-0.8584 11.1589 1.2 4.12072 6.4849 6.19181 7.7254 10.3005 0.9664 3.20087 0.4716 6.83792-0.5723 10.0144-0.8175 2.48803-4.7334 3.99946-4.2918 6.58088 0.6078 3.55377 6.1699 3.9028 8.5837 6.58089 3.2964 3.65727 5.8599 8.033 7.7254 12.5895 0.9643 2.3552 3.6998 5.84426 1.7168 7.43927-9.2266 7.42112-20.9825-11.1351-32.0955-15.2222-11.7301-4.31413-23.9228-7.45332-36.2155-9.71141-11.801-2.1678-23.8341-2.91831-35.8108-3.6418-6.9678-0.42091-20.9375-0.40462-20.9375-0.40462s-13.9523-0.0172-20.9375 0.40462z'/%3E %3Cpath d='m1869.06 595.401l-10.1836 0.11745-10.1836-0.11745m16.9312-33.8799c2.6422-5.60081-1.9753-9.7497-6.7476-13.8571-4.7723 4.10743-9.3897 8.25632-6.7475 13.8571m14.0661 46.73c3.8943 0.2869 8.6316 4.26757 11.5881 1.71675 1.336-1.1526 0.6752-3.66318 0-5.29332-1.5743-3.80071-8.4131-4.62493-8.7268-8.72683-0.2706-3.53784 5.1908-5.2117 6.2948-8.58376 0.5489-1.67687 0.6808-3.66554 0-5.29332-2.7515-6.57773-14.4931-6.95114-16.5271-13.6805-0.9011-2.98148 5.9324-6.49335 6.7999-6.86893 4.3393-1.87871 9.7036 2.65867 13.9877 0.7993 2.899-1.25827 6.1252-4.1237 6.0696-7.28357-0.06-3.43827-3.7256-6.31645-6.8789-7.68821-6.1079-2.65702-16.2205 5.9042-19.9783 0.40464-3.4586-5.06171 8.643-11.0806 7.0297-16.995-0.7665-2.81003-6.9773-5.26035-6.9773-5.26035s-6.2021 2.43824-6.9773 5.26035c-1.6239 5.91151 10.4883 11.9333 7.0297 16.995-3.7578 5.49956-13.8704-3.06166-19.9783-0.40464-3.1533 1.37176-6.8184 4.24994-6.8789 7.68821-0.056 3.15987 3.1706 6.0253 6.0696 7.28357 4.2841 1.85937 9.6484-2.67801 13.9877-0.7993 0.8674 0.37558 7.701 3.88745 6.7999 6.86893-2.034 6.7294-13.7756 7.10281-16.5271 13.6805-0.6809 1.62778-0.5489 3.61645 0 5.29332 1.1039 3.37206 6.5654 5.04592 6.2948 8.58376-0.3137 4.1019-7.1525 4.92612-8.7268 8.72683-0.6753 1.63014-1.336 4.14072 0 5.29332 2.9565 2.55082 7.6937-1.42985 11.588-1.71675 2.433-0.17924 7.3187 0 7.3187 0s4.8683-0.18054 7.3186 0z'/%3E %3Cpath fill='none' d='m1953.74 953.499s-7.1544-3.01914-10.8036-4.34009c-6.5977-2.3883-13.2592-4.63213-20.0298-6.47428-6.5995-1.79562-13.2329-3.68914-20.0298-4.45107-14.5762-1.63399-44.0021-0.20232-44.0021-0.20232s-29.4085-1.43357-44.0021 0.20232c-6.7969 0.76191-13.4303 2.65545-20.0298 4.45107-6.7706 1.84215-13.4321 4.08598-20.0298 6.47428-3.6492 1.32095-10.8036 4.34009-10.8036 4.34009m201.899-222.5s-11.9524-4.75619-18.0259-6.86702c-5.1003-1.77255-10.2059-3.58154-15.4508-4.86412-6.3972-1.56438-12.932-2.53824-19.4565-3.43352-9.3932-1.28887-18.8433-2.20847-28.307-2.78448-8.5842-0.52248-25.7932-0.60697-25.7932-0.60697s-17.1915 0.0836-25.7932 0.60697c-9.4637 0.57579-18.9138 1.49561-28.307 2.78448-6.5245 0.89528-13.0593 1.86914-19.4565 3.43352-5.2449 1.28258-10.3505 3.09157-15.4508 4.86412-6.0735 2.11083-18.0259 6.86702-18.0259 6.86702m-14.1568 120.41s17.5596-5.91847 26.4055-8.671c9.1286-2.84052 18.1733-6.06275 27.5157-8.09285 11.184-2.43029 22.6108-3.62932 33.9899-4.85571 11.0585-1.19184 33.2791-2.42786 33.2791-2.42786s22.2032 1.23478 33.2791 2.42786c11.3792 1.22574 22.8059 2.42542 33.9899 4.85571 9.3424 2.0301 18.3871 5.25233 27.5157 8.09285 8.8459 2.75253 26.4055 8.671 26.4055 8.671'/%3E %3C/g%3E %3Cg id='silverkey' fill='%23ccc'%3E %3Cg id='keybase'%3E %3Cpath d='m1533.28 904.042l101.171 86.7132s-5.1334 11.2137-7.279 16.9889c-1.9789 5.3266-3.8171 10.7271-5.1455 16.252-1.9584 8.145-4.1351 24.7886-4.1351 24.7886l-117.942-108.035c1.6729-24.6894 15.5662-33.4882 33.3308-36.7078z'/%3E %3Cpath d='m1518.99 958.197l-24.2832 27.1672 15.1647 14.5924-23.4623 22.89-15.1647-15.1647-25.5145 27.2017-0.2368 33.7431 58.0835 45.4939 20.0288-14.8785-1.1445-32.3322 15.4508 8.5838 15.4508-9.4422 0.8583 29.1849-12.5895-9.1561-13.734 18.0259-1.4306 32.0461 43.7772 38.9131 53.0494-47.0794-4.0084-14.1122-2.3054-12.678-1.2464-25.1286 1.9803-27.4395z'/%3E %3Cpath d='m1494.71 985.364l-0.6211 29.9932 15.6428-15.2612z'/%3E %3Cpath fill='none' d='m1571.935 1140.425l-1.8207 34.26245m-18.6096 -139.675l0.6445 31.7845m-14.8106 -17.3405l0.8297 25.8846m-14.425 -36.3405l0.5416 28.9249m-21.4347 15.2245l0.3115 30.6476m24.7368 -9.675l44.0639 36.8974 45.0552 -39.54m-171.018 -66.875l57.579 49.1932 18.8843 -16.8814 -14.8785 -12.5895 16.5953 -15.7369 12.8756 11.1589 14.5924 -14.8785 18.8843 18.312 -17.1507 13.4474 16.0062 14.5929 -15.1647 14.0202'/%3E %3Cpath d='m1901.35 1229.35l48.6021 44.5794 10.7633 31.4287-62.6421-6.6732-35.6637-35.2765-37.9692-35.1752-164.039-142.138s3.4783-13.1014 5.635-19.5218c3.124-9.3004 6.8664-18.3846 10.5645-27.472 0.9279-2.2802 2.9156-6.7855 2.9156-6.7855l183.014 162.24z'/%3E %3Cpath d='m1942.67 1236.04c27.0945 37.8682 72.6912 73.6383 86.5365 90.8418 13.8452 17.2034 22.7646 33.5407 2.5831 55.5383-20.1814 21.9976-43.064 9.5153-61.1352-2.5832-18.0712-12.0984-49.6026-51.3029-94.7165-81.3701z'/%3E %3Cpath d='m1926.7 1299.75l-35.1694-15.8738m40.928-38.2875c2.4231 7.9655 0.5742 16.7742 3.624 24.4159 3.0153 7.5554 14.0225 19.9737 14.0225 19.9737s-6.9976 0.9775-10.2616 2.2451c-4.731 1.8372-11.9561 2.7096-13.172 7.6371-1.0633 4.3091 4.0612 8.0262 7.0898 11.2707 2.9045 3.1116 6.6447 5.3721 10.3159 7.5262 6.1364 3.6005 12.391 7.6535 19.393 8.9161 8.7653 1.5806 25.1291-10.7555 26.6468-1.9791 0.6311 3.6495-7.3892 1.3125-10.7131 2.9459-7.7584 3.8123-11.6492 12.1174-4.8208 17.8939 4.3853 3.7097 11.2751 2.3464 16.9994 2.8209 5.4887 0.455 11.7572-2.745 16.5227 0.016 5.6107 3.2507 12.6678 11.1061 9.6914 16.867-3.0627 5.9283-14.4837 5.7692-19.9267 1.9095-4.0245-2.8539-2.947-9.4733-3.5417-14.371-0.1769-1.4578 0-2.937 0-4.4055'/%3E %3Ccircle cx='2154.6649' cy='1480.1466' r='129.6871'/%3E %3Cpath fill='%23fff' d='m2106.13 1485.65c-22.3554 0-40.4781 18.1226-40.4781 40.478 0 22.3555 18.1227 40.4781 40.4781 40.4781s40.4781-18.1226 40.4781-40.4781l14.0261-0.6088c0 22.3554 18.1227 40.4781 40.4781 40.4781s40.4781-18.1227 40.4781-40.4781-18.1227-40.4781-40.4781-40.4781l0.6088-7.9375c22.3555 0 40.4781-18.1227 40.4781-40.4781s-18.1226-40.4781-40.4781-40.4781c-22.3554 0-40.4781 18.1227-40.4781 40.4781l-14.026-1.2177c0-22.3555-18.1227-40.4781-40.4781-40.4781-22.3555 0-40.4781 18.1226-40.4781 40.4781 0 22.3554 18.1226 40.4781 40.4781 40.4781z'/%3E %3Ccircle cx='2154.6667' cy='1446.0519' r='14.61264'/%3E %3Ccircle cx='2189.3667' cy='1480.1479' r='14.61264'/%3E %3Ccircle cx='2155.2767' cy='1511.1999' r='14.61264'/%3E %3Ccircle cx='2119.3467' cy='1480.1479' r='14.61264'/%3E %3Cpath fill='%23fff' d='m2152.23 1558.42c-5.3378 10.9567-12.6202 15.941-21.919 21.919 13.2474 5.754 29.4005 4.6966 43.838 0-9.2987-4.6497-16.0413-11.9958-21.919-21.919zm-76.5786-80.2317c-10.9566-5.3378-15.9409-12.6203-21.919-21.919-5.7539 13.2473-4.6965 29.4005 0 43.838 4.6498-9.2988 11.9959-16.0414 21.919-21.919zm159.246 3.6531c10.9567-5.3378 15.941-12.6203 21.919-21.919 5.754 13.2473 4.6966 29.4005 0 43.838-4.6497-9.2988-11.9958-16.0414-21.919-21.919zm-78.4052-80.8406c-5.3378-10.9566-12.6203-15.9409-21.919-21.919 13.2473-5.7539 29.4005-4.6965 43.838 0-9.2988 4.6498-16.0414 11.9959-21.919 21.919z'/%3E %3C/g%3E %3Cg fill='%23ce9d09'%3E %3Cg id='keydeco'%3E %3Cpath d='m1533.48 903.819s0.7031-5.06124 0.0001-7.43925c-1.1438-3.86881-3.5741-7.46776-6.5809-10.1575-2.5433-2.27495-5.8071-3.92372-9.1561-4.57801-3.6147-0.70621-7.4637-0.11504-11.0158 0.85837-2.4196 0.6631-6.7534 3.32254-6.7534 3.32254l-14.8491 6.11961-5.5107 17.6674s-3.1741 5.5789-3.9314 8.65611c-0.8104 3.29294-1.4088 6.87107-0.5723 10.1574 0.9826 3.86017 3.2315 7.61137 6.2948 10.1574 2.8332 2.35479 6.6269 3.72901 10.3005 4.00577 2.8265 0.21295 8.2977-1.85982 8.2977-1.85982 1.5802-18.6113 9.856-32.8133 33.4766-36.9102z'/%3E %3Cpath d='m1500.27 885.645l-38.7531-17.0196-3.1474 3.00431 21.1189 38.2016s5.9243-8.73821 9.3535-12.7364c3.5106-4.09311 11.4281-11.4499 11.4281-11.4499z'/%3E %3Ccircle cy='865.26332' cx='1457.292' r='15.951473'/%3E %3Cpath d='m1566.19 932.256c3.3899 27.9522 7.3216 55.9043 16.0248 83.8565l31.0688 28.459c-6.625-29.2317-18.4423-58.4633-18.3681-87.695z'/%3E %3Cpath d='m1613.05 972.415l-85.4875-6.36886 27.2007 24.9158 78.0675 3.37974 1.1469-3.98967z'/%3E %3Cpath d='m1718.36 1066.92c-22.4447 8.4602-31.4178 22.3089-37.8571 37.1712-6.3529 0.5589-12.3057 0.6177-14.4104-4.1336 5.3477-34.6998 30.2103-45.5513 35.7531-47.747 14.9497-2.8246 12.1788 8.8497 16.5144 14.7094z'/%3E %3Cpath d='m1745.88 1092.82c-22.4446 8.4601-31.4177 22.3089-37.857 37.1711-6.3529 0.5589-12.3057 0.6177-14.4104-4.1336 5.3477-34.6998 30.2103-45.5512 35.753-47.747 14.9498-2.8246 12.1789 8.8497 16.5144 14.7095z'/%3E %3Cpath d='m2058.66 1354.69c-7.33655 -0.2015 -15.0781 1.5039 -15.0781 1.5039 0.3035 8.02055 -2.9456 16.58265 -11.7969 26.2305 -7.63945 8.32695 -15.6662 11.70345 -23.67185 12.041l-0.01 0.01s-2.8398 17.65195 2.5879 23.25195c6.3562 6.5581 27.11915 3.87695 27.11915 3.87695l1.7676 -1.1325a129.6875 129.6875 0 0 1 31.91405 -39.7949l0.332 -1.2595s3.0386 -16.5234 -2.1484 -21.5c-2.35045 -2.27015 -6.6137 -3.0726 -11.01565 0z'/%3E %3Ccircle cy='1375.4239' cx='2254.5167' r='17.656865'/%3E %3Ccircle cy='1580.0009' cx='2260.6067' r='17.656865'/%3E %3Ccircle cy='1591.5699' cx='2062.1167' r='17.656865'/%3E %3C/g%3E %3C/g%3E %3C/g%3E %3Cg id='goldkey' fill='%23ce9d09' transform='matrix(-1,0,0,1,3718.256,0)'%3E %3Cuse xlink:href='%23keybase'/%3E %3Cuse xlink:href='%23keydeco' fill='%23ccc'/%3E %3C/g%3E %3Cg id='cord'%3E %3Cg fill='%23fa0204'%3E %3Cpath id='piece1' d='m1869.19 1175.78c0 5.3802-4.4998 7.4585-13.2427 7.4585s-12.7861-2.5349-12.7861-7.9152c0-5.3802 4.0432-6.6974 12.7861-6.6974s13.2427 1.7739 13.2427 7.1541z'/%3E %3Cuse xlink:href='%23piece1' x='6.39127' y='14.309'/%3E %3Cpath d='m1877.34 1208.69c-1.772 5.0801-6.7053 5.5604-14.9604 2.681-8.255-2.8795-11.2378-6.6047-9.4658-11.6847 1.772-5.0801 6.0234-4.9922 14.2785-2.1127 8.2551 2.8794 11.9197 6.0364 10.1477 11.1164z'/%3E %3Cpath id='piece2' d='m1877.51 1222.51c-1.065 5.2737-5.8872 6.4202-14.4571 4.6895s-12.0312-5.0159-10.9662-10.2897c1.065-5.2737 5.289-5.7645 13.8588-4.0338 8.5699 1.7306 12.6295 4.3602 11.5645 9.634z'/%3E %3Cuse xlink:href='%23piece2' x='3.95963' y='16.1422'/%3E %3Cpath d='m1921.73 1216.2c-2.5904-0.6912-2.3033-5.3033-1.583-7.8857 1.107-3.9686 8.3538-9.11 8.3538-9.11s1.7671 5.5627 0.9501 8.1851c-1.1615 3.7283-3.948 9.8173-7.7209 8.8106z'/%3E %3Cpath d='m1912.29 1224.42c-2.8216-0.6217-3.1818-5.5227-2.444-8.3162 1.142-4.3238 9.6454-9.3253 9.6454-9.3253s1.4762 6.0417 0.5196 8.831c-1.2669 3.6937-3.9075 9.6508-7.721 8.8105z'/%3E %3Cpath d='m1901.52 1240.01c-4.2916-1.1384-3.8048-8.7623-2.6592-13.0521 0.946-3.5426 3.7155-9.1195 7.2774-8.2489 4.1673 1.0185 4.1144 8.3214 3.1027 12.4905-0.9208 3.7948-3.9464 9.8117-7.7209 8.8105z'/%3E %3Cpath d='m1888.73 1252.19c-4.2142-0.9262-6.0068-7.6384-5.1637-11.8701 0.8851-4.4419 5.3598-10.4103 9.7819-9.4309 4.4624 0.9884 6.0053 8.3528 4.9293 12.7949-1.0033 4.1426-5.3845 9.4211-9.5475 8.5061z'/%3E %3Cpath d='m1886.51 1259.58c-1.0768 5.087-7.5039 6.86-11.4614 5.5691-4.1541-1.355-9.5785-7.1863-8.4416-12.5236 1.1474-5.3859 8.1788-6.8138 12.3239-5.2257 3.8656 1.4809 8.6428 7.1552 7.5791 12.1802z'/%3E %3Cpath d='m1801.47 1210.29s5.1379 2.5312 7.3489 4.7921c2.321 2.3733 5.1107 3.3218 3.709 6.9229-1.4145 3.6339-5.8427 2.3881-8.1269-0.1558-2.1302-2.3723-2.931-11.5592-2.931-11.5592z'/%3E %3Cpath d='m1826.84 1219.06c5.2115 1.0469 5.1081 7.1209 2.4435 10.8465-2.7971 3.9106-10.8836 8.9923-16.3493 7.8872-5.5156-1.1152-4.8437-7.7572-1.7951-11.658 2.843-3.6377 10.5528-8.1097 15.7009-7.0757z'/%3E %3Cpath id='piece3' d='m1844.26 1230.55c4.8531 2.1688 3.4146 8.0709 0 11.1182-3.5896 3.1987-12.5967 6.3749-17.6849 4.0932-5.1345-2.3024-3.0165-8.6334 0.8162-11.767 3.5744-2.9224 12.0797-5.5868 16.8737-3.4444z'/%3E %3Cuse xlink:href='%23piece3' x='13.9976' y='10.6607'/%3E %3Cpath d='m1862.97 1250.68c4.7874 0.7544 6.069 7.4153 4.5846 11.6962-1.5593 4.494-7.4731 10.6689-12.4956 9.8697-5.0684-0.8064-5.9818-8.1322-4.2007-12.6343 1.6611-4.1985 7.3836-9.6772 12.1127-8.932z'/%3E %3Cpath d='m1875.1 1265.33c3.9649 2.3077 3.0331 9.5902 0.4105 13.5334-2.7541 4.1391-9.845 8.622-14.0023 6.1932-4.1951-2.451-2.7353-10.302 0.2157-14.3787 2.7522-3.8018 9.4605-7.6274 13.3771-5.3479z'/%3E %3Cpath d='m1789.02 1225.44c4.2435-0.3761 7.1824 5.9652 7.1269 10.5849-0.059 4.8498-3.317 12.4028-7.771 12.7899-4.4945 0.3906-7.3089-6.7007-7.0653-11.611 0.2273-4.5791 3.5185-11.3927 7.7102-11.7644z'/%3E %3Cpath d='m1802.91 1237.65c4.1568 0.9325 5.0275 7.8673 3.5694 12.2512-1.5316 4.6021-6.9326 10.8061-11.2933 9.82-4.4004-0.9952-4.9243-8.6065-3.1985-13.21 1.6094-4.293 6.8172-9.7825 10.9234-8.8615z'/%3E %3Cpath d='m1815.79 1246.24c4.9212 1.1581 5.952 9.7707 4.2258 15.2152-1.8133 5.7155-8.2076 13.4205-13.3701 12.1958-5.2096-1.2359-5.8298-10.6887-3.7868-16.4059 1.9054-5.3317 8.071-12.1493 12.9322-11.0055z'/%3E %3Cpath d='m1826.22 1256.8c5.0144-0.6444 9.0048 7.0573 9.301 12.7613 0.3098 5.9882-2.9706 15.4482-8.2344 16.115-5.3117 0.6727-9.2128-7.9599-9.3081-14.0304-0.089-5.6613 3.2892-14.2102 8.2424-14.8467z'/%3E %3Cpath id='piece4' d='m1838.59 1265.66c4.5564-0.5341 8.1822 5.85 8.4514 10.578 0.2815 4.9637-2.6993 12.8053-7.4822 13.358-4.8266 0.5576-8.3713-6.5981-8.4579-11.63-0.081-4.6927 2.9887-11.779 7.4895-12.3067z'/%3E %3Cuse xlink:href='%23piece4' x='12.7879' y='10.3504'/%3E %3Cpath id='piece5' d='m1929.28 1250.88c-3.2434 2.8459-9.7124 0.3125-12.6215-2.8742-3.0537-3.345-5.2098-10.4862-1.8005-13.4679 3.4404-3.009 10.2869 0.1121 13.2276 3.611 2.7423 3.263 4.3982 9.9199 1.1944 12.7311z'/%3E %3Cuse xlink:href='%23piece5' x='-6.99906' y='12.7922'/%3E %3Cuse xlink:href='%23piece5' x='-19.4791' y='23.4522'/%3E %3Cpath d='m1905.19 1281.18c-1.1383 4.1621-7.9325 5.6128-12.1161 4.5566-4.3915-1.1087-10.1258-5.8797-8.9239-10.2466 1.2128-4.4066 8.646-5.5749 13.0279-4.2756 4.0865 1.2117 9.1366 5.8543 8.0121 9.9656z'/%3E %3Cpath d='m1887.18 1278.19c3.6414 2.5388 2.7856 10.5507 0.377 14.8888-2.5295 4.5537-9.0418 9.4855-12.86 6.8135-3.8529-2.6965-2.5122-11.3338 0.1981-15.8188 2.5276-4.1825 8.6887-8.3913 12.2858-5.8835z'/%3E %3Cpath d='m1869.62 1287.55c3.9649 2.3077 3.0332 9.5902 0.4105 13.5334-2.7541 4.1392-9.8449 8.622-14.0022 6.1932-4.1952-2.451-2.7354-10.302 0.2157-14.3787 2.7522-3.8017 9.4604-7.6273 13.3771-5.3479z'/%3E %3Cpath id='piece6' d='m1831.34 1312.91c-3.3916 3.2346-0.7555 11.2719 2.7733 15.2819 3.7054 4.2091 11.7943 8.1045 15.3483 4.7027 3.5863-3.4329 0.2927-12.0241-3.5934-16.1312-3.6241-3.83-11.1791-7.0483-14.5293-3.8532z'/%3E %3Cuse xlink:href='%23piece6' x='-7.31929' y='13.7806'/%3E %3Cpath id='piece7' d='m1820.83 1339.55c-4.3482 1.7486-4.8759 10.1907-3.083 15.2224 1.8833 5.282 7.9545 11.896 12.5156 10.0521 4.6026-1.8607 4.7247-11.0608 2.6358-16.315-1.9481-4.8998-7.7742-10.687-12.0694-8.9598z'/%3E %3Cuse xlink:href='%23piece7' x='-10.5477' y='14.8521'/%3E %3Cpath id='piece8' d='m1802.66 1371.04c-4.5705 1.0369-6.4304 9.2885-5.4581 14.5409 1.0218 5.5138 5.9673 13.0069 10.763 11.9097 4.8395-1.1073 6.4191-10.1716 5.1899-15.6905-1.1464-5.1468-5.981-11.7847-10.4958-10.7605z'/%3E %3Cuse xlink:href='%23piece8' x='-10.1211' y='15.9316'/%3E %3Cpath id='piece9' d='m1784.06 1403.3c-4.6836 0.1712-8.0416 7.9347-8.0603 13.2763-0.019 5.6077 3.4514 13.888 8.3674 13.6993 4.9609-0.1905 8.1942-8.8046 8.0099-14.4558-0.1719-5.2701-3.6915-12.6895-8.3179-12.5204z'/%3E %3Cuse xlink:href='%23piece9' x='-10.3299' y='19.16'/%3E %3Cuse xlink:href='%23piece9' x='-22.3899' y='37.02'/%3E %3Cuse xlink:href='%23piece9' x='-34.87' y='52.31'/%3E %3Cuse xlink:href='%23piece9' x='-47.79' y='66.51'/%3E %3Cuse xlink:href='%23piece9' x='-61.99' y='78.14'/%3E %3Cuse xlink:href='%23piece9' x='-75.5599' y='90.62'/%3E %3Cpath d='m1692.79 1500.17l-5.2618 20.5953s2.9353 7.3347 5.9995 7.026c5.4811-0.552 6.9648-9.0469 8.0099-14.4557 0.9476-8.4237-8.7476-13.1656-8.7476-13.1656z'/%3E %3Cpath d='m2017.21 1513.25c1.6097 6.1241 15.2598 11.3138 15.2598 11.3138l-6.6509-27.7579c-5.7168 0.154-9.4945 12.4363-8.6089 16.4441z'/%3E %3Cpath d='m2016.01 1490.95c-4.3589-1.7217-10.549 4.0428-12.7088 8.9283-2.2663 5.1293-2.4091 14.1062 2.1699 15.9053 4.6206 1.8154 11.0377-4.7785 13.1357-10.0289 1.9564-4.8966 1.7085-13.1047-2.5973-14.8056z'/%3E %3Cpath id='piece10' d='m2000.82 1478.67c-4.6803-0.2433-8.7113 7.193-9.202 12.5121-0.5142 5.584 2.2105 14.1386 7.124 14.3851 4.9583 0.2487 8.9402-8.046 9.2562-13.6913 0.2944-5.2647-2.5557-12.9661-7.1789-13.2065z'/%3E %3Cuse xlink:href='%23piece10' x='-13.4001' y='-13.7001'/%3E %3Cuse xlink:href='%23piece10' x='-25.88' y='-29.23'/%3E %3Cuse xlink:href='%23piece10' x='-38.66' y='-42.32'/%3E %3Cuse xlink:href='%23piece10' x='-49.01' y='-60.28'/%3E %3Cuse xlink:href='%23piece10' x='-60.2801' y='-76.41'/%3E %3Cuse xlink:href='%23piece10' x='-70.63' y='-93.46'/%3E %3Cuse xlink:href='%23piece10' x='-79.76' y='-113.25'/%3E %3Cuse xlink:href='%23piece10' x='-89.81' y='-131.21'/%3E %3Cuse xlink:href='%23piece10' x='-98.03' y='-152.52'/%3E %3Cpath d='m1883.85 1304.56s-1.6473 26.6763 8.0374 28.389c6.0386 1.0678 10.7782-14.9091 10.7782-14.9091z'/%3E %3Cpath id='piece11' d='m1862.02 1610.75c-2.8778 3.699 0.9139 11.2601 4.9952 14.7063 4.2852 3.6171 12.8598 6.2779 15.8737 2.3895 3.0412-3.9239-1.4825-11.936-5.9313-15.4255-4.149-3.2541-12.0958-5.3239-14.9385-1.6701z'/%3E %3Cuse xlink:href='%23piece11' x='18.3' y='-2.15'/%3E %3Cuse xlink:href='%23piece11' x='36.81' y='-5.81'/%3E %3Cpath id='piece12' d='m1916.18 1603.8c-2.2897 4.0891 2.5943 10.9952 7.1468 13.7895 4.7797 2.9327 13.6566 4.2758 16.0525-0.021 2.4176-4.336-3.2579-11.578-8.1802-14.3601-4.5906-2.5942-12.7581-3.4473-15.02 0.592z'/%3E %3Cuse xlink:href='%23piece12' x='20.0199' y='-3.21989'/%3E %3Cpath id='piece13' d='m1953.48 1595.43c-1.9026 4.283 3.5981 10.7088 8.389 13.071 5.03 2.4789 13.993 2.9969 15.982-1.5028 2.0071-4.5407-4.3126-11.2279-9.4707-13.5437-4.8105-2.1594-13.0218-2.255-14.9012 1.9759z'/%3E %3Cuse xlink:href='%23piece13' x='18.94' y='-5.58998'/%3E %3Cpath id='piece14' d='m1991.26 1583.89c-1.6462 4.3879 4.2246 10.4775 9.1467 12.5525 5.1677 2.1773 14.1457 2.1649 15.8653-2.4445 1.7353-4.6513-4.9685-10.9534-10.2545-12.9604-4.9296-1.8714-13.1322-1.4816-14.7584 2.8528z'/%3E %3Cuse xlink:href='%23piece14' x='19.16' y='-6.23998'/%3E %3Cuse xlink:href='%23piece14' x='37.67' y='-13.9899'/%3E %3Cuse xlink:href='%23piece14' x='57.48' y='-22.17'/%3E %3Cuse xlink:href='%23piece14' x='77.5' y='-28.6299'/%3E %3Cuse xlink:href='%23piece14' x='79.87' y='-44.34'/%3E %3Cpath d='m2066.71 1534.88s13.5498 1.9917 14.7891-2.8749c1.6456-6.4625-15.4209-12.7452-15.4209-12.7452z'/%3E %3Cpath id='piece15' d='m1701.62 1575.59c-3.9861 2.4647-3.066 10.8731-0.4409 15.5252 2.7567 4.8833 9.8673 10.3646 14.0469 7.7697 4.2177-2.6186 2.7685-11.7047-0.186-16.5255-2.7555-4.4957-9.4834-9.2042-13.421-6.7695z'/%3E %3Cuse xlink:href='%23piece15' x='18.94' y='7.75003'/%3E %3Cuse xlink:href='%23piece15' x='37.03' y='10.55'/%3E %3Cuse xlink:href='%23piece15' x='56.83' y='15.5001'/%3E %3Cuse xlink:href='%23piece15' x='74.7' y='18.08'/%3E %3Cuse xlink:href='%23piece15' x='92.35' y='21.74'/%3E %3Cuse xlink:href='%23piece15' x='110.43' y='26.69'/%3E %3Cuse xlink:href='%23piece15' x='128.3' y='29.92'/%3E %3Cuse xlink:href='%23piece15' x='146.6' y='32.72'/%3E %3Cpath d='m1648.16 1517.51c-4.1667-2.1454-10.8978 2.9772-13.5312 7.6245-2.7637 4.8794-3.7956 13.7979 0.5824 16.042 4.4179 2.2645 11.457-3.6607 14.0652-8.6773 2.4321-4.6785 2.9991-12.8708-1.1168-14.9901z'/%3E %3Cpath d='m1642.01 1534.4c-4.4151-1.5719-10.4047 4.4008-12.3964 9.3572-2.0898 5.2037-1.9258 14.1803 2.7119 15.8218 4.6799 1.6566 10.868-5.1526 12.7855-10.4717 1.7879-4.9605 1.2598-13.1554-3.1015-14.7082z'/%3E %3Cpath d='m1647.74 1549.94c-4.5395-1.1649-9.9626 5.3264-11.4964 10.4431-1.6092 5.3718-0.6317 14.2965 4.1358 15.5106 4.8109 1.2252 10.3558-6.1173 11.7829-11.5884 1.3306-5.1022 0.061-13.2154-4.4229-14.3661z'/%3E %3Cpath d='m1662.37 1556.31c-4.499-1.3127-10.1315 4.9978-11.8319 10.0615-1.784 5.3163-1.0989 14.2682 3.6263 15.6376 4.7683 1.3819 10.5504-5.7753 12.1556-11.1967 1.4968-5.056 0.4935-13.2064-3.9506-14.5032z'/%3E %3Cpath id='piece16' d='m1671.91 1558.81c-4.5474 1.1337-6.2318 9.4229-5.1483 14.6535 1.1385 5.4908 6.242 12.8773 11.0134 11.6786 4.8148-1.2097 6.2017-10.3055 4.8557-15.7971-1.2554-5.1213-6.2297-11.6551-10.7217-10.5354z'/%3E %3Cuse xlink:href='%23piece16' x='16.79' y='6.23999'/%3E %3Cuse xlink:href='%23piece6' x='8.61071' y='-11.1894'/%3E %3Cuse xlink:href='%23piece6' x='4.66' y='6.47'/%3E %3Cuse xlink:href='%23piece6' x='4.91148' y='26.6794'/%3E %3Cuse xlink:href='%23piece6' x='4.66' y='47.8699'/%3E %3Cuse xlink:href='%23piece6' x='5.57' y='68.5699'/%3E %3Cuse xlink:href='%23piece6' x='2.22005' y='87.7499'/%3E %3Cuse xlink:href='%23piece6' x='4.66' y='109.06'/%3E %3Cuse xlink:href='%23piece6' x='2.22004' y='126.41'/%3E %3Cuse xlink:href='%23piece6' x='4.66' y='143.46'/%3E %3Cuse xlink:href='%23piece6' x='4.66' y='163.86'/%3E %3Cuse xlink:href='%23piece6' x='3.44006' y='183.95'/%3E %3Cuse xlink:href='%23piece6' x='3.74' y='203.13'/%3E %3Cuse xlink:href='%23piece6' x='4.35006' y='223.52'/%3E %3Cuse xlink:href='%23piece6' x='4.35006' y='243.31'/%3E %3Cuse xlink:href='%23piece6' x='3.74' y='263.1'/%3E %3Cuse xlink:href='%23piece6' x='2.52' y='283.19'/%3E %3Cuse xlink:href='%23piece6' x='2.52' y='305.11'/%3E %3Cuse xlink:href='%23piece6' x='1.92002' y='327.94'/%3E %3Cuse xlink:href='%23piece6' x='1.92002' y='349.25'/%3E %3Cuse xlink:href='%23piece6' x='1.92002' y='369.04'/%3E %3Cuse xlink:href='%23piece6' x='1.31006' y='391.27'/%3E %3Cpath id='piece17' d='m1882.24 1303.18c2.4423 3.7068-1.3196 10.8321-5.1636 13.9699-4.036 3.2931-11.9117 5.4626-14.4688 1.5665-2.5804-3.9315 1.8636-11.4583 6.0421-14.6207 3.8968-2.949 11.1785-4.577 13.5912-0.9154z'/%3E %3Cuse xlink:href='%23piece17' x='2.74003' y='16.13'/%3E %3Cuse xlink:href='%23piece17' x='2.43002' y='34.1'/%3E %3Cuse xlink:href='%23piece17' x='2.13' y='52.36'/%3E %3Cuse xlink:href='%23piece17' x='1.82003' y='69.11'/%3E %3Cuse xlink:href='%23piece17' x='2.74002' y='87.07'/%3E %3Cuse xlink:href='%23piece17' x='1.52002' y='104.42'/%3E %3Cpath d='m1883.25 1426.06c2.6959 3.8337-1.4565 11.2029-5.6994 14.448-4.4549 3.4059-13.148 5.6497-15.9706 1.6202-2.8482-4.0661 2.0571-11.8504 6.6693-15.1211 4.3012-3.05 12.3386-4.7336 15.0017-0.9467z'/%3E %3Cpath id='piece18' d='m1882.09 1443.58c3.3915 3.2345 0.7554 11.2718-2.7734 15.2819-3.7054 4.209-11.7943 8.1044-15.3482 4.7026-3.5863-3.4328-0.2928-12.0241 3.5933-16.1312 3.6241-3.83 11.1791-7.0482 14.5293-3.8532z'/%3E %3Cuse xlink:href='%23piece18' x='.610044' y='20.4001'/%3E %3Cuse xlink:href='%23piece18' x='.920001' y='40.4901'/%3E %3Cuse xlink:href='%23piece18' x='.310021' y='62.11'/%3E %3Cuse xlink:href='%23piece18' x='.920001' y='82.2'/%3E %3Cuse xlink:href='%23piece18' x='.310021' y='102.6'/%3E %3Cuse xlink:href='%23piece18' x='.610044' y='122.99'/%3E %3Cuse xlink:href='%23piece18' x='.610045' y='143.69'/%3E %3Cuse xlink:href='%23piece18' x='-.299955' y='164.4'/%3E %3Cuse xlink:href='%23piece18' x='.920001' y='183.27'/%3E %3Cuse xlink:href='%23piece18' x='.92' y='203.06'/%3E %3Cuse xlink:href='%23piece18' x='.310021' y='224.37'/%3E %3Cuse xlink:href='%23piece18' x='.310021' y='245.37'/%3E %3C/g%3E %3Cg%3E %3Cpath fill='%23fa0204' d='m1849.64 1848.26c19.9021 5.5241 31.7591 5.236 48.2193 0.4305l-17.4364-27.9844'/%3E %3Cpath fill='%23ce9d09' d='m1888.31 1776.16-31.7083-8.1414s0.3666-35.1832 20.3893-32.1154c16.6195 2.5464 11.9853 40.3409 11.319 40.2568z'/%3E %3Ccircle fill='%23ce9d09' cx='1872.8856' cy='1722.9711' r='12.9159'/%3E %3Cpath fill='%23fa0204' d='m1885.37 1791.86c7.0484 17.8642 11.3696 33.2411 4.7358 53.3857m7.5972 3.4126c-10.2262-8.2551-36.5822-5.8322-47.9812-0.3475-4.4526 0-16.4454-83.2401 25.7219-81.1827 38.7211 1.8892 24.9493 81.9145 22.2593 81.5302z'/%3E %3C/g%3E %3Cg%3E %3Cpath fill='%23fa0204' d='m1815.2 1866.34c19.2918 12.2385 37.2498 11.1397 54.2468 0.4305l-40.2546-41.9766'/%3E %3Ccircle fill='%23ce9d09' cx='1843.3956' cy='1738.2551' r='12.9159'/%3E %3Cpath fill='%23ce9d09' d='m1859.33 1780.02-32.7202-0.6458s-4.2451-26.6125 16.1449-27.7691c16.9243-0.96 17.2516 28.3629 16.5753 28.4149z'/%3E %3Cpath fill='%23fa0204' d='m1843.61 1860.74c-6.2615-13.9097-6.9109-31.0263-5.1664-49.5109m-9.4716 50.372c-7.6816-13.1828-9.1065-30.0153-3.0137-51.233m43.4039 56.6355c-4.9263-6.1908-40.2274-8.8289-54.0959-0.3918-5.02 0-18.5411-93.8481 28.9999-91.5285 43.6557 2.13 28.1288 92.3536 25.096 91.9203z'/%3E %3C/g%3E %3C/g%3E %3C/g%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 72 48'%3E %3Crect width='72' height='48' fill='%23009e60'/%3E %3Crect width='54' height='48' fill='%23fcd116'/%3E %3Crect width='18' height='48' fill='%230072c6'/%3E %3Cg fill='%23009e60'%3E %3Cpath d='m32,34 4,8 4,-8 -4,-8z'/%3E %3Cpath d='m27,24 4,8 4,-8 -4,-8z'/%3E %3Cpath d='m37,24 4,8 4,-8 -4,-8z'/%3E %3C/g%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 180 120'%3E %3Cdefs%3E %3Cg id='s' transform='translate(0,-36)'%3E %3Cg id='f'%3E %3Cg id='t'%3E %3Cpath d='M0,-5V0H3z' fill='%23fff' transform='rotate(18,0,-5)' id='o'/%3E %3Cuse xlink:href='%23o' transform='scale(-1,1)'/%3E %3C/g%3E %3Cuse xlink:href='%23t' transform='rotate(72)'/%3E %3C/g%3E %3Cuse xlink:href='%23t' transform='rotate(-72)'/%3E %3Cuse xlink:href='%23f' transform='rotate(144)'/%3E %3C/g%3E %3C/defs%3E %3Cpath d='M0,0H180V120H0z' fill='%23cf142b'/%3E %3Cpath d='M0,0H180V80H0z' fill='%2300247d'/%3E %3Cpath d='M0,0H180V40H0z' fill='%23ffcc00'/%3E %3Cg transform='translate(90,84)'%3E %3Cg id='s4'%3E %3Cg id='s2'%3E %3Cuse xlink:href='%23s' transform='rotate(10)'/%3E %3Cuse xlink:href='%23s' transform='rotate(30)'/%3E %3C/g%3E %3Cuse xlink:href='%23s2' transform='rotate(40)'/%3E %3C/g%3E %3Cuse xlink:href='%23s4' transform='rotate(-80)'/%3E %3C/g%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 1200 600'%3E %3Cdefs%3E %3ClinearGradient id='grad' gradientUnits='userSpaceOnUse' x1='103.083' y1='111.276' x2='92.5511' y2='107.764' gradientTransform='matrix(0.99614143,0,0,2.2525522,703.84172,-75.047171)'%3E %3Cstop stop-color='%23f00' offset='0'/%3E %3Cstop stop-color='%23ff0' offset='1'/%3E %3C/linearGradient%3E %3CclipPath id='c'%3E %3Cpath d='M0,0V150H700V300H600zM600,0H300V350H0V300z'/%3E %3C/clipPath%3E %3C/defs%3E %3Crect width='1200' height='600' fill='%2300247d'/%3E %3Cpath d='M0,0 600,300M600,0 0,300' stroke='%23fff' stroke-width='60'/%3E %3Cpath d='M0,0 600,300M600,0 0,300' stroke='%23cf142b' stroke-width='40' clip-path='url(%23c)'/%3E %3Cpath d='M300,0V350M0,150H700' stroke='%23fff' stroke-width='100'/%3E %3Cpath d='M300,0V350M0,150H700' stroke='%23cf142b' stroke-width='60'/%3E %3Cpath d='M0,300H600V0H1200V600H0z' fill='%2300247d'/%3E %3Cg%3E %3Cpath fill='%23fff' d='m776.26,144.068,250.401-0.92914-0.4646,222.992s8.8267,33.9134-104.992,85.4802c40.8818-4.18106,85.4802-47.8503,85.4802-47.8503s18.1181-23.2281,26.9449-10.2204c8.8267,13.0077,17.1889,19.5117,23.6928,24.622,6.504,5.11021,11.614,19.0472,1.8582,29.2676s-25.0866,11.6142-29.2676-0.92915c-6.504,3.25205-46.4568,51.5669-128.22,53.8897-83.1573-1.39373-128.685-54.3542-128.685-54.3542s-11.1496,17.6537-26.9448,3.71663c-15.3307-18.1182-3.71653-29.7324-3.71653-29.7324s13.0078-7.43296,16.7244-12.5433c6.03938-6.96852,7.89764-16.2598,18.1181-16.2598,12.0787,0.92916,16.7244,10.685,16.7244,10.685s41.811,44.134,86.8739,49.7086c-101.736-48.783-105.453-78.98-104.988-86.413l0.46458-221.133z'/%3E %3Cpath fill='%23006129' stroke='%23000' stroke-width='1.8873' d='m782.299,150.107,238.787-1.39371,0,214.63c0.4645,27.874-46.4566,56.2125-119.858,92.4486-75.7244-39.0236-119.394-62.7163-119.858-92.9131l0.92912-212.771z'/%3E %3Cg id='lamp' fill='%23f7c600' stroke='%23000' stroke-width='0.9437'%3E %3Cpath fill='none' stroke='%23f7c600' stroke-width='1.8873' d='m814.794,181.829,14.095-20.7013,14.1636,20.7446'/%3E %3Cpath d='m831.719,174.09c0.00053,1.54631-1.25288,2.80012-2.79923,2.80012s-2.79977-1.25381-2.79924-2.80012c-0.00053-1.54631,1.25289-2.80013,2.79924-2.80013s2.79976,1.25382,2.79923,2.80013z'/%3E %3Cpath d='m817.444,197.119,21.8516,0.0622s0.34262-2.83593-2.28248-4.55956c11.4454-1.57386,8.47204-11.6694,18.0575-12.2416,1.85988,0.28611-5.00735,4.29202-5.00735,4.29202s-5.77927,4.07838-3.14748,6.15185c2.08942,1.64618,3.00441-1.00133,3.29056-3.00428,0.28613-2.00296,9.29933-3.29055,8.01175-9.01315-2.14601-4.72127-14.7359,3.14727-14.7359,3.14727l-8.98216-0.0498c-0.56005-1.00812-3.03547-5.05072-5.59189-5.06944-3.03289,0.11067-5.16923,5.11927-5.16923,5.11927h-13.0191-7.29642s-0.69652,5.21257,9.60433,6.21405c2.31918,3.02889,4.11696,3.87515,6.13307,4.65921-1.34408,1.12015-1.72246,2.47524-1.71681,4.29203z'/%3E %3Cpath d='m819.017,192.684,18.2006-0.062'/%3E %3Cpath d='m810.681,181.953s1.45607,8.51263,8.17643,10.5287'/%3E %3Cpath fill='url(%23grad)' d='m809.561,181.841c0.67203-3.24812,1.90411-3.80827,3.24818-7.95248,0.22402-4.03218-3.24818-3.58421-2.24012-6.1603,1.79209-2.80015,0.89605-5.48827-2.46413-7.61639,0.67204,3.69624-4.36823,7.16842-4.36823,10.1925,0,3.02421,2.57614,2.35218,2.24012,6.94451,0.22402,2.68797-0.67203,2.01609-0.89604,4.59218h4.48022z'/%3E %3Cpath d='m831.495,161.657c0.00049,1.42254-1.15262,2.576-2.57522,2.576-1.42259,0-2.5757-1.15346-2.57521-2.576-0.00049-1.42254,1.15262-2.576,2.57521-2.576,1.4226,0,2.57571,1.15346,2.57522,2.576z'/%3E %3C/g%3E %3Cuse xlink:href='%23lamp' x='-0.77220062' y='41.304015'/%3E %3Cuse xlink:href='%23lamp' x='-1.0892006' y='82.013015'/%3E %3Cuse xlink:href='%23lamp' x='25.626799' y='126.09901'/%3E %3Cuse xlink:href='%23lamp' x='-4.5742006' y='162.16301'/%3E %3Cuse xlink:href='%23lamp' x='-3.7822006' y='204.77301'/%3E %3Cuse xlink:href='%23lamp' x='146.2798' y='0.67201485'/%3E %3Cuse xlink:href='%23lamp' x='144.9358' y='41.218015'/%3E %3Cuse xlink:href='%23lamp' x='143.1438' y='82.661015'/%3E %3Cuse xlink:href='%23lamp' x='145.1598' y='123.43101'/%3E %3Cuse xlink:href='%23lamp' x='144.7118' y='164.20101'/%3E %3Cuse xlink:href='%23lamp' x='144.9358' y='205.19501'/%3E %3Cg fill='%23ffc6b5' stroke='%23000' stroke-width='0.9437'%3E %3Cpath fill='%23f7c600' d='m915.843,406.315s5.70236,13.1472,12.1968,5.06884c6.49443-8.07841,4.11854-11.5633,4.11854-11.5633l-14.573-7.92002-4.27677,9.02885,2.53442,5.3856z'/%3E %3Cpath d='m928.357,404.572s0.95029,0.15854,1.74235-1.26706c0.79206-1.42559-1.74235-2.05942-2.85118-3.64339l-1.26721,2.53457,2.37604,2.37588z'/%3E %3Cpath d='m895.409,401.087-12.8305,6.96957s-6.33605,1.26706-6.8112,0c-0.47529-1.2672,0.15839-2.37603,3.48472-2.53441,3.32648-0.15839,12.3553-8.39532,12.3553-8.39532l3.80163,3.96016z'/%3E %3Cpath d='m895.568,173.149s0.31677,3.00961,0.47515,4.59362c0.15838,1.584-2.53442,4.91039-2.6928,4.752s-1.42559,0.15839-1.26721,1.10884c0.15838,0.95044,2.05927,1.26722,2.05927,1.26722s-0.79206,3.32639,0,3.48477c0.79191,0.1584-2.05927,4.27696,0,5.38568,2.05912,1.10872,5.54398,2.53433,7.12796,2.21755,1.58397-0.31678,0,6.17762,0,6.17762l-4.43516,9.504,24.3936-2.53432-5.06884-8.07851s-2.37588-1.584-1.74235-6.17762c0.63368-4.59361-0.31677-25.344-0.31677-25.344l-17.424-2.37606-1.10883,6.01923z'/%3E %3Cpath d='m891.132,209.264s-7.92002,3.64329-7.60326,13.4641c-2.05912,9.50401-3.16795,19.008-3.16795,19.008s-9.34561,10.6127-12.1968,14.4144c-2.85118,3.80165-7.12811,11.5632-8.71208,13.6224-1.58398,2.05929-7.76158,8.87057-7.6032,11.4049,0.1584,2.53427-1.4256,13.7809,4.752,15.048,1.58399,0.63353,6.65283-12.9889,6.65283-12.9889s0.31676-5.86068-1.4256-6.96953c-1.74235-1.10882,3.80163-4.9105,3.80163-4.9105s10.6128-7.76162,12.9889-9.66239c2.37603-1.90078,8.87046-9.18722,8.87046-9.18722l3.6431-43.2433z'/%3E %3Cpath fill='%23fff' d='m900.161,201.82s2.05927,5.54406,6.65281,4.59362c4.59369-0.95045,9.97929-5.22716,9.97929-5.22716s4.27678-0.1584,4.91046,0.47516c0.63353,0.63356,11.5631,11.2463,11.2464,14.5728-0.31677,3.32651-5.06884,2.37595-6.8112,4.59362-1.74235,2.21767-4.59369,7.76162-3.80162,11.8801,0.79206,4.11845,3.16794,9.50413,2.85118,11.5633-0.31677,2.05917-2.05912,2.69273-2.05912,3.80155,0,1.10885,1.42559,3.00974,1.42559,5.0689,0,2.05917-1.90089,5.06867-1.58397,7.12794,0.31676,2.05929,0.47514,8.0784,0.47514,8.0784l-0.47514,27.8785s1.58397,0.95029,1.74235,2.53442c0.15838,1.58397,10.7712,47.6785,10.7712,47.6785s-0.47514,1.42559-1.58397,1.26721c-1.10883-0.15839,4.27677,7.12795,4.43516,9.18722,0.15838,2.05928,5.54413,18.2162,5.3856,20.4337-0.15838,2.2175-0.9503,7.12796-1.42559,7.28634-0.47515,0.15838,3.48486,10.1377,2.85118,11.7216-0.63353,1.58397-7.12796,1.42559-7.12796,1.42559l-1.74235-0.31676s0.15838,2.05927-1.10883,2.21765-10.6128-0.4753-10.6128-0.4753-2.6928,4.11839-4.27677,3.96001c-1.58413-0.15838-3.64325-3.00956-4.11855-2.53427-0.47514,0.47515,1.42574,3.1678,0.95045,3.95986-0.47515,0.79206-8.55355,2.53457-10.1377-1.26706-1.58397-3.80162,0.95045-2.85133,0.4753-3.64324-0.4753-0.79206-4.11839-2.85118-5.22722-2.21765-1.10882,0.63352,2.85119,1.58397,2.6928,3.16809-0.15838,1.58398-3.48486,3.95986-4.75207,3.95986s-4.27677-5.86075-8.71193-5.22707c-4.43531,0.63353-7.28649,1.74236-7.28649,1.74236s-5.22722,2.2175-7.44487,1.74236c-2.2175-0.47515-3.16795-2.21766-3.16795-3.16795,0-0.95045,1.58397-5.06884,1.42559-6.33605s-1.42559-2.53442-1.42559-4.4353c0-1.90074,3.64325-8.39517,3.64325-8.39517l-0.15839-29.1457s-3.32648-0.00015-3.48486-2.05927,5.06884-46.0945,5.86075-48.9457c0.79206-2.85118,2.85133-12.9888,2.85133-12.9888s-2.37603,1.10882-2.53442,0c-0.15838-1.10883,7.12796-26.2944,7.12796-26.2944s1.26721-12.5137,1.26721-15.8401c0-3.32639-0.63353-7.92001-0.63353-7.92001s-6.50318-2.75297-6.65296-6.96956c-0.59473-6.70875,6.17766-10.4546,6.96973-12.6721,0.79191-2.21755,3.16794-8.87033,3.16794-8.87033s3.48487-6.01923,9.18723-6.96968z'/%3E %3Cpath fill='%23f7c600' d='m897.785,402.988s-15.3648,8.07855-17.5824,8.71208c-2.21765,0.63353-3.64324-2.6928-1.42559-3.32648,2.21765-0.63353,5.70236-0.95045,5.70236-0.95045s-5.22721-4.11839-5.06883-4.27677c0.15853-0.15838,7.12811-2.69265,7.28649-2.69265s2.21765,4.11824,3.64324,3.80148c1.4256-0.31677,5.54399-3.48471,5.54399-3.48471s2.21765,2.53441,1.90074,2.2175z'/%3E %3Cpath d='m919.432,407.423c1.45277,1.87357,2.02077,5.1232,5.34725,3.22246,3.32633-1.90074-1.70401-5.42879-1.70401-5.42879l-3.64324,2.20633z'/%3E %3Cpath d='m925.505,407.106s1.58398,1.26721,3.00957-0.15838-2.85133-4.43516-2.85133-4.43516l-2.05913,2.37604,1.90089,2.2175z'/%3E %3Cpath d='m932.317,216.96c0.15838,0,5.22722,15.6817,5.86074,19.6417,0.63368,3.95995,2.6928,19.8,1.90089,22.0176-0.79206,2.21767-8.87046,12.8304-9.82091,15.5232-0.95044,2.69283-6.65281,12.989-6.65281,12.989s-1.42559,10.1377-2.05927,10.6128c-0.63353,0.47529,1.63531,2.96351,1.42575,3.80162-0.31435,0.9429-4.59369,5.3856-6.49443,4.91046-1.90089-0.4753-4.91046-2.69295-5.06884-4.75207s0.15838-8.87047,1.58397-10.6128c1.4256-1.74236,8.87047-19.3249,9.34562-20.4337,0.47514-1.10884,6.81119-14.8896,6.96957-17.2656,0.15853-2.37605-1.97095-7.87036-4.2111-9.88644-4.98549-14.6729-3.02662-23.5215,7.22082-26.5457z'/%3E %3Cpath fill='%239c5100' d='m895.092,172.199s3.48487,0.47506,5.38561-0.63366c1.90089-1.10873,4.11854-1.58389,5.70251,0.63366,1.58398,2.21756,2.6928,2.05917,2.6928,2.05917s-2.37603,5.86073,0,6.49439c2.37604,0.63367,3.48471,0.63356,3.64325,1.42561,0.15838,0.79206-2.05927,2.53434-1.42574,3.32639,0.63368,0.79206,1.7425,1.74251,1.90088,2.37607,0.15839,0.63356-1.42559,3.32627-0.95044,3.95995,0.4753,0.63366,1.90089,3.16811,2.85118,3.16811,0.95045,0,0.31692,3.96005,3.1681,3.00961s2.6928-3.48489,2.6928-3.48489,3.00957-0.47516,3.80163-3.16801c0.79191-2.69283,2.6928-3.32639,2.6928-3.32639s3.80163-2.05917-1.26721-5.22716c0-22.1761-14.5728-19.8001-14.5728-19.8001s-1.74251-3.96017-4.59369-3.48489-3.00956,3.80179-5.06884,3.48489c-2.05912-0.31688-2.53426-1.74238-2.6928-1.58399-0.15838,0.15839-1.90073,3.32627-1.90073,4.11834,0,0.79204-5.54399-1.10885-5.06884,3.00961,0.47515,4.11845,3.16795,3.96005,3.00956,3.64327z'/%3E %3Cg fill='none'%3E %3Cpath d='m920.753,207.997s-14.0977,9.02885-13.7809,12.1968'/%3E %3Cpath d='m923.921,209.581s-3.16795,3.48477-3.32633,3.48477'/%3E %3Cpath d='m928.198,213.383s-6.96972,5.70244-5.86089,9.34561'/%3E %3Cpath d='m895.251,207.205s-2.05912,4.27673-1.58398,5.70234c0.4753,1.42561,3.96001,6.81128,4.43531,10.1377,0.47515,3.32639,0,5.70246,0,5.70246'/%3E %3Cpath d='m891.608,215.125s0.63353,5.06889,1.58398,6.01922c0.95044,0.95034,3.48486,5.22717,3.80162,6.96956'/%3E %3Cpath d='m890.341,236.192s4.1184,2.05939,7.92002-5.86073'/%3E %3Cpath d='m904.438,224.788c-0.15839,0-3.00957,7.76162,2.05927,10.6128,5.06883,2.85121,8.87046,2.53433,11.088,1.74238,2.21766-0.79194,4.59369-2.21756,4.59369-2.21756'/%3E %3Cpath d='m902.221,234.292s0.31677,10.4546,15.6817,20.7505'/%3E %3Cpath d='m902.854,244.112s-0.15838,9.18712,5.8609,13.3056'/%3E %3Cpath d='m899.686,233.341s-4.59369,13.6223-8.23678,15.048'/%3E %3Cpath d='m898.261,243.32s-0.15838,9.8209-1.42559,13.3057'/%3E %3Cpath d='m895.568,259.002s3.16795,3.96007,6.65281,3.64329c3.48471-0.31678,4.91031-4.43533,7.28634-3.80167,2.37604,0.63367,4.59369,2.53456,10.1377,2.05929'/%3E %3Cpath d='m911.725,265.021s0,8.07839,1.42559,8.87045,0.79206,8.2368,0.79206,8.2368'/%3E %3Cpath d='m892.4,261.22s-0.15838,7.60335-1.10882,10.2961c-0.9503,2.69273-2.85119,7.28645-2.53427,11.2464'/%3E %3Cpath d='m882.737,287.197c0.79191-0.31676,3.48486-2.69265,3.48486-2.69265'/%3E %3Cpath d='m887.648,286.247s-6.81134,29.1458-4.91045,46.5698'/%3E %3Cpath d='m889.232,287.673s-3.48487,21.8593-1.90089,25.9777'/%3E %3Cpath d='m887.489,287.039c0.15838,0,13.3056,0.95029,13.3056,0.95029'/%3E %3Cpath d='m902.696,286.247s3.64324,1.90089,8.71208,1.58397'/%3E %3Cpath d='m901.112,296.86s-0.63368,37.3826-1.58398,45.6194'/%3E %3Cpath d='m920.595,305.413s4.11839,32.7889,6.49443,35.7985'/%3E %3Cpath d='m912.675,309.532s2.53442,28.9873,3.96001,31.5217'/%3E %3Cpath d='m876.718,351.191s4.9103-1.58413,9.34546-6.33605c5.06899,6.81119,12.8305,0.31692,12.8305,0.31692s12.0384,8.23678,17.4242-0.95045c8.23678,5.3856,12.3552-0.79206,12.3552-0.79206s3.00972,4.59354,5.22722,4.11839'/%3E %3Cpath d='m920.753,350.716s6.17767,28.9874,15.3649,37.2242'/%3E %3Cpath d='m888.915,347.706s0.79191,24.2354,2.21751,41.3424'/%3E %3Cpath d='m887.806,375.11s-0.79207,15.84-1.74251,16.9489'/%3E %3Cpath d='m878.46,393.642s1.74236,6.81134,10.4544,0.4753c8.71193-6.3362,8.87032,2.37603,9.18723,3.32633,0.31677,0.95029,1.74236,7.76163,5.06869,2.05927'/%3E %3Cpath d='m910.141,390.158s-1.42559,14.0974,11.088,3.80147c12.5137-10.2959,14.5728-0.15823,14.8896,3.00972'/%3E %3Cpath d='m910.299,166.813s-1.10882,6.96954,6.33605,6.336c-0.95044,3.80167,1.90074,5.0689,1.90074,5.0689'/%3E %3Cpath d='m924.08,182.495c0.15853,0,3.32648,2.05916-0.15838,4.59361'/%3E %3Cpath d='m913.309,188.039s1.58382,1.90089,3.32633,1.42573c1.74236-0.47518,4.59354,1.74239,4.59354,1.74239s2.37603,0.79194,2.6928,0.31678'/%3E %3Cpath d='m903.646,194.058s5.38561,2.05927,8.87047-6.4944'/%3E %3Cpath d='m893.667,185.029,3.1681,0.1584'/%3E %3Cpath d='m858.523,284.924,0.24792,6.94179'/%3E %3Cpath d='m852.013,284.409s4.45059,7.44321,4.0787,11.4099'/%3E %3Cpath stroke-linejoin='round' d='m894.142,188.197,2.85118,0-2.53441,1.10883'/%3E %3Cpath stroke-linejoin='round' d='m911.665,299.962s3.32769-0.34968,3.2229,5.20608c2.12495-6.90163,6.44581-7.0656,6.44581-7.0656'/%3E %3Cpath stroke-width='1.6986' stroke-linejoin='round' d='m898.102,179.327c0.47515,0,2.2175-0.63368,2.53442-0.15839,0.31676,0.47528-1.90089,0.79206-2.53442,0.15839z'/%3E %3C/g%3E %3C/g%3E %3Cg fill='none' stroke='%23000' stroke-width='1.8873'%3E %3Cpath fill='%23f7c600' d='m900.299,458.579c66.8976-1.85832,110.102-50.1732,109.638-50.6378-0.4645-0.46458,8.8268-13.4724,16.2599-11.6142,7.4331,1.85832,18.1181,23.6929,31.1259,28.3385,6.5038,10.2204-1.8583,19.5118-4.6457,21.3701-2.7874,1.85831-15.3307,6.96852-17.189-0.46458-1.8581-7.43309-5.5747-6.03935-5.5747-6.03935s-59.4645,58.0707-128.22,55.748c-71.0786,0.46458-129.614-55.748-129.614-55.748l-5.11024,5.57477s-5.57479,6.03937-8.36219,5.57479c-2.78738-0.46458-14.8661-8.3621-15.7952-16.2598-0.92914-7.89767,7.43306-13.0079,7.43306-13.0079s20.4409-15.7954,22.7637-24.1575c4.64566-4.64561,13.4724,3.25189,13.4724,3.25189s53.8897,61.7873,113.819,58.0709z'/%3E %3Cpath d='m748.855,422.646s5.52789-1.4742,7.55478,0.82921c2.0269,2.30327,15.9387,15.9388,15.9387,15.9388'/%3E %3Cpath d='m761.477,429.095-5.52789,4.14587s13.9119,2.76361,10.7794,11.8849'/%3E %3Cpath d='m1052.34,422.185s-2.7641-1.47421-7.0941,1.7505c-4.3303,3.22456-15.294,15.4781-15.294,15.4781'/%3E %3Cpath d='m1039.9,428.727,5.9885,4.60653s-12.5298,0.8292-9.7659,12.7142'/%3E %3C/g%3E %3Cg fill='%23000'%3E %3Cpath d='m819.664,437.396c-0.36233,1.05196-1.32124-0.0286-2.1167,0.18281-2.09463,0.0787-3.83438,1.44493-5.62783,2.37754-6.13592,3.57703-12.2718,7.15406-18.4078,10.7311-0.61916-0.20373-0.47224-0.70419-0.32125-1.20622,1.63543-7.66322,3.3341-15.3134,4.92489-22.9858,0.26406-1.34229,0.68917-3.00961-0.60666-3.98662-0.55081-0.37618,0.30172-1.13938,0.65524-0.44562,3.13656,2.23685,6.27311,4.47369,9.40967,6.71054-0.30176,0.88447-0.8363,0.2643-1.3719-0.0946-1.30246-1.25352-2.87297-0.0955-2.83433,1.48783-1.11932,5.05195-2.21088,10.1101-3.31857,15.1646,4.16553-2.47603,8.37867-4.87373,12.5066-7.41174,1.47316-0.65547,2.56043-2.63086,1.02815-3.85506-0.58172-0.34251-1.5433-1.27927-0.58447-1.42187,2.22165,1.58438,4.44331,3.16877,6.66496,4.75315z'/%3E %3Cpath d='m826.275,469.382c-0.16777,0.5721-0.46619,0.69814-0.92215,0.2864-3.69141-2.01877-7.38282-4.03754-11.0742-6.05631,0.16777-0.5721,0.4662-0.69816,0.92216-0.28641,0.99931,0.68068,2.63447,0.93833,3.36348-0.25422,1.46548-2.35102,2.70085-4.83909,4.05889-7.25394,1.8462-3.41959,3.76974-6.79894,5.55943-10.2479,0.85611-1.22152-0.0994-2.72784-1.29719-3.25104-0.40497-0.21691-1.00172-0.37764-0.48962-0.86318,0.2462-0.30433,0.77152,0.34421,1.12983,0.42258,3.53863,1.93522,7.07727,3.87043,10.6159,5.80565-0.16777,0.5721-0.46619,0.69816-0.92215,0.28642-1.001-0.67935-2.64214-0.9398-3.37996,0.24523-1.46544,2.35104-2.70083,4.83909-4.05887,7.25394-1.84621,3.41958-3.76975,6.79893-5.55945,10.2479-0.85548,1.23068,0.0966,2.74667,1.31365,3.26002,0.24676,0.13495,0.49352,0.26991,0.74028,0.40486z'/%3E %3Cpath d='m868.884,459.388c-1.00242,2.8143-2.00484,5.62861-3.00726,8.44291-1.2319-0.13004-0.41252-1.7076-0.79582-2.53896-0.43991-3.80009-3.2427-7.34798-7.06085-8.16085-2.91908-0.79536-6.00002,0.70778-7.71381,3.08201-2.59075,3.5364-4.16561,7.85282-4.38703,12.2348-0.14778,2.49015,0.99504,5.04624,3.16882,6.35708,1.72432,1.13596,3.81745,1.593,5.86414,1.53554,0.72218-2.12904,1.58542-4.21491,2.1873-6.38101,0.24699-1.40888-1.20996-2.26005-2.37507-2.58291-0.18191-0.40867,0.26984-0.91183,0.74426-0.47135,3.67913,1.31047,7.35827,2.62093,11.0374,3.9314-0.13183,1.3581-1.66681-0.10859-2.51672,0.4334-1.35963,0.5218-1.47634,2.15677-1.99174,3.33918-0.44831,1.25866-0.89663,2.51732-1.34495,3.77598-4.94585,0.34999-10.0434-0.69666-14.3476-3.186-4.18483-2.6372-7.01502-7.72851-6.19175-12.7222,0.63731-4.27402,3.30111-8.27732,7.24184-10.1654,3.61966-1.92325,8.03709-1.91584,11.7955-0.3912,2.05559,0.69257,3.82986,1.96318,5.42017,3.40994,0.96375,1.30024,2.82894,1.30279,3.61967-0.17512,0.21785,0.0776,0.43569,0.15518,0.65354,0.23277'/%3E %3Cpath d='m886.836,488.201c-0.0223,0.44877-0.0724,0.85974-0.60997,0.60926-4.21257-0.63812-8.42515-1.27625-12.6377-1.91437,0.0223-0.44877,0.0724-0.85976,0.60998-0.60927,1.09552,0.22381,2.56416,0.20525,3.09269-0.97692,0.53524-1.68791,0.64169-3.47598,0.94965-5.21478,0.72349-4.8563,1.49549-9.70591,2.18624-14.5667,0.26829-1.04778-0.0904-2.23279-1.17512-2.63961-0.6141-0.29133-1.2988-0.33485-1.95936-0.44497,0.0223-0.44877,0.0724-0.85976,0.60997-0.60928,4.21257,0.63813,8.42515,1.27626,12.6377,1.91439-0.0223,0.44877-0.0724,0.85974-0.60998,0.60927-1.1016-0.2267-2.56339-0.19692-3.11123,0.97411-0.53526,1.68791-0.64169,3.47598-0.94966,5.21477-0.72349,4.85631-1.49546,9.70593-2.18623,14.5668-0.26553,1.04485,0.0941,2.25417,1.18531,2.64856,0.61993,0.28179,1.3048,0.32904,1.96771,0.43882z'/%3E %3Cpath d='m920.954,479.914c-0.16674,2.98737-0.33347,5.97475-0.50021,8.96212-7.51522,0.38345-15.0304,0.7669-22.5457,1.15035-0.13786-0.54875,0.009-0.84067,0.60604-0.72557,1.13326,0.0288,2.59279-0.4515,2.73734-1.75192,0.10037-2.22701-0.15016-4.45454-0.22473-6.68127-0.2431-4.44122-0.41871-8.88702-0.70892-13.325,0.12388-1.32148-1.06672-2.30103-2.32047-2.26067-0.39826-0.20163-1.47506,0.4153-1.36759-0.31092-0.18148-0.58815,0.63507-0.2751,0.98049-0.38746,4.18034-0.2133,8.36067-0.42659,12.541-0.63988,0.13785,0.54874-0.009,0.84069-0.60604,0.7256-1.15864-0.006-2.66506,0.27574-2.98562,1.58332-0.18294,1.92668,0.086,3.86449,0.13757,5.79531,0.25424,4.62527,0.43398,9.2557,0.73973,13.8774-0.0938,1.20984,0.87722,2.28029,2.13026,2.04705,1.83023-0.0915,3.69956-0.0136,5.48649-0.47334,2.50745-0.66714,3.8741-3.15018,4.56089-5.46973,0.44973-0.62711,0.0775-2.19165,1.07054-2.10165,0.0896-0.005,0.17929-0.009,0.26893-0.0137'/%3E %3Cpath d='m938.531,458.219c-0.59756,0.0106-0.3343,0.77285-0.48591,1.17286-0.99799,7.4764-1.94375,14.9603-2.97613,22.4318-0.251,1.6554-0.66406,3.58785-2.29741,4.42578-0.60243,0.21391-0.072,1.16167,0.48021,0.63456,2.50975-0.75292,5.01949-1.50585,7.52924-2.25877-0.0947-1.26854-1.54038-0.11599-2.3501-0.33901-1.7273-0.002-1.98401-2.09956-1.7436-3.41099,0.10417-0.88542,0.20833-1.77083,0.3125-2.65625,2.875-0.86458,5.75-1.72917,8.625-2.59375,1.10069,1.38573,2.31391,2.69066,3.30954,4.15271,0.74791,1.41036-1.0692,2.05489-2.12457,2.3273-0.49289,0.0522-0.0627,1.08444,0.38688,0.6048,3.77813-1.13243,7.55627-2.26487,11.3344-3.39731-0.0343-1.28248-1.67666-0.0806-2.36866-0.93623-2.12162-1.59417-3.64389-3.81223-5.39981-5.7751-4.07719-4.79409-8.15438-9.58846-12.2316-14.3824zm-0.0625,8.96875c2.04167,2.4375,4.08333,4.875,6.125,7.3125-2.44792,0.72917-4.89583,1.45833-7.34375,2.1875,0.40625-3.16667,0.8125-6.33333,1.21875-9.5z'/%3E %3Cpath d='m977.1,441.379c1.08619,2.02027,2.17237,4.04053,3.25856,6.0608-1.01376,0.87074-1.54101-1.14943-2.46007-1.45809-1.50628-1.26767-3.77854-1.50742-5.45644-0.43192-0.68677,0.35724-1.36507,0.73053-2.04797,1.09509,3.2768,6.06782,6.50863,12.1606,9.81456,18.2122,0.51183,1.5521,2.41826,1.84313,3.64829,0.96814,0.47558-0.34475,0.90639-0.54064,1.05915,0.18819-1.66296,0.96412-3.48109,1.88159-5.20372,2.82777-2.16967,1.16651-4.33934,2.33303-6.50901,3.49954-0.51117-0.52976-0.16902-0.80293,0.40615-1.00604,1.54289-0.57239,2.13516-2.44512,1.10289-3.76223-3.20609-6.02574-6.4605-12.0261-9.68551-18.042-1.79599,0.99462-4.0898,1.89186-4.54312,4.13133-0.51017,1.40933,0.23983,3.13506,0.2408,4.33405-0.55321,0.57388-0.6986-0.20859-0.9546-0.62321-0.92819-1.7264-1.85638-3.4528-2.78457-5.1792,6.70487-3.60483,13.4097-7.20967,20.1146-10.8145z'/%3E %3Cpath d='m992.351,432.337c2.0776,2.75429,4.1552,5.50857,6.2328,8.26286,1.44515-0.91843,2.65215-2.55983,2.21865-4.35293,0.1665-1.40062-1.83649-2.98786-1.14842-3.96993,0.45322-0.28145,0.72022,0.76715,1.09532,1.04351,2.3726,3.14543,4.7453,6.29085,7.1179,9.43628-0.9284,1.05716-1.6006-1.09804-2.5836-1.33091-1.3865-0.98572-3.3326-1.47708-4.8196-0.39701-1.11024,0.35461-1.05845,0.97758-0.303,1.6619,1.6701,2.15612,3.2205,4.41037,5.003,6.47497,1.091,1.05878,2.448-0.0476,3.3717-0.78331,2.3881-1.6263,4.4849-4.16522,4.362-7.21105,0.1567-1.32908-0.6787-2.81295-0.6701-3.93483,0.5356-0.7123,0.6849,0.39371,0.9923,0.75562,1.122,2.02645,2.244,4.0529,3.366,6.07935-5.8479,4.41112-11.6957,8.82225-17.5436,13.2334-0.76181-0.53919-0.0123-0.85701,0.46753-1.22935,1.63799-1.01232,1.11749-3.07847-0.0879-4.21329-3.74799-4.93642-7.43003-9.92457-11.2263-14.8233-0.97162-1.31754-2.7643-0.62395-3.74511,0.2947-0.40617,0.57713-1.04343-0.5784-0.27209-0.66375,5.51431-4.15951,11.0286-8.31901,16.5429-12.4785,1.5093,2.00085,3.0185,4.0017,4.5278,6.00255-1.0492,1.06371-1.9782-1.30665-3.1748-1.43095-2.17343-1.13109-4.75777-0.21919-6.55386,1.2098-1.07368,0.76459-2.11384,1.57485-3.16929,2.36419'/%3E %3C/g%3E %3C/g%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns:dc='http://purl.org/dc/elements/1.1/' xmlns:cc='http://creativecommons.org/ns%23' xmlns:rdf='http://www.w3.org/1999/02/22-rdf-syntax-ns%23' xmlns:svg='http://www.w3.org/2000/svg' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' id='Capa_1' x='0px' y='0px' width='1275.59px' height='850.394px' viewBox='1488.189 992.126 1275.59 850.394' enable-background='new 1488.189 992.126 1275.59 850.394' xml:space='preserve'%3E %3Crect id='rect3' x='1488.189' y='992.126' fill='%23FFFFFF' width='1275.59' height='850.394'/%3E %3Cpath id='path5' fill='%23369443' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M1885.935,1567.623 c0,0-1.033-6.99,12.242-12.116c13.275-5.126,14.307-24.232,11.652-36.97c0,0-6.932,12.116-15.339,16.155 c0,0-13.717,7.146-14.345,20.795c0,0-0.109,4.99-1.142,8.873c-0.565,2.126-6.637-17.087,4.867-31.377 c11.872-14.748,15.192-26.717,5.752-50.017c0,0-0.885,14.135-10.177,22.213c-9.292,8.077-10.474,8.699-10.325,27.96 c0,0,0.148,6.679-3.392,8.854c0,0-7.227-10.563-9.145-17.553c-1.917-6.99-2.802-9.941,5.457-18.019c0,0,26.461-17.1,7.375-54.522 c0,0-0.59,12.893-9.735,20.504c-9.145,7.611-8.407,12.737-8.85,25.941c-0.443,13.203-1.328,12.271-2.36,14.135 c0,0-16.814-30.911-3.835-47.377s20.207-19.883,5.9-50.483c0,0,0.635,15.689-10.818,23.456c-11.453,7.767-8.798,25.941-8.798,25.941 s0.737,6.835-1.622,11.805c0,0-16.202-31.601-0.737-48.62c13.127-14.446,14.012-24.543,6.932-45.047c0,0-0.885,9.476-8.112,14.601 c-7.227,5.126-12.979,10.252-11.652,29.979c0,0,0.59,13.825-1.18,17.708c0,0-6.785-12.582-8.702-20.815 c-1.917-8.233-2.655-13.048,2.36-21.281c5.015-8.233,24.927-31.844,1.18-65.861c0,0-0.737,11.029-6.785,20.97 c-6.047,9.941-3.245,21.747-1.917,30.756s-3.097,17.708-3.097,17.708s-10.325-18.951-8.112-40.697 c2.212-21.747-6.637-39.61-26.697-52.503c0,0-14.602,33.863,5.31,51.105c0,0,16.962,16.776,21.239,37.125 c0,0-12.832-1.243-24.484-23.921c-11.652-22.679-35.841-19.106-37.464-19.261c0,0,3.983,35.105,41.151,45.047 c0,0,23.747,4.039,28.172,21.436c0,0,3.982,11.961,5.605,18.329c0,0-7.522-2.951-14.455-13.203 c-6.932-10.252-6.047-11.495-29.499-13.825c0,0-9.44-1.088-14.455-7.767c0,0,9.882,37.125,35.251,36.814 c0,0,23.157-2.485,36.136,27.96c0,0-2.507-1.553-5.9-3.884c-3.392-2.33-11.947-6.679-28.909-4.66 c-16.962,2.019-21.682-0.777-25.959-2.175c0,0,17.109,31.377,41.299,22.057c24.189-9.32,35.872,24.665,36.136,25.319 c0,0-3.245-2.486-7.522-6.68c-4.277-4.194-13.157-9.366-29.942-4.039c0,0-12.094,4.66-24.337,0.932c0,0,11.8,22.834,39.381,18.951 c27.581-3.884,34.514,20.349,34.514,20.349s-3.687-2.175-6.195-4.194c-2.507-2.019-11.8-7.301-31.711-1.398 c-19.912,5.903-27.139-0.932-27.139-0.932s11.062,20.193,32.301,22.523c0,0,11.8-0.155,16.814-2.019 c5.015-1.864,18.289-4.815,27.434,8.388c0,0-2.507,0.466-6.342-1.243c0,0-14.159-5.126-24.927,3.883c0,0-9.587,9.786-23.157,7.922 c0,0,17.552,17.087,45.428,2.641c0,0,9.44-6.835,16.372-1.553C1869.858,1578.031,1885.935,1567.623,1885.935,1567.623z'/%3E %3Cpath id='path7' fill='%23F4C53D' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M2041.1,1146.669 c0,0-3.238-28.908,19.863-31.688c24.091-2.9,35.989,2.175,35.989,2.175l10.816,21.229l-3.737,14.291l-14.946,6.835 c0,0,2.557-21.954-17.568-22.411c-5.099-0.116-8.096,1.906-16.161,0.626C2047.245,1136.438,2042.907,1145.351,2041.1,1146.669z'/%3E %3Cpath id='path9' fill='%23F4C53D' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M2203.639,1218.226 c-3.442,4.453-17.208,6.006-17.208,6.006s14.159,10.873,20.256,26.407c6.097,15.533-164.113,0.103-164.113,0.103 s7.375-5.281,12.39-15.223c0,0-7.522,2.796-15.044-4.66c0,0,5.605,1.864,12.979-9.32c0,0,10.915-13.98,18.584-17.708 c0,0-3.54,2.175-12.094-2.485c0,0,14.75-1.864,20.059-27.028c0,0,0.885-5.592,6.49-13.669c5.605-8.078,4.425,1.553,14.75-10.874 c0,0,4.72-8.802,0.59-14.187c-4.13-5.385-8.555-3.417-17.208-8.595c-8.653-5.178-12.488-8.078-9.538-16.051 c2.95-7.974,10.62-6.731,11.701-6.731c1.082,0,1.672-6.938,11.112-11.702c9.44-4.764,34.514-2.693,38.25-0.621 c3.737,2.071,18.879,6.524,27.729,28.892c8.85,22.368-2.36,30.756,21.731,64.515c0,0-9.636,2.071-15.831,0.207 C2169.224,1185.502,2181.711,1207.663,2203.639,1218.226z'/%3E %3Cpath id='path11' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M2098.328,1123.835 c-19.617-0.932-12.094-19.624-12.094-19.624'/%3E %3Cpath id='path13' fill='%23F4C53D' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M2132.399,1126.398 c0,0-3.466-1.631-6.398-5.514c-4.115-5.449-13.292-8.077-18.233-2.951c0,0-5.015,5.592-9.44,5.903c0,0,5.015,1.553,8.481,4.738 c3.466,3.184,7.08,5.514,12.242,4.815c5.162-0.699,5.974-3.417,8.407-5.048C2129.892,1126.708,2132.399,1126.398,2132.399,1126.398z '/%3E %3Cpath id='path15' fill='%23F4C53D' stroke='%23010002' stroke-width='3' d='M2259.981,1405.765c0,0,18.29,14.912,33.629,0 c0,0,6.195,7.456,18.584,5.281c12.39-2.175,14.455-8.699,15.635-12.427c0,0,10.718,6.253,19.764,1.314 c9.047-4.939,9.047-12.394,9.047-12.394s15.733,3.101,23.796-7.562c8.063-10.663,3.147-21.226-1.18-22.469 c0,0,17.01,4.456,21.633-10.148c3.933-12.427-4.917-18.847-4.917-18.847s35.841-0.172,50.542-11.391c0,0,12.193-7.663,4.917-15.74 c0,0,32.252-5.178,40.315-18.019c0,0,3.54-3.521,2.36-9.734c0,0-0.197-3.521-3.737-3.728c0,0,36.78-5.681,47.395-17.812 c0,0,5.113-5.592,2.557-13.048c0,0-0.541-1.968-1.426-3.288c0,0,33.481-7.068,50-21.98c0,0,9.536-8.496,4.62-19.887 c0,0,55.951-15.322,42.972-39.968c0,0,26.156-8.492,17.896-32.102c0,0,21.633-10.977,12.193-28.374 c-9.034-16.65-36.775,2.899-69.624,11.988c0,0-88.884,27.985-132.656,35.432l-124.372,185.167l-72.568,27.96L2259.981,1405.765z'/%3E %3Cpath id='path17' fill='%23F4C53D' stroke='%23010002' stroke-width='3' d='M2259.097,1269.382c0,0,11.657-8.751,32.449,1.553 c0,0,7,4.82,12.507-0.461c4.601-4.413,5.032-12.549-1.297-17.247c-15.487-11.495-21.24-45.979,2.36-60.269 c0,0,34.219-20.297,159.696-52.229c0,0,10.513-2.915,16.118-1.517c6.172,1.539,10.423,6.835,11.295,11.366 c0,0,5.615,15.956-13.262,25.086c0,0-8.522,3.9-17.306,6.421c0,0,9.648-2.086,13.766,7.456c3.933,9.113-1.77,18.433-19.469,24.439 c0,0-4.787,1.863-11.603,3.521c0,0,15.143,4.349,7.866,16.569c0,0-6.49,12.841-29.401,15.119c0,0,17.109,1.864,5.015,18.122 c0,0-5.31,8.906-22.026,12.22c0,0,12.685,0.414,6.293,11.805c-6.391,11.391-21.432,17.812-36.232,18.847 c0,0-8.016,0.414-13.621-0.829c0,0,14.061,7.042,5.801,18.847c0,0-6.096,8.388-21.337,7.974c0,0,3.956,13.183-7.227,18.174 c-8.702,3.883-15.929-2.33-15.929-2.33s2.95,14.135-9.735,19.106c0,0-6.342,3.262-15.782,0c0,0-7.227,16.155-32.891,4.815 C2239.479,1364.602,2259.097,1269.382,2259.097,1269.382z'/%3E %3Cpath id='path19' fill='%23F6E200' stroke='%23010002' stroke-width='3' d='M2193.461,1317.07'/%3E %3Cpath id='path21' fill='none' stroke='%23010002' stroke-width='3' d='M2654.383,1121.815c0,0-40.315,23.342-165.869,46.684'/%3E %3Cpath id='path23' fill='%23F4C53D' stroke='%23010002' stroke-width='3' d='M1934.384,1534.589c0,0-14.946,25.682-33.039,26.096 c0,0-31.122-3.788-39.922,4.349c-6.136,5.675-12.39,10.356-14.946,24.854s4.916,17.605,6.686,18.226c0,0,1.377,10.356,11.603,7.663 c0,0,0.59,10.77,18.683,5.592c18.093-5.178,25.566-3.521,29.106-21.54c3.54-18.019,6.808-17.724,10.03-19.883 c4.327-2.9,12.455-5.64,18.486-9.113c5.418-3.12,26.156-13.67,33.235-14.498c7.08-0.828,5.506-24.646,5.506-24.646h-18.289 l-8.85-13.048L1934.384,1534.589z'/%3E %3Cpath id='path25' fill='none' stroke='%23010002' stroke-width='3' d='M2636.487,1153.918c0,0-109.115,35.594-159.93,39.968'/%3E %3Cpath id='path27' fill='none' stroke='%23010002' stroke-width='3' d='M2593.515,1193.886c0,0-64.011,20.094-138.971,32.774'/%3E %3Cpath id='path29' fill='none' stroke='%23010002' stroke-width='3' d='M2538.894,1235.753c0,0-72.322,17.372-106.849,20.255'/%3E %3Cpath id='path31' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M2490.368,1269.9 c0,0-61.173,12.758-76.672,14.292'/%3E %3Cpolygon id='polygon33' fill='%230081C6' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' points='2421.511,1362.939 2424.574,1460.005 2424.574,1460.005 2407.435,1450.062 2407.435,1450.062 2378.901,1573.241 2367.128,1564.783 2394.904,1446.772 2394.904,1446.772 2375.536,1447.128 2375.536,1447.128 '/%3E %3Cpath id='path35' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M2451.43,1301.381 c0,0-44.642,6.783-62.409,6.42'/%3E %3Cpath id='path37' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M2395.972,1328.513 c0,0-18.05-0.848-26.724-2.288'/%3E %3Cpath id='path39' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M2379.255,1357.509 c0,0-15.34-4.142-24.386-9.941'/%3E %3Cpath id='path41' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M2356.64,1387.54 c0,0-11.8-4.556-17.503-16.983'/%3E %3Cpath id='path43' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M2327.829,1398.62 c0,0-9.145-8.181-9.735-17.294'/%3E %3Cpolygon id='polygon45' fill='%230081C6' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' points='2532.37,1406.102 2491.805,1493.32 2491.805,1493.32 2481.104,1476.067 2481.104,1476.067 2395.461,1577.264 2386.188,1566.883 2471.506,1466.967 2471.506,1466.967 2454.247,1457.705 2454.247,1457.705 '/%3E %3Cpath id='path47' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M2293.61,1405.765 c0,0,3.424-2.953,1.082-15.792'/%3E %3Cpolygon id='polygon49' fill='%230081C6' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' points='2495.369,1342.078 2474.473,1436.672 2474.473,1436.672 2460.361,1422.396 2460.361,1422.396 2383.71,1569.785 2371.898,1562.89 2449.065,1415.802 2449.065,1415.802 2430.27,1410.867 2430.27,1410.867 '/%3E %3Cpath id='path51' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M2298.035,1371.126 c0,0,1.77-3.676,1.18-9.475'/%3E %3Cpath id='path53' fill='%23F4C53D' stroke='%23010002' stroke-width='3' d='M1991.986,1405.766c0,0-18.289,14.912-33.629,0 c0,0-6.195,7.456-18.584,5.281s-14.455-8.699-15.635-12.427c0,0-10.718,6.253-19.764,1.314c-9.047-4.939-9.047-12.395-9.047-12.395 s-15.733,3.101-23.796-7.562c-8.063-10.663-3.147-21.226,1.18-22.469c0,0-17.01,4.456-21.633-10.148 c-3.933-12.427,4.917-18.847,4.917-18.847s-35.841-0.172-50.542-11.391c0,0-12.193-7.663-4.916-15.74 c0,0-32.252-5.178-40.315-18.019c0,0-3.54-3.521-2.36-9.734c0,0,0.197-3.521,3.736-3.728c0,0-36.78-5.681-47.395-17.812 c0,0-5.113-5.592-2.557-13.048c0,0,0.541-1.968,1.426-3.288c0,0-33.481-7.068-50.001-21.98c0,0-9.536-8.496-4.62-19.887 c0,0-55.952-15.322-42.972-39.968c0,0-26.156-8.492-17.896-32.102c0,0-21.633-10.977-12.193-28.374 c9.034-16.65,36.776,2.899,69.624,11.988c0,0,88.884,27.985,132.656,35.432l124.372,185.167l72.568,27.96L1991.986,1405.766z'/%3E %3Cpath id='path55' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M2362.54,1187.263 c0,0-20.649,8.285-27.532,19.676c-6.883,11.391-2.35,22.462,0,28.814c1.181,3.192,15.733,31.248-1.377,51.545'/%3E %3Cpath id='path57' fill='%23F4C53D' stroke='%23010002' stroke-width='3' d='M1992.871,1269.383c0,0-11.657-8.751-32.449,1.553 c0,0-7,4.82-12.506-0.461c-4.601-4.413-5.033-12.549,1.297-17.247c15.487-11.495,21.239-45.979-2.36-60.269 c0,0-34.219-20.297-159.696-52.229c0,0-10.513-2.915-16.118-1.517c-6.172,1.539-10.423,6.835-11.295,11.366 c0,0-5.615,15.956,13.262,25.086c0,0,8.522,3.9,17.306,6.421c0,0-9.648-2.086-13.766,7.456c-3.933,9.113,1.77,18.433,19.469,24.439 c0,0,4.787,1.863,11.603,3.521c0,0-15.143,4.349-7.866,16.569c0,0,6.49,12.841,29.401,15.119c0,0-17.109,1.864-5.015,18.122 c0,0,5.31,8.906,22.026,12.22c0,0-12.685,0.414-6.293,11.805c6.391,11.391,21.432,17.812,36.233,18.847 c0,0,8.016,0.414,13.621-0.828c0,0-14.061,7.042-5.801,18.847c0,0,6.096,8.388,21.338,7.974c0,0-3.956,13.184,7.227,18.174 c8.702,3.883,15.929-2.33,15.929-2.33s-2.95,14.135,9.735,19.106c0,0,6.342,3.262,15.782,0c0,0,7.227,16.155,32.891,4.815 C2012.488,1364.602,1992.871,1269.383,1992.871,1269.383z'/%3E %3Cpath id='path59' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M2362.245,1309.355 c0,0-0.098-0.104-7.375-2.382'/%3E %3Cpath id='path61' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M2405.805,1279.531 c0,0-12.308,2.478-24.386,2.589'/%3E %3Cpath id='path63' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M2422.816,1249.189 c0,0-14.455,1.45-28.024,1.243'/%3E %3Cpath id='path65' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M2444.35,1217.501 c0,0-20.846,4.142-32.056,4.349'/%3E %3Cpath id='path67' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M2461.656,1182.085 c0,0-25.709,7.338-44.839,9.941'/%3E %3Cpath id='path69' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M2374.339,1207.145 c0,0,18.486,17.19-3.737,33.138c0,0,9.243,14.498-9.243,29.617'/%3E %3Cpath id='path71' fill='%23F4C53D' stroke='%23010002' stroke-width='3' d='M1994.394,1416.2c0,0-3.766,20.218-33.627,45.666 c0,0-23.04,20.324-22.45,43.727c0.601,23.832-4.13,26.51-13.176,34.588c0,0,18.683,1.45,27.729-10.977 c0,0-0.393,20.711-3.147,22.575c0,0,5.859,0.374,14.356-8.906c0,0,5.113-5.385,9.833-7.456c0,0-5.506,14.291-1.18,27.546 c0,0,1.377-5.178,8.653-7.456c0,0,13.176-2.693,18.29-21.747c0,0,3.343-12.634,23.992-23.818c0,0,23.402-8.827,22.813-20.361 S1994.394,1416.2,1994.394,1416.2z'/%3E %3Cpath id='path73' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M2366.276,1277.046 c0,0,2.753,27.646-31.072,27.648c0,0,6.49,24.647-26.156,23.819c0,0-3.737,19.675-27.336,15.74'/%3E %3Cpath id='path75' fill='%23F4C53D' stroke='%23010002' stroke-width='3' d='M2317.618,1534.589c0,0,14.946,25.682,33.039,26.096 c0,0,31.122-3.788,39.922,4.349c6.136,5.675,12.39,10.356,14.946,24.854c2.557,14.498-4.917,17.604-6.687,18.226 c0,0-1.377,10.356-11.603,7.663c0,0-0.59,10.77-18.683,5.592s-25.566-3.521-29.106-21.54c-3.54-18.019-6.808-17.724-10.03-19.883 c-4.327-2.9-12.455-5.64-18.486-9.113c-5.418-3.12-26.156-13.669-33.235-14.498c-7.08-0.828-5.507-24.646-5.507-24.646h18.289 l8.85-13.048L2317.618,1534.589z'/%3E %3Cpath id='path77' fill='%23F4C53D' stroke='%23010002' stroke-width='3' d='M2257.608,1416.2c0,0,3.766,20.218,33.627,45.666 c0,0,23.04,20.324,22.45,43.727c-0.601,23.832,4.13,26.51,13.176,34.588c0,0-18.683,1.45-27.729-10.977 c0,0,0.393,20.711,3.147,22.575c0,0-5.86,0.374-14.356-8.906c0,0-5.113-5.385-9.833-7.456c0,0,5.506,14.291,1.18,27.546 c0,0-1.377-5.178-8.653-7.456c0,0-13.176-2.692-18.29-21.747c0,0-3.343-12.634-23.992-23.818c0,0-23.403-8.827-22.813-20.361 C2206.112,1478.047,2257.608,1416.2,2257.608,1416.2z'/%3E %3Cpath id='path79' fill='none' stroke='%23010002' stroke-width='3' d='M2333.695,1560.685c0,0,5.352,1.191,16.962,0'/%3E %3Cpath id='path81' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M2383.303,1575.183 c0,0,16.323-2.485,15.536,32.931'/%3E %3Cpath id='path83' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M2373.47,1583.26 c0,0,14.75-1.864,13.766,32.517'/%3E %3Cpath id='path85' fill='none' stroke='%23010002' stroke-width='3' d='M2231.088,1500.416c0,0,7.08,1.45,11.997,7.042 c4.916,5.592,14.356,4.556,14.356,4.556s-5.113-4.142-6.883-14.498s-7.473-13.462-7.473-13.462'/%3E %3Cpath id='path87' fill='none' stroke='%23010002' stroke-width='3' d='M2259.974,1474.247c0,0,7.08,1.45,11.996,7.042 c4.916,5.592,14.356,4.556,14.356,4.556s-5.113-4.142-6.883-14.498s-7.473-13.462-7.473-13.462'/%3E %3Cpath id='path89' fill='none' stroke='%23010002' stroke-width='3' d='M2264.842,1514.447c0,0,6.182,1.266,10.474,6.149 c4.293,4.882,12.535,3.978,12.535,3.978s-4.465-3.617-6.01-12.658c-1.545-9.042-6.525-11.754-6.525-11.754'/%3E %3Cpath id='path91' fill='%23F4C53D' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M2149.136,1676.875 c0,0,5.361,23.657,23.993,21.747c0,0,13.176-1.243,12.193-23.197c0,0,19.469,10.356,22.616-15.326c0,0,17.699,4.142,17.503-19.883 c0,0,16.52,2.9,14.553-18.433c0,0,17.896,4.763,17.896-15.326c0,0,41.888-6.947-45.428-86.573l-77.877,46.393L2149.136,1676.875z'/%3E %3Cpath id='path93' fill='%23F4C53D' stroke='%23010002' stroke-width='3' d='M2140.483,1570.709c0,0,12.979,11.516,22.222-5.675 c0,0,12.586-0.621,14.553-10.148c0,0,10.227-1.036,12.193-10.77c0,0,13.963-1.45,13.57-13.255c0,0,25.385-1.96,0.008-30.7 c-25.377-28.741-68.446,47.684-68.446,47.684L2140.483,1570.709z'/%3E %3Cpath id='path95' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M2185.322,1675.425 c0,0-1.967-41.63-38.047-101.278'/%3E %3Cpath id='path97' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M2207.938,1660.099 c0,0,5.605-24.025-45.232-95.064c0,0,5.9-16.983-12.193-27.857'/%3E %3Cpath id='path99' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M2225.44,1640.216 c0,0,1.573-25.993-48.181-85.33c0,0,4.395-15.326-13.634-27.546'/%3E %3Cpath id='path101' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M2239.993,1621.783 c0,0-1.868-26.303-50.542-77.667c0,0,2.435-15.74-15.007-25.475'/%3E %3Cpath id='path103' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M2257.889,1606.457 c0,0-3.54-30.031-54.868-75.596c0,0,1.77-11.805-15.34-23.818'/%3E %3Cpath id='path105' fill='%23F4C53D' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M2102.865,1676.875 c0,0-5.361,23.657-23.992,21.747c0,0-13.176-1.243-12.193-23.197c0,0-19.469,10.356-22.616-15.326c0,0-17.699,4.142-17.503-19.883 c0,0-16.52,2.9-14.553-18.433c0,0-17.896,4.764-17.896-15.326c0,0-41.888-6.947,45.428-86.573l77.877,46.393L2102.865,1676.875z'/%3E %3Cpath id='path107' fill='%23F4C53D' stroke='%23010002' stroke-width='3' d='M2111.519,1570.709c0,0-12.979,11.516-22.223-5.674 c0,0-12.586-0.621-14.552-10.148c0,0-10.227-1.036-12.193-10.77c0,0-13.963-1.45-13.57-13.255c0,0-25.385-1.96-0.008-30.7 c25.377-28.741,68.446,47.683,68.446,47.683L2111.519,1570.709z'/%3E %3Cpath id='path109' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M2066.68,1675.425 c0,0,1.966-41.63,38.047-101.278'/%3E %3Cpath id='path111' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M2044.064,1660.099 c0,0-5.605-24.025,45.232-95.064c0,0-5.9-16.983,12.193-27.856'/%3E %3Cpath id='path113' fill='%23F4C53D' stroke='%23010002' stroke-width='3' d='M2126.001,1563.585c12.582,0,26.839,78.599,23.139,125.953 c-1.344,17.198-10.557,31.245-23.139,31.245s-21.795-14.047-23.139-31.245C2099.162,1642.184,2113.419,1563.585,2126.001,1563.585'/%3E %3Cpath id='path115' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M2026.561,1640.216 c0,0-1.573-25.993,48.182-85.33c0,0-4.395-15.326,13.634-27.546'/%3E %3Cpath id='path117' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M2012.008,1621.783 c0,0,1.868-26.303,50.542-77.667c0,0-2.435-15.74,15.007-25.475'/%3E %3Cellipse id='ellipse119' fill='%23F4C53D' stroke='%23010002' stroke-width='3' cx='2126.001' cy='1562.963' rx='17.41' ry='25.785'/%3E %3Cpath id='path121' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M1994.112,1606.457 c0,0,3.54-30.031,54.868-75.596c0,0-1.77-11.805,15.34-23.818'/%3E %3Cpath id='path123' fill='%23FFFFFF' stroke='%23010002' stroke-width='3' d='M2126.001,1557.331c0,0,147.66-65.433,148.029-216.805 h-296.058C1978.341,1491.898,2126.001,1557.331,2126.001,1557.331z'/%3E %3Cline id='line125' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' x1='2046.293' y1='1340.525' x2='2069.067' y2='1340.525'/%3E %3Cline id='line127' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' x1='2000.746' y1='1340.525' x2='2023.52' y2='1340.525'/%3E %3Cline id='line129' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' x1='2091.841' y1='1340.525' x2='2114.614' y2='1340.525'/%3E %3Cpath id='path131' fill='%23A60032' stroke='%23010002' stroke-width='3' d='M2000.746,1340.525v96.719c0,0,11.31,22.432,22.774,36.5 v-133.219L2000.746,1340.525L2000.746,1340.525z'/%3E %3Cpath id='path133' fill='%23A60032' stroke='%23010002' stroke-width='3' d='M2046.293,1340.525v159.435 c0,0,14.242,13.965,22.774,20.697v-180.132H2046.293z'/%3E %3Cpath id='path135' fill='%23A60032' stroke='%23010002' stroke-width='3' d='M2091.841,1340.525v197.076 c0,0,16.248,10.494,22.774,13.937v-211.013H2091.841z'/%3E %3Cline id='line137' fill='none' stroke='%23010002' stroke-width='3' x1='2000.746' y1='1340.525' x2='2023.52' y2='1340.525'/%3E %3Cline id='line139' fill='none' stroke='%23010002' stroke-width='3' x1='2046.293' y1='1340.525' x2='2069.067' y2='1340.525'/%3E %3Cline id='line141' fill='none' stroke='%23010002' stroke-width='3' x1='2091.841' y1='1340.525' x2='2114.614' y2='1340.525'/%3E %3Cpath id='path143' fill='%23A60032' stroke='%23010002' stroke-width='3' d='M2251.256,1340.525v96.719c0,0-11.31,22.432-22.773,36.5 v-133.219H2251.256z'/%3E %3Cpath id='path145' fill='%23A60032' stroke='%23010002' stroke-width='3' d='M2205.708,1340.525v159.435 c0,0-14.242,13.965-22.774,20.697v-180.132H2205.708z'/%3E %3Cpath id='path147' fill='%23A60032' stroke='%23010002' stroke-width='3' d='M2160.161,1340.525v197.076 c0,0-16.248,10.494-22.774,13.937v-211.013H2160.161z'/%3E %3Cline id='line149' fill='none' x1='2281.978' y1='1703.708' x2='2268.261' y2='1720.484'/%3E %3Cline id='line151' fill='none' x1='2251.256' y1='1701.845' x2='2289.057' y2='1736.793'/%3E %3Cpath id='path153' fill='%230081C6' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M2364.725,1614.728l-5.742,23.475 l0,0l15.719,15.659l0,0l-22.216,93.839l-19.76-26.542l-29.279,13.665l22.216-93.839l0,0l20.597-5.743l0,0l5.348-23.433 C2351.608,1611.809,2357.838,1609.369,2364.725,1614.728z'/%3E %3Cpath id='path155' fill='%230081C6' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M2369.988,1599.248l-11.315,21.11 l0,0l11.335,19.41l0,0l-44.521,84.586l-12.564-31.023l-31.64,5.219l44.521-84.586l0,0l21.306,0.067l0,0l10.924-21.177 C2358.035,1592.854,2365.982,1592.837,2369.988,1599.248z'/%3E %3Cpath id='path157' fill='%230081C6' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M2371.898,1605.387l-30.096,38.235 l0,0l6.898,21.598l0,0l-61.447,71.871l-5.615-33.205l-31.943-2.411l61.447-71.871l0,0l20.746,5.113l0,0l31.924-40.59 C2363.811,1594.128,2372.373,1598.38,2371.898,1605.387z'/%3E %3Cpath id='path159' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M1900.98,1512.014'/%3E %3Cpath id='path161' fill='none' stroke='%23010002' stroke-width='3' d='M1597.585,1121.816c0,0,40.315,23.342,165.869,46.684'/%3E %3Cpath id='path163' fill='none' stroke='%23010002' stroke-width='3' d='M1615.481,1153.918c0,0,109.115,35.594,159.93,39.968'/%3E %3Cpath id='path165' fill='none' stroke='%23010002' stroke-width='3' d='M1658.453,1193.886c0,0,64.011,20.094,138.971,32.774'/%3E %3Cpath id='path167' fill='none' stroke='%23010002' stroke-width='3' d='M1713.073,1235.753c0,0,72.322,17.371,106.849,20.255'/%3E %3Cpath id='path169' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M1761.599,1269.901 c0,0,61.173,12.758,76.672,14.292'/%3E %3Cpath id='path171' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M1800.538,1301.382 c0,0,44.642,6.783,62.409,6.42'/%3E %3Cpath id='path173' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M1855.996,1328.513 c0,0,18.05-0.848,26.724-2.288'/%3E %3Cpath id='path175' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M1872.712,1357.509 c0,0,15.34-4.142,24.386-9.941'/%3E %3Cpath id='path177' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M1895.328,1387.54 c0,0,11.8-4.556,17.503-16.983'/%3E %3Cpath id='path179' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M1924.139,1398.621 c0,0,9.145-8.181,9.735-17.294'/%3E %3Cpath id='path181' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M1958.358,1405.766 c0,0-3.424-2.953-1.082-15.792'/%3E %3Cpath id='path183' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M1953.933,1371.126 c0,0-1.77-3.676-1.18-9.475'/%3E %3Cpath id='path185' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M1889.428,1187.263 c0,0,20.649,8.284,27.532,19.675c6.883,11.391,2.35,22.462,0,28.814c-1.181,3.192-15.733,31.248,1.377,51.545'/%3E %3Cpath id='path187' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M1889.723,1309.355 c0,0,0.098-0.104,7.375-2.382'/%3E %3Cpath id='path189' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M1846.163,1279.531 c0,0,12.308,2.478,24.386,2.589'/%3E %3Cpath id='path191' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M1829.152,1249.189 c0,0,14.455,1.45,28.024,1.243'/%3E %3Cpath id='path193' fill='%23369443' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M1882.877,1610.513 c0,0-0.442-12.581,15.486-13.513l46.901,65.237c0,0-1.77,4.194-23.008,3.728c0,0-2.249-0.015-3.429,2.47 C1917.015,1672.25,1882.877,1610.513,1882.877,1610.513z'/%3E %3Cpath id='path195' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M1807.618,1217.501 c0,0,20.846,4.142,32.056,4.349'/%3E %3Cpath id='path197' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M1790.312,1182.085 c0,0,25.709,7.338,44.839,9.941'/%3E %3Cpath id='path199' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M1877.629,1207.146 c0,0-18.486,17.19,3.736,33.138c0,0-9.243,14.498,9.243,29.617'/%3E %3Cpath id='path201' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M1885.692,1277.047 c0,0-2.753,27.646,31.072,27.648c0,0-6.49,24.647,26.156,23.819c0,0,3.736,19.676,27.336,15.74'/%3E %3Cpath id='path203' fill='none' stroke='%23010002' stroke-width='3' d='M1918.258,1560.685c0,0-5.352,1.191-16.962,0'/%3E %3Cpath id='path205' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M1868.651,1575.183 c0,0-16.323-2.485-15.536,32.931'/%3E %3Cpath id='path207' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M1878.484,1583.26 c0,0-14.75-1.864-13.766,32.516'/%3E %3Cpath id='path209' fill='none' stroke='%23010002' stroke-width='3' d='M2020.914,1500.415c0,0-7.08,1.45-11.996,7.042 s-14.356,4.556-14.356,4.556s5.113-4.142,6.883-14.498s7.473-13.462,7.473-13.462'/%3E %3Cpath id='path211' fill='none' stroke='%23010002' stroke-width='3' d='M1992.028,1474.247c0,0-7.08,1.45-11.996,7.042 c-4.916,5.592-14.356,4.556-14.356,4.556s5.113-4.142,6.883-14.498s7.473-13.462,7.473-13.462'/%3E %3Cpath id='path213' fill='none' stroke='%23010002' stroke-width='3' d='M1987.16,1514.446c0,0-6.182,1.266-10.474,6.148 c-4.293,4.883-12.535,3.978-12.535,3.978s4.465-3.617,6.01-12.659c1.545-9.042,6.525-11.754,6.525-11.754'/%3E %3Cpath id='path215' fill='%23162667' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M2274.03,1230.549 c0,0-72.456,37.901-148.029-3.107c-75.573,41.008-148.029,3.107-148.029,3.107v109.976h296.058L2274.03,1230.549L2274.03,1230.549z'/%3E %3Cpath id='path217' fill='%230081C6' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M1609.306,1515.748 c7.175-2.929,12.342-5.756,12.32-13.412c-0.005-1.825-1.019-5.863-3.055-12.114l-48.177-147.24 c-2.853-8.747-5.01-13.947-6.01-15.863c-2.166-4.147-6.417-5.835-12.143-8.22h5.93h49.361h5.941 c-6.652,3.143-12.716,5.639-12.659,12.691c0.022,2.693,0.779,6.49,2.341,11.393l36.907,115.541l36.871-115.541 c1.562-4.903,2.369-8.7,2.343-11.393c-0.071-7.248-6.386-9.86-12.591-12.691h5.872h47.565h5.906 c-5.426,2.174-9.848,3.878-12.12,8.22c-1.002,1.916-3.157,7.116-6.009,15.863l-48.177,147.24c-2.038,6.25-2.775,10.357-3.056,12.258 c0,0-2.217,9.312,12.32,13.267L1609.306,1515.748L1609.306,1515.748z'/%3E %3Cpath id='path219' fill='%230081C6' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M2635.986,1500.605v-166.709 c0-2.884-0.476-5.095-1.425-6.634c-0.951-1.537-5.09-5.969-10.995-8.364h5.906h43.363h5.906c-5.906,1.955-10.046,6.706-10.995,8.292 c-0.951,1.586-1.425,3.821-1.425,6.706v166.709c0,2.981,0.491,5.264,1.476,6.85c0.983,1.586,5.039,5.458,10.944,8.292h-5.906 h-43.363h-5.906c5.906-2.687,10.044-6.825,10.995-8.364C2635.51,1505.847,2635.986,1503.586,2635.986,1500.605z'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='-15 -10 30 20'%3E %3Crect fill='%23DA251d' x='-20' y='-15' width='40' height='30'/%3E %3Cg id='g' transform='translate(0,-6)'%3E %3Cpolyline id='g1' fill='%23FF0' points='0,0 0,6 4,6' transform='rotate(18)'/%3E %3Cuse xlink:href='%23g1' transform='scale(-1,1)'/%3E %3C/g%3E %3Cg id='g2' transform='rotate(72)'%3E %3Cuse xlink:href='%23g'/%3E %3Cuse xlink:href='%23g' transform='rotate(72)'/%3E %3C/g%3E %3Cuse xlink:href='%23g2' transform='scale(-1,1)'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 950 570'%3E %3Crect width='950' height='285' fill='%23d21034'/%3E %3Crect y='285' width='950' height='285' fill='%23009543'/%3E %3Cpath d='M 0,0 L 552.8133,285 L 0,570 z' fill='%23000'/%3E %3Crect y='234' width='950' height='102' fill='%23000'/%3E %3Cpath d='M 0,40.502 L 474.251,284.9995 L 0,529.497 z' fill='%23fdce12'/%3E %3Crect y='270' width='950' height='30' fill='%23fdce12'/%3E %3Cpath d='M 0,74.25473 L 408.78173,285 L 0,495.745 z' fill='%23000'/%3E %3Cpath d='M 115.481,339.524 C 115.481,339.524 115.481,360.119 115.481,372 C 143.734,372 199.181,350.35 199.181,280.644 C 199.181,210.938 140.037,198 122.346,198 C 104.656,198 50,210.674 50,267.706 C 50,324.738 103.6,330.019 114.161,330.019 C 124.722,330.019 164.328,320.513 159.84,277.739 C 159.84,289.885 146.11,315.497 117.329,315.497 C 88.549,315.497 70.595,294.109 70.595,272.987 C 70.595,251.863 88.021,223.611 118.385,223.611 C 148.749,223.611 170.928,250.542 170.928,277.739 C 170.928,304.935 149.542,339.524 115.481,339.524 z' fill='%23fdce12'/%3E %3Cg id='frond' fill='%23fdce12'%3E %3Cpath d='M 90.728,297.245 L 92.411,298.334 C 92.411,298.334 105.778,267.838 141.72,246.154 C 137.165,248.629 113.105,260.61 90.728,297.245 z' stroke='%23fdce12'/%3E %3Cpath d='M 94.193,291.997 C 94.193,291.997 90.035,283.482 93.698,279.72 C 97.362,275.957 95.679,289.72 95.679,289.72 L 97.263,287.443 C 97.263,287.443 94.787,277.046 97.56,274.868 C 100.332,272.69 98.946,284.868 98.946,284.868 L 100.629,282.69 C 100.629,282.69 98.847,272.591 101.52,270.709 C 104.194,268.828 102.511,280.215 102.511,280.215 L 104.491,277.937 C 104.491,277.937 103.006,268.333 106.273,266.056 C 109.541,263.778 106.669,275.165 106.669,275.165 L 108.847,272.789 C 108.847,272.789 107.857,263.976 110.63,261.996 C 113.402,260.016 111.026,270.313 111.026,270.313 L 113.006,268.234 C 113.006,268.234 112.412,260.016 115.085,258.135 C 117.759,256.253 115.283,265.957 115.283,265.957 L 117.363,263.976 C 117.363,263.976 116.868,255.758 120.234,254.174 C 123.6,252.59 119.64,261.897 119.64,261.897 L 121.917,259.917 C 121.917,259.917 122.61,250.313 125.482,249.421 C 128.353,248.53 124.195,257.937 124.195,257.937 L 126.274,256.253 C 126.274,256.253 127.363,248.035 130.531,247.045 C 133.7,246.055 128.551,254.57 128.551,254.57 L 130.63,252.986 C 130.63,252.986 132.908,244.768 135.878,243.877 C 138.849,242.986 132.809,251.6 132.809,251.6 L 134.789,250.214 C 134.789,250.214 138.056,242.787 140.73,242.292 C 143.403,241.797 137.759,248.431 137.759,248.431 L 140.235,246.946 C 140.235,246.946 144.492,239.223 145.978,241.599 C 147.463,243.976 140.037,247.441 140.037,247.441 L 137.561,248.827 C 137.561,248.827 146.572,244.57 147.661,246.748 C 148.75,248.926 135.284,250.313 135.284,250.313 L 133.106,251.798 C 133.106,251.798 142.116,249.322 141.027,251.6 C 139.938,253.877 131.027,253.382 131.027,253.382 L 128.947,254.867 C 128.947,254.867 137.957,252.689 136.769,254.768 C 135.581,256.847 126.769,256.649 126.769,256.649 L 124.591,258.432 C 124.591,258.432 133.403,256.154 132.116,258.828 C 130.828,261.501 120.828,261.402 120.828,261.402 L 118.353,263.679 C 118.353,263.679 127.66,260.511 126.868,262.986 C 126.076,265.462 115.481,266.749 115.481,266.749 L 113.105,269.125 C 113.105,269.125 123.105,265.759 120.135,268.828 C 117.165,271.898 109.937,272.69 109.937,272.69 L 107.065,276.155 C 107.065,276.155 116.967,270.214 115.58,273.581 C 114.194,276.947 104.491,279.225 104.491,279.225 L 102.511,281.601 C 102.511,281.601 111.422,276.452 110.531,279.324 C 109.64,282.195 100.134,285.264 100.134,285.264 L 98.55,287.443 C 98.55,287.443 109.045,281.205 108.154,284.373 C 107.263,287.542 97.263,289.819 97.263,289.819 L 95.976,291.799 C 95.976,291.799 105.679,286.255 105.778,288.928 C 105.877,291.601 94.391,294.275 94.391,294.275 L 94.193,291.997 z'/%3E %3C/g%3E %3Cuse xlink:href='%23frond' transform='translate(238.5) scale(-1,1)'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 150 100'%3E %3Cpath fill='%23ED2939' d='M0,0H150V100H0z'/%3E %3Cpath fill='%23FFF' d='M0,0H40V40H0z'/%3E %3Cpath fill='%23002395' d='M0,0H20V40H0z'/%3E %3Cpath fill='none' stroke='%23FFF' d='M0,40H60V0'/%3E %3Cpath fill='%23FFF' d='M105,46 93,34H117zM101,50 89,38V62zM105,54 93,66H117zM109,50 121,38V62z'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 840 600'%3E %3Ctitle%3EFlag of Kosovo%3C/title%3E %3Cdefs%3E %3Cpath id='star' d='M0,-36 21.160269,29.124612 -34.238034,-11.124612H34.238034L-21.160269,29.124612z' fill='%23fff'/%3E %3C/defs%3E %3Crect width='840' height='600' fill='%23244aa5'/%3E %3Cpath fill='%23d0a650' transform='translate(229,151) scale(0.38,0.35)' d='m271.3,381.7c0,0 4.1,-3 5.6,-3.4c1.5,-0.4 6.8,-2.2 6.8,-2.2c0,0 3.4,-1.9 5.2,-1.9c1.9,0 5.6,2.2 6.8,4.1c1.1,1.9 7.1,5.2 7.1,5.2c0,0 4.1,1.5 4.9,0c0.8,-1.5 2.6,-2.6 4.5,-2.6c1.9,0 2.2,-1.9 2.2,-3.4c0,-1.5 0.8,-3.4 2.2,-5.2c1.5,-1.9 4.5,-3 4.5,-3c0,0 4.1,-1.9 4.5,-4.5c0.4,-2.6 4.5,-4.5 6.8,-4.9c2.2,-0.4 0,-1.5 6,-0.8c6,0.8 6.8,-1.5 7.1,-3.4c0.4,-1.9 0,-3.8 3.8,-3.4c3.8,0.4 5.6,0.4 5.6,-1.9c0,-2.2 3.4,-3.4 -2.6,-5.2c-6,-1.9 -5.6,-0.4 -6,-3.4c-0.4,-3 0,-2.6 -4.1,-3c-4.1,-0.4 -1.9,-2.6 -2.2,-4.9c-0.4,-2.2 -1.5,-3.4 -2.2,-4.9c-0.8,-1.5 -3,-1.5 -3,-3.7c0,-2.2 -0.4,-3.4 -2.6,-3.4c-2.2,0 -3,0 -3,-2.2c0,-2.2 0.4,-4.1 2.6,-4.1c2.2,0 3.4,-1.9 3,-4.1c-0.4,-2.2 -0.4,-7.1 -0.4,-7.1l3,-3.8c0,0 9,-7.9 9.8,-9.4c0.8,-1.5 3.8,-2.6 5.2,0.4c1.5,3 2.2,3.8 3.4,5.2c1.1,1.5 4.5,0.4 5.2,-1.1c0.8,-1.5 1.1,-7 3.1,-10c2,-2.9 3.4,-4.4 3.9,-6.8c0.5,-2.4 1.5,-4.4 3.9,-4.4c2.4,0 3.9,-3.4 3.9,-5.4c0,-2 1,-3.9 3.9,-4.4c2.9,-0.5 4.4,-2.4 5.4,0.5c1,2.9 2,2.9 3.9,3.9c2,1 4.9,2.4 6.3,1c1.5,-1.5 2.2,-3.9 4.4,-2.4c2.1,1.5 3.6,0 4.1,-2.9c0.5,-2.9 1,-6.8 1,-6.8c0,0 0.5,-2 3.9,-2c3.4,0 1,-2.4 2.9,-3.9c2,-1.5 2,-2.9 4.4,-2c2.4,1 6.3,-1.2 4.4,-3.6c-2,-2.4 -6.3,-6.3 -3.9,-9.3c2.4,-2.9 3.4,-7.8 1,-8.3c-2.4,-0.5 -5.9,0.5 -6.3,-2.4c-0.5,-2.9 -1.5,-4.9 1.5,-5.4c2.9,-0.5 7.8,-0.5 9.3,-2c1.5,-1.5 6.3,-2.4 6.3,-6.8c0,-4.4 1.5,-4.9 2,-7.3c0.5,-2.4 0.5,-7.5 -1.5,-9.9c-2,-2.4 -4.9,-5.9 -5.4,-7.3c-0.5,-1.5 -2.4,-3.9 -5.4,-4.9c-2.9,-1 -5.4,-1.5 -5.4,-3.9c0,-2.4 2,0.5 2,-5.9c0,-6.3 -3.9,-7.3 -3.9,-7.3l-5.9,-3.9c0,0 -10.4,-3 -13.2,-3c-2.8,0 -6,-3.2 -2.8,-5.2c3.2,-2 4,-5.6 2.8,-8.4c-1.2,-2.8 -2,-4.8 -6.4,-6c-4.4,-1.2 -5.6,-2.4 -3.6,-5.2c2,-2.8 2.4,-4.8 4.8,-2.8c2.4,2 6.4,2.8 9.6,1.2c3.2,-1.6 4.4,-2.8 6,-1.2c1.6,1.6 3.6,3.2 6,0.8c2.4,-2.4 6.8,-2.8 8.8,-1.6c2,1.2 6.8,0.8 8.4,0c1.6,-0.8 4.8,-3.6 4.8,-5.2c0,-1.6 2,-4.4 4,-5.6c2,-1.2 4.4,-5.2 6.4,-5.2c2,0 2.8,-2.4 2.8,-4c0,-1.6 1.6,-4.8 2,-6c0.4,-1.2 4.4,-2.9 7.2,-0.4c2.8,2.4 6.4,3.2 6.4,3.2c0,0 4,0.8 6,0c2,-0.8 4.8,-1.6 7.6,0.4c2.8,2 6.8,2 6.8,2c0,0 0.8,-3.2 0.8,-4.8c0,-1.6 0.8,-4.4 -0.8,-5.6c-1.6,-1.2 -3.6,-2.8 -0.4,-5.2c3.2,-2.4 3.2,-2 6.4,-2c3.2,0 5.2,0.4 7.6,0.4c2.4,0 6.4,2.4 6.4,4.8c0,2.4 1.6,4 3.6,5.2c2,1.2 4.4,2.4 3.6,4.4c-0.8,2 -0.8,3.6 1.6,3.2c2.4,-0.4 3.2,1.2 3.2,3.2c0,2 0.8,3.2 3.2,4c2.4,0.8 3.6,2.4 3.6,4.4c0,2 -0.4,3.2 0.4,5.2c0.8,2 3.2,5.2 3.2,5.2c0,0 4.4,5.6 -1.2,2.8c-5.6,-2.8 -6.8,-4 -8.8,-3.6c-2,0.4 -3.2,1.6 -3.2,1.6c0,0 -2.8,0.8 -4.8,0.8c-2,0 -4,4.4 -0.8,5.2c3.2,0.8 4.4,1.6 4.4,4.4c0,2.8 -1.2,2 -2.8,4c-1.6,2 -2.8,0.8 -5.6,0.8c-2.8,0 -3.6,2.4 -3.6,4.8c0,2.4 1.2,2 2.4,4c1.2,2 3.2,2.4 5.2,0.4c2,-2 3.6,-3.2 4.8,0.4c1.2,3.6 2.8,3.6 5.2,3.6c2.4,0 3.2,0 5.2,-1.2c2,-1.2 4.4,0 4.8,3.2c0.4,3.2 2.4,3.6 4.4,4.8c2,1.2 3.2,2 3.6,4c0.4,2 1.6,2.8 3.6,1.6c2,-1.2 5.2,-2 6.4,-0.4c1.2,1.6 3.2,4.8 3.2,4.8l0.4,4l7.6,2.8c0,0 0.8,2 0.8,3.6c0,1.6 1.2,2.4 3.2,2c2,-0.4 5.6,0 5.6,0c0,0 2.8,-1.2 2.8,-3.6c0,-2.4 1.2,-3.2 3.2,-3.2c2,0 6.4,1.6 7.6,-0.8c1.2,-2.4 4.8,-3.2 7.6,-2c2.8,1.2 10,4.4 10,4.4c0,0 -0.8,0.4 1.6,4.4c2.4,4 6.8,4 6.8,4c0,0 0.4,3.6 1.2,5.2c0.8,1.6 4.4,2.4 6.4,0.8c2,-1.6 4.8,-3.6 7.2,-3.6c2.4,0 4,0 4,-1.6c0,-1.6 -2.4,-2.8 -2.4,-5.2c0,-2.4 2.4,-2.4 2.8,-4.8c0.4,-2.4 2.8,0 4.4,1.2c1.6,1.2 3.6,3.2 3.6,4.8c0,1.6 3.2,7.2 5.2,8c2,0.8 7.2,1.2 8.8,-0.8c1.6,-2 5.6,-2.8 5.2,2c-0.4,4.8 -1.2,5.2 1.6,6.8c2.8,1.6 3.2,7.2 0.8,8.8c-2.4,1.6 -3.2,2 -3.2,4.8c0,2.8 -0.8,6 1.2,7.6c2,1.6 3.2,2.8 3.2,4.4c0,1.6 2.4,8.8 2.4,8.8c0,0 1.2,7.2 0.8,8.8c-0.4,1.6 -1.2,4.4 2.4,4c3.6,-0.4 4.4,-0.4 4.4,2.8c0,3.2 1.2,4.4 -0.8,5.6c-2,1.2 -3.2,5.2 -1.2,6c2,0.8 3.6,2 4,3.6c0.4,1.6 3.6,4.4 5.6,2.8c2,-1.6 2.4,-2.4 4,-2.8c1.6,-0.4 2.8,-1.6 1.2,-3.6c-1.6,-2 -2,-4 -0.4,-5.2c1.6,-1.2 2.4,-5.2 2.4,-5.2c0,0 2.4,-3.6 5.2,0c2.8,3.6 3.2,2.4 5.2,2.4c2,0 2.8,2 2.8,4c0,2 4,1.6 4,4.8c0,3.2 0.8,10.8 0.8,10.8c0,0 0,4.4 2.4,6c2.4,1.6 2,2 0.8,4c-1.2,2 -0.8,5.2 -0.8,6.8c0,1.6 0.8,2.4 -1.2,4c-2,1.6 -2.8,3.6 -1.6,6c1.2,2.4 0.8,4 4,6.8c3.2,2.8 2.8,4 2.8,6c0,2 3.2,4.8 3.2,6.8c0,2 2.4,4.4 4.4,4.8c2,0.4 4.4,4 4.4,6c0,2 0.4,7.2 0.4,7.2c0,0 -0.4,1.2 2,1.2c2.4,0 4,2.8 4.8,-0.4c0.8,-3.2 3.2,-3.6 4.8,-4.4c1.6,-0.8 4.8,-2.4 6.4,-1.2c1.6,1.2 3.6,1.2 5.2,1.2c1.6,0 9.2,0.4 9.2,0.4c0,0 2,-0.4 3.2,2.8c1.2,3.2 4.8,6.8 2.8,8.4c-2,1.6 -2,4.8 0.4,4.8c2.4,0 4.8,0 4.8,2c0,2 0.4,3.6 2.4,2.4c2,-1.2 3.2,-1.6 4,0c0.8,1.6 2.4,1.6 4.4,2.8c2,1.2 2.8,0.4 4,-1.2c1.2,-1.6 6,-3.2 6,-3.2c0,0 6.4,-1.6 8.8,-0.8c2.4,0.8 5.6,2.4 5.6,2.4c0,0 1.6,4 0.8,6.4c-0.8,2.4 -1.6,2 -0.8,5.6c0.8,3.6 -0.8,4 -2.4,3.6c-1.6,-0.4 -3.2,-0.4 -3.2,2.8c0,3.2 -1.6,4 -1.6,6.8c0,2.8 0,2.4 -1.6,3.6c-1.6,1.2 -2,3.2 0.4,3.6c2.4,0.4 1.6,3.2 1.6,4.8c0,1.6 -0.4,5.2 -0.4,5.2c0,0 0.4,2 -2.4,2c-2.8,0 -5.2,-0.4 -5.6,1.6c-0.4,2 -3.6,5.2 -0.8,7.2c2.8,2 2,3.2 0.4,4c-1.6,0.8 -2.8,4.8 0.4,6c3.2,1.2 2.8,2.4 0.8,4c-2,1.6 -6,2.8 -6,5.2c0,2.4 -0.8,2.4 -3.2,2.8c-2.4,0.4 -3.6,3.6 -0.8,7.6c2.8,4 3.6,3.2 5.6,3.2c2,0 2,-3.2 2,-3.2c0,0 6.8,0.4 8.8,0.4c2,0 4.8,0 6.4,-1.2c1.6,-1.2 6,-3.2 6,0.4c0,3.6 0.8,3.2 2.8,4.8c2,1.6 2.4,0.4 4,2.8c1.6,2.4 2,0.4 3.2,-2.4c1.2,-2.8 3.6,-5.6 5.6,-2.4c2,3.2 2,2.4 4.4,2.4c2.4,0 3.2,1.2 3.2,3.2c0,2 2.4,2 5.2,1.6c2.8,-0.4 3.2,1.6 4.4,3.6c1.2,2 1.6,1.6 3.2,1.6c1.6,0 3.2,0 4.4,-1.6c1.2,-1.6 2.8,-3.6 4.4,-1.2c1.6,2.4 4.8,2 5.6,-0.8c0.8,-2.8 4.4,-5.2 6.4,-2c2,3.2 3.6,3.2 5.6,3.6c2,0.4 4.8,0.4 6,2.4c1.2,2 5.2,5.2 2.4,7.6c-2.8,2.4 -6,5.6 -3.6,6.4c2.4,0.8 4,1.6 5.6,3.6c1.6,2 6.8,2.8 9.2,3.2c2.4,0.4 4.4,0.8 7.2,-1.6c2.8,-2.4 5.6,-2.4 5.2,0.8c-0.4,3.2 1.2,6.8 1.2,6.8c0,0 2,5.2 2,7.2c0,2 -0.4,2.4 3.2,4.8c3.6,2.4 3.2,4 6,1.6c2.8,-2.4 3.6,-3.6 3.6,-5.6c0,-2 0,-6.4 0,-6.4c0,0 4,-0.8 5.6,-2c1.6,-1.2 8,-4.8 9.6,-3.2c1.6,1.6 3.6,1.2 5.2,0.4c1.6,-0.8 4.8,-0.8 6.4,-0.8c1.6,0 4.4,0.4 7.6,-2.4c3.2,-2.8 3.2,-2 5.2,0c2,2 2,4.4 0.8,6c-1.2,1.6 0,5.2 2.8,5.2c2.8,0 3.6,1.6 3.6,3.6c0,2 0.4,4.8 0.8,6.4c0.4,1.6 0.4,2.4 4.8,3.6c4.4,1.2 3.6,4 4.4,6c0.8,2 0.8,3.6 -1.6,3.6c-2.4,0 -3.2,1.2 -3.6,3.2c-0.4,2 -4,2.8 -4,2.8l-3.6,-0.8c0,0 -2.4,0 -3.6,1.6c-1.2,1.6 -3.6,4.8 -2,7.6c1.6,2.8 1.6,4.4 0,5.6c-1.6,1.2 -2.4,7.2 -4,6c-1.6,-1.2 -3.6,0.4 -5.2,1.2c-1.6,0.8 -1.2,6.4 2,8.4c3.2,2 4,4.8 4,4.8l3.6,6c0,0 -1.2,1.2 -2,3.2c-0.8,2 -3.2,6 -0.8,6.8c2.4,0.8 1.2,5.2 -1.2,5.2c-2.4,0 -5.2,-1.2 -5.6,2c-0.4,3.2 -1.6,2.4 -4,2c-2.4,-0.4 -8.4,-2 -10,1.2c-1.6,3.2 -2,4.4 -4.8,4c-2.8,-0.4 -1.6,4.8 -0.8,6.8c0.8,2 3.6,4.8 3.6,4.8c0,0 2.4,2 2.4,6c0,4 -1.6,3.6 -3.2,0.8c-1.6,-2.8 -4.8,-2.4 -5.2,0.8c-0.4,3.2 -0.8,8 -3.6,8c-2.8,0 -4,0.8 -5.2,2.4c-1.2,1.6 -3.2,4.4 -3.2,6c0,1.6 -0.4,3.2 -2.4,3.6c-2,0.4 -2.4,4.8 -2.4,4.8c0,0 -4.8,0.8 -5.2,2.8c-0.4,2 0.4,5.2 -3.6,5.6c-4,0.4 -6.4,3.2 -7.6,5.2c-1.2,2 -1.6,3.6 0,5.6c1.6,2 2.8,8.4 4.8,9.6c2,1.2 3.6,1.6 3.2,4.8c-0.4,3.2 -2.8,5.6 0.4,5.6c3.2,0 5.2,0.8 4,3.6c-1.2,2.8 -1.2,3.2 -3.6,4.4c-2.4,1.2 -3.6,1.2 -3.6,4.4c0,3.2 0.8,3.2 -1.2,4.4c-2,1.2 -2,2.8 -2,5.2c0,2.4 -0.8,1.6 -3.2,4.4c-2.4,2.8 -5.6,2.8 -7.6,2c-2,-0.8 -2.4,-0.8 -2.8,-3.2c-0.4,-2.4 -4,-2.4 -6,-2c-2,0.4 -4.8,2.8 -4.8,2.8c0,0 -3.6,2.4 -2,4.4c1.6,2 0.8,5.2 -2,4.8c-2.8,-0.4 -9.2,3.2 -11.2,-0.4c-2,-3.6 -7.6,-6 -8.4,-1.2c-0.8,4.8 2.4,4.4 2,9.2c-0.4,4.8 -1.2,4.8 -2.8,6.4c-1.6,1.6 -1.6,2.8 -2,4.8c-0.4,2 -0.8,6.4 2,8c2.8,1.6 4,6 4,8.4c0,2.4 0,4.8 2.8,4.8c2.8,0 5.2,-0.4 5.6,-3.2c0.4,-2.8 6,-4.4 6.4,1.2c0.4,5.6 0.4,8.4 2.4,10.8c2,2.4 3.6,5.6 5.2,6.8c1.6,1.2 4.3,11.4 4.3,11.4c-3.9,0.9 -4.9,6.4 -7.4,7.5c-1.4,0.6 -2.9,0.1 -4.2,1.1c-1,0.8 -1,2.3 -2.4,3c-2.9,1.4 -2.4,-3.5 -5.9,-1.7c-3.2,1.6 -3.5,5.6 -8.1,3.9c-2.4,-0.9 -3.9,-11.1 -4.6,-13.5c-0.4,-1.4 -2.9,-5.6 -3.7,-6.9c-2.7,-4.4 -8.1,0 -9.8,-1.3c-2.7,-2 -1.5,-5.4 -5.6,-5.8c-8.3,-0.6 -2.4,5.5 -5.9,6.9c-6.7,2.6 -6.7,-6.8 -11.7,-2.5c-1.9,1.6 3,2.6 1.8,5.4c-1,2.3 -5.9,5.8 -5.6,8.5c0.4,3.7 4.1,4.8 5.2,7.9c3,8.2 -2,13.9 -9.5,7.5c-4.2,-3.6 -5,-10.3 -11.5,-9.8c-1.5,0.1 -2,1.8 -3.5,2c-1.5,0.1 -2.7,-1.5 -4.3,-1c-2.4,0.9 -0.3,2.7 -0.8,4.2c0,0 -3.2,2.9 -3.7,3.7c-1.8,2.6 -1.2,4.9 -3.8,7c-2.2,1.8 -3.9,0.7 -6.3,3.5c-2.5,2.9 -2.7,7.2 -5.9,10c-1.6,1.4 -2.7,-4.2 -4.7,-0.5c-0.3,0.5 -0.6,1 -0.8,1.5c-0.5,1.1 -0.6,1.6 -0.1,2.8c4.2,8.8 -4.6,12.1 -7.3,18.3c-1.2,2.6 2.1,5 0.8,7c-0.9,1.5 -4.8,5.6 -5.1,6.5c-0.3,0.9 -0.7,2.9 -1.4,3.6c-0.7,0.8 -3.1,0.4 -3.3,1.6c-0.2,1.4 2.5,2.5 3.2,3.4c0.9,1.1 -0.4,2.6 -0.1,2.9c4.5,4.9 1.8,3.4 4.1,7.7c0.3,0.6 1.7,-0.5 2.2,1.1c0.5,1.5 -1.1,1.4 -0.5,3.1c0.1,0.5 3.3,5 3.3,5.1c0.2,1.5 -6.1,4.6 -7.5,4.6c-3.8,0.1 3.3,-8.5 -2.9,-8.5c-2.7,0 -2.9,6.7 -3.6,7.4c-0.3,0.3 -2.8,-0 -3.4,-0c-4,-0 -6.6,5.4 -8.2,5.9c-1,0.4 -3.2,-0.6 -4.9,-0.3c-1.6,0.3 -3.5,2 -5,2c-1,0 -1.5,-0.7 -2.3,-1.2c-1.8,-1.1 -5.1,-1.6 -7.1,-2.3c-1.1,-0.4 -3.2,1.5 -3.9,1c-1.3,-0.9 0.9,-3.4 -2.1,-5.2c-0.4,-0.2 -2.6,-6 -2.5,-6.3c1,-3.8 2.1,-7.9 1.6,-11.9c-0.6,-4.1 -6.5,-7.6 -8.1,-10.9c-1.2,-2.5 -2.3,-9.1 -4.6,-10.8c-2.5,-1.8 -4.8,-5.3 -6.1,-8c-0.4,-0.8 0.8,-2.2 -0.1,-3.6c-1,-1.5 -2.9,-2.1 -3.4,-4.1c-0.4,-1.6 -0,-6.8 -1.7,-7.9c-1.9,-1.2 -14.1,-2.8 -17.1,-3.1c-1.6,-0.1 -2.8,-0.1 -4,-1.4c-0.5,-0.5 -1.3,-2.6 -1.7,-2.6c-1.2,-0.1 -2.6,0.6 -3.8,0.7c-0.9,0.1 -2.4,-0.6 -3.2,0c-3.9,2.9 -4.9,6.6 -8.6,9.7c-3.8,3.1 -8,3 -11.8,6.6c-2.4,2.3 -4,7.8 -6.4,10.4c-1,1.1 -2.6,-0 -3,0.5c-2,2.7 -4.8,4.3 -6.8,6.8c-0.4,0.5 -0.3,1.5 -0.8,1.9l-4.3,1.2c-1.1,0.2 -3.2,-0.1 -4.1,0.2c-2,0.7 -1.9,3 -8.7,4.5c-0.5,0.1 -1.4,0.6 -1.8,0.9c-0.8,0.6 -1.4,1.5 -2.2,2.1c-0.5,0.4 -2,-0.3 -2.9,-0.2c-1.7,0.3 -2.7,1.9 -4.3,2.1c-3.6,0.5 -9.4,-1.8 -12.2,-0.6c-1.7,0.7 -6.4,6.4 -8.1,7c-1.1,0.4 -1.9,-0.1 -3.1,-0.6c-0.6,0.8 -2,7 -2.5,8.4c-0,0.1 -7.7,7.1 -8.3,7.9c-1,1.2 -1.4,2.5 -2.6,3.8c-0.8,0.9 -2.1,1.7 -3.4,1.7c-1.6,0 -4,-1.3 -5.5,-1.6c-2.9,-0.5 -11.6,-0.9 -14.2,-0.3c-2.7,0.6 -1.9,9 -8.6,9.8c-3.9,0.5 -7.5,1.3 -11.5,1.7c-0.4,0 -2.8,-1.8 -5.2,-1.1c-0.9,0.3 -3.8,3.5 -3.8,4.5l-0,1.8c-0,0.3 0.8,1.4 0.7,1.5c-1.5,1.9 -4.9,4.9 -6,7.1c-0.3,0.6 -0.7,1.3 -1.2,1.7c-0.9,0.7 -5.5,2.6 -5.9,3.5c-1.1,3 3.2,5.8 2.8,7c-1.2,3.9 -6,7.6 -7.5,11.2c-0.6,1.5 1.6,6.5 1.5,8.2c-0.5,4.7 -2,10.7 -1.8,15.3c0,0.9 0.6,5.6 0.9,6.1c0.5,0.9 1.6,1.4 2.3,2.2c0.7,0.8 6,12 6.2,13.2c1,8.3 -10.1,5.4 -3.7,13.7c1,1.3 1.8,2.7 2.9,3.8c1.4,1.5 9.6,8 9.7,8.7c0.2,1.2 -6.6,2.4 -7.8,3.7c-3.2,3.4 -5.9,9.7 -9,13.2c-1.9,2.2 -3.6,-0.2 -6.1,4.9c-0.9,1.9 -0,6.2 -1.1,7.4c-1.6,1.8 -2.9,-0.6 -4.5,0.2c-0.7,0.3 -1.1,2.5 -1.8,3.1c-1.8,1.7 -17.8,10.9 -19.3,10.1c-0.8,-0.4 -1.7,-3.3 -1.8,-4.2c-0.2,-1 -1.2,-3.2 -2,-3.9c-4.1,-3.8 -10.4,-4.5 -14.4,0.1c-1,1.2 -1.1,3 -2.4,4.2c-2.2,2 -4.7,3.8 -6.8,5.8c-0.4,0.4 -1.6,1.9 -2.1,1.8c-1.6,-0.2 -5.5,-5 -6.5,-6.3c-1.8,-2.3 -7,-7.8 -7.5,-10.4c0,-8.9 -6.4,-18.2 -9.1,-26.9l4,0.1c4.5,-3.3 3.2,-11.4 11.3,-8.2c1,-1.5 0.9,-3.1 2.8,-4.2c0.7,-0.4 2,-0.8 2.4,-1.5c2.7,-4.5 5.9,-21.7 3.1,-26.1c-2.5,-4 -5.1,-3.8 -7.1,-10.4c-0.6,-1.8 0.5,-3.9 -0,-5.9c-0.4,-1.6 -3.1,-11.1 -3.5,-11.8c-0.5,-0.8 -2.2,-1.8 -2.3,-2.3c-0.1,-0.8 -0.7,-11.1 -0.4,-11.9c-2.7,-8 -11.8,-13.1 -12.3,-14c-1.1,-1.9 -2.2,-4.4 -3.4,-6.5c-1.4,-2.5 -1.4,-3.8 -2.2,-6.2c-0.3,-1.1 -1.8,-2 -1.9,-3.2c-0.2,-2.1 5.3,-6.5 5.1,-10.2c-0.1,-1.2 -3.5,-4.8 -2.8,-6.8c0.7,-2.1 4.2,-6.8 4.1,-9.1c-0.2,-3.1 -5.5,-9.8 -6.2,-13.1c-0.3,-1.6 2.1,-2.9 1.5,-4c-0.7,-1.4 -6.3,-6.9 -7.2,-8.5c-0.7,-1.2 2.1,-2.8 0.1,-5c-1.8,-2 -0.3,-1.3 -0.8,-3c-0.6,-1.9 -2.6,-3.6 -3.4,-5.6c-0.7,-1.7 -5.5,-20.5 -5.4,-21.6c-0.8,-1.3 -2.2,-2.4 -2.9,-3.7c-0.7,-1.3 -1,-3.8 -1.6,-4.8c-0.1,-0.1 -5.4,-1.8 -6.4,-3.5c-0.8,-1.4 -1,-6 -2.4,-8.3c-0.7,-1.1 -1.8,-0.9 -2.6,-1.7c-0.7,-0.6 -0.6,-1.7 -1.1,-2.4c-1.6,-2.4 -4.8,-0.2 -7,-9c-2.9,-2.2 -5.6,-4.1 -8.1,-6.8c-0.5,-0.5 -0.8,-1.1 -1.4,-1.4c-2,-0.9 -5,-1.2 -6.7,-2.8c-1,0 -6.3,-0.2 -6.9,-0.6c-0.6,-0.4 -1.2,-2.9 -1.6,-3c-2.8,-0.6 -7.4,-0.3 -9.8,-2.5c-1.9,-1.8 -2.3,-10.5 -5.7,-9.3c-0.4,-0.2 -0.9,-0.4 -1.4,-0.3c-2.2,-3.1 -9.8,-3.5 -12.9,-5.5c-0.9,-0.6 -3.8,-0.1 -3.8,-1c0.7,-1.7 0.5,-3.1 0.6,-4.8c-1.7,-1.8 -2.8,-3.9 -4,-5.2c-2.9,-0.7 -1.8,-1 -3.6,-2.2c-5,-0.4 -5.5,0.5 -8.7,3.7c-0.8,0.8 -2.4,1 -3.4,1.6c-1.7,1 -2.2,4.3 -4.6,2.8c-0.8,-0.5 -1.3,-1.3 -1.9,-1.9c-1.4,-1.3 -2.2,-0.6 -2.9,-3c-4.1,-2.4 -15.4,5.9 -18.1,0.1c-1.9,-1.1 -3.3,0.3 -4.9,-1.5c-0.8,-0.9 2.2,-10.9 -6,-15c1.9,-1.6 3.9,-2.7 5.7,-4.2c0.5,-1.1 -0.1,-2.8 -0.1,-3.9c-0,-1.7 1,-5 0.7,-6.2c-0.3,-1.2 -1.5,-2.2 -1.9,-3.6c-0.5,-1.4 0.1,-3.2 -0.6,-4.7c-0.5,-0.4 -2,-1.4 -2.6,-1.4c-2.1,-1.9 -4.4,-3.1 -6.1,-5.4c-0.4,-0.5 -0.7,-1.4 -1.2,-1.8c-1.5,-1.2 -6.4,-2.8 -6.2,-5.3c0.1,-0.8 1.1,-0.9 1.4,-1.7c0.3,-1 0.1,-2.3 0.8,-3.2c2.3,-3.4 7.4,-1.9 6.6,-8.2c-0.4,-2.8 -2.2,-5.2 -2.7,-8.2c-0.9,-0.7 -1,-1.9 -1.8,-2.6c-5,-0.5 -4.3,-6.1 -6.1,-7.4c-5.3,-3.9 -9.4,-1.5 -3.5,-9.2c0.8,-2.5 -5.1,-6.5 -6.3,-7.9c-2.1,-2.2 -1.1,-6.8 -1.9,-9.2c-0.4,-1.2 -3.9,-3.3 -5,-5c-0.3,-0.5 -1.2,-3.1 -1.7,-3.4l0.1,-0.8c1.1,-0.9 0.5,-2.7 0.2,-3.9c-0.7,-0.7 -2.2,-0.5 -2.7,-1c-4.8,-4.7 -10.6,-6.8 -16.9,-9.5c-1.7,-0.7 -1.2,-2.2 -2.6,-2.9c-1.2,-0.6 -9.7,-4.7 -10.3,-4.5c-1,-0.3 -1.7,-4.4 -2.4,-5.7c-0.6,-1.2 -3,-3.4 -3,-3.5c0.2,-3.8 -2,-4.3 -4.7,-6.3c0.2,-0.5 -0.3,-1.7 -0.3,-2.3c-0,-0.5 1.8,-7.1 2.1,-8c0.5,-1.4 2.2,-2.7 1.9,-4.3c-0.4,-2.5 -0.7,-6.4 -1.5,-8.6c-2.7,-7.8 -5.9,-6.8 -4.2,-17c0.4,-2.1 -0.3,-3.3 1.2,-5.2c-0.2,-0.1 0.7,-1.1 0.8,-1.3c0.9,-0.9 3.4,-2.4 3.9,-3.1c1.5,-2.2 2.4,-7.2 4.3,-8.8c1.4,-1.2 5.4,-3.5 6.1,-4.5c0.6,-0.8 1.5,-3.3 1,-4.3c-1.4,-0.9 -2.8,-0.5 -4.2,-0.7c-0.5,-0.1 -2.3,-1.5 -3.7,-1.8c-0.4,-0.5 -1.1,-1.1 -1.1,-1.8l-0.6,-0.6c-1.6,-0.2 -3.4,-1.3 -4.8,-1.8c-1.8,-0.8 -4.3,-0.9 -6,-2c-3.2,-2 -6.8,-7.5 -9.9,-8.3c-4.2,-1 -6.9,0.4 -10.9,0.6c-2.6,0.2 -2.6,-1.5 -4.7,-2.2c-2.8,-0.9 -0.7,1.6 -7.1,-0.6c-0.8,-0.7 0.4,-3.1 0.5,-4c-1,-0.3 -2.2,0.3 -3.4,-0c-5.3,-1.4 -3.3,-6.6 -4.7,-10c-0.6,-0.8 -2.8,-0.6 -3.8,-0.7c-0.3,-0.1 -0.4,-0.6 -0.3,-0.8l0.5,-0.4c0.9,-1.5 -2.3,-5.3 -2.2,-5.8c0.2,-1.2 6.7,-2.3 7.6,-2.4c0.3,-0.9 -0.6,-1.7 -0.7,-2.6c-0.2,-2 1,-4.6 1.6,-6.4l-0.2,-0.6c-1.8,-1.1 -2.4,-2.7 -4,-4c0.1,-0.9 1.2,-1.5 1.4,-2.4c3.1,-9.3 7.9,-1.9 12.1,-10.5c0.4,-0.8 1.6,-2.9 2,-4.3l0.8,-0.2c0.8,0.2 1.9,0.9 2.7,0.6c0.6,-0.9 1.9,-1.2 2.9,-1.5l1.5,0.4c7.8,-1.8 6,-4.9 10.5,-8.4c1.2,-0.9 4.7,-1.3 6.3,-1.9c1.7,0.8 4.1,3.7 7.3,5c2.3,1 10.2,2.8 11.5,3.6c1.7,1 2,3.4 3.5,4.3c4.5,2.6 1.9,-1.8 6.2,-0.9c4.4,1 8,4.9 12.1,6.8c0.7,0.3 2.4,-0.1 3.2,-0.3c1.3,-0.3 8.3,-1.7 9,-1.4c0.8,0.3 2,1.1 2.8,1.3c1,0.2 1.8,-2.1 2.5,-2c3,0.5 3.1,1.8 7.1,1.4c0.2,-0 2.1,-12.2 4,-12.8c1.1,-0.3 4.1,2.9 5,3.1c1.5,0.4 -0.1,-2.5 -0.2,-2.7c-0.4,-1 -2.5,-8.5 -2.4,-9.2c0.1,-0.4 2,0.6 2.9,0.3c2.2,-0.8 5.2,-1.4 6.8,-3.3c0.2,-0.2 3.6,-5.5 3.7,-5.7c0.2,-0.9 -0.9,-3 -0.4,-3.7c0.5,-0.6 2.4,-1.4 3.3,-2.4c1.3,-1.4 1.5,-3.8 3.3,-4.8c7.1,-0.7 9.6,-6.7 16,-7.5c0.4,-0 1.8,-0.3 2.1,-0.2l1.3,2.3c0.4,0.6 4.7,3.4 5.4,3.2c0.6,-0.1 0.9,-1.2 1.5,-1.4c1.3,0.2 4.9,-2.2 5.3,-3.4c0.1,-0.2 -0.8,-1.4 -0.4,-2.2c0.3,-0.6 4.8,-4.2 5.5,-4.6c1.6,-0 3.3,-0.4 4.8,0.2c0.9,0.4 1,1.9 2,2.1c1.1,0.1 3.1,-0.4 3.9,-0.2c0.9,0.2 1.3,-1.8 2.4,-1.9z'/%3E %3Cg id='h'%3E %3Cuse xlink:href='%23star' x='461.835' y='121.826'/%3E %3Cuse xlink:href='%23star' x='544.233' y='136.356'/%3E %3Cuse xlink:href='%23star' x='622.857' y='164.972'/%3E %3C/g%3E %3Cuse xlink:href='%23h' x='-840' transform='scale(-1,1)'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 2880 1440'%3E %3Cdefs%3E %3Cpath id='s' d='M0,0 0.309017,0.951057 -0.5,0.363271H0.5L-0.309017,0.951057z'/%3E %3C/defs%3E %3Crect width='2880' height='1440' fill='%23ce1126'/%3E %3Crect width='1440' height='720' fill='%23002b7f'/%3E %3Cg fill='%23fff'%3E %3Cuse xlink:href='%23s' transform='translate(720,30) scale(160)'/%3E %3Cuse xlink:href='%23s' transform='translate(500,210) scale(160)'/%3E %3Cuse xlink:href='%23s' transform='translate(945,180) scale(150)'/%3E %3Cuse xlink:href='%23s' transform='translate(830,364.894348) scale(100)'/%3E %3Cuse xlink:href='%23s' transform='translate(720,499.788697) scale(200)'/%3E %3C/g%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 450 300'%3E %3Crect width='450' height='300'/%3E %3Crect fill='%23FFF' width='450' height='200'/%3E %3Crect fill='%23CE1126' width='450' height='100'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 900 600'%3E %3Crect width='900' height='600' fill='%23ED2939'/%3E %3Crect width='600' height='600' fill='%23fff'/%3E %3Crect width='300' height='600' fill='%23002395'/%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 9 6'%3E %3CclipPath id='Z'%3E %3Cpath d='M0,0 4.5,3 0,6' id='X'/%3E %3C/clipPath%3E %3CclipPath id='A'%3E %3Cpath d='M0,0H9V6H0z'/%3E %3C/clipPath%3E %3Cg clip-path='url(%23A)'%3E %3Cpath d='M0,0V6H9V0z' fill='%23002395'/%3E %3Cpath d='M0,0V3H9V0z' fill='%23de3831'/%3E %3Cg stroke-width='2' stroke='%23fff'%3E %3Cpath d='M0,0 4.5,3 0,6M4.5,3H9' id='W'/%3E %3Cuse xlink:href='%23X' stroke='%23ffb612' clip-path='url(%23Z)'/%3E %3C/g%3E %3Cuse xlink:href='%23W' fill='none' stroke='%23007a4d' stroke-width='1.2'/%3E %3C/g%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 2100 1400'%3E %3Crect width='2100' height='1400' fill='%23198a00'/%3E %3Crect x='1850' y='500' width='250' height='900' fill='%23ef7d00'/%3E %3Crect x='1600' y='500' width='250' height='900' fill='%23000'/%3E %3Crect x='1350' y='500' width='250' height='900' fill='%23de2010'/%3E %3Cg fill='%23ef7d00' stroke='%23000' stroke-width='2.25' stroke-linecap='round' stroke-linejoin='round'%3E %3Cpath d='M 1916.4245,168.3344 C 1916.4245,168.3344 2002.4265,134.6285 2010.7593,127.6785 C 2014.5489,131.8483 1976.2829,174.2418 1902.0276,189.87871 C 1969.4633,175.2842 2027.0511,129.4158 2038.7957,130.8058 C 2042.2056,131.5008 2041.4461,175.6316 1886.8731,213.85517 C 1993.7101,188.14097 2055.8431,140.8829 2055.0855,146.0952 C 2055.8431,147.1376 2044.4782,183.27622 1950.9008,211.42263 C 1977.0424,205.86205 2047.8881,166.2494 2047.1305,173.8943 C 2049.4031,177.0216 1978.5575,260.41781 1850.5039,233.31502 C 1952.7956,257.63859 2019.0941,198.91314 2028.5661,199.95564 C 2030.4609,200.30309 2009.6221,251.38355 1880.8128,254.51107 C 1942.568,248.60433 1924.7593,254.16286 1924.7593,254.16286 C 1924.7593,254.16286 1888.3881,280.22426 1844.4417,262.50402 C 1878.918,271.19178 1882.7056,271.53828 1883.4633,274.31751 C 1881.1906,277.79154 1852.7764,283.00526 1825.4995,269.45208 C 1847.4718,277.79154 1867.1733,279.18294 1867.5512,282.31046 C 1867.1733,283.35177 1853.1561,290.64992 1840.654,285.43798 C 1828.1518,280.22426 1712.9782,215.24513 1712.9782,215.24513 L 1909.227,165.902 z'/%3E %3Cpath d='M 1685.7126,344.10525 C 1668.4556,344.10525 1667.9794,358.19028 1667.9794,358.19028 C 1667.9794,358.19028 1666.5551,359.20736 1667.5052,366.03421 C 1670.3541,361.38542 1671.7804,359.93337 1671.7804,359.93337 C 1673.6808,360.22451 1681.5962,362.40249 1694.104,353.39936 C 1682.7032,364.28942 1689.5134,368.35602 1689.5134,368.35602 C 1689.5134,368.35602 1686.8216,376.92419 1695.5285,378.66728 C 1692.8383,375.18109 1694.4214,372.13156 1694.4214,372.13156 C 1694.4214,372.13156 1706.6118,370.97066 1705.8204,357.32052 C 1706.2964,369.66245 1713.5789,372.71197 1713.5789,372.71197 C 1713.5789,372.71197 1713.5789,379.53704 1721.4943,380.11924 C 1717.2212,376.63305 1718.1694,371.26002 1718.1694,371.26002 C 1718.1694,371.26002 1728.4613,364.43494 1719.7526,352.81725 C 1724.9778,350.05699 1729.2529,342.36216 1729.2529,342.36216 C 1729.2529,342.36216 1722.1291,339.60198 1718.8042,337.28017 C 1717.2192,334.22886 1718.6456,317.52919 1718.6456,317.52919 L 1714.3704,295.89129 L 1702.1781,329.58356 C 1702.6522,324.79085 1702.9697,344.10525 1685.7126,344.10525 z'/%3E %3Cpath d='M 1770.9438,295.51356 C 1771.3216,295.86186 1783.8256,308.72015 1795.9482,308.02364 C 1800.4933,304.54953 1786.4761,296.90496 1786.4761,295.16705 C 1791.401,299.33759 1812.238,315.66829 1825.4995,309.76147 C 1830.8022,302.81171 1816.0275,303.85472 1799.7358,285.08968 C 1811.1007,292.03953 1839.5168,307.32884 1852.7764,301.42209 C 1858.4607,295.86186 1823.225,278.48634 1811.4804,264.93494 L 1781.1734,250.68874 L 1739.8773,281.61565 z'/%3E %3Cpath d='M 1724.3449,189.87853 C 1724.3449,189.87853 1738.3622,182.23388 1794.433,186.05621 C 1800.4952,186.75101 1832.6971,175.9792 1842.9266,172.8518 C 1859.2164,170.0719 1911.1199,159.6472 1925.1389,149.9175 C 1934.9888,148.8752 1922.4847,166.597 1909.9846,170.7667 C 1896.7229,176.32663 1848.6091,191.61602 1831.5597,189.53109 C 1852.0189,189.87871 1840.654,205.16792 1806.5555,197.87072 C 1822.8472,206.21035 1816.785,207.6003 1816.785,207.6003 C 1816.785,207.6003 1787.993,208.99025 1780.4158,203.083 C 1799.7377,209.68531 1791.7807,212.11761 1791.7807,212.11761 C 1791.7807,212.11761 1772.0811,213.855 1762.9868,210.03267 C 1777.0041,213.855 1769.8065,216.28754 1769.8065,216.28754 C 1769.8065,216.28754 1758.4416,218.02494 1748.9696,214.89759 C 1739.4994,211.77024 1725.1025,189.87853 1724.3449,189.87853 z'/%3E %3Cpath d='M 1746.8274,302.71636 L 1748.8865,336.69798 C 1748.8865,336.69798 1747.7776,338.44108 1746.8274,339.45816 C 1745.8771,340.47353 1720.5441,335.82644 1724.0276,353.54318 C 1724.0276,360.80493 1724.1863,362.69184 1729.5703,366.75845 C 1728.144,361.96582 1728.6201,358.62694 1728.6201,358.62694 C 1728.6201,358.62694 1735.7439,362.54802 1742.711,351.80187 C 1737.9617,362.40249 1741.2846,366.17804 1742.3936,366.46909 C 1743.5025,368.35772 1740.495,376.92419 1749.9935,376.77866 C 1746.3532,373.58352 1748.0949,368.93642 1748.0949,368.93642 C 1748.0949,368.93642 1758.0695,367.48617 1754.5859,350.93033 C 1758.2281,347.58966 1759.6525,350.78479 1759.6525,350.78479 C 1759.6525,350.78479 1760.7596,360.65939 1769.4684,358.62694 C 1773.428,360.65939 1768.8356,366.03242 1768.8356,366.03242 C 1768.8356,366.03242 1775.1678,366.17804 1777.0683,361.23981 C 1778.9688,356.30336 1781.1847,347.44413 1770.7341,343.81411 C 1769.4684,340.32971 1774.8524,340.03856 1774.8524,340.03856 C 1774.8524,340.03856 1781.502,342.07101 1783.4006,345.12063 C 1785.3011,348.17015 1784.6682,337.13456 1776.4354,335.97196 C 1766.3022,335.68091 1765.6694,333.79399 1765.6694,333.35902 C 1765.6694,332.92244 1763.9276,308.67167 1763.1361,301.70098 z'/%3E %3Cpath d='M 1782.0688,331.67486 C 1782.1934,330.11719 1764.7834,308.61621 1769.2001,305.83699 C 1773.6149,306.67035 1780.8559,316.44969 1786.7216,313.27539 C 1784.9439,309.46353 1779.7036,311.61029 1773.7529,301.85179 C 1767.8041,290.81969 1766.9351,274.25865 1746.0981,256.19352 C 1759.5883,275.31034 1790.1901,286.5157 1791.4861,280.9416 C 1792.782,275.3675 1764.5397,254.28933 1765.9868,249.20906 C 1771.6031,259.64161 1799.9606,282.88746 1820.8542,280.96244 C 1822.2862,276.48689 1803.7445,267.45433 1798.9726,259.01961 C 1785.626,250.79616 1749.9084,222.55764 1749.1925,216.00857 C 1736.1954,198.622 1728.0817,193.36226 1724.3034,191.35975 C 1722.8431,189.78217 1722.4767,188.27399 1722.1914,187.31517 C 1714.123,169.8692 1724.8097,164.2041 1731.0646,163.3664 C 1736.2124,162.8417 1737.7067,163.5485 1741.4113,161.9032 C 1737.0247,160.3293 1732.6401,158.8574 1728.2554,157.2835 C 1733.9738,161.1307 1748.5805,157.7436 1745.4143,168.8249 C 1751.8184,166.5901 1765.4446,151.7209 1729.9707,148.3652 C 1718.4264,136.218 1670.9623,129.237 1659.0818,182.2531 C 1660.0301,182.99639 1660.5269,183.60716 1663.5458,185.67499 C 1648.5575,179.01161 1608.1248,173.8732 1593.554,171.7138 C 1554.1905,161.297 1513.3099,136.1939 1509.3802,139.2811 C 1504.1242,141.4208 1533.1636,166.2005 1531.6542,166.749 C 1506.4747,153.2833 1483.4723,143.7431 1462.0688,135.0617 C 1447.0114,129.8992 1431.9299,117.8797 1430.2669,120.1662 C 1424.7253,130.6954 1454.4075,157.1623 1459.9287,160.2757 C 1465.4516,163.2539 1508.8759,181.72909 1508.2356,181.95975 C 1442.8304,154.731 1431.8645,149.7947 1428.5824,146.6553 C 1422.8177,145.4644 1408.775,128.074 1404.8615,129.1923 C 1402.719,131.1229 1407.0161,158.6011 1438.2263,170.9357 C 1443.3134,174.3363 1505.1266,194.67481 1504.5213,196.26941 C 1504.3701,196.66789 1433.7231,169.5256 1430.9789,168.5552 C 1417.358,163.6563 1400.6447,146.4846 1397.5201,148.4156 C 1394.5379,150.1678 1405.2248,168.754 1418.9884,174.5834 C 1426.2027,177.50343 1453.8752,190.0745 1478.8069,198.07552 C 1480.3981,198.60329 1433.9924,181.93483 1411.6811,173.3834 C 1401.5649,168.2337 1396.801,161.8148 1395.2601,163.1959 C 1392.9808,164.5768 1398.9425,192.03295 1470.6403,207.52545 C 1472.5293,208.26287 1495.8781,202.45215 1494.7241,203.22283 C 1494.4354,203.41556 1471.5384,207.98755 1469.309,207.83131 C 1467.3249,207.55335 1454.781,209.19336 1454.5541,209.78959 C 1453.7962,211.64683 1459.0989,221.47779 1496.1182,219.42766 C 1500.8508,219.16671 1526.5335,210.84928 1524.3758,212.63847 C 1523.2969,213.53358 1489.403,223.63519 1486.8217,223.83447 C 1484.5797,224.12502 1472.6728,225.26704 1472.2326,226.42862 C 1471.695,228.01284 1481.0459,235.00963 1500.9262,236.13064 C 1518.5282,236.98833 1551.9751,226.26591 1551.3042,226.96106 C 1550.6331,227.65612 1519.0604,237.5792 1518.2342,238.18393 C 1517.0918,238.77651 1505.5304,239.35172 1505.1246,240.16612 C 1504.1825,242.19168 1521.802,257.30424 1573.911,241.1763 C 1568.6762,247.66176 1543.4181,252.09749 1543.4544,253.26528 C 1543.3373,254.11259 1549.0191,259.14779 1557.8497,260.94983 C 1562.2647,261.85081 1568.3098,261.66709 1573.8316,260.86664 C 1583.7496,259.04555 1594.202,255.44675 1607.4824,244.18943 C 1609.0694,247.7224 1574.3077,263.85722 1575.9399,265.39586 C 1583.4775,271.80689 1608.5159,264.56939 1610.1556,263.72905 C 1611.7972,262.88693 1658.3714,238.79904 1658.2108,236.01114 C 1658.9344,239.58392 1598.1654,269.86969 1598.8209,271.11208 C 1602.7219,276.82124 1623.4814,270.81226 1624.4731,270.28731 C 1625.4631,269.76397 1650.9661,257.1275 1651.665,256.75496 C 1652.3622,256.38243 1621.6924,273.21904 1624.4241,275.78162 C 1623.1036,286.71498 1672.3226,268.23581 1676.1801,265.93476 C 1678.1089,264.78423 1652.5359,276.24772 1652.4679,281.69356 C 1660.7027,294.46357 1687.0709,290.41253 1691.1381,287.60379 C 1693.1727,286.19862 1688.7446,297.09029 1690.1709,296.10094 C 1690.6678,295.89648 1695.9063,290.21495 1697.9201,286.10327 C 1697.2777,289.67094 1694.3874,295.29174 1692.7004,301.74087 C 1691.0116,308.18993 1690.5279,315.46723 1688.2101,323.19855 C 1687.6791,326.59459 1704.4583,316.5589 1702.0213,292.56797 C 1703.4571,305.04684 1696.7224,328.38106 1698.4848,329.59393 C 1702.01,332.01968 1711.7559,317.97275 1712.7401,308.47409 C 1715.6343,313.2719 1721.7078,323.28692 1726.9331,325.59137 C 1726.3645,318.33312 1727.0332,318.66586 1724.6813,311.53229 C 1726.0376,302.06144 1726.2266,288.9536 1726.5552,274.15293 C 1740.7539,299.1002 1746.4174,309.63499 1742.4503,328.73974 C 1746.6724,330.35457 1753.4165,315.40489 1752.8725,307.70996 C 1758.2943,329.09143 1781.6966,332.29695 1782.0688,331.67486 z'/%3E %3Cpath d='M 1545.5749,173.2876 C 1545.5749,173.2876 1535.9106,179.9848 1523.8842,179.591 C 1526.8908,190.62165 1551.8029,182.15172 1551.8029,182.15172 C 1551.8029,182.15172 1539.7764,194.36428 1531.1861,196.33396 C 1536.3403,200.27349 1558.0311,198.89477 1561.6827,196.925 C 1565.3326,194.95515 1571.7762,187.27308 1571.7762,187.27308 C 1571.7762,187.27308 1549.4406,210.91026 1546.2193,210.71344 C 1545.7897,213.47107 1569.6284,212.48614 1574.5684,208.34971 C 1579.5066,204.21311 1591.9634,198.10691 1591.9634,198.10691 C 1591.9634,198.10691 1559.3195,218.98639 1557.8157,218.98639 C 1570.0573,221.94117 1594.5402,215.44075 1610.2179,206.57684 C 1587.0233,220.75926 1584.8773,223.31981 1573.0646,228.04728 C 1583.5889,230.2142 1588.9559,236.71462 1624.6073,222.53196 C 1645.0097,213.66823 1656.6051,197.51588 1656.6051,197.51588 C 1643.9348,213.07718 1623.9613,226.27561 1601.8435,239.27551 C 1600.5532,241.63891 1625.4649,251.28999 1657.2493,220.95624'/%3E %3Cpath d='M 1718.2413,239.07802 C 1718.2413,239.07802 1720.3891,248.33581 1728.9789,255.42769 C 1737.5707,262.51788 1738.2149,269.41228 1738.2149,269.41228'/%3E %3Cpath d='M 1713.9473,178.80314 C 1713.9473,178.80314 1716.9529,187.07601 1725.758,192.39452 C 1734.7786,197.71286 1748.3103,214.45591 1749.3833,217.41051 C 1750.4223,220.98661 1755.6098,246.76077 1755.1811,249.51746'/%3E %3Cpath d='M 1659.1838,191.60649 C 1659.8279,194.75808 1646.5116,210.71344 1664.7661,229.42617 C 1648.2288,247.94073 1648.2307,250.30583 1648.2307,250.30583 C 1648.2307,250.30583 1657.4646,255.03262 1674.0019,242.0322 C 1701.2751,272.76153 1692.1866,286.82411 1692.1866,286.82411'/%3E %3Cpath d='M 1690.0141,265.13074 C 1690.0141,265.13074 1687.5016,261.82996 1691.9807,249.5036 C 1696.0139,253.96009 1700.4987,254.91133 1702.4653,256.71508 C 1704.4299,258.51881 1725.0232,261.25304 1726.3323,273.87565'/%3E %3Cpath d='M 1714.2231,149.4322 C 1714.2231,148.5049 1710.0765,140.3439 1694.6066,150.5451 C 1702.8979,151.0086 1711.0872,155.3674 1714.2231,149.4322 z'/%3E %3Cpath d='M 1861.8688,186.75118 C 1862.6263,187.09854 1908.0897,196.13332 1923.2443,191.61602 C 1903.9224,215.24513 1865.2786,199.26067 1865.2786,199.26067 C 1884.2207,204.47295 1884.9802,204.12559 1891.0404,208.99025 C 1892.9352,213.50756 1856.1863,211.42263 1844.0619,205.16792 C 1877.7808,214.89759 1878.5384,214.20262 1879.6755,218.02494 C 1881.1926,223.23722 1824.3623,216.63491 1819.4373,209.68531 C 1834.5918,220.45741 1842.9266,222.54242 1851.2614,227.40708 C 1841.0319,231.57703 1822.0896,235.74603 1787.2336,213.16019 C 1833.0748,251.38355 1874.371,248.95092 1880.8128,255.90068 C 1864.9008,277.44503 1803.1456,243.04417 1774.7314,225.66951 C 1746.3173,208.29527 1836.8644,267.71596 1845.2011,266.67286 C 1841.0319,272.5796 1811.1026,267.36766 1809.2077,264.58844'/%3E %3Cpath d='M 1873.6134,226.71211 C 1868.3106,227.40708 1852.3986,227.40708 1850.126,227.05955'/%3E %3Cpath d='M 1532.2598,166.9845 C 1532.2598,166.9845 1566.8363,183.72743 1581.4391,182.54561 C 1577.574,185.89418 1571.7744,187.27308 1571.7744,187.27308 C 1575.4261,188.65197 1585.5196,193.57642 1600.7685,190.42467 C 1597.1169,193.77324 1592.3922,197.51604 1592.3922,197.51604 C 1592.3922,197.51604 1605.4932,202.04636 1620.3114,194.95515 C 1615.8021,200.07642 1613.2234,203.81922 1613.2234,203.81922 L 1623.5324,204.41009'/%3E %3C/g%3E %3C/svg%3E"},function(a,i){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 252 126'%3E %3Crect fill='%23319208' width='252' height='126'/%3E %3Crect y='18' fill='%23FFD200' width='252' height='90'/%3E %3Crect y='36' fill='%23DE2010' width='252' height='54'/%3E %3Crect y='54' width='252' height='18'/%3E %3Cpath d='M4.583,0l84,63l-84,63H0V0H4.583z'/%3E %3Cpath fill='%23FFF' d='M0,0l84,63L0,126'/%3E %3Cpolygon fill='%23DE2010' points='46.161,66.045 64.434,53.111 43.405,50.056 34,31 24.595,50.056 3.566,53.111 21.839,66.045 17.836,85.248 34,76 50.164,85.248 '/%3E %3Cpath fill='%23FFC618' d='M28.635,55.109c1.976,4.305,2.47,4.588,7.411,6.282c4.94,1.694,18.898,3.3,20.274,3.458c-0.9-0.9-16.621-12.545-19.85-14.875c-3.229-2.329-4.129-3.388-4.129-3.388s-2.911-5.24-3.917-6.776c-1.006-1.535-2.858-3.705-5.293-3.705s-3.917,1.429-4.623,3.97c-0.388,0.106-2.47,1.376-2.4,2.682c0.6-0.071,4.376-1.129,5.682,3.141c1.306,4.27,1.376,11.257,0.035,14.716c-1.341,3.459-3.423,6.07-3.423,9.105c0,0.423,0.282,1.27,0.988,1.27c0.247,1.341,2.223,10.904,2.223,10.904h28.161l4.473-17.292'/%3E %3Cg fill='none' stroke='%23000' stroke-width='0.2117'%3E %3Cpath d='M28.635,55.109c1.976,4.305,2.47,4.588,7.411,6.282c4.94,1.694,18.898,3.3,20.274,3.458c-0.9-0.9-16.621-12.545-19.85-14.875c-3.229-2.329-4.129-3.388-4.129-3.388s-2.911-5.24-3.917-6.776c-1.006-1.535-2.858-3.705-5.293-3.705s-3.917,1.429-4.623,3.97c-0.388,0.106-2.47,1.376-2.4,2.682c0.6-0.071,4.376-1.129,5.682,3.141c1.306,4.27,1.376,11.257,0.035,14.716c-1.341,3.459-3.423,6.07-3.423,9.105c0,0.423,0.282,1.27,0.988,1.27c0.247,1.341,2.223,10.904,2.223,10.904h28.161l4.473-17.292'/%3E %3Cpath d='M19.39,70.99c0,0,5.999-0.353,7.623-0.353c1.623,0,16.734,0.019,25.165,1.968'/%3E %3Cpath d='M21.508,70.871c0,0-0.601-0.728-0.213-2.175 c0.388-1.447,4.623-5.188,4.623-10.481'/%3E %3Cpath d='M25.142,70.637c0,0-0.494-2.364,4.905-4.376 c1.518-0.459,5.858-2.894,5.999-4.87'/%3E %3Cpath d='M29.473,66.485c0,0,13.243,0.058,23.724,2.175'/%3E %3Cpath d='M32.793,64.905c0,0,4.551,0.156,5.292-0.056c0.741-0.212,2.053-0.762,2.575-2.313'/%3E %3Cpath d='M35.49,64.959c0,0,2.434-1.265,2.911-2.911'/%3E %3Cpath d='M28.141,81.894c0,0-1.041-7.216-1.253-11.257l2.717,2.594l2.875-2.514l2.472,2.638l2.858-2.425l2.471,2.778l2.83-2.407l2.252,2.618l2.822-2.041l3.355,3.189'/%3E %3Cpath d='M50.951,77.345c-10.081-1.444-23.57-1.35-23.57-1.35'/%3E %3Cpath d='M22.694,51.052c0,0,8.2-3.918,9.647-4.465'/%3E %3C/g%3E %3Cg transform='matrix(0.211738,0,0,0.211738,16,36)' fill='none' stroke='%23000'%3E %3Cpolyline points='52.487,177.086 65.505,188.938 77.267,177.176 89.163,189.442 102.009,178.084 113.836,190.514 127.175,179.501 138.072,192.229 151.342,182.084 165.289,194.403'/%3E %3Ccircle cx='89.425' cy='154.584' r='5.167'/%3E %3Ccircle cx='111.237' cy='156.047' r='5.167'/%3E %3Ccircle cx='30.05' cy='16.5' r='4'/%3E %3C/g%3E %3C/svg%3E"},function(a,i,c){a.exports=c(258)},function(a){a.exports=JSON.parse('[{"name":{"common":"Aruba","official":"Aruba","native":{"nld":{"official":"Aruba","common":"Aruba"},"pap":{"official":"Aruba","common":"Aruba"}}},"tld":[".aw"],"cca2":"AW","ccn3":"533","cca3":"ABW","cioc":"ARU","independent":false,"status":"officially-assigned","currencies":{"AWG":{"name":"Aruban florin","symbol":"ƒ"}},"idd":{"root":"+2","suffixes":["97"]},"capital":["Oranjestad"],"altSpellings":["AW"],"region":"Americas","subregion":"Caribbean","languages":{"nld":"Dutch","pap":"Papiamento"},"translations":{"ces":{"official":"Aruba","common":"Aruba"},"deu":{"official":"Aruba","common":"Aruba"},"fra":{"official":"Aruba","common":"Aruba"},"hrv":{"official":"Aruba","common":"Aruba"},"ita":{"official":"Aruba","common":"Aruba"},"jpn":{"official":"アルバ","common":"アルバ"},"nld":{"official":"Aruba","common":"Aruba"},"por":{"official":"Aruba","common":"Aruba"},"rus":{"official":"Аруба","common":"Аруба"},"slk":{"official":"Aruba","common":"Aruba"},"spa":{"official":"Aruba","common":"Aruba"},"fin":{"official":"Aruba","common":"Aruba"},"est":{"official":"Aruba","common":"Aruba"},"zho":{"official":"阿鲁巴","common":"阿鲁巴"},"pol":{"official":"Aruba","common":"Aruba"},"urd":{"official":"اروبا","common":"اروبا"},"kor":{"official":"아루바","common":"아루바"},"per":{"official":"آروبا","common":"آروبا"}},"latlng":[12.5,-69.96666666],"landlocked":false,"borders":[],"area":180,"flag":"🇦🇼","demonyms":{"eng":{"f":"Aruban","m":"Aruban"},"fra":{"f":"Arubaise","m":"Arubais"}}},{"name":{"common":"Afghanistan","official":"Islamic Republic of Afghanistan","native":{"prs":{"official":"جمهوری اسلامی افغانستان","common":"افغانستان"},"pus":{"official":"د افغانستان اسلامي جمهوریت","common":"افغانستان"},"tuk":{"official":"Owganystan Yslam Respublikasy","common":"Owganystan"}}},"tld":[".af"],"cca2":"AF","ccn3":"004","cca3":"AFG","cioc":"AFG","independent":true,"status":"officially-assigned","currencies":{"AFN":{"name":"Afghan afghani","symbol":"؋"}},"idd":{"root":"+9","suffixes":["3"]},"capital":["Kabul"],"altSpellings":["AF","Afġānistān"],"region":"Asia","subregion":"Southern Asia","languages":{"prs":"Dari","pus":"Pashto","tuk":"Turkmen"},"translations":{"ces":{"official":"Afghánská islámská republika","common":"Afghánistán"},"cym":{"official":"Gweriniaeth Islamaidd Affganistan","common":"Affganistan"},"deu":{"official":"Islamische Republik Afghanistan","common":"Afghanistan"},"fra":{"official":"République islamique d\'Afghanistan","common":"Afghanistan"},"hrv":{"official":"Islamska Republika Afganistan","common":"Afganistan"},"ita":{"official":"Repubblica islamica dell\'Afghanistan","common":"Afghanistan"},"jpn":{"official":"アフガニスタン·イスラム共和国","common":"アフガニスタン"},"nld":{"official":"Islamitische Republiek Afghanistan","common":"Afghanistan"},"por":{"official":"República Islâmica do Afeganistão","common":"Afeganistão"},"rus":{"official":"Исламская Республика Афганистан","common":"Афганистан"},"slk":{"official":"Afgánsky islamský štát","common":"Afganistan"},"spa":{"official":"República Islámica de Afganistán","common":"Afganistán"},"fin":{"official":"Afganistanin islamilainen tasavalta","common":"Afganistan"},"est":{"official":"Afganistani Islamivabariik","common":"Afganistan"},"zho":{"official":"阿富汗伊斯兰共和国","common":"阿富汗"},"pol":{"official":"Islamska Republika Afganistanu","common":"Afganistan"},"urd":{"official":"اسلامی جمہوریہ افغانستان","common":"افغانستان"},"kor":{"official":"아프가니스탄 이슬람 공화국","common":"아프가니스탄"},"per":{"official":"جمهوری اسلامی افغانستان","common":"افغانستان"}},"latlng":[33,65],"landlocked":true,"borders":["IRN","PAK","TKM","UZB","TJK","CHN"],"area":652230,"flag":"🇦🇫","demonyms":{"eng":{"f":"Afghan","m":"Afghan"},"fra":{"f":"Afghane","m":"Afghan"}}},{"name":{"common":"Angola","official":"Republic of Angola","native":{"por":{"official":"República de Angola","common":"Angola"}}},"tld":[".ao"],"cca2":"AO","ccn3":"024","cca3":"AGO","cioc":"ANG","independent":true,"status":"officially-assigned","currencies":{"AOA":{"name":"Angolan kwanza","symbol":"Kz"}},"idd":{"root":"+2","suffixes":["44"]},"capital":["Luanda"],"altSpellings":["AO","República de Angola","ʁɛpublika de an\'ɡɔla"],"region":"Africa","subregion":"Middle Africa","languages":{"por":"Portuguese"},"translations":{"ces":{"official":"Angolská republika","common":"Angola"},"cym":{"official":"Gweriniaeth Angola","common":"Angola"},"deu":{"official":"Republik Angola","common":"Angola"},"fra":{"official":"République d\'Angola","common":"Angola"},"hrv":{"official":"Republika Angola","common":"Angola"},"ita":{"official":"Repubblica dell\'Angola","common":"Angola"},"jpn":{"official":"アンゴラ共和国","common":"アンゴラ"},"nld":{"official":"Republiek Angola","common":"Angola"},"por":{"official":"República de Angola","common":"Angola"},"rus":{"official":"Республика Ангола","common":"Ангола"},"slk":{"official":"Angolská republika","common":"Angola"},"spa":{"official":"República de Angola","common":"Angola"},"fin":{"official":"Angolan tasavalta","common":"Angola"},"est":{"official":"Angola Vabariik","common":"Angola"},"zho":{"official":"安哥拉共和国","common":"安哥拉"},"pol":{"official":"Republika Angoli","common":"Angola"},"urd":{"official":"جمہوریہ انگولہ","common":"انگولہ"},"kor":{"official":"앙골라 공화국","common":"앙골라"},"per":{"official":"جمهوری آنگولا","common":"آنگولا"}},"latlng":[-12.5,18.5],"landlocked":false,"borders":["COG","COD","ZMB","NAM"],"area":1246700,"flag":"🇦🇴","demonyms":{"eng":{"f":"Angolan","m":"Angolan"},"fra":{"f":"Angolaise","m":"Angolais"}}},{"name":{"common":"Anguilla","official":"Anguilla","native":{"eng":{"official":"Anguilla","common":"Anguilla"}}},"tld":[".ai"],"cca2":"AI","ccn3":"660","cca3":"AIA","cioc":"","independent":false,"status":"officially-assigned","currencies":{"XCD":{"name":"Eastern Caribbean dollar","symbol":"$"}},"idd":{"root":"+1","suffixes":["264"]},"capital":["The Valley"],"altSpellings":["AI"],"region":"Americas","subregion":"Caribbean","languages":{"eng":"English"},"translations":{"ces":{"official":"Anguilla","common":"Anguilla"},"deu":{"official":"Anguilla","common":"Anguilla"},"fra":{"official":"Anguilla","common":"Anguilla"},"hrv":{"official":"Anguilla","common":"Angvila"},"ita":{"official":"Anguilla","common":"Anguilla"},"jpn":{"official":"アングィラ","common":"アンギラ"},"nld":{"official":"Anguilla","common":"Anguilla"},"por":{"official":"Anguilla","common":"Anguilla"},"rus":{"official":"Ангилья","common":"Ангилья"},"slk":{"official":"Anguilla","common":"Anguilla"},"spa":{"official":"Anguila","common":"Anguilla"},"fin":{"official":"Anguilla","common":"Anguilla"},"est":{"official":"Anguilla","common":"Anguilla"},"zho":{"official":"安圭拉","common":"安圭拉"},"pol":{"official":"Anguilla","common":"Anguilla"},"urd":{"official":"اینگویلا","common":"اینگویلا"},"kor":{"official":"앵귈라","common":"앵귈라"},"per":{"official":"آنگویلا","common":"آنگویلا"}},"latlng":[18.25,-63.16666666],"landlocked":false,"borders":[],"area":91,"flag":"🇦🇮","demonyms":{"eng":{"f":"Anguillian","m":"Anguillian"},"fra":{"f":"Anguillane","m":"Anguillan"}}},{"name":{"common":"Åland Islands","official":"Åland Islands","native":{"swe":{"official":"Landskapet Åland","common":"Åland"}}},"tld":[".ax"],"cca2":"AX","ccn3":"248","cca3":"ALA","cioc":"","independent":false,"status":"officially-assigned","currencies":{"EUR":{"name":"Euro","symbol":"€"}},"idd":{"root":"+3","suffixes":["5818"]},"capital":["Mariehamn"],"altSpellings":["AX","Aaland","Aland","Ahvenanmaa"],"region":"Europe","subregion":"Northern Europe","languages":{"swe":"Swedish"},"translations":{"ces":{"official":"Ålandské ostrovy","common":"Ålandy"},"deu":{"official":"Åland-Inseln","common":"Åland"},"fra":{"official":"Ahvenanmaa","common":"Ahvenanmaa"},"hrv":{"official":"Aland Islands","common":"Ålandski otoci"},"ita":{"official":"Isole Åland","common":"Isole Aland"},"jpn":{"official":"オーランド諸島","common":"オーランド諸島"},"nld":{"official":"Åland eilanden","common":"Ålandeilanden"},"por":{"official":"Ilhas Åland","common":"Alândia"},"rus":{"official":"Аландские острова","common":"Аландские острова"},"slk":{"official":"Alandské ostrovy","common":"Alandy"},"spa":{"official":"Islas Åland","common":"Alandia"},"fin":{"official":"Ahvenanmaan maakunta","common":"Ahvenanmaa"},"est":{"official":"Ahvenamaa maakond","common":"Ahvenamaa"},"zho":{"official":"奥兰群岛","common":"奥兰群岛"},"pol":{"official":"Wyspy Alandzkie","common":"Wyspy Alandzkie"},"urd":{"official":"جزائر اولند","common":"جزائر اولند"},"kor":{"official":"올란드 제도","common":"올란드 제도"},"per":{"official":"جزایر الند","common":"جزایر الند"}},"latlng":[60.116667,19.9],"landlocked":false,"borders":[],"area":1580,"flag":"🇦🇽","demonyms":{"eng":{"f":"Ålandish","m":"Ålandish"},"fra":{"f":"Ålandaise","m":"Ålandais"}}},{"name":{"common":"Albania","official":"Republic of Albania","native":{"sqi":{"official":"Republika e Shqipërisë","common":"Shqipëria"}}},"tld":[".al"],"cca2":"AL","ccn3":"008","cca3":"ALB","cioc":"ALB","independent":true,"status":"officially-assigned","currencies":{"ALL":{"name":"Albanian lek","symbol":"L"}},"idd":{"root":"+3","suffixes":["55"]},"capital":["Tirana"],"altSpellings":["AL","Shqipëri","Shqipëria","Shqipnia"],"region":"Europe","subregion":"Southern Europe","languages":{"sqi":"Albanian"},"translations":{"ces":{"official":"Albánská republika","common":"Albánie"},"cym":{"official":"Gweriniaeth Albania","common":"Albania"},"deu":{"official":"Republik Albanien","common":"Albanien"},"fra":{"official":"République d\'Albanie","common":"Albanie"},"hrv":{"official":"Republika Albanija","common":"Albanija"},"ita":{"official":"Repubblica d\'Albania","common":"Albania"},"jpn":{"official":"アルバニア共和国","common":"アルバニア"},"nld":{"official":"Republiek Albanië","common":"Albanië"},"por":{"official":"República da Albânia","common":"Albânia"},"rus":{"official":"Республика Албания","common":"Албания"},"slk":{"official":"Albánska republika","common":"Albánsko"},"spa":{"official":"República de Albania","common":"Albania"},"fin":{"official":"Albanian tasavalta","common":"Albania"},"est":{"official":"Albaania Vabariik","common":"Albaania"},"zho":{"official":"阿尔巴尼亚共和国","common":"阿尔巴尼亚"},"pol":{"official":"Republika Albanii","common":"Albania"},"urd":{"official":"جمہوریہ البانیا","common":"البانیا"},"kor":{"official":"알바니아 공화국","common":"알바니아"},"per":{"official":"جمهوری آلبانی","common":"آلبانی"}},"latlng":[41,20],"landlocked":false,"borders":["MNE","GRC","MKD","UNK"],"area":28748,"flag":"🇦🇱","demonyms":{"eng":{"f":"Albanian","m":"Albanian"},"fra":{"f":"Albanaise","m":"Albanais"}}},{"name":{"common":"Andorra","official":"Principality of Andorra","native":{"cat":{"official":"Principat d\'Andorra","common":"Andorra"}}},"tld":[".ad"],"cca2":"AD","ccn3":"020","cca3":"AND","cioc":"AND","independent":true,"status":"officially-assigned","currencies":{"EUR":{"name":"Euro","symbol":"€"}},"idd":{"root":"+3","suffixes":["76"]},"capital":["Andorra la Vella"],"altSpellings":["AD","Principality of Andorra","Principat d\'Andorra"],"region":"Europe","subregion":"Southern Europe","languages":{"cat":"Catalan"},"translations":{"ces":{"official":"Andorrské knížectví","common":"Andorra"},"cym":{"official":"Tywysogaeth Andorra","common":"Andorra"},"deu":{"official":"Fürstentum Andorra","common":"Andorra"},"fra":{"official":"Principauté d\'Andorre","common":"Andorre"},"hrv":{"official":"Kneževina Andora","common":"Andora"},"ita":{"official":"Principato di Andorra","common":"Andorra"},"jpn":{"official":"アンドラ公国","common":"アンドラ"},"nld":{"official":"Prinsdom Andorra","common":"Andorra"},"por":{"official":"Principado de Andorra","common":"Andorra"},"rus":{"official":"Княжество Андорра","common":"Андорра"},"slk":{"official":"Andorrské kniežatstvo","common":"Andorra"},"spa":{"official":"Principado de Andorra","common":"Andorra"},"fin":{"official":"Andorran ruhtinaskunta","common":"Andorra"},"est":{"official":"Andorra Vürstiriik","common":"Andorra"},"zho":{"official":"安道尔公国","common":"安道尔"},"pol":{"official":"Księstwo Andory","common":"Andora"},"urd":{"official":"اماراتِ انڈورا","common":"انڈورا"},"kor":{"official":"안도라 공국","common":"안도라"},"per":{"official":"شاهزاده‌نشین آندورا","common":"آندورا"}},"latlng":[42.5,1.5],"landlocked":true,"borders":["FRA","ESP"],"area":468,"flag":"🇦🇩","demonyms":{"eng":{"f":"Andorran","m":"Andorran"},"fra":{"f":"Andorrane","m":"Andorran"}}},{"name":{"common":"United Arab Emirates","official":"United Arab Emirates","native":{"ara":{"official":"الإمارات العربية المتحدة","common":"دولة الإمارات العربية المتحدة"}}},"tld":[".ae","امارات."],"cca2":"AE","ccn3":"784","cca3":"ARE","cioc":"UAE","independent":true,"status":"officially-assigned","currencies":{"AED":{"name":"United Arab Emirates dirham","symbol":"د.إ"}},"idd":{"root":"+9","suffixes":["71"]},"capital":["Abu Dhabi"],"altSpellings":["AE","UAE","Emirates"],"region":"Asia","subregion":"Western Asia","languages":{"ara":"Arabic"},"translations":{"ces":{"official":"Spojené arabské emiráty","common":"Spojené arabské emiráty"},"deu":{"official":"Vereinigte Arabische Emirate","common":"Vereinigte Arabische Emirate"},"fra":{"official":"Émirats arabes unis","common":"Émirats arabes unis"},"hrv":{"official":"Ujedinjeni Arapski Emirati","common":"Ujedinjeni Arapski Emirati"},"ita":{"official":"Emirati Arabi Uniti","common":"Emirati Arabi Uniti"},"jpn":{"official":"アラブ首長国連邦","common":"アラブ首長国連邦"},"nld":{"official":"Verenigde Arabische Emiraten","common":"Verenigde Arabische Emiraten"},"por":{"official":"Emirados Árabes Unidos","common":"Emirados Árabes Unidos"},"rus":{"official":"Объединенные Арабские Эмираты","common":"Объединённые Арабские Эмираты"},"slk":{"official":"Spojené arabské emiráty","common":"Spojené arabské emiráty"},"spa":{"official":"Emiratos Árabes Unidos","common":"Emiratos Árabes Unidos"},"fin":{"official":"Yhdistyneet arabiemiirikunnat","common":"Arabiemiraatit"},"est":{"official":"Araabia Ühendemiraadid","common":"Araabia Ühendemiraadid"},"zho":{"official":"阿拉伯联合酋长国","common":"阿拉伯联合酋长国"},"pol":{"official":"Zjednoczone Emiraty Arabskie","common":"Zjednoczone Emiraty Arabskie"},"urd":{"official":"متحدہ عرب امارات","common":"متحدہ عرب امارات"},"kor":{"official":"아랍 토후국 연방","common":"아랍에미리트"},"per":{"official":"امارات متحده عربی","common":"امارات"}},"latlng":[24,54],"landlocked":false,"borders":["OMN","SAU"],"area":83600,"flag":"🇦🇪","demonyms":{"eng":{"f":"Emirati","m":"Emirati"},"fra":{"f":"Emirienne","m":"Emirien"}}},{"name":{"common":"Argentina","official":"Argentine Republic","native":{"grn":{"official":"Argentine Republic","common":"Argentina"},"spa":{"official":"República Argentina","common":"Argentina"}}},"tld":[".ar"],"cca2":"AR","ccn3":"032","cca3":"ARG","cioc":"ARG","independent":true,"status":"officially-assigned","currencies":{"ARS":{"name":"Argentine peso","symbol":"$"}},"idd":{"root":"+5","suffixes":["4"]},"capital":["Buenos Aires"],"altSpellings":["AR","Argentine Republic","República Argentina"],"region":"Americas","subregion":"South America","languages":{"grn":"Guaraní","spa":"Spanish"},"translations":{"ces":{"official":"Argentinská republika","common":"Argentina"},"cym":{"official":"Gweriniaeth yr Ariannin","common":"Ariannin"},"deu":{"official":"Argentinische Republik","common":"Argentinien"},"fra":{"official":"République argentine","common":"Argentine"},"hrv":{"official":"Argentinski Republika","common":"Argentina"},"ita":{"official":"Repubblica Argentina","common":"Argentina"},"jpn":{"official":"アルゼンチン共和国","common":"アルゼンチン"},"nld":{"official":"Argentijnse Republiek","common":"Argentinië"},"por":{"official":"República Argentina","common":"Argentina"},"rus":{"official":"Аргентинская Республика","common":"Аргентина"},"slk":{"official":"Argentínska republika","common":"Argentína"},"spa":{"official":"República Argentina","common":"Argentina"},"fin":{"official":"Argentiinan tasavalta","common":"Argentiina"},"est":{"official":"Argentina Vabariik","common":"Argentina"},"zho":{"official":"阿根廷共和国","common":"阿根廷"},"pol":{"official":"Republika Argentyńska","common":"Argentyna"},"urd":{"official":"جمہوریہ ارجنٹائن","common":"ارجنٹائن"},"kor":{"official":"아르헨티나 공화국","common":"아르헨티나"},"per":{"official":"جمهوری آرژانتین","common":"آرژانتین"}},"latlng":[-34,-64],"landlocked":false,"borders":["BOL","BRA","CHL","PRY","URY"],"area":2780400,"flag":"🇦🇷","demonyms":{"eng":{"f":"Argentine","m":"Argentine"},"fra":{"f":"Argentine","m":"Argentin"}}},{"name":{"common":"Armenia","official":"Republic of Armenia","native":{"hye":{"official":"Հայաստանի Հանրապետություն","common":"Հայաստան"}}},"tld":[".am"],"cca2":"AM","ccn3":"051","cca3":"ARM","cioc":"ARM","independent":true,"status":"officially-assigned","currencies":{"AMD":{"name":"Armenian dram","symbol":"֏"}},"idd":{"root":"+3","suffixes":["74"]},"capital":["Yerevan"],"altSpellings":["AM","Hayastan","Republic of Armenia","Հայաստանի Հանրապետություն"],"region":"Asia","subregion":"Western Asia","languages":{"hye":"Armenian"},"translations":{"ces":{"official":"Arménská republika","common":"Arménie"},"cym":{"official":"Gweriniaeth Armenia","common":"Armenia"},"deu":{"official":"Republik Armenien","common":"Armenien"},"fra":{"official":"République d\'Arménie","common":"Arménie"},"hrv":{"official":"Republika Armenija","common":"Armenija"},"ita":{"official":"Repubblica di Armenia","common":"Armenia"},"jpn":{"official":"アルメニア共和国","common":"アルメニア"},"nld":{"official":"Republiek Armenië","common":"Armenië"},"por":{"official":"República da Arménia","common":"Arménia"},"rus":{"official":"Республика Армения","common":"Армения"},"slk":{"official":"Arménska republika","common":"Arménsko"},"spa":{"official":"República de Armenia","common":"Armenia"},"fin":{"official":"Armenian tasavalta","common":"Armenia"},"est":{"official":"Armeenia Vabariik","common":"Armeenia"},"zho":{"official":"亚美尼亚共和国","common":"亚美尼亚"},"pol":{"official":"Republika Armenii","common":"Armenia"},"urd":{"official":"جمہوریہ آرمینیا","common":"آرمینیا"},"kor":{"official":"아르메니아 공화국","common":"아르메니아"},"per":{"official":"جمهوری ارمنستان","common":"ارمنستان"}},"latlng":[40,45],"landlocked":true,"borders":["AZE","GEO","IRN","TUR"],"area":29743,"flag":"🇦🇲","demonyms":{"eng":{"f":"Armenian","m":"Armenian"},"fra":{"f":"Arménienne","m":"Arménien"}}},{"name":{"common":"American Samoa","official":"American Samoa","native":{"eng":{"official":"American Samoa","common":"American Samoa"},"smo":{"official":"Sāmoa Amelika","common":"Sāmoa Amelika"}}},"tld":[".as"],"cca2":"AS","ccn3":"016","cca3":"ASM","cioc":"ASA","independent":false,"status":"officially-assigned","currencies":{"USD":{"name":"United States dollar","symbol":"$"}},"idd":{"root":"+1","suffixes":["684"]},"capital":["Pago Pago"],"altSpellings":["AS","Amerika Sāmoa","Amelika Sāmoa","Sāmoa Amelika"],"region":"Oceania","subregion":"Polynesia","languages":{"eng":"English","smo":"Samoan"},"translations":{"ces":{"official":"Americká Samoa","common":"Americká Samoa"},"deu":{"official":"Amerikanisch-Samoa","common":"Amerikanisch-Samoa"},"fra":{"official":"Samoa américaines","common":"Samoa américaines"},"hrv":{"official":"američka Samoa","common":"Američka Samoa"},"ita":{"official":"Samoa americane","common":"Samoa Americane"},"jpn":{"official":"米サモア","common":"アメリカ領サモア"},"nld":{"official":"Amerikaans Samoa","common":"Amerikaans Samoa"},"por":{"official":"Samoa americana","common":"Samoa Americana"},"rus":{"official":"американское Самоа","common":"Американское Самоа"},"slk":{"official":"Americká Samoa","common":"Americká Samoa"},"spa":{"official":"Samoa Americana","common":"Samoa Americana"},"fin":{"official":"Amerikan Samoa","common":"Amerikan Samoa"},"est":{"official":"Ameerika Samoa","common":"Ameerika Samoa"},"zho":{"official":"美属萨摩亚","common":"美属萨摩亚"},"pol":{"official":"Samoa Amerykańskie","common":"Samoa Amerykańskie"},"urd":{"official":"امریکی سمووا","common":"امریکی سمووا"},"kor":{"official":"아메리칸사모아","common":"아메리칸사모아"},"per":{"official":"ساموآی آمریکا","common":"ساموآی آمریکا"}},"latlng":[-14.33333333,-170],"landlocked":false,"borders":[],"area":199,"flag":"🇦🇸","demonyms":{"eng":{"f":"American Samoan","m":"American Samoan"},"fra":{"f":"Samoane","m":"Samoan"}}},{"name":{"common":"Antarctica","official":"Antarctica","native":{}},"tld":[".aq"],"cca2":"AQ","ccn3":"010","cca3":"ATA","cioc":"","independent":false,"status":"officially-assigned","currencies":[],"idd":{"root":"","suffixes":[]},"capital":[""],"altSpellings":["AQ"],"region":"Antarctic","subregion":"","languages":{},"translations":{"ces":{"official":"Antarktida","common":"Antarktida"},"cym":{"official":"Yr Antarctig","common":"Yr Antarctig"},"deu":{"official":"Antarktika","common":"Antarktis"},"fra":{"official":"Antarctique","common":"Antarctique"},"hrv":{"official":"Antarktika","common":"Antarktika"},"ita":{"official":"Antartide","common":"Antartide"},"jpn":{"official":"南極大陸","common":"南極"},"nld":{"official":"Antarctica","common":"Antarctica"},"por":{"official":"Antártica","common":"Antártida"},"rus":{"official":"Антарктида","common":"Антарктида"},"slk":{"official":"Antarktída","common":"Antarktída"},"spa":{"official":"Antártida","common":"Antártida"},"fin":{"official":"Etelämanner","common":"Etelämanner"},"est":{"official":"Antarktika","common":"Antarktika"},"zho":{"official":"南极洲","common":"南极洲"},"pol":{"official":"Antarktyka","common":"Antarktyka"},"urd":{"official":"انٹارکٹکا","common":"انٹارکٹکا"},"kor":{"official":"남극","common":"남극"},"per":{"official":"جنوبگان","common":"جنوبگان"}},"latlng":[-90,0],"landlocked":false,"borders":[],"area":14000000,"flag":"🇦🇶","demonyms":{"eng":{"f":"Antarctican","m":"Antarctican"},"fra":{"f":"Antarcticaine","m":"Antarcticain"}}},{"name":{"common":"French Southern and Antarctic Lands","official":"Territory of the French Southern and Antarctic Lands","native":{"fra":{"official":"Territoire des Terres australes et antarctiques françaises","common":"Terres australes et antarctiques françaises"}}},"tld":[".tf"],"cca2":"TF","ccn3":"260","cca3":"ATF","cioc":"","independent":false,"status":"officially-assigned","currencies":{"EUR":{"name":"Euro","symbol":"€"}},"idd":{"root":"+2","suffixes":["62"]},"capital":["Port-aux-Français"],"altSpellings":["TF","French Southern Territories"],"region":"Antarctic","subregion":"","languages":{"fra":"French"},"translations":{"ces":{"official":"Teritorium Francouzská jižní a antarktická území","common":"Francouzská jižní a antarktická území"},"deu":{"official":"Gebiet der Französisch Süd- und Antarktisgebiete","common":"Französische Süd- und Antarktisgebiete"},"fra":{"official":"Territoire des Terres australes et antarctiques françaises","common":"Terres australes et antarctiques françaises"},"hrv":{"official":"Teritoriju Francuski južni i antarktički teritoriji","common":"Francuski južni i antarktički teritoriji"},"ita":{"official":"Territorio della australi e antartiche francesi Terre","common":"Territori Francesi del Sud"},"jpn":{"official":"フランス領南方·南極地域の領土","common":"フランス領南方・南極地域"},"nld":{"official":"Grondgebied van de Franse Zuidelijke en Antarctische gebieden","common":"Franse Gebieden in de zuidelijke Indische Oceaan"},"por":{"official":"Território do Sul e Antártica Francesa","common":"Terras Austrais e Antárticas Francesas"},"rus":{"official":"Территория Французские Южные и Антарктические земли","common":"Французские Южные и Антарктические территории"},"slk":{"official":"Francúzske južné a antarktické územia","common":"Francúzske juŽné a antarktické územia"},"spa":{"official":"Territorio del Francés Tierras australes y antárticas","common":"Tierras Australes y Antárticas Francesas"},"fin":{"official":"Ranskan eteläiset ja antarktiset alueet","common":"Ranskan eteläiset ja antarktiset alueet"},"est":{"official":"Prantsuse Lõunaalad","common":"Prantsuse Lõunaalad"},"zho":{"official":"法国南部和南极土地","common":"法国南部和南极土地"},"pol":{"official":"Francuskie Terytoria Południowe i Antarktyczne","common":"Francuskie Terytoria Południowe i Antarktyczne"},"urd":{"official":"سرزمینِ جنوبی فرانسیسیہ و انٹارکٹیکہ","common":"سرزمین جنوبی فرانسیسیہ و انٹارکٹیکا"},"kor":{"official":"프랑스령 남부와 남극 지역","common":"프랑스령 남부와 남극 지역"},"per":{"official":"سرزمین‌های جنوبی و جنوبگانی فرانسه","common":"سرزمین‌های جنوبی و جنوبگانی فرانسه"}},"latlng":[-49.25,69.167],"landlocked":false,"borders":[],"area":7747,"flag":"🇹🇫","demonyms":{"eng":{"f":"French","m":"French"},"fra":{"f":"Française","m":"Français"}}},{"name":{"common":"Antigua and Barbuda","official":"Antigua and Barbuda","native":{"eng":{"official":"Antigua and Barbuda","common":"Antigua and Barbuda"}}},"tld":[".ag"],"cca2":"AG","ccn3":"028","cca3":"ATG","cioc":"ANT","independent":true,"status":"officially-assigned","currencies":{"XCD":{"name":"Eastern Caribbean dollar","symbol":"$"}},"idd":{"root":"+1","suffixes":["268"]},"capital":["Saint John\'s"],"altSpellings":["AG"],"region":"Americas","subregion":"Caribbean","languages":{"eng":"English"},"translations":{"ces":{"official":"Antigua a Barbuda","common":"Antigua a Barbuda"},"cym":{"official":"Antigwa a Barbiwda","common":"Antigwa a Barbiwda"},"deu":{"official":"Antigua und Barbuda","common":"Antigua und Barbuda"},"fra":{"official":"Antigua -et-Barbuda","common":"Antigua-et-Barbuda"},"hrv":{"official":"Antigva i Barbuda","common":"Antigva i Barbuda"},"ita":{"official":"Antigua e Barbuda","common":"Antigua e Barbuda"},"jpn":{"official":"アンチグアバーブーダ","common":"アンティグア・バーブーダ"},"nld":{"official":"Antigua en Barbuda","common":"Antigua en Barbuda"},"por":{"official":"Antigua e Barbuda","common":"Antígua e Barbuda"},"rus":{"official":"Антигуа и Барбуда","common":"Антигуа и Барбуда"},"slk":{"official":"Antigua a Barbuda","common":"Antigua a Barbuda"},"spa":{"official":"Antigua y Barbuda","common":"Antigua y Barbuda"},"fin":{"official":"Antigua ja Barbuda","common":"Antigua ja Barbuda"},"est":{"official":"Antigua ja Barbuda","common":"Antigua ja Barbuda"},"zho":{"official":"安提瓜和巴布达","common":"安提瓜和巴布达"},"pol":{"official":"Antigua i Barbuda","common":"Antigua i Barbuda"},"urd":{"official":"اینٹیگوا و باربوڈا","common":"اینٹیگوا و باربوڈا"},"kor":{"official":"앤티가 바부다","common":"앤티가 바부다"},"per":{"official":"آنتیگوا و باربودا","common":"آنتیگوا و باربودا"}},"latlng":[17.05,-61.8],"landlocked":false,"borders":[],"area":442,"flag":"🇦🇬","demonyms":{"eng":{"f":"Antiguan, Barbudan","m":"Antiguan, Barbudan"},"fra":{"f":"Antiguaise et barbudienne","m":"Antiguaise et barbudien"}}},{"name":{"common":"Australia","official":"Commonwealth of Australia","native":{"eng":{"official":"Commonwealth of Australia","common":"Australia"}}},"tld":[".au"],"cca2":"AU","ccn3":"036","cca3":"AUS","cioc":"AUS","independent":true,"status":"officially-assigned","currencies":{"AUD":{"name":"Australian dollar","symbol":"$"}},"idd":{"root":"+6","suffixes":["1"]},"capital":["Canberra"],"altSpellings":["AU"],"region":"Oceania","subregion":"Australia and New Zealand","languages":{"eng":"English"},"translations":{"ces":{"official":"Australské společenství","common":"Austrálie"},"cym":{"official":"Cymanwlad Awstralia","common":"Awstralia"},"deu":{"official":"Commonwealth Australien","common":"Australien"},"fra":{"official":"Australie","common":"Australie"},"hrv":{"official":"Commonwealth of Australia","common":"Australija"},"ita":{"official":"Commonwealth dell\'Australia","common":"Australia"},"jpn":{"official":"オーストラリア連邦","common":"オーストラリア"},"nld":{"official":"Gemenebest van Australië","common":"Australië"},"por":{"official":"Comunidade da Austrália","common":"Austrália"},"rus":{"official":"Содружество Австралии","common":"Австралия"},"slk":{"official":"Austrálsky zväz","common":"Austrália"},"spa":{"official":"Mancomunidad de Australia","common":"Australia"},"fin":{"official":"Australian liittovaltio","common":"Australia"},"est":{"official":"Austraalia Ühendus","common":"Austraalia"},"zho":{"official":"澳大利亚联邦","common":"澳大利亚"},"pol":{"official":"Związek Australijski","common":"Australia"},"urd":{"official":"دولتِ مشترکہ آسٹریلیا","common":"آسٹریلیا"},"kor":{"official":"오스트레일리아 연방","common":"호주"},"per":{"official":"قلمرو همسود استرالیا","common":"استرالیا"}},"latlng":[-27,133],"landlocked":false,"borders":[],"area":7692024,"flag":"🇦🇺","demonyms":{"eng":{"f":"Australian","m":"Australian"},"fra":{"f":"Australienne","m":"Australien"}}},{"name":{"common":"Austria","official":"Republic of Austria","native":{"bar":{"official":"Republik Österreich","common":"Österreich"}}},"tld":[".at"],"cca2":"AT","ccn3":"040","cca3":"AUT","cioc":"AUT","independent":true,"status":"officially-assigned","currencies":{"EUR":{"name":"Euro","symbol":"€"}},"idd":{"root":"+4","suffixes":["3"]},"capital":["Vienna"],"altSpellings":["AT","Osterreich","Oesterreich"],"region":"Europe","subregion":"Western Europe","languages":{"bar":"Austro-Bavarian German"},"translations":{"ces":{"official":"Rakouská republika","common":"Rakousko"},"cym":{"official":"Gweriniaeth Awstria","common":"Awstria"},"deu":{"official":"Republik Österreich","common":"Österreich"},"fra":{"official":"République d\'Autriche","common":"Autriche"},"hrv":{"official":"Republika Austrija","common":"Austrija"},"ita":{"official":"Repubblica d\'Austria","common":"Austria"},"jpn":{"official":"オーストリア共和国","common":"オーストリア"},"nld":{"official":"Republiek Oostenrijk","common":"Oostenrijk"},"por":{"official":"República da Áustria","common":"Áustria"},"rus":{"official":"Австрийская Республика","common":"Австрия"},"slk":{"official":"Rakúska republika","common":"Rakúsko"},"spa":{"official":"República de Austria","common":"Austria"},"fin":{"official":"Itävallan tasavalta","common":"Itävalta"},"est":{"official":"Austria Vabariik","common":"Austria"},"zho":{"official":"奥地利共和国","common":"奥地利"},"pol":{"official":"Republika Austrii","common":"Austria"},"urd":{"official":"جمہوریہ آسٹریا","common":"آسٹریا"},"kor":{"official":"오스트리아 공화국","common":"오스트리아"},"per":{"official":"جمهوری اتریش","common":"اتریش"}},"latlng":[47.33333333,13.33333333],"landlocked":true,"borders":["CZE","DEU","HUN","ITA","LIE","SVK","SVN","CHE"],"area":83871,"flag":"🇦🇹","demonyms":{"eng":{"f":"Austrian","m":"Austrian"},"fra":{"f":"Autrichienne","m":"Autrichien"}}},{"name":{"common":"Azerbaijan","official":"Republic of Azerbaijan","native":{"aze":{"official":"Azərbaycan Respublikası","common":"Azərbaycan"},"rus":{"official":"Азербайджанская Республика","common":"Азербайджан"}}},"tld":[".az"],"cca2":"AZ","ccn3":"031","cca3":"AZE","cioc":"AZE","independent":true,"status":"officially-assigned","currencies":{"AZN":{"name":"Azerbaijani manat","symbol":"₼"}},"idd":{"root":"+9","suffixes":["94"]},"capital":["Baku"],"altSpellings":["AZ","Republic of Azerbaijan","Azərbaycan Respublikası"],"region":"Asia","subregion":"Western Asia","languages":{"aze":"Azerbaijani","rus":"Russian"},"translations":{"ces":{"official":"Ázerbájdžánská republika","common":"Ázerbájdžán"},"cym":{"official":"Gweriniaeth Aserbaijan","common":"Aserbaijan"},"deu":{"official":"Republik Aserbaidschan","common":"Aserbaidschan"},"fra":{"official":"République d\'Azerbaïdjan","common":"Azerbaïdjan"},"hrv":{"official":"Republika Azerbajdžan","common":"Azerbajdžan"},"ita":{"official":"Repubblica dell\'Azerbaigian","common":"Azerbaijan"},"jpn":{"official":"アゼルバイジャン共和国","common":"アゼルバイジャン"},"nld":{"official":"Republiek Azerbeidzjan","common":"Azerbeidzjan"},"por":{"official":"República do Azerbaijão","common":"Azerbeijão"},"rus":{"official":"Азербайджанская Республика","common":"Азербайджан"},"slk":{"official":"Azerbajǆanská republika","common":"AzerbajǇan"},"spa":{"official":"República de Azerbaiyán","common":"Azerbaiyán"},"fin":{"official":"Azerbaidzanin tasavalta","common":"Azerbaidzan"},"est":{"official":"Aserbaidžaani Vabariik","common":"Aserbaidžaan"},"zho":{"official":"阿塞拜疆共和国","common":"阿塞拜疆"},"pol":{"official":"Republika Azerbejdżanu","common":"Azerbejdżan"},"urd":{"official":"جمہوریہ آذربائیجان","common":"آذربائیجان"},"kor":{"official":"아제르바이잔 공화국","common":"아제르바이잔"},"per":{"official":"جمهوری آذربایجان","common":"جمهوری آذربایجان"}},"latlng":[40.5,47.5],"landlocked":true,"borders":["ARM","GEO","IRN","RUS","TUR"],"area":86600,"flag":"🇦🇿","demonyms":{"eng":{"f":"Azerbaijani","m":"Azerbaijani"},"fra":{"f":"Azerbaïdjanaise","m":"Azerbaïdjanais"}}},{"name":{"common":"Burundi","official":"Republic of Burundi","native":{"fra":{"official":"République du Burundi","common":"Burundi"},"run":{"official":"Republika y\'Uburundi ","common":"Uburundi"}}},"tld":[".bi"],"cca2":"BI","ccn3":"108","cca3":"BDI","cioc":"BDI","independent":true,"status":"officially-assigned","currencies":{"BIF":{"name":"Burundian franc","symbol":"Fr"}},"idd":{"root":"+2","suffixes":["57"]},"capital":["Bujumbura"],"altSpellings":["BI","Republic of Burundi","Republika y\'Uburundi","République du Burundi"],"region":"Africa","subregion":"Eastern Africa","languages":{"fra":"French","run":"Kirundi"},"translations":{"ces":{"official":"Burundská republika","common":"Burundi"},"cym":{"official":"Gweriniaeth Bwrwndi","common":"Bwrwndi"},"deu":{"official":"Republik Burundi","common":"Burundi"},"fra":{"official":"République du Burundi","common":"Burundi"},"hrv":{"official":"Burundi","common":"Burundi"},"ita":{"official":"Repubblica del Burundi","common":"Burundi"},"jpn":{"official":"ブルンジ共和国","common":"ブルンジ"},"nld":{"official":"Republiek Burundi","common":"Burundi"},"por":{"official":"República do Burundi","common":"Burundi"},"rus":{"official":"Республика Бурунди","common":"Бурунди"},"slk":{"official":"Burundská republika","common":"Burundi"},"spa":{"official":"República de Burundi","common":"Burundi"},"fin":{"official":"Burundin tasavalta","common":"Burundi"},"est":{"official":"Burundi Vabariik","common":"Burundi"},"zho":{"official":"布隆迪共和国","common":"布隆迪"},"pol":{"official":"Republika Burundi","common":"Burundi"},"urd":{"official":"جمہوریہ برونڈی","common":"برونڈی"},"kor":{"official":"부룬디","common":"부룬디"},"per":{"official":"جمهوری بوروندی","common":"بوروندی"}},"latlng":[-3.5,30],"landlocked":true,"borders":["COD","RWA","TZA"],"area":27834,"flag":"🇧🇮","demonyms":{"eng":{"f":"Burundian","m":"Burundian"},"fra":{"f":"Burundaise","m":"Burundais"}}},{"name":{"common":"Belgium","official":"Kingdom of Belgium","native":{"deu":{"official":"Königreich Belgien","common":"Belgien"},"fra":{"official":"Royaume de Belgique","common":"Belgique"},"nld":{"official":"Koninkrijk België","common":"België"}}},"tld":[".be"],"cca2":"BE","ccn3":"056","cca3":"BEL","cioc":"BEL","independent":true,"status":"officially-assigned","currencies":{"EUR":{"name":"Euro","symbol":"€"}},"idd":{"root":"+3","suffixes":["2"]},"capital":["Brussels"],"altSpellings":["BE","België","Belgie","Belgien","Belgique","Kingdom of Belgium","Koninkrijk België","Royaume de Belgique","Königreich Belgien"],"region":"Europe","subregion":"Western Europe","languages":{"deu":"German","fra":"French","nld":"Dutch"},"translations":{"ces":{"official":"Belgické království","common":"Belgie"},"cym":{"official":"Teyrnas Gwlad Belg","common":"Gwlad Belg"},"deu":{"official":"Königreich Belgien","common":"Belgien"},"fra":{"official":"Royaume de Belgique","common":"Belgique"},"hrv":{"official":"Kraljevina Belgija","common":"Belgija"},"ita":{"official":"Regno del Belgio","common":"Belgio"},"jpn":{"official":"ベルギー王国","common":"ベルギー"},"nld":{"official":"Koninkrijk België","common":"België"},"por":{"official":"Reino da Bélgica","common":"Bélgica"},"rus":{"official":"Королевство Бельгия","common":"Бельгия"},"slk":{"official":"Belgické kráľovstvo","common":"Belgicko"},"spa":{"official":"Reino de Bélgica","common":"Bélgica"},"fin":{"official":"Belgian kuningaskunta","common":"Belgia"},"est":{"official":"Belgia Kuningriik","common":"Belgia"},"zho":{"official":"比利时王国","common":"比利时"},"pol":{"official":"Królestwo Belgii","common":"Belgia"},"urd":{"official":"مملکتِ بلجئیم","common":"بلجئیم"},"kor":{"official":"벨기에 왕국","common":"벨기에"},"per":{"official":"پادشاهی بلژیک","common":"بلژیک"}},"latlng":[50.83333333,4],"landlocked":false,"borders":["FRA","DEU","LUX","NLD"],"area":30528,"flag":"🇧🇪","demonyms":{"eng":{"f":"Belgian","m":"Belgian"},"fra":{"f":"Belge","m":"Belge"}}},{"name":{"common":"Benin","official":"Republic of Benin","native":{"fra":{"official":"République du Bénin","common":"Bénin"}}},"tld":[".bj"],"cca2":"BJ","ccn3":"204","cca3":"BEN","cioc":"BEN","independent":true,"status":"officially-assigned","currencies":{"XOF":{"name":"West African CFA franc","symbol":"Fr"}},"idd":{"root":"+2","suffixes":["29"]},"capital":["Porto-Novo"],"altSpellings":["BJ","Republic of Benin","République du Bénin"],"region":"Africa","subregion":"Western Africa","languages":{"fra":"French"},"translations":{"ces":{"official":"Beninská republika","common":"Benin"},"cym":{"official":"Gweriniaeth Benin","common":"Benin"},"deu":{"official":"Republik Benin","common":"Benin"},"fra":{"official":"République du Bénin","common":"Bénin"},"hrv":{"official":"Republika Benin","common":"Benin"},"ita":{"official":"Repubblica del Benin","common":"Benin"},"jpn":{"official":"ベナン共和国","common":"ベナン"},"nld":{"official":"Republiek Benin","common":"Benin"},"por":{"official":"República do Benin","common":"Benin"},"rus":{"official":"Республика Бенин","common":"Бенин"},"slk":{"official":"Beninská republika","common":"Benin"},"spa":{"official":"República de Benin","common":"Benín"},"fin":{"official":"Beninin tasavalta","common":"Benin"},"est":{"official":"Benini Vabariik","common":"Benin"},"zho":{"official":"贝宁共和国","common":"贝宁"},"pol":{"official":"Benin","common":"Benin"},"urd":{"official":"جمہوریہ بینن","common":"بینن"},"kor":{"official":"베냉 공화국","common":"베냉"},"per":{"official":"جمهوری بنین","common":"بنین"}},"latlng":[9.5,2.25],"landlocked":false,"borders":["BFA","NER","NGA","TGO"],"area":112622,"flag":"🇧🇯","demonyms":{"eng":{"f":"Beninese","m":"Beninese"},"fra":{"f":"Béninoise","m":"Béninois"}}},{"name":{"common":"Burkina Faso","official":"Burkina Faso","native":{"fra":{"official":"République du Burkina","common":"Burkina Faso"}}},"tld":[".bf"],"cca2":"BF","ccn3":"854","cca3":"BFA","cioc":"BUR","independent":true,"status":"officially-assigned","currencies":{"XOF":{"name":"West African CFA franc","symbol":"Fr"}},"idd":{"root":"+2","suffixes":["26"]},"capital":["Ouagadougou"],"altSpellings":["BF"],"region":"Africa","subregion":"Western Africa","languages":{"fra":"French"},"translations":{"ces":{"official":"Burkina Faso","common":"Burkina Faso"},"cym":{"official":"Bwrcina Ffaso","common":"Bwrcina Ffaso"},"deu":{"official":"Burkina Faso","common":"Burkina Faso"},"fra":{"official":"République du Burkina","common":"Burkina Faso"},"hrv":{"official":"Burkina Faso","common":"Burkina Faso"},"ita":{"official":"Burkina Faso","common":"Burkina Faso"},"jpn":{"official":"ブルキナファソ","common":"ブルキナファソ"},"nld":{"official":"Burkina Faso","common":"Burkina Faso"},"por":{"official":"Burkina Faso","common":"Burkina Faso"},"rus":{"official":"Буркина -Фасо","common":"Буркина-Фасо"},"slk":{"official":"Burkina Faso","common":"Burkina Faso"},"spa":{"official":"Burkina Faso","common":"Burkina Faso"},"fin":{"official":"Burkina Faso","common":"Burkina Faso"},"est":{"official":"Burkina Faso","common":"Burkina Faso"},"zho":{"official":"布基纳法索","common":"布基纳法索"},"pol":{"official":"Burkina Faso","common":"Burkina Faso"},"urd":{"official":"برکینا فاسو","common":"برکینا فاسو"},"kor":{"official":"부르키나파소","common":"부르키나파소"},"per":{"official":"بورکینافاسو","common":"بورکینافاسو"}},"latlng":[13,-2],"landlocked":true,"borders":["BEN","CIV","GHA","MLI","NER","TGO"],"area":272967,"flag":"🇧🇫","demonyms":{"eng":{"f":"Burkinabe","m":"Burkinabe"},"fra":{"f":"Burkinabée","m":"Burkinabé"}}},{"name":{"common":"Bangladesh","official":"People\'s Republic of Bangladesh","native":{"ben":{"official":"বাংলাদেশ গণপ্রজাতন্ত্রী","common":"বাংলাদেশ"}}},"tld":[".bd"],"cca2":"BD","ccn3":"050","cca3":"BGD","cioc":"BAN","independent":true,"status":"officially-assigned","currencies":{"BDT":{"name":"Bangladeshi taka","symbol":"৳"}},"idd":{"root":"+8","suffixes":["80"]},"capital":["Dhaka"],"altSpellings":["BD","People\'s Republic of Bangladesh","Gônôprôjatôntri Bangladesh"],"region":"Asia","subregion":"Southern Asia","languages":{"ben":"Bengali"},"translations":{"ces":{"official":"Bangladéšská lidová republika","common":"Bangladéš"},"cym":{"official":"Gweriniaeth Pobl Bangladesh","common":"Bangladesh"},"deu":{"official":"Volksrepublik Bangladesch","common":"Bangladesch"},"fra":{"official":"La République populaire du Bangladesh","common":"Bangladesh"},"hrv":{"official":"Narodna Republika Bangladeš","common":"Bangladeš"},"ita":{"official":"Repubblica popolare del Bangladesh","common":"Bangladesh"},"jpn":{"official":"バングラデシュ人民共和国","common":"バングラデシュ"},"nld":{"official":"Volksrepubliek Bangladesh","common":"Bangladesh"},"por":{"official":"República Popular do Bangladesh","common":"Bangladesh"},"rus":{"official":"Народная Республика Бангладеш","common":"Бангладеш"},"slk":{"official":"Bangladéšska ľudová republika","common":"Bangladéš"},"spa":{"official":"República Popular de Bangladesh","common":"Bangladesh"},"fin":{"official":"Bangladeshin kansantasavalta","common":"Bangladesh"},"est":{"official":"Bangladeshi Rahvavabariik","common":"Bangladesh"},"zho":{"official":"孟加拉人民共和国","common":"孟加拉国"},"pol":{"official":"Ludowa Republika Bangladeszu","common":"Bangladesz"},"urd":{"official":"عوامی جمہوریہ بنگلہ دیش","common":"بنگلہ دیش"},"kor":{"official":"방글라데시 인민 공화국","common":"방글라데시"},"per":{"official":"جمهوری خلق بنگلادش","common":"بنگلادش"}},"latlng":[24,90],"landlocked":false,"borders":["MMR","IND"],"area":147570,"flag":"🇧🇩","demonyms":{"eng":{"f":"Bangladeshi","m":"Bangladeshi"},"fra":{"f":"Bangladaise","m":"Bangladais"}}},{"name":{"common":"Bulgaria","official":"Republic of Bulgaria","native":{"bul":{"official":"Република България","common":"България"}}},"tld":[".bg"],"cca2":"BG","ccn3":"100","cca3":"BGR","cioc":"BUL","independent":true,"status":"officially-assigned","currencies":{"BGN":{"name":"Bulgarian lev","symbol":"лв"}},"idd":{"root":"+3","suffixes":["59"]},"capital":["Sofia"],"altSpellings":["BG","Republic of Bulgaria","Република България"],"region":"Europe","subregion":"Eastern Europe","languages":{"bul":"Bulgarian"},"translations":{"ces":{"official":"Bulharská republika","common":"Bulharsko"},"cym":{"official":"Gweriniaeth Bwlgaria","common":"Bwlgaria"},"deu":{"official":"Republik Bulgarien","common":"Bulgarien"},"fra":{"official":"République de Bulgarie","common":"Bulgarie"},"hrv":{"official":"Republika Bugarska","common":"Bugarska"},"ita":{"official":"Repubblica di Bulgaria","common":"Bulgaria"},"jpn":{"official":"ブルガリア共和国","common":"ブルガリア"},"nld":{"official":"Republiek Bulgarije","common":"Bulgarije"},"por":{"official":"República da Bulgária","common":"Bulgária"},"rus":{"official":"Республика Болгария","common":"Болгария"},"slk":{"official":"Bulharská republika","common":"Bulharsko"},"spa":{"official":"República de Bulgaria","common":"Bulgaria"},"fin":{"official":"Bulgarian tasavalta","common":"Bulgaria"},"est":{"official":"Bulgaaria Vabariik","common":"Bulgaaria"},"zho":{"official":"保加利亚共和国","common":"保加利亚"},"pol":{"official":"Republika Bułgarii","common":"Bułgaria"},"urd":{"official":"جمہوریہ بلغاریہ","common":"بلغاریہ"},"kor":{"official":"불가리아 공화국","common":"불가리아"},"per":{"official":"جمهوری بلغارستان","common":"بلغارستان"}},"latlng":[43,25],"landlocked":false,"borders":["GRC","MKD","ROU","SRB","TUR"],"area":110879,"flag":"🇧🇬","demonyms":{"eng":{"f":"Bulgarian","m":"Bulgarian"},"fra":{"f":"Bulgare","m":"Bulgare"}}},{"name":{"common":"Bahrain","official":"Kingdom of Bahrain","native":{"ara":{"official":"مملكة البحرين","common":"‏البحرين"}}},"tld":[".bh"],"cca2":"BH","ccn3":"048","cca3":"BHR","cioc":"BRN","independent":true,"status":"officially-assigned","currencies":{"BHD":{"name":"Bahraini dinar","symbol":".د.ب"}},"idd":{"root":"+9","suffixes":["73"]},"capital":["Manama"],"altSpellings":["BH","Kingdom of Bahrain","Mamlakat al-Baḥrayn"],"region":"Asia","subregion":"Western Asia","languages":{"ara":"Arabic"},"translations":{"ces":{"official":"Království Bahrajn","common":"Bahrajn"},"cym":{"official":"Teyrnas Bahrein","common":"Bahrain"},"deu":{"official":"Königreich Bahrain","common":"Bahrain"},"fra":{"official":"Royaume de Bahreïn","common":"Bahreïn"},"hrv":{"official":"Kraljevina Bahrein","common":"Bahrein"},"ita":{"official":"Regno del Bahrain","common":"Bahrein"},"jpn":{"official":"バーレーン王国","common":"バーレーン"},"nld":{"official":"Koninkrijk Bahrein","common":"Bahrein"},"por":{"official":"Reino do Bahrein","common":"Bahrein"},"rus":{"official":"Королевство Бахрейн","common":"Бахрейн"},"slk":{"official":"Bahrajnské kráľovstvo","common":"Bahrajn"},"spa":{"official":"Reino de Bahrein","common":"Bahrein"},"fin":{"official":"Bahrainin kuningaskunta","common":"Bahrain"},"est":{"official":"Bahreini Kuningriik","common":"Bahrein"},"zho":{"official":"巴林王国","common":"巴林"},"pol":{"official":"Królestwo Bahrajnu","common":"Bahrajn"},"urd":{"official":"مملکتِ بحرین","common":"بحرین"},"kor":{"official":"바레인 왕국","common":"바레인"},"per":{"official":"پادشاهی بحرین","common":"بحرین"}},"latlng":[26,50.55],"landlocked":false,"borders":[],"area":765,"flag":"🇧🇭","demonyms":{"eng":{"f":"Bahraini","m":"Bahraini"},"fra":{"f":"Bahreïnienne","m":"Bahreïnien"}}},{"name":{"common":"Bahamas","official":"Commonwealth of the Bahamas","native":{"eng":{"official":"Commonwealth of the Bahamas","common":"Bahamas"}}},"tld":[".bs"],"cca2":"BS","ccn3":"044","cca3":"BHS","cioc":"BAH","independent":true,"status":"officially-assigned","currencies":{"BSD":{"name":"Bahamian dollar","symbol":"$"},"USD":{"name":"United States dollar","symbol":"$"}},"idd":{"root":"+1","suffixes":["242"]},"capital":["Nassau"],"altSpellings":["BS","Commonwealth of the Bahamas"],"region":"Americas","subregion":"Caribbean","languages":{"eng":"English"},"translations":{"ces":{"official":"Bahamské společenství","common":"Bahamy"},"cym":{"official":"Cymanwlad y Bahamas","common":"Bahamas"},"deu":{"official":"Commonwealth der Bahamas","common":"Bahamas"},"fra":{"official":"Commonwealth des Bahamas","common":"Bahamas"},"hrv":{"official":"Zajednica Bahama","common":"Bahami"},"ita":{"official":"Commonwealth delle Bahamas","common":"Bahamas"},"jpn":{"official":"バハマ","common":"バハマ"},"nld":{"official":"Gemenebest van de Bahama\'s","common":"Bahama’s"},"por":{"official":"Comunidade das Bahamas","common":"Bahamas"},"rus":{"official":"Содружество Багамских Островов","common":"Багамские Острова"},"slk":{"official":"Bahamské spoločenstvo","common":"Bahamy"},"spa":{"official":"Commonwealth de las Bahamas","common":"Bahamas"},"fin":{"official":"Bahaman liittovaltio","common":"Bahamasaaret"},"est":{"official":"Bahama Ühendus","common":"Bahama"},"zho":{"official":"巴哈马联邦","common":"巴哈马"},"pol":{"official":"Bahamy","common":"Bahamy"},"urd":{"official":"دولتِ مشترکہ بہاماس","common":"بہاماس"},"kor":{"official":"바하마 연방","common":"바하마"},"per":{"official":"قلمرو همسود باهاما","common":"باهاما"}},"latlng":[24.25,-76],"landlocked":false,"borders":[],"area":13943,"flag":"🇧🇸","demonyms":{"eng":{"f":"Bahamian","m":"Bahamian"},"fra":{"f":"Bahamienne","m":"Bahamien"}}},{"name":{"common":"Bosnia and Herzegovina","official":"Bosnia and Herzegovina","native":{"bos":{"official":"Bosna i Hercegovina","common":"Bosna i Hercegovina"},"hrv":{"official":"Bosna i Hercegovina","common":"Bosna i Hercegovina"},"srp":{"official":"Боснa и Херцеговина","common":"Боснa и Херцеговина"}}},"tld":[".ba"],"cca2":"BA","ccn3":"070","cca3":"BIH","cioc":"BIH","independent":true,"status":"officially-assigned","currencies":{"BAM":{"name":"Bosnia and Herzegovina convertible mark","symbol":""}},"idd":{"root":"+3","suffixes":["87"]},"capital":["Sarajevo"],"altSpellings":["BA","Bosnia-Herzegovina","Босна и Херцеговина"],"region":"Europe","subregion":"Southern Europe","languages":{"bos":"Bosnian","hrv":"Croatian","srp":"Serbian"},"translations":{"ces":{"official":"Bosna a Hercegovina","common":"Bosna a Hercegovina"},"cym":{"official":"Bosnia a Hercegovina","common":"Bosnia a Hercegovina"},"deu":{"official":"Bosnien und Herzegowina","common":"Bosnien und Herzegowina"},"fra":{"official":"Bosnie-et-Herzégovine","common":"Bosnie-Herzégovine"},"hrv":{"official":"Bosna i Hercegovina","common":"Bosna i Hercegovina"},"ita":{"official":"Bosnia-Erzegovina","common":"Bosnia ed Erzegovina"},"jpn":{"official":"ボスニア·ヘルツェゴビナ","common":"ボスニア・ヘルツェゴビナ"},"nld":{"official":"Bosnië-Herzegovina","common":"Bosnië en Herzegovina"},"por":{"official":"Bósnia e Herzegovina","common":"Bósnia e Herzegovina"},"rus":{"official":"Босния и Герцеговина","common":"Босния и Герцеговина"},"slk":{"official":"Republika Bosny a Hercegoviny","common":"Bosna a Hercegovina"},"spa":{"official":"Bosnia y Herzegovina","common":"Bosnia y Herzegovina"},"fin":{"official":"Bosnia ja Hertsegovina","common":"Bosnia ja Hertsegovina"},"est":{"official":"Bosnia ja Hertsegoviina","common":"Bosnia ja Hertsegoviina"},"zho":{"official":"波斯尼亚和黑塞哥维那","common":"波斯尼亚和黑塞哥维那"},"pol":{"official":"Bośnia i Hercegowina","common":"Bośnia i Hercegowina"},"urd":{"official":"بوسنیا و ہرزیگووینا","common":"بوسنیا و ہرزیگووینا"},"kor":{"official":"보스니아 헤르체고비나","common":"보스니아 헤르체고비나"},"per":{"official":"بوسنی و هرزگوین","common":"بوسنی و هرزگوین"}},"latlng":[44,18],"landlocked":false,"borders":["HRV","MNE","SRB"],"area":51209,"flag":"🇧🇦","demonyms":{"eng":{"f":"Bosnian, Herzegovinian","m":"Bosnian, Herzegovinian"},"fra":{"f":"Bosnienne","m":"Bosnien"}}},{"name":{"common":"Saint Barthélemy","official":"Collectivity of Saint Barthélemy","native":{"fra":{"official":"Collectivité de Saint-Barthélemy","common":"Saint-Barthélemy"}}},"tld":[".bl"],"cca2":"BL","ccn3":"652","cca3":"BLM","cioc":"","independent":false,"status":"officially-assigned","currencies":{"EUR":{"name":"Euro","symbol":"€"}},"idd":{"root":"+5","suffixes":["90"]},"capital":["Gustavia"],"altSpellings":["BL","St. Barthelemy","Collectivity of Saint Barthélemy","Collectivité de Saint-Barthélemy"],"region":"Americas","subregion":"Caribbean","languages":{"fra":"French"},"translations":{"ces":{"official":"Svatý Bartoloměj","common":"Svatý Bartoloměj"},"deu":{"official":"Gebietskörperschaft Saint-Barthélemy","common":"Saint-Barthélemy"},"fra":{"official":"Collectivité de Saint-Barthélemy","common":"Saint-Barthélemy"},"hrv":{"official":"Kolektivnost sv Barthélemy","common":"Saint Barthélemy"},"ita":{"official":"Collettività di Saint Barthélemy","common":"Antille Francesi"},"jpn":{"official":"サン·バルテルミー島の集合体","common":"サン・バルテルミー"},"nld":{"official":"Gemeenschap Saint Barthélemy","common":"Saint Barthélemy"},"por":{"official":"Coletividade de Saint Barthélemy","common":"São Bartolomeu"},"rus":{"official":"Коллективность Санкт -Бартельми","common":"Сен-Бартелеми"},"slk":{"official":"Svätý Bartolomej","common":"Svätý Bartolomej"},"spa":{"official":"Colectividad de San Barthélemy","common":"San Bartolomé"},"fin":{"official":"Saint-Barthélemyn yhteisö","common":"Saint-Barthélemy"},"est":{"official":"Saint-Barthélemy territoriaalühendus","common":"Saint-Barthélemy"},"zho":{"official":"圣巴泰勒米集体","common":"圣巴泰勒米"},"pol":{"official":"Saint-Barthélemy","common":"Saint-Barthélemy"},"urd":{"official":"سینٹ بارتھیملے","common":"سینٹ بارتھیملے"},"kor":{"official":"생바르텔레미","common":"생바르텔레미"},"per":{"official":"سن بارتلمی","common":"سن بارتلمی"}},"latlng":[18.5,-63.41666666],"landlocked":false,"borders":[],"area":21,"flag":"🇧🇱","demonyms":{"eng":{"f":"Saint Barthélemy Islander","m":"Saint Barthélemy Islander"},"fra":{"f":"Barthéloméenne","m":"Barthéloméen"}}},{"name":{"common":"Saint Helena, Ascension and Tristan da Cunha","official":"Saint Helena, Ascension and Tristan da Cunha","native":{"eng":{"official":"Saint Helena, Ascension and Tristan da Cunha","common":"Saint Helena, Ascension and Tristan da Cunha"}}},"tld":[".sh",".ac"],"cca2":"SH","ccn3":"654","cca3":"SHN","cioc":"","independent":false,"status":"officially-assigned","currencies":{"GBP":{"name":"Pound sterling","symbol":"£"},"SHP":{"name":"Saint Helena pound","symbol":"£"}},"idd":{"root":"+2","suffixes":["90","47"]},"capital":["Jamestown"],"altSpellings":["Saint Helena","St. Helena, Ascension and Tristan da Cunha"],"region":"Africa","subregion":"Western Africa","languages":{"eng":"English"},"translations":{"ces":{"official":"Svatá Helena, Ascension a Tristan da Cunha","common":"Svatá Helena, Ascension a Tristan da Cunha"},"deu":{"official":"Sankt Helena, Ascension und Tristan da Cunha","common":"St. Helena, Ascension und Tristan da Cunha"},"fra":{"official":"Sainte-Hélène, Ascension et Tristan da Cunha","common":"Sainte-Hélène, Ascension et Tristan da Cunha"},"hrv":{"official":"Sveta Helena","common":"Sveta Helena"},"ita":{"official":"Sant\'Elena, Ascensione e Tristan da Cunha","common":"Sant\'Elena, Ascensione e Tristan da Cunha"},"jpn":{"official":"セントヘレナ・アセンションおよびトリスタンダクーニャ","common":"セントヘレナ・アセンションおよびトリスタンダクーニャ"},"nld":{"official":"Sint-Helena, Ascension en Tristan da Cunha","common":"Sint-Helena, Ascension en Tristan da Cunha"},"por":{"official":"Santa Helena, Ascensão e Tristão da Cunha","common":"Santa Helena, Ascensão e Tristão da Cunha"},"rus":{"official":"Острова Святой Елены, Вознесения и Тристан-да-Кунья","common":"Острова Святой Елены, Вознесения и Тристан-да-Кунья"},"slk":{"official":"Svätá Helena (zámorské územie)","common":"Svätá Helena (zámorské územie)"},"spa":{"official":"Santa Elena, Ascensión y Tristán de Acuña","common":"Santa Elena, Ascensión y Tristán de Acuña"},"fin":{"official":"Saint Helena, Ascension ja Tristan da Cunha","common":"Saint Helena, Ascension ja Tristan da Cunha"},"est":{"official":"Saint Helena, Ascension ja Tristan da Cunha","common":"Saint Helena, Ascension ja Tristan da Cunha"},"zho":{"official":"圣赫勒拿、阿森松和特里斯坦-达库尼亚","common":"圣赫勒拿、阿森松和特里斯坦-达库尼亚"},"pol":{"official":"Wyspa Świętej Heleny, Wyspa Wniebowstąpienia i Tristan da Cunha","common":"Wyspa Świętej Heleny, Wyspa Wniebowstąpienia i Tristan da Cunha"},"urd":{"official":"سینٹ ہلینا، اسینشن و ترسٹان دا کونیا","common":"سینٹ ہلینا، اسینشن و ترسٹان دا کونیا"},"kor":{"official":"세인트헬레나","common":"세인트헬레나"},"per":{"official":"سنت هلن","common":"سنت هلن"}},"latlng":[-15.95,-5.72],"landlocked":false,"borders":[],"area":394,"flag":"🇸🇭","demonyms":{"eng":{"f":"Saint Helenian","m":"Saint Helenian"},"fra":{"f":"Sainte-Hélénoise","m":"Sainte-Hélènois"}}},{"name":{"common":"Belarus","official":"Republic of Belarus","native":{"bel":{"official":"Рэспубліка Беларусь","common":"Белару́сь"},"rus":{"official":"Республика Беларусь","common":"Беларусь"}}},"tld":[".by"],"cca2":"BY","ccn3":"112","cca3":"BLR","cioc":"BLR","independent":true,"status":"officially-assigned","currencies":{"BYN":{"name":"Belarusian ruble","symbol":"Br"}},"idd":{"root":"+3","suffixes":["75"]},"capital":["Minsk"],"altSpellings":["BY","Bielaruś","Republic of Belarus","Белоруссия","Республика Белоруссия"],"region":"Europe","subregion":"Eastern Europe","languages":{"bel":"Belarusian","rus":"Russian"},"translations":{"ces":{"official":"Běloruská republika","common":"Bělorusko"},"cym":{"official":"Gweriniaeth Belarws","common":"Belarws"},"deu":{"official":"Republik Belarus","common":"Weißrussland"},"fra":{"official":"République de Biélorussie","common":"Biélorussie"},"hrv":{"official":"Republika Bjelorusija","common":"Bjelorusija"},"ita":{"official":"Repubblica di Belarus","common":"Bielorussia"},"jpn":{"official":"ベラルーシ共和国","common":"ベラルーシ"},"nld":{"official":"Republiek Belarus","common":"Wit-Rusland"},"por":{"official":"República da Bielorrússia","common":"Bielorússia"},"rus":{"official":"Республика Беларусь","common":"Беларусь"},"slk":{"official":"Bieloruská republika","common":"Bielorusko"},"spa":{"official":"República de Belarús","common":"Bielorrusia"},"fin":{"official":"Valko-Venäjän tasavalta","common":"Valko-Venäjä"},"est":{"official":"Valgevene Vabariik","common":"Valgevene"},"zho":{"official":"白俄罗斯共和国","common":"白俄罗斯"},"pol":{"official":"Republika Białorusi","common":"Białoruś"},"urd":{"official":"جمہوریہ بیلاروس","common":"بیلاروس"},"kor":{"official":"벨라루스 공화국","common":"벨라루스"},"per":{"official":"جمهوری بلاروس","common":"بلاروس"}},"latlng":[53,28],"landlocked":true,"borders":["LVA","LTU","POL","RUS","UKR"],"area":207600,"flag":"🇧🇾","demonyms":{"eng":{"f":"Belarusian","m":"Belarusian"},"fra":{"f":"Biélorusse","m":"Biélorusse"}}},{"name":{"common":"Belize","official":"Belize","native":{"bjz":{"official":"Belize","common":"Belize"},"eng":{"official":"Belize","common":"Belize"},"spa":{"official":"Belice","common":"Belice"}}},"tld":[".bz"],"cca2":"BZ","ccn3":"084","cca3":"BLZ","cioc":"BIZ","independent":true,"status":"officially-assigned","currencies":{"BZD":{"name":"Belize dollar","symbol":"$"}},"idd":{"root":"+5","suffixes":["01"]},"capital":["Belmopan"],"altSpellings":["BZ"],"region":"Americas","subregion":"Central America","languages":{"bjz":"Belizean Creole","eng":"English","spa":"Spanish"},"translations":{"ces":{"official":"Belize","common":"Belize"},"cym":{"official":"Belîs","common":"Belîs"},"deu":{"official":"Belize","common":"Belize"},"fra":{"official":"Belize","common":"Belize"},"hrv":{"official":"Belize","common":"Belize"},"ita":{"official":"Belize","common":"Belize"},"jpn":{"official":"ベリーズ","common":"ベリーズ"},"nld":{"official":"Belize","common":"Belize"},"por":{"official":"Belize","common":"Belize"},"rus":{"official":"Белиз","common":"Белиз"},"slk":{"official":"Belize","common":"Belize"},"spa":{"official":"Belice","common":"Belice"},"fin":{"official":"Belize","common":"Belize"},"est":{"official":"Belize","common":"Belize"},"zho":{"official":"伯利兹","common":"伯利兹"},"pol":{"official":"Belize","common":"Belize"},"urd":{"official":"بیلیز","common":"بیلیز"},"kor":{"official":"벨리즈","common":"벨리즈"},"per":{"official":"بلیز","common":"بلیز"}},"latlng":[17.25,-88.75],"landlocked":false,"borders":["GTM","MEX"],"area":22966,"flag":"🇧🇿","demonyms":{"eng":{"f":"Belizean","m":"Belizean"},"fra":{"f":"Bélizienne","m":"Bélizien"}}},{"name":{"common":"Bermuda","official":"Bermuda","native":{"eng":{"official":"Bermuda","common":"Bermuda"}}},"tld":[".bm"],"cca2":"BM","ccn3":"060","cca3":"BMU","cioc":"BER","independent":false,"status":"officially-assigned","currencies":{"BMD":{"name":"Bermudian dollar","symbol":"$"}},"idd":{"root":"+1","suffixes":["441"]},"capital":["Hamilton"],"altSpellings":["BM","The Islands of Bermuda","The Bermudas","Somers Isles"],"region":"Americas","subregion":"North America","languages":{"eng":"English"},"translations":{"ces":{"official":"Bermudské ostrovy","common":"Bermudy"},"cym":{"official":"Bermiwda","common":"Bermiwda"},"deu":{"official":"Bermuda","common":"Bermuda"},"fra":{"official":"Bermudes","common":"Bermudes"},"hrv":{"official":"Bermuda","common":"Bermudi"},"ita":{"official":"Bermuda","common":"Bermuda"},"jpn":{"official":"バミューダ","common":"バミューダ"},"nld":{"official":"Bermuda","common":"Bermuda"},"por":{"official":"Bermudas","common":"Bermudas"},"rus":{"official":"Бермудские острова","common":"Бермудские Острова"},"slk":{"official":"Bermudy","common":"Bermudy"},"spa":{"official":"Bermuda","common":"Bermudas"},"fin":{"official":"Bermuda","common":"Bermuda"},"est":{"official":"Bermuda","common":"Bermuda"},"zho":{"official":"百慕大","common":"百慕大"},"pol":{"official":"Bermudy","common":"Bermudy"},"urd":{"official":"برمودا","common":"برمودا"},"kor":{"official":"버뮤다","common":"버뮤다"},"per":{"official":"جزایر برمودا","common":"برمودا"}},"latlng":[32.33333333,-64.75],"landlocked":false,"borders":[],"area":54,"flag":"🇧🇲","demonyms":{"eng":{"f":"Bermudian","m":"Bermudian"},"fra":{"f":"Bermudienne","m":"Bermudien"}}},{"name":{"common":"Bolivia","official":"Plurinational State of Bolivia","native":{"aym":{"official":"Wuliwya Suyu","common":"Wuliwya"},"grn":{"official":"Tetã Volívia","common":"Volívia"},"que":{"official":"Buliwya Mamallaqta","common":"Buliwya"},"spa":{"official":"Estado Plurinacional de Bolivia","common":"Bolivia"}}},"tld":[".bo"],"cca2":"BO","ccn3":"068","cca3":"BOL","cioc":"BOL","independent":true,"status":"officially-assigned","currencies":{"BOB":{"name":"Bolivian boliviano","symbol":"Bs."}},"idd":{"root":"+5","suffixes":["91"]},"capital":["Sucre"],"altSpellings":["BO","Buliwya","Wuliwya","Bolivia, Plurinational State of","Plurinational State of Bolivia","Estado Plurinacional de Bolivia","Buliwya Mamallaqta","Wuliwya Suyu","Tetã Volívia"],"region":"Americas","subregion":"South America","languages":{"aym":"Aymara","grn":"Guaraní","que":"Quechua","spa":"Spanish"},"translations":{"ces":{"official":"Mnohonárodnostní stát Bolívie","common":"Bolívie"},"cym":{"official":"Gweriniaeth Bolifia","common":"Bolifia"},"deu":{"official":"Plurinationaler Staat Bolivien","common":"Bolivien"},"fra":{"official":"État plurinational de Bolivie","common":"Bolivie"},"hrv":{"official":"Plurinational State of Bolivia","common":"Bolivija"},"ita":{"official":"Stato Plurinazionale della Bolivia","common":"Bolivia"},"jpn":{"official":"ボリビアの多民族国","common":"ボリビア多民族国"},"nld":{"official":"Plurinationale Staat van Bolivia","common":"Bolivia"},"por":{"official":"Estado Plurinacional da Bolívia","common":"Bolívia"},"rus":{"official":"Многонациональное Государство Боливия","common":"Боливия"},"slk":{"official":"Bolívijská republika","common":"Bolívia"},"spa":{"official":"Estado Plurinacional de Bolivia","common":"Bolivia"},"fin":{"official":"Bolivian monikansainen valtio","common":"Bolivia"},"est":{"official":"Boliivia Paljurahvuseline Riik","common":"Boliivia"},"zho":{"official":"多民族玻利维亚国","common":"玻利维亚"},"pol":{"official":"Wielonarodowe Państwo Boliwia","common":"Boliwia"},"urd":{"official":"جمہوریہ بولیویا","common":"بولیویا"},"kor":{"official":"볼리비아 다민족국","common":"볼리비아"},"per":{"official":"جمهوری بولیوی","common":"بولیوی"}},"latlng":[-17,-65],"landlocked":true,"borders":["ARG","BRA","CHL","PRY","PER"],"area":1098581,"flag":"🇧🇴","demonyms":{"eng":{"f":"Bolivian","m":"Bolivian"},"fra":{"f":"Bolivienne","m":"Bolivien"}}},{"name":{"common":"Caribbean Netherlands","official":"Bonaire, Sint Eustatius and Saba","native":{"nld":{"official":"Bonaire, Sint Eustatius en Saba","common":"Caribisch Nederland"},"pap":{"official":"Boneiru, Sint Eustatius y Saba","common":"Boneiru, Sint Eustatius y Saba"}}},"tld":[".bq",".nl"],"cca2":"BQ","ccn3":"535","cca3":"BES","cioc":"","independent":false,"status":"officially-assigned","currencies":{"USD":{"name":"United States dollar","symbol":"$"}},"idd":{"root":"+5","suffixes":["99"]},"capital":[],"altSpellings":["BES islands"],"region":"Americas","subregion":"Caribbean","languages":{"eng":"English","nld":"Dutch","pap":"Papiamento"},"translations":{"ces":{"official":"Karibské Nizozemsko","common":"Karibské Nizozemsko"},"deu":{"official":"Bonaire, Sint Eustatius und Saba","common":"Karibische Niederlande"},"fra":{"official":"Bonaire, Saint-Eustache et Saba","common":"Pays-Bas caribéens"},"hrv":{"official":"Bonaire, Sint Eustatius i Saba","common":"Bonaire, Sint Eustatius i Saba"},"ita":{"official":"Bonaire, Sint Eustatius e Saba","common":"Paesi Bassi caraibici"},"jpn":{"official":"ボネール、シント・ユースタティウスおよびサバ","common":"ボネール、シント・ユースタティウスおよびサバ"},"nld":{"official":"Bonaire, Sint Eustatius en Saba","common":"Caribisch Nederland"},"por":{"official":"Bonaire, Saba e Santo Eustáquio","common":"Países Baixos Caribenhos"},"rus":{"official":"Бонэйр, Синт-Эстатиус и Саба","common":"Карибские Нидерланды"},"slk":{"official":"Bonaire, Sint Eustatius a Saba","common":"Bonaire, Sint Eustatius a Saba"},"spa":{"official":"Bonaire, San Eustaquio y Saba","common":"Caribe Neerlandés"},"fin":{"official":"Bonaire, Sint Eustatius ja Saba","common":"Bonaire, Sint Eustatius ja Saba"},"est":{"official":"Bonaire, Sint Eustatius ja Saba","common":"Bonaire, Sint Eustatius ja Saba"},"zho":{"official":"荷蘭加勒比區","common":"荷蘭加勒比區"},"pol":{"official":"Bonaire, Sint Eustatius i Saba","common":"Antyle Holenderskie"},"urd":{"official":"بونایر، سینٹ ایوسٹائیس اور سابا","common":"کیریبین نیدرلینڈز"},"kor":{"official":"보네르, 신트외스타티위스, 사바","common":"카리브 네덜란드"},"per":{"official":"جزایر کارائیب هلند","common":"جزایر کارائیب هلند"}},"latlng":[12.18,-68.25],"landlocked":false,"borders":[],"area":328,"flag":"","demonyms":{"eng":{"f":"Dutch","m":"Dutch"},"fra":{"f":"Néerlandaise","m":"Néerlandais"}}},{"name":{"common":"Brazil","official":"Federative Republic of Brazil","native":{"por":{"official":"República Federativa do Brasil","common":"Brasil"}}},"tld":[".br"],"cca2":"BR","ccn3":"076","cca3":"BRA","cioc":"BRA","independent":true,"status":"officially-assigned","currencies":{"BRL":{"name":"Brazilian real","symbol":"R$"}},"idd":{"root":"+5","suffixes":["5"]},"capital":["Brasília"],"altSpellings":["BR","Brasil","Federative Republic of Brazil","República Federativa do Brasil"],"region":"Americas","subregion":"South America","languages":{"por":"Portuguese"},"translations":{"ces":{"official":"Brazilská federativní republika","common":"Brazílie"},"cym":{"official":"Gweriniaeth Ffederal Brasil","common":"Brasil"},"deu":{"official":"Föderative Republik Brasilien","common":"Brasilien"},"fra":{"official":"République fédérative du Brésil","common":"Brésil"},"hrv":{"official":"Savezne Republike Brazil","common":"Brazil"},"ita":{"official":"Repubblica federativa del Brasile","common":"Brasile"},"jpn":{"official":"ブラジル連邦共和国","common":"ブラジル"},"nld":{"official":"Federale Republiek Brazilië","common":"Brazilië"},"por":{"official":"República Federativa do Brasil","common":"Brasil"},"rus":{"official":"Федеративная Республика Бразилия","common":"Бразилия"},"slk":{"official":"Brazílska federatívna republika","common":"Brazília"},"spa":{"official":"República Federativa del Brasil","common":"Brasil"},"fin":{"official":"Brasilian liittotasavalta","common":"Brasilia"},"est":{"official":"Brasiilia Liitvabariik","common":"Brasiilia"},"zho":{"official":"巴西联邦共和国","common":"巴西"},"pol":{"official":"Federacyjna Republika Brazylii","common":"Brazylia"},"urd":{"official":"وفاقی جمہوریہ برازیل","common":"برازیل"},"kor":{"official":"브라질 연방 공화국","common":"브라질"},"per":{"official":"جمهوری فدراتیو برزیل","common":"برزیل"}},"latlng":[-10,-55],"landlocked":false,"borders":["ARG","BOL","COL","GUF","GUY","PRY","PER","SUR","URY","VEN"],"area":8515767,"flag":"🇧🇷","demonyms":{"eng":{"f":"Brazilian","m":"Brazilian"},"fra":{"f":"Brésilienne","m":"Brésilien"}}},{"name":{"common":"Barbados","official":"Barbados","native":{"eng":{"official":"Barbados","common":"Barbados"}}},"tld":[".bb"],"cca2":"BB","ccn3":"052","cca3":"BRB","cioc":"BAR","independent":true,"status":"officially-assigned","currencies":{"BBD":{"name":"Barbadian dollar","symbol":"$"}},"idd":{"root":"+1","suffixes":["246"]},"capital":["Bridgetown"],"altSpellings":["BB"],"region":"Americas","subregion":"Caribbean","languages":{"eng":"English"},"translations":{"ces":{"official":"Barbados","common":"Barbados"},"cym":{"official":"Barbados","common":"Barbados"},"deu":{"official":"Barbados","common":"Barbados"},"fra":{"official":"Barbade","common":"Barbade"},"hrv":{"official":"Barbados","common":"Barbados"},"ita":{"official":"Barbados","common":"Barbados"},"jpn":{"official":"バルバドス","common":"バルバドス"},"nld":{"official":"Barbados","common":"Barbados"},"por":{"official":"Barbados","common":"Barbados"},"rus":{"official":"Барбадос","common":"Барбадос"},"slk":{"official":"Barbados","common":"Barbados"},"spa":{"official":"Barbados","common":"Barbados"},"fin":{"official":"Barbados","common":"Barbados"},"est":{"official":"Barbados","common":"Barbados"},"zho":{"official":"巴巴多斯","common":"巴巴多斯"},"pol":{"official":"Barbados","common":"Barbados"},"urd":{"official":"بارباڈوس","common":"بارباڈوس"},"kor":{"official":"바베이도스","common":"바베이도스"},"per":{"official":"باربادوس","common":"باربادوس"}},"latlng":[13.16666666,-59.53333333],"landlocked":false,"borders":[],"area":430,"flag":"🇧🇧","demonyms":{"eng":{"f":"Barbadian","m":"Barbadian"},"fra":{"f":"Barbadienne","m":"Barbadien"}}},{"name":{"common":"Brunei","official":"Nation of Brunei, Abode of Peace","native":{"msa":{"official":"Nation of Brunei, Abode Damai","common":"Negara Brunei Darussalam"}}},"tld":[".bn"],"cca2":"BN","ccn3":"096","cca3":"BRN","cioc":"BRU","independent":true,"status":"officially-assigned","currencies":{"BND":{"name":"Brunei dollar","symbol":"$"},"SGD":{"name":"Singapore dollar","symbol":"$"}},"idd":{"root":"+6","suffixes":["73"]},"capital":["Bandar Seri Begawan"],"altSpellings":["BN","Brunei Darussalam","Nation of Brunei","the Abode of Peace"],"region":"Asia","subregion":"South-Eastern Asia","languages":{"msa":"Malay"},"translations":{"ces":{"official":"Sultanát Brunej","common":"Brunej"},"cym":{"official":"Teyrnas Brwnei","common":"Brunei"},"deu":{"official":"Sultanat Brunei Darussalam","common":"Brunei"},"fra":{"official":"État de Brunei Darussalam","common":"Brunei"},"hrv":{"official":"Nacija od Bruneja, Kuću Mira","common":"Brunej"},"ita":{"official":"Nazione di Brunei, Dimora della Pace","common":"Brunei"},"jpn":{"official":"ブルネイ、平和の精舎の国家","common":"ブルネイ・ダルサラーム"},"nld":{"official":"Natie van Brunei, de verblijfplaats van de Vrede","common":"Brunei"},"por":{"official":"Nação do Brunei, Morada da Paz","common":"Brunei"},"rus":{"official":"Нация Бруней, обитель мира","common":"Бруней"},"slk":{"official":"Brunejský sultanât","common":"Brunej"},"spa":{"official":"Nación de Brunei, Morada de la Paz","common":"Brunei"},"fin":{"official":"Brunei Darussalamin valtio","common":"Brunei"},"est":{"official":"Brunei Darussalami Riik","common":"Brunei"},"zho":{"official":"文莱和平之国","common":"文莱"},"pol":{"official":"Państwo Brunei Darussalam","common":"Brunei"},"urd":{"official":"ریاستِ برونائی دارالسلام","common":"برونائی"},"kor":{"official":"브루나이 다루살람국","common":"브루나이"},"per":{"official":"برونئی سرای صلح","common":"برونئی"}},"latlng":[4.5,114.66666666],"landlocked":false,"borders":["MYS"],"area":5765,"flag":"🇧🇳","demonyms":{"eng":{"f":"Bruneian","m":"Bruneian"},"fra":{"f":"Brunéienne","m":"Brunéien"}}},{"name":{"common":"Bhutan","official":"Kingdom of Bhutan","native":{"dzo":{"official":"འབྲུག་རྒྱལ་ཁབ་","common":"འབྲུག་ཡུལ་"}}},"tld":[".bt"],"cca2":"BT","ccn3":"064","cca3":"BTN","cioc":"BHU","independent":true,"status":"officially-assigned","currencies":{"BTN":{"name":"Bhutanese ngultrum","symbol":"Nu."},"INR":{"name":"Indian rupee","symbol":"₹"}},"idd":{"root":"+9","suffixes":["75"]},"capital":["Thimphu"],"altSpellings":["BT","Kingdom of Bhutan"],"region":"Asia","subregion":"Southern Asia","languages":{"dzo":"Dzongkha"},"translations":{"ces":{"official":"Bhútánské království","common":"Bhútán"},"cym":{"official":"Teyrnas Bhwtan","common":"Bhwtan"},"deu":{"official":"Königreich Bhutan","common":"Bhutan"},"fra":{"official":"Royaume du Bhoutan","common":"Bhoutan"},"hrv":{"official":"Kraljevina Butan","common":"Butan"},"ita":{"official":"Regno del Bhutan","common":"Bhutan"},"jpn":{"official":"ブータン王国","common":"ブータン"},"nld":{"official":"Koninkrijk Bhutan","common":"Bhutan"},"por":{"official":"Reino do Butão","common":"Butão"},"rus":{"official":"Королевство Бутан","common":"Бутан"},"slk":{"official":"Bhutánske krâľovstvo","common":"Bhután"},"spa":{"official":"Reino de Bután","common":"Bután"},"fin":{"official":"Bhutanin kuningaskunta","common":"Bhutan"},"est":{"official":"Bhutani Kuningriik","common":"Bhutan"},"zho":{"official":"不丹王国","common":"不丹"},"pol":{"official":"Bhutan","common":"Bhutan"},"urd":{"official":"سلطنت بھوٹان","common":"بھوٹان"},"kor":{"official":"부탄 왕국","common":"부탄"},"per":{"official":"پادشاهی بوتان","common":"بوتان"}},"latlng":[27.5,90.5],"landlocked":true,"borders":["CHN","IND"],"area":38394,"flag":"🇧🇹","demonyms":{"eng":{"f":"Bhutanese","m":"Bhutanese"},"fra":{"f":"Bhoutanaise","m":"Bhoutanais"}}},{"name":{"common":"Bouvet Island","official":"Bouvet Island","native":{"nor":{"official":"Bouvetøya","common":"Bouvetøya"}}},"tld":[".bv"],"cca2":"BV","ccn3":"074","cca3":"BVT","cioc":"","independent":false,"status":"officially-assigned","currencies":[],"idd":{"root":"+4","suffixes":["7"]},"capital":[""],"altSpellings":["BV","Bouvetøya","Bouvet-øya"],"region":"Antarctic","subregion":"","languages":{"nor":"Norwegian"},"translations":{"ces":{"official":"Bouvetův ostrov","common":"Bouvetův ostrov"},"deu":{"official":"Bouvetinsel","common":"Bouvetinsel"},"fra":{"official":"Île Bouvet","common":"Île Bouvet"},"hrv":{"official":"Bouvet Island","common":"Otok Bouvet"},"ita":{"official":"Isola Bouvet","common":"Isola Bouvet"},"jpn":{"official":"ブーヴェ島","common":"ブーベ島"},"nld":{"official":"Bouvet Island","common":"Bouveteiland"},"por":{"official":"Ilha Bouvet","common":"Ilha Bouvet"},"rus":{"official":"Остров Буве","common":"Остров Буве"},"slk":{"official":"Bouvetov ostrov","common":"Bouvetov ostrov"},"spa":{"official":"Isla Bouvet","common":"Isla Bouvet"},"fin":{"official":"Bouvet\'nsaari","common":"Bouvet\'nsaari"},"est":{"official":"Bouvet’ saar","common":"Bouvet’ saar"},"zho":{"official":"布维岛","common":"布维岛"},"pol":{"official":"Wyspa Bouveta","common":"Wyspa Bouveta"},"urd":{"official":"جزیرہ بووہ","common":"جزیرہ بووہ"},"kor":{"official":"부베 섬","common":"부베 섬"},"per":{"official":"جزیرهٔ بووه","common":"جزیرهٔ بووه"}},"latlng":[-54.43333333,3.4],"landlocked":false,"borders":[],"area":49,"flag":"🇧🇻","demonyms":{"eng":{"f":"","m":""},"fra":{"f":"","m":""}}},{"name":{"common":"Botswana","official":"Republic of Botswana","native":{"eng":{"official":"Republic of Botswana","common":"Botswana"},"tsn":{"official":"Lefatshe la Botswana","common":"Botswana"}}},"tld":[".bw"],"cca2":"BW","ccn3":"072","cca3":"BWA","cioc":"BOT","independent":true,"status":"officially-assigned","currencies":{"BWP":{"name":"Botswana pula","symbol":"P"}},"idd":{"root":"+2","suffixes":["67"]},"capital":["Gaborone"],"altSpellings":["BW","Republic of Botswana","Lefatshe la Botswana"],"region":"Africa","subregion":"Southern Africa","languages":{"eng":"English","tsn":"Tswana"},"translations":{"ces":{"official":"Botswanská republika","common":"Botswana"},"deu":{"official":"Republik Botsuana","common":"Botswana"},"fra":{"official":"République du Botswana","common":"Botswana"},"hrv":{"official":"Republika Bocvana","common":"Bocvana"},"ita":{"official":"Repubblica del Botswana","common":"Botswana"},"jpn":{"official":"ボツワナ共和国","common":"ボツワナ"},"nld":{"official":"Republiek Botswana","common":"Botswana"},"por":{"official":"República do Botswana","common":"Botswana"},"rus":{"official":"Республика Ботсвана","common":"Ботсвана"},"slk":{"official":"Botswanská republika","common":"Botswana"},"spa":{"official":"República de Botswana","common":"Botswana"},"fin":{"official":"Botswanan tasavalta","common":"Botswana"},"est":{"official":"Botswana Vabariik","common":"Botswana"},"zho":{"official":"博茨瓦纳共和国","common":"博茨瓦纳"},"pol":{"official":"Republika Botswany","common":"Botswana"},"urd":{"official":"جمہوریہ بوٹسوانا","common":"بوٹسوانا"},"kor":{"official":"보츠와나 공화국","common":"보츠와나"},"per":{"official":"جمهوری بوتسوانا","common":"بوتسوانا"}},"latlng":[-22,24],"landlocked":true,"borders":["NAM","ZAF","ZMB","ZWE"],"area":582000,"flag":"🇧🇼","demonyms":{"eng":{"f":"Motswana","m":"Motswana"},"fra":{"f":"Botswanaise","m":"Botswanais"}}},{"name":{"common":"Central African Republic","official":"Central African Republic","native":{"fra":{"official":"République centrafricaine","common":"République centrafricaine"},"sag":{"official":"Ködörösêse tî Bêafrîka","common":"Bêafrîka"}}},"tld":[".cf"],"cca2":"CF","ccn3":"140","cca3":"CAF","cioc":"CAF","independent":true,"status":"officially-assigned","currencies":{"XAF":{"name":"Central African CFA franc","symbol":"Fr"}},"idd":{"root":"+2","suffixes":["36"]},"capital":["Bangui"],"altSpellings":["CF","Central African Republic","République centrafricaine"],"region":"Africa","subregion":"Middle Africa","languages":{"fra":"French","sag":"Sango"},"translations":{"ces":{"official":"Středoafrická republika","common":"Středoafrická republika"},"cym":{"official":"Gweriniaeth Canolbarth Affrica","common":"Gweriniaeth Canolbarth Affrica"},"deu":{"official":"Zentralafrikanische Republik","common":"Zentralafrikanische Republik"},"fra":{"official":"République centrafricaine","common":"République centrafricaine"},"hrv":{"official":"Centralna Afrička Republika","common":"Srednjoafrička Republika"},"ita":{"official":"Repubblica Centrafricana","common":"Repubblica Centrafricana"},"jpn":{"official":"中央アフリカ共和国","common":"中央アフリカ共和国"},"nld":{"official":"Centraal-Afrikaanse Republiek","common":"Centraal-Afrikaanse Republiek"},"por":{"official":"República Centro-Africano","common":"República Centro-Africana"},"rus":{"official":"Центрально-Африканская Республика","common":"Центральноафриканская Республика"},"slk":{"official":"Stredoafrická republika","common":"Stredoafrická republika"},"spa":{"official":"República Centroafricana","common":"República Centroafricana"},"fin":{"official":"Keski-Afrikan tasavalta","common":"Keski-Afrikan tasavalta"},"est":{"official":"Kesk-Aafrika Vabariik","common":"Kesk-Aafrika Vabariik"},"zho":{"official":"中非共和国","common":"中非共和国"},"pol":{"official":"Republika Środkowoafrykańska","common":"Republika Środkowoafrykańska"},"urd":{"official":"وسطی افریقی جمہوریہ","common":"وسطی افریقی جمہوریہ"},"kor":{"official":"중앙아프리카 공화국","common":"중앙아프리카 공화국"},"per":{"official":"جمهوری آفریقای مرکزی","common":"جمهوری آفریقای مرکزی"}},"latlng":[7,21],"landlocked":true,"borders":["CMR","TCD","COD","COG","SSD","SDN"],"area":622984,"flag":"🇨🇫","demonyms":{"eng":{"f":"Central African","m":"Central African"},"fra":{"f":"Centrafricaine","m":"Centrafricain"}}},{"name":{"common":"Canada","official":"Canada","native":{"eng":{"official":"Canada","common":"Canada"},"fra":{"official":"Canada","common":"Canada"}}},"tld":[".ca"],"cca2":"CA","ccn3":"124","cca3":"CAN","cioc":"CAN","independent":true,"status":"officially-assigned","currencies":{"CAD":{"name":"Canadian dollar","symbol":"$"}},"idd":{"root":"+1","suffixes":[""]},"capital":["Ottawa"],"altSpellings":["CA"],"region":"Americas","subregion":"North America","languages":{"eng":"English","fra":"French"},"translations":{"ces":{"official":"Kanada","common":"Kanada"},"cym":{"official":"Canada","common":"Canada"},"deu":{"official":"Kanada","common":"Kanada"},"fra":{"official":"Canada","common":"Canada"},"hrv":{"official":"Kanada","common":"Kanada"},"ita":{"official":"Canada","common":"Canada"},"jpn":{"official":"カナダ","common":"カナダ"},"nld":{"official":"Canada","common":"Canada"},"por":{"official":"Canadá","common":"Canadá"},"rus":{"official":"Канада","common":"Канада"},"slk":{"official":"Kanada","common":"Kanada"},"spa":{"official":"Canadá","common":"Canadá"},"fin":{"official":"Kanada","common":"Kanada"},"est":{"official":"Kanada","common":"Kanada"},"zho":{"official":"加拿大","common":"加拿大"},"pol":{"official":"Kanada","common":"Kanada"},"urd":{"official":"کینیڈا","common":"کینیڈا"},"kor":{"official":"캐나다","common":"캐나다"},"per":{"official":"کانادا","common":"کانادا"}},"latlng":[60,-95],"landlocked":false,"borders":["USA"],"area":9984670,"flag":"🇨🇦","demonyms":{"eng":{"f":"Canadian","m":"Canadian"},"fra":{"f":"Canadienne","m":"Canadien"}}},{"name":{"common":"Cocos (Keeling) Islands","official":"Territory of the Cocos (Keeling) Islands","native":{"eng":{"official":"Territory of the Cocos (Keeling) Islands","common":"Cocos (Keeling) Islands"}}},"tld":[".cc"],"cca2":"CC","ccn3":"166","cca3":"CCK","cioc":"","independent":false,"status":"officially-assigned","currencies":{"AUD":{"name":"Australian dollar","symbol":"$"}},"idd":{"root":"+6","suffixes":["1"]},"capital":["West Island"],"altSpellings":["CC","Keeling Islands","Cocos Islands"],"region":"Oceania","subregion":"Australia and New Zealand","languages":{"eng":"English"},"translations":{"ces":{"official":"Kokosové ostrovy","common":"Kokosové ostrovy"},"cym":{"official":"Tiriogaeth yr Ynysoedd Cocos (Keeling)","common":"Ynysoedd Cocos"},"deu":{"official":"Gebiet der Kokos- (Keeling-) Inseln","common":"Kokosinseln"},"fra":{"official":"Territoire des îles Cocos (Keeling)","common":"Îles Cocos"},"hrv":{"official":"Teritoriju Kokosovi (Keeling) Islands","common":"Kokosovi Otoci"},"ita":{"official":"Territorio della (Keeling) Isole Cocos","common":"Isole Cocos e Keeling"},"jpn":{"official":"ココス諸島の領土","common":"ココス（キーリング）諸島"},"nld":{"official":"Grondgebied van de Eilanden Cocos (Keeling )","common":"Cocoseilanden"},"por":{"official":"Território dos Cocos (Keeling)","common":"Ilhas Cocos (Keeling)"},"rus":{"official":"Территория Кокосовые (Килинг) острова","common":"Кокосовые острова"},"slk":{"official":"Kokosové ostrovy","common":"Kokosové ostrovy"},"spa":{"official":"Territorio de los (Keeling) Islas Cocos","common":"Islas Cocos o Islas Keeling"},"fin":{"official":"Kookossaaret","common":"Kookossaaret"},"est":{"official":"Kookossaarte ala","common":"Kookossaared"},"zho":{"official":"科科斯","common":"科科斯"},"pol":{"official":"Wyspy Kokosowe","common":"Wyspy Kokosowe"},"urd":{"official":"جزائر (کیلنگ) کوکوس","common":"جزائر کوکوس"},"kor":{"official":"코코스 제도","common":"코코스 제도"},"per":{"official":"جزایر کوکوس","common":"جزایر کوکوس"}},"latlng":[-12.5,96.83333333],"landlocked":false,"borders":[],"area":14,"flag":"🇨🇨","demonyms":{"eng":{"f":"Cocos Islander","m":"Cocos Islander"},"fra":{"f":"","m":""}}},{"name":{"common":"Switzerland","official":"Swiss Confederation","native":{"fra":{"official":"Confédération suisse","common":"Suisse"},"gsw":{"official":"Schweizerische Eidgenossenschaft","common":"Schweiz"},"ita":{"official":"Confederazione Svizzera","common":"Svizzera"},"roh":{"official":"Confederaziun svizra","common":"Svizra"}}},"tld":[".ch"],"cca2":"CH","ccn3":"756","cca3":"CHE","cioc":"SUI","independent":true,"status":"officially-assigned","currencies":{"CHF":{"name":"Swiss franc","symbol":"Fr."}},"idd":{"root":"+4","suffixes":["1"]},"capital":["Bern"],"altSpellings":["CH","Swiss Confederation","Schweiz","Suisse","Svizzera","Svizra"],"region":"Europe","subregion":"Western Europe","languages":{"fra":"French","gsw":"Swiss German","ita":"Italian","roh":"Romansh"},"translations":{"ces":{"official":"Švýcarská konfederace","common":"Švýcarsko"},"deu":{"official":"Schweizerische Eidgenossenschaft","common":"Schweiz"},"fra":{"official":"Confédération suisse","common":"Suisse"},"hrv":{"official":"švicarska Konfederacija","common":"Švicarska"},"ita":{"official":"Confederazione svizzera","common":"Svizzera"},"jpn":{"official":"スイス連邦","common":"スイス"},"nld":{"official":"Zwitserse Confederatie","common":"Zwitserland"},"por":{"official":"Confederação Suíça","common":"Suíça"},"rus":{"official":"Швейцарская Конфедерация","common":"Швейцария"},"slk":{"official":"Švajčiarska konfederácia","common":"Švajčiarsko"},"spa":{"official":"Confederación Suiza","common":"Suiza"},"fin":{"official":"Sveitsin valaliitto","common":"Sveitsi"},"est":{"official":"Šveitsi Konföderatsioon","common":"Šveits"},"zho":{"official":"瑞士联邦","common":"瑞士"},"pol":{"official":"Konfederacja Szwajcarska","common":"Szwajcaria"},"urd":{"official":"سوئیس  متحدہ","common":"سویٹذرلینڈ"},"kor":{"official":"스위스 연방","common":"스위스"},"per":{"official":"کنفدراسیون سوئیس","common":"سوئیس"}},"latlng":[47,8],"landlocked":true,"borders":["AUT","FRA","ITA","LIE","DEU"],"area":41284,"flag":"🇨🇭","demonyms":{"eng":{"f":"Swiss","m":"Swiss"},"fra":{"f":"Suisse","m":"Suisse"}}},{"name":{"common":"Chile","official":"Republic of Chile","native":{"spa":{"official":"República de Chile","common":"Chile"}}},"tld":[".cl"],"cca2":"CL","ccn3":"152","cca3":"CHL","cioc":"CHI","independent":true,"status":"officially-assigned","currencies":{"CLP":{"name":"Chilean peso","symbol":"$"}},"idd":{"root":"+5","suffixes":["6"]},"capital":["Santiago"],"altSpellings":["CL","Republic of Chile","República de Chile"],"region":"Americas","subregion":"South America","languages":{"spa":"Spanish"},"translations":{"ces":{"official":"Chilská republika","common":"Chile"},"cym":{"official":"Gweriniaeth Chile","common":"Chile"},"deu":{"official":"Republik Chile","common":"Chile"},"fra":{"official":"République du Chili","common":"Chili"},"hrv":{"official":"Republika Čile","common":"Čile"},"ita":{"official":"Repubblica del Cile","common":"Cile"},"jpn":{"official":"チリ共和国","common":"チリ"},"nld":{"official":"Republiek Chili","common":"Chili"},"por":{"official":"República do Chile","common":"Chile"},"rus":{"official":"Республика Чили","common":"Чили"},"slk":{"official":"Čílska republika","common":"Čile"},"spa":{"official":"República de Chile","common":"Chile"},"fin":{"official":"Chilen tasavalta","common":"Chile"},"est":{"official":"Tšiili Vabariik","common":"Tšiili"},"zho":{"official":"智利共和国","common":"智利"},"pol":{"official":"Republika Chile","common":"Chile"},"urd":{"official":"جمہوریہ چلی","common":"چلی"},"kor":{"official":"칠레 공화국","common":"칠레"},"per":{"official":"جمهوری شیلی","common":"شیلی"}},"latlng":[-30,-71],"landlocked":false,"borders":["ARG","BOL","PER"],"area":756102,"flag":"🇨🇱","demonyms":{"eng":{"f":"Chilean","m":"Chilean"},"fra":{"f":"Chilienne","m":"Chilien"}}},{"name":{"common":"China","official":"People\'s Republic of China","native":{"zho":{"official":"中华人民共和国","common":"中国"}}},"tld":[".cn",".中国",".中國",".公司",".网络"],"cca2":"CN","ccn3":"156","cca3":"CHN","cioc":"CHN","independent":true,"status":"officially-assigned","currencies":{"CNY":{"name":"Chinese yuan","symbol":"¥"}},"idd":{"root":"+8","suffixes":["6"]},"capital":["Beijing"],"altSpellings":["CN","Zhōngguó","Zhongguo","Zhonghua","People\'s Republic of China","中华人民共和国","Zhōnghuá Rénmín Gònghéguó"],"region":"Asia","subregion":"Eastern Asia","languages":{"zho":"Chinese"},"translations":{"ces":{"official":"Čínská lidová republika","common":"Čína"},"cym":{"official":"Gweriniaeth Pobl Tsieina","common":"Tsieina"},"deu":{"official":"Volksrepublik China","common":"China"},"fra":{"official":"République populaire de Chine","common":"Chine"},"hrv":{"official":"Narodna Republika Kina","common":"Kina"},"ita":{"official":"Repubblica popolare cinese","common":"Cina"},"jpn":{"official":"中華人民共和国","common":"中国"},"nld":{"official":"Volksrepubliek China","common":"China"},"por":{"official":"República Popular da China","common":"China"},"rus":{"official":"Народная Республика Китай","common":"Китай"},"slk":{"official":"Čínska ľudová republika","common":"Čína"},"spa":{"official":"República Popular de China","common":"China"},"fin":{"official":"Kiinan kansantasavalta","common":"Kiina"},"est":{"official":"Hiina Rahvavabariik","common":"Hiina"},"pol":{"official":"Chińska Republika Ludowa","common":"Chiny"},"urd":{"official":"عوامی جمہوریہ چین","common":"چین"},"kor":{"official":"중화인민공화국","common":"중국"},"per":{"official":"جمهوری خلق چین","common":"چین"}},"latlng":[35,105],"landlocked":false,"borders":["AFG","BTN","MMR","HKG","IND","KAZ","NPL","PRK","KGZ","LAO","MAC","MNG","PAK","RUS","TJK","VNM"],"area":9706961,"flag":"🇨🇳","demonyms":{"eng":{"f":"Chinese","m":"Chinese"},"fra":{"f":"Chinoise","m":"Chinois"}}},{"name":{"common":"Ivory Coast","official":"Republic of Côte d\'Ivoire","native":{"fra":{"official":"République de Côte d\'Ivoire","common":"Côte d\'Ivoire"}}},"tld":[".ci"],"cca2":"CI","ccn3":"384","cca3":"CIV","cioc":"CIV","independent":true,"status":"officially-assigned","currencies":{"XOF":{"name":"West African CFA franc","symbol":"Fr"}},"idd":{"root":"+2","suffixes":["25"]},"capital":["Yamoussoukro"],"altSpellings":["CI","Côte d\'Ivoire","Ivory Coast","Republic of Côte d\'Ivoire","République de Côte d\'Ivoire"],"region":"Africa","subregion":"Western Africa","languages":{"fra":"French"},"translations":{"ces":{"official":"Republika Pobřeží slonoviny","common":"Pobřeží slonoviny"},"deu":{"official":"Republik Côte d\'Ivoire","common":"Elfenbeinküste"},"fra":{"official":"République de Côte d\' Ivoire","common":"Côte d\'Ivoire"},"hrv":{"official":"Republika Côte d\'Ivoire","common":"Obala Bjelokosti"},"ita":{"official":"Repubblica della Costa d\'Avorio","common":"Costa d\'Avorio"},"jpn":{"official":"コートジボワール共和国","common":"コートジボワール"},"nld":{"official":"Republiek Ivoorkust","common":"Ivoorkust"},"por":{"official":"República da Côte d\'Ivoire","common":"Costa do Marfim"},"rus":{"official":"Республика Кот-д\'Ивуаре","common":"Кот-д’Ивуар"},"slk":{"official":"Republika Pobrežie Slonoviny","common":"Pobržie Slonoviny"},"spa":{"official":"República de Côte d\'Ivoire","common":"Costa de Marfil"},"fin":{"official":"Norsunluurannikon tasavalta","common":"Norsunluurannikko"},"est":{"official":"Côte d’Ivoire’i Vabariik","common":"Elevandiluurannik"},"zho":{"official":"科特迪瓦共和国","common":"科特迪瓦"},"pol":{"official":"Republika WybrzeŻa Kości Słoniowej","common":"WybrzeŻe Kości Słoniowej"},"urd":{"official":"جمہوریہ کوت دیواغ","common":"آئیوری کوسٹ"},"kor":{"official":"코트디부아르 공화국","common":"코트디부아르"},"per":{"official":"جمهوری ساحل عاج","common":"ساحل عاج"}},"latlng":[8,-5],"landlocked":false,"borders":["BFA","GHA","GIN","LBR","MLI"],"area":322463,"flag":"🇨🇮","demonyms":{"eng":{"f":"Ivorian","m":"Ivorian"},"fra":{"f":"Ivoirienne","m":"Ivoirien"}}},{"name":{"common":"Cameroon","official":"Republic of Cameroon","native":{"eng":{"official":"Republic of Cameroon","common":"Cameroon"},"fra":{"official":"République du Cameroun","common":"Cameroun"}}},"tld":[".cm"],"cca2":"CM","ccn3":"120","cca3":"CMR","cioc":"CMR","independent":true,"status":"officially-assigned","currencies":{"XAF":{"name":"Central African CFA franc","symbol":"Fr"}},"idd":{"root":"+2","suffixes":["37"]},"capital":["Yaoundé"],"altSpellings":["CM","Republic of Cameroon","République du Cameroun"],"region":"Africa","subregion":"Middle Africa","languages":{"eng":"English","fra":"French"},"translations":{"ces":{"official":"Kamerunská republika","common":"Kamerun"},"cym":{"official":"Gweriniaeth Camerŵn","common":"Camerŵn"},"deu":{"official":"Republik Kamerun","common":"Kamerun"},"fra":{"official":"République du Cameroun","common":"Cameroun"},"hrv":{"official":"Republika Kamerun","common":"Kamerun"},"ita":{"official":"Repubblica del Camerun","common":"Camerun"},"jpn":{"official":"カメルーン共和国","common":"カメルーン"},"nld":{"official":"Republiek Kameroen","common":"Kameroen"},"por":{"official":"República dos Camarões","common":"Camarões"},"rus":{"official":"Республика Камерун","common":"Камерун"},"slk":{"official":"Kamerunská republika","common":"Kamerun"},"spa":{"official":"República de Camerún","common":"Camerún"},"fin":{"official":"Kamerunin tasavalta","common":"Kamerun"},"est":{"official":"Kameruni Vabariik","common":"Kamerun"},"zho":{"official":"喀麦隆共和国","common":"喀麦隆"},"pol":{"official":"Republika WybrzeŻa Kości Słoniowej","common":"WybrzeŻe Kości Słoniowej"},"urd":{"official":"جمہوریہ کیمرون","common":"کیمرون"},"kor":{"official":"카메룬 공화국","common":"카메룬"},"per":{"official":"جمهوری کامِرون","common":"کامِرون"}},"latlng":[6,12],"landlocked":false,"borders":["CAF","TCD","COG","GNQ","GAB","NGA"],"area":475442,"flag":"🇨🇲","demonyms":{"eng":{"f":"Cameroonian","m":"Cameroonian"},"fra":{"f":"Camerounaise","m":"Camerounais"}}},{"name":{"common":"DR Congo","official":"Democratic Republic of the Congo","native":{"fra":{"official":"République démocratique du Congo","common":"RD Congo"},"kon":{"official":"Repubilika ya Kongo Demokratiki","common":"Repubilika ya Kongo Demokratiki"},"lin":{"official":"Republiki ya Kongó Demokratiki","common":"Republiki ya Kongó Demokratiki"},"lua":{"official":"Ditunga dia Kongu wa Mungalaata","common":"Ditunga dia Kongu wa Mungalaata"},"swa":{"official":"Jamhuri ya Kidemokrasia ya Kongo","common":"Jamhuri ya Kidemokrasia ya Kongo"}}},"tld":[".cd"],"cca2":"CD","ccn3":"180","cca3":"COD","cioc":"COD","independent":true,"status":"officially-assigned","currencies":{"CDF":{"name":"Congolese franc","symbol":"FC"}},"idd":{"root":"+2","suffixes":["43"]},"capital":["Kinshasa"],"altSpellings":["CD","DR Congo","Congo-Kinshasa","Congo, the Democratic Republic of the","DRC"],"region":"Africa","subregion":"Middle Africa","languages":{"fra":"French","kon":"Kikongo","lin":"Lingala","lua":"Tshiluba","swa":"Swahili"},"translations":{"ces":{"official":"Demokratická republika Kongo","common":"DR Kongo"},"cym":{"official":"Gweriniaeth Ddemocrataidd Congo","common":"Gweriniaeth Ddemocrataidd Congo"},"deu":{"official":"Demokratische Republik Kongo","common":"Kongo (Dem. Rep.)"},"fra":{"official":"République démocratique du Congo","common":"Congo (Rép. dém.)"},"hrv":{"official":"Demokratska Republika Kongo","common":"Kongo, Demokratska Republika"},"ita":{"official":"Repubblica Democratica del Congo","common":"Congo (Rep. Dem.)"},"jpn":{"official":"コンゴ民主共和国","common":"コンゴ民主共和国"},"nld":{"official":"Democratische Republiek Congo","common":"Congo (DRC)"},"por":{"official":"República Democrática do Congo","common":"República Democrática do Congo"},"rus":{"official":"Демократическая Республика Конго","common":"Демократическая Республика Конго"},"slk":{"official":"Konžská demokratická republika","common":"Kongo"},"spa":{"official":"República Democrática del Congo","common":"Congo (Rep. Dem.)"},"fin":{"official":"Kongon demokraattinen tasavalta","common":"Kongon demokraattinen tasavalta"},"est":{"official":"Kongo Demokraatlik Vabariik","common":"Kongo DV"},"zho":{"official":"刚果民主共和国","common":"民主刚果"},"pol":{"official":"Demokratyczna Republika Konga","common":"Demokratyczna Republika Konga"},"urd":{"official":"جمہوری جمہوریہ کانگو","common":"\\nکانگو"},"kor":{"official":"콩고 민주 공화국","common":"콩고 민주 공화국"},"per":{"official":"جمهوری دموکراتیک کنگو","common":"کنگو دموکراتیک"}},"latlng":[0,25],"landlocked":false,"borders":["AGO","BDI","CAF","COG","RWA","SSD","TZA","UGA","ZMB"],"area":2344858,"flag":"🇨🇩","demonyms":{"eng":{"f":"Congolese","m":"Congolese"},"fra":{"f":"Congolaise","m":"Congolais"}}},{"name":{"common":"Republic of the Congo","official":"Republic of the Congo","native":{"fra":{"official":"République du Congo","common":"République du Congo"},"kon":{"official":"Repubilika ya Kongo","common":"Repubilika ya Kongo"},"lin":{"official":"Republíki ya Kongó","common":"Republíki ya Kongó"}}},"tld":[".cg"],"cca2":"CG","ccn3":"178","cca3":"COG","cioc":"CGO","independent":true,"status":"officially-assigned","currencies":{"XAF":{"name":"Central African CFA franc","symbol":"Fr"}},"idd":{"root":"+2","suffixes":["42"]},"capital":["Brazzaville"],"altSpellings":["CG","Congo","Congo-Brazzaville"],"region":"Africa","subregion":"Middle Africa","languages":{"fra":"French","kon":"Kikongo","lin":"Lingala"},"translations":{"ces":{"official":"Konžská republika","common":"Kongo"},"cym":{"official":"Gweriniaeth y Congo","common":"Gweriniaeth y Congo"},"deu":{"official":"Republik Kongo","common":"Kongo"},"fra":{"official":"République du Congo","common":"Congo"},"hrv":{"official":"Republika Kongo","common":"Kongo"},"ita":{"official":"Repubblica del Congo","common":"Congo"},"jpn":{"official":"コンゴ共和国","common":"コンゴ共和国"},"nld":{"official":"Republiek Congo","common":"Congo"},"por":{"official":"República do Congo","common":"Congo"},"rus":{"official":"Республика Конго","common":"Республика Конго"},"slk":{"official":"Konžská republika","common":"Kongo"},"spa":{"official":"República del Congo","common":"Congo"},"fin":{"official":"Kongon tasavalta","common":"Kongo-Brazzaville"},"est":{"official":"Kongo Vabariik","common":"Kongo Vabariik"},"zho":{"official":"刚果共和国","common":"刚果"},"pol":{"official":"Republika Konga","common":"Kongo"},"urd":{"official":"جمہوریہ کانگو","common":"جمہوریہ کانگو"},"kor":{"official":"콩고","common":"콩고"},"per":{"official":"جمهوری برازاویل کُنگو","common":"جمهوری کُنگو"}},"latlng":[-1,15],"landlocked":false,"borders":["AGO","CMR","CAF","COD","GAB"],"area":342000,"flag":"🇨🇬","demonyms":{"eng":{"f":"Congolese","m":"Congolese"},"fra":{"f":"Congolaise","m":"Congolais"}}},{"name":{"common":"Cook Islands","official":"Cook Islands","native":{"eng":{"official":"Cook Islands","common":"Cook Islands"},"rar":{"official":"Kūki \'Āirani","common":"Kūki \'Āirani"}}},"tld":[".ck"],"cca2":"CK","ccn3":"184","cca3":"COK","cioc":"COK","independent":false,"status":"officially-assigned","currencies":{"CKD":{"name":"Cook Islands dollar","symbol":"$"},"NZD":{"name":"New Zealand dollar","symbol":"$"}},"idd":{"root":"+6","suffixes":["82"]},"capital":["Avarua"],"altSpellings":["CK","Kūki \'Āirani"],"region":"Oceania","subregion":"Polynesia","languages":{"eng":"English","rar":"Cook Islands Māori"},"translations":{"ces":{"official":"Cookovy ostrovy","common":"Cookovy ostrovy"},"cym":{"official":"Ynysoedd Cook","common":"Ynysoedd Cook"},"deu":{"official":"Cookinseln","common":"Cookinseln"},"fra":{"official":"Îles Cook","common":"Îles Cook"},"hrv":{"official":"Cook Islands","common":"Cookovo Otočje"},"ita":{"official":"Isole Cook","common":"Isole Cook"},"jpn":{"official":"クック諸島","common":"クック諸島"},"nld":{"official":"Cook eilanden","common":"Cookeilanden"},"por":{"official":"Ilhas Cook","common":"Ilhas Cook"},"rus":{"official":"острова Кука","common":"Острова Кука"},"slk":{"official":"Cookove ostrovy","common":"Cookove ostrovy"},"spa":{"official":"Islas Cook","common":"Islas Cook"},"fin":{"official":"Cookinsaaret","common":"Cookinsaaret"},"est":{"official":"Cooki saared","common":"Cooki saared"},"zho":{"official":"库克群岛","common":"库克群岛"},"pol":{"official":"Wyspy Cooka","common":"Wyspy Cooka"},"urd":{"official":"جزائر کک","common":"جزائر کک"},"kor":{"official":"쿡 제도","common":"쿡 제도"},"per":{"official":"جزایر کوک","common":"جزایر کوک"}},"latlng":[-21.23333333,-159.76666666],"landlocked":false,"borders":[],"area":236,"flag":"🇨🇰","demonyms":{"eng":{"f":"Cook Islander","m":"Cook Islander"},"fra":{"f":"Cookienne","m":"Cookien"}}},{"name":{"common":"Colombia","official":"Republic of Colombia","native":{"spa":{"official":"República de Colombia","common":"Colombia"}}},"tld":[".co"],"cca2":"CO","ccn3":"170","cca3":"COL","cioc":"COL","independent":true,"status":"officially-assigned","currencies":{"COP":{"name":"Colombian peso","symbol":"$"}},"idd":{"root":"+5","suffixes":["7"]},"capital":["Bogotá"],"altSpellings":["CO","Republic of Colombia","República de Colombia"],"region":"Americas","subregion":"South America","languages":{"spa":"Spanish"},"translations":{"ces":{"official":"Kolumbijská republika","common":"Kolumbie"},"cym":{"official":"Gweriniaeth Colombia","common":"Colombia"},"deu":{"official":"Republik Kolumbien","common":"Kolumbien"},"fra":{"official":"République de Colombie","common":"Colombie"},"hrv":{"official":"Republika Kolumbija","common":"Kolumbija"},"ita":{"official":"Repubblica di Colombia","common":"Colombia"},"jpn":{"official":"コロンビア共和国","common":"コロンビア"},"nld":{"official":"Republiek Colombia","common":"Colombia"},"por":{"official":"República da Colômbia","common":"Colômbia"},"rus":{"official":"Республика Колумбия","common":"Колумбия"},"slk":{"official":"Kolumbijská republika","common":"Kolumbia"},"spa":{"official":"República de Colombia","common":"Colombia"},"fin":{"official":"Kolumbian tasavalta","common":"Kolumbia"},"est":{"official":"Colombia Vabariik","common":"Colombia"},"zho":{"official":"哥伦比亚共和国","common":"哥伦比亚"},"pol":{"official":"Republika Kolumbii","common":"Kolumbia"},"urd":{"official":"جمہوریہ کولمبیا","common":"کولمبیا"},"kor":{"official":"콜롬비아 공화국","common":"콜롬비아"},"per":{"official":"جمهوری کلمبیا","common":"کلمبیا"}},"latlng":[4,-72],"landlocked":false,"borders":["BRA","ECU","PAN","PER","VEN"],"area":1141748,"flag":"🇨🇴","demonyms":{"eng":{"f":"Colombian","m":"Colombian"},"fra":{"f":"Colombienne","m":"Colombien"}}},{"name":{"common":"Comoros","official":"Union of the Comoros","native":{"ara":{"official":"الاتحاد القمري","common":"القمر‎"},"fra":{"official":"Union des Comores","common":"Comores"},"zdj":{"official":"Udzima wa Komori","common":"Komori"}}},"tld":[".km"],"cca2":"KM","ccn3":"174","cca3":"COM","cioc":"COM","independent":true,"status":"officially-assigned","currencies":{"KMF":{"name":"Comorian franc","symbol":"Fr"}},"idd":{"root":"+2","suffixes":["69"]},"capital":["Moroni"],"altSpellings":["KM","Union of the Comoros","Union des Comores","Udzima wa Komori","al-Ittiḥād al-Qumurī"],"region":"Africa","subregion":"Eastern Africa","languages":{"ara":"Arabic","fra":"French","zdj":"Comorian"},"translations":{"ces":{"official":"Komorský svaz","common":"Komory"},"cym":{"official":"Undeb y Comoros","common":"Y Comoros"},"deu":{"official":"Union der Komoren","common":"Komoren"},"fra":{"official":"Union des Comores","common":"Comores"},"hrv":{"official":"Savez Komori","common":"Komori"},"ita":{"official":"Unione delle Comore","common":"Comore"},"jpn":{"official":"コモロ連合","common":"コモロ"},"nld":{"official":"Unie van de Comoren","common":"Comoren"},"por":{"official":"União das Comores","common":"Comores"},"rus":{"official":"Союз Коморских Островов","common":"Коморы"},"slk":{"official":"Komorská únia","common":"Komory"},"spa":{"official":"Unión de las Comoras","common":"Comoras"},"fin":{"official":"Komorien liitto","common":"Komorit"},"est":{"official":"Komoori Liit","common":"Komoorid"},"zho":{"official":"科摩罗联盟","common":"科摩罗"},"pol":{"official":"Związek Komorów","common":"Komory"},"urd":{"official":"اتحاد القمری","common":"القمری"},"kor":{"official":"코모로 연방","common":"코모로"},"per":{"official":"مجمع‌الجزایر قمر","common":"اتحاد قُمُر"}},"latlng":[-12.16666666,44.25],"landlocked":false,"borders":[],"area":1862,"flag":"🇰🇲","demonyms":{"eng":{"f":"Comoran","m":"Comoran"},"fra":{"f":"Comorienne","m":"Comorien"}}},{"name":{"common":"Cape Verde","official":"Republic of Cabo Verde","native":{"por":{"official":"República de Cabo Verde","common":"Cabo Verde"}}},"tld":[".cv"],"cca2":"CV","ccn3":"132","cca3":"CPV","cioc":"CPV","independent":true,"status":"officially-assigned","currencies":{"CVE":{"name":"Cape Verdean escudo","symbol":"Esc"}},"idd":{"root":"+2","suffixes":["38"]},"capital":["Praia"],"altSpellings":["CV","Republic of Cabo Verde","República de Cabo Verde"],"region":"Africa","subregion":"Western Africa","languages":{"por":"Portuguese"},"translations":{"ces":{"official":"Kapverdská republika","common":"Kapverdy"},"cym":{"official":"Gweriniaeth Cabo Verde","common":"Penrhyn Verde"},"deu":{"official":"Republik Cabo Verde","common":"Kap Verde"},"fra":{"official":"République du Cap-Vert","common":"Îles du Cap-Vert"},"hrv":{"official":"Republika Cabo Verde","common":"Zelenortska Republika"},"ita":{"official":"Repubblica di Capo Verde","common":"Capo Verde"},"jpn":{"official":"カーボベルデ共和国","common":"カーボベルデ"},"nld":{"official":"Republiek van Cabo Verde","common":"Kaapverdië"},"por":{"official":"República de Cabo Verde","common":"Cabo Verde"},"rus":{"official":"Республика Кабо -Верде","common":"Кабо-Верде"},"slk":{"official":"Kapverdská republika","common":"Kapverdy"},"spa":{"official":"República de Cabo Verde","common":"Cabo Verde"},"fin":{"official":"Kap Verden tasavalta","common":"Kap Verde"},"est":{"official":"Cabo Verde Vabariik","common":"Roheneemesaared"},"zho":{"official":"佛得角共和国","common":"佛得角"},"pol":{"official":"Republika Zielonego Przylądka","common":"Republika Zielonego Przylądka"},"urd":{"official":"جمہوریہ کیپ ورڈی","common":"کیپ ورڈی"},"kor":{"official":"카보베르데 공화국","common":"카보베르데"},"per":{"official":"جمهوری کبو ورد","common":"دماغهٔ سبز"}},"latlng":[16,-24],"landlocked":false,"borders":[],"area":4033,"flag":"🇨🇻","demonyms":{"eng":{"f":"Cape Verdian","m":"Cape Verdian"},"fra":{"f":"Cap-verdienne","m":"Cap-verdien"}}},{"name":{"common":"Costa Rica","official":"Republic of Costa Rica","native":{"spa":{"official":"República de Costa Rica","common":"Costa Rica"}}},"tld":[".cr"],"cca2":"CR","ccn3":"188","cca3":"CRI","cioc":"CRC","independent":true,"status":"officially-assigned","currencies":{"CRC":{"name":"Costa Rican colón","symbol":"₡"}},"idd":{"root":"+5","suffixes":["06"]},"capital":["San José"],"altSpellings":["CR","Republic of Costa Rica","República de Costa Rica"],"region":"Americas","subregion":"Central America","languages":{"spa":"Spanish"},"translations":{"ces":{"official":"Kostarická republika","common":"Kostarika"},"cym":{"official":"Gweriniaeth Costa Rica","common":"Costa Rica"},"deu":{"official":"Republik Costa Rica","common":"Costa Rica"},"fra":{"official":"République du Costa Rica","common":"Costa Rica"},"hrv":{"official":"Republika Kostarika","common":"Kostarika"},"ita":{"official":"Repubblica di Costa Rica","common":"Costa Rica"},"jpn":{"official":"コスタリカ共和国","common":"コスタリカ"},"nld":{"official":"Republiek Costa Rica","common":"Costa Rica"},"por":{"official":"República da Costa Rica","common":"Costa Rica"},"rus":{"official":"Республика Коста-Рика","common":"Коста-Рика"},"slk":{"official":"Kostarická republika","common":"Kostarika"},"spa":{"official":"República de Costa Rica","common":"Costa Rica"},"fin":{"official":"Costa Rican tasavalta","common":"Costa Rica"},"est":{"official":"Costa Rica Vabariik","common":"Costa Rica"},"zho":{"official":"哥斯达黎加共和国","common":"哥斯达黎加"},"pol":{"official":"Republika Kostaryki","common":"Kostaryka"},"urd":{"official":"جمہوریہ کوسٹاریکا","common":"کوسٹاریکا"},"kor":{"official":"코스타리카 공화국","common":"코스타리카"},"per":{"official":"جمهوری کاستاریکا","common":"کاستاریکا"}},"latlng":[10,-84],"landlocked":false,"borders":["NIC","PAN"],"area":51100,"flag":"🇨🇷","demonyms":{"eng":{"f":"Costa Rican","m":"Costa Rican"},"fra":{"f":"Costaricaine","m":"Costaricain"}}},{"name":{"common":"Cuba","official":"Republic of Cuba","native":{"spa":{"official":"República de Cuba","common":"Cuba"}}},"tld":[".cu"],"cca2":"CU","ccn3":"192","cca3":"CUB","cioc":"CUB","independent":true,"status":"officially-assigned","currencies":{"CUC":{"name":"Cuban convertible peso","symbol":"$"},"CUP":{"name":"Cuban peso","symbol":"$"}},"idd":{"root":"+5","suffixes":["3"]},"capital":["Havana"],"altSpellings":["CU","Republic of Cuba","República de Cuba"],"region":"Americas","subregion":"Caribbean","languages":{"spa":"Spanish"},"translations":{"ces":{"official":"Kubánská republika","common":"Kuba"},"cym":{"official":"Gweriniaeth Ciwba","common":"Ciwba"},"deu":{"official":"Republik Kuba","common":"Kuba"},"fra":{"official":"République de Cuba","common":"Cuba"},"hrv":{"official":"Republika Kuba","common":"Kuba"},"ita":{"official":"Repubblica di Cuba","common":"Cuba"},"jpn":{"official":"キューバ共和国","common":"キューバ"},"nld":{"official":"Republiek Cuba","common":"Cuba"},"por":{"official":"República de Cuba","common":"Cuba"},"rus":{"official":"Республика Куба","common":"Куба"},"slk":{"official":"Kubánska republika","common":"Kuba"},"spa":{"official":"República de Cuba","common":"Cuba"},"fin":{"official":"Kuuban tasavalta","common":"Kuuba"},"est":{"official":"Kuuba Vabariik","common":"Kuuba"},"zho":{"official":"古巴共和国","common":"古巴"},"pol":{"official":"Republika Kuby","common":"Kuba"},"urd":{"official":"جمہوریہ کیوبا","common":"کیوبا"},"kor":{"official":"쿠바 공화국","common":"쿠바"},"per":{"official":"جمهوری کوبا","common":"کوبا"}},"latlng":[21.5,-80],"landlocked":false,"borders":[],"area":109884,"flag":"🇨🇺","demonyms":{"eng":{"f":"Cuban","m":"Cuban"},"fra":{"f":"Cubaine","m":"Cubain"}}},{"name":{"common":"Curaçao","official":"Country of Curaçao","native":{"eng":{"official":"Country of Curaçao","common":"Curaçao"},"nld":{"official":"Land Curaçao","common":"Curaçao"},"pap":{"official":"Pais Kòrsou","common":"Pais Kòrsou"}}},"tld":[".cw"],"cca2":"CW","ccn3":"531","cca3":"CUW","cioc":"","independent":false,"status":"officially-assigned","currencies":{"ANG":{"name":"Netherlands Antillean guilder","symbol":"ƒ"}},"idd":{"root":"+5","suffixes":["99"]},"capital":["Willemstad"],"altSpellings":["CW","Curacao","Kòrsou","Country of Curaçao","Land Curaçao","Pais Kòrsou"],"region":"Americas","subregion":"Caribbean","languages":{"eng":"English","nld":"Dutch","pap":"Papiamento"},"translations":{"ces":{"official":"Autonomní země Curaçao","common":"Curaçao"},"deu":{"official":"Land Curaçao","common":"Curaçao"},"fra":{"official":"Pays de Curaçao","common":"Curaçao"},"ita":{"official":"Paese di Curaçao","common":"Curaçao"},"nld":{"official":"Land Curaçao","common":"Curaçao"},"por":{"official":"País de Curaçao","common":"ilha da Curação"},"rus":{"official":"Страна Кюрасао","common":"Кюрасао"},"slk":{"official":"Curacao","common":"Curacao"},"spa":{"official":"País de Curazao","common":"Curazao"},"fin":{"official":"Curaçao","common":"Curaçao"},"est":{"official":"Curaçao","common":"Curaçao"},"zho":{"official":"库拉索","common":"库拉索"},"pol":{"official":"Curaçao","common":"Curaçao"},"urd":{"official":"مملکتِ کیوراساؤ","common":"کیوراساؤ"},"kor":{"official":"퀴라소","common":"퀴라소"},"per":{"official":"کوراسائو","common":"کوراسائو"}},"latlng":[12.116667,-68.933333],"landlocked":false,"borders":[],"area":444,"flag":"🇨🇼","demonyms":{"eng":{"f":"Curaçaoan","m":"Curaçaoan"},"fra":{"f":"Curacienne","m":"Curacien"}}},{"name":{"common":"Christmas Island","official":"Territory of Christmas Island","native":{"eng":{"official":"Territory of Christmas Island","common":"Christmas Island"}}},"tld":[".cx"],"cca2":"CX","ccn3":"162","cca3":"CXR","cioc":"","independent":false,"status":"officially-assigned","currencies":{"AUD":{"name":"Australian dollar","symbol":"$"}},"idd":{"root":"+6","suffixes":["1"]},"capital":["Flying Fish Cove"],"altSpellings":["CX","Territory of Christmas Island"],"region":"Oceania","subregion":"Australia and New Zealand","languages":{"eng":"English"},"translations":{"ces":{"official":"Teritorium Vánočního ostrova","common":"Vánoční ostrov"},"cym":{"official":"Tiriogaeth yr Ynys y Nadolig","common":"Ynys y Nadolig"},"deu":{"official":"Gebiet der Weihnachtsinsel","common":"Weihnachtsinsel"},"fra":{"official":"Territoire de l\'île Christmas","common":"Île Christmas"},"hrv":{"official":"Teritorij Božićni otok","common":"Božićni otok"},"ita":{"official":"Territorio di Christmas Island","common":"Isola di Natale"},"jpn":{"official":"クリスマス島の領土","common":"クリスマス島"},"nld":{"official":"Grondgebied van Christmas Island","common":"Christmaseiland"},"por":{"official":"Território da Ilha Christmas","common":"Ilha do Natal"},"rus":{"official":"Территория острова Рождества","common":"Остров Рождества"},"slk":{"official":"Teritórium Vianočného ostrova","common":"Vianočnú ostrov"},"spa":{"official":"Territorio de la Isla de Navidad","common":"Isla de Navidad"},"fin":{"official":"Joulusaaren alue","common":"Joulusaari"},"est":{"official":"Jõulusaare ala","common":"Jõulusaar"},"zho":{"official":"圣诞岛","common":"圣诞岛"},"pol":{"official":"Wyspa Bożego Narodzenia","common":"Wyspa Bożego Narodzenia"},"urd":{"official":"ریاستِ جزیرہ کرسمس","common":"جزیرہ کرسمس"},"kor":{"official":"크리스마스 섬","common":"크리스마스 섬"},"per":{"official":"جزیرهٔ کریسمس","common":"جزیرهٔ کریسمس"}},"latlng":[-10.5,105.66666666],"landlocked":false,"borders":[],"area":135,"flag":"🇨🇽","demonyms":{"eng":{"f":"Christmas Islander","m":"Christmas Islander"},"fra":{"f":"","m":""}}},{"name":{"common":"Cayman Islands","official":"Cayman Islands","native":{"eng":{"official":"Cayman Islands","common":"Cayman Islands"}}},"tld":[".ky"],"cca2":"KY","ccn3":"136","cca3":"CYM","cioc":"CAY","independent":false,"status":"officially-assigned","currencies":{"KYD":{"name":"Cayman Islands dollar","symbol":"$"}},"idd":{"root":"+1","suffixes":["345"]},"capital":["George Town"],"altSpellings":["KY"],"region":"Americas","subregion":"Caribbean","languages":{"eng":"English"},"translations":{"ces":{"official":"Kajmanské ostrovy","common":"Kajmanské ostrovy"},"cym":{"official":"Ynysoedd Cayman","common":"Ynysoedd Cayman"},"deu":{"official":"Cayman-Inseln","common":"Kaimaninseln"},"fra":{"official":"Îles Caïmans","common":"Îles Caïmans"},"hrv":{"official":"Kajmanski otoci","common":"Kajmanski otoci"},"ita":{"official":"Isole Cayman","common":"Isole Cayman"},"jpn":{"official":"ケイマン諸島","common":"ケイマン諸島"},"nld":{"official":"Caymaneilanden","common":"Caymaneilanden"},"por":{"official":"Ilhas Cayman","common":"Ilhas Caimão"},"rus":{"official":"Каймановы острова","common":"Каймановы острова"},"slk":{"official":"Kajmanie ostrovy","common":"Kajmanie ostrovy"},"spa":{"official":"Islas Caimán","common":"Islas Caimán"},"fin":{"official":"Caymansaaret","common":"Caymansaaret"},"est":{"official":"Kaimanisaared","common":"Kaimanisaared"},"zho":{"official":"开曼群岛","common":"开曼群岛"},"pol":{"official":"Kajmany","common":"Kajmany"},"urd":{"official":"جزائر کیمین","common":"جزائر کیمین"},"kor":{"official":"케이맨 제도","common":"케이맨 제도"},"per":{"official":"جزایر کیمن","common":"جزایر کیمن"}},"latlng":[19.5,-80.5],"landlocked":false,"borders":[],"area":264,"flag":"🇰🇾","demonyms":{"eng":{"f":"Caymanian","m":"Caymanian"},"fra":{"f":"Caïmanienne","m":"Caïmanien"}}},{"name":{"common":"Cyprus","official":"Republic of Cyprus","native":{"ell":{"official":"Δημοκρατία της Κύπρος","common":"Κύπρος"},"tur":{"official":"Kıbrıs Cumhuriyeti","common":"Kıbrıs"}}},"tld":[".cy"],"cca2":"CY","ccn3":"196","cca3":"CYP","cioc":"CYP","independent":true,"status":"officially-assigned","currencies":{"EUR":{"name":"Euro","symbol":"€"}},"idd":{"root":"+3","suffixes":["57"]},"capital":["Nicosia"],"altSpellings":["CY","Kýpros","Kıbrıs","Republic of Cyprus","Κυπριακή Δημοκρατία","Kıbrıs Cumhuriyeti"],"region":"Europe","subregion":"Eastern Europe","languages":{"ell":"Greek","tur":"Turkish"},"translations":{"ces":{"official":"Kyperská republika","common":"Kypr"},"cym":{"official":"Gweriniaeth Cyprus","common":"Cyprus"},"deu":{"official":"Republik Zypern","common":"Zypern"},"fra":{"official":"République de Chypre","common":"Chypre"},"hrv":{"official":"Republika Cipar","common":"Cipar"},"ita":{"official":"Repubblica di Cipro","common":"Cipro"},"jpn":{"official":"キプロス共和国","common":"キプロス"},"nld":{"official":"Republiek Cyprus","common":"Cyprus"},"por":{"official":"República de Chipre","common":"Chipre"},"rus":{"official":"Республика Кипр","common":"Кипр"},"slk":{"official":"Cyperská republika","common":"Cyprus"},"spa":{"official":"República de Chipre","common":"Chipre"},"fin":{"official":"Kyproksen tasavalta","common":"Kypros"},"est":{"official":"Küprose Vabariik","common":"Küpros"},"zho":{"official":"塞浦路斯共和国","common":"塞浦路斯"},"pol":{"official":"Republika Cypryjska","common":"Cypr"},"urd":{"official":"جمہوریہ قبرص","common":"قبرص"},"kor":{"official":"키프로스 공화국","common":"키프로스"},"per":{"official":"جمهوری قبرس","common":"قِبرِس"}},"latlng":[35,33],"landlocked":false,"borders":[],"area":9251,"flag":"🇨🇾","demonyms":{"eng":{"f":"Cypriot","m":"Cypriot"},"fra":{"f":"Chypriote","m":"Chypriote"}}},{"name":{"common":"Czechia","official":"Czech Republic","native":{"ces":{"official":"česká republika","common":"Česko"},"slk":{"official":"Česká republika","common":"Česko"}}},"tld":[".cz"],"cca2":"CZ","ccn3":"203","cca3":"CZE","cioc":"CZE","independent":true,"status":"officially-assigned","currencies":{"CZK":{"name":"Czech koruna","symbol":"Kč"}},"idd":{"root":"+4","suffixes":["20"]},"capital":["Prague"],"altSpellings":["CZ","Česká republika","Česko"],"region":"Europe","subregion":"Eastern Europe","languages":{"ces":"Czech","slk":"Slovak"},"translations":{"ces":{"official":"Česká republika","common":"Česko"},"cym":{"official":"Y Weriniaeth Tsiec","common":"Y Weriniaeth Tsiec"},"deu":{"official":"Tschechische Republik","common":"Tschechien"},"fra":{"official":"République tchèque","common":"Tchéquie"},"hrv":{"official":"Češka","common":"Češka"},"ita":{"official":"Repubblica Ceca","common":"Cechia"},"jpn":{"official":"チェコ共和国","common":"チェコ"},"nld":{"official":"Tsjechische Republiek","common":"Tsjechië"},"por":{"official":"República Checa","common":"Chéquia"},"rus":{"official":"Чешская Республика","common":"Чехия"},"slk":{"official":"Česká republika","common":"Česko"},"spa":{"official":"República Checa","common":"Chequia"},"fin":{"official":"Tšekin tasavalta","common":"Tšekki"},"est":{"official":"Tšehhi Vabariik","common":"Tšehhi"},"zho":{"official":"捷克共和国","common":"捷克"},"pol":{"official":"Republika Czeska","common":"Czechy"},"urd":{"official":"چيک جمہوريہ","common":"چيک"},"kor":{"official":"체코","common":"체코"},"per":{"official":"جمهوری چک","common":"جمهوری چک"}},"latlng":[49.75,15.5],"landlocked":true,"borders":["AUT","DEU","POL","SVK"],"area":78865,"flag":"🇨🇿","demonyms":{"eng":{"f":"Czech","m":"Czech"},"fra":{"f":"Tchèque","m":"Tchèque"}}},{"name":{"common":"Germany","official":"Federal Republic of Germany","native":{"deu":{"official":"Bundesrepublik Deutschland","common":"Deutschland"}}},"tld":[".de"],"cca2":"DE","ccn3":"276","cca3":"DEU","cioc":"GER","independent":true,"status":"officially-assigned","currencies":{"EUR":{"name":"Euro","symbol":"€"}},"idd":{"root":"+4","suffixes":["9"]},"capital":["Berlin"],"altSpellings":["DE","Federal Republic of Germany","Bundesrepublik Deutschland"],"region":"Europe","subregion":"Western Europe","languages":{"deu":"German"},"translations":{"ces":{"official":"Spolková republika Německo","common":"Německo"},"deu":{"official":"Bundesrepublik Deutschland","common":"Deutschland"},"fra":{"official":"République fédérale d\'Allemagne","common":"Allemagne"},"hrv":{"official":"Njemačka Federativna Republika","common":"Njemačka"},"ita":{"official":"Repubblica federale di Germania","common":"Germania"},"jpn":{"official":"ドイツ連邦共和国","common":"ドイツ"},"nld":{"official":"Bondsrepubliek Duitsland","common":"Duitsland"},"por":{"official":"República Federal da Alemanha","common":"Alemanha"},"rus":{"official":"Федеративная Республика Германия","common":"Германия"},"slk":{"official":"Nemecká spolková republika","common":"Nemecko"},"spa":{"official":"República Federal de Alemania","common":"Alemania"},"fin":{"official":"Saksan liittotasavalta","common":"Saksa"},"est":{"official":"Saksamaa Liitvabariik","common":"Saksamaa"},"zho":{"official":"德意志联邦共和国","common":"德国"},"pol":{"official":"Republika Federalna Niemiec","common":"Niemcy"},"urd":{"official":"وفاقی جمہوریہ جرمنی","common":"جرمنی"},"kor":{"official":"독일 연방 공화국","common":"독일"},"per":{"official":"جمهوری فدرال آلمان","common":"آلمان"}},"latlng":[51,9],"landlocked":false,"borders":["AUT","BEL","CZE","DNK","FRA","LUX","NLD","POL","CHE"],"area":357114,"flag":"🇩🇪","demonyms":{"eng":{"f":"German","m":"German"},"fra":{"f":"Allemande","m":"Allemand"}}},{"name":{"common":"Djibouti","official":"Republic of Djibouti","native":{"ara":{"official":"جمهورية جيبوتي","common":"جيبوتي‎"},"fra":{"official":"République de Djibouti","common":"Djibouti"}}},"tld":[".dj"],"cca2":"DJ","ccn3":"262","cca3":"DJI","cioc":"DJI","independent":true,"status":"officially-assigned","currencies":{"DJF":{"name":"Djiboutian franc","symbol":"Fr"}},"idd":{"root":"+2","suffixes":["53"]},"capital":["Djibouti"],"altSpellings":["DJ","Jabuuti","Gabuuti","Republic of Djibouti","République de Djibouti","Gabuutih Ummuuno","Jamhuuriyadda Jabuuti"],"region":"Africa","subregion":"Eastern Africa","languages":{"ara":"Arabic","fra":"French"},"translations":{"ces":{"official":"Džibutská republika","common":"Džibutsko"},"cym":{"official":"Gweriniaeth Jibwti","common":"Jibwti"},"deu":{"official":"Republik Dschibuti","common":"Dschibuti"},"fra":{"official":"République de Djibouti","common":"Djibouti"},"hrv":{"official":"Republika Džibuti","common":"Džibuti"},"ita":{"official":"Repubblica di Gibuti","common":"Gibuti"},"jpn":{"official":"ジブチ共和国","common":"ジブチ"},"nld":{"official":"Republiek Djibouti","common":"Djibouti"},"por":{"official":"República do Djibouti","common":"Djibouti"},"rus":{"official":"Республика Джибути","common":"Джибути"},"slk":{"official":"ǅibutská republika","common":"ǅibutsko"},"spa":{"official":"República de Djibouti","common":"Djibouti"},"fin":{"official":"Dijiboutin tasavalta","common":"Dijibouti"},"est":{"official":"Djibouti Vabariik","common":"Djibouti"},"zho":{"official":"吉布提共和国","common":"吉布提"},"pol":{"official":"Republika Dżibuti","common":"Dżibuti"},"urd":{"official":"جمہوریہ جبوتی","common":"جبوتی"},"kor":{"official":"지부티 공화국","common":"지부티"},"per":{"official":"جمهوری جیبوتی","common":"جیبوتی"}},"latlng":[11.5,43],"landlocked":false,"borders":["ERI","ETH","SOM"],"area":23200,"flag":"🇩🇯","demonyms":{"eng":{"f":"Djibouti","m":"Djibouti"},"fra":{"f":"Djiboutienne","m":"Djiboutien"}}},{"name":{"common":"Dominica","official":"Commonwealth of Dominica","native":{"eng":{"official":"Commonwealth of Dominica","common":"Dominica"}}},"tld":[".dm"],"cca2":"DM","ccn3":"212","cca3":"DMA","cioc":"DMA","independent":true,"status":"officially-assigned","currencies":{"XCD":{"name":"Eastern Caribbean dollar","symbol":"$"}},"idd":{"root":"+1","suffixes":["767"]},"capital":["Roseau"],"altSpellings":["DM","Dominique","Wai‘tu kubuli","Commonwealth of Dominica"],"region":"Americas","subregion":"Caribbean","languages":{"eng":"English"},"translations":{"ces":{"official":"Dominikánské společenství","common":"Dominika"},"cym":{"official":"Cymanwlad Dominica","common":"Dominica"},"deu":{"official":"Commonwealth von Dominica","common":"Dominica"},"fra":{"official":"Commonwealth de la Dominique","common":"Dominique"},"hrv":{"official":"Zajednica Dominika","common":"Dominika"},"ita":{"official":"Commonwealth di Dominica","common":"Dominica"},"jpn":{"official":"ドミニカ国","common":"ドミニカ国"},"nld":{"official":"Gemenebest Dominica","common":"Dominica"},"por":{"official":"Comunidade da Dominica","common":"Dominica"},"rus":{"official":"Содружество Доминики","common":"Доминика"},"slk":{"official":"Dominické spoločenstvo","common":"Dominika"},"spa":{"official":"Mancomunidad de Dominica","common":"Dominica"},"fin":{"official":"Dominican liittovaltio","common":"Dominica"},"est":{"official":"Dominica Ühendus","common":"Dominica"},"zho":{"official":"多米尼加共和国","common":"多米尼加"},"pol":{"official":"Wspólnota Dominiki","common":"Dominika"},"urd":{"official":"دولتِ مشترکہ ڈومینیکا","common":"ڈومینیکا"},"kor":{"official":"도미니카 공화국","common":"도미니카 공화국"},"per":{"official":"قلمرو همسود دومینیکا","common":"دومینیکا"}},"latlng":[15.41666666,-61.33333333],"landlocked":false,"borders":[],"area":751,"flag":"🇩🇲","demonyms":{"eng":{"f":"Dominican","m":"Dominican"},"fra":{"f":"Dominiquaise","m":"Dominiquais"}}},{"name":{"common":"Denmark","official":"Kingdom of Denmark","native":{"dan":{"official":"Kongeriget Danmark","common":"Danmark"}}},"tld":[".dk"],"cca2":"DK","ccn3":"208","cca3":"DNK","cioc":"DEN","independent":true,"status":"officially-assigned","currencies":{"DKK":{"name":"Danish krone","symbol":"kr"}},"idd":{"root":"+4","suffixes":["5"]},"capital":["Copenhagen"],"altSpellings":["DK","Danmark","Kingdom of Denmark","Kongeriget Danmark"],"region":"Europe","subregion":"Northern Europe","languages":{"dan":"Danish"},"translations":{"ces":{"official":"Dánské království","common":"Dánsko"},"cym":{"official":"Teyrnas Denmarc","common":"Denmarc"},"deu":{"official":"Königreich Dänemark","common":"Dänemark"},"fra":{"official":"Royaume du Danemark","common":"Danemark"},"hrv":{"official":"Kraljevina Danska","common":"Danska"},"ita":{"official":"Regno di Danimarca","common":"Danimarca"},"jpn":{"official":"デンマーク王国","common":"デンマーク"},"nld":{"official":"Koninkrijk Denemarken","common":"Denemarken"},"por":{"official":"Reino da Dinamarca","common":"Dinamarca"},"rus":{"official":"Королевство Дания","common":"Дания"},"slk":{"official":"Dánske kráľovstvo","common":"Dánsko"},"spa":{"official":"Reino de Dinamarca","common":"Dinamarca"},"fin":{"official":"Tanskan kuningaskunta","common":"Tanska"},"est":{"official":"Taani Kuningriik","common":"Taani"},"zho":{"official":"丹麦王国","common":"丹麦"},"pol":{"official":"Królestwo Danii","common":"Dania"},"urd":{"official":"مملکتِ ڈنمارک","common":"ڈنمارک"},"kor":{"official":"덴마크 왕국","common":"덴마크"},"per":{"official":"پادشاهی دانمارک","common":"دانمارک"}},"latlng":[56,10],"landlocked":false,"borders":["DEU"],"area":43094,"flag":"🇩🇰","demonyms":{"eng":{"f":"Danish","m":"Danish"},"fra":{"f":"Danoise","m":"Danois"}}},{"name":{"common":"Dominican Republic","official":"Dominican Republic","native":{"spa":{"official":"República Dominicana","common":"República Dominicana"}}},"tld":[".do"],"cca2":"DO","ccn3":"214","cca3":"DOM","cioc":"DOM","independent":true,"status":"officially-assigned","currencies":{"DOP":{"name":"Dominican peso","symbol":"$"}},"idd":{"root":"+1","suffixes":["809","829","849"]},"capital":["Santo Domingo"],"altSpellings":["DO"],"region":"Americas","subregion":"Caribbean","languages":{"spa":"Spanish"},"translations":{"ces":{"official":"Dominikánská republika","common":"Dominikánská republika"},"cym":{"official":"Gweriniaeth Dominica","common":"Gweriniaeth Dominica"},"deu":{"official":"Dominikanische Republik","common":"Dominikanische Republik"},"fra":{"official":"République Dominicaine","common":"République dominicaine"},"hrv":{"official":"Dominikanska Republika","common":"Dominikanska Republika"},"ita":{"official":"Repubblica Dominicana","common":"Repubblica Dominicana"},"jpn":{"official":"ドミニカ共和国","common":"ドミニカ共和国"},"nld":{"official":"Dominicaanse Republiek","common":"Dominicaanse Republiek"},"por":{"official":"República Dominicana","common":"República Dominicana"},"rus":{"official":"Доминиканская Республика","common":"Доминиканская Республика"},"slk":{"official":"Dominikánska republika","common":"Dominikánska republika"},"spa":{"official":"República Dominicana","common":"República Dominicana"},"fin":{"official":"Dominikaaninen tasavalta","common":"Dominikaaninen tasavalta"},"est":{"official":"Dominikaani Vabariik","common":"Dominikaani Vabariik"},"zho":{"official":"多明尼加共和国","common":"多明尼加"},"pol":{"official":"Republika Dominikańska","common":"Dominikana"},"urd":{"official":"جمہوریہ ڈومینیکن","common":"ڈومینیکن"},"kor":{"official":"도미니카 공화국","common":"도미니카 공화국"},"per":{"official":"جمهوری دومینیکن","common":"جمهوری دومینیکن"}},"latlng":[19,-70.66666666],"landlocked":false,"borders":["HTI"],"area":48671,"flag":"🇩🇴","demonyms":{"eng":{"f":"Dominican","m":"Dominican"},"fra":{"f":"Dominicaine","m":"Dominicain"}}},{"name":{"common":"Algeria","official":"People\'s Democratic Republic of Algeria","native":{"ara":{"official":"الجمهورية الديمقراطية الشعبية الجزائرية","common":"الجزائر"}}},"tld":[".dz","الجزائر."],"cca2":"DZ","ccn3":"012","cca3":"DZA","cioc":"ALG","independent":true,"status":"officially-assigned","currencies":{"DZD":{"name":"Algerian dinar","symbol":"د.ج"}},"idd":{"root":"+2","suffixes":["13"]},"capital":["Algiers"],"altSpellings":["DZ","Dzayer","Algérie"],"region":"Africa","subregion":"Northern Africa","languages":{"ara":"Arabic"},"translations":{"ces":{"official":"Alžírská demokratická a lidová republika","common":"Alžírsko"},"cym":{"official":"Gweriniaeth Ddemocrataidd Pobl Algeria","common":"Algeria"},"deu":{"official":"Demokratische Volksrepublik Algerien","common":"Algerien"},"fra":{"official":"République démocratique et populaire d\'Algérie","common":"Algérie"},"hrv":{"official":"Narodna Demokratska Republika Alžir","common":"Alžir"},"ita":{"official":"Repubblica popolare democratica di Algeria","common":"Algeria"},"jpn":{"official":"アルジェリア人民民主共和国","common":"アルジェリア"},"nld":{"official":"Democratische Volksrepubliek Algerije","common":"Algerije"},"por":{"official":"República Argelina Democrática e Popular","common":"Argélia"},"rus":{"official":"Народно-Демократическая Республика Алжир","common":"Алжир"},"slk":{"official":"Alžírska demokratická ľudová republika","common":"Alžírsko"},"spa":{"official":"República Argelina Democrática y Popular","common":"Argelia"},"fin":{"official":"Algerian demokraattinen kansantasavalta","common":"Algeria"},"est":{"official":"Alžeeria Demokraatlik Rahvavabariik","common":"Alžeeria"},"zho":{"official":"阿尔及利亚人民民主共和国","common":"阿尔及利亚"},"pol":{"official":"Algierska Republika Ludowo-Demokratyczna","common":"Algieria"},"urd":{"official":"عوامی جمہوری جمہوریہ الجزائر","common":"الجزائر"},"kor":{"official":"알제리 인민 민주 공화국","common":"알제리"},"per":{"official":"جمهوری دموکراتیک خلق الجزایر","common":"الجزایر"}},"latlng":[28,3],"landlocked":false,"borders":["TUN","LBY","NER","ESH","MRT","MLI","MAR"],"area":2381741,"flag":"🇩🇿","demonyms":{"eng":{"f":"Algerian","m":"Algerian"},"fra":{"f":"Algérienne","m":"Algérien"}}},{"name":{"common":"Ecuador","official":"Republic of Ecuador","native":{"spa":{"official":"República del Ecuador","common":"Ecuador"}}},"tld":[".ec"],"cca2":"EC","ccn3":"218","cca3":"ECU","cioc":"ECU","independent":true,"status":"officially-assigned","currencies":{"USD":{"name":"United States dollar","symbol":"$"}},"idd":{"root":"+5","suffixes":["93"]},"capital":["Quito"],"altSpellings":["EC","Republic of Ecuador","República del Ecuador"],"region":"Americas","subregion":"South America","languages":{"spa":"Spanish"},"translations":{"ces":{"official":"Ekvádorská republika","common":"Ekvádor"},"cym":{"official":"Gweriniaeth Ecwador","common":"Ecwador"},"deu":{"official":"Republik Ecuador","common":"Ecuador"},"fra":{"official":"République de l\'Équateur","common":"Équateur"},"hrv":{"official":"Republika Ekvador","common":"Ekvador"},"ita":{"official":"Repubblica dell\'Ecuador","common":"Ecuador"},"jpn":{"official":"エクアドル共和国","common":"エクアドル"},"nld":{"official":"Republiek Ecuador","common":"Ecuador"},"por":{"official":"República do Equador","common":"Equador"},"rus":{"official":"Республика Эквадор","common":"Эквадор"},"slk":{"official":"Ekvádorská republika","common":"Ekvádor"},"spa":{"official":"República del Ecuador","common":"Ecuador"},"fin":{"official":"Ecuadorin tasavalta","common":"Ecuador"},"est":{"official":"Ecuadori Vabariik","common":"Ecuador"},"zho":{"official":"厄瓜多尔共和国","common":"厄瓜多尔"},"pol":{"official":"Ekwador","common":"Ekwador"},"urd":{"official":"جمہوریہ ایکوڈور","common":"ایکواڈور"},"kor":{"official":"에콰도르 공화국","common":"에콰도르"},"per":{"official":"جمهوری اکوادور","common":"اکوادور"}},"latlng":[-2,-77.5],"landlocked":false,"borders":["COL","PER"],"area":276841,"flag":"🇪🇨","demonyms":{"eng":{"f":"Ecuadorean","m":"Ecuadorean"},"fra":{"f":"Équatorienne","m":"Équatorien"}}},{"name":{"common":"Egypt","official":"Arab Republic of Egypt","native":{"ara":{"official":"جمهورية مصر العربية","common":"مصر"}}},"tld":[".eg",".مصر"],"cca2":"EG","ccn3":"818","cca3":"EGY","cioc":"EGY","independent":true,"status":"officially-assigned","currencies":{"EGP":{"name":"Egyptian pound","symbol":"£"}},"idd":{"root":"+2","suffixes":["0"]},"capital":["Cairo"],"altSpellings":["EG","Arab Republic of Egypt"],"region":"Africa","subregion":"Northern Africa","languages":{"ara":"Arabic"},"translations":{"ces":{"official":"Egyptská arabská republika","common":"Egypt"},"cym":{"official":"Gweriniaeth Arabaidd yr Aifft","common":"Yr Aifft"},"deu":{"official":"Arabische Republik Ägypten","common":"Ägypten"},"fra":{"official":"République arabe d\'Égypte","common":"Égypte"},"hrv":{"official":"Arapska Republika Egipat","common":"Egipat"},"ita":{"official":"Repubblica araba d\'Egitto","common":"Egitto"},"jpn":{"official":"エジプト·アラブ共和国","common":"エジプト"},"nld":{"official":"Arabische Republiek Egypte","common":"Egypte"},"por":{"official":"República Árabe do Egipto","common":"Egito"},"rus":{"official":"Арабская Республика Египет","common":"Египет"},"slk":{"official":"Egyptská arabská republika","common":"Egypt"},"spa":{"official":"República Árabe de Egipto","common":"Egipto"},"fin":{"official":"Egyptin arabitasavalta","common":"Egypti"},"est":{"official":"Egiptuse Araabia Vabariik","common":"Egiptus"},"zho":{"official":"阿拉伯埃及共和国","common":"埃及"},"pol":{"official":"Arabska Republika Egiptu","common":"Egipt"},"urd":{"official":"مصری عرب جمہوریہ","common":"مصر"},"kor":{"official":"이집트 아랍 공화국","common":"이집트"},"per":{"official":"جمهوری عربی مصر","common":"مصر"}},"latlng":[27,30],"landlocked":false,"borders":["ISR","LBY","PSE","SDN"],"area":1002450,"flag":"🇪🇬","demonyms":{"eng":{"f":"Egyptian","m":"Egyptian"},"fra":{"f":"Égyptienne","m":"Égyptien"}}},{"name":{"common":"Eritrea","official":"State of Eritrea","native":{"ara":{"official":"دولة إرتريا","common":"إرتريا‎"},"eng":{"official":"State of Eritrea","common":"Eritrea"},"tir":{"official":"ሃገረ ኤርትራ","common":"ኤርትራ"}}},"tld":[".er"],"cca2":"ER","ccn3":"232","cca3":"ERI","cioc":"ERI","independent":true,"status":"officially-assigned","currencies":{"ERN":{"name":"Eritrean nakfa","symbol":"Nfk"}},"idd":{"root":"+2","suffixes":["91"]},"capital":["Asmara"],"altSpellings":["ER","State of Eritrea","ሃገረ ኤርትራ","Dawlat Iritriyá","ʾErtrā","Iritriyā"],"region":"Africa","subregion":"Eastern Africa","languages":{"ara":"Arabic","eng":"English","tir":"Tigrinya"},"translations":{"ces":{"official":"Stát Eritrea","common":"Eritrea"},"cym":{"official":"Gwladwriaeth Eritrea","common":"Eritrea"},"deu":{"official":"Staat Eritrea","common":"Eritrea"},"fra":{"official":"État d\'Érythrée","common":"Érythrée"},"hrv":{"official":"Država Eritreji","common":"Eritreja"},"ita":{"official":"Stato di Eritrea","common":"Eritrea"},"jpn":{"official":"エリトリア国","common":"エリトリア"},"nld":{"official":"Staat Eritrea","common":"Eritrea"},"por":{"official":"Estado da Eritreia","common":"Eritreia"},"rus":{"official":"Государство Эритрея","common":"Эритрея"},"slk":{"official":"Eritrejský štát","common":"Eritrea"},"spa":{"official":"Estado de Eritrea","common":"Eritrea"},"fin":{"official":"Eritrean valtio","common":"Eritrea"},"est":{"official":"Eritrea Riik","common":"Eritrea"},"zho":{"official":"厄立特里亚","common":"厄立特里亚"},"pol":{"official":"Państwo Erytrea","common":"Erytrea"},"urd":{"official":"ریاستِ ارتریا","common":"ارتریا"},"kor":{"official":"에리트레아국","common":"에리트레아"},"per":{"official":"جمهوری اریتره","common":"اریتره"}},"latlng":[15,39],"landlocked":false,"borders":["DJI","ETH","SDN"],"area":117600,"flag":"🇪🇷","demonyms":{"eng":{"f":"Eritrean","m":"Eritrean"},"fra":{"f":"Érythréenne","m":"Érythréen"}}},{"name":{"common":"Western Sahara","official":"Sahrawi Arab Democratic Republic","native":{"ber":{"official":"Sahrawi Arab Democratic Republic","common":"Western Sahara"},"mey":{"official":"الجمهورية العربية الصحراوية الديمقراطية","common":"الصحراء الغربية"},"spa":{"official":"República Árabe Saharaui Democrática","common":"Sahara Occidental"}}},"tld":[".eh"],"cca2":"EH","ccn3":"732","cca3":"ESH","cioc":"","independent":false,"status":"officially-assigned","currencies":{"DZD":{"name":"Algerian dinar","symbol":"دج"},"MAD":{"name":"Moroccan dirham","symbol":"DH"},"MRU":{"name":"Mauritanian ouguiya","symbol":"UM"}},"idd":{"root":"+2","suffixes":["125288","125289"]},"capital":["El Aaiún"],"altSpellings":["EH","Taneẓroft Tutrimt"],"region":"Africa","subregion":"Northern Africa","languages":{"ber":"Berber","mey":"Hassaniya","spa":"Spanish"},"translations":{"ces":{"official":"Západní Sahara","common":"Západní Sahara"},"deu":{"official":"Demokratische Arabische Republik Sahara","common":"Westsahara"},"fra":{"official":"République arabe sahraouie démocratique","common":"Sahara Occidental"},"hrv":{"official":"Sahrawi Arab Demokratska Republika","common":"Zapadna Sahara"},"ita":{"official":"Repubblica Araba Saharawi Democratica","common":"Sahara Occidentale"},"jpn":{"official":"サハラアラブ民主共和国","common":"西サハラ"},"nld":{"official":"Sahrawi Arabische Democratische Republiek","common":"Westelijke Sahara"},"por":{"official":"República Árabe Saharaui Democrática","common":"Saara Ocidental"},"rus":{"official":"Sahrawi Арабская Демократическая Республика","common":"Западная Сахара"},"slk":{"official":"Západná Sahara","common":"Západná Sahara"},"spa":{"official":"República Árabe Saharaui Democrática","common":"Sahara Occidental"},"fin":{"official":"Länsi-Sahara","common":"Länsi-Sahara"},"est":{"official":"Lääne-Sahara","common":"Lääne-Sahara"},"zho":{"official":"阿拉伯撒哈拉民主共和国","common":"西撒哈拉"},"pol":{"official":"Saharyjska Arabska Republika Demokratyczna","common":"Sahara Zachodnia"},"urd":{"official":"صحراوی عرب عوامی جمہوریہ","common":"مغربی صحارا"},"kor":{"official":"사하라 아랍 민주 공화국","common":"서사하라"},"per":{"official":"صحرای غربی","common":"صحرای غربی"}},"latlng":[24.5,-13],"landlocked":false,"borders":["DZA","MRT","MAR"],"area":266000,"flag":"🇪🇭","demonyms":{"eng":{"f":"Sahrawi","m":"Sahrawi"},"fra":{"f":"","m":""}}},{"name":{"common":"Spain","official":"Kingdom of Spain","native":{"spa":{"official":"Reino de España","common":"España"}}},"tld":[".es"],"cca2":"ES","ccn3":"724","cca3":"ESP","cioc":"ESP","independent":true,"status":"officially-assigned","currencies":{"EUR":{"name":"Euro","symbol":"€"}},"idd":{"root":"+3","suffixes":["4"]},"capital":["Madrid"],"altSpellings":["ES","Kingdom of Spain","Reino de España"],"region":"Europe","subregion":"Southern Europe","languages":{"spa":"Spanish"},"translations":{"ces":{"official":"Španělské království","common":"Španělsko"},"deu":{"official":"Königreich Spanien","common":"Spanien"},"fra":{"official":"Royaume d\'Espagne","common":"Espagne"},"hrv":{"official":"Kraljevina Španjolska","common":"Španjolska"},"ita":{"official":"Regno di Spagna","common":"Spagna"},"jpn":{"official":"スペイン王国","common":"スペイン"},"nld":{"official":"Koninkrijk Spanje","common":"Spanje"},"por":{"official":"Reino de Espanha","common":"Espanha"},"rus":{"official":"Королевство Испания","common":"Испания"},"slk":{"official":"Španielske kráľovstvo","common":"Španielsko"},"spa":{"official":"Reino de España","common":"España"},"fin":{"official":"Espanjan kuningaskunta","common":"Espanja"},"est":{"official":"Hispaania Kuningriik","common":"Hispaania"},"zho":{"official":"西班牙王国","common":"西班牙"},"pol":{"official":"Królestwo Hiszpanii ","common":"Hiszpania"},"urd":{"official":"مملکتِ ہسپانیہ","common":"ہسپانیہ"},"kor":{"official":"에스파냐 왕국","common":"스페인"},"per":{"official":"پادشاهی اسپانیا","common":"اسپانیا"}},"latlng":[40,-4],"landlocked":false,"borders":["AND","FRA","GIB","PRT","MAR"],"area":505992,"flag":"🇪🇸","demonyms":{"eng":{"f":"Spanish","m":"Spanish"},"fra":{"f":"Espagnole","m":"Espagnol"}}},{"name":{"common":"Estonia","official":"Republic of Estonia","native":{"est":{"official":"Eesti Vabariik","common":"Eesti"}}},"tld":[".ee"],"cca2":"EE","ccn3":"233","cca3":"EST","cioc":"EST","independent":true,"status":"officially-assigned","currencies":{"EUR":{"name":"Euro","symbol":"€"}},"idd":{"root":"+3","suffixes":["72"]},"capital":["Tallinn"],"altSpellings":["EE","Eesti","Republic of Estonia","Eesti Vabariik"],"region":"Europe","subregion":"Northern Europe","languages":{"est":"Estonian"},"translations":{"ces":{"official":"Estonská republika","common":"Estonsko"},"cym":{"official":"Gweriniaeth Estonia","common":"Estonia"},"deu":{"official":"Republik Estland","common":"Estland"},"fra":{"official":"République d\'Estonie","common":"Estonie"},"hrv":{"official":"Republika Estonija","common":"Estonija"},"ita":{"official":"Repubblica di Estonia","common":"Estonia"},"jpn":{"official":"エストニア共和国","common":"エストニア"},"nld":{"official":"Republiek Estland","common":"Estland"},"por":{"official":"República da Estónia","common":"Estónia"},"rus":{"official":"Эстонская Республика","common":"Эстония"},"slk":{"official":"Estónska republika","common":"Estónsko"},"spa":{"official":"República de Estonia","common":"Estonia"},"fin":{"official":"Viron tasavalta","common":"Viro"},"est":{"official":"Eesti Vabariik","common":"Eesti"},"zho":{"official":"爱沙尼亚共和国","common":"爱沙尼亚"},"pol":{"official":"Republika Estońska","common":"Estonia"},"urd":{"official":"جمہوریہ اسٹونیا","common":"اسٹونیا"},"kor":{"official":"에스토니아 공화국","common":"에스토니아"},"per":{"official":"جمهوری استونی","common":"اِستونی"}},"latlng":[59,26],"landlocked":false,"borders":["LVA","RUS"],"area":45227,"flag":"🇪🇪","demonyms":{"eng":{"f":"Estonian","m":"Estonian"},"fra":{"f":"Estonienne","m":"Estonien"}}},{"name":{"common":"Ethiopia","official":"Federal Democratic Republic of Ethiopia","native":{"amh":{"official":"የኢትዮጵያ ፌዴራላዊ ዲሞክራሲያዊ ሪፐብሊክ","common":"ኢትዮጵያ"}}},"tld":[".et"],"cca2":"ET","ccn3":"231","cca3":"ETH","cioc":"ETH","independent":true,"status":"officially-assigned","currencies":{"ETB":{"name":"Ethiopian birr","symbol":"Br"}},"idd":{"root":"+2","suffixes":["51"]},"capital":["Addis Ababa"],"altSpellings":["ET","ʾĪtyōṗṗyā","Federal Democratic Republic of Ethiopia","የኢትዮጵያ ፌዴራላዊ ዲሞክራሲያዊ ሪፐብሊክ"],"region":"Africa","subregion":"Eastern Africa","languages":{"amh":"Amharic"},"translations":{"ces":{"official":"Etiopská federativní demokratická republika","common":"Etiopie"},"cym":{"official":"Gweriniaeth Ddemocrataidd Ffederal Ethiopia","common":"Ethiopia"},"deu":{"official":"Demokratische Bundesrepublik Äthiopien","common":"Äthiopien"},"fra":{"official":"République fédérale démocratique d\'Éthiopie","common":"Éthiopie"},"hrv":{"official":"Savezna Demokratska Republika Etiopija","common":"Etiopija"},"ita":{"official":"Repubblica federale democratica di Etiopia","common":"Etiopia"},"jpn":{"official":"エチオピア連邦民主共和国","common":"エチオピア"},"nld":{"official":"Federale Democratische Republiek Ethiopië","common":"Ethiopië"},"por":{"official":"República Federal Democrática da Etiópia","common":"Etiópia"},"rus":{"official":"Федеративная Демократическая Республика Эфиопия","common":"Эфиопия"},"slk":{"official":"Etiópska federatívna demokratická republika","common":"Etiópia"},"spa":{"official":"República Democrática Federal de Etiopía","common":"Etiopía"},"fin":{"official":"Etiopian demokraattinen liittotasavalta","common":"Etiopia"},"est":{"official":"Etioopia Demokraatlik Liitvabariik","common":"Etioopia"},"zho":{"official":"埃塞俄比亚联邦民主共和国","common":"埃塞俄比亚"},"pol":{"official":"Federalna Demokratyczna Republika Etiopii","common":"Etiopia"},"urd":{"official":"وفاقی جمہوری جمہوریہ ایتھوپیا","common":"ایتھوپیا"},"kor":{"official":"에티오피아 연방 민주 공화국","common":"에티오피아"},"per":{"official":"جمهوری فدرال دموکراتیک اتیوپی","common":"اِتیوپی"}},"latlng":[8,38],"landlocked":true,"borders":["DJI","ERI","KEN","SOM","SSD","SDN"],"area":1104300,"flag":"🇪🇹","demonyms":{"eng":{"f":"Ethiopian","m":"Ethiopian"},"fra":{"f":"Éthiopienne","m":"Éthiopien"}}},{"name":{"common":"Finland","official":"Republic of Finland","native":{"fin":{"official":"Suomen tasavalta","common":"Suomi"},"swe":{"official":"Republiken Finland","common":"Finland"}}},"tld":[".fi"],"cca2":"FI","ccn3":"246","cca3":"FIN","cioc":"FIN","independent":true,"status":"officially-assigned","currencies":{"EUR":{"name":"Euro","symbol":"€"}},"idd":{"root":"+3","suffixes":["58"]},"capital":["Helsinki"],"altSpellings":["FI","Suomi","Republic of Finland","Suomen tasavalta","Republiken Finland"],"region":"Europe","subregion":"Northern Europe","languages":{"fin":"Finnish","swe":"Swedish"},"translations":{"ces":{"official":"Finská republika","common":"Finsko"},"deu":{"official":"Republik Finnland","common":"Finnland"},"fra":{"official":"République de Finlande","common":"Finlande"},"hrv":{"official":"Republika Finska","common":"Finska"},"ita":{"official":"Repubblica di Finlandia","common":"Finlandia"},"jpn":{"official":"フィンランド共和国","common":"フィンランド"},"nld":{"official":"Republiek Finland","common":"Finland"},"por":{"official":"República da Finlândia","common":"Finlândia"},"rus":{"official":"Финляндская Республика","common":"Финляндия"},"slk":{"official":"Fínska republika","common":"Fínsko"},"spa":{"official":"República de Finlandia","common":"Finlandia"},"fin":{"official":"Suomen tasavalta","common":"Suomi"},"est":{"official":"Soome Vabariik","common":"Soome"},"zho":{"official":"芬兰共和国","common":"芬兰"},"pol":{"official":"Republika Finlandii","common":"Finlandia"},"urd":{"official":"جمہوریہ فن لینڈ","common":"فن لینڈ"},"kor":{"official":"핀란드 공화국","common":"핀란드"},"per":{"official":"جمهوری فنلاند","common":"فنلاند"}},"latlng":[64,26],"landlocked":false,"borders":["NOR","SWE","RUS"],"area":338424,"flag":"🇫🇮","demonyms":{"eng":{"f":"Finnish","m":"Finnish"},"fra":{"f":"Finlandaise","m":"Finlandais"}}},{"name":{"common":"Fiji","official":"Republic of Fiji","native":{"eng":{"official":"Republic of Fiji","common":"Fiji"},"fij":{"official":"Matanitu Tugalala o Viti","common":"Viti"},"hif":{"official":"रिपब्लिक ऑफ फीजी","common":"फिजी"}}},"tld":[".fj"],"cca2":"FJ","ccn3":"242","cca3":"FJI","cioc":"FIJ","independent":true,"status":"officially-assigned","currencies":{"FJD":{"name":"Fijian dollar","symbol":"$"}},"idd":{"root":"+6","suffixes":["79"]},"capital":["Suva"],"altSpellings":["FJ","Viti","Republic of Fiji","Matanitu ko Viti","Fijī Gaṇarājya"],"region":"Oceania","subregion":"Melanesia","languages":{"eng":"English","fij":"Fijian","hif":"Fiji Hindi"},"translations":{"ces":{"official":"Republika Fidžijských ostrovů","common":"Fidži"},"deu":{"official":"Republik Fidschi","common":"Fidschi"},"fra":{"official":"République des Fidji","common":"Fidji"},"hrv":{"official":"Republika Fidži","common":"Fiđi"},"ita":{"official":"Repubblica di Figi","common":"Figi"},"jpn":{"official":"フィジー共和国","common":"フィジー"},"nld":{"official":"Republiek Fiji","common":"Fiji"},"por":{"official":"República de Fiji","common":"Fiji"},"rus":{"official":"Республика Фиджи","common":"Фиджи"},"slk":{"official":"Fiǆijská republika","common":"Fiǆi"},"spa":{"official":"República de Fiji","common":"Fiyi"},"fin":{"official":"Fidžin tasavalta","common":"Fidži"},"est":{"official":"Fidži Vabariik","common":"Fidži"},"zho":{"official":"斐济共和国","common":"斐济"},"pol":{"official":"Republika Fidżi","common":"Fidżi"},"urd":{"official":"جمہوریہ فجی","common":"فجی"},"kor":{"official":"피지 공화국","common":"피지"},"per":{"official":"جمهوری جزایر فیجی","common":"فیجی"}},"latlng":[-18,175],"landlocked":false,"borders":[],"area":18272,"flag":"🇫🇯","demonyms":{"eng":{"f":"Fijian","m":"Fijian"},"fra":{"f":"Fidjienne","m":"Fidjien"}}},{"name":{"common":"Falkland Islands","official":"Falkland Islands","native":{"eng":{"official":"Falkland Islands","common":"Falkland Islands"}}},"tld":[".fk"],"cca2":"FK","ccn3":"238","cca3":"FLK","cioc":"","independent":false,"status":"officially-assigned","currencies":{"FKP":{"name":"Falkland Islands pound","symbol":"£"}},"idd":{"root":"+5","suffixes":["00"]},"capital":["Stanley"],"altSpellings":["FK","Islas Malvinas","Falkland Islands (Malvinas)"],"region":"Americas","subregion":"South America","languages":{"eng":"English"},"translations":{"ces":{"official":"Falklandské ostrovy","common":"Falklandy"},"deu":{"official":"Falklandinseln","common":"Falklandinseln"},"fra":{"official":"Îles Malouines","common":"Îles Malouines"},"hrv":{"official":"Falklandski otoci","common":"Falklandski Otoci"},"ita":{"official":"Isole Falkland","common":"Isole Falkland o Isole Malvine"},"jpn":{"official":"フォークランド","common":"フォークランド（マルビナス）諸島"},"nld":{"official":"Falkland eilanden","common":"Falklandeilanden"},"por":{"official":"Ilhas Malvinas","common":"Ilhas Malvinas"},"rus":{"official":"Фолклендские острова","common":"Фолклендские острова"},"slk":{"official":"Falklandské ostrovy","common":"Falklandy"},"spa":{"official":"islas Malvinas","common":"Islas Malvinas"},"fin":{"official":"Falkandinsaaret","common":"Falkandinsaaret"},"est":{"official":"Falklandi saared","common":"Falklandi saared"},"zho":{"official":"福克兰群岛","common":"福克兰群岛"},"pol":{"official":"Falklandy","common":"Falklandy"},"urd":{"official":"جزائر فاکلینڈ","common":"جزائر فاکلینڈ"},"kor":{"official":"포클랜드 제도","common":"포클랜드 제도"},"per":{"official":"جزایر فالکلند","common":"جزایر فالکلند"}},"latlng":[-51.75,-59],"landlocked":false,"borders":[],"area":12173,"flag":"🇫🇰","demonyms":{"eng":{"f":"Falkland Islander","m":"Falkland Islander"},"fra":{"f":"Malouinne","m":"Malouin"}}},{"name":{"common":"France","official":"French Republic","native":{"fra":{"official":"République française","common":"France"}}},"tld":[".fr"],"cca2":"FR","ccn3":"250","cca3":"FRA","cioc":"FRA","independent":true,"status":"officially-assigned","currencies":{"EUR":{"name":"Euro","symbol":"€"}},"idd":{"root":"+3","suffixes":["3"]},"capital":["Paris"],"altSpellings":["FR","French Republic","République française"],"region":"Europe","subregion":"Western Europe","languages":{"fra":"French"},"translations":{"ces":{"official":"Francouzská republika","common":"Francie"},"deu":{"official":"Französische Republik","common":"Frankreich"},"fra":{"official":"République française","common":"France"},"hrv":{"official":"Francuska Republika","common":"Francuska"},"ita":{"official":"Repubblica francese","common":"Francia"},"jpn":{"official":"フランス共和国","common":"フランス"},"nld":{"official":"Franse Republiek","common":"Frankrijk"},"por":{"official":"República Francesa","common":"França"},"rus":{"official":"Французская Республика","common":"Франция"},"slk":{"official":"Francúzska republika","common":"Francúzsko"},"spa":{"official":"República francés","common":"Francia"},"fin":{"official":"Ranskan tasavalta","common":"Ranska"},"est":{"official":"Prantsuse Vabariik","common":"Prantsusmaa"},"zho":{"official":"法兰西共和国","common":"法国"},"pol":{"official":"Republika Francuska","common":"Francja"},"urd":{"official":"جمہوریہ فرانس","common":"فرانس"},"kor":{"official":"프랑스 공화국","common":"프랑스"},"per":{"official":"جمهوری فرانسه","common":"فرانسه"}},"latlng":[46,2],"landlocked":false,"borders":["AND","BEL","DEU","ITA","LUX","MCO","ESP","CHE"],"area":551695,"flag":"🇫🇷","demonyms":{"eng":{"f":"French","m":"French"},"fra":{"f":"Française","m":"Français"}}},{"name":{"common":"Faroe Islands","official":"Faroe Islands","native":{"dan":{"official":"Færøerne","common":"Færøerne"},"fao":{"official":"Føroyar","common":"Føroyar"}}},"tld":[".fo"],"cca2":"FO","ccn3":"234","cca3":"FRO","cioc":"","independent":false,"status":"officially-assigned","currencies":{"DKK":{"name":"Danish krone","symbol":"kr"},"FOK":{"name":"Faroese króna","symbol":"kr"}},"idd":{"root":"+2","suffixes":["98"]},"capital":["Tórshavn"],"altSpellings":["FO","Føroyar","Færøerne"],"region":"Europe","subregion":"Northern Europe","languages":{"dan":"Danish","fao":"Faroese"},"translations":{"ces":{"official":"Faerské ostrovy","common":"Faerské ostrovy"},"deu":{"official":"Färöer","common":"Färöer-Inseln"},"fra":{"official":"Îles Féroé","common":"Îles Féroé"},"hrv":{"official":"Farski Otoci","common":"Farski Otoci"},"ita":{"official":"Isole Faroe","common":"Isole Far Oer"},"jpn":{"official":"フェロー諸島","common":"フェロー諸島"},"nld":{"official":"Faeröer","common":"Faeröer"},"por":{"official":"Ilhas Faroe","common":"Ilhas Faroé"},"rus":{"official":"Фарерские острова","common":"Фарерские острова"},"slk":{"official":"Faerské ostrovy","common":"Faerské ostrovy"},"spa":{"official":"Islas Feroe","common":"Islas Faroe"},"fin":{"official":"Färsaaret","common":"Färsaaret"},"est":{"official":"Fääri saared","common":"Fääri saared"},"zho":{"official":"法罗群岛","common":"法罗群岛"},"pol":{"official":"Wyspy Owcze","common":"Wyspy Owcze"},"urd":{"official":"جزائر فارو","common":"جزائر فارو"},"kor":{"official":"페로 제도","common":"페로 제도"},"per":{"official":"جزایر فاروئه","common":"جزایر فاروئه"}},"latlng":[62,-7],"landlocked":false,"borders":[],"area":1393,"flag":"🇫🇴","demonyms":{"eng":{"f":"Faroese","m":"Faroese"},"fra":{"f":"Féroïenne","m":"Féroïen"}}},{"name":{"common":"Micronesia","official":"Federated States of Micronesia","native":{"eng":{"official":"Federated States of Micronesia","common":"Micronesia"}}},"tld":[".fm"],"cca2":"FM","ccn3":"583","cca3":"FSM","cioc":"FSM","independent":true,"status":"officially-assigned","currencies":[],"idd":{"root":"+6","suffixes":["91"]},"capital":["Palikir"],"altSpellings":["FM","Federated States of Micronesia","Micronesia, Federated States of"],"region":"Oceania","subregion":"Micronesia","languages":{"eng":"English"},"translations":{"ces":{"official":"Federativní státy Mikronésie","common":"Mikronésie"},"deu":{"official":"Föderierte Staaten von Mikronesien","common":"Mikronesien"},"fra":{"official":"États fédérés de Micronésie","common":"Micronésie"},"hrv":{"official":"Savezne Države Mikronezije","common":"Mikronezija"},"ita":{"official":"Stati federati di Micronesia","common":"Micronesia"},"jpn":{"official":"ミクロネシア連邦","common":"ミクロネシア連邦"},"nld":{"official":"Federale Staten van Micronesia","common":"Micronesië"},"por":{"official":"Estados Federados da Micronésia","common":"Micronésia"},"rus":{"official":"Федеративные Штаты Микронезии","common":"Федеративные Штаты Микронезии"},"slk":{"official":"Mikronézske federatívne štáty","common":"Mikronézia"},"spa":{"official":"Estados Federados de Micronesia","common":"Micronesia"},"fin":{"official":"Mikronesian liittovaltio","common":"Mikronesia"},"est":{"official":"Mikroneesia Liiduriigid","common":"Mikroneesia"},"zho":{"official":"密克罗尼西亚联邦","common":"密克罗尼西亚"},"pol":{"official":"Sfederowane Stany Mikronezji","common":"Mikronezja"},"urd":{"official":"ریاستہائے وفاقیہ مائکرونیشیا","common":"مائکرونیشیا"},"kor":{"official":"미크로네시아 연방","common":"미크로네시아"},"per":{"official":"ایالات فدرال میکرونزی","common":"میکرونزی"}},"latlng":[6.91666666,158.25],"landlocked":false,"borders":[],"area":702,"flag":"🇫🇲","demonyms":{"eng":{"f":"Micronesian","m":"Micronesian"},"fra":{"f":"Micronésienne","m":"Micronésien"}}},{"name":{"common":"Gabon","official":"Gabonese Republic","native":{"fra":{"official":"République gabonaise","common":"Gabon"}}},"tld":[".ga"],"cca2":"GA","ccn3":"266","cca3":"GAB","cioc":"GAB","independent":true,"status":"officially-assigned","currencies":{"XAF":{"name":"Central African CFA franc","symbol":"Fr"}},"idd":{"root":"+2","suffixes":["41"]},"capital":["Libreville"],"altSpellings":["GA","Gabonese Republic","République Gabonaise"],"region":"Africa","subregion":"Middle Africa","languages":{"fra":"French"},"translations":{"ces":{"official":"Gabonská republika","common":"Gabon"},"deu":{"official":"Gabunische Republik","common":"Gabun"},"fra":{"official":"République gabonaise","common":"Gabon"},"hrv":{"official":"Gabon Republika","common":"Gabon"},"ita":{"official":"Repubblica gabonese","common":"Gabon"},"jpn":{"official":"ガボン共和国","common":"ガボン"},"nld":{"official":"Republiek Gabon","common":"Gabon"},"por":{"official":"República do Gabão","common":"Gabão"},"rus":{"official":"Габона Республика","common":"Габон"},"slk":{"official":"Gabonská republika","common":"Gabon"},"spa":{"official":"República de Gabón","common":"Gabón"},"fin":{"official":"Gabonin tasavalta","common":"Gabon"},"est":{"official":"Gaboni Vabariik","common":"Gabon"},"zho":{"official":"加蓬共和国","common":"加蓬"},"pol":{"official":"Republika Gabońska","common":"Gabon"},"urd":{"official":"جمہوریہ گیبون","common":"گیبون"},"kor":{"official":"가봉 공화국","common":"가봉"},"per":{"official":"جمهوری گابُن","common":"گابن"}},"latlng":[-1,11.75],"landlocked":false,"borders":["CMR","COG","GNQ"],"area":267668,"flag":"🇬🇦","demonyms":{"eng":{"f":"Gabonese","m":"Gabonese"},"fra":{"f":"Gabonaise","m":"Gabonais"}}},{"name":{"common":"United Kingdom","official":"United Kingdom of Great Britain and Northern Ireland","native":{"eng":{"official":"United Kingdom of Great Britain and Northern Ireland","common":"United Kingdom"}}},"tld":[".uk"],"cca2":"GB","ccn3":"826","cca3":"GBR","cioc":"GBR","independent":true,"status":"officially-assigned","currencies":{"GBP":{"name":"British pound","symbol":"£"}},"idd":{"root":"+4","suffixes":["4"]},"capital":["London"],"altSpellings":["GB","UK","Great Britain"],"region":"Europe","subregion":"Northern Europe","languages":{"eng":"English"},"translations":{"ces":{"official":"Spojené království Velké Británie a Severního Irska","common":"Spojené království"},"deu":{"official":"Vereinigtes Königreich Großbritannien und Nordirland","common":"Vereinigtes Königreich"},"fra":{"official":"Royaume-Uni de Grande-Bretagne et d\'Irlande du Nord","common":"Royaume-Uni"},"hrv":{"official":"Ujedinjeno Kraljevstvo Velike Britanije i Sjeverne Irske","common":"Ujedinjeno Kraljevstvo"},"ita":{"official":"Regno Unito di Gran Bretagna e Irlanda del Nord","common":"Regno Unito"},"jpn":{"official":"グレート·ブリテンおよび北アイルランド連合王国","common":"イギリス"},"nld":{"official":"Verenigd Koninkrijk van Groot-Brittannië en Noord-Ierland","common":"Verenigd Koninkrijk"},"por":{"official":"Reino Unido da Grã-Bretanha e Irlanda do Norte","common":"Reino Unido"},"rus":{"official":"Соединенное Королевство Великобритании и Северной Ирландии","common":"Великобритания"},"slk":{"official":"Spojené kráľovstvo Veľkej Británie a SevernéhoÌrska","common":"Veľká Británia (Spojené kráľovstvo)"},"spa":{"official":"Reino Unido de Gran Bretaña e Irlanda del Norte","common":"Reino Unido"},"fin":{"official":"Ison-Britannian ja Pohjois-Irlannin yhdistynyt kuningaskunta","common":"Yhdistynyt kuningaskunta"},"est":{"official":"Suurbritannia ja Põhja-Iiri Ühendkuningriik","common":"Suurbritannia"},"zho":{"official":"大不列颠及北爱尔兰联合王国","common":"英国"},"pol":{"official":"Zjednoczone Królestwo Wielkiej Brytanii i Irlandii Północnej","common":"Zjednoczone Krłlestwo"},"urd":{"official":"مملکتِ متحدہ برطانیہ عظمی و شمالی آئرلینڈ","common":"مملکتِ متحدہ"},"kor":{"official":"그레이트브리튼 북아일랜드 연합 왕국","common":"영국"},"per":{"official":"پادشاهی متحد بریتانیای کبیر و ایرلند شمالی","common":"انگلیس"}},"latlng":[54,-2],"landlocked":false,"borders":["IRL"],"area":242900,"flag":"🇬🇧","demonyms":{"eng":{"f":"British","m":"British"},"fra":{"f":"Britannique","m":"Britannique"}}},{"name":{"common":"Georgia","official":"Georgia","native":{"kat":{"official":"საქართველო","common":"საქართველო"}}},"tld":[".ge"],"cca2":"GE","ccn3":"268","cca3":"GEO","cioc":"GEO","independent":true,"status":"officially-assigned","currencies":{"GEL":{"name":"lari","symbol":"₾"}},"idd":{"root":"+9","suffixes":["95"]},"capital":["Tbilisi"],"altSpellings":["GE","Sakartvelo"],"region":"Asia","subregion":"Western Asia","languages":{"kat":"Georgian"},"translations":{"ces":{"official":"Gruzie","common":"Gruzie"},"deu":{"official":"Georgien","common":"Georgien"},"fra":{"official":"République de Géorgie","common":"Géorgie"},"hrv":{"official":"Gruzija","common":"Gruzija"},"ita":{"official":"Georgia","common":"Georgia"},"jpn":{"official":"グルジア","common":"グルジア"},"nld":{"official":"Georgia","common":"Georgië"},"por":{"official":"Georgia","common":"Geórgia"},"rus":{"official":"Грузия","common":"Грузия"},"slk":{"official":"Gruzínsko","common":"Gruzínsko"},"spa":{"official":"Georgia","common":"Georgia"},"fin":{"official":"Georgia","common":"Georgia"},"est":{"official":"Gruusia","common":"Gruusia"},"zho":{"official":"格鲁吉亚","common":"格鲁吉亚"},"pol":{"official":"Gruzja","common":"Gruzja"},"urd":{"official":"جارجیا","common":"جارجیا"},"kor":{"official":"조지아","common":"조지아"},"per":{"official":"گرجستان","common":"گرجستان"}},"latlng":[42,43.5],"landlocked":false,"borders":["ARM","AZE","RUS","TUR"],"area":69700,"flag":"🇬🇪","demonyms":{"eng":{"f":"Georgian","m":"Georgian"},"fra":{"f":"Géorgienne","m":"Géorgien"}}},{"name":{"common":"Guernsey","official":"Bailiwick of Guernsey","native":{"eng":{"official":"Bailiwick of Guernsey","common":"Guernsey"},"fra":{"official":"Bailliage de Guernesey","common":"Guernesey"},"nfr":{"official":"Dgèrnésiais","common":"Dgèrnésiais"}}},"tld":[".gg"],"cca2":"GG","ccn3":"831","cca3":"GGY","cioc":"","independent":false,"status":"officially-assigned","currencies":{"GBP":{"name":"British pound","symbol":"£"},"GGP":{"name":"Guernsey pound","symbol":"£"}},"idd":{"root":"+4","suffixes":["4"]},"capital":["St. Peter Port"],"altSpellings":["GG","Bailiwick of Guernsey","Bailliage de Guernesey"],"region":"Europe","subregion":"Northern Europe","languages":{"eng":"English","fra":"French","nfr":"Guernésiais"},"translations":{"ces":{"official":"Rychtářství Guernsey","common":"Guernsey"},"deu":{"official":"Vogtei Guernsey","common":"Guernsey"},"fra":{"official":"Bailliage de Guernesey","common":"Guernesey"},"hrv":{"official":"Struka Guernsey","common":"Guernsey"},"ita":{"official":"Baliato di Guernsey","common":"Guernsey"},"jpn":{"official":"ガーンジーの得意分野","common":"ガーンジー"},"nld":{"official":"Baljuwschap Guernsey","common":"Guernsey"},"por":{"official":"Bailiado de Guernsey","common":"Guernsey"},"rus":{"official":"Коронное владение Гернси","common":"Гернси"},"slk":{"official":"Guernsey","common":"Guernsey"},"spa":{"official":"Bailía de Guernsey","common":"Guernsey"},"fin":{"official":"Guernsey","common":"Guernsey"},"est":{"official":"Guernsey foogtkond","common":"Guernsey"},"zho":{"official":"根西岛","common":"根西岛"},"pol":{"official":"Baliwat Guernsey","common":"Guernsey"},"urd":{"official":"گرنزی رودبار","common":"گرنزی"},"kor":{"official":"건지 섬","common":"건지 섬"},"per":{"official":"گرنزی","common":"گرنزی"}},"latlng":[49.46666666,-2.58333333],"landlocked":false,"borders":[],"area":78,"flag":"🇬🇬","demonyms":{"eng":{"f":"Channel Islander","m":"Channel Islander"},"fra":{"f":"Guernesiaise","m":"Guernesiais"}}},{"name":{"common":"Ghana","official":"Republic of Ghana","native":{"eng":{"official":"Republic of Ghana","common":"Ghana"}}},"tld":[".gh"],"cca2":"GH","ccn3":"288","cca3":"GHA","cioc":"GHA","independent":true,"status":"officially-assigned","currencies":{"GHS":{"name":"Ghanaian cedi","symbol":"₵"}},"idd":{"root":"+2","suffixes":["33"]},"capital":["Accra"],"altSpellings":["GH"],"region":"Africa","subregion":"Western Africa","languages":{"eng":"English"},"translations":{"ces":{"official":"Ghanská republika","common":"Ghana"},"deu":{"official":"Republik Ghana","common":"Ghana"},"fra":{"official":"République du Ghana","common":"Ghana"},"hrv":{"official":"Republika Gana","common":"Gana"},"ita":{"official":"Repubblica del Ghana","common":"Ghana"},"jpn":{"official":"ガーナ共和国","common":"ガーナ"},"nld":{"official":"Republiek Ghana","common":"Ghana"},"por":{"official":"República do Gana","common":"Gana"},"rus":{"official":"Республика Гана","common":"Гана"},"slk":{"official":"Ghanská republika","common":"Ghana"},"spa":{"official":"República de Ghana","common":"Ghana"},"fin":{"official":"Ghanan tasavalta","common":"Ghana"},"est":{"official":"Ghana Vabariik","common":"Ghana"},"zho":{"official":"加纳共和国","common":"加纳"},"pol":{"official":"Republika Ghany","common":"Ghana"},"urd":{"official":"جمہوریہ گھانا","common":"گھانا"},"kor":{"official":"가나 공화국","common":"가나"},"per":{"official":"جمهوری غنا","common":"غنا"}},"latlng":[8,-2],"landlocked":false,"borders":["BFA","CIV","TGO"],"area":238533,"flag":"🇬🇭","demonyms":{"eng":{"f":"Ghanaian","m":"Ghanaian"},"fra":{"f":"Ghanéenne","m":"Ghanéen"}}},{"name":{"common":"Gibraltar","official":"Gibraltar","native":{"eng":{"official":"Gibraltar","common":"Gibraltar"}}},"tld":[".gi"],"cca2":"GI","ccn3":"292","cca3":"GIB","cioc":"","independent":false,"status":"officially-assigned","currencies":{"GIP":{"name":"Gibraltar pound","symbol":"£"}},"idd":{"root":"+3","suffixes":["50"]},"capital":["Gibraltar"],"altSpellings":["GI"],"region":"Europe","subregion":"Southern Europe","languages":{"eng":"English"},"translations":{"ces":{"official":"Gibraltar","common":"Gibraltar"},"deu":{"official":"Gibraltar","common":"Gibraltar"},"fra":{"official":"Gibraltar","common":"Gibraltar"},"hrv":{"official":"Gibraltar","common":"Gibraltar"},"ita":{"official":"Gibilterra","common":"Gibilterra"},"jpn":{"official":"ジブラルタル","common":"ジブラルタル"},"nld":{"official":"Gibraltar","common":"Gibraltar"},"por":{"official":"Gibraltar","common":"Gibraltar"},"rus":{"official":"Гибралтар","common":"Гибралтар"},"slk":{"official":"Gibraltár","common":"Gibraltár"},"spa":{"official":"Gibraltar","common":"Gibraltar"},"fin":{"official":"Gibraltar","common":"Gibraltar"},"est":{"official":"Gibraltar","common":"Gibraltar"},"zho":{"official":"直布罗陀","common":"直布罗陀"},"pol":{"official":"Gibraltar","common":"Gibraltar"},"urd":{"official":"جبل الطارق","common":"جبل الطارق"},"kor":{"official":"지브롤터","common":"지브롤터"},"per":{"official":"جبل طارق","common":"جبل طارق"}},"latlng":[36.13333333,-5.35],"landlocked":false,"borders":["ESP"],"area":6,"flag":"🇬🇮","demonyms":{"eng":{"f":"Gibraltar","m":"Gibraltar"},"fra":{"f":"Gibraltarienne","m":"Gibraltarien"}}},{"name":{"common":"Guinea","official":"Republic of Guinea","native":{"fra":{"official":"République de Guinée","common":"Guinée"}}},"tld":[".gn"],"cca2":"GN","ccn3":"324","cca3":"GIN","cioc":"GUI","independent":true,"status":"officially-assigned","currencies":{"GNF":{"name":"Guinean franc","symbol":"Fr"}},"idd":{"root":"+2","suffixes":["24"]},"capital":["Conakry"],"altSpellings":["GN","Republic of Guinea","République de Guinée"],"region":"Africa","subregion":"Western Africa","languages":{"fra":"French"},"translations":{"ces":{"official":"Guinejská republika","common":"Guinea"},"deu":{"official":"Republik Guinea","common":"Guinea"},"fra":{"official":"République de Guinée","common":"Guinée"},"hrv":{"official":"Republika Gvineja","common":"Gvineja"},"ita":{"official":"Repubblica di Guinea","common":"Guinea"},"jpn":{"official":"ギニア共和国","common":"ギニア"},"nld":{"official":"Republiek Guinee","common":"Guinee"},"por":{"official":"República da Guiné","common":"Guiné"},"rus":{"official":"Республика Гвинея","common":"Гвинея"},"slk":{"official":"Guinejská republika","common":"Guinea"},"spa":{"official":"República de Guinea","common":"Guinea"},"fin":{"official":"Guinean tasavalta","common":"Guinea"},"est":{"official":"Guinea Vabariik","common":"Guinea"},"zho":{"official":"几内亚共和国","common":"几内亚"},"pol":{"official":"Republika Gwinei","common":"Gwinea"},"urd":{"official":"جمہوریہ گنی","common":"گنی"},"kor":{"official":"기니 공화국","common":"기니"},"per":{"official":"مملکت مستقل پاپوآ گینه نو","common":"پاپوآ گینه نو"}},"latlng":[11,-10],"landlocked":false,"borders":["CIV","GNB","LBR","MLI","SEN","SLE"],"area":245857,"flag":"🇬🇳","demonyms":{"eng":{"f":"Guinean","m":"Guinean"},"fra":{"f":"Guinéenne","m":"Guinéen"}}},{"name":{"common":"Guadeloupe","official":"Guadeloupe","native":{"fra":{"official":"Guadeloupe","common":"Guadeloupe"}}},"tld":[".gp"],"cca2":"GP","ccn3":"312","cca3":"GLP","cioc":"","independent":false,"status":"officially-assigned","currencies":{"EUR":{"name":"Euro","symbol":"€"}},"idd":{"root":"+5","suffixes":["90"]},"capital":["Basse-Terre"],"altSpellings":["GP","Gwadloup"],"region":"Americas","subregion":"Caribbean","languages":{"fra":"French"},"translations":{"ces":{"official":"Guadeloupe","common":"Guadeloupe"},"deu":{"official":"Guadeloupe","common":"Guadeloupe"},"fra":{"official":"Guadeloupe","common":"Guadeloupe"},"hrv":{"official":"Gvadalupa","common":"Gvadalupa"},"ita":{"official":"Guadeloupe","common":"Guadeloupa"},"jpn":{"official":"グアドループ島","common":"グアドループ"},"nld":{"official":"Guadeloupe","common":"Guadeloupe"},"por":{"official":"Guadalupe","common":"Guadalupe"},"rus":{"official":"Гваделупа","common":"Гваделупа"},"slk":{"official":"Guadeloupe","common":"Guadeloupe"},"spa":{"official":"Guadalupe","common":"Guadalupe"},"fin":{"official":"Guadeloupen departmentti","common":"Guadeloupe"},"est":{"official":"Guadeloupe’i ja sõltkondade departemang","common":"Guadeloupe"},"zho":{"official":"瓜德罗普岛","common":"瓜德罗普岛"},"pol":{"official":"Gwadelupa","common":"Gwadelupa"},"urd":{"official":"گواڈیلوپ","common":"گواڈیلوپ"},"kor":{"official":"과들루프","common":"과들루프"},"per":{"official":"گوادلوپ","common":"گوادلوپ"}},"latlng":[16.25,-61.583333],"landlocked":false,"borders":[],"area":1628,"flag":"🇬🇵","demonyms":{"eng":{"f":"Guadeloupian","m":"Guadeloupian"},"fra":{"f":"Guadeloupéenne","m":"Guadeloupéen"}}},{"name":{"common":"Gambia","official":"Republic of the Gambia","native":{"eng":{"official":"Republic of the Gambia","common":"Gambia"}}},"tld":[".gm"],"cca2":"GM","ccn3":"270","cca3":"GMB","cioc":"GAM","independent":true,"status":"officially-assigned","currencies":{"GMD":{"name":"dalasi","symbol":"D"}},"idd":{"root":"+2","suffixes":["20"]},"capital":["Banjul"],"altSpellings":["GM","Republic of the Gambia"],"region":"Africa","subregion":"Western Africa","languages":{"eng":"English"},"translations":{"ces":{"official":"Gambijská republika","common":"Gambie"},"deu":{"official":"Republik Gambia","common":"Gambia"},"fra":{"official":"République de Gambie","common":"Gambie"},"hrv":{"official":"Republika Gambija","common":"Gambija"},"ita":{"official":"Repubblica del Gambia","common":"Gambia"},"jpn":{"official":"ガンビア共和国","common":"ガンビア"},"nld":{"official":"Republiek Gambia","common":"Gambia"},"por":{"official":"República da Gâmbia","common":"Gâmbia"},"rus":{"official":"Республика Гамбия","common":"Гамбия"},"slk":{"official":"Gambijská republika","common":"Gambia"},"spa":{"official":"República de Gambia","common":"Gambia"},"fin":{"official":"Gambian tasavalta","common":"Gambia"},"est":{"official":"Gambia Vabariik","common":"Gambia"},"zho":{"official":"冈比亚共和国","common":"冈比亚"},"pol":{"official":"Republika Gambii","common":"Gambia"},"urd":{"official":"جمہوریہ گیمبیا","common":"گیمبیا"},"kor":{"official":"감비아 공화국","common":"감비아"},"per":{"official":"جمهوری گامبیا","common":"گامبیا"}},"latlng":[13.46666666,-16.56666666],"landlocked":false,"borders":["SEN"],"area":10689,"flag":"🇬🇲","demonyms":{"eng":{"f":"Gambian","m":"Gambian"},"fra":{"f":"Gambienne","m":"Gambien"}}},{"name":{"common":"Guinea-Bissau","official":"Republic of Guinea-Bissau","native":{"por":{"official":"República da Guiné-Bissau","common":"Guiné-Bissau"},"pov":{"official":"República da Guiné-Bissau","common":"Guiné-Bissau"}}},"tld":[".gw"],"cca2":"GW","ccn3":"624","cca3":"GNB","cioc":"GBS","independent":true,"status":"officially-assigned","currencies":{"XOF":{"name":"West African CFA franc","symbol":"Fr"}},"idd":{"root":"+2","suffixes":["45"]},"capital":["Bissau"],"altSpellings":["GW","Republic of Guinea-Bissau","República da Guiné-Bissau"],"region":"Africa","subregion":"Western Africa","languages":{"por":"Portuguese","pov":"Upper Guinea Creole"},"translations":{"ces":{"official":"Republika Guinea-Bissau","common":"Guinea-Bissau"},"deu":{"official":"Republik Guinea-Bissau","common":"Guinea-Bissau"},"fra":{"official":"République de Guinée-Bissau","common":"Guinée-Bissau"},"hrv":{"official":"Republika Gvineja Bisau","common":"Gvineja Bisau"},"ita":{"official":"Repubblica di Guinea-Bissau","common":"Guinea-Bissau"},"jpn":{"official":"ギニアビサウ共和国","common":"ギニアビサウ"},"nld":{"official":"Republiek Guinee-Bissau","common":"Guinee-Bissau"},"por":{"official":"República da Guiné-Bissau","common":"Guiné-Bissau"},"rus":{"official":"Республика Гвинея -Бисау","common":"Гвинея-Бисау"},"slk":{"official":"Guinejsko-bissauská republika","common":"Guinea-Bissau"},"spa":{"official":"República de Guinea-Bissau","common":"Guinea-Bisáu"},"fin":{"official":"Guinea-Bissaun tasavalta","common":"Guinea-Bissau"},"est":{"official":"Guinea-Bissau Vabariik","common":"Guinea-Bissau"},"zho":{"official":"几内亚比绍共和国","common":"几内亚比绍"},"pol":{"official":"Republika Gwinei Bissau","common":"Gwinea Bissau"},"urd":{"official":"جمہوریہ گنی بساؤ","common":"گنی بساؤ"},"kor":{"official":"기니비사우 공화국","common":"기니비사우"},"per":{"official":"جمهوری گینه بیسائو","common":"گینه بیسائو"}},"latlng":[12,-15],"landlocked":false,"borders":["GIN","SEN"],"area":36125,"flag":"🇬🇼","demonyms":{"eng":{"f":"Guinea-Bissauan","m":"Guinea-Bissauan"},"fra":{"f":"Bissau-Guinéenne","m":"Bissau-Guinéen"}}},{"name":{"common":"Equatorial Guinea","official":"Republic of Equatorial Guinea","native":{"fra":{"official":"République de la Guinée Équatoriale","common":"Guinée équatoriale"},"por":{"official":"República da Guiné Equatorial","common":"Guiné Equatorial"},"spa":{"official":"República de Guinea Ecuatorial","common":"Guinea Ecuatorial"}}},"tld":[".gq"],"cca2":"GQ","ccn3":"226","cca3":"GNQ","cioc":"GEQ","independent":true,"status":"officially-assigned","currencies":{"XAF":{"name":"Central African CFA franc","symbol":"Fr"}},"idd":{"root":"+2","suffixes":["40"]},"capital":["Malabo"],"altSpellings":["GQ","Republic of Equatorial Guinea","República de Guinea Ecuatorial","République de Guinée équatoriale","República da Guiné Equatorial"],"region":"Africa","subregion":"Middle Africa","languages":{"fra":"French","por":"Portuguese","spa":"Spanish"},"translations":{"ces":{"official":"Republika Rovníková Guinea","common":"Rovníková Guinea"},"cym":{"official":"Gweriniaeth Gini Gyhydeddol","common":"Gini Gyhydeddol"},"deu":{"official":"Republik Äquatorialguinea","common":"Äquatorialguinea"},"fra":{"official":"République de Guinée équatoriale","common":"Guinée équatoriale"},"hrv":{"official":"Republika Ekvatorska Gvineja","common":"Ekvatorijalna Gvineja"},"ita":{"official":"Repubblica della Guinea Equatoriale","common":"Guinea Equatoriale"},"jpn":{"official":"赤道ギニア共和国","common":"赤道ギニア"},"nld":{"official":"Republiek Equatoriaal-Guinea","common":"Equatoriaal-Guinea"},"por":{"official":"República da Guiné Equatorial","common":"Guiné Equatorial"},"rus":{"official":"Республика Экваториальная Гвинея","common":"Экваториальная Гвинея"},"slk":{"official":"Republika rovníkovej Guiney","common":"Rovníková Guinea"},"spa":{"official":"República de Guinea Ecuatorial","common":"Guinea Ecuatorial"},"fin":{"official":"Päiväntasaajan Guinean tasavalta","common":"Päiväntasaajan Guinea"},"est":{"official":"Ekvatoriaal-Guinea Vabariik","common":"Ekvatoriaal-Guinea"},"zho":{"official":"赤道几内亚共和国","common":"赤道几内亚"},"pol":{"official":"Republika Gwinei Równikowej","common":"Gwinea Równikowa"},"urd":{"official":"جمہوریہ استوائی گنی","common":"استوائی گنی"},"kor":{"official":"적도 기니 공화국","common":"적도 기니"},"per":{"official":"جمهوری گینه استوایی","common":"گینه استوایی"}},"latlng":[2,10],"landlocked":false,"borders":["CMR","GAB"],"area":28051,"flag":"🇬🇶","demonyms":{"eng":{"f":"Equatorial Guinean","m":"Equatorial Guinean"},"fra":{"f":"Équato-guinéenne","m":"Équato-guinéen"}}},{"name":{"common":"Greece","official":"Hellenic Republic","native":{"ell":{"official":"Ελληνική Δημοκρατία","common":"Ελλάδα"}}},"tld":[".gr"],"cca2":"GR","ccn3":"300","cca3":"GRC","cioc":"GRE","independent":true,"status":"officially-assigned","currencies":{"EUR":{"name":"Euro","symbol":"€"}},"idd":{"root":"+3","suffixes":["0"]},"capital":["Athens"],"altSpellings":["GR","Elláda","Hellenic Republic","Ελληνική Δημοκρατία"],"region":"Europe","subregion":"Southern Europe","languages":{"ell":"Greek"},"translations":{"ces":{"official":"Řecká republika","common":"Řecko"},"deu":{"official":"Hellenische Republik","common":"Griechenland"},"fra":{"official":"République hellénique","common":"Grèce"},"hrv":{"official":"Helenska Republika","common":"Grčka"},"ita":{"official":"Repubblica ellenica","common":"Grecia"},"jpn":{"official":"ギリシャ共和国","common":"ギリシャ"},"nld":{"official":"Helleense Republiek","common":"Griekenland"},"por":{"official":"República Helénica","common":"Grécia"},"rus":{"official":"Греческая Республика","common":"Греция"},"slk":{"official":"Grécka republika","common":"Greécko"},"spa":{"official":"República Helénica","common":"Grecia"},"fin":{"official":"Helleenien tasavalta","common":"Kreikka"},"est":{"official":"Kreeka Vabariik","common":"Kreeka"},"zho":{"official":"希腊共和国","common":"希腊"},"pol":{"official":"Republika Grecka","common":"Grecja"},"urd":{"official":"جمہوریہ ہیلینیہ","common":"یونان"},"kor":{"official":"그리스 공화국","common":"그리스"},"per":{"official":"جمهوری یونان","common":"یونان"}},"latlng":[39,22],"landlocked":false,"borders":["ALB","BGR","TUR","MKD"],"area":131990,"flag":"🇬🇷","demonyms":{"eng":{"f":"Greek","m":"Greek"},"fra":{"f":"Grecque","m":"Grec"}}},{"name":{"common":"Grenada","official":"Grenada","native":{"eng":{"official":"Grenada","common":"Grenada"}}},"tld":[".gd"],"cca2":"GD","ccn3":"308","cca3":"GRD","cioc":"GRN","independent":true,"status":"officially-assigned","currencies":{"XCD":{"name":"Eastern Caribbean dollar","symbol":"$"}},"idd":{"root":"+1","suffixes":["473"]},"capital":["St. George\'s"],"altSpellings":["GD"],"region":"Americas","subregion":"Caribbean","languages":{"eng":"English"},"translations":{"ces":{"official":"Grenada","common":"Grenada"},"deu":{"official":"Grenada","common":"Grenada"},"fra":{"official":"Grenade","common":"Grenade"},"hrv":{"official":"Grenada","common":"Grenada"},"ita":{"official":"Grenada","common":"Grenada"},"jpn":{"official":"グレナダ","common":"グレナダ"},"nld":{"official":"Grenada","common":"Grenada"},"por":{"official":"Grenada","common":"Granada"},"rus":{"official":"Гренада","common":"Гренада"},"slk":{"official":"Grenada","common":"Grenada"},"spa":{"official":"Granada","common":"Grenada"},"fin":{"official":"Grenada","common":"Grenada"},"est":{"official":"Grenada","common":"Grenada"},"zho":{"official":"格林纳达","common":"格林纳达"},"pol":{"official":"Grenada","common":"Grenada"},"urd":{"official":"گریناڈا","common":"گریناڈا"},"kor":{"official":"그레나다","common":"그레나다"},"per":{"official":"گرنادا","common":"گرنادا"}},"latlng":[12.11666666,-61.66666666],"landlocked":false,"borders":[],"area":344,"flag":"🇬🇩","demonyms":{"eng":{"f":"Grenadian","m":"Grenadian"},"fra":{"f":"Grenadienne","m":"Grenadien"}}},{"name":{"common":"Greenland","official":"Greenland","native":{"kal":{"official":"Kalaallit Nunaat","common":"Kalaallit Nunaat"}}},"tld":[".gl"],"cca2":"GL","ccn3":"304","cca3":"GRL","cioc":"","independent":false,"status":"officially-assigned","currencies":{"DKK":{"name":"krone","symbol":"kr."}},"idd":{"root":"+2","suffixes":["99"]},"capital":["Nuuk"],"altSpellings":["GL","Grønland"],"region":"Americas","subregion":"North America","languages":{"kal":"Greenlandic"},"translations":{"ces":{"official":"Grónsko","common":"Grónsko"},"deu":{"official":"Grönland","common":"Grönland"},"fra":{"official":"Groenland","common":"Groenland"},"hrv":{"official":"Grenland","common":"Grenland"},"ita":{"official":"Groenlandia","common":"Groenlandia"},"jpn":{"official":"グリーンランド","common":"グリーンランド"},"nld":{"official":"Groenland","common":"Groenland"},"por":{"official":"Groenlândia","common":"Gronelândia"},"rus":{"official":"Гренландия","common":"Гренландия"},"slk":{"official":"Grónsko","common":"Grónsko"},"spa":{"official":"Groenlandia","common":"Groenlandia"},"fin":{"official":"Groönlanti","common":"Groönlanti"},"est":{"official":"Gröönimaa","common":"Gröönimaa"},"zho":{"official":"格陵兰","common":"格陵兰"},"pol":{"official":"Grenlandia","common":"Grenlandia"},"urd":{"official":"گرین لینڈ","common":"گرین لینڈ"},"kor":{"official":"그린란드","common":"그린란드"},"per":{"official":"گروئنلند","common":"گرینلند"}},"latlng":[72,-40],"landlocked":false,"borders":[],"area":2166086,"flag":"🇬🇱","demonyms":{"eng":{"f":"Greenlandic","m":"Greenlandic"},"fra":{"f":"Groenlandaise","m":"Groenlandais"}}},{"name":{"common":"Guatemala","official":"Republic of Guatemala","native":{"spa":{"official":"República de Guatemala","common":"Guatemala"}}},"tld":[".gt"],"cca2":"GT","ccn3":"320","cca3":"GTM","cioc":"GUA","independent":true,"status":"officially-assigned","currencies":{"GTQ":{"name":"Guatemalan quetzal","symbol":"Q"}},"idd":{"root":"+5","suffixes":["02"]},"capital":["Guatemala City"],"altSpellings":["GT"],"region":"Americas","subregion":"Central America","languages":{"spa":"Spanish"},"translations":{"ces":{"official":"Republika Guatemala","common":"Guatemala"},"deu":{"official":"Republik Guatemala","common":"Guatemala"},"fra":{"official":"République du Guatemala","common":"Guatemala"},"hrv":{"official":"Republika Gvatemala","common":"Gvatemala"},"ita":{"official":"Repubblica del Guatemala","common":"Guatemala"},"jpn":{"official":"グアテマラ共和国","common":"グアテマラ"},"nld":{"official":"Republiek Guatemala","common":"Guatemala"},"por":{"official":"República da Guatemala","common":"Guatemala"},"rus":{"official":"Республика Гватемала","common":"Гватемала"},"slk":{"official":"Guatemalská republika","common":"Guatemala"},"spa":{"official":"República de Guatemala","common":"Guatemala"},"fin":{"official":"Guatemalan tasavalta","common":"Guatemala"},"est":{"official":"Guatemala Vabariik","common":"Guatemala"},"zho":{"official":"危地马拉共和国","common":"危地马拉"},"pol":{"official":"Republika Gwatemali","common":"Gwatemala"},"urd":{"official":"جمہوریہ گواتیمالا","common":"گواتیمالا"},"kor":{"official":"과테말라 공화국","common":"과테말라"},"per":{"official":"جمهوری گواتِمالا","common":"گواتِمالا"}},"latlng":[15.5,-90.25],"landlocked":false,"borders":["BLZ","SLV","HND","MEX"],"area":108889,"flag":"🇬🇹","demonyms":{"eng":{"f":"Guatemalan","m":"Guatemalan"},"fra":{"f":"Guatémaltèque","m":"Guatémaltèque"}}},{"name":{"common":"French Guiana","official":"Guiana","native":{"fra":{"official":"Guyane","common":"Guyane française"}}},"tld":[".gf"],"cca2":"GF","ccn3":"254","cca3":"GUF","cioc":"","independent":false,"status":"officially-assigned","currencies":{"EUR":{"name":"Euro","symbol":"€"}},"idd":{"root":"+5","suffixes":["94"]},"capital":["Cayenne"],"altSpellings":["GF","Guiana","Guyane"],"region":"Americas","subregion":"South America","languages":{"fra":"French"},"translations":{"ces":{"official":"Francouzská Guyana","common":"Francouzská Guyana"},"deu":{"official":"Französisch-Guayana","common":"Französisch-Guayana"},"fra":{"official":"Guyane","common":"Guyane"},"hrv":{"official":"Gijana","common":"Francuska Gvajana"},"ita":{"official":"Guiana","common":"Guyana francese"},"jpn":{"official":"ギアナ","common":"フランス領ギアナ"},"nld":{"official":"Guyana","common":"Frans-Guyana"},"por":{"official":"Guiana","common":"Guiana Francesa"},"rus":{"official":"Гвиана","common":"Французская Гвиана"},"slk":{"official":"Francúzska Guyana","common":"Guyana"},"spa":{"official":"Guayana","common":"Guayana Francesa"},"fin":{"official":"Ranskan Guayana","common":"Ranskan Guayana"},"est":{"official":"Guajaana departemang","common":"Prantsuse Guajaana"},"zho":{"official":"法属圭亚那","common":"法属圭亚那"},"pol":{"official":"Gujana Francuska","common":"Gujana Francuska"},"urd":{"official":"گیانا","common":"فرانسیسی گیانا"},"kor":{"official":"프랑스령 기아나","common":"프랑스령 기아나"},"per":{"official":"گویان فرانسه","common":"گویان فرانسه"}},"latlng":[4,-53],"landlocked":false,"borders":["BRA","SUR"],"area":83534,"flag":"🇬🇫","demonyms":{"eng":{"f":"Guianan","m":"Guianan"},"fra":{"f":"Guyanaise","m":"Guyanais"}}},{"name":{"common":"Guam","official":"Guam","native":{"cha":{"official":"Guåhån","common":"Guåhån"},"eng":{"official":"Guam","common":"Guam"},"spa":{"official":"Guam","common":"Guam"}}},"tld":[".gu"],"cca2":"GU","ccn3":"316","cca3":"GUM","cioc":"GUM","independent":false,"status":"officially-assigned","currencies":{"USD":{"name":"United States dollar","symbol":"$"}},"idd":{"root":"+1","suffixes":["671"]},"capital":["Hagåtña"],"altSpellings":["GU","Guåhån"],"region":"Oceania","subregion":"Micronesia","languages":{"cha":"Chamorro","eng":"English","spa":"Spanish"},"translations":{"ces":{"official":"Guam","common":"Guam"},"deu":{"official":"Guam","common":"Guam"},"fra":{"official":"Guam","common":"Guam"},"hrv":{"official":"Guam","common":"Guam"},"ita":{"official":"Guam","common":"Guam"},"jpn":{"official":"グアム","common":"グアム"},"nld":{"official":"Guam","common":"Guam"},"por":{"official":"Guam","common":"Guam"},"rus":{"official":"Гуам","common":"Гуам"},"slk":{"official":"Guam","common":"Guam"},"spa":{"official":"Guam","common":"Guam"},"fin":{"official":"Guam","common":"Guam"},"est":{"official":"Guami ala","common":"Guam"},"zho":{"official":"关岛","common":"关岛"},"pol":{"official":"Terytorium Guamu","common":"Guam"},"urd":{"official":"گوام","common":"گوام"},"kor":{"official":"괌","common":"괌"},"per":{"official":"گوآم","common":"گوآم"}},"latlng":[13.46666666,144.78333333],"landlocked":false,"borders":[],"area":549,"flag":"🇬🇺","demonyms":{"eng":{"f":"Guamanian","m":"Guamanian"},"fra":{"f":"","m":""}}},{"name":{"common":"Guyana","official":"Co-operative Republic of Guyana","native":{"eng":{"official":"Co-operative Republic of Guyana","common":"Guyana"}}},"tld":[".gy"],"cca2":"GY","ccn3":"328","cca3":"GUY","cioc":"GUY","independent":true,"status":"officially-assigned","currencies":{"GYD":{"name":"Guyanese dollar","symbol":"$"}},"idd":{"root":"+5","suffixes":["92"]},"capital":["Georgetown"],"altSpellings":["GY","Co-operative Republic of Guyana"],"region":"Americas","subregion":"South America","languages":{"eng":"English"},"translations":{"ces":{"official":"Kooperativní republika Guyana","common":"Guyana"},"deu":{"official":"Kooperative Republik Guyana","common":"Guyana"},"fra":{"official":"République coopérative de Guyana","common":"Guyana"},"hrv":{"official":"Zadruga Republika Gvajana","common":"Gvajana"},"ita":{"official":"Co -operative Republic of Guyana","common":"Guyana"},"jpn":{"official":"ガイアナの協同共和国","common":"ガイアナ"},"nld":{"official":"Coöperatieve Republiek Guyana","common":"Guyana"},"por":{"official":"Co -operative República da Guiana","common":"Guiana"},"rus":{"official":"Кооперативная Республика Гайана","common":"Гайана"},"slk":{"official":"Guyanská kooperatívna republika","common":"Guyana"},"spa":{"official":"República Cooperativa de Guyana","common":"Guyana"},"fin":{"official":"Guayanan osuustoiminnallinen tasavalta","common":"Guayana"},"est":{"official":"Guyana Vabariik","common":"Guyana"},"zho":{"official":"圭亚那共和国","common":"圭亚那"},"pol":{"official":"Kooperacyjna Republika Gujany","common":"Gujana"},"urd":{"official":"تعاونی جمہوریہ گیانا","common":"گیانا"},"kor":{"official":"가이아나 협동 공화국","common":"가이아나"},"per":{"official":"جمهوری تعاونی گویان","common":"گویان"}},"latlng":[5,-59],"landlocked":false,"borders":["BRA","SUR","VEN"],"area":214969,"flag":"🇬🇾","demonyms":{"eng":{"f":"Guyanese","m":"Guyanese"},"fra":{"f":"Guyanienne","m":"Guyanien"}}},{"name":{"common":"Hong Kong","official":"Hong Kong Special Administrative Region of the People\'s Republic of China","native":{"eng":{"official":"Hong Kong Special Administrative Region of the People\'s Republic of China","common":"Hong Kong"},"zho":{"official":"中华人民共和国香港特别行政区","common":"香港"}}},"tld":[".hk",".香港"],"cca2":"HK","ccn3":"344","cca3":"HKG","cioc":"HKG","independent":false,"status":"officially-assigned","currencies":{"HKD":{"name":"Hong Kong dollar","symbol":"$"}},"idd":{"root":"+8","suffixes":["52"]},"capital":["City of Victoria"],"altSpellings":["HK"],"region":"Asia","subregion":"Eastern Asia","languages":{"eng":"English","zho":"Chinese"},"translations":{"ces":{"official":"Zvláštní administrativní oblast Čínské lidové republiky Hongkong","common":"Hongkong"},"deu":{"official":"Sonderverwaltungszone Hongkong der Volksrepublik China","common":"Hongkong"},"fra":{"official":"Région administrative spéciale de Hong Kong de la République populaire de Chine","common":"Hong Kong"},"hrv":{"official":"Hong Kong Posebnog upravnog područjaNarodne Republike Kine","common":"Hong Kong"},"ita":{"official":"Hong Kong Regione amministrativa speciale della Repubblica Popolare Cinese","common":"Hong Kong"},"jpn":{"official":"中華人民共和国香港特別行政区","common":"香港"},"nld":{"official":"Hong Kong Speciale Administratieve Regio van de Volksrepubliek China","common":"Hongkong"},"por":{"official":"Hong Kong Região Administrativa Especial da República Popular da China","common":"Hong Kong"},"rus":{"official":"Hong Kong Специальный административный район Китайской Народной Республики Китая","common":"Гонконг"},"slk":{"official":"Špeciálna administratívna oblasťČínskej ľudovej republiky Hongkong","common":"Hongkong"},"spa":{"official":"Hong Kong Región Administrativa Especial de la República Popular China","common":"Hong Kong"},"fin":{"official":"Hong Kongin erityishallintoalue","common":"Hongkong"},"est":{"official":"Hongkongi erihalduspiirkond","common":"Hongkong"},"pol":{"official":"Specjalny Region Administracyjny Chińskiej Republiki Ludowej Hongkong","common":"Hongkong"},"urd":{"official":"ہانگ کانگ عوامی جمہوریہ چین کا خصوصی انتظامی علاقہ","common":"ہانگ کانگ"},"kor":{"official":"중화인민공화국 홍콩 특별행정구","common":"홍콩"},"per":{"official":"هُنگ کُنگ","common":"هُنگ کُنگ"}},"latlng":[22.267,114.188],"landlocked":false,"borders":["CHN"],"area":1104,"flag":"🇭🇰","demonyms":{"eng":{"f":"Hong Konger","m":"Hong Konger"},"fra":{"f":"Hongkongaise","m":"Hongkongais"}}},{"name":{"common":"Heard Island and McDonald Islands","official":"Heard Island and McDonald Islands","native":{"eng":{"official":"Heard Island and McDonald Islands","common":"Heard Island and McDonald Islands"}}},"tld":[".hm",".aq"],"cca2":"HM","ccn3":"334","cca3":"HMD","cioc":"","independent":false,"status":"officially-assigned","currencies":[],"idd":{"root":"","suffixes":[""]},"capital":[""],"altSpellings":["HM","Heard Island and McDonald Islands"],"region":"Antarctic","subregion":"","languages":{"eng":"English"},"translations":{"ces":{"official":"Heardův ostrov a McDonaldovy ostrovy","common":"Heardův ostrov a McDonaldovy ostrovy"},"deu":{"official":"Heard und McDonaldinseln","common":"Heard und die McDonaldinseln"},"fra":{"official":"Des îles Heard et McDonald","common":"Îles Heard-et-MacDonald"},"hrv":{"official":"Otok Heard i otočje McDonald","common":"Otok Heard i otočje McDonald"},"ita":{"official":"Isole Heard e McDonald","common":"Isole Heard e McDonald"},"jpn":{"official":"ハード島とマクドナルド諸島","common":"ハード島とマクドナルド諸島"},"nld":{"official":"Heard en McDonaldeilanden","common":"Heard-en McDonaldeilanden"},"por":{"official":"Ilha Heard e Ilhas McDonald","common":"Ilha Heard e Ilhas McDonald"},"rus":{"official":"Остров Херд и острова Макдональд","common":"Остров Херд и острова Макдональд"},"slk":{"official":"Teritórium Heardovho ostrova a Macdonaldových ostrovov","common":"Heardov ostrov"},"spa":{"official":"Islas Heard y McDonald","common":"Islas Heard y McDonald"},"fin":{"official":"Heard ja McDonaldinsaaret","common":"Heard ja McDonaldinsaaret"},"est":{"official":"Heardi ja McDonaldi saarte ala","common":"Heard ja McDonald"},"zho":{"official":"赫德岛和麦当劳群岛","common":"赫德岛和麦当劳群岛"},"pol":{"official":"Terytorium Wysp Heard i McDonalda","common":"Wyspy Heard i McDonalda"},"urd":{"official":"جزیرہ ہرڈ و جزائر مکڈونلڈ","common":"جزیرہ ہرڈ و جزائر مکڈونلڈ"},"kor":{"official":"허드 맥도널드 제도","common":"허드 맥도널드 제도"},"per":{"official":"جزیره هرد و جزایر مک‌دونالد","common":"جزیره هرد و جزایر مک‌دونالد"}},"latlng":[-53.1,72.51666666],"landlocked":false,"borders":[],"area":412,"flag":"🇭🇲","demonyms":{"eng":{"f":"Heard and McDonald Islander","m":"Heard and McDonald Islander"},"fra":{"f":"","m":""}}},{"name":{"common":"Honduras","official":"Republic of Honduras","native":{"spa":{"official":"República de Honduras","common":"Honduras"}}},"tld":[".hn"],"cca2":"HN","ccn3":"340","cca3":"HND","cioc":"HON","independent":true,"status":"officially-assigned","currencies":{"HNL":{"name":"Honduran lempira","symbol":"L"}},"idd":{"root":"+5","suffixes":["04"]},"capital":["Tegucigalpa"],"altSpellings":["HN","Republic of Honduras","República de Honduras"],"region":"Americas","subregion":"Central America","languages":{"spa":"Spanish"},"translations":{"ces":{"official":"Honduraská republika","common":"Honduras"},"deu":{"official":"Republik Honduras","common":"Honduras"},"fra":{"official":"République du Honduras","common":"Honduras"},"hrv":{"official":"Republika Honduras","common":"Honduras"},"ita":{"official":"Repubblica di Honduras","common":"Honduras"},"jpn":{"official":"ホンジュラス共和国","common":"ホンジュラス"},"nld":{"official":"Republiek Honduras","common":"Honduras"},"por":{"official":"República de Honduras","common":"Honduras"},"rus":{"official":"Республика Гондурас","common":"Гондурас"},"slk":{"official":"Honduraská republika","common":"Honduras"},"spa":{"official":"República de Honduras","common":"Honduras"},"fin":{"official":"Hondurasin tasavalta","common":"Honduras"},"est":{"official":"Hondurase Vabariik","common":"Honduras"},"zho":{"official":"洪都拉斯共和国","common":"洪都拉斯"},"pol":{"official":"Republika Hondurasu","common":"Honduras"},"urd":{"official":"جمہوریہ ہونڈوراس","common":"ہونڈوراس"},"kor":{"official":"온두라스 공화국","common":"온두라스"},"per":{"official":"جمهوری هندوراس","common":"هُندوراس"}},"latlng":[15,-86.5],"landlocked":false,"borders":["GTM","SLV","NIC"],"area":112492,"flag":"🇭🇳","demonyms":{"eng":{"f":"Honduran","m":"Honduran"},"fra":{"f":"Hondurienne","m":"Hondurien"}}},{"name":{"common":"Croatia","official":"Republic of Croatia","native":{"hrv":{"official":"Republika Hrvatska","common":"Hrvatska"}}},"tld":[".hr"],"cca2":"HR","ccn3":"191","cca3":"HRV","cioc":"CRO","independent":true,"status":"officially-assigned","currencies":{"HRK":{"name":"Croatian kuna","symbol":"kn"}},"idd":{"root":"+3","suffixes":["85"]},"capital":["Zagreb"],"altSpellings":["HR","Hrvatska","Republic of Croatia","Republika Hrvatska"],"region":"Europe","subregion":"Southern Europe","languages":{"hrv":"Croatian"},"translations":{"ces":{"official":"Chorvatská republika","common":"Chorvatsko"},"cym":{"official":"Gweriniaeth Croatia","common":"Croatia"},"deu":{"official":"Republik Kroatien","common":"Kroatien"},"fra":{"official":"République de Croatie","common":"Croatie"},"hrv":{"official":"Republika Hrvatska","common":"Hrvatska"},"ita":{"official":"Repubblica di Croazia","common":"Croazia"},"jpn":{"official":"クロアチア共和国","common":"クロアチア"},"nld":{"official":"Republiek Kroatië","common":"Kroatië"},"por":{"official":"República da Croácia","common":"Croácia"},"rus":{"official":"Республика Хорватия","common":"Хорватия"},"slk":{"official":"Chorvátska republika","common":"Chorvátsko"},"spa":{"official":"República de Croacia","common":"Croacia"},"fin":{"official":"Kroatian tasavalta","common":"Kroatia"},"est":{"official":"Horvaatia Vabariik","common":"Horvaatia"},"zho":{"official":"克罗地亚共和国","common":"克罗地亚"},"pol":{"official":"Republika Chorwacji","common":"Chorwacja"},"urd":{"official":"جمہوریہ کرویئشا","common":"کرویئشا"},"kor":{"official":"크로아티아 공화국","common":"크로아티아"},"per":{"official":"جمهوری کرواسی","common":"کرُواسی"}},"latlng":[45.16666666,15.5],"landlocked":false,"borders":["BIH","HUN","MNE","SRB","SVN"],"area":56594,"flag":"🇭🇷","demonyms":{"eng":{"f":"Croatian","m":"Croatian"},"fra":{"f":"Croate","m":"Croate"}}},{"name":{"common":"Haiti","official":"Republic of Haiti","native":{"fra":{"official":"République d\'Haïti","common":"Haïti"},"hat":{"official":"Repiblik Ayiti","common":"Ayiti"}}},"tld":[".ht"],"cca2":"HT","ccn3":"332","cca3":"HTI","cioc":"HAI","independent":true,"status":"officially-assigned","currencies":{"HTG":{"name":"Haitian gourde","symbol":"G"}},"idd":{"root":"+5","suffixes":["09"]},"capital":["Port-au-Prince"],"altSpellings":["HT","Republic of Haiti","République d\'Haïti","Repiblik Ayiti"],"region":"Americas","subregion":"Caribbean","languages":{"fra":"French","hat":"Haitian Creole"},"translations":{"ces":{"official":"Republika Haiti","common":"Haiti"},"deu":{"official":"Republik Haiti","common":"Haiti"},"fra":{"official":"République d\'Haïti","common":"Haïti"},"hrv":{"official":"Republika Haiti","common":"Haiti"},"ita":{"official":"Repubblica di Haiti","common":"Haiti"},"jpn":{"official":"ハイチ共和国","common":"ハイチ"},"nld":{"official":"Republiek Haïti","common":"Haïti"},"por":{"official":"República do Haiti","common":"Haiti"},"rus":{"official":"Республика Гаити","common":"Гаити"},"slk":{"official":"Haitská republika","common":"Haiti"},"spa":{"official":"República de Haití","common":"Haití"},"fin":{"official":"Haitin tasavalta","common":"Haiti"},"est":{"official":"Haiti Vabariik","common":"Haiti"},"zho":{"official":"海地共和国","common":"海地"},"pol":{"official":"Republika Haiti","common":"Haiti"},"urd":{"official":"جمہوریہ ہیٹی","common":"ہیٹی"},"kor":{"official":"아이티 공화국","common":"아이티"},"per":{"official":"جمهوری هائیتی","common":"هائیتی"}},"latlng":[19,-72.41666666],"landlocked":false,"borders":["DOM"],"area":27750,"flag":"🇭🇹","demonyms":{"eng":{"f":"Haitian","m":"Haitian"},"fra":{"f":"Haïtienne","m":"Haïtien"}}},{"name":{"common":"Hungary","official":"Hungary","native":{"hun":{"official":"Magyarország","common":"Magyarország"}}},"tld":[".hu"],"cca2":"HU","ccn3":"348","cca3":"HUN","cioc":"HUN","independent":true,"status":"officially-assigned","currencies":{"HUF":{"name":"Hungarian forint","symbol":"Ft"}},"idd":{"root":"+3","suffixes":["6"]},"capital":["Budapest"],"altSpellings":["HU"],"region":"Europe","subregion":"Eastern Europe","languages":{"hun":"Hungarian"},"translations":{"ces":{"official":"Maďarsko","common":"Maďarsko"},"deu":{"official":"Ungarn","common":"Ungarn"},"fra":{"official":"Hongrie","common":"Hongrie"},"hrv":{"official":"Madžarska","common":"Mađarska"},"ita":{"official":"Ungheria","common":"Ungheria"},"jpn":{"official":"ハンガリー","common":"ハンガリー"},"nld":{"official":"Hongarije","common":"Hongarije"},"por":{"official":"Hungria","common":"Hungria"},"rus":{"official":"Венгрия","common":"Венгрия"},"slk":{"official":"Maďarsko","common":"Maďarsko"},"spa":{"official":"Hungría","common":"Hungría"},"fin":{"official":"Unkari","common":"Unkari"},"est":{"official":"Ungari","common":"Ungari"},"zho":{"official":"匈牙利","common":"匈牙利"},"pol":{"official":"Węgry","common":"Węgry"},"urd":{"official":"مجارستان","common":"مجارستان"},"kor":{"official":"헝가리","common":"헝가리"},"per":{"official":"مجارستان","common":"مجارستان"}},"latlng":[47,20],"landlocked":true,"borders":["AUT","HRV","ROU","SRB","SVK","SVN","UKR"],"area":93028,"flag":"🇭🇺","demonyms":{"eng":{"f":"Hungarian","m":"Hungarian"},"fra":{"f":"Hongroise","m":"Hongrois"}}},{"name":{"common":"Indonesia","official":"Republic of Indonesia","native":{"ind":{"official":"Republik Indonesia","common":"Indonesia"}}},"tld":[".id"],"cca2":"ID","ccn3":"360","cca3":"IDN","cioc":"INA","independent":true,"status":"officially-assigned","currencies":{"IDR":{"name":"Indonesian rupiah","symbol":"Rp"}},"idd":{"root":"+6","suffixes":["2"]},"capital":["Jakarta"],"altSpellings":["ID","Republic of Indonesia","Republik Indonesia"],"region":"Asia","subregion":"South-Eastern Asia","languages":{"ind":"Indonesian"},"translations":{"ces":{"official":"Indonéská republika","common":"Indonésie"},"deu":{"official":"Republik Indonesien","common":"Indonesien"},"fra":{"official":"République d\'Indonésie","common":"Indonésie"},"hrv":{"official":"Republika Indonezija","common":"Indonezija"},"ita":{"official":"Repubblica di Indonesia","common":"Indonesia"},"jpn":{"official":"インドネシア共和国","common":"インドネシア"},"nld":{"official":"Republiek Indonesië","common":"Indonesië"},"por":{"official":"República da Indonésia","common":"Indonésia"},"rus":{"official":"Республика Индонезия","common":"Индонезия"},"slk":{"official":"Indonézska republika","common":"Indonézia"},"spa":{"official":"República de Indonesia","common":"Indonesia"},"fin":{"official":"Indonesian tasavalta","common":"Indonesia"},"est":{"official":"Indoneesia Vabariik","common":"Indoneesia"},"zho":{"official":"印度尼西亚共和国","common":"印度尼西亚"},"pol":{"official":"Republika Indonezji","common":"Indonezja"},"urd":{"official":"جمہوریہ انڈونیشیا","common":"انڈونیشیا"},"kor":{"official":"인도네시아 공화국","common":"인도네시아"},"per":{"official":"جمهوری اندونزی","common":"اندونزی"}},"latlng":[-5,120],"landlocked":false,"borders":["TLS","MYS","PNG"],"area":1904569,"flag":"🇮🇩","demonyms":{"eng":{"f":"Indonesian","m":"Indonesian"},"fra":{"f":"Indonésienne","m":"Indonésien"}}},{"name":{"common":"Isle of Man","official":"Isle of Man","native":{"eng":{"official":"Isle of Man","common":"Isle of Man"},"glv":{"official":"Ellan Vannin or Mannin","common":"Mannin"}}},"tld":[".im"],"cca2":"IM","ccn3":"833","cca3":"IMN","cioc":"","independent":false,"status":"officially-assigned","currencies":{"GBP":{"name":"British pound","symbol":"£"},"IMP":{"name":"Manx pound","symbol":"£"}},"idd":{"root":"+4","suffixes":["4"]},"capital":["Douglas"],"altSpellings":["IM","Ellan Vannin","Mann","Mannin"],"region":"Europe","subregion":"Northern Europe","languages":{"eng":"English","glv":"Manx"},"translations":{"ces":{"official":"Ostrov Man","common":"Ostrov Man"},"deu":{"official":"Isle of Man","common":"Insel Man"},"fra":{"official":"Isle of Man","common":"Île de Man"},"hrv":{"official":"Mana ostrvo","common":"Otok Man"},"ita":{"official":"Isola di Man","common":"Isola di Man"},"jpn":{"official":"マン島","common":"マン島"},"nld":{"official":"Isle of Man","common":"Isle of Man"},"por":{"official":"Isle of Man","common":"Ilha de Man"},"rus":{"official":"Остров Мэн","common":"Остров Мэн"},"slk":{"official":"Ostrov Man","common":"Man"},"spa":{"official":"Isla de Man","common":"Isla de Man"},"fin":{"official":"Mansaari","common":"Mansaari"},"est":{"official":"Mani saar","common":"Mani saar"},"zho":{"official":"马恩岛","common":"马恩岛"},"pol":{"official":"Wyspa Man","common":"Wyspa Man"},"urd":{"official":"آئل آف مین","common":"آئل آف مین"},"kor":{"official":"맨섬","common":"맨섬"},"per":{"official":"جزیرهٔ مَن","common":"جزیرهٔ مَن"}},"latlng":[54.25,-4.5],"landlocked":false,"borders":[],"area":572,"flag":"🇮🇲","demonyms":{"eng":{"f":"Manx","m":"Manx"},"fra":{"f":"","m":""}}},{"name":{"common":"India","official":"Republic of India","native":{"eng":{"official":"Republic of India","common":"India"},"hin":{"official":"भारत गणराज्य","common":"भारत"},"tam":{"official":"இந்தியக் குடியரசு","common":"இந்தியா"}}},"tld":[".in"],"cca2":"IN","ccn3":"356","cca3":"IND","cioc":"IND","independent":true,"status":"officially-assigned","currencies":{"INR":{"name":"Indian rupee","symbol":"₹"}},"idd":{"root":"+9","suffixes":["1"]},"capital":["New Delhi"],"altSpellings":["IN","Bhārat","Republic of India","Bharat Ganrajya","இந்தியா"],"region":"Asia","subregion":"Southern Asia","languages":{"eng":"English","hin":"Hindi","tam":"Tamil"},"translations":{"ces":{"official":"Indická republika","common":"Indie"},"deu":{"official":"Republik Indien","common":"Indien"},"fra":{"official":"République de l\'Inde","common":"Inde"},"hrv":{"official":"Republika Indija","common":"Indija"},"ita":{"official":"Repubblica dell\'India","common":"India"},"jpn":{"official":"インド共和国","common":"インド"},"nld":{"official":"Republiek India","common":"India"},"por":{"official":"República da Índia","common":"Índia"},"rus":{"official":"Республика Индия","common":"Индия"},"slk":{"official":"Indická republika","common":"India"},"spa":{"official":"República de la India","common":"India"},"fin":{"official":"Intian tasavalta","common":"Intia"},"est":{"official":"India Vabariik","common":"India"},"zho":{"official":"印度共和国","common":"印度"},"pol":{"official":"Republika Indii","common":"Indie"},"urd":{"official":"جمہوریہ بھارت","common":"بھارت"},"kor":{"official":"인도 공화국","common":"인도"},"per":{"official":"جمهوری هندوستان","common":"هند"}},"latlng":[20,77],"landlocked":false,"borders":["BGD","BTN","MMR","CHN","NPL","PAK"],"area":3287590,"flag":"🇮🇳","demonyms":{"eng":{"f":"Indian","m":"Indian"},"fra":{"f":"Indienne","m":"Indien"}}},{"name":{"common":"British Indian Ocean Territory","official":"British Indian Ocean Territory","native":{"eng":{"official":"British Indian Ocean Territory","common":"British Indian Ocean Territory"}}},"tld":[".io"],"cca2":"IO","ccn3":"086","cca3":"IOT","cioc":"","independent":false,"status":"officially-assigned","currencies":{"USD":{"name":"United States dollar","symbol":"$"}},"idd":{"root":"+2","suffixes":["46"]},"capital":["Diego Garcia"],"altSpellings":["IO"],"region":"Africa","subregion":"Eastern Africa","languages":{"eng":"English"},"translations":{"ces":{"official":"Britské indickooceánské území","common":"Britské indickooceánské území"},"cym":{"official":"Tiriogaeth Brydeinig Cefnfor India","common":"Tiriogaeth Brydeinig Cefnfor India"},"deu":{"official":"Britisches Territorium im Indischen Ozean","common":"Britisches Territorium im Indischen Ozean"},"fra":{"official":"Territoire britannique de l\' océan Indien","common":"Territoire britannique de l\'océan Indien"},"hrv":{"official":"British Indian Ocean Territory","common":"Britanski Indijskooceanski teritorij"},"ita":{"official":"Territorio britannico dell\'Oceano Indiano","common":"Territorio britannico dell\'oceano indiano"},"jpn":{"official":"イギリス領インド洋地域","common":"イギリス領インド洋地域"},"nld":{"official":"Brits Indische Oceaan Territorium","common":"Britse Gebieden in de Indische Oceaan"},"por":{"official":"British Indian Ocean Territory","common":"Território Britânico do Oceano Índico"},"rus":{"official":"Британская территория Индийского океана","common":"Британская территория в Индийском океане"},"slk":{"official":"Britské indickooceánske územie","common":"Britské indickooceánske územie"},"spa":{"official":"Territorio Británico del Océano Índico","common":"Territorio Británico del Océano Índico"},"fin":{"official":"Brittiläinen Intian valtameren alue","common":"Brittiläinen Intian valtameren alue"},"est":{"official":"Briti India ookeani ala","common":"Briti India ookeani ala"},"zho":{"official":"英属印度洋领地","common":"英属印度洋领地"},"pol":{"official":"Brytyjskie Terytorium Oceanu Indyjskiego","common":"Brytyjskie Terytorium Oceanu Indyjskiego"},"urd":{"official":"برطانوی بحرہند خطہ","common":"برطانوی بحرہند خطہ"},"kor":{"official":"인도 공화국","common":"인도"},"per":{"official":"قلمرو بریتانیا در اقیانوس هند","common":"قلمرو بریتانیا در اقیانوس هند"}},"latlng":[-6,71.5],"landlocked":false,"borders":[],"area":60,"flag":"🇮🇴","demonyms":{"eng":{"f":"Indian","m":"Indian"},"fra":{"f":"","m":""}}},{"name":{"common":"Ireland","official":"Republic of Ireland","native":{"eng":{"official":"Republic of Ireland","common":"Ireland"},"gle":{"official":"Poblacht na hÉireann","common":"Éire"}}},"tld":[".ie"],"cca2":"IE","ccn3":"372","cca3":"IRL","cioc":"IRL","independent":true,"status":"officially-assigned","currencies":{"EUR":{"name":"Euro","symbol":"€"}},"idd":{"root":"+3","suffixes":["53"]},"capital":["Dublin"],"altSpellings":["IE","Éire","Republic of Ireland","Poblacht na hÉireann"],"region":"Europe","subregion":"Northern Europe","languages":{"eng":"English","gle":"Irish"},"translations":{"ces":{"official":"Irsko","common":"Irsko"},"deu":{"official":"Republik Irland","common":"Irland"},"fra":{"official":"République d\'Irlande","common":"Irlande"},"hrv":{"official":"Republika Irska","common":"Irska"},"ita":{"official":"Repubblica d\'Irlanda","common":"Irlanda"},"jpn":{"official":"アイルランド共和国","common":"アイルランド"},"nld":{"official":"Republic of Ireland","common":"Ierland"},"por":{"official":"República da Irlanda","common":"Irlanda"},"rus":{"official":"Ирландия","common":"Ирландия"},"slk":{"official":"Írska republika","common":"Írsko"},"spa":{"official":"República de Irlanda","common":"Irlanda"},"fin":{"official":"Irlannin tasavalta","common":"Irlanti"},"est":{"official":"Iirimaa","common":"Iirimaa"},"zho":{"official":"爱尔兰共和国","common":"爱尔兰"},"pol":{"official":"Republika Irlandii","common":"Irlandia"},"urd":{"official":"جمہوریہ جزیرہ آئرلینڈ","common":"جزیرہ آئرلینڈ"},"kor":{"official":"아일랜드 공화국","common":"아일랜드"},"per":{"official":"ایرلند","common":"ایرلند"}},"latlng":[53,-8],"landlocked":false,"borders":["GBR"],"area":70273,"flag":"🇮🇪","demonyms":{"eng":{"f":"Irish","m":"Irish"},"fra":{"f":"Irlandaise","m":"Irlandais"}}},{"name":{"common":"Iran","official":"Islamic Republic of Iran","native":{"fas":{"official":"جمهوری اسلامی ایران","common":"ایران"}}},"tld":[".ir","ایران."],"cca2":"IR","ccn3":"364","cca3":"IRN","cioc":"IRI","independent":true,"status":"officially-assigned","currencies":{"IRR":{"name":"Iranian rial","symbol":"﷼"}},"idd":{"root":"+9","suffixes":["8"]},"capital":["Tehran"],"altSpellings":["IR","Islamic Republic of Iran","Iran, Islamic Republic of","Jomhuri-ye Eslāmi-ye Irān"],"region":"Asia","subregion":"Southern Asia","languages":{"fas":"Persian (Farsi)"},"translations":{"ces":{"official":"Islámská republika Írán","common":"Írán"},"deu":{"official":"Islamische Republik Iran","common":"Iran"},"fra":{"official":"République islamique d\'Iran","common":"Iran"},"hrv":{"official":"Islamska Republika Iran","common":"Iran"},"ita":{"official":"Repubblica islamica dell\'Iran","common":"Iran"},"jpn":{"official":"イラン·イスラム共和国","common":"イラン・イスラム共和国"},"nld":{"official":"Islamitische Republiek Iran","common":"Iran"},"por":{"official":"República Islâmica do Irã","common":"Irão"},"rus":{"official":"Исламская Республика Иран","common":"Иран"},"slk":{"official":"Iránska islamská republika","common":"Irán"},"spa":{"official":"República Islámica de Irán","common":"Iran"},"fin":{"official":"Iranin islamilainen tasavalta","common":"Iran"},"est":{"official":"Iraani Islamivabariik","common":"Iraan"},"zho":{"official":"伊朗伊斯兰共和国","common":"伊朗"},"pol":{"official":"Islamska Republika Iranu","common":"Iran"},"urd":{"official":"جمہوریہ ایران","common":"ایران"},"kor":{"official":"이란 이슬람 공화국","common":"이란"}},"latlng":[32,53],"landlocked":false,"borders":["AFG","ARM","AZE","IRQ","PAK","TUR","TKM"],"area":1648195,"flag":"🇮🇷","demonyms":{"eng":{"f":"Iranian","m":"Iranian"},"fra":{"f":"Iranienne","m":"Iranien"}}},{"name":{"common":"Iraq","official":"Republic of Iraq","native":{"ara":{"official":"جمهورية العراق","common":"العراق"},"arc":{"official":"ܩܘܼܛܢܵܐ ܐܝܼܪܲܩ","common":"ܩܘܼܛܢܵܐ"},"ckb":{"official":"کۆماری عێراق","common":"کۆماری"}}},"tld":[".iq"],"cca2":"IQ","ccn3":"368","cca3":"IRQ","cioc":"IRQ","independent":true,"status":"officially-assigned","currencies":{"IQD":{"name":"Iraqi dinar","symbol":"ع.د"}},"idd":{"root":"+9","suffixes":["64"]},"capital":["Baghdad"],"altSpellings":["IQ","Republic of Iraq","Jumhūriyyat al-‘Irāq"],"region":"Asia","subregion":"Western Asia","languages":{"ara":"Arabic","arc":"Aramaic","ckb":"Sorani"},"translations":{"ces":{"official":"Irácká republika","common":"Irák"},"deu":{"official":"Republik Irak","common":"Irak"},"fra":{"official":"République d\'Irak","common":"Irak"},"hrv":{"official":"Republika Irak","common":"Irak"},"ita":{"official":"Repubblica dell\'Iraq","common":"Iraq"},"jpn":{"official":"イラク共和国","common":"イラク"},"nld":{"official":"Republiek Irak","common":"Irak"},"por":{"official":"República do Iraque","common":"Iraque"},"rus":{"official":"Республика Ирак","common":"Ирак"},"slk":{"official":"Iracká republika","common":"Irak"},"spa":{"official":"República de Irak","common":"Irak"},"fin":{"official":"Irakin tasavalta","common":"Irak"},"est":{"official":"Iraagi Vabariik","common":"Iraak"},"zho":{"official":"伊拉克共和国","common":"伊拉克"},"pol":{"official":"Republika Iraku","common":"Irak"},"urd":{"official":"جمہوریہ عراق","common":"عراق"},"kor":{"official":"이라크 공화국","common":"이라크"},"per":{"official":"جمهوری عراق","common":"عراق"}},"latlng":[33,44],"landlocked":false,"borders":["IRN","JOR","KWT","SAU","SYR","TUR"],"area":438317,"flag":"🇮🇶","demonyms":{"eng":{"f":"Iraqi","m":"Iraqi"},"fra":{"f":"Irakienne","m":"Irakien"}}},{"name":{"common":"Iceland","official":"Iceland","native":{"isl":{"official":"Ísland","common":"Ísland"}}},"tld":[".is"],"cca2":"IS","ccn3":"352","cca3":"ISL","cioc":"ISL","independent":true,"status":"officially-assigned","currencies":{"ISK":{"name":"Icelandic króna","symbol":"kr"}},"idd":{"root":"+3","suffixes":["54"]},"capital":["Reykjavik"],"altSpellings":["IS","Island","Republic of Iceland","Lýðveldið Ísland"],"region":"Europe","subregion":"Northern Europe","languages":{"isl":"Icelandic"},"translations":{"ces":{"official":"Island","common":"Island"},"deu":{"official":"Island","common":"Island"},"fra":{"official":"République d\'Islande","common":"Islande"},"hrv":{"official":"Island","common":"Island"},"ita":{"official":"Islanda","common":"Islanda"},"jpn":{"official":"アイスランド","common":"アイスランド"},"nld":{"official":"IJsland","common":"IJsland"},"por":{"official":"Islândia","common":"Islândia"},"rus":{"official":"Исландия","common":"Исландия"},"slk":{"official":"Islandská republika","common":"Island"},"spa":{"official":"Islandia","common":"Islandia"},"fin":{"official":"Islanti","common":"Islanti"},"est":{"official":"Islandi Vabariik","common":"Island"},"zho":{"official":"冰岛","common":"冰岛"},"pol":{"official":"Republika Islandii","common":"Islandia"},"urd":{"official":"آئس لینڈ","common":"آئس لینڈ"},"kor":{"official":"아이슬란드 공화국","common":"아이슬란드"},"per":{"official":"جمهوری ایسلند","common":"ایسلند"}},"latlng":[65,-18],"landlocked":false,"borders":[],"area":103000,"flag":"🇮🇸","demonyms":{"eng":{"f":"Icelander","m":"Icelander"},"fra":{"f":"Islandaise","m":"Islandais"}}},{"name":{"common":"Israel","official":"State of Israel","native":{"ara":{"official":"دولة إسرائيل","common":"إسرائيل"},"heb":{"official":"מדינת ישראל","common":"ישראל"}}},"tld":[".il"],"cca2":"IL","ccn3":"376","cca3":"ISR","cioc":"ISR","independent":true,"status":"officially-assigned","currencies":{"ILS":{"name":"Israeli new shekel","symbol":"₪"}},"idd":{"root":"+9","suffixes":["72"]},"capital":["Jerusalem"],"altSpellings":["IL","State of Israel","Medīnat Yisrā\'el"],"region":"Asia","subregion":"Western Asia","languages":{"ara":"Arabic","heb":"Hebrew"},"translations":{"ces":{"official":"Stát Izrael","common":"Izrael"},"deu":{"official":"Staat Israel","common":"Israel"},"fra":{"official":"État d\'Israël","common":"Israël"},"hrv":{"official":"Država Izrael","common":"Izrael"},"ita":{"official":"Stato di Israele","common":"Israele"},"jpn":{"official":"イスラエル国","common":"イスラエル"},"nld":{"official":"Staat Israël","common":"Israël"},"por":{"official":"Estado de Israel","common":"Israel"},"rus":{"official":"Государство Израиль","common":"Израиль"},"slk":{"official":"Izraelský štát","common":"Izrael"},"spa":{"official":"Estado de Israel","common":"Israel"},"fin":{"official":"Israelin valtio","common":"Israel"},"est":{"official":"Iisraeli Riik","common":"Iisrael"},"zho":{"official":"以色列国","common":"以色列"},"pol":{"official":"Państwo Izrael","common":"Izrael"},"urd":{"official":"ریاستِ اسرائیل","common":"اسرائیل"},"kor":{"official":"이스라엘국","common":"이스라엘"},"per":{"official":"فلسطين اشغالی","common":"فلسطين اشغالی"}},"latlng":[31.47,35.13],"landlocked":false,"borders":["EGY","JOR","LBN","PSE","SYR"],"area":20770,"flag":"🇮🇱","demonyms":{"eng":{"f":"Israeli","m":"Israeli"},"fra":{"f":"Israélienne","m":"Israélien"}}},{"name":{"common":"Italy","official":"Italian Republic","native":{"ita":{"official":"Repubblica italiana","common":"Italia"}}},"tld":[".it"],"cca2":"IT","ccn3":"380","cca3":"ITA","cioc":"ITA","independent":true,"status":"officially-assigned","currencies":{"EUR":{"name":"Euro","symbol":"€"}},"idd":{"root":"+3","suffixes":["9"]},"capital":["Rome"],"altSpellings":["IT","Italian Republic","Repubblica italiana"],"region":"Europe","subregion":"Southern Europe","languages":{"ita":"Italian"},"translations":{"ces":{"official":"Italská republika","common":"Itálie"},"deu":{"official":"Italienische Republik","common":"Italien"},"fra":{"official":"République italienne","common":"Italie"},"hrv":{"official":"talijanska Republika","common":"Italija"},"ita":{"official":"Repubblica italiana","common":"Italia"},"jpn":{"official":"イタリア共和国","common":"イタリア"},"nld":{"official":"Italiaanse Republiek","common":"Italië"},"por":{"official":"República Italiana","common":"Itália"},"rus":{"official":"итальянская Республика","common":"Италия"},"slk":{"official":"Talianska republika","common":"Taliansko"},"spa":{"official":"República Italiana","common":"Italia"},"fin":{"official":"Italian tasavalta","common":"Italia"},"est":{"official":"Itaalia Vabariik","common":"Itaalia"},"zho":{"official":"意大利共和国","common":"意大利"},"pol":{"official":"Republika Włoska","common":"Włochy"},"urd":{"official":"جمہوریہ اطالیہ","common":"اطالیہ"},"kor":{"official":"이탈리아 공화국","common":"이탈리아"},"per":{"official":"جمهوری ایتالیا","common":"ایتالیا"}},"latlng":[42.83333333,12.83333333],"landlocked":false,"borders":["AUT","FRA","SMR","SVN","CHE","VAT"],"area":301336,"flag":"🇮🇹","demonyms":{"eng":{"f":"Italian","m":"Italian"},"fra":{"f":"Italienne","m":"Italien"}}},{"name":{"common":"Jamaica","official":"Jamaica","native":{"eng":{"official":"Jamaica","common":"Jamaica"},"jam":{"official":"Jamaica","common":"Jamaica"}}},"tld":[".jm"],"cca2":"JM","ccn3":"388","cca3":"JAM","cioc":"JAM","independent":true,"status":"officially-assigned","currencies":{"JMD":{"name":"Jamaican dollar","symbol":"$"}},"idd":{"root":"+1","suffixes":["876"]},"capital":["Kingston"],"altSpellings":["JM"],"region":"Americas","subregion":"Caribbean","languages":{"eng":"English","jam":"Jamaican Patois"},"translations":{"ces":{"official":"Jamajka","common":"Jamajka"},"deu":{"official":"Jamaika","common":"Jamaika"},"fra":{"official":"Jamaïque","common":"Jamaïque"},"hrv":{"official":"Jamajka","common":"Jamajka"},"ita":{"official":"Giamaica","common":"Giamaica"},"jpn":{"official":"ジャマイカ","common":"ジャマイカ"},"nld":{"official":"Jamaica","common":"Jamaica"},"por":{"official":"Jamaica","common":"Jamaica"},"rus":{"official":"Ямайка","common":"Ямайка"},"slk":{"official":"Jamajka","common":"Jamajka"},"spa":{"official":"Jamaica","common":"Jamaica"},"fin":{"official":"Jamaika","common":"Jamaika"},"est":{"official":"Jamaica","common":"Jamaica"},"zho":{"official":"牙买加","common":"牙买加"},"pol":{"official":"Jamajka","common":"Jamajka"},"urd":{"official":"جمیکا","common":"جمیکا"},"kor":{"official":"자메이카","common":"자메이카"},"per":{"official":"جامائیکا","common":"جامائیکا"}},"latlng":[18.25,-77.5],"landlocked":false,"borders":[],"area":10991,"flag":"🇯🇲","demonyms":{"eng":{"f":"Jamaican","m":"Jamaican"},"fra":{"f":"Jamaïcaine","m":"Jamaïcain"}}},{"name":{"common":"Jersey","official":"Bailiwick of Jersey","native":{"eng":{"official":"Bailiwick of Jersey","common":"Jersey"},"fra":{"official":"Bailliage de Jersey","common":"Jersey"},"nrf":{"official":"Bailliage dé Jèrri","common":"Jèrri"}}},"tld":[".je"],"cca2":"JE","ccn3":"832","cca3":"JEY","cioc":"","independent":false,"status":"officially-assigned","currencies":{"GBP":{"name":"British pound","symbol":"£"},"JEP":{"name":"Jersey pound","symbol":"£"}},"idd":{"root":"+4","suffixes":["4"]},"capital":["Saint Helier"],"altSpellings":["JE","Bailiwick of Jersey","Bailliage de Jersey","Bailliage dé Jèrri"],"region":"Europe","subregion":"Northern Europe","languages":{"eng":"English","fra":"French","nrf":"Jèrriais"},"translations":{"ces":{"official":"Rychtářství Jersey","common":"Jersey"},"deu":{"official":"Vogtei Jersey","common":"Jersey"},"fra":{"official":"Bailliage de Jersey","common":"Jersey"},"hrv":{"official":"Struka od Jersey","common":"Jersey"},"ita":{"official":"Baliato di Jersey","common":"Isola di Jersey"},"jpn":{"official":"ジャージの得意分野","common":"ジャージー"},"nld":{"official":"Baljuwschap Jersey","common":"Jersey"},"por":{"official":"Bailiado de Jersey","common":"Jersey"},"rus":{"official":"Коронное владение Джерси","common":"Джерси"},"slk":{"official":"Bailiwick Jersey","common":"Jersey"},"spa":{"official":"Bailía de Jersey","common":"Jersey"},"fin":{"official":"Jersey","common":"Jersey"},"est":{"official":"Jersey foogtkond","common":"Jersey"},"zho":{"official":"泽西岛","common":"泽西岛"},"pol":{"official":"Jersey","common":"Jersey"},"urd":{"official":"جرزی","common":"جرزی"},"kor":{"official":"저지 섬","common":"저지 섬"},"per":{"official":"جرزی","common":"جرزی"}},"latlng":[49.25,-2.16666666],"landlocked":false,"borders":[],"area":116,"flag":"🇯🇪","demonyms":{"eng":{"f":"Channel Islander","m":"Channel Islander"},"fra":{"f":"Jersiaise","m":"Jersiais"}}},{"name":{"common":"Jordan","official":"Hashemite Kingdom of Jordan","native":{"ara":{"official":"المملكة الأردنية الهاشمية","common":"الأردن"}}},"tld":[".jo","الاردن."],"cca2":"JO","ccn3":"400","cca3":"JOR","cioc":"JOR","independent":true,"status":"officially-assigned","currencies":{"JOD":{"name":"Jordanian dinar","symbol":"د.ا"}},"idd":{"root":"+9","suffixes":["62"]},"capital":["Amman"],"altSpellings":["JO","Hashemite Kingdom of Jordan","al-Mamlakah al-Urdunīyah al-Hāshimīyah"],"region":"Asia","subregion":"Western Asia","languages":{"ara":"Arabic"},"translations":{"ces":{"official":"Jordánské hášimovské království","common":"Jordánsko"},"deu":{"official":"Haschemitisches Königreich Jordanien","common":"Jordanien"},"fra":{"official":"Royaume hachémite de Jordanie","common":"Jordanie"},"hrv":{"official":"Hašemitske Kraljevine Jordan","common":"Jordan"},"ita":{"official":"Regno hascemita di Giordania","common":"Giordania"},"jpn":{"official":"ヨルダン·ハシミテ王国","common":"ヨルダン"},"nld":{"official":"Hasjemitisch Koninkrijk Jordanië","common":"Jordanië"},"por":{"official":"Reino Hachemita da Jordânia","common":"Jordânia"},"rus":{"official":"Иорданского Хашимитского Королевства","common":"Иордания"},"slk":{"official":"Jordánske hášimovské kráľovstvo","common":"Jordánsko"},"spa":{"official":"Reino Hachemita de Jordania","common":"Jordania"},"fin":{"official":"Jordanian hašemiittinen kunigaskunta","common":"Jordania"},"est":{"official":"Jordaania Hašimiidi Kuningriik","common":"Jordaania"},"zho":{"official":"约旦哈希姆王国","common":"约旦"},"pol":{"official":"Jordańskie Królestwo Haszymidzkie","common":"Jordania"},"urd":{"official":"ھاشمی مملکتِ اردن","common":"اردن"},"kor":{"official":"요르단 하심 왕국","common":"요르단"},"per":{"official":"پادشاهی اُردُن هاشمی","common":"اردن"}},"latlng":[31,36],"landlocked":false,"borders":["IRQ","ISR","PSE","SAU","SYR"],"area":89342,"flag":"🇯🇴","demonyms":{"eng":{"f":"Jordanian","m":"Jordanian"},"fra":{"f":"Jordanienne","m":"Jordanien"}}},{"name":{"common":"Japan","official":"Japan","native":{"jpn":{"official":"日本","common":"日本"}}},"tld":[".jp",".みんな"],"cca2":"JP","ccn3":"392","cca3":"JPN","cioc":"JPN","independent":true,"status":"officially-assigned","currencies":{"JPY":{"name":"Japanese yen","symbol":"¥"}},"idd":{"root":"+8","suffixes":["1"]},"capital":["Tokyo"],"altSpellings":["JP","Nippon","Nihon"],"region":"Asia","subregion":"Eastern Asia","languages":{"jpn":"Japanese"},"translations":{"ces":{"official":"Japonsko","common":"Japonsko"},"deu":{"official":"Japan","common":"Japan"},"fra":{"official":"Japon","common":"Japon"},"hrv":{"official":"Japan","common":"Japan"},"ita":{"official":"Giappone","common":"Giappone"},"jpn":{"official":"日本","common":"日本"},"nld":{"official":"Japan","common":"Japan"},"por":{"official":"Japão","common":"Japão"},"rus":{"official":"Япония","common":"Япония"},"slk":{"official":"Japonsko","common":"Japonsko"},"spa":{"official":"Japón","common":"Japón"},"fin":{"official":"Japani","common":"Japani"},"est":{"official":"Jaapan","common":"Jaapan"},"zho":{"official":"日本国","common":"日本"},"pol":{"official":"Japonia","common":"Japonia"},"urd":{"official":"جاپان","common":"جاپان"},"kor":{"official":"일본국","common":"일본"},"per":{"official":"ژاپن","common":"ژاپن"}},"latlng":[36,138],"landlocked":false,"borders":[],"area":377930,"flag":"🇯🇵","demonyms":{"eng":{"f":"Japanese","m":"Japanese"},"fra":{"f":"Japonaise","m":"Japonais"}}},{"name":{"common":"Kazakhstan","official":"Republic of Kazakhstan","native":{"kaz":{"official":"Қазақстан Республикасы","common":"Қазақстан"},"rus":{"official":"Республика Казахстан","common":"Казахстан"}}},"tld":[".kz",".қаз"],"cca2":"KZ","ccn3":"398","cca3":"KAZ","cioc":"KAZ","independent":true,"status":"officially-assigned","currencies":{"KZT":{"name":"Kazakhstani tenge","symbol":"₸"}},"idd":{"root":"+7","suffixes":["6XX","7XX"]},"capital":["Astana"],"altSpellings":["KZ","Qazaqstan","Казахстан","Republic of Kazakhstan","Қазақстан Республикасы","Qazaqstan Respublïkası","Республика Казахстан","Respublika Kazakhstan"],"region":"Asia","subregion":"Central Asia","languages":{"kaz":"Kazakh","rus":"Russian"},"translations":{"ces":{"official":"Republika Kazachstán","common":"Kazachstán"},"deu":{"official":"Republik Kasachstan","common":"Kasachstan"},"fra":{"official":"République du Kazakhstan","common":"Kazakhstan"},"hrv":{"official":"Republika Kazahstan","common":"Kazahstan"},"ita":{"official":"Repubblica del Kazakhstan","common":"Kazakistan"},"jpn":{"official":"カザフスタン共和国","common":"カザフスタン"},"nld":{"official":"Republiek Kazachstan","common":"Kazachstan"},"por":{"official":"República do Cazaquistão","common":"Cazaquistão"},"rus":{"official":"Республика Казахстан","common":"Казахстан"},"slk":{"official":"Kazašská republika","common":"Kazachstan"},"spa":{"official":"República de Kazajstán","common":"Kazajistán"},"fin":{"official":"Kazakstanin tasavalta","common":"Kazakstan"},"est":{"official":"Kasahstani Vabariik","common":"Kasahstan"},"zho":{"official":"哈萨克斯坦共和国","common":"哈萨克斯坦"},"pol":{"official":"Republika Kazachstanu","common":"Kazachstan"},"urd":{"official":"جمہوریہ قازقستان","common":"قازقستان"},"kor":{"official":"카자흐스탄 공화국","common":"카자흐스탄"},"per":{"official":"جمهوری قزاقستان","common":"قزاقستان"}},"latlng":[48,68],"landlocked":true,"borders":["CHN","KGZ","RUS","TKM","UZB"],"area":2724900,"flag":"🇰🇿","demonyms":{"eng":{"f":"Kazakhstani","m":"Kazakhstani"},"fra":{"f":"Kazakhstanaise","m":"Kazakhstanais"}}},{"name":{"common":"Kenya","official":"Republic of Kenya","native":{"eng":{"official":"Republic of Kenya","common":"Kenya"},"swa":{"official":"Republic of Kenya","common":"Kenya"}}},"tld":[".ke"],"cca2":"KE","ccn3":"404","cca3":"KEN","cioc":"KEN","independent":true,"status":"officially-assigned","currencies":{"KES":{"name":"Kenyan shilling","symbol":"Sh"}},"idd":{"root":"+2","suffixes":["54"]},"capital":["Nairobi"],"altSpellings":["KE","Republic of Kenya","Jamhuri ya Kenya"],"region":"Africa","subregion":"Eastern Africa","languages":{"eng":"English","swa":"Swahili"},"translations":{"ces":{"official":"Keňská republika","common":"Keňa"},"deu":{"official":"Republik Kenia","common":"Kenia"},"fra":{"official":"République du Kenya","common":"Kenya"},"hrv":{"official":"Republika Kenija","common":"Kenija"},"ita":{"official":"Repubblica del Kenya","common":"Kenya"},"jpn":{"official":"ケニア共和国","common":"ケニア"},"nld":{"official":"Republiek Kenia","common":"Kenia"},"por":{"official":"República do Quénia","common":"Quénia"},"rus":{"official":"Республика Кения","common":"Кения"},"slk":{"official":"Kenská republika","common":"Keňa"},"spa":{"official":"República de Kenya","common":"Kenia"},"fin":{"official":"Kenian tasavalta","common":"Kenia"},"est":{"official":"Keenia Vabariik","common":"Keenia"},"zho":{"official":"肯尼亚共和国","common":"肯尼亚"},"pol":{"official":"Republika Kenii","common":"Kenia"},"urd":{"official":"جمہوریہ کینیا","common":"کینیا"},"kor":{"official":"케냐 공화국","common":"케냐"},"per":{"official":"جمهوری کنیا","common":"کنیا"}},"latlng":[1,38],"landlocked":false,"borders":["ETH","SOM","SSD","TZA","UGA"],"area":580367,"flag":"🇰🇪","demonyms":{"eng":{"f":"Kenyan","m":"Kenyan"},"fra":{"f":"Kényane","m":"Kényan"}}},{"name":{"common":"Kyrgyzstan","official":"Kyrgyz Republic","native":{"kir":{"official":"Кыргыз Республикасы","common":"Кыргызстан"},"rus":{"official":"Кыргызская Республика","common":"Киргизия"}}},"tld":[".kg"],"cca2":"KG","ccn3":"417","cca3":"KGZ","cioc":"KGZ","independent":true,"status":"officially-assigned","currencies":{"KGS":{"name":"Kyrgyzstani som","symbol":"с"}},"idd":{"root":"+9","suffixes":["96"]},"capital":["Bishkek"],"altSpellings":["KG","Киргизия","Kyrgyz Republic","Кыргыз Республикасы","Kyrgyz Respublikasy"],"region":"Asia","subregion":"Central Asia","languages":{"kir":"Kyrgyz","rus":"Russian"},"translations":{"ces":{"official":"Kyrgyzská republika","common":"Kyrgyzstán"},"deu":{"official":"Kirgisische Republik","common":"Kirgisistan"},"fra":{"official":"République kirghize","common":"Kirghizistan"},"hrv":{"official":"Kirgistanu","common":"Kirgistan"},"ita":{"official":"Kirghizistan","common":"Kirghizistan"},"jpn":{"official":"キルギス共和国","common":"キルギス"},"nld":{"official":"Kirgizische Republiek","common":"Kirgizië"},"por":{"official":"República do Quirguistão","common":"Quirguistão"},"rus":{"official":"Кыргызская Республика","common":"Киргизия"},"slk":{"official":"Kirgizská republika","common":"Kirgizsko"},"spa":{"official":"República Kirguisa","common":"Kirguizistán"},"fin":{"official":"Kirgisian tasavalta","common":"Kirgisia"},"est":{"official":"Kirgiisi Vabariik","common":"Kõrgõzstan"},"zho":{"official":"吉尔吉斯斯坦共和国","common":"吉尔吉斯斯坦"},"pol":{"official":"Republika Kirgiska","common":"Kirgistan"},"urd":{"official":"جمہوریہ کرغیزستان","common":"کرغیزستان"},"kor":{"official":"키르기스 공화국","common":"키르기스스탄"},"per":{"official":"جمهوری قِرقیزستان","common":"قرقیزستان"}},"latlng":[41,75],"landlocked":true,"borders":["CHN","KAZ","TJK","UZB"],"area":199951,"flag":"🇰🇬","demonyms":{"eng":{"f":"Kirghiz","m":"Kirghiz"},"fra":{"f":"Kirghize","m":"Kirghize"}}},{"name":{"common":"Cambodia","official":"Kingdom of Cambodia","native":{"khm":{"official":"ព្រះរាជាណាចក្រកម្ពុជា","common":"Kâmpŭchéa"}}},"tld":[".kh"],"cca2":"KH","ccn3":"116","cca3":"KHM","cioc":"CAM","independent":true,"status":"officially-assigned","currencies":{"KHR":{"name":"Cambodian riel","symbol":"៛"},"USD":{"name":"United States dollar","symbol":"$"}},"idd":{"root":"+8","suffixes":["55"]},"capital":["Phnom Penh"],"altSpellings":["KH","Kingdom of Cambodia"],"region":"Asia","subregion":"South-Eastern Asia","languages":{"khm":"Khmer"},"translations":{"ces":{"official":"Kambodžské království","common":"Kambodža"},"cym":{"official":"Teyrnas Cambodia","common":"Cambodia"},"deu":{"official":"Königreich Kambodscha","common":"Kambodscha"},"fra":{"official":"Royaume du Cambodge","common":"Cambodge"},"hrv":{"official":"Kraljevina Kambodža","common":"Kambodža"},"ita":{"official":"Regno di Cambogia","common":"Cambogia"},"jpn":{"official":"カンボジア王国","common":"カンボジア"},"nld":{"official":"Koninkrijk Cambodja","common":"Cambodja"},"por":{"official":"Reino do Camboja","common":"Camboja"},"rus":{"official":"Королевство Камбоджа","common":"Камбоджа"},"slk":{"official":"Kamboǆské kráľovstvo","common":"Kamboǆa"},"spa":{"official":"Reino de Camboya","common":"Camboya"},"fin":{"official":"Kambodžan kuningaskunta","common":"Kambodža"},"est":{"official":"Kambodža Kuningriik","common":"Kambodža"},"zho":{"official":"柬埔寨王国","common":"柬埔寨"},"pol":{"official":"Królestwo Kambodży","common":"Kambodża"},"urd":{"official":"مملکتِ کمبوڈیا","common":"کمبوڈیا"},"kor":{"official":"캄보디아 왕국","common":"캄보디아"},"per":{"official":"پادشاهی کامبوج","common":"کامبوج"}},"latlng":[13,105],"landlocked":false,"borders":["LAO","THA","VNM"],"area":181035,"flag":"🇰🇭","demonyms":{"eng":{"f":"Cambodian","m":"Cambodian"},"fra":{"f":"Cambodgienne","m":"Cambodgien"}}},{"name":{"common":"Kiribati","official":"Independent and Sovereign Republic of Kiribati","native":{"eng":{"official":"Independent and Sovereign Republic of Kiribati","common":"Kiribati"},"gil":{"official":"Ribaberiki Kiribati","common":"Kiribati"}}},"tld":[".ki"],"cca2":"KI","ccn3":"296","cca3":"KIR","cioc":"KIR","independent":true,"status":"officially-assigned","currencies":{"AUD":{"name":"Australian dollar","symbol":"$"},"KID":{"name":"Kiribati dollar","symbol":"$"}},"idd":{"root":"+6","suffixes":["86"]},"capital":["South Tarawa"],"altSpellings":["KI","Republic of Kiribati","Ribaberiki Kiribati"],"region":"Oceania","subregion":"Micronesia","languages":{"eng":"English","gil":"Gilbertese"},"translations":{"ces":{"official":"Republika Kiribati","common":"Kiribati"},"deu":{"official":"Republik Kiribati","common":"Kiribati"},"fra":{"official":"République de Kiribati","common":"Kiribati"},"hrv":{"official":"Samostalne i suverene Republike Kiribati","common":"Kiribati"},"ita":{"official":"Repubblica indipendente e sovrano di Kiribati","common":"Kiribati"},"jpn":{"official":"キリバスの独立と主権共和国","common":"キリバス"},"nld":{"official":"Onafhankelijke en soevereine republiek Kiribati","common":"Kiribati"},"por":{"official":"Independente e soberano República de Kiribati","common":"Kiribati"},"rus":{"official":"Независимой и суверенной Республики Кирибати","common":"Кирибати"},"slk":{"official":"Kiribatská republika","common":"Kiribati"},"spa":{"official":"República Independiente y Soberano de Kiribati","common":"Kiribati"},"fin":{"official":"Kiribatin tasavalta","common":"Kiribati"},"est":{"official":"Kiribati Vabariik","common":"Kiribati"},"zho":{"official":"基里巴斯共和国","common":"基里巴斯"},"pol":{"official":"Republika Kiribati","common":"Kiribati"},"urd":{"official":"سلطنت آزاد جمہوریہ کیریباتی","common":"کیریباتی"},"kor":{"official":"키리바시 공화국","common":"키리바시"},"per":{"official":"جمهوری کیریباتی","common":"کیریباتی"}},"latlng":[1.41666666,173],"landlocked":false,"borders":[],"area":811,"flag":"🇰🇮","demonyms":{"eng":{"f":"I-Kiribati","m":"I-Kiribati"},"fra":{"f":"Kiribatienne","m":"Kiribatien"}}},{"name":{"common":"Saint Kitts and Nevis","official":"Federation of Saint Christopher and Nevis","native":{"eng":{"official":"Federation of Saint Christopher and Nevis","common":"Saint Kitts and Nevis"}}},"tld":[".kn"],"cca2":"KN","ccn3":"659","cca3":"KNA","cioc":"SKN","independent":true,"status":"officially-assigned","currencies":{"XCD":{"name":"Eastern Caribbean dollar","symbol":"$"}},"idd":{"root":"+1","suffixes":["869"]},"capital":["Basseterre"],"altSpellings":["KN","Federation of Saint Christopher and Nevis"],"region":"Americas","subregion":"Caribbean","languages":{"eng":"English"},"translations":{"ces":{"official":"Federace Sv. Kryštof a Nevis","common":"Svatý Kryštof a Nevis"},"deu":{"official":"Föderation von St. Kitts und Nevis","common":"St. Kitts und Nevis"},"fra":{"official":"Fédération de Saint-Christophe-et-Niévès","common":"Saint-Christophe-et-Niévès"},"hrv":{"official":"Federacija Sv.Kristofora i Nevisa","common":"Sveti Kristof i Nevis"},"ita":{"official":"Federazione di Saint Christopher e Nevis","common":"Saint Kitts e Nevis"},"jpn":{"official":"セントクリストファーNevis連盟","common":"セントクリストファー・ネイビス"},"nld":{"official":"Federatie van Saint Kitts en Nevis","common":"Saint Kitts en Nevis"},"por":{"official":"Federação de São Cristóvão e Nevis","common":"São Cristóvão e Nevis"},"rus":{"official":"Федерация Сент-Кристофер и Н е в и с","common":"Сент-Китс и Невис"},"slk":{"official":"Feder໡cia Svätého Krištofa a Nevisu","common":"Svätý Krištof a Nevis"},"spa":{"official":"Federación de San Cristóbal y Nevis","common":"San Cristóbal y Nieves"},"fin":{"official":"Saint Christopherin ja Nevisin federaatio","common":"Saint Kitts ja Nevis"},"est":{"official":"Saint Kittsi ja Nevise Föderatsioon","common":"Saint Kitts ja Nevis"},"zho":{"official":"圣克里斯托弗和尼维斯联邦","common":"圣基茨和尼维斯"},"pol":{"official":"Federacja Saint Kitts i Nevis","common":"Saint Kitts i Nevis"},"urd":{"official":"وفاقِ سینٹ کیٹز و ناویس","common":"سینٹ کیٹز و ناویس"},"kor":{"official":"세인트키츠 네비스 연방","common":"세인트키츠 네비스"},"per":{"official":"فدراسیون سنت کیتس و نویس","common":"سنت کیتس و نویس"}},"latlng":[17.33333333,-62.75],"landlocked":false,"borders":[],"area":261,"flag":"🇰🇳","demonyms":{"eng":{"f":"Kittitian or Nevisian","m":"Kittitian or Nevisian"},"fra":{"f":"Kittitienne-et-nevicienne","m":"Kittitien-et-nevicien"}}},{"name":{"common":"South Korea","official":"Republic of Korea","native":{"kor":{"official":"대한민국","common":"한국"}}},"tld":[".kr",".한국"],"cca2":"KR","ccn3":"410","cca3":"KOR","cioc":"KOR","independent":true,"status":"officially-assigned","currencies":{"KRW":{"name":"South Korean won","symbol":"₩"}},"idd":{"root":"+8","suffixes":["2"]},"capital":["Seoul"],"altSpellings":["KR","Korea, Republic of","Republic of Korea","남한","남조선"],"region":"Asia","subregion":"Eastern Asia","languages":{"kor":"Korean"},"translations":{"ces":{"official":"Korejská republika","common":"Jižní Korea"},"deu":{"official":"Republik Korea","common":"Südkorea"},"fra":{"official":"République de Corée","common":"Corée du Sud"},"hrv":{"official":"Republika Koreja","common":"Južna Koreja"},"ita":{"official":"Repubblica di Corea","common":"Corea del Sud"},"jpn":{"official":"大韓民国","common":"韓国"},"nld":{"official":"Republiek Korea","common":"Zuid-Korea"},"por":{"official":"República da Coreia","common":"Coreia do Sul"},"rus":{"official":"Республика Корея","common":"Южная Корея"},"slk":{"official":"Kórejská republika","common":"Južná Kórea"},"spa":{"official":"República de Corea","common":"Corea del Sur"},"fin":{"official":"Korean tasavalta","common":"Etelä-Korea"},"est":{"official":"Korea Vabariik","common":"Lõuna-Korea"},"zho":{"official":"大韩民国","common":"韩国"},"pol":{"official":"Republika Korei","common":"Korea Południowa"},"urd":{"official":"جمہوریہ کوریا ","common":"جنوبی کوریا"},"kor":{"official":"대한민국","common":"한국"},"per":{"official":"جمهوری کره","common":"کرهٔ جنوبی"}},"latlng":[37,127.5],"landlocked":false,"borders":["PRK"],"area":100210,"flag":"🇰🇷","demonyms":{"eng":{"f":"South Korean","m":"South Korean"},"fra":{"f":"Sud-coréenne","m":"Sud-coréen"}}},{"name":{"common":"Kosovo","official":"Republic of Kosovo","native":{"sqi":{"official":"Republika e Kosovës","common":"Kosova"},"srp":{"official":"Република Косово","common":"Косово"}}},"tld":[],"cca2":"XK","ccn3":"","cca3":"UNK","cioc":"KOS","independent":null,"status":"user-assigned","currencies":{"EUR":{"name":"Euro","symbol":"€"}},"idd":{"root":"+3","suffixes":["83"]},"capital":["Pristina"],"altSpellings":["XK","Република Косово"],"region":"Europe","subregion":"Eastern Europe","languages":{"sqi":"Albanian","srp":"Serbian"},"translations":{"ces":{"official":"Kosovská republika","common":"Kosovo"},"deu":{"official":"Republik Kosovo","common":"Kosovo"},"fra":{"official":"République du Kosovo","common":"Kosovo"},"hrv":{"official":"Republika Kosovo","common":"Kosovo"},"ita":{"official":"Repubblica del Kosovo","common":"Kosovo"},"nld":{"official":"Republiek Kosovo","common":"Kosovo"},"por":{"official":"República do Kosovo","common":"Kosovo"},"rus":{"official":"Республика Косово","common":"Республика Косово"},"slk":{"official":"Republika Kosovo","common":"Kosovo"},"spa":{"official":"República de Kosovo","common":"Kosovo"},"fin":{"official":"Kosovon tasavalta","common":"Kosovo"},"est":{"official":"Kosovo Vabariik","common":"Kosovo"},"zho":{"official":"科索沃共和国","common":"科索沃"},"pol":{"official":"Republika Kosowa","common":"Kosowo"},"urd":{"official":"جمہوریہ کوسووہ","common":"کوسووہ"},"kor":{"official":"코소보 공화국","common":"코소보"},"per":{"official":"جمهوری کوزوو","common":"کوزوو"}},"latlng":[42.666667,21.166667],"landlocked":true,"borders":["ALB","MKD","MNE","SRB"],"area":10908,"flag":"🇽🇰","demonyms":{"eng":{"f":"Kosovar","m":"Kosovar"},"fra":{"f":"Kosovare","m":"Kosovar"}}},{"name":{"common":"Kuwait","official":"State of Kuwait","native":{"ara":{"official":"دولة الكويت","common":"الكويت"}}},"tld":[".kw"],"cca2":"KW","ccn3":"414","cca3":"KWT","cioc":"KUW","independent":true,"status":"officially-assigned","currencies":{"KWD":{"name":"Kuwaiti dinar","symbol":"د.ك"}},"idd":{"root":"+9","suffixes":["65"]},"capital":["Kuwait City"],"altSpellings":["KW","State of Kuwait","Dawlat al-Kuwait"],"region":"Asia","subregion":"Western Asia","languages":{"ara":"Arabic"},"translations":{"ces":{"official":"Stát Kuvajt","common":"Kuvajt"},"deu":{"official":"Staat Kuwait","common":"Kuwait"},"fra":{"official":"État du Koweït","common":"Koweït"},"hrv":{"official":"Država Kuvajt","common":"Kuvajt"},"ita":{"official":"Stato del Kuwait","common":"Kuwait"},"jpn":{"official":"クウェート国","common":"クウェート"},"nld":{"official":"Staat Koeweit","common":"Koeweit"},"por":{"official":"Estado do Kuwait","common":"Kuwait"},"rus":{"official":"Государство Кувейт","common":"Кувейт"},"slk":{"official":"Kuvajtský štát","common":"Kuvajt"},"spa":{"official":"Estado de Kuwait","common":"Kuwait"},"fin":{"official":"Kuwaitin valtio","common":"Kuwait"},"est":{"official":"Kuveidi Riik","common":"Kuveit"},"zho":{"official":"科威特国","common":"科威特"},"pol":{"official":"Państwo Kuwejt","common":"Kuwejt"},"urd":{"official":"دولتِ کویت","common":"کویت"},"kor":{"official":"쿠웨이트국","common":"쿠웨이트"},"per":{"official":"دولت کویت","common":"کُویت"}},"latlng":[29.5,45.75],"landlocked":false,"borders":["IRQ","SAU"],"area":17818,"flag":"🇰🇼","demonyms":{"eng":{"f":"Kuwaiti","m":"Kuwaiti"},"fra":{"f":"Koweïtienne","m":"Koweïtien"}}},{"name":{"common":"Laos","official":"Lao People\'s Democratic Republic","native":{"lao":{"official":"ສາທາລະນະ ຊາທິປະໄຕ ຄົນລາວ ຂອງ","common":"ສປປລາວ"}}},"tld":[".la"],"cca2":"LA","ccn3":"418","cca3":"LAO","cioc":"LAO","independent":true,"status":"officially-assigned","currencies":{"LAK":{"name":"Lao kip","symbol":"₭"}},"idd":{"root":"+8","suffixes":["56"]},"capital":["Vientiane"],"altSpellings":["LA","Lao","Lao People\'s Democratic Republic","Sathalanalat Paxathipatai Paxaxon Lao"],"region":"Asia","subregion":"South-Eastern Asia","languages":{"lao":"Lao"},"translations":{"ces":{"official":"Laoská lidově demokratická republika","common":"Laos"},"deu":{"official":"Demokratische Volksrepublik Laos","common":"Laos"},"fra":{"official":"République démocratique populaire lao","common":"Laos"},"hrv":{"official":"Narodna Demokratska Republika","common":"Laos"},"ita":{"official":"Repubblica democratica popolare del Laos","common":"Laos"},"jpn":{"official":"ラオス人民民主共和国","common":"ラオス人民民主共和国"},"nld":{"official":"Lao Democratische Volksrepubliek","common":"Laos"},"por":{"official":"Laos, República Democrática","common":"Laos"},"rus":{"official":"Лаосская Народно-Демократическая Республика","common":"Лаос"},"slk":{"official":"Laoská ľudovodemokratická republika","common":"Laos"},"spa":{"official":"República Democrática Popular Lao","common":"Laos"},"fin":{"official":"Laosin demokraattinen kansantasavalta","common":"Laos"},"est":{"official":"Laose Demokraatlik Rahvavabariik","common":"Laos"},"zho":{"official":"老挝人民民主共和国","common":"老挝"},"pol":{"official":"Laotańska Republika Ludowo-Demokratyczna","common":"Laos"},"urd":{"official":"عوامی جمہوری جمہوریہ لاؤ","common":"لاؤس"},"kor":{"official":"라오 인민 민주 공화국","common":"라오스"},"per":{"official":"جمهوری دموکراتیک خلق لائوس","common":"لائوس"}},"latlng":[18,105],"landlocked":true,"borders":["MMR","KHM","CHN","THA","VNM"],"area":236800,"flag":"🇱🇦","demonyms":{"eng":{"f":"Laotian","m":"Laotian"},"fra":{"f":"Laotienne","m":"Laotien"}}},{"name":{"common":"Lebanon","official":"Lebanese Republic","native":{"ara":{"official":"الجمهورية اللبنانية","common":"لبنان"},"fra":{"official":"République libanaise","common":"Liban"}}},"tld":[".lb"],"cca2":"LB","ccn3":"422","cca3":"LBN","cioc":"LIB","independent":true,"status":"officially-assigned","currencies":{"LBP":{"name":"Lebanese pound","symbol":"ل.ل"}},"idd":{"root":"+9","suffixes":["61"]},"capital":["Beirut"],"altSpellings":["LB","Lebanese Republic","Al-Jumhūrīyah Al-Libnānīyah"],"region":"Asia","subregion":"Western Asia","languages":{"ara":"Arabic","fra":"French"},"translations":{"ces":{"official":"Libanonská republika","common":"Libanon"},"deu":{"official":"Libanesische Republik","common":"Libanon"},"fra":{"official":"République libanaise","common":"Liban"},"hrv":{"official":"Libanonska Republika","common":"Libanon"},"ita":{"official":"Repubblica libanese","common":"Libano"},"jpn":{"official":"レバノン共和国","common":"レバノン"},"nld":{"official":"Libanese Republiek","common":"Libanon"},"por":{"official":"República Libanesa","common":"Líbano"},"rus":{"official":"Ливанская Республика","common":"Ливан"},"slk":{"official":"Libanonská republika","common":"Libanon"},"spa":{"official":"República Libanesa","common":"Líbano"},"fin":{"official":"Libanonin tasavalta","common":"Libanon"},"est":{"official":"Liibanoni Vabariik","common":"Liibanon"},"zho":{"official":"黎巴嫩共和国","common":"黎巴嫩"},"pol":{"official":"Republika Libańska","common":"Liban"},"urd":{"official":"جمہوریہ لبنان","common":"لبنان"},"kor":{"official":"레바논 공화국","common":"레바논"},"per":{"official":"جمهوری لبنان","common":"لبنان"}},"latlng":[33.83333333,35.83333333],"landlocked":false,"borders":["ISR","SYR"],"area":10452,"flag":"🇱🇧","demonyms":{"eng":{"f":"Lebanese","m":"Lebanese"},"fra":{"f":"Libanaise","m":"Libanais"}}},{"name":{"common":"Liberia","official":"Republic of Liberia","native":{"eng":{"official":"Republic of Liberia","common":"Liberia"}}},"tld":[".lr"],"cca2":"LR","ccn3":"430","cca3":"LBR","cioc":"LBR","independent":true,"status":"officially-assigned","currencies":{"LRD":{"name":"Liberian dollar","symbol":"$"}},"idd":{"root":"+2","suffixes":["31"]},"capital":["Monrovia"],"altSpellings":["LR","Republic of Liberia"],"region":"Africa","subregion":"Western Africa","languages":{"eng":"English"},"translations":{"ces":{"official":"Liberijská republika","common":"Libérie"},"deu":{"official":"Republik Liberia","common":"Liberia"},"fra":{"official":"République du Libéria","common":"Liberia"},"hrv":{"official":"Republika Liberija","common":"Liberija"},"ita":{"official":"Repubblica di Liberia","common":"Liberia"},"jpn":{"official":"リベリア共和国","common":"リベリア"},"nld":{"official":"Republiek Liberia","common":"Liberia"},"por":{"official":"República da Libéria","common":"Libéria"},"rus":{"official":"Республика Либерия","common":"Либерия"},"slk":{"official":"Libérijská republika","common":"Libéria"},"spa":{"official":"República de Liberia","common":"Liberia"},"fin":{"official":"Liberian tasavalta","common":"Liberia"},"est":{"official":"Libeeria Vabariik","common":"Libeeria"},"zho":{"official":"利比里亚共和国","common":"利比里亚"},"pol":{"official":"Republika Liberii","common":"Liberia"},"urd":{"official":"جمہوریہ لائبیریا","common":"لائبیریا"},"kor":{"official":"라이베리아 공화국","common":"라이베리아"},"per":{"official":"جمهوری لیبریا","common":"لیبـِریا"}},"latlng":[6.5,-9.5],"landlocked":false,"borders":["GIN","CIV","SLE"],"area":111369,"flag":"🇱🇷","demonyms":{"eng":{"f":"Liberian","m":"Liberian"},"fra":{"f":"Libérienne","m":"Libérien"}}},{"name":{"common":"Libya","official":"State of Libya","native":{"ara":{"official":"الدولة ليبيا","common":"‏ليبيا"}}},"tld":[".ly"],"cca2":"LY","ccn3":"434","cca3":"LBY","cioc":"LBA","independent":true,"status":"officially-assigned","currencies":{"LYD":{"name":"Libyan dinar","symbol":"ل.د"}},"idd":{"root":"+2","suffixes":["18"]},"capital":["Tripoli"],"altSpellings":["LY","State of Libya","Dawlat Libya"],"region":"Africa","subregion":"Northern Africa","languages":{"ara":"Arabic"},"translations":{"ces":{"official":"Stát Libye","common":"Libye"},"deu":{"official":"Staat Libyen","common":"Libyen"},"fra":{"official":"Grande République arabe libyenne populaire et socialiste","common":"Libye"},"hrv":{"official":"Država Libiji","common":"Libija"},"ita":{"official":"Stato della Libia","common":"Libia"},"jpn":{"official":"リビアの国家","common":"リビア"},"nld":{"official":"Staat van Libië","common":"Libië"},"por":{"official":"Estado da Líbia","common":"Líbia"},"rus":{"official":"Государство Ливии","common":"Ливия"},"slk":{"official":"Líbya","common":"Líbya"},"spa":{"official":"Estado de Libia","common":"Libia"},"fin":{"official":"Libyan valtio","common":"Libya"},"est":{"official":"Liibüa","common":"Liibüa"},"zho":{"official":"利比亚国","common":"利比亚"},"pol":{"official":"Państwo Libia","common":"Libia"},"urd":{"official":"ریاستِ لیبیا","common":"لیبیا"},"kor":{"official":"리비아","common":"리비아"},"per":{"official":"دولت لیبی","common":"لیبی"}},"latlng":[25,17],"landlocked":false,"borders":["DZA","TCD","EGY","NER","SDN","TUN"],"area":1759540,"flag":"🇱🇾","demonyms":{"eng":{"f":"Libyan","m":"Libyan"},"fra":{"f":"Libyenne","m":"Libyen"}}},{"name":{"common":"Saint Lucia","official":"Saint Lucia","native":{"eng":{"official":"Saint Lucia","common":"Saint Lucia"}}},"tld":[".lc"],"cca2":"LC","ccn3":"662","cca3":"LCA","cioc":"LCA","independent":true,"status":"officially-assigned","currencies":{"XCD":{"name":"Eastern Caribbean dollar","symbol":"$"}},"idd":{"root":"+1","suffixes":["758"]},"capital":["Castries"],"altSpellings":["LC"],"region":"Americas","subregion":"Caribbean","languages":{"eng":"English"},"translations":{"ces":{"official":"Svatá Lucie","common":"Svatá Lucie"},"deu":{"official":"St. Lucia","common":"St. Lucia"},"fra":{"official":"Sainte-Lucie","common":"Sainte-Lucie"},"hrv":{"official":"Sveta Lucija","common":"Sveta Lucija"},"ita":{"official":"Santa Lucia","common":"Santa Lucia"},"jpn":{"official":"セントルシア","common":"セントルシア"},"nld":{"official":"Saint Lucia","common":"Saint Lucia"},"por":{"official":"Santa Lúcia","common":"Santa Lúcia"},"rus":{"official":"Сент-Люсия","common":"Сент-Люсия"},"slk":{"official":"Svätá Lucia","common":"Svätá Lucia"},"spa":{"official":"Santa Lucía","common":"Santa Lucía"},"fin":{"official":"Saint Lucia","common":"Saint Lucia"},"est":{"official":"Saint Lucia","common":"Saint Lucia"},"zho":{"official":"圣卢西亚","common":"圣卢西亚"},"pol":{"official":"Saint Lucia","common":"Saint Lucia"},"urd":{"official":"سینٹ لوسیا","common":"سینٹ لوسیا"},"kor":{"official":"세인트루시아","common":"세인트루시아"},"per":{"official":"سنت لوسیا","common":"سنت لوسیا"}},"latlng":[13.88333333,-60.96666666],"landlocked":false,"borders":[],"area":616,"flag":"🇱🇨","demonyms":{"eng":{"f":"Saint Lucian","m":"Saint Lucian"},"fra":{"f":"Saint-Lucienne","m":"Saint-Lucien"}}},{"name":{"common":"Liechtenstein","official":"Principality of Liechtenstein","native":{"deu":{"official":"Fürstentum Liechtenstein","common":"Liechtenstein"}}},"tld":[".li"],"cca2":"LI","ccn3":"438","cca3":"LIE","cioc":"LIE","independent":true,"status":"officially-assigned","currencies":{"CHF":{"name":"Swiss franc","symbol":"Fr"}},"idd":{"root":"+4","suffixes":["23"]},"capital":["Vaduz"],"altSpellings":["LI","Principality of Liechtenstein","Fürstentum Liechtenstein"],"region":"Europe","subregion":"Western Europe","languages":{"deu":"German"},"translations":{"ces":{"official":"Knížectví Lichtenštejnské","common":"Lichtenštejnsko"},"deu":{"official":"Fürstentum Liechtenstein","common":"Liechtenstein"},"fra":{"official":"Principauté du Liechtenstein","common":"Liechtenstein"},"hrv":{"official":"Kneževina Lihtenštajn","common":"Lihtenštajn"},"ita":{"official":"Principato del Liechtenstein","common":"Liechtenstein"},"jpn":{"official":"リヒテンシュタイン公国","common":"リヒテンシュタイン"},"nld":{"official":"Vorstendom Liechtenstein","common":"Liechtenstein"},"por":{"official":"Principado de Liechtenstein","common":"Liechtenstein"},"rus":{"official":"Княжество Лихтенштейн","common":"Лихтенштейн"},"slk":{"official":"Lichtenštajnské kniežatstvo","common":"Lichtenštajnsko"},"spa":{"official":"Principado de Liechtenstein","common":"Liechtenstein"},"fin":{"official":"Liechensteinin ruhtinaskunta","common":"Liechenstein"},"est":{"official":"Liechtensteini Vürstiriik","common":"Liechtenstein"},"zho":{"official":"列支敦士登公国","common":"列支敦士登"},"pol":{"official":"Księstwo Liechtensteinu","common":"Liechtenstein"},"urd":{"official":"امارات لیختینستائن","common":"لیختینستائن"},"kor":{"official":"리히텐슈타인 공국","common":"리히텐슈타인"},"per":{"official":"شاهزاده‌نشین لیختن‌اشتاین","common":"لیختن‌اشتاین"}},"latlng":[47.26666666,9.53333333],"landlocked":true,"borders":["AUT","CHE"],"area":160,"flag":"🇱🇮","demonyms":{"eng":{"f":"Liechtensteiner","m":"Liechtensteiner"},"fra":{"f":"Liechtensteinoise","m":"Liechtensteinois"}}},{"name":{"common":"Sri Lanka","official":"Democratic Socialist Republic of Sri Lanka","native":{"sin":{"official":"ශ්‍රී ලංකා ප්‍රජාතාන්ත්‍රික සමාජවාදී ජනරජය","common":"ශ්‍රී ලංකාව"},"tam":{"official":"இலங்கை சனநாயக சோசலிசக் குடியரசு","common":"இலங்கை"}}},"tld":[".lk",".இலங்கை",".ලංකා"],"cca2":"LK","ccn3":"144","cca3":"LKA","cioc":"SRI","independent":true,"status":"officially-assigned","currencies":{"LKR":{"name":"Sri Lankan rupee","symbol":"Rs  රු"}},"idd":{"root":"+9","suffixes":["4"]},"capital":["Colombo"],"altSpellings":["LK","ilaṅkai","Democratic Socialist Republic of Sri Lanka"],"region":"Asia","subregion":"Southern Asia","languages":{"sin":"Sinhala","tam":"Tamil"},"translations":{"ces":{"official":"Srílanská demokratická socialistická republika","common":"Srí Lanka"},"deu":{"official":"Demokratische Sozialistische Republik Sri Lanka","common":"Sri Lanka"},"fra":{"official":"République démocratique socialiste du Sri Lanka","common":"Sri Lanka"},"hrv":{"official":"Demokratska Socijalističke Republike Šri Lanke","common":"Šri Lanka"},"ita":{"official":"Repubblica democratica socialista dello Sri Lanka","common":"Sri Lanka"},"jpn":{"official":"スリランカ民主社会主義共和国","common":"スリランカ"},"nld":{"official":"Democratische Socialistische Republiek Sri Lanka","common":"Sri Lanka"},"por":{"official":"República Democrática Socialista do Sri Lanka","common":"Sri Lanka"},"rus":{"official":"Демократическая Социалистическая Республика Шри-Ланка","common":"Шри-Ланка"},"slk":{"official":"Srílanská demokratická socialistická republika","common":"Srí Lanka"},"spa":{"official":"República Democrática Socialista de Sri Lanka","common":"Sri Lanka"},"fin":{"official":"Sri Lankan demokraattinen sosialistinen tasavalta","common":"Sri Lanka"},"est":{"official":"Sri Lanka Demokraatlik Sotsialistlik Vabariik","common":"Sri Lanka"},"zho":{"official":"斯里兰卡民主社会主义共和国","common":"斯里兰卡"},"pol":{"official":"Demokratyczno-Socjalistyczna Republika Sri Lanki","common":"Sri Lanka"},"urd":{"official":"جمہوری و اشتراکی جمہوریہ سری لنکا","common":"سری لنکا"},"kor":{"official":"스리랑카 민주 사회주의 공화국","common":"스리랑카"},"per":{"official":"جمهوری دموکراتیک سوسیالیستی سری‌لانکا","common":"سری‌لانکا"}},"latlng":[7,81],"landlocked":false,"borders":["IND"],"area":65610,"flag":"🇱🇰","demonyms":{"eng":{"f":"Sri Lankan","m":"Sri Lankan"},"fra":{"f":"Sri-lankaise","m":"Sri-lankais"}}},{"name":{"common":"Lesotho","official":"Kingdom of Lesotho","native":{"eng":{"official":"Kingdom of Lesotho","common":"Lesotho"},"sot":{"official":"Kingdom of Lesotho","common":"Lesotho"}}},"tld":[".ls"],"cca2":"LS","ccn3":"426","cca3":"LSO","cioc":"LES","independent":true,"status":"officially-assigned","currencies":{"LSL":{"name":"Lesotho loti","symbol":"L"},"ZAR":{"name":"South African rand","symbol":"R"}},"idd":{"root":"+2","suffixes":["66"]},"capital":["Maseru"],"altSpellings":["LS","Kingdom of Lesotho","Muso oa Lesotho"],"region":"Africa","subregion":"Southern Africa","languages":{"eng":"English","sot":"Sotho"},"translations":{"ces":{"official":"Lesothské království","common":"Lesotho"},"deu":{"official":"Königreich Lesotho","common":"Lesotho"},"fra":{"official":"Royaume du Lesotho","common":"Lesotho"},"hrv":{"official":"Kraljevina Lesoto","common":"Lesoto"},"ita":{"official":"Regno del Lesotho","common":"Lesotho"},"jpn":{"official":"レソト王国","common":"レソト"},"nld":{"official":"Koninkrijk Lesotho","common":"Lesotho"},"por":{"official":"Reino do Lesoto","common":"Lesoto"},"rus":{"official":"Королевство Лесото","common":"Лесото"},"slk":{"official":"Lesothské kráľovstvo","common":"Lesotho"},"spa":{"official":"Reino de Lesotho","common":"Lesotho"},"fin":{"official":"Lesothon kuningaskunta","common":"Lesotho"},"est":{"official":"Lesotho Kuningriik","common":"Lesotho"},"zho":{"official":"莱索托王国","common":"莱索托"},"pol":{"official":"Królestwo Lesotho","common":"Lesotho"},"urd":{"official":"مملکتِ لیسوتھو","common":"لیسوتھو"},"kor":{"official":"레소토 왕국","common":"레소토"},"per":{"official":"پادشاهی لسوتو","common":"لسوتو"}},"latlng":[-29.5,28.5],"landlocked":true,"borders":["ZAF"],"area":30355,"flag":"🇱🇸","demonyms":{"eng":{"f":"Mosotho","m":"Mosotho"},"fra":{"f":"Lésothienne","m":"Lésothien"}}},{"name":{"common":"Lithuania","official":"Republic of Lithuania","native":{"lit":{"official":"Lietuvos Respublikos","common":"Lietuva"}}},"tld":[".lt"],"cca2":"LT","ccn3":"440","cca3":"LTU","cioc":"LTU","independent":true,"status":"officially-assigned","currencies":{"EUR":{"name":"Euro","symbol":"€"}},"idd":{"root":"+3","suffixes":["70"]},"capital":["Vilnius"],"altSpellings":["LT","Republic of Lithuania","Lietuvos Respublika"],"region":"Europe","subregion":"Northern Europe","languages":{"lit":"Lithuanian"},"translations":{"ces":{"official":"Litevská republika","common":"Litva"},"deu":{"official":"Republik Litauen","common":"Litauen"},"fra":{"official":"République de Lituanie","common":"Lituanie"},"hrv":{"official":"Republika Litva","common":"Litva"},"ita":{"official":"Repubblica di Lituania","common":"Lituania"},"jpn":{"official":"リトアニア共和国","common":"リトアニア"},"nld":{"official":"Republiek Litouwen","common":"Litouwen"},"por":{"official":"República da Lituânia","common":"Lituânia"},"rus":{"official":"Литовская Республика","common":"Литва"},"slk":{"official":"Litovská republika","common":"Litva"},"spa":{"official":"República de Lituania","common":"Lituania"},"fin":{"official":"Liettuan tasavalta","common":"Liettua"},"est":{"official":"Leedu Vabariik","common":"Leedu"},"zho":{"official":"立陶宛共和国","common":"立陶宛"},"pol":{"official":"Republika Litewska","common":"Litwa"},"urd":{"official":"جمہوریہ لتھووینیا","common":"لتھووینیا"},"kor":{"official":"리투아니아 공화국","common":"리투아니아"},"per":{"official":"لیتوانیایی‌ها","common":"لیتوانیایی‌ها"}},"latlng":[56,24],"landlocked":false,"borders":["BLR","LVA","POL","RUS"],"area":65300,"flag":"🇱🇹","demonyms":{"eng":{"f":"Lithuanian","m":"Lithuanian"},"fra":{"f":"Lituanienne","m":"Lituanien"}}},{"name":{"common":"Luxembourg","official":"Grand Duchy of Luxembourg","native":{"deu":{"official":"Großherzogtum Luxemburg","common":"Luxemburg"},"fra":{"official":"Grand-Duché de Luxembourg","common":"Luxembourg"},"ltz":{"official":"Groussherzogtum Lëtzebuerg","common":"Lëtzebuerg"}}},"tld":[".lu"],"cca2":"LU","ccn3":"442","cca3":"LUX","cioc":"LUX","independent":true,"status":"officially-assigned","currencies":{"EUR":{"name":"Euro","symbol":"€"}},"idd":{"root":"+3","suffixes":["52"]},"capital":["Luxembourg"],"altSpellings":["LU","Grand Duchy of Luxembourg","Grand-Duché de Luxembourg","Großherzogtum Luxemburg","Groussherzogtum Lëtzebuerg"],"region":"Europe","subregion":"Western Europe","languages":{"deu":"German","fra":"French","ltz":"Luxembourgish"},"translations":{"ces":{"official":"Lucemburské velkovévodství","common":"Lucembursko"},"deu":{"official":"Großherzogtum Luxemburg,","common":"Luxemburg"},"fra":{"official":"Grand-Duché de Luxembourg","common":"Luxembourg"},"hrv":{"official":"Veliko Vojvodstvo Luksemburg","common":"Luksemburg"},"ita":{"official":"Granducato di Lussemburgo","common":"Lussemburgo"},"jpn":{"official":"ルクセンブルク大公国","common":"ルクセンブルク"},"nld":{"official":"Groothertogdom Luxemburg","common":"Luxemburg"},"por":{"official":"Grão-Ducado do Luxemburgo","common":"Luxemburgo"},"rus":{"official":"Великое Герцогство Люксембург","common":"Люксембург"},"slk":{"official":"Luxemburské veľkovojvodstvo","common":"Luxembursko"},"spa":{"official":"Gran Ducado de Luxemburgo","common":"Luxemburgo"},"fin":{"official":"Luxemburgin suurherttuakunta","common":"Luxemburg"},"est":{"official":"Luksemburgi Suurhertsogiriik","common":"Luksemburg"},"zho":{"official":"卢森堡大公国","common":"卢森堡"},"pol":{"official":"Wielkie Księstwo Luksemburga","common":"Luksemburg"},"urd":{"official":"دوقیہ کبیرلکسمبرگ","common":"لکسمبرگ"},"kor":{"official":"룩셈부르크 대공국","common":"룩셈부르크"},"per":{"official":"دوک‌نشین لوکزامبورگ","common":"لوکزامبورگ"}},"latlng":[49.75,6.16666666],"landlocked":true,"borders":["BEL","FRA","DEU"],"area":2586,"flag":"🇱🇺","demonyms":{"eng":{"f":"Luxembourger","m":"Luxembourger"},"fra":{"f":"Luxembourgeoise","m":"Luxembourgeois"}}},{"name":{"common":"Latvia","official":"Republic of Latvia","native":{"lav":{"official":"Latvijas Republikas","common":"Latvija"}}},"tld":[".lv"],"cca2":"LV","ccn3":"428","cca3":"LVA","cioc":"LAT","independent":true,"status":"officially-assigned","currencies":{"EUR":{"name":"Euro","symbol":"€"}},"idd":{"root":"+3","suffixes":["71"]},"capital":["Riga"],"altSpellings":["LV","Republic of Latvia","Latvijas Republika"],"region":"Europe","subregion":"Northern Europe","languages":{"lav":"Latvian"},"translations":{"ces":{"official":"Lotyšská republika","common":"Lotyšsko"},"deu":{"official":"Republik Lettland","common":"Lettland"},"fra":{"official":"République de Lettonie","common":"Lettonie"},"hrv":{"official":"Republika Latvija","common":"Latvija"},"ita":{"official":"Repubblica di Lettonia","common":"Lettonia"},"jpn":{"official":"ラトビア共和国","common":"ラトビア"},"nld":{"official":"Republiek Letland","common":"Letland"},"por":{"official":"República da Letónia","common":"Letónia"},"rus":{"official":"Латвийская Республика","common":"Латвия"},"slk":{"official":"Lotyšská republika","common":"Lotyšsko"},"spa":{"official":"República de Letonia","common":"Letonia"},"fin":{"official":"Latvian tasavalta","common":"Latvia"},"est":{"official":"Läti Vabariik","common":"Läti"},"zho":{"official":"拉脱维亚共和国","common":"拉脱维亚"},"pol":{"official":"Republika Łotewska","common":"Łotwa"},"urd":{"official":"جمہوریہ لٹویا","common":"لٹویا"},"kor":{"official":"라트비아 공화국","common":"라트비아"},"per":{"official":"جمهوری لتونی","common":"لتونی"}},"latlng":[57,25],"landlocked":false,"borders":["BLR","EST","LTU","RUS"],"area":64559,"flag":"🇱🇻","demonyms":{"eng":{"f":"Latvian","m":"Latvian"},"fra":{"f":"Lettone","m":"Letton"}}},{"name":{"common":"Macau","official":"Macao Special Administrative Region of the People\'s Republic of China","native":{"por":{"official":"Região Administrativa Especial de Macau da República Popular da China","common":"Macau"},"zho":{"official":"中华人民共和国澳门特别行政区","common":"澳门"}}},"tld":[".mo"],"cca2":"MO","ccn3":"446","cca3":"MAC","cioc":"","independent":false,"status":"officially-assigned","currencies":{"MOP":{"name":"Macanese pataca","symbol":"P"}},"idd":{"root":"+8","suffixes":["53"]},"capital":[""],"altSpellings":["MO","澳门","Macao","Macao Special Administrative Region of the People\'s Republic of China","中華人民共和國澳門特別行政區","Região Administrativa Especial de Macau da República Popular da China"],"region":"Asia","subregion":"Eastern Asia","languages":{"por":"Portuguese","zho":"Chinese"},"translations":{"ces":{"official":"Zvláštní správní oblast Čínské lidové republiky Macao","common":"Macao"},"deu":{"official":"Sonderverwaltungsregion Macau der Volksrepublik China","common":"Macao"},"fra":{"official":"Région administrative spéciale de Macao de la République populaire de Chine","common":"Macao"},"hrv":{"official":"Makao Posebnog upravnog područjaNarodne Republike Kine","common":"Makao"},"ita":{"official":"Macao Regione amministrativa speciale della Repubblica Popolare Cinese","common":"Macao"},"jpn":{"official":"中華人民共和国マカオ特別行政区","common":"マカオ"},"nld":{"official":"Speciale Administratieve Regio Macau van de Volksrepubliek China","common":"Macao"},"por":{"official":"Macau Região Administrativa Especial da República Popular da China","common":"Macau"},"rus":{"official":"Специальный административный район Макао Китайской Народной Республики Китай","common":"Макао"},"slk":{"official":"Macao, Špeciàlna administratívna oblasŦ","common":"Macao"},"spa":{"official":"Macao, Región Administrativa Especial de la República Popular China","common":"Macao"},"fin":{"official":"Macaon Kiinan kansantasavallan erityishallintoalue","common":"Macao"},"est":{"official":"Macau erihalduspiirkond","common":"Macau"},"pol":{"official":"Specjalny Region Administracyjny Chińskiej Republiki Ludowej Makau","common":"Makau"},"urd":{"official":"مکاؤ عوامی جمہوریہ چین کا خصوصی انتظامی علاقہ","common":"مکاؤ"},"kor":{"official":"중화인민공화국 마카오 특별행정구","common":"마카오"},"per":{"official":"ماکائو","common":"ماکائو"}},"latlng":[22.16666666,113.55],"landlocked":false,"borders":["CHN"],"area":30,"flag":"🇲🇴","demonyms":{"eng":{"f":"Macanese","m":"Macanese"},"fra":{"f":"Macanaise","m":"Macanais"}}},{"name":{"common":"Saint Martin","official":"Saint Martin","native":{"fra":{"official":"Saint-Martin","common":"Saint-Martin"}}},"tld":[".fr",".gp"],"cca2":"MF","ccn3":"663","cca3":"MAF","cioc":"","independent":false,"status":"officially-assigned","currencies":{"EUR":{"name":"Euro","symbol":"€"}},"idd":{"root":"+5","suffixes":["90"]},"capital":["Marigot"],"altSpellings":["MF","Collectivity of Saint Martin","Collectivité de Saint-Martin","Saint Martin (French part)"],"region":"Americas","subregion":"Caribbean","languages":{"fra":"French"},"translations":{"ces":{"official":"Svatý Martin","common":"Svatý Martin (Francie)"},"deu":{"official":"Saint-Martin","common":"Saint-Martin"},"fra":{"official":"Saint-Martin","common":"Saint-Martin"},"hrv":{"official":"Saint Martin","common":"Sveti Martin"},"ita":{"official":"saint Martin","common":"Saint Martin"},"jpn":{"official":"サンマルタン島","common":"サン・マルタン（フランス領）"},"nld":{"official":"Saint Martin","common":"Saint-Martin"},"por":{"official":"saint Martin","common":"São Martinho"},"rus":{"official":"Сен-Мартен","common":"Сен-Мартен"},"slk":{"official":"Saint-Martin","common":"Saint-Martin"},"spa":{"official":"Saint Martin","common":"Saint Martin"},"fin":{"official":"Saint-Martin","common":"Saint-Martin"},"est":{"official":"Saint-Martini ühendus","common":"Saint-Martin"},"zho":{"official":"圣马丁","common":"圣马丁"},"pol":{"official":"Wspólnota Saint-Martin","common":"Saint-Martin"},"urd":{"official":"سینٹ مارٹن","common":"سینٹ مارٹن"},"kor":{"official":"생마르탱","common":"생마르탱"},"per":{"official":"سن مارتن","common":"سن مارتن"}},"latlng":[18.08333333,-63.95],"landlocked":false,"borders":["SXM"],"area":53,"flag":"🇲🇫","demonyms":{"eng":{"f":"Saint Martin Islander","m":"Saint Martin Islander"},"fra":{"f":"Saint-Martinoise","m":"Saint-Martinois"}}},{"name":{"common":"Morocco","official":"Kingdom of Morocco","native":{"ara":{"official":"المملكة المغربية","common":"المغرب"},"ber":{"official":"ⵜⴰⴳⵍⴷⵉⵜ ⵏ ⵍⵎⵖⵔⵉⴱ","common":"ⵍⵎⴰⵖⵔⵉⴱ"}}},"tld":[".ma","المغرب."],"cca2":"MA","ccn3":"504","cca3":"MAR","cioc":"MAR","independent":true,"status":"officially-assigned","currencies":{"MAD":{"name":"Moroccan dirham","symbol":"د.م."}},"idd":{"root":"+2","suffixes":["12"]},"capital":["Rabat"],"altSpellings":["MA","Kingdom of Morocco","Al-Mamlakah al-Maġribiyah"],"region":"Africa","subregion":"Northern Africa","languages":{"ara":"Arabic","ber":"Berber"},"translations":{"ces":{"official":"Marocké království","common":"Maroko"},"deu":{"official":"Königreich Marokko","common":"Marokko"},"fra":{"official":"Royaume du Maroc","common":"Maroc"},"hrv":{"official":"Kraljevina Maroko","common":"Maroko"},"ita":{"official":"Regno del Marocco","common":"Marocco"},"jpn":{"official":"モロッコ王国","common":"モロッコ"},"nld":{"official":"Koninkrijk Marokko","common":"Marokko"},"por":{"official":"Reino de Marrocos","common":"Marrocos"},"rus":{"official":"Королевство Марокко","common":"Марокко"},"slk":{"official":"Marocké kniežatstvo","common":"Maroko"},"spa":{"official":"Reino de Marruecos","common":"Marruecos"},"fin":{"official":"Marokon kuningaskunta","common":"Marokko"},"est":{"official":"Maroko Kuningriik","common":"Maroko"},"zho":{"official":"摩洛哥王国","common":"摩洛哥"},"pol":{"official":"Królestwo Marokańskie","common":"Maroko"},"urd":{"official":"مملکتِ مراکش","common":"مراکش"},"kor":{"official":"모로코 왕국","common":"모로코"},"per":{"official":"پادشاهی مراکش","common":"مراکش"}},"latlng":[32,-5],"landlocked":false,"borders":["DZA","ESH","ESP"],"area":446550,"flag":"🇲🇦","demonyms":{"eng":{"f":"Moroccan","m":"Moroccan"},"fra":{"f":"Marocaine","m":"Marocain"}}},{"name":{"common":"Monaco","official":"Principality of Monaco","native":{"fra":{"official":"Principauté de Monaco","common":"Monaco"}}},"tld":[".mc"],"cca2":"MC","ccn3":"492","cca3":"MCO","cioc":"MON","independent":true,"status":"officially-assigned","currencies":{"EUR":{"name":"Euro","symbol":"€"}},"idd":{"root":"+3","suffixes":["77"]},"capital":["Monaco"],"altSpellings":["MC","Principality of Monaco","Principauté de Monaco"],"region":"Europe","subregion":"Western Europe","languages":{"fra":"French"},"translations":{"ces":{"official":"Monacké knížectví","common":"Monako"},"deu":{"official":"Fürstentum Monaco","common":"Monaco"},"fra":{"official":"Principauté de Monaco","common":"Monaco"},"hrv":{"official":"Kneževina Monako","common":"Monako"},"ita":{"official":"Principato di Monaco","common":"Principato di Monaco"},"jpn":{"official":"モナコ公国","common":"モナコ"},"nld":{"official":"Vorstendom Monaco","common":"Monaco"},"por":{"official":"Principado do Mónaco","common":"Mónaco"},"rus":{"official":"Княжество Монако","common":"Монако"},"slk":{"official":"Monacké kniežatstvo","common":"Monako"},"spa":{"official":"Principado de Mónaco","common":"Mónaco"},"fin":{"official":"Monacon ruhtinaskunta","common":"Monaco"},"est":{"official":"Monaco Vürstiriik","common":"Monaco"},"zho":{"official":"摩纳哥公国","common":"摩纳哥"},"pol":{"official":"Księstwo Monako","common":"Monako"},"urd":{"official":"جمہوریہ مناکو","common":"موناکو"},"kor":{"official":"모나코 공국","common":"모나코"},"per":{"official":"شاهزاده‌نشین موناکو","common":"موناکو"}},"latlng":[43.73333333,7.4],"landlocked":false,"borders":["FRA"],"area":2.02,"flag":"🇲🇨","demonyms":{"eng":{"f":"Monegasque","m":"Monegasque"},"fra":{"f":"Monégasque","m":"Monégasque"}}},{"name":{"common":"Moldova","official":"Republic of Moldova","native":{"ron":{"official":"Republica Moldova","common":"Moldova"}}},"tld":[".md"],"cca2":"MD","ccn3":"498","cca3":"MDA","cioc":"MDA","independent":true,"status":"officially-assigned","currencies":{"MDL":{"name":"Moldovan leu","symbol":"L"}},"idd":{"root":"+3","suffixes":["73"]},"capital":["Chișinău"],"altSpellings":["MD","Moldova, Republic of","Republic of Moldova","Republica Moldova"],"region":"Europe","subregion":"Eastern Europe","languages":{"ron":"Moldavian"},"translations":{"ces":{"official":"Moldavská republika","common":"Moldavsko"},"deu":{"official":"Republik Moldau","common":"Moldawien"},"fra":{"official":"République de Moldavie","common":"Moldavie"},"hrv":{"official":"Moldavija","common":"Moldova"},"ita":{"official":"Repubblica di Moldova","common":"Moldavia"},"jpn":{"official":"モルドバ共和国","common":"モルドバ共和国"},"nld":{"official":"Republiek Moldavië","common":"Moldavië"},"por":{"official":"República da Moldávia","common":"Moldávia"},"rus":{"official":"Молдова","common":"Молдавия"},"slk":{"official":"Moldavská republika","common":"Moldavsko"},"spa":{"official":"República de Moldova","common":"Moldavia"},"fin":{"official":"Moldovan tasavalta","common":"Moldova"},"est":{"official":"Moldova Vabariik","common":"Moldova"},"zho":{"official":"摩尔多瓦共和国","common":"摩尔多瓦"},"pol":{"official":"Republika Mołdawii","common":"Mołdawia"},"urd":{"official":"جمہوریہ مالدووا","common":"مالدووا"},"kor":{"official":"몰도바 공화국","common":"몰도바"},"per":{"official":"جمهوری مولداوی","common":"مولداوی"}},"latlng":[47,29],"landlocked":true,"borders":["ROU","UKR"],"area":33846,"flag":"🇲🇩","demonyms":{"eng":{"f":"Moldovan","m":"Moldovan"},"fra":{"f":"Moldave","m":"Moldave"}}},{"name":{"common":"Madagascar","official":"Republic of Madagascar","native":{"fra":{"official":"République de Madagascar","common":"Madagascar"},"mlg":{"official":"Repoblikan\'i Madagasikara","common":"Madagasikara"}}},"tld":[".mg"],"cca2":"MG","ccn3":"450","cca3":"MDG","cioc":"MAD","independent":true,"status":"officially-assigned","currencies":{"MGA":{"name":"Malagasy ariary","symbol":"Ar"}},"idd":{"root":"+2","suffixes":["61"]},"capital":["Antananarivo"],"altSpellings":["MG","Republic of Madagascar","Repoblikan\'i Madagasikara","République de Madagascar"],"region":"Africa","subregion":"Eastern Africa","languages":{"fra":"French","mlg":"Malagasy"},"translations":{"ces":{"official":"Madagaskarská republika","common":"Madagaskar"},"deu":{"official":"Republik Madagaskar","common":"Madagaskar"},"fra":{"official":"République de Madagascar","common":"Madagascar"},"hrv":{"official":"Republika Madagaskar","common":"Madagaskar"},"ita":{"official":"Repubblica del Madagascar","common":"Madagascar"},"jpn":{"official":"マダガスカル共和国","common":"マダガスカル"},"nld":{"official":"Republiek Madagaskar","common":"Madagaskar"},"por":{"official":"República de Madagáscar","common":"Madagáscar"},"rus":{"official":"Республика Мадагаскар","common":"Мадагаскар"},"slk":{"official":"Madagaskarská republika","common":"Madagaskar"},"spa":{"official":"República de Madagascar","common":"Madagascar"},"fin":{"official":"Madagaskarin tasavalta","common":"Madagaskar"},"est":{"official":"Madagaskari Vabariik","common":"Madagaskar"},"zho":{"official":"马达加斯加共和国","common":"马达加斯加"},"pol":{"official":"Republika Madagaskaru","common":"Madagaskar"},"urd":{"official":"جمہوریہ مڈغاسکر","common":"مڈغاسکر"},"kor":{"official":"마다가스카르 공화국","common":"마다가스카르"},"per":{"official":"جمهوری ماداگاسکار","common":"ماداگاسکار"}},"latlng":[-20,47],"landlocked":false,"borders":[],"area":587041,"flag":"🇲🇬","demonyms":{"eng":{"f":"Malagasy","m":"Malagasy"},"fra":{"f":"Malgache","m":"Malgache"}}},{"name":{"common":"Maldives","official":"Republic of the Maldives","native":{"div":{"official":"ދިވެހިރާއްޖޭގެ ޖުމްހޫރިއްޔާ","common":"ދިވެހިރާއްޖޭގެ"}}},"tld":[".mv"],"cca2":"MV","ccn3":"462","cca3":"MDV","cioc":"MDV","independent":true,"status":"officially-assigned","currencies":{"MVR":{"name":"Maldivian rufiyaa","symbol":".ރ"}},"idd":{"root":"+9","suffixes":["60"]},"capital":["Malé"],"altSpellings":["MV","Maldive Islands","Republic of the Maldives","Dhivehi Raajjeyge Jumhooriyya"],"region":"Asia","subregion":"Southern Asia","languages":{"div":"Maldivian"},"translations":{"ces":{"official":"Maledivská republika","common":"Maledivy"},"deu":{"official":"Republik Malediven","common":"Malediven"},"fra":{"official":"République des Maldives","common":"Maldives"},"hrv":{"official":"Republika Maldivi","common":"Maldivi"},"ita":{"official":"Repubblica delle Maldive","common":"Maldive"},"jpn":{"official":"モルディブ共和国","common":"モルディブ"},"nld":{"official":"Republiek van de Malediven","common":"Maldiven"},"por":{"official":"República das Maldivas","common":"Maldivas"},"spa":{"official":"República de las Maldivas","common":"Maldivas"},"rus":{"official":"Республика Мальдивы","common":"Мальдивы"},"slk":{"official":"Maldivská republika","common":"Maldivy"},"fin":{"official":"Malediivien tasavalta","common":"Malediivit"},"est":{"official":"Maldiivi Vabariik","common":"Maldiivid"},"zho":{"official":"马尔代夫共和国","common":"马尔代夫"},"pol":{"official":"Republika Malediwów","common":"Malediwy"},"urd":{"official":"جمہوریہ مالدیپ","common":"مالدیپ"},"kor":{"official":"몰디브 공화국","common":"몰디브"},"per":{"official":"جمهوری مالدیو","common":"مالدیو"}},"latlng":[3.25,73],"landlocked":false,"borders":[],"area":300,"flag":"🇲🇻","demonyms":{"eng":{"f":"Maldivan","m":"Maldivan"},"fra":{"f":"Maldivienne","m":"Maldivien"}}},{"name":{"common":"Mexico","official":"United Mexican States","native":{"spa":{"official":"Estados Unidos Mexicanos","common":"México"}}},"tld":[".mx"],"cca2":"MX","ccn3":"484","cca3":"MEX","cioc":"MEX","independent":true,"status":"officially-assigned","currencies":{"MXN":{"name":"Mexican peso","symbol":"$"}},"idd":{"root":"+5","suffixes":["2"]},"capital":["Mexico City"],"altSpellings":["MX","Mexicanos","United Mexican States","Estados Unidos Mexicanos"],"region":"Americas","subregion":"North America","languages":{"spa":"Spanish"},"translations":{"ces":{"official":"Spojené státy mexické","common":"Mexiko"},"deu":{"official":"Vereinigte Mexikanische Staaten","common":"Mexiko"},"fra":{"official":"États-Unis du Mexique","common":"Mexique"},"hrv":{"official":"Sjedinjene Meksičke Države","common":"Meksiko"},"ita":{"official":"Stati Uniti del Messico","common":"Messico"},"jpn":{"official":"メキシコ合衆国","common":"メキシコ"},"nld":{"official":"Verenigde Mexicaanse Staten","common":"Mexico"},"por":{"official":"Estados Unidos Mexicanos","common":"México"},"rus":{"official":"Мексиканские Соединённые Штаты","common":"Мексика"},"slk":{"official":"Spojené štášy mexické","common":"Mexiko"},"spa":{"official":"Estados Unidos Mexicanos","common":"México"},"fin":{"official":"Meksikon yhdysvallat","common":"Meksiko"},"est":{"official":"Mehhiko Ühendriigid","common":"Mehhiko"},"zho":{"official":"墨西哥合众国","common":"墨西哥"},"pol":{"official":"Meksykańskie Stany Zjednoczone","common":"Meksyk"},"urd":{"official":"ریاستہائے متحدہ میکسیکو","common":"میکسیکو"},"kor":{"official":"멕시코 합중국","common":"멕시코"},"per":{"official":"ایالات متحد مکزیک","common":"مکزیک"}},"latlng":[23,-102],"landlocked":false,"borders":["BLZ","GTM","USA"],"area":1964375,"flag":"🇲🇽","demonyms":{"eng":{"f":"Mexican","m":"Mexican"},"fra":{"f":"Mexicaine","m":"Mexicain"}}},{"name":{"common":"Marshall Islands","official":"Republic of the Marshall Islands","native":{"eng":{"official":"Republic of the Marshall Islands","common":"Marshall Islands"},"mah":{"official":"Republic of the Marshall Islands","common":"M̧ajeļ"}}},"tld":[".mh"],"cca2":"MH","ccn3":"584","cca3":"MHL","cioc":"MHL","independent":true,"status":"officially-assigned","currencies":{"USD":{"name":"United States dollar","symbol":"$"}},"idd":{"root":"+6","suffixes":["92"]},"capital":["Majuro"],"altSpellings":["MH","Republic of the Marshall Islands","Aolepān Aorōkin M̧ajeļ"],"region":"Oceania","subregion":"Micronesia","languages":{"eng":"English","mah":"Marshallese"},"translations":{"ces":{"official":"Republika Marshallovy ostrovy","common":"Marshallovy ostrovy"},"deu":{"official":"Republik Marshallinseln","common":"Marshallinseln"},"fra":{"official":"République des Îles Marshall","common":"Îles Marshall"},"hrv":{"official":"Republika Maršalovi Otoci","common":"Maršalovi Otoci"},"ita":{"official":"Repubblica delle Isole Marshall","common":"Isole Marshall"},"jpn":{"official":"マーシャル諸島共和国","common":"マーシャル諸島"},"nld":{"official":"Republiek van de Marshall-eilanden","common":"Marshalleilanden"},"por":{"official":"República das Ilhas Marshall","common":"Ilhas Marshall"},"rus":{"official":"Республика Маршалловы острова","common":"Маршалловы Острова"},"slk":{"official":"Republika Marshallových ostrovov","common":"Marshallove ostrovy"},"spa":{"official":"República de las Islas Marshall","common":"Islas Marshall"},"fin":{"official":"Marshallinsaarten tasavalta","common":"Marshallinsaaret"},"est":{"official":"Marshalli Saarte Vabariik","common":"Marshalli Saared"},"zho":{"official":"马绍尔群岛共和国","common":"马绍尔群岛"},"pol":{"official":"Republika Wysp Marshalla","common":"Wyspy Marshalla"},"urd":{"official":"جمہوریہ جزائر مارشل","common":"جزائر مارشل"},"kor":{"official":"마셜 제도 공화국","common":"마셜 제도"},"per":{"official":"جمهوری جزایر مارشال","common":"جزایر مارشال"}},"latlng":[9,168],"landlocked":false,"borders":[],"area":181,"flag":"🇲🇭","demonyms":{"eng":{"f":"Marshallese","m":"Marshallese"},"fra":{"f":"Marshallaise","m":"Marshallais"}}},{"name":{"common":"North Macedonia","official":"Republic of North Macedonia","native":{"mkd":{"official":"Република Северна Македонија","common":"Македонија"}}},"tld":[".mk"],"cca2":"MK","ccn3":"807","cca3":"MKD","cioc":"MKD","independent":true,"status":"officially-assigned","currencies":{"MKD":{"name":"denar","symbol":"den"}},"idd":{"root":"+3","suffixes":["89"]},"capital":["Skopje"],"altSpellings":["MK","The former Yugoslav Republic of Macedonia","Republic of North Macedonia","Macedonia, The Former Yugoslav Republic of","Република Северна Македонија"],"region":"Europe","subregion":"Southern Europe","languages":{"mkd":"Macedonian"},"translations":{"ces":{"official":"Republika Severní Makedonie","common":"Severní Makedonie"},"deu":{"official":"Republik Nordmazedonien","common":"Nordmazedonien"},"fra":{"official":"République de Macédoine du Nord","common":"Macédoine du Nord"},"hrv":{"official":"Republika Sjeverna Makedonija","common":"Sjeverna Makedonija"},"ita":{"official":"Repubblica di Macedonia del Nord","common":"Macedonia del Nord"},"jpn":{"official":"北マケドニア共和国","common":"北マケドニア "},"nld":{"official":"Republiek Noord-Macedonië","common":"Noord-Macedonië"},"por":{"official":"República da Macedônia do Norte","common":"Macedónia do Norte"},"rus":{"official":"Республика Северная Македония","common":"Северная Македония"},"slk":{"official":"Severomacedónska republika","common":"Severné Macedónsko"},"spa":{"official":"República de Macedonia del Norte","common":"Macedonia del Norte"},"fin":{"official":"Pohjois-Makedonian tasavalta","common":"Pohjois-Makedonia"},"est":{"official":"Põhja-Makedoonia Vabariik","common":"Põhja-Makedoonia"},"zho":{"official":"北馬其頓共和國","common":"北馬其頓"},"pol":{"official":"Republika Macedonii Północnej","common":"Macedonia Północna"},"urd":{"official":"جمہوریہ مقدونیہ","common":"شمالی مقدونیہ"},"kor":{"official":"북마케도니아 공화국","common":"북마케도니아"},"per":{"official":"جمهوری مقدونیه شمالی","common":"مقدونیه شمالی"}},"latlng":[41.83333333,22],"landlocked":true,"borders":["ALB","BGR","GRC","UNK","SRB"],"area":25713,"flag":"🇲🇰","demonyms":{"eng":{"f":"Macedonian","m":"Macedonian"},"fra":{"f":"Macédonienne","m":"Macédonien"}}},{"name":{"common":"Mali","official":"Republic of Mali","native":{"fra":{"official":"République du Mali","common":"Mali"}}},"tld":[".ml"],"cca2":"ML","ccn3":"466","cca3":"MLI","cioc":"MLI","independent":true,"status":"officially-assigned","currencies":{"XOF":{"name":"West African CFA franc","symbol":"Fr"}},"idd":{"root":"+2","suffixes":["23"]},"capital":["Bamako"],"altSpellings":["ML","Republic of Mali","République du Mali"],"region":"Africa","subregion":"Western Africa","languages":{"fra":"French"},"translations":{"ces":{"official":"Republika Mali","common":"Mali"},"deu":{"official":"Republik Mali","common":"Mali"},"fra":{"official":"République du Mali","common":"Mali"},"hrv":{"official":"Republika Mali","common":"Mali"},"ita":{"official":"Repubblica del Mali","common":"Mali"},"jpn":{"official":"マリ共和国","common":"マリ"},"nld":{"official":"Republiek Mali","common":"Mali"},"por":{"official":"República do Mali","common":"Mali"},"rus":{"official":"Республика Мали","common":"Мали"},"slk":{"official":"Malijská republika","common":"Mali"},"spa":{"official":"República de Malí","common":"Mali"},"fin":{"official":"Malin tasavalta","common":"Mali"},"est":{"official":"Mali Vabariik","common":"Mali"},"zho":{"official":"马里共和国","common":"马里"},"pol":{"official":"Republika Mali","common":"Mali"},"urd":{"official":"جمہوریہ مالی","common":"مالی"},"kor":{"official":"말리 공화국","common":"말리"},"per":{"official":"جمهوری مالی","common":"مالی"}},"latlng":[17,-4],"landlocked":true,"borders":["DZA","BFA","GIN","CIV","MRT","NER","SEN"],"area":1240192,"flag":"🇲🇱","demonyms":{"eng":{"f":"Malian","m":"Malian"},"fra":{"f":"Malienne","m":"Malien"}}},{"name":{"common":"Malta","official":"Republic of Malta","native":{"eng":{"official":"Republic of Malta","common":"Malta"},"mlt":{"official":"Repubblika ta \' Malta","common":"Malta"}}},"tld":[".mt"],"cca2":"MT","ccn3":"470","cca3":"MLT","cioc":"MLT","independent":true,"status":"officially-assigned","currencies":{"EUR":{"name":"Euro","symbol":"€"}},"idd":{"root":"+3","suffixes":["56"]},"capital":["Valletta"],"altSpellings":["MT","Republic of Malta","Repubblika ta\' Malta"],"region":"Europe","subregion":"Southern Europe","languages":{"eng":"English","mlt":"Maltese"},"translations":{"ces":{"official":"Maltská republika","common":"Malta"},"deu":{"official":"Republik Malta","common":"Malta"},"fra":{"official":"République de Malte","common":"Malte"},"hrv":{"official":"Republika Malta","common":"Malta"},"ita":{"official":"Repubblica di Malta","common":"Malta"},"jpn":{"official":"マルタ共和国","common":"マルタ"},"nld":{"official":"Republiek Malta","common":"Malta"},"por":{"official":"República de Malta","common":"Malta"},"rus":{"official":"Республика Мальта","common":"Мальта"},"slk":{"official":"Maltská republika","common":"Malta"},"spa":{"official":"República de Malta","common":"Malta"},"fin":{"official":"Maltan tasavalta","common":"Malta"},"est":{"official":"Malta Vabariik","common":"Malta"},"zho":{"official":"马耳他共和国","common":"马耳他"},"pol":{"official":"Republika Malty","common":"Malta"},"urd":{"official":"جمہوریہ مالٹا","common":"مالٹا"},"kor":{"official":"몰타 공화국","common":"몰타"},"per":{"official":"جمهوری مالت","common":"مالت"}},"latlng":[35.83333333,14.58333333],"landlocked":false,"borders":[],"area":316,"flag":"🇲🇹","demonyms":{"eng":{"f":"Maltese","m":"Maltese"},"fra":{"f":"Maltaise","m":"Maltais"}}},{"name":{"common":"Myanmar","official":"Republic of the Union of Myanmar","native":{"mya":{"official":"ပြည်ထောင်စု သမ္မတ မြန်မာနိုင်ငံတော်","common":"မြန်မာ"}}},"tld":[".mm"],"cca2":"MM","ccn3":"104","cca3":"MMR","cioc":"MYA","independent":true,"status":"officially-assigned","currencies":{"MMK":{"name":"Burmese kyat","symbol":"Ks"}},"idd":{"root":"+9","suffixes":["5"]},"capital":["Naypyidaw"],"altSpellings":["MM","Burma","Republic of the Union of Myanmar","Pyidaunzu Thanmăda Myăma Nainngandaw"],"region":"Asia","subregion":"South-Eastern Asia","languages":{"mya":"Burmese"},"translations":{"ces":{"official":"Republika Myanmarský svaz","common":"Myanmar"},"deu":{"official":"Republik der Union Myanmar","common":"Myanmar"},"fra":{"official":"République de l\'Union du Myanmar","common":"Birmanie"},"hrv":{"official":"Republika Unije Mijanmar","common":"Mijanmar"},"ita":{"official":"Repubblica dell\'Unione di Myanmar","common":"Birmania"},"jpn":{"official":"ミャンマー連邦共和国","common":"ミャンマー"},"nld":{"official":"Republiek van de Unie van Myanmar","common":"Myanmar"},"por":{"official":"República da União de Myanmar","common":"Myanmar"},"rus":{"official":"Республика Союза Мьянма","common":"Мьянма"},"slk":{"official":"Mjanmarská zväzová republika","common":"Mjanmarsko"},"spa":{"official":"República de la Unión de Myanmar","common":"Myanmar"},"fin":{"official":"Myanmarin liiton tasavalta","common":"Myanmar"},"est":{"official":"Myanmari Liidu Vabariik","common":"Myanmar"},"zho":{"official":"缅甸联邦共和国","common":"缅甸"},"pol":{"official":"Republika Związku Mjanmy","common":"Mjanma"},"urd":{"official":"متحدہ جمہوریہ میانمار","common":"میانمار"},"kor":{"official":"미얀마 연방 공화국","common":"미얀마"},"per":{"official":"اتحادیه جمهوری میانمار","common":"میانمار"}},"latlng":[22,98],"landlocked":false,"borders":["BGD","CHN","IND","LAO","THA"],"area":676578,"flag":"🇲🇲","demonyms":{"eng":{"f":"Burmese","m":"Burmese"},"fra":{"f":"Birmane","m":"Birman"}}},{"name":{"common":"Montenegro","official":"Montenegro","native":{"srp":{"official":"Црна Гора","common":"Црна Гора"}}},"tld":[".me"],"cca2":"ME","ccn3":"499","cca3":"MNE","cioc":"MNE","independent":true,"status":"officially-assigned","currencies":{"EUR":{"name":"Euro","symbol":"€"}},"idd":{"root":"+3","suffixes":["82"]},"capital":["Podgorica"],"altSpellings":["ME","Crna Gora"],"region":"Europe","subregion":"Southern Europe","languages":{"srp":"Montenegrin"},"translations":{"ces":{"official":"Černá Hora","common":"Černá Hora"},"deu":{"official":"Montenegro","common":"Montenegro"},"fra":{"official":"Monténégro","common":"Monténégro"},"hrv":{"official":"Crna Gora","common":"Crna Gora"},"ita":{"official":"Montenegro","common":"Montenegro"},"jpn":{"official":"モンテネグロ","common":"モンテネグロ"},"nld":{"official":"Montenegro","common":"Montenegro"},"por":{"official":"Montenegro","common":"Montenegro"},"rus":{"official":"Черногория","common":"Черногория"},"slk":{"official":"Čierna Hora","common":"Čierna Hora"},"spa":{"official":"Montenegro","common":"Montenegro"},"fin":{"official":"Montenegro","common":"Montenegro"},"est":{"official":"Montenegro","common":"Montenegro"},"zho":{"official":"黑山","common":"黑山"},"pol":{"official":"Czarnogóra","common":"Czarnogóra"},"urd":{"official":"مونٹینیگرو","common":"مونٹینیگرو"},"kor":{"official":"몬테네그로","common":"몬테네그로"},"per":{"official":"مونته‌نگرو","common":"مونته‌نگرو"}},"latlng":[42.5,19.3],"landlocked":false,"borders":["ALB","BIH","HRV","UNK","SRB"],"area":13812,"flag":"🇲🇪","demonyms":{"eng":{"f":"Montenegrin","m":"Montenegrin"},"fra":{"f":"Monténégrine","m":"Monténégrin"}}},{"name":{"common":"Mongolia","official":"Mongolia","native":{"mon":{"official":"Монгол улс","common":"Монгол улс"}}},"tld":[".mn"],"cca2":"MN","ccn3":"496","cca3":"MNG","cioc":"MGL","independent":true,"status":"officially-assigned","currencies":{"MNT":{"name":"Mongolian tögrög","symbol":"₮"}},"idd":{"root":"+9","suffixes":["76"]},"capital":["Ulan Bator"],"altSpellings":["MN"],"region":"Asia","subregion":"Eastern Asia","languages":{"mon":"Mongolian"},"translations":{"ces":{"official":"Stát Mongolsko","common":"Mongolsko"},"deu":{"official":"Mongolei","common":"Mongolei"},"fra":{"official":"Mongolie","common":"Mongolie"},"hrv":{"official":"Mongolija","common":"Mongolija"},"ita":{"official":"Mongolia","common":"Mongolia"},"jpn":{"official":"モンゴル","common":"モンゴル"},"nld":{"official":"Mongolië","common":"Mongolië"},"por":{"official":"Mongólia","common":"Mongólia"},"rus":{"official":"Монголия","common":"Монголия"},"slk":{"official":"Mongolsko","common":"Mongolsko"},"spa":{"official":"Mongolia","common":"Mongolia"},"fin":{"official":"Mongolian tasavalta","common":"Mongolia"},"est":{"official":"Mongoolia","common":"Mongoolia"},"zho":{"official":"蒙古","common":"蒙古"},"pol":{"official":"Mongolia","common":"Mongolia"},"urd":{"official":"منگولیا","common":"منگولیا"},"kor":{"official":"몽골","common":"몽골국"},"per":{"official":"مغولستان","common":"مغولستان"}},"latlng":[46,105],"landlocked":true,"borders":["CHN","RUS"],"area":1564110,"flag":"🇲🇳","demonyms":{"eng":{"f":"Mongolian","m":"Mongolian"},"fra":{"f":"Mongole","m":"Mongol"}}},{"name":{"common":"Northern Mariana Islands","official":"Commonwealth of the Northern Mariana Islands","native":{"cal":{"official":"Commonwealth of the Northern Mariana Islands","common":"Northern Mariana Islands"},"cha":{"official":"Sankattan Siha Na Islas Mariånas","common":"Na Islas Mariånas"},"eng":{"official":"Commonwealth of the Northern Mariana Islands","common":"Northern Mariana Islands"}}},"tld":[".mp"],"cca2":"MP","ccn3":"580","cca3":"MNP","cioc":"","independent":false,"status":"officially-assigned","currencies":{"USD":{"name":"United States dollar","symbol":"$"}},"idd":{"root":"+1","suffixes":["670"]},"capital":["Saipan"],"altSpellings":["MP","Commonwealth of the Northern Mariana Islands","Sankattan Siha Na Islas Mariånas"],"region":"Oceania","subregion":"Micronesia","languages":{"cal":"Carolinian","cha":"Chamorro","eng":"English"},"translations":{"ces":{"official":"Společenství Severních Marian","common":"Severní Mariany"},"deu":{"official":"Commonwealth der Nördlichen Marianen","common":"Nördliche Marianen"},"fra":{"official":"Commonwealth des îles Mariannes du Nord","common":"Îles Mariannes du Nord"},"hrv":{"official":"Zajednica je Sjeverni Marijanski otoci","common":"Sjevernomarijanski otoci"},"ita":{"official":"Commonwealth delle Isole Marianne Settentrionali","common":"Isole Marianne Settentrionali"},"jpn":{"official":"北マリアナ諸島","common":"北マリアナ諸島"},"nld":{"official":"Commonwealth van de Noordelijke Marianen","common":"Noordelijke Marianeneilanden"},"por":{"official":"Comunidade das Ilhas Marianas do Norte","common":"Marianas Setentrionais"},"rus":{"official":"Содружество Северных Марианских островов","common":"Северные Марианские острова"},"slk":{"official":"Spoločenstvo ostrovov Severné Mariány","common":"Severné Mariány"},"spa":{"official":"Mancomunidad de las Islas Marianas del Norte","common":"Islas Marianas del Norte"},"fin":{"official":"Pohjois-Mariaanit","common":"Pohjois-Mariaanit"},"est":{"official":"Põhja-Mariaani Ühendus","common":"Põhja-Mariaanid"},"zho":{"official":"北马里亚纳群岛","common":"北马里亚纳群岛"},"pol":{"official":"Wspólnota Marianów Północnych","common":"Mariany Północne"},"urd":{"official":"دولتِ مشترکہ جزائر شمالی ماریانا","common":"جزائر شمالی ماریانا"},"kor":{"official":"북마리아나 제도","common":"북마리아나 제도"},"per":{"official":"جزایر ماریانای شمالی","common":"جزایر ماریانای شمالی"}},"latlng":[15.2,145.75],"landlocked":false,"borders":[],"area":464,"flag":"🇲🇵","demonyms":{"eng":{"f":"American","m":"American"},"fra":{"f":"Américaine","m":"Américan"}}},{"name":{"common":"Mozambique","official":"Republic of Mozambique","native":{"por":{"official":"República de Moçambique","common":"Moçambique"}}},"tld":[".mz"],"cca2":"MZ","ccn3":"508","cca3":"MOZ","cioc":"MOZ","independent":true,"status":"officially-assigned","currencies":{"MZN":{"name":"Mozambican metical","symbol":"MT"}},"idd":{"root":"+2","suffixes":["58"]},"capital":["Maputo"],"altSpellings":["MZ","Republic of Mozambique","República de Moçambique"],"region":"Africa","subregion":"Eastern Africa","languages":{"por":"Portuguese"},"translations":{"ces":{"official":"Mosambická republika","common":"Mosambik"},"deu":{"official":"Republik Mosambik","common":"Mosambik"},"fra":{"official":"République du Mozambique","common":"Mozambique"},"hrv":{"official":"Republika Mozambiku","common":"Mozambik"},"ita":{"official":"Repubblica del Mozambico","common":"Mozambico"},"jpn":{"official":"モザンビーク共和国","common":"モザンビーク"},"nld":{"official":"Republiek Mozambique","common":"Mozambique"},"por":{"official":"República de Moçambique","common":"Moçambique"},"rus":{"official":"Республика Мозамбик","common":"Мозамбик"},"slk":{"official":"Mozambická republika","common":"Mozambik"},"spa":{"official":"República de Mozambique","common":"Mozambique"},"fin":{"official":"Mosambikin tasavalta","common":"Mosambik"},"est":{"official":"Mosambiigi Vabariik","common":"Mosambiik"},"zho":{"official":"莫桑比克共和国","common":"莫桑比克"},"pol":{"official":"Republika Mozambiku","common":"Mozambik"},"urd":{"official":"جمہوریہ موزمبیق","common":"موزمبیق"},"kor":{"official":"모잠비크 공화국","common":"모잠비크"},"per":{"official":"جمهوری موزامبیک","common":"موزامبیک"}},"latlng":[-18.25,35],"landlocked":false,"borders":["MWI","ZAF","SWZ","TZA","ZMB","ZWE"],"area":801590,"flag":"🇲🇿","demonyms":{"eng":{"f":"Mozambican","m":"Mozambican"},"fra":{"f":"Mozambicaine","m":"Mozambicain"}}},{"name":{"common":"Mauritania","official":"Islamic Republic of Mauritania","native":{"ara":{"official":"الجمهورية الإسلامية الموريتانية","common":"موريتانيا"}}},"tld":[".mr"],"cca2":"MR","ccn3":"478","cca3":"MRT","cioc":"MTN","independent":true,"status":"officially-assigned","currencies":{"MRU":{"name":"Mauritanian ouguiya","symbol":"UM"}},"idd":{"root":"+2","suffixes":["22"]},"capital":["Nouakchott"],"altSpellings":["MR","Islamic Republic of Mauritania","al-Jumhūriyyah al-ʾIslāmiyyah al-Mūrītāniyyah"],"region":"Africa","subregion":"Western Africa","languages":{"ara":"Arabic"},"translations":{"ces":{"official":"Mauritánská islámská republika","common":"Mauritánie"},"deu":{"official":"Islamische Republik Mauretanien","common":"Mauretanien"},"fra":{"official":"République islamique de Mauritanie","common":"Mauritanie"},"hrv":{"official":"Islamska Republika Mauritanija","common":"Mauritanija"},"ita":{"official":"Repubblica islamica di Mauritania","common":"Mauritania"},"jpn":{"official":"モーリタニア·イスラム共和国","common":"モーリタニア"},"nld":{"official":"Islamitische Republiek Mauritanië","common":"Mauritanië"},"por":{"official":"República Islâmica da Mauritânia","common":"Mauritânia"},"rus":{"official":"Исламская Республика Мавритания","common":"Мавритания"},"slk":{"official":"Mauritánska islamská republika","common":"Mauritánia"},"spa":{"official":"República Islámica de Mauritania","common":"Mauritania"},"fin":{"official":"Mauritanian islamilainen tasavalta","common":"Mauritania"},"est":{"official":"Mauritaania Islamivabariik","common":"Mauritaania"},"zho":{"official":"毛里塔尼亚伊斯兰共和国","common":"毛里塔尼亚"},"pol":{"official":"Islamska Republika Mauretańska","common":"Mauretania"},"urd":{"official":"اسلامی جمہوریہ موریتانیہ","common":"موریتانیہ"},"kor":{"official":"모리타니 이슬람 공화국","common":"모리타니"},"per":{"official":"جمهوری اسلامی موریتانی","common":"موریتانی"}},"latlng":[20,-12],"landlocked":false,"borders":["DZA","MLI","SEN","ESH"],"area":1030700,"flag":"🇲🇷","demonyms":{"eng":{"f":"Mauritanian","m":"Mauritanian"},"fra":{"f":"Mauritanienne","m":"Mauritanien"}}},{"name":{"common":"Montserrat","official":"Montserrat","native":{"eng":{"official":"Montserrat","common":"Montserrat"}}},"tld":[".ms"],"cca2":"MS","ccn3":"500","cca3":"MSR","cioc":"","independent":false,"status":"officially-assigned","currencies":{"XCD":{"name":"Eastern Caribbean dollar","symbol":"$"}},"idd":{"root":"+1","suffixes":["664"]},"capital":["Plymouth"],"altSpellings":["MS"],"region":"Americas","subregion":"Caribbean","languages":{"eng":"English"},"translations":{"ces":{"official":"Montserrat","common":"Montserrat"},"deu":{"official":"Montserrat","common":"Montserrat"},"fra":{"official":"Montserrat","common":"Montserrat"},"hrv":{"official":"Montserrat","common":"Montserrat"},"ita":{"official":"Montserrat","common":"Montserrat"},"jpn":{"official":"モントセラト","common":"モントセラト"},"nld":{"official":"Montserrat","common":"Montserrat"},"por":{"official":"Montserrat","common":"Montserrat"},"rus":{"official":"Монтсеррат","common":"Монтсеррат"},"slk":{"official":"Montserrat","common":"Montserrat"},"spa":{"official":"Montserrat","common":"Montserrat"},"fin":{"official":"Montserrat","common":"Montserrat"},"est":{"official":"Montserrat","common":"Montserrat"},"zho":{"official":"蒙特塞拉特","common":"蒙特塞拉特"},"pol":{"official":"Montserrat","common":"Montserrat"},"urd":{"official":"مانٹسریٹ","common":"مانٹسریٹ"},"kor":{"official":"몬트세랫","common":"몬트세랫"},"per":{"official":"مونتسرات","common":"مونتسرات"}},"latlng":[16.75,-62.2],"landlocked":false,"borders":[],"area":102,"flag":"🇲🇸","demonyms":{"eng":{"f":"Montserratian","m":"Montserratian"},"fra":{"f":"Montserratienne","m":"Montserratien"}}},{"name":{"common":"Martinique","official":"Martinique","native":{"fra":{"official":"Martinique","common":"Martinique"}}},"tld":[".mq"],"cca2":"MQ","ccn3":"474","cca3":"MTQ","cioc":"","independent":false,"status":"officially-assigned","currencies":{"EUR":{"name":"Euro","symbol":"€"}},"idd":{"root":"+5","suffixes":["96"]},"capital":["Fort-de-France"],"altSpellings":["MQ"],"region":"Americas","subregion":"Caribbean","languages":{"fra":"French"},"translations":{"ces":{"official":"Martinik","common":"Martinik"},"deu":{"official":"Martinique","common":"Martinique"},"fra":{"official":"Martinique","common":"Martinique"},"hrv":{"official":"Martinique","common":"Martinique"},"ita":{"official":"Martinique","common":"Martinica"},"jpn":{"official":"マルティニーク島","common":"マルティニーク"},"nld":{"official":"Martinique","common":"Martinique"},"por":{"official":"Martinique","common":"Martinica"},"rus":{"official":"Мартиника","common":"Мартиника"},"spa":{"official":"Martinica","common":"Martinica"},"slk":{"official":"Martinique","common":"Martinique"},"fin":{"official":"Martinique","common":"Martinique"},"est":{"official":"Martinique’i departemang","common":"Martinique"},"zho":{"official":"马提尼克","common":"马提尼克"},"pol":{"official":"Martynika","common":"Martynika"},"urd":{"official":"مارٹینیک","common":"مارٹینیک"},"kor":{"official":"마르티니크","common":"마르티니크"},"per":{"official":"مارتینیک","common":"مارتینیک"}},"latlng":[14.666667,-61],"landlocked":false,"borders":[],"area":1128,"flag":"🇲🇶","demonyms":{"eng":{"f":"Martinican","m":"Martinican"},"fra":{"f":"Martiniquaise","m":"Martiniquais"}}},{"name":{"common":"Mauritius","official":"Republic of Mauritius","native":{"eng":{"official":"Republic of Mauritius","common":"Mauritius"},"fra":{"official":"République de Maurice","common":"Maurice"},"mfe":{"official":"Republik Moris","common":"Moris"}}},"tld":[".mu"],"cca2":"MU","ccn3":"480","cca3":"MUS","cioc":"MRI","independent":true,"status":"officially-assigned","currencies":{"MUR":{"name":"Mauritian rupee","symbol":"₨"}},"idd":{"root":"+2","suffixes":["30"]},"capital":["Port Louis"],"altSpellings":["MU","Republic of Mauritius","République de Maurice"],"region":"Africa","subregion":"Eastern Africa","languages":{"eng":"English","fra":"French","mfe":"Mauritian Creole"},"translations":{"ces":{"official":"Mauricijská republika","common":"Mauricius"},"deu":{"official":"Republik Mauritius","common":"Mauritius"},"fra":{"official":"République de Maurice","common":"Île Maurice"},"hrv":{"official":"Republika Mauricijus","common":"Mauricijus"},"ita":{"official":"Repubblica di Mauritius","common":"Mauritius"},"jpn":{"official":"モーリシャス共和国","common":"モーリシャス"},"nld":{"official":"Republiek Mauritius","common":"Mauritius"},"por":{"official":"República das Maurícias","common":"Maurício"},"rus":{"official":"Республика Маврикий","common":"Маврикий"},"slk":{"official":"Maurícijská republika","common":"Maurícius"},"spa":{"official":"República de Mauricio","common":"Mauricio"},"fin":{"official":"Mauritiuksen tasavalta","common":"Mauritius"},"est":{"official":"Mauritiuse Vabariik","common":"Mauritius"},"zho":{"official":"毛里求斯共和国","common":"毛里求斯"},"pol":{"official":"Republika Mauritiusu","common":"Mauritius"},"urd":{"official":"جمہوریہ موریشس","common":"موریشس"},"kor":{"official":"모리셔스 공화국","common":"모리셔스"},"per":{"official":"جمهوری موریس","common":"موریس"}},"latlng":[-20.28333333,57.55],"landlocked":false,"borders":[],"area":2040,"flag":"🇲🇺","demonyms":{"eng":{"f":"Mauritian","m":"Mauritian"},"fra":{"f":"Mauricienne","m":"Mauricien"}}},{"name":{"common":"Malawi","official":"Republic of Malawi","native":{"eng":{"official":"Republic of Malawi","common":"Malawi"},"nya":{"official":"Chalo cha Malawi, Dziko la Malaŵi","common":"Malaŵi"}}},"tld":[".mw"],"cca2":"MW","ccn3":"454","cca3":"MWI","cioc":"MAW","independent":true,"status":"officially-assigned","currencies":{"MWK":{"name":"Malawian kwacha","symbol":"MK"}},"idd":{"root":"+2","suffixes":["65"]},"capital":["Lilongwe"],"altSpellings":["MW","Republic of Malawi"],"region":"Africa","subregion":"Eastern Africa","languages":{"eng":"English","nya":"Chewa"},"translations":{"ces":{"official":"Malawiská republika","common":"Malawi"},"deu":{"official":"Republik Malawi","common":"Malawi"},"fra":{"official":"République du Malawi","common":"Malawi"},"hrv":{"official":"Republika Malavi","common":"Malavi"},"ita":{"official":"Repubblica del Malawi","common":"Malawi"},"jpn":{"official":"マラウイ共和国","common":"マラウイ"},"nld":{"official":"Republiek Malawi","common":"Malawi"},"por":{"official":"República do Malawi","common":"Malawi"},"rus":{"official":"Республика Малави","common":"Малави"},"slk":{"official":"Malawijská republika","common":"Malawi"},"spa":{"official":"República de Malawi","common":"Malawi"},"fin":{"official":"Malawin tasavalta","common":"Malawi"},"est":{"official":"Malawi Vabariik","common":"Malawi"},"zho":{"official":"马拉维共和国","common":"马拉维"},"pol":{"official":"Republika Malawi","common":"Malawi"},"urd":{"official":"جمہوریہ ملاوی","common":"ملاوی"},"kor":{"official":"말라위 공화국","common":"말라위"},"per":{"official":"جمهوری مالاوی","common":"مالاوی"}},"latlng":[-13.5,34],"landlocked":true,"borders":["MOZ","TZA","ZMB"],"area":118484,"flag":"🇲🇼","demonyms":{"eng":{"f":"Malawian","m":"Malawian"},"fra":{"f":"Malawienne","m":"Malawien"}}},{"name":{"common":"Malaysia","official":"Malaysia","native":{"eng":{"official":"Malaysia","common":"Malaysia"},"msa":{"official":"مليسيا","common":"مليسيا"}}},"tld":[".my"],"cca2":"MY","ccn3":"458","cca3":"MYS","cioc":"MAS","independent":true,"status":"officially-assigned","currencies":{"MYR":{"name":"Malaysian ringgit","symbol":"RM"}},"idd":{"root":"+6","suffixes":["0"]},"capital":["Kuala Lumpur"],"altSpellings":["MY"],"region":"Asia","subregion":"South-Eastern Asia","languages":{"eng":"English","msa":"Malay"},"translations":{"ces":{"official":"Malajsie","common":"Malajsie"},"deu":{"official":"Malaysia","common":"Malaysia"},"fra":{"official":"Fédération de Malaisie","common":"Malaisie"},"hrv":{"official":"Malezija","common":"Malezija"},"ita":{"official":"Malaysia","common":"Malesia"},"jpn":{"official":"マレーシア","common":"マレーシア"},"nld":{"official":"Maleisië","common":"Maleisië"},"por":{"official":"Malásia","common":"Malásia"},"rus":{"official":"Малайзия","common":"Малайзия"},"slk":{"official":"Malajzia","common":"Malajzia"},"spa":{"official":"Malasia","common":"Malasia"},"fin":{"official":"Malesia","common":"Malesia"},"est":{"official":"Malaisia","common":"Malaisia"},"zho":{"official":"马来西亚","common":"马来西亚"},"pol":{"official":"Malezja","common":"Malezja"},"urd":{"official":"ملائیشیا","common":"ملائیشیا"},"kor":{"official":"말레이시아","common":"말레이시아"},"per":{"official":"فدراسیون مالزی","common":"مالزی"}},"latlng":[2.5,112.5],"landlocked":false,"borders":["BRN","IDN","THA"],"area":330803,"flag":"🇲🇾","demonyms":{"eng":{"f":"Malaysian","m":"Malaysian"},"fra":{"f":"Malaisienne","m":"Malaisien"}}},{"name":{"common":"Mayotte","official":"Department of Mayotte","native":{"fra":{"official":"Département de Mayotte","common":"Mayotte"}}},"tld":[".yt"],"cca2":"YT","ccn3":"175","cca3":"MYT","cioc":"","independent":false,"status":"officially-assigned","currencies":{"EUR":{"name":"Euro","symbol":"€"}},"idd":{"root":"+2","suffixes":["62"]},"capital":["Mamoudzou"],"altSpellings":["YT","Department of Mayotte","Département de Mayotte"],"region":"Africa","subregion":"Eastern Africa","languages":{"fra":"French"},"translations":{"ces":{"official":"Mayotte","common":"Mayotte"},"deu":{"official":"Übersee-Département Mayotte","common":"Mayotte"},"fra":{"official":"Département de Mayotte","common":"Mayotte"},"hrv":{"official":"Odjel Mayotte","common":"Mayotte"},"ita":{"official":"Dipartimento di Mayotte","common":"Mayotte"},"jpn":{"official":"マヨット科","common":"マヨット"},"nld":{"official":"Afdeling Mayotte","common":"Mayotte"},"por":{"official":"Departamento de Mayotte","common":"Mayotte"},"rus":{"official":"Департамент Майотта","common":"Майотта"},"slk":{"official":"Department Mayotte","common":"Mayotte"},"spa":{"official":"Departamento de Mayotte","common":"Mayotte"},"fin":{"official":"Mayotte","common":"Mayotte"},"est":{"official":"Mayotte","common":"Mayotte"},"zho":{"official":"马约特","common":"马约特"},"pol":{"official":"Majotta","common":"Majotta"},"urd":{"official":"مایوٹ","common":"مایوٹ"},"kor":{"official":"마요트","common":"마요트"},"per":{"official":"مجموعه شهرستانی مایوت","common":"مایوت"}},"latlng":[-12.83333333,45.16666666],"landlocked":false,"borders":[],"area":374,"flag":"🇾🇹","demonyms":{"eng":{"f":"Mahoran","m":"Mahoran"},"fra":{"f":"Mahoraise","m":"Mahorais"}}},{"name":{"common":"Namibia","official":"Republic of Namibia","native":{"afr":{"official":"Republiek van Namibië","common":"Namibië"},"deu":{"official":"Republik Namibia","common":"Namibia"},"eng":{"official":"Republic of Namibia","common":"Namibia"},"her":{"official":"Republic of Namibia","common":"Namibia"},"hgm":{"official":"Republic of Namibia","common":"Namibia"},"kwn":{"official":"Republic of Namibia","common":"Namibia"},"loz":{"official":"Republic of Namibia","common":"Namibia"},"ndo":{"official":"Republic of Namibia","common":"Namibia"},"tsn":{"official":"Lefatshe la Namibia","common":"Namibia"}}},"tld":[".na"],"cca2":"NA","ccn3":"516","cca3":"NAM","cioc":"NAM","independent":true,"status":"officially-assigned","currencies":{"NAD":{"name":"Namibian dollar","symbol":"$"},"ZAR":{"name":"South African rand","symbol":"R"}},"idd":{"root":"+2","suffixes":["64"]},"capital":["Windhoek"],"altSpellings":["NA","Namibië","Republic of Namibia"],"region":"Africa","subregion":"Southern Africa","languages":{"afr":"Afrikaans","deu":"German","eng":"English","her":"Herero","hgm":"Khoekhoe","kwn":"Kwangali","loz":"Lozi","ndo":"Ndonga","tsn":"Tswana"},"translations":{"ces":{"official":"Namibijská republika","common":"Namibie"},"deu":{"official":"Republik Namibia","common":"Namibia"},"fra":{"official":"République de Namibie","common":"Namibie"},"hrv":{"official":"Republika Namibija","common":"Namibija"},"ita":{"official":"Repubblica di Namibia","common":"Namibia"},"jpn":{"official":"ナミビア共和国","common":"ナミビア"},"nld":{"official":"Republiek Namibië","common":"Namibië"},"por":{"official":"República da Namíbia","common":"Namíbia"},"rus":{"official":"Республика Намибия","common":"Намибия"},"slk":{"official":"Namíbijská republika","common":"Namíbia"},"spa":{"official":"República de Namibia","common":"Namibia"},"fin":{"official":"Namibian tasavalta","common":"Namibia"},"est":{"official":"Namiibia Vabariik","common":"Namiibia"},"zho":{"official":"纳米比亚共和国","common":"纳米比亚"},"pol":{"official":"Republika Namibii","common":"Namibia"},"urd":{"official":"جمہوریہ نمیبیا","common":"نمیبیا"},"kor":{"official":"나미비아 공화국","common":"나미비아"},"per":{"official":"جمهوری نامیبیا","common":"نامیبیا"}},"latlng":[-22,17],"landlocked":false,"borders":["AGO","BWA","ZAF","ZMB"],"area":825615,"flag":"🇳🇦","demonyms":{"eng":{"f":"Namibian","m":"Namibian"},"fra":{"f":"Namibienne","m":"Namibien"}}},{"name":{"common":"New Caledonia","official":"New Caledonia","native":{"fra":{"official":"Nouvelle-Calédonie","common":"Nouvelle-Calédonie"}}},"tld":[".nc"],"cca2":"NC","ccn3":"540","cca3":"NCL","cioc":"","independent":false,"status":"officially-assigned","currencies":{"XPF":{"name":"CFP franc","symbol":"₣"}},"idd":{"root":"+6","suffixes":["87"]},"capital":["Nouméa"],"altSpellings":["NC"],"region":"Oceania","subregion":"Melanesia","languages":{"fra":"French"},"translations":{"ces":{"official":"Nová Kaledonie","common":"Nová Kaledonie"},"deu":{"official":"Neukaledonien","common":"Neukaledonien"},"fra":{"official":"Nouvelle-Calédonie","common":"Nouvelle-Calédonie"},"hrv":{"official":"Nova Kaledonija","common":"Nova Kaledonija"},"ita":{"official":"Nuova Caledonia","common":"Nuova Caledonia"},"jpn":{"official":"ニューカレドニア","common":"ニューカレドニア"},"nld":{"official":"nieuw -Caledonië","common":"Nieuw-Caledonië"},"por":{"official":"New Caledonia","common":"Nova Caledónia"},"rus":{"official":"Новая Каледония","common":"Новая Каледония"},"slk":{"official":"Nová Kaledónia","common":"Nová Kaledónia"},"spa":{"official":"nueva Caledonia","common":"Nueva Caledonia"},"fin":{"official":"Uusi-Kaledonia","common":"Uusi-Kaledonia"},"est":{"official":"Uus-Kaledoonia","common":"Uus-Kaledoonia"},"zho":{"official":"新喀里多尼亚","common":"新喀里多尼亚"},"pol":{"official":"Nowa Kaledonia","common":"Nowa Kaledonia"},"urd":{"official":"نیو کیلیڈونیا","common":"نیو کیلیڈونیا"},"kor":{"official":"누벨칼레도니","common":"누벨칼레도니"},"per":{"official":"کالدونیای جدید","common":"کالدونیای جدید"}},"latlng":[-21.5,165.5],"landlocked":false,"borders":[],"area":18575,"flag":"🇳🇨","demonyms":{"eng":{"f":"New Caledonian","m":"New Caledonian"},"fra":{"f":"Néo-Calédonienne","m":"Néo-Calédonien"}}},{"name":{"common":"Niger","official":"Republic of Niger","native":{"fra":{"official":"République du Niger","common":"Niger"}}},"tld":[".ne"],"cca2":"NE","ccn3":"562","cca3":"NER","cioc":"NIG","independent":true,"status":"officially-assigned","currencies":{"XOF":{"name":"West African CFA franc","symbol":"Fr"}},"idd":{"root":"+2","suffixes":["27"]},"capital":["Niamey"],"altSpellings":["NE","Nijar"],"region":"Africa","subregion":"Western Africa","languages":{"fra":"French"},"translations":{"ces":{"official":"Nigerská republika","common":"Niger"},"deu":{"official":"Republik Niger","common":"Niger"},"fra":{"official":"République du Niger","common":"Niger"},"hrv":{"official":"Republika Niger","common":"Niger"},"ita":{"official":"Repubblica del Niger","common":"Niger"},"jpn":{"official":"ニジェール共和国","common":"ニジェール"},"nld":{"official":"Republiek Niger","common":"Niger"},"por":{"official":"República do Níger","common":"Níger"},"rus":{"official":"Республика Нигер","common":"Нигер"},"slk":{"official":"Nigérská republika","common":"Niger"},"spa":{"official":"República de Níger","common":"Níger"},"fin":{"official":"Nigerin tasavalta","common":"Niger"},"est":{"official":"Nigeri Vabariik","common":"Niger"},"zho":{"official":"尼日尔共和国","common":"尼日尔"},"pol":{"official":"Republika Nigru","common":"Niger"},"urd":{"official":"جمہوریہ نائجر","common":"نائجر"},"kor":{"official":"니제르 공화국","common":"니제르"},"per":{"official":"جمهوری نیجر","common":"نیجر"}},"latlng":[16,8],"landlocked":true,"borders":["DZA","BEN","BFA","TCD","LBY","MLI","NGA"],"area":1267000,"flag":"🇳🇪","demonyms":{"eng":{"f":"Nigerien","m":"Nigerien"},"fra":{"f":"Nigérienne","m":"Nigérien"}}},{"name":{"common":"Norfolk Island","official":"Territory of Norfolk Island","native":{"eng":{"official":"Territory of Norfolk Island","common":"Norfolk Island"},"pih":{"official":"Teratri of Norf\'k Ailen","common":"Norf\'k Ailen"}}},"tld":[".nf"],"cca2":"NF","ccn3":"574","cca3":"NFK","cioc":"","independent":false,"status":"officially-assigned","currencies":{"AUD":{"name":"Australian dollar","symbol":"$"}},"idd":{"root":"+6","suffixes":["72"]},"capital":["Kingston"],"altSpellings":["NF","Territory of Norfolk Island","Teratri of Norf\'k Ailen"],"region":"Oceania","subregion":"Australia and New Zealand","languages":{"eng":"English","pih":"Norfuk"},"translations":{"ces":{"official":"Teritorium ostrova Norfolk","common":"Norfolk"},"deu":{"official":"Gebiet der Norfolkinsel","common":"Norfolkinsel"},"fra":{"official":"Territoire de l\'île Norfolk","common":"Île Norfolk"},"hrv":{"official":"Teritorij Norfolk Island","common":"Otok Norfolk"},"ita":{"official":"Territorio di Norfolk Island","common":"Isola Norfolk"},"jpn":{"official":"ノーフォーク島の領土","common":"ノーフォーク島"},"nld":{"official":"Grondgebied van Norfolk Island","common":"Norfolkeiland"},"por":{"official":"Território da Ilha Norfolk","common":"Ilha Norfolk"},"rus":{"official":"Территория острова Норфолк","common":"Норфолк"},"slk":{"official":"Teritórium ostrova Norfolk","common":"Norfolk"},"spa":{"official":"Territorio de la Isla Norfolk","common":"Isla de Norfolk"},"fin":{"official":"Norfolkinsaaren territorio","common":"Norfolkinsaari"},"est":{"official":"Norfolki saare ala","common":"Norfolk"},"zho":{"official":"诺福克岛","common":"诺福克岛"},"pol":{"official":"Terytorium Wyspy Norfolk","common":"Wyspa Norfolk"},"urd":{"official":"جزیرہ نورفک خطہ","common":"جزیرہ نورفک"},"kor":{"official":"노퍽 섬","common":"노퍽 섬"},"per":{"official":"قلمرو جزایر نورفک","common":"جزیره نورفک"}},"latlng":[-29.03333333,167.95],"landlocked":false,"borders":[],"area":36,"flag":"🇳🇫","demonyms":{"eng":{"f":"Norfolk Islander","m":"Norfolk Islander"},"fra":{"f":"Norfolkaise","m":"Norfolkais"}}},{"name":{"common":"Nigeria","official":"Federal Republic of Nigeria","native":{"eng":{"official":"Federal Republic of Nigeria","common":"Nigeria"}}},"tld":[".ng"],"cca2":"NG","ccn3":"566","cca3":"NGA","cioc":"NGR","independent":true,"status":"officially-assigned","currencies":{"NGN":{"name":"Nigerian naira","symbol":"₦"}},"idd":{"root":"+2","suffixes":["34"]},"capital":["Abuja"],"altSpellings":["NG","Nijeriya","Naíjíríà","Federal Republic of Nigeria"],"region":"Africa","subregion":"Western Africa","languages":{"eng":"English"},"translations":{"ces":{"official":"Nigerijská federativní republika","common":"Nigérie"},"deu":{"official":"Bundesrepublik Nigeria","common":"Nigeria"},"fra":{"official":"République fédérale du Nigeria","common":"Nigéria"},"hrv":{"official":"Savezna Republika Nigerija","common":"Nigerija"},"ita":{"official":"Repubblica federale di Nigeria","common":"Nigeria"},"jpn":{"official":"ナイジェリア連邦共和国","common":"ナイジェリア"},"nld":{"official":"Federale Republiek Nigeria","common":"Nigeria"},"por":{"official":"República Federal da Nigéria","common":"Nigéria"},"rus":{"official":"Федеративная Республика Нигерия","common":"Нигерия"},"slk":{"official":"Nigérijská federatívna republika","common":"Nigéria"},"spa":{"official":"República Federal de Nigeria","common":"Nigeria"},"fin":{"official":"Nigerian liittotasavalta","common":"Nigeria"},"est":{"official":"Nigeeria Liitvabariik","common":"Nigeeria"},"zho":{"official":"尼日利亚联邦共和国","common":"尼日利亚"},"pol":{"official":"Federalna Republika Nigerii","common":"Nigeria"},"urd":{"official":"وفاقی جمہوریہ نائجیریا","common":"نائجیریا"},"kor":{"official":"나이지리아 연방 공화국","common":"나이지리아"},"per":{"official":"جمهوری فدرال نیجریه","common":"نیجریه"}},"latlng":[10,8],"landlocked":false,"borders":["BEN","CMR","TCD","NER"],"area":923768,"flag":"🇳🇬","demonyms":{"eng":{"f":"Nigerian","m":"Nigerian"},"fra":{"f":"Nigériane","m":"Nigérian"}}},{"name":{"common":"Nicaragua","official":"Republic of Nicaragua","native":{"spa":{"official":"República de Nicaragua","common":"Nicaragua"}}},"tld":[".ni"],"cca2":"NI","ccn3":"558","cca3":"NIC","cioc":"NCA","independent":true,"status":"officially-assigned","currencies":{"NIO":{"name":"Nicaraguan córdoba","symbol":"C$"}},"idd":{"root":"+5","suffixes":["05"]},"capital":["Managua"],"altSpellings":["NI","Republic of Nicaragua","República de Nicaragua"],"region":"Americas","subregion":"Central America","languages":{"spa":"Spanish"},"translations":{"ces":{"official":"Republika Nikaragua","common":"Nikaragua"},"deu":{"official":"Republik Nicaragua","common":"Nicaragua"},"fra":{"official":"République du Nicaragua","common":"Nicaragua"},"hrv":{"official":"Republika Nikaragva","common":"Nikaragva"},"ita":{"official":"Repubblica del Nicaragua","common":"Nicaragua"},"jpn":{"official":"ニカラグア共和国","common":"ニカラグア"},"nld":{"official":"Republiek Nicaragua","common":"Nicaragua"},"por":{"official":"República da Nicarágua","common":"Nicarágua"},"rus":{"official":"Республика Никарагуа","common":"Никарагуа"},"slk":{"official":"Nikaragujská republika","common":"Nikaragua"},"spa":{"official":"República de Nicaragua","common":"Nicaragua"},"fin":{"official":"Nicaraguan tasavalta","common":"Nicaragua"},"est":{"official":"Nicaragua Vabariik","common":"Nicaragua"},"zho":{"official":"尼加拉瓜共和国","common":"尼加拉瓜"},"pol":{"official":"Republika Nikaragui","common":"Nikaragua"},"urd":{"official":"جمہوریہ نکاراگوا","common":"نکاراگوا"},"kor":{"official":"니카라과 공화국","common":"니카라과"},"per":{"official":"جمهوری نیکاراگوئه","common":"نیکاراگوئه"}},"latlng":[13,-85],"landlocked":false,"borders":["CRI","HND"],"area":130373,"flag":"🇳🇮","demonyms":{"eng":{"f":"Nicaraguan","m":"Nicaraguan"},"fra":{"f":"Nicaraguayenne","m":"Nicaraguayen"}}},{"name":{"common":"Niue","official":"Niue","native":{"eng":{"official":"Niue","common":"Niue"},"niu":{"official":"Niuē","common":"Niuē"}}},"tld":[".nu"],"cca2":"NU","ccn3":"570","cca3":"NIU","cioc":"","independent":false,"status":"officially-assigned","currencies":{"NZD":{"name":"New Zealand dollar","symbol":"$"}},"idd":{"root":"+6","suffixes":["83"]},"capital":["Alofi"],"altSpellings":["NU"],"region":"Oceania","subregion":"Polynesia","languages":{"eng":"English","niu":"Niuean"},"translations":{"ces":{"official":"Niue","common":"Niue"},"deu":{"official":"Niue","common":"Niue"},"fra":{"official":"Niue","common":"Niue"},"hrv":{"official":"Niue","common":"Niue"},"ita":{"official":"Niue","common":"Niue"},"jpn":{"official":"ニウエ","common":"ニウエ"},"nld":{"official":"Niue","common":"Niue"},"por":{"official":"Niue","common":"Niue"},"rus":{"official":"Ниуэ","common":"Ниуэ"},"slk":{"official":"Niue","common":"Niue"},"spa":{"official":"Niue","common":"Niue"},"fin":{"official":"Niue","common":"Niue"},"est":{"official":"Niue","common":"Niue"},"zho":{"official":"纽埃","common":"纽埃"},"pol":{"official":"Niue","common":"Niue"},"urd":{"official":"نیووے","common":"نیووے"},"kor":{"official":"니우에","common":"니우에"},"per":{"official":"نیووی","common":"نیووی"}},"latlng":[-19.03333333,-169.86666666],"landlocked":false,"borders":[],"area":260,"flag":"🇳🇺","demonyms":{"eng":{"f":"Niuean","m":"Niuean"},"fra":{"f":"Niuéenne","m":"Niuéen"}}},{"name":{"common":"Netherlands","official":"Kingdom of the Netherlands","native":{"nld":{"official":"Koninkrijk der Nederlanden","common":"Nederland"}}},"tld":[".nl"],"cca2":"NL","ccn3":"528","cca3":"NLD","cioc":"NED","independent":true,"status":"officially-assigned","currencies":{"EUR":{"name":"Euro","symbol":"€"}},"idd":{"root":"+3","suffixes":["1"]},"capital":["Amsterdam"],"altSpellings":["NL","Holland","Nederland","The Netherlands"],"region":"Europe","subregion":"Western Europe","languages":{"nld":"Dutch"},"translations":{"ces":{"official":"Nizozemské království","common":"Nizozemsko"},"deu":{"official":"Niederlande","common":"Niederlande"},"fra":{"official":"Pays-Bas","common":"Pays-Bas"},"hrv":{"official":"Holandija","common":"Nizozemska"},"ita":{"official":"Paesi Bassi","common":"Paesi Bassi"},"jpn":{"official":"オランダ","common":"オランダ"},"nld":{"official":"Nederland","common":"Nederland"},"por":{"official":"Holanda","common":"Holanda"},"rus":{"official":"Нидерланды","common":"Нидерланды"},"slk":{"official":"Holandské kráľovstvo","common":"Holansko"},"spa":{"official":"Países Bajos","common":"Países Bajos"},"fin":{"official":"Alankomaat","common":"Alankomaat"},"est":{"official":"Madalmaade Kuningriik","common":"Holland"},"zho":{"official":"荷兰","common":"荷兰"},"pol":{"official":"Królestwo Niderlandów","common":"Holandia"},"urd":{"official":"مملکتِ نیدرلینڈز","common":"نیدرلینڈز"},"kor":{"official":"네덜란드 왕국","common":"네덜란드"},"per":{"official":"هلند","common":"هلند"}},"latlng":[52.5,5.75],"landlocked":false,"borders":["BEL","DEU"],"area":41850,"flag":"🇳🇱","demonyms":{"eng":{"f":"Dutch","m":"Dutch"},"fra":{"f":"Néerlandaise","m":"Néerlandais"}}},{"name":{"common":"Norway","official":"Kingdom of Norway","native":{"nno":{"official":"Kongeriket Noreg","common":"Noreg"},"nob":{"official":"Kongeriket Norge","common":"Norge"},"smi":{"official":"Norgga gonagasriika","common":"Norgga"}}},"tld":[".no"],"cca2":"NO","ccn3":"578","cca3":"NOR","cioc":"NOR","independent":true,"status":"officially-assigned","currencies":{"NOK":{"name":"Norwegian krone","symbol":"kr"}},"idd":{"root":"+4","suffixes":["7"]},"capital":["Oslo"],"altSpellings":["NO","Norge","Noreg","Kingdom of Norway","Kongeriket Norge","Kongeriket Noreg"],"region":"Europe","subregion":"Northern Europe","languages":{"nno":"Norwegian Nynorsk","nob":"Norwegian Bokmål","smi":"Sami"},"translations":{"ces":{"official":"Norské království","common":"Norsko"},"deu":{"official":"Königreich Norwegen","common":"Norwegen"},"fra":{"official":"Royaume de Norvège","common":"Norvège"},"hrv":{"official":"Kraljevina Norveška","common":"Norveška"},"ita":{"official":"Regno di Norvegia","common":"Norvegia"},"jpn":{"official":"ノルウェー王国","common":"ノルウェー"},"nld":{"official":"Koninkrijk Noorwegen","common":"Noorwegen"},"por":{"official":"Reino da Noruega","common":"Noruega"},"rus":{"official":"Королевство Норвегия","common":"Норвегия"},"slk":{"official":"Nórske kráľovstvo","common":"Nórsko"},"spa":{"official":"Reino de Noruega","common":"Noruega"},"fin":{"official":"Norjan kuningaskunta","common":"Norja"},"est":{"official":"Norra Kuningriik","common":"Norra"},"zho":{"official":"挪威王国","common":"挪威"},"pol":{"official":"Królestwo Norwegii","common":"Norwegia"},"urd":{"official":"مملکتِ ناروے","common":"ناروے"},"kor":{"official":"노르웨이 왕국","common":"노르웨이"},"per":{"official":"پادشاهی نروژ","common":"نروژ"}},"latlng":[62,10],"landlocked":false,"borders":["FIN","SWE","RUS"],"area":323802,"flag":"🇳🇴","demonyms":{"eng":{"f":"Norwegian","m":"Norwegian"},"fra":{"f":"Norvégienne","m":"Norvégien"}}},{"name":{"common":"Nepal","official":"Federal Democratic Republic of Nepal","native":{"nep":{"official":"नेपाल संघीय लोकतान्त्रिक गणतन्त्र","common":"नेपाल"}}},"tld":[".np"],"cca2":"NP","ccn3":"524","cca3":"NPL","cioc":"NEP","independent":true,"status":"officially-assigned","currencies":{"NPR":{"name":"Nepalese rupee","symbol":"₨"}},"idd":{"root":"+9","suffixes":["77"]},"capital":["Kathmandu"],"altSpellings":["NP","Federal Democratic Republic of Nepal","Loktāntrik Ganatantra Nepāl"],"region":"Asia","subregion":"Southern Asia","languages":{"nep":"Nepali"},"translations":{"ces":{"official":"Federativní demokratická republika Nepál","common":"Nepál"},"deu":{"official":"Demokratische Bundesrepublik Nepal","common":"Nepal"},"fra":{"official":"République du Népal","common":"Népal"},"hrv":{"official":"Savezna Demokratska Republika Nepal","common":"Nepal"},"ita":{"official":"Repubblica federale democratica del Nepal","common":"Nepal"},"jpn":{"official":"ネパール連邦民主共和国","common":"ネパール"},"nld":{"official":"Federale Democratische Republiek Nepal","common":"Nepal"},"por":{"official":"República Democrática Federal do Nepal","common":"Nepal"},"rus":{"official":"Федеративная Демократическая Республика Непал","common":"Непал"},"slk":{"official":"Nepálska federatívna demokratická republika","common":"Nepál"},"spa":{"official":"República Democrática Federal de Nepal","common":"Nepal"},"fin":{"official":"Nepalin demokraattinen liittotasavalta","common":"Nepal"},"est":{"official":"Nepali Demokraatlik Liitvabariik","common":"Nepal"},"zho":{"official":"尼泊尔联邦民主共和国","common":"尼泊尔"},"pol":{"official":"Federalna Demokratyczna Republika Nepalu","common":"Nepal"},"urd":{"official":"وفاقی جمہوری جمہوریہ نیپال","common":"نیپال"},"kor":{"official":"네팔 연방 민주 공화국","common":"네팔"},"per":{"official":"جمهوری فدرال دموکراتیک نپال","common":"نپال"}},"latlng":[28,84],"landlocked":true,"borders":["CHN","IND"],"area":147181,"flag":"🇳🇵","demonyms":{"eng":{"f":"Nepalese","m":"Nepalese"},"fra":{"f":"Népalaise","m":"Népalais"}}},{"name":{"common":"Nauru","official":"Republic of Nauru","native":{"eng":{"official":"Republic of Nauru","common":"Nauru"},"nau":{"official":"Republic of Nauru","common":"Nauru"}}},"tld":[".nr"],"cca2":"NR","ccn3":"520","cca3":"NRU","cioc":"NRU","independent":true,"status":"officially-assigned","currencies":{"AUD":{"name":"Australian dollar","symbol":"$"}},"idd":{"root":"+6","suffixes":["74"]},"capital":["Yaren"],"altSpellings":["NR","Naoero","Pleasant Island","Republic of Nauru","Ripublik Naoero"],"region":"Oceania","subregion":"Micronesia","languages":{"eng":"English","nau":"Nauru"},"translations":{"ces":{"official":"Republika Nauru","common":"Nauru"},"deu":{"official":"Republik Nauru","common":"Nauru"},"fra":{"official":"République de Nauru","common":"Nauru"},"hrv":{"official":"Republika Nauru","common":"Nauru"},"ita":{"official":"Repubblica di Nauru","common":"Nauru"},"jpn":{"official":"ナウル共和国","common":"ナウル"},"nld":{"official":"Republiek Nauru","common":"Nauru"},"por":{"official":"República de Nauru","common":"Nauru"},"rus":{"official":"Республика Науру","common":"Науру"},"slk":{"official":"Naurská republika","common":"Nauru"},"spa":{"official":"República de Nauru","common":"Nauru"},"fin":{"official":"Naurun tasavalta","common":"Nauru"},"est":{"official":"Nauru Vabariik","common":"Nauru"},"zho":{"official":"瑙鲁共和国","common":"瑙鲁"},"pol":{"official":"Republika Nauru","common":"Nauru"},"urd":{"official":"جمہوریہ ناورو","common":"ناورو"},"kor":{"official":"나우루 공화국","common":"나우루"},"per":{"official":"جمهوری نائورو","common":"نائورو"}},"latlng":[-0.53333333,166.91666666],"landlocked":false,"borders":[],"area":21,"flag":"🇳🇷","demonyms":{"eng":{"f":"Nauruan","m":"Nauruan"},"fra":{"f":"Nauruane","m":"Nauruan"}}},{"name":{"common":"New Zealand","official":"New Zealand","native":{"eng":{"official":"New Zealand","common":"New Zealand"},"mri":{"official":"Aotearoa","common":"Aotearoa"},"nzs":{"official":"New Zealand","common":"New Zealand"}}},"tld":[".nz"],"cca2":"NZ","ccn3":"554","cca3":"NZL","cioc":"NZL","independent":true,"status":"officially-assigned","currencies":{"NZD":{"name":"New Zealand dollar","symbol":"$"}},"idd":{"root":"+6","suffixes":["4"]},"capital":["Wellington"],"altSpellings":["NZ","Aotearoa"],"region":"Oceania","subregion":"Australia and New Zealand","languages":{"eng":"English","mri":"Māori","nzs":"New Zealand Sign Language"},"translations":{"ces":{"official":"Nový Zéland","common":"Nový Zéland"},"deu":{"official":"Neuseeland","common":"Neuseeland"},"fra":{"official":"Nouvelle-Zélande","common":"Nouvelle-Zélande"},"hrv":{"official":"Novi Zeland","common":"Novi Zeland"},"ita":{"official":"Nuova Zelanda","common":"Nuova Zelanda"},"jpn":{"official":"ニュージーランド","common":"ニュージーランド"},"nld":{"official":"Nieuw Zeeland","common":"Nieuw-Zeeland"},"por":{"official":"nova Zelândia","common":"Nova Zelândia"},"rus":{"official":"Новая Зеландия","common":"Новая Зеландия"},"slk":{"official":"Nový Zéland","common":"Nový Zéland"},"spa":{"official":"nueva Zelanda","common":"Nueva Zelanda"},"fin":{"official":"Uusi-Seelanti","common":"Uusi-Seelanti"},"est":{"official":"Uus-Meremaa","common":"Uus-Meremaa"},"zho":{"official":"新西兰","common":"新西兰"},"pol":{"official":"Nowa Zelandia","common":"Nowa Zelandia"},"urd":{"official":"نیوزی لینڈ","common":"نیوزی لینڈ"},"kor":{"official":"뉴질랜드","common":"뉴질랜드"},"per":{"official":"نیوزیلند","common":"نیوزیلند"}},"latlng":[-41,174],"landlocked":false,"borders":[],"area":270467,"flag":"🇳🇿","demonyms":{"eng":{"f":"New Zealander","m":"New Zealander"},"fra":{"f":"Neo-Zélandaise","m":"Neo-Zélandais"}}},{"name":{"common":"Oman","official":"Sultanate of Oman","native":{"ara":{"official":"سلطنة عمان","common":"عمان"}}},"tld":[".om"],"cca2":"OM","ccn3":"512","cca3":"OMN","cioc":"OMA","independent":true,"status":"officially-assigned","currencies":{"OMR":{"name":"Omani rial","symbol":"ر.ع."}},"idd":{"root":"+9","suffixes":["68"]},"capital":["Muscat"],"altSpellings":["OM","Sultanate of Oman","Salṭanat ʻUmān"],"region":"Asia","subregion":"Western Asia","languages":{"ara":"Arabic"},"translations":{"ces":{"official":"Sultanát Omán","common":"Omán"},"deu":{"official":"Sultanat Oman","common":"Oman"},"fra":{"official":"Sultanat d\'Oman","common":"Oman"},"hrv":{"official":"Sultanat Oman","common":"Oman"},"ita":{"official":"Sultanato dell\'Oman","common":"oman"},"jpn":{"official":"オマーン·スルタン国","common":"オマーン"},"nld":{"official":"Sultanaat van Oman","common":"Oman"},"por":{"official":"Sultanato de Omã","common":"Omã"},"rus":{"official":"Султанат Оман","common":"Оман"},"slk":{"official":"Ománsky sultanát","common":"Omán"},"spa":{"official":"Sultanato de Omán","common":"Omán"},"fin":{"official":"Omanin sulttaanikunta","common":"Oman"},"est":{"official":"Omaani Sultaniriik","common":"Omaan"},"zho":{"official":"阿曼苏丹国","common":"阿曼"},"pol":{"official":"Sułtanat Omanu","common":"Oman"},"urd":{"official":"سلطنت عمان","common":"عمان"},"kor":{"official":"오만 술탄국","common":"오만"},"per":{"official":"سلطان‌نشین عُمان","common":"عمان"}},"latlng":[21,57],"landlocked":false,"borders":["SAU","ARE","YEM"],"area":309500,"flag":"🇴🇲","demonyms":{"eng":{"f":"Omani","m":"Omani"},"fra":{"f":"Omanaise","m":"Omanais"}}},{"name":{"common":"Pakistan","official":"Islamic Republic of Pakistan","native":{"eng":{"official":"Islamic Republic of Pakistan","common":"Pakistan"},"urd":{"official":"اسلامی جمہوریۂ پاكستان","common":"پاكستان"}}},"tld":[".pk"],"cca2":"PK","ccn3":"586","cca3":"PAK","cioc":"PAK","independent":true,"status":"officially-assigned","currencies":{"PKR":{"name":"Pakistani rupee","symbol":"₨"}},"idd":{"root":"+9","suffixes":["2"]},"capital":["Islamabad"],"altSpellings":["PK","Pākistān","Islamic Republic of Pakistan","Islāmī Jumhūriya\'eh Pākistān"],"region":"Asia","subregion":"Southern Asia","languages":{"eng":"English","urd":"Urdu"},"translations":{"ces":{"official":"Pákistánská islámská republika","common":"Pákistán"},"deu":{"official":"Islamische Republik Pakistan","common":"Pakistan"},"fra":{"official":"République islamique du Pakistan","common":"Pakistan"},"hrv":{"official":"Islamska Republika Pakistan","common":"Pakistan"},"ita":{"official":"Repubblica islamica del Pakistan","common":"Pakistan"},"jpn":{"official":"パキスタン","common":"パキスタン"},"nld":{"official":"Islamitische Republiek Pakistan","common":"Pakistan"},"por":{"official":"República Islâmica do Paquistão","common":"Paquistão"},"rus":{"official":"Исламская Республика Пакистан","common":"Пакистан"},"slk":{"official":"Pakistanská islamská republika","common":"Pakistan"},"spa":{"official":"República Islámica de Pakistán","common":"Pakistán"},"fin":{"official":"Pakistanin islamilainen tasavalta","common":"Pakistan"},"est":{"official":"Pakistani Islamivabariik","common":"Pakistan"},"zho":{"official":"巴基斯坦伊斯兰共和国","common":"巴基斯坦"},"pol":{"official":"Islamska Republika Pakistanu","common":"Pakistan"},"urd":{"official":"اسلامی جمہوریہ پاکستان","common":"پاکستان"},"kor":{"official":"파키스탄 이슬람 공화국","common":"파키스탄"},"per":{"official":"جمهوری اسلامی پاکستان","common":"پاکستان"}},"latlng":[30,70],"landlocked":false,"borders":["AFG","CHN","IND","IRN"],"area":881912,"flag":"🇵🇰","demonyms":{"eng":{"f":"Pakistani","m":"Pakistani"},"fra":{"f":"Pakistanaise","m":"Pakistanais"}}},{"name":{"common":"Panama","official":"Republic of Panama","native":{"spa":{"official":"República de Panamá","common":"Panamá"}}},"tld":[".pa"],"cca2":"PA","ccn3":"591","cca3":"PAN","cioc":"PAN","independent":true,"status":"officially-assigned","currencies":{"PAB":{"name":"Panamanian balboa","symbol":"B/."},"USD":{"name":"United States dollar","symbol":"$"}},"idd":{"root":"+5","suffixes":["07"]},"capital":["Panama City"],"altSpellings":["PA","Republic of Panama","República de Panamá"],"region":"Americas","subregion":"Central America","languages":{"spa":"Spanish"},"translations":{"ces":{"official":"Panamská republika","common":"Panama"},"deu":{"official":"Republik Panama","common":"Panama"},"fra":{"official":"République du Panama","common":"Panama"},"hrv":{"official":"Republika Panama","common":"Panama"},"ita":{"official":"Repubblica di Panama","common":"Panama"},"jpn":{"official":"パナマ共和国","common":"パナマ"},"nld":{"official":"Republiek Panama","common":"Panama"},"por":{"official":"República do Panamá","common":"Panamá"},"rus":{"official":"Республика Панама","common":"Панама"},"slk":{"official":"Panamská republika","common":"Panama"},"spa":{"official":"República de Panamá","common":"Panamá"},"fin":{"official":"Panaman tasavalta","common":"Panama"},"est":{"official":"Panama Vabariik","common":"Panama"},"zho":{"official":"巴拿马共和国","common":"巴拿马"},"pol":{"official":"Republika Panamy","common":"Panama"},"urd":{"official":"جمہوریہ پاناما","common":"پاناما"},"kor":{"official":"파나마 공화국","common":"파나마"},"per":{"official":"جمهوری پاناما","common":"پاناما"}},"latlng":[9,-80],"landlocked":false,"borders":["COL","CRI"],"area":75417,"flag":"🇵🇦","demonyms":{"eng":{"f":"Panamanian","m":"Panamanian"},"fra":{"f":"Panaméenne","m":"Panaméen"}}},{"name":{"common":"Pitcairn Islands","official":"Pitcairn Group of Islands","native":{"eng":{"official":"Pitcairn Group of Islands","common":"Pitcairn Islands"}}},"tld":[".pn"],"cca2":"PN","ccn3":"612","cca3":"PCN","cioc":"","independent":false,"status":"officially-assigned","currencies":{"NZD":{"name":"New Zealand dollar","symbol":"$"}},"idd":{"root":"+6","suffixes":["4"]},"capital":["Adamstown"],"altSpellings":["PN","Pitcairn","Pitcairn Henderson Ducie and Oeno Islands"],"region":"Oceania","subregion":"Polynesia","languages":{"eng":"English"},"translations":{"ces":{"official":"Pitcairnovy ostrovy","common":"Pitcairnovy ostrovy"},"deu":{"official":"Pitcairninseln","common":"Pitcairninseln"},"fra":{"official":"Groupe d\'îles Pitcairn","common":"Îles Pitcairn"},"hrv":{"official":"Pitcairn skupine otoka","common":"Pitcairnovo otočje"},"ita":{"official":"Pitcairn gruppo di isole","common":"Isole Pitcairn"},"jpn":{"official":"島のピトケアングループ","common":"ピトケアン"},"nld":{"official":"Pitcairn groep eilanden","common":"Pitcairneilanden"},"por":{"official":"Pitcairn grupo de ilhas","common":"Ilhas Pitcairn"},"rus":{"official":"Питкэрн группа островов","common":"Острова Питкэрн"},"slk":{"official":"Pitcairnove ostrovy","common":"Pitcairnove ostrovy"},"spa":{"official":"Grupo de Islas Pitcairn","common":"Islas Pitcairn"},"fin":{"official":"Pitcairn","common":"Pitcairn"},"est":{"official":"Pitcairni, Hendersoni, Ducie ja Oeno saar","common":"Pitcairn"},"zho":{"official":"皮特凯恩群岛","common":"皮特凯恩群岛"},"pol":{"official":"Wyspy Pitcairn, Henderson, Ducie i Oeno","common":"Pitcairn"},"urd":{"official":"پٹکیرن جزائر","common":"جزائر پٹکیرن"},"kor":{"official":"핏케언 제도","common":"핏케언 제도"},"per":{"official":"جزایر پیت‌کرن","common":"جزایر پیت‌کرن"}},"latlng":[-25.06666666,-130.1],"landlocked":false,"borders":[],"area":47,"flag":"🇵🇳","demonyms":{"eng":{"f":"Pitcairn Islander","m":"Pitcairn Islander"},"fra":{"f":"Pitcairnaise","m":"Pitcairnais"}}},{"name":{"common":"Peru","official":"Republic of Peru","native":{"aym":{"official":"Piruw Suyu","common":"Piruw"},"que":{"official":"Piruw Ripuwlika","common":"Piruw"},"spa":{"official":"República del Perú","common":"Perú"}}},"tld":[".pe"],"cca2":"PE","ccn3":"604","cca3":"PER","cioc":"PER","independent":true,"status":"officially-assigned","currencies":{"PEN":{"name":"Peruvian sol","symbol":"S/."}},"idd":{"root":"+5","suffixes":["1"]},"capital":["Lima"],"altSpellings":["PE","Republic of Peru","República del Perú"],"region":"Americas","subregion":"South America","languages":{"aym":"Aymara","que":"Quechua","spa":"Spanish"},"translations":{"ces":{"official":"Peruánská republika","common":"Peru"},"deu":{"official":"Republik Peru","common":"Peru"},"fra":{"official":"République du Pérou","common":"Pérou"},"hrv":{"official":"Republika Peru","common":"Peru"},"ita":{"official":"Repubblica del Perù","common":"Perù"},"jpn":{"official":"ペルー共和国","common":"ペルー"},"nld":{"official":"Republiek Peru","common":"Peru"},"por":{"official":"República do Peru","common":"Perú"},"rus":{"official":"Республика Перу","common":"Перу"},"slk":{"official":"Peruánska republika","common":"Peru"},"spa":{"official":"República de Perú","common":"Perú"},"fin":{"official":"Perun tasavalta","common":"Peru"},"est":{"official":"Peruu Vabariik","common":"Peruu"},"zho":{"official":"秘鲁共和国","common":"秘鲁"},"pol":{"official":"Republika Peru","common":"Peru"},"urd":{"official":"جمہوریہ پیرو","common":"پیرو"},"kor":{"official":"페루 공화국","common":"페루"},"per":{"official":"جمهوری پرو","common":"پرو"}},"latlng":[-10,-76],"landlocked":false,"borders":["BOL","BRA","CHL","COL","ECU"],"area":1285216,"flag":"🇵🇪","demonyms":{"eng":{"f":"Peruvian","m":"Peruvian"},"fra":{"f":"Péruvienne","m":"Péruvien"}}},{"name":{"common":"Philippines","official":"Republic of the Philippines","native":{"eng":{"official":"Republic of the Philippines","common":"Philippines"},"fil":{"official":"Republic of the Philippines","common":"Pilipinas"}}},"tld":[".ph"],"cca2":"PH","ccn3":"608","cca3":"PHL","cioc":"PHI","independent":true,"status":"officially-assigned","currencies":{"PHP":{"name":"Philippine peso","symbol":"₱"}},"idd":{"root":"+6","suffixes":["3"]},"capital":["Manila"],"altSpellings":["PH","Republic of the Philippines","Repúblika ng Pilipinas"],"region":"Asia","subregion":"South-Eastern Asia","languages":{"eng":"English","fil":"Filipino"},"translations":{"ces":{"official":"Filipínská republika","common":"Filipíny"},"deu":{"official":"Republik der Philippinen","common":"Philippinen"},"fra":{"official":"République des Philippines","common":"Philippines"},"hrv":{"official":"Republika Filipini","common":"Filipini"},"ita":{"official":"Repubblica delle Filippine","common":"Filippine"},"jpn":{"official":"フィリピン共和国","common":"フィリピン"},"nld":{"official":"Republiek der Filipijnen","common":"Filipijnen"},"por":{"official":"República das Filipinas","common":"Filipinas"},"rus":{"official":"Республика Филиппины","common":"Филиппины"},"slk":{"official":"Filipínska republika","common":"Filipíny"},"spa":{"official":"República de las Filipinas","common":"Filipinas"},"fin":{"official":"Filippiinien tasavalta","common":"Filippiinit"},"est":{"official":"Filipiini Vabariik","common":"Filipiinid"},"zho":{"official":"菲律宾共和国","common":"菲律宾"},"pol":{"official":"Republika Filipin","common":"Filipiny"},"urd":{"official":"جمہوریہ فلپائن","common":"فلپائن"},"kor":{"official":"필리핀 공화국","common":"필리핀"},"per":{"official":"جمهوری فیلیپین","common":"فیلیپین"}},"latlng":[13,122],"landlocked":false,"borders":[],"area":342353,"flag":"🇵🇭","demonyms":{"eng":{"f":"Filipino","m":"Filipino"},"fra":{"f":"Philippine","m":"Philippin"}}},{"name":{"common":"Palau","official":"Republic of Palau","native":{"eng":{"official":"Republic of Palau","common":"Palau"},"pau":{"official":"Beluu er a Belau","common":"Belau"}}},"tld":[".pw"],"cca2":"PW","ccn3":"585","cca3":"PLW","cioc":"PLW","independent":true,"status":"officially-assigned","currencies":{"USD":{"name":"United States dollar","symbol":"$"}},"idd":{"root":"+6","suffixes":["80"]},"capital":["Ngerulmud"],"altSpellings":["PW","Republic of Palau","Beluu er a Belau"],"region":"Oceania","subregion":"Micronesia","languages":{"eng":"English","pau":"Palauan"},"translations":{"ces":{"official":"Republika Palau","common":"Palau"},"deu":{"official":"Republik Palau","common":"Palau"},"fra":{"official":"République des Palaos (Palau)","common":"Palaos (Palau)"},"hrv":{"official":"Republika Palau","common":"Palau"},"ita":{"official":"Repubblica di Palau","common":"Palau"},"jpn":{"official":"パラオ共和国","common":"パラオ"},"nld":{"official":"Republiek van Palau","common":"Palau"},"por":{"official":"República de Palau","common":"Palau"},"rus":{"official":"Республика Палау","common":"Палау"},"slk":{"official":"Palauská republika","common":"Palau"},"spa":{"official":"República de Palau","common":"Palau"},"fin":{"official":"Palaun tasavalta","common":"Palau"},"est":{"official":"Belau Vabariik","common":"Belau"},"zho":{"official":"帕劳共和国","common":"帕劳"},"pol":{"official":"Republika Palau","common":"Palau"},"urd":{"official":"جمہوریہ پلاؤ","common":"پلاؤ"},"kor":{"official":"팔라우 공화국","common":"팔라우"},"per":{"official":"جمهوری پالائو","common":"پالائو"}},"latlng":[7.5,134.5],"landlocked":false,"borders":[],"area":459,"flag":"🇵🇼","demonyms":{"eng":{"f":"Palauan","m":"Palauan"},"fra":{"f":"Paluane","m":"Paluan"}}},{"name":{"common":"Papua New Guinea","official":"Independent State of Papua New Guinea","native":{"eng":{"official":"Independent State of Papua New Guinea","common":"Papua New Guinea"},"hmo":{"official":"Independen Stet bilong Papua Niugini","common":"Papua Niu Gini"},"tpi":{"official":"Independen Stet bilong Papua Niugini","common":"Papua Niugini"}}},"tld":[".pg"],"cca2":"PG","ccn3":"598","cca3":"PNG","cioc":"PNG","independent":true,"status":"officially-assigned","currencies":{"PGK":{"name":"Papua New Guinean kina","symbol":"K"}},"idd":{"root":"+6","suffixes":["75"]},"capital":["Port Moresby"],"altSpellings":["PG","Independent State of Papua New Guinea","Independen Stet bilong Papua Niugini"],"region":"Oceania","subregion":"Melanesia","languages":{"eng":"English","hmo":"Hiri Motu","tpi":"Tok Pisin"},"translations":{"ces":{"official":"Nezávislý stát Papua Nová Guinea","common":"Papua-Nová Guinea"},"deu":{"official":"Unabhängiger Staat Papua-Neuguinea","common":"Papua-Neuguinea"},"fra":{"official":"État indépendant de Papouasie-Nouvelle-Guinée","common":"Papouasie-Nouvelle-Guinée"},"hrv":{"official":"Nezavisna Država Papui Novoj Gvineji","common":"Papua Nova Gvineja"},"ita":{"official":"Stato indipendente di Papua Nuova Guinea","common":"Papua Nuova Guinea"},"jpn":{"official":"パプアニューギニア独立国","common":"パプアニューギニア"},"nld":{"official":"Onafhankelijke Staat Papoea -Nieuw-Guinea","common":"Papoea-Nieuw-Guinea"},"por":{"official":"Estado Independente da Papua Nova Guiné","common":"Papua Nova Guiné"},"rus":{"official":"Независимое Государство Папуа-Новой Гвинеи","common":"Папуа — Новая Гвинея"},"slk":{"official":"Nezávislý štát Papua-Nová Guinea","common":"Papua-Nová Guinea"},"spa":{"official":"Estado Independiente de Papúa Nueva Guinea","common":"Papúa Nueva Guinea"},"fin":{"official":"Papua-Uuden-Guinean Itsenäinen valtio","common":"Papua-Uusi-Guinea"},"est":{"official":"Paapua Uus-Guinea Iseseisvusriik","common":"Paapua Uus-Guinea"},"zho":{"official":"巴布亚新几内亚","common":"巴布亚新几内亚"},"pol":{"official":"Niezależne Państwo Papui-Nowej Gwinei","common":"Papua-Nowa Gwinea"},"urd":{"official":"آزاد ریاستِ پاپوا نیو گنی","common":"پاپوا نیو گنی"},"kor":{"official":"파푸아뉴기니 독립국","common":"파푸아뉴기니"},"per":{"official":"مملکت مستقل پاپوآ گینهٔ نو","common":"پاپوآ گینه نو"}},"latlng":[-6,147],"landlocked":false,"borders":["IDN"],"area":462840,"flag":"🇵🇬","demonyms":{"eng":{"f":"Papua New Guinean","m":"Papua New Guinean"},"fra":{"f":"Papouasienne","m":"Papouasien"}}},{"name":{"common":"Poland","official":"Republic of Poland","native":{"pol":{"official":"Rzeczpospolita Polska","common":"Polska"}}},"tld":[".pl"],"cca2":"PL","ccn3":"616","cca3":"POL","cioc":"POL","independent":true,"status":"officially-assigned","currencies":{"PLN":{"name":"Polish złoty","symbol":"zł"}},"idd":{"root":"+4","suffixes":["8"]},"capital":["Warsaw"],"altSpellings":["PL","Republic of Poland","Rzeczpospolita Polska"],"region":"Europe","subregion":"Eastern Europe","languages":{"pol":"Polish"},"translations":{"ces":{"official":"Polská republika","common":"Polsko"},"deu":{"official":"Republik Polen","common":"Polen"},"fra":{"official":"République de Pologne","common":"Pologne"},"hrv":{"official":"Republika Poljska","common":"Poljska"},"ita":{"official":"Repubblica di Polonia","common":"Polonia"},"jpn":{"official":"ポーランド共和国","common":"ポーランド"},"nld":{"official":"Republiek Polen","common":"Polen"},"por":{"official":"República da Polónia","common":"Polónia"},"rus":{"official":"Республика Польша","common":"Польша"},"slk":{"official":"Poľská republika","common":"Poľsko"},"spa":{"official":"República de Polonia","common":"Polonia"},"fin":{"official":"Puolan tasavalta","common":"Puola"},"est":{"official":"Poola Vabariik","common":"Poola"},"zho":{"official":"波兰共和国","common":"波兰"},"pol":{"official":"Rzeczpospolita Polska","common":"Polska"},"urd":{"official":"جمہوریہ پولینڈ","common":"پولینڈ"},"kor":{"official":"폴란드 공화국","common":"폴란드"},"per":{"official":"جمهوری لهستان","common":"لهستان"}},"latlng":[52,20],"landlocked":false,"borders":["BLR","CZE","DEU","LTU","RUS","SVK","UKR"],"area":312679,"flag":"🇵🇱","demonyms":{"eng":{"f":"Polish","m":"Polish"},"fra":{"f":"Polonaise","m":"Polonais"}}},{"name":{"common":"Puerto Rico","official":"Commonwealth of Puerto Rico","native":{"eng":{"official":"Commonwealth of Puerto Rico","common":"Puerto Rico"},"spa":{"official":"Estado Libre Asociado de Puerto Rico","common":"Puerto Rico"}}},"tld":[".pr"],"cca2":"PR","ccn3":"630","cca3":"PRI","cioc":"PUR","independent":false,"status":"officially-assigned","currencies":{"USD":{"name":"United States dollar","symbol":"$"}},"idd":{"root":"+1","suffixes":["787","939"]},"capital":["San Juan"],"altSpellings":["PR","Commonwealth of Puerto Rico","Estado Libre Asociado de Puerto Rico"],"region":"Americas","subregion":"Caribbean","languages":{"eng":"English","spa":"Spanish"},"translations":{"ces":{"official":"Portoriko","common":"Portoriko"},"deu":{"official":"Freistaat Puerto Rico","common":"Puerto Rico"},"fra":{"official":"Porto Rico","common":"Porto Rico"},"hrv":{"official":"Zajednica Puerto Rico","common":"Portoriko"},"ita":{"official":"Commonwealth di Porto Rico","common":"Porto Rico"},"jpn":{"official":"プエルトリコのコモンウェルス","common":"プエルトリコ"},"nld":{"official":"Gemenebest van Puerto Rico","common":"Puerto Rico"},"por":{"official":"Commonwealth of Puerto Rico","common":"Porto Rico"},"rus":{"official":"Содружество Пуэрто-Рико","common":"Пуэрто-Рико"},"slk":{"official":"Portorické spoločenstvo","common":"Portoriko"},"spa":{"official":"Asociado de Puerto Rico","common":"Puerto Rico"},"fin":{"official":"Puerto Rico","common":"Puerto Rico"},"est":{"official":"Puerto Rico Ühendus","common":"Puerto Rico"},"zho":{"official":"波多黎各联邦","common":"波多黎各"},"pol":{"official":"Wolne Stowarzyszone Państwo Portoryko","common":"Portoryko"},"urd":{"official":" دولتِ مشترکہ پورٹو ریکو","common":"پورٹو ریکو"},"kor":{"official":"푸에르토리코","common":"푸에르토리코"},"per":{"official":"قلمرو همسود پورتوریکو","common":"پورتوریکو"}},"latlng":[18.25,-66.5],"landlocked":false,"borders":[],"area":8870,"flag":"🇵🇷","demonyms":{"eng":{"f":"Puerto Rican","m":"Puerto Rican"},"fra":{"f":"Portoricaine","m":"Portoricain"}}},{"name":{"common":"North Korea","official":"Democratic People\'s Republic of Korea","native":{"kor":{"official":"조선민주주의인민공화국","common":"조선"}}},"tld":[".kp"],"cca2":"KP","ccn3":"408","cca3":"PRK","cioc":"PRK","independent":true,"status":"officially-assigned","currencies":{"KPW":{"name":"North Korean won","symbol":"₩"}},"idd":{"root":"+8","suffixes":["50"]},"capital":["Pyongyang"],"altSpellings":["KP","Democratic People\'s Republic of Korea","DPRK","조선민주주의인민공화국","Chosŏn Minjujuŭi Inmin Konghwaguk","Korea, Democratic People\'s Republic of","북한","북조선"],"region":"Asia","subregion":"Eastern Asia","languages":{"kor":"Korean"},"translations":{"ces":{"official":"Korejská lidově demokratická republika","common":"Severní Korea"},"deu":{"official":"Demokratische Volksrepublik Korea","common":"Nordkorea"},"fra":{"official":"République populaire démocratique de Corée","common":"Corée du Nord"},"hrv":{"official":"Demokratska Narodna Republika Koreja","common":"Sjeverna Koreja"},"ita":{"official":"Repubblica democratica popolare di Corea","common":"Corea del Nord"},"jpn":{"official":"朝鮮民主主義人民共和国","common":"朝鮮民主主義人民共和国"},"nld":{"official":"Democratische Volksrepubliek Korea","common":"Noord-Korea"},"por":{"official":"República Popular Democrática da Coreia","common":"Coreia do Norte"},"rus":{"official":"Корейская Народно-Демократическая Республика Корея","common":"Северная Корея"},"slk":{"official":"Kórejská ľudovodemokratická republika","common":"Kórejská ľudovodemokratická republika (KĽR, Severná Kórea)"},"spa":{"official":"República Popular Democrática de Corea","common":"Corea del Norte"},"fin":{"official":"Korean demokraattinen kansantasavalta","common":"Pohjois-Korea"},"est":{"official":"Korea Rahvademokraatlik Vabariik","common":"Põhja-Korea"},"zho":{"official":"朝鲜人民民主共和国","common":"朝鲜"},"pol":{"official":"Koreańska Republika Ludowo-Demokratyczna","common":"Korea Północna"},"urd":{"official":"جمہوری عوامی جمہوریہ کوریا","common":"شمالی کوریا"},"kor":{"official":"조선민주주의인민공화국","common":"조선"},"per":{"official":"جمهوری دموکراتیک خلق کره","common":"کُره شمالی"}},"latlng":[40,127],"landlocked":false,"borders":["CHN","KOR","RUS"],"area":120538,"flag":"🇰🇵","demonyms":{"eng":{"f":"North Korean","m":"North Korean"},"fra":{"f":"Nord-coréenne","m":"Nord-coréen"}}},{"name":{"common":"Portugal","official":"Portuguese Republic","native":{"por":{"official":"República português","common":"Portugal"}}},"tld":[".pt"],"cca2":"PT","ccn3":"620","cca3":"PRT","cioc":"POR","independent":true,"status":"officially-assigned","currencies":{"EUR":{"name":"Euro","symbol":"€"}},"idd":{"root":"+3","suffixes":["51"]},"capital":["Lisbon"],"altSpellings":["PT","Portuguesa","Portuguese Republic","República Portuguesa"],"region":"Europe","subregion":"Southern Europe","languages":{"por":"Portuguese"},"translations":{"ces":{"official":"Portugalská republika","common":"Portugalsko"},"deu":{"official":"Portugiesische Republik","common":"Portugal"},"fra":{"official":"République portugaise","common":"Portugal"},"hrv":{"official":"Portugalska Republika","common":"Portugal"},"ita":{"official":"Repubblica portoghese","common":"Portogallo"},"jpn":{"official":"ポルトガル共和国","common":"ポルトガル"},"nld":{"official":"Portugese Republiek","common":"Portugal"},"por":{"official":"República português","common":"Portugal"},"rus":{"official":"Португальская Республика","common":"Португалия"},"slk":{"official":"Portugalská republika","common":"Portugalsko"},"spa":{"official":"República Portuguesa","common":"Portugal"},"fin":{"official":"Portugalin tasavalta","common":"Portugali"},"est":{"official":"Portugali Vabariik","common":"Portugal"},"zho":{"official":"葡萄牙共和国","common":"葡萄牙"},"pol":{"official":"Republika Portugalska","common":"Portugalia"},"urd":{"official":"جمہوریہ پرتگال","common":"پرتگال"},"kor":{"official":"포르투갈 공화국","common":"포르투갈"},"per":{"official":"جمهوری پرتغال","common":"پرتغال"}},"latlng":[39.5,-8],"landlocked":false,"borders":["ESP"],"area":92090,"flag":"🇵🇹","demonyms":{"eng":{"f":"Portuguese","m":"Portuguese"},"fra":{"f":"Portugaise","m":"Portugais"}}},{"name":{"common":"Paraguay","official":"Republic of Paraguay","native":{"grn":{"official":"Tetã Paraguái","common":"Paraguái"},"spa":{"official":"República de Paraguay","common":"Paraguay"}}},"tld":[".py"],"cca2":"PY","ccn3":"600","cca3":"PRY","cioc":"PAR","independent":true,"status":"officially-assigned","currencies":{"PYG":{"name":"Paraguayan guaraní","symbol":"₲"}},"idd":{"root":"+5","suffixes":["95"]},"capital":["Asunción"],"altSpellings":["PY","Republic of Paraguay","República del Paraguay","Tetã Paraguái"],"region":"Americas","subregion":"South America","languages":{"grn":"Guaraní","spa":"Spanish"},"translations":{"ces":{"official":"Paraguayská republika","common":"Paraguay"},"deu":{"official":"Republik Paraguay","common":"Paraguay"},"fra":{"official":"République du Paraguay","common":"Paraguay"},"hrv":{"official":"Republika Paragvaj","common":"Paragvaj"},"ita":{"official":"Repubblica del Paraguay","common":"Paraguay"},"jpn":{"official":"パラグアイ共和国","common":"パラグアイ"},"nld":{"official":"Republiek Paraguay","common":"Paraguay"},"por":{"official":"República do Paraguai","common":"Paraguai"},"rus":{"official":"Республика Парагвай","common":"Парагвай"},"slk":{"official":"Paraguajská republika","common":"Paraguaj"},"spa":{"official":"República de Paraguay","common":"Paraguay"},"fin":{"official":"Paraguayn tasavalta","common":"Paraguay"},"est":{"official":"Paraguay Vabariik","common":"Paraguay"},"zho":{"official":"巴拉圭共和国","common":"巴拉圭"},"pol":{"official":"Republika Paragwaju","common":"Paragwaj"},"urd":{"official":"جمہوریہ پیراگوئے","common":"پیراگوئے"},"kor":{"official":"파라과이 공화국","common":"파라과이"},"per":{"official":"جمهوری پاراگوئه","common":"پاراگوئه"}},"latlng":[-23,-58],"landlocked":true,"borders":["ARG","BOL","BRA"],"area":406752,"flag":"🇵🇾","demonyms":{"eng":{"f":"Paraguayan","m":"Paraguayan"},"fra":{"f":"Paraguayenne","m":"Paraguayen"}}},{"name":{"common":"Palestine","official":"State of Palestine","native":{"ara":{"official":"دولة فلسطين","common":"فلسطين"}}},"tld":[".ps","فلسطين."],"cca2":"PS","ccn3":"275","cca3":"PSE","cioc":"PLE","independent":false,"status":"officially-assigned","currencies":{"EGP":{"name":"Egyptian pound","symbol":"E£"},"ILS":{"name":"Israeli new shekel","symbol":"₪"},"JOD":{"name":"Jordanian dinar","symbol":"JD"}},"idd":{"root":"+9","suffixes":["70"]},"capital":["Ramallah"],"altSpellings":["PS","Palestine, State of","State of Palestine","Dawlat Filasṭin"],"region":"Asia","subregion":"Western Asia","languages":{"ara":"Arabic"},"translations":{"ces":{"official":"Stát Palestina","common":"Palestina"},"deu":{"official":"Staat Palästina","common":"Palästina"},"fra":{"official":"État de Palestine","common":"Palestine"},"hrv":{"official":"State of Palestine","common":"Palestina"},"ita":{"official":"Stato di Palestina","common":"Palestina"},"jpn":{"official":"パレスチナ自治政府","common":"パレスチナ"},"nld":{"official":"Staat Palestina","common":"Palestijnse gebieden"},"por":{"official":"Estado da Palestina","common":"Palestina"},"rus":{"official":"Государство Палестина","common":"Палестина"},"slk":{"official":"Palestínsky štát","common":"Palestína"},"spa":{"official":"Estado de Palestina","common":"Palestina"},"fin":{"official":"Palestiinan valtio","common":"Palestiina"},"est":{"official":"Palestiina Riik","common":"Palestiina"},"zho":{"official":"巴勒斯坦国","common":"巴勒斯坦"},"pol":{"official":"Państwo Palestyna","common":"Palestyna"},"urd":{"official":"ریاستِ فلسطین","common":"فلسطین"},"kor":{"official":"팔레스타인국","common":"팔레스타인"},"per":{"official":"دولت فلسطین","common":"فلسطین"}},"latlng":[31.9,35.2],"landlocked":false,"borders":["ISR","EGY","JOR"],"area":6220,"flag":"🇵🇸","demonyms":{"eng":{"f":"Palestinian","m":"Palestinian"},"fra":{"f":"Palestinienne","m":"Palestinien"}}},{"name":{"common":"French Polynesia","official":"French Polynesia","native":{"fra":{"official":"Polynésie française","common":"Polynésie française"}}},"tld":[".pf"],"cca2":"PF","ccn3":"258","cca3":"PYF","cioc":"","independent":false,"status":"officially-assigned","currencies":{"XPF":{"name":"CFP franc","symbol":"₣"}},"idd":{"root":"+6","suffixes":["89"]},"capital":["Papeetē"],"altSpellings":["PF","Polynésie française","French Polynesia","Pōrīnetia Farāni"],"region":"Oceania","subregion":"Polynesia","languages":{"fra":"French"},"translations":{"ces":{"official":"Francouzská Polynésie","common":"Francouzská Polynésie"},"deu":{"official":"Französisch-Polynesien","common":"Französisch-Polynesien"},"fra":{"official":"Polynésie française","common":"Polynésie française"},"hrv":{"official":"Francuska Polinezija","common":"Francuska Polinezija"},"ita":{"official":"Polinesia Francese","common":"Polinesia Francese"},"jpn":{"official":"フランス領ポリネシア","common":"フランス領ポリネシア"},"nld":{"official":"Frans-Polynesië","common":"Frans-Polynesië"},"por":{"official":"Polinésia Francesa","common":"Polinésia Francesa"},"rus":{"official":"Французская Полинезия","common":"Французская Полинезия"},"slk":{"official":"Francúzska Polynézia","common":"Francúzska Polynézia"},"spa":{"official":"Polinesia francés","common":"Polinesia Francesa"},"fin":{"official":"Ranskan Polynesia","common":"Ranskan Polynesia"},"est":{"official":"Prantsuse Polüneesia","common":"Prantsuse Polüneesia"},"zho":{"official":"法属波利尼西亚","common":"法属波利尼西亚"},"pol":{"official":"Polinezja Francuska","common":"Polinezja Francuska"},"urd":{"official":"فرانسیسی پولینیشیا","common":"فرانسیسی پولینیشیا"},"kor":{"official":"프랑스령 폴리네시아","common":"프랑스령 폴리네시아"},"per":{"official":"پُلی‌نِزی فرانسه","common":"پُلی‌نِزی فرانسه"}},"latlng":[-15,-140],"landlocked":false,"borders":[],"area":4167,"flag":"🇵🇫","demonyms":{"eng":{"f":"French Polynesian","m":"French Polynesian"},"fra":{"f":"Polynésienne","m":"Polynésien"}}},{"name":{"common":"Qatar","official":"State of Qatar","native":{"ara":{"official":"دولة قطر","common":"قطر"}}},"tld":[".qa","قطر."],"cca2":"QA","ccn3":"634","cca3":"QAT","cioc":"QAT","independent":true,"status":"officially-assigned","currencies":{"QAR":{"name":"Qatari riyal","symbol":"ر.ق"}},"idd":{"root":"+9","suffixes":["74"]},"capital":["Doha"],"altSpellings":["QA","State of Qatar","Dawlat Qaṭar"],"region":"Asia","subregion":"Western Asia","languages":{"ara":"Arabic"},"translations":{"ces":{"official":"Stát Katar","common":"Katar"},"deu":{"official":"Staat Katar","common":"Katar"},"fra":{"official":"État du Qatar","common":"Qatar"},"hrv":{"official":"Država Katar","common":"Katar"},"ita":{"official":"Stato del Qatar","common":"Qatar"},"jpn":{"official":"カタール国","common":"カタール"},"nld":{"official":"Staat Qatar","common":"Qatar"},"por":{"official":"Estado do Qatar","common":"Catar"},"rus":{"official":"Государство Катар","common":"Катар"},"slk":{"official":"Katarský štát","common":"Katar"},"spa":{"official":"Estado de Qatar","common":"Catar"},"fin":{"official":"Qatarin valtio","common":"Qatar"},"est":{"official":"Katari Riik","common":"Katar"},"zho":{"official":"卡塔尔国","common":"卡塔尔"},"pol":{"official":"Państwo Katar","common":"Katar"},"urd":{"official":"ریاستِ قطر","common":"قطر"},"kor":{"official":"카타르국","common":"카타르"},"per":{"official":"دولت قطر","common":"قطر"}},"latlng":[25.5,51.25],"landlocked":false,"borders":["SAU"],"area":11586,"flag":"🇶🇦","demonyms":{"eng":{"f":"Qatari","m":"Qatari"},"fra":{"f":"Qatarienne","m":"Qatarien"}}},{"name":{"common":"Réunion","official":"Réunion Island","native":{"fra":{"official":"Ile de la Réunion","common":"La Réunion"}}},"tld":[".re"],"cca2":"RE","ccn3":"638","cca3":"REU","cioc":"","independent":false,"status":"officially-assigned","currencies":{"EUR":{"name":"Euro","symbol":"€"}},"idd":{"root":"+2","suffixes":["62"]},"capital":["Saint-Denis"],"altSpellings":["RE","Reunion"],"region":"Africa","subregion":"Eastern Africa","languages":{"fra":"French"},"translations":{"ces":{"official":"Réunion","common":"Réunion"},"deu":{"official":"Réunion","common":"Réunion"},"fra":{"official":"Ile de la Réunion","common":"Réunion"},"hrv":{"official":"Réunion Island","common":"Réunion"},"ita":{"official":"Réunion","common":"Riunione"},"jpn":{"official":"レユニオン島","common":"レユニオン"},"nld":{"official":"Réunion","common":"Réunion"},"por":{"official":"Ilha da Reunião","common":"Reunião"},"rus":{"official":"Реюньон","common":"Реюньон"},"slk":{"official":"Réunionský zámorský departmán","common":"Réunion"},"spa":{"official":"Isla de la Reunión","common":"Reunión"},"fin":{"official":"Réunion","common":"Réunion"},"est":{"official":"Réunioni departemang","common":"Réunion"},"zho":{"official":"留尼旺岛","common":"留尼旺岛"},"pol":{"official":"Reunion","common":"Reunion"},"urd":{"official":"رے یونیوں جزیرہ","common":"رے یونیوں"},"kor":{"official":"레위니옹","common":"레위니옹"},"per":{"official":"رئونیون","common":"رئونیون"}},"latlng":[-21.15,55.5],"landlocked":false,"borders":[],"area":2511,"flag":"🇷🇪","demonyms":{"eng":{"f":"Réunionese","m":"Réunionese"},"fra":{"f":"Réunionnaise","m":"Réunionnais"}}},{"name":{"common":"Romania","official":"Romania","native":{"ron":{"official":"România","common":"România"}}},"tld":[".ro"],"cca2":"RO","ccn3":"642","cca3":"ROU","cioc":"ROU","independent":true,"status":"officially-assigned","currencies":{"RON":{"name":"Romanian leu","symbol":"lei"}},"idd":{"root":"+4","suffixes":["0"]},"capital":["Bucharest"],"altSpellings":["RO","Rumania","Roumania","România"],"region":"Europe","subregion":"Eastern Europe","languages":{"ron":"Romanian"},"translations":{"ces":{"official":"Rumunsko","common":"Rumunsko"},"deu":{"official":"Rumänien","common":"Rumänien"},"fra":{"official":"Roumanie","common":"Roumanie"},"hrv":{"official":"Rumunija","common":"Rumunjska"},"ita":{"official":"Romania","common":"Romania"},"jpn":{"official":"ルーマニア","common":"ルーマニア"},"nld":{"official":"Roemenië","common":"Roemenië"},"por":{"official":"Romênia","common":"Roménia"},"rus":{"official":"Румыния","common":"Румыния"},"slk":{"official":"Rumunsko","common":"Rumunsko"},"spa":{"official":"Rumania","common":"Rumania"},"fin":{"official":"Romania","common":"Romania"},"est":{"official":"Rumeenia","common":"Rumeenia"},"zho":{"official":"罗马尼亚","common":"罗马尼亚"},"pol":{"official":"Rumunia","common":"Rumunia"},"urd":{"official":"رومانیہ","common":"رومانیہ"},"kor":{"official":"루마니아","common":"루마니아"},"per":{"official":"رومانی","common":"رومانی"}},"latlng":[46,25],"landlocked":false,"borders":["BGR","HUN","MDA","SRB","UKR"],"area":238391,"flag":"🇷🇴","demonyms":{"eng":{"f":"Romanian","m":"Romanian"},"fra":{"f":"Roumaine","m":"Roumain"}}},{"name":{"common":"Russia","official":"Russian Federation","native":{"rus":{"official":"Российская Федерация","common":"Россия"}}},"tld":[".ru",".su",".рф"],"cca2":"RU","ccn3":"643","cca3":"RUS","cioc":"RUS","independent":true,"status":"officially-assigned","currencies":{"RUB":{"name":"Russian ruble","symbol":"₽"}},"idd":{"root":"+7","suffixes":["3XX","4XX","5XX","8XX","9XX"]},"capital":["Moscow"],"altSpellings":["RU","Russian Federation","Российская Федерация"],"region":"Europe","subregion":"Eastern Europe","languages":{"rus":"Russian"},"translations":{"ces":{"official":"Ruská federace","common":"Rusko"},"deu":{"official":"Russische Föderation","common":"Russland"},"fra":{"official":"Fédération de Russie","common":"Russie"},"hrv":{"official":"Ruska Federacija","common":"Rusija"},"ita":{"official":"Federazione russa","common":"Russia"},"jpn":{"official":"ロシア連邦","common":"ロシア連邦"},"nld":{"official":"Russische Federatie","common":"Rusland"},"por":{"official":"Federação Russa","common":"Rússia"},"rus":{"official":"Российская Федерация","common":"Россия"},"slk":{"official":"Ruská federácia","common":"Rusko"},"spa":{"official":"Federación de Rusia","common":"Rusia"},"fin":{"official":"Venäjän federaatio","common":"Venäjä"},"est":{"official":"Venemaa Föderatsioon","common":"Venemaa"},"zho":{"official":"俄罗斯联邦","common":"俄罗斯"},"pol":{"official":"Federacja Rosyjska","common":"Rosja"},"urd":{"official":"روسی وفاق","common":"روس"},"kor":{"official":"러시아 연방","common":"러시아"},"per":{"official":"فدراسیون روسیه","common":"روسیه"}},"latlng":[60,100],"landlocked":false,"borders":["AZE","BLR","CHN","EST","FIN","GEO","KAZ","PRK","LVA","LTU","MNG","NOR","POL","UKR"],"area":17098242,"flag":"🇷🇺","demonyms":{"eng":{"f":"Russian","m":"Russian"},"fra":{"f":"Russe","m":"Russe"}}},{"name":{"common":"Rwanda","official":"Republic of Rwanda","native":{"eng":{"official":"Republic of Rwanda","common":"Rwanda"},"fra":{"official":"République rwandaise","common":"Rwanda"},"kin":{"official":"Repubulika y\'u Rwanda","common":"Rwanda"}}},"tld":[".rw"],"cca2":"RW","ccn3":"646","cca3":"RWA","cioc":"RWA","independent":true,"status":"officially-assigned","currencies":{"RWF":{"name":"Rwandan franc","symbol":"Fr"}},"idd":{"root":"+2","suffixes":["50"]},"capital":["Kigali"],"altSpellings":["RW","Republic of Rwanda","Repubulika y\'u Rwanda","République du Rwanda"],"region":"Africa","subregion":"Eastern Africa","languages":{"eng":"English","fra":"French","kin":"Kinyarwanda"},"translations":{"ces":{"official":"Rwandská republika","common":"Rwanda"},"deu":{"official":"Republik Ruanda","common":"Ruanda"},"fra":{"official":"République rwandaise","common":"Rwanda"},"hrv":{"official":"Republika Ruandi","common":"Ruanda"},"ita":{"official":"Repubblica del Ruanda","common":"Ruanda"},"jpn":{"official":"ルワンダ共和国","common":"ルワンダ"},"nld":{"official":"Republiek Rwanda","common":"Rwanda"},"por":{"official":"República do Ruanda","common":"Ruanda"},"rus":{"official":"Республика Руанда","common":"Руанда"},"slk":{"official":"Rwandská republika","common":"Rwanda"},"spa":{"official":"República de Rwanda","common":"Ruanda"},"fin":{"official":"Ruandan tasavalta","common":"Ruanda"},"est":{"official":"Rwanda Vabariik","common":"Rwanda"},"zho":{"official":"卢旺达共和国","common":"卢旺达"},"pol":{"official":"Republika Rwandy","common":"Rwanda"},"urd":{"official":"جمہوریہ روانڈا","common":"روانڈا"},"kor":{"official":"르완다 공화국","common":"르완다"},"per":{"official":"جمهوری رواندا","common":"رواندا"}},"latlng":[-2,30],"landlocked":true,"borders":["BDI","COD","TZA","UGA"],"area":26338,"flag":"🇷🇼","demonyms":{"eng":{"f":"Rwandan","m":"Rwandan"},"fra":{"f":"Rwandaise","m":"Rwandais"}}},{"name":{"common":"Saudi Arabia","official":"Kingdom of Saudi Arabia","native":{"ara":{"official":"المملكة العربية السعودية","common":"العربية السعودية"}}},"tld":[".sa",".السعودية"],"cca2":"SA","ccn3":"682","cca3":"SAU","cioc":"KSA","independent":true,"status":"officially-assigned","currencies":{"SAR":{"name":"Saudi riyal","symbol":"ر.س"}},"idd":{"root":"+9","suffixes":["66"]},"capital":["Riyadh"],"altSpellings":["Saudi","SA","Kingdom of Saudi Arabia","Al-Mamlakah al-‘Arabiyyah as-Su‘ūdiyyah"],"region":"Asia","subregion":"Western Asia","languages":{"ara":"Arabic"},"translations":{"ces":{"official":"Saúdskoarabské království","common":"Saúdská Arábie"},"deu":{"official":"Königreich Saudi-Arabien","common":"Saudi-Arabien"},"fra":{"official":"Royaume d\'Arabie Saoudite","common":"Arabie Saoudite"},"hrv":{"official":"Kraljevina Saudijska Arabija","common":"Saudijska Arabija"},"ita":{"official":"Arabia Saudita","common":"Arabia Saudita"},"jpn":{"official":"サウジアラビア王国","common":"サウジアラビア"},"nld":{"official":"Koninkrijk van Saoedi-Arabië","common":"Saoedi-Arabië"},"por":{"official":"Reino da Arábia Saudita","common":"Arábia Saudita"},"rus":{"official":"Королевство Саудовская Аравия","common":"Саудовская Аравия"},"slk":{"official":"Saudskoarabské kráľovstvo","common":"Saudská Arábia"},"spa":{"official":"Reino de Arabia Saudita","common":"Arabia Saudí"},"fin":{"official":"Saudi-Arabian kuningaskunta","common":"Saudi-Arabia"},"est":{"official":"Saudi Araabia Kuningriik","common":"Saudi Araabia"},"zho":{"official":"沙特阿拉伯王国","common":"沙特阿拉伯"},"pol":{"official":"Królestwo Arabii Saudyjskiej","common":"Arabia Saudyjska"},"urd":{"official":"مملکتِ سعودی عرب","common":"سعودی عرب"},"kor":{"official":"사우디아라비아 왕국","common":"사우디아라비아"},"per":{"official":"پادشاهی عربی سَعودی","common":"عربستان سعودی"}},"latlng":[25,45],"landlocked":false,"borders":["IRQ","JOR","KWT","OMN","QAT","ARE","YEM"],"area":2149690,"flag":"🇸🇦","demonyms":{"eng":{"f":"Saudi Arabian","m":"Saudi Arabian"},"fra":{"f":"Saoudienne","m":"Saoudien"}}},{"name":{"common":"Sudan","official":"Republic of the Sudan","native":{"ara":{"official":"جمهورية السودان","common":"السودان"},"eng":{"official":"Republic of the Sudan","common":"Sudan"}}},"tld":[".sd"],"cca2":"SD","ccn3":"729","cca3":"SDN","cioc":"SUD","independent":true,"status":"officially-assigned","currencies":{"SDG":{"name":"Sudanese pound","symbol":""}},"idd":{"root":"+2","suffixes":["49"]},"capital":["Khartoum"],"altSpellings":["SD","Republic of the Sudan","Jumhūrīyat as-Sūdān"],"region":"Africa","subregion":"Northern Africa","languages":{"ara":"Arabic","eng":"English"},"translations":{"ces":{"official":"Súdánská republika","common":"Súdán"},"deu":{"official":"Republik Sudan","common":"Sudan"},"fra":{"official":"République du Soudan","common":"Soudan"},"hrv":{"official":"Republika Sudan","common":"Sudan"},"ita":{"official":"Repubblica del Sudan","common":"Sudan"},"jpn":{"official":"スーダン共和国","common":"スーダン"},"nld":{"official":"Republiek Soedan","common":"Soedan"},"por":{"official":"República do Sudão","common":"Sudão"},"rus":{"official":"Республика Судан","common":"Судан"},"slk":{"official":"Sudánska republika","common":"Sudán"},"spa":{"official":"República de Sudán","common":"Sudán"},"fin":{"official":"Sudanin tasavalta","common":"Sudan"},"est":{"official":"Sudaani Vabariik","common":"Sudaan"},"zho":{"official":"苏丹共和国","common":"苏丹"},"pol":{"official":"Republika Sudanu","common":"Sudan"},"urd":{"official":"جمہوریہ سودان","common":"سودان"},"kor":{"official":"수단 공화국","common":"수단"},"per":{"official":"جمهوری سودان","common":"سودان"}},"latlng":[15,30],"landlocked":false,"borders":["CAF","TCD","EGY","ERI","ETH","LBY","SSD"],"area":1886068,"flag":"🇸🇩","demonyms":{"eng":{"f":"Sudanese","m":"Sudanese"},"fra":{"f":"Soudanaise","m":"Soudanais"}}},{"name":{"common":"Senegal","official":"Republic of Senegal","native":{"fra":{"official":"République du Sénégal","common":"Sénégal"}}},"tld":[".sn"],"cca2":"SN","ccn3":"686","cca3":"SEN","cioc":"SEN","independent":true,"status":"officially-assigned","currencies":{"XOF":{"name":"West African CFA franc","symbol":"Fr"}},"idd":{"root":"+2","suffixes":["21"]},"capital":["Dakar"],"altSpellings":["SN","Republic of Senegal","République du Sénégal"],"region":"Africa","subregion":"Western Africa","languages":{"fra":"French"},"translations":{"ces":{"official":"Senegalská republika","common":"Senegal"},"deu":{"official":"Republik Senegal","common":"Senegal"},"fra":{"official":"République du Sénégal","common":"Sénégal"},"hrv":{"official":"Republika Senegal","common":"Senegal"},"ita":{"official":"Repubblica del Senegal","common":"Senegal"},"jpn":{"official":"セネガル共和国","common":"セネガル"},"nld":{"official":"Republiek Senegal","common":"Senegal"},"por":{"official":"República do Senegal","common":"Senegal"},"rus":{"official":"Республика Сенегал","common":"Сенегал"},"slk":{"official":"Senegalská republika","common":"Senegal"},"spa":{"official":"República de Senegal","common":"Senegal"},"fin":{"official":"Senegalin tasavalta","common":"Senegal"},"est":{"official":"Senegali Vabariik","common":"Senegal"},"zho":{"official":"塞内加尔共和国","common":"塞内加尔"},"pol":{"official":"Senegal","common":"Senegal"},"urd":{"official":"جمہوریہ سینیگال","common":"سینیگال"},"kor":{"official":"세네갈 공화국","common":"세네갈"},"per":{"official":"جمهوری سنگال","common":"سنگال"}},"latlng":[14,-14],"landlocked":false,"borders":["GMB","GIN","GNB","MLI","MRT"],"area":196722,"flag":"🇸🇳","demonyms":{"eng":{"f":"Senegalese","m":"Senegalese"},"fra":{"f":"Sénégalaise","m":"Sénégalais"}}},{"name":{"common":"Singapore","official":"Republic of Singapore","native":{"zho":{"official":"新加坡共和国","common":"新加坡"},"eng":{"official":"Republic of Singapore","common":"Singapore"},"msa":{"official":"Republik Singapura","common":"Singapura"},"tam":{"official":"சிங்கப்பூர் குடியரசு","common":"சிங்கப்பூர்"}}},"tld":[".sg",".新加坡",".சிங்கப்பூர்"],"cca2":"SG","ccn3":"702","cca3":"SGP","cioc":"SIN","independent":true,"status":"officially-assigned","currencies":{"SGD":{"name":"Singapore dollar","symbol":"$"}},"idd":{"root":"+6","suffixes":["5"]},"capital":["Singapore"],"altSpellings":["SG","Singapura","Republik Singapura","新加坡共和国"],"region":"Asia","subregion":"South-Eastern Asia","languages":{"zho":"Chinese","eng":"English","msa":"Malay","tam":"Tamil"},"translations":{"ces":{"official":"Singapurská republika","common":"Singapur"},"deu":{"official":"Republik Singapur","common":"Singapur"},"fra":{"official":"République de Singapour","common":"Singapour"},"hrv":{"official":"Republika Singapur","common":"Singapur"},"ita":{"official":"Repubblica di Singapore","common":"Singapore"},"jpn":{"official":"シンガポール共和国","common":"シンガポール"},"nld":{"official":"Republiek Singapore","common":"Singapore"},"por":{"official":"República de Singapura","common":"Singapura"},"rus":{"official":"Республика Сингапур","common":"Сингапур"},"slk":{"official":"Singapurská republika","common":"Singapur"},"spa":{"official":"República de Singapur","common":"Singapur"},"fin":{"official":"Singaporen tasavalta","common":"Singapore"},"est":{"official":"Singapuri Vabariik","common":"Singapur"},"pol":{"official":"Republika Singapuru","common":"Singapur"},"urd":{"official":"جمہوریہ سنگاپور","common":"سنگاپور"},"kor":{"official":"싱가포르 공화국","common":"싱가포르"},"per":{"official":"جمهوری سنگاپور","common":"سنگاپور"}},"latlng":[1.36666666,103.8],"landlocked":false,"borders":[],"area":710,"flag":"🇸🇬","demonyms":{"eng":{"f":"Singaporean","m":"Singaporean"},"fra":{"f":"Singapourienne","m":"Singapourien"}}},{"name":{"common":"South Georgia","official":"South Georgia and the South Sandwich Islands","native":{"eng":{"official":"South Georgia and the South Sandwich Islands","common":"South Georgia"}}},"tld":[".gs"],"cca2":"GS","ccn3":"239","cca3":"SGS","cioc":"","independent":false,"status":"officially-assigned","currencies":{"SHP":{"name":"Saint Helena pound","symbol":"£"}},"idd":{"root":"+5","suffixes":["00"]},"capital":["King Edward Point"],"altSpellings":["GS","South Georgia and the South Sandwich Islands"],"region":"Antarctic","subregion":"","languages":{"eng":"English"},"translations":{"ces":{"official":"Jižní Georgie a Jižní Sandwichovy ostrovy","common":"Jižní Georgie a Jižní Sandwichovy ostrovy"},"deu":{"official":"Südgeorgien und die Südlichen Sandwichinseln","common":"Südgeorgien und die Südlichen Sandwichinseln"},"fra":{"official":"Géorgie du Sud et les îles Sandwich du Sud","common":"Géorgie du Sud-et-les Îles Sandwich du Sud"},"hrv":{"official":"Južna Džordžija i Otoci Južni Sendvič","common":"Južna Georgija i otočje Južni Sandwich"},"ita":{"official":"Georgia del Sud e isole Sandwich del Sud","common":"Georgia del Sud e Isole Sandwich Meridionali"},"jpn":{"official":"サウスジョージア·サウスサンドウィッチ諸島","common":"サウスジョージア・サウスサンドウィッチ諸島"},"nld":{"official":"Zuid-Georgië en de Zuidelijke Sandwich-eilanden","common":"Zuid-Georgia en Zuidelijke Sandwicheilanden"},"por":{"official":"Geórgia do Sul e Sandwich do Sul","common":"Ilhas Geórgia do Sul e Sandwich do Sul"},"rus":{"official":"Южная Георгия и Южные Сандвичевы острова","common":"Южная Георгия и Южные Сандвичевы острова"},"slk":{"official":"Južná Georgia a Južné Sandwichove ostrovy","common":"Južná Georgia a Južné Sandwichove ostrovy"},"spa":{"official":"Georgia del Sur y las Islas Sandwich del Sur","common":"Islas Georgias del Sur y Sandwich del Sur"},"fin":{"official":"Etelä-Georgia ja Eteläiset Sandwichsaaret","common":"Etelä-Georgia ja Eteläiset Sandwichsaaret"},"est":{"official":"Lõuna-Georgia ja Lõuna-Sandwichi saared","common":"Lõuna-Georgia ja Lõuna-Sandwichi saared"},"zho":{"official":"南乔治亚岛和南桑威奇群岛","common":"南乔治亚"},"pol":{"official":"Georgia Południowa i Sandwich Południowy","common":"Georgia Południowa i Sandwich Południowy"},"urd":{"official":"جنوبی جارجیا و جزائر جنوبی سینڈوچ","common":"جنوبی جارجیا"},"kor":{"official":"조지아","common":"조지아"},"per":{"official":"جزایر جورجیای جنوبی و ساندویچ جنوبی","common":"جزایر جورجیای جنوبی و ساندویچ جنوبی"}},"latlng":[-54.5,-37],"landlocked":false,"borders":[],"area":3903,"flag":"🇬🇸","demonyms":{"eng":{"f":"South Georgian South Sandwich Islander","m":"South Georgian South Sandwich Islander"},"fra":{"f":"","m":""}}},{"name":{"common":"Svalbard and Jan Mayen","official":"Svalbard og Jan Mayen","native":{"nor":{"official":"Svalbard og Jan Mayen","common":"Svalbard og Jan Mayen"}}},"tld":[".sj"],"cca2":"SJ","ccn3":"744","cca3":"SJM","cioc":"","independent":false,"status":"officially-assigned","currencies":{"NOK":{"name":"krone","symbol":"kr"}},"idd":{"root":"+4","suffixes":["779"]},"capital":["Longyearbyen"],"altSpellings":["SJ","Svalbard and Jan Mayen Islands"],"region":"Europe","subregion":"Northern Europe","languages":{"nor":"Norwegian"},"translations":{"ces":{"official":"Špicberky a Jan Mayen","common":"Špicberky a Jan Mayen"},"deu":{"official":"Spitzbergen und Jan Mayen","common":"Spitzbergen und Jan Mayen"},"fra":{"official":"Jan Mayen Svalbard","common":"Svalbard et Jan Mayen"},"hrv":{"official":"Svalbard og Jan Mayen","common":"Svalbard i Jan Mayen"},"ita":{"official":"Svalbard og Jan Mayen","common":"Svalbard e Jan Mayen"},"jpn":{"official":"スバールバル諸島OGヤンマイエン","common":"スヴァールバル諸島およびヤンマイエン島"},"nld":{"official":"Svalbard og Jan Mayen","common":"Svalbard en Jan Mayen"},"por":{"official":"Svalbard og Jan Mayen","common":"Ilhas Svalbard e Jan Mayen"},"rus":{"official":"Свальбарда ог Ян-Майен","common":"Шпицберген и Ян-Майен"},"slk":{"official":"Svalbard a Jan Mayen","common":"Svalbard a Jan Mayen"},"spa":{"official":"Svalbard og Jan Mayen","common":"Islas Svalbard y Jan Mayen"},"fin":{"official":"Huippuvuoret","common":"Huippuvuoret"},"est":{"official":"Svalbard","common":"Svalbard"},"zho":{"official":"斯瓦尔巴特","common":"斯瓦尔巴特"},"pol":{"official":"Svalbard i Jan Mayen","common":"Svalbard i Jan Mayen"},"urd":{"official":"سوالبارڈ اور جان میئن","common":"سوالبارڈ اور جان میئن"},"kor":{"official":"스발바르 얀마옌 제도","common":"스발바르 얀마옌 제도"},"per":{"official":"سوالبارد و یان ماین","common":"سوالبارد و یان ماین"}},"latlng":[78,20],"landlocked":false,"borders":[],"area":-1,"flag":"🇸🇯","demonyms":{"eng":{"f":"Norwegian","m":"Norwegian"},"fra":{"f":"","m":""}}},{"name":{"common":"Solomon Islands","official":"Solomon Islands","native":{"eng":{"official":"Solomon Islands","common":"Solomon Islands"}}},"tld":[".sb"],"cca2":"SB","ccn3":"090","cca3":"SLB","cioc":"SOL","independent":true,"status":"officially-assigned","currencies":{"SBD":{"name":"Solomon Islands dollar","symbol":"$"}},"idd":{"root":"+6","suffixes":["77"]},"capital":["Honiara"],"altSpellings":["SB"],"region":"Oceania","subregion":"Melanesia","languages":{"eng":"English"},"translations":{"ces":{"official":"Šalamounovy ostrovy","common":"Šalamounovy ostrovy"},"deu":{"official":"Salomonen","common":"Salomonen"},"fra":{"official":"Îles Salomon","common":"Îles Salomon"},"hrv":{"official":"Solomonski Otoci","common":"Solomonski Otoci"},"ita":{"official":"Isole Salomone","common":"Isole Salomone"},"jpn":{"official":"ソロモン諸島","common":"ソロモン諸島"},"nld":{"official":"Solomon eilanden","common":"Salomonseilanden"},"por":{"official":"Ilhas Salomão","common":"Ilhas Salomão"},"rus":{"official":"Соломоновы острова","common":"Соломоновы Острова"},"slk":{"official":"Salomonove ostrovy","common":"Salomonove ostrovy"},"spa":{"official":"islas Salomón","common":"Islas Salomón"},"fin":{"official":"Salomonsaaret","common":"Salomonsaaret"},"est":{"official":"Saalomoni Saared","common":"Saalomoni Saared"},"zho":{"official":"所罗门群岛","common":"所罗门群岛"},"pol":{"official":"Wyspy Salomona","common":"Wyspy Salomona"},"urd":{"official":"جزائر سلیمان","common":"جزائر سلیمان"},"kor":{"official":"솔로몬 제도","common":"솔로몬 제도"},"per":{"official":"جزایر سلیمان","common":"جزایر سلیمان"}},"latlng":[-8,159],"landlocked":false,"borders":[],"area":28896,"flag":"🇸🇧","demonyms":{"eng":{"f":"Solomon Islander","m":"Solomon Islander"},"fra":{"f":"Salomonienne","m":"Salomonien"}}},{"name":{"common":"Sierra Leone","official":"Republic of Sierra Leone","native":{"eng":{"official":"Republic of Sierra Leone","common":"Sierra Leone"}}},"tld":[".sl"],"cca2":"SL","ccn3":"694","cca3":"SLE","cioc":"SLE","independent":true,"status":"officially-assigned","currencies":{"SLL":{"name":"Sierra Leonean leone","symbol":"Le"}},"idd":{"root":"+2","suffixes":["32"]},"capital":["Freetown"],"altSpellings":["SL","Republic of Sierra Leone"],"region":"Africa","subregion":"Western Africa","languages":{"eng":"English"},"translations":{"ces":{"official":"Republika Sierra Leone","common":"Sierra Leone"},"deu":{"official":"Republik Sierra Leone","common":"Sierra Leone"},"fra":{"official":"République de Sierra Leone","common":"Sierra Leone"},"hrv":{"official":"Republika Sijera Leone","common":"Sijera Leone"},"ita":{"official":"Repubblica della Sierra Leone","common":"Sierra Leone"},"jpn":{"official":"シエラレオネ共和国","common":"シエラレオネ"},"nld":{"official":"Republiek Sierra Leone","common":"Sierra Leone"},"por":{"official":"República da Serra Leoa","common":"Serra Leoa"},"rus":{"official":"Республика Сьерра-Леоне","common":"Сьерра-Леоне"},"slk":{"official":"Sierraleonská republika","common":"Sierra Leone"},"spa":{"official":"República de Sierra Leona","common":"Sierra Leone"},"fin":{"official":"Sierra Leonen tasavalta","common":"Sierra Leone"},"est":{"official":"Sierra Leone Vabariik","common":"Sierra Leone"},"zho":{"official":"塞拉利昂共和国","common":"塞拉利昂"},"pol":{"official":"Sierra Leone","common":"Sierra Leone"},"urd":{"official":"جمہوریہ سیرالیون","common":"سیرالیون"},"kor":{"official":"시에라리온 공화국","common":"시에라리온"},"per":{"official":"جمهوری سیرالئون","common":"سیرالئون"}},"latlng":[8.5,-11.5],"landlocked":false,"borders":["GIN","LBR"],"area":71740,"flag":"🇸🇱","demonyms":{"eng":{"f":"Sierra Leonean","m":"Sierra Leonean"},"fra":{"f":"Sierra-leonaise","m":"Sierra-leonais"}}},{"name":{"common":"El Salvador","official":"Republic of El Salvador","native":{"spa":{"official":"República de El Salvador","common":"El Salvador"}}},"tld":[".sv"],"cca2":"SV","ccn3":"222","cca3":"SLV","cioc":"ESA","independent":true,"status":"officially-assigned","currencies":{"USD":{"name":"United States dollar","symbol":"$"}},"idd":{"root":"+5","suffixes":["03"]},"capital":["San Salvador"],"altSpellings":["SV","Republic of El Salvador","República de El Salvador"],"region":"Americas","subregion":"Central America","languages":{"spa":"Spanish"},"translations":{"ces":{"official":"Salvadorská republika","common":"Salvador"},"cym":{"official":"Gweriniaeth El Salfador","common":"El Salfador"},"deu":{"official":"Republik El Salvador","common":"El Salvador"},"fra":{"official":"République du Salvador","common":"Salvador"},"hrv":{"official":"Republika El Salvador","common":"Salvador"},"ita":{"official":"Repubblica di El Salvador","common":"El Salvador"},"jpn":{"official":"エルサルバドル共和国","common":"エルサルバドル"},"nld":{"official":"Republiek El Salvador","common":"El Salvador"},"por":{"official":"República de El Salvador","common":"El Salvador"},"rus":{"official":"Республика Эль-Сальвадор","common":"Сальвадор"},"slk":{"official":"Salvádorská republika","common":"Salvádor"},"spa":{"official":"República de El Salvador","common":"El Salvador"},"fin":{"official":"El Salvadorin tasavalta","common":"El Salvador"},"est":{"official":"El Salvadori Vabariik","common":"El Salvador"},"zho":{"official":"萨尔瓦多共和国","common":"萨尔瓦多"},"pol":{"official":"Republika Salwadoru","common":"Salwador"},"urd":{"official":"جمہوریہ ایل سیلواڈور","common":"ایل سیلواڈور"},"kor":{"official":"엘살바도르 공화국","common":"엘살바도르"},"per":{"official":"جمهوری السالوادور","common":"السالوادور"}},"latlng":[13.83333333,-88.91666666],"landlocked":false,"borders":["GTM","HND"],"area":21041,"flag":"🇸🇻","demonyms":{"eng":{"f":"Salvadoran","m":"Salvadoran"},"fra":{"f":"Salvadorienne","m":"Salvadorien"}}},{"name":{"common":"San Marino","official":"Most Serene Republic of San Marino","native":{"ita":{"official":"Serenissima Repubblica di San Marino","common":"San Marino"}}},"tld":[".sm"],"cca2":"SM","ccn3":"674","cca3":"SMR","cioc":"SMR","independent":true,"status":"officially-assigned","currencies":{"EUR":{"name":"Euro","symbol":"€"}},"idd":{"root":"+3","suffixes":["78"]},"capital":["City of San Marino"],"altSpellings":["SM","Republic of San Marino","Repubblica di San Marino"],"region":"Europe","subregion":"Southern Europe","languages":{"ita":"Italian"},"translations":{"ces":{"official":"Republika San Marino","common":"San Marino"},"deu":{"official":"Republik San Marino","common":"San Marino"},"fra":{"official":"République de Saint-Marin","common":"Saint-Marin"},"hrv":{"official":"Većina Serene Republika San Marino","common":"San Marino"},"ita":{"official":"Serenissima Repubblica di San Marino","common":"San Marino"},"jpn":{"official":"サンマリノのほとんどセリーヌ共和国","common":"サンマリノ"},"nld":{"official":"Meest Serene Republiek San Marino","common":"San Marino"},"por":{"official":"Sereníssima República de San Marino","common":"San Marino"},"rus":{"official":"Большинство Serene Республика Сан-Марино","common":"Сан-Марино"},"slk":{"official":"Sanmarínska republika","common":"San Maríno"},"spa":{"official":"Serenísima República de San Marino","common":"San Marino"},"fin":{"official":"San Marinon seesteinen tasavalta","common":"San Marino"},"est":{"official":"San Marino Vabariik","common":"San Marino"},"zho":{"official":"圣马力诺共和国","common":"圣马力诺"},"pol":{"official":"Republika San Marino","common":"San Marino"},"urd":{"official":"جمہوریہ سان مارینو","common":"سان مارینو"},"kor":{"official":"산마리노 공화국","common":"산마리노"},"per":{"official":"جمهوری سان مارینو","common":"سان مارینو"}},"latlng":[43.76666666,12.41666666],"landlocked":true,"borders":["ITA"],"area":61,"flag":"🇸🇲","demonyms":{"eng":{"f":"Sammarinese","m":"Sammarinese"},"fra":{"f":"Saint-Marinaise","m":"Saint-Marinais"}}},{"name":{"common":"Somalia","official":"Federal Republic of Somalia","native":{"ara":{"official":"جمهورية الصومال‎‎","common":"الصومال‎‎"},"som":{"official":"Jamhuuriyadda Federaalka Soomaaliya","common":"Soomaaliya"}}},"tld":[".so"],"cca2":"SO","ccn3":"706","cca3":"SOM","cioc":"SOM","independent":true,"status":"officially-assigned","currencies":{"SOS":{"name":"Somali shilling","symbol":"Sh"}},"idd":{"root":"+2","suffixes":["52"]},"capital":["Mogadishu"],"altSpellings":["SO","aṣ-Ṣūmāl","Federal Republic of Somalia","Jamhuuriyadda Federaalka Soomaaliya","Jumhūriyyat aṣ-Ṣūmāl al-Fiderāliyya"],"region":"Africa","subregion":"Eastern Africa","languages":{"ara":"Arabic","som":"Somali"},"translations":{"ces":{"official":"Somálská demokratická republika","common":"Somálsko"},"deu":{"official":"Bundesrepublik Somalia","common":"Somalia"},"fra":{"official":"République fédérale de Somalie","common":"Somalie"},"hrv":{"official":"Savezna Republika Somaliji","common":"Somalija"},"ita":{"official":"Repubblica federale di Somalia","common":"Somalia"},"jpn":{"official":"ソマリア連邦共和国","common":"ソマリア"},"nld":{"official":"Federale Republiek Somalië","common":"Somalië"},"por":{"official":"República Federal da Somália","common":"Somália"},"rus":{"official":"Федеративная Республика Сомали","common":"Сомали"},"slk":{"official":"Somálska federatívna republika","common":"Somálsko"},"spa":{"official":"República Federal de Somalia","common":"Somalia"},"fin":{"official":"Somalian liittotasavalta","common":"Somalia"},"est":{"official":"Somaalia Liitvabariik","common":"Somaalia"},"zho":{"official":"索马里共和国","common":"索马里"},"pol":{"official":"Federalna Republika Somalii","common":"Somalia"},"urd":{"official":"وفاقی جمہوریہ صومالیہ","common":"صومالیہ"},"kor":{"official":" 소말리아 연방 공화국","common":"소말리아"},"per":{"official":"جمهوری فدرال سومالی","common":"سومالی"}},"latlng":[10,49],"landlocked":false,"borders":["DJI","ETH","KEN"],"area":637657,"flag":"🇸🇴","demonyms":{"eng":{"f":"Somali","m":"Somali"},"fra":{"f":"Somalienne","m":"Somalien"}}},{"name":{"common":"Saint Pierre and Miquelon","official":"Saint Pierre and Miquelon","native":{"fra":{"official":"Collectivité territoriale de Saint-Pierre-et-Miquelon","common":"Saint-Pierre-et-Miquelon"}}},"tld":[".pm"],"cca2":"PM","ccn3":"666","cca3":"SPM","cioc":"","independent":false,"status":"officially-assigned","currencies":{"EUR":{"name":"Euro","symbol":"€"}},"idd":{"root":"+5","suffixes":["08"]},"capital":["Saint-Pierre"],"altSpellings":["PM","Collectivité territoriale de Saint-Pierre-et-Miquelon"],"region":"Americas","subregion":"North America","languages":{"fra":"French"},"translations":{"ces":{"official":"Saint-Pierre a Miquelon","common":"Saint-Pierre a Miquelon"},"deu":{"official":"St. Pierre und Miquelon","common":"St. Pierre und Miquelon"},"fra":{"official":"Saint-Pierre-et-Miquelon","common":"Saint-Pierre-et-Miquelon"},"hrv":{"official":"Saint Pierre i Miquelon","common":"Sveti Petar i Mikelon"},"ita":{"official":"Saint Pierre e Miquelon","common":"Saint-Pierre e Miquelon"},"jpn":{"official":"サンピエール島·ミクロン島","common":"サンピエール島・ミクロン島"},"nld":{"official":"Saint-Pierre en Miquelon","common":"Saint Pierre en Miquelon"},"por":{"official":"Saint Pierre e Miquelon","common":"Saint-Pierre e Miquelon"},"rus":{"official":"Сен-Пьер и Микелон","common":"Сен-Пьер и Микелон"},"slk":{"official":"Ostrovy Saint Pierre a Miquelon","common":"Saint Pierre a Miquelon"},"spa":{"official":"San Pedro y Miquelón","common":"San Pedro y Miquelón"},"fin":{"official":"Saint-Pierre ja Miquelon","common":"Saint-Pierre ja Miquelon"},"est":{"official":"Saint-Pierre’i ja Miqueloni territoriaalühendus","common":"Saint-Pierre ja Miquelon"},"zho":{"official":"圣皮埃尔和密克隆","common":"圣皮埃尔和密克隆"},"pol":{"official":"Saint-Pierre i Miquelon","common":"Saint-Pierre i Miquelon"},"urd":{"official":"سینٹ پیئر و میکیلون","common":"سینٹ پیئر و میکیلون"},"kor":{"official":"생피에르 미클롱","common":"생피에르 미클롱"},"per":{"official":"سن-پیر-ا-میکلون","common":"سن-پیِر و میکلُن"}},"latlng":[46.83333333,-56.33333333],"landlocked":false,"borders":[],"area":242,"flag":"🇵🇲","demonyms":{"eng":{"f":"Saint-Pierrais, Miquelonnais","m":"Saint-Pierrais, Miquelonnais"},"fra":{"f":"Saint-Pierraise, Miquelonaise","m":"Saint-Pierrais, Miquelonais"}}},{"name":{"common":"Serbia","official":"Republic of Serbia","native":{"srp":{"official":"Република Србија","common":"Србија"}}},"tld":[".rs",".срб"],"cca2":"RS","ccn3":"688","cca3":"SRB","cioc":"SRB","independent":true,"status":"officially-assigned","currencies":{"RSD":{"name":"Serbian dinar","symbol":"дин."}},"idd":{"root":"+3","suffixes":["81"]},"capital":["Belgrade"],"altSpellings":["RS","Srbija","Republic of Serbia","Република Србија","Republika Srbija"],"region":"Europe","subregion":"Southern Europe","languages":{"srp":"Serbian"},"translations":{"ces":{"official":"Srbská republika","common":"Srbsko"},"deu":{"official":"Republik Serbien","common":"Serbien"},"fra":{"official":"République de Serbie","common":"Serbie"},"hrv":{"official":"Republika Srbija","common":"Srbija"},"ita":{"official":"Repubblica di Serbia","common":"Serbia"},"jpn":{"official":"セルビア共和国","common":"セルビア"},"nld":{"official":"Republiek Servië","common":"Servië"},"por":{"official":"República da Sérvia","common":"Sérvia"},"rus":{"official":"Республика Сербия","common":"Сербия"},"slk":{"official":"Srbská republika","common":"Srbsko"},"spa":{"official":"República de Serbia","common":"Serbia"},"fin":{"official":"Serbian tasavalta","common":"Serbia"},"est":{"official":"Serbia Vabariik","common":"Serbia"},"zho":{"official":"塞尔维亚共和国","common":"塞尔维亚"},"pol":{"official":"Republika Serbii","common":"Serbia"},"urd":{"official":"جمہوریہ سربیا","common":"سربیا"},"kor":{"official":"세르비아 공화국","common":"세르비아"},"per":{"official":"جمهوری صربستان","common":"صربستان"}},"latlng":[44,21],"landlocked":true,"borders":["BIH","BGR","HRV","HUN","UNK","MKD","MNE","ROU"],"area":88361,"flag":"🇷🇸","demonyms":{"eng":{"f":"Serbian","m":"Serbian"},"fra":{"f":"Serbe","m":"Serbe"}}},{"name":{"common":"South Sudan","official":"Republic of South Sudan","native":{"eng":{"official":"Republic of South Sudan","common":"South Sudan"}}},"tld":[".ss"],"cca2":"SS","ccn3":"728","cca3":"SSD","cioc":"","independent":true,"status":"officially-assigned","currencies":{"SSP":{"name":"South Sudanese pound","symbol":"£"}},"idd":{"root":"+2","suffixes":["11"]},"capital":["Juba"],"altSpellings":["SS"],"region":"Africa","subregion":"Middle Africa","languages":{"eng":"English"},"translations":{"ces":{"official":"Jihosúdánská republika","common":"Jižní Súdán"},"deu":{"official":"Republik Südsudan","common":"Südsudan"},"fra":{"official":"République du Soudan du Sud","common":"Soudan du Sud"},"hrv":{"official":"Republika Južni Sudan","common":"Južni Sudan"},"ita":{"official":"Repubblica del Sudan del Sud","common":"Sudan del sud"},"jpn":{"official":"南スーダン共和国","common":"南スーダン"},"nld":{"official":"Republiek Zuid-Soedan","common":"Zuid-Soedan"},"por":{"official":"República do Sudão do Sul","common":"Sudão do Sul"},"rus":{"official":"Республика Южный Судан","common":"Южный Судан"},"slk":{"official":"Juhosudánska republika","common":"Južný Sudán"},"spa":{"official":"República de Sudán del Sur","common":"Sudán del Sur"},"fin":{"official":"Etelä-Sudanin tasavalta","common":"Etelä-Sudan"},"est":{"official":"Lõuna-Sudaani Vabariik","common":"Lõuna-Sudaan"},"zho":{"official":"南苏丹共和国","common":"南苏丹"},"pol":{"official":"Republika Sudanu","common":"Sudan"},"urd":{"official":"جمہوریہ جنوبی سوڈان","common":"جنوبی سوڈان"},"kor":{"official":"남수단 공화국","common":"남수단"},"per":{"official":"جمهوری سودان جنوبی","common":"سودان جنوبی"}},"latlng":[7,30],"landlocked":true,"borders":["CAF","COD","ETH","KEN","SDN","UGA"],"area":619745,"flag":"🇸🇸","demonyms":{"eng":{"f":"South Sudanese","m":"South Sudanese"},"fra":{"f":"Sud-Soudanaise","m":"Sud-Soudanais"}}},{"name":{"common":"São Tomé and Príncipe","official":"Democratic Republic of São Tomé and Príncipe","native":{"por":{"official":"República Democrática do São Tomé e Príncipe","common":"São Tomé e Príncipe"}}},"tld":[".st"],"cca2":"ST","ccn3":"678","cca3":"STP","cioc":"STP","independent":true,"status":"officially-assigned","currencies":{"STN":{"name":"São Tomé and Príncipe dobra","symbol":"Db"}},"idd":{"root":"+2","suffixes":["39"]},"capital":["São Tomé"],"altSpellings":["ST","Democratic Republic of São Tomé and Príncipe","Sao Tome and Principe","República Democrática de São Tomé e Príncipe"],"region":"Africa","subregion":"Middle Africa","languages":{"por":"Portuguese"},"translations":{"ces":{"official":"Demokratická republika Svatý Tomáš a Princův ostrov","common":"Svatý Tomáš a Princův ostrov"},"deu":{"official":"Demokratische Republik São Tomé und Príncipe","common":"São Tomé und Príncipe"},"fra":{"official":"République démocratique de São Tomé et Príncipe","common":"São Tomé et Príncipe"},"hrv":{"official":"Demokratska Republika São Tome i Principe","common":"Sveti Toma i Princip"},"ita":{"official":"Repubblica democratica di São Tomé e Príncipe","common":"São Tomé e Príncipe"},"jpn":{"official":"サントメ·プリンシペ民主共和国","common":"サントメ・プリンシペ"},"nld":{"official":"Democratische Republiek Sao Tomé en Principe","common":"Sao Tomé en Principe"},"por":{"official":"República Democrática de São Tomé e Príncipe","common":"São Tomé e Príncipe"},"spa":{"official":"República Democrática de Santo Tomé y Príncipe","common":"Santo Tomé y Príncipe"},"rus":{"official":"Демократическая Республика Сан-Томе и Принсипи","common":"Сан-Томе и Принсипи"},"slk":{"official":"Demokratická republika Svätého Tomáša A princovho ostrova","common":"Svätý Tomáš a Princov ostrov"},"fin":{"official":"São Tomé ja Príncipen demokraattinen tasavalta","common":"São Téme ja Príncipe"},"est":{"official":"São Tomé ja Príncipe Demokraatlik Vabariik","common":"São Tomé ja Príncipe"},"zho":{"official":"圣多美和普林西比民主共和国","common":"圣多美和普林西比"},"pol":{"official":"Demokratyczna Republika Wysp Świętego Tomasza i Książęcej","common":"Wyspy Świętego Tomasza i Książęca"},"urd":{"official":"جمہوریہ ساؤ ٹومے و پرنسپے","common":"ساؤ ٹومے و پرنسپے"},"kor":{"official":"상투메 프린시페 민주 공화국","common":"상투메 프린시페"},"per":{"official":"جمهوری دموکراتیک سائوتومه و پرنسیپ","common":"سائوتومه و پرنسیپ"}},"latlng":[1,7],"landlocked":false,"borders":[],"area":964,"flag":"🇸🇹","demonyms":{"eng":{"f":"Sao Tomean","m":"Sao Tomean"},"fra":{"f":"Santoméenne","m":"Santoméen"}}},{"name":{"common":"Suriname","official":"Republic of Suriname","native":{"nld":{"official":"Republiek Suriname","common":"Suriname"}}},"tld":[".sr"],"cca2":"SR","ccn3":"740","cca3":"SUR","cioc":"SUR","independent":true,"status":"officially-assigned","currencies":{"SRD":{"name":"Surinamese dollar","symbol":"$"}},"idd":{"root":"+5","suffixes":["97"]},"capital":["Paramaribo"],"altSpellings":["SR","Sarnam","Sranangron","Republic of Suriname","Republiek Suriname"],"region":"Americas","subregion":"South America","languages":{"nld":"Dutch"},"translations":{"ces":{"official":"Republika Surinam","common":"Surinam"},"deu":{"official":"Republik Suriname","common":"Suriname"},"fra":{"official":"République du Suriname","common":"Surinam"},"hrv":{"official":"Republika Surinam","common":"Surinam"},"ita":{"official":"Repubblica del Suriname","common":"Suriname"},"jpn":{"official":"スリナム共和国","common":"スリナム"},"nld":{"official":"Republiek Suriname","common":"Suriname"},"por":{"official":"República do Suriname","common":"Suriname"},"rus":{"official":"Республика Суринам","common":"Суринам"},"slk":{"official":"Surinamská republika","common":"Surinam"},"spa":{"official":"República de Suriname","common":"Surinam"},"fin":{"official":"Surinamen tasavalta","common":"Suriname"},"est":{"official":"Suriname Vabariik","common":"Suriname"},"zho":{"official":"苏里南共和国","common":"苏里南"},"pol":{"official":"Republika Surinamu","common":"Surinam"},"urd":{"official":"جمہوریہ سرینام","common":"سرینام"},"kor":{"official":"수리남 공화국","common":"수리남"},"per":{"official":"جمهوری سورینام","common":"سورینام"}},"latlng":[4,-56],"landlocked":false,"borders":["BRA","GUF","GUY"],"area":163820,"flag":"🇸🇷","demonyms":{"eng":{"f":"Surinamer","m":"Surinamer"},"fra":{"f":"Surinamaise","m":"Surinamais"}}},{"name":{"common":"Slovakia","official":"Slovak Republic","native":{"slk":{"official":"Slovenská republika","common":"Slovensko"}}},"tld":[".sk"],"cca2":"SK","ccn3":"703","cca3":"SVK","cioc":"SVK","independent":true,"status":"officially-assigned","currencies":{"EUR":{"name":"Euro","symbol":"€"}},"idd":{"root":"+4","suffixes":["21"]},"capital":["Bratislava"],"altSpellings":["SK","Slovak Republic","Slovenská republika"],"region":"Europe","subregion":"Central Europe","languages":{"slk":"Slovak"},"translations":{"ces":{"official":"Slovenská republika","common":"Slovensko"},"deu":{"official":"Slowakische Republik","common":"Slowakei"},"fra":{"official":"République slovaque","common":"Slovaquie"},"hrv":{"official":"slovačka","common":"Slovačka"},"ita":{"official":"Repubblica slovacca","common":"Slovacchia"},"jpn":{"official":"スロバキア共和国","common":"スロバキア"},"nld":{"official":"Slowaakse Republiek","common":"Slowakije"},"por":{"official":"República Eslovaca","common":"Eslováquia"},"rus":{"official":"Словацкая Республика","common":"Словакия"},"slk":{"official":"Slovenská republika","common":"Slovensko"},"spa":{"official":"República Eslovaca","common":"República Eslovaca"},"fin":{"official":"Slovakian tasavalta","common":"Slovakia"},"est":{"official":"Slovaki Vabariik","common":"Slovakkia"},"zho":{"official":"斯洛伐克共和国","common":"斯洛伐克"},"pol":{"official":"Republika Słowacka","common":"Słowacja"},"urd":{"official":"جمہوریہ سلوواکیہ","common":"سلوواکیہ"},"kor":{"official":"슬로바키아 공화국","common":"슬로바키아"},"per":{"official":"جمهوری اسلواکی","common":"اِسلُواکی"}},"latlng":[48.66666666,19.5],"landlocked":true,"borders":["AUT","CZE","HUN","POL","UKR"],"area":49037,"flag":"🇸🇰","demonyms":{"eng":{"f":"Slovak","m":"Slovak"},"fra":{"f":"Slovaque","m":"Slovaque"}}},{"name":{"common":"Slovenia","official":"Republic of Slovenia","native":{"slv":{"official":"Republika Slovenija","common":"Slovenija"}}},"tld":[".si"],"cca2":"SI","ccn3":"705","cca3":"SVN","cioc":"SLO","independent":true,"status":"officially-assigned","currencies":{"EUR":{"name":"Euro","symbol":"€"}},"idd":{"root":"+3","suffixes":["86"]},"capital":["Ljubljana"],"altSpellings":["SI","Republic of Slovenia","Republika Slovenija"],"region":"Europe","subregion":"Southern Europe","languages":{"slv":"Slovene"},"translations":{"ces":{"official":"Slovinská republika","common":"Slovinsko"},"deu":{"official":"Republik Slowenien","common":"Slowenien"},"fra":{"official":"République de Slovénie","common":"Slovénie"},"hrv":{"official":"Republika Slovenija","common":"Slovenija"},"ita":{"official":"Repubblica di Slovenia","common":"Slovenia"},"jpn":{"official":"スロベニア共和国","common":"スロベニア"},"nld":{"official":"Republiek Slovenië","common":"Slovenië"},"por":{"official":"República da Eslovénia","common":"Eslovénia"},"rus":{"official":"Республика Словения","common":"Словения"},"slk":{"official":"Slovinská republika","common":"Slovinsko"},"spa":{"official":"República de Eslovenia","common":"Eslovenia"},"fin":{"official":"Slovenian tasavalta","common":"Slovenia"},"est":{"official":"Sloveenia Vabariik","common":"Sloveenia"},"zho":{"official":"斯洛文尼亚共和国","common":"斯洛文尼亚"},"pol":{"official":"Republika Słowenii","common":"Słowenia"},"urd":{"official":"جمہوریہ سلووینیا","common":"سلووینیا"},"kor":{"official":"슬로베니아 공화국","common":"슬로베니아"},"per":{"official":"جمهوری اسلوونی","common":"اسلوونی"}},"latlng":[46.11666666,14.81666666],"landlocked":false,"borders":["AUT","HRV","ITA","HUN"],"area":20273,"flag":"🇸🇮","demonyms":{"eng":{"f":"Slovene","m":"Slovene"},"fra":{"f":"Slovène","m":"Slovène"}}},{"name":{"common":"Sweden","official":"Kingdom of Sweden","native":{"swe":{"official":"Konungariket Sverige","common":"Sverige"}}},"tld":[".se"],"cca2":"SE","ccn3":"752","cca3":"SWE","cioc":"SWE","independent":true,"status":"officially-assigned","currencies":{"SEK":{"name":"Swedish krona","symbol":"kr"}},"idd":{"root":"+4","suffixes":["6"]},"capital":["Stockholm"],"altSpellings":["SE","Kingdom of Sweden","Konungariket Sverige"],"region":"Europe","subregion":"Northern Europe","languages":{"swe":"Swedish"},"translations":{"ces":{"official":"Švédské království","common":"Švédsko"},"deu":{"official":"Königreich Schweden","common":"Schweden"},"fra":{"official":"Royaume de Suède","common":"Suède"},"hrv":{"official":"Kraljevina Švedska","common":"Švedska"},"ita":{"official":"Regno di Svezia","common":"Svezia"},"jpn":{"official":"スウェーデン王国","common":"スウェーデン"},"nld":{"official":"Koninkrijk Zweden","common":"Zweden"},"por":{"official":"Reino da Suécia","common":"Suécia"},"rus":{"official":"Королевство Швеция","common":"Швеция"},"slk":{"official":"Švédske kráľovstvo","common":"Švédsko"},"spa":{"official":"Reino de Suecia","common":"Suecia"},"fin":{"official":"Ruotsin kuningaskunta","common":"Ruotsi"},"est":{"official":"Rootsi Kuningriik","common":"Rootsi"},"zho":{"official":"瑞典王国","common":"瑞典"},"pol":{"official":"Królestwo Szwecji","common":"Szwecja"},"urd":{"official":"مملکتِ سویڈن","common":"سویڈن"},"kor":{"official":"스웨덴 왕국","common":"스웨덴"},"per":{"official":"پادشاهی سوئد","common":"سوئد"}},"latlng":[62,15],"landlocked":false,"borders":["FIN","NOR"],"area":450295,"flag":"🇸🇪","demonyms":{"eng":{"f":"Swedish","m":"Swedish"},"fra":{"f":"Suédoise","m":"Suédois"}}},{"name":{"common":"Eswatini","official":"Kingdom of Eswatini","native":{"eng":{"official":"Kingdom of Eswatini","common":"Eswatini"},"ssw":{"official":"Umbuso weSwatini","common":"eSwatini"}}},"tld":[".sz"],"cca2":"SZ","ccn3":"748","cca3":"SWZ","cioc":"SWZ","independent":true,"status":"officially-assigned","currencies":{"SZL":{"name":"Swazi lilangeni","symbol":"L"}},"idd":{"root":"+2","suffixes":["68"]},"capital":["Lobamba"],"altSpellings":["SZ","Swaziland","weSwatini","Swatini","Ngwane","Kingdom of Eswatini","Umbuso weSwatini"],"region":"Africa","subregion":"Southern Africa","languages":{"eng":"English","ssw":"Swazi"},"translations":{"ces":{"official":"Svazijské království","common":"Svazijsko"},"deu":{"official":"Königreich Eswatini","common":"Swasiland"},"fra":{"official":"Royaume d’Eswatini","common":"Swaziland"},"hrv":{"official":"Kraljevina eSwatini","common":"Svazi"},"ita":{"official":"Regno di eSwatini","common":"Swaziland"},"jpn":{"official":"スワジランド王国","common":"スワジランド"},"nld":{"official":"Koninkrijk eSwatini","common":"Swaziland"},"por":{"official":"Reino de eSwatini","common":"Suazilândia"},"rus":{"official":"Королевство Свазиленд","common":"Свазиленд"},"slk":{"official":"Svazijské kráľovstvo","common":"Svazijsko"},"spa":{"official":"Reino de eSwatini","common":"Suazilandia"},"fin":{"official":"Swazimaan kuningaskunta","common":"Swazimaa"},"est":{"official":"eSwatini Kuningriik","common":"Svaasimaa"},"pol":{"official":"Królestwo Suazi","common":"Suazi"},"zho":{"official":"斯威士兰王国","common":"斯威士兰"},"urd":{"official":"مملکتِ سوازی لینڈ","common":"سوازی لینڈ"},"kor":{"official":"에스와티니 왕국","common":"에스와티니"},"per":{"official":"پادشاهی سوازیلند","common":"اسواتینی"}},"latlng":[-26.5,31.5],"landlocked":true,"borders":["MOZ","ZAF"],"area":17364,"flag":"🇸🇿","demonyms":{"eng":{"f":"Swazi","m":"Swazi"},"fra":{"f":"Swazie","m":"Swazie"}}},{"name":{"common":"Sint Maarten","official":"Sint Maarten","native":{"eng":{"official":"Sint Maarten","common":"Sint Maarten"},"fra":{"official":"Saint-Martin","common":"Saint-Martin"},"nld":{"official":"Sint Maarten","common":"Sint Maarten"}}},"tld":[".sx"],"cca2":"SX","ccn3":"534","cca3":"SXM","cioc":"","independent":false,"status":"officially-assigned","currencies":{"ANG":{"name":"Netherlands Antillean guilder","symbol":"ƒ"}},"idd":{"root":"+1","suffixes":["721"]},"capital":["Philipsburg"],"altSpellings":["SX","Sint Maarten (Dutch part)"],"region":"Americas","subregion":"Caribbean","languages":{"eng":"English","fra":"French","nld":"Dutch"},"translations":{"ces":{"official":"Svatý Martin","common":"Svatý Martin (Nizozemsko)"},"deu":{"official":"Sint Maarten","common":"Sint Maarten"},"fra":{"official":"Sint Maarten","common":"Saint-Martin"},"hrv":{"official":"Sveti Martin","common":"Sveti Martin"},"ita":{"official":"Sint Maarten","common":"Sint Maarten"},"jpn":{"official":"シントマールテン島","common":"シント・マールテン"},"nld":{"official":"Sint Maarten","common":"Sint Maarten"},"por":{"official":"Sint Maarten","common":"São Martinho"},"rus":{"official":"Синт-Маартен","common":"Синт-Мартен"},"slk":{"official":"Sint Maarten","common":"Sint Maarten"},"spa":{"official":"Sint Maarten","common":"Sint Maarten"},"fin":{"official":"Sint Maarten","common":"Sint Maarten"},"est":{"official":"Sint Maarten","common":"Sint Maarten"},"zho":{"official":"圣马丁岛","common":"圣马丁岛"},"pol":{"official":"Sint Maarten","common":"Sint Maarten"},"urd":{"official":"سنٹ مارٹن","common":"سنٹ مارٹن"},"kor":{"official":"신트마르턴","common":"신트마르턴"},"per":{"official":"سن مارتن","common":"سن مارتن"}},"latlng":[18.033333,-63.05],"landlocked":false,"borders":["MAF"],"area":34,"flag":"🇸🇽","demonyms":{"eng":{"f":"St. Maartener","m":"St. Maartener"},"fra":{"f":"Saint-Martinoise","m":"Saint-Martinois"}}},{"name":{"common":"Seychelles","official":"Republic of Seychelles","native":{"crs":{"official":"Repiblik Sesel","common":"Sesel"},"eng":{"official":"Republic of Seychelles","common":"Seychelles"},"fra":{"official":"République des Seychelles","common":"Seychelles"}}},"tld":[".sc"],"cca2":"SC","ccn3":"690","cca3":"SYC","cioc":"SEY","independent":true,"status":"officially-assigned","currencies":{"SCR":{"name":"Seychellois rupee","symbol":"₨"}},"idd":{"root":"+2","suffixes":["48"]},"capital":["Victoria"],"altSpellings":["SC","Republic of Seychelles","Repiblik Sesel","République des Seychelles"],"region":"Africa","subregion":"Eastern Africa","languages":{"crs":"Seychellois Creole","eng":"English","fra":"French"},"translations":{"ces":{"official":"Seychelská republika","common":"Seychely"},"deu":{"official":"Republik der Seychellen","common":"Seychellen"},"fra":{"official":"République des Seychelles","common":"Seychelles"},"hrv":{"official":"Republika Sejšeli","common":"Sejšeli"},"ita":{"official":"Repubblica delle Seychelles","common":"Seychelles"},"jpn":{"official":"セイシェル共和国","common":"セーシェル"},"nld":{"official":"Republiek der Seychellen","common":"Seychellen"},"por":{"official":"República das Seychelles","common":"Seicheles"},"rus":{"official":"Республика Сейшельские Острова","common":"Сейшельские Острова"},"slk":{"official":"Seychelská republika","common":"Seychely"},"spa":{"official":"República de las Seychelles","common":"Seychelles"},"fin":{"official":"Seychellien tasavalta","common":"Seychellit"},"est":{"official":"Seišelli Vabariik","common":"Seišellid"},"zho":{"official":"塞舌尔共和国","common":"塞舌尔"},"pol":{"official":"Republika Seszeli","common":"Seszele"},"urd":{"official":"جمہوریہ سیچیلیس","common":"سیچیلیس"},"kor":{"official":"세이셸 공화국","common":"세이셸"},"per":{"official":"جمهوری سیشل","common":"سیشل"}},"latlng":[-4.58333333,55.66666666],"landlocked":false,"borders":[],"area":452,"flag":"🇸🇨","demonyms":{"eng":{"f":"Seychellois","m":"Seychellois"},"fra":{"f":"Seychelloise","m":"Seychellois"}}},{"name":{"common":"Syria","official":"Syrian Arab Republic","native":{"ara":{"official":"الجمهورية العربية السورية","common":"سوريا"}}},"tld":[".sy","سوريا."],"cca2":"SY","ccn3":"760","cca3":"SYR","cioc":"SYR","independent":true,"status":"officially-assigned","currencies":{"SYP":{"name":"Syrian pound","symbol":"£"}},"idd":{"root":"+9","suffixes":["63"]},"capital":["Damascus"],"altSpellings":["SY","Syrian Arab Republic","Al-Jumhūrīyah Al-ʻArabīyah As-Sūrīyah"],"region":"Asia","subregion":"Western Asia","languages":{"ara":"Arabic"},"translations":{"ces":{"official":"Syrská arabská republika","common":"Sýrie"},"deu":{"official":"Arabische Republik Syrien","common":"Syrien"},"fra":{"official":"République arabe syrienne","common":"Syrie"},"hrv":{"official":"Sirijska Arapska Republika","common":"Sirija"},"ita":{"official":"Repubblica araba siriana","common":"Siria"},"jpn":{"official":"シリアアラブ共和国","common":"シリア・アラブ共和国"},"nld":{"official":"Syrische Arabische Republiek","common":"Syrië"},"por":{"official":"República Árabe Síria","common":"Síria"},"rus":{"official":"Сирийская Арабская Республика","common":"Сирия"},"slk":{"official":"Sýrska arabská republika","common":"Sýria"},"spa":{"official":"República Árabe Siria","common":"Siria"},"fin":{"official":"Syyrian arabitasavalta","common":"Syyria"},"est":{"official":"Süüria Araabia Vabariik","common":"Süüria"},"zho":{"official":"叙利亚阿拉伯共和国","common":"叙利亚"},"pol":{"official":"Syryjska Republika Arabska","common":"Syria"},"urd":{"official":"عرب جمہوریہ سوریہ","common":"سوریہ"},"kor":{"official":"시리아 아랍 공화국","common":"시리아"},"per":{"official":"جمهوری عربی سوریه","common":"سوریه"}},"latlng":[35,38],"landlocked":false,"borders":["IRQ","ISR","JOR","LBN","TUR"],"area":185180,"flag":"🇸🇾","demonyms":{"eng":{"f":"Syrian","m":"Syrian"},"fra":{"f":"Syrienne","m":"Syrien"}}},{"name":{"common":"Turks and Caicos Islands","official":"Turks and Caicos Islands","native":{"eng":{"official":"Turks and Caicos Islands","common":"Turks and Caicos Islands"}}},"tld":[".tc"],"cca2":"TC","ccn3":"796","cca3":"TCA","cioc":"","independent":false,"status":"officially-assigned","currencies":{"USD":{"name":"United States dollar","symbol":"$"}},"idd":{"root":"+1","suffixes":["649"]},"capital":["Cockburn Town"],"altSpellings":["TC"],"region":"Americas","subregion":"Caribbean","languages":{"eng":"English"},"translations":{"ces":{"official":"Turks a Caicos","common":"Turks a Caicos"},"deu":{"official":"Turks und Caicos Inseln","common":"Turks-und Caicosinseln"},"fra":{"official":"Îles Turques et Caïques","common":"Îles Turques-et-Caïques"},"hrv":{"official":"Otoci Turks i Caicos","common":"Otoci Turks i Caicos"},"ita":{"official":"Turks e Caicos","common":"Isole Turks e Caicos"},"jpn":{"official":"タークス·カイコス諸島","common":"タークス・カイコス諸島"},"nld":{"official":"Turks-en Caicoseilanden","common":"Turks-en Caicoseilanden"},"por":{"official":"Ilhas Turks e Caicos","common":"Ilhas Turks e Caicos"},"rus":{"official":"Теркс и Кайкос острова","common":"Теркс и Кайкос"},"slk":{"official":"Ostrovy Turks a Caicos","common":"Turks a Caicos"},"spa":{"official":"Islas Turcas y Caicos","common":"Islas Turks y Caicos"},"fin":{"official":"Turks-ja Caicossaaret","common":"Turks-ja Caicossaaret"},"est":{"official":"Turksi ja Caicose saared","common":"Turks ja Caicos"},"zho":{"official":"特克斯和凯科斯群岛","common":"特克斯和凯科斯群岛"},"pol":{"official":"Turks i Caicos","common":"Turks i Caicos"},"urd":{"official":"جزائر کیکس و ترکیہ","common":"جزائر کیکس و ترکیہ"},"kor":{"official":"터크스 케이커스 제도","common":"터크스 케이커스 제도"},"per":{"official":"جزایر تورکس و کایکوس","common":"جزایر تورکس و کایکوس"}},"latlng":[21.75,-71.58333333],"landlocked":false,"borders":[],"area":948,"flag":"🇹🇨","demonyms":{"eng":{"f":"Turks and Caicos Islander","m":"Turks and Caicos Islander"},"fra":{"f":"","m":""}}},{"name":{"common":"Chad","official":"Republic of Chad","native":{"ara":{"official":"جمهورية تشاد","common":"تشاد‎"},"fra":{"official":"République du Tchad","common":"Tchad"}}},"tld":[".td"],"cca2":"TD","ccn3":"148","cca3":"TCD","cioc":"CHA","independent":true,"status":"officially-assigned","currencies":{"XAF":{"name":"Central African CFA franc","symbol":"Fr"}},"idd":{"root":"+2","suffixes":["35"]},"capital":["N\'Djamena"],"altSpellings":["TD","Tchad","Republic of Chad","République du Tchad"],"region":"Africa","subregion":"Middle Africa","languages":{"ara":"Arabic","fra":"French"},"translations":{"ces":{"official":"Čadská republika","common":"Čad"},"cym":{"official":"Gweriniaeth Tsiad","common":"Tsiad"},"deu":{"official":"Republik Tschad","common":"Tschad"},"fra":{"official":"République du Tchad","common":"Tchad"},"hrv":{"official":"Čadu","common":"Čad"},"ita":{"official":"Repubblica del Ciad","common":"Ciad"},"jpn":{"official":"チャド共和国","common":"チャド"},"nld":{"official":"Republiek Tsjaad","common":"Tsjaad"},"por":{"official":"República do Chade","common":"Chade"},"rus":{"official":"Республика Чад","common":"Чад"},"slk":{"official":"Čadská republika","common":"Čad"},"spa":{"official":"República de Chad","common":"Chad"},"fin":{"official":"Tšadin tasavalta","common":"Tšad"},"est":{"official":"Tšaadi Vabariik","common":"Tšaad"},"zho":{"official":"乍得共和国","common":"乍得"},"pol":{"official":"Republika Czadu","common":"Czad"},"urd":{"official":"جمہوریہ چاڈ","common":"چاڈ"},"kor":{"official":"차드 공화국","common":"차드"},"per":{"official":"جمهوری چاد","common":"چاد"}},"latlng":[15,19],"landlocked":true,"borders":["CMR","CAF","LBY","NER","NGA","SDN"],"area":1284000,"flag":"🇹🇩","demonyms":{"eng":{"f":"Chadian","m":"Chadian"},"fra":{"f":"Tchadienne","m":"Tchadien"}}},{"name":{"common":"Togo","official":"Togolese Republic","native":{"fra":{"official":"République togolaise","common":"Togo"}}},"tld":[".tg"],"cca2":"TG","ccn3":"768","cca3":"TGO","cioc":"TOG","independent":true,"status":"officially-assigned","currencies":{"XOF":{"name":"West African CFA franc","symbol":"Fr"}},"idd":{"root":"+2","suffixes":["28"]},"capital":["Lomé"],"altSpellings":["TG","Togolese","Togolese Republic","République Togolaise"],"region":"Africa","subregion":"Western Africa","languages":{"fra":"French"},"translations":{"ces":{"official":"Republika Togo","common":"Togo"},"deu":{"official":"Republik Togo","common":"Togo"},"fra":{"official":"République togolaise","common":"Togo"},"hrv":{"official":"Togolese Republika","common":"Togo"},"ita":{"official":"Repubblica del Togo","common":"Togo"},"jpn":{"official":"トーゴ共和国","common":"トーゴ"},"nld":{"official":"Republiek Togo","common":"Togo"},"por":{"official":"República do Togo","common":"Togo"},"rus":{"official":"Того Республика","common":"Того"},"slk":{"official":"Togská republika","common":"Togo"},"spa":{"official":"República de Togo","common":"Togo"},"fin":{"official":"Togon tasavalta","common":"Togo"},"est":{"official":"Togo Vabariik","common":"Togo"},"zho":{"official":"多哥共和国","common":"多哥"},"pol":{"official":"Republika Togijska","common":"Togo"},"urd":{"official":"جمہوریہ ٹوگو","common":"ٹوگو"},"kor":{"official":"토고 공화국","common":"토고"},"per":{"official":"جمهوری توگو","common":"توگو"}},"latlng":[8,1.16666666],"landlocked":false,"borders":["BEN","BFA","GHA"],"area":56785,"flag":"🇹🇬","demonyms":{"eng":{"f":"Togolese","m":"Togolese"},"fra":{"f":"Togolaise","m":"Togolais"}}},{"name":{"common":"Thailand","official":"Kingdom of Thailand","native":{"tha":{"official":"ราชอาณาจักรไทย","common":"ประเทศไทย"}}},"tld":[".th",".ไทย"],"cca2":"TH","ccn3":"764","cca3":"THA","cioc":"THA","independent":true,"status":"officially-assigned","currencies":{"THB":{"name":"Thai baht","symbol":"฿"}},"idd":{"root":"+6","suffixes":["6"]},"capital":["Bangkok"],"altSpellings":["TH","Prathet","Thai","Kingdom of Thailand","ราชอาณาจักรไทย","Ratcha Anachak Thai"],"region":"Asia","subregion":"South-Eastern Asia","languages":{"tha":"Thai"},"translations":{"ces":{"official":"Thajské království","common":"Thajsko"},"deu":{"official":"Königreich Thailand","common":"Thailand"},"fra":{"official":"Royaume de Thaïlande","common":"Thaïlande"},"hrv":{"official":"Kraljevina Tajland","common":"Tajland"},"ita":{"official":"Regno di Thailandia","common":"Tailandia"},"jpn":{"official":"タイ王国","common":"タイ"},"nld":{"official":"Koninkrijk Thailand","common":"Thailand"},"por":{"official":"Reino da Tailândia","common":"Tailândia"},"rus":{"official":"Королевство Таиланд","common":"Таиланд"},"slk":{"official":"Thajské kráľovstvo","common":"Thajsko"},"spa":{"official":"Reino de Tailandia","common":"Tailandia"},"fin":{"official":"Thaimaan kuningaskunta","common":"Thaimaa"},"est":{"official":"Tai Kuningriik","common":"Tai"},"zho":{"official":"泰王国","common":"泰国"},"pol":{"official":"Królestwo Tajlandii","common":"Tajlandia"},"urd":{"official":"مملکتِ تھائی لینڈ","common":"تھائی لینڈ"},"kor":{"official":"타이 왕국","common":"태국"},"per":{"official":"پادشاهی تایلند","common":"تایلند"}},"latlng":[15,100],"landlocked":false,"borders":["MMR","KHM","LAO","MYS"],"area":513120,"flag":"🇹🇭","demonyms":{"eng":{"f":"Thai","m":"Thai"},"fra":{"f":"Thaïlandaise","m":"Thaïlandais"}}},{"name":{"common":"Tajikistan","official":"Republic of Tajikistan","native":{"rus":{"official":"Республика Таджикистан","common":"Таджикистан"},"tgk":{"official":"Ҷумҳурии Тоҷикистон","common":"Тоҷикистон"}}},"tld":[".tj"],"cca2":"TJ","ccn3":"762","cca3":"TJK","cioc":"TJK","independent":true,"status":"officially-assigned","currencies":{"TJS":{"name":"Tajikistani somoni","symbol":"ЅМ"}},"idd":{"root":"+9","suffixes":["92"]},"capital":["Dushanbe"],"altSpellings":["TJ","Toçikiston","Republic of Tajikistan","Ҷумҳурии Тоҷикистон","Çumhuriyi Toçikiston"],"region":"Asia","subregion":"Central Asia","languages":{"rus":"Russian","tgk":"Tajik"},"translations":{"ces":{"official":"Republika Tádžikistán","common":"Tádžikistán"},"deu":{"official":"Republik Tadschikistan","common":"Tadschikistan"},"fra":{"official":"République du Tadjikistan","common":"Tadjikistan"},"hrv":{"official":"Republika Tadžikistan","common":"Tađikistan"},"ita":{"official":"Repubblica del Tajikistan","common":"Tagikistan"},"jpn":{"official":"タジキスタン共和国","common":"タジキスタン"},"nld":{"official":"Tadzjikistan","common":"Tadzjikistan"},"por":{"official":"República do Tajiquistão","common":"Tajiquistão"},"rus":{"official":"Республика Таджикистан","common":"Таджикистан"},"slk":{"official":"Taǆická republika","common":"Taǆikistan"},"spa":{"official":"República de Tayikistán","common":"Tayikistán"},"fin":{"official":"Tadžikistanin tasavalta","common":"Tadžikistan"},"est":{"official":"Tadžikistani Vabariik","common":"Tadžikistan"},"zho":{"official":"塔吉克斯坦共和国","common":"塔吉克斯坦"},"pol":{"official":"Republika Tadżykistanu","common":"Tadżykistan"},"urd":{"official":"جمہوریہ تاجکستان","common":"تاجکستان"},"kor":{"official":"타지키스탄 공화국","common":"타지키스탄"},"per":{"official":"جمهوری تاجیکستان","common":"تاجیکِستان"}},"latlng":[39,71],"landlocked":true,"borders":["AFG","CHN","KGZ","UZB"],"area":143100,"flag":"🇹🇯","demonyms":{"eng":{"f":"Tadzhik","m":"Tadzhik"},"fra":{"f":"Tadjike","m":"Tadjike"}}},{"name":{"common":"Tokelau","official":"Tokelau","native":{"eng":{"official":"Tokelau","common":"Tokelau"},"smo":{"official":"Tokelau","common":"Tokelau"},"tkl":{"official":"Tokelau","common":"Tokelau"}}},"tld":[".tk"],"cca2":"TK","ccn3":"772","cca3":"TKL","cioc":"","independent":false,"status":"officially-assigned","currencies":{"NZD":{"name":"New Zealand dollar","symbol":"$"}},"idd":{"root":"+6","suffixes":["90"]},"capital":["Fakaofo"],"altSpellings":["TK"],"region":"Oceania","subregion":"Polynesia","languages":{"eng":"English","smo":"Samoan","tkl":"Tokelauan"},"translations":{"ces":{"official":"Tokelau","common":"Tokelau"},"deu":{"official":"Tokelau","common":"Tokelau"},"fra":{"official":"Îles Tokelau","common":"Tokelau"},"hrv":{"official":"Tokelau","common":"Tokelau"},"ita":{"official":"Tokelau","common":"Isole Tokelau"},"jpn":{"official":"トケラウ諸島","common":"トケラウ"},"nld":{"official":"Tokelau","common":"Tokelau"},"por":{"official":"Tokelau","common":"Tokelau"},"rus":{"official":"Токелау","common":"Токелау"},"slk":{"official":"Tokelauské ostrovy","common":"Tokelau"},"spa":{"official":"Tokelau","common":"Islas Tokelau"},"fin":{"official":"Tokelau","common":"Tokelau"},"est":{"official":"Tokelau","common":"Tokelau"},"zho":{"official":"托克劳","common":"托克劳"},"pol":{"official":"Tokelau","common":"Tokelau"},"urd":{"official":"ٹوکیلاؤ","common":"ٹوکیلاؤ"},"kor":{"official":"토켈라우","common":"토켈라우"},"per":{"official":"توکلائو","common":"توکلائو"}},"latlng":[-9,-172],"landlocked":false,"borders":[],"area":12,"flag":"🇹🇰","demonyms":{"eng":{"f":"Tokelauan","m":"Tokelauan"},"fra":{"f":"","m":""}}},{"name":{"common":"Turkmenistan","official":"Turkmenistan","native":{"rus":{"official":"Туркменистан","common":"Туркмения"},"tuk":{"official":"Türkmenistan","common":"Türkmenistan"}}},"tld":[".tm"],"cca2":"TM","ccn3":"795","cca3":"TKM","cioc":"TKM","independent":true,"status":"officially-assigned","currencies":{"TMT":{"name":"Turkmenistan manat","symbol":"m"}},"idd":{"root":"+9","suffixes":["93"]},"capital":["Ashgabat"],"altSpellings":["TM"],"region":"Asia","subregion":"Central Asia","languages":{"rus":"Russian","tuk":"Turkmen"},"translations":{"ces":{"official":"Turkmenistán","common":"Turkmenistán"},"deu":{"official":"Turkmenistan","common":"Turkmenistan"},"fra":{"official":"Turkménistan","common":"Turkménistan"},"hrv":{"official":"Turkmenistan","common":"Turkmenistan"},"ita":{"official":"Turkmenistan","common":"Turkmenistan"},"jpn":{"official":"トルクメニスタン","common":"トルクメニスタン"},"nld":{"official":"Turkmenistan","common":"Turkmenistan"},"por":{"official":"Turcomenistão","common":"Turquemenistão"},"rus":{"official":"Туркменистан","common":"Туркмения"},"slk":{"official":"Turkménsko","common":"Turkménsko"},"spa":{"official":"Turkmenistán","common":"Turkmenistán"},"fin":{"official":"Turkmenistan","common":"Turkmenistan"},"est":{"official":"Türkmenistan","common":"Türkmenistan"},"zho":{"official":"土库曼斯坦","common":"土库曼斯坦"},"pol":{"official":"Republika Turkmenistanu","common":"Turkmenistan"},"urd":{"official":"ترکمانستان","common":"ترکمانستان"},"kor":{"official":"투르크메니스탄","common":"투르크메니스탄"},"per":{"official":"جمهوری خلق ترکمنستان","common":"ترکمنستان"}},"latlng":[40,60],"landlocked":true,"borders":["AFG","IRN","KAZ","UZB"],"area":488100,"flag":"🇹🇲","demonyms":{"eng":{"f":"Turkmen","m":"Turkmen"},"fra":{"f":"Turkmène","m":"Turkmène"}}},{"name":{"common":"Timor-Leste","official":"Democratic Republic of Timor-Leste","native":{"por":{"official":"República Democrática de Timor-Leste","common":"Timor-Leste"},"tet":{"official":"Repúblika Demokrátika Timór-Leste","common":"Timór-Leste"}}},"tld":[".tl"],"cca2":"TL","ccn3":"626","cca3":"TLS","cioc":"TLS","independent":true,"status":"officially-assigned","currencies":{"USD":{"name":"United States dollar","symbol":"$"}},"idd":{"root":"+6","suffixes":["70"]},"capital":["Dili"],"altSpellings":["TL","East Timor","Democratic Republic of Timor-Leste","República Democrática de Timor-Leste","Repúblika Demokrátika Timór-Leste","Timór Lorosa\'e","Timor Lorosae"],"region":"Asia","subregion":"South-Eastern Asia","languages":{"por":"Portuguese","tet":"Tetum"},"translations":{"ces":{"official":"Demokratická republika Východní Timor","common":"Východní Timor"},"deu":{"official":"Demokratische Republik Timor-Leste","common":"Osttimor"},"fra":{"official":"République démocratique du Timor oriental","common":"Timor oriental"},"hrv":{"official":"Demokratska Republika Timor-Leste","common":"Istočni Timor"},"ita":{"official":"Repubblica Democratica di Timor Est","common":"Timor Est"},"jpn":{"official":"東ティモール民主共和国","common":"東ティモール"},"nld":{"official":"Democratische Republiek Oost-Timor","common":"Oost-Timor"},"por":{"official":"República Democrática de Timor-Leste","common":"Timor-Leste"},"rus":{"official":"Демократическая Республика Тимор -Лешти","common":"Восточный Тимор"},"slk":{"official":"Východotimorská demokratická republika","common":"Východný Timor"},"spa":{"official":"República Democrática de Timor-Leste","common":"Timor Oriental"},"fin":{"official":"Itä-Timorin demokraattinen tasavalta","common":"Itä-Timor"},"est":{"official":"Timor-Leste Demokraatlik Vabariik","common":"Ida-Timor"},"zho":{"official":"东帝汶民主共和国","common":"东帝汶"},"pol":{"official":"Demokratyczna Republika Timoru Wschodniego","common":"Timor Wschodni"},"urd":{"official":"جمہوری جمہوریہ مشرقی تیمور","common":"مشرقی تیمور"},"kor":{"official":"동티모르 민주 공화국","common":"동티모르"},"per":{"official":"جمهوری دموکراتیک تیمور شرقی","common":"تیمور شرقی"}},"latlng":[-8.83333333,125.91666666],"landlocked":false,"borders":["IDN"],"area":14874,"flag":"🇹🇱","demonyms":{"eng":{"f":"East Timorese","m":"East Timorese"},"fra":{"f":"Est-timoraise","m":"Est-timorais"}}},{"name":{"common":"Tonga","official":"Kingdom of Tonga","native":{"eng":{"official":"Kingdom of Tonga","common":"Tonga"},"ton":{"official":"Kingdom of Tonga","common":"Tonga"}}},"tld":[".to"],"cca2":"TO","ccn3":"776","cca3":"TON","cioc":"TGA","independent":true,"status":"officially-assigned","currencies":{"TOP":{"name":"Tongan paʻanga","symbol":"T$"}},"idd":{"root":"+6","suffixes":["76"]},"capital":["Nuku\'alofa"],"altSpellings":["TO"],"region":"Oceania","subregion":"Polynesia","languages":{"eng":"English","ton":"Tongan"},"translations":{"ces":{"official":"Království Tonga","common":"Tonga"},"deu":{"official":"Königreich Tonga","common":"Tonga"},"fra":{"official":"Royaume des Tonga","common":"Tonga"},"hrv":{"official":"Kraljevina Tonga","common":"Tonga"},"ita":{"official":"Regno di Tonga","common":"Tonga"},"jpn":{"official":"トンガ王国","common":"トンガ"},"nld":{"official":"Koninkrijk Tonga","common":"Tonga"},"por":{"official":"Reino de Tonga","common":"Tonga"},"rus":{"official":"Королевство Тонга","common":"Тонга"},"slk":{"official":"Tongské kráľovstvo","common":"Tonga"},"spa":{"official":"Reino de Tonga","common":"Tonga"},"fin":{"official":"Tongan kuningaskunta","common":"Tonga"},"est":{"official":"Tonga Kuningriik","common":"Tonga"},"zho":{"official":"汤加王国","common":"汤加"},"pol":{"official":"Królestwo Tonga","common":"Tonga"},"urd":{"official":"مملکتِ ٹونگا","common":"ٹونگا"},"kor":{"official":"통가 왕국","common":"통가"},"per":{"official":"پادشاهی تونگا","common":"تونگا"}},"latlng":[-20,-175],"landlocked":false,"borders":[],"area":747,"flag":"🇹🇴","demonyms":{"eng":{"f":"Tongan","m":"Tongan"},"fra":{"f":"Tonguienne","m":"Tonguien"}}},{"name":{"common":"Trinidad and Tobago","official":"Republic of Trinidad and Tobago","native":{"eng":{"official":"Republic of Trinidad and Tobago","common":"Trinidad and Tobago"}}},"tld":[".tt"],"cca2":"TT","ccn3":"780","cca3":"TTO","cioc":"TTO","independent":true,"status":"officially-assigned","currencies":{"TTD":{"name":"Trinidad and Tobago dollar","symbol":"$"}},"idd":{"root":"+1","suffixes":["868"]},"capital":["Port of Spain"],"altSpellings":["TT","Republic of Trinidad and Tobago"],"region":"Americas","subregion":"Caribbean","languages":{"eng":"English"},"translations":{"ces":{"official":"Republika Trinidad a Tobago","common":"Trinidad a Tobago"},"deu":{"official":"Republik Trinidad und Tobago","common":"Trinidad und Tobago"},"fra":{"official":"République de Trinité-et-Tobago","common":"Trinité-et-Tobago"},"hrv":{"official":"Republika Trinidad i Tobago","common":"Trinidad i Tobago"},"ita":{"official":"Repubblica di Trinidad e Tobago","common":"Trinidad e Tobago"},"jpn":{"official":"トリニダード·トバゴ共和国","common":"トリニダード・トバゴ"},"nld":{"official":"Republiek Trinidad en Tobago","common":"Trinidad en Tobago"},"por":{"official":"República de Trinidad e Tobago","common":"Trinidade e Tobago"},"rus":{"official":"Республика Тринидад и Тобаго","common":"Тринидад и Тобаго"},"slk":{"official":"Republika Trinidad a Tobaga","common":"Trinidad a Tobago"},"spa":{"official":"República de Trinidad y Tobago","common":"Trinidad y Tobago"},"fin":{"official":"Trinidadin ja Tobagon tasavalta","common":"Trinidad ja Tobago"},"est":{"official":"Trinidadi ja Tobago Vabariik","common":"Trinidad ja Tobago"},"zho":{"official":"特立尼达和多巴哥共和国","common":"特立尼达和多巴哥"},"pol":{"official":"Trynidad i Tobago","common":"Trynidad i Tobago"},"urd":{"official":"جمہوریہ ٹرینیڈاڈ و ٹوباگو","common":"ٹرینیڈاڈ و ٹوباگو"},"kor":{"official":"트리니다드 토바고 공화국","common":"트리니다드 토바고"},"per":{"official":"جمهوری ترینیداد و توباگو","common":"ترینیداد و توباگو"}},"latlng":[11,-61],"landlocked":false,"borders":[],"area":5130,"flag":"🇹🇹","demonyms":{"eng":{"f":"Trinidadian","m":"Trinidadian"},"fra":{"f":"Trinidadienne","m":"Trinidadien"}}},{"name":{"common":"Tunisia","official":"Tunisian Republic","native":{"ara":{"official":"الجمهورية التونسية","common":"تونس"}}},"tld":[".tn"],"cca2":"TN","ccn3":"788","cca3":"TUN","cioc":"TUN","independent":true,"status":"officially-assigned","currencies":{"TND":{"name":"Tunisian dinar","symbol":"د.ت"}},"idd":{"root":"+2","suffixes":["16"]},"capital":["Tunis"],"altSpellings":["TN","Republic of Tunisia","al-Jumhūriyyah at-Tūnisiyyah"],"region":"Africa","subregion":"Northern Africa","languages":{"ara":"Arabic"},"translations":{"ces":{"official":"Tuniská republika","common":"Tunisko"},"deu":{"official":"Tunesische Republik","common":"Tunesien"},"fra":{"official":"République tunisienne","common":"Tunisie"},"hrv":{"official":"Tuniski Republika","common":"Tunis"},"ita":{"official":"Repubblica tunisina","common":"Tunisia"},"jpn":{"official":"チュニジア共和国","common":"チュニジア"},"nld":{"official":"Republiek Tunesië","common":"Tunesië"},"por":{"official":"República da Tunísia","common":"Tunísia"},"rus":{"official":"Тунисской Республики","common":"Тунис"},"slk":{"official":"Tuniská republika","common":"Tunisko"},"spa":{"official":"República de Túnez","common":"Túnez"},"fin":{"official":"Tunisian tasavalta","common":"Tunisia"},"est":{"official":"Tuneesia Vabariik","common":"Tuneesia"},"zho":{"official":"突尼斯共和国","common":"突尼斯"},"pol":{"official":"Republika Tunezyjska","common":"Tunezja"},"urd":{"official":"جمہوریہ تونس","common":"تونس"},"kor":{"official":"튀니지 공화국","common":"튀니지"},"per":{"official":"جمهوری تونس","common":"تونس"}},"latlng":[34,9],"landlocked":false,"borders":["DZA","LBY"],"area":163610,"flag":"🇹🇳","demonyms":{"eng":{"f":"Tunisian","m":"Tunisian"},"fra":{"f":"Tunisienne","m":"Tunisien"}}},{"name":{"common":"Turkey","official":"Republic of Turkey","native":{"tur":{"official":"Türkiye Cumhuriyeti","common":"Türkiye"}}},"tld":[".tr"],"cca2":"TR","ccn3":"792","cca3":"TUR","cioc":"TUR","independent":true,"status":"officially-assigned","currencies":{"TRY":{"name":"Turkish lira","symbol":"₺"}},"idd":{"root":"+9","suffixes":["0"]},"capital":["Ankara"],"altSpellings":["TR","Turkiye","Republic of Turkey","Türkiye Cumhuriyeti"],"region":"Asia","subregion":"Western Asia","languages":{"tur":"Turkish"},"translations":{"ces":{"official":"Turecká republika","common":"Turecko"},"deu":{"official":"Republik Türkei","common":"Türkei"},"fra":{"official":"République de Turquie","common":"Turquie"},"hrv":{"official":"Republika Turska","common":"Turska"},"ita":{"official":"Repubblica di Turchia","common":"Turchia"},"jpn":{"official":"トルコ共和国","common":"トルコ"},"nld":{"official":"Republiek Turkije","common":"Turkije"},"por":{"official":"República da Turquia","common":"Turquia"},"rus":{"official":"Республика Турции","common":"Турция"},"slk":{"official":"Turecká republika","common":"Turecko"},"spa":{"official":"República de Turquía","common":"Turquía"},"fin":{"official":"Turkin tasavalta","common":"Turkki"},"est":{"official":"Türgi Vabariik","common":"Türgi"},"zho":{"official":"土耳其共和国","common":"土耳其"},"pol":{"official":"Republika Turcji","common":"Turcja"},"urd":{"official":"جمہوریہ ترکی","common":"ترکی"},"kor":{"official":"터키 공화국","common":"터키"},"per":{"official":"جمهوری ترکیه","common":"ترکیه"}},"latlng":[39,35],"landlocked":false,"borders":["ARM","AZE","BGR","GEO","GRC","IRN","IRQ","SYR"],"area":783562,"flag":"🇹🇷","demonyms":{"eng":{"f":"Turkish","m":"Turkish"},"fra":{"f":"Turque","m":"Turc"}}},{"name":{"common":"Tuvalu","official":"Tuvalu","native":{"eng":{"official":"Tuvalu","common":"Tuvalu"},"tvl":{"official":"Tuvalu","common":"Tuvalu"}}},"tld":[".tv"],"cca2":"TV","ccn3":"798","cca3":"TUV","cioc":"TUV","independent":true,"status":"officially-assigned","currencies":{"AUD":{"name":"Australian dollar","symbol":"$"},"TVD":{"name":"Tuvaluan dollar","symbol":"$"}},"idd":{"root":"+6","suffixes":["88"]},"capital":["Funafuti"],"altSpellings":["TV"],"region":"Oceania","subregion":"Polynesia","languages":{"eng":"English","tvl":"Tuvaluan"},"translations":{"ces":{"official":"Tuvalu","common":"Tuvalu"},"deu":{"official":"Tuvalu","common":"Tuvalu"},"fra":{"official":"Tuvalu","common":"Tuvalu"},"hrv":{"official":"Tuvalu","common":"Tuvalu"},"ita":{"official":"Tuvalu","common":"Tuvalu"},"jpn":{"official":"ツバル","common":"ツバル"},"nld":{"official":"Tuvalu","common":"Tuvalu"},"por":{"official":"Tuvalu","common":"Tuvalu"},"rus":{"official":"Тувалу","common":"Тувалу"},"slk":{"official":"Tuvalu","common":"Tuvalu"},"spa":{"official":"Tuvalu","common":"Tuvalu"},"fin":{"official":"Tuvalu","common":"Tuvalu"},"est":{"official":"Tuvalu","common":"Tuvalu"},"zho":{"official":"图瓦卢","common":"图瓦卢"},"pol":{"official":"Tuvalu","common":"Tuvalu"},"urd":{"official":"تووالو","common":"تووالو"},"kor":{"official":"투발루","common":"투발루"},"per":{"official":"تووالو","common":"تووالو"}},"latlng":[-8,178],"landlocked":false,"borders":[],"area":26,"flag":"🇹🇻","demonyms":{"eng":{"f":"Tuvaluan","m":"Tuvaluan"},"fra":{"f":"Tuvaluane","m":"Tuvaluan"}}},{"name":{"common":"Taiwan","official":"Republic of China (Taiwan)","native":{"zho":{"official":"中華民國","common":"台灣"}}},"tld":[".tw",".台灣",".台湾"],"cca2":"TW","ccn3":"158","cca3":"TWN","cioc":"TPE","independent":false,"status":"officially-assigned","currencies":{"TWD":{"name":"New Taiwan dollar","symbol":"$"}},"idd":{"root":"+8","suffixes":["86"]},"capital":["Taipei"],"altSpellings":["TW","Táiwān","Republic of China","中華民國","Zhōnghuá Mínguó","Chinese Taipei"],"region":"Asia","subregion":"Eastern Asia","languages":{"zho":"Chinese"},"translations":{"ces":{"official":"Čínská republika","common":"Tchaj-wan"},"deu":{"official":"Republik China (Taiwan)","common":"Taiwan"},"fra":{"official":"République de Chine (Taïwan)","common":"Taïwan"},"hrv":{"official":"Republika Kina","common":"Tajvan"},"ita":{"official":"Repubblica cinese (Taiwan)","common":"Taiwan"},"jpn":{"official":"中華民国","common":"台湾"},"nld":{"official":"Republiek China (Taiwan)","common":"Taiwan"},"por":{"official":"República da China","common":"Ilha Formosa"},"rus":{"official":"Китайская Республика","common":"Тайвань"},"slk":{"official":"Čínska republika","common":"Taiwan"},"spa":{"official":"República de China en Taiwán","common":"Taiwán"},"fin":{"official":"Kiinan tasavalta","common":"Taiwan"},"est":{"official":"Taiwani","common":"Taiwan"},"pol":{"official":"Republika Chińska (Tajwan)","common":"Tajwan"},"urd":{"official":"جمہوریہ چین (تائیوان)","common":"تائیوان"},"kor":{"official":"중화민국","common":"대만"},"per":{"official":"جمهوری چین","common":"تایوان"}},"latlng":[23.5,121],"landlocked":false,"borders":[],"area":36193,"flag":"🇹🇼","demonyms":{"eng":{"f":"Taiwanese","m":"Taiwanese"},"fra":{"f":"Taïwanaise","m":"Taïwanais"}}},{"name":{"common":"Tanzania","official":"United Republic of Tanzania","native":{"eng":{"official":"United Republic of Tanzania","common":"Tanzania"},"swa":{"official":"Jamhuri ya Muungano wa Tanzania","common":"Tanzania"}}},"tld":[".tz"],"cca2":"TZ","ccn3":"834","cca3":"TZA","cioc":"TAN","independent":true,"status":"officially-assigned","currencies":{"TZS":{"name":"Tanzanian shilling","symbol":"Sh"}},"idd":{"root":"+2","suffixes":["55"]},"capital":["Dodoma"],"altSpellings":["TZ","Tanzania, United Republic of","United Republic of Tanzania","Jamhuri ya Muungano wa Tanzania"],"region":"Africa","subregion":"Eastern Africa","languages":{"eng":"English","swa":"Swahili"},"translations":{"ces":{"official":"Sjednocená tanzanská republika","common":"Tanzanie"},"deu":{"official":"Vereinigte Republik Tansania","common":"Tansania"},"fra":{"official":"République -Unie de Tanzanie","common":"Tanzanie"},"hrv":{"official":"Ujedinjena Republika Tanzanija","common":"Tanzanija"},"ita":{"official":"Repubblica Unita di Tanzania","common":"Tanzania"},"jpn":{"official":"タンザニア連合共和国","common":"タンザニア"},"nld":{"official":"Verenigde Republiek Tanzania","common":"Tanzania"},"por":{"official":"República Unida da Tanzânia","common":"Tanzânia"},"rus":{"official":"Объединенная Республика Танзания","common":"Танзания"},"slk":{"official":"Tanzánijská zjednotená republika","common":"Tanzánia"},"spa":{"official":"República Unida de Tanzania","common":"Tanzania"},"fin":{"official":"Tansanian yhdistynyt tasavalta","common":"Tansania"},"est":{"official":"Tansaania Ühendvabariik","common":"Tansaania"},"zho":{"official":"坦桑尼亚联合共和国","common":"坦桑尼亚"},"pol":{"official":"Zjednoczona Republika Tanzanii","common":"Tanzania"},"urd":{"official":"متحدہ جمہوریہ تنزانیہ","common":"تنزانیہ"},"kor":{"official":"탄자니아 연합 공화국","common":"탄자니아"},"per":{"official":"جمهوری متحد تانزانیا","common":"تانزانیا"}},"latlng":[-6,35],"landlocked":false,"borders":["BDI","COD","KEN","MWI","MOZ","RWA","UGA","ZMB"],"area":945087,"flag":"🇹🇿","demonyms":{"eng":{"f":"Tanzanian","m":"Tanzanian"},"fra":{"f":"Tanzanienne","m":"Tanzanien"}}},{"name":{"common":"Uganda","official":"Republic of Uganda","native":{"eng":{"official":"Republic of Uganda","common":"Uganda"},"swa":{"official":"Republic of Uganda","common":"Uganda"}}},"tld":[".ug"],"cca2":"UG","ccn3":"800","cca3":"UGA","cioc":"UGA","independent":true,"status":"officially-assigned","currencies":{"UGX":{"name":"Ugandan shilling","symbol":"Sh"}},"idd":{"root":"+2","suffixes":["56"]},"capital":["Kampala"],"altSpellings":["UG","Republic of Uganda","Jamhuri ya Uganda"],"region":"Africa","subregion":"Eastern Africa","languages":{"eng":"English","swa":"Swahili"},"translations":{"ces":{"official":"Ugandská republika","common":"Uganda"},"deu":{"official":"Republik Uganda","common":"Uganda"},"fra":{"official":"République de l\'Ouganda","common":"Ouganda"},"hrv":{"official":"Republika Uganda","common":"Uganda"},"ita":{"official":"Repubblica di Uganda","common":"Uganda"},"jpn":{"official":"ウガンダ共和国","common":"ウガンダ"},"nld":{"official":"Republiek Uganda","common":"Oeganda"},"por":{"official":"República do Uganda","common":"Uganda"},"rus":{"official":"Республика Уганда","common":"Уганда"},"slk":{"official":"Ugandská republika","common":"Uganda"},"spa":{"official":"República de Uganda","common":"Uganda"},"fin":{"official":"Ugandan tasavalta","common":"Uganda"},"est":{"official":"Uganda Vabariik","common":"Uganda"},"zho":{"official":"乌干达共和国","common":"乌干达"},"pol":{"official":"Republika Ugandy","common":"Uganda"},"urd":{"official":"جمہوریہ یوگنڈا","common":"یوگنڈا"},"kor":{"official":"우간다 공화국","common":"우간다"},"per":{"official":"جمهوری اوگاندا","common":"اوگاندا"}},"latlng":[1,32],"landlocked":true,"borders":["COD","KEN","RWA","SSD","TZA"],"area":241550,"flag":"🇺🇬","demonyms":{"eng":{"f":"Ugandan","m":"Ugandan"},"fra":{"f":"Ougandaise","m":"Ougandais"}}},{"name":{"common":"Ukraine","official":"Ukraine","native":{"ukr":{"official":"Україна","common":"Україна"}}},"tld":[".ua",".укр"],"cca2":"UA","ccn3":"804","cca3":"UKR","cioc":"UKR","independent":true,"status":"officially-assigned","currencies":{"UAH":{"name":"Ukrainian hryvnia","symbol":"₴"}},"idd":{"root":"+3","suffixes":["80"]},"capital":["Kyiv"],"altSpellings":["UA","Ukrayina"],"region":"Europe","subregion":"Eastern Europe","languages":{"ukr":"Ukrainian"},"translations":{"ces":{"official":"Ukrajina","common":"Ukrajina"},"deu":{"official":"Ukraine","common":"Ukraine"},"fra":{"official":"Ukraine","common":"Ukraine"},"hrv":{"official":"Ukrajina","common":"Ukrajina"},"ita":{"official":"Ucraina","common":"Ucraina"},"jpn":{"official":"ウクライナ","common":"ウクライナ"},"nld":{"official":"Oekraïne","common":"Oekraïne"},"por":{"official":"Ucrânia","common":"Ucrânia"},"rus":{"official":"Украина","common":"Украина"},"slk":{"official":"Ukrajina","common":"Ukrajina"},"spa":{"official":"Ucrania","common":"Ucrania"},"fin":{"official":"Ukraina","common":"Ukraina"},"est":{"official":"Ukraina","common":"Ukraina"},"zho":{"official":"乌克兰","common":"乌克兰"},"pol":{"official":"Ukraina","common":"Ukraina"},"urd":{"official":"یوکرین","common":"یوکرین"},"kor":{"official":"우크라이나","common":"우크라이나"},"per":{"official":"اوکراین","common":"اوکراین"}},"latlng":[49,32],"landlocked":false,"borders":["BLR","HUN","MDA","POL","ROU","RUS","SVK"],"area":603500,"flag":"🇺🇦","demonyms":{"eng":{"f":"Ukrainian","m":"Ukrainian"},"fra":{"f":"Ukrainienne","m":"Ukrainien"}}},{"name":{"common":"United States Minor Outlying Islands","official":"United States Minor Outlying Islands","native":{"eng":{"official":"United States Minor Outlying Islands","common":"United States Minor Outlying Islands"}}},"tld":[".us"],"cca2":"UM","ccn3":"581","cca3":"UMI","cioc":"","independent":false,"status":"officially-assigned","currencies":{"USD":{"name":"United States dollar","symbol":"$"}},"idd":{"root":"+2","suffixes":["68"]},"capital":[""],"altSpellings":["UM"],"region":"Americas","subregion":"North America","languages":{"eng":"English"},"translations":{"ces":{"official":"Menší odlehlé ostrovy Spojených států amerických","common":"Menší odlehlé ostrovy USA"},"deu":{"official":"USA, kleinere ausgelagerte Inseln","common":"Kleinere Inselbesitzungen der Vereinigten Staaten"},"fra":{"official":"Îles mineures éloignées des États-Unis","common":"Îles mineures éloignées des États-Unis"},"hrv":{"official":"Mali udaljeni otoci SAD-a","common":"Mali udaljeni otoci SAD-a"},"ita":{"official":"Stati Uniti Isole Minori","common":"Isole minori esterne degli Stati Uniti d\'America"},"jpn":{"official":"アメリカ合衆国外諸島","common":"合衆国領有小離島"},"nld":{"official":"Kleine afgelegen eilanden van de Verenigde Staten","common":"Kleine afgelegen eilanden van de Verenigde Staten"},"por":{"official":"Estados Unidos Ilhas Menores Distantes","common":"Ilhas Menores Distantes dos Estados Unidos"},"rus":{"official":"Внешние малые острова США","common":"Внешние малые острова США"},"slk":{"official":"Menšie odľahlé ostrovy Spjoených štátov","common":"Menšie odľahlé ostrovy USA"},"spa":{"official":"Estados Unidos Islas menores alejadas de","common":"Islas Ultramarinas Menores de Estados Unidos"},"fin":{"official":"Yhdysvaltain asumattomat saaret","common":"Yhdysvaltain asumattomat saaret"},"est":{"official":"Ühendriikide väikesed hajasaared","common":"Ühendriikide hajasaared"},"zho":{"official":"美国本土外小岛屿","common":"美国本土外小岛屿"},"pol":{"official":"Dalekie Wyspy Mniejsze Stanów Zjednoczonych","common":"Dalekie Wyspy Mniejsze Stanów Zjednoczonych"},"urd":{"official":"امریکی چھوٹے بیرونی جزائر","common":"امریکی چھوٹے بیرونی جزائر"},"kor":{"official":"미국령 군소 제도","common":"미국령 군소 제도"},"per":{"official":"جزایر کوچک حاشیه‌ای ایالات متحده آمریکا","common":"جزایر کوچک حاشیه‌ای ایالات متحده آمریکا"}},"latlng":[19.3,166.633333],"landlocked":false,"borders":[],"area":34.2,"flag":"🇺🇲","demonyms":{"eng":{"f":"American","m":"American"},"fra":{"f":"","m":""}}},{"name":{"common":"Uruguay","official":"Oriental Republic of Uruguay","native":{"spa":{"official":"República Oriental del Uruguay","common":"Uruguay"}}},"tld":[".uy"],"cca2":"UY","ccn3":"858","cca3":"URY","cioc":"URU","independent":true,"status":"officially-assigned","currencies":{"UYU":{"name":"Uruguayan peso","symbol":"$"}},"idd":{"root":"+5","suffixes":["98"]},"capital":["Montevideo"],"altSpellings":["UY","Oriental Republic of Uruguay","República Oriental del Uruguay"],"region":"Americas","subregion":"South America","languages":{"spa":"Spanish"},"translations":{"ces":{"official":"Uruguayská východní republika","common":"Uruguay"},"deu":{"official":"Republik Östlich des Uruguay","common":"Uruguay"},"fra":{"official":"République orientale de l\'Uruguay","common":"Uruguay"},"hrv":{"official":"Orijentalna Republika Urugvaj","common":"Urugvaj"},"ita":{"official":"Repubblica Orientale dell\'Uruguay","common":"Uruguay"},"jpn":{"official":"ウルグアイ東方共和国","common":"ウルグアイ"},"nld":{"official":"Oosterse Republiek Uruguay","common":"Uruguay"},"por":{"official":"República Oriental do Uruguai","common":"Uruguai"},"rus":{"official":"Восточной Республики Уругвай","common":"Уругвай"},"slk":{"official":"Uruguajská východná republika","common":"Uruguaj"},"spa":{"official":"República Oriental del Uruguay","common":"Uruguay"},"fin":{"official":"Uruguayn itäinen tasavalta","common":"Uruguay"},"est":{"official":"Uruguay Idavabariik","common":"Uruguay"},"zho":{"official":"乌拉圭东岸共和国","common":"乌拉圭"},"pol":{"official":"Wschodnia Republika Urugwaju","common":"Urugwaj"},"urd":{"official":"جمہوریہ شرقیہ یوراگوئے","common":"یوراگوئے"},"kor":{"official":"우루과이 동방 공화국","common":"우루과이"},"per":{"official":"جمهوری اروگوئه","common":"اروگوئه"}},"latlng":[-33,-56],"landlocked":false,"borders":["ARG","BRA"],"area":181034,"flag":"🇺🇾","demonyms":{"eng":{"f":"Uruguayan","m":"Uruguayan"},"fra":{"f":"Uruguayenne","m":"Uruguayen"}}},{"name":{"common":"United States","official":"United States of America","native":{"eng":{"official":"United States of America","common":"United States"}}},"tld":[".us"],"cca2":"US","ccn3":"840","cca3":"USA","cioc":"USA","independent":true,"status":"officially-assigned","currencies":{"USD":{"name":"United States dollar","symbol":"$"}},"idd":{"root":"+1","suffixes":["201","202","203","205","206","207","208","209","210","212","213","214","215","216","217","218","219","220","224","225","227","228","229","231","234","239","240","248","251","252","253","254","256","260","262","267","269","270","272","274","276","281","283","301","302","303","304","305","307","308","309","310","312","313","314","315","316","317","318","319","320","321","323","325","327","330","331","334","336","337","339","346","347","351","352","360","361","364","380","385","386","401","402","404","405","406","407","408","409","410","412","413","414","415","417","419","423","424","425","430","432","434","435","440","442","443","447","458","463","464","469","470","475","478","479","480","484","501","502","503","504","505","507","508","509","510","512","513","515","516","517","518","520","530","531","534","539","540","541","551","559","561","562","563","564","567","570","571","573","574","575","580","585","586","601","602","603","605","606","607","608","609","610","612","614","615","616","617","618","619","620","623","626","628","629","630","631","636","641","646","650","651","657","660","661","662","667","669","678","681","682","701","702","703","704","706","707","708","712","713","714","715","716","717","718","719","720","724","725","727","730","731","732","734","737","740","743","747","754","757","760","762","763","765","769","770","772","773","774","775","779","781","785","786","801","802","803","804","805","806","808","810","812","813","814","815","816","817","818","828","830","831","832","843","845","847","848","850","854","856","857","858","859","860","862","863","864","865","870","872","878","901","903","904","906","907","908","909","910","912","913","914","915","916","917","918","919","920","925","928","929","930","931","934","936","937","938","940","941","947","949","951","952","954","956","959","970","971","972","973","975","978","979","980","984","985","989"]},"capital":["Washington D.C."],"altSpellings":["US","USA","United States of America"],"region":"Americas","subregion":"North America","languages":{"eng":"English"},"translations":{"ces":{"official":"Spojené státy americké","common":"Spojené státy"},"deu":{"official":"Vereinigte Staaten von Amerika","common":"Vereinigte Staaten"},"fra":{"official":"Les états-unis d\'Amérique","common":"États-Unis"},"hrv":{"official":"Sjedinjene Države Amerike","common":"Sjedinjene Američke Države"},"ita":{"official":"Stati Uniti d\'America","common":"Stati Uniti d\'America"},"jpn":{"official":"アメリカ合衆国","common":"アメリカ合衆国"},"nld":{"official":"Verenigde Staten van Amerika","common":"Verenigde Staten"},"por":{"official":"Estados Unidos da América","common":"Estados Unidos"},"rus":{"official":"Соединенные Штаты Америки","common":"Соединённые Штаты Америки"},"slk":{"official":"Spojené štáty Americké","common":"Spojené štáty americké"},"spa":{"official":"Estados Unidos de América","common":"Estados Unidos"},"fin":{"official":"Amerikan yhdysvallat","common":"Yhdysvallat"},"est":{"official":"Ameerika Ühendriigid","common":"Ameerika Ühendriigid"},"zho":{"official":"美利坚合众国","common":"美国"},"pol":{"official":"Stany Zjednoczone Ameryki","common":"Stany Zjednoczone"},"urd":{"official":"ریاستہائے متحدہ امریکا","common":"ریاستہائے متحدہ"},"kor":{"official":"아메리카 합중국","common":"미국"},"per":{"official":"ایالات متحده آمریکا","common":"ایالات متحده آمریکا"}},"latlng":[38,-97],"landlocked":false,"borders":["CAN","MEX"],"area":9372610,"flag":"🇺🇸","demonyms":{"eng":{"f":"American","m":"American"},"fra":{"f":"Américaine","m":"Américain"}}},{"name":{"common":"Uzbekistan","official":"Republic of Uzbekistan","native":{"rus":{"official":"Республика Узбекистан","common":"Узбекистан"},"uzb":{"official":"O\'zbekiston Respublikasi","common":"O‘zbekiston"}}},"tld":[".uz"],"cca2":"UZ","ccn3":"860","cca3":"UZB","cioc":"UZB","independent":true,"status":"officially-assigned","currencies":{"UZS":{"name":"Uzbekistani soʻm","symbol":"so\'m"}},"idd":{"root":"+9","suffixes":["98"]},"capital":["Tashkent"],"altSpellings":["UZ","Republic of Uzbekistan","O‘zbekiston Respublikasi","Ўзбекистон Республикаси"],"region":"Asia","subregion":"Central Asia","languages":{"rus":"Russian","uzb":"Uzbek"},"translations":{"ces":{"official":"Republika Uzbekistán","common":"Uzbekistán"},"deu":{"official":"Republik Usbekistan","common":"Usbekistan"},"fra":{"official":"République d\'Ouzbékistan","common":"Ouzbékistan"},"hrv":{"official":"Republika Uzbekistan","common":"Uzbekistan"},"ita":{"official":"Repubblica di Uzbekistan","common":"Uzbekistan"},"jpn":{"official":"ウズベキスタン共和国","common":"ウズベキスタン"},"nld":{"official":"Republiek Oezbekistan","common":"Oezbekistan"},"por":{"official":"República do Usbequistão","common":"Uzbequistão"},"rus":{"official":"Республика Узбекистан","common":"Узбекистан"},"slk":{"official":"Uzbecká republika","common":"Uzbekistan"},"spa":{"official":"República de Uzbekistán","common":"Uzbekistán"},"fin":{"official":"Uzbekistanin tasavalta","common":"Uzbekistan"},"est":{"official":"Usbekistani Vabariik","common":"Usbekistan"},"zho":{"official":"乌兹别克斯坦共和国","common":"乌兹别克斯坦"},"pol":{"official":"Republika Uzbekistanu","common":"Uzbekistan"},"urd":{"official":"جمہوریہ ازبکستان","common":"ازبکستان"},"kor":{"official":"우즈베키스탄 공화국","common":"우즈베키스탄"},"per":{"official":"جمهوری ازبکستان","common":"ازبکستان"}},"latlng":[41,64],"landlocked":true,"borders":["AFG","KAZ","KGZ","TJK","TKM"],"area":447400,"flag":"🇺🇿","demonyms":{"eng":{"f":"Uzbekistani","m":"Uzbekistani"},"fra":{"f":"Ouzbèke","m":"Ouzbèke"}}},{"name":{"common":"Vatican City","official":"Vatican City State","native":{"ita":{"official":"Stato della Città del Vaticano","common":"Vaticano"},"lat":{"official":"Status Civitatis Vaticanæ","common":"Vaticanæ"}}},"tld":[".va"],"cca2":"VA","ccn3":"336","cca3":"VAT","cioc":"","independent":true,"status":"officially-assigned","currencies":{"EUR":{"name":"Euro","symbol":"€"}},"idd":{"root":"+3","suffixes":["906698","79"]},"capital":["Vatican City"],"altSpellings":["VA","Holy See (Vatican City State)","Vatican City State","Stato della Città del Vaticano"],"region":"Europe","subregion":"Southern Europe","languages":{"ita":"Italian","lat":"Latin"},"translations":{"ces":{"official":"Městský stát Vatikán","common":"Vatikán"},"deu":{"official":"Staat Vatikanstadt","common":"Vatikanstadt"},"fra":{"official":"Cité du Vatican","common":"Cité du Vatican"},"hrv":{"official":"Vatikan","common":"Vatikan"},"ita":{"official":"Città del Vaticano","common":"Città del Vaticano"},"jpn":{"official":"バチカン市国の状態","common":"バチカン市国"},"nld":{"official":"Vaticaanstad","common":"Vaticaanstad"},"por":{"official":"Cidade do Vaticano","common":"Cidade do Vaticano"},"rus":{"official":"Город-государство Ватикан","common":"Ватикан"},"slk":{"official":"Svätá stolica (Vatikánsky mestský štát","common":"Vatikán"},"spa":{"official":"Ciudad del Vaticano","common":"Ciudad del Vaticano"},"fin":{"official":"Vatikaanin kaupunkivaltio","common":"Vatikaani"},"est":{"official":"Vatikani Linnriik","common":"Vatikan"},"zho":{"official":"梵蒂冈城国","common":"梵蒂冈"},"pol":{"official":"Państwo Watykańskie","common":"Watykan"},"urd":{"official":"ویٹیکن سٹی","common":"ویٹیکن سٹی"},"kor":{"official":"바티칸 시국","common":"바티칸"},"per":{"official":"دولت‌شهر واتیکان","common":"واتیکان"}},"latlng":[41.9,12.45],"landlocked":true,"borders":["ITA"],"area":0.44,"flag":"🇻🇦","demonyms":{"eng":{"f":"Vatican","m":"Vatican"},"fra":{"f":"Vaticane","m":"Vatican"}}},{"name":{"common":"Saint Vincent and the Grenadines","official":"Saint Vincent and the Grenadines","native":{"eng":{"official":"Saint Vincent and the Grenadines","common":"Saint Vincent and the Grenadines"}}},"tld":[".vc"],"cca2":"VC","ccn3":"670","cca3":"VCT","cioc":"VIN","independent":true,"status":"officially-assigned","currencies":{"XCD":{"name":"Eastern Caribbean dollar","symbol":"$"}},"idd":{"root":"+1","suffixes":["784"]},"capital":["Kingstown"],"altSpellings":["VC"],"region":"Americas","subregion":"Caribbean","languages":{"eng":"English"},"translations":{"ces":{"official":"Svatý Vincenc a Grenadiny","common":"Svatý Vincenc a Grenadiny"},"deu":{"official":"St. Vincent und die Grenadinen","common":"St. Vincent und die Grenadinen"},"fra":{"official":"Saint-Vincent-et-les Grenadines","common":"Saint-Vincent-et-les-Grenadines"},"hrv":{"official":"Sveti Vincent i Grenadini","common":"Sveti Vincent i Grenadini"},"ita":{"official":"Saint Vincent e Grenadine","common":"Saint Vincent e Grenadine"},"jpn":{"official":"セントビンセントおよびグレナディーン諸島","common":"セントビンセントおよびグレナディーン諸島"},"nld":{"official":"Saint Vincent en de Grenadines","common":"Saint Vincent en de Grenadines"},"por":{"official":"São Vicente e Granadinas","common":"São Vincente e Granadinas"},"rus":{"official":"Сент-Винсент и Гренадины","common":"Сент-Винсент и Гренадины"},"slk":{"official":"Svätý Vincent a Grenadíny","common":"Svätý Vincent a Grenadíny"},"spa":{"official":"San Vicente y las Granadinas","common":"San Vicente y Granadinas"},"fin":{"official":"Saint Vincent ja Grenadiinit","common":"Saint Vincent ja Grenadiinit"},"est":{"official":"Saint Vincent ja Grenadiinid","common":"Saint Vincent"},"zho":{"official":"圣文森特和格林纳丁斯","common":"圣文森特和格林纳丁斯"},"pol":{"official":"Saint Vincent i Grenadyny","common":"Saint Vincent i Grenadyny"},"urd":{"official":"سینٹ وینسینٹ و گریناڈائنز","common":"سینٹ وینسینٹ و گریناڈائنز"},"kor":{"official":"세인트빈센트 그레나딘","common":"세인트빈센트 그레나딘"},"per":{"official":"سنت وینسنت و گرنادین‌ها","common":"سنت وینسنت و گرنادین‌ها"}},"latlng":[13.25,-61.2],"landlocked":false,"borders":[],"area":389,"flag":"🇻🇨","demonyms":{"eng":{"f":"Saint Vincentian","m":"Saint Vincentian"},"fra":{"f":"Vincentaise","m":"Vincentais"}}},{"name":{"common":"Venezuela","official":"Bolivarian Republic of Venezuela","native":{"spa":{"official":"República Bolivariana de Venezuela","common":"Venezuela"}}},"tld":[".ve"],"cca2":"VE","ccn3":"862","cca3":"VEN","cioc":"VEN","independent":true,"status":"officially-assigned","currencies":{"VES":{"name":"Venezuelan bolívar soberano","symbol":"Bs.S."}},"idd":{"root":"+5","suffixes":["8"]},"capital":["Caracas"],"altSpellings":["VE","Bolivarian Republic of Venezuela","Venezuela, Bolivarian Republic of","República Bolivariana de Venezuela"],"region":"Americas","subregion":"South America","languages":{"spa":"Spanish"},"translations":{"ces":{"official":"Bolívarská republika Venezuela","common":"Venezuela"},"deu":{"official":"Bolivarische Republik Venezuela","common":"Venezuela"},"fra":{"official":"République bolivarienne du Venezuela","common":"Venezuela"},"hrv":{"official":"BOLIVARIJANSKA Republika Venezuela","common":"Venezuela"},"ita":{"official":"Repubblica Bolivariana del Venezuela","common":"Venezuela"},"jpn":{"official":"ベネズエラ·ボリバル共和国","common":"ベネズエラ・ボリバル共和国"},"nld":{"official":"Bolivariaanse Republiek Venezuela","common":"Venezuela"},"por":{"official":"República Bolivariana da Venezuela","common":"Venezuela"},"rus":{"official":"Боливарианская Республика Венесуэла","common":"Венесуэла"},"slk":{"official":"Venezuelská bolívarovská republika","common":"Venezuela"},"spa":{"official":"República Bolivariana de Venezuela","common":"Venezuela"},"fin":{"official":"Venezuelan bolivariaainen tasavalta","common":"Venezuela"},"est":{"official":"Venezuela Bolívari Vabariik","common":"Venezuela"},"zho":{"official":"委内瑞拉玻利瓦尔共和国","common":"委内瑞拉"},"pol":{"official":"Boliwariańska Republika Wenezueli","common":"Wenezuela"},"urd":{"official":"جمہوریہ وینیزویلا","common":"وینیزویلا"},"kor":{"official":"베네수엘라 볼리바르 공화국","common":"베네수엘라"},"per":{"official":"جمهوری بولیواری ونزوئلا","common":"ونزوئلا"}},"latlng":[8,-66],"landlocked":false,"borders":["BRA","COL","GUY"],"area":916445,"flag":"🇻🇪","demonyms":{"eng":{"f":"Venezuelan","m":"Venezuelan"},"fra":{"f":"Vénézuélienne","m":"Vénézuélien"}}},{"name":{"common":"British Virgin Islands","official":"Virgin Islands","native":{"eng":{"official":"Virgin Islands","common":"British Virgin Islands"}}},"tld":[".vg"],"cca2":"VG","ccn3":"092","cca3":"VGB","cioc":"IVB","independent":false,"status":"officially-assigned","currencies":{"USD":{"name":"United States dollar","symbol":"$"}},"idd":{"root":"+1","suffixes":["284"]},"capital":["Road Town"],"altSpellings":["VG","Virgin Islands, British"],"region":"Americas","subregion":"Caribbean","languages":{"eng":"English"},"translations":{"ces":{"official":"Britské Panenské ostrovy","common":"Britské Panenské ostrovy"},"deu":{"official":"Jungferninseln","common":"Britische Jungferninseln"},"fra":{"official":"îles Vierges","common":"Îles Vierges britanniques"},"hrv":{"official":"Djevičanski Otoci","common":"Britanski Djevičanski Otoci"},"ita":{"official":"Isole Vergini","common":"Isole Vergini Britanniche"},"jpn":{"official":"バージン諸島","common":"イギリス領ヴァージン諸島"},"nld":{"official":"Maagdeneilanden","common":"Britse Maagdeneilanden"},"por":{"official":"Ilhas Virgens","common":"Ilhas Virgens"},"rus":{"official":"Виргинские острова","common":"Британские Виргинские острова"},"slk":{"official":"Panenské ostrovy","common":"Panenské ostrovy"},"spa":{"official":"Islas Vírgenes","common":"Islas Vírgenes del Reino Unido"},"fin":{"official":"Brittiläiset Neitsytsaaret","common":"Neitsytsaaret"},"est":{"official":"Neitsisaared","common":"Briti Neitsisaared"},"zho":{"official":"英属维尔京群岛","common":"英属维尔京群岛"},"pol":{"official":"Brytyjskie Wyspy Dziewicze","common":"Brytyjskie Wyspy Dziewicze"},"urd":{"official":"برطانوی جزائر ورجن","common":"برطانوی جزائر ورجن"},"kor":{"official":"영국령 버진아일랜드","common":"영국령 버진아일랜드"},"per":{"official":"جزایر ویرجین بریتانیا","common":"جزایر ویرجین بریتانیا"}},"latlng":[18.431383,-64.62305],"landlocked":false,"borders":[],"area":151,"flag":"🇻🇬","demonyms":{"eng":{"f":"Virgin Islander","m":"Virgin Islander"},"fra":{"f":"","m":""}}},{"name":{"common":"United States Virgin Islands","official":"Virgin Islands of the United States","native":{"eng":{"official":"Virgin Islands of the United States","common":"United States Virgin Islands"}}},"tld":[".vi"],"cca2":"VI","ccn3":"850","cca3":"VIR","cioc":"ISV","independent":false,"status":"officially-assigned","currencies":{"USD":{"name":"United States dollar","symbol":"$"}},"idd":{"root":"+1","suffixes":["340"]},"capital":["Charlotte Amalie"],"altSpellings":["VI","Virgin Islands, U.S."],"region":"Americas","subregion":"Caribbean","languages":{"eng":"English"},"translations":{"ces":{"official":"Americké Panenské ostrovy","common":"Americké Panenské ostrovy"},"deu":{"official":"Amerikanische Jungferninseln","common":"Amerikanische Jungferninseln"},"fra":{"official":"Îles Vierges des États-Unis","common":"Îles Vierges des États-Unis"},"hrv":{"official":"Djevičanski Otoci SAD","common":"Američki Djevičanski Otoci"},"ita":{"official":"Isole Vergini degli Stati Uniti","common":"Isole Vergini americane"},"jpn":{"official":"米国のバージン諸島","common":"アメリカ領ヴァージン諸島"},"nld":{"official":"Maagdeneilanden van de Verenigde Staten","common":"Amerikaanse Maagdeneilanden"},"por":{"official":"Ilhas Virgens dos Estados Unidos","common":"Ilhas Virgens dos Estados Unidos"},"rus":{"official":"Виргинские острова Соединенных Штатов","common":"Виргинские Острова"},"slk":{"official":"Americké Panenské ostrovy","common":"Americké Panenské ostrovy"},"spa":{"official":"Islas Vírgenes de los Estados Unidos","common":"Islas Vírgenes de los Estados Unidos"},"fin":{"official":"Yhdysvaltain Neitsytsaaret","common":"Neitsytsaaret"},"est":{"official":"Ühendriikide Neitsisaared","common":"Neitsisaared, USA"},"zho":{"official":"美属维尔京群岛","common":"美属维尔京群岛"},"pol":{"official":"Wyspy Dziewicze Stanów Zjednoczonych","common":"Wyspy Dziewicze Stanów Zjednoczonych"},"urd":{"official":"امریکی جزائر ورجن","common":"امریکی جزائر ورجن"},"kor":{"official":"미국령 버진아일랜드","common":"미국령 버진아일랜드"},"per":{"official":"جزایر ویرجین ایالات متحده آمریکا","common":"جزایر ویرجین ایالات متحده آمریکا"}},"latlng":[18.35,-64.933333],"landlocked":false,"borders":[],"area":347,"flag":"🇻🇮","demonyms":{"eng":{"f":"Virgin Islander","m":"Virgin Islander"},"fra":{"f":"","m":""}}},{"name":{"common":"Vietnam","official":"Socialist Republic of Vietnam","native":{"vie":{"official":"Cộng hòa xã hội chủ nghĩa Việt Nam","common":"Việt Nam"}}},"tld":[".vn"],"cca2":"VN","ccn3":"704","cca3":"VNM","cioc":"VIE","independent":true,"status":"officially-assigned","currencies":{"VND":{"name":"Vietnamese đồng","symbol":"₫"}},"idd":{"root":"+8","suffixes":["4"]},"capital":["Hanoi"],"altSpellings":["VN","Socialist Republic of Vietnam","Cộng hòa Xã hội chủ nghĩa Việt Nam","Viet Nam"],"region":"Asia","subregion":"South-Eastern Asia","languages":{"vie":"Vietnamese"},"translations":{"ces":{"official":"Vietnamská socialistická republika","common":"Vietnam"},"deu":{"official":"Sozialistische Republik Vietnam","common":"Vietnam"},"fra":{"official":"République socialiste du Viêt Nam","common":"Viêt Nam"},"hrv":{"official":"Socijalistička Republika Vijetnam","common":"Vijetnam"},"ita":{"official":"Repubblica socialista del Vietnam","common":"Vietnam"},"jpn":{"official":"ベトナム社会主義共和国","common":"ベトナム"},"nld":{"official":"Socialistische Republiek Vietnam","common":"Vietnam"},"por":{"official":"República Socialista do Vietname","common":"Vietname"},"rus":{"official":"Социалистическая Республика Вьетнам","common":"Вьетнам"},"slk":{"official":"Vietnamská socialistická republika","common":"Vietnam"},"spa":{"official":"República Socialista de Vietnam","common":"Vietnam"},"fin":{"official":"Vietnamin sosialistinen tasavalta","common":"Vietnam"},"est":{"official":"Vietnami Sotsialistlik Vabariik","common":"Vietnam"},"zho":{"official":"越南社会主义共和国","common":"越南"},"pol":{"official":"Socjalistyczna Republika Wietnamu","common":"Wietnam"},"urd":{"official":"اشتراکی جمہوریہ ویتنام","common":"ویتنام"},"kor":{"official":"베트남 사회주의 공화국","common":"베트남"},"per":{"official":"جمهوری سوسیالیستی ویتنام","common":"ویتنام"}},"latlng":[16.16666666,107.83333333],"landlocked":false,"borders":["KHM","CHN","LAO"],"area":331212,"flag":"🇻🇳","demonyms":{"eng":{"f":"Vietnamese","m":"Vietnamese"},"fra":{"f":"Vietnamienne","m":"Vietnamien"}}},{"name":{"common":"Vanuatu","official":"Republic of Vanuatu","native":{"bis":{"official":"Ripablik blong Vanuatu","common":"Vanuatu"},"eng":{"official":"Republic of Vanuatu","common":"Vanuatu"},"fra":{"official":"République de Vanuatu","common":"Vanuatu"}}},"tld":[".vu"],"cca2":"VU","ccn3":"548","cca3":"VUT","cioc":"VAN","independent":true,"status":"officially-assigned","currencies":{"VUV":{"name":"Vanuatu vatu","symbol":"Vt"}},"idd":{"root":"+6","suffixes":["78"]},"capital":["Port Vila"],"altSpellings":["VU","Republic of Vanuatu","Ripablik blong Vanuatu","République de Vanuatu"],"region":"Oceania","subregion":"Melanesia","languages":{"bis":"Bislama","eng":"English","fra":"French"},"translations":{"ces":{"official":"Republika Vanuatu","common":"Vanuatu"},"deu":{"official":"Vanuatu","common":"Vanuatu"},"fra":{"official":"République de Vanuatu","common":"Vanuatu"},"hrv":{"official":"Republika Vanuatu","common":"Vanuatu"},"ita":{"official":"Repubblica di Vanuatu","common":"Vanuatu"},"jpn":{"official":"バヌアツ共和国","common":"バヌアツ"},"nld":{"official":"Republiek Vanuatu","common":"Vanuatu"},"por":{"official":"República de Vanuatu","common":"Vanuatu"},"rus":{"official":"Республика Вануату","common":"Вануату"},"slk":{"official":"Vanuatská republika","common":"Vanuatu"},"spa":{"official":"República de Vanuatu","common":"Vanuatu"},"fin":{"official":"Vanuatun tasavalta","common":"Vanuatu"},"est":{"official":"Vanuatu Vabariik","common":"Vanuatu"},"zho":{"official":"瓦努阿图共和国","common":"瓦努阿图"},"pol":{"official":"Republika Vanuatu","common":"Vanuatu"},"urd":{"official":"جمہوریہ وانواتو","common":"وانواتو"},"kor":{"official":"바누아투 공화국","common":"바누아투"},"per":{"official":"جمهوری وانواتو","common":"وانواتو"}},"latlng":[-16,167],"landlocked":false,"borders":[],"area":12189,"flag":"🇻🇺","demonyms":{"eng":{"f":"Ni-Vanuatu","m":"Ni-Vanuatu"},"fra":{"f":"Vanuatuane","m":"Vanuatuan"}}},{"name":{"common":"Wallis and Futuna","official":"Territory of the Wallis and Futuna Islands","native":{"fra":{"official":"Territoire des îles Wallis et Futuna","common":"Wallis et Futuna"}}},"tld":[".wf"],"cca2":"WF","ccn3":"876","cca3":"WLF","cioc":"","independent":false,"status":"officially-assigned","currencies":{"XPF":{"name":"CFP franc","symbol":"₣"}},"idd":{"root":"+6","suffixes":["81"]},"capital":["Mata-Utu"],"altSpellings":["WF","Territory of the Wallis and Futuna Islands","Territoire des îles Wallis et Futuna"],"region":"Oceania","subregion":"Polynesia","languages":{"fra":"French"},"translations":{"ces":{"official":"Teritorium ostrovů Wallis a Futuna","common":"Wallis a Futuna"},"deu":{"official":"Gebiet der Wallis und Futuna","common":"Wallis und Futuna"},"fra":{"official":"Territoire des îles Wallis et Futuna","common":"Wallis-et-Futuna"},"hrv":{"official":"Teritoriju Wallis i Futuna","common":"Wallis i Fortuna"},"ita":{"official":"Territorio delle Isole Wallis e Futuna","common":"Wallis e Futuna"},"jpn":{"official":"ウォリス·フツナ諸島の領土","common":"ウォリス・フツナ"},"nld":{"official":"Grondgebied van de Wallis en Futuna","common":"Wallis en Futuna"},"por":{"official":"Território das Ilhas Wallis e Futuna","common":"Wallis e Futuna"},"rus":{"official":"Территория Уоллис и Футуна острова","common":"Уоллис и Футуна"},"slk":{"official":"Teritórium ostrovov Wallis a Futuna","common":"Wallis a Futuna"},"spa":{"official":"Territorio de las Islas Wallis y Futuna","common":"Wallis y Futuna"},"fin":{"official":"Wallisin ja Futunan yhteisö","common":"Wallis ja Futuna"},"est":{"official":"Wallise ja Futuna ala","common":"Wallis ja Futuna"},"zho":{"official":"瓦利斯和富图纳群岛","common":"瓦利斯和富图纳群岛"},"pol":{"official":"Terytorium Wysp Wallis i Futuna","common":"Wallis i Futuna"},"urd":{"official":"سر زمینِ والس و فتونہ جزائر","common":"والس و فتونہ"},"kor":{"official":"왈리스 퓌튀나","common":"왈리스 퓌튀나"},"per":{"official":"جزایر والیس و فوتونا","common":"والیس و فوتونا"}},"latlng":[-13.3,-176.2],"landlocked":false,"borders":[],"area":142,"flag":"🇼🇫","demonyms":{"eng":{"f":"Wallis and Futuna Islander","m":"Wallis and Futuna Islander"},"fra":{"f":"","m":""}}},{"name":{"common":"Samoa","official":"Independent State of Samoa","native":{"eng":{"official":"Independent State of Samoa","common":"Samoa"},"smo":{"official":"Malo Saʻoloto Tutoʻatasi o Sāmoa","common":"Sāmoa"}}},"tld":[".ws"],"cca2":"WS","ccn3":"882","cca3":"WSM","cioc":"SAM","independent":true,"status":"officially-assigned","currencies":{"WST":{"name":"Samoan tālā","symbol":"T"}},"idd":{"root":"+6","suffixes":["85"]},"capital":["Apia"],"altSpellings":["WS","Independent State of Samoa","Malo Saʻoloto Tutoʻatasi o Sāmoa"],"region":"Oceania","subregion":"Polynesia","languages":{"eng":"English","smo":"Samoan"},"translations":{"ces":{"official":"Nezávislý stát Samoa","common":"Samoa"},"deu":{"official":"Unabhängige Staat Samoa","common":"Samoa"},"fra":{"official":"Samoa","common":"Samoa"},"hrv":{"official":"Nezavisna Država Samoa","common":"Samoa"},"ita":{"official":"Stato indipendente di Samoa","common":"Samoa"},"jpn":{"official":"サモア独立国","common":"サモア"},"nld":{"official":"Onafhankelijke Staat Samoa","common":"Samoa"},"por":{"official":"Estado Independente de Samoa","common":"Samoa"},"rus":{"official":"Независимое Государство Самоа","common":"Самоа"},"slk":{"official":"Nezávislý štátSamoa","common":"Samoa"},"spa":{"official":"Estado Independiente de Samoa","common":"Samoa"},"fin":{"official":"Samoan itsenäinen valtio","common":"Samoa"},"est":{"official":"Samoa Iseseisvusriik","common":"Samoa"},"zho":{"official":"萨摩亚独立国","common":"萨摩亚"},"pol":{"official":"Niezależne Państwo Samoa","common":"Samoa"},"urd":{"official":"آزاد سلطنتِ ساموا","common":"سامووا"},"kor":{"official":"사모아 독립국","common":"사모아"},"per":{"official":"ایالت مستقل ساموآ","common":"ساموآ"}},"latlng":[-13.58333333,-172.33333333],"landlocked":false,"borders":[],"area":2842,"flag":"🇼🇸","demonyms":{"eng":{"f":"Samoan","m":"Samoan"},"fra":{"f":"Samoane","m":"Samoan"}}},{"name":{"common":"Yemen","official":"Republic of Yemen","native":{"ara":{"official":"الجمهورية اليمنية","common":"اليَمَن"}}},"tld":[".ye"],"cca2":"YE","ccn3":"887","cca3":"YEM","cioc":"YEM","independent":true,"status":"officially-assigned","currencies":{"YER":{"name":"Yemeni rial","symbol":"﷼"}},"idd":{"root":"+9","suffixes":["67"]},"capital":["Sana\'a"],"altSpellings":["YE","Yemeni Republic","al-Jumhūriyyah al-Yamaniyyah"],"region":"Asia","subregion":"Western Asia","languages":{"ara":"Arabic"},"translations":{"ces":{"official":"Jemenská republika","common":"Jemen"},"deu":{"official":"Republik Jemen","common":"Jemen"},"fra":{"official":"République du Yémen","common":"Yémen"},"hrv":{"official":"Republika Jemen","common":"Jemen"},"ita":{"official":"Repubblica dello Yemen","common":"Yemen"},"jpn":{"official":"イエメン共和国","common":"イエメン"},"nld":{"official":"Republiek Jemen","common":"Jemen"},"por":{"official":"República do Iêmen","common":"Iémen"},"rus":{"official":"Йеменская Республика","common":"Йемен"},"slk":{"official":"Jemenská republika","common":"Jemen"},"spa":{"official":"República de Yemen","common":"Yemen"},"fin":{"official":"Jemenin tasavalta","common":"Jemen"},"est":{"official":"Jeemeni Vabariik","common":"Jeemen"},"zho":{"official":"也门共和国","common":"也门"},"pol":{"official":"Republika Jemeńska","common":"Jemen"},"urd":{"official":"جمہوریہ یمن","common":"یمن"},"kor":{"official":"예멘 공화국","common":"예멘"},"per":{"official":"جمهوری یمن","common":"یمن"}},"latlng":[15,48],"landlocked":false,"borders":["OMN","SAU"],"area":527968,"flag":"🇾🇪","demonyms":{"eng":{"f":"Yemeni","m":"Yemeni"},"fra":{"f":"Yéménite","m":"Yéménite"}}},{"name":{"common":"South Africa","official":"Republic of South Africa","native":{"afr":{"official":"Republiek van Suid-Afrika","common":"South Africa"},"eng":{"official":"Republic of South Africa","common":"South Africa"},"nbl":{"official":"IRiphabliki yeSewula Afrika","common":"Sewula Afrika"},"nso":{"official":"Rephaboliki ya Afrika-Borwa ","common":"Afrika-Borwa"},"sot":{"official":"Rephaboliki ya Afrika Borwa","common":"Afrika Borwa"},"ssw":{"official":"IRiphabhulikhi yeNingizimu Afrika","common":"Ningizimu Afrika"},"tsn":{"official":"Rephaboliki ya Aforika Borwa","common":"Aforika Borwa"},"tso":{"official":"Riphabliki ra Afrika Dzonga","common":"Afrika Dzonga"},"ven":{"official":"Riphabuḽiki ya Afurika Tshipembe","common":"Afurika Tshipembe"},"xho":{"official":"IRiphabliki yaseMzantsi Afrika","common":"Mzantsi Afrika"},"zul":{"official":"IRiphabliki yaseNingizimu Afrika","common":"Ningizimu Afrika"}}},"tld":[".za"],"cca2":"ZA","ccn3":"710","cca3":"ZAF","cioc":"RSA","independent":true,"status":"officially-assigned","currencies":{"ZAR":{"name":"South African rand","symbol":"R"}},"idd":{"root":"+2","suffixes":["7"]},"capital":["Pretoria","Bloemfontein","Cape Town"],"altSpellings":["ZA","RSA","Suid-Afrika","Republic of South Africa"],"region":"Africa","subregion":"Southern Africa","languages":{"afr":"Afrikaans","eng":"English","nbl":"Southern Ndebele","nso":"Northern Sotho","sot":"Southern Sotho","ssw":"Swazi","tsn":"Tswana","tso":"Tsonga","ven":"Venda","xho":"Xhosa","zul":"Zulu"},"translations":{"ces":{"official":"Jihoafrická republika","common":"Jihoafrická republika"},"deu":{"official":"Republik Südafrika","common":"Südafrika"},"fra":{"official":"République d\'Afrique du Sud","common":"Afrique du Sud"},"hrv":{"official":"Južnoafrička Republika","common":"Južnoafrička Republika"},"ita":{"official":"Repubblica del Sud Africa","common":"Sud Africa"},"jpn":{"official":"南アフリカ共和国","common":"南アフリカ"},"nld":{"official":"Republiek Zuid-Afrika","common":"Zuid-Afrika"},"por":{"official":"República da África do Sul","common":"África do Sul"},"rus":{"official":"Южно-Африканская Республика","common":"Южно-Африканская Республика"},"slk":{"official":"Juhoafrická republika","common":"Juhoafrická republika"},"spa":{"official":"República de Sudáfrica","common":"República de Sudáfrica"},"fin":{"official":"Etelä-Afrikan tasavalta","common":"Etelä-Afrikka"},"est":{"official":"Lõuna-Aafrika Vabariik","common":"Lõuna-Aafrika Vabariik"},"zho":{"official":"南非共和国","common":"南非"},"pol":{"official":"Republika Południowej Afryki","common":"Południowa Afryka"},"urd":{"official":"جمہوریہ جنوبی افریقا","common":"جنوبی افریقا"},"kor":{"official":"남아프리카 공화국","common":"남아프리카"},"per":{"official":"جمهوری آفریقای جنوبی","common":"آفریقای جنوبی"}},"latlng":[-29,24],"landlocked":false,"borders":["BWA","LSO","MOZ","NAM","SWZ","ZWE"],"area":1221037,"flag":"🇿🇦","demonyms":{"eng":{"f":"South African","m":"South African"},"fra":{"f":"Sud-africaine","m":"Sud-africain"}}},{"name":{"common":"Zambia","official":"Republic of Zambia","native":{"eng":{"official":"Republic of Zambia","common":"Zambia"}}},"tld":[".zm"],"cca2":"ZM","ccn3":"894","cca3":"ZMB","cioc":"ZAM","independent":true,"status":"officially-assigned","currencies":{"ZMW":{"name":"Zambian kwacha","symbol":"ZK"}},"idd":{"root":"+2","suffixes":["60"]},"capital":["Lusaka"],"altSpellings":["ZM","Republic of Zambia"],"region":"Africa","subregion":"Eastern Africa","languages":{"eng":"English"},"translations":{"ces":{"official":"Zambijská republika","common":"Zambie"},"deu":{"official":"Republik Sambia","common":"Sambia"},"fra":{"official":"République de Zambie","common":"Zambie"},"hrv":{"official":"Republika Zambija","common":"Zambija"},"ita":{"official":"Repubblica di Zambia","common":"Zambia"},"jpn":{"official":"ザンビア共和国","common":"ザンビア"},"nld":{"official":"Republiek Zambia","common":"Zambia"},"por":{"official":"República da Zâmbia","common":"Zâmbia"},"rus":{"official":"Республика Замбия","common":"Замбия"},"slk":{"official":"Zambijská republika","common":"Zambia"},"spa":{"official":"República de Zambia","common":"Zambia"},"fin":{"official":"Sambian tasavalta","common":"Sambia"},"est":{"official":"Sambia Vabariik","common":"Sambia"},"zho":{"official":"赞比亚共和国","common":"赞比亚"},"pol":{"official":"Republika Zambii","common":"Zambia"},"urd":{"official":"جمہوریہ زیمبیا","common":"زیمبیا"},"kor":{"official":"잠비아 공화국","common":"잠비아"},"per":{"official":"جمهوری زامبیا","common":"زامبیا"}},"latlng":[-15,30],"landlocked":true,"borders":["AGO","BWA","COD","MWI","MOZ","NAM","TZA","ZWE"],"area":752612,"flag":"🇿🇲","demonyms":{"eng":{"f":"Zambian","m":"Zambian"},"fra":{"f":"Zambienne","m":"Zambien"}}},{"name":{"common":"Zimbabwe","official":"Republic of Zimbabwe","native":{"bwg":{"official":"Republic of Zimbabwe","common":"Zimbabwe"},"eng":{"official":"Republic of Zimbabwe","common":"Zimbabwe"},"kck":{"official":"Republic of Zimbabwe","common":"Zimbabwe"},"khi":{"official":"Republic of Zimbabwe","common":"Zimbabwe"},"ndc":{"official":"Republic of Zimbabwe","common":"Zimbabwe"},"nde":{"official":"Republic of Zimbabwe","common":"Zimbabwe"},"nya":{"official":"Republic of Zimbabwe","common":"Zimbabwe"},"sna":{"official":"Republic of Zimbabwe","common":"Zimbabwe"},"sot":{"official":"Republic of Zimbabwe","common":"Zimbabwe"},"toi":{"official":"Republic of Zimbabwe","common":"Zimbabwe"},"tsn":{"official":"Republic of Zimbabwe","common":"Zimbabwe"},"tso":{"official":"Republic of Zimbabwe","common":"Zimbabwe"},"ven":{"official":"Republic of Zimbabwe","common":"Zimbabwe"},"xho":{"official":"Republic of Zimbabwe","common":"Zimbabwe"},"zib":{"official":"Republic of Zimbabwe","common":"Zimbabwe"}}},"tld":[".zw"],"cca2":"ZW","ccn3":"716","cca3":"ZWE","cioc":"ZIM","independent":true,"status":"officially-assigned","currencies":{"BWP":{"name":"Botswana pula","symbol":"P"},"CNY":{"name":"Chinese yuan","symbol":"¥"},"EUR":{"name":"Euro","symbol":"€"},"GBP":{"name":"British pound","symbol":"£"},"INR":{"name":"Indian rupee","symbol":"₹"},"JPY":{"name":"Japanese yen","symbol":"¥"},"USD":{"name":"United States dollar","symbol":"$"},"ZAR":{"name":"South African rand","symbol":"Rs"},"ZWB":{"name":"Zimbabwean bonds","symbol":"$"}},"idd":{"root":"+2","suffixes":["63"]},"capital":["Harare"],"altSpellings":["ZW","Republic of Zimbabwe"],"region":"Africa","subregion":"Eastern Africa","languages":{"bwg":"Chibarwe","eng":"English","kck":"Kalanga","khi":"Khoisan","ndc":"Ndau","nde":"Northern Ndebele","nya":"Chewa","sna":"Shona","sot":"Sotho","toi":"Tonga","tsn":"Tswana","tso":"Tsonga","ven":"Venda","xho":"Xhosa","zib":"Zimbabwean Sign Language"},"translations":{"ces":{"official":"Zimbabwská republika","common":"Zimbabwe"},"deu":{"official":"Republik Simbabwe","common":"Simbabwe"},"fra":{"official":"République du Zimbabwe","common":"Zimbabwe"},"hrv":{"official":"Republika Zimbabve","common":"Zimbabve"},"ita":{"official":"Repubblica dello Zimbabwe","common":"Zimbabwe"},"jpn":{"official":"ジンバブエ共和国","common":"ジンバブエ"},"nld":{"official":"Republiek Zimbabwe","common":"Zimbabwe"},"por":{"official":"República do Zimbabwe","common":"Zimbabwe"},"rus":{"official":"Республика Зимбабве","common":"Зимбабве"},"slk":{"official":"Zimbabwianska republika","common":"Zimbabwe"},"spa":{"official":"República de Zimbabue","common":"Zimbabue"},"fin":{"official":"Zimbabwen tasavalta","common":"Zimbabwe"},"est":{"official":"Zimbabwe Vabariik","common":"Zimbabwe"},"zho":{"official":"津巴布韦共和国","common":"津巴布韦"},"pol":{"official":"Republika Zimbabwe","common":"Zimbabwe"},"urd":{"official":"جمہوریہ زمبابوے","common":"زمبابوے"},"kor":{"official":"짐바브웨 공화국","common":"짐바브웨"},"per":{"official":"جمهوری زیمبابوه","common":"زیمبابوه"}},"latlng":[-20,30],"landlocked":true,"borders":["BWA","MOZ","ZAF","ZMB"],"area":390757,"flag":"🇿🇼","demonyms":{"eng":{"f":"Zimbabwean","m":"Zimbabwean"},"fra":{"f":"Zimbabwéenne","m":"Zimbabwéen"}}}]')},function(a,i,c){"use strict";c.r(i);var l=c(0),o=c.n(l),t=c(1),e=c.n(t),n=c(2),s=c.n(n),r=c(3),f=c.n(r),m=c(4),d=c.n(m),h=c(5),C=c.n(h),p=c(6),E=c.n(p),M=c(7),u=c.n(M),k=c(8),z=c.n(k),g=c(9),v=c.n(g),b=c(10),w=c.n(b),x=c(11),y=c.n(x),S=c(12),R=c.n(S),A=c(13),B=c.n(A),L=c(14),F=c.n(L),G=c(15),j=c.n(G),T=c(16),N=c.n(T),P=c(17),V=c.n(P),K=c(18),I=c.n(K),H=c(19),D=c.n(H),U=c(20),O=c.n(U),q=c(21),Z=c.n(q),_=c(22),J=c.n(_),W=c(23),Y=c.n(W),X=c(24),$=c.n(X),Q=c(25),aa=c.n(Q),ia=c(26),ca=c.n(ia),la=c(27),oa=c.n(la),ta=c(28),ea=c.n(ta),na=c(29),sa=c.n(na),ra=c(30),fa=c.n(ra),ma=c(31),da=c.n(ma),ha=c(32),Ca=c.n(ha),pa=c(33),Ea=c.n(pa),Ma=c(34),ua=c.n(Ma),ka=c(35),za=c.n(ka),ga=c(36),va=c.n(ga),ba=c(37),wa=c.n(ba),xa=c(38),ya=c.n(xa),Sa=c(39),Ra=c.n(Sa),Aa=c(40),Ba=c.n(Aa),La=c(41),Fa=c.n(La),Ga=c(42),ja=c.n(Ga),Ta=c(43),Na=c.n(Ta),Pa=c(44),Va=c.n(Pa),Ka=c(45),Ia=c.n(Ka),Ha=c(46),Da=c.n(Ha),Ua=c(47),Oa=c.n(Ua),qa=c(48),Za=c.n(qa),_a=c(49),Ja=c.n(_a),Wa=c(50),Ya=c.n(Wa),Xa=c(51),$a=c.n(Xa),Qa=c(52),ai=c.n(Qa),ii=c(53),ci=c.n(ii),li=c(54),oi=c.n(li),ti=c(55),ei=c.n(ti),ni=c(56),si=c.n(ni),ri=c(57),fi=c.n(ri),mi=c(58),di=c.n(mi),hi=c(59),Ci=c.n(hi),pi=c(60),Ei=c.n(pi),Mi=c(61),ui=c.n(Mi),ki=c(62),zi=c.n(ki),gi=c(63),vi=c.n(gi),bi=c(64),wi=c.n(bi),xi=c(65),yi=c.n(xi),Si=c(66),Ri=c.n(Si),Ai=c(67),Bi=c.n(Ai),Li=c(68),Fi=c.n(Li),Gi=c(69),ji=c.n(Gi),Ti=c(70),Ni=c.n(Ti),Pi=c(71),Vi=c.n(Pi),Ki=c(72),Ii=c.n(Ki),Hi=c(73),Di=c.n(Hi),Ui=c(74),Oi=c.n(Ui),qi=c(75),Zi=c.n(qi),_i=c(76),Ji=c.n(_i),Wi=c(77),Yi=c.n(Wi),Xi=c(78),$i=c.n(Xi),Qi=c(79),ac=c.n(Qi),ic=c(80),cc=c.n(ic),lc=c(81),oc=c.n(lc),tc=c(82),ec=c.n(tc),nc=c(83),sc=c.n(nc),rc=c(84),fc=c.n(rc),mc=c(85),dc=c.n(mc),hc=c(86),Cc=c.n(hc),pc=c(87),Ec=c.n(pc),Mc=c(88),uc=c.n(Mc),kc=c(89),zc=c.n(kc),gc=c(90),vc=c.n(gc),bc=c(91),wc=c.n(bc),xc=c(92),yc=c.n(xc),Sc=c(93),Rc=c.n(Sc),Ac=c(94),Bc=c.n(Ac),Lc=c(95),Fc=c.n(Lc),Gc=c(96),jc=c.n(Gc),Tc=c(97),Nc=c.n(Tc),Pc=c(98),Vc=c.n(Pc),Kc=c(99),Ic=c.n(Kc),Hc=c(100),Dc=c.n(Hc),Uc=c(101),Oc=c.n(Uc),qc=c(102),Zc=c.n(qc),_c=c(103),Jc=c.n(_c),Wc=c(104),Yc=c.n(Wc),Xc=c(105),$c=c.n(Xc),Qc=c(106),al=c.n(Qc),il=c(107),cl=c.n(il),ll=c(108),ol=c.n(ll),tl=c(109),el=c.n(tl),nl=c(110),sl=c.n(nl),rl=c(111),fl=c.n(rl),ml=c(112),dl=c.n(ml),hl=c(113),Cl=c.n(hl),pl=c(114),El=c.n(pl),Ml=c(115),ul=c.n(Ml),kl=c(116),zl=c.n(kl),gl=c(117),vl=c.n(gl),bl=c(118),wl=c.n(bl),xl=c(119),yl=c.n(xl),Sl=c(120),Rl=c.n(Sl),Al=c(121),Bl=c.n(Al),Ll=c(122),Fl=c.n(Ll),Gl=c(123),jl=c.n(Gl),Tl=c(124),Nl=c.n(Tl),Pl=c(125),Vl=c.n(Pl),Kl=c(126),Il=c.n(Kl),Hl=c(127),Dl=c.n(Hl),Ul=c(128),Ol=c.n(Ul),ql=c(129),Zl=c.n(ql),_l=c(130),Jl=c.n(_l),Wl=c(131),Yl=c.n(Wl),Xl=c(132),$l=c.n(Xl),Ql=c(133),ao=c.n(Ql),io=c(134),co=c.n(io),lo=c(135),oo=c.n(lo),to=c(136),eo=c.n(to),no=c(137),so=c.n(no),ro=c(138),fo=c.n(ro),mo=c(139),ho=c.n(mo),Co=c(140),po=c.n(Co),Eo=c(141),Mo=c.n(Eo),uo=c(142),ko=c.n(uo),zo=c(143),go=c.n(zo),vo=c(144),bo=c.n(vo),wo=c(145),xo=c.n(wo),yo=c(146),So=c.n(yo),Ro=c(147),Ao=c.n(Ro),Bo=c(148),Lo=c.n(Bo),Fo=c(149),Go=c.n(Fo),jo=c(150),To=c.n(jo),No=c(151),Po=c.n(No),Vo=c(152),Ko=c.n(Vo),Io=c(153),Ho=c.n(Io),Do=c(154),Uo=c.n(Do),Oo=c(155),qo=c.n(Oo),Zo=c(156),_o=c.n(Zo),Jo=c(157),Wo=c.n(Jo),Yo=c(158),Xo=c.n(Yo),$o=c(159),Qo=c.n($o),at=c(160),it=c.n(at),ct=c(161),lt=c.n(ct),ot=c(162),tt=c.n(ot),et=c(163),nt=c.n(et),st=c(164),rt=c.n(st),ft=c(165),mt=c.n(ft),dt=c(166),ht=c.n(dt),Ct=c(167),pt=c.n(Ct),Et=c(168),Mt=c.n(Et),ut=c(169),kt=c.n(ut),zt=c(170),gt=c.n(zt),vt=c(171),bt=c.n(vt),wt=c(172),xt=c.n(wt),yt=c(173),St=c.n(yt),Rt=c(174),At=c.n(Rt),Bt=c(175),Lt=c.n(Bt),Ft=c(176),Gt=c.n(Ft),jt=c(177),Tt=c.n(jt),Nt=c(178),Pt=c.n(Nt),Vt=c(179),Kt=c.n(Vt),It=c(180),Ht=c.n(It),Dt=c(181),Ut=c.n(Dt),Ot=c(182),qt=c.n(Ot),Zt=c(183),_t=c.n(Zt),Jt=c(184),Wt=c.n(Jt),Yt=c(185),Xt=c.n(Yt),$t=c(186),Qt=c.n($t),ae=c(187),ie=c.n(ae),ce=c(188),le=c.n(ce),oe=c(189),te=c.n(oe),ee=c(190),ne=c.n(ee),se=c(191),re=c.n(se),fe=c(192),me=c.n(fe),de=c(193),he=c.n(de),Ce=c(194),pe=c.n(Ce),Ee=c(195),Me=c.n(Ee),ue=c(196),ke=c.n(ue),ze=c(197),ge=c.n(ze),ve=c(198),be=c.n(ve),we=c(199),xe=c.n(we),ye=c(200),Se=c.n(ye),Re=c(201),Ae=c.n(Re),Be=c(202),Le=c.n(Be),Fe=c(203),Ge=c.n(Fe),je=c(204),Te=c.n(je),Ne=c(205),Pe=c.n(Ne),Ve=c(206),Ke=c.n(Ve),Ie=c(207),He=c.n(Ie),De=c(208),Ue=c.n(De),Oe=c(209),qe=c.n(Oe),Ze=c(210),_e=c.n(Ze),Je=c(211),We=c.n(Je),Ye=c(212),Xe=c.n(Ye),$e=c(213),Qe=c.n($e),an=c(214),cn=c.n(an),ln=c(215),on=c.n(ln),tn=c(216),en=c.n(tn),nn=c(217),sn=c.n(nn),rn=c(218),fn=c.n(rn),mn=c(219),dn=c.n(mn),hn=c(220),Cn=c.n(hn),pn=c(221),En=c.n(pn),Mn=c(222),un=c.n(Mn),kn=c(223),zn=c.n(kn),gn=c(224),vn=c.n(gn),bn=c(225),wn=c.n(bn),xn=c(226),yn=c.n(xn),Sn=c(227),Rn=c.n(Sn),An=c(228),Bn=c.n(An),Ln=c(229),Fn=c.n(Ln),Gn=c(230),jn=c.n(Gn),Tn=c(231),Nn=c.n(Tn),Pn=c(232),Vn=c.n(Pn),Kn=c(233),In=c.n(Kn),Hn=c(234),Dn=c.n(Hn),Un=c(235),On=c.n(Un),qn=c(236),Zn=c.n(qn),_n=c(237),Jn=c.n(_n),Wn=c(238),Yn=c.n(Wn),Xn=c(239),$n=c.n(Xn),Qn=c(240),as=c.n(Qn),is=c(241),cs=c.n(is),ls=c(242),os=c.n(ls),ts=c(243),es=c.n(ts),ns=c(244),ss=c.n(ns),rs=c(245),fs=c.n(rs),ms=c(246),ds=c.n(ms),hs=c(247),Cs=c.n(hs),ps=c(248),Es=c.n(ps),Ms=c(249),us=c.n(Ms),ks=c(250),zs=c.n(ks),gs=c(251),vs=c.n(gs),bs=c(252),ws=c.n(bs),xs=c(253),ys=c.n(xs),Ss=c(254),Rs=c.n(Ss),As=c(255),Bs=c.n(As),Ls=c(256),Fs=c.n(Ls),Gs={flag_AD:e.a,flag_AE:s.a,flag_AF:f.a,flag_AG:d.a,flag_AI:C.a,flag_AL:E.a,flag_AM:u.a,flag_AN:z.a,flag_AO:v.a,flag_AQ:w.a,flag_AR:y.a,flag_AS:R.a,flag_AT:B.a,flag_AU:F.a,flag_AW:j.a,flag_AX:N.a,flag_AZ:V.a,flag_BA:I.a,flag_BB:D.a,flag_BD:O.a,flag_BE:Z.a,flag_BF:J.a,flag_BG:Y.a,flag_BH:$.a,flag_BI:aa.a,flag_BJ:ca.a,flag_BL:oa.a,flag_BM:ea.a,flag_BN:sa.a,flag_BO:fa.a,flag_BQ:da.a,flag_BR:Ca.a,flag_BS:Ea.a,flag_BT:ua.a,flag_BV:za.a,flag_BW:va.a,flag_BY:wa.a,flag_BZ:ya.a,flag_CA:Ra.a,flag_CC:Ba.a,flag_CD:Fa.a,flag_CF:ja.a,flag_CG:Na.a,flag_CH:Va.a,flag_CI:Ia.a,flag_CK:Da.a,flag_CL:Oa.a,flag_CM:Za.a,flag_CN:Ja.a,flag_CO:Ya.a,flag_CR:$a.a,flag_CU:ai.a,flag_CV:ci.a,flag_CW:oi.a,flag_CX:ei.a,flag_CY:si.a,flag_CZ:fi.a,flag_DE:di.a,flag_DJ:Ci.a,flag_DK:Ei.a,flag_DM:ui.a,flag_DO:zi.a,flag_DZ:vi.a,flag_EC:wi.a,flag_EE:yi.a,flag_EG:Ri.a,flag_EH:Bi.a,flag_ER:Fi.a,flag_ES:ji.a,flag_ET:Ni.a,flag_EU:Vi.a,flag_FI:Ii.a,flag_FJ:Di.a,flag_FK:Oi.a,flag_FM:Zi.a,flag_FO:Ji.a,flag_FR:Yi.a,flag_GA:$i.a,flag_GB_ENG:ac.a,flag_GB_NIR:cc.a,flag_GB_SCT:oc.a,flag_GB_WLS:ec.a,flag_GB:sc.a,flag_GD:fc.a,flag_GE:dc.a,flag_GF:Cc.a,flag_GG:Ec.a,flag_GH:uc.a,flag_GI:zc.a,flag_GL:vc.a,flag_GM:wc.a,flag_GN:yc.a,flag_GP:Rc.a,flag_GQ:Bc.a,flag_GR:Fc.a,flag_GS:jc.a,flag_GT:Nc.a,flag_GU:Vc.a,flag_GW:Ic.a,flag_GY:Dc.a,flag_HK:Oc.a,flag_HM:Zc.a,flag_HN:Jc.a,flag_HR:Yc.a,flag_HT:$c.a,flag_HU:al.a,flag_ID:cl.a,flag_IE:ol.a,flag_IL:el.a,flag_IM:sl.a,flag_IN:fl.a,flag_IO:dl.a,flag_IQ:Cl.a,flag_IR:El.a,flag_IS:ul.a,flag_IT:zl.a,flag_JE:vl.a,flag_JM:wl.a,flag_JO:yl.a,flag_JP:Rl.a,flag_KE:Bl.a,flag_KG:Fl.a,flag_KH:jl.a,flag_KI:Nl.a,flag_KM:Vl.a,flag_KN:Il.a,flag_KP:Dl.a,flag_KR:Ol.a,flag_KW:Zl.a,flag_KY:Jl.a,flag_KZ:Yl.a,flag_LA:$l.a,flag_LB:ao.a,flag_LC:co.a,flag_LI:oo.a,flag_LK:eo.a,flag_LR:so.a,flag_LS:fo.a,flag_LT:ho.a,flag_LU:po.a,flag_LV:Mo.a,flag_LY:ko.a,flag_MA:go.a,flag_MC:bo.a,flag_MD:xo.a,flag_ME:So.a,flag_MF:Ao.a,flag_MG:Lo.a,flag_MH:Go.a,flag_MK:To.a,flag_ML:Po.a,flag_MM:Ko.a,flag_MN:Ho.a,flag_MO:Uo.a,flag_MP:qo.a,flag_MQ:_o.a,flag_MR:Wo.a,flag_MS:Xo.a,flag_MT:Qo.a,flag_MU:it.a,flag_MV:lt.a,flag_MW:tt.a,flag_MX:nt.a,flag_MY:rt.a,flag_MZ:mt.a,flag_NA:ht.a,flag_NC:pt.a,flag_NE:Mt.a,flag_NF:kt.a,flag_NG:gt.a,flag_NI:bt.a,flag_NL:xt.a,flag_NO:St.a,flag_NP:At.a,flag_NR:Lt.a,flag_NU:Gt.a,flag_NZ:Tt.a,flag_OM:Pt.a,flag_PA:Kt.a,flag_PE:Ht.a,flag_PF:Ut.a,flag_PG:qt.a,flag_PH:_t.a,flag_PK:Wt.a,flag_PL:Xt.a,flag_PM:Qt.a,flag_PN:ie.a,flag_PR:le.a,flag_PS:te.a,flag_PT:ne.a,flag_PW:re.a,flag_PY:me.a,flag_QA:he.a,flag_RE:pe.a,flag_RO:Me.a,flag_RS:ke.a,flag_RU:ge.a,flag_RW:be.a,flag_SA:xe.a,flag_SB:Se.a,flag_SC:Ae.a,flag_SD:Le.a,flag_SE:Ge.a,flag_SG:Te.a,flag_SH:Pe.a,flag_SI:Ke.a,flag_SJ:He.a,flag_SK:Ue.a,flag_SL:qe.a,flag_SM:_e.a,flag_SN:We.a,flag_SO:Xe.a,flag_SR:Qe.a,flag_SS:cn.a,flag_ST:on.a,flag_SV:en.a,flag_SX:sn.a,flag_SY:fn.a,flag_SZ:dn.a,flag_TC:Cn.a,flag_TD:En.a,flag_TF:un.a,flag_TG:zn.a,flag_TH:vn.a,flag_TJ:wn.a,flag_TK:yn.a,flag_TL:Rn.a,flag_TM:Bn.a,flag_TN:Fn.a,flag_TO:jn.a,flag_TR:Nn.a,flag_TT:Vn.a,flag_TV:In.a,flag_TW:Dn.a,flag_TZ:On.a,flag_UA:Zn.a,flag_UG:Jn.a,flag_UM:Yn.a,flag_US:$n.a,flag_UY:as.a,flag_UZ:cs.a,flag_VA:os.a,flag_VC:es.a,flag_VE:ss.a,flag_VG:fs.a,flag_VI:ds.a,flag_VN:Cs.a,flag_VU:Es.a,flag_WF:us.a,flag_XK:zs.a,flag_WS:vs.a,flag_YE:ws.a,flag_YT:ys.a,flag_ZA:Rs.a,flag_ZM:Bs.a,flag_ZW:Fs.a},js=c(257),Ts=c.n(js);function Ns(){return(Ns=Object.assign||function(a){for(var i=1;i<arguments.length;i++){var c=arguments[i];for(var l in c)Object.prototype.hasOwnProperty.call(c,l)&&(a[l]=c[l])}return a}).apply(this,arguments)}function Ps(a,i){if(null==a)return{};var c,l,o=function(a,i){if(null==a)return{};var c,l,o={},t=Object.keys(a);for(l=0;l<t.length;l++)c=t[l],i.indexOf(c)>=0||(o[c]=a[c]);return o}(a,i);if(Object.getOwnPropertySymbols){var t=Object.getOwnPropertySymbols(a);for(l=0;l<t.length;l++)c=t[l],i.indexOf(c)>=0||Object.prototype.propertyIsEnumerable.call(a,c)&&(o[c]=a[c])}return o}i.default=function(a){var i=a.code,c=a.fallback,l=void 0===c?null:c,t=Ps(a,["code","fallback"]);if(!i)return l;var e=function(a){var i=String(a).toUpperCase(),c=Ts.a.find((function(a){return a.cca2===i||a.ccn3===i||a.cca3==i}));return c&&c.cca2||a}(i),n=Gs["flag_"+e.replace("-","_")];return n?o.a.createElement("img",Ns({},t,{src:n})):l}}])}));

/***/ }),
/* 536 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3____ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_flickity__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_flickity___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_flickity__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SlideshowMobile=function(_Component){_inherits(SlideshowMobile,_Component);function SlideshowMobile(){var _ref;var _temp,_this,_ret;_classCallCheck(this,SlideshowMobile);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=SlideshowMobile.__proto__||Object.getPrototypeOf(SlideshowMobile)).call.apply(_ref,[this].concat(args))),_this),_this.state={activeSlider:false,cardLength:0,next:false,prev:false},_this.initSlider=function(){_this.flktySlides=new __WEBPACK_IMPORTED_MODULE_4_flickity___default.a(_this.slider,{lazyLoad:1,pageDots:false,prevNextButtons:false,contain:true,on:{'ready':function ready(){_this.setState({next:_this.cards.length>1});},'change':function change(index){_this.setState({prev:index>0,next:index<_this.cards.length-1});}}});},_this.onResize=Object(__WEBPACK_IMPORTED_MODULE_1_lodash__["throttle"])(function(){_this.isSlider();},400),_this.isSlider=function(){if(_this.state.cardLength>0&&_this.slider){_this.setState({activeSlider:_this.state.cardLength>_this.slider.offsetWidth},function(){if((!_this.flktySlides||!_this.flktySlides.isActive)&&_this.state.activeSlider)_this.initSlider();if(_this.flktySlides&&!_this.state.activeSlider)_this.flktySlides.destroy();});}},_this.next=function(e){e.preventDefault();_this.flktySlides.next();},_this.prev=function(e){e.preventDefault();_this.flktySlides.previous();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(SlideshowMobile,[{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener('resize',this.onResize.bind(this));}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(_ref2){var _this2=this;var children=_ref2.children,isHome=_ref2.isHome,ready=_ref2.ready;if(children!==this.props.children&&ready&&ready!==this.props.ready){this.timer=setTimeout(function(){if(_this2.slider)_this2.init();},300);}}},{key:'init',value:function init(){var _this3=this;window.addEventListener('resize',this.onResize.bind(this));this.cards=this.slider.querySelectorAll('.card-inner');this.setState({cardLength:this.cards?this.cards[0].offsetWidth*this.cards.length:0},function(){_this3.isSlider();});}},{key:'render',value:function render(){var _this4=this;var children=this.props.children;var _state=this.state,activeSlider=_state.activeSlider,prev=_state.prev,next=_state.next;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:' slideshow-article '+Object(__WEBPACK_IMPORTED_MODULE_2__styles__["_50" /* SlideshowStyle */])(prev,next)},activeSlider&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'slideshow-article-nav'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'slideshow-nav-prev prev',onClick:this.prev},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3____["d" /* Arrow */],{width:24,height:24})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'slideshow-nav-next next',onClick:this.next},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3____["d" /* Arrow */],{width:24,height:24}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'slideshow-article-container flex',ref:function ref(slider){return _this4.slider=slider;}},children));}}]);return SlideshowMobile;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (SlideshowMobile);

/***/ }),
/* 537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_Router__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3____ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(8);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CHALLENGE_ROLE=['ROLE_SELLER','ROLE_STORE_MANAGER'];var UserNav=function(_Component){_inherits(UserNav,_Component);function UserNav(){var _ref;var _temp,_this,_ret;_classCallCheck(this,UserNav);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=UserNav.__proto__||Object.getPrototypeOf(UserNav)).call.apply(_ref,[this].concat(args))),_this),_this.state={nav:[{value:'My Information',url:__WEBPACK_IMPORTED_MODULE_1__services_Router__["a" /* default */].information.path},{value:'Team',url:__WEBPACK_IMPORTED_MODULE_1__services_Router__["a" /* default */].team.exactPath},{value:'Challenge',url:__WEBPACK_IMPORTED_MODULE_1__services_Router__["a" /* default */].challenge.path},{value:'Agenda',url:__WEBPACK_IMPORTED_MODULE_1__services_Router__["a" /* default */].event.path},{value:'Alerts',url:__WEBPACK_IMPORTED_MODULE_1__services_Router__["a" /* default */].counterfeits.path}]},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(UserNav,[{key:'componentDidMount',value:function componentDidMount(){if(CHALLENGE_ROLE.indexOf(this.props.role)===-1){this.setState({nav:this.state.nav.filter(function(nav){return nav.value!=='Challenge';})});}}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'user-nav '+__WEBPACK_IMPORTED_MODULE_2__styles__["_70" /* UserNavStyle */]+' no-print'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'Hi ',this.props.name,', Welcome !'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3____["J" /* Nav */],{nav:this.state.nav}));}}]);return UserNav;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */])(function(_ref2){var Session=_ref2.Session;return{name:Session.username,role:Session.role};})(UserNav));

/***/ }),
/* 538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProductList=function(_Component){_inherits(ProductList,_Component);function ProductList(){_classCallCheck(this,ProductList);return _possibleConstructorReturn(this,(ProductList.__proto__||Object.getPrototypeOf(ProductList)).apply(this,arguments));}_createClass(ProductList,[{key:'render',value:function render(){var products=this.props.products;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list flex'},products&&products.map(function(product,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1____["n" /* Card */],Object.assign({},product,{key:index,shadow:true,category:null,label:'discover'}));}));}}]);return ProductList;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ProductList);

/***/ }),
/* 539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2____ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_ApiController__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shapes__ = __webpack_require__(47);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SearchList=function(_Component){_inherits(SearchList,_Component);function SearchList(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,SearchList);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=SearchList.__proto__||Object.getPrototypeOf(SearchList)).call.apply(_ref,[this].concat(args))),_this),_this.state={products:[],filters:[],filterProduct:null,ready:false},_this.getFirstCategorie=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(categories){var category;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return categories[0];case 2:category=_context.sent;return _context.abrupt('return',category);case 4:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref2.apply(this,arguments);};}(),_this.getSearch=Object(__WEBPACK_IMPORTED_MODULE_5_lodash__["debounce"])(function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(key){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_3__services_ApiController__["searchTerm"])(key).then(function(data){if(data.pages.length>0){_this.setState({products:data.pages,results:data.pages.length,filters:data.categories[Object.keys(data.categories)[0]].filters,category:Object.keys(data.categories)[0]});var categories=Object.keys(data.categories).reduce(function(acc,category){acc.push({label:category,results:data.categories[category].results,filters:data.categories[category].filters});return acc;},[]);_this.setState({categories:categories,ready:true});}else{_this.setState({products:[],results:0,filters:[],category:'',ready:true});}}).catch(function(e){console.log('Something wrong with search',e);});case 2:case'end':return _context2.stop();}}},_callee2,_this2);}));return function(_x2){return _ref3.apply(this,arguments);};}(),500),_this.handlerCategory=function(category){return function(e){e.preventDefault();var modelsFilters=_this.state.categories.filter(function(category){return category.label==='models';});_this.setState({category:category,filters:category!=='models'?[]:modelsFilters[0].filters,filterProduct:null});};},_this.getFilters=function(filters){var nProducts=_this.state.products.filter(function(product){return _this.state.category===product.category.toLowerCase();}).reduce(function(productFilters,product){var isFiltering=Object.keys(filters).reduce(function(filtering,category){if(!product.filters.models[category]){filtering=false;}else{filters[category].map(function(filter){if(product.filters.models[category].indexOf(filter)===-1)filtering=false;return filter;});}return filtering;},true);if(isFiltering)productFilters.push(product);return productFilters;},[]);_this.setState({filterProduct:Object.keys(filters).length>0?nProducts:null});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(SearchList,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(_ref4){var search=_ref4.search;if(search!==this.props.search&&search!==''){this.setState({ready:false});this.getSearch(search);}}},{key:'render',value:function render(){var _this3=this;var _state=this.state,products=_state.products,results=_state.results,categories=_state.categories,filters=_state.filters,filterProduct=_state.filterProduct,ready=_state.ready;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:Object(__WEBPACK_IMPORTED_MODULE_4__styles__["_80" /* searchListStyle */])(ready)},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'search-load'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Shapes__["m" /* Load */],{'with':24,height:24})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'search-transition'},products&&products.length>=1&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'results'},results,' ',results>1?'results':'result',' :'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'filters'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2____["N" /* Pan */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('ul',{className:'categories-filter flex flex-nowrap reset'},categories&&categories.map(function(category,index){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',{className:'category-filter '+(category.label===_this3.state.category?'active':''),key:index,onClick:_this3.handlerCategory(category.label)},category.label,'  ',category.results);}))),this.state.category==='models'&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2____["y" /* Filter */],{filters:filters,filtering:this.getFilters,dark:true})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'product-list'},filterProduct?filterProduct.filter(function(product){return _this3.state.category===product.category.toLowerCase();}).map(function(product,index){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2____["n" /* Card */],Object.assign({},product,{key:index,search:true,label:'read more'}));}):products.filter(function(product){return _this3.state.category===product.category.toLowerCase();}).map(function(product,index){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2____["n" /* Card */],Object.assign({},product,{key:index,search:true,label:'read more'}));}))),products&&products.length===0&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'no-results'},'No results')));}}]);return SearchList;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (SearchList);

/***/ }),
/* 540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(5);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SimpleFilter=function(_Component){_inherits(SimpleFilter,_Component);function SimpleFilter(){_classCallCheck(this,SimpleFilter);return _possibleConstructorReturn(this,(SimpleFilter.__proto__||Object.getPrototypeOf(SimpleFilter)).apply(this,arguments));}_createClass(SimpleFilter,[{key:'render',value:function render(){var _props=this.props,filters=_props.filters,parentPath=_props.parentPath;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'simple-filter '+__WEBPACK_IMPORTED_MODULE_1__styles__["_41" /* SimpleFilterStyle */]+' reset flex'},filters&&filters.map(function(filter,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:index,className:'simple-filter-item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["c" /* NavLink */],{to:parentPath+'/'+(index>0?filter.slug:''),exact:true},filter.icon&&filter.icon,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'  ',filter.label,' ')));}));}}]);return SimpleFilter;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (SimpleFilter);

/***/ }),
/* 541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TeamCard=function(_Component){_inherits(TeamCard,_Component);function TeamCard(){var _ref;var _temp,_this,_ret;_classCallCheck(this,TeamCard);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=TeamCard.__proto__||Object.getPrototypeOf(TeamCard)).call.apply(_ref,[this].concat(args))),_this),_this.state={active:false},_this.handlerClick=function(){_this.setState({active:!_this.state.active});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(TeamCard,[{key:'render',value:function render(){var user=this.props.user;var active=this.state.active;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'team-line team '+Object(__WEBPACK_IMPORTED_MODULE_1__styles__["_60" /* TeamCardStyle */])(user.cover,active)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'team-inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'team-recto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'flex'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'team-picture'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'team-information'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'team-name'},' ',user.title,' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'team-job'},' ',user.job,' '),user.description&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'team-link',onClick:this.handlerClick},' Contact ')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'team-verso'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'team-close',onClick:this.handlerClick}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'team-name'},' ',user.title,' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'team-job'},' ',user.job,' '),user.description&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'team-description',dangerouslySetInnerHTML:{__html:user.description}}))));}}]);return TeamCard;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (TeamCard);

/***/ }),
/* 542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(8);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Quantity=function(_Component){_inherits(Quantity,_Component);function Quantity(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Quantity);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Quantity.__proto__||Object.getPrototypeOf(Quantity)).call.apply(_ref,[this].concat(args))),_this),_this.state={qty:0},_this.moreQty=function(e){e.preventDefault();_this.setState({qty:_this.state.qty+1},function(){_this.callBack();});},_this.lessQty=function(e){e.preventDefault();_this.setState({qty:_this.state.qty>0?_this.state.qty-1:0},function(){_this.callBack();});},_this.callBack=function(){_this.props.updateQty(_this.state.qty,_this.props.id);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Quantity,[{key:'componentDidMount',value:function componentDidMount(){this.setState({qty:this.props.qty});}},{key:'render',value:function render(){var qty=this.state.qty;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'flex '+__WEBPACK_IMPORTED_MODULE_1__styles__["_28" /* QuantityStyle */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'qty-less',onClick:this.lessQty}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'qty-number'},qty),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'qty-more',onClick:this.moreQty}));}}]);return Quantity;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function(_ref2){var Session=_ref2.Session;return{role:Session.role};})(Quantity));

/***/ }),
/* 543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__static_default_picture_RM_jpg__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__static_default_picture_RM_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__static_default_picture_RM_jpg__);
/* unused harmony default export */ var _unused_webpack_default_export = (function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_1__static_default_picture_RM_jpg___default.a,alt:'Richard Mille - default picture'});});

/***/ }),
/* 544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2____ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AlertCard=function(_Component){_inherits(AlertCard,_Component);function AlertCard(){_classCallCheck(this,AlertCard);return _possibleConstructorReturn(this,(AlertCard.__proto__||Object.getPrototypeOf(AlertCard)).apply(this,arguments));}_createClass(AlertCard,[{key:'render',value:function render(){var _props=this.props,slug=_props.slug,title=_props.title,slug_bookmark=_props.slug_bookmark,type=_props.type,is_bookmark=_props.is_bookmark;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:'/user/alerts'+slug,className:' '+__WEBPACK_IMPORTED_MODULE_3__styles__["C" /* CounterfeitsCardStyle */]+' counterfeit flex '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'counterfeit-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2____["b" /* Alert */],{width:24,height:24}),' ',title,' '),slug_bookmark&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'counterfeit-bookmark'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2____["j" /* BookmarkButton */],{item:{slug_bookmark:slug_bookmark,type:type},is_bookmark:is_bookmark})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'counterfeit-link'},' Read more '));}}]);return AlertCard;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (AlertCard);

/***/ }),
/* 545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Event=function(_Component){_inherits(Event,_Component);function Event(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Event);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Event.__proto__||Object.getPrototypeOf(Event)).call.apply(_ref,[this].concat(args))),_this),_this.state={open:false},_this.handlerClick=function(e){e.preventDefault();_this.setState({open:!_this.state.open});},_this.getDayNumber=function(date){return date.slice(8,10);},_this.getDayWeeks=function(date){var day=__WEBPACK_IMPORTED_MODULE_1_moment__(date).day();var weeks=["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"];return weeks[day];},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Event,[{key:'render',value:function render(){var _props=this.props,date_start=_props.date_start,date_end=_props.date_end,hour=_props.hour,content_preview=_props.content_preview,content_top=_props.content_top,content_bottom=_props.content_bottom,cover=_props.cover,title=_props.title;var open=this.state.open;var now=__WEBPACK_IMPORTED_MODULE_1_moment__().get('date');var max=__WEBPACK_IMPORTED_MODULE_1_moment__().daysInMonth();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'event '+Object(__WEBPACK_IMPORTED_MODULE_2__styles__["I" /* EventStyle */])(cover)+' flex',onClick:this.handlerClick},date_start==date_end&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'event-day'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'number'},this.getDayNumber(date_start)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'day'},this.getDayWeeks(date_start)),hour&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'hour'},hour,':00')),date_start!=date_end&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'event-day'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'number'},__WEBPACK_IMPORTED_MODULE_1_moment__(date_start).format('MM-DD')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'day'},'to'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'number'},__WEBPACK_IMPORTED_MODULE_1_moment__(date_end).format('MM-DD'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'event-info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'event-title'},title),!open&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'event-description',dangerouslySetInnerHTML:{'__html':content_preview}}),open&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,content_top&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'event-description',dangerouslySetInnerHTML:{'__html':content_top}}),cover&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'event-picture'}),content_bottom&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'event-description',dangerouslySetInnerHTML:{'__html':content_bottom}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'event-link'},!open&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'link'},'Read more'),open&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'close'})));}}]);return Event;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Event);

/***/ }),
/* 546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_flickity__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_flickity___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_flickity__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FlickitySlider=function(_Component){_inherits(FlickitySlider,_Component);function FlickitySlider(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,FlickitySlider);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=FlickitySlider.__proto__||Object.getPrototypeOf(FlickitySlider)).call.apply(_ref,[this].concat(args))),_this),_this.state={ready:false,slides:[]},_this.initFlickity=function(){_this.flkty=new __WEBPACK_IMPORTED_MODULE_2_flickity___default.a(_this.sliderProduct,Object.assign({lazyLoad:1},_this.props.options));_this.slides=document.querySelectorAll('.product-template');_this.bottom=window.innerWidth>1024?80:70;_this.viewport=_this.sliderProduct.querySelector('.flickity-viewport');if(_this.slides[0]&&_this.slides[0].querySelector('.template-scroll')){_this.viewport.style.height=_this.slides[0].querySelector('.template-scroll').offsetHeight+_this.bottom+'px';}_this.onChange();},_this.onChange=function(){_this.flkty.on('change',function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(index){var scrollTemplate;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_this.props.callback(index);scrollTemplate=_this.slides[index].querySelector('.template-scroll');if(_this.slides[index]&&scrollTemplate){_this.viewport.style.height=scrollTemplate.offsetHeight+_this.bottom+'px';}document.querySelector('.app-body').scrollIntoView();case 4:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref2.apply(this,arguments);};}());},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(FlickitySlider,[{key:'componentDidMount',value:function componentDidMount(){this.initFlickity();}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(_ref3){var _this3=this;var active=_ref3.active,ready=_ref3.ready;if(active!==this.props.active){this.flkty.select(active);}if(ready!==this.props.ready&&ready&&active===0){clearTimeout(this.timer);if(this.flkty)this.flkty.destroy();this.timer=setTimeout(function(){_this3.initFlickity();},200);}}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.flkty.destroy();clearTimeout(this.timer);}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(_ref4){var active=_ref4.active,ready=_ref4.ready;return ready!==this.props.ready||active!==this.props.active;}},{key:'render',value:function render(){var _this4=this;var _props=this.props,children=_props.children,className=_props.className;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:className,ref:function ref(flickity){return _this4.sliderProduct=flickity;}},children);}}]);return FlickitySlider;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (FlickitySlider);

/***/ }),
/* 547 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(1);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var slug_bookmark=_ref.slug_bookmark,type=_ref.type,is_bookmark=_ref.is_bookmark,pdf=_ref.pdf,next=_ref.next,previous=_ref.previous;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:''+Object(__WEBPACK_IMPORTED_MODULE_2__styles__["d" /* ArticleNavStyle */])(pdf&&pdf.length>0,previous&&next)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1____["_0" /* ReturnButton */],null),slug_bookmark&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1____["j" /* BookmarkButton */],{item:{slug_bookmark:slug_bookmark,type:type},is_bookmark:is_bookmark,big:true}),pdf&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1____["M" /* PDFButton */],{big:true,pdfs:pdf}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pdf-annotation'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1____["d" /* Arrow */],{width:24,height:24}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Click here to download the PDF'))),previous&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:previous,className:'btn btn__arrow btn__arrow--previous'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1____["f" /* ArrowDrop */],{width:24,height:24})),next&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:next,className:'btn btn__arrow btn__arrow--next'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1____["f" /* ArrowDrop */],{width:24,height:24})));});

/***/ }),
/* 548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_hammerjs__ = __webpack_require__(549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_hammerjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_hammerjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Pan=function(_Component){_inherits(Pan,_Component);function Pan(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Pan);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Pan.__proto__||Object.getPrototypeOf(Pan)).call.apply(_ref,[this].concat(args))),_this),_this.state={x:window.innerWidth,tX:0,step:200,enable:false},_this.resize=Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["throttle"])(function(){_this.setState({x:window.innerWidth,enable:window.innerWidth<_this.elt.querySelector('ul').scrollWidth});},400),_this.onPan=function(event){event.stopPropagation();var _this$state=_this.state,x=_this$state.x,tX=_this$state.tX,step=_this$state.step;var panWidth=_this.elt.querySelector('ul').scrollWidth;var n=tX;if(x<panWidth){if(event.additionalEvent==='panleft')n=panWidth+tX<=x?tX:n-step;else n=tX===0?0:n+step;_this.setState({tX:n});}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Pan,[{key:'componentDidMount',value:function componentDidMount(){this.setState({enable:this.state.x<this.elt.querySelector('ul').scrollWidth});window.addEventListener('resize',this.resize);}},{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener('resize',this.resize);}},{key:'render',value:function render(){var _this2=this;var children=this.props.children;var _state=this.state,tX=_state.tX,enable=_state.enable;return(// <Hammer onPanEnd={this.onPan}>
__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pan '+Object(__WEBPACK_IMPORTED_MODULE_3__styles__["_16" /* PanStyle */])(tX,enable)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pan-inner',ref:function ref(elt){return _this2.elt=elt;}},children))// </Hammer>
);}}]);return Pan;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Pan);

/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);
var ReactDOM = __webpack_require__(49);

// require('hammerjs') when in a browser. This is safe because Hammer is only
// invoked in componentDidMount, which is not executed on the server.
var Hammer = (typeof window !== 'undefined') ? __webpack_require__(550) : undefined;

var privateProps = {
	children: true,
	direction: true,
	options: true,
	recognizeWith: true,
	vertical: true,
};

/**
 * Hammer Component
 * ================
 */

var handlerToEvent = {
	action: 'tap press',
	onDoubleTap: 'doubletap',
	onPan: 'pan',
	onPanCancel: 'pancancel',
	onPanEnd: 'panend',
	onPanStart: 'panstart',
	onPinch: 'pinch',
	onPinchCancel: 'pinchcancel',
	onPinchEnd: 'pinchend',
	onPinchIn: 'pinchin',
	onPinchOut: 'pinchout',
	onPinchStart: 'pinchstart',
	onPress: 'press',
	onPressUp: 'pressup',
	onRotate: 'rotate',
	onRotateCancel: 'rotatecancel',
	onRotateEnd: 'rotateend',
	onRotateMove: 'rotatemove',
	onRotateStart: 'rotatestart',
	onSwipe: 'swipe',
	onTap: 'tap',
};

Object.keys(handlerToEvent).forEach(function (i) {
	privateProps[i] = true;
});

function updateHammer (hammer, props) {
	if (props.hasOwnProperty('vertical')) {
		console.warn('vertical is deprecated, please use `direction` instead');
	}

	var directionProp = props.direction;
	if (directionProp || props.hasOwnProperty('vertical')) {
		direction = directionProp ? directionProp : (props.vertical ? 'DIRECTION_ALL' : 'DIRECTION_HORIZONTAL');
		hammer.get('pan').set({ direction: Hammer[direction] });
		hammer.get('swipe').set({ direction: Hammer[direction] });
	}

	if (props.options) {
		Object.keys(props.options).forEach(function (option) {
			if (option === 'recognizers') {
				Object.keys(props.options.recognizers).forEach(function (gesture) {
					var recognizer = hammer.get(gesture);
					recognizer.set(props.options.recognizers[gesture]);
				}, this);
			} else {
				var key = option;
				var optionObj = {};
				optionObj[key] = props.options[option];
				hammer.set(optionObj);
			}
		}, this);
	}

	if (props.recognizeWith) {
		Object.keys(props.recognizeWith).forEach(function (gesture) {
			var recognizer = hammer.get(gesture);
			recognizer.recognizeWith(props.recognizeWith[gesture]);
		}, this);
	}

	Object.keys(props).forEach(function (p) {
		var e = handlerToEvent[p];
		if (e) {
			hammer.off(e);
			hammer.on(e, props[p]);
		}
	});
}

var HammerComponent = React.createClass({

	displayName: 'Hammer',

	propTypes: {
		className: React.PropTypes.string,
	},

	componentDidMount: function () {
		this.hammer = new Hammer(ReactDOM.findDOMNode(this));
		updateHammer(this.hammer, this.props);
	},

	componentDidUpdate: function () {
		if (this.hammer) {
			updateHammer(this.hammer, this.props);
		}
	},

	componentWillUnmount: function () {
		if (this.hammer) {
			this.hammer.stop();
			this.hammer.destroy();
		}
		this.hammer = null;
	},

	render: function () {
		var props = {};

		Object.keys(this.props).forEach(function (i) {
			if (!privateProps[i]) {
				props[i] = this.props[i];
			}
		}, this);

		// Reuse the child provided
		// This makes it flexible to use whatever element is wanted (div, ul, etc)
		return React.cloneElement(React.Children.only(this.props.children), props);
	}
});

module.exports = HammerComponent;


/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*! Hammer.JS - v2.0.7 - 2016-04-22
 * http://hammerjs.github.io/
 *
 * Copyright (c) 2016 Jorik Tangelder;
 * Licensed under the MIT license */
(function(window, document, exportName, undefined) {
  'use strict';

var VENDOR_PREFIXES = ['', 'webkit', 'Moz', 'MS', 'ms', 'o'];
var TEST_ELEMENT = document.createElement('div');

var TYPE_FUNCTION = 'function';

var round = Math.round;
var abs = Math.abs;
var now = Date.now;

/**
 * set a timeout with a given scope
 * @param {Function} fn
 * @param {Number} timeout
 * @param {Object} context
 * @returns {number}
 */
function setTimeoutContext(fn, timeout, context) {
    return setTimeout(bindFn(fn, context), timeout);
}

/**
 * if the argument is an array, we want to execute the fn on each entry
 * if it aint an array we don't want to do a thing.
 * this is used by all the methods that accept a single and array argument.
 * @param {*|Array} arg
 * @param {String} fn
 * @param {Object} [context]
 * @returns {Boolean}
 */
function invokeArrayArg(arg, fn, context) {
    if (Array.isArray(arg)) {
        each(arg, context[fn], context);
        return true;
    }
    return false;
}

/**
 * walk objects and arrays
 * @param {Object} obj
 * @param {Function} iterator
 * @param {Object} context
 */
function each(obj, iterator, context) {
    var i;

    if (!obj) {
        return;
    }

    if (obj.forEach) {
        obj.forEach(iterator, context);
    } else if (obj.length !== undefined) {
        i = 0;
        while (i < obj.length) {
            iterator.call(context, obj[i], i, obj);
            i++;
        }
    } else {
        for (i in obj) {
            obj.hasOwnProperty(i) && iterator.call(context, obj[i], i, obj);
        }
    }
}

/**
 * wrap a method with a deprecation warning and stack trace
 * @param {Function} method
 * @param {String} name
 * @param {String} message
 * @returns {Function} A new function wrapping the supplied method.
 */
function deprecate(method, name, message) {
    var deprecationMessage = 'DEPRECATED METHOD: ' + name + '\n' + message + ' AT \n';
    return function() {
        var e = new Error('get-stack-trace');
        var stack = e && e.stack ? e.stack.replace(/^[^\(]+?[\n$]/gm, '')
            .replace(/^\s+at\s+/gm, '')
            .replace(/^Object.<anonymous>\s*\(/gm, '{anonymous}()@') : 'Unknown Stack Trace';

        var log = window.console && (window.console.warn || window.console.log);
        if (log) {
            log.call(window.console, deprecationMessage, stack);
        }
        return method.apply(this, arguments);
    };
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} target
 * @param {...Object} objects_to_assign
 * @returns {Object} target
 */
var assign;
if (typeof Object.assign !== 'function') {
    assign = function assign(target) {
        if (target === undefined || target === null) {
            throw new TypeError('Cannot convert undefined or null to object');
        }

        var output = Object(target);
        for (var index = 1; index < arguments.length; index++) {
            var source = arguments[index];
            if (source !== undefined && source !== null) {
                for (var nextKey in source) {
                    if (source.hasOwnProperty(nextKey)) {
                        output[nextKey] = source[nextKey];
                    }
                }
            }
        }
        return output;
    };
} else {
    assign = Object.assign;
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} dest
 * @param {Object} src
 * @param {Boolean} [merge=false]
 * @returns {Object} dest
 */
var extend = deprecate(function extend(dest, src, merge) {
    var keys = Object.keys(src);
    var i = 0;
    while (i < keys.length) {
        if (!merge || (merge && dest[keys[i]] === undefined)) {
            dest[keys[i]] = src[keys[i]];
        }
        i++;
    }
    return dest;
}, 'extend', 'Use `assign`.');

/**
 * merge the values from src in the dest.
 * means that properties that exist in dest will not be overwritten by src
 * @param {Object} dest
 * @param {Object} src
 * @returns {Object} dest
 */
var merge = deprecate(function merge(dest, src) {
    return extend(dest, src, true);
}, 'merge', 'Use `assign`.');

/**
 * simple class inheritance
 * @param {Function} child
 * @param {Function} base
 * @param {Object} [properties]
 */
function inherit(child, base, properties) {
    var baseP = base.prototype,
        childP;

    childP = child.prototype = Object.create(baseP);
    childP.constructor = child;
    childP._super = baseP;

    if (properties) {
        assign(childP, properties);
    }
}

/**
 * simple function bind
 * @param {Function} fn
 * @param {Object} context
 * @returns {Function}
 */
function bindFn(fn, context) {
    return function boundFn() {
        return fn.apply(context, arguments);
    };
}

/**
 * let a boolean value also be a function that must return a boolean
 * this first item in args will be used as the context
 * @param {Boolean|Function} val
 * @param {Array} [args]
 * @returns {Boolean}
 */
function boolOrFn(val, args) {
    if (typeof val == TYPE_FUNCTION) {
        return val.apply(args ? args[0] || undefined : undefined, args);
    }
    return val;
}

/**
 * use the val2 when val1 is undefined
 * @param {*} val1
 * @param {*} val2
 * @returns {*}
 */
function ifUndefined(val1, val2) {
    return (val1 === undefined) ? val2 : val1;
}

/**
 * addEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function addEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.addEventListener(type, handler, false);
    });
}

/**
 * removeEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function removeEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.removeEventListener(type, handler, false);
    });
}

/**
 * find if a node is in the given parent
 * @method hasParent
 * @param {HTMLElement} node
 * @param {HTMLElement} parent
 * @return {Boolean} found
 */
function hasParent(node, parent) {
    while (node) {
        if (node == parent) {
            return true;
        }
        node = node.parentNode;
    }
    return false;
}

/**
 * small indexOf wrapper
 * @param {String} str
 * @param {String} find
 * @returns {Boolean} found
 */
function inStr(str, find) {
    return str.indexOf(find) > -1;
}

/**
 * split string on whitespace
 * @param {String} str
 * @returns {Array} words
 */
function splitStr(str) {
    return str.trim().split(/\s+/g);
}

/**
 * find if a array contains the object using indexOf or a simple polyFill
 * @param {Array} src
 * @param {String} find
 * @param {String} [findByKey]
 * @return {Boolean|Number} false when not found, or the index
 */
function inArray(src, find, findByKey) {
    if (src.indexOf && !findByKey) {
        return src.indexOf(find);
    } else {
        var i = 0;
        while (i < src.length) {
            if ((findByKey && src[i][findByKey] == find) || (!findByKey && src[i] === find)) {
                return i;
            }
            i++;
        }
        return -1;
    }
}

/**
 * convert array-like objects to real arrays
 * @param {Object} obj
 * @returns {Array}
 */
function toArray(obj) {
    return Array.prototype.slice.call(obj, 0);
}

/**
 * unique array with objects based on a key (like 'id') or just by the array's value
 * @param {Array} src [{id:1},{id:2},{id:1}]
 * @param {String} [key]
 * @param {Boolean} [sort=False]
 * @returns {Array} [{id:1},{id:2}]
 */
function uniqueArray(src, key, sort) {
    var results = [];
    var values = [];
    var i = 0;

    while (i < src.length) {
        var val = key ? src[i][key] : src[i];
        if (inArray(values, val) < 0) {
            results.push(src[i]);
        }
        values[i] = val;
        i++;
    }

    if (sort) {
        if (!key) {
            results = results.sort();
        } else {
            results = results.sort(function sortUniqueArray(a, b) {
                return a[key] > b[key];
            });
        }
    }

    return results;
}

/**
 * get the prefixed property
 * @param {Object} obj
 * @param {String} property
 * @returns {String|Undefined} prefixed
 */
function prefixed(obj, property) {
    var prefix, prop;
    var camelProp = property[0].toUpperCase() + property.slice(1);

    var i = 0;
    while (i < VENDOR_PREFIXES.length) {
        prefix = VENDOR_PREFIXES[i];
        prop = (prefix) ? prefix + camelProp : property;

        if (prop in obj) {
            return prop;
        }
        i++;
    }
    return undefined;
}

/**
 * get a unique id
 * @returns {number} uniqueId
 */
var _uniqueId = 1;
function uniqueId() {
    return _uniqueId++;
}

/**
 * get the window object of an element
 * @param {HTMLElement} element
 * @returns {DocumentView|Window}
 */
function getWindowForElement(element) {
    var doc = element.ownerDocument || element;
    return (doc.defaultView || doc.parentWindow || window);
}

var MOBILE_REGEX = /mobile|tablet|ip(ad|hone|od)|android/i;

var SUPPORT_TOUCH = ('ontouchstart' in window);
var SUPPORT_POINTER_EVENTS = prefixed(window, 'PointerEvent') !== undefined;
var SUPPORT_ONLY_TOUCH = SUPPORT_TOUCH && MOBILE_REGEX.test(navigator.userAgent);

var INPUT_TYPE_TOUCH = 'touch';
var INPUT_TYPE_PEN = 'pen';
var INPUT_TYPE_MOUSE = 'mouse';
var INPUT_TYPE_KINECT = 'kinect';

var COMPUTE_INTERVAL = 25;

var INPUT_START = 1;
var INPUT_MOVE = 2;
var INPUT_END = 4;
var INPUT_CANCEL = 8;

var DIRECTION_NONE = 1;
var DIRECTION_LEFT = 2;
var DIRECTION_RIGHT = 4;
var DIRECTION_UP = 8;
var DIRECTION_DOWN = 16;

var DIRECTION_HORIZONTAL = DIRECTION_LEFT | DIRECTION_RIGHT;
var DIRECTION_VERTICAL = DIRECTION_UP | DIRECTION_DOWN;
var DIRECTION_ALL = DIRECTION_HORIZONTAL | DIRECTION_VERTICAL;

var PROPS_XY = ['x', 'y'];
var PROPS_CLIENT_XY = ['clientX', 'clientY'];

/**
 * create new input type manager
 * @param {Manager} manager
 * @param {Function} callback
 * @returns {Input}
 * @constructor
 */
function Input(manager, callback) {
    var self = this;
    this.manager = manager;
    this.callback = callback;
    this.element = manager.element;
    this.target = manager.options.inputTarget;

    // smaller wrapper around the handler, for the scope and the enabled state of the manager,
    // so when disabled the input events are completely bypassed.
    this.domHandler = function(ev) {
        if (boolOrFn(manager.options.enable, [manager])) {
            self.handler(ev);
        }
    };

    this.init();

}

Input.prototype = {
    /**
     * should handle the inputEvent data and trigger the callback
     * @virtual
     */
    handler: function() { },

    /**
     * bind the events
     */
    init: function() {
        this.evEl && addEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && addEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && addEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    },

    /**
     * unbind the events
     */
    destroy: function() {
        this.evEl && removeEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && removeEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && removeEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    }
};

/**
 * create new input type manager
 * called by the Manager constructor
 * @param {Hammer} manager
 * @returns {Input}
 */
function createInputInstance(manager) {
    var Type;
    var inputClass = manager.options.inputClass;

    if (inputClass) {
        Type = inputClass;
    } else if (SUPPORT_POINTER_EVENTS) {
        Type = PointerEventInput;
    } else if (SUPPORT_ONLY_TOUCH) {
        Type = TouchInput;
    } else if (!SUPPORT_TOUCH) {
        Type = MouseInput;
    } else {
        Type = TouchMouseInput;
    }
    return new (Type)(manager, inputHandler);
}

/**
 * handle input events
 * @param {Manager} manager
 * @param {String} eventType
 * @param {Object} input
 */
function inputHandler(manager, eventType, input) {
    var pointersLen = input.pointers.length;
    var changedPointersLen = input.changedPointers.length;
    var isFirst = (eventType & INPUT_START && (pointersLen - changedPointersLen === 0));
    var isFinal = (eventType & (INPUT_END | INPUT_CANCEL) && (pointersLen - changedPointersLen === 0));

    input.isFirst = !!isFirst;
    input.isFinal = !!isFinal;

    if (isFirst) {
        manager.session = {};
    }

    // source event is the normalized value of the domEvents
    // like 'touchstart, mouseup, pointerdown'
    input.eventType = eventType;

    // compute scale, rotation etc
    computeInputData(manager, input);

    // emit secret event
    manager.emit('hammer.input', input);

    manager.recognize(input);
    manager.session.prevInput = input;
}

/**
 * extend the data with some usable properties like scale, rotate, velocity etc
 * @param {Object} manager
 * @param {Object} input
 */
function computeInputData(manager, input) {
    var session = manager.session;
    var pointers = input.pointers;
    var pointersLength = pointers.length;

    // store the first input to calculate the distance and direction
    if (!session.firstInput) {
        session.firstInput = simpleCloneInputData(input);
    }

    // to compute scale and rotation we need to store the multiple touches
    if (pointersLength > 1 && !session.firstMultiple) {
        session.firstMultiple = simpleCloneInputData(input);
    } else if (pointersLength === 1) {
        session.firstMultiple = false;
    }

    var firstInput = session.firstInput;
    var firstMultiple = session.firstMultiple;
    var offsetCenter = firstMultiple ? firstMultiple.center : firstInput.center;

    var center = input.center = getCenter(pointers);
    input.timeStamp = now();
    input.deltaTime = input.timeStamp - firstInput.timeStamp;

    input.angle = getAngle(offsetCenter, center);
    input.distance = getDistance(offsetCenter, center);

    computeDeltaXY(session, input);
    input.offsetDirection = getDirection(input.deltaX, input.deltaY);

    var overallVelocity = getVelocity(input.deltaTime, input.deltaX, input.deltaY);
    input.overallVelocityX = overallVelocity.x;
    input.overallVelocityY = overallVelocity.y;
    input.overallVelocity = (abs(overallVelocity.x) > abs(overallVelocity.y)) ? overallVelocity.x : overallVelocity.y;

    input.scale = firstMultiple ? getScale(firstMultiple.pointers, pointers) : 1;
    input.rotation = firstMultiple ? getRotation(firstMultiple.pointers, pointers) : 0;

    input.maxPointers = !session.prevInput ? input.pointers.length : ((input.pointers.length >
        session.prevInput.maxPointers) ? input.pointers.length : session.prevInput.maxPointers);

    computeIntervalInputData(session, input);

    // find the correct target
    var target = manager.element;
    if (hasParent(input.srcEvent.target, target)) {
        target = input.srcEvent.target;
    }
    input.target = target;
}

function computeDeltaXY(session, input) {
    var center = input.center;
    var offset = session.offsetDelta || {};
    var prevDelta = session.prevDelta || {};
    var prevInput = session.prevInput || {};

    if (input.eventType === INPUT_START || prevInput.eventType === INPUT_END) {
        prevDelta = session.prevDelta = {
            x: prevInput.deltaX || 0,
            y: prevInput.deltaY || 0
        };

        offset = session.offsetDelta = {
            x: center.x,
            y: center.y
        };
    }

    input.deltaX = prevDelta.x + (center.x - offset.x);
    input.deltaY = prevDelta.y + (center.y - offset.y);
}

/**
 * velocity is calculated every x ms
 * @param {Object} session
 * @param {Object} input
 */
function computeIntervalInputData(session, input) {
    var last = session.lastInterval || input,
        deltaTime = input.timeStamp - last.timeStamp,
        velocity, velocityX, velocityY, direction;

    if (input.eventType != INPUT_CANCEL && (deltaTime > COMPUTE_INTERVAL || last.velocity === undefined)) {
        var deltaX = input.deltaX - last.deltaX;
        var deltaY = input.deltaY - last.deltaY;

        var v = getVelocity(deltaTime, deltaX, deltaY);
        velocityX = v.x;
        velocityY = v.y;
        velocity = (abs(v.x) > abs(v.y)) ? v.x : v.y;
        direction = getDirection(deltaX, deltaY);

        session.lastInterval = input;
    } else {
        // use latest velocity info if it doesn't overtake a minimum period
        velocity = last.velocity;
        velocityX = last.velocityX;
        velocityY = last.velocityY;
        direction = last.direction;
    }

    input.velocity = velocity;
    input.velocityX = velocityX;
    input.velocityY = velocityY;
    input.direction = direction;
}

/**
 * create a simple clone from the input used for storage of firstInput and firstMultiple
 * @param {Object} input
 * @returns {Object} clonedInputData
 */
function simpleCloneInputData(input) {
    // make a simple copy of the pointers because we will get a reference if we don't
    // we only need clientXY for the calculations
    var pointers = [];
    var i = 0;
    while (i < input.pointers.length) {
        pointers[i] = {
            clientX: round(input.pointers[i].clientX),
            clientY: round(input.pointers[i].clientY)
        };
        i++;
    }

    return {
        timeStamp: now(),
        pointers: pointers,
        center: getCenter(pointers),
        deltaX: input.deltaX,
        deltaY: input.deltaY
    };
}

/**
 * get the center of all the pointers
 * @param {Array} pointers
 * @return {Object} center contains `x` and `y` properties
 */
function getCenter(pointers) {
    var pointersLength = pointers.length;

    // no need to loop when only one touch
    if (pointersLength === 1) {
        return {
            x: round(pointers[0].clientX),
            y: round(pointers[0].clientY)
        };
    }

    var x = 0, y = 0, i = 0;
    while (i < pointersLength) {
        x += pointers[i].clientX;
        y += pointers[i].clientY;
        i++;
    }

    return {
        x: round(x / pointersLength),
        y: round(y / pointersLength)
    };
}

/**
 * calculate the velocity between two points. unit is in px per ms.
 * @param {Number} deltaTime
 * @param {Number} x
 * @param {Number} y
 * @return {Object} velocity `x` and `y`
 */
function getVelocity(deltaTime, x, y) {
    return {
        x: x / deltaTime || 0,
        y: y / deltaTime || 0
    };
}

/**
 * get the direction between two points
 * @param {Number} x
 * @param {Number} y
 * @return {Number} direction
 */
function getDirection(x, y) {
    if (x === y) {
        return DIRECTION_NONE;
    }

    if (abs(x) >= abs(y)) {
        return x < 0 ? DIRECTION_LEFT : DIRECTION_RIGHT;
    }
    return y < 0 ? DIRECTION_UP : DIRECTION_DOWN;
}

/**
 * calculate the absolute distance between two points
 * @param {Object} p1 {x, y}
 * @param {Object} p2 {x, y}
 * @param {Array} [props] containing x and y keys
 * @return {Number} distance
 */
function getDistance(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];

    return Math.sqrt((x * x) + (y * y));
}

/**
 * calculate the angle between two coordinates
 * @param {Object} p1
 * @param {Object} p2
 * @param {Array} [props] containing x and y keys
 * @return {Number} angle
 */
function getAngle(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];
    return Math.atan2(y, x) * 180 / Math.PI;
}

/**
 * calculate the rotation degrees between two pointersets
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} rotation
 */
function getRotation(start, end) {
    return getAngle(end[1], end[0], PROPS_CLIENT_XY) + getAngle(start[1], start[0], PROPS_CLIENT_XY);
}

/**
 * calculate the scale factor between two pointersets
 * no scale is 1, and goes down to 0 when pinched together, and bigger when pinched out
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} scale
 */
function getScale(start, end) {
    return getDistance(end[0], end[1], PROPS_CLIENT_XY) / getDistance(start[0], start[1], PROPS_CLIENT_XY);
}

var MOUSE_INPUT_MAP = {
    mousedown: INPUT_START,
    mousemove: INPUT_MOVE,
    mouseup: INPUT_END
};

var MOUSE_ELEMENT_EVENTS = 'mousedown';
var MOUSE_WINDOW_EVENTS = 'mousemove mouseup';

/**
 * Mouse events input
 * @constructor
 * @extends Input
 */
function MouseInput() {
    this.evEl = MOUSE_ELEMENT_EVENTS;
    this.evWin = MOUSE_WINDOW_EVENTS;

    this.pressed = false; // mousedown state

    Input.apply(this, arguments);
}

inherit(MouseInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function MEhandler(ev) {
        var eventType = MOUSE_INPUT_MAP[ev.type];

        // on start we want to have the left mouse button down
        if (eventType & INPUT_START && ev.button === 0) {
            this.pressed = true;
        }

        if (eventType & INPUT_MOVE && ev.which !== 1) {
            eventType = INPUT_END;
        }

        // mouse must be down
        if (!this.pressed) {
            return;
        }

        if (eventType & INPUT_END) {
            this.pressed = false;
        }

        this.callback(this.manager, eventType, {
            pointers: [ev],
            changedPointers: [ev],
            pointerType: INPUT_TYPE_MOUSE,
            srcEvent: ev
        });
    }
});

var POINTER_INPUT_MAP = {
    pointerdown: INPUT_START,
    pointermove: INPUT_MOVE,
    pointerup: INPUT_END,
    pointercancel: INPUT_CANCEL,
    pointerout: INPUT_CANCEL
};

// in IE10 the pointer types is defined as an enum
var IE10_POINTER_TYPE_ENUM = {
    2: INPUT_TYPE_TOUCH,
    3: INPUT_TYPE_PEN,
    4: INPUT_TYPE_MOUSE,
    5: INPUT_TYPE_KINECT // see https://twitter.com/jacobrossi/status/480596438489890816
};

var POINTER_ELEMENT_EVENTS = 'pointerdown';
var POINTER_WINDOW_EVENTS = 'pointermove pointerup pointercancel';

// IE10 has prefixed support, and case-sensitive
if (window.MSPointerEvent && !window.PointerEvent) {
    POINTER_ELEMENT_EVENTS = 'MSPointerDown';
    POINTER_WINDOW_EVENTS = 'MSPointerMove MSPointerUp MSPointerCancel';
}

/**
 * Pointer events input
 * @constructor
 * @extends Input
 */
function PointerEventInput() {
    this.evEl = POINTER_ELEMENT_EVENTS;
    this.evWin = POINTER_WINDOW_EVENTS;

    Input.apply(this, arguments);

    this.store = (this.manager.session.pointerEvents = []);
}

inherit(PointerEventInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function PEhandler(ev) {
        var store = this.store;
        var removePointer = false;

        var eventTypeNormalized = ev.type.toLowerCase().replace('ms', '');
        var eventType = POINTER_INPUT_MAP[eventTypeNormalized];
        var pointerType = IE10_POINTER_TYPE_ENUM[ev.pointerType] || ev.pointerType;

        var isTouch = (pointerType == INPUT_TYPE_TOUCH);

        // get index of the event in the store
        var storeIndex = inArray(store, ev.pointerId, 'pointerId');

        // start and mouse must be down
        if (eventType & INPUT_START && (ev.button === 0 || isTouch)) {
            if (storeIndex < 0) {
                store.push(ev);
                storeIndex = store.length - 1;
            }
        } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
            removePointer = true;
        }

        // it not found, so the pointer hasn't been down (so it's probably a hover)
        if (storeIndex < 0) {
            return;
        }

        // update the event in the store
        store[storeIndex] = ev;

        this.callback(this.manager, eventType, {
            pointers: store,
            changedPointers: [ev],
            pointerType: pointerType,
            srcEvent: ev
        });

        if (removePointer) {
            // remove from the store
            store.splice(storeIndex, 1);
        }
    }
});

var SINGLE_TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var SINGLE_TOUCH_TARGET_EVENTS = 'touchstart';
var SINGLE_TOUCH_WINDOW_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Touch events input
 * @constructor
 * @extends Input
 */
function SingleTouchInput() {
    this.evTarget = SINGLE_TOUCH_TARGET_EVENTS;
    this.evWin = SINGLE_TOUCH_WINDOW_EVENTS;
    this.started = false;

    Input.apply(this, arguments);
}

inherit(SingleTouchInput, Input, {
    handler: function TEhandler(ev) {
        var type = SINGLE_TOUCH_INPUT_MAP[ev.type];

        // should we handle the touch events?
        if (type === INPUT_START) {
            this.started = true;
        }

        if (!this.started) {
            return;
        }

        var touches = normalizeSingleTouches.call(this, ev, type);

        // when done, reset the started state
        if (type & (INPUT_END | INPUT_CANCEL) && touches[0].length - touches[1].length === 0) {
            this.started = false;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function normalizeSingleTouches(ev, type) {
    var all = toArray(ev.touches);
    var changed = toArray(ev.changedTouches);

    if (type & (INPUT_END | INPUT_CANCEL)) {
        all = uniqueArray(all.concat(changed), 'identifier', true);
    }

    return [all, changed];
}

var TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var TOUCH_TARGET_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Multi-user touch events input
 * @constructor
 * @extends Input
 */
function TouchInput() {
    this.evTarget = TOUCH_TARGET_EVENTS;
    this.targetIds = {};

    Input.apply(this, arguments);
}

inherit(TouchInput, Input, {
    handler: function MTEhandler(ev) {
        var type = TOUCH_INPUT_MAP[ev.type];
        var touches = getTouches.call(this, ev, type);
        if (!touches) {
            return;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function getTouches(ev, type) {
    var allTouches = toArray(ev.touches);
    var targetIds = this.targetIds;

    // when there is only one touch, the process can be simplified
    if (type & (INPUT_START | INPUT_MOVE) && allTouches.length === 1) {
        targetIds[allTouches[0].identifier] = true;
        return [allTouches, allTouches];
    }

    var i,
        targetTouches,
        changedTouches = toArray(ev.changedTouches),
        changedTargetTouches = [],
        target = this.target;

    // get target touches from touches
    targetTouches = allTouches.filter(function(touch) {
        return hasParent(touch.target, target);
    });

    // collect touches
    if (type === INPUT_START) {
        i = 0;
        while (i < targetTouches.length) {
            targetIds[targetTouches[i].identifier] = true;
            i++;
        }
    }

    // filter changed touches to only contain touches that exist in the collected target ids
    i = 0;
    while (i < changedTouches.length) {
        if (targetIds[changedTouches[i].identifier]) {
            changedTargetTouches.push(changedTouches[i]);
        }

        // cleanup removed touches
        if (type & (INPUT_END | INPUT_CANCEL)) {
            delete targetIds[changedTouches[i].identifier];
        }
        i++;
    }

    if (!changedTargetTouches.length) {
        return;
    }

    return [
        // merge targetTouches with changedTargetTouches so it contains ALL touches, including 'end' and 'cancel'
        uniqueArray(targetTouches.concat(changedTargetTouches), 'identifier', true),
        changedTargetTouches
    ];
}

/**
 * Combined touch and mouse input
 *
 * Touch has a higher priority then mouse, and while touching no mouse events are allowed.
 * This because touch devices also emit mouse events while doing a touch.
 *
 * @constructor
 * @extends Input
 */

var DEDUP_TIMEOUT = 2500;
var DEDUP_DISTANCE = 25;

function TouchMouseInput() {
    Input.apply(this, arguments);

    var handler = bindFn(this.handler, this);
    this.touch = new TouchInput(this.manager, handler);
    this.mouse = new MouseInput(this.manager, handler);

    this.primaryTouch = null;
    this.lastTouches = [];
}

inherit(TouchMouseInput, Input, {
    /**
     * handle mouse and touch events
     * @param {Hammer} manager
     * @param {String} inputEvent
     * @param {Object} inputData
     */
    handler: function TMEhandler(manager, inputEvent, inputData) {
        var isTouch = (inputData.pointerType == INPUT_TYPE_TOUCH),
            isMouse = (inputData.pointerType == INPUT_TYPE_MOUSE);

        if (isMouse && inputData.sourceCapabilities && inputData.sourceCapabilities.firesTouchEvents) {
            return;
        }

        // when we're in a touch event, record touches to  de-dupe synthetic mouse event
        if (isTouch) {
            recordTouches.call(this, inputEvent, inputData);
        } else if (isMouse && isSyntheticEvent.call(this, inputData)) {
            return;
        }

        this.callback(manager, inputEvent, inputData);
    },

    /**
     * remove the event listeners
     */
    destroy: function destroy() {
        this.touch.destroy();
        this.mouse.destroy();
    }
});

function recordTouches(eventType, eventData) {
    if (eventType & INPUT_START) {
        this.primaryTouch = eventData.changedPointers[0].identifier;
        setLastTouch.call(this, eventData);
    } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
        setLastTouch.call(this, eventData);
    }
}

function setLastTouch(eventData) {
    var touch = eventData.changedPointers[0];

    if (touch.identifier === this.primaryTouch) {
        var lastTouch = {x: touch.clientX, y: touch.clientY};
        this.lastTouches.push(lastTouch);
        var lts = this.lastTouches;
        var removeLastTouch = function() {
            var i = lts.indexOf(lastTouch);
            if (i > -1) {
                lts.splice(i, 1);
            }
        };
        setTimeout(removeLastTouch, DEDUP_TIMEOUT);
    }
}

function isSyntheticEvent(eventData) {
    var x = eventData.srcEvent.clientX, y = eventData.srcEvent.clientY;
    for (var i = 0; i < this.lastTouches.length; i++) {
        var t = this.lastTouches[i];
        var dx = Math.abs(x - t.x), dy = Math.abs(y - t.y);
        if (dx <= DEDUP_DISTANCE && dy <= DEDUP_DISTANCE) {
            return true;
        }
    }
    return false;
}

var PREFIXED_TOUCH_ACTION = prefixed(TEST_ELEMENT.style, 'touchAction');
var NATIVE_TOUCH_ACTION = PREFIXED_TOUCH_ACTION !== undefined;

// magical touchAction value
var TOUCH_ACTION_COMPUTE = 'compute';
var TOUCH_ACTION_AUTO = 'auto';
var TOUCH_ACTION_MANIPULATION = 'manipulation'; // not implemented
var TOUCH_ACTION_NONE = 'none';
var TOUCH_ACTION_PAN_X = 'pan-x';
var TOUCH_ACTION_PAN_Y = 'pan-y';
var TOUCH_ACTION_MAP = getTouchActionProps();

/**
 * Touch Action
 * sets the touchAction property or uses the js alternative
 * @param {Manager} manager
 * @param {String} value
 * @constructor
 */
function TouchAction(manager, value) {
    this.manager = manager;
    this.set(value);
}

TouchAction.prototype = {
    /**
     * set the touchAction value on the element or enable the polyfill
     * @param {String} value
     */
    set: function(value) {
        // find out the touch-action by the event handlers
        if (value == TOUCH_ACTION_COMPUTE) {
            value = this.compute();
        }

        if (NATIVE_TOUCH_ACTION && this.manager.element.style && TOUCH_ACTION_MAP[value]) {
            this.manager.element.style[PREFIXED_TOUCH_ACTION] = value;
        }
        this.actions = value.toLowerCase().trim();
    },

    /**
     * just re-set the touchAction value
     */
    update: function() {
        this.set(this.manager.options.touchAction);
    },

    /**
     * compute the value for the touchAction property based on the recognizer's settings
     * @returns {String} value
     */
    compute: function() {
        var actions = [];
        each(this.manager.recognizers, function(recognizer) {
            if (boolOrFn(recognizer.options.enable, [recognizer])) {
                actions = actions.concat(recognizer.getTouchAction());
            }
        });
        return cleanTouchActions(actions.join(' '));
    },

    /**
     * this method is called on each input cycle and provides the preventing of the browser behavior
     * @param {Object} input
     */
    preventDefaults: function(input) {
        var srcEvent = input.srcEvent;
        var direction = input.offsetDirection;

        // if the touch action did prevented once this session
        if (this.manager.session.prevented) {
            srcEvent.preventDefault();
            return;
        }

        var actions = this.actions;
        var hasNone = inStr(actions, TOUCH_ACTION_NONE) && !TOUCH_ACTION_MAP[TOUCH_ACTION_NONE];
        var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_Y];
        var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_X];

        if (hasNone) {
            //do not prevent defaults if this is a tap gesture

            var isTapPointer = input.pointers.length === 1;
            var isTapMovement = input.distance < 2;
            var isTapTouchTime = input.deltaTime < 250;

            if (isTapPointer && isTapMovement && isTapTouchTime) {
                return;
            }
        }

        if (hasPanX && hasPanY) {
            // `pan-x pan-y` means browser handles all scrolling/panning, do not prevent
            return;
        }

        if (hasNone ||
            (hasPanY && direction & DIRECTION_HORIZONTAL) ||
            (hasPanX && direction & DIRECTION_VERTICAL)) {
            return this.preventSrc(srcEvent);
        }
    },

    /**
     * call preventDefault to prevent the browser's default behavior (scrolling in most cases)
     * @param {Object} srcEvent
     */
    preventSrc: function(srcEvent) {
        this.manager.session.prevented = true;
        srcEvent.preventDefault();
    }
};

/**
 * when the touchActions are collected they are not a valid value, so we need to clean things up. *
 * @param {String} actions
 * @returns {*}
 */
function cleanTouchActions(actions) {
    // none
    if (inStr(actions, TOUCH_ACTION_NONE)) {
        return TOUCH_ACTION_NONE;
    }

    var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X);
    var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y);

    // if both pan-x and pan-y are set (different recognizers
    // for different directions, e.g. horizontal pan but vertical swipe?)
    // we need none (as otherwise with pan-x pan-y combined none of these
    // recognizers will work, since the browser would handle all panning
    if (hasPanX && hasPanY) {
        return TOUCH_ACTION_NONE;
    }

    // pan-x OR pan-y
    if (hasPanX || hasPanY) {
        return hasPanX ? TOUCH_ACTION_PAN_X : TOUCH_ACTION_PAN_Y;
    }

    // manipulation
    if (inStr(actions, TOUCH_ACTION_MANIPULATION)) {
        return TOUCH_ACTION_MANIPULATION;
    }

    return TOUCH_ACTION_AUTO;
}

function getTouchActionProps() {
    if (!NATIVE_TOUCH_ACTION) {
        return false;
    }
    var touchMap = {};
    var cssSupports = window.CSS && window.CSS.supports;
    ['auto', 'manipulation', 'pan-y', 'pan-x', 'pan-x pan-y', 'none'].forEach(function(val) {

        // If css.supports is not supported but there is native touch-action assume it supports
        // all values. This is the case for IE 10 and 11.
        touchMap[val] = cssSupports ? window.CSS.supports('touch-action', val) : true;
    });
    return touchMap;
}

/**
 * Recognizer flow explained; *
 * All recognizers have the initial state of POSSIBLE when a input session starts.
 * The definition of a input session is from the first input until the last input, with all it's movement in it. *
 * Example session for mouse-input: mousedown -> mousemove -> mouseup
 *
 * On each recognizing cycle (see Manager.recognize) the .recognize() method is executed
 * which determines with state it should be.
 *
 * If the recognizer has the state FAILED, CANCELLED or RECOGNIZED (equals ENDED), it is reset to
 * POSSIBLE to give it another change on the next cycle.
 *
 *               Possible
 *                  |
 *            +-----+---------------+
 *            |                     |
 *      +-----+-----+               |
 *      |           |               |
 *   Failed      Cancelled          |
 *                          +-------+------+
 *                          |              |
 *                      Recognized       Began
 *                                         |
 *                                      Changed
 *                                         |
 *                                  Ended/Recognized
 */
var STATE_POSSIBLE = 1;
var STATE_BEGAN = 2;
var STATE_CHANGED = 4;
var STATE_ENDED = 8;
var STATE_RECOGNIZED = STATE_ENDED;
var STATE_CANCELLED = 16;
var STATE_FAILED = 32;

/**
 * Recognizer
 * Every recognizer needs to extend from this class.
 * @constructor
 * @param {Object} options
 */
function Recognizer(options) {
    this.options = assign({}, this.defaults, options || {});

    this.id = uniqueId();

    this.manager = null;

    // default is enable true
    this.options.enable = ifUndefined(this.options.enable, true);

    this.state = STATE_POSSIBLE;

    this.simultaneous = {};
    this.requireFail = [];
}

Recognizer.prototype = {
    /**
     * @virtual
     * @type {Object}
     */
    defaults: {},

    /**
     * set options
     * @param {Object} options
     * @return {Recognizer}
     */
    set: function(options) {
        assign(this.options, options);

        // also update the touchAction, in case something changed about the directions/enabled state
        this.manager && this.manager.touchAction.update();
        return this;
    },

    /**
     * recognize simultaneous with an other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    recognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'recognizeWith', this)) {
            return this;
        }

        var simultaneous = this.simultaneous;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (!simultaneous[otherRecognizer.id]) {
            simultaneous[otherRecognizer.id] = otherRecognizer;
            otherRecognizer.recognizeWith(this);
        }
        return this;
    },

    /**
     * drop the simultaneous link. it doesnt remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRecognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRecognizeWith', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        delete this.simultaneous[otherRecognizer.id];
        return this;
    },

    /**
     * recognizer can only run when an other is failing
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    requireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'requireFailure', this)) {
            return this;
        }

        var requireFail = this.requireFail;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (inArray(requireFail, otherRecognizer) === -1) {
            requireFail.push(otherRecognizer);
            otherRecognizer.requireFailure(this);
        }
        return this;
    },

    /**
     * drop the requireFailure link. it does not remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRequireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRequireFailure', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        var index = inArray(this.requireFail, otherRecognizer);
        if (index > -1) {
            this.requireFail.splice(index, 1);
        }
        return this;
    },

    /**
     * has require failures boolean
     * @returns {boolean}
     */
    hasRequireFailures: function() {
        return this.requireFail.length > 0;
    },

    /**
     * if the recognizer can recognize simultaneous with an other recognizer
     * @param {Recognizer} otherRecognizer
     * @returns {Boolean}
     */
    canRecognizeWith: function(otherRecognizer) {
        return !!this.simultaneous[otherRecognizer.id];
    },

    /**
     * You should use `tryEmit` instead of `emit` directly to check
     * that all the needed recognizers has failed before emitting.
     * @param {Object} input
     */
    emit: function(input) {
        var self = this;
        var state = this.state;

        function emit(event) {
            self.manager.emit(event, input);
        }

        // 'panstart' and 'panmove'
        if (state < STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }

        emit(self.options.event); // simple 'eventName' events

        if (input.additionalEvent) { // additional event(panleft, panright, pinchin, pinchout...)
            emit(input.additionalEvent);
        }

        // panend and pancancel
        if (state >= STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }
    },

    /**
     * Check that all the require failure recognizers has failed,
     * if true, it emits a gesture event,
     * otherwise, setup the state to FAILED.
     * @param {Object} input
     */
    tryEmit: function(input) {
        if (this.canEmit()) {
            return this.emit(input);
        }
        // it's failing anyway
        this.state = STATE_FAILED;
    },

    /**
     * can we emit?
     * @returns {boolean}
     */
    canEmit: function() {
        var i = 0;
        while (i < this.requireFail.length) {
            if (!(this.requireFail[i].state & (STATE_FAILED | STATE_POSSIBLE))) {
                return false;
            }
            i++;
        }
        return true;
    },

    /**
     * update the recognizer
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        // make a new copy of the inputData
        // so we can change the inputData without messing up the other recognizers
        var inputDataClone = assign({}, inputData);

        // is is enabled and allow recognizing?
        if (!boolOrFn(this.options.enable, [this, inputDataClone])) {
            this.reset();
            this.state = STATE_FAILED;
            return;
        }

        // reset when we've reached the end
        if (this.state & (STATE_RECOGNIZED | STATE_CANCELLED | STATE_FAILED)) {
            this.state = STATE_POSSIBLE;
        }

        this.state = this.process(inputDataClone);

        // the recognizer has recognized a gesture
        // so trigger an event
        if (this.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED | STATE_CANCELLED)) {
            this.tryEmit(inputDataClone);
        }
    },

    /**
     * return the state of the recognizer
     * the actual recognizing happens in this method
     * @virtual
     * @param {Object} inputData
     * @returns {Const} STATE
     */
    process: function(inputData) { }, // jshint ignore:line

    /**
     * return the preferred touch-action
     * @virtual
     * @returns {Array}
     */
    getTouchAction: function() { },

    /**
     * called when the gesture isn't allowed to recognize
     * like when another is being recognized or it is disabled
     * @virtual
     */
    reset: function() { }
};

/**
 * get a usable string, used as event postfix
 * @param {Const} state
 * @returns {String} state
 */
function stateStr(state) {
    if (state & STATE_CANCELLED) {
        return 'cancel';
    } else if (state & STATE_ENDED) {
        return 'end';
    } else if (state & STATE_CHANGED) {
        return 'move';
    } else if (state & STATE_BEGAN) {
        return 'start';
    }
    return '';
}

/**
 * direction cons to string
 * @param {Const} direction
 * @returns {String}
 */
function directionStr(direction) {
    if (direction == DIRECTION_DOWN) {
        return 'down';
    } else if (direction == DIRECTION_UP) {
        return 'up';
    } else if (direction == DIRECTION_LEFT) {
        return 'left';
    } else if (direction == DIRECTION_RIGHT) {
        return 'right';
    }
    return '';
}

/**
 * get a recognizer by name if it is bound to a manager
 * @param {Recognizer|String} otherRecognizer
 * @param {Recognizer} recognizer
 * @returns {Recognizer}
 */
function getRecognizerByNameIfManager(otherRecognizer, recognizer) {
    var manager = recognizer.manager;
    if (manager) {
        return manager.get(otherRecognizer);
    }
    return otherRecognizer;
}

/**
 * This recognizer is just used as a base for the simple attribute recognizers.
 * @constructor
 * @extends Recognizer
 */
function AttrRecognizer() {
    Recognizer.apply(this, arguments);
}

inherit(AttrRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof AttrRecognizer
     */
    defaults: {
        /**
         * @type {Number}
         * @default 1
         */
        pointers: 1
    },

    /**
     * Used to check if it the recognizer receives valid input, like input.distance > 10.
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {Boolean} recognized
     */
    attrTest: function(input) {
        var optionPointers = this.options.pointers;
        return optionPointers === 0 || input.pointers.length === optionPointers;
    },

    /**
     * Process the input and return the state for the recognizer
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {*} State
     */
    process: function(input) {
        var state = this.state;
        var eventType = input.eventType;

        var isRecognized = state & (STATE_BEGAN | STATE_CHANGED);
        var isValid = this.attrTest(input);

        // on cancel input and we've recognized before, return STATE_CANCELLED
        if (isRecognized && (eventType & INPUT_CANCEL || !isValid)) {
            return state | STATE_CANCELLED;
        } else if (isRecognized || isValid) {
            if (eventType & INPUT_END) {
                return state | STATE_ENDED;
            } else if (!(state & STATE_BEGAN)) {
                return STATE_BEGAN;
            }
            return state | STATE_CHANGED;
        }
        return STATE_FAILED;
    }
});

/**
 * Pan
 * Recognized when the pointer is down and moved in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function PanRecognizer() {
    AttrRecognizer.apply(this, arguments);

    this.pX = null;
    this.pY = null;
}

inherit(PanRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PanRecognizer
     */
    defaults: {
        event: 'pan',
        threshold: 10,
        pointers: 1,
        direction: DIRECTION_ALL
    },

    getTouchAction: function() {
        var direction = this.options.direction;
        var actions = [];
        if (direction & DIRECTION_HORIZONTAL) {
            actions.push(TOUCH_ACTION_PAN_Y);
        }
        if (direction & DIRECTION_VERTICAL) {
            actions.push(TOUCH_ACTION_PAN_X);
        }
        return actions;
    },

    directionTest: function(input) {
        var options = this.options;
        var hasMoved = true;
        var distance = input.distance;
        var direction = input.direction;
        var x = input.deltaX;
        var y = input.deltaY;

        // lock to axis?
        if (!(direction & options.direction)) {
            if (options.direction & DIRECTION_HORIZONTAL) {
                direction = (x === 0) ? DIRECTION_NONE : (x < 0) ? DIRECTION_LEFT : DIRECTION_RIGHT;
                hasMoved = x != this.pX;
                distance = Math.abs(input.deltaX);
            } else {
                direction = (y === 0) ? DIRECTION_NONE : (y < 0) ? DIRECTION_UP : DIRECTION_DOWN;
                hasMoved = y != this.pY;
                distance = Math.abs(input.deltaY);
            }
        }
        input.direction = direction;
        return hasMoved && distance > options.threshold && direction & options.direction;
    },

    attrTest: function(input) {
        return AttrRecognizer.prototype.attrTest.call(this, input) &&
            (this.state & STATE_BEGAN || (!(this.state & STATE_BEGAN) && this.directionTest(input)));
    },

    emit: function(input) {

        this.pX = input.deltaX;
        this.pY = input.deltaY;

        var direction = directionStr(input.direction);

        if (direction) {
            input.additionalEvent = this.options.event + direction;
        }
        this._super.emit.call(this, input);
    }
});

/**
 * Pinch
 * Recognized when two or more pointers are moving toward (zoom-in) or away from each other (zoom-out).
 * @constructor
 * @extends AttrRecognizer
 */
function PinchRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(PinchRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'pinch',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.scale - 1) > this.options.threshold || this.state & STATE_BEGAN);
    },

    emit: function(input) {
        if (input.scale !== 1) {
            var inOut = input.scale < 1 ? 'in' : 'out';
            input.additionalEvent = this.options.event + inOut;
        }
        this._super.emit.call(this, input);
    }
});

/**
 * Press
 * Recognized when the pointer is down for x ms without any movement.
 * @constructor
 * @extends Recognizer
 */
function PressRecognizer() {
    Recognizer.apply(this, arguments);

    this._timer = null;
    this._input = null;
}

inherit(PressRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PressRecognizer
     */
    defaults: {
        event: 'press',
        pointers: 1,
        time: 251, // minimal time of the pointer to be pressed
        threshold: 9 // a minimal movement is ok, but keep it low
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_AUTO];
    },

    process: function(input) {
        var options = this.options;
        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTime = input.deltaTime > options.time;

        this._input = input;

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (!validMovement || !validPointers || (input.eventType & (INPUT_END | INPUT_CANCEL) && !validTime)) {
            this.reset();
        } else if (input.eventType & INPUT_START) {
            this.reset();
            this._timer = setTimeoutContext(function() {
                this.state = STATE_RECOGNIZED;
                this.tryEmit();
            }, options.time, this);
        } else if (input.eventType & INPUT_END) {
            return STATE_RECOGNIZED;
        }
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function(input) {
        if (this.state !== STATE_RECOGNIZED) {
            return;
        }

        if (input && (input.eventType & INPUT_END)) {
            this.manager.emit(this.options.event + 'up', input);
        } else {
            this._input.timeStamp = now();
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Rotate
 * Recognized when two or more pointer are moving in a circular motion.
 * @constructor
 * @extends AttrRecognizer
 */
function RotateRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(RotateRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof RotateRecognizer
     */
    defaults: {
        event: 'rotate',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.rotation) > this.options.threshold || this.state & STATE_BEGAN);
    }
});

/**
 * Swipe
 * Recognized when the pointer is moving fast (velocity), with enough distance in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function SwipeRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(SwipeRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof SwipeRecognizer
     */
    defaults: {
        event: 'swipe',
        threshold: 10,
        velocity: 0.3,
        direction: DIRECTION_HORIZONTAL | DIRECTION_VERTICAL,
        pointers: 1
    },

    getTouchAction: function() {
        return PanRecognizer.prototype.getTouchAction.call(this);
    },

    attrTest: function(input) {
        var direction = this.options.direction;
        var velocity;

        if (direction & (DIRECTION_HORIZONTAL | DIRECTION_VERTICAL)) {
            velocity = input.overallVelocity;
        } else if (direction & DIRECTION_HORIZONTAL) {
            velocity = input.overallVelocityX;
        } else if (direction & DIRECTION_VERTICAL) {
            velocity = input.overallVelocityY;
        }

        return this._super.attrTest.call(this, input) &&
            direction & input.offsetDirection &&
            input.distance > this.options.threshold &&
            input.maxPointers == this.options.pointers &&
            abs(velocity) > this.options.velocity && input.eventType & INPUT_END;
    },

    emit: function(input) {
        var direction = directionStr(input.offsetDirection);
        if (direction) {
            this.manager.emit(this.options.event + direction, input);
        }

        this.manager.emit(this.options.event, input);
    }
});

/**
 * A tap is ecognized when the pointer is doing a small tap/click. Multiple taps are recognized if they occur
 * between the given interval and position. The delay option can be used to recognize multi-taps without firing
 * a single tap.
 *
 * The eventData from the emitted event contains the property `tapCount`, which contains the amount of
 * multi-taps being recognized.
 * @constructor
 * @extends Recognizer
 */
function TapRecognizer() {
    Recognizer.apply(this, arguments);

    // previous time and center,
    // used for tap counting
    this.pTime = false;
    this.pCenter = false;

    this._timer = null;
    this._input = null;
    this.count = 0;
}

inherit(TapRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'tap',
        pointers: 1,
        taps: 1,
        interval: 300, // max time between the multi-tap taps
        time: 250, // max time of the pointer to be down (like finger on the screen)
        threshold: 9, // a minimal movement is ok, but keep it low
        posThreshold: 10 // a multi-tap can be a bit off the initial position
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_MANIPULATION];
    },

    process: function(input) {
        var options = this.options;

        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTouchTime = input.deltaTime < options.time;

        this.reset();

        if ((input.eventType & INPUT_START) && (this.count === 0)) {
            return this.failTimeout();
        }

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (validMovement && validTouchTime && validPointers) {
            if (input.eventType != INPUT_END) {
                return this.failTimeout();
            }

            var validInterval = this.pTime ? (input.timeStamp - this.pTime < options.interval) : true;
            var validMultiTap = !this.pCenter || getDistance(this.pCenter, input.center) < options.posThreshold;

            this.pTime = input.timeStamp;
            this.pCenter = input.center;

            if (!validMultiTap || !validInterval) {
                this.count = 1;
            } else {
                this.count += 1;
            }

            this._input = input;

            // if tap count matches we have recognized it,
            // else it has began recognizing...
            var tapCount = this.count % options.taps;
            if (tapCount === 0) {
                // no failing requirements, immediately trigger the tap event
                // or wait as long as the multitap interval to trigger
                if (!this.hasRequireFailures()) {
                    return STATE_RECOGNIZED;
                } else {
                    this._timer = setTimeoutContext(function() {
                        this.state = STATE_RECOGNIZED;
                        this.tryEmit();
                    }, options.interval, this);
                    return STATE_BEGAN;
                }
            }
        }
        return STATE_FAILED;
    },

    failTimeout: function() {
        this._timer = setTimeoutContext(function() {
            this.state = STATE_FAILED;
        }, this.options.interval, this);
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function() {
        if (this.state == STATE_RECOGNIZED) {
            this._input.tapCount = this.count;
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Simple way to create a manager with a default set of recognizers.
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Hammer(element, options) {
    options = options || {};
    options.recognizers = ifUndefined(options.recognizers, Hammer.defaults.preset);
    return new Manager(element, options);
}

/**
 * @const {string}
 */
Hammer.VERSION = '2.0.7';

/**
 * default settings
 * @namespace
 */
Hammer.defaults = {
    /**
     * set if DOM events are being triggered.
     * But this is slower and unused by simple implementations, so disabled by default.
     * @type {Boolean}
     * @default false
     */
    domEvents: false,

    /**
     * The value for the touchAction property/fallback.
     * When set to `compute` it will magically set the correct value based on the added recognizers.
     * @type {String}
     * @default compute
     */
    touchAction: TOUCH_ACTION_COMPUTE,

    /**
     * @type {Boolean}
     * @default true
     */
    enable: true,

    /**
     * EXPERIMENTAL FEATURE -- can be removed/changed
     * Change the parent input target element.
     * If Null, then it is being set the to main element.
     * @type {Null|EventTarget}
     * @default null
     */
    inputTarget: null,

    /**
     * force an input class
     * @type {Null|Function}
     * @default null
     */
    inputClass: null,

    /**
     * Default recognizer setup when calling `Hammer()`
     * When creating a new Manager these will be skipped.
     * @type {Array}
     */
    preset: [
        // RecognizerClass, options, [recognizeWith, ...], [requireFailure, ...]
        [RotateRecognizer, {enable: false}],
        [PinchRecognizer, {enable: false}, ['rotate']],
        [SwipeRecognizer, {direction: DIRECTION_HORIZONTAL}],
        [PanRecognizer, {direction: DIRECTION_HORIZONTAL}, ['swipe']],
        [TapRecognizer],
        [TapRecognizer, {event: 'doubletap', taps: 2}, ['tap']],
        [PressRecognizer]
    ],

    /**
     * Some CSS properties can be used to improve the working of Hammer.
     * Add them to this method and they will be set when creating a new Manager.
     * @namespace
     */
    cssProps: {
        /**
         * Disables text selection to improve the dragging gesture. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userSelect: 'none',

        /**
         * Disable the Windows Phone grippers when pressing an element.
         * @type {String}
         * @default 'none'
         */
        touchSelect: 'none',

        /**
         * Disables the default callout shown when you touch and hold a touch target.
         * On iOS, when you touch and hold a touch target such as a link, Safari displays
         * a callout containing information about the link. This property allows you to disable that callout.
         * @type {String}
         * @default 'none'
         */
        touchCallout: 'none',

        /**
         * Specifies whether zooming is enabled. Used by IE10>
         * @type {String}
         * @default 'none'
         */
        contentZooming: 'none',

        /**
         * Specifies that an entire element should be draggable instead of its contents. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userDrag: 'none',

        /**
         * Overrides the highlight color shown when the user taps a link or a JavaScript
         * clickable element in iOS. This property obeys the alpha value, if specified.
         * @type {String}
         * @default 'rgba(0,0,0,0)'
         */
        tapHighlightColor: 'rgba(0,0,0,0)'
    }
};

var STOP = 1;
var FORCED_STOP = 2;

/**
 * Manager
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Manager(element, options) {
    this.options = assign({}, Hammer.defaults, options || {});

    this.options.inputTarget = this.options.inputTarget || element;

    this.handlers = {};
    this.session = {};
    this.recognizers = [];
    this.oldCssProps = {};

    this.element = element;
    this.input = createInputInstance(this);
    this.touchAction = new TouchAction(this, this.options.touchAction);

    toggleCssProps(this, true);

    each(this.options.recognizers, function(item) {
        var recognizer = this.add(new (item[0])(item[1]));
        item[2] && recognizer.recognizeWith(item[2]);
        item[3] && recognizer.requireFailure(item[3]);
    }, this);
}

Manager.prototype = {
    /**
     * set options
     * @param {Object} options
     * @returns {Manager}
     */
    set: function(options) {
        assign(this.options, options);

        // Options that need a little more setup
        if (options.touchAction) {
            this.touchAction.update();
        }
        if (options.inputTarget) {
            // Clean up existing event listeners and reinitialize
            this.input.destroy();
            this.input.target = options.inputTarget;
            this.input.init();
        }
        return this;
    },

    /**
     * stop recognizing for this session.
     * This session will be discarded, when a new [input]start event is fired.
     * When forced, the recognizer cycle is stopped immediately.
     * @param {Boolean} [force]
     */
    stop: function(force) {
        this.session.stopped = force ? FORCED_STOP : STOP;
    },

    /**
     * run the recognizers!
     * called by the inputHandler function on every movement of the pointers (touches)
     * it walks through all the recognizers and tries to detect the gesture that is being made
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        var session = this.session;
        if (session.stopped) {
            return;
        }

        // run the touch-action polyfill
        this.touchAction.preventDefaults(inputData);

        var recognizer;
        var recognizers = this.recognizers;

        // this holds the recognizer that is being recognized.
        // so the recognizer's state needs to be BEGAN, CHANGED, ENDED or RECOGNIZED
        // if no recognizer is detecting a thing, it is set to `null`
        var curRecognizer = session.curRecognizer;

        // reset when the last recognizer is recognized
        // or when we're in a new session
        if (!curRecognizer || (curRecognizer && curRecognizer.state & STATE_RECOGNIZED)) {
            curRecognizer = session.curRecognizer = null;
        }

        var i = 0;
        while (i < recognizers.length) {
            recognizer = recognizers[i];

            // find out if we are allowed try to recognize the input for this one.
            // 1.   allow if the session is NOT forced stopped (see the .stop() method)
            // 2.   allow if we still haven't recognized a gesture in this session, or the this recognizer is the one
            //      that is being recognized.
            // 3.   allow if the recognizer is allowed to run simultaneous with the current recognized recognizer.
            //      this can be setup with the `recognizeWith()` method on the recognizer.
            if (session.stopped !== FORCED_STOP && ( // 1
                    !curRecognizer || recognizer == curRecognizer || // 2
                    recognizer.canRecognizeWith(curRecognizer))) { // 3
                recognizer.recognize(inputData);
            } else {
                recognizer.reset();
            }

            // if the recognizer has been recognizing the input as a valid gesture, we want to store this one as the
            // current active recognizer. but only if we don't already have an active recognizer
            if (!curRecognizer && recognizer.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED)) {
                curRecognizer = session.curRecognizer = recognizer;
            }
            i++;
        }
    },

    /**
     * get a recognizer by its event name.
     * @param {Recognizer|String} recognizer
     * @returns {Recognizer|Null}
     */
    get: function(recognizer) {
        if (recognizer instanceof Recognizer) {
            return recognizer;
        }

        var recognizers = this.recognizers;
        for (var i = 0; i < recognizers.length; i++) {
            if (recognizers[i].options.event == recognizer) {
                return recognizers[i];
            }
        }
        return null;
    },

    /**
     * add a recognizer to the manager
     * existing recognizers with the same event name will be removed
     * @param {Recognizer} recognizer
     * @returns {Recognizer|Manager}
     */
    add: function(recognizer) {
        if (invokeArrayArg(recognizer, 'add', this)) {
            return this;
        }

        // remove existing
        var existing = this.get(recognizer.options.event);
        if (existing) {
            this.remove(existing);
        }

        this.recognizers.push(recognizer);
        recognizer.manager = this;

        this.touchAction.update();
        return recognizer;
    },

    /**
     * remove a recognizer by name or instance
     * @param {Recognizer|String} recognizer
     * @returns {Manager}
     */
    remove: function(recognizer) {
        if (invokeArrayArg(recognizer, 'remove', this)) {
            return this;
        }

        recognizer = this.get(recognizer);

        // let's make sure this recognizer exists
        if (recognizer) {
            var recognizers = this.recognizers;
            var index = inArray(recognizers, recognizer);

            if (index !== -1) {
                recognizers.splice(index, 1);
                this.touchAction.update();
            }
        }

        return this;
    },

    /**
     * bind event
     * @param {String} events
     * @param {Function} handler
     * @returns {EventEmitter} this
     */
    on: function(events, handler) {
        if (events === undefined) {
            return;
        }
        if (handler === undefined) {
            return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            handlers[event] = handlers[event] || [];
            handlers[event].push(handler);
        });
        return this;
    },

    /**
     * unbind event, leave emit blank to remove all handlers
     * @param {String} events
     * @param {Function} [handler]
     * @returns {EventEmitter} this
     */
    off: function(events, handler) {
        if (events === undefined) {
            return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            if (!handler) {
                delete handlers[event];
            } else {
                handlers[event] && handlers[event].splice(inArray(handlers[event], handler), 1);
            }
        });
        return this;
    },

    /**
     * emit event to the listeners
     * @param {String} event
     * @param {Object} data
     */
    emit: function(event, data) {
        // we also want to trigger dom events
        if (this.options.domEvents) {
            triggerDomEvent(event, data);
        }

        // no handlers, so skip it all
        var handlers = this.handlers[event] && this.handlers[event].slice();
        if (!handlers || !handlers.length) {
            return;
        }

        data.type = event;
        data.preventDefault = function() {
            data.srcEvent.preventDefault();
        };

        var i = 0;
        while (i < handlers.length) {
            handlers[i](data);
            i++;
        }
    },

    /**
     * destroy the manager and unbinds all events
     * it doesn't unbind dom events, that is the user own responsibility
     */
    destroy: function() {
        this.element && toggleCssProps(this, false);

        this.handlers = {};
        this.session = {};
        this.input.destroy();
        this.element = null;
    }
};

/**
 * add/remove the css properties as defined in manager.options.cssProps
 * @param {Manager} manager
 * @param {Boolean} add
 */
function toggleCssProps(manager, add) {
    var element = manager.element;
    if (!element.style) {
        return;
    }
    var prop;
    each(manager.options.cssProps, function(value, name) {
        prop = prefixed(element.style, name);
        if (add) {
            manager.oldCssProps[prop] = element.style[prop];
            element.style[prop] = value;
        } else {
            element.style[prop] = manager.oldCssProps[prop] || '';
        }
    });
    if (!add) {
        manager.oldCssProps = {};
    }
}

/**
 * trigger dom event
 * @param {String} event
 * @param {Object} data
 */
function triggerDomEvent(event, data) {
    var gestureEvent = document.createEvent('Event');
    gestureEvent.initEvent(event, true, true);
    gestureEvent.gesture = data;
    data.target.dispatchEvent(gestureEvent);
}

assign(Hammer, {
    INPUT_START: INPUT_START,
    INPUT_MOVE: INPUT_MOVE,
    INPUT_END: INPUT_END,
    INPUT_CANCEL: INPUT_CANCEL,

    STATE_POSSIBLE: STATE_POSSIBLE,
    STATE_BEGAN: STATE_BEGAN,
    STATE_CHANGED: STATE_CHANGED,
    STATE_ENDED: STATE_ENDED,
    STATE_RECOGNIZED: STATE_RECOGNIZED,
    STATE_CANCELLED: STATE_CANCELLED,
    STATE_FAILED: STATE_FAILED,

    DIRECTION_NONE: DIRECTION_NONE,
    DIRECTION_LEFT: DIRECTION_LEFT,
    DIRECTION_RIGHT: DIRECTION_RIGHT,
    DIRECTION_UP: DIRECTION_UP,
    DIRECTION_DOWN: DIRECTION_DOWN,
    DIRECTION_HORIZONTAL: DIRECTION_HORIZONTAL,
    DIRECTION_VERTICAL: DIRECTION_VERTICAL,
    DIRECTION_ALL: DIRECTION_ALL,

    Manager: Manager,
    Input: Input,
    TouchAction: TouchAction,

    TouchInput: TouchInput,
    MouseInput: MouseInput,
    PointerEventInput: PointerEventInput,
    TouchMouseInput: TouchMouseInput,
    SingleTouchInput: SingleTouchInput,

    Recognizer: Recognizer,
    AttrRecognizer: AttrRecognizer,
    Tap: TapRecognizer,
    Pan: PanRecognizer,
    Swipe: SwipeRecognizer,
    Pinch: PinchRecognizer,
    Rotate: RotateRecognizer,
    Press: PressRecognizer,

    on: addEventListeners,
    off: removeEventListeners,
    each: each,
    merge: merge,
    extend: extend,
    assign: assign,
    inherit: inherit,
    bindFn: bindFn,
    prefixed: prefixed
});

// this prevents errors when Hammer is loaded in the presence of an AMD
//  style loader but by script tag, not by the loader.
var freeGlobal = (typeof window !== 'undefined' ? window : (typeof self !== 'undefined' ? self : {})); // jshint ignore:line
freeGlobal.Hammer = Hammer;

if (true) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
        return Hammer;
    }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
} else if (typeof module != 'undefined' && module.exports) {
    module.exports = Hammer;
} else {
    window[exportName] = Hammer;
}

})(window, document, 'Hammer');


/***/ }),
/* 551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_flickity__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_flickity___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_flickity__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2____ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_getAverageColor__ = __webpack_require__(37);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SimpleSlider=function(_Component){_inherits(SimpleSlider,_Component);function SimpleSlider(){var _ref;var _temp,_this,_ret;_classCallCheck(this,SimpleSlider);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=SimpleSlider.__proto__||Object.getPrototypeOf(SimpleSlider)).call.apply(_ref,[this].concat(args))),_this),_this.state={color:[]},_this.initSlider=function(){_this.flktySlides=new __WEBPACK_IMPORTED_MODULE_1_flickity___default.a(_this.slider,{lazyLoad:1,pageDots:_this.props.images.length>1});var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=_this.props.images[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var image=_step.value;Object(__WEBPACK_IMPORTED_MODULE_4__helpers_getAverageColor__["a" /* getAverageColor */])(image.url).then(function(data){_this.setState({color:[].concat(_toConsumableArray(_this.state.color),[data])});}).catch(function(e){console.log(e);});}// Reinit Slider (to prevent adding .is-selected)
}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}_this.flktySlides.reloadCells();setTimeout(function(){_this.flktySlides.reloadCells();},600);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(SimpleSlider,[{key:'componentDidMount',value:function componentDidMount(){this.initSlider();}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(_ref2){var _this2=this;var images=_ref2.images;if(images!==this.props.images){this.flktySlides.destroy();this.timer=setTimeout(function(){_this2.initSlider();},200);}}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.flktySlides.destroy();}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(_ref3,_ref4){var images=_ref3.images;var color=_ref4.color;return images!==this.props.images||this.state.color!==color;}},{key:'render',value:function render(){var _this3=this;var images=this.props.images;var color=this.state.color;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'flickity-slider-parent',ref:function ref(flickity){return _this3.slider=flickity;}},images.map(function(image,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'flickity-slide template-picture template-picture--'+image.picture_position+' '+Object(__WEBPACK_IMPORTED_MODULE_3__styles__["_79" /* flickitySlideStyle */])(image.type==='file'?image.url:'',color[index]),key:index},image.type==='prodibi'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2____["R" /* Prodibi */],{id:image.reference,width:image.width,height:image.height}));}));}}]);return SimpleSlider;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (SimpleSlider);

/***/ }),
/* 552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Gallery=function(_Component){_inherits(Gallery,_Component);function Gallery(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Gallery);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Gallery.__proto__||Object.getPrototypeOf(Gallery)).call.apply(_ref,[this].concat(args))),_this),_this.state={open:false,active:null,link:null,title:'',legend:'',transition:false},_this.handleClick=function(index,item){return function(e){e.preventDefault();_this.setState({active:index,link:item.image,title:item.title,legend:item.legend,open:true});_this.timer=setTimeout(function(){_this.setState({transition:true});},400);};},_this.close=function(e){e.preventDefault();_this.setState({transition:false});_this.timer=setTimeout(function(){_this.setState({open:false});},300);_this.timer=setTimeout(function(){_this.setState({active:null,link:null,title:'',legend:''});},700);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Gallery,[{key:'render',value:function render(){var _this2=this;var images=this.props.images;var _state=this.state,active=_state.active,open=_state.open,link=_state.link,title=_state.title,transition=_state.transition,legend=_state.legend;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:Object(__WEBPACK_IMPORTED_MODULE_1__styles__["T" /* GalleryStyle */])(open,transition)+' gallery'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'flex gallery__pictures'},images.map(function(item,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'picture gallery__picture '+(index===active?'active':null),key:index,onClick:_this2.handleClick(index,item)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:item.image,alt:item.title}));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'gallery__focus'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'gallery__close',onClick:this.close}),link&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:link,alt:title}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'gallery__focus-legend'},legend))));}}]);return Gallery;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Gallery);

/***/ }),
/* 553 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_ApiController__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Poll=function(_Component){_inherits(Poll,_Component);function Poll(props){_classCallCheck(this,Poll);var _this=_possibleConstructorReturn(this,(Poll.__proto__||Object.getPrototypeOf(Poll)).call(this,props));_this.getDatas=function(){Object(__WEBPACK_IMPORTED_MODULE_0__services_ApiController__["fetchPoll"])().then(function(data){if(data.id){_this.setState({poll:data});}}).catch(function(err){console.log('Something Wrong with Poll data',err);});};_this.togglePoll=function(){_this.setState({isOpen:!_this.state.isOpen});};_this.sendChoice=function(){if(_this.state.choice!==null&&_this.state.choice!==''){fetch('/survey/'+_this.state.poll.id+'.json',{body:JSON.stringify({choice:_this.state.choice}),headers:{'Content-Type':'application/json'},method:'POST'}).then(function(){_this.setState({success:true});setTimeout(function(){_this.setState({isOpen:false});},3000);}).catch(function(err){console.log('Something Wrong with sending datas',err);});}else{_this.setState({error:true});}};_this.state={isOpen:true,poll:null,choice:null,success:false,hasFreeChoice:false};return _this;}_createClass(Poll,[{key:'componentDidMount',value:function componentDidMount(){this.getDatas();}},{key:'render',value:function render(){var _this2=this;return this.state.poll!==null&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'poll  '+(!this.state.isOpen?'is-closed':'')+' '+__WEBPACK_IMPORTED_MODULE_2__styles__["_19" /* PollStyle */]},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'poll__close',onClick:function onClick(){return _this2.togglePoll();}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('svg',{className:'shape shape--arrow',width:'18',height:'18',viewBox:'0 0 129 129'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'m40.4,121.3c-0.8,0.8-1.8,1.2-2.9,1.2s-2.1-0.4-2.9-1.2c-1.6-1.6-1.6-4.2 0-5.8l51-51-51-51c-1.6-1.6-1.6-4.2 0-5.8 1.6-1.6 4.2-1.6 5.8,0l53.9,53.9c1.6,1.6 1.6,4.2 0,5.8l-53.9,53.9z'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'poll__title'},this.state.poll.title),!this.state.success&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('fieldset',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('legend',{className:'poll__question'},this.state.poll.question),this.state.poll.choices.map(function(choice,i){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'poll__radio',key:i},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{onChange:function onChange(){return _this2.setState({choice:choice,error:false,hasFreeChoice:false});},type:'radio',id:choice,value:choice,name:'poll'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:choice},choice));}),this.state.poll.addFreeTextChoice&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'poll__free-wrap'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'poll__radio'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{onChange:function onChange(){return _this2.setState({hasFreeChoice:true,error:false});},type:'radio',id:'other',value:'other',name:'poll'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'other'},'Other')),this.state.hasFreeChoice&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'poll__free'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'otherText'},'Please explain'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{onChange:function onChange(e){return _this2.setState({choice:e.target.value,error:e.target.value===''?true:false});},id:'otherText',type:'text',placeholder:'Please explain'})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{onClick:function onClick(){return _this2.sendChoice();},className:'poll__submit',type:'submit',value:'Submit'})),this.state.error&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'poll__error'},'Please select an answer'),this.state.success&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'poll__success'},'Thank you, your answer has been taken into account'));}}]);return Poll;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Poll);

/***/ }),
/* 554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Field__ = __webpack_require__(555);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__Field__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Checkbox__ = __webpack_require__(556);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__Checkbox__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__UploadFile__ = __webpack_require__(557);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_2__UploadFile__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Textarea__ = __webpack_require__(558);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__Textarea__["a"]; });


/***/ }),
/* 555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Field=function(_Component){_inherits(Field,_Component);function Field(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Field);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Field.__proto__||Object.getPrototypeOf(Field)).call.apply(_ref,[this].concat(args))),_this),_this.state={value:'',patternEmail:''},_this.handleChange=function(event){_this.changeValue(event.target.value);},_this.changeValue=function(val){_this.setState({value:val});if(typeof _this.props.onChange==='function')_this.props.onChange({key:_this.props.name,value:val});},_this.iEmail=function(email){// Test pattern Email
},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Field,[{key:'componentDidMount',value:function componentDidMount(){var value=this.props.value;if(value&&(value!==''||typeof value!=='undefined'))this.changeValue(value);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(_ref2){var clean=_ref2.clean;if(clean!==this.props.clean){this.setState({value:''});}}},{key:'render',value:function render(){var _this2=this;var _props=this.props,children=_props.children,id=_props.id,type=_props.type,name=_props.name,className=_props.className,big=_props.big,disabled=_props.disabled;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-field '+Object(__WEBPACK_IMPORTED_MODULE_2__styles__["N" /* FieldStyle */])(this.state.value==='',big)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:type,id:id,name:name,value:this.state.value,ref:function ref(input){return _this2.input=input;},className:className,onChange:this.handleChange,disabled:disabled}),type!=='hidden'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:id},children));}}]);return Field;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Field.defaultProps={big:false};/* harmony default export */ __webpack_exports__["a"] = (Field);Field.propTypes={id:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,name:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,className:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,type:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,big:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};

/***/ }),
/* 556 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Checkbox=function(_Component){_inherits(Checkbox,_Component);function Checkbox(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Checkbox);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Checkbox.__proto__||Object.getPrototypeOf(Checkbox)).call.apply(_ref,[this].concat(args))),_this),_this.state={checked:false},_this.handlerChange=function(e){_this.setState({checked:e.currentTarget.checked});_this.props.onCallback({checked:e.currentTarget.checked,value:e.currentTarget.value});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Checkbox,[{key:'componentDidMount',value:function componentDidMount(){this.setState({checked:this.props.checked});if(this.props.checked)this.props.onCallback({checked:true,value:this.checkbox.value});}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(_ref2){var checked=_ref2.checked;if(this.props.checked!==checked){this.setState({checked:checked});this.props.onCallback({checked:checked,value:this.checkbox.value});}}},{key:'render',value:function render(){var _this2=this;var _props=this.props,children=_props.children,name=_props.name,id=_props.id,value=_props.value,className=_props.className;var checked=this.state.checked;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:className+' checkbox '+Object(__WEBPACK_IMPORTED_MODULE_1__styles__["w" /* CheckboxStyle */])(checked)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',name:name,id:id,value:value||1,checked:checked,onChange:this.handlerChange,ref:function ref(checkbox){return _this2.checkbox=checkbox;}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:id,className:'checkbox-label'},children));}}]);return Checkbox;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Checkbox);

/***/ }),
/* 557 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var UploadFile=function(_Component){_inherits(UploadFile,_Component);function UploadFile(){var _ref;var _temp,_this,_ret;_classCallCheck(this,UploadFile);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=UploadFile.__proto__||Object.getPrototypeOf(UploadFile)).call.apply(_ref,[this].concat(args))),_this),_this.state={},_this.handlerChange=function(e){var file=e.currentTarget.files[0];_this.props.uploadCallback(file);},_this.defaultProps={name:'upload-file',id:'upload-file'},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(UploadFile,[{key:'render',value:function render(){var _props=this.props,children=_props.children,name=_props.name,id=_props.id,accept=_props.accept,value=_props.value;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:' upload '+__WEBPACK_IMPORTED_MODULE_2__styles__["_67" /* UploadStyle */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'file',name:name,id:id,defaultValue:value,onChange:this.handlerChange,accept:accept}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:id},' ',children,' '));}}]);return UploadFile;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (UploadFile);UploadFile.propTypes={name:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,id:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};

/***/ }),
/* 558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Textarea=function(_Component){_inherits(Textarea,_Component);function Textarea(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Textarea);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Textarea.__proto__||Object.getPrototypeOf(Textarea)).call.apply(_ref,[this].concat(args))),_this),_this.state={value:null},_this.handleChange=function(event){_this.changeValue(event.target.value);},_this.changeValue=function(val){_this.setState({value:val});if(typeof _this.props.onChange==='function')_this.props.onChange({key:_this.props.name,value:val});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Textarea,[{key:'componentDidMount',value:function componentDidMount(){var value=this.props.value;if(value!==''||typeof value!=='undefined')this.changeValue(value);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(_ref2){var clean=_ref2.clean;if(clean!==this.props.clean){this.setState({value:null});}}},{key:'render',value:function render(){var _this2=this;var _props=this.props,children=_props.children,id=_props.id,name=_props.name,className=_props.className,disabled=_props.disabled;var value=this.state.value;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-field '+Object(__WEBPACK_IMPORTED_MODULE_2__styles__["N" /* FieldStyle */])(value==='')+' '+Object(__WEBPACK_IMPORTED_MODULE_2__styles__["_63" /* TextareaStyle */])(!value)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{id:id,name:name,ref:function ref(input){return _this2.input=input;},value:value,className:className,onChange:this.handleChange,disabled:disabled}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:id},children));}}]);return Textarea;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Textarea);Textarea.propTypes={id:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,name:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,className:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};

/***/ }),
/* 559 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BaseTemplate__ = __webpack_require__(560);
/* unused harmony reexport BaseTemplate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SliderTemplate__ = __webpack_require__(561);
/* unused harmony reexport SliderTemplate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SocialTemplate__ = __webpack_require__(562);
/* unused harmony reexport SocialTemplate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SuggestTemplate__ = __webpack_require__(563);
/* unused harmony reexport SuggestTemplate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VideoTemplate__ = __webpack_require__(564);
/* unused harmony reexport VideoTemplate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FullTextTemplate__ = __webpack_require__(565);
/* unused harmony reexport FullTextTemplate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__IntroTemplate__ = __webpack_require__(566);
/* unused harmony reexport IntroTemplate */


/***/ }),
/* 560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_flickity__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_flickity___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_flickity__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BaseTemplate=function(_Component){_inherits(BaseTemplate,_Component);function BaseTemplate(){_classCallCheck(this,BaseTemplate);return _possibleConstructorReturn(this,(BaseTemplate.__proto__||Object.getPrototypeOf(BaseTemplate)).apply(this,arguments));}_createClass(BaseTemplate,[{key:'componentDidMount',value:function componentDidMount(){if(this.props.images){this.flkty=new __WEBPACK_IMPORTED_MODULE_1_flickity___default.a(this.slider,{lazyLoad:1});}}},{key:'render',value:function render(){var _this2=this;var _props=this.props,type=_props.type,title=_props.title,titleBis=_props.titleBis,description=_props.description,descriptionBis=_props.descriptionBis,image=_props.image,images=_props.images;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'product-template--base product-template template '+Object(__WEBPACK_IMPORTED_MODULE_2__styles__["h" /* BaseTemplateStyle */])(image&&image.type==='file'?image.url:'',type)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'template-scroll'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'template-left'},images&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'flickity-slider',ref:function ref(flickity){return _this2.slider=flickity;}},images.map(function(image,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'flickity-slide '+Object(__WEBPACK_IMPORTED_MODULE_2__styles__["_79" /* flickitySlideStyle */])(image.type==='file'?image.url:''),key:index},image.type==='prodibi'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["R" /* Prodibi */],{id:image.reference,width:image.width,height:image.height}));}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'template-right template-content'},title&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'subtitle'},title),description&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content',dangerouslySetInnerHTML:{__html:description}}),titleBis&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'subtitle'},titleBis),descriptionBis&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content',dangerouslySetInnerHTML:{__html:descriptionBis}}))));}}]);return BaseTemplate;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* unused harmony default export */ var _unused_webpack_default_export = (BaseTemplate);

/***/ }),
/* 561 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__static_default_picture_RM_jpg__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__static_default_picture_RM_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__static_default_picture_RM_jpg__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SliderTemplate=function(_Component){_inherits(SliderTemplate,_Component);function SliderTemplate(){var _ref;var _temp,_this,_ret;_classCallCheck(this,SliderTemplate);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=SliderTemplate.__proto__||Object.getPrototypeOf(SliderTemplate)).call.apply(_ref,[this].concat(args))),_this),_this.state={active:0,lastPicture:__WEBPACK_IMPORTED_MODULE_2__static_default_picture_RM_jpg___default.a,lastPicturePosition:'center'},_this.updateSlides=function(index){return function(e){e.preventDefault();_this.setState({active:index,lastPicture:_this.props.items[index].image!==''?_this.props.items[index].image:_this.state.lastPicture,lastPicturePosition:_this.props.items[index].picture_position!==''?_this.props.items[index].picture_position:_this.state.lastPicturePosition});};},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(SliderTemplate,[{key:'componentDidMount',value:function componentDidMount(){this.setState({lastPicture:this.props.items[0].image!==''?this.props.items[0].image:this.state.lastPicture,lastPicturePosition:this.props.items[0].picture_position!==''?this.props.items[0].picture_position:this.state.lastPicturePosition});}},{key:'render',value:function render(){var _this2=this;var _props=this.props,title=_props.title,items=_props.items;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'product-template--slider product-template '+Object(__WEBPACK_IMPORTED_MODULE_1__styles__["_48" /* SliderTemplateStyle */])(this.state.lastPicture)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'template-scroll flex'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'template-left template-left--'+this.state.lastPicturePosition}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'template-right template-content'},title&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'subtitle'},title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'reset'},items.map(function(slide,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:index,className:'flex '+(index===_this2.state.active?'active':''),onClick:_this2.updateSlides(index)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'number'},index+1),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'label'},' ',slide.description,' '));})))));}}]);return SliderTemplate;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* unused harmony default export */ var _unused_webpack_default_export = (SliderTemplate);

/***/ }),
/* 562 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3____ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SocialTemplate=function(_Component){_inherits(SocialTemplate,_Component);function SocialTemplate(){var _ref;var _temp,_this,_ret;_classCallCheck(this,SocialTemplate);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=SocialTemplate.__proto__||Object.getPrototypeOf(SocialTemplate)).call.apply(_ref,[this].concat(args))),_this),_this.state={},_this.getIcons=function(type){var nComponent=null;switch(type){case'instagram':nComponent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3____["D" /* Instagram */],{width:24,height:24});break;case'facebook':nComponent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3____["v" /* Facebook */],{width:24,height:24});break;case'twitter':nComponent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3____["_15" /* Twitter */],{width:24,height:24});break;case'linkedin':nComponent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3____["E" /* Linkedin */],{width:24,height:24});break;case'weibo':nComponent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3____["_23" /* Weibo */],{width:24,height:24});break;case'desktop':nComponent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3____["r" /* Desktop */],{width:24,height:24});break;default:break;}return nComponent;},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(SocialTemplate,[{key:'render',value:function render(){var _this2=this;var _props=this.props,items=_props.items,title=_props.title,picture=_props.picture;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'product-template product-template--videos '+Object(__WEBPACK_IMPORTED_MODULE_2__styles__["_52" /* SocialTemplateStyle */])(picture)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'template-scroll flex'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'template-left'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'template-right template-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'subtitle'},' ',title,' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'social-container'},items.map(function(social,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'social-row flex items-center',key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'social-svg'},_this2.getIcons(social.type)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'social-label'},' ',social.label,' : '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:social.link,target:'_blank'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'link'},' ',social.link,' ')));})))));}}]);return SocialTemplate;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* unused harmony default export */ var _unused_webpack_default_export = (SocialTemplate);

/***/ }),
/* 563 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SuggestTemplate=function(_Component){_inherits(SuggestTemplate,_Component);function SuggestTemplate(){var _ref;var _temp,_this,_ret;_classCallCheck(this,SuggestTemplate);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=SuggestTemplate.__proto__||Object.getPrototypeOf(SuggestTemplate)).call.apply(_ref,[this].concat(args))),_this),_this.state={},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(SuggestTemplate,[{key:'render',value:function render(){var _props=this.props,picture=_props.picture,picturePosition=_props.picturePosition,title=_props.title,items=_props.items;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'product-template--suggest product-template '+Object(__WEBPACK_IMPORTED_MODULE_2__styles__["_59" /* SuggestTemplateStyle */])(picture)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'template-scroll'},picture&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'template-left'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'template-right '+(!picture?'full':'')+' template-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'flex'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'subtitle'},title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'suggest-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'flex flex-wrap'},items.map(function(product,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1____["n" /* Card */],{title:product.name,description:product.description,slug:product.url,cover:product.picture,pdfs:product.pdfs,is_bookmark:product.is_bookmark,slug_bookmark:product.slug_bookmark,key:index});})))))));}}]);return SuggestTemplate;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* unused harmony default export */ var _unused_webpack_default_export = (SuggestTemplate);

/***/ }),
/* 564 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var VideoTemplate=function(_Component){_inherits(VideoTemplate,_Component);function VideoTemplate(){_classCallCheck(this,VideoTemplate);return _possibleConstructorReturn(this,(VideoTemplate.__proto__||Object.getPrototypeOf(VideoTemplate)).apply(this,arguments));}_createClass(VideoTemplate,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'product-template product-template--videos'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'template-scroll'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1____["_22" /* Videos */],this.props)));}}]);return VideoTemplate;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* unused harmony default export */ var _unused_webpack_default_export = (VideoTemplate);

/***/ }),
/* 565 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_flickity__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_flickity___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_flickity__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FullTextTemplate=function(_Component){_inherits(FullTextTemplate,_Component);function FullTextTemplate(){_classCallCheck(this,FullTextTemplate);return _possibleConstructorReturn(this,(FullTextTemplate.__proto__||Object.getPrototypeOf(FullTextTemplate)).apply(this,arguments));}_createClass(FullTextTemplate,[{key:'componentDidMount',value:function componentDidMount(){if(this.props.images){this.flkty=new __WEBPACK_IMPORTED_MODULE_1_flickity___default.a(this.slider);}}},{key:'render',value:function render(){var _props=this.props,type=_props.type,title=_props.title,description=_props.description,description2=_props.description2;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'product-template--base product-template template '+__WEBPACK_IMPORTED_MODULE_2__styles__["_62" /* TextTemplateStyle */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'template-scroll'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'template-content'},title&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'subtitle'},title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'flex'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'template-left'},description&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content',dangerouslySetInnerHTML:{__html:description}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'template-right '},description2&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content',dangerouslySetInnerHTML:{__html:description2}}))))));}}]);return FullTextTemplate;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* unused harmony default export */ var _unused_webpack_default_export = (FullTextTemplate);

/***/ }),
/* 566 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_emotion__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var IntroTemplate=function(_Component){_inherits(IntroTemplate,_Component);function IntroTemplate(){var _ref;var _temp,_this,_ret;_classCallCheck(this,IntroTemplate);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=IntroTemplate.__proto__||Object.getPrototypeOf(IntroTemplate)).call.apply(_ref,[this].concat(args))),_this),_this.state={},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(IntroTemplate,[{key:'shouldComponentUpdate',value:function shouldComponentUpdate(){return false;}},{key:'render',value:function render(){var _props=this.props,titleProduct=_props.titleProduct,title=_props.title,picture=_props.picture,items=_props.items,type=_props.type,sport=_props.sport,lifestyle=_props.lifestyle,expert=_props.expert;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:Object(__WEBPACK_IMPORTED_MODULE_2__styles__["Y" /* IntroTemplateStyle */])(picture)+' product-template product-template--intro'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'template-scroll'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'template-left template-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'title'},titleProduct),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'subtitle'},' ',title,' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content'},type==='introproduct'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-row flex'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'label'},'Class'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'description'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'flex'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'range-label  '+Object(__WEBPACK_IMPORTED_MODULE_1_emotion__["a" /* css */])({color:__WEBPACK_IMPORTED_MODULE_2__styles__["x" /* Colors */].red})},' Sport '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'range'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["T" /* ProgressBar */],{theme:'red',x:sport,big:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'flex'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'range-label  '+Object(__WEBPACK_IMPORTED_MODULE_1_emotion__["a" /* css */])({color:__WEBPACK_IMPORTED_MODULE_2__styles__["x" /* Colors */].blue})},' Expert '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'range'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["T" /* ProgressBar */],{theme:'blue',x:expert,big:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'flex'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'range-label '+Object(__WEBPACK_IMPORTED_MODULE_1_emotion__["a" /* css */])({color:__WEBPACK_IMPORTED_MODULE_2__styles__["x" /* Colors */].green})},' Lifestyle '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'range'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["T" /* ProgressBar */],{theme:'green',x:lifestyle,big:true}))))),items&&items.map(function(item,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-row flex',key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'label'},item.label),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'description'},' ',item.description,' '));}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'template-right'})));}}]);return IntroTemplate;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* unused harmony default export */ var _unused_webpack_default_export = (IntroTemplate);

/***/ }),
/* 567 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CurrentRanking__ = __webpack_require__(568);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__CurrentRanking__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__RankingIQ__ = __webpack_require__(569);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_1__RankingIQ__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PushQuizz__ = __webpack_require__(570);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_2__PushQuizz__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PushHighScore__ = __webpack_require__(571);
/* unused harmony reexport PushHighScore */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__BestRanking__ = __webpack_require__(572);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_4__BestRanking__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__QuizzRanking__ = __webpack_require__(573);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_5__QuizzRanking__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ChartRanking__ = __webpack_require__(574);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_6__ChartRanking__["a"]; });


/***/ }),
/* 568 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_ApiController__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_Router__ = __webpack_require__(12);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CurrentRanking=function(_Component){_inherits(CurrentRanking,_Component);function CurrentRanking(){var _ref;var _temp,_this,_ret;_classCallCheck(this,CurrentRanking);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=CurrentRanking.__proto__||Object.getPrototypeOf(CurrentRanking)).call.apply(_ref,[this].concat(args))),_this),_this.getSup=function(sup){var str='';switch(sup){case 1:case 31:str='st';break;case 2:str='nd';break;case 3:str='rd';break;default:str='th';break;}return str;},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(CurrentRanking,[{key:'render',value:function render(){var _props=this.props,preview=_props.preview,current=_props.current,total=_props.total,score=_props.score;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'current-ranking '+Object(__WEBPACK_IMPORTED_MODULE_2__styles__["E" /* CurrentRankingStyle */])(preview)+' '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'current-ranking-label'},preview?'My ranking':'current ranking'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'current-ranking-number'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'current'},score?current:'-',score&&!preview?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('sup',null,this.getSup(current)):null),score&&preview?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'all'},' /',total,' '):null),!preview&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:__WEBPACK_IMPORTED_MODULE_5__services_Router__["a" /* default */].ranking.exactPath,className:'link'},' View general ranking '));}}]);return CurrentRanking;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);CurrentRanking.defaultProps={preview:false};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */])(function(_ref2){var Session=_ref2.Session;return{total:Session.challenge.quizzTotal,current:Session.challenge.current,score:Session.challenge.quizz};})(CurrentRanking));

/***/ }),
/* 569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(8);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RAD=function RAD(x){return 251.327412287-251.327412287*x/100;};var RankingIQ=function(_Component){_inherits(RankingIQ,_Component);function RankingIQ(){var _ref;var _temp,_this,_ret;_classCallCheck(this,RankingIQ);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=RankingIQ.__proto__||Object.getPrototypeOf(RankingIQ)).call.apply(_ref,[this].concat(args))),_this),_this.state={score:0},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(RankingIQ,[{key:'render',value:function render(){var _props=this.props,preview=_props.preview,score=_props.score;var real_score=parseInt(score)/10;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ranking-iq '+Object(__WEBPACK_IMPORTED_MODULE_1__styles__["_34" /* RankingIQStyle */])(preview,RAD(real_score))},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ranking-iq-inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'label'},'My RM IQ'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'score'},' ',score,' ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ranking-iq-progress'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',{viewBox:'0 0 100 100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('circle',{className:'progress',cx:'50',cy:'50',r:'40'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('circle',{className:'progress-bar',cx:'50',cy:'50',r:'40'}))));}}]);return RankingIQ;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function(_ref2){var Session=_ref2.Session;return{score:Session.challenge.rankingIQ};})(RankingIQ));

/***/ }),
/* 570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_Router__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_date__ = __webpack_require__(64);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PushQuizz=function(_Component){_inherits(PushQuizz,_Component);function PushQuizz(){_classCallCheck(this,PushQuizz);return _possibleConstructorReturn(this,(PushQuizz.__proto__||Object.getPrototypeOf(PushQuizz)).apply(this,arguments));}_createClass(PushQuizz,[{key:'render',value:function render(){var picture=this.props.picture;var _props$menu$challenge=this.props.menu.challenge.quiz,date_start=_props$menu$challenge.date_start,date_end=_props$menu$challenge.date_end,enabled=_props$menu$challenge.enabled,alreadyPlayed=_props$menu$challenge.alreadyPlayed,current=_props$menu$challenge.current;console.log(this.props);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'push-quizz '+Object(__WEBPACK_IMPORTED_MODULE_3__styles__["_26" /* PushQuizzStyle */])()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'push-quizz-inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Challenge Yourself'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,date_start.substring(3,5),'th of ',Object(__WEBPACK_IMPORTED_MODULE_5__helpers_date__["d" /* GetMonth */])(date_start.substring(0,2)),' to ',date_end.substring(3,5),'th of ',Object(__WEBPACK_IMPORTED_MODULE_5__helpers_date__["d" /* GetMonth */])(date_end.substring(0,2))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:__WEBPACK_IMPORTED_MODULE_4__services_Router__["a" /* default */].currentQuizz.path,className:'btn btn-white'},' Start the quizz '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:__WEBPACK_IMPORTED_MODULE_4__services_Router__["a" /* default */].hubQuizz.path,className:'link'},' See previous quizzes ')));}}]);return PushQuizz;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function(_ref){var Session=_ref.Session;return{menu:Session.menu};})(PushQuizz));

/***/ }),
/* 571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_Router__ = __webpack_require__(12);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PushQuizz=function(_Component){_inherits(PushQuizz,_Component);function PushQuizz(){var _ref;var _temp,_this,_ret;_classCallCheck(this,PushQuizz);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=PushQuizz.__proto__||Object.getPrototypeOf(PushQuizz)).call.apply(_ref,[this].concat(args))),_this),_this.state={hasScore:false,fake:[]},_this.getLast=function(){var last=_this.props.menu.challenge.rankings.length<10?10-_this.props.menu.challenge.rankings.length:0;var fake=[];if(last!==0){for(var i=0;i<last;i++){fake.push(i);}_this.setState({fake:fake});}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(PushQuizz,[{key:'componentDidMount',value:function componentDidMount(){this.getLast();}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(_ref2){var menu=_ref2.menu;if(menu.challenge.rankings!==this.props.menu.challenge.rankings)this.getLast();}},{key:'render',value:function render(){var rankings=this.props.menu.challenge.rankings;var fake=this.state.fake;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'push-high-score '+__WEBPACK_IMPORTED_MODULE_3__styles__["_25" /* PushHighScoreStyle */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'High Score'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ranking-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'first'},rankings.slice(0,3).map(function(ranking,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ranking-line flex '+(ranking.score&&ranking.current?'current current--menu':''),key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'number'},index+1,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('sup',null,index===0?'st':index===1?'nd':'rd')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'name'},' ',ranking.score?ranking.name:'-',' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'localisation'},' ',ranking.score?ranking.city:'-',' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'score'},' ',ranking.score?ranking.score:'-',' '));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'last'},rankings.slice(3,rankings.length).map(function(ranking,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ranking-line flex '+(ranking.score&&ranking.current?'current current--menu':''),key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'number'},index+4),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'name'},' ',ranking.score?ranking.name:'-',' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'localisation'},' ',ranking.score?ranking.city:'-',' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'score'},' ',ranking.score?ranking.score:'-',' '));}),fake.length>0&&fake.map(function(index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ranking-line flex',key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'number'},rankings.length+index+1),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'name'},' - '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'localisation'},' - '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'score'},' - '));}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Link */],{to:__WEBPACK_IMPORTED_MODULE_4__services_Router__["a" /* default */].ranking.exactPath,className:'link'},'Check the general ranking'));}}]);return PushQuizz;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(_ref3){var Session=_ref3.Session;return{menu:Session.menu};})(PushQuizz));

/***/ }),
/* 572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BestRanking=function(_Component){_inherits(BestRanking,_Component);function BestRanking(){var _ref;var _temp,_this,_ret;_classCallCheck(this,BestRanking);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=BestRanking.__proto__||Object.getPrototypeOf(BestRanking)).call.apply(_ref,[this].concat(args))),_this),_this.state={best:0},_this.getSup=function(sup){var str='';switch(sup){case 1:str='st';break;case 2:str='nd';break;case 3:str='rd';break;default:str='th';break;}return str;},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(BestRanking,[{key:'render',value:function render(){var best=this.props.best;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'best-ranking '+__WEBPACK_IMPORTED_MODULE_2__styles__["i" /* BestRankingStyle */]+' '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'best-ranking-label label'},'Best ranking'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'best-ranking-number number'},best?best:'-',best&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('sup',null,' ',this.getSup(best),' ')));}}]);return BestRanking;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(_ref2){var Session=_ref2.Session;return{best:Session.challenge.best};})(BestRanking));

/***/ }),
/* 573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_Router__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_ApiController__ = __webpack_require__(10);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var QuizzRanking=function(_Component){_inherits(QuizzRanking,_Component);function QuizzRanking(){_classCallCheck(this,QuizzRanking);return _possibleConstructorReturn(this,(QuizzRanking.__proto__||Object.getPrototypeOf(QuizzRanking)).apply(this,arguments));}_createClass(QuizzRanking,[{key:'render',value:function render(){var _props=this.props,quizz=_props.quizz,total=_props.total;var x=parseInt(quizz)/parseInt(total)*100;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'quizz-ranking '+Object(__WEBPACK_IMPORTED_MODULE_2__styles__["_31" /* QuizzRankingStyle */])(x)+' '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'quizz-ranking-label label'},'Quizz taken'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'quizz-ranking-number'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'number'},quizz),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'all'},'/',total)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'quizz-ranking-link'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["b" /* Link */],{to:__WEBPACK_IMPORTED_MODULE_4__services_Router__["a" /* default */].hubQuizz.path,className:'link'},'See all Quizzes')));}}]);return QuizzRanking;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(_ref){var Session=_ref.Session;return{quizz:Session.challenge.quizz,total:Session.challenge.quizzTotal};})(QuizzRanking));

/***/ }),
/* 574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_chart_js__ = __webpack_require__(575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_chart_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ChartRanking=function(_Component){_inherits(ChartRanking,_Component);function ChartRanking(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,ChartRanking);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ChartRanking.__proto__||Object.getPrototypeOf(ChartRanking)).call.apply(_ref,[this].concat(args))),_this),_this.state={ready:false},_this.initChart=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(results){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return new __WEBPACK_IMPORTED_MODULE_2_chart_js___default.a(_this.ctx,{type:'line',data:{labels:results.labels,datasets:[{label:'',data:results.scores,borderWidth:4,borderColor:__WEBPACK_IMPORTED_MODULE_4__styles__["x" /* Colors */].red,lineTension:0,pointBorderWidth:2,pointBorderColor:'white',pointBackgroundColor:__WEBPACK_IMPORTED_MODULE_4__styles__["x" /* Colors */].red,pointRadius:6,backgroundColor:'transparent'}]},options:{legend:{display:false,lineWidth:0,hidden:false},scales:{xAxes:[{gridLines:{display:false},ticks:{fontSize:14,fontStyle:'bold',fontColor:'black',padding:10}}],yAxes:[{gridLines:{borderDash:[2,2],color:__WEBPACK_IMPORTED_MODULE_4__styles__["x" /* Colors */].darkGrey,zeroLineBorderDash:[2,2],zeroLineColor:__WEBPACK_IMPORTED_MODULE_4__styles__["x" /* Colors */].darkGrey},ticks:{max:1000,fontColor:__WEBPACK_IMPORTED_MODULE_4__styles__["x" /* Colors */].grey,fontSize:14,fontStyle:'bold',padding:20},position:'right'}]}}});case 2:_this.chart=_context.sent;case 3:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref2.apply(this,arguments);};}(),_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ChartRanking,[{key:'componentDidMount',value:function componentDidMount(){this.ctx=this.chart.getContext('2d');this.initChart(this.props.results);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(_ref3){var _this3=this;var results=_ref3.results;if(results!==this.props.results){if(this.chart)this.chart.destroy();this.timer=setTimeout(function(){_this3.initChart(results);},200);}}},{key:'componentWillUnmount',value:function componentWillUnmount(){clearTimeout(this.timer);}},{key:'render',value:function render(){var _this4=this;var _props=this.props,height=_props.height,width=_props.width;var ready=this.state.ready;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'chart'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'label-charts'},'Evolution'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('canvas',{ref:function ref(chart){return _this4.chart=chart;}})));}}]);return ChartRanking;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(function(_ref4){var Session=_ref4.Session;return{results:Session.challenge.results};})(ChartRanking));

/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

/*!
 * Chart.js v2.9.4
 * https://www.chartjs.org
 * (c) 2020 Chart.js Contributors
 * Released under the MIT License
 */
(function (global, factory) {
 true ? module.exports = factory(function() { try { return __webpack_require__(48); } catch(e) { } }()) :
typeof define === 'function' && define.amd ? define(['require'], function(require) { return factory(function() { try { return require('moment'); } catch(e) { } }()); }) :
(global = global || self, global.Chart = factory(global.moment));
}(this, (function (moment) { 'use strict';

moment = moment && moment.hasOwnProperty('default') ? moment['default'] : moment;

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

function getCjsExportFromNamespace (n) {
	return n && n['default'] || n;
}

var colorName = {
	"aliceblue": [240, 248, 255],
	"antiquewhite": [250, 235, 215],
	"aqua": [0, 255, 255],
	"aquamarine": [127, 255, 212],
	"azure": [240, 255, 255],
	"beige": [245, 245, 220],
	"bisque": [255, 228, 196],
	"black": [0, 0, 0],
	"blanchedalmond": [255, 235, 205],
	"blue": [0, 0, 255],
	"blueviolet": [138, 43, 226],
	"brown": [165, 42, 42],
	"burlywood": [222, 184, 135],
	"cadetblue": [95, 158, 160],
	"chartreuse": [127, 255, 0],
	"chocolate": [210, 105, 30],
	"coral": [255, 127, 80],
	"cornflowerblue": [100, 149, 237],
	"cornsilk": [255, 248, 220],
	"crimson": [220, 20, 60],
	"cyan": [0, 255, 255],
	"darkblue": [0, 0, 139],
	"darkcyan": [0, 139, 139],
	"darkgoldenrod": [184, 134, 11],
	"darkgray": [169, 169, 169],
	"darkgreen": [0, 100, 0],
	"darkgrey": [169, 169, 169],
	"darkkhaki": [189, 183, 107],
	"darkmagenta": [139, 0, 139],
	"darkolivegreen": [85, 107, 47],
	"darkorange": [255, 140, 0],
	"darkorchid": [153, 50, 204],
	"darkred": [139, 0, 0],
	"darksalmon": [233, 150, 122],
	"darkseagreen": [143, 188, 143],
	"darkslateblue": [72, 61, 139],
	"darkslategray": [47, 79, 79],
	"darkslategrey": [47, 79, 79],
	"darkturquoise": [0, 206, 209],
	"darkviolet": [148, 0, 211],
	"deeppink": [255, 20, 147],
	"deepskyblue": [0, 191, 255],
	"dimgray": [105, 105, 105],
	"dimgrey": [105, 105, 105],
	"dodgerblue": [30, 144, 255],
	"firebrick": [178, 34, 34],
	"floralwhite": [255, 250, 240],
	"forestgreen": [34, 139, 34],
	"fuchsia": [255, 0, 255],
	"gainsboro": [220, 220, 220],
	"ghostwhite": [248, 248, 255],
	"gold": [255, 215, 0],
	"goldenrod": [218, 165, 32],
	"gray": [128, 128, 128],
	"green": [0, 128, 0],
	"greenyellow": [173, 255, 47],
	"grey": [128, 128, 128],
	"honeydew": [240, 255, 240],
	"hotpink": [255, 105, 180],
	"indianred": [205, 92, 92],
	"indigo": [75, 0, 130],
	"ivory": [255, 255, 240],
	"khaki": [240, 230, 140],
	"lavender": [230, 230, 250],
	"lavenderblush": [255, 240, 245],
	"lawngreen": [124, 252, 0],
	"lemonchiffon": [255, 250, 205],
	"lightblue": [173, 216, 230],
	"lightcoral": [240, 128, 128],
	"lightcyan": [224, 255, 255],
	"lightgoldenrodyellow": [250, 250, 210],
	"lightgray": [211, 211, 211],
	"lightgreen": [144, 238, 144],
	"lightgrey": [211, 211, 211],
	"lightpink": [255, 182, 193],
	"lightsalmon": [255, 160, 122],
	"lightseagreen": [32, 178, 170],
	"lightskyblue": [135, 206, 250],
	"lightslategray": [119, 136, 153],
	"lightslategrey": [119, 136, 153],
	"lightsteelblue": [176, 196, 222],
	"lightyellow": [255, 255, 224],
	"lime": [0, 255, 0],
	"limegreen": [50, 205, 50],
	"linen": [250, 240, 230],
	"magenta": [255, 0, 255],
	"maroon": [128, 0, 0],
	"mediumaquamarine": [102, 205, 170],
	"mediumblue": [0, 0, 205],
	"mediumorchid": [186, 85, 211],
	"mediumpurple": [147, 112, 219],
	"mediumseagreen": [60, 179, 113],
	"mediumslateblue": [123, 104, 238],
	"mediumspringgreen": [0, 250, 154],
	"mediumturquoise": [72, 209, 204],
	"mediumvioletred": [199, 21, 133],
	"midnightblue": [25, 25, 112],
	"mintcream": [245, 255, 250],
	"mistyrose": [255, 228, 225],
	"moccasin": [255, 228, 181],
	"navajowhite": [255, 222, 173],
	"navy": [0, 0, 128],
	"oldlace": [253, 245, 230],
	"olive": [128, 128, 0],
	"olivedrab": [107, 142, 35],
	"orange": [255, 165, 0],
	"orangered": [255, 69, 0],
	"orchid": [218, 112, 214],
	"palegoldenrod": [238, 232, 170],
	"palegreen": [152, 251, 152],
	"paleturquoise": [175, 238, 238],
	"palevioletred": [219, 112, 147],
	"papayawhip": [255, 239, 213],
	"peachpuff": [255, 218, 185],
	"peru": [205, 133, 63],
	"pink": [255, 192, 203],
	"plum": [221, 160, 221],
	"powderblue": [176, 224, 230],
	"purple": [128, 0, 128],
	"rebeccapurple": [102, 51, 153],
	"red": [255, 0, 0],
	"rosybrown": [188, 143, 143],
	"royalblue": [65, 105, 225],
	"saddlebrown": [139, 69, 19],
	"salmon": [250, 128, 114],
	"sandybrown": [244, 164, 96],
	"seagreen": [46, 139, 87],
	"seashell": [255, 245, 238],
	"sienna": [160, 82, 45],
	"silver": [192, 192, 192],
	"skyblue": [135, 206, 235],
	"slateblue": [106, 90, 205],
	"slategray": [112, 128, 144],
	"slategrey": [112, 128, 144],
	"snow": [255, 250, 250],
	"springgreen": [0, 255, 127],
	"steelblue": [70, 130, 180],
	"tan": [210, 180, 140],
	"teal": [0, 128, 128],
	"thistle": [216, 191, 216],
	"tomato": [255, 99, 71],
	"turquoise": [64, 224, 208],
	"violet": [238, 130, 238],
	"wheat": [245, 222, 179],
	"white": [255, 255, 255],
	"whitesmoke": [245, 245, 245],
	"yellow": [255, 255, 0],
	"yellowgreen": [154, 205, 50]
};

var conversions = createCommonjsModule(function (module) {
/* MIT license */


// NOTE: conversions should only return primitive values (i.e. arrays, or
//       values that give correct `typeof` results).
//       do not use box values types (i.e. Number(), String(), etc.)

var reverseKeywords = {};
for (var key in colorName) {
	if (colorName.hasOwnProperty(key)) {
		reverseKeywords[colorName[key]] = key;
	}
}

var convert = module.exports = {
	rgb: {channels: 3, labels: 'rgb'},
	hsl: {channels: 3, labels: 'hsl'},
	hsv: {channels: 3, labels: 'hsv'},
	hwb: {channels: 3, labels: 'hwb'},
	cmyk: {channels: 4, labels: 'cmyk'},
	xyz: {channels: 3, labels: 'xyz'},
	lab: {channels: 3, labels: 'lab'},
	lch: {channels: 3, labels: 'lch'},
	hex: {channels: 1, labels: ['hex']},
	keyword: {channels: 1, labels: ['keyword']},
	ansi16: {channels: 1, labels: ['ansi16']},
	ansi256: {channels: 1, labels: ['ansi256']},
	hcg: {channels: 3, labels: ['h', 'c', 'g']},
	apple: {channels: 3, labels: ['r16', 'g16', 'b16']},
	gray: {channels: 1, labels: ['gray']}
};

// hide .channels and .labels properties
for (var model in convert) {
	if (convert.hasOwnProperty(model)) {
		if (!('channels' in convert[model])) {
			throw new Error('missing channels property: ' + model);
		}

		if (!('labels' in convert[model])) {
			throw new Error('missing channel labels property: ' + model);
		}

		if (convert[model].labels.length !== convert[model].channels) {
			throw new Error('channel and label counts mismatch: ' + model);
		}

		var channels = convert[model].channels;
		var labels = convert[model].labels;
		delete convert[model].channels;
		delete convert[model].labels;
		Object.defineProperty(convert[model], 'channels', {value: channels});
		Object.defineProperty(convert[model], 'labels', {value: labels});
	}
}

convert.rgb.hsl = function (rgb) {
	var r = rgb[0] / 255;
	var g = rgb[1] / 255;
	var b = rgb[2] / 255;
	var min = Math.min(r, g, b);
	var max = Math.max(r, g, b);
	var delta = max - min;
	var h;
	var s;
	var l;

	if (max === min) {
		h = 0;
	} else if (r === max) {
		h = (g - b) / delta;
	} else if (g === max) {
		h = 2 + (b - r) / delta;
	} else if (b === max) {
		h = 4 + (r - g) / delta;
	}

	h = Math.min(h * 60, 360);

	if (h < 0) {
		h += 360;
	}

	l = (min + max) / 2;

	if (max === min) {
		s = 0;
	} else if (l <= 0.5) {
		s = delta / (max + min);
	} else {
		s = delta / (2 - max - min);
	}

	return [h, s * 100, l * 100];
};

convert.rgb.hsv = function (rgb) {
	var rdif;
	var gdif;
	var bdif;
	var h;
	var s;

	var r = rgb[0] / 255;
	var g = rgb[1] / 255;
	var b = rgb[2] / 255;
	var v = Math.max(r, g, b);
	var diff = v - Math.min(r, g, b);
	var diffc = function (c) {
		return (v - c) / 6 / diff + 1 / 2;
	};

	if (diff === 0) {
		h = s = 0;
	} else {
		s = diff / v;
		rdif = diffc(r);
		gdif = diffc(g);
		bdif = diffc(b);

		if (r === v) {
			h = bdif - gdif;
		} else if (g === v) {
			h = (1 / 3) + rdif - bdif;
		} else if (b === v) {
			h = (2 / 3) + gdif - rdif;
		}
		if (h < 0) {
			h += 1;
		} else if (h > 1) {
			h -= 1;
		}
	}

	return [
		h * 360,
		s * 100,
		v * 100
	];
};

convert.rgb.hwb = function (rgb) {
	var r = rgb[0];
	var g = rgb[1];
	var b = rgb[2];
	var h = convert.rgb.hsl(rgb)[0];
	var w = 1 / 255 * Math.min(r, Math.min(g, b));

	b = 1 - 1 / 255 * Math.max(r, Math.max(g, b));

	return [h, w * 100, b * 100];
};

convert.rgb.cmyk = function (rgb) {
	var r = rgb[0] / 255;
	var g = rgb[1] / 255;
	var b = rgb[2] / 255;
	var c;
	var m;
	var y;
	var k;

	k = Math.min(1 - r, 1 - g, 1 - b);
	c = (1 - r - k) / (1 - k) || 0;
	m = (1 - g - k) / (1 - k) || 0;
	y = (1 - b - k) / (1 - k) || 0;

	return [c * 100, m * 100, y * 100, k * 100];
};

/**
 * See https://en.m.wikipedia.org/wiki/Euclidean_distance#Squared_Euclidean_distance
 * */
function comparativeDistance(x, y) {
	return (
		Math.pow(x[0] - y[0], 2) +
		Math.pow(x[1] - y[1], 2) +
		Math.pow(x[2] - y[2], 2)
	);
}

convert.rgb.keyword = function (rgb) {
	var reversed = reverseKeywords[rgb];
	if (reversed) {
		return reversed;
	}

	var currentClosestDistance = Infinity;
	var currentClosestKeyword;

	for (var keyword in colorName) {
		if (colorName.hasOwnProperty(keyword)) {
			var value = colorName[keyword];

			// Compute comparative distance
			var distance = comparativeDistance(rgb, value);

			// Check if its less, if so set as closest
			if (distance < currentClosestDistance) {
				currentClosestDistance = distance;
				currentClosestKeyword = keyword;
			}
		}
	}

	return currentClosestKeyword;
};

convert.keyword.rgb = function (keyword) {
	return colorName[keyword];
};

convert.rgb.xyz = function (rgb) {
	var r = rgb[0] / 255;
	var g = rgb[1] / 255;
	var b = rgb[2] / 255;

	// assume sRGB
	r = r > 0.04045 ? Math.pow(((r + 0.055) / 1.055), 2.4) : (r / 12.92);
	g = g > 0.04045 ? Math.pow(((g + 0.055) / 1.055), 2.4) : (g / 12.92);
	b = b > 0.04045 ? Math.pow(((b + 0.055) / 1.055), 2.4) : (b / 12.92);

	var x = (r * 0.4124) + (g * 0.3576) + (b * 0.1805);
	var y = (r * 0.2126) + (g * 0.7152) + (b * 0.0722);
	var z = (r * 0.0193) + (g * 0.1192) + (b * 0.9505);

	return [x * 100, y * 100, z * 100];
};

convert.rgb.lab = function (rgb) {
	var xyz = convert.rgb.xyz(rgb);
	var x = xyz[0];
	var y = xyz[1];
	var z = xyz[2];
	var l;
	var a;
	var b;

	x /= 95.047;
	y /= 100;
	z /= 108.883;

	x = x > 0.008856 ? Math.pow(x, 1 / 3) : (7.787 * x) + (16 / 116);
	y = y > 0.008856 ? Math.pow(y, 1 / 3) : (7.787 * y) + (16 / 116);
	z = z > 0.008856 ? Math.pow(z, 1 / 3) : (7.787 * z) + (16 / 116);

	l = (116 * y) - 16;
	a = 500 * (x - y);
	b = 200 * (y - z);

	return [l, a, b];
};

convert.hsl.rgb = function (hsl) {
	var h = hsl[0] / 360;
	var s = hsl[1] / 100;
	var l = hsl[2] / 100;
	var t1;
	var t2;
	var t3;
	var rgb;
	var val;

	if (s === 0) {
		val = l * 255;
		return [val, val, val];
	}

	if (l < 0.5) {
		t2 = l * (1 + s);
	} else {
		t2 = l + s - l * s;
	}

	t1 = 2 * l - t2;

	rgb = [0, 0, 0];
	for (var i = 0; i < 3; i++) {
		t3 = h + 1 / 3 * -(i - 1);
		if (t3 < 0) {
			t3++;
		}
		if (t3 > 1) {
			t3--;
		}

		if (6 * t3 < 1) {
			val = t1 + (t2 - t1) * 6 * t3;
		} else if (2 * t3 < 1) {
			val = t2;
		} else if (3 * t3 < 2) {
			val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
		} else {
			val = t1;
		}

		rgb[i] = val * 255;
	}

	return rgb;
};

convert.hsl.hsv = function (hsl) {
	var h = hsl[0];
	var s = hsl[1] / 100;
	var l = hsl[2] / 100;
	var smin = s;
	var lmin = Math.max(l, 0.01);
	var sv;
	var v;

	l *= 2;
	s *= (l <= 1) ? l : 2 - l;
	smin *= lmin <= 1 ? lmin : 2 - lmin;
	v = (l + s) / 2;
	sv = l === 0 ? (2 * smin) / (lmin + smin) : (2 * s) / (l + s);

	return [h, sv * 100, v * 100];
};

convert.hsv.rgb = function (hsv) {
	var h = hsv[0] / 60;
	var s = hsv[1] / 100;
	var v = hsv[2] / 100;
	var hi = Math.floor(h) % 6;

	var f = h - Math.floor(h);
	var p = 255 * v * (1 - s);
	var q = 255 * v * (1 - (s * f));
	var t = 255 * v * (1 - (s * (1 - f)));
	v *= 255;

	switch (hi) {
		case 0:
			return [v, t, p];
		case 1:
			return [q, v, p];
		case 2:
			return [p, v, t];
		case 3:
			return [p, q, v];
		case 4:
			return [t, p, v];
		case 5:
			return [v, p, q];
	}
};

convert.hsv.hsl = function (hsv) {
	var h = hsv[0];
	var s = hsv[1] / 100;
	var v = hsv[2] / 100;
	var vmin = Math.max(v, 0.01);
	var lmin;
	var sl;
	var l;

	l = (2 - s) * v;
	lmin = (2 - s) * vmin;
	sl = s * vmin;
	sl /= (lmin <= 1) ? lmin : 2 - lmin;
	sl = sl || 0;
	l /= 2;

	return [h, sl * 100, l * 100];
};

// http://dev.w3.org/csswg/css-color/#hwb-to-rgb
convert.hwb.rgb = function (hwb) {
	var h = hwb[0] / 360;
	var wh = hwb[1] / 100;
	var bl = hwb[2] / 100;
	var ratio = wh + bl;
	var i;
	var v;
	var f;
	var n;

	// wh + bl cant be > 1
	if (ratio > 1) {
		wh /= ratio;
		bl /= ratio;
	}

	i = Math.floor(6 * h);
	v = 1 - bl;
	f = 6 * h - i;

	if ((i & 0x01) !== 0) {
		f = 1 - f;
	}

	n = wh + f * (v - wh); // linear interpolation

	var r;
	var g;
	var b;
	switch (i) {
		default:
		case 6:
		case 0: r = v; g = n; b = wh; break;
		case 1: r = n; g = v; b = wh; break;
		case 2: r = wh; g = v; b = n; break;
		case 3: r = wh; g = n; b = v; break;
		case 4: r = n; g = wh; b = v; break;
		case 5: r = v; g = wh; b = n; break;
	}

	return [r * 255, g * 255, b * 255];
};

convert.cmyk.rgb = function (cmyk) {
	var c = cmyk[0] / 100;
	var m = cmyk[1] / 100;
	var y = cmyk[2] / 100;
	var k = cmyk[3] / 100;
	var r;
	var g;
	var b;

	r = 1 - Math.min(1, c * (1 - k) + k);
	g = 1 - Math.min(1, m * (1 - k) + k);
	b = 1 - Math.min(1, y * (1 - k) + k);

	return [r * 255, g * 255, b * 255];
};

convert.xyz.rgb = function (xyz) {
	var x = xyz[0] / 100;
	var y = xyz[1] / 100;
	var z = xyz[2] / 100;
	var r;
	var g;
	var b;

	r = (x * 3.2406) + (y * -1.5372) + (z * -0.4986);
	g = (x * -0.9689) + (y * 1.8758) + (z * 0.0415);
	b = (x * 0.0557) + (y * -0.2040) + (z * 1.0570);

	// assume sRGB
	r = r > 0.0031308
		? ((1.055 * Math.pow(r, 1.0 / 2.4)) - 0.055)
		: r * 12.92;

	g = g > 0.0031308
		? ((1.055 * Math.pow(g, 1.0 / 2.4)) - 0.055)
		: g * 12.92;

	b = b > 0.0031308
		? ((1.055 * Math.pow(b, 1.0 / 2.4)) - 0.055)
		: b * 12.92;

	r = Math.min(Math.max(0, r), 1);
	g = Math.min(Math.max(0, g), 1);
	b = Math.min(Math.max(0, b), 1);

	return [r * 255, g * 255, b * 255];
};

convert.xyz.lab = function (xyz) {
	var x = xyz[0];
	var y = xyz[1];
	var z = xyz[2];
	var l;
	var a;
	var b;

	x /= 95.047;
	y /= 100;
	z /= 108.883;

	x = x > 0.008856 ? Math.pow(x, 1 / 3) : (7.787 * x) + (16 / 116);
	y = y > 0.008856 ? Math.pow(y, 1 / 3) : (7.787 * y) + (16 / 116);
	z = z > 0.008856 ? Math.pow(z, 1 / 3) : (7.787 * z) + (16 / 116);

	l = (116 * y) - 16;
	a = 500 * (x - y);
	b = 200 * (y - z);

	return [l, a, b];
};

convert.lab.xyz = function (lab) {
	var l = lab[0];
	var a = lab[1];
	var b = lab[2];
	var x;
	var y;
	var z;

	y = (l + 16) / 116;
	x = a / 500 + y;
	z = y - b / 200;

	var y2 = Math.pow(y, 3);
	var x2 = Math.pow(x, 3);
	var z2 = Math.pow(z, 3);
	y = y2 > 0.008856 ? y2 : (y - 16 / 116) / 7.787;
	x = x2 > 0.008856 ? x2 : (x - 16 / 116) / 7.787;
	z = z2 > 0.008856 ? z2 : (z - 16 / 116) / 7.787;

	x *= 95.047;
	y *= 100;
	z *= 108.883;

	return [x, y, z];
};

convert.lab.lch = function (lab) {
	var l = lab[0];
	var a = lab[1];
	var b = lab[2];
	var hr;
	var h;
	var c;

	hr = Math.atan2(b, a);
	h = hr * 360 / 2 / Math.PI;

	if (h < 0) {
		h += 360;
	}

	c = Math.sqrt(a * a + b * b);

	return [l, c, h];
};

convert.lch.lab = function (lch) {
	var l = lch[0];
	var c = lch[1];
	var h = lch[2];
	var a;
	var b;
	var hr;

	hr = h / 360 * 2 * Math.PI;
	a = c * Math.cos(hr);
	b = c * Math.sin(hr);

	return [l, a, b];
};

convert.rgb.ansi16 = function (args) {
	var r = args[0];
	var g = args[1];
	var b = args[2];
	var value = 1 in arguments ? arguments[1] : convert.rgb.hsv(args)[2]; // hsv -> ansi16 optimization

	value = Math.round(value / 50);

	if (value === 0) {
		return 30;
	}

	var ansi = 30
		+ ((Math.round(b / 255) << 2)
		| (Math.round(g / 255) << 1)
		| Math.round(r / 255));

	if (value === 2) {
		ansi += 60;
	}

	return ansi;
};

convert.hsv.ansi16 = function (args) {
	// optimization here; we already know the value and don't need to get
	// it converted for us.
	return convert.rgb.ansi16(convert.hsv.rgb(args), args[2]);
};

convert.rgb.ansi256 = function (args) {
	var r = args[0];
	var g = args[1];
	var b = args[2];

	// we use the extended greyscale palette here, with the exception of
	// black and white. normal palette only has 4 greyscale shades.
	if (r === g && g === b) {
		if (r < 8) {
			return 16;
		}

		if (r > 248) {
			return 231;
		}

		return Math.round(((r - 8) / 247) * 24) + 232;
	}

	var ansi = 16
		+ (36 * Math.round(r / 255 * 5))
		+ (6 * Math.round(g / 255 * 5))
		+ Math.round(b / 255 * 5);

	return ansi;
};

convert.ansi16.rgb = function (args) {
	var color = args % 10;

	// handle greyscale
	if (color === 0 || color === 7) {
		if (args > 50) {
			color += 3.5;
		}

		color = color / 10.5 * 255;

		return [color, color, color];
	}

	var mult = (~~(args > 50) + 1) * 0.5;
	var r = ((color & 1) * mult) * 255;
	var g = (((color >> 1) & 1) * mult) * 255;
	var b = (((color >> 2) & 1) * mult) * 255;

	return [r, g, b];
};

convert.ansi256.rgb = function (args) {
	// handle greyscale
	if (args >= 232) {
		var c = (args - 232) * 10 + 8;
		return [c, c, c];
	}

	args -= 16;

	var rem;
	var r = Math.floor(args / 36) / 5 * 255;
	var g = Math.floor((rem = args % 36) / 6) / 5 * 255;
	var b = (rem % 6) / 5 * 255;

	return [r, g, b];
};

convert.rgb.hex = function (args) {
	var integer = ((Math.round(args[0]) & 0xFF) << 16)
		+ ((Math.round(args[1]) & 0xFF) << 8)
		+ (Math.round(args[2]) & 0xFF);

	var string = integer.toString(16).toUpperCase();
	return '000000'.substring(string.length) + string;
};

convert.hex.rgb = function (args) {
	var match = args.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
	if (!match) {
		return [0, 0, 0];
	}

	var colorString = match[0];

	if (match[0].length === 3) {
		colorString = colorString.split('').map(function (char) {
			return char + char;
		}).join('');
	}

	var integer = parseInt(colorString, 16);
	var r = (integer >> 16) & 0xFF;
	var g = (integer >> 8) & 0xFF;
	var b = integer & 0xFF;

	return [r, g, b];
};

convert.rgb.hcg = function (rgb) {
	var r = rgb[0] / 255;
	var g = rgb[1] / 255;
	var b = rgb[2] / 255;
	var max = Math.max(Math.max(r, g), b);
	var min = Math.min(Math.min(r, g), b);
	var chroma = (max - min);
	var grayscale;
	var hue;

	if (chroma < 1) {
		grayscale = min / (1 - chroma);
	} else {
		grayscale = 0;
	}

	if (chroma <= 0) {
		hue = 0;
	} else
	if (max === r) {
		hue = ((g - b) / chroma) % 6;
	} else
	if (max === g) {
		hue = 2 + (b - r) / chroma;
	} else {
		hue = 4 + (r - g) / chroma + 4;
	}

	hue /= 6;
	hue %= 1;

	return [hue * 360, chroma * 100, grayscale * 100];
};

convert.hsl.hcg = function (hsl) {
	var s = hsl[1] / 100;
	var l = hsl[2] / 100;
	var c = 1;
	var f = 0;

	if (l < 0.5) {
		c = 2.0 * s * l;
	} else {
		c = 2.0 * s * (1.0 - l);
	}

	if (c < 1.0) {
		f = (l - 0.5 * c) / (1.0 - c);
	}

	return [hsl[0], c * 100, f * 100];
};

convert.hsv.hcg = function (hsv) {
	var s = hsv[1] / 100;
	var v = hsv[2] / 100;

	var c = s * v;
	var f = 0;

	if (c < 1.0) {
		f = (v - c) / (1 - c);
	}

	return [hsv[0], c * 100, f * 100];
};

convert.hcg.rgb = function (hcg) {
	var h = hcg[0] / 360;
	var c = hcg[1] / 100;
	var g = hcg[2] / 100;

	if (c === 0.0) {
		return [g * 255, g * 255, g * 255];
	}

	var pure = [0, 0, 0];
	var hi = (h % 1) * 6;
	var v = hi % 1;
	var w = 1 - v;
	var mg = 0;

	switch (Math.floor(hi)) {
		case 0:
			pure[0] = 1; pure[1] = v; pure[2] = 0; break;
		case 1:
			pure[0] = w; pure[1] = 1; pure[2] = 0; break;
		case 2:
			pure[0] = 0; pure[1] = 1; pure[2] = v; break;
		case 3:
			pure[0] = 0; pure[1] = w; pure[2] = 1; break;
		case 4:
			pure[0] = v; pure[1] = 0; pure[2] = 1; break;
		default:
			pure[0] = 1; pure[1] = 0; pure[2] = w;
	}

	mg = (1.0 - c) * g;

	return [
		(c * pure[0] + mg) * 255,
		(c * pure[1] + mg) * 255,
		(c * pure[2] + mg) * 255
	];
};

convert.hcg.hsv = function (hcg) {
	var c = hcg[1] / 100;
	var g = hcg[2] / 100;

	var v = c + g * (1.0 - c);
	var f = 0;

	if (v > 0.0) {
		f = c / v;
	}

	return [hcg[0], f * 100, v * 100];
};

convert.hcg.hsl = function (hcg) {
	var c = hcg[1] / 100;
	var g = hcg[2] / 100;

	var l = g * (1.0 - c) + 0.5 * c;
	var s = 0;

	if (l > 0.0 && l < 0.5) {
		s = c / (2 * l);
	} else
	if (l >= 0.5 && l < 1.0) {
		s = c / (2 * (1 - l));
	}

	return [hcg[0], s * 100, l * 100];
};

convert.hcg.hwb = function (hcg) {
	var c = hcg[1] / 100;
	var g = hcg[2] / 100;
	var v = c + g * (1.0 - c);
	return [hcg[0], (v - c) * 100, (1 - v) * 100];
};

convert.hwb.hcg = function (hwb) {
	var w = hwb[1] / 100;
	var b = hwb[2] / 100;
	var v = 1 - b;
	var c = v - w;
	var g = 0;

	if (c < 1) {
		g = (v - c) / (1 - c);
	}

	return [hwb[0], c * 100, g * 100];
};

convert.apple.rgb = function (apple) {
	return [(apple[0] / 65535) * 255, (apple[1] / 65535) * 255, (apple[2] / 65535) * 255];
};

convert.rgb.apple = function (rgb) {
	return [(rgb[0] / 255) * 65535, (rgb[1] / 255) * 65535, (rgb[2] / 255) * 65535];
};

convert.gray.rgb = function (args) {
	return [args[0] / 100 * 255, args[0] / 100 * 255, args[0] / 100 * 255];
};

convert.gray.hsl = convert.gray.hsv = function (args) {
	return [0, 0, args[0]];
};

convert.gray.hwb = function (gray) {
	return [0, 100, gray[0]];
};

convert.gray.cmyk = function (gray) {
	return [0, 0, 0, gray[0]];
};

convert.gray.lab = function (gray) {
	return [gray[0], 0, 0];
};

convert.gray.hex = function (gray) {
	var val = Math.round(gray[0] / 100 * 255) & 0xFF;
	var integer = (val << 16) + (val << 8) + val;

	var string = integer.toString(16).toUpperCase();
	return '000000'.substring(string.length) + string;
};

convert.rgb.gray = function (rgb) {
	var val = (rgb[0] + rgb[1] + rgb[2]) / 3;
	return [val / 255 * 100];
};
});
var conversions_1 = conversions.rgb;
var conversions_2 = conversions.hsl;
var conversions_3 = conversions.hsv;
var conversions_4 = conversions.hwb;
var conversions_5 = conversions.cmyk;
var conversions_6 = conversions.xyz;
var conversions_7 = conversions.lab;
var conversions_8 = conversions.lch;
var conversions_9 = conversions.hex;
var conversions_10 = conversions.keyword;
var conversions_11 = conversions.ansi16;
var conversions_12 = conversions.ansi256;
var conversions_13 = conversions.hcg;
var conversions_14 = conversions.apple;
var conversions_15 = conversions.gray;

/*
	this function routes a model to all other models.

	all functions that are routed have a property `.conversion` attached
	to the returned synthetic function. This property is an array
	of strings, each with the steps in between the 'from' and 'to'
	color models (inclusive).

	conversions that are not possible simply are not included.
*/

function buildGraph() {
	var graph = {};
	// https://jsperf.com/object-keys-vs-for-in-with-closure/3
	var models = Object.keys(conversions);

	for (var len = models.length, i = 0; i < len; i++) {
		graph[models[i]] = {
			// http://jsperf.com/1-vs-infinity
			// micro-opt, but this is simple.
			distance: -1,
			parent: null
		};
	}

	return graph;
}

// https://en.wikipedia.org/wiki/Breadth-first_search
function deriveBFS(fromModel) {
	var graph = buildGraph();
	var queue = [fromModel]; // unshift -> queue -> pop

	graph[fromModel].distance = 0;

	while (queue.length) {
		var current = queue.pop();
		var adjacents = Object.keys(conversions[current]);

		for (var len = adjacents.length, i = 0; i < len; i++) {
			var adjacent = adjacents[i];
			var node = graph[adjacent];

			if (node.distance === -1) {
				node.distance = graph[current].distance + 1;
				node.parent = current;
				queue.unshift(adjacent);
			}
		}
	}

	return graph;
}

function link(from, to) {
	return function (args) {
		return to(from(args));
	};
}

function wrapConversion(toModel, graph) {
	var path = [graph[toModel].parent, toModel];
	var fn = conversions[graph[toModel].parent][toModel];

	var cur = graph[toModel].parent;
	while (graph[cur].parent) {
		path.unshift(graph[cur].parent);
		fn = link(conversions[graph[cur].parent][cur], fn);
		cur = graph[cur].parent;
	}

	fn.conversion = path;
	return fn;
}

var route = function (fromModel) {
	var graph = deriveBFS(fromModel);
	var conversion = {};

	var models = Object.keys(graph);
	for (var len = models.length, i = 0; i < len; i++) {
		var toModel = models[i];
		var node = graph[toModel];

		if (node.parent === null) {
			// no possible conversion, or this node is the source model.
			continue;
		}

		conversion[toModel] = wrapConversion(toModel, graph);
	}

	return conversion;
};

var convert = {};

var models = Object.keys(conversions);

function wrapRaw(fn) {
	var wrappedFn = function (args) {
		if (args === undefined || args === null) {
			return args;
		}

		if (arguments.length > 1) {
			args = Array.prototype.slice.call(arguments);
		}

		return fn(args);
	};

	// preserve .conversion property if there is one
	if ('conversion' in fn) {
		wrappedFn.conversion = fn.conversion;
	}

	return wrappedFn;
}

function wrapRounded(fn) {
	var wrappedFn = function (args) {
		if (args === undefined || args === null) {
			return args;
		}

		if (arguments.length > 1) {
			args = Array.prototype.slice.call(arguments);
		}

		var result = fn(args);

		// we're assuming the result is an array here.
		// see notice in conversions.js; don't use box types
		// in conversion functions.
		if (typeof result === 'object') {
			for (var len = result.length, i = 0; i < len; i++) {
				result[i] = Math.round(result[i]);
			}
		}

		return result;
	};

	// preserve .conversion property if there is one
	if ('conversion' in fn) {
		wrappedFn.conversion = fn.conversion;
	}

	return wrappedFn;
}

models.forEach(function (fromModel) {
	convert[fromModel] = {};

	Object.defineProperty(convert[fromModel], 'channels', {value: conversions[fromModel].channels});
	Object.defineProperty(convert[fromModel], 'labels', {value: conversions[fromModel].labels});

	var routes = route(fromModel);
	var routeModels = Object.keys(routes);

	routeModels.forEach(function (toModel) {
		var fn = routes[toModel];

		convert[fromModel][toModel] = wrapRounded(fn);
		convert[fromModel][toModel].raw = wrapRaw(fn);
	});
});

var colorConvert = convert;

var colorName$1 = {
	"aliceblue": [240, 248, 255],
	"antiquewhite": [250, 235, 215],
	"aqua": [0, 255, 255],
	"aquamarine": [127, 255, 212],
	"azure": [240, 255, 255],
	"beige": [245, 245, 220],
	"bisque": [255, 228, 196],
	"black": [0, 0, 0],
	"blanchedalmond": [255, 235, 205],
	"blue": [0, 0, 255],
	"blueviolet": [138, 43, 226],
	"brown": [165, 42, 42],
	"burlywood": [222, 184, 135],
	"cadetblue": [95, 158, 160],
	"chartreuse": [127, 255, 0],
	"chocolate": [210, 105, 30],
	"coral": [255, 127, 80],
	"cornflowerblue": [100, 149, 237],
	"cornsilk": [255, 248, 220],
	"crimson": [220, 20, 60],
	"cyan": [0, 255, 255],
	"darkblue": [0, 0, 139],
	"darkcyan": [0, 139, 139],
	"darkgoldenrod": [184, 134, 11],
	"darkgray": [169, 169, 169],
	"darkgreen": [0, 100, 0],
	"darkgrey": [169, 169, 169],
	"darkkhaki": [189, 183, 107],
	"darkmagenta": [139, 0, 139],
	"darkolivegreen": [85, 107, 47],
	"darkorange": [255, 140, 0],
	"darkorchid": [153, 50, 204],
	"darkred": [139, 0, 0],
	"darksalmon": [233, 150, 122],
	"darkseagreen": [143, 188, 143],
	"darkslateblue": [72, 61, 139],
	"darkslategray": [47, 79, 79],
	"darkslategrey": [47, 79, 79],
	"darkturquoise": [0, 206, 209],
	"darkviolet": [148, 0, 211],
	"deeppink": [255, 20, 147],
	"deepskyblue": [0, 191, 255],
	"dimgray": [105, 105, 105],
	"dimgrey": [105, 105, 105],
	"dodgerblue": [30, 144, 255],
	"firebrick": [178, 34, 34],
	"floralwhite": [255, 250, 240],
	"forestgreen": [34, 139, 34],
	"fuchsia": [255, 0, 255],
	"gainsboro": [220, 220, 220],
	"ghostwhite": [248, 248, 255],
	"gold": [255, 215, 0],
	"goldenrod": [218, 165, 32],
	"gray": [128, 128, 128],
	"green": [0, 128, 0],
	"greenyellow": [173, 255, 47],
	"grey": [128, 128, 128],
	"honeydew": [240, 255, 240],
	"hotpink": [255, 105, 180],
	"indianred": [205, 92, 92],
	"indigo": [75, 0, 130],
	"ivory": [255, 255, 240],
	"khaki": [240, 230, 140],
	"lavender": [230, 230, 250],
	"lavenderblush": [255, 240, 245],
	"lawngreen": [124, 252, 0],
	"lemonchiffon": [255, 250, 205],
	"lightblue": [173, 216, 230],
	"lightcoral": [240, 128, 128],
	"lightcyan": [224, 255, 255],
	"lightgoldenrodyellow": [250, 250, 210],
	"lightgray": [211, 211, 211],
	"lightgreen": [144, 238, 144],
	"lightgrey": [211, 211, 211],
	"lightpink": [255, 182, 193],
	"lightsalmon": [255, 160, 122],
	"lightseagreen": [32, 178, 170],
	"lightskyblue": [135, 206, 250],
	"lightslategray": [119, 136, 153],
	"lightslategrey": [119, 136, 153],
	"lightsteelblue": [176, 196, 222],
	"lightyellow": [255, 255, 224],
	"lime": [0, 255, 0],
	"limegreen": [50, 205, 50],
	"linen": [250, 240, 230],
	"magenta": [255, 0, 255],
	"maroon": [128, 0, 0],
	"mediumaquamarine": [102, 205, 170],
	"mediumblue": [0, 0, 205],
	"mediumorchid": [186, 85, 211],
	"mediumpurple": [147, 112, 219],
	"mediumseagreen": [60, 179, 113],
	"mediumslateblue": [123, 104, 238],
	"mediumspringgreen": [0, 250, 154],
	"mediumturquoise": [72, 209, 204],
	"mediumvioletred": [199, 21, 133],
	"midnightblue": [25, 25, 112],
	"mintcream": [245, 255, 250],
	"mistyrose": [255, 228, 225],
	"moccasin": [255, 228, 181],
	"navajowhite": [255, 222, 173],
	"navy": [0, 0, 128],
	"oldlace": [253, 245, 230],
	"olive": [128, 128, 0],
	"olivedrab": [107, 142, 35],
	"orange": [255, 165, 0],
	"orangered": [255, 69, 0],
	"orchid": [218, 112, 214],
	"palegoldenrod": [238, 232, 170],
	"palegreen": [152, 251, 152],
	"paleturquoise": [175, 238, 238],
	"palevioletred": [219, 112, 147],
	"papayawhip": [255, 239, 213],
	"peachpuff": [255, 218, 185],
	"peru": [205, 133, 63],
	"pink": [255, 192, 203],
	"plum": [221, 160, 221],
	"powderblue": [176, 224, 230],
	"purple": [128, 0, 128],
	"rebeccapurple": [102, 51, 153],
	"red": [255, 0, 0],
	"rosybrown": [188, 143, 143],
	"royalblue": [65, 105, 225],
	"saddlebrown": [139, 69, 19],
	"salmon": [250, 128, 114],
	"sandybrown": [244, 164, 96],
	"seagreen": [46, 139, 87],
	"seashell": [255, 245, 238],
	"sienna": [160, 82, 45],
	"silver": [192, 192, 192],
	"skyblue": [135, 206, 235],
	"slateblue": [106, 90, 205],
	"slategray": [112, 128, 144],
	"slategrey": [112, 128, 144],
	"snow": [255, 250, 250],
	"springgreen": [0, 255, 127],
	"steelblue": [70, 130, 180],
	"tan": [210, 180, 140],
	"teal": [0, 128, 128],
	"thistle": [216, 191, 216],
	"tomato": [255, 99, 71],
	"turquoise": [64, 224, 208],
	"violet": [238, 130, 238],
	"wheat": [245, 222, 179],
	"white": [255, 255, 255],
	"whitesmoke": [245, 245, 245],
	"yellow": [255, 255, 0],
	"yellowgreen": [154, 205, 50]
};

/* MIT license */


var colorString = {
   getRgba: getRgba,
   getHsla: getHsla,
   getRgb: getRgb,
   getHsl: getHsl,
   getHwb: getHwb,
   getAlpha: getAlpha,

   hexString: hexString,
   rgbString: rgbString,
   rgbaString: rgbaString,
   percentString: percentString,
   percentaString: percentaString,
   hslString: hslString,
   hslaString: hslaString,
   hwbString: hwbString,
   keyword: keyword
};

function getRgba(string) {
   if (!string) {
      return;
   }
   var abbr =  /^#([a-fA-F0-9]{3,4})$/i,
       hex =  /^#([a-fA-F0-9]{6}([a-fA-F0-9]{2})?)$/i,
       rgba = /^rgba?\(\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/i,
       per = /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/i,
       keyword = /(\w+)/;

   var rgb = [0, 0, 0],
       a = 1,
       match = string.match(abbr),
       hexAlpha = "";
   if (match) {
      match = match[1];
      hexAlpha = match[3];
      for (var i = 0; i < rgb.length; i++) {
         rgb[i] = parseInt(match[i] + match[i], 16);
      }
      if (hexAlpha) {
         a = Math.round((parseInt(hexAlpha + hexAlpha, 16) / 255) * 100) / 100;
      }
   }
   else if (match = string.match(hex)) {
      hexAlpha = match[2];
      match = match[1];
      for (var i = 0; i < rgb.length; i++) {
         rgb[i] = parseInt(match.slice(i * 2, i * 2 + 2), 16);
      }
      if (hexAlpha) {
         a = Math.round((parseInt(hexAlpha, 16) / 255) * 100) / 100;
      }
   }
   else if (match = string.match(rgba)) {
      for (var i = 0; i < rgb.length; i++) {
         rgb[i] = parseInt(match[i + 1]);
      }
      a = parseFloat(match[4]);
   }
   else if (match = string.match(per)) {
      for (var i = 0; i < rgb.length; i++) {
         rgb[i] = Math.round(parseFloat(match[i + 1]) * 2.55);
      }
      a = parseFloat(match[4]);
   }
   else if (match = string.match(keyword)) {
      if (match[1] == "transparent") {
         return [0, 0, 0, 0];
      }
      rgb = colorName$1[match[1]];
      if (!rgb) {
         return;
      }
   }

   for (var i = 0; i < rgb.length; i++) {
      rgb[i] = scale(rgb[i], 0, 255);
   }
   if (!a && a != 0) {
      a = 1;
   }
   else {
      a = scale(a, 0, 1);
   }
   rgb[3] = a;
   return rgb;
}

function getHsla(string) {
   if (!string) {
      return;
   }
   var hsl = /^hsla?\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
   var match = string.match(hsl);
   if (match) {
      var alpha = parseFloat(match[4]);
      var h = scale(parseInt(match[1]), 0, 360),
          s = scale(parseFloat(match[2]), 0, 100),
          l = scale(parseFloat(match[3]), 0, 100),
          a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
      return [h, s, l, a];
   }
}

function getHwb(string) {
   if (!string) {
      return;
   }
   var hwb = /^hwb\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
   var match = string.match(hwb);
   if (match) {
    var alpha = parseFloat(match[4]);
      var h = scale(parseInt(match[1]), 0, 360),
          w = scale(parseFloat(match[2]), 0, 100),
          b = scale(parseFloat(match[3]), 0, 100),
          a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
      return [h, w, b, a];
   }
}

function getRgb(string) {
   var rgba = getRgba(string);
   return rgba && rgba.slice(0, 3);
}

function getHsl(string) {
  var hsla = getHsla(string);
  return hsla && hsla.slice(0, 3);
}

function getAlpha(string) {
   var vals = getRgba(string);
   if (vals) {
      return vals[3];
   }
   else if (vals = getHsla(string)) {
      return vals[3];
   }
   else if (vals = getHwb(string)) {
      return vals[3];
   }
}

// generators
function hexString(rgba, a) {
   var a = (a !== undefined && rgba.length === 3) ? a : rgba[3];
   return "#" + hexDouble(rgba[0]) 
              + hexDouble(rgba[1])
              + hexDouble(rgba[2])
              + (
                 (a >= 0 && a < 1)
                 ? hexDouble(Math.round(a * 255))
                 : ""
              );
}

function rgbString(rgba, alpha) {
   if (alpha < 1 || (rgba[3] && rgba[3] < 1)) {
      return rgbaString(rgba, alpha);
   }
   return "rgb(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2] + ")";
}

function rgbaString(rgba, alpha) {
   if (alpha === undefined) {
      alpha = (rgba[3] !== undefined ? rgba[3] : 1);
   }
   return "rgba(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2]
           + ", " + alpha + ")";
}

function percentString(rgba, alpha) {
   if (alpha < 1 || (rgba[3] && rgba[3] < 1)) {
      return percentaString(rgba, alpha);
   }
   var r = Math.round(rgba[0]/255 * 100),
       g = Math.round(rgba[1]/255 * 100),
       b = Math.round(rgba[2]/255 * 100);

   return "rgb(" + r + "%, " + g + "%, " + b + "%)";
}

function percentaString(rgba, alpha) {
   var r = Math.round(rgba[0]/255 * 100),
       g = Math.round(rgba[1]/255 * 100),
       b = Math.round(rgba[2]/255 * 100);
   return "rgba(" + r + "%, " + g + "%, " + b + "%, " + (alpha || rgba[3] || 1) + ")";
}

function hslString(hsla, alpha) {
   if (alpha < 1 || (hsla[3] && hsla[3] < 1)) {
      return hslaString(hsla, alpha);
   }
   return "hsl(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%)";
}

function hslaString(hsla, alpha) {
   if (alpha === undefined) {
      alpha = (hsla[3] !== undefined ? hsla[3] : 1);
   }
   return "hsla(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%, "
           + alpha + ")";
}

// hwb is a bit different than rgb(a) & hsl(a) since there is no alpha specific syntax
// (hwb have alpha optional & 1 is default value)
function hwbString(hwb, alpha) {
   if (alpha === undefined) {
      alpha = (hwb[3] !== undefined ? hwb[3] : 1);
   }
   return "hwb(" + hwb[0] + ", " + hwb[1] + "%, " + hwb[2] + "%"
           + (alpha !== undefined && alpha !== 1 ? ", " + alpha : "") + ")";
}

function keyword(rgb) {
  return reverseNames[rgb.slice(0, 3)];
}

// helpers
function scale(num, min, max) {
   return Math.min(Math.max(min, num), max);
}

function hexDouble(num) {
  var str = num.toString(16).toUpperCase();
  return (str.length < 2) ? "0" + str : str;
}


//create a list of reverse color names
var reverseNames = {};
for (var name in colorName$1) {
   reverseNames[colorName$1[name]] = name;
}

/* MIT license */



var Color = function (obj) {
	if (obj instanceof Color) {
		return obj;
	}
	if (!(this instanceof Color)) {
		return new Color(obj);
	}

	this.valid = false;
	this.values = {
		rgb: [0, 0, 0],
		hsl: [0, 0, 0],
		hsv: [0, 0, 0],
		hwb: [0, 0, 0],
		cmyk: [0, 0, 0, 0],
		alpha: 1
	};

	// parse Color() argument
	var vals;
	if (typeof obj === 'string') {
		vals = colorString.getRgba(obj);
		if (vals) {
			this.setValues('rgb', vals);
		} else if (vals = colorString.getHsla(obj)) {
			this.setValues('hsl', vals);
		} else if (vals = colorString.getHwb(obj)) {
			this.setValues('hwb', vals);
		}
	} else if (typeof obj === 'object') {
		vals = obj;
		if (vals.r !== undefined || vals.red !== undefined) {
			this.setValues('rgb', vals);
		} else if (vals.l !== undefined || vals.lightness !== undefined) {
			this.setValues('hsl', vals);
		} else if (vals.v !== undefined || vals.value !== undefined) {
			this.setValues('hsv', vals);
		} else if (vals.w !== undefined || vals.whiteness !== undefined) {
			this.setValues('hwb', vals);
		} else if (vals.c !== undefined || vals.cyan !== undefined) {
			this.setValues('cmyk', vals);
		}
	}
};

Color.prototype = {
	isValid: function () {
		return this.valid;
	},
	rgb: function () {
		return this.setSpace('rgb', arguments);
	},
	hsl: function () {
		return this.setSpace('hsl', arguments);
	},
	hsv: function () {
		return this.setSpace('hsv', arguments);
	},
	hwb: function () {
		return this.setSpace('hwb', arguments);
	},
	cmyk: function () {
		return this.setSpace('cmyk', arguments);
	},

	rgbArray: function () {
		return this.values.rgb;
	},
	hslArray: function () {
		return this.values.hsl;
	},
	hsvArray: function () {
		return this.values.hsv;
	},
	hwbArray: function () {
		var values = this.values;
		if (values.alpha !== 1) {
			return values.hwb.concat([values.alpha]);
		}
		return values.hwb;
	},
	cmykArray: function () {
		return this.values.cmyk;
	},
	rgbaArray: function () {
		var values = this.values;
		return values.rgb.concat([values.alpha]);
	},
	hslaArray: function () {
		var values = this.values;
		return values.hsl.concat([values.alpha]);
	},
	alpha: function (val) {
		if (val === undefined) {
			return this.values.alpha;
		}
		this.setValues('alpha', val);
		return this;
	},

	red: function (val) {
		return this.setChannel('rgb', 0, val);
	},
	green: function (val) {
		return this.setChannel('rgb', 1, val);
	},
	blue: function (val) {
		return this.setChannel('rgb', 2, val);
	},
	hue: function (val) {
		if (val) {
			val %= 360;
			val = val < 0 ? 360 + val : val;
		}
		return this.setChannel('hsl', 0, val);
	},
	saturation: function (val) {
		return this.setChannel('hsl', 1, val);
	},
	lightness: function (val) {
		return this.setChannel('hsl', 2, val);
	},
	saturationv: function (val) {
		return this.setChannel('hsv', 1, val);
	},
	whiteness: function (val) {
		return this.setChannel('hwb', 1, val);
	},
	blackness: function (val) {
		return this.setChannel('hwb', 2, val);
	},
	value: function (val) {
		return this.setChannel('hsv', 2, val);
	},
	cyan: function (val) {
		return this.setChannel('cmyk', 0, val);
	},
	magenta: function (val) {
		return this.setChannel('cmyk', 1, val);
	},
	yellow: function (val) {
		return this.setChannel('cmyk', 2, val);
	},
	black: function (val) {
		return this.setChannel('cmyk', 3, val);
	},

	hexString: function () {
		return colorString.hexString(this.values.rgb);
	},
	rgbString: function () {
		return colorString.rgbString(this.values.rgb, this.values.alpha);
	},
	rgbaString: function () {
		return colorString.rgbaString(this.values.rgb, this.values.alpha);
	},
	percentString: function () {
		return colorString.percentString(this.values.rgb, this.values.alpha);
	},
	hslString: function () {
		return colorString.hslString(this.values.hsl, this.values.alpha);
	},
	hslaString: function () {
		return colorString.hslaString(this.values.hsl, this.values.alpha);
	},
	hwbString: function () {
		return colorString.hwbString(this.values.hwb, this.values.alpha);
	},
	keyword: function () {
		return colorString.keyword(this.values.rgb, this.values.alpha);
	},

	rgbNumber: function () {
		var rgb = this.values.rgb;
		return (rgb[0] << 16) | (rgb[1] << 8) | rgb[2];
	},

	luminosity: function () {
		// http://www.w3.org/TR/WCAG20/#relativeluminancedef
		var rgb = this.values.rgb;
		var lum = [];
		for (var i = 0; i < rgb.length; i++) {
			var chan = rgb[i] / 255;
			lum[i] = (chan <= 0.03928) ? chan / 12.92 : Math.pow(((chan + 0.055) / 1.055), 2.4);
		}
		return 0.2126 * lum[0] + 0.7152 * lum[1] + 0.0722 * lum[2];
	},

	contrast: function (color2) {
		// http://www.w3.org/TR/WCAG20/#contrast-ratiodef
		var lum1 = this.luminosity();
		var lum2 = color2.luminosity();
		if (lum1 > lum2) {
			return (lum1 + 0.05) / (lum2 + 0.05);
		}
		return (lum2 + 0.05) / (lum1 + 0.05);
	},

	level: function (color2) {
		var contrastRatio = this.contrast(color2);
		if (contrastRatio >= 7.1) {
			return 'AAA';
		}

		return (contrastRatio >= 4.5) ? 'AA' : '';
	},

	dark: function () {
		// YIQ equation from http://24ways.org/2010/calculating-color-contrast
		var rgb = this.values.rgb;
		var yiq = (rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1000;
		return yiq < 128;
	},

	light: function () {
		return !this.dark();
	},

	negate: function () {
		var rgb = [];
		for (var i = 0; i < 3; i++) {
			rgb[i] = 255 - this.values.rgb[i];
		}
		this.setValues('rgb', rgb);
		return this;
	},

	lighten: function (ratio) {
		var hsl = this.values.hsl;
		hsl[2] += hsl[2] * ratio;
		this.setValues('hsl', hsl);
		return this;
	},

	darken: function (ratio) {
		var hsl = this.values.hsl;
		hsl[2] -= hsl[2] * ratio;
		this.setValues('hsl', hsl);
		return this;
	},

	saturate: function (ratio) {
		var hsl = this.values.hsl;
		hsl[1] += hsl[1] * ratio;
		this.setValues('hsl', hsl);
		return this;
	},

	desaturate: function (ratio) {
		var hsl = this.values.hsl;
		hsl[1] -= hsl[1] * ratio;
		this.setValues('hsl', hsl);
		return this;
	},

	whiten: function (ratio) {
		var hwb = this.values.hwb;
		hwb[1] += hwb[1] * ratio;
		this.setValues('hwb', hwb);
		return this;
	},

	blacken: function (ratio) {
		var hwb = this.values.hwb;
		hwb[2] += hwb[2] * ratio;
		this.setValues('hwb', hwb);
		return this;
	},

	greyscale: function () {
		var rgb = this.values.rgb;
		// http://en.wikipedia.org/wiki/Grayscale#Converting_color_to_grayscale
		var val = rgb[0] * 0.3 + rgb[1] * 0.59 + rgb[2] * 0.11;
		this.setValues('rgb', [val, val, val]);
		return this;
	},

	clearer: function (ratio) {
		var alpha = this.values.alpha;
		this.setValues('alpha', alpha - (alpha * ratio));
		return this;
	},

	opaquer: function (ratio) {
		var alpha = this.values.alpha;
		this.setValues('alpha', alpha + (alpha * ratio));
		return this;
	},

	rotate: function (degrees) {
		var hsl = this.values.hsl;
		var hue = (hsl[0] + degrees) % 360;
		hsl[0] = hue < 0 ? 360 + hue : hue;
		this.setValues('hsl', hsl);
		return this;
	},

	/**
	 * Ported from sass implementation in C
	 * https://github.com/sass/libsass/blob/0e6b4a2850092356aa3ece07c6b249f0221caced/functions.cpp#L209
	 */
	mix: function (mixinColor, weight) {
		var color1 = this;
		var color2 = mixinColor;
		var p = weight === undefined ? 0.5 : weight;

		var w = 2 * p - 1;
		var a = color1.alpha() - color2.alpha();

		var w1 = (((w * a === -1) ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
		var w2 = 1 - w1;

		return this
			.rgb(
				w1 * color1.red() + w2 * color2.red(),
				w1 * color1.green() + w2 * color2.green(),
				w1 * color1.blue() + w2 * color2.blue()
			)
			.alpha(color1.alpha() * p + color2.alpha() * (1 - p));
	},

	toJSON: function () {
		return this.rgb();
	},

	clone: function () {
		// NOTE(SB): using node-clone creates a dependency to Buffer when using browserify,
		// making the final build way to big to embed in Chart.js. So let's do it manually,
		// assuming that values to clone are 1 dimension arrays containing only numbers,
		// except 'alpha' which is a number.
		var result = new Color();
		var source = this.values;
		var target = result.values;
		var value, type;

		for (var prop in source) {
			if (source.hasOwnProperty(prop)) {
				value = source[prop];
				type = ({}).toString.call(value);
				if (type === '[object Array]') {
					target[prop] = value.slice(0);
				} else if (type === '[object Number]') {
					target[prop] = value;
				} else {
					console.error('unexpected color value:', value);
				}
			}
		}

		return result;
	}
};

Color.prototype.spaces = {
	rgb: ['red', 'green', 'blue'],
	hsl: ['hue', 'saturation', 'lightness'],
	hsv: ['hue', 'saturation', 'value'],
	hwb: ['hue', 'whiteness', 'blackness'],
	cmyk: ['cyan', 'magenta', 'yellow', 'black']
};

Color.prototype.maxes = {
	rgb: [255, 255, 255],
	hsl: [360, 100, 100],
	hsv: [360, 100, 100],
	hwb: [360, 100, 100],
	cmyk: [100, 100, 100, 100]
};

Color.prototype.getValues = function (space) {
	var values = this.values;
	var vals = {};

	for (var i = 0; i < space.length; i++) {
		vals[space.charAt(i)] = values[space][i];
	}

	if (values.alpha !== 1) {
		vals.a = values.alpha;
	}

	// {r: 255, g: 255, b: 255, a: 0.4}
	return vals;
};

Color.prototype.setValues = function (space, vals) {
	var values = this.values;
	var spaces = this.spaces;
	var maxes = this.maxes;
	var alpha = 1;
	var i;

	this.valid = true;

	if (space === 'alpha') {
		alpha = vals;
	} else if (vals.length) {
		// [10, 10, 10]
		values[space] = vals.slice(0, space.length);
		alpha = vals[space.length];
	} else if (vals[space.charAt(0)] !== undefined) {
		// {r: 10, g: 10, b: 10}
		for (i = 0; i < space.length; i++) {
			values[space][i] = vals[space.charAt(i)];
		}

		alpha = vals.a;
	} else if (vals[spaces[space][0]] !== undefined) {
		// {red: 10, green: 10, blue: 10}
		var chans = spaces[space];

		for (i = 0; i < space.length; i++) {
			values[space][i] = vals[chans[i]];
		}

		alpha = vals.alpha;
	}

	values.alpha = Math.max(0, Math.min(1, (alpha === undefined ? values.alpha : alpha)));

	if (space === 'alpha') {
		return false;
	}

	var capped;

	// cap values of the space prior converting all values
	for (i = 0; i < space.length; i++) {
		capped = Math.max(0, Math.min(maxes[space][i], values[space][i]));
		values[space][i] = Math.round(capped);
	}

	// convert to all the other color spaces
	for (var sname in spaces) {
		if (sname !== space) {
			values[sname] = colorConvert[space][sname](values[space]);
		}
	}

	return true;
};

Color.prototype.setSpace = function (space, args) {
	var vals = args[0];

	if (vals === undefined) {
		// color.rgb()
		return this.getValues(space);
	}

	// color.rgb(10, 10, 10)
	if (typeof vals === 'number') {
		vals = Array.prototype.slice.call(args);
	}

	this.setValues(space, vals);
	return this;
};

Color.prototype.setChannel = function (space, index, val) {
	var svalues = this.values[space];
	if (val === undefined) {
		// color.red()
		return svalues[index];
	} else if (val === svalues[index]) {
		// color.red(color.red())
		return this;
	}

	// color.red(100)
	svalues[index] = val;
	this.setValues(space, svalues);

	return this;
};

if (typeof window !== 'undefined') {
	window.Color = Color;
}

var chartjsColor = Color;

function isValidKey(key) {
	return ['__proto__', 'prototype', 'constructor'].indexOf(key) === -1;
}

/**
 * @namespace Chart.helpers
 */
var helpers = {
	/**
	 * An empty function that can be used, for example, for optional callback.
	 */
	noop: function() {},

	/**
	 * Returns a unique id, sequentially generated from a global variable.
	 * @returns {number}
	 * @function
	 */
	uid: (function() {
		var id = 0;
		return function() {
			return id++;
		};
	}()),

	/**
	 * Returns true if `value` is neither null nor undefined, else returns false.
	 * @param {*} value - The value to test.
	 * @returns {boolean}
	 * @since 2.7.0
	 */
	isNullOrUndef: function(value) {
		return value === null || typeof value === 'undefined';
	},

	/**
	 * Returns true if `value` is an array (including typed arrays), else returns false.
	 * @param {*} value - The value to test.
	 * @returns {boolean}
	 * @function
	 */
	isArray: function(value) {
		if (Array.isArray && Array.isArray(value)) {
			return true;
		}
		var type = Object.prototype.toString.call(value);
		if (type.substr(0, 7) === '[object' && type.substr(-6) === 'Array]') {
			return true;
		}
		return false;
	},

	/**
	 * Returns true if `value` is an object (excluding null), else returns false.
	 * @param {*} value - The value to test.
	 * @returns {boolean}
	 * @since 2.7.0
	 */
	isObject: function(value) {
		return value !== null && Object.prototype.toString.call(value) === '[object Object]';
	},

	/**
	 * Returns true if `value` is a finite number, else returns false
	 * @param {*} value  - The value to test.
	 * @returns {boolean}
	 */
	isFinite: function(value) {
		return (typeof value === 'number' || value instanceof Number) && isFinite(value);
	},

	/**
	 * Returns `value` if defined, else returns `defaultValue`.
	 * @param {*} value - The value to return if defined.
	 * @param {*} defaultValue - The value to return if `value` is undefined.
	 * @returns {*}
	 */
	valueOrDefault: function(value, defaultValue) {
		return typeof value === 'undefined' ? defaultValue : value;
	},

	/**
	 * Returns value at the given `index` in array if defined, else returns `defaultValue`.
	 * @param {Array} value - The array to lookup for value at `index`.
	 * @param {number} index - The index in `value` to lookup for value.
	 * @param {*} defaultValue - The value to return if `value[index]` is undefined.
	 * @returns {*}
	 */
	valueAtIndexOrDefault: function(value, index, defaultValue) {
		return helpers.valueOrDefault(helpers.isArray(value) ? value[index] : value, defaultValue);
	},

	/**
	 * Calls `fn` with the given `args` in the scope defined by `thisArg` and returns the
	 * value returned by `fn`. If `fn` is not a function, this method returns undefined.
	 * @param {function} fn - The function to call.
	 * @param {Array|undefined|null} args - The arguments with which `fn` should be called.
	 * @param {object} [thisArg] - The value of `this` provided for the call to `fn`.
	 * @returns {*}
	 */
	callback: function(fn, args, thisArg) {
		if (fn && typeof fn.call === 'function') {
			return fn.apply(thisArg, args);
		}
	},

	/**
	 * Note(SB) for performance sake, this method should only be used when loopable type
	 * is unknown or in none intensive code (not called often and small loopable). Else
	 * it's preferable to use a regular for() loop and save extra function calls.
	 * @param {object|Array} loopable - The object or array to be iterated.
	 * @param {function} fn - The function to call for each item.
	 * @param {object} [thisArg] - The value of `this` provided for the call to `fn`.
	 * @param {boolean} [reverse] - If true, iterates backward on the loopable.
	 */
	each: function(loopable, fn, thisArg, reverse) {
		var i, len, keys;
		if (helpers.isArray(loopable)) {
			len = loopable.length;
			if (reverse) {
				for (i = len - 1; i >= 0; i--) {
					fn.call(thisArg, loopable[i], i);
				}
			} else {
				for (i = 0; i < len; i++) {
					fn.call(thisArg, loopable[i], i);
				}
			}
		} else if (helpers.isObject(loopable)) {
			keys = Object.keys(loopable);
			len = keys.length;
			for (i = 0; i < len; i++) {
				fn.call(thisArg, loopable[keys[i]], keys[i]);
			}
		}
	},

	/**
	 * Returns true if the `a0` and `a1` arrays have the same content, else returns false.
	 * @see https://stackoverflow.com/a/14853974
	 * @param {Array} a0 - The array to compare
	 * @param {Array} a1 - The array to compare
	 * @returns {boolean}
	 */
	arrayEquals: function(a0, a1) {
		var i, ilen, v0, v1;

		if (!a0 || !a1 || a0.length !== a1.length) {
			return false;
		}

		for (i = 0, ilen = a0.length; i < ilen; ++i) {
			v0 = a0[i];
			v1 = a1[i];

			if (v0 instanceof Array && v1 instanceof Array) {
				if (!helpers.arrayEquals(v0, v1)) {
					return false;
				}
			} else if (v0 !== v1) {
				// NOTE: two different object instances will never be equal: {x:20} != {x:20}
				return false;
			}
		}

		return true;
	},

	/**
	 * Returns a deep copy of `source` without keeping references on objects and arrays.
	 * @param {*} source - The value to clone.
	 * @returns {*}
	 */
	clone: function(source) {
		if (helpers.isArray(source)) {
			return source.map(helpers.clone);
		}

		if (helpers.isObject(source)) {
			var target = Object.create(source);
			var keys = Object.keys(source);
			var klen = keys.length;
			var k = 0;

			for (; k < klen; ++k) {
				target[keys[k]] = helpers.clone(source[keys[k]]);
			}

			return target;
		}

		return source;
	},

	/**
	 * The default merger when Chart.helpers.merge is called without merger option.
	 * Note(SB): also used by mergeConfig and mergeScaleConfig as fallback.
	 * @private
	 */
	_merger: function(key, target, source, options) {
		if (!isValidKey(key)) {
			// We want to ensure we do not copy prototypes over
			// as this can pollute global namespaces
			return;
		}

		var tval = target[key];
		var sval = source[key];

		if (helpers.isObject(tval) && helpers.isObject(sval)) {
			helpers.merge(tval, sval, options);
		} else {
			target[key] = helpers.clone(sval);
		}
	},

	/**
	 * Merges source[key] in target[key] only if target[key] is undefined.
	 * @private
	 */
	_mergerIf: function(key, target, source) {
		if (!isValidKey(key)) {
			// We want to ensure we do not copy prototypes over
			// as this can pollute global namespaces
			return;
		}

		var tval = target[key];
		var sval = source[key];

		if (helpers.isObject(tval) && helpers.isObject(sval)) {
			helpers.mergeIf(tval, sval);
		} else if (!target.hasOwnProperty(key)) {
			target[key] = helpers.clone(sval);
		}
	},

	/**
	 * Recursively deep copies `source` properties into `target` with the given `options`.
	 * IMPORTANT: `target` is not cloned and will be updated with `source` properties.
	 * @param {object} target - The target object in which all sources are merged into.
	 * @param {object|object[]} source - Object(s) to merge into `target`.
	 * @param {object} [options] - Merging options:
	 * @param {function} [options.merger] - The merge method (key, target, source, options)
	 * @returns {object} The `target` object.
	 */
	merge: function(target, source, options) {
		var sources = helpers.isArray(source) ? source : [source];
		var ilen = sources.length;
		var merge, i, keys, klen, k;

		if (!helpers.isObject(target)) {
			return target;
		}

		options = options || {};
		merge = options.merger || helpers._merger;

		for (i = 0; i < ilen; ++i) {
			source = sources[i];
			if (!helpers.isObject(source)) {
				continue;
			}

			keys = Object.keys(source);
			for (k = 0, klen = keys.length; k < klen; ++k) {
				merge(keys[k], target, source, options);
			}
		}

		return target;
	},

	/**
	 * Recursively deep copies `source` properties into `target` *only* if not defined in target.
	 * IMPORTANT: `target` is not cloned and will be updated with `source` properties.
	 * @param {object} target - The target object in which all sources are merged into.
	 * @param {object|object[]} source - Object(s) to merge into `target`.
	 * @returns {object} The `target` object.
	 */
	mergeIf: function(target, source) {
		return helpers.merge(target, source, {merger: helpers._mergerIf});
	},

	/**
	 * Applies the contents of two or more objects together into the first object.
	 * @param {object} target - The target object in which all objects are merged into.
	 * @param {object} arg1 - Object containing additional properties to merge in target.
	 * @param {object} argN - Additional objects containing properties to merge in target.
	 * @returns {object} The `target` object.
	 */
	extend: Object.assign || function(target) {
		return helpers.merge(target, [].slice.call(arguments, 1), {
			merger: function(key, dst, src) {
				dst[key] = src[key];
			}
		});
	},

	/**
	 * Basic javascript inheritance based on the model created in Backbone.js
	 */
	inherits: function(extensions) {
		var me = this;
		var ChartElement = (extensions && extensions.hasOwnProperty('constructor')) ? extensions.constructor : function() {
			return me.apply(this, arguments);
		};

		var Surrogate = function() {
			this.constructor = ChartElement;
		};

		Surrogate.prototype = me.prototype;
		ChartElement.prototype = new Surrogate();
		ChartElement.extend = helpers.inherits;

		if (extensions) {
			helpers.extend(ChartElement.prototype, extensions);
		}

		ChartElement.__super__ = me.prototype;
		return ChartElement;
	},

	_deprecated: function(scope, value, previous, current) {
		if (value !== undefined) {
			console.warn(scope + ': "' + previous +
				'" is deprecated. Please use "' + current + '" instead');
		}
	}
};

var helpers_core = helpers;

// DEPRECATIONS

/**
 * Provided for backward compatibility, use Chart.helpers.callback instead.
 * @function Chart.helpers.callCallback
 * @deprecated since version 2.6.0
 * @todo remove at version 3
 * @private
 */
helpers.callCallback = helpers.callback;

/**
 * Provided for backward compatibility, use Array.prototype.indexOf instead.
 * Array.prototype.indexOf compatibility: Chrome, Opera, Safari, FF1.5+, IE9+
 * @function Chart.helpers.indexOf
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers.indexOf = function(array, item, fromIndex) {
	return Array.prototype.indexOf.call(array, item, fromIndex);
};

/**
 * Provided for backward compatibility, use Chart.helpers.valueOrDefault instead.
 * @function Chart.helpers.getValueOrDefault
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers.getValueOrDefault = helpers.valueOrDefault;

/**
 * Provided for backward compatibility, use Chart.helpers.valueAtIndexOrDefault instead.
 * @function Chart.helpers.getValueAtIndexOrDefault
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers.getValueAtIndexOrDefault = helpers.valueAtIndexOrDefault;

/**
 * Easing functions adapted from Robert Penner's easing equations.
 * @namespace Chart.helpers.easingEffects
 * @see http://www.robertpenner.com/easing/
 */
var effects = {
	linear: function(t) {
		return t;
	},

	easeInQuad: function(t) {
		return t * t;
	},

	easeOutQuad: function(t) {
		return -t * (t - 2);
	},

	easeInOutQuad: function(t) {
		if ((t /= 0.5) < 1) {
			return 0.5 * t * t;
		}
		return -0.5 * ((--t) * (t - 2) - 1);
	},

	easeInCubic: function(t) {
		return t * t * t;
	},

	easeOutCubic: function(t) {
		return (t = t - 1) * t * t + 1;
	},

	easeInOutCubic: function(t) {
		if ((t /= 0.5) < 1) {
			return 0.5 * t * t * t;
		}
		return 0.5 * ((t -= 2) * t * t + 2);
	},

	easeInQuart: function(t) {
		return t * t * t * t;
	},

	easeOutQuart: function(t) {
		return -((t = t - 1) * t * t * t - 1);
	},

	easeInOutQuart: function(t) {
		if ((t /= 0.5) < 1) {
			return 0.5 * t * t * t * t;
		}
		return -0.5 * ((t -= 2) * t * t * t - 2);
	},

	easeInQuint: function(t) {
		return t * t * t * t * t;
	},

	easeOutQuint: function(t) {
		return (t = t - 1) * t * t * t * t + 1;
	},

	easeInOutQuint: function(t) {
		if ((t /= 0.5) < 1) {
			return 0.5 * t * t * t * t * t;
		}
		return 0.5 * ((t -= 2) * t * t * t * t + 2);
	},

	easeInSine: function(t) {
		return -Math.cos(t * (Math.PI / 2)) + 1;
	},

	easeOutSine: function(t) {
		return Math.sin(t * (Math.PI / 2));
	},

	easeInOutSine: function(t) {
		return -0.5 * (Math.cos(Math.PI * t) - 1);
	},

	easeInExpo: function(t) {
		return (t === 0) ? 0 : Math.pow(2, 10 * (t - 1));
	},

	easeOutExpo: function(t) {
		return (t === 1) ? 1 : -Math.pow(2, -10 * t) + 1;
	},

	easeInOutExpo: function(t) {
		if (t === 0) {
			return 0;
		}
		if (t === 1) {
			return 1;
		}
		if ((t /= 0.5) < 1) {
			return 0.5 * Math.pow(2, 10 * (t - 1));
		}
		return 0.5 * (-Math.pow(2, -10 * --t) + 2);
	},

	easeInCirc: function(t) {
		if (t >= 1) {
			return t;
		}
		return -(Math.sqrt(1 - t * t) - 1);
	},

	easeOutCirc: function(t) {
		return Math.sqrt(1 - (t = t - 1) * t);
	},

	easeInOutCirc: function(t) {
		if ((t /= 0.5) < 1) {
			return -0.5 * (Math.sqrt(1 - t * t) - 1);
		}
		return 0.5 * (Math.sqrt(1 - (t -= 2) * t) + 1);
	},

	easeInElastic: function(t) {
		var s = 1.70158;
		var p = 0;
		var a = 1;
		if (t === 0) {
			return 0;
		}
		if (t === 1) {
			return 1;
		}
		if (!p) {
			p = 0.3;
		}
		if (a < 1) {
			a = 1;
			s = p / 4;
		} else {
			s = p / (2 * Math.PI) * Math.asin(1 / a);
		}
		return -(a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p));
	},

	easeOutElastic: function(t) {
		var s = 1.70158;
		var p = 0;
		var a = 1;
		if (t === 0) {
			return 0;
		}
		if (t === 1) {
			return 1;
		}
		if (!p) {
			p = 0.3;
		}
		if (a < 1) {
			a = 1;
			s = p / 4;
		} else {
			s = p / (2 * Math.PI) * Math.asin(1 / a);
		}
		return a * Math.pow(2, -10 * t) * Math.sin((t - s) * (2 * Math.PI) / p) + 1;
	},

	easeInOutElastic: function(t) {
		var s = 1.70158;
		var p = 0;
		var a = 1;
		if (t === 0) {
			return 0;
		}
		if ((t /= 0.5) === 2) {
			return 1;
		}
		if (!p) {
			p = 0.45;
		}
		if (a < 1) {
			a = 1;
			s = p / 4;
		} else {
			s = p / (2 * Math.PI) * Math.asin(1 / a);
		}
		if (t < 1) {
			return -0.5 * (a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p));
		}
		return a * Math.pow(2, -10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p) * 0.5 + 1;
	},
	easeInBack: function(t) {
		var s = 1.70158;
		return t * t * ((s + 1) * t - s);
	},

	easeOutBack: function(t) {
		var s = 1.70158;
		return (t = t - 1) * t * ((s + 1) * t + s) + 1;
	},

	easeInOutBack: function(t) {
		var s = 1.70158;
		if ((t /= 0.5) < 1) {
			return 0.5 * (t * t * (((s *= (1.525)) + 1) * t - s));
		}
		return 0.5 * ((t -= 2) * t * (((s *= (1.525)) + 1) * t + s) + 2);
	},

	easeInBounce: function(t) {
		return 1 - effects.easeOutBounce(1 - t);
	},

	easeOutBounce: function(t) {
		if (t < (1 / 2.75)) {
			return 7.5625 * t * t;
		}
		if (t < (2 / 2.75)) {
			return 7.5625 * (t -= (1.5 / 2.75)) * t + 0.75;
		}
		if (t < (2.5 / 2.75)) {
			return 7.5625 * (t -= (2.25 / 2.75)) * t + 0.9375;
		}
		return 7.5625 * (t -= (2.625 / 2.75)) * t + 0.984375;
	},

	easeInOutBounce: function(t) {
		if (t < 0.5) {
			return effects.easeInBounce(t * 2) * 0.5;
		}
		return effects.easeOutBounce(t * 2 - 1) * 0.5 + 0.5;
	}
};

var helpers_easing = {
	effects: effects
};

// DEPRECATIONS

/**
 * Provided for backward compatibility, use Chart.helpers.easing.effects instead.
 * @function Chart.helpers.easingEffects
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers_core.easingEffects = effects;

var PI = Math.PI;
var RAD_PER_DEG = PI / 180;
var DOUBLE_PI = PI * 2;
var HALF_PI = PI / 2;
var QUARTER_PI = PI / 4;
var TWO_THIRDS_PI = PI * 2 / 3;

/**
 * @namespace Chart.helpers.canvas
 */
var exports$1 = {
	/**
	 * Clears the entire canvas associated to the given `chart`.
	 * @param {Chart} chart - The chart for which to clear the canvas.
	 */
	clear: function(chart) {
		chart.ctx.clearRect(0, 0, chart.width, chart.height);
	},

	/**
	 * Creates a "path" for a rectangle with rounded corners at position (x, y) with a
	 * given size (width, height) and the same `radius` for all corners.
	 * @param {CanvasRenderingContext2D} ctx - The canvas 2D Context.
	 * @param {number} x - The x axis of the coordinate for the rectangle starting point.
	 * @param {number} y - The y axis of the coordinate for the rectangle starting point.
	 * @param {number} width - The rectangle's width.
	 * @param {number} height - The rectangle's height.
	 * @param {number} radius - The rounded amount (in pixels) for the four corners.
	 * @todo handle `radius` as top-left, top-right, bottom-right, bottom-left array/object?
	 */
	roundedRect: function(ctx, x, y, width, height, radius) {
		if (radius) {
			var r = Math.min(radius, height / 2, width / 2);
			var left = x + r;
			var top = y + r;
			var right = x + width - r;
			var bottom = y + height - r;

			ctx.moveTo(x, top);
			if (left < right && top < bottom) {
				ctx.arc(left, top, r, -PI, -HALF_PI);
				ctx.arc(right, top, r, -HALF_PI, 0);
				ctx.arc(right, bottom, r, 0, HALF_PI);
				ctx.arc(left, bottom, r, HALF_PI, PI);
			} else if (left < right) {
				ctx.moveTo(left, y);
				ctx.arc(right, top, r, -HALF_PI, HALF_PI);
				ctx.arc(left, top, r, HALF_PI, PI + HALF_PI);
			} else if (top < bottom) {
				ctx.arc(left, top, r, -PI, 0);
				ctx.arc(left, bottom, r, 0, PI);
			} else {
				ctx.arc(left, top, r, -PI, PI);
			}
			ctx.closePath();
			ctx.moveTo(x, y);
		} else {
			ctx.rect(x, y, width, height);
		}
	},

	drawPoint: function(ctx, style, radius, x, y, rotation) {
		var type, xOffset, yOffset, size, cornerRadius;
		var rad = (rotation || 0) * RAD_PER_DEG;

		if (style && typeof style === 'object') {
			type = style.toString();
			if (type === '[object HTMLImageElement]' || type === '[object HTMLCanvasElement]') {
				ctx.save();
				ctx.translate(x, y);
				ctx.rotate(rad);
				ctx.drawImage(style, -style.width / 2, -style.height / 2, style.width, style.height);
				ctx.restore();
				return;
			}
		}

		if (isNaN(radius) || radius <= 0) {
			return;
		}

		ctx.beginPath();

		switch (style) {
		// Default includes circle
		default:
			ctx.arc(x, y, radius, 0, DOUBLE_PI);
			ctx.closePath();
			break;
		case 'triangle':
			ctx.moveTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
			rad += TWO_THIRDS_PI;
			ctx.lineTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
			rad += TWO_THIRDS_PI;
			ctx.lineTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
			ctx.closePath();
			break;
		case 'rectRounded':
			// NOTE: the rounded rect implementation changed to use `arc` instead of
			// `quadraticCurveTo` since it generates better results when rect is
			// almost a circle. 0.516 (instead of 0.5) produces results with visually
			// closer proportion to the previous impl and it is inscribed in the
			// circle with `radius`. For more details, see the following PRs:
			// https://github.com/chartjs/Chart.js/issues/5597
			// https://github.com/chartjs/Chart.js/issues/5858
			cornerRadius = radius * 0.516;
			size = radius - cornerRadius;
			xOffset = Math.cos(rad + QUARTER_PI) * size;
			yOffset = Math.sin(rad + QUARTER_PI) * size;
			ctx.arc(x - xOffset, y - yOffset, cornerRadius, rad - PI, rad - HALF_PI);
			ctx.arc(x + yOffset, y - xOffset, cornerRadius, rad - HALF_PI, rad);
			ctx.arc(x + xOffset, y + yOffset, cornerRadius, rad, rad + HALF_PI);
			ctx.arc(x - yOffset, y + xOffset, cornerRadius, rad + HALF_PI, rad + PI);
			ctx.closePath();
			break;
		case 'rect':
			if (!rotation) {
				size = Math.SQRT1_2 * radius;
				ctx.rect(x - size, y - size, 2 * size, 2 * size);
				break;
			}
			rad += QUARTER_PI;
			/* falls through */
		case 'rectRot':
			xOffset = Math.cos(rad) * radius;
			yOffset = Math.sin(rad) * radius;
			ctx.moveTo(x - xOffset, y - yOffset);
			ctx.lineTo(x + yOffset, y - xOffset);
			ctx.lineTo(x + xOffset, y + yOffset);
			ctx.lineTo(x - yOffset, y + xOffset);
			ctx.closePath();
			break;
		case 'crossRot':
			rad += QUARTER_PI;
			/* falls through */
		case 'cross':
			xOffset = Math.cos(rad) * radius;
			yOffset = Math.sin(rad) * radius;
			ctx.moveTo(x - xOffset, y - yOffset);
			ctx.lineTo(x + xOffset, y + yOffset);
			ctx.moveTo(x + yOffset, y - xOffset);
			ctx.lineTo(x - yOffset, y + xOffset);
			break;
		case 'star':
			xOffset = Math.cos(rad) * radius;
			yOffset = Math.sin(rad) * radius;
			ctx.moveTo(x - xOffset, y - yOffset);
			ctx.lineTo(x + xOffset, y + yOffset);
			ctx.moveTo(x + yOffset, y - xOffset);
			ctx.lineTo(x - yOffset, y + xOffset);
			rad += QUARTER_PI;
			xOffset = Math.cos(rad) * radius;
			yOffset = Math.sin(rad) * radius;
			ctx.moveTo(x - xOffset, y - yOffset);
			ctx.lineTo(x + xOffset, y + yOffset);
			ctx.moveTo(x + yOffset, y - xOffset);
			ctx.lineTo(x - yOffset, y + xOffset);
			break;
		case 'line':
			xOffset = Math.cos(rad) * radius;
			yOffset = Math.sin(rad) * radius;
			ctx.moveTo(x - xOffset, y - yOffset);
			ctx.lineTo(x + xOffset, y + yOffset);
			break;
		case 'dash':
			ctx.moveTo(x, y);
			ctx.lineTo(x + Math.cos(rad) * radius, y + Math.sin(rad) * radius);
			break;
		}

		ctx.fill();
		ctx.stroke();
	},

	/**
	 * Returns true if the point is inside the rectangle
	 * @param {object} point - The point to test
	 * @param {object} area - The rectangle
	 * @returns {boolean}
	 * @private
	 */
	_isPointInArea: function(point, area) {
		var epsilon = 1e-6; // 1e-6 is margin in pixels for accumulated error.

		return point.x > area.left - epsilon && point.x < area.right + epsilon &&
			point.y > area.top - epsilon && point.y < area.bottom + epsilon;
	},

	clipArea: function(ctx, area) {
		ctx.save();
		ctx.beginPath();
		ctx.rect(area.left, area.top, area.right - area.left, area.bottom - area.top);
		ctx.clip();
	},

	unclipArea: function(ctx) {
		ctx.restore();
	},

	lineTo: function(ctx, previous, target, flip) {
		var stepped = target.steppedLine;
		if (stepped) {
			if (stepped === 'middle') {
				var midpoint = (previous.x + target.x) / 2.0;
				ctx.lineTo(midpoint, flip ? target.y : previous.y);
				ctx.lineTo(midpoint, flip ? previous.y : target.y);
			} else if ((stepped === 'after' && !flip) || (stepped !== 'after' && flip)) {
				ctx.lineTo(previous.x, target.y);
			} else {
				ctx.lineTo(target.x, previous.y);
			}
			ctx.lineTo(target.x, target.y);
			return;
		}

		if (!target.tension) {
			ctx.lineTo(target.x, target.y);
			return;
		}

		ctx.bezierCurveTo(
			flip ? previous.controlPointPreviousX : previous.controlPointNextX,
			flip ? previous.controlPointPreviousY : previous.controlPointNextY,
			flip ? target.controlPointNextX : target.controlPointPreviousX,
			flip ? target.controlPointNextY : target.controlPointPreviousY,
			target.x,
			target.y);
	}
};

var helpers_canvas = exports$1;

// DEPRECATIONS

/**
 * Provided for backward compatibility, use Chart.helpers.canvas.clear instead.
 * @namespace Chart.helpers.clear
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers_core.clear = exports$1.clear;

/**
 * Provided for backward compatibility, use Chart.helpers.canvas.roundedRect instead.
 * @namespace Chart.helpers.drawRoundedRectangle
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers_core.drawRoundedRectangle = function(ctx) {
	ctx.beginPath();
	exports$1.roundedRect.apply(exports$1, arguments);
};

var defaults = {
	/**
	 * @private
	 */
	_set: function(scope, values) {
		return helpers_core.merge(this[scope] || (this[scope] = {}), values);
	}
};

// TODO(v3): remove 'global' from namespace.  all default are global and
// there's inconsistency around which options are under 'global'
defaults._set('global', {
	defaultColor: 'rgba(0,0,0,0.1)',
	defaultFontColor: '#666',
	defaultFontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
	defaultFontSize: 12,
	defaultFontStyle: 'normal',
	defaultLineHeight: 1.2,
	showLines: true
});

var core_defaults = defaults;

var valueOrDefault = helpers_core.valueOrDefault;

/**
 * Converts the given font object into a CSS font string.
 * @param {object} font - A font object.
 * @return {string} The CSS font string. See https://developer.mozilla.org/en-US/docs/Web/CSS/font
 * @private
 */
function toFontString(font) {
	if (!font || helpers_core.isNullOrUndef(font.size) || helpers_core.isNullOrUndef(font.family)) {
		return null;
	}

	return (font.style ? font.style + ' ' : '')
		+ (font.weight ? font.weight + ' ' : '')
		+ font.size + 'px '
		+ font.family;
}

/**
 * @alias Chart.helpers.options
 * @namespace
 */
var helpers_options = {
	/**
	 * Converts the given line height `value` in pixels for a specific font `size`.
	 * @param {number|string} value - The lineHeight to parse (eg. 1.6, '14px', '75%', '1.6em').
	 * @param {number} size - The font size (in pixels) used to resolve relative `value`.
	 * @returns {number} The effective line height in pixels (size * 1.2 if value is invalid).
	 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/line-height
	 * @since 2.7.0
	 */
	toLineHeight: function(value, size) {
		var matches = ('' + value).match(/^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/);
		if (!matches || matches[1] === 'normal') {
			return size * 1.2;
		}

		value = +matches[2];

		switch (matches[3]) {
		case 'px':
			return value;
		case '%':
			value /= 100;
			break;
		}

		return size * value;
	},

	/**
	 * Converts the given value into a padding object with pre-computed width/height.
	 * @param {number|object} value - If a number, set the value to all TRBL component,
	 *  else, if and object, use defined properties and sets undefined ones to 0.
	 * @returns {object} The padding values (top, right, bottom, left, width, height)
	 * @since 2.7.0
	 */
	toPadding: function(value) {
		var t, r, b, l;

		if (helpers_core.isObject(value)) {
			t = +value.top || 0;
			r = +value.right || 0;
			b = +value.bottom || 0;
			l = +value.left || 0;
		} else {
			t = r = b = l = +value || 0;
		}

		return {
			top: t,
			right: r,
			bottom: b,
			left: l,
			height: t + b,
			width: l + r
		};
	},

	/**
	 * Parses font options and returns the font object.
	 * @param {object} options - A object that contains font options to be parsed.
	 * @return {object} The font object.
	 * @todo Support font.* options and renamed to toFont().
	 * @private
	 */
	_parseFont: function(options) {
		var globalDefaults = core_defaults.global;
		var size = valueOrDefault(options.fontSize, globalDefaults.defaultFontSize);
		var font = {
			family: valueOrDefault(options.fontFamily, globalDefaults.defaultFontFamily),
			lineHeight: helpers_core.options.toLineHeight(valueOrDefault(options.lineHeight, globalDefaults.defaultLineHeight), size),
			size: size,
			style: valueOrDefault(options.fontStyle, globalDefaults.defaultFontStyle),
			weight: null,
			string: ''
		};

		font.string = toFontString(font);
		return font;
	},

	/**
	 * Evaluates the given `inputs` sequentially and returns the first defined value.
	 * @param {Array} inputs - An array of values, falling back to the last value.
	 * @param {object} [context] - If defined and the current value is a function, the value
	 * is called with `context` as first argument and the result becomes the new input.
	 * @param {number} [index] - If defined and the current value is an array, the value
	 * at `index` become the new input.
	 * @param {object} [info] - object to return information about resolution in
	 * @param {boolean} [info.cacheable] - Will be set to `false` if option is not cacheable.
	 * @since 2.7.0
	 */
	resolve: function(inputs, context, index, info) {
		var cacheable = true;
		var i, ilen, value;

		for (i = 0, ilen = inputs.length; i < ilen; ++i) {
			value = inputs[i];
			if (value === undefined) {
				continue;
			}
			if (context !== undefined && typeof value === 'function') {
				value = value(context);
				cacheable = false;
			}
			if (index !== undefined && helpers_core.isArray(value)) {
				value = value[index];
				cacheable = false;
			}
			if (value !== undefined) {
				if (info && !cacheable) {
					info.cacheable = false;
				}
				return value;
			}
		}
	}
};

/**
 * @alias Chart.helpers.math
 * @namespace
 */
var exports$2 = {
	/**
	 * Returns an array of factors sorted from 1 to sqrt(value)
	 * @private
	 */
	_factorize: function(value) {
		var result = [];
		var sqrt = Math.sqrt(value);
		var i;

		for (i = 1; i < sqrt; i++) {
			if (value % i === 0) {
				result.push(i);
				result.push(value / i);
			}
		}
		if (sqrt === (sqrt | 0)) { // if value is a square number
			result.push(sqrt);
		}

		result.sort(function(a, b) {
			return a - b;
		}).pop();
		return result;
	},

	log10: Math.log10 || function(x) {
		var exponent = Math.log(x) * Math.LOG10E; // Math.LOG10E = 1 / Math.LN10.
		// Check for whole powers of 10,
		// which due to floating point rounding error should be corrected.
		var powerOf10 = Math.round(exponent);
		var isPowerOf10 = x === Math.pow(10, powerOf10);

		return isPowerOf10 ? powerOf10 : exponent;
	}
};

var helpers_math = exports$2;

// DEPRECATIONS

/**
 * Provided for backward compatibility, use Chart.helpers.math.log10 instead.
 * @namespace Chart.helpers.log10
 * @deprecated since version 2.9.0
 * @todo remove at version 3
 * @private
 */
helpers_core.log10 = exports$2.log10;

var getRtlAdapter = function(rectX, width) {
	return {
		x: function(x) {
			return rectX + rectX + width - x;
		},
		setWidth: function(w) {
			width = w;
		},
		textAlign: function(align) {
			if (align === 'center') {
				return align;
			}
			return align === 'right' ? 'left' : 'right';
		},
		xPlus: function(x, value) {
			return x - value;
		},
		leftForLtr: function(x, itemWidth) {
			return x - itemWidth;
		},
	};
};

var getLtrAdapter = function() {
	return {
		x: function(x) {
			return x;
		},
		setWidth: function(w) { // eslint-disable-line no-unused-vars
		},
		textAlign: function(align) {
			return align;
		},
		xPlus: function(x, value) {
			return x + value;
		},
		leftForLtr: function(x, _itemWidth) { // eslint-disable-line no-unused-vars
			return x;
		},
	};
};

var getAdapter = function(rtl, rectX, width) {
	return rtl ? getRtlAdapter(rectX, width) : getLtrAdapter();
};

var overrideTextDirection = function(ctx, direction) {
	var style, original;
	if (direction === 'ltr' || direction === 'rtl') {
		style = ctx.canvas.style;
		original = [
			style.getPropertyValue('direction'),
			style.getPropertyPriority('direction'),
		];

		style.setProperty('direction', direction, 'important');
		ctx.prevTextDirection = original;
	}
};

var restoreTextDirection = function(ctx) {
	var original = ctx.prevTextDirection;
	if (original !== undefined) {
		delete ctx.prevTextDirection;
		ctx.canvas.style.setProperty('direction', original[0], original[1]);
	}
};

var helpers_rtl = {
	getRtlAdapter: getAdapter,
	overrideTextDirection: overrideTextDirection,
	restoreTextDirection: restoreTextDirection,
};

var helpers$1 = helpers_core;
var easing = helpers_easing;
var canvas = helpers_canvas;
var options = helpers_options;
var math = helpers_math;
var rtl = helpers_rtl;
helpers$1.easing = easing;
helpers$1.canvas = canvas;
helpers$1.options = options;
helpers$1.math = math;
helpers$1.rtl = rtl;

function interpolate(start, view, model, ease) {
	var keys = Object.keys(model);
	var i, ilen, key, actual, origin, target, type, c0, c1;

	for (i = 0, ilen = keys.length; i < ilen; ++i) {
		key = keys[i];

		target = model[key];

		// if a value is added to the model after pivot() has been called, the view
		// doesn't contain it, so let's initialize the view to the target value.
		if (!view.hasOwnProperty(key)) {
			view[key] = target;
		}

		actual = view[key];

		if (actual === target || key[0] === '_') {
			continue;
		}

		if (!start.hasOwnProperty(key)) {
			start[key] = actual;
		}

		origin = start[key];

		type = typeof target;

		if (type === typeof origin) {
			if (type === 'string') {
				c0 = chartjsColor(origin);
				if (c0.valid) {
					c1 = chartjsColor(target);
					if (c1.valid) {
						view[key] = c1.mix(c0, ease).rgbString();
						continue;
					}
				}
			} else if (helpers$1.isFinite(origin) && helpers$1.isFinite(target)) {
				view[key] = origin + (target - origin) * ease;
				continue;
			}
		}

		view[key] = target;
	}
}

var Element = function(configuration) {
	helpers$1.extend(this, configuration);
	this.initialize.apply(this, arguments);
};

helpers$1.extend(Element.prototype, {
	_type: undefined,

	initialize: function() {
		this.hidden = false;
	},

	pivot: function() {
		var me = this;
		if (!me._view) {
			me._view = helpers$1.extend({}, me._model);
		}
		me._start = {};
		return me;
	},

	transition: function(ease) {
		var me = this;
		var model = me._model;
		var start = me._start;
		var view = me._view;

		// No animation -> No Transition
		if (!model || ease === 1) {
			me._view = helpers$1.extend({}, model);
			me._start = null;
			return me;
		}

		if (!view) {
			view = me._view = {};
		}

		if (!start) {
			start = me._start = {};
		}

		interpolate(start, view, model, ease);

		return me;
	},

	tooltipPosition: function() {
		return {
			x: this._model.x,
			y: this._model.y
		};
	},

	hasValue: function() {
		return helpers$1.isNumber(this._model.x) && helpers$1.isNumber(this._model.y);
	}
});

Element.extend = helpers$1.inherits;

var core_element = Element;

var exports$3 = core_element.extend({
	chart: null, // the animation associated chart instance
	currentStep: 0, // the current animation step
	numSteps: 60, // default number of steps
	easing: '', // the easing to use for this animation
	render: null, // render function used by the animation service

	onAnimationProgress: null, // user specified callback to fire on each step of the animation
	onAnimationComplete: null, // user specified callback to fire when the animation finishes
});

var core_animation = exports$3;

// DEPRECATIONS

/**
 * Provided for backward compatibility, use Chart.Animation instead
 * @prop Chart.Animation#animationObject
 * @deprecated since version 2.6.0
 * @todo remove at version 3
 */
Object.defineProperty(exports$3.prototype, 'animationObject', {
	get: function() {
		return this;
	}
});

/**
 * Provided for backward compatibility, use Chart.Animation#chart instead
 * @prop Chart.Animation#chartInstance
 * @deprecated since version 2.6.0
 * @todo remove at version 3
 */
Object.defineProperty(exports$3.prototype, 'chartInstance', {
	get: function() {
		return this.chart;
	},
	set: function(value) {
		this.chart = value;
	}
});

core_defaults._set('global', {
	animation: {
		duration: 1000,
		easing: 'easeOutQuart',
		onProgress: helpers$1.noop,
		onComplete: helpers$1.noop
	}
});

var core_animations = {
	animations: [],
	request: null,

	/**
	 * @param {Chart} chart - The chart to animate.
	 * @param {Chart.Animation} animation - The animation that we will animate.
	 * @param {number} duration - The animation duration in ms.
	 * @param {boolean} lazy - if true, the chart is not marked as animating to enable more responsive interactions
	 */
	addAnimation: function(chart, animation, duration, lazy) {
		var animations = this.animations;
		var i, ilen;

		animation.chart = chart;
		animation.startTime = Date.now();
		animation.duration = duration;

		if (!lazy) {
			chart.animating = true;
		}

		for (i = 0, ilen = animations.length; i < ilen; ++i) {
			if (animations[i].chart === chart) {
				animations[i] = animation;
				return;
			}
		}

		animations.push(animation);

		// If there are no animations queued, manually kickstart a digest, for lack of a better word
		if (animations.length === 1) {
			this.requestAnimationFrame();
		}
	},

	cancelAnimation: function(chart) {
		var index = helpers$1.findIndex(this.animations, function(animation) {
			return animation.chart === chart;
		});

		if (index !== -1) {
			this.animations.splice(index, 1);
			chart.animating = false;
		}
	},

	requestAnimationFrame: function() {
		var me = this;
		if (me.request === null) {
			// Skip animation frame requests until the active one is executed.
			// This can happen when processing mouse events, e.g. 'mousemove'
			// and 'mouseout' events will trigger multiple renders.
			me.request = helpers$1.requestAnimFrame.call(window, function() {
				me.request = null;
				me.startDigest();
			});
		}
	},

	/**
	 * @private
	 */
	startDigest: function() {
		var me = this;

		me.advance();

		// Do we have more stuff to animate?
		if (me.animations.length > 0) {
			me.requestAnimationFrame();
		}
	},

	/**
	 * @private
	 */
	advance: function() {
		var animations = this.animations;
		var animation, chart, numSteps, nextStep;
		var i = 0;

		// 1 animation per chart, so we are looping charts here
		while (i < animations.length) {
			animation = animations[i];
			chart = animation.chart;
			numSteps = animation.numSteps;

			// Make sure that currentStep starts at 1
			// https://github.com/chartjs/Chart.js/issues/6104
			nextStep = Math.floor((Date.now() - animation.startTime) / animation.duration * numSteps) + 1;
			animation.currentStep = Math.min(nextStep, numSteps);

			helpers$1.callback(animation.render, [chart, animation], chart);
			helpers$1.callback(animation.onAnimationProgress, [animation], chart);

			if (animation.currentStep >= numSteps) {
				helpers$1.callback(animation.onAnimationComplete, [animation], chart);
				chart.animating = false;
				animations.splice(i, 1);
			} else {
				++i;
			}
		}
	}
};

var resolve = helpers$1.options.resolve;

var arrayEvents = ['push', 'pop', 'shift', 'splice', 'unshift'];

/**
 * Hooks the array methods that add or remove values ('push', pop', 'shift', 'splice',
 * 'unshift') and notify the listener AFTER the array has been altered. Listeners are
 * called on the 'onData*' callbacks (e.g. onDataPush, etc.) with same arguments.
 */
function listenArrayEvents(array, listener) {
	if (array._chartjs) {
		array._chartjs.listeners.push(listener);
		return;
	}

	Object.defineProperty(array, '_chartjs', {
		configurable: true,
		enumerable: false,
		value: {
			listeners: [listener]
		}
	});

	arrayEvents.forEach(function(key) {
		var method = 'onData' + key.charAt(0).toUpperCase() + key.slice(1);
		var base = array[key];

		Object.defineProperty(array, key, {
			configurable: true,
			enumerable: false,
			value: function() {
				var args = Array.prototype.slice.call(arguments);
				var res = base.apply(this, args);

				helpers$1.each(array._chartjs.listeners, function(object) {
					if (typeof object[method] === 'function') {
						object[method].apply(object, args);
					}
				});

				return res;
			}
		});
	});
}

/**
 * Removes the given array event listener and cleanup extra attached properties (such as
 * the _chartjs stub and overridden methods) if array doesn't have any more listeners.
 */
function unlistenArrayEvents(array, listener) {
	var stub = array._chartjs;
	if (!stub) {
		return;
	}

	var listeners = stub.listeners;
	var index = listeners.indexOf(listener);
	if (index !== -1) {
		listeners.splice(index, 1);
	}

	if (listeners.length > 0) {
		return;
	}

	arrayEvents.forEach(function(key) {
		delete array[key];
	});

	delete array._chartjs;
}

// Base class for all dataset controllers (line, bar, etc)
var DatasetController = function(chart, datasetIndex) {
	this.initialize(chart, datasetIndex);
};

helpers$1.extend(DatasetController.prototype, {

	/**
	 * Element type used to generate a meta dataset (e.g. Chart.element.Line).
	 * @type {Chart.core.element}
	 */
	datasetElementType: null,

	/**
	 * Element type used to generate a meta data (e.g. Chart.element.Point).
	 * @type {Chart.core.element}
	 */
	dataElementType: null,

	/**
	 * Dataset element option keys to be resolved in _resolveDatasetElementOptions.
	 * A derived controller may override this to resolve controller-specific options.
	 * The keys defined here are for backward compatibility for legend styles.
	 * @private
	 */
	_datasetElementOptions: [
		'backgroundColor',
		'borderCapStyle',
		'borderColor',
		'borderDash',
		'borderDashOffset',
		'borderJoinStyle',
		'borderWidth'
	],

	/**
	 * Data element option keys to be resolved in _resolveDataElementOptions.
	 * A derived controller may override this to resolve controller-specific options.
	 * The keys defined here are for backward compatibility for legend styles.
	 * @private
	 */
	_dataElementOptions: [
		'backgroundColor',
		'borderColor',
		'borderWidth',
		'pointStyle'
	],

	initialize: function(chart, datasetIndex) {
		var me = this;
		me.chart = chart;
		me.index = datasetIndex;
		me.linkScales();
		me.addElements();
		me._type = me.getMeta().type;
	},

	updateIndex: function(datasetIndex) {
		this.index = datasetIndex;
	},

	linkScales: function() {
		var me = this;
		var meta = me.getMeta();
		var chart = me.chart;
		var scales = chart.scales;
		var dataset = me.getDataset();
		var scalesOpts = chart.options.scales;

		if (meta.xAxisID === null || !(meta.xAxisID in scales) || dataset.xAxisID) {
			meta.xAxisID = dataset.xAxisID || scalesOpts.xAxes[0].id;
		}
		if (meta.yAxisID === null || !(meta.yAxisID in scales) || dataset.yAxisID) {
			meta.yAxisID = dataset.yAxisID || scalesOpts.yAxes[0].id;
		}
	},

	getDataset: function() {
		return this.chart.data.datasets[this.index];
	},

	getMeta: function() {
		return this.chart.getDatasetMeta(this.index);
	},

	getScaleForId: function(scaleID) {
		return this.chart.scales[scaleID];
	},

	/**
	 * @private
	 */
	_getValueScaleId: function() {
		return this.getMeta().yAxisID;
	},

	/**
	 * @private
	 */
	_getIndexScaleId: function() {
		return this.getMeta().xAxisID;
	},

	/**
	 * @private
	 */
	_getValueScale: function() {
		return this.getScaleForId(this._getValueScaleId());
	},

	/**
	 * @private
	 */
	_getIndexScale: function() {
		return this.getScaleForId(this._getIndexScaleId());
	},

	reset: function() {
		this._update(true);
	},

	/**
	 * @private
	 */
	destroy: function() {
		if (this._data) {
			unlistenArrayEvents(this._data, this);
		}
	},

	createMetaDataset: function() {
		var me = this;
		var type = me.datasetElementType;
		return type && new type({
			_chart: me.chart,
			_datasetIndex: me.index
		});
	},

	createMetaData: function(index) {
		var me = this;
		var type = me.dataElementType;
		return type && new type({
			_chart: me.chart,
			_datasetIndex: me.index,
			_index: index
		});
	},

	addElements: function() {
		var me = this;
		var meta = me.getMeta();
		var data = me.getDataset().data || [];
		var metaData = meta.data;
		var i, ilen;

		for (i = 0, ilen = data.length; i < ilen; ++i) {
			metaData[i] = metaData[i] || me.createMetaData(i);
		}

		meta.dataset = meta.dataset || me.createMetaDataset();
	},

	addElementAndReset: function(index) {
		var element = this.createMetaData(index);
		this.getMeta().data.splice(index, 0, element);
		this.updateElement(element, index, true);
	},

	buildOrUpdateElements: function() {
		var me = this;
		var dataset = me.getDataset();
		var data = dataset.data || (dataset.data = []);

		// In order to correctly handle data addition/deletion animation (an thus simulate
		// real-time charts), we need to monitor these data modifications and synchronize
		// the internal meta data accordingly.
		if (me._data !== data) {
			if (me._data) {
				// This case happens when the user replaced the data array instance.
				unlistenArrayEvents(me._data, me);
			}

			if (data && Object.isExtensible(data)) {
				listenArrayEvents(data, me);
			}
			me._data = data;
		}

		// Re-sync meta data in case the user replaced the data array or if we missed
		// any updates and so make sure that we handle number of datapoints changing.
		me.resyncElements();
	},

	/**
	 * Returns the merged user-supplied and default dataset-level options
	 * @private
	 */
	_configure: function() {
		var me = this;
		me._config = helpers$1.merge(Object.create(null), [
			me.chart.options.datasets[me._type],
			me.getDataset(),
		], {
			merger: function(key, target, source) {
				if (key !== '_meta' && key !== 'data') {
					helpers$1._merger(key, target, source);
				}
			}
		});
	},

	_update: function(reset) {
		var me = this;
		me._configure();
		me._cachedDataOpts = null;
		me.update(reset);
	},

	update: helpers$1.noop,

	transition: function(easingValue) {
		var meta = this.getMeta();
		var elements = meta.data || [];
		var ilen = elements.length;
		var i = 0;

		for (; i < ilen; ++i) {
			elements[i].transition(easingValue);
		}

		if (meta.dataset) {
			meta.dataset.transition(easingValue);
		}
	},

	draw: function() {
		var meta = this.getMeta();
		var elements = meta.data || [];
		var ilen = elements.length;
		var i = 0;

		if (meta.dataset) {
			meta.dataset.draw();
		}

		for (; i < ilen; ++i) {
			elements[i].draw();
		}
	},

	/**
	 * Returns a set of predefined style properties that should be used to represent the dataset
	 * or the data if the index is specified
	 * @param {number} index - data index
	 * @return {IStyleInterface} style object
	 */
	getStyle: function(index) {
		var me = this;
		var meta = me.getMeta();
		var dataset = meta.dataset;
		var style;

		me._configure();
		if (dataset && index === undefined) {
			style = me._resolveDatasetElementOptions(dataset || {});
		} else {
			index = index || 0;
			style = me._resolveDataElementOptions(meta.data[index] || {}, index);
		}

		if (style.fill === false || style.fill === null) {
			style.backgroundColor = style.borderColor;
		}

		return style;
	},

	/**
	 * @private
	 */
	_resolveDatasetElementOptions: function(element, hover) {
		var me = this;
		var chart = me.chart;
		var datasetOpts = me._config;
		var custom = element.custom || {};
		var options = chart.options.elements[me.datasetElementType.prototype._type] || {};
		var elementOptions = me._datasetElementOptions;
		var values = {};
		var i, ilen, key, readKey;

		// Scriptable options
		var context = {
			chart: chart,
			dataset: me.getDataset(),
			datasetIndex: me.index,
			hover: hover
		};

		for (i = 0, ilen = elementOptions.length; i < ilen; ++i) {
			key = elementOptions[i];
			readKey = hover ? 'hover' + key.charAt(0).toUpperCase() + key.slice(1) : key;
			values[key] = resolve([
				custom[readKey],
				datasetOpts[readKey],
				options[readKey]
			], context);
		}

		return values;
	},

	/**
	 * @private
	 */
	_resolveDataElementOptions: function(element, index) {
		var me = this;
		var custom = element && element.custom;
		var cached = me._cachedDataOpts;
		if (cached && !custom) {
			return cached;
		}
		var chart = me.chart;
		var datasetOpts = me._config;
		var options = chart.options.elements[me.dataElementType.prototype._type] || {};
		var elementOptions = me._dataElementOptions;
		var values = {};

		// Scriptable options
		var context = {
			chart: chart,
			dataIndex: index,
			dataset: me.getDataset(),
			datasetIndex: me.index
		};

		// `resolve` sets cacheable to `false` if any option is indexed or scripted
		var info = {cacheable: !custom};

		var keys, i, ilen, key;

		custom = custom || {};

		if (helpers$1.isArray(elementOptions)) {
			for (i = 0, ilen = elementOptions.length; i < ilen; ++i) {
				key = elementOptions[i];
				values[key] = resolve([
					custom[key],
					datasetOpts[key],
					options[key]
				], context, index, info);
			}
		} else {
			keys = Object.keys(elementOptions);
			for (i = 0, ilen = keys.length; i < ilen; ++i) {
				key = keys[i];
				values[key] = resolve([
					custom[key],
					datasetOpts[elementOptions[key]],
					datasetOpts[key],
					options[key]
				], context, index, info);
			}
		}

		if (info.cacheable) {
			me._cachedDataOpts = Object.freeze(values);
		}

		return values;
	},

	removeHoverStyle: function(element) {
		helpers$1.merge(element._model, element.$previousStyle || {});
		delete element.$previousStyle;
	},

	setHoverStyle: function(element) {
		var dataset = this.chart.data.datasets[element._datasetIndex];
		var index = element._index;
		var custom = element.custom || {};
		var model = element._model;
		var getHoverColor = helpers$1.getHoverColor;

		element.$previousStyle = {
			backgroundColor: model.backgroundColor,
			borderColor: model.borderColor,
			borderWidth: model.borderWidth
		};

		model.backgroundColor = resolve([custom.hoverBackgroundColor, dataset.hoverBackgroundColor, getHoverColor(model.backgroundColor)], undefined, index);
		model.borderColor = resolve([custom.hoverBorderColor, dataset.hoverBorderColor, getHoverColor(model.borderColor)], undefined, index);
		model.borderWidth = resolve([custom.hoverBorderWidth, dataset.hoverBorderWidth, model.borderWidth], undefined, index);
	},

	/**
	 * @private
	 */
	_removeDatasetHoverStyle: function() {
		var element = this.getMeta().dataset;

		if (element) {
			this.removeHoverStyle(element);
		}
	},

	/**
	 * @private
	 */
	_setDatasetHoverStyle: function() {
		var element = this.getMeta().dataset;
		var prev = {};
		var i, ilen, key, keys, hoverOptions, model;

		if (!element) {
			return;
		}

		model = element._model;
		hoverOptions = this._resolveDatasetElementOptions(element, true);

		keys = Object.keys(hoverOptions);
		for (i = 0, ilen = keys.length; i < ilen; ++i) {
			key = keys[i];
			prev[key] = model[key];
			model[key] = hoverOptions[key];
		}

		element.$previousStyle = prev;
	},

	/**
	 * @private
	 */
	resyncElements: function() {
		var me = this;
		var meta = me.getMeta();
		var data = me.getDataset().data;
		var numMeta = meta.data.length;
		var numData = data.length;

		if (numData < numMeta) {
			meta.data.splice(numData, numMeta - numData);
		} else if (numData > numMeta) {
			me.insertElements(numMeta, numData - numMeta);
		}
	},

	/**
	 * @private
	 */
	insertElements: function(start, count) {
		for (var i = 0; i < count; ++i) {
			this.addElementAndReset(start + i);
		}
	},

	/**
	 * @private
	 */
	onDataPush: function() {
		var count = arguments.length;
		this.insertElements(this.getDataset().data.length - count, count);
	},

	/**
	 * @private
	 */
	onDataPop: function() {
		this.getMeta().data.pop();
	},

	/**
	 * @private
	 */
	onDataShift: function() {
		this.getMeta().data.shift();
	},

	/**
	 * @private
	 */
	onDataSplice: function(start, count) {
		this.getMeta().data.splice(start, count);
		this.insertElements(start, arguments.length - 2);
	},

	/**
	 * @private
	 */
	onDataUnshift: function() {
		this.insertElements(0, arguments.length);
	}
});

DatasetController.extend = helpers$1.inherits;

var core_datasetController = DatasetController;

var TAU = Math.PI * 2;

core_defaults._set('global', {
	elements: {
		arc: {
			backgroundColor: core_defaults.global.defaultColor,
			borderColor: '#fff',
			borderWidth: 2,
			borderAlign: 'center'
		}
	}
});

function clipArc(ctx, arc) {
	var startAngle = arc.startAngle;
	var endAngle = arc.endAngle;
	var pixelMargin = arc.pixelMargin;
	var angleMargin = pixelMargin / arc.outerRadius;
	var x = arc.x;
	var y = arc.y;

	// Draw an inner border by cliping the arc and drawing a double-width border
	// Enlarge the clipping arc by 0.33 pixels to eliminate glitches between borders
	ctx.beginPath();
	ctx.arc(x, y, arc.outerRadius, startAngle - angleMargin, endAngle + angleMargin);
	if (arc.innerRadius > pixelMargin) {
		angleMargin = pixelMargin / arc.innerRadius;
		ctx.arc(x, y, arc.innerRadius - pixelMargin, endAngle + angleMargin, startAngle - angleMargin, true);
	} else {
		ctx.arc(x, y, pixelMargin, endAngle + Math.PI / 2, startAngle - Math.PI / 2);
	}
	ctx.closePath();
	ctx.clip();
}

function drawFullCircleBorders(ctx, vm, arc, inner) {
	var endAngle = arc.endAngle;
	var i;

	if (inner) {
		arc.endAngle = arc.startAngle + TAU;
		clipArc(ctx, arc);
		arc.endAngle = endAngle;
		if (arc.endAngle === arc.startAngle && arc.fullCircles) {
			arc.endAngle += TAU;
			arc.fullCircles--;
		}
	}

	ctx.beginPath();
	ctx.arc(arc.x, arc.y, arc.innerRadius, arc.startAngle + TAU, arc.startAngle, true);
	for (i = 0; i < arc.fullCircles; ++i) {
		ctx.stroke();
	}

	ctx.beginPath();
	ctx.arc(arc.x, arc.y, vm.outerRadius, arc.startAngle, arc.startAngle + TAU);
	for (i = 0; i < arc.fullCircles; ++i) {
		ctx.stroke();
	}
}

function drawBorder(ctx, vm, arc) {
	var inner = vm.borderAlign === 'inner';

	if (inner) {
		ctx.lineWidth = vm.borderWidth * 2;
		ctx.lineJoin = 'round';
	} else {
		ctx.lineWidth = vm.borderWidth;
		ctx.lineJoin = 'bevel';
	}

	if (arc.fullCircles) {
		drawFullCircleBorders(ctx, vm, arc, inner);
	}

	if (inner) {
		clipArc(ctx, arc);
	}

	ctx.beginPath();
	ctx.arc(arc.x, arc.y, vm.outerRadius, arc.startAngle, arc.endAngle);
	ctx.arc(arc.x, arc.y, arc.innerRadius, arc.endAngle, arc.startAngle, true);
	ctx.closePath();
	ctx.stroke();
}

var element_arc = core_element.extend({
	_type: 'arc',

	inLabelRange: function(mouseX) {
		var vm = this._view;

		if (vm) {
			return (Math.pow(mouseX - vm.x, 2) < Math.pow(vm.radius + vm.hoverRadius, 2));
		}
		return false;
	},

	inRange: function(chartX, chartY) {
		var vm = this._view;

		if (vm) {
			var pointRelativePosition = helpers$1.getAngleFromPoint(vm, {x: chartX, y: chartY});
			var angle = pointRelativePosition.angle;
			var distance = pointRelativePosition.distance;

			// Sanitise angle range
			var startAngle = vm.startAngle;
			var endAngle = vm.endAngle;
			while (endAngle < startAngle) {
				endAngle += TAU;
			}
			while (angle > endAngle) {
				angle -= TAU;
			}
			while (angle < startAngle) {
				angle += TAU;
			}

			// Check if within the range of the open/close angle
			var betweenAngles = (angle >= startAngle && angle <= endAngle);
			var withinRadius = (distance >= vm.innerRadius && distance <= vm.outerRadius);

			return (betweenAngles && withinRadius);
		}
		return false;
	},

	getCenterPoint: function() {
		var vm = this._view;
		var halfAngle = (vm.startAngle + vm.endAngle) / 2;
		var halfRadius = (vm.innerRadius + vm.outerRadius) / 2;
		return {
			x: vm.x + Math.cos(halfAngle) * halfRadius,
			y: vm.y + Math.sin(halfAngle) * halfRadius
		};
	},

	getArea: function() {
		var vm = this._view;
		return Math.PI * ((vm.endAngle - vm.startAngle) / (2 * Math.PI)) * (Math.pow(vm.outerRadius, 2) - Math.pow(vm.innerRadius, 2));
	},

	tooltipPosition: function() {
		var vm = this._view;
		var centreAngle = vm.startAngle + ((vm.endAngle - vm.startAngle) / 2);
		var rangeFromCentre = (vm.outerRadius - vm.innerRadius) / 2 + vm.innerRadius;

		return {
			x: vm.x + (Math.cos(centreAngle) * rangeFromCentre),
			y: vm.y + (Math.sin(centreAngle) * rangeFromCentre)
		};
	},

	draw: function() {
		var ctx = this._chart.ctx;
		var vm = this._view;
		var pixelMargin = (vm.borderAlign === 'inner') ? 0.33 : 0;
		var arc = {
			x: vm.x,
			y: vm.y,
			innerRadius: vm.innerRadius,
			outerRadius: Math.max(vm.outerRadius - pixelMargin, 0),
			pixelMargin: pixelMargin,
			startAngle: vm.startAngle,
			endAngle: vm.endAngle,
			fullCircles: Math.floor(vm.circumference / TAU)
		};
		var i;

		ctx.save();

		ctx.fillStyle = vm.backgroundColor;
		ctx.strokeStyle = vm.borderColor;

		if (arc.fullCircles) {
			arc.endAngle = arc.startAngle + TAU;
			ctx.beginPath();
			ctx.arc(arc.x, arc.y, arc.outerRadius, arc.startAngle, arc.endAngle);
			ctx.arc(arc.x, arc.y, arc.innerRadius, arc.endAngle, arc.startAngle, true);
			ctx.closePath();
			for (i = 0; i < arc.fullCircles; ++i) {
				ctx.fill();
			}
			arc.endAngle = arc.startAngle + vm.circumference % TAU;
		}

		ctx.beginPath();
		ctx.arc(arc.x, arc.y, arc.outerRadius, arc.startAngle, arc.endAngle);
		ctx.arc(arc.x, arc.y, arc.innerRadius, arc.endAngle, arc.startAngle, true);
		ctx.closePath();
		ctx.fill();

		if (vm.borderWidth) {
			drawBorder(ctx, vm, arc);
		}

		ctx.restore();
	}
});

var valueOrDefault$1 = helpers$1.valueOrDefault;

var defaultColor = core_defaults.global.defaultColor;

core_defaults._set('global', {
	elements: {
		line: {
			tension: 0.4,
			backgroundColor: defaultColor,
			borderWidth: 3,
			borderColor: defaultColor,
			borderCapStyle: 'butt',
			borderDash: [],
			borderDashOffset: 0.0,
			borderJoinStyle: 'miter',
			capBezierPoints: true,
			fill: true, // do we fill in the area between the line and its base axis
		}
	}
});

var element_line = core_element.extend({
	_type: 'line',

	draw: function() {
		var me = this;
		var vm = me._view;
		var ctx = me._chart.ctx;
		var spanGaps = vm.spanGaps;
		var points = me._children.slice(); // clone array
		var globalDefaults = core_defaults.global;
		var globalOptionLineElements = globalDefaults.elements.line;
		var lastDrawnIndex = -1;
		var closePath = me._loop;
		var index, previous, currentVM;

		if (!points.length) {
			return;
		}

		if (me._loop) {
			for (index = 0; index < points.length; ++index) {
				previous = helpers$1.previousItem(points, index);
				// If the line has an open path, shift the point array
				if (!points[index]._view.skip && previous._view.skip) {
					points = points.slice(index).concat(points.slice(0, index));
					closePath = spanGaps;
					break;
				}
			}
			// If the line has a close path, add the first point again
			if (closePath) {
				points.push(points[0]);
			}
		}

		ctx.save();

		// Stroke Line Options
		ctx.lineCap = vm.borderCapStyle || globalOptionLineElements.borderCapStyle;

		// IE 9 and 10 do not support line dash
		if (ctx.setLineDash) {
			ctx.setLineDash(vm.borderDash || globalOptionLineElements.borderDash);
		}

		ctx.lineDashOffset = valueOrDefault$1(vm.borderDashOffset, globalOptionLineElements.borderDashOffset);
		ctx.lineJoin = vm.borderJoinStyle || globalOptionLineElements.borderJoinStyle;
		ctx.lineWidth = valueOrDefault$1(vm.borderWidth, globalOptionLineElements.borderWidth);
		ctx.strokeStyle = vm.borderColor || globalDefaults.defaultColor;

		// Stroke Line
		ctx.beginPath();

		// First point moves to it's starting position no matter what
		currentVM = points[0]._view;
		if (!currentVM.skip) {
			ctx.moveTo(currentVM.x, currentVM.y);
			lastDrawnIndex = 0;
		}

		for (index = 1; index < points.length; ++index) {
			currentVM = points[index]._view;
			previous = lastDrawnIndex === -1 ? helpers$1.previousItem(points, index) : points[lastDrawnIndex];

			if (!currentVM.skip) {
				if ((lastDrawnIndex !== (index - 1) && !spanGaps) || lastDrawnIndex === -1) {
					// There was a gap and this is the first point after the gap
					ctx.moveTo(currentVM.x, currentVM.y);
				} else {
					// Line to next point
					helpers$1.canvas.lineTo(ctx, previous._view, currentVM);
				}
				lastDrawnIndex = index;
			}
		}

		if (closePath) {
			ctx.closePath();
		}

		ctx.stroke();
		ctx.restore();
	}
});

var valueOrDefault$2 = helpers$1.valueOrDefault;

var defaultColor$1 = core_defaults.global.defaultColor;

core_defaults._set('global', {
	elements: {
		point: {
			radius: 3,
			pointStyle: 'circle',
			backgroundColor: defaultColor$1,
			borderColor: defaultColor$1,
			borderWidth: 1,
			// Hover
			hitRadius: 1,
			hoverRadius: 4,
			hoverBorderWidth: 1
		}
	}
});

function xRange(mouseX) {
	var vm = this._view;
	return vm ? (Math.abs(mouseX - vm.x) < vm.radius + vm.hitRadius) : false;
}

function yRange(mouseY) {
	var vm = this._view;
	return vm ? (Math.abs(mouseY - vm.y) < vm.radius + vm.hitRadius) : false;
}

var element_point = core_element.extend({
	_type: 'point',

	inRange: function(mouseX, mouseY) {
		var vm = this._view;
		return vm ? ((Math.pow(mouseX - vm.x, 2) + Math.pow(mouseY - vm.y, 2)) < Math.pow(vm.hitRadius + vm.radius, 2)) : false;
	},

	inLabelRange: xRange,
	inXRange: xRange,
	inYRange: yRange,

	getCenterPoint: function() {
		var vm = this._view;
		return {
			x: vm.x,
			y: vm.y
		};
	},

	getArea: function() {
		return Math.PI * Math.pow(this._view.radius, 2);
	},

	tooltipPosition: function() {
		var vm = this._view;
		return {
			x: vm.x,
			y: vm.y,
			padding: vm.radius + vm.borderWidth
		};
	},

	draw: function(chartArea) {
		var vm = this._view;
		var ctx = this._chart.ctx;
		var pointStyle = vm.pointStyle;
		var rotation = vm.rotation;
		var radius = vm.radius;
		var x = vm.x;
		var y = vm.y;
		var globalDefaults = core_defaults.global;
		var defaultColor = globalDefaults.defaultColor; // eslint-disable-line no-shadow

		if (vm.skip) {
			return;
		}

		// Clipping for Points.
		if (chartArea === undefined || helpers$1.canvas._isPointInArea(vm, chartArea)) {
			ctx.strokeStyle = vm.borderColor || defaultColor;
			ctx.lineWidth = valueOrDefault$2(vm.borderWidth, globalDefaults.elements.point.borderWidth);
			ctx.fillStyle = vm.backgroundColor || defaultColor;
			helpers$1.canvas.drawPoint(ctx, pointStyle, radius, x, y, rotation);
		}
	}
});

var defaultColor$2 = core_defaults.global.defaultColor;

core_defaults._set('global', {
	elements: {
		rectangle: {
			backgroundColor: defaultColor$2,
			borderColor: defaultColor$2,
			borderSkipped: 'bottom',
			borderWidth: 0
		}
	}
});

function isVertical(vm) {
	return vm && vm.width !== undefined;
}

/**
 * Helper function to get the bounds of the bar regardless of the orientation
 * @param bar {Chart.Element.Rectangle} the bar
 * @return {Bounds} bounds of the bar
 * @private
 */
function getBarBounds(vm) {
	var x1, x2, y1, y2, half;

	if (isVertical(vm)) {
		half = vm.width / 2;
		x1 = vm.x - half;
		x2 = vm.x + half;
		y1 = Math.min(vm.y, vm.base);
		y2 = Math.max(vm.y, vm.base);
	} else {
		half = vm.height / 2;
		x1 = Math.min(vm.x, vm.base);
		x2 = Math.max(vm.x, vm.base);
		y1 = vm.y - half;
		y2 = vm.y + half;
	}

	return {
		left: x1,
		top: y1,
		right: x2,
		bottom: y2
	};
}

function swap(orig, v1, v2) {
	return orig === v1 ? v2 : orig === v2 ? v1 : orig;
}

function parseBorderSkipped(vm) {
	var edge = vm.borderSkipped;
	var res = {};

	if (!edge) {
		return res;
	}

	if (vm.horizontal) {
		if (vm.base > vm.x) {
			edge = swap(edge, 'left', 'right');
		}
	} else if (vm.base < vm.y) {
		edge = swap(edge, 'bottom', 'top');
	}

	res[edge] = true;
	return res;
}

function parseBorderWidth(vm, maxW, maxH) {
	var value = vm.borderWidth;
	var skip = parseBorderSkipped(vm);
	var t, r, b, l;

	if (helpers$1.isObject(value)) {
		t = +value.top || 0;
		r = +value.right || 0;
		b = +value.bottom || 0;
		l = +value.left || 0;
	} else {
		t = r = b = l = +value || 0;
	}

	return {
		t: skip.top || (t < 0) ? 0 : t > maxH ? maxH : t,
		r: skip.right || (r < 0) ? 0 : r > maxW ? maxW : r,
		b: skip.bottom || (b < 0) ? 0 : b > maxH ? maxH : b,
		l: skip.left || (l < 0) ? 0 : l > maxW ? maxW : l
	};
}

function boundingRects(vm) {
	var bounds = getBarBounds(vm);
	var width = bounds.right - bounds.left;
	var height = bounds.bottom - bounds.top;
	var border = parseBorderWidth(vm, width / 2, height / 2);

	return {
		outer: {
			x: bounds.left,
			y: bounds.top,
			w: width,
			h: height
		},
		inner: {
			x: bounds.left + border.l,
			y: bounds.top + border.t,
			w: width - border.l - border.r,
			h: height - border.t - border.b
		}
	};
}

function inRange(vm, x, y) {
	var skipX = x === null;
	var skipY = y === null;
	var bounds = !vm || (skipX && skipY) ? false : getBarBounds(vm);

	return bounds
		&& (skipX || x >= bounds.left && x <= bounds.right)
		&& (skipY || y >= bounds.top && y <= bounds.bottom);
}

var element_rectangle = core_element.extend({
	_type: 'rectangle',

	draw: function() {
		var ctx = this._chart.ctx;
		var vm = this._view;
		var rects = boundingRects(vm);
		var outer = rects.outer;
		var inner = rects.inner;

		ctx.fillStyle = vm.backgroundColor;
		ctx.fillRect(outer.x, outer.y, outer.w, outer.h);

		if (outer.w === inner.w && outer.h === inner.h) {
			return;
		}

		ctx.save();
		ctx.beginPath();
		ctx.rect(outer.x, outer.y, outer.w, outer.h);
		ctx.clip();
		ctx.fillStyle = vm.borderColor;
		ctx.rect(inner.x, inner.y, inner.w, inner.h);
		ctx.fill('evenodd');
		ctx.restore();
	},

	height: function() {
		var vm = this._view;
		return vm.base - vm.y;
	},

	inRange: function(mouseX, mouseY) {
		return inRange(this._view, mouseX, mouseY);
	},

	inLabelRange: function(mouseX, mouseY) {
		var vm = this._view;
		return isVertical(vm)
			? inRange(vm, mouseX, null)
			: inRange(vm, null, mouseY);
	},

	inXRange: function(mouseX) {
		return inRange(this._view, mouseX, null);
	},

	inYRange: function(mouseY) {
		return inRange(this._view, null, mouseY);
	},

	getCenterPoint: function() {
		var vm = this._view;
		var x, y;
		if (isVertical(vm)) {
			x = vm.x;
			y = (vm.y + vm.base) / 2;
		} else {
			x = (vm.x + vm.base) / 2;
			y = vm.y;
		}

		return {x: x, y: y};
	},

	getArea: function() {
		var vm = this._view;

		return isVertical(vm)
			? vm.width * Math.abs(vm.y - vm.base)
			: vm.height * Math.abs(vm.x - vm.base);
	},

	tooltipPosition: function() {
		var vm = this._view;
		return {
			x: vm.x,
			y: vm.y
		};
	}
});

var elements = {};
var Arc = element_arc;
var Line = element_line;
var Point = element_point;
var Rectangle = element_rectangle;
elements.Arc = Arc;
elements.Line = Line;
elements.Point = Point;
elements.Rectangle = Rectangle;

var deprecated = helpers$1._deprecated;
var valueOrDefault$3 = helpers$1.valueOrDefault;

core_defaults._set('bar', {
	hover: {
		mode: 'label'
	},

	scales: {
		xAxes: [{
			type: 'category',
			offset: true,
			gridLines: {
				offsetGridLines: true
			}
		}],

		yAxes: [{
			type: 'linear'
		}]
	}
});

core_defaults._set('global', {
	datasets: {
		bar: {
			categoryPercentage: 0.8,
			barPercentage: 0.9
		}
	}
});

/**
 * Computes the "optimal" sample size to maintain bars equally sized while preventing overlap.
 * @private
 */
function computeMinSampleSize(scale, pixels) {
	var min = scale._length;
	var prev, curr, i, ilen;

	for (i = 1, ilen = pixels.length; i < ilen; ++i) {
		min = Math.min(min, Math.abs(pixels[i] - pixels[i - 1]));
	}

	for (i = 0, ilen = scale.getTicks().length; i < ilen; ++i) {
		curr = scale.getPixelForTick(i);
		min = i > 0 ? Math.min(min, Math.abs(curr - prev)) : min;
		prev = curr;
	}

	return min;
}

/**
 * Computes an "ideal" category based on the absolute bar thickness or, if undefined or null,
 * uses the smallest interval (see computeMinSampleSize) that prevents bar overlapping. This
 * mode currently always generates bars equally sized (until we introduce scriptable options?).
 * @private
 */
function computeFitCategoryTraits(index, ruler, options) {
	var thickness = options.barThickness;
	var count = ruler.stackCount;
	var curr = ruler.pixels[index];
	var min = helpers$1.isNullOrUndef(thickness)
		? computeMinSampleSize(ruler.scale, ruler.pixels)
		: -1;
	var size, ratio;

	if (helpers$1.isNullOrUndef(thickness)) {
		size = min * options.categoryPercentage;
		ratio = options.barPercentage;
	} else {
		// When bar thickness is enforced, category and bar percentages are ignored.
		// Note(SB): we could add support for relative bar thickness (e.g. barThickness: '50%')
		// and deprecate barPercentage since this value is ignored when thickness is absolute.
		size = thickness * count;
		ratio = 1;
	}

	return {
		chunk: size / count,
		ratio: ratio,
		start: curr - (size / 2)
	};
}

/**
 * Computes an "optimal" category that globally arranges bars side by side (no gap when
 * percentage options are 1), based on the previous and following categories. This mode
 * generates bars with different widths when data are not evenly spaced.
 * @private
 */
function computeFlexCategoryTraits(index, ruler, options) {
	var pixels = ruler.pixels;
	var curr = pixels[index];
	var prev = index > 0 ? pixels[index - 1] : null;
	var next = index < pixels.length - 1 ? pixels[index + 1] : null;
	var percent = options.categoryPercentage;
	var start, size;

	if (prev === null) {
		// first data: its size is double based on the next point or,
		// if it's also the last data, we use the scale size.
		prev = curr - (next === null ? ruler.end - ruler.start : next - curr);
	}

	if (next === null) {
		// last data: its size is also double based on the previous point.
		next = curr + curr - prev;
	}

	start = curr - (curr - Math.min(prev, next)) / 2 * percent;
	size = Math.abs(next - prev) / 2 * percent;

	return {
		chunk: size / ruler.stackCount,
		ratio: options.barPercentage,
		start: start
	};
}

var controller_bar = core_datasetController.extend({

	dataElementType: elements.Rectangle,

	/**
	 * @private
	 */
	_dataElementOptions: [
		'backgroundColor',
		'borderColor',
		'borderSkipped',
		'borderWidth',
		'barPercentage',
		'barThickness',
		'categoryPercentage',
		'maxBarThickness',
		'minBarLength'
	],

	initialize: function() {
		var me = this;
		var meta, scaleOpts;

		core_datasetController.prototype.initialize.apply(me, arguments);

		meta = me.getMeta();
		meta.stack = me.getDataset().stack;
		meta.bar = true;

		scaleOpts = me._getIndexScale().options;
		deprecated('bar chart', scaleOpts.barPercentage, 'scales.[x/y]Axes.barPercentage', 'dataset.barPercentage');
		deprecated('bar chart', scaleOpts.barThickness, 'scales.[x/y]Axes.barThickness', 'dataset.barThickness');
		deprecated('bar chart', scaleOpts.categoryPercentage, 'scales.[x/y]Axes.categoryPercentage', 'dataset.categoryPercentage');
		deprecated('bar chart', me._getValueScale().options.minBarLength, 'scales.[x/y]Axes.minBarLength', 'dataset.minBarLength');
		deprecated('bar chart', scaleOpts.maxBarThickness, 'scales.[x/y]Axes.maxBarThickness', 'dataset.maxBarThickness');
	},

	update: function(reset) {
		var me = this;
		var rects = me.getMeta().data;
		var i, ilen;

		me._ruler = me.getRuler();

		for (i = 0, ilen = rects.length; i < ilen; ++i) {
			me.updateElement(rects[i], i, reset);
		}
	},

	updateElement: function(rectangle, index, reset) {
		var me = this;
		var meta = me.getMeta();
		var dataset = me.getDataset();
		var options = me._resolveDataElementOptions(rectangle, index);

		rectangle._xScale = me.getScaleForId(meta.xAxisID);
		rectangle._yScale = me.getScaleForId(meta.yAxisID);
		rectangle._datasetIndex = me.index;
		rectangle._index = index;
		rectangle._model = {
			backgroundColor: options.backgroundColor,
			borderColor: options.borderColor,
			borderSkipped: options.borderSkipped,
			borderWidth: options.borderWidth,
			datasetLabel: dataset.label,
			label: me.chart.data.labels[index]
		};

		if (helpers$1.isArray(dataset.data[index])) {
			rectangle._model.borderSkipped = null;
		}

		me._updateElementGeometry(rectangle, index, reset, options);

		rectangle.pivot();
	},

	/**
	 * @private
	 */
	_updateElementGeometry: function(rectangle, index, reset, options) {
		var me = this;
		var model = rectangle._model;
		var vscale = me._getValueScale();
		var base = vscale.getBasePixel();
		var horizontal = vscale.isHorizontal();
		var ruler = me._ruler || me.getRuler();
		var vpixels = me.calculateBarValuePixels(me.index, index, options);
		var ipixels = me.calculateBarIndexPixels(me.index, index, ruler, options);

		model.horizontal = horizontal;
		model.base = reset ? base : vpixels.base;
		model.x = horizontal ? reset ? base : vpixels.head : ipixels.center;
		model.y = horizontal ? ipixels.center : reset ? base : vpixels.head;
		model.height = horizontal ? ipixels.size : undefined;
		model.width = horizontal ? undefined : ipixels.size;
	},

	/**
	 * Returns the stacks based on groups and bar visibility.
	 * @param {number} [last] - The dataset index
	 * @returns {string[]} The list of stack IDs
	 * @private
	 */
	_getStacks: function(last) {
		var me = this;
		var scale = me._getIndexScale();
		var metasets = scale._getMatchingVisibleMetas(me._type);
		var stacked = scale.options.stacked;
		var ilen = metasets.length;
		var stacks = [];
		var i, meta;

		for (i = 0; i < ilen; ++i) {
			meta = metasets[i];
			// stacked   | meta.stack
			//           | found | not found | undefined
			// false     |   x   |     x     |     x
			// true      |       |     x     |
			// undefined |       |     x     |     x
			if (stacked === false || stacks.indexOf(meta.stack) === -1 ||
				(stacked === undefined && meta.stack === undefined)) {
				stacks.push(meta.stack);
			}
			if (meta.index === last) {
				break;
			}
		}

		return stacks;
	},

	/**
	 * Returns the effective number of stacks based on groups and bar visibility.
	 * @private
	 */
	getStackCount: function() {
		return this._getStacks().length;
	},

	/**
	 * Returns the stack index for the given dataset based on groups and bar visibility.
	 * @param {number} [datasetIndex] - The dataset index
	 * @param {string} [name] - The stack name to find
	 * @returns {number} The stack index
	 * @private
	 */
	getStackIndex: function(datasetIndex, name) {
		var stacks = this._getStacks(datasetIndex);
		var index = (name !== undefined)
			? stacks.indexOf(name)
			: -1; // indexOf returns -1 if element is not present

		return (index === -1)
			? stacks.length - 1
			: index;
	},

	/**
	 * @private
	 */
	getRuler: function() {
		var me = this;
		var scale = me._getIndexScale();
		var pixels = [];
		var i, ilen;

		for (i = 0, ilen = me.getMeta().data.length; i < ilen; ++i) {
			pixels.push(scale.getPixelForValue(null, i, me.index));
		}

		return {
			pixels: pixels,
			start: scale._startPixel,
			end: scale._endPixel,
			stackCount: me.getStackCount(),
			scale: scale
		};
	},

	/**
	 * Note: pixel values are not clamped to the scale area.
	 * @private
	 */
	calculateBarValuePixels: function(datasetIndex, index, options) {
		var me = this;
		var chart = me.chart;
		var scale = me._getValueScale();
		var isHorizontal = scale.isHorizontal();
		var datasets = chart.data.datasets;
		var metasets = scale._getMatchingVisibleMetas(me._type);
		var value = scale._parseValue(datasets[datasetIndex].data[index]);
		var minBarLength = options.minBarLength;
		var stacked = scale.options.stacked;
		var stack = me.getMeta().stack;
		var start = value.start === undefined ? 0 : value.max >= 0 && value.min >= 0 ? value.min : value.max;
		var length = value.start === undefined ? value.end : value.max >= 0 && value.min >= 0 ? value.max - value.min : value.min - value.max;
		var ilen = metasets.length;
		var i, imeta, ivalue, base, head, size, stackLength;

		if (stacked || (stacked === undefined && stack !== undefined)) {
			for (i = 0; i < ilen; ++i) {
				imeta = metasets[i];

				if (imeta.index === datasetIndex) {
					break;
				}

				if (imeta.stack === stack) {
					stackLength = scale._parseValue(datasets[imeta.index].data[index]);
					ivalue = stackLength.start === undefined ? stackLength.end : stackLength.min >= 0 && stackLength.max >= 0 ? stackLength.max : stackLength.min;

					if ((value.min < 0 && ivalue < 0) || (value.max >= 0 && ivalue > 0)) {
						start += ivalue;
					}
				}
			}
		}

		base = scale.getPixelForValue(start);
		head = scale.getPixelForValue(start + length);
		size = head - base;

		if (minBarLength !== undefined && Math.abs(size) < minBarLength) {
			size = minBarLength;
			if (length >= 0 && !isHorizontal || length < 0 && isHorizontal) {
				head = base - minBarLength;
			} else {
				head = base + minBarLength;
			}
		}

		return {
			size: size,
			base: base,
			head: head,
			center: head + size / 2
		};
	},

	/**
	 * @private
	 */
	calculateBarIndexPixels: function(datasetIndex, index, ruler, options) {
		var me = this;
		var range = options.barThickness === 'flex'
			? computeFlexCategoryTraits(index, ruler, options)
			: computeFitCategoryTraits(index, ruler, options);

		var stackIndex = me.getStackIndex(datasetIndex, me.getMeta().stack);
		var center = range.start + (range.chunk * stackIndex) + (range.chunk / 2);
		var size = Math.min(
			valueOrDefault$3(options.maxBarThickness, Infinity),
			range.chunk * range.ratio);

		return {
			base: center - size / 2,
			head: center + size / 2,
			center: center,
			size: size
		};
	},

	draw: function() {
		var me = this;
		var chart = me.chart;
		var scale = me._getValueScale();
		var rects = me.getMeta().data;
		var dataset = me.getDataset();
		var ilen = rects.length;
		var i = 0;

		helpers$1.canvas.clipArea(chart.ctx, chart.chartArea);

		for (; i < ilen; ++i) {
			var val = scale._parseValue(dataset.data[i]);
			if (!isNaN(val.min) && !isNaN(val.max)) {
				rects[i].draw();
			}
		}

		helpers$1.canvas.unclipArea(chart.ctx);
	},

	/**
	 * @private
	 */
	_resolveDataElementOptions: function() {
		var me = this;
		var values = helpers$1.extend({}, core_datasetController.prototype._resolveDataElementOptions.apply(me, arguments));
		var indexOpts = me._getIndexScale().options;
		var valueOpts = me._getValueScale().options;

		values.barPercentage = valueOrDefault$3(indexOpts.barPercentage, values.barPercentage);
		values.barThickness = valueOrDefault$3(indexOpts.barThickness, values.barThickness);
		values.categoryPercentage = valueOrDefault$3(indexOpts.categoryPercentage, values.categoryPercentage);
		values.maxBarThickness = valueOrDefault$3(indexOpts.maxBarThickness, values.maxBarThickness);
		values.minBarLength = valueOrDefault$3(valueOpts.minBarLength, values.minBarLength);

		return values;
	}

});

var valueOrDefault$4 = helpers$1.valueOrDefault;
var resolve$1 = helpers$1.options.resolve;

core_defaults._set('bubble', {
	hover: {
		mode: 'single'
	},

	scales: {
		xAxes: [{
			type: 'linear', // bubble should probably use a linear scale by default
			position: 'bottom',
			id: 'x-axis-0' // need an ID so datasets can reference the scale
		}],
		yAxes: [{
			type: 'linear',
			position: 'left',
			id: 'y-axis-0'
		}]
	},

	tooltips: {
		callbacks: {
			title: function() {
				// Title doesn't make sense for scatter since we format the data as a point
				return '';
			},
			label: function(item, data) {
				var datasetLabel = data.datasets[item.datasetIndex].label || '';
				var dataPoint = data.datasets[item.datasetIndex].data[item.index];
				return datasetLabel + ': (' + item.xLabel + ', ' + item.yLabel + ', ' + dataPoint.r + ')';
			}
		}
	}
});

var controller_bubble = core_datasetController.extend({
	/**
	 * @protected
	 */
	dataElementType: elements.Point,

	/**
	 * @private
	 */
	_dataElementOptions: [
		'backgroundColor',
		'borderColor',
		'borderWidth',
		'hoverBackgroundColor',
		'hoverBorderColor',
		'hoverBorderWidth',
		'hoverRadius',
		'hitRadius',
		'pointStyle',
		'rotation'
	],

	/**
	 * @protected
	 */
	update: function(reset) {
		var me = this;
		var meta = me.getMeta();
		var points = meta.data;

		// Update Points
		helpers$1.each(points, function(point, index) {
			me.updateElement(point, index, reset);
		});
	},

	/**
	 * @protected
	 */
	updateElement: function(point, index, reset) {
		var me = this;
		var meta = me.getMeta();
		var custom = point.custom || {};
		var xScale = me.getScaleForId(meta.xAxisID);
		var yScale = me.getScaleForId(meta.yAxisID);
		var options = me._resolveDataElementOptions(point, index);
		var data = me.getDataset().data[index];
		var dsIndex = me.index;

		var x = reset ? xScale.getPixelForDecimal(0.5) : xScale.getPixelForValue(typeof data === 'object' ? data : NaN, index, dsIndex);
		var y = reset ? yScale.getBasePixel() : yScale.getPixelForValue(data, index, dsIndex);

		point._xScale = xScale;
		point._yScale = yScale;
		point._options = options;
		point._datasetIndex = dsIndex;
		point._index = index;
		point._model = {
			backgroundColor: options.backgroundColor,
			borderColor: options.borderColor,
			borderWidth: options.borderWidth,
			hitRadius: options.hitRadius,
			pointStyle: options.pointStyle,
			rotation: options.rotation,
			radius: reset ? 0 : options.radius,
			skip: custom.skip || isNaN(x) || isNaN(y),
			x: x,
			y: y,
		};

		point.pivot();
	},

	/**
	 * @protected
	 */
	setHoverStyle: function(point) {
		var model = point._model;
		var options = point._options;
		var getHoverColor = helpers$1.getHoverColor;

		point.$previousStyle = {
			backgroundColor: model.backgroundColor,
			borderColor: model.borderColor,
			borderWidth: model.borderWidth,
			radius: model.radius
		};

		model.backgroundColor = valueOrDefault$4(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
		model.borderColor = valueOrDefault$4(options.hoverBorderColor, getHoverColor(options.borderColor));
		model.borderWidth = valueOrDefault$4(options.hoverBorderWidth, options.borderWidth);
		model.radius = options.radius + options.hoverRadius;
	},

	/**
	 * @private
	 */
	_resolveDataElementOptions: function(point, index) {
		var me = this;
		var chart = me.chart;
		var dataset = me.getDataset();
		var custom = point.custom || {};
		var data = dataset.data[index] || {};
		var values = core_datasetController.prototype._resolveDataElementOptions.apply(me, arguments);

		// Scriptable options
		var context = {
			chart: chart,
			dataIndex: index,
			dataset: dataset,
			datasetIndex: me.index
		};

		// In case values were cached (and thus frozen), we need to clone the values
		if (me._cachedDataOpts === values) {
			values = helpers$1.extend({}, values);
		}

		// Custom radius resolution
		values.radius = resolve$1([
			custom.radius,
			data.r,
			me._config.radius,
			chart.options.elements.point.radius
		], context, index);

		return values;
	}
});

var valueOrDefault$5 = helpers$1.valueOrDefault;

var PI$1 = Math.PI;
var DOUBLE_PI$1 = PI$1 * 2;
var HALF_PI$1 = PI$1 / 2;

core_defaults._set('doughnut', {
	animation: {
		// Boolean - Whether we animate the rotation of the Doughnut
		animateRotate: true,
		// Boolean - Whether we animate scaling the Doughnut from the centre
		animateScale: false
	},
	hover: {
		mode: 'single'
	},
	legendCallback: function(chart) {
		var list = document.createElement('ul');
		var data = chart.data;
		var datasets = data.datasets;
		var labels = data.labels;
		var i, ilen, listItem, listItemSpan;

		list.setAttribute('class', chart.id + '-legend');
		if (datasets.length) {
			for (i = 0, ilen = datasets[0].data.length; i < ilen; ++i) {
				listItem = list.appendChild(document.createElement('li'));
				listItemSpan = listItem.appendChild(document.createElement('span'));
				listItemSpan.style.backgroundColor = datasets[0].backgroundColor[i];
				if (labels[i]) {
					listItem.appendChild(document.createTextNode(labels[i]));
				}
			}
		}

		return list.outerHTML;
	},
	legend: {
		labels: {
			generateLabels: function(chart) {
				var data = chart.data;
				if (data.labels.length && data.datasets.length) {
					return data.labels.map(function(label, i) {
						var meta = chart.getDatasetMeta(0);
						var style = meta.controller.getStyle(i);

						return {
							text: label,
							fillStyle: style.backgroundColor,
							strokeStyle: style.borderColor,
							lineWidth: style.borderWidth,
							hidden: isNaN(data.datasets[0].data[i]) || meta.data[i].hidden,

							// Extra data used for toggling the correct item
							index: i
						};
					});
				}
				return [];
			}
		},

		onClick: function(e, legendItem) {
			var index = legendItem.index;
			var chart = this.chart;
			var i, ilen, meta;

			for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
				meta = chart.getDatasetMeta(i);
				// toggle visibility of index if exists
				if (meta.data[index]) {
					meta.data[index].hidden = !meta.data[index].hidden;
				}
			}

			chart.update();
		}
	},

	// The percentage of the chart that we cut out of the middle.
	cutoutPercentage: 50,

	// The rotation of the chart, where the first data arc begins.
	rotation: -HALF_PI$1,

	// The total circumference of the chart.
	circumference: DOUBLE_PI$1,

	// Need to override these to give a nice default
	tooltips: {
		callbacks: {
			title: function() {
				return '';
			},
			label: function(tooltipItem, data) {
				var dataLabel = data.labels[tooltipItem.index];
				var value = ': ' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];

				if (helpers$1.isArray(dataLabel)) {
					// show value on first line of multiline label
					// need to clone because we are changing the value
					dataLabel = dataLabel.slice();
					dataLabel[0] += value;
				} else {
					dataLabel += value;
				}

				return dataLabel;
			}
		}
	}
});

var controller_doughnut = core_datasetController.extend({

	dataElementType: elements.Arc,

	linkScales: helpers$1.noop,

	/**
	 * @private
	 */
	_dataElementOptions: [
		'backgroundColor',
		'borderColor',
		'borderWidth',
		'borderAlign',
		'hoverBackgroundColor',
		'hoverBorderColor',
		'hoverBorderWidth',
	],

	// Get index of the dataset in relation to the visible datasets. This allows determining the inner and outer radius correctly
	getRingIndex: function(datasetIndex) {
		var ringIndex = 0;

		for (var j = 0; j < datasetIndex; ++j) {
			if (this.chart.isDatasetVisible(j)) {
				++ringIndex;
			}
		}

		return ringIndex;
	},

	update: function(reset) {
		var me = this;
		var chart = me.chart;
		var chartArea = chart.chartArea;
		var opts = chart.options;
		var ratioX = 1;
		var ratioY = 1;
		var offsetX = 0;
		var offsetY = 0;
		var meta = me.getMeta();
		var arcs = meta.data;
		var cutout = opts.cutoutPercentage / 100 || 0;
		var circumference = opts.circumference;
		var chartWeight = me._getRingWeight(me.index);
		var maxWidth, maxHeight, i, ilen;

		// If the chart's circumference isn't a full circle, calculate size as a ratio of the width/height of the arc
		if (circumference < DOUBLE_PI$1) {
			var startAngle = opts.rotation % DOUBLE_PI$1;
			startAngle += startAngle >= PI$1 ? -DOUBLE_PI$1 : startAngle < -PI$1 ? DOUBLE_PI$1 : 0;
			var endAngle = startAngle + circumference;
			var startX = Math.cos(startAngle);
			var startY = Math.sin(startAngle);
			var endX = Math.cos(endAngle);
			var endY = Math.sin(endAngle);
			var contains0 = (startAngle <= 0 && endAngle >= 0) || endAngle >= DOUBLE_PI$1;
			var contains90 = (startAngle <= HALF_PI$1 && endAngle >= HALF_PI$1) || endAngle >= DOUBLE_PI$1 + HALF_PI$1;
			var contains180 = startAngle === -PI$1 || endAngle >= PI$1;
			var contains270 = (startAngle <= -HALF_PI$1 && endAngle >= -HALF_PI$1) || endAngle >= PI$1 + HALF_PI$1;
			var minX = contains180 ? -1 : Math.min(startX, startX * cutout, endX, endX * cutout);
			var minY = contains270 ? -1 : Math.min(startY, startY * cutout, endY, endY * cutout);
			var maxX = contains0 ? 1 : Math.max(startX, startX * cutout, endX, endX * cutout);
			var maxY = contains90 ? 1 : Math.max(startY, startY * cutout, endY, endY * cutout);
			ratioX = (maxX - minX) / 2;
			ratioY = (maxY - minY) / 2;
			offsetX = -(maxX + minX) / 2;
			offsetY = -(maxY + minY) / 2;
		}

		for (i = 0, ilen = arcs.length; i < ilen; ++i) {
			arcs[i]._options = me._resolveDataElementOptions(arcs[i], i);
		}

		chart.borderWidth = me.getMaxBorderWidth();
		maxWidth = (chartArea.right - chartArea.left - chart.borderWidth) / ratioX;
		maxHeight = (chartArea.bottom - chartArea.top - chart.borderWidth) / ratioY;
		chart.outerRadius = Math.max(Math.min(maxWidth, maxHeight) / 2, 0);
		chart.innerRadius = Math.max(chart.outerRadius * cutout, 0);
		chart.radiusLength = (chart.outerRadius - chart.innerRadius) / (me._getVisibleDatasetWeightTotal() || 1);
		chart.offsetX = offsetX * chart.outerRadius;
		chart.offsetY = offsetY * chart.outerRadius;

		meta.total = me.calculateTotal();

		me.outerRadius = chart.outerRadius - chart.radiusLength * me._getRingWeightOffset(me.index);
		me.innerRadius = Math.max(me.outerRadius - chart.radiusLength * chartWeight, 0);

		for (i = 0, ilen = arcs.length; i < ilen; ++i) {
			me.updateElement(arcs[i], i, reset);
		}
	},

	updateElement: function(arc, index, reset) {
		var me = this;
		var chart = me.chart;
		var chartArea = chart.chartArea;
		var opts = chart.options;
		var animationOpts = opts.animation;
		var centerX = (chartArea.left + chartArea.right) / 2;
		var centerY = (chartArea.top + chartArea.bottom) / 2;
		var startAngle = opts.rotation; // non reset case handled later
		var endAngle = opts.rotation; // non reset case handled later
		var dataset = me.getDataset();
		var circumference = reset && animationOpts.animateRotate ? 0 : arc.hidden ? 0 : me.calculateCircumference(dataset.data[index]) * (opts.circumference / DOUBLE_PI$1);
		var innerRadius = reset && animationOpts.animateScale ? 0 : me.innerRadius;
		var outerRadius = reset && animationOpts.animateScale ? 0 : me.outerRadius;
		var options = arc._options || {};

		helpers$1.extend(arc, {
			// Utility
			_datasetIndex: me.index,
			_index: index,

			// Desired view properties
			_model: {
				backgroundColor: options.backgroundColor,
				borderColor: options.borderColor,
				borderWidth: options.borderWidth,
				borderAlign: options.borderAlign,
				x: centerX + chart.offsetX,
				y: centerY + chart.offsetY,
				startAngle: startAngle,
				endAngle: endAngle,
				circumference: circumference,
				outerRadius: outerRadius,
				innerRadius: innerRadius,
				label: helpers$1.valueAtIndexOrDefault(dataset.label, index, chart.data.labels[index])
			}
		});

		var model = arc._model;

		// Set correct angles if not resetting
		if (!reset || !animationOpts.animateRotate) {
			if (index === 0) {
				model.startAngle = opts.rotation;
			} else {
				model.startAngle = me.getMeta().data[index - 1]._model.endAngle;
			}

			model.endAngle = model.startAngle + model.circumference;
		}

		arc.pivot();
	},

	calculateTotal: function() {
		var dataset = this.getDataset();
		var meta = this.getMeta();
		var total = 0;
		var value;

		helpers$1.each(meta.data, function(element, index) {
			value = dataset.data[index];
			if (!isNaN(value) && !element.hidden) {
				total += Math.abs(value);
			}
		});

		/* if (total === 0) {
			total = NaN;
		}*/

		return total;
	},

	calculateCircumference: function(value) {
		var total = this.getMeta().total;
		if (total > 0 && !isNaN(value)) {
			return DOUBLE_PI$1 * (Math.abs(value) / total);
		}
		return 0;
	},

	// gets the max border or hover width to properly scale pie charts
	getMaxBorderWidth: function(arcs) {
		var me = this;
		var max = 0;
		var chart = me.chart;
		var i, ilen, meta, arc, controller, options, borderWidth, hoverWidth;

		if (!arcs) {
			// Find the outmost visible dataset
			for (i = 0, ilen = chart.data.datasets.length; i < ilen; ++i) {
				if (chart.isDatasetVisible(i)) {
					meta = chart.getDatasetMeta(i);
					arcs = meta.data;
					if (i !== me.index) {
						controller = meta.controller;
					}
					break;
				}
			}
		}

		if (!arcs) {
			return 0;
		}

		for (i = 0, ilen = arcs.length; i < ilen; ++i) {
			arc = arcs[i];
			if (controller) {
				controller._configure();
				options = controller._resolveDataElementOptions(arc, i);
			} else {
				options = arc._options;
			}
			if (options.borderAlign !== 'inner') {
				borderWidth = options.borderWidth;
				hoverWidth = options.hoverBorderWidth;

				max = borderWidth > max ? borderWidth : max;
				max = hoverWidth > max ? hoverWidth : max;
			}
		}
		return max;
	},

	/**
	 * @protected
	 */
	setHoverStyle: function(arc) {
		var model = arc._model;
		var options = arc._options;
		var getHoverColor = helpers$1.getHoverColor;

		arc.$previousStyle = {
			backgroundColor: model.backgroundColor,
			borderColor: model.borderColor,
			borderWidth: model.borderWidth,
		};

		model.backgroundColor = valueOrDefault$5(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
		model.borderColor = valueOrDefault$5(options.hoverBorderColor, getHoverColor(options.borderColor));
		model.borderWidth = valueOrDefault$5(options.hoverBorderWidth, options.borderWidth);
	},

	/**
	 * Get radius length offset of the dataset in relation to the visible datasets weights. This allows determining the inner and outer radius correctly
	 * @private
	 */
	_getRingWeightOffset: function(datasetIndex) {
		var ringWeightOffset = 0;

		for (var i = 0; i < datasetIndex; ++i) {
			if (this.chart.isDatasetVisible(i)) {
				ringWeightOffset += this._getRingWeight(i);
			}
		}

		return ringWeightOffset;
	},

	/**
	 * @private
	 */
	_getRingWeight: function(dataSetIndex) {
		return Math.max(valueOrDefault$5(this.chart.data.datasets[dataSetIndex].weight, 1), 0);
	},

	/**
	 * Returns the sum of all visibile data set weights.  This value can be 0.
	 * @private
	 */
	_getVisibleDatasetWeightTotal: function() {
		return this._getRingWeightOffset(this.chart.data.datasets.length);
	}
});

core_defaults._set('horizontalBar', {
	hover: {
		mode: 'index',
		axis: 'y'
	},

	scales: {
		xAxes: [{
			type: 'linear',
			position: 'bottom'
		}],

		yAxes: [{
			type: 'category',
			position: 'left',
			offset: true,
			gridLines: {
				offsetGridLines: true
			}
		}]
	},

	elements: {
		rectangle: {
			borderSkipped: 'left'
		}
	},

	tooltips: {
		mode: 'index',
		axis: 'y'
	}
});

core_defaults._set('global', {
	datasets: {
		horizontalBar: {
			categoryPercentage: 0.8,
			barPercentage: 0.9
		}
	}
});

var controller_horizontalBar = controller_bar.extend({
	/**
	 * @private
	 */
	_getValueScaleId: function() {
		return this.getMeta().xAxisID;
	},

	/**
	 * @private
	 */
	_getIndexScaleId: function() {
		return this.getMeta().yAxisID;
	}
});

var valueOrDefault$6 = helpers$1.valueOrDefault;
var resolve$2 = helpers$1.options.resolve;
var isPointInArea = helpers$1.canvas._isPointInArea;

core_defaults._set('line', {
	showLines: true,
	spanGaps: false,

	hover: {
		mode: 'label'
	},

	scales: {
		xAxes: [{
			type: 'category',
			id: 'x-axis-0'
		}],
		yAxes: [{
			type: 'linear',
			id: 'y-axis-0'
		}]
	}
});

function scaleClip(scale, halfBorderWidth) {
	var tickOpts = scale && scale.options.ticks || {};
	var reverse = tickOpts.reverse;
	var min = tickOpts.min === undefined ? halfBorderWidth : 0;
	var max = tickOpts.max === undefined ? halfBorderWidth : 0;
	return {
		start: reverse ? max : min,
		end: reverse ? min : max
	};
}

function defaultClip(xScale, yScale, borderWidth) {
	var halfBorderWidth = borderWidth / 2;
	var x = scaleClip(xScale, halfBorderWidth);
	var y = scaleClip(yScale, halfBorderWidth);

	return {
		top: y.end,
		right: x.end,
		bottom: y.start,
		left: x.start
	};
}

function toClip(value) {
	var t, r, b, l;

	if (helpers$1.isObject(value)) {
		t = value.top;
		r = value.right;
		b = value.bottom;
		l = value.left;
	} else {
		t = r = b = l = value;
	}

	return {
		top: t,
		right: r,
		bottom: b,
		left: l
	};
}


var controller_line = core_datasetController.extend({

	datasetElementType: elements.Line,

	dataElementType: elements.Point,

	/**
	 * @private
	 */
	_datasetElementOptions: [
		'backgroundColor',
		'borderCapStyle',
		'borderColor',
		'borderDash',
		'borderDashOffset',
		'borderJoinStyle',
		'borderWidth',
		'cubicInterpolationMode',
		'fill'
	],

	/**
	 * @private
	 */
	_dataElementOptions: {
		backgroundColor: 'pointBackgroundColor',
		borderColor: 'pointBorderColor',
		borderWidth: 'pointBorderWidth',
		hitRadius: 'pointHitRadius',
		hoverBackgroundColor: 'pointHoverBackgroundColor',
		hoverBorderColor: 'pointHoverBorderColor',
		hoverBorderWidth: 'pointHoverBorderWidth',
		hoverRadius: 'pointHoverRadius',
		pointStyle: 'pointStyle',
		radius: 'pointRadius',
		rotation: 'pointRotation'
	},

	update: function(reset) {
		var me = this;
		var meta = me.getMeta();
		var line = meta.dataset;
		var points = meta.data || [];
		var options = me.chart.options;
		var config = me._config;
		var showLine = me._showLine = valueOrDefault$6(config.showLine, options.showLines);
		var i, ilen;

		me._xScale = me.getScaleForId(meta.xAxisID);
		me._yScale = me.getScaleForId(meta.yAxisID);

		// Update Line
		if (showLine) {
			// Compatibility: If the properties are defined with only the old name, use those values
			if (config.tension !== undefined && config.lineTension === undefined) {
				config.lineTension = config.tension;
			}

			// Utility
			line._scale = me._yScale;
			line._datasetIndex = me.index;
			// Data
			line._children = points;
			// Model
			line._model = me._resolveDatasetElementOptions(line);

			line.pivot();
		}

		// Update Points
		for (i = 0, ilen = points.length; i < ilen; ++i) {
			me.updateElement(points[i], i, reset);
		}

		if (showLine && line._model.tension !== 0) {
			me.updateBezierControlPoints();
		}

		// Now pivot the point for animation
		for (i = 0, ilen = points.length; i < ilen; ++i) {
			points[i].pivot();
		}
	},

	updateElement: function(point, index, reset) {
		var me = this;
		var meta = me.getMeta();
		var custom = point.custom || {};
		var dataset = me.getDataset();
		var datasetIndex = me.index;
		var value = dataset.data[index];
		var xScale = me._xScale;
		var yScale = me._yScale;
		var lineModel = meta.dataset._model;
		var x, y;

		var options = me._resolveDataElementOptions(point, index);

		x = xScale.getPixelForValue(typeof value === 'object' ? value : NaN, index, datasetIndex);
		y = reset ? yScale.getBasePixel() : me.calculatePointY(value, index, datasetIndex);

		// Utility
		point._xScale = xScale;
		point._yScale = yScale;
		point._options = options;
		point._datasetIndex = datasetIndex;
		point._index = index;

		// Desired view properties
		point._model = {
			x: x,
			y: y,
			skip: custom.skip || isNaN(x) || isNaN(y),
			// Appearance
			radius: options.radius,
			pointStyle: options.pointStyle,
			rotation: options.rotation,
			backgroundColor: options.backgroundColor,
			borderColor: options.borderColor,
			borderWidth: options.borderWidth,
			tension: valueOrDefault$6(custom.tension, lineModel ? lineModel.tension : 0),
			steppedLine: lineModel ? lineModel.steppedLine : false,
			// Tooltip
			hitRadius: options.hitRadius
		};
	},

	/**
	 * @private
	 */
	_resolveDatasetElementOptions: function(element) {
		var me = this;
		var config = me._config;
		var custom = element.custom || {};
		var options = me.chart.options;
		var lineOptions = options.elements.line;
		var values = core_datasetController.prototype._resolveDatasetElementOptions.apply(me, arguments);

		// The default behavior of lines is to break at null values, according
		// to https://github.com/chartjs/Chart.js/issues/2435#issuecomment-216718158
		// This option gives lines the ability to span gaps
		values.spanGaps = valueOrDefault$6(config.spanGaps, options.spanGaps);
		values.tension = valueOrDefault$6(config.lineTension, lineOptions.tension);
		values.steppedLine = resolve$2([custom.steppedLine, config.steppedLine, lineOptions.stepped]);
		values.clip = toClip(valueOrDefault$6(config.clip, defaultClip(me._xScale, me._yScale, values.borderWidth)));

		return values;
	},

	calculatePointY: function(value, index, datasetIndex) {
		var me = this;
		var chart = me.chart;
		var yScale = me._yScale;
		var sumPos = 0;
		var sumNeg = 0;
		var i, ds, dsMeta, stackedRightValue, rightValue, metasets, ilen;

		if (yScale.options.stacked) {
			rightValue = +yScale.getRightValue(value);
			metasets = chart._getSortedVisibleDatasetMetas();
			ilen = metasets.length;

			for (i = 0; i < ilen; ++i) {
				dsMeta = metasets[i];
				if (dsMeta.index === datasetIndex) {
					break;
				}

				ds = chart.data.datasets[dsMeta.index];
				if (dsMeta.type === 'line' && dsMeta.yAxisID === yScale.id) {
					stackedRightValue = +yScale.getRightValue(ds.data[index]);
					if (stackedRightValue < 0) {
						sumNeg += stackedRightValue || 0;
					} else {
						sumPos += stackedRightValue || 0;
					}
				}
			}

			if (rightValue < 0) {
				return yScale.getPixelForValue(sumNeg + rightValue);
			}
			return yScale.getPixelForValue(sumPos + rightValue);
		}
		return yScale.getPixelForValue(value);
	},

	updateBezierControlPoints: function() {
		var me = this;
		var chart = me.chart;
		var meta = me.getMeta();
		var lineModel = meta.dataset._model;
		var area = chart.chartArea;
		var points = meta.data || [];
		var i, ilen, model, controlPoints;

		// Only consider points that are drawn in case the spanGaps option is used
		if (lineModel.spanGaps) {
			points = points.filter(function(pt) {
				return !pt._model.skip;
			});
		}

		function capControlPoint(pt, min, max) {
			return Math.max(Math.min(pt, max), min);
		}

		if (lineModel.cubicInterpolationMode === 'monotone') {
			helpers$1.splineCurveMonotone(points);
		} else {
			for (i = 0, ilen = points.length; i < ilen; ++i) {
				model = points[i]._model;
				controlPoints = helpers$1.splineCurve(
					helpers$1.previousItem(points, i)._model,
					model,
					helpers$1.nextItem(points, i)._model,
					lineModel.tension
				);
				model.controlPointPreviousX = controlPoints.previous.x;
				model.controlPointPreviousY = controlPoints.previous.y;
				model.controlPointNextX = controlPoints.next.x;
				model.controlPointNextY = controlPoints.next.y;
			}
		}

		if (chart.options.elements.line.capBezierPoints) {
			for (i = 0, ilen = points.length; i < ilen; ++i) {
				model = points[i]._model;
				if (isPointInArea(model, area)) {
					if (i > 0 && isPointInArea(points[i - 1]._model, area)) {
						model.controlPointPreviousX = capControlPoint(model.controlPointPreviousX, area.left, area.right);
						model.controlPointPreviousY = capControlPoint(model.controlPointPreviousY, area.top, area.bottom);
					}
					if (i < points.length - 1 && isPointInArea(points[i + 1]._model, area)) {
						model.controlPointNextX = capControlPoint(model.controlPointNextX, area.left, area.right);
						model.controlPointNextY = capControlPoint(model.controlPointNextY, area.top, area.bottom);
					}
				}
			}
		}
	},

	draw: function() {
		var me = this;
		var chart = me.chart;
		var meta = me.getMeta();
		var points = meta.data || [];
		var area = chart.chartArea;
		var canvas = chart.canvas;
		var i = 0;
		var ilen = points.length;
		var clip;

		if (me._showLine) {
			clip = meta.dataset._model.clip;

			helpers$1.canvas.clipArea(chart.ctx, {
				left: clip.left === false ? 0 : area.left - clip.left,
				right: clip.right === false ? canvas.width : area.right + clip.right,
				top: clip.top === false ? 0 : area.top - clip.top,
				bottom: clip.bottom === false ? canvas.height : area.bottom + clip.bottom
			});

			meta.dataset.draw();

			helpers$1.canvas.unclipArea(chart.ctx);
		}

		// Draw the points
		for (; i < ilen; ++i) {
			points[i].draw(area);
		}
	},

	/**
	 * @protected
	 */
	setHoverStyle: function(point) {
		var model = point._model;
		var options = point._options;
		var getHoverColor = helpers$1.getHoverColor;

		point.$previousStyle = {
			backgroundColor: model.backgroundColor,
			borderColor: model.borderColor,
			borderWidth: model.borderWidth,
			radius: model.radius
		};

		model.backgroundColor = valueOrDefault$6(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
		model.borderColor = valueOrDefault$6(options.hoverBorderColor, getHoverColor(options.borderColor));
		model.borderWidth = valueOrDefault$6(options.hoverBorderWidth, options.borderWidth);
		model.radius = valueOrDefault$6(options.hoverRadius, options.radius);
	},
});

var resolve$3 = helpers$1.options.resolve;

core_defaults._set('polarArea', {
	scale: {
		type: 'radialLinear',
		angleLines: {
			display: false
		},
		gridLines: {
			circular: true
		},
		pointLabels: {
			display: false
		},
		ticks: {
			beginAtZero: true
		}
	},

	// Boolean - Whether to animate the rotation of the chart
	animation: {
		animateRotate: true,
		animateScale: true
	},

	startAngle: -0.5 * Math.PI,
	legendCallback: function(chart) {
		var list = document.createElement('ul');
		var data = chart.data;
		var datasets = data.datasets;
		var labels = data.labels;
		var i, ilen, listItem, listItemSpan;

		list.setAttribute('class', chart.id + '-legend');
		if (datasets.length) {
			for (i = 0, ilen = datasets[0].data.length; i < ilen; ++i) {
				listItem = list.appendChild(document.createElement('li'));
				listItemSpan = listItem.appendChild(document.createElement('span'));
				listItemSpan.style.backgroundColor = datasets[0].backgroundColor[i];
				if (labels[i]) {
					listItem.appendChild(document.createTextNode(labels[i]));
				}
			}
		}

		return list.outerHTML;
	},
	legend: {
		labels: {
			generateLabels: function(chart) {
				var data = chart.data;
				if (data.labels.length && data.datasets.length) {
					return data.labels.map(function(label, i) {
						var meta = chart.getDatasetMeta(0);
						var style = meta.controller.getStyle(i);

						return {
							text: label,
							fillStyle: style.backgroundColor,
							strokeStyle: style.borderColor,
							lineWidth: style.borderWidth,
							hidden: isNaN(data.datasets[0].data[i]) || meta.data[i].hidden,

							// Extra data used for toggling the correct item
							index: i
						};
					});
				}
				return [];
			}
		},

		onClick: function(e, legendItem) {
			var index = legendItem.index;
			var chart = this.chart;
			var i, ilen, meta;

			for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
				meta = chart.getDatasetMeta(i);
				meta.data[index].hidden = !meta.data[index].hidden;
			}

			chart.update();
		}
	},

	// Need to override these to give a nice default
	tooltips: {
		callbacks: {
			title: function() {
				return '';
			},
			label: function(item, data) {
				return data.labels[item.index] + ': ' + item.yLabel;
			}
		}
	}
});

var controller_polarArea = core_datasetController.extend({

	dataElementType: elements.Arc,

	linkScales: helpers$1.noop,

	/**
	 * @private
	 */
	_dataElementOptions: [
		'backgroundColor',
		'borderColor',
		'borderWidth',
		'borderAlign',
		'hoverBackgroundColor',
		'hoverBorderColor',
		'hoverBorderWidth',
	],

	/**
	 * @private
	 */
	_getIndexScaleId: function() {
		return this.chart.scale.id;
	},

	/**
	 * @private
	 */
	_getValueScaleId: function() {
		return this.chart.scale.id;
	},

	update: function(reset) {
		var me = this;
		var dataset = me.getDataset();
		var meta = me.getMeta();
		var start = me.chart.options.startAngle || 0;
		var starts = me._starts = [];
		var angles = me._angles = [];
		var arcs = meta.data;
		var i, ilen, angle;

		me._updateRadius();

		meta.count = me.countVisibleElements();

		for (i = 0, ilen = dataset.data.length; i < ilen; i++) {
			starts[i] = start;
			angle = me._computeAngle(i);
			angles[i] = angle;
			start += angle;
		}

		for (i = 0, ilen = arcs.length; i < ilen; ++i) {
			arcs[i]._options = me._resolveDataElementOptions(arcs[i], i);
			me.updateElement(arcs[i], i, reset);
		}
	},

	/**
	 * @private
	 */
	_updateRadius: function() {
		var me = this;
		var chart = me.chart;
		var chartArea = chart.chartArea;
		var opts = chart.options;
		var minSize = Math.min(chartArea.right - chartArea.left, chartArea.bottom - chartArea.top);

		chart.outerRadius = Math.max(minSize / 2, 0);
		chart.innerRadius = Math.max(opts.cutoutPercentage ? (chart.outerRadius / 100) * (opts.cutoutPercentage) : 1, 0);
		chart.radiusLength = (chart.outerRadius - chart.innerRadius) / chart.getVisibleDatasetCount();

		me.outerRadius = chart.outerRadius - (chart.radiusLength * me.index);
		me.innerRadius = me.outerRadius - chart.radiusLength;
	},

	updateElement: function(arc, index, reset) {
		var me = this;
		var chart = me.chart;
		var dataset = me.getDataset();
		var opts = chart.options;
		var animationOpts = opts.animation;
		var scale = chart.scale;
		var labels = chart.data.labels;

		var centerX = scale.xCenter;
		var centerY = scale.yCenter;

		// var negHalfPI = -0.5 * Math.PI;
		var datasetStartAngle = opts.startAngle;
		var distance = arc.hidden ? 0 : scale.getDistanceFromCenterForValue(dataset.data[index]);
		var startAngle = me._starts[index];
		var endAngle = startAngle + (arc.hidden ? 0 : me._angles[index]);

		var resetRadius = animationOpts.animateScale ? 0 : scale.getDistanceFromCenterForValue(dataset.data[index]);
		var options = arc._options || {};

		helpers$1.extend(arc, {
			// Utility
			_datasetIndex: me.index,
			_index: index,
			_scale: scale,

			// Desired view properties
			_model: {
				backgroundColor: options.backgroundColor,
				borderColor: options.borderColor,
				borderWidth: options.borderWidth,
				borderAlign: options.borderAlign,
				x: centerX,
				y: centerY,
				innerRadius: 0,
				outerRadius: reset ? resetRadius : distance,
				startAngle: reset && animationOpts.animateRotate ? datasetStartAngle : startAngle,
				endAngle: reset && animationOpts.animateRotate ? datasetStartAngle : endAngle,
				label: helpers$1.valueAtIndexOrDefault(labels, index, labels[index])
			}
		});

		arc.pivot();
	},

	countVisibleElements: function() {
		var dataset = this.getDataset();
		var meta = this.getMeta();
		var count = 0;

		helpers$1.each(meta.data, function(element, index) {
			if (!isNaN(dataset.data[index]) && !element.hidden) {
				count++;
			}
		});

		return count;
	},

	/**
	 * @protected
	 */
	setHoverStyle: function(arc) {
		var model = arc._model;
		var options = arc._options;
		var getHoverColor = helpers$1.getHoverColor;
		var valueOrDefault = helpers$1.valueOrDefault;

		arc.$previousStyle = {
			backgroundColor: model.backgroundColor,
			borderColor: model.borderColor,
			borderWidth: model.borderWidth,
		};

		model.backgroundColor = valueOrDefault(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
		model.borderColor = valueOrDefault(options.hoverBorderColor, getHoverColor(options.borderColor));
		model.borderWidth = valueOrDefault(options.hoverBorderWidth, options.borderWidth);
	},

	/**
	 * @private
	 */
	_computeAngle: function(index) {
		var me = this;
		var count = this.getMeta().count;
		var dataset = me.getDataset();
		var meta = me.getMeta();

		if (isNaN(dataset.data[index]) || meta.data[index].hidden) {
			return 0;
		}

		// Scriptable options
		var context = {
			chart: me.chart,
			dataIndex: index,
			dataset: dataset,
			datasetIndex: me.index
		};

		return resolve$3([
			me.chart.options.elements.arc.angle,
			(2 * Math.PI) / count
		], context, index);
	}
});

core_defaults._set('pie', helpers$1.clone(core_defaults.doughnut));
core_defaults._set('pie', {
	cutoutPercentage: 0
});

// Pie charts are Doughnut chart with different defaults
var controller_pie = controller_doughnut;

var valueOrDefault$7 = helpers$1.valueOrDefault;

core_defaults._set('radar', {
	spanGaps: false,
	scale: {
		type: 'radialLinear'
	},
	elements: {
		line: {
			fill: 'start',
			tension: 0 // no bezier in radar
		}
	}
});

var controller_radar = core_datasetController.extend({
	datasetElementType: elements.Line,

	dataElementType: elements.Point,

	linkScales: helpers$1.noop,

	/**
	 * @private
	 */
	_datasetElementOptions: [
		'backgroundColor',
		'borderWidth',
		'borderColor',
		'borderCapStyle',
		'borderDash',
		'borderDashOffset',
		'borderJoinStyle',
		'fill'
	],

	/**
	 * @private
	 */
	_dataElementOptions: {
		backgroundColor: 'pointBackgroundColor',
		borderColor: 'pointBorderColor',
		borderWidth: 'pointBorderWidth',
		hitRadius: 'pointHitRadius',
		hoverBackgroundColor: 'pointHoverBackgroundColor',
		hoverBorderColor: 'pointHoverBorderColor',
		hoverBorderWidth: 'pointHoverBorderWidth',
		hoverRadius: 'pointHoverRadius',
		pointStyle: 'pointStyle',
		radius: 'pointRadius',
		rotation: 'pointRotation'
	},

	/**
	 * @private
	 */
	_getIndexScaleId: function() {
		return this.chart.scale.id;
	},

	/**
	 * @private
	 */
	_getValueScaleId: function() {
		return this.chart.scale.id;
	},

	update: function(reset) {
		var me = this;
		var meta = me.getMeta();
		var line = meta.dataset;
		var points = meta.data || [];
		var scale = me.chart.scale;
		var config = me._config;
		var i, ilen;

		// Compatibility: If the properties are defined with only the old name, use those values
		if (config.tension !== undefined && config.lineTension === undefined) {
			config.lineTension = config.tension;
		}

		// Utility
		line._scale = scale;
		line._datasetIndex = me.index;
		// Data
		line._children = points;
		line._loop = true;
		// Model
		line._model = me._resolveDatasetElementOptions(line);

		line.pivot();

		// Update Points
		for (i = 0, ilen = points.length; i < ilen; ++i) {
			me.updateElement(points[i], i, reset);
		}

		// Update bezier control points
		me.updateBezierControlPoints();

		// Now pivot the point for animation
		for (i = 0, ilen = points.length; i < ilen; ++i) {
			points[i].pivot();
		}
	},

	updateElement: function(point, index, reset) {
		var me = this;
		var custom = point.custom || {};
		var dataset = me.getDataset();
		var scale = me.chart.scale;
		var pointPosition = scale.getPointPositionForValue(index, dataset.data[index]);
		var options = me._resolveDataElementOptions(point, index);
		var lineModel = me.getMeta().dataset._model;
		var x = reset ? scale.xCenter : pointPosition.x;
		var y = reset ? scale.yCenter : pointPosition.y;

		// Utility
		point._scale = scale;
		point._options = options;
		point._datasetIndex = me.index;
		point._index = index;

		// Desired view properties
		point._model = {
			x: x, // value not used in dataset scale, but we want a consistent API between scales
			y: y,
			skip: custom.skip || isNaN(x) || isNaN(y),
			// Appearance
			radius: options.radius,
			pointStyle: options.pointStyle,
			rotation: options.rotation,
			backgroundColor: options.backgroundColor,
			borderColor: options.borderColor,
			borderWidth: options.borderWidth,
			tension: valueOrDefault$7(custom.tension, lineModel ? lineModel.tension : 0),

			// Tooltip
			hitRadius: options.hitRadius
		};
	},

	/**
	 * @private
	 */
	_resolveDatasetElementOptions: function() {
		var me = this;
		var config = me._config;
		var options = me.chart.options;
		var values = core_datasetController.prototype._resolveDatasetElementOptions.apply(me, arguments);

		values.spanGaps = valueOrDefault$7(config.spanGaps, options.spanGaps);
		values.tension = valueOrDefault$7(config.lineTension, options.elements.line.tension);

		return values;
	},

	updateBezierControlPoints: function() {
		var me = this;
		var meta = me.getMeta();
		var area = me.chart.chartArea;
		var points = meta.data || [];
		var i, ilen, model, controlPoints;

		// Only consider points that are drawn in case the spanGaps option is used
		if (meta.dataset._model.spanGaps) {
			points = points.filter(function(pt) {
				return !pt._model.skip;
			});
		}

		function capControlPoint(pt, min, max) {
			return Math.max(Math.min(pt, max), min);
		}

		for (i = 0, ilen = points.length; i < ilen; ++i) {
			model = points[i]._model;
			controlPoints = helpers$1.splineCurve(
				helpers$1.previousItem(points, i, true)._model,
				model,
				helpers$1.nextItem(points, i, true)._model,
				model.tension
			);

			// Prevent the bezier going outside of the bounds of the graph
			model.controlPointPreviousX = capControlPoint(controlPoints.previous.x, area.left, area.right);
			model.controlPointPreviousY = capControlPoint(controlPoints.previous.y, area.top, area.bottom);
			model.controlPointNextX = capControlPoint(controlPoints.next.x, area.left, area.right);
			model.controlPointNextY = capControlPoint(controlPoints.next.y, area.top, area.bottom);
		}
	},

	setHoverStyle: function(point) {
		var model = point._model;
		var options = point._options;
		var getHoverColor = helpers$1.getHoverColor;

		point.$previousStyle = {
			backgroundColor: model.backgroundColor,
			borderColor: model.borderColor,
			borderWidth: model.borderWidth,
			radius: model.radius
		};

		model.backgroundColor = valueOrDefault$7(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
		model.borderColor = valueOrDefault$7(options.hoverBorderColor, getHoverColor(options.borderColor));
		model.borderWidth = valueOrDefault$7(options.hoverBorderWidth, options.borderWidth);
		model.radius = valueOrDefault$7(options.hoverRadius, options.radius);
	}
});

core_defaults._set('scatter', {
	hover: {
		mode: 'single'
	},

	scales: {
		xAxes: [{
			id: 'x-axis-1',    // need an ID so datasets can reference the scale
			type: 'linear',    // scatter should not use a category axis
			position: 'bottom'
		}],
		yAxes: [{
			id: 'y-axis-1',
			type: 'linear',
			position: 'left'
		}]
	},

	tooltips: {
		callbacks: {
			title: function() {
				return '';     // doesn't make sense for scatter since data are formatted as a point
			},
			label: function(item) {
				return '(' + item.xLabel + ', ' + item.yLabel + ')';
			}
		}
	}
});

core_defaults._set('global', {
	datasets: {
		scatter: {
			showLine: false
		}
	}
});

// Scatter charts use line controllers
var controller_scatter = controller_line;

// NOTE export a map in which the key represents the controller type, not
// the class, and so must be CamelCase in order to be correctly retrieved
// by the controller in core.controller.js (`controllers[meta.type]`).

var controllers = {
	bar: controller_bar,
	bubble: controller_bubble,
	doughnut: controller_doughnut,
	horizontalBar: controller_horizontalBar,
	line: controller_line,
	polarArea: controller_polarArea,
	pie: controller_pie,
	radar: controller_radar,
	scatter: controller_scatter
};

/**
 * Helper function to get relative position for an event
 * @param {Event|IEvent} event - The event to get the position for
 * @param {Chart} chart - The chart
 * @returns {object} the event position
 */
function getRelativePosition(e, chart) {
	if (e.native) {
		return {
			x: e.x,
			y: e.y
		};
	}

	return helpers$1.getRelativePosition(e, chart);
}

/**
 * Helper function to traverse all of the visible elements in the chart
 * @param {Chart} chart - the chart
 * @param {function} handler - the callback to execute for each visible item
 */
function parseVisibleItems(chart, handler) {
	var metasets = chart._getSortedVisibleDatasetMetas();
	var metadata, i, j, ilen, jlen, element;

	for (i = 0, ilen = metasets.length; i < ilen; ++i) {
		metadata = metasets[i].data;
		for (j = 0, jlen = metadata.length; j < jlen; ++j) {
			element = metadata[j];
			if (!element._view.skip) {
				handler(element);
			}
		}
	}
}

/**
 * Helper function to get the items that intersect the event position
 * @param {ChartElement[]} items - elements to filter
 * @param {object} position - the point to be nearest to
 * @return {ChartElement[]} the nearest items
 */
function getIntersectItems(chart, position) {
	var elements = [];

	parseVisibleItems(chart, function(element) {
		if (element.inRange(position.x, position.y)) {
			elements.push(element);
		}
	});

	return elements;
}

/**
 * Helper function to get the items nearest to the event position considering all visible items in teh chart
 * @param {Chart} chart - the chart to look at elements from
 * @param {object} position - the point to be nearest to
 * @param {boolean} intersect - if true, only consider items that intersect the position
 * @param {function} distanceMetric - function to provide the distance between points
 * @return {ChartElement[]} the nearest items
 */
function getNearestItems(chart, position, intersect, distanceMetric) {
	var minDistance = Number.POSITIVE_INFINITY;
	var nearestItems = [];

	parseVisibleItems(chart, function(element) {
		if (intersect && !element.inRange(position.x, position.y)) {
			return;
		}

		var center = element.getCenterPoint();
		var distance = distanceMetric(position, center);
		if (distance < minDistance) {
			nearestItems = [element];
			minDistance = distance;
		} else if (distance === minDistance) {
			// Can have multiple items at the same distance in which case we sort by size
			nearestItems.push(element);
		}
	});

	return nearestItems;
}

/**
 * Get a distance metric function for two points based on the
 * axis mode setting
 * @param {string} axis - the axis mode. x|y|xy
 */
function getDistanceMetricForAxis(axis) {
	var useX = axis.indexOf('x') !== -1;
	var useY = axis.indexOf('y') !== -1;

	return function(pt1, pt2) {
		var deltaX = useX ? Math.abs(pt1.x - pt2.x) : 0;
		var deltaY = useY ? Math.abs(pt1.y - pt2.y) : 0;
		return Math.sqrt(Math.pow(deltaX, 2) + Math.pow(deltaY, 2));
	};
}

function indexMode(chart, e, options) {
	var position = getRelativePosition(e, chart);
	// Default axis for index mode is 'x' to match old behaviour
	options.axis = options.axis || 'x';
	var distanceMetric = getDistanceMetricForAxis(options.axis);
	var items = options.intersect ? getIntersectItems(chart, position) : getNearestItems(chart, position, false, distanceMetric);
	var elements = [];

	if (!items.length) {
		return [];
	}

	chart._getSortedVisibleDatasetMetas().forEach(function(meta) {
		var element = meta.data[items[0]._index];

		// don't count items that are skipped (null data)
		if (element && !element._view.skip) {
			elements.push(element);
		}
	});

	return elements;
}

/**
 * @interface IInteractionOptions
 */
/**
 * If true, only consider items that intersect the point
 * @name IInterfaceOptions#boolean
 * @type Boolean
 */

/**
 * Contains interaction related functions
 * @namespace Chart.Interaction
 */
var core_interaction = {
	// Helper function for different modes
	modes: {
		single: function(chart, e) {
			var position = getRelativePosition(e, chart);
			var elements = [];

			parseVisibleItems(chart, function(element) {
				if (element.inRange(position.x, position.y)) {
					elements.push(element);
					return elements;
				}
			});

			return elements.slice(0, 1);
		},

		/**
		 * @function Chart.Interaction.modes.label
		 * @deprecated since version 2.4.0
		 * @todo remove at version 3
		 * @private
		 */
		label: indexMode,

		/**
		 * Returns items at the same index. If the options.intersect parameter is true, we only return items if we intersect something
		 * If the options.intersect mode is false, we find the nearest item and return the items at the same index as that item
		 * @function Chart.Interaction.modes.index
		 * @since v2.4.0
		 * @param {Chart} chart - the chart we are returning items from
		 * @param {Event} e - the event we are find things at
		 * @param {IInteractionOptions} options - options to use during interaction
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */
		index: indexMode,

		/**
		 * Returns items in the same dataset. If the options.intersect parameter is true, we only return items if we intersect something
		 * If the options.intersect is false, we find the nearest item and return the items in that dataset
		 * @function Chart.Interaction.modes.dataset
		 * @param {Chart} chart - the chart we are returning items from
		 * @param {Event} e - the event we are find things at
		 * @param {IInteractionOptions} options - options to use during interaction
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */
		dataset: function(chart, e, options) {
			var position = getRelativePosition(e, chart);
			options.axis = options.axis || 'xy';
			var distanceMetric = getDistanceMetricForAxis(options.axis);
			var items = options.intersect ? getIntersectItems(chart, position) : getNearestItems(chart, position, false, distanceMetric);

			if (items.length > 0) {
				items = chart.getDatasetMeta(items[0]._datasetIndex).data;
			}

			return items;
		},

		/**
		 * @function Chart.Interaction.modes.x-axis
		 * @deprecated since version 2.4.0. Use index mode and intersect == true
		 * @todo remove at version 3
		 * @private
		 */
		'x-axis': function(chart, e) {
			return indexMode(chart, e, {intersect: false});
		},

		/**
		 * Point mode returns all elements that hit test based on the event position
		 * of the event
		 * @function Chart.Interaction.modes.intersect
		 * @param {Chart} chart - the chart we are returning items from
		 * @param {Event} e - the event we are find things at
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */
		point: function(chart, e) {
			var position = getRelativePosition(e, chart);
			return getIntersectItems(chart, position);
		},

		/**
		 * nearest mode returns the element closest to the point
		 * @function Chart.Interaction.modes.intersect
		 * @param {Chart} chart - the chart we are returning items from
		 * @param {Event} e - the event we are find things at
		 * @param {IInteractionOptions} options - options to use
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */
		nearest: function(chart, e, options) {
			var position = getRelativePosition(e, chart);
			options.axis = options.axis || 'xy';
			var distanceMetric = getDistanceMetricForAxis(options.axis);
			return getNearestItems(chart, position, options.intersect, distanceMetric);
		},

		/**
		 * x mode returns the elements that hit-test at the current x coordinate
		 * @function Chart.Interaction.modes.x
		 * @param {Chart} chart - the chart we are returning items from
		 * @param {Event} e - the event we are find things at
		 * @param {IInteractionOptions} options - options to use
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */
		x: function(chart, e, options) {
			var position = getRelativePosition(e, chart);
			var items = [];
			var intersectsItem = false;

			parseVisibleItems(chart, function(element) {
				if (element.inXRange(position.x)) {
					items.push(element);
				}

				if (element.inRange(position.x, position.y)) {
					intersectsItem = true;
				}
			});

			// If we want to trigger on an intersect and we don't have any items
			// that intersect the position, return nothing
			if (options.intersect && !intersectsItem) {
				items = [];
			}
			return items;
		},

		/**
		 * y mode returns the elements that hit-test at the current y coordinate
		 * @function Chart.Interaction.modes.y
		 * @param {Chart} chart - the chart we are returning items from
		 * @param {Event} e - the event we are find things at
		 * @param {IInteractionOptions} options - options to use
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */
		y: function(chart, e, options) {
			var position = getRelativePosition(e, chart);
			var items = [];
			var intersectsItem = false;

			parseVisibleItems(chart, function(element) {
				if (element.inYRange(position.y)) {
					items.push(element);
				}

				if (element.inRange(position.x, position.y)) {
					intersectsItem = true;
				}
			});

			// If we want to trigger on an intersect and we don't have any items
			// that intersect the position, return nothing
			if (options.intersect && !intersectsItem) {
				items = [];
			}
			return items;
		}
	}
};

var extend = helpers$1.extend;

function filterByPosition(array, position) {
	return helpers$1.where(array, function(v) {
		return v.pos === position;
	});
}

function sortByWeight(array, reverse) {
	return array.sort(function(a, b) {
		var v0 = reverse ? b : a;
		var v1 = reverse ? a : b;
		return v0.weight === v1.weight ?
			v0.index - v1.index :
			v0.weight - v1.weight;
	});
}

function wrapBoxes(boxes) {
	var layoutBoxes = [];
	var i, ilen, box;

	for (i = 0, ilen = (boxes || []).length; i < ilen; ++i) {
		box = boxes[i];
		layoutBoxes.push({
			index: i,
			box: box,
			pos: box.position,
			horizontal: box.isHorizontal(),
			weight: box.weight
		});
	}
	return layoutBoxes;
}

function setLayoutDims(layouts, params) {
	var i, ilen, layout;
	for (i = 0, ilen = layouts.length; i < ilen; ++i) {
		layout = layouts[i];
		// store width used instead of chartArea.w in fitBoxes
		layout.width = layout.horizontal
			? layout.box.fullWidth && params.availableWidth
			: params.vBoxMaxWidth;
		// store height used instead of chartArea.h in fitBoxes
		layout.height = layout.horizontal && params.hBoxMaxHeight;
	}
}

function buildLayoutBoxes(boxes) {
	var layoutBoxes = wrapBoxes(boxes);
	var left = sortByWeight(filterByPosition(layoutBoxes, 'left'), true);
	var right = sortByWeight(filterByPosition(layoutBoxes, 'right'));
	var top = sortByWeight(filterByPosition(layoutBoxes, 'top'), true);
	var bottom = sortByWeight(filterByPosition(layoutBoxes, 'bottom'));

	return {
		leftAndTop: left.concat(top),
		rightAndBottom: right.concat(bottom),
		chartArea: filterByPosition(layoutBoxes, 'chartArea'),
		vertical: left.concat(right),
		horizontal: top.concat(bottom)
	};
}

function getCombinedMax(maxPadding, chartArea, a, b) {
	return Math.max(maxPadding[a], chartArea[a]) + Math.max(maxPadding[b], chartArea[b]);
}

function updateDims(chartArea, params, layout) {
	var box = layout.box;
	var maxPadding = chartArea.maxPadding;
	var newWidth, newHeight;

	if (layout.size) {
		// this layout was already counted for, lets first reduce old size
		chartArea[layout.pos] -= layout.size;
	}
	layout.size = layout.horizontal ? box.height : box.width;
	chartArea[layout.pos] += layout.size;

	if (box.getPadding) {
		var boxPadding = box.getPadding();
		maxPadding.top = Math.max(maxPadding.top, boxPadding.top);
		maxPadding.left = Math.max(maxPadding.left, boxPadding.left);
		maxPadding.bottom = Math.max(maxPadding.bottom, boxPadding.bottom);
		maxPadding.right = Math.max(maxPadding.right, boxPadding.right);
	}

	newWidth = params.outerWidth - getCombinedMax(maxPadding, chartArea, 'left', 'right');
	newHeight = params.outerHeight - getCombinedMax(maxPadding, chartArea, 'top', 'bottom');

	if (newWidth !== chartArea.w || newHeight !== chartArea.h) {
		chartArea.w = newWidth;
		chartArea.h = newHeight;

		// return true if chart area changed in layout's direction
		var sizes = layout.horizontal ? [newWidth, chartArea.w] : [newHeight, chartArea.h];
		return sizes[0] !== sizes[1] && (!isNaN(sizes[0]) || !isNaN(sizes[1]));
	}
}

function handleMaxPadding(chartArea) {
	var maxPadding = chartArea.maxPadding;

	function updatePos(pos) {
		var change = Math.max(maxPadding[pos] - chartArea[pos], 0);
		chartArea[pos] += change;
		return change;
	}
	chartArea.y += updatePos('top');
	chartArea.x += updatePos('left');
	updatePos('right');
	updatePos('bottom');
}

function getMargins(horizontal, chartArea) {
	var maxPadding = chartArea.maxPadding;

	function marginForPositions(positions) {
		var margin = {left: 0, top: 0, right: 0, bottom: 0};
		positions.forEach(function(pos) {
			margin[pos] = Math.max(chartArea[pos], maxPadding[pos]);
		});
		return margin;
	}

	return horizontal
		? marginForPositions(['left', 'right'])
		: marginForPositions(['top', 'bottom']);
}

function fitBoxes(boxes, chartArea, params) {
	var refitBoxes = [];
	var i, ilen, layout, box, refit, changed;

	for (i = 0, ilen = boxes.length; i < ilen; ++i) {
		layout = boxes[i];
		box = layout.box;

		box.update(
			layout.width || chartArea.w,
			layout.height || chartArea.h,
			getMargins(layout.horizontal, chartArea)
		);
		if (updateDims(chartArea, params, layout)) {
			changed = true;
			if (refitBoxes.length) {
				// Dimensions changed and there were non full width boxes before this
				// -> we have to refit those
				refit = true;
			}
		}
		if (!box.fullWidth) { // fullWidth boxes don't need to be re-fitted in any case
			refitBoxes.push(layout);
		}
	}

	return refit ? fitBoxes(refitBoxes, chartArea, params) || changed : changed;
}

function placeBoxes(boxes, chartArea, params) {
	var userPadding = params.padding;
	var x = chartArea.x;
	var y = chartArea.y;
	var i, ilen, layout, box;

	for (i = 0, ilen = boxes.length; i < ilen; ++i) {
		layout = boxes[i];
		box = layout.box;
		if (layout.horizontal) {
			box.left = box.fullWidth ? userPadding.left : chartArea.left;
			box.right = box.fullWidth ? params.outerWidth - userPadding.right : chartArea.left + chartArea.w;
			box.top = y;
			box.bottom = y + box.height;
			box.width = box.right - box.left;
			y = box.bottom;
		} else {
			box.left = x;
			box.right = x + box.width;
			box.top = chartArea.top;
			box.bottom = chartArea.top + chartArea.h;
			box.height = box.bottom - box.top;
			x = box.right;
		}
	}

	chartArea.x = x;
	chartArea.y = y;
}

core_defaults._set('global', {
	layout: {
		padding: {
			top: 0,
			right: 0,
			bottom: 0,
			left: 0
		}
	}
});

/**
 * @interface ILayoutItem
 * @prop {string} position - The position of the item in the chart layout. Possible values are
 * 'left', 'top', 'right', 'bottom', and 'chartArea'
 * @prop {number} weight - The weight used to sort the item. Higher weights are further away from the chart area
 * @prop {boolean} fullWidth - if true, and the item is horizontal, then push vertical boxes down
 * @prop {function} isHorizontal - returns true if the layout item is horizontal (ie. top or bottom)
 * @prop {function} update - Takes two parameters: width and height. Returns size of item
 * @prop {function} getPadding -  Returns an object with padding on the edges
 * @prop {number} width - Width of item. Must be valid after update()
 * @prop {number} height - Height of item. Must be valid after update()
 * @prop {number} left - Left edge of the item. Set by layout system and cannot be used in update
 * @prop {number} top - Top edge of the item. Set by layout system and cannot be used in update
 * @prop {number} right - Right edge of the item. Set by layout system and cannot be used in update
 * @prop {number} bottom - Bottom edge of the item. Set by layout system and cannot be used in update
 */

// The layout service is very self explanatory.  It's responsible for the layout within a chart.
// Scales, Legends and Plugins all rely on the layout service and can easily register to be placed anywhere they need
// It is this service's responsibility of carrying out that layout.
var core_layouts = {
	defaults: {},

	/**
	 * Register a box to a chart.
	 * A box is simply a reference to an object that requires layout. eg. Scales, Legend, Title.
	 * @param {Chart} chart - the chart to use
	 * @param {ILayoutItem} item - the item to add to be layed out
	 */
	addBox: function(chart, item) {
		if (!chart.boxes) {
			chart.boxes = [];
		}

		// initialize item with default values
		item.fullWidth = item.fullWidth || false;
		item.position = item.position || 'top';
		item.weight = item.weight || 0;
		item._layers = item._layers || function() {
			return [{
				z: 0,
				draw: function() {
					item.draw.apply(item, arguments);
				}
			}];
		};

		chart.boxes.push(item);
	},

	/**
	 * Remove a layoutItem from a chart
	 * @param {Chart} chart - the chart to remove the box from
	 * @param {ILayoutItem} layoutItem - the item to remove from the layout
	 */
	removeBox: function(chart, layoutItem) {
		var index = chart.boxes ? chart.boxes.indexOf(layoutItem) : -1;
		if (index !== -1) {
			chart.boxes.splice(index, 1);
		}
	},

	/**
	 * Sets (or updates) options on the given `item`.
	 * @param {Chart} chart - the chart in which the item lives (or will be added to)
	 * @param {ILayoutItem} item - the item to configure with the given options
	 * @param {object} options - the new item options.
	 */
	configure: function(chart, item, options) {
		var props = ['fullWidth', 'position', 'weight'];
		var ilen = props.length;
		var i = 0;
		var prop;

		for (; i < ilen; ++i) {
			prop = props[i];
			if (options.hasOwnProperty(prop)) {
				item[prop] = options[prop];
			}
		}
	},

	/**
	 * Fits boxes of the given chart into the given size by having each box measure itself
	 * then running a fitting algorithm
	 * @param {Chart} chart - the chart
	 * @param {number} width - the width to fit into
	 * @param {number} height - the height to fit into
	 */
	update: function(chart, width, height) {
		if (!chart) {
			return;
		}

		var layoutOptions = chart.options.layout || {};
		var padding = helpers$1.options.toPadding(layoutOptions.padding);

		var availableWidth = width - padding.width;
		var availableHeight = height - padding.height;
		var boxes = buildLayoutBoxes(chart.boxes);
		var verticalBoxes = boxes.vertical;
		var horizontalBoxes = boxes.horizontal;

		// Essentially we now have any number of boxes on each of the 4 sides.
		// Our canvas looks like the following.
		// The areas L1 and L2 are the left axes. R1 is the right axis, T1 is the top axis and
		// B1 is the bottom axis
		// There are also 4 quadrant-like locations (left to right instead of clockwise) reserved for chart overlays
		// These locations are single-box locations only, when trying to register a chartArea location that is already taken,
		// an error will be thrown.
		//
		// |----------------------------------------------------|
		// |                  T1 (Full Width)                   |
		// |----------------------------------------------------|
		// |    |    |                 T2                  |    |
		// |    |----|-------------------------------------|----|
		// |    |    | C1 |                           | C2 |    |
		// |    |    |----|                           |----|    |
		// |    |    |                                     |    |
		// | L1 | L2 |           ChartArea (C0)            | R1 |
		// |    |    |                                     |    |
		// |    |    |----|                           |----|    |
		// |    |    | C3 |                           | C4 |    |
		// |    |----|-------------------------------------|----|
		// |    |    |                 B1                  |    |
		// |----------------------------------------------------|
		// |                  B2 (Full Width)                   |
		// |----------------------------------------------------|
		//

		var params = Object.freeze({
			outerWidth: width,
			outerHeight: height,
			padding: padding,
			availableWidth: availableWidth,
			vBoxMaxWidth: availableWidth / 2 / verticalBoxes.length,
			hBoxMaxHeight: availableHeight / 2
		});
		var chartArea = extend({
			maxPadding: extend({}, padding),
			w: availableWidth,
			h: availableHeight,
			x: padding.left,
			y: padding.top
		}, padding);

		setLayoutDims(verticalBoxes.concat(horizontalBoxes), params);

		// First fit vertical boxes
		fitBoxes(verticalBoxes, chartArea, params);

		// Then fit horizontal boxes
		if (fitBoxes(horizontalBoxes, chartArea, params)) {
			// if the area changed, re-fit vertical boxes
			fitBoxes(verticalBoxes, chartArea, params);
		}

		handleMaxPadding(chartArea);

		// Finally place the boxes to correct coordinates
		placeBoxes(boxes.leftAndTop, chartArea, params);

		// Move to opposite side of chart
		chartArea.x += chartArea.w;
		chartArea.y += chartArea.h;

		placeBoxes(boxes.rightAndBottom, chartArea, params);

		chart.chartArea = {
			left: chartArea.left,
			top: chartArea.top,
			right: chartArea.left + chartArea.w,
			bottom: chartArea.top + chartArea.h
		};

		// Finally update boxes in chartArea (radial scale for example)
		helpers$1.each(boxes.chartArea, function(layout) {
			var box = layout.box;
			extend(box, chart.chartArea);
			box.update(chartArea.w, chartArea.h);
		});
	}
};

/**
 * Platform fallback implementation (minimal).
 * @see https://github.com/chartjs/Chart.js/pull/4591#issuecomment-319575939
 */

var platform_basic = {
	acquireContext: function(item) {
		if (item && item.canvas) {
			// Support for any object associated to a canvas (including a context2d)
			item = item.canvas;
		}

		return item && item.getContext('2d') || null;
	}
};

var platform_dom = "/*\r\n * DOM element rendering detection\r\n * https://davidwalsh.name/detect-node-insertion\r\n */\r\n@keyframes chartjs-render-animation {\r\n\tfrom { opacity: 0.99; }\r\n\tto { opacity: 1; }\r\n}\r\n\r\n.chartjs-render-monitor {\r\n\tanimation: chartjs-render-animation 0.001s;\r\n}\r\n\r\n/*\r\n * DOM element resizing detection\r\n * https://github.com/marcj/css-element-queries\r\n */\r\n.chartjs-size-monitor,\r\n.chartjs-size-monitor-expand,\r\n.chartjs-size-monitor-shrink {\r\n\tposition: absolute;\r\n\tdirection: ltr;\r\n\tleft: 0;\r\n\ttop: 0;\r\n\tright: 0;\r\n\tbottom: 0;\r\n\toverflow: hidden;\r\n\tpointer-events: none;\r\n\tvisibility: hidden;\r\n\tz-index: -1;\r\n}\r\n\r\n.chartjs-size-monitor-expand > div {\r\n\tposition: absolute;\r\n\twidth: 1000000px;\r\n\theight: 1000000px;\r\n\tleft: 0;\r\n\ttop: 0;\r\n}\r\n\r\n.chartjs-size-monitor-shrink > div {\r\n\tposition: absolute;\r\n\twidth: 200%;\r\n\theight: 200%;\r\n\tleft: 0;\r\n\ttop: 0;\r\n}\r\n";

var platform_dom$1 = /*#__PURE__*/Object.freeze({
__proto__: null,
'default': platform_dom
});

var stylesheet = getCjsExportFromNamespace(platform_dom$1);

var EXPANDO_KEY = '$chartjs';
var CSS_PREFIX = 'chartjs-';
var CSS_SIZE_MONITOR = CSS_PREFIX + 'size-monitor';
var CSS_RENDER_MONITOR = CSS_PREFIX + 'render-monitor';
var CSS_RENDER_ANIMATION = CSS_PREFIX + 'render-animation';
var ANIMATION_START_EVENTS = ['animationstart', 'webkitAnimationStart'];

/**
 * DOM event types -> Chart.js event types.
 * Note: only events with different types are mapped.
 * @see https://developer.mozilla.org/en-US/docs/Web/Events
 */
var EVENT_TYPES = {
	touchstart: 'mousedown',
	touchmove: 'mousemove',
	touchend: 'mouseup',
	pointerenter: 'mouseenter',
	pointerdown: 'mousedown',
	pointermove: 'mousemove',
	pointerup: 'mouseup',
	pointerleave: 'mouseout',
	pointerout: 'mouseout'
};

/**
 * The "used" size is the final value of a dimension property after all calculations have
 * been performed. This method uses the computed style of `element` but returns undefined
 * if the computed style is not expressed in pixels. That can happen in some cases where
 * `element` has a size relative to its parent and this last one is not yet displayed,
 * for example because of `display: none` on a parent node.
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/used_value
 * @returns {number} Size in pixels or undefined if unknown.
 */
function readUsedSize(element, property) {
	var value = helpers$1.getStyle(element, property);
	var matches = value && value.match(/^(\d+)(\.\d+)?px$/);
	return matches ? Number(matches[1]) : undefined;
}

/**
 * Initializes the canvas style and render size without modifying the canvas display size,
 * since responsiveness is handled by the controller.resize() method. The config is used
 * to determine the aspect ratio to apply in case no explicit height has been specified.
 */
function initCanvas(canvas, config) {
	var style = canvas.style;

	// NOTE(SB) canvas.getAttribute('width') !== canvas.width: in the first case it
	// returns null or '' if no explicit value has been set to the canvas attribute.
	var renderHeight = canvas.getAttribute('height');
	var renderWidth = canvas.getAttribute('width');

	// Chart.js modifies some canvas values that we want to restore on destroy
	canvas[EXPANDO_KEY] = {
		initial: {
			height: renderHeight,
			width: renderWidth,
			style: {
				display: style.display,
				height: style.height,
				width: style.width
			}
		}
	};

	// Force canvas to display as block to avoid extra space caused by inline
	// elements, which would interfere with the responsive resize process.
	// https://github.com/chartjs/Chart.js/issues/2538
	style.display = style.display || 'block';

	if (renderWidth === null || renderWidth === '') {
		var displayWidth = readUsedSize(canvas, 'width');
		if (displayWidth !== undefined) {
			canvas.width = displayWidth;
		}
	}

	if (renderHeight === null || renderHeight === '') {
		if (canvas.style.height === '') {
			// If no explicit render height and style height, let's apply the aspect ratio,
			// which one can be specified by the user but also by charts as default option
			// (i.e. options.aspectRatio). If not specified, use canvas aspect ratio of 2.
			canvas.height = canvas.width / (config.options.aspectRatio || 2);
		} else {
			var displayHeight = readUsedSize(canvas, 'height');
			if (displayWidth !== undefined) {
				canvas.height = displayHeight;
			}
		}
	}

	return canvas;
}

/**
 * Detects support for options object argument in addEventListener.
 * https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Safely_detecting_option_support
 * @private
 */
var supportsEventListenerOptions = (function() {
	var supports = false;
	try {
		var options = Object.defineProperty({}, 'passive', {
			// eslint-disable-next-line getter-return
			get: function() {
				supports = true;
			}
		});
		window.addEventListener('e', null, options);
	} catch (e) {
		// continue regardless of error
	}
	return supports;
}());

// Default passive to true as expected by Chrome for 'touchstart' and 'touchend' events.
// https://github.com/chartjs/Chart.js/issues/4287
var eventListenerOptions = supportsEventListenerOptions ? {passive: true} : false;

function addListener(node, type, listener) {
	node.addEventListener(type, listener, eventListenerOptions);
}

function removeListener(node, type, listener) {
	node.removeEventListener(type, listener, eventListenerOptions);
}

function createEvent(type, chart, x, y, nativeEvent) {
	return {
		type: type,
		chart: chart,
		native: nativeEvent || null,
		x: x !== undefined ? x : null,
		y: y !== undefined ? y : null,
	};
}

function fromNativeEvent(event, chart) {
	var type = EVENT_TYPES[event.type] || event.type;
	var pos = helpers$1.getRelativePosition(event, chart);
	return createEvent(type, chart, pos.x, pos.y, event);
}

function throttled(fn, thisArg) {
	var ticking = false;
	var args = [];

	return function() {
		args = Array.prototype.slice.call(arguments);
		thisArg = thisArg || this;

		if (!ticking) {
			ticking = true;
			helpers$1.requestAnimFrame.call(window, function() {
				ticking = false;
				fn.apply(thisArg, args);
			});
		}
	};
}

function createDiv(cls) {
	var el = document.createElement('div');
	el.className = cls || '';
	return el;
}

// Implementation based on https://github.com/marcj/css-element-queries
function createResizer(handler) {
	var maxSize = 1000000;

	// NOTE(SB) Don't use innerHTML because it could be considered unsafe.
	// https://github.com/chartjs/Chart.js/issues/5902
	var resizer = createDiv(CSS_SIZE_MONITOR);
	var expand = createDiv(CSS_SIZE_MONITOR + '-expand');
	var shrink = createDiv(CSS_SIZE_MONITOR + '-shrink');

	expand.appendChild(createDiv());
	shrink.appendChild(createDiv());

	resizer.appendChild(expand);
	resizer.appendChild(shrink);
	resizer._reset = function() {
		expand.scrollLeft = maxSize;
		expand.scrollTop = maxSize;
		shrink.scrollLeft = maxSize;
		shrink.scrollTop = maxSize;
	};

	var onScroll = function() {
		resizer._reset();
		handler();
	};

	addListener(expand, 'scroll', onScroll.bind(expand, 'expand'));
	addListener(shrink, 'scroll', onScroll.bind(shrink, 'shrink'));

	return resizer;
}

// https://davidwalsh.name/detect-node-insertion
function watchForRender(node, handler) {
	var expando = node[EXPANDO_KEY] || (node[EXPANDO_KEY] = {});
	var proxy = expando.renderProxy = function(e) {
		if (e.animationName === CSS_RENDER_ANIMATION) {
			handler();
		}
	};

	helpers$1.each(ANIMATION_START_EVENTS, function(type) {
		addListener(node, type, proxy);
	});

	// #4737: Chrome might skip the CSS animation when the CSS_RENDER_MONITOR class
	// is removed then added back immediately (same animation frame?). Accessing the
	// `offsetParent` property will force a reflow and re-evaluate the CSS animation.
	// https://gist.github.com/paulirish/5d52fb081b3570c81e3a#box-metrics
	// https://github.com/chartjs/Chart.js/issues/4737
	expando.reflow = !!node.offsetParent;

	node.classList.add(CSS_RENDER_MONITOR);
}

function unwatchForRender(node) {
	var expando = node[EXPANDO_KEY] || {};
	var proxy = expando.renderProxy;

	if (proxy) {
		helpers$1.each(ANIMATION_START_EVENTS, function(type) {
			removeListener(node, type, proxy);
		});

		delete expando.renderProxy;
	}

	node.classList.remove(CSS_RENDER_MONITOR);
}

function addResizeListener(node, listener, chart) {
	var expando = node[EXPANDO_KEY] || (node[EXPANDO_KEY] = {});

	// Let's keep track of this added resizer and thus avoid DOM query when removing it.
	var resizer = expando.resizer = createResizer(throttled(function() {
		if (expando.resizer) {
			var container = chart.options.maintainAspectRatio && node.parentNode;
			var w = container ? container.clientWidth : 0;
			listener(createEvent('resize', chart));
			if (container && container.clientWidth < w && chart.canvas) {
				// If the container size shrank during chart resize, let's assume
				// scrollbar appeared. So we resize again with the scrollbar visible -
				// effectively making chart smaller and the scrollbar hidden again.
				// Because we are inside `throttled`, and currently `ticking`, scroll
				// events are ignored during this whole 2 resize process.
				// If we assumed wrong and something else happened, we are resizing
				// twice in a frame (potential performance issue)
				listener(createEvent('resize', chart));
			}
		}
	}));

	// The resizer needs to be attached to the node parent, so we first need to be
	// sure that `node` is attached to the DOM before injecting the resizer element.
	watchForRender(node, function() {
		if (expando.resizer) {
			var container = node.parentNode;
			if (container && container !== resizer.parentNode) {
				container.insertBefore(resizer, container.firstChild);
			}

			// The container size might have changed, let's reset the resizer state.
			resizer._reset();
		}
	});
}

function removeResizeListener(node) {
	var expando = node[EXPANDO_KEY] || {};
	var resizer = expando.resizer;

	delete expando.resizer;
	unwatchForRender(node);

	if (resizer && resizer.parentNode) {
		resizer.parentNode.removeChild(resizer);
	}
}

/**
 * Injects CSS styles inline if the styles are not already present.
 * @param {HTMLDocument|ShadowRoot} rootNode - the node to contain the <style>.
 * @param {string} css - the CSS to be injected.
 */
function injectCSS(rootNode, css) {
	// https://stackoverflow.com/q/3922139
	var expando = rootNode[EXPANDO_KEY] || (rootNode[EXPANDO_KEY] = {});
	if (!expando.containsStyles) {
		expando.containsStyles = true;
		css = '/* Chart.js */\n' + css;
		var style = document.createElement('style');
		style.setAttribute('type', 'text/css');
		style.appendChild(document.createTextNode(css));
		rootNode.appendChild(style);
	}
}

var platform_dom$2 = {
	/**
	 * When `true`, prevents the automatic injection of the stylesheet required to
	 * correctly detect when the chart is added to the DOM and then resized. This
	 * switch has been added to allow external stylesheet (`dist/Chart(.min)?.js`)
	 * to be manually imported to make this library compatible with any CSP.
	 * See https://github.com/chartjs/Chart.js/issues/5208
	 */
	disableCSSInjection: false,

	/**
	 * This property holds whether this platform is enabled for the current environment.
	 * Currently used by platform.js to select the proper implementation.
	 * @private
	 */
	_enabled: typeof window !== 'undefined' && typeof document !== 'undefined',

	/**
	 * Initializes resources that depend on platform options.
	 * @param {HTMLCanvasElement} canvas - The Canvas element.
	 * @private
	 */
	_ensureLoaded: function(canvas) {
		if (!this.disableCSSInjection) {
			// If the canvas is in a shadow DOM, then the styles must also be inserted
			// into the same shadow DOM.
			// https://github.com/chartjs/Chart.js/issues/5763
			var root = canvas.getRootNode ? canvas.getRootNode() : document;
			var targetNode = root.host ? root : document.head;
			injectCSS(targetNode, stylesheet);
		}
	},

	acquireContext: function(item, config) {
		if (typeof item === 'string') {
			item = document.getElementById(item);
		} else if (item.length) {
			// Support for array based queries (such as jQuery)
			item = item[0];
		}

		if (item && item.canvas) {
			// Support for any object associated to a canvas (including a context2d)
			item = item.canvas;
		}

		// To prevent canvas fingerprinting, some add-ons undefine the getContext
		// method, for example: https://github.com/kkapsner/CanvasBlocker
		// https://github.com/chartjs/Chart.js/issues/2807
		var context = item && item.getContext && item.getContext('2d');

		// `instanceof HTMLCanvasElement/CanvasRenderingContext2D` fails when the item is
		// inside an iframe or when running in a protected environment. We could guess the
		// types from their toString() value but let's keep things flexible and assume it's
		// a sufficient condition if the item has a context2D which has item as `canvas`.
		// https://github.com/chartjs/Chart.js/issues/3887
		// https://github.com/chartjs/Chart.js/issues/4102
		// https://github.com/chartjs/Chart.js/issues/4152
		if (context && context.canvas === item) {
			// Load platform resources on first chart creation, to make it possible to
			// import the library before setting platform options.
			this._ensureLoaded(item);
			initCanvas(item, config);
			return context;
		}

		return null;
	},

	releaseContext: function(context) {
		var canvas = context.canvas;
		if (!canvas[EXPANDO_KEY]) {
			return;
		}

		var initial = canvas[EXPANDO_KEY].initial;
		['height', 'width'].forEach(function(prop) {
			var value = initial[prop];
			if (helpers$1.isNullOrUndef(value)) {
				canvas.removeAttribute(prop);
			} else {
				canvas.setAttribute(prop, value);
			}
		});

		helpers$1.each(initial.style || {}, function(value, key) {
			canvas.style[key] = value;
		});

		// The canvas render size might have been changed (and thus the state stack discarded),
		// we can't use save() and restore() to restore the initial state. So make sure that at
		// least the canvas context is reset to the default state by setting the canvas width.
		// https://www.w3.org/TR/2011/WD-html5-20110525/the-canvas-element.html
		// eslint-disable-next-line no-self-assign
		canvas.width = canvas.width;

		delete canvas[EXPANDO_KEY];
	},

	addEventListener: function(chart, type, listener) {
		var canvas = chart.canvas;
		if (type === 'resize') {
			// Note: the resize event is not supported on all browsers.
			addResizeListener(canvas, listener, chart);
			return;
		}

		var expando = listener[EXPANDO_KEY] || (listener[EXPANDO_KEY] = {});
		var proxies = expando.proxies || (expando.proxies = {});
		var proxy = proxies[chart.id + '_' + type] = function(event) {
			listener(fromNativeEvent(event, chart));
		};

		addListener(canvas, type, proxy);
	},

	removeEventListener: function(chart, type, listener) {
		var canvas = chart.canvas;
		if (type === 'resize') {
			// Note: the resize event is not supported on all browsers.
			removeResizeListener(canvas);
			return;
		}

		var expando = listener[EXPANDO_KEY] || {};
		var proxies = expando.proxies || {};
		var proxy = proxies[chart.id + '_' + type];
		if (!proxy) {
			return;
		}

		removeListener(canvas, type, proxy);
	}
};

// DEPRECATIONS

/**
 * Provided for backward compatibility, use EventTarget.addEventListener instead.
 * EventTarget.addEventListener compatibility: Chrome, Opera 7, Safari, FF1.5+, IE9+
 * @see https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener
 * @function Chart.helpers.addEvent
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers$1.addEvent = addListener;

/**
 * Provided for backward compatibility, use EventTarget.removeEventListener instead.
 * EventTarget.removeEventListener compatibility: Chrome, Opera 7, Safari, FF1.5+, IE9+
 * @see https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/removeEventListener
 * @function Chart.helpers.removeEvent
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers$1.removeEvent = removeListener;

// @TODO Make possible to select another platform at build time.
var implementation = platform_dom$2._enabled ? platform_dom$2 : platform_basic;

/**
 * @namespace Chart.platform
 * @see https://chartjs.gitbooks.io/proposals/content/Platform.html
 * @since 2.4.0
 */
var platform = helpers$1.extend({
	/**
	 * @since 2.7.0
	 */
	initialize: function() {},

	/**
	 * Called at chart construction time, returns a context2d instance implementing
	 * the [W3C Canvas 2D Context API standard]{@link https://www.w3.org/TR/2dcontext/}.
	 * @param {*} item - The native item from which to acquire context (platform specific)
	 * @param {object} options - The chart options
	 * @returns {CanvasRenderingContext2D} context2d instance
	 */
	acquireContext: function() {},

	/**
	 * Called at chart destruction time, releases any resources associated to the context
	 * previously returned by the acquireContext() method.
	 * @param {CanvasRenderingContext2D} context - The context2d instance
	 * @returns {boolean} true if the method succeeded, else false
	 */
	releaseContext: function() {},

	/**
	 * Registers the specified listener on the given chart.
	 * @param {Chart} chart - Chart from which to listen for event
	 * @param {string} type - The ({@link IEvent}) type to listen for
	 * @param {function} listener - Receives a notification (an object that implements
	 * the {@link IEvent} interface) when an event of the specified type occurs.
	 */
	addEventListener: function() {},

	/**
	 * Removes the specified listener previously registered with addEventListener.
	 * @param {Chart} chart - Chart from which to remove the listener
	 * @param {string} type - The ({@link IEvent}) type to remove
	 * @param {function} listener - The listener function to remove from the event target.
	 */
	removeEventListener: function() {}

}, implementation);

core_defaults._set('global', {
	plugins: {}
});

/**
 * The plugin service singleton
 * @namespace Chart.plugins
 * @since 2.1.0
 */
var core_plugins = {
	/**
	 * Globally registered plugins.
	 * @private
	 */
	_plugins: [],

	/**
	 * This identifier is used to invalidate the descriptors cache attached to each chart
	 * when a global plugin is registered or unregistered. In this case, the cache ID is
	 * incremented and descriptors are regenerated during following API calls.
	 * @private
	 */
	_cacheId: 0,

	/**
	 * Registers the given plugin(s) if not already registered.
	 * @param {IPlugin[]|IPlugin} plugins plugin instance(s).
	 */
	register: function(plugins) {
		var p = this._plugins;
		([]).concat(plugins).forEach(function(plugin) {
			if (p.indexOf(plugin) === -1) {
				p.push(plugin);
			}
		});

		this._cacheId++;
	},

	/**
	 * Unregisters the given plugin(s) only if registered.
	 * @param {IPlugin[]|IPlugin} plugins plugin instance(s).
	 */
	unregister: function(plugins) {
		var p = this._plugins;
		([]).concat(plugins).forEach(function(plugin) {
			var idx = p.indexOf(plugin);
			if (idx !== -1) {
				p.splice(idx, 1);
			}
		});

		this._cacheId++;
	},

	/**
	 * Remove all registered plugins.
	 * @since 2.1.5
	 */
	clear: function() {
		this._plugins = [];
		this._cacheId++;
	},

	/**
	 * Returns the number of registered plugins?
	 * @returns {number}
	 * @since 2.1.5
	 */
	count: function() {
		return this._plugins.length;
	},

	/**
	 * Returns all registered plugin instances.
	 * @returns {IPlugin[]} array of plugin objects.
	 * @since 2.1.5
	 */
	getAll: function() {
		return this._plugins;
	},

	/**
	 * Calls enabled plugins for `chart` on the specified hook and with the given args.
	 * This method immediately returns as soon as a plugin explicitly returns false. The
	 * returned value can be used, for instance, to interrupt the current action.
	 * @param {Chart} chart - The chart instance for which plugins should be called.
	 * @param {string} hook - The name of the plugin method to call (e.g. 'beforeUpdate').
	 * @param {Array} [args] - Extra arguments to apply to the hook call.
	 * @returns {boolean} false if any of the plugins return false, else returns true.
	 */
	notify: function(chart, hook, args) {
		var descriptors = this.descriptors(chart);
		var ilen = descriptors.length;
		var i, descriptor, plugin, params, method;

		for (i = 0; i < ilen; ++i) {
			descriptor = descriptors[i];
			plugin = descriptor.plugin;
			method = plugin[hook];
			if (typeof method === 'function') {
				params = [chart].concat(args || []);
				params.push(descriptor.options);
				if (method.apply(plugin, params) === false) {
					return false;
				}
			}
		}

		return true;
	},

	/**
	 * Returns descriptors of enabled plugins for the given chart.
	 * @returns {object[]} [{ plugin, options }]
	 * @private
	 */
	descriptors: function(chart) {
		var cache = chart.$plugins || (chart.$plugins = {});
		if (cache.id === this._cacheId) {
			return cache.descriptors;
		}

		var plugins = [];
		var descriptors = [];
		var config = (chart && chart.config) || {};
		var options = (config.options && config.options.plugins) || {};

		this._plugins.concat(config.plugins || []).forEach(function(plugin) {
			var idx = plugins.indexOf(plugin);
			if (idx !== -1) {
				return;
			}

			var id = plugin.id;
			var opts = options[id];
			if (opts === false) {
				return;
			}

			if (opts === true) {
				opts = helpers$1.clone(core_defaults.global.plugins[id]);
			}

			plugins.push(plugin);
			descriptors.push({
				plugin: plugin,
				options: opts || {}
			});
		});

		cache.descriptors = descriptors;
		cache.id = this._cacheId;
		return descriptors;
	},

	/**
	 * Invalidates cache for the given chart: descriptors hold a reference on plugin option,
	 * but in some cases, this reference can be changed by the user when updating options.
	 * https://github.com/chartjs/Chart.js/issues/5111#issuecomment-355934167
	 * @private
	 */
	_invalidate: function(chart) {
		delete chart.$plugins;
	}
};

var core_scaleService = {
	// Scale registration object. Extensions can register new scale types (such as log or DB scales) and then
	// use the new chart options to grab the correct scale
	constructors: {},
	// Use a registration function so that we can move to an ES6 map when we no longer need to support
	// old browsers

	// Scale config defaults
	defaults: {},
	registerScaleType: function(type, scaleConstructor, scaleDefaults) {
		this.constructors[type] = scaleConstructor;
		this.defaults[type] = helpers$1.clone(scaleDefaults);
	},
	getScaleConstructor: function(type) {
		return this.constructors.hasOwnProperty(type) ? this.constructors[type] : undefined;
	},
	getScaleDefaults: function(type) {
		// Return the scale defaults merged with the global settings so that we always use the latest ones
		return this.defaults.hasOwnProperty(type) ? helpers$1.merge(Object.create(null), [core_defaults.scale, this.defaults[type]]) : {};
	},
	updateScaleDefaults: function(type, additions) {
		var me = this;
		if (me.defaults.hasOwnProperty(type)) {
			me.defaults[type] = helpers$1.extend(me.defaults[type], additions);
		}
	},
	addScalesToLayout: function(chart) {
		// Adds each scale to the chart.boxes array to be sized accordingly
		helpers$1.each(chart.scales, function(scale) {
			// Set ILayoutItem parameters for backwards compatibility
			scale.fullWidth = scale.options.fullWidth;
			scale.position = scale.options.position;
			scale.weight = scale.options.weight;
			core_layouts.addBox(chart, scale);
		});
	}
};

var valueOrDefault$8 = helpers$1.valueOrDefault;
var getRtlHelper = helpers$1.rtl.getRtlAdapter;

core_defaults._set('global', {
	tooltips: {
		enabled: true,
		custom: null,
		mode: 'nearest',
		position: 'average',
		intersect: true,
		backgroundColor: 'rgba(0,0,0,0.8)',
		titleFontStyle: 'bold',
		titleSpacing: 2,
		titleMarginBottom: 6,
		titleFontColor: '#fff',
		titleAlign: 'left',
		bodySpacing: 2,
		bodyFontColor: '#fff',
		bodyAlign: 'left',
		footerFontStyle: 'bold',
		footerSpacing: 2,
		footerMarginTop: 6,
		footerFontColor: '#fff',
		footerAlign: 'left',
		yPadding: 6,
		xPadding: 6,
		caretPadding: 2,
		caretSize: 5,
		cornerRadius: 6,
		multiKeyBackground: '#fff',
		displayColors: true,
		borderColor: 'rgba(0,0,0,0)',
		borderWidth: 0,
		callbacks: {
			// Args are: (tooltipItems, data)
			beforeTitle: helpers$1.noop,
			title: function(tooltipItems, data) {
				var title = '';
				var labels = data.labels;
				var labelCount = labels ? labels.length : 0;

				if (tooltipItems.length > 0) {
					var item = tooltipItems[0];
					if (item.label) {
						title = item.label;
					} else if (item.xLabel) {
						title = item.xLabel;
					} else if (labelCount > 0 && item.index < labelCount) {
						title = labels[item.index];
					}
				}

				return title;
			},
			afterTitle: helpers$1.noop,

			// Args are: (tooltipItems, data)
			beforeBody: helpers$1.noop,

			// Args are: (tooltipItem, data)
			beforeLabel: helpers$1.noop,
			label: function(tooltipItem, data) {
				var label = data.datasets[tooltipItem.datasetIndex].label || '';

				if (label) {
					label += ': ';
				}
				if (!helpers$1.isNullOrUndef(tooltipItem.value)) {
					label += tooltipItem.value;
				} else {
					label += tooltipItem.yLabel;
				}
				return label;
			},
			labelColor: function(tooltipItem, chart) {
				var meta = chart.getDatasetMeta(tooltipItem.datasetIndex);
				var activeElement = meta.data[tooltipItem.index];
				var view = activeElement._view;
				return {
					borderColor: view.borderColor,
					backgroundColor: view.backgroundColor
				};
			},
			labelTextColor: function() {
				return this._options.bodyFontColor;
			},
			afterLabel: helpers$1.noop,

			// Args are: (tooltipItems, data)
			afterBody: helpers$1.noop,

			// Args are: (tooltipItems, data)
			beforeFooter: helpers$1.noop,
			footer: helpers$1.noop,
			afterFooter: helpers$1.noop
		}
	}
});

var positioners = {
	/**
	 * Average mode places the tooltip at the average position of the elements shown
	 * @function Chart.Tooltip.positioners.average
	 * @param elements {ChartElement[]} the elements being displayed in the tooltip
	 * @returns {object} tooltip position
	 */
	average: function(elements) {
		if (!elements.length) {
			return false;
		}

		var i, len;
		var x = 0;
		var y = 0;
		var count = 0;

		for (i = 0, len = elements.length; i < len; ++i) {
			var el = elements[i];
			if (el && el.hasValue()) {
				var pos = el.tooltipPosition();
				x += pos.x;
				y += pos.y;
				++count;
			}
		}

		return {
			x: x / count,
			y: y / count
		};
	},

	/**
	 * Gets the tooltip position nearest of the item nearest to the event position
	 * @function Chart.Tooltip.positioners.nearest
	 * @param elements {Chart.Element[]} the tooltip elements
	 * @param eventPosition {object} the position of the event in canvas coordinates
	 * @returns {object} the tooltip position
	 */
	nearest: function(elements, eventPosition) {
		var x = eventPosition.x;
		var y = eventPosition.y;
		var minDistance = Number.POSITIVE_INFINITY;
		var i, len, nearestElement;

		for (i = 0, len = elements.length; i < len; ++i) {
			var el = elements[i];
			if (el && el.hasValue()) {
				var center = el.getCenterPoint();
				var d = helpers$1.distanceBetweenPoints(eventPosition, center);

				if (d < minDistance) {
					minDistance = d;
					nearestElement = el;
				}
			}
		}

		if (nearestElement) {
			var tp = nearestElement.tooltipPosition();
			x = tp.x;
			y = tp.y;
		}

		return {
			x: x,
			y: y
		};
	}
};

// Helper to push or concat based on if the 2nd parameter is an array or not
function pushOrConcat(base, toPush) {
	if (toPush) {
		if (helpers$1.isArray(toPush)) {
			// base = base.concat(toPush);
			Array.prototype.push.apply(base, toPush);
		} else {
			base.push(toPush);
		}
	}

	return base;
}

/**
 * Returns array of strings split by newline
 * @param {string} value - The value to split by newline.
 * @returns {string[]} value if newline present - Returned from String split() method
 * @function
 */
function splitNewlines(str) {
	if ((typeof str === 'string' || str instanceof String) && str.indexOf('\n') > -1) {
		return str.split('\n');
	}
	return str;
}


/**
 * Private helper to create a tooltip item model
 * @param element - the chart element (point, arc, bar) to create the tooltip item for
 * @return new tooltip item
 */
function createTooltipItem(element) {
	var xScale = element._xScale;
	var yScale = element._yScale || element._scale; // handle radar || polarArea charts
	var index = element._index;
	var datasetIndex = element._datasetIndex;
	var controller = element._chart.getDatasetMeta(datasetIndex).controller;
	var indexScale = controller._getIndexScale();
	var valueScale = controller._getValueScale();

	return {
		xLabel: xScale ? xScale.getLabelForIndex(index, datasetIndex) : '',
		yLabel: yScale ? yScale.getLabelForIndex(index, datasetIndex) : '',
		label: indexScale ? '' + indexScale.getLabelForIndex(index, datasetIndex) : '',
		value: valueScale ? '' + valueScale.getLabelForIndex(index, datasetIndex) : '',
		index: index,
		datasetIndex: datasetIndex,
		x: element._model.x,
		y: element._model.y
	};
}

/**
 * Helper to get the reset model for the tooltip
 * @param tooltipOpts {object} the tooltip options
 */
function getBaseModel(tooltipOpts) {
	var globalDefaults = core_defaults.global;

	return {
		// Positioning
		xPadding: tooltipOpts.xPadding,
		yPadding: tooltipOpts.yPadding,
		xAlign: tooltipOpts.xAlign,
		yAlign: tooltipOpts.yAlign,

		// Drawing direction and text direction
		rtl: tooltipOpts.rtl,
		textDirection: tooltipOpts.textDirection,

		// Body
		bodyFontColor: tooltipOpts.bodyFontColor,
		_bodyFontFamily: valueOrDefault$8(tooltipOpts.bodyFontFamily, globalDefaults.defaultFontFamily),
		_bodyFontStyle: valueOrDefault$8(tooltipOpts.bodyFontStyle, globalDefaults.defaultFontStyle),
		_bodyAlign: tooltipOpts.bodyAlign,
		bodyFontSize: valueOrDefault$8(tooltipOpts.bodyFontSize, globalDefaults.defaultFontSize),
		bodySpacing: tooltipOpts.bodySpacing,

		// Title
		titleFontColor: tooltipOpts.titleFontColor,
		_titleFontFamily: valueOrDefault$8(tooltipOpts.titleFontFamily, globalDefaults.defaultFontFamily),
		_titleFontStyle: valueOrDefault$8(tooltipOpts.titleFontStyle, globalDefaults.defaultFontStyle),
		titleFontSize: valueOrDefault$8(tooltipOpts.titleFontSize, globalDefaults.defaultFontSize),
		_titleAlign: tooltipOpts.titleAlign,
		titleSpacing: tooltipOpts.titleSpacing,
		titleMarginBottom: tooltipOpts.titleMarginBottom,

		// Footer
		footerFontColor: tooltipOpts.footerFontColor,
		_footerFontFamily: valueOrDefault$8(tooltipOpts.footerFontFamily, globalDefaults.defaultFontFamily),
		_footerFontStyle: valueOrDefault$8(tooltipOpts.footerFontStyle, globalDefaults.defaultFontStyle),
		footerFontSize: valueOrDefault$8(tooltipOpts.footerFontSize, globalDefaults.defaultFontSize),
		_footerAlign: tooltipOpts.footerAlign,
		footerSpacing: tooltipOpts.footerSpacing,
		footerMarginTop: tooltipOpts.footerMarginTop,

		// Appearance
		caretSize: tooltipOpts.caretSize,
		cornerRadius: tooltipOpts.cornerRadius,
		backgroundColor: tooltipOpts.backgroundColor,
		opacity: 0,
		legendColorBackground: tooltipOpts.multiKeyBackground,
		displayColors: tooltipOpts.displayColors,
		borderColor: tooltipOpts.borderColor,
		borderWidth: tooltipOpts.borderWidth
	};
}

/**
 * Get the size of the tooltip
 */
function getTooltipSize(tooltip, model) {
	var ctx = tooltip._chart.ctx;

	var height = model.yPadding * 2; // Tooltip Padding
	var width = 0;

	// Count of all lines in the body
	var body = model.body;
	var combinedBodyLength = body.reduce(function(count, bodyItem) {
		return count + bodyItem.before.length + bodyItem.lines.length + bodyItem.after.length;
	}, 0);
	combinedBodyLength += model.beforeBody.length + model.afterBody.length;

	var titleLineCount = model.title.length;
	var footerLineCount = model.footer.length;
	var titleFontSize = model.titleFontSize;
	var bodyFontSize = model.bodyFontSize;
	var footerFontSize = model.footerFontSize;

	height += titleLineCount * titleFontSize; // Title Lines
	height += titleLineCount ? (titleLineCount - 1) * model.titleSpacing : 0; // Title Line Spacing
	height += titleLineCount ? model.titleMarginBottom : 0; // Title's bottom Margin
	height += combinedBodyLength * bodyFontSize; // Body Lines
	height += combinedBodyLength ? (combinedBodyLength - 1) * model.bodySpacing : 0; // Body Line Spacing
	height += footerLineCount ? model.footerMarginTop : 0; // Footer Margin
	height += footerLineCount * (footerFontSize); // Footer Lines
	height += footerLineCount ? (footerLineCount - 1) * model.footerSpacing : 0; // Footer Line Spacing

	// Title width
	var widthPadding = 0;
	var maxLineWidth = function(line) {
		width = Math.max(width, ctx.measureText(line).width + widthPadding);
	};

	ctx.font = helpers$1.fontString(titleFontSize, model._titleFontStyle, model._titleFontFamily);
	helpers$1.each(model.title, maxLineWidth);

	// Body width
	ctx.font = helpers$1.fontString(bodyFontSize, model._bodyFontStyle, model._bodyFontFamily);
	helpers$1.each(model.beforeBody.concat(model.afterBody), maxLineWidth);

	// Body lines may include some extra width due to the color box
	widthPadding = model.displayColors ? (bodyFontSize + 2) : 0;
	helpers$1.each(body, function(bodyItem) {
		helpers$1.each(bodyItem.before, maxLineWidth);
		helpers$1.each(bodyItem.lines, maxLineWidth);
		helpers$1.each(bodyItem.after, maxLineWidth);
	});

	// Reset back to 0
	widthPadding = 0;

	// Footer width
	ctx.font = helpers$1.fontString(footerFontSize, model._footerFontStyle, model._footerFontFamily);
	helpers$1.each(model.footer, maxLineWidth);

	// Add padding
	width += 2 * model.xPadding;

	return {
		width: width,
		height: height
	};
}

/**
 * Helper to get the alignment of a tooltip given the size
 */
function determineAlignment(tooltip, size) {
	var model = tooltip._model;
	var chart = tooltip._chart;
	var chartArea = tooltip._chart.chartArea;
	var xAlign = 'center';
	var yAlign = 'center';

	if (model.y < size.height) {
		yAlign = 'top';
	} else if (model.y > (chart.height - size.height)) {
		yAlign = 'bottom';
	}

	var lf, rf; // functions to determine left, right alignment
	var olf, orf; // functions to determine if left/right alignment causes tooltip to go outside chart
	var yf; // function to get the y alignment if the tooltip goes outside of the left or right edges
	var midX = (chartArea.left + chartArea.right) / 2;
	var midY = (chartArea.top + chartArea.bottom) / 2;

	if (yAlign === 'center') {
		lf = function(x) {
			return x <= midX;
		};
		rf = function(x) {
			return x > midX;
		};
	} else {
		lf = function(x) {
			return x <= (size.width / 2);
		};
		rf = function(x) {
			return x >= (chart.width - (size.width / 2));
		};
	}

	olf = function(x) {
		return x + size.width + model.caretSize + model.caretPadding > chart.width;
	};
	orf = function(x) {
		return x - size.width - model.caretSize - model.caretPadding < 0;
	};
	yf = function(y) {
		return y <= midY ? 'top' : 'bottom';
	};

	if (lf(model.x)) {
		xAlign = 'left';

		// Is tooltip too wide and goes over the right side of the chart.?
		if (olf(model.x)) {
			xAlign = 'center';
			yAlign = yf(model.y);
		}
	} else if (rf(model.x)) {
		xAlign = 'right';

		// Is tooltip too wide and goes outside left edge of canvas?
		if (orf(model.x)) {
			xAlign = 'center';
			yAlign = yf(model.y);
		}
	}

	var opts = tooltip._options;
	return {
		xAlign: opts.xAlign ? opts.xAlign : xAlign,
		yAlign: opts.yAlign ? opts.yAlign : yAlign
	};
}

/**
 * Helper to get the location a tooltip needs to be placed at given the initial position (via the vm) and the size and alignment
 */
function getBackgroundPoint(vm, size, alignment, chart) {
	// Background Position
	var x = vm.x;
	var y = vm.y;

	var caretSize = vm.caretSize;
	var caretPadding = vm.caretPadding;
	var cornerRadius = vm.cornerRadius;
	var xAlign = alignment.xAlign;
	var yAlign = alignment.yAlign;
	var paddingAndSize = caretSize + caretPadding;
	var radiusAndPadding = cornerRadius + caretPadding;

	if (xAlign === 'right') {
		x -= size.width;
	} else if (xAlign === 'center') {
		x -= (size.width / 2);
		if (x + size.width > chart.width) {
			x = chart.width - size.width;
		}
		if (x < 0) {
			x = 0;
		}
	}

	if (yAlign === 'top') {
		y += paddingAndSize;
	} else if (yAlign === 'bottom') {
		y -= size.height + paddingAndSize;
	} else {
		y -= (size.height / 2);
	}

	if (yAlign === 'center') {
		if (xAlign === 'left') {
			x += paddingAndSize;
		} else if (xAlign === 'right') {
			x -= paddingAndSize;
		}
	} else if (xAlign === 'left') {
		x -= radiusAndPadding;
	} else if (xAlign === 'right') {
		x += radiusAndPadding;
	}

	return {
		x: x,
		y: y
	};
}

function getAlignedX(vm, align) {
	return align === 'center'
		? vm.x + vm.width / 2
		: align === 'right'
			? vm.x + vm.width - vm.xPadding
			: vm.x + vm.xPadding;
}

/**
 * Helper to build before and after body lines
 */
function getBeforeAfterBodyLines(callback) {
	return pushOrConcat([], splitNewlines(callback));
}

var exports$4 = core_element.extend({
	initialize: function() {
		this._model = getBaseModel(this._options);
		this._lastActive = [];
	},

	// Get the title
	// Args are: (tooltipItem, data)
	getTitle: function() {
		var me = this;
		var opts = me._options;
		var callbacks = opts.callbacks;

		var beforeTitle = callbacks.beforeTitle.apply(me, arguments);
		var title = callbacks.title.apply(me, arguments);
		var afterTitle = callbacks.afterTitle.apply(me, arguments);

		var lines = [];
		lines = pushOrConcat(lines, splitNewlines(beforeTitle));
		lines = pushOrConcat(lines, splitNewlines(title));
		lines = pushOrConcat(lines, splitNewlines(afterTitle));

		return lines;
	},

	// Args are: (tooltipItem, data)
	getBeforeBody: function() {
		return getBeforeAfterBodyLines(this._options.callbacks.beforeBody.apply(this, arguments));
	},

	// Args are: (tooltipItem, data)
	getBody: function(tooltipItems, data) {
		var me = this;
		var callbacks = me._options.callbacks;
		var bodyItems = [];

		helpers$1.each(tooltipItems, function(tooltipItem) {
			var bodyItem = {
				before: [],
				lines: [],
				after: []
			};
			pushOrConcat(bodyItem.before, splitNewlines(callbacks.beforeLabel.call(me, tooltipItem, data)));
			pushOrConcat(bodyItem.lines, callbacks.label.call(me, tooltipItem, data));
			pushOrConcat(bodyItem.after, splitNewlines(callbacks.afterLabel.call(me, tooltipItem, data)));

			bodyItems.push(bodyItem);
		});

		return bodyItems;
	},

	// Args are: (tooltipItem, data)
	getAfterBody: function() {
		return getBeforeAfterBodyLines(this._options.callbacks.afterBody.apply(this, arguments));
	},

	// Get the footer and beforeFooter and afterFooter lines
	// Args are: (tooltipItem, data)
	getFooter: function() {
		var me = this;
		var callbacks = me._options.callbacks;

		var beforeFooter = callbacks.beforeFooter.apply(me, arguments);
		var footer = callbacks.footer.apply(me, arguments);
		var afterFooter = callbacks.afterFooter.apply(me, arguments);

		var lines = [];
		lines = pushOrConcat(lines, splitNewlines(beforeFooter));
		lines = pushOrConcat(lines, splitNewlines(footer));
		lines = pushOrConcat(lines, splitNewlines(afterFooter));

		return lines;
	},

	update: function(changed) {
		var me = this;
		var opts = me._options;

		// Need to regenerate the model because its faster than using extend and it is necessary due to the optimization in Chart.Element.transition
		// that does _view = _model if ease === 1. This causes the 2nd tooltip update to set properties in both the view and model at the same time
		// which breaks any animations.
		var existingModel = me._model;
		var model = me._model = getBaseModel(opts);
		var active = me._active;

		var data = me._data;

		// In the case where active.length === 0 we need to keep these at existing values for good animations
		var alignment = {
			xAlign: existingModel.xAlign,
			yAlign: existingModel.yAlign
		};
		var backgroundPoint = {
			x: existingModel.x,
			y: existingModel.y
		};
		var tooltipSize = {
			width: existingModel.width,
			height: existingModel.height
		};
		var tooltipPosition = {
			x: existingModel.caretX,
			y: existingModel.caretY
		};

		var i, len;

		if (active.length) {
			model.opacity = 1;

			var labelColors = [];
			var labelTextColors = [];
			tooltipPosition = positioners[opts.position].call(me, active, me._eventPosition);

			var tooltipItems = [];
			for (i = 0, len = active.length; i < len; ++i) {
				tooltipItems.push(createTooltipItem(active[i]));
			}

			// If the user provided a filter function, use it to modify the tooltip items
			if (opts.filter) {
				tooltipItems = tooltipItems.filter(function(a) {
					return opts.filter(a, data);
				});
			}

			// If the user provided a sorting function, use it to modify the tooltip items
			if (opts.itemSort) {
				tooltipItems = tooltipItems.sort(function(a, b) {
					return opts.itemSort(a, b, data);
				});
			}

			// Determine colors for boxes
			helpers$1.each(tooltipItems, function(tooltipItem) {
				labelColors.push(opts.callbacks.labelColor.call(me, tooltipItem, me._chart));
				labelTextColors.push(opts.callbacks.labelTextColor.call(me, tooltipItem, me._chart));
			});


			// Build the Text Lines
			model.title = me.getTitle(tooltipItems, data);
			model.beforeBody = me.getBeforeBody(tooltipItems, data);
			model.body = me.getBody(tooltipItems, data);
			model.afterBody = me.getAfterBody(tooltipItems, data);
			model.footer = me.getFooter(tooltipItems, data);

			// Initial positioning and colors
			model.x = tooltipPosition.x;
			model.y = tooltipPosition.y;
			model.caretPadding = opts.caretPadding;
			model.labelColors = labelColors;
			model.labelTextColors = labelTextColors;

			// data points
			model.dataPoints = tooltipItems;

			// We need to determine alignment of the tooltip
			tooltipSize = getTooltipSize(this, model);
			alignment = determineAlignment(this, tooltipSize);
			// Final Size and Position
			backgroundPoint = getBackgroundPoint(model, tooltipSize, alignment, me._chart);
		} else {
			model.opacity = 0;
		}

		model.xAlign = alignment.xAlign;
		model.yAlign = alignment.yAlign;
		model.x = backgroundPoint.x;
		model.y = backgroundPoint.y;
		model.width = tooltipSize.width;
		model.height = tooltipSize.height;

		// Point where the caret on the tooltip points to
		model.caretX = tooltipPosition.x;
		model.caretY = tooltipPosition.y;

		me._model = model;

		if (changed && opts.custom) {
			opts.custom.call(me, model);
		}

		return me;
	},

	drawCaret: function(tooltipPoint, size) {
		var ctx = this._chart.ctx;
		var vm = this._view;
		var caretPosition = this.getCaretPosition(tooltipPoint, size, vm);

		ctx.lineTo(caretPosition.x1, caretPosition.y1);
		ctx.lineTo(caretPosition.x2, caretPosition.y2);
		ctx.lineTo(caretPosition.x3, caretPosition.y3);
	},
	getCaretPosition: function(tooltipPoint, size, vm) {
		var x1, x2, x3, y1, y2, y3;
		var caretSize = vm.caretSize;
		var cornerRadius = vm.cornerRadius;
		var xAlign = vm.xAlign;
		var yAlign = vm.yAlign;
		var ptX = tooltipPoint.x;
		var ptY = tooltipPoint.y;
		var width = size.width;
		var height = size.height;

		if (yAlign === 'center') {
			y2 = ptY + (height / 2);

			if (xAlign === 'left') {
				x1 = ptX;
				x2 = x1 - caretSize;
				x3 = x1;

				y1 = y2 + caretSize;
				y3 = y2 - caretSize;
			} else {
				x1 = ptX + width;
				x2 = x1 + caretSize;
				x3 = x1;

				y1 = y2 - caretSize;
				y3 = y2 + caretSize;
			}
		} else {
			if (xAlign === 'left') {
				x2 = ptX + cornerRadius + (caretSize);
				x1 = x2 - caretSize;
				x3 = x2 + caretSize;
			} else if (xAlign === 'right') {
				x2 = ptX + width - cornerRadius - caretSize;
				x1 = x2 - caretSize;
				x3 = x2 + caretSize;
			} else {
				x2 = vm.caretX;
				x1 = x2 - caretSize;
				x3 = x2 + caretSize;
			}
			if (yAlign === 'top') {
				y1 = ptY;
				y2 = y1 - caretSize;
				y3 = y1;
			} else {
				y1 = ptY + height;
				y2 = y1 + caretSize;
				y3 = y1;
				// invert drawing order
				var tmp = x3;
				x3 = x1;
				x1 = tmp;
			}
		}
		return {x1: x1, x2: x2, x3: x3, y1: y1, y2: y2, y3: y3};
	},

	drawTitle: function(pt, vm, ctx) {
		var title = vm.title;
		var length = title.length;
		var titleFontSize, titleSpacing, i;

		if (length) {
			var rtlHelper = getRtlHelper(vm.rtl, vm.x, vm.width);

			pt.x = getAlignedX(vm, vm._titleAlign);

			ctx.textAlign = rtlHelper.textAlign(vm._titleAlign);
			ctx.textBaseline = 'middle';

			titleFontSize = vm.titleFontSize;
			titleSpacing = vm.titleSpacing;

			ctx.fillStyle = vm.titleFontColor;
			ctx.font = helpers$1.fontString(titleFontSize, vm._titleFontStyle, vm._titleFontFamily);

			for (i = 0; i < length; ++i) {
				ctx.fillText(title[i], rtlHelper.x(pt.x), pt.y + titleFontSize / 2);
				pt.y += titleFontSize + titleSpacing; // Line Height and spacing

				if (i + 1 === length) {
					pt.y += vm.titleMarginBottom - titleSpacing; // If Last, add margin, remove spacing
				}
			}
		}
	},

	drawBody: function(pt, vm, ctx) {
		var bodyFontSize = vm.bodyFontSize;
		var bodySpacing = vm.bodySpacing;
		var bodyAlign = vm._bodyAlign;
		var body = vm.body;
		var drawColorBoxes = vm.displayColors;
		var xLinePadding = 0;
		var colorX = drawColorBoxes ? getAlignedX(vm, 'left') : 0;

		var rtlHelper = getRtlHelper(vm.rtl, vm.x, vm.width);

		var fillLineOfText = function(line) {
			ctx.fillText(line, rtlHelper.x(pt.x + xLinePadding), pt.y + bodyFontSize / 2);
			pt.y += bodyFontSize + bodySpacing;
		};

		var bodyItem, textColor, labelColors, lines, i, j, ilen, jlen;
		var bodyAlignForCalculation = rtlHelper.textAlign(bodyAlign);

		ctx.textAlign = bodyAlign;
		ctx.textBaseline = 'middle';
		ctx.font = helpers$1.fontString(bodyFontSize, vm._bodyFontStyle, vm._bodyFontFamily);

		pt.x = getAlignedX(vm, bodyAlignForCalculation);

		// Before body lines
		ctx.fillStyle = vm.bodyFontColor;
		helpers$1.each(vm.beforeBody, fillLineOfText);

		xLinePadding = drawColorBoxes && bodyAlignForCalculation !== 'right'
			? bodyAlign === 'center' ? (bodyFontSize / 2 + 1) : (bodyFontSize + 2)
			: 0;

		// Draw body lines now
		for (i = 0, ilen = body.length; i < ilen; ++i) {
			bodyItem = body[i];
			textColor = vm.labelTextColors[i];
			labelColors = vm.labelColors[i];

			ctx.fillStyle = textColor;
			helpers$1.each(bodyItem.before, fillLineOfText);

			lines = bodyItem.lines;
			for (j = 0, jlen = lines.length; j < jlen; ++j) {
				// Draw Legend-like boxes if needed
				if (drawColorBoxes) {
					var rtlColorX = rtlHelper.x(colorX);

					// Fill a white rect so that colours merge nicely if the opacity is < 1
					ctx.fillStyle = vm.legendColorBackground;
					ctx.fillRect(rtlHelper.leftForLtr(rtlColorX, bodyFontSize), pt.y, bodyFontSize, bodyFontSize);

					// Border
					ctx.lineWidth = 1;
					ctx.strokeStyle = labelColors.borderColor;
					ctx.strokeRect(rtlHelper.leftForLtr(rtlColorX, bodyFontSize), pt.y, bodyFontSize, bodyFontSize);

					// Inner square
					ctx.fillStyle = labelColors.backgroundColor;
					ctx.fillRect(rtlHelper.leftForLtr(rtlHelper.xPlus(rtlColorX, 1), bodyFontSize - 2), pt.y + 1, bodyFontSize - 2, bodyFontSize - 2);
					ctx.fillStyle = textColor;
				}

				fillLineOfText(lines[j]);
			}

			helpers$1.each(bodyItem.after, fillLineOfText);
		}

		// Reset back to 0 for after body
		xLinePadding = 0;

		// After body lines
		helpers$1.each(vm.afterBody, fillLineOfText);
		pt.y -= bodySpacing; // Remove last body spacing
	},

	drawFooter: function(pt, vm, ctx) {
		var footer = vm.footer;
		var length = footer.length;
		var footerFontSize, i;

		if (length) {
			var rtlHelper = getRtlHelper(vm.rtl, vm.x, vm.width);

			pt.x = getAlignedX(vm, vm._footerAlign);
			pt.y += vm.footerMarginTop;

			ctx.textAlign = rtlHelper.textAlign(vm._footerAlign);
			ctx.textBaseline = 'middle';

			footerFontSize = vm.footerFontSize;

			ctx.fillStyle = vm.footerFontColor;
			ctx.font = helpers$1.fontString(footerFontSize, vm._footerFontStyle, vm._footerFontFamily);

			for (i = 0; i < length; ++i) {
				ctx.fillText(footer[i], rtlHelper.x(pt.x), pt.y + footerFontSize / 2);
				pt.y += footerFontSize + vm.footerSpacing;
			}
		}
	},

	drawBackground: function(pt, vm, ctx, tooltipSize) {
		ctx.fillStyle = vm.backgroundColor;
		ctx.strokeStyle = vm.borderColor;
		ctx.lineWidth = vm.borderWidth;
		var xAlign = vm.xAlign;
		var yAlign = vm.yAlign;
		var x = pt.x;
		var y = pt.y;
		var width = tooltipSize.width;
		var height = tooltipSize.height;
		var radius = vm.cornerRadius;

		ctx.beginPath();
		ctx.moveTo(x + radius, y);
		if (yAlign === 'top') {
			this.drawCaret(pt, tooltipSize);
		}
		ctx.lineTo(x + width - radius, y);
		ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
		if (yAlign === 'center' && xAlign === 'right') {
			this.drawCaret(pt, tooltipSize);
		}
		ctx.lineTo(x + width, y + height - radius);
		ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
		if (yAlign === 'bottom') {
			this.drawCaret(pt, tooltipSize);
		}
		ctx.lineTo(x + radius, y + height);
		ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
		if (yAlign === 'center' && xAlign === 'left') {
			this.drawCaret(pt, tooltipSize);
		}
		ctx.lineTo(x, y + radius);
		ctx.quadraticCurveTo(x, y, x + radius, y);
		ctx.closePath();

		ctx.fill();

		if (vm.borderWidth > 0) {
			ctx.stroke();
		}
	},

	draw: function() {
		var ctx = this._chart.ctx;
		var vm = this._view;

		if (vm.opacity === 0) {
			return;
		}

		var tooltipSize = {
			width: vm.width,
			height: vm.height
		};
		var pt = {
			x: vm.x,
			y: vm.y
		};

		// IE11/Edge does not like very small opacities, so snap to 0
		var opacity = Math.abs(vm.opacity < 1e-3) ? 0 : vm.opacity;

		// Truthy/falsey value for empty tooltip
		var hasTooltipContent = vm.title.length || vm.beforeBody.length || vm.body.length || vm.afterBody.length || vm.footer.length;

		if (this._options.enabled && hasTooltipContent) {
			ctx.save();
			ctx.globalAlpha = opacity;

			// Draw Background
			this.drawBackground(pt, vm, ctx, tooltipSize);

			// Draw Title, Body, and Footer
			pt.y += vm.yPadding;

			helpers$1.rtl.overrideTextDirection(ctx, vm.textDirection);

			// Titles
			this.drawTitle(pt, vm, ctx);

			// Body
			this.drawBody(pt, vm, ctx);

			// Footer
			this.drawFooter(pt, vm, ctx);

			helpers$1.rtl.restoreTextDirection(ctx, vm.textDirection);

			ctx.restore();
		}
	},

	/**
	 * Handle an event
	 * @private
	 * @param {IEvent} event - The event to handle
	 * @returns {boolean} true if the tooltip changed
	 */
	handleEvent: function(e) {
		var me = this;
		var options = me._options;
		var changed = false;

		me._lastActive = me._lastActive || [];

		// Find Active Elements for tooltips
		if (e.type === 'mouseout') {
			me._active = [];
		} else {
			me._active = me._chart.getElementsAtEventForMode(e, options.mode, options);
			if (options.reverse) {
				me._active.reverse();
			}
		}

		// Remember Last Actives
		changed = !helpers$1.arrayEquals(me._active, me._lastActive);

		// Only handle target event on tooltip change
		if (changed) {
			me._lastActive = me._active;

			if (options.enabled || options.custom) {
				me._eventPosition = {
					x: e.x,
					y: e.y
				};

				me.update(true);
				me.pivot();
			}
		}

		return changed;
	}
});

/**
 * @namespace Chart.Tooltip.positioners
 */
var positioners_1 = positioners;

var core_tooltip = exports$4;
core_tooltip.positioners = positioners_1;

var valueOrDefault$9 = helpers$1.valueOrDefault;

core_defaults._set('global', {
	elements: {},
	events: [
		'mousemove',
		'mouseout',
		'click',
		'touchstart',
		'touchmove'
	],
	hover: {
		onHover: null,
		mode: 'nearest',
		intersect: true,
		animationDuration: 400
	},
	onClick: null,
	maintainAspectRatio: true,
	responsive: true,
	responsiveAnimationDuration: 0
});

/**
 * Recursively merge the given config objects representing the `scales` option
 * by incorporating scale defaults in `xAxes` and `yAxes` array items, then
 * returns a deep copy of the result, thus doesn't alter inputs.
 */
function mergeScaleConfig(/* config objects ... */) {
	return helpers$1.merge(Object.create(null), [].slice.call(arguments), {
		merger: function(key, target, source, options) {
			if (key === 'xAxes' || key === 'yAxes') {
				var slen = source[key].length;
				var i, type, scale;

				if (!target[key]) {
					target[key] = [];
				}

				for (i = 0; i < slen; ++i) {
					scale = source[key][i];
					type = valueOrDefault$9(scale.type, key === 'xAxes' ? 'category' : 'linear');

					if (i >= target[key].length) {
						target[key].push({});
					}

					if (!target[key][i].type || (scale.type && scale.type !== target[key][i].type)) {
						// new/untyped scale or type changed: let's apply the new defaults
						// then merge source scale to correctly overwrite the defaults.
						helpers$1.merge(target[key][i], [core_scaleService.getScaleDefaults(type), scale]);
					} else {
						// scales type are the same
						helpers$1.merge(target[key][i], scale);
					}
				}
			} else {
				helpers$1._merger(key, target, source, options);
			}
		}
	});
}

/**
 * Recursively merge the given config objects as the root options by handling
 * default scale options for the `scales` and `scale` properties, then returns
 * a deep copy of the result, thus doesn't alter inputs.
 */
function mergeConfig(/* config objects ... */) {
	return helpers$1.merge(Object.create(null), [].slice.call(arguments), {
		merger: function(key, target, source, options) {
			var tval = target[key] || Object.create(null);
			var sval = source[key];

			if (key === 'scales') {
				// scale config merging is complex. Add our own function here for that
				target[key] = mergeScaleConfig(tval, sval);
			} else if (key === 'scale') {
				// used in polar area & radar charts since there is only one scale
				target[key] = helpers$1.merge(tval, [core_scaleService.getScaleDefaults(sval.type), sval]);
			} else {
				helpers$1._merger(key, target, source, options);
			}
		}
	});
}

function initConfig(config) {
	config = config || Object.create(null);

	// Do NOT use mergeConfig for the data object because this method merges arrays
	// and so would change references to labels and datasets, preventing data updates.
	var data = config.data = config.data || {};
	data.datasets = data.datasets || [];
	data.labels = data.labels || [];

	config.options = mergeConfig(
		core_defaults.global,
		core_defaults[config.type],
		config.options || {});

	return config;
}

function updateConfig(chart) {
	var newOptions = chart.options;

	helpers$1.each(chart.scales, function(scale) {
		core_layouts.removeBox(chart, scale);
	});

	newOptions = mergeConfig(
		core_defaults.global,
		core_defaults[chart.config.type],
		newOptions);

	chart.options = chart.config.options = newOptions;
	chart.ensureScalesHaveIDs();
	chart.buildOrUpdateScales();

	// Tooltip
	chart.tooltip._options = newOptions.tooltips;
	chart.tooltip.initialize();
}

function nextAvailableScaleId(axesOpts, prefix, index) {
	var id;
	var hasId = function(obj) {
		return obj.id === id;
	};

	do {
		id = prefix + index++;
	} while (helpers$1.findIndex(axesOpts, hasId) >= 0);

	return id;
}

function positionIsHorizontal(position) {
	return position === 'top' || position === 'bottom';
}

function compare2Level(l1, l2) {
	return function(a, b) {
		return a[l1] === b[l1]
			? a[l2] - b[l2]
			: a[l1] - b[l1];
	};
}

var Chart = function(item, config) {
	this.construct(item, config);
	return this;
};

helpers$1.extend(Chart.prototype, /** @lends Chart */ {
	/**
	 * @private
	 */
	construct: function(item, config) {
		var me = this;

		config = initConfig(config);

		var context = platform.acquireContext(item, config);
		var canvas = context && context.canvas;
		var height = canvas && canvas.height;
		var width = canvas && canvas.width;

		me.id = helpers$1.uid();
		me.ctx = context;
		me.canvas = canvas;
		me.config = config;
		me.width = width;
		me.height = height;
		me.aspectRatio = height ? width / height : null;
		me.options = config.options;
		me._bufferedRender = false;
		me._layers = [];

		/**
		 * Provided for backward compatibility, Chart and Chart.Controller have been merged,
		 * the "instance" still need to be defined since it might be called from plugins.
		 * @prop Chart#chart
		 * @deprecated since version 2.6.0
		 * @todo remove at version 3
		 * @private
		 */
		me.chart = me;
		me.controller = me; // chart.chart.controller #inception

		// Add the chart instance to the global namespace
		Chart.instances[me.id] = me;

		// Define alias to the config data: `chart.data === chart.config.data`
		Object.defineProperty(me, 'data', {
			get: function() {
				return me.config.data;
			},
			set: function(value) {
				me.config.data = value;
			}
		});

		if (!context || !canvas) {
			// The given item is not a compatible context2d element, let's return before finalizing
			// the chart initialization but after setting basic chart / controller properties that
			// can help to figure out that the chart is not valid (e.g chart.canvas !== null);
			// https://github.com/chartjs/Chart.js/issues/2807
			console.error("Failed to create chart: can't acquire context from the given item");
			return;
		}

		me.initialize();
		me.update();
	},

	/**
	 * @private
	 */
	initialize: function() {
		var me = this;

		// Before init plugin notification
		core_plugins.notify(me, 'beforeInit');

		helpers$1.retinaScale(me, me.options.devicePixelRatio);

		me.bindEvents();

		if (me.options.responsive) {
			// Initial resize before chart draws (must be silent to preserve initial animations).
			me.resize(true);
		}

		me.initToolTip();

		// After init plugin notification
		core_plugins.notify(me, 'afterInit');

		return me;
	},

	clear: function() {
		helpers$1.canvas.clear(this);
		return this;
	},

	stop: function() {
		// Stops any current animation loop occurring
		core_animations.cancelAnimation(this);
		return this;
	},

	resize: function(silent) {
		var me = this;
		var options = me.options;
		var canvas = me.canvas;
		var aspectRatio = (options.maintainAspectRatio && me.aspectRatio) || null;

		// the canvas render width and height will be casted to integers so make sure that
		// the canvas display style uses the same integer values to avoid blurring effect.

		// Set to 0 instead of canvas.size because the size defaults to 300x150 if the element is collapsed
		var newWidth = Math.max(0, Math.floor(helpers$1.getMaximumWidth(canvas)));
		var newHeight = Math.max(0, Math.floor(aspectRatio ? newWidth / aspectRatio : helpers$1.getMaximumHeight(canvas)));

		if (me.width === newWidth && me.height === newHeight) {
			return;
		}

		canvas.width = me.width = newWidth;
		canvas.height = me.height = newHeight;
		canvas.style.width = newWidth + 'px';
		canvas.style.height = newHeight + 'px';

		helpers$1.retinaScale(me, options.devicePixelRatio);

		if (!silent) {
			// Notify any plugins about the resize
			var newSize = {width: newWidth, height: newHeight};
			core_plugins.notify(me, 'resize', [newSize]);

			// Notify of resize
			if (options.onResize) {
				options.onResize(me, newSize);
			}

			me.stop();
			me.update({
				duration: options.responsiveAnimationDuration
			});
		}
	},

	ensureScalesHaveIDs: function() {
		var options = this.options;
		var scalesOptions = options.scales || {};
		var scaleOptions = options.scale;

		helpers$1.each(scalesOptions.xAxes, function(xAxisOptions, index) {
			if (!xAxisOptions.id) {
				xAxisOptions.id = nextAvailableScaleId(scalesOptions.xAxes, 'x-axis-', index);
			}
		});

		helpers$1.each(scalesOptions.yAxes, function(yAxisOptions, index) {
			if (!yAxisOptions.id) {
				yAxisOptions.id = nextAvailableScaleId(scalesOptions.yAxes, 'y-axis-', index);
			}
		});

		if (scaleOptions) {
			scaleOptions.id = scaleOptions.id || 'scale';
		}
	},

	/**
	 * Builds a map of scale ID to scale object for future lookup.
	 */
	buildOrUpdateScales: function() {
		var me = this;
		var options = me.options;
		var scales = me.scales || {};
		var items = [];
		var updated = Object.keys(scales).reduce(function(obj, id) {
			obj[id] = false;
			return obj;
		}, {});

		if (options.scales) {
			items = items.concat(
				(options.scales.xAxes || []).map(function(xAxisOptions) {
					return {options: xAxisOptions, dtype: 'category', dposition: 'bottom'};
				}),
				(options.scales.yAxes || []).map(function(yAxisOptions) {
					return {options: yAxisOptions, dtype: 'linear', dposition: 'left'};
				})
			);
		}

		if (options.scale) {
			items.push({
				options: options.scale,
				dtype: 'radialLinear',
				isDefault: true,
				dposition: 'chartArea'
			});
		}

		helpers$1.each(items, function(item) {
			var scaleOptions = item.options;
			var id = scaleOptions.id;
			var scaleType = valueOrDefault$9(scaleOptions.type, item.dtype);

			if (positionIsHorizontal(scaleOptions.position) !== positionIsHorizontal(item.dposition)) {
				scaleOptions.position = item.dposition;
			}

			updated[id] = true;
			var scale = null;
			if (id in scales && scales[id].type === scaleType) {
				scale = scales[id];
				scale.options = scaleOptions;
				scale.ctx = me.ctx;
				scale.chart = me;
			} else {
				var scaleClass = core_scaleService.getScaleConstructor(scaleType);
				if (!scaleClass) {
					return;
				}
				scale = new scaleClass({
					id: id,
					type: scaleType,
					options: scaleOptions,
					ctx: me.ctx,
					chart: me
				});
				scales[scale.id] = scale;
			}

			scale.mergeTicksOptions();

			// TODO(SB): I think we should be able to remove this custom case (options.scale)
			// and consider it as a regular scale part of the "scales"" map only! This would
			// make the logic easier and remove some useless? custom code.
			if (item.isDefault) {
				me.scale = scale;
			}
		});
		// clear up discarded scales
		helpers$1.each(updated, function(hasUpdated, id) {
			if (!hasUpdated) {
				delete scales[id];
			}
		});

		me.scales = scales;

		core_scaleService.addScalesToLayout(this);
	},

	buildOrUpdateControllers: function() {
		var me = this;
		var newControllers = [];
		var datasets = me.data.datasets;
		var i, ilen;

		for (i = 0, ilen = datasets.length; i < ilen; i++) {
			var dataset = datasets[i];
			var meta = me.getDatasetMeta(i);
			var type = dataset.type || me.config.type;

			if (meta.type && meta.type !== type) {
				me.destroyDatasetMeta(i);
				meta = me.getDatasetMeta(i);
			}
			meta.type = type;
			meta.order = dataset.order || 0;
			meta.index = i;

			if (meta.controller) {
				meta.controller.updateIndex(i);
				meta.controller.linkScales();
			} else {
				var ControllerClass = controllers[meta.type];
				if (ControllerClass === undefined) {
					throw new Error('"' + meta.type + '" is not a chart type.');
				}

				meta.controller = new ControllerClass(me, i);
				newControllers.push(meta.controller);
			}
		}

		return newControllers;
	},

	/**
	 * Reset the elements of all datasets
	 * @private
	 */
	resetElements: function() {
		var me = this;
		helpers$1.each(me.data.datasets, function(dataset, datasetIndex) {
			me.getDatasetMeta(datasetIndex).controller.reset();
		}, me);
	},

	/**
	* Resets the chart back to it's state before the initial animation
	*/
	reset: function() {
		this.resetElements();
		this.tooltip.initialize();
	},

	update: function(config) {
		var me = this;
		var i, ilen;

		if (!config || typeof config !== 'object') {
			// backwards compatibility
			config = {
				duration: config,
				lazy: arguments[1]
			};
		}

		updateConfig(me);

		// plugins options references might have change, let's invalidate the cache
		// https://github.com/chartjs/Chart.js/issues/5111#issuecomment-355934167
		core_plugins._invalidate(me);

		if (core_plugins.notify(me, 'beforeUpdate') === false) {
			return;
		}

		// In case the entire data object changed
		me.tooltip._data = me.data;

		// Make sure dataset controllers are updated and new controllers are reset
		var newControllers = me.buildOrUpdateControllers();

		// Make sure all dataset controllers have correct meta data counts
		for (i = 0, ilen = me.data.datasets.length; i < ilen; i++) {
			me.getDatasetMeta(i).controller.buildOrUpdateElements();
		}

		me.updateLayout();

		// Can only reset the new controllers after the scales have been updated
		if (me.options.animation && me.options.animation.duration) {
			helpers$1.each(newControllers, function(controller) {
				controller.reset();
			});
		}

		me.updateDatasets();

		// Need to reset tooltip in case it is displayed with elements that are removed
		// after update.
		me.tooltip.initialize();

		// Last active contains items that were previously in the tooltip.
		// When we reset the tooltip, we need to clear it
		me.lastActive = [];

		// Do this before render so that any plugins that need final scale updates can use it
		core_plugins.notify(me, 'afterUpdate');

		me._layers.sort(compare2Level('z', '_idx'));

		if (me._bufferedRender) {
			me._bufferedRequest = {
				duration: config.duration,
				easing: config.easing,
				lazy: config.lazy
			};
		} else {
			me.render(config);
		}
	},

	/**
	 * Updates the chart layout unless a plugin returns `false` to the `beforeLayout`
	 * hook, in which case, plugins will not be called on `afterLayout`.
	 * @private
	 */
	updateLayout: function() {
		var me = this;

		if (core_plugins.notify(me, 'beforeLayout') === false) {
			return;
		}

		core_layouts.update(this, this.width, this.height);

		me._layers = [];
		helpers$1.each(me.boxes, function(box) {
			// _configure is called twice, once in core.scale.update and once here.
			// Here the boxes are fully updated and at their final positions.
			if (box._configure) {
				box._configure();
			}
			me._layers.push.apply(me._layers, box._layers());
		}, me);

		me._layers.forEach(function(item, index) {
			item._idx = index;
		});

		/**
		 * Provided for backward compatibility, use `afterLayout` instead.
		 * @method IPlugin#afterScaleUpdate
		 * @deprecated since version 2.5.0
		 * @todo remove at version 3
		 * @private
		 */
		core_plugins.notify(me, 'afterScaleUpdate');
		core_plugins.notify(me, 'afterLayout');
	},

	/**
	 * Updates all datasets unless a plugin returns `false` to the `beforeDatasetsUpdate`
	 * hook, in which case, plugins will not be called on `afterDatasetsUpdate`.
	 * @private
	 */
	updateDatasets: function() {
		var me = this;

		if (core_plugins.notify(me, 'beforeDatasetsUpdate') === false) {
			return;
		}

		for (var i = 0, ilen = me.data.datasets.length; i < ilen; ++i) {
			me.updateDataset(i);
		}

		core_plugins.notify(me, 'afterDatasetsUpdate');
	},

	/**
	 * Updates dataset at index unless a plugin returns `false` to the `beforeDatasetUpdate`
	 * hook, in which case, plugins will not be called on `afterDatasetUpdate`.
	 * @private
	 */
	updateDataset: function(index) {
		var me = this;
		var meta = me.getDatasetMeta(index);
		var args = {
			meta: meta,
			index: index
		};

		if (core_plugins.notify(me, 'beforeDatasetUpdate', [args]) === false) {
			return;
		}

		meta.controller._update();

		core_plugins.notify(me, 'afterDatasetUpdate', [args]);
	},

	render: function(config) {
		var me = this;

		if (!config || typeof config !== 'object') {
			// backwards compatibility
			config = {
				duration: config,
				lazy: arguments[1]
			};
		}

		var animationOptions = me.options.animation;
		var duration = valueOrDefault$9(config.duration, animationOptions && animationOptions.duration);
		var lazy = config.lazy;

		if (core_plugins.notify(me, 'beforeRender') === false) {
			return;
		}

		var onComplete = function(animation) {
			core_plugins.notify(me, 'afterRender');
			helpers$1.callback(animationOptions && animationOptions.onComplete, [animation], me);
		};

		if (animationOptions && duration) {
			var animation = new core_animation({
				numSteps: duration / 16.66, // 60 fps
				easing: config.easing || animationOptions.easing,

				render: function(chart, animationObject) {
					var easingFunction = helpers$1.easing.effects[animationObject.easing];
					var currentStep = animationObject.currentStep;
					var stepDecimal = currentStep / animationObject.numSteps;

					chart.draw(easingFunction(stepDecimal), stepDecimal, currentStep);
				},

				onAnimationProgress: animationOptions.onProgress,
				onAnimationComplete: onComplete
			});

			core_animations.addAnimation(me, animation, duration, lazy);
		} else {
			me.draw();

			// See https://github.com/chartjs/Chart.js/issues/3781
			onComplete(new core_animation({numSteps: 0, chart: me}));
		}

		return me;
	},

	draw: function(easingValue) {
		var me = this;
		var i, layers;

		me.clear();

		if (helpers$1.isNullOrUndef(easingValue)) {
			easingValue = 1;
		}

		me.transition(easingValue);

		if (me.width <= 0 || me.height <= 0) {
			return;
		}

		if (core_plugins.notify(me, 'beforeDraw', [easingValue]) === false) {
			return;
		}

		// Because of plugin hooks (before/afterDatasetsDraw), datasets can't
		// currently be part of layers. Instead, we draw
		// layers <= 0 before(default, backward compat), and the rest after
		layers = me._layers;
		for (i = 0; i < layers.length && layers[i].z <= 0; ++i) {
			layers[i].draw(me.chartArea);
		}

		me.drawDatasets(easingValue);

		// Rest of layers
		for (; i < layers.length; ++i) {
			layers[i].draw(me.chartArea);
		}

		me._drawTooltip(easingValue);

		core_plugins.notify(me, 'afterDraw', [easingValue]);
	},

	/**
	 * @private
	 */
	transition: function(easingValue) {
		var me = this;

		for (var i = 0, ilen = (me.data.datasets || []).length; i < ilen; ++i) {
			if (me.isDatasetVisible(i)) {
				me.getDatasetMeta(i).controller.transition(easingValue);
			}
		}

		me.tooltip.transition(easingValue);
	},

	/**
	 * @private
	 */
	_getSortedDatasetMetas: function(filterVisible) {
		var me = this;
		var datasets = me.data.datasets || [];
		var result = [];
		var i, ilen;

		for (i = 0, ilen = datasets.length; i < ilen; ++i) {
			if (!filterVisible || me.isDatasetVisible(i)) {
				result.push(me.getDatasetMeta(i));
			}
		}

		result.sort(compare2Level('order', 'index'));

		return result;
	},

	/**
	 * @private
	 */
	_getSortedVisibleDatasetMetas: function() {
		return this._getSortedDatasetMetas(true);
	},

	/**
	 * Draws all datasets unless a plugin returns `false` to the `beforeDatasetsDraw`
	 * hook, in which case, plugins will not be called on `afterDatasetsDraw`.
	 * @private
	 */
	drawDatasets: function(easingValue) {
		var me = this;
		var metasets, i;

		if (core_plugins.notify(me, 'beforeDatasetsDraw', [easingValue]) === false) {
			return;
		}

		metasets = me._getSortedVisibleDatasetMetas();
		for (i = metasets.length - 1; i >= 0; --i) {
			me.drawDataset(metasets[i], easingValue);
		}

		core_plugins.notify(me, 'afterDatasetsDraw', [easingValue]);
	},

	/**
	 * Draws dataset at index unless a plugin returns `false` to the `beforeDatasetDraw`
	 * hook, in which case, plugins will not be called on `afterDatasetDraw`.
	 * @private
	 */
	drawDataset: function(meta, easingValue) {
		var me = this;
		var args = {
			meta: meta,
			index: meta.index,
			easingValue: easingValue
		};

		if (core_plugins.notify(me, 'beforeDatasetDraw', [args]) === false) {
			return;
		}

		meta.controller.draw(easingValue);

		core_plugins.notify(me, 'afterDatasetDraw', [args]);
	},

	/**
	 * Draws tooltip unless a plugin returns `false` to the `beforeTooltipDraw`
	 * hook, in which case, plugins will not be called on `afterTooltipDraw`.
	 * @private
	 */
	_drawTooltip: function(easingValue) {
		var me = this;
		var tooltip = me.tooltip;
		var args = {
			tooltip: tooltip,
			easingValue: easingValue
		};

		if (core_plugins.notify(me, 'beforeTooltipDraw', [args]) === false) {
			return;
		}

		tooltip.draw();

		core_plugins.notify(me, 'afterTooltipDraw', [args]);
	},

	/**
	 * Get the single element that was clicked on
	 * @return An object containing the dataset index and element index of the matching element. Also contains the rectangle that was draw
	 */
	getElementAtEvent: function(e) {
		return core_interaction.modes.single(this, e);
	},

	getElementsAtEvent: function(e) {
		return core_interaction.modes.label(this, e, {intersect: true});
	},

	getElementsAtXAxis: function(e) {
		return core_interaction.modes['x-axis'](this, e, {intersect: true});
	},

	getElementsAtEventForMode: function(e, mode, options) {
		var method = core_interaction.modes[mode];
		if (typeof method === 'function') {
			return method(this, e, options);
		}

		return [];
	},

	getDatasetAtEvent: function(e) {
		return core_interaction.modes.dataset(this, e, {intersect: true});
	},

	getDatasetMeta: function(datasetIndex) {
		var me = this;
		var dataset = me.data.datasets[datasetIndex];
		if (!dataset._meta) {
			dataset._meta = {};
		}

		var meta = dataset._meta[me.id];
		if (!meta) {
			meta = dataset._meta[me.id] = {
				type: null,
				data: [],
				dataset: null,
				controller: null,
				hidden: null,			// See isDatasetVisible() comment
				xAxisID: null,
				yAxisID: null,
				order: dataset.order || 0,
				index: datasetIndex
			};
		}

		return meta;
	},

	getVisibleDatasetCount: function() {
		var count = 0;
		for (var i = 0, ilen = this.data.datasets.length; i < ilen; ++i) {
			if (this.isDatasetVisible(i)) {
				count++;
			}
		}
		return count;
	},

	isDatasetVisible: function(datasetIndex) {
		var meta = this.getDatasetMeta(datasetIndex);

		// meta.hidden is a per chart dataset hidden flag override with 3 states: if true or false,
		// the dataset.hidden value is ignored, else if null, the dataset hidden state is returned.
		return typeof meta.hidden === 'boolean' ? !meta.hidden : !this.data.datasets[datasetIndex].hidden;
	},

	generateLegend: function() {
		return this.options.legendCallback(this);
	},

	/**
	 * @private
	 */
	destroyDatasetMeta: function(datasetIndex) {
		var id = this.id;
		var dataset = this.data.datasets[datasetIndex];
		var meta = dataset._meta && dataset._meta[id];

		if (meta) {
			meta.controller.destroy();
			delete dataset._meta[id];
		}
	},

	destroy: function() {
		var me = this;
		var canvas = me.canvas;
		var i, ilen;

		me.stop();

		// dataset controllers need to cleanup associated data
		for (i = 0, ilen = me.data.datasets.length; i < ilen; ++i) {
			me.destroyDatasetMeta(i);
		}

		if (canvas) {
			me.unbindEvents();
			helpers$1.canvas.clear(me);
			platform.releaseContext(me.ctx);
			me.canvas = null;
			me.ctx = null;
		}

		core_plugins.notify(me, 'destroy');

		delete Chart.instances[me.id];
	},

	toBase64Image: function() {
		return this.canvas.toDataURL.apply(this.canvas, arguments);
	},

	initToolTip: function() {
		var me = this;
		me.tooltip = new core_tooltip({
			_chart: me,
			_chartInstance: me, // deprecated, backward compatibility
			_data: me.data,
			_options: me.options.tooltips
		}, me);
	},

	/**
	 * @private
	 */
	bindEvents: function() {
		var me = this;
		var listeners = me._listeners = {};
		var listener = function() {
			me.eventHandler.apply(me, arguments);
		};

		helpers$1.each(me.options.events, function(type) {
			platform.addEventListener(me, type, listener);
			listeners[type] = listener;
		});

		// Elements used to detect size change should not be injected for non responsive charts.
		// See https://github.com/chartjs/Chart.js/issues/2210
		if (me.options.responsive) {
			listener = function() {
				me.resize();
			};

			platform.addEventListener(me, 'resize', listener);
			listeners.resize = listener;
		}
	},

	/**
	 * @private
	 */
	unbindEvents: function() {
		var me = this;
		var listeners = me._listeners;
		if (!listeners) {
			return;
		}

		delete me._listeners;
		helpers$1.each(listeners, function(listener, type) {
			platform.removeEventListener(me, type, listener);
		});
	},

	updateHoverStyle: function(elements, mode, enabled) {
		var prefix = enabled ? 'set' : 'remove';
		var element, i, ilen;

		for (i = 0, ilen = elements.length; i < ilen; ++i) {
			element = elements[i];
			if (element) {
				this.getDatasetMeta(element._datasetIndex).controller[prefix + 'HoverStyle'](element);
			}
		}

		if (mode === 'dataset') {
			this.getDatasetMeta(elements[0]._datasetIndex).controller['_' + prefix + 'DatasetHoverStyle']();
		}
	},

	/**
	 * @private
	 */
	eventHandler: function(e) {
		var me = this;
		var tooltip = me.tooltip;

		if (core_plugins.notify(me, 'beforeEvent', [e]) === false) {
			return;
		}

		// Buffer any update calls so that renders do not occur
		me._bufferedRender = true;
		me._bufferedRequest = null;

		var changed = me.handleEvent(e);
		// for smooth tooltip animations issue #4989
		// the tooltip should be the source of change
		// Animation check workaround:
		// tooltip._start will be null when tooltip isn't animating
		if (tooltip) {
			changed = tooltip._start
				? tooltip.handleEvent(e)
				: changed | tooltip.handleEvent(e);
		}

		core_plugins.notify(me, 'afterEvent', [e]);

		var bufferedRequest = me._bufferedRequest;
		if (bufferedRequest) {
			// If we have an update that was triggered, we need to do a normal render
			me.render(bufferedRequest);
		} else if (changed && !me.animating) {
			// If entering, leaving, or changing elements, animate the change via pivot
			me.stop();

			// We only need to render at this point. Updating will cause scales to be
			// recomputed generating flicker & using more memory than necessary.
			me.render({
				duration: me.options.hover.animationDuration,
				lazy: true
			});
		}

		me._bufferedRender = false;
		me._bufferedRequest = null;

		return me;
	},

	/**
	 * Handle an event
	 * @private
	 * @param {IEvent} event the event to handle
	 * @return {boolean} true if the chart needs to re-render
	 */
	handleEvent: function(e) {
		var me = this;
		var options = me.options || {};
		var hoverOptions = options.hover;
		var changed = false;

		me.lastActive = me.lastActive || [];

		// Find Active Elements for hover and tooltips
		if (e.type === 'mouseout') {
			me.active = [];
		} else {
			me.active = me.getElementsAtEventForMode(e, hoverOptions.mode, hoverOptions);
		}

		// Invoke onHover hook
		// Need to call with native event here to not break backwards compatibility
		helpers$1.callback(options.onHover || options.hover.onHover, [e.native, me.active], me);

		if (e.type === 'mouseup' || e.type === 'click') {
			if (options.onClick) {
				// Use e.native here for backwards compatibility
				options.onClick.call(me, e.native, me.active);
			}
		}

		// Remove styling for last active (even if it may still be active)
		if (me.lastActive.length) {
			me.updateHoverStyle(me.lastActive, hoverOptions.mode, false);
		}

		// Built in hover styling
		if (me.active.length && hoverOptions.mode) {
			me.updateHoverStyle(me.active, hoverOptions.mode, true);
		}

		changed = !helpers$1.arrayEquals(me.active, me.lastActive);

		// Remember Last Actives
		me.lastActive = me.active;

		return changed;
	}
});

/**
 * NOTE(SB) We actually don't use this container anymore but we need to keep it
 * for backward compatibility. Though, it can still be useful for plugins that
 * would need to work on multiple charts?!
 */
Chart.instances = {};

var core_controller = Chart;

// DEPRECATIONS

/**
 * Provided for backward compatibility, use Chart instead.
 * @class Chart.Controller
 * @deprecated since version 2.6
 * @todo remove at version 3
 * @private
 */
Chart.Controller = Chart;

/**
 * Provided for backward compatibility, not available anymore.
 * @namespace Chart
 * @deprecated since version 2.8
 * @todo remove at version 3
 * @private
 */
Chart.types = {};

/**
 * Provided for backward compatibility, not available anymore.
 * @namespace Chart.helpers.configMerge
 * @deprecated since version 2.8.0
 * @todo remove at version 3
 * @private
 */
helpers$1.configMerge = mergeConfig;

/**
 * Provided for backward compatibility, not available anymore.
 * @namespace Chart.helpers.scaleMerge
 * @deprecated since version 2.8.0
 * @todo remove at version 3
 * @private
 */
helpers$1.scaleMerge = mergeScaleConfig;

var core_helpers = function() {

	// -- Basic js utility methods

	helpers$1.where = function(collection, filterCallback) {
		if (helpers$1.isArray(collection) && Array.prototype.filter) {
			return collection.filter(filterCallback);
		}
		var filtered = [];

		helpers$1.each(collection, function(item) {
			if (filterCallback(item)) {
				filtered.push(item);
			}
		});

		return filtered;
	};
	helpers$1.findIndex = Array.prototype.findIndex ?
		function(array, callback, scope) {
			return array.findIndex(callback, scope);
		} :
		function(array, callback, scope) {
			scope = scope === undefined ? array : scope;
			for (var i = 0, ilen = array.length; i < ilen; ++i) {
				if (callback.call(scope, array[i], i, array)) {
					return i;
				}
			}
			return -1;
		};
	helpers$1.findNextWhere = function(arrayToSearch, filterCallback, startIndex) {
		// Default to start of the array
		if (helpers$1.isNullOrUndef(startIndex)) {
			startIndex = -1;
		}
		for (var i = startIndex + 1; i < arrayToSearch.length; i++) {
			var currentItem = arrayToSearch[i];
			if (filterCallback(currentItem)) {
				return currentItem;
			}
		}
	};
	helpers$1.findPreviousWhere = function(arrayToSearch, filterCallback, startIndex) {
		// Default to end of the array
		if (helpers$1.isNullOrUndef(startIndex)) {
			startIndex = arrayToSearch.length;
		}
		for (var i = startIndex - 1; i >= 0; i--) {
			var currentItem = arrayToSearch[i];
			if (filterCallback(currentItem)) {
				return currentItem;
			}
		}
	};

	// -- Math methods
	helpers$1.isNumber = function(n) {
		return !isNaN(parseFloat(n)) && isFinite(n);
	};
	helpers$1.almostEquals = function(x, y, epsilon) {
		return Math.abs(x - y) < epsilon;
	};
	helpers$1.almostWhole = function(x, epsilon) {
		var rounded = Math.round(x);
		return ((rounded - epsilon) <= x) && ((rounded + epsilon) >= x);
	};
	helpers$1.max = function(array) {
		return array.reduce(function(max, value) {
			if (!isNaN(value)) {
				return Math.max(max, value);
			}
			return max;
		}, Number.NEGATIVE_INFINITY);
	};
	helpers$1.min = function(array) {
		return array.reduce(function(min, value) {
			if (!isNaN(value)) {
				return Math.min(min, value);
			}
			return min;
		}, Number.POSITIVE_INFINITY);
	};
	helpers$1.sign = Math.sign ?
		function(x) {
			return Math.sign(x);
		} :
		function(x) {
			x = +x; // convert to a number
			if (x === 0 || isNaN(x)) {
				return x;
			}
			return x > 0 ? 1 : -1;
		};
	helpers$1.toRadians = function(degrees) {
		return degrees * (Math.PI / 180);
	};
	helpers$1.toDegrees = function(radians) {
		return radians * (180 / Math.PI);
	};

	/**
	 * Returns the number of decimal places
	 * i.e. the number of digits after the decimal point, of the value of this Number.
	 * @param {number} x - A number.
	 * @returns {number} The number of decimal places.
	 * @private
	 */
	helpers$1._decimalPlaces = function(x) {
		if (!helpers$1.isFinite(x)) {
			return;
		}
		var e = 1;
		var p = 0;
		while (Math.round(x * e) / e !== x) {
			e *= 10;
			p++;
		}
		return p;
	};

	// Gets the angle from vertical upright to the point about a centre.
	helpers$1.getAngleFromPoint = function(centrePoint, anglePoint) {
		var distanceFromXCenter = anglePoint.x - centrePoint.x;
		var distanceFromYCenter = anglePoint.y - centrePoint.y;
		var radialDistanceFromCenter = Math.sqrt(distanceFromXCenter * distanceFromXCenter + distanceFromYCenter * distanceFromYCenter);

		var angle = Math.atan2(distanceFromYCenter, distanceFromXCenter);

		if (angle < (-0.5 * Math.PI)) {
			angle += 2.0 * Math.PI; // make sure the returned angle is in the range of (-PI/2, 3PI/2]
		}

		return {
			angle: angle,
			distance: radialDistanceFromCenter
		};
	};
	helpers$1.distanceBetweenPoints = function(pt1, pt2) {
		return Math.sqrt(Math.pow(pt2.x - pt1.x, 2) + Math.pow(pt2.y - pt1.y, 2));
	};

	/**
	 * Provided for backward compatibility, not available anymore
	 * @function Chart.helpers.aliasPixel
	 * @deprecated since version 2.8.0
	 * @todo remove at version 3
	 */
	helpers$1.aliasPixel = function(pixelWidth) {
		return (pixelWidth % 2 === 0) ? 0 : 0.5;
	};

	/**
	 * Returns the aligned pixel value to avoid anti-aliasing blur
	 * @param {Chart} chart - The chart instance.
	 * @param {number} pixel - A pixel value.
	 * @param {number} width - The width of the element.
	 * @returns {number} The aligned pixel value.
	 * @private
	 */
	helpers$1._alignPixel = function(chart, pixel, width) {
		var devicePixelRatio = chart.currentDevicePixelRatio;
		var halfWidth = width / 2;
		return Math.round((pixel - halfWidth) * devicePixelRatio) / devicePixelRatio + halfWidth;
	};

	helpers$1.splineCurve = function(firstPoint, middlePoint, afterPoint, t) {
		// Props to Rob Spencer at scaled innovation for his post on splining between points
		// http://scaledinnovation.com/analytics/splines/aboutSplines.html

		// This function must also respect "skipped" points

		var previous = firstPoint.skip ? middlePoint : firstPoint;
		var current = middlePoint;
		var next = afterPoint.skip ? middlePoint : afterPoint;

		var d01 = Math.sqrt(Math.pow(current.x - previous.x, 2) + Math.pow(current.y - previous.y, 2));
		var d12 = Math.sqrt(Math.pow(next.x - current.x, 2) + Math.pow(next.y - current.y, 2));

		var s01 = d01 / (d01 + d12);
		var s12 = d12 / (d01 + d12);

		// If all points are the same, s01 & s02 will be inf
		s01 = isNaN(s01) ? 0 : s01;
		s12 = isNaN(s12) ? 0 : s12;

		var fa = t * s01; // scaling factor for triangle Ta
		var fb = t * s12;

		return {
			previous: {
				x: current.x - fa * (next.x - previous.x),
				y: current.y - fa * (next.y - previous.y)
			},
			next: {
				x: current.x + fb * (next.x - previous.x),
				y: current.y + fb * (next.y - previous.y)
			}
		};
	};
	helpers$1.EPSILON = Number.EPSILON || 1e-14;
	helpers$1.splineCurveMonotone = function(points) {
		// This function calculates Bézier control points in a similar way than |splineCurve|,
		// but preserves monotonicity of the provided data and ensures no local extremums are added
		// between the dataset discrete points due to the interpolation.
		// See : https://en.wikipedia.org/wiki/Monotone_cubic_interpolation

		var pointsWithTangents = (points || []).map(function(point) {
			return {
				model: point._model,
				deltaK: 0,
				mK: 0
			};
		});

		// Calculate slopes (deltaK) and initialize tangents (mK)
		var pointsLen = pointsWithTangents.length;
		var i, pointBefore, pointCurrent, pointAfter;
		for (i = 0; i < pointsLen; ++i) {
			pointCurrent = pointsWithTangents[i];
			if (pointCurrent.model.skip) {
				continue;
			}

			pointBefore = i > 0 ? pointsWithTangents[i - 1] : null;
			pointAfter = i < pointsLen - 1 ? pointsWithTangents[i + 1] : null;
			if (pointAfter && !pointAfter.model.skip) {
				var slopeDeltaX = (pointAfter.model.x - pointCurrent.model.x);

				// In the case of two points that appear at the same x pixel, slopeDeltaX is 0
				pointCurrent.deltaK = slopeDeltaX !== 0 ? (pointAfter.model.y - pointCurrent.model.y) / slopeDeltaX : 0;
			}

			if (!pointBefore || pointBefore.model.skip) {
				pointCurrent.mK = pointCurrent.deltaK;
			} else if (!pointAfter || pointAfter.model.skip) {
				pointCurrent.mK = pointBefore.deltaK;
			} else if (this.sign(pointBefore.deltaK) !== this.sign(pointCurrent.deltaK)) {
				pointCurrent.mK = 0;
			} else {
				pointCurrent.mK = (pointBefore.deltaK + pointCurrent.deltaK) / 2;
			}
		}

		// Adjust tangents to ensure monotonic properties
		var alphaK, betaK, tauK, squaredMagnitude;
		for (i = 0; i < pointsLen - 1; ++i) {
			pointCurrent = pointsWithTangents[i];
			pointAfter = pointsWithTangents[i + 1];
			if (pointCurrent.model.skip || pointAfter.model.skip) {
				continue;
			}

			if (helpers$1.almostEquals(pointCurrent.deltaK, 0, this.EPSILON)) {
				pointCurrent.mK = pointAfter.mK = 0;
				continue;
			}

			alphaK = pointCurrent.mK / pointCurrent.deltaK;
			betaK = pointAfter.mK / pointCurrent.deltaK;
			squaredMagnitude = Math.pow(alphaK, 2) + Math.pow(betaK, 2);
			if (squaredMagnitude <= 9) {
				continue;
			}

			tauK = 3 / Math.sqrt(squaredMagnitude);
			pointCurrent.mK = alphaK * tauK * pointCurrent.deltaK;
			pointAfter.mK = betaK * tauK * pointCurrent.deltaK;
		}

		// Compute control points
		var deltaX;
		for (i = 0; i < pointsLen; ++i) {
			pointCurrent = pointsWithTangents[i];
			if (pointCurrent.model.skip) {
				continue;
			}

			pointBefore = i > 0 ? pointsWithTangents[i - 1] : null;
			pointAfter = i < pointsLen - 1 ? pointsWithTangents[i + 1] : null;
			if (pointBefore && !pointBefore.model.skip) {
				deltaX = (pointCurrent.model.x - pointBefore.model.x) / 3;
				pointCurrent.model.controlPointPreviousX = pointCurrent.model.x - deltaX;
				pointCurrent.model.controlPointPreviousY = pointCurrent.model.y - deltaX * pointCurrent.mK;
			}
			if (pointAfter && !pointAfter.model.skip) {
				deltaX = (pointAfter.model.x - pointCurrent.model.x) / 3;
				pointCurrent.model.controlPointNextX = pointCurrent.model.x + deltaX;
				pointCurrent.model.controlPointNextY = pointCurrent.model.y + deltaX * pointCurrent.mK;
			}
		}
	};
	helpers$1.nextItem = function(collection, index, loop) {
		if (loop) {
			return index >= collection.length - 1 ? collection[0] : collection[index + 1];
		}
		return index >= collection.length - 1 ? collection[collection.length - 1] : collection[index + 1];
	};
	helpers$1.previousItem = function(collection, index, loop) {
		if (loop) {
			return index <= 0 ? collection[collection.length - 1] : collection[index - 1];
		}
		return index <= 0 ? collection[0] : collection[index - 1];
	};
	// Implementation of the nice number algorithm used in determining where axis labels will go
	helpers$1.niceNum = function(range, round) {
		var exponent = Math.floor(helpers$1.log10(range));
		var fraction = range / Math.pow(10, exponent);
		var niceFraction;

		if (round) {
			if (fraction < 1.5) {
				niceFraction = 1;
			} else if (fraction < 3) {
				niceFraction = 2;
			} else if (fraction < 7) {
				niceFraction = 5;
			} else {
				niceFraction = 10;
			}
		} else if (fraction <= 1.0) {
			niceFraction = 1;
		} else if (fraction <= 2) {
			niceFraction = 2;
		} else if (fraction <= 5) {
			niceFraction = 5;
		} else {
			niceFraction = 10;
		}

		return niceFraction * Math.pow(10, exponent);
	};
	// Request animation polyfill - https://www.paulirish.com/2011/requestanimationframe-for-smart-animating/
	helpers$1.requestAnimFrame = (function() {
		if (typeof window === 'undefined') {
			return function(callback) {
				callback();
			};
		}
		return window.requestAnimationFrame ||
			window.webkitRequestAnimationFrame ||
			window.mozRequestAnimationFrame ||
			window.oRequestAnimationFrame ||
			window.msRequestAnimationFrame ||
			function(callback) {
				return window.setTimeout(callback, 1000 / 60);
			};
	}());
	// -- DOM methods
	helpers$1.getRelativePosition = function(evt, chart) {
		var mouseX, mouseY;
		var e = evt.originalEvent || evt;
		var canvas = evt.target || evt.srcElement;
		var boundingRect = canvas.getBoundingClientRect();

		var touches = e.touches;
		if (touches && touches.length > 0) {
			mouseX = touches[0].clientX;
			mouseY = touches[0].clientY;

		} else {
			mouseX = e.clientX;
			mouseY = e.clientY;
		}

		// Scale mouse coordinates into canvas coordinates
		// by following the pattern laid out by 'jerryj' in the comments of
		// https://www.html5canvastutorials.com/advanced/html5-canvas-mouse-coordinates/
		var paddingLeft = parseFloat(helpers$1.getStyle(canvas, 'padding-left'));
		var paddingTop = parseFloat(helpers$1.getStyle(canvas, 'padding-top'));
		var paddingRight = parseFloat(helpers$1.getStyle(canvas, 'padding-right'));
		var paddingBottom = parseFloat(helpers$1.getStyle(canvas, 'padding-bottom'));
		var width = boundingRect.right - boundingRect.left - paddingLeft - paddingRight;
		var height = boundingRect.bottom - boundingRect.top - paddingTop - paddingBottom;

		// We divide by the current device pixel ratio, because the canvas is scaled up by that amount in each direction. However
		// the backend model is in unscaled coordinates. Since we are going to deal with our model coordinates, we go back here
		mouseX = Math.round((mouseX - boundingRect.left - paddingLeft) / (width) * canvas.width / chart.currentDevicePixelRatio);
		mouseY = Math.round((mouseY - boundingRect.top - paddingTop) / (height) * canvas.height / chart.currentDevicePixelRatio);

		return {
			x: mouseX,
			y: mouseY
		};

	};

	// Private helper function to convert max-width/max-height values that may be percentages into a number
	function parseMaxStyle(styleValue, node, parentProperty) {
		var valueInPixels;
		if (typeof styleValue === 'string') {
			valueInPixels = parseInt(styleValue, 10);

			if (styleValue.indexOf('%') !== -1) {
				// percentage * size in dimension
				valueInPixels = valueInPixels / 100 * node.parentNode[parentProperty];
			}
		} else {
			valueInPixels = styleValue;
		}

		return valueInPixels;
	}

	/**
	 * Returns if the given value contains an effective constraint.
	 * @private
	 */
	function isConstrainedValue(value) {
		return value !== undefined && value !== null && value !== 'none';
	}

	/**
	 * Returns the max width or height of the given DOM node in a cross-browser compatible fashion
	 * @param {HTMLElement} domNode - the node to check the constraint on
	 * @param {string} maxStyle - the style that defines the maximum for the direction we are using ('max-width' / 'max-height')
	 * @param {string} percentageProperty - property of parent to use when calculating width as a percentage
	 * @see {@link https://www.nathanaeljones.com/blog/2013/reading-max-width-cross-browser}
	 */
	function getConstraintDimension(domNode, maxStyle, percentageProperty) {
		var view = document.defaultView;
		var parentNode = helpers$1._getParentNode(domNode);
		var constrainedNode = view.getComputedStyle(domNode)[maxStyle];
		var constrainedContainer = view.getComputedStyle(parentNode)[maxStyle];
		var hasCNode = isConstrainedValue(constrainedNode);
		var hasCContainer = isConstrainedValue(constrainedContainer);
		var infinity = Number.POSITIVE_INFINITY;

		if (hasCNode || hasCContainer) {
			return Math.min(
				hasCNode ? parseMaxStyle(constrainedNode, domNode, percentageProperty) : infinity,
				hasCContainer ? parseMaxStyle(constrainedContainer, parentNode, percentageProperty) : infinity);
		}

		return 'none';
	}
	// returns Number or undefined if no constraint
	helpers$1.getConstraintWidth = function(domNode) {
		return getConstraintDimension(domNode, 'max-width', 'clientWidth');
	};
	// returns Number or undefined if no constraint
	helpers$1.getConstraintHeight = function(domNode) {
		return getConstraintDimension(domNode, 'max-height', 'clientHeight');
	};
	/**
	 * @private
 	 */
	helpers$1._calculatePadding = function(container, padding, parentDimension) {
		padding = helpers$1.getStyle(container, padding);

		return padding.indexOf('%') > -1 ? parentDimension * parseInt(padding, 10) / 100 : parseInt(padding, 10);
	};
	/**
	 * @private
	 */
	helpers$1._getParentNode = function(domNode) {
		var parent = domNode.parentNode;
		if (parent && parent.toString() === '[object ShadowRoot]') {
			parent = parent.host;
		}
		return parent;
	};
	helpers$1.getMaximumWidth = function(domNode) {
		var container = helpers$1._getParentNode(domNode);
		if (!container) {
			return domNode.clientWidth;
		}

		var clientWidth = container.clientWidth;
		var paddingLeft = helpers$1._calculatePadding(container, 'padding-left', clientWidth);
		var paddingRight = helpers$1._calculatePadding(container, 'padding-right', clientWidth);

		var w = clientWidth - paddingLeft - paddingRight;
		var cw = helpers$1.getConstraintWidth(domNode);
		return isNaN(cw) ? w : Math.min(w, cw);
	};
	helpers$1.getMaximumHeight = function(domNode) {
		var container = helpers$1._getParentNode(domNode);
		if (!container) {
			return domNode.clientHeight;
		}

		var clientHeight = container.clientHeight;
		var paddingTop = helpers$1._calculatePadding(container, 'padding-top', clientHeight);
		var paddingBottom = helpers$1._calculatePadding(container, 'padding-bottom', clientHeight);

		var h = clientHeight - paddingTop - paddingBottom;
		var ch = helpers$1.getConstraintHeight(domNode);
		return isNaN(ch) ? h : Math.min(h, ch);
	};
	helpers$1.getStyle = function(el, property) {
		return el.currentStyle ?
			el.currentStyle[property] :
			document.defaultView.getComputedStyle(el, null).getPropertyValue(property);
	};
	helpers$1.retinaScale = function(chart, forceRatio) {
		var pixelRatio = chart.currentDevicePixelRatio = forceRatio || (typeof window !== 'undefined' && window.devicePixelRatio) || 1;
		if (pixelRatio === 1) {
			return;
		}

		var canvas = chart.canvas;
		var height = chart.height;
		var width = chart.width;

		canvas.height = height * pixelRatio;
		canvas.width = width * pixelRatio;
		chart.ctx.scale(pixelRatio, pixelRatio);

		// If no style has been set on the canvas, the render size is used as display size,
		// making the chart visually bigger, so let's enforce it to the "correct" values.
		// See https://github.com/chartjs/Chart.js/issues/3575
		if (!canvas.style.height && !canvas.style.width) {
			canvas.style.height = height + 'px';
			canvas.style.width = width + 'px';
		}
	};
	// -- Canvas methods
	helpers$1.fontString = function(pixelSize, fontStyle, fontFamily) {
		return fontStyle + ' ' + pixelSize + 'px ' + fontFamily;
	};
	helpers$1.longestText = function(ctx, font, arrayOfThings, cache) {
		cache = cache || {};
		var data = cache.data = cache.data || {};
		var gc = cache.garbageCollect = cache.garbageCollect || [];

		if (cache.font !== font) {
			data = cache.data = {};
			gc = cache.garbageCollect = [];
			cache.font = font;
		}

		ctx.font = font;
		var longest = 0;
		var ilen = arrayOfThings.length;
		var i, j, jlen, thing, nestedThing;
		for (i = 0; i < ilen; i++) {
			thing = arrayOfThings[i];

			// Undefined strings and arrays should not be measured
			if (thing !== undefined && thing !== null && helpers$1.isArray(thing) !== true) {
				longest = helpers$1.measureText(ctx, data, gc, longest, thing);
			} else if (helpers$1.isArray(thing)) {
				// if it is an array lets measure each element
				// to do maybe simplify this function a bit so we can do this more recursively?
				for (j = 0, jlen = thing.length; j < jlen; j++) {
					nestedThing = thing[j];
					// Undefined strings and arrays should not be measured
					if (nestedThing !== undefined && nestedThing !== null && !helpers$1.isArray(nestedThing)) {
						longest = helpers$1.measureText(ctx, data, gc, longest, nestedThing);
					}
				}
			}
		}

		var gcLen = gc.length / 2;
		if (gcLen > arrayOfThings.length) {
			for (i = 0; i < gcLen; i++) {
				delete data[gc[i]];
			}
			gc.splice(0, gcLen);
		}
		return longest;
	};
	helpers$1.measureText = function(ctx, data, gc, longest, string) {
		var textWidth = data[string];
		if (!textWidth) {
			textWidth = data[string] = ctx.measureText(string).width;
			gc.push(string);
		}
		if (textWidth > longest) {
			longest = textWidth;
		}
		return longest;
	};

	/**
	 * @deprecated
	 */
	helpers$1.numberOfLabelLines = function(arrayOfThings) {
		var numberOfLines = 1;
		helpers$1.each(arrayOfThings, function(thing) {
			if (helpers$1.isArray(thing)) {
				if (thing.length > numberOfLines) {
					numberOfLines = thing.length;
				}
			}
		});
		return numberOfLines;
	};

	helpers$1.color = !chartjsColor ?
		function(value) {
			console.error('Color.js not found!');
			return value;
		} :
		function(value) {
			/* global CanvasGradient */
			if (value instanceof CanvasGradient) {
				value = core_defaults.global.defaultColor;
			}

			return chartjsColor(value);
		};

	helpers$1.getHoverColor = function(colorValue) {
		/* global CanvasPattern */
		return (colorValue instanceof CanvasPattern || colorValue instanceof CanvasGradient) ?
			colorValue :
			helpers$1.color(colorValue).saturate(0.5).darken(0.1).rgbString();
	};
};

function abstract() {
	throw new Error(
		'This method is not implemented: either no adapter can ' +
		'be found or an incomplete integration was provided.'
	);
}

/**
 * Date adapter (current used by the time scale)
 * @namespace Chart._adapters._date
 * @memberof Chart._adapters
 * @private
 */

/**
 * Currently supported unit string values.
 * @typedef {('millisecond'|'second'|'minute'|'hour'|'day'|'week'|'month'|'quarter'|'year')}
 * @memberof Chart._adapters._date
 * @name Unit
 */

/**
 * @class
 */
function DateAdapter(options) {
	this.options = options || {};
}

helpers$1.extend(DateAdapter.prototype, /** @lends DateAdapter */ {
	/**
	 * Returns a map of time formats for the supported formatting units defined
	 * in Unit as well as 'datetime' representing a detailed date/time string.
	 * @returns {{string: string}}
	 */
	formats: abstract,

	/**
	 * Parses the given `value` and return the associated timestamp.
	 * @param {any} value - the value to parse (usually comes from the data)
	 * @param {string} [format] - the expected data format
	 * @returns {(number|null)}
	 * @function
	 */
	parse: abstract,

	/**
	 * Returns the formatted date in the specified `format` for a given `timestamp`.
	 * @param {number} timestamp - the timestamp to format
	 * @param {string} format - the date/time token
	 * @return {string}
	 * @function
	 */
	format: abstract,

	/**
	 * Adds the specified `amount` of `unit` to the given `timestamp`.
	 * @param {number} timestamp - the input timestamp
	 * @param {number} amount - the amount to add
	 * @param {Unit} unit - the unit as string
	 * @return {number}
	 * @function
	 */
	add: abstract,

	/**
	 * Returns the number of `unit` between the given timestamps.
	 * @param {number} max - the input timestamp (reference)
	 * @param {number} min - the timestamp to substract
	 * @param {Unit} unit - the unit as string
	 * @return {number}
	 * @function
	 */
	diff: abstract,

	/**
	 * Returns start of `unit` for the given `timestamp`.
	 * @param {number} timestamp - the input timestamp
	 * @param {Unit} unit - the unit as string
	 * @param {number} [weekday] - the ISO day of the week with 1 being Monday
	 * and 7 being Sunday (only needed if param *unit* is `isoWeek`).
	 * @function
	 */
	startOf: abstract,

	/**
	 * Returns end of `unit` for the given `timestamp`.
	 * @param {number} timestamp - the input timestamp
	 * @param {Unit} unit - the unit as string
	 * @function
	 */
	endOf: abstract,

	// DEPRECATIONS

	/**
	 * Provided for backward compatibility for scale.getValueForPixel(),
	 * this method should be overridden only by the moment adapter.
	 * @deprecated since version 2.8.0
	 * @todo remove at version 3
	 * @private
	 */
	_create: function(value) {
		return value;
	}
});

DateAdapter.override = function(members) {
	helpers$1.extend(DateAdapter.prototype, members);
};

var _date = DateAdapter;

var core_adapters = {
	_date: _date
};

/**
 * Namespace to hold static tick generation functions
 * @namespace Chart.Ticks
 */
var core_ticks = {
	/**
	 * Namespace to hold formatters for different types of ticks
	 * @namespace Chart.Ticks.formatters
	 */
	formatters: {
		/**
		 * Formatter for value labels
		 * @method Chart.Ticks.formatters.values
		 * @param value the value to display
		 * @return {string|string[]} the label to display
		 */
		values: function(value) {
			return helpers$1.isArray(value) ? value : '' + value;
		},

		/**
		 * Formatter for linear numeric ticks
		 * @method Chart.Ticks.formatters.linear
		 * @param tickValue {number} the value to be formatted
		 * @param index {number} the position of the tickValue parameter in the ticks array
		 * @param ticks {number[]} the list of ticks being converted
		 * @return {string} string representation of the tickValue parameter
		 */
		linear: function(tickValue, index, ticks) {
			// If we have lots of ticks, don't use the ones
			var delta = ticks.length > 3 ? ticks[2] - ticks[1] : ticks[1] - ticks[0];

			// If we have a number like 2.5 as the delta, figure out how many decimal places we need
			if (Math.abs(delta) > 1) {
				if (tickValue !== Math.floor(tickValue)) {
					// not an integer
					delta = tickValue - Math.floor(tickValue);
				}
			}

			var logDelta = helpers$1.log10(Math.abs(delta));
			var tickString = '';

			if (tickValue !== 0) {
				var maxTick = Math.max(Math.abs(ticks[0]), Math.abs(ticks[ticks.length - 1]));
				if (maxTick < 1e-4) { // all ticks are small numbers; use scientific notation
					var logTick = helpers$1.log10(Math.abs(tickValue));
					var numExponential = Math.floor(logTick) - Math.floor(logDelta);
					numExponential = Math.max(Math.min(numExponential, 20), 0);
					tickString = tickValue.toExponential(numExponential);
				} else {
					var numDecimal = -1 * Math.floor(logDelta);
					numDecimal = Math.max(Math.min(numDecimal, 20), 0); // toFixed has a max of 20 decimal places
					tickString = tickValue.toFixed(numDecimal);
				}
			} else {
				tickString = '0'; // never show decimal places for 0
			}

			return tickString;
		},

		logarithmic: function(tickValue, index, ticks) {
			var remain = tickValue / (Math.pow(10, Math.floor(helpers$1.log10(tickValue))));

			if (tickValue === 0) {
				return '0';
			} else if (remain === 1 || remain === 2 || remain === 5 || index === 0 || index === ticks.length - 1) {
				return tickValue.toExponential();
			}
			return '';
		}
	}
};

var isArray = helpers$1.isArray;
var isNullOrUndef = helpers$1.isNullOrUndef;
var valueOrDefault$a = helpers$1.valueOrDefault;
var valueAtIndexOrDefault = helpers$1.valueAtIndexOrDefault;

core_defaults._set('scale', {
	display: true,
	position: 'left',
	offset: false,

	// grid line settings
	gridLines: {
		display: true,
		color: 'rgba(0,0,0,0.1)',
		lineWidth: 1,
		drawBorder: true,
		drawOnChartArea: true,
		drawTicks: true,
		tickMarkLength: 10,
		zeroLineWidth: 1,
		zeroLineColor: 'rgba(0,0,0,0.25)',
		zeroLineBorderDash: [],
		zeroLineBorderDashOffset: 0.0,
		offsetGridLines: false,
		borderDash: [],
		borderDashOffset: 0.0
	},

	// scale label
	scaleLabel: {
		// display property
		display: false,

		// actual label
		labelString: '',

		// top/bottom padding
		padding: {
			top: 4,
			bottom: 4
		}
	},

	// label settings
	ticks: {
		beginAtZero: false,
		minRotation: 0,
		maxRotation: 50,
		mirror: false,
		padding: 0,
		reverse: false,
		display: true,
		autoSkip: true,
		autoSkipPadding: 0,
		labelOffset: 0,
		// We pass through arrays to be rendered as multiline labels, we convert Others to strings here.
		callback: core_ticks.formatters.values,
		minor: {},
		major: {}
	}
});

/** Returns a new array containing numItems from arr */
function sample(arr, numItems) {
	var result = [];
	var increment = arr.length / numItems;
	var i = 0;
	var len = arr.length;

	for (; i < len; i += increment) {
		result.push(arr[Math.floor(i)]);
	}
	return result;
}

function getPixelForGridLine(scale, index, offsetGridLines) {
	var length = scale.getTicks().length;
	var validIndex = Math.min(index, length - 1);
	var lineValue = scale.getPixelForTick(validIndex);
	var start = scale._startPixel;
	var end = scale._endPixel;
	var epsilon = 1e-6; // 1e-6 is margin in pixels for accumulated error.
	var offset;

	if (offsetGridLines) {
		if (length === 1) {
			offset = Math.max(lineValue - start, end - lineValue);
		} else if (index === 0) {
			offset = (scale.getPixelForTick(1) - lineValue) / 2;
		} else {
			offset = (lineValue - scale.getPixelForTick(validIndex - 1)) / 2;
		}
		lineValue += validIndex < index ? offset : -offset;

		// Return undefined if the pixel is out of the range
		if (lineValue < start - epsilon || lineValue > end + epsilon) {
			return;
		}
	}
	return lineValue;
}

function garbageCollect(caches, length) {
	helpers$1.each(caches, function(cache) {
		var gc = cache.gc;
		var gcLen = gc.length / 2;
		var i;
		if (gcLen > length) {
			for (i = 0; i < gcLen; ++i) {
				delete cache.data[gc[i]];
			}
			gc.splice(0, gcLen);
		}
	});
}

/**
 * Returns {width, height, offset} objects for the first, last, widest, highest tick
 * labels where offset indicates the anchor point offset from the top in pixels.
 */
function computeLabelSizes(ctx, tickFonts, ticks, caches) {
	var length = ticks.length;
	var widths = [];
	var heights = [];
	var offsets = [];
	var widestLabelSize = 0;
	var highestLabelSize = 0;
	var i, j, jlen, label, tickFont, fontString, cache, lineHeight, width, height, nestedLabel, widest, highest;

	for (i = 0; i < length; ++i) {
		label = ticks[i].label;
		tickFont = ticks[i].major ? tickFonts.major : tickFonts.minor;
		ctx.font = fontString = tickFont.string;
		cache = caches[fontString] = caches[fontString] || {data: {}, gc: []};
		lineHeight = tickFont.lineHeight;
		width = height = 0;
		// Undefined labels and arrays should not be measured
		if (!isNullOrUndef(label) && !isArray(label)) {
			width = helpers$1.measureText(ctx, cache.data, cache.gc, width, label);
			height = lineHeight;
		} else if (isArray(label)) {
			// if it is an array let's measure each element
			for (j = 0, jlen = label.length; j < jlen; ++j) {
				nestedLabel = label[j];
				// Undefined labels and arrays should not be measured
				if (!isNullOrUndef(nestedLabel) && !isArray(nestedLabel)) {
					width = helpers$1.measureText(ctx, cache.data, cache.gc, width, nestedLabel);
					height += lineHeight;
				}
			}
		}
		widths.push(width);
		heights.push(height);
		offsets.push(lineHeight / 2);
		widestLabelSize = Math.max(width, widestLabelSize);
		highestLabelSize = Math.max(height, highestLabelSize);
	}
	garbageCollect(caches, length);

	widest = widths.indexOf(widestLabelSize);
	highest = heights.indexOf(highestLabelSize);

	function valueAt(idx) {
		return {
			width: widths[idx] || 0,
			height: heights[idx] || 0,
			offset: offsets[idx] || 0
		};
	}

	return {
		first: valueAt(0),
		last: valueAt(length - 1),
		widest: valueAt(widest),
		highest: valueAt(highest)
	};
}

function getTickMarkLength(options) {
	return options.drawTicks ? options.tickMarkLength : 0;
}

function getScaleLabelHeight(options) {
	var font, padding;

	if (!options.display) {
		return 0;
	}

	font = helpers$1.options._parseFont(options);
	padding = helpers$1.options.toPadding(options.padding);

	return font.lineHeight + padding.height;
}

function parseFontOptions(options, nestedOpts) {
	return helpers$1.extend(helpers$1.options._parseFont({
		fontFamily: valueOrDefault$a(nestedOpts.fontFamily, options.fontFamily),
		fontSize: valueOrDefault$a(nestedOpts.fontSize, options.fontSize),
		fontStyle: valueOrDefault$a(nestedOpts.fontStyle, options.fontStyle),
		lineHeight: valueOrDefault$a(nestedOpts.lineHeight, options.lineHeight)
	}), {
		color: helpers$1.options.resolve([nestedOpts.fontColor, options.fontColor, core_defaults.global.defaultFontColor])
	});
}

function parseTickFontOptions(options) {
	var minor = parseFontOptions(options, options.minor);
	var major = options.major.enabled ? parseFontOptions(options, options.major) : minor;

	return {minor: minor, major: major};
}

function nonSkipped(ticksToFilter) {
	var filtered = [];
	var item, index, len;
	for (index = 0, len = ticksToFilter.length; index < len; ++index) {
		item = ticksToFilter[index];
		if (typeof item._index !== 'undefined') {
			filtered.push(item);
		}
	}
	return filtered;
}

function getEvenSpacing(arr) {
	var len = arr.length;
	var i, diff;

	if (len < 2) {
		return false;
	}

	for (diff = arr[0], i = 1; i < len; ++i) {
		if (arr[i] - arr[i - 1] !== diff) {
			return false;
		}
	}
	return diff;
}

function calculateSpacing(majorIndices, ticks, axisLength, ticksLimit) {
	var evenMajorSpacing = getEvenSpacing(majorIndices);
	var spacing = (ticks.length - 1) / ticksLimit;
	var factors, factor, i, ilen;

	// If the major ticks are evenly spaced apart, place the minor ticks
	// so that they divide the major ticks into even chunks
	if (!evenMajorSpacing) {
		return Math.max(spacing, 1);
	}

	factors = helpers$1.math._factorize(evenMajorSpacing);
	for (i = 0, ilen = factors.length - 1; i < ilen; i++) {
		factor = factors[i];
		if (factor > spacing) {
			return factor;
		}
	}
	return Math.max(spacing, 1);
}

function getMajorIndices(ticks) {
	var result = [];
	var i, ilen;
	for (i = 0, ilen = ticks.length; i < ilen; i++) {
		if (ticks[i].major) {
			result.push(i);
		}
	}
	return result;
}

function skipMajors(ticks, majorIndices, spacing) {
	var count = 0;
	var next = majorIndices[0];
	var i, tick;

	spacing = Math.ceil(spacing);
	for (i = 0; i < ticks.length; i++) {
		tick = ticks[i];
		if (i === next) {
			tick._index = i;
			count++;
			next = majorIndices[count * spacing];
		} else {
			delete tick.label;
		}
	}
}

function skip(ticks, spacing, majorStart, majorEnd) {
	var start = valueOrDefault$a(majorStart, 0);
	var end = Math.min(valueOrDefault$a(majorEnd, ticks.length), ticks.length);
	var count = 0;
	var length, i, tick, next;

	spacing = Math.ceil(spacing);
	if (majorEnd) {
		length = majorEnd - majorStart;
		spacing = length / Math.floor(length / spacing);
	}

	next = start;

	while (next < 0) {
		count++;
		next = Math.round(start + count * spacing);
	}

	for (i = Math.max(start, 0); i < end; i++) {
		tick = ticks[i];
		if (i === next) {
			tick._index = i;
			count++;
			next = Math.round(start + count * spacing);
		} else {
			delete tick.label;
		}
	}
}

var Scale = core_element.extend({

	zeroLineIndex: 0,

	/**
	 * Get the padding needed for the scale
	 * @method getPadding
	 * @private
	 * @returns {Padding} the necessary padding
	 */
	getPadding: function() {
		var me = this;
		return {
			left: me.paddingLeft || 0,
			top: me.paddingTop || 0,
			right: me.paddingRight || 0,
			bottom: me.paddingBottom || 0
		};
	},

	/**
	 * Returns the scale tick objects ({label, major})
	 * @since 2.7
	 */
	getTicks: function() {
		return this._ticks;
	},

	/**
	* @private
	*/
	_getLabels: function() {
		var data = this.chart.data;
		return this.options.labels || (this.isHorizontal() ? data.xLabels : data.yLabels) || data.labels || [];
	},

	// These methods are ordered by lifecyle. Utilities then follow.
	// Any function defined here is inherited by all scale types.
	// Any function can be extended by the scale type

	/**
	 * Provided for backward compatibility, not available anymore
	 * @function Chart.Scale.mergeTicksOptions
	 * @deprecated since version 2.8.0
	 * @todo remove at version 3
	 */
	mergeTicksOptions: function() {
		// noop
	},

	beforeUpdate: function() {
		helpers$1.callback(this.options.beforeUpdate, [this]);
	},

	/**
	 * @param {number} maxWidth - the max width in pixels
	 * @param {number} maxHeight - the max height in pixels
	 * @param {object} margins - the space between the edge of the other scales and edge of the chart
	 *   This space comes from two sources:
	 *     - padding - space that's required to show the labels at the edges of the scale
	 *     - thickness of scales or legends in another orientation
	 */
	update: function(maxWidth, maxHeight, margins) {
		var me = this;
		var tickOpts = me.options.ticks;
		var sampleSize = tickOpts.sampleSize;
		var i, ilen, labels, ticks, samplingEnabled;

		// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
		me.beforeUpdate();

		// Absorb the master measurements
		me.maxWidth = maxWidth;
		me.maxHeight = maxHeight;
		me.margins = helpers$1.extend({
			left: 0,
			right: 0,
			top: 0,
			bottom: 0
		}, margins);

		me._ticks = null;
		me.ticks = null;
		me._labelSizes = null;
		me._maxLabelLines = 0;
		me.longestLabelWidth = 0;
		me.longestTextCache = me.longestTextCache || {};
		me._gridLineItems = null;
		me._labelItems = null;

		// Dimensions
		me.beforeSetDimensions();
		me.setDimensions();
		me.afterSetDimensions();

		// Data min/max
		me.beforeDataLimits();
		me.determineDataLimits();
		me.afterDataLimits();

		// Ticks - `this.ticks` is now DEPRECATED!
		// Internal ticks are now stored as objects in the PRIVATE `this._ticks` member
		// and must not be accessed directly from outside this class. `this.ticks` being
		// around for long time and not marked as private, we can't change its structure
		// without unexpected breaking changes. If you need to access the scale ticks,
		// use scale.getTicks() instead.

		me.beforeBuildTicks();

		// New implementations should return an array of objects but for BACKWARD COMPAT,
		// we still support no return (`this.ticks` internally set by calling this method).
		ticks = me.buildTicks() || [];

		// Allow modification of ticks in callback.
		ticks = me.afterBuildTicks(ticks) || ticks;

		// Ensure ticks contains ticks in new tick format
		if ((!ticks || !ticks.length) && me.ticks) {
			ticks = [];
			for (i = 0, ilen = me.ticks.length; i < ilen; ++i) {
				ticks.push({
					value: me.ticks[i],
					major: false
				});
			}
		}

		me._ticks = ticks;

		// Compute tick rotation and fit using a sampled subset of labels
		// We generally don't need to compute the size of every single label for determining scale size
		samplingEnabled = sampleSize < ticks.length;
		labels = me._convertTicksToLabels(samplingEnabled ? sample(ticks, sampleSize) : ticks);

		// _configure is called twice, once here, once from core.controller.updateLayout.
		// Here we haven't been positioned yet, but dimensions are correct.
		// Variables set in _configure are needed for calculateTickRotation, and
		// it's ok that coordinates are not correct there, only dimensions matter.
		me._configure();

		// Tick Rotation
		me.beforeCalculateTickRotation();
		me.calculateTickRotation();
		me.afterCalculateTickRotation();

		me.beforeFit();
		me.fit();
		me.afterFit();

		// Auto-skip
		me._ticksToDraw = tickOpts.display && (tickOpts.autoSkip || tickOpts.source === 'auto') ? me._autoSkip(ticks) : ticks;

		if (samplingEnabled) {
			// Generate labels using all non-skipped ticks
			labels = me._convertTicksToLabels(me._ticksToDraw);
		}

		me.ticks = labels;   // BACKWARD COMPATIBILITY

		// IMPORTANT: after this point, we consider that `this.ticks` will NEVER change!

		me.afterUpdate();

		// TODO(v3): remove minSize as a public property and return value from all layout boxes. It is unused
		// make maxWidth and maxHeight private
		return me.minSize;
	},

	/**
	 * @private
	 */
	_configure: function() {
		var me = this;
		var reversePixels = me.options.ticks.reverse;
		var startPixel, endPixel;

		if (me.isHorizontal()) {
			startPixel = me.left;
			endPixel = me.right;
		} else {
			startPixel = me.top;
			endPixel = me.bottom;
			// by default vertical scales are from bottom to top, so pixels are reversed
			reversePixels = !reversePixels;
		}
		me._startPixel = startPixel;
		me._endPixel = endPixel;
		me._reversePixels = reversePixels;
		me._length = endPixel - startPixel;
	},

	afterUpdate: function() {
		helpers$1.callback(this.options.afterUpdate, [this]);
	},

	//

	beforeSetDimensions: function() {
		helpers$1.callback(this.options.beforeSetDimensions, [this]);
	},
	setDimensions: function() {
		var me = this;
		// Set the unconstrained dimension before label rotation
		if (me.isHorizontal()) {
			// Reset position before calculating rotation
			me.width = me.maxWidth;
			me.left = 0;
			me.right = me.width;
		} else {
			me.height = me.maxHeight;

			// Reset position before calculating rotation
			me.top = 0;
			me.bottom = me.height;
		}

		// Reset padding
		me.paddingLeft = 0;
		me.paddingTop = 0;
		me.paddingRight = 0;
		me.paddingBottom = 0;
	},
	afterSetDimensions: function() {
		helpers$1.callback(this.options.afterSetDimensions, [this]);
	},

	// Data limits
	beforeDataLimits: function() {
		helpers$1.callback(this.options.beforeDataLimits, [this]);
	},
	determineDataLimits: helpers$1.noop,
	afterDataLimits: function() {
		helpers$1.callback(this.options.afterDataLimits, [this]);
	},

	//
	beforeBuildTicks: function() {
		helpers$1.callback(this.options.beforeBuildTicks, [this]);
	},
	buildTicks: helpers$1.noop,
	afterBuildTicks: function(ticks) {
		var me = this;
		// ticks is empty for old axis implementations here
		if (isArray(ticks) && ticks.length) {
			return helpers$1.callback(me.options.afterBuildTicks, [me, ticks]);
		}
		// Support old implementations (that modified `this.ticks` directly in buildTicks)
		me.ticks = helpers$1.callback(me.options.afterBuildTicks, [me, me.ticks]) || me.ticks;
		return ticks;
	},

	beforeTickToLabelConversion: function() {
		helpers$1.callback(this.options.beforeTickToLabelConversion, [this]);
	},
	convertTicksToLabels: function() {
		var me = this;
		// Convert ticks to strings
		var tickOpts = me.options.ticks;
		me.ticks = me.ticks.map(tickOpts.userCallback || tickOpts.callback, this);
	},
	afterTickToLabelConversion: function() {
		helpers$1.callback(this.options.afterTickToLabelConversion, [this]);
	},

	//

	beforeCalculateTickRotation: function() {
		helpers$1.callback(this.options.beforeCalculateTickRotation, [this]);
	},
	calculateTickRotation: function() {
		var me = this;
		var options = me.options;
		var tickOpts = options.ticks;
		var numTicks = me.getTicks().length;
		var minRotation = tickOpts.minRotation || 0;
		var maxRotation = tickOpts.maxRotation;
		var labelRotation = minRotation;
		var labelSizes, maxLabelWidth, maxLabelHeight, maxWidth, tickWidth, maxHeight, maxLabelDiagonal;

		if (!me._isVisible() || !tickOpts.display || minRotation >= maxRotation || numTicks <= 1 || !me.isHorizontal()) {
			me.labelRotation = minRotation;
			return;
		}

		labelSizes = me._getLabelSizes();
		maxLabelWidth = labelSizes.widest.width;
		maxLabelHeight = labelSizes.highest.height - labelSizes.highest.offset;

		// Estimate the width of each grid based on the canvas width, the maximum
		// label width and the number of tick intervals
		maxWidth = Math.min(me.maxWidth, me.chart.width - maxLabelWidth);
		tickWidth = options.offset ? me.maxWidth / numTicks : maxWidth / (numTicks - 1);

		// Allow 3 pixels x2 padding either side for label readability
		if (maxLabelWidth + 6 > tickWidth) {
			tickWidth = maxWidth / (numTicks - (options.offset ? 0.5 : 1));
			maxHeight = me.maxHeight - getTickMarkLength(options.gridLines)
				- tickOpts.padding - getScaleLabelHeight(options.scaleLabel);
			maxLabelDiagonal = Math.sqrt(maxLabelWidth * maxLabelWidth + maxLabelHeight * maxLabelHeight);
			labelRotation = helpers$1.toDegrees(Math.min(
				Math.asin(Math.min((labelSizes.highest.height + 6) / tickWidth, 1)),
				Math.asin(Math.min(maxHeight / maxLabelDiagonal, 1)) - Math.asin(maxLabelHeight / maxLabelDiagonal)
			));
			labelRotation = Math.max(minRotation, Math.min(maxRotation, labelRotation));
		}

		me.labelRotation = labelRotation;
	},
	afterCalculateTickRotation: function() {
		helpers$1.callback(this.options.afterCalculateTickRotation, [this]);
	},

	//

	beforeFit: function() {
		helpers$1.callback(this.options.beforeFit, [this]);
	},
	fit: function() {
		var me = this;
		// Reset
		var minSize = me.minSize = {
			width: 0,
			height: 0
		};

		var chart = me.chart;
		var opts = me.options;
		var tickOpts = opts.ticks;
		var scaleLabelOpts = opts.scaleLabel;
		var gridLineOpts = opts.gridLines;
		var display = me._isVisible();
		var isBottom = opts.position === 'bottom';
		var isHorizontal = me.isHorizontal();

		// Width
		if (isHorizontal) {
			minSize.width = me.maxWidth;
		} else if (display) {
			minSize.width = getTickMarkLength(gridLineOpts) + getScaleLabelHeight(scaleLabelOpts);
		}

		// height
		if (!isHorizontal) {
			minSize.height = me.maxHeight; // fill all the height
		} else if (display) {
			minSize.height = getTickMarkLength(gridLineOpts) + getScaleLabelHeight(scaleLabelOpts);
		}

		// Don't bother fitting the ticks if we are not showing the labels
		if (tickOpts.display && display) {
			var tickFonts = parseTickFontOptions(tickOpts);
			var labelSizes = me._getLabelSizes();
			var firstLabelSize = labelSizes.first;
			var lastLabelSize = labelSizes.last;
			var widestLabelSize = labelSizes.widest;
			var highestLabelSize = labelSizes.highest;
			var lineSpace = tickFonts.minor.lineHeight * 0.4;
			var tickPadding = tickOpts.padding;

			if (isHorizontal) {
				// A horizontal axis is more constrained by the height.
				var isRotated = me.labelRotation !== 0;
				var angleRadians = helpers$1.toRadians(me.labelRotation);
				var cosRotation = Math.cos(angleRadians);
				var sinRotation = Math.sin(angleRadians);

				var labelHeight = sinRotation * widestLabelSize.width
					+ cosRotation * (highestLabelSize.height - (isRotated ? highestLabelSize.offset : 0))
					+ (isRotated ? 0 : lineSpace); // padding

				minSize.height = Math.min(me.maxHeight, minSize.height + labelHeight + tickPadding);

				var offsetLeft = me.getPixelForTick(0) - me.left;
				var offsetRight = me.right - me.getPixelForTick(me.getTicks().length - 1);
				var paddingLeft, paddingRight;

				// Ensure that our ticks are always inside the canvas. When rotated, ticks are right aligned
				// which means that the right padding is dominated by the font height
				if (isRotated) {
					paddingLeft = isBottom ?
						cosRotation * firstLabelSize.width + sinRotation * firstLabelSize.offset :
						sinRotation * (firstLabelSize.height - firstLabelSize.offset);
					paddingRight = isBottom ?
						sinRotation * (lastLabelSize.height - lastLabelSize.offset) :
						cosRotation * lastLabelSize.width + sinRotation * lastLabelSize.offset;
				} else {
					paddingLeft = firstLabelSize.width / 2;
					paddingRight = lastLabelSize.width / 2;
				}

				// Adjust padding taking into account changes in offsets
				// and add 3 px to move away from canvas edges
				me.paddingLeft = Math.max((paddingLeft - offsetLeft) * me.width / (me.width - offsetLeft), 0) + 3;
				me.paddingRight = Math.max((paddingRight - offsetRight) * me.width / (me.width - offsetRight), 0) + 3;
			} else {
				// A vertical axis is more constrained by the width. Labels are the
				// dominant factor here, so get that length first and account for padding
				var labelWidth = tickOpts.mirror ? 0 :
					// use lineSpace for consistency with horizontal axis
					// tickPadding is not implemented for horizontal
					widestLabelSize.width + tickPadding + lineSpace;

				minSize.width = Math.min(me.maxWidth, minSize.width + labelWidth);

				me.paddingTop = firstLabelSize.height / 2;
				me.paddingBottom = lastLabelSize.height / 2;
			}
		}

		me.handleMargins();

		if (isHorizontal) {
			me.width = me._length = chart.width - me.margins.left - me.margins.right;
			me.height = minSize.height;
		} else {
			me.width = minSize.width;
			me.height = me._length = chart.height - me.margins.top - me.margins.bottom;
		}
	},

	/**
	 * Handle margins and padding interactions
	 * @private
	 */
	handleMargins: function() {
		var me = this;
		if (me.margins) {
			me.margins.left = Math.max(me.paddingLeft, me.margins.left);
			me.margins.top = Math.max(me.paddingTop, me.margins.top);
			me.margins.right = Math.max(me.paddingRight, me.margins.right);
			me.margins.bottom = Math.max(me.paddingBottom, me.margins.bottom);
		}
	},

	afterFit: function() {
		helpers$1.callback(this.options.afterFit, [this]);
	},

	// Shared Methods
	isHorizontal: function() {
		var pos = this.options.position;
		return pos === 'top' || pos === 'bottom';
	},
	isFullWidth: function() {
		return this.options.fullWidth;
	},

	// Get the correct value. NaN bad inputs, If the value type is object get the x or y based on whether we are horizontal or not
	getRightValue: function(rawValue) {
		// Null and undefined values first
		if (isNullOrUndef(rawValue)) {
			return NaN;
		}
		// isNaN(object) returns true, so make sure NaN is checking for a number; Discard Infinite values
		if ((typeof rawValue === 'number' || rawValue instanceof Number) && !isFinite(rawValue)) {
			return NaN;
		}

		// If it is in fact an object, dive in one more level
		if (rawValue) {
			if (this.isHorizontal()) {
				if (rawValue.x !== undefined) {
					return this.getRightValue(rawValue.x);
				}
			} else if (rawValue.y !== undefined) {
				return this.getRightValue(rawValue.y);
			}
		}

		// Value is good, return it
		return rawValue;
	},

	_convertTicksToLabels: function(ticks) {
		var me = this;
		var labels, i, ilen;

		me.ticks = ticks.map(function(tick) {
			return tick.value;
		});

		me.beforeTickToLabelConversion();

		// New implementations should return the formatted tick labels but for BACKWARD
		// COMPAT, we still support no return (`this.ticks` internally changed by calling
		// this method and supposed to contain only string values).
		labels = me.convertTicksToLabels(ticks) || me.ticks;

		me.afterTickToLabelConversion();

		// BACKWARD COMPAT: synchronize `_ticks` with labels (so potentially `this.ticks`)
		for (i = 0, ilen = ticks.length; i < ilen; ++i) {
			ticks[i].label = labels[i];
		}

		return labels;
	},

	/**
	 * @private
	 */
	_getLabelSizes: function() {
		var me = this;
		var labelSizes = me._labelSizes;

		if (!labelSizes) {
			me._labelSizes = labelSizes = computeLabelSizes(me.ctx, parseTickFontOptions(me.options.ticks), me.getTicks(), me.longestTextCache);
			me.longestLabelWidth = labelSizes.widest.width;
		}

		return labelSizes;
	},

	/**
	 * @private
	 */
	_parseValue: function(value) {
		var start, end, min, max;

		if (isArray(value)) {
			start = +this.getRightValue(value[0]);
			end = +this.getRightValue(value[1]);
			min = Math.min(start, end);
			max = Math.max(start, end);
		} else {
			value = +this.getRightValue(value);
			start = undefined;
			end = value;
			min = value;
			max = value;
		}

		return {
			min: min,
			max: max,
			start: start,
			end: end
		};
	},

	/**
	* @private
	*/
	_getScaleLabel: function(rawValue) {
		var v = this._parseValue(rawValue);
		if (v.start !== undefined) {
			return '[' + v.start + ', ' + v.end + ']';
		}

		return +this.getRightValue(rawValue);
	},

	/**
	 * Used to get the value to display in the tooltip for the data at the given index
	 * @param index
	 * @param datasetIndex
	 */
	getLabelForIndex: helpers$1.noop,

	/**
	 * Returns the location of the given data point. Value can either be an index or a numerical value
	 * The coordinate (0, 0) is at the upper-left corner of the canvas
	 * @param value
	 * @param index
	 * @param datasetIndex
	 */
	getPixelForValue: helpers$1.noop,

	/**
	 * Used to get the data value from a given pixel. This is the inverse of getPixelForValue
	 * The coordinate (0, 0) is at the upper-left corner of the canvas
	 * @param pixel
	 */
	getValueForPixel: helpers$1.noop,

	/**
	 * Returns the location of the tick at the given index
	 * The coordinate (0, 0) is at the upper-left corner of the canvas
	 */
	getPixelForTick: function(index) {
		var me = this;
		var offset = me.options.offset;
		var numTicks = me._ticks.length;
		var tickWidth = 1 / Math.max(numTicks - (offset ? 0 : 1), 1);

		return index < 0 || index > numTicks - 1
			? null
			: me.getPixelForDecimal(index * tickWidth + (offset ? tickWidth / 2 : 0));
	},

	/**
	 * Utility for getting the pixel location of a percentage of scale
	 * The coordinate (0, 0) is at the upper-left corner of the canvas
	 */
	getPixelForDecimal: function(decimal) {
		var me = this;

		if (me._reversePixels) {
			decimal = 1 - decimal;
		}

		return me._startPixel + decimal * me._length;
	},

	getDecimalForPixel: function(pixel) {
		var decimal = (pixel - this._startPixel) / this._length;
		return this._reversePixels ? 1 - decimal : decimal;
	},

	/**
	 * Returns the pixel for the minimum chart value
	 * The coordinate (0, 0) is at the upper-left corner of the canvas
	 */
	getBasePixel: function() {
		return this.getPixelForValue(this.getBaseValue());
	},

	getBaseValue: function() {
		var me = this;
		var min = me.min;
		var max = me.max;

		return me.beginAtZero ? 0 :
			min < 0 && max < 0 ? max :
			min > 0 && max > 0 ? min :
			0;
	},

	/**
	 * Returns a subset of ticks to be plotted to avoid overlapping labels.
	 * @private
	 */
	_autoSkip: function(ticks) {
		var me = this;
		var tickOpts = me.options.ticks;
		var axisLength = me._length;
		var ticksLimit = tickOpts.maxTicksLimit || axisLength / me._tickSize() + 1;
		var majorIndices = tickOpts.major.enabled ? getMajorIndices(ticks) : [];
		var numMajorIndices = majorIndices.length;
		var first = majorIndices[0];
		var last = majorIndices[numMajorIndices - 1];
		var i, ilen, spacing, avgMajorSpacing;

		// If there are too many major ticks to display them all
		if (numMajorIndices > ticksLimit) {
			skipMajors(ticks, majorIndices, numMajorIndices / ticksLimit);
			return nonSkipped(ticks);
		}

		spacing = calculateSpacing(majorIndices, ticks, axisLength, ticksLimit);

		if (numMajorIndices > 0) {
			for (i = 0, ilen = numMajorIndices - 1; i < ilen; i++) {
				skip(ticks, spacing, majorIndices[i], majorIndices[i + 1]);
			}
			avgMajorSpacing = numMajorIndices > 1 ? (last - first) / (numMajorIndices - 1) : null;
			skip(ticks, spacing, helpers$1.isNullOrUndef(avgMajorSpacing) ? 0 : first - avgMajorSpacing, first);
			skip(ticks, spacing, last, helpers$1.isNullOrUndef(avgMajorSpacing) ? ticks.length : last + avgMajorSpacing);
			return nonSkipped(ticks);
		}
		skip(ticks, spacing);
		return nonSkipped(ticks);
	},

	/**
	 * @private
	 */
	_tickSize: function() {
		var me = this;
		var optionTicks = me.options.ticks;

		// Calculate space needed by label in axis direction.
		var rot = helpers$1.toRadians(me.labelRotation);
		var cos = Math.abs(Math.cos(rot));
		var sin = Math.abs(Math.sin(rot));

		var labelSizes = me._getLabelSizes();
		var padding = optionTicks.autoSkipPadding || 0;
		var w = labelSizes ? labelSizes.widest.width + padding : 0;
		var h = labelSizes ? labelSizes.highest.height + padding : 0;

		// Calculate space needed for 1 tick in axis direction.
		return me.isHorizontal()
			? h * cos > w * sin ? w / cos : h / sin
			: h * sin < w * cos ? h / cos : w / sin;
	},

	/**
	 * @private
	 */
	_isVisible: function() {
		var me = this;
		var chart = me.chart;
		var display = me.options.display;
		var i, ilen, meta;

		if (display !== 'auto') {
			return !!display;
		}

		// When 'auto', the scale is visible if at least one associated dataset is visible.
		for (i = 0, ilen = chart.data.datasets.length; i < ilen; ++i) {
			if (chart.isDatasetVisible(i)) {
				meta = chart.getDatasetMeta(i);
				if (meta.xAxisID === me.id || meta.yAxisID === me.id) {
					return true;
				}
			}
		}

		return false;
	},

	/**
	 * @private
	 */
	_computeGridLineItems: function(chartArea) {
		var me = this;
		var chart = me.chart;
		var options = me.options;
		var gridLines = options.gridLines;
		var position = options.position;
		var offsetGridLines = gridLines.offsetGridLines;
		var isHorizontal = me.isHorizontal();
		var ticks = me._ticksToDraw;
		var ticksLength = ticks.length + (offsetGridLines ? 1 : 0);

		var tl = getTickMarkLength(gridLines);
		var items = [];
		var axisWidth = gridLines.drawBorder ? valueAtIndexOrDefault(gridLines.lineWidth, 0, 0) : 0;
		var axisHalfWidth = axisWidth / 2;
		var alignPixel = helpers$1._alignPixel;
		var alignBorderValue = function(pixel) {
			return alignPixel(chart, pixel, axisWidth);
		};
		var borderValue, i, tick, lineValue, alignedLineValue;
		var tx1, ty1, tx2, ty2, x1, y1, x2, y2, lineWidth, lineColor, borderDash, borderDashOffset;

		if (position === 'top') {
			borderValue = alignBorderValue(me.bottom);
			ty1 = me.bottom - tl;
			ty2 = borderValue - axisHalfWidth;
			y1 = alignBorderValue(chartArea.top) + axisHalfWidth;
			y2 = chartArea.bottom;
		} else if (position === 'bottom') {
			borderValue = alignBorderValue(me.top);
			y1 = chartArea.top;
			y2 = alignBorderValue(chartArea.bottom) - axisHalfWidth;
			ty1 = borderValue + axisHalfWidth;
			ty2 = me.top + tl;
		} else if (position === 'left') {
			borderValue = alignBorderValue(me.right);
			tx1 = me.right - tl;
			tx2 = borderValue - axisHalfWidth;
			x1 = alignBorderValue(chartArea.left) + axisHalfWidth;
			x2 = chartArea.right;
		} else {
			borderValue = alignBorderValue(me.left);
			x1 = chartArea.left;
			x2 = alignBorderValue(chartArea.right) - axisHalfWidth;
			tx1 = borderValue + axisHalfWidth;
			tx2 = me.left + tl;
		}

		for (i = 0; i < ticksLength; ++i) {
			tick = ticks[i] || {};

			// autoskipper skipped this tick (#4635)
			if (isNullOrUndef(tick.label) && i < ticks.length) {
				continue;
			}

			if (i === me.zeroLineIndex && options.offset === offsetGridLines) {
				// Draw the first index specially
				lineWidth = gridLines.zeroLineWidth;
				lineColor = gridLines.zeroLineColor;
				borderDash = gridLines.zeroLineBorderDash || [];
				borderDashOffset = gridLines.zeroLineBorderDashOffset || 0.0;
			} else {
				lineWidth = valueAtIndexOrDefault(gridLines.lineWidth, i, 1);
				lineColor = valueAtIndexOrDefault(gridLines.color, i, 'rgba(0,0,0,0.1)');
				borderDash = gridLines.borderDash || [];
				borderDashOffset = gridLines.borderDashOffset || 0.0;
			}

			lineValue = getPixelForGridLine(me, tick._index || i, offsetGridLines);

			// Skip if the pixel is out of the range
			if (lineValue === undefined) {
				continue;
			}

			alignedLineValue = alignPixel(chart, lineValue, lineWidth);

			if (isHorizontal) {
				tx1 = tx2 = x1 = x2 = alignedLineValue;
			} else {
				ty1 = ty2 = y1 = y2 = alignedLineValue;
			}

			items.push({
				tx1: tx1,
				ty1: ty1,
				tx2: tx2,
				ty2: ty2,
				x1: x1,
				y1: y1,
				x2: x2,
				y2: y2,
				width: lineWidth,
				color: lineColor,
				borderDash: borderDash,
				borderDashOffset: borderDashOffset,
			});
		}

		items.ticksLength = ticksLength;
		items.borderValue = borderValue;

		return items;
	},

	/**
	 * @private
	 */
	_computeLabelItems: function() {
		var me = this;
		var options = me.options;
		var optionTicks = options.ticks;
		var position = options.position;
		var isMirrored = optionTicks.mirror;
		var isHorizontal = me.isHorizontal();
		var ticks = me._ticksToDraw;
		var fonts = parseTickFontOptions(optionTicks);
		var tickPadding = optionTicks.padding;
		var tl = getTickMarkLength(options.gridLines);
		var rotation = -helpers$1.toRadians(me.labelRotation);
		var items = [];
		var i, ilen, tick, label, x, y, textAlign, pixel, font, lineHeight, lineCount, textOffset;

		if (position === 'top') {
			y = me.bottom - tl - tickPadding;
			textAlign = !rotation ? 'center' : 'left';
		} else if (position === 'bottom') {
			y = me.top + tl + tickPadding;
			textAlign = !rotation ? 'center' : 'right';
		} else if (position === 'left') {
			x = me.right - (isMirrored ? 0 : tl) - tickPadding;
			textAlign = isMirrored ? 'left' : 'right';
		} else {
			x = me.left + (isMirrored ? 0 : tl) + tickPadding;
			textAlign = isMirrored ? 'right' : 'left';
		}

		for (i = 0, ilen = ticks.length; i < ilen; ++i) {
			tick = ticks[i];
			label = tick.label;

			// autoskipper skipped this tick (#4635)
			if (isNullOrUndef(label)) {
				continue;
			}

			pixel = me.getPixelForTick(tick._index || i) + optionTicks.labelOffset;
			font = tick.major ? fonts.major : fonts.minor;
			lineHeight = font.lineHeight;
			lineCount = isArray(label) ? label.length : 1;

			if (isHorizontal) {
				x = pixel;
				textOffset = position === 'top'
					? ((!rotation ? 0.5 : 1) - lineCount) * lineHeight
					: (!rotation ? 0.5 : 0) * lineHeight;
			} else {
				y = pixel;
				textOffset = (1 - lineCount) * lineHeight / 2;
			}

			items.push({
				x: x,
				y: y,
				rotation: rotation,
				label: label,
				font: font,
				textOffset: textOffset,
				textAlign: textAlign
			});
		}

		return items;
	},

	/**
	 * @private
	 */
	_drawGrid: function(chartArea) {
		var me = this;
		var gridLines = me.options.gridLines;

		if (!gridLines.display) {
			return;
		}

		var ctx = me.ctx;
		var chart = me.chart;
		var alignPixel = helpers$1._alignPixel;
		var axisWidth = gridLines.drawBorder ? valueAtIndexOrDefault(gridLines.lineWidth, 0, 0) : 0;
		var items = me._gridLineItems || (me._gridLineItems = me._computeGridLineItems(chartArea));
		var width, color, i, ilen, item;

		for (i = 0, ilen = items.length; i < ilen; ++i) {
			item = items[i];
			width = item.width;
			color = item.color;

			if (width && color) {
				ctx.save();
				ctx.lineWidth = width;
				ctx.strokeStyle = color;
				if (ctx.setLineDash) {
					ctx.setLineDash(item.borderDash);
					ctx.lineDashOffset = item.borderDashOffset;
				}

				ctx.beginPath();

				if (gridLines.drawTicks) {
					ctx.moveTo(item.tx1, item.ty1);
					ctx.lineTo(item.tx2, item.ty2);
				}

				if (gridLines.drawOnChartArea) {
					ctx.moveTo(item.x1, item.y1);
					ctx.lineTo(item.x2, item.y2);
				}

				ctx.stroke();
				ctx.restore();
			}
		}

		if (axisWidth) {
			// Draw the line at the edge of the axis
			var firstLineWidth = axisWidth;
			var lastLineWidth = valueAtIndexOrDefault(gridLines.lineWidth, items.ticksLength - 1, 1);
			var borderValue = items.borderValue;
			var x1, x2, y1, y2;

			if (me.isHorizontal()) {
				x1 = alignPixel(chart, me.left, firstLineWidth) - firstLineWidth / 2;
				x2 = alignPixel(chart, me.right, lastLineWidth) + lastLineWidth / 2;
				y1 = y2 = borderValue;
			} else {
				y1 = alignPixel(chart, me.top, firstLineWidth) - firstLineWidth / 2;
				y2 = alignPixel(chart, me.bottom, lastLineWidth) + lastLineWidth / 2;
				x1 = x2 = borderValue;
			}

			ctx.lineWidth = axisWidth;
			ctx.strokeStyle = valueAtIndexOrDefault(gridLines.color, 0);
			ctx.beginPath();
			ctx.moveTo(x1, y1);
			ctx.lineTo(x2, y2);
			ctx.stroke();
		}
	},

	/**
	 * @private
	 */
	_drawLabels: function() {
		var me = this;
		var optionTicks = me.options.ticks;

		if (!optionTicks.display) {
			return;
		}

		var ctx = me.ctx;
		var items = me._labelItems || (me._labelItems = me._computeLabelItems());
		var i, j, ilen, jlen, item, tickFont, label, y;

		for (i = 0, ilen = items.length; i < ilen; ++i) {
			item = items[i];
			tickFont = item.font;

			// Make sure we draw text in the correct color and font
			ctx.save();
			ctx.translate(item.x, item.y);
			ctx.rotate(item.rotation);
			ctx.font = tickFont.string;
			ctx.fillStyle = tickFont.color;
			ctx.textBaseline = 'middle';
			ctx.textAlign = item.textAlign;

			label = item.label;
			y = item.textOffset;
			if (isArray(label)) {
				for (j = 0, jlen = label.length; j < jlen; ++j) {
					// We just make sure the multiline element is a string here..
					ctx.fillText('' + label[j], 0, y);
					y += tickFont.lineHeight;
				}
			} else {
				ctx.fillText(label, 0, y);
			}
			ctx.restore();
		}
	},

	/**
	 * @private
	 */
	_drawTitle: function() {
		var me = this;
		var ctx = me.ctx;
		var options = me.options;
		var scaleLabel = options.scaleLabel;

		if (!scaleLabel.display) {
			return;
		}

		var scaleLabelFontColor = valueOrDefault$a(scaleLabel.fontColor, core_defaults.global.defaultFontColor);
		var scaleLabelFont = helpers$1.options._parseFont(scaleLabel);
		var scaleLabelPadding = helpers$1.options.toPadding(scaleLabel.padding);
		var halfLineHeight = scaleLabelFont.lineHeight / 2;
		var position = options.position;
		var rotation = 0;
		var scaleLabelX, scaleLabelY;

		if (me.isHorizontal()) {
			scaleLabelX = me.left + me.width / 2; // midpoint of the width
			scaleLabelY = position === 'bottom'
				? me.bottom - halfLineHeight - scaleLabelPadding.bottom
				: me.top + halfLineHeight + scaleLabelPadding.top;
		} else {
			var isLeft = position === 'left';
			scaleLabelX = isLeft
				? me.left + halfLineHeight + scaleLabelPadding.top
				: me.right - halfLineHeight - scaleLabelPadding.top;
			scaleLabelY = me.top + me.height / 2;
			rotation = isLeft ? -0.5 * Math.PI : 0.5 * Math.PI;
		}

		ctx.save();
		ctx.translate(scaleLabelX, scaleLabelY);
		ctx.rotate(rotation);
		ctx.textAlign = 'center';
		ctx.textBaseline = 'middle';
		ctx.fillStyle = scaleLabelFontColor; // render in correct colour
		ctx.font = scaleLabelFont.string;
		ctx.fillText(scaleLabel.labelString, 0, 0);
		ctx.restore();
	},

	draw: function(chartArea) {
		var me = this;

		if (!me._isVisible()) {
			return;
		}

		me._drawGrid(chartArea);
		me._drawTitle();
		me._drawLabels();
	},

	/**
	 * @private
	 */
	_layers: function() {
		var me = this;
		var opts = me.options;
		var tz = opts.ticks && opts.ticks.z || 0;
		var gz = opts.gridLines && opts.gridLines.z || 0;

		if (!me._isVisible() || tz === gz || me.draw !== me._draw) {
			// backward compatibility: draw has been overridden by custom scale
			return [{
				z: tz,
				draw: function() {
					me.draw.apply(me, arguments);
				}
			}];
		}

		return [{
			z: gz,
			draw: function() {
				me._drawGrid.apply(me, arguments);
				me._drawTitle.apply(me, arguments);
			}
		}, {
			z: tz,
			draw: function() {
				me._drawLabels.apply(me, arguments);
			}
		}];
	},

	/**
	 * @private
	 */
	_getMatchingVisibleMetas: function(type) {
		var me = this;
		var isHorizontal = me.isHorizontal();
		return me.chart._getSortedVisibleDatasetMetas()
			.filter(function(meta) {
				return (!type || meta.type === type)
					&& (isHorizontal ? meta.xAxisID === me.id : meta.yAxisID === me.id);
			});
	}
});

Scale.prototype._draw = Scale.prototype.draw;

var core_scale = Scale;

var isNullOrUndef$1 = helpers$1.isNullOrUndef;

var defaultConfig = {
	position: 'bottom'
};

var scale_category = core_scale.extend({
	determineDataLimits: function() {
		var me = this;
		var labels = me._getLabels();
		var ticksOpts = me.options.ticks;
		var min = ticksOpts.min;
		var max = ticksOpts.max;
		var minIndex = 0;
		var maxIndex = labels.length - 1;
		var findIndex;

		if (min !== undefined) {
			// user specified min value
			findIndex = labels.indexOf(min);
			if (findIndex >= 0) {
				minIndex = findIndex;
			}
		}

		if (max !== undefined) {
			// user specified max value
			findIndex = labels.indexOf(max);
			if (findIndex >= 0) {
				maxIndex = findIndex;
			}
		}

		me.minIndex = minIndex;
		me.maxIndex = maxIndex;
		me.min = labels[minIndex];
		me.max = labels[maxIndex];
	},

	buildTicks: function() {
		var me = this;
		var labels = me._getLabels();
		var minIndex = me.minIndex;
		var maxIndex = me.maxIndex;

		// If we are viewing some subset of labels, slice the original array
		me.ticks = (minIndex === 0 && maxIndex === labels.length - 1) ? labels : labels.slice(minIndex, maxIndex + 1);
	},

	getLabelForIndex: function(index, datasetIndex) {
		var me = this;
		var chart = me.chart;

		if (chart.getDatasetMeta(datasetIndex).controller._getValueScaleId() === me.id) {
			return me.getRightValue(chart.data.datasets[datasetIndex].data[index]);
		}

		return me._getLabels()[index];
	},

	_configure: function() {
		var me = this;
		var offset = me.options.offset;
		var ticks = me.ticks;

		core_scale.prototype._configure.call(me);

		if (!me.isHorizontal()) {
			// For backward compatibility, vertical category scale reverse is inverted.
			me._reversePixels = !me._reversePixels;
		}

		if (!ticks) {
			return;
		}

		me._startValue = me.minIndex - (offset ? 0.5 : 0);
		me._valueRange = Math.max(ticks.length - (offset ? 0 : 1), 1);
	},

	// Used to get data value locations.  Value can either be an index or a numerical value
	getPixelForValue: function(value, index, datasetIndex) {
		var me = this;
		var valueCategory, labels, idx;

		if (!isNullOrUndef$1(index) && !isNullOrUndef$1(datasetIndex)) {
			value = me.chart.data.datasets[datasetIndex].data[index];
		}

		// If value is a data object, then index is the index in the data array,
		// not the index of the scale. We need to change that.
		if (!isNullOrUndef$1(value)) {
			valueCategory = me.isHorizontal() ? value.x : value.y;
		}
		if (valueCategory !== undefined || (value !== undefined && isNaN(index))) {
			labels = me._getLabels();
			value = helpers$1.valueOrDefault(valueCategory, value);
			idx = labels.indexOf(value);
			index = idx !== -1 ? idx : index;
			if (isNaN(index)) {
				index = value;
			}
		}
		return me.getPixelForDecimal((index - me._startValue) / me._valueRange);
	},

	getPixelForTick: function(index) {
		var ticks = this.ticks;
		return index < 0 || index > ticks.length - 1
			? null
			: this.getPixelForValue(ticks[index], index + this.minIndex);
	},

	getValueForPixel: function(pixel) {
		var me = this;
		var value = Math.round(me._startValue + me.getDecimalForPixel(pixel) * me._valueRange);
		return Math.min(Math.max(value, 0), me.ticks.length - 1);
	},

	getBasePixel: function() {
		return this.bottom;
	}
});

// INTERNAL: static default options, registered in src/index.js
var _defaults = defaultConfig;
scale_category._defaults = _defaults;

var noop = helpers$1.noop;
var isNullOrUndef$2 = helpers$1.isNullOrUndef;

/**
 * Generate a set of linear ticks
 * @param generationOptions the options used to generate the ticks
 * @param dataRange the range of the data
 * @returns {number[]} array of tick values
 */
function generateTicks(generationOptions, dataRange) {
	var ticks = [];
	// To get a "nice" value for the tick spacing, we will use the appropriately named
	// "nice number" algorithm. See https://stackoverflow.com/questions/8506881/nice-label-algorithm-for-charts-with-minimum-ticks
	// for details.

	var MIN_SPACING = 1e-14;
	var stepSize = generationOptions.stepSize;
	var unit = stepSize || 1;
	var maxNumSpaces = generationOptions.maxTicks - 1;
	var min = generationOptions.min;
	var max = generationOptions.max;
	var precision = generationOptions.precision;
	var rmin = dataRange.min;
	var rmax = dataRange.max;
	var spacing = helpers$1.niceNum((rmax - rmin) / maxNumSpaces / unit) * unit;
	var factor, niceMin, niceMax, numSpaces;

	// Beyond MIN_SPACING floating point numbers being to lose precision
	// such that we can't do the math necessary to generate ticks
	if (spacing < MIN_SPACING && isNullOrUndef$2(min) && isNullOrUndef$2(max)) {
		return [rmin, rmax];
	}

	numSpaces = Math.ceil(rmax / spacing) - Math.floor(rmin / spacing);
	if (numSpaces > maxNumSpaces) {
		// If the calculated num of spaces exceeds maxNumSpaces, recalculate it
		spacing = helpers$1.niceNum(numSpaces * spacing / maxNumSpaces / unit) * unit;
	}

	if (stepSize || isNullOrUndef$2(precision)) {
		// If a precision is not specified, calculate factor based on spacing
		factor = Math.pow(10, helpers$1._decimalPlaces(spacing));
	} else {
		// If the user specified a precision, round to that number of decimal places
		factor = Math.pow(10, precision);
		spacing = Math.ceil(spacing * factor) / factor;
	}

	niceMin = Math.floor(rmin / spacing) * spacing;
	niceMax = Math.ceil(rmax / spacing) * spacing;

	// If min, max and stepSize is set and they make an evenly spaced scale use it.
	if (stepSize) {
		// If very close to our whole number, use it.
		if (!isNullOrUndef$2(min) && helpers$1.almostWhole(min / spacing, spacing / 1000)) {
			niceMin = min;
		}
		if (!isNullOrUndef$2(max) && helpers$1.almostWhole(max / spacing, spacing / 1000)) {
			niceMax = max;
		}
	}

	numSpaces = (niceMax - niceMin) / spacing;
	// If very close to our rounded value, use it.
	if (helpers$1.almostEquals(numSpaces, Math.round(numSpaces), spacing / 1000)) {
		numSpaces = Math.round(numSpaces);
	} else {
		numSpaces = Math.ceil(numSpaces);
	}

	niceMin = Math.round(niceMin * factor) / factor;
	niceMax = Math.round(niceMax * factor) / factor;
	ticks.push(isNullOrUndef$2(min) ? niceMin : min);
	for (var j = 1; j < numSpaces; ++j) {
		ticks.push(Math.round((niceMin + j * spacing) * factor) / factor);
	}
	ticks.push(isNullOrUndef$2(max) ? niceMax : max);

	return ticks;
}

var scale_linearbase = core_scale.extend({
	getRightValue: function(value) {
		if (typeof value === 'string') {
			return +value;
		}
		return core_scale.prototype.getRightValue.call(this, value);
	},

	handleTickRangeOptions: function() {
		var me = this;
		var opts = me.options;
		var tickOpts = opts.ticks;

		// If we are forcing it to begin at 0, but 0 will already be rendered on the chart,
		// do nothing since that would make the chart weird. If the user really wants a weird chart
		// axis, they can manually override it
		if (tickOpts.beginAtZero) {
			var minSign = helpers$1.sign(me.min);
			var maxSign = helpers$1.sign(me.max);

			if (minSign < 0 && maxSign < 0) {
				// move the top up to 0
				me.max = 0;
			} else if (minSign > 0 && maxSign > 0) {
				// move the bottom down to 0
				me.min = 0;
			}
		}

		var setMin = tickOpts.min !== undefined || tickOpts.suggestedMin !== undefined;
		var setMax = tickOpts.max !== undefined || tickOpts.suggestedMax !== undefined;

		if (tickOpts.min !== undefined) {
			me.min = tickOpts.min;
		} else if (tickOpts.suggestedMin !== undefined) {
			if (me.min === null) {
				me.min = tickOpts.suggestedMin;
			} else {
				me.min = Math.min(me.min, tickOpts.suggestedMin);
			}
		}

		if (tickOpts.max !== undefined) {
			me.max = tickOpts.max;
		} else if (tickOpts.suggestedMax !== undefined) {
			if (me.max === null) {
				me.max = tickOpts.suggestedMax;
			} else {
				me.max = Math.max(me.max, tickOpts.suggestedMax);
			}
		}

		if (setMin !== setMax) {
			// We set the min or the max but not both.
			// So ensure that our range is good
			// Inverted or 0 length range can happen when
			// ticks.min is set, and no datasets are visible
			if (me.min >= me.max) {
				if (setMin) {
					me.max = me.min + 1;
				} else {
					me.min = me.max - 1;
				}
			}
		}

		if (me.min === me.max) {
			me.max++;

			if (!tickOpts.beginAtZero) {
				me.min--;
			}
		}
	},

	getTickLimit: function() {
		var me = this;
		var tickOpts = me.options.ticks;
		var stepSize = tickOpts.stepSize;
		var maxTicksLimit = tickOpts.maxTicksLimit;
		var maxTicks;

		if (stepSize) {
			maxTicks = Math.ceil(me.max / stepSize) - Math.floor(me.min / stepSize) + 1;
		} else {
			maxTicks = me._computeTickLimit();
			maxTicksLimit = maxTicksLimit || 11;
		}

		if (maxTicksLimit) {
			maxTicks = Math.min(maxTicksLimit, maxTicks);
		}

		return maxTicks;
	},

	_computeTickLimit: function() {
		return Number.POSITIVE_INFINITY;
	},

	handleDirectionalChanges: noop,

	buildTicks: function() {
		var me = this;
		var opts = me.options;
		var tickOpts = opts.ticks;

		// Figure out what the max number of ticks we can support it is based on the size of
		// the axis area. For now, we say that the minimum tick spacing in pixels must be 40
		// We also limit the maximum number of ticks to 11 which gives a nice 10 squares on
		// the graph. Make sure we always have at least 2 ticks
		var maxTicks = me.getTickLimit();
		maxTicks = Math.max(2, maxTicks);

		var numericGeneratorOptions = {
			maxTicks: maxTicks,
			min: tickOpts.min,
			max: tickOpts.max,
			precision: tickOpts.precision,
			stepSize: helpers$1.valueOrDefault(tickOpts.fixedStepSize, tickOpts.stepSize)
		};
		var ticks = me.ticks = generateTicks(numericGeneratorOptions, me);

		me.handleDirectionalChanges();

		// At this point, we need to update our max and min given the tick values since we have expanded the
		// range of the scale
		me.max = helpers$1.max(ticks);
		me.min = helpers$1.min(ticks);

		if (tickOpts.reverse) {
			ticks.reverse();

			me.start = me.max;
			me.end = me.min;
		} else {
			me.start = me.min;
			me.end = me.max;
		}
	},

	convertTicksToLabels: function() {
		var me = this;
		me.ticksAsNumbers = me.ticks.slice();
		me.zeroLineIndex = me.ticks.indexOf(0);

		core_scale.prototype.convertTicksToLabels.call(me);
	},

	_configure: function() {
		var me = this;
		var ticks = me.getTicks();
		var start = me.min;
		var end = me.max;
		var offset;

		core_scale.prototype._configure.call(me);

		if (me.options.offset && ticks.length) {
			offset = (end - start) / Math.max(ticks.length - 1, 1) / 2;
			start -= offset;
			end += offset;
		}
		me._startValue = start;
		me._endValue = end;
		me._valueRange = end - start;
	}
});

var defaultConfig$1 = {
	position: 'left',
	ticks: {
		callback: core_ticks.formatters.linear
	}
};

var DEFAULT_MIN = 0;
var DEFAULT_MAX = 1;

function getOrCreateStack(stacks, stacked, meta) {
	var key = [
		meta.type,
		// we have a separate stack for stack=undefined datasets when the opts.stacked is undefined
		stacked === undefined && meta.stack === undefined ? meta.index : '',
		meta.stack
	].join('.');

	if (stacks[key] === undefined) {
		stacks[key] = {
			pos: [],
			neg: []
		};
	}

	return stacks[key];
}

function stackData(scale, stacks, meta, data) {
	var opts = scale.options;
	var stacked = opts.stacked;
	var stack = getOrCreateStack(stacks, stacked, meta);
	var pos = stack.pos;
	var neg = stack.neg;
	var ilen = data.length;
	var i, value;

	for (i = 0; i < ilen; ++i) {
		value = scale._parseValue(data[i]);
		if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden) {
			continue;
		}

		pos[i] = pos[i] || 0;
		neg[i] = neg[i] || 0;

		if (opts.relativePoints) {
			pos[i] = 100;
		} else if (value.min < 0 || value.max < 0) {
			neg[i] += value.min;
		} else {
			pos[i] += value.max;
		}
	}
}

function updateMinMax(scale, meta, data) {
	var ilen = data.length;
	var i, value;

	for (i = 0; i < ilen; ++i) {
		value = scale._parseValue(data[i]);
		if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden) {
			continue;
		}

		scale.min = Math.min(scale.min, value.min);
		scale.max = Math.max(scale.max, value.max);
	}
}

var scale_linear = scale_linearbase.extend({
	determineDataLimits: function() {
		var me = this;
		var opts = me.options;
		var chart = me.chart;
		var datasets = chart.data.datasets;
		var metasets = me._getMatchingVisibleMetas();
		var hasStacks = opts.stacked;
		var stacks = {};
		var ilen = metasets.length;
		var i, meta, data, values;

		me.min = Number.POSITIVE_INFINITY;
		me.max = Number.NEGATIVE_INFINITY;

		if (hasStacks === undefined) {
			for (i = 0; !hasStacks && i < ilen; ++i) {
				meta = metasets[i];
				hasStacks = meta.stack !== undefined;
			}
		}

		for (i = 0; i < ilen; ++i) {
			meta = metasets[i];
			data = datasets[meta.index].data;
			if (hasStacks) {
				stackData(me, stacks, meta, data);
			} else {
				updateMinMax(me, meta, data);
			}
		}

		helpers$1.each(stacks, function(stackValues) {
			values = stackValues.pos.concat(stackValues.neg);
			me.min = Math.min(me.min, helpers$1.min(values));
			me.max = Math.max(me.max, helpers$1.max(values));
		});

		me.min = helpers$1.isFinite(me.min) && !isNaN(me.min) ? me.min : DEFAULT_MIN;
		me.max = helpers$1.isFinite(me.max) && !isNaN(me.max) ? me.max : DEFAULT_MAX;

		// Common base implementation to handle ticks.min, ticks.max, ticks.beginAtZero
		me.handleTickRangeOptions();
	},

	// Returns the maximum number of ticks based on the scale dimension
	_computeTickLimit: function() {
		var me = this;
		var tickFont;

		if (me.isHorizontal()) {
			return Math.ceil(me.width / 40);
		}
		tickFont = helpers$1.options._parseFont(me.options.ticks);
		return Math.ceil(me.height / tickFont.lineHeight);
	},

	// Called after the ticks are built. We need
	handleDirectionalChanges: function() {
		if (!this.isHorizontal()) {
			// We are in a vertical orientation. The top value is the highest. So reverse the array
			this.ticks.reverse();
		}
	},

	getLabelForIndex: function(index, datasetIndex) {
		return this._getScaleLabel(this.chart.data.datasets[datasetIndex].data[index]);
	},

	// Utils
	getPixelForValue: function(value) {
		var me = this;
		return me.getPixelForDecimal((+me.getRightValue(value) - me._startValue) / me._valueRange);
	},

	getValueForPixel: function(pixel) {
		return this._startValue + this.getDecimalForPixel(pixel) * this._valueRange;
	},

	getPixelForTick: function(index) {
		var ticks = this.ticksAsNumbers;
		if (index < 0 || index > ticks.length - 1) {
			return null;
		}
		return this.getPixelForValue(ticks[index]);
	}
});

// INTERNAL: static default options, registered in src/index.js
var _defaults$1 = defaultConfig$1;
scale_linear._defaults = _defaults$1;

var valueOrDefault$b = helpers$1.valueOrDefault;
var log10 = helpers$1.math.log10;

/**
 * Generate a set of logarithmic ticks
 * @param generationOptions the options used to generate the ticks
 * @param dataRange the range of the data
 * @returns {number[]} array of tick values
 */
function generateTicks$1(generationOptions, dataRange) {
	var ticks = [];

	var tickVal = valueOrDefault$b(generationOptions.min, Math.pow(10, Math.floor(log10(dataRange.min))));

	var endExp = Math.floor(log10(dataRange.max));
	var endSignificand = Math.ceil(dataRange.max / Math.pow(10, endExp));
	var exp, significand;

	if (tickVal === 0) {
		exp = Math.floor(log10(dataRange.minNotZero));
		significand = Math.floor(dataRange.minNotZero / Math.pow(10, exp));

		ticks.push(tickVal);
		tickVal = significand * Math.pow(10, exp);
	} else {
		exp = Math.floor(log10(tickVal));
		significand = Math.floor(tickVal / Math.pow(10, exp));
	}
	var precision = exp < 0 ? Math.pow(10, Math.abs(exp)) : 1;

	do {
		ticks.push(tickVal);

		++significand;
		if (significand === 10) {
			significand = 1;
			++exp;
			precision = exp >= 0 ? 1 : precision;
		}

		tickVal = Math.round(significand * Math.pow(10, exp) * precision) / precision;
	} while (exp < endExp || (exp === endExp && significand < endSignificand));

	var lastTick = valueOrDefault$b(generationOptions.max, tickVal);
	ticks.push(lastTick);

	return ticks;
}

var defaultConfig$2 = {
	position: 'left',

	// label settings
	ticks: {
		callback: core_ticks.formatters.logarithmic
	}
};

// TODO(v3): change this to positiveOrDefault
function nonNegativeOrDefault(value, defaultValue) {
	return helpers$1.isFinite(value) && value >= 0 ? value : defaultValue;
}

var scale_logarithmic = core_scale.extend({
	determineDataLimits: function() {
		var me = this;
		var opts = me.options;
		var chart = me.chart;
		var datasets = chart.data.datasets;
		var isHorizontal = me.isHorizontal();
		function IDMatches(meta) {
			return isHorizontal ? meta.xAxisID === me.id : meta.yAxisID === me.id;
		}
		var datasetIndex, meta, value, data, i, ilen;

		// Calculate Range
		me.min = Number.POSITIVE_INFINITY;
		me.max = Number.NEGATIVE_INFINITY;
		me.minNotZero = Number.POSITIVE_INFINITY;

		var hasStacks = opts.stacked;
		if (hasStacks === undefined) {
			for (datasetIndex = 0; datasetIndex < datasets.length; datasetIndex++) {
				meta = chart.getDatasetMeta(datasetIndex);
				if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta) &&
					meta.stack !== undefined) {
					hasStacks = true;
					break;
				}
			}
		}

		if (opts.stacked || hasStacks) {
			var valuesPerStack = {};

			for (datasetIndex = 0; datasetIndex < datasets.length; datasetIndex++) {
				meta = chart.getDatasetMeta(datasetIndex);
				var key = [
					meta.type,
					// we have a separate stack for stack=undefined datasets when the opts.stacked is undefined
					((opts.stacked === undefined && meta.stack === undefined) ? datasetIndex : ''),
					meta.stack
				].join('.');

				if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
					if (valuesPerStack[key] === undefined) {
						valuesPerStack[key] = [];
					}

					data = datasets[datasetIndex].data;
					for (i = 0, ilen = data.length; i < ilen; i++) {
						var values = valuesPerStack[key];
						value = me._parseValue(data[i]);
						// invalid, hidden and negative values are ignored
						if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden || value.min < 0 || value.max < 0) {
							continue;
						}
						values[i] = values[i] || 0;
						values[i] += value.max;
					}
				}
			}

			helpers$1.each(valuesPerStack, function(valuesForType) {
				if (valuesForType.length > 0) {
					var minVal = helpers$1.min(valuesForType);
					var maxVal = helpers$1.max(valuesForType);
					me.min = Math.min(me.min, minVal);
					me.max = Math.max(me.max, maxVal);
				}
			});

		} else {
			for (datasetIndex = 0; datasetIndex < datasets.length; datasetIndex++) {
				meta = chart.getDatasetMeta(datasetIndex);
				if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
					data = datasets[datasetIndex].data;
					for (i = 0, ilen = data.length; i < ilen; i++) {
						value = me._parseValue(data[i]);
						// invalid, hidden and negative values are ignored
						if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden || value.min < 0 || value.max < 0) {
							continue;
						}

						me.min = Math.min(value.min, me.min);
						me.max = Math.max(value.max, me.max);

						if (value.min !== 0) {
							me.minNotZero = Math.min(value.min, me.minNotZero);
						}
					}
				}
			}
		}

		me.min = helpers$1.isFinite(me.min) ? me.min : null;
		me.max = helpers$1.isFinite(me.max) ? me.max : null;
		me.minNotZero = helpers$1.isFinite(me.minNotZero) ? me.minNotZero : null;

		// Common base implementation to handle ticks.min, ticks.max
		this.handleTickRangeOptions();
	},

	handleTickRangeOptions: function() {
		var me = this;
		var tickOpts = me.options.ticks;
		var DEFAULT_MIN = 1;
		var DEFAULT_MAX = 10;

		me.min = nonNegativeOrDefault(tickOpts.min, me.min);
		me.max = nonNegativeOrDefault(tickOpts.max, me.max);

		if (me.min === me.max) {
			if (me.min !== 0 && me.min !== null) {
				me.min = Math.pow(10, Math.floor(log10(me.min)) - 1);
				me.max = Math.pow(10, Math.floor(log10(me.max)) + 1);
			} else {
				me.min = DEFAULT_MIN;
				me.max = DEFAULT_MAX;
			}
		}
		if (me.min === null) {
			me.min = Math.pow(10, Math.floor(log10(me.max)) - 1);
		}
		if (me.max === null) {
			me.max = me.min !== 0
				? Math.pow(10, Math.floor(log10(me.min)) + 1)
				: DEFAULT_MAX;
		}
		if (me.minNotZero === null) {
			if (me.min > 0) {
				me.minNotZero = me.min;
			} else if (me.max < 1) {
				me.minNotZero = Math.pow(10, Math.floor(log10(me.max)));
			} else {
				me.minNotZero = DEFAULT_MIN;
			}
		}
	},

	buildTicks: function() {
		var me = this;
		var tickOpts = me.options.ticks;
		var reverse = !me.isHorizontal();

		var generationOptions = {
			min: nonNegativeOrDefault(tickOpts.min),
			max: nonNegativeOrDefault(tickOpts.max)
		};
		var ticks = me.ticks = generateTicks$1(generationOptions, me);

		// At this point, we need to update our max and min given the tick values since we have expanded the
		// range of the scale
		me.max = helpers$1.max(ticks);
		me.min = helpers$1.min(ticks);

		if (tickOpts.reverse) {
			reverse = !reverse;
			me.start = me.max;
			me.end = me.min;
		} else {
			me.start = me.min;
			me.end = me.max;
		}
		if (reverse) {
			ticks.reverse();
		}
	},

	convertTicksToLabels: function() {
		this.tickValues = this.ticks.slice();

		core_scale.prototype.convertTicksToLabels.call(this);
	},

	// Get the correct tooltip label
	getLabelForIndex: function(index, datasetIndex) {
		return this._getScaleLabel(this.chart.data.datasets[datasetIndex].data[index]);
	},

	getPixelForTick: function(index) {
		var ticks = this.tickValues;
		if (index < 0 || index > ticks.length - 1) {
			return null;
		}
		return this.getPixelForValue(ticks[index]);
	},

	/**
	 * Returns the value of the first tick.
	 * @param {number} value - The minimum not zero value.
	 * @return {number} The first tick value.
	 * @private
	 */
	_getFirstTickValue: function(value) {
		var exp = Math.floor(log10(value));
		var significand = Math.floor(value / Math.pow(10, exp));

		return significand * Math.pow(10, exp);
	},

	_configure: function() {
		var me = this;
		var start = me.min;
		var offset = 0;

		core_scale.prototype._configure.call(me);

		if (start === 0) {
			start = me._getFirstTickValue(me.minNotZero);
			offset = valueOrDefault$b(me.options.ticks.fontSize, core_defaults.global.defaultFontSize) / me._length;
		}

		me._startValue = log10(start);
		me._valueOffset = offset;
		me._valueRange = (log10(me.max) - log10(start)) / (1 - offset);
	},

	getPixelForValue: function(value) {
		var me = this;
		var decimal = 0;

		value = +me.getRightValue(value);

		if (value > me.min && value > 0) {
			decimal = (log10(value) - me._startValue) / me._valueRange + me._valueOffset;
		}
		return me.getPixelForDecimal(decimal);
	},

	getValueForPixel: function(pixel) {
		var me = this;
		var decimal = me.getDecimalForPixel(pixel);
		return decimal === 0 && me.min === 0
			? 0
			: Math.pow(10, me._startValue + (decimal - me._valueOffset) * me._valueRange);
	}
});

// INTERNAL: static default options, registered in src/index.js
var _defaults$2 = defaultConfig$2;
scale_logarithmic._defaults = _defaults$2;

var valueOrDefault$c = helpers$1.valueOrDefault;
var valueAtIndexOrDefault$1 = helpers$1.valueAtIndexOrDefault;
var resolve$4 = helpers$1.options.resolve;

var defaultConfig$3 = {
	display: true,

	// Boolean - Whether to animate scaling the chart from the centre
	animate: true,
	position: 'chartArea',

	angleLines: {
		display: true,
		color: 'rgba(0,0,0,0.1)',
		lineWidth: 1,
		borderDash: [],
		borderDashOffset: 0.0
	},

	gridLines: {
		circular: false
	},

	// label settings
	ticks: {
		// Boolean - Show a backdrop to the scale label
		showLabelBackdrop: true,

		// String - The colour of the label backdrop
		backdropColor: 'rgba(255,255,255,0.75)',

		// Number - The backdrop padding above & below the label in pixels
		backdropPaddingY: 2,

		// Number - The backdrop padding to the side of the label in pixels
		backdropPaddingX: 2,

		callback: core_ticks.formatters.linear
	},

	pointLabels: {
		// Boolean - if true, show point labels
		display: true,

		// Number - Point label font size in pixels
		fontSize: 10,

		// Function - Used to convert point labels
		callback: function(label) {
			return label;
		}
	}
};

function getTickBackdropHeight(opts) {
	var tickOpts = opts.ticks;

	if (tickOpts.display && opts.display) {
		return valueOrDefault$c(tickOpts.fontSize, core_defaults.global.defaultFontSize) + tickOpts.backdropPaddingY * 2;
	}
	return 0;
}

function measureLabelSize(ctx, lineHeight, label) {
	if (helpers$1.isArray(label)) {
		return {
			w: helpers$1.longestText(ctx, ctx.font, label),
			h: label.length * lineHeight
		};
	}

	return {
		w: ctx.measureText(label).width,
		h: lineHeight
	};
}

function determineLimits(angle, pos, size, min, max) {
	if (angle === min || angle === max) {
		return {
			start: pos - (size / 2),
			end: pos + (size / 2)
		};
	} else if (angle < min || angle > max) {
		return {
			start: pos - size,
			end: pos
		};
	}

	return {
		start: pos,
		end: pos + size
	};
}

/**
 * Helper function to fit a radial linear scale with point labels
 */
function fitWithPointLabels(scale) {

	// Right, this is really confusing and there is a lot of maths going on here
	// The gist of the problem is here: https://gist.github.com/nnnick/696cc9c55f4b0beb8fe9
	//
	// Reaction: https://dl.dropboxusercontent.com/u/34601363/toomuchscience.gif
	//
	// Solution:
	//
	// We assume the radius of the polygon is half the size of the canvas at first
	// at each index we check if the text overlaps.
	//
	// Where it does, we store that angle and that index.
	//
	// After finding the largest index and angle we calculate how much we need to remove
	// from the shape radius to move the point inwards by that x.
	//
	// We average the left and right distances to get the maximum shape radius that can fit in the box
	// along with labels.
	//
	// Once we have that, we can find the centre point for the chart, by taking the x text protrusion
	// on each side, removing that from the size, halving it and adding the left x protrusion width.
	//
	// This will mean we have a shape fitted to the canvas, as large as it can be with the labels
	// and position it in the most space efficient manner
	//
	// https://dl.dropboxusercontent.com/u/34601363/yeahscience.gif

	var plFont = helpers$1.options._parseFont(scale.options.pointLabels);

	// Get maximum radius of the polygon. Either half the height (minus the text width) or half the width.
	// Use this to calculate the offset + change. - Make sure L/R protrusion is at least 0 to stop issues with centre points
	var furthestLimits = {
		l: 0,
		r: scale.width,
		t: 0,
		b: scale.height - scale.paddingTop
	};
	var furthestAngles = {};
	var i, textSize, pointPosition;

	scale.ctx.font = plFont.string;
	scale._pointLabelSizes = [];

	var valueCount = scale.chart.data.labels.length;
	for (i = 0; i < valueCount; i++) {
		pointPosition = scale.getPointPosition(i, scale.drawingArea + 5);
		textSize = measureLabelSize(scale.ctx, plFont.lineHeight, scale.pointLabels[i]);
		scale._pointLabelSizes[i] = textSize;

		// Add quarter circle to make degree 0 mean top of circle
		var angleRadians = scale.getIndexAngle(i);
		var angle = helpers$1.toDegrees(angleRadians) % 360;
		var hLimits = determineLimits(angle, pointPosition.x, textSize.w, 0, 180);
		var vLimits = determineLimits(angle, pointPosition.y, textSize.h, 90, 270);

		if (hLimits.start < furthestLimits.l) {
			furthestLimits.l = hLimits.start;
			furthestAngles.l = angleRadians;
		}

		if (hLimits.end > furthestLimits.r) {
			furthestLimits.r = hLimits.end;
			furthestAngles.r = angleRadians;
		}

		if (vLimits.start < furthestLimits.t) {
			furthestLimits.t = vLimits.start;
			furthestAngles.t = angleRadians;
		}

		if (vLimits.end > furthestLimits.b) {
			furthestLimits.b = vLimits.end;
			furthestAngles.b = angleRadians;
		}
	}

	scale.setReductions(scale.drawingArea, furthestLimits, furthestAngles);
}

function getTextAlignForAngle(angle) {
	if (angle === 0 || angle === 180) {
		return 'center';
	} else if (angle < 180) {
		return 'left';
	}

	return 'right';
}

function fillText(ctx, text, position, lineHeight) {
	var y = position.y + lineHeight / 2;
	var i, ilen;

	if (helpers$1.isArray(text)) {
		for (i = 0, ilen = text.length; i < ilen; ++i) {
			ctx.fillText(text[i], position.x, y);
			y += lineHeight;
		}
	} else {
		ctx.fillText(text, position.x, y);
	}
}

function adjustPointPositionForLabelHeight(angle, textSize, position) {
	if (angle === 90 || angle === 270) {
		position.y -= (textSize.h / 2);
	} else if (angle > 270 || angle < 90) {
		position.y -= textSize.h;
	}
}

function drawPointLabels(scale) {
	var ctx = scale.ctx;
	var opts = scale.options;
	var pointLabelOpts = opts.pointLabels;
	var tickBackdropHeight = getTickBackdropHeight(opts);
	var outerDistance = scale.getDistanceFromCenterForValue(opts.ticks.reverse ? scale.min : scale.max);
	var plFont = helpers$1.options._parseFont(pointLabelOpts);

	ctx.save();

	ctx.font = plFont.string;
	ctx.textBaseline = 'middle';

	for (var i = scale.chart.data.labels.length - 1; i >= 0; i--) {
		// Extra pixels out for some label spacing
		var extra = (i === 0 ? tickBackdropHeight / 2 : 0);
		var pointLabelPosition = scale.getPointPosition(i, outerDistance + extra + 5);

		// Keep this in loop since we may support array properties here
		var pointLabelFontColor = valueAtIndexOrDefault$1(pointLabelOpts.fontColor, i, core_defaults.global.defaultFontColor);
		ctx.fillStyle = pointLabelFontColor;

		var angleRadians = scale.getIndexAngle(i);
		var angle = helpers$1.toDegrees(angleRadians);
		ctx.textAlign = getTextAlignForAngle(angle);
		adjustPointPositionForLabelHeight(angle, scale._pointLabelSizes[i], pointLabelPosition);
		fillText(ctx, scale.pointLabels[i], pointLabelPosition, plFont.lineHeight);
	}
	ctx.restore();
}

function drawRadiusLine(scale, gridLineOpts, radius, index) {
	var ctx = scale.ctx;
	var circular = gridLineOpts.circular;
	var valueCount = scale.chart.data.labels.length;
	var lineColor = valueAtIndexOrDefault$1(gridLineOpts.color, index - 1);
	var lineWidth = valueAtIndexOrDefault$1(gridLineOpts.lineWidth, index - 1);
	var pointPosition;

	if ((!circular && !valueCount) || !lineColor || !lineWidth) {
		return;
	}

	ctx.save();
	ctx.strokeStyle = lineColor;
	ctx.lineWidth = lineWidth;
	if (ctx.setLineDash) {
		ctx.setLineDash(gridLineOpts.borderDash || []);
		ctx.lineDashOffset = gridLineOpts.borderDashOffset || 0.0;
	}

	ctx.beginPath();
	if (circular) {
		// Draw circular arcs between the points
		ctx.arc(scale.xCenter, scale.yCenter, radius, 0, Math.PI * 2);
	} else {
		// Draw straight lines connecting each index
		pointPosition = scale.getPointPosition(0, radius);
		ctx.moveTo(pointPosition.x, pointPosition.y);

		for (var i = 1; i < valueCount; i++) {
			pointPosition = scale.getPointPosition(i, radius);
			ctx.lineTo(pointPosition.x, pointPosition.y);
		}
	}
	ctx.closePath();
	ctx.stroke();
	ctx.restore();
}

function numberOrZero(param) {
	return helpers$1.isNumber(param) ? param : 0;
}

var scale_radialLinear = scale_linearbase.extend({
	setDimensions: function() {
		var me = this;

		// Set the unconstrained dimension before label rotation
		me.width = me.maxWidth;
		me.height = me.maxHeight;
		me.paddingTop = getTickBackdropHeight(me.options) / 2;
		me.xCenter = Math.floor(me.width / 2);
		me.yCenter = Math.floor((me.height - me.paddingTop) / 2);
		me.drawingArea = Math.min(me.height - me.paddingTop, me.width) / 2;
	},

	determineDataLimits: function() {
		var me = this;
		var chart = me.chart;
		var min = Number.POSITIVE_INFINITY;
		var max = Number.NEGATIVE_INFINITY;

		helpers$1.each(chart.data.datasets, function(dataset, datasetIndex) {
			if (chart.isDatasetVisible(datasetIndex)) {
				var meta = chart.getDatasetMeta(datasetIndex);

				helpers$1.each(dataset.data, function(rawValue, index) {
					var value = +me.getRightValue(rawValue);
					if (isNaN(value) || meta.data[index].hidden) {
						return;
					}

					min = Math.min(value, min);
					max = Math.max(value, max);
				});
			}
		});

		me.min = (min === Number.POSITIVE_INFINITY ? 0 : min);
		me.max = (max === Number.NEGATIVE_INFINITY ? 0 : max);

		// Common base implementation to handle ticks.min, ticks.max, ticks.beginAtZero
		me.handleTickRangeOptions();
	},

	// Returns the maximum number of ticks based on the scale dimension
	_computeTickLimit: function() {
		return Math.ceil(this.drawingArea / getTickBackdropHeight(this.options));
	},

	convertTicksToLabels: function() {
		var me = this;

		scale_linearbase.prototype.convertTicksToLabels.call(me);

		// Point labels
		me.pointLabels = me.chart.data.labels.map(function() {
			var label = helpers$1.callback(me.options.pointLabels.callback, arguments, me);
			return label || label === 0 ? label : '';
		});
	},

	getLabelForIndex: function(index, datasetIndex) {
		return +this.getRightValue(this.chart.data.datasets[datasetIndex].data[index]);
	},

	fit: function() {
		var me = this;
		var opts = me.options;

		if (opts.display && opts.pointLabels.display) {
			fitWithPointLabels(me);
		} else {
			me.setCenterPoint(0, 0, 0, 0);
		}
	},

	/**
	 * Set radius reductions and determine new radius and center point
	 * @private
	 */
	setReductions: function(largestPossibleRadius, furthestLimits, furthestAngles) {
		var me = this;
		var radiusReductionLeft = furthestLimits.l / Math.sin(furthestAngles.l);
		var radiusReductionRight = Math.max(furthestLimits.r - me.width, 0) / Math.sin(furthestAngles.r);
		var radiusReductionTop = -furthestLimits.t / Math.cos(furthestAngles.t);
		var radiusReductionBottom = -Math.max(furthestLimits.b - (me.height - me.paddingTop), 0) / Math.cos(furthestAngles.b);

		radiusReductionLeft = numberOrZero(radiusReductionLeft);
		radiusReductionRight = numberOrZero(radiusReductionRight);
		radiusReductionTop = numberOrZero(radiusReductionTop);
		radiusReductionBottom = numberOrZero(radiusReductionBottom);

		me.drawingArea = Math.min(
			Math.floor(largestPossibleRadius - (radiusReductionLeft + radiusReductionRight) / 2),
			Math.floor(largestPossibleRadius - (radiusReductionTop + radiusReductionBottom) / 2));
		me.setCenterPoint(radiusReductionLeft, radiusReductionRight, radiusReductionTop, radiusReductionBottom);
	},

	setCenterPoint: function(leftMovement, rightMovement, topMovement, bottomMovement) {
		var me = this;
		var maxRight = me.width - rightMovement - me.drawingArea;
		var maxLeft = leftMovement + me.drawingArea;
		var maxTop = topMovement + me.drawingArea;
		var maxBottom = (me.height - me.paddingTop) - bottomMovement - me.drawingArea;

		me.xCenter = Math.floor(((maxLeft + maxRight) / 2) + me.left);
		me.yCenter = Math.floor(((maxTop + maxBottom) / 2) + me.top + me.paddingTop);
	},

	getIndexAngle: function(index) {
		var chart = this.chart;
		var angleMultiplier = 360 / chart.data.labels.length;
		var options = chart.options || {};
		var startAngle = options.startAngle || 0;

		// Start from the top instead of right, so remove a quarter of the circle
		var angle = (index * angleMultiplier + startAngle) % 360;

		return (angle < 0 ? angle + 360 : angle) * Math.PI * 2 / 360;
	},

	getDistanceFromCenterForValue: function(value) {
		var me = this;

		if (helpers$1.isNullOrUndef(value)) {
			return NaN;
		}

		// Take into account half font size + the yPadding of the top value
		var scalingFactor = me.drawingArea / (me.max - me.min);
		if (me.options.ticks.reverse) {
			return (me.max - value) * scalingFactor;
		}
		return (value - me.min) * scalingFactor;
	},

	getPointPosition: function(index, distanceFromCenter) {
		var me = this;
		var thisAngle = me.getIndexAngle(index) - (Math.PI / 2);
		return {
			x: Math.cos(thisAngle) * distanceFromCenter + me.xCenter,
			y: Math.sin(thisAngle) * distanceFromCenter + me.yCenter
		};
	},

	getPointPositionForValue: function(index, value) {
		return this.getPointPosition(index, this.getDistanceFromCenterForValue(value));
	},

	getBasePosition: function(index) {
		var me = this;
		var min = me.min;
		var max = me.max;

		return me.getPointPositionForValue(index || 0,
			me.beginAtZero ? 0 :
			min < 0 && max < 0 ? max :
			min > 0 && max > 0 ? min :
			0);
	},

	/**
	 * @private
	 */
	_drawGrid: function() {
		var me = this;
		var ctx = me.ctx;
		var opts = me.options;
		var gridLineOpts = opts.gridLines;
		var angleLineOpts = opts.angleLines;
		var lineWidth = valueOrDefault$c(angleLineOpts.lineWidth, gridLineOpts.lineWidth);
		var lineColor = valueOrDefault$c(angleLineOpts.color, gridLineOpts.color);
		var i, offset, position;

		if (opts.pointLabels.display) {
			drawPointLabels(me);
		}

		if (gridLineOpts.display) {
			helpers$1.each(me.ticks, function(label, index) {
				if (index !== 0) {
					offset = me.getDistanceFromCenterForValue(me.ticksAsNumbers[index]);
					drawRadiusLine(me, gridLineOpts, offset, index);
				}
			});
		}

		if (angleLineOpts.display && lineWidth && lineColor) {
			ctx.save();
			ctx.lineWidth = lineWidth;
			ctx.strokeStyle = lineColor;
			if (ctx.setLineDash) {
				ctx.setLineDash(resolve$4([angleLineOpts.borderDash, gridLineOpts.borderDash, []]));
				ctx.lineDashOffset = resolve$4([angleLineOpts.borderDashOffset, gridLineOpts.borderDashOffset, 0.0]);
			}

			for (i = me.chart.data.labels.length - 1; i >= 0; i--) {
				offset = me.getDistanceFromCenterForValue(opts.ticks.reverse ? me.min : me.max);
				position = me.getPointPosition(i, offset);
				ctx.beginPath();
				ctx.moveTo(me.xCenter, me.yCenter);
				ctx.lineTo(position.x, position.y);
				ctx.stroke();
			}

			ctx.restore();
		}
	},

	/**
	 * @private
	 */
	_drawLabels: function() {
		var me = this;
		var ctx = me.ctx;
		var opts = me.options;
		var tickOpts = opts.ticks;

		if (!tickOpts.display) {
			return;
		}

		var startAngle = me.getIndexAngle(0);
		var tickFont = helpers$1.options._parseFont(tickOpts);
		var tickFontColor = valueOrDefault$c(tickOpts.fontColor, core_defaults.global.defaultFontColor);
		var offset, width;

		ctx.save();
		ctx.font = tickFont.string;
		ctx.translate(me.xCenter, me.yCenter);
		ctx.rotate(startAngle);
		ctx.textAlign = 'center';
		ctx.textBaseline = 'middle';

		helpers$1.each(me.ticks, function(label, index) {
			if (index === 0 && !tickOpts.reverse) {
				return;
			}

			offset = me.getDistanceFromCenterForValue(me.ticksAsNumbers[index]);

			if (tickOpts.showLabelBackdrop) {
				width = ctx.measureText(label).width;
				ctx.fillStyle = tickOpts.backdropColor;

				ctx.fillRect(
					-width / 2 - tickOpts.backdropPaddingX,
					-offset - tickFont.size / 2 - tickOpts.backdropPaddingY,
					width + tickOpts.backdropPaddingX * 2,
					tickFont.size + tickOpts.backdropPaddingY * 2
				);
			}

			ctx.fillStyle = tickFontColor;
			ctx.fillText(label, 0, -offset);
		});

		ctx.restore();
	},

	/**
	 * @private
	 */
	_drawTitle: helpers$1.noop
});

// INTERNAL: static default options, registered in src/index.js
var _defaults$3 = defaultConfig$3;
scale_radialLinear._defaults = _defaults$3;

var deprecated$1 = helpers$1._deprecated;
var resolve$5 = helpers$1.options.resolve;
var valueOrDefault$d = helpers$1.valueOrDefault;

// Integer constants are from the ES6 spec.
var MIN_INTEGER = Number.MIN_SAFE_INTEGER || -9007199254740991;
var MAX_INTEGER = Number.MAX_SAFE_INTEGER || 9007199254740991;

var INTERVALS = {
	millisecond: {
		common: true,
		size: 1,
		steps: 1000
	},
	second: {
		common: true,
		size: 1000,
		steps: 60
	},
	minute: {
		common: true,
		size: 60000,
		steps: 60
	},
	hour: {
		common: true,
		size: 3600000,
		steps: 24
	},
	day: {
		common: true,
		size: 86400000,
		steps: 30
	},
	week: {
		common: false,
		size: 604800000,
		steps: 4
	},
	month: {
		common: true,
		size: 2.628e9,
		steps: 12
	},
	quarter: {
		common: false,
		size: 7.884e9,
		steps: 4
	},
	year: {
		common: true,
		size: 3.154e10
	}
};

var UNITS = Object.keys(INTERVALS);

function sorter(a, b) {
	return a - b;
}

function arrayUnique(items) {
	var hash = {};
	var out = [];
	var i, ilen, item;

	for (i = 0, ilen = items.length; i < ilen; ++i) {
		item = items[i];
		if (!hash[item]) {
			hash[item] = true;
			out.push(item);
		}
	}

	return out;
}

function getMin(options) {
	return helpers$1.valueOrDefault(options.time.min, options.ticks.min);
}

function getMax(options) {
	return helpers$1.valueOrDefault(options.time.max, options.ticks.max);
}

/**
 * Returns an array of {time, pos} objects used to interpolate a specific `time` or position
 * (`pos`) on the scale, by searching entries before and after the requested value. `pos` is
 * a decimal between 0 and 1: 0 being the start of the scale (left or top) and 1 the other
 * extremity (left + width or top + height). Note that it would be more optimized to directly
 * store pre-computed pixels, but the scale dimensions are not guaranteed at the time we need
 * to create the lookup table. The table ALWAYS contains at least two items: min and max.
 *
 * @param {number[]} timestamps - timestamps sorted from lowest to highest.
 * @param {string} distribution - If 'linear', timestamps will be spread linearly along the min
 * and max range, so basically, the table will contains only two items: {min, 0} and {max, 1}.
 * If 'series', timestamps will be positioned at the same distance from each other. In this
 * case, only timestamps that break the time linearity are registered, meaning that in the
 * best case, all timestamps are linear, the table contains only min and max.
 */
function buildLookupTable(timestamps, min, max, distribution) {
	if (distribution === 'linear' || !timestamps.length) {
		return [
			{time: min, pos: 0},
			{time: max, pos: 1}
		];
	}

	var table = [];
	var items = [min];
	var i, ilen, prev, curr, next;

	for (i = 0, ilen = timestamps.length; i < ilen; ++i) {
		curr = timestamps[i];
		if (curr > min && curr < max) {
			items.push(curr);
		}
	}

	items.push(max);

	for (i = 0, ilen = items.length; i < ilen; ++i) {
		next = items[i + 1];
		prev = items[i - 1];
		curr = items[i];

		// only add points that breaks the scale linearity
		if (prev === undefined || next === undefined || Math.round((next + prev) / 2) !== curr) {
			table.push({time: curr, pos: i / (ilen - 1)});
		}
	}

	return table;
}

// @see adapted from https://www.anujgakhar.com/2014/03/01/binary-search-in-javascript/
function lookup(table, key, value) {
	var lo = 0;
	var hi = table.length - 1;
	var mid, i0, i1;

	while (lo >= 0 && lo <= hi) {
		mid = (lo + hi) >> 1;
		i0 = table[mid - 1] || null;
		i1 = table[mid];

		if (!i0) {
			// given value is outside table (before first item)
			return {lo: null, hi: i1};
		} else if (i1[key] < value) {
			lo = mid + 1;
		} else if (i0[key] > value) {
			hi = mid - 1;
		} else {
			return {lo: i0, hi: i1};
		}
	}

	// given value is outside table (after last item)
	return {lo: i1, hi: null};
}

/**
 * Linearly interpolates the given source `value` using the table items `skey` values and
 * returns the associated `tkey` value. For example, interpolate(table, 'time', 42, 'pos')
 * returns the position for a timestamp equal to 42. If value is out of bounds, values at
 * index [0, 1] or [n - 1, n] are used for the interpolation.
 */
function interpolate$1(table, skey, sval, tkey) {
	var range = lookup(table, skey, sval);

	// Note: the lookup table ALWAYS contains at least 2 items (min and max)
	var prev = !range.lo ? table[0] : !range.hi ? table[table.length - 2] : range.lo;
	var next = !range.lo ? table[1] : !range.hi ? table[table.length - 1] : range.hi;

	var span = next[skey] - prev[skey];
	var ratio = span ? (sval - prev[skey]) / span : 0;
	var offset = (next[tkey] - prev[tkey]) * ratio;

	return prev[tkey] + offset;
}

function toTimestamp(scale, input) {
	var adapter = scale._adapter;
	var options = scale.options.time;
	var parser = options.parser;
	var format = parser || options.format;
	var value = input;

	if (typeof parser === 'function') {
		value = parser(value);
	}

	// Only parse if its not a timestamp already
	if (!helpers$1.isFinite(value)) {
		value = typeof format === 'string'
			? adapter.parse(value, format)
			: adapter.parse(value);
	}

	if (value !== null) {
		return +value;
	}

	// Labels are in an incompatible format and no `parser` has been provided.
	// The user might still use the deprecated `format` option for parsing.
	if (!parser && typeof format === 'function') {
		value = format(input);

		// `format` could return something else than a timestamp, if so, parse it
		if (!helpers$1.isFinite(value)) {
			value = adapter.parse(value);
		}
	}

	return value;
}

function parse(scale, input) {
	if (helpers$1.isNullOrUndef(input)) {
		return null;
	}

	var options = scale.options.time;
	var value = toTimestamp(scale, scale.getRightValue(input));
	if (value === null) {
		return value;
	}

	if (options.round) {
		value = +scale._adapter.startOf(value, options.round);
	}

	return value;
}

/**
 * Figures out what unit results in an appropriate number of auto-generated ticks
 */
function determineUnitForAutoTicks(minUnit, min, max, capacity) {
	var ilen = UNITS.length;
	var i, interval, factor;

	for (i = UNITS.indexOf(minUnit); i < ilen - 1; ++i) {
		interval = INTERVALS[UNITS[i]];
		factor = interval.steps ? interval.steps : MAX_INTEGER;

		if (interval.common && Math.ceil((max - min) / (factor * interval.size)) <= capacity) {
			return UNITS[i];
		}
	}

	return UNITS[ilen - 1];
}

/**
 * Figures out what unit to format a set of ticks with
 */
function determineUnitForFormatting(scale, numTicks, minUnit, min, max) {
	var i, unit;

	for (i = UNITS.length - 1; i >= UNITS.indexOf(minUnit); i--) {
		unit = UNITS[i];
		if (INTERVALS[unit].common && scale._adapter.diff(max, min, unit) >= numTicks - 1) {
			return unit;
		}
	}

	return UNITS[minUnit ? UNITS.indexOf(minUnit) : 0];
}

function determineMajorUnit(unit) {
	for (var i = UNITS.indexOf(unit) + 1, ilen = UNITS.length; i < ilen; ++i) {
		if (INTERVALS[UNITS[i]].common) {
			return UNITS[i];
		}
	}
}

/**
 * Generates a maximum of `capacity` timestamps between min and max, rounded to the
 * `minor` unit using the given scale time `options`.
 * Important: this method can return ticks outside the min and max range, it's the
 * responsibility of the calling code to clamp values if needed.
 */
function generate(scale, min, max, capacity) {
	var adapter = scale._adapter;
	var options = scale.options;
	var timeOpts = options.time;
	var minor = timeOpts.unit || determineUnitForAutoTicks(timeOpts.minUnit, min, max, capacity);
	var stepSize = resolve$5([timeOpts.stepSize, timeOpts.unitStepSize, 1]);
	var weekday = minor === 'week' ? timeOpts.isoWeekday : false;
	var first = min;
	var ticks = [];
	var time;

	// For 'week' unit, handle the first day of week option
	if (weekday) {
		first = +adapter.startOf(first, 'isoWeek', weekday);
	}

	// Align first ticks on unit
	first = +adapter.startOf(first, weekday ? 'day' : minor);

	// Prevent browser from freezing in case user options request millions of milliseconds
	if (adapter.diff(max, min, minor) > 100000 * stepSize) {
		throw min + ' and ' + max + ' are too far apart with stepSize of ' + stepSize + ' ' + minor;
	}

	for (time = first; time < max; time = +adapter.add(time, stepSize, minor)) {
		ticks.push(time);
	}

	if (time === max || options.bounds === 'ticks') {
		ticks.push(time);
	}

	return ticks;
}

/**
 * Returns the start and end offsets from edges in the form of {start, end}
 * where each value is a relative width to the scale and ranges between 0 and 1.
 * They add extra margins on the both sides by scaling down the original scale.
 * Offsets are added when the `offset` option is true.
 */
function computeOffsets(table, ticks, min, max, options) {
	var start = 0;
	var end = 0;
	var first, last;

	if (options.offset && ticks.length) {
		first = interpolate$1(table, 'time', ticks[0], 'pos');
		if (ticks.length === 1) {
			start = 1 - first;
		} else {
			start = (interpolate$1(table, 'time', ticks[1], 'pos') - first) / 2;
		}
		last = interpolate$1(table, 'time', ticks[ticks.length - 1], 'pos');
		if (ticks.length === 1) {
			end = last;
		} else {
			end = (last - interpolate$1(table, 'time', ticks[ticks.length - 2], 'pos')) / 2;
		}
	}

	return {start: start, end: end, factor: 1 / (start + 1 + end)};
}

function setMajorTicks(scale, ticks, map, majorUnit) {
	var adapter = scale._adapter;
	var first = +adapter.startOf(ticks[0].value, majorUnit);
	var last = ticks[ticks.length - 1].value;
	var major, index;

	for (major = first; major <= last; major = +adapter.add(major, 1, majorUnit)) {
		index = map[major];
		if (index >= 0) {
			ticks[index].major = true;
		}
	}
	return ticks;
}

function ticksFromTimestamps(scale, values, majorUnit) {
	var ticks = [];
	var map = {};
	var ilen = values.length;
	var i, value;

	for (i = 0; i < ilen; ++i) {
		value = values[i];
		map[value] = i;

		ticks.push({
			value: value,
			major: false
		});
	}

	// We set the major ticks separately from the above loop because calling startOf for every tick
	// is expensive when there is a large number of ticks
	return (ilen === 0 || !majorUnit) ? ticks : setMajorTicks(scale, ticks, map, majorUnit);
}

var defaultConfig$4 = {
	position: 'bottom',

	/**
	 * Data distribution along the scale:
	 * - 'linear': data are spread according to their time (distances can vary),
	 * - 'series': data are spread at the same distance from each other.
	 * @see https://github.com/chartjs/Chart.js/pull/4507
	 * @since 2.7.0
	 */
	distribution: 'linear',

	/**
	 * Scale boundary strategy (bypassed by min/max time options)
	 * - `data`: make sure data are fully visible, ticks outside are removed
	 * - `ticks`: make sure ticks are fully visible, data outside are truncated
	 * @see https://github.com/chartjs/Chart.js/pull/4556
	 * @since 2.7.0
	 */
	bounds: 'data',

	adapters: {},
	time: {
		parser: false, // false == a pattern string from https://momentjs.com/docs/#/parsing/string-format/ or a custom callback that converts its argument to a moment
		unit: false, // false == automatic or override with week, month, year, etc.
		round: false, // none, or override with week, month, year, etc.
		displayFormat: false, // DEPRECATED
		isoWeekday: false, // override week start day - see https://momentjs.com/docs/#/get-set/iso-weekday/
		minUnit: 'millisecond',
		displayFormats: {}
	},
	ticks: {
		autoSkip: false,

		/**
		 * Ticks generation input values:
		 * - 'auto': generates "optimal" ticks based on scale size and time options.
		 * - 'data': generates ticks from data (including labels from data {t|x|y} objects).
		 * - 'labels': generates ticks from user given `data.labels` values ONLY.
		 * @see https://github.com/chartjs/Chart.js/pull/4507
		 * @since 2.7.0
		 */
		source: 'auto',

		major: {
			enabled: false
		}
	}
};

var scale_time = core_scale.extend({
	initialize: function() {
		this.mergeTicksOptions();
		core_scale.prototype.initialize.call(this);
	},

	update: function() {
		var me = this;
		var options = me.options;
		var time = options.time || (options.time = {});
		var adapter = me._adapter = new core_adapters._date(options.adapters.date);

		// DEPRECATIONS: output a message only one time per update
		deprecated$1('time scale', time.format, 'time.format', 'time.parser');
		deprecated$1('time scale', time.min, 'time.min', 'ticks.min');
		deprecated$1('time scale', time.max, 'time.max', 'ticks.max');

		// Backward compatibility: before introducing adapter, `displayFormats` was
		// supposed to contain *all* unit/string pairs but this can't be resolved
		// when loading the scale (adapters are loaded afterward), so let's populate
		// missing formats on update
		helpers$1.mergeIf(time.displayFormats, adapter.formats());

		return core_scale.prototype.update.apply(me, arguments);
	},

	/**
	 * Allows data to be referenced via 't' attribute
	 */
	getRightValue: function(rawValue) {
		if (rawValue && rawValue.t !== undefined) {
			rawValue = rawValue.t;
		}
		return core_scale.prototype.getRightValue.call(this, rawValue);
	},

	determineDataLimits: function() {
		var me = this;
		var chart = me.chart;
		var adapter = me._adapter;
		var options = me.options;
		var unit = options.time.unit || 'day';
		var min = MAX_INTEGER;
		var max = MIN_INTEGER;
		var timestamps = [];
		var datasets = [];
		var labels = [];
		var i, j, ilen, jlen, data, timestamp, labelsAdded;
		var dataLabels = me._getLabels();

		for (i = 0, ilen = dataLabels.length; i < ilen; ++i) {
			labels.push(parse(me, dataLabels[i]));
		}

		for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
			if (chart.isDatasetVisible(i)) {
				data = chart.data.datasets[i].data;

				// Let's consider that all data have the same format.
				if (helpers$1.isObject(data[0])) {
					datasets[i] = [];

					for (j = 0, jlen = data.length; j < jlen; ++j) {
						timestamp = parse(me, data[j]);
						timestamps.push(timestamp);
						datasets[i][j] = timestamp;
					}
				} else {
					datasets[i] = labels.slice(0);
					if (!labelsAdded) {
						timestamps = timestamps.concat(labels);
						labelsAdded = true;
					}
				}
			} else {
				datasets[i] = [];
			}
		}

		if (labels.length) {
			min = Math.min(min, labels[0]);
			max = Math.max(max, labels[labels.length - 1]);
		}

		if (timestamps.length) {
			timestamps = ilen > 1 ? arrayUnique(timestamps).sort(sorter) : timestamps.sort(sorter);
			min = Math.min(min, timestamps[0]);
			max = Math.max(max, timestamps[timestamps.length - 1]);
		}

		min = parse(me, getMin(options)) || min;
		max = parse(me, getMax(options)) || max;

		// In case there is no valid min/max, set limits based on unit time option
		min = min === MAX_INTEGER ? +adapter.startOf(Date.now(), unit) : min;
		max = max === MIN_INTEGER ? +adapter.endOf(Date.now(), unit) + 1 : max;

		// Make sure that max is strictly higher than min (required by the lookup table)
		me.min = Math.min(min, max);
		me.max = Math.max(min + 1, max);

		// PRIVATE
		me._table = [];
		me._timestamps = {
			data: timestamps,
			datasets: datasets,
			labels: labels
		};
	},

	buildTicks: function() {
		var me = this;
		var min = me.min;
		var max = me.max;
		var options = me.options;
		var tickOpts = options.ticks;
		var timeOpts = options.time;
		var timestamps = me._timestamps;
		var ticks = [];
		var capacity = me.getLabelCapacity(min);
		var source = tickOpts.source;
		var distribution = options.distribution;
		var i, ilen, timestamp;

		if (source === 'data' || (source === 'auto' && distribution === 'series')) {
			timestamps = timestamps.data;
		} else if (source === 'labels') {
			timestamps = timestamps.labels;
		} else {
			timestamps = generate(me, min, max, capacity);
		}

		if (options.bounds === 'ticks' && timestamps.length) {
			min = timestamps[0];
			max = timestamps[timestamps.length - 1];
		}

		// Enforce limits with user min/max options
		min = parse(me, getMin(options)) || min;
		max = parse(me, getMax(options)) || max;

		// Remove ticks outside the min/max range
		for (i = 0, ilen = timestamps.length; i < ilen; ++i) {
			timestamp = timestamps[i];
			if (timestamp >= min && timestamp <= max) {
				ticks.push(timestamp);
			}
		}

		me.min = min;
		me.max = max;

		// PRIVATE
		// determineUnitForFormatting relies on the number of ticks so we don't use it when
		// autoSkip is enabled because we don't yet know what the final number of ticks will be
		me._unit = timeOpts.unit || (tickOpts.autoSkip
			? determineUnitForAutoTicks(timeOpts.minUnit, me.min, me.max, capacity)
			: determineUnitForFormatting(me, ticks.length, timeOpts.minUnit, me.min, me.max));
		me._majorUnit = !tickOpts.major.enabled || me._unit === 'year' ? undefined
			: determineMajorUnit(me._unit);
		me._table = buildLookupTable(me._timestamps.data, min, max, distribution);
		me._offsets = computeOffsets(me._table, ticks, min, max, options);

		if (tickOpts.reverse) {
			ticks.reverse();
		}

		return ticksFromTimestamps(me, ticks, me._majorUnit);
	},

	getLabelForIndex: function(index, datasetIndex) {
		var me = this;
		var adapter = me._adapter;
		var data = me.chart.data;
		var timeOpts = me.options.time;
		var label = data.labels && index < data.labels.length ? data.labels[index] : '';
		var value = data.datasets[datasetIndex].data[index];

		if (helpers$1.isObject(value)) {
			label = me.getRightValue(value);
		}
		if (timeOpts.tooltipFormat) {
			return adapter.format(toTimestamp(me, label), timeOpts.tooltipFormat);
		}
		if (typeof label === 'string') {
			return label;
		}
		return adapter.format(toTimestamp(me, label), timeOpts.displayFormats.datetime);
	},

	/**
	 * Function to format an individual tick mark
	 * @private
	 */
	tickFormatFunction: function(time, index, ticks, format) {
		var me = this;
		var adapter = me._adapter;
		var options = me.options;
		var formats = options.time.displayFormats;
		var minorFormat = formats[me._unit];
		var majorUnit = me._majorUnit;
		var majorFormat = formats[majorUnit];
		var tick = ticks[index];
		var tickOpts = options.ticks;
		var major = majorUnit && majorFormat && tick && tick.major;
		var label = adapter.format(time, format ? format : major ? majorFormat : minorFormat);
		var nestedTickOpts = major ? tickOpts.major : tickOpts.minor;
		var formatter = resolve$5([
			nestedTickOpts.callback,
			nestedTickOpts.userCallback,
			tickOpts.callback,
			tickOpts.userCallback
		]);

		return formatter ? formatter(label, index, ticks) : label;
	},

	convertTicksToLabels: function(ticks) {
		var labels = [];
		var i, ilen;

		for (i = 0, ilen = ticks.length; i < ilen; ++i) {
			labels.push(this.tickFormatFunction(ticks[i].value, i, ticks));
		}

		return labels;
	},

	/**
	 * @private
	 */
	getPixelForOffset: function(time) {
		var me = this;
		var offsets = me._offsets;
		var pos = interpolate$1(me._table, 'time', time, 'pos');
		return me.getPixelForDecimal((offsets.start + pos) * offsets.factor);
	},

	getPixelForValue: function(value, index, datasetIndex) {
		var me = this;
		var time = null;

		if (index !== undefined && datasetIndex !== undefined) {
			time = me._timestamps.datasets[datasetIndex][index];
		}

		if (time === null) {
			time = parse(me, value);
		}

		if (time !== null) {
			return me.getPixelForOffset(time);
		}
	},

	getPixelForTick: function(index) {
		var ticks = this.getTicks();
		return index >= 0 && index < ticks.length ?
			this.getPixelForOffset(ticks[index].value) :
			null;
	},

	getValueForPixel: function(pixel) {
		var me = this;
		var offsets = me._offsets;
		var pos = me.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
		var time = interpolate$1(me._table, 'pos', pos, 'time');

		// DEPRECATION, we should return time directly
		return me._adapter._create(time);
	},

	/**
	 * @private
	 */
	_getLabelSize: function(label) {
		var me = this;
		var ticksOpts = me.options.ticks;
		var tickLabelWidth = me.ctx.measureText(label).width;
		var angle = helpers$1.toRadians(me.isHorizontal() ? ticksOpts.maxRotation : ticksOpts.minRotation);
		var cosRotation = Math.cos(angle);
		var sinRotation = Math.sin(angle);
		var tickFontSize = valueOrDefault$d(ticksOpts.fontSize, core_defaults.global.defaultFontSize);

		return {
			w: (tickLabelWidth * cosRotation) + (tickFontSize * sinRotation),
			h: (tickLabelWidth * sinRotation) + (tickFontSize * cosRotation)
		};
	},

	/**
	 * Crude approximation of what the label width might be
	 * @private
	 */
	getLabelWidth: function(label) {
		return this._getLabelSize(label).w;
	},

	/**
	 * @private
	 */
	getLabelCapacity: function(exampleTime) {
		var me = this;
		var timeOpts = me.options.time;
		var displayFormats = timeOpts.displayFormats;

		// pick the longest format (milliseconds) for guestimation
		var format = displayFormats[timeOpts.unit] || displayFormats.millisecond;
		var exampleLabel = me.tickFormatFunction(exampleTime, 0, ticksFromTimestamps(me, [exampleTime], me._majorUnit), format);
		var size = me._getLabelSize(exampleLabel);
		var capacity = Math.floor(me.isHorizontal() ? me.width / size.w : me.height / size.h);

		if (me.options.offset) {
			capacity--;
		}

		return capacity > 0 ? capacity : 1;
	}
});

// INTERNAL: static default options, registered in src/index.js
var _defaults$4 = defaultConfig$4;
scale_time._defaults = _defaults$4;

var scales = {
	category: scale_category,
	linear: scale_linear,
	logarithmic: scale_logarithmic,
	radialLinear: scale_radialLinear,
	time: scale_time
};

var FORMATS = {
	datetime: 'MMM D, YYYY, h:mm:ss a',
	millisecond: 'h:mm:ss.SSS a',
	second: 'h:mm:ss a',
	minute: 'h:mm a',
	hour: 'hA',
	day: 'MMM D',
	week: 'll',
	month: 'MMM YYYY',
	quarter: '[Q]Q - YYYY',
	year: 'YYYY'
};

core_adapters._date.override(typeof moment === 'function' ? {
	_id: 'moment', // DEBUG ONLY

	formats: function() {
		return FORMATS;
	},

	parse: function(value, format) {
		if (typeof value === 'string' && typeof format === 'string') {
			value = moment(value, format);
		} else if (!(value instanceof moment)) {
			value = moment(value);
		}
		return value.isValid() ? value.valueOf() : null;
	},

	format: function(time, format) {
		return moment(time).format(format);
	},

	add: function(time, amount, unit) {
		return moment(time).add(amount, unit).valueOf();
	},

	diff: function(max, min, unit) {
		return moment(max).diff(moment(min), unit);
	},

	startOf: function(time, unit, weekday) {
		time = moment(time);
		if (unit === 'isoWeek') {
			return time.isoWeekday(weekday).valueOf();
		}
		return time.startOf(unit).valueOf();
	},

	endOf: function(time, unit) {
		return moment(time).endOf(unit).valueOf();
	},

	// DEPRECATIONS

	/**
	 * Provided for backward compatibility with scale.getValueForPixel().
	 * @deprecated since version 2.8.0
	 * @todo remove at version 3
	 * @private
	 */
	_create: function(time) {
		return moment(time);
	},
} : {});

core_defaults._set('global', {
	plugins: {
		filler: {
			propagate: true
		}
	}
});

var mappers = {
	dataset: function(source) {
		var index = source.fill;
		var chart = source.chart;
		var meta = chart.getDatasetMeta(index);
		var visible = meta && chart.isDatasetVisible(index);
		var points = (visible && meta.dataset._children) || [];
		var length = points.length || 0;

		return !length ? null : function(point, i) {
			return (i < length && points[i]._view) || null;
		};
	},

	boundary: function(source) {
		var boundary = source.boundary;
		var x = boundary ? boundary.x : null;
		var y = boundary ? boundary.y : null;

		if (helpers$1.isArray(boundary)) {
			return function(point, i) {
				return boundary[i];
			};
		}

		return function(point) {
			return {
				x: x === null ? point.x : x,
				y: y === null ? point.y : y,
			};
		};
	}
};

// @todo if (fill[0] === '#')
function decodeFill(el, index, count) {
	var model = el._model || {};
	var fill = model.fill;
	var target;

	if (fill === undefined) {
		fill = !!model.backgroundColor;
	}

	if (fill === false || fill === null) {
		return false;
	}

	if (fill === true) {
		return 'origin';
	}

	target = parseFloat(fill, 10);
	if (isFinite(target) && Math.floor(target) === target) {
		if (fill[0] === '-' || fill[0] === '+') {
			target = index + target;
		}

		if (target === index || target < 0 || target >= count) {
			return false;
		}

		return target;
	}

	switch (fill) {
	// compatibility
	case 'bottom':
		return 'start';
	case 'top':
		return 'end';
	case 'zero':
		return 'origin';
	// supported boundaries
	case 'origin':
	case 'start':
	case 'end':
		return fill;
	// invalid fill values
	default:
		return false;
	}
}

function computeLinearBoundary(source) {
	var model = source.el._model || {};
	var scale = source.el._scale || {};
	var fill = source.fill;
	var target = null;
	var horizontal;

	if (isFinite(fill)) {
		return null;
	}

	// Backward compatibility: until v3, we still need to support boundary values set on
	// the model (scaleTop, scaleBottom and scaleZero) because some external plugins and
	// controllers might still use it (e.g. the Smith chart).

	if (fill === 'start') {
		target = model.scaleBottom === undefined ? scale.bottom : model.scaleBottom;
	} else if (fill === 'end') {
		target = model.scaleTop === undefined ? scale.top : model.scaleTop;
	} else if (model.scaleZero !== undefined) {
		target = model.scaleZero;
	} else if (scale.getBasePixel) {
		target = scale.getBasePixel();
	}

	if (target !== undefined && target !== null) {
		if (target.x !== undefined && target.y !== undefined) {
			return target;
		}

		if (helpers$1.isFinite(target)) {
			horizontal = scale.isHorizontal();
			return {
				x: horizontal ? target : null,
				y: horizontal ? null : target
			};
		}
	}

	return null;
}

function computeCircularBoundary(source) {
	var scale = source.el._scale;
	var options = scale.options;
	var length = scale.chart.data.labels.length;
	var fill = source.fill;
	var target = [];
	var start, end, center, i, point;

	if (!length) {
		return null;
	}

	start = options.ticks.reverse ? scale.max : scale.min;
	end = options.ticks.reverse ? scale.min : scale.max;
	center = scale.getPointPositionForValue(0, start);
	for (i = 0; i < length; ++i) {
		point = fill === 'start' || fill === 'end'
			? scale.getPointPositionForValue(i, fill === 'start' ? start : end)
			: scale.getBasePosition(i);
		if (options.gridLines.circular) {
			point.cx = center.x;
			point.cy = center.y;
			point.angle = scale.getIndexAngle(i) - Math.PI / 2;
		}
		target.push(point);
	}
	return target;
}

function computeBoundary(source) {
	var scale = source.el._scale || {};

	if (scale.getPointPositionForValue) {
		return computeCircularBoundary(source);
	}
	return computeLinearBoundary(source);
}

function resolveTarget(sources, index, propagate) {
	var source = sources[index];
	var fill = source.fill;
	var visited = [index];
	var target;

	if (!propagate) {
		return fill;
	}

	while (fill !== false && visited.indexOf(fill) === -1) {
		if (!isFinite(fill)) {
			return fill;
		}

		target = sources[fill];
		if (!target) {
			return false;
		}

		if (target.visible) {
			return fill;
		}

		visited.push(fill);
		fill = target.fill;
	}

	return false;
}

function createMapper(source) {
	var fill = source.fill;
	var type = 'dataset';

	if (fill === false) {
		return null;
	}

	if (!isFinite(fill)) {
		type = 'boundary';
	}

	return mappers[type](source);
}

function isDrawable(point) {
	return point && !point.skip;
}

function drawArea(ctx, curve0, curve1, len0, len1) {
	var i, cx, cy, r;

	if (!len0 || !len1) {
		return;
	}

	// building first area curve (normal)
	ctx.moveTo(curve0[0].x, curve0[0].y);
	for (i = 1; i < len0; ++i) {
		helpers$1.canvas.lineTo(ctx, curve0[i - 1], curve0[i]);
	}

	if (curve1[0].angle !== undefined) {
		cx = curve1[0].cx;
		cy = curve1[0].cy;
		r = Math.sqrt(Math.pow(curve1[0].x - cx, 2) + Math.pow(curve1[0].y - cy, 2));
		for (i = len1 - 1; i > 0; --i) {
			ctx.arc(cx, cy, r, curve1[i].angle, curve1[i - 1].angle, true);
		}
		return;
	}

	// joining the two area curves
	ctx.lineTo(curve1[len1 - 1].x, curve1[len1 - 1].y);

	// building opposite area curve (reverse)
	for (i = len1 - 1; i > 0; --i) {
		helpers$1.canvas.lineTo(ctx, curve1[i], curve1[i - 1], true);
	}
}

function doFill(ctx, points, mapper, view, color, loop) {
	var count = points.length;
	var span = view.spanGaps;
	var curve0 = [];
	var curve1 = [];
	var len0 = 0;
	var len1 = 0;
	var i, ilen, index, p0, p1, d0, d1, loopOffset;

	ctx.beginPath();

	for (i = 0, ilen = count; i < ilen; ++i) {
		index = i % count;
		p0 = points[index]._view;
		p1 = mapper(p0, index, view);
		d0 = isDrawable(p0);
		d1 = isDrawable(p1);

		if (loop && loopOffset === undefined && d0) {
			loopOffset = i + 1;
			ilen = count + loopOffset;
		}

		if (d0 && d1) {
			len0 = curve0.push(p0);
			len1 = curve1.push(p1);
		} else if (len0 && len1) {
			if (!span) {
				drawArea(ctx, curve0, curve1, len0, len1);
				len0 = len1 = 0;
				curve0 = [];
				curve1 = [];
			} else {
				if (d0) {
					curve0.push(p0);
				}
				if (d1) {
					curve1.push(p1);
				}
			}
		}
	}

	drawArea(ctx, curve0, curve1, len0, len1);

	ctx.closePath();
	ctx.fillStyle = color;
	ctx.fill();
}

var plugin_filler = {
	id: 'filler',

	afterDatasetsUpdate: function(chart, options) {
		var count = (chart.data.datasets || []).length;
		var propagate = options.propagate;
		var sources = [];
		var meta, i, el, source;

		for (i = 0; i < count; ++i) {
			meta = chart.getDatasetMeta(i);
			el = meta.dataset;
			source = null;

			if (el && el._model && el instanceof elements.Line) {
				source = {
					visible: chart.isDatasetVisible(i),
					fill: decodeFill(el, i, count),
					chart: chart,
					el: el
				};
			}

			meta.$filler = source;
			sources.push(source);
		}

		for (i = 0; i < count; ++i) {
			source = sources[i];
			if (!source) {
				continue;
			}

			source.fill = resolveTarget(sources, i, propagate);
			source.boundary = computeBoundary(source);
			source.mapper = createMapper(source);
		}
	},

	beforeDatasetsDraw: function(chart) {
		var metasets = chart._getSortedVisibleDatasetMetas();
		var ctx = chart.ctx;
		var meta, i, el, view, points, mapper, color;

		for (i = metasets.length - 1; i >= 0; --i) {
			meta = metasets[i].$filler;

			if (!meta || !meta.visible) {
				continue;
			}

			el = meta.el;
			view = el._view;
			points = el._children || [];
			mapper = meta.mapper;
			color = view.backgroundColor || core_defaults.global.defaultColor;

			if (mapper && color && points.length) {
				helpers$1.canvas.clipArea(ctx, chart.chartArea);
				doFill(ctx, points, mapper, view, color, el._loop);
				helpers$1.canvas.unclipArea(ctx);
			}
		}
	}
};

var getRtlHelper$1 = helpers$1.rtl.getRtlAdapter;
var noop$1 = helpers$1.noop;
var valueOrDefault$e = helpers$1.valueOrDefault;

core_defaults._set('global', {
	legend: {
		display: true,
		position: 'top',
		align: 'center',
		fullWidth: true,
		reverse: false,
		weight: 1000,

		// a callback that will handle
		onClick: function(e, legendItem) {
			var index = legendItem.datasetIndex;
			var ci = this.chart;
			var meta = ci.getDatasetMeta(index);

			// See controller.isDatasetVisible comment
			meta.hidden = meta.hidden === null ? !ci.data.datasets[index].hidden : null;

			// We hid a dataset ... rerender the chart
			ci.update();
		},

		onHover: null,
		onLeave: null,

		labels: {
			boxWidth: 40,
			padding: 10,
			// Generates labels shown in the legend
			// Valid properties to return:
			// text : text to display
			// fillStyle : fill of coloured box
			// strokeStyle: stroke of coloured box
			// hidden : if this legend item refers to a hidden item
			// lineCap : cap style for line
			// lineDash
			// lineDashOffset :
			// lineJoin :
			// lineWidth :
			generateLabels: function(chart) {
				var datasets = chart.data.datasets;
				var options = chart.options.legend || {};
				var usePointStyle = options.labels && options.labels.usePointStyle;

				return chart._getSortedDatasetMetas().map(function(meta) {
					var style = meta.controller.getStyle(usePointStyle ? 0 : undefined);

					return {
						text: datasets[meta.index].label,
						fillStyle: style.backgroundColor,
						hidden: !chart.isDatasetVisible(meta.index),
						lineCap: style.borderCapStyle,
						lineDash: style.borderDash,
						lineDashOffset: style.borderDashOffset,
						lineJoin: style.borderJoinStyle,
						lineWidth: style.borderWidth,
						strokeStyle: style.borderColor,
						pointStyle: style.pointStyle,
						rotation: style.rotation,

						// Below is extra data used for toggling the datasets
						datasetIndex: meta.index
					};
				}, this);
			}
		}
	},

	legendCallback: function(chart) {
		var list = document.createElement('ul');
		var datasets = chart.data.datasets;
		var i, ilen, listItem, listItemSpan;

		list.setAttribute('class', chart.id + '-legend');

		for (i = 0, ilen = datasets.length; i < ilen; i++) {
			listItem = list.appendChild(document.createElement('li'));
			listItemSpan = listItem.appendChild(document.createElement('span'));
			listItemSpan.style.backgroundColor = datasets[i].backgroundColor;
			if (datasets[i].label) {
				listItem.appendChild(document.createTextNode(datasets[i].label));
			}
		}

		return list.outerHTML;
	}
});

/**
 * Helper function to get the box width based on the usePointStyle option
 * @param {object} labelopts - the label options on the legend
 * @param {number} fontSize - the label font size
 * @return {number} width of the color box area
 */
function getBoxWidth(labelOpts, fontSize) {
	return labelOpts.usePointStyle && labelOpts.boxWidth > fontSize ?
		fontSize :
		labelOpts.boxWidth;
}

/**
 * IMPORTANT: this class is exposed publicly as Chart.Legend, backward compatibility required!
 */
var Legend = core_element.extend({

	initialize: function(config) {
		var me = this;
		helpers$1.extend(me, config);

		// Contains hit boxes for each dataset (in dataset order)
		me.legendHitBoxes = [];

		/**
 		 * @private
 		 */
		me._hoveredItem = null;

		// Are we in doughnut mode which has a different data type
		me.doughnutMode = false;
	},

	// These methods are ordered by lifecycle. Utilities then follow.
	// Any function defined here is inherited by all legend types.
	// Any function can be extended by the legend type

	beforeUpdate: noop$1,
	update: function(maxWidth, maxHeight, margins) {
		var me = this;

		// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
		me.beforeUpdate();

		// Absorb the master measurements
		me.maxWidth = maxWidth;
		me.maxHeight = maxHeight;
		me.margins = margins;

		// Dimensions
		me.beforeSetDimensions();
		me.setDimensions();
		me.afterSetDimensions();
		// Labels
		me.beforeBuildLabels();
		me.buildLabels();
		me.afterBuildLabels();

		// Fit
		me.beforeFit();
		me.fit();
		me.afterFit();
		//
		me.afterUpdate();

		return me.minSize;
	},
	afterUpdate: noop$1,

	//

	beforeSetDimensions: noop$1,
	setDimensions: function() {
		var me = this;
		// Set the unconstrained dimension before label rotation
		if (me.isHorizontal()) {
			// Reset position before calculating rotation
			me.width = me.maxWidth;
			me.left = 0;
			me.right = me.width;
		} else {
			me.height = me.maxHeight;

			// Reset position before calculating rotation
			me.top = 0;
			me.bottom = me.height;
		}

		// Reset padding
		me.paddingLeft = 0;
		me.paddingTop = 0;
		me.paddingRight = 0;
		me.paddingBottom = 0;

		// Reset minSize
		me.minSize = {
			width: 0,
			height: 0
		};
	},
	afterSetDimensions: noop$1,

	//

	beforeBuildLabels: noop$1,
	buildLabels: function() {
		var me = this;
		var labelOpts = me.options.labels || {};
		var legendItems = helpers$1.callback(labelOpts.generateLabels, [me.chart], me) || [];

		if (labelOpts.filter) {
			legendItems = legendItems.filter(function(item) {
				return labelOpts.filter(item, me.chart.data);
			});
		}

		if (me.options.reverse) {
			legendItems.reverse();
		}

		me.legendItems = legendItems;
	},
	afterBuildLabels: noop$1,

	//

	beforeFit: noop$1,
	fit: function() {
		var me = this;
		var opts = me.options;
		var labelOpts = opts.labels;
		var display = opts.display;

		var ctx = me.ctx;

		var labelFont = helpers$1.options._parseFont(labelOpts);
		var fontSize = labelFont.size;

		// Reset hit boxes
		var hitboxes = me.legendHitBoxes = [];

		var minSize = me.minSize;
		var isHorizontal = me.isHorizontal();

		if (isHorizontal) {
			minSize.width = me.maxWidth; // fill all the width
			minSize.height = display ? 10 : 0;
		} else {
			minSize.width = display ? 10 : 0;
			minSize.height = me.maxHeight; // fill all the height
		}

		// Increase sizes here
		if (!display) {
			me.width = minSize.width = me.height = minSize.height = 0;
			return;
		}
		ctx.font = labelFont.string;

		if (isHorizontal) {
			// Labels

			// Width of each line of legend boxes. Labels wrap onto multiple lines when there are too many to fit on one
			var lineWidths = me.lineWidths = [0];
			var totalHeight = 0;

			ctx.textAlign = 'left';
			ctx.textBaseline = 'middle';

			helpers$1.each(me.legendItems, function(legendItem, i) {
				var boxWidth = getBoxWidth(labelOpts, fontSize);
				var width = boxWidth + (fontSize / 2) + ctx.measureText(legendItem.text).width;

				if (i === 0 || lineWidths[lineWidths.length - 1] + width + 2 * labelOpts.padding > minSize.width) {
					totalHeight += fontSize + labelOpts.padding;
					lineWidths[lineWidths.length - (i > 0 ? 0 : 1)] = 0;
				}

				// Store the hitbox width and height here. Final position will be updated in `draw`
				hitboxes[i] = {
					left: 0,
					top: 0,
					width: width,
					height: fontSize
				};

				lineWidths[lineWidths.length - 1] += width + labelOpts.padding;
			});

			minSize.height += totalHeight;

		} else {
			var vPadding = labelOpts.padding;
			var columnWidths = me.columnWidths = [];
			var columnHeights = me.columnHeights = [];
			var totalWidth = labelOpts.padding;
			var currentColWidth = 0;
			var currentColHeight = 0;

			helpers$1.each(me.legendItems, function(legendItem, i) {
				var boxWidth = getBoxWidth(labelOpts, fontSize);
				var itemWidth = boxWidth + (fontSize / 2) + ctx.measureText(legendItem.text).width;

				// If too tall, go to new column
				if (i > 0 && currentColHeight + fontSize + 2 * vPadding > minSize.height) {
					totalWidth += currentColWidth + labelOpts.padding;
					columnWidths.push(currentColWidth); // previous column width
					columnHeights.push(currentColHeight);
					currentColWidth = 0;
					currentColHeight = 0;
				}

				// Get max width
				currentColWidth = Math.max(currentColWidth, itemWidth);
				currentColHeight += fontSize + vPadding;

				// Store the hitbox width and height here. Final position will be updated in `draw`
				hitboxes[i] = {
					left: 0,
					top: 0,
					width: itemWidth,
					height: fontSize
				};
			});

			totalWidth += currentColWidth;
			columnWidths.push(currentColWidth);
			columnHeights.push(currentColHeight);
			minSize.width += totalWidth;
		}

		me.width = minSize.width;
		me.height = minSize.height;
	},
	afterFit: noop$1,

	// Shared Methods
	isHorizontal: function() {
		return this.options.position === 'top' || this.options.position === 'bottom';
	},

	// Actually draw the legend on the canvas
	draw: function() {
		var me = this;
		var opts = me.options;
		var labelOpts = opts.labels;
		var globalDefaults = core_defaults.global;
		var defaultColor = globalDefaults.defaultColor;
		var lineDefault = globalDefaults.elements.line;
		var legendHeight = me.height;
		var columnHeights = me.columnHeights;
		var legendWidth = me.width;
		var lineWidths = me.lineWidths;

		if (!opts.display) {
			return;
		}

		var rtlHelper = getRtlHelper$1(opts.rtl, me.left, me.minSize.width);
		var ctx = me.ctx;
		var fontColor = valueOrDefault$e(labelOpts.fontColor, globalDefaults.defaultFontColor);
		var labelFont = helpers$1.options._parseFont(labelOpts);
		var fontSize = labelFont.size;
		var cursor;

		// Canvas setup
		ctx.textAlign = rtlHelper.textAlign('left');
		ctx.textBaseline = 'middle';
		ctx.lineWidth = 0.5;
		ctx.strokeStyle = fontColor; // for strikethrough effect
		ctx.fillStyle = fontColor; // render in correct colour
		ctx.font = labelFont.string;

		var boxWidth = getBoxWidth(labelOpts, fontSize);
		var hitboxes = me.legendHitBoxes;

		// current position
		var drawLegendBox = function(x, y, legendItem) {
			if (isNaN(boxWidth) || boxWidth <= 0) {
				return;
			}

			// Set the ctx for the box
			ctx.save();

			var lineWidth = valueOrDefault$e(legendItem.lineWidth, lineDefault.borderWidth);
			ctx.fillStyle = valueOrDefault$e(legendItem.fillStyle, defaultColor);
			ctx.lineCap = valueOrDefault$e(legendItem.lineCap, lineDefault.borderCapStyle);
			ctx.lineDashOffset = valueOrDefault$e(legendItem.lineDashOffset, lineDefault.borderDashOffset);
			ctx.lineJoin = valueOrDefault$e(legendItem.lineJoin, lineDefault.borderJoinStyle);
			ctx.lineWidth = lineWidth;
			ctx.strokeStyle = valueOrDefault$e(legendItem.strokeStyle, defaultColor);

			if (ctx.setLineDash) {
				// IE 9 and 10 do not support line dash
				ctx.setLineDash(valueOrDefault$e(legendItem.lineDash, lineDefault.borderDash));
			}

			if (labelOpts && labelOpts.usePointStyle) {
				// Recalculate x and y for drawPoint() because its expecting
				// x and y to be center of figure (instead of top left)
				var radius = boxWidth * Math.SQRT2 / 2;
				var centerX = rtlHelper.xPlus(x, boxWidth / 2);
				var centerY = y + fontSize / 2;

				// Draw pointStyle as legend symbol
				helpers$1.canvas.drawPoint(ctx, legendItem.pointStyle, radius, centerX, centerY, legendItem.rotation);
			} else {
				// Draw box as legend symbol
				ctx.fillRect(rtlHelper.leftForLtr(x, boxWidth), y, boxWidth, fontSize);
				if (lineWidth !== 0) {
					ctx.strokeRect(rtlHelper.leftForLtr(x, boxWidth), y, boxWidth, fontSize);
				}
			}

			ctx.restore();
		};

		var fillText = function(x, y, legendItem, textWidth) {
			var halfFontSize = fontSize / 2;
			var xLeft = rtlHelper.xPlus(x, boxWidth + halfFontSize);
			var yMiddle = y + halfFontSize;

			ctx.fillText(legendItem.text, xLeft, yMiddle);

			if (legendItem.hidden) {
				// Strikethrough the text if hidden
				ctx.beginPath();
				ctx.lineWidth = 2;
				ctx.moveTo(xLeft, yMiddle);
				ctx.lineTo(rtlHelper.xPlus(xLeft, textWidth), yMiddle);
				ctx.stroke();
			}
		};

		var alignmentOffset = function(dimension, blockSize) {
			switch (opts.align) {
			case 'start':
				return labelOpts.padding;
			case 'end':
				return dimension - blockSize;
			default: // center
				return (dimension - blockSize + labelOpts.padding) / 2;
			}
		};

		// Horizontal
		var isHorizontal = me.isHorizontal();
		if (isHorizontal) {
			cursor = {
				x: me.left + alignmentOffset(legendWidth, lineWidths[0]),
				y: me.top + labelOpts.padding,
				line: 0
			};
		} else {
			cursor = {
				x: me.left + labelOpts.padding,
				y: me.top + alignmentOffset(legendHeight, columnHeights[0]),
				line: 0
			};
		}

		helpers$1.rtl.overrideTextDirection(me.ctx, opts.textDirection);

		var itemHeight = fontSize + labelOpts.padding;
		helpers$1.each(me.legendItems, function(legendItem, i) {
			var textWidth = ctx.measureText(legendItem.text).width;
			var width = boxWidth + (fontSize / 2) + textWidth;
			var x = cursor.x;
			var y = cursor.y;

			rtlHelper.setWidth(me.minSize.width);

			// Use (me.left + me.minSize.width) and (me.top + me.minSize.height)
			// instead of me.right and me.bottom because me.width and me.height
			// may have been changed since me.minSize was calculated
			if (isHorizontal) {
				if (i > 0 && x + width + labelOpts.padding > me.left + me.minSize.width) {
					y = cursor.y += itemHeight;
					cursor.line++;
					x = cursor.x = me.left + alignmentOffset(legendWidth, lineWidths[cursor.line]);
				}
			} else if (i > 0 && y + itemHeight > me.top + me.minSize.height) {
				x = cursor.x = x + me.columnWidths[cursor.line] + labelOpts.padding;
				cursor.line++;
				y = cursor.y = me.top + alignmentOffset(legendHeight, columnHeights[cursor.line]);
			}

			var realX = rtlHelper.x(x);

			drawLegendBox(realX, y, legendItem);

			hitboxes[i].left = rtlHelper.leftForLtr(realX, hitboxes[i].width);
			hitboxes[i].top = y;

			// Fill the actual label
			fillText(realX, y, legendItem, textWidth);

			if (isHorizontal) {
				cursor.x += width + labelOpts.padding;
			} else {
				cursor.y += itemHeight;
			}
		});

		helpers$1.rtl.restoreTextDirection(me.ctx, opts.textDirection);
	},

	/**
	 * @private
	 */
	_getLegendItemAt: function(x, y) {
		var me = this;
		var i, hitBox, lh;

		if (x >= me.left && x <= me.right && y >= me.top && y <= me.bottom) {
			// See if we are touching one of the dataset boxes
			lh = me.legendHitBoxes;
			for (i = 0; i < lh.length; ++i) {
				hitBox = lh[i];

				if (x >= hitBox.left && x <= hitBox.left + hitBox.width && y >= hitBox.top && y <= hitBox.top + hitBox.height) {
					// Touching an element
					return me.legendItems[i];
				}
			}
		}

		return null;
	},

	/**
	 * Handle an event
	 * @private
	 * @param {IEvent} event - The event to handle
	 */
	handleEvent: function(e) {
		var me = this;
		var opts = me.options;
		var type = e.type === 'mouseup' ? 'click' : e.type;
		var hoveredItem;

		if (type === 'mousemove') {
			if (!opts.onHover && !opts.onLeave) {
				return;
			}
		} else if (type === 'click') {
			if (!opts.onClick) {
				return;
			}
		} else {
			return;
		}

		// Chart event already has relative position in it
		hoveredItem = me._getLegendItemAt(e.x, e.y);

		if (type === 'click') {
			if (hoveredItem && opts.onClick) {
				// use e.native for backwards compatibility
				opts.onClick.call(me, e.native, hoveredItem);
			}
		} else {
			if (opts.onLeave && hoveredItem !== me._hoveredItem) {
				if (me._hoveredItem) {
					opts.onLeave.call(me, e.native, me._hoveredItem);
				}
				me._hoveredItem = hoveredItem;
			}

			if (opts.onHover && hoveredItem) {
				// use e.native for backwards compatibility
				opts.onHover.call(me, e.native, hoveredItem);
			}
		}
	}
});

function createNewLegendAndAttach(chart, legendOpts) {
	var legend = new Legend({
		ctx: chart.ctx,
		options: legendOpts,
		chart: chart
	});

	core_layouts.configure(chart, legend, legendOpts);
	core_layouts.addBox(chart, legend);
	chart.legend = legend;
}

var plugin_legend = {
	id: 'legend',

	/**
	 * Backward compatibility: since 2.1.5, the legend is registered as a plugin, making
	 * Chart.Legend obsolete. To avoid a breaking change, we export the Legend as part of
	 * the plugin, which one will be re-exposed in the chart.js file.
	 * https://github.com/chartjs/Chart.js/pull/2640
	 * @private
	 */
	_element: Legend,

	beforeInit: function(chart) {
		var legendOpts = chart.options.legend;

		if (legendOpts) {
			createNewLegendAndAttach(chart, legendOpts);
		}
	},

	beforeUpdate: function(chart) {
		var legendOpts = chart.options.legend;
		var legend = chart.legend;

		if (legendOpts) {
			helpers$1.mergeIf(legendOpts, core_defaults.global.legend);

			if (legend) {
				core_layouts.configure(chart, legend, legendOpts);
				legend.options = legendOpts;
			} else {
				createNewLegendAndAttach(chart, legendOpts);
			}
		} else if (legend) {
			core_layouts.removeBox(chart, legend);
			delete chart.legend;
		}
	},

	afterEvent: function(chart, e) {
		var legend = chart.legend;
		if (legend) {
			legend.handleEvent(e);
		}
	}
};

var noop$2 = helpers$1.noop;

core_defaults._set('global', {
	title: {
		display: false,
		fontStyle: 'bold',
		fullWidth: true,
		padding: 10,
		position: 'top',
		text: '',
		weight: 2000         // by default greater than legend (1000) to be above
	}
});

/**
 * IMPORTANT: this class is exposed publicly as Chart.Legend, backward compatibility required!
 */
var Title = core_element.extend({
	initialize: function(config) {
		var me = this;
		helpers$1.extend(me, config);

		// Contains hit boxes for each dataset (in dataset order)
		me.legendHitBoxes = [];
	},

	// These methods are ordered by lifecycle. Utilities then follow.

	beforeUpdate: noop$2,
	update: function(maxWidth, maxHeight, margins) {
		var me = this;

		// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
		me.beforeUpdate();

		// Absorb the master measurements
		me.maxWidth = maxWidth;
		me.maxHeight = maxHeight;
		me.margins = margins;

		// Dimensions
		me.beforeSetDimensions();
		me.setDimensions();
		me.afterSetDimensions();
		// Labels
		me.beforeBuildLabels();
		me.buildLabels();
		me.afterBuildLabels();

		// Fit
		me.beforeFit();
		me.fit();
		me.afterFit();
		//
		me.afterUpdate();

		return me.minSize;

	},
	afterUpdate: noop$2,

	//

	beforeSetDimensions: noop$2,
	setDimensions: function() {
		var me = this;
		// Set the unconstrained dimension before label rotation
		if (me.isHorizontal()) {
			// Reset position before calculating rotation
			me.width = me.maxWidth;
			me.left = 0;
			me.right = me.width;
		} else {
			me.height = me.maxHeight;

			// Reset position before calculating rotation
			me.top = 0;
			me.bottom = me.height;
		}

		// Reset padding
		me.paddingLeft = 0;
		me.paddingTop = 0;
		me.paddingRight = 0;
		me.paddingBottom = 0;

		// Reset minSize
		me.minSize = {
			width: 0,
			height: 0
		};
	},
	afterSetDimensions: noop$2,

	//

	beforeBuildLabels: noop$2,
	buildLabels: noop$2,
	afterBuildLabels: noop$2,

	//

	beforeFit: noop$2,
	fit: function() {
		var me = this;
		var opts = me.options;
		var minSize = me.minSize = {};
		var isHorizontal = me.isHorizontal();
		var lineCount, textSize;

		if (!opts.display) {
			me.width = minSize.width = me.height = minSize.height = 0;
			return;
		}

		lineCount = helpers$1.isArray(opts.text) ? opts.text.length : 1;
		textSize = lineCount * helpers$1.options._parseFont(opts).lineHeight + opts.padding * 2;

		me.width = minSize.width = isHorizontal ? me.maxWidth : textSize;
		me.height = minSize.height = isHorizontal ? textSize : me.maxHeight;
	},
	afterFit: noop$2,

	// Shared Methods
	isHorizontal: function() {
		var pos = this.options.position;
		return pos === 'top' || pos === 'bottom';
	},

	// Actually draw the title block on the canvas
	draw: function() {
		var me = this;
		var ctx = me.ctx;
		var opts = me.options;

		if (!opts.display) {
			return;
		}

		var fontOpts = helpers$1.options._parseFont(opts);
		var lineHeight = fontOpts.lineHeight;
		var offset = lineHeight / 2 + opts.padding;
		var rotation = 0;
		var top = me.top;
		var left = me.left;
		var bottom = me.bottom;
		var right = me.right;
		var maxWidth, titleX, titleY;

		ctx.fillStyle = helpers$1.valueOrDefault(opts.fontColor, core_defaults.global.defaultFontColor); // render in correct colour
		ctx.font = fontOpts.string;

		// Horizontal
		if (me.isHorizontal()) {
			titleX = left + ((right - left) / 2); // midpoint of the width
			titleY = top + offset;
			maxWidth = right - left;
		} else {
			titleX = opts.position === 'left' ? left + offset : right - offset;
			titleY = top + ((bottom - top) / 2);
			maxWidth = bottom - top;
			rotation = Math.PI * (opts.position === 'left' ? -0.5 : 0.5);
		}

		ctx.save();
		ctx.translate(titleX, titleY);
		ctx.rotate(rotation);
		ctx.textAlign = 'center';
		ctx.textBaseline = 'middle';

		var text = opts.text;
		if (helpers$1.isArray(text)) {
			var y = 0;
			for (var i = 0; i < text.length; ++i) {
				ctx.fillText(text[i], 0, y, maxWidth);
				y += lineHeight;
			}
		} else {
			ctx.fillText(text, 0, 0, maxWidth);
		}

		ctx.restore();
	}
});

function createNewTitleBlockAndAttach(chart, titleOpts) {
	var title = new Title({
		ctx: chart.ctx,
		options: titleOpts,
		chart: chart
	});

	core_layouts.configure(chart, title, titleOpts);
	core_layouts.addBox(chart, title);
	chart.titleBlock = title;
}

var plugin_title = {
	id: 'title',

	/**
	 * Backward compatibility: since 2.1.5, the title is registered as a plugin, making
	 * Chart.Title obsolete. To avoid a breaking change, we export the Title as part of
	 * the plugin, which one will be re-exposed in the chart.js file.
	 * https://github.com/chartjs/Chart.js/pull/2640
	 * @private
	 */
	_element: Title,

	beforeInit: function(chart) {
		var titleOpts = chart.options.title;

		if (titleOpts) {
			createNewTitleBlockAndAttach(chart, titleOpts);
		}
	},

	beforeUpdate: function(chart) {
		var titleOpts = chart.options.title;
		var titleBlock = chart.titleBlock;

		if (titleOpts) {
			helpers$1.mergeIf(titleOpts, core_defaults.global.title);

			if (titleBlock) {
				core_layouts.configure(chart, titleBlock, titleOpts);
				titleBlock.options = titleOpts;
			} else {
				createNewTitleBlockAndAttach(chart, titleOpts);
			}
		} else if (titleBlock) {
			core_layouts.removeBox(chart, titleBlock);
			delete chart.titleBlock;
		}
	}
};

var plugins = {};
var filler = plugin_filler;
var legend = plugin_legend;
var title = plugin_title;
plugins.filler = filler;
plugins.legend = legend;
plugins.title = title;

/**
 * @namespace Chart
 */


core_controller.helpers = helpers$1;

// @todo dispatch these helpers into appropriated helpers/helpers.* file and write unit tests!
core_helpers();

core_controller._adapters = core_adapters;
core_controller.Animation = core_animation;
core_controller.animationService = core_animations;
core_controller.controllers = controllers;
core_controller.DatasetController = core_datasetController;
core_controller.defaults = core_defaults;
core_controller.Element = core_element;
core_controller.elements = elements;
core_controller.Interaction = core_interaction;
core_controller.layouts = core_layouts;
core_controller.platform = platform;
core_controller.plugins = core_plugins;
core_controller.Scale = core_scale;
core_controller.scaleService = core_scaleService;
core_controller.Ticks = core_ticks;
core_controller.Tooltip = core_tooltip;

// Register built-in scales

core_controller.helpers.each(scales, function(scale, type) {
	core_controller.scaleService.registerScaleType(type, scale, scale._defaults);
});

// Load to register built-in adapters (as side effects)


// Loading built-in plugins

for (var k in plugins) {
	if (plugins.hasOwnProperty(k)) {
		core_controller.plugins.register(plugins[k]);
	}
}

core_controller.platform.initialize();

var src = core_controller;
if (typeof window !== 'undefined') {
	window.Chart = core_controller;
}

// DEPRECATIONS

/**
 * Provided for backward compatibility, not available anymore
 * @namespace Chart.Chart
 * @deprecated since version 2.8.0
 * @todo remove at version 3
 * @private
 */
core_controller.Chart = core_controller;

/**
 * Provided for backward compatibility, not available anymore
 * @namespace Chart.Legend
 * @deprecated since version 2.1.5
 * @todo remove at version 3
 * @private
 */
core_controller.Legend = plugins.legend._element;

/**
 * Provided for backward compatibility, not available anymore
 * @namespace Chart.Title
 * @deprecated since version 2.1.5
 * @todo remove at version 3
 * @private
 */
core_controller.Title = plugins.title._element;

/**
 * Provided for backward compatibility, use Chart.plugins instead
 * @namespace Chart.pluginService
 * @deprecated since version 2.1.5
 * @todo remove at version 3
 * @private
 */
core_controller.pluginService = core_controller.plugins;

/**
 * Provided for backward compatibility, inheriting from Chart.PlugingBase has no
 * effect, instead simply create/register plugins via plain JavaScript objects.
 * @interface Chart.PluginBase
 * @deprecated since version 2.5.0
 * @todo remove at version 3
 * @private
 */
core_controller.PluginBase = core_controller.Element.extend({});

/**
 * Provided for backward compatibility, use Chart.helpers.canvas instead.
 * @namespace Chart.canvasHelpers
 * @deprecated since version 2.6.0
 * @todo remove at version 3
 * @private
 */
core_controller.canvasHelpers = core_controller.helpers.canvas;

/**
 * Provided for backward compatibility, use Chart.layouts instead.
 * @namespace Chart.layoutService
 * @deprecated since version 2.7.3
 * @todo remove at version 3
 * @private
 */
core_controller.layoutService = core_controller.layouts;

/**
 * Provided for backward compatibility, not available anymore.
 * @namespace Chart.LinearScaleBase
 * @deprecated since version 2.8
 * @todo remove at version 3
 * @private
 */
core_controller.LinearScaleBase = scale_linearbase;

/**
 * Provided for backward compatibility, instead we should create a new Chart
 * by setting the type in the config (`new Chart(id, {type: '{chart-type}'}`).
 * @deprecated since version 2.8.0
 * @todo remove at version 3
 */
core_controller.helpers.each(
	[
		'Bar',
		'Bubble',
		'Doughnut',
		'Line',
		'PolarArea',
		'Radar',
		'Scatter'
	],
	function(klass) {
		core_controller[klass] = function(ctx, cfg) {
			return new core_controller(ctx, core_controller.helpers.merge(cfg || {}, {
				type: klass.charAt(0).toLowerCase() + klass.slice(1)
			}));
		};
	}
);

return src;

})));


/***/ }),
/* 576 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components__ = __webpack_require__(2);
/* harmony default export */ __webpack_exports__["a"] = (function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'logo '+__WEBPACK_IMPORTED_MODULE_2__styles__["_4" /* LogoStyle */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:'/'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["Y" /* RM */],{width:38,height:15}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'logo--label'},'Brand Center')));});

/***/ }),
/* 577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_Router__ = __webpack_require__(12);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Base=function(_Component){_inherits(Base,_Component);function Base(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Base);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Base.__proto__||Object.getPrototypeOf(Base)).call.apply(_ref,[this].concat(args))),_this),_this.state={push:{},categories:{},background:''},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Base,[{key:'componentDidMount',value:function componentDidMount(){}},{key:'render',value:function render(){var _props=this.props,push=_props.push,categories=_props.categories,type=_props.type,load=_props.load;var picture=push&&push.picture?push.picture:'';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'panel-inner '+Object(__WEBPACK_IMPORTED_MODULE_4__styles__["g" /* BaseStyle */])(picture,load)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'flex panel-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'panel-inner--categories flex'},categories&&categories.map(function(category,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'panel-inner--category category',key:Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["uniqueId"])(category.name)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'category-name'},category.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'reset'},category.menu&&category.menu.map(function(item){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'category-item',key:Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["uniqueId"])(category.label)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* NavLink */],{to:item.url},item.label));})),type==='models'&&index===0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:__WEBPACK_IMPORTED_MODULE_5__services_Router__["a" /* default */].models.path,className:'link-all'},' All models'));}),type==='brand'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'panel-inner--category category'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'category-name'},'Charity'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'reset'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'category-item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* NavLink */],{to:'/brand/charity'},'Paris Brain Institute'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'panel-inner--push'},push&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["U" /* PushContent */],push))));}}]);return Base;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Base);

/***/ }),
/* 578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__static_montre_jpg__ = __webpack_require__(579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__static_montre_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__static_montre_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_Router__ = __webpack_require__(12);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CHALLENGE_ROLE=['ROLE_SELLER','ROLE_STORE_MANAGER'];var Challenge=function(_Component){_inherits(Challenge,_Component);function Challenge(){_classCallCheck(this,Challenge);return _possibleConstructorReturn(this,(Challenge.__proto__||Object.getPrototypeOf(Challenge)).apply(this,arguments));}_createClass(Challenge,[{key:'render',value:function render(){var _props=this.props,role=_props.role,menu=_props.menu,load=_props.load;var gift=menu.challenge.gift;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'page-inner panel-challenge '+Object(__WEBPACK_IMPORTED_MODULE_1__styles__["v" /* ChallengePanelStyle */])(__WEBPACK_IMPORTED_MODULE_4__static_montre_jpg___default.a,load)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'panel-challenge-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'flex challenge-panel-top'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'challenge-panel-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'title'},'Challenge')),CHALLENGE_ROLE.indexOf(role)!==-1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'challenge-panel-ranking flex'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ranking-push'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["q" /* CurrentRanking */],{preview:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ranking-push'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["Z" /* RankingIQ */],{preview:true})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'challenge-panel-push flex'},gift&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'push'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["U" /* PushContent */],Object.assign({},gift,{description:'',page:__WEBPACK_IMPORTED_MODULE_5__services_Router__["a" /* default */].hubQuizz.path,label:'Discover',picture:gift.image}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'push'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["V" /* PushQuizz */],null)))));}}]);return Challenge;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(function(_ref){var Session=_ref.Session;return{menu:Session.menu,role:Session.role};})(Challenge));

/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/montre.02289be1.jpg";

/***/ }),
/* 580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Panel__ = __webpack_require__(166);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var HeaderMobile=function(_Component){_inherits(HeaderMobile,_Component);function HeaderMobile(){var _ref;var _temp,_this,_ret;_classCallCheck(this,HeaderMobile);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=HeaderMobile.__proto__||Object.getPrototypeOf(HeaderMobile)).call.apply(_ref,[this].concat(args))),_this),_this.state={navPanel:false,accountPanel:false,notificationPanel:false,panelItem:'',load:false,open:false// mobileMenu: false,
},_this.getPanelItem=function(val){return function(e){e.preventDefault();_this.hasActive();_this.setState({load:false});_this.timeout=setTimeout(function(){_this.setState({panelItem:val!==_this.state.panelItem?val:'',navPanel:val!==_this.state.panelItem,load:true,notificationPanel:false,open:val==='search'?false:_this.state.open},function(){document.body.style.overflow=val!==_this.state.panelItem?'auto':'hidden';if(!_this.state.open&&_this.state.panelItem==='')_this.disableActive();});},_this.state.navPanel?300:0);};},_this.updateNotificationPanel=function(){_this.setState({notificationPanel:!_this.state.notificationPanel,accountPanel:false,open:false,panelItem:'',navPanel:false},function(){if(_this.state.notificationPanel)_this.hasActive();else _this.disableActive();});},_this.handlerOpenMenu=function(e){_this.setState({open:!_this.state.open,notificationPanel:false,panelItem:'',navPanel:false},function(){document.body.style.overflow='hidden';if(_this.state.open)_this.hasActive();else _this.disableActive();});},_this.updateAccountPanel=function(){_this.setState({accountPanel:!_this.state.accountPanel,notificationPanel:false});},_this.closeMobilePanel=function(){_this.panelBack();_this.setState({open:false},function(){document.body.style.overflow='auto';});_this.disableActive();},_this.hasActive=function(){var elt=document.querySelector('.header .mobile-nav.active, .header .mobile-nav .active');if(elt)elt.classList.add('disable');},_this.disableActive=function(){var elt=document.querySelector('.header .mobile-nav.active.disable, .header .mobile-nav .active.disable');if(elt)elt.classList.remove('disable');},_this.clearPanel=function(){_this.setState({panelItem:'',navPanel:false});},_this.panelBack=function(){_this.clearPanel();_this.setState({accountPanel:false});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(HeaderMobile,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(_ref2){var location=_ref2.location;if(location.pathname!==this.props.location.pathname){this.closeMobilePanel();this.setState({notificationPanel:false});}}},{key:'render',// isActive = (item) => {
//   const location = this.props.location.pathname.split('/')
//   if (item === 'brand') {
//     return location.includes(item) || location.includes('friends-and-partners') || location.includes('materials') || location.includes('complications')
//   }
//   return location.includes(item)
// }
value:function render(){var _state=this.state,navPanel=_state.navPanel,panelItem=_state.panelItem,notificationPanel=_state.notificationPanel,accountPanel=_state.accountPanel,load=_state.load,open=_state.open;var _props=this.props,location=_props.location,username=_props.username;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:Object(__WEBPACK_IMPORTED_MODULE_3__styles__["W" /* HeaderMenuStyle */])(notificationPanel||accountPanel)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'secondary-nav flex '+Object(__WEBPACK_IMPORTED_MODULE_3__styles__["_9" /* MobileNav */])(open)},location.pathname==='/'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["c" /* NavLink */],{to:'/',className:'main-nav--item btn--icon btn search-nav mobile-nav '+(panelItem===''?'in-view':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["_1" /* Search */],{width:24,height:24})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'btn--icon btn search-nav mobile-nav '+(panelItem==='search'?'active':''),onClick:this.getPanelItem('search')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["_1" /* Search */],{width:24,height:24})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'btn--icon btn notification-nav mobile-nav'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["L" /* Notifications */],{open:notificationPanel,callbackClick:this.updateNotificationPanel})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'btn--icon btn bookmarks-nav mobile-nav'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["l" /* Bookmarks */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'btn--icon btn menu-nav mobile-nav',onClick:this.handlerOpenMenu},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'menu-mobile '+Object(__WEBPACK_IMPORTED_MODULE_3__styles__["_8" /* MenuMobileStyle */])(open,navPanel||accountPanel)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'menu-mobile-head flex'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'menu-mobile-return',onClick:this.panelBack},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["f" /* ArrowDrop */],{width:24,height:24})),// Remove test when training panel should be visible
panelItem!=='training'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'menu-mobile-head-title menu-mobile-head-title--'+panelItem},panelItem==='challenge'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'menu-mobile-head-title--inline'},'Challenge '):panelItem!==''?panelItem:username),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'menu-mobile-close',onClick:this.closeMobilePanel},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'reset main-nav'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'main-nav--item '+(panelItem==='news'?'active':''),onClick:this.getPanelItem('news')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'middle'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'News '))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'main-nav--item '+(panelItem==='models'?'active':''),onClick:this.getPanelItem('models')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'middle'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Models '))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'main-nav--item '+(panelItem==='brand'?'active':''),onClick:this.getPanelItem('brand')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'middle'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Brand '))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'main-nav--item item-challenge '+(panelItem==='challenge'?'active':''),onClick:this.getPanelItem('challenge')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'middle'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,' Challenge ')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'profile-nav'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["a" /* Account */],{open:accountPanel,callbackClick:this.updateAccountPanel,clearMobilePanel:this.closeMobilePanel})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'header-outside',onClick:this.closeSecondaryPanel}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Panel__["a" /* default */],{open:navPanel,isLoad:load,content:panelItem,isMobile:true}));}}]);return HeaderMobile;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["g" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(_ref3){var Session=_ref3.Session;return{username:Session.username};})(HeaderMobile)));

/***/ }),
/* 581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_Router__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__static_logo_footer_institut_png__ = __webpack_require__(582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__static_logo_footer_institut_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__static_logo_footer_institut_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_ApiController__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Footer=function(_Component){_inherits(Footer,_Component);function Footer(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Footer);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Footer.__proto__||Object.getPrototypeOf(Footer)).call.apply(_ref,[this].concat(args))),_this),_this.state={counter:'00000',ready:false},_this.getDatas=function(){Object(__WEBPACK_IMPORTED_MODULE_4__services_ApiController__["fetchCounter"])().then(function(data){var counter=data.counter;if(counter.length<5){counter=''+new Array(5-counter.length+1).join('0')+counter;}_this.setState({counter:counter});}).catch(function(err){console.log('Something Wrong with counter',err);});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Footer,[{key:'componentDidMount',value:function componentDidMount(){this.getDatas();}},{key:'render',value:function render(){var counter=this.state.counter;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('footer',{className:'app-footer '+__WEBPACK_IMPORTED_MODULE_5__styles__["_76" /* appFooter */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'counter-wrap'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'counter-logo',src:__WEBPACK_IMPORTED_MODULE_3__static_logo_footer_institut_png___default.a,alt:'Institut du Cerveau'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'counter'},counter.split('').map(function(char,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{key:index},char);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'reset'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* NavLink */],{to:__WEBPACK_IMPORTED_MODULE_2__services_Router__["a" /* default */].contact.path},'Contact'),' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* NavLink */],{to:__WEBPACK_IMPORTED_MODULE_2__services_Router__["a" /* default */].faqs.path},'Q&A'),' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* NavLink */],{to:__WEBPACK_IMPORTED_MODULE_2__services_Router__["a" /* default */].legals.path},'Legal info'),' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* NavLink */],{to:__WEBPACK_IMPORTED_MODULE_2__services_Router__["a" /* default */].privacy.path},'Privacy'),' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* NavLink */],{to:__WEBPACK_IMPORTED_MODULE_2__services_Router__["a" /* default */].sitemap.path},'Sitemap'),' ')));}}]);return Footer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Footer);

/***/ }),
/* 582 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAALYAAAAuCAYAAACFxeMqAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAtqADAAQAAAABAAAALgAAAAAZXzkPAAAYRElEQVR4Ae2dB5RV1b2HRVSKBRUpIgoK2BFLLFEUFERFDVFsKAbfEzWWmCx7NBqNLklMMImxxvLUEKPYG1YEFBQFK6AoFpQmAoINEVTe953Z+75zz9w7c2fm0t6a31rf7L7P3vv8dznnzECD1cqopUuXNqG6rqHK2bjTGjRoML+Ml6ivqn4EShqBNUrKVXqmC8n6u5D9B9xZGPtruI/AYxi5xl5nUWdzKtkhVOR13qTuL+pc8XKsgD6syeV2g37hsgtx76Uf40K43llZRoCb9QuYBgsgqxlEXA4t69JeyjeEgyDqazx716XOcpalLQ3SFKubPE3hFIiah2dAOj/hkupKl6mLf3lfry5tra7s6tVlqEk6q82d5O8M24Or0anwKHwDbcDV/EUGsC9uXbQ0UzgbziQvnyD9asyVrgFX3bEwGGol6nJXuhWs6wVwN1xm4nqtqfw+8Hqj4JdQr6pGgEHbDm6ARaB+hCugxhOLMq7YB0KUK3Y811fVjGWeRjvWhmdCw77HfbzYRUmzHx3h2EBf3M1jfvyt4RVQC0EjX2ai/nbwPqivYNAyu9hyqLikMzad3IS2uApvC+2gBTQF5Wr8GbwL42ECK/di3JwITyJwKvXchXsteD6+CLy5F5K+Uqy4tKcc+j5UYp/yxiFdOX322eD9QDop+i1fUl2xQB3d7PW+q2N9K7R4UcPG4NajZYfBMeCxYkOoTt6sicGAb+PmzU0XIPwCaT2JGwK94DcwDa6Hsoj67VN36AjerFlc95HQnyMId4NmMA9Gw0OkF3xzQxl3lO3gAHBS+8DnA/AbMJpyU3GLybJbUEfc0n8k7FuiJywQ6m6Lt7dhtBCeI316Esr/4XW3T9WlwU8h7yjiGuBvBYeAfV8Ets1Jk1O43sZEHAy27VsYSb6PcbNai4hdU9dzgk4k7yvZjKtUmA4dA5MgrR8ITIdx8ATcC/fBMBgPcyEtt7WCZ2ni14exIbNvTjyXlyTyVnkUId2HMtulPA48DztAvB7enOzTy+BulCfimoDHpS+hkOzvLZBrO36PIo5NIdmWp+JF8K8Fh6QyzsbvZE+EvxX4PFJIHk3uMCPuGtAV7IvyIbR/RS3/95O4NaEXRM3Bc2jMgX8zmBwTM65Hkz/FvKuC6wzPica7MvwFzsxFrrbaGPwPwCj4EBYwc10Jc6KcK4Crxu5wPPSBDjCUtPPJb505EfatyUAiRoMPSefAACiX4hEgrmZDqDhngKmL2O6fwE205yDa9aVp+F2xfPD1uBTliroEXO2V7T4WXoUJUBu5iovtUO54tZF1uAKvDd6bYvWYz7Gxf+Yz/P9SeYZNDwfDr0JP38K9EJ7ghlc5ACF9FnkfEgyjJ+51sCVcRXgmee7CnxNhjywa3Ongw2An4qbkMpTHo8HYBm/0szAMNM69wN3EiWyeHcGtPLZxA/watvKs6ZuOm8CyW4Db+dHgMepOKCTH7F24PSQa/ij4a+p43dfABUZ5FHk78S2bH/bZBe2pUL2TweuvesKwjoSox/G4ItValG8P74QKPW60yVZG3B7wLSwCJ1G1Il8pR5G7yBf1HZ7rIDeJ8XsMOBd8O6MWw41eHHd16AJu9+pT2DjdMMK+X24DTpqcCKePIksIP5hLzHhIsw29IR4hPIr0iNnwp48i3xC+IaalXeI9iuwJvh1SHpH6pfPoJ86jSE9wPNRn4ARNhD99FPH4dWlIWiUdVys73QTn4tCDd3CPZ/WcF8K1cig/lYKngLPfd6QnQVZu4aPBlfMI2rFONkMZwrOpYxDtcZVLhN8V6Db4oCJmNY8stlG5RbtCxvyu3pfTNlfqRJRfCu5C78W4Im7DIvG1iS5nXaVcP7cQlJJ5ZcuTGDaN2hM6h8Zdzg37vBwNpZ7nqefJUNfhGMdamXo1sH+D7dgKukM55fb/CcwsUOki4qJhm5wYDm3WsKfDS0Yi23wi+JDpA/Px0NaEeq28I6BBqe7JT16N4T4R/OVyPHerTrBZ4gs/MCJXxqfhY9CA+kM5pZEu5joaeCF59i6kr4k8G95MJW6E/wi4A8Zh3P+Adqn0eu9KNALRsF0t1TsYwYIKb9l++pCjgXncKbTSuTv4UOTWty/GsiXuClWYCH5U6gUXwRsQjybx2OJD7xO0N+50BFcaOd6FVCy+UN5VOi4adovQC1fscutbKowrZqMClXscGQoeDXyVdiSscGHcnqM/gytpzE+hK/gcEj9SaODuQldi3Mv7/Mtli8p2uftlZby/y7JKn52znSoWjobtA55qWuGU9WcHavPGa9yfZWsOq6MPkS/AsnyIzF665DBtXAQvwxUU2hcuBVc/+9UFPKYUUjlXyGJ1Ge+RKr147FCgMS4qP4F4zwtkyYuK9eVFriqB2MkpocGdWX08MpRF1OUqcUqo7EPc94pU7Kp9J9gejyIazwoT7W4Mg+AMyE52dxbfh8fzuQaQNroYb198JZgbT/xxvEkqSbFeV9m2lHciJUr5vb5vsOIR0vYeRvo+SUZ+4HcFd8eJ9yImpd14LeNcYNrriUpdL0at1G7clp6hlWdAB+gN90OdxEBYt9v4gaGim1nxvilSqTdjIsyAVnAcPArLXbQ72TW48AWg0ZxAnOPxImg8m4APlvZPI3ayaljK/L5eVBrxjuDvqYzFbQk+T/wWSpF1zw0ZNcz94AHqcnezLhejPzOmRC2dj99rbAouJpuDeZ/GdUw7Qg9YFzRg82Tl4mL7lEcWJ8fduB9Aa7D+m2HVER3ww8IkUP6+gANXK1HWDyjd4SmIehZPduVzJYl5P8Tvh4X0x4NtCjUglPFLZZQfJlyNEuFvCvEDjb+f8VxMS7vE2+fHQfkxJZlIuI3Ac3P8cII3J/Ol5YcMF4JE+P1Y4vv4QrKsD8kxb3UfaOzH6YUqIs4PNtem6vLjSw/4AorJcboXLKuyH2jWJe6yJKXyD+u9JF5vVXCTrTGspBfTYGfzVnAPHdm4lA6QryVsAwfD5ZQZAxpTr1D+cdx+XGNhCKcdt9bdwRWmObgyKVcUV41iyq442bD1RsVdKYbTbkyzfFKGdvq84U30q5xt/wqiYv4fiXgbBpJ/WEzE75sTw1eDK2BalpmVjsDvddPHk5w/jNe9pN8O1puW4c9iBHmX4HdHORWmxfjgek+nw9lwPeSORvhz18P/NdwCD0FW7h5zspErczjPIDDMK2ls3CrdYs+Hhxm49Pkr6Q95vcluTf6OxXoQjRJvIrewv8ONYeArYlM/qcMyv4arwO38N+AA+lVvAm4lUcY2Owl8EFIO+njyux27C3izOoMT03bPJ+0V3DyRT0P2qNACzDeHfK/h5hTq6kCE1+oEa8MCsG3+aqj+Sgp170TCXmBb/eWqN2AsZTQg22k/NoJdDCMn1Fukx2NNEkk+x8jJvys0A/v5Ktjnb3FzCu1tS0RPcIGyj96HZ+F98Cuq9XhtJ56/O59nsNTRiPi9wfb7JdgJNA78u1LbuOrJwYY/QHobHkHYv+5Iz25vTBN4D6IW4/FI4Wp/HDiIVYo8bsfngpoOGlm96kdg2YwABvYzeAvSeoyAq1dOhLcDPzH3hu1h3VxiCR7yZw3b1aZe9SOw7EYAo1sHToLXIGoqHreysoi6NOxfh8pdsesNuywjW19J3hm70HBgbE2J9xz8e/D8NQ325bzl2a1ahfJnkbF9gcweb7aD3cDXUntQrw86tRbXs42+qusOt1LfENyyiLo943aHbrAlGPah0HPxZBgFY7hmco7GX6+VfQS4qUeBvzutnoY1S2kz+fa3QAmq9HvPpdSfzcN1fE32Hyj5d7yzdWTD1OUrwFPgbahKPpu8DgMg75kkW2d9eNmOgG82ShKr0FBu1hZkHgT7Q1/wBX51Sr+2G07mzwsU8HWVq138uFEgS+Uo2uOO45sFV31X6ikwC6zPNx2upj7o+mZhU73gH9SabryT03jrMT77is48vl3xL2iOgOqkMfum5WboRVn/LK5OO1B1F6xPL8MIcKNcuVyR1BiodmKQ5xAzB3nTyyLq83x+JnwS6tbxI8QVcDe4u1wAvunpBO4I5t3MBuAa3w6MM23rbMOIawHuTmn50WckXAwngM8hf4Xsw7YfQg7P1lkfXklHgJt1Mii/pFVrqORJG7Zn6TqLOteEgaA0tOEwCDRov15q1GnD3oqwX8/82tbOBuBq2O1hDpiW96WTcGO4BqL8M7Ip0AcqHTOIWw9Oh1ngMeiiqjpKuvk3hPQHk6qKFEyjvP3wq2G1i0zBCkqIDNdYG9f2+m67xqKcX5kdUxckd8hlqtoMxpO0yA8OfpTxIcoPD8tbG3LBc8Cjw41wFlu+51v74xHpdsjKY4hkVSmeevyw4SQ8OWQ2jx84+nKdCSEuzyH+S8rdQOQY6AF/zctAgHSPTcdDH/BYZ3v9i30/DHmsG0Y9yfEJfyLS1sZzNPghzDQ/nF0KToiB4BHJo5YTfQruAPD66lO4jDorHfHIax+3BSeg5RfCEPJ6fxORRyN2PI8CJ77XdFf0QfkBuI/8X+FWEnk8gm4PHlv3AHdKX0R8D3NJH4/7ELxIHT/gJiLe46Fv3s4E2zUD/oc8jlFO5PPouRecBi400+Cf5JuEW3NR4erwCqg7qquBPGVdsanP6+8JGvJs0EByIuzKMgyyK7YGZP52ZsaNK7aruGneuET4/fh0B0R5M4+M6TV1KetqtQ+8BcW0kIRboXm6fsLrw/Wg3J3GgzuNzzxR7hJ7gCuiH8ei/DdGNPRKIj77uyEzidPQHRvbuz08A8XkzvgsJGXSFyBuHTgH3Lmq0lwS/wTrxfL47UM/8P6qd+HgmB5d4rzPJ0LUJDz7xvRKW2pMKOYyI1w1XL1UYiQV3uX2023MlUT3G5gPadm+6emIjH9pKqw/HY5JGtd+IeBq8jq4utRYDLZj7Ip1L3QOFbhqvQkvg6uqcjU8Fq6hjKtdWktCwLba77MhPdGM49Y0WIQ7CmyvcrU/lPpcnbNqRsShIdJP8/4zG771sb1bwr+gJyjb607xEnwEytW0O9xGmba4adlebcRVNcr74id53SjH+QT4FXXYhyjHPH6+t8/pMjGPrvniap+Xz07URrNDoQ2KDFq6zvQ10o1P56mJ3w7MAY8hfrbvBGmtQaBLOiLld5tLG41+sc5EoT+bE2gTorypw7np0bhCdMmOx6a/QUvwOu/AAbAr7Alup/8Ab55tOQiOhULSQDW6/w6JTuzRcA98GuIWhLBBDcvrbG0gij5qlDtDnGhf4bcOtT5cCDuC7Z0GJ4D5batHNCfWl2B7PG6cBzkxVhrlOHgYroO+sAvsBL3gavDdv3Jc+sBWBlaoGBi3D+Xyr7EUFekeG5RbV1kaTz0+eI0At2a3ww42AHcjiG1LjiIhfhPi/bJpG64Cy7eCuMW7ZW8T8q6B/yiIWojnONNqKsr5kDsAoubg0TjyRFxzuCtkWoI7ApqYCdejyN8hLfsxHHaFvMWCsEe1zvApKB+Mz09fkLAL0i2gFsNz4BHAvu8Ljp36HOIkylVBnEeN34LyofpDSO5BLlNF211kKom8zeA0iEcVy/c3I67tcPwddzUZDspWQpxHkRNAG1AToVvMl15NY1wpbjLoZFwMxbaJWM9YPK5Q+zOT342RdXRdqS6Gz6EHjKdTr+C+CmfAJ+ANj/0z32PgSuVD5yTwKHAM2AcnZzQQXfNFuWqZpzay3p+Hgktwn2IMxhSo6Avi/gmudBqDC0DeKks4yq3Xtg+grnFg+3Ii7P2YDvZXNYXejI+uhmP/XCW9J8qx9CHQY4x5HM/G4E41AW6HPJH3ayL+BR+D9Xms6Qp5Ip91eE2fWVx0XEzWJcryL0K0B+2pDZRNBWdUCbVvHPJ8TuPjGadgMdId6KcLJtYy0msyQA7MoXAB7AEd4S04EX4KvWEmePh0BboUr4bWC7xxr8BgOBe8oQtBaShus1FOjhYxUEPX66QNtBHtOKFAHRpHa9C4GsFaoHG/DlnZNn9VQOMtJg3nPugP1mcbdocRoBHtA23BvjpGj4Dyutslvoo02/UL2hyico4RGrPtVZbbJvGFH5Sx796Do8FjjUechmDbpsGnYB3KMbaOsqnGhk2DbZxGpD6ocKr/STnuRf7qUn2p4jmoywnzMvUejusA2Zd5XgMNx38F5ES8A+lTtAO8BuG5JhIeqWM5w8h6XfG/BY3A/u4G10NN5YRxhVJOqiMChquS1yw2mTTskVUVpi8eZ14jz1joBj5EunOMSPnxJpP5GfJPN4A0MMdH2d69A4arku11F0jEtZvj+SOcCE6OtExrl45YFn6NoaayA7FhE9OF6dCuhM+BSxisZJsh7jDCJ0N7/B/hXkPak/h/hv9YmAkXgbO/A1wG7gKDyeeWW6XIs5QMC9KZQlw6KucnLZtXQ86JdM+MU4mYDDuBY9SDuHakfYy/JvL4Icp2OrnmGahGGu9nBfLYVsvPLpCWjXJlvBu6gRPUs3O8d10JK69zT+Kr+GEbF4ew/vkwA7LGGbLkHO/dVENcw0nkTjHQMDLNHdu2OH6uzJuBk6YPFJvAJFUr21hQtTHsTtS0QajtrUytNvgouBbepZOn4N4Ir8NIsDMay5Pg07Tb1DfwCLwIh4PGbpwDXq1hk2dZyNV6KNhWb2or+B2cBFWKPpu/JZNA41sI06E9fA/28zRwZSwkDdfy4uTOyhv5HVhXdbIPw+FD2AI2hl6wCawHGvD4AE4i651a4U2uYboLUKG2mC0alu217Wod6Jv4Ktr6GP7+jIftzolx8q1JO9g/F1nYo41aZ1bGuxsWHMuCkdkaMuFdQtjZnKzKqfQ4AD6pukpcCmNhTzp2Ku7OuINwlXntrKuYk8GZfBhMBhXrqggt35/e9H+DRqHWhOPp02XggBYUaW7jV8HVIYP1jAh+yyWGxRh8n4U0+9uE+B9CWjSaULxmDnVY3lX/wVBSI3BiOtbKFX0o+eKOYpyT4QU9yD53Bu9dpfYaR5r20zCkR8NuRJyTSLla+++x5Bl1klLxnNMm+NOO9Zg/3v8N8HsSyGojIrqBk6qSamPYe4Za3sV1VSokG+Uq1xoeoWN20Ic4b3SUDXJwndH7Q3fwKHI/rFDRTo1iFpwHsc3esAvhYQz4APCVma/WfKXXBvqR9iScDV2Nw7Xsf2Au2N/N4CbSdHMibN2ujL7Cuxwa5xLr5nHn07AdZ6+xD+wMGs/HYHtzCvfpeSJcqVVL8PVoXMySSMK+FtyNgDvQ7fjNF+W9d4Ior9mF9Dw7I+zY9IetISsn2pyAaRuCf5r4X+BrxobQibgzoA8UVNHVp1BuKyY+dtI/THWACikarY3UWIvJDj8Nx8If4T2Ig4p3xYm+ues8SgvOgb+AO4rj1RsOghkwD+yDE7gFRHmjj6KOv1HHB/gvgeuhIRwIo0PdH+FvBnuARuc1vNk+BwyGOin0wQXoOXDiRGnwj5M+N0ak3E/x/wGGwHrg/X6K9g7DnQSu5F2gB7iaLgIfVgdSn/d7IYwGV/vG0Bf8xScXrC9gG/g5uNpWEnWQdelMEqxj85BhC9wb4EL4EjYGx1z7cyI5rrUXF9zFqwbZuDwRf1hI28sE/HeDD2NngGX/DL8EW38BfAEdwYdJX8mdB/vB16DxrHDRDlenI+A9KEXeZFd1b2Ai/N7Y8yF+dMBbUI7BUNgsVdYPNH5mV062l8AFpiSR1w8e/cD7EPUJHg2voEizzHHg76BUJfv6IuweK8LvLuYq/TYU01ckvA4fhQyzcS9O1eEu6AP7+yE963hdy18L34XEibgFJ0ust6hLwVYwBkaCszVPxPl7CRqlK5CG3RLuB987KwfXrdjOnwUzoDWcCtNhW+gJdtTjyUoh2uJEtJ0a52uQNVD75VfFx8Bt05U9T8S5hXaDB8Evemlp0L66HAhu3zkRbgaDwTyOrWNfsmFbEfk3hXFgHfPhDnCnKSrSndBd4FbIGrgT7B34PaR3qqQ+4uzr9nAPpPuqHUyAs2EvGAW2yYl2QboxhBvBfvAspMfb9g+BneFocEysw/vSNdbhkaFGorA3zfe+bgF5Iq0pEZ6t/S/o3KISEe/26tZhvFujg+2DltvwdLDOVqTZQetwsPx3PtzWVirRPo8LbpHtwK16MbilT6W9bqFVivKO+abgOdEx8Dz6CbxP+dyYEU5Efg2wOZhXmWcGed2GS1KowzG1vZbzw9r8UgqHsi3Ja3utw4dG+2l7F+AWFWU9IthXx8vXgJ/DZMpp7E5gbUVXW/I/7TI9T+TzONMR2oL5HKsPgt/+2DblffBfx3U8V/tf114fPfbMVuMAAAAASUVORK5CYII="

/***/ }),
/* 583 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(1);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var children=_ref.children;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:''+__WEBPACK_IMPORTED_MODULE_2__styles__["f" /* AuthStyle */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'auth--middle'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components__["I" /* Logo */],{nClass:'logo',width:'359',height:'28'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:''},'Brand center'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'auth--container'},children)));});

/***/ }),
/* 584 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Login__ = __webpack_require__(585);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__Login__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ForgotPassword__ = __webpack_require__(586);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__ForgotPassword__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EditPassword__ = __webpack_require__(587);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__EditPassword__["a"]; });


/***/ }),
/* 585 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_ga__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_actions_Session__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Login=function(_Component){_inherits(Login,_Component);function Login(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,Login);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Login.__proto__||Object.getPrototypeOf(Login)).call.apply(_ref,[this].concat(args))),_this),_this.state={waiting:false,error:'',form:{}},_this.requestLogin=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return _this.props.logIn(_this.state.form).then(function(){if(_this.props.error&&_this.props.error!=='')_this.setState({error:_this.props.error});}).catch(function(err){console.log('Someting Wrong with Login.',err);});case 2:case'end':return _context.stop();}}},_callee,_this2);})),_this.addFormData=function(data){var form=_this.state.form;var row=[];row[data.key]=data.value;_this.setState({form:Object.assign({},form,row)});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Login,[{key:'componentDidMount',value:function componentDidMount(){__WEBPACK_IMPORTED_MODULE_3_react_ga__["a" /* default */].pageview('/login');}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(_ref3){var _this3=this;var fields=_ref3.fields,error=_ref3.error;if(fields!==this.props.fields){fields.map(function(_ref4){var name=_ref4.name,value=_ref4.value;if(value&&_this3.state[name]!==value){_this3.setState(_defineProperty({},name,value));}return value;});}}},{key:'render',value:function render(){var _this4=this;var fields=this.props.fields;var error=this.state.error;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'login '+__WEBPACK_IMPORTED_MODULE_6__styles__["_3" /* LoginStyle */]},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('form',{className:__WEBPACK_IMPORTED_MODULE_6__styles__["R" /* Form */],onSubmit:this.requestLogin},fields.map(function(field){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components__["x" /* Field */],Object.assign({onChange:_this4.addFormData},field,{key:field.id}),' ',field.placeholder,' ');}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components__["m" /* Button */],{type:'submit',onCallback:this.requestLogin},' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components__["_18" /* User */],{width:'24',height:'24'}),' Log In '),error!==''&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components__["t" /* Error */],null,error)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'login--bottom'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Link */],{to:'/forgot-password'},' Forgot my password ')));}}]);return Login;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */])(function(_ref5){var Session=_ref5.Session;return{fields:Session.fields,error:Session.error&&Session.error.message};},function(dispatch){return{logIn:function logIn(fields){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__store_actions_Session__["f" /* logIn */])(fields));}};})(Login));

/***/ }),
/* 586 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_ga__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_actions_Session__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ForgotPassword=function(_Component){_inherits(ForgotPassword,_Component);function ForgotPassword(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,ForgotPassword);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ForgotPassword.__proto__||Object.getPrototypeOf(ForgotPassword)).call.apply(_ref,[this].concat(args))),_this),_this.state={waiting:false,error:'',success:'',formdata:{}},_this.addFormData=function(data){var formData=_this.state.formData;var row=[];row[data.key]=data.value;_this.setState({formData:Object.assign({},formData,row)});},_this.requestForgotPassword=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return _this.props.forgotPassord(_this.state.formData).then(function(){if(_this.props.error&&_this.props.error!=='')_this.setState({error:_this.props.error});if(_this.props.success&&_this.props.success!=='')_this.setState({success:'An e-mail will have been sent to you at the address that you provided '});}).catch(function(err){console.log(err);});case 2:case'end':return _context.stop();}}},_callee,_this2);})),_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ForgotPassword,[{key:'componentDidMount',value:function componentDidMount(){__WEBPACK_IMPORTED_MODULE_3_react_ga__["a" /* default */].pageview('/forgot-password');}},{key:'render',value:function render(){var fields=this.props.fields;var _state=this.state,error=_state.error,success=_state.success;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'forgot-password'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('form',{className:__WEBPACK_IMPORTED_MODULE_6__styles__["R" /* Form */],onSubmit:this.requestForgotPassword},fields&&fields.email&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components__["x" /* Field */],{onChange:this.addFormData,type:'email',id:fields.email.id,name:fields.email.name,value:fields.email.value,className:''},' Your email '),fields&&fields['_token']&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components__["x" /* Field */],{onChange:this.addFormData,type:'hidden',id:fields['_token'].id,name:fields['_token'].name,value:fields['_token'].value},' Your email '),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components__["m" /* Button */],{type:'submit',onCallback:this.requestForgotPassword},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components__["_18" /* User */],{width:'24',height:'24'}),' Get a new password'),error!==''&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components__["t" /* Error */],null,error),success!==''&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components__["_11" /* Success */],null,success)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'forgot-password--bottom'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["b" /* Link */],{to:'/login',className:__WEBPACK_IMPORTED_MODULE_6__styles__["_2" /* LinkButtonStyle */]},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components__["_18" /* User */],{width:'24',height:'24'}),' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'btn--label'},' Login page '),' ')));}}]);return ForgotPassword;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function(_ref3){var Session=_ref3.Session;return{fields:Session.forgot_password.fields,error:Session.error&&Session.error.message,success:Session.error&&Session.error.success};},function(dispatch){return{forgotPassord:function forgotPassord(fields){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__store_actions_Session__["e" /* forgotPassword */])(fields));}};})(ForgotPassword));

/***/ }),
/* 587 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_ga__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_actions_Session__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_ApiController__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var EditPassword=function(_Component){_inherits(EditPassword,_Component);function EditPassword(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,EditPassword);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=EditPassword.__proto__||Object.getPrototypeOf(EditPassword)).call.apply(_ref,[this].concat(args))),_this),_this.state={error:'',success:'',isLoaded:true,token:'',redirect:false,formdata:{}},_this.getResetPassword=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var token;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:token=_this.getURLParameter(_this.props.location,'token');_context.next=3;return Object(__WEBPACK_IMPORTED_MODULE_6__services_ApiController__["fetchReset"])('/reset-password.json?token='+token).then(function(data){if(data.form){_this.setState({form:data.form,isLoaded:false});}else{_this.setState({redirect:true});}}).catch(function(err){console.log(err);});case 3:case'end':return _context.stop();}}},_callee,_this2);})),_this.addFormData=function(data){var formData=_this.state.formData;var row=[];row[data.key]=data.value;_this.setState({formData:Object.assign({},formData,row)});},_this.requestForgot=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return _this.props.changePassword(_this.state.formData,_this.state.form.action).then(function(){if(_this.props.error&&_this.props.error!=='')_this.setState({error:_this.props.error});if(_this.props.success&&_this.props.success!==''){_this.setState({success:'Password changed'});}}).catch(function(err){console.log(err);});case 2:case'end':return _context2.stop();}}},_callee2,_this2);})),_temp),_possibleConstructorReturn(_this,_ret);}_createClass(EditPassword,[{key:'componentDidMount',value:function componentDidMount(){this.getResetPassword();__WEBPACK_IMPORTED_MODULE_3_react_ga__["a" /* default */].pageview('/reset-password');}},{key:'getURLParameter',//utils
value:function getURLParameter(url,name){return decodeURIComponent((new RegExp('[?|&]'+name+'='+'([^&;]+?)(&|#|;|$)').exec(url.search)||[null,''])[1].replace(/\+/g,'%20'))||null;}},{key:'render',value:function render(){var _state=this.state,isLoaded=_state.isLoaded,redirect=_state.redirect,form=_state.form,error=_state.error,success=_state.success;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'forgot-password'},redirect&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["d" /* Redirect */],{to:'/'}),isLoaded&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components__["F" /* Load */],{width:50,height:50}),form&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('form',{className:__WEBPACK_IMPORTED_MODULE_7__styles__["R" /* Form */],onSubmit:this.requestForgot},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components__["x" /* Field */],{type:'password',onChange:this.addFormData,id:form.fields.plainPassword.id+'$first',name:form.fields.plainPassword.name+'[first]',value:''},'New Password '),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components__["x" /* Field */],{type:'password',onChange:this.addFormData,id:form.fields.plainPassword.id+'$second',name:form.fields.plainPassword.name+'[second]',value:''},'Confirm new Password '),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components__["x" /* Field */],{type:'hidden',onChange:this.addFormData,id:form.fields['_token'].id,name:form.fields['_token'].name,value:form.fields['_token'].value},'Confirm new Password '),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components__["m" /* Button */],{type:'submit',onCallback:this.requestForgot},' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components__["_18" /* User */],{width:'24',height:'24'}),' Reset password ')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'forgot-password--bottom'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["b" /* Link */],{to:'/login',className:__WEBPACK_IMPORTED_MODULE_7__styles__["_2" /* LinkButtonStyle */]},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components__["_18" /* User */],{width:'24',height:'24'}),' Login page ')),error!==''&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components__["t" /* Error */],null,error),success!==''&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components__["_11" /* Success */],null,success)));}}]);return EditPassword;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function(_ref4){var Session=_ref4.Session;return{error:Session.error&&Session.error.changePassword,success:Session.passwordChanged};},function(dispatch){return{changePassword:function changePassword(fields,action){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__store_actions_Session__["c" /* editPassword */])(fields,action));}};})(EditPassword));

/***/ }),
/* 588 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_recompose__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Layout___ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_Router__ = __webpack_require__(12);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AppRouter=function(_Component){_inherits(AppRouter,_Component);function AppRouter(){_classCallCheck(this,AppRouter);return _possibleConstructorReturn(this,(AppRouter.__proto__||Object.getPrototypeOf(AppRouter)).apply(this,arguments));}_createClass(AppRouter,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(_ref){var location=_ref.location;if(location!==this.props.location){document.querySelector('.app-body').scrollIntoView();}}},{key:'render',value:function render(){var menu=this.props.menu;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Layout___["b" /* BaseLayout */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'app-body '+__WEBPACK_IMPORTED_MODULE_6__styles__["_75" /* appBody */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["f" /* Switch */],{location:this.props.location},menu&&menu.models.categories.map(function(category){return category.menu.map(function(menu,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{path:menu.url,component:__WEBPACK_IMPORTED_MODULE_7__services_Router__["a" /* default */].catalog.component,exact:true,key:index});});}),Object.keys(__WEBPACK_IMPORTED_MODULE_7__services_Router__["a" /* default */]).map(function(route,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_7__services_Router__["a" /* default */][route].path,component:__WEBPACK_IMPORTED_MODULE_7__services_Router__["a" /* default */][route].component,exact:__WEBPACK_IMPORTED_MODULE_7__services_Router__["a" /* default */][route].exact||false,key:index});}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{component:__WEBPACK_IMPORTED_MODULE_7__services_Router__["a" /* default */].home.component}))));}}]);return AppRouter;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var enhance=Object(__WEBPACK_IMPORTED_MODULE_4_recompose__["a" /* compose */])(__WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* withRouter */],Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(function(_ref2){var Session=_ref2.Session;return{menu:Session.menu};}));/* harmony default export */ __webpack_exports__["a"] = (enhance(AppRouter));

/***/ }),
/* 589 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2____ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_actions_Session__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_recompose__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_ApiController__ = __webpack_require__(10);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AuthGate=function(_Component){_inherits(AuthGate,_Component);function AuthGate(){var _ref;var _temp,_this,_ret;_classCallCheck(this,AuthGate);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=AuthGate.__proto__||Object.getPrototypeOf(AuthGate)).call.apply(_ref,[this].concat(args))),_this),_this.state={loaded:false,transition:false},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(AuthGate,[{key:'componentDidMount',value:function componentDidMount(){this.getUser();}},{key:'getUser',value:function getUser(){var _this2=this;this.props.fetchUser().then(function(){// this.props.fetchChallenge()
Object(__WEBPACK_IMPORTED_MODULE_7__services_ApiController__["initGA"])(_this2.props.username);_this2.setState({transition:true},function(){_this2.transitionTimeout=setTimeout(function(){_this2.setState({loaded:true});},400);});}).catch(function(err){console.log('Something wrong');});}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(_ref2){var location=_ref2.location;if(location.pathname!==this.props.location.pathname){this.props.isConnected();}}},{key:'componentWillUnmount',value:function componentWillUnmount(){// clearTimeout(this.transitionTimeout)
}},{key:'render',value:function render(){var _state=this.state,transition=_state.transition,loaded=_state.loaded;var username=this.props.username;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'app'},!loaded&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["G" /* Loader */],{transition:transition}),Boolean(username)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2____["a" /* AppRouter */],null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2____["b" /* Auth */],null));}}]);return AuthGate;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var enhance=Object(__WEBPACK_IMPORTED_MODULE_6_recompose__["a" /* compose */])(__WEBPACK_IMPORTED_MODULE_5_react_router__["a" /* withRouter */],Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(_ref3){var Session=_ref3.Session;return{username:Session.username,connectedAt:Session.initAt};},function(dispatch){return{fetchUser:function fetchUser(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__store_actions_Session__["d" /* fetchUser */])());},isConnected:function isConnected(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__store_actions_Session__["a" /* checkConnect */])());}};}));/* harmony default export */ __webpack_exports__["a"] = (enhance(AuthGate));

/***/ }),
/* 590 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_emotion__ = __webpack_require__(3);
var _templateObject=_taggedTemplateLiteral(['\n  @font-face{\n    font-family: \'Interstate-ExtraLight\';\n    font-style: normal;\n    font-weight: 200;\n    src: url(',');\n    src: local(\'Interstate-ExtraLight\'), local(\'Interstate-ExtraLight\'),\n         url(',') format(\'embedded-opentype\'),\n         url(',') format(\'woff2\'),\n         url(',') format(\'woff\'),\n         url(',') format(\'truetype\'),\n         url(',') format(\'svg\');\n  }\n\n  @font-face{\n    font-family: Interstate-bold;\n    font-style: normal;\n    font-weight: bold;\n    src: url(','); /* IE9 Compat Modes */\n    src: local(\'Interstate-Bold\'), local(\'Interstate-Bold\'),\n         url(',') format(\'embedded-opentype\'),\n         url(',') format(\'woff2\'),\n         url(',') format(\'woff\'),\n         url(',') format(\'truetype\');\n  }\n\n  @font-face{\n    font-family: Interstate-Bold-Condensed;\n    font-style: normal;\n    font-weight: bold;\n    src: local(\'Interstate-Bold-Condensed\'), local(\'Interstate-Bold-Condensed\'),\n         url(',') format(\'woff2\'),\n         url(',') format(\'woff\');\n  }\n'],['\n  @font-face{\n    font-family: \'Interstate-ExtraLight\';\n    font-style: normal;\n    font-weight: 200;\n    src: url(',');\n    src: local(\'Interstate-ExtraLight\'), local(\'Interstate-ExtraLight\'),\n         url(',') format(\'embedded-opentype\'),\n         url(',') format(\'woff2\'),\n         url(',') format(\'woff\'),\n         url(',') format(\'truetype\'),\n         url(',') format(\'svg\');\n  }\n\n  @font-face{\n    font-family: Interstate-bold;\n    font-style: normal;\n    font-weight: bold;\n    src: url(','); /* IE9 Compat Modes */\n    src: local(\'Interstate-Bold\'), local(\'Interstate-Bold\'),\n         url(',') format(\'embedded-opentype\'),\n         url(',') format(\'woff2\'),\n         url(',') format(\'woff\'),\n         url(',') format(\'truetype\');\n  }\n\n  @font-face{\n    font-family: Interstate-Bold-Condensed;\n    font-style: normal;\n    font-weight: bold;\n    src: local(\'Interstate-Bold-Condensed\'), local(\'Interstate-Bold-Condensed\'),\n         url(',') format(\'woff2\'),\n         url(',') format(\'woff\');\n  }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["b" /* injectGlobal */])(_templateObject,__webpack_require__(167),__webpack_require__(167),__webpack_require__(591),__webpack_require__(592),__webpack_require__(593),__webpack_require__(594),__webpack_require__(595),__webpack_require__(596),__webpack_require__(597),__webpack_require__(598),__webpack_require__(599),__webpack_require__(600),__webpack_require__(601));

/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/Interstate-ExtraLight.16fac23f.woff2";

/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/Interstate-ExtraLight.0aa7fb28.woff";

/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/Interstate-ExtraLight.fc330f32.ttf";

/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/Interstate-ExtraLight.bd0f8ba8.svg";

/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/Interstate-Bold.2e29b707.eot";

/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/Interstate-Bold.2e29b707.eot";

/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/Interstate-Bold.da28bf38.woff2";

/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/Interstate-Bold.b3bc25e1.woff";

/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/Interstate-Bold.8695a341.ttf";

/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/Interstate-Bold-Condensed.2280ead2.woff2";

/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/Interstate-Bold-Condensed.b326d65f.woff";

/***/ }),
/* 602 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_emotion__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(1);
var _templateObject=_taggedTemplateLiteral(['\n  html {\n    font-size: 16px;\n    -webkit-font-smoothing: antialiased;\n\n    /*\n    @media all and (min-width: 1024px){\n      font-size: 1.11vw;\n    }\n\n    @media all and (min-width: 1600px) {\n      font-size: 16px;\n    }\n    */\n  }\n\n  body {\n    font-family: ',', sans-serif;\n    margin: 0px;\n\n    overflow-x: hidden;\n  }\n\n  * {\n    box-sizing: border-box;\n  }\n\n  .container {\n    width: 100%;\n    padding: 0px 40px;\n    max-width: 460px;\n    margin: 0px auto;\n  }\n\n  .flex{\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n  }\n\n  .flex-nowrap{\n    flex-wrap: nowrap;\n  }\n\n  .items-center{\n    align-items: center;\n  }\n\n  .content-center{\n    justify-content: center;\n  }\n\n  .flex-column{\n    flex-direction: column;\n\n    .column{\n      flex: 1 0 auto;\n    }\n  }\n\n  p{\n    font-size: 1rem;\n    line-height: 2em;\n    font-family: ',';\n  }\n\n  *:focus {\n    outline: 0;\n  }\n\n  a{\n    text-decoration: none;\n  }\n\n  ul.reset{\n    list-style: none;\n    margin: 0px;\n    padding: 0px;\n  }\n\n  img{\n    width: auto;\n    height: auto;\n    max-width: 100%;\n    max-height: 100%;\n  }\n\n  .fluid{\n    width: 100%;\n    padding: 0px 20px;\n  }\n\n  .btn-reset{\n    background: none;\n    margin: 0px;\n    border: 0px;\n  }\n\n  .page-inner{\n    padding: 20px;\n  }\n\n  .content b, .content strong{\n    font-weight: bold;\n  }\n\n  .content a {\n    border-bottom: 1px solid black;\n    color: black;\n  }\n\n  .content ul,\n  .content ol {\n    text-align: left;\n    padding: 0px 1rem;\n  }\n  \n  .content ol {\n    counter-reset: item;\n    list-style: none;\n    \n  }\n\n  .content ol > li{\n    counter-increment: item;\n    padding-left: 1.5rem;\n    position: relative;\n  }\n\n  ol > li:before {\n    display: inline-block;\n    width: 1em;\n    font-weight: bold;\n    content: counter(item) ".";\n    position: absolute;\n    top: 8px;\n    left: 0;\n  }\n\n  .content li {\n    padding: 0.5rem 0;\n  }\n\n  .content b, .content strong{\n    font-weight: bold;\n  }\n\n  .transition{\n    transition: all 1000ms ease 400ms;\n    opacity: 0;\n    transform: translateY(10px);\n  }\n\n  .transition--ready{\n    opacity: 1;\n    transform: translateY(0px);\n  }\n\n  @media (min-width: 768px){\n    .fluid{\n      padding: 0px 4rem;\n    }\n\n    .page-inner{\n      padding: 4rem;\n    }\n  }\n\n  @media (min-width: 1024px){\n    .fluid{\n      padding: 0px 8rem;\n    }\n\n    .page-inner{\n      padding: 4rem 8rem;\n    }\n  }\n\n  @media print {\n    header, footer, .no-print{\n      display: none;\n    }\n  }\n'],['\n  html {\n    font-size: 16px;\n    -webkit-font-smoothing: antialiased;\n\n    /*\n    @media all and (min-width: 1024px){\n      font-size: 1.11vw;\n    }\n\n    @media all and (min-width: 1600px) {\n      font-size: 16px;\n    }\n    */\n  }\n\n  body {\n    font-family: ',', sans-serif;\n    margin: 0px;\n\n    overflow-x: hidden;\n  }\n\n  * {\n    box-sizing: border-box;\n  }\n\n  .container {\n    width: 100%;\n    padding: 0px 40px;\n    max-width: 460px;\n    margin: 0px auto;\n  }\n\n  .flex{\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n  }\n\n  .flex-nowrap{\n    flex-wrap: nowrap;\n  }\n\n  .items-center{\n    align-items: center;\n  }\n\n  .content-center{\n    justify-content: center;\n  }\n\n  .flex-column{\n    flex-direction: column;\n\n    .column{\n      flex: 1 0 auto;\n    }\n  }\n\n  p{\n    font-size: 1rem;\n    line-height: 2em;\n    font-family: ',';\n  }\n\n  *:focus {\n    outline: 0;\n  }\n\n  a{\n    text-decoration: none;\n  }\n\n  ul.reset{\n    list-style: none;\n    margin: 0px;\n    padding: 0px;\n  }\n\n  img{\n    width: auto;\n    height: auto;\n    max-width: 100%;\n    max-height: 100%;\n  }\n\n  .fluid{\n    width: 100%;\n    padding: 0px 20px;\n  }\n\n  .btn-reset{\n    background: none;\n    margin: 0px;\n    border: 0px;\n  }\n\n  .page-inner{\n    padding: 20px;\n  }\n\n  .content b, .content strong{\n    font-weight: bold;\n  }\n\n  .content a {\n    border-bottom: 1px solid black;\n    color: black;\n  }\n\n  .content ul,\n  .content ol {\n    text-align: left;\n    padding: 0px 1rem;\n  }\n  \n  .content ol {\n    counter-reset: item;\n    list-style: none;\n    \n  }\n\n  .content ol > li{\n    counter-increment: item;\n    padding-left: 1.5rem;\n    position: relative;\n  }\n\n  ol > li:before {\n    display: inline-block;\n    width: 1em;\n    font-weight: bold;\n    content: counter(item) ".";\n    position: absolute;\n    top: 8px;\n    left: 0;\n  }\n\n  .content li {\n    padding: 0.5rem 0;\n  }\n\n  .content b, .content strong{\n    font-weight: bold;\n  }\n\n  .transition{\n    transition: all 1000ms ease 400ms;\n    opacity: 0;\n    transform: translateY(10px);\n  }\n\n  .transition--ready{\n    opacity: 1;\n    transform: translateY(0px);\n  }\n\n  @media (min-width: 768px){\n    .fluid{\n      padding: 0px 4rem;\n    }\n\n    .page-inner{\n      padding: 4rem;\n    }\n  }\n\n  @media (min-width: 1024px){\n    .fluid{\n      padding: 0px 8rem;\n    }\n\n    .page-inner{\n      padding: 4rem 8rem;\n    }\n  }\n\n  @media print {\n    header, footer, .no-print{\n      display: none;\n    }\n  }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}Object(__WEBPACK_IMPORTED_MODULE_0_emotion__["b" /* injectGlobal */])(_templateObject,__WEBPACK_IMPORTED_MODULE_1____["Q" /* Font */].base,__WEBPACK_IMPORTED_MODULE_1____["Q" /* Font */].base);

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.207cc6ee.js